/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 316);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.19.3
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

var hookCallback;

function hooks () {
    return hookCallback.apply(null, arguments);
}

// This is done to register the method called with moment()
// without creating circular dependencies.
function setHookCallback (callback) {
    hookCallback = callback;
}

function isArray(input) {
    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
}

function isObject(input) {
    // IE8 will treat undefined and null as object if it wasn't for
    // input != null
    return input != null && Object.prototype.toString.call(input) === '[object Object]';
}

function isObjectEmpty(obj) {
    if (Object.getOwnPropertyNames) {
        return (Object.getOwnPropertyNames(obj).length === 0);
    } else {
        var k;
        for (k in obj) {
            if (obj.hasOwnProperty(k)) {
                return false;
            }
        }
        return true;
    }
}

function isUndefined(input) {
    return input === void 0;
}

function isNumber(input) {
    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
}

function isDate(input) {
    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
}

function map(arr, fn) {
    var res = [], i;
    for (i = 0; i < arr.length; ++i) {
        res.push(fn(arr[i], i));
    }
    return res;
}

function hasOwnProp(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
}

function extend(a, b) {
    for (var i in b) {
        if (hasOwnProp(b, i)) {
            a[i] = b[i];
        }
    }

    if (hasOwnProp(b, 'toString')) {
        a.toString = b.toString;
    }

    if (hasOwnProp(b, 'valueOf')) {
        a.valueOf = b.valueOf;
    }

    return a;
}

function createUTC (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, true).utc();
}

function defaultParsingFlags() {
    // We need to deep clone this object.
    return {
        empty           : false,
        unusedTokens    : [],
        unusedInput     : [],
        overflow        : -2,
        charsLeftOver   : 0,
        nullInput       : false,
        invalidMonth    : null,
        invalidFormat   : false,
        userInvalidated : false,
        iso             : false,
        parsedDateParts : [],
        meridiem        : null,
        rfc2822         : false,
        weekdayMismatch : false
    };
}

function getParsingFlags(m) {
    if (m._pf == null) {
        m._pf = defaultParsingFlags();
    }
    return m._pf;
}

var some;
if (Array.prototype.some) {
    some = Array.prototype.some;
} else {
    some = function (fun) {
        var t = Object(this);
        var len = t.length >>> 0;

        for (var i = 0; i < len; i++) {
            if (i in t && fun.call(this, t[i], i, t)) {
                return true;
            }
        }

        return false;
    };
}

function isValid(m) {
    if (m._isValid == null) {
        var flags = getParsingFlags(m);
        var parsedParts = some.call(flags.parsedDateParts, function (i) {
            return i != null;
        });
        var isNowValid = !isNaN(m._d.getTime()) &&
            flags.overflow < 0 &&
            !flags.empty &&
            !flags.invalidMonth &&
            !flags.invalidWeekday &&
            !flags.weekdayMismatch &&
            !flags.nullInput &&
            !flags.invalidFormat &&
            !flags.userInvalidated &&
            (!flags.meridiem || (flags.meridiem && parsedParts));

        if (m._strict) {
            isNowValid = isNowValid &&
                flags.charsLeftOver === 0 &&
                flags.unusedTokens.length === 0 &&
                flags.bigHour === undefined;
        }

        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        }
        else {
            return isNowValid;
        }
    }
    return m._isValid;
}

function createInvalid (flags) {
    var m = createUTC(NaN);
    if (flags != null) {
        extend(getParsingFlags(m), flags);
    }
    else {
        getParsingFlags(m).userInvalidated = true;
    }

    return m;
}

// Plugins that add properties should also add the key here (null value),
// so we can properly clone ourselves.
var momentProperties = hooks.momentProperties = [];

function copyConfig(to, from) {
    var i, prop, val;

    if (!isUndefined(from._isAMomentObject)) {
        to._isAMomentObject = from._isAMomentObject;
    }
    if (!isUndefined(from._i)) {
        to._i = from._i;
    }
    if (!isUndefined(from._f)) {
        to._f = from._f;
    }
    if (!isUndefined(from._l)) {
        to._l = from._l;
    }
    if (!isUndefined(from._strict)) {
        to._strict = from._strict;
    }
    if (!isUndefined(from._tzm)) {
        to._tzm = from._tzm;
    }
    if (!isUndefined(from._isUTC)) {
        to._isUTC = from._isUTC;
    }
    if (!isUndefined(from._offset)) {
        to._offset = from._offset;
    }
    if (!isUndefined(from._pf)) {
        to._pf = getParsingFlags(from);
    }
    if (!isUndefined(from._locale)) {
        to._locale = from._locale;
    }

    if (momentProperties.length > 0) {
        for (i = 0; i < momentProperties.length; i++) {
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) {
                to[prop] = val;
            }
        }
    }

    return to;
}

var updateInProgress = false;

// Moment prototype object
function Moment(config) {
    copyConfig(this, config);
    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
    if (!this.isValid()) {
        this._d = new Date(NaN);
    }
    // Prevent infinite loop in case updateOffset creates new moment
    // objects.
    if (updateInProgress === false) {
        updateInProgress = true;
        hooks.updateOffset(this);
        updateInProgress = false;
    }
}

function isMoment (obj) {
    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
}

function absFloor (number) {
    if (number < 0) {
        // -0 -> 0
        return Math.ceil(number) || 0;
    } else {
        return Math.floor(number);
    }
}

function toInt(argumentForCoercion) {
    var coercedNumber = +argumentForCoercion,
        value = 0;

    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = absFloor(coercedNumber);
    }

    return value;
}

// compare two arrays, return the number of differences
function compareArrays(array1, array2, dontConvert) {
    var len = Math.min(array1.length, array2.length),
        lengthDiff = Math.abs(array1.length - array2.length),
        diffs = 0,
        i;
    for (i = 0; i < len; i++) {
        if ((dontConvert && array1[i] !== array2[i]) ||
            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
            diffs++;
        }
    }
    return diffs + lengthDiff;
}

function warn(msg) {
    if (hooks.suppressDeprecationWarnings === false &&
            (typeof console !==  'undefined') && console.warn) {
        console.warn('Deprecation warning: ' + msg);
    }
}

function deprecate(msg, fn) {
    var firstTime = true;

    return extend(function () {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(null, msg);
        }
        if (firstTime) {
            var args = [];
            var arg;
            for (var i = 0; i < arguments.length; i++) {
                arg = '';
                if (typeof arguments[i] === 'object') {
                    arg += '\n[' + i + '] ';
                    for (var key in arguments[0]) {
                        arg += key + ': ' + arguments[0][key] + ', ';
                    }
                    arg = arg.slice(0, -2); // Remove trailing comma and space
                } else {
                    arg = arguments[i];
                }
                args.push(arg);
            }
            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
            firstTime = false;
        }
        return fn.apply(this, arguments);
    }, fn);
}

var deprecations = {};

function deprecateSimple(name, msg) {
    if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(name, msg);
    }
    if (!deprecations[name]) {
        warn(msg);
        deprecations[name] = true;
    }
}

hooks.suppressDeprecationWarnings = false;
hooks.deprecationHandler = null;

function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
}

function set (config) {
    var prop, i;
    for (i in config) {
        prop = config[i];
        if (isFunction(prop)) {
            this[i] = prop;
        } else {
            this['_' + i] = prop;
        }
    }
    this._config = config;
    // Lenient ordinal parsing accepts just a number in addition to
    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
    // TODO: Remove "ordinalParse" fallback in next major release.
    this._dayOfMonthOrdinalParseLenient = new RegExp(
        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
            '|' + (/\d{1,2}/).source);
}

function mergeConfigs(parentConfig, childConfig) {
    var res = extend({}, parentConfig), prop;
    for (prop in childConfig) {
        if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) {
                res[prop] = childConfig[prop];
            } else {
                delete res[prop];
            }
        }
    }
    for (prop in parentConfig) {
        if (hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])) {
            // make sure changes to properties don't modify parent config
            res[prop] = extend({}, res[prop]);
        }
    }
    return res;
}

function Locale(config) {
    if (config != null) {
        this.set(config);
    }
}

var keys;

if (Object.keys) {
    keys = Object.keys;
} else {
    keys = function (obj) {
        var i, res = [];
        for (i in obj) {
            if (hasOwnProp(obj, i)) {
                res.push(i);
            }
        }
        return res;
    };
}

var defaultCalendar = {
    sameDay : '[Today at] LT',
    nextDay : '[Tomorrow at] LT',
    nextWeek : 'dddd [at] LT',
    lastDay : '[Yesterday at] LT',
    lastWeek : '[Last] dddd [at] LT',
    sameElse : 'L'
};

function calendar (key, mom, now) {
    var output = this._calendar[key] || this._calendar['sameElse'];
    return isFunction(output) ? output.call(mom, now) : output;
}

var defaultLongDateFormat = {
    LTS  : 'h:mm:ss A',
    LT   : 'h:mm A',
    L    : 'MM/DD/YYYY',
    LL   : 'MMMM D, YYYY',
    LLL  : 'MMMM D, YYYY h:mm A',
    LLLL : 'dddd, MMMM D, YYYY h:mm A'
};

function longDateFormat (key) {
    var format = this._longDateFormat[key],
        formatUpper = this._longDateFormat[key.toUpperCase()];

    if (format || !formatUpper) {
        return format;
    }

    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
        return val.slice(1);
    });

    return this._longDateFormat[key];
}

var defaultInvalidDate = 'Invalid date';

function invalidDate () {
    return this._invalidDate;
}

var defaultOrdinal = '%d';
var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

function ordinal (number) {
    return this._ordinal.replace('%d', number);
}

var defaultRelativeTime = {
    future : 'in %s',
    past   : '%s ago',
    s  : 'a few seconds',
    ss : '%d seconds',
    m  : 'a minute',
    mm : '%d minutes',
    h  : 'an hour',
    hh : '%d hours',
    d  : 'a day',
    dd : '%d days',
    M  : 'a month',
    MM : '%d months',
    y  : 'a year',
    yy : '%d years'
};

function relativeTime (number, withoutSuffix, string, isFuture) {
    var output = this._relativeTime[string];
    return (isFunction(output)) ?
        output(number, withoutSuffix, string, isFuture) :
        output.replace(/%d/i, number);
}

function pastFuture (diff, output) {
    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
}

var aliases = {};

function addUnitAlias (unit, shorthand) {
    var lowerCase = unit.toLowerCase();
    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
}

function normalizeUnits(units) {
    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
}

function normalizeObjectUnits(inputObject) {
    var normalizedInput = {},
        normalizedProp,
        prop;

    for (prop in inputObject) {
        if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) {
                normalizedInput[normalizedProp] = inputObject[prop];
            }
        }
    }

    return normalizedInput;
}

var priorities = {};

function addUnitPriority(unit, priority) {
    priorities[unit] = priority;
}

function getPrioritizedUnits(unitsObj) {
    var units = [];
    for (var u in unitsObj) {
        units.push({unit: u, priority: priorities[u]});
    }
    units.sort(function (a, b) {
        return a.priority - b.priority;
    });
    return units;
}

function zeroFill(number, targetLength, forceSign) {
    var absNumber = '' + Math.abs(number),
        zerosToFill = targetLength - absNumber.length,
        sign = number >= 0;
    return (sign ? (forceSign ? '+' : '') : '-') +
        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
}

var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

var formatFunctions = {};

var formatTokenFunctions = {};

// token:    'M'
// padded:   ['MM', 2]
// ordinal:  'Mo'
// callback: function () { this.month() + 1 }
function addFormatToken (token, padded, ordinal, callback) {
    var func = callback;
    if (typeof callback === 'string') {
        func = function () {
            return this[callback]();
        };
    }
    if (token) {
        formatTokenFunctions[token] = func;
    }
    if (padded) {
        formatTokenFunctions[padded[0]] = function () {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
    }
    if (ordinal) {
        formatTokenFunctions[ordinal] = function () {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
}

function removeFormattingTokens(input) {
    if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, '');
    }
    return input.replace(/\\/g, '');
}

function makeFormatFunction(format) {
    var array = format.match(formattingTokens), i, length;

    for (i = 0, length = array.length; i < length; i++) {
        if (formatTokenFunctions[array[i]]) {
            array[i] = formatTokenFunctions[array[i]];
        } else {
            array[i] = removeFormattingTokens(array[i]);
        }
    }

    return function (mom) {
        var output = '', i;
        for (i = 0; i < length; i++) {
            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
        }
        return output;
    };
}

// format date using native date object
function formatMoment(m, format) {
    if (!m.isValid()) {
        return m.localeData().invalidDate();
    }

    format = expandFormat(format, m.localeData());
    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

    return formatFunctions[format](m);
}

function expandFormat(format, locale) {
    var i = 5;

    function replaceLongDateFormatTokens(input) {
        return locale.longDateFormat(input) || input;
    }

    localFormattingTokens.lastIndex = 0;
    while (i >= 0 && localFormattingTokens.test(format)) {
        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
        localFormattingTokens.lastIndex = 0;
        i -= 1;
    }

    return format;
}

var match1         = /\d/;            //       0 - 9
var match2         = /\d\d/;          //      00 - 99
var match3         = /\d{3}/;         //     000 - 999
var match4         = /\d{4}/;         //    0000 - 9999
var match6         = /[+-]?\d{6}/;    // -999999 - 999999
var match1to2      = /\d\d?/;         //       0 - 99
var match3to4      = /\d\d\d\d?/;     //     999 - 9999
var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
var match1to3      = /\d{1,3}/;       //       0 - 999
var match1to4      = /\d{1,4}/;       //       0 - 9999
var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

var matchUnsigned  = /\d+/;           //       0 - inf
var matchSigned    = /[+-]?\d+/;      //    -inf - inf

var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

// any word (or two) characters or numbers including two/three word month in arabic.
// includes scottish gaelic two word and hyphenated months
var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;


var regexes = {};

function addRegexToken (token, regex, strictRegex) {
    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
        return (isStrict && strictRegex) ? strictRegex : regex;
    };
}

function getParseRegexForToken (token, config) {
    if (!hasOwnProp(regexes, token)) {
        return new RegExp(unescapeFormat(token));
    }

    return regexes[token](config._strict, config._locale);
}

// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
function unescapeFormat(s) {
    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
        return p1 || p2 || p3 || p4;
    }));
}

function regexEscape(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}

var tokens = {};

function addParseToken (token, callback) {
    var i, func = callback;
    if (typeof token === 'string') {
        token = [token];
    }
    if (isNumber(callback)) {
        func = function (input, array) {
            array[callback] = toInt(input);
        };
    }
    for (i = 0; i < token.length; i++) {
        tokens[token[i]] = func;
    }
}

function addWeekParseToken (token, callback) {
    addParseToken(token, function (input, array, config, token) {
        config._w = config._w || {};
        callback(input, config._w, config, token);
    });
}

function addTimeToArrayFromToken(token, input, config) {
    if (input != null && hasOwnProp(tokens, token)) {
        tokens[token](input, config._a, config, token);
    }
}

var YEAR = 0;
var MONTH = 1;
var DATE = 2;
var HOUR = 3;
var MINUTE = 4;
var SECOND = 5;
var MILLISECOND = 6;
var WEEK = 7;
var WEEKDAY = 8;

// FORMATTING

addFormatToken('Y', 0, 0, function () {
    var y = this.year();
    return y <= 9999 ? '' + y : '+' + y;
});

addFormatToken(0, ['YY', 2], 0, function () {
    return this.year() % 100;
});

addFormatToken(0, ['YYYY',   4],       0, 'year');
addFormatToken(0, ['YYYYY',  5],       0, 'year');
addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

// ALIASES

addUnitAlias('year', 'y');

// PRIORITIES

addUnitPriority('year', 1);

// PARSING

addRegexToken('Y',      matchSigned);
addRegexToken('YY',     match1to2, match2);
addRegexToken('YYYY',   match1to4, match4);
addRegexToken('YYYYY',  match1to6, match6);
addRegexToken('YYYYYY', match1to6, match6);

addParseToken(['YYYYY', 'YYYYYY'], YEAR);
addParseToken('YYYY', function (input, array) {
    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
});
addParseToken('YY', function (input, array) {
    array[YEAR] = hooks.parseTwoDigitYear(input);
});
addParseToken('Y', function (input, array) {
    array[YEAR] = parseInt(input, 10);
});

// HELPERS

function daysInYear(year) {
    return isLeapYear(year) ? 366 : 365;
}

function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}

// HOOKS

hooks.parseTwoDigitYear = function (input) {
    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
};

// MOMENTS

var getSetYear = makeGetSet('FullYear', true);

function getIsLeapYear () {
    return isLeapYear(this.year());
}

function makeGetSet (unit, keepTime) {
    return function (value) {
        if (value != null) {
            set$1(this, unit, value);
            hooks.updateOffset(this, keepTime);
            return this;
        } else {
            return get(this, unit);
        }
    };
}

function get (mom, unit) {
    return mom.isValid() ?
        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
}

function set$1 (mom, unit, value) {
    if (mom.isValid() && !isNaN(value)) {
        if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
        }
        else {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
    }
}

// MOMENTS

function stringGet (units) {
    units = normalizeUnits(units);
    if (isFunction(this[units])) {
        return this[units]();
    }
    return this;
}


function stringSet (units, value) {
    if (typeof units === 'object') {
        units = normalizeObjectUnits(units);
        var prioritized = getPrioritizedUnits(units);
        for (var i = 0; i < prioritized.length; i++) {
            this[prioritized[i].unit](units[prioritized[i].unit]);
        }
    } else {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units](value);
        }
    }
    return this;
}

function mod(n, x) {
    return ((n % x) + x) % x;
}

var indexOf;

if (Array.prototype.indexOf) {
    indexOf = Array.prototype.indexOf;
} else {
    indexOf = function (o) {
        // I know
        var i;
        for (i = 0; i < this.length; ++i) {
            if (this[i] === o) {
                return i;
            }
        }
        return -1;
    };
}

function daysInMonth(year, month) {
    if (isNaN(year) || isNaN(month)) {
        return NaN;
    }
    var modMonth = mod(month, 12);
    year += (month - modMonth) / 12;
    return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
}

// FORMATTING

addFormatToken('M', ['MM', 2], 'Mo', function () {
    return this.month() + 1;
});

addFormatToken('MMM', 0, 0, function (format) {
    return this.localeData().monthsShort(this, format);
});

addFormatToken('MMMM', 0, 0, function (format) {
    return this.localeData().months(this, format);
});

// ALIASES

addUnitAlias('month', 'M');

// PRIORITY

addUnitPriority('month', 8);

// PARSING

addRegexToken('M',    match1to2);
addRegexToken('MM',   match1to2, match2);
addRegexToken('MMM',  function (isStrict, locale) {
    return locale.monthsShortRegex(isStrict);
});
addRegexToken('MMMM', function (isStrict, locale) {
    return locale.monthsRegex(isStrict);
});

addParseToken(['M', 'MM'], function (input, array) {
    array[MONTH] = toInt(input) - 1;
});

addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
    var month = config._locale.monthsParse(input, token, config._strict);
    // if we didn't find a month name, mark the date as invalid.
    if (month != null) {
        array[MONTH] = month;
    } else {
        getParsingFlags(config).invalidMonth = input;
    }
});

// LOCALES

var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
function localeMonths (m, format) {
    if (!m) {
        return isArray(this._months) ? this._months :
            this._months['standalone'];
    }
    return isArray(this._months) ? this._months[m.month()] :
        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
}

var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
function localeMonthsShort (m, format) {
    if (!m) {
        return isArray(this._monthsShort) ? this._monthsShort :
            this._monthsShort['standalone'];
    }
    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
}

function handleStrictParse(monthName, format, strict) {
    var i, ii, mom, llc = monthName.toLocaleLowerCase();
    if (!this._monthsParse) {
        // this is not used
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
        for (i = 0; i < 12; ++i) {
            mom = createUTC([2000, i]);
            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeMonthsParse (monthName, format, strict) {
    var i, mom, regex;

    if (this._monthsParseExact) {
        return handleStrictParse.call(this, monthName, format, strict);
    }

    if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
    }

    // TODO: add sorting
    // Sorting makes sure if one month (or abbr) is a prefix of another
    // see sorting in computeMonthsParse
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        if (strict && !this._longMonthsParse[i]) {
            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
        }
        if (!strict && !this._monthsParse[i]) {
            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
            return i;
        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
            return i;
        } else if (!strict && this._monthsParse[i].test(monthName)) {
            return i;
        }
    }
}

// MOMENTS

function setMonth (mom, value) {
    var dayOfMonth;

    if (!mom.isValid()) {
        // No op
        return mom;
    }

    if (typeof value === 'string') {
        if (/^\d+$/.test(value)) {
            value = toInt(value);
        } else {
            value = mom.localeData().monthsParse(value);
            // TODO: Another silent failure?
            if (!isNumber(value)) {
                return mom;
            }
        }
    }

    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
    return mom;
}

function getSetMonth (value) {
    if (value != null) {
        setMonth(this, value);
        hooks.updateOffset(this, true);
        return this;
    } else {
        return get(this, 'Month');
    }
}

function getDaysInMonth () {
    return daysInMonth(this.year(), this.month());
}

var defaultMonthsShortRegex = matchWord;
function monthsShortRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsShortStrictRegex;
        } else {
            return this._monthsShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsShortRegex')) {
            this._monthsShortRegex = defaultMonthsShortRegex;
        }
        return this._monthsShortStrictRegex && isStrict ?
            this._monthsShortStrictRegex : this._monthsShortRegex;
    }
}

var defaultMonthsRegex = matchWord;
function monthsRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsStrictRegex;
        } else {
            return this._monthsRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsRegex')) {
            this._monthsRegex = defaultMonthsRegex;
        }
        return this._monthsStrictRegex && isStrict ?
            this._monthsStrictRegex : this._monthsRegex;
    }
}

function computeMonthsParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom;
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        shortPieces.push(this.monthsShort(mom, ''));
        longPieces.push(this.months(mom, ''));
        mixedPieces.push(this.months(mom, ''));
        mixedPieces.push(this.monthsShort(mom, ''));
    }
    // Sorting makes sure if one month (or abbr) is a prefix of another it
    // will match the longer piece.
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 12; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
    }
    for (i = 0; i < 24; i++) {
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._monthsShortRegex = this._monthsRegex;
    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
}

function createDate (y, m, d, h, M, s, ms) {
    // can't just apply() to create a date:
    // https://stackoverflow.com/q/181348
    var date = new Date(y, m, d, h, M, s, ms);

    // the date constructor remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
        date.setFullYear(y);
    }
    return date;
}

function createUTCDate (y) {
    var date = new Date(Date.UTC.apply(null, arguments));

    // the Date.UTC function remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
        date.setUTCFullYear(y);
    }
    return date;
}

// start-of-first-week - start-of-year
function firstWeekOffset(year, dow, doy) {
    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
        fwd = 7 + dow - doy,
        // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

    return -fwdlw + fwd - 1;
}

// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
    var localWeekday = (7 + weekday - dow) % 7,
        weekOffset = firstWeekOffset(year, dow, doy),
        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
        resYear, resDayOfYear;

    if (dayOfYear <= 0) {
        resYear = year - 1;
        resDayOfYear = daysInYear(resYear) + dayOfYear;
    } else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1;
        resDayOfYear = dayOfYear - daysInYear(year);
    } else {
        resYear = year;
        resDayOfYear = dayOfYear;
    }

    return {
        year: resYear,
        dayOfYear: resDayOfYear
    };
}

function weekOfYear(mom, dow, doy) {
    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
        resWeek, resYear;

    if (week < 1) {
        resYear = mom.year() - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
    } else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy);
        resYear = mom.year() + 1;
    } else {
        resYear = mom.year();
        resWeek = week;
    }

    return {
        week: resWeek,
        year: resYear
    };
}

function weeksInYear(year, dow, doy) {
    var weekOffset = firstWeekOffset(year, dow, doy),
        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
}

// FORMATTING

addFormatToken('w', ['ww', 2], 'wo', 'week');
addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

// ALIASES

addUnitAlias('week', 'w');
addUnitAlias('isoWeek', 'W');

// PRIORITIES

addUnitPriority('week', 5);
addUnitPriority('isoWeek', 5);

// PARSING

addRegexToken('w',  match1to2);
addRegexToken('ww', match1to2, match2);
addRegexToken('W',  match1to2);
addRegexToken('WW', match1to2, match2);

addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
    week[token.substr(0, 1)] = toInt(input);
});

// HELPERS

// LOCALES

function localeWeek (mom) {
    return weekOfYear(mom, this._week.dow, this._week.doy).week;
}

var defaultLocaleWeek = {
    dow : 0, // Sunday is the first day of the week.
    doy : 6  // The week that contains Jan 1st is the first week of the year.
};

function localeFirstDayOfWeek () {
    return this._week.dow;
}

function localeFirstDayOfYear () {
    return this._week.doy;
}

// MOMENTS

function getSetWeek (input) {
    var week = this.localeData().week(this);
    return input == null ? week : this.add((input - week) * 7, 'd');
}

function getSetISOWeek (input) {
    var week = weekOfYear(this, 1, 4).week;
    return input == null ? week : this.add((input - week) * 7, 'd');
}

// FORMATTING

addFormatToken('d', 0, 'do', 'day');

addFormatToken('dd', 0, 0, function (format) {
    return this.localeData().weekdaysMin(this, format);
});

addFormatToken('ddd', 0, 0, function (format) {
    return this.localeData().weekdaysShort(this, format);
});

addFormatToken('dddd', 0, 0, function (format) {
    return this.localeData().weekdays(this, format);
});

addFormatToken('e', 0, 0, 'weekday');
addFormatToken('E', 0, 0, 'isoWeekday');

// ALIASES

addUnitAlias('day', 'd');
addUnitAlias('weekday', 'e');
addUnitAlias('isoWeekday', 'E');

// PRIORITY
addUnitPriority('day', 11);
addUnitPriority('weekday', 11);
addUnitPriority('isoWeekday', 11);

// PARSING

addRegexToken('d',    match1to2);
addRegexToken('e',    match1to2);
addRegexToken('E',    match1to2);
addRegexToken('dd',   function (isStrict, locale) {
    return locale.weekdaysMinRegex(isStrict);
});
addRegexToken('ddd',   function (isStrict, locale) {
    return locale.weekdaysShortRegex(isStrict);
});
addRegexToken('dddd',   function (isStrict, locale) {
    return locale.weekdaysRegex(isStrict);
});

addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
    var weekday = config._locale.weekdaysParse(input, token, config._strict);
    // if we didn't get a weekday name, mark the date as invalid
    if (weekday != null) {
        week.d = weekday;
    } else {
        getParsingFlags(config).invalidWeekday = input;
    }
});

addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
    week[token] = toInt(input);
});

// HELPERS

function parseWeekday(input, locale) {
    if (typeof input !== 'string') {
        return input;
    }

    if (!isNaN(input)) {
        return parseInt(input, 10);
    }

    input = locale.weekdaysParse(input);
    if (typeof input === 'number') {
        return input;
    }

    return null;
}

function parseIsoWeekday(input, locale) {
    if (typeof input === 'string') {
        return locale.weekdaysParse(input) % 7 || 7;
    }
    return isNaN(input) ? null : input;
}

// LOCALES

var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
function localeWeekdays (m, format) {
    if (!m) {
        return isArray(this._weekdays) ? this._weekdays :
            this._weekdays['standalone'];
    }
    return isArray(this._weekdays) ? this._weekdays[m.day()] :
        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
}

var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
function localeWeekdaysShort (m) {
    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
}

var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
function localeWeekdaysMin (m) {
    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
}

function handleStrictParse$1(weekdayName, format, strict) {
    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._minWeekdaysParse = [];

        for (i = 0; i < 7; ++i) {
            mom = createUTC([2000, 1]).day(i);
            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'dddd') {
            ii = indexOf.call(this._weekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'dddd') {
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._minWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeWeekdaysParse (weekdayName, format, strict) {
    var i, mom, regex;

    if (this._weekdaysParseExact) {
        return handleStrictParse$1.call(this, weekdayName, format, strict);
    }

    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._minWeekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._fullWeekdaysParse = [];
    }

    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already

        mom = createUTC([2000, 1]).day(i);
        if (strict && !this._fullWeekdaysParse[i]) {
            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
        }
        if (!this._weekdaysParse[i]) {
            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
            return i;
        }
    }
}

// MOMENTS

function getSetDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
    if (input != null) {
        input = parseWeekday(input, this.localeData());
        return this.add(input - day, 'd');
    } else {
        return day;
    }
}

function getSetLocaleDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
    return input == null ? weekday : this.add(input - weekday, 'd');
}

function getSetISODayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }

    // behaves the same as moment#day except
    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
    // as a setter, sunday should belong to the previous week.

    if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData());
        return this.day(this.day() % 7 ? weekday : weekday - 7);
    } else {
        return this.day() || 7;
    }
}

var defaultWeekdaysRegex = matchWord;
function weekdaysRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysStrictRegex;
        } else {
            return this._weekdaysRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            this._weekdaysRegex = defaultWeekdaysRegex;
        }
        return this._weekdaysStrictRegex && isStrict ?
            this._weekdaysStrictRegex : this._weekdaysRegex;
    }
}

var defaultWeekdaysShortRegex = matchWord;
function weekdaysShortRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysShortStrictRegex;
        } else {
            return this._weekdaysShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
        }
        return this._weekdaysShortStrictRegex && isStrict ?
            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
    }
}

var defaultWeekdaysMinRegex = matchWord;
function weekdaysMinRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysMinStrictRegex;
        } else {
            return this._weekdaysMinRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
        }
        return this._weekdaysMinStrictRegex && isStrict ?
            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
    }
}


function computeWeekdaysParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom, minp, shortp, longp;
    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, 1]).day(i);
        minp = this.weekdaysMin(mom, '');
        shortp = this.weekdaysShort(mom, '');
        longp = this.weekdays(mom, '');
        minPieces.push(minp);
        shortPieces.push(shortp);
        longPieces.push(longp);
        mixedPieces.push(minp);
        mixedPieces.push(shortp);
        mixedPieces.push(longp);
    }
    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
    // will match the longer piece.
    minPieces.sort(cmpLenRev);
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 7; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._weekdaysShortRegex = this._weekdaysRegex;
    this._weekdaysMinRegex = this._weekdaysRegex;

    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
}

// FORMATTING

function hFormat() {
    return this.hours() % 12 || 12;
}

function kFormat() {
    return this.hours() || 24;
}

addFormatToken('H', ['HH', 2], 0, 'hour');
addFormatToken('h', ['hh', 2], 0, hFormat);
addFormatToken('k', ['kk', 2], 0, kFormat);

addFormatToken('hmm', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
});

addFormatToken('hmmss', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

addFormatToken('Hmm', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2);
});

addFormatToken('Hmmss', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

function meridiem (token, lowercase) {
    addFormatToken(token, 0, 0, function () {
        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
    });
}

meridiem('a', true);
meridiem('A', false);

// ALIASES

addUnitAlias('hour', 'h');

// PRIORITY
addUnitPriority('hour', 13);

// PARSING

function matchMeridiem (isStrict, locale) {
    return locale._meridiemParse;
}

addRegexToken('a',  matchMeridiem);
addRegexToken('A',  matchMeridiem);
addRegexToken('H',  match1to2);
addRegexToken('h',  match1to2);
addRegexToken('k',  match1to2);
addRegexToken('HH', match1to2, match2);
addRegexToken('hh', match1to2, match2);
addRegexToken('kk', match1to2, match2);

addRegexToken('hmm', match3to4);
addRegexToken('hmmss', match5to6);
addRegexToken('Hmm', match3to4);
addRegexToken('Hmmss', match5to6);

addParseToken(['H', 'HH'], HOUR);
addParseToken(['k', 'kk'], function (input, array, config) {
    var kInput = toInt(input);
    array[HOUR] = kInput === 24 ? 0 : kInput;
});
addParseToken(['a', 'A'], function (input, array, config) {
    config._isPm = config._locale.isPM(input);
    config._meridiem = input;
});
addParseToken(['h', 'hh'], function (input, array, config) {
    array[HOUR] = toInt(input);
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
    getParsingFlags(config).bigHour = true;
});
addParseToken('Hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
});
addParseToken('Hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
});

// LOCALES

function localeIsPM (input) {
    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
    // Using charAt should be more compatible.
    return ((input + '').toLowerCase().charAt(0) === 'p');
}

var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
function localeMeridiem (hours, minutes, isLower) {
    if (hours > 11) {
        return isLower ? 'pm' : 'PM';
    } else {
        return isLower ? 'am' : 'AM';
    }
}


// MOMENTS

// Setting the hour should keep the time, because the user explicitly
// specified which hour he wants. So trying to maintain the same hour (in
// a new timezone) makes sense. Adding/subtracting hours does not follow
// this rule.
var getSetHour = makeGetSet('Hours', true);

// months
// week
// weekdays
// meridiem
var baseConfig = {
    calendar: defaultCalendar,
    longDateFormat: defaultLongDateFormat,
    invalidDate: defaultInvalidDate,
    ordinal: defaultOrdinal,
    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
    relativeTime: defaultRelativeTime,

    months: defaultLocaleMonths,
    monthsShort: defaultLocaleMonthsShort,

    week: defaultLocaleWeek,

    weekdays: defaultLocaleWeekdays,
    weekdaysMin: defaultLocaleWeekdaysMin,
    weekdaysShort: defaultLocaleWeekdaysShort,

    meridiemParse: defaultLocaleMeridiemParse
};

// internal storage for locale config files
var locales = {};
var localeFamilies = {};
var globalLocale;

function normalizeLocale(key) {
    return key ? key.toLowerCase().replace('_', '-') : key;
}

// pick the locale from the array
// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
function chooseLocale(names) {
    var i = 0, j, next, locale, split;

    while (i < names.length) {
        split = normalizeLocale(names[i]).split('-');
        j = split.length;
        next = normalizeLocale(names[i + 1]);
        next = next ? next.split('-') : null;
        while (j > 0) {
            locale = loadLocale(split.slice(0, j).join('-'));
            if (locale) {
                return locale;
            }
            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                //the next array item is better than a shallower substring of this one
                break;
            }
            j--;
        }
        i++;
    }
    return null;
}

function loadLocale(name) {
    var oldLocale = null;
    // TODO: Find a better way to register and load all the locales in Node
    if (!locales[name] && (typeof module !== 'undefined') &&
            module && module.exports) {
        try {
            oldLocale = globalLocale._abbr;
            var aliasedRequire = require;
            __webpack_require__(649)("./" + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {}
    }
    return locales[name];
}

// This function will load locale and then set the global locale.  If
// no arguments are passed in, it will simply return the current global
// locale key.
function getSetGlobalLocale (key, values) {
    var data;
    if (key) {
        if (isUndefined(values)) {
            data = getLocale(key);
        }
        else {
            data = defineLocale(key, values);
        }

        if (data) {
            // moment.duration._locale = moment._locale = data;
            globalLocale = data;
        }
    }

    return globalLocale._abbr;
}

function defineLocale (name, config) {
    if (config !== null) {
        var parentConfig = baseConfig;
        config.abbr = name;
        if (locales[name] != null) {
            deprecateSimple('defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                    'an existing locale. moment.defineLocale(localeName, ' +
                    'config) should only be used for creating a new locale ' +
                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
            parentConfig = locales[name]._config;
        } else if (config.parentLocale != null) {
            if (locales[config.parentLocale] != null) {
                parentConfig = locales[config.parentLocale]._config;
            } else {
                if (!localeFamilies[config.parentLocale]) {
                    localeFamilies[config.parentLocale] = [];
                }
                localeFamilies[config.parentLocale].push({
                    name: name,
                    config: config
                });
                return null;
            }
        }
        locales[name] = new Locale(mergeConfigs(parentConfig, config));

        if (localeFamilies[name]) {
            localeFamilies[name].forEach(function (x) {
                defineLocale(x.name, x.config);
            });
        }

        // backwards compat for now: also set the locale
        // make sure we set the locale AFTER all child locales have been
        // created, so we won't end up with the child locale set.
        getSetGlobalLocale(name);


        return locales[name];
    } else {
        // useful for testing
        delete locales[name];
        return null;
    }
}

function updateLocale(name, config) {
    if (config != null) {
        var locale, tmpLocale, parentConfig = baseConfig;
        // MERGE
        tmpLocale = loadLocale(name);
        if (tmpLocale != null) {
            parentConfig = tmpLocale._config;
        }
        config = mergeConfigs(parentConfig, config);
        locale = new Locale(config);
        locale.parentLocale = locales[name];
        locales[name] = locale;

        // backwards compat for now: also set the locale
        getSetGlobalLocale(name);
    } else {
        // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
            } else if (locales[name] != null) {
                delete locales[name];
            }
        }
    }
    return locales[name];
}

// returns locale data
function getLocale (key) {
    var locale;

    if (key && key._locale && key._locale._abbr) {
        key = key._locale._abbr;
    }

    if (!key) {
        return globalLocale;
    }

    if (!isArray(key)) {
        //short-circuit everything else
        locale = loadLocale(key);
        if (locale) {
            return locale;
        }
        key = [key];
    }

    return chooseLocale(key);
}

function listLocales() {
    return keys(locales);
}

function checkOverflow (m) {
    var overflow;
    var a = m._a;

    if (a && getParsingFlags(m).overflow === -2) {
        overflow =
            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
            -1;

        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
            overflow = DATE;
        }
        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
            overflow = WEEK;
        }
        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
            overflow = WEEKDAY;
        }

        getParsingFlags(m).overflow = overflow;
    }

    return m;
}

// Pick the first defined of two or three arguments.
function defaults(a, b, c) {
    if (a != null) {
        return a;
    }
    if (b != null) {
        return b;
    }
    return c;
}

function currentDateArray(config) {
    // hooks is actually the exported moment object
    var nowValue = new Date(hooks.now());
    if (config._useUTC) {
        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
    }
    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
}

// convert an array to a date.
// the array should mirror the parameters below
// note: all values past the year are optional and will default to the lowest possible value.
// [year, month, day , hour, minute, second, millisecond]
function configFromArray (config) {
    var i, date, input = [], currentDate, yearToUse;

    if (config._d) {
        return;
    }

    currentDate = currentDateArray(config);

    //compute day of the year from weeks and weekdays
    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
        dayOfYearFromWeekInfo(config);
    }

    //if the day of the year is set, figure out what it is
    if (config._dayOfYear != null) {
        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
            getParsingFlags(config)._overflowDayOfYear = true;
        }

        date = createUTCDate(yearToUse, 0, config._dayOfYear);
        config._a[MONTH] = date.getUTCMonth();
        config._a[DATE] = date.getUTCDate();
    }

    // Default to current date.
    // * if no year, month, day of month are given, default to today
    // * if day of month is given, default month and year
    // * if month is given, default only year
    // * if year is given, don't default anything
    for (i = 0; i < 3 && config._a[i] == null; ++i) {
        config._a[i] = input[i] = currentDate[i];
    }

    // Zero out whatever was not defaulted, including time
    for (; i < 7; i++) {
        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
    }

    // Check for 24:00:00.000
    if (config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0) {
        config._nextDay = true;
        config._a[HOUR] = 0;
    }

    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
    // Apply timezone offset from input. The actual utcOffset can be changed
    // with parseZone.
    if (config._tzm != null) {
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
    }

    if (config._nextDay) {
        config._a[HOUR] = 24;
    }

    // check for mismatching day of week
    if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== config._d.getDay()) {
        getParsingFlags(config).weekdayMismatch = true;
    }
}

function dayOfYearFromWeekInfo(config) {
    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

    w = config._w;
    if (w.GG != null || w.W != null || w.E != null) {
        dow = 1;
        doy = 4;

        // TODO: We need to take the current isoWeekYear, but that depends on
        // how we interpret now (local, utc, fixed offset). So create
        // a now version of current config (take local/utc/offset flags, and
        // create now).
        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
        week = defaults(w.W, 1);
        weekday = defaults(w.E, 1);
        if (weekday < 1 || weekday > 7) {
            weekdayOverflow = true;
        }
    } else {
        dow = config._locale._week.dow;
        doy = config._locale._week.doy;

        var curWeek = weekOfYear(createLocal(), dow, doy);

        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

        // Default to current week.
        week = defaults(w.w, curWeek.week);

        if (w.d != null) {
            // weekday -- low day numbers are considered next week
            weekday = w.d;
            if (weekday < 0 || weekday > 6) {
                weekdayOverflow = true;
            }
        } else if (w.e != null) {
            // local weekday -- counting starts from begining of week
            weekday = w.e + dow;
            if (w.e < 0 || w.e > 6) {
                weekdayOverflow = true;
            }
        } else {
            // default to begining of week
            weekday = dow;
        }
    }
    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
        getParsingFlags(config)._overflowWeeks = true;
    } else if (weekdayOverflow != null) {
        getParsingFlags(config)._overflowWeekday = true;
    } else {
        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
    }
}

// iso 8601 regex
// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

var isoDates = [
    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
    ['YYYY-DDD', /\d{4}-\d{3}/],
    ['YYYY-MM', /\d{4}-\d\d/, false],
    ['YYYYYYMMDD', /[+-]\d{10}/],
    ['YYYYMMDD', /\d{8}/],
    // YYYYMM is NOT allowed by the standard
    ['GGGG[W]WWE', /\d{4}W\d{3}/],
    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
    ['YYYYDDD', /\d{7}/]
];

// iso time formats and regexes
var isoTimes = [
    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
    ['HH:mm', /\d\d:\d\d/],
    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
    ['HHmmss', /\d\d\d\d\d\d/],
    ['HHmm', /\d\d\d\d/],
    ['HH', /\d\d/]
];

var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

// date from iso format
function configFromISO(config) {
    var i, l,
        string = config._i,
        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
        allowTime, dateFormat, timeFormat, tzFormat;

    if (match) {
        getParsingFlags(config).iso = true;

        for (i = 0, l = isoDates.length; i < l; i++) {
            if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
        }
        if (dateFormat == null) {
            config._isValid = false;
            return;
        }
        if (match[3]) {
            for (i = 0, l = isoTimes.length; i < l; i++) {
                if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
            }
            if (timeFormat == null) {
                config._isValid = false;
                return;
            }
        }
        if (!allowTime && timeFormat != null) {
            config._isValid = false;
            return;
        }
        if (match[4]) {
            if (tzRegex.exec(match[4])) {
                tzFormat = 'Z';
            } else {
                config._isValid = false;
                return;
            }
        }
        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
        configFromStringAndFormat(config);
    } else {
        config._isValid = false;
    }
}

// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
    var result = [
        untruncateYear(yearStr),
        defaultLocaleMonthsShort.indexOf(monthStr),
        parseInt(dayStr, 10),
        parseInt(hourStr, 10),
        parseInt(minuteStr, 10)
    ];

    if (secondStr) {
        result.push(parseInt(secondStr, 10));
    }

    return result;
}

function untruncateYear(yearStr) {
    var year = parseInt(yearStr, 10);
    if (year <= 49) {
        return 2000 + year;
    } else if (year <= 999) {
        return 1900 + year;
    }
    return year;
}

function preprocessRFC2822(s) {
    // Remove comments and folding whitespace and replace multiple-spaces with a single space
    return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').trim();
}

function checkWeekday(weekdayStr, parsedInput, config) {
    if (weekdayStr) {
        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
        var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
            weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
        if (weekdayProvided !== weekdayActual) {
            getParsingFlags(config).weekdayMismatch = true;
            config._isValid = false;
            return false;
        }
    }
    return true;
}

var obsOffsets = {
    UT: 0,
    GMT: 0,
    EDT: -4 * 60,
    EST: -5 * 60,
    CDT: -5 * 60,
    CST: -6 * 60,
    MDT: -6 * 60,
    MST: -7 * 60,
    PDT: -7 * 60,
    PST: -8 * 60
};

function calculateOffset(obsOffset, militaryOffset, numOffset) {
    if (obsOffset) {
        return obsOffsets[obsOffset];
    } else if (militaryOffset) {
        // the only allowed military tz is Z
        return 0;
    } else {
        var hm = parseInt(numOffset, 10);
        var m = hm % 100, h = (hm - m) / 100;
        return h * 60 + m;
    }
}

// date and time from ref 2822 format
function configFromRFC2822(config) {
    var match = rfc2822.exec(preprocessRFC2822(config._i));
    if (match) {
        var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
        if (!checkWeekday(match[1], parsedArray, config)) {
            return;
        }

        config._a = parsedArray;
        config._tzm = calculateOffset(match[8], match[9], match[10]);

        config._d = createUTCDate.apply(null, config._a);
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

        getParsingFlags(config).rfc2822 = true;
    } else {
        config._isValid = false;
    }
}

// date from iso format or fallback
function configFromString(config) {
    var matched = aspNetJsonRegex.exec(config._i);

    if (matched !== null) {
        config._d = new Date(+matched[1]);
        return;
    }

    configFromISO(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    configFromRFC2822(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    // Final attempt, use Input Fallback
    hooks.createFromInputFallback(config);
}

hooks.createFromInputFallback = deprecate(
    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
    'discouraged and will be removed in an upcoming major release. Please refer to ' +
    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
    function (config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    }
);

// constant that refers to the ISO standard
hooks.ISO_8601 = function () {};

// constant that refers to the RFC 2822 form
hooks.RFC_2822 = function () {};

// date from string and format string
function configFromStringAndFormat(config) {
    // TODO: Move this to another part of the creation flow to prevent circular deps
    if (config._f === hooks.ISO_8601) {
        configFromISO(config);
        return;
    }
    if (config._f === hooks.RFC_2822) {
        configFromRFC2822(config);
        return;
    }
    config._a = [];
    getParsingFlags(config).empty = true;

    // This array is used to make a Date, either with `new Date` or `Date.UTC`
    var string = '' + config._i,
        i, parsedInput, tokens, token, skipped,
        stringLength = string.length,
        totalParsedInputLength = 0;

    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

    for (i = 0; i < tokens.length; i++) {
        token = tokens[i];
        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
        // console.log('token', token, 'parsedInput', parsedInput,
        //         'regex', getParseRegexForToken(token, config));
        if (parsedInput) {
            skipped = string.substr(0, string.indexOf(parsedInput));
            if (skipped.length > 0) {
                getParsingFlags(config).unusedInput.push(skipped);
            }
            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
            totalParsedInputLength += parsedInput.length;
        }
        // don't parse if it's not a known token
        if (formatTokenFunctions[token]) {
            if (parsedInput) {
                getParsingFlags(config).empty = false;
            }
            else {
                getParsingFlags(config).unusedTokens.push(token);
            }
            addTimeToArrayFromToken(token, parsedInput, config);
        }
        else if (config._strict && !parsedInput) {
            getParsingFlags(config).unusedTokens.push(token);
        }
    }

    // add remaining unparsed input length to the string
    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
    if (string.length > 0) {
        getParsingFlags(config).unusedInput.push(string);
    }

    // clear _12h flag if hour is <= 12
    if (config._a[HOUR] <= 12 &&
        getParsingFlags(config).bigHour === true &&
        config._a[HOUR] > 0) {
        getParsingFlags(config).bigHour = undefined;
    }

    getParsingFlags(config).parsedDateParts = config._a.slice(0);
    getParsingFlags(config).meridiem = config._meridiem;
    // handle meridiem
    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

    configFromArray(config);
    checkOverflow(config);
}


function meridiemFixWrap (locale, hour, meridiem) {
    var isPm;

    if (meridiem == null) {
        // nothing to do
        return hour;
    }
    if (locale.meridiemHour != null) {
        return locale.meridiemHour(hour, meridiem);
    } else if (locale.isPM != null) {
        // Fallback
        isPm = locale.isPM(meridiem);
        if (isPm && hour < 12) {
            hour += 12;
        }
        if (!isPm && hour === 12) {
            hour = 0;
        }
        return hour;
    } else {
        // this is not supposed to happen
        return hour;
    }
}

// date from string and array of format strings
function configFromStringAndArray(config) {
    var tempConfig,
        bestMoment,

        scoreToBeat,
        i,
        currentScore;

    if (config._f.length === 0) {
        getParsingFlags(config).invalidFormat = true;
        config._d = new Date(NaN);
        return;
    }

    for (i = 0; i < config._f.length; i++) {
        currentScore = 0;
        tempConfig = copyConfig({}, config);
        if (config._useUTC != null) {
            tempConfig._useUTC = config._useUTC;
        }
        tempConfig._f = config._f[i];
        configFromStringAndFormat(tempConfig);

        if (!isValid(tempConfig)) {
            continue;
        }

        // if there is any input that was not parsed add a penalty for that format
        currentScore += getParsingFlags(tempConfig).charsLeftOver;

        //or tokens
        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

        getParsingFlags(tempConfig).score = currentScore;

        if (scoreToBeat == null || currentScore < scoreToBeat) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
        }
    }

    extend(config, bestMoment || tempConfig);
}

function configFromObject(config) {
    if (config._d) {
        return;
    }

    var i = normalizeObjectUnits(config._i);
    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
        return obj && parseInt(obj, 10);
    });

    configFromArray(config);
}

function createFromConfig (config) {
    var res = new Moment(checkOverflow(prepareConfig(config)));
    if (res._nextDay) {
        // Adding is smart enough around DST
        res.add(1, 'd');
        res._nextDay = undefined;
    }

    return res;
}

function prepareConfig (config) {
    var input = config._i,
        format = config._f;

    config._locale = config._locale || getLocale(config._l);

    if (input === null || (format === undefined && input === '')) {
        return createInvalid({nullInput: true});
    }

    if (typeof input === 'string') {
        config._i = input = config._locale.preparse(input);
    }

    if (isMoment(input)) {
        return new Moment(checkOverflow(input));
    } else if (isDate(input)) {
        config._d = input;
    } else if (isArray(format)) {
        configFromStringAndArray(config);
    } else if (format) {
        configFromStringAndFormat(config);
    }  else {
        configFromInput(config);
    }

    if (!isValid(config)) {
        config._d = null;
    }

    return config;
}

function configFromInput(config) {
    var input = config._i;
    if (isUndefined(input)) {
        config._d = new Date(hooks.now());
    } else if (isDate(input)) {
        config._d = new Date(input.valueOf());
    } else if (typeof input === 'string') {
        configFromString(config);
    } else if (isArray(input)) {
        config._a = map(input.slice(0), function (obj) {
            return parseInt(obj, 10);
        });
        configFromArray(config);
    } else if (isObject(input)) {
        configFromObject(config);
    } else if (isNumber(input)) {
        // from milliseconds
        config._d = new Date(input);
    } else {
        hooks.createFromInputFallback(config);
    }
}

function createLocalOrUTC (input, format, locale, strict, isUTC) {
    var c = {};

    if (locale === true || locale === false) {
        strict = locale;
        locale = undefined;
    }

    if ((isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)) {
        input = undefined;
    }
    // object construction must be done this way.
    // https://github.com/moment/moment/issues/1423
    c._isAMomentObject = true;
    c._useUTC = c._isUTC = isUTC;
    c._l = locale;
    c._i = input;
    c._f = format;
    c._strict = strict;

    return createFromConfig(c);
}

function createLocal (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, false);
}

var prototypeMin = deprecate(
    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other < this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

var prototypeMax = deprecate(
    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other > this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

// Pick a moment m from moments so that m[fn](other) is true for all
// other. This relies on the function fn to be transitive.
//
// moments should either be an array of moment objects or an array, whose
// first element is an array of moment objects.
function pickBy(fn, moments) {
    var res, i;
    if (moments.length === 1 && isArray(moments[0])) {
        moments = moments[0];
    }
    if (!moments.length) {
        return createLocal();
    }
    res = moments[0];
    for (i = 1; i < moments.length; ++i) {
        if (!moments[i].isValid() || moments[i][fn](res)) {
            res = moments[i];
        }
    }
    return res;
}

// TODO: Use [].sort instead?
function min () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isBefore', args);
}

function max () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isAfter', args);
}

var now = function () {
    return Date.now ? Date.now() : +(new Date());
};

var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

function isDurationValid(m) {
    for (var key in m) {
        if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
            return false;
        }
    }

    var unitHasDecimal = false;
    for (var i = 0; i < ordering.length; ++i) {
        if (m[ordering[i]]) {
            if (unitHasDecimal) {
                return false; // only allow non-integers for smallest unit
            }
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                unitHasDecimal = true;
            }
        }
    }

    return true;
}

function isValid$1() {
    return this._isValid;
}

function createInvalid$1() {
    return createDuration(NaN);
}

function Duration (duration) {
    var normalizedInput = normalizeObjectUnits(duration),
        years = normalizedInput.year || 0,
        quarters = normalizedInput.quarter || 0,
        months = normalizedInput.month || 0,
        weeks = normalizedInput.week || 0,
        days = normalizedInput.day || 0,
        hours = normalizedInput.hour || 0,
        minutes = normalizedInput.minute || 0,
        seconds = normalizedInput.second || 0,
        milliseconds = normalizedInput.millisecond || 0;

    this._isValid = isDurationValid(normalizedInput);

    // representation for dateAddRemove
    this._milliseconds = +milliseconds +
        seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
    // Because of dateAddRemove treats 24 hours as different from a
    // day when working around DST, we need to store them separately
    this._days = +days +
        weeks * 7;
    // It is impossible to translate months into days without knowing
    // which months you are are talking about, so we have to store
    // it separately.
    this._months = +months +
        quarters * 3 +
        years * 12;

    this._data = {};

    this._locale = getLocale();

    this._bubble();
}

function isDuration (obj) {
    return obj instanceof Duration;
}

function absRound (number) {
    if (number < 0) {
        return Math.round(-1 * number) * -1;
    } else {
        return Math.round(number);
    }
}

// FORMATTING

function offset (token, separator) {
    addFormatToken(token, 0, 0, function () {
        var offset = this.utcOffset();
        var sign = '+';
        if (offset < 0) {
            offset = -offset;
            sign = '-';
        }
        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
    });
}

offset('Z', ':');
offset('ZZ', '');

// PARSING

addRegexToken('Z',  matchShortOffset);
addRegexToken('ZZ', matchShortOffset);
addParseToken(['Z', 'ZZ'], function (input, array, config) {
    config._useUTC = true;
    config._tzm = offsetFromString(matchShortOffset, input);
});

// HELPERS

// timezone chunker
// '+10:00' > ['10',  '00']
// '-1530'  > ['-15', '30']
var chunkOffset = /([\+\-]|\d\d)/gi;

function offsetFromString(matcher, string) {
    var matches = (string || '').match(matcher);

    if (matches === null) {
        return null;
    }

    var chunk   = matches[matches.length - 1] || [];
    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
    var minutes = +(parts[1] * 60) + toInt(parts[2]);

    return minutes === 0 ?
      0 :
      parts[0] === '+' ? minutes : -minutes;
}

// Return a moment from input, that is local/utc/zone equivalent to model.
function cloneWithOffset(input, model) {
    var res, diff;
    if (model._isUTC) {
        res = model.clone();
        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
        // Use low-level api, because this fn is low-level api.
        res._d.setTime(res._d.valueOf() + diff);
        hooks.updateOffset(res, false);
        return res;
    } else {
        return createLocal(input).local();
    }
}

function getDateOffset (m) {
    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
    // https://github.com/moment/moment/pull/1871
    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
}

// HOOKS

// This function will be called whenever a moment is mutated.
// It is intended to keep the offset in sync with the timezone.
hooks.updateOffset = function () {};

// MOMENTS

// keepLocalTime = true means only change the timezone, without
// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
// +0200, so we adjust the time as needed, to be valid.
//
// Keeping the time actually adds/subtracts (one hour)
// from the actual represented time. That is why we call updateOffset
// a second time. In case it wants us to change the offset again
// _changeInProgress == true case, then we have to adjust, because
// there is no such time in the given timezone.
function getSetOffset (input, keepLocalTime, keepMinutes) {
    var offset = this._offset || 0,
        localAdjust;
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    if (input != null) {
        if (typeof input === 'string') {
            input = offsetFromString(matchShortOffset, input);
            if (input === null) {
                return this;
            }
        } else if (Math.abs(input) < 16 && !keepMinutes) {
            input = input * 60;
        }
        if (!this._isUTC && keepLocalTime) {
            localAdjust = getDateOffset(this);
        }
        this._offset = input;
        this._isUTC = true;
        if (localAdjust != null) {
            this.add(localAdjust, 'm');
        }
        if (offset !== input) {
            if (!keepLocalTime || this._changeInProgress) {
                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
            } else if (!this._changeInProgress) {
                this._changeInProgress = true;
                hooks.updateOffset(this, true);
                this._changeInProgress = null;
            }
        }
        return this;
    } else {
        return this._isUTC ? offset : getDateOffset(this);
    }
}

function getSetZone (input, keepLocalTime) {
    if (input != null) {
        if (typeof input !== 'string') {
            input = -input;
        }

        this.utcOffset(input, keepLocalTime);

        return this;
    } else {
        return -this.utcOffset();
    }
}

function setOffsetToUTC (keepLocalTime) {
    return this.utcOffset(0, keepLocalTime);
}

function setOffsetToLocal (keepLocalTime) {
    if (this._isUTC) {
        this.utcOffset(0, keepLocalTime);
        this._isUTC = false;

        if (keepLocalTime) {
            this.subtract(getDateOffset(this), 'm');
        }
    }
    return this;
}

function setOffsetToParsedOffset () {
    if (this._tzm != null) {
        this.utcOffset(this._tzm, false, true);
    } else if (typeof this._i === 'string') {
        var tZone = offsetFromString(matchOffset, this._i);
        if (tZone != null) {
            this.utcOffset(tZone);
        }
        else {
            this.utcOffset(0, true);
        }
    }
    return this;
}

function hasAlignedHourOffset (input) {
    if (!this.isValid()) {
        return false;
    }
    input = input ? createLocal(input).utcOffset() : 0;

    return (this.utcOffset() - input) % 60 === 0;
}

function isDaylightSavingTime () {
    return (
        this.utcOffset() > this.clone().month(0).utcOffset() ||
        this.utcOffset() > this.clone().month(5).utcOffset()
    );
}

function isDaylightSavingTimeShifted () {
    if (!isUndefined(this._isDSTShifted)) {
        return this._isDSTShifted;
    }

    var c = {};

    copyConfig(c, this);
    c = prepareConfig(c);

    if (c._a) {
        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
        this._isDSTShifted = this.isValid() &&
            compareArrays(c._a, other.toArray()) > 0;
    } else {
        this._isDSTShifted = false;
    }

    return this._isDSTShifted;
}

function isLocal () {
    return this.isValid() ? !this._isUTC : false;
}

function isUtcOffset () {
    return this.isValid() ? this._isUTC : false;
}

function isUtc () {
    return this.isValid() ? this._isUTC && this._offset === 0 : false;
}

// ASP.NET json date format regex
var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
// and further modified to allow for strings containing both week and day
var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

function createDuration (input, key) {
    var duration = input,
        // matching against regexp is expensive, do it on demand
        match = null,
        sign,
        ret,
        diffRes;

    if (isDuration(input)) {
        duration = {
            ms : input._milliseconds,
            d  : input._days,
            M  : input._months
        };
    } else if (isNumber(input)) {
        duration = {};
        if (key) {
            duration[key] = input;
        } else {
            duration.milliseconds = input;
        }
    } else if (!!(match = aspNetRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : 1;
        duration = {
            y  : 0,
            d  : toInt(match[DATE])                         * sign,
            h  : toInt(match[HOUR])                         * sign,
            m  : toInt(match[MINUTE])                       * sign,
            s  : toInt(match[SECOND])                       * sign,
            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
        };
    } else if (!!(match = isoRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
        duration = {
            y : parseIso(match[2], sign),
            M : parseIso(match[3], sign),
            w : parseIso(match[4], sign),
            d : parseIso(match[5], sign),
            h : parseIso(match[6], sign),
            m : parseIso(match[7], sign),
            s : parseIso(match[8], sign)
        };
    } else if (duration == null) {// checks for null or undefined
        duration = {};
    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

        duration = {};
        duration.ms = diffRes.milliseconds;
        duration.M = diffRes.months;
    }

    ret = new Duration(duration);

    if (isDuration(input) && hasOwnProp(input, '_locale')) {
        ret._locale = input._locale;
    }

    return ret;
}

createDuration.fn = Duration.prototype;
createDuration.invalid = createInvalid$1;

function parseIso (inp, sign) {
    // We'd normally use ~~inp for this, but unfortunately it also
    // converts floats to ints.
    // inp may be undefined, so careful calling replace on it.
    var res = inp && parseFloat(inp.replace(',', '.'));
    // apply sign while we're at it
    return (isNaN(res) ? 0 : res) * sign;
}

function positiveMomentsDifference(base, other) {
    var res = {milliseconds: 0, months: 0};

    res.months = other.month() - base.month() +
        (other.year() - base.year()) * 12;
    if (base.clone().add(res.months, 'M').isAfter(other)) {
        --res.months;
    }

    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

    return res;
}

function momentsDifference(base, other) {
    var res;
    if (!(base.isValid() && other.isValid())) {
        return {milliseconds: 0, months: 0};
    }

    other = cloneWithOffset(other, base);
    if (base.isBefore(other)) {
        res = positiveMomentsDifference(base, other);
    } else {
        res = positiveMomentsDifference(other, base);
        res.milliseconds = -res.milliseconds;
        res.months = -res.months;
    }

    return res;
}

// TODO: remove 'name' arg after deprecation is removed
function createAdder(direction, name) {
    return function (val, period) {
        var dur, tmp;
        //invert the arguments, but complain about it
        if (period !== null && !isNaN(+period)) {
            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
            tmp = val; val = period; period = tmp;
        }

        val = typeof val === 'string' ? +val : val;
        dur = createDuration(val, period);
        addSubtract(this, dur, direction);
        return this;
    };
}

function addSubtract (mom, duration, isAdding, updateOffset) {
    var milliseconds = duration._milliseconds,
        days = absRound(duration._days),
        months = absRound(duration._months);

    if (!mom.isValid()) {
        // No op
        return;
    }

    updateOffset = updateOffset == null ? true : updateOffset;

    if (months) {
        setMonth(mom, get(mom, 'Month') + months * isAdding);
    }
    if (days) {
        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
    }
    if (milliseconds) {
        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
    }
    if (updateOffset) {
        hooks.updateOffset(mom, days || months);
    }
}

var add      = createAdder(1, 'add');
var subtract = createAdder(-1, 'subtract');

function getCalendarFormat(myMoment, now) {
    var diff = myMoment.diff(now, 'days', true);
    return diff < -6 ? 'sameElse' :
            diff < -1 ? 'lastWeek' :
            diff < 0 ? 'lastDay' :
            diff < 1 ? 'sameDay' :
            diff < 2 ? 'nextDay' :
            diff < 7 ? 'nextWeek' : 'sameElse';
}

function calendar$1 (time, formats) {
    // We want to compare the start of today, vs this.
    // Getting start-of-today depends on whether we're local/utc/offset or not.
    var now = time || createLocal(),
        sod = cloneWithOffset(now, this).startOf('day'),
        format = hooks.calendarFormat(this, sod) || 'sameElse';

    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
}

function clone () {
    return new Moment(this);
}

function isAfter (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() > localInput.valueOf();
    } else {
        return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
}

function isBefore (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() < localInput.valueOf();
    } else {
        return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
}

function isBetween (from, to, units, inclusivity) {
    inclusivity = inclusivity || '()';
    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
}

function isSame (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input),
        inputMs;
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(units || 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() === localInput.valueOf();
    } else {
        inputMs = localInput.valueOf();
        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
    }
}

function isSameOrAfter (input, units) {
    return this.isSame(input, units) || this.isAfter(input,units);
}

function isSameOrBefore (input, units) {
    return this.isSame(input, units) || this.isBefore(input,units);
}

function diff (input, units, asFloat) {
    var that,
        zoneDelta,
        delta, output;

    if (!this.isValid()) {
        return NaN;
    }

    that = cloneWithOffset(input, this);

    if (!that.isValid()) {
        return NaN;
    }

    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

    units = normalizeUnits(units);

    switch (units) {
        case 'year': output = monthDiff(this, that) / 12; break;
        case 'month': output = monthDiff(this, that); break;
        case 'quarter': output = monthDiff(this, that) / 3; break;
        case 'second': output = (this - that) / 1e3; break; // 1000
        case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
        case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
        case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
        case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
        default: output = this - that;
    }

    return asFloat ? output : absFloor(output);
}

function monthDiff (a, b) {
    // difference in months
    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
        // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'),
        anchor2, adjust;

    if (b - anchor < 0) {
        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor - anchor2);
    } else {
        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor2 - anchor);
    }

    //check for negative zero, return zero if negative zero
    return -(wholeMonthDiff + adjust) || 0;
}

hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

function toString () {
    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
}

function toISOString() {
    if (!this.isValid()) {
        return null;
    }
    var m = this.clone().utc();
    if (m.year() < 0 || m.year() > 9999) {
        return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
    }
    if (isFunction(Date.prototype.toISOString)) {
        // native implementation is ~50x faster, use it when we can
        return this.toDate().toISOString();
    }
    return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
}

/**
 * Return a human readable representation of a moment that can
 * also be evaluated to get a new moment which is the same
 *
 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
 */
function inspect () {
    if (!this.isValid()) {
        return 'moment.invalid(/* ' + this._i + ' */)';
    }
    var func = 'moment';
    var zone = '';
    if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
        zone = 'Z';
    }
    var prefix = '[' + func + '("]';
    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
    var suffix = zone + '[")]';

    return this.format(prefix + year + datetime + suffix);
}

function format (inputString) {
    if (!inputString) {
        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
    }
    var output = formatMoment(this, inputString);
    return this.localeData().postformat(output);
}

function from (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function fromNow (withoutSuffix) {
    return this.from(createLocal(), withoutSuffix);
}

function to (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function toNow (withoutSuffix) {
    return this.to(createLocal(), withoutSuffix);
}

// If passed a locale key, it will set the locale for this
// instance.  Otherwise, it will return the locale configuration
// variables for this instance.
function locale (key) {
    var newLocaleData;

    if (key === undefined) {
        return this._locale._abbr;
    } else {
        newLocaleData = getLocale(key);
        if (newLocaleData != null) {
            this._locale = newLocaleData;
        }
        return this;
    }
}

var lang = deprecate(
    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
    function (key) {
        if (key === undefined) {
            return this.localeData();
        } else {
            return this.locale(key);
        }
    }
);

function localeData () {
    return this._locale;
}

function startOf (units) {
    units = normalizeUnits(units);
    // the following switch intentionally omits break keywords
    // to utilize falling through the cases.
    switch (units) {
        case 'year':
            this.month(0);
            /* falls through */
        case 'quarter':
        case 'month':
            this.date(1);
            /* falls through */
        case 'week':
        case 'isoWeek':
        case 'day':
        case 'date':
            this.hours(0);
            /* falls through */
        case 'hour':
            this.minutes(0);
            /* falls through */
        case 'minute':
            this.seconds(0);
            /* falls through */
        case 'second':
            this.milliseconds(0);
    }

    // weeks are a special case
    if (units === 'week') {
        this.weekday(0);
    }
    if (units === 'isoWeek') {
        this.isoWeekday(1);
    }

    // quarters are also special
    if (units === 'quarter') {
        this.month(Math.floor(this.month() / 3) * 3);
    }

    return this;
}

function endOf (units) {
    units = normalizeUnits(units);
    if (units === undefined || units === 'millisecond') {
        return this;
    }

    // 'date' is an alias for 'day', so it should be considered as such.
    if (units === 'date') {
        units = 'day';
    }

    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
}

function valueOf () {
    return this._d.valueOf() - ((this._offset || 0) * 60000);
}

function unix () {
    return Math.floor(this.valueOf() / 1000);
}

function toDate () {
    return new Date(this.valueOf());
}

function toArray () {
    var m = this;
    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
}

function toObject () {
    var m = this;
    return {
        years: m.year(),
        months: m.month(),
        date: m.date(),
        hours: m.hours(),
        minutes: m.minutes(),
        seconds: m.seconds(),
        milliseconds: m.milliseconds()
    };
}

function toJSON () {
    // new Date(NaN).toJSON() === null
    return this.isValid() ? this.toISOString() : null;
}

function isValid$2 () {
    return isValid(this);
}

function parsingFlags () {
    return extend({}, getParsingFlags(this));
}

function invalidAt () {
    return getParsingFlags(this).overflow;
}

function creationData() {
    return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
    };
}

// FORMATTING

addFormatToken(0, ['gg', 2], 0, function () {
    return this.weekYear() % 100;
});

addFormatToken(0, ['GG', 2], 0, function () {
    return this.isoWeekYear() % 100;
});

function addWeekYearFormatToken (token, getter) {
    addFormatToken(0, [token, token.length], 0, getter);
}

addWeekYearFormatToken('gggg',     'weekYear');
addWeekYearFormatToken('ggggg',    'weekYear');
addWeekYearFormatToken('GGGG',  'isoWeekYear');
addWeekYearFormatToken('GGGGG', 'isoWeekYear');

// ALIASES

addUnitAlias('weekYear', 'gg');
addUnitAlias('isoWeekYear', 'GG');

// PRIORITY

addUnitPriority('weekYear', 1);
addUnitPriority('isoWeekYear', 1);


// PARSING

addRegexToken('G',      matchSigned);
addRegexToken('g',      matchSigned);
addRegexToken('GG',     match1to2, match2);
addRegexToken('gg',     match1to2, match2);
addRegexToken('GGGG',   match1to4, match4);
addRegexToken('gggg',   match1to4, match4);
addRegexToken('GGGGG',  match1to6, match6);
addRegexToken('ggggg',  match1to6, match6);

addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
    week[token.substr(0, 2)] = toInt(input);
});

addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
    week[token] = hooks.parseTwoDigitYear(input);
});

// MOMENTS

function getSetWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy);
}

function getSetISOWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input, this.isoWeek(), this.isoWeekday(), 1, 4);
}

function getISOWeeksInYear () {
    return weeksInYear(this.year(), 1, 4);
}

function getWeeksInYear () {
    var weekInfo = this.localeData()._week;
    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
}

function getSetWeekYearHelper(input, week, weekday, dow, doy) {
    var weeksTarget;
    if (input == null) {
        return weekOfYear(this, dow, doy).year;
    } else {
        weeksTarget = weeksInYear(input, dow, doy);
        if (week > weeksTarget) {
            week = weeksTarget;
        }
        return setWeekAll.call(this, input, week, weekday, dow, doy);
    }
}

function setWeekAll(weekYear, week, weekday, dow, doy) {
    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

    this.year(date.getUTCFullYear());
    this.month(date.getUTCMonth());
    this.date(date.getUTCDate());
    return this;
}

// FORMATTING

addFormatToken('Q', 0, 'Qo', 'quarter');

// ALIASES

addUnitAlias('quarter', 'Q');

// PRIORITY

addUnitPriority('quarter', 7);

// PARSING

addRegexToken('Q', match1);
addParseToken('Q', function (input, array) {
    array[MONTH] = (toInt(input) - 1) * 3;
});

// MOMENTS

function getSetQuarter (input) {
    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
}

// FORMATTING

addFormatToken('D', ['DD', 2], 'Do', 'date');

// ALIASES

addUnitAlias('date', 'D');

// PRIOROITY
addUnitPriority('date', 9);

// PARSING

addRegexToken('D',  match1to2);
addRegexToken('DD', match1to2, match2);
addRegexToken('Do', function (isStrict, locale) {
    // TODO: Remove "ordinalParse" fallback in next major release.
    return isStrict ?
      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
      locale._dayOfMonthOrdinalParseLenient;
});

addParseToken(['D', 'DD'], DATE);
addParseToken('Do', function (input, array) {
    array[DATE] = toInt(input.match(match1to2)[0], 10);
});

// MOMENTS

var getSetDayOfMonth = makeGetSet('Date', true);

// FORMATTING

addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

// ALIASES

addUnitAlias('dayOfYear', 'DDD');

// PRIORITY
addUnitPriority('dayOfYear', 4);

// PARSING

addRegexToken('DDD',  match1to3);
addRegexToken('DDDD', match3);
addParseToken(['DDD', 'DDDD'], function (input, array, config) {
    config._dayOfYear = toInt(input);
});

// HELPERS

// MOMENTS

function getSetDayOfYear (input) {
    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
}

// FORMATTING

addFormatToken('m', ['mm', 2], 0, 'minute');

// ALIASES

addUnitAlias('minute', 'm');

// PRIORITY

addUnitPriority('minute', 14);

// PARSING

addRegexToken('m',  match1to2);
addRegexToken('mm', match1to2, match2);
addParseToken(['m', 'mm'], MINUTE);

// MOMENTS

var getSetMinute = makeGetSet('Minutes', false);

// FORMATTING

addFormatToken('s', ['ss', 2], 0, 'second');

// ALIASES

addUnitAlias('second', 's');

// PRIORITY

addUnitPriority('second', 15);

// PARSING

addRegexToken('s',  match1to2);
addRegexToken('ss', match1to2, match2);
addParseToken(['s', 'ss'], SECOND);

// MOMENTS

var getSetSecond = makeGetSet('Seconds', false);

// FORMATTING

addFormatToken('S', 0, 0, function () {
    return ~~(this.millisecond() / 100);
});

addFormatToken(0, ['SS', 2], 0, function () {
    return ~~(this.millisecond() / 10);
});

addFormatToken(0, ['SSS', 3], 0, 'millisecond');
addFormatToken(0, ['SSSS', 4], 0, function () {
    return this.millisecond() * 10;
});
addFormatToken(0, ['SSSSS', 5], 0, function () {
    return this.millisecond() * 100;
});
addFormatToken(0, ['SSSSSS', 6], 0, function () {
    return this.millisecond() * 1000;
});
addFormatToken(0, ['SSSSSSS', 7], 0, function () {
    return this.millisecond() * 10000;
});
addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
    return this.millisecond() * 100000;
});
addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
    return this.millisecond() * 1000000;
});


// ALIASES

addUnitAlias('millisecond', 'ms');

// PRIORITY

addUnitPriority('millisecond', 16);

// PARSING

addRegexToken('S',    match1to3, match1);
addRegexToken('SS',   match1to3, match2);
addRegexToken('SSS',  match1to3, match3);

var token;
for (token = 'SSSS'; token.length <= 9; token += 'S') {
    addRegexToken(token, matchUnsigned);
}

function parseMs(input, array) {
    array[MILLISECOND] = toInt(('0.' + input) * 1000);
}

for (token = 'S'; token.length <= 9; token += 'S') {
    addParseToken(token, parseMs);
}
// MOMENTS

var getSetMillisecond = makeGetSet('Milliseconds', false);

// FORMATTING

addFormatToken('z',  0, 0, 'zoneAbbr');
addFormatToken('zz', 0, 0, 'zoneName');

// MOMENTS

function getZoneAbbr () {
    return this._isUTC ? 'UTC' : '';
}

function getZoneName () {
    return this._isUTC ? 'Coordinated Universal Time' : '';
}

var proto = Moment.prototype;

proto.add               = add;
proto.calendar          = calendar$1;
proto.clone             = clone;
proto.diff              = diff;
proto.endOf             = endOf;
proto.format            = format;
proto.from              = from;
proto.fromNow           = fromNow;
proto.to                = to;
proto.toNow             = toNow;
proto.get               = stringGet;
proto.invalidAt         = invalidAt;
proto.isAfter           = isAfter;
proto.isBefore          = isBefore;
proto.isBetween         = isBetween;
proto.isSame            = isSame;
proto.isSameOrAfter     = isSameOrAfter;
proto.isSameOrBefore    = isSameOrBefore;
proto.isValid           = isValid$2;
proto.lang              = lang;
proto.locale            = locale;
proto.localeData        = localeData;
proto.max               = prototypeMax;
proto.min               = prototypeMin;
proto.parsingFlags      = parsingFlags;
proto.set               = stringSet;
proto.startOf           = startOf;
proto.subtract          = subtract;
proto.toArray           = toArray;
proto.toObject          = toObject;
proto.toDate            = toDate;
proto.toISOString       = toISOString;
proto.inspect           = inspect;
proto.toJSON            = toJSON;
proto.toString          = toString;
proto.unix              = unix;
proto.valueOf           = valueOf;
proto.creationData      = creationData;

// Year
proto.year       = getSetYear;
proto.isLeapYear = getIsLeapYear;

// Week Year
proto.weekYear    = getSetWeekYear;
proto.isoWeekYear = getSetISOWeekYear;

// Quarter
proto.quarter = proto.quarters = getSetQuarter;

// Month
proto.month       = getSetMonth;
proto.daysInMonth = getDaysInMonth;

// Week
proto.week           = proto.weeks        = getSetWeek;
proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
proto.weeksInYear    = getWeeksInYear;
proto.isoWeeksInYear = getISOWeeksInYear;

// Day
proto.date       = getSetDayOfMonth;
proto.day        = proto.days             = getSetDayOfWeek;
proto.weekday    = getSetLocaleDayOfWeek;
proto.isoWeekday = getSetISODayOfWeek;
proto.dayOfYear  = getSetDayOfYear;

// Hour
proto.hour = proto.hours = getSetHour;

// Minute
proto.minute = proto.minutes = getSetMinute;

// Second
proto.second = proto.seconds = getSetSecond;

// Millisecond
proto.millisecond = proto.milliseconds = getSetMillisecond;

// Offset
proto.utcOffset            = getSetOffset;
proto.utc                  = setOffsetToUTC;
proto.local                = setOffsetToLocal;
proto.parseZone            = setOffsetToParsedOffset;
proto.hasAlignedHourOffset = hasAlignedHourOffset;
proto.isDST                = isDaylightSavingTime;
proto.isLocal              = isLocal;
proto.isUtcOffset          = isUtcOffset;
proto.isUtc                = isUtc;
proto.isUTC                = isUtc;

// Timezone
proto.zoneAbbr = getZoneAbbr;
proto.zoneName = getZoneName;

// Deprecations
proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

function createUnix (input) {
    return createLocal(input * 1000);
}

function createInZone () {
    return createLocal.apply(null, arguments).parseZone();
}

function preParsePostFormat (string) {
    return string;
}

var proto$1 = Locale.prototype;

proto$1.calendar        = calendar;
proto$1.longDateFormat  = longDateFormat;
proto$1.invalidDate     = invalidDate;
proto$1.ordinal         = ordinal;
proto$1.preparse        = preParsePostFormat;
proto$1.postformat      = preParsePostFormat;
proto$1.relativeTime    = relativeTime;
proto$1.pastFuture      = pastFuture;
proto$1.set             = set;

// Month
proto$1.months            =        localeMonths;
proto$1.monthsShort       =        localeMonthsShort;
proto$1.monthsParse       =        localeMonthsParse;
proto$1.monthsRegex       = monthsRegex;
proto$1.monthsShortRegex  = monthsShortRegex;

// Week
proto$1.week = localeWeek;
proto$1.firstDayOfYear = localeFirstDayOfYear;
proto$1.firstDayOfWeek = localeFirstDayOfWeek;

// Day of Week
proto$1.weekdays       =        localeWeekdays;
proto$1.weekdaysMin    =        localeWeekdaysMin;
proto$1.weekdaysShort  =        localeWeekdaysShort;
proto$1.weekdaysParse  =        localeWeekdaysParse;

proto$1.weekdaysRegex       =        weekdaysRegex;
proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

// Hours
proto$1.isPM = localeIsPM;
proto$1.meridiem = localeMeridiem;

function get$1 (format, index, field, setter) {
    var locale = getLocale();
    var utc = createUTC().set(setter, index);
    return locale[field](utc, format);
}

function listMonthsImpl (format, index, field) {
    if (isNumber(format)) {
        index = format;
        format = undefined;
    }

    format = format || '';

    if (index != null) {
        return get$1(format, index, field, 'month');
    }

    var i;
    var out = [];
    for (i = 0; i < 12; i++) {
        out[i] = get$1(format, i, field, 'month');
    }
    return out;
}

// ()
// (5)
// (fmt, 5)
// (fmt)
// (true)
// (true, 5)
// (true, fmt, 5)
// (true, fmt)
function listWeekdaysImpl (localeSorted, format, index, field) {
    if (typeof localeSorted === 'boolean') {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    } else {
        format = localeSorted;
        index = format;
        localeSorted = false;

        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    }

    var locale = getLocale(),
        shift = localeSorted ? locale._week.dow : 0;

    if (index != null) {
        return get$1(format, (index + shift) % 7, field, 'day');
    }

    var i;
    var out = [];
    for (i = 0; i < 7; i++) {
        out[i] = get$1(format, (i + shift) % 7, field, 'day');
    }
    return out;
}

function listMonths (format, index) {
    return listMonthsImpl(format, index, 'months');
}

function listMonthsShort (format, index) {
    return listMonthsImpl(format, index, 'monthsShort');
}

function listWeekdays (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
}

function listWeekdaysShort (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
}

function listWeekdaysMin (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
}

getSetGlobalLocale('en', {
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (toInt(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    }
});

// Side effect imports
hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

var mathAbs = Math.abs;

function abs () {
    var data           = this._data;

    this._milliseconds = mathAbs(this._milliseconds);
    this._days         = mathAbs(this._days);
    this._months       = mathAbs(this._months);

    data.milliseconds  = mathAbs(data.milliseconds);
    data.seconds       = mathAbs(data.seconds);
    data.minutes       = mathAbs(data.minutes);
    data.hours         = mathAbs(data.hours);
    data.months        = mathAbs(data.months);
    data.years         = mathAbs(data.years);

    return this;
}

function addSubtract$1 (duration, input, value, direction) {
    var other = createDuration(input, value);

    duration._milliseconds += direction * other._milliseconds;
    duration._days         += direction * other._days;
    duration._months       += direction * other._months;

    return duration._bubble();
}

// supports only 2.0-style add(1, 's') or add(duration)
function add$1 (input, value) {
    return addSubtract$1(this, input, value, 1);
}

// supports only 2.0-style subtract(1, 's') or subtract(duration)
function subtract$1 (input, value) {
    return addSubtract$1(this, input, value, -1);
}

function absCeil (number) {
    if (number < 0) {
        return Math.floor(number);
    } else {
        return Math.ceil(number);
    }
}

function bubble () {
    var milliseconds = this._milliseconds;
    var days         = this._days;
    var months       = this._months;
    var data         = this._data;
    var seconds, minutes, hours, years, monthsFromDays;

    // if we have a mix of positive and negative values, bubble down first
    // check: https://github.com/moment/moment/issues/2166
    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
            (milliseconds <= 0 && days <= 0 && months <= 0))) {
        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
        days = 0;
        months = 0;
    }

    // The following code bubbles up values, see the tests for
    // examples of what that means.
    data.milliseconds = milliseconds % 1000;

    seconds           = absFloor(milliseconds / 1000);
    data.seconds      = seconds % 60;

    minutes           = absFloor(seconds / 60);
    data.minutes      = minutes % 60;

    hours             = absFloor(minutes / 60);
    data.hours        = hours % 24;

    days += absFloor(hours / 24);

    // convert days to months
    monthsFromDays = absFloor(daysToMonths(days));
    months += monthsFromDays;
    days -= absCeil(monthsToDays(monthsFromDays));

    // 12 months -> 1 year
    years = absFloor(months / 12);
    months %= 12;

    data.days   = days;
    data.months = months;
    data.years  = years;

    return this;
}

function daysToMonths (days) {
    // 400 years have 146097 days (taking into account leap year rules)
    // 400 years have 12 months === 4800
    return days * 4800 / 146097;
}

function monthsToDays (months) {
    // the reverse of daysToMonths
    return months * 146097 / 4800;
}

function as (units) {
    if (!this.isValid()) {
        return NaN;
    }
    var days;
    var months;
    var milliseconds = this._milliseconds;

    units = normalizeUnits(units);

    if (units === 'month' || units === 'year') {
        days   = this._days   + milliseconds / 864e5;
        months = this._months + daysToMonths(days);
        return units === 'month' ? months : months / 12;
    } else {
        // handle milliseconds separately because of floating point math errors (issue #1867)
        days = this._days + Math.round(monthsToDays(this._months));
        switch (units) {
            case 'week'   : return days / 7     + milliseconds / 6048e5;
            case 'day'    : return days         + milliseconds / 864e5;
            case 'hour'   : return days * 24    + milliseconds / 36e5;
            case 'minute' : return days * 1440  + milliseconds / 6e4;
            case 'second' : return days * 86400 + milliseconds / 1000;
            // Math.floor prevents floating point math errors here
            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
            default: throw new Error('Unknown unit ' + units);
        }
    }
}

// TODO: Use this.as('ms')?
function valueOf$1 () {
    if (!this.isValid()) {
        return NaN;
    }
    return (
        this._milliseconds +
        this._days * 864e5 +
        (this._months % 12) * 2592e6 +
        toInt(this._months / 12) * 31536e6
    );
}

function makeAs (alias) {
    return function () {
        return this.as(alias);
    };
}

var asMilliseconds = makeAs('ms');
var asSeconds      = makeAs('s');
var asMinutes      = makeAs('m');
var asHours        = makeAs('h');
var asDays         = makeAs('d');
var asWeeks        = makeAs('w');
var asMonths       = makeAs('M');
var asYears        = makeAs('y');

function clone$1 () {
    return createDuration(this);
}

function get$2 (units) {
    units = normalizeUnits(units);
    return this.isValid() ? this[units + 's']() : NaN;
}

function makeGetter(name) {
    return function () {
        return this.isValid() ? this._data[name] : NaN;
    };
}

var milliseconds = makeGetter('milliseconds');
var seconds      = makeGetter('seconds');
var minutes      = makeGetter('minutes');
var hours        = makeGetter('hours');
var days         = makeGetter('days');
var months       = makeGetter('months');
var years        = makeGetter('years');

function weeks () {
    return absFloor(this.days() / 7);
}

var round = Math.round;
var thresholds = {
    ss: 44,         // a few seconds to seconds
    s : 45,         // seconds to minute
    m : 45,         // minutes to hour
    h : 22,         // hours to day
    d : 26,         // days to month
    M : 11          // months to year
};

// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
}

function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
    var duration = createDuration(posNegDuration).abs();
    var seconds  = round(duration.as('s'));
    var minutes  = round(duration.as('m'));
    var hours    = round(duration.as('h'));
    var days     = round(duration.as('d'));
    var months   = round(duration.as('M'));
    var years    = round(duration.as('y'));

    var a = seconds <= thresholds.ss && ['s', seconds]  ||
            seconds < thresholds.s   && ['ss', seconds] ||
            minutes <= 1             && ['m']           ||
            minutes < thresholds.m   && ['mm', minutes] ||
            hours   <= 1             && ['h']           ||
            hours   < thresholds.h   && ['hh', hours]   ||
            days    <= 1             && ['d']           ||
            days    < thresholds.d   && ['dd', days]    ||
            months  <= 1             && ['M']           ||
            months  < thresholds.M   && ['MM', months]  ||
            years   <= 1             && ['y']           || ['yy', years];

    a[2] = withoutSuffix;
    a[3] = +posNegDuration > 0;
    a[4] = locale;
    return substituteTimeAgo.apply(null, a);
}

// This function allows you to set the rounding function for relative time strings
function getSetRelativeTimeRounding (roundingFunction) {
    if (roundingFunction === undefined) {
        return round;
    }
    if (typeof(roundingFunction) === 'function') {
        round = roundingFunction;
        return true;
    }
    return false;
}

// This function allows you to set a threshold for relative time strings
function getSetRelativeTimeThreshold (threshold, limit) {
    if (thresholds[threshold] === undefined) {
        return false;
    }
    if (limit === undefined) {
        return thresholds[threshold];
    }
    thresholds[threshold] = limit;
    if (threshold === 's') {
        thresholds.ss = limit - 1;
    }
    return true;
}

function humanize (withSuffix) {
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var locale = this.localeData();
    var output = relativeTime$1(this, !withSuffix, locale);

    if (withSuffix) {
        output = locale.pastFuture(+this, output);
    }

    return locale.postformat(output);
}

var abs$1 = Math.abs;

function sign(x) {
    return ((x > 0) - (x < 0)) || +x;
}

function toISOString$1() {
    // for ISO strings we do not use the normal bubbling rules:
    //  * milliseconds bubble up until they become hours
    //  * days do not bubble at all
    //  * months bubble up until they become years
    // This is because there is no context-free conversion between hours and days
    // (think of clock changes)
    // and also not between days and months (28-31 days per month)
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var seconds = abs$1(this._milliseconds) / 1000;
    var days         = abs$1(this._days);
    var months       = abs$1(this._months);
    var minutes, hours, years;

    // 3600 seconds -> 60 minutes -> 1 hour
    minutes           = absFloor(seconds / 60);
    hours             = absFloor(minutes / 60);
    seconds %= 60;
    minutes %= 60;

    // 12 months -> 1 year
    years  = absFloor(months / 12);
    months %= 12;


    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
    var Y = years;
    var M = months;
    var D = days;
    var h = hours;
    var m = minutes;
    var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
    var total = this.asSeconds();

    if (!total) {
        // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
    }

    var totalSign = total < 0 ? '-' : '';
    var ymSign = sign(this._months) !== sign(total) ? '-' : '';
    var daysSign = sign(this._days) !== sign(total) ? '-' : '';
    var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

    return totalSign + 'P' +
        (Y ? ymSign + Y + 'Y' : '') +
        (M ? ymSign + M + 'M' : '') +
        (D ? daysSign + D + 'D' : '') +
        ((h || m || s) ? 'T' : '') +
        (h ? hmsSign + h + 'H' : '') +
        (m ? hmsSign + m + 'M' : '') +
        (s ? hmsSign + s + 'S' : '');
}

var proto$2 = Duration.prototype;

proto$2.isValid        = isValid$1;
proto$2.abs            = abs;
proto$2.add            = add$1;
proto$2.subtract       = subtract$1;
proto$2.as             = as;
proto$2.asMilliseconds = asMilliseconds;
proto$2.asSeconds      = asSeconds;
proto$2.asMinutes      = asMinutes;
proto$2.asHours        = asHours;
proto$2.asDays         = asDays;
proto$2.asWeeks        = asWeeks;
proto$2.asMonths       = asMonths;
proto$2.asYears        = asYears;
proto$2.valueOf        = valueOf$1;
proto$2._bubble        = bubble;
proto$2.clone          = clone$1;
proto$2.get            = get$2;
proto$2.milliseconds   = milliseconds;
proto$2.seconds        = seconds;
proto$2.minutes        = minutes;
proto$2.hours          = hours;
proto$2.days           = days;
proto$2.weeks          = weeks;
proto$2.months         = months;
proto$2.years          = years;
proto$2.humanize       = humanize;
proto$2.toISOString    = toISOString$1;
proto$2.toString       = toISOString$1;
proto$2.toJSON         = toISOString$1;
proto$2.locale         = locale;
proto$2.localeData     = localeData;

// Deprecations
proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
proto$2.lang = lang;

// Side effect imports

// FORMATTING

addFormatToken('X', 0, 0, 'unix');
addFormatToken('x', 0, 0, 'valueOf');

// PARSING

addRegexToken('x', matchSigned);
addRegexToken('X', matchTimestamp);
addParseToken('X', function (input, array, config) {
    config._d = new Date(parseFloat(input, 10) * 1000);
});
addParseToken('x', function (input, array, config) {
    config._d = new Date(toInt(input));
});

// Side effect imports


hooks.version = '2.19.3';

setHookCallback(createLocal);

hooks.fn                    = proto;
hooks.min                   = min;
hooks.max                   = max;
hooks.now                   = now;
hooks.utc                   = createUTC;
hooks.unix                  = createUnix;
hooks.months                = listMonths;
hooks.isDate                = isDate;
hooks.locale                = getSetGlobalLocale;
hooks.invalid               = createInvalid;
hooks.duration              = createDuration;
hooks.isMoment              = isMoment;
hooks.weekdays              = listWeekdays;
hooks.parseZone             = createInZone;
hooks.localeData            = getLocale;
hooks.isDuration            = isDuration;
hooks.monthsShort           = listMonthsShort;
hooks.weekdaysMin           = listWeekdaysMin;
hooks.defineLocale          = defineLocale;
hooks.updateLocale          = updateLocale;
hooks.locales               = listLocales;
hooks.weekdaysShort         = listWeekdaysShort;
hooks.normalizeUnits        = normalizeUnits;
hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
hooks.calendarFormat        = getCalendarFormat;
hooks.prototype             = proto;

return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(48)(module)))

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(32);


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReactCSS = exports.loop = exports.handleActive = exports.handleHover = exports.hover = undefined;

var _flattenNames = __webpack_require__(490);

var _flattenNames2 = _interopRequireDefault(_flattenNames);

var _mergeClasses = __webpack_require__(563);

var _mergeClasses2 = _interopRequireDefault(_mergeClasses);

var _autoprefix = __webpack_require__(588);

var _autoprefix2 = _interopRequireDefault(_autoprefix);

var _hover2 = __webpack_require__(589);

var _hover3 = _interopRequireDefault(_hover2);

var _active = __webpack_require__(590);

var _active2 = _interopRequireDefault(_active);

var _loop2 = __webpack_require__(591);

var _loop3 = _interopRequireDefault(_loop2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.hover = _hover3.default;
exports.handleHover = _hover3.default;
exports.handleActive = _active2.default;
exports.loop = _loop3.default;
var ReactCSS = exports.ReactCSS = function ReactCSS(classes) {
  for (var _len = arguments.length, activations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    activations[_key - 1] = arguments[_key];
  }

  var activeNames = (0, _flattenNames2.default)(activations);
  var merged = (0, _mergeClasses2.default)(classes, activeNames);
  return (0, _autoprefix2.default)(merged);
};

exports.default = ReactCSS;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(12);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(416)();
}


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Alpha = __webpack_require__(592);

Object.defineProperty(exports, 'Alpha', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Alpha).default;
  }
});

var _Checkboard = __webpack_require__(190);

Object.defineProperty(exports, 'Checkboard', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Checkboard).default;
  }
});

var _EditableInput = __webpack_require__(595);

Object.defineProperty(exports, 'EditableInput', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_EditableInput).default;
  }
});

var _Hue = __webpack_require__(596);

Object.defineProperty(exports, 'Hue', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Hue).default;
  }
});

var _Raised = __webpack_require__(598);

Object.defineProperty(exports, 'Raised', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Raised).default;
  }
});

var _Saturation = __webpack_require__(599);

Object.defineProperty(exports, 'Saturation', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Saturation).default;
  }
});

var _ColorWrap = __webpack_require__(192);

Object.defineProperty(exports, 'ColorWrap', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ColorWrap).default;
  }
});

var _Swatch = __webpack_require__(607);

Object.defineProperty(exports, 'Swatch', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Swatch).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable no-unused-vars */
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (e) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (Object.getOwnPropertySymbols) {
			symbols = Object.getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5);

var DOMProperty = __webpack_require__(36);
var ReactDOMComponentFlags = __webpack_require__(112);

var invariant = __webpack_require__(2);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var Flags = ReactDOMComponentFlags;

var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);

/**
 * Check if a given node should be cached.
 */
function shouldPrecacheNode(node, nodeID) {
  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
}

/**
 * Drill down (through composites and empty components) until we get a host or
 * host text component.
 *
 * This is pretty polymorphic but unavoidable with the current structure we have
 * for `_renderedChildren`.
 */
function getRenderedHostOrTextFromComponent(component) {
  var rendered;
  while (rendered = component._renderedComponent) {
    component = rendered;
  }
  return component;
}

/**
 * Populate `_hostNode` on the rendered host/text component with the given
 * DOM node. The passed `inst` can be a composite.
 */
function precacheNode(inst, node) {
  var hostInst = getRenderedHostOrTextFromComponent(inst);
  hostInst._hostNode = node;
  node[internalInstanceKey] = hostInst;
}

function uncacheNode(inst) {
  var node = inst._hostNode;
  if (node) {
    delete node[internalInstanceKey];
    inst._hostNode = null;
  }
}

/**
 * Populate `_hostNode` on each child of `inst`, assuming that the children
 * match up with the DOM (element) children of `node`.
 *
 * We cache entire levels at once to avoid an n^2 problem where we access the
 * children of a node sequentially and have to walk from the start to our target
 * node every time.
 *
 * Since we update `_renderedChildren` and the actual DOM at (slightly)
 * different times, we could race here and see a newer `_renderedChildren` than
 * the DOM nodes we see. To avoid this, ReactMultiChild calls
 * `prepareToManageChildren` before we change `_renderedChildren`, at which
 * time the container's child nodes are always cached (until it unmounts).
 */
function precacheChildNodes(inst, node) {
  if (inst._flags & Flags.hasCachedChildNodes) {
    return;
  }
  var children = inst._renderedChildren;
  var childNode = node.firstChild;
  outer: for (var name in children) {
    if (!children.hasOwnProperty(name)) {
      continue;
    }
    var childInst = children[name];
    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
    if (childID === 0) {
      // We're currently unmounting this child in ReactMultiChild; skip it.
      continue;
    }
    // We assume the child nodes are in the same order as the child instances.
    for (; childNode !== null; childNode = childNode.nextSibling) {
      if (shouldPrecacheNode(childNode, childID)) {
        precacheNode(childInst, childNode);
        continue outer;
      }
    }
    // We reached the end of the DOM children without finding an ID match.
     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
  }
  inst._flags |= Flags.hasCachedChildNodes;
}

/**
 * Given a DOM node, return the closest ReactDOMComponent or
 * ReactDOMTextComponent instance ancestor.
 */
function getClosestInstanceFromNode(node) {
  if (node[internalInstanceKey]) {
    return node[internalInstanceKey];
  }

  // Walk up the tree until we find an ancestor whose instance we have cached.
  var parents = [];
  while (!node[internalInstanceKey]) {
    parents.push(node);
    if (node.parentNode) {
      node = node.parentNode;
    } else {
      // Top of the tree. This node must not be part of a React tree (or is
      // unmounted, potentially).
      return null;
    }
  }

  var closest;
  var inst;
  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
    closest = inst;
    if (parents.length) {
      precacheChildNodes(inst, node);
    }
  }

  return closest;
}

/**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */
function getInstanceFromNode(node) {
  var inst = getClosestInstanceFromNode(node);
  if (inst != null && inst._hostNode === node) {
    return inst;
  } else {
    return null;
  }
}

/**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */
function getNodeFromInstance(inst) {
  // Without this first invariant, passing a non-DOM-component triggers the next
  // invariant for a missing parent, which is super confusing.
  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  if (inst._hostNode) {
    return inst._hostNode;
  }

  // Walk up the tree until we find an ancestor whose DOM node we have cached.
  var parents = [];
  while (!inst._hostNode) {
    parents.push(inst);
    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
    inst = inst._hostParent;
  }

  // Now parents contains each ancestor that does *not* have a cached native
  // node, and `inst` is the deepest ancestor that does.
  for (; parents.length; inst = parents.pop()) {
    precacheChildNodes(inst, inst._hostNode);
  }

  return inst._hostNode;
}

var ReactDOMComponentTree = {
  getClosestInstanceFromNode: getClosestInstanceFromNode,
  getInstanceFromNode: getInstanceFromNode,
  getNodeFromInstance: getNodeFromInstance,
  precacheChildNodes: precacheChildNodes,
  precacheNode: precacheNode,
  uncacheNode: uncacheNode
};

module.exports = ReactDOMComponentTree;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 13 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// Trust the developer to only use ReactInstrumentation with a __DEV__ check

var debugTool = null;

if (false) {
  var ReactDebugTool = require('./ReactDebugTool');
  debugTool = ReactDebugTool;
}

module.exports = { debugTool: debugTool };

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(157);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.red = undefined;

var _each = __webpack_require__(604);

var _each2 = _interopRequireDefault(_each);

var _tinycolor = __webpack_require__(606);

var _tinycolor2 = _interopRequireDefault(_tinycolor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  simpleCheckForValidColor: function simpleCheckForValidColor(data) {
    var keysToCheck = ['r', 'g', 'b', 'a', 'h', 's', 'l', 'v'];
    var checked = 0;
    var passed = 0;
    (0, _each2.default)(keysToCheck, function (letter) {
      if (data[letter]) {
        checked += 1;
        if (!isNaN(data[letter])) {
          passed += 1;
        }
        if (letter === 's' || letter === 'l') {
          var percentPatt = /^\d+%$/;
          if (percentPatt.test(data[letter])) {
            passed += 1;
          }
        }
      }
    });
    return checked === passed ? data : false;
  },
  toState: function toState(data, oldHue) {
    var color = data.hex ? (0, _tinycolor2.default)(data.hex) : (0, _tinycolor2.default)(data);
    var hsl = color.toHsl();
    var hsv = color.toHsv();
    var rgb = color.toRgb();
    var hex = color.toHex();
    if (hsl.s === 0) {
      hsl.h = oldHue || 0;
      hsv.h = oldHue || 0;
    }
    var transparent = hex === '000000' && rgb.a === 0;

    return {
      hsl: hsl,
      hex: transparent ? 'transparent' : '#' + hex,
      rgb: rgb,
      hsv: hsv,
      oldHue: data.h || oldHue || hsl.h,
      source: data.source
    };
  },
  isValidHex: function isValidHex(hex) {
    // disable hex4 and hex8
    var lh = String(hex).charAt(0) === '#' ? 1 : 0;
    return hex.length !== 4 + lh && hex.length < 7 + lh && (0, _tinycolor2.default)(hex).isValid();
  },
  getContrastingColor: function getContrastingColor(data) {
    if (!data) {
      return '#fff';
    }
    var col = this.toState(data);
    if (col.hex === 'transparent') {
      return 'rgba(0,0,0,0.4)';
    }
    var yiq = (col.rgb.r * 299 + col.rgb.g * 587 + col.rgb.b * 114) / 1000;
    return yiq >= 128 ? '#000' : '#fff';
  }
};
var red = exports.red = {
  hsl: { a: 1, h: 0, l: 0.5, s: 1 },
  hex: '#ff0000',
  rgb: { r: 255, g: 0, b: 0, a: 1 },
  hsv: { h: 0, s: 1, v: 1, a: 1 }
};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5),
    _assign = __webpack_require__(8);

var CallbackQueue = __webpack_require__(116);
var PooledClass = __webpack_require__(27);
var ReactFeatureFlags = __webpack_require__(117);
var ReactReconciler = __webpack_require__(37);
var Transaction = __webpack_require__(51);

var invariant = __webpack_require__(2);

var dirtyComponents = [];
var updateBatchNumber = 0;
var asapCallbackQueue = CallbackQueue.getPooled();
var asapEnqueued = false;

var batchingStrategy = null;

function ensureInjected() {
  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
}

var NESTED_UPDATES = {
  initialize: function () {
    this.dirtyComponentsLength = dirtyComponents.length;
  },
  close: function () {
    if (this.dirtyComponentsLength !== dirtyComponents.length) {
      // Additional updates were enqueued by componentDidUpdate handlers or
      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
      // these new updates so that if A's componentDidUpdate calls setState on
      // B, B will update before the callback A's updater provided when calling
      // setState.
      dirtyComponents.splice(0, this.dirtyComponentsLength);
      flushBatchedUpdates();
    } else {
      dirtyComponents.length = 0;
    }
  }
};

var UPDATE_QUEUEING = {
  initialize: function () {
    this.callbackQueue.reset();
  },
  close: function () {
    this.callbackQueue.notifyAll();
  }
};

var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];

function ReactUpdatesFlushTransaction() {
  this.reinitializeTransaction();
  this.dirtyComponentsLength = null;
  this.callbackQueue = CallbackQueue.getPooled();
  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */true);
}

_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  destructor: function () {
    this.dirtyComponentsLength = null;
    CallbackQueue.release(this.callbackQueue);
    this.callbackQueue = null;
    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
    this.reconcileTransaction = null;
  },

  perform: function (method, scope, a) {
    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
    // with this transaction's wrappers around it.
    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
  }
});

PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);

function batchedUpdates(callback, a, b, c, d, e) {
  ensureInjected();
  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
}

/**
 * Array comparator for ReactComponents by mount ordering.
 *
 * @param {ReactComponent} c1 first component you're comparing
 * @param {ReactComponent} c2 second component you're comparing
 * @return {number} Return value usable by Array.prototype.sort().
 */
function mountOrderComparator(c1, c2) {
  return c1._mountOrder - c2._mountOrder;
}

function runBatchedUpdates(transaction) {
  var len = transaction.dirtyComponentsLength;
  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;

  // Since reconciling a component higher in the owner hierarchy usually (not
  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
  // them before their children by sorting the array.
  dirtyComponents.sort(mountOrderComparator);

  // Any updates enqueued while reconciling must be performed after this entire
  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
  // C, B could update twice in a single batch if C's render enqueues an update
  // to B (since B would have already updated, we should skip it, and the only
  // way we can know to do so is by checking the batch counter).
  updateBatchNumber++;

  for (var i = 0; i < len; i++) {
    // If a component is unmounted before pending changes apply, it will still
    // be here, but we assume that it has cleared its _pendingCallbacks and
    // that performUpdateIfNecessary is a noop.
    var component = dirtyComponents[i];

    // If performUpdateIfNecessary happens to enqueue any new updates, we
    // shouldn't execute the callbacks until the next render happens, so
    // stash the callbacks first
    var callbacks = component._pendingCallbacks;
    component._pendingCallbacks = null;

    var markerName;
    if (ReactFeatureFlags.logTopLevelRenders) {
      var namedComponent = component;
      // Duck type TopLevelWrapper. This is probably always true.
      if (component._currentElement.type.isReactTopLevelWrapper) {
        namedComponent = component._renderedComponent;
      }
      markerName = 'React update: ' + namedComponent.getName();
      console.time(markerName);
    }

    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);

    if (markerName) {
      console.timeEnd(markerName);
    }

    if (callbacks) {
      for (var j = 0; j < callbacks.length; j++) {
        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
      }
    }
  }
}

var flushBatchedUpdates = function () {
  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
  // array and perform any updates enqueued by mount-ready handlers (i.e.,
  // componentDidUpdate) but we need to check here too in order to catch
  // updates enqueued by setState callbacks and asap calls.
  while (dirtyComponents.length || asapEnqueued) {
    if (dirtyComponents.length) {
      var transaction = ReactUpdatesFlushTransaction.getPooled();
      transaction.perform(runBatchedUpdates, null, transaction);
      ReactUpdatesFlushTransaction.release(transaction);
    }

    if (asapEnqueued) {
      asapEnqueued = false;
      var queue = asapCallbackQueue;
      asapCallbackQueue = CallbackQueue.getPooled();
      queue.notifyAll();
      CallbackQueue.release(queue);
    }
  }
};

/**
 * Mark a component as needing a rerender, adding an optional callback to a
 * list of functions which will be executed once the rerender occurs.
 */
function enqueueUpdate(component) {
  ensureInjected();

  // Various parts of our code (such as ReactCompositeComponent's
  // _renderValidatedComponent) assume that calls to render aren't nested;
  // verify that that's the case. (This is called by each top-level update
  // function, like setState, forceUpdate, etc.; creation and
  // destruction of top-level components is guarded in ReactMount.)

  if (!batchingStrategy.isBatchingUpdates) {
    batchingStrategy.batchedUpdates(enqueueUpdate, component);
    return;
  }

  dirtyComponents.push(component);
  if (component._updateBatchNumber == null) {
    component._updateBatchNumber = updateBatchNumber + 1;
  }
}

/**
 * Enqueue a callback to be run at the end of the current batching cycle. Throws
 * if no updates are currently being performed.
 */
function asap(callback, context) {
  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
  asapCallbackQueue.enqueue(callback, context);
  asapEnqueued = true;
}

var ReactUpdatesInjection = {
  injectReconcileTransaction: function (ReconcileTransaction) {
    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
  },

  injectBatchingStrategy: function (_batchingStrategy) {
    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
    batchingStrategy = _batchingStrategy;
  }
};

var ReactUpdates = {
  /**
   * React references `ReactReconcileTransaction` using this property in order
   * to allow dependency injection.
   *
   * @internal
   */
  ReactReconcileTransaction: null,

  batchedUpdates: batchedUpdates,
  enqueueUpdate: enqueueUpdate,
  flushBatchedUpdates: flushBatchedUpdates,
  injection: ReactUpdatesInjection,
  asap: asap
};

module.exports = ReactUpdates;

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Router__ = __webpack_require__(413);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return __WEBPACK_IMPORTED_MODULE_0__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Link__ = __webpack_require__(140);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Link", function() { return __WEBPACK_IMPORTED_MODULE_1__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IndexLink__ = __webpack_require__(423);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "IndexLink", function() { return __WEBPACK_IMPORTED_MODULE_2__IndexLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__withRouter__ = __webpack_require__(424);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withRouter", function() { return __WEBPACK_IMPORTED_MODULE_3__withRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__IndexRedirect__ = __webpack_require__(425);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "IndexRedirect", function() { return __WEBPACK_IMPORTED_MODULE_4__IndexRedirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__IndexRoute__ = __webpack_require__(426);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "IndexRoute", function() { return __WEBPACK_IMPORTED_MODULE_5__IndexRoute__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(142);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Redirect", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(427);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RouteUtils__ = __webpack_require__(24);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createRoutes", function() { return __WEBPACK_IMPORTED_MODULE_8__RouteUtils__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__RouterContext__ = __webpack_require__(86);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "RouterContext", function() { return __WEBPACK_IMPORTED_MODULE_9__RouterContext__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PropTypes__ = __webpack_require__(88);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "locationShape", function() { return __WEBPACK_IMPORTED_MODULE_10__PropTypes__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "routerShape", function() { return __WEBPACK_IMPORTED_MODULE_10__PropTypes__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__match__ = __webpack_require__(428);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "match", function() { return __WEBPACK_IMPORTED_MODULE_11__match__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__useRouterHistory__ = __webpack_require__(146);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "useRouterHistory", function() { return __WEBPACK_IMPORTED_MODULE_12__useRouterHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PatternUtils__ = __webpack_require__(40);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "formatPattern", function() { return __WEBPACK_IMPORTED_MODULE_13__PatternUtils__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__applyRouterMiddleware__ = __webpack_require__(433);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "applyRouterMiddleware", function() { return __WEBPACK_IMPORTED_MODULE_14__applyRouterMiddleware__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__browserHistory__ = __webpack_require__(434);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "browserHistory", function() { return __WEBPACK_IMPORTED_MODULE_15__browserHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__hashHistory__ = __webpack_require__(437);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "hashHistory", function() { return __WEBPACK_IMPORTED_MODULE_16__hashHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__createMemoryHistory__ = __webpack_require__(143);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createMemoryHistory", function() { return __WEBPACK_IMPORTED_MODULE_17__createMemoryHistory__["a"]; });
/* components */









/* components (configuration) */










/* utils */















/* histories */








/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {

  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null

};

module.exports = ReactCurrentOwner;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(8);

var PooledClass = __webpack_require__(27);

var emptyFunction = __webpack_require__(12);
var warning = __webpack_require__(4);

var didWarnForAddedNewProperty = false;
var isProxySupported = typeof Proxy === 'function';

var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var EventInterface = {
  type: null,
  target: null,
  // currentTarget is set when dispatching; no use in copying it here
  currentTarget: emptyFunction.thatReturnsNull,
  eventPhase: null,
  bubbles: null,
  cancelable: null,
  timeStamp: function (event) {
    return event.timeStamp || Date.now();
  },
  defaultPrevented: null,
  isTrusted: null
};

/**
 * Synthetic events are dispatched by event plugins, typically in response to a
 * top-level event delegation handler.
 *
 * These systems should generally use pooling to reduce the frequency of garbage
 * collection. The system should check `isPersistent` to determine whether the
 * event should be released into the pool after being dispatched. Users that
 * need a persisted event should invoke `persist`.
 *
 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
 * normalizing browser quirks. Subclasses do not necessarily have to implement a
 * DOM interface; custom application-specific events can also subclass this.
 *
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {*} targetInst Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @param {DOMEventTarget} nativeEventTarget Target node.
 */
function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
  if (false) {
    // these have a getter/setter for warnings
    delete this.nativeEvent;
    delete this.preventDefault;
    delete this.stopPropagation;
  }

  this.dispatchConfig = dispatchConfig;
  this._targetInst = targetInst;
  this.nativeEvent = nativeEvent;

  var Interface = this.constructor.Interface;
  for (var propName in Interface) {
    if (!Interface.hasOwnProperty(propName)) {
      continue;
    }
    if (false) {
      delete this[propName]; // this has a getter/setter for warnings
    }
    var normalize = Interface[propName];
    if (normalize) {
      this[propName] = normalize(nativeEvent);
    } else {
      if (propName === 'target') {
        this.target = nativeEventTarget;
      } else {
        this[propName] = nativeEvent[propName];
      }
    }
  }

  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
  if (defaultPrevented) {
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  } else {
    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
  }
  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
  return this;
}

_assign(SyntheticEvent.prototype, {

  preventDefault: function () {
    this.defaultPrevented = true;
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.preventDefault) {
      event.preventDefault();
    } else if (typeof event.returnValue !== 'unknown') {
      // eslint-disable-line valid-typeof
      event.returnValue = false;
    }
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  },

  stopPropagation: function () {
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.stopPropagation) {
      event.stopPropagation();
    } else if (typeof event.cancelBubble !== 'unknown') {
      // eslint-disable-line valid-typeof
      // The ChangeEventPlugin registers a "propertychange" event for
      // IE. This event does not support bubbling or cancelling, and
      // any references to cancelBubble throw "Member not found".  A
      // typeof check of "unknown" circumvents this issue (and is also
      // IE specific).
      event.cancelBubble = true;
    }

    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
  },

  /**
   * We release all dispatched `SyntheticEvent`s after each event loop, adding
   * them back into the pool. This allows a way to hold onto a reference that
   * won't be added back into the pool.
   */
  persist: function () {
    this.isPersistent = emptyFunction.thatReturnsTrue;
  },

  /**
   * Checks if this event should be released back into the pool.
   *
   * @return {boolean} True if this should not be released, false otherwise.
   */
  isPersistent: emptyFunction.thatReturnsFalse,

  /**
   * `PooledClass` looks for `destructor` on each instance it releases.
   */
  destructor: function () {
    var Interface = this.constructor.Interface;
    for (var propName in Interface) {
      if (false) {
        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
      } else {
        this[propName] = null;
      }
    }
    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
      this[shouldBeReleasedProperties[i]] = null;
    }
    if (false) {
      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
    }
  }

});

SyntheticEvent.Interface = EventInterface;

if (false) {
  if (isProxySupported) {
    /*eslint-disable no-func-assign */
    SyntheticEvent = new Proxy(SyntheticEvent, {
      construct: function (target, args) {
        return this.apply(target, Object.create(target.prototype), args);
      },
      apply: function (constructor, that, args) {
        return new Proxy(constructor.apply(that, args), {
          set: function (target, prop, value) {
            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re adding a new property in the synthetic event object. ' + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
              didWarnForAddedNewProperty = true;
            }
            target[prop] = value;
            return true;
          }
        });
      }
    });
    /*eslint-enable no-func-assign */
  }
}
/**
 * Helper to reduce boilerplate when creating subclasses.
 *
 * @param {function} Class
 * @param {?object} Interface
 */
SyntheticEvent.augmentClass = function (Class, Interface) {
  var Super = this;

  var E = function () {};
  E.prototype = Super.prototype;
  var prototype = new E();

  _assign(prototype, Class.prototype);
  Class.prototype = prototype;
  Class.prototype.constructor = Class;

  Class.Interface = _assign({}, Super.Interface, Interface);
  Class.augmentClass = Super.augmentClass;

  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
};

PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);

module.exports = SyntheticEvent;

/**
  * Helper to nullify syntheticEvent instance properties when destructing
  *
  * @param {object} SyntheticEvent
  * @param {String} propName
  * @return {object} defineProperty object
  */
function getPooledWarningPropertyDefinition(propName, getVal) {
  var isFunction = typeof getVal === 'function';
  return {
    configurable: true,
    set: set,
    get: get
  };

  function set(val) {
    var action = isFunction ? 'setting the method' : 'setting the property';
    warn(action, 'This is effectively a no-op');
    return val;
  }

  function get() {
    var action = isFunction ? 'accessing the method' : 'accessing the property';
    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
    warn(action, result);
    return getVal;
  }

  function warn(action, result) {
    var warningCondition = false;
     false ? warning(warningCondition, 'This synthetic event is reused for performance reasons. If you\'re seeing this, ' + 'you\'re %s `%s` on a released/nullified synthetic event. %s. ' + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
  }
}

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__(1);
var factory = __webpack_require__(414);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 22 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = isReactChildren;
/* harmony export (immutable) */ __webpack_exports__["a"] = createRouteFromReactElement;
/* unused harmony export createRoutesFromReactChildren */
/* harmony export (immutable) */ __webpack_exports__["b"] = createRoutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function isValidChild(object) {
  return object == null || __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(object);
}

function isReactChildren(object) {
  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
}

function createRoute(defaultProps, props) {
  return _extends({}, defaultProps, props);
}

function createRouteFromReactElement(element) {
  var type = element.type;
  var route = createRoute(type.defaultProps, element.props);

  if (route.children) {
    var childRoutes = createRoutesFromReactChildren(route.children, route);

    if (childRoutes.length) route.childRoutes = childRoutes;

    delete route.children;
  }

  return route;
}

/**
 * Creates and returns a routes object from the given ReactChildren. JSX
 * provides a convenient way to visualize how routes in the hierarchy are
 * nested.
 *
 *   import { Route, createRoutesFromReactChildren } from 'react-router'
 *
 *   const routes = createRoutesFromReactChildren(
 *     <Route component={App}>
 *       <Route path="home" component={Dashboard}/>
 *       <Route path="news" component={NewsFeed}/>
 *     </Route>
 *   )
 *
 * Note: This method is automatically used when you provide <Route> children
 * to a <Router> component.
 */
function createRoutesFromReactChildren(children, parentRoute) {
  var routes = [];

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
    if (__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
      // Component classes may have a static create* method.
      if (element.type.createRouteFromReactElement) {
        var route = element.type.createRouteFromReactElement(element, parentRoute);

        if (route) routes.push(route);
      } else {
        routes.push(createRouteFromReactElement(element));
      }
    }
  });

  return routes;
}

/**
 * Creates and returns an array of routes from the given object which
 * may be a JSX route, a plain object route, or an array of either.
 */
function createRoutes(routes) {
  if (isReactChildren(routes)) {
    routes = createRoutesFromReactChildren(routes);
  } else if (routes && !Array.isArray(routes)) {
    routes = [routes];
  }

  return routes;
}

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.createPath = exports.parsePath = exports.getQueryStringValueFromPath = exports.stripQueryStringValueFromPath = exports.addQueryStringValueToPath = undefined;

var _warning = __webpack_require__(23);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var addQueryStringValueToPath = exports.addQueryStringValueToPath = function addQueryStringValueToPath(path, key, value) {
  var _parsePath = parsePath(path),
      pathname = _parsePath.pathname,
      search = _parsePath.search,
      hash = _parsePath.hash;

  return createPath({
    pathname: pathname,
    search: search + (search.indexOf('?') === -1 ? '?' : '&') + key + '=' + value,
    hash: hash
  });
};

var stripQueryStringValueFromPath = exports.stripQueryStringValueFromPath = function stripQueryStringValueFromPath(path, key) {
  var _parsePath2 = parsePath(path),
      pathname = _parsePath2.pathname,
      search = _parsePath2.search,
      hash = _parsePath2.hash;

  return createPath({
    pathname: pathname,
    search: search.replace(new RegExp('([?&])' + key + '=[a-zA-Z0-9]+(&?)'), function (match, prefix, suffix) {
      return prefix === '?' ? prefix : suffix;
    }),
    hash: hash
  });
};

var getQueryStringValueFromPath = exports.getQueryStringValueFromPath = function getQueryStringValueFromPath(path, key) {
  var _parsePath3 = parsePath(path),
      search = _parsePath3.search;

  var match = search.match(new RegExp('[?&]' + key + '=([a-zA-Z0-9]+)'));
  return match && match[1];
};

var extractPath = function extractPath(string) {
  var match = string.match(/^(https?:)?\/\/[^\/]*/);
  return match == null ? string : string.substring(match[0].length);
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = extractPath(path);
  var search = '';
  var hash = '';

   false ? (0, _warning2.default)(path === pathname, 'A path must be pathname + search + hash only, not a full URL like "%s"', path) : void 0;

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substring(hashIndex);
    pathname = pathname.substring(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substring(searchIndex);
    pathname = pathname.substring(0, searchIndex);
  }

  if (pathname === '') pathname = '/';

  return {
    pathname: pathname,
    search: search,
    hash: hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  if (location == null || typeof location === 'string') return location;

  var basename = location.basename,
      pathname = location.pathname,
      search = location.search,
      hash = location.hash;

  var path = (basename || '') + pathname;

  if (search && search !== '?') path += search;

  if (hash) path += hash;

  return path;
};

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(167),
    baseIteratee = __webpack_require__(505),
    baseMap = __webpack_require__(561),
    isArray = __webpack_require__(13);

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee, 3));
}

module.exports = map;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(5);

var invariant = __webpack_require__(2);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 28 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(49),
    getRawTag = __webpack_require__(492),
    objectToString = __webpack_require__(493);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 30 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(518),
    getValue = __webpack_require__(521);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(8);

var ReactChildren = __webpack_require__(317);
var ReactComponent = __webpack_require__(66);
var ReactPureComponent = __webpack_require__(322);
var ReactClass = __webpack_require__(323);
var ReactDOMFactories = __webpack_require__(325);
var ReactElement = __webpack_require__(34);
var ReactPropTypes = __webpack_require__(326);
var ReactVersion = __webpack_require__(330);

var onlyChild = __webpack_require__(331);
var warning = __webpack_require__(4);

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (false) {
  var canDefineProperty = require('./canDefineProperty');
  var ReactElementValidator = require('./ReactElementValidator');
  var didWarnPropTypesDeprecated = false;
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var __spread = _assign;

if (false) {
  var warned = false;
  __spread = function () {
    process.env.NODE_ENV !== 'production' ? warning(warned, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.') : void 0;
    warned = true;
    return _assign.apply(null, arguments);
  };
}

var React = {

  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactComponent,
  PureComponent: ReactPureComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: ReactClass.createClass,
  createFactory: createFactory,
  createMixin: function (mixin) {
    // Currently a noop. Will be used to validate and trace mixins.
    return mixin;
  },

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Deprecated hook for JSX spread, don't use this for anything.
  __spread: __spread
};

// TODO: Fix tests so that this deprecation warning doesn't cause failures.
if (false) {
  if (canDefineProperty) {
    Object.defineProperty(React, 'PropTypes', {
      get: function () {
        process.env.NODE_ENV !== 'production' ? warning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated. Use ' + 'the prop-types package from npm instead.') : void 0;
        didWarnPropTypesDeprecated = true;
        return ReactPropTypes;
      }
    });
  }
}

module.exports = React;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(8);

var ReactCurrentOwner = __webpack_require__(19);

var warning = __webpack_require__(4);
var canDefineProperty = __webpack_require__(109);
var hasOwnProperty = Object.prototype.hasOwnProperty;

var REACT_ELEMENT_TYPE = __webpack_require__(110);

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown, specialPropRefWarningShown;

function hasValidRef(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (false) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */
ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    if (false) {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  if (false) {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */
ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */
ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5);

var invariant = __webpack_require__(2);

function checkMask(value, bitmask) {
  return (value & bitmask) === bitmask;
}

var DOMPropertyInjection = {
  /**
   * Mapping from normalized, camelcased property names to a configuration that
   * specifies how the associated DOM property should be accessed or rendered.
   */
  MUST_USE_PROPERTY: 0x1,
  HAS_BOOLEAN_VALUE: 0x4,
  HAS_NUMERIC_VALUE: 0x8,
  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,

  /**
   * Inject some specialized knowledge about the DOM. This takes a config object
   * with the following properties:
   *
   * isCustomAttribute: function that given an attribute name will return true
   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
   * attributes where it's impossible to enumerate all of the possible
   * attribute names,
   *
   * Properties: object mapping DOM property name to one of the
   * DOMPropertyInjection constants or null. If your attribute isn't in here,
   * it won't get written to the DOM.
   *
   * DOMAttributeNames: object mapping React attribute name to the DOM
   * attribute name. Attribute names not specified use the **lowercase**
   * normalized name.
   *
   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
   * attribute namespace URL. (Attribute names not specified use no namespace.)
   *
   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
   * Property names not specified use the normalized name.
   *
   * DOMMutationMethods: Properties that require special mutation methods. If
   * `value` is undefined, the mutation method should unset the property.
   *
   * @param {object} domPropertyConfig the config as described above.
   */
  injectDOMPropertyConfig: function (domPropertyConfig) {
    var Injection = DOMPropertyInjection;
    var Properties = domPropertyConfig.Properties || {};
    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};

    if (domPropertyConfig.isCustomAttribute) {
      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
    }

    for (var propName in Properties) {
      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;

      var lowerCased = propName.toLowerCase();
      var propConfig = Properties[propName];

      var propertyInfo = {
        attributeName: lowerCased,
        attributeNamespace: null,
        propertyName: propName,
        mutationMethod: null,

        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
      };
      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;

      if (false) {
        DOMProperty.getPossibleStandardName[lowerCased] = propName;
      }

      if (DOMAttributeNames.hasOwnProperty(propName)) {
        var attributeName = DOMAttributeNames[propName];
        propertyInfo.attributeName = attributeName;
        if (false) {
          DOMProperty.getPossibleStandardName[attributeName] = propName;
        }
      }

      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
      }

      if (DOMPropertyNames.hasOwnProperty(propName)) {
        propertyInfo.propertyName = DOMPropertyNames[propName];
      }

      if (DOMMutationMethods.hasOwnProperty(propName)) {
        propertyInfo.mutationMethod = DOMMutationMethods[propName];
      }

      DOMProperty.properties[propName] = propertyInfo;
    }
  }
};

/* eslint-disable max-len */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
/* eslint-enable max-len */

/**
 * DOMProperty exports lookup objects that can be used like functions:
 *
 *   > DOMProperty.isValid['id']
 *   true
 *   > DOMProperty.isValid['foobar']
 *   undefined
 *
 * Although this may be confusing, it performs better in general.
 *
 * @see http://jsperf.com/key-exists
 * @see http://jsperf.com/key-missing
 */
var DOMProperty = {

  ID_ATTRIBUTE_NAME: 'data-reactid',
  ROOT_ATTRIBUTE_NAME: 'data-reactroot',

  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',

  /**
   * Map from property "standard name" to an object with info about how to set
   * the property in the DOM. Each object contains:
   *
   * attributeName:
   *   Used when rendering markup or with `*Attribute()`.
   * attributeNamespace
   * propertyName:
   *   Used on DOM node instances. (This includes properties that mutate due to
   *   external factors.)
   * mutationMethod:
   *   If non-null, used instead of the property or `setAttribute()` after
   *   initial render.
   * mustUseProperty:
   *   Whether the property must be accessed and mutated as an object property.
   * hasBooleanValue:
   *   Whether the property should be removed when set to a falsey value.
   * hasNumericValue:
   *   Whether the property must be numeric or parse as a numeric and should be
   *   removed when set to a falsey value.
   * hasPositiveNumericValue:
   *   Whether the property must be positive numeric or parse as a positive
   *   numeric and should be removed when set to a falsey value.
   * hasOverloadedBooleanValue:
   *   Whether the property can be used as a flag as well as with a value.
   *   Removed when strictly equal to false; present without a value when
   *   strictly equal to true; present with a value otherwise.
   */
  properties: {},

  /**
   * Mapping from lowercase property names to the properly cased version, used
   * to warn in the case of missing properties. Available only in __DEV__.
   *
   * autofocus is predefined, because adding it to the property whitelist
   * causes unintended side effects.
   *
   * @type {Object}
   */
  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,

  /**
   * All of the isCustomAttribute() functions that have been injected.
   */
  _isCustomAttributeFunctions: [],

  /**
   * Checks whether a property name is a custom attribute.
   * @method
   */
  isCustomAttribute: function (attributeName) {
    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
      if (isCustomAttributeFn(attributeName)) {
        return true;
      }
    }
    return false;
  },

  injection: DOMPropertyInjection
};

module.exports = DOMProperty;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactRef = __webpack_require__(341);
var ReactInstrumentation = __webpack_require__(14);

var warning = __webpack_require__(4);

/**
 * Helper to call ReactRef.attachRefs with this composite component, split out
 * to avoid allocations in the transaction mount-ready queue.
 */
function attachRefs() {
  ReactRef.attachRefs(this, this._currentElement);
}

var ReactReconciler = {

  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} the containing host component instance
   * @param {?object} info about the host container
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID // 0 in production and for roots
  ) {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
      }
    }
    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
      }
    }
    return markup;
  },

  /**
   * Returns a value that can be passed to
   * ReactComponentEnvironment.replaceNodeWithMarkup.
   */
  getHostNode: function (internalInstance) {
    return internalInstance.getHostNode();
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (internalInstance, safely) {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
      }
    }
    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
    internalInstance.unmountComponent(safely);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Update a component using a new element.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @internal
   */
  receiveComponent: function (internalInstance, nextElement, transaction, context) {
    var prevElement = internalInstance._currentElement;

    if (nextElement === prevElement && context === internalInstance._context) {
      // Since elements are immutable after the owner is rendered,
      // we can do a cheap identity compare here to determine if this is a
      // superfluous reconcile. It's possible for state to be mutable but such
      // change should trigger an update of the owner which would recreate
      // the element. We explicitly check for the existence of an owner since
      // it's possible for an element created outside a composite to be
      // deeply mutated and reused.

      // TODO: Bailing out early is just a perf optimization right?
      // TODO: Removing the return statement should affect correctness?
      return;
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
      }
    }

    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);

    if (refsChanged) {
      ReactRef.detachRefs(internalInstance, prevElement);
    }

    internalInstance.receiveComponent(nextElement, transaction, context);

    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Flush any dirty changes in a component.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
      // The component's enqueued batch number should always be the current
      // batch or the following one.
       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
      return;
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
      }
    }
    internalInstance.performUpdateIfNecessary(transaction);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  }

};

module.exports = ReactReconciler;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMNamespaces = __webpack_require__(75);
var setInnerHTML = __webpack_require__(53);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(76);
var setTextContent = __webpack_require__(120);

var ELEMENT_NODE_TYPE = 1;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

/**
 * In IE (8-11) and Edge, appending nodes with no children is dramatically
 * faster than appending a full subtree, so we essentially queue up the
 * .appendChild calls here and apply them so each node is added to its parent
 * before any children are added.
 *
 * In other browsers, doing so is slower or neutral compared to the other order
 * (in Firefox, twice as slow) so we only do this inversion in IE.
 *
 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
 */
var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);

function insertTreeChildren(tree) {
  if (!enableLazy) {
    return;
  }
  var node = tree.node;
  var children = tree.children;
  if (children.length) {
    for (var i = 0; i < children.length; i++) {
      insertTreeBefore(node, children[i], null);
    }
  } else if (tree.html != null) {
    setInnerHTML(node, tree.html);
  } else if (tree.text != null) {
    setTextContent(node, tree.text);
  }
}

var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
  // DocumentFragments aren't actually part of the DOM after insertion so
  // appending children won't update the DOM. We need to ensure the fragment
  // is properly populated first, breaking out of our lazy approach for just
  // this level. Also, some <object> plugins (like Flash Player) will read
  // <param> nodes immediately upon insertion into the DOM, so <object>
  // must also be populated prior to insertion into the DOM.
  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
    insertTreeChildren(tree);
    parentNode.insertBefore(tree.node, referenceNode);
  } else {
    parentNode.insertBefore(tree.node, referenceNode);
    insertTreeChildren(tree);
  }
});

function replaceChildWithTree(oldNode, newTree) {
  oldNode.parentNode.replaceChild(newTree.node, oldNode);
  insertTreeChildren(newTree);
}

function queueChild(parentTree, childTree) {
  if (enableLazy) {
    parentTree.children.push(childTree);
  } else {
    parentTree.node.appendChild(childTree.node);
  }
}

function queueHTML(tree, html) {
  if (enableLazy) {
    tree.html = html;
  } else {
    setInnerHTML(tree.node, html);
  }
}

function queueText(tree, text) {
  if (enableLazy) {
    tree.text = text;
  } else {
    setTextContent(tree.node, text);
  }
}

function toString() {
  return this.node.nodeName;
}

function DOMLazyTree(node) {
  return {
    node: node,
    children: [],
    html: null,
    text: null,
    toString: toString
  };
}

DOMLazyTree.insertTreeBefore = insertTreeBefore;
DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
DOMLazyTree.queueChild = queueChild;
DOMLazyTree.queueHTML = queueHTML;
DOMLazyTree.queueText = queueText;

module.exports = DOMLazyTree;

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* unused harmony export _resetWarned */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var warned = {};

function routerWarning(falseToWarn, message) {
  // Only issue deprecation warnings once.
  if (message.indexOf('deprecated') !== -1) {
    if (warned[message]) {
      return;
    }

    warned[message] = true;
  }

  message = '[react-router] ' + message;

  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  __WEBPACK_IMPORTED_MODULE_0_warning___default.a.apply(undefined, [falseToWarn, message].concat(args));
}

function _resetWarned() {
  warned = {};
}

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export compilePattern */
/* harmony export (immutable) */ __webpack_exports__["c"] = matchPattern;
/* harmony export (immutable) */ __webpack_exports__["b"] = getParamNames;
/* unused harmony export getParams */
/* harmony export (immutable) */ __webpack_exports__["a"] = formatPattern;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);


function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function _compilePattern(pattern) {
  var regexpSource = '';
  var paramNames = [];
  var tokens = [];

  var match = void 0,
      lastIndex = 0,
      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)|\\\(|\\\)/g;
  while (match = matcher.exec(pattern)) {
    if (match.index !== lastIndex) {
      tokens.push(pattern.slice(lastIndex, match.index));
      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
    }

    if (match[1]) {
      regexpSource += '([^/]+)';
      paramNames.push(match[1]);
    } else if (match[0] === '**') {
      regexpSource += '(.*)';
      paramNames.push('splat');
    } else if (match[0] === '*') {
      regexpSource += '(.*?)';
      paramNames.push('splat');
    } else if (match[0] === '(') {
      regexpSource += '(?:';
    } else if (match[0] === ')') {
      regexpSource += ')?';
    } else if (match[0] === '\\(') {
      regexpSource += '\\(';
    } else if (match[0] === '\\)') {
      regexpSource += '\\)';
    }

    tokens.push(match[0]);

    lastIndex = matcher.lastIndex;
  }

  if (lastIndex !== pattern.length) {
    tokens.push(pattern.slice(lastIndex, pattern.length));
    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
  }

  return {
    pattern: pattern,
    regexpSource: regexpSource,
    paramNames: paramNames,
    tokens: tokens
  };
}

var CompiledPatternsCache = Object.create(null);

function compilePattern(pattern) {
  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);

  return CompiledPatternsCache[pattern];
}

/**
 * Attempts to match a pattern on the given pathname. Patterns may use
 * the following special characters:
 *
 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
 *                  captured string is considered a "param"
 * - ()             Wraps a segment of the URL that is optional
 * - *              Consumes (non-greedy) all characters up to the next
 *                  character in the pattern, or to the end of the URL if
 *                  there is none
 * - **             Consumes (greedy) all characters up to the next character
 *                  in the pattern, or to the end of the URL if there is none
 *
 *  The function calls callback(error, matched) when finished.
 * The return value is an object with the following properties:
 *
 * - remainingPathname
 * - paramNames
 * - paramValues
 */
function matchPattern(pattern, pathname) {
  // Ensure pattern starts with leading slash for consistency with pathname.
  if (pattern.charAt(0) !== '/') {
    pattern = '/' + pattern;
  }

  var _compilePattern2 = compilePattern(pattern),
      regexpSource = _compilePattern2.regexpSource,
      paramNames = _compilePattern2.paramNames,
      tokens = _compilePattern2.tokens;

  if (pattern.charAt(pattern.length - 1) !== '/') {
    regexpSource += '/?'; // Allow optional path separator at end.
  }

  // Special-case patterns like '*' for catch-all routes.
  if (tokens[tokens.length - 1] === '*') {
    regexpSource += '$';
  }

  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
  if (match == null) {
    return null;
  }

  var matchedPath = match[0];
  var remainingPathname = pathname.substr(matchedPath.length);

  if (remainingPathname) {
    // Require that the match ends at a path separator, if we didn't match
    // the full path, so any remaining pathname is a new path segment.
    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
      return null;
    }

    // If there is a remaining pathname, treat the path separator as part of
    // the remaining pathname for properly continuing the match.
    remainingPathname = '/' + remainingPathname;
  }

  return {
    remainingPathname: remainingPathname,
    paramNames: paramNames,
    paramValues: match.slice(1).map(function (v) {
      return v && decodeURIComponent(v);
    })
  };
}

function getParamNames(pattern) {
  return compilePattern(pattern).paramNames;
}

function getParams(pattern, pathname) {
  var match = matchPattern(pattern, pathname);
  if (!match) {
    return null;
  }

  var paramNames = match.paramNames,
      paramValues = match.paramValues;

  var params = {};

  paramNames.forEach(function (paramName, index) {
    params[paramName] = paramValues[index];
  });

  return params;
}

/**
 * Returns a version of the given pattern with params interpolated. Throws
 * if there is a dynamic segment of the pattern for which there is no param.
 */
function formatPattern(pattern, params) {
  params = params || {};

  var _compilePattern3 = compilePattern(pattern),
      tokens = _compilePattern3.tokens;

  var parenCount = 0,
      pathname = '',
      splatIndex = 0,
      parenHistory = [];

  var token = void 0,
      paramName = void 0,
      paramValue = void 0;
  for (var i = 0, len = tokens.length; i < len; ++i) {
    token = tokens[i];

    if (token === '*' || token === '**') {
      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;

      !(paramValue != null || parenCount > 0) ?  false ? invariant(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default.a(false) : void 0;

      if (paramValue != null) pathname += encodeURI(paramValue);
    } else if (token === '(') {
      parenHistory[parenCount] = '';
      parenCount += 1;
    } else if (token === ')') {
      var parenText = parenHistory.pop();
      parenCount -= 1;

      if (parenCount) parenHistory[parenCount - 1] += parenText;else pathname += parenText;
    } else if (token === '\\(') {
      pathname += '(';
    } else if (token === '\\)') {
      pathname += ')';
    } else if (token.charAt(0) === ':') {
      paramName = token.substring(1);
      paramValue = params[paramName];

      !(paramValue != null || parenCount > 0) ?  false ? invariant(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default.a(false) : void 0;

      if (paramValue == null) {
        if (parenCount) {
          parenHistory[parenCount - 1] = '';

          var curTokenIdx = tokens.indexOf(token);
          var tokensSubset = tokens.slice(curTokenIdx, tokens.length);
          var nextParenIdx = -1;

          for (var _i = 0; _i < tokensSubset.length; _i++) {
            if (tokensSubset[_i] == ')') {
              nextParenIdx = _i;
              break;
            }
          }

          !(nextParenIdx > 0) ?  false ? invariant(false, 'Path "%s" is missing end paren at segment "%s"', pattern, tokensSubset.join('')) : __WEBPACK_IMPORTED_MODULE_0_invariant___default.a(false) : void 0;

          // jump to ending paren
          i = curTokenIdx + nextParenIdx - 1;
        }
      } else if (parenCount) parenHistory[parenCount - 1] += encodeURIComponent(paramValue);else pathname += encodeURIComponent(paramValue);
    } else {
      if (parenCount) parenHistory[parenCount - 1] += token;else pathname += token;
    }
  }

  !(parenCount <= 0) ?  false ? invariant(false, 'Path "%s" is missing end paren', pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default.a(false) : void 0;

  return pathname.replace(/\/+/g, '/');
}

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.statesAreEqual = exports.createLocation = exports.createQuery = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(10);

var _invariant2 = _interopRequireDefault(_invariant);

var _warning = __webpack_require__(23);

var _warning2 = _interopRequireDefault(_warning);

var _PathUtils = __webpack_require__(25);

var _Actions = __webpack_require__(56);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createQuery = exports.createQuery = function createQuery(props) {
  return _extends(Object.create(null), props);
};

var createLocation = exports.createLocation = function createLocation() {
  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Actions.POP;
  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var object = typeof input === 'string' ? (0, _PathUtils.parsePath)(input) : input;

   false ? (0, _warning2.default)(!object.path, 'Location descriptor objects should have a `pathname`, not a `path`.') : void 0;

  var pathname = object.pathname || '/';
  var search = object.search || '';
  var hash = object.hash || '';
  var state = object.state;

  return {
    pathname: pathname,
    search: search,
    hash: hash,
    state: state,
    action: action,
    key: key
  };
};

var isDate = function isDate(object) {
  return Object.prototype.toString.call(object) === '[object Date]';
};

var statesAreEqual = exports.statesAreEqual = function statesAreEqual(a, b) {
  if (a === b) return true;

  var typeofA = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var typeofB = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (typeofA !== typeofB) return false;

  !(typeofA !== 'function') ?  false ? (0, _invariant2.default)(false, 'You must not store functions in location state') : (0, _invariant2.default)(false) : void 0;

  // Not the same object, but same type.
  if (typeofA === 'object') {
    !!(isDate(a) && isDate(b)) ?  false ? (0, _invariant2.default)(false, 'You must not store Date objects in location state') : (0, _invariant2.default)(false) : void 0;

    if (!Array.isArray(a)) {
      var keysofA = Object.keys(a);
      var keysofB = Object.keys(b);
      return keysofA.length === keysofB.length && keysofA.every(function (key) {
        return statesAreEqual(a[key], b[key]);
      });
    }

    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return statesAreEqual(item, b[index]);
    });
  }

  // All other serializable types (string, number, boolean)
  // should be strict equal.
  return false;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.key === b.key &&
  // a.action === b.action && // Different action !== location change.
  a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && statesAreEqual(a.state, b.state);
};

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(18);

__webpack_require__(480);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = _react2.default.createElement(
    "nav",
    null,
    _react2.default.createElement(
        _reactRouter.Link,
        { to: '/' },
        _react2.default.createElement(
            "h1",
            { className: "fadeDown" },
            "eric dudley"
        )
    )
);

var Navigation = function (_React$Component) {
    _inherits(Navigation, _React$Component);

    function Navigation() {
        _classCallCheck(this, Navigation);

        return _possibleConstructorReturn(this, (Navigation.__proto__ || Object.getPrototypeOf(Navigation)).apply(this, arguments));
    }

    _createClass(Navigation, [{
        key: "render",
        value: function render() {
            return _ref;
        }
    }]);

    return Navigation;
}(_react2.default.Component);

exports.default = Navigation;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(44);
var EventPluginUtils = __webpack_require__(69);

var accumulateInto = __webpack_require__(113);
var forEachAccumulated = __webpack_require__(114);
var warning = __webpack_require__(4);

var getListener = EventPluginHub.getListener;

/**
 * Some event types have a notion of different registration names for different
 * "phases" of propagation. This finds listeners by a given phase.
 */
function listenerAtPhase(inst, event, propagationPhase) {
  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
  return getListener(inst, registrationName);
}

/**
 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
 * here, allows us to not have to bind or create functions for each event.
 * Mutating the event's members allows us to not have to create a wrapping
 * "dispatch" object that pairs the event with the listener.
 */
function accumulateDirectionalDispatches(inst, phase, event) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
  }
  var listener = listenerAtPhase(inst, event, phase);
  if (listener) {
    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
  }
}

/**
 * Collect dispatches (must be entirely collected before dispatching - see unit
 * tests). Lazily allocate the array to conserve memory.  We must loop through
 * each event and perform the traversal for each one. We cannot perform a
 * single traversal for the entire collection of events because each event may
 * have a different target.
 */
function accumulateTwoPhaseDispatchesSingle(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
 */
function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    var targetInst = event._targetInst;
    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Accumulates without regard to direction, does not look for phased
 * registration names. Same as `accumulateDirectDispatchesSingle` but without
 * requiring that the `dispatchMarker` be the same as the dispatched ID.
 */
function accumulateDispatches(inst, ignoredDirection, event) {
  if (event && event.dispatchConfig.registrationName) {
    var registrationName = event.dispatchConfig.registrationName;
    var listener = getListener(inst, registrationName);
    if (listener) {
      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
    }
  }
}

/**
 * Accumulates dispatches on an `SyntheticEvent`, but only for the
 * `dispatchMarker`.
 * @param {SyntheticEvent} event
 */
function accumulateDirectDispatchesSingle(event) {
  if (event && event.dispatchConfig.registrationName) {
    accumulateDispatches(event._targetInst, null, event);
  }
}

function accumulateTwoPhaseDispatches(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
}

function accumulateTwoPhaseDispatchesSkipTarget(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
}

function accumulateEnterLeaveDispatches(leave, enter, from, to) {
  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
}

function accumulateDirectDispatches(events) {
  forEachAccumulated(events, accumulateDirectDispatchesSingle);
}

/**
 * A small set of propagation patterns, each of which will accept a small amount
 * of information, and generate a set of "dispatch ready event objects" - which
 * are sets of events that have already been annotated with a set of dispatched
 * listener functions/ids. The API is designed this way to discourage these
 * propagation strategies from actually executing the dispatches, since we
 * always want to collect the entire set of dispatches before executing event a
 * single one.
 *
 * @constructor EventPropagators
 */
var EventPropagators = {
  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
  accumulateDirectDispatches: accumulateDirectDispatches,
  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
};

module.exports = EventPropagators;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5);

var EventPluginRegistry = __webpack_require__(68);
var EventPluginUtils = __webpack_require__(69);
var ReactErrorUtils = __webpack_require__(70);

var accumulateInto = __webpack_require__(113);
var forEachAccumulated = __webpack_require__(114);
var invariant = __webpack_require__(2);

/**
 * Internal store for event listeners
 */
var listenerBank = {};

/**
 * Internal queue of events that have accumulated their dispatches and are
 * waiting to have their dispatches executed.
 */
var eventQueue = null;

/**
 * Dispatches an event and releases it back into the pool, unless persistent.
 *
 * @param {?object} event Synthetic event to be dispatched.
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @private
 */
var executeDispatchesAndRelease = function (event, simulated) {
  if (event) {
    EventPluginUtils.executeDispatchesInOrder(event, simulated);

    if (!event.isPersistent()) {
      event.constructor.release(event);
    }
  }
};
var executeDispatchesAndReleaseSimulated = function (e) {
  return executeDispatchesAndRelease(e, true);
};
var executeDispatchesAndReleaseTopLevel = function (e) {
  return executeDispatchesAndRelease(e, false);
};

var getDictionaryKey = function (inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
};

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

function shouldPreventMouseEvent(name, type, props) {
  switch (name) {
    case 'onClick':
    case 'onClickCapture':
    case 'onDoubleClick':
    case 'onDoubleClickCapture':
    case 'onMouseDown':
    case 'onMouseDownCapture':
    case 'onMouseMove':
    case 'onMouseMoveCapture':
    case 'onMouseUp':
    case 'onMouseUpCapture':
      return !!(props.disabled && isInteractive(type));
    default:
      return false;
  }
}

/**
 * This is a unified interface for event plugins to be installed and configured.
 *
 * Event plugins can implement the following properties:
 *
 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
 *     Required. When a top-level event is fired, this method is expected to
 *     extract synthetic events that will in turn be queued and dispatched.
 *
 *   `eventTypes` {object}
 *     Optional, plugins that fire events must publish a mapping of registration
 *     names that are used to register listeners. Values of this mapping must
 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
 *
 *   `executeDispatch` {function(object, function, string)}
 *     Optional, allows plugins to override how an event gets dispatched. By
 *     default, the listener is simply invoked.
 *
 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
 *
 * @public
 */
var EventPluginHub = {

  /**
   * Methods for injecting dependencies.
   */
  injection: {

    /**
     * @param {array} InjectedEventPluginOrder
     * @public
     */
    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,

    /**
     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
     */
    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName

  },

  /**
   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {function} listener The callback to store.
   */
  putListener: function (inst, registrationName, listener) {
    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;

    var key = getDictionaryKey(inst);
    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
    bankForRegistrationName[key] = listener;

    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.didPutListener) {
      PluginModule.didPutListener(inst, registrationName, listener);
    }
  },

  /**
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @return {?function} The stored callback.
   */
  getListener: function (inst, registrationName) {
    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
    // live here; needs to be moved to a better place soon
    var bankForRegistrationName = listenerBank[registrationName];
    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
      return null;
    }
    var key = getDictionaryKey(inst);
    return bankForRegistrationName && bankForRegistrationName[key];
  },

  /**
   * Deletes a listener from the registration bank.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   */
  deleteListener: function (inst, registrationName) {
    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.willDeleteListener) {
      PluginModule.willDeleteListener(inst, registrationName);
    }

    var bankForRegistrationName = listenerBank[registrationName];
    // TODO: This should never be null -- when is it?
    if (bankForRegistrationName) {
      var key = getDictionaryKey(inst);
      delete bankForRegistrationName[key];
    }
  },

  /**
   * Deletes all listeners for the DOM element with the supplied ID.
   *
   * @param {object} inst The instance, which is the source of events.
   */
  deleteAllListeners: function (inst) {
    var key = getDictionaryKey(inst);
    for (var registrationName in listenerBank) {
      if (!listenerBank.hasOwnProperty(registrationName)) {
        continue;
      }

      if (!listenerBank[registrationName][key]) {
        continue;
      }

      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
      if (PluginModule && PluginModule.willDeleteListener) {
        PluginModule.willDeleteListener(inst, registrationName);
      }

      delete listenerBank[registrationName][key];
    }
  },

  /**
   * Allows registered plugins an opportunity to extract events from top-level
   * native browser events.
   *
   * @return {*} An accumulation of synthetic events.
   * @internal
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events;
    var plugins = EventPluginRegistry.plugins;
    for (var i = 0; i < plugins.length; i++) {
      // Not every plugin in the ordering may be loaded at runtime.
      var possiblePlugin = plugins[i];
      if (possiblePlugin) {
        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
        if (extractedEvents) {
          events = accumulateInto(events, extractedEvents);
        }
      }
    }
    return events;
  },

  /**
   * Enqueues a synthetic event that should be dispatched when
   * `processEventQueue` is invoked.
   *
   * @param {*} events An accumulation of synthetic events.
   * @internal
   */
  enqueueEvents: function (events) {
    if (events) {
      eventQueue = accumulateInto(eventQueue, events);
    }
  },

  /**
   * Dispatches all synthetic events on the event queue.
   *
   * @internal
   */
  processEventQueue: function (simulated) {
    // Set `eventQueue` to null before processing it so that we can tell if more
    // events get enqueued while processing.
    var processingEventQueue = eventQueue;
    eventQueue = null;
    if (simulated) {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
    } else {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
    }
    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
    // This would be a good time to rethrow if any of the event handlers threw.
    ReactErrorUtils.rethrowCaughtError();
  },

  /**
   * These are needed for tests only. Do not use!
   */
  __purge: function () {
    listenerBank = {};
  },

  __getListenerBank: function () {
    return listenerBank;
  }

};

module.exports = EventPluginHub;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(20);

var getEventTarget = __webpack_require__(71);

/**
 * @interface UIEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var UIEventInterface = {
  view: function (event) {
    if (event.view) {
      return event.view;
    }

    var target = getEventTarget(event);
    if (target.window === target) {
      // target is a window object
      return target;
    }

    var doc = target.ownerDocument;
    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
    if (doc) {
      return doc.defaultView || doc.parentWindow;
    } else {
      return window;
    }
  },
  detail: function (event) {
    return event.detail || 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);

module.exports = SyntheticUIEvent;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 */

// TODO: Replace this with ES6: var ReactInstanceMap = new Map();

var ReactInstanceMap = {

  /**
   * This API should be called `delete` but we'd have to make sure to always
   * transform these to strings for IE support. When this transform is fully
   * supported we can rename it.
   */
  remove: function (key) {
    key._reactInternalInstance = undefined;
  },

  get: function (key) {
    return key._reactInternalInstance;
  },

  has: function (key) {
    return key._reactInternalInstance !== undefined;
  },

  set: function (key, value) {
    key._reactInternalInstance = value;
  }

};

module.exports = ReactInstanceMap;

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = falsy;
/* unused harmony export history */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return component; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return components; });
/* unused harmony export route */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return routes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


function falsy(props, propName, componentName) {
  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
}

var history = __WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"]({
  listen: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  push: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  replace: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  go: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goBack: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goForward: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired
});

var component = __WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"]([__WEBPACK_IMPORTED_MODULE_0_prop_types__["func"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]]);
var components = __WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"]([component, __WEBPACK_IMPORTED_MODULE_0_prop_types__["object"]]);
var route = __WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"]([__WEBPACK_IMPORTED_MODULE_0_prop_types__["object"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["element"]]);
var routes = __WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"]([route, __WEBPACK_IMPORTED_MODULE_0_prop_types__["arrayOf"](route)]);

/***/ }),
/* 48 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(15);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(159),
    baseKeys = __webpack_require__(502),
    isArrayLike = __webpack_require__(58);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(5);

var invariant = __webpack_require__(2);

var OBSERVED_ERROR = {};

/**
 * `Transaction` creates a black box that is able to wrap any method such that
 * certain invariants are maintained before and after the method is invoked
 * (Even if an exception is thrown while invoking the wrapped method). Whoever
 * instantiates a transaction can provide enforcers of the invariants at
 * creation time. The `Transaction` class itself will supply one additional
 * automatic invariant for you - the invariant that any transaction instance
 * should not be run while it is already being run. You would typically create a
 * single instance of a `Transaction` for reuse multiple times, that potentially
 * is used to wrap several different methods. Wrappers are extremely simple -
 * they only require implementing two methods.
 *
 * <pre>
 *                       wrappers (injected at creation time)
 *                                      +        +
 *                                      |        |
 *                    +-----------------|--------|--------------+
 *                    |                 v        |              |
 *                    |      +---------------+   |              |
 *                    |   +--|    wrapper1   |---|----+         |
 *                    |   |  +---------------+   v    |         |
 *                    |   |          +-------------+  |         |
 *                    |   |     +----|   wrapper2  |--------+   |
 *                    |   |     |    +-------------+  |     |   |
 *                    |   |     |                     |     |   |
 *                    |   v     v                     v     v   | wrapper
 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | +---+ +---+   +---------+   +---+ +---+ |
 *                    |  initialize                    close    |
 *                    +-----------------------------------------+
 * </pre>
 *
 * Use cases:
 * - Preserving the input selection ranges before/after reconciliation.
 *   Restoring selection even in the event of an unexpected error.
 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
 *   while guaranteeing that afterwards, the event system is reactivated.
 * - Flushing a queue of collected DOM mutations to the main UI thread after a
 *   reconciliation takes place in a worker thread.
 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
 *   content.
 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
 * - (Future use case): Layout calculations before and after DOM updates.
 *
 * Transactional plugin API:
 * - A module that has an `initialize` method that returns any precomputation.
 * - and a `close` method that accepts the precomputation. `close` is invoked
 *   when the wrapped process is completed, or has failed.
 *
 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
 * that implement `initialize` and `close`.
 * @return {Transaction} Single transaction for reuse in thread.
 *
 * @class Transaction
 */
var TransactionImpl = {
  /**
   * Sets up this instance so that it is prepared for collecting metrics. Does
   * so such that this setup method may be used on an instance that is already
   * initialized, in a way that does not consume additional memory upon reuse.
   * That can be useful if you decide to make your subclass of this mixin a
   * "PooledClass".
   */
  reinitializeTransaction: function () {
    this.transactionWrappers = this.getTransactionWrappers();
    if (this.wrapperInitData) {
      this.wrapperInitData.length = 0;
    } else {
      this.wrapperInitData = [];
    }
    this._isInTransaction = false;
  },

  _isInTransaction: false,

  /**
   * @abstract
   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
   */
  getTransactionWrappers: null,

  isInTransaction: function () {
    return !!this._isInTransaction;
  },

  /**
   * Executes the function within a safety window. Use this for the top level
   * methods that result in large amounts of computation/mutations that would
   * need to be safety checked. The optional arguments helps prevent the need
   * to bind in many cases.
   *
   * @param {function} method Member of scope to call.
   * @param {Object} scope Scope to invoke from.
   * @param {Object?=} a Argument to pass to the method.
   * @param {Object?=} b Argument to pass to the method.
   * @param {Object?=} c Argument to pass to the method.
   * @param {Object?=} d Argument to pass to the method.
   * @param {Object?=} e Argument to pass to the method.
   * @param {Object?=} f Argument to pass to the method.
   *
   * @return {*} Return value from `method`.
   */
  perform: function (method, scope, a, b, c, d, e, f) {
    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
    var errorThrown;
    var ret;
    try {
      this._isInTransaction = true;
      // Catching errors makes debugging more difficult, so we start with
      // errorThrown set to true before setting it to false after calling
      // close -- if it's still set to true in the finally block, it means
      // one of these calls threw.
      errorThrown = true;
      this.initializeAll(0);
      ret = method.call(scope, a, b, c, d, e, f);
      errorThrown = false;
    } finally {
      try {
        if (errorThrown) {
          // If `method` throws, prefer to show that stack trace over any thrown
          // by invoking `closeAll`.
          try {
            this.closeAll(0);
          } catch (err) {}
        } else {
          // Since `method` didn't throw, we don't want to silence the exception
          // here.
          this.closeAll(0);
        }
      } finally {
        this._isInTransaction = false;
      }
    }
    return ret;
  },

  initializeAll: function (startIndex) {
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      try {
        // Catching errors makes debugging more difficult, so we start with the
        // OBSERVED_ERROR state before overwriting it with the real return value
        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
        // block, it means wrapper.initialize threw.
        this.wrapperInitData[i] = OBSERVED_ERROR;
        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
      } finally {
        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
          // The initializer for wrapper i threw an error; initialize the
          // remaining wrappers but silence any exceptions from them to ensure
          // that the first error is the one to bubble up.
          try {
            this.initializeAll(i + 1);
          } catch (err) {}
        }
      }
    }
  },

  /**
   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
   * them the respective return values of `this.transactionWrappers.init[i]`
   * (`close`rs that correspond to initializers that failed will not be
   * invoked).
   */
  closeAll: function (startIndex) {
    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      var initData = this.wrapperInitData[i];
      var errorThrown;
      try {
        // Catching errors makes debugging more difficult, so we start with
        // errorThrown set to true before setting it to false after calling
        // close -- if it's still set to true in the finally block, it means
        // wrapper.close threw.
        errorThrown = true;
        if (initData !== OBSERVED_ERROR && wrapper.close) {
          wrapper.close.call(this, initData);
        }
        errorThrown = false;
      } finally {
        if (errorThrown) {
          // The closer for wrapper i threw an error; close the remaining
          // wrappers but silence any exceptions from them to ensure that the
          // first error is the one to bubble up.
          try {
            this.closeAll(i + 1);
          } catch (e) {}
        }
      }
    }
    this.wrapperInitData.length = 0;
  }
};

module.exports = TransactionImpl;

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(45);
var ViewportMetrics = __webpack_require__(119);

var getEventModifierState = __webpack_require__(73);

/**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var MouseEventInterface = {
  screenX: null,
  screenY: null,
  clientX: null,
  clientY: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  getModifierState: getEventModifierState,
  button: function (event) {
    // Webkit, Firefox, IE9+
    // which:  1 2 3
    // button: 0 1 2 (standard)
    var button = event.button;
    if ('which' in event) {
      return button;
    }
    // IE<9
    // which:  undefined
    // button: 0 0 0
    // button: 1 4 2 (onmouseup)
    return button === 2 ? 2 : button === 4 ? 1 : 0;
  },
  buttons: null,
  relatedTarget: function (event) {
    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
  },
  // "Proprietary" Interface.
  pageX: function (event) {
    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
  },
  pageY: function (event) {
    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);

module.exports = SyntheticMouseEvent;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(11);
var DOMNamespaces = __webpack_require__(75);

var WHITESPACE_TEST = /^[ \r\n\t\f]/;
var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;

var createMicrosoftUnsafeLocalFunction = __webpack_require__(76);

// SVG temp container for IE lacking innerHTML
var reusableSVGContainer;

/**
 * Set the innerHTML property of a node, ensuring that whitespace is preserved
 * even in IE8.
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */
var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
  // IE does not have innerHTML for SVG nodes, so instead we inject the
  // new markup in a temp node and then move the child nodes across into
  // the target node
  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
    var svgNode = reusableSVGContainer.firstChild;
    while (svgNode.firstChild) {
      node.appendChild(svgNode.firstChild);
    }
  } else {
    node.innerHTML = html;
  }
});

if (ExecutionEnvironment.canUseDOM) {
  // IE8: When updating a just created node with innerHTML only leading
  // whitespace is removed. When updating an existing node with innerHTML
  // whitespace in root TextNodes is also collapsed.
  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html

  // Feature detection; only IE8 is known to behave improperly like this.
  var testElement = document.createElement('div');
  testElement.innerHTML = ' ';
  if (testElement.innerHTML === '') {
    setInnerHTML = function (node, html) {
      // Magic theory: IE8 supposedly differentiates between added and updated
      // nodes when processing innerHTML, innerHTML on updated nodes suffers
      // from worse whitespace behavior. Re-adding a node like this triggers
      // the initial and more favorable whitespace behavior.
      // TODO: What to do on a detached node?
      if (node.parentNode) {
        node.parentNode.replaceChild(node, node);
      }

      // We also implement a workaround for non-visible tags disappearing into
      // thin air on IE8, this only happens if there is no visible text
      // in-front of the non-visible tags. Piggyback on the whitespace fix
      // and simply check if any non-visible tags appear in the source.
      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
        // Recover leading whitespace by temporarily prepending any character.
        // \uFEFF has the potential advantage of being zero-width/invisible.
        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
        // in hopes that this is preserved even if "\uFEFF" is transformed to
        // the actual Unicode character (by Babel, for example).
        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
        node.innerHTML = String.fromCharCode(0xFEFF) + html;

        // deleteData leaves an empty `TextNode` which offsets the index of all
        // children. Definitely want to avoid this.
        var textNode = node.firstChild;
        if (textNode.data.length === 1) {
          node.removeChild(textNode);
        } else {
          textNode.deleteData(0, 1);
        }
      } else {
        node.innerHTML = html;
      }
    };
  }
  testElement = null;
}

module.exports = setInnerHTML;

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * Based on the escape-html library, which is used under the MIT License below:
 *
 * Copyright (c) 2012-2013 TJ Holowaychuk
 * Copyright (c) 2015 Andreas Lubbe
 * Copyright (c) 2015 Tiancheng "Timothy" Gu
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * 'Software'), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 */



// code copied and modified from escape-html
/**
 * Module variables.
 * @private
 */

var matchHtmlRegExp = /["'&<>]/;

/**
 * Escape special characters in the given string of html.
 *
 * @param  {string} string The string to escape for inserting into HTML
 * @return {string}
 * @public
 */

function escapeHtml(string) {
  var str = '' + string;
  var match = matchHtmlRegExp.exec(str);

  if (!match) {
    return str;
  }

  var escape;
  var html = '';
  var index = 0;
  var lastIndex = 0;

  for (index = match.index; index < str.length; index++) {
    switch (str.charCodeAt(index)) {
      case 34:
        // "
        escape = '&quot;';
        break;
      case 38:
        // &
        escape = '&amp;';
        break;
      case 39:
        // '
        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
        break;
      case 60:
        // <
        escape = '&lt;';
        break;
      case 62:
        // >
        escape = '&gt;';
        break;
      default:
        continue;
    }

    if (lastIndex !== index) {
      html += str.substring(lastIndex, index);
    }

    lastIndex = index + 1;
    html += escape;
  }

  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
}
// end code copied and modified from escape-html


/**
 * Escapes text to prevent scripting attacks.
 *
 * @param {*} text Text value to escape.
 * @return {string} An escaped string.
 */
function escapeTextContentForBrowser(text) {
  if (typeof text === 'boolean' || typeof text === 'number') {
    // this shortcircuit helps perf for types that we know will never have
    // special characters, especially given that this function is used often
    // for numeric dom ids.
    return '' + text;
  }
  return escapeHtml(text);
}

module.exports = escapeTextContentForBrowser;

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(8);

var EventPluginRegistry = __webpack_require__(68);
var ReactEventEmitterMixin = __webpack_require__(362);
var ViewportMetrics = __webpack_require__(119);

var getVendorPrefixedEventName = __webpack_require__(363);
var isEventSupported = __webpack_require__(72);

/**
 * Summary of `ReactBrowserEventEmitter` event handling:
 *
 *  - Top-level delegation is used to trap most native browser events. This
 *    may only occur in the main thread and is the responsibility of
 *    ReactEventListener, which is injected and can therefore support pluggable
 *    event sources. This is the only work that occurs in the main thread.
 *
 *  - We normalize and de-duplicate events to account for browser quirks. This
 *    may be done in the worker thread.
 *
 *  - Forward these native events (with the associated top-level type used to
 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
 *    to extract any synthetic events.
 *
 *  - The `EventPluginHub` will then process each event by annotating them with
 *    "dispatches", a sequence of listeners and IDs that care about that event.
 *
 *  - The `EventPluginHub` then dispatches the events.
 *
 * Overview of React and the event system:
 *
 * +------------+    .
 * |    DOM     |    .
 * +------------+    .
 *       |           .
 *       v           .
 * +------------+    .
 * | ReactEvent |    .
 * |  Listener  |    .
 * +------------+    .                         +-----------+
 *       |           .               +--------+|SimpleEvent|
 *       |           .               |         |Plugin     |
 * +-----|------+    .               v         +-----------+
 * |     |      |    .    +--------------+                    +------------+
 * |     +-----------.--->|EventPluginHub|                    |    Event   |
 * |            |    .    |              |     +-----------+  | Propagators|
 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
 * |            |    .    |              |     +-----------+  |  utilities |
 * |     +-----------.--->|              |                    +------------+
 * |     |      |    .    +--------------+
 * +-----|------+    .                ^        +-----------+
 *       |           .                |        |Enter/Leave|
 *       +           .                +-------+|Plugin     |
 * +-------------+   .                         +-----------+
 * | application |   .
 * |-------------|   .
 * |             |   .
 * |             |   .
 * +-------------+   .
 *                   .
 *    React Core     .  General Purpose Event Plugin System
 */

var hasEventPageXY;
var alreadyListeningTo = {};
var isMonitoringScrollValue = false;
var reactTopListenersCounter = 0;

// For events like 'submit' which don't consistently bubble (which we trap at a
// lower node than `document`), binding at `document` would cause duplicate
// events so we don't include them here
var topEventMapping = {
  topAbort: 'abort',
  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
  topBlur: 'blur',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topChange: 'change',
  topClick: 'click',
  topCompositionEnd: 'compositionend',
  topCompositionStart: 'compositionstart',
  topCompositionUpdate: 'compositionupdate',
  topContextMenu: 'contextmenu',
  topCopy: 'copy',
  topCut: 'cut',
  topDoubleClick: 'dblclick',
  topDrag: 'drag',
  topDragEnd: 'dragend',
  topDragEnter: 'dragenter',
  topDragExit: 'dragexit',
  topDragLeave: 'dragleave',
  topDragOver: 'dragover',
  topDragStart: 'dragstart',
  topDrop: 'drop',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topFocus: 'focus',
  topInput: 'input',
  topKeyDown: 'keydown',
  topKeyPress: 'keypress',
  topKeyUp: 'keyup',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topMouseDown: 'mousedown',
  topMouseMove: 'mousemove',
  topMouseOut: 'mouseout',
  topMouseOver: 'mouseover',
  topMouseUp: 'mouseup',
  topPaste: 'paste',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topScroll: 'scroll',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topSelectionChange: 'selectionchange',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTextInput: 'textInput',
  topTimeUpdate: 'timeupdate',
  topTouchCancel: 'touchcancel',
  topTouchEnd: 'touchend',
  topTouchMove: 'touchmove',
  topTouchStart: 'touchstart',
  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting',
  topWheel: 'wheel'
};

/**
 * To ensure no conflicts with other potential React instances on the page
 */
var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);

function getListeningForDocument(mountAt) {
  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
  // directly.
  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
    mountAt[topListenersIDKey] = reactTopListenersCounter++;
    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
  }
  return alreadyListeningTo[mountAt[topListenersIDKey]];
}

/**
 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
 * example:
 *
 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
 *
 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
 *
 * @internal
 */
var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {

  /**
   * Injectable event backend
   */
  ReactEventListener: null,

  injection: {
    /**
     * @param {object} ReactEventListener
     */
    injectReactEventListener: function (ReactEventListener) {
      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
    }
  },

  /**
   * Sets whether or not any created callbacks should be enabled.
   *
   * @param {boolean} enabled True if callbacks should be enabled.
   */
  setEnabled: function (enabled) {
    if (ReactBrowserEventEmitter.ReactEventListener) {
      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
    }
  },

  /**
   * @return {boolean} True if callbacks are enabled.
   */
  isEnabled: function () {
    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
  },

  /**
   * We listen for bubbled touch events on the document object.
   *
   * Firefox v8.01 (and possibly others) exhibited strange behavior when
   * mounting `onmousemove` events at some node that was not the document
   * element. The symptoms were that if your mouse is not moving over something
   * contained within that mount point (for example on the background) the
   * top-level listeners for `onmousemove` won't be called. However, if you
   * register the `mousemove` on the document object, then it will of course
   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
   * top-level listeners to the document object only, at least for these
   * movement types of events and possibly all events.
   *
   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
   *
   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
   * they bubble to document.
   *
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {object} contentDocumentHandle Document which owns the container
   */
  listenTo: function (registrationName, contentDocumentHandle) {
    var mountAt = contentDocumentHandle;
    var isListening = getListeningForDocument(mountAt);
    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];

    for (var i = 0; i < dependencies.length; i++) {
      var dependency = dependencies[i];
      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
        if (dependency === 'topWheel') {
          if (isEventSupported('wheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
          } else if (isEventSupported('mousewheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
          } else {
            // Firefox needs to capture a different mouse scroll event.
            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
          }
        } else if (dependency === 'topScroll') {

          if (isEventSupported('scroll', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
          } else {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
          }
        } else if (dependency === 'topFocus' || dependency === 'topBlur') {

          if (isEventSupported('focus', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
          } else if (isEventSupported('focusin')) {
            // IE has `focusin` and `focusout` events which bubble.
            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
          }

          // to make sure blur and focus event listeners are only attached once
          isListening.topBlur = true;
          isListening.topFocus = true;
        } else if (topEventMapping.hasOwnProperty(dependency)) {
          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
        }

        isListening[dependency] = true;
      }
    }
  },

  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
  },

  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
  },

  /**
   * Protect against document.createEvent() returning null
   * Some popup blocker extensions appear to do this:
   * https://github.com/facebook/react/issues/6887
   */
  supportsEventPageXY: function () {
    if (!document.createEvent) {
      return false;
    }
    var ev = document.createEvent('MouseEvent');
    return ev != null && 'pageX' in ev;
  },

  /**
   * Listens to window scroll and resize events. We cache scroll values so that
   * application code can access them without triggering reflows.
   *
   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
   * pageX/pageY isn't supported (legacy browsers).
   *
   * NOTE: Scroll events do not bubble.
   *
   * @see http://www.quirksmode.org/dom/events/scroll.html
   */
  ensureScrollValueMonitoring: function () {
    if (hasEventPageXY === undefined) {
      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
    }
    if (!hasEventPageXY && !isMonitoringScrollValue) {
      var refresh = ViewportMetrics.refreshScrollValues;
      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
      isMonitoringScrollValue = true;
    }
  }

});

module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/**
 * Indicates that navigation was caused by a call to history.push.
 */
var PUSH = exports.PUSH = 'PUSH';

/**
 * Indicates that navigation was caused by a call to history.replace.
 */
var REPLACE = exports.REPLACE = 'REPLACE';

/**
 * Indicates that navigation was caused by some other action such
 * as using a browser's back/forward buttons and/or manually manipulating
 * the URL in a browser's location bar. This is the default.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
 * for more information.
 */
var POP = exports.POP = 'POP';

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopstateOnHashchange = exports.supportsPopstateOnHashchange = function supportsPopstateOnHashchange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(164),
    isLength = __webpack_require__(99);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(508),
    listCacheDelete = __webpack_require__(509),
    listCacheGet = __webpack_require__(510),
    listCacheHas = __webpack_require__(511),
    listCacheSet = __webpack_require__(512);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(103);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(31);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(530);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(29),
    isObjectLike = __webpack_require__(30);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(63);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(185),
    baseAssignValue = __webpack_require__(186);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(33);

var ReactNoopUpdateQueue = __webpack_require__(67);

var canDefineProperty = __webpack_require__(109);
var emptyObject = __webpack_require__(35);
var invariant = __webpack_require__(2);
var warning = __webpack_require__(4);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'setState');
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'forceUpdate');
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (false) {
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function (methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : void 0;
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

module.exports = ReactComponent;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var warning = __webpack_require__(4);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnNoop(publicInstance, 'setState');
  }
};

module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(5);

var invariant = __webpack_require__(2);

/**
 * Injectable ordering of event plugins.
 */
var eventPluginOrder = null;

/**
 * Injectable mapping from names to event plugin modules.
 */
var namesToPlugins = {};

/**
 * Recomputes the plugin list using the injected plugins and plugin ordering.
 *
 * @private
 */
function recomputePluginOrdering() {
  if (!eventPluginOrder) {
    // Wait until an `eventPluginOrder` is injected.
    return;
  }
  for (var pluginName in namesToPlugins) {
    var pluginModule = namesToPlugins[pluginName];
    var pluginIndex = eventPluginOrder.indexOf(pluginName);
    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
    if (EventPluginRegistry.plugins[pluginIndex]) {
      continue;
    }
    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
    var publishedEvents = pluginModule.eventTypes;
    for (var eventName in publishedEvents) {
      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
    }
  }
}

/**
 * Publishes an event so that it can be dispatched by the supplied plugin.
 *
 * @param {object} dispatchConfig Dispatch configuration for the event.
 * @param {object} PluginModule Plugin publishing the event.
 * @return {boolean} True if the event was successfully published.
 * @private
 */
function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;

  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
  if (phasedRegistrationNames) {
    for (var phaseName in phasedRegistrationNames) {
      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
        var phasedRegistrationName = phasedRegistrationNames[phaseName];
        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
      }
    }
    return true;
  } else if (dispatchConfig.registrationName) {
    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
    return true;
  }
  return false;
}

/**
 * Publishes a registration name that is used to identify dispatched events and
 * can be used with `EventPluginHub.putListener` to register listeners.
 *
 * @param {string} registrationName Registration name to add.
 * @param {object} PluginModule Plugin publishing the event.
 * @private
 */
function publishRegistrationName(registrationName, pluginModule, eventName) {
  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;

  if (false) {
    var lowerCasedName = registrationName.toLowerCase();
    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;

    if (registrationName === 'onDoubleClick') {
      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
    }
  }
}

/**
 * Registers plugins so that they can extract and dispatch events.
 *
 * @see {EventPluginHub}
 */
var EventPluginRegistry = {

  /**
   * Ordered list of injected plugins.
   */
  plugins: [],

  /**
   * Mapping from event name to dispatch config
   */
  eventNameDispatchConfigs: {},

  /**
   * Mapping from registration name to plugin module
   */
  registrationNameModules: {},

  /**
   * Mapping from registration name to event name
   */
  registrationNameDependencies: {},

  /**
   * Mapping from lowercase registration names to the properly cased version,
   * used to warn in the case of missing event handlers. Available
   * only in __DEV__.
   * @type {Object}
   */
  possibleRegistrationNames:  false ? {} : null,
  // Trust the developer to only use possibleRegistrationNames in __DEV__

  /**
   * Injects an ordering of plugins (by plugin name). This allows the ordering
   * to be decoupled from injection of the actual plugins so that ordering is
   * always deterministic regardless of packaging, on-the-fly injection, etc.
   *
   * @param {array} InjectedEventPluginOrder
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginOrder}
   */
  injectEventPluginOrder: function (injectedEventPluginOrder) {
    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
    // Clone the ordering so it cannot be dynamically mutated.
    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
    recomputePluginOrdering();
  },

  /**
   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
   * in the ordering injected by `injectEventPluginOrder`.
   *
   * Plugins can be injected as part of page initialization or on-the-fly.
   *
   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginsByName}
   */
  injectEventPluginsByName: function (injectedNamesToPlugins) {
    var isOrderingDirty = false;
    for (var pluginName in injectedNamesToPlugins) {
      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
        continue;
      }
      var pluginModule = injectedNamesToPlugins[pluginName];
      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
        namesToPlugins[pluginName] = pluginModule;
        isOrderingDirty = true;
      }
    }
    if (isOrderingDirty) {
      recomputePluginOrdering();
    }
  },

  /**
   * Looks up the plugin for the supplied event.
   *
   * @param {object} event A synthetic event.
   * @return {?object} The plugin that created the supplied event.
   * @internal
   */
  getPluginModuleForEvent: function (event) {
    var dispatchConfig = event.dispatchConfig;
    if (dispatchConfig.registrationName) {
      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
    }
    if (dispatchConfig.phasedRegistrationNames !== undefined) {
      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
      // that it is not undefined.
      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;

      for (var phase in phasedRegistrationNames) {
        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
          continue;
        }
        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
        if (pluginModule) {
          return pluginModule;
        }
      }
    }
    return null;
  },

  /**
   * Exposed for unit testing.
   * @private
   */
  _resetEventPlugins: function () {
    eventPluginOrder = null;
    for (var pluginName in namesToPlugins) {
      if (namesToPlugins.hasOwnProperty(pluginName)) {
        delete namesToPlugins[pluginName];
      }
    }
    EventPluginRegistry.plugins.length = 0;

    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
    for (var eventName in eventNameDispatchConfigs) {
      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
        delete eventNameDispatchConfigs[eventName];
      }
    }

    var registrationNameModules = EventPluginRegistry.registrationNameModules;
    for (var registrationName in registrationNameModules) {
      if (registrationNameModules.hasOwnProperty(registrationName)) {
        delete registrationNameModules[registrationName];
      }
    }

    if (false) {
      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
      for (var lowerCasedName in possibleRegistrationNames) {
        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
          delete possibleRegistrationNames[lowerCasedName];
        }
      }
    }
  }

};

module.exports = EventPluginRegistry;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5);

var ReactErrorUtils = __webpack_require__(70);

var invariant = __webpack_require__(2);
var warning = __webpack_require__(4);

/**
 * Injected dependencies:
 */

/**
 * - `ComponentTree`: [required] Module that can convert between React instances
 *   and actual node references.
 */
var ComponentTree;
var TreeTraversal;
var injection = {
  injectComponentTree: function (Injected) {
    ComponentTree = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
    }
  },
  injectTreeTraversal: function (Injected) {
    TreeTraversal = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
    }
  }
};

function isEndish(topLevelType) {
  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
}

function isMoveish(topLevelType) {
  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
}
function isStartish(topLevelType) {
  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
}

var validateEventDispatches;
if (false) {
  validateEventDispatches = function (event) {
    var dispatchListeners = event._dispatchListeners;
    var dispatchInstances = event._dispatchInstances;

    var listenersIsArr = Array.isArray(dispatchListeners);
    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;

    var instancesIsArr = Array.isArray(dispatchInstances);
    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;

    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
  };
}

/**
 * Dispatch the event to the listener.
 * @param {SyntheticEvent} event SyntheticEvent to handle
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @param {function} listener Application-level callback
 * @param {*} inst Internal component instance
 */
function executeDispatch(event, simulated, listener, inst) {
  var type = event.type || 'unknown-event';
  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
  if (simulated) {
    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
  } else {
    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
  }
  event.currentTarget = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches.
 */
function executeDispatchesInOrder(event, simulated) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
    }
  } else if (dispatchListeners) {
    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
  }
  event._dispatchListeners = null;
  event._dispatchInstances = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches, but stops
 * at the first dispatch execution returning true, and returns that id.
 *
 * @return {?string} id of the first dispatch execution who's listener returns
 * true, or null if no listener returned true.
 */
function executeDispatchesInOrderStopAtTrueImpl(event) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      if (dispatchListeners[i](event, dispatchInstances[i])) {
        return dispatchInstances[i];
      }
    }
  } else if (dispatchListeners) {
    if (dispatchListeners(event, dispatchInstances)) {
      return dispatchInstances;
    }
  }
  return null;
}

/**
 * @see executeDispatchesInOrderStopAtTrueImpl
 */
function executeDispatchesInOrderStopAtTrue(event) {
  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
  event._dispatchInstances = null;
  event._dispatchListeners = null;
  return ret;
}

/**
 * Execution of a "direct" dispatch - there must be at most one dispatch
 * accumulated on the event or it is considered an error. It doesn't really make
 * sense for an event with multiple dispatches (bubbled) to keep track of the
 * return values at each dispatch execution, but it does tend to make sense when
 * dealing with "direct" dispatches.
 *
 * @return {*} The return value of executing the single dispatch.
 */
function executeDirectDispatch(event) {
  if (false) {
    validateEventDispatches(event);
  }
  var dispatchListener = event._dispatchListeners;
  var dispatchInstance = event._dispatchInstances;
  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
  var res = dispatchListener ? dispatchListener(event) : null;
  event.currentTarget = null;
  event._dispatchListeners = null;
  event._dispatchInstances = null;
  return res;
}

/**
 * @param {SyntheticEvent} event
 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
 */
function hasDispatches(event) {
  return !!event._dispatchListeners;
}

/**
 * General utilities that are useful in creating custom Event Plugins.
 */
var EventPluginUtils = {
  isEndish: isEndish,
  isMoveish: isMoveish,
  isStartish: isStartish,

  executeDirectDispatch: executeDirectDispatch,
  executeDispatchesInOrder: executeDispatchesInOrder,
  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
  hasDispatches: hasDispatches,

  getInstanceFromNode: function (node) {
    return ComponentTree.getInstanceFromNode(node);
  },
  getNodeFromInstance: function (node) {
    return ComponentTree.getNodeFromInstance(node);
  },
  isAncestor: function (a, b) {
    return TreeTraversal.isAncestor(a, b);
  },
  getLowestCommonAncestor: function (a, b) {
    return TreeTraversal.getLowestCommonAncestor(a, b);
  },
  getParentInstance: function (inst) {
    return TreeTraversal.getParentInstance(inst);
  },
  traverseTwoPhase: function (target, fn, arg) {
    return TreeTraversal.traverseTwoPhase(target, fn, arg);
  },
  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
  },

  injection: injection
};

module.exports = EventPluginUtils;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var caughtError = null;

/**
 * Call a function while guarding against errors that happens within it.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} a First argument
 * @param {*} b Second argument
 */
function invokeGuardedCallback(name, func, a) {
  try {
    func(a);
  } catch (x) {
    if (caughtError === null) {
      caughtError = x;
    }
  }
}

var ReactErrorUtils = {
  invokeGuardedCallback: invokeGuardedCallback,

  /**
   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
   * handler are sure to be rethrown by rethrowCaughtError.
   */
  invokeGuardedCallbackWithCatch: invokeGuardedCallback,

  /**
   * During execution of guarded functions we will capture the first error which
   * we will rethrow to be handled by the top level error handler.
   */
  rethrowCaughtError: function () {
    if (caughtError) {
      var error = caughtError;
      caughtError = null;
      throw error;
    }
  }
};

if (false) {
  /**
   * To help development we can get better devtools integration by simulating a
   * real browser event.
   */
  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
    var fakeNode = document.createElement('react');
    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
      var boundFunc = func.bind(null, a);
      var evtType = 'react-' + name;
      fakeNode.addEventListener(evtType, boundFunc, false);
      var evt = document.createEvent('Event');
      evt.initEvent(evtType, false, false);
      fakeNode.dispatchEvent(evt);
      fakeNode.removeEventListener(evtType, boundFunc, false);
    };
  }
}

module.exports = ReactErrorUtils;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */

function getEventTarget(nativeEvent) {
  var target = nativeEvent.target || nativeEvent.srcElement || window;

  // Normalize SVG <use> element events #4963
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
  // @see http://www.quirksmode.org/js/events_properties.html
  return target.nodeType === 3 ? target.parentNode : target;
}

module.exports = getEventTarget;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(11);

var useHasFeature;
if (ExecutionEnvironment.canUseDOM) {
  useHasFeature = document.implementation && document.implementation.hasFeature &&
  // always returns true in newer browsers as per the standard.
  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
  document.implementation.hasFeature('', '') !== true;
}

/**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @param {?boolean} capture Check if the capture phase is supported.
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */
function isEventSupported(eventNameSuffix, capture) {
  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
    return false;
  }

  var eventName = 'on' + eventNameSuffix;
  var isSupported = eventName in document;

  if (!isSupported) {
    var element = document.createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
    // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
  }

  return isSupported;
}

module.exports = isEventSupported;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */

var modifierKeyToProp = {
  'Alt': 'altKey',
  'Control': 'ctrlKey',
  'Meta': 'metaKey',
  'Shift': 'shiftKey'
};

// IE8 does not implement getModifierState so we simply map it to the only
// modifier keys exposed by the event itself, does not support Lock-keys.
// Currently, all major browsers except Chrome seems to support Lock-keys.
function modifierStateGetter(keyArg) {
  var syntheticEvent = this;
  var nativeEvent = syntheticEvent.nativeEvent;
  if (nativeEvent.getModifierState) {
    return nativeEvent.getModifierState(keyArg);
  }
  var keyProp = modifierKeyToProp[keyArg];
  return keyProp ? !!nativeEvent[keyProp] : false;
}

function getEventModifierState(nativeEvent) {
  return modifierStateGetter;
}

module.exports = getEventModifierState;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMLazyTree = __webpack_require__(38);
var Danger = __webpack_require__(347);
var ReactDOMComponentTree = __webpack_require__(9);
var ReactInstrumentation = __webpack_require__(14);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(76);
var setInnerHTML = __webpack_require__(53);
var setTextContent = __webpack_require__(120);

function getNodeAfter(parentNode, node) {
  // Special case for text components, which return [open, close] comments
  // from getHostNode.
  if (Array.isArray(node)) {
    node = node[1];
  }
  return node ? node.nextSibling : parentNode.firstChild;
}

/**
 * Inserts `childNode` as a child of `parentNode` at the `index`.
 *
 * @param {DOMElement} parentNode Parent node in which to insert.
 * @param {DOMElement} childNode Child node to insert.
 * @param {number} index Index at which to insert the child.
 * @internal
 */
var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
  // We rely exclusively on `insertBefore(node, null)` instead of also using
  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
  // we are careful to use `null`.)
  parentNode.insertBefore(childNode, referenceNode);
});

function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
}

function moveChild(parentNode, childNode, referenceNode) {
  if (Array.isArray(childNode)) {
    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
  } else {
    insertChildAt(parentNode, childNode, referenceNode);
  }
}

function removeChild(parentNode, childNode) {
  if (Array.isArray(childNode)) {
    var closingComment = childNode[1];
    childNode = childNode[0];
    removeDelimitedText(parentNode, childNode, closingComment);
    parentNode.removeChild(closingComment);
  }
  parentNode.removeChild(childNode);
}

function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
  var node = openingComment;
  while (true) {
    var nextNode = node.nextSibling;
    insertChildAt(parentNode, node, referenceNode);
    if (node === closingComment) {
      break;
    }
    node = nextNode;
  }
}

function removeDelimitedText(parentNode, startNode, closingComment) {
  while (true) {
    var node = startNode.nextSibling;
    if (node === closingComment) {
      // The closing comment is removed by ReactMultiChild.
      break;
    } else {
      parentNode.removeChild(node);
    }
  }
}

function replaceDelimitedText(openingComment, closingComment, stringText) {
  var parentNode = openingComment.parentNode;
  var nodeAfterComment = openingComment.nextSibling;
  if (nodeAfterComment === closingComment) {
    // There are no text nodes between the opening and closing comments; insert
    // a new one if stringText isn't empty.
    if (stringText) {
      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
    }
  } else {
    if (stringText) {
      // Set the text content of the first node after the opening comment, and
      // remove all following nodes up until the closing comment.
      setTextContent(nodeAfterComment, stringText);
      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
    } else {
      removeDelimitedText(parentNode, openingComment, closingComment);
    }
  }

  if (false) {
    ReactInstrumentation.debugTool.onHostOperation({
      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
      type: 'replace text',
      payload: stringText
    });
  }
}

var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
if (false) {
  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
    if (prevInstance._debugID !== 0) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: prevInstance._debugID,
        type: 'replace with',
        payload: markup.toString()
      });
    } else {
      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
      if (nextInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: nextInstance._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  };
}

/**
 * Operations for updating with DOM children.
 */
var DOMChildrenOperations = {

  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,

  replaceDelimitedText: replaceDelimitedText,

  /**
   * Updates a component's children by processing a series of updates. The
   * update configurations are each expected to have a `parentNode` property.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  processUpdates: function (parentNode, updates) {
    if (false) {
      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
    }

    for (var k = 0; k < updates.length; k++) {
      var update = updates[k];
      switch (update.type) {
        case 'INSERT_MARKUP':
          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'insert child',
              payload: { toIndex: update.toIndex, content: update.content.toString() }
            });
          }
          break;
        case 'MOVE_EXISTING':
          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'move child',
              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
            });
          }
          break;
        case 'SET_MARKUP':
          setInnerHTML(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace children',
              payload: update.content.toString()
            });
          }
          break;
        case 'TEXT_CONTENT':
          setTextContent(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace text',
              payload: update.content.toString()
            });
          }
          break;
        case 'REMOVE_NODE':
          removeChild(parentNode, update.fromNode);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'remove child',
              payload: { fromIndex: update.fromIndex }
            });
          }
          break;
      }
    }
  }

};

module.exports = DOMChildrenOperations;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMNamespaces = {
  html: 'http://www.w3.org/1999/xhtml',
  mathml: 'http://www.w3.org/1998/Math/MathML',
  svg: 'http://www.w3.org/2000/svg'
};

module.exports = DOMNamespaces;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* globals MSApp */



/**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */

var createMicrosoftUnsafeLocalFunction = function (func) {
  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
    return function (arg0, arg1, arg2, arg3) {
      MSApp.execUnsafeLocalFunction(function () {
        return func(arg0, arg1, arg2, arg3);
      });
    };
  } else {
    return func;
  }
};

module.exports = createMicrosoftUnsafeLocalFunction;

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5);

var ReactPropTypesSecret = __webpack_require__(365);
var propTypesFactory = __webpack_require__(366);

var React = __webpack_require__(32);
var PropTypes = propTypesFactory(React.isValidElement);

var invariant = __webpack_require__(2);
var warning = __webpack_require__(4);

var hasReadOnlyValue = {
  'button': true,
  'checkbox': true,
  'image': true,
  'hidden': true,
  'radio': true,
  'reset': true,
  'submit': true
};

function _assertSingleLink(inputProps) {
  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
}
function _assertValueLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
}

function _assertCheckedLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
}

var propTypes = {
  value: function (props, propName, componentName) {
    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  checked: function (props, propName, componentName) {
    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  onChange: PropTypes.func
};

var loggedTypeFailures = {};
function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Provide a linked `value` attribute for controlled forms. You should not use
 * this outside of the ReactDOM controlled form components.
 */
var LinkedValueUtils = {
  checkPropTypes: function (tagName, props, owner) {
    for (var propName in propTypes) {
      if (propTypes.hasOwnProperty(propName)) {
        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
      }
      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
        // Only monitor this failure once because there tends to be a lot of the
        // same error.
        loggedTypeFailures[error.message] = true;

        var addendum = getDeclarationErrorAddendum(owner);
         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
      }
    }
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current value of the input either from value prop or link.
   */
  getValue: function (inputProps) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.value;
    }
    return inputProps.value;
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current checked status of the input either from checked prop
   *             or link.
   */
  getChecked: function (inputProps) {
    if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.value;
    }
    return inputProps.checked;
  },

  /**
   * @param {object} inputProps Props for form component
   * @param {SyntheticEvent} event change event to handle
   */
  executeOnChange: function (inputProps, event) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.requestChange(event.target.value);
    } else if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.requestChange(event.target.checked);
    } else if (inputProps.onChange) {
      return inputProps.onChange.call(undefined, event);
    }
  }
};

module.exports = LinkedValueUtils;

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(5);

var invariant = __webpack_require__(2);

var injected = false;

var ReactComponentEnvironment = {

  /**
   * Optionally injectable hook for swapping out mount images in the middle of
   * the tree.
   */
  replaceNodeWithMarkup: null,

  /**
   * Optionally injectable hook for processing a queue of child updates. Will
   * later move into MultiChildComponents.
   */
  processChildrenUpdates: null,

  injection: {
    injectEnvironment: function (environment) {
      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
      injected = true;
    }
  }

};

module.exports = ReactComponentEnvironment;

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Given a `prevElement` and `nextElement`, determines if the existing
 * instance should be updated as opposed to being destroyed or replaced by a new
 * instance. Both arguments are elements. This ensures that this logic can
 * operate on stateless trees without any backing instance.
 *
 * @param {?object} prevElement
 * @param {?object} nextElement
 * @return {boolean} True if the existing instance should be updated.
 * @protected
 */

function shouldUpdateReactComponent(prevElement, nextElement) {
  var prevEmpty = prevElement === null || prevElement === false;
  var nextEmpty = nextElement === null || nextElement === false;
  if (prevEmpty || nextEmpty) {
    return prevEmpty === nextEmpty;
  }

  var prevType = typeof prevElement;
  var nextType = typeof nextElement;
  if (prevType === 'string' || prevType === 'number') {
    return nextType === 'string' || nextType === 'number';
  } else {
    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
  }
}

module.exports = shouldUpdateReactComponent;

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5);

var ReactCurrentOwner = __webpack_require__(19);
var ReactInstanceMap = __webpack_require__(46);
var ReactInstrumentation = __webpack_require__(14);
var ReactUpdates = __webpack_require__(17);

var invariant = __webpack_require__(2);
var warning = __webpack_require__(4);

function enqueueUpdate(internalInstance) {
  ReactUpdates.enqueueUpdate(internalInstance);
}

function formatUnexpectedArgument(arg) {
  var type = typeof arg;
  if (type !== 'object') {
    return type;
  }
  var displayName = arg.constructor && arg.constructor.name || type;
  var keys = Object.keys(arg);
  if (keys.length > 0 && keys.length < 20) {
    return displayName + ' (keys: ' + keys.join(', ') + ')';
  }
  return displayName;
}

function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
  var internalInstance = ReactInstanceMap.get(publicInstance);
  if (!internalInstance) {
    if (false) {
      var ctor = publicInstance.constructor;
      // Only warn when we have a callerName. Otherwise we should be silent.
      // We're probably calling from enqueueCallback. We don't want to warn
      // there because we already warned for the corresponding lifecycle method.
      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
    }
    return null;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + 'within `render` or another component\'s constructor). Render methods ' + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
  }

  return internalInstance;
}

/**
 * ReactUpdateQueue allows for state updates to be scheduled into a later
 * reconciliation step.
 */
var ReactUpdateQueue = {

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    if (false) {
      var owner = ReactCurrentOwner.current;
      if (owner !== null) {
        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
        owner._warnedAboutRefsInRender = true;
      }
    }
    var internalInstance = ReactInstanceMap.get(publicInstance);
    if (internalInstance) {
      // During componentWillMount and render this will still be null but after
      // that will always render to something. At least for now. So we can use
      // this hack.
      return !!internalInstance._renderedComponent;
    } else {
      return false;
    }
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @param {string} callerName Name of the calling function in the public API.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback, callerName) {
    ReactUpdateQueue.validateCallback(callback, callerName);
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);

    // Previously we would throw an error if we didn't have an internal
    // instance. Since we want to make it a no-op instead, we mirror the same
    // behavior we have in other enqueue* methods.
    // We also need to ignore callbacks in componentWillMount. See
    // enqueueUpdates.
    if (!internalInstance) {
      return null;
    }

    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    // TODO: The callback here is ignored when setState is called from
    // componentWillMount. Either fix it or disallow doing so completely in
    // favor of getInitialState. Alternatively, we can disallow
    // componentWillMount during server-side rendering.
    enqueueUpdate(internalInstance);
  },

  enqueueCallbackInternal: function (internalInstance, callback) {
    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    enqueueUpdate(internalInstance);
  },

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingForceUpdate = true;

    enqueueUpdate(internalInstance);
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState, callback) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingStateQueue = [completeState];
    internalInstance._pendingReplaceState = true;

    // Future-proof 15.5
    if (callback !== undefined && callback !== null) {
      ReactUpdateQueue.validateCallback(callback, 'replaceState');
      if (internalInstance._pendingCallbacks) {
        internalInstance._pendingCallbacks.push(callback);
      } else {
        internalInstance._pendingCallbacks = [callback];
      }
    }

    enqueueUpdate(internalInstance);
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    if (false) {
      ReactInstrumentation.debugTool.onSetState();
      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
    }

    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');

    if (!internalInstance) {
      return;
    }

    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
    queue.push(partialState);

    enqueueUpdate(internalInstance);
  },

  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
    internalInstance._pendingElement = nextElement;
    // TODO: introduce _pendingContext instead of setting it directly.
    internalInstance._context = nextContext;
    enqueueUpdate(internalInstance);
  },

  validateCallback: function (callback, callerName) {
    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
  }

};

module.exports = ReactUpdateQueue;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(8);

var emptyFunction = __webpack_require__(12);
var warning = __webpack_require__(4);

var validateDOMNesting = emptyFunction;

if (false) {
  // This validation code was written based on the HTML5 parsing spec:
  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  //
  // Note: this does not catch all invalid nesting, nor does it try to (as it's
  // not clear what practical benefit doing so provides); instead, we warn only
  // for cases where the parser will give a parse tree differing from what React
  // intended. For example, <b><div></div></b> is invalid but we don't warn
  // because it still parses correctly; we do warn for other cases like nested
  // <p> tags where the beginning of the second element implicitly closes the
  // first, causing a confusing mess.

  // https://html.spec.whatwg.org/multipage/syntax.html#special
  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',

  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
  // TODO: Distinguish by namespace here -- for <title>, including it here
  // errs on the side of fewer warnings
  'foreignObject', 'desc', 'title'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
  var buttonScopeTags = inScopeTags.concat(['button']);

  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];

  var emptyAncestorInfo = {
    current: null,

    formTag: null,
    aTagInScope: null,
    buttonTagInScope: null,
    nobrTagInScope: null,
    pTagInButtonScope: null,

    listItemTagAutoclosing: null,
    dlItemTagAutoclosing: null
  };

  var updatedAncestorInfo = function (oldInfo, tag, instance) {
    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
    var info = { tag: tag, instance: instance };

    if (inScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.aTagInScope = null;
      ancestorInfo.buttonTagInScope = null;
      ancestorInfo.nobrTagInScope = null;
    }
    if (buttonScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.pTagInButtonScope = null;
    }

    // See rules for 'li', 'dd', 'dt' start tags in
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
      ancestorInfo.listItemTagAutoclosing = null;
      ancestorInfo.dlItemTagAutoclosing = null;
    }

    ancestorInfo.current = info;

    if (tag === 'form') {
      ancestorInfo.formTag = info;
    }
    if (tag === 'a') {
      ancestorInfo.aTagInScope = info;
    }
    if (tag === 'button') {
      ancestorInfo.buttonTagInScope = info;
    }
    if (tag === 'nobr') {
      ancestorInfo.nobrTagInScope = info;
    }
    if (tag === 'p') {
      ancestorInfo.pTagInButtonScope = info;
    }
    if (tag === 'li') {
      ancestorInfo.listItemTagAutoclosing = info;
    }
    if (tag === 'dd' || tag === 'dt') {
      ancestorInfo.dlItemTagAutoclosing = info;
    }

    return ancestorInfo;
  };

  /**
   * Returns whether
   */
  var isTagValidWithParent = function (tag, parentTag) {
    // First, let's check if we're in an unusual parsing mode...
    switch (parentTag) {
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
      case 'select':
        return tag === 'option' || tag === 'optgroup' || tag === '#text';
      case 'optgroup':
        return tag === 'option' || tag === '#text';
      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
      // but
      case 'option':
        return tag === '#text';

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
      // No special behavior since these rules fall back to "in body" mode for
      // all except special table nodes which cause bad parsing behavior anyway.

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
      case 'tr':
        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
      case 'tbody':
      case 'thead':
      case 'tfoot':
        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
      case 'colgroup':
        return tag === 'col' || tag === 'template';

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
      case 'table':
        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
      case 'head':
        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';

      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
      case 'html':
        return tag === 'head' || tag === 'body';
      case '#document':
        return tag === 'html';
    }

    // Probably in the "in body" parsing mode, so we outlaw only tag combos
    // where the parsing rules cause implicit opens or closes to be added.
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    switch (tag) {
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';

      case 'rp':
      case 'rt':
        return impliedEndTags.indexOf(parentTag) === -1;

      case 'body':
      case 'caption':
      case 'col':
      case 'colgroup':
      case 'frame':
      case 'head':
      case 'html':
      case 'tbody':
      case 'td':
      case 'tfoot':
      case 'th':
      case 'thead':
      case 'tr':
        // These tags are only valid with a few parents that have special child
        // parsing rules -- if we're down here, then none of those matched and
        // so we allow it only if we don't know what the parent is, as all other
        // cases are invalid.
        return parentTag == null;
    }

    return true;
  };

  /**
   * Returns whether
   */
  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
    switch (tag) {
      case 'address':
      case 'article':
      case 'aside':
      case 'blockquote':
      case 'center':
      case 'details':
      case 'dialog':
      case 'dir':
      case 'div':
      case 'dl':
      case 'fieldset':
      case 'figcaption':
      case 'figure':
      case 'footer':
      case 'header':
      case 'hgroup':
      case 'main':
      case 'menu':
      case 'nav':
      case 'ol':
      case 'p':
      case 'section':
      case 'summary':
      case 'ul':
      case 'pre':
      case 'listing':
      case 'table':
      case 'hr':
      case 'xmp':
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return ancestorInfo.pTagInButtonScope;

      case 'form':
        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;

      case 'li':
        return ancestorInfo.listItemTagAutoclosing;

      case 'dd':
      case 'dt':
        return ancestorInfo.dlItemTagAutoclosing;

      case 'button':
        return ancestorInfo.buttonTagInScope;

      case 'a':
        // Spec says something about storing a list of markers, but it sounds
        // equivalent to this check.
        return ancestorInfo.aTagInScope;

      case 'nobr':
        return ancestorInfo.nobrTagInScope;
    }

    return null;
  };

  /**
   * Given a ReactCompositeComponent instance, return a list of its recursive
   * owners, starting at the root and ending with the instance itself.
   */
  var findOwnerStack = function (instance) {
    if (!instance) {
      return [];
    }

    var stack = [];
    do {
      stack.push(instance);
    } while (instance = instance._currentElement._owner);
    stack.reverse();
    return stack;
  };

  var didWarn = {};

  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;

    if (childText != null) {
      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
      childTag = '#text';
    }

    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
    var problematic = invalidParent || invalidAncestor;

    if (problematic) {
      var ancestorTag = problematic.tag;
      var ancestorInstance = problematic.instance;

      var childOwner = childInstance && childInstance._currentElement._owner;
      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;

      var childOwners = findOwnerStack(childOwner);
      var ancestorOwners = findOwnerStack(ancestorOwner);

      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
      var i;

      var deepestCommon = -1;
      for (i = 0; i < minStackLen; i++) {
        if (childOwners[i] === ancestorOwners[i]) {
          deepestCommon = i;
        } else {
          break;
        }
      }

      var UNKNOWN = '(unknown)';
      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ownerInfo = [].concat(
      // If the parent and child instances have a common owner ancestor, start
      // with that -- otherwise we just start with the parent's owners.
      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
      // If we're warning about an invalid (non-parent) ancestry, add '...'
      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');

      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
      if (didWarn[warnKey]) {
        return;
      }
      didWarn[warnKey] = true;

      var tagDisplayName = childTag;
      var whitespaceInfo = '';
      if (childTag === '#text') {
        if (/\S/.test(childText)) {
          tagDisplayName = 'Text nodes';
        } else {
          tagDisplayName = 'Whitespace text nodes';
          whitespaceInfo = ' Make sure you don\'t have any extra whitespace between tags on ' + 'each line of your source code.';
        }
      } else {
        tagDisplayName = '<' + childTag + '>';
      }

      if (invalidParent) {
        var info = '';
        if (ancestorTag === 'table' && childTag === 'tr') {
          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
        }
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
      } else {
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
      }
    }
  };

  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;

  // For testing
  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;
    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
  };
}

module.exports = validateDOMNesting;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */

function getEventCharCode(nativeEvent) {
  var charCode;
  var keyCode = nativeEvent.keyCode;

  if ('charCode' in nativeEvent) {
    charCode = nativeEvent.charCode;

    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
    if (charCode === 0 && keyCode === 13) {
      charCode = 13;
    }
  } else {
    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
    charCode = keyCode;
  }

  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
  // Must not discard the (non-)printable Enter-key.
  if (charCode >= 32 || charCode === 13) {
    return charCode;
  }

  return 0;
}

module.exports = getEventCharCode;

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = loopAsync;
/* harmony export (immutable) */ __webpack_exports__["b"] = mapAsync;
function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var sync = false,
      hasNext = false,
      doneArgs = void 0;

  function done() {
    isDone = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      doneArgs = [].concat(Array.prototype.slice.call(arguments));
      return;
    }

    callback.apply(this, arguments);
  }

  function next() {
    if (isDone) {
      return;
    }

    hasNext = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      return;
    }

    sync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work.call(this, currentTurn++, next, done);
    }

    sync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(this, doneArgs);
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  }

  next();
}

function mapAsync(array, work, callback) {
  var length = array.length;
  var values = [];

  if (length === 0) return callback(null, values);

  var isDone = false,
      doneCount = 0;

  function done(index, error, value) {
    if (isDone) return;

    if (error) {
      isDone = true;
      callback(error);
    } else {
      values[index] = value;

      isDone = ++doneCount === length;

      if (isDone) callback(null, values);
    }
  }

  array.forEach(function (item, index) {
    work(item, index, function (error, value) {
      done(index, error, value);
    });
  });
}

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getRouteParams__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ContextUtils__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RouteUtils__ = __webpack_require__(24);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };










/**
 * A <RouterContext> renders the component tree for a given router state
 * and sets the history object and the current location in context.
 */
var RouterContext = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default.a({
  displayName: 'RouterContext',

  mixins: [__WEBPACK_IMPORTED_MODULE_5__ContextUtils__["a" /* ContextProvider */]('router')],

  propTypes: {
    router: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"].isRequired,
    location: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"].isRequired,
    routes: __WEBPACK_IMPORTED_MODULE_3_prop_types__["array"].isRequired,
    params: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"].isRequired,
    components: __WEBPACK_IMPORTED_MODULE_3_prop_types__["array"].isRequired,
    createElement: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"].isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      createElement: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement
    };
  },


  childContextTypes: {
    router: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"].isRequired
  },

  getChildContext: function getChildContext() {
    return {
      router: this.props.router
    };
  },
  createElement: function createElement(component, props) {
    return component == null ? null : this.props.createElement(component, props);
  },
  render: function render() {
    var _this = this;

    var _props = this.props,
        location = _props.location,
        routes = _props.routes,
        params = _props.params,
        components = _props.components,
        router = _props.router;

    var element = null;

    if (components) {
      element = components.reduceRight(function (element, components, index) {
        if (components == null) return element; // Don't create new children; use the grandchildren.

        var route = routes[index];
        var routeParams = __WEBPACK_IMPORTED_MODULE_4__getRouteParams__["a" /* default */](route, params);
        var props = {
          location: location,
          params: params,
          route: route,
          router: router,
          routeParams: routeParams,
          routes: routes
        };

        if (__WEBPACK_IMPORTED_MODULE_6__RouteUtils__["c" /* isReactChildren */](element)) {
          props.children = element;
        } else if (element) {
          for (var prop in element) {
            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
          }
        }

        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
          var elements = {};

          for (var key in components) {
            if (Object.prototype.hasOwnProperty.call(components, key)) {
              // Pass through the key as a prop to createElement to allow
              // custom createElement functions to know which named component
              // they're rendering, for e.g. matching up to fetched data.
              elements[key] = _this.createElement(components[key], _extends({
                key: key }, props));
            }
          }

          return elements;
        }

        return _this.createElement(components, props);
      }, element);
    }

    !(element === null || element === false || __WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(element)) ?  false ? invariant(false, 'The root route must render a single element') : __WEBPACK_IMPORTED_MODULE_0_invariant___default.a(false) : void 0;

    return element;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (RouterContext);

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ContextProvider;
/* harmony export (immutable) */ __webpack_exports__["b"] = ContextSubscriber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


// Works around issues with context updates failing to propagate.
// Caveat: the context value is expected to never change its identity.
// https://github.com/facebook/react/issues/2517
// https://github.com/reactjs/react-router/issues/470

var contextProviderShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  eventIndex: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired
});

function makeContextName(name) {
  return '@@contextSubscriber/' + name;
}

function ContextProvider(name) {
  var _childContextTypes, _ref2;

  var contextName = makeContextName(name);
  var listenersKey = contextName + '/listeners';
  var eventIndexKey = contextName + '/eventIndex';
  var subscribeKey = contextName + '/subscribe';

  return _ref2 = {
    childContextTypes: (_childContextTypes = {}, _childContextTypes[contextName] = contextProviderShape.isRequired, _childContextTypes),

    getChildContext: function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextName] = {
        eventIndex: this[eventIndexKey],
        subscribe: this[subscribeKey]
      }, _ref;
    },
    componentWillMount: function componentWillMount() {
      this[listenersKey] = [];
      this[eventIndexKey] = 0;
    },
    componentWillReceiveProps: function componentWillReceiveProps() {
      this[eventIndexKey]++;
    },
    componentDidUpdate: function componentDidUpdate() {
      var _this = this;

      this[listenersKey].forEach(function (listener) {
        return listener(_this[eventIndexKey]);
      });
    }
  }, _ref2[subscribeKey] = function (listener) {
    var _this2 = this;

    // No need to immediately call listener here.
    this[listenersKey].push(listener);

    return function () {
      _this2[listenersKey] = _this2[listenersKey].filter(function (item) {
        return item !== listener;
      });
    };
  }, _ref2;
}

function ContextSubscriber(name) {
  var _contextTypes, _ref4;

  var contextName = makeContextName(name);
  var lastRenderedEventIndexKey = contextName + '/lastRenderedEventIndex';
  var handleContextUpdateKey = contextName + '/handleContextUpdate';
  var unsubscribeKey = contextName + '/unsubscribe';

  return _ref4 = {
    contextTypes: (_contextTypes = {}, _contextTypes[contextName] = contextProviderShape, _contextTypes),

    getInitialState: function getInitialState() {
      var _ref3;

      if (!this.context[contextName]) {
        return {};
      }

      return _ref3 = {}, _ref3[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _ref3;
    },
    componentDidMount: function componentDidMount() {
      if (!this.context[contextName]) {
        return;
      }

      this[unsubscribeKey] = this.context[contextName].subscribe(this[handleContextUpdateKey]);
    },
    componentWillReceiveProps: function componentWillReceiveProps() {
      var _setState;

      if (!this.context[contextName]) {
        return;
      }

      this.setState((_setState = {}, _setState[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _setState));
    },
    componentWillUnmount: function componentWillUnmount() {
      if (!this[unsubscribeKey]) {
        return;
      }

      this[unsubscribeKey]();
      this[unsubscribeKey] = null;
    }
  }, _ref4[handleContextUpdateKey] = function (eventIndex) {
    if (eventIndex !== this.state[lastRenderedEventIndexKey]) {
      var _setState2;

      this.setState((_setState2 = {}, _setState2[lastRenderedEventIndexKey] = eventIndex, _setState2));
    }
  }, _ref4;
}

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return routerShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return locationShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var routerShape = __WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"]({
  push: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  replace: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  go: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goBack: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goForward: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  setRouteLeaveHook: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  isActive: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired
});

var locationShape = __WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"]({
  pathname: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"].isRequired,
  search: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"].isRequired,
  state: __WEBPACK_IMPORTED_MODULE_0_prop_types__["object"],
  action: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"].isRequired,
  key: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]
});

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _warning = __webpack_require__(23);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var runTransitionHook = function runTransitionHook(hook, location, callback) {
  var result = hook(location, callback);

  if (hook.length < 2) {
    // Assume the hook runs synchronously and automatically
    // call the callback with the return value.
    callback(result);
  } else {
     false ? (0, _warning2.default)(result === undefined, 'You should not "return" in a transition hook with a callback argument; ' + 'call the callback instead') : void 0;
  }
};

exports.default = runTransitionHook;

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _AsyncUtils = __webpack_require__(432);

var _PathUtils = __webpack_require__(25);

var _runTransitionHook = __webpack_require__(89);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _Actions = __webpack_require__(56);

var _LocationUtils = __webpack_require__(41);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createHistory = function createHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getCurrentLocation = options.getCurrentLocation,
      getUserConfirmation = options.getUserConfirmation,
      pushLocation = options.pushLocation,
      replaceLocation = options.replaceLocation,
      go = options.go,
      keyLength = options.keyLength;


  var currentLocation = void 0;
  var pendingLocation = void 0;
  var beforeListeners = [];
  var listeners = [];
  var allKeys = [];

  var getCurrentIndex = function getCurrentIndex() {
    if (pendingLocation && pendingLocation.action === _Actions.POP) return allKeys.indexOf(pendingLocation.key);

    if (currentLocation) return allKeys.indexOf(currentLocation.key);

    return -1;
  };

  var updateLocation = function updateLocation(nextLocation) {
    var currentIndex = getCurrentIndex();

    currentLocation = nextLocation;

    if (currentLocation.action === _Actions.PUSH) {
      allKeys = [].concat(allKeys.slice(0, currentIndex + 1), [currentLocation.key]);
    } else if (currentLocation.action === _Actions.REPLACE) {
      allKeys[currentIndex] = currentLocation.key;
    }

    listeners.forEach(function (listener) {
      return listener(currentLocation);
    });
  };

  var listenBefore = function listenBefore(listener) {
    beforeListeners.push(listener);

    return function () {
      return beforeListeners = beforeListeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var listen = function listen(listener) {
    listeners.push(listener);

    return function () {
      return listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, callback) {
    (0, _AsyncUtils.loopAsync)(beforeListeners.length, function (index, next, done) {
      (0, _runTransitionHook2.default)(beforeListeners[index], location, function (result) {
        return result != null ? done(result) : next();
      });
    }, function (message) {
      if (getUserConfirmation && typeof message === 'string') {
        getUserConfirmation(message, function (ok) {
          return callback(ok !== false);
        });
      } else {
        callback(message !== false);
      }
    });
  };

  var transitionTo = function transitionTo(nextLocation) {
    if (currentLocation && (0, _LocationUtils.locationsAreEqual)(currentLocation, nextLocation) || pendingLocation && (0, _LocationUtils.locationsAreEqual)(pendingLocation, nextLocation)) return; // Nothing to do

    pendingLocation = nextLocation;

    confirmTransitionTo(nextLocation, function (ok) {
      if (pendingLocation !== nextLocation) return; // Transition was interrupted during confirmation

      pendingLocation = null;

      if (ok) {
        // Treat PUSH to same path like REPLACE to be consistent with browsers
        if (nextLocation.action === _Actions.PUSH) {
          var prevPath = (0, _PathUtils.createPath)(currentLocation);
          var nextPath = (0, _PathUtils.createPath)(nextLocation);

          if (nextPath === prevPath && (0, _LocationUtils.statesAreEqual)(currentLocation.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
        }

        if (nextLocation.action === _Actions.POP) {
          updateLocation(nextLocation);
        } else if (nextLocation.action === _Actions.PUSH) {
          if (pushLocation(nextLocation) !== false) updateLocation(nextLocation);
        } else if (nextLocation.action === _Actions.REPLACE) {
          if (replaceLocation(nextLocation) !== false) updateLocation(nextLocation);
        }
      } else if (currentLocation && nextLocation.action === _Actions.POP) {
        var prevIndex = allKeys.indexOf(currentLocation.key);
        var nextIndex = allKeys.indexOf(nextLocation.key);

        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL
      }
    });
  };

  var push = function push(input) {
    return transitionTo(createLocation(input, _Actions.PUSH));
  };

  var replace = function replace(input) {
    return transitionTo(createLocation(input, _Actions.REPLACE));
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength || 6);
  };

  var createHref = function createHref(location) {
    return (0, _PathUtils.createPath)(location);
  };

  var createLocation = function createLocation(location, action) {
    var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : createKey();
    return (0, _LocationUtils.createLocation)(location, action, key);
  };

  return {
    getCurrentLocation: getCurrentLocation,
    listenBefore: listenBefore,
    listen: listen,
    transitionTo: transitionTo,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    createKey: createKey,
    createPath: _PathUtils.createPath,
    createHref: createHref,
    createLocation: createLocation
  };
};

exports.default = createHistory;

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.go = exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getUserConfirmation = exports.getCurrentLocation = undefined;

var _LocationUtils = __webpack_require__(41);

var _DOMUtils = __webpack_require__(57);

var _DOMStateStorage = __webpack_require__(147);

var _PathUtils = __webpack_require__(25);

var _ExecutionEnvironment = __webpack_require__(91);

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var needsHashchangeListener = _ExecutionEnvironment.canUseDOM && !(0, _DOMUtils.supportsPopstateOnHashchange)();

var _createLocation = function _createLocation(historyState) {
  var key = historyState && historyState.key;

  return (0, _LocationUtils.createLocation)({
    pathname: window.location.pathname,
    search: window.location.search,
    hash: window.location.hash,
    state: key ? (0, _DOMStateStorage.readState)(key) : undefined
  }, undefined, key);
};

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
  var historyState = void 0;
  try {
    historyState = window.history.state || {};
  } catch (error) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    historyState = {};
  }

  return _createLocation(historyState);
};

var getUserConfirmation = exports.getUserConfirmation = function getUserConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

var startListener = exports.startListener = function startListener(listener) {
  var handlePopState = function handlePopState(event) {
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) // Ignore extraneous popstate events in WebKit
      return;
    listener(_createLocation(event.state));
  };

  (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

  var handleUnpoppedHashChange = function handleUnpoppedHashChange() {
    return listener(getCurrentLocation());
  };

  if (needsHashchangeListener) {
    (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
  }

  return function () {
    (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

    if (needsHashchangeListener) {
      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
    }
  };
};

var updateLocation = function updateLocation(location, updateState) {
  var state = location.state,
      key = location.key;


  if (state !== undefined) (0, _DOMStateStorage.saveState)(key, state);

  updateState({ key: key }, (0, _PathUtils.createPath)(location));
};

var pushLocation = exports.pushLocation = function pushLocation(location) {
  return updateLocation(location, function (state, path) {
    return window.history.pushState(state, null, path);
  });
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
  return updateLocation(location, function (state, path) {
    return window.history.replaceState(state, null, path);
  });
};

var go = exports.go = function go(n) {
  if (n) window.history.go(n);
};

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(153);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createStore", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "combineReducers", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(458);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */](value) || __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */](value) != objectTag) {
    return false;
  }
  var proto = __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */](value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 96 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(158),
    castFunction = __webpack_require__(165);

/**
 * Iterates over own enumerable string keyed properties of an object and
 * invokes `iteratee` for each property. The iteratee is invoked with three
 * arguments: (value, key, object). Iteratee functions may exit iteration
 * early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forOwnRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forOwn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forOwn(object, iteratee) {
  return object && baseForOwn(object, castFunction(iteratee));
}

module.exports = forOwn;


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(15),
    stubFalse = __webpack_require__(498);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(48)(module)))

/***/ }),
/* 99 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 100 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(163);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(59),
    stackClear = __webpack_require__(513),
    stackDelete = __webpack_require__(514),
    stackGet = __webpack_require__(515),
    stackHas = __webpack_require__(516),
    stackSet = __webpack_require__(517);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 103 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(31),
    root = __webpack_require__(15);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(522),
    mapCacheDelete = __webpack_require__(529),
    mapCacheGet = __webpack_require__(531),
    mapCacheHas = __webpack_require__(532),
    mapCacheSet = __webpack_require__(533);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(542),
    stubArray = __webpack_require__(177);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(13),
    isSymbol = __webpack_require__(63);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(171);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var canDefineProperty = false;
if (false) {
  try {
    // $FlowFixMe https://github.com/facebook/flow/issues/285
    Object.defineProperty({}, 'x', { get: function () {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMComponentFlags = {
  hasCachedChildNodes: 1 << 0
};

module.exports = ReactDOMComponentFlags;

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(5);

var invariant = __webpack_require__(2);

/**
 * Accumulates items that must not be null or undefined into the first one. This
 * is used to conserve memory by avoiding array allocations, and thus sacrifices
 * API cleanness. Since `current` can be null before being passed in and not
 * null after this function, make sure to assign it back to `current`:
 *
 * `a = accumulateInto(a, b);`
 *
 * This API should be sparingly used. Try `accumulate` for something cleaner.
 *
 * @return {*|array<*>} An accumulation of items.
 */

function accumulateInto(current, next) {
  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;

  if (current == null) {
    return next;
  }

  // Both are not empty. Warning: Never call x.concat(y) when you are not
  // certain that x is an Array (x could be a string with concat method).
  if (Array.isArray(current)) {
    if (Array.isArray(next)) {
      current.push.apply(current, next);
      return current;
    }
    current.push(next);
    return current;
  }

  if (Array.isArray(next)) {
    // A bit too dangerous to mutate `next`.
    return [current].concat(next);
  }

  return [current, next];
}

module.exports = accumulateInto;

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * @param {array} arr an "accumulation" of items which is either an Array or
 * a single item. Useful when paired with the `accumulate` module. This is a
 * simple utility that allows us to reason about a collection of items, but
 * handling the case when there is exactly one item (and we do not need to
 * allocate an array).
 */

function forEachAccumulated(arr, cb, scope) {
  if (Array.isArray(arr)) {
    arr.forEach(cb, scope);
  } else if (arr) {
    cb.call(scope, arr);
  }
}

module.exports = forEachAccumulated;

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(11);

var contentKey = null;

/**
 * Gets the key used to access text content on a DOM node.
 *
 * @return {?string} Key used to access text content.
 * @internal
 */
function getTextContentAccessor() {
  if (!contentKey && ExecutionEnvironment.canUseDOM) {
    // Prefer textContent to innerText because many browsers support both but
    // SVG <text> elements don't support innerText even when <div> does.
    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
  }
  return contentKey;
}

module.exports = getTextContentAccessor;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(5);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PooledClass = __webpack_require__(27);

var invariant = __webpack_require__(2);

/**
 * A specialized pseudo-event module to help keep track of components waiting to
 * be notified when their DOM representations are available for use.
 *
 * This implements `PooledClass`, so you should never need to instantiate this.
 * Instead, use `CallbackQueue.getPooled()`.
 *
 * @class ReactMountReady
 * @implements PooledClass
 * @internal
 */

var CallbackQueue = function () {
  function CallbackQueue(arg) {
    _classCallCheck(this, CallbackQueue);

    this._callbacks = null;
    this._contexts = null;
    this._arg = arg;
  }

  /**
   * Enqueues a callback to be invoked when `notifyAll` is invoked.
   *
   * @param {function} callback Invoked when `notifyAll` is invoked.
   * @param {?object} context Context to call `callback` with.
   * @internal
   */


  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
    this._callbacks = this._callbacks || [];
    this._callbacks.push(callback);
    this._contexts = this._contexts || [];
    this._contexts.push(context);
  };

  /**
   * Invokes all enqueued callbacks and clears the queue. This is invoked after
   * the DOM representation of a component has been created or updated.
   *
   * @internal
   */


  CallbackQueue.prototype.notifyAll = function notifyAll() {
    var callbacks = this._callbacks;
    var contexts = this._contexts;
    var arg = this._arg;
    if (callbacks && contexts) {
      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
      this._callbacks = null;
      this._contexts = null;
      for (var i = 0; i < callbacks.length; i++) {
        callbacks[i].call(contexts[i], arg);
      }
      callbacks.length = 0;
      contexts.length = 0;
    }
  };

  CallbackQueue.prototype.checkpoint = function checkpoint() {
    return this._callbacks ? this._callbacks.length : 0;
  };

  CallbackQueue.prototype.rollback = function rollback(len) {
    if (this._callbacks && this._contexts) {
      this._callbacks.length = len;
      this._contexts.length = len;
    }
  };

  /**
   * Resets the internal queue.
   *
   * @internal
   */


  CallbackQueue.prototype.reset = function reset() {
    this._callbacks = null;
    this._contexts = null;
  };

  /**
   * `PooledClass` looks for this.
   */


  CallbackQueue.prototype.destructor = function destructor() {
    this.reset();
  };

  return CallbackQueue;
}();

module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactFeatureFlags = {
  // When true, call console.time() before and .timeEnd() after each top-level
  // render (both initial renders and updates). Useful when looking at prod-mode
  // timeline profiles in Chrome, for example.
  logTopLevelRenders: false
};

module.exports = ReactFeatureFlags;

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */

var supportedInputTypes = {
  'color': true,
  'date': true,
  'datetime': true,
  'datetime-local': true,
  'email': true,
  'month': true,
  'number': true,
  'password': true,
  'range': true,
  'search': true,
  'tel': true,
  'text': true,
  'time': true,
  'url': true,
  'week': true
};

function isTextInputElement(elem) {
  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();

  if (nodeName === 'input') {
    return !!supportedInputTypes[elem.type];
  }

  if (nodeName === 'textarea') {
    return true;
  }

  return false;
}

module.exports = isTextInputElement;

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ViewportMetrics = {

  currentScrollLeft: 0,

  currentScrollTop: 0,

  refreshScrollValues: function (scrollPosition) {
    ViewportMetrics.currentScrollLeft = scrollPosition.x;
    ViewportMetrics.currentScrollTop = scrollPosition.y;
  }

};

module.exports = ViewportMetrics;

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(11);
var escapeTextContentForBrowser = __webpack_require__(54);
var setInnerHTML = __webpack_require__(53);

/**
 * Set the textContent property of a node, ensuring that whitespace is preserved
 * even in IE8. innerText is a poor substitute for textContent and, among many
 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
 * as it should.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */
var setTextContent = function (node, text) {
  if (text) {
    var firstChild = node.firstChild;

    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
      firstChild.nodeValue = text;
      return;
    }
  }
  node.textContent = text;
};

if (ExecutionEnvironment.canUseDOM) {
  if (!('textContent' in document.documentElement)) {
    setTextContent = function (node, text) {
      if (node.nodeType === 3) {
        node.nodeValue = text;
        return;
      }
      setInnerHTML(node, escapeTextContentForBrowser(text));
    };
  }
}

module.exports = setTextContent;

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * CSS properties which accept numbers but are not in units of "px".
 */

var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridColumn: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};

/**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */
function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}

/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */
var prefixes = ['Webkit', 'ms', 'Moz', 'O'];

// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.
Object.keys(isUnitlessNumber).forEach(function (prop) {
  prefixes.forEach(function (prefix) {
    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
  });
});

/**
 * Most style properties can be unset by doing .style[prop] = '' but IE8
 * doesn't like doing that with shorthand properties so for the properties that
 * IE8 breaks on, which are listed here, we instead unset each of the
 * individual properties. See http://bugs.jquery.com/ticket/12385.
 * The 4-value 'clock' properties like margin, padding, border-width seem to
 * behave without any problems. Curiously, list-style works too without any
 * special prodding.
 */
var shorthandPropertyExpansions = {
  background: {
    backgroundAttachment: true,
    backgroundColor: true,
    backgroundImage: true,
    backgroundPositionX: true,
    backgroundPositionY: true,
    backgroundRepeat: true
  },
  backgroundPosition: {
    backgroundPositionX: true,
    backgroundPositionY: true
  },
  border: {
    borderWidth: true,
    borderStyle: true,
    borderColor: true
  },
  borderBottom: {
    borderBottomWidth: true,
    borderBottomStyle: true,
    borderBottomColor: true
  },
  borderLeft: {
    borderLeftWidth: true,
    borderLeftStyle: true,
    borderLeftColor: true
  },
  borderRight: {
    borderRightWidth: true,
    borderRightStyle: true,
    borderRightColor: true
  },
  borderTop: {
    borderTopWidth: true,
    borderTopStyle: true,
    borderTopColor: true
  },
  font: {
    fontStyle: true,
    fontVariant: true,
    fontWeight: true,
    fontSize: true,
    lineHeight: true,
    fontFamily: true
  },
  outline: {
    outlineWidth: true,
    outlineStyle: true,
    outlineColor: true
  }
};

var CSSProperty = {
  isUnitlessNumber: isUnitlessNumber,
  shorthandPropertyExpansions: shorthandPropertyExpansions
};

module.exports = CSSProperty;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(36);
var ReactDOMComponentTree = __webpack_require__(9);
var ReactInstrumentation = __webpack_require__(14);

var quoteAttributeValueForBrowser = __webpack_require__(361);
var warning = __webpack_require__(4);

var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
var illegalAttributeNameCache = {};
var validatedAttributeNameCache = {};

function isAttributeNameSafe(attributeName) {
  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
    return true;
  }
  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
    return false;
  }
  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
    validatedAttributeNameCache[attributeName] = true;
    return true;
  }
  illegalAttributeNameCache[attributeName] = true;
   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
  return false;
}

function shouldIgnoreValue(propertyInfo, value) {
  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
}

/**
 * Operations for dealing with DOM properties.
 */
var DOMPropertyOperations = {

  /**
   * Creates markup for the ID property.
   *
   * @param {string} id Unescaped ID.
   * @return {string} Markup string.
   */
  createMarkupForID: function (id) {
    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
  },

  setAttributeForID: function (node, id) {
    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
  },

  createMarkupForRoot: function () {
    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
  },

  setAttributeForRoot: function (node) {
    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
  },

  /**
   * Creates markup for a property.
   *
   * @param {string} name
   * @param {*} value
   * @return {?string} Markup string, or null if the property was invalid.
   */
  createMarkupForProperty: function (name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      if (shouldIgnoreValue(propertyInfo, value)) {
        return '';
      }
      var attributeName = propertyInfo.attributeName;
      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
        return attributeName + '=""';
      }
      return attributeName + '=' + quoteAttributeValueForBrowser(value);
    } else if (DOMProperty.isCustomAttribute(name)) {
      if (value == null) {
        return '';
      }
      return name + '=' + quoteAttributeValueForBrowser(value);
    }
    return null;
  },

  /**
   * Creates markup for a custom property.
   *
   * @param {string} name
   * @param {*} value
   * @return {string} Markup string, or empty string if the property was invalid.
   */
  createMarkupForCustomAttribute: function (name, value) {
    if (!isAttributeNameSafe(name) || value == null) {
      return '';
    }
    return name + '=' + quoteAttributeValueForBrowser(value);
  },

  /**
   * Sets the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   * @param {*} value
   */
  setValueForProperty: function (node, name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, value);
      } else if (shouldIgnoreValue(propertyInfo, value)) {
        this.deleteValueForProperty(node, name);
        return;
      } else if (propertyInfo.mustUseProperty) {
        // Contrary to `setAttribute`, object properties are properly
        // `toString`ed by IE8/9.
        node[propertyInfo.propertyName] = value;
      } else {
        var attributeName = propertyInfo.attributeName;
        var namespace = propertyInfo.attributeNamespace;
        // `setAttribute` with objects becomes only `[object]` in IE8/9,
        // ('' + value) makes it output the correct toString()-value.
        if (namespace) {
          node.setAttributeNS(namespace, attributeName, '' + value);
        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
          node.setAttribute(attributeName, '');
        } else {
          node.setAttribute(attributeName, '' + value);
        }
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      DOMPropertyOperations.setValueForAttribute(node, name, value);
      return;
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  setValueForAttribute: function (node, name, value) {
    if (!isAttributeNameSafe(name)) {
      return;
    }
    if (value == null) {
      node.removeAttribute(name);
    } else {
      node.setAttribute(name, '' + value);
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  /**
   * Deletes an attributes from a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForAttribute: function (node, name) {
    node.removeAttribute(name);
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  },

  /**
   * Deletes the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForProperty: function (node, name) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, undefined);
      } else if (propertyInfo.mustUseProperty) {
        var propName = propertyInfo.propertyName;
        if (propertyInfo.hasBooleanValue) {
          node[propName] = false;
        } else {
          node[propName] = '';
        }
      } else {
        node.removeAttribute(propertyInfo.attributeName);
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      node.removeAttribute(name);
    }

    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  }

};

module.exports = DOMPropertyOperations;

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(8);

var LinkedValueUtils = __webpack_require__(77);
var ReactDOMComponentTree = __webpack_require__(9);
var ReactUpdates = __webpack_require__(17);

var warning = __webpack_require__(4);

var didWarnValueLink = false;
var didWarnValueDefaultValue = false;

function updateOptionsIfPendingUpdateAndMounted() {
  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
    this._wrapperState.pendingUpdate = false;

    var props = this._currentElement.props;
    var value = LinkedValueUtils.getValue(props);

    if (value != null) {
      updateOptions(this, Boolean(props.multiple), value);
    }
  }
}

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

var valuePropNames = ['value', 'defaultValue'];

/**
 * Validation function for `value` and `defaultValue`.
 * @private
 */
function checkSelectPropTypes(inst, props) {
  var owner = inst._currentElement._owner;
  LinkedValueUtils.checkPropTypes('select', props, owner);

  if (props.valueLink !== undefined && !didWarnValueLink) {
     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
    didWarnValueLink = true;
  }

  for (var i = 0; i < valuePropNames.length; i++) {
    var propName = valuePropNames[i];
    if (props[propName] == null) {
      continue;
    }
    var isArray = Array.isArray(props[propName]);
    if (props.multiple && !isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    } else if (!props.multiple && isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    }
  }
}

/**
 * @param {ReactDOMComponent} inst
 * @param {boolean} multiple
 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
 * @private
 */
function updateOptions(inst, multiple, propValue) {
  var selectedValue, i;
  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;

  if (multiple) {
    selectedValue = {};
    for (i = 0; i < propValue.length; i++) {
      selectedValue['' + propValue[i]] = true;
    }
    for (i = 0; i < options.length; i++) {
      var selected = selectedValue.hasOwnProperty(options[i].value);
      if (options[i].selected !== selected) {
        options[i].selected = selected;
      }
    }
  } else {
    // Do not set `select.value` as exact behavior isn't consistent across all
    // browsers for all cases.
    selectedValue = '' + propValue;
    for (i = 0; i < options.length; i++) {
      if (options[i].value === selectedValue) {
        options[i].selected = true;
        return;
      }
    }
    if (options.length) {
      options[0].selected = true;
    }
  }
}

/**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */
var ReactDOMSelect = {
  getHostProps: function (inst, props) {
    return _assign({}, props, {
      onChange: inst._wrapperState.onChange,
      value: undefined
    });
  },

  mountWrapper: function (inst, props) {
    if (false) {
      checkSelectPropTypes(inst, props);
    }

    var value = LinkedValueUtils.getValue(props);
    inst._wrapperState = {
      pendingUpdate: false,
      initialValue: value != null ? value : props.defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      wasMultiple: Boolean(props.multiple)
    };

    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
      didWarnValueDefaultValue = true;
    }
  },

  getSelectValueContext: function (inst) {
    // ReactDOMOption looks at this initial value so the initial generated
    // markup has correct `selected` attributes
    return inst._wrapperState.initialValue;
  },

  postUpdateWrapper: function (inst) {
    var props = inst._currentElement.props;

    // After the initial mount, we control selected-ness manually so don't pass
    // this value down
    inst._wrapperState.initialValue = undefined;

    var wasMultiple = inst._wrapperState.wasMultiple;
    inst._wrapperState.wasMultiple = Boolean(props.multiple);

    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      inst._wrapperState.pendingUpdate = false;
      updateOptions(inst, Boolean(props.multiple), value);
    } else if (wasMultiple !== Boolean(props.multiple)) {
      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
      if (props.defaultValue != null) {
        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
      } else {
        // Revert the select back to its default unselected state.
        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
      }
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  if (this._rootNodeID) {
    this._wrapperState.pendingUpdate = true;
  }
  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
  return returnValue;
}

module.exports = ReactDOMSelect;

/***/ }),
/* 125 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5),
    _assign = __webpack_require__(8);

var ReactCompositeComponent = __webpack_require__(374);
var ReactEmptyComponent = __webpack_require__(128);
var ReactHostComponent = __webpack_require__(129);

var getNextDebugID = __webpack_require__(375);
var invariant = __webpack_require__(2);
var warning = __webpack_require__(4);

// To avoid a cyclic dependency, we create the final class in this module
var ReactCompositeComponentWrapper = function (element) {
  this.construct(element);
};

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Check if the type reference is a known internal type. I.e. not a user
 * provided composite type.
 *
 * @param {function} type
 * @return {boolean} Returns true if this is a valid internal type.
 */
function isInternalComponentType(type) {
  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
}

/**
 * Given a ReactNode, create an instance that will actually be mounted.
 *
 * @param {ReactNode} node
 * @param {boolean} shouldHaveDebugID
 * @return {object} A new instance of the element's constructor.
 * @protected
 */
function instantiateReactComponent(node, shouldHaveDebugID) {
  var instance;

  if (node === null || node === false) {
    instance = ReactEmptyComponent.create(instantiateReactComponent);
  } else if (typeof node === 'object') {
    var element = node;
    var type = element.type;
    if (typeof type !== 'function' && typeof type !== 'string') {
      var info = '';
      if (false) {
        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
          info += ' You likely forgot to export your component from the file ' + 'it\'s defined in.';
        }
      }
      info += getDeclarationErrorAddendum(element._owner);
       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
    }

    // Special case string values
    if (typeof element.type === 'string') {
      instance = ReactHostComponent.createInternalComponent(element);
    } else if (isInternalComponentType(element.type)) {
      // This is temporarily available for custom components that are not string
      // representations. I.e. ART. Once those are updated to use the string
      // representation, we can drop this code path.
      instance = new element.type(element);

      // We renamed this. Allow the old name for compat. :(
      if (!instance.getHostNode) {
        instance.getHostNode = instance.getNativeNode;
      }
    } else {
      instance = new ReactCompositeComponentWrapper(element);
    }
  } else if (typeof node === 'string' || typeof node === 'number') {
    instance = ReactHostComponent.createInstanceForText(node);
  } else {
     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
  }

  // These two fields are used by the DOM and ART diffing algorithms
  // respectively. Instead of using expandos on components, we should be
  // storing the state needed by the diffing algorithms elsewhere.
  instance._mountIndex = 0;
  instance._mountImage = null;

  if (false) {
    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
  }

  // Internal instances should fully constructed at this point, so they should
  // not get any new fields added to them at this point.
  if (false) {
    if (Object.preventExtensions) {
      Object.preventExtensions(instance);
    }
  }

  return instance;
}

_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
  _instantiateReactComponent: instantiateReactComponent
});

module.exports = instantiateReactComponent;

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(5);

var React = __webpack_require__(32);

var invariant = __webpack_require__(2);

var ReactNodeTypes = {
  HOST: 0,
  COMPOSITE: 1,
  EMPTY: 2,

  getType: function (node) {
    if (node === null || node === false) {
      return ReactNodeTypes.EMPTY;
    } else if (React.isValidElement(node)) {
      if (typeof node.type === 'function') {
        return ReactNodeTypes.COMPOSITE;
      } else {
        return ReactNodeTypes.HOST;
      }
    }
     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
  }
};

module.exports = ReactNodeTypes;

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyComponentFactory;

var ReactEmptyComponentInjection = {
  injectEmptyComponentFactory: function (factory) {
    emptyComponentFactory = factory;
  }
};

var ReactEmptyComponent = {
  create: function (instantiate) {
    return emptyComponentFactory(instantiate);
  }
};

ReactEmptyComponent.injection = ReactEmptyComponentInjection;

module.exports = ReactEmptyComponent;

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5);

var invariant = __webpack_require__(2);

var genericComponentClass = null;
var textComponentClass = null;

var ReactHostComponentInjection = {
  // This accepts a class that receives the tag string. This is a catch all
  // that can render any kind of tag.
  injectGenericComponentClass: function (componentClass) {
    genericComponentClass = componentClass;
  },
  // This accepts a text component class that takes the text string to be
  // rendered as props.
  injectTextComponentClass: function (componentClass) {
    textComponentClass = componentClass;
  }
};

/**
 * Get a host internal component class for a specific tag.
 *
 * @param {ReactElement} element The element to create.
 * @return {function} The internal class constructor function.
 */
function createInternalComponent(element) {
  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
  return new genericComponentClass(element);
}

/**
 * @param {ReactText} text
 * @return {ReactComponent}
 */
function createInstanceForText(text) {
  return new textComponentClass(text);
}

/**
 * @param {ReactComponent} component
 * @return {boolean}
 */
function isTextComponent(component) {
  return component instanceof textComponentClass;
}

var ReactHostComponent = {
  createInternalComponent: createInternalComponent,
  createInstanceForText: createInstanceForText,
  isTextComponent: isTextComponent,
  injection: ReactHostComponentInjection
};

module.exports = ReactHostComponent;

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5);

var ReactCurrentOwner = __webpack_require__(19);
var REACT_ELEMENT_TYPE = __webpack_require__(376);

var getIteratorFn = __webpack_require__(377);
var invariant = __webpack_require__(2);
var KeyEscapeUtils = __webpack_require__(81);
var warning = __webpack_require__(4);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(33);

var ReactCurrentOwner = __webpack_require__(19);

var invariant = __webpack_require__(2);
var warning = __webpack_require__(4);

function isNative(fn) {
  // Based on isNative() from Lodash
  var funcToString = Function.prototype.toString;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var reIsNative = RegExp('^' + funcToString
  // Take an example native function source for comparison
  .call(hasOwnProperty)
  // Strip regex characters so we can use it for regex
  .replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
  // Remove hasOwnProperty from the template to make it generic
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
  try {
    var source = funcToString.call(fn);
    return reIsNative.test(source);
  } catch (err) {
    return false;
  }
}

var canUseCollections =
// Array.from
typeof Array.from === 'function' &&
// Map
typeof Map === 'function' && isNative(Map) &&
// Map.prototype.keys
Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
// Set
typeof Set === 'function' && isNative(Set) &&
// Set.prototype.keys
Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);

var setItem;
var getItem;
var removeItem;
var getItemIDs;
var addRoot;
var removeRoot;
var getRootIDs;

if (canUseCollections) {
  var itemMap = new Map();
  var rootIDSet = new Set();

  setItem = function (id, item) {
    itemMap.set(id, item);
  };
  getItem = function (id) {
    return itemMap.get(id);
  };
  removeItem = function (id) {
    itemMap['delete'](id);
  };
  getItemIDs = function () {
    return Array.from(itemMap.keys());
  };

  addRoot = function (id) {
    rootIDSet.add(id);
  };
  removeRoot = function (id) {
    rootIDSet['delete'](id);
  };
  getRootIDs = function () {
    return Array.from(rootIDSet.keys());
  };
} else {
  var itemByKey = {};
  var rootByKey = {};

  // Use non-numeric keys to prevent V8 performance issues:
  // https://github.com/facebook/react/pull/7232
  var getKeyFromID = function (id) {
    return '.' + id;
  };
  var getIDFromKey = function (key) {
    return parseInt(key.substr(1), 10);
  };

  setItem = function (id, item) {
    var key = getKeyFromID(id);
    itemByKey[key] = item;
  };
  getItem = function (id) {
    var key = getKeyFromID(id);
    return itemByKey[key];
  };
  removeItem = function (id) {
    var key = getKeyFromID(id);
    delete itemByKey[key];
  };
  getItemIDs = function () {
    return Object.keys(itemByKey).map(getIDFromKey);
  };

  addRoot = function (id) {
    var key = getKeyFromID(id);
    rootByKey[key] = true;
  };
  removeRoot = function (id) {
    var key = getKeyFromID(id);
    delete rootByKey[key];
  };
  getRootIDs = function () {
    return Object.keys(rootByKey).map(getIDFromKey);
  };
}

var unmountedIDs = [];

function purgeDeep(id) {
  var item = getItem(id);
  if (item) {
    var childIDs = item.childIDs;

    removeItem(id);
    childIDs.forEach(purgeDeep);
  }
}

function describeComponentFrame(name, source, ownerName) {
  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
}

function getDisplayName(element) {
  if (element == null) {
    return '#empty';
  } else if (typeof element === 'string' || typeof element === 'number') {
    return '#text';
  } else if (typeof element.type === 'string') {
    return element.type;
  } else {
    return element.type.displayName || element.type.name || 'Unknown';
  }
}

function describeID(id) {
  var name = ReactComponentTreeHook.getDisplayName(id);
  var element = ReactComponentTreeHook.getElement(id);
  var ownerID = ReactComponentTreeHook.getOwnerID(id);
  var ownerName;
  if (ownerID) {
    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
  }
   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
  return describeComponentFrame(name, element && element._source, ownerName);
}

var ReactComponentTreeHook = {
  onSetChildren: function (id, nextChildIDs) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.childIDs = nextChildIDs;

    for (var i = 0; i < nextChildIDs.length; i++) {
      var nextChildID = nextChildIDs[i];
      var nextChild = getItem(nextChildID);
      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
      if (nextChild.parentID == null) {
        nextChild.parentID = id;
        // TODO: This shouldn't be necessary but mounting a new root during in
        // componentWillMount currently causes not-yet-mounted components to
        // be purged from our tree data so their parent id is missing.
      }
      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
    }
  },
  onBeforeMountComponent: function (id, element, parentID) {
    var item = {
      element: element,
      parentID: parentID,
      text: null,
      childIDs: [],
      isMounted: false,
      updateCount: 0
    };
    setItem(id, item);
  },
  onBeforeUpdateComponent: function (id, element) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.element = element;
  },
  onMountComponent: function (id) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.isMounted = true;
    var isRoot = item.parentID === 0;
    if (isRoot) {
      addRoot(id);
    }
  },
  onUpdateComponent: function (id) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.updateCount++;
  },
  onUnmountComponent: function (id) {
    var item = getItem(id);
    if (item) {
      // We need to check if it exists.
      // `item` might not exist if it is inside an error boundary, and a sibling
      // error boundary child threw while mounting. Then this instance never
      // got a chance to mount, but it still gets an unmounting event during
      // the error boundary cleanup.
      item.isMounted = false;
      var isRoot = item.parentID === 0;
      if (isRoot) {
        removeRoot(id);
      }
    }
    unmountedIDs.push(id);
  },
  purgeUnmountedComponents: function () {
    if (ReactComponentTreeHook._preventPurging) {
      // Should only be used for testing.
      return;
    }

    for (var i = 0; i < unmountedIDs.length; i++) {
      var id = unmountedIDs[i];
      purgeDeep(id);
    }
    unmountedIDs.length = 0;
  },
  isMounted: function (id) {
    var item = getItem(id);
    return item ? item.isMounted : false;
  },
  getCurrentStackAddendum: function (topElement) {
    var info = '';
    if (topElement) {
      var name = getDisplayName(topElement);
      var owner = topElement._owner;
      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
    }

    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    info += ReactComponentTreeHook.getStackAddendumByID(id);
    return info;
  },
  getStackAddendumByID: function (id) {
    var info = '';
    while (id) {
      info += describeID(id);
      id = ReactComponentTreeHook.getParentID(id);
    }
    return info;
  },
  getChildIDs: function (id) {
    var item = getItem(id);
    return item ? item.childIDs : [];
  },
  getDisplayName: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element) {
      return null;
    }
    return getDisplayName(element);
  },
  getElement: function (id) {
    var item = getItem(id);
    return item ? item.element : null;
  },
  getOwnerID: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element || !element._owner) {
      return null;
    }
    return element._owner._debugID;
  },
  getParentID: function (id) {
    var item = getItem(id);
    return item ? item.parentID : null;
  },
  getSource: function (id) {
    var item = getItem(id);
    var element = item ? item.element : null;
    var source = element != null ? element._source : null;
    return source;
  },
  getText: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (typeof element === 'string') {
      return element;
    } else if (typeof element === 'number') {
      return '' + element;
    } else {
      return null;
    }
  },
  getUpdateCount: function (id) {
    var item = getItem(id);
    return item ? item.updateCount : 0;
  },


  getRootIDs: getRootIDs,
  getRegisteredIDs: getItemIDs
};

module.exports = ReactComponentTreeHook;

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(12);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMSelection = __webpack_require__(389);

var containsNode = __webpack_require__(391);
var focusNode = __webpack_require__(121);
var getActiveElement = __webpack_require__(134);

function isInDocument(node) {
  return containsNode(document.documentElement, node);
}

/**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */
var ReactInputSelection = {

  hasSelectionCapabilities: function (elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
  },

  getSelectionInformation: function () {
    var focusedElem = getActiveElement();
    return {
      focusedElem: focusedElem,
      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
    };
  },

  /**
   * @restoreSelection: If any selection information was potentially lost,
   * restore it. This is useful when performing operations that could remove dom
   * nodes and place them back in, resulting in focus being lost.
   */
  restoreSelection: function (priorSelectionInformation) {
    var curFocusedElem = getActiveElement();
    var priorFocusedElem = priorSelectionInformation.focusedElem;
    var priorSelectionRange = priorSelectionInformation.selectionRange;
    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
      }
      focusNode(priorFocusedElem);
    }
  },

  /**
   * @getSelection: Gets the selection bounds of a focused textarea, input or
   * contentEditable node.
   * -@input: Look up selection bounds of this input
   * -@return {start: selectionStart, end: selectionEnd}
   */
  getSelection: function (input) {
    var selection;

    if ('selectionStart' in input) {
      // Modern browser with input or textarea.
      selection = {
        start: input.selectionStart,
        end: input.selectionEnd
      };
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      // IE8 input.
      var range = document.selection.createRange();
      // There can only be one selection per document in IE, so it must
      // be in our element.
      if (range.parentElement() === input) {
        selection = {
          start: -range.moveStart('character', -input.value.length),
          end: -range.moveEnd('character', -input.value.length)
        };
      }
    } else {
      // Content editable or old IE textarea.
      selection = ReactDOMSelection.getOffsets(input);
    }

    return selection || { start: 0, end: 0 };
  },

  /**
   * @setSelection: Sets the selection bounds of a textarea or input and focuses
   * the input.
   * -@input     Set selection bounds of this input or textarea
   * -@offsets   Object of same form that is returned from get*
   */
  setSelection: function (input, offsets) {
    var start = offsets.start;
    var end = offsets.end;
    if (end === undefined) {
      end = start;
    }

    if ('selectionStart' in input) {
      input.selectionStart = start;
      input.selectionEnd = Math.min(end, input.value.length);
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      var range = input.createTextRange();
      range.collapse(true);
      range.moveStart('character', start);
      range.moveEnd('character', end - start);
      range.select();
    } else {
      ReactDOMSelection.setOffsets(input, offsets);
    }
  }
};

module.exports = ReactInputSelection;

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5);

var DOMLazyTree = __webpack_require__(38);
var DOMProperty = __webpack_require__(36);
var React = __webpack_require__(32);
var ReactBrowserEventEmitter = __webpack_require__(55);
var ReactCurrentOwner = __webpack_require__(19);
var ReactDOMComponentTree = __webpack_require__(9);
var ReactDOMContainerInfo = __webpack_require__(406);
var ReactDOMFeatureFlags = __webpack_require__(407);
var ReactFeatureFlags = __webpack_require__(117);
var ReactInstanceMap = __webpack_require__(46);
var ReactInstrumentation = __webpack_require__(14);
var ReactMarkupChecksum = __webpack_require__(408);
var ReactReconciler = __webpack_require__(37);
var ReactUpdateQueue = __webpack_require__(82);
var ReactUpdates = __webpack_require__(17);

var emptyObject = __webpack_require__(35);
var instantiateReactComponent = __webpack_require__(126);
var invariant = __webpack_require__(2);
var setInnerHTML = __webpack_require__(53);
var shouldUpdateReactComponent = __webpack_require__(80);
var warning = __webpack_require__(4);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;

var ELEMENT_NODE_TYPE = 1;
var DOC_NODE_TYPE = 9;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

var instancesByReactRootID = {};

/**
 * Finds the index of the first character
 * that's not common between the two given strings.
 *
 * @return {number} the index of the character where the strings diverge
 */
function firstDifferenceIndex(string1, string2) {
  var minLen = Math.min(string1.length, string2.length);
  for (var i = 0; i < minLen; i++) {
    if (string1.charAt(i) !== string2.charAt(i)) {
      return i;
    }
  }
  return string1.length === string2.length ? -1 : minLen;
}

/**
 * @param {DOMElement|DOMDocument} container DOM element that may contain
 * a React component
 * @return {?*} DOM element that may have the reactRoot ID, or null.
 */
function getReactRootElementInContainer(container) {
  if (!container) {
    return null;
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    return container.documentElement;
  } else {
    return container.firstChild;
  }
}

function internalGetID(node) {
  // If node is something like a window, document, or text node, none of
  // which support attributes or a .getAttribute method, gracefully return
  // the empty string, as if the attribute were missing.
  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
}

/**
 * Mounts this component and inserts it into the DOM.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {ReactReconcileTransaction} transaction
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
  var markerName;
  if (ReactFeatureFlags.logTopLevelRenders) {
    var wrappedElement = wrapperInstance._currentElement.props.child;
    var type = wrappedElement.type;
    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
    console.time(markerName);
  }

  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
  );

  if (markerName) {
    console.timeEnd(markerName);
  }

  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
}

/**
 * Batched mount.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */
  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
  ReactUpdates.ReactReconcileTransaction.release(transaction);
}

/**
 * Unmounts a component and removes it from the DOM.
 *
 * @param {ReactComponent} instance React component instance.
 * @param {DOMElement} container DOM element to unmount from.
 * @final
 * @internal
 * @see {ReactMount.unmountComponentAtNode}
 */
function unmountComponentFromNode(instance, container, safely) {
  if (false) {
    ReactInstrumentation.debugTool.onBeginFlush();
  }
  ReactReconciler.unmountComponent(instance, safely);
  if (false) {
    ReactInstrumentation.debugTool.onEndFlush();
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    container = container.documentElement;
  }

  // http://jsperf.com/emptying-a-node
  while (container.lastChild) {
    container.removeChild(container.lastChild);
  }
}

/**
 * True if the supplied DOM node has a direct React-rendered child that is
 * not a React root element. Useful for warning in `render`,
 * `unmountComponentAtNode`, etc.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM element contains a direct child that was
 * rendered by React but is not a root element.
 * @internal
 */
function hasNonRootReactChild(container) {
  var rootEl = getReactRootElementInContainer(container);
  if (rootEl) {
    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
    return !!(inst && inst._hostParent);
  }
}

/**
 * True if the supplied DOM node is a React DOM element and
 * it has been rendered by another copy of React.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM has been rendered by another copy of React
 * @internal
 */
function nodeIsRenderedByOtherInstance(container) {
  var rootEl = getReactRootElementInContainer(container);
  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
}

/**
 * True if the supplied DOM node is a valid node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid DOM node.
 * @internal
 */
function isValidContainer(node) {
  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
}

/**
 * True if the supplied DOM node is a valid React node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid React DOM node.
 * @internal
 */
function isReactNode(node) {
  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
}

function getHostRootInstanceInContainer(container) {
  var rootEl = getReactRootElementInContainer(container);
  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
}

function getTopLevelWrapperInContainer(container) {
  var root = getHostRootInstanceInContainer(container);
  return root ? root._hostContainerInfo._topLevelWrapper : null;
}

/**
 * Temporary (?) hack so that we can store all top-level pending updates on
 * composites instead of having to worry about different types of components
 * here.
 */
var topLevelRootCounter = 1;
var TopLevelWrapper = function () {
  this.rootID = topLevelRootCounter++;
};
TopLevelWrapper.prototype.isReactComponent = {};
if (false) {
  TopLevelWrapper.displayName = 'TopLevelWrapper';
}
TopLevelWrapper.prototype.render = function () {
  return this.props.child;
};
TopLevelWrapper.isReactTopLevelWrapper = true;

/**
 * Mounting is the process of initializing a React component by creating its
 * representative DOM elements and inserting them into a supplied `container`.
 * Any prior content inside `container` is destroyed in the process.
 *
 *   ReactMount.render(
 *     component,
 *     document.getElementById('container')
 *   );
 *
 *   <div id="container">                   <-- Supplied `container`.
 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
 *       // ...                                 component.
 *     </div>
 *   </div>
 *
 * Inside of `container`, the first element rendered is the "reactRoot".
 */
var ReactMount = {

  TopLevelWrapper: TopLevelWrapper,

  /**
   * Used by devtools. The keys are not important.
   */
  _instancesByReactRootID: instancesByReactRootID,

  /**
   * This is a hook provided to support rendering React components while
   * ensuring that the apparent scroll position of its `container` does not
   * change.
   *
   * @param {DOMElement} container The `container` being rendered into.
   * @param {function} renderCallback This must be called once to do the render.
   */
  scrollMonitor: function (container, renderCallback) {
    renderCallback();
  },

  /**
   * Take a component that's already mounted into the DOM and replace its props
   * @param {ReactComponent} prevComponent component instance already in the DOM
   * @param {ReactElement} nextElement component instance to render
   * @param {DOMElement} container container to render into
   * @param {?function} callback function triggered on completion
   */
  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
    ReactMount.scrollMonitor(container, function () {
      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
      if (callback) {
        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
      }
    });

    return prevComponent;
  },

  /**
   * Render a new component into the DOM. Hooked by hooks!
   *
   * @param {ReactElement} nextElement element to render
   * @param {DOMElement} container container to render into
   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
   * @return {ReactComponent} nextComponent
   */
  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case.
     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;

    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
    var componentInstance = instantiateReactComponent(nextElement, false);

    // The initial render is synchronous but any updates that happen during
    // rendering, in componentWillMount or componentDidMount, will be batched
    // according to the current batching strategy.

    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);

    var wrapperID = componentInstance._instance.rootID;
    instancesByReactRootID[wrapperID] = componentInstance;

    return componentInstance;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
  },

  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' :
    // Check if it quacks like an element
    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;

     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;

    var nextWrappedElement = React.createElement(TopLevelWrapper, { child: nextElement });

    var nextContext;
    if (parentComponent) {
      var parentInst = ReactInstanceMap.get(parentComponent);
      nextContext = parentInst._processChildContext(parentInst._context);
    } else {
      nextContext = emptyObject;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);

    if (prevComponent) {
      var prevWrappedElement = prevComponent._currentElement;
      var prevElement = prevWrappedElement.props.child;
      if (shouldUpdateReactComponent(prevElement, nextElement)) {
        var publicInst = prevComponent._renderedComponent.getPublicInstance();
        var updatedCallback = callback && function () {
          callback.call(publicInst);
        };
        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
        return publicInst;
      } else {
        ReactMount.unmountComponentAtNode(container);
      }
    }

    var reactRootElement = getReactRootElementInContainer(container);
    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
    var containerHasNonRootReactChild = hasNonRootReactChild(container);

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;

      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
        var rootElementSibling = reactRootElement;
        while (rootElementSibling) {
          if (internalGetID(rootElementSibling)) {
            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
            break;
          }
          rootElementSibling = rootElementSibling.nextSibling;
        }
      }
    }

    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
    if (callback) {
      callback.call(component);
    }
    return component;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  render: function (nextElement, container, callback) {
    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
  },

  /**
   * Unmounts and destroys the React component rendered in the `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
   *
   * @param {DOMElement} container DOM element containing a React component.
   * @return {boolean} True if a component was found in and unmounted from
   *                   `container`
   */
  unmountComponentAtNode: function (container) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case. (Strictly speaking, unmounting won't cause a
    // render but we still don't expect to be in a render call here.)
     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by another copy of React.') : void 0;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);
    if (!prevComponent) {
      // Check if the node being unmounted was rendered by React, but isn't a
      // root node.
      var containerHasNonRootReactChild = hasNonRootReactChild(container);

      // Check if the container itself is a React root node.
      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);

      if (false) {
        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
      }

      return false;
    }
    delete instancesByReactRootID[prevComponent._instance.rootID];
    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
    return true;
  },

  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;

    if (shouldReuseMarkup) {
      var rootElement = getReactRootElementInContainer(container);
      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
        ReactDOMComponentTree.precacheNode(instance, rootElement);
        return;
      } else {
        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);

        var rootMarkup = rootElement.outerHTML;
        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);

        var normalizedMarkup = markup;
        if (false) {
          // because rootMarkup is retrieved from the DOM, various normalizations
          // will have occurred which will not be present in `markup`. Here,
          // insert markup into a <div> or <iframe> depending on the container
          // type to perform the same normalizations before comparing.
          var normalizer;
          if (container.nodeType === ELEMENT_NODE_TYPE) {
            normalizer = document.createElement('div');
            normalizer.innerHTML = markup;
            normalizedMarkup = normalizer.innerHTML;
          } else {
            normalizer = document.createElement('iframe');
            document.body.appendChild(normalizer);
            normalizer.contentDocument.write(markup);
            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
            document.body.removeChild(normalizer);
          }
        }

        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);

        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;

        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
        }
      }
    }

    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;

    if (transaction.useCreateElement) {
      while (container.lastChild) {
        container.removeChild(container.lastChild);
      }
      DOMLazyTree.insertTreeBefore(container, markup, null);
    } else {
      setInnerHTML(container, markup);
      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
    }

    if (false) {
      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
      if (hostNode._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: hostNode._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  }
};

module.exports = ReactMount;

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactNodeTypes = __webpack_require__(127);

function getHostComponentFromComposite(inst) {
  var type;

  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
    inst = inst._renderedComponent;
  }

  if (type === ReactNodeTypes.HOST) {
    return inst._renderedComponent;
  } else if (type === ReactNodeTypes.EMPTY) {
    return null;
  }
}

module.exports = getHostComponentFromComposite;

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createTransitionManager;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__routerWarning__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TransitionUtils__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isActive__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getComponents__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__matchRoutes__ = __webpack_require__(421);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








function hasAnyProperties(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
  }return false;
}

function createTransitionManager(history, routes) {
  var state = {};

  var _getTransitionUtils = __WEBPACK_IMPORTED_MODULE_2__TransitionUtils__["a" /* default */](),
      runEnterHooks = _getTransitionUtils.runEnterHooks,
      runChangeHooks = _getTransitionUtils.runChangeHooks,
      runLeaveHooks = _getTransitionUtils.runLeaveHooks;

  // Signature should be (location, indexOnly), but needs to support (path,
  // query, indexOnly)


  function isActive(location, indexOnly) {
    location = history.createLocation(location);

    return __WEBPACK_IMPORTED_MODULE_3__isActive__["a" /* default */](location, indexOnly, state.location, state.routes, state.params);
  }

  var partialNextState = void 0;

  function match(location, callback) {
    if (partialNextState && partialNextState.location === location) {
      // Continue from where we left off.
      finishMatch(partialNextState, callback);
    } else {
      __WEBPACK_IMPORTED_MODULE_5__matchRoutes__["a" /* default */](routes, location, function (error, nextState) {
        if (error) {
          callback(error);
        } else if (nextState) {
          finishMatch(_extends({}, nextState, { location: location }), callback);
        } else {
          callback();
        }
      });
    }
  }

  function finishMatch(nextState, callback) {
    var _computeChangedRoutes = __WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__["a" /* default */](state, nextState),
        leaveRoutes = _computeChangedRoutes.leaveRoutes,
        changeRoutes = _computeChangedRoutes.changeRoutes,
        enterRoutes = _computeChangedRoutes.enterRoutes;

    runLeaveHooks(leaveRoutes, state);

    // Tear down confirmation hooks for left routes
    leaveRoutes.filter(function (route) {
      return enterRoutes.indexOf(route) === -1;
    }).forEach(removeListenBeforeHooksForRoute);

    // change and enter hooks are run in series
    runChangeHooks(changeRoutes, state, nextState, function (error, redirectInfo) {
      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);

      runEnterHooks(enterRoutes, nextState, finishEnterHooks);
    });

    function finishEnterHooks(error, redirectInfo) {
      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);

      // TODO: Fetch components after state is updated.
      __WEBPACK_IMPORTED_MODULE_4__getComponents__["a" /* default */](nextState, function (error, components) {
        if (error) {
          callback(error);
        } else {
          // TODO: Make match a pure function and have some other API
          // for "match and update state".
          callback(null, null, state = _extends({}, nextState, { components: components }));
        }
      });
    }

    function handleErrorOrRedirect(error, redirectInfo) {
      if (error) callback(error);else callback(null, redirectInfo);
    }
  }

  var RouteGuid = 1;

  function getRouteID(route) {
    var create = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    return route.__id__ || create && (route.__id__ = RouteGuid++);
  }

  var RouteHooks = Object.create(null);

  function getRouteHooksForRoutes(routes) {
    return routes.map(function (route) {
      return RouteHooks[getRouteID(route)];
    }).filter(function (hook) {
      return hook;
    });
  }

  function transitionHook(location, callback) {
    __WEBPACK_IMPORTED_MODULE_5__matchRoutes__["a" /* default */](routes, location, function (error, nextState) {
      if (nextState == null) {
        // TODO: We didn't actually match anything, but hang
        // onto error/nextState so we don't have to matchRoutes
        // again in the listen callback.
        callback();
        return;
      }

      // Cache some state here so we don't have to
      // matchRoutes() again in the listen callback.
      partialNextState = _extends({}, nextState, { location: location });

      var hooks = getRouteHooksForRoutes(__WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__["a" /* default */](state, partialNextState).leaveRoutes);

      var result = void 0;
      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
        // Passing the location arg here indicates to
        // the user that this is a transition hook.
        result = hooks[i](location);
      }

      callback(result);
    });
  }

  /* istanbul ignore next: untestable with Karma */
  function beforeUnloadHook() {
    // Synchronously check to see if any route hooks want
    // to prevent the current window/tab from closing.
    if (state.routes) {
      var hooks = getRouteHooksForRoutes(state.routes);

      var message = void 0;
      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
        // Passing no args indicates to the user that this is a
        // beforeunload hook. We don't know the next location.
        message = hooks[i]();
      }

      return message;
    }
  }

  var unlistenBefore = void 0,
      unlistenBeforeUnload = void 0;

  function removeListenBeforeHooksForRoute(route) {
    var routeID = getRouteID(route);
    if (!routeID) {
      return;
    }

    delete RouteHooks[routeID];

    if (!hasAnyProperties(RouteHooks)) {
      // teardown transition & beforeunload hooks
      if (unlistenBefore) {
        unlistenBefore();
        unlistenBefore = null;
      }

      if (unlistenBeforeUnload) {
        unlistenBeforeUnload();
        unlistenBeforeUnload = null;
      }
    }
  }

  /**
   * Registers the given hook function to run before leaving the given route.
   *
   * During a normal transition, the hook function receives the next location
   * as its only argument and can return either a prompt message (string) to show the user,
   * to make sure they want to leave the page; or `false`, to prevent the transition.
   * Any other return value will have no effect.
   *
   * During the beforeunload event (in browsers) the hook receives no arguments.
   * In this case it must return a prompt message to prevent the transition.
   *
   * Returns a function that may be used to unbind the listener.
   */
  function listenBeforeLeavingRoute(route, hook) {
    var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
    var routeID = getRouteID(route, true);

    RouteHooks[routeID] = hook;

    if (thereWereNoRouteHooks) {
      // setup transition & beforeunload hooks
      unlistenBefore = history.listenBefore(transitionHook);

      if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
    }

    return function () {
      removeListenBeforeHooksForRoute(route);
    };
  }

  /**
   * This is the API for stateful environments. As the location
   * changes, we update state and call the listener. We can also
   * gracefully handle errors and redirects.
   */
  function listen(listener) {
    function historyListener(location) {
      if (state.location === location) {
        listener(null, state);
      } else {
        match(location, function (error, redirectLocation, nextState) {
          if (error) {
            listener(error);
          } else if (redirectLocation) {
            history.replace(redirectLocation);
          } else if (nextState) {
            listener(null, nextState);
          } else {
             false ? warning(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
          }
        });
      }
    }

    // TODO: Only use a single history listener. Otherwise we'll end up with
    // multiple concurrent calls to match.

    // Set up the history listener first in case the initial match redirects.
    var unsubscribe = history.listen(historyListener);

    if (state.location) {
      // Picking up on a matchContext.
      listener(null, state);
    } else {
      historyListener(history.getCurrentLocation());
    }

    return unsubscribe;
  }

  return {
    isActive: isActive,
    match: match,
    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
    listen: listen
  };
}

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPromise;
function isPromise(obj) {
  return obj && typeof obj.then === 'function';
}

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = createRouterObject;
/* harmony export (immutable) */ __webpack_exports__["a"] = assignRouterState;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function createRouterObject(history, transitionManager, state) {
  var router = _extends({}, history, {
    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
    isActive: transitionManager.isActive
  });

  return assignRouterState(router, state);
}

function assignRouterState(router, _ref) {
  var location = _ref.location,
      params = _ref.params,
      routes = _ref.routes;

  router.location = location;
  router.params = params;
  router.routes = routes;

  return router;
}

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PropTypes__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ContextUtils__ = __webpack_require__(87);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
function isEmptyObject(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
  }return true;
}

function resolveToLocation(to, router) {
  return typeof to === 'function' ? to(router.location) : to;
}

/**
 * A <Link> is used to create an <a> element that links to a route.
 * When that route is active, the link gets the value of its
 * activeClassName prop.
 *
 * For example, assuming you have the following route:
 *
 *   <Route path="/posts/:postID" component={Post} />
 *
 * You could use the following component to link to that route:
 *
 *   <Link to={`/posts/${post.id}`} />
 */
var Link = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default.a({
  displayName: 'Link',

  mixins: [__WEBPACK_IMPORTED_MODULE_5__ContextUtils__["b" /* ContextSubscriber */]('router')],

  contextTypes: {
    router: __WEBPACK_IMPORTED_MODULE_4__PropTypes__["b" /* routerShape */]
  },

  propTypes: {
    to: __WEBPACK_IMPORTED_MODULE_2_prop_types__["oneOfType"]([__WEBPACK_IMPORTED_MODULE_2_prop_types__["string"], __WEBPACK_IMPORTED_MODULE_2_prop_types__["object"], __WEBPACK_IMPORTED_MODULE_2_prop_types__["func"]]),
    activeStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types__["object"],
    activeClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types__["string"],
    onlyActiveOnIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types__["bool"].isRequired,
    onClick: __WEBPACK_IMPORTED_MODULE_2_prop_types__["func"],
    target: __WEBPACK_IMPORTED_MODULE_2_prop_types__["string"]
  },

  getDefaultProps: function getDefaultProps() {
    return {
      onlyActiveOnIndex: false,
      style: {}
    };
  },
  handleClick: function handleClick(event) {
    if (this.props.onClick) this.props.onClick(event);

    if (event.defaultPrevented) return;

    var router = this.context.router;

    !router ?  false ? invariant(false, '<Link>s rendered outside of a router context cannot navigate.') : __WEBPACK_IMPORTED_MODULE_3_invariant___default.a(false) : void 0;

    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;

    // If target prop is set (e.g. to "_blank"), let browser handle link.
    /* istanbul ignore if: untestable with Karma */
    if (this.props.target) return;

    event.preventDefault();

    router.push(resolveToLocation(this.props.to, router));
  },
  render: function render() {
    var _props = this.props,
        to = _props.to,
        activeClassName = _props.activeClassName,
        activeStyle = _props.activeStyle,
        onlyActiveOnIndex = _props.onlyActiveOnIndex,
        props = _objectWithoutProperties(_props, ['to', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);

    // Ignore if rendered outside the context of router to simplify unit testing.


    var router = this.context.router;


    if (router) {
      // If user does not specify a `to` prop, return an empty anchor tag.
      if (!to) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', props);
      }

      var toLocation = resolveToLocation(to, router);
      props.href = router.createHref(toLocation);

      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
        if (router.isActive(toLocation, onlyActiveOnIndex)) {
          if (activeClassName) {
            if (props.className) {
              props.className += ' ' + activeClassName;
            } else {
              props.className = activeClassName;
            }
          }

          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
        }
      }
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', _extends({}, props, { onClick: this.handleClick }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    arguments: true,
    arity: true
};

var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
        var keys = Object.getOwnPropertyNames(sourceComponent);

        /* istanbul ignore else */
        if (isGetOwnPropertySymbolsAvailable) {
            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
                try {
                    targetComponent[keys[i]] = sourceComponent[keys[i]];
                } catch (error) {

                }
            }
        }
    }

    return targetComponent;
};


/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RouteUtils__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PatternUtils__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(47);







/**
 * A <Redirect> is used to declare another URL path a client should
 * be sent to when they request a given URL.
 *
 * Redirects are placed alongside routes in the route configuration
 * and are traversed in the same manner.
 */
/* eslint-disable react/require-render-return */
var Redirect = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default.a({
  displayName: 'Redirect',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element) {
      var route = __WEBPACK_IMPORTED_MODULE_3__RouteUtils__["a" /* createRouteFromReactElement */](element);

      if (route.from) route.path = route.from;

      route.onEnter = function (nextState, replace) {
        var location = nextState.location,
            params = nextState.params;


        var pathname = void 0;
        if (route.to.charAt(0) === '/') {
          pathname = __WEBPACK_IMPORTED_MODULE_4__PatternUtils__["a" /* formatPattern */](route.to, params);
        } else if (!route.to) {
          pathname = location.pathname;
        } else {
          var routeIndex = nextState.routes.indexOf(route);
          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
          pathname = __WEBPACK_IMPORTED_MODULE_4__PatternUtils__["a" /* formatPattern */](pattern, params);
        }

        replace({
          pathname: pathname,
          query: route.query || location.query,
          state: route.state || location.state
        });
      };

      return route;
    },
    getRoutePattern: function getRoutePattern(routes, routeIndex) {
      var parentPattern = '';

      for (var i = routeIndex; i >= 0; i--) {
        var route = routes[i];
        var pattern = route.path || '';

        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;

        if (pattern.indexOf('/') === 0) break;
      }

      return '/' + parentPattern;
    }
  },

  propTypes: {
    path: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
    from: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"], // Alias for path
    to: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"].isRequired,
    query: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    state: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    onEnter: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */],
    children: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<Redirect> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_2_invariant___default.a(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createMemoryHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory__);




function createMemoryHistory(options) {
  // signatures and type checking differ between `useQueries` and
  // `createMemoryHistory`, have to create `memoryHistory` first because
  // `useQueries` doesn't understand the signature
  var memoryHistory = __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory___default.a(options);
  var createHistory = function createHistory() {
    return memoryHistory;
  };
  var history = __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default.a(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default.a(createHistory))(options);
  return history;
}

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _queryString = __webpack_require__(429);

var _runTransitionHook = __webpack_require__(89);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _LocationUtils = __webpack_require__(41);

var _PathUtils = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultStringifyQuery = function defaultStringifyQuery(query) {
  return (0, _queryString.stringify)(query).replace(/%20/g, '+');
};

var defaultParseQueryString = _queryString.parse;

/**
 * Returns a new createHistory function that may be used to create
 * history objects that know how to handle URL queries.
 */
var useQueries = function useQueries(createHistory) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var history = createHistory(options);
    var stringifyQuery = options.stringifyQuery,
        parseQueryString = options.parseQueryString;


    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;

    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;

    var decodeQuery = function decodeQuery(location) {
      if (!location) return location;

      if (location.query == null) location.query = parseQueryString(location.search.substring(1));

      return location;
    };

    var encodeQuery = function encodeQuery(location, query) {
      if (query == null) return location;

      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
      var queryString = stringifyQuery(query);
      var search = queryString ? '?' + queryString : '';

      return _extends({}, object, {
        search: search
      });
    };

    // Override all read methods with query-aware versions.
    var getCurrentLocation = function getCurrentLocation() {
      return decodeQuery(history.getCurrentLocation());
    };

    var listenBefore = function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        return (0, _runTransitionHook2.default)(hook, decodeQuery(location), callback);
      });
    };

    var listen = function listen(listener) {
      return history.listen(function (location) {
        return listener(decodeQuery(location));
      });
    };

    // Override all write methods with query-aware versions.
    var push = function push(location) {
      return history.push(encodeQuery(location, location.query));
    };

    var replace = function replace(location) {
      return history.replace(encodeQuery(location, location.query));
    };

    var createPath = function createPath(location) {
      return history.createPath(encodeQuery(location, location.query));
    };

    var createHref = function createHref(location) {
      return history.createHref(encodeQuery(location, location.query));
    };

    var createLocation = function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var newLocation = history.createLocation.apply(history, [encodeQuery(location, location.query)].concat(args));

      if (location.query) newLocation.query = (0, _LocationUtils.createQuery)(location.query);

      return decodeQuery(newLocation);
    };

    return _extends({}, history, {
      getCurrentLocation: getCurrentLocation,
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation
    });
  };
};

exports.default = useQueries;

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _runTransitionHook = __webpack_require__(89);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _PathUtils = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useBasename = function useBasename(createHistory) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var history = createHistory(options);
    var basename = options.basename;


    var addBasename = function addBasename(location) {
      if (!location) return location;

      if (basename && location.basename == null) {
        if (location.pathname.toLowerCase().indexOf(basename.toLowerCase()) === 0) {
          location.pathname = location.pathname.substring(basename.length);
          location.basename = basename;

          if (location.pathname === '') location.pathname = '/';
        } else {
          location.basename = '';
        }
      }

      return location;
    };

    var prependBasename = function prependBasename(location) {
      if (!basename) return location;

      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
      var pname = object.pathname;
      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
      var pathname = normalizedBasename + normalizedPathname;

      return _extends({}, object, {
        pathname: pathname
      });
    };

    // Override all read methods with basename-aware versions.
    var getCurrentLocation = function getCurrentLocation() {
      return addBasename(history.getCurrentLocation());
    };

    var listenBefore = function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        return (0, _runTransitionHook2.default)(hook, addBasename(location), callback);
      });
    };

    var listen = function listen(listener) {
      return history.listen(function (location) {
        return listener(addBasename(location));
      });
    };

    // Override all write methods with basename-aware versions.
    var push = function push(location) {
      return history.push(prependBasename(location));
    };

    var replace = function replace(location) {
      return history.replace(prependBasename(location));
    };

    var createPath = function createPath(location) {
      return history.createPath(prependBasename(location));
    };

    var createHref = function createHref(location) {
      return history.createHref(prependBasename(location));
    };

    var createLocation = function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
    };

    return _extends({}, history, {
      getCurrentLocation: getCurrentLocation,
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation
    });
  };
};

exports.default = useBasename;

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useRouterHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__);



function useRouterHistory(createHistory) {
  return function (options) {
    var history = __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default.a(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default.a(createHistory))(options);
    return history;
  };
}

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.readState = exports.saveState = undefined;

var _warning = __webpack_require__(23);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QuotaExceededErrors = {
  QuotaExceededError: true,
  QUOTA_EXCEEDED_ERR: true
};

var SecurityErrors = {
  SecurityError: true
};

var KeyPrefix = '@@History/';

var createKey = function createKey(key) {
  return KeyPrefix + key;
};

var saveState = exports.saveState = function saveState(key, state) {
  if (!window.sessionStorage) {
    // Session storage is not available or hidden.
    // sessionStorage is undefined in Internet Explorer when served via file protocol.
     false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available') : void 0;

    return;
  }

  try {
    if (state == null) {
      window.sessionStorage.removeItem(createKey(key));
    } else {
      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
    }
  } catch (error) {
    if (SecurityErrors[error.name]) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available due to security settings') : void 0;

      return;
    }

    if (QuotaExceededErrors[error.name] && window.sessionStorage.length === 0) {
      // Safari "private mode" throws QuotaExceededError.
       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : void 0;

      return;
    }

    throw error;
  }
};

var readState = exports.readState = function readState(key) {
  var json = void 0;
  try {
    json = window.sessionStorage.getItem(createKey(key));
  } catch (error) {
    if (SecurityErrors[error.name]) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
       false ? (0, _warning2.default)(false, '[history] Unable to read state; sessionStorage is not available due to security settings') : void 0;

      return undefined;
    }
  }

  if (json) {
    try {
      return JSON.parse(json);
    } catch (error) {
      // Ignore invalid JSON.
    }
  }

  return undefined;
};

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createRouterHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__useRouterHistory__ = __webpack_require__(146);


var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

function createRouterHistory(createHistory) {
  var history = void 0;
  if (canUseDOM) history = __WEBPACK_IMPORTED_MODULE_0__useRouterHistory__["a" /* default */](createHistory)();
  return history;
}

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__ = __webpack_require__(149);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var hotReloadingVersion = 0;
var dummyState = {};
function noop() {}
function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);
        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };

  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory) {
  var _contextTypes, _childContextTypes;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$getDisplayName = _ref.getDisplayName,
      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
    return 'ConnectAdvanced(' + name + ')';
  } : _ref$getDisplayName,
      _ref$methodName = _ref.methodName,
      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
      _ref$renderCountProp = _ref.renderCountProp,
      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
      _ref$storeKey = _ref.storeKey,
      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
      _ref$withRef = _ref.withRef,
      withRef = _ref$withRef === undefined ? false : _ref$withRef,
      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;

  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);

  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default.a(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + ('connect. Instead received ' + JSON.stringify(WrappedComponent)));

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);

        __WEBPACK_IMPORTED_MODULE_1_invariant___default.a(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));

        _this.initSelector();
        _this.initSubscription();
        return _this;
      }

      Connect.prototype.getChildContext = function getChildContext() {
        var _ref2;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return;

        // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.
        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_1_invariant___default.a(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
        return this.wrappedInstance;
      };

      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      Connect.prototype.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      Connect.prototype.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return;

        // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this));

        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.
        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      Connect.prototype.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidMount` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      Connect.prototype.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
        // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad
        var withExtras = _extends({}, props);
        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      Connect.prototype.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector();

          if (this.subscription) this.subscription.tryUnsubscribe();
          this.initSubscription();
          if (shouldHandleStateChanges) this.subscription.trySubscribe();
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default.a(Connect, WrappedComponent);
  };
}

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_symbol_observable__);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'
};

/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} enhancer The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */
function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */](action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      listeners[i]();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/zenparsing/es-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable___default.a] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable___default.a] = observable, _ref2;
}

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(452);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  var last = funcs[funcs.length - 1];
  var rest = funcs.slice(0, -1);
  return function () {
    return rest.reduceRight(function (composed, f) {
      return f(composed);
    }, last.apply(undefined, arguments));
  };
}

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(156);


function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
}

// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}

// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    
function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    };

    // allow detectFactoryAndVerify to get ownProps
    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);

      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(93);



function verifyPlainObject(value, displayName, methodName) {
  if (!__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */](value)) {
    __WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */](methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
  }
}

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(494),
    keys = __webpack_require__(50);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(496),
    isArguments = __webpack_require__(160),
    isArray = __webpack_require__(13),
    isBuffer = __webpack_require__(98),
    isIndex = __webpack_require__(161),
    isTypedArray = __webpack_require__(162);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(497),
    isObjectLike = __webpack_require__(30);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 161 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(499),
    baseUnary = __webpack_require__(500),
    nodeUtil = __webpack_require__(501);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 163 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(29),
    isObject = __webpack_require__(22);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(166);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),
/* 166 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 167 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 168 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(534),
    isObjectLike = __webpack_require__(30);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(535),
    arraySome = __webpack_require__(538),
    cacheHas = __webpack_require__(539);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(15);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 172 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 173 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(175),
    getSymbols = __webpack_require__(106),
    keys = __webpack_require__(50);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(176),
    isArray = __webpack_require__(13);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 176 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 177 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(543),
    Map = __webpack_require__(104),
    Promise = __webpack_require__(544),
    Set = __webpack_require__(545),
    WeakMap = __webpack_require__(546),
    baseGetTag = __webpack_require__(29),
    toSource = __webpack_require__(168);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(22);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 180 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(182),
    toKey = __webpack_require__(64);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(13),
    isKey = __webpack_require__(107),
    stringToPath = __webpack_require__(550),
    toString = __webpack_require__(553);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(158),
    createBaseEach = __webpack_require__(562);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 184 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(186),
    eq = __webpack_require__(103);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(566);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(159),
    baseKeysIn = __webpack_require__(569),
    isArrayLike = __webpack_require__(58);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(176),
    getPrototype = __webpack_require__(101),
    getSymbols = __webpack_require__(106),
    stubArray = __webpack_require__(177);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),
/* 189 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Checkboard = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(3);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _checkboard = __webpack_require__(594);

var checkboard = _interopRequireWildcard(_checkboard);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Checkboard = exports.Checkboard = function Checkboard(_ref) {
  var white = _ref.white,
      grey = _ref.grey,
      size = _ref.size,
      renderers = _ref.renderers,
      borderRadius = _ref.borderRadius,
      boxShadow = _ref.boxShadow;

  var styles = (0, _reactcss2.default)({
    'default': {
      grid: {
        borderRadius: borderRadius,
        boxShadow: boxShadow,
        absolute: '0px 0px 0px 0px',
        background: 'url(' + checkboard.get(white, grey, size, renderers.canvas) + ') center left'
      }
    }
  });

  return _react2.default.createElement('div', { style: styles.grid });
};

Checkboard.defaultProps = {
  size: 8,
  white: 'transparent',
  grey: 'rgba(0,0,0,.08)',
  renderers: {}
};

exports.default = Checkboard;

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(22),
    now = __webpack_require__(601),
    toNumber = __webpack_require__(602);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColorWrap = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _debounce = __webpack_require__(191);

var _debounce2 = _interopRequireDefault(_debounce);

var _color = __webpack_require__(16);

var _color2 = _interopRequireDefault(_color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ColorWrap = exports.ColorWrap = function ColorWrap(Picker) {
  var ColorPicker = function (_ref) {
    _inherits(ColorPicker, _ref);

    function ColorPicker(props) {
      _classCallCheck(this, ColorPicker);

      var _this = _possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this));

      _this.handleChange = function (data, event) {
        var isValidColor = _color2.default.simpleCheckForValidColor(data);
        if (isValidColor) {
          var colors = _color2.default.toState(data, data.h || _this.state.oldHue);
          _this.setState(colors);
          _this.props.onChangeComplete && _this.debounce(_this.props.onChangeComplete, colors, event);
          _this.props.onChange && _this.props.onChange(colors, event);
        }
      };

      _this.handleSwatchHover = function (data, event) {
        var isValidColor = _color2.default.simpleCheckForValidColor(data);
        if (isValidColor) {
          var colors = _color2.default.toState(data, data.h || _this.state.oldHue);
          _this.setState(colors);
          _this.props.onSwatchHover && _this.props.onSwatchHover(colors, event);
        }
      };

      _this.state = _extends({}, _color2.default.toState(props.color, 0));

      _this.debounce = (0, _debounce2.default)(function (fn, data, event) {
        fn(data, event);
      }, 100);
      return _this;
    }

    _createClass(ColorPicker, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        this.setState(_extends({}, _color2.default.toState(nextProps.color, this.state.oldHue)));
      }
    }, {
      key: 'render',
      value: function render() {
        var optionalEvents = {};
        if (this.props.onSwatchHover) {
          optionalEvents.onSwatchHover = this.handleSwatchHover;
        }

        return _react2.default.createElement(Picker, _extends({}, this.props, this.state, {
          onChange: this.handleChange
        }, optionalEvents));
      }
    }]);

    return ColorPicker;
  }(_react.PureComponent || _react.Component);

  ColorPicker.propTypes = _extends({}, Picker.propTypes);

  ColorPicker.defaultProps = _extends({}, Picker.defaultProps, {
    color: {
      h: 250,
      s: 0.50,
      l: 0.20,
      a: 1
    }
  });

  return ColorPicker;
};

exports.default = ColorWrap;

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "red", function() { return red; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pink", function() { return pink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "purple", function() { return purple; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deepPurple", function() { return deepPurple; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "indigo", function() { return indigo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "blue", function() { return blue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lightBlue", function() { return lightBlue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cyan", function() { return cyan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "teal", function() { return teal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "green", function() { return green; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lightGreen", function() { return lightGreen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lime", function() { return lime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "yellow", function() { return yellow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "amber", function() { return amber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "orange", function() { return orange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deepOrange", function() { return deepOrange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "brown", function() { return brown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "grey", function() { return grey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "blueGrey", function() { return blueGrey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "darkText", function() { return darkText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lightText", function() { return lightText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "darkIcons", function() { return darkIcons; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lightIcons", function() { return lightIcons; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "white", function() { return white; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "black", function() { return black; });
var red = {"50":"#ffebee","100":"#ffcdd2","200":"#ef9a9a","300":"#e57373","400":"#ef5350","500":"#f44336","600":"#e53935","700":"#d32f2f","800":"#c62828","900":"#b71c1c","a100":"#ff8a80","a200":"#ff5252","a400":"#ff1744","a700":"#d50000"};
var pink = {"50":"#fce4ec","100":"#f8bbd0","200":"#f48fb1","300":"#f06292","400":"#ec407a","500":"#e91e63","600":"#d81b60","700":"#c2185b","800":"#ad1457","900":"#880e4f","a100":"#ff80ab","a200":"#ff4081","a400":"#f50057","a700":"#c51162"};
var purple = {"50":"#f3e5f5","100":"#e1bee7","200":"#ce93d8","300":"#ba68c8","400":"#ab47bc","500":"#9c27b0","600":"#8e24aa","700":"#7b1fa2","800":"#6a1b9a","900":"#4a148c","a100":"#ea80fc","a200":"#e040fb","a400":"#d500f9","a700":"#aa00ff"};
var deepPurple = {"50":"#ede7f6","100":"#d1c4e9","200":"#b39ddb","300":"#9575cd","400":"#7e57c2","500":"#673ab7","600":"#5e35b1","700":"#512da8","800":"#4527a0","900":"#311b92","a100":"#b388ff","a200":"#7c4dff","a400":"#651fff","a700":"#6200ea"};
var indigo = {"50":"#e8eaf6","100":"#c5cae9","200":"#9fa8da","300":"#7986cb","400":"#5c6bc0","500":"#3f51b5","600":"#3949ab","700":"#303f9f","800":"#283593","900":"#1a237e","a100":"#8c9eff","a200":"#536dfe","a400":"#3d5afe","a700":"#304ffe"};
var blue = {"50":"#e3f2fd","100":"#bbdefb","200":"#90caf9","300":"#64b5f6","400":"#42a5f5","500":"#2196f3","600":"#1e88e5","700":"#1976d2","800":"#1565c0","900":"#0d47a1","a100":"#82b1ff","a200":"#448aff","a400":"#2979ff","a700":"#2962ff"};
var lightBlue = {"50":"#e1f5fe","100":"#b3e5fc","200":"#81d4fa","300":"#4fc3f7","400":"#29b6f6","500":"#03a9f4","600":"#039be5","700":"#0288d1","800":"#0277bd","900":"#01579b","a100":"#80d8ff","a200":"#40c4ff","a400":"#00b0ff","a700":"#0091ea"};
var cyan = {"50":"#e0f7fa","100":"#b2ebf2","200":"#80deea","300":"#4dd0e1","400":"#26c6da","500":"#00bcd4","600":"#00acc1","700":"#0097a7","800":"#00838f","900":"#006064","a100":"#84ffff","a200":"#18ffff","a400":"#00e5ff","a700":"#00b8d4"};
var teal = {"50":"#e0f2f1","100":"#b2dfdb","200":"#80cbc4","300":"#4db6ac","400":"#26a69a","500":"#009688","600":"#00897b","700":"#00796b","800":"#00695c","900":"#004d40","a100":"#a7ffeb","a200":"#64ffda","a400":"#1de9b6","a700":"#00bfa5"};
var green = {"50":"#e8f5e9","100":"#c8e6c9","200":"#a5d6a7","300":"#81c784","400":"#66bb6a","500":"#4caf50","600":"#43a047","700":"#388e3c","800":"#2e7d32","900":"#1b5e20","a100":"#b9f6ca","a200":"#69f0ae","a400":"#00e676","a700":"#00c853"};
var lightGreen = {"50":"#f1f8e9","100":"#dcedc8","200":"#c5e1a5","300":"#aed581","400":"#9ccc65","500":"#8bc34a","600":"#7cb342","700":"#689f38","800":"#558b2f","900":"#33691e","a100":"#ccff90","a200":"#b2ff59","a400":"#76ff03","a700":"#64dd17"};
var lime = {"50":"#f9fbe7","100":"#f0f4c3","200":"#e6ee9c","300":"#dce775","400":"#d4e157","500":"#cddc39","600":"#c0ca33","700":"#afb42b","800":"#9e9d24","900":"#827717","a100":"#f4ff81","a200":"#eeff41","a400":"#c6ff00","a700":"#aeea00"};
var yellow = {"50":"#fffde7","100":"#fff9c4","200":"#fff59d","300":"#fff176","400":"#ffee58","500":"#ffeb3b","600":"#fdd835","700":"#fbc02d","800":"#f9a825","900":"#f57f17","a100":"#ffff8d","a200":"#ffff00","a400":"#ffea00","a700":"#ffd600"};
var amber = {"50":"#fff8e1","100":"#ffecb3","200":"#ffe082","300":"#ffd54f","400":"#ffca28","500":"#ffc107","600":"#ffb300","700":"#ffa000","800":"#ff8f00","900":"#ff6f00","a100":"#ffe57f","a200":"#ffd740","a400":"#ffc400","a700":"#ffab00"};
var orange = {"50":"#fff3e0","100":"#ffe0b2","200":"#ffcc80","300":"#ffb74d","400":"#ffa726","500":"#ff9800","600":"#fb8c00","700":"#f57c00","800":"#ef6c00","900":"#e65100","a100":"#ffd180","a200":"#ffab40","a400":"#ff9100","a700":"#ff6d00"};
var deepOrange = {"50":"#fbe9e7","100":"#ffccbc","200":"#ffab91","300":"#ff8a65","400":"#ff7043","500":"#ff5722","600":"#f4511e","700":"#e64a19","800":"#d84315","900":"#bf360c","a100":"#ff9e80","a200":"#ff6e40","a400":"#ff3d00","a700":"#dd2c00"};
var brown = {"50":"#efebe9","100":"#d7ccc8","200":"#bcaaa4","300":"#a1887f","400":"#8d6e63","500":"#795548","600":"#6d4c41","700":"#5d4037","800":"#4e342e","900":"#3e2723"};
var grey = {"50":"#fafafa","100":"#f5f5f5","200":"#eeeeee","300":"#e0e0e0","400":"#bdbdbd","500":"#9e9e9e","600":"#757575","700":"#616161","800":"#424242","900":"#212121"};
var blueGrey = {"50":"#eceff1","100":"#cfd8dc","200":"#b0bec5","300":"#90a4ae","400":"#78909c","500":"#607d8b","600":"#546e7a","700":"#455a64","800":"#37474f","900":"#263238"};
var darkText = {"primary":"rgba(0, 0, 0, 0.87)","secondary":"rgba(0, 0, 0, 0.54)","disabled":"rgba(0, 0, 0, 0.38)","dividers":"rgba(0, 0, 0, 0.12)"};
var lightText = {"primary":"rgba(255, 255, 255, 1)","secondary":"rgba(255, 255, 255, 0.7)","disabled":"rgba(255, 255, 255, 0.5)","dividers":"rgba(255, 255, 255, 0.12)"};
var darkIcons = {"active":"rgba(0, 0, 0, 0.54)","inactive":"rgba(0, 0, 0, 0.38)"};
var lightIcons = {"active":"rgba(255, 255, 255, 1)","inactive":"rgba(255, 255, 255, 0.5)"};
var white = "#ffffff";
var black = "#000000";

/* harmony default export */ __webpack_exports__["default"] = ({
  red: red,
  pink: pink,
  purple: purple,
  deepPurple: deepPurple,
  indigo: indigo,
  blue: blue,
  lightBlue: lightBlue,
  cyan: cyan,
  teal: teal,
  green: green,
  lightGreen: lightGreen,
  lime: lime,
  yellow: yellow,
  amber: amber,
  orange: orange,
  deepOrange: deepOrange,
  brown: brown,
  grey: grey,
  blueGrey: blueGrey,
  darkText: darkText,
  lightText: lightText,
  darkIcons: darkIcons,
  lightIcons: lightIcons,
  white: white,
  black: black
});


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Afrikaans [af]
//! author : Werner Mollentze : https://github.com/wernerm

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var af = moment.defineLocale('af', {
    months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
    monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
    weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
    weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
    weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
    meridiemParse: /vm|nm/i,
    isPM : function (input) {
        return /^nm$/i.test(input);
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 12) {
            return isLower ? 'vm' : 'VM';
        } else {
            return isLower ? 'nm' : 'NM';
        }
    },
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Vandag om] LT',
        nextDay : '[Môre om] LT',
        nextWeek : 'dddd [om] LT',
        lastDay : '[Gister om] LT',
        lastWeek : '[Laas] dddd [om] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'oor %s',
        past : '%s gelede',
        s : '\'n paar sekondes',
        m : '\'n minuut',
        mm : '%d minute',
        h : '\'n uur',
        hh : '%d ure',
        d : '\'n dag',
        dd : '%d dae',
        M : '\'n maand',
        MM : '%d maande',
        y : '\'n jaar',
        yy : '%d jaar'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
    },
    week : {
        dow : 1, // Maandag is die eerste dag van die week.
        doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
    }
});

return af;

})));


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic [ar]
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '١',
    '2': '٢',
    '3': '٣',
    '4': '٤',
    '5': '٥',
    '6': '٦',
    '7': '٧',
    '8': '٨',
    '9': '٩',
    '0': '٠'
};
var numberMap = {
    '١': '1',
    '٢': '2',
    '٣': '3',
    '٤': '4',
    '٥': '5',
    '٦': '6',
    '٧': '7',
    '٨': '8',
    '٩': '9',
    '٠': '0'
};
var pluralForm = function (n) {
    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
};
var plurals = {
    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
};
var pluralize = function (u) {
    return function (number, withoutSuffix, string, isFuture) {
        var f = pluralForm(number),
            str = plurals[u][pluralForm(number)];
        if (f === 2) {
            str = str[withoutSuffix ? 0 : 1];
        }
        return str.replace(/%d/i, number);
    };
};
var months = [
    'كانون الثاني يناير',
    'شباط فبراير',
    'آذار مارس',
    'نيسان أبريل',
    'أيار مايو',
    'حزيران يونيو',
    'تموز يوليو',
    'آب أغسطس',
    'أيلول سبتمبر',
    'تشرين الأول أكتوبر',
    'تشرين الثاني نوفمبر',
    'كانون الأول ديسمبر'
];

var ar = moment.defineLocale('ar', {
    months : months,
    monthsShort : months,
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'D/\u200FM/\u200FYYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ص|م/,
    isPM : function (input) {
        return 'م' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ص';
        } else {
            return 'م';
        }
    },
    calendar : {
        sameDay: '[اليوم عند الساعة] LT',
        nextDay: '[غدًا عند الساعة] LT',
        nextWeek: 'dddd [عند الساعة] LT',
        lastDay: '[أمس عند الساعة] LT',
        lastWeek: 'dddd [عند الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'بعد %s',
        past : 'منذ %s',
        s : pluralize('s'),
        m : pluralize('m'),
        mm : pluralize('m'),
        h : pluralize('h'),
        hh : pluralize('h'),
        d : pluralize('d'),
        dd : pluralize('d'),
        M : pluralize('M'),
        MM : pluralize('M'),
        y : pluralize('y'),
        yy : pluralize('y')
    },
    preparse: function (string) {
        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
            return numberMap[match];
        }).replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return ar;

})));


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Algeria) [ar-dz]
//! author : Noureddine LOUAHEDJ : https://github.com/noureddineme

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arDz = moment.defineLocale('ar-dz', {
    months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 4  // The week that contains Jan 1st is the first week of the year.
    }
});

return arDz;

})));


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Kuwait) [ar-kw]
//! author : Nusret Parlak: https://github.com/nusretparlak

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arKw = moment.defineLocale('ar-kw', {
    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return arKw;

})));


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Lybia) [ar-ly]
//! author : Ali Hmer: https://github.com/kikoanis

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '1',
    '2': '2',
    '3': '3',
    '4': '4',
    '5': '5',
    '6': '6',
    '7': '7',
    '8': '8',
    '9': '9',
    '0': '0'
};
var pluralForm = function (n) {
    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
};
var plurals = {
    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
};
var pluralize = function (u) {
    return function (number, withoutSuffix, string, isFuture) {
        var f = pluralForm(number),
            str = plurals[u][pluralForm(number)];
        if (f === 2) {
            str = str[withoutSuffix ? 0 : 1];
        }
        return str.replace(/%d/i, number);
    };
};
var months = [
    'يناير',
    'فبراير',
    'مارس',
    'أبريل',
    'مايو',
    'يونيو',
    'يوليو',
    'أغسطس',
    'سبتمبر',
    'أكتوبر',
    'نوفمبر',
    'ديسمبر'
];

var arLy = moment.defineLocale('ar-ly', {
    months : months,
    monthsShort : months,
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'D/\u200FM/\u200FYYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ص|م/,
    isPM : function (input) {
        return 'م' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ص';
        } else {
            return 'م';
        }
    },
    calendar : {
        sameDay: '[اليوم عند الساعة] LT',
        nextDay: '[غدًا عند الساعة] LT',
        nextWeek: 'dddd [عند الساعة] LT',
        lastDay: '[أمس عند الساعة] LT',
        lastWeek: 'dddd [عند الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'بعد %s',
        past : 'منذ %s',
        s : pluralize('s'),
        m : pluralize('m'),
        mm : pluralize('m'),
        h : pluralize('h'),
        hh : pluralize('h'),
        d : pluralize('d'),
        dd : pluralize('d'),
        M : pluralize('M'),
        MM : pluralize('M'),
        y : pluralize('y'),
        yy : pluralize('y')
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return arLy;

})));


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Morocco) [ar-ma]
//! author : ElFadili Yassine : https://github.com/ElFadiliY
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arMa = moment.defineLocale('ar-ma', {
    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return arMa;

})));


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Saudi Arabia) [ar-sa]
//! author : Suhail Alkowaileet : https://github.com/xsoh

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '١',
    '2': '٢',
    '3': '٣',
    '4': '٤',
    '5': '٥',
    '6': '٦',
    '7': '٧',
    '8': '٨',
    '9': '٩',
    '0': '٠'
};
var numberMap = {
    '١': '1',
    '٢': '2',
    '٣': '3',
    '٤': '4',
    '٥': '5',
    '٦': '6',
    '٧': '7',
    '٨': '8',
    '٩': '9',
    '٠': '0'
};

var arSa = moment.defineLocale('ar-sa', {
    months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ص|م/,
    isPM : function (input) {
        return 'م' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ص';
        } else {
            return 'م';
        }
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    preparse: function (string) {
        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
            return numberMap[match];
        }).replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return arSa;

})));


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale  :  Arabic (Tunisia) [ar-tn]
//! author : Nader Toukabri : https://github.com/naderio

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arTn = moment.defineLocale('ar-tn', {
    months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'في %s',
        past: 'منذ %s',
        s: 'ثوان',
        m: 'دقيقة',
        mm: '%d دقائق',
        h: 'ساعة',
        hh: '%d ساعات',
        d: 'يوم',
        dd: '%d أيام',
        M: 'شهر',
        MM: '%d أشهر',
        y: 'سنة',
        yy: '%d سنوات'
    },
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4 // The week that contains Jan 4th is the first week of the year.
    }
});

return arTn;

})));


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Azerbaijani [az]
//! author : topchiyev : https://github.com/topchiyev

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var suffixes = {
    1: '-inci',
    5: '-inci',
    8: '-inci',
    70: '-inci',
    80: '-inci',
    2: '-nci',
    7: '-nci',
    20: '-nci',
    50: '-nci',
    3: '-üncü',
    4: '-üncü',
    100: '-üncü',
    6: '-ncı',
    9: '-uncu',
    10: '-uncu',
    30: '-uncu',
    60: '-ıncı',
    90: '-ıncı'
};

var az = moment.defineLocale('az', {
    months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
    monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
    weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
    weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
    weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[bugün saat] LT',
        nextDay : '[sabah saat] LT',
        nextWeek : '[gələn həftə] dddd [saat] LT',
        lastDay : '[dünən] LT',
        lastWeek : '[keçən həftə] dddd [saat] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s sonra',
        past : '%s əvvəl',
        s : 'birneçə saniyyə',
        m : 'bir dəqiqə',
        mm : '%d dəqiqə',
        h : 'bir saat',
        hh : '%d saat',
        d : 'bir gün',
        dd : '%d gün',
        M : 'bir ay',
        MM : '%d ay',
        y : 'bir il',
        yy : '%d il'
    },
    meridiemParse: /gecə|səhər|gündüz|axşam/,
    isPM : function (input) {
        return /^(gündüz|axşam)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'gecə';
        } else if (hour < 12) {
            return 'səhər';
        } else if (hour < 17) {
            return 'gündüz';
        } else {
            return 'axşam';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
    ordinal : function (number) {
        if (number === 0) {  // special case for zero
            return number + '-ıncı';
        }
        var a = number % 10,
            b = number % 100 - a,
            c = number >= 100 ? 100 : null;
        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return az;

})));


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Belarusian [be]
//! author : Dmitry Demidov : https://github.com/demidov91
//! author: Praleska: http://praleska.pro/
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(word, num) {
    var forms = word.split('_');
    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
        'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
        'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
        'dd': 'дзень_дні_дзён',
        'MM': 'месяц_месяцы_месяцаў',
        'yy': 'год_гады_гадоў'
    };
    if (key === 'm') {
        return withoutSuffix ? 'хвіліна' : 'хвіліну';
    }
    else if (key === 'h') {
        return withoutSuffix ? 'гадзіна' : 'гадзіну';
    }
    else {
        return number + ' ' + plural(format[key], +number);
    }
}

var be = moment.defineLocale('be', {
    months : {
        format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
        standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
    },
    monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
    weekdays : {
        format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
        standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
        isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
    },
    weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
    weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY г.',
        LLL : 'D MMMM YYYY г., HH:mm',
        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
    },
    calendar : {
        sameDay: '[Сёння ў] LT',
        nextDay: '[Заўтра ў] LT',
        lastDay: '[Учора ў] LT',
        nextWeek: function () {
            return '[У] dddd [ў] LT';
        },
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 5:
                case 6:
                    return '[У мінулую] dddd [ў] LT';
                case 1:
                case 2:
                case 4:
                    return '[У мінулы] dddd [ў] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'праз %s',
        past : '%s таму',
        s : 'некалькі секунд',
        m : relativeTimeWithPlural,
        mm : relativeTimeWithPlural,
        h : relativeTimeWithPlural,
        hh : relativeTimeWithPlural,
        d : 'дзень',
        dd : relativeTimeWithPlural,
        M : 'месяц',
        MM : relativeTimeWithPlural,
        y : 'год',
        yy : relativeTimeWithPlural
    },
    meridiemParse: /ночы|раніцы|дня|вечара/,
    isPM : function (input) {
        return /^(дня|вечара)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ночы';
        } else if (hour < 12) {
            return 'раніцы';
        } else if (hour < 17) {
            return 'дня';
        } else {
            return 'вечара';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'M':
            case 'd':
            case 'DDD':
            case 'w':
            case 'W':
                return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
            case 'D':
                return number + '-га';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return be;

})));


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bulgarian [bg]
//! author : Krasen Borisov : https://github.com/kraz

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var bg = moment.defineLocale('bg', {
    months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
    monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
    weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
    weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'D.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY H:mm',
        LLLL : 'dddd, D MMMM YYYY H:mm'
    },
    calendar : {
        sameDay : '[Днес в] LT',
        nextDay : '[Утре в] LT',
        nextWeek : 'dddd [в] LT',
        lastDay : '[Вчера в] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 6:
                    return '[В изминалата] dddd [в] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[В изминалия] dddd [в] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'след %s',
        past : 'преди %s',
        s : 'няколко секунди',
        m : 'минута',
        mm : '%d минути',
        h : 'час',
        hh : '%d часа',
        d : 'ден',
        dd : '%d дни',
        M : 'месец',
        MM : '%d месеца',
        y : 'година',
        yy : '%d години'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
    ordinal : function (number) {
        var lastDigit = number % 10,
            last2Digits = number % 100;
        if (number === 0) {
            return number + '-ев';
        } else if (last2Digits === 0) {
            return number + '-ен';
        } else if (last2Digits > 10 && last2Digits < 20) {
            return number + '-ти';
        } else if (lastDigit === 1) {
            return number + '-ви';
        } else if (lastDigit === 2) {
            return number + '-ри';
        } else if (lastDigit === 7 || lastDigit === 8) {
            return number + '-ми';
        } else {
            return number + '-ти';
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return bg;

})));


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bambara [bm]
//! author : Estelle Comment : https://github.com/estellecomment

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

// Language contact person : Abdoufata Kane : https://github.com/abdoufata

var bm = moment.defineLocale('bm', {
    months : 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split('_'),
    monthsShort : 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
    weekdays : 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
    weekdaysShort : 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
    weekdaysMin : 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'MMMM [tile] D [san] YYYY',
        LLL : 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
        LLLL : 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm'
    },
    calendar : {
        sameDay : '[Bi lɛrɛ] LT',
        nextDay : '[Sini lɛrɛ] LT',
        nextWeek : 'dddd [don lɛrɛ] LT',
        lastDay : '[Kunu lɛrɛ] LT',
        lastWeek : 'dddd [tɛmɛnen lɛrɛ] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s kɔnɔ',
        past : 'a bɛ %s bɔ',
        s : 'sanga dama dama',
        m : 'miniti kelen',
        mm : 'miniti %d',
        h : 'lɛrɛ kelen',
        hh : 'lɛrɛ %d',
        d : 'tile kelen',
        dd : 'tile %d',
        M : 'kalo kelen',
        MM : 'kalo %d',
        y : 'san kelen',
        yy : 'san %d'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return bm;

})));


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bengali [bn]
//! author : Kaushik Gandhi : https://github.com/kaushikgandhi

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '১',
    '2': '২',
    '3': '৩',
    '4': '৪',
    '5': '৫',
    '6': '৬',
    '7': '৭',
    '8': '৮',
    '9': '৯',
    '0': '০'
};
var numberMap = {
    '১': '1',
    '২': '2',
    '৩': '3',
    '৪': '4',
    '৫': '5',
    '৬': '6',
    '৭': '7',
    '৮': '8',
    '৯': '9',
    '০': '0'
};

var bn = moment.defineLocale('bn', {
    months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
    monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
    weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
    weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
    weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
    longDateFormat : {
        LT : 'A h:mm সময়',
        LTS : 'A h:mm:ss সময়',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm সময়',
        LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
    },
    calendar : {
        sameDay : '[আজ] LT',
        nextDay : '[আগামীকাল] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[গতকাল] LT',
        lastWeek : '[গত] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s পরে',
        past : '%s আগে',
        s : 'কয়েক সেকেন্ড',
        m : 'এক মিনিট',
        mm : '%d মিনিট',
        h : 'এক ঘন্টা',
        hh : '%d ঘন্টা',
        d : 'এক দিন',
        dd : '%d দিন',
        M : 'এক মাস',
        MM : '%d মাস',
        y : 'এক বছর',
        yy : '%d বছর'
    },
    preparse: function (string) {
        return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if ((meridiem === 'রাত' && hour >= 4) ||
                (meridiem === 'দুপুর' && hour < 5) ||
                meridiem === 'বিকাল') {
            return hour + 12;
        } else {
            return hour;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'রাত';
        } else if (hour < 10) {
            return 'সকাল';
        } else if (hour < 17) {
            return 'দুপুর';
        } else if (hour < 20) {
            return 'বিকাল';
        } else {
            return 'রাত';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return bn;

})));


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tibetan [bo]
//! author : Thupten N. Chakrishar : https://github.com/vajradog

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '༡',
    '2': '༢',
    '3': '༣',
    '4': '༤',
    '5': '༥',
    '6': '༦',
    '7': '༧',
    '8': '༨',
    '9': '༩',
    '0': '༠'
};
var numberMap = {
    '༡': '1',
    '༢': '2',
    '༣': '3',
    '༤': '4',
    '༥': '5',
    '༦': '6',
    '༧': '7',
    '༨': '8',
    '༩': '9',
    '༠': '0'
};

var bo = moment.defineLocale('bo', {
    months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
    monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
    weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
    weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
    weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm',
        LLLL : 'dddd, D MMMM YYYY, A h:mm'
    },
    calendar : {
        sameDay : '[དི་རིང] LT',
        nextDay : '[སང་ཉིན] LT',
        nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
        lastDay : '[ཁ་སང] LT',
        lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ལ་',
        past : '%s སྔན་ལ',
        s : 'ལམ་སང',
        m : 'སྐར་མ་གཅིག',
        mm : '%d སྐར་མ',
        h : 'ཆུ་ཚོད་གཅིག',
        hh : '%d ཆུ་ཚོད',
        d : 'ཉིན་གཅིག',
        dd : '%d ཉིན་',
        M : 'ཟླ་བ་གཅིག',
        MM : '%d ཟླ་བ',
        y : 'ལོ་གཅིག',
        yy : '%d ལོ'
    },
    preparse: function (string) {
        return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
                (meridiem === 'ཉིན་གུང' && hour < 5) ||
                meridiem === 'དགོང་དག') {
            return hour + 12;
        } else {
            return hour;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'མཚན་མོ';
        } else if (hour < 10) {
            return 'ཞོགས་ཀས';
        } else if (hour < 17) {
            return 'ཉིན་གུང';
        } else if (hour < 20) {
            return 'དགོང་དག';
        } else {
            return 'མཚན་མོ';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return bo;

})));


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Breton [br]
//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function relativeTimeWithMutation(number, withoutSuffix, key) {
    var format = {
        'mm': 'munutenn',
        'MM': 'miz',
        'dd': 'devezh'
    };
    return number + ' ' + mutation(format[key], number);
}
function specialMutationForYears(number) {
    switch (lastNumber(number)) {
        case 1:
        case 3:
        case 4:
        case 5:
        case 9:
            return number + ' bloaz';
        default:
            return number + ' vloaz';
    }
}
function lastNumber(number) {
    if (number > 9) {
        return lastNumber(number % 10);
    }
    return number;
}
function mutation(text, number) {
    if (number === 2) {
        return softMutation(text);
    }
    return text;
}
function softMutation(text) {
    var mutationTable = {
        'm': 'v',
        'b': 'v',
        'd': 'z'
    };
    if (mutationTable[text.charAt(0)] === undefined) {
        return text;
    }
    return mutationTable[text.charAt(0)] + text.substring(1);
}

var br = moment.defineLocale('br', {
    months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
    monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
    weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
    weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
    weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'h[e]mm A',
        LTS : 'h[e]mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D [a viz] MMMM YYYY',
        LLL : 'D [a viz] MMMM YYYY h[e]mm A',
        LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
    },
    calendar : {
        sameDay : '[Hiziv da] LT',
        nextDay : '[Warc\'hoazh da] LT',
        nextWeek : 'dddd [da] LT',
        lastDay : '[Dec\'h da] LT',
        lastWeek : 'dddd [paset da] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'a-benn %s',
        past : '%s \'zo',
        s : 'un nebeud segondennoù',
        m : 'ur vunutenn',
        mm : relativeTimeWithMutation,
        h : 'un eur',
        hh : '%d eur',
        d : 'un devezh',
        dd : relativeTimeWithMutation,
        M : 'ur miz',
        MM : relativeTimeWithMutation,
        y : 'ur bloaz',
        yy : specialMutationForYears
    },
    dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
    ordinal : function (number) {
        var output = (number === 1) ? 'añ' : 'vet';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return br;

})));


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bosnian [bs]
//! author : Nedim Cholich : https://github.com/frontyard
//! based on (hr) translation by Bojan Marković

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function translate(number, withoutSuffix, key) {
    var result = number + ' ';
    switch (key) {
        case 'm':
            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
        case 'mm':
            if (number === 1) {
                result += 'minuta';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'minute';
            } else {
                result += 'minuta';
            }
            return result;
        case 'h':
            return withoutSuffix ? 'jedan sat' : 'jednog sata';
        case 'hh':
            if (number === 1) {
                result += 'sat';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'sata';
            } else {
                result += 'sati';
            }
            return result;
        case 'dd':
            if (number === 1) {
                result += 'dan';
            } else {
                result += 'dana';
            }
            return result;
        case 'MM':
            if (number === 1) {
                result += 'mjesec';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'mjeseca';
            } else {
                result += 'mjeseci';
            }
            return result;
        case 'yy':
            if (number === 1) {
                result += 'godina';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'godine';
            } else {
                result += 'godina';
            }
            return result;
    }
}

var bs = moment.defineLocale('bs', {
    months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[danas u] LT',
        nextDay  : '[sutra u] LT',
        nextWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedjelju] [u] LT';
                case 3:
                    return '[u] [srijedu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[jučer u] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                    return '[prošlu] dddd [u] LT';
                case 6:
                    return '[prošle] [subote] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[prošli] dddd [u] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'prije %s',
        s      : 'par sekundi',
        m      : translate,
        mm     : translate,
        h      : translate,
        hh     : translate,
        d      : 'dan',
        dd     : translate,
        M      : 'mjesec',
        MM     : translate,
        y      : 'godinu',
        yy     : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return bs;

})));


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Catalan [ca]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ca = moment.defineLocale('ca', {
    months : {
        standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
        format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
        isFormat: /D[oD]?(\s)+MMMM/
    },
    monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
    monthsParseExact : true,
    weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
    weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
    weekdaysMin : 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM [de] YYYY',
        ll : 'D MMM YYYY',
        LLL : 'D MMMM [de] YYYY [a les] H:mm',
        lll : 'D MMM YYYY, H:mm',
        LLLL : 'dddd D MMMM [de] YYYY [a les] H:mm',
        llll : 'ddd D MMM YYYY, H:mm'
    },
    calendar : {
        sameDay : function () {
            return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        nextDay : function () {
            return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        lastDay : function () {
            return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'd\'aquí %s',
        past : 'fa %s',
        s : 'uns segons',
        m : 'un minut',
        mm : '%d minuts',
        h : 'una hora',
        hh : '%d hores',
        d : 'un dia',
        dd : '%d dies',
        M : 'un mes',
        MM : '%d mesos',
        y : 'un any',
        yy : '%d anys'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
    ordinal : function (number, period) {
        var output = (number === 1) ? 'r' :
            (number === 2) ? 'n' :
            (number === 3) ? 'r' :
            (number === 4) ? 't' : 'è';
        if (period === 'w' || period === 'W') {
            output = 'a';
        }
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return ca;

})));


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Czech [cs]
//! author : petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_');
var monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
function plural(n) {
    return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':  // a few seconds / in a few seconds / a few seconds ago
            return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
        case 'm':  // a minute / in a minute / a minute ago
            return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'minuty' : 'minut');
            } else {
                return result + 'minutami';
            }
            break;
        case 'h':  // an hour / in an hour / an hour ago
            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
        case 'hh': // 9 hours / in 9 hours / 9 hours ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'hodiny' : 'hodin');
            } else {
                return result + 'hodinami';
            }
            break;
        case 'd':  // a day / in a day / a day ago
            return (withoutSuffix || isFuture) ? 'den' : 'dnem';
        case 'dd': // 9 days / in 9 days / 9 days ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'dny' : 'dní');
            } else {
                return result + 'dny';
            }
            break;
        case 'M':  // a month / in a month / a month ago
            return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
        case 'MM': // 9 months / in 9 months / 9 months ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'měsíce' : 'měsíců');
            } else {
                return result + 'měsíci';
            }
            break;
        case 'y':  // a year / in a year / a year ago
            return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
        case 'yy': // 9 years / in 9 years / 9 years ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'roky' : 'let');
            } else {
                return result + 'lety';
            }
            break;
    }
}

var cs = moment.defineLocale('cs', {
    months : months,
    monthsShort : monthsShort,
    monthsParse : (function (months, monthsShort) {
        var i, _monthsParse = [];
        for (i = 0; i < 12; i++) {
            // use custom parser to solve problem with July (červenec)
            _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
        }
        return _monthsParse;
    }(months, monthsShort)),
    shortMonthsParse : (function (monthsShort) {
        var i, _shortMonthsParse = [];
        for (i = 0; i < 12; i++) {
            _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
        }
        return _shortMonthsParse;
    }(monthsShort)),
    longMonthsParse : (function (months) {
        var i, _longMonthsParse = [];
        for (i = 0; i < 12; i++) {
            _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
        }
        return _longMonthsParse;
    }(months)),
    weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
    weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
    weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
    longDateFormat : {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd D. MMMM YYYY H:mm',
        l : 'D. M. YYYY'
    },
    calendar : {
        sameDay: '[dnes v] LT',
        nextDay: '[zítra v] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[v neděli v] LT';
                case 1:
                case 2:
                    return '[v] dddd [v] LT';
                case 3:
                    return '[ve středu v] LT';
                case 4:
                    return '[ve čtvrtek v] LT';
                case 5:
                    return '[v pátek v] LT';
                case 6:
                    return '[v sobotu v] LT';
            }
        },
        lastDay: '[včera v] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[minulou neděli v] LT';
                case 1:
                case 2:
                    return '[minulé] dddd [v] LT';
                case 3:
                    return '[minulou středu v] LT';
                case 4:
                case 5:
                    return '[minulý] dddd [v] LT';
                case 6:
                    return '[minulou sobotu v] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'za %s',
        past : 'před %s',
        s : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse : /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return cs;

})));


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chuvash [cv]
//! author : Anatoly Mironov : https://github.com/mirontoli

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var cv = moment.defineLocale('cv', {
    months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
    monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
    weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
    weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
    weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
        LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
        LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
    },
    calendar : {
        sameDay: '[Паян] LT [сехетре]',
        nextDay: '[Ыран] LT [сехетре]',
        lastDay: '[Ӗнер] LT [сехетре]',
        nextWeek: '[Ҫитес] dddd LT [сехетре]',
        lastWeek: '[Иртнӗ] dddd LT [сехетре]',
        sameElse: 'L'
    },
    relativeTime : {
        future : function (output) {
            var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
            return output + affix;
        },
        past : '%s каялла',
        s : 'пӗр-ик ҫеккунт',
        m : 'пӗр минут',
        mm : '%d минут',
        h : 'пӗр сехет',
        hh : '%d сехет',
        d : 'пӗр кун',
        dd : '%d кун',
        M : 'пӗр уйӑх',
        MM : '%d уйӑх',
        y : 'пӗр ҫул',
        yy : '%d ҫул'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
    ordinal : '%d-мӗш',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return cv;

})));


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Welsh [cy]
//! author : Robert Allen : https://github.com/robgallen
//! author : https://github.com/ryangreaves

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var cy = moment.defineLocale('cy', {
    months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
    monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
    weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
    weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
    weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
    weekdaysParseExact : true,
    // time formats are the same as en-gb
    longDateFormat: {
        LT: 'HH:mm',
        LTS : 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[Heddiw am] LT',
        nextDay: '[Yfory am] LT',
        nextWeek: 'dddd [am] LT',
        lastDay: '[Ddoe am] LT',
        lastWeek: 'dddd [diwethaf am] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'mewn %s',
        past: '%s yn ôl',
        s: 'ychydig eiliadau',
        m: 'munud',
        mm: '%d munud',
        h: 'awr',
        hh: '%d awr',
        d: 'diwrnod',
        dd: '%d diwrnod',
        M: 'mis',
        MM: '%d mis',
        y: 'blwyddyn',
        yy: '%d flynedd'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
    // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
    ordinal: function (number) {
        var b = number,
            output = '',
            lookup = [
                '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
                'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
            ];
        if (b > 20) {
            if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                output = 'fed'; // not 30ain, 70ain or 90ain
            } else {
                output = 'ain';
            }
        } else if (b > 0) {
            output = lookup[b];
        }
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return cy;

})));


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Danish [da]
//! author : Ulrik Nielsen : https://github.com/mrbase

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var da = moment.defineLocale('da', {
    months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
    weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH:mm',
        LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
    },
    calendar : {
        sameDay : '[i dag kl.] LT',
        nextDay : '[i morgen kl.] LT',
        nextWeek : 'på dddd [kl.] LT',
        lastDay : '[i går kl.] LT',
        lastWeek : '[i] dddd[s kl.] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : '%s siden',
        s : 'få sekunder',
        m : 'et minut',
        mm : '%d minutter',
        h : 'en time',
        hh : '%d timer',
        d : 'en dag',
        dd : '%d dage',
        M : 'en måned',
        MM : '%d måneder',
        y : 'et år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return da;

})));


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German [de]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eine Minute', 'einer Minute'],
        'h': ['eine Stunde', 'einer Stunde'],
        'd': ['ein Tag', 'einem Tag'],
        'dd': [number + ' Tage', number + ' Tagen'],
        'M': ['ein Monat', 'einem Monat'],
        'MM': [number + ' Monate', number + ' Monaten'],
        'y': ['ein Jahr', 'einem Jahr'],
        'yy': [number + ' Jahre', number + ' Jahren']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var de = moment.defineLocale('de', {
    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH:mm',
        LLLL : 'dddd, D. MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[heute um] LT [Uhr]',
        sameElse: 'L',
        nextDay: '[morgen um] LT [Uhr]',
        nextWeek: 'dddd [um] LT [Uhr]',
        lastDay: '[gestern um] LT [Uhr]',
        lastWeek: '[letzten] dddd [um] LT [Uhr]'
    },
    relativeTime : {
        future : 'in %s',
        past : 'vor %s',
        s : 'ein paar Sekunden',
        m : processRelativeTime,
        mm : '%d Minuten',
        h : processRelativeTime,
        hh : '%d Stunden',
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return de;

})));


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Austria) [de-at]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Martin Groller : https://github.com/MadMG
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eine Minute', 'einer Minute'],
        'h': ['eine Stunde', 'einer Stunde'],
        'd': ['ein Tag', 'einem Tag'],
        'dd': [number + ' Tage', number + ' Tagen'],
        'M': ['ein Monat', 'einem Monat'],
        'MM': [number + ' Monate', number + ' Monaten'],
        'y': ['ein Jahr', 'einem Jahr'],
        'yy': [number + ' Jahre', number + ' Jahren']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var deAt = moment.defineLocale('de-at', {
    months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort : 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH:mm',
        LLLL : 'dddd, D. MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[heute um] LT [Uhr]',
        sameElse: 'L',
        nextDay: '[morgen um] LT [Uhr]',
        nextWeek: 'dddd [um] LT [Uhr]',
        lastDay: '[gestern um] LT [Uhr]',
        lastWeek: '[letzten] dddd [um] LT [Uhr]'
    },
    relativeTime : {
        future : 'in %s',
        past : 'vor %s',
        s : 'ein paar Sekunden',
        m : processRelativeTime,
        mm : '%d Minuten',
        h : processRelativeTime,
        hh : '%d Stunden',
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return deAt;

})));


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Switzerland) [de-ch]
//! author : sschueller : https://github.com/sschueller

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


// based on: https://www.bk.admin.ch/dokumentation/sprachen/04915/05016/index.html?lang=de#

function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eine Minute', 'einer Minute'],
        'h': ['eine Stunde', 'einer Stunde'],
        'd': ['ein Tag', 'einem Tag'],
        'dd': [number + ' Tage', number + ' Tagen'],
        'M': ['ein Monat', 'einem Monat'],
        'MM': [number + ' Monate', number + ' Monaten'],
        'y': ['ein Jahr', 'einem Jahr'],
        'yy': [number + ' Jahre', number + ' Jahren']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var deCh = moment.defineLocale('de-ch', {
    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
    weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT: 'HH.mm',
        LTS: 'HH.mm.ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH.mm',
        LLLL : 'dddd, D. MMMM YYYY HH.mm'
    },
    calendar : {
        sameDay: '[heute um] LT [Uhr]',
        sameElse: 'L',
        nextDay: '[morgen um] LT [Uhr]',
        nextWeek: 'dddd [um] LT [Uhr]',
        lastDay: '[gestern um] LT [Uhr]',
        lastWeek: '[letzten] dddd [um] LT [Uhr]'
    },
    relativeTime : {
        future : 'in %s',
        past : 'vor %s',
        s : 'ein paar Sekunden',
        m : processRelativeTime,
        mm : '%d Minuten',
        h : processRelativeTime,
        hh : '%d Stunden',
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return deCh;

})));


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maldivian [dv]
//! author : Jawish Hameed : https://github.com/jawish

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'ޖެނުއަރީ',
    'ފެބްރުއަރީ',
    'މާރިޗު',
    'އޭޕްރީލު',
    'މޭ',
    'ޖޫން',
    'ޖުލައި',
    'އޯގަސްޓު',
    'ސެޕްޓެމްބަރު',
    'އޮކްޓޯބަރު',
    'ނޮވެމްބަރު',
    'ޑިސެމްބަރު'
];
var weekdays = [
    'އާދިއްތަ',
    'ހޯމަ',
    'އަންގާރަ',
    'ބުދަ',
    'ބުރާސްފަތި',
    'ހުކުރު',
    'ހޮނިހިރު'
];

var dv = moment.defineLocale('dv', {
    months : months,
    monthsShort : months,
    weekdays : weekdays,
    weekdaysShort : weekdays,
    weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
    longDateFormat : {

        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'D/M/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /މކ|މފ/,
    isPM : function (input) {
        return 'މފ' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'މކ';
        } else {
            return 'މފ';
        }
    },
    calendar : {
        sameDay : '[މިއަދު] LT',
        nextDay : '[މާދަމާ] LT',
        nextWeek : 'dddd LT',
        lastDay : '[އިއްޔެ] LT',
        lastWeek : '[ފާއިތުވި] dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ތެރޭގައި %s',
        past : 'ކުރިން %s',
        s : 'ސިކުންތުކޮޅެއް',
        m : 'މިނިޓެއް',
        mm : 'މިނިޓު %d',
        h : 'ގަޑިއިރެއް',
        hh : 'ގަޑިއިރު %d',
        d : 'ދުވަހެއް',
        dd : 'ދުވަސް %d',
        M : 'މަހެއް',
        MM : 'މަސް %d',
        y : 'އަހަރެއް',
        yy : 'އަހަރު %d'
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/,/g, '،');
    },
    week : {
        dow : 7,  // Sunday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return dv;

})));


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Greek [el]
//! author : Aggelos Karalias : https://github.com/mehiel

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
}


var el = moment.defineLocale('el', {
    monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
    monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
    months : function (momentToFormat, format) {
        if (!momentToFormat) {
            return this._monthsNominativeEl;
        } else if (typeof format === 'string' && /D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
            return this._monthsGenitiveEl[momentToFormat.month()];
        } else {
            return this._monthsNominativeEl[momentToFormat.month()];
        }
    },
    monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
    weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
    weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
    weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'μμ' : 'ΜΜ';
        } else {
            return isLower ? 'πμ' : 'ΠΜ';
        }
    },
    isPM : function (input) {
        return ((input + '').toLowerCase()[0] === 'μ');
    },
    meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendarEl : {
        sameDay : '[Σήμερα {}] LT',
        nextDay : '[Αύριο {}] LT',
        nextWeek : 'dddd [{}] LT',
        lastDay : '[Χθες {}] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 6:
                    return '[το προηγούμενο] dddd [{}] LT';
                default:
                    return '[την προηγούμενη] dddd [{}] LT';
            }
        },
        sameElse : 'L'
    },
    calendar : function (key, mom) {
        var output = this._calendarEl[key],
            hours = mom && mom.hours();
        if (isFunction(output)) {
            output = output.apply(mom);
        }
        return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
    },
    relativeTime : {
        future : 'σε %s',
        past : '%s πριν',
        s : 'λίγα δευτερόλεπτα',
        m : 'ένα λεπτό',
        mm : '%d λεπτά',
        h : 'μία ώρα',
        hh : '%d ώρες',
        d : 'μία μέρα',
        dd : '%d μέρες',
        M : 'ένας μήνας',
        MM : '%d μήνες',
        y : 'ένας χρόνος',
        yy : '%d χρόνια'
    },
    dayOfMonthOrdinalParse: /\d{1,2}η/,
    ordinal: '%dη',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4st is the first week of the year.
    }
});

return el;

})));


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Australia) [en-au]
//! author : Jared Morse : https://github.com/jarcoal

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enAu = moment.defineLocale('en-au', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enAu;

})));


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Canada) [en-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enCa = moment.defineLocale('en-ca', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'YYYY-MM-DD',
        LL : 'MMMM D, YYYY',
        LLL : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    }
});

return enCa;

})));


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (United Kingdom) [en-gb]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enGb = moment.defineLocale('en-gb', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enGb;

})));


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Ireland) [en-ie]
//! author : Chris Cartlidge : https://github.com/chriscartlidge

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enIe = moment.defineLocale('en-ie', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enIe;

})));


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (New Zealand) [en-nz]
//! author : Luke McGregor : https://github.com/lukemcgregor

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enNz = moment.defineLocale('en-nz', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enNz;

})));


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Esperanto [eo]
//! author : Colin Dean : https://github.com/colindean
//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
//! comment : miestasmia corrected the translation by colindean

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var eo = moment.defineLocale('eo', {
    months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
    weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
    weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
    weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'D[-a de] MMMM, YYYY',
        LLL : 'D[-a de] MMMM, YYYY HH:mm',
        LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
    },
    meridiemParse: /[ap]\.t\.m/i,
    isPM: function (input) {
        return input.charAt(0).toLowerCase() === 'p';
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'p.t.m.' : 'P.T.M.';
        } else {
            return isLower ? 'a.t.m.' : 'A.T.M.';
        }
    },
    calendar : {
        sameDay : '[Hodiaŭ je] LT',
        nextDay : '[Morgaŭ je] LT',
        nextWeek : 'dddd [je] LT',
        lastDay : '[Hieraŭ je] LT',
        lastWeek : '[pasinta] dddd [je] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'post %s',
        past : 'antaŭ %s',
        s : 'sekundoj',
        m : 'minuto',
        mm : '%d minutoj',
        h : 'horo',
        hh : '%d horoj',
        d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
        dd : '%d tagoj',
        M : 'monato',
        MM : '%d monatoj',
        y : 'jaro',
        yy : '%d jaroj'
    },
    dayOfMonthOrdinalParse: /\d{1,2}a/,
    ordinal : '%da',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return eo;

})));


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish [es]
//! author : Julio Napurí : https://github.com/julionc

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

var es = moment.defineLocale('es', {
    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortDot;
        } else if (/-MMM-/.test(format)) {
            return monthsShort[m.month()];
        } else {
            return monthsShortDot[m.month()];
        }
    },
    monthsRegex : monthsRegex,
    monthsShortRegex : monthsRegex,
    monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
    monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,
    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY H:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
    },
    calendar : {
        sameDay : function () {
            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextDay : function () {
            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastDay : function () {
            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'en %s',
        past : 'hace %s',
        s : 'unos segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'una hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un año',
        yy : '%d años'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return es;

})));


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (Dominican Republic) [es-do]

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

var esDo = moment.defineLocale('es-do', {
    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortDot;
        } else if (/-MMM-/.test(format)) {
            return monthsShort[m.month()];
        } else {
            return monthsShortDot[m.month()];
        }
    },
    monthsRegex: monthsRegex,
    monthsShortRegex: monthsRegex,
    monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
    monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
    monthsParse: monthsParse,
    longMonthsParse: monthsParse,
    shortMonthsParse: monthsParse,
    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY h:mm A',
        LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
    },
    calendar : {
        sameDay : function () {
            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextDay : function () {
            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastDay : function () {
            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'en %s',
        past : 'hace %s',
        s : 'unos segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'una hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un año',
        yy : '%d años'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return esDo;

})));


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (United States) [es-us]
//! author : bustta : https://github.com/bustta

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

var esUs = moment.defineLocale('es-us', {
    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortDot;
        } else if (/-MMM-/.test(format)) {
            return monthsShort[m.month()];
        } else {
            return monthsShortDot[m.month()];
        }
    },
    monthsParseExact : true,
    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'MM/DD/YYYY',
        LL : 'MMMM [de] D [de] YYYY',
        LLL : 'MMMM [de] D [de] YYYY H:mm',
        LLLL : 'dddd, MMMM [de] D [de] YYYY H:mm'
    },
    calendar : {
        sameDay : function () {
            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextDay : function () {
            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastDay : function () {
            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'en %s',
        past : 'hace %s',
        s : 'unos segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'una hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un año',
        yy : '%d años'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return esUs;

})));


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Estonian [et]
//! author : Henry Kehlmann : https://github.com/madhenry
//! improvements : Illimar Tambek : https://github.com/ragulka

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
        'm' : ['ühe minuti', 'üks minut'],
        'mm': [number + ' minuti', number + ' minutit'],
        'h' : ['ühe tunni', 'tund aega', 'üks tund'],
        'hh': [number + ' tunni', number + ' tundi'],
        'd' : ['ühe päeva', 'üks päev'],
        'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
        'MM': [number + ' kuu', number + ' kuud'],
        'y' : ['ühe aasta', 'aasta', 'üks aasta'],
        'yy': [number + ' aasta', number + ' aastat']
    };
    if (withoutSuffix) {
        return format[key][2] ? format[key][2] : format[key][1];
    }
    return isFuture ? format[key][0] : format[key][1];
}

var et = moment.defineLocale('et', {
    months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
    monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
    weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
    weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
    weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
    longDateFormat : {
        LT   : 'H:mm',
        LTS : 'H:mm:ss',
        L    : 'DD.MM.YYYY',
        LL   : 'D. MMMM YYYY',
        LLL  : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[Täna,] LT',
        nextDay  : '[Homme,] LT',
        nextWeek : '[Järgmine] dddd LT',
        lastDay  : '[Eile,] LT',
        lastWeek : '[Eelmine] dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s pärast',
        past   : '%s tagasi',
        s      : processRelativeTime,
        m      : processRelativeTime,
        mm     : processRelativeTime,
        h      : processRelativeTime,
        hh     : processRelativeTime,
        d      : processRelativeTime,
        dd     : '%d päeva',
        M      : processRelativeTime,
        MM     : processRelativeTime,
        y      : processRelativeTime,
        yy     : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return et;

})));


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Basque [eu]
//! author : Eneko Illarramendi : https://github.com/eillarra

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var eu = moment.defineLocale('eu', {
    months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
    monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
    monthsParseExact : true,
    weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
    weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
    weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'YYYY[ko] MMMM[ren] D[a]',
        LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
        LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
        l : 'YYYY-M-D',
        ll : 'YYYY[ko] MMM D[a]',
        lll : 'YYYY[ko] MMM D[a] HH:mm',
        llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
    },
    calendar : {
        sameDay : '[gaur] LT[etan]',
        nextDay : '[bihar] LT[etan]',
        nextWeek : 'dddd LT[etan]',
        lastDay : '[atzo] LT[etan]',
        lastWeek : '[aurreko] dddd LT[etan]',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s barru',
        past : 'duela %s',
        s : 'segundo batzuk',
        m : 'minutu bat',
        mm : '%d minutu',
        h : 'ordu bat',
        hh : '%d ordu',
        d : 'egun bat',
        dd : '%d egun',
        M : 'hilabete bat',
        MM : '%d hilabete',
        y : 'urte bat',
        yy : '%d urte'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return eu;

})));


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Persian [fa]
//! author : Ebrahim Byagowi : https://github.com/ebraminio

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '۱',
    '2': '۲',
    '3': '۳',
    '4': '۴',
    '5': '۵',
    '6': '۶',
    '7': '۷',
    '8': '۸',
    '9': '۹',
    '0': '۰'
};
var numberMap = {
    '۱': '1',
    '۲': '2',
    '۳': '3',
    '۴': '4',
    '۵': '5',
    '۶': '6',
    '۷': '7',
    '۸': '8',
    '۹': '9',
    '۰': '0'
};

var fa = moment.defineLocale('fa', {
    months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
    monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
    weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
    weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
    weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    meridiemParse: /قبل از ظهر|بعد از ظهر/,
    isPM: function (input) {
        return /بعد از ظهر/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'قبل از ظهر';
        } else {
            return 'بعد از ظهر';
        }
    },
    calendar : {
        sameDay : '[امروز ساعت] LT',
        nextDay : '[فردا ساعت] LT',
        nextWeek : 'dddd [ساعت] LT',
        lastDay : '[دیروز ساعت] LT',
        lastWeek : 'dddd [پیش] [ساعت] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'در %s',
        past : '%s پیش',
        s : 'چند ثانیه',
        m : 'یک دقیقه',
        mm : '%d دقیقه',
        h : 'یک ساعت',
        hh : '%d ساعت',
        d : 'یک روز',
        dd : '%d روز',
        M : 'یک ماه',
        MM : '%d ماه',
        y : 'یک سال',
        yy : '%d سال'
    },
    preparse: function (string) {
        return string.replace(/[۰-۹]/g, function (match) {
            return numberMap[match];
        }).replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    dayOfMonthOrdinalParse: /\d{1,2}م/,
    ordinal : '%dم',
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12 // The week that contains Jan 1st is the first week of the year.
    }
});

return fa;

})));


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Finnish [fi]
//! author : Tarmo Aidantausta : https://github.com/bleadof

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' ');
var numbersFuture = [
        'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
        numbersPast[7], numbersPast[8], numbersPast[9]
    ];
function translate(number, withoutSuffix, key, isFuture) {
    var result = '';
    switch (key) {
        case 's':
            return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
        case 'm':
            return isFuture ? 'minuutin' : 'minuutti';
        case 'mm':
            result = isFuture ? 'minuutin' : 'minuuttia';
            break;
        case 'h':
            return isFuture ? 'tunnin' : 'tunti';
        case 'hh':
            result = isFuture ? 'tunnin' : 'tuntia';
            break;
        case 'd':
            return isFuture ? 'päivän' : 'päivä';
        case 'dd':
            result = isFuture ? 'päivän' : 'päivää';
            break;
        case 'M':
            return isFuture ? 'kuukauden' : 'kuukausi';
        case 'MM':
            result = isFuture ? 'kuukauden' : 'kuukautta';
            break;
        case 'y':
            return isFuture ? 'vuoden' : 'vuosi';
        case 'yy':
            result = isFuture ? 'vuoden' : 'vuotta';
            break;
    }
    result = verbalNumber(number, isFuture) + ' ' + result;
    return result;
}
function verbalNumber(number, isFuture) {
    return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
}

var fi = moment.defineLocale('fi', {
    months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
    monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
    weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
    weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
    weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD.MM.YYYY',
        LL : 'Do MMMM[ta] YYYY',
        LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
        LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
        l : 'D.M.YYYY',
        ll : 'Do MMM YYYY',
        lll : 'Do MMM YYYY, [klo] HH.mm',
        llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
    },
    calendar : {
        sameDay : '[tänään] [klo] LT',
        nextDay : '[huomenna] [klo] LT',
        nextWeek : 'dddd [klo] LT',
        lastDay : '[eilen] [klo] LT',
        lastWeek : '[viime] dddd[na] [klo] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s päästä',
        past : '%s sitten',
        s : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fi;

})));


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Faroese [fo]
//! author : Ragnar Johannesen : https://github.com/ragnar123

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var fo = moment.defineLocale('fo', {
    months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
    weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
    weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
    weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D. MMMM, YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Í dag kl.] LT',
        nextDay : '[Í morgin kl.] LT',
        nextWeek : 'dddd [kl.] LT',
        lastDay : '[Í gjár kl.] LT',
        lastWeek : '[síðstu] dddd [kl] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'um %s',
        past : '%s síðani',
        s : 'fá sekund',
        m : 'ein minutt',
        mm : '%d minuttir',
        h : 'ein tími',
        hh : '%d tímar',
        d : 'ein dagur',
        dd : '%d dagar',
        M : 'ein mánaði',
        MM : '%d mánaðir',
        y : 'eitt ár',
        yy : '%d ár'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fo;

})));


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French [fr]
//! author : John Fischer : https://github.com/jfroffice

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var fr = moment.defineLocale('fr', {
    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
    monthsParseExact : true,
    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Aujourd’hui à] LT',
        nextDay : '[Demain à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[Hier à] LT',
        lastWeek : 'dddd [dernier à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dans %s',
        past : 'il y a %s',
        s : 'quelques secondes',
        m : 'une minute',
        mm : '%d minutes',
        h : 'une heure',
        hh : '%d heures',
        d : 'un jour',
        dd : '%d jours',
        M : 'un mois',
        MM : '%d mois',
        y : 'un an',
        yy : '%d ans'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
    ordinal : function (number, period) {
        switch (period) {
            // TODO: Return 'e' when day of month > 1. Move this case inside
            // block for masculine words below.
            // See https://github.com/moment/moment/issues/3375
            case 'D':
                return number + (number === 1 ? 'er' : '');

            // Words with masculine grammatical gender: mois, trimestre, jour
            default:
            case 'M':
            case 'Q':
            case 'DDD':
            case 'd':
                return number + (number === 1 ? 'er' : 'e');

            // Words with feminine grammatical gender: semaine
            case 'w':
            case 'W':
                return number + (number === 1 ? 're' : 'e');
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fr;

})));


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Canada) [fr-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var frCa = moment.defineLocale('fr-ca', {
    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
    monthsParseExact : true,
    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Aujourd’hui à] LT',
        nextDay : '[Demain à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[Hier à] LT',
        lastWeek : 'dddd [dernier à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dans %s',
        past : 'il y a %s',
        s : 'quelques secondes',
        m : 'une minute',
        mm : '%d minutes',
        h : 'une heure',
        hh : '%d heures',
        d : 'un jour',
        dd : '%d jours',
        M : 'un mois',
        MM : '%d mois',
        y : 'un an',
        yy : '%d ans'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
    ordinal : function (number, period) {
        switch (period) {
            // Words with masculine grammatical gender: mois, trimestre, jour
            default:
            case 'M':
            case 'Q':
            case 'D':
            case 'DDD':
            case 'd':
                return number + (number === 1 ? 'er' : 'e');

            // Words with feminine grammatical gender: semaine
            case 'w':
            case 'W':
                return number + (number === 1 ? 're' : 'e');
        }
    }
});

return frCa;

})));


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Switzerland) [fr-ch]
//! author : Gaspard Bucher : https://github.com/gaspard

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var frCh = moment.defineLocale('fr-ch', {
    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
    monthsParseExact : true,
    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Aujourd’hui à] LT',
        nextDay : '[Demain à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[Hier à] LT',
        lastWeek : 'dddd [dernier à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dans %s',
        past : 'il y a %s',
        s : 'quelques secondes',
        m : 'une minute',
        mm : '%d minutes',
        h : 'une heure',
        hh : '%d heures',
        d : 'un jour',
        dd : '%d jours',
        M : 'un mois',
        MM : '%d mois',
        y : 'un an',
        yy : '%d ans'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
    ordinal : function (number, period) {
        switch (period) {
            // Words with masculine grammatical gender: mois, trimestre, jour
            default:
            case 'M':
            case 'Q':
            case 'D':
            case 'DDD':
            case 'd':
                return number + (number === 1 ? 'er' : 'e');

            // Words with feminine grammatical gender: semaine
            case 'w':
            case 'W':
                return number + (number === 1 ? 're' : 'e');
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return frCh;

})));


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Frisian [fy]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_');
var monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');

var fy = moment.defineLocale('fy', {
    months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortWithDots;
        } else if (/-MMM-/.test(format)) {
            return monthsShortWithoutDots[m.month()];
        } else {
            return monthsShortWithDots[m.month()];
        }
    },
    monthsParseExact : true,
    weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
    weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
    weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[hjoed om] LT',
        nextDay: '[moarn om] LT',
        nextWeek: 'dddd [om] LT',
        lastDay: '[juster om] LT',
        lastWeek: '[ôfrûne] dddd [om] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'oer %s',
        past : '%s lyn',
        s : 'in pear sekonden',
        m : 'ien minút',
        mm : '%d minuten',
        h : 'ien oere',
        hh : '%d oeren',
        d : 'ien dei',
        dd : '%d dagen',
        M : 'ien moanne',
        MM : '%d moannen',
        y : 'ien jier',
        yy : '%d jierren'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fy;

})));


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Scottish Gaelic [gd]
//! author : Jon Ashdown : https://github.com/jonashdown

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
];

var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];

var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];

var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];

var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];

var gd = moment.defineLocale('gd', {
    months : months,
    monthsShort : monthsShort,
    monthsParseExact : true,
    weekdays : weekdays,
    weekdaysShort : weekdaysShort,
    weekdaysMin : weekdaysMin,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[An-diugh aig] LT',
        nextDay : '[A-màireach aig] LT',
        nextWeek : 'dddd [aig] LT',
        lastDay : '[An-dè aig] LT',
        lastWeek : 'dddd [seo chaidh] [aig] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ann an %s',
        past : 'bho chionn %s',
        s : 'beagan diogan',
        m : 'mionaid',
        mm : '%d mionaidean',
        h : 'uair',
        hh : '%d uairean',
        d : 'latha',
        dd : '%d latha',
        M : 'mìos',
        MM : '%d mìosan',
        y : 'bliadhna',
        yy : '%d bliadhna'
    },
    dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
    ordinal : function (number) {
        var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return gd;

})));


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Galician [gl]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var gl = moment.defineLocale('gl', {
    months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
    monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY H:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
    },
    calendar : {
        sameDay : function () {
            return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
        },
        nextDay : function () {
            return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
        },
        lastDay : function () {
            return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
        },
        lastWeek : function () {
            return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : function (str) {
            if (str.indexOf('un') === 0) {
                return 'n' + str;
            }
            return 'en ' + str;
        },
        past : 'hai %s',
        s : 'uns segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'unha hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un ano',
        yy : '%d anos'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return gl;

})));


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Konkani Latin script [gom-latn]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        's': ['thodde secondanim', 'thodde second'],
        'm': ['eka mintan', 'ek minute'],
        'mm': [number + ' mintanim', number + ' mintam'],
        'h': ['eka horan', 'ek hor'],
        'hh': [number + ' horanim', number + ' hor'],
        'd': ['eka disan', 'ek dis'],
        'dd': [number + ' disanim', number + ' dis'],
        'M': ['eka mhoinean', 'ek mhoino'],
        'MM': [number + ' mhoineanim', number + ' mhoine'],
        'y': ['eka vorsan', 'ek voros'],
        'yy': [number + ' vorsanim', number + ' vorsam']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var gomLatn = moment.defineLocale('gom-latn', {
    months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
    monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
    weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
    weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'A h:mm [vazta]',
        LTS : 'A h:mm:ss [vazta]',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY A h:mm [vazta]',
        LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
        llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
    },
    calendar : {
        sameDay: '[Aiz] LT',
        nextDay: '[Faleam] LT',
        nextWeek: '[Ieta to] dddd[,] LT',
        lastDay: '[Kal] LT',
        lastWeek: '[Fatlo] dddd[,] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s',
        past : '%s adim',
        s : processRelativeTime,
        m : processRelativeTime,
        mm : processRelativeTime,
        h : processRelativeTime,
        hh : processRelativeTime,
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse : /\d{1,2}(er)/,
    ordinal : function (number, period) {
        switch (period) {
            // the ordinal 'er' only applies to day of the month
            case 'D':
                return number + 'er';
            default:
            case 'M':
            case 'Q':
            case 'DDD':
            case 'd':
            case 'w':
            case 'W':
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    },
    meridiemParse: /rati|sokalli|donparam|sanje/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'rati') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'sokalli') {
            return hour;
        } else if (meridiem === 'donparam') {
            return hour > 12 ? hour : hour + 12;
        } else if (meridiem === 'sanje') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'rati';
        } else if (hour < 12) {
            return 'sokalli';
        } else if (hour < 16) {
            return 'donparam';
        } else if (hour < 20) {
            return 'sanje';
        } else {
            return 'rati';
        }
    }
});

return gomLatn;

})));


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Gujarati [gu]
//! author : Kaushik Thanki : https://github.com/Kaushik1987

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
        '1': '૧',
        '2': '૨',
        '3': '૩',
        '4': '૪',
        '5': '૫',
        '6': '૬',
        '7': '૭',
        '8': '૮',
        '9': '૯',
        '0': '૦'
    };
var numberMap = {
        '૧': '1',
        '૨': '2',
        '૩': '3',
        '૪': '4',
        '૫': '5',
        '૬': '6',
        '૭': '7',
        '૮': '8',
        '૯': '9',
        '૦': '0'
    };

var gu = moment.defineLocale('gu', {
    months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split('_'),
    monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split('_'),
    monthsParseExact: true,
    weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split('_'),
    weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
    weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
    longDateFormat: {
        LT: 'A h:mm વાગ્યે',
        LTS: 'A h:mm:ss વાગ્યે',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
        LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે'
    },
    calendar: {
        sameDay: '[આજ] LT',
        nextDay: '[કાલે] LT',
        nextWeek: 'dddd, LT',
        lastDay: '[ગઇકાલે] LT',
        lastWeek: '[પાછલા] dddd, LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: '%s મા',
        past: '%s પેહલા',
        s: 'અમુક પળો',
        m: 'એક મિનિટ',
        mm: '%d મિનિટ',
        h: 'એક કલાક',
        hh: '%d કલાક',
        d: 'એક દિવસ',
        dd: '%d દિવસ',
        M: 'એક મહિનો',
        MM: '%d મહિનો',
        y: 'એક વર્ષ',
        yy: '%d વર્ષ'
    },
    preparse: function (string) {
        return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
    meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'રાત') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'સવાર') {
            return hour;
        } else if (meridiem === 'બપોર') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'સાંજ') {
            return hour + 12;
        }
    },
    meridiem: function (hour, minute, isLower) {
        if (hour < 4) {
            return 'રાત';
        } else if (hour < 10) {
            return 'સવાર';
        } else if (hour < 17) {
            return 'બપોર';
        } else if (hour < 20) {
            return 'સાંજ';
        } else {
            return 'રાત';
        }
    },
    week: {
        dow: 0, // Sunday is the first day of the week.
        doy: 6 // The week that contains Jan 1st is the first week of the year.
    }
});

return gu;

})));


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hebrew [he]
//! author : Tomer Cohen : https://github.com/tomer
//! author : Moshe Simantov : https://github.com/DevelopmentIL
//! author : Tal Ater : https://github.com/TalAter

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var he = moment.defineLocale('he', {
    months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
    monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
    weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
    weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
    weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [ב]MMMM YYYY',
        LLL : 'D [ב]MMMM YYYY HH:mm',
        LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
        l : 'D/M/YYYY',
        ll : 'D MMM YYYY',
        lll : 'D MMM YYYY HH:mm',
        llll : 'ddd, D MMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[היום ב־]LT',
        nextDay : '[מחר ב־]LT',
        nextWeek : 'dddd [בשעה] LT',
        lastDay : '[אתמול ב־]LT',
        lastWeek : '[ביום] dddd [האחרון בשעה] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'בעוד %s',
        past : 'לפני %s',
        s : 'מספר שניות',
        m : 'דקה',
        mm : '%d דקות',
        h : 'שעה',
        hh : function (number) {
            if (number === 2) {
                return 'שעתיים';
            }
            return number + ' שעות';
        },
        d : 'יום',
        dd : function (number) {
            if (number === 2) {
                return 'יומיים';
            }
            return number + ' ימים';
        },
        M : 'חודש',
        MM : function (number) {
            if (number === 2) {
                return 'חודשיים';
            }
            return number + ' חודשים';
        },
        y : 'שנה',
        yy : function (number) {
            if (number === 2) {
                return 'שנתיים';
            } else if (number % 10 === 0 && number !== 10) {
                return number + ' שנה';
            }
            return number + ' שנים';
        }
    },
    meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
    isPM : function (input) {
        return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 5) {
            return 'לפנות בוקר';
        } else if (hour < 10) {
            return 'בבוקר';
        } else if (hour < 12) {
            return isLower ? 'לפנה"צ' : 'לפני הצהריים';
        } else if (hour < 18) {
            return isLower ? 'אחה"צ' : 'אחרי הצהריים';
        } else {
            return 'בערב';
        }
    }
});

return he;

})));


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hindi [hi]
//! author : Mayank Singhal : https://github.com/mayanksinghal

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '१',
    '2': '२',
    '3': '३',
    '4': '४',
    '5': '५',
    '6': '६',
    '7': '७',
    '8': '८',
    '9': '९',
    '0': '०'
};
var numberMap = {
    '१': '1',
    '२': '2',
    '३': '3',
    '४': '4',
    '५': '5',
    '६': '6',
    '७': '7',
    '८': '8',
    '९': '9',
    '०': '0'
};

var hi = moment.defineLocale('hi', {
    months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
    monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
    monthsParseExact: true,
    weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
    weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
    longDateFormat : {
        LT : 'A h:mm बजे',
        LTS : 'A h:mm:ss बजे',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm बजे',
        LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
    },
    calendar : {
        sameDay : '[आज] LT',
        nextDay : '[कल] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[कल] LT',
        lastWeek : '[पिछले] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s में',
        past : '%s पहले',
        s : 'कुछ ही क्षण',
        m : 'एक मिनट',
        mm : '%d मिनट',
        h : 'एक घंटा',
        hh : '%d घंटे',
        d : 'एक दिन',
        dd : '%d दिन',
        M : 'एक महीने',
        MM : '%d महीने',
        y : 'एक वर्ष',
        yy : '%d वर्ष'
    },
    preparse: function (string) {
        return string.replace(/[१२३४५६७८९०]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    // Hindi notation for meridiems are quite fuzzy in practice. While there exists
    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
    meridiemParse: /रात|सुबह|दोपहर|शाम/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'रात') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'सुबह') {
            return hour;
        } else if (meridiem === 'दोपहर') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'शाम') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'रात';
        } else if (hour < 10) {
            return 'सुबह';
        } else if (hour < 17) {
            return 'दोपहर';
        } else if (hour < 20) {
            return 'शाम';
        } else {
            return 'रात';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return hi;

})));


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Croatian [hr]
//! author : Bojan Marković : https://github.com/bmarkovic

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function translate(number, withoutSuffix, key) {
    var result = number + ' ';
    switch (key) {
        case 'm':
            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
        case 'mm':
            if (number === 1) {
                result += 'minuta';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'minute';
            } else {
                result += 'minuta';
            }
            return result;
        case 'h':
            return withoutSuffix ? 'jedan sat' : 'jednog sata';
        case 'hh':
            if (number === 1) {
                result += 'sat';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'sata';
            } else {
                result += 'sati';
            }
            return result;
        case 'dd':
            if (number === 1) {
                result += 'dan';
            } else {
                result += 'dana';
            }
            return result;
        case 'MM':
            if (number === 1) {
                result += 'mjesec';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'mjeseca';
            } else {
                result += 'mjeseci';
            }
            return result;
        case 'yy':
            if (number === 1) {
                result += 'godina';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'godine';
            } else {
                result += 'godina';
            }
            return result;
    }
}

var hr = moment.defineLocale('hr', {
    months : {
        format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
        standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
    },
    monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
    monthsParseExact: true,
    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[danas u] LT',
        nextDay  : '[sutra u] LT',
        nextWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedjelju] [u] LT';
                case 3:
                    return '[u] [srijedu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[jučer u] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                    return '[prošlu] dddd [u] LT';
                case 6:
                    return '[prošle] [subote] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[prošli] dddd [u] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'prije %s',
        s      : 'par sekundi',
        m      : translate,
        mm     : translate,
        h      : translate,
        hh     : translate,
        d      : 'dan',
        dd     : translate,
        M      : 'mjesec',
        MM     : translate,
        y      : 'godinu',
        yy     : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return hr;

})));


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hungarian [hu]
//! author : Adam Brunner : https://github.com/adambrunner

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
function translate(number, withoutSuffix, key, isFuture) {
    var num = number;
    switch (key) {
        case 's':
            return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
        case 'm':
            return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
        case 'mm':
            return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
        case 'h':
            return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
        case 'hh':
            return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
        case 'd':
            return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
        case 'dd':
            return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
        case 'M':
            return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
        case 'MM':
            return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
        case 'y':
            return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
        case 'yy':
            return num + (isFuture || withoutSuffix ? ' év' : ' éve');
    }
    return '';
}
function week(isFuture) {
    return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
}

var hu = moment.defineLocale('hu', {
    months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
    monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
    weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
    weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
    weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'YYYY.MM.DD.',
        LL : 'YYYY. MMMM D.',
        LLL : 'YYYY. MMMM D. H:mm',
        LLLL : 'YYYY. MMMM D., dddd H:mm'
    },
    meridiemParse: /de|du/i,
    isPM: function (input) {
        return input.charAt(1).toLowerCase() === 'u';
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 12) {
            return isLower === true ? 'de' : 'DE';
        } else {
            return isLower === true ? 'du' : 'DU';
        }
    },
    calendar : {
        sameDay : '[ma] LT[-kor]',
        nextDay : '[holnap] LT[-kor]',
        nextWeek : function () {
            return week.call(this, true);
        },
        lastDay : '[tegnap] LT[-kor]',
        lastWeek : function () {
            return week.call(this, false);
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s múlva',
        past : '%s',
        s : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return hu;

})));


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Armenian [hy-am]
//! author : Armendarabyan : https://github.com/armendarabyan

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var hyAm = moment.defineLocale('hy-am', {
    months : {
        format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
        standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
    },
    monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
    weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
    weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
    weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY թ.',
        LLL : 'D MMMM YYYY թ., HH:mm',
        LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
    },
    calendar : {
        sameDay: '[այսօր] LT',
        nextDay: '[վաղը] LT',
        lastDay: '[երեկ] LT',
        nextWeek: function () {
            return 'dddd [օրը ժամը] LT';
        },
        lastWeek: function () {
            return '[անցած] dddd [օրը ժամը] LT';
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s հետո',
        past : '%s առաջ',
        s : 'մի քանի վայրկյան',
        m : 'րոպե',
        mm : '%d րոպե',
        h : 'ժամ',
        hh : '%d ժամ',
        d : 'օր',
        dd : '%d օր',
        M : 'ամիս',
        MM : '%d ամիս',
        y : 'տարի',
        yy : '%d տարի'
    },
    meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
    isPM: function (input) {
        return /^(ցերեկվա|երեկոյան)$/.test(input);
    },
    meridiem : function (hour) {
        if (hour < 4) {
            return 'գիշերվա';
        } else if (hour < 12) {
            return 'առավոտվա';
        } else if (hour < 17) {
            return 'ցերեկվա';
        } else {
            return 'երեկոյան';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'DDD':
            case 'w':
            case 'W':
            case 'DDDo':
                if (number === 1) {
                    return number + '-ին';
                }
                return number + '-րդ';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return hyAm;

})));


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Indonesian [id]
//! author : Mohammad Satrio Utomo : https://github.com/tyok
//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var id = moment.defineLocale('id', {
    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
    weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
    weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /pagi|siang|sore|malam/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'pagi') {
            return hour;
        } else if (meridiem === 'siang') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'sore' || meridiem === 'malam') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'pagi';
        } else if (hours < 15) {
            return 'siang';
        } else if (hours < 19) {
            return 'sore';
        } else {
            return 'malam';
        }
    },
    calendar : {
        sameDay : '[Hari ini pukul] LT',
        nextDay : '[Besok pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kemarin pukul] LT',
        lastWeek : 'dddd [lalu pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dalam %s',
        past : '%s yang lalu',
        s : 'beberapa detik',
        m : 'semenit',
        mm : '%d menit',
        h : 'sejam',
        hh : '%d jam',
        d : 'sehari',
        dd : '%d hari',
        M : 'sebulan',
        MM : '%d bulan',
        y : 'setahun',
        yy : '%d tahun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return id;

})));


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Icelandic [is]
//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(n) {
    if (n % 100 === 11) {
        return true;
    } else if (n % 10 === 1) {
        return false;
    }
    return true;
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':
            return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
        case 'm':
            return withoutSuffix ? 'mínúta' : 'mínútu';
        case 'mm':
            if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
            } else if (withoutSuffix) {
                return result + 'mínúta';
            }
            return result + 'mínútu';
        case 'hh':
            if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
            }
            return result + 'klukkustund';
        case 'd':
            if (withoutSuffix) {
                return 'dagur';
            }
            return isFuture ? 'dag' : 'degi';
        case 'dd':
            if (plural(number)) {
                if (withoutSuffix) {
                    return result + 'dagar';
                }
                return result + (isFuture ? 'daga' : 'dögum');
            } else if (withoutSuffix) {
                return result + 'dagur';
            }
            return result + (isFuture ? 'dag' : 'degi');
        case 'M':
            if (withoutSuffix) {
                return 'mánuður';
            }
            return isFuture ? 'mánuð' : 'mánuði';
        case 'MM':
            if (plural(number)) {
                if (withoutSuffix) {
                    return result + 'mánuðir';
                }
                return result + (isFuture ? 'mánuði' : 'mánuðum');
            } else if (withoutSuffix) {
                return result + 'mánuður';
            }
            return result + (isFuture ? 'mánuð' : 'mánuði');
        case 'y':
            return withoutSuffix || isFuture ? 'ár' : 'ári';
        case 'yy':
            if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
            }
            return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
    }
}

var is = moment.defineLocale('is', {
    months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
    weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
    weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
    weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY [kl.] H:mm',
        LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
    },
    calendar : {
        sameDay : '[í dag kl.] LT',
        nextDay : '[á morgun kl.] LT',
        nextWeek : 'dddd [kl.] LT',
        lastDay : '[í gær kl.] LT',
        lastWeek : '[síðasta] dddd [kl.] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'eftir %s',
        past : 'fyrir %s síðan',
        s : translate,
        m : translate,
        mm : translate,
        h : 'klukkustund',
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return is;

})));


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Italian [it]
//! author : Lorenzo : https://github.com/aliem
//! author: Mattia Larentis: https://github.com/nostalgiaz

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var it = moment.defineLocale('it', {
    months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
    monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
    weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
    weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
    weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Oggi alle] LT',
        nextDay: '[Domani alle] LT',
        nextWeek: 'dddd [alle] LT',
        lastDay: '[Ieri alle] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[la scorsa] dddd [alle] LT';
                default:
                    return '[lo scorso] dddd [alle] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : function (s) {
            return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
        },
        past : '%s fa',
        s : 'alcuni secondi',
        m : 'un minuto',
        mm : '%d minuti',
        h : 'un\'ora',
        hh : '%d ore',
        d : 'un giorno',
        dd : '%d giorni',
        M : 'un mese',
        MM : '%d mesi',
        y : 'un anno',
        yy : '%d anni'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal: '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return it;

})));


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Japanese [ja]
//! author : LI Long : https://github.com/baryon

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ja = moment.defineLocale('ja', {
    months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
    weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
    weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY/MM/DD',
        LL : 'YYYY年M月D日',
        LLL : 'YYYY年M月D日 HH:mm',
        LLLL : 'YYYY年M月D日 HH:mm dddd',
        l : 'YYYY/MM/DD',
        ll : 'YYYY年M月D日',
        lll : 'YYYY年M月D日 HH:mm',
        llll : 'YYYY年M月D日 HH:mm dddd'
    },
    meridiemParse: /午前|午後/i,
    isPM : function (input) {
        return input === '午後';
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return '午前';
        } else {
            return '午後';
        }
    },
    calendar : {
        sameDay : '[今日] LT',
        nextDay : '[明日] LT',
        nextWeek : '[来週]dddd LT',
        lastDay : '[昨日] LT',
        lastWeek : '[前週]dddd LT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse : /\d{1,2}日/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd':
            case 'D':
            case 'DDD':
                return number + '日';
            default:
                return number;
        }
    },
    relativeTime : {
        future : '%s後',
        past : '%s前',
        s : '数秒',
        m : '1分',
        mm : '%d分',
        h : '1時間',
        hh : '%d時間',
        d : '1日',
        dd : '%d日',
        M : '1ヶ月',
        MM : '%dヶ月',
        y : '1年',
        yy : '%d年'
    }
});

return ja;

})));


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Javanese [jv]
//! author : Rony Lantip : https://github.com/lantip
//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var jv = moment.defineLocale('jv', {
    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
    weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
    weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /enjing|siyang|sonten|ndalu/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'enjing') {
            return hour;
        } else if (meridiem === 'siyang') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'enjing';
        } else if (hours < 15) {
            return 'siyang';
        } else if (hours < 19) {
            return 'sonten';
        } else {
            return 'ndalu';
        }
    },
    calendar : {
        sameDay : '[Dinten puniko pukul] LT',
        nextDay : '[Mbenjang pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kala wingi pukul] LT',
        lastWeek : 'dddd [kepengker pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'wonten ing %s',
        past : '%s ingkang kepengker',
        s : 'sawetawis detik',
        m : 'setunggal menit',
        mm : '%d menit',
        h : 'setunggal jam',
        hh : '%d jam',
        d : 'sedinten',
        dd : '%d dinten',
        M : 'sewulan',
        MM : '%d wulan',
        y : 'setaun',
        yy : '%d taun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return jv;

})));


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Georgian [ka]
//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ka = moment.defineLocale('ka', {
    months : {
        standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
        format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
    },
    monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
    weekdays : {
        standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
        format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
        isFormat: /(წინა|შემდეგ)/
    },
    weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
    weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[დღეს] LT[-ზე]',
        nextDay : '[ხვალ] LT[-ზე]',
        lastDay : '[გუშინ] LT[-ზე]',
        nextWeek : '[შემდეგ] dddd LT[-ზე]',
        lastWeek : '[წინა] dddd LT-ზე',
        sameElse : 'L'
    },
    relativeTime : {
        future : function (s) {
            return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
                s.replace(/ი$/, 'ში') :
                s + 'ში';
        },
        past : function (s) {
            if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
                return s.replace(/(ი|ე)$/, 'ის უკან');
            }
            if ((/წელი/).test(s)) {
                return s.replace(/წელი$/, 'წლის უკან');
            }
        },
        s : 'რამდენიმე წამი',
        m : 'წუთი',
        mm : '%d წუთი',
        h : 'საათი',
        hh : '%d საათი',
        d : 'დღე',
        dd : '%d დღე',
        M : 'თვე',
        MM : '%d თვე',
        y : 'წელი',
        yy : '%d წელი'
    },
    dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
    ordinal : function (number) {
        if (number === 0) {
            return number;
        }
        if (number === 1) {
            return number + '-ლი';
        }
        if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
            return 'მე-' + number;
        }
        return number + '-ე';
    },
    week : {
        dow : 1,
        doy : 7
    }
});

return ka;

})));


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kazakh [kk]
//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var suffixes = {
    0: '-ші',
    1: '-ші',
    2: '-ші',
    3: '-ші',
    4: '-ші',
    5: '-ші',
    6: '-шы',
    7: '-ші',
    8: '-ші',
    9: '-шы',
    10: '-шы',
    20: '-шы',
    30: '-шы',
    40: '-шы',
    50: '-ші',
    60: '-шы',
    70: '-ші',
    80: '-ші',
    90: '-шы',
    100: '-ші'
};

var kk = moment.defineLocale('kk', {
    months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
    monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
    weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
    weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
    weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Бүгін сағат] LT',
        nextDay : '[Ертең сағат] LT',
        nextWeek : 'dddd [сағат] LT',
        lastDay : '[Кеше сағат] LT',
        lastWeek : '[Өткен аптаның] dddd [сағат] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ішінде',
        past : '%s бұрын',
        s : 'бірнеше секунд',
        m : 'бір минут',
        mm : '%d минут',
        h : 'бір сағат',
        hh : '%d сағат',
        d : 'бір күн',
        dd : '%d күн',
        M : 'бір ай',
        MM : '%d ай',
        y : 'бір жыл',
        yy : '%d жыл'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
    ordinal : function (number) {
        var a = number % 10,
            b = number >= 100 ? 100 : null;
        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return kk;

})));


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Cambodian [km]
//! author : Kruy Vanna : https://github.com/kruyvanna

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var km = moment.defineLocale('km', {
    months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
    monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
    weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
    weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
    weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
    longDateFormat: {
        LT: 'HH:mm',
        LTS : 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
        nextDay: '[ស្អែក ម៉ោង] LT',
        nextWeek: 'dddd [ម៉ោង] LT',
        lastDay: '[ម្សិលមិញ ម៉ោង] LT',
        lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: '%sទៀត',
        past: '%sមុន',
        s: 'ប៉ុន្មានវិនាទី',
        m: 'មួយនាទី',
        mm: '%d នាទី',
        h: 'មួយម៉ោង',
        hh: '%d ម៉ោង',
        d: 'មួយថ្ងៃ',
        dd: '%d ថ្ងៃ',
        M: 'មួយខែ',
        MM: '%d ខែ',
        y: 'មួយឆ្នាំ',
        yy: '%d ឆ្នាំ'
    },
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4 // The week that contains Jan 4th is the first week of the year.
    }
});

return km;

})));


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kannada [kn]
//! author : Rajeev Naik : https://github.com/rajeevnaikte

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '೧',
    '2': '೨',
    '3': '೩',
    '4': '೪',
    '5': '೫',
    '6': '೬',
    '7': '೭',
    '8': '೮',
    '9': '೯',
    '0': '೦'
};
var numberMap = {
    '೧': '1',
    '೨': '2',
    '೩': '3',
    '೪': '4',
    '೫': '5',
    '೬': '6',
    '೭': '7',
    '೮': '8',
    '೯': '9',
    '೦': '0'
};

var kn = moment.defineLocale('kn', {
    months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
    monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬ_ಅಕ್ಟೋಬ_ನವೆಂಬ_ಡಿಸೆಂಬ'.split('_'),
    monthsParseExact: true,
    weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
    weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
    weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm',
        LLLL : 'dddd, D MMMM YYYY, A h:mm'
    },
    calendar : {
        sameDay : '[ಇಂದು] LT',
        nextDay : '[ನಾಳೆ] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[ನಿನ್ನೆ] LT',
        lastWeek : '[ಕೊನೆಯ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ನಂತರ',
        past : '%s ಹಿಂದೆ',
        s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
        m : 'ಒಂದು ನಿಮಿಷ',
        mm : '%d ನಿಮಿಷ',
        h : 'ಒಂದು ಗಂಟೆ',
        hh : '%d ಗಂಟೆ',
        d : 'ಒಂದು ದಿನ',
        dd : '%d ದಿನ',
        M : 'ಒಂದು ತಿಂಗಳು',
        MM : '%d ತಿಂಗಳು',
        y : 'ಒಂದು ವರ್ಷ',
        yy : '%d ವರ್ಷ'
    },
    preparse: function (string) {
        return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'ರಾತ್ರಿ') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
            return hour;
        } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'ಸಂಜೆ') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ರಾತ್ರಿ';
        } else if (hour < 10) {
            return 'ಬೆಳಿಗ್ಗೆ';
        } else if (hour < 17) {
            return 'ಮಧ್ಯಾಹ್ನ';
        } else if (hour < 20) {
            return 'ಸಂಜೆ';
        } else {
            return 'ರಾತ್ರಿ';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
    ordinal : function (number) {
        return number + 'ನೇ';
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return kn;

})));


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Korean [ko]
//! author : Kyungwook, Park : https://github.com/kyungw00k
//! author : Jeeeyul Lee <jeeeyul@gmail.com>

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ko = moment.defineLocale('ko', {
    months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
    monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
    weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
    weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
    weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'YYYY.MM.DD',
        LL : 'YYYY년 MMMM D일',
        LLL : 'YYYY년 MMMM D일 A h:mm',
        LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
        l : 'YYYY.MM.DD',
        ll : 'YYYY년 MMMM D일',
        lll : 'YYYY년 MMMM D일 A h:mm',
        llll : 'YYYY년 MMMM D일 dddd A h:mm'
    },
    calendar : {
        sameDay : '오늘 LT',
        nextDay : '내일 LT',
        nextWeek : 'dddd LT',
        lastDay : '어제 LT',
        lastWeek : '지난주 dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s 후',
        past : '%s 전',
        s : '몇 초',
        ss : '%d초',
        m : '1분',
        mm : '%d분',
        h : '한 시간',
        hh : '%d시간',
        d : '하루',
        dd : '%d일',
        M : '한 달',
        MM : '%d달',
        y : '일 년',
        yy : '%d년'
    },
    dayOfMonthOrdinalParse : /\d{1,2}(일|월|주)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd':
            case 'D':
            case 'DDD':
                return number + '일';
            case 'M':
                return number + '월';
            case 'w':
            case 'W':
                return number + '주';
            default:
                return number;
        }
    },
    meridiemParse : /오전|오후/,
    isPM : function (token) {
        return token === '오후';
    },
    meridiem : function (hour, minute, isUpper) {
        return hour < 12 ? '오전' : '오후';
    }
});

return ko;

})));


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kyrgyz [ky]
//! author : Chyngyz Arystan uulu : https://github.com/chyngyz

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';



var suffixes = {
    0: '-чү',
    1: '-чи',
    2: '-чи',
    3: '-чү',
    4: '-чү',
    5: '-чи',
    6: '-чы',
    7: '-чи',
    8: '-чи',
    9: '-чу',
    10: '-чу',
    20: '-чы',
    30: '-чу',
    40: '-чы',
    50: '-чү',
    60: '-чы',
    70: '-чи',
    80: '-чи',
    90: '-чу',
    100: '-чү'
};

var ky = moment.defineLocale('ky', {
    months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
    monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
    weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
    weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
    weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Бүгүн саат] LT',
        nextDay : '[Эртең саат] LT',
        nextWeek : 'dddd [саат] LT',
        lastDay : '[Кече саат] LT',
        lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ичинде',
        past : '%s мурун',
        s : 'бирнече секунд',
        m : 'бир мүнөт',
        mm : '%d мүнөт',
        h : 'бир саат',
        hh : '%d саат',
        d : 'бир күн',
        dd : '%d күн',
        M : 'бир ай',
        MM : '%d ай',
        y : 'бир жыл',
        yy : '%d жыл'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
    ordinal : function (number) {
        var a = number % 10,
            b = number >= 100 ? 100 : null;
        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return ky;

})));


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Luxembourgish [lb]
//! author : mweimerskirch : https://github.com/mweimerskirch
//! author : David Raison : https://github.com/kwisatz

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eng Minutt', 'enger Minutt'],
        'h': ['eng Stonn', 'enger Stonn'],
        'd': ['een Dag', 'engem Dag'],
        'M': ['ee Mount', 'engem Mount'],
        'y': ['ee Joer', 'engem Joer']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}
function processFutureTime(string) {
    var number = string.substr(0, string.indexOf(' '));
    if (eifelerRegelAppliesToNumber(number)) {
        return 'a ' + string;
    }
    return 'an ' + string;
}
function processPastTime(string) {
    var number = string.substr(0, string.indexOf(' '));
    if (eifelerRegelAppliesToNumber(number)) {
        return 'viru ' + string;
    }
    return 'virun ' + string;
}
/**
 * Returns true if the word before the given number loses the '-n' ending.
 * e.g. 'an 10 Deeg' but 'a 5 Deeg'
 *
 * @param number {integer}
 * @returns {boolean}
 */
function eifelerRegelAppliesToNumber(number) {
    number = parseInt(number, 10);
    if (isNaN(number)) {
        return false;
    }
    if (number < 0) {
        // Negative Number --> always true
        return true;
    } else if (number < 10) {
        // Only 1 digit
        if (4 <= number && number <= 7) {
            return true;
        }
        return false;
    } else if (number < 100) {
        // 2 digits
        var lastDigit = number % 10, firstDigit = number / 10;
        if (lastDigit === 0) {
            return eifelerRegelAppliesToNumber(firstDigit);
        }
        return eifelerRegelAppliesToNumber(lastDigit);
    } else if (number < 10000) {
        // 3 or 4 digits --> recursively check first digit
        while (number >= 10) {
            number = number / 10;
        }
        return eifelerRegelAppliesToNumber(number);
    } else {
        // Anything larger than 4 digits: recursively check first n-3 digits
        number = number / 1000;
        return eifelerRegelAppliesToNumber(number);
    }
}

var lb = moment.defineLocale('lb', {
    months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
    weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
    weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm [Auer]',
        LTS: 'H:mm:ss [Auer]',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm [Auer]',
        LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
    },
    calendar: {
        sameDay: '[Haut um] LT',
        sameElse: 'L',
        nextDay: '[Muer um] LT',
        nextWeek: 'dddd [um] LT',
        lastDay: '[Gëschter um] LT',
        lastWeek: function () {
            // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
            switch (this.day()) {
                case 2:
                case 4:
                    return '[Leschten] dddd [um] LT';
                default:
                    return '[Leschte] dddd [um] LT';
            }
        }
    },
    relativeTime : {
        future : processFutureTime,
        past : processPastTime,
        s : 'e puer Sekonnen',
        m : processRelativeTime,
        mm : '%d Minutten',
        h : processRelativeTime,
        hh : '%d Stonnen',
        d : processRelativeTime,
        dd : '%d Deeg',
        M : processRelativeTime,
        MM : '%d Méint',
        y : processRelativeTime,
        yy : '%d Joer'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal: '%d.',
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return lb;

})));


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lao [lo]
//! author : Ryan Hart : https://github.com/ryanhart2

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var lo = moment.defineLocale('lo', {
    months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
    monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
    weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
    weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
    weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
    isPM: function (input) {
        return input === 'ຕອນແລງ';
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ຕອນເຊົ້າ';
        } else {
            return 'ຕອນແລງ';
        }
    },
    calendar : {
        sameDay : '[ມື້ນີ້ເວລາ] LT',
        nextDay : '[ມື້ອື່ນເວລາ] LT',
        nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
        lastDay : '[ມື້ວານນີ້ເວລາ] LT',
        lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ອີກ %s',
        past : '%sຜ່ານມາ',
        s : 'ບໍ່ເທົ່າໃດວິນາທີ',
        m : '1 ນາທີ',
        mm : '%d ນາທີ',
        h : '1 ຊົ່ວໂມງ',
        hh : '%d ຊົ່ວໂມງ',
        d : '1 ມື້',
        dd : '%d ມື້',
        M : '1 ເດືອນ',
        MM : '%d ເດືອນ',
        y : '1 ປີ',
        yy : '%d ປີ'
    },
    dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
    ordinal : function (number) {
        return 'ທີ່' + number;
    }
});

return lo;

})));


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lithuanian [lt]
//! author : Mindaugas Mozūras : https://github.com/mmozuras

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var units = {
    'm' : 'minutė_minutės_minutę',
    'mm': 'minutės_minučių_minutes',
    'h' : 'valanda_valandos_valandą',
    'hh': 'valandos_valandų_valandas',
    'd' : 'diena_dienos_dieną',
    'dd': 'dienos_dienų_dienas',
    'M' : 'mėnuo_mėnesio_mėnesį',
    'MM': 'mėnesiai_mėnesių_mėnesius',
    'y' : 'metai_metų_metus',
    'yy': 'metai_metų_metus'
};
function translateSeconds(number, withoutSuffix, key, isFuture) {
    if (withoutSuffix) {
        return 'kelios sekundės';
    } else {
        return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
    }
}
function translateSingular(number, withoutSuffix, key, isFuture) {
    return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
}
function special(number) {
    return number % 10 === 0 || (number > 10 && number < 20);
}
function forms(key) {
    return units[key].split('_');
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    if (number === 1) {
        return result + translateSingular(number, withoutSuffix, key[0], isFuture);
    } else if (withoutSuffix) {
        return result + (special(number) ? forms(key)[1] : forms(key)[0]);
    } else {
        if (isFuture) {
            return result + forms(key)[1];
        } else {
            return result + (special(number) ? forms(key)[1] : forms(key)[2]);
        }
    }
}
var lt = moment.defineLocale('lt', {
    months : {
        format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
        standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
        isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
    },
    monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
    weekdays : {
        format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
        standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
        isFormat: /dddd HH:mm/
    },
    weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
    weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'YYYY [m.] MMMM D [d.]',
        LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
        LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
        l : 'YYYY-MM-DD',
        ll : 'YYYY [m.] MMMM D [d.]',
        lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
        llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
    },
    calendar : {
        sameDay : '[Šiandien] LT',
        nextDay : '[Rytoj] LT',
        nextWeek : 'dddd LT',
        lastDay : '[Vakar] LT',
        lastWeek : '[Praėjusį] dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'po %s',
        past : 'prieš %s',
        s : translateSeconds,
        m : translateSingular,
        mm : translate,
        h : translateSingular,
        hh : translate,
        d : translateSingular,
        dd : translate,
        M : translateSingular,
        MM : translate,
        y : translateSingular,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}-oji/,
    ordinal : function (number) {
        return number + '-oji';
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return lt;

})));


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Latvian [lv]
//! author : Kristaps Karlsons : https://github.com/skakri
//! author : Jānis Elmeris : https://github.com/JanisE

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var units = {
    'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
    'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
    'h': 'stundas_stundām_stunda_stundas'.split('_'),
    'hh': 'stundas_stundām_stunda_stundas'.split('_'),
    'd': 'dienas_dienām_diena_dienas'.split('_'),
    'dd': 'dienas_dienām_diena_dienas'.split('_'),
    'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
    'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
    'y': 'gada_gadiem_gads_gadi'.split('_'),
    'yy': 'gada_gadiem_gads_gadi'.split('_')
};
/**
 * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
 */
function format(forms, number, withoutSuffix) {
    if (withoutSuffix) {
        // E.g. "21 minūte", "3 minūtes".
        return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
    } else {
        // E.g. "21 minūtes" as in "pēc 21 minūtes".
        // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
        return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
    }
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    return number + ' ' + format(units[key], number, withoutSuffix);
}
function relativeTimeWithSingular(number, withoutSuffix, key) {
    return format(units[key], number, withoutSuffix);
}
function relativeSeconds(number, withoutSuffix) {
    return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
}

var lv = moment.defineLocale('lv', {
    months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
    monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
    weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
    weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
    weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY.',
        LL : 'YYYY. [gada] D. MMMM',
        LLL : 'YYYY. [gada] D. MMMM, HH:mm',
        LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
    },
    calendar : {
        sameDay : '[Šodien pulksten] LT',
        nextDay : '[Rīt pulksten] LT',
        nextWeek : 'dddd [pulksten] LT',
        lastDay : '[Vakar pulksten] LT',
        lastWeek : '[Pagājušā] dddd [pulksten] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'pēc %s',
        past : 'pirms %s',
        s : relativeSeconds,
        m : relativeTimeWithSingular,
        mm : relativeTimeWithPlural,
        h : relativeTimeWithSingular,
        hh : relativeTimeWithPlural,
        d : relativeTimeWithSingular,
        dd : relativeTimeWithPlural,
        M : relativeTimeWithSingular,
        MM : relativeTimeWithPlural,
        y : relativeTimeWithSingular,
        yy : relativeTimeWithPlural
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return lv;

})));


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Montenegrin [me]
//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var translator = {
    words: { //Different grammatical cases
        m: ['jedan minut', 'jednog minuta'],
        mm: ['minut', 'minuta', 'minuta'],
        h: ['jedan sat', 'jednog sata'],
        hh: ['sat', 'sata', 'sati'],
        dd: ['dan', 'dana', 'dana'],
        MM: ['mjesec', 'mjeseca', 'mjeseci'],
        yy: ['godina', 'godine', 'godina']
    },
    correctGrammaticalCase: function (number, wordKey) {
        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
    },
    translate: function (number, withoutSuffix, key) {
        var wordKey = translator.words[key];
        if (key.length === 1) {
            return withoutSuffix ? wordKey[0] : wordKey[1];
        } else {
            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
        }
    }
};

var me = moment.defineLocale('me', {
    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
    monthsParseExact : true,
    weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
    weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm',
        LLLL: 'dddd, D. MMMM YYYY H:mm'
    },
    calendar: {
        sameDay: '[danas u] LT',
        nextDay: '[sjutra u] LT',

        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedjelju] [u] LT';
                case 3:
                    return '[u] [srijedu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[juče u] LT',
        lastWeek : function () {
            var lastWeekDays = [
                '[prošle] [nedjelje] [u] LT',
                '[prošlog] [ponedjeljka] [u] LT',
                '[prošlog] [utorka] [u] LT',
                '[prošle] [srijede] [u] LT',
                '[prošlog] [četvrtka] [u] LT',
                '[prošlog] [petka] [u] LT',
                '[prošle] [subote] [u] LT'
            ];
            return lastWeekDays[this.day()];
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'prije %s',
        s      : 'nekoliko sekundi',
        m      : translator.translate,
        mm     : translator.translate,
        h      : translator.translate,
        hh     : translator.translate,
        d      : 'dan',
        dd     : translator.translate,
        M      : 'mjesec',
        MM     : translator.translate,
        y      : 'godinu',
        yy     : translator.translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return me;

})));


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maori [mi]
//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var mi = moment.defineLocale('mi', {
    months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
    monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
    monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
    monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
    monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
    monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
    weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
    weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
    weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY [i] HH:mm',
        LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
    },
    calendar: {
        sameDay: '[i teie mahana, i] LT',
        nextDay: '[apopo i] LT',
        nextWeek: 'dddd [i] LT',
        lastDay: '[inanahi i] LT',
        lastWeek: 'dddd [whakamutunga i] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'i roto i %s',
        past: '%s i mua',
        s: 'te hēkona ruarua',
        m: 'he meneti',
        mm: '%d meneti',
        h: 'te haora',
        hh: '%d haora',
        d: 'he ra',
        dd: '%d ra',
        M: 'he marama',
        MM: '%d marama',
        y: 'he tau',
        yy: '%d tau'
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal: '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return mi;

})));


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Macedonian [mk]
//! author : Borislav Mickov : https://github.com/B0k0

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var mk = moment.defineLocale('mk', {
    months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
    monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
    weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
    weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
    weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'D.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY H:mm',
        LLLL : 'dddd, D MMMM YYYY H:mm'
    },
    calendar : {
        sameDay : '[Денес во] LT',
        nextDay : '[Утре во] LT',
        nextWeek : '[Во] dddd [во] LT',
        lastDay : '[Вчера во] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 6:
                    return '[Изминатата] dddd [во] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[Изминатиот] dddd [во] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'после %s',
        past : 'пред %s',
        s : 'неколку секунди',
        m : 'минута',
        mm : '%d минути',
        h : 'час',
        hh : '%d часа',
        d : 'ден',
        dd : '%d дена',
        M : 'месец',
        MM : '%d месеци',
        y : 'година',
        yy : '%d години'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
    ordinal : function (number) {
        var lastDigit = number % 10,
            last2Digits = number % 100;
        if (number === 0) {
            return number + '-ев';
        } else if (last2Digits === 0) {
            return number + '-ен';
        } else if (last2Digits > 10 && last2Digits < 20) {
            return number + '-ти';
        } else if (lastDigit === 1) {
            return number + '-ви';
        } else if (lastDigit === 2) {
            return number + '-ри';
        } else if (lastDigit === 7 || lastDigit === 8) {
            return number + '-ми';
        } else {
            return number + '-ти';
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return mk;

})));


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malayalam [ml]
//! author : Floyd Pink : https://github.com/floydpink

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ml = moment.defineLocale('ml', {
    months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
    monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
    monthsParseExact : true,
    weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
    weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
    weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm -നു',
        LTS : 'A h:mm:ss -നു',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm -നു',
        LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
    },
    calendar : {
        sameDay : '[ഇന്ന്] LT',
        nextDay : '[നാളെ] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[ഇന്നലെ] LT',
        lastWeek : '[കഴിഞ്ഞ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s കഴിഞ്ഞ്',
        past : '%s മുൻപ്',
        s : 'അൽപ നിമിഷങ്ങൾ',
        m : 'ഒരു മിനിറ്റ്',
        mm : '%d മിനിറ്റ്',
        h : 'ഒരു മണിക്കൂർ',
        hh : '%d മണിക്കൂർ',
        d : 'ഒരു ദിവസം',
        dd : '%d ദിവസം',
        M : 'ഒരു മാസം',
        MM : '%d മാസം',
        y : 'ഒരു വർഷം',
        yy : '%d വർഷം'
    },
    meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if ((meridiem === 'രാത്രി' && hour >= 4) ||
                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
                meridiem === 'വൈകുന്നേരം') {
            return hour + 12;
        } else {
            return hour;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'രാത്രി';
        } else if (hour < 12) {
            return 'രാവിലെ';
        } else if (hour < 17) {
            return 'ഉച്ച കഴിഞ്ഞ്';
        } else if (hour < 20) {
            return 'വൈകുന്നേരം';
        } else {
            return 'രാത്രി';
        }
    }
});

return ml;

})));


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Marathi [mr]
//! author : Harshad Kale : https://github.com/kalehv
//! author : Vivek Athalye : https://github.com/vnathalye

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '१',
    '2': '२',
    '3': '३',
    '4': '४',
    '5': '५',
    '6': '६',
    '7': '७',
    '8': '८',
    '9': '९',
    '0': '०'
};
var numberMap = {
    '१': '1',
    '२': '2',
    '३': '3',
    '४': '4',
    '५': '5',
    '६': '6',
    '७': '7',
    '८': '8',
    '९': '9',
    '०': '0'
};

function relativeTimeMr(number, withoutSuffix, string, isFuture)
{
    var output = '';
    if (withoutSuffix) {
        switch (string) {
            case 's': output = 'काही सेकंद'; break;
            case 'm': output = 'एक मिनिट'; break;
            case 'mm': output = '%d मिनिटे'; break;
            case 'h': output = 'एक तास'; break;
            case 'hh': output = '%d तास'; break;
            case 'd': output = 'एक दिवस'; break;
            case 'dd': output = '%d दिवस'; break;
            case 'M': output = 'एक महिना'; break;
            case 'MM': output = '%d महिने'; break;
            case 'y': output = 'एक वर्ष'; break;
            case 'yy': output = '%d वर्षे'; break;
        }
    }
    else {
        switch (string) {
            case 's': output = 'काही सेकंदां'; break;
            case 'm': output = 'एका मिनिटा'; break;
            case 'mm': output = '%d मिनिटां'; break;
            case 'h': output = 'एका तासा'; break;
            case 'hh': output = '%d तासां'; break;
            case 'd': output = 'एका दिवसा'; break;
            case 'dd': output = '%d दिवसां'; break;
            case 'M': output = 'एका महिन्या'; break;
            case 'MM': output = '%d महिन्यां'; break;
            case 'y': output = 'एका वर्षा'; break;
            case 'yy': output = '%d वर्षां'; break;
        }
    }
    return output.replace(/%d/i, number);
}

var mr = moment.defineLocale('mr', {
    months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
    monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
    monthsParseExact : true,
    weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
    weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
    longDateFormat : {
        LT : 'A h:mm वाजता',
        LTS : 'A h:mm:ss वाजता',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm वाजता',
        LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
    },
    calendar : {
        sameDay : '[आज] LT',
        nextDay : '[उद्या] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[काल] LT',
        lastWeek: '[मागील] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future: '%sमध्ये',
        past: '%sपूर्वी',
        s: relativeTimeMr,
        m: relativeTimeMr,
        mm: relativeTimeMr,
        h: relativeTimeMr,
        hh: relativeTimeMr,
        d: relativeTimeMr,
        dd: relativeTimeMr,
        M: relativeTimeMr,
        MM: relativeTimeMr,
        y: relativeTimeMr,
        yy: relativeTimeMr
    },
    preparse: function (string) {
        return string.replace(/[१२३४५६७८९०]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'रात्री') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'सकाळी') {
            return hour;
        } else if (meridiem === 'दुपारी') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'सायंकाळी') {
            return hour + 12;
        }
    },
    meridiem: function (hour, minute, isLower) {
        if (hour < 4) {
            return 'रात्री';
        } else if (hour < 10) {
            return 'सकाळी';
        } else if (hour < 17) {
            return 'दुपारी';
        } else if (hour < 20) {
            return 'सायंकाळी';
        } else {
            return 'रात्री';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return mr;

})));


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ms = moment.defineLocale('ms', {
    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /pagi|tengahari|petang|malam/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'pagi') {
            return hour;
        } else if (meridiem === 'tengahari') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'petang' || meridiem === 'malam') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'pagi';
        } else if (hours < 15) {
            return 'tengahari';
        } else if (hours < 19) {
            return 'petang';
        } else {
            return 'malam';
        }
    },
    calendar : {
        sameDay : '[Hari ini pukul] LT',
        nextDay : '[Esok pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kelmarin pukul] LT',
        lastWeek : 'dddd [lepas pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dalam %s',
        past : '%s yang lepas',
        s : 'beberapa saat',
        m : 'seminit',
        mm : '%d minit',
        h : 'sejam',
        hh : '%d jam',
        d : 'sehari',
        dd : '%d hari',
        M : 'sebulan',
        MM : '%d bulan',
        y : 'setahun',
        yy : '%d tahun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return ms;

})));


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms-my]
//! note : DEPRECATED, the correct one is [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var msMy = moment.defineLocale('ms-my', {
    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /pagi|tengahari|petang|malam/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'pagi') {
            return hour;
        } else if (meridiem === 'tengahari') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'petang' || meridiem === 'malam') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'pagi';
        } else if (hours < 15) {
            return 'tengahari';
        } else if (hours < 19) {
            return 'petang';
        } else {
            return 'malam';
        }
    },
    calendar : {
        sameDay : '[Hari ini pukul] LT',
        nextDay : '[Esok pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kelmarin pukul] LT',
        lastWeek : 'dddd [lepas pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dalam %s',
        past : '%s yang lepas',
        s : 'beberapa saat',
        m : 'seminit',
        mm : '%d minit',
        h : 'sejam',
        hh : '%d jam',
        d : 'sehari',
        dd : '%d hari',
        M : 'sebulan',
        MM : '%d bulan',
        y : 'setahun',
        yy : '%d tahun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return msMy;

})));


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Burmese [my]
//! author : Squar team, mysquar.com
//! author : David Rossellat : https://github.com/gholadr
//! author : Tin Aung Lin : https://github.com/thanyawzinmin

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '၁',
    '2': '၂',
    '3': '၃',
    '4': '၄',
    '5': '၅',
    '6': '၆',
    '7': '၇',
    '8': '၈',
    '9': '၉',
    '0': '၀'
};
var numberMap = {
    '၁': '1',
    '၂': '2',
    '၃': '3',
    '၄': '4',
    '၅': '5',
    '၆': '6',
    '၇': '7',
    '၈': '8',
    '၉': '9',
    '၀': '0'
};

var my = moment.defineLocale('my', {
    months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
    monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
    weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
    weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
    weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),

    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[ယနေ.] LT [မှာ]',
        nextDay: '[မနက်ဖြန်] LT [မှာ]',
        nextWeek: 'dddd LT [မှာ]',
        lastDay: '[မနေ.က] LT [မှာ]',
        lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'လာမည့် %s မှာ',
        past: 'လွန်ခဲ့သော %s က',
        s: 'စက္ကန်.အနည်းငယ်',
        m: 'တစ်မိနစ်',
        mm: '%d မိနစ်',
        h: 'တစ်နာရီ',
        hh: '%d နာရီ',
        d: 'တစ်ရက်',
        dd: '%d ရက်',
        M: 'တစ်လ',
        MM: '%d လ',
        y: 'တစ်နှစ်',
        yy: '%d နှစ်'
    },
    preparse: function (string) {
        return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4 // The week that contains Jan 1st is the first week of the year.
    }
});

return my;

})));


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Norwegian Bokmål [nb]
//! authors : Espen Hovlandsdal : https://github.com/rexxars
//!           Sigurd Gartmann : https://github.com/sigurdga

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var nb = moment.defineLocale('nb', {
    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
    monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
    monthsParseExact : true,
    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
    weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY [kl.] HH:mm',
        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
    },
    calendar : {
        sameDay: '[i dag kl.] LT',
        nextDay: '[i morgen kl.] LT',
        nextWeek: 'dddd [kl.] LT',
        lastDay: '[i går kl.] LT',
        lastWeek: '[forrige] dddd [kl.] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : '%s siden',
        s : 'noen sekunder',
        m : 'ett minutt',
        mm : '%d minutter',
        h : 'en time',
        hh : '%d timer',
        d : 'en dag',
        dd : '%d dager',
        M : 'en måned',
        MM : '%d måneder',
        y : 'ett år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nb;

})));


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nepalese [ne]
//! author : suvash : https://github.com/suvash

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '१',
    '2': '२',
    '3': '३',
    '4': '४',
    '5': '५',
    '6': '६',
    '7': '७',
    '8': '८',
    '9': '९',
    '0': '०'
};
var numberMap = {
    '१': '1',
    '२': '2',
    '३': '3',
    '४': '4',
    '५': '5',
    '६': '6',
    '७': '7',
    '८': '8',
    '९': '9',
    '०': '0'
};

var ne = moment.defineLocale('ne', {
    months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
    monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
    monthsParseExact : true,
    weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
    weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
    weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'Aको h:mm बजे',
        LTS : 'Aको h:mm:ss बजे',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, Aको h:mm बजे',
        LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
    },
    preparse: function (string) {
        return string.replace(/[१२३४५६७८९०]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'राति') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'बिहान') {
            return hour;
        } else if (meridiem === 'दिउँसो') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'साँझ') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 3) {
            return 'राति';
        } else if (hour < 12) {
            return 'बिहान';
        } else if (hour < 16) {
            return 'दिउँसो';
        } else if (hour < 20) {
            return 'साँझ';
        } else {
            return 'राति';
        }
    },
    calendar : {
        sameDay : '[आज] LT',
        nextDay : '[भोलि] LT',
        nextWeek : '[आउँदो] dddd[,] LT',
        lastDay : '[हिजो] LT',
        lastWeek : '[गएको] dddd[,] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%sमा',
        past : '%s अगाडि',
        s : 'केही क्षण',
        m : 'एक मिनेट',
        mm : '%d मिनेट',
        h : 'एक घण्टा',
        hh : '%d घण्टा',
        d : 'एक दिन',
        dd : '%d दिन',
        M : 'एक महिना',
        MM : '%d महिना',
        y : 'एक बर्ष',
        yy : '%d बर्ष'
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return ne;

})));


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch [nl]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

var nl = moment.defineLocale('nl', {
    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortWithDots;
        } else if (/-MMM-/.test(format)) {
            return monthsShortWithoutDots[m.month()];
        } else {
            return monthsShortWithDots[m.month()];
        }
    },

    monthsRegex: monthsRegex,
    monthsShortRegex: monthsRegex,
    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,

    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
    weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[vandaag om] LT',
        nextDay: '[morgen om] LT',
        nextWeek: 'dddd [om] LT',
        lastDay: '[gisteren om] LT',
        lastWeek: '[afgelopen] dddd [om] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'over %s',
        past : '%s geleden',
        s : 'een paar seconden',
        m : 'één minuut',
        mm : '%d minuten',
        h : 'één uur',
        hh : '%d uur',
        d : 'één dag',
        dd : '%d dagen',
        M : 'één maand',
        MM : '%d maanden',
        y : 'één jaar',
        yy : '%d jaar'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nl;

})));


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch (Belgium) [nl-be]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

var nlBe = moment.defineLocale('nl-be', {
    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortWithDots;
        } else if (/-MMM-/.test(format)) {
            return monthsShortWithoutDots[m.month()];
        } else {
            return monthsShortWithDots[m.month()];
        }
    },

    monthsRegex: monthsRegex,
    monthsShortRegex: monthsRegex,
    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,

    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
    weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[vandaag om] LT',
        nextDay: '[morgen om] LT',
        nextWeek: 'dddd [om] LT',
        lastDay: '[gisteren om] LT',
        lastWeek: '[afgelopen] dddd [om] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'over %s',
        past : '%s geleden',
        s : 'een paar seconden',
        m : 'één minuut',
        mm : '%d minuten',
        h : 'één uur',
        hh : '%d uur',
        d : 'één dag',
        dd : '%d dagen',
        M : 'één maand',
        MM : '%d maanden',
        y : 'één jaar',
        yy : '%d jaar'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nlBe;

})));


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nynorsk [nn]
//! author : https://github.com/mechuwind

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var nn = moment.defineLocale('nn', {
    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
    weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
    weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
    weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY [kl.] H:mm',
        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
    },
    calendar : {
        sameDay: '[I dag klokka] LT',
        nextDay: '[I morgon klokka] LT',
        nextWeek: 'dddd [klokka] LT',
        lastDay: '[I går klokka] LT',
        lastWeek: '[Føregåande] dddd [klokka] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : '%s sidan',
        s : 'nokre sekund',
        m : 'eit minutt',
        mm : '%d minutt',
        h : 'ein time',
        hh : '%d timar',
        d : 'ein dag',
        dd : '%d dagar',
        M : 'ein månad',
        MM : '%d månader',
        y : 'eit år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nn;

})));


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Punjabi (India) [pa-in]
//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '੧',
    '2': '੨',
    '3': '੩',
    '4': '੪',
    '5': '੫',
    '6': '੬',
    '7': '੭',
    '8': '੮',
    '9': '੯',
    '0': '੦'
};
var numberMap = {
    '੧': '1',
    '੨': '2',
    '੩': '3',
    '੪': '4',
    '੫': '5',
    '੬': '6',
    '੭': '7',
    '੮': '8',
    '੯': '9',
    '੦': '0'
};

var paIn = moment.defineLocale('pa-in', {
    // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
    months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
    monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
    weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
    weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
    weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm ਵਜੇ',
        LTS : 'A h:mm:ss ਵਜੇ',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
        LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
    },
    calendar : {
        sameDay : '[ਅਜ] LT',
        nextDay : '[ਕਲ] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[ਕਲ] LT',
        lastWeek : '[ਪਿਛਲੇ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ਵਿੱਚ',
        past : '%s ਪਿਛਲੇ',
        s : 'ਕੁਝ ਸਕਿੰਟ',
        m : 'ਇਕ ਮਿੰਟ',
        mm : '%d ਮਿੰਟ',
        h : 'ਇੱਕ ਘੰਟਾ',
        hh : '%d ਘੰਟੇ',
        d : 'ਇੱਕ ਦਿਨ',
        dd : '%d ਦਿਨ',
        M : 'ਇੱਕ ਮਹੀਨਾ',
        MM : '%d ਮਹੀਨੇ',
        y : 'ਇੱਕ ਸਾਲ',
        yy : '%d ਸਾਲ'
    },
    preparse: function (string) {
        return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
    meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'ਰਾਤ') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'ਸਵੇਰ') {
            return hour;
        } else if (meridiem === 'ਦੁਪਹਿਰ') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'ਸ਼ਾਮ') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ਰਾਤ';
        } else if (hour < 10) {
            return 'ਸਵੇਰ';
        } else if (hour < 17) {
            return 'ਦੁਪਹਿਰ';
        } else if (hour < 20) {
            return 'ਸ਼ਾਮ';
        } else {
            return 'ਰਾਤ';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return paIn;

})));


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Polish [pl]
//! author : Rafal Hirsz : https://github.com/evoL

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_');
var monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
function plural(n) {
    return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
}
function translate(number, withoutSuffix, key) {
    var result = number + ' ';
    switch (key) {
        case 'm':
            return withoutSuffix ? 'minuta' : 'minutę';
        case 'mm':
            return result + (plural(number) ? 'minuty' : 'minut');
        case 'h':
            return withoutSuffix  ? 'godzina'  : 'godzinę';
        case 'hh':
            return result + (plural(number) ? 'godziny' : 'godzin');
        case 'MM':
            return result + (plural(number) ? 'miesiące' : 'miesięcy');
        case 'yy':
            return result + (plural(number) ? 'lata' : 'lat');
    }
}

var pl = moment.defineLocale('pl', {
    months : function (momentToFormat, format) {
        if (!momentToFormat) {
            return monthsNominative;
        } else if (format === '') {
            // Hack: if format empty we know this is used to generate
            // RegExp by moment. Give then back both valid forms of months
            // in RegExp ready format.
            return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
        } else if (/D MMMM/.test(format)) {
            return monthsSubjective[momentToFormat.month()];
        } else {
            return monthsNominative[momentToFormat.month()];
        }
    },
    monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
    weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
    weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
    weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Dziś o] LT',
        nextDay: '[Jutro o] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[W niedzielę o] LT';

                case 2:
                    return '[We wtorek o] LT';

                case 3:
                    return '[W środę o] LT';

                case 6:
                    return '[W sobotę o] LT';

                default:
                    return '[W] dddd [o] LT';
            }
        },
        lastDay: '[Wczoraj o] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[W zeszłą niedzielę o] LT';
                case 3:
                    return '[W zeszłą środę o] LT';
                case 6:
                    return '[W zeszłą sobotę o] LT';
                default:
                    return '[W zeszły] dddd [o] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'za %s',
        past : '%s temu',
        s : 'kilka sekund',
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : '1 dzień',
        dd : '%d dni',
        M : 'miesiąc',
        MM : translate,
        y : 'rok',
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return pl;

})));


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese [pt]
//! author : Jefferson : https://github.com/jalex79

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var pt = moment.defineLocale('pt', {
    months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
    monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY HH:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Hoje às] LT',
        nextDay: '[Amanhã às] LT',
        nextWeek: 'dddd [às] LT',
        lastDay: '[Ontem às] LT',
        lastWeek: function () {
            return (this.day() === 0 || this.day() === 6) ?
                '[Último] dddd [às] LT' : // Saturday + Sunday
                '[Última] dddd [às] LT'; // Monday - Friday
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'em %s',
        past : 'há %s',
        s : 'segundos',
        m : 'um minuto',
        mm : '%d minutos',
        h : 'uma hora',
        hh : '%d horas',
        d : 'um dia',
        dd : '%d dias',
        M : 'um mês',
        MM : '%d meses',
        y : 'um ano',
        yy : '%d anos'
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return pt;

})));


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese (Brazil) [pt-br]
//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ptBr = moment.defineLocale('pt-br', {
    months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
    monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
    },
    calendar : {
        sameDay: '[Hoje às] LT',
        nextDay: '[Amanhã às] LT',
        nextWeek: 'dddd [às] LT',
        lastDay: '[Ontem às] LT',
        lastWeek: function () {
            return (this.day() === 0 || this.day() === 6) ?
                '[Último] dddd [às] LT' : // Saturday + Sunday
                '[Última] dddd [às] LT'; // Monday - Friday
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'em %s',
        past : '%s atrás',
        s : 'poucos segundos',
        ss : '%d segundos',
        m : 'um minuto',
        mm : '%d minutos',
        h : 'uma hora',
        hh : '%d horas',
        d : 'um dia',
        dd : '%d dias',
        M : 'um mês',
        MM : '%d meses',
        y : 'um ano',
        yy : '%d anos'
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal : '%dº'
});

return ptBr;

})));


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Romanian [ro]
//! author : Vlad Gurdiga : https://github.com/gurdiga
//! author : Valentin Agachi : https://github.com/avaly

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
            'mm': 'minute',
            'hh': 'ore',
            'dd': 'zile',
            'MM': 'luni',
            'yy': 'ani'
        },
        separator = ' ';
    if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
        separator = ' de ';
    }
    return number + separator + format[key];
}

var ro = moment.defineLocale('ro', {
    months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
    monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
    weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
    weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY H:mm',
        LLLL : 'dddd, D MMMM YYYY H:mm'
    },
    calendar : {
        sameDay: '[azi la] LT',
        nextDay: '[mâine la] LT',
        nextWeek: 'dddd [la] LT',
        lastDay: '[ieri la] LT',
        lastWeek: '[fosta] dddd [la] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'peste %s',
        past : '%s în urmă',
        s : 'câteva secunde',
        m : 'un minut',
        mm : relativeTimeWithPlural,
        h : 'o oră',
        hh : relativeTimeWithPlural,
        d : 'o zi',
        dd : relativeTimeWithPlural,
        M : 'o lună',
        MM : relativeTimeWithPlural,
        y : 'un an',
        yy : relativeTimeWithPlural
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return ro;

})));


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Russian [ru]
//! author : Viktorminator : https://github.com/Viktorminator
//! Author : Menelion Elensúle : https://github.com/Oire
//! author : Коренберг Марк : https://github.com/socketpair

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(word, num) {
    var forms = word.split('_');
    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
        'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
        'hh': 'час_часа_часов',
        'dd': 'день_дня_дней',
        'MM': 'месяц_месяца_месяцев',
        'yy': 'год_года_лет'
    };
    if (key === 'm') {
        return withoutSuffix ? 'минута' : 'минуту';
    }
    else {
        return number + ' ' + plural(format[key], +number);
    }
}
var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];

// http://new.gramota.ru/spravka/rules/139-prop : § 103
// Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
// CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
var ru = moment.defineLocale('ru', {
    months : {
        format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
        standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
    },
    monthsShort : {
        // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
        format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
        standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
    },
    weekdays : {
        standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
        format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
        isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
    },
    weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
    weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,

    // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
    monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

    // копия предыдущего
    monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

    // полные названия с падежами
    monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

    // Выражение, которое соотвествует только сокращённым формам
    monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY г.',
        LLL : 'D MMMM YYYY г., HH:mm',
        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
    },
    calendar : {
        sameDay: '[Сегодня в] LT',
        nextDay: '[Завтра в] LT',
        lastDay: '[Вчера в] LT',
        nextWeek: function (now) {
            if (now.week() !== this.week()) {
                switch (this.day()) {
                    case 0:
                        return '[В следующее] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[В следующий] dddd [в] LT';
                    case 3:
                    case 5:
                    case 6:
                        return '[В следующую] dddd [в] LT';
                }
            } else {
                if (this.day() === 2) {
                    return '[Во] dddd [в] LT';
                } else {
                    return '[В] dddd [в] LT';
                }
            }
        },
        lastWeek: function (now) {
            if (now.week() !== this.week()) {
                switch (this.day()) {
                    case 0:
                        return '[В прошлое] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[В прошлый] dddd [в] LT';
                    case 3:
                    case 5:
                    case 6:
                        return '[В прошлую] dddd [в] LT';
                }
            } else {
                if (this.day() === 2) {
                    return '[Во] dddd [в] LT';
                } else {
                    return '[В] dddd [в] LT';
                }
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'через %s',
        past : '%s назад',
        s : 'несколько секунд',
        m : relativeTimeWithPlural,
        mm : relativeTimeWithPlural,
        h : 'час',
        hh : relativeTimeWithPlural,
        d : 'день',
        dd : relativeTimeWithPlural,
        M : 'месяц',
        MM : relativeTimeWithPlural,
        y : 'год',
        yy : relativeTimeWithPlural
    },
    meridiemParse: /ночи|утра|дня|вечера/i,
    isPM : function (input) {
        return /^(дня|вечера)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ночи';
        } else if (hour < 12) {
            return 'утра';
        } else if (hour < 17) {
            return 'дня';
        } else {
            return 'вечера';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'M':
            case 'd':
            case 'DDD':
                return number + '-й';
            case 'D':
                return number + '-го';
            case 'w':
            case 'W':
                return number + '-я';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return ru;

})));


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sindhi [sd]
//! author : Narain Sagar : https://github.com/narainsagar

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'جنوري',
    'فيبروري',
    'مارچ',
    'اپريل',
    'مئي',
    'جون',
    'جولاءِ',
    'آگسٽ',
    'سيپٽمبر',
    'آڪٽوبر',
    'نومبر',
    'ڊسمبر'
];
var days = [
    'آچر',
    'سومر',
    'اڱارو',
    'اربع',
    'خميس',
    'جمع',
    'ڇنڇر'
];

var sd = moment.defineLocale('sd', {
    months : months,
    monthsShort : months,
    weekdays : days,
    weekdaysShort : days,
    weekdaysMin : days,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd، D MMMM YYYY HH:mm'
    },
    meridiemParse: /صبح|شام/,
    isPM : function (input) {
        return 'شام' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'صبح';
        }
        return 'شام';
    },
    calendar : {
        sameDay : '[اڄ] LT',
        nextDay : '[سڀاڻي] LT',
        nextWeek : 'dddd [اڳين هفتي تي] LT',
        lastDay : '[ڪالهه] LT',
        lastWeek : '[گزريل هفتي] dddd [تي] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s پوء',
        past : '%s اڳ',
        s : 'چند سيڪنڊ',
        m : 'هڪ منٽ',
        mm : '%d منٽ',
        h : 'هڪ ڪلاڪ',
        hh : '%d ڪلاڪ',
        d : 'هڪ ڏينهن',
        dd : '%d ڏينهن',
        M : 'هڪ مهينو',
        MM : '%d مهينا',
        y : 'هڪ سال',
        yy : '%d سال'
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/,/g, '،');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sd;

})));


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Northern Sami [se]
//! authors : Bård Rolstad Henriksen : https://github.com/karamell

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';



var se = moment.defineLocale('se', {
    months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
    monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
    weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
    weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
    weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'MMMM D. [b.] YYYY',
        LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
        LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
    },
    calendar : {
        sameDay: '[otne ti] LT',
        nextDay: '[ihttin ti] LT',
        nextWeek: 'dddd [ti] LT',
        lastDay: '[ikte ti] LT',
        lastWeek: '[ovddit] dddd [ti] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s geažes',
        past : 'maŋit %s',
        s : 'moadde sekunddat',
        m : 'okta minuhta',
        mm : '%d minuhtat',
        h : 'okta diimmu',
        hh : '%d diimmut',
        d : 'okta beaivi',
        dd : '%d beaivvit',
        M : 'okta mánnu',
        MM : '%d mánut',
        y : 'okta jahki',
        yy : '%d jagit'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return se;

})));


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sinhalese [si]
//! author : Sampath Sitinamaluwa : https://github.com/sampathsris

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


/*jshint -W100*/
var si = moment.defineLocale('si', {
    months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
    monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
    weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
    weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
    weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'a h:mm',
        LTS : 'a h:mm:ss',
        L : 'YYYY/MM/DD',
        LL : 'YYYY MMMM D',
        LLL : 'YYYY MMMM D, a h:mm',
        LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
    },
    calendar : {
        sameDay : '[අද] LT[ට]',
        nextDay : '[හෙට] LT[ට]',
        nextWeek : 'dddd LT[ට]',
        lastDay : '[ඊයේ] LT[ට]',
        lastWeek : '[පසුගිය] dddd LT[ට]',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%sකින්',
        past : '%sකට පෙර',
        s : 'තත්පර කිහිපය',
        m : 'මිනිත්තුව',
        mm : 'මිනිත්තු %d',
        h : 'පැය',
        hh : 'පැය %d',
        d : 'දිනය',
        dd : 'දින %d',
        M : 'මාසය',
        MM : 'මාස %d',
        y : 'වසර',
        yy : 'වසර %d'
    },
    dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
    ordinal : function (number) {
        return number + ' වැනි';
    },
    meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
    isPM : function (input) {
        return input === 'ප.ව.' || input === 'පස් වරු';
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'ප.ව.' : 'පස් වරු';
        } else {
            return isLower ? 'පෙ.ව.' : 'පෙර වරු';
        }
    }
});

return si;

})));


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovak [sk]
//! author : Martin Minka : https://github.com/k2s
//! based on work of petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_');
var monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
function plural(n) {
    return (n > 1) && (n < 5);
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':  // a few seconds / in a few seconds / a few seconds ago
            return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
        case 'm':  // a minute / in a minute / a minute ago
            return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'minúty' : 'minút');
            } else {
                return result + 'minútami';
            }
            break;
        case 'h':  // an hour / in an hour / an hour ago
            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
        case 'hh': // 9 hours / in 9 hours / 9 hours ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'hodiny' : 'hodín');
            } else {
                return result + 'hodinami';
            }
            break;
        case 'd':  // a day / in a day / a day ago
            return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
        case 'dd': // 9 days / in 9 days / 9 days ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'dni' : 'dní');
            } else {
                return result + 'dňami';
            }
            break;
        case 'M':  // a month / in a month / a month ago
            return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
        case 'MM': // 9 months / in 9 months / 9 months ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'mesiace' : 'mesiacov');
            } else {
                return result + 'mesiacmi';
            }
            break;
        case 'y':  // a year / in a year / a year ago
            return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
        case 'yy': // 9 years / in 9 years / 9 years ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'roky' : 'rokov');
            } else {
                return result + 'rokmi';
            }
            break;
    }
}

var sk = moment.defineLocale('sk', {
    months : months,
    monthsShort : monthsShort,
    weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
    weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
    weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
    longDateFormat : {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay: '[dnes o] LT',
        nextDay: '[zajtra o] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[v nedeľu o] LT';
                case 1:
                case 2:
                    return '[v] dddd [o] LT';
                case 3:
                    return '[v stredu o] LT';
                case 4:
                    return '[vo štvrtok o] LT';
                case 5:
                    return '[v piatok o] LT';
                case 6:
                    return '[v sobotu o] LT';
            }
        },
        lastDay: '[včera o] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[minulú nedeľu o] LT';
                case 1:
                case 2:
                    return '[minulý] dddd [o] LT';
                case 3:
                    return '[minulú stredu o] LT';
                case 4:
                case 5:
                    return '[minulý] dddd [o] LT';
                case 6:
                    return '[minulú sobotu o] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'za %s',
        past : 'pred %s',
        s : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sk;

})));


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovenian [sl]
//! author : Robert Sedovšek : https://github.com/sedovsek

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':
            return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
        case 'm':
            return withoutSuffix ? 'ena minuta' : 'eno minuto';
        case 'mm':
            if (number === 1) {
                result += withoutSuffix ? 'minuta' : 'minuto';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'minute' : 'minutami';
            } else {
                result += withoutSuffix || isFuture ? 'minut' : 'minutami';
            }
            return result;
        case 'h':
            return withoutSuffix ? 'ena ura' : 'eno uro';
        case 'hh':
            if (number === 1) {
                result += withoutSuffix ? 'ura' : 'uro';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'uri' : 'urama';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'ure' : 'urami';
            } else {
                result += withoutSuffix || isFuture ? 'ur' : 'urami';
            }
            return result;
        case 'd':
            return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
        case 'dd':
            if (number === 1) {
                result += withoutSuffix || isFuture ? 'dan' : 'dnem';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
            } else {
                result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
            }
            return result;
        case 'M':
            return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
        case 'MM':
            if (number === 1) {
                result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
            } else {
                result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
            }
            return result;
        case 'y':
            return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
        case 'yy':
            if (number === 1) {
                result += withoutSuffix || isFuture ? 'leto' : 'letom';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'leti' : 'letoma';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'leta' : 'leti';
            } else {
                result += withoutSuffix || isFuture ? 'let' : 'leti';
            }
            return result;
    }
}

var sl = moment.defineLocale('sl', {
    months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
    weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
    weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[danes ob] LT',
        nextDay  : '[jutri ob] LT',

        nextWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[v] [nedeljo] [ob] LT';
                case 3:
                    return '[v] [sredo] [ob] LT';
                case 6:
                    return '[v] [soboto] [ob] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[v] dddd [ob] LT';
            }
        },
        lastDay  : '[včeraj ob] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[prejšnjo] [nedeljo] [ob] LT';
                case 3:
                    return '[prejšnjo] [sredo] [ob] LT';
                case 6:
                    return '[prejšnjo] [soboto] [ob] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[prejšnji] dddd [ob] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'čez %s',
        past   : 'pred %s',
        s      : processRelativeTime,
        m      : processRelativeTime,
        mm     : processRelativeTime,
        h      : processRelativeTime,
        hh     : processRelativeTime,
        d      : processRelativeTime,
        dd     : processRelativeTime,
        M      : processRelativeTime,
        MM     : processRelativeTime,
        y      : processRelativeTime,
        yy     : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return sl;

})));


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Albanian [sq]
//! author : Flakërim Ismani : https://github.com/flakerimi
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Oerd Cukalla : https://github.com/oerd

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var sq = moment.defineLocale('sq', {
    months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
    monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
    weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
    weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
    weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
    weekdaysParseExact : true,
    meridiemParse: /PD|MD/,
    isPM: function (input) {
        return input.charAt(0) === 'M';
    },
    meridiem : function (hours, minutes, isLower) {
        return hours < 12 ? 'PD' : 'MD';
    },
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Sot në] LT',
        nextDay : '[Nesër në] LT',
        nextWeek : 'dddd [në] LT',
        lastDay : '[Dje në] LT',
        lastWeek : 'dddd [e kaluar në] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'në %s',
        past : '%s më parë',
        s : 'disa sekonda',
        m : 'një minutë',
        mm : '%d minuta',
        h : 'një orë',
        hh : '%d orë',
        d : 'një ditë',
        dd : '%d ditë',
        M : 'një muaj',
        MM : '%d muaj',
        y : 'një vit',
        yy : '%d vite'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sq;

})));


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian [sr]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var translator = {
    words: { //Different grammatical cases
        m: ['jedan minut', 'jedne minute'],
        mm: ['minut', 'minute', 'minuta'],
        h: ['jedan sat', 'jednog sata'],
        hh: ['sat', 'sata', 'sati'],
        dd: ['dan', 'dana', 'dana'],
        MM: ['mesec', 'meseca', 'meseci'],
        yy: ['godina', 'godine', 'godina']
    },
    correctGrammaticalCase: function (number, wordKey) {
        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
    },
    translate: function (number, withoutSuffix, key) {
        var wordKey = translator.words[key];
        if (key.length === 1) {
            return withoutSuffix ? wordKey[0] : wordKey[1];
        } else {
            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
        }
    }
};

var sr = moment.defineLocale('sr', {
    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
    weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm',
        LLLL: 'dddd, D. MMMM YYYY H:mm'
    },
    calendar: {
        sameDay: '[danas u] LT',
        nextDay: '[sutra u] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedelju] [u] LT';
                case 3:
                    return '[u] [sredu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[juče u] LT',
        lastWeek : function () {
            var lastWeekDays = [
                '[prošle] [nedelje] [u] LT',
                '[prošlog] [ponedeljka] [u] LT',
                '[prošlog] [utorka] [u] LT',
                '[prošle] [srede] [u] LT',
                '[prošlog] [četvrtka] [u] LT',
                '[prošlog] [petka] [u] LT',
                '[prošle] [subote] [u] LT'
            ];
            return lastWeekDays[this.day()];
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'pre %s',
        s      : 'nekoliko sekundi',
        m      : translator.translate,
        mm     : translator.translate,
        h      : translator.translate,
        hh     : translator.translate,
        d      : 'dan',
        dd     : translator.translate,
        M      : 'mesec',
        MM     : translator.translate,
        y      : 'godinu',
        yy     : translator.translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return sr;

})));


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian Cyrillic [sr-cyrl]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var translator = {
    words: { //Different grammatical cases
        m: ['један минут', 'једне минуте'],
        mm: ['минут', 'минуте', 'минута'],
        h: ['један сат', 'једног сата'],
        hh: ['сат', 'сата', 'сати'],
        dd: ['дан', 'дана', 'дана'],
        MM: ['месец', 'месеца', 'месеци'],
        yy: ['година', 'године', 'година']
    },
    correctGrammaticalCase: function (number, wordKey) {
        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
    },
    translate: function (number, withoutSuffix, key) {
        var wordKey = translator.words[key];
        if (key.length === 1) {
            return withoutSuffix ? wordKey[0] : wordKey[1];
        } else {
            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
        }
    }
};

var srCyrl = moment.defineLocale('sr-cyrl', {
    months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
    monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
    monthsParseExact: true,
    weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
    weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
    weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm',
        LLLL: 'dddd, D. MMMM YYYY H:mm'
    },
    calendar: {
        sameDay: '[данас у] LT',
        nextDay: '[сутра у] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[у] [недељу] [у] LT';
                case 3:
                    return '[у] [среду] [у] LT';
                case 6:
                    return '[у] [суботу] [у] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[у] dddd [у] LT';
            }
        },
        lastDay  : '[јуче у] LT',
        lastWeek : function () {
            var lastWeekDays = [
                '[прошле] [недеље] [у] LT',
                '[прошлог] [понедељка] [у] LT',
                '[прошлог] [уторка] [у] LT',
                '[прошле] [среде] [у] LT',
                '[прошлог] [четвртка] [у] LT',
                '[прошлог] [петка] [у] LT',
                '[прошле] [суботе] [у] LT'
            ];
            return lastWeekDays[this.day()];
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'за %s',
        past   : 'пре %s',
        s      : 'неколико секунди',
        m      : translator.translate,
        mm     : translator.translate,
        h      : translator.translate,
        hh     : translator.translate,
        d      : 'дан',
        dd     : translator.translate,
        M      : 'месец',
        MM     : translator.translate,
        y      : 'годину',
        yy     : translator.translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return srCyrl;

})));


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : siSwati [ss]
//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';



var ss = moment.defineLocale('ss', {
    months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
    monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
    weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
    weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
    weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Namuhla nga] LT',
        nextDay : '[Kusasa nga] LT',
        nextWeek : 'dddd [nga] LT',
        lastDay : '[Itolo nga] LT',
        lastWeek : 'dddd [leliphelile] [nga] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'nga %s',
        past : 'wenteka nga %s',
        s : 'emizuzwana lomcane',
        m : 'umzuzu',
        mm : '%d emizuzu',
        h : 'lihora',
        hh : '%d emahora',
        d : 'lilanga',
        dd : '%d emalanga',
        M : 'inyanga',
        MM : '%d tinyanga',
        y : 'umnyaka',
        yy : '%d iminyaka'
    },
    meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'ekuseni';
        } else if (hours < 15) {
            return 'emini';
        } else if (hours < 19) {
            return 'entsambama';
        } else {
            return 'ebusuku';
        }
    },
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'ekuseni') {
            return hour;
        } else if (meridiem === 'emini') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
            if (hour === 0) {
                return 0;
            }
            return hour + 12;
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}/,
    ordinal : '%d',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return ss;

})));


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swedish [sv]
//! author : Jens Alm : https://github.com/ulmus

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var sv = moment.defineLocale('sv', {
    months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
    weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
    weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
    weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [kl.] HH:mm',
        LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
        lll : 'D MMM YYYY HH:mm',
        llll : 'ddd D MMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Idag] LT',
        nextDay: '[Imorgon] LT',
        lastDay: '[Igår] LT',
        nextWeek: '[På] dddd LT',
        lastWeek: '[I] dddd[s] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : 'för %s sedan',
        s : 'några sekunder',
        m : 'en minut',
        mm : '%d minuter',
        h : 'en timme',
        hh : '%d timmar',
        d : 'en dag',
        dd : '%d dagar',
        M : 'en månad',
        MM : '%d månader',
        y : 'ett år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'e' :
            (b === 1) ? 'a' :
            (b === 2) ? 'a' :
            (b === 3) ? 'e' : 'e';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sv;

})));


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swahili [sw]
//! author : Fahad Kassim : https://github.com/fadsel

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var sw = moment.defineLocale('sw', {
    months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
    weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
    weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
    weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[leo saa] LT',
        nextDay : '[kesho saa] LT',
        nextWeek : '[wiki ijayo] dddd [saat] LT',
        lastDay : '[jana] LT',
        lastWeek : '[wiki iliyopita] dddd [saat] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s baadaye',
        past : 'tokea %s',
        s : 'hivi punde',
        m : 'dakika moja',
        mm : 'dakika %d',
        h : 'saa limoja',
        hh : 'masaa %d',
        d : 'siku moja',
        dd : 'masiku %d',
        M : 'mwezi mmoja',
        MM : 'miezi %d',
        y : 'mwaka mmoja',
        yy : 'miaka %d'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return sw;

})));


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tamil [ta]
//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '௧',
    '2': '௨',
    '3': '௩',
    '4': '௪',
    '5': '௫',
    '6': '௬',
    '7': '௭',
    '8': '௮',
    '9': '௯',
    '0': '௦'
};
var numberMap = {
    '௧': '1',
    '௨': '2',
    '௩': '3',
    '௪': '4',
    '௫': '5',
    '௬': '6',
    '௭': '7',
    '௮': '8',
    '௯': '9',
    '௦': '0'
};

var ta = moment.defineLocale('ta', {
    months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
    monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
    weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
    weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
    weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, HH:mm',
        LLLL : 'dddd, D MMMM YYYY, HH:mm'
    },
    calendar : {
        sameDay : '[இன்று] LT',
        nextDay : '[நாளை] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[நேற்று] LT',
        lastWeek : '[கடந்த வாரம்] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s இல்',
        past : '%s முன்',
        s : 'ஒரு சில விநாடிகள்',
        m : 'ஒரு நிமிடம்',
        mm : '%d நிமிடங்கள்',
        h : 'ஒரு மணி நேரம்',
        hh : '%d மணி நேரம்',
        d : 'ஒரு நாள்',
        dd : '%d நாட்கள்',
        M : 'ஒரு மாதம்',
        MM : '%d மாதங்கள்',
        y : 'ஒரு வருடம்',
        yy : '%d ஆண்டுகள்'
    },
    dayOfMonthOrdinalParse: /\d{1,2}வது/,
    ordinal : function (number) {
        return number + 'வது';
    },
    preparse: function (string) {
        return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    // refer http://ta.wikipedia.org/s/1er1
    meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
    meridiem : function (hour, minute, isLower) {
        if (hour < 2) {
            return ' யாமம்';
        } else if (hour < 6) {
            return ' வைகறை';  // வைகறை
        } else if (hour < 10) {
            return ' காலை'; // காலை
        } else if (hour < 14) {
            return ' நண்பகல்'; // நண்பகல்
        } else if (hour < 18) {
            return ' எற்பாடு'; // எற்பாடு
        } else if (hour < 22) {
            return ' மாலை'; // மாலை
        } else {
            return ' யாமம்';
        }
    },
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'யாமம்') {
            return hour < 2 ? hour : hour + 12;
        } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
            return hour;
        } else if (meridiem === 'நண்பகல்') {
            return hour >= 10 ? hour : hour + 12;
        } else {
            return hour + 12;
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return ta;

})));


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Telugu [te]
//! author : Krishna Chaitanya Thota : https://github.com/kcthota

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var te = moment.defineLocale('te', {
    months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
    monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
    monthsParseExact : true,
    weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
    weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
    weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm',
        LLLL : 'dddd, D MMMM YYYY, A h:mm'
    },
    calendar : {
        sameDay : '[నేడు] LT',
        nextDay : '[రేపు] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[నిన్న] LT',
        lastWeek : '[గత] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s లో',
        past : '%s క్రితం',
        s : 'కొన్ని క్షణాలు',
        m : 'ఒక నిమిషం',
        mm : '%d నిమిషాలు',
        h : 'ఒక గంట',
        hh : '%d గంటలు',
        d : 'ఒక రోజు',
        dd : '%d రోజులు',
        M : 'ఒక నెల',
        MM : '%d నెలలు',
        y : 'ఒక సంవత్సరం',
        yy : '%d సంవత్సరాలు'
    },
    dayOfMonthOrdinalParse : /\d{1,2}వ/,
    ordinal : '%dవ',
    meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'రాత్రి') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'ఉదయం') {
            return hour;
        } else if (meridiem === 'మధ్యాహ్నం') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'సాయంత్రం') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'రాత్రి';
        } else if (hour < 10) {
            return 'ఉదయం';
        } else if (hour < 17) {
            return 'మధ్యాహ్నం';
        } else if (hour < 20) {
            return 'సాయంత్రం';
        } else {
            return 'రాత్రి';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return te;

})));


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tetun Dili (East Timor) [tet]
//! author : Joshua Brooks : https://github.com/joshbrooks
//! author : Onorio De J. Afonso : https://github.com/marobo

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tet = moment.defineLocale('tet', {
    months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juniu_Juliu_Augustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Aug_Set_Out_Nov_Dez'.split('_'),
    weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sexta_Sabadu'.split('_'),
    weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sext_Sab'.split('_'),
    weekdaysMin : 'Do_Seg_Te_Ku_Ki_Sex_Sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Ohin iha] LT',
        nextDay: '[Aban iha] LT',
        nextWeek: 'dddd [iha] LT',
        lastDay: '[Horiseik iha] LT',
        lastWeek: 'dddd [semana kotuk] [iha] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'iha %s',
        past : '%s liuba',
        s : 'minutu balun',
        m : 'minutu ida',
        mm : 'minutus %d',
        h : 'horas ida',
        hh : 'horas %d',
        d : 'loron ida',
        dd : 'loron %d',
        M : 'fulan ida',
        MM : 'fulan %d',
        y : 'tinan ida',
        yy : 'tinan %d'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return tet;

})));


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Thai [th]
//! author : Kridsada Thanabulpong : https://github.com/sirn

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var th = moment.defineLocale('th', {
    months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
    monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
    monthsParseExact: true,
    weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
    weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
    weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY เวลา H:mm',
        LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
    },
    meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
    isPM: function (input) {
        return input === 'หลังเที่ยง';
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ก่อนเที่ยง';
        } else {
            return 'หลังเที่ยง';
        }
    },
    calendar : {
        sameDay : '[วันนี้ เวลา] LT',
        nextDay : '[พรุ่งนี้ เวลา] LT',
        nextWeek : 'dddd[หน้า เวลา] LT',
        lastDay : '[เมื่อวานนี้ เวลา] LT',
        lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'อีก %s',
        past : '%sที่แล้ว',
        s : 'ไม่กี่วินาที',
        m : '1 นาที',
        mm : '%d นาที',
        h : '1 ชั่วโมง',
        hh : '%d ชั่วโมง',
        d : '1 วัน',
        dd : '%d วัน',
        M : '1 เดือน',
        MM : '%d เดือน',
        y : '1 ปี',
        yy : '%d ปี'
    }
});

return th;

})));


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tagalog (Philippines) [tl-ph]
//! author : Dan Hagman : https://github.com/hagmandan

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tlPh = moment.defineLocale('tl-ph', {
    months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
    monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
    weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
    weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
    weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'MM/D/YYYY',
        LL : 'MMMM D, YYYY',
        LLL : 'MMMM D, YYYY HH:mm',
        LLLL : 'dddd, MMMM DD, YYYY HH:mm'
    },
    calendar : {
        sameDay: 'LT [ngayong araw]',
        nextDay: '[Bukas ng] LT',
        nextWeek: 'LT [sa susunod na] dddd',
        lastDay: 'LT [kahapon]',
        lastWeek: 'LT [noong nakaraang] dddd',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'sa loob ng %s',
        past : '%s ang nakalipas',
        s : 'ilang segundo',
        m : 'isang minuto',
        mm : '%d minuto',
        h : 'isang oras',
        hh : '%d oras',
        d : 'isang araw',
        dd : '%d araw',
        M : 'isang buwan',
        MM : '%d buwan',
        y : 'isang taon',
        yy : '%d taon'
    },
    dayOfMonthOrdinalParse: /\d{1,2}/,
    ordinal : function (number) {
        return number;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return tlPh;

})));


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Klingon [tlh]
//! author : Dominika Kruk : https://github.com/amaranthrose

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

function translateFuture(output) {
    var time = output;
    time = (output.indexOf('jaj') !== -1) ?
    time.slice(0, -3) + 'leS' :
    (output.indexOf('jar') !== -1) ?
    time.slice(0, -3) + 'waQ' :
    (output.indexOf('DIS') !== -1) ?
    time.slice(0, -3) + 'nem' :
    time + ' pIq';
    return time;
}

function translatePast(output) {
    var time = output;
    time = (output.indexOf('jaj') !== -1) ?
    time.slice(0, -3) + 'Hu’' :
    (output.indexOf('jar') !== -1) ?
    time.slice(0, -3) + 'wen' :
    (output.indexOf('DIS') !== -1) ?
    time.slice(0, -3) + 'ben' :
    time + ' ret';
    return time;
}

function translate(number, withoutSuffix, string, isFuture) {
    var numberNoun = numberAsNoun(number);
    switch (string) {
        case 'mm':
            return numberNoun + ' tup';
        case 'hh':
            return numberNoun + ' rep';
        case 'dd':
            return numberNoun + ' jaj';
        case 'MM':
            return numberNoun + ' jar';
        case 'yy':
            return numberNoun + ' DIS';
    }
}

function numberAsNoun(number) {
    var hundred = Math.floor((number % 1000) / 100),
    ten = Math.floor((number % 100) / 10),
    one = number % 10,
    word = '';
    if (hundred > 0) {
        word += numbersNouns[hundred] + 'vatlh';
    }
    if (ten > 0) {
        word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
    }
    if (one > 0) {
        word += ((word !== '') ? ' ' : '') + numbersNouns[one];
    }
    return (word === '') ? 'pagh' : word;
}

var tlh = moment.defineLocale('tlh', {
    months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
    monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
    monthsParseExact : true,
    weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
    weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
    weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[DaHjaj] LT',
        nextDay: '[wa’leS] LT',
        nextWeek: 'LLL',
        lastDay: '[wa’Hu’] LT',
        lastWeek: 'LLL',
        sameElse: 'L'
    },
    relativeTime : {
        future : translateFuture,
        past : translatePast,
        s : 'puS lup',
        m : 'wa’ tup',
        mm : translate,
        h : 'wa’ rep',
        hh : translate,
        d : 'wa’ jaj',
        dd : translate,
        M : 'wa’ jar',
        MM : translate,
        y : 'wa’ DIS',
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return tlh;

})));


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Turkish [tr]
//! authors : Erhan Gundogan : https://github.com/erhangundogan,
//!           Burak Yiğit Kaya: https://github.com/BYK

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var suffixes = {
    1: '\'inci',
    5: '\'inci',
    8: '\'inci',
    70: '\'inci',
    80: '\'inci',
    2: '\'nci',
    7: '\'nci',
    20: '\'nci',
    50: '\'nci',
    3: '\'üncü',
    4: '\'üncü',
    100: '\'üncü',
    6: '\'ncı',
    9: '\'uncu',
    10: '\'uncu',
    30: '\'uncu',
    60: '\'ıncı',
    90: '\'ıncı'
};

var tr = moment.defineLocale('tr', {
    months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
    monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
    weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
    weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
    weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[bugün saat] LT',
        nextDay : '[yarın saat] LT',
        nextWeek : '[gelecek] dddd [saat] LT',
        lastDay : '[dün] LT',
        lastWeek : '[geçen] dddd [saat] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s sonra',
        past : '%s önce',
        s : 'birkaç saniye',
        m : 'bir dakika',
        mm : '%d dakika',
        h : 'bir saat',
        hh : '%d saat',
        d : 'bir gün',
        dd : '%d gün',
        M : 'bir ay',
        MM : '%d ay',
        y : 'bir yıl',
        yy : '%d yıl'
    },
    dayOfMonthOrdinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
    ordinal : function (number) {
        if (number === 0) {  // special case for zero
            return number + '\'ıncı';
        }
        var a = number % 10,
            b = number % 100 - a,
            c = number >= 100 ? 100 : null;
        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return tr;

})));


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Talossan [tzl]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v
//! author : Iustì Canun

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


// After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
// This is currently too difficult (maybe even impossible) to add.
var tzl = moment.defineLocale('tzl', {
    months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
    monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
    weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
    weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
    weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM [dallas] YYYY',
        LLL : 'D. MMMM [dallas] YYYY HH.mm',
        LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
    },
    meridiemParse: /d\'o|d\'a/i,
    isPM : function (input) {
        return 'd\'o' === input.toLowerCase();
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'd\'o' : 'D\'O';
        } else {
            return isLower ? 'd\'a' : 'D\'A';
        }
    },
    calendar : {
        sameDay : '[oxhi à] LT',
        nextDay : '[demà à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[ieiri à] LT',
        lastWeek : '[sür el] dddd [lasteu à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'osprei %s',
        past : 'ja%s',
        s : processRelativeTime,
        m : processRelativeTime,
        mm : processRelativeTime,
        h : processRelativeTime,
        hh : processRelativeTime,
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        's': ['viensas secunds', '\'iensas secunds'],
        'm': ['\'n míut', '\'iens míut'],
        'mm': [number + ' míuts', '' + number + ' míuts'],
        'h': ['\'n þora', '\'iensa þora'],
        'hh': [number + ' þoras', '' + number + ' þoras'],
        'd': ['\'n ziua', '\'iensa ziua'],
        'dd': [number + ' ziuas', '' + number + ' ziuas'],
        'M': ['\'n mes', '\'iens mes'],
        'MM': [number + ' mesen', '' + number + ' mesen'],
        'y': ['\'n ar', '\'iens ar'],
        'yy': [number + ' ars', '' + number + ' ars']
    };
    return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
}

return tzl;

})));


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight [tzm]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tzm = moment.defineLocale('tzm', {
    months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
    monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
    weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
    weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
    weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS: 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
        nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
        nextWeek: 'dddd [ⴴ] LT',
        lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
        lastWeek: 'dddd [ⴴ] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
        past : 'ⵢⴰⵏ %s',
        s : 'ⵉⵎⵉⴽ',
        m : 'ⵎⵉⵏⵓⴺ',
        mm : '%d ⵎⵉⵏⵓⴺ',
        h : 'ⵙⴰⵄⴰ',
        hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
        d : 'ⴰⵙⵙ',
        dd : '%d oⵙⵙⴰⵏ',
        M : 'ⴰⵢoⵓⵔ',
        MM : '%d ⵉⵢⵢⵉⵔⵏ',
        y : 'ⴰⵙⴳⴰⵙ',
        yy : '%d ⵉⵙⴳⴰⵙⵏ'
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return tzm;

})));


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight Latin [tzm-latn]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tzmLatn = moment.defineLocale('tzm-latn', {
    months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
    monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
    weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
    weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
    weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[asdkh g] LT',
        nextDay: '[aska g] LT',
        nextWeek: 'dddd [g] LT',
        lastDay: '[assant g] LT',
        lastWeek: 'dddd [g] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'dadkh s yan %s',
        past : 'yan %s',
        s : 'imik',
        m : 'minuḍ',
        mm : '%d minuḍ',
        h : 'saɛa',
        hh : '%d tassaɛin',
        d : 'ass',
        dd : '%d ossan',
        M : 'ayowr',
        MM : '%d iyyirn',
        y : 'asgas',
        yy : '%d isgasn'
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return tzmLatn;

})));


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Ukrainian [uk]
//! author : zemlanin : https://github.com/zemlanin
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(word, num) {
    var forms = word.split('_');
    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
        'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
        'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
        'dd': 'день_дні_днів',
        'MM': 'місяць_місяці_місяців',
        'yy': 'рік_роки_років'
    };
    if (key === 'm') {
        return withoutSuffix ? 'хвилина' : 'хвилину';
    }
    else if (key === 'h') {
        return withoutSuffix ? 'година' : 'годину';
    }
    else {
        return number + ' ' + plural(format[key], +number);
    }
}
function weekdaysCaseReplace(m, format) {
    var weekdays = {
        'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
        'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
        'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
    };

    if (!m) {
        return weekdays['nominative'];
    }

    var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
        'accusative' :
        ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
            'genitive' :
            'nominative');
    return weekdays[nounCase][m.day()];
}
function processHoursFunction(str) {
    return function () {
        return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
    };
}

var uk = moment.defineLocale('uk', {
    months : {
        'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
        'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
    },
    monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
    weekdays : weekdaysCaseReplace,
    weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY р.',
        LLL : 'D MMMM YYYY р., HH:mm',
        LLLL : 'dddd, D MMMM YYYY р., HH:mm'
    },
    calendar : {
        sameDay: processHoursFunction('[Сьогодні '),
        nextDay: processHoursFunction('[Завтра '),
        lastDay: processHoursFunction('[Вчора '),
        nextWeek: processHoursFunction('[У] dddd ['),
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 5:
                case 6:
                    return processHoursFunction('[Минулої] dddd [').call(this);
                case 1:
                case 2:
                case 4:
                    return processHoursFunction('[Минулого] dddd [').call(this);
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'за %s',
        past : '%s тому',
        s : 'декілька секунд',
        m : relativeTimeWithPlural,
        mm : relativeTimeWithPlural,
        h : 'годину',
        hh : relativeTimeWithPlural,
        d : 'день',
        dd : relativeTimeWithPlural,
        M : 'місяць',
        MM : relativeTimeWithPlural,
        y : 'рік',
        yy : relativeTimeWithPlural
    },
    // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
    meridiemParse: /ночі|ранку|дня|вечора/,
    isPM: function (input) {
        return /^(дня|вечора)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ночі';
        } else if (hour < 12) {
            return 'ранку';
        } else if (hour < 17) {
            return 'дня';
        } else {
            return 'вечора';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'M':
            case 'd':
            case 'DDD':
            case 'w':
            case 'W':
                return number + '-й';
            case 'D':
                return number + '-го';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return uk;

})));


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Urdu [ur]
//! author : Sawood Alam : https://github.com/ibnesayeed
//! author : Zack : https://github.com/ZackVision

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'جنوری',
    'فروری',
    'مارچ',
    'اپریل',
    'مئی',
    'جون',
    'جولائی',
    'اگست',
    'ستمبر',
    'اکتوبر',
    'نومبر',
    'دسمبر'
];
var days = [
    'اتوار',
    'پیر',
    'منگل',
    'بدھ',
    'جمعرات',
    'جمعہ',
    'ہفتہ'
];

var ur = moment.defineLocale('ur', {
    months : months,
    monthsShort : months,
    weekdays : days,
    weekdaysShort : days,
    weekdaysMin : days,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd، D MMMM YYYY HH:mm'
    },
    meridiemParse: /صبح|شام/,
    isPM : function (input) {
        return 'شام' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'صبح';
        }
        return 'شام';
    },
    calendar : {
        sameDay : '[آج بوقت] LT',
        nextDay : '[کل بوقت] LT',
        nextWeek : 'dddd [بوقت] LT',
        lastDay : '[گذشتہ روز بوقت] LT',
        lastWeek : '[گذشتہ] dddd [بوقت] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s بعد',
        past : '%s قبل',
        s : 'چند سیکنڈ',
        m : 'ایک منٹ',
        mm : '%d منٹ',
        h : 'ایک گھنٹہ',
        hh : '%d گھنٹے',
        d : 'ایک دن',
        dd : '%d دن',
        M : 'ایک ماہ',
        MM : '%d ماہ',
        y : 'ایک سال',
        yy : '%d سال'
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/,/g, '،');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return ur;

})));


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek [uz]
//! author : Sardor Muminov : https://github.com/muminoff

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var uz = moment.defineLocale('uz', {
    months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
    monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
    weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
    weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
    weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'D MMMM YYYY, dddd HH:mm'
    },
    calendar : {
        sameDay : '[Бугун соат] LT [да]',
        nextDay : '[Эртага] LT [да]',
        nextWeek : 'dddd [куни соат] LT [да]',
        lastDay : '[Кеча соат] LT [да]',
        lastWeek : '[Утган] dddd [куни соат] LT [да]',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'Якин %s ичида',
        past : 'Бир неча %s олдин',
        s : 'фурсат',
        m : 'бир дакика',
        mm : '%d дакика',
        h : 'бир соат',
        hh : '%d соат',
        d : 'бир кун',
        dd : '%d кун',
        M : 'бир ой',
        MM : '%d ой',
        y : 'бир йил',
        yy : '%d йил'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 4th is the first week of the year.
    }
});

return uz;

})));


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek Latin [uz-latn]
//! author : Rasulbek Mirzayev : github.com/Rasulbeeek

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var uzLatn = moment.defineLocale('uz-latn', {
    months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
    monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
    weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
    weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
    weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'D MMMM YYYY, dddd HH:mm'
    },
    calendar : {
        sameDay : '[Bugun soat] LT [da]',
        nextDay : '[Ertaga] LT [da]',
        nextWeek : 'dddd [kuni soat] LT [da]',
        lastDay : '[Kecha soat] LT [da]',
        lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'Yaqin %s ichida',
        past : 'Bir necha %s oldin',
        s : 'soniya',
        m : 'bir daqiqa',
        mm : '%d daqiqa',
        h : 'bir soat',
        hh : '%d soat',
        d : 'bir kun',
        dd : '%d kun',
        M : 'bir oy',
        MM : '%d oy',
        y : 'bir yil',
        yy : '%d yil'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return uzLatn;

})));


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Vietnamese [vi]
//! author : Bang Nguyen : https://github.com/bangnk

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var vi = moment.defineLocale('vi', {
    months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
    monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
    monthsParseExact : true,
    weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
    weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
    weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
    weekdaysParseExact : true,
    meridiemParse: /sa|ch/i,
    isPM : function (input) {
        return /^ch$/i.test(input);
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 12) {
            return isLower ? 'sa' : 'SA';
        } else {
            return isLower ? 'ch' : 'CH';
        }
    },
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM [năm] YYYY',
        LLL : 'D MMMM [năm] YYYY HH:mm',
        LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
        l : 'DD/M/YYYY',
        ll : 'D MMM YYYY',
        lll : 'D MMM YYYY HH:mm',
        llll : 'ddd, D MMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Hôm nay lúc] LT',
        nextDay: '[Ngày mai lúc] LT',
        nextWeek: 'dddd [tuần tới lúc] LT',
        lastDay: '[Hôm qua lúc] LT',
        lastWeek: 'dddd [tuần rồi lúc] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s tới',
        past : '%s trước',
        s : 'vài giây',
        m : 'một phút',
        mm : '%d phút',
        h : 'một giờ',
        hh : '%d giờ',
        d : 'một ngày',
        dd : '%d ngày',
        M : 'một tháng',
        MM : '%d tháng',
        y : 'một năm',
        yy : '%d năm'
    },
    dayOfMonthOrdinalParse: /\d{1,2}/,
    ordinal : function (number) {
        return number;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return vi;

})));


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Pseudo [x-pseudo]
//! author : Andrew Hood : https://github.com/andrewhood125

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var xPseudo = moment.defineLocale('x-pseudo', {
    months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
    monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
    monthsParseExact : true,
    weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
    weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
    weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[T~ódá~ý át] LT',
        nextDay : '[T~ómó~rró~w át] LT',
        nextWeek : 'dddd [át] LT',
        lastDay : '[Ý~ést~érdá~ý át] LT',
        lastWeek : '[L~ást] dddd [át] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'í~ñ %s',
        past : '%s á~gó',
        s : 'á ~féw ~sécó~ñds',
        m : 'á ~míñ~úté',
        mm : '%d m~íñú~tés',
        h : 'á~ñ hó~úr',
        hh : '%d h~óúrs',
        d : 'á ~dáý',
        dd : '%d d~áýs',
        M : 'á ~móñ~th',
        MM : '%d m~óñt~hs',
        y : 'á ~ýéár',
        yy : '%d ý~éárs'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return xPseudo;

})));


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Yoruba Nigeria [yo]
//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var yo = moment.defineLocale('yo', {
    months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
    monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
    weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
    weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
    weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Ònì ni] LT',
        nextDay : '[Ọ̀la ni] LT',
        nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
        lastDay : '[Àna ni] LT',
        lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ní %s',
        past : '%s kọjá',
        s : 'ìsẹjú aayá die',
        m : 'ìsẹjú kan',
        mm : 'ìsẹjú %d',
        h : 'wákati kan',
        hh : 'wákati %d',
        d : 'ọjọ́ kan',
        dd : 'ọjọ́ %d',
        M : 'osù kan',
        MM : 'osù %d',
        y : 'ọdún kan',
        yy : 'ọdún %d'
    },
    dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
    ordinal : 'ọjọ́ %d',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4 // The week that contains Jan 4th is the first week of the year.
    }
});

return yo;

})));


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (China) [zh-cn]
//! author : suupic : https://github.com/suupic
//! author : Zeno Zeng : https://github.com/zenozeng

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var zhCn = moment.defineLocale('zh-cn', {
    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
    weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY年MMMD日',
        LL : 'YYYY年MMMD日',
        LLL : 'YYYY年MMMD日Ah点mm分',
        LLLL : 'YYYY年MMMD日ddddAh点mm分',
        l : 'YYYY年MMMD日',
        ll : 'YYYY年MMMD日',
        lll : 'YYYY年MMMD日 HH:mm',
        llll : 'YYYY年MMMD日dddd HH:mm'
    },
    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === '凌晨' || meridiem === '早上' ||
                meridiem === '上午') {
            return hour;
        } else if (meridiem === '下午' || meridiem === '晚上') {
            return hour + 12;
        } else {
            // '中午'
            return hour >= 11 ? hour : hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        var hm = hour * 100 + minute;
        if (hm < 600) {
            return '凌晨';
        } else if (hm < 900) {
            return '早上';
        } else if (hm < 1130) {
            return '上午';
        } else if (hm < 1230) {
            return '中午';
        } else if (hm < 1800) {
            return '下午';
        } else {
            return '晚上';
        }
    },
    calendar : {
        sameDay : '[今天]LT',
        nextDay : '[明天]LT',
        nextWeek : '[下]ddddLT',
        lastDay : '[昨天]LT',
        lastWeek : '[上]ddddLT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd':
            case 'D':
            case 'DDD':
                return number + '日';
            case 'M':
                return number + '月';
            case 'w':
            case 'W':
                return number + '周';
            default:
                return number;
        }
    },
    relativeTime : {
        future : '%s内',
        past : '%s前',
        s : '几秒',
        m : '1 分钟',
        mm : '%d 分钟',
        h : '1 小时',
        hh : '%d 小时',
        d : '1 天',
        dd : '%d 天',
        M : '1 个月',
        MM : '%d 个月',
        y : '1 年',
        yy : '%d 年'
    },
    week : {
        // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return zhCn;

})));


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Hong Kong) [zh-hk]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Konstantin : https://github.com/skfd

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var zhHk = moment.defineLocale('zh-hk', {
    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY年MMMD日',
        LL : 'YYYY年MMMD日',
        LLL : 'YYYY年MMMD日 HH:mm',
        LLLL : 'YYYY年MMMD日dddd HH:mm',
        l : 'YYYY年MMMD日',
        ll : 'YYYY年MMMD日',
        lll : 'YYYY年MMMD日 HH:mm',
        llll : 'YYYY年MMMD日dddd HH:mm'
    },
    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
            return hour;
        } else if (meridiem === '中午') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === '下午' || meridiem === '晚上') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        var hm = hour * 100 + minute;
        if (hm < 600) {
            return '凌晨';
        } else if (hm < 900) {
            return '早上';
        } else if (hm < 1130) {
            return '上午';
        } else if (hm < 1230) {
            return '中午';
        } else if (hm < 1800) {
            return '下午';
        } else {
            return '晚上';
        }
    },
    calendar : {
        sameDay : '[今天]LT',
        nextDay : '[明天]LT',
        nextWeek : '[下]ddddLT',
        lastDay : '[昨天]LT',
        lastWeek : '[上]ddddLT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd' :
            case 'D' :
            case 'DDD' :
                return number + '日';
            case 'M' :
                return number + '月';
            case 'w' :
            case 'W' :
                return number + '週';
            default :
                return number;
        }
    },
    relativeTime : {
        future : '%s內',
        past : '%s前',
        s : '幾秒',
        m : '1 分鐘',
        mm : '%d 分鐘',
        h : '1 小時',
        hh : '%d 小時',
        d : '1 天',
        dd : '%d 天',
        M : '1 個月',
        MM : '%d 個月',
        y : '1 年',
        yy : '%d 年'
    }
});

return zhHk;

})));


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Taiwan) [zh-tw]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var zhTw = moment.defineLocale('zh-tw', {
    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY年MMMD日',
        LL : 'YYYY年MMMD日',
        LLL : 'YYYY年MMMD日 HH:mm',
        LLLL : 'YYYY年MMMD日dddd HH:mm',
        l : 'YYYY年MMMD日',
        ll : 'YYYY年MMMD日',
        lll : 'YYYY年MMMD日 HH:mm',
        llll : 'YYYY年MMMD日dddd HH:mm'
    },
    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
            return hour;
        } else if (meridiem === '中午') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === '下午' || meridiem === '晚上') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        var hm = hour * 100 + minute;
        if (hm < 600) {
            return '凌晨';
        } else if (hm < 900) {
            return '早上';
        } else if (hm < 1130) {
            return '上午';
        } else if (hm < 1230) {
            return '中午';
        } else if (hm < 1800) {
            return '下午';
        } else {
            return '晚上';
        }
    },
    calendar : {
        sameDay : '[今天]LT',
        nextDay : '[明天]LT',
        nextWeek : '[下]ddddLT',
        lastDay : '[昨天]LT',
        lastWeek : '[上]ddddLT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd' :
            case 'D' :
            case 'DDD' :
                return number + '日';
            case 'M' :
                return number + '月';
            case 'w' :
            case 'W' :
                return number + '週';
            default :
                return number;
        }
    },
    relativeTime : {
        future : '%s內',
        past : '%s前',
        s : '幾秒',
        m : '1 分鐘',
        mm : '%d 分鐘',
        h : '1 小時',
        hh : '%d 小時',
        d : '1 天',
        dd : '%d 天',
        M : '1 個月',
        MM : '%d 個月',
        y : '1 年',
        yy : '%d 年'
    }
});

return zhTw;

})));


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function parse (rawValue) {
  const parsed = parseValue(rawValue);

  if (parsed === undefined) {
    return null;
  }

  return parsed;
}

function parseValue (rawValue) {
  try {
    return JSON.parse(rawValue);
  } catch (err) {
    return rawValue;
  }
}

module.exports = parse;


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routerMiddleware = exports.routerActions = exports.goForward = exports.goBack = exports.go = exports.replace = exports.push = exports.CALL_HISTORY_METHOD = exports.routerReducer = exports.LOCATION_CHANGE = exports.syncHistoryWithStore = undefined;

var _reducer = __webpack_require__(314);

Object.defineProperty(exports, 'LOCATION_CHANGE', {
  enumerable: true,
  get: function get() {
    return _reducer.LOCATION_CHANGE;
  }
});
Object.defineProperty(exports, 'routerReducer', {
  enumerable: true,
  get: function get() {
    return _reducer.routerReducer;
  }
});

var _actions = __webpack_require__(315);

Object.defineProperty(exports, 'CALL_HISTORY_METHOD', {
  enumerable: true,
  get: function get() {
    return _actions.CALL_HISTORY_METHOD;
  }
});
Object.defineProperty(exports, 'push', {
  enumerable: true,
  get: function get() {
    return _actions.push;
  }
});
Object.defineProperty(exports, 'replace', {
  enumerable: true,
  get: function get() {
    return _actions.replace;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _actions.go;
  }
});
Object.defineProperty(exports, 'goBack', {
  enumerable: true,
  get: function get() {
    return _actions.goBack;
  }
});
Object.defineProperty(exports, 'goForward', {
  enumerable: true,
  get: function get() {
    return _actions.goForward;
  }
});
Object.defineProperty(exports, 'routerActions', {
  enumerable: true,
  get: function get() {
    return _actions.routerActions;
  }
});

var _sync = __webpack_require__(678);

var _sync2 = _interopRequireDefault(_sync);

var _middleware = __webpack_require__(679);

var _middleware2 = _interopRequireDefault(_middleware);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports.syncHistoryWithStore = _sync2['default'];
exports.routerMiddleware = _middleware2['default'];

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.routerReducer = routerReducer;
/**
 * This action type will be dispatched when your history
 * receives a location change.
 */
var LOCATION_CHANGE = exports.LOCATION_CHANGE = '@@router/LOCATION_CHANGE';

var initialState = {
  locationBeforeTransitions: null
};

/**
 * This reducer will update the state with the most recent location history
 * has transitioned to. This may not be in sync with the router, particularly
 * if you have asynchronously-loaded routes, so reading from and relying on
 * this state is discouraged.
 */
function routerReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      type = _ref.type,
      payload = _ref.payload;

  if (type === LOCATION_CHANGE) {
    return _extends({}, state, { locationBeforeTransitions: payload });
  }

  return state;
}

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * This action type will be dispatched by the history actions below.
 * If you're writing a middleware to watch for navigation events, be sure to
 * look for actions of this type.
 */
var CALL_HISTORY_METHOD = exports.CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';

function updateLocation(method) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return {
      type: CALL_HISTORY_METHOD,
      payload: { method: method, args: args }
    };
  };
}

/**
 * These actions correspond to the history API.
 * The associated routerMiddleware will capture these events before they get to
 * your reducer and reissue them as the matching function on your history.
 */
var push = exports.push = updateLocation('push');
var replace = exports.replace = updateLocation('replace');
var go = exports.go = updateLocation('go');
var goBack = exports.goBack = updateLocation('goBack');
var goForward = exports.goForward = updateLocation('goForward');

var routerActions = exports.routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(332);

var _reactRouter = __webpack_require__(18);

var _reactHotLoader = __webpack_require__(440);

var _Root = __webpack_require__(444);

var _Root2 = _interopRequireDefault(_Root);

var _configureStore = __webpack_require__(671);

var _configureStore2 = _interopRequireDefault(_configureStore);

var _reactRouterRedux = __webpack_require__(313);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable import/default */

__webpack_require__(680); // Tell webpack to load favicon.ico


var store = (0, _configureStore2.default)();

// Create an enhanced history that syncs navigation events with the store
var history = (0, _reactRouterRedux.syncHistoryWithStore)(_reactRouter.browserHistory, store);

(0, _reactDom.render)(_react2.default.createElement(
    _reactHotLoader.AppContainer,
    null,
    _react2.default.createElement(_Root2.default, { store: store, history: history })
), document.getElementById('app'));

if (false) {
    module.hot.accept('./components/Root', function () {
        var NewRoot = require('./components/Root').default;
        (0, _reactDom.render)(_react2.default.createElement(
            _reactHotLoader.AppContainer,
            null,
            _react2.default.createElement(NewRoot, { store: store, history: history })
        ), document.getElementById('app'));
    });
}

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var PooledClass = __webpack_require__(318);
var ReactElement = __webpack_require__(34);

var emptyFunction = __webpack_require__(12);
var traverseAllChildren = __webpack_require__(319);

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;


  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(33);

var invariant = __webpack_require__(2);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(33);

var ReactCurrentOwner = __webpack_require__(19);
var REACT_ELEMENT_TYPE = __webpack_require__(110);

var getIteratorFn = __webpack_require__(320);
var invariant = __webpack_require__(2);
var KeyEscapeUtils = __webpack_require__(321);
var warning = __webpack_require__(4);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(8);

var ReactComponent = __webpack_require__(66);
var ReactNoopUpdateQueue = __webpack_require__(67);

var emptyObject = __webpack_require__(35);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactPureComponent(props, context, updater) {
  // Duplicated from ReactComponent.
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

function ComponentDummy() {}
ComponentDummy.prototype = ReactComponent.prototype;
ReactPureComponent.prototype = new ComponentDummy();
ReactPureComponent.prototype.constructor = ReactPureComponent;
// Avoid an extra prototype jump for these methods.
_assign(ReactPureComponent.prototype, ReactComponent.prototype);
ReactPureComponent.prototype.isPureReactComponent = true;

module.exports = ReactPureComponent;

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(33),
    _assign = __webpack_require__(8);

var ReactComponent = __webpack_require__(66);
var ReactElement = __webpack_require__(34);
var ReactPropTypeLocationNames = __webpack_require__(324);
var ReactNoopUpdateQueue = __webpack_require__(67);

var emptyObject = __webpack_require__(35);
var invariant = __webpack_require__(2);
var warning = __webpack_require__(4);

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

/**
 * Policies that describe methods in `ReactClassInterface`.
 */


var injectedMixins = [];

/**
 * Composite components are higher-level components that compose other composite
 * or host components.
 *
 * To create a new type of `ReactClass`, pass a specification of
 * your new class to `React.createClass`. The only requirement of your class
 * specification is that you implement a `render` method.
 *
 *   var MyComponent = React.createClass({
 *     render: function() {
 *       return <div>Hello World</div>;
 *     }
 *   });
 *
 * The class specification supports a specific protocol of methods that have
 * special meaning (e.g. `render`). See `ReactClassInterface` for
 * more the comprehensive protocol. Any other properties and methods in the
 * class specification will be available on the prototype.
 *
 * @interface ReactClassInterface
 * @internal
 */
var ReactClassInterface = {

  /**
   * An array of Mixin objects to include when defining your component.
   *
   * @type {array}
   * @optional
   */
  mixins: 'DEFINE_MANY',

  /**
   * An object containing properties and methods that should be defined on
   * the component's constructor instead of its prototype (static methods).
   *
   * @type {object}
   * @optional
   */
  statics: 'DEFINE_MANY',

  /**
   * Definition of prop types for this component.
   *
   * @type {object}
   * @optional
   */
  propTypes: 'DEFINE_MANY',

  /**
   * Definition of context types for this component.
   *
   * @type {object}
   * @optional
   */
  contextTypes: 'DEFINE_MANY',

  /**
   * Definition of context types this component sets for its children.
   *
   * @type {object}
   * @optional
   */
  childContextTypes: 'DEFINE_MANY',

  // ==== Definition methods ====

  /**
   * Invoked when the component is mounted. Values in the mapping will be set on
   * `this.props` if that prop is not specified (i.e. using an `in` check).
   *
   * This method is invoked before `getInitialState` and therefore cannot rely
   * on `this.state` or use `this.setState`.
   *
   * @return {object}
   * @optional
   */
  getDefaultProps: 'DEFINE_MANY_MERGED',

  /**
   * Invoked once before the component is mounted. The return value will be used
   * as the initial value of `this.state`.
   *
   *   getInitialState: function() {
   *     return {
   *       isOn: false,
   *       fooBaz: new BazFoo()
   *     }
   *   }
   *
   * @return {object}
   * @optional
   */
  getInitialState: 'DEFINE_MANY_MERGED',

  /**
   * @return {object}
   * @optional
   */
  getChildContext: 'DEFINE_MANY_MERGED',

  /**
   * Uses props from `this.props` and state from `this.state` to render the
   * structure of the component.
   *
   * No guarantees are made about when or how often this method is invoked, so
   * it must not have side effects.
   *
   *   render: function() {
   *     var name = this.props.name;
   *     return <div>Hello, {name}!</div>;
   *   }
   *
   * @return {ReactComponent}
   * @required
   */
  render: 'DEFINE_ONCE',

  // ==== Delegate methods ====

  /**
   * Invoked when the component is initially created and about to be mounted.
   * This may have side effects, but any external subscriptions or data created
   * by this method must be cleaned up in `componentWillUnmount`.
   *
   * @optional
   */
  componentWillMount: 'DEFINE_MANY',

  /**
   * Invoked when the component has been mounted and has a DOM representation.
   * However, there is no guarantee that the DOM node is in the document.
   *
   * Use this as an opportunity to operate on the DOM when the component has
   * been mounted (initialized and rendered) for the first time.
   *
   * @param {DOMElement} rootNode DOM element representing the component.
   * @optional
   */
  componentDidMount: 'DEFINE_MANY',

  /**
   * Invoked before the component receives new props.
   *
   * Use this as an opportunity to react to a prop transition by updating the
   * state using `this.setState`. Current props are accessed via `this.props`.
   *
   *   componentWillReceiveProps: function(nextProps, nextContext) {
   *     this.setState({
   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
   *     });
   *   }
   *
   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
   * transition may cause a state change, but the opposite is not true. If you
   * need it, you are probably looking for `componentWillUpdate`.
   *
   * @param {object} nextProps
   * @optional
   */
  componentWillReceiveProps: 'DEFINE_MANY',

  /**
   * Invoked while deciding if the component should be updated as a result of
   * receiving new props, state and/or context.
   *
   * Use this as an opportunity to `return false` when you're certain that the
   * transition to the new props/state/context will not require a component
   * update.
   *
   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
   *     return !equal(nextProps, this.props) ||
   *       !equal(nextState, this.state) ||
   *       !equal(nextContext, this.context);
   *   }
   *
   * @param {object} nextProps
   * @param {?object} nextState
   * @param {?object} nextContext
   * @return {boolean} True if the component should update.
   * @optional
   */
  shouldComponentUpdate: 'DEFINE_ONCE',

  /**
   * Invoked when the component is about to update due to a transition from
   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
   * and `nextContext`.
   *
   * Use this as an opportunity to perform preparation before an update occurs.
   *
   * NOTE: You **cannot** use `this.setState()` in this method.
   *
   * @param {object} nextProps
   * @param {?object} nextState
   * @param {?object} nextContext
   * @param {ReactReconcileTransaction} transaction
   * @optional
   */
  componentWillUpdate: 'DEFINE_MANY',

  /**
   * Invoked when the component's DOM representation has been updated.
   *
   * Use this as an opportunity to operate on the DOM when the component has
   * been updated.
   *
   * @param {object} prevProps
   * @param {?object} prevState
   * @param {?object} prevContext
   * @param {DOMElement} rootNode DOM element representing the component.
   * @optional
   */
  componentDidUpdate: 'DEFINE_MANY',

  /**
   * Invoked when the component is about to be removed from its parent and have
   * its DOM representation destroyed.
   *
   * Use this as an opportunity to deallocate any external resources.
   *
   * NOTE: There is no `componentDidUnmount` since your component will have been
   * destroyed by that point.
   *
   * @optional
   */
  componentWillUnmount: 'DEFINE_MANY',

  // ==== Advanced methods ====

  /**
   * Updates the component's currently mounted DOM representation.
   *
   * By default, this implements React's rendering and reconciliation algorithm.
   * Sophisticated clients may wish to override this.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   * @overridable
   */
  updateComponent: 'OVERRIDE_BASE'

};

/**
 * Mapping from class specification keys to special processing functions.
 *
 * Although these are declared like instance properties in the specification
 * when defining classes using `React.createClass`, they are actually static
 * and are accessible on the constructor instead of the prototype. Despite
 * being static, they must be defined outside of the "statics" key under
 * which all other static methods are defined.
 */
var RESERVED_SPEC_KEYS = {
  displayName: function (Constructor, displayName) {
    Constructor.displayName = displayName;
  },
  mixins: function (Constructor, mixins) {
    if (mixins) {
      for (var i = 0; i < mixins.length; i++) {
        mixSpecIntoComponent(Constructor, mixins[i]);
      }
    }
  },
  childContextTypes: function (Constructor, childContextTypes) {
    if (false) {
      validateTypeDef(Constructor, childContextTypes, 'childContext');
    }
    Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
  },
  contextTypes: function (Constructor, contextTypes) {
    if (false) {
      validateTypeDef(Constructor, contextTypes, 'context');
    }
    Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
  },
  /**
   * Special case getDefaultProps which should move into statics but requires
   * automatic merging.
   */
  getDefaultProps: function (Constructor, getDefaultProps) {
    if (Constructor.getDefaultProps) {
      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
    } else {
      Constructor.getDefaultProps = getDefaultProps;
    }
  },
  propTypes: function (Constructor, propTypes) {
    if (false) {
      validateTypeDef(Constructor, propTypes, 'prop');
    }
    Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
  },
  statics: function (Constructor, statics) {
    mixStaticSpecIntoComponent(Constructor, statics);
  },
  autobind: function () {} };

function validateTypeDef(Constructor, typeDef, location) {
  for (var propName in typeDef) {
    if (typeDef.hasOwnProperty(propName)) {
      // use a warning instead of an invariant so components
      // don't show up in prod but only in __DEV__
       false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
    }
  }
}

function validateMethodOverride(isAlreadyDefined, name) {
  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;

  // Disallow overriding of base class methods unless explicitly allowed.
  if (ReactClassMixin.hasOwnProperty(name)) {
    !(specPolicy === 'OVERRIDE_BASE') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.', name) : _prodInvariant('73', name) : void 0;
  }

  // Disallow defining methods more than once unless explicitly allowed.
  if (isAlreadyDefined) {
    !(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('74', name) : void 0;
  }
}

/**
 * Mixin helper which handles policy validation and reserved
 * specification keys when building React classes.
 */
function mixSpecIntoComponent(Constructor, spec) {
  if (!spec) {
    if (false) {
      var typeofSpec = typeof spec;
      var isMixinValid = typeofSpec === 'object' && spec !== null;

      process.env.NODE_ENV !== 'production' ? warning(isMixinValid, '%s: You\'re attempting to include a mixin that is either null ' + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec) : void 0;
    }

    return;
  }

  !(typeof spec !== 'function') ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component class or function as a mixin. Instead, just use a regular object.') : _prodInvariant('75') : void 0;
  !!ReactElement.isValidElement(spec) ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component as a mixin. Instead, just use a regular object.') : _prodInvariant('76') : void 0;

  var proto = Constructor.prototype;
  var autoBindPairs = proto.__reactAutoBindPairs;

  // By handling mixins before any other properties, we ensure the same
  // chaining order is applied to methods with DEFINE_MANY policy, whether
  // mixins are listed before or after these methods in the spec.
  if (spec.hasOwnProperty(MIXINS_KEY)) {
    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
  }

  for (var name in spec) {
    if (!spec.hasOwnProperty(name)) {
      continue;
    }

    if (name === MIXINS_KEY) {
      // We have already handled mixins in a special case above.
      continue;
    }

    var property = spec[name];
    var isAlreadyDefined = proto.hasOwnProperty(name);
    validateMethodOverride(isAlreadyDefined, name);

    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
      RESERVED_SPEC_KEYS[name](Constructor, property);
    } else {
      // Setup methods on prototype:
      // The following member methods should not be automatically bound:
      // 1. Expected ReactClass methods (in the "interface").
      // 2. Overridden methods (that were mixed in).
      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
      var isFunction = typeof property === 'function';
      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;

      if (shouldAutoBind) {
        autoBindPairs.push(name, property);
        proto[name] = property;
      } else {
        if (isAlreadyDefined) {
          var specPolicy = ReactClassInterface[name];

          // These cases should already be caught by validateMethodOverride.
          !(isReactClassMethod && (specPolicy === 'DEFINE_MANY_MERGED' || specPolicy === 'DEFINE_MANY')) ?  false ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.', specPolicy, name) : _prodInvariant('77', specPolicy, name) : void 0;

          // For methods which are defined more than once, call the existing
          // methods before calling the new property, merging if appropriate.
          if (specPolicy === 'DEFINE_MANY_MERGED') {
            proto[name] = createMergedResultFunction(proto[name], property);
          } else if (specPolicy === 'DEFINE_MANY') {
            proto[name] = createChainedFunction(proto[name], property);
          }
        } else {
          proto[name] = property;
          if (false) {
            // Add verbose displayName to the function, which helps when looking
            // at profiling tools.
            if (typeof property === 'function' && spec.displayName) {
              proto[name].displayName = spec.displayName + '_' + name;
            }
          }
        }
      }
    }
  }
}

function mixStaticSpecIntoComponent(Constructor, statics) {
  if (!statics) {
    return;
  }
  for (var name in statics) {
    var property = statics[name];
    if (!statics.hasOwnProperty(name)) {
      continue;
    }

    var isReserved = name in RESERVED_SPEC_KEYS;
    !!isReserved ?  false ? invariant(false, 'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.', name) : _prodInvariant('78', name) : void 0;

    var isInherited = name in Constructor;
    !!isInherited ?  false ? invariant(false, 'ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('79', name) : void 0;
    Constructor[name] = property;
  }
}

/**
 * Merge two objects, but throw if both contain the same key.
 *
 * @param {object} one The first object, which is mutated.
 * @param {object} two The second object
 * @return {object} one after it has been mutated to contain everything in two.
 */
function mergeIntoWithNoDuplicateKeys(one, two) {
  !(one && two && typeof one === 'object' && typeof two === 'object') ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : _prodInvariant('80') : void 0;

  for (var key in two) {
    if (two.hasOwnProperty(key)) {
      !(one[key] === undefined) ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.', key) : _prodInvariant('81', key) : void 0;
      one[key] = two[key];
    }
  }
  return one;
}

/**
 * Creates a function that invokes two functions and merges their return values.
 *
 * @param {function} one Function to invoke first.
 * @param {function} two Function to invoke second.
 * @return {function} Function that invokes the two argument functions.
 * @private
 */
function createMergedResultFunction(one, two) {
  return function mergedResult() {
    var a = one.apply(this, arguments);
    var b = two.apply(this, arguments);
    if (a == null) {
      return b;
    } else if (b == null) {
      return a;
    }
    var c = {};
    mergeIntoWithNoDuplicateKeys(c, a);
    mergeIntoWithNoDuplicateKeys(c, b);
    return c;
  };
}

/**
 * Creates a function that invokes two functions and ignores their return vales.
 *
 * @param {function} one Function to invoke first.
 * @param {function} two Function to invoke second.
 * @return {function} Function that invokes the two argument functions.
 * @private
 */
function createChainedFunction(one, two) {
  return function chainedFunction() {
    one.apply(this, arguments);
    two.apply(this, arguments);
  };
}

/**
 * Binds a method to the component.
 *
 * @param {object} component Component whose method is going to be bound.
 * @param {function} method Method to be bound.
 * @return {function} The bound method.
 */
function bindAutoBindMethod(component, method) {
  var boundMethod = method.bind(component);
  if (false) {
    boundMethod.__reactBoundContext = component;
    boundMethod.__reactBoundMethod = method;
    boundMethod.__reactBoundArguments = null;
    var componentName = component.constructor.displayName;
    var _bind = boundMethod.bind;
    boundMethod.bind = function (newThis) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      // User is trying to bind() an autobound method; we effectively will
      // ignore the value of "this" that the user is trying to use, so
      // let's warn.
      if (newThis !== component && newThis !== null) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
      } else if (!args.length) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
        return boundMethod;
      }
      var reboundMethod = _bind.apply(boundMethod, arguments);
      reboundMethod.__reactBoundContext = component;
      reboundMethod.__reactBoundMethod = method;
      reboundMethod.__reactBoundArguments = args;
      return reboundMethod;
    };
  }
  return boundMethod;
}

/**
 * Binds all auto-bound methods in a component.
 *
 * @param {object} component Component whose method is going to be bound.
 */
function bindAutoBindMethods(component) {
  var pairs = component.__reactAutoBindPairs;
  for (var i = 0; i < pairs.length; i += 2) {
    var autoBindKey = pairs[i];
    var method = pairs[i + 1];
    component[autoBindKey] = bindAutoBindMethod(component, method);
  }
}

/**
 * Add more to the ReactClass base class. These are all legacy features and
 * therefore not already part of the modern ReactComponent.
 */
var ReactClassMixin = {

  /**
   * TODO: This will be deprecated because state should always keep a consistent
   * type signature and the only use case for this, is to avoid that.
   */
  replaceState: function (newState, callback) {
    this.updater.enqueueReplaceState(this, newState);
    if (callback) {
      this.updater.enqueueCallback(this, callback, 'replaceState');
    }
  },

  /**
   * Checks whether or not this composite component is mounted.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function () {
    return this.updater.isMounted(this);
  }
};

var ReactClassComponent = function () {};
_assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);

var didWarnDeprecated = false;

/**
 * Module for creating composite components.
 *
 * @class ReactClass
 */
var ReactClass = {

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  createClass: function (spec) {
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(didWarnDeprecated, '%s: React.createClass is deprecated and will be removed in version 16. ' + 'Use plain JavaScript classes instead. If you\'re not yet ready to ' + 'migrate, create-react-class is available on npm as a ' + 'drop-in replacement.', spec && spec.displayName || 'A Component') : void 0;
      didWarnDeprecated = true;
    }

    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function (props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (initialState === undefined && this.getInitialState._isMockFunction) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : _prodInvariant('82', Constructor.displayName || 'ReactCompositeComponent') : void 0;

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, spec);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    !Constructor.prototype.render ?  false ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : _prodInvariant('83') : void 0;

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  },

  injection: {
    injectMixin: function (mixin) {
      injectedMixins.push(mixin);
    }
  }

};

module.exports = ReactClass;

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactPropTypeLocationNames = {};

if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
}

module.exports = ReactPropTypeLocationNames;

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactElement = __webpack_require__(34);

/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */
var createDOMFactory = ReactElement.createFactory;
if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createDOMFactory = ReactElementValidator.createFactory;
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 * This is also accessible via `React.DOM`.
 *
 * @public
 */
var ReactDOMFactories = {
  a: createDOMFactory('a'),
  abbr: createDOMFactory('abbr'),
  address: createDOMFactory('address'),
  area: createDOMFactory('area'),
  article: createDOMFactory('article'),
  aside: createDOMFactory('aside'),
  audio: createDOMFactory('audio'),
  b: createDOMFactory('b'),
  base: createDOMFactory('base'),
  bdi: createDOMFactory('bdi'),
  bdo: createDOMFactory('bdo'),
  big: createDOMFactory('big'),
  blockquote: createDOMFactory('blockquote'),
  body: createDOMFactory('body'),
  br: createDOMFactory('br'),
  button: createDOMFactory('button'),
  canvas: createDOMFactory('canvas'),
  caption: createDOMFactory('caption'),
  cite: createDOMFactory('cite'),
  code: createDOMFactory('code'),
  col: createDOMFactory('col'),
  colgroup: createDOMFactory('colgroup'),
  data: createDOMFactory('data'),
  datalist: createDOMFactory('datalist'),
  dd: createDOMFactory('dd'),
  del: createDOMFactory('del'),
  details: createDOMFactory('details'),
  dfn: createDOMFactory('dfn'),
  dialog: createDOMFactory('dialog'),
  div: createDOMFactory('div'),
  dl: createDOMFactory('dl'),
  dt: createDOMFactory('dt'),
  em: createDOMFactory('em'),
  embed: createDOMFactory('embed'),
  fieldset: createDOMFactory('fieldset'),
  figcaption: createDOMFactory('figcaption'),
  figure: createDOMFactory('figure'),
  footer: createDOMFactory('footer'),
  form: createDOMFactory('form'),
  h1: createDOMFactory('h1'),
  h2: createDOMFactory('h2'),
  h3: createDOMFactory('h3'),
  h4: createDOMFactory('h4'),
  h5: createDOMFactory('h5'),
  h6: createDOMFactory('h6'),
  head: createDOMFactory('head'),
  header: createDOMFactory('header'),
  hgroup: createDOMFactory('hgroup'),
  hr: createDOMFactory('hr'),
  html: createDOMFactory('html'),
  i: createDOMFactory('i'),
  iframe: createDOMFactory('iframe'),
  img: createDOMFactory('img'),
  input: createDOMFactory('input'),
  ins: createDOMFactory('ins'),
  kbd: createDOMFactory('kbd'),
  keygen: createDOMFactory('keygen'),
  label: createDOMFactory('label'),
  legend: createDOMFactory('legend'),
  li: createDOMFactory('li'),
  link: createDOMFactory('link'),
  main: createDOMFactory('main'),
  map: createDOMFactory('map'),
  mark: createDOMFactory('mark'),
  menu: createDOMFactory('menu'),
  menuitem: createDOMFactory('menuitem'),
  meta: createDOMFactory('meta'),
  meter: createDOMFactory('meter'),
  nav: createDOMFactory('nav'),
  noscript: createDOMFactory('noscript'),
  object: createDOMFactory('object'),
  ol: createDOMFactory('ol'),
  optgroup: createDOMFactory('optgroup'),
  option: createDOMFactory('option'),
  output: createDOMFactory('output'),
  p: createDOMFactory('p'),
  param: createDOMFactory('param'),
  picture: createDOMFactory('picture'),
  pre: createDOMFactory('pre'),
  progress: createDOMFactory('progress'),
  q: createDOMFactory('q'),
  rp: createDOMFactory('rp'),
  rt: createDOMFactory('rt'),
  ruby: createDOMFactory('ruby'),
  s: createDOMFactory('s'),
  samp: createDOMFactory('samp'),
  script: createDOMFactory('script'),
  section: createDOMFactory('section'),
  select: createDOMFactory('select'),
  small: createDOMFactory('small'),
  source: createDOMFactory('source'),
  span: createDOMFactory('span'),
  strong: createDOMFactory('strong'),
  style: createDOMFactory('style'),
  sub: createDOMFactory('sub'),
  summary: createDOMFactory('summary'),
  sup: createDOMFactory('sup'),
  table: createDOMFactory('table'),
  tbody: createDOMFactory('tbody'),
  td: createDOMFactory('td'),
  textarea: createDOMFactory('textarea'),
  tfoot: createDOMFactory('tfoot'),
  th: createDOMFactory('th'),
  thead: createDOMFactory('thead'),
  time: createDOMFactory('time'),
  title: createDOMFactory('title'),
  tr: createDOMFactory('tr'),
  track: createDOMFactory('track'),
  u: createDOMFactory('u'),
  ul: createDOMFactory('ul'),
  'var': createDOMFactory('var'),
  video: createDOMFactory('video'),
  wbr: createDOMFactory('wbr'),

  // SVG
  circle: createDOMFactory('circle'),
  clipPath: createDOMFactory('clipPath'),
  defs: createDOMFactory('defs'),
  ellipse: createDOMFactory('ellipse'),
  g: createDOMFactory('g'),
  image: createDOMFactory('image'),
  line: createDOMFactory('line'),
  linearGradient: createDOMFactory('linearGradient'),
  mask: createDOMFactory('mask'),
  path: createDOMFactory('path'),
  pattern: createDOMFactory('pattern'),
  polygon: createDOMFactory('polygon'),
  polyline: createDOMFactory('polyline'),
  radialGradient: createDOMFactory('radialGradient'),
  rect: createDOMFactory('rect'),
  stop: createDOMFactory('stop'),
  svg: createDOMFactory('svg'),
  text: createDOMFactory('text'),
  tspan: createDOMFactory('tspan')
};

module.exports = ReactDOMFactories;

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _require = __webpack_require__(34),
    isValidElement = _require.isValidElement;

var factory = __webpack_require__(327);

module.exports = factory(isValidElement);

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



// React 15.5 references this module, and assumes PropTypes are still callable in production.
// Therefore we re-export development-only version with all the PropTypes checks here.
// However if one is migrating to the `prop-types` npm library, they will go through the
// `index.js` entry point, and it will branch depending on the environment.
var factory = __webpack_require__(328);
module.exports = function(isValidElement) {
  // It is still allowed in 15.5.
  var throwOnDirectAccess = false;
  return factory(isValidElement, throwOnDirectAccess);
};


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(12);
var invariant = __webpack_require__(2);
var warning = __webpack_require__(4);

var ReactPropTypesSecret = __webpack_require__(111);
var checkPropTypes = __webpack_require__(329);

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          invariant(
            false,
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            warning(
              false,
              'You are manually calling a React.PropTypes validation ' +
              'function for the `%s` prop on `%s`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
              propFullName,
              componentName
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        warning(
          false,
          'Invalid argument supplid to oneOfType. Expected an array of check functions, but ' +
          'received %s at index %s.',
          getPostfixForTypeWarning(checker),
          i
        );
        return emptyFunction.thatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



if (false) {
  var invariant = require('fbjs/lib/invariant');
  var warning = require('fbjs/lib/warning');
  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
  var loggedTypeFailures = {};
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
        }
      }
    }
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



module.exports = '15.5.4';

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */


var _prodInvariant = __webpack_require__(33);

var ReactElement = __webpack_require__(34);

var invariant = __webpack_require__(2);

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
  return children;
}

module.exports = onlyChild;

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(333);


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/



var ReactDOMComponentTree = __webpack_require__(9);
var ReactDefaultInjection = __webpack_require__(334);
var ReactMount = __webpack_require__(135);
var ReactReconciler = __webpack_require__(37);
var ReactUpdates = __webpack_require__(17);
var ReactVersion = __webpack_require__(410);

var findDOMNode = __webpack_require__(411);
var getHostComponentFromComposite = __webpack_require__(136);
var renderSubtreeIntoContainer = __webpack_require__(412);
var warning = __webpack_require__(4);

ReactDefaultInjection.inject();

var ReactDOM = {
  findDOMNode: findDOMNode,
  render: ReactMount.render,
  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
  version: ReactVersion,

  /* eslint-disable camelcase */
  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
};

// Inject the runtime into a devtools global hook regardless of browser.
// Allows for debugging when the hook is injected on the page.
if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
    ComponentTree: {
      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
      getNodeFromInstance: function (inst) {
        // inst is an internal instance (but could be a composite)
        if (inst._renderedComponent) {
          inst = getHostComponentFromComposite(inst);
        }
        if (inst) {
          return ReactDOMComponentTree.getNodeFromInstance(inst);
        } else {
          return null;
        }
      }
    },
    Mount: ReactMount,
    Reconciler: ReactReconciler
  });
}

if (false) {
  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {

    // First check if devtools is not installed
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
      // If we're in Chrome or Firefox, provide a download link if not installed.
      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
        // Firefox does not have the issue with devtools loaded over file://
        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
      }
    }

    var testFunc = function testFn() {};
    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, 'It looks like you\'re using a minified copy of the development build ' + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;

    // If we're in IE8, check to see if we are in compatibility mode and provide
    // information on preventing compatibility mode
    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;

    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;

    var expectedFeatures = [
    // shims
    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];

    for (var i = 0; i < expectedFeatures.length; i++) {
      if (!expectedFeatures[i]) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
        break;
      }
    }
  }
}

if (false) {
  var ReactInstrumentation = require('./ReactInstrumentation');
  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');

  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
}

module.exports = ReactDOM;

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ARIADOMPropertyConfig = __webpack_require__(335);
var BeforeInputEventPlugin = __webpack_require__(336);
var ChangeEventPlugin = __webpack_require__(340);
var DefaultEventPluginOrder = __webpack_require__(343);
var EnterLeaveEventPlugin = __webpack_require__(344);
var HTMLDOMPropertyConfig = __webpack_require__(345);
var ReactComponentBrowserEnvironment = __webpack_require__(346);
var ReactDOMComponent = __webpack_require__(352);
var ReactDOMComponentTree = __webpack_require__(9);
var ReactDOMEmptyComponent = __webpack_require__(381);
var ReactDOMTreeTraversal = __webpack_require__(382);
var ReactDOMTextComponent = __webpack_require__(383);
var ReactDefaultBatchingStrategy = __webpack_require__(384);
var ReactEventListener = __webpack_require__(385);
var ReactInjection = __webpack_require__(387);
var ReactReconcileTransaction = __webpack_require__(388);
var SVGDOMPropertyConfig = __webpack_require__(394);
var SelectEventPlugin = __webpack_require__(395);
var SimpleEventPlugin = __webpack_require__(396);

var alreadyInjected = false;

function inject() {
  if (alreadyInjected) {
    // TODO: This is currently true because these injections are shared between
    // the client and the server package. They should be built independently
    // and not share any injection state. Then this problem will be solved.
    return;
  }
  alreadyInjected = true;

  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);

  /**
   * Inject modules for resolving DOM hierarchy and plugin ordering.
   */
  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);

  /**
   * Some important event plugins included by default (without having to require
   * them).
   */
  ReactInjection.EventPluginHub.injectEventPluginsByName({
    SimpleEventPlugin: SimpleEventPlugin,
    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
    ChangeEventPlugin: ChangeEventPlugin,
    SelectEventPlugin: SelectEventPlugin,
    BeforeInputEventPlugin: BeforeInputEventPlugin
  });

  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);

  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);

  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);

  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
    return new ReactDOMEmptyComponent(instantiate);
  });

  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);

  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
}

module.exports = {
  inject: inject
};

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ARIADOMPropertyConfig = {
  Properties: {
    // Global States and Properties
    'aria-current': 0, // state
    'aria-details': 0,
    'aria-disabled': 0, // state
    'aria-hidden': 0, // state
    'aria-invalid': 0, // state
    'aria-keyshortcuts': 0,
    'aria-label': 0,
    'aria-roledescription': 0,
    // Widget Attributes
    'aria-autocomplete': 0,
    'aria-checked': 0,
    'aria-expanded': 0,
    'aria-haspopup': 0,
    'aria-level': 0,
    'aria-modal': 0,
    'aria-multiline': 0,
    'aria-multiselectable': 0,
    'aria-orientation': 0,
    'aria-placeholder': 0,
    'aria-pressed': 0,
    'aria-readonly': 0,
    'aria-required': 0,
    'aria-selected': 0,
    'aria-sort': 0,
    'aria-valuemax': 0,
    'aria-valuemin': 0,
    'aria-valuenow': 0,
    'aria-valuetext': 0,
    // Live Region Attributes
    'aria-atomic': 0,
    'aria-busy': 0,
    'aria-live': 0,
    'aria-relevant': 0,
    // Drag-and-Drop Attributes
    'aria-dropeffect': 0,
    'aria-grabbed': 0,
    // Relationship Attributes
    'aria-activedescendant': 0,
    'aria-colcount': 0,
    'aria-colindex': 0,
    'aria-colspan': 0,
    'aria-controls': 0,
    'aria-describedby': 0,
    'aria-errormessage': 0,
    'aria-flowto': 0,
    'aria-labelledby': 0,
    'aria-owns': 0,
    'aria-posinset': 0,
    'aria-rowcount': 0,
    'aria-rowindex': 0,
    'aria-rowspan': 0,
    'aria-setsize': 0
  },
  DOMAttributeNames: {},
  DOMPropertyNames: {}
};

module.exports = ARIADOMPropertyConfig;

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(43);
var ExecutionEnvironment = __webpack_require__(11);
var FallbackCompositionState = __webpack_require__(337);
var SyntheticCompositionEvent = __webpack_require__(338);
var SyntheticInputEvent = __webpack_require__(339);

var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
var START_KEYCODE = 229;

var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;

var documentMode = null;
if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
  documentMode = document.documentMode;
}

// Webkit offers a very useful `textInput` event that can be used to
// directly represent `beforeInput`. The IE `textinput` event is not as
// useful, so we don't use it.
var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();

// In IE9+, we have access to composition events, but the data supplied
// by the native compositionend event may be incorrect. Japanese ideographic
// spaces, for instance (\u3000) are not recorded correctly.
var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);

/**
 * Opera <= 12 includes TextEvent in window, but does not fire
 * text input events. Rely on keypress instead.
 */
function isPresto() {
  var opera = window.opera;
  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
}

var SPACEBAR_CODE = 32;
var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);

// Events and their corresponding property names.
var eventTypes = {
  beforeInput: {
    phasedRegistrationNames: {
      bubbled: 'onBeforeInput',
      captured: 'onBeforeInputCapture'
    },
    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
  },
  compositionEnd: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionEnd',
      captured: 'onCompositionEndCapture'
    },
    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionStart: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionStart',
      captured: 'onCompositionStartCapture'
    },
    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionUpdate: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionUpdate',
      captured: 'onCompositionUpdateCapture'
    },
    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  }
};

// Track whether we've ever handled a keypress on the space key.
var hasSpaceKeypress = false;

/**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */
function isKeypressCommand(nativeEvent) {
  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
  !(nativeEvent.ctrlKey && nativeEvent.altKey);
}

/**
 * Translate native top level events into event types.
 *
 * @param {string} topLevelType
 * @return {object}
 */
function getCompositionEventType(topLevelType) {
  switch (topLevelType) {
    case 'topCompositionStart':
      return eventTypes.compositionStart;
    case 'topCompositionEnd':
      return eventTypes.compositionEnd;
    case 'topCompositionUpdate':
      return eventTypes.compositionUpdate;
  }
}

/**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionStart(topLevelType, nativeEvent) {
  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
}

/**
 * Does our fallback mode think that this event is the end of composition?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionEnd(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topKeyUp':
      // Command keys insert or clear IME input.
      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
    case 'topKeyDown':
      // Expect IME keyCode on each keydown. If we get any other
      // code we must have exited earlier.
      return nativeEvent.keyCode !== START_KEYCODE;
    case 'topKeyPress':
    case 'topMouseDown':
    case 'topBlur':
      // Events are not possible without cancelling IME.
      return true;
    default:
      return false;
  }
}

/**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */
function getDataFromCustomEvent(nativeEvent) {
  var detail = nativeEvent.detail;
  if (typeof detail === 'object' && 'data' in detail) {
    return detail.data;
  }
  return null;
}

// Track the current IME composition fallback object, if any.
var currentComposition = null;

/**
 * @return {?object} A SyntheticCompositionEvent.
 */
function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var eventType;
  var fallbackData;

  if (canUseCompositionEvent) {
    eventType = getCompositionEventType(topLevelType);
  } else if (!currentComposition) {
    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
      eventType = eventTypes.compositionStart;
    }
  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
    eventType = eventTypes.compositionEnd;
  }

  if (!eventType) {
    return null;
  }

  if (useFallbackCompositionData) {
    // The current composition is stored statically and must not be
    // overwritten while composition continues.
    if (!currentComposition && eventType === eventTypes.compositionStart) {
      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
    } else if (eventType === eventTypes.compositionEnd) {
      if (currentComposition) {
        fallbackData = currentComposition.getData();
      }
    }
  }

  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);

  if (fallbackData) {
    // Inject data generated from fallback path into the synthetic event.
    // This matches the property of native CompositionEventInterface.
    event.data = fallbackData;
  } else {
    var customData = getDataFromCustomEvent(nativeEvent);
    if (customData !== null) {
      event.data = customData;
    }
  }

  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The string corresponding to this `beforeInput` event.
 */
function getNativeBeforeInputChars(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topCompositionEnd':
      return getDataFromCustomEvent(nativeEvent);
    case 'topKeyPress':
      /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */
      var which = nativeEvent.which;
      if (which !== SPACEBAR_CODE) {
        return null;
      }

      hasSpaceKeypress = true;
      return SPACEBAR_CHAR;

    case 'topTextInput':
      // Record the characters to be added to the DOM.
      var chars = nativeEvent.data;

      // If it's a spacebar character, assume that we have already handled
      // it at the keypress level and bail immediately. Android Chrome
      // doesn't give us keycodes, so we need to blacklist it.
      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
        return null;
      }

      return chars;

    default:
      // For other native event types, do nothing.
      return null;
  }
}

/**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 *
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The fallback string for this `beforeInput` event.
 */
function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
  // If we are currently composing (IME) and using a fallback to do so,
  // try to extract the composed characters from the fallback object.
  // If composition event is available, we extract a string only at
  // compositionevent, otherwise extract it at fallback events.
  if (currentComposition) {
    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
      var chars = currentComposition.getData();
      FallbackCompositionState.release(currentComposition);
      currentComposition = null;
      return chars;
    }
    return null;
  }

  switch (topLevelType) {
    case 'topPaste':
      // If a paste event occurs after a keypress, throw out the input
      // chars. Paste events should not lead to BeforeInput events.
      return null;
    case 'topKeyPress':
      /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */
      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
        return String.fromCharCode(nativeEvent.which);
      }
      return null;
    case 'topCompositionEnd':
      return useFallbackCompositionData ? null : nativeEvent.data;
    default:
      return null;
  }
}

/**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */
function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var chars;

  if (canUseTextInputEvent) {
    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
  } else {
    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
  }

  // If no characters are being inserted, no BeforeInput event should
  // be fired.
  if (!chars) {
    return null;
  }

  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);

  event.data = chars;
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */
var BeforeInputEventPlugin = {

  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
  }
};

module.exports = BeforeInputEventPlugin;

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(8);

var PooledClass = __webpack_require__(27);

var getTextContentAccessor = __webpack_require__(115);

/**
 * This helper class stores information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 * @param {DOMEventTarget} root
 */
function FallbackCompositionState(root) {
  this._root = root;
  this._startText = this.getText();
  this._fallbackText = null;
}

_assign(FallbackCompositionState.prototype, {
  destructor: function () {
    this._root = null;
    this._startText = null;
    this._fallbackText = null;
  },

  /**
   * Get current text of input.
   *
   * @return {string}
   */
  getText: function () {
    if ('value' in this._root) {
      return this._root.value;
    }
    return this._root[getTextContentAccessor()];
  },

  /**
   * Determine the differing substring between the initially stored
   * text content and the current content.
   *
   * @return {string}
   */
  getData: function () {
    if (this._fallbackText) {
      return this._fallbackText;
    }

    var start;
    var startValue = this._startText;
    var startLength = startValue.length;
    var end;
    var endValue = this.getText();
    var endLength = endValue.length;

    for (start = 0; start < startLength; start++) {
      if (startValue[start] !== endValue[start]) {
        break;
      }
    }

    var minEnd = startLength - start;
    for (end = 1; end <= minEnd; end++) {
      if (startValue[startLength - end] !== endValue[endLength - end]) {
        break;
      }
    }

    var sliceTail = end > 1 ? 1 - end : undefined;
    this._fallbackText = endValue.slice(start, sliceTail);
    return this._fallbackText;
  }
});

PooledClass.addPoolingTo(FallbackCompositionState);

module.exports = FallbackCompositionState;

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(20);

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */
var CompositionEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);

module.exports = SyntheticCompositionEvent;

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(20);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */
var InputEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);

module.exports = SyntheticInputEvent;

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(44);
var EventPropagators = __webpack_require__(43);
var ExecutionEnvironment = __webpack_require__(11);
var ReactDOMComponentTree = __webpack_require__(9);
var ReactUpdates = __webpack_require__(17);
var SyntheticEvent = __webpack_require__(20);

var getEventTarget = __webpack_require__(71);
var isEventSupported = __webpack_require__(72);
var isTextInputElement = __webpack_require__(118);

var eventTypes = {
  change: {
    phasedRegistrationNames: {
      bubbled: 'onChange',
      captured: 'onChangeCapture'
    },
    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
  }
};

/**
 * For IE shims
 */
var activeElement = null;
var activeElementInst = null;
var activeElementValue = null;
var activeElementValueProp = null;

/**
 * SECTION: handle `change` event
 */
function shouldUseChangeEvent(elem) {
  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
}

var doesChangeEventBubble = false;
if (ExecutionEnvironment.canUseDOM) {
  // See `handleChange` comment below
  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
}

function manualDispatchChangeEvent(nativeEvent) {
  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementInst, nativeEvent, getEventTarget(nativeEvent));
  EventPropagators.accumulateTwoPhaseDispatches(event);

  // If change and propertychange bubbled, we'd just bind to it like all the
  // other events and have it go through ReactBrowserEventEmitter. Since it
  // doesn't, we manually listen for the events and so we have to enqueue and
  // process the abstract event manually.
  //
  // Batching is necessary here in order to ensure that all event handlers run
  // before the next rerender (including event handlers attached to ancestor
  // elements instead of directly on the input). Without this, controlled
  // components don't work properly in conjunction with event bubbling because
  // the component is rerendered and the value reverted before all the event
  // handlers can run. See https://github.com/facebook/react/issues/708.
  ReactUpdates.batchedUpdates(runEventInBatch, event);
}

function runEventInBatch(event) {
  EventPluginHub.enqueueEvents(event);
  EventPluginHub.processEventQueue(false);
}

function startWatchingForChangeEventIE8(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
}

function stopWatchingForChangeEventIE8() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
  activeElement = null;
  activeElementInst = null;
}

function getTargetInstForChangeEvent(topLevelType, targetInst) {
  if (topLevelType === 'topChange') {
    return targetInst;
  }
}
function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForChangeEventIE8();
    startWatchingForChangeEventIE8(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForChangeEventIE8();
  }
}

/**
 * SECTION: handle `input` event
 */
var isInputEventSupported = false;
if (ExecutionEnvironment.canUseDOM) {
  // IE9 claims to support the input event but fails to trigger it when
  // deleting text, so we ignore its input events.
  // IE10+ fire input events to often, such when a placeholder
  // changes or when an input with a placeholder is focused.
  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 11);
}

/**
 * (For IE <=11) Replacement getter/setter for the `value` property that gets
 * set on the active element.
 */
var newValueProp = {
  get: function () {
    return activeElementValueProp.get.call(this);
  },
  set: function (val) {
    // Cast to a string so we can do equality checks.
    activeElementValue = '' + val;
    activeElementValueProp.set.call(this, val);
  }
};

/**
 * (For IE <=11) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */
function startWatchingForValueChange(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElementValue = target.value;
  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');

  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
  // on DOM elements
  Object.defineProperty(activeElement, 'value', newValueProp);
  if (activeElement.attachEvent) {
    activeElement.attachEvent('onpropertychange', handlePropertyChange);
  } else {
    activeElement.addEventListener('propertychange', handlePropertyChange, false);
  }
}

/**
 * (For IE <=11) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */
function stopWatchingForValueChange() {
  if (!activeElement) {
    return;
  }

  // delete restores the original property definition
  delete activeElement.value;

  if (activeElement.detachEvent) {
    activeElement.detachEvent('onpropertychange', handlePropertyChange);
  } else {
    activeElement.removeEventListener('propertychange', handlePropertyChange, false);
  }

  activeElement = null;
  activeElementInst = null;
  activeElementValue = null;
  activeElementValueProp = null;
}

/**
 * (For IE <=11) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */
function handlePropertyChange(nativeEvent) {
  if (nativeEvent.propertyName !== 'value') {
    return;
  }
  var value = nativeEvent.srcElement.value;
  if (value === activeElementValue) {
    return;
  }
  activeElementValue = value;

  manualDispatchChangeEvent(nativeEvent);
}

/**
 * If a `change` event should be fired, returns the target's ID.
 */
function getTargetInstForInputEvent(topLevelType, targetInst) {
  if (topLevelType === 'topInput') {
    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
    // what we want so fall through here and trigger an abstract event
    return targetInst;
  }
}

function handleEventsForInputEventIE(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // In IE8, we can capture almost all .value changes by adding a
    // propertychange handler and looking for events with propertyName
    // equal to 'value'
    // In IE9-11, propertychange fires for most input events but is buggy and
    // doesn't fire when text is deleted, but conveniently, selectionchange
    // appears to fire in all of the remaining cases so we catch those and
    // forward the event if the value has changed
    // In either case, we don't want to call the event handler if the value
    // is changed from JS so we redefine a setter for `.value` that updates
    // our activeElementValue variable, allowing us to ignore those changes
    //
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForValueChange();
    startWatchingForValueChange(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForValueChange();
  }
}

// For IE8 and IE9.
function getTargetInstForInputEventIE(topLevelType, targetInst) {
  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
    // On the selectionchange event, the target is just document which isn't
    // helpful for us so just check activeElement instead.
    //
    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
    // propertychange on the first input event after setting `value` from a
    // script and fires only keydown, keypress, keyup. Catching keyup usually
    // gets it and catching keydown lets us fire an event for the first
    // keystroke if user does a key repeat (it'll be a little delayed: right
    // before the second keystroke). Other input methods (e.g., paste) seem to
    // fire selectionchange normally.
    if (activeElement && activeElement.value !== activeElementValue) {
      activeElementValue = activeElement.value;
      return activeElementInst;
    }
  }
}

/**
 * SECTION: handle `click` event
 */
function shouldUseClickEvent(elem) {
  // Use the `click` event to detect changes to checkbox and radio inputs.
  // This approach works across all browsers, whereas `change` does not fire
  // until `blur` in IE8.
  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
}

function getTargetInstForClickEvent(topLevelType, targetInst) {
  if (topLevelType === 'topClick') {
    return targetInst;
  }
}

function handleControlledInputBlur(inst, node) {
  // TODO: In IE, inst is occasionally null. Why?
  if (inst == null) {
    return;
  }

  // Fiber and ReactDOM keep wrapper state in separate places
  var state = inst._wrapperState || node._wrapperState;

  if (!state || !state.controlled || node.type !== 'number') {
    return;
  }

  // If controlled, assign the value attribute to the current value on blur
  var value = '' + node.value;
  if (node.getAttribute('value') !== value) {
    node.setAttribute('value', value);
  }
}

/**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */
var ChangeEventPlugin = {

  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    var getTargetInstFunc, handleEventFunc;
    if (shouldUseChangeEvent(targetNode)) {
      if (doesChangeEventBubble) {
        getTargetInstFunc = getTargetInstForChangeEvent;
      } else {
        handleEventFunc = handleEventsForChangeEventIE8;
      }
    } else if (isTextInputElement(targetNode)) {
      if (isInputEventSupported) {
        getTargetInstFunc = getTargetInstForInputEvent;
      } else {
        getTargetInstFunc = getTargetInstForInputEventIE;
        handleEventFunc = handleEventsForInputEventIE;
      }
    } else if (shouldUseClickEvent(targetNode)) {
      getTargetInstFunc = getTargetInstForClickEvent;
    }

    if (getTargetInstFunc) {
      var inst = getTargetInstFunc(topLevelType, targetInst);
      if (inst) {
        var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, nativeEventTarget);
        event.type = 'change';
        EventPropagators.accumulateTwoPhaseDispatches(event);
        return event;
      }
    }

    if (handleEventFunc) {
      handleEventFunc(topLevelType, targetNode, targetInst);
    }

    // When blurring, set the value attribute for number inputs
    if (topLevelType === 'topBlur') {
      handleControlledInputBlur(targetInst, targetNode);
    }
  }

};

module.exports = ChangeEventPlugin;

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactOwner = __webpack_require__(342);

var ReactRef = {};

function attachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(component.getPublicInstance());
  } else {
    // Legacy ref
    ReactOwner.addComponentAsRefTo(component, ref, owner);
  }
}

function detachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(null);
  } else {
    // Legacy ref
    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
  }
}

ReactRef.attachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    attachRef(ref, instance, element._owner);
  }
};

ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
  // If either the owner or a `ref` has changed, make sure the newest owner
  // has stored a reference to `this`, and the previous owner (if different)
  // has forgotten the reference to `this`. We use the element instead
  // of the public this.props because the post processing cannot determine
  // a ref. The ref conceptually lives on the element.

  // TODO: Should this even be possible? The owner cannot change because
  // it's forbidden by shouldUpdateReactComponent. The ref can change
  // if you swap the keys of but not the refs. Reconsider where this check
  // is made. It probably belongs where the key checking and
  // instantiateReactComponent is done.

  var prevRef = null;
  var prevOwner = null;
  if (prevElement !== null && typeof prevElement === 'object') {
    prevRef = prevElement.ref;
    prevOwner = prevElement._owner;
  }

  var nextRef = null;
  var nextOwner = null;
  if (nextElement !== null && typeof nextElement === 'object') {
    nextRef = nextElement.ref;
    nextOwner = nextElement._owner;
  }

  return prevRef !== nextRef ||
  // If owner changes but we have an unchanged function ref, don't update refs
  typeof nextRef === 'string' && nextOwner !== prevOwner;
};

ReactRef.detachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    detachRef(ref, instance, element._owner);
  }
};

module.exports = ReactRef;

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(5);

var invariant = __webpack_require__(2);

/**
 * @param {?object} object
 * @return {boolean} True if `object` is a valid owner.
 * @final
 */
function isValidOwner(object) {
  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
}

/**
 * ReactOwners are capable of storing references to owned components.
 *
 * All components are capable of //being// referenced by owner components, but
 * only ReactOwner components are capable of //referencing// owned components.
 * The named reference is known as a "ref".
 *
 * Refs are available when mounted and updated during reconciliation.
 *
 *   var MyComponent = React.createClass({
 *     render: function() {
 *       return (
 *         <div onClick={this.handleClick}>
 *           <CustomComponent ref="custom" />
 *         </div>
 *       );
 *     },
 *     handleClick: function() {
 *       this.refs.custom.handleClick();
 *     },
 *     componentDidMount: function() {
 *       this.refs.custom.initialize();
 *     }
 *   });
 *
 * Refs should rarely be used. When refs are used, they should only be done to
 * control data that is not handled by React's data flow.
 *
 * @class ReactOwner
 */
var ReactOwner = {
  /**
   * Adds a component by ref to an owner component.
   *
   * @param {ReactComponent} component Component to reference.
   * @param {string} ref Name by which to refer to the component.
   * @param {ReactOwner} owner Component on which to record the ref.
   * @final
   * @internal
   */
  addComponentAsRefTo: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
    owner.attachRef(ref, component);
  },

  /**
   * Removes a component by ref from an owner component.
   *
   * @param {ReactComponent} component Component to dereference.
   * @param {string} ref Name of the ref to remove.
   * @param {ReactOwner} owner Component on which the ref is recorded.
   * @final
   * @internal
   */
  removeComponentAsRefFrom: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
    var ownerPublicInstance = owner.getPublicInstance();
    // Check that `component`'s owner is still alive and that `component` is still the current ref
    // because we do not want to detach the ref if another component stole it.
    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
      owner.detachRef(ref);
    }
  }

};

module.exports = ReactOwner;

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Module that is injectable into `EventPluginHub`, that specifies a
 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
 * plugins, without having to package every one of them. This is better than
 * having plugins be ordered in the same order that they are injected because
 * that ordering would be influenced by the packaging order.
 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
 */

var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];

module.exports = DefaultEventPluginOrder;

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(43);
var ReactDOMComponentTree = __webpack_require__(9);
var SyntheticMouseEvent = __webpack_require__(52);

var eventTypes = {
  mouseEnter: {
    registrationName: 'onMouseEnter',
    dependencies: ['topMouseOut', 'topMouseOver']
  },
  mouseLeave: {
    registrationName: 'onMouseLeave',
    dependencies: ['topMouseOut', 'topMouseOver']
  }
};

var EnterLeaveEventPlugin = {

  eventTypes: eventTypes,

  /**
   * For almost every interaction we care about, there will be both a top-level
   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
   * we do not extract duplicate events. However, moving the mouse into the
   * browser from outside will not fire a `mouseout` event. In this case, we use
   * the `mouseover` top-level event.
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
      return null;
    }
    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
      // Must not be a mouse in or mouse out - ignoring.
      return null;
    }

    var win;
    if (nativeEventTarget.window === nativeEventTarget) {
      // `nativeEventTarget` is probably a window object.
      win = nativeEventTarget;
    } else {
      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
      var doc = nativeEventTarget.ownerDocument;
      if (doc) {
        win = doc.defaultView || doc.parentWindow;
      } else {
        win = window;
      }
    }

    var from;
    var to;
    if (topLevelType === 'topMouseOut') {
      from = targetInst;
      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
    } else {
      // Moving to a node from outside the window.
      from = null;
      to = targetInst;
    }

    if (from === to) {
      // Nothing pertains to our managed components.
      return null;
    }

    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);

    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
    leave.type = 'mouseleave';
    leave.target = fromNode;
    leave.relatedTarget = toNode;

    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
    enter.type = 'mouseenter';
    enter.target = toNode;
    enter.relatedTarget = fromNode;

    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);

    return [leave, enter];
  }

};

module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(36);

var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;

var HTMLDOMPropertyConfig = {
  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
  Properties: {
    /**
     * Standard Properties
     */
    accept: 0,
    acceptCharset: 0,
    accessKey: 0,
    action: 0,
    allowFullScreen: HAS_BOOLEAN_VALUE,
    allowTransparency: 0,
    alt: 0,
    // specifies target context for links with `preload` type
    as: 0,
    async: HAS_BOOLEAN_VALUE,
    autoComplete: 0,
    // autoFocus is polyfilled/normalized by AutoFocusUtils
    // autoFocus: HAS_BOOLEAN_VALUE,
    autoPlay: HAS_BOOLEAN_VALUE,
    capture: HAS_BOOLEAN_VALUE,
    cellPadding: 0,
    cellSpacing: 0,
    charSet: 0,
    challenge: 0,
    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    cite: 0,
    classID: 0,
    className: 0,
    cols: HAS_POSITIVE_NUMERIC_VALUE,
    colSpan: 0,
    content: 0,
    contentEditable: 0,
    contextMenu: 0,
    controls: HAS_BOOLEAN_VALUE,
    coords: 0,
    crossOrigin: 0,
    data: 0, // For `<object />` acts as `src`.
    dateTime: 0,
    'default': HAS_BOOLEAN_VALUE,
    defer: HAS_BOOLEAN_VALUE,
    dir: 0,
    disabled: HAS_BOOLEAN_VALUE,
    download: HAS_OVERLOADED_BOOLEAN_VALUE,
    draggable: 0,
    encType: 0,
    form: 0,
    formAction: 0,
    formEncType: 0,
    formMethod: 0,
    formNoValidate: HAS_BOOLEAN_VALUE,
    formTarget: 0,
    frameBorder: 0,
    headers: 0,
    height: 0,
    hidden: HAS_BOOLEAN_VALUE,
    high: 0,
    href: 0,
    hrefLang: 0,
    htmlFor: 0,
    httpEquiv: 0,
    icon: 0,
    id: 0,
    inputMode: 0,
    integrity: 0,
    is: 0,
    keyParams: 0,
    keyType: 0,
    kind: 0,
    label: 0,
    lang: 0,
    list: 0,
    loop: HAS_BOOLEAN_VALUE,
    low: 0,
    manifest: 0,
    marginHeight: 0,
    marginWidth: 0,
    max: 0,
    maxLength: 0,
    media: 0,
    mediaGroup: 0,
    method: 0,
    min: 0,
    minLength: 0,
    // Caution; `option.selected` is not updated if `select.multiple` is
    // disabled with `removeAttribute`.
    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    name: 0,
    nonce: 0,
    noValidate: HAS_BOOLEAN_VALUE,
    open: HAS_BOOLEAN_VALUE,
    optimum: 0,
    pattern: 0,
    placeholder: 0,
    playsInline: HAS_BOOLEAN_VALUE,
    poster: 0,
    preload: 0,
    profile: 0,
    radioGroup: 0,
    readOnly: HAS_BOOLEAN_VALUE,
    referrerPolicy: 0,
    rel: 0,
    required: HAS_BOOLEAN_VALUE,
    reversed: HAS_BOOLEAN_VALUE,
    role: 0,
    rows: HAS_POSITIVE_NUMERIC_VALUE,
    rowSpan: HAS_NUMERIC_VALUE,
    sandbox: 0,
    scope: 0,
    scoped: HAS_BOOLEAN_VALUE,
    scrolling: 0,
    seamless: HAS_BOOLEAN_VALUE,
    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    shape: 0,
    size: HAS_POSITIVE_NUMERIC_VALUE,
    sizes: 0,
    span: HAS_POSITIVE_NUMERIC_VALUE,
    spellCheck: 0,
    src: 0,
    srcDoc: 0,
    srcLang: 0,
    srcSet: 0,
    start: HAS_NUMERIC_VALUE,
    step: 0,
    style: 0,
    summary: 0,
    tabIndex: 0,
    target: 0,
    title: 0,
    // Setting .type throws on non-<input> tags
    type: 0,
    useMap: 0,
    value: 0,
    width: 0,
    wmode: 0,
    wrap: 0,

    /**
     * RDFa Properties
     */
    about: 0,
    datatype: 0,
    inlist: 0,
    prefix: 0,
    // property is also supported for OpenGraph in meta tags.
    property: 0,
    resource: 0,
    'typeof': 0,
    vocab: 0,

    /**
     * Non-standard Properties
     */
    // autoCapitalize and autoCorrect are supported in Mobile Safari for
    // keyboard hints.
    autoCapitalize: 0,
    autoCorrect: 0,
    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
    autoSave: 0,
    // color is for Safari mask-icon link
    color: 0,
    // itemProp, itemScope, itemType are for
    // Microdata support. See http://schema.org/docs/gs.html
    itemProp: 0,
    itemScope: HAS_BOOLEAN_VALUE,
    itemType: 0,
    // itemID and itemRef are for Microdata support as well but
    // only specified in the WHATWG spec document. See
    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
    itemID: 0,
    itemRef: 0,
    // results show looking glass icon and recent searches on input
    // search fields in WebKit/Blink
    results: 0,
    // IE-only attribute that specifies security restrictions on an iframe
    // as an alternative to the sandbox attribute on IE<10
    security: 0,
    // IE-only attribute that controls focus behavior
    unselectable: 0
  },
  DOMAttributeNames: {
    acceptCharset: 'accept-charset',
    className: 'class',
    htmlFor: 'for',
    httpEquiv: 'http-equiv'
  },
  DOMPropertyNames: {},
  DOMMutationMethods: {
    value: function (node, value) {
      if (value == null) {
        return node.removeAttribute('value');
      }

      // Number inputs get special treatment due to some edge cases in
      // Chrome. Let everything else assign the value attribute as normal.
      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
      if (node.type !== 'number' || node.hasAttribute('value') === false) {
        node.setAttribute('value', '' + value);
      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
        // Don't assign an attribute if validation reports bad
        // input. Chrome will clear the value. Additionally, don't
        // operate on inputs that have focus, otherwise Chrome might
        // strip off trailing decimal places and cause the user's
        // cursor position to jump to the beginning of the input.
        //
        // In ReactDOMInput, we have an onBlur event that will trigger
        // this function again when focus is lost.
        node.setAttribute('value', '' + value);
      }
    }
  }
};

module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMChildrenOperations = __webpack_require__(74);
var ReactDOMIDOperations = __webpack_require__(351);

/**
 * Abstracts away all functionality of the reconciler that requires knowledge of
 * the browser context. TODO: These callers should be refactored to avoid the
 * need for this injection.
 */
var ReactComponentBrowserEnvironment = {

  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,

  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup

};

module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5);

var DOMLazyTree = __webpack_require__(38);
var ExecutionEnvironment = __webpack_require__(11);

var createNodesFromMarkup = __webpack_require__(348);
var emptyFunction = __webpack_require__(12);
var invariant = __webpack_require__(2);

var Danger = {

  /**
   * Replaces a node with a string of markup at its current position within its
   * parent. The markup must render into a single root node.
   *
   * @param {DOMElement} oldChild Child node to replace.
   * @param {string} markup Markup to render in place of the child node.
   * @internal
   */
  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;

    if (typeof markup === 'string') {
      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
      oldChild.parentNode.replaceChild(newChild, oldChild);
    } else {
      DOMLazyTree.replaceChildWithTree(oldChild, markup);
    }
  }

};

module.exports = Danger;

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/*eslint-disable fb-www/unsafe-html*/

var ExecutionEnvironment = __webpack_require__(11);

var createArrayFromMixed = __webpack_require__(349);
var getMarkupWrap = __webpack_require__(350);
var invariant = __webpack_require__(2);

/**
 * Dummy container used to render all markup.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Pattern used by `getNodeName`.
 */
var nodeNamePattern = /^\s*<(\w+)/;

/**
 * Extracts the `nodeName` of the first element in a string of markup.
 *
 * @param {string} markup String of markup.
 * @return {?string} Node name of the supplied markup.
 */
function getNodeName(markup) {
  var nodeNameMatch = markup.match(nodeNamePattern);
  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
}

/**
 * Creates an array containing the nodes rendered from the supplied markup. The
 * optionally supplied `handleScript` function will be invoked once for each
 * <script> element that is rendered. If no `handleScript` function is supplied,
 * an exception is thrown if any <script> elements are rendered.
 *
 * @param {string} markup A string of valid HTML markup.
 * @param {?function} handleScript Invoked once for each rendered <script>.
 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
 */
function createNodesFromMarkup(markup, handleScript) {
  var node = dummyNode;
  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
  var nodeName = getNodeName(markup);

  var wrap = nodeName && getMarkupWrap(nodeName);
  if (wrap) {
    node.innerHTML = wrap[1] + markup + wrap[2];

    var wrapDepth = wrap[0];
    while (wrapDepth--) {
      node = node.lastChild;
    }
  } else {
    node.innerHTML = markup;
  }

  var scripts = node.getElementsByTagName('script');
  if (scripts.length) {
    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
    createArrayFromMixed(scripts).forEach(handleScript);
  }

  var nodes = Array.from(node.childNodes);
  while (node.lastChild) {
    node.removeChild(node.lastChild);
  }
  return nodes;
}

module.exports = createNodesFromMarkup;

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var invariant = __webpack_require__(2);

/**
 * Convert array-like objects to arrays.
 *
 * This API assumes the caller knows the contents of the data type. For less
 * well defined inputs use createArrayFromMixed.
 *
 * @param {object|function|filelist} obj
 * @return {array}
 */
function toArray(obj) {
  var length = obj.length;

  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
  // in old versions of Safari).
  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;

  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;

  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;

  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;

  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
  // without method will throw during the slice call and skip straight to the
  // fallback.
  if (obj.hasOwnProperty) {
    try {
      return Array.prototype.slice.call(obj);
    } catch (e) {
      // IE < 9 does not support Array#slice on collections objects
    }
  }

  // Fall back to copying key by key. This assumes all keys have a value,
  // so will not preserve sparsely populated inputs.
  var ret = Array(length);
  for (var ii = 0; ii < length; ii++) {
    ret[ii] = obj[ii];
  }
  return ret;
}

/**
 * Perform a heuristic test to determine if an object is "array-like".
 *
 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
 *   Joshu replied: "Mu."
 *
 * This function determines if its argument has "array nature": it returns
 * true if the argument is an actual array, an `arguments' object, or an
 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
 *
 * It will return false for other array-like objects like Filelist.
 *
 * @param {*} obj
 * @return {boolean}
 */
function hasArrayNature(obj) {
  return (
    // not null/false
    !!obj && (
    // arrays are objects, NodeLists are functions in Safari
    typeof obj == 'object' || typeof obj == 'function') &&
    // quacks like an array
    'length' in obj &&
    // not window
    !('setInterval' in obj) &&
    // no DOM node should be considered an array-like
    // a 'select' element has 'length' and 'item' properties on IE8
    typeof obj.nodeType != 'number' && (
    // a real array
    Array.isArray(obj) ||
    // arguments
    'callee' in obj ||
    // HTMLCollection/NodeList
    'item' in obj)
  );
}

/**
 * Ensure that the argument is an array by wrapping it in an array if it is not.
 * Creates a copy of the argument if it is already an array.
 *
 * This is mostly useful idiomatically:
 *
 *   var createArrayFromMixed = require('createArrayFromMixed');
 *
 *   function takesOneOrMoreThings(things) {
 *     things = createArrayFromMixed(things);
 *     ...
 *   }
 *
 * This allows you to treat `things' as an array, but accept scalars in the API.
 *
 * If you need to convert an array-like object, like `arguments`, into an array
 * use toArray instead.
 *
 * @param {*} obj
 * @return {array}
 */
function createArrayFromMixed(obj) {
  if (!hasArrayNature(obj)) {
    return [obj];
  } else if (Array.isArray(obj)) {
    return obj.slice();
  } else {
    return toArray(obj);
  }
}

module.exports = createArrayFromMixed;

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/*eslint-disable fb-www/unsafe-html */

var ExecutionEnvironment = __webpack_require__(11);

var invariant = __webpack_require__(2);

/**
 * Dummy container used to detect which wraps are necessary.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Some browsers cannot use `innerHTML` to render certain elements standalone,
 * so we wrap them, render the wrapped nodes, then extract the desired node.
 *
 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
 */

var shouldWrap = {};

var selectWrap = [1, '<select multiple="true">', '</select>'];
var tableWrap = [1, '<table>', '</table>'];
var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];

var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];

var markupWrap = {
  '*': [1, '?<div>', '</div>'],

  'area': [1, '<map>', '</map>'],
  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
  'legend': [1, '<fieldset>', '</fieldset>'],
  'param': [1, '<object>', '</object>'],
  'tr': [2, '<table><tbody>', '</tbody></table>'],

  'optgroup': selectWrap,
  'option': selectWrap,

  'caption': tableWrap,
  'colgroup': tableWrap,
  'tbody': tableWrap,
  'tfoot': tableWrap,
  'thead': tableWrap,

  'td': trWrap,
  'th': trWrap
};

// Initialize the SVG elements since we know they'll always need to be wrapped
// consistently. If they are created inside a <div> they will be initialized in
// the wrong namespace (and will not display).
var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
svgElements.forEach(function (nodeName) {
  markupWrap[nodeName] = svgWrap;
  shouldWrap[nodeName] = true;
});

/**
 * Gets the markup wrap configuration for the supplied `nodeName`.
 *
 * NOTE: This lazily detects which wraps are necessary for the current browser.
 *
 * @param {string} nodeName Lowercase `nodeName`.
 * @return {?array} Markup wrap configuration, if applicable.
 */
function getMarkupWrap(nodeName) {
  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
  if (!markupWrap.hasOwnProperty(nodeName)) {
    nodeName = '*';
  }
  if (!shouldWrap.hasOwnProperty(nodeName)) {
    if (nodeName === '*') {
      dummyNode.innerHTML = '<link />';
    } else {
      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
    }
    shouldWrap[nodeName] = !dummyNode.firstChild;
  }
  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
}

module.exports = getMarkupWrap;

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMChildrenOperations = __webpack_require__(74);
var ReactDOMComponentTree = __webpack_require__(9);

/**
 * Operations used to process updates to DOM nodes.
 */
var ReactDOMIDOperations = {

  /**
   * Updates a component's children by processing a series of updates.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
    DOMChildrenOperations.processUpdates(node, updates);
  }
};

module.exports = ReactDOMIDOperations;

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* global hasOwnProperty:true */



var _prodInvariant = __webpack_require__(5),
    _assign = __webpack_require__(8);

var AutoFocusUtils = __webpack_require__(353);
var CSSPropertyOperations = __webpack_require__(354);
var DOMLazyTree = __webpack_require__(38);
var DOMNamespaces = __webpack_require__(75);
var DOMProperty = __webpack_require__(36);
var DOMPropertyOperations = __webpack_require__(123);
var EventPluginHub = __webpack_require__(44);
var EventPluginRegistry = __webpack_require__(68);
var ReactBrowserEventEmitter = __webpack_require__(55);
var ReactDOMComponentFlags = __webpack_require__(112);
var ReactDOMComponentTree = __webpack_require__(9);
var ReactDOMInput = __webpack_require__(364);
var ReactDOMOption = __webpack_require__(370);
var ReactDOMSelect = __webpack_require__(124);
var ReactDOMTextarea = __webpack_require__(371);
var ReactInstrumentation = __webpack_require__(14);
var ReactMultiChild = __webpack_require__(372);
var ReactServerRenderingTransaction = __webpack_require__(379);

var emptyFunction = __webpack_require__(12);
var escapeTextContentForBrowser = __webpack_require__(54);
var invariant = __webpack_require__(2);
var isEventSupported = __webpack_require__(72);
var shallowEqual = __webpack_require__(79);
var validateDOMNesting = __webpack_require__(83);
var warning = __webpack_require__(4);

var Flags = ReactDOMComponentFlags;
var deleteListener = EventPluginHub.deleteListener;
var getNode = ReactDOMComponentTree.getNodeFromInstance;
var listenTo = ReactBrowserEventEmitter.listenTo;
var registrationNameModules = EventPluginRegistry.registrationNameModules;

// For quickly matching children type, to test if can be treated as content.
var CONTENT_TYPES = { 'string': true, 'number': true };

var STYLE = 'style';
var HTML = '__html';
var RESERVED_PROPS = {
  children: null,
  dangerouslySetInnerHTML: null,
  suppressContentEditableWarning: null
};

// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
var DOC_FRAGMENT_TYPE = 11;

function getDeclarationErrorAddendum(internalInstance) {
  if (internalInstance) {
    var owner = internalInstance._currentElement._owner || null;
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' This DOM node was rendered by `' + name + '`.';
      }
    }
  }
  return '';
}

function friendlyStringify(obj) {
  if (typeof obj === 'object') {
    if (Array.isArray(obj)) {
      return '[' + obj.map(friendlyStringify).join(', ') + ']';
    } else {
      var pairs = [];
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
        }
      }
      return '{' + pairs.join(', ') + '}';
    }
  } else if (typeof obj === 'string') {
    return JSON.stringify(obj);
  } else if (typeof obj === 'function') {
    return '[function object]';
  }
  // Differs from JSON.stringify in that undefined because undefined and that
  // inf and nan don't become null
  return String(obj);
}

var styleMutationWarning = {};

function checkAndWarnForMutatedStyle(style1, style2, component) {
  if (style1 == null || style2 == null) {
    return;
  }
  if (shallowEqual(style1, style2)) {
    return;
  }

  var componentName = component._tag;
  var owner = component._currentElement._owner;
  var ownerName;
  if (owner) {
    ownerName = owner.getName();
  }

  var hash = ownerName + '|' + componentName;

  if (styleMutationWarning.hasOwnProperty(hash)) {
    return;
  }

  styleMutationWarning[hash] = true;

   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
}

/**
 * @param {object} component
 * @param {?object} props
 */
function assertValidProps(component, props) {
  if (!props) {
    return;
  }
  // Note the use of `==` which checks for null or undefined.
  if (voidElementTags[component._tag]) {
    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
  }
  if (props.dangerouslySetInnerHTML != null) {
    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
  }
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
  }
  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
}

function enqueuePutListener(inst, registrationName, listener, transaction) {
  if (transaction instanceof ReactServerRenderingTransaction) {
    return;
  }
  if (false) {
    // IE8 has no API for event capturing and the `onScroll` event doesn't
    // bubble.
    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : void 0;
  }
  var containerInfo = inst._hostContainerInfo;
  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
  listenTo(registrationName, doc);
  transaction.getReactMountReady().enqueue(putListener, {
    inst: inst,
    registrationName: registrationName,
    listener: listener
  });
}

function putListener() {
  var listenerToPut = this;
  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
}

function inputPostMount() {
  var inst = this;
  ReactDOMInput.postMountWrapper(inst);
}

function textareaPostMount() {
  var inst = this;
  ReactDOMTextarea.postMountWrapper(inst);
}

function optionPostMount() {
  var inst = this;
  ReactDOMOption.postMountWrapper(inst);
}

var setAndValidateContentChildDev = emptyFunction;
if (false) {
  setAndValidateContentChildDev = function (content) {
    var hasExistingContent = this._contentDebugID != null;
    var debugID = this._debugID;
    // This ID represents the inlined child that has no backing instance:
    var contentDebugID = -debugID;

    if (content == null) {
      if (hasExistingContent) {
        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
      }
      this._contentDebugID = null;
      return;
    }

    validateDOMNesting(null, String(content), this, this._ancestorInfo);
    this._contentDebugID = contentDebugID;
    if (hasExistingContent) {
      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
    } else {
      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
    }
  };
}

// There are so many media events, it makes sense to just
// maintain a list rather than create a `trapBubbledEvent` for each
var mediaEvents = {
  topAbort: 'abort',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTimeUpdate: 'timeupdate',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting'
};

function trapBubbledEventsLocal() {
  var inst = this;
  // If a component renders to null or if another component fatals and causes
  // the state of the tree to be corrupted, `node` here can be null.
  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
  var node = getNode(inst);
  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;

  switch (inst._tag) {
    case 'iframe':
    case 'object':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'video':
    case 'audio':

      inst._wrapperState.listeners = [];
      // Create listener for each media event
      for (var event in mediaEvents) {
        if (mediaEvents.hasOwnProperty(event)) {
          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
        }
      }
      break;
    case 'source':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
      break;
    case 'img':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'form':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
      break;
    case 'input':
    case 'select':
    case 'textarea':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
      break;
  }
}

function postUpdateSelectWrapper() {
  ReactDOMSelect.postUpdateWrapper(this);
}

// For HTML, certain tags should omit their close tag. We keep a whitelist for
// those special-case tags.

var omittedCloseTags = {
  'area': true,
  'base': true,
  'br': true,
  'col': true,
  'embed': true,
  'hr': true,
  'img': true,
  'input': true,
  'keygen': true,
  'link': true,
  'meta': true,
  'param': true,
  'source': true,
  'track': true,
  'wbr': true
};

var newlineEatingTags = {
  'listing': true,
  'pre': true,
  'textarea': true
};

// For HTML, certain tags cannot have children. This has the same purpose as
// `omittedCloseTags` except that `menuitem` should still have its closing tag.

var voidElementTags = _assign({
  'menuitem': true
}, omittedCloseTags);

// We accept any tag to be rendered but since this gets injected into arbitrary
// HTML, we want to make sure that it's a safe tag.
// http://www.w3.org/TR/REC-xml/#NT-Name

var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
var validatedTagCache = {};
var hasOwnProperty = {}.hasOwnProperty;

function validateDangerousTag(tag) {
  if (!hasOwnProperty.call(validatedTagCache, tag)) {
    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
    validatedTagCache[tag] = true;
  }
}

function isCustomComponent(tagName, props) {
  return tagName.indexOf('-') >= 0 || props.is != null;
}

var globalIdCounter = 1;

/**
 * Creates a new React class that is idempotent and capable of containing other
 * React components. It accepts event listeners and DOM properties that are
 * valid according to `DOMProperty`.
 *
 *  - Event listeners: `onClick`, `onMouseDown`, etc.
 *  - DOM properties: `className`, `name`, `title`, etc.
 *
 * The `style` property functions differently from the DOM API. It accepts an
 * object mapping of style properties to values.
 *
 * @constructor ReactDOMComponent
 * @extends ReactMultiChild
 */
function ReactDOMComponent(element) {
  var tag = element.type;
  validateDangerousTag(tag);
  this._currentElement = element;
  this._tag = tag.toLowerCase();
  this._namespaceURI = null;
  this._renderedChildren = null;
  this._previousStyle = null;
  this._previousStyleCopy = null;
  this._hostNode = null;
  this._hostParent = null;
  this._rootNodeID = 0;
  this._domID = 0;
  this._hostContainerInfo = null;
  this._wrapperState = null;
  this._topLevelWrapper = null;
  this._flags = 0;
  if (false) {
    this._ancestorInfo = null;
    setAndValidateContentChildDev.call(this, null);
  }
}

ReactDOMComponent.displayName = 'ReactDOMComponent';

ReactDOMComponent.Mixin = {

  /**
   * Generates root tag markup then recurses. This method has side effects and
   * is not idempotent.
   *
   * @internal
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?ReactDOMComponent} the parent component instance
   * @param {?object} info about the host container
   * @param {object} context
   * @return {string} The computed markup.
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    this._rootNodeID = globalIdCounter++;
    this._domID = hostContainerInfo._idCounter++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var props = this._currentElement.props;

    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        this._wrapperState = {
          listeners: null
        };
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'input':
        ReactDOMInput.mountWrapper(this, props, hostParent);
        props = ReactDOMInput.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'option':
        ReactDOMOption.mountWrapper(this, props, hostParent);
        props = ReactDOMOption.getHostProps(this, props);
        break;
      case 'select':
        ReactDOMSelect.mountWrapper(this, props, hostParent);
        props = ReactDOMSelect.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'textarea':
        ReactDOMTextarea.mountWrapper(this, props, hostParent);
        props = ReactDOMTextarea.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
    }

    assertValidProps(this, props);

    // We create tags in the namespace of their parent container, except HTML
    // tags get no namespace.
    var namespaceURI;
    var parentTag;
    if (hostParent != null) {
      namespaceURI = hostParent._namespaceURI;
      parentTag = hostParent._tag;
    } else if (hostContainerInfo._tag) {
      namespaceURI = hostContainerInfo._namespaceURI;
      parentTag = hostContainerInfo._tag;
    }
    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
      namespaceURI = DOMNamespaces.html;
    }
    if (namespaceURI === DOMNamespaces.html) {
      if (this._tag === 'svg') {
        namespaceURI = DOMNamespaces.svg;
      } else if (this._tag === 'math') {
        namespaceURI = DOMNamespaces.mathml;
      }
    }
    this._namespaceURI = namespaceURI;

    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo._tag) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(this._tag, null, this, parentInfo);
      }
      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
    }

    var mountImage;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var el;
      if (namespaceURI === DOMNamespaces.html) {
        if (this._tag === 'script') {
          // Create the script via .innerHTML so its "parser-inserted" flag is
          // set to true and it does not execute
          var div = ownerDocument.createElement('div');
          var type = this._currentElement.type;
          div.innerHTML = '<' + type + '></' + type + '>';
          el = div.removeChild(div.firstChild);
        } else if (props.is) {
          el = ownerDocument.createElement(this._currentElement.type, props.is);
        } else {
          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
          // See discussion in https://github.com/facebook/react/pull/6896
          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
          el = ownerDocument.createElement(this._currentElement.type);
        }
      } else {
        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
      }
      ReactDOMComponentTree.precacheNode(this, el);
      this._flags |= Flags.hasCachedChildNodes;
      if (!this._hostParent) {
        DOMPropertyOperations.setAttributeForRoot(el);
      }
      this._updateDOMProperties(null, props, transaction);
      var lazyTree = DOMLazyTree(el);
      this._createInitialChildren(transaction, props, context, lazyTree);
      mountImage = lazyTree;
    } else {
      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
      var tagContent = this._createContentMarkup(transaction, props, context);
      if (!tagContent && omittedCloseTags[this._tag]) {
        mountImage = tagOpen + '/>';
      } else {
        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
      }
    }

    switch (this._tag) {
      case 'input':
        transaction.getReactMountReady().enqueue(inputPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'textarea':
        transaction.getReactMountReady().enqueue(textareaPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'select':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'button':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'option':
        transaction.getReactMountReady().enqueue(optionPostMount, this);
        break;
    }

    return mountImage;
  },

  /**
   * Creates markup for the open tag and all attributes.
   *
   * This method has side effects because events get registered.
   *
   * Iterating over object properties is faster than iterating over arrays.
   * @see http://jsperf.com/obj-vs-arr-iteration
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @return {string} Markup of opening tag.
   */
  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
    var ret = '<' + this._currentElement.type;

    for (var propKey in props) {
      if (!props.hasOwnProperty(propKey)) {
        continue;
      }
      var propValue = props[propKey];
      if (propValue == null) {
        continue;
      }
      if (registrationNameModules.hasOwnProperty(propKey)) {
        if (propValue) {
          enqueuePutListener(this, propKey, propValue, transaction);
        }
      } else {
        if (propKey === STYLE) {
          if (propValue) {
            if (false) {
              // See `_updateDOMProperties`. style block
              this._previousStyle = propValue;
            }
            propValue = this._previousStyleCopy = _assign({}, props.style);
          }
          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
        }
        var markup = null;
        if (this._tag != null && isCustomComponent(this._tag, props)) {
          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
          }
        } else {
          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
        }
        if (markup) {
          ret += ' ' + markup;
        }
      }
    }

    // For static pages, no need to put React ID and checksum. Saves lots of
    // bytes.
    if (transaction.renderToStaticMarkup) {
      return ret;
    }

    if (!this._hostParent) {
      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
    }
    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
    return ret;
  },

  /**
   * Creates markup for the content between the tags.
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @param {object} context
   * @return {string} Content markup.
   */
  _createContentMarkup: function (transaction, props, context) {
    var ret = '';

    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        ret = innerHTML.__html;
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      if (contentToUse != null) {
        // TODO: Validate that text is allowed as a child of this node
        ret = escapeTextContentForBrowser(contentToUse);
        if (false) {
          setAndValidateContentChildDev.call(this, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        ret = mountImages.join('');
      }
    }
    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
      // text/html ignores the first character in these tags if it's a newline
      // Prefer to break application/xml over text/html (for now) by adding
      // a newline specifically to get eaten by the parser. (Alternately for
      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
      // \r is normalized out by HTMLTextAreaElement#value.)
      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
      // See: Parsing of "textarea" "listing" and "pre" elements
      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
      return '\n' + ret;
    } else {
      return ret;
    }
  },

  _createInitialChildren: function (transaction, props, context, lazyTree) {
    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      // TODO: Validate that text is allowed as a child of this node
      if (contentToUse != null) {
        // Avoid setting textContent when the text is empty. In IE11 setting
        // textContent on a text area will cause the placeholder to not
        // show within the textarea until it has been focused and blurred again.
        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
        if (contentToUse !== '') {
          if (false) {
            setAndValidateContentChildDev.call(this, contentToUse);
          }
          DOMLazyTree.queueText(lazyTree, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        for (var i = 0; i < mountImages.length; i++) {
          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
        }
      }
    }
  },

  /**
   * Receives a next element and updates the component.
   *
   * @internal
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} context
   */
  receiveComponent: function (nextElement, transaction, context) {
    var prevElement = this._currentElement;
    this._currentElement = nextElement;
    this.updateComponent(transaction, prevElement, nextElement, context);
  },

  /**
   * Updates a DOM component after it has already been allocated and
   * attached to the DOM. Reconciles the root DOM node, then recurses.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevElement
   * @param {ReactElement} nextElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevElement, nextElement, context) {
    var lastProps = prevElement.props;
    var nextProps = this._currentElement.props;

    switch (this._tag) {
      case 'input':
        lastProps = ReactDOMInput.getHostProps(this, lastProps);
        nextProps = ReactDOMInput.getHostProps(this, nextProps);
        break;
      case 'option':
        lastProps = ReactDOMOption.getHostProps(this, lastProps);
        nextProps = ReactDOMOption.getHostProps(this, nextProps);
        break;
      case 'select':
        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
        break;
      case 'textarea':
        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
        break;
    }

    assertValidProps(this, nextProps);
    this._updateDOMProperties(lastProps, nextProps, transaction);
    this._updateDOMChildren(lastProps, nextProps, transaction, context);

    switch (this._tag) {
      case 'input':
        // Update the wrapper around inputs *after* updating props. This has to
        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
        // raise warnings and prevent the new value from being assigned.
        ReactDOMInput.updateWrapper(this);
        break;
      case 'textarea':
        ReactDOMTextarea.updateWrapper(this);
        break;
      case 'select':
        // <select> value update needs to occur after <option> children
        // reconciliation
        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
        break;
    }
  },

  /**
   * Reconciles the properties by detecting differences in property values and
   * updating the DOM as necessary. This function is probably the single most
   * critical path for performance optimization.
   *
   * TODO: Benchmark whether checking for changed values in memory actually
   *       improves performance (especially statically positioned elements).
   * TODO: Benchmark the effects of putting this at the top since 99% of props
   *       do not change for a given reconciliation.
   * TODO: Benchmark areas that can be improved with caching.
   *
   * @private
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {?DOMElement} node
   */
  _updateDOMProperties: function (lastProps, nextProps, transaction) {
    var propKey;
    var styleName;
    var styleUpdates;
    for (propKey in lastProps) {
      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
        continue;
      }
      if (propKey === STYLE) {
        var lastStyle = this._previousStyleCopy;
        for (styleName in lastStyle) {
          if (lastStyle.hasOwnProperty(styleName)) {
            styleUpdates = styleUpdates || {};
            styleUpdates[styleName] = '';
          }
        }
        this._previousStyleCopy = null;
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (lastProps[propKey]) {
          // Only call deleteListener if there was a listener previously or
          // else willDeleteListener gets called when there wasn't actually a
          // listener (e.g., onClick={null})
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, lastProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
      }
    }
    for (propKey in nextProps) {
      var nextProp = nextProps[propKey];
      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
        continue;
      }
      if (propKey === STYLE) {
        if (nextProp) {
          if (false) {
            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
            this._previousStyle = nextProp;
          }
          nextProp = this._previousStyleCopy = _assign({}, nextProp);
        } else {
          this._previousStyleCopy = null;
        }
        if (lastProp) {
          // Unset styles on `lastProp` but not on `nextProp`.
          for (styleName in lastProp) {
            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = '';
            }
          }
          // Update styles that changed since `lastProp`.
          for (styleName in nextProp) {
            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = nextProp[styleName];
            }
          }
        } else {
          // Relies on `updateStylesByID` not mutating `styleUpdates`.
          styleUpdates = nextProp;
        }
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (nextProp) {
          enqueuePutListener(this, propKey, nextProp, transaction);
        } else if (lastProp) {
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, nextProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        var node = getNode(this);
        // If we're updating to null or undefined, we should remove the property
        // from the DOM node instead of inadvertently setting to a string. This
        // brings us in line with the same behavior we have on initial render.
        if (nextProp != null) {
          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
        } else {
          DOMPropertyOperations.deleteValueForProperty(node, propKey);
        }
      }
    }
    if (styleUpdates) {
      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
    }
  },

  /**
   * Reconciles the children with the various properties that affect the
   * children content.
   *
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   */
  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;

    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;

    // Note the use of `!=` which checks for null or undefined.
    var lastChildren = lastContent != null ? null : lastProps.children;
    var nextChildren = nextContent != null ? null : nextProps.children;

    // If we're switching from children to content/html or vice versa, remove
    // the old content
    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
    if (lastChildren != null && nextChildren == null) {
      this.updateChildren(null, transaction, context);
    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
      this.updateTextContent('');
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    }

    if (nextContent != null) {
      if (lastContent !== nextContent) {
        this.updateTextContent('' + nextContent);
        if (false) {
          setAndValidateContentChildDev.call(this, nextContent);
        }
      }
    } else if (nextHtml != null) {
      if (lastHtml !== nextHtml) {
        this.updateMarkup('' + nextHtml);
      }
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    } else if (nextChildren != null) {
      if (false) {
        setAndValidateContentChildDev.call(this, null);
      }

      this.updateChildren(nextChildren, transaction, context);
    }
  },

  getHostNode: function () {
    return getNode(this);
  },

  /**
   * Destroys all event registrations for this instance. Does not remove from
   * the DOM. That must be done by the parent.
   *
   * @internal
   */
  unmountComponent: function (safely) {
    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        var listeners = this._wrapperState.listeners;
        if (listeners) {
          for (var i = 0; i < listeners.length; i++) {
            listeners[i].remove();
          }
        }
        break;
      case 'html':
      case 'head':
      case 'body':
        /**
         * Components like <html> <head> and <body> can't be removed or added
         * easily in a cross-browser way, however it's valuable to be able to
         * take advantage of React's reconciliation for styling and <title>
         * management. So we just document it and throw in dangerous cases.
         */
         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
        break;
    }

    this.unmountChildren(safely);
    ReactDOMComponentTree.uncacheNode(this);
    EventPluginHub.deleteAllListeners(this);
    this._rootNodeID = 0;
    this._domID = 0;
    this._wrapperState = null;

    if (false) {
      setAndValidateContentChildDev.call(this, null);
    }
  },

  getPublicInstance: function () {
    return getNode(this);
  }

};

_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);

module.exports = ReactDOMComponent;

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMComponentTree = __webpack_require__(9);

var focusNode = __webpack_require__(121);

var AutoFocusUtils = {
  focusDOMComponent: function () {
    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
  }
};

module.exports = AutoFocusUtils;

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var CSSProperty = __webpack_require__(122);
var ExecutionEnvironment = __webpack_require__(11);
var ReactInstrumentation = __webpack_require__(14);

var camelizeStyleName = __webpack_require__(355);
var dangerousStyleValue = __webpack_require__(357);
var hyphenateStyleName = __webpack_require__(358);
var memoizeStringOnly = __webpack_require__(360);
var warning = __webpack_require__(4);

var processStyleName = memoizeStringOnly(function (styleName) {
  return hyphenateStyleName(styleName);
});

var hasShorthandPropertyBug = false;
var styleFloatAccessor = 'cssFloat';
if (ExecutionEnvironment.canUseDOM) {
  var tempStyle = document.createElement('div').style;
  try {
    // IE8 throws "Invalid argument." if resetting shorthand style properties.
    tempStyle.font = '';
  } catch (e) {
    hasShorthandPropertyBug = true;
  }
  // IE8 only supports accessing cssFloat (standard) as styleFloat
  if (document.documentElement.style.cssFloat === undefined) {
    styleFloatAccessor = 'styleFloat';
  }
}

if (false) {
  // 'msTransform' is correct, but the other prefixes should be capitalized
  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;

  // style values shouldn't contain a semicolon
  var badStyleValueWithSemicolonPattern = /;\s*$/;

  var warnedStyleNames = {};
  var warnedStyleValues = {};
  var warnedForNaNValue = false;

  var warnHyphenatedStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
  };

  var warnBadVendoredStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
  };

  var warnStyleValueWithSemicolon = function (name, value, owner) {
    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
      return;
    }

    warnedStyleValues[value] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon.%s ' + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
  };

  var warnStyleValueIsNaN = function (name, value, owner) {
    if (warnedForNaNValue) {
      return;
    }

    warnedForNaNValue = true;
    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
  };

  var checkRenderMessage = function (owner) {
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' Check the render method of `' + name + '`.';
      }
    }
    return '';
  };

  /**
   * @param {string} name
   * @param {*} value
   * @param {ReactDOMComponent} component
   */
  var warnValidStyle = function (name, value, component) {
    var owner;
    if (component) {
      owner = component._currentElement._owner;
    }
    if (name.indexOf('-') > -1) {
      warnHyphenatedStyleName(name, owner);
    } else if (badVendoredStyleNamePattern.test(name)) {
      warnBadVendoredStyleName(name, owner);
    } else if (badStyleValueWithSemicolonPattern.test(value)) {
      warnStyleValueWithSemicolon(name, value, owner);
    }

    if (typeof value === 'number' && isNaN(value)) {
      warnStyleValueIsNaN(name, value, owner);
    }
  };
}

/**
 * Operations for dealing with CSS properties.
 */
var CSSPropertyOperations = {

  /**
   * Serializes a mapping of style properties for use as inline styles:
   *
   *   > createMarkupForStyles({width: '200px', height: 0})
   *   "width:200px;height:0;"
   *
   * Undefined values are ignored so that declarative programming is easier.
   * The result should be HTML-escaped before insertion into the DOM.
   *
   * @param {object} styles
   * @param {ReactDOMComponent} component
   * @return {?string}
   */
  createMarkupForStyles: function (styles, component) {
    var serialized = '';
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var styleValue = styles[styleName];
      if (false) {
        warnValidStyle(styleName, styleValue, component);
      }
      if (styleValue != null) {
        serialized += processStyleName(styleName) + ':';
        serialized += dangerousStyleValue(styleName, styleValue, component) + ';';
      }
    }
    return serialized || null;
  },

  /**
   * Sets the value for multiple styles on a node.  If a value is specified as
   * '' (empty string), the corresponding style property will be unset.
   *
   * @param {DOMElement} node
   * @param {object} styles
   * @param {ReactDOMComponent} component
   */
  setValueForStyles: function (node, styles, component) {
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: component._debugID,
        type: 'update styles',
        payload: styles
      });
    }

    var style = node.style;
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      if (false) {
        warnValidStyle(styleName, styles[styleName], component);
      }
      var styleValue = dangerousStyleValue(styleName, styles[styleName], component);
      if (styleName === 'float' || styleName === 'cssFloat') {
        styleName = styleFloatAccessor;
      }
      if (styleValue) {
        style[styleName] = styleValue;
      } else {
        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
        if (expansion) {
          // Shorthand property that IE8 won't like unsetting, so unset each
          // component to placate it
          for (var individualStyleName in expansion) {
            style[individualStyleName] = '';
          }
        } else {
          style[styleName] = '';
        }
      }
    }
  }

};

module.exports = CSSPropertyOperations;

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var camelize = __webpack_require__(356);

var msPattern = /^-ms-/;

/**
 * Camelcases a hyphenated CSS property name, for example:
 *
 *   > camelizeStyleName('background-color')
 *   < "backgroundColor"
 *   > camelizeStyleName('-moz-transition')
 *   < "MozTransition"
 *   > camelizeStyleName('-ms-transition')
 *   < "msTransition"
 *
 * As Andi Smith suggests
 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
 * is converted to lowercase `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function camelizeStyleName(string) {
  return camelize(string.replace(msPattern, 'ms-'));
}

module.exports = camelizeStyleName;

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _hyphenPattern = /-(.)/g;

/**
 * Camelcases a hyphenated string, for example:
 *
 *   > camelize('background-color')
 *   < "backgroundColor"
 *
 * @param {string} string
 * @return {string}
 */
function camelize(string) {
  return string.replace(_hyphenPattern, function (_, character) {
    return character.toUpperCase();
  });
}

module.exports = camelize;

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var CSSProperty = __webpack_require__(122);
var warning = __webpack_require__(4);

var isUnitlessNumber = CSSProperty.isUnitlessNumber;
var styleWarnings = {};

/**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @param {ReactDOMComponent} component
 * @return {string} Normalized style value with dimensions applied.
 */
function dangerousStyleValue(name, value, component) {
  // Note that we've removed escapeTextForBrowser() calls here since the
  // whole string will be escaped when the attribute is injected into
  // the markup. If you provide unsafe user data here they can inject
  // arbitrary CSS which may be problematic (I couldn't repro this):
  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
  // This is not an XSS hole but instead a potential CSS injection issue
  // which has lead to a greater discussion about how we're going to
  // trust URLs moving forward. See #2115901

  var isEmpty = value == null || typeof value === 'boolean' || value === '';
  if (isEmpty) {
    return '';
  }

  var isNonNumeric = isNaN(value);
  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
    return '' + value; // cast to string
  }

  if (typeof value === 'string') {
    if (false) {
      // Allow '0' to pass through without warning. 0 is already special and
      // doesn't require units, so we don't need to warn about it.
      if (component && value !== '0') {
        var owner = component._currentElement._owner;
        var ownerName = owner ? owner.getName() : null;
        if (ownerName && !styleWarnings[ownerName]) {
          styleWarnings[ownerName] = {};
        }
        var warned = false;
        if (ownerName) {
          var warnings = styleWarnings[ownerName];
          warned = warnings[name];
          if (!warned) {
            warnings[name] = true;
          }
        }
        if (!warned) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
        }
      }
    }
    value = value.trim();
  }
  return value + 'px';
}

module.exports = dangerousStyleValue;

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var hyphenate = __webpack_require__(359);

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @typechecks static-only
 */



/**
 * Memoizes the return value of a function that accepts one string argument.
 */

function memoizeStringOnly(callback) {
  var cache = {};
  return function (string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }
    return cache[string];
  };
}

module.exports = memoizeStringOnly;

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var escapeTextContentForBrowser = __webpack_require__(54);

/**
 * Escapes attribute value to prevent scripting attacks.
 *
 * @param {*} value Value to escape.
 * @return {string} An escaped string.
 */
function quoteAttributeValueForBrowser(value) {
  return '"' + escapeTextContentForBrowser(value) + '"';
}

module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(44);

function runEventQueueInBatch(events) {
  EventPluginHub.enqueueEvents(events);
  EventPluginHub.processEventQueue(false);
}

var ReactEventEmitterMixin = {

  /**
   * Streams a fired top-level event to `EventPluginHub` where plugins have the
   * opportunity to create `ReactEvent`s to be dispatched.
   */
  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
    runEventQueueInBatch(events);
  }
};

module.exports = ReactEventEmitterMixin;

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(11);

/**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */
function makePrefixMap(styleProp, eventName) {
  var prefixes = {};

  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
  prefixes['Moz' + styleProp] = 'moz' + eventName;
  prefixes['ms' + styleProp] = 'MS' + eventName;
  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();

  return prefixes;
}

/**
 * A list of event names to a configurable list of vendor prefixes.
 */
var vendorPrefixes = {
  animationend: makePrefixMap('Animation', 'AnimationEnd'),
  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
  animationstart: makePrefixMap('Animation', 'AnimationStart'),
  transitionend: makePrefixMap('Transition', 'TransitionEnd')
};

/**
 * Event names that have already been detected and prefixed (if applicable).
 */
var prefixedEventNames = {};

/**
 * Element to check for prefixes on.
 */
var style = {};

/**
 * Bootstrap if a DOM exists.
 */
if (ExecutionEnvironment.canUseDOM) {
  style = document.createElement('div').style;

  // On some platforms, in particular some releases of Android 4.x,
  // the un-prefixed "animation" and "transition" properties are defined on the
  // style object but the events that fire will still be prefixed, so we need
  // to check if the un-prefixed events are usable, and if not remove them from the map.
  if (!('AnimationEvent' in window)) {
    delete vendorPrefixes.animationend.animation;
    delete vendorPrefixes.animationiteration.animation;
    delete vendorPrefixes.animationstart.animation;
  }

  // Same as above
  if (!('TransitionEvent' in window)) {
    delete vendorPrefixes.transitionend.transition;
  }
}

/**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */
function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  } else if (!vendorPrefixes[eventName]) {
    return eventName;
  }

  var prefixMap = vendorPrefixes[eventName];

  for (var styleProp in prefixMap) {
    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
      return prefixedEventNames[eventName] = prefixMap[styleProp];
    }
  }

  return '';
}

module.exports = getVendorPrefixedEventName;

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5),
    _assign = __webpack_require__(8);

var DOMPropertyOperations = __webpack_require__(123);
var LinkedValueUtils = __webpack_require__(77);
var ReactDOMComponentTree = __webpack_require__(9);
var ReactUpdates = __webpack_require__(17);

var invariant = __webpack_require__(2);
var warning = __webpack_require__(4);

var didWarnValueLink = false;
var didWarnCheckedLink = false;
var didWarnValueDefaultValue = false;
var didWarnCheckedDefaultChecked = false;
var didWarnControlledToUncontrolled = false;
var didWarnUncontrolledToControlled = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMInput.updateWrapper(this);
  }
}

function isControlled(props) {
  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
  return usesChecked ? props.checked != null : props.value != null;
}

/**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */
var ReactDOMInput = {
  getHostProps: function (inst, props) {
    var value = LinkedValueUtils.getValue(props);
    var checked = LinkedValueUtils.getChecked(props);

    var hostProps = _assign({
      // Make sure we set .type before any other properties (setting .value
      // before .type means .value is lost in IE11 and below)
      type: undefined,
      // Make sure we set .step before .value (setting .value before .step
      // means .value is rounded on mount, based upon step precision)
      step: undefined,
      // Make sure we set .min & .max before .value (to ensure proper order
      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
      min: undefined,
      max: undefined
    }, props, {
      defaultChecked: undefined,
      defaultValue: undefined,
      value: value != null ? value : inst._wrapperState.initialValue,
      checked: checked != null ? checked : inst._wrapperState.initialChecked,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);

      var owner = inst._currentElement._owner;

      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnCheckedLink = true;
      }
      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnCheckedDefaultChecked = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnValueDefaultValue = true;
      }
    }

    var defaultValue = props.defaultValue;
    inst._wrapperState = {
      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
      initialValue: props.value != null ? props.value : defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      controlled: isControlled(props)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    if (false) {
      var controlled = isControlled(props);
      var owner = inst._currentElement._owner;

      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnUncontrolledToControlled = true;
      }
      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnControlledToUncontrolled = true;
      }
    }

    // TODO: Shouldn't this be getChecked(props)?
    var checked = props.checked;
    if (checked != null) {
      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      if (value === 0 && node.value === '') {
        node.value = '0';
        // Note: IE9 reports a number inputs as 'text', so check props instead.
      } else if (props.type === 'number') {
        // Simulate `input.valueAsNumber`. IE9 does not support it
        var valueAsNumber = parseFloat(node.value, 10) || 0;

        // eslint-disable-next-line
        if (value != valueAsNumber) {
          // Cast `value` to a string to ensure the value is set correctly. While
          // browsers typically do this as necessary, jsdom doesn't.
          node.value = '' + value;
        }
        // eslint-disable-next-line
      } else if (value != node.value) {
        // Cast `value` to a string to ensure the value is set correctly. While
        // browsers typically do this as necessary, jsdom doesn't.
        node.value = '' + value;
      }
    } else {
      if (props.value == null && props.defaultValue != null) {
        // In Chrome, assigning defaultValue to certain input types triggers input validation.
        // For number inputs, the display value loses trailing decimal points. For email inputs,
        // Chrome raises "The specified value <x> is not a valid email address".
        //
        // Here we check to see if the defaultValue has actually changed, avoiding these problems
        // when the user is inputting text
        //
        // https://github.com/facebook/react/issues/7253
        if (node.defaultValue !== '' + props.defaultValue) {
          node.defaultValue = '' + props.defaultValue;
        }
      }
      if (props.checked == null && props.defaultChecked != null) {
        node.defaultChecked = !!props.defaultChecked;
      }
    }
  },

  postMountWrapper: function (inst) {
    var props = inst._currentElement.props;

    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);

    // Detach value from defaultValue. We won't do anything if we're working on
    // submit or reset inputs as those values & defaultValues are linked. They
    // are not resetable nodes so this operation doesn't matter and actually
    // removes browser-default values (eg "Submit Query") when no value is
    // provided.

    switch (props.type) {
      case 'submit':
      case 'reset':
        break;
      case 'color':
      case 'date':
      case 'datetime':
      case 'datetime-local':
      case 'month':
      case 'time':
      case 'week':
        // This fixes the no-show issue on iOS Safari and Android Chrome:
        // https://github.com/facebook/react/issues/7233
        node.value = '';
        node.value = node.defaultValue;
        break;
      default:
        node.value = node.value;
        break;
    }

    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
    // this is needed to work around a chrome bug where setting defaultChecked
    // will sometimes influence the value of checked (even after detachment).
    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
    // We need to temporarily unset name to avoid disrupting radio button groups.
    var name = node.name;
    if (name !== '') {
      node.name = '';
    }
    node.defaultChecked = !node.defaultChecked;
    node.defaultChecked = !node.defaultChecked;
    if (name !== '') {
      node.name = name;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;

  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  // Here we use asap to wait until all updates have propagated, which
  // is important when using controlled components within layers:
  // https://github.com/facebook/react/issues/1698
  ReactUpdates.asap(forceUpdateIfMounted, this);

  var name = props.name;
  if (props.type === 'radio' && name != null) {
    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
    var queryRoot = rootNode;

    while (queryRoot.parentNode) {
      queryRoot = queryRoot.parentNode;
    }

    // If `rootNode.form` was non-null, then we could try `form.elements`,
    // but that sometimes behaves strangely in IE8. We could also try using
    // `form.getElementsByName`, but that will only return direct children
    // and won't include inputs that use the HTML5 `form=` attribute. Since
    // the input might not even be in a form, let's just use the global
    // `querySelectorAll` to ensure we don't miss anything.
    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');

    for (var i = 0; i < group.length; i++) {
      var otherNode = group[i];
      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
        continue;
      }
      // This will throw if radio buttons rendered by different copies of React
      // and the same name are rendered into the same form (same as #1939).
      // That's probably okay; we don't support it just as we don't support
      // mixing React radio buttons with non-React ones.
      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
      // If this is a controlled radio button group, forcing the input that
      // was previously checked to update will cause it to be come re-checked
      // as appropriate.
      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
    }
  }

  return returnValue;
}

module.exports = ReactDOMInput;

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



// React 15.5 references this module, and assumes PropTypes are still callable in production.
// Therefore we re-export development-only version with all the PropTypes checks here.
// However if one is migrating to the `prop-types` npm library, they will go through the
// `index.js` entry point, and it will branch depending on the environment.
var factory = __webpack_require__(367);
module.exports = function(isValidElement) {
  // It is still allowed in 15.5.
  var throwOnDirectAccess = false;
  return factory(isValidElement, throwOnDirectAccess);
};


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(12);
var invariant = __webpack_require__(2);
var warning = __webpack_require__(4);

var ReactPropTypesSecret = __webpack_require__(368);
var checkPropTypes = __webpack_require__(369);

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          invariant(
            false,
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            warning(
              false,
              'You are manually calling a React.PropTypes validation ' +
              'function for the `%s` prop on `%s`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
              propFullName,
              componentName
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        warning(
          false,
          'Invalid argument supplid to oneOfType. Expected an array of check functions, but ' +
          'received %s at index %s.',
          getPostfixForTypeWarning(checker),
          i
        );
        return emptyFunction.thatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



if (false) {
  var invariant = require('fbjs/lib/invariant');
  var warning = require('fbjs/lib/warning');
  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
  var loggedTypeFailures = {};
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
        }
      }
    }
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(8);

var React = __webpack_require__(32);
var ReactDOMComponentTree = __webpack_require__(9);
var ReactDOMSelect = __webpack_require__(124);

var warning = __webpack_require__(4);
var didWarnInvalidOptionChildren = false;

function flattenChildren(children) {
  var content = '';

  // Flatten children and warn if they aren't strings or numbers;
  // invalid types are ignored.
  React.Children.forEach(children, function (child) {
    if (child == null) {
      return;
    }
    if (typeof child === 'string' || typeof child === 'number') {
      content += child;
    } else if (!didWarnInvalidOptionChildren) {
      didWarnInvalidOptionChildren = true;
       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
    }
  });

  return content;
}

/**
 * Implements an <option> host component that warns when `selected` is set.
 */
var ReactDOMOption = {
  mountWrapper: function (inst, props, hostParent) {
    // TODO (yungsters): Remove support for `selected` in <option>.
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
    }

    // Look up whether this option is 'selected'
    var selectValue = null;
    if (hostParent != null) {
      var selectParent = hostParent;

      if (selectParent._tag === 'optgroup') {
        selectParent = selectParent._hostParent;
      }

      if (selectParent != null && selectParent._tag === 'select') {
        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
      }
    }

    // If the value is null (e.g., no specified value or after initial mount)
    // or missing (e.g., for <datalist>), we don't change props.selected
    var selected = null;
    if (selectValue != null) {
      var value;
      if (props.value != null) {
        value = props.value + '';
      } else {
        value = flattenChildren(props.children);
      }
      selected = false;
      if (Array.isArray(selectValue)) {
        // multiple
        for (var i = 0; i < selectValue.length; i++) {
          if ('' + selectValue[i] === value) {
            selected = true;
            break;
          }
        }
      } else {
        selected = '' + selectValue === value;
      }
    }

    inst._wrapperState = { selected: selected };
  },

  postMountWrapper: function (inst) {
    // value="" should make a value attribute (#6219)
    var props = inst._currentElement.props;
    if (props.value != null) {
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      node.setAttribute('value', props.value);
    }
  },

  getHostProps: function (inst, props) {
    var hostProps = _assign({ selected: undefined, children: undefined }, props);

    // Read state only from initial mount because <select> updates value
    // manually; we need the initial state only for server rendering
    if (inst._wrapperState.selected != null) {
      hostProps.selected = inst._wrapperState.selected;
    }

    var content = flattenChildren(props.children);

    if (content) {
      hostProps.children = content;
    }

    return hostProps;
  }

};

module.exports = ReactDOMOption;

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5),
    _assign = __webpack_require__(8);

var LinkedValueUtils = __webpack_require__(77);
var ReactDOMComponentTree = __webpack_require__(9);
var ReactUpdates = __webpack_require__(17);

var invariant = __webpack_require__(2);
var warning = __webpack_require__(4);

var didWarnValueLink = false;
var didWarnValDefaultVal = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMTextarea.updateWrapper(this);
  }
}

/**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */
var ReactDOMTextarea = {
  getHostProps: function (inst, props) {
    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;

    // Always set children to the same thing. In IE9, the selection range will
    // get reset if `textContent` is mutated.  We could add a check in setTextContent
    // to only set the value if/when the value differs from the node value (which would
    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
    // The value can be a boolean or object so that's why it's forced to be a string.
    var hostProps = _assign({}, props, {
      value: undefined,
      defaultValue: undefined,
      children: '' + inst._wrapperState.initialValue,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
        didWarnValDefaultVal = true;
      }
    }

    var value = LinkedValueUtils.getValue(props);
    var initialValue = value;

    // Only bother fetching default value if we're going to use it
    if (value == null) {
      var defaultValue = props.defaultValue;
      // TODO (yungsters): Remove support for children content in <textarea>.
      var children = props.children;
      if (children != null) {
        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
        }
        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
        if (Array.isArray(children)) {
          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
          children = children[0];
        }

        defaultValue = '' + children;
      }
      if (defaultValue == null) {
        defaultValue = '';
      }
      initialValue = defaultValue;
    }

    inst._wrapperState = {
      initialValue: '' + initialValue,
      listeners: null,
      onChange: _handleChange.bind(inst)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      // Cast `value` to a string to ensure the value is set correctly. While
      // browsers typically do this as necessary, jsdom doesn't.
      var newValue = '' + value;

      // To avoid side effects (such as losing text selection), only set value if changed
      if (newValue !== node.value) {
        node.value = newValue;
      }
      if (props.defaultValue == null) {
        node.defaultValue = newValue;
      }
    }
    if (props.defaultValue != null) {
      node.defaultValue = props.defaultValue;
    }
  },

  postMountWrapper: function (inst) {
    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var textContent = node.textContent;

    // Only set node.value if textContent is equal to the expected
    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
    // will populate textContent as well.
    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
    if (textContent === inst._wrapperState.initialValue) {
      node.value = textContent;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);
  ReactUpdates.asap(forceUpdateIfMounted, this);
  return returnValue;
}

module.exports = ReactDOMTextarea;

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5);

var ReactComponentEnvironment = __webpack_require__(78);
var ReactInstanceMap = __webpack_require__(46);
var ReactInstrumentation = __webpack_require__(14);

var ReactCurrentOwner = __webpack_require__(19);
var ReactReconciler = __webpack_require__(37);
var ReactChildReconciler = __webpack_require__(373);

var emptyFunction = __webpack_require__(12);
var flattenChildren = __webpack_require__(378);
var invariant = __webpack_require__(2);

/**
 * Make an update for markup to be rendered and inserted at a supplied index.
 *
 * @param {string} markup Markup that renders into an element.
 * @param {number} toIndex Destination index.
 * @private
 */
function makeInsertMarkup(markup, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'INSERT_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for moving an existing element to another index.
 *
 * @param {number} fromIndex Source index of the existing element.
 * @param {number} toIndex Destination index of the element.
 * @private
 */
function makeMove(child, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'MOVE_EXISTING',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: ReactReconciler.getHostNode(child),
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for removing an element at an index.
 *
 * @param {number} fromIndex Index of the element to remove.
 * @private
 */
function makeRemove(child, node) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'REMOVE_NODE',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: node,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the markup of a node.
 *
 * @param {string} markup Markup that renders into an element.
 * @private
 */
function makeSetMarkup(markup) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'SET_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the text content.
 *
 * @param {string} textContent Text content to set.
 * @private
 */
function makeTextContent(textContent) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'TEXT_CONTENT',
    content: textContent,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Push an update, if any, onto the queue. Creates a new queue if none is
 * passed and always returns the queue. Mutative.
 */
function enqueue(queue, update) {
  if (update) {
    queue = queue || [];
    queue.push(update);
  }
  return queue;
}

/**
 * Processes any enqueued updates.
 *
 * @private
 */
function processQueue(inst, updateQueue) {
  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
}

var setChildrenForInstrumentation = emptyFunction;
if (false) {
  var getDebugID = function (inst) {
    if (!inst._debugID) {
      // Check for ART-like instances. TODO: This is silly/gross.
      var internal;
      if (internal = ReactInstanceMap.get(inst)) {
        inst = internal;
      }
    }
    return inst._debugID;
  };
  setChildrenForInstrumentation = function (children) {
    var debugID = getDebugID(this);
    // TODO: React Native empty components are also multichild.
    // This means they still get into this method but don't have _debugID.
    if (debugID !== 0) {
      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
        return children[key]._debugID;
      }) : []);
    }
  };
}

/**
 * ReactMultiChild are capable of reconciling multiple children.
 *
 * @class ReactMultiChild
 * @internal
 */
var ReactMultiChild = {

  /**
   * Provides common functionality for components that must reconcile multiple
   * children. This is used by `ReactDOMComponent` to mount, update, and
   * unmount child components.
   *
   * @lends {ReactMultiChild.prototype}
   */
  Mixin: {

    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
      if (false) {
        var selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
        }
      }
      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
    },

    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
      var nextChildren;
      var selfDebugID = 0;
      if (false) {
        selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
          return nextChildren;
        }
      }
      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
      return nextChildren;
    },

    /**
     * Generates a "mount image" for each of the supplied children. In the case
     * of `ReactDOMComponent`, a mount image is a string of markup.
     *
     * @param {?object} nestedChildren Nested child maps.
     * @return {array} An array of mounted representations.
     * @internal
     */
    mountChildren: function (nestedChildren, transaction, context) {
      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
      this._renderedChildren = children;

      var mountImages = [];
      var index = 0;
      for (var name in children) {
        if (children.hasOwnProperty(name)) {
          var child = children[name];
          var selfDebugID = 0;
          if (false) {
            selfDebugID = getDebugID(this);
          }
          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
          child._mountIndex = index++;
          mountImages.push(mountImage);
        }
      }

      if (false) {
        setChildrenForInstrumentation.call(this, children);
      }

      return mountImages;
    },

    /**
     * Replaces any rendered children with a text content string.
     *
     * @param {string} nextContent String of content.
     * @internal
     */
    updateTextContent: function (nextContent) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      // Set new text content.
      var updates = [makeTextContent(nextContent)];
      processQueue(this, updates);
    },

    /**
     * Replaces any rendered children with a markup string.
     *
     * @param {string} nextMarkup String of markup.
     * @internal
     */
    updateMarkup: function (nextMarkup) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      var updates = [makeSetMarkup(nextMarkup)];
      processQueue(this, updates);
    },

    /**
     * Updates the rendered children with new children.
     *
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @internal
     */
    updateChildren: function (nextNestedChildrenElements, transaction, context) {
      // Hook used by React ART
      this._updateChildren(nextNestedChildrenElements, transaction, context);
    },

    /**
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @final
     * @protected
     */
    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
      var prevChildren = this._renderedChildren;
      var removedNodes = {};
      var mountImages = [];
      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
      if (!nextChildren && !prevChildren) {
        return;
      }
      var updates = null;
      var name;
      // `nextIndex` will increment for each child in `nextChildren`, but
      // `lastIndex` will be the last index visited in `prevChildren`.
      var nextIndex = 0;
      var lastIndex = 0;
      // `nextMountIndex` will increment for each newly mounted child.
      var nextMountIndex = 0;
      var lastPlacedNode = null;
      for (name in nextChildren) {
        if (!nextChildren.hasOwnProperty(name)) {
          continue;
        }
        var prevChild = prevChildren && prevChildren[name];
        var nextChild = nextChildren[name];
        if (prevChild === nextChild) {
          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
          prevChild._mountIndex = nextIndex;
        } else {
          if (prevChild) {
            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
            // The `removedNodes` loop below will actually remove the child.
          }
          // The child must be instantiated before it's mounted.
          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
          nextMountIndex++;
        }
        nextIndex++;
        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
      }
      // Remove children that are no longer present.
      for (name in removedNodes) {
        if (removedNodes.hasOwnProperty(name)) {
          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
        }
      }
      if (updates) {
        processQueue(this, updates);
      }
      this._renderedChildren = nextChildren;

      if (false) {
        setChildrenForInstrumentation.call(this, nextChildren);
      }
    },

    /**
     * Unmounts all rendered children. This should be used to clean up children
     * when this component is unmounted. It does not actually perform any
     * backend operations.
     *
     * @internal
     */
    unmountChildren: function (safely) {
      var renderedChildren = this._renderedChildren;
      ReactChildReconciler.unmountChildren(renderedChildren, safely);
      this._renderedChildren = null;
    },

    /**
     * Moves a child component to the supplied index.
     *
     * @param {ReactComponent} child Component to move.
     * @param {number} toIndex Destination index of the element.
     * @param {number} lastIndex Last index visited of the siblings of `child`.
     * @protected
     */
    moveChild: function (child, afterNode, toIndex, lastIndex) {
      // If the index of `child` is less than `lastIndex`, then it needs to
      // be moved. Otherwise, we do not need to move it because a child will be
      // inserted or moved before `child`.
      if (child._mountIndex < lastIndex) {
        return makeMove(child, afterNode, toIndex);
      }
    },

    /**
     * Creates a child component.
     *
     * @param {ReactComponent} child Component to create.
     * @param {string} mountImage Markup to insert.
     * @protected
     */
    createChild: function (child, afterNode, mountImage) {
      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
    },

    /**
     * Removes a child component.
     *
     * @param {ReactComponent} child Child to remove.
     * @protected
     */
    removeChild: function (child, node) {
      return makeRemove(child, node);
    },

    /**
     * Mounts a child with the supplied name.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to mount.
     * @param {string} name Name of the child.
     * @param {number} index Index at which to insert the child.
     * @param {ReactReconcileTransaction} transaction
     * @private
     */
    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
      child._mountIndex = index;
      return this.createChild(child, afterNode, mountImage);
    },

    /**
     * Unmounts a rendered child.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to unmount.
     * @private
     */
    _unmountChild: function (child, node) {
      var update = this.removeChild(child, node);
      child._mountIndex = null;
      return update;
    }

  }

};

module.exports = ReactMultiChild;

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactReconciler = __webpack_require__(37);

var instantiateReactComponent = __webpack_require__(126);
var KeyEscapeUtils = __webpack_require__(81);
var shouldUpdateReactComponent = __webpack_require__(80);
var traverseAllChildren = __webpack_require__(130);
var warning = __webpack_require__(4);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && process.env && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(131);
}

function instantiateChild(childInstances, child, name, selfDebugID) {
  // We found a component instance.
  var keyUnique = childInstances[name] === undefined;
  if (false) {
    if (!ReactComponentTreeHook) {
      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
    }
    if (!keyUnique) {
      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
    }
  }
  if (child != null && keyUnique) {
    childInstances[name] = instantiateReactComponent(child, true);
  }
}

/**
 * ReactChildReconciler provides helpers for initializing or updating a set of
 * children. Its output is suitable for passing it onto ReactMultiChild which
 * does diffed reordering and insertion.
 */
var ReactChildReconciler = {
  /**
   * Generates a "mount image" for each of the supplied children. In the case
   * of `ReactDOMComponent`, a mount image is a string of markup.
   *
   * @param {?object} nestedChildNodes Nested child maps.
   * @return {?object} A set of child instances.
   * @internal
   */
  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID // 0 in production and for roots
  ) {
    if (nestedChildNodes == null) {
      return null;
    }
    var childInstances = {};

    if (false) {
      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
        return instantiateChild(childInsts, child, name, selfDebugID);
      }, childInstances);
    } else {
      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
    }
    return childInstances;
  },

  /**
   * Updates the rendered children and returns a new set of children.
   *
   * @param {?object} prevChildren Previously initialized set of children.
   * @param {?object} nextChildren Flat child element maps.
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @return {?object} A new set of child instances.
   * @internal
   */
  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID // 0 in production and for roots
  ) {
    // We currently don't have a way to track moves here but if we use iterators
    // instead of for..in we can zip the iterators and check if an item has
    // moved.
    // TODO: If nothing has changed, return the prevChildren object so that we
    // can quickly bailout if nothing has changed.
    if (!nextChildren && !prevChildren) {
      return;
    }
    var name;
    var prevChild;
    for (name in nextChildren) {
      if (!nextChildren.hasOwnProperty(name)) {
        continue;
      }
      prevChild = prevChildren && prevChildren[name];
      var prevElement = prevChild && prevChild._currentElement;
      var nextElement = nextChildren[name];
      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
        nextChildren[name] = prevChild;
      } else {
        if (prevChild) {
          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
          ReactReconciler.unmountComponent(prevChild, false);
        }
        // The child must be instantiated before it's mounted.
        var nextChildInstance = instantiateReactComponent(nextElement, true);
        nextChildren[name] = nextChildInstance;
        // Creating mount image now ensures refs are resolved in right order
        // (see https://github.com/facebook/react/pull/7101 for explanation).
        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
        mountImages.push(nextChildMountImage);
      }
    }
    // Unmount children that are no longer present.
    for (name in prevChildren) {
      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
        prevChild = prevChildren[name];
        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
        ReactReconciler.unmountComponent(prevChild, false);
      }
    }
  },

  /**
   * Unmounts all rendered children. This should be used to clean up children
   * when this component is unmounted.
   *
   * @param {?object} renderedChildren Previously initialized set of children.
   * @internal
   */
  unmountChildren: function (renderedChildren, safely) {
    for (var name in renderedChildren) {
      if (renderedChildren.hasOwnProperty(name)) {
        var renderedChild = renderedChildren[name];
        ReactReconciler.unmountComponent(renderedChild, safely);
      }
    }
  }

};

module.exports = ReactChildReconciler;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(125)))

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5),
    _assign = __webpack_require__(8);

var React = __webpack_require__(32);
var ReactComponentEnvironment = __webpack_require__(78);
var ReactCurrentOwner = __webpack_require__(19);
var ReactErrorUtils = __webpack_require__(70);
var ReactInstanceMap = __webpack_require__(46);
var ReactInstrumentation = __webpack_require__(14);
var ReactNodeTypes = __webpack_require__(127);
var ReactReconciler = __webpack_require__(37);

if (false) {
  var checkReactTypeSpec = require('./checkReactTypeSpec');
}

var emptyObject = __webpack_require__(35);
var invariant = __webpack_require__(2);
var shallowEqual = __webpack_require__(79);
var shouldUpdateReactComponent = __webpack_require__(80);
var warning = __webpack_require__(4);

var CompositeTypes = {
  ImpureClass: 0,
  PureClass: 1,
  StatelessFunctional: 2
};

function StatelessComponent(Component) {}
StatelessComponent.prototype.render = function () {
  var Component = ReactInstanceMap.get(this)._currentElement.type;
  var element = Component(this.props, this.context, this.updater);
  warnIfInvalidElement(Component, element);
  return element;
};

function warnIfInvalidElement(Component, element) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
  }
}

function shouldConstruct(Component) {
  return !!(Component.prototype && Component.prototype.isReactComponent);
}

function isPureComponent(Component) {
  return !!(Component.prototype && Component.prototype.isPureReactComponent);
}

// Separated into a function to contain deoptimizations caused by try/finally.
function measureLifeCyclePerf(fn, debugID, timerType) {
  if (debugID === 0) {
    // Top-level wrappers (see ReactMount) and empty components (see
    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
    // Both are implementation details that should go away in the future.
    return fn();
  }

  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
  try {
    return fn();
  } finally {
    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
  }
}

/**
 * ------------------ The Life-Cycle of a Composite Component ------------------
 *
 * - constructor: Initialization of state. The instance is now retained.
 *   - componentWillMount
 *   - render
 *   - [children's constructors]
 *     - [children's componentWillMount and render]
 *     - [children's componentDidMount]
 *     - componentDidMount
 *
 *       Update Phases:
 *       - componentWillReceiveProps (only called if parent updated)
 *       - shouldComponentUpdate
 *         - componentWillUpdate
 *           - render
 *           - [children's constructors or receive props phases]
 *         - componentDidUpdate
 *
 *     - componentWillUnmount
 *     - [children's componentWillUnmount]
 *   - [children destroyed]
 * - (destroyed): The instance is now blank, released by React and ready for GC.
 *
 * -----------------------------------------------------------------------------
 */

/**
 * An incrementing ID assigned to each component when it is mounted. This is
 * used to enforce the order in which `ReactUpdates` updates dirty components.
 *
 * @private
 */
var nextMountID = 1;

/**
 * @lends {ReactCompositeComponent.prototype}
 */
var ReactCompositeComponent = {

  /**
   * Base constructor for all composite component.
   *
   * @param {ReactElement} element
   * @final
   * @internal
   */
  construct: function (element) {
    this._currentElement = element;
    this._rootNodeID = 0;
    this._compositeType = null;
    this._instance = null;
    this._hostParent = null;
    this._hostContainerInfo = null;

    // See ReactUpdateQueue
    this._updateBatchNumber = null;
    this._pendingElement = null;
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    this._renderedNodeType = null;
    this._renderedComponent = null;
    this._context = null;
    this._mountOrder = 0;
    this._topLevelWrapper = null;

    // See ReactUpdates and ReactUpdateQueue.
    this._pendingCallbacks = null;

    // ComponentWillUnmount shall only be called once
    this._calledComponentWillUnmount = false;

    if (false) {
      this._warnedAboutRefsInRender = false;
    }
  },

  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} hostParent
   * @param {?object} hostContainerInfo
   * @param {?object} context
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var _this = this;

    this._context = context;
    this._mountOrder = nextMountID++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var publicProps = this._currentElement.props;
    var publicContext = this._processContext(context);

    var Component = this._currentElement.type;

    var updateQueue = transaction.getUpdateQueue();

    // Initialize the public class
    var doConstruct = shouldConstruct(Component);
    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
    var renderedElement;

    // Support functional components
    if (!doConstruct && (inst == null || inst.render == null)) {
      renderedElement = inst;
      warnIfInvalidElement(Component, renderedElement);
      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
      inst = new StatelessComponent(Component);
      this._compositeType = CompositeTypes.StatelessFunctional;
    } else {
      if (isPureComponent(Component)) {
        this._compositeType = CompositeTypes.PureClass;
      } else {
        this._compositeType = CompositeTypes.ImpureClass;
      }
    }

    if (false) {
      // This will throw later in _renderValidatedComponent, but add an early
      // warning now to help debugging
      if (inst.render == null) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
      }

      var propsMutated = inst.props !== publicProps;
      var componentName = Component.displayName || Component.name || 'Component';

      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + 'up the same props that your component\'s constructor was passed.', componentName, componentName) : void 0;
    }

    // These should be set up in the constructor, but as a convenience for
    // simpler class abstractions, we set them up after the fact.
    inst.props = publicProps;
    inst.context = publicContext;
    inst.refs = emptyObject;
    inst.updater = updateQueue;

    this._instance = inst;

    // Store a reference from the instance back to the internal representation
    ReactInstanceMap.set(inst, this);

    if (false) {
      // Since plain JS classes are defined without any special initialization
      // logic, we can not catch common errors early. Therefore, we have to
      // catch them here, at initialization time, instead.
      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
    }

    var initialState = inst.state;
    if (initialState === undefined) {
      inst.state = initialState = null;
    }
    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;

    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    var markup;
    if (inst.unstable_handleError) {
      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } else {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }

    if (inst.componentDidMount) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(function () {
            return inst.componentDidMount();
          }, _this._debugID, 'componentDidMount');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
      }
    }

    return markup;
  },

  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
    if (false) {
      ReactCurrentOwner.current = this;
      try {
        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
    }
  },

  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
    var Component = this._currentElement.type;

    if (doConstruct) {
      if (false) {
        return measureLifeCyclePerf(function () {
          return new Component(publicProps, publicContext, updateQueue);
        }, this._debugID, 'ctor');
      } else {
        return new Component(publicProps, publicContext, updateQueue);
      }
    }

    // This can still be an instance in case of factory components
    // but we'll count this as time spent rendering as the more common case.
    if (false) {
      return measureLifeCyclePerf(function () {
        return Component(publicProps, publicContext, updateQueue);
      }, this._debugID, 'render');
    } else {
      return Component(publicProps, publicContext, updateQueue);
    }
  },

  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var markup;
    var checkpoint = transaction.checkpoint();
    try {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } catch (e) {
      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
      transaction.rollback(checkpoint);
      this._instance.unstable_handleError(e);
      if (this._pendingStateQueue) {
        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
      }
      checkpoint = transaction.checkpoint();

      this._renderedComponent.unmountComponent(true);
      transaction.rollback(checkpoint);

      // Try again - we've informed the component about the error, so they can render an error message this time.
      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }
    return markup;
  },

  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var inst = this._instance;

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (inst.componentWillMount) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillMount();
        }, debugID, 'componentWillMount');
      } else {
        inst.componentWillMount();
      }
      // When mounting, calls to `setState` by `componentWillMount` will set
      // `this._pendingStateQueue` without triggering a re-render.
      if (this._pendingStateQueue) {
        inst.state = this._processPendingState(inst.props, inst.context);
      }
    }

    // If not a stateless component, we now render
    if (renderedElement === undefined) {
      renderedElement = this._renderValidatedComponent();
    }

    var nodeType = ReactNodeTypes.getType(renderedElement);
    this._renderedNodeType = nodeType;
    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
    );
    this._renderedComponent = child;

    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);

    if (false) {
      if (debugID !== 0) {
        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
      }
    }

    return markup;
  },

  getHostNode: function () {
    return ReactReconciler.getHostNode(this._renderedComponent);
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (safely) {
    if (!this._renderedComponent) {
      return;
    }

    var inst = this._instance;

    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
      inst._calledComponentWillUnmount = true;

      if (safely) {
        var name = this.getName() + '.componentWillUnmount()';
        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
      } else {
        if (false) {
          measureLifeCyclePerf(function () {
            return inst.componentWillUnmount();
          }, this._debugID, 'componentWillUnmount');
        } else {
          inst.componentWillUnmount();
        }
      }
    }

    if (this._renderedComponent) {
      ReactReconciler.unmountComponent(this._renderedComponent, safely);
      this._renderedNodeType = null;
      this._renderedComponent = null;
      this._instance = null;
    }

    // Reset pending fields
    // Even if this component is scheduled for another update in ReactUpdates,
    // it would still be ignored because these fields are reset.
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;
    this._pendingCallbacks = null;
    this._pendingElement = null;

    // These fields do not really need to be reset since this object is no
    // longer accessible.
    this._context = null;
    this._rootNodeID = 0;
    this._topLevelWrapper = null;

    // Delete the reference from the instance to this internal representation
    // which allow the internals to be properly cleaned up even if the user
    // leaks a reference to the public instance.
    ReactInstanceMap.remove(inst);

    // Some existing components rely on inst.props even after they've been
    // destroyed (in event handlers).
    // TODO: inst.props = null;
    // TODO: inst.state = null;
    // TODO: inst.context = null;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _maskContext: function (context) {
    var Component = this._currentElement.type;
    var contextTypes = Component.contextTypes;
    if (!contextTypes) {
      return emptyObject;
    }
    var maskedContext = {};
    for (var contextName in contextTypes) {
      maskedContext[contextName] = context[contextName];
    }
    return maskedContext;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`, and asserts that they are valid.
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _processContext: function (context) {
    var maskedContext = this._maskContext(context);
    if (false) {
      var Component = this._currentElement.type;
      if (Component.contextTypes) {
        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
      }
    }
    return maskedContext;
  },

  /**
   * @param {object} currentContext
   * @return {object}
   * @private
   */
  _processChildContext: function (currentContext) {
    var Component = this._currentElement.type;
    var inst = this._instance;
    var childContext;

    if (inst.getChildContext) {
      if (false) {
        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
        try {
          childContext = inst.getChildContext();
        } finally {
          ReactInstrumentation.debugTool.onEndProcessingChildContext();
        }
      } else {
        childContext = inst.getChildContext();
      }
    }

    if (childContext) {
      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
      if (false) {
        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
      }
      for (var name in childContext) {
        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
      }
      return _assign({}, currentContext, childContext);
    }
    return currentContext;
  },

  /**
   * Assert that the context types are valid
   *
   * @param {object} typeSpecs Map of context field to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @private
   */
  _checkContextTypes: function (typeSpecs, values, location) {
    if (false) {
      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
    }
  },

  receiveComponent: function (nextElement, transaction, nextContext) {
    var prevElement = this._currentElement;
    var prevContext = this._context;

    this._pendingElement = null;

    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
  },

  /**
   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
   * is set, update the component.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (transaction) {
    if (this._pendingElement != null) {
      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
    } else {
      this._updateBatchNumber = null;
    }
  },

  /**
   * Perform an update to a mounted component. The componentWillReceiveProps and
   * shouldComponentUpdate methods are called, then (assuming the update isn't
   * skipped) the remaining update lifecycle methods are called and the DOM
   * representation is updated.
   *
   * By default, this implements React's rendering and reconciliation algorithm.
   * Sophisticated clients may wish to override this.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevParentElement
   * @param {ReactElement} nextParentElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
    var inst = this._instance;
    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;

    var willReceive = false;
    var nextContext;

    // Determine if the context has changed or not
    if (this._context === nextUnmaskedContext) {
      nextContext = inst.context;
    } else {
      nextContext = this._processContext(nextUnmaskedContext);
      willReceive = true;
    }

    var prevProps = prevParentElement.props;
    var nextProps = nextParentElement.props;

    // Not a simple state update but a props update
    if (prevParentElement !== nextParentElement) {
      willReceive = true;
    }

    // An update here will schedule an update but immediately set
    // _pendingStateQueue which will ensure that any state updates gets
    // immediately reconciled instead of waiting for the next batch.
    if (willReceive && inst.componentWillReceiveProps) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillReceiveProps(nextProps, nextContext);
        }, this._debugID, 'componentWillReceiveProps');
      } else {
        inst.componentWillReceiveProps(nextProps, nextContext);
      }
    }

    var nextState = this._processPendingState(nextProps, nextContext);
    var shouldUpdate = true;

    if (!this._pendingForceUpdate) {
      if (inst.shouldComponentUpdate) {
        if (false) {
          shouldUpdate = measureLifeCyclePerf(function () {
            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
          }, this._debugID, 'shouldComponentUpdate');
        } else {
          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
        }
      } else {
        if (this._compositeType === CompositeTypes.PureClass) {
          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
        }
      }
    }

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
    }

    this._updateBatchNumber = null;
    if (shouldUpdate) {
      this._pendingForceUpdate = false;
      // Will set `this.props`, `this.state` and `this.context`.
      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
    } else {
      // If it's determined that a component should not update, we still want
      // to set props and state but we shortcut the rest of the update.
      this._currentElement = nextParentElement;
      this._context = nextUnmaskedContext;
      inst.props = nextProps;
      inst.state = nextState;
      inst.context = nextContext;
    }
  },

  _processPendingState: function (props, context) {
    var inst = this._instance;
    var queue = this._pendingStateQueue;
    var replace = this._pendingReplaceState;
    this._pendingReplaceState = false;
    this._pendingStateQueue = null;

    if (!queue) {
      return inst.state;
    }

    if (replace && queue.length === 1) {
      return queue[0];
    }

    var nextState = _assign({}, replace ? queue[0] : inst.state);
    for (var i = replace ? 1 : 0; i < queue.length; i++) {
      var partial = queue[i];
      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
    }

    return nextState;
  },

  /**
   * Merges new props and state, notifies delegate methods of update and
   * performs update.
   *
   * @param {ReactElement} nextElement Next element
   * @param {object} nextProps Next public object to set as properties.
   * @param {?object} nextState Next object to set as state.
   * @param {?object} nextContext Next public object to set as context.
   * @param {ReactReconcileTransaction} transaction
   * @param {?object} unmaskedContext
   * @private
   */
  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
    var _this2 = this;

    var inst = this._instance;

    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
    var prevProps;
    var prevState;
    var prevContext;
    if (hasComponentDidUpdate) {
      prevProps = inst.props;
      prevState = inst.state;
      prevContext = inst.context;
    }

    if (inst.componentWillUpdate) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillUpdate(nextProps, nextState, nextContext);
        }, this._debugID, 'componentWillUpdate');
      } else {
        inst.componentWillUpdate(nextProps, nextState, nextContext);
      }
    }

    this._currentElement = nextElement;
    this._context = unmaskedContext;
    inst.props = nextProps;
    inst.state = nextState;
    inst.context = nextContext;

    this._updateRenderedComponent(transaction, unmaskedContext);

    if (hasComponentDidUpdate) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
      }
    }
  },

  /**
   * Call the component's `render` method and update the DOM accordingly.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  _updateRenderedComponent: function (transaction, context) {
    var prevComponentInstance = this._renderedComponent;
    var prevRenderedElement = prevComponentInstance._currentElement;
    var nextRenderedElement = this._renderValidatedComponent();

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
    } else {
      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
      ReactReconciler.unmountComponent(prevComponentInstance, false);

      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
      this._renderedNodeType = nodeType;
      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
      );
      this._renderedComponent = child;

      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);

      if (false) {
        if (debugID !== 0) {
          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
        }
      }

      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
    }
  },

  /**
   * Overridden in shallow rendering.
   *
   * @protected
   */
  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
  },

  /**
   * @protected
   */
  _renderValidatedComponentWithoutOwnerOrContext: function () {
    var inst = this._instance;
    var renderedElement;

    if (false) {
      renderedElement = measureLifeCyclePerf(function () {
        return inst.render();
      }, this._debugID, 'render');
    } else {
      renderedElement = inst.render();
    }

    if (false) {
      // We allow auto-mocks to proceed as if they're returning null.
      if (renderedElement === undefined && inst.render._isMockFunction) {
        // This is probably bad practice. Consider warning here and
        // deprecating this convenience.
        renderedElement = null;
      }
    }

    return renderedElement;
  },

  /**
   * @private
   */
  _renderValidatedComponent: function () {
    var renderedElement;
    if ("production" !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
      ReactCurrentOwner.current = this;
      try {
        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
    }
    !(
    // TODO: An `isValidNode` function would probably be more appropriate
    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;

    return renderedElement;
  },

  /**
   * Lazily allocates the refs object and stores `component` as `ref`.
   *
   * @param {string} ref Reference name.
   * @param {component} component Component to store as `ref`.
   * @final
   * @private
   */
  attachRef: function (ref, component) {
    var inst = this.getPublicInstance();
    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
    var publicComponentInstance = component.getPublicInstance();
    if (false) {
      var componentName = component && component.getName ? component.getName() : 'a component';
      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
    }
    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
    refs[ref] = publicComponentInstance;
  },

  /**
   * Detaches a reference name.
   *
   * @param {string} ref Name to dereference.
   * @final
   * @private
   */
  detachRef: function (ref) {
    var refs = this.getPublicInstance().refs;
    delete refs[ref];
  },

  /**
   * Get a text description of the component that can be used to identify it
   * in error messages.
   * @return {string} The name or null.
   * @internal
   */
  getName: function () {
    var type = this._currentElement.type;
    var constructor = this._instance && this._instance.constructor;
    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
  },

  /**
   * Get the publicly accessible representation of this component - i.e. what
   * is exposed by refs and returned by render. Can be null for stateless
   * components.
   *
   * @return {ReactComponent} the public component instance.
   * @internal
   */
  getPublicInstance: function () {
    var inst = this._instance;
    if (this._compositeType === CompositeTypes.StatelessFunctional) {
      return null;
    }
    return inst;
  },

  // Stub
  _instantiateReactComponent: null

};

module.exports = ReactCompositeComponent;

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var nextDebugID = 1;

function getNextDebugID() {
  return nextDebugID++;
}

module.exports = getNextDebugID;

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var KeyEscapeUtils = __webpack_require__(81);
var traverseAllChildren = __webpack_require__(130);
var warning = __webpack_require__(4);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && process.env && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(131);
}

/**
 * @param {function} traverseContext Context passed through traversal.
 * @param {?ReactComponent} child React child component.
 * @param {!string} name String name of key path to child.
 * @param {number=} selfDebugID Optional debugID of the current internal instance.
 */
function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
  // We found a component instance.
  if (traverseContext && typeof traverseContext === 'object') {
    var result = traverseContext;
    var keyUnique = result[name] === undefined;
    if (false) {
      if (!ReactComponentTreeHook) {
        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
      }
      if (!keyUnique) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
      }
    }
    if (keyUnique && child != null) {
      result[name] = child;
    }
  }
}

/**
 * Flattens children that are typically specified as `props.children`. Any null
 * children will not be included in the resulting object.
 * @return {!object} flattened children keyed by name.
 */
function flattenChildren(children, selfDebugID) {
  if (children == null) {
    return children;
  }
  var result = {};

  if (false) {
    traverseAllChildren(children, function (traverseContext, child, name) {
      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
    }, result);
  } else {
    traverseAllChildren(children, flattenSingleChildIntoContext, result);
  }
  return result;
}

module.exports = flattenChildren;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(125)))

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(8);

var PooledClass = __webpack_require__(27);
var Transaction = __webpack_require__(51);
var ReactInstrumentation = __webpack_require__(14);
var ReactServerUpdateQueue = __webpack_require__(380);

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

var noopCallbackQueue = {
  enqueue: function () {}
};

/**
 * @class ReactServerRenderingTransaction
 * @param {boolean} renderToStaticMarkup
 */
function ReactServerRenderingTransaction(renderToStaticMarkup) {
  this.reinitializeTransaction();
  this.renderToStaticMarkup = renderToStaticMarkup;
  this.useCreateElement = false;
  this.updateQueue = new ReactServerUpdateQueue(this);
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array} Empty list of operation wrap procedures.
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return noopCallbackQueue;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return this.updateQueue;
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {},

  checkpoint: function () {},

  rollback: function () {}
};

_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactServerRenderingTransaction);

module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReactUpdateQueue = __webpack_require__(82);

var warning = __webpack_require__(4);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the update queue used for server rendering.
 * It delegates to ReactUpdateQueue while server rendering is in progress and
 * switches to ReactNoopUpdateQueue after the transaction has completed.
 * @class ReactServerUpdateQueue
 * @param {Transaction} transaction
 */

var ReactServerUpdateQueue = function () {
  function ReactServerUpdateQueue(transaction) {
    _classCallCheck(this, ReactServerUpdateQueue);

    this.transaction = transaction;
  }

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */


  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
    return false;
  };

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
    }
  };

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
    } else {
      warnNoop(publicInstance, 'forceUpdate');
    }
  };

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} completeState Next state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
    } else {
      warnNoop(publicInstance, 'replaceState');
    }
  };

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} partialState Next partial state to be merged with state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
    } else {
      warnNoop(publicInstance, 'setState');
    }
  };

  return ReactServerUpdateQueue;
}();

module.exports = ReactServerUpdateQueue;

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(8);

var DOMLazyTree = __webpack_require__(38);
var ReactDOMComponentTree = __webpack_require__(9);

var ReactDOMEmptyComponent = function (instantiate) {
  // ReactCompositeComponent uses this:
  this._currentElement = null;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;
  this._hostContainerInfo = null;
  this._domID = 0;
};
_assign(ReactDOMEmptyComponent.prototype, {
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var domID = hostContainerInfo._idCounter++;
    this._domID = domID;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var nodeValue = ' react-empty: ' + this._domID + ' ';
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var node = ownerDocument.createComment(nodeValue);
      ReactDOMComponentTree.precacheNode(this, node);
      return DOMLazyTree(node);
    } else {
      if (transaction.renderToStaticMarkup) {
        // Normally we'd insert a comment node, but since this is a situation
        // where React won't take over (static pages), we can simply return
        // nothing.
        return '';
      }
      return '<!--' + nodeValue + '-->';
    }
  },
  receiveComponent: function () {},
  getHostNode: function () {
    return ReactDOMComponentTree.getNodeFromInstance(this);
  },
  unmountComponent: function () {
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMEmptyComponent;

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5);

var invariant = __webpack_require__(2);

/**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */
function getLowestCommonAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  var depthA = 0;
  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
    depthA++;
  }
  var depthB = 0;
  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
    depthB++;
  }

  // If A is deeper, crawl up.
  while (depthA - depthB > 0) {
    instA = instA._hostParent;
    depthA--;
  }

  // If B is deeper, crawl up.
  while (depthB - depthA > 0) {
    instB = instB._hostParent;
    depthB--;
  }

  // Walk in lockstep until we find a match.
  var depth = depthA;
  while (depth--) {
    if (instA === instB) {
      return instA;
    }
    instA = instA._hostParent;
    instB = instB._hostParent;
  }
  return null;
}

/**
 * Return if A is an ancestor of B.
 */
function isAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;

  while (instB) {
    if (instB === instA) {
      return true;
    }
    instB = instB._hostParent;
  }
  return false;
}

/**
 * Return the parent instance of the passed-in instance.
 */
function getParentInstance(inst) {
  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;

  return inst._hostParent;
}

/**
 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
 */
function traverseTwoPhase(inst, fn, arg) {
  var path = [];
  while (inst) {
    path.push(inst);
    inst = inst._hostParent;
  }
  var i;
  for (i = path.length; i-- > 0;) {
    fn(path[i], 'captured', arg);
  }
  for (i = 0; i < path.length; i++) {
    fn(path[i], 'bubbled', arg);
  }
}

/**
 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
 * should would receive a `mouseEnter` or `mouseLeave` event.
 *
 * Does not invoke the callback on the nearest common ancestor because nothing
 * "entered" or "left" that element.
 */
function traverseEnterLeave(from, to, fn, argFrom, argTo) {
  var common = from && to ? getLowestCommonAncestor(from, to) : null;
  var pathFrom = [];
  while (from && from !== common) {
    pathFrom.push(from);
    from = from._hostParent;
  }
  var pathTo = [];
  while (to && to !== common) {
    pathTo.push(to);
    to = to._hostParent;
  }
  var i;
  for (i = 0; i < pathFrom.length; i++) {
    fn(pathFrom[i], 'bubbled', argFrom);
  }
  for (i = pathTo.length; i-- > 0;) {
    fn(pathTo[i], 'captured', argTo);
  }
}

module.exports = {
  isAncestor: isAncestor,
  getLowestCommonAncestor: getLowestCommonAncestor,
  getParentInstance: getParentInstance,
  traverseTwoPhase: traverseTwoPhase,
  traverseEnterLeave: traverseEnterLeave
};

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5),
    _assign = __webpack_require__(8);

var DOMChildrenOperations = __webpack_require__(74);
var DOMLazyTree = __webpack_require__(38);
var ReactDOMComponentTree = __webpack_require__(9);

var escapeTextContentForBrowser = __webpack_require__(54);
var invariant = __webpack_require__(2);
var validateDOMNesting = __webpack_require__(83);

/**
 * Text nodes violate a couple assumptions that React makes about components:
 *
 *  - When mounting text into the DOM, adjacent text nodes are merged.
 *  - Text nodes cannot be assigned a React root ID.
 *
 * This component is used to wrap strings between comment nodes so that they
 * can undergo the same reconciliation that is applied to elements.
 *
 * TODO: Investigate representing React components in the DOM with text nodes.
 *
 * @class ReactDOMTextComponent
 * @extends ReactComponent
 * @internal
 */
var ReactDOMTextComponent = function (text) {
  // TODO: This is really a ReactText (ReactNode), not a ReactElement
  this._currentElement = text;
  this._stringText = '' + text;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;

  // Properties
  this._domID = 0;
  this._mountIndex = 0;
  this._closingComment = null;
  this._commentNodes = null;
};

_assign(ReactDOMTextComponent.prototype, {

  /**
   * Creates the markup for this text node. This node is not intended to have
   * any features besides containing text content.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @return {string} Markup for this text node.
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo != null) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(null, this._stringText, this, parentInfo);
      }
    }

    var domID = hostContainerInfo._idCounter++;
    var openingValue = ' react-text: ' + domID + ' ';
    var closingValue = ' /react-text ';
    this._domID = domID;
    this._hostParent = hostParent;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var openingComment = ownerDocument.createComment(openingValue);
      var closingComment = ownerDocument.createComment(closingValue);
      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
      if (this._stringText) {
        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
      }
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
      ReactDOMComponentTree.precacheNode(this, openingComment);
      this._closingComment = closingComment;
      return lazyTree;
    } else {
      var escapedText = escapeTextContentForBrowser(this._stringText);

      if (transaction.renderToStaticMarkup) {
        // Normally we'd wrap this between comment nodes for the reasons stated
        // above, but since this is a situation where React won't take over
        // (static pages), we can simply return the text as it is.
        return escapedText;
      }

      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
    }
  },

  /**
   * Updates this component by updating the text content.
   *
   * @param {ReactText} nextText The next text content
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  receiveComponent: function (nextText, transaction) {
    if (nextText !== this._currentElement) {
      this._currentElement = nextText;
      var nextStringText = '' + nextText;
      if (nextStringText !== this._stringText) {
        // TODO: Save this as pending props and use performUpdateIfNecessary
        // and/or updateComponent to do the actual update for consistency with
        // other component types?
        this._stringText = nextStringText;
        var commentNodes = this.getHostNode();
        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
      }
    }
  },

  getHostNode: function () {
    var hostNode = this._commentNodes;
    if (hostNode) {
      return hostNode;
    }
    if (!this._closingComment) {
      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
      var node = openingComment.nextSibling;
      while (true) {
        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
          this._closingComment = node;
          break;
        }
        node = node.nextSibling;
      }
    }
    hostNode = [this._hostNode, this._closingComment];
    this._commentNodes = hostNode;
    return hostNode;
  },

  unmountComponent: function () {
    this._closingComment = null;
    this._commentNodes = null;
    ReactDOMComponentTree.uncacheNode(this);
  }

});

module.exports = ReactDOMTextComponent;

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(8);

var ReactUpdates = __webpack_require__(17);
var Transaction = __webpack_require__(51);

var emptyFunction = __webpack_require__(12);

var RESET_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: function () {
    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
  }
};

var FLUSH_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
};

var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];

function ReactDefaultBatchingStrategyTransaction() {
  this.reinitializeTransaction();
}

_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  }
});

var transaction = new ReactDefaultBatchingStrategyTransaction();

var ReactDefaultBatchingStrategy = {
  isBatchingUpdates: false,

  /**
   * Call the provided function in a context within which calls to `setState`
   * and friends are batched such that components aren't updated unnecessarily.
   */
  batchedUpdates: function (callback, a, b, c, d, e) {
    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;

    ReactDefaultBatchingStrategy.isBatchingUpdates = true;

    // The code is written this way to avoid extra allocations
    if (alreadyBatchingUpdates) {
      return callback(a, b, c, d, e);
    } else {
      return transaction.perform(callback, null, a, b, c, d, e);
    }
  }
};

module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(8);

var EventListener = __webpack_require__(132);
var ExecutionEnvironment = __webpack_require__(11);
var PooledClass = __webpack_require__(27);
var ReactDOMComponentTree = __webpack_require__(9);
var ReactUpdates = __webpack_require__(17);

var getEventTarget = __webpack_require__(71);
var getUnboundedScrollPosition = __webpack_require__(386);

/**
 * Find the deepest React component completely containing the root of the
 * passed-in instance (for use when entire React trees are nested within each
 * other). If React trees are not nested, returns null.
 */
function findParent(inst) {
  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
  // traversal, but caching is difficult to do correctly without using a
  // mutation observer to listen for all DOM changes.
  while (inst._hostParent) {
    inst = inst._hostParent;
  }
  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
  var container = rootNode.parentNode;
  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
}

// Used to store ancestor hierarchy in top level callback
function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
  this.topLevelType = topLevelType;
  this.nativeEvent = nativeEvent;
  this.ancestors = [];
}
_assign(TopLevelCallbackBookKeeping.prototype, {
  destructor: function () {
    this.topLevelType = null;
    this.nativeEvent = null;
    this.ancestors.length = 0;
  }
});
PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);

function handleTopLevelImpl(bookKeeping) {
  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);

  // Loop through the hierarchy, in case there's any nested components.
  // It's important that we build the array of ancestors before calling any
  // event handlers, because event handlers can modify the DOM, leading to
  // inconsistencies with ReactMount's node cache. See #1105.
  var ancestor = targetInst;
  do {
    bookKeeping.ancestors.push(ancestor);
    ancestor = ancestor && findParent(ancestor);
  } while (ancestor);

  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
    targetInst = bookKeeping.ancestors[i];
    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
  }
}

function scrollValueMonitor(cb) {
  var scrollPosition = getUnboundedScrollPosition(window);
  cb(scrollPosition);
}

var ReactEventListener = {
  _enabled: true,
  _handleTopLevel: null,

  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,

  setHandleTopLevel: function (handleTopLevel) {
    ReactEventListener._handleTopLevel = handleTopLevel;
  },

  setEnabled: function (enabled) {
    ReactEventListener._enabled = !!enabled;
  },

  isEnabled: function () {
    return ReactEventListener._enabled;
  },

  /**
   * Traps top-level events by using event bubbling.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  /**
   * Traps a top-level event by using event capturing.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  monitorScrollValue: function (refresh) {
    var callback = scrollValueMonitor.bind(null, refresh);
    EventListener.listen(window, 'scroll', callback);
  },

  dispatchEvent: function (topLevelType, nativeEvent) {
    if (!ReactEventListener._enabled) {
      return;
    }

    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
    try {
      // Event queue being processed in the same cycle allows
      // `preventDefault`.
      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
    } finally {
      TopLevelCallbackBookKeeping.release(bookKeeping);
    }
  }
};

module.exports = ReactEventListener;

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are unbounded, unlike `getScrollPosition`. This means they
 * may be negative or exceed the element boundaries (which is possible using
 * inertial scrolling).
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */

function getUnboundedScrollPosition(scrollable) {
  if (scrollable.Window && scrollable instanceof scrollable.Window) {
    return {
      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
    };
  }
  return {
    x: scrollable.scrollLeft,
    y: scrollable.scrollTop
  };
}

module.exports = getUnboundedScrollPosition;

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(36);
var EventPluginHub = __webpack_require__(44);
var EventPluginUtils = __webpack_require__(69);
var ReactComponentEnvironment = __webpack_require__(78);
var ReactEmptyComponent = __webpack_require__(128);
var ReactBrowserEventEmitter = __webpack_require__(55);
var ReactHostComponent = __webpack_require__(129);
var ReactUpdates = __webpack_require__(17);

var ReactInjection = {
  Component: ReactComponentEnvironment.injection,
  DOMProperty: DOMProperty.injection,
  EmptyComponent: ReactEmptyComponent.injection,
  EventPluginHub: EventPluginHub.injection,
  EventPluginUtils: EventPluginUtils.injection,
  EventEmitter: ReactBrowserEventEmitter.injection,
  HostComponent: ReactHostComponent.injection,
  Updates: ReactUpdates.injection
};

module.exports = ReactInjection;

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(8);

var CallbackQueue = __webpack_require__(116);
var PooledClass = __webpack_require__(27);
var ReactBrowserEventEmitter = __webpack_require__(55);
var ReactInputSelection = __webpack_require__(133);
var ReactInstrumentation = __webpack_require__(14);
var Transaction = __webpack_require__(51);
var ReactUpdateQueue = __webpack_require__(82);

/**
 * Ensures that, when possible, the selection range (currently selected text
 * input) is not disturbed by performing the transaction.
 */
var SELECTION_RESTORATION = {
  /**
   * @return {Selection} Selection information.
   */
  initialize: ReactInputSelection.getSelectionInformation,
  /**
   * @param {Selection} sel Selection information returned from `initialize`.
   */
  close: ReactInputSelection.restoreSelection
};

/**
 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
 * high level DOM manipulations (like temporarily removing a text input from the
 * DOM).
 */
var EVENT_SUPPRESSION = {
  /**
   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
   * the reconciliation.
   */
  initialize: function () {
    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
    ReactBrowserEventEmitter.setEnabled(false);
    return currentlyEnabled;
  },

  /**
   * @param {boolean} previouslyEnabled Enabled status of
   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
   *   restores the previous value.
   */
  close: function (previouslyEnabled) {
    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
  }
};

/**
 * Provides a queue for collecting `componentDidMount` and
 * `componentDidUpdate` callbacks during the transaction.
 */
var ON_DOM_READY_QUEUEING = {
  /**
   * Initializes the internal `onDOMReady` queue.
   */
  initialize: function () {
    this.reactMountReady.reset();
  },

  /**
   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
   */
  close: function () {
    this.reactMountReady.notifyAll();
  }
};

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

/**
 * Currently:
 * - The order that these are listed in the transaction is critical:
 * - Suppresses events.
 * - Restores selection range.
 *
 * Future:
 * - Restore document/overflow scroll positions that were unintentionally
 *   modified via DOM insertions above the top viewport boundary.
 * - Implement/integrate with customized constraint based layout system and keep
 *   track of which dimensions must be remeasured.
 *
 * @class ReactReconcileTransaction
 */
function ReactReconcileTransaction(useCreateElement) {
  this.reinitializeTransaction();
  // Only server-side rendering really needs this option (see
  // `ReactServerRendering`), but server-side uses
  // `ReactServerRenderingTransaction` instead. This option is here so that it's
  // accessible and defaults to false when `ReactDOMComponent` and
  // `ReactDOMTextComponent` checks it in `mountComponent`.`
  this.renderToStaticMarkup = false;
  this.reactMountReady = CallbackQueue.getPooled(null);
  this.useCreateElement = useCreateElement;
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array<object>} List of operation wrap procedures.
   *   TODO: convert to array<TransactionWrapper>
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return this.reactMountReady;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return ReactUpdateQueue;
  },

  /**
   * Save current transaction state -- if the return value from this method is
   * passed to `rollback`, the transaction will be reset to that state.
   */
  checkpoint: function () {
    // reactMountReady is the our only stateful wrapper
    return this.reactMountReady.checkpoint();
  },

  rollback: function (checkpoint) {
    this.reactMountReady.rollback(checkpoint);
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {
    CallbackQueue.release(this.reactMountReady);
    this.reactMountReady = null;
  }
};

_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactReconcileTransaction);

module.exports = ReactReconcileTransaction;

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(11);

var getNodeForCharacterOffset = __webpack_require__(390);
var getTextContentAccessor = __webpack_require__(115);

/**
 * While `isCollapsed` is available on the Selection object and `collapsed`
 * is available on the Range object, IE11 sometimes gets them wrong.
 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
 */
function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
  return anchorNode === focusNode && anchorOffset === focusOffset;
}

/**
 * Get the appropriate anchor and focus node/offset pairs for IE.
 *
 * The catch here is that IE's selection API doesn't provide information
 * about whether the selection is forward or backward, so we have to
 * behave as though it's always forward.
 *
 * IE text differs from modern selection in that it behaves as though
 * block elements end with a new line. This means character offsets will
 * differ between the two APIs.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getIEOffsets(node) {
  var selection = document.selection;
  var selectedRange = selection.createRange();
  var selectedLength = selectedRange.text.length;

  // Duplicate selection so we can move range without breaking user selection.
  var fromStart = selectedRange.duplicate();
  fromStart.moveToElementText(node);
  fromStart.setEndPoint('EndToStart', selectedRange);

  var startOffset = fromStart.text.length;
  var endOffset = startOffset + selectedLength;

  return {
    start: startOffset,
    end: endOffset
  };
}

/**
 * @param {DOMElement} node
 * @return {?object}
 */
function getModernOffsets(node) {
  var selection = window.getSelection && window.getSelection();

  if (!selection || selection.rangeCount === 0) {
    return null;
  }

  var anchorNode = selection.anchorNode;
  var anchorOffset = selection.anchorOffset;
  var focusNode = selection.focusNode;
  var focusOffset = selection.focusOffset;

  var currentRange = selection.getRangeAt(0);

  // In Firefox, range.startContainer and range.endContainer can be "anonymous
  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
  // divs do not seem to expose properties, triggering a "Permission denied
  // error" if any of its properties are accessed. The only seemingly possible
  // way to avoid erroring is to access a property that typically works for
  // non-anonymous divs and catch any error that may otherwise arise. See
  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
  try {
    /* eslint-disable no-unused-expressions */
    currentRange.startContainer.nodeType;
    currentRange.endContainer.nodeType;
    /* eslint-enable no-unused-expressions */
  } catch (e) {
    return null;
  }

  // If the node and offset values are the same, the selection is collapsed.
  // `Selection.isCollapsed` is available natively, but IE sometimes gets
  // this value wrong.
  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);

  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;

  var tempRange = currentRange.cloneRange();
  tempRange.selectNodeContents(node);
  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);

  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);

  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
  var end = start + rangeLength;

  // Detect whether the selection is backward.
  var detectionRange = document.createRange();
  detectionRange.setStart(anchorNode, anchorOffset);
  detectionRange.setEnd(focusNode, focusOffset);
  var isBackward = detectionRange.collapsed;

  return {
    start: isBackward ? end : start,
    end: isBackward ? start : end
  };
}

/**
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setIEOffsets(node, offsets) {
  var range = document.selection.createRange().duplicate();
  var start, end;

  if (offsets.end === undefined) {
    start = offsets.start;
    end = start;
  } else if (offsets.start > offsets.end) {
    start = offsets.end;
    end = offsets.start;
  } else {
    start = offsets.start;
    end = offsets.end;
  }

  range.moveToElementText(node);
  range.moveStart('character', start);
  range.setEndPoint('EndToStart', range);
  range.moveEnd('character', end - start);
  range.select();
}

/**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setModernOffsets(node, offsets) {
  if (!window.getSelection) {
    return;
  }

  var selection = window.getSelection();
  var length = node[getTextContentAccessor()].length;
  var start = Math.min(offsets.start, length);
  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);

  // IE 11 uses modern selection, but doesn't support the extend method.
  // Flip backward selections, so we can set with a single range.
  if (!selection.extend && start > end) {
    var temp = end;
    end = start;
    start = temp;
  }

  var startMarker = getNodeForCharacterOffset(node, start);
  var endMarker = getNodeForCharacterOffset(node, end);

  if (startMarker && endMarker) {
    var range = document.createRange();
    range.setStart(startMarker.node, startMarker.offset);
    selection.removeAllRanges();

    if (start > end) {
      selection.addRange(range);
      selection.extend(endMarker.node, endMarker.offset);
    } else {
      range.setEnd(endMarker.node, endMarker.offset);
      selection.addRange(range);
    }
  }
}

var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);

var ReactDOMSelection = {
  /**
   * @param {DOMElement} node
   */
  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,

  /**
   * @param {DOMElement|DOMTextNode} node
   * @param {object} offsets
   */
  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
};

module.exports = ReactDOMSelection;

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */

function getLeafNode(node) {
  while (node && node.firstChild) {
    node = node.firstChild;
  }
  return node;
}

/**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */
function getSiblingNode(node) {
  while (node) {
    if (node.nextSibling) {
      return node.nextSibling;
    }
    node = node.parentNode;
  }
}

/**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */
function getNodeForCharacterOffset(root, offset) {
  var node = getLeafNode(root);
  var nodeStart = 0;
  var nodeEnd = 0;

  while (node) {
    if (node.nodeType === 3) {
      nodeEnd = nodeStart + node.textContent.length;

      if (nodeStart <= offset && nodeEnd >= offset) {
        return {
          node: node,
          offset: offset - nodeStart
        };
      }

      nodeStart = nodeEnd;
    }

    node = getLeafNode(getSiblingNode(node));
  }
}

module.exports = getNodeForCharacterOffset;

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(392);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(393);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var NS = {
  xlink: 'http://www.w3.org/1999/xlink',
  xml: 'http://www.w3.org/XML/1998/namespace'
};

// We use attributes for everything SVG so let's avoid some duplication and run
// code instead.
// The following are all specified in the HTML config already so we exclude here.
// - class (as className)
// - color
// - height
// - id
// - lang
// - max
// - media
// - method
// - min
// - name
// - style
// - target
// - type
// - width
var ATTRS = {
  accentHeight: 'accent-height',
  accumulate: 0,
  additive: 0,
  alignmentBaseline: 'alignment-baseline',
  allowReorder: 'allowReorder',
  alphabetic: 0,
  amplitude: 0,
  arabicForm: 'arabic-form',
  ascent: 0,
  attributeName: 'attributeName',
  attributeType: 'attributeType',
  autoReverse: 'autoReverse',
  azimuth: 0,
  baseFrequency: 'baseFrequency',
  baseProfile: 'baseProfile',
  baselineShift: 'baseline-shift',
  bbox: 0,
  begin: 0,
  bias: 0,
  by: 0,
  calcMode: 'calcMode',
  capHeight: 'cap-height',
  clip: 0,
  clipPath: 'clip-path',
  clipRule: 'clip-rule',
  clipPathUnits: 'clipPathUnits',
  colorInterpolation: 'color-interpolation',
  colorInterpolationFilters: 'color-interpolation-filters',
  colorProfile: 'color-profile',
  colorRendering: 'color-rendering',
  contentScriptType: 'contentScriptType',
  contentStyleType: 'contentStyleType',
  cursor: 0,
  cx: 0,
  cy: 0,
  d: 0,
  decelerate: 0,
  descent: 0,
  diffuseConstant: 'diffuseConstant',
  direction: 0,
  display: 0,
  divisor: 0,
  dominantBaseline: 'dominant-baseline',
  dur: 0,
  dx: 0,
  dy: 0,
  edgeMode: 'edgeMode',
  elevation: 0,
  enableBackground: 'enable-background',
  end: 0,
  exponent: 0,
  externalResourcesRequired: 'externalResourcesRequired',
  fill: 0,
  fillOpacity: 'fill-opacity',
  fillRule: 'fill-rule',
  filter: 0,
  filterRes: 'filterRes',
  filterUnits: 'filterUnits',
  floodColor: 'flood-color',
  floodOpacity: 'flood-opacity',
  focusable: 0,
  fontFamily: 'font-family',
  fontSize: 'font-size',
  fontSizeAdjust: 'font-size-adjust',
  fontStretch: 'font-stretch',
  fontStyle: 'font-style',
  fontVariant: 'font-variant',
  fontWeight: 'font-weight',
  format: 0,
  from: 0,
  fx: 0,
  fy: 0,
  g1: 0,
  g2: 0,
  glyphName: 'glyph-name',
  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
  glyphOrientationVertical: 'glyph-orientation-vertical',
  glyphRef: 'glyphRef',
  gradientTransform: 'gradientTransform',
  gradientUnits: 'gradientUnits',
  hanging: 0,
  horizAdvX: 'horiz-adv-x',
  horizOriginX: 'horiz-origin-x',
  ideographic: 0,
  imageRendering: 'image-rendering',
  'in': 0,
  in2: 0,
  intercept: 0,
  k: 0,
  k1: 0,
  k2: 0,
  k3: 0,
  k4: 0,
  kernelMatrix: 'kernelMatrix',
  kernelUnitLength: 'kernelUnitLength',
  kerning: 0,
  keyPoints: 'keyPoints',
  keySplines: 'keySplines',
  keyTimes: 'keyTimes',
  lengthAdjust: 'lengthAdjust',
  letterSpacing: 'letter-spacing',
  lightingColor: 'lighting-color',
  limitingConeAngle: 'limitingConeAngle',
  local: 0,
  markerEnd: 'marker-end',
  markerMid: 'marker-mid',
  markerStart: 'marker-start',
  markerHeight: 'markerHeight',
  markerUnits: 'markerUnits',
  markerWidth: 'markerWidth',
  mask: 0,
  maskContentUnits: 'maskContentUnits',
  maskUnits: 'maskUnits',
  mathematical: 0,
  mode: 0,
  numOctaves: 'numOctaves',
  offset: 0,
  opacity: 0,
  operator: 0,
  order: 0,
  orient: 0,
  orientation: 0,
  origin: 0,
  overflow: 0,
  overlinePosition: 'overline-position',
  overlineThickness: 'overline-thickness',
  paintOrder: 'paint-order',
  panose1: 'panose-1',
  pathLength: 'pathLength',
  patternContentUnits: 'patternContentUnits',
  patternTransform: 'patternTransform',
  patternUnits: 'patternUnits',
  pointerEvents: 'pointer-events',
  points: 0,
  pointsAtX: 'pointsAtX',
  pointsAtY: 'pointsAtY',
  pointsAtZ: 'pointsAtZ',
  preserveAlpha: 'preserveAlpha',
  preserveAspectRatio: 'preserveAspectRatio',
  primitiveUnits: 'primitiveUnits',
  r: 0,
  radius: 0,
  refX: 'refX',
  refY: 'refY',
  renderingIntent: 'rendering-intent',
  repeatCount: 'repeatCount',
  repeatDur: 'repeatDur',
  requiredExtensions: 'requiredExtensions',
  requiredFeatures: 'requiredFeatures',
  restart: 0,
  result: 0,
  rotate: 0,
  rx: 0,
  ry: 0,
  scale: 0,
  seed: 0,
  shapeRendering: 'shape-rendering',
  slope: 0,
  spacing: 0,
  specularConstant: 'specularConstant',
  specularExponent: 'specularExponent',
  speed: 0,
  spreadMethod: 'spreadMethod',
  startOffset: 'startOffset',
  stdDeviation: 'stdDeviation',
  stemh: 0,
  stemv: 0,
  stitchTiles: 'stitchTiles',
  stopColor: 'stop-color',
  stopOpacity: 'stop-opacity',
  strikethroughPosition: 'strikethrough-position',
  strikethroughThickness: 'strikethrough-thickness',
  string: 0,
  stroke: 0,
  strokeDasharray: 'stroke-dasharray',
  strokeDashoffset: 'stroke-dashoffset',
  strokeLinecap: 'stroke-linecap',
  strokeLinejoin: 'stroke-linejoin',
  strokeMiterlimit: 'stroke-miterlimit',
  strokeOpacity: 'stroke-opacity',
  strokeWidth: 'stroke-width',
  surfaceScale: 'surfaceScale',
  systemLanguage: 'systemLanguage',
  tableValues: 'tableValues',
  targetX: 'targetX',
  targetY: 'targetY',
  textAnchor: 'text-anchor',
  textDecoration: 'text-decoration',
  textRendering: 'text-rendering',
  textLength: 'textLength',
  to: 0,
  transform: 0,
  u1: 0,
  u2: 0,
  underlinePosition: 'underline-position',
  underlineThickness: 'underline-thickness',
  unicode: 0,
  unicodeBidi: 'unicode-bidi',
  unicodeRange: 'unicode-range',
  unitsPerEm: 'units-per-em',
  vAlphabetic: 'v-alphabetic',
  vHanging: 'v-hanging',
  vIdeographic: 'v-ideographic',
  vMathematical: 'v-mathematical',
  values: 0,
  vectorEffect: 'vector-effect',
  version: 0,
  vertAdvY: 'vert-adv-y',
  vertOriginX: 'vert-origin-x',
  vertOriginY: 'vert-origin-y',
  viewBox: 'viewBox',
  viewTarget: 'viewTarget',
  visibility: 0,
  widths: 0,
  wordSpacing: 'word-spacing',
  writingMode: 'writing-mode',
  x: 0,
  xHeight: 'x-height',
  x1: 0,
  x2: 0,
  xChannelSelector: 'xChannelSelector',
  xlinkActuate: 'xlink:actuate',
  xlinkArcrole: 'xlink:arcrole',
  xlinkHref: 'xlink:href',
  xlinkRole: 'xlink:role',
  xlinkShow: 'xlink:show',
  xlinkTitle: 'xlink:title',
  xlinkType: 'xlink:type',
  xmlBase: 'xml:base',
  xmlns: 0,
  xmlnsXlink: 'xmlns:xlink',
  xmlLang: 'xml:lang',
  xmlSpace: 'xml:space',
  y: 0,
  y1: 0,
  y2: 0,
  yChannelSelector: 'yChannelSelector',
  z: 0,
  zoomAndPan: 'zoomAndPan'
};

var SVGDOMPropertyConfig = {
  Properties: {},
  DOMAttributeNamespaces: {
    xlinkActuate: NS.xlink,
    xlinkArcrole: NS.xlink,
    xlinkHref: NS.xlink,
    xlinkRole: NS.xlink,
    xlinkShow: NS.xlink,
    xlinkTitle: NS.xlink,
    xlinkType: NS.xlink,
    xmlBase: NS.xml,
    xmlLang: NS.xml,
    xmlSpace: NS.xml
  },
  DOMAttributeNames: {}
};

Object.keys(ATTRS).forEach(function (key) {
  SVGDOMPropertyConfig.Properties[key] = 0;
  if (ATTRS[key]) {
    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
  }
});

module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(43);
var ExecutionEnvironment = __webpack_require__(11);
var ReactDOMComponentTree = __webpack_require__(9);
var ReactInputSelection = __webpack_require__(133);
var SyntheticEvent = __webpack_require__(20);

var getActiveElement = __webpack_require__(134);
var isTextInputElement = __webpack_require__(118);
var shallowEqual = __webpack_require__(79);

var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;

var eventTypes = {
  select: {
    phasedRegistrationNames: {
      bubbled: 'onSelect',
      captured: 'onSelectCapture'
    },
    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
  }
};

var activeElement = null;
var activeElementInst = null;
var lastSelection = null;
var mouseDown = false;

// Track whether a listener exists for this plugin. If none exist, we do
// not extract events. See #3639.
var hasListener = false;

/**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getSelection(node) {
  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
    return {
      start: node.selectionStart,
      end: node.selectionEnd
    };
  } else if (window.getSelection) {
    var selection = window.getSelection();
    return {
      anchorNode: selection.anchorNode,
      anchorOffset: selection.anchorOffset,
      focusNode: selection.focusNode,
      focusOffset: selection.focusOffset
    };
  } else if (document.selection) {
    var range = document.selection.createRange();
    return {
      parentElement: range.parentElement(),
      text: range.text,
      top: range.boundingTop,
      left: range.boundingLeft
    };
  }
}

/**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @return {?SyntheticEvent}
 */
function constructSelectEvent(nativeEvent, nativeEventTarget) {
  // Ensure we have the right element, and that the user is not dragging a
  // selection (this matches native `select` event behavior). In HTML5, select
  // fires only on input and textarea thus if there's no focused element we
  // won't dispatch.
  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
    return null;
  }

  // Only fire when selection has actually changed.
  var currentSelection = getSelection(activeElement);
  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
    lastSelection = currentSelection;

    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);

    syntheticEvent.type = 'select';
    syntheticEvent.target = activeElement;

    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);

    return syntheticEvent;
  }

  return null;
}

/**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */
var SelectEventPlugin = {

  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (!hasListener) {
      return null;
    }

    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    switch (topLevelType) {
      // Track the input node that has focus.
      case 'topFocus':
        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
          activeElement = targetNode;
          activeElementInst = targetInst;
          lastSelection = null;
        }
        break;
      case 'topBlur':
        activeElement = null;
        activeElementInst = null;
        lastSelection = null;
        break;

      // Don't fire the event while the user is dragging. This matches the
      // semantics of the native select event.
      case 'topMouseDown':
        mouseDown = true;
        break;
      case 'topContextMenu':
      case 'topMouseUp':
        mouseDown = false;
        return constructSelectEvent(nativeEvent, nativeEventTarget);

      // Chrome and IE fire non-standard event when selection is changed (and
      // sometimes when it hasn't). IE's event fires out of order with respect
      // to key and input events on deletion, so we discard it.
      //
      // Firefox doesn't support selectionchange, so check selection status
      // after each key entry. The selection changes after keydown and before
      // keyup, but we check on keydown as well in the case of holding down a
      // key, when multiple keydown events are fired but only one keyup is.
      // This is also our approach for IE handling, for the reason above.
      case 'topSelectionChange':
        if (skipSelectionChangeEvent) {
          break;
        }
      // falls through
      case 'topKeyDown':
      case 'topKeyUp':
        return constructSelectEvent(nativeEvent, nativeEventTarget);
    }

    return null;
  },

  didPutListener: function (inst, registrationName, listener) {
    if (registrationName === 'onSelect') {
      hasListener = true;
    }
  }
};

module.exports = SelectEventPlugin;

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(5);

var EventListener = __webpack_require__(132);
var EventPropagators = __webpack_require__(43);
var ReactDOMComponentTree = __webpack_require__(9);
var SyntheticAnimationEvent = __webpack_require__(397);
var SyntheticClipboardEvent = __webpack_require__(398);
var SyntheticEvent = __webpack_require__(20);
var SyntheticFocusEvent = __webpack_require__(399);
var SyntheticKeyboardEvent = __webpack_require__(400);
var SyntheticMouseEvent = __webpack_require__(52);
var SyntheticDragEvent = __webpack_require__(402);
var SyntheticTouchEvent = __webpack_require__(403);
var SyntheticTransitionEvent = __webpack_require__(404);
var SyntheticUIEvent = __webpack_require__(45);
var SyntheticWheelEvent = __webpack_require__(405);

var emptyFunction = __webpack_require__(12);
var getEventCharCode = __webpack_require__(84);
var invariant = __webpack_require__(2);

/**
 * Turns
 * ['abort', ...]
 * into
 * eventTypes = {
 *   'abort': {
 *     phasedRegistrationNames: {
 *       bubbled: 'onAbort',
 *       captured: 'onAbortCapture',
 *     },
 *     dependencies: ['topAbort'],
 *   },
 *   ...
 * };
 * topLevelEventsToDispatchConfig = {
 *   'topAbort': { sameConfig }
 * };
 */
var eventTypes = {};
var topLevelEventsToDispatchConfig = {};
['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
  var onEvent = 'on' + capitalizedEvent;
  var topEvent = 'top' + capitalizedEvent;

  var type = {
    phasedRegistrationNames: {
      bubbled: onEvent,
      captured: onEvent + 'Capture'
    },
    dependencies: [topEvent]
  };
  eventTypes[event] = type;
  topLevelEventsToDispatchConfig[topEvent] = type;
});

var onClickListeners = {};

function getDictionaryKey(inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
}

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

var SimpleEventPlugin = {

  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
    if (!dispatchConfig) {
      return null;
    }
    var EventConstructor;
    switch (topLevelType) {
      case 'topAbort':
      case 'topCanPlay':
      case 'topCanPlayThrough':
      case 'topDurationChange':
      case 'topEmptied':
      case 'topEncrypted':
      case 'topEnded':
      case 'topError':
      case 'topInput':
      case 'topInvalid':
      case 'topLoad':
      case 'topLoadedData':
      case 'topLoadedMetadata':
      case 'topLoadStart':
      case 'topPause':
      case 'topPlay':
      case 'topPlaying':
      case 'topProgress':
      case 'topRateChange':
      case 'topReset':
      case 'topSeeked':
      case 'topSeeking':
      case 'topStalled':
      case 'topSubmit':
      case 'topSuspend':
      case 'topTimeUpdate':
      case 'topVolumeChange':
      case 'topWaiting':
        // HTML Events
        // @see http://www.w3.org/TR/html5/index.html#events-0
        EventConstructor = SyntheticEvent;
        break;
      case 'topKeyPress':
        // Firefox creates a keypress event for function keys too. This removes
        // the unwanted keypress events. Enter is however both printable and
        // non-printable. One would expect Tab to be as well (but it isn't).
        if (getEventCharCode(nativeEvent) === 0) {
          return null;
        }
      /* falls through */
      case 'topKeyDown':
      case 'topKeyUp':
        EventConstructor = SyntheticKeyboardEvent;
        break;
      case 'topBlur':
      case 'topFocus':
        EventConstructor = SyntheticFocusEvent;
        break;
      case 'topClick':
        // Firefox creates a click event on right mouse clicks. This removes the
        // unwanted click events.
        if (nativeEvent.button === 2) {
          return null;
        }
      /* falls through */
      case 'topDoubleClick':
      case 'topMouseDown':
      case 'topMouseMove':
      case 'topMouseUp':
      // TODO: Disabled elements should not respond to mouse events
      /* falls through */
      case 'topMouseOut':
      case 'topMouseOver':
      case 'topContextMenu':
        EventConstructor = SyntheticMouseEvent;
        break;
      case 'topDrag':
      case 'topDragEnd':
      case 'topDragEnter':
      case 'topDragExit':
      case 'topDragLeave':
      case 'topDragOver':
      case 'topDragStart':
      case 'topDrop':
        EventConstructor = SyntheticDragEvent;
        break;
      case 'topTouchCancel':
      case 'topTouchEnd':
      case 'topTouchMove':
      case 'topTouchStart':
        EventConstructor = SyntheticTouchEvent;
        break;
      case 'topAnimationEnd':
      case 'topAnimationIteration':
      case 'topAnimationStart':
        EventConstructor = SyntheticAnimationEvent;
        break;
      case 'topTransitionEnd':
        EventConstructor = SyntheticTransitionEvent;
        break;
      case 'topScroll':
        EventConstructor = SyntheticUIEvent;
        break;
      case 'topWheel':
        EventConstructor = SyntheticWheelEvent;
        break;
      case 'topCopy':
      case 'topCut':
      case 'topPaste':
        EventConstructor = SyntheticClipboardEvent;
        break;
    }
    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
    EventPropagators.accumulateTwoPhaseDispatches(event);
    return event;
  },

  didPutListener: function (inst, registrationName, listener) {
    // Mobile Safari does not fire properly bubble click events on
    // non-interactive elements, which means delegated click listeners do not
    // fire. The workaround for this bug involves attaching an empty click
    // listener on the target node.
    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      if (!onClickListeners[key]) {
        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
      }
    }
  },

  willDeleteListener: function (inst, registrationName) {
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      onClickListeners[key].remove();
      delete onClickListeners[key];
    }
  }

};

module.exports = SimpleEventPlugin;

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(20);

/**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */
var AnimationEventInterface = {
  animationName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);

module.exports = SyntheticAnimationEvent;

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(20);

/**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */
var ClipboardEventInterface = {
  clipboardData: function (event) {
    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);

module.exports = SyntheticClipboardEvent;

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(45);

/**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var FocusEventInterface = {
  relatedTarget: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);

module.exports = SyntheticFocusEvent;

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(45);

var getEventCharCode = __webpack_require__(84);
var getEventKey = __webpack_require__(401);
var getEventModifierState = __webpack_require__(73);

/**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var KeyboardEventInterface = {
  key: getEventKey,
  location: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  repeat: null,
  locale: null,
  getModifierState: getEventModifierState,
  // Legacy Interface
  charCode: function (event) {
    // `charCode` is the result of a KeyPress event and represents the value of
    // the actual printable character.

    // KeyPress is deprecated, but its replacement is not yet final and not
    // implemented in any major browser. Only KeyPress has charCode.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    return 0;
  },
  keyCode: function (event) {
    // `keyCode` is the result of a KeyDown/Up event and represents the value of
    // physical keyboard key.

    // The actual meaning of the value depends on the users' keyboard layout
    // which cannot be detected. Assuming that it is a US keyboard layout
    // provides a surprisingly accurate mapping for US and European users.
    // Due to this, it is left to the user to implement at this time.
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  },
  which: function (event) {
    // `which` is an alias for either `keyCode` or `charCode` depending on the
    // type of the event.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);

module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var getEventCharCode = __webpack_require__(84);

/**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var normalizeKey = {
  'Esc': 'Escape',
  'Spacebar': ' ',
  'Left': 'ArrowLeft',
  'Up': 'ArrowUp',
  'Right': 'ArrowRight',
  'Down': 'ArrowDown',
  'Del': 'Delete',
  'Win': 'OS',
  'Menu': 'ContextMenu',
  'Apps': 'ContextMenu',
  'Scroll': 'ScrollLock',
  'MozPrintableKey': 'Unidentified'
};

/**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var translateToKey = {
  8: 'Backspace',
  9: 'Tab',
  12: 'Clear',
  13: 'Enter',
  16: 'Shift',
  17: 'Control',
  18: 'Alt',
  19: 'Pause',
  20: 'CapsLock',
  27: 'Escape',
  32: ' ',
  33: 'PageUp',
  34: 'PageDown',
  35: 'End',
  36: 'Home',
  37: 'ArrowLeft',
  38: 'ArrowUp',
  39: 'ArrowRight',
  40: 'ArrowDown',
  45: 'Insert',
  46: 'Delete',
  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
  144: 'NumLock',
  145: 'ScrollLock',
  224: 'Meta'
};

/**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */
function getEventKey(nativeEvent) {
  if (nativeEvent.key) {
    // Normalize inconsistent values reported by browsers due to
    // implementations of a working draft specification.

    // FireFox implements `key` but returns `MozPrintableKey` for all
    // printable characters (normalized to `Unidentified`), ignore it.
    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
    if (key !== 'Unidentified') {
      return key;
    }
  }

  // Browser does not implement `key`, polyfill as much of it as we can.
  if (nativeEvent.type === 'keypress') {
    var charCode = getEventCharCode(nativeEvent);

    // The enter-key is technically both printable and non-printable and can
    // thus be captured by `keypress`, no other non-printable key should.
    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
  }
  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
    // While user keyboard layout determines the actual meaning of each
    // `keyCode` value, almost all function keys have a universal value.
    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
  }
  return '';
}

module.exports = getEventKey;

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticMouseEvent = __webpack_require__(52);

/**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var DragEventInterface = {
  dataTransfer: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);

module.exports = SyntheticDragEvent;

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(45);

var getEventModifierState = __webpack_require__(73);

/**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */
var TouchEventInterface = {
  touches: null,
  targetTouches: null,
  changedTouches: null,
  altKey: null,
  metaKey: null,
  ctrlKey: null,
  shiftKey: null,
  getModifierState: getEventModifierState
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);

module.exports = SyntheticTouchEvent;

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(20);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */
var TransitionEventInterface = {
  propertyName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);

module.exports = SyntheticTransitionEvent;

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticMouseEvent = __webpack_require__(52);

/**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var WheelEventInterface = {
  deltaX: function (event) {
    return 'deltaX' in event ? event.deltaX :
    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
  },
  deltaY: function (event) {
    return 'deltaY' in event ? event.deltaY :
    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
    'wheelDeltaY' in event ? -event.wheelDeltaY :
    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
    'wheelDelta' in event ? -event.wheelDelta : 0;
  },
  deltaZ: null,

  // Browsers without "deltaMode" is reporting in raw wheel delta where one
  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
  deltaMode: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticMouseEvent}
 */
function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);

module.exports = SyntheticWheelEvent;

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var validateDOMNesting = __webpack_require__(83);

var DOC_NODE_TYPE = 9;

function ReactDOMContainerInfo(topLevelWrapper, node) {
  var info = {
    _topLevelWrapper: topLevelWrapper,
    _idCounter: 1,
    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
    _node: node,
    _tag: node ? node.nodeName.toLowerCase() : null,
    _namespaceURI: node ? node.namespaceURI : null
  };
  if (false) {
    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
  }
  return info;
}

module.exports = ReactDOMContainerInfo;

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMFeatureFlags = {
  useCreateElement: true,
  useFiber: false
};

module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var adler32 = __webpack_require__(409);

var TAG_END = /\/?>/;
var COMMENT_START = /^<\!\-\-/;

var ReactMarkupChecksum = {
  CHECKSUM_ATTR_NAME: 'data-react-checksum',

  /**
   * @param {string} markup Markup string
   * @return {string} Markup string with checksum attribute attached
   */
  addChecksumToMarkup: function (markup) {
    var checksum = adler32(markup);

    // Add checksum (handle both parent tags, comments and self-closing tags)
    if (COMMENT_START.test(markup)) {
      return markup;
    } else {
      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
    }
  },

  /**
   * @param {string} markup to use
   * @param {DOMElement} element root React element
   * @returns {boolean} whether or not the markup is the same
   */
  canReuseMarkup: function (markup, element) {
    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
    var markupChecksum = adler32(markup);
    return markupChecksum === existingChecksum;
  }
};

module.exports = ReactMarkupChecksum;

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var MOD = 65521;

// adler32 is not cryptographically strong, and is only used to sanity check that
// markup generated on the server matches the markup generated on the client.
// This implementation (a modified version of the SheetJS version) has been optimized
// for our use case, at the expense of conforming to the adler32 specification
// for non-ascii inputs.
function adler32(data) {
  var a = 1;
  var b = 0;
  var i = 0;
  var l = data.length;
  var m = l & ~0x3;
  while (i < m) {
    var n = Math.min(i + 4096, m);
    for (; i < n; i += 4) {
      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
    }
    a %= MOD;
    b %= MOD;
  }
  for (; i < l; i++) {
    b += a += data.charCodeAt(i);
  }
  a %= MOD;
  b %= MOD;
  return a | b << 16;
}

module.exports = adler32;

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



module.exports = '15.5.4';

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(5);

var ReactCurrentOwner = __webpack_require__(19);
var ReactDOMComponentTree = __webpack_require__(9);
var ReactInstanceMap = __webpack_require__(46);

var getHostComponentFromComposite = __webpack_require__(136);
var invariant = __webpack_require__(2);
var warning = __webpack_require__(4);

/**
 * Returns the DOM node rendered by this element.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
 *
 * @param {ReactComponent|DOMElement} componentOrElement
 * @return {?DOMElement} The root node of this element.
 */
function findDOMNode(componentOrElement) {
  if (false) {
    var owner = ReactCurrentOwner.current;
    if (owner !== null) {
      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
      owner._warnedAboutRefsInRender = true;
    }
  }
  if (componentOrElement == null) {
    return null;
  }
  if (componentOrElement.nodeType === 1) {
    return componentOrElement;
  }

  var inst = ReactInstanceMap.get(componentOrElement);
  if (inst) {
    inst = getHostComponentFromComposite(inst);
    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
  }

  if (typeof componentOrElement.render === 'function') {
     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
  } else {
     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
  }
}

module.exports = findDOMNode;

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactMount = __webpack_require__(135);

module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RouterContext__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RouteUtils__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RouterUtils__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__routerWarning__ = __webpack_require__(39);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }













var propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"],
  children: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["d" /* routes */],
  routes: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["d" /* routes */], // alias for children
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  createElement: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onError: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onUpdate: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],

  // PRIVATE: For client-side rehydration of server match.
  matchContext: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"]
};

/**
 * A <Router> is a high-level API for automatically setting up
 * a router that renders a <RouterContext> with all the props
 * it needs each time the URL changes.
 */
var Router = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default.a({
  displayName: 'Router',

  propTypes: propTypes,

  getDefaultProps: function getDefaultProps() {
    return {
      render: function render(props) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__RouterContext__["a" /* default */], props);
      }
    };
  },
  getInitialState: function getInitialState() {
    return {
      location: null,
      routes: null,
      params: null,
      components: null
    };
  },
  handleError: function handleError(error) {
    if (this.props.onError) {
      this.props.onError.call(this, error);
    } else {
      // Throw errors by default so we don't silently swallow them!
      throw error; // This error probably occurred in getChildRoutes or getComponents.
    }
  },
  createRouterObject: function createRouterObject(state) {
    var matchContext = this.props.matchContext;

    if (matchContext) {
      return matchContext.router;
    }

    var history = this.props.history;

    return __WEBPACK_IMPORTED_MODULE_8__RouterUtils__["b" /* createRouterObject */](history, this.transitionManager, state);
  },
  createTransitionManager: function createTransitionManager() {
    var matchContext = this.props.matchContext;

    if (matchContext) {
      return matchContext.transitionManager;
    }

    var history = this.props.history;
    var _props = this.props,
        routes = _props.routes,
        children = _props.children;


    !history.getCurrentLocation ?  false ? invariant(false, 'You have provided a history object created with history v4.x or v2.x ' + 'and earlier. This version of React Router is only compatible with v3 ' + 'history objects. Please change to history v3.x.') : __WEBPACK_IMPORTED_MODULE_0_invariant___default.a(false) : void 0;

    return __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */](history, __WEBPACK_IMPORTED_MODULE_7__RouteUtils__["b" /* createRoutes */](routes || children));
  },
  componentWillMount: function componentWillMount() {
    var _this = this;

    this.transitionManager = this.createTransitionManager();
    this.router = this.createRouterObject(this.state);

    this._unlisten = this.transitionManager.listen(function (error, state) {
      if (error) {
        _this.handleError(error);
      } else {
        // Keep the identity of this.router because of a caveat in ContextUtils:
        // they only work if the object identity is preserved.
        __WEBPACK_IMPORTED_MODULE_8__RouterUtils__["a" /* assignRouterState */](_this.router, state);
        _this.setState(state, _this.props.onUpdate);
      }
    });
  },


  /* istanbul ignore next: sanity check */
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
     false ? warning(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;

     false ? warning((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
  },
  componentWillUnmount: function componentWillUnmount() {
    if (this._unlisten) this._unlisten();
  },
  render: function render() {
    var _state = this.state,
        location = _state.location,
        routes = _state.routes,
        params = _state.params,
        components = _state.components;

    var _props2 = this.props,
        createElement = _props2.createElement,
        render = _props2.render,
        props = _objectWithoutProperties(_props2, ['createElement', 'render']);

    if (location == null) return null; // Async match

    // Only forward non-Router-specific props to routing context, as those are
    // the only ones that might be custom routing context props.
    Object.keys(propTypes).forEach(function (propType) {
      return delete props[propType];
    });

    return render(_extends({}, props, {
      router: this.router,
      location: location,
      routes: routes,
      params: params,
      components: components,
      createElement: createElement
    }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(415);

var emptyObject = __webpack_require__(35);
var _invariant = __webpack_require__(2);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }
    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isInherited = name in Constructor;
      _invariant(
        !isInherited,
        'ReactClass: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be ' +
          'due to a mixin.',
        name
      );
      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(12);
var invariant = __webpack_require__(2);
var ReactPropTypesSecret = __webpack_require__(111);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(40);


function routeParamsChanged(route, prevState, nextState) {
  if (!route.path) return false;

  var paramNames = __WEBPACK_IMPORTED_MODULE_0__PatternUtils__["b" /* getParamNames */](route.path);

  return paramNames.some(function (paramName) {
    return prevState.params[paramName] !== nextState.params[paramName];
  });
}

/**
 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
 * the change from prevState to nextState. We leave routes if either
 * 1) they are not in the next state or 2) they are in the next state
 * but their params have changed (i.e. /users/123 => /users/456).
 *
 * leaveRoutes are ordered starting at the leaf route of the tree
 * we're leaving up to the common parent route. enterRoutes are ordered
 * from the top of the tree we're entering down to the leaf route.
 *
 * changeRoutes are any routes that didn't leave or enter during
 * the transition.
 */
function computeChangedRoutes(prevState, nextState) {
  var prevRoutes = prevState && prevState.routes;
  var nextRoutes = nextState.routes;

  var leaveRoutes = void 0,
      changeRoutes = void 0,
      enterRoutes = void 0;
  if (prevRoutes) {
    var parentIsLeaving = false;
    leaveRoutes = prevRoutes.filter(function (route) {
      if (parentIsLeaving) {
        return true;
      } else {
        var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
        if (isLeaving) parentIsLeaving = true;
        return isLeaving;
      }
    });

    // onLeave hooks start at the leaf route.
    leaveRoutes.reverse();

    enterRoutes = [];
    changeRoutes = [];

    nextRoutes.forEach(function (route) {
      var isNew = prevRoutes.indexOf(route) === -1;
      var paramsChanged = leaveRoutes.indexOf(route) !== -1;

      if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
    });
  } else {
    leaveRoutes = [];
    changeRoutes = [];
    enterRoutes = nextRoutes;
  }

  return {
    leaveRoutes: leaveRoutes,
    changeRoutes: changeRoutes,
    enterRoutes: enterRoutes
  };
}

/* harmony default export */ __webpack_exports__["a"] = (computeChangedRoutes);

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTransitionUtils;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(85);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var PendingHooks = function PendingHooks() {
  var _this = this;

  _classCallCheck(this, PendingHooks);

  this.hooks = [];

  this.add = function (hook) {
    return _this.hooks.push(hook);
  };

  this.remove = function (hook) {
    return _this.hooks = _this.hooks.filter(function (h) {
      return h !== hook;
    });
  };

  this.has = function (hook) {
    return _this.hooks.indexOf(hook) !== -1;
  };

  this.clear = function () {
    return _this.hooks = [];
  };
};

function getTransitionUtils() {
  var enterHooks = new PendingHooks();
  var changeHooks = new PendingHooks();

  function createTransitionHook(hook, route, asyncArity, pendingHooks) {
    var isSync = hook.length < asyncArity;

    var transitionHook = function transitionHook() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      hook.apply(route, args);

      if (isSync) {
        var callback = args[args.length - 1];
        // Assume hook executes synchronously and
        // automatically call the callback.
        callback();
      }
    };

    pendingHooks.add(transitionHook);

    return transitionHook;
  }

  function getEnterHooks(routes) {
    return routes.reduce(function (hooks, route) {
      if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3, enterHooks));
      return hooks;
    }, []);
  }

  function getChangeHooks(routes) {
    return routes.reduce(function (hooks, route) {
      if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4, changeHooks));
      return hooks;
    }, []);
  }

  function runTransitionHooks(length, iter, callback) {
    if (!length) {
      callback();
      return;
    }

    var redirectInfo = void 0;
    function replace(location) {
      redirectInfo = location;
    }

    __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["a" /* loopAsync */](length, function (index, next, done) {
      iter(index, replace, function (error) {
        if (error || redirectInfo) {
          done(error, redirectInfo); // No need to continue.
        } else {
          next();
        }
      });
    }, callback);
  }

  /**
   * Runs all onEnter hooks in the given array of routes in order
   * with onEnter(nextState, replace, callback) and calls
   * callback(error, redirectInfo) when finished. The first hook
   * to use replace short-circuits the loop.
   *
   * If a hook needs to run asynchronously, it may use the callback
   * function. However, doing so will cause the transition to pause,
   * which could lead to a non-responsive UI if the hook is slow.
   */
  function runEnterHooks(routes, nextState, callback) {
    enterHooks.clear();
    var hooks = getEnterHooks(routes);
    return runTransitionHooks(hooks.length, function (index, replace, next) {
      var wrappedNext = function wrappedNext() {
        if (enterHooks.has(hooks[index])) {
          next.apply(undefined, arguments);
          enterHooks.remove(hooks[index]);
        }
      };
      hooks[index](nextState, replace, wrappedNext);
    }, callback);
  }

  /**
   * Runs all onChange hooks in the given array of routes in order
   * with onChange(prevState, nextState, replace, callback) and calls
   * callback(error, redirectInfo) when finished. The first hook
   * to use replace short-circuits the loop.
   *
   * If a hook needs to run asynchronously, it may use the callback
   * function. However, doing so will cause the transition to pause,
   * which could lead to a non-responsive UI if the hook is slow.
   */
  function runChangeHooks(routes, state, nextState, callback) {
    changeHooks.clear();
    var hooks = getChangeHooks(routes);
    return runTransitionHooks(hooks.length, function (index, replace, next) {
      var wrappedNext = function wrappedNext() {
        if (changeHooks.has(hooks[index])) {
          next.apply(undefined, arguments);
          changeHooks.remove(hooks[index]);
        }
      };
      hooks[index](state, nextState, replace, wrappedNext);
    }, callback);
  }

  /**
   * Runs all onLeave hooks in the given array of routes in order.
   */
  function runLeaveHooks(routes, prevState) {
    for (var i = 0, len = routes.length; i < len; ++i) {
      if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
    }
  }

  return {
    runEnterHooks: runEnterHooks,
    runChangeHooks: runChangeHooks,
    runLeaveHooks: runLeaveHooks
  };
}

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isActive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(40);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



function deepEqual(a, b) {
  if (a == b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return deepEqual(item, b[index]);
    });
  }

  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
    for (var p in a) {
      if (!Object.prototype.hasOwnProperty.call(a, p)) {
        continue;
      }

      if (a[p] === undefined) {
        if (b[p] !== undefined) {
          return false;
        }
      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
        return false;
      } else if (!deepEqual(a[p], b[p])) {
        return false;
      }
    }

    return true;
  }

  return String(a) === String(b);
}

/**
 * Returns true if the current pathname matches the supplied one, net of
 * leading and trailing slash normalization. This is sufficient for an
 * indexOnly route match.
 */
function pathIsActive(pathname, currentPathname) {
  // Normalize leading slash for consistency. Leading slash on pathname has
  // already been normalized in isActive. See caveat there.
  if (currentPathname.charAt(0) !== '/') {
    currentPathname = '/' + currentPathname;
  }

  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
  // `/foo` as active, but in this case, we would already have failed the
  // match.
  if (pathname.charAt(pathname.length - 1) !== '/') {
    pathname += '/';
  }
  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
    currentPathname += '/';
  }

  return currentPathname === pathname;
}

/**
 * Returns true if the given pathname matches the active routes and params.
 */
function routeIsActive(pathname, routes, params) {
  var remainingPathname = pathname,
      paramNames = [],
      paramValues = [];

  // for...of would work here but it's probably slower post-transpilation.
  for (var i = 0, len = routes.length; i < len; ++i) {
    var route = routes[i];
    var pattern = route.path || '';

    if (pattern.charAt(0) === '/') {
      remainingPathname = pathname;
      paramNames = [];
      paramValues = [];
    }

    if (remainingPathname !== null && pattern) {
      var matched = __WEBPACK_IMPORTED_MODULE_0__PatternUtils__["c" /* matchPattern */](pattern, remainingPathname);
      if (matched) {
        remainingPathname = matched.remainingPathname;
        paramNames = [].concat(paramNames, matched.paramNames);
        paramValues = [].concat(paramValues, matched.paramValues);
      } else {
        remainingPathname = null;
      }

      if (remainingPathname === '') {
        // We have an exact match on the route. Just check that all the params
        // match.
        // FIXME: This doesn't work on repeated params.
        return paramNames.every(function (paramName, index) {
          return String(paramValues[index]) === String(params[paramName]);
        });
      }
    }
  }

  return false;
}

/**
 * Returns true if all key/value pairs in the given query are
 * currently active.
 */
function queryIsActive(query, activeQuery) {
  if (activeQuery == null) return query == null;

  if (query == null) return true;

  return deepEqual(query, activeQuery);
}

/**
 * Returns true if a <Link> to the given pathname/query combination is
 * currently active.
 */
function isActive(_ref, indexOnly, currentLocation, routes, params) {
  var pathname = _ref.pathname,
      query = _ref.query;

  if (currentLocation == null) return false;

  // TODO: This is a bit ugly. It keeps around support for treating pathnames
  // without preceding slashes as absolute paths, but possibly also works
  // around the same quirks with basenames as in matchRoutes.
  if (pathname.charAt(0) !== '/') {
    pathname = '/' + pathname;
  }

  if (!pathIsActive(pathname, currentLocation.pathname)) {
    // The path check is necessary and sufficient for indexOnly, but otherwise
    // we still need to check the routes.
    if (indexOnly || !routeIsActive(pathname, routes, params)) {
      return false;
    }
  }

  return queryIsActive(query, currentLocation.query);
}

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PromiseUtils__ = __webpack_require__(138);



function getComponentsForRoute(nextState, route, callback) {
  if (route.component || route.components) {
    callback(null, route.component || route.components);
    return;
  }

  var getComponent = route.getComponent || route.getComponents;
  if (getComponent) {
    var componentReturn = getComponent.call(route, nextState, callback);
    if (__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */](componentReturn)) componentReturn.then(function (component) {
      return callback(null, component);
    }, callback);
  } else {
    callback();
  }
}

/**
 * Asynchronously fetches all components needed for the given router
 * state and calls callback(error, components) when finished.
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getComponents method.
 */
function getComponents(nextState, callback) {
  __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["b" /* mapAsync */](nextState.routes, function (route, index, callback) {
    getComponentsForRoute(nextState, route, callback);
  }, callback);
}

/* harmony default export */ __webpack_exports__["a"] = (getComponents);

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = matchRoutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PromiseUtils__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PatternUtils__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__routerWarning__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(24);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







function getChildRoutes(route, location, paramNames, paramValues, callback) {
  if (route.childRoutes) {
    return [null, route.childRoutes];
  }
  if (!route.getChildRoutes) {
    return [];
  }

  var sync = true,
      result = void 0;

  var partialNextState = {
    location: location,
    params: createParams(paramNames, paramValues)
  };

  var childRoutesReturn = route.getChildRoutes(partialNextState, function (error, childRoutes) {
    childRoutes = !error && __WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */](childRoutes);
    if (sync) {
      result = [error, childRoutes];
      return;
    }

    callback(error, childRoutes);
  });

  if (__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */](childRoutesReturn)) childRoutesReturn.then(function (childRoutes) {
    return callback(null, __WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */](childRoutes));
  }, callback);

  sync = false;
  return result; // Might be undefined.
}

function getIndexRoute(route, location, paramNames, paramValues, callback) {
  if (route.indexRoute) {
    callback(null, route.indexRoute);
  } else if (route.getIndexRoute) {
    var partialNextState = {
      location: location,
      params: createParams(paramNames, paramValues)
    };

    var indexRoutesReturn = route.getIndexRoute(partialNextState, function (error, indexRoute) {
      callback(error, !error && __WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */](indexRoute)[0]);
    });

    if (__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */](indexRoutesReturn)) indexRoutesReturn.then(function (indexRoute) {
      return callback(null, __WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */](indexRoute)[0]);
    }, callback);
  } else if (route.childRoutes || route.getChildRoutes) {
    var onChildRoutes = function onChildRoutes(error, childRoutes) {
      if (error) {
        callback(error);
        return;
      }

      var pathless = childRoutes.filter(function (childRoute) {
        return !childRoute.path;
      });

      __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["a" /* loopAsync */](pathless.length, function (index, next, done) {
        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
          if (error || indexRoute) {
            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
            done(error, routes);
          } else {
            next();
          }
        });
      }, function (err, routes) {
        callback(null, routes);
      });
    };

    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
    if (result) {
      onChildRoutes.apply(undefined, result);
    }
  } else {
    callback();
  }
}

function assignParams(params, paramNames, paramValues) {
  return paramNames.reduce(function (params, paramName, index) {
    var paramValue = paramValues && paramValues[index];

    if (Array.isArray(params[paramName])) {
      params[paramName].push(paramValue);
    } else if (paramName in params) {
      params[paramName] = [params[paramName], paramValue];
    } else {
      params[paramName] = paramValue;
    }

    return params;
  }, params);
}

function createParams(paramNames, paramValues) {
  return assignParams({}, paramNames, paramValues);
}

function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
  var pattern = route.path || '';

  if (pattern.charAt(0) === '/') {
    remainingPathname = location.pathname;
    paramNames = [];
    paramValues = [];
  }

  // Only try to match the path if the route actually has a pattern, and if
  // we're not just searching for potential nested absolute paths.
  if (remainingPathname !== null && pattern) {
    try {
      var matched = __WEBPACK_IMPORTED_MODULE_2__PatternUtils__["c" /* matchPattern */](pattern, remainingPathname);
      if (matched) {
        remainingPathname = matched.remainingPathname;
        paramNames = [].concat(paramNames, matched.paramNames);
        paramValues = [].concat(paramValues, matched.paramValues);
      } else {
        remainingPathname = null;
      }
    } catch (error) {
      callback(error);
    }

    // By assumption, pattern is non-empty here, which is the prerequisite for
    // actually terminating a match.
    if (remainingPathname === '') {
      var match = {
        routes: [route],
        params: createParams(paramNames, paramValues)
      };

      getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
        if (error) {
          callback(error);
        } else {
          if (Array.isArray(indexRoute)) {
            var _match$routes;

             false ? warning(indexRoute.every(function (route) {
              return !route.path;
            }), 'Index routes should not have paths') : void 0;
            (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
          } else if (indexRoute) {
             false ? warning(!indexRoute.path, 'Index routes should not have paths') : void 0;
            match.routes.push(indexRoute);
          }

          callback(null, match);
        }
      });

      return;
    }
  }

  if (remainingPathname != null || route.childRoutes) {
    // Either a) this route matched at least some of the path or b)
    // we don't have to load this route's children asynchronously. In
    // either case continue checking for matches in the subtree.
    var onChildRoutes = function onChildRoutes(error, childRoutes) {
      if (error) {
        callback(error);
      } else if (childRoutes) {
        // Check the child routes to see if any of them match.
        matchRoutes(childRoutes, location, function (error, match) {
          if (error) {
            callback(error);
          } else if (match) {
            // A child route matched! Augment the match and pass it up the stack.
            match.routes.unshift(route);
            callback(null, match);
          } else {
            callback();
          }
        }, remainingPathname, paramNames, paramValues);
      } else {
        callback();
      }
    };

    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
    if (result) {
      onChildRoutes.apply(undefined, result);
    }
  } else {
    callback();
  }
}

/**
 * Asynchronously matches the given location to a set of routes and calls
 * callback(error, state) when finished. The state object will have the
 * following properties:
 *
 * - routes       An array of routes that matched, in hierarchical order
 * - params       An object of URL parameters
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getChildRoutes method.
 */
function matchRoutes(routes, location, callback, remainingPathname) {
  var paramNames = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var paramValues = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];

  if (remainingPathname === undefined) {
    // TODO: This is a little bit ugly, but it works around a quirk in history
    // that strips the leading slash from pathnames when using basenames with
    // trailing slashes.
    if (location.pathname.charAt(0) !== '/') {
      location = _extends({}, location, {
        pathname: '/' + location.pathname
      });
    }
    remainingPathname = location.pathname;
  }

  __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["a" /* loopAsync */](routes.length, function (index, next, done) {
    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
      if (error || match) {
        done(error, match);
      } else {
        next();
      }
    });
  }, callback);
}

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(40);


/**
 * Extracts an object of params the given route cares about from
 * the given params object.
 */
function getRouteParams(route, params) {
  var routeParams = {};

  if (!route.path) return routeParams;

  __WEBPACK_IMPORTED_MODULE_0__PatternUtils__["b" /* getParamNames */](route.path).forEach(function (p) {
    if (Object.prototype.hasOwnProperty.call(params, p)) {
      routeParams[p] = params[p];
    }
  });

  return routeParams;
}

/* harmony default export */ __webpack_exports__["a"] = (getRouteParams);

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(140);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/**
 * An <IndexLink> is used to link to an <IndexRoute>.
 */
var IndexLink = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default.a({
  displayName: 'IndexLink',

  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Link__["a" /* default */], _extends({}, this.props, { onlyActiveOnIndex: true }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (IndexLink);

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withRouter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ContextUtils__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PropTypes__ = __webpack_require__(88);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

function withRouter(WrappedComponent, options) {
  var withRef = options && options.withRef;

  var WithRouter = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default.a({
    displayName: 'WithRouter',

    mixins: [__WEBPACK_IMPORTED_MODULE_4__ContextUtils__["b" /* ContextSubscriber */]('router')],

    contextTypes: { router: __WEBPACK_IMPORTED_MODULE_5__PropTypes__["b" /* routerShape */] },
    propTypes: { router: __WEBPACK_IMPORTED_MODULE_5__PropTypes__["b" /* routerShape */] },

    getWrappedInstance: function getWrappedInstance() {
      !withRef ?  false ? invariant(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : __WEBPACK_IMPORTED_MODULE_0_invariant___default.a(false) : void 0;

      return this.wrappedInstance;
    },
    render: function render() {
      var _this = this;

      var router = this.props.router || this.context.router;
      if (!router) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedComponent, this.props);
      }

      var params = router.params,
          location = router.location,
          routes = router.routes;

      var props = _extends({}, this.props, { router: router, params: params, location: location, routes: routes });

      if (withRef) {
        props.ref = function (c) {
          _this.wrappedInstance = c;
        };
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedComponent, props);
    }
  });

  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
  WithRouter.WrappedComponent = WrappedComponent;

  return __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics___default.a(WithRouter, WrappedComponent);
}

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redirect__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(47);







/**
 * An <IndexRedirect> is used to redirect from an indexRoute.
 */
/* eslint-disable react/require-render-return */
var IndexRedirect = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default.a({
  displayName: 'IndexRedirect',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
      /* istanbul ignore else: sanity check */
      if (parentRoute) {
        parentRoute.indexRoute = __WEBPACK_IMPORTED_MODULE_4__Redirect__["a" /* default */].createRouteFromReactElement(element);
      } else {
         false ? warning(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
      }
    }
  },

  propTypes: {
    to: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"].isRequired,
    query: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    state: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    onEnter: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */],
    children: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_3_invariant___default.a(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (IndexRedirect);

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(47);







/**
 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
 * a JSX route config.
 */
/* eslint-disable react/require-render-return */
var IndexRoute = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default.a({
  displayName: 'IndexRoute',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
      /* istanbul ignore else: sanity check */
      if (parentRoute) {
        parentRoute.indexRoute = __WEBPACK_IMPORTED_MODULE_4__RouteUtils__["a" /* createRouteFromReactElement */](element);
      } else {
         false ? warning(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
      }
    }
  },

  propTypes: {
    path: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */],
    component: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["a" /* component */],
    components: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["b" /* components */],
    getComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
    getComponents: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_3_invariant___default.a(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (IndexRoute);

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RouteUtils__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__ = __webpack_require__(47);






/**
 * A <Route> is used to declare which components are rendered to the
 * page when the URL matches a given pattern.
 *
 * Routes are arranged in a nested tree structure. When a new URL is
 * requested, the tree is searched depth-first to find a route whose
 * path matches the URL.  When one is found, all routes in the tree
 * that lead to it are considered "active" and their components are
 * rendered into the DOM, nested in the same order as in the tree.
 */
/* eslint-disable react/require-render-return */
var Route = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default.a({
  displayName: 'Route',

  statics: {
    createRouteFromReactElement: __WEBPACK_IMPORTED_MODULE_3__RouteUtils__["a" /* createRouteFromReactElement */]
  },

  propTypes: {
    path: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
    component: __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__["a" /* component */],
    components: __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__["b" /* components */],
    getComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
    getComponents: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<Route> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_2_invariant___default.a(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RouterUtils__ = __webpack_require__(139);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









/**
 * A high-level API to be used for server-side rendering.
 *
 * This function matches a location to a set of routes and calls
 * callback(error, redirectLocation, renderProps) when finished.
 *
 * Note: You probably don't want to use this in a browser unless you're using
 * server-side rendering with async routes.
 */
function match(_ref, callback) {
  var history = _ref.history,
      routes = _ref.routes,
      location = _ref.location,
      options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);

  !(history || location) ?  false ? invariant(false, 'match needs a history or a location') : __WEBPACK_IMPORTED_MODULE_1_invariant___default.a(false) : void 0;

  history = history ? history : __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__["a" /* default */](options);
  var transitionManager = __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */](history, __WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */](routes));

  if (location) {
    // Allow match({ location: '/the/path', ... })
    location = history.createLocation(location);
  } else {
    location = history.getCurrentLocation();
  }

  transitionManager.match(location, function (error, redirectLocation, nextState) {
    var renderProps = void 0;

    if (nextState) {
      var router = __WEBPACK_IMPORTED_MODULE_5__RouterUtils__["b" /* createRouterObject */](history, transitionManager, nextState);
      renderProps = _extends({}, nextState, {
        router: router,
        matchContext: { transitionManager: transitionManager, router: router }
      });
    }

    callback(error, redirectLocation && history.createLocation(redirectLocation, __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__["REPLACE"]), renderProps);
  });
}

/* harmony default export */ __webpack_exports__["a"] = (match);

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(430);
var objectAssign = __webpack_require__(8);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		formatter(decodeURIComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(23);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(10);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(41);

var _PathUtils = __webpack_require__(25);

var _createHistory = __webpack_require__(90);

var _createHistory2 = _interopRequireDefault(_createHistory);

var _Actions = __webpack_require__(56);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createStateStorage = function createStateStorage(entries) {
  return entries.filter(function (entry) {
    return entry.state;
  }).reduce(function (memo, entry) {
    memo[entry.key] = entry.state;
    return memo;
  }, {});
};

var createMemoryHistory = function createMemoryHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (Array.isArray(options)) {
    options = { entries: options };
  } else if (typeof options === 'string') {
    options = { entries: [options] };
  }

  var getCurrentLocation = function getCurrentLocation() {
    var entry = entries[current];
    var path = (0, _PathUtils.createPath)(entry);

    var key = void 0,
        state = void 0;
    if (entry.key) {
      key = entry.key;
      state = readState(key);
    }

    var init = (0, _PathUtils.parsePath)(path);

    return (0, _LocationUtils.createLocation)(_extends({}, init, { state: state }), undefined, key);
  };

  var canGo = function canGo(n) {
    var index = current + n;
    return index >= 0 && index < entries.length;
  };

  var go = function go(n) {
    if (!n) return;

    if (!canGo(n)) {
       false ? (0, _warning2.default)(false, 'Cannot go(%s) there is not enough history', n) : void 0;

      return;
    }

    current += n;
    var currentLocation = getCurrentLocation();

    // Change action to POP
    history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
  };

  var pushLocation = function pushLocation(location) {
    current += 1;

    if (current < entries.length) entries.splice(current);

    entries.push(location);

    saveState(location.key, location.state);
  };

  var replaceLocation = function replaceLocation(location) {
    entries[current] = location;
    saveState(location.key, location.state);
  };

  var history = (0, _createHistory2.default)(_extends({}, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: go
  }));

  var _options = options,
      entries = _options.entries,
      current = _options.current;


  if (typeof entries === 'string') {
    entries = [entries];
  } else if (!Array.isArray(entries)) {
    entries = ['/'];
  }

  entries = entries.map(function (entry) {
    return (0, _LocationUtils.createLocation)(entry);
  });

  if (current == null) {
    current = entries.length - 1;
  } else {
    !(current >= 0 && current < entries.length) ?  false ? (0, _invariant2.default)(false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : (0, _invariant2.default)(false) : void 0;
  }

  var storage = createStateStorage(entries);

  var saveState = function saveState(key, state) {
    return storage[key] = state;
  };

  var readState = function readState(key) {
    return storage[key];
  };

  return _extends({}, history, {
    canGo: canGo
  });
};

exports.default = createMemoryHistory;

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var loopAsync = exports.loopAsync = function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var isSync = false,
      hasNext = false,
      doneArgs = void 0;

  var done = function done() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    isDone = true;

    if (isSync) {
      // Iterate instead of recursing if possible.
      doneArgs = args;
      return;
    }

    callback.apply(undefined, args);
  };

  var next = function next() {
    if (isDone) return;

    hasNext = true;

    if (isSync) return; // Iterate instead of recursing if possible.

    isSync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work(currentTurn++, next, done);
    }

    isSync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(undefined, doneArgs);
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  };

  next();
};

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RouterContext__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(39);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/* harmony default export */ __webpack_exports__["a"] = (function () {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  if (false) {
    middlewares.forEach(function (middleware, index) {
      process.env.NODE_ENV !== 'production' ? warning(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
    });
  }

  var withContext = middlewares.map(function (middleware) {
    return middleware.renderRouterContext;
  }).filter(Boolean);
  var withComponent = middlewares.map(function (middleware) {
    return middleware.renderRouteComponent;
  }).filter(Boolean);

  var makeCreateElement = function makeCreateElement() {
    var baseCreateElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"];
    return function (Component, props) {
      return withComponent.reduceRight(function (previous, renderRouteComponent) {
        return renderRouteComponent(previous, props);
      }, baseCreateElement(Component, props));
    };
  };

  return function (renderProps) {
    return withContext.reduceRight(function (previous, renderRouterContext) {
      return renderRouterContext(previous, renderProps);
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__RouterContext__["a" /* default */], _extends({}, renderProps, {
      createElement: makeCreateElement(renderProps.createElement)
    })));
  };
});

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createRouterHistory__ = __webpack_require__(148);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__createRouterHistory__["a" /* default */](__WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory___default.a));

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(10);

var _invariant2 = _interopRequireDefault(_invariant);

var _ExecutionEnvironment = __webpack_require__(91);

var _BrowserProtocol = __webpack_require__(92);

var BrowserProtocol = _interopRequireWildcard(_BrowserProtocol);

var _RefreshProtocol = __webpack_require__(436);

var RefreshProtocol = _interopRequireWildcard(_RefreshProtocol);

var _DOMUtils = __webpack_require__(57);

var _createHistory = __webpack_require__(90);

var _createHistory2 = _interopRequireDefault(_createHistory);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates and returns a history object that uses HTML5's history API
 * (pushState, replaceState, and the popstate event) to manage history.
 * This is the recommended method of managing history in browsers because
 * it provides the cleanest URLs.
 *
 * Note: In browsers that do not support the HTML5 history API full
 * page reloads will be used to preserve clean URLs. You can force this
 * behavior using { forceRefresh: true } in options.
 */
var createBrowserHistory = function createBrowserHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Browser history needs a DOM') : (0, _invariant2.default)(false) : void 0;

  var useRefresh = options.forceRefresh || !(0, _DOMUtils.supportsHistory)();
  var Protocol = useRefresh ? RefreshProtocol : BrowserProtocol;

  var getUserConfirmation = Protocol.getUserConfirmation,
      getCurrentLocation = Protocol.getCurrentLocation,
      pushLocation = Protocol.pushLocation,
      replaceLocation = Protocol.replaceLocation,
      go = Protocol.go;


  var history = (0, _createHistory2.default)(_extends({
    getUserConfirmation: getUserConfirmation }, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: go
  }));

  var listenerCount = 0,
      stopListener = void 0;

  var startListener = function startListener(listener, before) {
    if (++listenerCount === 1) stopListener = BrowserProtocol.startListener(history.transitionTo);

    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopListener();
    };
  };

  var listenBefore = function listenBefore(listener) {
    return startListener(listener, true);
  };

  var listen = function listen(listener) {
    return startListener(listener, false);
  };

  return _extends({}, history, {
    listenBefore: listenBefore,
    listen: listen
  });
};

exports.default = createBrowserHistory;

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.replaceLocation = exports.pushLocation = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;

var _BrowserProtocol = __webpack_require__(92);

Object.defineProperty(exports, 'getUserConfirmation', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.getUserConfirmation;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.go;
  }
});

var _LocationUtils = __webpack_require__(41);

var _PathUtils = __webpack_require__(25);

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
  return (0, _LocationUtils.createLocation)(window.location);
};

var pushLocation = exports.pushLocation = function pushLocation(location) {
  window.location.href = (0, _PathUtils.createPath)(location);
  return false; // Don't update location
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
  window.location.replace((0, _PathUtils.createPath)(location));
  return false; // Don't update location
};

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createRouterHistory__ = __webpack_require__(148);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__createRouterHistory__["a" /* default */](__WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory___default.a));

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(23);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(10);

var _invariant2 = _interopRequireDefault(_invariant);

var _ExecutionEnvironment = __webpack_require__(91);

var _DOMUtils = __webpack_require__(57);

var _HashProtocol = __webpack_require__(439);

var HashProtocol = _interopRequireWildcard(_HashProtocol);

var _createHistory = __webpack_require__(90);

var _createHistory2 = _interopRequireDefault(_createHistory);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DefaultQueryKey = '_k';

var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!' + path;
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substring(1) : path;
    }
  },
  noslash: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '/' ? path.substring(1) : path;
    },
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

var createHashHistory = function createHashHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Hash history needs a DOM') : (0, _invariant2.default)(false) : void 0;

  var queryKey = options.queryKey,
      hashType = options.hashType;


   false ? (0, _warning2.default)(queryKey !== false, 'Using { queryKey: false } no longer works. Instead, just don\'t ' + 'use location state if you don\'t want a key in your URL query string') : void 0;

  if (typeof queryKey !== 'string') queryKey = DefaultQueryKey;

  if (hashType == null) hashType = 'slash';

  if (!(hashType in HashPathCoders)) {
     false ? (0, _warning2.default)(false, 'Invalid hash type: %s', hashType) : void 0;

    hashType = 'slash';
  }

  var pathCoder = HashPathCoders[hashType];

  var getUserConfirmation = HashProtocol.getUserConfirmation;


  var getCurrentLocation = function getCurrentLocation() {
    return HashProtocol.getCurrentLocation(pathCoder, queryKey);
  };

  var pushLocation = function pushLocation(location) {
    return HashProtocol.pushLocation(location, pathCoder, queryKey);
  };

  var replaceLocation = function replaceLocation(location) {
    return HashProtocol.replaceLocation(location, pathCoder, queryKey);
  };

  var history = (0, _createHistory2.default)(_extends({
    getUserConfirmation: getUserConfirmation }, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: HashProtocol.go
  }));

  var listenerCount = 0,
      stopListener = void 0;

  var startListener = function startListener(listener, before) {
    if (++listenerCount === 1) stopListener = HashProtocol.startListener(history.transitionTo, pathCoder, queryKey);

    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopListener();
    };
  };

  var listenBefore = function listenBefore(listener) {
    return startListener(listener, true);
  };

  var listen = function listen(listener) {
    return startListener(listener, false);
  };

  var goIsSupportedWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();

  var go = function go(n) {
     false ? (0, _warning2.default)(goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;

    history.go(n);
  };

  var createHref = function createHref(path) {
    return '#' + pathCoder.encodePath(history.createHref(path));
  };

  return _extends({}, history, {
    listenBefore: listenBefore,
    listen: listen,
    go: go,
    createHref: createHref
  });
};

exports.default = createHashHistory;

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;

var _BrowserProtocol = __webpack_require__(92);

Object.defineProperty(exports, 'getUserConfirmation', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.getUserConfirmation;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.go;
  }
});

var _warning = __webpack_require__(23);

var _warning2 = _interopRequireDefault(_warning);

var _LocationUtils = __webpack_require__(41);

var _DOMUtils = __webpack_require__(57);

var _DOMStateStorage = __webpack_require__(147);

var _PathUtils = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HashChangeEvent = 'hashchange';

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation(pathCoder, queryKey) {
  var path = pathCoder.decodePath(getHashPath());
  var key = (0, _PathUtils.getQueryStringValueFromPath)(path, queryKey);

  var state = void 0;
  if (key) {
    path = (0, _PathUtils.stripQueryStringValueFromPath)(path, queryKey);
    state = (0, _DOMStateStorage.readState)(key);
  }

  var init = (0, _PathUtils.parsePath)(path);
  init.state = state;

  return (0, _LocationUtils.createLocation)(init, undefined, key);
};

var prevLocation = void 0;

var startListener = exports.startListener = function startListener(listener, pathCoder, queryKey) {
  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = pathCoder.encodePath(path);

    if (path !== encodedPath) {
      // Always be sure we have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var currentLocation = getCurrentLocation(pathCoder, queryKey);

      if (prevLocation && currentLocation.key && prevLocation.key === currentLocation.key) return; // Ignore extraneous hashchange events

      prevLocation = currentLocation;

      listener(currentLocation);
    }
  };

  // Ensure the hash is encoded properly.
  var path = getHashPath();
  var encodedPath = pathCoder.encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);

  return function () {
    return (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
  };
};

var updateLocation = function updateLocation(location, pathCoder, queryKey, updateHash) {
  var state = location.state,
      key = location.key;


  var path = pathCoder.encodePath((0, _PathUtils.createPath)(location));

  if (state !== undefined) {
    path = (0, _PathUtils.addQueryStringValueToPath)(path, queryKey, key);
    (0, _DOMStateStorage.saveState)(key, state);
  }

  prevLocation = location;

  updateHash(path);
};

var pushLocation = exports.pushLocation = function pushLocation(location, pathCoder, queryKey) {
  return updateLocation(location, pathCoder, queryKey, function (path) {
    if (getHashPath() !== path) {
      pushHashPath(path);
    } else {
       false ? (0, _warning2.default)(false, 'You cannot PUSH the same path using hash history') : void 0;
    }
  });
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location, pathCoder, queryKey) {
  return updateLocation(location, pathCoder, queryKey, function (path) {
    if (getHashPath() !== path) replaceHashPath(path);
  });
};

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(441);


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var AppContainer = __webpack_require__(442);

module.exports = function warnAboutIncorrectUsage(arg) {
  if (this && this.callback) {
    throw new Error('React Hot Loader: The Webpack loader is now exported separately. ' + 'If you use Babel, we recommend that you remove "react-hot-loader" ' + 'from the "loaders" section of your Webpack configuration altogether, ' + 'and instead add "react-hot-loader/babel" to the "plugins" section ' + 'of your .babelrc file. ' + 'If you prefer not to use Babel, replace "react-hot-loader" or ' + '"react-hot" with "react-hot-loader/webpack" in the "loaders" section ' + 'of your Webpack configuration.');
  } else if (arg && arg.types && arg.types.IfStatement) {
    throw new Error('React Hot Loader: The Babel plugin is exported separately. ' + 'Replace "react-hot-loader" with "react-hot-loader/babel" ' + 'in the "plugins" section of your .babelrc file. ' + 'While we recommend the above, if you prefer not to use Babel, ' + 'you may remove "react-hot-loader" from the "plugins" section of ' + 'your .babelrc file altogether, and instead add ' + '"react-hot-loader/webpack" to the "loaders" section of your Webpack ' + 'configuration.');
  } else {
    throw new Error('React Hot Loader does not have a default export. ' + 'If you use the import statement, make sure to include the ' + 'curly braces: import { AppContainer } from "react-hot-loader". ' + 'If you use CommonJS, make sure to read the named export: ' + 'require("react-hot-loader").AppContainer.');
  }
};

module.exports.AppContainer = AppContainer;

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */



if (true) {
  module.exports = __webpack_require__(443);
} else {
  module.exports = require('./AppContainer.dev');
}

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* eslint-disable react/prop-types */



var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var Component = React.Component;

var AppContainer = function (_Component) {
  _inherits(AppContainer, _Component);

  function AppContainer() {
    _classCallCheck(this, AppContainer);

    return _possibleConstructorReturn(this, (AppContainer.__proto__ || Object.getPrototypeOf(AppContainer)).apply(this, arguments));
  }

  _createClass(AppContainer, [{
    key: 'render',
    value: function render() {
      if (this.props.component) {
        return React.createElement(this.props.component, this.props.props);
      }

      return React.Children.only(this.props.children);
    }
  }]);

  return AppContainer;
}(Component);

module.exports = AppContainer;

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(445);

var _routes = __webpack_require__(469);

var _routes2 = _interopRequireDefault(_routes);

var _reactRouter = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function logPageView() {
  if (typeof window.ga === "function") {
    window.ga("set", "page", location.pathname + location.search);
    window.ga("send", "pageview");
  }
}

var Root = function (_Component) {
  _inherits(Root, _Component);

  function Root() {
    _classCallCheck(this, Root);

    return _possibleConstructorReturn(this, (Root.__proto__ || Object.getPrototypeOf(Root)).apply(this, arguments));
  }

  _createClass(Root, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          store = _props.store,
          history = _props.history;

      return _react2.default.createElement(
        _reactRedux.Provider,
        { store: store },
        _react2.default.createElement(_reactRouter.Router, { history: history, routes: _routes2.default, onUpdate: logPageView })
      );
    }
  }]);

  return Root;
}(_react.Component);

exports.default = Root;

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(448);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Provider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createProvider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connectAdvanced", function() { return __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connect", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });






/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createProvider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_warning__ = __webpack_require__(93);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  __WEBPACK_IMPORTED_MODULE_3__utils_warning__["a" /* default */]('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider() {
  var _Provider$childContex;

  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  var subKey = arguments[1];

  var subscriptionKey = subKey || storeKey + 'Subscription';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      _classCallCheck(this, Provider);

      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

      _this[storeKey] = props.store;
      return _this;
    }

    Provider.prototype.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);
  Provider.displayName = 'Provider';

  return Provider;
}

/* harmony default export */ __webpack_exports__["b"] = (createProvider());

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];

  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);

      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;

        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription = function () {
  function Subscription(store, parentSub, onStateChange) {
    _classCallCheck(this, Subscription);

    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  Subscription.prototype.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  Subscription.prototype.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);

      this.listeners = createListenerCollection();
    }
  };

  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeProps__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectorFactory__ = __webpack_require__(467);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
  };
}

function strictEqual(a, b) {
  return a === b;
}

// createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios
function createConnect() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === undefined ? __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === undefined ? __WEBPACK_IMPORTED_MODULE_4__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === undefined ? __WEBPACK_IMPORTED_MODULE_5__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref2$pure = _ref2.pure,
        pure = _ref2$pure === undefined ? true : _ref2$pure,
        _ref2$areStatesEqual = _ref2.areStatesEqual,
        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areOwnPropsEqua,
        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areStatePropsEq,
        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areMergedPropsE,
        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');

    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',

      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return 'Connect(' + name + ')';
      },

      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),

      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual

    }, extraOptions));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(155);



function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */](mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */](function (dispatch) {
    return { dispatch: dispatch };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */](function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_0_redux__["bindActionCreators"](mapDispatchToProps, dispatch);
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(455);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */](value)
    : __WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */](value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(453);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(28)))

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(152);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(457);


/** Built-in value references. */
var getPrototype = __WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */](Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(460);


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ponyfill = __webpack_require__(461);

var _ponyfill2 = _interopRequireDefault(_ponyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var root; /* global window */


if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = (0, _ponyfill2['default'])(root);
exports['default'] = result;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28), __webpack_require__(48)(module)))

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports['default'] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var _Symbol = root.Symbol;

	if (typeof _Symbol === 'function') {
		if (_Symbol.observable) {
			result = _Symbol.observable;
		} else {
			result = _Symbol('observable');
			_Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(153);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */](inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerSanity(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  if (false) {
    var unexpectedKeyCache = {};
  }

  var sanityError;
  try {
    assertReducerSanity(finalReducers);
  } catch (e) {
    sanityError = e;
  }

  return function combination() {
    var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
    var action = arguments[1];

    if (sanityError) {
      throw sanityError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var i = 0; i < finalReducerKeys.length; i++) {
      var key = finalReducerKeys[i];
      var reducer = finalReducers[key];
      var previousStateForKey = state[key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(key, action);
        throw new Error(errorMessage);
      }
      nextState[key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(154);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(155);


function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */](mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */](function () {
    return {};
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(156);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;

    var hasRunOnce = false;
    var mergedProps = void 0;

    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;

        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__verifySubselectors__ = __webpack_require__(468);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;

  var hasRunAtLeastOnce = false;
  var state = void 0;
  var ownProps = void 0;
  var stateProps = void 0;
  var dispatchProps = void 0;
  var mergedProps = void 0;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;

    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);

    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;

    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}

// TODO: Add more comments

// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;

  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(93);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      __WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */]('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(18);

var _App = __webpack_require__(470);

var _App2 = _interopRequireDefault(_App);

var _Home = __webpack_require__(478);

var _Home2 = _interopRequireDefault(_Home);

var _Tutor = __webpack_require__(481);

var _Tutor2 = _interopRequireDefault(_Tutor);

var _Gallery = __webpack_require__(483);

var _Gallery2 = _interopRequireDefault(_Gallery);

var _Performer = __webpack_require__(486);

var _Performer2 = _interopRequireDefault(_Performer);

var _Stretch = __webpack_require__(644);

var _Stretch2 = _interopRequireDefault(_Stretch);

var _Resume = __webpack_require__(669);

var _Resume2 = _interopRequireDefault(_Resume);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createElement(
    _reactRouter.Route,
    { path: '/', component: _App2.default },
    _react2.default.createElement(_reactRouter.IndexRoute, { component: _Home2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: '/tutor', component: _Tutor2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: '/photographer', component: _Gallery2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: '/performer', component: _Performer2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: '/stretch', component: _Stretch2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: '/resume', component: _Resume2.default })
);

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Drops = __webpack_require__(471);

var _Drops2 = _interopRequireDefault(_Drops);

__webpack_require__(96);

var _Cluster = __webpack_require__(473);

var _Cluster2 = _interopRequireDefault(_Cluster);

var _P5Wrapper = __webpack_require__(476);

var _P5Wrapper2 = _interopRequireDefault(_P5Wrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// This is a class-based component because the current
// version of hot reloading won't hot reload a stateless
// component at the top-level.
var _ref = _react2.default.createElement(_P5Wrapper2.default, { sketch: _Cluster2.default });

var App = function (_React$Component) {
    _inherits(App, _React$Component);

    function App() {
        _classCallCheck(this, App);

        return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
    }

    _createClass(App, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { id: 'app-component' },
                _ref,
                this.props.children
            );
        }
    }]);

    return App;
}(_react2.default.Component);

exports.default = App;

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(472);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Drops = function (_React$Component) {
    _inherits(Drops, _React$Component);

    function Drops() {
        _classCallCheck(this, Drops);

        var _this = _possibleConstructorReturn(this, (Drops.__proto__ || Object.getPrototypeOf(Drops)).call(this));

        _this.min_drop_speed = 20;
        _this.drop_speed_variance = 3;
        _this.delay_time = 30;
        _this.drop_density_width = 100; // in px
        _this.drop_density = 1;
        _this.min_drop_size = 0.25 * (_this.drop_density_width / _this.drop_density);
        _this.drop_size_variance = _this.min_drop_size;
        _this.initial_drops = 30; // deprecated
        _this.gravity_direction = 0;
        _this.angle_wiggle = 0;
        _this.drop_red = 0;
        _this.drop_green = 0;
        _this.drop_blue = 0;
        _this.frames = 0;
        _this.transition_frame = 60;
        _this.transition_time = 250;
        _this.panel_height = 10;
        return _this;
    }

    _createClass(Drops, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            var self = this;
            window.addEventListener("resize", function () {
                self.updateDrops(self);
            });
            this.drops = [];
            this.ctx = this.refs.drops_canvas.getContext('2d');
            this.updateDrops(this);
            this.updateCanvas(this);
        }
    }, {
        key: "updateDrops",
        value: function updateDrops(self) {
            self.ctx.canvas.width = window.innerWidth;
            self.ctx.canvas.height = window.innerHeight;
            self.initial_drops = Math.round(self.drop_density * (self.ctx.canvas.width / self.drop_density_width));
            self.drops = [];
            var win_gap = self.ctx.canvas.width / self.initial_drops;
            for (var i = 0; i < self.initial_drops; i++) {
                self.drops.push(self.createDrop(window.innerHeight));
                self.drops[i].x = win_gap * i;
            }
        }
    }, {
        key: "updateCanvas",
        value: function updateCanvas(self) {
            self.draw_interval = setInterval(function () {
                self.frames++;
                if (self.frames > self.transition_frame) {
                    self.ctx.fillStyle = '#000';
                    self.ctx.fillRect(0, self.panel_height, self.ctx.canvas.width, self.ctx.canvas.height - 3 * self.panel_height);
                }
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = self.drops[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var drop = _step.value;

                        if (self.frames < self.transition_frame) {
                            var clrstr = 'rgb(' + self.drop_red + ',' + self.drop_green + ',' + self.drop_blue + ')';
                            self.ctx.fillStyle = clrstr;
                            self.ctx.fillRect(drop.x - drop.r, drop.y - drop.r, drop.r * 8, drop.r * 8);
                        } else {
                            self.ctx.fillStyle = 'rgba(22, 255, 255, 1)';
                            var lsize = 15 * (drop.r / (self.min_drop_size + self.drop_size_variance));
                            self.ctx.fillRect(drop.x - lsize / 2, drop.y + drop.s * 0.9, lsize, lsize);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = self.drops[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var _drop = _step2.value;

                        if (_drop.y > self.ctx.canvas.height + _drop.r) {
                            self.drops[self.drops.indexOf(_drop)] = self.createDrop(4 * (self.min_drop_size + self.drop_size_variance));
                        } else {
                            _drop.y += _drop.s;
                            _drop.d = (_drop.d + self.gravity_direction) / 2;
                            _drop.d += (Math.random() > 0.5 ? 1 : -1) * Math.random() * self.angle_wiggle;
                        }
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }

                if (self.frames > self.transition_frame) {
                    self.ctx.fillStyle = 'rgba(0, 0, 0, 0.05)';
                    self.ctx.fillRect(0, 0, self.ctx.canvas.width, self.panel_height);
                    self.ctx.fillRect(0, self.ctx.canvas.height - 3 * self.panel_height, self.ctx.canvas.width, 3 * self.panel_height);
                }
                if (self.frames < self.transition_frame + self.transition_time && self.frames >= self.transition_frame) {
                    var anim_rat = 1 - (self.frames - self.transition_frame) / self.transition_time;
                    self.ctx.fillStyle = 'rgba(0,0,0,' + anim_rat + ')';
                    self.ctx.fillRect(0, 0, self.ctx.canvas.width, self.ctx.canvas.height);
                }
            }, this.delay_time);
        }
    }, {
        key: "createDrop",
        value: function createDrop(soff) {
            var ndrop = {
                x: Math.random() * this.ctx.canvas.width,
                y: Math.random() * -soff + -this.min_drop_size,
                r: Math.random() * this.drop_size_variance + this.min_drop_size,
                s: 10,
                d: 0
            };
            ndrop.s = ndrop.r / this.min_drop_size * this.drop_speed_variance + this.min_drop_speed;
            return ndrop;
        }
    }, {
        key: "render",
        value: function render() {
            return _react2.default.createElement(
                "div",
                { id: "drops" },
                _react2.default.createElement("canvas", { ref: "drops_canvas" })
            );
        }
    }]);

    return Drops;
}(_react2.default.Component);

exports.default = Drops;

/***/ }),
/* 472 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = clusterSketch;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(474);

var _Dot = __webpack_require__(475);

var _Dot2 = _interopRequireDefault(_Dot);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function clusterSketch(p) {
    var rotation = 0;
    p.myCustomRedrawAccordingToNewPropsHandler = function (props) {
        if (props.rotation) {
            rotation = props.rotation * Math.PI / 180;
        }
    };

    var makeDot = function makeDot() {
        return new _Dot2.default(p);
    };

    var makeDots = function makeDots() {
        DOTS_COUNT = p.width * DOTS_DENSITY;
        dots = [];
        for (var i = 0; i < DOTS_COUNT; i++) {
            var dot = makeDot();
            dot.pos.x = p.random(-p.width, 0);
            dot.pos.y = p.random(-p.height, 0);
            dot.spd = p.random(4, 7);
            dot.clr = 'rgb(22, 255, 255)';
            dot.rad = 2;

            var angle = p.random(0, p.PI * 2);
            dot.vel.x = p.cos(angle) * dot.spd;
            dot.vel.y = p.sin(angle) * dot.spd;

            dots.push(dot);
        }
    };

    var mousePos = function mousePos() {
        return p.createVector(p.mouseX - p.width / 2, p.mouseY - p.height / 2);
    };

    var dots = [];
    var DOTS_DENSITY = 1.5 / 100;
    var DOTS_COUNT = 0;
    var BACKGROUND_COLOR = 0;
    var CLUSTER_DIST = 200;

    window.addEventListener('resize', function () {
        p.resizeCanvas(window.innerWidth, window.innerHeight);
        makeDots();
    });

    p.setup = function () {
        p.createCanvas(window.innerWidth, window.innerHeight, p.WEBGL);
        makeDots();
    };

    p.draw = function () {
        p.background(BACKGROUND_COLOR);
        p.rotateY(rotation);
        for (var i = 0; i < dots.length; i++) {
            var dot = dots[i];
            p.push();
            p.fill(dot.clr);
            dot.update();
            dot.render();
            p.pop();

            var dot_modpos = dot.modpos;
            var mouse_pos = mousePos();
            var dist_to_mouse = dot_modpos.dist(mouse_pos);
            if (dist_to_mouse < CLUSTER_DIST) {
                p.push();
                p.stroke(dot.clr);
                p.line(dot_modpos.x, dot_modpos.y, mouse_pos.x, mouse_pos.y);
                p.pop();
            }

            for (var j = i - 1; j >= 0; j--) {
                var other = dots[j];
                var other_modpos = other.modpos;
                if (dot.modpos.dist(other.modpos) < CLUSTER_DIST) {
                    p.push();
                    p.stroke(dot.clr);
                    p.line(dot_modpos.x, dot_modpos.y, other_modpos.x, other_modpos.y);
                    p.pop();
                }
            }
        }
    };
}

/***/ }),
/* 474 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Dot = function () {
    function Dot(p) {
        _classCallCheck(this, Dot);

        this.p = p;
        this.pos = this.p.createVector(0, 0);
        this.vel = this.p.createVector(0, 0);
        this.rad = 0;
        this.spd = 0;
        this.clr = 0;
    }

    _createClass(Dot, [{
        key: "update",
        value: function update() {
            this.pos.add(this.vel);
        }
    }, {
        key: "render",
        value: function render() {
            this.p.ellipse(this.modpos.x, this.modpos.y, this.rad, this.rad);
        }
    }, {
        key: "modpos",
        get: function get() {
            var x = this.pos.x;
            var y = this.pos.y;

            if (x < 0) {
                x = this.p.width - Math.abs(x) % this.p.width;
            } else {
                x = Math.abs(x) % this.p.width;
            }

            if (y < 0) {
                y = this.p.height - Math.abs(y) % this.p.height;
            } else {
                y = Math.abs(y) % this.p.height;
            }

            x -= this.p.width / 2;
            y -= this.p.height / 2;

            return this.p.createVector(x, y);
        }
    }]);

    return Dot;
}();

exports.default = Dot;

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _p = __webpack_require__(477);

var _p2 = _interopRequireDefault(_p);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var P5Wrapper = function (_React$Component) {
  _inherits(P5Wrapper, _React$Component);

  function P5Wrapper() {
    _classCallCheck(this, P5Wrapper);

    return _possibleConstructorReturn(this, (P5Wrapper.__proto__ || Object.getPrototypeOf(P5Wrapper)).apply(this, arguments));
  }

  _createClass(P5Wrapper, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.canvas = new _p2.default(this.props.sketch, this.wrapper);
      if (this.canvas.myCustomRedrawAccordingToNewPropsHandler) {
        this.canvas.myCustomRedrawAccordingToNewPropsHandler(this.props);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newprops) {
      if (this.props.sketch !== newprops.sketch) {
        this.wrapper.removeChild(this.wrapper.childNodes[0]);
        this.canvas = new _p2.default(newprops.sketch, this.wrapper);
      }
      if (this.canvas.myCustomRedrawAccordingToNewPropsHandler) {
        this.canvas.myCustomRedrawAccordingToNewPropsHandler(newprops);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement('div', { ref: function ref(wrapper) {
          return _this2.wrapper = wrapper;
        } });
    }
  }]);

  return P5Wrapper;
}(_react2.default.Component);

exports.default = P5Wrapper;

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var require;var require;/*! p5.js v0.6.0 January 19, 2018 */
(function(f){if(true){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.p5 = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
module.exports={
    "project": {
        "name": "p5",
        "description": "[![Build Status](https://travis-ci.org/processing/p5.js.svg?branch=master)](https://travis-ci.org/processing/p5.js) [![npm version](https://badge.fury.io/js/p5.svg)](https://www.npmjs.com/package/p5)",
        "version": "0.6.0",
        "url": "https://github.com/processing/p5.js#readme"
    },
    "files": {
        "src/color/color_conversion.js": {
            "name": "src/color/color_conversion.js",
            "modules": {
                "Color Conversion": 1
            },
            "classes": {},
            "fors": {
                "p5": 1
            },
            "namespaces": {}
        },
        "src/color/creating_reading.js": {
            "name": "src/color/creating_reading.js",
            "modules": {
                "Creating & Reading": 1
            },
            "classes": {},
            "fors": {
                "p5": 1
            },
            "namespaces": {}
        },
        "src/color/p5.Color.js": {
            "name": "src/color/p5.Color.js",
            "modules": {},
            "classes": {
                "p5.Color": 1
            },
            "fors": {
                "p5": 1
            },
            "namespaces": {}
        },
        "src/color/setting.js": {
            "name": "src/color/setting.js",
            "modules": {
                "Setting": 1
            },
            "classes": {},
            "fors": {
                "p5": 1
            },
            "namespaces": {}
        },
        "src/core/2d_primitives.js": {
            "name": "src/core/2d_primitives.js",
            "modules": {
                "2D Primitives": 1
            },
            "classes": {},
            "fors": {
                "p5": 1
            },
            "namespaces": {}
        },
        "src/core/attributes.js": {
            "name": "src/core/attributes.js",
            "modules": {
                "Attributes": 1
            },
            "classes": {},
            "fors": {
                "p5": 1
            },
            "namespaces": {}
        },
        "src/core/canvas.js": {
            "name": "src/core/canvas.js",
            "modules": {},
            "classes": {},
            "fors": {},
            "namespaces": {}
        },
        "src/core/constants.js": {
            "name": "src/core/constants.js",
            "modules": {
                "Constants": 1
            },
            "classes": {},
            "fors": {
                "p5": 1
            },
            "namespaces": {}
        },
        "src/core/core.js": {
            "name": "src/core/core.js",
            "modules": {
                "Structure": 1
            },
            "classes": {
                "p5": 1
            },
            "fors": {
                "p5": 1
            },
            "namespaces": {}
        },
        "src/core/curves.js": {
            "name": "src/core/curves.js",
            "modules": {
                "Curves": 1
            },
            "classes": {},
            "fors": {
                "p5": 1
            },
            "namespaces": {}
        },
        "src/core/environment.js": {
            "name": "src/core/environment.js",
            "modules": {
                "Environment": 1
            },
            "classes": {},
            "fors": {
                "p5": 1
            },
            "namespaces": {}
        },
        "src/core/error_helpers.js": {
            "name": "src/core/error_helpers.js",
            "modules": {},
            "classes": {},
            "fors": {
                "p5": 1
            },
            "namespaces": {}
        },
        "src/core/init.js": {
            "name": "src/core/init.js",
            "modules": {},
            "classes": {},
            "fors": {},
            "namespaces": {}
        },
        "src/core/p5.Element.js": {
            "name": "src/core/p5.Element.js",
            "modules": {
                "DOM": 1
            },
            "classes": {
                "p5.Element": 1
            },
            "fors": {
                "p5.Element": 1
            },
            "namespaces": {}
        },
        "src/core/p5.Graphics.js": {
            "name": "src/core/p5.Graphics.js",
            "modules": {
                "Rendering": 1
            },
            "classes": {
                "p5.Graphics": 1
            },
            "fors": {
                "p5": 1
            },
            "namespaces": {}
        },
        "src/core/p5.Renderer.js": {
            "name": "src/core/p5.Renderer.js",
            "modules": {},
            "classes": {
                "p5.Renderer": 1
            },
            "fors": {
                "p5": 1
            },
            "namespaces": {}
        },
        "src/core/p5.Renderer2D.js": {
            "name": "src/core/p5.Renderer2D.js",
            "modules": {},
            "classes": {},
            "fors": {},
            "namespaces": {}
        },
        "src/core/rendering.js": {
            "name": "src/core/rendering.js",
            "modules": {},
            "classes": {},
            "fors": {
                "p5": 1
            },
            "namespaces": {}
        },
        "src/core/shim.js": {
            "name": "src/core/shim.js",
            "modules": {},
            "classes": {},
            "fors": {},
            "namespaces": {}
        },
        "src/core/structure.js": {
            "name": "src/core/structure.js",
            "modules": {},
            "classes": {},
            "fors": {
                "p5": 1
            },
            "namespaces": {}
        },
        "src/core/transform.js": {
            "name": "src/core/transform.js",
            "modules": {
                "Transform": 1
            },
            "classes": {},
            "fors": {
                "p5": 1
            },
            "namespaces": {}
        },
        "src/core/vertex.js": {
            "name": "src/core/vertex.js",
            "modules": {
                "Vertex": 1
            },
            "classes": {},
            "fors": {
                "p5": 1
            },
            "namespaces": {}
        },
        "src/data/p5.TypedDict.js": {
            "name": "src/data/p5.TypedDict.js",
            "modules": {
                "Dictionary": 1
            },
            "classes": {
                "p5.TypedDict": 1,
                "p5.StringDict": 1,
                "p5.NumberDict": 1
            },
            "fors": {
                "p5.TypedDict": 1,
                "p5": 1
            },
            "namespaces": {}
        },
        "src/events/acceleration.js": {
            "name": "src/events/acceleration.js",
            "modules": {
                "Acceleration": 1
            },
            "classes": {},
            "fors": {
                "p5": 1
            },
            "namespaces": {}
        },
        "src/events/keyboard.js": {
            "name": "src/events/keyboard.js",
            "modules": {
                "Keyboard": 1
            },
            "classes": {},
            "fors": {
                "p5": 1
            },
            "namespaces": {}
        },
        "src/events/mouse.js": {
            "name": "src/events/mouse.js",
            "modules": {
                "Mouse": 1
            },
            "classes": {},
            "fors": {
                "p5": 1
            },
            "namespaces": {}
        },
        "src/events/touch.js": {
            "name": "src/events/touch.js",
            "modules": {
                "Touch": 1
            },
            "classes": {},
            "fors": {
                "p5": 1
            },
            "namespaces": {}
        },
        "src/image/filters.js": {
            "name": "src/image/filters.js",
            "modules": {},
            "classes": {},
            "fors": {},
            "namespaces": {}
        },
        "src/image/image.js": {
            "name": "src/image/image.js",
            "modules": {
                "Image": 1
            },
            "classes": {},
            "fors": {
                "p5": 1
            },
            "namespaces": {}
        },
        "src/image/loading_displaying.js": {
            "name": "src/image/loading_displaying.js",
            "modules": {
                "Loading & Displaying": 1
            },
            "classes": {},
            "fors": {
                "p5": 1
            },
            "namespaces": {}
        },
        "src/image/p5.Image.js": {
            "name": "src/image/p5.Image.js",
            "modules": {},
            "classes": {
                "p5.Image": 1
            },
            "fors": {},
            "namespaces": {}
        },
        "src/image/pixels.js": {
            "name": "src/image/pixels.js",
            "modules": {
                "Pixels": 1
            },
            "classes": {},
            "fors": {
                "p5": 1
            },
            "namespaces": {}
        },
        "src/io/files.js": {
            "name": "src/io/files.js",
            "modules": {
                "Input": 1,
                "Output": 1
            },
            "classes": {
                "p5.PrintWriter": 1
            },
            "fors": {
                "p5": 1
            },
            "namespaces": {}
        },
        "src/io/p5.Table.js": {
            "name": "src/io/p5.Table.js",
            "modules": {
                "Table": 1
            },
            "classes": {
                "p5.Table": 1
            },
            "fors": {},
            "namespaces": {}
        },
        "src/io/p5.TableRow.js": {
            "name": "src/io/p5.TableRow.js",
            "modules": {},
            "classes": {
                "p5.TableRow": 1
            },
            "fors": {},
            "namespaces": {}
        },
        "src/io/p5.XML.js": {
            "name": "src/io/p5.XML.js",
            "modules": {
                "XML": 1
            },
            "classes": {
                "p5.XML": 1
            },
            "fors": {},
            "namespaces": {}
        },
        "src/math/calculation.js": {
            "name": "src/math/calculation.js",
            "modules": {
                "Calculation": 1
            },
            "classes": {},
            "fors": {
                "p5": 1
            },
            "namespaces": {}
        },
        "src/math/math.js": {
            "name": "src/math/math.js",
            "modules": {
                "Math": 1
            },
            "classes": {},
            "fors": {
                "p5": 1
            },
            "namespaces": {}
        },
        "src/math/noise.js": {
            "name": "src/math/noise.js",
            "modules": {
                "Noise": 1
            },
            "classes": {},
            "fors": {
                "p5": 1
            },
            "namespaces": {}
        },
        "src/math/p5.Vector.js": {
            "name": "src/math/p5.Vector.js",
            "modules": {},
            "classes": {
                "p5.Vector": 1
            },
            "fors": {},
            "namespaces": {}
        },
        "src/math/random.js": {
            "name": "src/math/random.js",
            "modules": {
                "Random": 1
            },
            "classes": {},
            "fors": {
                "p5": 1
            },
            "namespaces": {}
        },
        "src/math/trigonometry.js": {
            "name": "src/math/trigonometry.js",
            "modules": {
                "Trigonometry": 1
            },
            "classes": {},
            "fors": {
                "p5": 1
            },
            "namespaces": {}
        },
        "src/typography/attributes.js": {
            "name": "src/typography/attributes.js",
            "modules": {},
            "classes": {},
            "fors": {
                "p5": 1
            },
            "namespaces": {}
        },
        "src/typography/loading_displaying.js": {
            "name": "src/typography/loading_displaying.js",
            "modules": {},
            "classes": {},
            "fors": {
                "p5": 1
            },
            "namespaces": {}
        },
        "src/typography/p5.Font.js": {
            "name": "src/typography/p5.Font.js",
            "modules": {
                "Font": 1
            },
            "classes": {
                "p5.Font": 1
            },
            "fors": {},
            "namespaces": {}
        },
        "src/utilities/array_functions.js": {
            "name": "src/utilities/array_functions.js",
            "modules": {
                "Array Functions": 1
            },
            "classes": {},
            "fors": {
                "p5": 1
            },
            "namespaces": {}
        },
        "src/utilities/conversion.js": {
            "name": "src/utilities/conversion.js",
            "modules": {
                "Conversion": 1
            },
            "classes": {},
            "fors": {
                "p5": 1
            },
            "namespaces": {}
        },
        "src/utilities/string_functions.js": {
            "name": "src/utilities/string_functions.js",
            "modules": {
                "String Functions": 1
            },
            "classes": {},
            "fors": {
                "p5": 1
            },
            "namespaces": {}
        },
        "src/utilities/time_date.js": {
            "name": "src/utilities/time_date.js",
            "modules": {
                "Time & Date": 1
            },
            "classes": {},
            "fors": {
                "p5": 1
            },
            "namespaces": {}
        },
        "src/webgl/camera.js": {
            "name": "src/webgl/camera.js",
            "modules": {
                "Camera": 1
            },
            "classes": {},
            "fors": {
                "p5": 1
            },
            "namespaces": {}
        },
        "src/webgl/interaction.js": {
            "name": "src/webgl/interaction.js",
            "modules": {},
            "classes": {},
            "fors": {
                "p5": 1
            },
            "namespaces": {}
        },
        "src/webgl/light.js": {
            "name": "src/webgl/light.js",
            "modules": {
                "Lights": 1
            },
            "classes": {},
            "fors": {
                "p5": 1
            },
            "namespaces": {}
        },
        "src/webgl/loading.js": {
            "name": "src/webgl/loading.js",
            "modules": {
                "3D Models": 1
            },
            "classes": {},
            "fors": {
                "p5": 1
            },
            "namespaces": {}
        },
        "src/webgl/material.js": {
            "name": "src/webgl/material.js",
            "modules": {
                "Material": 1
            },
            "classes": {},
            "fors": {
                "p5": 1
            },
            "namespaces": {}
        },
        "src/webgl/p5.Geometry.js": {
            "name": "src/webgl/p5.Geometry.js",
            "modules": {},
            "classes": {
                "p5.Geometry": 1
            },
            "fors": {},
            "namespaces": {}
        },
        "src/webgl/p5.Matrix.js": {
            "name": "src/webgl/p5.Matrix.js",
            "modules": {},
            "classes": {
                "p5.Matrix": 1
            },
            "fors": {},
            "namespaces": {}
        },
        "src/webgl/p5.RendererGL.Immediate.js": {
            "name": "src/webgl/p5.RendererGL.Immediate.js",
            "modules": {},
            "classes": {},
            "fors": {},
            "namespaces": {}
        },
        "src/webgl/p5.RendererGL.Retained.js": {
            "name": "src/webgl/p5.RendererGL.Retained.js",
            "modules": {},
            "classes": {},
            "fors": {},
            "namespaces": {}
        },
        "src/webgl/p5.RendererGL.js": {
            "name": "src/webgl/p5.RendererGL.js",
            "modules": {},
            "classes": {
                "p5.RendererGL": 1
            },
            "fors": {
                "p5": 1
            },
            "namespaces": {}
        },
        "src/webgl/p5.Shader.js": {
            "name": "src/webgl/p5.Shader.js",
            "modules": {
                "Shaders": 1
            },
            "classes": {
                "p5.Shader": 1
            },
            "fors": {
                "p5": 1
            },
            "namespaces": {}
        },
        "src/webgl/p5.Texture.js": {
            "name": "src/webgl/p5.Texture.js",
            "modules": {},
            "classes": {
                "p5.Texture": 1
            },
            "fors": {
                "p5": 1
            },
            "namespaces": {}
        },
        "src/webgl/primitives.js": {
            "name": "src/webgl/primitives.js",
            "modules": {
                "3D Primitives": 1
            },
            "classes": {},
            "fors": {
                "p5": 1
            },
            "namespaces": {}
        },
        "lib/addons/p5.dom.js": {
            "name": "lib/addons/p5.dom.js",
            "modules": {
                "p5.dom": 1
            },
            "classes": {
                "p5.MediaElement": 1,
                "p5.File": 1
            },
            "fors": {
                "p5.dom": 1,
                "p5.Element": 1
            },
            "namespaces": {}
        },
        "lib/addons/p5.sound.js": {
            "name": "lib/addons/p5.sound.js",
            "modules": {
                "p5.sound": 1
            },
            "classes": {
                "p5.SoundFile": 1,
                "p5.Amplitude": 1,
                "p5.FFT": 1,
                "p5.Signal": 1,
                "p5.Oscillator": 1,
                "p5.SinOsc": 1,
                "p5.TriOsc": 1,
                "p5.SawOsc": 1,
                "p5.SqrOsc": 1,
                "p5.Env": 1,
                "p5.Pulse": 1,
                "p5.Noise": 1,
                "p5.AudioIn": 1,
                "p5.Effect": 1,
                "p5.Filter": 1,
                "p5.LowPass": 1,
                "p5.HighPass": 1,
                "p5.BandPass": 1,
                "p5.EQ": 1,
                "p5.Panner3D": 1,
                "p5.Delay": 1,
                "p5.Reverb": 1,
                "p5.Convolver": 1,
                "p5.Phrase": 1,
                "p5.Part": 1,
                "p5.Score": 1,
                "p5.SoundLoop": 1,
                "p5.Compressor": 1,
                "p5.SoundRecorder": 1,
                "p5.PeakDetect": 1,
                "p5.Gain": 1,
                "p5.AudioVoice": 1,
                "p5.MonoSynth": 1,
                "p5.PolySynth": 1,
                "p5.Distortion": 1
            },
            "fors": {
                "p5.sound": 1,
                "p5": 1
            },
            "namespaces": {}
        },
        "lib/addons/p5.sound.min.js": {
            "name": "lib/addons/p5.sound.min.js",
            "modules": {},
            "classes": {},
            "fors": {},
            "namespaces": {}
        }
    },
    "modules": {
        "Conversion": {
            "name": "Conversion",
            "submodules": {
                "Color Conversion": 1
            },
            "elements": {},
            "classes": {},
            "fors": {
                "p5": 1
            },
            "namespaces": {},
            "module": "Data",
            "file": "src/utilities/conversion.js",
            "line": 1,
            "requires": [
                "core"
            ]
        },
        "Color Conversion": {
            "name": "Color Conversion",
            "submodules": {},
            "elements": {},
            "classes": {},
            "fors": {
                "p5": 1
            },
            "is_submodule": 1,
            "namespaces": {},
            "module": "Conversion",
            "namespace": "",
            "file": "src/color/color_conversion.js",
            "line": 1,
            "requires": [
                "core"
            ]
        },
        "Color": {
            "name": "Color",
            "submodules": {
                "Creating & Reading": 1,
                "Setting": 1
            },
            "elements": {},
            "classes": {
                "p5.Color": 1
            },
            "fors": {
                "p5": 1
            },
            "namespaces": {},
            "file": "src/color/p5.Color.js",
            "line": 16
        },
        "Creating & Reading": {
            "name": "Creating & Reading",
            "submodules": {},
            "elements": {},
            "classes": {
                "p5.Color": 1
            },
            "fors": {
                "p5": 1
            },
            "is_submodule": 1,
            "namespaces": {},
            "module": "Color",
            "namespace": "",
            "file": "src/color/p5.Color.js",
            "line": 16,
            "requires": [
                "core",
                "constants"
            ],
            "description": "<p>Each color stores the color mode and level maxes that applied at the\ntime of its construction. These are used to interpret the input arguments\n(at construction and later for that instance of color) and to format the\noutput e.g. when saturation() is requested.</p>\n<p>Internally we store an array representing the ideal RGBA values in floating\npoint form, normalized from 0 to 1. From this we calculate the closest\nscreen color (RGBA levels from 0 to 255) and expose this to the renderer.</p>\n<p>We also cache normalized, floating point components of the color in various\nrepresentations as they are calculated. This is done to prevent repeating a\nconversion that has already been performed.</p>\n"
        },
        "Setting": {
            "name": "Setting",
            "submodules": {},
            "elements": {},
            "classes": {},
            "fors": {
                "p5": 1
            },
            "is_submodule": 1,
            "namespaces": {},
            "module": "Color",
            "namespace": "",
            "file": "src/color/setting.js",
            "line": 1,
            "requires": [
                "core",
                "constants"
            ]
        },
        "Shape": {
            "name": "Shape",
            "submodules": {
                "2D Primitives": 1,
                "Curves": 1,
                "Vertex": 1,
                "3D Models": 1,
                "3D Primitives": 1
            },
            "elements": {},
            "classes": {},
            "fors": {
                "p5": 1
            },
            "namespaces": {}
        },
        "2D Primitives": {
            "name": "2D Primitives",
            "submodules": {},
            "elements": {},
            "classes": {},
            "fors": {
                "p5": 1
            },
            "is_submodule": 1,
            "namespaces": {},
            "module": "Shape",
            "namespace": "",
            "file": "src/core/2d_primitives.js",
            "line": 1,
            "requires": [
                "core",
                "constants"
            ]
        },
        "Attributes": {
            "name": "Attributes",
            "submodules": {},
            "elements": {},
            "classes": {},
            "fors": {
                "p5": 1
            },
            "is_submodule": 1,
            "namespaces": {},
            "module": "Typography",
            "namespace": "",
            "file": "src/core/attributes.js",
            "line": 1,
            "requires": [
                "core",
                "constants"
            ]
        },
        "Constants": {
            "name": "Constants",
            "submodules": {},
            "elements": {},
            "classes": {},
            "fors": {
                "p5": 1
            },
            "namespaces": {},
            "module": "Constants",
            "file": "src/core/constants.js",
            "line": 1
        },
        "Structure": {
            "name": "Structure",
            "submodules": {},
            "elements": {},
            "classes": {},
            "fors": {
                "p5": 1
            },
            "namespaces": {},
            "module": "IO",
            "file": "src/core/core.js",
            "line": 1,
            "requires": [
                "constants"
            ]
        },
        "Curves": {
            "name": "Curves",
            "submodules": {},
            "elements": {},
            "classes": {},
            "fors": {
                "p5": 1
            },
            "is_submodule": 1,
            "namespaces": {},
            "module": "Shape",
            "namespace": "",
            "file": "src/core/curves.js",
            "line": 1,
            "requires": [
                "core"
            ]
        },
        "Environment": {
            "name": "Environment",
            "submodules": {},
            "elements": {},
            "classes": {},
            "fors": {
                "p5": 1
            },
            "namespaces": {},
            "module": "Environment",
            "file": "src/core/environment.js",
            "line": 1,
            "requires": [
                "core",
                "constants"
            ]
        },
        "DOM": {
            "name": "DOM",
            "submodules": {},
            "elements": {},
            "classes": {
                "p5.Element": 1
            },
            "fors": {
                "p5.Element": 1
            },
            "namespaces": {},
            "module": "DOM",
            "file": "src/core/p5.Element.js",
            "line": 11,
            "description": "<p>Base class for all elements added to a sketch, including canvas,\ngraphics buffers, and other HTML elements. Methods in blue are\nincluded in the core functionality, methods in brown are added\nwith the <a href=\"http://p5js.org/reference/#/libraries/p5.dom\">p5.dom\nlibrary</a>.\nIt is not called directly, but p5.Element\nobjects are created by calling createCanvas, createGraphics,\nor in the p5.dom library, createDiv, createImg, createInput, etc.</p>\n"
        },
        "Rendering": {
            "name": "Rendering",
            "submodules": {
                "undefined": 1
            },
            "elements": {},
            "classes": {
                "p5.RendererGL": 1,
                "p5.Graphics": 1,
                "p5.Renderer": 1
            },
            "fors": {
                "p5": 1
            },
            "namespaces": {},
            "module": "Rendering",
            "file": "src/webgl/p5.RendererGL.js",
            "line": 438,
            "description": "<p>Thin wrapper around a renderer, to be used for creating a\ngraphics buffer object. Use this class if you need\nto draw into an off-screen graphics buffer. The two parameters define the\nwidth and height in pixels. The fields and methods for this class are\nextensive, but mirror the normal drawing API for p5.</p>\n"
        },
        "Transform": {
            "name": "Transform",
            "submodules": {},
            "elements": {},
            "classes": {},
            "fors": {
                "p5": 1
            },
            "namespaces": {},
            "module": "Transform",
            "file": "src/core/transform.js",
            "line": 1,
            "requires": [
                "core",
                "constants"
            ]
        },
        "Vertex": {
            "name": "Vertex",
            "submodules": {},
            "elements": {},
            "classes": {},
            "fors": {
                "p5": 1
            },
            "is_submodule": 1,
            "namespaces": {},
            "module": "Shape",
            "namespace": "",
            "file": "src/core/vertex.js",
            "line": 1,
            "requires": [
                "core",
                "constants"
            ]
        },
        "Data": {
            "name": "Data",
            "submodules": {
                "Dictionary": 1,
                "Array Functions": 1,
                "String Functions": 1
            },
            "elements": {},
            "classes": {
                "p5.TypedDict": 1,
                "p5.StringDict": 1,
                "p5.NumberDict": 1
            },
            "fors": {
                "p5.TypedDict": 1,
                "p5": 1
            },
            "namespaces": {},
            "file": "src/data/p5.TypedDict.js",
            "line": 397
        },
        "Dictionary": {
            "name": "Dictionary",
            "submodules": {},
            "elements": {},
            "classes": {
                "p5.TypedDict": 1,
                "p5.StringDict": 1,
                "p5.NumberDict": 1
            },
            "fors": {
                "p5.TypedDict": 1,
                "p5": 1
            },
            "is_submodule": 1,
            "namespaces": {},
            "module": "Data",
            "namespace": "",
            "file": "src/data/p5.TypedDict.js",
            "line": 397,
            "requires": [
                "core\n\nThis module defines the p5 methods for the p5 Dictionary classes\nthese classes StringDict and NumberDict are for storing and working\nwith key",
                "value pairs"
            ],
            "description": "<p>Base class for all p5.Dictionary types. More specifically\n typed Dictionary objects inherit from this</p>\n"
        },
        "Events": {
            "name": "Events",
            "submodules": {
                "Acceleration": 1,
                "Keyboard": 1,
                "Mouse": 1,
                "Touch": 1
            },
            "elements": {},
            "classes": {},
            "fors": {
                "p5": 1
            },
            "namespaces": {}
        },
        "Acceleration": {
            "name": "Acceleration",
            "submodules": {},
            "elements": {},
            "classes": {},
            "fors": {
                "p5": 1
            },
            "is_submodule": 1,
            "namespaces": {},
            "module": "Events",
            "namespace": "",
            "file": "src/events/acceleration.js",
            "line": 1,
            "requires": [
                "core"
            ]
        },
        "Keyboard": {
            "name": "Keyboard",
            "submodules": {},
            "elements": {},
            "classes": {},
            "fors": {
                "p5": 1
            },
            "is_submodule": 1,
            "namespaces": {},
            "module": "Events",
            "namespace": "",
            "file": "src/events/keyboard.js",
            "line": 1,
            "requires": [
                "core"
            ]
        },
        "Mouse": {
            "name": "Mouse",
            "submodules": {},
            "elements": {},
            "classes": {},
            "fors": {
                "p5": 1
            },
            "is_submodule": 1,
            "namespaces": {},
            "module": "Events",
            "namespace": "",
            "file": "src/events/mouse.js",
            "line": 1,
            "requires": [
                "core",
                "constants"
            ]
        },
        "Touch": {
            "name": "Touch",
            "submodules": {},
            "elements": {},
            "classes": {},
            "fors": {
                "p5": 1
            },
            "is_submodule": 1,
            "namespaces": {},
            "module": "Events",
            "namespace": "",
            "file": "src/events/touch.js",
            "line": 1,
            "requires": [
                "core"
            ]
        },
        "Image": {
            "name": "Image",
            "submodules": {
                "Pixels": 1
            },
            "elements": {},
            "classes": {
                "p5.Image": 1
            },
            "fors": {
                "p5": 1
            },
            "namespaces": {},
            "module": "Image",
            "file": "src/image/p5.Image.js",
            "line": 23,
            "requires": [
                "core"
            ],
            "description": "<p>Creates a new p5.Image. A p5.Image is a canvas backed representation of an\nimage.\n<br><br>\np5 can display .gif, .jpg and .png images. Images may be displayed\nin 2D and 3D space. Before an image is used, it must be loaded with the\nloadImage() function. The p5.Image class contains fields for the width and\nheight of the image, as well as an array called pixels[] that contains the\nvalues for every pixel in the image.\n<br><br>\nThe methods described below allow easy access to the image&#39;s pixels and\nalpha channel and simplify the process of compositing.\n<br><br>\nBefore using the pixels[] array, be sure to use the loadPixels() method on\nthe image to make sure that the pixel data is properly loaded.</p>\n"
        },
        "Loading & Displaying": {
            "name": "Loading & Displaying",
            "submodules": {},
            "elements": {},
            "classes": {},
            "fors": {
                "p5": 1
            },
            "is_submodule": 1,
            "namespaces": {},
            "module": "Typography",
            "namespace": "",
            "file": "src/image/loading_displaying.js",
            "line": 1,
            "requires": [
                "core"
            ]
        },
        "Pixels": {
            "name": "Pixels",
            "submodules": {},
            "elements": {},
            "classes": {},
            "fors": {
                "p5": 1
            },
            "is_submodule": 1,
            "namespaces": {},
            "module": "Image",
            "namespace": "",
            "file": "src/image/pixels.js",
            "line": 1,
            "requires": [
                "core"
            ]
        },
        "IO": {
            "name": "IO",
            "submodules": {
                "Structure": 1,
                "Input": 1,
                "Output": 1,
                "Table": 1,
                "XML": 1,
                "Time & Date": 1
            },
            "elements": {},
            "classes": {
                "p5": 1,
                "p5.PrintWriter": 1,
                "p5.Table": 1,
                "p5.TableRow": 1,
                "p5.XML": 1
            },
            "fors": {
                "p5": 1
            },
            "namespaces": {},
            "file": "src/io/p5.XML.js",
            "line": 11
        },
        "Input": {
            "name": "Input",
            "submodules": {},
            "elements": {},
            "classes": {},
            "fors": {
                "p5": 1
            },
            "is_submodule": 1,
            "namespaces": {},
            "module": "IO",
            "namespace": "",
            "file": "src/io/files.js",
            "line": 1,
            "requires": [
                "core"
            ]
        },
        "Output": {
            "name": "Output",
            "submodules": {},
            "elements": {},
            "classes": {
                "p5": 1,
                "p5.PrintWriter": 1
            },
            "fors": {
                "p5": 1
            },
            "is_submodule": 1,
            "namespaces": {},
            "module": "IO",
            "namespace": "",
            "file": "src/io/files.js",
            "line": 1102,
            "description": "<p>This is the p5 instance constructor.</p>\n<p>A p5 instance holds all the properties and methods related to\na p5 sketch.  It expects an incoming sketch closure and it can also\ntake an optional node parameter for attaching the generated p5 canvas\nto a node.  The sketch closure takes the newly created p5 instance as\nits sole argument and may optionally set preload(), setup(), and/or\ndraw() properties on it for running a sketch.</p>\n<p>A p5 sketch can run in &quot;global&quot; or &quot;instance&quot; mode:\n&quot;global&quot;   - all properties and methods are attached to the window\n&quot;instance&quot; - all properties and methods are bound to this p5 object</p>\n"
        },
        "Table": {
            "name": "Table",
            "submodules": {},
            "elements": {},
            "classes": {
                "p5.Table": 1,
                "p5.TableRow": 1
            },
            "fors": {},
            "is_submodule": 1,
            "namespaces": {},
            "module": "IO",
            "namespace": "",
            "file": "src/io/p5.TableRow.js",
            "line": 11,
            "requires": [
                "core"
            ],
            "description": "<p>Table objects store data with multiple rows and columns, much\nlike in a traditional spreadsheet. Tables can be generated from\nscratch, dynamically, or using data from an existing file.</p>\n"
        },
        "XML": {
            "name": "XML",
            "submodules": {},
            "elements": {},
            "classes": {
                "p5.XML": 1
            },
            "fors": {},
            "is_submodule": 1,
            "namespaces": {},
            "module": "IO",
            "namespace": "",
            "file": "src/io/p5.XML.js",
            "line": 11,
            "requires": [
                "core"
            ],
            "description": "<p>XML is a representation of an XML object, able to parse XML code. Use\nloadXML() to load external XML files and create XML objects.</p>\n"
        },
        "Math": {
            "name": "Math",
            "submodules": {
                "Calculation": 1,
                "Noise": 1,
                "Random": 1,
                "Trigonometry": 1
            },
            "elements": {},
            "classes": {
                "p5.Vector": 1
            },
            "fors": {
                "p5": 1
            },
            "namespaces": {},
            "module": "Math",
            "file": "src/math/p5.Vector.js",
            "line": 13,
            "requires": [
                "core"
            ],
            "description": "<p>A class to describe a two or three dimensional vector, specifically\na Euclidean (also known as geometric) vector. A vector is an entity\nthat has both magnitude and direction. The datatype, however, stores\nthe components of the vector (x, y for 2D, and x, y, z for 3D). The magnitude\nand direction can be accessed via the methods mag() and heading().\n<br><br>\nIn many of the p5.js examples, you will see p5.Vector used to describe a\nposition, velocity, or acceleration. For example, if you consider a rectangle\nmoving across the screen, at any given instant it has a position (a vector\nthat points from the origin to its location), a velocity (the rate at which\nthe object&#39;s position changes per time unit, expressed as a vector), and\nacceleration (the rate at which the object&#39;s velocity changes per time\nunit, expressed as a vector).\n<br><br>\nSince vectors represent groupings of values, we cannot simply use\ntraditional addition/multiplication/etc. Instead, we&#39;ll need to do some\n&quot;vector&quot; math, which is made easy by the methods inside the p5.Vector class.</p>\n"
        },
        "Calculation": {
            "name": "Calculation",
            "submodules": {},
            "elements": {},
            "classes": {},
            "fors": {
                "p5": 1
            },
            "is_submodule": 1,
            "namespaces": {},
            "module": "Math",
            "namespace": "",
            "file": "src/math/calculation.js",
            "line": 1,
            "requires": [
                "core"
            ]
        },
        "Noise": {
            "name": "Noise",
            "submodules": {},
            "elements": {},
            "classes": {},
            "fors": {
                "p5": 1
            },
            "is_submodule": 1,
            "namespaces": {},
            "module": "Math",
            "namespace": "",
            "file": "src/math/noise.js",
            "line": 14,
            "requires": [
                "core"
            ]
        },
        "Random": {
            "name": "Random",
            "submodules": {},
            "elements": {},
            "classes": {},
            "fors": {
                "p5": 1
            },
            "is_submodule": 1,
            "namespaces": {},
            "module": "Math",
            "namespace": "",
            "file": "src/math/random.js",
            "line": 1,
            "requires": [
                "core"
            ]
        },
        "Trigonometry": {
            "name": "Trigonometry",
            "submodules": {},
            "elements": {},
            "classes": {},
            "fors": {
                "p5": 1
            },
            "is_submodule": 1,
            "namespaces": {},
            "module": "Math",
            "namespace": "",
            "file": "src/math/trigonometry.js",
            "line": 1,
            "requires": [
                "core",
                "polargeometry",
                "constants"
            ]
        },
        "Typography": {
            "name": "Typography",
            "submodules": {
                "Attributes": 1,
                "Loading & Displaying": 1,
                "Font": 1
            },
            "elements": {},
            "classes": {
                "p5.Font": 1
            },
            "fors": {
                "p5": 1
            },
            "namespaces": {},
            "file": "src/typography/p5.Font.js",
            "line": 21
        },
        "Font": {
            "name": "Font",
            "submodules": {},
            "elements": {},
            "classes": {
                "p5.Font": 1
            },
            "fors": {},
            "is_submodule": 1,
            "namespaces": {},
            "module": "Typography",
            "namespace": "",
            "file": "src/typography/p5.Font.js",
            "line": 21,
            "description": "<p>This module defines the p5.Font class and functions for\ndrawing text to the display canvas.</p>\n",
            "requires": [
                "core",
                "constants"
            ]
        },
        "Array Functions": {
            "name": "Array Functions",
            "submodules": {},
            "elements": {},
            "classes": {},
            "fors": {
                "p5": 1
            },
            "is_submodule": 1,
            "namespaces": {},
            "module": "Data",
            "namespace": "",
            "file": "src/utilities/array_functions.js",
            "line": 1,
            "requires": [
                "core"
            ]
        },
        "String Functions": {
            "name": "String Functions",
            "submodules": {},
            "elements": {},
            "classes": {},
            "fors": {
                "p5": 1
            },
            "is_submodule": 1,
            "namespaces": {},
            "module": "Data",
            "namespace": "",
            "file": "src/utilities/string_functions.js",
            "line": 1,
            "requires": [
                "core"
            ]
        },
        "Time & Date": {
            "name": "Time & Date",
            "submodules": {},
            "elements": {},
            "classes": {},
            "fors": {
                "p5": 1
            },
            "is_submodule": 1,
            "namespaces": {},
            "module": "IO",
            "namespace": "",
            "file": "src/utilities/time_date.js",
            "line": 1,
            "requires": [
                "core"
            ]
        },
        "Lights, Camera": {
            "name": "Lights, Camera",
            "submodules": {
                "Camera": 1,
                "Lights": 1,
                "Material": 1,
                "Shaders": 1
            },
            "elements": {},
            "classes": {
                "p5.Geometry": 1,
                "p5.Matrix": 1,
                "p5.Shader": 1,
                "p5.Texture": 1
            },
            "fors": {
                "p5": 1
            },
            "namespaces": {},
            "file": "src/webgl/p5.Texture.js",
            "line": 13
        },
        "Camera": {
            "name": "Camera",
            "submodules": {},
            "elements": {},
            "classes": {},
            "fors": {
                "p5": 1
            },
            "is_submodule": 1,
            "namespaces": {},
            "module": "Lights, Camera",
            "namespace": "",
            "file": "src/webgl/camera.js",
            "line": 1,
            "requires": [
                "core"
            ]
        },
        "Lights": {
            "name": "Lights",
            "submodules": {},
            "elements": {},
            "classes": {},
            "fors": {
                "p5": 1
            },
            "is_submodule": 1,
            "namespaces": {},
            "module": "Lights, Camera",
            "namespace": "",
            "file": "src/webgl/light.js",
            "line": 1,
            "requires": [
                "core"
            ]
        },
        "3D Models": {
            "name": "3D Models",
            "submodules": {},
            "elements": {},
            "classes": {},
            "fors": {
                "p5": 1
            },
            "is_submodule": 1,
            "namespaces": {},
            "module": "Shape",
            "namespace": "",
            "file": "src/webgl/loading.js",
            "line": 1,
            "requires": [
                "core",
                "p5.Geometry"
            ]
        },
        "Material": {
            "name": "Material",
            "submodules": {},
            "elements": {},
            "classes": {
                "p5.Texture": 1
            },
            "fors": {
                "p5": 1
            },
            "is_submodule": 1,
            "namespaces": {},
            "module": "Lights, Camera",
            "namespace": "",
            "file": "src/webgl/p5.Texture.js",
            "line": 13,
            "requires": [
                "core"
            ],
            "description": "<p>This module defines the p5.Texture class</p>\n"
        },
        "Shaders": {
            "name": "Shaders",
            "submodules": {},
            "elements": {},
            "classes": {
                "p5.Shader": 1
            },
            "fors": {
                "p5": 1
            },
            "is_submodule": 1,
            "namespaces": {},
            "module": "Lights, Camera",
            "namespace": "",
            "file": "src/webgl/p5.Shader.js",
            "line": 13,
            "description": "<p>This module defines the p5.Shader class</p>\n",
            "requires": [
                "core"
            ]
        },
        "3D Primitives": {
            "name": "3D Primitives",
            "submodules": {},
            "elements": {},
            "classes": {},
            "fors": {
                "p5": 1
            },
            "is_submodule": 1,
            "namespaces": {},
            "module": "Shape",
            "namespace": "",
            "file": "src/webgl/primitives.js",
            "line": 1,
            "requires": [
                "core",
                "p5.Geometry"
            ]
        },
        "p5.dom": {
            "name": "p5.dom",
            "submodules": {},
            "elements": {},
            "classes": {
                "p5.dom": 1,
                "p5.MediaElement": 1,
                "p5.File": 1
            },
            "fors": {
                "p5.dom": 1,
                "p5.Element": 1
            },
            "namespaces": {},
            "module": "p5.dom",
            "file": "lib/addons/p5.dom.js",
            "line": 2876,
            "description": "<p><p>The web is much more than just canvas and p5.dom makes it easy to interact\nwith other HTML5 objects, including text, hyperlink, image, input, video,\naudio, and webcam.</p></p>\n<p><p>There is a set of creation methods, DOM manipulation methods, and\nan extended p5.Element that supports a range of HTML elements. See the\n<a href='https://github.com/processing/p5.js/wiki/Beyond-the-canvas'>\nbeyond the canvas tutorial</a> for a full overview of how this addon works.</p>\n<p><p>Methods and properties shown in black are part of the p5.js core, items in\nblue are part of the p5.dom library. You will need to include an extra file\nin order to access the blue functions. See the\n<a href='http://p5js.org/libraries/#using-a-library'>using a library</a>\nsection for information on how to include this library. p5.dom comes with\n<a href='http://p5js.org/download'>p5 complete</a> or you can download the single file\n<a href='https://raw.githubusercontent.com/lmccart/p5.js/master/lib/addons/p5.dom.js'>\nhere</a>.</p></p>\n<p><p>See <a href='https://github.com/processing/p5.js/wiki/Beyond-the-canvas'>tutorial: beyond the canvas</a>\nfor more info on how to use this libary.</a></p>\n",
            "tag": "main",
            "itemtype": "main"
        },
        "p5.sound": {
            "name": "p5.sound",
            "submodules": {},
            "elements": {},
            "classes": {
                "p5.sound": 1,
                "p5.SoundFile": 1,
                "p5.Amplitude": 1,
                "p5.FFT": 1,
                "p5.Signal": 1,
                "p5.Oscillator": 1,
                "p5.SinOsc": 1,
                "p5.TriOsc": 1,
                "p5.SawOsc": 1,
                "p5.SqrOsc": 1,
                "p5.Env": 1,
                "p5.Pulse": 1,
                "p5.Noise": 1,
                "p5.AudioIn": 1,
                "p5.Effect": 1,
                "p5.Filter": 1,
                "p5.LowPass": 1,
                "p5.HighPass": 1,
                "p5.BandPass": 1,
                "p5.EQ": 1,
                "p5.Panner3D": 1,
                "p5.Delay": 1,
                "p5.Reverb": 1,
                "p5.Convolver": 1,
                "p5.Phrase": 1,
                "p5.Part": 1,
                "p5.Score": 1,
                "p5.SoundLoop": 1,
                "p5.Compressor": 1,
                "p5.SoundRecorder": 1,
                "p5.PeakDetect": 1,
                "p5.Gain": 1,
                "p5.AudioVoice": 1,
                "p5.MonoSynth": 1,
                "p5.PolySynth": 1,
                "p5.Distortion": 1
            },
            "fors": {
                "p5.sound": 1,
                "p5": 1
            },
            "namespaces": {},
            "module": "p5.sound",
            "file": "lib/addons/p5.sound.js",
            "line": 12243,
            "description": "<p>p5.sound extends p5 with <a href=\"http://caniuse.com/audio-api\"\ntarget=\"_blank\">Web Audio</a> functionality including audio input,\nplayback, analysis and synthesis.\n<br/><br/>\n<a href=\"#/p5.SoundFile\"><b>p5.SoundFile</b></a>: Load and play sound files.<br/>\n<a href=\"#/p5.Amplitude\"><b>p5.Amplitude</b></a>: Get the current volume of a sound.<br/>\n<a href=\"#/p5.AudioIn\"><b>p5.AudioIn</b></a>: Get sound from an input source, typically\n  a computer microphone.<br/>\n<a href=\"#/p5.FFT\"><b>p5.FFT</b></a>: Analyze the frequency of sound. Returns\n  results from the frequency spectrum or time domain (waveform).<br/>\n<a href=\"#/p5.Oscillator\"><b>p5.Oscillator</b></a>: Generate Sine,\n  Triangle, Square and Sawtooth waveforms. Base class of\n  <a href=\"#/p5.Noise\">p5.Noise</a> and <a href=\"#/p5.Pulse\">p5.Pulse</a>.\n  <br/>\n<a href=\"#/p5.Env\"><b>p5.Env</b></a>: An Envelope is a series\n  of fades over time. Often used to control an object&#39;s\n  output gain level as an &quot;ADSR Envelope&quot; (Attack, Decay,\n  Sustain, Release). Can also modulate other parameters.<br/>\n<a href=\"#/p5.Delay\"><b>p5.Delay</b></a>: A delay effect with\n  parameters for feedback, delayTime, and lowpass filter.<br/>\n<a href=\"#/p5.Filter\"><b>p5.Filter</b></a>: Filter the frequency range of a\n  sound.\n<br/>\n<a href=\"#/p5.Reverb\"><b>p5.Reverb</b></a>: Add reverb to a sound by specifying\n  duration and decay. <br/>\n<b><a href=\"#/p5.Convolver\">p5.Convolver</a>:</b> Extends\n<a href=\"#/p5.Reverb\">p5.Reverb</a> to simulate the sound of real\n  physical spaces through convolution.<br/>\n<b><a href=\"#/p5.SoundRecorder\">p5.SoundRecorder</a></b>: Record sound for playback\n  / save the .wav file.\n<b><a href=\"#/p5.Phrase\">p5.Phrase</a></b>, <b><a href=\"#/p5.Part\">p5.Part</a></b> and\n<b><a href=\"#/p5.Score\">p5.Score</a></b>: Compose musical sequences.\n<br/><br/>\np5.sound is on <a href=\"https://github.com/therewasaguy/p5.sound/\">GitHub</a>.\nDownload the latest version\n<a href=\"https://github.com/therewasaguy/p5.sound/blob/master/lib/p5.sound.js\">here</a>.</p>\n",
            "tag": "main",
            "itemtype": "main"
        }
    },
    "classes": {
        "p5": {
            "name": "p5",
            "shortname": "p5",
            "classitems": [],
            "plugins": [],
            "extensions": [],
            "plugin_for": [],
            "extension_for": [],
            "module": "IO",
            "submodule": "Output",
            "namespace": "",
            "file": "src/core/core.js",
            "line": 15,
            "description": "<p>This is the p5 instance constructor.</p>\n<p>A p5 instance holds all the properties and methods related to\na p5 sketch.  It expects an incoming sketch closure and it can also\ntake an optional node parameter for attaching the generated p5 canvas\nto a node.  The sketch closure takes the newly created p5 instance as\nits sole argument and may optionally set preload(), setup(), and/or\ndraw() properties on it for running a sketch.</p>\n<p>A p5 sketch can run in &quot;global&quot; or &quot;instance&quot; mode:\n&quot;global&quot;   - all properties and methods are attached to the window\n&quot;instance&quot; - all properties and methods are bound to this p5 object</p>\n",
            "is_constructor": 1,
            "params": [
                {
                    "name": "sketch",
                    "description": "<p>a closure that can set optional preload(),\n                             setup(), and/or draw() properties on the\n                             given p5 instance</p>\n",
                    "type": "Function"
                },
                {
                    "name": "node",
                    "description": "<p>element to attach canvas to, if a\n                                     boolean is passed in use it as sync</p>\n",
                    "type": "HTMLElement|Boolean",
                    "optional": true
                },
                {
                    "name": "sync",
                    "description": "<p>start synchronously (optional)</p>\n",
                    "type": "Boolean",
                    "optional": true
                }
            ],
            "return": {
                "description": "a p5 instance",
                "type": "P5"
            }
        },
        "p5.Color": {
            "name": "p5.Color",
            "shortname": "p5.Color",
            "classitems": [],
            "plugins": [],
            "extensions": [],
            "plugin_for": [],
            "extension_for": [],
            "module": "Color",
            "submodule": "Creating & Reading",
            "namespace": "",
            "file": "src/color/p5.Color.js",
            "line": 16,
            "description": "<p>Each color stores the color mode and level maxes that applied at the\ntime of its construction. These are used to interpret the input arguments\n(at construction and later for that instance of color) and to format the\noutput e.g. when saturation() is requested.</p>\n<p>Internally we store an array representing the ideal RGBA values in floating\npoint form, normalized from 0 to 1. From this we calculate the closest\nscreen color (RGBA levels from 0 to 255) and expose this to the renderer.</p>\n<p>We also cache normalized, floating point components of the color in various\nrepresentations as they are calculated. This is done to prevent repeating a\nconversion that has already been performed.</p>\n",
            "is_constructor": 1
        },
        "p5.Element": {
            "name": "p5.Element",
            "shortname": "p5.Element",
            "classitems": [],
            "plugins": [],
            "extensions": [],
            "plugin_for": [],
            "extension_for": [],
            "module": "DOM",
            "submodule": "DOM",
            "namespace": "",
            "file": "src/core/p5.Element.js",
            "line": 11,
            "description": "<p>Base class for all elements added to a sketch, including canvas,\ngraphics buffers, and other HTML elements. Methods in blue are\nincluded in the core functionality, methods in brown are added\nwith the <a href=\"http://p5js.org/reference/#/libraries/p5.dom\">p5.dom\nlibrary</a>.\nIt is not called directly, but p5.Element\nobjects are created by calling createCanvas, createGraphics,\nor in the p5.dom library, createDiv, createImg, createInput, etc.</p>\n",
            "is_constructor": 1,
            "params": [
                {
                    "name": "elt",
                    "description": "<p>DOM node that is wrapped</p>\n",
                    "type": "String"
                },
                {
                    "name": "pInst",
                    "description": "<p>pointer to p5 instance</p>\n",
                    "type": "P5",
                    "optional": true
                }
            ]
        },
        "p5.Graphics": {
            "name": "p5.Graphics",
            "shortname": "p5.Graphics",
            "classitems": [],
            "plugins": [],
            "extensions": [],
            "plugin_for": [],
            "extension_for": [],
            "module": "Rendering",
            "submodule": "Rendering",
            "namespace": "",
            "file": "src/core/p5.Graphics.js",
            "line": 12,
            "description": "<p>Thin wrapper around a renderer, to be used for creating a\ngraphics buffer object. Use this class if you need\nto draw into an off-screen graphics buffer. The two parameters define the\nwidth and height in pixels. The fields and methods for this class are\nextensive, but mirror the normal drawing API for p5.</p>\n",
            "is_constructor": 1,
            "extends": "p5.Element",
            "params": [
                {
                    "name": "w",
                    "description": "<p>width</p>\n",
                    "type": "Number"
                },
                {
                    "name": "h",
                    "description": "<p>height</p>\n",
                    "type": "Number"
                },
                {
                    "name": "renderer",
                    "description": "<p>the renderer to use, either P2D or WEBGL</p>\n",
                    "type": "Constant"
                },
                {
                    "name": "pInst",
                    "description": "<p>pointer to p5 instance</p>\n",
                    "type": "P5",
                    "optional": true
                }
            ]
        },
        "p5.Renderer": {
            "name": "p5.Renderer",
            "shortname": "p5.Renderer",
            "classitems": [],
            "plugins": [],
            "extensions": [],
            "plugin_for": [],
            "extension_for": [],
            "module": "Rendering",
            "submodule": "Rendering",
            "namespace": "",
            "file": "src/core/p5.Renderer.js",
            "line": 12,
            "description": "<p>Main graphics and rendering context, as well as the base API\nimplementation for p5.js &quot;core&quot;. To be used as the superclass for\nRenderer2D and Renderer3D classes, respecitvely.</p>\n",
            "is_constructor": 1,
            "extends": "p5.Element",
            "params": [
                {
                    "name": "elt",
                    "description": "<p>DOM node that is wrapped</p>\n",
                    "type": "String"
                },
                {
                    "name": "pInst",
                    "description": "<p>pointer to p5 instance</p>\n",
                    "type": "P5",
                    "optional": true
                },
                {
                    "name": "isMainCanvas",
                    "description": "<p>whether we&#39;re using it as main canvas</p>\n",
                    "type": "Boolean",
                    "optional": true
                }
            ]
        },
        "p5.TypedDict": {
            "name": "p5.TypedDict",
            "shortname": "p5.TypedDict",
            "classitems": [],
            "plugins": [],
            "extensions": [],
            "plugin_for": [],
            "extension_for": [],
            "module": "Data",
            "submodule": "Dictionary",
            "namespace": "",
            "file": "src/data/p5.TypedDict.js",
            "line": 66,
            "description": "<p>Base class for all p5.Dictionary types. More specifically\n typed Dictionary objects inherit from this</p>\n",
            "is_constructor": 1
        },
        "p5.StringDict": {
            "name": "p5.StringDict",
            "shortname": "p5.StringDict",
            "classitems": [],
            "plugins": [],
            "extensions": [],
            "plugin_for": [],
            "extension_for": [],
            "module": "Data",
            "submodule": "Dictionary",
            "namespace": "",
            "file": "src/data/p5.TypedDict.js",
            "line": 376,
            "description": "<p>A  Dictionary class for Strings.</p>\n",
            "is_constructor": 1,
            "extends": "p5.TypedDict"
        },
        "p5.NumberDict": {
            "name": "p5.NumberDict",
            "shortname": "p5.NumberDict",
            "classitems": [],
            "plugins": [],
            "extensions": [],
            "plugin_for": [],
            "extension_for": [],
            "module": "Data",
            "submodule": "Dictionary",
            "namespace": "",
            "file": "src/data/p5.TypedDict.js",
            "line": 397,
            "description": "<p>A simple Dictionary class for Numbers.</p>\n",
            "is_constructor": 1,
            "extends": "p5.TypedDict"
        },
        "p5.Image": {
            "name": "p5.Image",
            "shortname": "p5.Image",
            "classitems": [],
            "plugins": [],
            "extensions": [],
            "plugin_for": [],
            "extension_for": [],
            "module": "Image",
            "submodule": "Image",
            "namespace": "",
            "file": "src/image/p5.Image.js",
            "line": 23,
            "description": "<p>Creates a new p5.Image. A p5.Image is a canvas backed representation of an\nimage.\n<br><br>\np5 can display .gif, .jpg and .png images. Images may be displayed\nin 2D and 3D space. Before an image is used, it must be loaded with the\nloadImage() function. The p5.Image class contains fields for the width and\nheight of the image, as well as an array called pixels[] that contains the\nvalues for every pixel in the image.\n<br><br>\nThe methods described below allow easy access to the image&#39;s pixels and\nalpha channel and simplify the process of compositing.\n<br><br>\nBefore using the pixels[] array, be sure to use the loadPixels() method on\nthe image to make sure that the pixel data is properly loaded.</p>\n",
            "example": [
                "\n<div><code>\nfunction setup() {\n  var img = createImage(100, 100); // same as new p5.Image(100, 100);\n  img.loadPixels();\n  createCanvas(100, 100);\n  background(0);\n\n  // helper for writing color to array\n  function writeColor(image, x, y, red, green, blue, alpha) {\n    var index = (x + y * width) * 4;\n    image.pixels[index] = red;\n    image.pixels[index + 1] = green;\n    image.pixels[index + 2] = blue;\n    image.pixels[index + 3] = alpha;\n  }\n\n  var x, y;\n  // fill with random colors\n  for (y = 0; y < img.height; y++) {\n    for (x = 0; x < img.width; x++) {\n      var red = random(255);\n      var green = random(255);\n      var blue = random(255);\n      var alpha = 255;\n      writeColor(img, x, y, red, green, blue, alpha);\n    }\n  }\n\n  // draw a red line\n  y = 0;\n  for (x = 0; x < img.width; x++) {\n    writeColor(img, x, y, 255, 0, 0, 255);\n  }\n\n  // draw a green line\n  y = img.height - 1;\n  for (x = 0; x < img.width; x++) {\n    writeColor(img, x, y, 0, 255, 0, 255);\n  }\n\n  img.updatePixels();\n  image(img, 0, 0);\n}\n</code></div>"
            ],
            "is_constructor": 1,
            "params": [
                {
                    "name": "width",
                    "description": "",
                    "type": "Number"
                },
                {
                    "name": "height",
                    "description": "",
                    "type": "Number"
                }
            ]
        },
        "p5.PrintWriter": {
            "name": "p5.PrintWriter",
            "shortname": "p5.PrintWriter",
            "classitems": [],
            "plugins": [],
            "extensions": [],
            "plugin_for": [],
            "extension_for": [],
            "module": "IO",
            "submodule": "Output",
            "namespace": "",
            "file": "src/io/files.js",
            "line": 1102,
            "is_constructor": 1,
            "params": [
                {
                    "name": "filename",
                    "description": "",
                    "type": "String"
                },
                {
                    "name": "extension",
                    "description": "",
                    "type": "String",
                    "optional": true
                }
            ]
        },
        "p5.Table": {
            "name": "p5.Table",
            "shortname": "p5.Table",
            "classitems": [],
            "plugins": [],
            "extensions": [],
            "plugin_for": [],
            "extension_for": [],
            "module": "IO",
            "submodule": "Table",
            "namespace": "",
            "file": "src/io/p5.Table.js",
            "line": 35,
            "description": "<p>Table objects store data with multiple rows and columns, much\nlike in a traditional spreadsheet. Tables can be generated from\nscratch, dynamically, or using data from an existing file.</p>\n",
            "is_constructor": 1,
            "params": [
                {
                    "name": "rows",
                    "description": "<p>An array of p5.TableRow objects</p>\n",
                    "type": "p5.TableRow[]",
                    "optional": true
                }
            ]
        },
        "p5.TableRow": {
            "name": "p5.TableRow",
            "shortname": "p5.TableRow",
            "classitems": [],
            "plugins": [],
            "extensions": [],
            "plugin_for": [],
            "extension_for": [],
            "module": "IO",
            "submodule": "Table",
            "namespace": "",
            "file": "src/io/p5.TableRow.js",
            "line": 11,
            "description": "<p>A TableRow object represents a single row of data values,\nstored in columns, from a table.</p>\n<p>A Table Row contains both an ordered array, and an unordered\nJSON object.</p>\n",
            "is_constructor": 1,
            "params": [
                {
                    "name": "str",
                    "description": "<p>optional: populate the row with a\n                            string of values, separated by the\n                            separator</p>\n",
                    "type": "String",
                    "optional": true
                },
                {
                    "name": "separator",
                    "description": "<p>comma separated values (csv) by default</p>\n",
                    "type": "String",
                    "optional": true
                }
            ]
        },
        "p5.XML": {
            "name": "p5.XML",
            "shortname": "p5.XML",
            "classitems": [],
            "plugins": [],
            "extensions": [],
            "plugin_for": [],
            "extension_for": [],
            "module": "IO",
            "submodule": "XML",
            "namespace": "",
            "file": "src/io/p5.XML.js",
            "line": 11,
            "description": "<p>XML is a representation of an XML object, able to parse XML code. Use\nloadXML() to load external XML files and create XML objects.</p>\n",
            "is_constructor": 1,
            "example": [
                "\n<div class='norender'><code>\n// The following short XML file called \"mammals.xml\" is parsed\n// in the code below.\n//\n// <?xml version=\"1.0\"?>\n// &lt;mammals&gt;\n//   &lt;animal id=\"0\" species=\"Capra hircus\">Goat&lt;/animal&gt;\n//   &lt;animal id=\"1\" species=\"Panthera pardus\">Leopard&lt;/animal&gt;\n//   &lt;animal id=\"2\" species=\"Equus zebra\">Zebra&lt;/animal&gt;\n// &lt;/mammals&gt;\n\nvar xml;\n\nfunction preload() {\n  xml = loadXML('assets/mammals.xml');\n}\n\nfunction setup() {\n  var children = xml.getChildren('animal');\n\n  for (var i = 0; i < children.length; i++) {\n    var id = children[i].getNum('id');\n    var coloring = children[i].getString('species');\n    var name = children[i].getContent();\n    print(id + ', ' + coloring + ', ' + name);\n  }\n}\n\n// Sketch prints:\n// 0, Capra hircus, Goat\n// 1, Panthera pardus, Leopard\n// 2, Equus zebra, Zebra\n</code></div>"
            ],
            "alt": "no image displayed"
        },
        "p5.Vector": {
            "name": "p5.Vector",
            "shortname": "p5.Vector",
            "classitems": [],
            "plugins": [],
            "extensions": [],
            "plugin_for": [],
            "extension_for": [],
            "module": "Math",
            "submodule": "Math",
            "namespace": "",
            "file": "src/math/p5.Vector.js",
            "line": 13,
            "description": "<p>A class to describe a two or three dimensional vector, specifically\na Euclidean (also known as geometric) vector. A vector is an entity\nthat has both magnitude and direction. The datatype, however, stores\nthe components of the vector (x, y for 2D, and x, y, z for 3D). The magnitude\nand direction can be accessed via the methods mag() and heading().\n<br><br>\nIn many of the p5.js examples, you will see p5.Vector used to describe a\nposition, velocity, or acceleration. For example, if you consider a rectangle\nmoving across the screen, at any given instant it has a position (a vector\nthat points from the origin to its location), a velocity (the rate at which\nthe object&#39;s position changes per time unit, expressed as a vector), and\nacceleration (the rate at which the object&#39;s velocity changes per time\nunit, expressed as a vector).\n<br><br>\nSince vectors represent groupings of values, we cannot simply use\ntraditional addition/multiplication/etc. Instead, we&#39;ll need to do some\n&quot;vector&quot; math, which is made easy by the methods inside the p5.Vector class.</p>\n",
            "is_constructor": 1,
            "params": [
                {
                    "name": "x",
                    "description": "<p>x component of the vector</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "y",
                    "description": "<p>y component of the vector</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "z",
                    "description": "<p>z component of the vector</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "example": [
                "\n<div>\n<code>\nvar v1 = createVector(40, 50);\nvar v2 = createVector(40, 50);\n\nellipse(v1.x, v1.y, 50, 50);\nellipse(v2.x, v2.y, 50, 50);\nv1.add(v2);\nellipse(v1.x, v1.y, 50, 50);\n</code>\n</div>"
            ],
            "alt": "2 white ellipses. One center-left the other bottom right and off canvas"
        },
        "p5.Font": {
            "name": "p5.Font",
            "shortname": "p5.Font",
            "classitems": [],
            "plugins": [],
            "extensions": [],
            "plugin_for": [],
            "extension_for": [],
            "module": "Typography",
            "submodule": "Font",
            "namespace": "",
            "file": "src/typography/p5.Font.js",
            "line": 21,
            "description": "<p>Base class for font handling</p>\n",
            "is_constructor": 1,
            "params": [
                {
                    "name": "pInst",
                    "description": "<p>pointer to p5 instance</p>\n",
                    "type": "P5",
                    "optional": true
                }
            ]
        },
        "p5.Geometry": {
            "name": "p5.Geometry",
            "shortname": "p5.Geometry",
            "classitems": [],
            "plugins": [],
            "extensions": [],
            "plugin_for": [],
            "extension_for": [],
            "module": "Lights, Camera",
            "namespace": "",
            "file": "src/webgl/p5.Geometry.js",
            "line": 6,
            "description": "<p>p5 Geometry class</p>\n",
            "is_constructor": 1,
            "params": [
                {
                    "name": "vertData",
                    "description": "<p>callback function or Object\n                    containing routine(s) for vertex data generation</p>\n",
                    "type": "Function | Object"
                },
                {
                    "name": "detailX",
                    "description": "<p>number of vertices on horizontal surface</p>\n",
                    "type": "Integer",
                    "optional": true
                },
                {
                    "name": "detailY",
                    "description": "<p>number of vertices on horizontal surface</p>\n",
                    "type": "Integer",
                    "optional": true
                },
                {
                    "name": "callback",
                    "description": "<p>function to call upon object instantiation.</p>\n",
                    "type": "Function",
                    "optional": true
                }
            ]
        },
        "p5.RendererGL": {
            "name": "fill",
            "shortname": "p5.RendererGL",
            "classitems": [],
            "plugins": [],
            "extensions": [],
            "plugin_for": [],
            "extension_for": [],
            "module": "Rendering",
            "namespace": "",
            "file": "src/webgl/p5.RendererGL.js",
            "line": 438,
            "description": "<p>Basic fill material for geometry with a given color</p>\n",
            "is_constructor": 1,
            "extends": "p5.Renderer",
            "todo": [
                "extend class to include public method for offscreen\nrendering (FBO)."
            ],
            "submodule": "Rendering",
            "itemtype": "method",
            "params": [
                {
                    "name": "v1",
                    "description": "<p>gray value,\nred or hue value (depending on the current color mode),\nor color Array, or CSS color string</p>\n",
                    "type": "Number|Number[]|String|p5.Color"
                },
                {
                    "name": "v2",
                    "description": "<p>green or saturation value</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "v3",
                    "description": "<p>blue or brightness value</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "a",
                    "description": "<p>opacity</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\nfunction setup() {\n  createCanvas(200, 200, WEBGL);\n}\n\nfunction draw() {\n  background(0);\n  noStroke();\n  fill(100, 100, 240);\n  rotateX(frameCount * 0.01);\n  rotateY(frameCount * 0.01);\n  box(75, 75, 75);\n}\n</code>\n</div>"
            ],
            "alt": "black canvas with purple cube spinning"
        },
        "p5.Shader": {
            "name": "p5.Shader",
            "shortname": "p5.Shader",
            "classitems": [],
            "plugins": [],
            "extensions": [],
            "plugin_for": [],
            "extension_for": [],
            "module": "Lights, Camera",
            "submodule": "Shaders",
            "namespace": "",
            "file": "src/webgl/p5.Shader.js",
            "line": 13,
            "description": "<p>Shader class for WEBGL Mode</p>\n",
            "is_constructor": 1,
            "params": [
                {
                    "name": "renderer",
                    "description": "<p>an instance of p5.RendererGL that\nwill provide the GL context for this new p5.Shader</p>\n",
                    "type": "p5.RendererGL"
                },
                {
                    "name": "vertSrc",
                    "description": "<p>source code for the vertex shader (as a string)</p>\n",
                    "type": "String"
                },
                {
                    "name": "fragSrc",
                    "description": "<p>source code for the fragment shader (as a string)</p>\n",
                    "type": "String"
                }
            ]
        },
        "p5.Texture": {
            "name": "p5.Texture",
            "shortname": "p5.Texture",
            "classitems": [],
            "plugins": [],
            "extensions": [],
            "plugin_for": [],
            "extension_for": [],
            "module": "Lights, Camera",
            "submodule": "Material",
            "namespace": "",
            "file": "src/webgl/p5.Texture.js",
            "line": 13,
            "description": "<p>Texture class for WEBGL Mode</p>\n",
            "is_constructor": 1,
            "params": [
                {
                    "name": "renderer",
                    "description": "<p>an instance of p5.RendererGL that\nwill provide the GL context for this new p5.Texture</p>\n",
                    "type": "p5.RendererGL"
                },
                {
                    "name": "obj",
                    "description": "<p>the\nobject containing the image data to store in the texture.</p>\n",
                    "type": "p5.Image|p5.Graphics|p5.Element|p5.MediaElement",
                    "optional": true
                }
            ]
        },
        "p5.dom": {
            "name": "p5.dom",
            "shortname": "p5.dom",
            "classitems": [],
            "plugins": [],
            "extensions": [],
            "plugin_for": [],
            "extension_for": [],
            "module": "p5.dom",
            "submodule": "p5.dom",
            "namespace": ""
        },
        "p5.MediaElement": {
            "name": "p5.MediaElement",
            "shortname": "p5.MediaElement",
            "classitems": [],
            "plugins": [],
            "extensions": [],
            "plugin_for": [],
            "extension_for": [],
            "module": "p5.dom",
            "submodule": "p5.dom",
            "namespace": "",
            "file": "lib/addons/p5.dom.js",
            "line": 1820,
            "description": "<p>Extends p5.Element to handle audio and video. In addition to the methods\nof p5.Element, it also contains methods for controlling media. It is not\ncalled directly, but p5.MediaElements are created by calling createVideo,\ncreateAudio, and createCapture.</p>\n",
            "is_constructor": 1,
            "params": [
                {
                    "name": "elt",
                    "description": "<p>DOM node that is wrapped</p>\n",
                    "type": "String"
                }
            ]
        },
        "p5.File": {
            "name": "p5.File",
            "shortname": "p5.File",
            "classitems": [],
            "plugins": [],
            "extensions": [],
            "plugin_for": [],
            "extension_for": [],
            "module": "p5.dom",
            "submodule": "p5.dom",
            "namespace": "",
            "file": "lib/addons/p5.dom.js",
            "line": 2876,
            "description": "<p>Base class for a file\nUsing this for createFileInput</p>\n",
            "is_constructor": 1,
            "params": [
                {
                    "name": "file",
                    "description": "<p>File that is wrapped</p>\n",
                    "type": "File"
                }
            ]
        },
        "p5.sound": {
            "name": "p5.sound",
            "shortname": "p5.sound",
            "classitems": [],
            "plugins": [],
            "extensions": [],
            "plugin_for": [],
            "extension_for": [],
            "module": "p5.sound",
            "submodule": "p5.sound",
            "namespace": ""
        },
        "p5.SoundFile": {
            "name": "p5.SoundFile",
            "shortname": "p5.SoundFile",
            "classitems": [],
            "plugins": [],
            "extensions": [],
            "plugin_for": [],
            "extension_for": [],
            "module": "p5.sound",
            "submodule": "p5.sound",
            "namespace": "",
            "file": "lib/addons/p5.sound.js",
            "line": 740,
            "description": "<p>SoundFile object with a path to a file.</p>\n\n<p>The p5.SoundFile may not be available immediately because\nit loads the file information asynchronously.</p>\n\n<p>To do something with the sound as soon as it loads\npass the name of a function as the second parameter.</p>\n\n<p>Only one file path is required. However, audio file formats\n(i.e. mp3, ogg, wav and m4a/aac) are not supported by all\nweb browsers. If you want to ensure compatability, instead of a single\nfile path, you may include an Array of filepaths, and the browser will\nchoose a format that works.</p>",
            "is_constructor": 1,
            "params": [
                {
                    "name": "path",
                    "description": "<p>path to a sound file (String). Optionally,\n                             you may include multiple file formats in\n                             an array. Alternately, accepts an object\n                             from the HTML5 File API, or a p5.File.</p>\n",
                    "type": "String|Array"
                },
                {
                    "name": "successCallback",
                    "description": "<p>Name of a function to call once file loads</p>\n",
                    "type": "Function",
                    "optional": true
                },
                {
                    "name": "errorCallback",
                    "description": "<p>Name of a function to call if file fails to\n                                    load. This function will receive an error or\n                                   XMLHttpRequest object with information\n                                   about what went wrong.</p>\n",
                    "type": "Function",
                    "optional": true
                },
                {
                    "name": "whileLoadingCallback",
                    "description": "<p>Name of a function to call while file\n                                           is loading. That function will\n                                           receive progress of the request to\n                                           load the sound file\n                                           (between 0 and 1) as its first\n                                           parameter. This progress\n                                           does not account for the additional\n                                           time needed to decode the audio data.</p>\n",
                    "type": "Function",
                    "optional": true
                }
            ],
            "example": [
                "\n<div><code>\n\nfunction preload() {\n  soundFormats('mp3', 'ogg');\n  mySound = loadSound('assets/doorbell.mp3');\n}\n\nfunction setup() {\n  mySound.setVolume(0.1);\n  mySound.play();\n}\n\n </code></div>"
            ]
        },
        "p5.Amplitude": {
            "name": "p5.Amplitude",
            "shortname": "p5.Amplitude",
            "classitems": [],
            "plugins": [],
            "extensions": [],
            "plugin_for": [],
            "extension_for": [],
            "module": "p5.sound",
            "submodule": "p5.sound",
            "namespace": "",
            "file": "lib/addons/p5.sound.js",
            "line": 2154,
            "description": "<p>Amplitude measures volume between 0.0 and 1.0.\nListens to all p5sound by default, or use setInput()\nto listen to a specific sound source. Accepts an optional\nsmoothing value, which defaults to 0.</p>\n",
            "is_constructor": 1,
            "params": [
                {
                    "name": "smoothing",
                    "description": "<p>between 0.0 and .999 to smooth\n                           amplitude readings (defaults to 0)</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "example": [
                "\n<div><code>\nvar sound, amplitude, cnv;\n\nfunction preload(){\n  sound = loadSound('assets/beat.mp3');\n}\nfunction setup() {\n  cnv = createCanvas(100,100);\n  amplitude = new p5.Amplitude();\n\n  // start / stop the sound when canvas is clicked\n  cnv.mouseClicked(function() {\n    if (sound.isPlaying() ){\n      sound.stop();\n    } else {\n      sound.play();\n    }\n  });\n}\nfunction draw() {\n  background(0);\n  fill(255);\n  var level = amplitude.getLevel();\n  var size = map(level, 0, 1, 0, 200);\n  ellipse(width/2, height/2, size, size);\n}\n\n</code></div>"
            ]
        },
        "p5.FFT": {
            "name": "p5.FFT",
            "shortname": "p5.FFT",
            "classitems": [],
            "plugins": [],
            "extensions": [],
            "plugin_for": [],
            "extension_for": [],
            "module": "p5.sound",
            "submodule": "p5.sound",
            "namespace": "",
            "file": "lib/addons/p5.sound.js",
            "line": 2426,
            "description": "<p>FFT (Fast Fourier Transform) is an analysis algorithm that\nisolates individual\n<a href=\"https://en.wikipedia.org/wiki/Audio_frequency\">\naudio frequencies</a> within a waveform.</p>\n\n<p>Once instantiated, a p5.FFT object can return an array based on\ntwo types of analyses: <br> • <code>FFT.waveform()</code> computes\namplitude values along the time domain. The array indices correspond\nto samples across a brief moment in time. Each value represents\namplitude of the waveform at that sample of time.<br>\n• <code>FFT.analyze() </code> computes amplitude values along the\nfrequency domain. The array indices correspond to frequencies (i.e.\npitches), from the lowest to the highest that humans can hear. Each\nvalue represents amplitude at that slice of the frequency spectrum.\nUse with <code>getEnergy()</code> to measure amplitude at specific\nfrequencies, or within a range of frequencies. </p>\n\n<p>FFT analyzes a very short snapshot of sound called a sample\nbuffer. It returns an array of amplitude measurements, referred\nto as <code>bins</code>. The array is 1024 bins long by default.\nYou can change the bin array length, but it must be a power of 2\nbetween 16 and 1024 in order for the FFT algorithm to function\ncorrectly. The actual size of the FFT buffer is twice the\nnumber of bins, so given a standard sample rate, the buffer is\n2048/44100 seconds long.</p>",
            "is_constructor": 1,
            "params": [
                {
                    "name": "smoothing",
                    "description": "<p>Smooth results of Freq Spectrum.\n                              0.0 &lt; smoothing &lt; 1.0.\n                              Defaults to 0.8.</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "bins",
                    "description": "<p>Length of resulting array.\n                          Must be a power of two between\n                          16 and 1024. Defaults to 1024.</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "example": [
                "\n<div><code>\nfunction preload(){\n  sound = loadSound('assets/Damscray_DancingTiger.mp3');\n}\n\nfunction setup(){\n  var cnv = createCanvas(100,100);\n  cnv.mouseClicked(togglePlay);\n  fft = new p5.FFT();\n  sound.amp(0.2);\n}\n\nfunction draw(){\n  background(0);\n\n  var spectrum = fft.analyze();\n  noStroke();\n  fill(0,255,0); // spectrum is green\n  for (var i = 0; i< spectrum.length; i++){\n    var x = map(i, 0, spectrum.length, 0, width);\n    var h = -height + map(spectrum[i], 0, 255, height, 0);\n    rect(x, height, width / spectrum.length, h )\n  }\n\n  var waveform = fft.waveform();\n  noFill();\n  beginShape();\n  stroke(255,0,0); // waveform is red\n  strokeWeight(1);\n  for (var i = 0; i< waveform.length; i++){\n    var x = map(i, 0, waveform.length, 0, width);\n    var y = map( waveform[i], -1, 1, 0, height);\n    vertex(x,y);\n  }\n  endShape();\n\n  text('click to play/pause', 4, 10);\n}\n\n// fade sound if mouse is over canvas\nfunction togglePlay() {\n  if (sound.isPlaying()) {\n    sound.pause();\n  } else {\n    sound.loop();\n  }\n}\n</code></div>"
            ]
        },
        "p5.Signal": {
            "name": "p5.Signal",
            "shortname": "p5.Signal",
            "classitems": [],
            "plugins": [],
            "extensions": [],
            "plugin_for": [],
            "extension_for": [],
            "module": "p5.sound",
            "submodule": "p5.sound",
            "namespace": "",
            "file": "lib/addons/p5.sound.js",
            "line": 4828,
            "description": "<p>p5.Signal is a constant audio-rate signal used by p5.Oscillator\nand p5.Envelope for modulation math.</p>\n\n<p>This is necessary because Web Audio is processed on a seprate clock.\nFor example, the p5 draw loop runs about 60 times per second. But\nthe audio clock must process samples 44100 times per second. If we\nwant to add a value to each of those samples, we can&#39;t do it in the\ndraw loop, but we can do it by adding a constant-rate audio signal.</p.\n\n<p>This class mostly functions behind the scenes in p5.sound, and returns\na Tone.Signal from the Tone.js library by Yotam Mann.\nIf you want to work directly with audio signals for modular\nsynthesis, check out\n<a href='http://bit.ly/1oIoEng' target=_'blank'>tone.js.</a></p>",
            "is_constructor": 1,
            "return": {
                "description": "A Signal object from the Tone.js library",
                "type": "Tone.Signal"
            },
            "example": [
                "\n<div><code>\nfunction setup() {\n  carrier = new p5.Oscillator('sine');\n  carrier.amp(1); // set amplitude\n  carrier.freq(220); // set frequency\n  carrier.start(); // start oscillating\n\n  modulator = new p5.Oscillator('sawtooth');\n  modulator.disconnect();\n  modulator.amp(1);\n  modulator.freq(4);\n  modulator.start();\n\n  // Modulator's default amplitude range is -1 to 1.\n  // Multiply it by -200, so the range is -200 to 200\n  // then add 220 so the range is 20 to 420\n  carrier.freq( modulator.mult(-200).add(220) );\n}\n</code></div>"
            ]
        },
        "p5.Oscillator": {
            "name": "p5.Oscillator",
            "shortname": "p5.Oscillator",
            "classitems": [],
            "plugins": [],
            "extensions": [],
            "plugin_for": [],
            "extension_for": [],
            "module": "p5.sound",
            "submodule": "p5.sound",
            "namespace": "",
            "file": "lib/addons/p5.sound.js",
            "line": 4974,
            "description": "<p>Creates a signal that oscillates between -1.0 and 1.0.\nBy default, the oscillation takes the form of a sinusoidal\nshape (&#39;sine&#39;). Additional types include &#39;triangle&#39;,\n&#39;sawtooth&#39; and &#39;square&#39;. The frequency defaults to\n440 oscillations per second (440Hz, equal to the pitch of an\n&#39;A&#39; note).</p>\n\n<p>Set the type of oscillation with setType(), or by instantiating a\nspecific oscillator: <a href=\"/reference/#/p5.SinOsc\">p5.SinOsc</a>, <a\nhref=\"/reference/#/p5.TriOsc\">p5.TriOsc</a>, <a\nhref=\"/reference/#/p5.SqrOsc\">p5.SqrOsc</a>, or <a\nhref=\"/reference/#/p5.SawOsc\">p5.SawOsc</a>.\n</p>",
            "is_constructor": 1,
            "params": [
                {
                    "name": "freq",
                    "description": "<p>frequency defaults to 440Hz</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "type",
                    "description": "<p>type of oscillator. Options:\n                       &#39;sine&#39; (default), &#39;triangle&#39;,\n                       &#39;sawtooth&#39;, &#39;square&#39;</p>\n",
                    "type": "String",
                    "optional": true
                }
            ],
            "example": [
                "\n<div><code>\nvar osc;\nvar playing = false;\n\nfunction setup() {\n  backgroundColor = color(255,0,255);\n  textAlign(CENTER);\n\n  osc = new p5.Oscillator();\n  osc.setType('sine');\n  osc.freq(240);\n  osc.amp(0);\n  osc.start();\n}\n\nfunction draw() {\n  background(backgroundColor)\n  text('click to play', width/2, height/2);\n}\n\nfunction mouseClicked() {\n  if (mouseX > 0 && mouseX < width && mouseY < height && mouseY > 0) {\n    if (!playing) {\n      // ramp amplitude to 0.5 over 0.05 seconds\n      osc.amp(0.5, 0.05);\n      playing = true;\n      backgroundColor = color(0,255,255);\n    } else {\n      // ramp amplitude to 0 over 0.5 seconds\n      osc.amp(0, 0.5);\n      playing = false;\n      backgroundColor = color(255,0,255);\n    }\n  }\n}\n</code> </div>"
            ]
        },
        "p5.SinOsc": {
            "name": "p5.SinOsc",
            "shortname": "p5.SinOsc",
            "classitems": [],
            "plugins": [],
            "extensions": [],
            "plugin_for": [],
            "extension_for": [],
            "module": "p5.sound",
            "submodule": "p5.sound",
            "namespace": "",
            "file": "lib/addons/p5.sound.js",
            "line": 5409,
            "description": "<p>Constructor: <code>new p5.SinOsc()</code>.\nThis creates a Sine Wave Oscillator and is\nequivalent to <code> new p5.Oscillator(&#39;sine&#39;)\n</code> or creating a p5.Oscillator and then calling\nits method <code>setType(&#39;sine&#39;)</code>.\nSee p5.Oscillator for methods.</p>\n",
            "is_constructor": 1,
            "extends": "p5.Oscillator",
            "params": [
                {
                    "name": "freq",
                    "description": "<p>Set the frequency</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ]
        },
        "p5.TriOsc": {
            "name": "p5.TriOsc",
            "shortname": "p5.TriOsc",
            "classitems": [],
            "plugins": [],
            "extensions": [],
            "plugin_for": [],
            "extension_for": [],
            "module": "p5.sound",
            "submodule": "p5.sound",
            "namespace": "",
            "file": "lib/addons/p5.sound.js",
            "line": 5426,
            "description": "<p>Constructor: <code>new p5.TriOsc()</code>.\nThis creates a Triangle Wave Oscillator and is\nequivalent to <code>new p5.Oscillator(&#39;triangle&#39;)\n</code> or creating a p5.Oscillator and then calling\nits method <code>setType(&#39;triangle&#39;)</code>.\nSee p5.Oscillator for methods.</p>\n",
            "is_constructor": 1,
            "extends": "p5.Oscillator",
            "params": [
                {
                    "name": "freq",
                    "description": "<p>Set the frequency</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ]
        },
        "p5.SawOsc": {
            "name": "p5.SawOsc",
            "shortname": "p5.SawOsc",
            "classitems": [],
            "plugins": [],
            "extensions": [],
            "plugin_for": [],
            "extension_for": [],
            "module": "p5.sound",
            "submodule": "p5.sound",
            "namespace": "",
            "file": "lib/addons/p5.sound.js",
            "line": 5443,
            "description": "<p>Constructor: <code>new p5.SawOsc()</code>.\nThis creates a SawTooth Wave Oscillator and is\nequivalent to <code> new p5.Oscillator(&#39;sawtooth&#39;)\n</code> or creating a p5.Oscillator and then calling\nits method <code>setType(&#39;sawtooth&#39;)</code>.\nSee p5.Oscillator for methods.</p>\n",
            "is_constructor": 1,
            "extends": "p5.Oscillator",
            "params": [
                {
                    "name": "freq",
                    "description": "<p>Set the frequency</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ]
        },
        "p5.SqrOsc": {
            "name": "p5.SqrOsc",
            "shortname": "p5.SqrOsc",
            "classitems": [],
            "plugins": [],
            "extensions": [],
            "plugin_for": [],
            "extension_for": [],
            "module": "p5.sound",
            "submodule": "p5.sound",
            "namespace": "",
            "file": "lib/addons/p5.sound.js",
            "line": 5460,
            "description": "<p>Constructor: <code>new p5.SqrOsc()</code>.\nThis creates a Square Wave Oscillator and is\nequivalent to <code> new p5.Oscillator(&#39;square&#39;)\n</code> or creating a p5.Oscillator and then calling\nits method <code>setType(&#39;square&#39;)</code>.\nSee p5.Oscillator for methods.</p>\n",
            "is_constructor": 1,
            "extends": "p5.Oscillator",
            "params": [
                {
                    "name": "freq",
                    "description": "<p>Set the frequency</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ]
        },
        "p5.Env": {
            "name": "p5.Env",
            "shortname": "p5.Env",
            "classitems": [],
            "plugins": [],
            "extensions": [],
            "plugin_for": [],
            "extension_for": [],
            "module": "p5.sound",
            "submodule": "p5.sound",
            "namespace": "",
            "file": "lib/addons/p5.sound.js",
            "line": 5917,
            "description": "<p>Envelopes are pre-defined amplitude distribution over time.\nTypically, envelopes are used to control the output volume\nof an object, a series of fades referred to as Attack, Decay,\nSustain and Release (\n<a href=\"https://upload.wikimedia.org/wikipedia/commons/e/ea/ADSR_parameter.svg\">ADSR</a>\n). Envelopes can also control other Web Audio Parameters—for example, a p5.Env can\ncontrol an Oscillator&#39;s frequency like this: <code>osc.freq(env)</code>.</p>\n<p>Use <code><a href=\"#/p5.Env/setRange\">setRange</a></code> to change the attack/release level.\nUse <code><a href=\"#/p5.Env/setADSR\">setADSR</a></code> to change attackTime, decayTime, sustainPercent and releaseTime.</p>\n<p>Use the <code><a href=\"#/p5.Env/play\">play</a></code> method to play the entire envelope,\nthe <code><a href=\"#/p5.Env/ramp\">ramp</a></code> method for a pingable trigger,\nor <code><a href=\"#/p5.Env/triggerAttack\">triggerAttack</a></code>/\n<code><a href=\"#/p5.Env/triggerRelease\">triggerRelease</a></code> to trigger noteOn/noteOff.</p>",
            "is_constructor": 1,
            "example": [
                "\n<div><code>\nvar attackLevel = 1.0;\nvar releaseLevel = 0;\n\nvar attackTime = 0.001\nvar decayTime = 0.2;\nvar susPercent = 0.2;\nvar releaseTime = 0.5;\n\nvar env, triOsc;\n\nfunction setup() {\n  var cnv = createCanvas(100, 100);\n\n  textAlign(CENTER);\n  text('click to play', width/2, height/2);\n\n  env = new p5.Env();\n  env.setADSR(attackTime, decayTime, susPercent, releaseTime);\n  env.setRange(attackLevel, releaseLevel);\n\n  triOsc = new p5.Oscillator('triangle');\n  triOsc.amp(env);\n  triOsc.start();\n  triOsc.freq(220);\n\n  cnv.mousePressed(playEnv);\n}\n\nfunction playEnv(){\n  env.play();\n}\n</code></div>"
            ]
        },
        "p5.Pulse": {
            "name": "p5.Pulse",
            "shortname": "p5.Pulse",
            "classitems": [],
            "plugins": [],
            "extensions": [],
            "plugin_for": [],
            "extension_for": [],
            "module": "p5.sound",
            "submodule": "p5.sound",
            "namespace": "",
            "file": "lib/addons/p5.sound.js",
            "line": 6709,
            "description": "<p>Creates a Pulse object, an oscillator that implements\nPulse Width Modulation.\nThe pulse is created with two oscillators.\nAccepts a parameter for frequency, and to set the\nwidth between the pulses. See <a href=\"\nhttp://p5js.org/reference/#/p5.Oscillator\">\n<code>p5.Oscillator</code> for a full list of methods.</p>\n",
            "extends": "p5.Oscillator",
            "is_constructor": 1,
            "params": [
                {
                    "name": "freq",
                    "description": "<p>Frequency in oscillations per second (Hz)</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "w",
                    "description": "<p>Width between the pulses (0 to 1.0,\n                       defaults to 0)</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "example": [
                "\n<div><code>\nvar pulse;\nfunction setup() {\n  background(0);\n\n  // Create and start the pulse wave oscillator\n  pulse = new p5.Pulse();\n  pulse.amp(0.5);\n  pulse.freq(220);\n  pulse.start();\n}\n\nfunction draw() {\n  var w = map(mouseX, 0, width, 0, 1);\n  w = constrain(w, 0, 1);\n  pulse.width(w)\n}\n</code></div>"
            ]
        },
        "p5.Noise": {
            "name": "p5.Noise",
            "shortname": "p5.Noise",
            "classitems": [],
            "plugins": [],
            "extensions": [],
            "plugin_for": [],
            "extension_for": [],
            "module": "p5.sound",
            "submodule": "p5.sound",
            "namespace": "",
            "file": "lib/addons/p5.sound.js",
            "line": 6886,
            "description": "<p>Noise is a type of oscillator that generates a buffer with random values.</p>\n",
            "extends": "p5.Oscillator",
            "is_constructor": 1,
            "params": [
                {
                    "name": "type",
                    "description": "<p>Type of noise can be &#39;white&#39; (default),\n                     &#39;brown&#39; or &#39;pink&#39;.</p>\n",
                    "type": "String"
                }
            ]
        },
        "p5.AudioIn": {
            "name": "p5.AudioIn",
            "shortname": "p5.AudioIn",
            "classitems": [],
            "plugins": [],
            "extensions": [],
            "plugin_for": [],
            "extension_for": [],
            "module": "p5.sound",
            "submodule": "p5.sound",
            "namespace": "",
            "file": "lib/addons/p5.sound.js",
            "line": 7075,
            "description": "<p>Get audio from an input, i.e. your computer&#39;s microphone.</p>\n\n<p>Turn the mic on/off with the start() and stop() methods. When the mic\nis on, its volume can be measured with getLevel or by connecting an\nFFT object.</p>\n\n<p>If you want to hear the AudioIn, use the .connect() method.\nAudioIn does not connect to p5.sound output by default to prevent\nfeedback.</p>\n\n<p><em>Note: This uses the <a href=\"http://caniuse.com/stream\">getUserMedia/\nStream</a> API, which is not supported by certain browsers. Access in Chrome browser\nis limited to localhost and https, but access over http may be limited.</em></p>",
            "is_constructor": 1,
            "params": [
                {
                    "name": "errorCallback",
                    "description": "<p>A function to call if there is an error\n                                  accessing the AudioIn. For example,\n                                  Safari and iOS devices do not\n                                  currently allow microphone access.</p>\n",
                    "type": "Function",
                    "optional": true
                }
            ],
            "example": [
                "\n<div><code>\nvar mic;\nfunction setup(){\n  mic = new p5.AudioIn()\n  mic.start();\n}\nfunction draw(){\n  background(0);\n  micLevel = mic.getLevel();\n  ellipse(width/2, constrain(height-micLevel*height*5, 0, height), 10, 10);\n}\n</code></div>"
            ]
        },
        "p5.Effect": {
            "name": "p5.Effect",
            "shortname": "p5.Effect",
            "classitems": [],
            "plugins": [],
            "extensions": [],
            "plugin_for": [],
            "extension_for": [],
            "module": "p5.sound",
            "submodule": "p5.sound",
            "namespace": "",
            "file": "lib/addons/p5.sound.js",
            "line": 7970,
            "description": "<p>Effect is a base class for audio effects in p5. <br>\nThis module handles the nodes and methods that are\ncommon and useful for current and future effects.</p>\n<p>This class is extended by <a href=\"reference/#/p5.Distortion\">p5.Distortion</a>,\n<a href=\"reference/#/p5.Compressor\">p5.Compressor</a>,\n<a href=\"reference/#/p5.Delay\">p5.Delay</a>,\n<a href=\"reference/#/p5.Filter\">p5.Filter</a>,\n<a href=\"reference/#/p5.Reverb\">p5.Reverb</a>.</p>\n",
            "is_constructor": 1,
            "params": [
                {
                    "name": "ac",
                    "description": "<p>Reference to the audio context of the p5 object</p>\n",
                    "type": "Object",
                    "optional": true
                },
                {
                    "name": "input",
                    "description": "<p>Gain Node effect wrapper</p>\n",
                    "type": "AudioNode",
                    "optional": true
                },
                {
                    "name": "output",
                    "description": "<p>Gain Node effect wrapper</p>\n",
                    "type": "AudioNode",
                    "optional": true
                },
                {
                    "name": "_drywet",
                    "description": "<p>Tone.JS CrossFade node (defaults to value: 1)</p>\n",
                    "type": "Object",
                    "optional": true
                },
                {
                    "name": "wet",
                    "description": "<p>Effects that extend this class should connect\n                             to the wet signal to this gain node, so that dry and wet\n                             signals are mixed properly.</p>\n",
                    "type": "AudioNode",
                    "optional": true
                }
            ]
        },
        "p5.Filter": {
            "name": "p5.Filter",
            "shortname": "p5.Filter",
            "classitems": [],
            "plugins": [],
            "extensions": [],
            "plugin_for": [],
            "extension_for": [],
            "module": "p5.sound",
            "submodule": "p5.sound",
            "namespace": "",
            "file": "lib/addons/p5.sound.js",
            "line": 8102,
            "description": "<p><p>A p5.Filter uses a Web Audio Biquad Filter to filter\nthe frequency response of an input source. Subclasses\ninclude:</p></p>\n<ul>\n<li><a href=\"/reference/#/p5.LowPass\"><code>p5.LowPass</code></a>:\nAllows frequencies below the cutoff frequency to pass through,\nand attenuates frequencies above the cutoff.<br/></li>\n<li><a href=\"/reference/#/p5.HighPass\"><code>p5.HighPass</code></a>:\nThe opposite of a lowpass filter. <br/></li>\n<li><a href=\"/reference/#/p5.BandPass\"><code>p5.BandPass</code></a>:\nAllows a range of frequencies to pass through and attenuates\nthe frequencies below and above this frequency range.<br/></li>\n</ul>\n<p>The <code>.res()</code> method controls either width of the\nbandpass, or resonance of the low/highpass cutoff frequency.</p>\n<p>This class extends <a href = \"/reference/#/p5.Effect\">p5.Effect</a>.\nMethods <a href = \"/reference/#/p5.Effect/amp\">amp()</a>, <a href = \"/reference/#/p5.Effect/chain\">chain()</a>,\n<a href = \"/reference/#/p5.Effect/drywet\">drywet()</a>, <a href = \"/reference/#/p5.Effect/connect\">connect()</a>, and\n<a href = \"/reference/#/p5.Effect/disconnect\">disconnect()</a> are available.</p>\n",
            "extends": "p5.Effect",
            "is_constructor": 1,
            "params": [
                {
                    "name": "type",
                    "description": "<p>&#39;lowpass&#39; (default), &#39;highpass&#39;, &#39;bandpass&#39;</p>\n",
                    "type": "String",
                    "optional": true
                }
            ],
            "example": [
                "\n<div><code>\nvar fft, noise, filter;\n\nfunction setup() {\n  fill(255, 40, 255);\n\n  filter = new p5.BandPass();\n\n  noise = new p5.Noise();\n  // disconnect unfiltered noise,\n  // and connect to filter\n  noise.disconnect();\n  noise.connect(filter);\n  noise.start();\n\n  fft = new p5.FFT();\n}\n\nfunction draw() {\n  background(30);\n\n  // set the BandPass frequency based on mouseX\n  var freq = map(mouseX, 0, width, 20, 10000);\n  filter.freq(freq);\n  // give the filter a narrow band (lower res = wider bandpass)\n  filter.res(50);\n\n  // draw filtered spectrum\n  var spectrum = fft.analyze();\n  noStroke();\n  for (var i = 0; i < spectrum.length; i++) {\n    var x = map(i, 0, spectrum.length, 0, width);\n    var h = -height + map(spectrum[i], 0, 255, height, 0);\n    rect(x, height, width/spectrum.length, h);\n  }\n\n  isMouseOverCanvas();\n}\n\nfunction isMouseOverCanvas() {\n  var mX = mouseX, mY = mouseY;\n  if (mX > 0 && mX < width && mY < height && mY > 0) {\n    noise.amp(0.5, 0.2);\n  } else {\n    noise.amp(0, 0.2);\n  }\n}\n</code></div>"
            ]
        },
        "p5.LowPass": {
            "name": "p5.LowPass",
            "shortname": "p5.LowPass",
            "classitems": [],
            "plugins": [],
            "extensions": [],
            "plugin_for": [],
            "extension_for": [],
            "module": "p5.sound",
            "submodule": "p5.sound",
            "namespace": "",
            "file": "lib/addons/p5.sound.js",
            "line": 8332,
            "description": "<p>Constructor: <code>new p5.LowPass()</code> Filter.\nThis is the same as creating a p5.Filter and then calling\nits method <code>setType(&#39;lowpass&#39;)</code>.\nSee p5.Filter for methods.</p>\n",
            "is_constructor": 1,
            "extends": "p5.Filter"
        },
        "p5.HighPass": {
            "name": "p5.HighPass",
            "shortname": "p5.HighPass",
            "classitems": [],
            "plugins": [],
            "extensions": [],
            "plugin_for": [],
            "extension_for": [],
            "module": "p5.sound",
            "submodule": "p5.sound",
            "namespace": "",
            "file": "lib/addons/p5.sound.js",
            "line": 8346,
            "description": "<p>Constructor: <code>new p5.HighPass()</code> Filter.\nThis is the same as creating a p5.Filter and then calling\nits method <code>setType(&#39;highpass&#39;)</code>.\nSee p5.Filter for methods.</p>\n",
            "is_constructor": 1,
            "extends": "p5.Filter"
        },
        "p5.BandPass": {
            "name": "p5.BandPass",
            "shortname": "p5.BandPass",
            "classitems": [],
            "plugins": [],
            "extensions": [],
            "plugin_for": [],
            "extension_for": [],
            "module": "p5.sound",
            "submodule": "p5.sound",
            "namespace": "",
            "file": "lib/addons/p5.sound.js",
            "line": 8360,
            "description": "<p>Constructor: <code>new p5.BandPass()</code> Filter.\nThis is the same as creating a p5.Filter and then calling\nits method <code>setType(&#39;bandpass&#39;)</code>.\nSee p5.Filter for methods.</p>\n",
            "is_constructor": 1,
            "extends": "p5.Filter"
        },
        "p5.EQ": {
            "name": "p5.EQ",
            "shortname": "p5.EQ",
            "classitems": [],
            "plugins": [],
            "extensions": [],
            "plugin_for": [],
            "extension_for": [],
            "module": "p5.sound",
            "submodule": "p5.sound",
            "namespace": "",
            "file": "lib/addons/p5.sound.js",
            "line": 8429,
            "description": "<p>p5.EQ is an audio effect that performs the function of a multiband\naudio equalizer. Equalization is used to adjust the balance of\nfrequency compoenents of an audio signal. This process is commonly used\nin sound production and recording to change the waveform before it reaches\na sound output device. EQ can also be used as an audio effect to create\ninteresting distortions by filtering out parts of the spectrum. p5.EQ is\nbuilt using a chain of Web Audio Biquad Filter Nodes and can be\ninstantiated with 3 or 8 bands. Bands can be added or removed from\nthe EQ by directly modifying p5.EQ.bands (the array that stores filters).</p>\n<p>This class extends <a href = \"/reference/#/p5.Effect\">p5.Effect</a>.\nMethods <a href = \"/reference/#/p5.Effect/amp\">amp()</a>, <a href = \"/reference/#/p5.Effect/chain\">chain()</a>,\n<a href = \"/reference/#/p5.Effect/drywet\">drywet()</a>, <a href = \"/reference/#/p5.Effect/connect\">connect()</a>, and\n<a href = \"/reference/#/p5.Effect/disconnect\">disconnect()</a> are available.</p>\n",
            "is_constructor": 1,
            "extends": "p5.Effect",
            "params": [
                {
                    "name": "_eqsize",
                    "description": "<p>Constructor will accept 3 or 8, defaults to 3</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "return": {
                "description": "p5.EQ object",
                "type": "Object"
            },
            "example": [
                "\n<div><code>\nvar eq;\nvar band_names;\nvar band_index;\n\nvar soundFile, play;\n\nfunction preload() {\n  soundFormats('mp3', 'ogg');\n  soundFile = loadSound('assets/beat');\n}\n\nfunction setup() {\n  eq = new p5.EQ(3);\n  soundFile.disconnect();\n  eq.process(soundFile);\n\n  band_names = ['lows','mids','highs'];\n  band_index = 0;\n  play = false;\n  textAlign(CENTER);\n}\n\nfunction draw() {\n  background(30);\n  noStroke();\n  fill(255);\n  text('click to kill',50,25);\n\n  fill(255, 40, 255);\n  textSize(26);\n  text(band_names[band_index],50,55);\n\n  fill(255);\n  textSize(9);\n  text('space = play/pause',50,80);\n}\n\n//If mouse is over canvas, cycle to the next band and kill the frequency\nfunction mouseClicked() {\n  for (var i = 0; i < eq.bands.length; i++) {\n    eq.bands[i].gain(0);\n  }\n  eq.bands[band_index].gain(-40);\n  if (mouseX > 0 && mouseX < width && mouseY < height && mouseY > 0) {\n    band_index === 2 ? band_index = 0 : band_index++;\n  }\n}\n\n//use space bar to trigger play / pause\nfunction keyPressed() {\n  if (key===' ') {\n    play = !play\n    play ? soundFile.loop() : soundFile.pause();\n  }\n}\n</code></div>"
            ]
        },
        "p5.Panner3D": {
            "name": "p5.Panner3D",
            "shortname": "p5.Panner3D",
            "classitems": [],
            "plugins": [],
            "extensions": [],
            "plugin_for": [],
            "extension_for": [],
            "module": "p5.sound",
            "submodule": "p5.sound",
            "namespace": "",
            "file": "lib/addons/p5.sound.js",
            "line": 8619,
            "description": "<p>Panner3D is based on the <a title=\"Web Audio Panner docs\"  href=\n\"https://developer.mozilla.org/en-US/docs/Web/API/PannerNode\">\nWeb Audio Spatial Panner Node</a>.\nThis panner is a spatial processing node that allows audio to be positioned\nand oriented in 3D space.</p>\n<p>The position is relative to an <a title=\"Web Audio Listener docs\" href=\n\"https://developer.mozilla.org/en-US/docs/Web/API/AudioListener\">\nAudio Context Listener</a>, which can be accessed\nby <code>p5.soundOut.audiocontext.listener</code></p>\n",
            "is_constructor": 1
        },
        "p5.Delay": {
            "name": "p5.Delay",
            "shortname": "p5.Delay",
            "classitems": [],
            "plugins": [],
            "extensions": [],
            "plugin_for": [],
            "extension_for": [],
            "module": "p5.sound",
            "submodule": "p5.sound",
            "namespace": "",
            "file": "lib/addons/p5.sound.js",
            "line": 9068,
            "description": "<p>Delay is an echo effect. It processes an existing sound source,\nand outputs a delayed version of that sound. The p5.Delay can\nproduce different effects depending on the delayTime, feedback,\nfilter, and type. In the example below, a feedback of 0.5 (the\ndefaul value) will produce a looping delay that decreases in\nvolume by 50% each repeat. A filter will cut out the high\nfrequencies so that the delay does not sound as piercing as the\noriginal source.</p>\n<p>This class extends <a href = \"/reference/#/p5.Effect\">p5.Effect</a>.\nMethods <a href = \"/reference/#/p5.Effect/amp\">amp()</a>, <a href = \"/reference/#/p5.Effect/chain\">chain()</a>,\n<a href = \"/reference/#/p5.Effect/drywet\">drywet()</a>, <a href = \"/reference/#/p5.Effect/connect\">connect()</a>, and\n<a href = \"/reference/#/p5.Effect/disconnect\">disconnect()</a> are available.</p>\n",
            "extends": "p5.Effect",
            "is_constructor": 1,
            "example": [
                "\n<div><code>\nvar noise, env, delay;\n\nfunction setup() {\n  background(0);\n  noStroke();\n  fill(255);\n  textAlign(CENTER);\n  text('click to play', width/2, height/2);\n\n  noise = new p5.Noise('brown');\n  noise.amp(0);\n  noise.start();\n\n  delay = new p5.Delay();\n\n  // delay.process() accepts 4 parameters:\n  // source, delayTime, feedback, filter frequency\n  // play with these numbers!!\n  delay.process(noise, .12, .7, 2300);\n\n  // play the noise with an envelope,\n  // a series of fades ( time / value pairs )\n  env = new p5.Env(.01, 0.2, .2, .1);\n}\n\n// mouseClick triggers envelope\nfunction mouseClicked() {\n  // is mouse over canvas?\n  if (mouseX > 0 && mouseX < width && mouseY > 0 && mouseY < height) {\n    env.play(noise);\n  }\n}\n</code></div>"
            ]
        },
        "p5.Reverb": {
            "name": "p5.Reverb",
            "shortname": "p5.Reverb",
            "classitems": [],
            "plugins": [],
            "extensions": [],
            "plugin_for": [],
            "extension_for": [],
            "module": "p5.sound",
            "submodule": "p5.sound",
            "namespace": "",
            "file": "lib/addons/p5.sound.js",
            "line": 9345,
            "description": "<p>Reverb adds depth to a sound through a large number of decaying\nechoes. It creates the perception that sound is occurring in a\nphysical space. The p5.Reverb has paramters for Time (how long does the\nreverb last) and decayRate (how much the sound decays with each echo)\nthat can be set with the .set() or .process() methods. The p5.Convolver\nextends p5.Reverb allowing you to recreate the sound of actual physical\nspaces through convolution.</p>\n<p>This class extends <a href = \"/reference/#/p5.Effect\">p5.Effect</a>.\nMethods <a href = \"/reference/#/p5.Effect/amp\">amp()</a>, <a href = \"/reference/#/p5.Effect/chain\">chain()</a>,\n<a href = \"/reference/#/p5.Effect/drywet\">drywet()</a>, <a href = \"/reference/#/p5.Effect/connect\">connect()</a>, and\n<a href = \"/reference/#/p5.Effect/disconnect\">disconnect()</a> are available.</p>\n",
            "extends": "p5.Effect",
            "is_constructor": 1,
            "example": [
                "\n<div><code>\nvar soundFile, reverb;\nfunction preload() {\n  soundFile = loadSound('assets/Damscray_DancingTiger.mp3');\n}\n\nfunction setup() {\n  reverb = new p5.Reverb();\n  soundFile.disconnect(); // so we'll only hear reverb...\n\n  // connect soundFile to reverb, process w/\n  // 3 second reverbTime, decayRate of 2%\n  reverb.process(soundFile, 3, 2);\n  soundFile.play();\n}\n</code></div>"
            ]
        },
        "p5.Convolver": {
            "name": "p5.Convolver",
            "shortname": "p5.Convolver",
            "classitems": [],
            "plugins": [],
            "extensions": [],
            "plugin_for": [],
            "extension_for": [],
            "module": "p5.sound",
            "submodule": "p5.sound",
            "namespace": "",
            "file": "lib/addons/p5.sound.js",
            "line": 9505,
            "description": "<p>p5.Convolver extends p5.Reverb. It can emulate the sound of real\nphysical spaces through a process called <a href=\"\nhttps://en.wikipedia.org/wiki/Convolution_reverb#Real_space_simulation\">\nconvolution</a>.</p>\n\n<p>Convolution multiplies any audio input by an &quot;impulse response&quot;\nto simulate the dispersion of sound over time. The impulse response is\ngenerated from an audio file that you provide. One way to\ngenerate an impulse response is to pop a balloon in a reverberant space\nand record the echo. Convolution can also be used to experiment with\nsound.</p>\n\n<p>Use the method <code>createConvolution(path)</code> to instantiate a\np5.Convolver with a path to your impulse response audio file.</p>",
            "extends": "p5.Effect",
            "is_constructor": 1,
            "params": [
                {
                    "name": "path",
                    "description": "<p>path to a sound file</p>\n",
                    "type": "String"
                },
                {
                    "name": "callback",
                    "description": "<p>function to call when loading succeeds</p>\n",
                    "type": "Function",
                    "optional": true
                },
                {
                    "name": "errorCallback",
                    "description": "<p>function to call if loading fails.\n                                   This function will receive an error or\n                                   XMLHttpRequest object with information\n                                   about what went wrong.</p>\n",
                    "type": "Function",
                    "optional": true
                }
            ],
            "example": [
                "\n<div><code>\nvar cVerb, sound;\nfunction preload() {\n  // We have both MP3 and OGG versions of all sound assets\n  soundFormats('ogg', 'mp3');\n\n  // Try replacing 'bx-spring' with other soundfiles like\n  // 'concrete-tunnel' 'small-plate' 'drum' 'beatbox'\n  cVerb = createConvolver('assets/bx-spring.mp3');\n\n  // Try replacing 'Damscray_DancingTiger' with\n  // 'beat', 'doorbell', lucky_dragons'\n  sound = loadSound('assets/Damscray_DancingTiger.mp3');\n}\n\nfunction setup() {\n  // disconnect from master output...\n  sound.disconnect();\n\n  // ...and process with cVerb\n  // so that we only hear the convolution\n  cVerb.process(sound);\n\n  sound.play();\n}\n</code></div>"
            ]
        },
        "p5.Phrase": {
            "name": "p5.Phrase",
            "shortname": "p5.Phrase",
            "classitems": [],
            "plugins": [],
            "extensions": [],
            "plugin_for": [],
            "extension_for": [],
            "module": "p5.sound",
            "submodule": "p5.sound",
            "namespace": "",
            "file": "lib/addons/p5.sound.js",
            "line": 10057,
            "description": "<p>A phrase is a pattern of musical events over time, i.e.\na series of notes and rests.</p>\n\n<p>Phrases must be added to a p5.Part for playback, and\neach part can play multiple phrases at the same time.\nFor example, one Phrase might be a kick drum, another\ncould be a snare, and another could be the bassline.</p>\n\n<p>The first parameter is a name so that the phrase can be\nmodified or deleted later. The callback is a a function that\nthis phrase will call at every step—for example it might be\ncalled <code>playNote(value){}</code>. The array determines\nwhich value is passed into the callback at each step of the\nphrase. It can be numbers, an object with multiple numbers,\nor a zero (0) indicates a rest so the callback won&#39;t be called).</p>",
            "is_constructor": 1,
            "params": [
                {
                    "name": "name",
                    "description": "<p>Name so that you can access the Phrase.</p>\n",
                    "type": "String"
                },
                {
                    "name": "callback",
                    "description": "<p>The name of a function that this phrase\n                           will call. Typically it will play a sound,\n                           and accept two parameters: a time at which\n                           to play the sound (in seconds from now),\n                           and a value from the sequence array. The\n                           time should be passed into the play() or\n                           start() method to ensure precision.</p>\n",
                    "type": "Function"
                },
                {
                    "name": "sequence",
                    "description": "<p>Array of values to pass into the callback\n                          at each step of the phrase.</p>\n",
                    "type": "Array"
                }
            ],
            "example": [
                "\n<div><code>\nvar mySound, myPhrase, myPart;\nvar pattern = [1,0,0,2,0,2,0,0];\nvar msg = 'click to play';\n\nfunction preload() {\n  mySound = loadSound('assets/beatbox.mp3');\n}\n\nfunction setup() {\n  noStroke();\n  fill(255);\n  textAlign(CENTER);\n  masterVolume(0.1);\n\n  myPhrase = new p5.Phrase('bbox', makeSound, pattern);\n  myPart = new p5.Part();\n  myPart.addPhrase(myPhrase);\n  myPart.setBPM(60);\n}\n\nfunction draw() {\n  background(0);\n  text(msg, width/2, height/2);\n}\n\nfunction makeSound(time, playbackRate) {\n  mySound.rate(playbackRate);\n  mySound.play(time);\n}\n\nfunction mouseClicked() {\n  if (mouseX > 0 && mouseX < width && mouseY > 0 && mouseY < height) {\n    myPart.start();\n    msg = 'playing pattern';\n  }\n}\n\n</code></div>"
            ]
        },
        "p5.Part": {
            "name": "p5.Part",
            "shortname": "p5.Part",
            "classitems": [],
            "plugins": [],
            "extensions": [],
            "plugin_for": [],
            "extension_for": [],
            "module": "p5.sound",
            "submodule": "p5.sound",
            "namespace": "",
            "file": "lib/addons/p5.sound.js",
            "line": 10142,
            "description": "<p>A p5.Part plays back one or more p5.Phrases. Instantiate a part\nwith steps and tatums. By default, each step represents 1/16th note.</p>\n\n<p>See p5.Phrase for more about musical timing.</p>",
            "is_constructor": 1,
            "params": [
                {
                    "name": "steps",
                    "description": "<p>Steps in the part</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "tatums",
                    "description": "<p>Divisions of a beat (default is 1/16, a quarter note)</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "example": [
                "\n<div><code>\nvar box, drum, myPart;\nvar boxPat = [1,0,0,2,0,2,0,0];\nvar drumPat = [0,1,1,0,2,0,1,0];\nvar msg = 'click to play';\n\nfunction preload() {\n  box = loadSound('assets/beatbox.mp3');\n  drum = loadSound('assets/drum.mp3');\n}\n\nfunction setup() {\n  noStroke();\n  fill(255);\n  textAlign(CENTER);\n  masterVolume(0.1);\n\n  var boxPhrase = new p5.Phrase('box', playBox, boxPat);\n  var drumPhrase = new p5.Phrase('drum', playDrum, drumPat);\n  myPart = new p5.Part();\n  myPart.addPhrase(boxPhrase);\n  myPart.addPhrase(drumPhrase);\n  myPart.setBPM(60);\n  masterVolume(0.1);\n}\n\nfunction draw() {\n  background(0);\n  text(msg, width/2, height/2);\n}\n\nfunction playBox(time, playbackRate) {\n  box.rate(playbackRate);\n  box.play(time);\n}\n\nfunction playDrum(time, playbackRate) {\n  drum.rate(playbackRate);\n  drum.play(time);\n}\n\nfunction mouseClicked() {\n  if (mouseX > 0 && mouseX < width && mouseY > 0 && mouseY < height) {\n    myPart.start();\n    msg = 'playing part';\n  }\n}\n</code></div>"
            ]
        },
        "p5.Score": {
            "name": "p5.Score",
            "shortname": "p5.Score",
            "classitems": [],
            "plugins": [],
            "extensions": [],
            "plugin_for": [],
            "extension_for": [],
            "module": "p5.sound",
            "submodule": "p5.sound",
            "namespace": "",
            "file": "lib/addons/p5.sound.js",
            "line": 10396,
            "description": "<p>A Score consists of a series of Parts. The parts will\nbe played back in order. For example, you could have an\nA part, a B part, and a C part, and play them back in this order\n<code>new p5.Score(a, a, b, a, c)</code></p>\n",
            "is_constructor": 1,
            "params": [
                {
                    "name": "parts",
                    "description": "<p>One or multiple parts, to be played in sequence.</p>\n",
                    "type": "p5.Part",
                    "optional": true,
                    "multiple": true
                }
            ]
        },
        "p5.SoundLoop": {
            "name": "p5.SoundLoop",
            "shortname": "p5.SoundLoop",
            "classitems": [],
            "plugins": [],
            "extensions": [],
            "plugin_for": [],
            "extension_for": [],
            "module": "p5.sound",
            "submodule": "p5.sound",
            "namespace": "",
            "file": "lib/addons/p5.sound.js",
            "line": 10527,
            "description": "<p>SoundLoop</p>\n",
            "is_constructor": 1,
            "params": [
                {
                    "name": "callback",
                    "description": "<p>this function will be called on each iteration of theloop</p>\n",
                    "type": "Function"
                },
                {
                    "name": "interval",
                    "description": "<p>amount of time or beats for each iteration of the loop\n                                      defaults to 1</p>\n",
                    "type": "Number|String",
                    "optional": true
                }
            ],
            "example": [
                "\n<div><code>\nvar click;\nvar looper1;\n\nfunction preload() {\n  click = loadSound('assets/drum.mp3');\n}\n\nfunction setup() {\n  //the looper's callback is passed the timeFromNow\n  //this value should be used as a reference point from\n  //which to schedule sounds\n  looper1 = new p5.SoundLoop(function(timeFromNow){\n    click.play(timeFromNow);\n    background(255 * (looper1.iterations % 2));\n    }, 2);\n\n  //stop after 10 iteratios;\n  looper1.maxIterations = 10;\n  //start the loop\n  looper1.start();\n}\n</code></div>"
            ]
        },
        "p5.Compressor": {
            "name": "p5.Compressor",
            "shortname": "p5.Compressor",
            "classitems": [],
            "plugins": [],
            "extensions": [],
            "plugin_for": [],
            "extension_for": [],
            "module": "p5.sound",
            "submodule": "p5.sound",
            "namespace": "",
            "file": "lib/addons/p5.sound.js",
            "line": 10786,
            "description": "<p>Compressor is an audio effect class that performs dynamics compression\non an audio input source. This is a very commonly used technique in music\nand sound production. Compression creates an overall louder, richer,\nand fuller sound by lowering the volume of louds and raising that of softs.\nCompression can be used to avoid clipping (sound distortion due to\npeaks in volume) and is especially useful when many sounds are played\nat once. Compression can be used on indivudal sound sources in addition\nto the master output.</p>\n<p>This class extends <a href = \"/reference/#/p5.Effect\">p5.Effect</a>.\nMethods <a href = \"/reference/#/p5.Effect/amp\">amp()</a>, <a href = \"/reference/#/p5.Effect/chain\">chain()</a>,\n<a href = \"/reference/#/p5.Effect/drywet\">drywet()</a>, <a href = \"/reference/#/p5.Effect/connect\">connect()</a>, and\n<a href = \"/reference/#/p5.Effect/disconnect\">disconnect()</a> are available.</p>\n",
            "is_constructor": 1,
            "extends": "p5.Effect"
        },
        "p5.SoundRecorder": {
            "name": "p5.SoundRecorder",
            "shortname": "p5.SoundRecorder",
            "classitems": [],
            "plugins": [],
            "extensions": [],
            "plugin_for": [],
            "extension_for": [],
            "module": "p5.sound",
            "submodule": "p5.sound",
            "namespace": "",
            "file": "lib/addons/p5.sound.js",
            "line": 10994,
            "description": "<p>Record sounds for playback and/or to save as a .wav file.\nThe p5.SoundRecorder records all sound output from your sketch,\nor can be assigned a specific source with setInput().</p>\n<p>The record() method accepts a p5.SoundFile as a parameter.\nWhen playback is stopped (either after the given amount of time,\nor with the stop() method), the p5.SoundRecorder will send its\nrecording to that p5.SoundFile for playback.</p>",
            "is_constructor": 1,
            "example": [
                "\n<div><code>\nvar mic, recorder, soundFile;\nvar state = 0;\n\nfunction setup() {\n  background(200);\n  // create an audio in\n  mic = new p5.AudioIn();\n\n  // prompts user to enable their browser mic\n  mic.start();\n\n  // create a sound recorder\n  recorder = new p5.SoundRecorder();\n\n  // connect the mic to the recorder\n  recorder.setInput(mic);\n\n  // this sound file will be used to\n  // playback & save the recording\n  soundFile = new p5.SoundFile();\n\n  text('keyPress to record', 20, 20);\n}\n\nfunction keyPressed() {\n  // make sure user enabled the mic\n  if (state === 0 && mic.enabled) {\n\n    // record to our p5.SoundFile\n    recorder.record(soundFile);\n\n    background(255,0,0);\n    text('Recording!', 20, 20);\n    state++;\n  }\n  else if (state === 1) {\n    background(0,255,0);\n\n    // stop recorder and\n    // send result to soundFile\n    recorder.stop();\n\n    text('Stopped', 20, 20);\n    state++;\n  }\n\n  else if (state === 2) {\n    soundFile.play(); // play the result!\n    save(soundFile, 'mySound.wav');\n    state++;\n  }\n}\n</div></code>"
            ]
        },
        "p5.PeakDetect": {
            "name": "p5.PeakDetect",
            "shortname": "p5.PeakDetect",
            "classitems": [],
            "plugins": [],
            "extensions": [],
            "plugin_for": [],
            "extension_for": [],
            "module": "p5.sound",
            "submodule": "p5.sound",
            "namespace": "",
            "file": "lib/addons/p5.sound.js",
            "line": 11283,
            "description": "<p>PeakDetect works in conjunction with p5.FFT to\nlook for onsets in some or all of the frequency spectrum.\n</p>\n<p>\nTo use p5.PeakDetect, call <code>update</code> in the draw loop\nand pass in a p5.FFT object.\n</p>\n<p>\nYou can listen for a specific part of the frequency spectrum by\nsetting the range between <code>freq1</code> and <code>freq2</code>.\n</p>\n\n<p><code>threshold</code> is the threshold for detecting a peak,\nscaled between 0 and 1. It is logarithmic, so 0.1 is half as loud\nas 1.0.</p>\n\n<p>\nThe update method is meant to be run in the draw loop, and\n<b>frames</b> determines how many loops must pass before\nanother peak can be detected.\nFor example, if the frameRate() = 60, you could detect the beat of a\n120 beat-per-minute song with this equation:\n<code> framesPerPeak = 60 / (estimatedBPM / 60 );</code>\n</p>\n\n<p>\nBased on example contribtued by @b2renger, and a simple beat detection\nexplanation by <a href=\"a\nhref=&quot;http://www.airtightinteractive.com/2013/10/making-audio-reactive-visuals/&quot;\ntarget=&quot;_blank&quot;\">a\nhref=&quot;http://www.airtightinteractive.com/2013/10/making-audio-reactive-visuals/&quot;\ntarget=&quot;_blank&quot;</a>Felix Turner</a>.\n</p>",
            "is_constructor": 1,
            "params": [
                {
                    "name": "freq1",
                    "description": "<p>lowFrequency - defaults to 20Hz</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "freq2",
                    "description": "<p>highFrequency - defaults to 20000 Hz</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "threshold",
                    "description": "<p>Threshold for detecting a beat between 0 and 1\n                          scaled logarithmically where 0.1 is 1/2 the loudness\n                          of 1.0. Defaults to 0.35.</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "framesPerPeak",
                    "description": "<p>Defaults to 20.</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "example": [
                "\n<div><code>\n\nvar cnv, soundFile, fft, peakDetect;\nvar ellipseWidth = 10;\n\nfunction setup() {\n  background(0);\n  noStroke();\n  fill(255);\n  textAlign(CENTER);\n\n  soundFile = loadSound('assets/beat.mp3');\n\n  // p5.PeakDetect requires a p5.FFT\n  fft = new p5.FFT();\n  peakDetect = new p5.PeakDetect();\n\n}\n\nfunction draw() {\n  background(0);\n  text('click to play/pause', width/2, height/2);\n\n  // peakDetect accepts an fft post-analysis\n  fft.analyze();\n  peakDetect.update(fft);\n\n  if ( peakDetect.isDetected ) {\n    ellipseWidth = 50;\n  } else {\n    ellipseWidth *= 0.95;\n  }\n\n  ellipse(width/2, height/2, ellipseWidth, ellipseWidth);\n}\n\n// toggle play/stop when canvas is clicked\nfunction mouseClicked() {\n  if (mouseX > 0 && mouseX < width && mouseY > 0 && mouseY < height) {\n    if (soundFile.isPlaying() ) {\n      soundFile.stop();\n    } else {\n      soundFile.play();\n    }\n  }\n}\n</code></div>"
            ]
        },
        "p5.Gain": {
            "name": "p5.Gain",
            "shortname": "p5.Gain",
            "classitems": [],
            "plugins": [],
            "extensions": [],
            "plugin_for": [],
            "extension_for": [],
            "module": "p5.sound",
            "submodule": "p5.sound",
            "namespace": "",
            "file": "lib/addons/p5.sound.js",
            "line": 11503,
            "description": "<p>A gain node is usefull to set the relative volume of sound.\nIt&#39;s typically used to build mixers.</p>\n",
            "is_constructor": 1,
            "example": [
                "\n<div><code>\n\n // load two soundfile and crossfade beetween them\n var sound1,sound2;\n var gain1, gain2, gain3;\n\n function preload(){\n soundFormats('ogg', 'mp3');\n sound1 = loadSound('../_files/Damscray_01');\n sound2 = loadSound('../_files/beat.mp3');\n }\n\n function setup() {\n createCanvas(400,200);\n\n // create a 'master' gain to which we will connect both soundfiles\n gain3 = new p5.Gain();\n gain3.connect();\n\n // setup first sound for playing\n sound1.rate(1);\n sound1.loop();\n sound1.disconnect(); // diconnect from p5 output\n\n gain1 = new p5.Gain(); // setup a gain node\n gain1.setInput(sound1); // connect the first sound to its input\n gain1.connect(gain3); // connect its output to the 'master'\n\n sound2.rate(1);\n sound2.disconnect();\n sound2.loop();\n\n gain2 = new p5.Gain();\n gain2.setInput(sound2);\n gain2.connect(gain3);\n\n }\n\n function draw(){\n background(180);\n\n // calculate the horizontal distance beetween the mouse and the right of the screen\n var d = dist(mouseX,0,width,0);\n\n // map the horizontal position of the mouse to values useable for volume control of sound1\n var vol1 = map(mouseX,0,width,0,1);\n var vol2 = 1-vol1; // when sound1 is loud, sound2 is quiet and vice versa\n\n gain1.amp(vol1,0.5,0);\n gain2.amp(vol2,0.5,0);\n\n // map the vertical position of the mouse to values useable for 'master volume control'\n var vol3 = map(mouseY,0,height,0,1);\n gain3.amp(vol3,0.5,0);\n }\n</code></div>\n"
            ]
        },
        "p5.AudioVoice": {
            "name": "p5.AudioVoice",
            "shortname": "p5.AudioVoice",
            "classitems": [],
            "plugins": [],
            "extensions": [],
            "plugin_for": [],
            "extension_for": [],
            "module": "p5.sound",
            "submodule": "p5.sound",
            "namespace": "",
            "file": "lib/addons/p5.sound.js",
            "line": 11638,
            "description": "<p>Base class for monophonic synthesizers. Any extensions of this class\nshould follow the API and implement the methods below in order to\nremain compatible with p5.PolySynth();</p>\n",
            "is_constructor": 1
        },
        "p5.MonoSynth": {
            "name": "p5.MonoSynth",
            "shortname": "p5.MonoSynth",
            "classitems": [],
            "plugins": [],
            "extensions": [],
            "plugin_for": [],
            "extension_for": [],
            "module": "p5.sound",
            "submodule": "p5.sound",
            "namespace": "",
            "file": "lib/addons/p5.sound.js",
            "line": 11711,
            "description": "<p>An MonoSynth is used as a single voice for sound synthesis.\nThis is a class to be used in conjonction with the PolySynth\nclass. Custom synthetisers should be built inheriting from\nthis class.</p>\n",
            "is_constructor": 1,
            "example": [
                "\n<div><code>\nvar monosynth;\nvar x;\n\nfunction setup() {\n  monosynth = new p5.MonoSynth();\n  monosynth.loadPreset('simpleBass');\n  monosynth.play(45,1,x=0,1);\n  monosynth.play(49,1,x+=1,0.25);\n  monosynth.play(50,1,x+=0.25,0.25);\n  monosynth.play(49,1,x+=0.5,0.25);\n  monosynth.play(50,1,x+=0.25,0.25);\n}\n</code></div>"
            ]
        },
        "p5.PolySynth": {
            "name": "p5.PolySynth",
            "shortname": "p5.PolySynth",
            "classitems": [],
            "plugins": [],
            "extensions": [],
            "plugin_for": [],
            "extension_for": [],
            "module": "p5.sound",
            "submodule": "p5.sound",
            "namespace": "",
            "file": "lib/addons/p5.sound.js",
            "line": 11943,
            "description": "<p>An AudioVoice is used as a single voice for sound synthesis.\nThe PolySynth class holds an array of AudioVoice, and deals\nwith voices allocations, with setting notes to be played, and\nparameters to be set.</p>\n",
            "is_constructor": 1,
            "params": [
                {
                    "name": "synthVoice",
                    "description": "<p>A monophonic synth voice inheriting\n                               the AudioVoice class. Defaults to p5.MonoSynth</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "polyValue",
                    "description": "<p>Number of voices, defaults to 8;</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "example": [
                "\n<div><code>\nvar polysynth;\nfunction setup() {\n  polysynth = new p5.PolySynth();\n  polysynth.play(53,1,0,3);\n  polysynth.play(60,1,0,2.9);\n  polysynth.play(69,1,0,3);\n  polysynth.play(71,1,0,3);\n  polysynth.play(74,1,0,3);\n}\n</code></div>\n"
            ]
        },
        "p5.Distortion": {
            "name": "p5.Distortion",
            "shortname": "p5.Distortion",
            "classitems": [],
            "plugins": [],
            "extensions": [],
            "plugin_for": [],
            "extension_for": [],
            "module": "p5.sound",
            "submodule": "p5.sound",
            "namespace": "",
            "file": "lib/addons/p5.sound.js",
            "line": 12243,
            "description": "<p>A Distortion effect created with a Waveshaper Node,\nwith an approach adapted from\n<a href=\"http://stackoverflow.com/questions/22312841/waveshaper-node-in-webaudio-how-to-emulate-distortion\">Kevin Ennis</a></p>\n<p>This class extends <a href = \"/reference/#/p5.Effect\">p5.Effect</a>.\nMethods <a href = \"/reference/#/p5.Effect/amp\">amp()</a>, <a href = \"/reference/#/p5.Effect/chain\">chain()</a>,\n<a href = \"/reference/#/p5.Effect/drywet\">drywet()</a>, <a href = \"/reference/#/p5.Effect/connect\">connect()</a>, and\n<a href = \"/reference/#/p5.Effect/disconnect\">disconnect()</a> are available.</p>\n",
            "extends": "p5.Effect",
            "is_constructor": 1,
            "params": [
                {
                    "name": "amount",
                    "description": "<p>Unbounded distortion amount.\n                               Normal values range from 0-1.</p>\n",
                    "type": "Number",
                    "optional": true,
                    "optdefault": "0.25"
                },
                {
                    "name": "oversample",
                    "description": "<p>&#39;none&#39;, &#39;2x&#39;, or &#39;4x&#39;.</p>\n",
                    "type": "String",
                    "optional": true,
                    "optdefault": "'none'"
                }
            ]
        }
    },
    "elements": {},
    "classitems": [
        {
            "file": "src/color/color_conversion.js",
            "line": 10,
            "description": "<p>Conversions adapted from <a href=\"http://www.easyrgb.com/math.html\">http://www.easyrgb.com/math.html</a>.</p>\n<p>In these functions, hue is always in the range [0,1); all other components\nare in the range [0,1]. &#39;Brightness&#39; and &#39;value&#39; are used interchangeably.</p>\n",
            "class": "p5",
            "module": "Conversion",
            "submodule": "Color Conversion"
        },
        {
            "file": "src/color/color_conversion.js",
            "line": 20,
            "description": "<p>Convert an HSBA array to HSLA.</p>\n",
            "class": "p5",
            "module": "Conversion",
            "submodule": "Color Conversion"
        },
        {
            "file": "src/color/color_conversion.js",
            "line": 46,
            "description": "<p>Convert an HSBA array to RGBA.</p>\n",
            "class": "p5",
            "module": "Conversion",
            "submodule": "Color Conversion"
        },
        {
            "file": "src/color/color_conversion.js",
            "line": 101,
            "description": "<p>Convert an HSLA array to HSBA.</p>\n",
            "class": "p5",
            "module": "Conversion",
            "submodule": "Color Conversion"
        },
        {
            "file": "src/color/color_conversion.js",
            "line": 124,
            "description": "<p>Convert an HSLA array to RGBA.</p>\n<p>We need to change basis from HSLA to something that can be more easily be\nprojected onto RGBA. We will choose hue and brightness as our first two\ncomponents, and pick a convenient third one (&#39;zest&#39;) so that we don&#39;t need\nto calculate formal HSBA saturation.</p>\n",
            "class": "p5",
            "module": "Conversion",
            "submodule": "Color Conversion"
        },
        {
            "file": "src/color/color_conversion.js",
            "line": 188,
            "description": "<p>Convert an RGBA array to HSBA.</p>\n",
            "class": "p5",
            "module": "Conversion",
            "submodule": "Color Conversion"
        },
        {
            "file": "src/color/color_conversion.js",
            "line": 227,
            "description": "<p>Convert an RGBA array to HSLA.</p>\n",
            "class": "p5",
            "module": "Conversion",
            "submodule": "Color Conversion"
        },
        {
            "file": "src/color/creating_reading.js",
            "line": 16,
            "description": "<p>Extracts the alpha value from a color or pixel array.</p>\n",
            "itemtype": "method",
            "name": "alpha",
            "params": [
                {
                    "name": "color",
                    "description": "<p>p5.Color object, color components,\n                                        or CSS color</p>\n",
                    "type": "p5.Color|Number[]|String"
                }
            ],
            "return": {
                "description": "the alpha value",
                "type": "Number"
            },
            "example": [
                "\n<div>\n<code>\nnoStroke();\nvar c = color(0, 126, 255, 102);\nfill(c);\nrect(15, 15, 35, 70);\nvar value = alpha(c); // Sets 'value' to 102\nfill(value);\nrect(50, 15, 35, 70);\n</code>\n</div>"
            ],
            "alt": "Left half of canvas light blue and right half light charcoal grey.\nLeft half of canvas light purple and right half a royal blue.\nLeft half of canvas salmon pink and the right half white.\nYellow rect in middle right of canvas, with 55 pixel width and height.\nYellow ellipse in top left canvas, black ellipse in bottom right,both 80x80.\nBright fuschia rect in middle of canvas, 60 pixel width and height.\nTwo bright green rects on opposite sides of the canvas, both 45x80.\nFour blue rects in each corner of the canvas, each are 35x35.\nBright sea green rect on left and darker rect on right of canvas, both 45x80.\nDark green rect on left and light green rect on right of canvas, both 45x80.\nDark blue rect on left and light teal rect on right of canvas, both 45x80.\nblue rect on left and green on right, both with black outlines & 35x60.\nsalmon pink rect on left and black on right, both 35x60.\n4 rects, tan, brown, brownish purple and purple, with white outlines & 20x60.\nlight pastel green rect on left and dark grey rect on right, both 35x60.\nyellow rect on left and red rect on right, both with black outlines & 35x60.\ngrey canvas\ndeep pink rect on left and grey rect on right, both 35x60.",
            "class": "p5",
            "module": "Color",
            "submodule": "Creating & Reading"
        },
        {
            "file": "src/color/creating_reading.js",
            "line": 61,
            "description": "<p>Extracts the blue value from a color or pixel array.</p>\n",
            "itemtype": "method",
            "name": "blue",
            "params": [
                {
                    "name": "color",
                    "description": "<p>p5.Color object, color components,\n                                        or CSS color</p>\n",
                    "type": "p5.Color|Number[]|String"
                }
            ],
            "return": {
                "description": "the blue value",
                "type": "Number"
            },
            "example": [
                "\n<div>\n<code>\nvar c = color(175, 100, 220); // Define color 'c'\nfill(c); // Use color variable 'c' as fill color\nrect(15, 20, 35, 60); // Draw left rectangle\n\nvar blueValue = blue(c); // Get blue in 'c'\nprint(blueValue); // Prints \"220.0\"\nfill(0, 0, blueValue); // Use 'blueValue' in new fill\nrect(50, 20, 35, 60); // Draw right rectangle\n</code>\n</div>"
            ],
            "alt": "Left half of canvas light purple and right half a royal blue.",
            "class": "p5",
            "module": "Color",
            "submodule": "Creating & Reading"
        },
        {
            "file": "src/color/creating_reading.js",
            "line": 91,
            "description": "<p>Extracts the HSB brightness value from a color or pixel array.</p>\n",
            "itemtype": "method",
            "name": "brightness",
            "params": [
                {
                    "name": "color",
                    "description": "<p>p5.Color object, color components,\n                                        or CSS color</p>\n",
                    "type": "p5.Color|Number[]|String"
                }
            ],
            "return": {
                "description": "the brightness value",
                "type": "Number"
            },
            "example": [
                "\n<div>\n<code>\nnoStroke();\ncolorMode(HSB, 255);\nvar c = color(0, 126, 255);\nfill(c);\nrect(15, 20, 35, 60);\nvar value = brightness(c); // Sets 'value' to 255\nfill(value);\nrect(50, 20, 35, 60);\n</code>\n</div>"
            ],
            "alt": "Left half of canvas salmon pink and the right half white.",
            "class": "p5",
            "module": "Color",
            "submodule": "Creating & Reading"
        },
        {
            "file": "src/color/creating_reading.js",
            "line": 121,
            "description": "<p>Creates colors for storing in variables of the color datatype. The\nparameters are interpreted as RGB or HSB values depending on the\ncurrent colorMode(). The default mode is RGB values from 0 to 255\nand, therefore, the function call color(255, 204, 0) will return a\nbright yellow color.\n<br><br>\nNote that if only one value is provided to color(), it will be interpreted\nas a grayscale value. Add a second value, and it will be used for alpha\ntransparency. When three values are specified, they are interpreted as\neither RGB or HSB values. Adding a fourth value applies alpha\ntransparency.\n<br><br>\nIf a single string argument is provided, RGB, RGBA and Hex CSS color\nstrings and all named color strings are supported. In this case, an alpha\nnumber value as a second argument is not supported, the RGBA form should be\nused.</p>\n",
            "itemtype": "method",
            "name": "color",
            "return": {
                "description": "resulting color",
                "type": "p5.Color"
            },
            "example": [
                "\n<div>\n<code>\nvar c = color(255, 204, 0); // Define color 'c'\nfill(c); // Use color variable 'c' as fill color\nnoStroke(); // Don't draw a stroke around shapes\nrect(30, 20, 55, 55); // Draw rectangle\n</code>\n</div>\n\n<div>\n<code>\nvar c = color(255, 204, 0); // Define color 'c'\nfill(c); // Use color variable 'c' as fill color\nnoStroke(); // Don't draw a stroke around shapes\nellipse(25, 25, 80, 80); // Draw left circle\n\n// Using only one value with color()\n// generates a grayscale value.\nc = color(65); // Update 'c' with grayscale value\nfill(c); // Use updated 'c' as fill color\nellipse(75, 75, 80, 80); // Draw right circle\n</code>\n</div>\n\n<div>\n<code>\n// Named SVG & CSS colors may be used,\nvar c = color('magenta');\nfill(c); // Use 'c' as fill color\nnoStroke(); // Don't draw a stroke around shapes\nrect(20, 20, 60, 60); // Draw rectangle\n</code>\n</div>\n\n<div>\n<code>\n// as can hex color codes:\nnoStroke(); // Don't draw a stroke around shapes\nvar c = color('#0f0');\nfill(c); // Use 'c' as fill color\nrect(0, 10, 45, 80); // Draw rectangle\n\nc = color('#00ff00');\nfill(c); // Use updated 'c' as fill color\nrect(55, 10, 45, 80); // Draw rectangle\n</code>\n</div>\n\n<div>\n<code>\n// RGB and RGBA color strings are also supported:\n// these all set to the same color (solid blue)\nvar c;\nnoStroke(); // Don't draw a stroke around shapes\nc = color('rgb(0,0,255)');\nfill(c); // Use 'c' as fill color\nrect(10, 10, 35, 35); // Draw rectangle\n\nc = color('rgb(0%, 0%, 100%)');\nfill(c); // Use updated 'c' as fill color\nrect(55, 10, 35, 35); // Draw rectangle\n\nc = color('rgba(0, 0, 255, 1)');\nfill(c); // Use updated 'c' as fill color\nrect(10, 55, 35, 35); // Draw rectangle\n\nc = color('rgba(0%, 0%, 100%, 1)');\nfill(c); // Use updated 'c' as fill color\nrect(55, 55, 35, 35); // Draw rectangle\n</code>\n</div>\n\n<div>\n<code>\n// HSL color is also supported and can be specified\n// by value\nvar c;\nnoStroke(); // Don't draw a stroke around shapes\nc = color('hsl(160, 100%, 50%)');\nfill(c); // Use 'c' as fill color\nrect(0, 10, 45, 80); // Draw rectangle\n\nc = color('hsla(160, 100%, 50%, 0.5)');\nfill(c); // Use updated 'c' as fill color\nrect(55, 10, 45, 80); // Draw rectangle\n</code>\n</div>\n\n<div>\n<code>\n// HSB color is also supported and can be specified\n// by value\nvar c;\nnoStroke(); // Don't draw a stroke around shapes\nc = color('hsb(160, 100%, 50%)');\nfill(c); // Use 'c' as fill color\nrect(0, 10, 45, 80); // Draw rectangle\n\nc = color('hsba(160, 100%, 50%, 0.5)');\nfill(c); // Use updated 'c' as fill color\nrect(55, 10, 45, 80); // Draw rectangle\n</code>\n</div>\n\n<div>\n<code>\nvar c; // Declare color 'c'\nnoStroke(); // Don't draw a stroke around shapes\n\n// If no colorMode is specified, then the\n// default of RGB with scale of 0-255 is used.\nc = color(50, 55, 100); // Create a color for 'c'\nfill(c); // Use color variable 'c' as fill color\nrect(0, 10, 45, 80); // Draw left rect\n\ncolorMode(HSB, 100); // Use HSB with scale of 0-100\nc = color(50, 55, 100); // Update 'c' with new color\nfill(c); // Use updated 'c' as fill color\nrect(55, 10, 45, 80); // Draw right rect\n</code>\n</div>"
            ],
            "alt": "Yellow rect in middle right of canvas, with 55 pixel width and height.\nYellow ellipse in top left of canvas, black ellipse in bottom right,both 80x80.\nBright fuschia rect in middle of canvas, 60 pixel width and height.\nTwo bright green rects on opposite sides of the canvas, both 45x80.\nFour blue rects in each corner of the canvas, each are 35x35.\nBright sea green rect on left and darker rect on right of canvas, both 45x80.\nDark green rect on left and lighter green rect on right of canvas, both 45x80.\nDark blue rect on left and light teal rect on right of canvas, both 45x80.",
            "class": "p5",
            "module": "Color",
            "submodule": "Creating & Reading",
            "overloads": [
                {
                    "line": 121,
                    "params": [
                        {
                            "name": "gray",
                            "description": "<p>number specifying value between white\n                                and black.</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "alpha",
                            "description": "<p>alpha value relative to current color range\n                                (default is 0-255)</p>\n",
                            "type": "Number",
                            "optional": true
                        }
                    ],
                    "return": {
                        "description": "resulting color",
                        "type": "p5.Color"
                    }
                },
                {
                    "line": 280,
                    "params": [
                        {
                            "name": "v1",
                            "description": "<p>red or hue value relative to\n                                the current color range</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "v2",
                            "description": "<p>green or saturation value\n                                relative to the current color range</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "v3",
                            "description": "<p>blue or brightness value\n                                relative to the current color range</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "alpha",
                            "description": "",
                            "type": "Number",
                            "optional": true
                        }
                    ],
                    "return": {
                        "description": "",
                        "type": "p5.Color"
                    }
                },
                {
                    "line": 292,
                    "params": [
                        {
                            "name": "value",
                            "description": "<p>a color string</p>\n",
                            "type": "String"
                        },
                        {
                            "name": "alpha",
                            "description": "",
                            "type": "Number",
                            "optional": true
                        }
                    ],
                    "return": {
                        "description": "",
                        "type": "p5.Color"
                    }
                },
                {
                    "line": 298,
                    "params": [
                        {
                            "name": "values",
                            "description": "<p>an array containing the red,green,blue &amp;\n                                and alpha components of the color</p>\n",
                            "type": "Number[]"
                        }
                    ],
                    "return": {
                        "description": "",
                        "type": "p5.Color"
                    }
                },
                {
                    "line": 304,
                    "params": [
                        {
                            "name": "color",
                            "description": "",
                            "type": "p5.Color"
                        }
                    ],
                    "return": {
                        "description": "",
                        "type": "p5.Color"
                    }
                }
            ]
        },
        {
            "file": "src/color/creating_reading.js",
            "line": 320,
            "description": "<p>Extracts the green value from a color or pixel array.</p>\n",
            "itemtype": "method",
            "name": "green",
            "params": [
                {
                    "name": "color",
                    "description": "<p>p5.Color object, color components,\n                                        or CSS color</p>\n",
                    "type": "p5.Color|Number[]|String"
                }
            ],
            "return": {
                "description": "the green value",
                "type": "Number"
            },
            "example": [
                "\n<div>\n<code>\nvar c = color(20, 75, 200); // Define color 'c'\nfill(c); // Use color variable 'c' as fill color\nrect(15, 20, 35, 60); // Draw left rectangle\n\nvar greenValue = green(c); // Get green in 'c'\nprint(greenValue); // Print \"75.0\"\nfill(0, greenValue, 0); // Use 'greenValue' in new fill\nrect(50, 20, 35, 60); // Draw right rectangle\n</code>\n</div>"
            ],
            "alt": "blue rect on left and green on right, both with black outlines & 35x60.",
            "class": "p5",
            "module": "Color",
            "submodule": "Creating & Reading"
        },
        {
            "file": "src/color/creating_reading.js",
            "line": 351,
            "description": "<p>Extracts the hue value from a color or pixel array.</p>\n<p>Hue exists in both HSB and HSL. This function will return the\nHSB-normalized hue when supplied with an HSB color object (or when supplied\nwith a pixel array while the color mode is HSB), but will default to the\nHSL-normalized hue otherwise. (The values will only be different if the\nmaximum hue setting for each system is different.)</p>\n",
            "itemtype": "method",
            "name": "hue",
            "params": [
                {
                    "name": "color",
                    "description": "<p>p5.Color object, color components,\n                                        or CSS color</p>\n",
                    "type": "p5.Color|Number[]|String"
                }
            ],
            "return": {
                "description": "the hue",
                "type": "Number"
            },
            "example": [
                "\n<div>\n<code>\nnoStroke();\ncolorMode(HSB, 255);\nvar c = color(0, 126, 255);\nfill(c);\nrect(15, 20, 35, 60);\nvar value = hue(c); // Sets 'value' to \"0\"\nfill(value);\nrect(50, 20, 35, 60);\n</code>\n</div>"
            ],
            "alt": "salmon pink rect on left and black on right, both 35x60.",
            "class": "p5",
            "module": "Color",
            "submodule": "Creating & Reading"
        },
        {
            "file": "src/color/creating_reading.js",
            "line": 388,
            "description": "<p>Blends two colors to find a third color somewhere between them. The amt\nparameter is the amount to interpolate between the two values where 0.0\nequal to the first color, 0.1 is very near the first color, 0.5 is halfway\nin between, etc. An amount below 0 will be treated as 0. Likewise, amounts\nabove 1 will be capped at 1. This is different from the behavior of lerp(),\nbut necessary because otherwise numbers outside the range will produce\nstrange and unexpected colors.\n<br><br>\nThe way that colours are interpolated depends on the current color mode.</p>\n",
            "itemtype": "method",
            "name": "lerpColor",
            "params": [
                {
                    "name": "c1",
                    "description": "<p>interpolate from this color</p>\n",
                    "type": "p5.Color"
                },
                {
                    "name": "c2",
                    "description": "<p>interpolate to this color</p>\n",
                    "type": "p5.Color"
                },
                {
                    "name": "amt",
                    "description": "<p>number between 0 and 1</p>\n",
                    "type": "Number"
                }
            ],
            "return": {
                "description": "interpolated color",
                "type": "p5.Color"
            },
            "example": [
                "\n<div>\n<code>\ncolorMode(RGB);\nstroke(255);\nbackground(51);\nvar from = color(218, 165, 32);\nvar to = color(72, 61, 139);\ncolorMode(RGB); // Try changing to HSB.\nvar interA = lerpColor(from, to, 0.33);\nvar interB = lerpColor(from, to, 0.66);\nfill(from);\nrect(10, 20, 20, 60);\nfill(interA);\nrect(30, 20, 20, 60);\nfill(interB);\nrect(50, 20, 20, 60);\nfill(to);\nrect(70, 20, 20, 60);\n</code>\n</div>"
            ],
            "alt": "4 rects one tan, brown, brownish purple, purple, with white outlines & 20x60",
            "class": "p5",
            "module": "Color",
            "submodule": "Creating & Reading"
        },
        {
            "file": "src/color/creating_reading.js",
            "line": 485,
            "description": "<p>Extracts the HSL lightness value from a color or pixel array.</p>\n",
            "itemtype": "method",
            "name": "lightness",
            "params": [
                {
                    "name": "color",
                    "description": "<p>p5.Color object, color components,\n                                        or CSS color</p>\n",
                    "type": "p5.Color|Number[]|String"
                }
            ],
            "return": {
                "description": "the lightness",
                "type": "Number"
            },
            "example": [
                "\n<div>\n<code>\nnoStroke();\ncolorMode(HSL);\nvar c = color(156, 100, 50, 1);\nfill(c);\nrect(15, 20, 35, 60);\nvar value = lightness(c); // Sets 'value' to 50\nfill(value);\nrect(50, 20, 35, 60);\n</code>\n</div>"
            ],
            "alt": "light pastel green rect on left and dark grey rect on right, both 35x60.",
            "class": "p5",
            "module": "Color",
            "submodule": "Creating & Reading"
        },
        {
            "file": "src/color/creating_reading.js",
            "line": 515,
            "description": "<p>Extracts the red value from a color or pixel array.</p>\n",
            "itemtype": "method",
            "name": "red",
            "params": [
                {
                    "name": "color",
                    "description": "<p>p5.Color object, color components,\n                                        or CSS color</p>\n",
                    "type": "p5.Color|Number[]|String"
                }
            ],
            "return": {
                "description": "the red value",
                "type": "Number"
            },
            "example": [
                "\n<div>\n<code>\nvar c = color(255, 204, 0); // Define color 'c'\nfill(c); // Use color variable 'c' as fill color\nrect(15, 20, 35, 60); // Draw left rectangle\n\nvar redValue = red(c); // Get red in 'c'\nprint(redValue); // Print \"255.0\"\nfill(redValue, 0, 0); // Use 'redValue' in new fill\nrect(50, 20, 35, 60); // Draw right rectangle\n</code>\n</div>\n\n<div>\n<code>\ncolorMode(RGB, 255);\nvar c = color(127, 255, 0);\ncolorMode(RGB, 1);\nvar myColor = red(c);\nprint(myColor);\n</code>\n</div>"
            ],
            "alt": "yellow rect on left and red rect on right, both with black outlines and 35x60.\ngrey canvas",
            "class": "p5",
            "module": "Color",
            "submodule": "Creating & Reading"
        },
        {
            "file": "src/color/creating_reading.js",
            "line": 555,
            "description": "<p>Extracts the saturation value from a color or pixel array.</p>\n<p>Saturation is scaled differently in HSB and HSL. This function will return\nthe HSB saturation when supplied with an HSB color object (or when supplied\nwith a pixel array while the color mode is HSB), but will default to the\nHSL saturation otherwise.</p>\n",
            "itemtype": "method",
            "name": "saturation",
            "params": [
                {
                    "name": "color",
                    "description": "<p>p5.Color object, color components,\n                                        or CSS color</p>\n",
                    "type": "p5.Color|Number[]|String"
                }
            ],
            "return": {
                "description": "the saturation value",
                "type": "Number"
            },
            "example": [
                "\n<div>\n<code>\nnoStroke();\ncolorMode(HSB, 255);\nvar c = color(0, 126, 255);\nfill(c);\nrect(15, 20, 35, 60);\nvar value = saturation(c); // Sets 'value' to 126\nfill(value);\nrect(50, 20, 35, 60);\n</code>\n</div>"
            ],
            "alt": "deep pink rect on left and grey rect on right, both 35x60.",
            "class": "p5",
            "module": "Color",
            "submodule": "Creating & Reading"
        },
        {
            "file": "src/color/p5.Color.js",
            "line": 54,
            "itemtype": "method",
            "name": "toString",
            "return": {
                "description": "",
                "type": "String"
            },
            "example": [
                "\n<div>\n<code>\nvar myColor;\nfunction setup() {\n  createCanvas(200, 200);\n  stroke(255);\n  myColor = color(100, 100, 250);\n  fill(myColor);\n}\n\nfunction draw() {\n  text(myColor.toString(), 10, 10);\n}\n</code>\n</div>"
            ],
            "alt": "canvas with text representation of color",
            "class": "p5.Color",
            "module": "Color",
            "submodule": "Creating & Reading"
        },
        {
            "file": "src/color/p5.Color.js",
            "line": 83,
            "itemtype": "method",
            "name": "setRed",
            "params": [
                {
                    "name": "red",
                    "description": "<p>the new red value</p>\n",
                    "type": "Number"
                }
            ],
            "example": [
                "\n<div>\n<code>\nvar backgroundColor;\n\nfunction setup() {\n  backgroundColor = color(100, 50, 150);\n}\n\nfunction draw() {\n  backgroundColor.setRed(128 + 128 * sin(millis() / 1000));\n  background(backgroundColor);\n}\n</code>\n</div>"
            ],
            "alt": "canvas with gradually changing background color",
            "class": "p5.Color",
            "module": "Color",
            "submodule": "Creating & Reading"
        },
        {
            "file": "src/color/p5.Color.js",
            "line": 110,
            "itemtype": "method",
            "name": "setGreen",
            "params": [
                {
                    "name": "green",
                    "description": "<p>the new green value</p>\n",
                    "type": "Number"
                }
            ],
            "example": [
                "\n<div>\n<code>\nvar backgroundColor;\n\nfunction setup() {\n  backgroundColor = color(100, 50, 150);\n}\n\nfunction draw() {\n  backgroundColor.setGreen(128 + 128 * sin(millis() / 1000));\n  background(backgroundColor);\n}\n</code>\n</div>"
            ],
            "alt": "canvas with gradually changing background color",
            "class": "p5.Color",
            "module": "Color",
            "submodule": "Creating & Reading"
        },
        {
            "file": "src/color/p5.Color.js",
            "line": 137,
            "itemtype": "method",
            "name": "setBlue",
            "params": [
                {
                    "name": "blue",
                    "description": "<p>the new blue value</p>\n",
                    "type": "Number"
                }
            ],
            "example": [
                "\n<div>\n<code>\nvar backgroundColor;\n\nfunction setup() {\n  backgroundColor = color(100, 50, 150);\n}\n\nfunction draw() {\n  backgroundColor.setBlue(128 + 128 * sin(millis() / 1000));\n  background(backgroundColor);\n}\n</code>\n</div>"
            ],
            "alt": "canvas with gradually changing background color",
            "class": "p5.Color",
            "module": "Color",
            "submodule": "Creating & Reading"
        },
        {
            "file": "src/color/p5.Color.js",
            "line": 164,
            "itemtype": "method",
            "name": "setAlpha",
            "params": [
                {
                    "name": "alpha",
                    "description": "<p>the new alpha value</p>\n",
                    "type": "Number"
                }
            ],
            "example": [
                "\n<div>\n<code>\nvar squareColor;\n\nfunction setup() {\n  ellipseMode(CORNERS);\n  strokeWeight(4);\n  squareColor = color(100, 50, 150);\n}\n\nfunction draw() {\n  background(255);\n\n  noFill();\n  stroke(0);\n  ellipse(10, 10, width - 10, height - 10);\n\n  squareColor.setAlpha(128 + 128 * sin(millis() / 1000));\n  fill(squareColor);\n  noStroke();\n  rect(13, 13, width - 26, height - 26);\n}\n</code>\n</div>"
            ],
            "alt": "circle behind a square with gradually changing opacity",
            "class": "p5.Color",
            "module": "Color",
            "submodule": "Creating & Reading"
        },
        {
            "file": "src/color/p5.Color.js",
            "line": 242,
            "description": "<p>Hue is the same in HSB and HSL, but the maximum value may be different.\nThis function will return the HSB-normalized saturation when supplied with\nan HSB color object, but will default to the HSL-normalized saturation\notherwise.</p>\n",
            "class": "p5.Color",
            "module": "Color",
            "submodule": "Creating & Reading"
        },
        {
            "file": "src/color/p5.Color.js",
            "line": 273,
            "description": "<p>Saturation is scaled differently in HSB and HSL. This function will return\nthe HSB saturation when supplied with an HSB color object, but will default\nto the HSL saturation otherwise.</p>\n",
            "class": "p5.Color",
            "module": "Color",
            "submodule": "Creating & Reading"
        },
        {
            "file": "src/color/p5.Color.js",
            "line": 292,
            "description": "<p>CSS named colors.</p>\n",
            "class": "p5.Color",
            "module": "Color",
            "submodule": "Creating & Reading"
        },
        {
            "file": "src/color/p5.Color.js",
            "line": 445,
            "description": "<p>These regular expressions are used to build up the patterns for matching\nviable CSS color strings: fragmenting the regexes in this way increases the\nlegibility and comprehensibility of the code.</p>\n<p>Note that RGB values of .9 are not parsed by IE, but are supported here for\ncolor string consistency.</p>\n",
            "class": "p5.Color",
            "module": "Color",
            "submodule": "Creating & Reading"
        },
        {
            "file": "src/color/p5.Color.js",
            "line": 458,
            "description": "<p>Full color string patterns. The capture groups are necessary.</p>\n",
            "class": "p5.Color",
            "module": "Color",
            "submodule": "Creating & Reading"
        },
        {
            "file": "src/color/p5.Color.js",
            "line": 812,
            "description": "<p>For HSB and HSL, interpret the gray level as a brightness/lightness\nvalue (they are equivalent when chroma is zero). For RGB, normalize the\ngray level according to the blue maximum.</p>\n",
            "class": "p5.Color",
            "module": "Color",
            "submodule": "Creating & Reading"
        },
        {
            "file": "src/color/setting.js",
            "line": 15,
            "description": "<p>The background() function sets the color used for the background of the\np5.js canvas. The default background is light gray. This function is\ntypically used within draw() to clear the display window at the beginning\nof each frame, but it can be used inside setup() to set the background on\nthe first frame of animation or if the background need only be set once.\n<br><br>\nThe color is either specified in terms of the RGB, HSB, or HSL color\ndepending on the current colorMode. (The default color space is RGB, with\neach value in the range from 0 to 255). The alpha range by default is also 0 to 255.\n<br><br>\nIf a single string argument is provided, RGB, RGBA and Hex CSS color strings\nand all named color strings are supported. In this case, an alpha number\nvalue as a second argument is not supported, the RGBA form should be used.\n<br><br>\nA p5.Color object can also be provided to set the background color.\n<br><br>\nA p5.Image can also be provided to set the background iamge.</p>\n",
            "itemtype": "method",
            "name": "background",
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\n// Grayscale integer value\nbackground(51);\n</code>\n</div>\n\n<div>\n<code>\n// R, G & B integer values\nbackground(255, 204, 0);\n</code>\n</div>\n\n<div>\n<code>\n// H, S & B integer values\ncolorMode(HSB);\nbackground(255, 204, 100);\n</code>\n</div>\n\n<div>\n<code>\n// Named SVG/CSS color string\nbackground('red');\n</code>\n</div>\n\n<div>\n<code>\n// three-digit hexadecimal RGB notation\nbackground('#fae');\n</code>\n</div>\n\n<div>\n<code>\n// six-digit hexadecimal RGB notation\nbackground('#222222');\n</code>\n</div>\n\n<div>\n<code>\n// integer RGB notation\nbackground('rgb(0,255,0)');\n</code>\n</div>\n\n<div>\n<code>\n// integer RGBA notation\nbackground('rgba(0,255,0, 0.25)');\n</code>\n</div>\n\n<div>\n<code>\n// percentage RGB notation\nbackground('rgb(100%,0%,10%)');\n</code>\n</div>\n\n<div>\n<code>\n// percentage RGBA notation\nbackground('rgba(100%,0%,100%,0.5)');\n</code>\n</div>\n\n<div>\n<code>\n// p5 Color object\nbackground(color(0, 0, 255));\n</code>\n</div>"
            ],
            "alt": "canvas with darkest charcoal grey background.\ncanvas with yellow background.\ncanvas with royal blue background.\ncanvas with red background.\ncanvas with pink background.\ncanvas with black background.\ncanvas with bright green background.\ncanvas with soft green background.\ncanvas with red background.\ncanvas with light purple background.\ncanvas with blue background.",
            "class": "p5",
            "module": "Color",
            "submodule": "Setting",
            "overloads": [
                {
                    "line": 15,
                    "params": [
                        {
                            "name": "color",
                            "description": "<p>any value created by the color() function</p>\n",
                            "type": "p5.Color"
                        }
                    ],
                    "chainable": 1
                },
                {
                    "line": 131,
                    "params": [
                        {
                            "name": "colorstring",
                            "description": "<p>color string, possible formats include: integer\n                        rgb() or rgba(), percentage rgb() or rgba(),\n                        3-digit hex, 6-digit hex</p>\n",
                            "type": "String"
                        },
                        {
                            "name": "a",
                            "description": "<p>opacity of the background relative to current\n                            color range (default is 0-255)</p>\n",
                            "type": "Number",
                            "optional": true
                        }
                    ],
                    "chainable": 1
                },
                {
                    "line": 141,
                    "params": [
                        {
                            "name": "gray",
                            "description": "<p>specifies a value between white and black</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "a",
                            "description": "",
                            "type": "Number",
                            "optional": true
                        }
                    ],
                    "chainable": 1
                },
                {
                    "line": 148,
                    "params": [
                        {
                            "name": "v1",
                            "description": "<p>red or hue value (depending on the current color\n                       mode)</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "v2",
                            "description": "<p>green or saturation value (depending on the current\n                       color mode)</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "v3",
                            "description": "<p>blue or brightness value (depending on the current\n                       color mode)</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "a",
                            "description": "",
                            "type": "Number",
                            "optional": true
                        }
                    ],
                    "chainable": 1
                },
                {
                    "line": 160,
                    "params": [
                        {
                            "name": "values",
                            "description": "<p>an array containing the red,green,blue &amp;\n                                and alpha components of the color</p>\n",
                            "type": "Number[]"
                        }
                    ],
                    "chainable": 1
                },
                {
                    "line": 167,
                    "params": [
                        {
                            "name": "image",
                            "description": "<p>image created with loadImage() or createImage(),\n                            to set as background\n                            (must be same size as the sketch window)</p>\n",
                            "type": "p5.Image"
                        },
                        {
                            "name": "a",
                            "description": "",
                            "type": "Number",
                            "optional": true
                        }
                    ],
                    "chainable": 1
                }
            ]
        },
        {
            "file": "src/color/setting.js",
            "line": 185,
            "description": "<p>Clears the pixels within a buffer. This function only works on p5.Canvas\nobjects created with the createCanvas() function; it won&#39;t work with the\nmain display window. Unlike the main graphics context, pixels in\nadditional graphics areas created with createGraphics() can be entirely\nor partially transparent. This function clears everything to make all of\nthe pixels 100% transparent.</p>\n",
            "itemtype": "method",
            "name": "clear",
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\n// Clear the screen on mouse press.\nfunction setup() {\n  createCanvas(100, 100);\n}\n\nfunction draw() {\n  ellipse(mouseX, mouseY, 20, 20);\n}\n\nfunction mousePressed() {\n  clear();\n}\n</code>\n</div>"
            ],
            "alt": "20x20 white ellipses are continually drawn at mouse x and y coordinates.",
            "class": "p5",
            "module": "Color",
            "submodule": "Setting"
        },
        {
            "file": "src/color/setting.js",
            "line": 223,
            "description": "<p>colorMode() changes the way p5.js interprets color data. By default, the\nparameters for fill(), stroke(), background(), and color() are defined by\nvalues between 0 and 255 using the RGB color model. This is equivalent to\nsetting colorMode(RGB, 255). Setting colorMode(HSB) lets you use the HSB\nsystem instead. By default, this is colorMode(HSB, 360, 100, 100, 1). You\ncan also use HSL.\n<br><br>\nNote: existing color objects remember the mode that they were created in,\nso you can change modes as you like without affecting their appearance.</p>\n",
            "itemtype": "method",
            "name": "colorMode",
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\nnoStroke();\ncolorMode(RGB, 100);\nfor (var i = 0; i < 100; i++) {\n  for (var j = 0; j < 100; j++) {\n    stroke(i, j, 0);\n    point(i, j);\n  }\n}\n</code>\n</div>\n\n<div>\n<code>\nnoStroke();\ncolorMode(HSB, 100);\nfor (var i = 0; i < 100; i++) {\n  for (var j = 0; j < 100; j++) {\n    stroke(i, j, 100);\n    point(i, j);\n  }\n}\n</code>\n</div>\n\n<div>\n<code>\ncolorMode(RGB, 255);\nvar c = color(127, 255, 0);\n\ncolorMode(RGB, 1);\nvar myColor = c._getRed();\ntext(myColor, 10, 10, 80, 80);\n</code>\n</div>\n\n<div>\n<code>\nnoFill();\ncolorMode(RGB, 255, 255, 255, 1);\nbackground(255);\n\nstrokeWeight(4);\nstroke(255, 0, 10, 0.3);\nellipse(40, 40, 50, 50);\nellipse(50, 50, 40, 40);\n</code>\n</div>"
            ],
            "alt": "Green to red gradient from bottom L to top R. shading originates from top left.\nRainbow gradient from left to right. Brightness increasing to white at top.\nunknown image.\n50x50 ellipse at middle L & 40x40 ellipse at center. Transluscent pink outlines.",
            "class": "p5",
            "module": "Color",
            "submodule": "Setting",
            "overloads": [
                {
                    "line": 223,
                    "params": [
                        {
                            "name": "mode",
                            "description": "<p>either RGB, HSB or HSL, corresponding to\n                         Red/Green/Blue and Hue/Saturation/Brightness\n                         (or Lightness)</p>\n",
                            "type": "Constant"
                        },
                        {
                            "name": "max",
                            "description": "<p>range for all values</p>\n",
                            "type": "Number",
                            "optional": true
                        }
                    ],
                    "chainable": 1
                },
                {
                    "line": 300,
                    "params": [
                        {
                            "name": "mode",
                            "description": "",
                            "type": "Constant"
                        },
                        {
                            "name": "max1",
                            "description": "<p>range for the red or hue depending on the\n                             current color mode</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "max2",
                            "description": "<p>range for the green or saturation depending\n                             on the current color mode</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "max3",
                            "description": "<p>range for the blue or brightness/lighntess\n                             depending on the current color mode</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "maxA",
                            "description": "<p>range for the alpha</p>\n",
                            "type": "Number",
                            "optional": true
                        }
                    ],
                    "chainable": 1
                }
            ]
        },
        {
            "file": "src/color/setting.js",
            "line": 344,
            "description": "<p>Sets the color used to fill shapes. For example, if you run\nfill(204, 102, 0), all subsequent shapes will be filled with orange. This\ncolor is either specified in terms of the RGB or HSB color depending on\nthe current colorMode(). (The default color space is RGB, with each value\nin the range from 0 to 255). The alpha range by default is also 0 to 255.\n<br><br>\nIf a single string argument is provided, RGB, RGBA and Hex CSS color strings\nand all named color strings are supported. In this case, an alpha number\nvalue as a second argument is not supported, the RGBA form should be used.\n<br><br>\nA p5 Color object can also be provided to set the fill color.</p>\n",
            "itemtype": "method",
            "name": "fill",
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\n// Grayscale integer value\nfill(51);\nrect(20, 20, 60, 60);\n</code>\n</div>\n\n<div>\n<code>\n// R, G & B integer values\nfill(255, 204, 0);\nrect(20, 20, 60, 60);\n</code>\n</div>\n\n<div>\n<code>\n// H, S & B integer values\ncolorMode(HSB);\nfill(255, 204, 100);\nrect(20, 20, 60, 60);\n</code>\n</div>\n\n<div>\n<code>\n// Named SVG/CSS color string\nfill('red');\nrect(20, 20, 60, 60);\n</code>\n</div>\n\n<div>\n<code>\n// three-digit hexadecimal RGB notation\nfill('#fae');\nrect(20, 20, 60, 60);\n</code>\n</div>\n\n<div>\n<code>\n// six-digit hexadecimal RGB notation\nfill('#222222');\nrect(20, 20, 60, 60);\n</code>\n</div>\n\n<div>\n<code>\n// integer RGB notation\nfill('rgb(0,255,0)');\nrect(20, 20, 60, 60);\n</code>\n</div>\n\n<div>\n<code>\n// integer RGBA notation\nfill('rgba(0,255,0, 0.25)');\nrect(20, 20, 60, 60);\n</code>\n</div>\n\n<div>\n<code>\n// percentage RGB notation\nfill('rgb(100%,0%,10%)');\nrect(20, 20, 60, 60);\n</code>\n</div>\n\n<div>\n<code>\n// percentage RGBA notation\nfill('rgba(100%,0%,100%,0.5)');\nrect(20, 20, 60, 60);\n</code>\n</div>\n\n<div>\n<code>\n// p5 Color object\nfill(color(0, 0, 255));\nrect(20, 20, 60, 60);\n</code>\n</div>"
            ],
            "alt": "60x60 dark charcoal grey rect with black outline in center of canvas.\n60x60 yellow rect with black outline in center of canvas.\n60x60 royal blue rect with black outline in center of canvas.\n60x60 red rect with black outline in center of canvas.\n60x60 pink rect with black outline in center of canvas.\n60x60 black rect with black outline in center of canvas.\n60x60 light green rect with black outline in center of canvas.\n60x60 soft green rect with black outline in center of canvas.\n60x60 red rect with black outline in center of canvas.\n60x60 dark fushcia rect with black outline in center of canvas.\n60x60 blue rect with black outline in center of canvas.",
            "class": "p5",
            "module": "Color",
            "submodule": "Setting",
            "overloads": [
                {
                    "line": 344,
                    "params": [
                        {
                            "name": "v1",
                            "description": "<p>red or hue value relative to\n                                the current color range</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "v2",
                            "description": "<p>green or saturation value\n                                relative to the current color range</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "v3",
                            "description": "<p>blue or brightness value\n                                relative to the current color range</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "alpha",
                            "description": "",
                            "type": "Number",
                            "optional": true
                        }
                    ],
                    "chainable": 1
                },
                {
                    "line": 469,
                    "params": [
                        {
                            "name": "value",
                            "description": "<p>a color string</p>\n",
                            "type": "String"
                        },
                        {
                            "name": "alpha",
                            "description": "",
                            "type": "Number",
                            "optional": true
                        }
                    ],
                    "chainable": 1
                },
                {
                    "line": 476,
                    "params": [
                        {
                            "name": "values",
                            "description": "<p>an array containing the red,green,blue &amp;\n                                and alpha components of the color</p>\n",
                            "type": "Number[]"
                        }
                    ],
                    "chainable": 1
                },
                {
                    "line": 483,
                    "params": [
                        {
                            "name": "color",
                            "description": "<p>the fill color</p>\n",
                            "type": "p5.Color"
                        }
                    ],
                    "chainable": 1
                }
            ]
        },
        {
            "file": "src/color/setting.js",
            "line": 495,
            "description": "<p>Disables filling geometry. If both noStroke() and noFill() are called,\nnothing will be drawn to the screen.</p>\n",
            "itemtype": "method",
            "name": "noFill",
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\nrect(15, 10, 55, 55);\nnoFill();\nrect(20, 20, 60, 60);\n</code>\n</div>\n\n<div modernizr='webgl'>\n<code>\nfunction setup() {\n  createCanvas(100, 100, WEBGL);\n}\n\nfunction draw() {\n  background(0);\n  noFill();\n  stroke(100, 100, 240);\n  rotateX(frameCount * 0.01);\n  rotateY(frameCount * 0.01);\n  box(45, 45, 45);\n}\n</code>\n</div>"
            ],
            "alt": "white rect top middle and noFill rect center. Both 60x60 with black outlines.\nblack canvas with purple cube wireframe spinning",
            "class": "p5",
            "module": "Color",
            "submodule": "Setting"
        },
        {
            "file": "src/color/setting.js",
            "line": 536,
            "description": "<p>Disables drawing the stroke (outline). If both noStroke() and noFill()\nare called, nothing will be drawn to the screen.</p>\n",
            "itemtype": "method",
            "name": "noStroke",
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\nnoStroke();\nrect(20, 20, 60, 60);\n</code>\n</div>\n\n<div modernizr='webgl'>\n<code>\nfunction setup() {\n  createCanvas(100, 100, WEBGL);\n}\n\nfunction draw() {\n  background(0);\n  noStroke();\n  fill(240, 150, 150);\n  rotateX(frameCount * 0.01);\n  rotateY(frameCount * 0.01);\n  box(45, 45, 45);\n}\n</code>\n</div>"
            ],
            "alt": "60x60 white rect at center. no outline.\nblack canvas with pink cube spinning",
            "class": "p5",
            "module": "Color",
            "submodule": "Setting"
        },
        {
            "file": "src/color/setting.js",
            "line": 576,
            "description": "<p>Sets the color used to draw lines and borders around shapes. This color\nis either specified in terms of the RGB or HSB color depending on the\ncurrent colorMode() (the default color space is RGB, with each value in\nthe range from 0 to 255). The alpha range by default is also 0 to 255.\n<br><br>\nIf a single string argument is provided, RGB, RGBA and Hex CSS color\nstrings and all named color strings are supported. In this case, an alpha\nnumber value as a second argument is not supported, the RGBA form should be\nused.\n<br><br>\nA p5 Color object can also be provided to set the stroke color.</p>\n",
            "itemtype": "method",
            "name": "stroke",
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\n// Grayscale integer value\nstrokeWeight(4);\nstroke(51);\nrect(20, 20, 60, 60);\n</code>\n</div>\n\n<div>\n<code>\n// R, G & B integer values\nstroke(255, 204, 0);\nstrokeWeight(4);\nrect(20, 20, 60, 60);\n</code>\n</div>\n\n<div>\n<code>\n// H, S & B integer values\ncolorMode(HSB);\nstrokeWeight(4);\nstroke(255, 204, 100);\nrect(20, 20, 60, 60);\n</code>\n</div>\n\n<div>\n<code>\n// Named SVG/CSS color string\nstroke('red');\nstrokeWeight(4);\nrect(20, 20, 60, 60);\n</code>\n</div>\n\n<div>\n<code>\n// three-digit hexadecimal RGB notation\nstroke('#fae');\nstrokeWeight(4);\nrect(20, 20, 60, 60);\n</code>\n</div>\n\n<div>\n<code>\n// six-digit hexadecimal RGB notation\nstroke('#222222');\nstrokeWeight(4);\nrect(20, 20, 60, 60);\n</code>\n</div>\n\n<div>\n<code>\n// integer RGB notation\nstroke('rgb(0,255,0)');\nstrokeWeight(4);\nrect(20, 20, 60, 60);\n</code>\n</div>\n\n<div>\n<code>\n// integer RGBA notation\nstroke('rgba(0,255,0,0.25)');\nstrokeWeight(4);\nrect(20, 20, 60, 60);\n</code>\n</div>\n\n<div>\n<code>\n// percentage RGB notation\nstroke('rgb(100%,0%,10%)');\nstrokeWeight(4);\nrect(20, 20, 60, 60);\n</code>\n</div>\n\n<div>\n<code>\n// percentage RGBA notation\nstroke('rgba(100%,0%,100%,0.5)');\nstrokeWeight(4);\nrect(20, 20, 60, 60);\n</code>\n</div>\n\n<div>\n<code>\n// p5 Color object\nstroke(color(0, 0, 255));\nstrokeWeight(4);\nrect(20, 20, 60, 60);\n</code>\n</div>"
            ],
            "alt": "60x60 white rect at center. Dark charcoal grey outline.\n60x60 white rect at center. Yellow outline.\n60x60 white rect at center. Royal blue outline.\n60x60 white rect at center. Red outline.\n60x60 white rect at center. Pink outline.\n60x60 white rect at center. Black outline.\n60x60 white rect at center. Bright green outline.\n60x60 white rect at center. Soft green outline.\n60x60 white rect at center. Red outline.\n60x60 white rect at center. Dark fushcia outline.\n60x60 white rect at center. Blue outline.",
            "class": "p5",
            "module": "Color",
            "submodule": "Setting",
            "overloads": [
                {
                    "line": 576,
                    "params": [
                        {
                            "name": "v1",
                            "description": "<p>red or hue value relative to\n                                the current color range</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "v2",
                            "description": "<p>green or saturation value\n                                relative to the current color range</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "v3",
                            "description": "<p>blue or brightness value\n                                relative to the current color range</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "alpha",
                            "description": "",
                            "type": "Number",
                            "optional": true
                        }
                    ],
                    "chainable": 1
                },
                {
                    "line": 715,
                    "params": [
                        {
                            "name": "value",
                            "description": "<p>a color string</p>\n",
                            "type": "String"
                        },
                        {
                            "name": "alpha",
                            "description": "",
                            "type": "Number",
                            "optional": true
                        }
                    ],
                    "chainable": 1
                },
                {
                    "line": 722,
                    "params": [
                        {
                            "name": "values",
                            "description": "<p>an array containing the red,green,blue &amp;\n                                and alpha components of the color</p>\n",
                            "type": "Number[]"
                        }
                    ],
                    "chainable": 1
                },
                {
                    "line": 729,
                    "params": [
                        {
                            "name": "color",
                            "description": "<p>the stroke color</p>\n",
                            "type": "p5.Color"
                        }
                    ],
                    "chainable": 1
                }
            ]
        },
        {
            "file": "src/core/2d_primitives.js",
            "line": 16,
            "description": "<p>Draw an arc to the screen. If called with only x, y, w, h, start, and\nstop, the arc will be drawn and filled as an open pie segment. If a mode parameter is provided, the arc\nwill be filled like an open semi-circle (OPEN) , a closed semi-circle (CHORD), or as a closed pie segment (PIE). The\norigin may be changed with the ellipseMode() function.<br><br>\nNote that drawing a full circle (ex: 0 to TWO_PI) will appear blank\nbecause 0 and TWO_PI are the same position on the unit circle. The\nbest way to handle this is by using the ellipse() function instead\nto create a closed ellipse, and to use the arc() function\nonly to draw parts of an ellipse.</p>\n",
            "itemtype": "method",
            "name": "arc",
            "params": [
                {
                    "name": "x",
                    "description": "<p>x-coordinate of the arc&#39;s ellipse</p>\n",
                    "type": "Number"
                },
                {
                    "name": "y",
                    "description": "<p>y-coordinate of the arc&#39;s ellipse</p>\n",
                    "type": "Number"
                },
                {
                    "name": "w",
                    "description": "<p>width of the arc&#39;s ellipse by default</p>\n",
                    "type": "Number"
                },
                {
                    "name": "h",
                    "description": "<p>height of the arc&#39;s ellipse by default</p>\n",
                    "type": "Number"
                },
                {
                    "name": "start",
                    "description": "<p>angle to start the arc, specified in radians</p>\n",
                    "type": "Number"
                },
                {
                    "name": "stop",
                    "description": "<p>angle to stop the arc, specified in radians</p>\n",
                    "type": "Number"
                },
                {
                    "name": "mode",
                    "description": "<p>optional parameter to determine the way of drawing\n                        the arc. either CHORD, PIE or OPEN</p>\n",
                    "type": "Constant",
                    "optional": true
                }
            ],
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\narc(50, 55, 50, 50, 0, HALF_PI);\nnoFill();\narc(50, 55, 60, 60, HALF_PI, PI);\narc(50, 55, 70, 70, PI, PI + QUARTER_PI);\narc(50, 55, 80, 80, PI + QUARTER_PI, TWO_PI);\n</code>\n</div>\n\n<div>\n<code>\narc(50, 50, 80, 80, 0, PI + QUARTER_PI);\n</code>\n</div>\n\n<div>\n<code>\narc(50, 50, 80, 80, 0, PI + QUARTER_PI, OPEN);\n</code>\n</div>\n\n<div>\n<code>\narc(50, 50, 80, 80, 0, PI + QUARTER_PI, CHORD);\n</code>\n</div>\n\n<div>\n<code>\narc(50, 50, 80, 80, 0, PI + QUARTER_PI, PIE);\n</code>\n</div>"
            ],
            "alt": "shattered outline of an ellipse with a quarter of a white circle bottom-right.\nwhite ellipse with top right quarter missing.\nwhite ellipse with black outline with top right missing.\nwhite ellipse with top right missing with black outline around shape.\nwhite ellipse with top right quarter missing with black outline around the shape.",
            "class": "p5",
            "module": "Shape",
            "submodule": "2D Primitives"
        },
        {
            "file": "src/core/2d_primitives.js",
            "line": 134,
            "description": "<p>Draws an ellipse (oval) to the screen. An ellipse with equal width and\nheight is a circle. By default, the first two parameters set the location,\nand the third and fourth parameters set the shape&#39;s width and height. If\nno height is specified, the value of width is used for both the width and\nheight. If a negative height or width is specified, the absolute value is taken.\nThe origin may be changed with the ellipseMode() function.</p>\n",
            "itemtype": "method",
            "name": "ellipse",
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\nellipse(56, 46, 55, 55);\n</code>\n</div>"
            ],
            "alt": "white ellipse with black outline in middle-right of canvas that is 55x55.",
            "class": "p5",
            "module": "Shape",
            "submodule": "2D Primitives",
            "overloads": [
                {
                    "line": 134,
                    "params": [
                        {
                            "name": "x",
                            "description": "<p>x-coordinate of the ellipse.</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "y",
                            "description": "<p>y-coordinate of the ellipse.</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "w",
                            "description": "<p>width of the ellipse.</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "h",
                            "description": "<p>height of the ellipse.</p>\n",
                            "type": "Number",
                            "optional": true
                        }
                    ],
                    "chainable": 1
                },
                {
                    "line": 159,
                    "params": [
                        {
                            "name": "x",
                            "description": "",
                            "type": "Number"
                        },
                        {
                            "name": "y",
                            "description": "",
                            "type": "Number"
                        },
                        {
                            "name": "w",
                            "description": "",
                            "type": "Number"
                        },
                        {
                            "name": "h",
                            "description": "",
                            "type": "Number"
                        },
                        {
                            "name": "detailX",
                            "description": "<p>number of segments in the x-direction</p>\n",
                            "type": "Integer"
                        },
                        {
                            "name": "detailY",
                            "description": "<p>number of segments in the y-direction</p>\n",
                            "type": "Integer",
                            "optional": true
                        }
                    ]
                }
            ]
        },
        {
            "file": "src/core/2d_primitives.js",
            "line": 190,
            "description": "<p>Draws a line (a direct path between two points) to the screen. The version\nof line() with four parameters draws the line in 2D. To color a line, use\nthe stroke() function. A line cannot be filled, therefore the fill()\nfunction will not affect the color of a line. 2D lines are drawn with a\nwidth of one pixel by default, but this can be changed with the\nstrokeWeight() function.</p>\n",
            "itemtype": "method",
            "name": "line",
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\nline(30, 20, 85, 75);\n</code>\n</div>\n\n<div>\n<code>\nline(30, 20, 85, 20);\nstroke(126);\nline(85, 20, 85, 75);\nstroke(255);\nline(85, 75, 30, 75);\n</code>\n</div>"
            ],
            "alt": "line 78 pixels long running from mid-top to bottom-right of canvas.\n3 lines of various stroke sizes. Form top, bottom and right sides of a square.",
            "class": "p5",
            "module": "Shape",
            "submodule": "2D Primitives",
            "overloads": [
                {
                    "line": 190,
                    "params": [
                        {
                            "name": "x1",
                            "description": "<p>the x-coordinate of the first point</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "y1",
                            "description": "<p>the y-coordinate of the first point</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "x2",
                            "description": "<p>the x-coordinate of the second point</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "y2",
                            "description": "<p>the y-coordinate of the second point</p>\n",
                            "type": "Number"
                        }
                    ],
                    "chainable": 1
                },
                {
                    "line": 226,
                    "params": [
                        {
                            "name": "x1",
                            "description": "",
                            "type": "Number"
                        },
                        {
                            "name": "y1",
                            "description": "",
                            "type": "Number"
                        },
                        {
                            "name": "z1",
                            "description": "<p>the z-coordinate of the first point</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "x2",
                            "description": "",
                            "type": "Number"
                        },
                        {
                            "name": "y2",
                            "description": "",
                            "type": "Number"
                        },
                        {
                            "name": "z2",
                            "description": "<p>the z-coordinate of the second point</p>\n",
                            "type": "Number"
                        }
                    ],
                    "chainable": 1
                }
            ]
        },
        {
            "file": "src/core/2d_primitives.js",
            "line": 246,
            "description": "<p>Draws a point, a coordinate in space at the dimension of one pixel.\nThe first parameter is the horizontal value for the point, the second\nvalue is the vertical value for the point. The color of the point is\ndetermined by the current stroke.</p>\n",
            "itemtype": "method",
            "name": "point",
            "params": [
                {
                    "name": "x",
                    "description": "<p>the x-coordinate</p>\n",
                    "type": "Number"
                },
                {
                    "name": "y",
                    "description": "<p>the y-coordinate</p>\n",
                    "type": "Number"
                },
                {
                    "name": "z",
                    "description": "<p>the z-coordinate (for WEBGL mode)</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\npoint(30, 20);\npoint(85, 20);\npoint(85, 75);\npoint(30, 75);\n</code>\n</div>"
            ],
            "alt": "4 points centered in the middle-right of the canvas.",
            "class": "p5",
            "module": "Shape",
            "submodule": "2D Primitives"
        },
        {
            "file": "src/core/2d_primitives.js",
            "line": 281,
            "description": "<p>Draw a quad. A quad is a quadrilateral, a four sided polygon. It is\nsimilar to a rectangle, but the angles between its edges are not\nconstrained to ninety degrees. The first pair of parameters (x1,y1)\nsets the first vertex and the subsequent pairs should proceed\nclockwise or counter-clockwise around the defined shape.</p>\n",
            "itemtype": "method",
            "name": "quad",
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\nquad(38, 31, 86, 20, 69, 63, 30, 76);\n</code>\n</div>"
            ],
            "alt": "irregular white quadrilateral shape with black outline mid-right of canvas.",
            "class": "p5",
            "module": "Shape",
            "submodule": "2D Primitives",
            "overloads": [
                {
                    "line": 281,
                    "params": [
                        {
                            "name": "x1",
                            "description": "<p>the x-coordinate of the first point</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "y1",
                            "description": "<p>the y-coordinate of the first point</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "x2",
                            "description": "<p>the x-coordinate of the second point</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "y2",
                            "description": "<p>the y-coordinate of the second point</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "x3",
                            "description": "<p>the x-coordinate of the third point</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "y3",
                            "description": "<p>the y-coordinate of the third point</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "x4",
                            "description": "<p>the x-coordinate of the fourth point</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "y4",
                            "description": "<p>the y-coordinate of the fourth point</p>\n",
                            "type": "Number"
                        }
                    ],
                    "chainable": 1
                },
                {
                    "line": 309,
                    "params": [
                        {
                            "name": "x1",
                            "description": "",
                            "type": "Number"
                        },
                        {
                            "name": "y1",
                            "description": "",
                            "type": "Number"
                        },
                        {
                            "name": "z1",
                            "description": "",
                            "type": "Number"
                        },
                        {
                            "name": "x2",
                            "description": "",
                            "type": "Number"
                        },
                        {
                            "name": "y2",
                            "description": "",
                            "type": "Number"
                        },
                        {
                            "name": "z2",
                            "description": "",
                            "type": "Number"
                        },
                        {
                            "name": "x3",
                            "description": "",
                            "type": "Number"
                        },
                        {
                            "name": "y3",
                            "description": "",
                            "type": "Number"
                        },
                        {
                            "name": "z3",
                            "description": "",
                            "type": "Number"
                        },
                        {
                            "name": "x4",
                            "description": "",
                            "type": "Number"
                        },
                        {
                            "name": "y4",
                            "description": "",
                            "type": "Number"
                        },
                        {
                            "name": "z4",
                            "description": "",
                            "type": "Number"
                        }
                    ],
                    "chainable": 1
                }
            ]
        },
        {
            "file": "src/core/2d_primitives.js",
            "line": 335,
            "description": "<p>Draws a rectangle to the screen. A rectangle is a four-sided shape with\nevery angle at ninety degrees. By default, the first two parameters set\nthe location of the upper-left corner, the third sets the width, and the\nfourth sets the height. The way these parameters are interpreted, however,\nmay be changed with the rectMode() function.\n<br><br>\nThe fifth, sixth, seventh and eighth parameters, if specified,\ndetermine corner radius for the top-right, top-left, lower-right and\nlower-left corners, respectively. An omitted corner radius parameter is set\nto the value of the previously specified radius value in the parameter list.</p>\n",
            "itemtype": "method",
            "name": "rect",
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\n// Draw a rectangle at location (30, 20) with a width and height of 55.\nrect(30, 20, 55, 55);\n</code>\n</div>\n\n<div>\n<code>\n// Draw a rectangle with rounded corners, each having a radius of 20.\nrect(30, 20, 55, 55, 20);\n</code>\n</div>\n\n<div>\n<code>\n// Draw a rectangle with rounded corners having the following radii:\n// top-left = 20, top-right = 15, bottom-right = 10, bottom-left = 5.\nrect(30, 20, 55, 55, 20, 15, 10, 5);\n</code>\n</div>"
            ],
            "alt": "55x55 white rect with black outline in mid-right of canvas.\n55x55 white rect with black outline and rounded edges in mid-right of canvas.\n55x55 white rect with black outline and rounded edges of different radii.",
            "class": "p5",
            "module": "Shape",
            "submodule": "2D Primitives",
            "overloads": [
                {
                    "line": 335,
                    "params": [
                        {
                            "name": "x",
                            "description": "<p>x-coordinate of the rectangle.</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "y",
                            "description": "<p>y-coordinate of the rectangle.</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "w",
                            "description": "<p>width of the rectangle.</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "h",
                            "description": "<p>height of the rectangle.</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "tl",
                            "description": "<p>optional radius of top-left corner.</p>\n",
                            "type": "Number",
                            "optional": true
                        },
                        {
                            "name": "tr",
                            "description": "<p>optional radius of top-right corner.</p>\n",
                            "type": "Number",
                            "optional": true
                        },
                        {
                            "name": "br",
                            "description": "<p>optional radius of bottom-right corner.</p>\n",
                            "type": "Number",
                            "optional": true
                        },
                        {
                            "name": "bl",
                            "description": "<p>optional radius of bottom-left corner.</p>\n",
                            "type": "Number",
                            "optional": true
                        }
                    ],
                    "chainable": 1
                },
                {
                    "line": 385,
                    "params": [
                        {
                            "name": "x",
                            "description": "",
                            "type": "Number"
                        },
                        {
                            "name": "y",
                            "description": "",
                            "type": "Number"
                        },
                        {
                            "name": "w",
                            "description": "",
                            "type": "Number"
                        },
                        {
                            "name": "h",
                            "description": "",
                            "type": "Number"
                        },
                        {
                            "name": "detailX",
                            "description": "<p>number of segments in the x-direction</p>\n",
                            "type": "Integer",
                            "optional": true
                        },
                        {
                            "name": "detailY",
                            "description": "<p>number of segments in the y-direction</p>\n",
                            "type": "Integer",
                            "optional": true
                        }
                    ],
                    "chainable": 1
                }
            ]
        },
        {
            "file": "src/core/2d_primitives.js",
            "line": 406,
            "description": "<p>A triangle is a plane created by connecting three points. The first two\narguments specify the first point, the middle two arguments specify the\nsecond point, and the last two arguments specify the third point.</p>\n",
            "itemtype": "method",
            "name": "triangle",
            "params": [
                {
                    "name": "x1",
                    "description": "<p>x-coordinate of the first point</p>\n",
                    "type": "Number"
                },
                {
                    "name": "y1",
                    "description": "<p>y-coordinate of the first point</p>\n",
                    "type": "Number"
                },
                {
                    "name": "x2",
                    "description": "<p>x-coordinate of the second point</p>\n",
                    "type": "Number"
                },
                {
                    "name": "y2",
                    "description": "<p>y-coordinate of the second point</p>\n",
                    "type": "Number"
                },
                {
                    "name": "x3",
                    "description": "<p>x-coordinate of the third point</p>\n",
                    "type": "Number"
                },
                {
                    "name": "y3",
                    "description": "<p>y-coordinate of the third point</p>\n",
                    "type": "Number"
                }
            ],
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\ntriangle(30, 75, 58, 20, 86, 75);\n</code>\n</div>"
            ],
            "alt": "white triangle with black outline in mid-right of canvas.",
            "class": "p5",
            "module": "Shape",
            "submodule": "2D Primitives"
        },
        {
            "file": "src/core/attributes.js",
            "line": 14,
            "description": "<p>Modifies the location from which ellipses are drawn by changing the way\nin which parameters given to ellipse() are interpreted.\n<br><br>\nThe default mode is ellipseMode(CENTER), which interprets the first two\nparameters of ellipse() as the shape&#39;s center point, while the third and\nfourth parameters are its width and height.\n<br><br>\nellipseMode(RADIUS) also uses the first two parameters of ellipse() as\nthe shape&#39;s center point, but uses the third and fourth parameters to\nspecify half of the shapes&#39;s width and height.\n<br><br>\nellipseMode(CORNER) interprets the first two parameters of ellipse() as\nthe upper-left corner of the shape, while the third and fourth parameters\nare its width and height.\n<br><br>\nellipseMode(CORNERS) interprets the first two parameters of ellipse() as\nthe location of one corner of the ellipse&#39;s bounding box, and the third\nand fourth parameters as the location of the opposite corner.\n<br><br>\nThe parameter must be written in ALL CAPS because Javascript is a\ncase-sensitive language.</p>\n",
            "itemtype": "method",
            "name": "ellipseMode",
            "params": [
                {
                    "name": "mode",
                    "description": "<p>either CENTER, RADIUS, CORNER, or CORNERS</p>\n",
                    "type": "Constant"
                }
            ],
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\nellipseMode(RADIUS); // Set ellipseMode to RADIUS\nfill(255); // Set fill to white\nellipse(50, 50, 30, 30); // Draw white ellipse using RADIUS mode\n\nellipseMode(CENTER); // Set ellipseMode to CENTER\nfill(100); // Set fill to gray\nellipse(50, 50, 30, 30); // Draw gray ellipse using CENTER mode\n</code>\n</div>\n\n<div>\n<code>\nellipseMode(CORNER); // Set ellipseMode is CORNER\nfill(255); // Set fill to white\nellipse(25, 25, 50, 50); // Draw white ellipse using CORNER mode\n\nellipseMode(CORNERS); // Set ellipseMode to CORNERS\nfill(100); // Set fill to gray\nellipse(25, 25, 50, 50); // Draw gray ellipse using CORNERS mode\n</code>\n</div>"
            ],
            "alt": "60x60 white ellipse and 30x30 grey ellipse with black outlines at center.\n60x60 white ellipse @center and 30x30 grey ellipse top-right, black outlines.",
            "class": "p5",
            "module": "Shape",
            "submodule": "Attributes"
        },
        {
            "file": "src/core/attributes.js",
            "line": 83,
            "description": "<p>Draws all geometry with jagged (aliased) edges. Note that smooth() is\nactive by default, so it is necessary to call noSmooth() to disable\nsmoothing of geometry, images, and fonts.</p>\n",
            "itemtype": "method",
            "name": "noSmooth",
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\nbackground(0);\nnoStroke();\nsmooth();\nellipse(30, 48, 36, 36);\nnoSmooth();\nellipse(70, 48, 36, 36);\n</code>\n</div>"
            ],
            "alt": "2 pixelated 36x36 white ellipses to left & right of center, black background",
            "class": "p5",
            "module": "Shape",
            "submodule": "Attributes"
        },
        {
            "file": "src/core/attributes.js",
            "line": 111,
            "description": "<p>Modifies the location from which rectangles are drawn by changing the way\nin which parameters given to rect() are interpreted.\n<br><br>\nThe default mode is rectMode(CORNER), which interprets the first two\nparameters of rect() as the upper-left corner of the shape, while the\nthird and fourth parameters are its width and height.\n<br><br>\nrectMode(CORNERS) interprets the first two parameters of rect() as the\nlocation of one corner, and the third and fourth parameters as the\nlocation of the opposite corner.\n<br><br>\nrectMode(CENTER) interprets the first two parameters of rect() as the\nshape&#39;s center point, while the third and fourth parameters are its\nwidth and height.\n<br><br>\nrectMode(RADIUS) also uses the first two parameters of rect() as the\nshape&#39;s center point, but uses the third and fourth parameters to specify\nhalf of the shapes&#39;s width and height.\n<br><br>\nThe parameter must be written in ALL CAPS because Javascript is a\ncase-sensitive language.</p>\n",
            "itemtype": "method",
            "name": "rectMode",
            "params": [
                {
                    "name": "mode",
                    "description": "<p>either CORNER, CORNERS, CENTER, or RADIUS</p>\n",
                    "type": "Constant"
                }
            ],
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\nrectMode(CORNER); // Default rectMode is CORNER\nfill(255); // Set fill to white\nrect(25, 25, 50, 50); // Draw white rect using CORNER mode\n\nrectMode(CORNERS); // Set rectMode to CORNERS\nfill(100); // Set fill to gray\nrect(25, 25, 50, 50); // Draw gray rect using CORNERS mode\n</code>\n</div>\n\n<div>\n<code>\nrectMode(RADIUS); // Set rectMode to RADIUS\nfill(255); // Set fill to white\nrect(50, 50, 30, 30); // Draw white rect using RADIUS mode\n\nrectMode(CENTER); // Set rectMode to CENTER\nfill(100); // Set fill to gray\nrect(50, 50, 30, 30); // Draw gray rect using CENTER mode\n</code>\n</div>"
            ],
            "alt": "50x50 white rect at center and 25x25 grey rect in the top left of the other.\n50x50 white rect at center and 25x25 grey rect in the center of the other.",
            "class": "p5",
            "module": "Shape",
            "submodule": "Attributes"
        },
        {
            "file": "src/core/attributes.js",
            "line": 180,
            "description": "<p>Draws all geometry with smooth (anti-aliased) edges. smooth() will also\nimprove image quality of resized images. Note that smooth() is active by\ndefault; noSmooth() can be used to disable smoothing of geometry,\nimages, and fonts.</p>\n",
            "itemtype": "method",
            "name": "smooth",
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\nbackground(0);\nnoStroke();\nsmooth();\nellipse(30, 48, 36, 36);\nnoSmooth();\nellipse(70, 48, 36, 36);\n</code>\n</div>"
            ],
            "alt": "2 pixelated 36x36 white ellipses one left one right of center. On black.",
            "class": "p5",
            "module": "Shape",
            "submodule": "Attributes"
        },
        {
            "file": "src/core/attributes.js",
            "line": 209,
            "description": "<p>Sets the style for rendering line endings. These ends are either squared,\nextended, or rounded, each of which specified with the corresponding\nparameters: SQUARE, PROJECT, and ROUND. The default cap is ROUND.</p>\n",
            "itemtype": "method",
            "name": "strokeCap",
            "params": [
                {
                    "name": "cap",
                    "description": "<p>either SQUARE, PROJECT, or ROUND</p>\n",
                    "type": "Constant"
                }
            ],
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\nstrokeWeight(12.0);\nstrokeCap(ROUND);\nline(20, 30, 80, 30);\nstrokeCap(SQUARE);\nline(20, 50, 80, 50);\nstrokeCap(PROJECT);\nline(20, 70, 80, 70);\n</code>\n</div>"
            ],
            "alt": "3 lines. Top line: rounded ends, mid: squared, bottom:longer squared ends.",
            "class": "p5",
            "module": "Shape",
            "submodule": "Attributes"
        },
        {
            "file": "src/core/attributes.js",
            "line": 246,
            "description": "<p>Sets the style of the joints which connect line segments. These joints\nare either mitered, beveled, or rounded and specified with the\ncorresponding parameters MITER, BEVEL, and ROUND. The default joint is\nMITER.</p>\n",
            "itemtype": "method",
            "name": "strokeJoin",
            "params": [
                {
                    "name": "join",
                    "description": "<p>either MITER, BEVEL, ROUND</p>\n",
                    "type": "Constant"
                }
            ],
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\nnoFill();\nstrokeWeight(10.0);\nstrokeJoin(MITER);\nbeginShape();\nvertex(35, 20);\nvertex(65, 50);\nvertex(35, 80);\nendShape();\n</code>\n</div>\n\n<div>\n<code>\nnoFill();\nstrokeWeight(10.0);\nstrokeJoin(BEVEL);\nbeginShape();\nvertex(35, 20);\nvertex(65, 50);\nvertex(35, 80);\nendShape();\n</code>\n</div>\n\n<div>\n<code>\nnoFill();\nstrokeWeight(10.0);\nstrokeJoin(ROUND);\nbeginShape();\nvertex(35, 20);\nvertex(65, 50);\nvertex(35, 80);\nendShape();\n</code>\n</div>"
            ],
            "alt": "Right-facing arrowhead shape with pointed tip in center of canvas.\nRight-facing arrowhead shape with flat tip in center of canvas.\nRight-facing arrowhead shape with rounded tip in center of canvas.",
            "class": "p5",
            "module": "Shape",
            "submodule": "Attributes"
        },
        {
            "file": "src/core/attributes.js",
            "line": 313,
            "description": "<p>Sets the width of the stroke used for lines, points, and the border\naround shapes. All widths are set in units of pixels.</p>\n",
            "itemtype": "method",
            "name": "strokeWeight",
            "params": [
                {
                    "name": "weight",
                    "description": "<p>the weight (in pixels) of the stroke</p>\n",
                    "type": "Number"
                }
            ],
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\nstrokeWeight(1); // Default\nline(20, 20, 80, 20);\nstrokeWeight(4); // Thicker\nline(20, 40, 80, 40);\nstrokeWeight(10); // Beastly\nline(20, 70, 80, 70);\n</code>\n</div>"
            ],
            "alt": "3 horizontal black lines. Top line: thin, mid: medium, bottom:thick.",
            "class": "p5",
            "module": "Shape",
            "submodule": "Attributes"
        },
        {
            "file": "src/core/canvas.js",
            "line": 1,
            "requires": [
                "constants"
            ],
            "class": "p5",
            "module": "Shape"
        },
        {
            "file": "src/core/constants.js",
            "line": 13,
            "itemtype": "property",
            "name": "P2D",
            "type": "String",
            "final": 1,
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 18,
            "itemtype": "property",
            "name": "WEBGL",
            "type": "String",
            "final": 1,
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 34,
            "description": "<p>HALF_PI is a mathematical constant with the value\n1.57079632679489661923. It is half the ratio of the\ncircumference of a circle to its diameter. It is useful in\ncombination with the trigonometric functions sin() and cos().</p>\n",
            "itemtype": "property",
            "name": "HALF_PI",
            "type": "Number",
            "final": 1,
            "example": [
                "\n<div><code>\narc(50, 50, 80, 80, 0, HALF_PI);\n</code></div>"
            ],
            "alt": "80x80 white quarter-circle with curve toward bottom right of canvas.",
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 53,
            "description": "<p>PI is a mathematical constant with the value\n3.14159265358979323846. It is the ratio of the circumference\nof a circle to its diameter. It is useful in combination with\nthe trigonometric functions sin() and cos().</p>\n",
            "itemtype": "property",
            "name": "PI",
            "type": "Number",
            "final": 1,
            "example": [
                "\n<div><code>\narc(50, 50, 80, 80, 0, PI);\n</code></div>"
            ],
            "alt": "white half-circle with curve toward bottom of canvas.",
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 72,
            "description": "<p>QUARTER_PI is a mathematical constant with the value 0.7853982.\nIt is one quarter the ratio of the circumference of a circle to\nits diameter. It is useful in combination with the trigonometric\nfunctions sin() and cos().</p>\n",
            "itemtype": "property",
            "name": "QUARTER_PI",
            "type": "Number",
            "final": 1,
            "example": [
                "\n<div><code>\narc(50, 50, 80, 80, 0, QUARTER_PI);\n</code></div>"
            ],
            "alt": "white eighth-circle rotated about 40 degrees with curve bottom right canvas.",
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 91,
            "description": "<p>TAU is an alias for TWO_PI, a mathematical constant with the\nvalue 6.28318530717958647693. It is twice the ratio of the\ncircumference of a circle to its diameter. It is useful in\ncombination with the trigonometric functions sin() and cos().</p>\n",
            "itemtype": "property",
            "name": "TAU",
            "type": "Number",
            "final": 1,
            "example": [
                "\n<div><code>\narc(50, 50, 80, 80, 0, TAU);\n</code></div>"
            ],
            "alt": "80x80 white ellipse shape in center of canvas.",
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 110,
            "description": "<p>TWO_PI is a mathematical constant with the value\n6.28318530717958647693. It is twice the ratio of the\ncircumference of a circle to its diameter. It is useful in\ncombination with the trigonometric functions sin() and cos().</p>\n",
            "itemtype": "property",
            "name": "TWO_PI",
            "type": "Number",
            "final": 1,
            "example": [
                "\n<div><code>\narc(50, 50, 80, 80, 0, TWO_PI);\n</code></div>"
            ],
            "alt": "80x80 white ellipse shape in center of canvas.",
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 129,
            "description": "<p>Constant to be used with angleMode() function, to set the mode which\np5.js interprates and calculates angles (either DEGREES or RADIANS).</p>\n",
            "itemtype": "property",
            "name": "DEGREES",
            "type": "String",
            "final": 1,
            "example": [
                "\n<div class='norender'><code>\nfunction setup() {\n  angleMode(DEGREES);\n}\n</code></div>"
            ],
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 143,
            "description": "<p>Constant to be used with angleMode() function, to set the mode which\np5.js interprates and calculates angles (either RADIANS or DEGREES).</p>\n",
            "itemtype": "property",
            "name": "RADIANS",
            "type": "String",
            "final": 1,
            "example": [
                "\n<div class='norender'><code>\nfunction setup() {\n  angleMode(RADIANS);\n}\n</code></div>"
            ],
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 161,
            "itemtype": "property",
            "name": "CORNER",
            "type": "String",
            "final": 1,
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 166,
            "itemtype": "property",
            "name": "CORNERS",
            "type": "String",
            "final": 1,
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 171,
            "itemtype": "property",
            "name": "RADIUS",
            "type": "String",
            "final": 1,
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 176,
            "itemtype": "property",
            "name": "RIGHT",
            "type": "String",
            "final": 1,
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 181,
            "itemtype": "property",
            "name": "LEFT",
            "type": "String",
            "final": 1,
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 186,
            "itemtype": "property",
            "name": "CENTER",
            "type": "String",
            "final": 1,
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 191,
            "itemtype": "property",
            "name": "TOP",
            "type": "String",
            "final": 1,
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 196,
            "itemtype": "property",
            "name": "BOTTOM",
            "type": "String",
            "final": 1,
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 201,
            "itemtype": "property",
            "name": "BASELINE",
            "type": "String",
            "final": 1,
            "default": "alphabetic",
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 207,
            "itemtype": "property",
            "name": "POINTS",
            "type": "Number",
            "final": 1,
            "default": "0x0000",
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 213,
            "itemtype": "property",
            "name": "LINES",
            "type": "Number",
            "final": 1,
            "default": "0x0001",
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 219,
            "itemtype": "property",
            "name": "LINE_STRIP",
            "type": "Number",
            "final": 1,
            "default": "0x0003",
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 225,
            "itemtype": "property",
            "name": "LINE_LOOP",
            "type": "Number",
            "final": 1,
            "default": "0x0002",
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 231,
            "itemtype": "property",
            "name": "TRIANGLES",
            "type": "Number",
            "final": 1,
            "default": "0x0004",
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 237,
            "itemtype": "property",
            "name": "TRIANGLE_FAN",
            "type": "Number",
            "final": 1,
            "default": "0x0006",
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 243,
            "itemtype": "property",
            "name": "TRIANGLE_STRIP",
            "type": "Number",
            "final": 1,
            "default": "0x0005",
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 249,
            "itemtype": "property",
            "name": "QUADS",
            "type": "String",
            "final": 1,
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 254,
            "itemtype": "property",
            "name": "QUAD_STRIP",
            "type": "String",
            "final": 1,
            "default": "quad_strip",
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 260,
            "itemtype": "property",
            "name": "CLOSE",
            "type": "String",
            "final": 1,
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 265,
            "itemtype": "property",
            "name": "OPEN",
            "type": "String",
            "final": 1,
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 270,
            "itemtype": "property",
            "name": "CHORD",
            "type": "String",
            "final": 1,
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 275,
            "itemtype": "property",
            "name": "PIE",
            "type": "String",
            "final": 1,
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 280,
            "itemtype": "property",
            "name": "PROJECT",
            "type": "String",
            "final": 1,
            "default": "square",
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 286,
            "itemtype": "property",
            "name": "SQUARE",
            "type": "String",
            "final": 1,
            "default": "butt",
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 292,
            "itemtype": "property",
            "name": "ROUND",
            "type": "String",
            "final": 1,
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 297,
            "itemtype": "property",
            "name": "BEVEL",
            "type": "String",
            "final": 1,
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 302,
            "itemtype": "property",
            "name": "MITER",
            "type": "String",
            "final": 1,
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 309,
            "itemtype": "property",
            "name": "RGB",
            "type": "String",
            "final": 1,
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 314,
            "itemtype": "property",
            "name": "HSB",
            "type": "String",
            "final": 1,
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 319,
            "itemtype": "property",
            "name": "HSL",
            "type": "String",
            "final": 1,
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 345,
            "itemtype": "property",
            "name": "BLEND",
            "type": "String",
            "final": 1,
            "default": "source-over",
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 351,
            "itemtype": "property",
            "name": "ADD",
            "type": "String",
            "final": 1,
            "default": "lighter",
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 359,
            "itemtype": "property",
            "name": "DARKEST",
            "type": "String",
            "final": 1,
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 364,
            "itemtype": "property",
            "name": "LIGHTEST",
            "type": "String",
            "final": 1,
            "default": "lighten",
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 370,
            "itemtype": "property",
            "name": "DIFFERENCE",
            "type": "String",
            "final": 1,
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 375,
            "itemtype": "property",
            "name": "EXCLUSION",
            "type": "String",
            "final": 1,
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 380,
            "itemtype": "property",
            "name": "MULTIPLY",
            "type": "String",
            "final": 1,
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 385,
            "itemtype": "property",
            "name": "SCREEN",
            "type": "String",
            "final": 1,
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 390,
            "itemtype": "property",
            "name": "REPLACE",
            "type": "String",
            "final": 1,
            "default": "copy",
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 396,
            "itemtype": "property",
            "name": "OVERLAY",
            "type": "String",
            "final": 1,
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 401,
            "itemtype": "property",
            "name": "HARD_LIGHT",
            "type": "String",
            "final": 1,
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 406,
            "itemtype": "property",
            "name": "SOFT_LIGHT",
            "type": "String",
            "final": 1,
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 411,
            "itemtype": "property",
            "name": "DODGE",
            "type": "String",
            "final": 1,
            "default": "color-dodge",
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 417,
            "itemtype": "property",
            "name": "BURN",
            "type": "String",
            "final": 1,
            "default": "color-burn",
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 425,
            "itemtype": "property",
            "name": "THRESHOLD",
            "type": "String",
            "final": 1,
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 430,
            "itemtype": "property",
            "name": "GRAY",
            "type": "String",
            "final": 1,
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 435,
            "itemtype": "property",
            "name": "OPAQUE",
            "type": "String",
            "final": 1,
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 440,
            "itemtype": "property",
            "name": "INVERT",
            "type": "String",
            "final": 1,
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 445,
            "itemtype": "property",
            "name": "POSTERIZE",
            "type": "String",
            "final": 1,
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 450,
            "itemtype": "property",
            "name": "DILATE",
            "type": "String",
            "final": 1,
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 455,
            "itemtype": "property",
            "name": "ERODE",
            "type": "String",
            "final": 1,
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 460,
            "itemtype": "property",
            "name": "BLUR",
            "type": "String",
            "final": 1,
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 467,
            "itemtype": "property",
            "name": "NORMAL",
            "type": "String",
            "final": 1,
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 472,
            "itemtype": "property",
            "name": "ITALIC",
            "type": "String",
            "final": 1,
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 477,
            "itemtype": "property",
            "name": "BOLD",
            "type": "String",
            "final": 1,
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 501,
            "itemtype": "property",
            "name": "LANDSCAPE",
            "type": "String",
            "final": 1,
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/constants.js",
            "line": 506,
            "itemtype": "property",
            "name": "PORTRAIT",
            "type": "String",
            "final": 1,
            "class": "p5",
            "module": "Constants",
            "submodule": "Constants"
        },
        {
            "file": "src/core/core.js",
            "line": 49,
            "description": "<p>Called directly before setup(), the preload() function is used to handle\nasynchronous loading of external files. If a preload function is\ndefined, setup() will wait until any load calls within have finished.\nNothing besides load calls should be inside preload (loadImage,\nloadJSON, loadFont, loadStrings, etc).<br><br>\nBy default the text &quot;loading...&quot; will be displayed. To make your own\nloading page, include an HTML element with id &quot;p5_loading&quot; in your\npage. More information <a href=\"http://bit.ly/2kQ6Nio\">here</a>.</p>\n",
            "itemtype": "method",
            "name": "preload",
            "example": [
                "\n<div><code>\nvar img;\nvar c;\nfunction preload() {\n // preload() runs once\n  img = loadImage('assets/laDefense.jpg');\n}\n\nfunction setup() {\n // setup() waits until preload() is done\n  img.loadPixels();\n  // get color of middle pixel\n  c = img.get(img.width / 2, img.height / 2);\n}\n\nfunction draw() {\n  background(c);\n  image(img, 25, 25, 50, 50);\n}\n</code></div>"
            ],
            "alt": "nothing displayed",
            "class": "p5",
            "module": "Structure",
            "submodule": "Structure"
        },
        {
            "file": "src/core/core.js",
            "line": 87,
            "description": "<p>The setup() function is called once when the program starts. It&#39;s used to\ndefine initial environment properties such as screen size and background\ncolor and to load media such as images and fonts as the program starts.\nThere can only be one setup() function for each program and it shouldn&#39;t\nbe called again after its initial execution.\n<br><br>\nNote: Variables declared within setup() are not accessible within other\nfunctions, including draw().</p>\n",
            "itemtype": "method",
            "name": "setup",
            "example": [
                "\n<div><code>\nvar a = 0;\n\nfunction setup() {\n  background(0);\n  noStroke();\n  fill(102);\n}\n\nfunction draw() {\n  rect(a++ % width, 10, 2, 80);\n}\n</code></div>"
            ],
            "alt": "nothing displayed",
            "class": "p5",
            "module": "Structure",
            "submodule": "Structure"
        },
        {
            "file": "src/core/core.js",
            "line": 118,
            "description": "<p>Called directly after setup(), the draw() function continuously executes\nthe lines of code contained inside its block until the program is stopped\nor noLoop() is called. Note if noLoop() is called in setup(), draw() will\nstill be executed once before stopping. draw() is called automatically and\nshould never be called explicitly.\n<br><br>\nIt should always be controlled with noLoop(), redraw() and loop(). After\nnoLoop() stops the code in draw() from executing, redraw() causes the\ncode inside draw() to execute once, and loop() will cause the code\ninside draw() to resume executing continuously.\n<br><br>\nThe number of times draw() executes in each second may be controlled with\nthe frameRate() function.\n<br><br>\nThere can only be one draw() function for each sketch, and draw() must\nexist if you want the code to run continuously, or to process events such\nas mousePressed(). Sometimes, you might have an empty call to draw() in\nyour program, as shown in the above example.\n<br><br>\nIt is important to note that the drawing coordinate system will be reset\nat the beginning of each draw() call. If any transformations are performed\nwithin draw() (ex: scale, rotate, translate, their effects will be\nundone at the beginning of draw(), so transformations will not accumulate\nover time. On the other hand, styling applied (ex: fill, stroke, etc) will\nremain in effect.</p>\n",
            "itemtype": "method",
            "name": "draw",
            "example": [
                "\n<div><code>\nvar yPos = 0;\nfunction setup() {\n // setup() runs once\n  frameRate(30);\n}\nfunction draw() {\n // draw() loops forever, until stopped\n  background(204);\n  yPos = yPos - 1;\n  if (yPos < 0) {\n    yPos = height;\n  }\n  line(0, yPos, width, yPos);\n}\n</code></div>"
            ],
            "alt": "nothing displayed",
            "class": "p5",
            "module": "Structure",
            "submodule": "Structure"
        },
        {
            "file": "src/core/core.js",
            "line": 401,
            "description": "<p>Removes the entire p5 sketch. This will remove the canvas and any\nelements created by p5.js. It will also stop the draw loop and unbind\nany properties or methods from the window global scope. It will\nleave a variable p5 in case you wanted to create a new p5 sketch.\nIf you like, you can set p5 = null to erase it. While all functions and\nvariables and objects created by the p5 library will be removed, any\nother global variables created by your code will remain.</p>\n",
            "itemtype": "method",
            "name": "remove",
            "example": [
                "\n<div class='norender'><code>\nfunction draw() {\n  ellipse(50, 50, 10, 10);\n}\n\nfunction mousePressed() {\n  remove(); // remove whole sketch on mouse press\n}\n</code></div>"
            ],
            "alt": "nothing displayed",
            "class": "p5",
            "module": "Structure",
            "submodule": "Structure"
        },
        {
            "file": "src/core/curves.js",
            "line": 13,
            "description": "<p>Draws a cubic Bezier curve on the screen. These curves are defined by a\nseries of anchor and control points. The first two parameters specify\nthe first anchor point and the last two parameters specify the other\nanchor point, which become the first and last points on the curve. The\nmiddle parameters specify the two control points which define the shape\nof the curve. Approximately speaking, control points &quot;pull&quot; the curve\ntowards them.<br /><br />Bezier curves were developed by French\nautomotive engineer Pierre Bezier, and are commonly used in computer\ngraphics to define gently sloping curves. See also curve().</p>\n",
            "itemtype": "method",
            "name": "bezier",
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\nnoFill();\nstroke(255, 102, 0);\nline(85, 20, 10, 10);\nline(90, 90, 15, 80);\nstroke(0, 0, 0);\nbezier(85, 20, 10, 10, 90, 90, 15, 80);\n</code>\n</div>\n\n<div>\n<code>\nbackground(0, 0, 0);\nnoFill();\nstroke(255);\nbezier(250, 250, 0, 100, 100, 0, 100, 0, 0, 0, 100, 0);\n</code>\n</div>"
            ],
            "alt": "stretched black s-shape in center with orange lines extending from end points.\nstretched black s-shape with 10 5x5 white ellipses along the shape.\nstretched black s-shape with 7 5x5 ellipses and orange lines along the shape.\nstretched black s-shape with 17 small orange lines extending from under shape.\nhorseshoe shape with orange ends facing left and black curved center.\nhorseshoe shape with orange ends facing left and black curved center.\nLine shaped like right-facing arrow,points move with mouse-x and warp shape.\nhorizontal line that hooks downward on the right and 13 5x5 ellipses along it.\nright curving line mid-right of canvas with 7 short lines radiating from it.",
            "class": "p5",
            "module": "Shape",
            "submodule": "Curves",
            "overloads": [
                {
                    "line": 13,
                    "params": [
                        {
                            "name": "x1",
                            "description": "<p>x-coordinate for the first anchor point</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "y1",
                            "description": "<p>y-coordinate for the first anchor point</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "x2",
                            "description": "<p>x-coordinate for the first control point</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "y2",
                            "description": "<p>y-coordinate for the first control point</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "x3",
                            "description": "<p>x-coordinate for the second control point</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "y3",
                            "description": "<p>y-coordinate for the second control point</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "x4",
                            "description": "<p>x-coordinate for the second anchor point</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "y4",
                            "description": "<p>y-coordinate for the second anchor point</p>\n",
                            "type": "Number"
                        }
                    ],
                    "chainable": 1
                },
                {
                    "line": 66,
                    "params": [
                        {
                            "name": "x1",
                            "description": "",
                            "type": "Number"
                        },
                        {
                            "name": "y1",
                            "description": "",
                            "type": "Number"
                        },
                        {
                            "name": "z1",
                            "description": "<p>z-coordinate for the first anchor point</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "x2",
                            "description": "",
                            "type": "Number"
                        },
                        {
                            "name": "y2",
                            "description": "",
                            "type": "Number"
                        },
                        {
                            "name": "z2",
                            "description": "<p>z-coordinate for the first control point</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "x3",
                            "description": "",
                            "type": "Number"
                        },
                        {
                            "name": "y3",
                            "description": "",
                            "type": "Number"
                        },
                        {
                            "name": "z3",
                            "description": "<p>z-coordinate for the second control point</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "x4",
                            "description": "",
                            "type": "Number"
                        },
                        {
                            "name": "y4",
                            "description": "",
                            "type": "Number"
                        },
                        {
                            "name": "z4",
                            "description": "<p>z-coordinate for the second anchor point</p>\n",
                            "type": "Number"
                        }
                    ],
                    "chainable": 1
                }
            ]
        },
        {
            "file": "src/core/curves.js",
            "line": 92,
            "description": "<p>Sets the resolution at which Beziers display.</p>\n<p>The default value is 20.</p>\n",
            "itemtype": "method",
            "name": "bezierDetail",
            "params": [
                {
                    "name": "detail",
                    "description": "<p>resolution of the curves</p>\n",
                    "type": "Number"
                }
            ],
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\nbackground(204);\nbezierDetail(50);\nbezier(85, 20, 10, 10, 90, 90, 15, 80);\n</code>\n</div>"
            ],
            "alt": "stretched black s-shape with 7 5x5 ellipses and orange lines along the shape.",
            "class": "p5",
            "module": "Shape",
            "submodule": "Curves"
        },
        {
            "file": "src/core/curves.js",
            "line": 119,
            "description": "<p>Evaluates the Bezier at position t for points a, b, c, d.\nThe parameters a and d are the first and last points\non the curve, and b and c are the control points.\nThe final parameter t varies between 0 and 1.\nThis can be done once with the x coordinates and a second time\nwith the y coordinates to get the location of a bezier curve at t.</p>\n",
            "itemtype": "method",
            "name": "bezierPoint",
            "params": [
                {
                    "name": "a",
                    "description": "<p>coordinate of first point on the curve</p>\n",
                    "type": "Number"
                },
                {
                    "name": "b",
                    "description": "<p>coordinate of first control point</p>\n",
                    "type": "Number"
                },
                {
                    "name": "c",
                    "description": "<p>coordinate of second control point</p>\n",
                    "type": "Number"
                },
                {
                    "name": "d",
                    "description": "<p>coordinate of second point on the curve</p>\n",
                    "type": "Number"
                },
                {
                    "name": "t",
                    "description": "<p>value between 0 and 1</p>\n",
                    "type": "Number"
                }
            ],
            "return": {
                "description": "the value of the Bezier at position t",
                "type": "Number"
            },
            "example": [
                "\n<div>\n<code>\nnoFill();\nvar x1 = 85,\n x2 = 10,\n x3 = 90,\n x4 = 15;\nvar y1 = 20,\n y2 = 10,\n y3 = 90,\n y4 = 80;\nbezier(x1, y1, x2, y2, x3, y3, x4, y4);\nfill(255);\nvar steps = 10;\nfor (var i = 0; i <= steps; i++) {\n  var t = i / steps;\n  var x = bezierPoint(x1, x2, x3, x4, t);\n  var y = bezierPoint(y1, y2, y3, y4, t);\n  ellipse(x, y, 5, 5);\n}\n</code>\n</div>"
            ],
            "alt": "stretched black s-shape with 17 small orange lines extending from under shape.",
            "class": "p5",
            "module": "Shape",
            "submodule": "Curves"
        },
        {
            "file": "src/core/curves.js",
            "line": 174,
            "description": "<p>Evaluates the tangent to the Bezier at position t for points a, b, c, d.\nThe parameters a and d are the first and last points\non the curve, and b and c are the control points.\nThe final parameter t varies between 0 and 1.</p>\n",
            "itemtype": "method",
            "name": "bezierTangent",
            "params": [
                {
                    "name": "a",
                    "description": "<p>coordinate of first point on the curve</p>\n",
                    "type": "Number"
                },
                {
                    "name": "b",
                    "description": "<p>coordinate of first control point</p>\n",
                    "type": "Number"
                },
                {
                    "name": "c",
                    "description": "<p>coordinate of second control point</p>\n",
                    "type": "Number"
                },
                {
                    "name": "d",
                    "description": "<p>coordinate of second point on the curve</p>\n",
                    "type": "Number"
                },
                {
                    "name": "t",
                    "description": "<p>value between 0 and 1</p>\n",
                    "type": "Number"
                }
            ],
            "return": {
                "description": "the tangent at position t",
                "type": "Number"
            },
            "example": [
                "\n<div>\n<code>\nnoFill();\nbezier(85, 20, 10, 10, 90, 90, 15, 80);\nvar steps = 6;\nfill(255);\nfor (var i = 0; i <= steps; i++) {\n  var t = i / steps;\n  // Get the location of the point\n  var x = bezierPoint(85, 10, 90, 15, t);\n  var y = bezierPoint(20, 10, 90, 80, t);\n  // Get the tangent points\n  var tx = bezierTangent(85, 10, 90, 15, t);\n  var ty = bezierTangent(20, 10, 90, 80, t);\n  // Calculate an angle from the tangent points\n  var a = atan2(ty, tx);\n  a += PI;\n  stroke(255, 102, 0);\n  line(x, y, cos(a) * 30 + x, sin(a) * 30 + y);\n  // The following line of code makes a line\n  // inverse of the above line\n  //line(x, y, cos(a)*-30 + x, sin(a)*-30 + y);\n  stroke(0);\n  ellipse(x, y, 5, 5);\n}\n</code>\n</div>\n\n<div>\n<code>\nnoFill();\nbezier(85, 20, 10, 10, 90, 90, 15, 80);\nstroke(255, 102, 0);\nvar steps = 16;\nfor (var i = 0; i <= steps; i++) {\n  var t = i / steps;\n  var x = bezierPoint(85, 10, 90, 15, t);\n  var y = bezierPoint(20, 10, 90, 80, t);\n  var tx = bezierTangent(85, 10, 90, 15, t);\n  var ty = bezierTangent(20, 10, 90, 80, t);\n  var a = atan2(ty, tx);\n  a -= HALF_PI;\n  line(x, y, cos(a) * 8 + x, sin(a) * 8 + y);\n}\n</code>\n</div>"
            ],
            "alt": "s-shaped line with 17 short orange lines extending from underside of shape",
            "class": "p5",
            "module": "Shape",
            "submodule": "Curves"
        },
        {
            "file": "src/core/curves.js",
            "line": 253,
            "description": "<p>Draws a curved line on the screen between two points, given as the\nmiddle four parameters. The first two parameters are a control point, as\nif the curve came from this point even though it&#39;s not drawn. The last\ntwo parameters similarly describe the other control point. <br /><br />\nLonger curves can be created by putting a series of curve() functions\ntogether or using curveVertex(). An additional function called\ncurveTightness() provides control for the visual quality of the curve.\nThe curve() function is an implementation of Catmull-Rom splines.</p>\n",
            "itemtype": "method",
            "name": "curve",
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\nnoFill();\nstroke(255, 102, 0);\ncurve(5, 26, 5, 26, 73, 24, 73, 61);\nstroke(0);\ncurve(5, 26, 73, 24, 73, 61, 15, 65);\nstroke(255, 102, 0);\ncurve(73, 24, 73, 61, 15, 65, 15, 65);\n</code>\n</div>\n<div>\n<code>\n// Define the curve points as JavaScript objects\nvar p1 = { x: 5, y: 26 },\n p2 = { x: 73, y: 24 };\nvar p3 = { x: 73, y: 61 },\n p4 = { x: 15, y: 65 };\nnoFill();\nstroke(255, 102, 0);\ncurve(p1.x, p1.y, p1.x, p1.y, p2.x, p2.y, p3.x, p3.y);\nstroke(0);\ncurve(p1.x, p1.y, p2.x, p2.y, p3.x, p3.y, p4.x, p4.y);\nstroke(255, 102, 0);\ncurve(p2.x, p2.y, p3.x, p3.y, p4.x, p4.y, p4.x, p4.y);\n</code>\n</div>\n<div>\n<code>\nnoFill();\nstroke(255, 102, 0);\ncurve(5, 26, 0, 5, 26, 0, 73, 24, 0, 73, 61, 0);\nstroke(0);\ncurve(5, 26, 0, 73, 24, 0, 73, 61, 0, 15, 65, 0);\nstroke(255, 102, 0);\ncurve(73, 24, 0, 73, 61, 0, 15, 65, 0, 15, 65, 0);\n</code>\n</div>"
            ],
            "alt": "horseshoe shape with orange ends facing left and black curved center.\nhorseshoe shape with orange ends facing left and black curved center.\ncurving black and orange lines.",
            "class": "p5",
            "module": "Shape",
            "submodule": "Curves",
            "overloads": [
                {
                    "line": 253,
                    "params": [
                        {
                            "name": "x1",
                            "description": "<p>x-coordinate for the beginning control point</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "y1",
                            "description": "<p>y-coordinate for the beginning control point</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "x2",
                            "description": "<p>x-coordinate for the first point</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "y2",
                            "description": "<p>y-coordinate for the first point</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "x3",
                            "description": "<p>x-coordinate for the second point</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "y3",
                            "description": "<p>y-coordinate for the second point</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "x4",
                            "description": "<p>x-coordinate for the ending control point</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "y4",
                            "description": "<p>y-coordinate for the ending control point</p>\n",
                            "type": "Number"
                        }
                    ],
                    "chainable": 1
                },
                {
                    "line": 318,
                    "params": [
                        {
                            "name": "x1",
                            "description": "",
                            "type": "Number"
                        },
                        {
                            "name": "y1",
                            "description": "",
                            "type": "Number"
                        },
                        {
                            "name": "z1",
                            "description": "<p>z-coordinate for the beginning control point</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "x2",
                            "description": "",
                            "type": "Number"
                        },
                        {
                            "name": "y2",
                            "description": "",
                            "type": "Number"
                        },
                        {
                            "name": "z2",
                            "description": "<p>z-coordinate for the first point</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "x3",
                            "description": "",
                            "type": "Number"
                        },
                        {
                            "name": "y3",
                            "description": "",
                            "type": "Number"
                        },
                        {
                            "name": "z3",
                            "description": "<p>z-coordinate for the second point</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "x4",
                            "description": "",
                            "type": "Number"
                        },
                        {
                            "name": "y4",
                            "description": "",
                            "type": "Number"
                        },
                        {
                            "name": "z4",
                            "description": "<p>z-coordinate for the ending control point</p>\n",
                            "type": "Number"
                        }
                    ],
                    "chainable": 1
                }
            ]
        },
        {
            "file": "src/core/curves.js",
            "line": 344,
            "description": "<p>Sets the resolution at which curves display.</p>\n<p>The default value is 20.</p>\n",
            "itemtype": "method",
            "name": "curveDetail",
            "params": [
                {
                    "name": "resolution",
                    "description": "<p>of the curves</p>\n",
                    "type": "Number"
                }
            ],
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\nbackground(204);\ncurveDetail(20);\ncurve(5, 26, 5, 26, 73, 24, 73, 61);\n</code>\n</div>"
            ],
            "alt": "white arch shape in top-mid canvas.",
            "class": "p5",
            "module": "Shape",
            "submodule": "Curves"
        },
        {
            "file": "src/core/curves.js",
            "line": 371,
            "description": "<p>Modifies the quality of forms created with curve() and curveVertex().\nThe parameter tightness determines how the curve fits to the vertex\npoints. The value 0.0 is the default value for tightness (this value\ndefines the curves to be Catmull-Rom splines) and the value 1.0 connects\nall the points with straight lines. Values within the range -5.0 and 5.0\nwill deform the curves but will leave them recognizable and as values\nincrease in magnitude, they will continue to deform.</p>\n",
            "itemtype": "method",
            "name": "curveTightness",
            "params": [
                {
                    "name": "amount",
                    "description": "<p>of deformation from the original vertices</p>\n",
                    "type": "Number"
                }
            ],
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\n// Move the mouse left and right to see the curve change\n\nfunction setup() {\n  createCanvas(100, 100);\n  noFill();\n}\n\nfunction draw() {\n  background(204);\n  var t = map(mouseX, 0, width, -5, 5);\n  curveTightness(t);\n  beginShape();\n  curveVertex(10, 26);\n  curveVertex(10, 26);\n  curveVertex(83, 24);\n  curveVertex(83, 61);\n  curveVertex(25, 65);\n  curveVertex(25, 65);\n  endShape();\n}\n</code>\n</div>"
            ],
            "alt": "Line shaped like right-facing arrow,points move with mouse-x and warp shape.",
            "class": "p5",
            "module": "Shape",
            "submodule": "Curves"
        },
        {
            "file": "src/core/curves.js",
            "line": 417,
            "description": "<p>Evaluates the curve at position t for points a, b, c, d.\nThe parameter t varies between 0 and 1, a and d are points\non the curve, and b and c are the control points.\nThis can be done once with the x coordinates and a second time\nwith the y coordinates to get the location of a curve at t.</p>\n",
            "itemtype": "method",
            "name": "curvePoint",
            "params": [
                {
                    "name": "a",
                    "description": "<p>coordinate of first point on the curve</p>\n",
                    "type": "Number"
                },
                {
                    "name": "b",
                    "description": "<p>coordinate of first control point</p>\n",
                    "type": "Number"
                },
                {
                    "name": "c",
                    "description": "<p>coordinate of second control point</p>\n",
                    "type": "Number"
                },
                {
                    "name": "d",
                    "description": "<p>coordinate of second point on the curve</p>\n",
                    "type": "Number"
                },
                {
                    "name": "t",
                    "description": "<p>value between 0 and 1</p>\n",
                    "type": "Number"
                }
            ],
            "return": {
                "description": "bezier value at position t",
                "type": "Number"
            },
            "example": [
                "\n<div>\n<code>\nnoFill();\ncurve(5, 26, 5, 26, 73, 24, 73, 61);\ncurve(5, 26, 73, 24, 73, 61, 15, 65);\nfill(255);\nellipseMode(CENTER);\nvar steps = 6;\nfor (var i = 0; i <= steps; i++) {\n  var t = i / steps;\n  var x = curvePoint(5, 5, 73, 73, t);\n  var y = curvePoint(26, 26, 24, 61, t);\n  ellipse(x, y, 5, 5);\n  x = curvePoint(5, 73, 73, 15, t);\n  y = curvePoint(26, 24, 61, 65, t);\n  ellipse(x, y, 5, 5);\n}\n</code>\n</div>\n\nline hooking down to right-bottom with 13 5x5 white ellipse points"
            ],
            "class": "p5",
            "module": "Shape",
            "submodule": "Curves"
        },
        {
            "file": "src/core/curves.js",
            "line": 466,
            "description": "<p>Evaluates the tangent to the curve at position t for points a, b, c, d.\nThe parameter t varies between 0 and 1, a and d are points on the curve,\nand b and c are the control points.</p>\n",
            "itemtype": "method",
            "name": "curveTangent",
            "params": [
                {
                    "name": "a",
                    "description": "<p>coordinate of first point on the curve</p>\n",
                    "type": "Number"
                },
                {
                    "name": "b",
                    "description": "<p>coordinate of first control point</p>\n",
                    "type": "Number"
                },
                {
                    "name": "c",
                    "description": "<p>coordinate of second control point</p>\n",
                    "type": "Number"
                },
                {
                    "name": "d",
                    "description": "<p>coordinate of second point on the curve</p>\n",
                    "type": "Number"
                },
                {
                    "name": "t",
                    "description": "<p>value between 0 and 1</p>\n",
                    "type": "Number"
                }
            ],
            "return": {
                "description": "the tangent at position t",
                "type": "Number"
            },
            "example": [
                "\n<div>\n<code>\nnoFill();\ncurve(5, 26, 73, 24, 73, 61, 15, 65);\nvar steps = 6;\nfor (var i = 0; i <= steps; i++) {\n  var t = i / steps;\n  var x = curvePoint(5, 73, 73, 15, t);\n  var y = curvePoint(26, 24, 61, 65, t);\n  //ellipse(x, y, 5, 5);\n  var tx = curveTangent(5, 73, 73, 15, t);\n  var ty = curveTangent(26, 24, 61, 65, t);\n  var a = atan2(ty, tx);\n  a -= PI / 2.0;\n  line(x, y, cos(a) * 8 + x, sin(a) * 8 + y);\n}\n</code>\n</div>"
            ],
            "alt": "right curving line mid-right of canvas with 7 short lines radiating from it.",
            "class": "p5",
            "module": "Shape",
            "submodule": "Curves"
        },
        {
            "file": "src/core/environment.js",
            "line": 22,
            "description": "<p>The print() function writes to the console area of your browser.\nThis function is often helpful for looking at the data a program is\nproducing. This function creates a new line of text for each call to\nthe function. Individual elements can be\nseparated with quotes (&quot;&quot;) and joined with the addition operator (+).</p>\n",
            "itemtype": "method",
            "name": "print",
            "params": [
                {
                    "name": "contents",
                    "description": "<p>any combination of Number, String, Object, Boolean,\n                      Array to print</p>\n",
                    "type": "Any"
                }
            ],
            "example": [
                "\n<div><code class='norender'>\nvar x = 10;\nprint('The value of x is ' + x);\n// prints \"The value of x is 10\"\n</code></div>"
            ],
            "alt": "default grey canvas",
            "class": "p5",
            "module": "Environment",
            "submodule": "Environment"
        },
        {
            "file": "src/core/environment.js",
            "line": 49,
            "description": "<p>The system variable frameCount contains the number of frames that have\nbeen displayed since the program started. Inside setup() the value is 0,\nafter the first iteration of draw it is 1, etc.</p>\n",
            "itemtype": "property",
            "name": "frameCount",
            "type": "Integer",
            "readonly": "",
            "example": [
                "\n  <div><code>\nfunction setup() {\n  frameRate(30);\n  textSize(20);\n  textSize(30);\n  textAlign(CENTER);\n}\n\nfunction draw() {\n  background(200);\n  text(frameCount, width / 2, height / 2);\n}\n</code></div>"
            ],
            "alt": "numbers rapidly counting upward with frame count set to 30.",
            "class": "p5",
            "module": "Environment",
            "submodule": "Environment"
        },
        {
            "file": "src/core/environment.js",
            "line": 77,
            "description": "<p>Confirms if the window a p5.js program is in is &quot;focused,&quot; meaning that\nthe sketch will accept mouse or keyboard input. This variable is\n&quot;true&quot; if the window is focused and &quot;false&quot; if not.</p>\n",
            "itemtype": "property",
            "name": "focused",
            "type": "Boolean",
            "readonly": "",
            "example": [
                "\n<div><code>\n// To demonstrate, put two windows side by side.\n// Click on the window that the p5 sketch isn't in!\nfunction draw() {\n  background(200);\n  noStroke();\n  fill(0, 200, 0);\n  ellipse(25, 25, 50, 50);\n\n  if (!focused) {\n   // or \"if (focused === false)\"\n    stroke(200, 0, 0);\n    line(0, 0, 100, 100);\n    line(100, 0, 0, 100);\n  }\n}\n</code></div>"
            ],
            "alt": "green 50x50 ellipse at top left. Red X covers canvas when page focus changes",
            "class": "p5",
            "module": "Environment",
            "submodule": "Environment"
        },
        {
            "file": "src/core/environment.js",
            "line": 109,
            "description": "<p>Sets the cursor to a predefined symbol or an image, or makes it visible\nif already hidden. If you are trying to set an image as the cursor, the\nrecommended size is 16x16 or 32x32 pixels. It is not possible to load an\nimage as the cursor if you are exporting your program for the Web, and not\nall MODES work with all browsers. The values for parameters x and y must\nbe less than the dimensions of the image.</p>\n",
            "itemtype": "method",
            "name": "cursor",
            "params": [
                {
                    "name": "type",
                    "description": "<p>either ARROW, CROSS, HAND, MOVE, TEXT, or\n                              WAIT, or path for image</p>\n",
                    "type": "String|Constant"
                },
                {
                    "name": "x",
                    "description": "<p>the horizontal active spot of the cursor</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "y",
                    "description": "<p>the vertical active spot of the cursor</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "example": [
                "\n<div><code>\n// Move the mouse left and right across the image\n// to see the cursor change from a cross to a hand\nfunction draw() {\n  line(width / 2, 0, width / 2, height);\n  if (mouseX < 50) {\n    cursor(CROSS);\n  } else {\n    cursor(HAND);\n  }\n}\n</code></div>"
            ],
            "alt": "horizontal line divides canvas. cursor on left is a cross, right is hand.",
            "class": "p5",
            "module": "Environment",
            "submodule": "Environment"
        },
        {
            "file": "src/core/environment.js",
            "line": 170,
            "description": "<p>Specifies the number of frames to be displayed every second. For example,\nthe function call frameRate(30) will attempt to refresh 30 times a second.\nIf the processor is not fast enough to maintain the specified rate, the\nframe rate will not be achieved. Setting the frame rate within setup() is\nrecommended. The default rate is 60 frames per second. This is the same as\nsetFrameRate(val).\n<br><br>\nCalling frameRate() with no arguments returns the current framerate. The\ndraw function must run at least once before it will return a value. This\nis the same as getFrameRate().\n<br><br>\nCalling frameRate() with arguments that are not of the type numbers\nor are non positive also returns current framerate.</p>\n",
            "itemtype": "method",
            "name": "frameRate",
            "chainable": 1,
            "example": [
                "\n\n<div><code>\nvar rectX = 0;\nvar fr = 30; //starting FPS\nvar clr;\n\nfunction setup() {\n  background(200);\n  frameRate(fr); // Attempt to refresh at starting FPS\n  clr = color(255, 0, 0);\n}\n\nfunction draw() {\n  background(200);\n  rectX = rectX += 1; // Move Rectangle\n\n  if (rectX >= width) {\n   // If you go off screen.\n    if (fr === 30) {\n      clr = color(0, 0, 255);\n      fr = 10;\n      frameRate(fr); // make frameRate 10 FPS\n    } else {\n      clr = color(255, 0, 0);\n      fr = 30;\n      frameRate(fr); // make frameRate 30 FPS\n    }\n    rectX = 0;\n  }\n  fill(clr);\n  rect(rectX, 40, 20, 20);\n}\n</code></div>"
            ],
            "alt": "blue rect moves left to right, followed by red rect moving faster. Loops.",
            "class": "p5",
            "module": "Environment",
            "submodule": "Environment",
            "overloads": [
                {
                    "line": 170,
                    "params": [
                        {
                            "name": "fps",
                            "description": "<p>number of frames to be displayed every second</p>\n",
                            "type": "Number"
                        }
                    ],
                    "chainable": 1
                },
                {
                    "line": 228,
                    "params": [],
                    "return": {
                        "description": "current frameRate",
                        "type": "Number"
                    }
                }
            ]
        },
        {
            "file": "src/core/environment.js",
            "line": 268,
            "description": "<p>Hides the cursor from view.</p>\n",
            "itemtype": "method",
            "name": "noCursor",
            "example": [
                "\n<div><code>\nfunction setup() {\n  noCursor();\n}\n\nfunction draw() {\n  background(200);\n  ellipse(mouseX, mouseY, 10, 10);\n}\n</code></div>"
            ],
            "alt": "cursor becomes 10x 10 white ellipse the moves with mouse x and y.",
            "class": "p5",
            "module": "Environment",
            "submodule": "Environment"
        },
        {
            "file": "src/core/environment.js",
            "line": 293,
            "description": "<p>System variable that stores the width of the entire screen display. This\nis used to run a full-screen program on any display size.</p>\n",
            "itemtype": "property",
            "name": "displayWidth",
            "type": "Number",
            "readonly": "",
            "example": [
                "\n<div class=\"norender\"><code>\ncreateCanvas(displayWidth, displayHeight);\n</code></div>"
            ],
            "alt": "cursor becomes 10x 10 white ellipse the moves with mouse x and y.",
            "class": "p5",
            "module": "Environment",
            "submodule": "Environment"
        },
        {
            "file": "src/core/environment.js",
            "line": 310,
            "description": "<p>System variable that stores the height of the entire screen display. This\nis used to run a full-screen program on any display size.</p>\n",
            "itemtype": "property",
            "name": "displayHeight",
            "type": "Number",
            "readonly": "",
            "example": [
                "\n<div class=\"norender\"><code>\ncreateCanvas(displayWidth, displayHeight);\n</code></div>"
            ],
            "alt": "no display.",
            "class": "p5",
            "module": "Environment",
            "submodule": "Environment"
        },
        {
            "file": "src/core/environment.js",
            "line": 327,
            "description": "<p>System variable that stores the width of the inner window, it maps to\nwindow.innerWidth.</p>\n",
            "itemtype": "property",
            "name": "windowWidth",
            "type": "Number",
            "readonly": "",
            "example": [
                "\n<div class=\"norender\"><code>\ncreateCanvas(windowWidth, windowHeight);\n</code></div>"
            ],
            "alt": "no display.",
            "class": "p5",
            "module": "Environment",
            "submodule": "Environment"
        },
        {
            "file": "src/core/environment.js",
            "line": 343,
            "description": "<p>System variable that stores the height of the inner window, it maps to\nwindow.innerHeight.</p>\n",
            "itemtype": "property",
            "name": "windowHeight",
            "type": "Number",
            "readonly": "",
            "example": [
                "\n<div class=\"norender\"><code>\ncreateCanvas(windowWidth, windowHeight);\n</code></div>"
            ],
            "alt": "no display.",
            "class": "p5",
            "module": "Environment",
            "submodule": "Environment"
        },
        {
            "file": "src/core/environment.js",
            "line": 359,
            "description": "<p>The windowResized() function is called once every time the browser window\nis resized. This is a good place to resize the canvas or do any other\nadjustments to accommodate the new window size.</p>\n",
            "itemtype": "method",
            "name": "windowResized",
            "example": [
                "\n<div class=\"norender\"><code>\nfunction setup() {\n  createCanvas(windowWidth, windowHeight);\n}\n\nfunction draw() {\n  background(0, 100, 200);\n}\n\nfunction windowResized() {\n  resizeCanvas(windowWidth, windowHeight);\n}\n</code></div>"
            ],
            "alt": "no display.",
            "class": "p5",
            "module": "Environment",
            "submodule": "Environment"
        },
        {
            "file": "src/core/environment.js",
            "line": 413,
            "description": "<p>System variable that stores the width of the drawing canvas. This value\nis set by the first parameter of the createCanvas() function.\nFor example, the function call createCanvas(320, 240) sets the width\nvariable to the value 320. The value of width defaults to 100 if\ncreateCanvas() is not used in a program.</p>\n",
            "itemtype": "property",
            "name": "width",
            "type": "Number",
            "readonly": "",
            "class": "p5",
            "module": "Environment",
            "submodule": "Environment"
        },
        {
            "file": "src/core/environment.js",
            "line": 425,
            "description": "<p>System variable that stores the height of the drawing canvas. This value\nis set by the second parameter of the createCanvas() function. For\nexample, the function call createCanvas(320, 240) sets the height\nvariable to the value 240. The value of height defaults to 100 if\ncreateCanvas() is not used in a program.</p>\n",
            "itemtype": "property",
            "name": "height",
            "type": "Number",
            "readonly": "",
            "class": "p5",
            "module": "Environment",
            "submodule": "Environment"
        },
        {
            "file": "src/core/environment.js",
            "line": 437,
            "description": "<p>If argument is given, sets the sketch to fullscreen or not based on the\nvalue of the argument. If no argument is given, returns the current\nfullscreen state. Note that due to browser restrictions this can only\nbe called on user input, for example, on mouse press like the example\nbelow.</p>\n",
            "itemtype": "method",
            "name": "fullscreen",
            "params": [
                {
                    "name": "val",
                    "description": "<p>whether the sketch should be in fullscreen mode\nor not</p>\n",
                    "type": "Boolean",
                    "optional": true
                }
            ],
            "return": {
                "description": "current fullscreen state",
                "type": "Boolean"
            },
            "example": [
                "\n<div>\n<code>\n// Clicking in the box toggles fullscreen on and off.\nfunction setup() {\n  background(200);\n}\nfunction mousePressed() {\n  if (mouseX > 0 && mouseX < 100 && mouseY > 0 && mouseY < 100) {\n    var fs = fullscreen();\n    fullscreen(!fs);\n  }\n}\n</code>\n</div>"
            ],
            "alt": "no display.",
            "class": "p5",
            "module": "Environment",
            "submodule": "Environment"
        },
        {
            "file": "src/core/environment.js",
            "line": 488,
            "description": "<p>Sets the pixel scaling for high pixel density displays. By default\npixel density is set to match display density, call pixelDensity(1)\nto turn this off. Calling pixelDensity() with no arguments returns\nthe current pixel density of the sketch.</p>\n",
            "itemtype": "method",
            "name": "pixelDensity",
            "params": [
                {
                    "name": "val",
                    "description": "<p>whether or how much the sketch should scale</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "return": {
                "description": "current pixel density of the sketch",
                "type": "Number"
            },
            "example": [
                "\n<div>\n<code>\nfunction setup() {\n  pixelDensity(1);\n  createCanvas(100, 100);\n  background(200);\n  ellipse(width / 2, height / 2, 50, 50);\n}\n</code>\n</div>\n<div>\n<code>\nfunction setup() {\n  pixelDensity(3.0);\n  createCanvas(100, 100);\n  background(200);\n  ellipse(width / 2, height / 2, 50, 50);\n}\n</code>\n</div>"
            ],
            "alt": "fuzzy 50x50 white ellipse with black outline in center of canvas.\nsharp 50x50 white ellipse with black outline in center of canvas.",
            "class": "p5",
            "module": "Environment",
            "submodule": "Environment"
        },
        {
            "file": "src/core/environment.js",
            "line": 534,
            "description": "<p>Returns the pixel density of the current display the sketch is running on.</p>\n",
            "itemtype": "method",
            "name": "displayDensity",
            "return": {
                "description": "current pixel density of the display",
                "type": "Number"
            },
            "example": [
                "\n<div>\n<code>\nfunction setup() {\n  var density = displayDensity();\n  pixelDensity(density);\n  createCanvas(100, 100);\n  background(200);\n  ellipse(width / 2, height / 2, 50, 50);\n}\n</code>\n</div>"
            ],
            "alt": "50x50 white ellipse with black outline in center of canvas.",
            "class": "p5",
            "module": "Environment",
            "submodule": "Environment"
        },
        {
            "file": "src/core/environment.js",
            "line": 591,
            "description": "<p>Gets the current URL.</p>\n",
            "itemtype": "method",
            "name": "getURL",
            "return": {
                "description": "url",
                "type": "String"
            },
            "example": [
                "\n<div>\n<code>\nvar url;\nvar x = 100;\n\nfunction setup() {\n  fill(0);\n  noStroke();\n  url = getURL();\n}\n\nfunction draw() {\n  background(200);\n  text(url, x, height / 2);\n  x--;\n}\n</code>\n</div>"
            ],
            "alt": "current url (http://p5js.org/reference/#/p5/getURL) moves right to left.",
            "class": "p5",
            "module": "Environment",
            "submodule": "Environment"
        },
        {
            "file": "src/core/environment.js",
            "line": 622,
            "description": "<p>Gets the current URL path as an array.</p>\n",
            "itemtype": "method",
            "name": "getURLPath",
            "return": {
                "description": "path components",
                "type": "String[]"
            },
            "example": [
                "\n<div class='norender'><code>\nfunction setup() {\n  var urlPath = getURLPath();\n  for (var i = 0; i < urlPath.length; i++) {\n    text(urlPath[i], 10, i * 20 + 20);\n  }\n}\n</code></div>"
            ],
            "alt": "no display",
            "class": "p5",
            "module": "Environment",
            "submodule": "Environment"
        },
        {
            "file": "src/core/environment.js",
            "line": 645,
            "description": "<p>Gets the current URL params as an Object.</p>\n",
            "itemtype": "method",
            "name": "getURLParams",
            "return": {
                "description": "URL params",
                "type": "Object"
            },
            "example": [
                "\n<div class='norender'>\n<code>\n// Example: http://p5js.org?year=2014&month=May&day=15\n\nfunction setup() {\n  var params = getURLParams();\n  text(params.day, 10, 20);\n  text(params.month, 10, 40);\n  text(params.year, 10, 60);\n}\n</code>\n</div>"
            ],
            "alt": "no display.",
            "class": "p5",
            "module": "Environment",
            "submodule": "Environment"
        },
        {
            "file": "src/core/error_helpers.js",
            "line": 1,
            "requires": [
                "core"
            ],
            "class": "p5",
            "module": "Environment"
        },
        {
            "file": "src/core/error_helpers.js",
            "line": 397,
            "description": "<p>Validates parameters\nparam  {String}               func    the name of the function\nparam  {Array}                args    user input arguments</p>\n<p>example:\n var a;\n ellipse(10,10,a,5);\nconsole ouput:\n &quot;It looks like ellipse received an empty variable in spot #2.&quot;</p>\n<p>example:\n ellipse(10,&quot;foo&quot;,5,5);\nconsole output:\n &quot;ellipse was expecting a number for parameter #1,\n          received &quot;foo&quot; instead.&quot;</p>\n",
            "class": "p5",
            "module": "Environment"
        },
        {
            "file": "src/core/error_helpers.js",
            "line": 449,
            "description": "<p>Prints out all the colors in the color pallete with white text.\nFor color blindness testing.</p>\n",
            "class": "p5",
            "module": "Environment"
        },
        {
            "file": "src/core/p5.Element.js",
            "line": 27,
            "description": "<p>Underlying HTML element. All normal HTML methods can be called on this.</p>\n",
            "example": [
                "\n<div>\n<code>\ncreateCanvas(300, 500);\nbackground(0, 0, 0, 0);\nvar input = createInput();\ninput.position(20, 225);\nvar inputElem = new p5.Element(input.elt);\ninputElem.style('width:450px;');\ninputElem.value('some string');\n</code>\n</div>"
            ],
            "itemtype": "property",
            "name": "elt",
            "readonly": "",
            "class": "p5.Element",
            "module": "DOM",
            "submodule": "DOM"
        },
        {
            "file": "src/core/p5.Element.js",
            "line": 53,
            "description": "<p>Attaches the element to the parent specified. A way of setting\n the container for the element. Accepts either a string ID, DOM\n node, or p5.Element. If no arguments given, parent node is returned.\n For more ways to position the canvas, see the\n <a href='https://github.com/processing/p5.js/wiki/Positioning-your-canvas'>\n positioning the canvas</a> wiki page.</p>\n",
            "itemtype": "method",
            "name": "parent",
            "chainable": 1,
            "example": [
                "\n <div class=\"norender\"><code>\n // in the html file:\n // &lt;div id=\"myContainer\">&lt;/div>\n// in the js file:\n var cnv = createCanvas(100, 100);\n cnv.parent('myContainer');\n </code></div>\n <div class='norender'><code>\n var div0 = createDiv('this is the parent');\n var div1 = createDiv('this is the child');\n div1.parent(div0); // use p5.Element\n </code></div>\n <div class='norender'><code>\n var div0 = createDiv('this is the parent');\n div0.id('apples');\n var div1 = createDiv('this is the child');\n div1.parent('apples'); // use id\n </code></div>\n <div class='norender'><code>\n var elt = document.getElementById('myParentDiv');\n var div1 = createDiv('this is the child');\n div1.parent(elt); // use element from page\n </code></div>"
            ],
            "alt": "no display.",
            "class": "p5.Element",
            "module": "DOM",
            "submodule": "DOM",
            "overloads": [
                {
                    "line": 53,
                    "params": [
                        {
                            "name": "parent",
                            "description": "<p>the ID, DOM node, or p5.Element\n                         of desired parent element</p>\n",
                            "type": "String|p5.Element|Object"
                        }
                    ],
                    "chainable": 1
                },
                {
                    "line": 96,
                    "params": [],
                    "return": {
                        "description": "",
                        "type": "p5.Element"
                    }
                }
            ]
        },
        {
            "file": "src/core/p5.Element.js",
            "line": 118,
            "description": "<p>Sets the ID of the element. If no ID argument is passed in, it instead\n returns the current ID of the element.</p>\n",
            "itemtype": "method",
            "name": "id",
            "chainable": 1,
            "example": [
                "\n <div class='norender'><code>\n function setup() {\n   var cnv = createCanvas(100, 100);\n   // Assigns a CSS selector ID to\n   // the canvas element.\n   cnv.id('mycanvas');\n }\n </code></div>"
            ],
            "alt": "no display.",
            "class": "p5.Element",
            "module": "DOM",
            "submodule": "DOM",
            "overloads": [
                {
                    "line": 118,
                    "params": [
                        {
                            "name": "id",
                            "description": "<p>ID of the element</p>\n",
                            "type": "String"
                        }
                    ],
                    "chainable": 1
                },
                {
                    "line": 140,
                    "params": [],
                    "return": {
                        "description": "the id of the element",
                        "type": "String"
                    }
                }
            ]
        },
        {
            "file": "src/core/p5.Element.js",
            "line": 155,
            "description": "<p>Adds given class to the element. If no class argument is passed in, it\n instead returns a string containing the current class(es) of the element.</p>\n",
            "itemtype": "method",
            "name": "class",
            "chainable": 1,
            "example": [
                "\n <div class='norender'><code>\n function setup() {\n   var cnv = createCanvas(100, 100);\n   // Assigns a CSS selector class 'small'\n   // to the canvas element.\n   cnv.class('small');\n }\n </code></div>"
            ],
            "alt": "no display.",
            "class": "p5.Element",
            "module": "DOM",
            "submodule": "DOM",
            "overloads": [
                {
                    "line": 155,
                    "params": [
                        {
                            "name": "class",
                            "description": "<p>class to add</p>\n",
                            "type": "String"
                        }
                    ],
                    "chainable": 1
                },
                {
                    "line": 177,
                    "params": [],
                    "return": {
                        "description": "the class of the element",
                        "type": "String"
                    }
                }
            ]
        },
        {
            "file": "src/core/p5.Element.js",
            "line": 190,
            "description": "<p>The .mousePressed() function is called once after every time a\nmouse button is pressed over the element. This can be used to\nattach element specific event listeners.</p>\n",
            "itemtype": "method",
            "name": "mousePressed",
            "params": [
                {
                    "name": "fxn",
                    "description": "<p>function to be fired when mouse is\n                               pressed over the element.\n                               if <code>false</code> is passed instead, the previously\n                               firing function will no longer fire.</p>\n",
                    "type": "Function|Boolean"
                }
            ],
            "chainable": 1,
            "example": [
                "\n<div class='norender'><code>\nvar cnv;\nvar d;\nvar g;\nfunction setup() {\n  cnv = createCanvas(100, 100);\n  cnv.mousePressed(changeGray); // attach listener for\n  // canvas click only\n  d = 10;\n  g = 100;\n}\n\nfunction draw() {\n  background(g);\n  ellipse(width / 2, height / 2, d, d);\n}\n\n// this function fires with any click anywhere\nfunction mousePressed() {\n  d = d + 10;\n}\n\n// this function fires only when cnv is clicked\nfunction changeGray() {\n  g = random(0, 255);\n}\n</code></div>"
            ],
            "alt": "no display.",
            "class": "p5.Element",
            "module": "DOM",
            "submodule": "DOM"
        },
        {
            "file": "src/core/p5.Element.js",
            "line": 240,
            "description": "<p>The .doubleClicked() function is called once after every time a\nmouse button is pressed twice over the element. This can be used to\nattach element and action specific event listeners.</p>\n",
            "itemtype": "method",
            "name": "doubleClicked",
            "params": [
                {
                    "name": "fxn",
                    "description": "<p>function to be fired when mouse is\n                               double clicked over the element.\n                               if <code>false</code> is passed instead, the previously\n                               firing function will no longer fire.</p>\n",
                    "type": "Function|Boolean"
                }
            ],
            "return": {
                "description": "",
                "type": "p5.Element"
            },
            "example": [
                "\n<div class='norender'><code>\nvar cnv;\nvar d;\nvar g;\nfunction setup() {\n  cnv = createCanvas(100, 100);\n  cnv.doubleClicked(changeGray); // attach listener for\n  // canvas double click only\n  d = 10;\n  g = 100;\n}\n\nfunction draw() {\n  background(g);\n  ellipse(width / 2, height / 2, d, d);\n}\n\n// this function fires with any double click anywhere\nfunction doubleClicked() {\n  d = d + 10;\n}\n\n// this function fires only when cnv is double clicked\nfunction changeGray() {\n  g = random(0, 255);\n}\n</code></div>"
            ],
            "alt": "no display.",
            "class": "p5.Element",
            "module": "DOM",
            "submodule": "DOM"
        },
        {
            "file": "src/core/p5.Element.js",
            "line": 289,
            "description": "<p>The .mouseWheel() function is called once after every time a\nmouse wheel is scrolled over the element. This can be used to\nattach element specific event listeners.\n<br><br>\nThe function accepts a callback function as argument which will be executed\nwhen the <code>wheel</code> event is triggered on the element, the callback function is\npassed one argument <code>event</code>. The <code>event.deltaY</code> property returns negative\nvalues if the mouse wheel is rotated up or away from the user and positive\nin the other direction. The <code>event.deltaX</code> does the same as <code>event.deltaY</code>\nexcept it reads the horizontal wheel scroll of the mouse wheel.\n<br><br>\nOn OS X with &quot;natural&quot; scrolling enabled, the <code>event.deltaY</code> values are\nreversed.</p>\n",
            "itemtype": "method",
            "name": "mouseWheel",
            "params": [
                {
                    "name": "fxn",
                    "description": "<p>function to be fired when mouse is\n                               scrolled over the element.\n                               if <code>false</code> is passed instead, the previously\n                               firing function will no longer fire.</p>\n",
                    "type": "Function|Boolean"
                }
            ],
            "chainable": 1,
            "example": [
                "\n<div class='norender'><code>\nvar cnv;\nvar d;\nvar g;\nfunction setup() {\n  cnv = createCanvas(100, 100);\n  cnv.mouseWheel(changeSize); // attach listener for\n  // activity on canvas only\n  d = 10;\n  g = 100;\n}\n\nfunction draw() {\n  background(g);\n  ellipse(width / 2, height / 2, d, d);\n}\n\n// this function fires with mousewheel movement\n// anywhere on screen\nfunction mouseWheel() {\n  g = g + 10;\n}\n\n// this function fires with mousewheel movement\n// over canvas only\nfunction changeSize(event) {\n  if (event.deltaY > 0) {\n    d = d + 10;\n  } else {\n    d = d - 10;\n  }\n}\n</code></div>"
            ],
            "alt": "no display.",
            "class": "p5.Element",
            "module": "DOM",
            "submodule": "DOM"
        },
        {
            "file": "src/core/p5.Element.js",
            "line": 355,
            "description": "<p>The .mouseReleased() function is called once after every time a\nmouse button is released over the element. This can be used to\nattach element specific event listeners.</p>\n",
            "itemtype": "method",
            "name": "mouseReleased",
            "params": [
                {
                    "name": "fxn",
                    "description": "<p>function to be fired when mouse is\n                               released over the element.\n                               if <code>false</code> is passed instead, the previously\n                               firing function will no longer fire.</p>\n",
                    "type": "Function|Boolean"
                }
            ],
            "chainable": 1,
            "example": [
                "\n<div class='norender'><code>\nvar cnv;\nvar d;\nvar g;\nfunction setup() {\n  cnv = createCanvas(100, 100);\n  cnv.mouseReleased(changeGray); // attach listener for\n  // activity on canvas only\n  d = 10;\n  g = 100;\n}\n\nfunction draw() {\n  background(g);\n  ellipse(width / 2, height / 2, d, d);\n}\n\n// this function fires after the mouse has been\n// released\nfunction mouseReleased() {\n  d = d + 10;\n}\n\n// this function fires after the mouse has been\n// released while on canvas\nfunction changeGray() {\n  g = random(0, 255);\n}\n</code></div>"
            ],
            "alt": "no display.",
            "class": "p5.Element",
            "module": "DOM",
            "submodule": "DOM"
        },
        {
            "file": "src/core/p5.Element.js",
            "line": 408,
            "description": "<p>The .mouseClicked() function is called once after a mouse button is\npressed and released over the element. This can be used to\nattach element specific event listeners.</p>\n",
            "itemtype": "method",
            "name": "mouseClicked",
            "params": [
                {
                    "name": "fxn",
                    "description": "<p>function to be fired when mouse is\n                               clicked over the element.\n                               if <code>false</code> is passed instead, the previously\n                               firing function will no longer fire.</p>\n",
                    "type": "Function|Boolean"
                }
            ],
            "chainable": 1,
            "example": [
                "\n<div class=\"norender\">\n<code>\nvar cnv;\nvar d;\nvar g;\n\nfunction setup() {\n  cnv = createCanvas(100, 100);\n  cnv.mouseClicked(changeGray); // attach listener for\n  // activity on canvas only\n  d = 10;\n  g = 100;\n}\n\nfunction draw() {\n  background(g);\n  ellipse(width / 2, height / 2, d, d);\n}\n\n// this function fires after the mouse has been\n// clicked anywhere\nfunction mouseClicked() {\n  d = d + 10;\n}\n\n// this function fires after the mouse has been\n// clicked on canvas\nfunction changeGray() {\n  g = random(0, 255);\n}\n</code>\n</div>"
            ],
            "alt": "no display.",
            "class": "p5.Element",
            "module": "DOM",
            "submodule": "DOM"
        },
        {
            "file": "src/core/p5.Element.js",
            "line": 462,
            "description": "<p>The .mouseMoved() function is called once every time a\nmouse moves over the element. This can be used to attach an\nelement specific event listener.</p>\n",
            "itemtype": "method",
            "name": "mouseMoved",
            "params": [
                {
                    "name": "fxn",
                    "description": "<p>function to be fired when a mouse moves\n                               over the element.\n                               if <code>false</code> is passed instead, the previously\n                               firing function will no longer fire.</p>\n",
                    "type": "Function|Boolean"
                }
            ],
            "chainable": 1,
            "example": [
                "\n<div class='norender'><code>\nvar cnv;\nvar d = 30;\nvar g;\nfunction setup() {\n  cnv = createCanvas(100, 100);\n  cnv.mouseMoved(changeSize); // attach listener for\n  // activity on canvas only\n  d = 10;\n  g = 100;\n}\n\nfunction draw() {\n  background(g);\n  fill(200);\n  ellipse(width / 2, height / 2, d, d);\n}\n\n// this function fires when mouse moves anywhere on\n// page\nfunction mouseMoved() {\n  g = g + 5;\n  if (g > 255) {\n    g = 0;\n  }\n}\n\n// this function fires when mouse moves over canvas\nfunction changeSize() {\n  d = d + 2;\n  if (d > 100) {\n    d = 0;\n  }\n}\n</code></div>"
            ],
            "alt": "no display.",
            "class": "p5.Element",
            "module": "DOM",
            "submodule": "DOM"
        },
        {
            "file": "src/core/p5.Element.js",
            "line": 521,
            "description": "<p>The .mouseOver() function is called once after every time a\nmouse moves onto the element. This can be used to attach an\nelement specific event listener.</p>\n",
            "itemtype": "method",
            "name": "mouseOver",
            "params": [
                {
                    "name": "fxn",
                    "description": "<p>function to be fired when a mouse moves\n                               onto the element.\n                               if <code>false</code> is passed instead, the previously\n                               firing function will no longer fire.</p>\n",
                    "type": "Function|Boolean"
                }
            ],
            "chainable": 1,
            "example": [
                "\n<div class='norender'><code>\nvar cnv;\nvar d;\nfunction setup() {\n  cnv = createCanvas(100, 100);\n  cnv.mouseOver(changeGray);\n  d = 10;\n}\n\nfunction draw() {\n  ellipse(width / 2, height / 2, d, d);\n}\n\nfunction changeGray() {\n  d = d + 10;\n  if (d > 100) {\n    d = 0;\n  }\n}\n</code></div>"
            ],
            "alt": "no display.",
            "class": "p5.Element",
            "module": "DOM",
            "submodule": "DOM"
        },
        {
            "file": "src/core/p5.Element.js",
            "line": 564,
            "description": "<p>The .changed() function is called when the value of an\nelement changes.\nThis can be used to attach an element specific event listener.</p>\n",
            "itemtype": "method",
            "name": "changed",
            "params": [
                {
                    "name": "fxn",
                    "description": "<p>function to be fired when the value of\n                               an element changes.\n                               if <code>false</code> is passed instead, the previously\n                               firing function will no longer fire.</p>\n",
                    "type": "Function|Boolean"
                }
            ],
            "chainable": 1,
            "example": [
                "\n<div><code>\nvar sel;\n\nfunction setup() {\n  textAlign(CENTER);\n  background(200);\n  sel = createSelect();\n  sel.position(10, 10);\n  sel.option('pear');\n  sel.option('kiwi');\n  sel.option('grape');\n  sel.changed(mySelectEvent);\n}\n\nfunction mySelectEvent() {\n  var item = sel.value();\n  background(200);\n  text(\"it's a \" + item + '!', 50, 50);\n}\n</code></div>\n<div><code>\nvar checkbox;\nvar cnv;\n\nfunction setup() {\n  checkbox = createCheckbox(' fill');\n  checkbox.changed(changeFill);\n  cnv = createCanvas(100, 100);\n  cnv.position(0, 30);\n  noFill();\n}\n\nfunction draw() {\n  background(200);\n  ellipse(50, 50, 50, 50);\n}\n\nfunction changeFill() {\n  if (checkbox.checked()) {\n    fill(0);\n  } else {\n    noFill();\n  }\n}\n</code></div>"
            ],
            "alt": "dropdown: pear, kiwi, grape. When selected text \"its a\" + selection shown.",
            "class": "p5.Element",
            "module": "DOM",
            "submodule": "DOM"
        },
        {
            "file": "src/core/p5.Element.js",
            "line": 631,
            "description": "<p>The .input() function is called when any user input is\ndetected with an element. The input event is often used\nto detect keystrokes in a input element, or changes on a\nslider element. This can be used to attach an element specific\nevent listener.</p>\n",
            "itemtype": "method",
            "name": "input",
            "params": [
                {
                    "name": "fxn",
                    "description": "<p>function to be fired when any user input is\n                               detected within the element.\n                               if <code>false</code> is passed instead, the previously\n                               firing function will no longer fire.</p>\n",
                    "type": "Function|Boolean"
                }
            ],
            "chainable": 1,
            "example": [
                "\n<div class='norender'><code>\n// Open your console to see the output\nfunction setup() {\n  var inp = createInput('');\n  inp.input(myInputEvent);\n}\n\nfunction myInputEvent() {\n  console.log('you are typing: ', this.value());\n}\n</code></div>"
            ],
            "alt": "no display.",
            "class": "p5.Element",
            "module": "DOM",
            "submodule": "DOM"
        },
        {
            "file": "src/core/p5.Element.js",
            "line": 666,
            "description": "<p>The .mouseOut() function is called once after every time a\nmouse moves off the element. This can be used to attach an\nelement specific event listener.</p>\n",
            "itemtype": "method",
            "name": "mouseOut",
            "params": [
                {
                    "name": "fxn",
                    "description": "<p>function to be fired when a mouse\n                               moves off of an element.\n                               if <code>false</code> is passed instead, the previously\n                               firing function will no longer fire.</p>\n",
                    "type": "Function|Boolean"
                }
            ],
            "chainable": 1,
            "example": [
                "\n<div class='norender'><code>\nvar cnv;\nvar d;\nfunction setup() {\n  cnv = createCanvas(100, 100);\n  cnv.mouseOut(changeGray);\n  d = 10;\n}\n\nfunction draw() {\n  ellipse(width / 2, height / 2, d, d);\n}\n\nfunction changeGray() {\n  d = d + 10;\n  if (d > 100) {\n    d = 0;\n  }\n}\n</code></div>"
            ],
            "alt": "no display.",
            "class": "p5.Element",
            "module": "DOM",
            "submodule": "DOM"
        },
        {
            "file": "src/core/p5.Element.js",
            "line": 708,
            "description": "<p>The .touchStarted() function is called once after every time a touch is\nregistered. This can be used to attach element specific event listeners.</p>\n",
            "itemtype": "method",
            "name": "touchStarted",
            "params": [
                {
                    "name": "fxn",
                    "description": "<p>function to be fired when a touch\n                               starts over the element.\n                               if <code>false</code> is passed instead, the previously\n                               firing function will no longer fire.</p>\n",
                    "type": "Function|Boolean"
                }
            ],
            "chainable": 1,
            "example": [
                "\n<div class='norender'><code>\nvar cnv;\nvar d;\nvar g;\nfunction setup() {\n  cnv = createCanvas(100, 100);\n  cnv.touchStarted(changeGray); // attach listener for\n  // canvas click only\n  d = 10;\n  g = 100;\n}\n\nfunction draw() {\n  background(g);\n  ellipse(width / 2, height / 2, d, d);\n}\n\n// this function fires with any touch anywhere\nfunction touchStarted() {\n  d = d + 10;\n}\n\n// this function fires only when cnv is clicked\nfunction changeGray() {\n  g = random(0, 255);\n}\n</code></div>"
            ],
            "alt": "no display.",
            "class": "p5.Element",
            "module": "DOM",
            "submodule": "DOM"
        },
        {
            "file": "src/core/p5.Element.js",
            "line": 757,
            "description": "<p>The .touchMoved() function is called once after every time a touch move is\nregistered. This can be used to attach element specific event listeners.</p>\n",
            "itemtype": "method",
            "name": "touchMoved",
            "params": [
                {
                    "name": "fxn",
                    "description": "<p>function to be fired when a touch moves over\n                               the element.\n                               if <code>false</code> is passed instead, the previously\n                               firing function will no longer fire.</p>\n",
                    "type": "Function|Boolean"
                }
            ],
            "chainable": 1,
            "example": [
                "\n<div class='norender'><code>\nvar cnv;\nvar g;\nfunction setup() {\n  cnv = createCanvas(100, 100);\n  cnv.touchMoved(changeGray); // attach listener for\n  // canvas click only\n  g = 100;\n}\n\nfunction draw() {\n  background(g);\n}\n\n// this function fires only when cnv is clicked\nfunction changeGray() {\n  g = random(0, 255);\n}\n</code></div>"
            ],
            "alt": "no display.",
            "class": "p5.Element",
            "module": "DOM",
            "submodule": "DOM"
        },
        {
            "file": "src/core/p5.Element.js",
            "line": 798,
            "description": "<p>The .touchEnded() function is called once after every time a touch is\nregistered. This can be used to attach element specific event listeners.</p>\n",
            "itemtype": "method",
            "name": "touchEnded",
            "params": [
                {
                    "name": "fxn",
                    "description": "<p>function to be fired when a touch ends\n                               over the element.\n                               if <code>false</code> is passed instead, the previously\n                               firing function will no longer fire.</p>\n",
                    "type": "Function|Boolean"
                }
            ],
            "chainable": 1,
            "example": [
                "\n<div class='norender'><code>\nvar cnv;\nvar d;\nvar g;\nfunction setup() {\n  cnv = createCanvas(100, 100);\n  cnv.touchEnded(changeGray); // attach listener for\n  // canvas click only\n  d = 10;\n  g = 100;\n}\n\nfunction draw() {\n  background(g);\n  ellipse(width / 2, height / 2, d, d);\n}\n\n// this function fires with any touch anywhere\nfunction touchEnded() {\n  d = d + 10;\n}\n\n// this function fires only when cnv is clicked\nfunction changeGray() {\n  g = random(0, 255);\n}\n</code></div>"
            ],
            "alt": "no display.",
            "class": "p5.Element",
            "module": "DOM",
            "submodule": "DOM"
        },
        {
            "file": "src/core/p5.Element.js",
            "line": 848,
            "description": "<p>The .dragOver() function is called once after every time a\nfile is dragged over the element. This can be used to attach an\nelement specific event listener.</p>\n",
            "itemtype": "method",
            "name": "dragOver",
            "params": [
                {
                    "name": "fxn",
                    "description": "<p>function to be fired when a file is\n                               dragged over the element.\n                               if <code>false</code> is passed instead, the previously\n                               firing function will no longer fire.</p>\n",
                    "type": "Function|Boolean"
                }
            ],
            "chainable": 1,
            "example": [
                "\n<div><code>\n// To test this sketch, simply drag a\n// file over the canvas\nfunction setup() {\n  var c = createCanvas(100, 100);\n  background(200);\n  textAlign(CENTER);\n  text('Drag file', width / 2, height / 2);\n  c.dragOver(dragOverCallback);\n}\n\n// This function will be called whenever\n// a file is dragged over the canvas\nfunction dragOverCallback() {\n  background(240);\n  text('Dragged over', width / 2, height / 2);\n}\n</code></div>"
            ],
            "alt": "nothing displayed",
            "class": "p5.Element",
            "module": "DOM",
            "submodule": "DOM"
        },
        {
            "file": "src/core/p5.Element.js",
            "line": 886,
            "description": "<p>The .dragLeave() function is called once after every time a\ndragged file leaves the element area. This can be used to attach an\nelement specific event listener.</p>\n",
            "itemtype": "method",
            "name": "dragLeave",
            "params": [
                {
                    "name": "fxn",
                    "description": "<p>function to be fired when a file is\n                               dragged off the element.\n                               if <code>false</code> is passed instead, the previously\n                               firing function will no longer fire.</p>\n",
                    "type": "Function|Boolean"
                }
            ],
            "chainable": 1,
            "example": [
                "\n<div><code>\n// To test this sketch, simply drag a file\n// over and then out of the canvas area\nfunction setup() {\n  var c = createCanvas(100, 100);\n  background(200);\n  textAlign(CENTER);\n  text('Drag file', width / 2, height / 2);\n  c.dragLeave(dragLeaveCallback);\n}\n\n// This function will be called whenever\n// a file is dragged out of the canvas\nfunction dragLeaveCallback() {\n  background(240);\n  text('Dragged off', width / 2, height / 2);\n}\n</code></div>"
            ],
            "alt": "nothing displayed",
            "class": "p5.Element",
            "module": "DOM",
            "submodule": "DOM"
        },
        {
            "file": "src/core/p5.Element.js",
            "line": 924,
            "description": "<p>The .drop() function is called for each file dropped on the element.\nIt requires a callback that is passed a p5.File object.  You can\noptionally pass two callbacks, the first one (required) is triggered\nfor each file dropped when the file is loaded.  The second (optional)\nis triggered just once when a file (or files) are dropped.</p>\n",
            "itemtype": "method",
            "name": "drop",
            "params": [
                {
                    "name": "callback",
                    "description": "<p>callback triggered when files are dropped.</p>\n",
                    "type": "Function"
                },
                {
                    "name": "fxn",
                    "description": "<p>callback to receive loaded file.</p>\n",
                    "type": "Function",
                    "optional": true
                }
            ],
            "chainable": 1,
            "example": [
                "\n<div><code>\nfunction setup() {\n  var c = createCanvas(100, 100);\n  background(200);\n  textAlign(CENTER);\n  text('drop image', width / 2, height / 2);\n  c.drop(gotFile);\n}\n\nfunction gotFile(file) {\n  var img = createImg(file.data).hide();\n  // Draw the image onto the canvas\n  image(img, 0, 0, width, height);\n}\n</code></div>"
            ],
            "alt": "Canvas turns into whatever image is dragged/dropped onto it.",
            "class": "p5.Element",
            "module": "DOM",
            "submodule": "DOM"
        },
        {
            "file": "src/core/p5.Element.js",
            "line": 1059,
            "description": "<p>Helper fxn for sharing pixel methods</p>\n",
            "class": "p5.Element",
            "module": "DOM",
            "submodule": "DOM"
        },
        {
            "file": "src/core/p5.Graphics.js",
            "line": 68,
            "itemtype": "method",
            "name": "remove",
            "class": "p5.Graphics",
            "module": "Rendering",
            "submodule": "Rendering"
        },
        {
            "file": "src/core/p5.Renderer.js",
            "line": 63,
            "description": "<p>Resize our canvas element.</p>\n",
            "class": "p5.Renderer",
            "module": "Rendering",
            "submodule": "Rendering"
        },
        {
            "file": "src/core/p5.Renderer.js",
            "line": 132,
            "description": "<p>Helper fxn to check font type (system or otf)</p>\n",
            "class": "p5.Renderer",
            "module": "Rendering",
            "submodule": "Rendering"
        },
        {
            "file": "src/core/p5.Renderer.js",
            "line": 185,
            "description": "<p>Helper fxn to measure ascent and descent.\nAdapted from <a href=\"http://stackoverflow.com/a/25355178\">http://stackoverflow.com/a/25355178</a></p>\n",
            "class": "p5.Renderer",
            "module": "Rendering",
            "submodule": "Rendering"
        },
        {
            "file": "src/core/p5.Renderer2D.js",
            "line": 10,
            "description": "<p>p5.Renderer2D\nThe 2D graphics canvas renderer class.\nextends p5.Renderer</p>\n",
            "class": "p5",
            "module": "Rendering"
        },
        {
            "file": "src/core/p5.Renderer2D.js",
            "line": 404,
            "description": "<p>Generate a cubic Bezier representing an arc on the unit circle of total\nangle <code>size</code> radians, beginning <code>start</code> radians above the x-axis. Up to\nfour of these curves are combined to make a full arc.</p>\n<p>See www.joecridge.me/bezier.pdf for an explanation of the method.</p>\n",
            "class": "p5",
            "module": "Rendering"
        },
        {
            "file": "src/core/rendering.js",
            "line": 16,
            "description": "<p>Creates a canvas element in the document, and sets the dimensions of it\nin pixels. This method should be called only once at the start of setup.\nCalling createCanvas more than once in a sketch will result in very\nunpredictable behavior. If you want more than one drawing canvas\nyou could use createGraphics (hidden by default but it can be shown).\n<br><br>\nThe system variables width and height are set by the parameters passed\nto this function. If createCanvas() is not used, the window will be\ngiven a default size of 100x100 pixels.\n<br><br>\nFor more ways to position the canvas, see the\n<a href='https://github.com/processing/p5.js/wiki/Positioning-your-canvas'>\npositioning the canvas</a> wiki page.</p>\n",
            "itemtype": "method",
            "name": "createCanvas",
            "params": [
                {
                    "name": "w",
                    "description": "<p>width of the canvas</p>\n",
                    "type": "Number"
                },
                {
                    "name": "h",
                    "description": "<p>height of the canvas</p>\n",
                    "type": "Number"
                },
                {
                    "name": "renderer",
                    "description": "<p>either P2D or WEBGL</p>\n",
                    "type": "Constant",
                    "optional": true
                }
            ],
            "return": {
                "description": "canvas generated",
                "type": "HTMLCanvasElement"
            },
            "example": [
                "\n<div>\n<code>\nfunction setup() {\n  createCanvas(100, 50);\n  background(153);\n  line(0, 0, width, height);\n}\n</code>\n</div>"
            ],
            "alt": "Black line extending from top-left of canvas to bottom right.",
            "class": "p5",
            "module": "Rendering",
            "submodule": "Rendering"
        },
        {
            "file": "src/core/rendering.js",
            "line": 116,
            "description": "<p>Resizes the canvas to given width and height. The canvas will be cleared\nand draw will be called immediately, allowing the sketch to re-render itself\nin the resized canvas.</p>\n",
            "itemtype": "method",
            "name": "resizeCanvas",
            "params": [
                {
                    "name": "w",
                    "description": "<p>width of the canvas</p>\n",
                    "type": "Number"
                },
                {
                    "name": "h",
                    "description": "<p>height of the canvas</p>\n",
                    "type": "Number"
                },
                {
                    "name": "noRedraw",
                    "description": "<p>don&#39;t redraw the canvas immediately</p>\n",
                    "type": "Boolean",
                    "optional": true
                }
            ],
            "example": [
                "\n<div class=\"norender\"><code>\nfunction setup() {\n  createCanvas(windowWidth, windowHeight);\n}\n\nfunction draw() {\n  background(0, 100, 200);\n}\n\nfunction windowResized() {\n  resizeCanvas(windowWidth, windowHeight);\n}\n</code></div>"
            ],
            "alt": "No image displayed.",
            "class": "p5",
            "module": "Rendering",
            "submodule": "Rendering"
        },
        {
            "file": "src/core/rendering.js",
            "line": 169,
            "description": "<p>Removes the default canvas for a p5 sketch that doesn&#39;t\nrequire a canvas</p>\n",
            "itemtype": "method",
            "name": "noCanvas",
            "example": [
                "\n<div>\n<code>\nfunction setup() {\n  noCanvas();\n}\n</code>\n</div>"
            ],
            "alt": "no image displayed",
            "class": "p5",
            "module": "Rendering",
            "submodule": "Rendering"
        },
        {
            "file": "src/core/rendering.js",
            "line": 192,
            "description": "<p>Creates and returns a new p5.Renderer object. Use this class if you need\nto draw into an off-screen graphics buffer. The two parameters define the\nwidth and height in pixels.</p>\n",
            "itemtype": "method",
            "name": "createGraphics",
            "params": [
                {
                    "name": "w",
                    "description": "<p>width of the offscreen graphics buffer</p>\n",
                    "type": "Number"
                },
                {
                    "name": "h",
                    "description": "<p>height of the offscreen graphics buffer</p>\n",
                    "type": "Number"
                },
                {
                    "name": "renderer",
                    "description": "<p>either P2D or WEBGL\nundefined defaults to p2d</p>\n",
                    "type": "Constant",
                    "optional": true
                }
            ],
            "return": {
                "description": "offscreen graphics buffer",
                "type": "p5.Graphics"
            },
            "example": [
                "\n<div>\n<code>\nvar pg;\nfunction setup() {\n  createCanvas(100, 100);\n  pg = createGraphics(100, 100);\n}\nfunction draw() {\n  background(200);\n  pg.background(100);\n  pg.noStroke();\n  pg.ellipse(pg.width / 2, pg.height / 2, 50, 50);\n  image(pg, 50, 50);\n  image(pg, 0, 0, 50, 50);\n}\n</code>\n</div>"
            ],
            "alt": "4 grey squares alternating light and dark grey. White quarter circle mid-left.",
            "class": "p5",
            "module": "Rendering",
            "submodule": "Rendering"
        },
        {
            "file": "src/core/rendering.js",
            "line": 231,
            "description": "<p>Blends the pixels in the display window according to the defined mode.\nThere is a choice of the following modes to blend the source pixels (A)\nwith the ones of pixels already in the display window (B):</p>\n<ul>\n<li><code>BLEND</code> - linear interpolation of colours: C =\nA<em>factor + B. This is the default blending mode.</li>\n<li><code>ADD</code> - sum of A and B</li>\n<li><code>DARKEST</code> - only the darkest colour succeeds: C =\nmin(A</em>factor, B).</li>\n<li><code>LIGHTEST</code> - only the lightest colour succeeds: C =\nmax(A*factor, B).</li>\n<li><code>DIFFERENCE</code> - subtract colors from underlying image.</li>\n<li><code>EXCLUSION</code> - similar to <code>DIFFERENCE</code>, but less\nextreme.</li>\n<li><code>MULTIPLY</code> - multiply the colors, result will always be\ndarker.</li>\n<li><code>SCREEN</code> - opposite multiply, uses inverse values of the\ncolors.</li>\n<li><code>REPLACE</code> - the pixels entirely replace the others and\ndon&#39;t utilize alpha (transparency) values.</li>\n<li><code>OVERLAY</code> - mix of <code>MULTIPLY</code> and <code>SCREEN\n</code>. Multiplies dark values, and screens light values.</li>\n<li><code>HARD_LIGHT</code> - <code>SCREEN</code> when greater than 50%\ngray, <code>MULTIPLY</code> when lower.</li>\n<li><code>SOFT_LIGHT</code> - mix of <code>DARKEST</code> and\n<code>LIGHTEST</code>. Works like <code>OVERLAY</code>, but not as harsh.\n</li>\n<li><code>DODGE</code> - lightens light tones and increases contrast,\nignores darks.</li>\n<li><code>BURN</code> - darker areas are applied, increasing contrast,\nignores lights.</li>\n</ul>",
            "itemtype": "method",
            "name": "blendMode",
            "params": [
                {
                    "name": "mode",
                    "description": "<p>blend mode to set for canvas.\n               either BLEND, DARKEST, LIGHTEST, DIFFERENCE, MULTIPLY,\n               EXCLUSION, SCREEN, REPLACE, OVERLAY, HARD_LIGHT,\n               SOFT_LIGHT, DODGE, BURN, ADD or NORMAL</p>\n",
                    "type": "Constant"
                }
            ],
            "example": [
                "\n<div>\n<code>\nblendMode(LIGHTEST);\nstrokeWeight(30);\nstroke(80, 150, 255);\nline(25, 25, 75, 75);\nstroke(255, 50, 50);\nline(75, 25, 25, 75);\n</code>\n</div>\n<div>\n<code>\nblendMode(MULTIPLY);\nstrokeWeight(30);\nstroke(80, 150, 255);\nline(25, 25, 75, 75);\nstroke(255, 50, 50);\nline(75, 25, 25, 75);\n</code>\n</div>"
            ],
            "alt": "translucent image thick red & blue diagonal rounded lines intersecting center\nThick red & blue diagonal rounded lines intersecting center. dark at overlap",
            "class": "p5",
            "module": "Rendering",
            "submodule": "Rendering"
        },
        {
            "file": "src/core/shim.js",
            "line": 70,
            "description": "<p>shim for Uint8ClampedArray.slice\n(allows arrayCopy to work with pixels[])\nwith thanks to <a href=\"http://halfpapstudios.com/blog/tag/html5-canvas/\">http://halfpapstudios.com/blog/tag/html5-canvas/</a>\nEnumerable set to false to protect for...in from\nUint8ClampedArray.prototype pollution.</p>\n",
            "class": "p5",
            "module": "Rendering"
        },
        {
            "file": "src/core/structure.js",
            "line": 15,
            "description": "<p>Stops p5.js from continuously executing the code within draw().\nIf loop() is called, the code in draw() begins to run continuously again.\nIf using noLoop() in setup(), it should be the last line inside the block.\n<br><br>\nWhen noLoop() is used, it&#39;s not possible to manipulate or access the\nscreen inside event handling functions such as mousePressed() or\nkeyPressed(). Instead, use those functions to call redraw() or loop(),\nwhich will run draw(), which can update the screen properly. This means\nthat when noLoop() has been called, no drawing can happen, and functions\nlike saveFrame() or loadPixels() may not be used.\n<br><br>\nNote that if the sketch is resized, redraw() will be called to update\nthe sketch, even after noLoop() has been specified. Otherwise, the sketch\nwould enter an odd state until loop() was called.</p>\n",
            "itemtype": "method",
            "name": "noLoop",
            "example": [
                "\n<div><code>\nfunction setup() {\n  createCanvas(100, 100);\n  background(200);\n  noLoop();\n}\n\nfunction draw() {\n  line(10, 10, 90, 90);\n}\n</code></div>\n\n<div><code>\nvar x = 0;\nfunction setup() {\n  createCanvas(100, 100);\n}\n\nfunction draw() {\n  background(204);\n  x = x + 0.1;\n  if (x > width) {\n    x = 0;\n  }\n  line(x, 0, x, height);\n}\n\nfunction mousePressed() {\n  noLoop();\n}\n\nfunction mouseReleased() {\n  loop();\n}\n</code></div>"
            ],
            "alt": "113 pixel long line extending from top-left to bottom right of canvas.\nhorizontal line moves slowly from left. Loops but stops on mouse press.",
            "class": "p5",
            "module": "Structure",
            "submodule": "Structure"
        },
        {
            "file": "src/core/structure.js",
            "line": 77,
            "description": "<p>By default, p5.js loops through draw() continuously, executing the code\nwithin it. However, the draw() loop may be stopped by calling noLoop().\nIn that case, the draw() loop can be resumed with loop().</p>\n",
            "itemtype": "method",
            "name": "loop",
            "example": [
                "\n<div><code>\nvar x = 0;\nfunction setup() {\n  createCanvas(100, 100);\n  noLoop();\n}\n\nfunction draw() {\n  background(204);\n  x = x + 0.1;\n  if (x > width) {\n    x = 0;\n  }\n  line(x, 0, x, height);\n}\n\nfunction mousePressed() {\n  loop();\n}\n\nfunction mouseReleased() {\n  noLoop();\n}\n</code></div>"
            ],
            "alt": "horizontal line moves slowly from left. Loops but stops on mouse press.",
            "class": "p5",
            "module": "Structure",
            "submodule": "Structure"
        },
        {
            "file": "src/core/structure.js",
            "line": 132,
            "description": "<p>The push() function saves the current drawing style settings and\ntransformations, while pop() restores these settings. Note that these\nfunctions are always used together. They allow you to change the style\nand transformation settings and later return to what you had. When a new\nstate is started with push(), it builds on the current style and transform\ninformation. The push() and pop() functions can be embedded to provide\nmore control. (See the second example for a demonstration.)\n<br><br>\npush() stores information related to the current transformation state\nand style settings controlled by the following functions: fill(),\nstroke(), tint(), strokeWeight(), strokeCap(), strokeJoin(),\nimageMode(), rectMode(), ellipseMode(), colorMode(), textAlign(),\ntextFont(), textMode(), textSize(), textLeading().</p>\n",
            "itemtype": "method",
            "name": "push",
            "example": [
                "\n<div>\n<code>\nellipse(0, 50, 33, 33); // Left circle\n\npush(); // Start a new drawing state\nstrokeWeight(10);\nfill(204, 153, 0);\ntranslate(50, 0);\nellipse(0, 50, 33, 33); // Middle circle\npop(); // Restore original state\n\nellipse(100, 50, 33, 33); // Right circle\n</code>\n</div>\n<div>\n<code>\nellipse(0, 50, 33, 33); // Left circle\n\npush(); // Start a new drawing state\nstrokeWeight(10);\nfill(204, 153, 0);\nellipse(33, 50, 33, 33); // Left-middle circle\n\npush(); // Start another new drawing state\nstroke(0, 102, 153);\nellipse(66, 50, 33, 33); // Right-middle circle\npop(); // Restore previous state\n\npop(); // Restore original state\n\nellipse(100, 50, 33, 33); // Right circle\n</code>\n</div>"
            ],
            "alt": "Gold ellipse + thick black outline @center 2 white ellipses on left and right.\n2 Gold ellipses left black right blue stroke. 2 white ellipses on left+right.",
            "class": "p5",
            "module": "Structure",
            "submodule": "Structure"
        },
        {
            "file": "src/core/structure.js",
            "line": 211,
            "description": "<p>The push() function saves the current drawing style settings and\ntransformations, while pop() restores these settings. Note that these\nfunctions are always used together. They allow you to change the style\nand transformation settings and later return to what you had. When a new\nstate is started with push(), it builds on the current style and transform\ninformation. The push() and pop() functions can be embedded to provide\nmore control. (See the second example for a demonstration.)\n<br><br>\npush() stores information related to the current transformation state\nand style settings controlled by the following functions: fill(),\nstroke(), tint(), strokeWeight(), strokeCap(), strokeJoin(),\nimageMode(), rectMode(), ellipseMode(), colorMode(), textAlign(),\ntextFont(), textMode(), textSize(), textLeading().</p>\n",
            "itemtype": "method",
            "name": "pop",
            "example": [
                "\n<div>\n<code>\nellipse(0, 50, 33, 33); // Left circle\n\npush(); // Start a new drawing state\ntranslate(50, 0);\nstrokeWeight(10);\nfill(204, 153, 0);\nellipse(0, 50, 33, 33); // Middle circle\npop(); // Restore original state\n\nellipse(100, 50, 33, 33); // Right circle\n</code>\n</div>\n<div>\n<code>\nellipse(0, 50, 33, 33); // Left circle\n\npush(); // Start a new drawing state\nstrokeWeight(10);\nfill(204, 153, 0);\nellipse(33, 50, 33, 33); // Left-middle circle\n\npush(); // Start another new drawing state\nstroke(0, 102, 153);\nellipse(66, 50, 33, 33); // Right-middle circle\npop(); // Restore previous state\n\npop(); // Restore original state\n\nellipse(100, 50, 33, 33); // Right circle\n</code>\n</div>"
            ],
            "alt": "Gold ellipse + thick black outline @center 2 white ellipses on left and right.\n2 Gold ellipses left black right blue stroke. 2 white ellipses on left+right.",
            "class": "p5",
            "module": "Structure",
            "submodule": "Structure"
        },
        {
            "file": "src/core/structure.js",
            "line": 282,
            "description": "<p>Executes the code within draw() one time. This functions allows the\n program to update the display window only when necessary, for example\n when an event registered by mousePressed() or keyPressed() occurs.\n <br><br>\n In structuring a program, it only makes sense to call redraw() within\n events such as mousePressed(). This is because redraw() does not run\n draw() immediately (it only sets a flag that indicates an update is\n needed).\n <br><br>\n The redraw() function does not work properly when called inside draw().\n To enable/disable animations, use loop() and noLoop().\n <br><br>\n In addition you can set the number of redraws per method call. Just\n add an integer as single parameter for the number of redraws.</p>\n",
            "itemtype": "method",
            "name": "redraw",
            "params": [
                {
                    "name": "n",
                    "description": "<p>Redraw for n-times. The default value is 1.</p>\n",
                    "type": "Integer",
                    "optional": true
                }
            ],
            "example": [
                "\n <div><code>\n var x = 0;\nfunction setup() {\n   createCanvas(100, 100);\n   noLoop();\n }\nfunction draw() {\n   background(204);\n   line(x, 0, x, height);\n }\nfunction mousePressed() {\n   x += 1;\n   redraw();\n }\n </code></div>\n<div class='norender'><code>\n var x = 0;\nfunction setup() {\n   createCanvas(100, 100);\n   noLoop();\n }\nfunction draw() {\n   background(204);\n   x += 1;\n   line(x, 0, x, height);\n }\nfunction mousePressed() {\n   redraw(5);\n }\n </code></div>"
            ],
            "alt": "black line on far left of canvas\n black line on far left of canvas",
            "class": "p5",
            "module": "Structure",
            "submodule": "Structure"
        },
        {
            "file": "src/core/transform.js",
            "line": 14,
            "description": "<p>Multiplies the current matrix by the one specified through the parameters.\nThis is a powerful operation that can perform the equivalent of translate,\nscale, shear and rotate all at once. You can learn more about transformation\nmatrices on <a href=\"https://en.wikipedia.org/wiki/Transformation_matrix\">\nWikipedia</a>.</p>\n<p>The naming of the arguments here follows the naming of the <a href=\n\"https://html.spec.whatwg.org/multipage/canvas.html#dom-context-2d-transform\">\nWHATWG specification</a> and corresponds to a\ntransformation matrix of the\nform:</p>\n<blockquote>\n<p><img style=\"max-width: 150px\" src=\"assets/transformation-matrix.png\"\nalt=\"The transformation matrix used when applyMatrix is called\"/></p>\n</blockquote>\n",
            "itemtype": "method",
            "name": "applyMatrix",
            "params": [
                {
                    "name": "a",
                    "description": "<p>numbers which define the 2x3 matrix to be multiplied</p>\n",
                    "type": "Number"
                },
                {
                    "name": "b",
                    "description": "<p>numbers which define the 2x3 matrix to be multiplied</p>\n",
                    "type": "Number"
                },
                {
                    "name": "c",
                    "description": "<p>numbers which define the 2x3 matrix to be multiplied</p>\n",
                    "type": "Number"
                },
                {
                    "name": "d",
                    "description": "<p>numbers which define the 2x3 matrix to be multiplied</p>\n",
                    "type": "Number"
                },
                {
                    "name": "e",
                    "description": "<p>numbers which define the 2x3 matrix to be multiplied</p>\n",
                    "type": "Number"
                },
                {
                    "name": "f",
                    "description": "<p>numbers which define the 2x3 matrix to be multiplied</p>\n",
                    "type": "Number"
                }
            ],
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\nfunction setup() {\n  frameRate(10);\n  rectMode(CENTER);\n}\n\nfunction draw() {\n  var step = frameCount % 20;\n  background(200);\n  // Equivalent to translate(x, y);\n  applyMatrix(1, 0, 0, 1, 40 + step, 50);\n  rect(0, 0, 50, 50);\n}\n</code>\n</div>\n<div>\n<code>\nfunction setup() {\n  frameRate(10);\n  rectMode(CENTER);\n}\n\nfunction draw() {\n  var step = frameCount % 20;\n  background(200);\n  translate(50, 50);\n  // Equivalent to scale(x, y);\n  applyMatrix(1 / step, 0, 0, 1 / step, 0, 0);\n  rect(0, 0, 50, 50);\n}\n</code>\n</div>\n<div>\n<code>\nfunction setup() {\n  frameRate(10);\n  rectMode(CENTER);\n}\n\nfunction draw() {\n  var step = frameCount % 20;\n  var angle = map(step, 0, 20, 0, TWO_PI);\n  var cos_a = cos(angle);\n  var sin_a = sin(angle);\n  background(200);\n  translate(50, 50);\n  // Equivalent to rotate(angle);\n  applyMatrix(cos_a, sin_a, -sin_a, cos_a, 0, 0);\n  rect(0, 0, 50, 50);\n}\n</code>\n</div>\n<div>\n<code>\nfunction setup() {\n  frameRate(10);\n  rectMode(CENTER);\n}\n\nfunction draw() {\n  var step = frameCount % 20;\n  var angle = map(step, 0, 20, -PI / 4, PI / 4);\n  background(200);\n  translate(50, 50);\n  // equivalent to shearX(angle);\n  var shear_factor = 1 / tan(PI / 2 - angle);\n  applyMatrix(1, 0, shear_factor, 1, 0, 0);\n  rect(0, 0, 50, 50);\n}\n</code>\n</div>"
            ],
            "alt": "A rectangle translating to the right\nA rectangle shrinking to the center\nA rectangle rotating clockwise about the center\nA rectangle shearing",
            "class": "p5",
            "module": "Transform",
            "submodule": "Transform"
        },
        {
            "file": "src/core/transform.js",
            "line": 136,
            "description": "<p>Replaces the current matrix with the identity matrix.</p>\n",
            "itemtype": "method",
            "name": "resetMatrix",
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\ntranslate(50, 50);\napplyMatrix(0.5, 0.5, -0.5, 0.5, 0, 0);\nrect(0, 0, 20, 20);\n// Note that the translate is also reset.\nresetMatrix();\nrect(0, 0, 20, 20);\n</code>\n</div>"
            ],
            "alt": "A rotated retangle in the center with another at the top left corner",
            "class": "p5",
            "module": "Transform",
            "submodule": "Transform"
        },
        {
            "file": "src/core/transform.js",
            "line": 162,
            "description": "<p>Rotates a shape the amount specified by the angle parameter. This\nfunction accounts for angleMode, so angles can be entered in either\nRADIANS or DEGREES.\n<br><br>\nObjects are always rotated around their relative position to the\norigin and positive numbers rotate objects in a clockwise direction.\nTransformations apply to everything that happens after and subsequent\ncalls to the function accumulates the effect. For example, calling\nrotate(HALF_PI) and then rotate(HALF_PI) is the same as rotate(PI).\nAll tranformations are reset when draw() begins again.\n<br><br>\nTechnically, rotate() multiplies the current transformation matrix\nby a rotation matrix. This function can be further controlled by\nthe push() and pop().</p>\n",
            "itemtype": "method",
            "name": "rotate",
            "params": [
                {
                    "name": "angle",
                    "description": "<p>the angle of rotation, specified in radians\n                       or degrees, depending on current angleMode</p>\n",
                    "type": "Number"
                },
                {
                    "name": "axis",
                    "description": "<p>(in 3d) the axis to rotate around</p>\n",
                    "type": "p5.Vector|Number[]",
                    "optional": true
                }
            ],
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\ntranslate(width / 2, height / 2);\nrotate(PI / 3.0);\nrect(-26, -26, 52, 52);\n</code>\n</div>"
            ],
            "alt": "white 52x52 rect with black outline at center rotated counter 45 degrees",
            "class": "p5",
            "module": "Transform",
            "submodule": "Transform"
        },
        {
            "file": "src/core/transform.js",
            "line": 208,
            "description": "<p>Rotates around X axis.</p>\n",
            "itemtype": "method",
            "name": "rotateX",
            "params": [
                {
                    "name": "rad",
                    "description": "<p>angles in radians</p>\n",
                    "type": "Number"
                }
            ],
            "chainable": 1,
            "example": [
                "\n<div modernizr='webgl'>\n<code>\nfunction setup() {\n  createCanvas(100, 100, WEBGL);\n}\nfunction draw() {\n  background(255);\n  rotateX(millis() / 1000);\n  box();\n}\n</code>\n</div>"
            ],
            "alt": "3d box rotating around the x axis.",
            "class": "p5",
            "module": "Transform",
            "submodule": "Transform"
        },
        {
            "file": "src/core/transform.js",
            "line": 240,
            "description": "<p>Rotates around Y axis.</p>\n",
            "itemtype": "method",
            "name": "rotateY",
            "params": [
                {
                    "name": "rad",
                    "description": "<p>angles in radians</p>\n",
                    "type": "Number"
                }
            ],
            "chainable": 1,
            "example": [
                "\n<div modernizr='webgl'>\n<code>\nfunction setup() {\n  createCanvas(100, 100, WEBGL);\n}\nfunction draw() {\n  background(255);\n  rotateY(millis() / 1000);\n  box();\n}\n</code>\n</div>"
            ],
            "alt": "3d box rotating around the y axis.",
            "class": "p5",
            "module": "Transform",
            "submodule": "Transform"
        },
        {
            "file": "src/core/transform.js",
            "line": 272,
            "description": "<p>Rotates around Z axis. Webgl mode only.</p>\n",
            "itemtype": "method",
            "name": "rotateZ",
            "params": [
                {
                    "name": "rad",
                    "description": "<p>angles in radians</p>\n",
                    "type": "Number"
                }
            ],
            "chainable": 1,
            "example": [
                "\n<div modernizr='webgl'>\n<code>\nfunction setup() {\n  createCanvas(100, 100, WEBGL);\n}\nfunction draw() {\n  background(255);\n  rotateZ(millis() / 1000);\n  box();\n}\n</code>\n</div>"
            ],
            "alt": "3d box rotating around the z axis.",
            "class": "p5",
            "module": "Transform",
            "submodule": "Transform"
        },
        {
            "file": "src/core/transform.js",
            "line": 304,
            "description": "<p>Increases or decreases the size of a shape by expanding and contracting\nvertices. Objects always scale from their relative origin to the\ncoordinate system. Scale values are specified as decimal percentages.\nFor example, the function call scale(2.0) increases the dimension of a\nshape by 200%.\n<br><br>\nTransformations apply to everything that happens after and subsequent\ncalls to the function multiply the effect. For example, calling scale(2.0)\nand then scale(1.5) is the same as scale(3.0). If scale() is called\nwithin draw(), the transformation is reset when the loop begins again.\n<br><br>\nUsing this function with the z parameter is only available in WEBGL mode.\nThis function can be further controlled with push() and pop().</p>\n",
            "itemtype": "method",
            "name": "scale",
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\ntranslate(width / 2, height / 2);\nrotate(PI / 3.0);\nrect(-26, -26, 52, 52);\n</code>\n</div>\n\n<div>\n<code>\nrect(30, 20, 50, 50);\nscale(0.5, 1.3);\nrect(30, 20, 50, 50);\n</code>\n</div>"
            ],
            "alt": "white 52x52 rect with black outline at center rotated counter 45 degrees\n2 white rects with black outline- 1 50x50 at center. other 25x65 bottom left",
            "class": "p5",
            "module": "Transform",
            "submodule": "Transform",
            "overloads": [
                {
                    "line": 304,
                    "params": [
                        {
                            "name": "s",
                            "description": "<p>percent to scale the object, or percentage to\n                     scale the object in the x-axis if multiple arguments\n                     are given</p>\n",
                            "type": "Number|p5.Vector|Number[]"
                        },
                        {
                            "name": "y",
                            "description": "<p>percent to scale the object in the y-axis</p>\n",
                            "type": "Number",
                            "optional": true
                        },
                        {
                            "name": "z",
                            "description": "<p>percent to scale the object in the z-axis (webgl only)</p>\n",
                            "type": "Number",
                            "optional": true
                        }
                    ],
                    "chainable": 1
                },
                {
                    "line": 349,
                    "params": [
                        {
                            "name": "scales",
                            "description": "<p>per-axis percents to scale the object</p>\n",
                            "type": "p5.Vector|Number[]"
                        }
                    ],
                    "chainable": 1
                }
            ]
        },
        {
            "file": "src/core/transform.js",
            "line": 379,
            "description": "<p>Shears a shape around the x-axis the amount specified by the angle\nparameter. Angles should be specified in the current angleMode.\nObjects are always sheared around their relative position to the origin\nand positive numbers shear objects in a clockwise direction.\n<br><br>\nTransformations apply to everything that happens after and subsequent\ncalls to the function accumulates the effect. For example, calling\nshearX(PI/2) and then shearX(PI/2) is the same as shearX(PI).\nIf shearX() is called within the draw(), the transformation is reset when\nthe loop begins again.\n<br><br>\nTechnically, shearX() multiplies the current transformation matrix by a\nrotation matrix. This function can be further controlled by the\npush() and pop() functions.</p>\n",
            "itemtype": "method",
            "name": "shearX",
            "params": [
                {
                    "name": "angle",
                    "description": "<p>angle of shear specified in radians or degrees,\n                       depending on current angleMode</p>\n",
                    "type": "Number"
                }
            ],
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\ntranslate(width / 4, height / 4);\nshearX(PI / 4.0);\nrect(0, 0, 30, 30);\n</code>\n</div>"
            ],
            "alt": "white irregular quadrilateral with black outline at top middle.",
            "class": "p5",
            "module": "Transform",
            "submodule": "Transform"
        },
        {
            "file": "src/core/transform.js",
            "line": 421,
            "description": "<p>Shears a shape around the y-axis the amount specified by the angle\nparameter. Angles should be specified in the current angleMode. Objects\nare always sheared around their relative position to the origin and\npositive numbers shear objects in a clockwise direction.\n<br><br>\nTransformations apply to everything that happens after and subsequent\ncalls to the function accumulates the effect. For example, calling\nshearY(PI/2) and then shearY(PI/2) is the same as shearY(PI). If\nshearY() is called within the draw(), the transformation is reset when\nthe loop begins again.\n<br><br>\nTechnically, shearY() multiplies the current transformation matrix by a\nrotation matrix. This function can be further controlled by the\npush() and pop() functions.</p>\n",
            "itemtype": "method",
            "name": "shearY",
            "params": [
                {
                    "name": "angle",
                    "description": "<p>angle of shear specified in radians or degrees,\n                       depending on current angleMode</p>\n",
                    "type": "Number"
                }
            ],
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\ntranslate(width / 4, height / 4);\nshearY(PI / 4.0);\nrect(0, 0, 30, 30);\n</code>\n</div>"
            ],
            "alt": "white irregular quadrilateral with black outline at middle bottom.",
            "class": "p5",
            "module": "Transform",
            "submodule": "Transform"
        },
        {
            "file": "src/core/transform.js",
            "line": 463,
            "description": "<p>Specifies an amount to displace objects within the display window.\nThe x parameter specifies left/right translation, the y parameter\nspecifies up/down translation.\n<br><br>\nTransformations are cumulative and apply to everything that happens after\nand subsequent calls to the function accumulates the effect. For example,\ncalling translate(50, 0) and then translate(20, 0) is the same as\ntranslate(70, 0). If translate() is called within draw(), the\ntransformation is reset when the loop begins again. This function can be\nfurther controlled by using push() and pop().</p>\n",
            "itemtype": "method",
            "name": "translate",
            "params": [
                {
                    "name": "x",
                    "description": "<p>left/right translation</p>\n",
                    "type": "Number"
                },
                {
                    "name": "y",
                    "description": "<p>up/down translation</p>\n",
                    "type": "Number"
                },
                {
                    "name": "z",
                    "description": "<p>forward/backward translation (webgl only)</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\ntranslate(30, 20);\nrect(0, 0, 55, 55);\n</code>\n</div>\n\n<div>\n<code>\nrect(0, 0, 55, 55); // Draw rect at original 0,0\ntranslate(30, 20);\nrect(0, 0, 55, 55); // Draw rect at new 0,0\ntranslate(14, 14);\nrect(0, 0, 55, 55); // Draw rect at new 0,0\n</code>\n</div>"
            ],
            "alt": "white 55x55 rect with black outline at center right.\n3 white 55x55 rects with black outlines at top-l, center-r and bottom-r.",
            "class": "p5",
            "module": "Transform",
            "submodule": "Transform"
        },
        {
            "file": "src/core/vertex.js",
            "line": 22,
            "description": "<p>Use the beginContour() and endContour() functions to create negative\nshapes within shapes such as the center of the letter &#39;O&#39;. beginContour()\nbegins recording vertices for the shape and endContour() stops recording.\nThe vertices that define a negative shape must &quot;wind&quot; in the opposite\ndirection from the exterior shape. First draw vertices for the exterior\nclockwise order, then for internal shapes, draw vertices\nshape in counter-clockwise.\n<br><br>\nThese functions can only be used within a beginShape()/endShape() pair and\ntransformations such as translate(), rotate(), and scale() do not work\nwithin a beginContour()/endContour() pair. It is also not possible to use\nother shapes, such as ellipse() or rect() within.</p>\n",
            "itemtype": "method",
            "name": "beginContour",
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\ntranslate(50, 50);\nstroke(255, 0, 0);\nbeginShape();\n// Exterior part of shape, clockwise winding\nvertex(-40, -40);\nvertex(40, -40);\nvertex(40, 40);\nvertex(-40, 40);\n// Interior part of shape, counter-clockwise winding\nbeginContour();\nvertex(-20, -20);\nvertex(-20, 20);\nvertex(20, 20);\nvertex(20, -20);\nendContour();\nendShape(CLOSE);\n</code>\n</div>"
            ],
            "alt": "white rect and smaller grey rect with red outlines in center of canvas.",
            "class": "p5",
            "module": "Shape",
            "submodule": "Vertex"
        },
        {
            "file": "src/core/vertex.js",
            "line": 70,
            "description": "<p>Using the beginShape() and endShape() functions allow creating more\ncomplex forms. beginShape() begins recording vertices for a shape and\nendShape() stops recording. The value of the kind parameter tells it which\ntypes of shapes to create from the provided vertices. With no mode\nspecified, the shape can be any irregular polygon.\n<br><br>\nThe parameters available for beginShape() are POINTS, LINES, TRIANGLES,\nTRIANGLE_FAN, TRIANGLE_STRIP, QUADS, and QUAD_STRIP. After calling the\nbeginShape() function, a series of vertex() commands must follow. To stop\ndrawing the shape, call endShape(). Each shape will be outlined with the\ncurrent stroke color and filled with the fill color.\n<br><br>\nTransformations such as translate(), rotate(), and scale() do not work\nwithin beginShape(). It is also not possible to use other shapes, such as\nellipse() or rect() within beginShape().</p>\n",
            "itemtype": "method",
            "name": "beginShape",
            "params": [
                {
                    "name": "kind",
                    "description": "<p>either POINTS, LINES, TRIANGLES, TRIANGLE_FAN\n                               TRIANGLE_STRIP, QUADS, or QUAD_STRIP</p>\n",
                    "type": "Constant",
                    "optional": true
                }
            ],
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\nbeginShape();\nvertex(30, 20);\nvertex(85, 20);\nvertex(85, 75);\nvertex(30, 75);\nendShape(CLOSE);\n</code>\n</div>\n\n<div>\n<code>\nbeginShape(POINTS);\nvertex(30, 20);\nvertex(85, 20);\nvertex(85, 75);\nvertex(30, 75);\nendShape();\n</code>\n</div>\n\n<div>\n<code>\nbeginShape(LINES);\nvertex(30, 20);\nvertex(85, 20);\nvertex(85, 75);\nvertex(30, 75);\nendShape();\n</code>\n</div>\n\n<div>\n<code>\nnoFill();\nbeginShape();\nvertex(30, 20);\nvertex(85, 20);\nvertex(85, 75);\nvertex(30, 75);\nendShape();\n</code>\n</div>\n\n<div>\n<code>\nnoFill();\nbeginShape();\nvertex(30, 20);\nvertex(85, 20);\nvertex(85, 75);\nvertex(30, 75);\nendShape(CLOSE);\n</code>\n</div>\n\n<div>\n<code>\nbeginShape(TRIANGLES);\nvertex(30, 75);\nvertex(40, 20);\nvertex(50, 75);\nvertex(60, 20);\nvertex(70, 75);\nvertex(80, 20);\nendShape();\n</code>\n</div>\n\n<div>\n<code>\nbeginShape(TRIANGLE_STRIP);\nvertex(30, 75);\nvertex(40, 20);\nvertex(50, 75);\nvertex(60, 20);\nvertex(70, 75);\nvertex(80, 20);\nvertex(90, 75);\nendShape();\n</code>\n</div>\n\n<div>\n<code>\nbeginShape(TRIANGLE_FAN);\nvertex(57.5, 50);\nvertex(57.5, 15);\nvertex(92, 50);\nvertex(57.5, 85);\nvertex(22, 50);\nvertex(57.5, 15);\nendShape();\n</code>\n</div>\n\n<div>\n<code>\nbeginShape(QUADS);\nvertex(30, 20);\nvertex(30, 75);\nvertex(50, 75);\nvertex(50, 20);\nvertex(65, 20);\nvertex(65, 75);\nvertex(85, 75);\nvertex(85, 20);\nendShape();\n</code>\n</div>\n\n<div>\n<code>\nbeginShape(QUAD_STRIP);\nvertex(30, 20);\nvertex(30, 75);\nvertex(50, 20);\nvertex(50, 75);\nvertex(65, 20);\nvertex(65, 75);\nvertex(85, 20);\nvertex(85, 75);\nendShape();\n</code>\n</div>\n\n<div>\n<code>\nbeginShape();\nvertex(20, 20);\nvertex(40, 20);\nvertex(40, 40);\nvertex(60, 40);\nvertex(60, 60);\nvertex(20, 60);\nendShape(CLOSE);\n</code>\n</div>"
            ],
            "alt": "white square-shape with black outline in middle-right of canvas.\n4 black points in a square shape in middle-right of canvas.\n2 horizontal black lines. In the top-right and bottom-right of canvas.\n3 line shape with horizontal on top, vertical in middle and horizontal bottom.\nsquare line shape in middle-right of canvas.\n2 white triangle shapes mid-right canvas. left one pointing up and right down.\n5 horizontal interlocking and alternating white triangles in mid-right canvas.\n4 interlocking white triangles in 45 degree rotated square-shape.\n2 white rectangle shapes in mid-right canvas. Both 20x55.\n3 side-by-side white rectangles center rect is smaller in mid-right canvas.\nThick white l-shape with black outline mid-top-left of canvas.",
            "class": "p5",
            "module": "Shape",
            "submodule": "Vertex"
        },
        {
            "file": "src/core/vertex.js",
            "line": 269,
            "description": "<p>Specifies vertex coordinates for Bezier curves. Each call to\nbezierVertex() defines the position of two control points and\none anchor point of a Bezier curve, adding a new segment to a\nline or shape.\n<br><br>\nThe first time bezierVertex() is used within a\nbeginShape() call, it must be prefaced with a call to vertex()\nto set the first anchor point. This function must be used between\nbeginShape() and endShape() and only when there is no MODE\nparameter specified to beginShape().</p>\n",
            "itemtype": "method",
            "name": "bezierVertex",
            "params": [
                {
                    "name": "x2",
                    "description": "<p>x-coordinate for the first control point</p>\n",
                    "type": "Number"
                },
                {
                    "name": "y2",
                    "description": "<p>y-coordinate for the first control point</p>\n",
                    "type": "Number"
                },
                {
                    "name": "x3",
                    "description": "<p>x-coordinate for the second control point</p>\n",
                    "type": "Number"
                },
                {
                    "name": "y3",
                    "description": "<p>y-coordinate for the second control point</p>\n",
                    "type": "Number"
                },
                {
                    "name": "x4",
                    "description": "<p>x-coordinate for the anchor point</p>\n",
                    "type": "Number"
                },
                {
                    "name": "y4",
                    "description": "<p>y-coordinate for the anchor point</p>\n",
                    "type": "Number"
                }
            ],
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\nnoFill();\nbeginShape();\nvertex(30, 20);\nbezierVertex(80, 0, 80, 75, 30, 75);\nendShape();\n</code>\n</div>\n\n<div>\n<code>\nbeginShape();\nvertex(30, 20);\nbezierVertex(80, 0, 80, 75, 30, 75);\nbezierVertex(50, 80, 60, 25, 30, 20);\nendShape();\n</code>\n</div>"
            ],
            "alt": "crescent-shaped line in middle of canvas. Points facing left.\nwhite crescent shape in middle of canvas. Points facing left.",
            "class": "p5",
            "module": "Shape",
            "submodule": "Vertex"
        },
        {
            "file": "src/core/vertex.js",
            "line": 335,
            "description": "<p>Specifies vertex coordinates for curves. This function may only\nbe used between beginShape() and endShape() and only when there\nis no MODE parameter specified to beginShape().\n<br><br>\nThe first and last points in a series of curveVertex() lines will be used to\nguide the beginning and end of a the curve. A minimum of four\npoints is required to draw a tiny curve between the second and\nthird points. Adding a fifth point with curveVertex() will draw\nthe curve between the second, third, and fourth points. The\ncurveVertex() function is an implementation of Catmull-Rom\nsplines.</p>\n",
            "itemtype": "method",
            "name": "curveVertex",
            "params": [
                {
                    "name": "x",
                    "description": "<p>x-coordinate of the vertex</p>\n",
                    "type": "Number"
                },
                {
                    "name": "y",
                    "description": "<p>y-coordinate of the vertex</p>\n",
                    "type": "Number"
                }
            ],
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\nnoFill();\nbeginShape();\ncurveVertex(84, 91);\ncurveVertex(84, 91);\ncurveVertex(68, 19);\ncurveVertex(21, 17);\ncurveVertex(32, 100);\ncurveVertex(32, 100);\nendShape();\n</code>\n</div>"
            ],
            "alt": "Upside-down u-shape line, mid canvas. left point extends beyond canvas view.",
            "class": "p5",
            "module": "Shape",
            "submodule": "Vertex"
        },
        {
            "file": "src/core/vertex.js",
            "line": 378,
            "description": "<p>Use the beginContour() and endContour() functions to create negative\nshapes within shapes such as the center of the letter &#39;O&#39;. beginContour()\nbegins recording vertices for the shape and endContour() stops recording.\nThe vertices that define a negative shape must &quot;wind&quot; in the opposite\ndirection from the exterior shape. First draw vertices for the exterior\nclockwise order, then for internal shapes, draw vertices\nshape in counter-clockwise.\n<br><br>\nThese functions can only be used within a beginShape()/endShape() pair and\ntransformations such as translate(), rotate(), and scale() do not work\nwithin a beginContour()/endContour() pair. It is also not possible to use\nother shapes, such as ellipse() or rect() within.</p>\n",
            "itemtype": "method",
            "name": "endContour",
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\ntranslate(50, 50);\nstroke(255, 0, 0);\nbeginShape();\n// Exterior part of shape, clockwise winding\nvertex(-40, -40);\nvertex(40, -40);\nvertex(40, 40);\nvertex(-40, 40);\n// Interior part of shape, counter-clockwise winding\nbeginContour();\nvertex(-20, -20);\nvertex(-20, 20);\nvertex(20, 20);\nvertex(20, -20);\nendContour();\nendShape(CLOSE);\n</code>\n</div>"
            ],
            "alt": "white rect and smaller grey rect with red outlines in center of canvas.",
            "class": "p5",
            "module": "Shape",
            "submodule": "Vertex"
        },
        {
            "file": "src/core/vertex.js",
            "line": 438,
            "description": "<p>The endShape() function is the companion to beginShape() and may only be\ncalled after beginShape(). When endshape() is called, all of image data\ndefined since the previous call to beginShape() is written into the image\nbuffer. The constant CLOSE as the value for the MODE parameter to close\nthe shape (to connect the beginning and the end).</p>\n",
            "itemtype": "method",
            "name": "endShape",
            "params": [
                {
                    "name": "mode",
                    "description": "<p>use CLOSE to close the shape</p>\n",
                    "type": "Constant",
                    "optional": true
                }
            ],
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\nnoFill();\n\nbeginShape();\nvertex(20, 20);\nvertex(45, 20);\nvertex(45, 80);\nendShape(CLOSE);\n\nbeginShape();\nvertex(50, 20);\nvertex(75, 20);\nvertex(75, 80);\nendShape();\n</code>\n</div>"
            ],
            "alt": "Triangle line shape with smallest interior angle on bottom and upside-down L.",
            "class": "p5",
            "module": "Shape",
            "submodule": "Vertex"
        },
        {
            "file": "src/core/vertex.js",
            "line": 523,
            "description": "<p>Specifies vertex coordinates for quadratic Bezier curves. Each call to\nquadraticVertex() defines the position of one control points and one\nanchor point of a Bezier curve, adding a new segment to a line or shape.\nThe first time quadraticVertex() is used within a beginShape() call, it\nmust be prefaced with a call to vertex() to set the first anchor point.\nThis function must be used between beginShape() and endShape() and only\nwhen there is no MODE parameter specified to beginShape().</p>\n",
            "itemtype": "method",
            "name": "quadraticVertex",
            "params": [
                {
                    "name": "cx",
                    "description": "<p>x-coordinate for the control point</p>\n",
                    "type": "Number"
                },
                {
                    "name": "cy",
                    "description": "<p>y-coordinate for the control point</p>\n",
                    "type": "Number"
                },
                {
                    "name": "x3",
                    "description": "<p>x-coordinate for the anchor point</p>\n",
                    "type": "Number"
                },
                {
                    "name": "y3",
                    "description": "<p>y-coordinate for the anchor point</p>\n",
                    "type": "Number"
                }
            ],
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\nnoFill();\nstrokeWeight(4);\nbeginShape();\nvertex(20, 20);\nquadraticVertex(80, 20, 50, 50);\nendShape();\n</code>\n</div>\n\n<div>\n<code>\nnoFill();\nstrokeWeight(4);\nbeginShape();\nvertex(20, 20);\nquadraticVertex(80, 20, 50, 50);\nquadraticVertex(20, 80, 80, 80);\nvertex(80, 60);\nendShape();\n</code>\n</div>"
            ],
            "alt": "arched-shaped black line with 4 pixel thick stroke weight.\nbackwards s-shaped black line with 4 pixel thick stroke weight.",
            "class": "p5",
            "module": "Shape",
            "submodule": "Vertex"
        },
        {
            "file": "src/core/vertex.js",
            "line": 601,
            "description": "<p>All shapes are constructed by connecting a series of vertices. vertex()\nis used to specify the vertex coordinates for points, lines, triangles,\nquads, and polygons. It is used exclusively within the beginShape() and\nendShape() functions.</p>\n",
            "itemtype": "method",
            "name": "vertex",
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\nbeginShape(POINTS);\nvertex(30, 20);\nvertex(85, 20);\nvertex(85, 75);\nvertex(30, 75);\nendShape();\n</code>\n</div>"
            ],
            "alt": "4 black points in a square shape in middle-right of canvas.",
            "class": "p5",
            "module": "Shape",
            "submodule": "Vertex",
            "overloads": [
                {
                    "line": 601,
                    "params": [
                        {
                            "name": "x",
                            "description": "<p>x-coordinate of the vertex</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "y",
                            "description": "<p>y-coordinate of the vertex</p>\n",
                            "type": "Number"
                        }
                    ],
                    "chainable": 1
                },
                {
                    "line": 627,
                    "params": [
                        {
                            "name": "x",
                            "description": "",
                            "type": "Number"
                        },
                        {
                            "name": "y",
                            "description": "",
                            "type": "Number"
                        },
                        {
                            "name": "z",
                            "description": "<p>z-coordinate of the vertex</p>\n",
                            "type": "Number",
                            "optional": true
                        },
                        {
                            "name": "u",
                            "description": "<p>the vertex&#39;s texture u-coordinate</p>\n",
                            "type": "Number",
                            "optional": true
                        },
                        {
                            "name": "v",
                            "description": "<p>the vertex&#39;s texture v-coordinate</p>\n",
                            "type": "Number",
                            "optional": true
                        }
                    ]
                }
            ]
        },
        {
            "file": "src/data/p5.TypedDict.js",
            "line": 16,
            "description": "<p>Creates a new instance of p5.StringDict using the key, value pair\n or object you provide.</p>\n",
            "itemtype": "method",
            "name": "createStringDict",
            "params": [
                {
                    "name": "key",
                    "description": "<p>or object</p>\n",
                    "type": "String|Object"
                },
                {
                    "name": "value",
                    "description": "",
                    "type": "String"
                }
            ],
            "return": {
                "description": "",
                "type": "p5.StringDict"
            },
            "example": [
                "\n <div class=\"norender\">\n <code>\n function setup() {\n   var myDictionary = createStringDict('p5', 'js');\n   print(myDictionary.hasKey('p5')); // logs true to console\n }\n </code></div>"
            ],
            "class": "p5",
            "module": "Data",
            "submodule": "Dictionary"
        },
        {
            "file": "src/data/p5.TypedDict.js",
            "line": 41,
            "description": "<p>Creates a new instance of p5.NumberDict using the key, value pair\n or object you provide.</p>\n",
            "itemtype": "method",
            "name": "createNumberDict",
            "params": [
                {
                    "name": "key",
                    "description": "<p>or object</p>\n",
                    "type": "Number|Object"
                },
                {
                    "name": "value",
                    "description": "",
                    "type": "Number"
                }
            ],
            "return": {
                "description": "",
                "type": "p5.NumberDict"
            },
            "example": [
                "\n <div class=\"norender\">\n <code>\n function setup() {\n   var myDictionary = createNumberDict('p5', 42);\n   print(myDictionary.hasKey('p5')); // logs true to console\n }\n </code></div>"
            ],
            "class": "p5",
            "module": "Data",
            "submodule": "Dictionary"
        },
        {
            "file": "src/data/p5.TypedDict.js",
            "line": 86,
            "description": "<p>Returns the number of key-value pairs currently in Dictionary object</p>\n",
            "itemtype": "method",
            "name": "size",
            "return": {
                "description": "the number of key-value pairs in Dictionary object",
                "type": "Integer"
            },
            "example": [
                "\n<div class=\"norender\">\n<code>\nfunction setup() {\n  var myDictionary = createNumberDict(1, 10);\n  myDictionary.create(2, 20);\n  myDictionary.create(3, 30);\n  print(myDictionary.size()); // value of amt is 3\n}\n</code></div>\n"
            ],
            "class": "p5.TypedDict",
            "module": "Data",
            "submodule": "Dictionary"
        },
        {
            "file": "src/data/p5.TypedDict.js",
            "line": 108,
            "description": "<p>Returns true if key exists in Dictionary\notherwise returns false</p>\n",
            "itemtype": "method",
            "name": "hasKey",
            "params": [
                {
                    "name": "key",
                    "description": "<p>that you want to access</p>\n",
                    "type": "Number|String"
                }
            ],
            "return": {
                "description": "whether that key exists in Dictionary",
                "type": "Boolean"
            },
            "example": [
                "\n<div class=\"norender\">\n<code>\nfunction setup() {\n  var myDictionary = createStringDict('p5', 'js');\n  print(myDictionary.hasKey('p5')); // logs true to console\n}\n</code></div>\n"
            ],
            "class": "p5.TypedDict",
            "module": "Data",
            "submodule": "Dictionary"
        },
        {
            "file": "src/data/p5.TypedDict.js",
            "line": 131,
            "description": "<p>Returns value stored at supplied key.</p>\n",
            "itemtype": "method",
            "name": "get",
            "params": [
                {
                    "name": "key",
                    "description": "<p>that you want to access</p>\n",
                    "type": "Number|String"
                }
            ],
            "return": {
                "description": "the value stored at that key",
                "type": "Number|String"
            },
            "example": [
                "\n<div class=\"norender\">\n<code>\nfunction setup() {\n  var myDictionary = createStringDict('p5', 'js');\n  var myValue = myDictionary.get('p5');\n  print(myValue === 'js'); // logs true to console\n}\n</code></div>\n"
            ],
            "class": "p5.TypedDict",
            "module": "Data",
            "submodule": "Dictionary"
        },
        {
            "file": "src/data/p5.TypedDict.js",
            "line": 158,
            "description": "<p>Changes the value of key if in it already exists in\nin the Dictionary otherwise makes a new key-value pair</p>\n",
            "itemtype": "method",
            "name": "set",
            "params": [
                {
                    "name": "key",
                    "description": "",
                    "type": "Number|String"
                },
                {
                    "name": "value",
                    "description": "",
                    "type": "Number|String"
                }
            ],
            "example": [
                "\n<div class=\"norender\">\n<code>\nfunction setup() {\n  var myDictionary = createStringDict('p5', 'js');\n  myDictionary.set('p5', 'JS');\n  myDictionary.print();\n  // above logs \"key: p5 - value: JS\" to console\n}\n</code></div>\n"
            ],
            "class": "p5.TypedDict",
            "module": "Data",
            "submodule": "Dictionary"
        },
        {
            "file": "src/data/p5.TypedDict.js",
            "line": 187,
            "description": "<p>private helper function to handle the user passing objects in\nduring construction or calls to create()</p>\n",
            "class": "p5.TypedDict",
            "module": "Data",
            "submodule": "Dictionary"
        },
        {
            "file": "src/data/p5.TypedDict.js",
            "line": 198,
            "description": "<p>Creates a key-value pair in the Dictionary</p>\n",
            "itemtype": "method",
            "name": "create",
            "example": [
                "\n<div class=\"norender\">\n<code>\nfunction setup() {\n  var myDictionary = createStringDict('p5', 'js');\n  myDictionary.create('happy', 'coding');\n  myDictionary.print();\n  // above logs \"key: p5 - value: js, key: happy - value: coding\" to console\n}\n</code></div>"
            ],
            "class": "p5.TypedDict",
            "module": "Data",
            "submodule": "Dictionary",
            "overloads": [
                {
                    "line": 198,
                    "params": [
                        {
                            "name": "key",
                            "description": "",
                            "type": "Number|String"
                        },
                        {
                            "name": "value",
                            "description": "",
                            "type": "Number|String"
                        }
                    ]
                },
                {
                    "line": 216,
                    "params": [
                        {
                            "name": "obj",
                            "description": "<p>key/value pair</p>\n",
                            "type": "Object"
                        }
                    ]
                }
            ]
        },
        {
            "file": "src/data/p5.TypedDict.js",
            "line": 234,
            "description": "<p>Empties Dictionary of all key-value pairs</p>\n",
            "itemtype": "method",
            "name": "clear",
            "example": [
                "\n<div class=\"norender\">\n<code>\nfunction setup() {\n  var myDictionary = createStringDict('p5', 'js');\n  print(myDictionary.hasKey('p5')); // prints 'true'\n  myDictionary.clear();\n  print(myDictionary.hasKey('p5')); // prints 'false'\n}\n</code>\n</div>"
            ],
            "class": "p5.TypedDict",
            "module": "Data",
            "submodule": "Dictionary"
        },
        {
            "file": "src/data/p5.TypedDict.js",
            "line": 254,
            "description": "<p>Removes a key-value pair in the Dictionary</p>\n",
            "itemtype": "method",
            "name": "remove",
            "params": [
                {
                    "name": "key",
                    "description": "<p>for the pair to remove</p>\n",
                    "type": "Number|String"
                }
            ],
            "example": [
                "\n<div class=\"norender\">\n<code>\nfunction setup() {\n  var myDictionary = createStringDict('p5', 'js');\n  myDictionary.create('happy', 'coding');\n  myDictionary.print();\n  // above logs \"key: p5 - value: js, key: happy - value: coding\" to console\n  myDictionary.remove('p5');\n  myDictionary.print();\n  // above logs \"key: happy value: coding\" to console\n}\n</code></div>\n"
            ],
            "class": "p5.TypedDict",
            "module": "Data",
            "submodule": "Dictionary"
        },
        {
            "file": "src/data/p5.TypedDict.js",
            "line": 284,
            "description": "<p>Logs the list of items currently in the Dictionary to the console</p>\n",
            "itemtype": "method",
            "name": "print",
            "example": [
                "\n<div class=\"norender\">\n<code>\nfunction setup() {\n  var myDictionary = createStringDict('p5', 'js');\n  myDictionary.create('happy', 'coding');\n  myDictionary.print();\n  // above logs \"key: p5 - value: js, key: happy - value: coding\" to console\n}\n</code>\n</div>"
            ],
            "class": "p5.TypedDict",
            "module": "Data",
            "submodule": "Dictionary"
        },
        {
            "file": "src/data/p5.TypedDict.js",
            "line": 308,
            "description": "<p>Converts the Dictionary into a CSV file for local\nstorage.</p>\n",
            "itemtype": "method",
            "name": "saveTable",
            "example": [
                "\n<div>\n<code>\ncreateButton('save')\n  .position(10, 10)\n  .mousePressed(function() {\n    createNumberDict({\n      john: 1940,\n     paul: 1942,\n     george: 1943,\n     ringo: 1940\n    }).saveTable('beatles');\n  });\n</code>\n</div>"
            ],
            "class": "p5.TypedDict",
            "module": "Data",
            "submodule": "Dictionary"
        },
        {
            "file": "src/data/p5.TypedDict.js",
            "line": 341,
            "description": "<p>Converts the Dictionary into a JSON file for local\nstorage.</p>\n",
            "itemtype": "method",
            "name": "saveJSON",
            "example": [
                "\n<div>\n<code>\ncreateButton('save')\n  .position(10, 10)\n  .mousePressed(function() {\n    createNumberDict({\n      john: 1940,\n     paul: 1942,\n     george: 1943,\n     ringo: 1940\n    }).saveJSON('beatles');\n  });\n</code>\n</div>"
            ],
            "class": "p5.TypedDict",
            "module": "Data",
            "submodule": "Dictionary"
        },
        {
            "file": "src/data/p5.TypedDict.js",
            "line": 367,
            "description": "<p>private helper function to ensure that the user passed in valid\nvalues for the Dictionary type</p>\n",
            "class": "p5.TypedDict",
            "module": "Data",
            "submodule": "Dictionary"
        },
        {
            "file": "src/data/p5.TypedDict.js",
            "line": 414,
            "description": "<p>private helper function to ensure that the user passed in valid\nvalues for the Dictionary type</p>\n",
            "class": "p5.NumberDict",
            "module": "Data",
            "submodule": "Dictionary"
        },
        {
            "file": "src/data/p5.TypedDict.js",
            "line": 423,
            "description": "<p>Add to a value stored at a certain key\nThe sum is stored in that location in the Dictionary.</p>\n",
            "itemtype": "method",
            "name": "add",
            "params": [
                {
                    "name": "Key",
                    "description": "<p>for value you wish to add to</p>\n",
                    "type": "Number"
                },
                {
                    "name": "Amount",
                    "description": "<p>to add to the value</p>\n",
                    "type": "Number"
                }
            ],
            "example": [
                "\n<div class='norender'>\n<code>\nfunction setup() {\n  var myDictionary = createNumberDict(2, 5);\n  myDictionary.add(2, 2);\n  console.log(myDictionary.get(2)); // logs 7 to console.\n}\n</code></div>\n\n"
            ],
            "class": "p5.NumberDict",
            "module": "Data",
            "submodule": "Dictionary"
        },
        {
            "file": "src/data/p5.TypedDict.js",
            "line": 451,
            "description": "<p>Subtract from a value stored at a certain key\nThe difference is stored in that location in the Dictionary.</p>\n",
            "itemtype": "method",
            "name": "sub",
            "params": [
                {
                    "name": "Key",
                    "description": "<p>for value you wish to subtract from</p>\n",
                    "type": "Number"
                },
                {
                    "name": "Amount",
                    "description": "<p>to subtract from the value</p>\n",
                    "type": "Number"
                }
            ],
            "example": [
                "\n<div class='norender'>\n<code>\nfunction setup() {\n  var myDictionary = createNumberDict(2, 5);\n  myDictionary.sub(2, 2);\n  console.log(myDictionary.get(2)); // logs 3 to console.\n}\n</code></div>\n\n"
            ],
            "class": "p5.NumberDict",
            "module": "Data",
            "submodule": "Dictionary"
        },
        {
            "file": "src/data/p5.TypedDict.js",
            "line": 475,
            "description": "<p>Multiply a value stored at a certain key\nThe product is stored in that location in the Dictionary.</p>\n",
            "itemtype": "method",
            "name": "mult",
            "params": [
                {
                    "name": "Key",
                    "description": "<p>for value you wish to multiply</p>\n",
                    "type": "Number"
                },
                {
                    "name": "Amount",
                    "description": "<p>to multiply the value by</p>\n",
                    "type": "Number"
                }
            ],
            "example": [
                "\n<div class='norender'>\n<code>\nfunction setup() {\n  var myDictionary = createNumberDict(2, 4);\n  myDictionary.mult(2, 2);\n  console.log(myDictionary.get(2)); // logs 8 to console.\n}\n</code></div>\n\n"
            ],
            "class": "p5.NumberDict",
            "module": "Data",
            "submodule": "Dictionary"
        },
        {
            "file": "src/data/p5.TypedDict.js",
            "line": 503,
            "description": "<p>Divide a value stored at a certain key\nThe quotient is stored in that location in the Dictionary.</p>\n",
            "itemtype": "method",
            "name": "div",
            "params": [
                {
                    "name": "Key",
                    "description": "<p>for value you wish to divide</p>\n",
                    "type": "Number"
                },
                {
                    "name": "Amount",
                    "description": "<p>to divide the value by</p>\n",
                    "type": "Number"
                }
            ],
            "example": [
                "\n<div class='norender'>\n<code>\nfunction setup() {\n  var myDictionary = createNumberDict(2, 8);\n  myDictionary.div(2, 2);\n  console.log(myDictionary.get(2)); // logs 4 to console.\n}\n</code></div>\n\n"
            ],
            "class": "p5.NumberDict",
            "module": "Data",
            "submodule": "Dictionary"
        },
        {
            "file": "src/data/p5.TypedDict.js",
            "line": 531,
            "description": "<p>private helper function for finding lowest or highest value\nthe argument &#39;flip&#39; is used to flip the comparison arrow\nfrom &#39;less than&#39; to &#39;greater than&#39;</p>\n",
            "class": "p5.NumberDict",
            "module": "Data",
            "submodule": "Dictionary"
        },
        {
            "file": "src/data/p5.TypedDict.js",
            "line": 554,
            "description": "<p>Return the lowest value.</p>\n",
            "itemtype": "method",
            "name": "minValue",
            "return": {
                "description": "",
                "type": "Number"
            },
            "example": [
                "\n<div class='norender'>\n<code>\nfunction setup() {\n  var myDictionary = createNumberDict({ 2: -10, 4: 0.65, 1.2: 3 });\n  var lowestValue = myDictionary.minValue(); // value is -10\n  print(lowestValue);\n}\n</code></div>\n"
            ],
            "class": "p5.NumberDict",
            "module": "Data",
            "submodule": "Dictionary"
        },
        {
            "file": "src/data/p5.TypedDict.js",
            "line": 575,
            "description": "<p>Return the highest value.</p>\n",
            "itemtype": "method",
            "name": "maxValue",
            "return": {
                "description": "",
                "type": "Number"
            },
            "example": [
                "\n<div class='norender'>\n<code>\nfunction setup() {\n  var myDictionary = createNumberDict({ 2: -10, 4: 0.65, 1.2: 3 });\n  var highestValue = myDictionary.maxValue(); // value is 3\n  print(highestValue);\n}\n</code></div>\n"
            ],
            "class": "p5.NumberDict",
            "module": "Data",
            "submodule": "Dictionary"
        },
        {
            "file": "src/data/p5.TypedDict.js",
            "line": 596,
            "description": "<p>private helper function for finding lowest or highest key\nthe argument &#39;flip&#39; is used to flip the comparison arrow\nfrom &#39;less than&#39; to &#39;greater than&#39;</p>\n",
            "class": "p5.NumberDict",
            "module": "Data",
            "submodule": "Dictionary"
        },
        {
            "file": "src/data/p5.TypedDict.js",
            "line": 619,
            "description": "<p>Return the lowest key.</p>\n",
            "itemtype": "method",
            "name": "minKey",
            "return": {
                "description": "",
                "type": "Number"
            },
            "example": [
                "\n<div class='norender'>\n<code>\nfunction setup() {\n  var myDictionary = createNumberDict({ 2: 4, 4: 6, 1.2: 3 });\n  var lowestKey = myDictionary.minKey(); // value is 1.2\n  print(lowestKey);\n}\n</code></div>\n"
            ],
            "class": "p5.NumberDict",
            "module": "Data",
            "submodule": "Dictionary"
        },
        {
            "file": "src/data/p5.TypedDict.js",
            "line": 640,
            "description": "<p>Return the highest key.</p>\n",
            "itemtype": "method",
            "name": "maxKey",
            "return": {
                "description": "",
                "type": "Number"
            },
            "example": [
                "\n<div class='norender'>\n<code>\nfunction setup() {\n  var myDictionary = createNumberDict({ 2: 4, 4: 6, 1.2: 3 });\n  var highestKey = myDictionary.maxKey(); // value is 4\n  print(highestKey);\n}\n</code></div>\n"
            ],
            "class": "p5.NumberDict",
            "module": "Data",
            "submodule": "Dictionary"
        },
        {
            "file": "src/events/acceleration.js",
            "line": 12,
            "description": "<p>The system variable deviceOrientation always contains the orientation of\nthe device. The value of this variable will either be set &#39;landscape&#39;\nor &#39;portrait&#39;. If no data is available it will be set to &#39;undefined&#39;.\neither LANDSCAPE or PORTRAIT.</p>\n",
            "itemtype": "property",
            "name": "deviceOrientation",
            "type": "Constant",
            "readonly": "",
            "class": "p5",
            "module": "Events",
            "submodule": "Acceleration"
        },
        {
            "file": "src/events/acceleration.js",
            "line": 23,
            "description": "<p>The system variable accelerationX always contains the acceleration of the\ndevice along the x axis. Value is represented as meters per second squared.</p>\n",
            "itemtype": "property",
            "name": "accelerationX",
            "type": "Number",
            "readonly": "",
            "class": "p5",
            "module": "Events",
            "submodule": "Acceleration"
        },
        {
            "file": "src/events/acceleration.js",
            "line": 32,
            "description": "<p>The system variable accelerationY always contains the acceleration of the\ndevice along the y axis. Value is represented as meters per second squared.</p>\n",
            "itemtype": "property",
            "name": "accelerationY",
            "type": "Number",
            "readonly": "",
            "class": "p5",
            "module": "Events",
            "submodule": "Acceleration"
        },
        {
            "file": "src/events/acceleration.js",
            "line": 41,
            "description": "<p>The system variable accelerationZ always contains the acceleration of the\ndevice along the z axis. Value is represented as meters per second squared.</p>\n",
            "itemtype": "property",
            "name": "accelerationZ",
            "type": "Number",
            "readonly": "",
            "class": "p5",
            "module": "Events",
            "submodule": "Acceleration"
        },
        {
            "file": "src/events/acceleration.js",
            "line": 50,
            "description": "<p>The system variable pAccelerationX always contains the acceleration of the\ndevice along the x axis in the frame previous to the current frame. Value\nis represented as meters per second squared.</p>\n",
            "itemtype": "property",
            "name": "pAccelerationX",
            "type": "Number",
            "readonly": "",
            "class": "p5",
            "module": "Events",
            "submodule": "Acceleration"
        },
        {
            "file": "src/events/acceleration.js",
            "line": 60,
            "description": "<p>The system variable pAccelerationY always contains the acceleration of the\ndevice along the y axis in the frame previous to the current frame. Value\nis represented as meters per second squared.</p>\n",
            "itemtype": "property",
            "name": "pAccelerationY",
            "type": "Number",
            "readonly": "",
            "class": "p5",
            "module": "Events",
            "submodule": "Acceleration"
        },
        {
            "file": "src/events/acceleration.js",
            "line": 70,
            "description": "<p>The system variable pAccelerationZ always contains the acceleration of the\ndevice along the z axis in the frame previous to the current frame. Value\nis represented as meters per second squared.</p>\n",
            "itemtype": "property",
            "name": "pAccelerationZ",
            "type": "Number",
            "readonly": "",
            "class": "p5",
            "module": "Events",
            "submodule": "Acceleration"
        },
        {
            "file": "src/events/acceleration.js",
            "line": 91,
            "description": "<p>The system variable rotationX always contains the rotation of the\ndevice along the x axis. Value is represented as 0 to +/-180 degrees.\n<br><br>\nNote: The order the rotations are called is important, ie. if used\ntogether, it must be called in the order Z-X-Y or there might be\nunexpected behaviour.</p>\n",
            "example": [
                "\n<div>\n<code>\nfunction setup() {\n  createCanvas(100, 100, WEBGL);\n}\n\nfunction draw() {\n  background(200);\n  //rotateZ(radians(rotationZ));\n  rotateX(radians(rotationX));\n  //rotateY(radians(rotationY));\n  box(200, 200, 200);\n}\n</code>\n</div>"
            ],
            "itemtype": "property",
            "name": "rotationX",
            "type": "Number",
            "readonly": "",
            "alt": "red horizontal line right, green vertical line bottom. black background.",
            "class": "p5",
            "module": "Events",
            "submodule": "Acceleration"
        },
        {
            "file": "src/events/acceleration.js",
            "line": 125,
            "description": "<p>The system variable rotationY always contains the rotation of the\ndevice along the y axis. Value is represented as 0 to +/-90 degrees.\n<br><br>\nNote: The order the rotations are called is important, ie. if used\ntogether, it must be called in the order Z-X-Y or there might be\nunexpected behaviour.</p>\n",
            "example": [
                "\n<div>\n<code>\nfunction setup() {\n  createCanvas(100, 100, WEBGL);\n}\n\nfunction draw() {\n  background(200);\n  //rotateZ(radians(rotationZ));\n  //rotateX(radians(rotationX));\n  rotateY(radians(rotationY));\n  box(200, 200, 200);\n}\n</code>\n</div>"
            ],
            "itemtype": "property",
            "name": "rotationY",
            "type": "Number",
            "readonly": "",
            "alt": "red horizontal line right, green vertical line bottom. black background.",
            "class": "p5",
            "module": "Events",
            "submodule": "Acceleration"
        },
        {
            "file": "src/events/acceleration.js",
            "line": 158,
            "description": "<p>The system variable rotationZ always contains the rotation of the\ndevice along the z axis. Value is represented as 0 to 359 degrees.\n<br><br>\nUnlike rotationX and rotationY, this variable is available for devices\nwith a built-in compass only.\n<br><br>\nNote: The order the rotations are called is important, ie. if used\ntogether, it must be called in the order Z-X-Y or there might be\nunexpected behaviour.</p>\n",
            "example": [
                "\n<div>\n<code>\nfunction setup() {\n  createCanvas(100, 100, WEBGL);\n}\n\nfunction draw() {\n  background(200);\n  rotateZ(radians(rotationZ));\n  //rotateX(radians(rotationX));\n  //rotateY(radians(rotationY));\n  box(200, 200, 200);\n}\n</code>\n</div>"
            ],
            "itemtype": "property",
            "name": "rotationZ",
            "type": "Number",
            "readonly": "",
            "alt": "red horizontal line right, green vertical line bottom. black background.",
            "class": "p5",
            "module": "Events",
            "submodule": "Acceleration"
        },
        {
            "file": "src/events/acceleration.js",
            "line": 194,
            "description": "<p>The system variable pRotationX always contains the rotation of the\ndevice along the x axis in the frame previous to the current frame. Value\nis represented as 0 to +/-180 degrees.\n<br><br>\npRotationX can also be used with rotationX to determine the rotate\ndirection of the device along the X-axis.</p>\n",
            "example": [
                "\n<div class='norender'>\n<code>\n// A simple if statement looking at whether\n// rotationX - pRotationX < 0 is true or not will be\n// sufficient for determining the rotate direction\n// in most cases.\n\n// Some extra logic is needed to account for cases where\n// the angles wrap around.\nvar rotateDirection = 'clockwise';\n\n// Simple range conversion to make things simpler.\n// This is not absolutely necessary but the logic\n// will be different in that case.\n\nvar rX = rotationX + 180;\nvar pRX = pRotationX + 180;\n\nif ((rX - pRX > 0 && rX - pRX < 270) || rX - pRX < -270) {\n  rotateDirection = 'clockwise';\n} else if (rX - pRX < 0 || rX - pRX > 270) {\n  rotateDirection = 'counter-clockwise';\n}\n\nprint(rotateDirection);\n</code>\n</div>"
            ],
            "alt": "no image to display.",
            "itemtype": "property",
            "name": "pRotationX",
            "type": "Number",
            "readonly": "",
            "class": "p5",
            "module": "Events",
            "submodule": "Acceleration"
        },
        {
            "file": "src/events/acceleration.js",
            "line": 239,
            "description": "<p>The system variable pRotationY always contains the rotation of the\ndevice along the y axis in the frame previous to the current frame. Value\nis represented as 0 to +/-90 degrees.\n<br><br>\npRotationY can also be used with rotationY to determine the rotate\ndirection of the device along the Y-axis.</p>\n",
            "example": [
                "\n<div class='norender'>\n<code>\n// A simple if statement looking at whether\n// rotationY - pRotationY < 0 is true or not will be\n// sufficient for determining the rotate direction\n// in most cases.\n\n// Some extra logic is needed to account for cases where\n// the angles wrap around.\nvar rotateDirection = 'clockwise';\n\n// Simple range conversion to make things simpler.\n// This is not absolutely necessary but the logic\n// will be different in that case.\n\nvar rY = rotationY + 180;\nvar pRY = pRotationY + 180;\n\nif ((rY - pRY > 0 && rY - pRY < 270) || rY - pRY < -270) {\n  rotateDirection = 'clockwise';\n} else if (rY - pRY < 0 || rY - pRY > 270) {\n  rotateDirection = 'counter-clockwise';\n}\nprint(rotateDirection);\n</code>\n</div>"
            ],
            "alt": "no image to display.",
            "itemtype": "property",
            "name": "pRotationY",
            "type": "Number",
            "readonly": "",
            "class": "p5",
            "module": "Events",
            "submodule": "Acceleration"
        },
        {
            "file": "src/events/acceleration.js",
            "line": 283,
            "description": "<p>The system variable pRotationZ always contains the rotation of the\ndevice along the z axis in the frame previous to the current frame. Value\nis represented as 0 to 359 degrees.\n<br><br>\npRotationZ can also be used with rotationZ to determine the rotate\ndirection of the device along the Z-axis.</p>\n",
            "example": [
                "\n<div class='norender'>\n<code>\n// A simple if statement looking at whether\n// rotationZ - pRotationZ < 0 is true or not will be\n// sufficient for determining the rotate direction\n// in most cases.\n\n// Some extra logic is needed to account for cases where\n// the angles wrap around.\nvar rotateDirection = 'clockwise';\n\nif (\n  (rotationZ - pRotationZ > 0 && rotationZ - pRotationZ < 270) ||\n  rotationZ - pRotationZ < -270\n) {\n  rotateDirection = 'clockwise';\n} else if (rotationZ - pRotationZ < 0 || rotationZ - pRotationZ > 270) {\n  rotateDirection = 'counter-clockwise';\n}\nprint(rotateDirection);\n</code>\n</div>"
            ],
            "alt": "no image to display.",
            "itemtype": "property",
            "name": "pRotationZ",
            "type": "Number",
            "readonly": "",
            "class": "p5",
            "module": "Events",
            "submodule": "Acceleration"
        },
        {
            "file": "src/events/acceleration.js",
            "line": 341,
            "itemtype": "property",
            "name": "turnAxis",
            "type": "String",
            "readonly": "",
            "class": "p5",
            "module": "Events",
            "submodule": "Acceleration"
        },
        {
            "file": "src/events/acceleration.js",
            "line": 350,
            "description": "<p>The setMoveThreshold() function is used to set the movement threshold for\nthe deviceMoved() function. The default threshold is set to 0.5.</p>\n",
            "itemtype": "method",
            "name": "setMoveThreshold",
            "params": [
                {
                    "name": "value",
                    "description": "<p>The threshold value</p>\n",
                    "type": "Number"
                }
            ],
            "class": "p5",
            "module": "Events",
            "submodule": "Acceleration"
        },
        {
            "file": "src/events/acceleration.js",
            "line": 363,
            "description": "<p>The setShakeThreshold() function is used to set the movement threshold for\nthe deviceShaken() function. The default threshold is set to 30.</p>\n",
            "itemtype": "method",
            "name": "setShakeThreshold",
            "params": [
                {
                    "name": "value",
                    "description": "<p>The threshold value</p>\n",
                    "type": "Number"
                }
            ],
            "class": "p5",
            "module": "Events",
            "submodule": "Acceleration"
        },
        {
            "file": "src/events/acceleration.js",
            "line": 376,
            "description": "<p>The deviceMoved() function is called when the device is moved by more than\nthe threshold value along X, Y or Z axis. The default threshold is set to\n0.5.</p>\n",
            "itemtype": "method",
            "name": "deviceMoved",
            "example": [
                "\n<div class=\"norender\">\n<code>\n// Run this example on a mobile device\n// Move the device around\n// to change the value.\n\nvar value = 0;\nfunction draw() {\n  fill(value);\n  rect(25, 25, 50, 50);\n}\nfunction deviceMoved() {\n  value = value + 5;\n  if (value > 255) {\n    value = 0;\n  }\n}\n</code>\n</div>"
            ],
            "alt": "50x50 black rect in center of canvas. turns white on mobile when device moves",
            "class": "p5",
            "module": "Events",
            "submodule": "Acceleration"
        },
        {
            "file": "src/events/acceleration.js",
            "line": 407,
            "description": "<p>The deviceTurned() function is called when the device rotates by\nmore than 90 degrees continuously.\n<br><br>\nThe axis that triggers the deviceTurned() method is stored in the turnAxis\nvariable. The deviceTurned() method can be locked to trigger on any axis:\nX, Y or Z by comparing the turnAxis variable to &#39;X&#39;, &#39;Y&#39; or &#39;Z&#39;.</p>\n",
            "itemtype": "method",
            "name": "deviceTurned",
            "example": [
                "\n<div class=\"norender\">\n<code>\n// Run this example on a mobile device\n// Rotate the device by 90 degrees\n// to change the value.\n\nvar value = 0;\nfunction draw() {\n  fill(value);\n  rect(25, 25, 50, 50);\n}\nfunction deviceTurned() {\n  if (value === 0) {\n    value = 255;\n  } else if (value === 255) {\n    value = 0;\n  }\n}\n</code>\n</div>\n<div>\n<code>\n// Run this example on a mobile device\n// Rotate the device by 90 degrees in the\n// X-axis to change the value.\n\nvar value = 0;\nfunction draw() {\n  fill(value);\n  rect(25, 25, 50, 50);\n}\nfunction deviceTurned() {\n  if (turnAxis === 'X') {\n    if (value === 0) {\n      value = 255;\n    } else if (value === 255) {\n      value = 0;\n    }\n  }\n}\n</code>\n</div>"
            ],
            "alt": "50x50 black rect in center of canvas. turns white on mobile when device turns\n50x50 black rect in center of canvas. turns white on mobile when x-axis turns",
            "class": "p5",
            "module": "Events",
            "submodule": "Acceleration"
        },
        {
            "file": "src/events/acceleration.js",
            "line": 466,
            "description": "<p>The deviceShaken() function is called when the device total acceleration\nchanges of accelerationX and accelerationY values is more than\nthe threshold value. The default threshold is set to 30.</p>\n",
            "itemtype": "method",
            "name": "deviceShaken",
            "example": [
                "\n<div class=\"norender\">\n<code>\n// Run this example on a mobile device\n// Shake the device to change the value.\n\nvar value = 0;\nfunction draw() {\n  fill(value);\n  rect(25, 25, 50, 50);\n}\nfunction deviceShaken() {\n  value = value + 5;\n  if (value > 255) {\n    value = 0;\n  }\n}\n</code>\n</div>"
            ],
            "alt": "50x50 black rect in center of canvas. turns white on mobile when device shakes",
            "class": "p5",
            "module": "Events",
            "submodule": "Acceleration"
        },
        {
            "file": "src/events/keyboard.js",
            "line": 18,
            "description": "<p>The boolean system variable keyIsPressed is true if any key is pressed\nand false if no keys are pressed.</p>\n",
            "itemtype": "property",
            "name": "keyIsPressed",
            "type": "Boolean",
            "readonly": "",
            "example": [
                "\n<div>\n<code>\nfunction draw() {\n  if (keyIsPressed === true) {\n    fill(0);\n  } else {\n    fill(255);\n  }\n  rect(25, 25, 50, 50);\n}\n</code>\n</div>"
            ],
            "alt": "50x50 white rect that turns black on keypress.",
            "class": "p5",
            "module": "Events",
            "submodule": "Keyboard"
        },
        {
            "file": "src/events/keyboard.js",
            "line": 45,
            "description": "<p>The system variable key always contains the value of the most recent\nkey on the keyboard that was typed. To get the proper capitalization, it\nis best to use it within keyTyped(). For non-ASCII keys, use the keyCode\nvariable.</p>\n",
            "itemtype": "property",
            "name": "key",
            "type": "String",
            "readonly": "",
            "example": [
                "\n<div><code>\n// Click any key to display it!\n// (Not Guaranteed to be Case Sensitive)\nfunction setup() {\n  fill(245, 123, 158);\n  textSize(50);\n}\n\nfunction draw() {\n  background(200);\n  text(key, 33, 65); // Display last key pressed.\n}\n</code></div>"
            ],
            "alt": "canvas displays any key value that is pressed in pink font.",
            "class": "p5",
            "module": "Events",
            "submodule": "Keyboard"
        },
        {
            "file": "src/events/keyboard.js",
            "line": 74,
            "description": "<p>The variable keyCode is used to detect special keys such as BACKSPACE,\nDELETE, ENTER, RETURN, TAB, ESCAPE, SHIFT, CONTROL, OPTION, ALT, UP_ARROW,\nDOWN_ARROW, LEFT_ARROW, RIGHT_ARROW.\nYou can also check for custom keys by looking up the keyCode of any key\non a site like this: <a href=\"http://keycode.info/\">keycode.info</a>.</p>\n",
            "itemtype": "property",
            "name": "keyCode",
            "type": "Integer",
            "readonly": "",
            "example": [
                "\n<div><code>\nvar fillVal = 126;\nfunction draw() {\n  fill(fillVal);\n  rect(25, 25, 50, 50);\n}\n\nfunction keyPressed() {\n  if (keyCode === UP_ARROW) {\n    fillVal = 255;\n  } else if (keyCode === DOWN_ARROW) {\n    fillVal = 0;\n  }\n  return false; // prevent default\n}\n</code></div>"
            ],
            "alt": "Grey rect center. turns white when up arrow pressed and black when down",
            "class": "p5",
            "module": "Events",
            "submodule": "Keyboard"
        },
        {
            "file": "src/events/keyboard.js",
            "line": 107,
            "description": "<p>The keyPressed() function is called once every time a key is pressed. The\nkeyCode for the key that was pressed is stored in the keyCode variable.\n<br><br>\nFor non-ASCII keys, use the keyCode variable. You can check if the keyCode\nequals BACKSPACE, DELETE, ENTER, RETURN, TAB, ESCAPE, SHIFT, CONTROL,\nOPTION, ALT, UP_ARROW, DOWN_ARROW, LEFT_ARROW, RIGHT_ARROW.\n<br><br>\nFor ASCII keys that was pressed is stored in the key variable. However, it\ndoes not distinguish between uppercase and lowercase. For this reason, it\nis recommended to use keyTyped() to read the key variable, in which the\ncase of the variable will be distinguished.\n<br><br>\nBecause of how operating systems handle key repeats, holding down a key\nmay cause multiple calls to keyTyped() (and keyReleased() as well). The\nrate of repeat is set by the operating system and how each computer is\nconfigured.<br><br>\nBrowsers may have different default\nbehaviors attached to various key events. To prevent any default\nbehavior for this event, add &quot;return false&quot; to the end of the method.</p>\n",
            "itemtype": "method",
            "name": "keyPressed",
            "example": [
                "\n<div>\n<code>\nvar value = 0;\nfunction draw() {\n  fill(value);\n  rect(25, 25, 50, 50);\n}\nfunction keyPressed() {\n  if (value === 0) {\n    value = 255;\n  } else {\n    value = 0;\n  }\n}\n</code>\n</div>\n<div>\n<code>\nvar value = 0;\nfunction draw() {\n  fill(value);\n  rect(25, 25, 50, 50);\n}\nfunction keyPressed() {\n  if (keyCode === LEFT_ARROW) {\n    value = 255;\n  } else if (keyCode === RIGHT_ARROW) {\n    value = 0;\n  }\n}\n</code>\n</div>\n<div class=\"norender\">\n<code>\nfunction keyPressed() {\n  // Do something\n  return false; // prevent any default behaviour\n}\n</code>\n</div>"
            ],
            "alt": "black rect center. turns white when key pressed and black when released\nblack rect center. turns white when left arrow pressed and black when right.",
            "class": "p5",
            "module": "Events",
            "submodule": "Keyboard"
        },
        {
            "file": "src/events/keyboard.js",
            "line": 198,
            "description": "<p>The keyReleased() function is called once every time a key is released.\nSee key and keyCode for more information.<br><br>\nBrowsers may have different default\nbehaviors attached to various key events. To prevent any default\nbehavior for this event, add &quot;return false&quot; to the end of the method.</p>\n",
            "itemtype": "method",
            "name": "keyReleased",
            "example": [
                "\n<div>\n<code>\nvar value = 0;\nfunction draw() {\n  fill(value);\n  rect(25, 25, 50, 50);\n}\nfunction keyReleased() {\n  if (value === 0) {\n    value = 255;\n  } else {\n    value = 0;\n  }\n  return false; // prevent any default behavior\n}\n</code>\n</div>"
            ],
            "alt": "black rect center. turns white when key pressed and black when pressed again",
            "class": "p5",
            "module": "Events",
            "submodule": "Keyboard"
        },
        {
            "file": "src/events/keyboard.js",
            "line": 254,
            "description": "<p>The keyTyped() function is called once every time a key is pressed, but\naction keys such as Ctrl, Shift, and Alt are ignored. The most recent\nkey pressed will be stored in the key variable.\n<br><br>\nBecause of how operating systems handle key repeats, holding down a key\nwill cause multiple calls to keyTyped() (and keyReleased() as well). The\nrate of repeat is set by the operating system and how each computer is\nconfigured.<br><br>\nBrowsers may have different default behaviors attached to various key\nevents. To prevent any default behavior for this event, add &quot;return false&quot;\nto the end of the method.</p>\n",
            "itemtype": "method",
            "name": "keyTyped",
            "example": [
                "\n<div>\n<code>\nvar value = 0;\nfunction draw() {\n  fill(value);\n  rect(25, 25, 50, 50);\n}\nfunction keyTyped() {\n  if (key === 'a') {\n    value = 255;\n  } else if (key === 'b') {\n    value = 0;\n  }\n  // uncomment to prevent any default behavior\n  // return false;\n}\n</code>\n</div>"
            ],
            "alt": "black rect center. turns white when 'a' key typed and black when 'b' pressed",
            "class": "p5",
            "module": "Events",
            "submodule": "Keyboard"
        },
        {
            "file": "src/events/keyboard.js",
            "line": 308,
            "description": "<p>The onblur function is called when the user is no longer focused\non the p5 element. Because the keyup events will not fire if the user is\nnot focused on the element we must assume all keys currently down have\nbeen released.</p>\n",
            "class": "p5",
            "module": "Events",
            "submodule": "Keyboard"
        },
        {
            "file": "src/events/keyboard.js",
            "line": 318,
            "description": "<p>The keyIsDown() function checks if the key is currently down, i.e. pressed.\nIt can be used if you have an object that moves, and you want several keys\nto be able to affect its behaviour simultaneously, such as moving a\nsprite diagonally. You can put in any number representing the keyCode of\nthe key, or use any of the variable keyCode names listed\n<a href=\"http://p5js.org/reference/#p5/keyCode\">here</a>.</p>\n",
            "itemtype": "method",
            "name": "keyIsDown",
            "params": [
                {
                    "name": "code",
                    "description": "<p>The key to check for.</p>\n",
                    "type": "Number"
                }
            ],
            "return": {
                "description": "whether key is down or not",
                "type": "Boolean"
            },
            "example": [
                "\n<div><code>\nvar x = 100;\nvar y = 100;\n\nfunction setup() {\n  createCanvas(512, 512);\n}\n\nfunction draw() {\n  if (keyIsDown(LEFT_ARROW)) {\n    x -= 5;\n  }\n\n  if (keyIsDown(RIGHT_ARROW)) {\n    x += 5;\n  }\n\n  if (keyIsDown(UP_ARROW)) {\n    y -= 5;\n  }\n\n  if (keyIsDown(DOWN_ARROW)) {\n    y += 5;\n  }\n\n  clear();\n  fill(255, 0, 0);\n  ellipse(x, y, 50, 50);\n}\n</code></div>"
            ],
            "alt": "50x50 red ellipse moves left, right, up and down with arrow presses.",
            "class": "p5",
            "module": "Events",
            "submodule": "Keyboard"
        },
        {
            "file": "src/events/mouse.js",
            "line": 22,
            "description": "<p>The system variable mouseX always contains the current horizontal\nposition of the mouse, relative to (0, 0) of the canvas. If touch is\nused instead of mouse input, mouseX will hold the x value of the most\nrecent touch point.</p>\n",
            "itemtype": "property",
            "name": "mouseX",
            "type": "Number",
            "readonly": "",
            "example": [
                "\n<div>\n<code>\n// Move the mouse across the canvas\nfunction draw() {\n  background(244, 248, 252);\n  line(mouseX, 0, mouseX, 100);\n}\n</code>\n</div>"
            ],
            "alt": "horizontal black line moves left and right with mouse x-position",
            "class": "p5",
            "module": "Events",
            "submodule": "Mouse"
        },
        {
            "file": "src/events/mouse.js",
            "line": 48,
            "description": "<p>The system variable mouseY always contains the current vertical position\nof the mouse, relative to (0, 0) of the canvas. If touch is\nused instead of mouse input, mouseY will hold the y value of the most\nrecent touch point.</p>\n",
            "itemtype": "property",
            "name": "mouseY",
            "type": "Number",
            "readonly": "",
            "example": [
                "\n<div>\n<code>\n// Move the mouse across the canvas\nfunction draw() {\n  background(244, 248, 252);\n  line(0, mouseY, 100, mouseY);\n}\n</code>\n</div>"
            ],
            "alt": "vertical black line moves up and down with mouse y-position",
            "class": "p5",
            "module": "Events",
            "submodule": "Mouse"
        },
        {
            "file": "src/events/mouse.js",
            "line": 74,
            "description": "<p>The system variable pmouseX always contains the horizontal position of\nthe mouse or finger in the frame previous to the current frame, relative to\n(0, 0) of the canvas.</p>\n",
            "itemtype": "property",
            "name": "pmouseX",
            "type": "Number",
            "readonly": "",
            "example": [
                "\n<div>\n<code>\n// Move the mouse across the canvas to leave a trail\nfunction setup() {\n  //slow down the frameRate to make it more visible\n  frameRate(10);\n}\n\nfunction draw() {\n  background(244, 248, 252);\n  line(mouseX, mouseY, pmouseX, pmouseY);\n  print(pmouseX + ' -> ' + mouseX);\n}\n</code>\n</div>"
            ],
            "alt": "line trail is created from cursor movements. faster movement make longer line.",
            "class": "p5",
            "module": "Events",
            "submodule": "Mouse"
        },
        {
            "file": "src/events/mouse.js",
            "line": 105,
            "description": "<p>The system variable pmouseY always contains the vertical position of the\nmouse or finger in the frame previous to the current frame, relative to\n(0, 0) of the canvas.</p>\n",
            "itemtype": "property",
            "name": "pmouseY",
            "type": "Number",
            "readonly": "",
            "example": [
                "\n<div>\n<code>\nfunction draw() {\n  background(237, 34, 93);\n  fill(0);\n  //draw a square only if the mouse is not moving\n  if (mouseY === pmouseY && mouseX === pmouseX) {\n    rect(20, 20, 60, 60);\n  }\n\n  print(pmouseY + ' -> ' + mouseY);\n}\n</code>\n</div>"
            ],
            "alt": "60x60 black rect center, fuschia background. rect flickers on mouse movement",
            "class": "p5",
            "module": "Events",
            "submodule": "Mouse"
        },
        {
            "file": "src/events/mouse.js",
            "line": 135,
            "description": "<p>The system variable winMouseX always contains the current horizontal\nposition of the mouse, relative to (0, 0) of the window.</p>\n",
            "itemtype": "property",
            "name": "winMouseX",
            "type": "Number",
            "readonly": "",
            "example": [
                "\n<div>\n<code>\nvar myCanvas;\n\nfunction setup() {\n  //use a variable to store a pointer to the canvas\n  myCanvas = createCanvas(100, 100);\n}\n\nfunction draw() {\n  background(237, 34, 93);\n  fill(0);\n\n  //move the canvas to the horizontal mouse position\n  //rela                    tive to the window\n  myCanvas.position(winMouseX + 1, windowHeight / 2);\n\n  //the y of the square is relative to the canvas\n  rect(20, mouseY, 60, 60);\n}\n</code>\n</div>"
            ],
            "alt": "60x60 black rect y moves with mouse y and fuschia canvas moves with mouse x",
            "class": "p5",
            "module": "Events",
            "submodule": "Mouse"
        },
        {
            "file": "src/events/mouse.js",
            "line": 172,
            "description": "<p>The system variable winMouseY always contains the current vertical\nposition of the mouse, relative to (0, 0) of the window.</p>\n",
            "itemtype": "property",
            "name": "winMouseY",
            "type": "Number",
            "readonly": "",
            "example": [
                "\n<div>\n<code>\nvar myCanvas;\n\nfunction setup() {\n  //use a variable to store a pointer to the canvas\n  myCanvas = createCanvas(100, 100);\n}\n\nfunction draw() {\n  background(237, 34, 93);\n  fill(0);\n\n  //move the canvas to the vertical mouse position\n  //rel                    ative to the window\n  myCanvas.position(windowWidth / 2, winMouseY + 1);\n\n  //the x of the square is relative to the canvas\n  rect(mouseX, 20, 60, 60);\n}\n</code>\n</div>"
            ],
            "alt": "60x60 black rect x moves with mouse x and fuschia canvas y moves with mouse y",
            "class": "p5",
            "module": "Events",
            "submodule": "Mouse"
        },
        {
            "file": "src/events/mouse.js",
            "line": 209,
            "description": "<p>The system variable pwinMouseX always contains the horizontal position\nof the mouse in the frame previous to the current frame, relative to\n(0, 0) of the window.</p>\n",
            "itemtype": "property",
            "name": "pwinMouseX",
            "type": "Number",
            "readonly": "",
            "example": [
                "\n<div>\n<code>\nvar myCanvas;\n\nfunction setup() {\n  //use a variable to store a pointer to the canvas\n  myCanvas = createCanvas(100, 100);\n  noStroke();\n  fill(237, 34, 93);\n}\n\nfunction draw() {\n  clear();\n  //the difference between previous and\n  //current x position is the horizontal mouse speed\n  var speed = abs(winMouseX - pwinMouseX);\n  //change the size of the circle\n  //according to the horizontal speed\n  ellipse(50, 50, 10 + speed * 5, 10 + speed * 5);\n  //move the canvas to the mouse position\n  myCanvas.position(winMouseX + 1, winMouseY + 1);\n}\n</code>\n</div>"
            ],
            "alt": "fuschia ellipse moves with mouse x and y. Grows and shrinks with mouse speed",
            "class": "p5",
            "module": "Events",
            "submodule": "Mouse"
        },
        {
            "file": "src/events/mouse.js",
            "line": 249,
            "description": "<p>The system variable pwinMouseY always contains the vertical position of\nthe mouse in the frame previous to the current frame, relative to (0, 0)\nof the window.</p>\n",
            "itemtype": "property",
            "name": "pwinMouseY",
            "type": "Number",
            "readonly": "",
            "example": [
                "\n<div>\n<code>\nvar myCanvas;\n\nfunction setup() {\n  //use a variable to store a pointer to the canvas\n  myCanvas = createCanvas(100, 100);\n  noStroke();\n  fill(237, 34, 93);\n}\n\nfunction draw() {\n  clear();\n  //the difference between previous and\n  //current y position is the vertical mouse speed\n  var speed = abs(winMouseY - pwinMouseY);\n  //change the size of the circle\n  //according to the vertical speed\n  ellipse(50, 50, 10 + speed * 5, 10 + speed * 5);\n  //move the canvas to the mouse position\n  myCanvas.position(winMouseX + 1, winMouseY + 1);\n}\n</code>\n</div>"
            ],
            "alt": "fuschia ellipse moves with mouse x and y. Grows and shrinks with mouse speed",
            "class": "p5",
            "module": "Events",
            "submodule": "Mouse"
        },
        {
            "file": "src/events/mouse.js",
            "line": 290,
            "description": "<p>Processing automatically tracks if the mouse button is pressed and which\nbutton is pressed. The value of the system variable mouseButton is either\nLEFT, RIGHT, or CENTER depending on which button was pressed last.\nWarning: different browsers may track mouseButton differently.</p>\n",
            "itemtype": "property",
            "name": "mouseButton",
            "type": "Constant",
            "readonly": "",
            "example": [
                "\n<div>\n<code>\nfunction draw() {\n  background(237, 34, 93);\n  fill(0);\n\n  if (mouseIsPressed) {\n    if (mouseButton === LEFT) {\n      ellipse(50, 50, 50, 50);\n    }\n    if (mouseButton === RIGHT) {\n      rect(25, 25, 50, 50);\n    }\n    if (mouseButton === CENTER) {\n      triangle(23, 75, 50, 20, 78, 75);\n    }\n  }\n\n  print(mouseButton);\n}\n</code>\n</div>"
            ],
            "alt": "50x50 black ellipse appears on center of fuschia canvas on mouse click/press.",
            "class": "p5",
            "module": "Events",
            "submodule": "Mouse"
        },
        {
            "file": "src/events/mouse.js",
            "line": 329,
            "description": "<p>The boolean system variable mouseIsPressed is true if the mouse is pressed\nand false if not.</p>\n",
            "itemtype": "property",
            "name": "mouseIsPressed",
            "type": "Boolean",
            "readonly": "",
            "example": [
                "\n<div>\n<code>\nfunction draw() {\n  background(237, 34, 93);\n  fill(0);\n\n  if (mouseIsPressed) {\n    ellipse(50, 50, 50, 50);\n  } else {\n    rect(25, 25, 50, 50);\n  }\n\n  print(mouseIsPressed);\n}\n</code>\n</div>"
            ],
            "alt": "black 50x50 rect becomes ellipse with mouse click/press. fuschia background.",
            "class": "p5",
            "module": "Events",
            "submodule": "Mouse"
        },
        {
            "file": "src/events/mouse.js",
            "line": 418,
            "description": "<p>The mouseMoved() function is called every time the mouse moves and a mouse\nbutton is not pressed.<br><br>\nBrowsers may have different default\nbehaviors attached to various mouse events. To prevent any default\nbehavior for this event, add &quot;return false&quot; to the end of the method.</p>\n",
            "itemtype": "method",
            "name": "mouseMoved",
            "example": [
                "\n<div>\n<code>\n// Move the mouse across the page\n// to change its value\n\nvar value = 0;\nfunction draw() {\n  fill(value);\n  rect(25, 25, 50, 50);\n}\nfunction mouseMoved() {\n  value = value + 5;\n  if (value > 255) {\n    value = 0;\n  }\n}\n</code>\n</div>\n\n<div class=\"norender\">\n<code>\nfunction mouseMoved() {\n  ellipse(mouseX, mouseY, 5, 5);\n  // prevent default\n  return false;\n}\n</code>\n</div>"
            ],
            "alt": "black 50x50 rect becomes lighter with mouse movements until white then resets\nno image displayed",
            "class": "p5",
            "module": "Events",
            "submodule": "Mouse"
        },
        {
            "file": "src/events/mouse.js",
            "line": 462,
            "description": "<p>The mouseDragged() function is called once every time the mouse moves and\na mouse button is pressed. If no mouseDragged() function is defined, the\ntouchMoved() function will be called instead if it is defined.<br><br>\nBrowsers may have different default\nbehaviors attached to various mouse events. To prevent any default\nbehavior for this event, add &quot;return false&quot; to the end of the method.</p>\n",
            "itemtype": "method",
            "name": "mouseDragged",
            "example": [
                "\n<div>\n<code>\n// Drag the mouse across the page\n// to change its value\n\nvar value = 0;\nfunction draw() {\n  fill(value);\n  rect(25, 25, 50, 50);\n}\nfunction mouseDragged() {\n  value = value + 5;\n  if (value > 255) {\n    value = 0;\n  }\n}\n</code>\n</div>\n\n<div class=\"norender\">\n<code>\nfunction mouseDragged() {\n  ellipse(mouseX, mouseY, 5, 5);\n  // prevent default\n  return false;\n}\n</code>\n</div>"
            ],
            "alt": "black 50x50 rect turns lighter with mouse click and drag until white, resets\nno image displayed",
            "class": "p5",
            "module": "Events",
            "submodule": "Mouse"
        },
        {
            "file": "src/events/mouse.js",
            "line": 532,
            "description": "<p>The mousePressed() function is called once after every time a mouse button\nis pressed. The mouseButton variable (see the related reference entry)\ncan be used to determine which button has been pressed. If no\nmousePressed() function is defined, the touchStarted() function will be\ncalled instead if it is defined.<br><br>\nBrowsers may have different default\nbehaviors attached to various mouse events. To prevent any default\nbehavior for this event, add &quot;return false&quot; to the end of the method.</p>\n",
            "itemtype": "method",
            "name": "mousePressed",
            "example": [
                "\n<div>\n<code>\n// Click within the image to change\n// the value of the rectangle\n\nvar value = 0;\nfunction draw() {\n  fill(value);\n  rect(25, 25, 50, 50);\n}\nfunction mousePressed() {\n  if (value === 0) {\n    value = 255;\n  } else {\n    value = 0;\n  }\n}\n</code>\n</div>\n\n<div class=\"norender\">\n<code>\nfunction mousePressed() {\n  ellipse(mouseX, mouseY, 5, 5);\n  // prevent default\n  return false;\n}\n</code>\n</div>"
            ],
            "alt": "black 50x50 rect turns white with mouse click/press.\nno image displayed",
            "class": "p5",
            "module": "Events",
            "submodule": "Mouse"
        },
        {
            "file": "src/events/mouse.js",
            "line": 598,
            "description": "<p>The mouseReleased() function is called every time a mouse button is\nreleased. If no mouseReleased() function is defined, the touchEnded()\nfunction will be called instead if it is defined.<br><br>\nBrowsers may have different default\nbehaviors attached to various mouse events. To prevent any default\nbehavior for this event, add &quot;return false&quot; to the end of the method.</p>\n",
            "itemtype": "method",
            "name": "mouseReleased",
            "example": [
                "\n<div>\n<code>\n// Click within the image to change\n// the value of the rectangle\n// after the mouse has been clicked\n\nvar value = 0;\nfunction draw() {\n  fill(value);\n  rect(25, 25, 50, 50);\n}\nfunction mouseReleased() {\n  if (value === 0) {\n    value = 255;\n  } else {\n    value = 0;\n  }\n}\n</code>\n</div>\n\n<div class=\"norender\">\n<code>\nfunction mouseReleased() {\n  ellipse(mouseX, mouseY, 5, 5);\n  // prevent default\n  return false;\n}\n</code>\n</div>"
            ],
            "alt": "black 50x50 rect turns white with mouse click/press.\nno image displayed",
            "class": "p5",
            "module": "Events",
            "submodule": "Mouse"
        },
        {
            "file": "src/events/mouse.js",
            "line": 665,
            "description": "<p>The mouseClicked() function is called once after a mouse button has been\npressed and then released.<br><br>\nBrowsers handle clicks differently, so this function is only guaranteed to be\nrun when the left mouse button is clicked. To handle other mouse buttons\nbeing pressed or released, see mousePressed() or mouseReleased().<br><br>\nBrowsers may have different default\nbehaviors attached to various mouse events. To prevent any default\nbehavior for this event, add &quot;return false&quot; to the end of the method.</p>\n",
            "itemtype": "method",
            "name": "mouseClicked",
            "example": [
                "\n<div>\n<code>\n// Click within the image to change\n// the value of the rectangle\n// after the mouse has been clicked\n\nvar value = 0;\nfunction draw() {\n  fill(value);\n  rect(25, 25, 50, 50);\n}\n\nfunction mouseClicked() {\n  if (value === 0) {\n    value = 255;\n  } else {\n    value = 0;\n  }\n}\n</code>\n</div>\n\n<div class=\"norender\">\n<code>\nfunction mouseClicked() {\n  ellipse(mouseX, mouseY, 5, 5);\n  // prevent default\n  return false;\n}\n</code>\n</div>"
            ],
            "alt": "black 50x50 rect turns white with mouse click/press.\nno image displayed",
            "class": "p5",
            "module": "Events",
            "submodule": "Mouse"
        },
        {
            "file": "src/events/mouse.js",
            "line": 724,
            "description": "<p>The doubleClicked() function is executed every time a event\nlistener has detected a dblclick event which is a part of the\nDOM L3 specification. The doubleClicked event is fired when a\npointing device button (usually a mouse&#39;s primary button)\nis clicked twice on a single element. For more info on the\ndblclick event refer to mozilla&#39;s documentation here:\n<a href=\"https://developer.mozilla.org/en-US/docs/Web/Events/dblclick\">https://developer.mozilla.org/en-US/docs/Web/Events/dblclick</a></p>\n",
            "itemtype": "method",
            "name": "doubleClicked",
            "example": [
                "\n<div>\n<code>\n// Click within the image to change\n// the value of the rectangle\n// after the mouse has been double clicked\n\nvar value = 0;\nfunction draw() {\n  fill(value);\n  rect(25, 25, 50, 50);\n}\n\nfunction doubleClicked() {\n  if (value === 0) {\n    value = 255;\n  } else {\n    value = 0;\n  }\n}\n</code>\n</div>\n\n<div class=\"norender\">\n<code>\nfunction doubleClicked() {\n  ellipse(mouseX, mouseY, 5, 5);\n  // prevent default\n  return false;\n}\n</code>\n</div>"
            ],
            "alt": "black 50x50 rect turns white with mouse doubleClick/press.\nno image displayed",
            "class": "p5",
            "module": "Events",
            "submodule": "Mouse"
        },
        {
            "file": "src/events/mouse.js",
            "line": 782,
            "description": "<p>The function mouseWheel() is executed every time a vertical mouse wheel\nevent is detected either triggered by an actual mouse wheel or by a\ntouchpad.<br><br>\nThe event.delta property returns the amount the mouse wheel\nhave scrolled. The values can be positive or negative depending on the\nscroll direction (on OS X with &quot;natural&quot; scrolling enabled, the signs\nare inverted).<br><br>\nBrowsers may have different default behaviors attached to various\nmouse events. To prevent any default behavior for this event, add\n&quot;return false&quot; to the end of the method.<br><br>\nDue to the current support of the &quot;wheel&quot; event on Safari, the function\nmay only work as expected if &quot;return false&quot; is included while using Safari.</p>\n",
            "itemtype": "method",
            "name": "mouseWheel",
            "example": [
                "\n<div>\n<code>\nvar pos = 25;\n\nfunction draw() {\n  background(237, 34, 93);\n  fill(0);\n  rect(25, pos, 50, 50);\n}\n\nfunction mouseWheel(event) {\n  print(event.delta);\n  //move the square according to the vertical scroll amount\n  pos += event.delta;\n  //uncomment to block page scrolling\n  //return false;\n}\n</code>\n</div>"
            ],
            "alt": "black 50x50 rect moves up and down with vertical scroll. fuschia background",
            "class": "p5",
            "module": "Events",
            "submodule": "Mouse"
        },
        {
            "file": "src/events/touch.js",
            "line": 12,
            "description": "<p>The system variable touches[] contains an array of the positions of all\ncurrent touch points, relative to (0, 0) of the canvas, and IDs identifying a\nunique touch as it moves. Each element in the array is an object with x, y,\nand id properties.</p>\n<p>The touches[] array is not supported on Safari and IE on touch-based\ndesktops (laptops).</p>\n",
            "itemtype": "property",
            "name": "touches",
            "type": "Object[]",
            "readonly": "",
            "class": "p5",
            "module": "Events",
            "submodule": "Touch"
        },
        {
            "file": "src/events/touch.js",
            "line": 57,
            "description": "<p>The touchStarted() function is called once after every time a touch is\nregistered. If no touchStarted() function is defined, the mousePressed()\nfunction will be called instead if it is defined.<br><br>\nBrowsers may have different default behaviors attached to various touch\nevents. To prevent any default behavior for this event, add &quot;return false&quot;\nto the end of the method.</p>\n",
            "itemtype": "method",
            "name": "touchStarted",
            "example": [
                "\n<div>\n<code>\n// Touch within the image to change\n// the value of the rectangle\n\nvar value = 0;\nfunction draw() {\n  fill(value);\n  rect(25, 25, 50, 50);\n}\nfunction touchStarted() {\n  if (value === 0) {\n    value = 255;\n  } else {\n    value = 0;\n  }\n}\n</code>\n</div>\n\n<div class=\"norender\">\n<code>\nfunction touchStarted() {\n  ellipse(mouseX, mouseY, 5, 5);\n  // prevent default\n  return false;\n}\n</code>\n</div>"
            ],
            "alt": "50x50 black rect turns white with touch event.\nno image displayed",
            "class": "p5",
            "module": "Events",
            "submodule": "Touch"
        },
        {
            "file": "src/events/touch.js",
            "line": 120,
            "description": "<p>The touchMoved() function is called every time a touch move is registered.\nIf no touchMoved() function is defined, the mouseDragged() function will\nbe called instead if it is defined.<br><br>\nBrowsers may have different default behaviors attached to various touch\nevents. To prevent any default behavior for this event, add &quot;return false&quot;\nto the end of the method.</p>\n",
            "itemtype": "method",
            "name": "touchMoved",
            "example": [
                "\n<div>\n<code>\n// Move your finger across the page\n// to change its value\n\nvar value = 0;\nfunction draw() {\n  fill(value);\n  rect(25, 25, 50, 50);\n}\nfunction touchMoved() {\n  value = value + 5;\n  if (value > 255) {\n    value = 0;\n  }\n}\n</code>\n</div>\n\n<div class=\"norender\">\n<code>\nfunction touchMoved() {\n  ellipse(mouseX, mouseY, 5, 5);\n  // prevent default\n  return false;\n}\n</code>\n</div>"
            ],
            "alt": "50x50 black rect turns lighter with touch until white. resets\nno image displayed",
            "class": "p5",
            "module": "Events",
            "submodule": "Touch"
        },
        {
            "file": "src/events/touch.js",
            "line": 182,
            "description": "<p>The touchEnded() function is called every time a touch ends. If no\ntouchEnded() function is defined, the mouseReleased() function will be\ncalled instead if it is defined.<br><br>\nBrowsers may have different default behaviors attached to various touch\nevents. To prevent any default behavior for this event, add &quot;return false&quot;\nto the end of the method.</p>\n",
            "itemtype": "method",
            "name": "touchEnded",
            "example": [
                "\n<div>\n<code>\n// Release touch within the image to\n// change the value of the rectangle\n\nvar value = 0;\nfunction draw() {\n  fill(value);\n  rect(25, 25, 50, 50);\n}\nfunction touchEnded() {\n  if (value === 0) {\n    value = 255;\n  } else {\n    value = 0;\n  }\n}\n</code>\n</div>\n\n<div class=\"norender\">\n<code>\nfunction touchEnded() {\n  ellipse(mouseX, mouseY, 5, 5);\n  // prevent default\n  return false;\n}\n</code>\n</div>"
            ],
            "alt": "50x50 black rect turns white with touch.\nno image displayed",
            "class": "p5",
            "module": "Events",
            "submodule": "Touch"
        },
        {
            "file": "src/image/filters.js",
            "line": 3,
            "description": "<p>This module defines the filters for use with image buffers.</p>\n<p>This module is basically a collection of functions stored in an object\nas opposed to modules. The functions are destructive, modifying\nthe passed in canvas rather than creating a copy.</p>\n<p>Generally speaking users of this module will use the Filters.apply method\non a canvas to create an effect.</p>\n<p>A number of functions are borrowed/adapted from\n<a href=\"http://www.html5rocks.com/en/tutorials/canvas/imagefilters/\">http://www.html5rocks.com/en/tutorials/canvas/imagefilters/</a>\nor the java processing implementation.</p>\n",
            "class": "p5",
            "module": "Events"
        },
        {
            "file": "src/image/image.js",
            "line": 8,
            "description": "<p>This module defines the p5 methods for the p5.Image class\nfor drawing images to the main display canvas.</p>\n",
            "class": "p5",
            "module": "Image",
            "submodule": "Image"
        },
        {
            "file": "src/image/image.js",
            "line": 18,
            "description": "<p>Creates a new p5.Image (the datatype for storing images). This provides a\nfresh buffer of pixels to play with. Set the size of the buffer with the\nwidth and height parameters.\n<br><br>\n.pixels gives access to an array containing the values for all the pixels\nin the display window.\nThese values are numbers. This array is the size (including an appropriate\nfactor for the pixelDensity) of the display window x4,\nrepresenting the R, G, B, A values in order for each pixel, moving from\nleft to right across each row, then down each column. See .pixels for\nmore info. It may also be simpler to use set() or get().\n<br><br>\nBefore accessing the pixels of an image, the data must loaded with the\nloadPixels() function. After the array data has been modified, the\nupdatePixels() function must be run to update the changes.</p>\n",
            "itemtype": "method",
            "name": "createImage",
            "params": [
                {
                    "name": "width",
                    "description": "<p>width in pixels</p>\n",
                    "type": "Integer"
                },
                {
                    "name": "height",
                    "description": "<p>height in pixels</p>\n",
                    "type": "Integer"
                }
            ],
            "return": {
                "description": "the p5.Image object",
                "type": "p5.Image"
            },
            "example": [
                "\n<div>\n<code>\nvar img = createImage(66, 66);\nimg.loadPixels();\nfor (var i = 0; i < img.width; i++) {\n  for (var j = 0; j < img.height; j++) {\n    img.set(i, j, color(0, 90, 102));\n  }\n}\nimg.updatePixels();\nimage(img, 17, 17);\n</code>\n</div>\n\n<div>\n<code>\nvar img = createImage(66, 66);\nimg.loadPixels();\nfor (var i = 0; i < img.width; i++) {\n  for (var j = 0; j < img.height; j++) {\n    img.set(i, j, color(0, 90, 102, (i % img.width) * 2));\n  }\n}\nimg.updatePixels();\nimage(img, 17, 17);\nimage(img, 34, 34);\n</code>\n</div>\n\n<div>\n<code>\nvar pink = color(255, 102, 204);\nvar img = createImage(66, 66);\nimg.loadPixels();\nvar d = pixelDensity();\nvar halfImage = 4 * (width * d) * (height / 2 * d);\nfor (var i = 0; i < halfImage; i += 4) {\n  img.pixels[i] = red(pink);\n  img.pixels[i + 1] = green(pink);\n  img.pixels[i + 2] = blue(pink);\n  img.pixels[i + 3] = alpha(pink);\n}\nimg.updatePixels();\nimage(img, 17, 17);\n</code>\n</div>"
            ],
            "alt": "66x66 dark turquoise rect in center of canvas.\n2 gradated dark turquoise rects fade left. 1 center 1 bottom right of canvas\nno image displayed",
            "class": "p5",
            "module": "Image",
            "submodule": "Image"
        },
        {
            "file": "src/image/image.js",
            "line": 98,
            "description": "<p>Save the current canvas as an image. In Safari, this will open the\nimage in the window and the user must provide their own\nfilename on save-as. Other browsers will either save the\nfile immediately, or prompt the user with a dialogue window.</p>\n",
            "itemtype": "method",
            "name": "saveCanvas",
            "example": [
                "\n <div class='norender'><code>\n function setup() {\n var c = createCanvas(100, 100);\n background(255, 0, 0);\n saveCanvas(c, 'myCanvas', 'jpg');\n }\n </code></div>\n <div class='norender'><code>\n // note that this example has the same result as above\n // if no canvas is specified, defaults to main canvas\n function setup() {\n var c = createCanvas(100, 100);\n background(255, 0, 0);\n saveCanvas('myCanvas', 'jpg');\n\n // all of the following are valid\n saveCanvas(c, 'myCanvas', 'jpg');\n saveCanvas(c, 'myCanvas');\n saveCanvas(c);\n saveCanvas('myCanvas', 'png');\n saveCanvas('myCanvas');\n saveCanvas();\n }\n </code></div>"
            ],
            "alt": "no image displayed\n no image displayed\n no image displayed",
            "class": "p5",
            "module": "Image",
            "submodule": "Image",
            "overloads": [
                {
                    "line": 98,
                    "params": [
                        {
                            "name": "selectedCanvas",
                            "description": "<p>a variable\n                                representing a specific html5 canvas (optional)</p>\n",
                            "type": "p5.Element|HTMLCanvasElement"
                        },
                        {
                            "name": "filename",
                            "description": "",
                            "type": "String",
                            "optional": true
                        },
                        {
                            "name": "extension",
                            "description": "<p>&#39;jpg&#39; or &#39;png&#39;</p>\n",
                            "type": "String",
                            "optional": true
                        }
                    ]
                },
                {
                    "line": 141,
                    "params": [
                        {
                            "name": "filename",
                            "description": "",
                            "type": "String",
                            "optional": true
                        },
                        {
                            "name": "extension",
                            "description": "",
                            "type": "String",
                            "optional": true
                        }
                    ]
                }
            ]
        },
        {
            "file": "src/image/image.js",
            "line": 178,
            "description": "<p>Capture a sequence of frames that can be used to create a movie.\nAccepts a callback. For example, you may wish to send the frames\nto a server where they can be stored or converted into a movie.\nIf no callback is provided, the browser will pop up save dialogues in an\nattempt to download all of the images that have just been created. With the\ncallback provided the image data isn&#39;t saved by default but instead passed\nas an argument to the callback function as an array of objects, with the\nsize of array equal to the total number of frames.</p>\n<p>Note that saveFrames() will only save the first 15 frames of an animation.\nTo export longer animations, you might look into a library like\n<a href=\"https://github.com/spite/ccapture.js/\">ccapture.js</a>.</p>\n",
            "itemtype": "method",
            "name": "saveFrames",
            "params": [
                {
                    "name": "filename",
                    "description": "",
                    "type": "String"
                },
                {
                    "name": "extension",
                    "description": "<p>&#39;jpg&#39; or &#39;png&#39;</p>\n",
                    "type": "String"
                },
                {
                    "name": "duration",
                    "description": "<p>Duration in seconds to save the frames for.</p>\n",
                    "type": "Number"
                },
                {
                    "name": "framerate",
                    "description": "<p>Framerate to save the frames in.</p>\n",
                    "type": "Number"
                },
                {
                    "name": "callback",
                    "description": "<p>A callback function that will be executed\n                                to handle the image data. This function\n                                should accept an array as argument. The\n                                array will contain the specified number of\n                                frames of objects. Each object has three\n                                properties: imageData - an\n                                image/octet-stream, filename and extension.</p>\n",
                    "type": "Function(Array)",
                    "optional": true
                }
            ],
            "example": [
                "\n<div><code>\n function draw() {\n background(mouseX);\n }\n\n function mousePressed() {\n saveFrames('out', 'png', 1, 25, function(data) {\n   print(data);\n });\n }\n</code></div>"
            ],
            "alt": "canvas background goes from light to dark with mouse x.",
            "class": "p5",
            "module": "Image",
            "submodule": "Image"
        },
        {
            "file": "src/image/loading_displaying.js",
            "line": 17,
            "description": "<p>Loads an image from a path and creates a p5.Image from it.\n<br><br>\nThe image may not be immediately available for rendering\nIf you want to ensure that the image is ready before doing\nanything with it, place the loadImage() call in preload().\nYou may also supply a callback function to handle the image when it&#39;s ready.\n<br><br>\nThe path to the image should be relative to the HTML file\nthat links in your sketch. Loading an image from a URL or other\nremote location may be blocked due to your browser&#39;s built-in\nsecurity.</p>\n",
            "itemtype": "method",
            "name": "loadImage",
            "params": [
                {
                    "name": "path",
                    "description": "<p>Path of the image to be loaded</p>\n",
                    "type": "String"
                },
                {
                    "name": "successCallback",
                    "description": "<p>Function to be called once\n                               the image is loaded. Will be passed the\n                               p5.Image.</p>\n",
                    "type": "function(p5.Image)",
                    "optional": true
                },
                {
                    "name": "failureCallback",
                    "description": "<p>called with event error if\n                               the image fails to load.</p>\n",
                    "type": "Function(Event)",
                    "optional": true
                }
            ],
            "return": {
                "description": "the p5.Image object",
                "type": "p5.Image"
            },
            "example": [
                "\n<div>\n<code>\nvar img;\nfunction preload() {\n  img = loadImage('assets/laDefense.jpg');\n}\nfunction setup() {\n  image(img, 0, 0);\n}\n</code>\n</div>\n<div>\n<code>\nfunction setup() {\n  // here we use a callback to display the image after loading\n  loadImage('assets/laDefense.jpg', function(img) {\n    image(img, 0, 0);\n  });\n}\n</code>\n</div>"
            ],
            "alt": "image of the underside of a white umbrella and grided ceililng above\nimage of the underside of a white umbrella and grided ceililng above",
            "class": "p5",
            "module": "Image",
            "submodule": "Loading & Displaying"
        },
        {
            "file": "src/image/loading_displaying.js",
            "line": 125,
            "description": "<p>Draw an image to the p5.js canvas.</p>\n<p>This function can be used with different numbers of parameters. The\nsimplest use requires only three parameters: img, x, and y—where (x, y) is\nthe position of the image. Two more parameters can optionally be added to\nspecify the width and height of the image.</p>\n<p>This function can also be used with all eight Number parameters. To\ndifferentiate between all these parameters, p5.js uses the language of\n&quot;destination rectangle&quot; (which corresponds to &quot;dx&quot;, &quot;dy&quot;, etc.) and &quot;source\nimage&quot; (which corresponds to &quot;sx&quot;, &quot;sy&quot;, etc.) below. Specifying the\n&quot;source image&quot; dimensions can be useful when you want to display a\nsubsection of the source image instead of the whole thing. Here&#39;s a diagram\nto explain further:\n<img src=\"assets/drawImage.png\"></img></p>\n",
            "itemtype": "method",
            "name": "image",
            "example": [
                "\n<div>\n<code>\nvar img;\nfunction preload() {\n  img = loadImage('assets/laDefense.jpg');\n}\nfunction setup() {\n  // Top-left corner of the img is at (0, 0)\n  // Width and height are the img's original width and height\n  image(img, 0, 0);\n}\n</code>\n</div>\n<div>\n<code>\nvar img;\nfunction preload() {\n  img = loadImage('assets/laDefense.jpg');\n}\nfunction setup() {\n  background(50);\n  // Top-left corner of the img is at (10, 10)\n  // Width and height are 50 x 50\n  image(img, 10, 10, 50, 50);\n}\n</code>\n</div>\n<div>\n<code>\nfunction setup() {\n  // Here, we use a callback to display the image after loading\n  loadImage('assets/laDefense.jpg', function(img) {\n    image(img, 0, 0);\n  });\n}\n</code>\n</div>\n<div>\n<code>\nvar img;\nfunction preload() {\n  img = loadImage('assets/gradient.png');\n}\nfunction setup() {\n  // 1. Background image\n  // Top-left corner of the img is at (0, 0)\n  // Width and height are the img's original width and height, 100 x 100\n  image(img, 0, 0);\n  // 2. Top right image\n  // Top-left corner of destination rectangle is at (50, 0)\n  // Destination rectangle width and height are 40 x 20\n  // The next parameters are relative to the source image:\n  // - Starting at position (50, 50) on the source image, capture a 50 x 50\n  // subsection\n  // - Draw this subsection to fill the dimensions of the destination rectangle\n  image(img, 50, 0, 40, 20, 50, 50, 50, 50);\n}\n</code>\n</div>"
            ],
            "alt": "image of the underside of a white umbrella and gridded ceiling above\nimage of the underside of a white umbrella and gridded ceiling above",
            "class": "p5",
            "module": "Image",
            "submodule": "Loading & Displaying",
            "overloads": [
                {
                    "line": 125,
                    "params": [
                        {
                            "name": "img",
                            "description": "<p>the image to display</p>\n",
                            "type": "p5.Image|p5.Element"
                        },
                        {
                            "name": "x",
                            "description": "<p>the x-coordinate of the top-left corner of the image</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "y",
                            "description": "<p>the y-coordinate of the top-left corner of the image</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "width",
                            "description": "<p>the width to draw the image</p>\n",
                            "type": "Number",
                            "optional": true
                        },
                        {
                            "name": "height",
                            "description": "<p>the height to draw the image</p>\n",
                            "type": "Number",
                            "optional": true
                        }
                    ]
                },
                {
                    "line": 213,
                    "params": [
                        {
                            "name": "img",
                            "description": "",
                            "type": "p5.Image|p5.Element"
                        },
                        {
                            "name": "dx",
                            "description": "<p>the x-coordinate of the destination\n                          rectangle in which to draw the source image</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "dy",
                            "description": "<p>the y-coordinate of the destination\n                          rectangle in which to draw the source image</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "dWidth",
                            "description": "<p>the width of the destination rectangle</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "dHeight",
                            "description": "<p>the height of the destination rectangle</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "sx",
                            "description": "<p>the x-coordinate of the subsection of the source\nimage to draw into the destination rectangle</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "sy",
                            "description": "<p>the y-coordinate of the subsection of the source\nimage to draw into the destination rectangle</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "sWidth",
                            "description": "<p>the width of the subsection of the\n                          source image to draw into the destination\n                          rectangle</p>\n",
                            "type": "Number",
                            "optional": true
                        },
                        {
                            "name": "sHeight",
                            "description": "<p>the height of the subsection of the\n                           source image to draw into the destination rectangle</p>\n",
                            "type": "Number",
                            "optional": true
                        }
                    ]
                }
            ]
        },
        {
            "file": "src/image/loading_displaying.js",
            "line": 296,
            "description": "<p>Sets the fill value for displaying images. Images can be tinted to\nspecified colors or made transparent by including an alpha value.\n<br><br>\nTo apply transparency to an image without affecting its color, use\nwhite as the tint color and specify an alpha value. For instance,\ntint(255, 128) will make an image 50% transparent (assuming the default\nalpha range of 0-255, which can be changed with colorMode()).\n<br><br>\nThe value for the gray parameter must be less than or equal to the current\nmaximum value as specified by colorMode(). The default maximum value is\n255.</p>\n",
            "itemtype": "method",
            "name": "tint",
            "example": [
                "\n<div>\n<code>\nvar img;\nfunction preload() {\n  img = loadImage('assets/laDefense.jpg');\n}\nfunction setup() {\n  image(img, 0, 0);\n  tint(0, 153, 204); // Tint blue\n  image(img, 50, 0);\n}\n</code>\n</div>\n\n<div>\n<code>\nvar img;\nfunction preload() {\n  img = loadImage('assets/laDefense.jpg');\n}\nfunction setup() {\n  image(img, 0, 0);\n  tint(0, 153, 204, 126); // Tint blue and set transparency\n  image(img, 50, 0);\n}\n</code>\n</div>\n\n<div>\n<code>\nvar img;\nfunction preload() {\n  img = loadImage('assets/laDefense.jpg');\n}\nfunction setup() {\n  image(img, 0, 0);\n  tint(255, 126); // Apply transparency without changing color\n  image(img, 50, 0);\n}\n</code>\n</div>"
            ],
            "alt": "2 side by side images of umbrella and ceiling, one image with blue tint\nImages of umbrella and ceiling, one half of image with blue tint\n2 side by side images of umbrella and ceiling, one image translucent",
            "class": "p5",
            "module": "Image",
            "submodule": "Loading & Displaying",
            "overloads": [
                {
                    "line": 296,
                    "params": [
                        {
                            "name": "v1",
                            "description": "<p>red or hue value relative to\n                                the current color range</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "v2",
                            "description": "<p>green or saturation value\n                                relative to the current color range</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "v3",
                            "description": "<p>blue or brightness value\n                                relative to the current color range</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "alpha",
                            "description": "",
                            "type": "Number",
                            "optional": true
                        }
                    ]
                },
                {
                    "line": 369,
                    "params": [
                        {
                            "name": "value",
                            "description": "<p>a color string</p>\n",
                            "type": "String"
                        },
                        {
                            "name": "alpha",
                            "description": "",
                            "type": "Number",
                            "optional": true
                        }
                    ]
                },
                {
                    "line": 375,
                    "params": [
                        {
                            "name": "values",
                            "description": "<p>an array containing the red,green,blue &amp;\n                                and alpha components of the color</p>\n",
                            "type": "Number[]"
                        }
                    ]
                },
                {
                    "line": 381,
                    "params": [
                        {
                            "name": "color",
                            "description": "<p>the tint color</p>\n",
                            "type": "p5.Color"
                        }
                    ]
                }
            ]
        },
        {
            "file": "src/image/loading_displaying.js",
            "line": 391,
            "description": "<p>Removes the current fill value for displaying images and reverts to\ndisplaying images with their original hues.</p>\n",
            "itemtype": "method",
            "name": "noTint",
            "example": [
                "\n<div>\n<code>\nvar img;\nfunction preload() {\n  img = loadImage('assets/bricks.jpg');\n}\nfunction setup() {\n  tint(0, 153, 204); // Tint blue\n  image(img, 0, 0);\n  noTint(); // Disable tint\n  image(img, 50, 0);\n}\n</code>\n</div>"
            ],
            "alt": "2 side by side images of bricks, left image with blue tint",
            "class": "p5",
            "module": "Image",
            "submodule": "Loading & Displaying"
        },
        {
            "file": "src/image/loading_displaying.js",
            "line": 457,
            "description": "<p>Set image mode. Modifies the location from which images are drawn by\nchanging the way in which parameters given to image() are interpreted.\nThe default mode is imageMode(CORNER), which interprets the second and\nthird parameters of image() as the upper-left corner of the image. If\ntwo additional parameters are specified, they are used to set the image&#39;s\nwidth and height.\n<br><br>\nimageMode(CORNERS) interprets the second and third parameters of image()\nas the location of one corner, and the fourth and fifth parameters as the\nopposite corner.\n<br><br>\nimageMode(CENTER) interprets the second and third parameters of image()\nas the image&#39;s center point. If two additional parameters are specified,\nthey are used to set the image&#39;s width and height.</p>\n",
            "itemtype": "method",
            "name": "imageMode",
            "params": [
                {
                    "name": "mode",
                    "description": "<p>either CORNER, CORNERS, or CENTER</p>\n",
                    "type": "Constant"
                }
            ],
            "example": [
                "\n\n<div>\n<code>\nvar img;\nfunction preload() {\n  img = loadImage('assets/bricks.jpg');\n}\nfunction setup() {\n  imageMode(CORNER);\n  image(img, 10, 10, 50, 50);\n}\n</code>\n</div>\n\n<div>\n<code>\nvar img;\nfunction preload() {\n  img = loadImage('assets/bricks.jpg');\n}\nfunction setup() {\n  imageMode(CORNERS);\n  image(img, 10, 10, 90, 40);\n}\n</code>\n</div>\n\n<div>\n<code>\nvar img;\nfunction preload() {\n  img = loadImage('assets/bricks.jpg');\n}\nfunction setup() {\n  imageMode(CENTER);\n  image(img, 50, 50, 80, 80);\n}\n</code>\n</div>"
            ],
            "alt": "small square image of bricks\nhorizontal rectangle image of bricks\nlarge square image of bricks",
            "class": "p5",
            "module": "Image",
            "submodule": "Loading & Displaying"
        },
        {
            "file": "src/image/p5.Image.js",
            "line": 9,
            "description": "<p>This module defines the p5.Image class and P5 methods for\ndrawing images to the main display canvas.</p>\n",
            "class": "p5.Image",
            "module": "Image",
            "submodule": "Image"
        },
        {
            "file": "src/image/p5.Image.js",
            "line": 91,
            "description": "<p>Image width.</p>\n",
            "itemtype": "property",
            "name": "width",
            "type": "Number",
            "readonly": "",
            "example": [
                "\n<div><code>\nvar img;\nfunction preload() {\n  img = loadImage('assets/rockies.jpg');\n}\n\nfunction setup() {\n  createCanvas(100, 100);\n  image(img, 0, 0);\n  for (var i = 0; i < img.width; i++) {\n    var c = img.get(i, img.height / 2);\n    stroke(c);\n    line(i, height / 2, i, height);\n  }\n}\n</code></div>"
            ],
            "alt": "rocky mountains in top and horizontal lines in corresponding colors in bottom.",
            "class": "p5.Image",
            "module": "Image",
            "submodule": "Image"
        },
        {
            "file": "src/image/p5.Image.js",
            "line": 118,
            "description": "<p>Image height.</p>\n",
            "itemtype": "property",
            "name": "height",
            "type": "Number",
            "readonly": "",
            "example": [
                "\n<div><code>\nvar img;\nfunction preload() {\n  img = loadImage('assets/rockies.jpg');\n}\n\nfunction setup() {\n  createCanvas(100, 100);\n  image(img, 0, 0);\n  for (var i = 0; i < img.height; i++) {\n    var c = img.get(img.width / 2, i);\n    stroke(c);\n    line(0, i, width / 2, i);\n  }\n}\n</code></div>"
            ],
            "alt": "rocky mountains on right and vertical lines in corresponding colors on left.",
            "class": "p5.Image",
            "module": "Image",
            "submodule": "Image"
        },
        {
            "file": "src/image/p5.Image.js",
            "line": 152,
            "description": "<p>Array containing the values for all the pixels in the display window.\nThese values are numbers. This array is the size (include an appropriate\nfactor for pixelDensity) of the display window x4,\nrepresenting the R, G, B, A values in order for each pixel, moving from\nleft to right across each row, then down each column. Retina and other\nhigh denisty displays may have more pixels[] (by a factor of\npixelDensity^2).\nFor example, if the image is 100x100 pixels, there will be 40,000. With\npixelDensity = 2, there will be 160,000. The first four values\n(indices 0-3) in the array will be the R, G, B, A values of the pixel at\n(0, 0). The second four values (indices 4-7) will contain the R, G, B, A\nvalues of the pixel at (1, 0). More generally, to set values for a pixel\nat (x, y):</p>\n<pre><code class=\"lang-javascript\">var d = pixelDensity();\nfor (var i = 0; i &lt; d; i++) {\n  for (var j = 0; j &lt; d; j++) {\n    // loop over\n    idx = 4 * ((y * d + j) * width * d + (x * d + i));\n    pixels[idx] = r;\n    pixels[idx+1] = g;\n    pixels[idx+2] = b;\n    pixels[idx+3] = a;\n  }\n}\n</code></pre>\n<p><br><br>\nBefore accessing this array, the data must loaded with the loadPixels()\nfunction. After the array data has been modified, the updatePixels()\nfunction must be run to update the changes.</p>\n",
            "itemtype": "property",
            "name": "pixels",
            "type": "Number[]",
            "example": [
                "\n<div>\n<code>\nvar img = createImage(66, 66);\nimg.loadPixels();\nfor (var i = 0; i < img.width; i++) {\n  for (var j = 0; j < img.height; j++) {\n    img.set(i, j, color(0, 90, 102));\n  }\n}\nimg.updatePixels();\nimage(img, 17, 17);\n</code>\n</div>\n<div>\n<code>\nvar pink = color(255, 102, 204);\nvar img = createImage(66, 66);\nimg.loadPixels();\nfor (var i = 0; i < 4 * (width * height / 2); i += 4) {\n  img.pixels[i] = red(pink);\n  img.pixels[i + 1] = green(pink);\n  img.pixels[i + 2] = blue(pink);\n  img.pixels[i + 3] = alpha(pink);\n}\nimg.updatePixels();\nimage(img, 17, 17);\n</code>\n</div>"
            ],
            "alt": "66x66 turquoise rect in center of canvas\n66x66 pink rect in center of canvas",
            "class": "p5.Image",
            "module": "Image",
            "submodule": "Image"
        },
        {
            "file": "src/image/p5.Image.js",
            "line": 223,
            "description": "<p>Helper fxn for sharing pixel methods</p>\n",
            "class": "p5.Image",
            "module": "Image",
            "submodule": "Image"
        },
        {
            "file": "src/image/p5.Image.js",
            "line": 232,
            "description": "<p>Loads the pixels data for this image into the [pixels] attribute.</p>\n",
            "itemtype": "method",
            "name": "loadPixels",
            "example": [
                "\n<div><code>\nvar myImage;\nvar halfImage;\n\nfunction preload() {\n  myImage = loadImage('assets/rockies.jpg');\n}\n\nfunction setup() {\n  myImage.loadPixels();\n  halfImage = 4 * width * height / 2;\n  for (var i = 0; i < halfImage; i++) {\n    myImage.pixels[i + halfImage] = myImage.pixels[i];\n  }\n  myImage.updatePixels();\n}\n\nfunction draw() {\n  image(myImage, 0, 0);\n}\n</code></div>"
            ],
            "alt": "2 images of rocky mountains vertically stacked",
            "class": "p5.Image",
            "module": "Image",
            "submodule": "Image"
        },
        {
            "file": "src/image/p5.Image.js",
            "line": 268,
            "description": "<p>Updates the backing canvas for this image with the contents of\nthe [pixels] array.</p>\n",
            "itemtype": "method",
            "name": "updatePixels",
            "example": [
                "\n<div><code>\nvar myImage;\nvar halfImage;\n\nfunction preload() {\n  myImage = loadImage('assets/rockies.jpg');\n}\n\nfunction setup() {\n  myImage.loadPixels();\n  halfImage = 4 * width * height / 2;\n  for (var i = 0; i < halfImage; i++) {\n    myImage.pixels[i + halfImage] = myImage.pixels[i];\n  }\n  myImage.updatePixels();\n}\n\nfunction draw() {\n  image(myImage, 0, 0);\n}\n</code></div>"
            ],
            "alt": "2 images of rocky mountains vertically stacked",
            "class": "p5.Image",
            "module": "Image",
            "submodule": "Image",
            "overloads": [
                {
                    "line": 268,
                    "params": [
                        {
                            "name": "x",
                            "description": "<p>x-offset of the target update area for the\n                             underlying canvas</p>\n",
                            "type": "Integer"
                        },
                        {
                            "name": "y",
                            "description": "<p>y-offset of the target update area for the\n                             underlying canvas</p>\n",
                            "type": "Integer"
                        },
                        {
                            "name": "w",
                            "description": "<p>height of the target update area for the\n                             underlying canvas</p>\n",
                            "type": "Integer"
                        },
                        {
                            "name": "h",
                            "description": "<p>height of the target update area for the\n                             underlying canvas</p>\n",
                            "type": "Integer"
                        }
                    ]
                },
                {
                    "line": 308,
                    "params": []
                }
            ]
        },
        {
            "file": "src/image/p5.Image.js",
            "line": 316,
            "description": "<p>Get a region of pixels from an image.</p>\n<p>If no params are passed, those whole image is returned,\nif x and y are the only params passed a single pixel is extracted\nif all params are passed a rectangle region is extracted and a p5.Image\nis returned.</p>\n<p>Returns undefined if the region is outside the bounds of the image</p>\n",
            "itemtype": "method",
            "name": "get",
            "params": [
                {
                    "name": "x",
                    "description": "<p>x-coordinate of the pixel</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "y",
                    "description": "<p>y-coordinate of the pixel</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "w",
                    "description": "<p>width</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "h",
                    "description": "<p>height</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "return": {
                "description": "color of pixel at x,y in array format\n                                   [R, G, B, A] or p5.Image",
                "type": "Number[]|Color|p5.Image"
            },
            "example": [
                "\n<div><code>\nvar myImage;\nvar c;\n\nfunction preload() {\n  myImage = loadImage('assets/rockies.jpg');\n}\n\nfunction setup() {\n  background(myImage);\n  noStroke();\n  c = myImage.get(60, 90);\n  fill(c);\n  rect(25, 25, 50, 50);\n}\n\n//get() returns color here\n</code></div>"
            ],
            "alt": "image of rocky mountains with 50x50 green rect in front",
            "class": "p5.Image",
            "module": "Image",
            "submodule": "Image"
        },
        {
            "file": "src/image/p5.Image.js",
            "line": 361,
            "description": "<p>Set the color of a single pixel or write an image into\nthis p5.Image.</p>\n<p>Note that for a large number of pixels this will\nbe slower than directly manipulating the pixels array\nand then calling updatePixels().</p>\n",
            "itemtype": "method",
            "name": "set",
            "params": [
                {
                    "name": "x",
                    "description": "<p>x-coordinate of the pixel</p>\n",
                    "type": "Number"
                },
                {
                    "name": "y",
                    "description": "<p>y-coordinate of the pixel</p>\n",
                    "type": "Number"
                },
                {
                    "name": "a",
                    "description": "<p>grayscale value | pixel array |\n                               a p5.Color | image to copy</p>\n",
                    "type": "Number|Number[]|Object"
                }
            ],
            "example": [
                "\n<div>\n<code>\nvar img = createImage(66, 66);\nimg.loadPixels();\nfor (var i = 0; i < img.width; i++) {\n  for (var j = 0; j < img.height; j++) {\n    img.set(i, j, color(0, 90, 102, (i % img.width) * 2));\n  }\n}\nimg.updatePixels();\nimage(img, 17, 17);\nimage(img, 34, 34);\n</code>\n</div>"
            ],
            "alt": "2 gradated dark turquoise rects fade left. 1 center 1 bottom right of canvas",
            "class": "p5.Image",
            "module": "Image",
            "submodule": "Image"
        },
        {
            "file": "src/image/p5.Image.js",
            "line": 399,
            "description": "<p>Resize the image to a new width and height. To make the image scale\nproportionally, use 0 as the value for the wide or high parameter.\nFor instance, to make the width of an image 150 pixels, and change\nthe height using the same proportion, use resize(150, 0).</p>\n",
            "itemtype": "method",
            "name": "resize",
            "params": [
                {
                    "name": "width",
                    "description": "<p>the resized image width</p>\n",
                    "type": "Number"
                },
                {
                    "name": "height",
                    "description": "<p>the resized image height</p>\n",
                    "type": "Number"
                }
            ],
            "example": [
                "\n<div><code>\nvar img;\n\nfunction preload() {\n  img = loadImage('assets/rockies.jpg');\n}\n\nfunction draw() {\n  image(img, 0, 0);\n}\n\nfunction mousePressed() {\n  img.resize(50, 100);\n}\n</code></div>"
            ],
            "alt": "image of rocky mountains. zoomed in",
            "class": "p5.Image",
            "module": "Image",
            "submodule": "Image"
        },
        {
            "file": "src/image/p5.Image.js",
            "line": 483,
            "description": "<p>Copies a region of pixels from one image to another. If no\nsrcImage is specified this is used as the source. If the source\nand destination regions aren&#39;t the same size, it will\nautomatically resize source pixels to fit the specified\ntarget region.</p>\n",
            "itemtype": "method",
            "name": "copy",
            "example": [
                "\n<div><code>\nvar photo;\nvar bricks;\nvar x;\nvar y;\n\nfunction preload() {\n  photo = loadImage('assets/rockies.jpg');\n  bricks = loadImage('assets/bricks.jpg');\n}\n\nfunction setup() {\n  x = bricks.width / 2;\n  y = bricks.height / 2;\n  photo.copy(bricks, 0, 0, x, y, 0, 0, x, y);\n  image(photo, 0, 0);\n}\n</code></div>"
            ],
            "alt": "image of rocky mountains and smaller image on top of bricks at top left",
            "class": "p5.Image",
            "module": "Image",
            "submodule": "Image",
            "overloads": [
                {
                    "line": 483,
                    "params": [
                        {
                            "name": "srcImage",
                            "description": "<p>source image</p>\n",
                            "type": "p5.Image|p5.Element"
                        },
                        {
                            "name": "sx",
                            "description": "<p>X coordinate of the source&#39;s upper left corner</p>\n",
                            "type": "Integer"
                        },
                        {
                            "name": "sy",
                            "description": "<p>Y coordinate of the source&#39;s upper left corner</p>\n",
                            "type": "Integer"
                        },
                        {
                            "name": "sw",
                            "description": "<p>source image width</p>\n",
                            "type": "Integer"
                        },
                        {
                            "name": "sh",
                            "description": "<p>source image height</p>\n",
                            "type": "Integer"
                        },
                        {
                            "name": "dx",
                            "description": "<p>X coordinate of the destination&#39;s upper left corner</p>\n",
                            "type": "Integer"
                        },
                        {
                            "name": "dy",
                            "description": "<p>Y coordinate of the destination&#39;s upper left corner</p>\n",
                            "type": "Integer"
                        },
                        {
                            "name": "dw",
                            "description": "<p>destination image width</p>\n",
                            "type": "Integer"
                        },
                        {
                            "name": "dh",
                            "description": "<p>destination image height</p>\n",
                            "type": "Integer"
                        }
                    ]
                },
                {
                    "line": 524,
                    "params": [
                        {
                            "name": "sx",
                            "description": "",
                            "type": "Integer"
                        },
                        {
                            "name": "sy",
                            "description": "",
                            "type": "Integer"
                        },
                        {
                            "name": "sw",
                            "description": "",
                            "type": "Integer"
                        },
                        {
                            "name": "sh",
                            "description": "",
                            "type": "Integer"
                        },
                        {
                            "name": "dx",
                            "description": "",
                            "type": "Integer"
                        },
                        {
                            "name": "dy",
                            "description": "",
                            "type": "Integer"
                        },
                        {
                            "name": "dw",
                            "description": "",
                            "type": "Integer"
                        },
                        {
                            "name": "dh",
                            "description": "",
                            "type": "Integer"
                        }
                    ]
                }
            ]
        },
        {
            "file": "src/image/p5.Image.js",
            "line": 563,
            "description": "<p>Masks part of an image from displaying by loading another\nimage and using it&#39;s alpha channel as an alpha channel for\nthis image.</p>\n",
            "itemtype": "method",
            "name": "mask",
            "params": [
                {
                    "name": "srcImage",
                    "description": "<p>source image</p>\n",
                    "type": "p5.Image"
                }
            ],
            "example": [
                "\n<div><code>\nvar photo, maskImage;\nfunction preload() {\n  photo = loadImage('assets/rockies.jpg');\n  maskImage = loadImage('assets/mask2.png');\n}\n\nfunction setup() {\n  createCanvas(100, 100);\n  photo.mask(maskImage);\n  image(photo, 0, 0);\n}\n</code></div>"
            ],
            "alt": "image of rocky mountains with white at right\n\n\nhttp://blogs.adobe.com/webplatform/2013/01/28/blending-features-in-canvas/",
            "class": "p5.Image",
            "module": "Image",
            "submodule": "Image"
        },
        {
            "file": "src/image/p5.Image.js",
            "line": 626,
            "description": "<p>Applies an image filter to a p5.Image</p>\n",
            "itemtype": "method",
            "name": "filter",
            "params": [
                {
                    "name": "filterType",
                    "description": "<p>either THRESHOLD, GRAY, OPAQUE, INVERT,\n                               POSTERIZE, BLUR, ERODE, DILATE or BLUR.\n                               See Filters.js for docs on\n                               each available filter</p>\n",
                    "type": "Constant"
                },
                {
                    "name": "filterParam",
                    "description": "<p>an optional parameter unique\n                               to each filter, see above</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "example": [
                "\n<div><code>\nvar photo1;\nvar photo2;\n\nfunction preload() {\n  photo1 = loadImage('assets/rockies.jpg');\n  photo2 = loadImage('assets/rockies.jpg');\n}\n\nfunction setup() {\n  photo2.filter('gray');\n  image(photo1, 0, 0);\n  image(photo2, width / 2, 0);\n}\n</code></div>"
            ],
            "alt": "2 images of rocky mountains left one in color, right in black and white",
            "class": "p5.Image",
            "module": "Image",
            "submodule": "Image"
        },
        {
            "file": "src/image/p5.Image.js",
            "line": 662,
            "description": "<p>Copies a region of pixels from one image to another, using a specified\nblend mode to do the operation.</p>\n",
            "itemtype": "method",
            "name": "blend",
            "example": [
                "\n<div><code>\nvar mountains;\nvar bricks;\n\nfunction preload() {\n  mountains = loadImage('assets/rockies.jpg');\n  bricks = loadImage('assets/bricks_third.jpg');\n}\n\nfunction setup() {\n  mountains.blend(bricks, 0, 0, 33, 100, 67, 0, 33, 100, ADD);\n  image(mountains, 0, 0);\n  image(bricks, 0, 0);\n}\n</code></div>\n<div><code>\nvar mountains;\nvar bricks;\n\nfunction preload() {\n  mountains = loadImage('assets/rockies.jpg');\n  bricks = loadImage('assets/bricks_third.jpg');\n}\n\nfunction setup() {\n  mountains.blend(bricks, 0, 0, 33, 100, 67, 0, 33, 100, DARKEST);\n  image(mountains, 0, 0);\n  image(bricks, 0, 0);\n}\n</code></div>\n<div><code>\nvar mountains;\nvar bricks;\n\nfunction preload() {\n  mountains = loadImage('assets/rockies.jpg');\n  bricks = loadImage('assets/bricks_third.jpg');\n}\n\nfunction setup() {\n  mountains.blend(bricks, 0, 0, 33, 100, 67, 0, 33, 100, LIGHTEST);\n  image(mountains, 0, 0);\n  image(bricks, 0, 0);\n}\n</code></div>"
            ],
            "alt": "image of rocky mountains. Brick images on left and right. Right overexposed\nimage of rockies. Brickwall images on left and right. Right mortar transparent\nimage of rockies. Brickwall images on left and right. Right translucent",
            "class": "p5.Image",
            "module": "Image",
            "submodule": "Image",
            "overloads": [
                {
                    "line": 662,
                    "params": [
                        {
                            "name": "srcImage",
                            "description": "<p>source image</p>\n",
                            "type": "p5.Image"
                        },
                        {
                            "name": "sx",
                            "description": "<p>X coordinate of the source&#39;s upper left corner</p>\n",
                            "type": "Integer"
                        },
                        {
                            "name": "sy",
                            "description": "<p>Y coordinate of the source&#39;s upper left corner</p>\n",
                            "type": "Integer"
                        },
                        {
                            "name": "sw",
                            "description": "<p>source image width</p>\n",
                            "type": "Integer"
                        },
                        {
                            "name": "sh",
                            "description": "<p>source image height</p>\n",
                            "type": "Integer"
                        },
                        {
                            "name": "dx",
                            "description": "<p>X coordinate of the destination&#39;s upper left corner</p>\n",
                            "type": "Integer"
                        },
                        {
                            "name": "dy",
                            "description": "<p>Y coordinate of the destination&#39;s upper left corner</p>\n",
                            "type": "Integer"
                        },
                        {
                            "name": "dw",
                            "description": "<p>destination image width</p>\n",
                            "type": "Integer"
                        },
                        {
                            "name": "dh",
                            "description": "<p>destination image height</p>\n",
                            "type": "Integer"
                        },
                        {
                            "name": "blendMode",
                            "description": "<p>the blend mode. either\n    BLEND, DARKEST, LIGHTEST, DIFFERENCE,\n    MULTIPLY, EXCLUSION, SCREEN, REPLACE, OVERLAY, HARD_LIGHT,\n    SOFT_LIGHT, DODGE, BURN, ADD or NORMAL.</p>\n<p>Available blend modes are: normal | multiply | screen | overlay |\n           darken | lighten | color-dodge | color-burn | hard-light |\n           soft-light | difference | exclusion | hue | saturation |\n           color | luminosity</p>\n<p><a href=\"http://blogs.adobe.com/webplatform/2013/01/28/blending-features-in-canvas/\">http://blogs.adobe.com/webplatform/2013/01/28/blending-features-in-canvas/</a></p>\n",
                            "type": "Constant"
                        }
                    ]
                },
                {
                    "line": 741,
                    "params": [
                        {
                            "name": "sx",
                            "description": "",
                            "type": "Integer"
                        },
                        {
                            "name": "sy",
                            "description": "",
                            "type": "Integer"
                        },
                        {
                            "name": "sw",
                            "description": "",
                            "type": "Integer"
                        },
                        {
                            "name": "sh",
                            "description": "",
                            "type": "Integer"
                        },
                        {
                            "name": "dx",
                            "description": "",
                            "type": "Integer"
                        },
                        {
                            "name": "dy",
                            "description": "",
                            "type": "Integer"
                        },
                        {
                            "name": "dw",
                            "description": "",
                            "type": "Integer"
                        },
                        {
                            "name": "dh",
                            "description": "",
                            "type": "Integer"
                        },
                        {
                            "name": "blendMode",
                            "description": "",
                            "type": "Constant"
                        }
                    ]
                }
            ]
        },
        {
            "file": "src/image/p5.Image.js",
            "line": 784,
            "description": "<p>Saves the image to a file and force the browser to download it.\nAccepts two strings for filename and file extension\nSupports png (default) and jpg.</p>\n",
            "itemtype": "method",
            "name": "save",
            "params": [
                {
                    "name": "filename",
                    "description": "<p>give your file a name</p>\n",
                    "type": "String"
                },
                {
                    "name": "extension",
                    "description": "<p>&#39;png&#39; or &#39;jpg&#39;</p>\n",
                    "type": "String"
                }
            ],
            "example": [
                "\n<div><code>\nvar photo;\n\nfunction preload() {\n  photo = loadImage('assets/rockies.jpg');\n}\n\nfunction draw() {\n  image(photo, 0, 0);\n}\n\nfunction keyTyped() {\n  if (key === 's') {\n    photo.save('photo', 'png');\n  }\n}\n</code></div>"
            ],
            "alt": "image of rocky mountains.",
            "class": "p5.Image",
            "module": "Image",
            "submodule": "Image"
        },
        {
            "file": "src/image/pixels.js",
            "line": 14,
            "description": "<p><a href='https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference\n/Global_Objects/Uint8ClampedArray' target='_blank'>Uint8ClampedArray</a>\ncontaining the values for all the pixels in the display window.\nThese values are numbers. This array is the size (include an appropriate\nfactor for pixelDensity) of the display window x4,\nrepresenting the R, G, B, A values in order for each pixel, moving from\nleft to right across each row, then down each column. Retina and other\nhigh density displays will have more pixels[] (by a factor of\npixelDensity^2).\nFor example, if the image is 100x100 pixels, there will be 40,000. On a\nretina display, there will be 160,000.\n<br><br>\nThe first four values (indices 0-3) in the array will be the R, G, B, A\nvalues of the pixel at (0, 0). The second four values (indices 4-7) will\ncontain the R, G, B, A values of the pixel at (1, 0). More generally, to\nset values for a pixel at (x, y):</p>\n<pre><code class=\"lang-javascript\">var d = pixelDensity();\nfor (var i = 0; i &lt; d; i++) {\n  for (var j = 0; j &lt; d; j++) {\n    // loop over\n    idx = 4 * ((y * d + j) * width * d + (x * d + i));\n    pixels[idx] = r;\n    pixels[idx+1] = g;\n    pixels[idx+2] = b;\n    pixels[idx+3] = a;\n  }\n}\n</code></pre>\n<p>While the above method is complex, it is flexible enough to work with\nany pixelDensity. Note that set() will automatically take care of\nsetting all the appropriate values in pixels[] for a given (x, y) at\nany pixelDensity, but the performance may not be as fast when lots of\nmodifications are made to the pixel array.\n<br><br>\nBefore accessing this array, the data must loaded with the loadPixels()\nfunction. After the array data has been modified, the updatePixels()\nfunction must be run to update the changes.\n<br><br>\nNote that this is not a standard javascript array.  This means that\nstandard javascript functions such as <code>slice()</code> or\n<code>arrayCopy()</code> do not\nwork.</p>",
            "itemtype": "property",
            "name": "pixels",
            "type": "Number[]",
            "example": [
                "\n<div>\n<code>\nvar pink = color(255, 102, 204);\nloadPixels();\nvar d = pixelDensity();\nvar halfImage = 4 * (width * d) * (height / 2 * d);\nfor (var i = 0; i < halfImage; i += 4) {\n  pixels[i] = red(pink);\n  pixels[i + 1] = green(pink);\n  pixels[i + 2] = blue(pink);\n  pixels[i + 3] = alpha(pink);\n}\nupdatePixels();\n</code>\n</div>"
            ],
            "alt": "top half of canvas pink, bottom grey",
            "class": "p5",
            "module": "Image",
            "submodule": "Pixels"
        },
        {
            "file": "src/image/pixels.js",
            "line": 83,
            "description": "<p>Copies a region of pixels from one image to another, using a specified\nblend mode to do the operation.</p>\n",
            "itemtype": "method",
            "name": "blend",
            "example": [
                "\n<div><code>\nvar img0;\nvar img1;\n\nfunction preload() {\n  img0 = loadImage('assets/rockies.jpg');\n  img1 = loadImage('assets/bricks_third.jpg');\n}\n\nfunction setup() {\n  background(img0);\n  image(img1, 0, 0);\n  blend(img1, 0, 0, 33, 100, 67, 0, 33, 100, LIGHTEST);\n}\n</code></div>\n<div><code>\nvar img0;\nvar img1;\n\nfunction preload() {\n  img0 = loadImage('assets/rockies.jpg');\n  img1 = loadImage('assets/bricks_third.jpg');\n}\n\nfunction setup() {\n  background(img0);\n  image(img1, 0, 0);\n  blend(img1, 0, 0, 33, 100, 67, 0, 33, 100, DARKEST);\n}\n</code></div>\n<div><code>\nvar img0;\nvar img1;\n\nfunction preload() {\n  img0 = loadImage('assets/rockies.jpg');\n  img1 = loadImage('assets/bricks_third.jpg');\n}\n\nfunction setup() {\n  background(img0);\n  image(img1, 0, 0);\n  blend(img1, 0, 0, 33, 100, 67, 0, 33, 100, ADD);\n}\n</code></div>"
            ],
            "alt": "image of rocky mountains. Brick images on left and right. Right overexposed\nimage of rockies. Brickwall images on left and right. Right mortar transparent\nimage of rockies. Brickwall images on left and right. Right translucent",
            "class": "p5",
            "module": "Image",
            "submodule": "Pixels",
            "overloads": [
                {
                    "line": 83,
                    "params": [
                        {
                            "name": "srcImage",
                            "description": "<p>source image</p>\n",
                            "type": "p5.Image"
                        },
                        {
                            "name": "sx",
                            "description": "<p>X coordinate of the source&#39;s upper left corner</p>\n",
                            "type": "Integer"
                        },
                        {
                            "name": "sy",
                            "description": "<p>Y coordinate of the source&#39;s upper left corner</p>\n",
                            "type": "Integer"
                        },
                        {
                            "name": "sw",
                            "description": "<p>source image width</p>\n",
                            "type": "Integer"
                        },
                        {
                            "name": "sh",
                            "description": "<p>source image height</p>\n",
                            "type": "Integer"
                        },
                        {
                            "name": "dx",
                            "description": "<p>X coordinate of the destination&#39;s upper left corner</p>\n",
                            "type": "Integer"
                        },
                        {
                            "name": "dy",
                            "description": "<p>Y coordinate of the destination&#39;s upper left corner</p>\n",
                            "type": "Integer"
                        },
                        {
                            "name": "dw",
                            "description": "<p>destination image width</p>\n",
                            "type": "Integer"
                        },
                        {
                            "name": "dh",
                            "description": "<p>destination image height</p>\n",
                            "type": "Integer"
                        },
                        {
                            "name": "blendMode",
                            "description": "<p>the blend mode. either\n    BLEND, DARKEST, LIGHTEST, DIFFERENCE,\n    MULTIPLY, EXCLUSION, SCREEN, REPLACE, OVERLAY, HARD_LIGHT,\n    SOFT_LIGHT, DODGE, BURN, ADD or NORMAL.</p>\n",
                            "type": "Constant"
                        }
                    ]
                },
                {
                    "line": 156,
                    "params": [
                        {
                            "name": "sx",
                            "description": "",
                            "type": "Integer"
                        },
                        {
                            "name": "sy",
                            "description": "",
                            "type": "Integer"
                        },
                        {
                            "name": "sw",
                            "description": "",
                            "type": "Integer"
                        },
                        {
                            "name": "sh",
                            "description": "",
                            "type": "Integer"
                        },
                        {
                            "name": "dx",
                            "description": "",
                            "type": "Integer"
                        },
                        {
                            "name": "dy",
                            "description": "",
                            "type": "Integer"
                        },
                        {
                            "name": "dw",
                            "description": "",
                            "type": "Integer"
                        },
                        {
                            "name": "dh",
                            "description": "",
                            "type": "Integer"
                        },
                        {
                            "name": "blendMode",
                            "description": "",
                            "type": "Constant"
                        }
                    ]
                }
            ]
        },
        {
            "file": "src/image/pixels.js",
            "line": 176,
            "description": "<p>Copies a region of the canvas to another region of the canvas\nand copies a region of pixels from an image used as the srcImg parameter\ninto the canvas srcImage is specified this is used as the source. If\nthe source and destination regions aren&#39;t the same size, it will\nautomatically resize source pixels to fit the specified\ntarget region.</p>\n",
            "itemtype": "method",
            "name": "copy",
            "example": [
                "\n<div><code>\nvar img;\n\nfunction preload() {\n  img = loadImage('assets/rockies.jpg');\n}\n\nfunction setup() {\n  background(img);\n  copy(img, 7, 22, 10, 10, 35, 25, 50, 50);\n  stroke(255);\n  noFill();\n  // Rectangle shows area being copied\n  rect(7, 22, 10, 10);\n}\n</code></div>"
            ],
            "alt": "image of rocky mountains. Brick images on left and right. Right overexposed\nimage of rockies. Brickwall images on left and right. Right mortar transparent\nimage of rockies. Brickwall images on left and right. Right translucent",
            "class": "p5",
            "module": "Image",
            "submodule": "Pixels",
            "overloads": [
                {
                    "line": 176,
                    "params": [
                        {
                            "name": "srcImage",
                            "description": "<p>source image</p>\n",
                            "type": "p5.Image|p5.Element"
                        },
                        {
                            "name": "sx",
                            "description": "<p>X coordinate of the source&#39;s upper left corner</p>\n",
                            "type": "Integer"
                        },
                        {
                            "name": "sy",
                            "description": "<p>Y coordinate of the source&#39;s upper left corner</p>\n",
                            "type": "Integer"
                        },
                        {
                            "name": "sw",
                            "description": "<p>source image width</p>\n",
                            "type": "Integer"
                        },
                        {
                            "name": "sh",
                            "description": "<p>source image height</p>\n",
                            "type": "Integer"
                        },
                        {
                            "name": "dx",
                            "description": "<p>X coordinate of the destination&#39;s upper left corner</p>\n",
                            "type": "Integer"
                        },
                        {
                            "name": "dy",
                            "description": "<p>Y coordinate of the destination&#39;s upper left corner</p>\n",
                            "type": "Integer"
                        },
                        {
                            "name": "dw",
                            "description": "<p>destination image width</p>\n",
                            "type": "Integer"
                        },
                        {
                            "name": "dh",
                            "description": "<p>destination image height</p>\n",
                            "type": "Integer"
                        }
                    ]
                },
                {
                    "line": 219,
                    "params": [
                        {
                            "name": "sx",
                            "description": "",
                            "type": "Integer"
                        },
                        {
                            "name": "sy",
                            "description": "",
                            "type": "Integer"
                        },
                        {
                            "name": "sw",
                            "description": "",
                            "type": "Integer"
                        },
                        {
                            "name": "sh",
                            "description": "",
                            "type": "Integer"
                        },
                        {
                            "name": "dx",
                            "description": "",
                            "type": "Integer"
                        },
                        {
                            "name": "dy",
                            "description": "",
                            "type": "Integer"
                        },
                        {
                            "name": "dw",
                            "description": "",
                            "type": "Integer"
                        },
                        {
                            "name": "dh",
                            "description": "",
                            "type": "Integer"
                        }
                    ]
                }
            ]
        },
        {
            "file": "src/image/pixels.js",
            "line": 235,
            "description": "<p>Applies a filter to the canvas.\n<br><br></p>\n<p>The presets options are:\n<br><br></p>\n<p>THRESHOLD\nConverts the image to black and white pixels depending if they are above or\nbelow the threshold defined by the level parameter. The parameter must be\nbetween 0.0 (black) and 1.0 (white). If no level is specified, 0.5 is used.\n<br><br></p>\n<p>GRAY\nConverts any colors in the image to grayscale equivalents. No parameter\nis used.\n<br><br></p>\n<p>OPAQUE\nSets the alpha channel to entirely opaque. No parameter is used.\n<br><br></p>\n<p>INVERT\nSets each pixel to its inverse value. No parameter is used.\n<br><br></p>\n<p>POSTERIZE\nLimits each channel of the image to the number of colors specified as the\nparameter. The parameter can be set to values between 2 and 255, but\nresults are most noticeable in the lower ranges.\n<br><br></p>\n<p>BLUR\nExecutes a Gaussian blur with the level parameter specifying the extent\nof the blurring. If no parameter is used, the blur is equivalent to\nGaussian blur of radius 1. Larger values increase the blur.\n<br><br></p>\n<p>ERODE\nReduces the light areas. No parameter is used.\n<br><br></p>\n<p>DILATE\nIncreases the light areas. No parameter is used.</p>\n",
            "itemtype": "method",
            "name": "filter",
            "params": [
                {
                    "name": "filterType",
                    "description": "<p>either THRESHOLD, GRAY, OPAQUE, INVERT,\n                               POSTERIZE, BLUR, ERODE, DILATE or BLUR.\n                               See Filters.js for docs on\n                               each available filter</p>\n",
                    "type": "Constant"
                },
                {
                    "name": "filterParam",
                    "description": "<p>an optional parameter unique\n                               to each filter, see above</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "example": [
                "\n<div>\n<code>\nvar img;\nfunction preload() {\n  img = loadImage('assets/bricks.jpg');\n}\nfunction setup() {\n  image(img, 0, 0);\n  filter(THRESHOLD);\n}\n</code>\n</div>\n\n<div>\n<code>\nvar img;\nfunction preload() {\n  img = loadImage('assets/bricks.jpg');\n}\nfunction setup() {\n  image(img, 0, 0);\n  filter(GRAY);\n}\n</code>\n</div>\n\n<div>\n<code>\nvar img;\nfunction preload() {\n  img = loadImage('assets/bricks.jpg');\n}\nfunction setup() {\n  image(img, 0, 0);\n  filter(OPAQUE);\n}\n</code>\n</div>\n\n<div>\n<code>\nvar img;\nfunction preload() {\n  img = loadImage('assets/bricks.jpg');\n}\nfunction setup() {\n  image(img, 0, 0);\n  filter(INVERT);\n}\n</code>\n</div>\n\n<div>\n<code>\nvar img;\nfunction preload() {\n  img = loadImage('assets/bricks.jpg');\n}\nfunction setup() {\n  image(img, 0, 0);\n  filter(POSTERIZE, 3);\n}\n</code>\n</div>\n\n<div>\n<code>\nvar img;\nfunction preload() {\n  img = loadImage('assets/bricks.jpg');\n}\nfunction setup() {\n  image(img, 0, 0);\n  filter(DILATE);\n}\n</code>\n</div>\n\n<div>\n<code>\nvar img;\nfunction preload() {\n  img = loadImage('assets/bricks.jpg');\n}\nfunction setup() {\n  image(img, 0, 0);\n  filter(BLUR, 3);\n}\n</code>\n</div>\n\n<div>\n<code>\nvar img;\nfunction preload() {\n  img = loadImage('assets/bricks.jpg');\n}\nfunction setup() {\n  image(img, 0, 0);\n  filter(ERODE);\n}\n</code>\n</div>"
            ],
            "alt": "black and white image of a brick wall.\ngreyscale image of a brickwall\nimage of a brickwall\njade colored image of a brickwall\nred and pink image of a brickwall\nimage of a brickwall\nblurry image of a brickwall\nimage of a brickwall\nimage of a brickwall with less detail",
            "class": "p5",
            "module": "Image",
            "submodule": "Pixels"
        },
        {
            "file": "src/image/pixels.js",
            "line": 413,
            "description": "<p>Returns an array of [R,G,B,A] values for any pixel or grabs a section of\nan image. If no parameters are specified, the entire image is returned.\nUse the x and y parameters to get the value of one pixel. Get a section of\nthe display window by specifying additional w and h parameters. When\ngetting an image, the x and y parameters define the coordinates for the\nupper-left corner of the image, regardless of the current imageMode().\n<br><br>\nIf the pixel requested is outside of the image window, [0,0,0,255] is\nreturned. To get the numbers scaled according to the current color ranges\nand taking into account colorMode, use getColor instead of get.\n<br><br>\nGetting the color of a single pixel with get(x, y) is easy, but not as fast\nas grabbing the data directly from pixels[]. The equivalent statement to\nget(x, y) using pixels[] with pixel density d is\n<code>\nvar x, y, d; // set these to the coordinates\nvar off = (y <em> width + x) </em> d * 4;\nvar components = [\n  pixels[off],\n  pixels[off + 1],\n  pixels[off + 2],\n  pixels[off + 3]\n];\nprint(components);\n</code>\n<br><br>\nSee the reference for pixels[] for more information.</p>\n",
            "itemtype": "method",
            "name": "get",
            "params": [
                {
                    "name": "x",
                    "description": "<p>x-coordinate of the pixel</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "y",
                    "description": "<p>y-coordinate of the pixel</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "w",
                    "description": "<p>width</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "h",
                    "description": "<p>height</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "return": {
                "description": "values of pixel at x,y in array format\n                             [R, G, B, A] or p5.Image",
                "type": "Number[]|p5.Image"
            },
            "example": [
                "\n<div>\n<code>\nvar img;\nfunction preload() {\n  img = loadImage('assets/rockies.jpg');\n}\nfunction setup() {\n  image(img, 0, 0);\n  var c = get();\n  image(c, width / 2, 0);\n}\n</code>\n</div>\n\n<div>\n<code>\nvar img;\nfunction preload() {\n  img = loadImage('assets/rockies.jpg');\n}\nfunction setup() {\n  image(img, 0, 0);\n  var c = get(50, 90);\n  fill(c);\n  noStroke();\n  rect(25, 25, 50, 50);\n}\n</code>\n</div>"
            ],
            "alt": "2 images of the rocky mountains, side-by-side\nImage of the rocky mountains with 50x50 green rect in center of canvas",
            "class": "p5",
            "module": "Image",
            "submodule": "Pixels"
        },
        {
            "file": "src/image/pixels.js",
            "line": 489,
            "description": "<p>Loads the pixel data for the display window into the pixels[] array. This\nfunction must always be called before reading from or writing to pixels[].\nNote that only changes made with set() or direct manipulation of pixels[]\nwill occur.</p>\n",
            "itemtype": "method",
            "name": "loadPixels",
            "example": [
                "\n<div>\n<code>\nvar img;\nfunction preload() {\n  img = loadImage('assets/rockies.jpg');\n}\n\nfunction setup() {\n  image(img, 0, 0);\n  var d = pixelDensity();\n  var halfImage = 4 * (img.width * d) * (img.height * d / 2);\n  loadPixels();\n  for (var i = 0; i < halfImage; i++) {\n    pixels[i + halfImage] = pixels[i];\n  }\n  updatePixels();\n}\n</code>\n</div>"
            ],
            "alt": "two images of the rocky mountains. one on top, one on bottom of canvas.",
            "class": "p5",
            "module": "Image",
            "submodule": "Pixels"
        },
        {
            "file": "src/image/pixels.js",
            "line": 525,
            "description": "<p>Changes the color of any pixel, or writes an image directly to the\ndisplay window.</p>\n<p>The x and y parameters specify the pixel to change and the c parameter\nspecifies the color value. This can be a p5.Color object, or [R, G, B, A]\npixel array. It can also be a single grayscale value.\nWhen setting an image, the x and y parameters define the coordinates for\nthe upper-left corner of the image, regardless of the current imageMode().\n</p>\n<p>\nAfter using set(), you must call updatePixels() for your changes to appear.\nThis should be called once all pixels have been set, and must be called before\ncalling .get() or drawing the image.\n</p>\n<p>Setting the color of a single pixel with set(x, y) is easy, but not as\nfast as putting the data directly into pixels[]. Setting the pixels[]\nvalues directly may be complicated when working with a retina display,\nbut will perform better when lots of pixels need to be set directly on\nevery loop.</p>\n<p>See the reference for pixels[] for more information.</p>",
            "itemtype": "method",
            "name": "set",
            "params": [
                {
                    "name": "x",
                    "description": "<p>x-coordinate of the pixel</p>\n",
                    "type": "Number"
                },
                {
                    "name": "y",
                    "description": "<p>y-coordinate of the pixel</p>\n",
                    "type": "Number"
                },
                {
                    "name": "c",
                    "description": "<p>insert a grayscale value | a pixel array |\n                               a p5.Color object | a p5.Image to copy</p>\n",
                    "type": "Number|Number[]|Object"
                }
            ],
            "example": [
                "\n<div>\n<code>\nvar black = color(0);\nset(30, 20, black);\nset(85, 20, black);\nset(85, 75, black);\nset(30, 75, black);\nupdatePixels();\n</code>\n</div>\n\n<div>\n<code>\nfor (var i = 30; i < width - 15; i++) {\n  for (var j = 20; j < height - 25; j++) {\n    var c = color(204 - j, 153 - i, 0);\n    set(i, j, c);\n  }\n}\nupdatePixels();\n</code>\n</div>\n\n<div>\n<code>\nvar img;\nfunction preload() {\n  img = loadImage('assets/rockies.jpg');\n}\n\nfunction setup() {\n  set(0, 0, img);\n  updatePixels();\n  line(0, 0, width, height);\n  line(0, height, width, 0);\n}\n</code>\n</div>"
            ],
            "alt": "4 black points in the shape of a square middle-right of canvas.\nsquare with orangey-brown gradient lightening at bottom right.\nimage of the rocky mountains. with lines like an 'x' through the center.",
            "class": "p5",
            "module": "Image",
            "submodule": "Pixels"
        },
        {
            "file": "src/image/pixels.js",
            "line": 599,
            "description": "<p>Updates the display window with the data in the pixels[] array.\nUse in conjunction with loadPixels(). If you&#39;re only reading pixels from\nthe array, there&#39;s no need to call updatePixels() — updating is only\nnecessary to apply changes. updatePixels() should be called anytime the\npixels array is manipulated or set() is called, and only changes made with\nset() or direct changes to pixels[] will occur.</p>\n",
            "itemtype": "method",
            "name": "updatePixels",
            "params": [
                {
                    "name": "x",
                    "description": "<p>x-coordinate of the upper-left corner of region\n                        to update</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "y",
                    "description": "<p>y-coordinate of the upper-left corner of region\n                        to update</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "w",
                    "description": "<p>width of region to update</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "h",
                    "description": "<p>height of region to update</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "example": [
                "\n<div>\n<code>\nvar img;\nfunction preload() {\n  img = loadImage('assets/rockies.jpg');\n}\n\nfunction setup() {\n  image(img, 0, 0);\n  var d = pixelDensity();\n  var halfImage = 4 * (img.width * d) * (img.height * d / 2);\n  loadPixels();\n  for (var i = 0; i < halfImage; i++) {\n    pixels[i + halfImage] = pixels[i];\n  }\n  updatePixels();\n}\n</code>\n</div>"
            ],
            "alt": "two images of the rocky mountains. one on top, one on bottom of canvas.",
            "class": "p5",
            "module": "Image",
            "submodule": "Pixels"
        },
        {
            "file": "src/io/files.js",
            "line": 19,
            "description": "<p>Loads a JSON file from a file or a URL, and returns an Object.\nNote that even if the JSON file contains an Array, an Object will be\nreturned with index numbers as keys.</p>\n<p>This method is asynchronous, meaning it may not finish before the next\nline in your sketch is executed. JSONP is supported via a polyfill and you\ncan pass in as the second argument an object with definitions of the json\ncallback following the syntax specified <a href=\"https://github.com/camsong/\nfetch-jsonp\">here</a>.</p>\n",
            "itemtype": "method",
            "name": "loadJSON",
            "params": [
                {
                    "name": "path",
                    "description": "<p>name of the file or url to load</p>\n",
                    "type": "String"
                },
                {
                    "name": "jsonpOptions",
                    "description": "<p>options object for jsonp related settings</p>\n",
                    "type": "Object",
                    "optional": true
                },
                {
                    "name": "datatype",
                    "description": "<p>&quot;json&quot; or &quot;jsonp&quot;</p>\n",
                    "type": "String",
                    "optional": true
                },
                {
                    "name": "callback",
                    "description": "<p>function to be executed after\n                                   loadJSON() completes, data is passed\n                                   in as first argument</p>\n",
                    "type": "Function",
                    "optional": true
                },
                {
                    "name": "errorCallback",
                    "description": "<p>function to be executed if\n                                   there is an error, response is passed\n                                   in as first argument</p>\n",
                    "type": "Function",
                    "optional": true
                }
            ],
            "return": {
                "description": "JSON data",
                "type": "Object|Array"
            },
            "example": [
                "\n\n<p>Calling loadJSON() inside preload() guarantees to complete the\noperation before setup() and draw() are called.</p>\n\n<div><code>\n// Examples use USGS Earthquake API:\n//   https://earthquake.usgs.gov/fdsnws/event/1/#methods\nvar earthquakes;\nfunction preload() {\n  // Get the most recent earthquake in the database\n  var url =\n   'https://earthquake.usgs.gov/earthquakes/feed/v1.0/' +\n    'summary/all_day.geojson';\n  earthquakes = loadJSON(url);\n}\n\nfunction setup() {\n  noLoop();\n}\n\nfunction draw() {\n  background(200);\n  // Get the magnitude and name of the earthquake out of the loaded JSON\n  var earthquakeMag = earthquakes.features[0].properties.mag;\n  var earthquakeName = earthquakes.features[0].properties.place;\n  ellipse(width / 2, height / 2, earthquakeMag * 10, earthquakeMag * 10);\n  textAlign(CENTER);\n  text(earthquakeName, 0, height - 30, width, 30);\n}\n</code></div>\n\n\n<p>Outside of preload(), you may supply a callback function to handle the\nobject:</p>\n<div><code>\nfunction setup() {\n  noLoop();\n  var url =\n   'https://earthquake.usgs.gov/earthquakes/feed/v1.0/' +\n    'summary/all_day.geojson';\n  loadJSON(url, drawEarthquake);\n}\n\nfunction draw() {\n  background(200);\n}\n\nfunction drawEarthquake(earthquakes) {\n  // Get the magnitude and name of the earthquake out of the loaded JSON\n  var earthquakeMag = earthquakes.features[0].properties.mag;\n  var earthquakeName = earthquakes.features[0].properties.place;\n  ellipse(width / 2, height / 2, earthquakeMag * 10, earthquakeMag * 10);\n  textAlign(CENTER);\n  text(earthquakeName, 0, height - 30, width, 30);\n}\n</code></div>"
            ],
            "alt": "50x50 ellipse that changes from black to white depending on the current humidity\n50x50 ellipse that changes from black to white depending on the current humidity",
            "class": "p5",
            "module": "IO",
            "submodule": "Input"
        },
        {
            "file": "src/io/files.js",
            "line": 154,
            "description": "<p>Reads the contents of a file and creates a String array of its individual\nlines. If the name of the file is used as the parameter, as in the above\nexample, the file must be located in the sketch directory/folder.\n<br><br>\nAlternatively, the file maybe be loaded from anywhere on the local\ncomputer using an absolute path (something that starts with / on Unix and\nLinux, or a drive letter on Windows), or the filename parameter can be a\nURL for a file found on a network.\n<br><br>\nThis method is asynchronous, meaning it may not finish before the next\nline in your sketch is executed.</p>\n",
            "itemtype": "method",
            "name": "loadStrings",
            "params": [
                {
                    "name": "filename",
                    "description": "<p>name of the file or url to load</p>\n",
                    "type": "String"
                },
                {
                    "name": "callback",
                    "description": "<p>function to be executed after loadStrings()\n                              completes, Array is passed in as first\n                              argument</p>\n",
                    "type": "Function",
                    "optional": true
                },
                {
                    "name": "errorCallback",
                    "description": "<p>function to be executed if\n                              there is an error, response is passed\n                              in as first argument</p>\n",
                    "type": "Function",
                    "optional": true
                }
            ],
            "return": {
                "description": "Array of Strings",
                "type": "String[]"
            },
            "example": [
                "\n\n<p>Calling loadStrings() inside preload() guarantees to complete the\noperation before setup() and draw() are called.</p>\n\n<div><code>\nvar result;\nfunction preload() {\n  result = loadStrings('assets/test.txt');\n}\n\nfunction setup() {\n  background(200);\n  var ind = floor(random(result.length));\n  text(result[ind], 10, 10, 80, 80);\n}\n</code></div>\n\n<p>Outside of preload(), you may supply a callback function to handle the\nobject:</p>\n\n<div><code>\nfunction setup() {\n  loadStrings('assets/test.txt', pickString);\n}\n\nfunction pickString(result) {\n  background(200);\n  var ind = floor(random(result.length));\n  text(result[ind], 10, 10, 80, 80);\n}\n</code></div>"
            ],
            "alt": "randomly generated text from a file, for example \"i smell like butter\"\nrandomly generated text from a file, for example \"i have three feet\"",
            "class": "p5",
            "module": "IO",
            "submodule": "Input"
        },
        {
            "file": "src/io/files.js",
            "line": 253,
            "description": "<p>Reads the contents of a file or URL and creates a p5.Table object with\nits values. If a file is specified, it must be located in the sketch&#39;s\n&quot;data&quot; folder. The filename parameter can also be a URL to a file found\nonline. By default, the file is assumed to be comma-separated (in CSV\nformat). Table only looks for a header row if the &#39;header&#39; option is\nincluded.</p>\n\n<p>Possible options include:\n<ul>\n<li>csv - parse the table as comma-separated values</li>\n<li>tsv - parse the table as tab-separated values</li>\n<li>header - this table has a header (title) row</li>\n</ul>\n</p>\n\n<p>When passing in multiple options, pass them in as separate parameters,\nseperated by commas. For example:\n<br><br>\n<code>\nloadTable(&#39;my_csv_file.csv&#39;, &#39;csv&#39;, &#39;header&#39;);\n</code>\n</p>\n\n<p> All files loaded and saved use UTF-8 encoding.</p>\n\n<p>This method is asynchronous, meaning it may not finish before the next\nline in your sketch is executed. Calling loadTable() inside preload()\nguarantees to complete the operation before setup() and draw() are called.\n<p>Outside of preload(), you may supply a callback function to handle the\nobject:</p>\n</p>",
            "itemtype": "method",
            "name": "loadTable",
            "return": {
                "description": "Table object containing data",
                "type": "Object"
            },
            "example": [
                "\n<div class=\"norender\">\n<code>\n// Given the following CSV file called \"mammals.csv\"\n// located in the project's \"assets\" folder:\n//\n// id,species,name\n// 0,Capra hircus,Goat\n// 1,Panthera pardus,Leopard\n// 2,Equus zebra,Zebra\n\nvar table;\n\nfunction preload() {\n  //my table is comma separated value \"csv\"\n  //and has a header specifying the columns labels\n  table = loadTable('assets/mammals.csv', 'csv', 'header');\n  //the file can be remote\n  //table = loadTable(\"http://p5js.org/reference/assets/mammals.csv\",\n  //                  \"csv\", \"header\");\n}\n\nfunction setup() {\n  //count the columns\n  print(table.getRowCount() + ' total rows in table');\n  print(table.getColumnCount() + ' total columns in table');\n\n  print(table.getColumn('name'));\n  //[\"Goat\", \"Leopard\", \"Zebra\"]\n\n  //cycle through the table\n  for (var r = 0; r < table.getRowCount(); r++)\n    for (var c = 0; c < table.getColumnCount(); c++) {\n      print(table.getString(r, c));\n    }\n}\n</code>\n</div>"
            ],
            "alt": "randomly generated text from a file, for example \"i smell like butter\"\nrandomly generated text from a file, for example \"i have three feet\"",
            "class": "p5",
            "module": "IO",
            "submodule": "Input",
            "overloads": [
                {
                    "line": 253,
                    "params": [
                        {
                            "name": "filename",
                            "description": "<p>name of the file or URL to load</p>\n",
                            "type": "String"
                        },
                        {
                            "name": "options",
                            "description": "<p>&quot;header&quot; &quot;csv&quot; &quot;tsv&quot;</p>\n",
                            "type": "String"
                        },
                        {
                            "name": "callback",
                            "description": "<p>function to be executed after\n                                    loadTable() completes. On success, the\n                                    Table object is passed in as the\n                                    first argument.</p>\n",
                            "type": "Function",
                            "optional": true
                        },
                        {
                            "name": "errorCallback",
                            "description": "<p>function to be executed if\n                                    there is an error, response is passed\n                                    in as first argument</p>\n",
                            "type": "Function",
                            "optional": true
                        }
                    ],
                    "return": {
                        "description": "Table object containing data",
                        "type": "Object"
                    }
                },
                {
                    "line": 342,
                    "params": [
                        {
                            "name": "filename",
                            "description": "",
                            "type": "String"
                        },
                        {
                            "name": "callback",
                            "description": "",
                            "type": "Function",
                            "optional": true
                        },
                        {
                            "name": "errorCallback",
                            "description": "",
                            "type": "Function",
                            "optional": true
                        }
                    ],
                    "return": {
                        "description": "",
                        "type": "Object"
                    }
                }
            ]
        },
        {
            "file": "src/io/files.js",
            "line": 586,
            "description": "<p>Reads the contents of a file and creates an XML object with its values.\nIf the name of the file is used as the parameter, as in the above example,\nthe file must be located in the sketch directory/folder.</p>\n<p>Alternatively, the file maybe be loaded from anywhere on the local\ncomputer using an absolute path (something that starts with / on Unix and\nLinux, or a drive letter on Windows), or the filename parameter can be a\nURL for a file found on a network.</p>\n<p>This method is asynchronous, meaning it may not finish before the next\nline in your sketch is executed. Calling loadXML() inside preload()\nguarantees to complete the operation before setup() and draw() are called.</p>\n<p>Outside of preload(), you may supply a callback function to handle the\nobject.</p>\n",
            "itemtype": "method",
            "name": "loadXML",
            "params": [
                {
                    "name": "filename",
                    "description": "<p>name of the file or URL to load</p>\n",
                    "type": "String"
                },
                {
                    "name": "callback",
                    "description": "<p>function to be executed after loadXML()\n                              completes, XML object is passed in as\n                              first argument</p>\n",
                    "type": "Function",
                    "optional": true
                },
                {
                    "name": "errorCallback",
                    "description": "<p>function to be executed if\n                              there is an error, response is passed\n                              in as first argument</p>\n",
                    "type": "Function",
                    "optional": true
                }
            ],
            "return": {
                "description": "XML object containing data",
                "type": "Object"
            },
            "example": [
                "\n<div class='norender'><code>\n// The following short XML file called \"mammals.xml\" is parsed\n// in the code below.\n//\n// <?xml version=\"1.0\"?>\n// &lt;mammals&gt;\n//   &lt;animal id=\"0\" species=\"Capra hircus\">Goat&lt;/animal&gt;\n//   &lt;animal id=\"1\" species=\"Panthera pardus\">Leopard&lt;/animal&gt;\n//   &lt;animal id=\"2\" species=\"Equus zebra\">Zebra&lt;/animal&gt;\n// &lt;/mammals&gt;\n\nvar xml;\n\nfunction preload() {\n  xml = loadXML('assets/mammals.xml');\n}\n\nfunction setup() {\n  var children = xml.getChildren('animal');\n\n  for (var i = 0; i < children.length; i++) {\n    var id = children[i].getNum('id');\n    var coloring = children[i].getString('species');\n    var name = children[i].getContent();\n    print(id + ', ' + coloring + ', ' + name);\n  }\n}\n\n// Sketch prints:\n// 0, Capra hircus, Goat\n// 1, Panthera pardus, Leopard\n// 2, Equus zebra, Zebra\n</code></div>"
            ],
            "alt": "no image displayed",
            "class": "p5",
            "module": "IO",
            "submodule": "Input"
        },
        {
            "file": "src/io/files.js",
            "line": 687,
            "description": "<p>Method for executing an HTTP GET request. If data type is not specified,\np5 will try to guess based on the URL, defaulting to text. This is equivalent to\ncalling <code>httpDo(path, &#39;GET&#39;)</code>.</p>\n",
            "itemtype": "method",
            "name": "httpGet",
            "params": [
                {
                    "name": "path",
                    "description": "<p>name of the file or url to load</p>\n",
                    "type": "String"
                },
                {
                    "name": "datatype",
                    "description": "<p>&quot;json&quot;, &quot;jsonp&quot;, &quot;xml&quot;, or &quot;text&quot;</p>\n",
                    "type": "String",
                    "optional": true
                },
                {
                    "name": "data",
                    "description": "<p>param data passed sent with request</p>\n",
                    "type": "Object",
                    "optional": true
                },
                {
                    "name": "callback",
                    "description": "<p>function to be executed after\n                                   httpGet() completes, data is passed in\n                                   as first argument</p>\n",
                    "type": "Function",
                    "optional": true
                },
                {
                    "name": "errorCallback",
                    "description": "<p>function to be executed if\n                                   there is an error, response is passed\n                                   in as first argument</p>\n",
                    "type": "Function",
                    "optional": true
                }
            ],
            "example": [
                "\n<div class='norender'><code>\n// Examples use USGS Earthquake API:\n//   https://earthquake.usgs.gov/fdsnws/event/1/#methods\nvar earthquakes;\nfunction preload() {\n  // Get the most recent earthquake in the database\n  var url =\n   'https://earthquake.usgs.gov/fdsnws/event/1/query?' +\n    'format=geojson&limit=1&orderby=time';\n  httpGet(url, 'jsonp', false, function(response) {\n    // when the HTTP request completes, populate the variable that holds the\n    // earthquake data used in the visualization.\n    earthquakes = response;\n  });\n}\n\nfunction draw() {\n  if (!earthquakes) {\n    // Wait until the earthquake data has loaded before drawing.\n    return;\n  }\n  background(200);\n  // Get the magnitude and name of the earthquake out of the loaded JSON\n  var earthquakeMag = earthquakes.features[0].properties.mag;\n  var earthquakeName = earthquakes.features[0].properties.place;\n  ellipse(width / 2, height / 2, earthquakeMag * 10, earthquakeMag * 10);\n  textAlign(CENTER);\n  text(earthquakeName, 0, height - 30, width, 30);\n  noLoop();\n}\n</code></div>"
            ],
            "class": "p5",
            "module": "IO",
            "submodule": "Input"
        },
        {
            "file": "src/io/files.js",
            "line": 741,
            "description": "<p>Method for executing an HTTP POST request. If data type is not specified,\np5 will try to guess based on the URL, defaulting to text. This is equivalent to\ncalling <code>httpDo(path, &#39;POST&#39;)</code>.</p>\n",
            "itemtype": "method",
            "name": "httpPost",
            "params": [
                {
                    "name": "path",
                    "description": "<p>name of the file or url to load</p>\n",
                    "type": "String"
                },
                {
                    "name": "datatype",
                    "description": "<p>&quot;json&quot;, &quot;jsonp&quot;, &quot;xml&quot;, or &quot;text&quot;.\n                                   If omitted, httpPost() will guess.</p>\n",
                    "type": "String",
                    "optional": true
                },
                {
                    "name": "data",
                    "description": "<p>param data passed sent with request</p>\n",
                    "type": "Object",
                    "optional": true
                },
                {
                    "name": "callback",
                    "description": "<p>function to be executed after\n                                   httpPost() completes, data is passed in\n                                   as first argument</p>\n",
                    "type": "Function",
                    "optional": true
                },
                {
                    "name": "errorCallback",
                    "description": "<p>function to be executed if\n                                   there is an error, response is passed\n                                   in as first argument</p>\n",
                    "type": "Function",
                    "optional": true
                }
            ],
            "example": [
                "\n<div>\n<code>\n// Examples use jsonplaceholder.typicode.com for a Mock Data API\n\nvar url = 'https://jsonplaceholder.typicode.com/posts';\nvar postData = { userId: 1, title: 'p5 Clicked!', body: 'p5.js is way cool.' };\n\nfunction setup() {\n  createCanvas(800, 800);\n}\n\nfunction mousePressed() {\n  // Pick new random color values\n  var r = random(255);\n  var g = random(255);\n  var b = random(255);\n\n  httpPost(url, 'json', postData, function(result) {\n    strokeWeight(2);\n    stroke(r, g, b);\n    fill(r, g, b, 127);\n    ellipse(mouseX, mouseY, 200, 200);\n    text(result.body, mouseX, mouseY);\n  });\n}\n</code>\n</div>\n\n\n<div><code>\nvar url = 'https://invalidURL'; // A bad URL that will cause errors\nvar postData = { title: 'p5 Clicked!', body: 'p5.js is way cool.' };\n\nfunction setup() {\n  createCanvas(800, 800);\n}\n\nfunction mousePressed() {\n  // Pick new random color values\n  var r = random(255);\n  var g = random(255);\n  var b = random(255);\n\n  httpPost(\n    url,\n    'json',\n    postData,\n    function(result) {\n      // ... won't be called\n    },\n    function(error) {\n      strokeWeight(2);\n      stroke(r, g, b);\n      fill(r, g, b, 127);\n      text(error.toString(), mouseX, mouseY);\n    }\n  );\n}\n</code></div>\n"
            ],
            "class": "p5",
            "module": "IO",
            "submodule": "Input"
        },
        {
            "file": "src/io/files.js",
            "line": 826,
            "description": "<p>Method for executing an HTTP request. If data type is not specified,\np5 will try to guess based on the URL, defaulting to text.<br><br>\nFor more advanced use, you may also pass in the path as the first argument\nand a object as the second argument, the signature follows the one specified\nin the Fetch API specification.</p>\n",
            "itemtype": "method",
            "name": "httpDo",
            "example": [
                "\n<div>\n<code>\n// Examples use USGS Earthquake API:\n// https://earthquake.usgs.gov/fdsnws/event/1/#methods\n\n// displays an animation of all USGS earthquakes\nvar earthquakes;\nvar eqFeatureIndex = 0;\n\nfunction preload() {\n  var url = 'https://earthquake.usgs.gov/fdsnws/event/1/query?format=geojson';\n  httpDo(\n    url,\n    {\n      method: 'GET',\n      // Other Request options, like special headers for apis\n      headers: { authorization: 'Bearer secretKey' }\n    },\n    function(res) {\n      earthquakes = res;\n    }\n  );\n}\n\nfunction draw() {\n  // wait until the data is loaded\n  if (!earthquakes || !earthquakes.features[eqFeatureIndex]) {\n    return;\n  }\n  clear();\n\n  var feature = earthquakes.features[eqFeatureIndex];\n  var mag = feature.properties.mag;\n  var rad = mag / 11 * ((width + height) / 2);\n  fill(255, 0, 0, 100);\n  ellipse(width / 2 + random(-2, 2), height / 2 + random(-2, 2), rad, rad);\n\n  if (eqFeatureIndex >= earthquakes.features.length) {\n    eqFeatureIndex = 0;\n  } else {\n    eqFeatureIndex += 1;\n  }\n}\n</code>\n</div>"
            ],
            "class": "p5",
            "module": "IO",
            "submodule": "Input",
            "overloads": [
                {
                    "line": 826,
                    "params": [
                        {
                            "name": "path",
                            "description": "<p>name of the file or url to load</p>\n",
                            "type": "String"
                        },
                        {
                            "name": "method",
                            "description": "<p>either &quot;GET&quot;, &quot;POST&quot;, or &quot;PUT&quot;,\n                                   defaults to &quot;GET&quot;</p>\n",
                            "type": "String",
                            "optional": true
                        },
                        {
                            "name": "datatype",
                            "description": "<p>&quot;json&quot;, &quot;jsonp&quot;, &quot;xml&quot;, or &quot;text&quot;</p>\n",
                            "type": "String",
                            "optional": true
                        },
                        {
                            "name": "data",
                            "description": "<p>param data passed sent with request</p>\n",
                            "type": "Object",
                            "optional": true
                        },
                        {
                            "name": "callback",
                            "description": "<p>function to be executed after\n                                   httpGet() completes, data is passed in\n                                   as first argument</p>\n",
                            "type": "Function",
                            "optional": true
                        },
                        {
                            "name": "errorCallback",
                            "description": "<p>function to be executed if\n                                   there is an error, response is passed\n                                   in as first argument</p>\n",
                            "type": "Function",
                            "optional": true
                        }
                    ]
                },
                {
                    "line": 895,
                    "params": [
                        {
                            "name": "path",
                            "description": "",
                            "type": "String"
                        },
                        {
                            "name": "options",
                            "description": "<p>Request object options as documented in the\n                                   &quot;fetch&quot; API\n<a href=\"https://developer.mozilla.org/en/docs/Web/API/Fetch_API\">reference</a></p>\n",
                            "type": "Object"
                        },
                        {
                            "name": "callback",
                            "description": "",
                            "type": "Function",
                            "optional": true
                        },
                        {
                            "name": "errorCallback",
                            "description": "",
                            "type": "Function",
                            "optional": true
                        }
                    ]
                }
            ]
        },
        {
            "file": "src/io/files.js",
            "line": 1063,
            "itemtype": "method",
            "name": "createWriter",
            "params": [
                {
                    "name": "name",
                    "description": "<p>name of the file to be created</p>\n",
                    "type": "String"
                },
                {
                    "name": "extension",
                    "description": "",
                    "type": "String",
                    "optional": true
                }
            ],
            "return": {
                "description": "",
                "type": "p5.PrintWriter"
            },
            "example": [
                "\n<div>\n<code>\ncreateButton('save')\n  .position(10, 10)\n  .mousePressed(function() {\n    var writer = createWriter('squares.txt');\n    for (var i = 0; i < 10; i++) {\n      writer.print(i * i);\n    }\n    writer.close();\n    writer.flush();\n  });\n</code>\n</div>"
            ],
            "class": "p5",
            "module": "IO",
            "submodule": "Output"
        },
        {
            "file": "src/io/files.js",
            "line": 1113,
            "itemtype": "method",
            "name": "write",
            "params": [
                {
                    "name": "data",
                    "description": "",
                    "type": "Array"
                }
            ],
            "class": "p5.PrintWriter",
            "module": "IO",
            "submodule": "Output"
        },
        {
            "file": "src/io/files.js",
            "line": 1120,
            "itemtype": "method",
            "name": "print",
            "params": [
                {
                    "name": "data",
                    "description": "",
                    "type": "Array"
                }
            ],
            "class": "p5.PrintWriter",
            "module": "IO",
            "submodule": "Output"
        },
        {
            "file": "src/io/files.js",
            "line": 1127,
            "itemtype": "method",
            "name": "flush",
            "class": "p5.PrintWriter",
            "module": "IO",
            "submodule": "Output"
        },
        {
            "file": "src/io/files.js",
            "line": 1133,
            "itemtype": "method",
            "name": "close",
            "class": "p5.PrintWriter",
            "module": "IO",
            "submodule": "Output"
        },
        {
            "file": "src/io/files.js",
            "line": 1162,
            "description": "<p>Save an image, text, json, csv, wav, or html. Prompts download to\nthe client&#39;s computer. <b>Note that it is not recommended to call save()\nwithin draw if it&#39;s looping, as the save() function will open a new save\ndialog every frame.</b></p>\n<p>The default behavior is to save the canvas as an image. You can\noptionally specify a filename.\nFor example:</p>\n <pre class='language-javascript'><code>\n save();\n save(&#39;myCanvas.jpg&#39;); // save a specific canvas with a filename\n </code></pre>\n\n<p>Alternately, the first parameter can be a pointer to a canvas\np5.Element, an Array of Strings,\nan Array of JSON, a JSON object, a p5.Table, a p5.Image, or a\np5.SoundFile (requires p5.sound). The second parameter is a filename\n(including extension). The third parameter is for options specific\nto this type of object. This method will save a file that fits the\ngiven paramaters. For example:</p>\n\n <pre class='language-javascript'><code>\n // Saves canvas as an image\n save('myCanvas.jpg');\n\n // Saves pImage as a png image\n var img = createImage(10, 10);\n save(img, 'my.png');\n\n // Saves canvas as an image\n var cnv = createCanvas(100, 100);\n save(cnv, 'myCanvas.jpg');\n\n // Saves p5.Renderer object as an image\n var gb = createGraphics(100, 100);\n save(gb, 'myGraphics.jpg');\n\n var myTable = new p5.Table();\n\n // Saves table as html file\n save(myTable, 'myTable.html');\n\n // Comma Separated Values\n save(myTable, 'myTable.csv');\n\n // Tab Separated Values\n save(myTable, 'myTable.tsv');\n\n var myJSON = { a: 1, b: true };\n\n // Saves pretty JSON\n save(myJSON, 'my.json');\n\n // Optimizes JSON filesize\n save(myJSON, 'my.json', true);\n\n // Saves array of strings to a text file with line breaks after each item\n var arrayOfStrings = ['a', 'b'];\n save(arrayOfStrings, 'my.txt');\n </code></pre>",
            "itemtype": "method",
            "name": "save",
            "params": [
                {
                    "name": "objectOrFilename",
                    "description": "<p>If filename is provided, will\n                                           save canvas as an image with\n                                           either png or jpg extension\n                                           depending on the filename.\n                                           If object is provided, will\n                                           save depending on the object\n                                           and filename (see examples\n                                           above).</p>\n",
                    "type": "Object|String",
                    "optional": true
                },
                {
                    "name": "filename",
                    "description": "<p>If an object is provided as the first\n                             parameter, then the second parameter\n                             indicates the filename,\n                             and should include an appropriate\n                             file extension (see examples above).</p>\n",
                    "type": "String",
                    "optional": true
                },
                {
                    "name": "options",
                    "description": "<p>Additional options depend on\n                          filetype. For example, when saving JSON,\n                          <code>true</code> indicates that the\n                          output will be optimized for filesize,\n                          rather than readability.</p>\n",
                    "type": "Boolean|String",
                    "optional": true
                }
            ],
            "class": "p5",
            "module": "IO",
            "submodule": "Output"
        },
        {
            "file": "src/io/files.js",
            "line": 1290,
            "description": "<p>Writes the contents of an Array or a JSON object to a .json file.\nThe file saving process and location of the saved file will\nvary between web browsers.</p>\n",
            "itemtype": "method",
            "name": "saveJSON",
            "params": [
                {
                    "name": "json",
                    "description": "",
                    "type": "Array|Object"
                },
                {
                    "name": "filename",
                    "description": "",
                    "type": "String"
                },
                {
                    "name": "optimize",
                    "description": "<p>If true, removes line breaks\n                               and spaces from the output\n                               file to optimize filesize\n                               (but not readability).</p>\n",
                    "type": "Boolean",
                    "optional": true
                }
            ],
            "example": [
                "\n <div><code>\n var json = {}; // new  JSON Object\n\n json.id = 0;\n json.species = 'Panthera leo';\n json.name = 'Lion';\n\n createButton('save')\n .position(10, 10)\n .mousePressed(function() {\n   saveJSON(json, 'lion.json');\n });\n\n // saves the following to a file called \"lion.json\":\n // {\n //   \"id\": 0,\n //   \"species\": \"Panthera leo\",\n //   \"name\": \"Lion\"\n // }\n </code></div>"
            ],
            "alt": "no image displayed",
            "class": "p5",
            "module": "IO",
            "submodule": "Output"
        },
        {
            "file": "src/io/files.js",
            "line": 1341,
            "description": "<p>Writes an array of Strings to a text file, one line per String.\nThe file saving process and location of the saved file will\nvary between web browsers.</p>\n",
            "itemtype": "method",
            "name": "saveStrings",
            "params": [
                {
                    "name": "list",
                    "description": "<p>string array to be written</p>\n",
                    "type": "String[]"
                },
                {
                    "name": "filename",
                    "description": "<p>filename for output</p>\n",
                    "type": "String"
                },
                {
                    "name": "extension",
                    "description": "<p>the filename&#39;s extension</p>\n",
                    "type": "String",
                    "optional": true
                }
            ],
            "example": [
                "\n <div><code>\n var words = 'apple bear cat dog';\n\n // .split() outputs an Array\n var list = split(words, ' ');\n\n createButton('save')\n .position(10, 10)\n .mousePressed(function() {\n   saveStrings(list, 'nouns.txt');\n });\n\n // Saves the following to a file called 'nouns.txt':\n //\n // apple\n // bear\n // cat\n // dog\n </code></div>"
            ],
            "alt": "no image displayed",
            "class": "p5",
            "module": "IO",
            "submodule": "Output"
        },
        {
            "file": "src/io/files.js",
            "line": 1402,
            "description": "<p>Writes the contents of a Table object to a file. Defaults to a\ntext file with comma-separated-values (&#39;csv&#39;) but can also\nuse tab separation (&#39;tsv&#39;), or generate an HTML table (&#39;html&#39;).\nThe file saving process and location of the saved file will\nvary between web browsers.</p>\n",
            "itemtype": "method",
            "name": "saveTable",
            "params": [
                {
                    "name": "Table",
                    "description": "<p>the Table object to save to a file</p>\n",
                    "type": "p5.Table"
                },
                {
                    "name": "filename",
                    "description": "<p>the filename to which the Table should be saved</p>\n",
                    "type": "String"
                },
                {
                    "name": "options",
                    "description": "<p>can be one of &quot;tsv&quot;, &quot;csv&quot;, or &quot;html&quot;</p>\n",
                    "type": "String",
                    "optional": true
                }
            ],
            "example": [
                "\n<div><code>\n var table;\n\n function setup() {\n table = new p5.Table();\n\n table.addColumn('id');\n table.addColumn('species');\n table.addColumn('name');\n\n var newRow = table.addRow();\n newRow.setNum('id', table.getRowCount() - 1);\n newRow.setString('species', 'Panthera leo');\n newRow.setString('name', 'Lion');\n\n // To save, un-comment next line then click 'run'\n // saveTable(table, 'new.csv');\n }\n\n // Saves the following to a file called 'new.csv':\n // id,species,name\n // 0,Panthera leo,Lion\n </code></div>"
            ],
            "alt": "no image displayed",
            "class": "p5",
            "module": "IO",
            "submodule": "Output"
        },
        {
            "file": "src/io/files.js",
            "line": 1549,
            "description": "<p>Forces download. Accepts a url to filedata/blob, a filename,\nand an extension (optional).\nThis is a private function because it does not do any formatting,\nbut it is used by saveStrings, saveJSON, saveTable etc.</p>\n",
            "itemtype": "method",
            "name": "downloadFile",
            "params": [
                {
                    "name": "data",
                    "description": "<p>either an href generated by createObjectURL,\n                              or a Blob object containing the data</p>\n",
                    "type": "String|Blob"
                },
                {
                    "name": "filename",
                    "description": "",
                    "type": "String",
                    "optional": true
                },
                {
                    "name": "extension",
                    "description": "",
                    "type": "String",
                    "optional": true
                }
            ],
            "class": "p5",
            "module": "IO",
            "submodule": "Output"
        },
        {
            "file": "src/io/p5.Table.js",
            "line": 11,
            "description": "<p>Table Options</p>\n<p>Generic class for handling tabular data, typically from a\nCSV, TSV, or other sort of spreadsheet file.</p>\n<p>CSV files are\n<a href=\"http://en.wikipedia.org/wiki/Comma-separated_values\">\ncomma separated values</a>, often with the data in quotes. TSV\nfiles use tabs as separators, and usually don&#39;t bother with the\nquotes.</p>\n<p>File names should end with .csv if they&#39;re comma separated.</p>\n<p>A rough &quot;spec&quot; for CSV can be found\n<a href=\"http://tools.ietf.org/html/rfc4180\">here</a>.</p>\n<p>To load files, use the loadTable method.</p>\n<p>To save tables to your computer, use the save method\n or the saveTable method.</p>\n\n<p>Possible options include:</p>\n<ul>\n<li>csv - parse the table as comma-separated values\n<li>tsv - parse the table as tab-separated values\n<li>header - this table has a header (title) row\n</ul>",
            "class": "p5.Table",
            "module": "IO",
            "submodule": "Table"
        },
        {
            "file": "src/io/p5.Table.js",
            "line": 45,
            "itemtype": "property",
            "name": "columns",
            "type": "String[]",
            "class": "p5.Table",
            "module": "IO",
            "submodule": "Table"
        },
        {
            "file": "src/io/p5.Table.js",
            "line": 50,
            "itemtype": "property",
            "name": "rows",
            "type": "p5.TableRow[]",
            "class": "p5.Table",
            "module": "IO",
            "submodule": "Table"
        },
        {
            "file": "src/io/p5.Table.js",
            "line": 57,
            "description": "<p>Use addRow() to add a new row of data to a p5.Table object. By default,\nan empty row is created. Typically, you would store a reference to\nthe new row in a TableRow object (see newRow in the example above),\nand then set individual values using set().</p>\n<p>If a p5.TableRow object is included as a parameter, then that row is\nduplicated and added to the table.</p>\n",
            "itemtype": "method",
            "name": "addRow",
            "params": [
                {
                    "name": "row",
                    "description": "<p>row to be added to the table</p>\n",
                    "type": "p5.TableRow",
                    "optional": true
                }
            ],
            "example": [
                "\n <div class=\"norender\">\n <code>\n // Given the CSV file \"mammals.csv\"\n // in the project's \"assets\" folder:\n //\n // id,species,name\n // 0,Capra hircus,Goat\n // 1,Panthera pardus,Leopard\n // 2,Equus zebra,Zebra\n\n var table;\n\n function preload() {\n //my table is comma separated value \"csv\"\n //and has a header specifying the columns labels\n table = loadTable('assets/mammals.csv', 'csv', 'header');\n }\n\n function setup() {\n //add a row\n var newRow = table.addRow();\n newRow.setString('id', table.getRowCount() - 1);\n newRow.setString('species', 'Canis Lupus');\n newRow.setString('name', 'Wolf');\n\n //print the results\n for (var r = 0; r < table.getRowCount(); r++)\n   for (var c = 0; c < table.getColumnCount(); c++)\n     print(table.getString(r, c));\n }\n </code>\n </div>"
            ],
            "alt": "no image displayed",
            "class": "p5.Table",
            "module": "IO",
            "submodule": "Table"
        },
        {
            "file": "src/io/p5.Table.js",
            "line": 120,
            "description": "<p>Removes a row from the table object.</p>\n",
            "itemtype": "method",
            "name": "removeRow",
            "params": [
                {
                    "name": "id",
                    "description": "<p>ID number of the row to remove</p>\n",
                    "type": "Integer"
                }
            ],
            "example": [
                "\n<div class=\"norender\">\n<code>\n// Given the CSV file \"mammals.csv\"\n// in the project's \"assets\" folder:\n//\n// id,species,name\n// 0,Capra hircus,Goat\n// 1,Panthera pardus,Leopard\n// 2,Equus zebra,Zebra\n\nvar table;\n\nfunction preload() {\n  //my table is comma separated value \"csv\"\n  //and has a header specifying the columns labels\n  table = loadTable('assets/mammals.csv', 'csv', 'header');\n}\n\nfunction setup() {\n  //remove the first row\n  table.removeRow(0);\n\n  //print the results\n  for (var r = 0; r < table.getRowCount(); r++)\n    for (var c = 0; c < table.getColumnCount(); c++)\n      print(table.getString(r, c));\n}\n</code>\n</div>"
            ],
            "alt": "no image displayed",
            "class": "p5.Table",
            "module": "IO",
            "submodule": "Table"
        },
        {
            "file": "src/io/p5.Table.js",
            "line": 168,
            "description": "<p>Returns a reference to the specified p5.TableRow. The reference\ncan then be used to get and set values of the selected row.</p>\n",
            "itemtype": "method",
            "name": "getRow",
            "params": [
                {
                    "name": "rowID",
                    "description": "<p>ID number of the row to get</p>\n",
                    "type": "Integer"
                }
            ],
            "return": {
                "description": "p5.TableRow object",
                "type": "p5.TableRow"
            },
            "example": [
                "\n<div class=\"norender\">\n<code>\n// Given the CSV file \"mammals.csv\"\n// in the project's \"assets\" folder:\n//\n// id,species,name\n// 0,Capra hircus,Goat\n// 1,Panthera pardus,Leopard\n// 2,Equus zebra,Zebra\n\nvar table;\n\nfunction preload() {\n  //my table is comma separated value \"csv\"\n  //and has a header specifying the columns labels\n  table = loadTable('assets/mammals.csv', 'csv', 'header');\n}\n\nfunction setup() {\n  var row = table.getRow(1);\n  //print it column by column\n  //note: a row is an object, not an array\n  for (var c = 0; c < table.getColumnCount(); c++) {\n    print(row.getString(c));\n  }\n}\n</code>\n</div>"
            ],
            "alt": "no image displayed",
            "class": "p5.Table",
            "module": "IO",
            "submodule": "Table"
        },
        {
            "file": "src/io/p5.Table.js",
            "line": 214,
            "description": "<p>Gets all rows from the table. Returns an array of p5.TableRows.</p>\n",
            "itemtype": "method",
            "name": "getRows",
            "return": {
                "description": "Array of p5.TableRows",
                "type": "p5.TableRow[]"
            },
            "example": [
                "\n <div class=\"norender\">\n <code>\n // Given the CSV file \"mammals.csv\"\n // in the project's \"assets\" folder:\n //\n // id,species,name\n // 0,Capra hircus,Goat\n // 1,Panthera pardus,Leopard\n // 2,Equus zebra,Zebra\n\n var table;\n\n function preload() {\n //my table is comma separated value \"csv\"\n //and has a header specifying the columns labels\n table = loadTable('assets/mammals.csv', 'csv', 'header');\n }\n\n function setup() {\n var rows = table.getRows();\n\n //warning: rows is an array of objects\n for (var r = 0; r < rows.length; r++) {\n   rows[r].set('name', 'Unicorn');\n }\n\n //print the results\n for (r = 0; r < table.getRowCount(); r++)\n   for (var c = 0; c < table.getColumnCount(); c++)\n     print(table.getString(r, c));\n }\n </code>\n </div>"
            ],
            "alt": "no image displayed",
            "class": "p5.Table",
            "module": "IO",
            "submodule": "Table"
        },
        {
            "file": "src/io/p5.Table.js",
            "line": 263,
            "description": "<p>Finds the first row in the Table that contains the value\nprovided, and returns a reference to that row. Even if\nmultiple rows are possible matches, only the first matching\nrow is returned. The column to search may be specified by\neither its ID or title.</p>\n",
            "itemtype": "method",
            "name": "findRow",
            "params": [
                {
                    "name": "value",
                    "description": "<p>The value to match</p>\n",
                    "type": "String"
                },
                {
                    "name": "column",
                    "description": "<p>ID number or title of the\n                               column to search</p>\n",
                    "type": "Integer|String"
                }
            ],
            "return": {
                "description": "",
                "type": "p5.TableRow"
            },
            "example": [
                "\n <div class=\"norender\">\n <code>\n // Given the CSV file \"mammals.csv\"\n // in the project's \"assets\" folder:\n //\n // id,species,name\n // 0,Capra hircus,Goat\n // 1,Panthera pardus,Leopard\n // 2,Equus zebra,Zebra\n\n var table;\n\n function preload() {\n //my table is comma separated value \"csv\"\n //and has a header specifying the columns labels\n table = loadTable('assets/mammals.csv', 'csv', 'header');\n }\n\n function setup() {\n //find the animal named zebra\n var row = table.findRow('Zebra', 'name');\n //find the corresponding species\n print(row.getString('species'));\n }\n </code>\n </div>"
            ],
            "alt": "no image displayed",
            "class": "p5.Table",
            "module": "IO",
            "submodule": "Table"
        },
        {
            "file": "src/io/p5.Table.js",
            "line": 328,
            "description": "<p>Finds the rows in the Table that contain the value\nprovided, and returns references to those rows. Returns an\nArray, so for must be used to iterate through all the rows,\nas shown in the example above. The column to search may be\nspecified by either its ID or title.</p>\n",
            "itemtype": "method",
            "name": "findRows",
            "params": [
                {
                    "name": "value",
                    "description": "<p>The value to match</p>\n",
                    "type": "String"
                },
                {
                    "name": "column",
                    "description": "<p>ID number or title of the\n                               column to search</p>\n",
                    "type": "Integer|String"
                }
            ],
            "return": {
                "description": "An Array of TableRow objects",
                "type": "p5.TableRow[]"
            },
            "example": [
                "\n <div class=\"norender\">\n <code>\n // Given the CSV file \"mammals.csv\"\n // in the project's \"assets\" folder:\n //\n // id,species,name\n // 0,Capra hircus,Goat\n // 1,Panthera pardus,Leopard\n // 2,Equus zebra,Zebra\n\n var table;\n\n function preload() {\n //my table is comma separated value \"csv\"\n //and has a header specifying the columns labels\n table = loadTable('assets/mammals.csv', 'csv', 'header');\n }\n\n function setup() {\n //add another goat\n var newRow = table.addRow();\n newRow.setString('id', table.getRowCount() - 1);\n newRow.setString('species', 'Scape Goat');\n newRow.setString('name', 'Goat');\n\n //find the rows containing animals named Goat\n var rows = table.findRows('Goat', 'name');\n print(rows.length + ' Goats found');\n }\n </code>\n </div>"
            ],
            "alt": "no image displayed",
            "class": "p5.Table",
            "module": "IO",
            "submodule": "Table"
        },
        {
            "file": "src/io/p5.Table.js",
            "line": 397,
            "description": "<p>Finds the first row in the Table that matches the regular\nexpression provided, and returns a reference to that row.\nEven if multiple rows are possible matches, only the first\nmatching row is returned. The column to search may be\nspecified by either its ID or title.</p>\n",
            "itemtype": "method",
            "name": "matchRow",
            "params": [
                {
                    "name": "regexp",
                    "description": "<p>The regular expression to match</p>\n",
                    "type": "String"
                },
                {
                    "name": "column",
                    "description": "<p>The column ID (number) or\n                                 title (string)</p>\n",
                    "type": "String|Integer"
                }
            ],
            "return": {
                "description": "TableRow object",
                "type": "p5.TableRow"
            },
            "class": "p5.Table",
            "module": "IO",
            "submodule": "Table"
        },
        {
            "file": "src/io/p5.Table.js",
            "line": 427,
            "description": "<p>Finds the rows in the Table that match the regular expression provided,\nand returns references to those rows. Returns an array, so for must be\nused to iterate through all the rows, as shown in the example. The\ncolumn to search may be specified by either its ID or title.</p>\n",
            "itemtype": "method",
            "name": "matchRows",
            "params": [
                {
                    "name": "regexp",
                    "description": "<p>The regular expression to match</p>\n",
                    "type": "String"
                },
                {
                    "name": "column",
                    "description": "<p>The column ID (number) or\n                                 title (string)</p>\n",
                    "type": "String|Integer",
                    "optional": true
                }
            ],
            "return": {
                "description": "An Array of TableRow objects",
                "type": "p5.TableRow[]"
            },
            "example": [
                "\nvar table;\n\nfunction setup() {\n\n  table = new p5.Table();\n\n  table.addColumn('name');\n  table.addColumn('type');\n\n  var newRow = table.addRow();\n  newRow.setString('name', 'Lion');\n  newRow.setString('type', 'Mammal');\n\n  newRow = table.addRow();\n  newRow.setString('name', 'Snake');\n  newRow.setString('type', 'Reptile');\n\n  newRow = table.addRow();\n  newRow.setString('name', 'Mosquito');\n  newRow.setString('type', 'Insect');\n\n  newRow = table.addRow();\n  newRow.setString('name', 'Lizard');\n  newRow.setString('type', 'Reptile');\n\n  var rows = table.matchRows('R.*', 'type');\n  for (var i = 0; i < rows.length; i++) {\n    print(rows[i].getString('name') + ': ' + rows[i].getString('type'));\n  }\n}\n// Sketch prints:\n// Snake: Reptile\n// Lizard: Reptile"
            ],
            "class": "p5.Table",
            "module": "IO",
            "submodule": "Table"
        },
        {
            "file": "src/io/p5.Table.js",
            "line": 491,
            "description": "<p>Retrieves all values in the specified column, and returns them\nas an array. The column may be specified by either its ID or title.</p>\n",
            "itemtype": "method",
            "name": "getColumn",
            "params": [
                {
                    "name": "column",
                    "description": "<p>String or Number of the column to return</p>\n",
                    "type": "String|Number"
                }
            ],
            "return": {
                "description": "Array of column values",
                "type": "Array"
            },
            "example": [
                "\n <div class=\"norender\">\n <code>\n // Given the CSV file \"mammals.csv\"\n // in the project's \"assets\" folder:\n //\n // id,species,name\n // 0,Capra hircus,Goat\n // 1,Panthera pardus,Leopard\n // 2,Equus zebra,Zebra\n\n var table;\n\n function preload() {\n //my table is comma separated value \"csv\"\n //and has a header specifying the columns labels\n table = loadTable('assets/mammals.csv', 'csv', 'header');\n }\n\n function setup() {\n //getColumn returns an array that can be printed directly\n print(table.getColumn('species'));\n //outputs [\"Capra hircus\", \"Panthera pardus\", \"Equus zebra\"]\n }\n </code>\n </div>"
            ],
            "alt": "no image displayed",
            "class": "p5.Table",
            "module": "IO",
            "submodule": "Table"
        },
        {
            "file": "src/io/p5.Table.js",
            "line": 544,
            "description": "<p>Removes all rows from a Table. While all rows are removed,\ncolumns and column titles are maintained.</p>\n",
            "itemtype": "method",
            "name": "clearRows",
            "example": [
                "\n <div class=\"norender\">\n <code>\n // Given the CSV file \"mammals.csv\"\n // in the project's \"assets\" folder:\n //\n // id,species,name\n // 0,Capra hircus,Goat\n // 1,Panthera pardus,Leopard\n // 2,Equus zebra,Zebra\n\n var table;\n\n function preload() {\n //my table is comma separated value \"csv\"\n //and has a header specifying the columns labels\n table = loadTable('assets/mammals.csv', 'csv', 'header');\n }\n\n function setup() {\n table.clearRows();\n print(table.getRowCount() + ' total rows in table');\n print(table.getColumnCount() + ' total columns in table');\n }\n </code>\n </div>"
            ],
            "alt": "no image displayed",
            "class": "p5.Table",
            "module": "IO",
            "submodule": "Table"
        },
        {
            "file": "src/io/p5.Table.js",
            "line": 586,
            "description": "<p>Use addColumn() to add a new column to a Table object.\nTypically, you will want to specify a title, so the column\nmay be easily referenced later by name. (If no title is\nspecified, the new column&#39;s title will be null.)</p>\n",
            "itemtype": "method",
            "name": "addColumn",
            "params": [
                {
                    "name": "title",
                    "description": "<p>title of the given column</p>\n",
                    "type": "String",
                    "optional": true
                }
            ],
            "example": [
                "\n <div class=\"norender\">\n <code>\n // Given the CSV file \"mammals.csv\"\n // in the project's \"assets\" folder:\n //\n // id,species,name\n // 0,Capra hircus,Goat\n // 1,Panthera pardus,Leopard\n // 2,Equus zebra,Zebra\n\n var table;\n\n function preload() {\n //my table is comma separated value \"csv\"\n //and has a header specifying the columns labels\n table = loadTable('assets/mammals.csv', 'csv', 'header');\n }\n\n function setup() {\n table.addColumn('carnivore');\n table.set(0, 'carnivore', 'no');\n table.set(1, 'carnivore', 'yes');\n table.set(2, 'carnivore', 'no');\n\n //print the results\n for (var r = 0; r < table.getRowCount(); r++)\n   for (var c = 0; c < table.getColumnCount(); c++)\n     print(table.getString(r, c));\n }\n </code>\n </div>"
            ],
            "alt": "no image displayed",
            "class": "p5.Table",
            "module": "IO",
            "submodule": "Table"
        },
        {
            "file": "src/io/p5.Table.js",
            "line": 637,
            "description": "<p>Returns the total number of columns in a Table.</p>\n",
            "itemtype": "method",
            "name": "getColumnCount",
            "return": {
                "description": "Number of columns in this table",
                "type": "Integer"
            },
            "class": "p5.Table",
            "module": "IO",
            "submodule": "Table"
        },
        {
            "file": "src/io/p5.Table.js",
            "line": 647,
            "description": "<p>Returns the total number of rows in a Table.</p>\n",
            "itemtype": "method",
            "name": "getRowCount",
            "return": {
                "description": "Number of rows in this table",
                "type": "Integer"
            },
            "class": "p5.Table",
            "module": "IO",
            "submodule": "Table"
        },
        {
            "file": "src/io/p5.Table.js",
            "line": 657,
            "description": "<p>Removes any of the specified characters (or &quot;tokens&quot;).</p>\n\n<p>If no column is specified, then the values in all columns and\nrows are processed. A specific column may be referenced by\neither its ID or title.</p>",
            "itemtype": "method",
            "name": "removeTokens",
            "params": [
                {
                    "name": "chars",
                    "description": "<p>String listing characters to be removed</p>\n",
                    "type": "String"
                },
                {
                    "name": "column",
                    "description": "<p>Column ID (number)\n                                 or name (string)</p>\n",
                    "type": "String|Integer",
                    "optional": true
                }
            ],
            "class": "p5.Table",
            "module": "IO",
            "submodule": "Table"
        },
        {
            "file": "src/io/p5.Table.js",
            "line": 706,
            "description": "<p>Trims leading and trailing whitespace, such as spaces and tabs,\nfrom String table values. If no column is specified, then the\nvalues in all columns and rows are trimmed. A specific column\nmay be referenced by either its ID or title.</p>\n",
            "itemtype": "method",
            "name": "trim",
            "params": [
                {
                    "name": "column",
                    "description": "<p>Column ID (number)\n                                 or name (string)</p>\n",
                    "type": "String|Integer",
                    "optional": true
                }
            ],
            "class": "p5.Table",
            "module": "IO",
            "submodule": "Table"
        },
        {
            "file": "src/io/p5.Table.js",
            "line": 746,
            "description": "<p>Use removeColumn() to remove an existing column from a Table\nobject. The column to be removed may be identified by either\nits title (a String) or its index value (an int).\nremoveColumn(0) would remove the first column, removeColumn(1)\nwould remove the second column, and so on.</p>\n",
            "itemtype": "method",
            "name": "removeColumn",
            "params": [
                {
                    "name": "column",
                    "description": "<p>columnName (string) or ID (number)</p>\n",
                    "type": "String|Integer"
                }
            ],
            "example": [
                "\n <div class=\"norender\">\n <code>\n // Given the CSV file \"mammals.csv\"\n // in the project's \"assets\" folder:\n //\n // id,species,name\n // 0,Capra hircus,Goat\n // 1,Panthera pardus,Leopard\n // 2,Equus zebra,Zebra\n\n var table;\n\n function preload() {\n //my table is comma separated value \"csv\"\n //and has a header specifying the columns labels\n table = loadTable('assets/mammals.csv', 'csv', 'header');\n }\n\n function setup() {\n table.removeColumn('id');\n print(table.getColumnCount());\n }\n </code>\n </div>"
            ],
            "alt": "no image displayed",
            "class": "p5.Table",
            "module": "IO",
            "submodule": "Table"
        },
        {
            "file": "src/io/p5.Table.js",
            "line": 812,
            "description": "<p>Stores a value in the Table&#39;s specified row and column.\nThe row is specified by its ID, while the column may be specified\nby either its ID or title.</p>\n",
            "itemtype": "method",
            "name": "set",
            "params": [
                {
                    "name": "column",
                    "description": "<p>column ID (Number)\n                              or title (String)</p>\n",
                    "type": "String|Integer"
                },
                {
                    "name": "value",
                    "description": "<p>value to assign</p>\n",
                    "type": "String|Number"
                }
            ],
            "example": [
                "\n<div class=\"norender\">\n<code>\n// Given the CSV file \"mammals.csv\"\n// in the project's \"assets\" folder:\n//\n// id,species,name\n// 0,Capra hircus,Goat\n// 1,Panthera pardus,Leopard\n// 2,Equus zebra,Zebra\n\nvar table;\n\nfunction preload() {\n  //my table is comma separated value \"csv\"\n  //and has a header specifying the columns labels\n  table = loadTable('assets/mammals.csv', 'csv', 'header');\n}\n\nfunction setup() {\n  table.set(0, 'species', 'Canis Lupus');\n  table.set(0, 'name', 'Wolf');\n\n  //print the results\n  for (var r = 0; r < table.getRowCount(); r++)\n    for (var c = 0; c < table.getColumnCount(); c++)\n      print(table.getString(r, c));\n}\n</code>\n</div>"
            ],
            "alt": "no image displayed",
            "class": "p5.Table",
            "module": "IO",
            "submodule": "Table"
        },
        {
            "file": "src/io/p5.Table.js",
            "line": 861,
            "description": "<p>Stores a Float value in the Table&#39;s specified row and column.\nThe row is specified by its ID, while the column may be specified\nby either its ID or title.</p>\n",
            "itemtype": "method",
            "name": "setNum",
            "params": [
                {
                    "name": "row",
                    "description": "<p>row ID</p>\n",
                    "type": "Integer"
                },
                {
                    "name": "column",
                    "description": "<p>column ID (Number)\n                              or title (String)</p>\n",
                    "type": "String|Integer"
                },
                {
                    "name": "value",
                    "description": "<p>value to assign</p>\n",
                    "type": "Number"
                }
            ],
            "example": [
                "\n<div class=\"norender\">\n<code>\n// Given the CSV file \"mammals.csv\"\n// in the project's \"assets\" folder:\n//\n// id,species,name\n// 0,Capra hircus,Goat\n// 1,Panthera pardus,Leopard\n// 2,Equus zebra,Zebra\n\nvar table;\n\nfunction preload() {\n  //my table is comma separated value \"csv\"\n  //and has a header specifying the columns labels\n  table = loadTable('assets/mammals.csv', 'csv', 'header');\n}\n\nfunction setup() {\n  table.setNum(1, 'id', 1);\n\n  print(table.getColumn(0));\n  //[\"0\", 1, \"2\"]\n}\n</code>\n</div>"
            ],
            "alt": "no image displayed",
            "class": "p5.Table",
            "module": "IO",
            "submodule": "Table"
        },
        {
            "file": "src/io/p5.Table.js",
            "line": 907,
            "description": "<p>Stores a String value in the Table&#39;s specified row and column.\nThe row is specified by its ID, while the column may be specified\nby either its ID or title.</p>\n",
            "itemtype": "method",
            "name": "setString",
            "params": [
                {
                    "name": "row",
                    "description": "<p>row ID</p>\n",
                    "type": "Integer"
                },
                {
                    "name": "column",
                    "description": "<p>column ID (Number)\n                              or title (String)</p>\n",
                    "type": "String|Integer"
                },
                {
                    "name": "value",
                    "description": "<p>value to assign</p>\n",
                    "type": "String"
                }
            ],
            "class": "p5.Table",
            "module": "IO",
            "submodule": "Table"
        },
        {
            "file": "src/io/p5.Table.js",
            "line": 922,
            "description": "<p>Retrieves a value from the Table&#39;s specified row and column.\nThe row is specified by its ID, while the column may be specified by\neither its ID or title.</p>\n",
            "itemtype": "method",
            "name": "get",
            "params": [
                {
                    "name": "row",
                    "description": "<p>row ID</p>\n",
                    "type": "Integer"
                },
                {
                    "name": "column",
                    "description": "<p>columnName (string) or\n                                  ID (number)</p>\n",
                    "type": "String|Integer"
                }
            ],
            "return": {
                "description": "",
                "type": "String|Number"
            },
            "example": [
                "\n<div class=\"norender\">\n<code>\n// Given the CSV file \"mammals.csv\"\n// in the project's \"assets\" folder:\n//\n// id,species,name\n// 0,Capra hircus,Goat\n// 1,Panthera pardus,Leopard\n// 2,Equus zebra,Zebra\n\nvar table;\n\nfunction preload() {\n  //my table is comma separated value \"csv\"\n  //and has a header specifying the columns labels\n  table = loadTable('assets/mammals.csv', 'csv', 'header');\n}\n\nfunction setup() {\n  print(table.get(0, 1));\n  //Capra hircus\n  print(table.get(0, 'species'));\n  //Capra hircus\n}\n</code>\n</div>"
            ],
            "alt": "no image displayed",
            "class": "p5.Table",
            "module": "IO",
            "submodule": "Table"
        },
        {
            "file": "src/io/p5.Table.js",
            "line": 969,
            "description": "<p>Retrieves a Float value from the Table&#39;s specified row and column.\nThe row is specified by its ID, while the column may be specified by\neither its ID or title.</p>\n",
            "itemtype": "method",
            "name": "getNum",
            "params": [
                {
                    "name": "row",
                    "description": "<p>row ID</p>\n",
                    "type": "Integer"
                },
                {
                    "name": "column",
                    "description": "<p>columnName (string) or\n                                  ID (number)</p>\n",
                    "type": "String|Integer"
                }
            ],
            "return": {
                "description": "",
                "type": "Number"
            },
            "example": [
                "\n<div class=\"norender\">\n<code>\n// Given the CSV file \"mammals.csv\"\n// in the project's \"assets\" folder:\n//\n// id,species,name\n// 0,Capra hircus,Goat\n// 1,Panthera pardus,Leopard\n// 2,Equus zebra,Zebra\n\nvar table;\n\nfunction preload() {\n  //my table is comma separated value \"csv\"\n  //and has a header specifying the columns labels\n  table = loadTable('assets/mammals.csv', 'csv', 'header');\n}\n\nfunction setup() {\n  print(table.getNum(1, 0) + 100);\n  //id 1 + 100 = 101\n}\n</code>\n</div>"
            ],
            "alt": "no image displayed",
            "class": "p5.Table",
            "module": "IO",
            "submodule": "Table"
        },
        {
            "file": "src/io/p5.Table.js",
            "line": 1014,
            "description": "<p>Retrieves a String value from the Table&#39;s specified row and column.\nThe row is specified by its ID, while the column may be specified by\neither its ID or title.</p>\n",
            "itemtype": "method",
            "name": "getString",
            "params": [
                {
                    "name": "row",
                    "description": "<p>row ID</p>\n",
                    "type": "Integer"
                },
                {
                    "name": "column",
                    "description": "<p>columnName (string) or\n                                  ID (number)</p>\n",
                    "type": "String|Integer"
                }
            ],
            "return": {
                "description": "",
                "type": "String"
            },
            "example": [
                "\n<div class=\"norender\">\n<code>\n// Given the CSV file \"mammals.csv\"\n// in the project's \"assets\" folder:\n//\n// id,species,name\n// 0,Capra hircus,Goat\n// 1,Panthera pardus,Leopard\n// 2,Equus zebra,Zebra\n\nvar table;\n\nfunction preload() {\n  //my table is comma separated value \"csv\"\n  //and has a header specifying the columns labels\n  table = loadTable('assets/mammals.csv', 'csv', 'header');\n}\n\nfunction setup() {\n  var tableArray = table.getArray();\n\n  //output each row as array\n  for (var i = 0; i < tableArray.length; i++) {\n    print(tableArray[i]);\n  }\n}\n</code>\n</div>"
            ],
            "alt": "no image displayed",
            "class": "p5.Table",
            "module": "IO",
            "submodule": "Table"
        },
        {
            "file": "src/io/p5.Table.js",
            "line": 1063,
            "description": "<p>Retrieves all table data and returns as an object. If a column name is\npassed in, each row object will be stored with that attribute as its\ntitle.</p>\n",
            "itemtype": "method",
            "name": "getObject",
            "params": [
                {
                    "name": "headerColumn",
                    "description": "<p>Name of the column which should be used to\n                             title each row object (optional)</p>\n",
                    "type": "String",
                    "optional": true
                }
            ],
            "return": {
                "description": "",
                "type": "Object"
            },
            "example": [
                "\n<div class=\"norender\">\n<code>\n// Given the CSV file \"mammals.csv\"\n// in the project's \"assets\" folder:\n//\n// id,species,name\n// 0,Capra hircus,Goat\n// 1,Panthera pardus,Leopard\n// 2,Equus zebra,Zebra\n\nvar table;\n\nfunction preload() {\n  //my table is comma separated value \"csv\"\n  //and has a header specifying the columns labels\n  table = loadTable('assets/mammals.csv', 'csv', 'header');\n}\n\nfunction setup() {\n  var tableObject = table.getObject();\n\n  print(tableObject);\n  //outputs an object\n}\n</code>\n</div>"
            ],
            "alt": "no image displayed",
            "class": "p5.Table",
            "module": "IO",
            "submodule": "Table"
        },
        {
            "file": "src/io/p5.Table.js",
            "line": 1127,
            "description": "<p>Retrieves all table data and returns it as a multidimensional array.</p>\n",
            "itemtype": "method",
            "name": "getArray",
            "return": {
                "description": "",
                "type": "Array"
            },
            "class": "p5.Table",
            "module": "IO",
            "submodule": "Table"
        },
        {
            "file": "src/io/p5.TableRow.js",
            "line": 43,
            "description": "<p>Stores a value in the TableRow&#39;s specified column.\nThe column may be specified by either its ID or title.</p>\n",
            "itemtype": "method",
            "name": "set",
            "params": [
                {
                    "name": "column",
                    "description": "<p>Column ID (Number)\n                              or Title (String)</p>\n",
                    "type": "String|Integer"
                },
                {
                    "name": "value",
                    "description": "<p>The value to be stored</p>\n",
                    "type": "String|Number"
                }
            ],
            "class": "p5.TableRow",
            "module": "IO",
            "submodule": "Table"
        },
        {
            "file": "src/io/p5.TableRow.js",
            "line": 74,
            "description": "<p>Stores a Float value in the TableRow&#39;s specified column.\nThe column may be specified by either its ID or title.</p>\n",
            "itemtype": "method",
            "name": "setNum",
            "params": [
                {
                    "name": "column",
                    "description": "<p>Column ID (Number)\n                              or Title (String)</p>\n",
                    "type": "String|Integer"
                },
                {
                    "name": "value",
                    "description": "<p>The value to be stored\n                              as a Float</p>\n",
                    "type": "Number"
                }
            ],
            "class": "p5.TableRow",
            "module": "IO",
            "submodule": "Table"
        },
        {
            "file": "src/io/p5.TableRow.js",
            "line": 89,
            "description": "<p>Stores a String value in the TableRow&#39;s specified column.\nThe column may be specified by either its ID or title.</p>\n",
            "itemtype": "method",
            "name": "setString",
            "params": [
                {
                    "name": "column",
                    "description": "<p>Column ID (Number)\n                              or Title (String)</p>\n",
                    "type": "String|Integer"
                },
                {
                    "name": "value",
                    "description": "<p>The value to be stored\n                              as a String</p>\n",
                    "type": "String"
                }
            ],
            "class": "p5.TableRow",
            "module": "IO",
            "submodule": "Table"
        },
        {
            "file": "src/io/p5.TableRow.js",
            "line": 104,
            "description": "<p>Retrieves a value from the TableRow&#39;s specified column.\nThe column may be specified by either its ID or title.</p>\n",
            "itemtype": "method",
            "name": "get",
            "params": [
                {
                    "name": "column",
                    "description": "<p>columnName (string) or\n                                 ID (number)</p>\n",
                    "type": "String|Integer"
                }
            ],
            "return": {
                "description": "",
                "type": "String|Number"
            },
            "class": "p5.TableRow",
            "module": "IO",
            "submodule": "Table"
        },
        {
            "file": "src/io/p5.TableRow.js",
            "line": 121,
            "description": "<p>Retrieves a Float value from the TableRow&#39;s specified\ncolumn. The column may be specified by either its ID or\ntitle.</p>\n",
            "itemtype": "method",
            "name": "getNum",
            "params": [
                {
                    "name": "column",
                    "description": "<p>columnName (string) or\n                                 ID (number)</p>\n",
                    "type": "String|Integer"
                }
            ],
            "return": {
                "description": "Float Floating point number",
                "type": "Number"
            },
            "class": "p5.TableRow",
            "module": "IO",
            "submodule": "Table"
        },
        {
            "file": "src/io/p5.TableRow.js",
            "line": 145,
            "description": "<p>Retrieves an String value from the TableRow&#39;s specified\ncolumn. The column may be specified by either its ID or\ntitle.</p>\n",
            "itemtype": "method",
            "name": "getString",
            "params": [
                {
                    "name": "column",
                    "description": "<p>columnName (string) or\n                                 ID (number)</p>\n",
                    "type": "String|Integer"
                }
            ],
            "return": {
                "description": "String",
                "type": "String"
            },
            "class": "p5.TableRow",
            "module": "IO",
            "submodule": "Table"
        },
        {
            "file": "src/io/p5.XML.js",
            "line": 65,
            "description": "<p>Gets a copy of the element&#39;s parent. Returns the parent as another\np5.XML object.</p>\n",
            "itemtype": "method",
            "name": "getParent",
            "return": {
                "description": "element parent",
                "type": "p5.XML"
            },
            "example": [
                "\n<div class='norender'><code>\n// The following short XML file called \"mammals.xml\" is parsed\n// in the code below.\n//\n// <?xml version=\"1.0\"?>\n// &lt;mammals&gt;\n//   &lt;animal id=\"0\" species=\"Capra hircus\">Goat&lt;/animal&gt;\n//   &lt;animal id=\"1\" species=\"Panthera pardus\">Leopard&lt;/animal&gt;\n//   &lt;animal id=\"2\" species=\"Equus zebra\">Zebra&lt;/animal&gt;\n// &lt;/mammals&gt;\n\nvar xml;\n\nfunction preload() {\n  xml = loadXML('assets/mammals.xml');\n}\n\nfunction setup() {\n  var children = xml.getChildren('animal');\n  var parent = children[1].getParent();\n  print(parent.getName());\n}\n\n// Sketch prints:\n// mammals\n</code></div>"
            ],
            "class": "p5.XML",
            "module": "IO",
            "submodule": "XML"
        },
        {
            "file": "src/io/p5.XML.js",
            "line": 103,
            "description": "<p>Gets the element&#39;s full name, which is returned as a String.</p>\n",
            "itemtype": "method",
            "name": "getName",
            "return": {
                "description": "the name of the node",
                "type": "String"
            },
            "example": [
                "&lt;animal\n <div class='norender'><code>\n // The following short XML file called \"mammals.xml\" is parsed\n // in the code below.\n //\n // <?xml version=\"1.0\"?>\n // &lt;mammals&gt;\n //   &lt;animal id=\"0\" species=\"Capra hircus\">Goat&lt;/animal&gt;\n //   &lt;animal id=\"1\" species=\"Panthera pardus\">Leopard&lt;/animal&gt;\n //   &lt;animal id=\"2\" species=\"Equus zebra\">Zebra&lt;/animal&gt;\n // &lt;/mammals&gt;\n\n var xml;\n\n function preload() {\n xml = loadXML('assets/mammals.xml');\n }\n\n function setup() {\n print(xml.getName());\n }\n\n // Sketch prints:\n // mammals\n </code></div>"
            ],
            "class": "p5.XML",
            "module": "IO",
            "submodule": "XML"
        },
        {
            "file": "src/io/p5.XML.js",
            "line": 138,
            "description": "<p>Sets the element&#39;s name, which is specified as a String.</p>\n",
            "itemtype": "method",
            "name": "setName",
            "params": [
                {
                    "name": "the",
                    "description": "<p>new name of the node</p>\n",
                    "type": "String"
                }
            ],
            "example": [
                "&lt;animal\n<div class='norender'><code>\n// The following short XML file called \"mammals.xml\" is parsed\n// in the code below.\n//\n// <?xml version=\"1.0\"?>\n// &lt;mammals&gt;\n//   &lt;animal id=\"0\" species=\"Capra hircus\">Goat&lt;/animal&gt;\n//   &lt;animal id=\"1\" species=\"Panthera pardus\">Leopard&lt;/animal&gt;\n//   &lt;animal id=\"2\" species=\"Equus zebra\">Zebra&lt;/animal&gt;\n// &lt;/mammals&gt;\n\nvar xml;\n\nfunction preload() {\n  xml = loadXML('assets/mammals.xml');\n}\n\nfunction setup() {\n  print(xml.getName());\n  xml.setName('fish');\n  print(xml.getName());\n}\n\n// Sketch prints:\n// mammals\n// fish\n</code></div>"
            ],
            "class": "p5.XML",
            "module": "IO",
            "submodule": "XML"
        },
        {
            "file": "src/io/p5.XML.js",
            "line": 176,
            "description": "<p>Checks whether or not the element has any children, and returns the result\nas a boolean.</p>\n",
            "itemtype": "method",
            "name": "hasChildren",
            "return": {
                "description": "",
                "type": "Boolean"
            },
            "example": [
                "&lt;animal\n<div class='norender'><code>\n// The following short XML file called \"mammals.xml\" is parsed\n// in the code below.\n//\n// <?xml version=\"1.0\"?>\n// &lt;mammals&gt;\n//   &lt;animal id=\"0\" species=\"Capra hircus\">Goat&lt;/animal&gt;\n//   &lt;animal id=\"1\" species=\"Panthera pardus\">Leopard&lt;/animal&gt;\n//   &lt;animal id=\"2\" species=\"Equus zebra\">Zebra&lt;/animal&gt;\n// &lt;/mammals&gt;\n\nvar xml;\n\nfunction preload() {\n  xml = loadXML('assets/mammals.xml');\n}\n\nfunction setup() {\n  print(xml.hasChildren());\n}\n\n// Sketch prints:\n// true\n</code></div>"
            ],
            "class": "p5.XML",
            "module": "IO",
            "submodule": "XML"
        },
        {
            "file": "src/io/p5.XML.js",
            "line": 212,
            "description": "<p>Get the names of all of the element&#39;s children, and returns the names as an\narray of Strings. This is the same as looping through and calling getName()\non each child element individually.</p>\n",
            "itemtype": "method",
            "name": "listChildren",
            "return": {
                "description": "names of the children of the element",
                "type": "String[]"
            },
            "example": [
                "&lt;animal\n<div class='norender'><code>\n// The following short XML file called \"mammals.xml\" is parsed\n// in the code below.\n//\n// <?xml version=\"1.0\"?>\n// &lt;mammals&gt;\n//   &lt;animal id=\"0\" species=\"Capra hircus\">Goat&lt;/animal&gt;\n//   &lt;animal id=\"1\" species=\"Panthera pardus\">Leopard&lt;/animal&gt;\n//   &lt;animal id=\"2\" species=\"Equus zebra\">Zebra&lt;/animal&gt;\n// &lt;/mammals&gt;\n\nvar xml;\n\nfunction preload() {\n  xml = loadXML('assets/mammals.xml');\n}\n\nfunction setup() {\n  print(xml.listChildren());\n}\n\n// Sketch prints:\n// [\"animal\", \"animal\", \"animal\"]\n</code></div>"
            ],
            "class": "p5.XML",
            "module": "IO",
            "submodule": "XML"
        },
        {
            "file": "src/io/p5.XML.js",
            "line": 251,
            "description": "<p>Returns all of the element&#39;s children as an array of p5.XML objects. When\nthe name parameter is specified, then it will return all children that match\nthat name.</p>\n",
            "itemtype": "method",
            "name": "getChildren",
            "params": [
                {
                    "name": "name",
                    "description": "<p>element name</p>\n",
                    "type": "String",
                    "optional": true
                }
            ],
            "return": {
                "description": "children of the element",
                "type": "p5.XML[]"
            },
            "example": [
                "&lt;animal\n<div class='norender'><code>\n// The following short XML file called \"mammals.xml\" is parsed\n// in the code below.\n//\n// <?xml version=\"1.0\"?>\n// &lt;mammals&gt;\n//   &lt;animal id=\"0\" species=\"Capra hircus\">Goat&lt;/animal&gt;\n//   &lt;animal id=\"1\" species=\"Panthera pardus\">Leopard&lt;/animal&gt;\n//   &lt;animal id=\"2\" species=\"Equus zebra\">Zebra&lt;/animal&gt;\n// &lt;/mammals&gt;\n\nvar xml;\n\nfunction preload() {\n  xml = loadXML('assets/mammals.xml');\n}\n\nfunction setup() {\n  var animals = xml.getChildren('animal');\n\n  for (var i = 0; i < animals.length; i++) {\n    print(animals[i].getContent());\n  }\n}\n\n// Sketch prints:\n// \"Goat\"\n// \"Leopard\"\n// \"Zebra\"\n</code></div>"
            ],
            "class": "p5.XML",
            "module": "IO",
            "submodule": "XML"
        },
        {
            "file": "src/io/p5.XML.js",
            "line": 301,
            "description": "<p>Returns the first of the element&#39;s children that matches the name parameter\nor the child of the given index.It returns undefined if no matching\nchild is found.</p>\n",
            "itemtype": "method",
            "name": "getChild",
            "params": [
                {
                    "name": "name",
                    "description": "<p>element name or index</p>\n",
                    "type": "String|Integer"
                }
            ],
            "return": {
                "description": "",
                "type": "p5.XML"
            },
            "example": [
                "&lt;animal\n<div class='norender'><code>\n// The following short XML file called \"mammals.xml\" is parsed\n// in the code below.\n//\n// <?xml version=\"1.0\"?>\n// &lt;mammals&gt;\n//   &lt;animal id=\"0\" species=\"Capra hircus\">Goat&lt;/animal&gt;\n//   &lt;animal id=\"1\" species=\"Panthera pardus\">Leopard&lt;/animal&gt;\n//   &lt;animal id=\"2\" species=\"Equus zebra\">Zebra&lt;/animal&gt;\n// &lt;/mammals&gt;\n\nvar xml;\n\nfunction preload() {\n  xml = loadXML('assets/mammals.xml');\n}\n\nfunction setup() {\n  var firstChild = xml.getChild('animal');\n  print(firstChild.getContent());\n}\n\n// Sketch prints:\n// \"Goat\"\n</code></div>\n<div class='norender'><code>\nvar xml;\n\nfunction preload() {\n  xml = loadXML('assets/mammals.xml');\n}\n\nfunction setup() {\n  var secondChild = xml.getChild(1);\n  print(secondChild.getContent());\n}\n\n// Sketch prints:\n// \"Leopard\"\n</code></div>"
            ],
            "class": "p5.XML",
            "module": "IO",
            "submodule": "XML"
        },
        {
            "file": "src/io/p5.XML.js",
            "line": 361,
            "description": "<p>Appends a new child to the element. The child can be specified with\neither a String, which will be used as the new tag&#39;s name, or as a\nreference to an existing p5.XML object.\nA reference to the newly created child is returned as an p5.XML object.</p>\n",
            "itemtype": "method",
            "name": "addChild",
            "params": [
                {
                    "name": "a",
                    "description": "<p>p5.XML Object which will be the child to be added</p>\n",
                    "type": "p5.XML"
                }
            ],
            "class": "p5.XML",
            "module": "IO",
            "submodule": "XML"
        },
        {
            "file": "src/io/p5.XML.js",
            "line": 378,
            "description": "<p>Removes the element specified by name or index.</p>\n",
            "itemtype": "method",
            "name": "removeChild",
            "params": [
                {
                    "name": "name",
                    "description": "<p>element name or index</p>\n",
                    "type": "String|Integer"
                }
            ],
            "example": [
                "\n<div class='norender'><code>\n// The following short XML file called \"mammals.xml\" is parsed\n// in the code below.\n//\n// <?xml version=\"1.0\"?>\n// &lt;mammals&gt;\n//   &lt;animal id=\"0\" species=\"Capra hircus\">Goat&lt;/animal&gt;\n//   &lt;animal id=\"1\" species=\"Panthera pardus\">Leopard&lt;/animal&gt;\n//   &lt;animal id=\"2\" species=\"Equus zebra\">Zebra&lt;/animal&gt;\n// &lt;/mammals&gt;\n\nvar xml;\n\nfunction preload() {\n  xml = loadXML('assets/mammals.xml');\n}\n\nfunction setup() {\n  xml.removeChild('animal');\n  var children = xml.getChildren();\n  for (var i = 0; i < children.length; i++) {\n    print(children[i].getContent());\n  }\n}\n\n// Sketch prints:\n// \"Leopard\"\n// \"Zebra\"\n</code></div>\n<div class='norender'><code>\nvar xml;\n\nfunction preload() {\n  xml = loadXML('assets/mammals.xml');\n}\n\nfunction setup() {\n  xml.removeChild(1);\n  var children = xml.getChildren();\n  for (var i = 0; i < children.length; i++) {\n    print(children[i].getContent());\n  }\n}\n\n// Sketch prints:\n// \"Goat\"\n// \"Zebra\"\n</code></div>"
            ],
            "class": "p5.XML",
            "module": "IO",
            "submodule": "XML"
        },
        {
            "file": "src/io/p5.XML.js",
            "line": 450,
            "description": "<p>Counts the specified element&#39;s number of attributes, returned as an Number.</p>\n",
            "itemtype": "method",
            "name": "getAttributeCount",
            "return": {
                "description": "",
                "type": "Integer"
            },
            "example": [
                "\n<div class='norender'><code>\n// The following short XML file called \"mammals.xml\" is parsed\n// in the code below.\n//\n// <?xml version=\"1.0\"?>\n// &lt;mammals&gt;\n//   &lt;animal id=\"0\" species=\"Capra hircus\">Goat&lt;/animal&gt;\n//   &lt;animal id=\"1\" species=\"Panthera pardus\">Leopard&lt;/animal&gt;\n//   &lt;animal id=\"2\" species=\"Equus zebra\">Zebra&lt;/animal&gt;\n// &lt;/mammals&gt;\n\nvar xml;\n\nfunction preload() {\n  xml = loadXML('assets/mammals.xml');\n}\n\nfunction setup() {\n  var firstChild = xml.getChild('animal');\n  print(firstChild.getAttributeCount());\n}\n\n// Sketch prints:\n// 2\n</code></div>"
            ],
            "class": "p5.XML",
            "module": "IO",
            "submodule": "XML"
        },
        {
            "file": "src/io/p5.XML.js",
            "line": 486,
            "description": "<p>Gets all of the specified element&#39;s attributes, and returns them as an\narray of Strings.</p>\n",
            "itemtype": "method",
            "name": "listAttributes",
            "return": {
                "description": "an array of strings containing the names of attributes",
                "type": "String[]"
            },
            "example": [
                "\n<div class='norender'><code>\n// The following short XML file called \"mammals.xml\" is parsed\n// in the code below.\n//\n// <?xml version=\"1.0\"?>\n// &lt;mammals&gt;\n//   &lt;animal id=\"0\" species=\"Capra hircus\">Goat&lt;/animal&gt;\n//   &lt;animal id=\"1\" species=\"Panthera pardus\">Leopard&lt;/animal&gt;\n//   &lt;animal id=\"2\" species=\"Equus zebra\">Zebra&lt;/animal&gt;\n// &lt;/mammals&gt;\n\nvar xml;\n\nfunction preload() {\n  xml = loadXML('assets/mammals.xml');\n}\n\nfunction setup() {\n  var firstChild = xml.getChild('animal');\n  print(firstChild.listAttributes());\n}\n\n// Sketch prints:\n// [\"id\", \"species\"]\n</code></div>"
            ],
            "class": "p5.XML",
            "module": "IO",
            "submodule": "XML"
        },
        {
            "file": "src/io/p5.XML.js",
            "line": 523,
            "description": "<p>Checks whether or not an element has the specified attribute.</p>\n",
            "itemtype": "method",
            "name": "hasAttribute",
            "params": [
                {
                    "name": "the",
                    "description": "<p>attribute to be checked</p>\n",
                    "type": "String"
                }
            ],
            "return": {
                "description": "true if attribute found else false",
                "type": "Boolean"
            },
            "example": [
                "\n <div class='norender'><code>\n // The following short XML file called \"mammals.xml\" is parsed\n // in the code below.\n //\n // <?xml version=\"1.0\"?>\n // &lt;mammals&gt;\n //   &lt;animal id=\"0\" species=\"Capra hircus\">Goat&lt;/animal&gt;\n //   &lt;animal id=\"1\" species=\"Panthera pardus\">Leopard&lt;/animal&gt;\n //   &lt;animal id=\"2\" species=\"Equus zebra\">Zebra&lt;/animal&gt;\n // &lt;/mammals&gt;\n\n var xml;\n\n function preload() {\n xml = loadXML('assets/mammals.xml');\n }\n\n function setup() {\n var firstChild = xml.getChild('animal');\n print(firstChild.hasAttribute('species'));\n print(firstChild.hasAttribute('color'));\n }\n\n // Sketch prints:\n // true\n // false\n </code></div>"
            ],
            "class": "p5.XML",
            "module": "IO",
            "submodule": "XML"
        },
        {
            "file": "src/io/p5.XML.js",
            "line": 562,
            "description": "<p>Returns an attribute value of the element as an Number. If the defaultValue\nparameter is specified and the attribute doesn&#39;t exist, then defaultValue\nis returned. If no defaultValue is specified and the attribute doesn&#39;t\nexist, the value 0 is returned.</p>\n",
            "itemtype": "method",
            "name": "getNum",
            "params": [
                {
                    "name": "name",
                    "description": "<p>the non-null full name of the attribute</p>\n",
                    "type": "String"
                },
                {
                    "name": "defaultValue",
                    "description": "<p>the default value of the attribute</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "return": {
                "description": "",
                "type": "Number"
            },
            "example": [
                "\n<div class='norender'><code>\n// The following short XML file called \"mammals.xml\" is parsed\n// in the code below.\n//\n// <?xml version=\"1.0\"?>\n// &lt;mammals&gt;\n//   &lt;animal id=\"0\" species=\"Capra hircus\">Goat&lt;/animal&gt;\n//   &lt;animal id=\"1\" species=\"Panthera pardus\">Leopard&lt;/animal&gt;\n//   &lt;animal id=\"2\" species=\"Equus zebra\">Zebra&lt;/animal&gt;\n// &lt;/mammals&gt;\n\nvar xml;\n\nfunction preload() {\n  xml = loadXML('assets/mammals.xml');\n}\n\nfunction setup() {\n  var firstChild = xml.getChild('animal');\n  print(firstChild.getNum('id'));\n}\n\n// Sketch prints:\n// 0\n</code></div>"
            ],
            "class": "p5.XML",
            "module": "IO",
            "submodule": "XML"
        },
        {
            "file": "src/io/p5.XML.js",
            "line": 603,
            "description": "<p>Returns an attribute value of the element as an String. If the defaultValue\nparameter is specified and the attribute doesn&#39;t exist, then defaultValue\nis returned. If no defaultValue is specified and the attribute doesn&#39;t\nexist, null is returned.</p>\n",
            "itemtype": "method",
            "name": "getString",
            "params": [
                {
                    "name": "name",
                    "description": "<p>the non-null full name of the attribute</p>\n",
                    "type": "String"
                },
                {
                    "name": "defaultValue",
                    "description": "<p>the default value of the attribute</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "return": {
                "description": "",
                "type": "Number"
            },
            "example": [
                "\n<div class='norender'><code>\n// The following short XML file called \"mammals.xml\" is parsed\n// in the code below.\n//\n// <?xml version=\"1.0\"?>\n// &lt;mammals&gt;\n//   &lt;animal id=\"0\" species=\"Capra hircus\">Goat&lt;/animal&gt;\n//   &lt;animal id=\"1\" species=\"Panthera pardus\">Leopard&lt;/animal&gt;\n//   &lt;animal id=\"2\" species=\"Equus zebra\">Zebra&lt;/animal&gt;\n// &lt;/mammals&gt;\n\nvar xml;\n\nfunction preload() {\n  xml = loadXML('assets/mammals.xml');\n}\n\nfunction setup() {\n  var firstChild = xml.getChild('animal');\n  print(firstChild.getString('species'));\n}\n\n// Sketch prints:\n// \"Capra hircus\"\n</code></div>"
            ],
            "class": "p5.XML",
            "module": "IO",
            "submodule": "XML"
        },
        {
            "file": "src/io/p5.XML.js",
            "line": 644,
            "description": "<p>Sets the content of an element&#39;s attribute. The first parameter specifies\nthe attribute name, while the second specifies the new content.</p>\n",
            "itemtype": "method",
            "name": "setAttribute",
            "params": [
                {
                    "name": "name",
                    "description": "<p>the full name of the attribute</p>\n",
                    "type": "String"
                },
                {
                    "name": "value",
                    "description": "<p>the value of the attribute</p>\n",
                    "type": "Number"
                }
            ],
            "example": [
                "\n<div class='norender'><code>\n// The following short XML file called \"mammals.xml\" is parsed\n// in the code below.\n//\n// <?xml version=\"1.0\"?>\n// &lt;mammals&gt;\n//   &lt;animal id=\"0\" species=\"Capra hircus\">Goat&lt;/animal&gt;\n//   &lt;animal id=\"1\" species=\"Panthera pardus\">Leopard&lt;/animal&gt;\n//   &lt;animal id=\"2\" species=\"Equus zebra\">Zebra&lt;/animal&gt;\n// &lt;/mammals&gt;\n\nvar xml;\n\nfunction preload() {\n  xml = loadXML('assets/mammals.xml');\n}\n\nfunction setup() {\n  var firstChild = xml.getChild('animal');\n  print(firstChild.getString('species'));\n  firstChild.setAttribute('species', 'Jamides zebra');\n  print(firstChild.getString('species'));\n}\n\n// Sketch prints:\n// \"Capra hircus\"\n// \"Jamides zebra\"\n</code></div>"
            ],
            "class": "p5.XML",
            "module": "IO",
            "submodule": "XML"
        },
        {
            "file": "src/io/p5.XML.js",
            "line": 687,
            "description": "<p>Returns the content of an element. If there is no such content,\ndefaultValue is returned if specified, otherwise null is returned.</p>\n",
            "itemtype": "method",
            "name": "getContent",
            "params": [
                {
                    "name": "defaultValue",
                    "description": "<p>value returned if no content is found</p>\n",
                    "type": "String",
                    "optional": true
                }
            ],
            "return": {
                "description": "",
                "type": "String"
            },
            "example": [
                "\n<div class='norender'><code>\n// The following short XML file called \"mammals.xml\" is parsed\n// in the code below.\n//\n// <?xml version=\"1.0\"?>\n// &lt;mammals&gt;\n//   &lt;animal id=\"0\" species=\"Capra hircus\">Goat&lt;/animal&gt;\n//   &lt;animal id=\"1\" species=\"Panthera pardus\">Leopard&lt;/animal&gt;\n//   &lt;animal id=\"2\" species=\"Equus zebra\">Zebra&lt;/animal&gt;\n// &lt;/mammals&gt;\n\nvar xml;\n\nfunction preload() {\n  xml = loadXML('assets/mammals.xml');\n}\n\nfunction setup() {\n  var firstChild = xml.getChild('animal');\n  print(firstChild.getContent());\n}\n\n// Sketch prints:\n// \"Goat\"\n</code></div>"
            ],
            "class": "p5.XML",
            "module": "IO",
            "submodule": "XML"
        },
        {
            "file": "src/io/p5.XML.js",
            "line": 725,
            "description": "<p>Sets the element&#39;s content.</p>\n",
            "itemtype": "method",
            "name": "setContent",
            "params": [
                {
                    "name": "text",
                    "description": "<p>the new content</p>\n",
                    "type": "String"
                }
            ],
            "example": [
                "\n<div class='norender'><code>\n// The following short XML file called \"mammals.xml\" is parsed\n// in the code below.\n//\n// <?xml version=\"1.0\"?>\n// &lt;mammals&gt;\n//   &lt;animal id=\"0\" species=\"Capra hircus\">Goat&lt;/animal&gt;\n//   &lt;animal id=\"1\" species=\"Panthera pardus\">Leopard&lt;/animal&gt;\n//   &lt;animal id=\"2\" species=\"Equus zebra\">Zebra&lt;/animal&gt;\n// &lt;/mammals&gt;\n\nvar xml;\n\nfunction preload() {\n  xml = loadXML('assets/mammals.xml');\n}\n\nfunction setup() {\n  var firstChild = xml.getChild('animal');\n  print(firstChild.getContent());\n  firstChild.setContent('Mountain Goat');\n  print(firstChild.getContent());\n}\n\n// Sketch prints:\n// \"Goat\"\n// \"Mountain Goat\"\n</code></div>"
            ],
            "class": "p5.XML",
            "module": "IO",
            "submodule": "XML"
        },
        {
            "file": "src/io/p5.XML.js",
            "line": 767,
            "description": "<p>This method is called while the parsing of XML (when loadXML() is\ncalled). The difference between this method and the setContent()\nmethod defined later is that this one is used to set the content\nwhen the node in question has more nodes under it and so on and\nnot directly text content. While in the other one is used when\nthe node in question directly has text inside it.</p>\n",
            "class": "p5.XML",
            "module": "IO",
            "submodule": "XML"
        },
        {
            "file": "src/io/p5.XML.js",
            "line": 784,
            "description": "<p>This method is called while the parsing of XML (when loadXML() is\ncalled). The XML node is passed and its attributes are stored in the\np5.XML&#39;s attribute Object.</p>\n",
            "class": "p5.XML",
            "module": "IO",
            "submodule": "XML"
        },
        {
            "file": "src/math/calculation.js",
            "line": 12,
            "description": "<p>Calculates the absolute value (magnitude) of a number. Maps to Math.abs().\nThe absolute value of a number is always positive.</p>\n",
            "itemtype": "method",
            "name": "abs",
            "params": [
                {
                    "name": "n",
                    "description": "<p>number to compute</p>\n",
                    "type": "Number"
                }
            ],
            "return": {
                "description": "absolute value of given number",
                "type": "Number"
            },
            "example": [
                "\n<div class = \"norender\"><code>\nfunction setup() {\n  var x = -3;\n  var y = abs(x);\n\n  print(x); // -3\n  print(y); // 3\n}\n</code></div>"
            ],
            "alt": "no image displayed",
            "class": "p5",
            "module": "Math",
            "submodule": "Calculation"
        },
        {
            "file": "src/math/calculation.js",
            "line": 36,
            "description": "<p>Calculates the closest int value that is greater than or equal to the\nvalue of the parameter. Maps to Math.ceil(). For example, ceil(9.03)\nreturns the value 10.</p>\n",
            "itemtype": "method",
            "name": "ceil",
            "params": [
                {
                    "name": "n",
                    "description": "<p>number to round up</p>\n",
                    "type": "Number"
                }
            ],
            "return": {
                "description": "rounded up number",
                "type": "Integer"
            },
            "example": [
                "\n<div><code>\nfunction draw() {\n  background(200);\n  // map, mouseX between 0 and 5.\n  var ax = map(mouseX, 0, 100, 0, 5);\n  var ay = 66;\n\n  //Get the ceiling of the mapped number.\n  var bx = ceil(map(mouseX, 0, 100, 0, 5));\n  var by = 33;\n\n  // Multiply the mapped numbers by 20 to more easily\n  // see the changes.\n  stroke(0);\n  fill(0);\n  line(0, ay, ax * 20, ay);\n  line(0, by, bx * 20, by);\n\n  // Reformat the float returned by map and draw it.\n  noStroke();\n  text(nfc(ax, 2), ax, ay - 5);\n  text(nfc(bx, 1), bx, by - 5);\n}\n</code></div>"
            ],
            "alt": "2 horizontal lines & number sets. increase with mouse x. bottom to 2 decimals",
            "class": "p5",
            "module": "Math",
            "submodule": "Calculation"
        },
        {
            "file": "src/math/calculation.js",
            "line": 76,
            "description": "<p>Constrains a value between a minimum and maximum value.</p>\n",
            "itemtype": "method",
            "name": "constrain",
            "params": [
                {
                    "name": "n",
                    "description": "<p>number to constrain</p>\n",
                    "type": "Number"
                },
                {
                    "name": "low",
                    "description": "<p>minimum limit</p>\n",
                    "type": "Number"
                },
                {
                    "name": "high",
                    "description": "<p>maximum limit</p>\n",
                    "type": "Number"
                }
            ],
            "return": {
                "description": "constrained number",
                "type": "Number"
            },
            "example": [
                "\n<div><code>\nfunction draw() {\n  background(200);\n\n  var leftWall = 25;\n  var rightWall = 75;\n\n  // xm is just the mouseX, while\n  // xc is the mouseX, but constrained\n  // between the leftWall and rightWall!\n  var xm = mouseX;\n  var xc = constrain(mouseX, leftWall, rightWall);\n\n  // Draw the walls.\n  stroke(150);\n  line(leftWall, 0, leftWall, height);\n  line(rightWall, 0, rightWall, height);\n\n  // Draw xm and xc as circles.\n  noStroke();\n  fill(150);\n  ellipse(xm, 33, 9, 9); // Not Constrained\n  fill(0);\n  ellipse(xc, 66, 9, 9); // Constrained\n}\n</code></div>"
            ],
            "alt": "2 vertical lines. 2 ellipses move with mouse X 1 does not move passed lines",
            "class": "p5",
            "module": "Math",
            "submodule": "Calculation"
        },
        {
            "file": "src/math/calculation.js",
            "line": 121,
            "description": "<p>Calculates the distance between two points.</p>\n",
            "itemtype": "method",
            "name": "dist",
            "return": {
                "description": "distance between the two points",
                "type": "Number"
            },
            "example": [
                "\n<div><code>\n// Move your mouse inside the canvas to see the\n// change in distance between two points!\nfunction draw() {\n  background(200);\n  fill(0);\n\n  var x1 = 10;\n  var y1 = 90;\n  var x2 = mouseX;\n  var y2 = mouseY;\n\n  line(x1, y1, x2, y2);\n  ellipse(x1, y1, 7, 7);\n  ellipse(x2, y2, 7, 7);\n\n  // d is the length of the line\n  // the distance from point 1 to point 2.\n  var d = int(dist(x1, y1, x2, y2));\n\n  // Let's write d along the line we are drawing!\n  push();\n  translate((x1 + x2) / 2, (y1 + y2) / 2);\n  rotate(atan2(y2 - y1, x2 - x1));\n  text(nfc(d, 1), 0, -5);\n  pop();\n  // Fancy!\n}\n</code></div>"
            ],
            "alt": "2 ellipses joined by line. 1 ellipse moves with mouse X&Y. Distance displayed.",
            "class": "p5",
            "module": "Math",
            "submodule": "Calculation",
            "overloads": [
                {
                    "line": 121,
                    "params": [
                        {
                            "name": "x1",
                            "description": "<p>x-coordinate of the first point</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "y1",
                            "description": "<p>y-coordinate of the first point</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "x2",
                            "description": "<p>x-coordinate of the second point</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "y2",
                            "description": "<p>y-coordinate of the second point</p>\n",
                            "type": "Number"
                        }
                    ],
                    "return": {
                        "description": "distance between the two points",
                        "type": "Number"
                    }
                },
                {
                    "line": 165,
                    "params": [
                        {
                            "name": "x1",
                            "description": "",
                            "type": "Number"
                        },
                        {
                            "name": "y1",
                            "description": "",
                            "type": "Number"
                        },
                        {
                            "name": "z1",
                            "description": "<p>z-coordinate of the first point</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "x2",
                            "description": "",
                            "type": "Number"
                        },
                        {
                            "name": "y2",
                            "description": "",
                            "type": "Number"
                        },
                        {
                            "name": "z2",
                            "description": "<p>z-coordinate of the second point</p>\n",
                            "type": "Number"
                        }
                    ],
                    "return": {
                        "description": "distance between the two points",
                        "type": "Number"
                    }
                }
            ]
        },
        {
            "file": "src/math/calculation.js",
            "line": 190,
            "description": "<p>Returns Euler&#39;s number e (2.71828...) raised to the power of the n\nparameter. Maps to Math.exp().</p>\n",
            "itemtype": "method",
            "name": "exp",
            "params": [
                {
                    "name": "n",
                    "description": "<p>exponent to raise</p>\n",
                    "type": "Number"
                }
            ],
            "return": {
                "description": "e^n",
                "type": "Number"
            },
            "example": [
                "\n<div><code>\nfunction draw() {\n  background(200);\n\n  // Compute the exp() function with a value between 0 and 2\n  var xValue = map(mouseX, 0, width, 0, 2);\n  var yValue = exp(xValue);\n\n  var y = map(yValue, 0, 8, height, 0);\n\n  var legend = 'exp (' + nfc(xValue, 3) + ')\\n= ' + nf(yValue, 1, 4);\n  stroke(150);\n  line(mouseX, y, mouseX, height);\n  fill(0);\n  text(legend, 5, 15);\n  noStroke();\n  ellipse(mouseX, y, 7, 7);\n\n  // Draw the exp(x) curve,\n  // over the domain of x from 0 to 2\n  noFill();\n  stroke(0);\n  beginShape();\n  for (var x = 0; x < width; x++) {\n    xValue = map(x, 0, width, 0, 2);\n    yValue = exp(xValue);\n    y = map(yValue, 0, 8, height, 0);\n    vertex(x, y);\n  }\n\n  endShape();\n  line(0, 0, 0, height);\n  line(0, height - 1, width, height - 1);\n}\n</code></div>"
            ],
            "alt": "ellipse moves along a curve with mouse x. e^n displayed.",
            "class": "p5",
            "module": "Math",
            "submodule": "Calculation"
        },
        {
            "file": "src/math/calculation.js",
            "line": 240,
            "description": "<p>Calculates the closest int value that is less than or equal to the\nvalue of the parameter. Maps to Math.floor().</p>\n",
            "itemtype": "method",
            "name": "floor",
            "params": [
                {
                    "name": "n",
                    "description": "<p>number to round down</p>\n",
                    "type": "Number"
                }
            ],
            "return": {
                "description": "rounded down number",
                "type": "Integer"
            },
            "example": [
                "\n<div><code>\nfunction draw() {\n  background(200);\n  //map, mouseX between 0 and 5.\n  var ax = map(mouseX, 0, 100, 0, 5);\n  var ay = 66;\n\n  //Get the floor of the mapped number.\n  var bx = floor(map(mouseX, 0, 100, 0, 5));\n  var by = 33;\n\n  // Multiply the mapped numbers by 20 to more easily\n  // see the changes.\n  stroke(0);\n  fill(0);\n  line(0, ay, ax * 20, ay);\n  line(0, by, bx * 20, by);\n\n  // Reformat the float returned by map and draw it.\n  noStroke();\n  text(nfc(ax, 2), ax, ay - 5);\n  text(nfc(bx, 1), bx, by - 5);\n}\n</code></div>"
            ],
            "alt": "2 horizontal lines & number sets. increase with mouse x. bottom to 2 decimals",
            "class": "p5",
            "module": "Math",
            "submodule": "Calculation"
        },
        {
            "file": "src/math/calculation.js",
            "line": 279,
            "description": "<p>Calculates a number between two numbers at a specific increment. The amt\nparameter is the amount to interpolate between the two values where 0.0\nequal to the first point, 0.1 is very near the first point, 0.5 is\nhalf-way in between, etc. The lerp function is convenient for creating\nmotion along a straight path and for drawing dotted lines.</p>\n",
            "itemtype": "method",
            "name": "lerp",
            "params": [
                {
                    "name": "start",
                    "description": "<p>first value</p>\n",
                    "type": "Number"
                },
                {
                    "name": "stop",
                    "description": "<p>second value</p>\n",
                    "type": "Number"
                },
                {
                    "name": "amt",
                    "description": "<p>number between 0.0 and 1.0</p>\n",
                    "type": "Number"
                }
            ],
            "return": {
                "description": "lerped value",
                "type": "Number"
            },
            "example": [
                "\n<div><code>\nfunction setup() {\n  background(200);\n  var a = 20;\n  var b = 80;\n  var c = lerp(a, b, 0.2);\n  var d = lerp(a, b, 0.5);\n  var e = lerp(a, b, 0.8);\n\n  var y = 50;\n\n  strokeWeight(5);\n  stroke(0); // Draw the original points in black\n  point(a, y);\n  point(b, y);\n\n  stroke(100); // Draw the lerp points in gray\n  point(c, y);\n  point(d, y);\n  point(e, y);\n}\n</code></div>"
            ],
            "alt": "5 points horizontally staggered mid-canvas. mid 3 are grey, outer black",
            "class": "p5",
            "module": "Math",
            "submodule": "Calculation"
        },
        {
            "file": "src/math/calculation.js",
            "line": 324,
            "description": "<p>Calculates the natural logarithm (the base-e logarithm) of a number. This\nfunction expects the n parameter to be a value greater than 0.0. Maps to\nMath.log().</p>\n",
            "itemtype": "method",
            "name": "log",
            "params": [
                {
                    "name": "n",
                    "description": "<p>number greater than 0</p>\n",
                    "type": "Number"
                }
            ],
            "return": {
                "description": "natural logarithm of n",
                "type": "Number"
            },
            "example": [
                "\n<div><code>\nfunction draw() {\n  background(200);\n  var maxX = 2.8;\n  var maxY = 1.5;\n\n  // Compute the natural log of a value between 0 and maxX\n  var xValue = map(mouseX, 0, width, 0, maxX);\n  if (xValue > 0) {\n   // Cannot take the log of a negative number.\n    var yValue = log(xValue);\n    var y = map(yValue, -maxY, maxY, height, 0);\n\n    // Display the calculation occurring.\n    var legend = 'log(' + nf(xValue, 1, 2) + ')\\n= ' + nf(yValue, 1, 3);\n    stroke(150);\n    line(mouseX, y, mouseX, height);\n    fill(0);\n    text(legend, 5, 15);\n    noStroke();\n    ellipse(mouseX, y, 7, 7);\n  }\n\n  // Draw the log(x) curve,\n  // over the domain of x from 0 to maxX\n  noFill();\n  stroke(0);\n  beginShape();\n  for (var x = 0; x < width; x++) {\n    xValue = map(x, 0, width, 0, maxX);\n    yValue = log(xValue);\n    y = map(yValue, -maxY, maxY, height, 0);\n    vertex(x, y);\n  }\n  endShape();\n  line(0, 0, 0, height);\n  line(0, height / 2, width, height / 2);\n}\n</code></div>"
            ],
            "alt": "ellipse moves along a curve with mouse x. natural logarithm of n displayed.",
            "class": "p5",
            "module": "Math",
            "submodule": "Calculation"
        },
        {
            "file": "src/math/calculation.js",
            "line": 379,
            "description": "<p>Calculates the magnitude (or length) of a vector. A vector is a direction\nin space commonly used in computer graphics and linear algebra. Because it\nhas no &quot;start&quot; position, the magnitude of a vector can be thought of as\nthe distance from the coordinate 0,0 to its x,y value. Therefore, mag() is\na shortcut for writing dist(0, 0, x, y).</p>\n",
            "itemtype": "method",
            "name": "mag",
            "params": [
                {
                    "name": "a",
                    "description": "<p>first value</p>\n",
                    "type": "Number"
                },
                {
                    "name": "b",
                    "description": "<p>second value</p>\n",
                    "type": "Number"
                }
            ],
            "return": {
                "description": "magnitude of vector from (0,0) to (a,b)",
                "type": "Number"
            },
            "example": [
                "\n<div><code>\nfunction setup() {\n  var x1 = 20;\n  var x2 = 80;\n  var y1 = 30;\n  var y2 = 70;\n\n  line(0, 0, x1, y1);\n  print(mag(x1, y1)); // Prints \"36.05551275463989\"\n  line(0, 0, x2, y1);\n  print(mag(x2, y1)); // Prints \"85.44003745317531\"\n  line(0, 0, x1, y2);\n  print(mag(x1, y2)); // Prints \"72.80109889280519\"\n  line(0, 0, x2, y2);\n  print(mag(x2, y2)); // Prints \"106.3014581273465\"\n}\n</code></div>"
            ],
            "alt": "4 lines of different length radiate from top left of canvas.",
            "class": "p5",
            "module": "Math",
            "submodule": "Calculation"
        },
        {
            "file": "src/math/calculation.js",
            "line": 418,
            "description": "<p>Re-maps a number from one range to another.\n<br><br>\nIn the first example above, the number 25 is converted from a value in the\nrange of 0 to 100 into a value that ranges from the left edge of the\nwindow (0) to the right edge (width).</p>\n",
            "itemtype": "method",
            "name": "map",
            "params": [
                {
                    "name": "value",
                    "description": "<p>the incoming value to be converted</p>\n",
                    "type": "Number"
                },
                {
                    "name": "start1",
                    "description": "<p>lower bound of the value&#39;s current range</p>\n",
                    "type": "Number"
                },
                {
                    "name": "stop1",
                    "description": "<p>upper bound of the value&#39;s current range</p>\n",
                    "type": "Number"
                },
                {
                    "name": "start2",
                    "description": "<p>lower bound of the value&#39;s target range</p>\n",
                    "type": "Number"
                },
                {
                    "name": "stop2",
                    "description": "<p>upper bound of the value&#39;s target range</p>\n",
                    "type": "Number"
                },
                {
                    "name": "withinBounds",
                    "description": "<p>constrain the value to the newly mapped range</p>\n",
                    "type": "Boolean",
                    "optional": true
                }
            ],
            "return": {
                "description": "remapped number",
                "type": "Number"
            },
            "example": [
                "\n  <div><code>\nvar value = 25;\nvar m = map(value, 0, 100, 0, width);\nellipse(m, 50, 10, 10);\n</code></div>\n\n  <div><code>\nfunction setup() {\n  noStroke();\n}\n\nfunction draw() {\n  background(204);\n  var x1 = map(mouseX, 0, width, 25, 75);\n  ellipse(x1, 25, 25, 25);\n  //This ellipse is constrained to the 0-100 range\n  //after setting withinBounds to true\n  var x2 = map(mouseX, 0, width, 0, 100, true);\n  ellipse(x2, 75, 25, 25);\n}\n</code></div>"
            ],
            "alt": "10 by 10 white ellipse with in mid left canvas\n2 25 by 25 white ellipses move with mouse x. Bottom has more range from X",
            "class": "p5",
            "module": "Math",
            "submodule": "Calculation"
        },
        {
            "file": "src/math/calculation.js",
            "line": 474,
            "description": "<p>Determines the largest value in a sequence of numbers, and then returns\nthat value. max() accepts any number of Number parameters, or an Array\nof any length.</p>\n",
            "itemtype": "method",
            "name": "max",
            "return": {
                "description": "maximum Number",
                "type": "Number"
            },
            "example": [
                "\n<div><code>\nfunction setup() {\n  // Change the elements in the array and run the sketch\n  // to show how max() works!\n  var numArray = [2, 1, 5, 4, 8, 9];\n  fill(0);\n  noStroke();\n  text('Array Elements', 0, 10);\n  // Draw all numbers in the array\n  var spacing = 15;\n  var elemsY = 25;\n  for (var i = 0; i < numArray.length; i++) {\n    text(numArray[i], i * spacing, elemsY);\n  }\n  var maxX = 33;\n  var maxY = 80;\n  // Draw the Maximum value in the array.\n  textSize(32);\n  text(max(numArray), maxX, maxY);\n}\n</code></div>"
            ],
            "alt": "Small text at top reads: Array Elements 2 1 5 4 8 9. Large text at center: 9",
            "class": "p5",
            "module": "Math",
            "submodule": "Calculation",
            "overloads": [
                {
                    "line": 474,
                    "params": [
                        {
                            "name": "n0",
                            "description": "<p>Number to compare</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "n1",
                            "description": "<p>Number to compare</p>\n",
                            "type": "Number"
                        }
                    ],
                    "return": {
                        "description": "maximum Number",
                        "type": "Number"
                    }
                },
                {
                    "line": 510,
                    "params": [
                        {
                            "name": "nums",
                            "description": "<p>Numbers to compare</p>\n",
                            "type": "Number[]"
                        }
                    ],
                    "return": {
                        "description": "",
                        "type": "Number"
                    }
                }
            ]
        },
        {
            "file": "src/math/calculation.js",
            "line": 524,
            "description": "<p>Determines the smallest value in a sequence of numbers, and then returns\nthat value. min() accepts any number of Number parameters, or an Array\nof any length.</p>\n",
            "itemtype": "method",
            "name": "min",
            "return": {
                "description": "minimum Number",
                "type": "Number"
            },
            "example": [
                "\n<div><code>\nfunction setup() {\n  // Change the elements in the array and run the sketch\n  // to show how min() works!\n  var numArray = [2, 1, 5, 4, 8, 9];\n  fill(0);\n  noStroke();\n  text('Array Elements', 0, 10);\n  // Draw all numbers in the array\n  var spacing = 15;\n  var elemsY = 25;\n  for (var i = 0; i < numArray.length; i++) {\n    text(numArray[i], i * spacing, elemsY);\n  }\n  var maxX = 33;\n  var maxY = 80;\n  // Draw the Minimum value in the array.\n  textSize(32);\n  text(min(numArray), maxX, maxY);\n}\n</code></div>"
            ],
            "alt": "Small text at top reads: Array Elements 2 1 5 4 8 9. Large text at center: 1",
            "class": "p5",
            "module": "Math",
            "submodule": "Calculation",
            "overloads": [
                {
                    "line": 524,
                    "params": [
                        {
                            "name": "n0",
                            "description": "<p>Number to compare</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "n1",
                            "description": "<p>Number to compare</p>\n",
                            "type": "Number"
                        }
                    ],
                    "return": {
                        "description": "minimum Number",
                        "type": "Number"
                    }
                },
                {
                    "line": 560,
                    "params": [
                        {
                            "name": "nums",
                            "description": "<p>Numbers to compare</p>\n",
                            "type": "Number[]"
                        }
                    ],
                    "return": {
                        "description": "",
                        "type": "Number"
                    }
                }
            ]
        },
        {
            "file": "src/math/calculation.js",
            "line": 574,
            "description": "<p>Normalizes a number from another range into a value between 0 and 1.\nIdentical to map(value, low, high, 0, 1).\nNumbers outside of the range are not clamped to 0 and 1, because\nout-of-range values are often intentional and useful. (See the second\nexample above.)</p>\n",
            "itemtype": "method",
            "name": "norm",
            "params": [
                {
                    "name": "value",
                    "description": "<p>incoming value to be normalized</p>\n",
                    "type": "Number"
                },
                {
                    "name": "start",
                    "description": "<p>lower bound of the value&#39;s current range</p>\n",
                    "type": "Number"
                },
                {
                    "name": "stop",
                    "description": "<p>upper bound of the value&#39;s current range</p>\n",
                    "type": "Number"
                }
            ],
            "return": {
                "description": "normalized number",
                "type": "Number"
            },
            "example": [
                "\n<div><code>\nfunction draw() {\n  background(200);\n  var currentNum = mouseX;\n  var lowerBound = 0;\n  var upperBound = width; //100;\n  var normalized = norm(currentNum, lowerBound, upperBound);\n  var lineY = 70;\n  line(0, lineY, width, lineY);\n  //Draw an ellipse mapped to the non-normalized value.\n  noStroke();\n  fill(50);\n  var s = 7; // ellipse size\n  ellipse(currentNum, lineY, s, s);\n\n  // Draw the guide\n  var guideY = lineY + 15;\n  text('0', 0, guideY);\n  textAlign(RIGHT);\n  text('100', width, guideY);\n\n  // Draw the normalized value\n  textAlign(LEFT);\n  fill(0);\n  textSize(32);\n  var normalY = 40;\n  var normalX = 20;\n  text(normalized, normalX, normalY);\n}\n</code></div>"
            ],
            "alt": "ellipse moves with mouse. 0 shown left & 100 right and updating values center",
            "class": "p5",
            "module": "Math",
            "submodule": "Calculation"
        },
        {
            "file": "src/math/calculation.js",
            "line": 627,
            "description": "<p>Facilitates exponential expressions. The pow() function is an efficient\nway of multiplying numbers by themselves (or their reciprocals) in large\nquantities. For example, pow(3, 5) is equivalent to the expression\n3<em>3</em>3<em>3</em>3 and pow(3, -5) is equivalent to 1 / 3<em>3</em>3<em>3</em>3. Maps to\nMath.pow().</p>\n",
            "itemtype": "method",
            "name": "pow",
            "params": [
                {
                    "name": "n",
                    "description": "<p>base of the exponential expression</p>\n",
                    "type": "Number"
                },
                {
                    "name": "e",
                    "description": "<p>power by which to raise the base</p>\n",
                    "type": "Number"
                }
            ],
            "return": {
                "description": "n^e",
                "type": "Number"
            },
            "example": [
                "\n<div><code>\nfunction setup() {\n  //Exponentially increase the size of an ellipse.\n  var eSize = 3; // Original Size\n  var eLoc = 10; // Original Location\n\n  ellipse(eLoc, eLoc, eSize, eSize);\n\n  ellipse(eLoc * 2, eLoc * 2, pow(eSize, 2), pow(eSize, 2));\n\n  ellipse(eLoc * 4, eLoc * 4, pow(eSize, 3), pow(eSize, 3));\n\n  ellipse(eLoc * 8, eLoc * 8, pow(eSize, 4), pow(eSize, 4));\n}\n</code></div>"
            ],
            "alt": "small to large ellipses radiating from top left of canvas",
            "class": "p5",
            "module": "Math",
            "submodule": "Calculation"
        },
        {
            "file": "src/math/calculation.js",
            "line": 661,
            "description": "<p>Calculates the integer closest to the n parameter. For example,\nround(133.8) returns the value 134. Maps to Math.round().</p>\n",
            "itemtype": "method",
            "name": "round",
            "params": [
                {
                    "name": "n",
                    "description": "<p>number to round</p>\n",
                    "type": "Number"
                }
            ],
            "return": {
                "description": "rounded number",
                "type": "Integer"
            },
            "example": [
                "\n<div><code>\nfunction draw() {\n  background(200);\n  //map, mouseX between 0 and 5.\n  var ax = map(mouseX, 0, 100, 0, 5);\n  var ay = 66;\n\n  // Round the mapped number.\n  var bx = round(map(mouseX, 0, 100, 0, 5));\n  var by = 33;\n\n  // Multiply the mapped numbers by 20 to more easily\n  // see the changes.\n  stroke(0);\n  fill(0);\n  line(0, ay, ax * 20, ay);\n  line(0, by, bx * 20, by);\n\n  // Reformat the float returned by map and draw it.\n  noStroke();\n  text(nfc(ax, 2), ax, ay - 5);\n  text(nfc(bx, 1), bx, by - 5);\n}\n</code></div>"
            ],
            "alt": "horizontal center line squared values displayed on top and regular on bottom.",
            "class": "p5",
            "module": "Math",
            "submodule": "Calculation"
        },
        {
            "file": "src/math/calculation.js",
            "line": 700,
            "description": "<p>Squares a number (multiplies a number by itself). The result is always a\npositive number, as multiplying two negative numbers always yields a\npositive result. For example, -1 * -1 = 1.</p>\n",
            "itemtype": "method",
            "name": "sq",
            "params": [
                {
                    "name": "n",
                    "description": "<p>number to square</p>\n",
                    "type": "Number"
                }
            ],
            "return": {
                "description": "squared number",
                "type": "Number"
            },
            "example": [
                "\n<div><code>\nfunction draw() {\n  background(200);\n  var eSize = 7;\n  var x1 = map(mouseX, 0, width, 0, 10);\n  var y1 = 80;\n  var x2 = sq(x1);\n  var y2 = 20;\n\n  // Draw the non-squared.\n  line(0, y1, width, y1);\n  ellipse(x1, y1, eSize, eSize);\n\n  // Draw the squared.\n  line(0, y2, width, y2);\n  ellipse(x2, y2, eSize, eSize);\n\n  // Draw dividing line.\n  stroke(100);\n  line(0, height / 2, width, height / 2);\n\n  // Draw text.\n  var spacing = 15;\n  noStroke();\n  fill(0);\n  text('x = ' + x1, 0, y1 + spacing);\n  text('sq(x) = ' + x2, 0, y2 + spacing);\n}\n</code></div>"
            ],
            "alt": "horizontal center line squared values displayed on top and regular on bottom.",
            "class": "p5",
            "module": "Math",
            "submodule": "Calculation"
        },
        {
            "file": "src/math/calculation.js",
            "line": 747,
            "description": "<p>Calculates the square root of a number. The square root of a number is\nalways positive, even though there may be a valid negative root. The\nsquare root s of number a is such that s*s = a. It is the opposite of\nsquaring. Maps to Math.sqrt().</p>\n",
            "itemtype": "method",
            "name": "sqrt",
            "params": [
                {
                    "name": "n",
                    "description": "<p>non-negative number to square root</p>\n",
                    "type": "Number"
                }
            ],
            "return": {
                "description": "square root of number",
                "type": "Number"
            },
            "example": [
                "\n<div><code>\nfunction draw() {\n  background(200);\n  var eSize = 7;\n  var x1 = mouseX;\n  var y1 = 80;\n  var x2 = sqrt(x1);\n  var y2 = 20;\n\n  // Draw the non-squared.\n  line(0, y1, width, y1);\n  ellipse(x1, y1, eSize, eSize);\n\n  // Draw the squared.\n  line(0, y2, width, y2);\n  ellipse(x2, y2, eSize, eSize);\n\n  // Draw dividing line.\n  stroke(100);\n  line(0, height / 2, width, height / 2);\n\n  // Draw text.\n  noStroke();\n  fill(0);\n  var spacing = 15;\n  text('x = ' + x1, 0, y1 + spacing);\n  text('sqrt(x) = ' + x2, 0, y2 + spacing);\n}\n</code></div>"
            ],
            "alt": "horizontal center line squareroot values displayed on top and regular on bottom.",
            "class": "p5",
            "module": "Math",
            "submodule": "Calculation"
        },
        {
            "file": "src/math/math.js",
            "line": 12,
            "description": "<p>Creates a new p5.Vector (the datatype for storing vectors). This provides a\ntwo or three dimensional vector, specifically a Euclidean (also known as\ngeometric) vector. A vector is an entity that has both magnitude and\ndirection.</p>\n",
            "itemtype": "method",
            "name": "createVector",
            "params": [
                {
                    "name": "x",
                    "description": "<p>x component of the vector</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "y",
                    "description": "<p>y component of the vector</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "z",
                    "description": "<p>z component of the vector</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "return": {
                "description": "",
                "type": "p5.Vector"
            },
            "example": [
                "\n<div modernizr='webgl'><code>\nfunction setup() {\n  createCanvas(100, 100, WEBGL);\n  noStroke();\n  fill(255, 102, 204);\n}\n\nfunction draw() {\n  background(255);\n  pointLight(color(255), createVector(sin(millis() / 1000) * 20, -40, -10));\n  scale(0.75);\n  sphere();\n}\n</code></div>"
            ],
            "alt": "a purple sphere lit by a point light oscillating horizontally",
            "class": "p5",
            "module": "Math",
            "submodule": "Math"
        },
        {
            "file": "src/math/noise.js",
            "line": 40,
            "description": "<p>Returns the Perlin noise value at specified coordinates. Perlin noise is\na random sequence generator producing a more natural ordered, harmonic\nsuccession of numbers compared to the standard <b>random()</b> function.\nIt was invented by Ken Perlin in the 1980s and been used since in\ngraphical applications to produce procedural textures, natural motion,\nshapes, terrains etc.<br /><br /> The main difference to the\n<b>random()</b> function is that Perlin noise is defined in an infinite\nn-dimensional space where each pair of coordinates corresponds to a\nfixed semi-random value (fixed only for the lifespan of the program; see\nthe noiseSeed() function). p5.js can compute 1D, 2D and 3D noise,\ndepending on the number of coordinates given. The resulting value will\nalways be between 0.0 and 1.0. The noise value can be animated by moving\nthrough the noise space as demonstrated in the example above. The 2nd\nand 3rd dimension can also be interpreted as time.<br /><br />The actual\nnoise is structured similar to an audio signal, in respect to the\nfunction&#39;s use of frequencies. Similar to the concept of harmonics in\nphysics, perlin noise is computed over several octaves which are added\ntogether for the final result. <br /><br />Another way to adjust the\ncharacter of the resulting sequence is the scale of the input\ncoordinates. As the function works within an infinite space the value of\nthe coordinates doesn&#39;t matter as such, only the distance between\nsuccessive coordinates does (eg. when using <b>noise()</b> within a\nloop). As a general rule the smaller the difference between coordinates,\nthe smoother the resulting noise sequence will be. Steps of 0.005-0.03\nwork best for most applications, but this will differ depending on use.</p>\n",
            "itemtype": "method",
            "name": "noise",
            "params": [
                {
                    "name": "x",
                    "description": "<p>x-coordinate in noise space</p>\n",
                    "type": "Number"
                },
                {
                    "name": "y",
                    "description": "<p>y-coordinate in noise space</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "z",
                    "description": "<p>z-coordinate in noise space</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "return": {
                "description": "Perlin noise value (between 0 and 1) at specified\n                     coordinates",
                "type": "Number"
            },
            "example": [
                "\n<div>\n<code>\nvar xoff = 0.0;\n\nfunction draw() {\n  background(204);\n  xoff = xoff + 0.01;\n  var n = noise(xoff) * width;\n  line(n, 0, n, height);\n}\n</code>\n</div>\n<div>\n<code>var noiseScale=0.02;\n\nfunction draw() {\n  background(0);\n  for (var x=0; x < width; x++) {\n    var noiseVal = noise((mouseX+x)*noiseScale, mouseY*noiseScale);\n    stroke(noiseVal*255);\n    line(x, mouseY+noiseVal*80, x, height);\n  }\n}\n</code>\n</div>"
            ],
            "alt": "vertical line moves left to right with updating noise values.\nhorizontal wave pattern effected by mouse x-position & updating noise values.",
            "class": "p5",
            "module": "Math",
            "submodule": "Noise"
        },
        {
            "file": "src/math/noise.js",
            "line": 187,
            "description": "<p>Adjusts the character and level of detail produced by the Perlin noise\n function. Similar to harmonics in physics, noise is computed over\n several octaves. Lower octaves contribute more to the output signal and\n as such define the overall intensity of the noise, whereas higher octaves\n create finer grained details in the noise sequence.\n <br><br>\n By default, noise is computed over 4 octaves with each octave contributing\n exactly half than its predecessor, starting at 50% strength for the 1st\n octave. This falloff amount can be changed by adding an additional function\n parameter. Eg. a falloff factor of 0.75 means each octave will now have\n 75% impact (25% less) of the previous lower octave. Any value between\n 0.0 and 1.0 is valid, however note that values greater than 0.5 might\n result in greater than 1.0 values returned by <b>noise()</b>.\n <br><br>\n By changing these parameters, the signal created by the <b>noise()</b>\n function can be adapted to fit very specific needs and characteristics.</p>\n",
            "itemtype": "method",
            "name": "noiseDetail",
            "params": [
                {
                    "name": "lod",
                    "description": "<p>number of octaves to be used by the noise</p>\n",
                    "type": "Number"
                },
                {
                    "name": "falloff",
                    "description": "<p>falloff factor for each octave</p>\n",
                    "type": "Number"
                }
            ],
            "example": [
                "\n <div>\n <code>\n var noiseVal;\n var noiseScale = 0.02;\nfunction setup() {\n   createCanvas(100, 100);\n }\nfunction draw() {\n   background(0);\n   for (var y = 0; y < height; y++) {\n     for (var x = 0; x < width / 2; x++) {\n       noiseDetail(2, 0.2);\n       noiseVal = noise((mouseX + x) * noiseScale, (mouseY + y) * noiseScale);\n       stroke(noiseVal * 255);\n       point(x, y);\n       noiseDetail(8, 0.65);\n       noiseVal = noise(\n         (mouseX + x + width / 2) * noiseScale,\n         (mouseY + y) * noiseScale\n       );\n       stroke(noiseVal * 255);\n       point(x + width / 2, y);\n     }\n   }\n }\n </code>\n </div>"
            ],
            "alt": "2 vertical grey smokey patterns affected my mouse x-position and noise.",
            "class": "p5",
            "module": "Math",
            "submodule": "Noise"
        },
        {
            "file": "src/math/noise.js",
            "line": 253,
            "description": "<p>Sets the seed value for <b>noise()</b>. By default, <b>noise()</b>\nproduces different results each time the program is run. Set the\n<b>value</b> parameter to a constant to return the same pseudo-random\nnumbers each time the software is run.</p>\n",
            "itemtype": "method",
            "name": "noiseSeed",
            "params": [
                {
                    "name": "seed",
                    "description": "<p>the seed value</p>\n",
                    "type": "Number"
                }
            ],
            "example": [
                "\n<div>\n<code>var xoff = 0.0;\n\nfunction setup() {\n  noiseSeed(99);\n  stroke(0, 10);\n}\n\nfunction draw() {\n  xoff = xoff + .01;\n  var n = noise(xoff) * width;\n  line(n, 0, n, height);\n}\n</code>\n</div>"
            ],
            "alt": "vertical grey lines drawing in pattern affected by noise.",
            "class": "p5",
            "module": "Math",
            "submodule": "Noise"
        },
        {
            "file": "src/math/p5.Vector.js",
            "line": 69,
            "description": "<p>The x component of the vector</p>\n",
            "itemtype": "property",
            "name": "x",
            "type": "Number",
            "class": "p5.Vector",
            "module": "Math",
            "submodule": "Math"
        },
        {
            "file": "src/math/p5.Vector.js",
            "line": 74,
            "description": "<p>The y component of the vector</p>\n",
            "itemtype": "property",
            "name": "y",
            "type": "Number",
            "class": "p5.Vector",
            "module": "Math",
            "submodule": "Math"
        },
        {
            "file": "src/math/p5.Vector.js",
            "line": 79,
            "description": "<p>The z component of the vector</p>\n",
            "itemtype": "property",
            "name": "z",
            "type": "Number",
            "class": "p5.Vector",
            "module": "Math",
            "submodule": "Math"
        },
        {
            "file": "src/math/p5.Vector.js",
            "line": 87,
            "description": "<p>Returns a string representation of a vector v by calling String(v)\nor v.toString(). This method is useful for logging vectors in the\nconsole.</p>\n",
            "itemtype": "method",
            "name": "toString",
            "return": {
                "description": "",
                "type": "String"
            },
            "example": [
                "\n<div class = \"norender\">\n<code>\nfunction setup() {\n  var v = createVector(20, 30);\n  print(String(v)); // prints \"p5.Vector Object : [20, 30, 0]\"\n}\n</code>\n</div>"
            ],
            "class": "p5.Vector",
            "module": "Math",
            "submodule": "Math"
        },
        {
            "file": "src/math/p5.Vector.js",
            "line": 107,
            "description": "<p>Sets the x, y, and z component of the vector using two or three separate\nvariables, the data from a p5.Vector, or the values from a float array.</p>\n",
            "itemtype": "method",
            "name": "set",
            "chainable": 1,
            "example": [
                "\n<div class=\"norender\">\n<code>\nfunction setup() {\n  var v = createVector(1, 2, 3);\n  v.set(4, 5, 6); // Sets vector to [4, 5, 6]\n\n  var v1 = createVector(0, 0, 0);\n  var arr = [1, 2, 3];\n  v1.set(arr); // Sets vector to [1, 2, 3]\n}\n</code>\n</div>"
            ],
            "class": "p5.Vector",
            "module": "Math",
            "submodule": "Math",
            "overloads": [
                {
                    "line": 107,
                    "params": [
                        {
                            "name": "x",
                            "description": "<p>the x component of the vector</p>\n",
                            "type": "Number",
                            "optional": true
                        },
                        {
                            "name": "y",
                            "description": "<p>the y component of the vector</p>\n",
                            "type": "Number",
                            "optional": true
                        },
                        {
                            "name": "z",
                            "description": "<p>the z component of the vector</p>\n",
                            "type": "Number",
                            "optional": true
                        }
                    ],
                    "chainable": 1
                },
                {
                    "line": 129,
                    "params": [
                        {
                            "name": "value",
                            "description": "<p>the vector to set</p>\n",
                            "type": "p5.Vector|Number[]"
                        }
                    ],
                    "chainable": 1
                }
            ]
        },
        {
            "file": "src/math/p5.Vector.js",
            "line": 153,
            "description": "<p>Gets a copy of the vector, returns a p5.Vector object.</p>\n",
            "itemtype": "method",
            "name": "copy",
            "return": {
                "description": "the copy of the p5.Vector object",
                "type": "p5.Vector"
            },
            "example": [
                "\n<div class=\"norender\">\n<code>\nvar v1 = createVector(1, 2, 3);\nvar v2 = v1.copy();\nprint(v1.x === v2.x && v1.y === v2.y && v1.z === v2.z);\n// Prints \"true\"\n</code>\n</div>"
            ],
            "class": "p5.Vector",
            "module": "Math",
            "submodule": "Math"
        },
        {
            "file": "src/math/p5.Vector.js",
            "line": 176,
            "description": "<p>Adds x, y, and z components to a vector, adds one vector to another, or\nadds two independent vectors together. The version of the method that adds\ntwo vectors together is a static method and returns a p5.Vector, the others\nacts directly on the vector. See the examples for more context.</p>\n",
            "itemtype": "method",
            "name": "add",
            "chainable": 1,
            "example": [
                "\n<div class=\"norender\">\n<code>\nvar v = createVector(1, 2, 3);\nv.add(4, 5, 6);\n// v's components are set to [5, 7, 9]\n</code>\n</div>\n\n<div class=\"norender\">\n<code>\n// Static method\nvar v1 = createVector(1, 2, 3);\nvar v2 = createVector(2, 3, 4);\n\nvar v3 = p5.Vector.add(v1, v2);\n// v3 has components [3, 5, 7]\nprint(v3);\n</code>\n</div>"
            ],
            "class": "p5.Vector",
            "module": "Math",
            "submodule": "Math",
            "overloads": [
                {
                    "line": 176,
                    "params": [
                        {
                            "name": "x",
                            "description": "<p>the x component of the vector to be added</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "y",
                            "description": "<p>the y component of the vector to be added</p>\n",
                            "type": "Number",
                            "optional": true
                        },
                        {
                            "name": "z",
                            "description": "<p>the z component of the vector to be added</p>\n",
                            "type": "Number",
                            "optional": true
                        }
                    ],
                    "chainable": 1
                },
                {
                    "line": 208,
                    "params": [
                        {
                            "name": "value",
                            "description": "<p>the vector to add</p>\n",
                            "type": "p5.Vector|Number[]"
                        }
                    ],
                    "chainable": 1
                },
                {
                    "line": 1035,
                    "params": [
                        {
                            "name": "v1",
                            "description": "<p>a p5.Vector to add</p>\n",
                            "type": "p5.Vector"
                        },
                        {
                            "name": "v2",
                            "description": "<p>a p5.Vector to add</p>\n",
                            "type": "p5.Vector"
                        },
                        {
                            "name": "target",
                            "description": "<p>the vector to receive the result</p>\n",
                            "type": "p5.Vector"
                        }
                    ],
                    "static": 1
                },
                {
                    "line": 1042,
                    "params": [
                        {
                            "name": "v1",
                            "description": "",
                            "type": "p5.Vector"
                        },
                        {
                            "name": "v2",
                            "description": "",
                            "type": "p5.Vector"
                        }
                    ],
                    "static": 1,
                    "return": {
                        "description": "the resulting p5.Vector",
                        "type": "p5.Vector"
                    }
                }
            ]
        },
        {
            "file": "src/math/p5.Vector.js",
            "line": 232,
            "description": "<p>Subtracts x, y, and z components from a vector, subtracts one vector from\nanother, or subtracts two independent vectors. The version of the method\nthat subtracts two vectors is a static method and returns a p5.Vector, the\nother acts directly on the vector. See the examples for more context.</p>\n",
            "itemtype": "method",
            "name": "sub",
            "chainable": 1,
            "example": [
                "\n<div class=\"norender\">\n<code>\nvar v = createVector(4, 5, 6);\nv.sub(1, 1, 1);\n// v's components are set to [3, 4, 5]\n</code>\n</div>\n\n<div class=\"norender\">\n<code>\n// Static method\nvar v1 = createVector(2, 3, 4);\nvar v2 = createVector(1, 2, 3);\n\nvar v3 = p5.Vector.sub(v1, v2);\n// v3 has components [1, 1, 1]\nprint(v3);\n</code>\n</div>"
            ],
            "class": "p5.Vector",
            "module": "Math",
            "submodule": "Math",
            "overloads": [
                {
                    "line": 232,
                    "params": [
                        {
                            "name": "x",
                            "description": "<p>the x component of the vector to subtract</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "y",
                            "description": "<p>the y component of the vector to subtract</p>\n",
                            "type": "Number",
                            "optional": true
                        },
                        {
                            "name": "z",
                            "description": "<p>the z component of the vector to subtract</p>\n",
                            "type": "Number",
                            "optional": true
                        }
                    ],
                    "chainable": 1
                },
                {
                    "line": 264,
                    "params": [
                        {
                            "name": "value",
                            "description": "<p>the vector to subtract</p>\n",
                            "type": "p5.Vector|Number[]"
                        }
                    ],
                    "chainable": 1
                },
                {
                    "line": 1065,
                    "params": [
                        {
                            "name": "v1",
                            "description": "<p>a p5.Vector to subtract from</p>\n",
                            "type": "p5.Vector"
                        },
                        {
                            "name": "v2",
                            "description": "<p>a p5.Vector to subtract</p>\n",
                            "type": "p5.Vector"
                        },
                        {
                            "name": "target",
                            "description": "<p>if undefined a new vector will be created</p>\n",
                            "type": "p5.Vector"
                        }
                    ],
                    "static": 1
                },
                {
                    "line": 1072,
                    "params": [
                        {
                            "name": "v1",
                            "description": "",
                            "type": "p5.Vector"
                        },
                        {
                            "name": "v2",
                            "description": "",
                            "type": "p5.Vector"
                        }
                    ],
                    "static": 1,
                    "return": {
                        "description": "the resulting p5.Vector",
                        "type": "p5.Vector"
                    }
                }
            ]
        },
        {
            "file": "src/math/p5.Vector.js",
            "line": 288,
            "description": "<p>Multiply the vector by a scalar. The static version of this method\ncreates a new p5.Vector while the non static version acts on the vector\ndirectly. See the examples for more context.</p>\n",
            "itemtype": "method",
            "name": "mult",
            "chainable": 1,
            "example": [
                "\n<div class=\"norender\">\n<code>\nvar v = createVector(1, 2, 3);\nv.mult(2);\n// v's components are set to [2, 4, 6]\n</code>\n</div>\n\n<div class=\"norender\">\n<code>\n// Static method\nvar v1 = createVector(1, 2, 3);\nvar v2 = p5.Vector.mult(v1, 2);\n// v2 has components [2, 4, 6]\nprint(v2);\n</code>\n</div>"
            ],
            "class": "p5.Vector",
            "module": "Math",
            "submodule": "Math",
            "overloads": [
                {
                    "line": 288,
                    "params": [
                        {
                            "name": "n",
                            "description": "<p>the number to multiply with the vector</p>\n",
                            "type": "Number"
                        }
                    ],
                    "chainable": 1
                },
                {
                    "line": 1093,
                    "params": [
                        {
                            "name": "v",
                            "description": "<p>the vector to multiply</p>\n",
                            "type": "p5.Vector"
                        },
                        {
                            "name": "n",
                            "description": "",
                            "type": "Number"
                        },
                        {
                            "name": "target",
                            "description": "<p>if undefined a new vector will be created</p>\n",
                            "type": "p5.Vector"
                        }
                    ],
                    "static": 1
                },
                {
                    "line": 1100,
                    "params": [
                        {
                            "name": "v",
                            "description": "",
                            "type": "p5.Vector"
                        },
                        {
                            "name": "n",
                            "description": "",
                            "type": "Number"
                        }
                    ],
                    "static": 1,
                    "return": {
                        "description": "the resulting new p5.Vector",
                        "type": "p5.Vector"
                    }
                }
            ]
        },
        {
            "file": "src/math/p5.Vector.js",
            "line": 329,
            "description": "<p>Divide the vector by a scalar. The static version of this method creates a\nnew p5.Vector while the non static version acts on the vector directly.\nSee the examples for more context.</p>\n",
            "itemtype": "method",
            "name": "div",
            "chainable": 1,
            "example": [
                "\n<div class=\"norender\">\n<code>\nvar v = createVector(6, 4, 2);\nv.div(2); //v's components are set to [3, 2, 1]\n</code>\n</div>\n\n<div class=\"norender\">\n<code>\n// Static method\nvar v1 = createVector(6, 4, 2);\nvar v2 = p5.Vector.div(v1, 2);\n// v2 has components [3, 2, 1]\nprint(v2);\n</code>\n</div>"
            ],
            "class": "p5.Vector",
            "module": "Math",
            "submodule": "Math",
            "overloads": [
                {
                    "line": 329,
                    "params": [
                        {
                            "name": "n",
                            "description": "<p>the number to divide the vector by</p>\n",
                            "type": "Number"
                        }
                    ],
                    "chainable": 1
                },
                {
                    "line": 1120,
                    "params": [
                        {
                            "name": "v",
                            "description": "<p>the vector to divide</p>\n",
                            "type": "p5.Vector"
                        },
                        {
                            "name": "n",
                            "description": "",
                            "type": "Number"
                        },
                        {
                            "name": "target",
                            "description": "<p>if undefined a new vector will be created</p>\n",
                            "type": "p5.Vector"
                        }
                    ],
                    "static": 1
                },
                {
                    "line": 1127,
                    "params": [
                        {
                            "name": "v",
                            "description": "",
                            "type": "p5.Vector"
                        },
                        {
                            "name": "n",
                            "description": "",
                            "type": "Number"
                        }
                    ],
                    "static": 1,
                    "return": {
                        "description": "the resulting new p5.Vector",
                        "type": "p5.Vector"
                    }
                }
            ]
        },
        {
            "file": "src/math/p5.Vector.js",
            "line": 373,
            "description": "<p>Calculates the magnitude (length) of the vector and returns the result as\na float (this is simply the equation sqrt(x<em>x + y</em>y + z*z).)</p>\n",
            "itemtype": "method",
            "name": "mag",
            "return": {
                "description": "magnitude of the vector",
                "type": "Number"
            },
            "example": [
                "\n<div class=\"norender\">\n<code>\nvar v = createVector(20.0, 30.0, 40.0);\nvar m = v.mag();\nprint(m); // Prints \"53.85164807134504\"\n</code>\n</div>"
            ],
            "class": "p5.Vector",
            "module": "Math",
            "submodule": "Math",
            "overloads": [
                {
                    "line": 373,
                    "params": [],
                    "return": {
                        "description": "magnitude of the vector",
                        "type": "Number"
                    }
                },
                {
                    "line": 1217,
                    "params": [
                        {
                            "name": "vecT",
                            "description": "<p>the vector to return the magnitude of</p>\n",
                            "type": "p5.Vector"
                        }
                    ],
                    "static": 1,
                    "return": {
                        "description": "the magnitude of vecT",
                        "type": "Number"
                    }
                }
            ]
        },
        {
            "file": "src/math/p5.Vector.js",
            "line": 392,
            "description": "<p>Calculates the squared magnitude of the vector and returns the result\nas a float (this is simply the equation <em>(x<em>x + y</em>y + z*z)</em>.)\nFaster if the real length is not required in the\ncase of comparing vectors, etc.</p>\n",
            "itemtype": "method",
            "name": "magSq",
            "return": {
                "description": "squared magnitude of the vector",
                "type": "Number"
            },
            "example": [
                "\n<div class=\"norender\">\n<code>\n// Static method\nvar v1 = createVector(6, 4, 2);\nprint(v1.magSq()); // Prints \"56\"\n</code>\n</div>"
            ],
            "class": "p5.Vector",
            "module": "Math",
            "submodule": "Math"
        },
        {
            "file": "src/math/p5.Vector.js",
            "line": 416,
            "description": "<p>Calculates the dot product of two vectors. The version of the method\nthat computes the dot product of two independent vectors is a static\nmethod. See the examples for more context.</p>\n",
            "itemtype": "method",
            "name": "dot",
            "return": {
                "description": "the dot product",
                "type": "Number"
            },
            "example": [
                "\n<div class=\"norender\">\n<code>\nvar v1 = createVector(1, 2, 3);\nvar v2 = createVector(2, 3, 4);\n\nprint(v1.dot(v2)); // Prints \"20\"\n</code>\n</div>\n\n<div class=\"norender\">\n<code>\n//Static method\nvar v1 = createVector(1, 2, 3);\nvar v2 = createVector(3, 2, 1);\nprint(p5.Vector.dot(v1, v2)); // Prints \"10\"\n</code>\n</div>"
            ],
            "class": "p5.Vector",
            "module": "Math",
            "submodule": "Math",
            "overloads": [
                {
                    "line": 416,
                    "params": [
                        {
                            "name": "x",
                            "description": "<p>x component of the vector</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "y",
                            "description": "<p>y component of the vector</p>\n",
                            "type": "Number",
                            "optional": true
                        },
                        {
                            "name": "z",
                            "description": "<p>z component of the vector</p>\n",
                            "type": "Number",
                            "optional": true
                        }
                    ],
                    "return": {
                        "description": "the dot product",
                        "type": "Number"
                    }
                },
                {
                    "line": 447,
                    "params": [
                        {
                            "name": "value",
                            "description": "<p>value component of the vector or a p5.Vector</p>\n",
                            "type": "p5.Vector"
                        }
                    ],
                    "return": {
                        "description": "",
                        "type": "Number"
                    }
                },
                {
                    "line": 1147,
                    "params": [
                        {
                            "name": "v1",
                            "description": "<p>the first p5.Vector</p>\n",
                            "type": "p5.Vector"
                        },
                        {
                            "name": "v2",
                            "description": "<p>the second p5.Vector</p>\n",
                            "type": "p5.Vector"
                        }
                    ],
                    "static": 1,
                    "return": {
                        "description": "the dot product",
                        "type": "Number"
                    }
                }
            ]
        },
        {
            "file": "src/math/p5.Vector.js",
            "line": 459,
            "description": "<p>Calculates and returns a vector composed of the cross product between\ntwo vectors. Both the static and non static methods return a new p5.Vector.\nSee the examples for more context.</p>\n",
            "itemtype": "method",
            "name": "cross",
            "return": {
                "description": "p5.Vector composed of cross product",
                "type": "p5.Vector"
            },
            "example": [
                "\n<div class=\"norender\">\n<code>\nvar v1 = createVector(1, 2, 3);\nvar v2 = createVector(1, 2, 3);\n\nv1.cross(v2); // v's components are [0, 0, 0]\n</code>\n</div>\n\n<div class=\"norender\">\n<code>\n// Static method\nvar v1 = createVector(1, 0, 0);\nvar v2 = createVector(0, 1, 0);\n\nvar crossProduct = p5.Vector.cross(v1, v2);\n// crossProduct has components [0, 0, 1]\nprint(crossProduct);\n</code>\n</div>"
            ],
            "class": "p5.Vector",
            "module": "Math",
            "submodule": "Math",
            "overloads": [
                {
                    "line": 459,
                    "params": [
                        {
                            "name": "v",
                            "description": "<p>p5.Vector to be crossed</p>\n",
                            "type": "p5.Vector"
                        }
                    ],
                    "return": {
                        "description": "p5.Vector composed of cross product",
                        "type": "p5.Vector"
                    }
                },
                {
                    "line": 1161,
                    "params": [
                        {
                            "name": "v1",
                            "description": "<p>the first p5.Vector</p>\n",
                            "type": "p5.Vector"
                        },
                        {
                            "name": "v2",
                            "description": "<p>the second p5.Vector</p>\n",
                            "type": "p5.Vector"
                        }
                    ],
                    "static": 1,
                    "return": {
                        "description": "the cross product",
                        "type": "Number"
                    }
                }
            ]
        },
        {
            "file": "src/math/p5.Vector.js",
            "line": 500,
            "description": "<p>Calculates the Euclidean distance between two points (considering a\npoint as a vector object).</p>\n",
            "itemtype": "method",
            "name": "dist",
            "return": {
                "description": "the distance",
                "type": "Number"
            },
            "example": [
                "\n<div class=\"norender\">\n<code>\nvar v1 = createVector(1, 0, 0);\nvar v2 = createVector(0, 1, 0);\n\nvar distance = v1.dist(v2); // distance is 1.4142...\nprint(distance);\n</code>\n</div>\n\n<div class=\"norender\">\n<code>\n// Static method\nvar v1 = createVector(1, 0, 0);\nvar v2 = createVector(0, 1, 0);\n\nvar distance = p5.Vector.dist(v1, v2);\n// distance is 1.4142...\nprint(distance);\n</code>\n</div>"
            ],
            "class": "p5.Vector",
            "module": "Math",
            "submodule": "Math",
            "overloads": [
                {
                    "line": 500,
                    "params": [
                        {
                            "name": "v",
                            "description": "<p>the x, y, and z coordinates of a p5.Vector</p>\n",
                            "type": "p5.Vector"
                        }
                    ],
                    "return": {
                        "description": "the distance",
                        "type": "Number"
                    }
                },
                {
                    "line": 1176,
                    "params": [
                        {
                            "name": "v1",
                            "description": "<p>the first p5.Vector</p>\n",
                            "type": "p5.Vector"
                        },
                        {
                            "name": "v2",
                            "description": "<p>the second p5.Vector</p>\n",
                            "type": "p5.Vector"
                        }
                    ],
                    "static": 1,
                    "return": {
                        "description": "the distance",
                        "type": "Number"
                    }
                }
            ]
        },
        {
            "file": "src/math/p5.Vector.js",
            "line": 537,
            "description": "<p>Normalize the vector to length 1 (make it a unit vector).</p>\n",
            "itemtype": "method",
            "name": "normalize",
            "return": {
                "description": "normalized p5.Vector",
                "type": "p5.Vector"
            },
            "example": [
                "\n<div class=\"norender\">\n<code>\nvar v = createVector(10, 20, 2);\n// v has components [10.0, 20.0, 2.0]\nv.normalize();\n// v's components are set to\n// [0.4454354, 0.8908708, 0.089087084]\n</code>\n</div>"
            ],
            "class": "p5.Vector",
            "module": "Math",
            "submodule": "Math"
        },
        {
            "file": "src/math/p5.Vector.js",
            "line": 557,
            "description": "<p>Limit the magnitude of this vector to the value used for the <b>max</b>\nparameter.</p>\n",
            "itemtype": "method",
            "name": "limit",
            "params": [
                {
                    "name": "max",
                    "description": "<p>the maximum magnitude for the vector</p>\n",
                    "type": "Number"
                }
            ],
            "chainable": 1,
            "example": [
                "\n<div class=\"norender\">\n<code>\nvar v = createVector(10, 20, 2);\n// v has components [10.0, 20.0, 2.0]\nv.limit(5);\n// v's components are set to\n// [2.2271771, 4.4543543, 0.4454354]\n</code>\n</div>"
            ],
            "class": "p5.Vector",
            "module": "Math",
            "submodule": "Math"
        },
        {
            "file": "src/math/p5.Vector.js",
            "line": 584,
            "description": "<p>Set the magnitude of this vector to the value used for the <b>len</b>\nparameter.</p>\n",
            "itemtype": "method",
            "name": "setMag",
            "params": [
                {
                    "name": "len",
                    "description": "<p>the new length for this vector</p>\n",
                    "type": "Number"
                }
            ],
            "chainable": 1,
            "example": [
                "\n<div class=\"norender\">\n<code>\nvar v = createVector(10, 20, 2);\n// v has components [10.0, 20.0, 2.0]\nv.setMag(10);\n// v's components are set to [6.0, 8.0, 0.0]\n</code>\n</div>"
            ],
            "class": "p5.Vector",
            "module": "Math",
            "submodule": "Math"
        },
        {
            "file": "src/math/p5.Vector.js",
            "line": 605,
            "description": "<p>Calculate the angle of rotation for this vector (only 2D vectors)</p>\n",
            "itemtype": "method",
            "name": "heading",
            "return": {
                "description": "the angle of rotation",
                "type": "Number"
            },
            "example": [
                "\n<div class = \"norender\">\n<code>\nfunction setup() {\n  var v1 = createVector(30, 50);\n  print(v1.heading()); // 1.0303768265243125\n\n  v1 = createVector(40, 50);\n  print(v1.heading()); // 0.8960553845713439\n\n  v1 = createVector(30, 70);\n  print(v1.heading()); // 1.1659045405098132\n}\n</code>\n</div>"
            ],
            "class": "p5.Vector",
            "module": "Math",
            "submodule": "Math"
        },
        {
            "file": "src/math/p5.Vector.js",
            "line": 637,
            "description": "<p>Rotate the vector by an angle (only 2D vectors), magnitude remains the\nsame</p>\n",
            "itemtype": "method",
            "name": "rotate",
            "params": [
                {
                    "name": "angle",
                    "description": "<p>the angle of rotation</p>\n",
                    "type": "Number"
                }
            ],
            "chainable": 1,
            "example": [
                "\n<div class=\"norender\">\n<code>\nvar v = createVector(10.0, 20.0);\n// v has components [10.0, 20.0, 0.0]\nv.rotate(HALF_PI);\n// v's components are set to [-20.0, 9.999999, 0.0]\n</code>\n</div>"
            ],
            "class": "p5.Vector",
            "module": "Math",
            "submodule": "Math"
        },
        {
            "file": "src/math/p5.Vector.js",
            "line": 667,
            "description": "<p>Calculates and returns the angle (in radians) between two vectors.</p>\n",
            "itemtype": "method",
            "name": "angleBetween",
            "params": [
                {
                    "name": "the",
                    "description": "<p>x, y, and z components of a p5.Vector</p>\n",
                    "type": "p5.Vector"
                }
            ],
            "return": {
                "description": "the angle between (in radians)",
                "type": "Number"
            },
            "example": [
                "\n<div class=\"norender\">\n<code>\nvar v1 = createVector(1, 0, 0);\nvar v2 = createVector(0, 1, 0);\n\nvar angle = v1.angleBetween(v2);\n// angle is PI/2\nprint(angle);\n</code>\n</div>"
            ],
            "class": "p5.Vector",
            "module": "Math",
            "submodule": "Math"
        },
        {
            "file": "src/math/p5.Vector.js",
            "line": 700,
            "description": "<p>Linear interpolate the vector to another vector</p>\n",
            "itemtype": "method",
            "name": "lerp",
            "chainable": 1,
            "example": [
                "\n<div class=\"norender\">\n<code>\nvar v = createVector(1, 1, 0);\n\nv.lerp(3, 3, 0, 0.5); // v now has components [2,2,0]\n</code>\n</div>\n\n<div class=\"norender\">\n<code>\nvar v1 = createVector(0, 0, 0);\nvar v2 = createVector(100, 100, 0);\n\nvar v3 = p5.Vector.lerp(v1, v2, 0.5);\n// v3 has components [50,50,0]\nprint(v3);\n</code>\n</div>"
            ],
            "class": "p5.Vector",
            "module": "Math",
            "submodule": "Math",
            "overloads": [
                {
                    "line": 700,
                    "params": [
                        {
                            "name": "x",
                            "description": "<p>the x component</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "y",
                            "description": "<p>the y component</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "z",
                            "description": "<p>the z component</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "amt",
                            "description": "<p>the amount of interpolation; some value between 0.0\n                        (old vector) and 1.0 (new vector). 0.9 is very near\n                        the new vector. 0.5 is halfway in between.</p>\n",
                            "type": "Number"
                        }
                    ],
                    "chainable": 1
                },
                {
                    "line": 732,
                    "params": [
                        {
                            "name": "v",
                            "description": "<p>the p5.Vector to lerp to</p>\n",
                            "type": "p5.Vector"
                        },
                        {
                            "name": "amt",
                            "description": "",
                            "type": "Number"
                        }
                    ],
                    "chainable": 1
                },
                {
                    "line": 1191,
                    "params": [
                        {
                            "name": "v1",
                            "description": "",
                            "type": "p5.Vector"
                        },
                        {
                            "name": "v2",
                            "description": "",
                            "type": "p5.Vector"
                        },
                        {
                            "name": "amt",
                            "description": "",
                            "type": "Number"
                        },
                        {
                            "name": "target",
                            "description": "<p>if undefined a new vector will be created</p>\n",
                            "type": "p5.Vector"
                        }
                    ],
                    "static": 1
                },
                {
                    "line": 1199,
                    "params": [
                        {
                            "name": "v1",
                            "description": "",
                            "type": "p5.Vector"
                        },
                        {
                            "name": "v2",
                            "description": "",
                            "type": "p5.Vector"
                        },
                        {
                            "name": "amt",
                            "description": "",
                            "type": "Number"
                        }
                    ],
                    "static": 1,
                    "return": {
                        "description": "the lerped value",
                        "type": "Number"
                    }
                }
            ]
        },
        {
            "file": "src/math/p5.Vector.js",
            "line": 748,
            "description": "<p>Return a representation of this vector as a float array. This is only\nfor temporary use. If used in any other fashion, the contents should be\ncopied by using the <b>p5.Vector.copy()</b> method to copy into your own\narray.</p>\n",
            "itemtype": "method",
            "name": "array",
            "return": {
                "description": "an Array with the 3 values",
                "type": "Number[]"
            },
            "example": [
                "\n<div class = \"norender\">\n<code>\nfunction setup() {\n  var v = createVector(20, 30);\n  print(v.array()); // Prints : Array [20, 30, 0]\n}\n</code>\n</div>\n\n<div class=\"norender\">\n<code>\nvar v = createVector(10.0, 20.0, 30.0);\nvar f = v.array();\nprint(f[0]); // Prints \"10.0\"\nprint(f[1]); // Prints \"20.0\"\nprint(f[2]); // Prints \"30.0\"\n</code>\n</div>"
            ],
            "class": "p5.Vector",
            "module": "Math",
            "submodule": "Math"
        },
        {
            "file": "src/math/p5.Vector.js",
            "line": 780,
            "description": "<p>Equality check against a p5.Vector</p>\n",
            "itemtype": "method",
            "name": "equals",
            "return": {
                "description": "whether the vectors are equals",
                "type": "Boolean"
            },
            "example": [
                "\n<div class = \"norender\">\n<code>\nvar v1 = createVector(5, 10, 20);\nvar v2 = createVector(5, 10, 20);\nvar v3 = createVector(13, 10, 19);\n\nprint(v1.equals(v2.x, v2.y, v2.z)); // true\nprint(v1.equals(v3.x, v3.y, v3.z)); // false\n</code>\n</div>\n\n<div class=\"norender\">\n<code>\nvar v1 = createVector(10.0, 20.0, 30.0);\nvar v2 = createVector(10.0, 20.0, 30.0);\nvar v3 = createVector(0.0, 0.0, 0.0);\nprint(v1.equals(v2)); // true\nprint(v1.equals(v3)); // false\n</code>\n</div>"
            ],
            "class": "p5.Vector",
            "module": "Math",
            "submodule": "Math",
            "overloads": [
                {
                    "line": 780,
                    "params": [
                        {
                            "name": "x",
                            "description": "<p>the x component of the vector</p>\n",
                            "type": "Number",
                            "optional": true
                        },
                        {
                            "name": "y",
                            "description": "<p>the y component of the vector</p>\n",
                            "type": "Number",
                            "optional": true
                        },
                        {
                            "name": "z",
                            "description": "<p>the z component of the vector</p>\n",
                            "type": "Number",
                            "optional": true
                        }
                    ],
                    "return": {
                        "description": "whether the vectors are equals",
                        "type": "Boolean"
                    }
                },
                {
                    "line": 810,
                    "params": [
                        {
                            "name": "value",
                            "description": "<p>the vector to compare</p>\n",
                            "type": "p5.Vector|Array"
                        }
                    ],
                    "return": {
                        "description": "",
                        "type": "Boolean"
                    }
                }
            ]
        },
        {
            "file": "src/math/p5.Vector.js",
            "line": 835,
            "description": "<p>Make a new 2D vector from an angle</p>\n",
            "itemtype": "method",
            "name": "fromAngle",
            "static": 1,
            "params": [
                {
                    "name": "angle",
                    "description": "<p>the desired angle</p>\n",
                    "type": "Number"
                },
                {
                    "name": "length",
                    "description": "<p>the length of the new vector (defaults to 1)</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "return": {
                "description": "the new p5.Vector object",
                "type": "p5.Vector"
            },
            "example": [
                "\n<div>\n<code>\nfunction draw() {\n  background(200);\n\n  // Create a variable, proportional to the mouseX,\n  // varying from 0-360, to represent an angle in degrees.\n  angleMode(DEGREES);\n  var myDegrees = map(mouseX, 0, width, 0, 360);\n\n  // Display that variable in an onscreen text.\n  // (Note the nfc() function to truncate additional decimal places,\n  // and the \"\\xB0\" character for the degree symbol.)\n  var readout = 'angle = ' + nfc(myDegrees, 1) + '\\xB0';\n  noStroke();\n  fill(0);\n  text(readout, 5, 15);\n\n  // Create a p5.Vector using the fromAngle function,\n  // and extract its x and y components.\n  var v = p5.Vector.fromAngle(radians(myDegrees), 30);\n  var vx = v.x;\n  var vy = v.y;\n\n  push();\n  translate(width / 2, height / 2);\n  noFill();\n  stroke(150);\n  line(0, 0, 30, 0);\n  stroke(0);\n  line(0, 0, vx, vy);\n  pop();\n}\n</code>\n</div>"
            ],
            "class": "p5.Vector",
            "module": "Math",
            "submodule": "Math"
        },
        {
            "file": "src/math/p5.Vector.js",
            "line": 900,
            "description": "<p>Make a new 3D vector from a pair of ISO spherical angles</p>\n",
            "itemtype": "method",
            "name": "fromAngles",
            "static": 1,
            "params": [
                {
                    "name": "theta",
                    "description": "<p>the polar angle (zero is up)</p>\n",
                    "type": "Number"
                },
                {
                    "name": "phi",
                    "description": "<p>the azimuthal angle (zero is out of the screen)</p>\n",
                    "type": "Number"
                },
                {
                    "name": "length",
                    "description": "<p>the length of the new vector (defaults to 1)</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "return": {
                "description": "the new p5.Vector object",
                "type": "p5.Vector"
            },
            "example": [
                "\n<div modernizr='webgl'>\n<code>\nfunction setup() {\n  createCanvas(100, 100, WEBGL);\n  fill(255);\n  noStroke();\n}\nfunction draw() {\n  background(255);\n\n  var t = millis() / 1000;\n\n  // add three point lights\n  pointLight(color('#f00'), p5.Vector.fromAngles(t * 1.0, t * 1.3, 100));\n  pointLight(color('#0f0'), p5.Vector.fromAngles(t * 1.1, t * 1.2, 100));\n  pointLight(color('#00f'), p5.Vector.fromAngles(t * 1.2, t * 1.1, 100));\n\n  sphere(35);\n}\n</code>\n</div>"
            ],
            "class": "p5.Vector",
            "module": "Math",
            "submodule": "Math"
        },
        {
            "file": "src/math/p5.Vector.js",
            "line": 963,
            "description": "<p>Make a new 2D unit vector from a random angle</p>\n",
            "itemtype": "method",
            "name": "random2D",
            "static": 1,
            "return": {
                "description": "the new p5.Vector object",
                "type": "p5.Vector"
            },
            "example": [
                "\n<div class=\"norender\">\n<code>\nvar v = p5.Vector.random2D();\n// May make v's attributes something like:\n// [0.61554617, -0.51195765, 0.0] or\n// [-0.4695841, -0.14366731, 0.0] or\n// [0.6091097, -0.22805278, 0.0]\nprint(v);\n</code>\n</div>"
            ],
            "class": "p5.Vector",
            "module": "Math",
            "submodule": "Math"
        },
        {
            "file": "src/math/p5.Vector.js",
            "line": 997,
            "description": "<p>Make a new random 3D unit vector.</p>\n",
            "itemtype": "method",
            "name": "random3D",
            "static": 1,
            "return": {
                "description": "the new p5.Vector object",
                "type": "p5.Vector"
            },
            "example": [
                "\n<div class=\"norender\">\n<code>\nvar v = p5.Vector.random3D();\n// May make v's attributes something like:\n// [0.61554617, -0.51195765, 0.599168] or\n// [-0.4695841, -0.14366731, -0.8711202] or\n// [0.6091097, -0.22805278, -0.7595902]\nprint(v);\n</code>\n</div>"
            ],
            "class": "p5.Vector",
            "module": "Math",
            "submodule": "Math"
        },
        {
            "file": "src/math/p5.Vector.js",
            "line": 1090,
            "description": "<p>Multiplies a vector by a scalar and returns a new vector.</p>\n",
            "class": "p5.Vector",
            "module": "Math",
            "submodule": "Math"
        },
        {
            "file": "src/math/p5.Vector.js",
            "line": 1117,
            "description": "<p>Divides a vector by a scalar and returns a new vector.</p>\n",
            "class": "p5.Vector",
            "module": "Math",
            "submodule": "Math"
        },
        {
            "file": "src/math/p5.Vector.js",
            "line": 1144,
            "description": "<p>Calculates the dot product of two vectors.</p>\n",
            "class": "p5.Vector",
            "module": "Math",
            "submodule": "Math"
        },
        {
            "file": "src/math/p5.Vector.js",
            "line": 1158,
            "description": "<p>Calculates the cross product of two vectors.</p>\n",
            "class": "p5.Vector",
            "module": "Math",
            "submodule": "Math"
        },
        {
            "file": "src/math/p5.Vector.js",
            "line": 1172,
            "description": "<p>Calculates the Euclidean distance between two points (considering a\npoint as a vector object).</p>\n",
            "class": "p5.Vector",
            "module": "Math",
            "submodule": "Math"
        },
        {
            "file": "src/math/p5.Vector.js",
            "line": 1187,
            "description": "<p>Linear interpolate a vector to another vector and return the result as a\nnew vector.</p>\n",
            "class": "p5.Vector",
            "module": "Math",
            "submodule": "Math"
        },
        {
            "file": "src/math/random.js",
            "line": 48,
            "description": "<p>Sets the seed value for random().</p>\n<p>By default, random() produces different results each time the program\nis run. Set the seed parameter to a constant to return the same\npseudo-random numbers each time the software is run.</p>\n",
            "itemtype": "method",
            "name": "randomSeed",
            "params": [
                {
                    "name": "seed",
                    "description": "<p>the seed value</p>\n",
                    "type": "Number"
                }
            ],
            "example": [
                "\n<div>\n<code>\nrandomSeed(99);\nfor (var i = 0; i < 100; i++) {\n  var r = random(0, 255);\n  stroke(r);\n  line(i, 0, i, 100);\n}\n</code>\n</div>"
            ],
            "alt": "many vertical lines drawn in white, black or grey.",
            "class": "p5",
            "module": "Math",
            "submodule": "Random"
        },
        {
            "file": "src/math/random.js",
            "line": 79,
            "description": "<p>Return a random floating-point number.</p>\n<p>Takes either 0, 1 or 2 arguments.</p>\n<p>If no argument is given, returns a random number from 0\nup to (but not including) 1.</p>\n<p>If one argument is given and it is a number, returns a random number from 0\nup to (but not including) the number.</p>\n<p>If one argument is given and it is an array, returns a random element from\nthat array.</p>\n<p>If two arguments are given, returns a random number from the\nfirst argument up to (but not including) the second argument.</p>\n",
            "itemtype": "method",
            "name": "random",
            "return": {
                "description": "the random number",
                "type": "Number"
            },
            "example": [
                "\n<div>\n<code>\nfor (var i = 0; i < 100; i++) {\n  var r = random(50);\n  stroke(r * 5);\n  line(50, i, 50 + r, i);\n}\n</code>\n</div>\n<div>\n<code>\nfor (var i = 0; i < 100; i++) {\n  var r = random(-50, 50);\n  line(50, i, 50 + r, i);\n}\n</code>\n</div>\n<div>\n<code>\n// Get a random element from an array using the random(Array) syntax\nvar words = ['apple', 'bear', 'cat', 'dog'];\nvar word = random(words); // select random word\ntext(word, 10, 50); // draw the word\n</code>\n</div>"
            ],
            "alt": "100 horizontal lines from center canvas to right. size+fill change each time\n100 horizontal lines from center of canvas. height & side change each render\nword displayed at random. Either apple, bear, cat, or dog",
            "class": "p5",
            "module": "Math",
            "submodule": "Random",
            "overloads": [
                {
                    "line": 79,
                    "params": [
                        {
                            "name": "min",
                            "description": "<p>the lower bound (inclusive)</p>\n",
                            "type": "Number",
                            "optional": true
                        },
                        {
                            "name": "max",
                            "description": "<p>the upper bound (exclusive)</p>\n",
                            "type": "Number",
                            "optional": true
                        }
                    ],
                    "return": {
                        "description": "the random number",
                        "type": "Number"
                    }
                },
                {
                    "line": 133,
                    "params": [
                        {
                            "name": "choices",
                            "description": "<p>the array to choose from</p>\n",
                            "type": "Array"
                        }
                    ],
                    "return": {
                        "description": "the random element from the array",
                        "type": "*"
                    }
                }
            ]
        },
        {
            "file": "src/math/random.js",
            "line": 166,
            "description": "<p>Returns a random number fitting a Gaussian, or\n normal, distribution. There is theoretically no minimum or maximum\n value that randomGaussian() might return. Rather, there is\n just a very low probability that values far from the mean will be\n returned; and a higher probability that numbers near the mean will\n be returned.\n <br><br>\n Takes either 0, 1 or 2 arguments.<br>\n If no args, returns a mean of 0 and standard deviation of 1.<br>\n If one arg, that arg is the mean (standard deviation is 1).<br>\n If two args, first is mean, second is standard deviation.</p>\n",
            "itemtype": "method",
            "name": "randomGaussian",
            "params": [
                {
                    "name": "mean",
                    "description": "<p>the mean</p>\n",
                    "type": "Number"
                },
                {
                    "name": "sd",
                    "description": "<p>the standard deviation</p>\n",
                    "type": "Number"
                }
            ],
            "return": {
                "description": "the random number",
                "type": "Number"
            },
            "example": [
                "\n <div>\n <code>\n for (var y = 0; y < 100; y++) {\n   var x = randomGaussian(50, 15);\n   line(50, y, x, y);\n }\n </code>\n </div>\n <div>\n <code>\n var distribution = new Array(360);\nfunction setup() {\n   createCanvas(100, 100);\n   for (var i = 0; i < distribution.length; i++) {\n     distribution[i] = floor(randomGaussian(0, 15));\n   }\n }\nfunction draw() {\n   background(204);\n  translate(width / 2, width / 2);\n  for (var i = 0; i < distribution.length; i++) {\n     rotate(TWO_PI / distribution.length);\n     stroke(0);\n     var dist = abs(distribution[i]);\n     line(0, 0, dist, 0);\n   }\n }\n </code>\n </div>"
            ],
            "alt": "100 horizontal lines from center of canvas. height & side change each render\n black lines radiate from center of canvas. size determined each render",
            "class": "p5",
            "module": "Math",
            "submodule": "Random"
        },
        {
            "file": "src/math/trigonometry.js",
            "line": 18,
            "description": "<p>The inverse of cos(), returns the arc cosine of a value. This function\nexpects the values in the range of -1 to 1 and values are returned in\nthe range 0 to PI (3.1415927).</p>\n",
            "itemtype": "method",
            "name": "acos",
            "params": [
                {
                    "name": "value",
                    "description": "<p>the value whose arc cosine is to be returned</p>\n",
                    "type": "Number"
                }
            ],
            "return": {
                "description": "the arc cosine of the given value",
                "type": "Number"
            },
            "example": [
                "\n<div class= “norender\">\n<code>\nvar a = PI;\nvar c = cos(a);\nvar ac = acos(c);\n// Prints: \"3.1415927 : -1.0 : 3.1415927\"\nprint(a + ' : ' + c + ' : ' + ac);\n</code>\n</div>\n\n<div class= “norender\">\n<code>\nvar a = PI + PI / 4.0;\nvar c = cos(a);\nvar ac = acos(c);\n// Prints: \"3.926991 : -0.70710665 : 2.3561943\"\nprint(a + ' : ' + c + ' : ' + ac);\n</code>\n</div>"
            ],
            "class": "p5",
            "module": "Math",
            "submodule": "Trigonometry"
        },
        {
            "file": "src/math/trigonometry.js",
            "line": 56,
            "description": "<p>The inverse of sin(), returns the arc sine of a value. This function\nexpects the values in the range of -1 to 1 and values are returned\nin the range -PI/2 to PI/2.</p>\n",
            "itemtype": "method",
            "name": "asin",
            "params": [
                {
                    "name": "value",
                    "description": "<p>the value whose arc sine is to be returned</p>\n",
                    "type": "Number"
                }
            ],
            "return": {
                "description": "the arc sine of the given value",
                "type": "Number"
            },
            "example": [
                "\n<div class= “norender\">\n<code>\nvar a = PI + PI / 3;\nvar s = sin(a);\nvar as = asin(s);\n// Prints: \"1.0471976 : 0.86602545 : 1.0471976\"\nprint(a + ' : ' + s + ' : ' + as);\n</code>\n</div>\n\n<div class= “norender\">\n<code>\nvar a = PI + PI / 3.0;\nvar s = sin(a);\nvar as = asin(s);\n// Prints: \"4.1887903 : -0.86602545 : -1.0471976\"\nprint(a + ' : ' + s + ' : ' + as);\n</code>\n</div>\n"
            ],
            "class": "p5",
            "module": "Math",
            "submodule": "Trigonometry"
        },
        {
            "file": "src/math/trigonometry.js",
            "line": 95,
            "description": "<p>The inverse of tan(), returns the arc tangent of a value. This function\nexpects the values in the range of -Infinity to Infinity (exclusive) and\nvalues are returned in the range -PI/2 to PI/2.</p>\n",
            "itemtype": "method",
            "name": "atan",
            "params": [
                {
                    "name": "value",
                    "description": "<p>the value whose arc tangent is to be returned</p>\n",
                    "type": "Number"
                }
            ],
            "return": {
                "description": "the arc tangent of the given value",
                "type": "Number"
            },
            "example": [
                "\n<div class= “norender\">\n<code>\nvar a = PI + PI / 3;\nvar t = tan(a);\nvar at = atan(t);\n// Prints: \"1.0471976 : 1.7320509 : 1.0471976\"\nprint(a + ' : ' + t + ' : ' + at);\n</code>\n</div>\n\n<div class= “norender\">\n<code>\nvar a = PI + PI / 3.0;\nvar t = tan(a);\nvar at = atan(t);\n// Prints: \"4.1887903 : 1.7320513 : 1.0471977\"\nprint(a + ' : ' + t + ' : ' + at);\n</code>\n</div>\n"
            ],
            "class": "p5",
            "module": "Math",
            "submodule": "Trigonometry"
        },
        {
            "file": "src/math/trigonometry.js",
            "line": 134,
            "description": "<p>Calculates the angle (in radians) from a specified point to the coordinate\norigin as measured from the positive x-axis. Values are returned as a\nfloat in the range from PI to -PI. The atan2() function is most often used\nfor orienting geometry to the position of the cursor.\n<br><br>\nNote: The y-coordinate of the point is the first parameter, and the\nx-coordinate is the second parameter, due the the structure of calculating\nthe tangent.</p>\n",
            "itemtype": "method",
            "name": "atan2",
            "params": [
                {
                    "name": "y",
                    "description": "<p>y-coordinate of the point</p>\n",
                    "type": "Number"
                },
                {
                    "name": "x",
                    "description": "<p>x-coordinate of the point</p>\n",
                    "type": "Number"
                }
            ],
            "return": {
                "description": "the arc tangent of the given point",
                "type": "Number"
            },
            "example": [
                "\n<div>\n<code>\nfunction draw() {\n  background(204);\n  translate(width / 2, height / 2);\n  var a = atan2(mouseY - height / 2, mouseX - width / 2);\n  rotate(a);\n  rect(-30, -5, 60, 10);\n}\n</code>\n</div>"
            ],
            "alt": "60 by 10 rect at center of canvas rotates with mouse movements",
            "class": "p5",
            "module": "Math",
            "submodule": "Trigonometry"
        },
        {
            "file": "src/math/trigonometry.js",
            "line": 174,
            "description": "<p>Calculates the cosine of an angle. This function takes into account the\ncurrent angleMode. Values are returned in the range -1 to 1.</p>\n",
            "itemtype": "method",
            "name": "cos",
            "params": [
                {
                    "name": "angle",
                    "description": "<p>the angle</p>\n",
                    "type": "Number"
                }
            ],
            "return": {
                "description": "the cosine of the angle",
                "type": "Number"
            },
            "example": [
                "\n<div>\n<code>\nvar a = 0.0;\nvar inc = TWO_PI / 25.0;\nfor (var i = 0; i < 25; i++) {\n  line(i * 4, 50, i * 4, 50 + cos(a) * 40.0);\n  a = a + inc;\n}\n</code>\n</div>"
            ],
            "alt": "vertical black lines form wave patterns, extend-down on left and right side",
            "class": "p5",
            "module": "Math",
            "submodule": "Trigonometry"
        },
        {
            "file": "src/math/trigonometry.js",
            "line": 206,
            "description": "<p>Calculates the sine of an angle. This function takes into account the\ncurrent angleMode. Values are returned in the range -1 to 1.</p>\n",
            "itemtype": "method",
            "name": "sin",
            "params": [
                {
                    "name": "angle",
                    "description": "<p>the angle</p>\n",
                    "type": "Number"
                }
            ],
            "return": {
                "description": "the sine of the angle",
                "type": "Number"
            },
            "example": [
                "\n<div>\n<code>\nvar a = 0.0;\nvar inc = TWO_PI / 25.0;\nfor (var i = 0; i < 25; i++) {\n  line(i * 4, 50, i * 4, 50 + sin(a) * 40.0);\n  a = a + inc;\n}\n</code>\n</div>"
            ],
            "alt": "vertical black lines extend down and up from center to form wave pattern",
            "class": "p5",
            "module": "Math",
            "submodule": "Trigonometry"
        },
        {
            "file": "src/math/trigonometry.js",
            "line": 238,
            "description": "<p>Calculates the tangent of an angle. This function takes into account\nthe current angleMode. Values are returned in the range -1 to 1.</p>\n",
            "itemtype": "method",
            "name": "tan",
            "params": [
                {
                    "name": "angle",
                    "description": "<p>the angle</p>\n",
                    "type": "Number"
                }
            ],
            "return": {
                "description": "the tangent of the angle",
                "type": "Number"
            },
            "example": [
                "\n<div>\n<code>\nvar a = 0.0;\nvar inc = TWO_PI / 50.0;\nfor (var i = 0; i < 100; i = i + 2) {\n  line(i, 50, i, 50 + tan(a) * 2.0);\n  a = a + inc;\n}\n</code>"
            ],
            "alt": "vertical black lines end down and up from center to form spike pattern",
            "class": "p5",
            "module": "Math",
            "submodule": "Trigonometry"
        },
        {
            "file": "src/math/trigonometry.js",
            "line": 270,
            "description": "<p>Converts a radian measurement to its corresponding value in degrees.\nRadians and degrees are two ways of measuring the same thing. There are\n360 degrees in a circle and 2*PI radians in a circle. For example,\n90° = PI/2 = 1.5707964.</p>\n",
            "itemtype": "method",
            "name": "degrees",
            "params": [
                {
                    "name": "radians",
                    "description": "<p>the radians value to convert to degrees</p>\n",
                    "type": "Number"
                }
            ],
            "return": {
                "description": "the converted angle",
                "type": "Number"
            },
            "example": [
                "\n<div class= “norender\">\n<code>\nvar rad = PI / 4;\nvar deg = degrees(rad);\nprint(rad + ' radians is ' + deg + ' degrees');\n// Prints: 0.7853981633974483 radians is 45 degrees\n</code>\n</div>\n"
            ],
            "class": "p5",
            "module": "Math",
            "submodule": "Trigonometry"
        },
        {
            "file": "src/math/trigonometry.js",
            "line": 296,
            "description": "<p>Converts a degree measurement to its corresponding value in radians.\nRadians and degrees are two ways of measuring the same thing. There are\n360 degrees in a circle and 2*PI radians in a circle. For example,\n90° = PI/2 = 1.5707964.</p>\n",
            "itemtype": "method",
            "name": "radians",
            "params": [
                {
                    "name": "degrees",
                    "description": "<p>the degree value to convert to radians</p>\n",
                    "type": "Number"
                }
            ],
            "return": {
                "description": "the converted angle",
                "type": "Number"
            },
            "example": [
                "\n<div class= “norender\">\n<code>\nvar deg = 45.0;\nvar rad = radians(deg);\nprint(deg + ' degrees is ' + rad + ' radians');\n// Prints: 45 degrees is 0.7853981633974483 radians\n</code>\n</div>"
            ],
            "class": "p5",
            "module": "Math",
            "submodule": "Trigonometry"
        },
        {
            "file": "src/math/trigonometry.js",
            "line": 320,
            "description": "<p>Sets the current mode of p5 to given mode. Default mode is RADIANS.</p>\n",
            "itemtype": "method",
            "name": "angleMode",
            "params": [
                {
                    "name": "mode",
                    "description": "<p>either RADIANS or DEGREES</p>\n",
                    "type": "Constant"
                }
            ],
            "example": [
                "\n<div>\n<code>\nfunction draw() {\n  background(204);\n  angleMode(DEGREES); // Change the mode to DEGREES\n  var a = atan2(mouseY - height / 2, mouseX - width / 2);\n  translate(width / 2, height / 2);\n  push();\n  rotate(a);\n  rect(-20, -5, 40, 10); // Larger rectangle is rotating in degrees\n  pop();\n  angleMode(RADIANS); // Change the mode to RADIANS\n  rotate(a); // var a stays the same\n  rect(-40, -5, 20, 10); // Smaller rectangle is rotating in radians\n}\n</code>\n</div>"
            ],
            "alt": "40 by 10 rect in center rotates with mouse moves. 20 by 10 rect moves faster.",
            "class": "p5",
            "module": "Math",
            "submodule": "Trigonometry"
        },
        {
            "file": "src/typography/attributes.js",
            "line": 13,
            "description": "<p>Sets the current alignment for drawing text. Accepts two\narguments: horizAlign (LEFT, CENTER, or RIGHT) and\nvertAlign (TOP, BOTTOM, CENTER, or BASELINE).</p>\n<p>The horizAlign parameter is in reference to the x value\nof the text() function, while the vertAlign parameter is\nin reference to the y value.</p>\n<p>So if you write textAlign(LEFT), you are aligning the left\nedge of your text to the x value you give in text(). If you\nwrite textAlign(RIGHT, TOP), you are aligning the right edge\nof your text to the x value and the top of edge of the text\nto the y value.</p>\n",
            "itemtype": "method",
            "name": "textAlign",
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\ntextSize(16);\ntextAlign(RIGHT);\ntext('ABCD', 50, 30);\ntextAlign(CENTER);\ntext('EFGH', 50, 50);\ntextAlign(LEFT);\ntext('IJKL', 50, 70);\n</code>\n</div>"
            ],
            "alt": "Letters ABCD displayed at top right, EFGH at center and IJKL at bottom left.",
            "class": "p5",
            "module": "Typography",
            "submodule": "Attributes",
            "overloads": [
                {
                    "line": 13,
                    "params": [
                        {
                            "name": "horizAlign",
                            "description": "<p>horizontal alignment, either LEFT,\n                           CENTER, or RIGHT</p>\n",
                            "type": "Constant"
                        },
                        {
                            "name": "vertAlign",
                            "description": "<p>vertical alignment, either TOP,\n                           BOTTOM, CENTER, or BASELINE</p>\n",
                            "type": "Constant",
                            "optional": true
                        }
                    ],
                    "chainable": 1
                },
                {
                    "line": 51,
                    "params": [],
                    "return": {
                        "description": "",
                        "type": "Object"
                    }
                }
            ]
        },
        {
            "file": "src/typography/attributes.js",
            "line": 59,
            "description": "<p>Sets/gets the spacing, in pixels, between lines of text. This\nsetting will be used in all subsequent calls to the text() function.</p>\n",
            "itemtype": "method",
            "name": "textLeading",
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\n// Text to display. The \"\\n\" is a \"new line\" character\nvar lines = 'L1\\nL2\\nL3';\ntextSize(12);\n\ntextLeading(10); // Set leading to 10\ntext(lines, 10, 25);\n\ntextLeading(20); // Set leading to 20\ntext(lines, 40, 25);\n\ntextLeading(30); // Set leading to 30\ntext(lines, 70, 25);\n</code>\n</div>"
            ],
            "alt": "set L1 L2 & L3 displayed vertically 3 times. spacing increases for each set",
            "class": "p5",
            "module": "Typography",
            "submodule": "Attributes",
            "overloads": [
                {
                    "line": 59,
                    "params": [
                        {
                            "name": "leading",
                            "description": "<p>the size in pixels for spacing between lines</p>\n",
                            "type": "Number"
                        }
                    ],
                    "chainable": 1
                },
                {
                    "line": 88,
                    "params": [],
                    "return": {
                        "description": "",
                        "type": "Number"
                    }
                }
            ]
        },
        {
            "file": "src/typography/attributes.js",
            "line": 96,
            "description": "<p>Sets/gets the current font size. This size will be used in all subsequent\ncalls to the text() function. Font size is measured in pixels.</p>\n",
            "itemtype": "method",
            "name": "textSize",
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\ntextSize(12);\ntext('Font Size 12', 10, 30);\ntextSize(14);\ntext('Font Size 14', 10, 60);\ntextSize(16);\ntext('Font Size 16', 10, 90);\n</code>\n</div>"
            ],
            "alt": "Font Size 12 displayed small, Font Size 14 medium & Font Size 16 large",
            "class": "p5",
            "module": "Typography",
            "submodule": "Attributes",
            "overloads": [
                {
                    "line": 96,
                    "params": [
                        {
                            "name": "theSize",
                            "description": "<p>the size of the letters in units of pixels</p>\n",
                            "type": "Number"
                        }
                    ],
                    "chainable": 1
                },
                {
                    "line": 119,
                    "params": [],
                    "return": {
                        "description": "",
                        "type": "Number"
                    }
                }
            ]
        },
        {
            "file": "src/typography/attributes.js",
            "line": 127,
            "description": "<p>Sets/gets the style of the text for system fonts to NORMAL, ITALIC, or BOLD.\nNote: this may be is overridden by CSS styling. For non-system fonts\n(opentype, truetype, etc.) please load styled fonts instead.</p>\n",
            "itemtype": "method",
            "name": "textStyle",
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\nstrokeWeight(0);\ntextSize(12);\ntextStyle(NORMAL);\ntext('Font Style Normal', 10, 30);\ntextStyle(ITALIC);\ntext('Font Style Italic', 10, 60);\ntextStyle(BOLD);\ntext('Font Style Bold', 10, 90);\n</code>\n</div>"
            ],
            "alt": "words Font Style Normal displayed normally, Italic in italic and bold in bold",
            "class": "p5",
            "module": "Typography",
            "submodule": "Attributes",
            "overloads": [
                {
                    "line": 127,
                    "params": [
                        {
                            "name": "theStyle",
                            "description": "<p>styling for text, either NORMAL,\n                           ITALIC, or BOLD</p>\n",
                            "type": "Constant"
                        }
                    ],
                    "chainable": 1
                },
                {
                    "line": 153,
                    "params": [],
                    "return": {
                        "description": "",
                        "type": "String"
                    }
                }
            ]
        },
        {
            "file": "src/typography/attributes.js",
            "line": 161,
            "description": "<p>Calculates and returns the width of any character or text string.</p>\n",
            "itemtype": "method",
            "name": "textWidth",
            "params": [
                {
                    "name": "theText",
                    "description": "<p>the String of characters to measure</p>\n",
                    "type": "String"
                }
            ],
            "return": {
                "description": "",
                "type": "Number"
            },
            "example": [
                "\n<div>\n<code>\ntextSize(28);\n\nvar aChar = 'P';\nvar cWidth = textWidth(aChar);\ntext(aChar, 0, 40);\nline(cWidth, 0, cWidth, 50);\n\nvar aString = 'p5.js';\nvar sWidth = textWidth(aString);\ntext(aString, 0, 85);\nline(sWidth, 50, sWidth, 100);\n</code>\n</div>"
            ],
            "alt": "Letter P and p5.js are displayed with vertical lines at end. P is wide",
            "class": "p5",
            "module": "Typography",
            "submodule": "Attributes"
        },
        {
            "file": "src/typography/attributes.js",
            "line": 195,
            "description": "<p>Returns the ascent of the current font at its current size. The ascent\nrepresents the distance, in pixels, of the tallest character above\nthe baseline.</p>\n",
            "itemtype": "method",
            "name": "textAscent",
            "return": {
                "description": "",
                "type": "Number"
            },
            "example": [
                "\n<div>\n<code>\nvar base = height * 0.75;\nvar scalar = 0.8; // Different for each font\n\ntextSize(32); // Set initial text size\nvar asc = textAscent() * scalar; // Calc ascent\nline(0, base - asc, width, base - asc);\ntext('dp', 0, base); // Draw text on baseline\n\ntextSize(64); // Increase text size\nasc = textAscent() * scalar; // Recalc ascent\nline(40, base - asc, width, base - asc);\ntext('dp', 40, base); // Draw text on baseline\n</code>\n</div>"
            ],
            "class": "p5",
            "module": "Typography",
            "submodule": "Attributes"
        },
        {
            "file": "src/typography/attributes.js",
            "line": 223,
            "description": "<p>Returns the descent of the current font at its current size. The descent\nrepresents the distance, in pixels, of the character with the longest\ndescender below the baseline.</p>\n",
            "itemtype": "method",
            "name": "textDescent",
            "return": {
                "description": "",
                "type": "Number"
            },
            "example": [
                "\n<div>\n<code>\nvar base = height * 0.75;\nvar scalar = 0.8; // Different for each font\n\ntextSize(32); // Set initial text size\nvar desc = textDescent() * scalar; // Calc ascent\nline(0, base + desc, width, base + desc);\ntext('dp', 0, base); // Draw text on baseline\n\ntextSize(64); // Increase text size\ndesc = textDescent() * scalar; // Recalc ascent\nline(40, base + desc, width, base + desc);\ntext('dp', 40, base); // Draw text on baseline\n</code>\n</div>"
            ],
            "class": "p5",
            "module": "Typography",
            "submodule": "Attributes"
        },
        {
            "file": "src/typography/attributes.js",
            "line": 251,
            "description": "<p>Helper function to measure ascent and descent.</p>\n",
            "class": "p5",
            "module": "Typography",
            "submodule": "Attributes"
        },
        {
            "file": "src/typography/loading_displaying.js",
            "line": 16,
            "description": "<p>Loads an opentype font file (.otf, .ttf) from a file or a URL,\nand returns a PFont Object. This method is asynchronous,\nmeaning it may not finish before the next line in your sketch\nis executed.\n<br><br>\nThe path to the font should be relative to the HTML file\nthat links in your sketch. Loading an from a URL or other\nremote location may be blocked due to your browser&#39;s built-in\nsecurity.</p>\n",
            "itemtype": "method",
            "name": "loadFont",
            "params": [
                {
                    "name": "path",
                    "description": "<p>name of the file or url to load</p>\n",
                    "type": "String"
                },
                {
                    "name": "callback",
                    "description": "<p>function to be executed after\n                                   loadFont() completes</p>\n",
                    "type": "Function",
                    "optional": true
                },
                {
                    "name": "onError",
                    "description": "<p>function to be executed if\n                                   an error occurs</p>\n",
                    "type": "Function",
                    "optional": true
                }
            ],
            "return": {
                "description": "p5.Font object",
                "type": "p5.Font"
            },
            "example": [
                "\n\n<p>Calling loadFont() inside preload() guarantees that the load\noperation will have completed before setup() and draw() are called.</p>\n\n<div><code>\nvar myFont;\nfunction preload() {\n  myFont = loadFont('assets/AvenirNextLTPro-Demi.otf');\n}\n\nfunction setup() {\n  fill('#ED225D');\n  textFont(myFont);\n  textSize(36);\n  text('p5*js', 10, 50);\n}\n</code></div>\n\nOutside of preload(), you may supply a callback function to handle the\nobject:\n\n<div><code>\nfunction setup() {\n  loadFont('assets/AvenirNextLTPro-Demi.otf', drawText);\n}\n\nfunction drawText(font) {\n  fill('#ED225D');\n  textFont(font, 36);\n  text('p5*js', 10, 50);\n}\n</code></div>\n\n<p>You can also use the string name of the font to style other HTML\nelements.</p>\n\n<div><code>\nfunction preload() {\n  loadFont('assets/Avenir.otf');\n}\n\nfunction setup() {\n  var myDiv = createDiv('hello there');\n  myDiv.style('font-family', 'Avenir');\n}\n</code></div>"
            ],
            "alt": "p5*js in p5's theme dark pink\np5*js in p5's theme dark pink",
            "class": "p5",
            "module": "Typography",
            "submodule": "Loading & Displaying"
        },
        {
            "file": "src/typography/loading_displaying.js",
            "line": 142,
            "description": "<p>Draws text to the screen. Displays the information specified in the first\nparameter on the screen in the position specified by the additional\nparameters. A default font will be used unless a font is set with the\ntextFont() function and a default size will be used unless a font is set\nwith textSize(). Change the color of the text with the fill() function.\nChange the outline of the text with the stroke() and strokeWeight()\nfunctions.\n<br><br>\nThe text displays in relation to the textAlign() function, which gives the\noption to draw to the left, right, and center of the coordinates.\n<br><br>\nThe x2 and y2 parameters define a rectangular area to display within and\nmay only be used with string data. When these parameters are specified,\nthey are interpreted based on the current rectMode() setting. Text that\ndoes not fit completely within the rectangle specified will not be drawn\nto the screen.</p>\n",
            "itemtype": "method",
            "name": "text",
            "params": [
                {
                    "name": "str",
                    "description": "<p>the alphanumeric symbols to be displayed</p>\n",
                    "type": "String|Object|Array"
                },
                {
                    "name": "x",
                    "description": "<p>x-coordinate of text</p>\n",
                    "type": "Number"
                },
                {
                    "name": "y",
                    "description": "<p>y-coordinate of text</p>\n",
                    "type": "Number"
                },
                {
                    "name": "x2",
                    "description": "<p>by default, the width of the text box,\n                    see rectMode() for more info</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "y2",
                    "description": "<p>by default, the height of the text box,\n                    see rectMode() for more info</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\ntextSize(32);\ntext('word', 10, 30);\nfill(0, 102, 153);\ntext('word', 10, 60);\nfill(0, 102, 153, 51);\ntext('word', 10, 90);\n</code>\n</div>\n<div>\n<code>\nvar s = 'The quick brown fox jumped over the lazy dog.';\nfill(50);\ntext(s, 10, 10, 70, 80); // Text wraps within text box\n</code>\n</div>"
            ],
            "alt": "'word' displayed 3 times going from black, blue to translucent blue\nThe quick brown fox jumped over the lazy dog.",
            "class": "p5",
            "module": "Typography",
            "submodule": "Loading & Displaying"
        },
        {
            "file": "src/typography/loading_displaying.js",
            "line": 199,
            "description": "<p>Sets the current font that will be drawn with the text() function.</p>\n",
            "itemtype": "method",
            "name": "textFont",
            "return": {
                "description": "the current font",
                "type": "Object"
            },
            "example": [
                "\n<div>\n<code>\nfill(0);\ntextSize(12);\ntextFont('Georgia');\ntext('Georgia', 12, 30);\ntextFont('Helvetica');\ntext('Helvetica', 12, 60);\n</code>\n</div>\n<div>\n<code>\nvar fontRegular, fontItalic, fontBold;\nfunction preload() {\n  fontRegular = loadFont('assets/Regular.otf');\n  fontItalic = loadFont('assets/Italic.ttf');\n  fontBold = loadFont('assets/Bold.ttf');\n}\nfunction setup() {\n  background(210);\n  fill(0)\n   .strokeWeight(0)\n   .textSize(10);\n  textFont(fontRegular);\n  text('Font Style Normal', 10, 30);\n  textFont(fontItalic);\n  text('Font Style Italic', 10, 50);\n  textFont(fontBold);\n  text('Font Style Bold', 10, 70);\n}\n</code>\n</div>"
            ],
            "alt": "words Font Style Normal displayed normally, Italic in italic and bold in bold",
            "class": "p5",
            "module": "Typography",
            "submodule": "Loading & Displaying",
            "overloads": [
                {
                    "line": 199,
                    "params": [],
                    "return": {
                        "description": "the current font",
                        "type": "Object"
                    }
                },
                {
                    "line": 242,
                    "params": [
                        {
                            "name": "font",
                            "description": "<p>a font loaded via loadFont(), or a String\nrepresenting a <a href=\"https://mzl.la/2dOw8WD\">web safe font</a> (a font\nthat is generally available across all systems)</p>\n",
                            "type": "Object|String"
                        },
                        {
                            "name": "size",
                            "description": "<p>the font size to use</p>\n",
                            "type": "Number",
                            "optional": true
                        }
                    ],
                    "chainable": 1
                }
            ]
        },
        {
            "file": "src/typography/p5.Font.js",
            "line": 32,
            "description": "<p>Underlying opentype font implementation</p>\n",
            "itemtype": "property",
            "name": "font",
            "class": "p5.Font",
            "module": "Typography",
            "submodule": "Font"
        },
        {
            "file": "src/typography/p5.Font.js",
            "line": 45,
            "description": "<p>Returns a tight bounding box for the given text string using this\nfont (currently only supports single lines)</p>\n",
            "itemtype": "method",
            "name": "textBounds",
            "params": [
                {
                    "name": "line",
                    "description": "<p>a line of text</p>\n",
                    "type": "String"
                },
                {
                    "name": "x",
                    "description": "<p>x-position</p>\n",
                    "type": "Number"
                },
                {
                    "name": "y",
                    "description": "<p>y-position</p>\n",
                    "type": "Number"
                },
                {
                    "name": "fontSize",
                    "description": "<p>font size to use (optional)</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "options",
                    "description": "<p>opentype options (optional)</p>\n",
                    "type": "Object",
                    "optional": true
                }
            ],
            "return": {
                "description": "a rectangle object with properties: x, y, w, h",
                "type": "Object"
            },
            "example": [
                "\n<div>\n<code>\nvar font;\nvar textString = 'Lorem ipsum dolor sit amet.';\nfunction preload() {\n  font = loadFont('./assets/Regular.otf');\n}\nfunction setup() {\n  background(210);\n\n  var bbox = font.textBounds(textString, 10, 30, 12);\n  fill(255);\n  stroke(0);\n  rect(bbox.x, bbox.y, bbox.w, bbox.h);\n  fill(0);\n  noStroke();\n\n  textFont(font);\n  textSize(12);\n  text(textString, 10, 30);\n}\n</code>\n</div>"
            ],
            "alt": "words Lorem ipsum dol go off canvas and contained by white bounding box",
            "class": "p5.Font",
            "module": "Typography",
            "submodule": "Font"
        },
        {
            "file": "src/typography/p5.Font.js",
            "line": 160,
            "description": "<p>Computes an array of points following the path for specified text</p>\n",
            "itemtype": "method",
            "name": "textToPoints",
            "params": [
                {
                    "name": "txt",
                    "description": "<p>a line of text</p>\n",
                    "type": "String"
                },
                {
                    "name": "x",
                    "description": "<p>x-position</p>\n",
                    "type": "Number"
                },
                {
                    "name": "y",
                    "description": "<p>y-position</p>\n",
                    "type": "Number"
                },
                {
                    "name": "fontSize",
                    "description": "<p>font size to use (optional)</p>\n",
                    "type": "Number"
                },
                {
                    "name": "options",
                    "description": "<p>an (optional) object that can contain:</p>\n<p><br>sampleFactor - the ratio of path-length to number of samples\n(default=.25); higher values yield more points and are therefore\nmore precise</p>\n<p><br>simplifyThreshold - if set to a non-zero value, collinear points will be\nbe removed from the polygon; the value represents the threshold angle to use\nwhen determining whether two edges are collinear</p>\n",
                    "type": "Object",
                    "optional": true
                }
            ],
            "return": {
                "description": "an array of points, each with x, y, alpha (the path angle)",
                "type": "Array"
            },
            "example": [
                "\n<div>\n<code>\nvar font;\nfunction preload() {\n  font = loadFont('./assets/Avenir.otf');\n}\n\nvar points;\nvar bounds;\nfunction setup() {\n  createCanvas(100, 100);\n  stroke(0);\n  fill(255, 104, 204);\n\n  points = font.textToPoints('p5', 0, 0, 10, {\n    sampleFactor: 5,\n    simplifyThreshold: 0\n  });\n  bounds = font.textBounds(' p5 ', 0, 0, 10);\n}\n\nfunction draw() {\n  background(255);\n  beginShape();\n  translate(-bounds.x * width / bounds.w, -bounds.y * height / bounds.h);\n  for (var i = 0; i < points.length; i++) {\n    var p = points[i];\n    vertex(\n      p.x * width / bounds.w +\n        sin(20 * p.y / bounds.h + millis() / 1000) * width / 30,\n      p.y * height / bounds.h\n    );\n  }\n  endShape(CLOSE);\n}\n</code>\n</div>\n"
            ],
            "class": "p5.Font",
            "module": "Typography",
            "submodule": "Font"
        },
        {
            "file": "src/utilities/array_functions.js",
            "line": 12,
            "description": "<p>Adds a value to the end of an array. Extends the length of\nthe array by one. Maps to Array.push().</p>\n",
            "itemtype": "method",
            "name": "append",
            "params": [
                {
                    "name": "array",
                    "description": "<p>Array to append</p>\n",
                    "type": "Array"
                },
                {
                    "name": "value",
                    "description": "<p>to be added to the Array</p>\n",
                    "type": "Any"
                }
            ],
            "example": [
                "\n<div class='norender'><code>\nfunction setup() {\n  var myArray = ['Mango', 'Apple', 'Papaya'];\n  print(myArray); // ['Mango', 'Apple', 'Papaya']\n\n  append(myArray, 'Peach');\n  print(myArray); // ['Mango', 'Apple', 'Papaya', 'Peach']\n}\n</code></div>"
            ],
            "class": "p5",
            "module": "Data",
            "submodule": "Array Functions"
        },
        {
            "file": "src/utilities/array_functions.js",
            "line": 35,
            "description": "<p>Copies an array (or part of an array) to another array. The src array is\ncopied to the dst array, beginning at the position specified by\nsrcPosition and into the position specified by dstPosition. The number of\nelements to copy is determined by length. Note that copying values\noverwrites existing values in the destination array. To append values\ninstead of overwriting them, use concat().\n<br><br>\nThe simplified version with only two arguments, arrayCopy(src, dst),\ncopies an entire array to another of the same size. It is equivalent to\narrayCopy(src, 0, dst, 0, src.length).\n<br><br>\nUsing this function is far more efficient for copying array data than\niterating through a for() loop and copying each element individually.</p>\n",
            "itemtype": "method",
            "name": "arrayCopy",
            "example": [
                "\n<div class='norender'><code>\nvar src = ['A', 'B', 'C'];\nvar dst = [1, 2, 3];\nvar srcPosition = 1;\nvar dstPosition = 0;\nvar length = 2;\n\nprint(src); // ['A', 'B', 'C']\nprint(dst); // [ 1 ,  2 ,  3 ]\n\narrayCopy(src, srcPosition, dst, dstPosition, length);\nprint(dst); // ['B', 'C', 3]\n</code></div>"
            ],
            "class": "p5",
            "module": "Data",
            "submodule": "Array Functions",
            "overloads": [
                {
                    "line": 35,
                    "params": [
                        {
                            "name": "src",
                            "description": "<p>the source Array</p>\n",
                            "type": "Array"
                        },
                        {
                            "name": "srcPosition",
                            "description": "<p>starting position in the source Array</p>\n",
                            "type": "Integer"
                        },
                        {
                            "name": "dst",
                            "description": "<p>the destination Array</p>\n",
                            "type": "Array"
                        },
                        {
                            "name": "dstPosition",
                            "description": "<p>starting position in the destination Array</p>\n",
                            "type": "Integer"
                        },
                        {
                            "name": "length",
                            "description": "<p>number of Array elements to be copied</p>\n",
                            "type": "Integer"
                        }
                    ]
                },
                {
                    "line": 72,
                    "params": [
                        {
                            "name": "src",
                            "description": "",
                            "type": "Array"
                        },
                        {
                            "name": "dst",
                            "description": "",
                            "type": "Array"
                        },
                        {
                            "name": "length",
                            "description": "",
                            "type": "Integer",
                            "optional": true
                        }
                    ]
                }
            ]
        },
        {
            "file": "src/utilities/array_functions.js",
            "line": 110,
            "description": "<p>Concatenates two arrays, maps to Array.concat(). Does not modify the\ninput arrays.</p>\n",
            "itemtype": "method",
            "name": "concat",
            "params": [
                {
                    "name": "a",
                    "description": "<p>first Array to concatenate</p>\n",
                    "type": "Array"
                },
                {
                    "name": "b",
                    "description": "<p>second Array to concatenate</p>\n",
                    "type": "Array"
                }
            ],
            "return": {
                "description": "concatenated array",
                "type": "Array"
            },
            "example": [
                "\n<div class = 'norender'><code>\nfunction setup() {\n  var arr1 = ['A', 'B', 'C'];\n  var arr2 = [1, 2, 3];\n\n  print(arr1); // ['A','B','C']\n  print(arr2); // [1,2,3]\n\n  var arr3 = concat(arr1, arr2);\n\n  print(arr1); // ['A','B','C']\n  print(arr2); // [1, 2, 3]\n  print(arr3); // ['A','B','C', 1, 2, 3]\n}\n</code></div>"
            ],
            "class": "p5",
            "module": "Data",
            "submodule": "Array Functions"
        },
        {
            "file": "src/utilities/array_functions.js",
            "line": 140,
            "description": "<p>Reverses the order of an array, maps to Array.reverse()</p>\n",
            "itemtype": "method",
            "name": "reverse",
            "params": [
                {
                    "name": "list",
                    "description": "<p>Array to reverse</p>\n",
                    "type": "Array"
                }
            ],
            "example": [
                "\n<div class='norender'><code>\nfunction setup() {\n  var myArray = ['A', 'B', 'C'];\n  print(myArray); // ['A','B','C']\n\n  reverse(myArray);\n  print(myArray); // ['C','B','A']\n}\n</code></div>"
            ],
            "class": "p5",
            "module": "Data",
            "submodule": "Array Functions"
        },
        {
            "file": "src/utilities/array_functions.js",
            "line": 160,
            "description": "<p>Decreases an array by one element and returns the shortened array,\nmaps to Array.pop().</p>\n",
            "itemtype": "method",
            "name": "shorten",
            "params": [
                {
                    "name": "list",
                    "description": "<p>Array to shorten</p>\n",
                    "type": "Array"
                }
            ],
            "return": {
                "description": "shortened Array",
                "type": "Array"
            },
            "example": [
                "\n<div class = 'norender'><code>\nfunction setup() {\n  var myArray = ['A', 'B', 'C'];\n  print(myArray); // ['A', 'B', 'C']\n  var newArray = shorten(myArray);\n  print(myArray); // ['A','B','C']\n  print(newArray); // ['A','B']\n}\n</code></div>"
            ],
            "class": "p5",
            "module": "Data",
            "submodule": "Array Functions"
        },
        {
            "file": "src/utilities/array_functions.js",
            "line": 183,
            "description": "<p>Randomizes the order of the elements of an array. Implements\n<a href='http://Bost.Ocks.org/mike/shuffle/' target=_blank>\nFisher-Yates Shuffle Algorithm</a>.</p>\n",
            "itemtype": "method",
            "name": "shuffle",
            "params": [
                {
                    "name": "array",
                    "description": "<p>Array to shuffle</p>\n",
                    "type": "Array"
                },
                {
                    "name": "bool",
                    "description": "<p>modify passed array</p>\n",
                    "type": "Boolean",
                    "optional": true
                }
            ],
            "return": {
                "description": "shuffled Array",
                "type": "Array"
            },
            "example": [
                "\n<div><code>\nfunction setup() {\n  var regularArr = ['ABC', 'def', createVector(), TAU, Math.E];\n  print(regularArr);\n  shuffle(regularArr, true); // force modifications to passed array\n  print(regularArr);\n\n  // By default shuffle() returns a shuffled cloned array:\n  var newArr = shuffle(regularArr);\n  print(regularArr);\n  print(newArr);\n}\n</code></div>"
            ],
            "class": "p5",
            "module": "Data",
            "submodule": "Array Functions"
        },
        {
            "file": "src/utilities/array_functions.js",
            "line": 225,
            "description": "<p>Sorts an array of numbers from smallest to largest, or puts an array of\nwords in alphabetical order. The original array is not modified; a\nre-ordered array is returned. The count parameter states the number of\nelements to sort. For example, if there are 12 elements in an array and\ncount is set to 5, only the first 5 elements in the array will be sorted.</p>\n",
            "itemtype": "method",
            "name": "sort",
            "params": [
                {
                    "name": "list",
                    "description": "<p>Array to sort</p>\n",
                    "type": "Array"
                },
                {
                    "name": "count",
                    "description": "<p>number of elements to sort, starting from 0</p>\n",
                    "type": "Integer",
                    "optional": true
                }
            ],
            "example": [
                "\n<div class = 'norender'><code>\nfunction setup() {\n  var words = ['banana', 'apple', 'pear', 'lime'];\n  print(words); // ['banana', 'apple', 'pear', 'lime']\n  var count = 4; // length of array\n\n  words = sort(words, count);\n  print(words); // ['apple', 'banana', 'lime', 'pear']\n}\n</code></div>\n<div class = 'norender'><code>\nfunction setup() {\n  var numbers = [2, 6, 1, 5, 14, 9, 8, 12];\n  print(numbers); // [2, 6, 1, 5, 14, 9, 8, 12]\n  var count = 5; // Less than the length of the array\n\n  numbers = sort(numbers, count);\n  print(numbers); // [1,2,5,6,14,9,8,12]\n}\n</code></div>"
            ],
            "class": "p5",
            "module": "Data",
            "submodule": "Array Functions"
        },
        {
            "file": "src/utilities/array_functions.js",
            "line": 271,
            "description": "<p>Inserts a value or an array of values into an existing array. The first\nparameter specifies the initial array to be modified, and the second\nparameter defines the data to be inserted. The third parameter is an index\nvalue which specifies the array position from which to insert data.\n(Remember that array index numbering starts at zero, so the first position\nis 0, the second position is 1, and so on.)</p>\n",
            "itemtype": "method",
            "name": "splice",
            "params": [
                {
                    "name": "list",
                    "description": "<p>Array to splice into</p>\n",
                    "type": "Array"
                },
                {
                    "name": "value",
                    "description": "<p>value to be spliced in</p>\n",
                    "type": "Any"
                },
                {
                    "name": "position",
                    "description": "<p>in the array from which to insert data</p>\n",
                    "type": "Integer"
                }
            ],
            "example": [
                "\n<div class = 'norender'><code>\nfunction setup() {\n  var myArray = [0, 1, 2, 3, 4];\n  var insArray = ['A', 'B', 'C'];\n  print(myArray); // [0, 1, 2, 3, 4]\n  print(insArray); // ['A','B','C']\n\n  splice(myArray, insArray, 3);\n  print(myArray); // [0,1,2,'A','B','C',3,4]\n}\n</code></div>"
            ],
            "class": "p5",
            "module": "Data",
            "submodule": "Array Functions"
        },
        {
            "file": "src/utilities/array_functions.js",
            "line": 304,
            "description": "<p>Extracts an array of elements from an existing array. The list parameter\ndefines the array from which the elements will be copied, and the start\nand count parameters specify which elements to extract. If no count is\ngiven, elements will be extracted from the start to the end of the array.\nWhen specifying the start, remember that the first array element is 0.\nThis function does not change the source array.</p>\n",
            "itemtype": "method",
            "name": "subset",
            "params": [
                {
                    "name": "list",
                    "description": "<p>Array to extract from</p>\n",
                    "type": "Array"
                },
                {
                    "name": "start",
                    "description": "<p>position to begin</p>\n",
                    "type": "Integer"
                },
                {
                    "name": "count",
                    "description": "<p>number of values to extract</p>\n",
                    "type": "Integer",
                    "optional": true
                }
            ],
            "return": {
                "description": "Array of extracted elements",
                "type": "Array"
            },
            "example": [
                "\n<div class = 'norender'><code>\nfunction setup() {\n  var myArray = [1, 2, 3, 4, 5];\n  print(myArray); // [1, 2, 3, 4, 5]\n\n  var sub1 = subset(myArray, 0, 3);\n  var sub2 = subset(myArray, 2, 2);\n  print(sub1); // [1,2,3]\n  print(sub2); // [3,4]\n}\n</code></div>"
            ],
            "class": "p5",
            "module": "Data",
            "submodule": "Array Functions"
        },
        {
            "file": "src/utilities/conversion.js",
            "line": 12,
            "description": "<p>Converts a string to its floating point representation. The contents of a\nstring must resemble a number, or NaN (not a number) will be returned.\nFor example, float(&quot;1234.56&quot;) evaluates to 1234.56, but float(&quot;giraffe&quot;)\nwill return NaN.</p>\n<p>When an array of values is passed in, then an array of floats of the same\nlength is returned.</p>\n",
            "itemtype": "method",
            "name": "float",
            "params": [
                {
                    "name": "str",
                    "description": "<p>float string to parse</p>\n",
                    "type": "String"
                }
            ],
            "return": {
                "description": "floating point representation of string",
                "type": "Number"
            },
            "example": [
                "\n<div><code>\nvar str = '20';\nvar diameter = float(str);\nellipse(width / 2, height / 2, diameter, diameter);\n</code></div>"
            ],
            "alt": "20 by 20 white ellipse in the center of the canvas",
            "class": "p5",
            "module": "Data",
            "submodule": "Conversion"
        },
        {
            "file": "src/utilities/conversion.js",
            "line": 42,
            "description": "<p>Converts a boolean, string, or float to its integer representation.\nWhen an array of values is passed in, then an int array of the same length\nis returned.</p>\n",
            "itemtype": "method",
            "name": "int",
            "return": {
                "description": "integer representation of value",
                "type": "Number"
            },
            "example": [
                "\n<div class='norender'><code>\nprint(int('10')); // 10\nprint(int(10.31)); // 10\nprint(int(-10)); // -10\nprint(int(true)); // 1\nprint(int(false)); // 0\nprint(int([false, true, '10.3', 9.8])); // [0, 1, 10, 9]\n</code></div>"
            ],
            "class": "p5",
            "module": "Data",
            "submodule": "Conversion",
            "overloads": [
                {
                    "line": 42,
                    "params": [
                        {
                            "name": "n",
                            "description": "<p>value to parse</p>\n",
                            "type": "String|Boolean|Number"
                        }
                    ],
                    "return": {
                        "description": "integer representation of value",
                        "type": "Number"
                    }
                },
                {
                    "line": 61,
                    "params": [
                        {
                            "name": "ns",
                            "description": "<p>values to parse</p>\n",
                            "type": "Array"
                        }
                    ],
                    "return": {
                        "description": "integer representation of values",
                        "type": "Number[]"
                    }
                }
            ]
        },
        {
            "file": "src/utilities/conversion.js",
            "line": 81,
            "description": "<p>Converts a boolean, string or number to its string representation.\nWhen an array of values is passed in, then an array of strings of the same\nlength is returned.</p>\n",
            "itemtype": "method",
            "name": "str",
            "params": [
                {
                    "name": "n",
                    "description": "<p>value to parse</p>\n",
                    "type": "String|Boolean|Number|Array"
                }
            ],
            "return": {
                "description": "string representation of value",
                "type": "String"
            },
            "example": [
                "\n<div class='norender'><code>\nprint(str('10')); // \"10\"\nprint(str(10.31)); // \"10.31\"\nprint(str(-10)); // \"-10\"\nprint(str(true)); // \"true\"\nprint(str(false)); // \"false\"\nprint(str([true, '10.3', 9.8])); // [ \"true\", \"10.3\", \"9.8\" ]\n</code></div>"
            ],
            "class": "p5",
            "module": "Data",
            "submodule": "Conversion"
        },
        {
            "file": "src/utilities/conversion.js",
            "line": 107,
            "description": "<p>Converts a number or string to its boolean representation.\nFor a number, any non-zero value (positive or negative) evaluates to true,\nwhile zero evaluates to false. For a string, the value &quot;true&quot; evaluates to\ntrue, while any other value evaluates to false. When an array of number or\nstring values is passed in, then a array of booleans of the same length is\nreturned.</p>\n",
            "itemtype": "method",
            "name": "boolean",
            "params": [
                {
                    "name": "n",
                    "description": "<p>value to parse</p>\n",
                    "type": "String|Boolean|Number|Array"
                }
            ],
            "return": {
                "description": "boolean representation of value",
                "type": "Boolean"
            },
            "example": [
                "\n<div class='norender'><code>\nprint(boolean(0)); // false\nprint(boolean(1)); // true\nprint(boolean('true')); // true\nprint(boolean('abcd')); // false\nprint(boolean([0, 12, 'true'])); // [false, true, false]\n</code></div>"
            ],
            "class": "p5",
            "module": "Data",
            "submodule": "Conversion"
        },
        {
            "file": "src/utilities/conversion.js",
            "line": 139,
            "description": "<p>Converts a number, string representation of a number, or boolean to its byte\nrepresentation. A byte can be only a whole number between -128 and 127, so\nwhen a value outside of this range is converted, it wraps around to the\ncorresponding byte representation. When an array of number, string or boolean\nvalues is passed in, then an array of bytes the same length is returned.</p>\n",
            "itemtype": "method",
            "name": "byte",
            "return": {
                "description": "byte representation of value",
                "type": "Number"
            },
            "example": [
                "\n<div class='norender'><code>\nprint(byte(127)); // 127\nprint(byte(128)); // -128\nprint(byte(23.4)); // 23\nprint(byte('23.4')); // 23\nprint(byte('hello')); // NaN\nprint(byte(true)); // 1\nprint(byte([0, 255, '100'])); // [0, -1, 100]\n</code></div>"
            ],
            "class": "p5",
            "module": "Data",
            "submodule": "Conversion",
            "overloads": [
                {
                    "line": 139,
                    "params": [
                        {
                            "name": "n",
                            "description": "<p>value to parse</p>\n",
                            "type": "String|Boolean|Number"
                        }
                    ],
                    "return": {
                        "description": "byte representation of value",
                        "type": "Number"
                    }
                },
                {
                    "line": 161,
                    "params": [
                        {
                            "name": "ns",
                            "description": "<p>values to parse</p>\n",
                            "type": "Array"
                        }
                    ],
                    "return": {
                        "description": "array of byte representation of values",
                        "type": "Number[]"
                    }
                }
            ]
        },
        {
            "file": "src/utilities/conversion.js",
            "line": 175,
            "description": "<p>Converts a number or string to its corresponding single-character\nstring representation. If a string parameter is provided, it is first\nparsed as an integer and then translated into a single-character string.\nWhen an array of number or string values is passed in, then an array of\nsingle-character strings of the same length is returned.</p>\n",
            "itemtype": "method",
            "name": "char",
            "return": {
                "description": "string representation of value",
                "type": "String"
            },
            "example": [
                "\n<div class='norender'><code>\nprint(char(65)); // \"A\"\nprint(char('65')); // \"A\"\nprint(char([65, 66, 67])); // [ \"A\", \"B\", \"C\" ]\nprint(join(char([65, 66, 67]), '')); // \"ABC\"\n</code></div>"
            ],
            "class": "p5",
            "module": "Data",
            "submodule": "Conversion",
            "overloads": [
                {
                    "line": 175,
                    "params": [
                        {
                            "name": "n",
                            "description": "<p>value to parse</p>\n",
                            "type": "String|Number"
                        }
                    ],
                    "return": {
                        "description": "string representation of value",
                        "type": "String"
                    }
                },
                {
                    "line": 194,
                    "params": [
                        {
                            "name": "ns",
                            "description": "<p>values to parse</p>\n",
                            "type": "Array"
                        }
                    ],
                    "return": {
                        "description": "array of string representation of values",
                        "type": "String[]"
                    }
                }
            ]
        },
        {
            "file": "src/utilities/conversion.js",
            "line": 209,
            "description": "<p>Converts a single-character string to its corresponding integer\nrepresentation. When an array of single-character string values is passed\nin, then an array of integers of the same length is returned.</p>\n",
            "itemtype": "method",
            "name": "unchar",
            "return": {
                "description": "integer representation of value",
                "type": "Number"
            },
            "example": [
                "\n<div class='norender'><code>\nprint(unchar('A')); // 65\nprint(unchar(['A', 'B', 'C'])); // [ 65, 66, 67 ]\nprint(unchar(split('ABC', ''))); // [ 65, 66, 67 ]\n</code></div>"
            ],
            "class": "p5",
            "module": "Data",
            "submodule": "Conversion",
            "overloads": [
                {
                    "line": 209,
                    "params": [
                        {
                            "name": "n",
                            "description": "<p>value to parse</p>\n",
                            "type": "String"
                        }
                    ],
                    "return": {
                        "description": "integer representation of value",
                        "type": "Number"
                    }
                },
                {
                    "line": 225,
                    "params": [
                        {
                            "name": "ns",
                            "description": "<p>values to parse</p>\n",
                            "type": "Array"
                        }
                    ],
                    "return": {
                        "description": "integer representation of values",
                        "type": "Number[]"
                    }
                }
            ]
        },
        {
            "file": "src/utilities/conversion.js",
            "line": 238,
            "description": "<p>Converts a number to a string in its equivalent hexadecimal notation. If a\nsecond parameter is passed, it is used to set the number of characters to\ngenerate in the hexadecimal notation. When an array is passed in, an\narray of strings in hexadecimal notation of the same length is returned.</p>\n",
            "itemtype": "method",
            "name": "hex",
            "return": {
                "description": "hexadecimal string representation of value",
                "type": "String"
            },
            "example": [
                "\n<div class='norender'><code>\nprint(hex(255)); // \"000000FF\"\nprint(hex(255, 6)); // \"0000FF\"\nprint(hex([0, 127, 255], 6)); // [ \"000000\", \"00007F\", \"0000FF\" ]\n</code></div>"
            ],
            "class": "p5",
            "module": "Data",
            "submodule": "Conversion",
            "overloads": [
                {
                    "line": 238,
                    "params": [
                        {
                            "name": "n",
                            "description": "<p>value to parse</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "digits",
                            "description": "",
                            "type": "Number",
                            "optional": true
                        }
                    ],
                    "return": {
                        "description": "hexadecimal string representation of value",
                        "type": "String"
                    }
                },
                {
                    "line": 256,
                    "params": [
                        {
                            "name": "ns",
                            "description": "<p>array of values to parse</p>\n",
                            "type": "Number[]"
                        },
                        {
                            "name": "digits",
                            "description": "",
                            "type": "Number",
                            "optional": true
                        }
                    ],
                    "return": {
                        "description": "hexadecimal string representation of values",
                        "type": "String[]"
                    }
                }
            ]
        },
        {
            "file": "src/utilities/conversion.js",
            "line": 285,
            "description": "<p>Converts a string representation of a hexadecimal number to its equivalent\ninteger value. When an array of strings in hexadecimal notation is passed\nin, an array of integers of the same length is returned.</p>\n",
            "itemtype": "method",
            "name": "unhex",
            "return": {
                "description": "integer representation of hexadecimal value",
                "type": "Number"
            },
            "example": [
                "\n<div class='norender'><code>\nprint(unhex('A')); // 10\nprint(unhex('FF')); // 255\nprint(unhex(['FF', 'AA', '00'])); // [ 255, 170, 0 ]\n</code></div>"
            ],
            "class": "p5",
            "module": "Data",
            "submodule": "Conversion",
            "overloads": [
                {
                    "line": 285,
                    "params": [
                        {
                            "name": "n",
                            "description": "<p>value to parse</p>\n",
                            "type": "String"
                        }
                    ],
                    "return": {
                        "description": "integer representation of hexadecimal value",
                        "type": "Number"
                    }
                },
                {
                    "line": 301,
                    "params": [
                        {
                            "name": "ns",
                            "description": "<p>values to parse</p>\n",
                            "type": "Array"
                        }
                    ],
                    "return": {
                        "description": "integer representations of hexadecimal value",
                        "type": "Number[]"
                    }
                }
            ]
        },
        {
            "file": "src/utilities/string_functions.js",
            "line": 15,
            "description": "<p>Combines an array of Strings into one String, each separated by the\ncharacter(s) used for the separator parameter. To join arrays of ints or\nfloats, it&#39;s necessary to first convert them to Strings using nf() or\nnfs().</p>\n",
            "itemtype": "method",
            "name": "join",
            "params": [
                {
                    "name": "list",
                    "description": "<p>array of Strings to be joined</p>\n",
                    "type": "Array"
                },
                {
                    "name": "separator",
                    "description": "<p>String to be placed between each item</p>\n",
                    "type": "String"
                }
            ],
            "return": {
                "description": "joined String",
                "type": "String"
            },
            "example": [
                "\n<div>\n<code>\nvar array = ['Hello', 'world!'];\nvar separator = ' ';\nvar message = join(array, separator);\ntext(message, 5, 50);\n</code>\n</div>"
            ],
            "alt": "\"hello world!\" displayed middle left of canvas.",
            "class": "p5",
            "module": "Data",
            "submodule": "String Functions"
        },
        {
            "file": "src/utilities/string_functions.js",
            "line": 44,
            "description": "<p>This function is used to apply a regular expression to a piece of text,\nand return matching groups (elements found inside parentheses) as a\nString array. If there are no matches, a null value will be returned.\nIf no groups are specified in the regular expression, but the sequence\nmatches, an array of length 1 (with the matched text as the first element\nof the array) will be returned.\n<br><br>\nTo use the function, first check to see if the result is null. If the\nresult is null, then the sequence did not match at all. If the sequence\ndid match, an array is returned.\n<br><br>\nIf there are groups (specified by sets of parentheses) in the regular\nexpression, then the contents of each will be returned in the array.\nElement [0] of a regular expression match returns the entire matching\nstring, and the match groups start at element [1] (the first group is [1],\nthe second [2], and so on).</p>\n",
            "itemtype": "method",
            "name": "match",
            "params": [
                {
                    "name": "str",
                    "description": "<p>the String to be searched</p>\n",
                    "type": "String"
                },
                {
                    "name": "regexp",
                    "description": "<p>the regexp to be used for matching</p>\n",
                    "type": "String"
                }
            ],
            "return": {
                "description": "Array of Strings found",
                "type": "String[]"
            },
            "example": [
                "\n<div>\n<code>\nvar string = 'Hello p5js*!';\nvar regexp = 'p5js\\\\*';\nvar m = match(string, regexp);\ntext(m, 5, 50);\n</code>\n</div>"
            ],
            "alt": "\"p5js*\" displayed middle left of canvas.",
            "class": "p5",
            "module": "Data",
            "submodule": "String Functions"
        },
        {
            "file": "src/utilities/string_functions.js",
            "line": 85,
            "description": "<p>This function is used to apply a regular expression to a piece of text,\nand return a list of matching groups (elements found inside parentheses)\nas a two-dimensional String array. If there are no matches, a null value\nwill be returned. If no groups are specified in the regular expression,\nbut the sequence matches, a two dimensional array is still returned, but\nthe second dimension is only of length one.\n<br><br>\nTo use the function, first check to see if the result is null. If the\nresult is null, then the sequence did not match at all. If the sequence\ndid match, a 2D array is returned.\n<br><br>\nIf there are groups (specified by sets of parentheses) in the regular\nexpression, then the contents of each will be returned in the array.\nAssuming a loop with counter variable i, element [i][0] of a regular\nexpression match returns the entire matching string, and the match groups\nstart at element [i][1] (the first group is [i][1], the second [i][2],\nand so on).</p>\n",
            "itemtype": "method",
            "name": "matchAll",
            "params": [
                {
                    "name": "str",
                    "description": "<p>the String to be searched</p>\n",
                    "type": "String"
                },
                {
                    "name": "regexp",
                    "description": "<p>the regexp to be used for matching</p>\n",
                    "type": "String"
                }
            ],
            "return": {
                "description": "2d Array of Strings found",
                "type": "String[]"
            },
            "example": [
                "\n<div class=\"norender\">\n<code>\nvar string = 'Hello p5js*! Hello world!';\nvar regexp = 'Hello';\nmatchAll(string, regexp);\n</code>\n</div>"
            ],
            "class": "p5",
            "module": "Data",
            "submodule": "String Functions"
        },
        {
            "file": "src/utilities/string_functions.js",
            "line": 132,
            "description": "<p>Utility function for formatting numbers into strings. There are two\nversions: one for formatting floats, and one for formatting ints.\nThe values for the digits, left, and right parameters should always\nbe positive integers.</p>\n",
            "itemtype": "method",
            "name": "nf",
            "return": {
                "description": "formatted String",
                "type": "String"
            },
            "example": [
                "\n<div>\n<code>\nfunction setup() {\n  background(200);\n  var num = 112.53106115;\n\n  noStroke();\n  fill(0);\n  textSize(14);\n  // Draw formatted numbers\n  text(nf(num, 5, 2), 10, 20);\n\n  text(nf(num, 4, 3), 10, 55);\n\n  text(nf(num, 3, 6), 10, 85);\n\n  // Draw dividing lines\n  stroke(120);\n  line(0, 30, width, 30);\n  line(0, 65, width, 65);\n}\n</code>\n</div>"
            ],
            "alt": "\"0011253\" top left, \"0112.531\" mid left, \"112.531061\" bottom left canvas",
            "class": "p5",
            "module": "Data",
            "submodule": "String Functions",
            "overloads": [
                {
                    "line": 132,
                    "params": [
                        {
                            "name": "num",
                            "description": "<p>the Number to format</p>\n",
                            "type": "Number|String"
                        },
                        {
                            "name": "left",
                            "description": "<p>number of digits to the left of the\n                               decimal point</p>\n",
                            "type": "Integer|String",
                            "optional": true
                        },
                        {
                            "name": "right",
                            "description": "<p>number of digits to the right of the\n                               decimal point</p>\n",
                            "type": "Integer|String",
                            "optional": true
                        }
                    ],
                    "return": {
                        "description": "formatted String",
                        "type": "String"
                    }
                },
                {
                    "line": 174,
                    "params": [
                        {
                            "name": "nums",
                            "description": "<p>the Numbers to format</p>\n",
                            "type": "Array"
                        },
                        {
                            "name": "left",
                            "description": "",
                            "type": "Integer|String",
                            "optional": true
                        },
                        {
                            "name": "right",
                            "description": "",
                            "type": "Integer|String",
                            "optional": true
                        }
                    ],
                    "return": {
                        "description": "formatted Strings",
                        "type": "String[]"
                    }
                }
            ]
        },
        {
            "file": "src/utilities/string_functions.js",
            "line": 237,
            "description": "<p>Utility function for formatting numbers into strings and placing\nappropriate commas to mark units of 1000. There are two versions: one\nfor formatting ints, and one for formatting an array of ints. The value\nfor the right parameter should always be a positive integer.</p>\n",
            "itemtype": "method",
            "name": "nfc",
            "return": {
                "description": "formatted String",
                "type": "String"
            },
            "example": [
                "\n<div>\n<code>\nfunction setup() {\n  background(200);\n  var num = 11253106.115;\n  var numArr = [1, 1, 2];\n\n  noStroke();\n  fill(0);\n  textSize(12);\n\n  // Draw formatted numbers\n  text(nfc(num, 4), 10, 30);\n  text(nfc(numArr, 2), 10, 80);\n\n  // Draw dividing line\n  stroke(120);\n  line(0, 50, width, 50);\n}\n</code>\n</div>"
            ],
            "alt": "\"11,253,106.115\" top middle and \"1.00,1.00,2.00\" displayed bottom mid",
            "class": "p5",
            "module": "Data",
            "submodule": "String Functions",
            "overloads": [
                {
                    "line": 237,
                    "params": [
                        {
                            "name": "num",
                            "description": "<p>the Number to format</p>\n",
                            "type": "Number|String"
                        },
                        {
                            "name": "right",
                            "description": "<p>number of digits to the right of the\n                                 decimal point</p>\n",
                            "type": "Integer|String",
                            "optional": true
                        }
                    ],
                    "return": {
                        "description": "formatted String",
                        "type": "String"
                    }
                },
                {
                    "line": 275,
                    "params": [
                        {
                            "name": "nums",
                            "description": "<p>the Numbers to format</p>\n",
                            "type": "Array"
                        },
                        {
                            "name": "right",
                            "description": "",
                            "type": "Integer|String",
                            "optional": true
                        }
                    ],
                    "return": {
                        "description": "formatted Strings",
                        "type": "String[]"
                    }
                }
            ]
        },
        {
            "file": "src/utilities/string_functions.js",
            "line": 313,
            "description": "<p>Utility function for formatting numbers into strings. Similar to nf() but\nputs a &quot;+&quot; in front of positive numbers and a &quot;-&quot; in front of negative\nnumbers. There are two versions: one for formatting floats, and one for\nformatting ints. The values for left, and right parameters\nshould always be positive integers.</p>\n",
            "itemtype": "method",
            "name": "nfp",
            "return": {
                "description": "formatted String",
                "type": "String"
            },
            "example": [
                "\n<div>\n<code>\nfunction setup() {\n  background(200);\n  var num1 = 11253106.115;\n  var num2 = -11253106.115;\n\n  noStroke();\n  fill(0);\n  textSize(12);\n\n  // Draw formatted numbers\n  text(nfp(num1, 4, 2), 10, 30);\n  text(nfp(num2, 4, 2), 10, 80);\n\n  // Draw dividing line\n  stroke(120);\n  line(0, 50, width, 50);\n}\n</code>\n</div>"
            ],
            "alt": "\"+11253106.11\" top middle and \"-11253106.11\" displayed bottom middle",
            "class": "p5",
            "module": "Data",
            "submodule": "String Functions",
            "overloads": [
                {
                    "line": 313,
                    "params": [
                        {
                            "name": "num",
                            "description": "<p>the Number to format</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "left",
                            "description": "<p>number of digits to the left of the decimal\n                               point</p>\n",
                            "type": "Integer",
                            "optional": true
                        },
                        {
                            "name": "right",
                            "description": "<p>number of digits to the right of the\n                               decimal point</p>\n",
                            "type": "Integer",
                            "optional": true
                        }
                    ],
                    "return": {
                        "description": "formatted String",
                        "type": "String"
                    }
                },
                {
                    "line": 354,
                    "params": [
                        {
                            "name": "nums",
                            "description": "<p>the Numbers to format</p>\n",
                            "type": "Number[]"
                        },
                        {
                            "name": "left",
                            "description": "",
                            "type": "Integer",
                            "optional": true
                        },
                        {
                            "name": "right",
                            "description": "",
                            "type": "Integer",
                            "optional": true
                        }
                    ],
                    "return": {
                        "description": "formatted Strings",
                        "type": "String[]"
                    }
                }
            ]
        },
        {
            "file": "src/utilities/string_functions.js",
            "line": 375,
            "description": "<p>Utility function for formatting numbers into strings. Similar to nf() but\nputs a &quot; &quot; (space) in front of positive numbers and a &quot;-&quot; in front of\nnegative numbers. There are two versions: one for formatting floats, and\none for formatting ints. The values for the digits, left, and right\nparameters should always be positive integers.</p>\n",
            "itemtype": "method",
            "name": "nfs",
            "return": {
                "description": "formatted String",
                "type": "String"
            },
            "example": [
                "\n<div>\n<code>\nfunction setup() {\n  background(200);\n  var num1 = 11253106.115;\n  var num2 = -11253106.115;\n\n  noStroke();\n  fill(0);\n  textSize(12);\n  // Draw formatted numbers\n  text(nfs(num1, 4, 2), 10, 30);\n\n  text(nfs(num2, 4, 2), 10, 80);\n\n  // Draw dividing line\n  stroke(120);\n  line(0, 50, width, 50);\n}\n</code>\n</div>"
            ],
            "alt": "\"11253106.11\" top middle and \"-11253106.11\" displayed bottom middle",
            "class": "p5",
            "module": "Data",
            "submodule": "String Functions",
            "overloads": [
                {
                    "line": 375,
                    "params": [
                        {
                            "name": "num",
                            "description": "<p>the Number to format</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "left",
                            "description": "<p>number of digits to the left of the decimal\n                               point</p>\n",
                            "type": "Integer",
                            "optional": true
                        },
                        {
                            "name": "right",
                            "description": "<p>number of digits to the right of the\n                               decimal point</p>\n",
                            "type": "Integer",
                            "optional": true
                        }
                    ],
                    "return": {
                        "description": "formatted String",
                        "type": "String"
                    }
                },
                {
                    "line": 416,
                    "params": [
                        {
                            "name": "nums",
                            "description": "<p>the Numbers to format</p>\n",
                            "type": "Array"
                        },
                        {
                            "name": "left",
                            "description": "",
                            "type": "Integer",
                            "optional": true
                        },
                        {
                            "name": "right",
                            "description": "",
                            "type": "Integer",
                            "optional": true
                        }
                    ],
                    "return": {
                        "description": "formatted Strings",
                        "type": "String[]"
                    }
                }
            ]
        },
        {
            "file": "src/utilities/string_functions.js",
            "line": 437,
            "description": "<p>The split() function maps to String.split(), it breaks a String into\npieces using a character or string as the delimiter. The delim parameter\nspecifies the character or characters that mark the boundaries between\neach piece. A String[] array is returned that contains each of the pieces.</p>\n<p>The splitTokens() function works in a similar fashion, except that it\nsplits using a range of characters instead of a specific character or\nsequence.</p>\n",
            "itemtype": "method",
            "name": "split",
            "params": [
                {
                    "name": "value",
                    "description": "<p>the String to be split</p>\n",
                    "type": "String"
                },
                {
                    "name": "delim",
                    "description": "<p>the String used to separate the data</p>\n",
                    "type": "String"
                }
            ],
            "return": {
                "description": "Array of Strings",
                "type": "String[]"
            },
            "example": [
                "\n<div>\n<code>\nvar names = 'Pat,Xio,Alex';\nvar splitString = split(names, ',');\ntext(splitString[0], 5, 30);\ntext(splitString[1], 5, 50);\ntext(splitString[2], 5, 70);\n</code>\n</div>"
            ],
            "alt": "\"pat\" top left, \"Xio\" mid left and \"Alex\" displayed bottom left",
            "class": "p5",
            "module": "Data",
            "submodule": "String Functions"
        },
        {
            "file": "src/utilities/string_functions.js",
            "line": 471,
            "description": "<p>The splitTokens() function splits a String at one or many character\ndelimiters or &quot;tokens.&quot; The delim parameter specifies the character or\ncharacters to be used as a boundary.\n<br><br>\nIf no delim characters are specified, any whitespace character is used to\nsplit. Whitespace characters include tab (\\t), line feed (\\n), carriage\nreturn (\\r), form feed (\\f), and space.</p>\n",
            "itemtype": "method",
            "name": "splitTokens",
            "params": [
                {
                    "name": "value",
                    "description": "<p>the String to be split</p>\n",
                    "type": "String"
                },
                {
                    "name": "delim",
                    "description": "<p>list of individual Strings that will be used as\n                         separators</p>\n",
                    "type": "String",
                    "optional": true
                }
            ],
            "return": {
                "description": "Array of Strings",
                "type": "String[]"
            },
            "example": [
                "\n<div class = \"norender\">\n<code>\nfunction setup() {\n  var myStr = 'Mango, Banana, Lime';\n  var myStrArr = splitTokens(myStr, ',');\n\n  print(myStrArr); // prints : [\"Mango\",\" Banana\",\" Lime\"]\n}\n</code>\n</div>"
            ],
            "class": "p5",
            "module": "Data",
            "submodule": "String Functions"
        },
        {
            "file": "src/utilities/string_functions.js",
            "line": 526,
            "description": "<p>Removes whitespace characters from the beginning and end of a String. In\naddition to standard whitespace characters such as space, carriage return,\nand tab, this function also removes the Unicode &quot;nbsp&quot; character.</p>\n",
            "itemtype": "method",
            "name": "trim",
            "return": {
                "description": "a trimmed String",
                "type": "String"
            },
            "example": [
                "\n<div>\n<code>\nvar string = trim('  No new lines\\n   ');\ntext(string + ' here', 2, 50);\n</code>\n</div>"
            ],
            "alt": "\"No new lines here\" displayed center canvas",
            "class": "p5",
            "module": "Data",
            "submodule": "String Functions",
            "overloads": [
                {
                    "line": 526,
                    "params": [
                        {
                            "name": "str",
                            "description": "<p>a String to be trimmed</p>\n",
                            "type": "String"
                        }
                    ],
                    "return": {
                        "description": "a trimmed String",
                        "type": "String"
                    }
                },
                {
                    "line": 546,
                    "params": [
                        {
                            "name": "strs",
                            "description": "<p>an Array of Strings to be trimmed</p>\n",
                            "type": "Array"
                        }
                    ],
                    "return": {
                        "description": "an Array of trimmed Strings",
                        "type": "String[]"
                    }
                }
            ]
        },
        {
            "file": "src/utilities/time_date.js",
            "line": 12,
            "description": "<p>p5.js communicates with the clock on your computer. The day() function\nreturns the current day as a value from 1 - 31.</p>\n",
            "itemtype": "method",
            "name": "day",
            "return": {
                "description": "the current day",
                "type": "Integer"
            },
            "example": [
                "\n<div>\n<code>\nvar d = day();\ntext('Current day: \\n' + d, 5, 50);\n</code>\n</div>"
            ],
            "alt": "Current day is displayed",
            "class": "p5",
            "module": "IO",
            "submodule": "Time & Date"
        },
        {
            "file": "src/utilities/time_date.js",
            "line": 34,
            "description": "<p>p5.js communicates with the clock on your computer. The hour() function\nreturns the current hour as a value from 0 - 23.</p>\n",
            "itemtype": "method",
            "name": "hour",
            "return": {
                "description": "the current hour",
                "type": "Integer"
            },
            "example": [
                "\n<div>\n<code>\nvar h = hour();\ntext('Current hour:\\n' + h, 5, 50);\n</code>\n</div>"
            ],
            "alt": "Current hour is displayed",
            "class": "p5",
            "module": "IO",
            "submodule": "Time & Date"
        },
        {
            "file": "src/utilities/time_date.js",
            "line": 56,
            "description": "<p>p5.js communicates with the clock on your computer. The minute() function\nreturns the current minute as a value from 0 - 59.</p>\n",
            "itemtype": "method",
            "name": "minute",
            "return": {
                "description": "the current minute",
                "type": "Integer"
            },
            "example": [
                "\n<div>\n<code>\nvar m = minute();\ntext('Current minute: \\n' + m, 5, 50);\n</code>\n</div>"
            ],
            "alt": "Current minute is displayed",
            "class": "p5",
            "module": "IO",
            "submodule": "Time & Date"
        },
        {
            "file": "src/utilities/time_date.js",
            "line": 78,
            "description": "<p>Returns the number of milliseconds (thousandths of a second) since\nstarting the program. This information is often used for timing events and\nanimation sequences.</p>\n",
            "itemtype": "method",
            "name": "millis",
            "return": {
                "description": "the number of milliseconds since starting the program",
                "type": "Number"
            },
            "example": [
                "\n<div>\n<code>\nvar millisecond = millis();\ntext('Milliseconds \\nrunning: \\n' + millisecond, 5, 40);\n</code>\n</div>"
            ],
            "alt": "number of milliseconds since program has started displayed",
            "class": "p5",
            "module": "IO",
            "submodule": "Time & Date"
        },
        {
            "file": "src/utilities/time_date.js",
            "line": 101,
            "description": "<p>p5.js communicates with the clock on your computer. The month() function\nreturns the current month as a value from 1 - 12.</p>\n",
            "itemtype": "method",
            "name": "month",
            "return": {
                "description": "the current month",
                "type": "Integer"
            },
            "example": [
                "\n<div>\n<code>\nvar m = month();\ntext('Current month: \\n' + m, 5, 50);\n</code>\n</div>"
            ],
            "alt": "Current month is displayed",
            "class": "p5",
            "module": "IO",
            "submodule": "Time & Date"
        },
        {
            "file": "src/utilities/time_date.js",
            "line": 123,
            "description": "<p>p5.js communicates with the clock on your computer. The second() function\nreturns the current second as a value from 0 - 59.</p>\n",
            "itemtype": "method",
            "name": "second",
            "return": {
                "description": "the current second",
                "type": "Integer"
            },
            "example": [
                "\n<div>\n<code>\nvar s = second();\ntext('Current second: \\n' + s, 5, 50);\n</code>\n</div>"
            ],
            "alt": "Current second is displayed",
            "class": "p5",
            "module": "IO",
            "submodule": "Time & Date"
        },
        {
            "file": "src/utilities/time_date.js",
            "line": 145,
            "description": "<p>p5.js communicates with the clock on your computer. The year() function\nreturns the current year as an integer (2014, 2015, 2016, etc).</p>\n",
            "itemtype": "method",
            "name": "year",
            "return": {
                "description": "the current year",
                "type": "Integer"
            },
            "example": [
                "\n<div>\n<code>\nvar y = year();\ntext('Current year: \\n' + y, 5, 50);\n</code>\n</div>"
            ],
            "alt": "Current year is displayed",
            "class": "p5",
            "module": "IO",
            "submodule": "Time & Date"
        },
        {
            "file": "src/webgl/camera.js",
            "line": 12,
            "description": "<p>Sets camera position for a 3D sketch. The function behaves similarly\ngluLookAt, except that it replaces the existing modelview matrix instead\nof applying any transformations calculated here on top of the existing\nmodel view.\nWhen called with no arguments, this function\nsets a default camera equivalent to calling\ncamera(0, 0, (height/2.0) / tan(PI*30.0 / 180.0), 0, 0, 0, 0, 1, 0);</p>\n",
            "itemtype": "method",
            "name": "camera",
            "params": [
                {
                    "name": "x",
                    "description": "<p>camera position value on x axis</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "y",
                    "description": "<p>camera position value on y axis</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "z",
                    "description": "<p>camera position value on z axis</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "centerX",
                    "description": "<p>x coordinate representing center of the sketch</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "centerY",
                    "description": "<p>y coordinate representing center of the sketch</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "centerZ",
                    "description": "<p>z coordinate representing center of the sketch</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "upX",
                    "description": "<p>x component of direction &#39;up&#39; from camera</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "upY",
                    "description": "<p>y component of direction &#39;up&#39; from camera</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "upZ",
                    "description": "<p>z component of direction &#39;up&#39; from camera</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\nfunction setup() {\n  createCanvas(100, 100, WEBGL);\n}\nfunction draw() {\n  //move the camera away from the plane by a sin wave\n  camera(0, 0, sin(frameCount * 0.01) * 100, 0, 0, 0, 0, 1, 0);\n  plane(120, 120);\n}\n</code>\n</div>"
            ],
            "alt": "blue square shrinks in size grows to fill canvas. disappears then loops.",
            "class": "p5",
            "module": "Lights, Camera",
            "submodule": "Camera"
        },
        {
            "file": "src/webgl/camera.js",
            "line": 159,
            "description": "<p>Sets perspective camera. When called with no arguments, the defaults\nprovided are equivalent to\nperspective(PI/3.0, width/height, cameraZ/10.0, cameraZ<em>10.0)\nwhere cameraZ is ((height/2.0) / tan(PI</em>60.0/360.0));</p>\n",
            "itemtype": "method",
            "name": "perspective",
            "params": [
                {
                    "name": "fovy",
                    "description": "<p>camera frustum vertical field of view,\n                          from bottom to top of view, in degrees</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "aspect",
                    "description": "<p>camera frustum aspect ratio</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "near",
                    "description": "<p>frustum near plane length</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "far",
                    "description": "<p>frustum far plane length</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\n//drag mouse to toggle the world!\n//you will see there's a vanish point\nfunction setup() {\n  createCanvas(100, 100, WEBGL);\n  var fov = 60 / 180 * PI;\n  var cameraZ = height / 2.0 / tan(fov / 2.0);\n  perspective(60 / 180 * PI, width / height, cameraZ * 0.1, cameraZ * 10);\n}\nfunction draw() {\n  background(200);\n  orbitControl();\n  for (var i = -1; i < 2; i++) {\n    for (var j = -2; j < 3; j++) {\n      push();\n      translate(i * 160, 0, j * 160);\n      box(40, 40, 40);\n      pop();\n    }\n  }\n}\n</code>\n</div>"
            ],
            "alt": "colored 3d boxes toggleable with mouse position",
            "class": "p5",
            "module": "Lights, Camera",
            "submodule": "Camera"
        },
        {
            "file": "src/webgl/camera.js",
            "line": 239,
            "description": "<p>Setup ortho camera</p>\n",
            "itemtype": "method",
            "name": "ortho",
            "params": [
                {
                    "name": "left",
                    "description": "<p>camera frustum left plane</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "right",
                    "description": "<p>camera frustum right plane</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "bottom",
                    "description": "<p>camera frustum bottom plane</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "top",
                    "description": "<p>camera frustum top plane</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "near",
                    "description": "<p>camera frustum near plane</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "far",
                    "description": "<p>camera frustum far plane</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\n//drag mouse to toggle the world!\n//there's no vanish point\nfunction setup() {\n  createCanvas(100, 100, WEBGL);\n  ortho(-width / 2, width / 2, height / 2, -height / 2, 0, 500);\n}\nfunction draw() {\n  background(200);\n  orbitControl();\n  strokeWeight(0.1);\n  for (var i = -1; i < 2; i++) {\n    for (var j = -2; j < 3; j++) {\n      push();\n      translate(i * 160, 0, j * 160);\n      box(40, 40, 40);\n      pop();\n    }\n  }\n}\n</code>\n</div>"
            ],
            "alt": "3 3d boxes, reveal several more boxes on 3d plane when mouse used to toggle",
            "class": "p5",
            "module": "Lights, Camera",
            "submodule": "Camera"
        },
        {
            "file": "src/webgl/interaction.js",
            "line": 5,
            "itemtype": "method",
            "name": "orbitControl",
            "chainable": 1,
            "class": "p5",
            "module": "Lights, Camera"
        },
        {
            "file": "src/webgl/light.js",
            "line": 12,
            "description": "<p>Creates an ambient light with a color</p>\n",
            "itemtype": "method",
            "name": "ambientLight",
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\nfunction setup() {\n  createCanvas(100, 100, WEBGL);\n}\nfunction draw() {\n  background(0);\n  ambientLight(150);\n  ambientMaterial(250);\n  noStroke();\n  sphere(25);\n}\n</code>\n</div>"
            ],
            "alt": "evenly distributed light across a sphere",
            "class": "p5",
            "module": "Lights, Camera",
            "submodule": "Lights",
            "overloads": [
                {
                    "line": 12,
                    "params": [
                        {
                            "name": "v1",
                            "description": "<p>red or hue value relative to\n                                the current color range</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "v2",
                            "description": "<p>green or saturation value\n                                relative to the current color range</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "v3",
                            "description": "<p>blue or brightness value\n                                relative to the current color range</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "alpha",
                            "description": "",
                            "type": "Number",
                            "optional": true
                        }
                    ],
                    "chainable": 1
                },
                {
                    "line": 46,
                    "params": [
                        {
                            "name": "value",
                            "description": "<p>a color string</p>\n",
                            "type": "String"
                        },
                        {
                            "name": "alpha",
                            "description": "",
                            "type": "Number",
                            "optional": true
                        }
                    ],
                    "chainable": 1
                },
                {
                    "line": 53,
                    "params": [
                        {
                            "name": "values",
                            "description": "<p>an array containing the red,green,blue &amp;\n                                and alpha components of the color</p>\n",
                            "type": "Number[]"
                        }
                    ],
                    "chainable": 1
                },
                {
                    "line": 60,
                    "params": [
                        {
                            "name": "color",
                            "description": "<p>the ambient light color</p>\n",
                            "type": "p5.Color"
                        }
                    ],
                    "chainable": 1
                }
            ]
        },
        {
            "file": "src/webgl/light.js",
            "line": 93,
            "description": "<p>Creates a directional light with a color and a direction</p>\n",
            "itemtype": "method",
            "name": "directionalLight",
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\nfunction setup() {\n  createCanvas(100, 100, WEBGL);\n}\nfunction draw() {\n  background(0);\n  //move your mouse to change light direction\n  var dirX = (mouseX / width - 0.5) * 2;\n  var dirY = (mouseY / height - 0.5) * 2;\n  directionalLight(250, 250, 250, -dirX, -dirY, 0.25);\n  ambientMaterial(250);\n  noStroke();\n  sphere(25);\n}\n</code>\n</div>"
            ],
            "alt": "light source on canvas changeable with mouse position",
            "class": "p5",
            "module": "Lights, Camera",
            "submodule": "Lights",
            "overloads": [
                {
                    "line": 93,
                    "params": [
                        {
                            "name": "v1",
                            "description": "<p>red or hue value (depending on the current\ncolor mode),</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "v2",
                            "description": "<p>green or saturation value</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "v3",
                            "description": "<p>blue or brightness value</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "position",
                            "description": "<p>the direction of the light</p>\n",
                            "type": "p5.Vector"
                        }
                    ],
                    "chainable": 1
                },
                {
                    "line": 126,
                    "params": [
                        {
                            "name": "color",
                            "description": "<p>color Array, CSS color string,\n                                            or p5.Color value</p>\n",
                            "type": "Number[]|String|p5.Color"
                        },
                        {
                            "name": "x",
                            "description": "<p>x axis direction</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "y",
                            "description": "<p>y axis direction</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "z",
                            "description": "<p>z axis direction</p>\n",
                            "type": "Number"
                        }
                    ],
                    "chainable": 1
                },
                {
                    "line": 136,
                    "params": [
                        {
                            "name": "color",
                            "description": "",
                            "type": "Number[]|String|p5.Color"
                        },
                        {
                            "name": "position",
                            "description": "",
                            "type": "p5.Vector"
                        }
                    ],
                    "chainable": 1
                },
                {
                    "line": 143,
                    "params": [
                        {
                            "name": "v1",
                            "description": "",
                            "type": "Number"
                        },
                        {
                            "name": "v2",
                            "description": "",
                            "type": "Number"
                        },
                        {
                            "name": "v3",
                            "description": "",
                            "type": "Number"
                        },
                        {
                            "name": "x",
                            "description": "",
                            "type": "Number"
                        },
                        {
                            "name": "y",
                            "description": "",
                            "type": "Number"
                        },
                        {
                            "name": "z",
                            "description": "",
                            "type": "Number"
                        }
                    ],
                    "chainable": 1
                }
            ]
        },
        {
            "file": "src/webgl/light.js",
            "line": 197,
            "description": "<p>Creates a point light with a color and a light position</p>\n",
            "itemtype": "method",
            "name": "pointLight",
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\nfunction setup() {\n  createCanvas(100, 100, WEBGL);\n}\nfunction draw() {\n  background(0);\n  //move your mouse to change light position\n  var locX = mouseX - width / 2;\n  var locY = mouseY - height / 2;\n  // to set the light position,\n  // think of the world's coordinate as:\n  // -width/2,-height/2 -------- width/2,-height/2\n  //                |            |\n  //                |     0,0    |\n  //                |            |\n  // -width/2,height/2--------width/2,height/2\n  pointLight(250, 250, 250, locX, locY, 50);\n  ambientMaterial(250);\n  noStroke();\n  sphere(25);\n}\n</code>\n</div>"
            ],
            "alt": "spot light on canvas changes position with mouse",
            "class": "p5",
            "module": "Lights, Camera",
            "submodule": "Lights",
            "overloads": [
                {
                    "line": 197,
                    "params": [
                        {
                            "name": "v1",
                            "description": "<p>red or hue value (depending on the current\ncolor mode),</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "v2",
                            "description": "<p>green or saturation value</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "v3",
                            "description": "<p>blue or brightness value</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "x",
                            "description": "<p>x axis position</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "y",
                            "description": "<p>y axis position</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "z",
                            "description": "<p>z axis position</p>\n",
                            "type": "Number"
                        }
                    ],
                    "chainable": 1
                },
                {
                    "line": 239,
                    "params": [
                        {
                            "name": "v1",
                            "description": "",
                            "type": "Number"
                        },
                        {
                            "name": "v2",
                            "description": "",
                            "type": "Number"
                        },
                        {
                            "name": "v3",
                            "description": "",
                            "type": "Number"
                        },
                        {
                            "name": "position",
                            "description": "<p>the position of the light</p>\n",
                            "type": "p5.Vector"
                        }
                    ],
                    "chainable": 1
                },
                {
                    "line": 248,
                    "params": [
                        {
                            "name": "color",
                            "description": "<p>color Array, CSS color string,\nor p5.Color value</p>\n",
                            "type": "Number[]|String|p5.Color"
                        },
                        {
                            "name": "x",
                            "description": "",
                            "type": "Number"
                        },
                        {
                            "name": "y",
                            "description": "",
                            "type": "Number"
                        },
                        {
                            "name": "z",
                            "description": "",
                            "type": "Number"
                        }
                    ],
                    "chainable": 1
                },
                {
                    "line": 258,
                    "params": [
                        {
                            "name": "color",
                            "description": "",
                            "type": "Number[]|String|p5.Color"
                        },
                        {
                            "name": "position",
                            "description": "",
                            "type": "p5.Vector"
                        }
                    ],
                    "chainable": 1
                }
            ]
        },
        {
            "file": "src/webgl/loading.js",
            "line": 14,
            "description": "<p>Load a 3d model from an OBJ file.\n<br><br>\nOne of the limitations of the OBJ format is that it doesn&#39;t have a built-in\nsense of scale. This means that models exported from different programs might\nbe very different sizes. If your model isn&#39;t displaying, try calling\nloadModel() with the normalized parameter set to true. This will resize the\nmodel to a scale appropriate for p5. You can also make additional changes to\nthe final size of your model with the scale() function.</p>\n",
            "itemtype": "method",
            "name": "loadModel",
            "return": {
                "description": "the p5.Geometry object",
                "type": "p5.Geometry"
            },
            "example": [
                "\n<div>\n<code>\n//draw a spinning teapot\nvar teapot;\n\nfunction preload() {\n  teapot = loadModel('assets/teapot.obj');\n}\n\nfunction setup() {\n  createCanvas(100, 100, WEBGL);\n}\n\nfunction draw() {\n  background(200);\n  rotateX(frameCount * 0.01);\n  rotateY(frameCount * 0.01);\n  model(teapot);\n}\n</code>\n</div>"
            ],
            "alt": "Vertically rotating 3-d teapot with red, green and blue gradient.",
            "class": "p5",
            "module": "Shape",
            "submodule": "3D Models",
            "overloads": [
                {
                    "line": 14,
                    "params": [
                        {
                            "name": "path",
                            "description": "<p>Path of the model to be loaded</p>\n",
                            "type": "String"
                        },
                        {
                            "name": "normalize",
                            "description": "<p>If true, scale the model to a\n                                     standardized size when loading</p>\n",
                            "type": "Boolean"
                        },
                        {
                            "name": "successCallback",
                            "description": "<p>Function to be called\n                                    once the model is loaded. Will be passed\n                                    the 3D model object.</p>\n",
                            "type": "function(p5.Geometry)",
                            "optional": true
                        },
                        {
                            "name": "failureCallback",
                            "description": "<p>called with event error if\n                                        the image fails to load.</p>\n",
                            "type": "Function(Event)",
                            "optional": true
                        }
                    ],
                    "return": {
                        "description": "the p5.Geometry object",
                        "type": "p5.Geometry"
                    }
                },
                {
                    "line": 61,
                    "params": [
                        {
                            "name": "path",
                            "description": "",
                            "type": "String"
                        },
                        {
                            "name": "successCallback",
                            "description": "",
                            "type": "function(p5.Geometry)",
                            "optional": true
                        },
                        {
                            "name": "failureCallback",
                            "description": "",
                            "type": "Function(Event)",
                            "optional": true
                        }
                    ],
                    "return": {
                        "description": "the p5.Geometry object",
                        "type": "p5.Geometry"
                    }
                }
            ]
        },
        {
            "file": "src/webgl/loading.js",
            "line": 103,
            "description": "<p>Parse OBJ lines into model. For reference, this is what a simple model of a\nsquare might look like:</p>\n<p>v -0.5 -0.5 0.5\nv -0.5 -0.5 -0.5\nv -0.5 0.5 -0.5\nv -0.5 0.5 0.5</p>\n<p>f 4 3 2 1</p>\n",
            "class": "p5",
            "module": "Shape",
            "submodule": "3D Models"
        },
        {
            "file": "src/webgl/loading.js",
            "line": 212,
            "description": "<p>Render a 3d model to the screen.</p>\n",
            "itemtype": "method",
            "name": "model",
            "params": [
                {
                    "name": "model",
                    "description": "<p>Loaded 3d model to be rendered</p>\n",
                    "type": "p5.Geometry"
                }
            ],
            "example": [
                "\n<div>\n<code>\n//draw a spinning teapot\nvar teapot;\n\nfunction preload() {\n  teapot = loadModel('assets/teapot.obj');\n}\n\nfunction setup() {\n  createCanvas(100, 100, WEBGL);\n}\n\nfunction draw() {\n  background(200);\n  rotateX(frameCount * 0.01);\n  rotateY(frameCount * 0.01);\n  model(teapot);\n}\n</code>\n</div>"
            ],
            "alt": "Vertically rotating 3-d teapot with red, green and blue gradient.",
            "class": "p5",
            "module": "Shape",
            "submodule": "3D Models"
        },
        {
            "file": "src/webgl/material.js",
            "line": 14,
            "description": "<p>Loads a custom shader from the provided vertex and fragment\nshader paths. The shader files are loaded asynchronously in the\nbackground, so this method should be used in preload().</p>\n<p>For now, there are three main types of shaders. p5 will automatically\nsupply appropriate vertices, normals, colors, and lighting attributes\nif the parameters defined in the shader match the names.</p>\n",
            "itemtype": "method",
            "name": "loadShader",
            "params": [
                {
                    "name": "vertFilename",
                    "description": "<p>path to file containing vertex shader\nsource code</p>\n",
                    "type": "String",
                    "optional": true
                },
                {
                    "name": "fragFilename",
                    "description": "<p>path to file containing fragment shader\nsource code</p>\n",
                    "type": "String",
                    "optional": true
                }
            ],
            "return": {
                "description": "a shader object created from the provided\nvertex and fragment shader files.",
                "type": "p5.Shader"
            },
            "class": "p5",
            "module": "Lights, Camera",
            "submodule": "Material"
        },
        {
            "file": "src/webgl/material.js",
            "line": 56,
            "itemtype": "method",
            "name": "createShader",
            "params": [
                {
                    "name": "vertSrc",
                    "description": "<p>source code for the vertex shader</p>\n",
                    "type": "String"
                },
                {
                    "name": "fragSrc",
                    "description": "<p>source code for the fragment shader</p>\n",
                    "type": "String"
                }
            ],
            "return": {
                "description": "a shader object created from the provided\nvertex and fragment shaders.",
                "type": "p5.Shader"
            },
            "example": [
                "\n<div modernizr='webgl'>\n<code>\n// the 'varying's are shared between both vertex & fragment shaders\nvar varying = 'precision highp float; varying vec2 vPos;';\n\n// the vertex shader is called for each vertex\nvar vs =\n  varying +\n  'attribute vec3 aPosition;' +\n  'void main() { vPos = (gl_Position = vec4(aPosition,1.0)).xy; }';\n\n// the fragment shader is called for each pixel\nvar fs =\n  varying +\n  'uniform vec2 p;' +\n  'uniform float r;' +\n  'const int I = 500;' +\n  'void main() {' +\n  '  vec2 c = p + vPos * r, z = c;' +\n  '  float n = 0.0;' +\n  '  for (int i = I; i > 0; i --) {' +\n  '    if(z.x*z.x+z.y*z.y > 4.0) {' +\n  '      n = float(i)/float(I);' +\n  '      break;' +\n  '    }' +\n  '    z = vec2(z.x*z.x-z.y*z.y, 2.0*z.x*z.y) + c;' +\n  '  }' +\n  '  gl_FragColor = vec4(0.5-cos(n*17.0)/2.0,0.5-cos(n*13.0)/2.0,0.5-cos(n*23.0)/2.0,1.0);' +\n  '}';\n\nvar mandel;\nfunction setup() {\n  createCanvas(100, 100, WEBGL);\n\n  // create and initialize the shader\n  mandel = createShader(vs, fs);\n  shader(mandel);\n  noStroke();\n\n  // 'p' is the center point of the Mandelbrot image\n  mandel.setUniform('p', [-0.74364388703, 0.13182590421]);\n}\n\nfunction draw() {\n  // 'r' is the size of the image in Mandelbrot-space\n  mandel.setUniform('r', 1.5 * exp(-6.5 * (1 + sin(millis() / 2000))));\n  quad(-1, -1, 1, -1, 1, 1, -1, 1);\n}\n</code>\n</div>"
            ],
            "alt": "zooming Mandelbrot set. a colorful, infinitely detailed fractal.",
            "class": "p5",
            "module": "Lights, Camera",
            "submodule": "Material"
        },
        {
            "file": "src/webgl/material.js",
            "line": 122,
            "description": "<p>The shader() function lets the user provide a custom shader\nto fill in shapes in WEBGL mode. Users can create their\nown shaders by loading vertex and fragment shaders with\nloadShader().</p>\n",
            "itemtype": "method",
            "name": "shader",
            "chainable": 1,
            "params": [
                {
                    "name": "s",
                    "description": "<p>the desired p5.Shader to use for rendering\nshapes.</p>\n",
                    "type": "p5.Shader",
                    "optional": true
                }
            ],
            "class": "p5",
            "module": "Lights, Camera",
            "submodule": "Material"
        },
        {
            "file": "src/webgl/material.js",
            "line": 145,
            "description": "<p>Normal material for geometry. You can view all\npossible materials in this\n<a href=\"https://p5js.org/examples/3d-materials.html\">example</a>.</p>\n",
            "itemtype": "method",
            "name": "normalMaterial",
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\nfunction setup() {\n  createCanvas(100, 100, WEBGL);\n}\n\nfunction draw() {\n  background(200);\n  normalMaterial();\n  sphere(50);\n}\n</code>\n</div>"
            ],
            "alt": "Red, green and blue gradient.",
            "class": "p5",
            "module": "Lights, Camera",
            "submodule": "Material"
        },
        {
            "file": "src/webgl/material.js",
            "line": 178,
            "description": "<p>Texture for geometry.  You can view other possible materials in this\n<a href=\"https://p5js.org/examples/3d-materials.html\">example</a>.</p>\n",
            "itemtype": "method",
            "name": "texture",
            "params": [
                {
                    "name": "tex",
                    "description": "<p>2-dimensional graphics\n                   to render as texture</p>\n",
                    "type": "p5.Image|p5.MediaElement|p5.Graphics"
                }
            ],
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\nvar img;\nfunction preload() {\n  img = loadImage('assets/laDefense.jpg');\n}\n\nfunction setup() {\n  createCanvas(100, 100, WEBGL);\n}\n\nfunction draw() {\n  background(0);\n  rotateZ(frameCount * 0.01);\n  rotateX(frameCount * 0.01);\n  rotateY(frameCount * 0.01);\n  //pass image as texture\n  texture(img);\n  box(200, 200, 200);\n}\n</code>\n</div>\n\n<div>\n<code>\nvar pg;\nfunction setup() {\n  createCanvas(100, 100, WEBGL);\n  pg = createGraphics(200, 200);\n  pg.textSize(100);\n}\n\nfunction draw() {\n  background(0);\n  pg.background(255);\n  pg.text('hello!', 0, 100);\n  //pass image as texture\n  texture(pg);\n  plane(200);\n}\n</code>\n</div>\n\n<div>\n<code>\nvar vid;\nfunction preload() {\n  vid = createVideo('assets/fingers.mov');\n  vid.hide();\n  vid.loop();\n}\nfunction setup() {\n  createCanvas(100, 100, WEBGL);\n}\n\nfunction draw() {\n  background(0);\n  //pass video frame as texture\n  texture(vid);\n  plane(200);\n}\n</code>\n</div>"
            ],
            "alt": "Rotating view of many images umbrella and grid roof on a 3d plane\nblack canvas\nblack canvas",
            "class": "p5",
            "module": "Lights, Camera",
            "submodule": "Material"
        },
        {
            "file": "src/webgl/material.js",
            "line": 273,
            "description": "<p>Ambient material for geometry with a given color. You can view all\npossible materials in this\n<a href=\"https://p5js.org/examples/3d-materials.html\">example</a>.</p>\n",
            "itemtype": "method",
            "name": "ambientMaterial",
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\nfunction setup() {\n  createCanvas(100, 100, WEBGL);\n}\nfunction draw() {\n  background(0);\n  ambientLight(100);\n  pointLight(250, 250, 250, 100, 100, 0);\n  ambientMaterial(250);\n  sphere(50);\n}\n</code>\n</div>"
            ],
            "alt": "radiating light source from top right of canvas",
            "class": "p5",
            "module": "Lights, Camera",
            "submodule": "Material",
            "overloads": [
                {
                    "line": 273,
                    "params": [
                        {
                            "name": "v1",
                            "description": "<p>gray value, red or hue value\n                        (depending on the current color mode),</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "v2",
                            "description": "<p>green or saturation value</p>\n",
                            "type": "Number",
                            "optional": true
                        },
                        {
                            "name": "v3",
                            "description": "<p>blue or brightness value</p>\n",
                            "type": "Number",
                            "optional": true
                        },
                        {
                            "name": "a",
                            "description": "<p>opacity</p>\n",
                            "type": "Number",
                            "optional": true
                        }
                    ],
                    "chainable": 1
                },
                {
                    "line": 304,
                    "params": [
                        {
                            "name": "color",
                            "description": "<p>color, color Array, or CSS color string</p>\n",
                            "type": "Number[]|String|p5.Color"
                        }
                    ],
                    "chainable": 1
                }
            ]
        },
        {
            "file": "src/webgl/material.js",
            "line": 320,
            "description": "<p>Specular material for geometry with a given color. You can view all\npossible materials in this\n<a href=\"https://p5js.org/examples/3d-materials.html\">example</a>.</p>\n",
            "itemtype": "method",
            "name": "specularMaterial",
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\nfunction setup() {\n  createCanvas(100, 100, WEBGL);\n}\nfunction draw() {\n  background(0);\n  ambientLight(100);\n  pointLight(250, 250, 250, 100, 100, 0);\n  specularMaterial(250);\n  sphere(50);\n}\n</code>\n</div>"
            ],
            "alt": "diffused radiating light source from top right of canvas",
            "class": "p5",
            "module": "Lights, Camera",
            "submodule": "Material",
            "overloads": [
                {
                    "line": 320,
                    "params": [
                        {
                            "name": "v1",
                            "description": "<p>gray value, red or hue value\n                      (depending on the current color mode),</p>\n",
                            "type": "Number"
                        },
                        {
                            "name": "v2",
                            "description": "<p>green or saturation value</p>\n",
                            "type": "Number",
                            "optional": true
                        },
                        {
                            "name": "v3",
                            "description": "<p>blue or brightness value</p>\n",
                            "type": "Number",
                            "optional": true
                        },
                        {
                            "name": "a",
                            "description": "<p>opacity</p>\n",
                            "type": "Number",
                            "optional": true
                        }
                    ],
                    "chainable": 1
                },
                {
                    "line": 351,
                    "params": [
                        {
                            "name": "color",
                            "description": "<p>color Array, or CSS color string</p>\n",
                            "type": "Number[]|String|p5.Color"
                        }
                    ],
                    "chainable": 1
                }
            ]
        },
        {
            "file": "src/webgl/p5.Geometry.js",
            "line": 54,
            "itemtype": "method",
            "name": "computeFaces",
            "chainable": 1,
            "class": "p5.Geometry",
            "module": "Lights, Camera"
        },
        {
            "file": "src/webgl/p5.Geometry.js",
            "line": 87,
            "description": "<p>computes smooth normals per vertex as an average of each\nface.</p>\n",
            "itemtype": "method",
            "name": "computeNormals",
            "chainable": 1,
            "class": "p5.Geometry",
            "module": "Lights, Camera"
        },
        {
            "file": "src/webgl/p5.Geometry.js",
            "line": 116,
            "description": "<p>Averages the vertex normals. Used in curved\nsurfaces</p>\n",
            "itemtype": "method",
            "name": "averageNormals",
            "chainable": 1,
            "class": "p5.Geometry",
            "module": "Lights, Camera"
        },
        {
            "file": "src/webgl/p5.Geometry.js",
            "line": 137,
            "description": "<p>Averages pole normals.  Used in spherical primitives</p>\n",
            "itemtype": "method",
            "name": "averagePoleNormals",
            "chainable": 1,
            "class": "p5.Geometry",
            "module": "Lights, Camera"
        },
        {
            "file": "src/webgl/p5.Geometry.js",
            "line": 226,
            "description": "<p>Modifies all vertices to be centered within the range -100 to 100.</p>\n",
            "itemtype": "method",
            "name": "normalize",
            "chainable": 1,
            "class": "p5.Geometry",
            "module": "Lights, Camera"
        },
        {
            "file": "src/webgl/p5.RendererGL.Immediate.js",
            "line": 1,
            "description": "<p>Welcome to RendererGL Immediate Mode.\nImmediate mode is used for drawing custom shapes\nfrom a set of vertices.  Immediate Mode is activated\nwhen you call beginShape() &amp; de-activated when you call endShape().\nImmediate mode is a style of programming borrowed\nfrom OpenGL&#39;s (now-deprecated) immediate mode.\nIt differs from p5.js&#39; default, Retained Mode, which caches\ngeometries and buffers on the CPU to reduce the number of webgl\ndraw calls. Retained mode is more efficient &amp; performative,\nhowever, Immediate Mode is useful for sketching quick\ngeometric ideas.</p>\n",
            "class": "p5.RendererGL",
            "module": "Lights, Camera"
        },
        {
            "file": "src/webgl/p5.RendererGL.Immediate.js",
            "line": 19,
            "description": "<p>Begin shape drawing.  This is a helpful way of generating\ncustom shapes quickly.  However in WEBGL mode, application\nperformance will likely drop as a result of too many calls to\nbeginShape() / endShape().  As a high performance alternative,\nplease use p5.js geometry primitives.</p>\n",
            "itemtype": "method",
            "name": "beginShape",
            "params": [
                {
                    "name": "mode",
                    "description": "<p>webgl primitives mode.  beginShape supports the\n                      following modes:\n                      POINTS,LINES,LINE_STRIP,LINE_LOOP,TRIANGLES,\n                      TRIANGLE_STRIP,and TRIANGLE_FAN.</p>\n",
                    "type": "Number"
                }
            ],
            "chainable": 1,
            "class": "p5.RendererGL",
            "module": "Lights, Camera"
        },
        {
            "file": "src/webgl/p5.RendererGL.Immediate.js",
            "line": 61,
            "description": "<p>adds a vertex to be drawn in a custom Shape.</p>\n",
            "itemtype": "method",
            "name": "vertex",
            "params": [
                {
                    "name": "x",
                    "description": "<p>x-coordinate of vertex</p>\n",
                    "type": "Number"
                },
                {
                    "name": "y",
                    "description": "<p>y-coordinate of vertex</p>\n",
                    "type": "Number"
                },
                {
                    "name": "z",
                    "description": "<p>z-coordinate of vertex</p>\n",
                    "type": "Number"
                }
            ],
            "chainable": 1,
            "todo": [
                "implement handling of p5.Vector args"
            ],
            "class": "p5.RendererGL",
            "module": "Lights, Camera"
        },
        {
            "file": "src/webgl/p5.RendererGL.Immediate.js",
            "line": 104,
            "description": "<p>End shape drawing and render vertices to screen.</p>\n",
            "chainable": 1,
            "class": "p5.RendererGL",
            "module": "Lights, Camera"
        },
        {
            "file": "src/webgl/p5.RendererGL.js",
            "line": 79,
            "description": "<p>model view, projection, &amp; normal\nmatrices</p>\n",
            "class": "p5.RendererGL",
            "module": "Lights, Camera"
        },
        {
            "file": "src/webgl/p5.RendererGL.js",
            "line": 199,
            "description": "<p>Set attributes for the WebGL Drawing context.\nThis is a way of adjusting ways that the WebGL\nrenderer works to fine-tune the display and performance.\nThis should be put in setup().\nThe available attributes are:\n<br>\nalpha - indicates if the canvas contains an alpha buffer\ndefault is true\n<br><br>\ndepth - indicates whether the drawing buffer has a depth buffer\nof at least 16 bits - default is true\n<br><br>\nstencil - indicates whether the drawing buffer has a stencil buffer\nof at least 8 bits\n<br><br>\nantialias - indicates whether or not to perform anti-aliasing\ndefault is false\n<br><br>\npremultipliedAlpha - indicates that the page compositor will assume\nthe drawing buffer contains colors with pre-multiplied alpha\ndefault is false\n<br><br>\npreserveDrawingBuffer - if true the buffers will not be cleared and\nand will preserve their values until cleared or overwritten by author\n(note that p5 clears automatically on draw loop)\ndefault is true\n<br><br>\nperPixelLighting - if true, per-pixel lighting will be used in the\nlighting shader.\ndefault is false\n<br><br></p>\n",
            "itemtype": "method",
            "name": "setAttributes",
            "example": [
                "\n<div>\n<code>\nfunction setup() {\n  createCanvas(100, 100, WEBGL);\n}\n\nfunction draw() {\n  background(255);\n  push();\n  rotateZ(frameCount * 0.02);\n  rotateX(frameCount * 0.02);\n  rotateY(frameCount * 0.02);\n  fill(0, 0, 0);\n  box(50);\n  pop();\n}\n</code>\n</div>\n<br>\nNow with the antialias attribute set to true.\n<br>\n<div>\n<code>\nfunction setup() {\n  createCanvas(100, 100, WEBGL);\n  setAttributes('antialias', true);\n}\n\nfunction draw() {\n  background(255);\n  push();\n  rotateZ(frameCount * 0.02);\n  rotateX(frameCount * 0.02);\n  rotateY(frameCount * 0.02);\n  fill(0, 0, 0);\n  box(50);\n  pop();\n}\n</code>\n</div>\n\n<div>\n<code>\n// press the mouse button to enable perPixelLighting\nfunction setup() {\n  createCanvas(100, 100, WEBGL);\n  noStroke();\n  fill(255);\n}\n\nvar lights = [\n  { c: '#f00', t: 1.12, p: 1.91, r: 0.2 },\n  { c: '#0f0', t: 1.21, p: 1.31, r: 0.2 },\n  { c: '#00f', t: 1.37, p: 1.57, r: 0.2 },\n  { c: '#ff0', t: 1.12, p: 1.91, r: 0.7 },\n  { c: '#0ff', t: 1.21, p: 1.31, r: 0.7 },\n  { c: '#f0f', t: 1.37, p: 1.57, r: 0.7 }\n];\n\nfunction draw() {\n  var t = millis() / 1000 + 1000;\n  background(0);\n  directionalLight(color('#222'), 1, 1, 1);\n\n  for (var i = 0; i < lights.length; i++) {\n    var light = lights[i];\n    pointLight(\n      color(light.c),\n      p5.Vector.fromAngles(t * light.t, t * light.p, width * light.r)\n    );\n  }\n\n  specularMaterial(255);\n  sphere(width * 0.1);\n\n  rotateX(t * 0.77);\n  rotateY(t * 0.83);\n  rotateZ(t * 0.91);\n  torus(width * 0.3, width * 0.07, 30, 10);\n}\n\nfunction mousePressed() {\n  setAttributes('perPixelLighting', true);\n  noStroke();\n  fill(255);\n}\nfunction mouseReleased() {\n  setAttributes('perPixelLighting', false);\n  noStroke();\n  fill(255);\n}\n</code>\n</div>"
            ],
            "alt": "a rotating cube with smoother edges",
            "class": "p5",
            "module": "Rendering",
            "submodule": "Rendering",
            "overloads": [
                {
                    "line": 199,
                    "params": [
                        {
                            "name": "key",
                            "description": "<p>Name of attribute</p>\n",
                            "type": "String"
                        },
                        {
                            "name": "value",
                            "description": "<p>New value of named attribute</p>\n",
                            "type": "Boolean"
                        }
                    ]
                },
                {
                    "line": 332,
                    "params": [
                        {
                            "name": "obj",
                            "description": "<p>object with key-value pairs</p>\n",
                            "type": "Object"
                        }
                    ]
                }
            ]
        },
        {
            "file": "src/webgl/p5.RendererGL.js",
            "line": 416,
            "description": "<p>[background description]</p>\n",
            "class": "p5.RendererGL",
            "module": "Rendering",
            "submodule": "Rendering"
        },
        {
            "file": "src/webgl/p5.RendererGL.js",
            "line": 485,
            "description": "<p>Basic stroke material for geometry with a given color</p>\n",
            "itemtype": "method",
            "name": "stroke",
            "params": [
                {
                    "name": "v1",
                    "description": "<p>gray value,\nred or hue value (depending on the current color mode),\nor color Array, or CSS color string</p>\n",
                    "type": "Number|Number[]|String|p5.Color"
                },
                {
                    "name": "v2",
                    "description": "<p>green or saturation value</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "v3",
                    "description": "<p>blue or brightness value</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "a",
                    "description": "<p>opacity</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "example": [
                "\n<div>\n<code>\nfunction setup() {\n  createCanvas(200, 200, WEBGL);\n}\n\nfunction draw() {\n  background(0);\n  stroke(240, 150, 150);\n  fill(100, 100, 240);\n  rotateX(frameCount * 0.01);\n  rotateY(frameCount * 0.01);\n  box(75, 75, 75);\n}\n</code>\n</div>"
            ],
            "alt": "black canvas with purple cube with pink outline spinning",
            "class": "p5.RendererGL",
            "module": "Rendering",
            "submodule": "Rendering"
        },
        {
            "file": "src/webgl/p5.RendererGL.js",
            "line": 525,
            "description": "<p>Change weight of stroke</p>\n",
            "itemtype": "method",
            "name": "strokeWeight",
            "params": [
                {
                    "name": "stroke",
                    "description": "<p>weight to be used for drawing</p>\n",
                    "type": "Number"
                }
            ],
            "example": [
                "\n<div>\n<code>\nfunction setup() {\n  createCanvas(200, 400, WEBGL);\n  setAttributes('antialias', true);\n}\n\nfunction draw() {\n  background(0);\n  noStroke();\n  translate(0, -100, 0);\n  stroke(240, 150, 150);\n  fill(100, 100, 240);\n  push();\n  strokeWeight(8);\n  rotateX(frameCount * 0.01);\n  rotateY(frameCount * 0.01);\n  sphere(75);\n  pop();\n  push();\n  translate(0, 200, 0);\n  strokeWeight(1);\n  rotateX(frameCount * 0.01);\n  rotateY(frameCount * 0.01);\n  sphere(75);\n  pop();\n}\n</code>\n</div>"
            ],
            "alt": "black canvas with two purple rotating spheres with pink\noutlines the sphere on top has much heavier outlines,",
            "class": "p5.RendererGL",
            "module": "Rendering",
            "submodule": "Rendering"
        },
        {
            "file": "src/webgl/p5.RendererGL.js",
            "line": 573,
            "description": "<p>Returns an array of [R,G,B,A] values for any pixel or grabs a section of\nan image. If no parameters are specified, the entire image is returned.\nUse the x and y parameters to get the value of one pixel. Get a section of\nthe display window by specifying additional w and h parameters. When\ngetting an image, the x and y parameters define the coordinates for the\nupper-left corner of the image, regardless of the current imageMode().\n<br><br>\nIf the pixel requested is outside of the image window, [0,0,0,255] is\nreturned.\n<br><br>\nGetting the color of a single pixel with get(x, y) is easy, but not as fast\nas grabbing the data directly from pixels[]. The equivalent statement to\nget(x, y) is using pixels[] with pixel density d</p>\n",
            "itemtype": "method",
            "name": "get",
            "params": [
                {
                    "name": "x",
                    "description": "<p>x-coordinate of the pixel</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "y",
                    "description": "<p>y-coordinate of the pixel</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "w",
                    "description": "<p>width</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "h",
                    "description": "<p>height</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "return": {
                "description": "color of pixel at x,y in array format\n                                   [R, G, B, A] or p5.Image",
                "type": "Number[]|Color|p5.Image"
            },
            "class": "p5.RendererGL",
            "module": "Rendering",
            "submodule": "Rendering"
        },
        {
            "file": "src/webgl/p5.RendererGL.js",
            "line": 601,
            "description": "<p>Loads the pixels data for this canvas into the pixels[] attribute.\nNote that updatePixels() and set() do not work.\nAny pixel manipulation must be done directly to the pixels[] array.</p>\n",
            "itemtype": "method",
            "name": "loadPixels",
            "class": "p5.RendererGL",
            "module": "Rendering",
            "submodule": "Rendering"
        },
        {
            "file": "src/webgl/p5.RendererGL.js",
            "line": 751,
            "description": "<p>pushes a copy of the model view matrix onto the\nMV Matrix stack.</p>\n",
            "class": "p5.RendererGL",
            "module": "Rendering",
            "submodule": "Rendering"
        },
        {
            "file": "src/webgl/p5.RendererGL.js",
            "line": 760,
            "description": "<p>[pop description]</p>\n",
            "class": "p5.RendererGL",
            "module": "Rendering",
            "submodule": "Rendering"
        },
        {
            "file": "src/webgl/p5.Shader.js",
            "line": 271,
            "description": "<p>Wrapper around gl.uniform functions.\nAs we store uniform info in the shader we can use that\nto do type checking on the supplied data and call\nthe appropriate function.</p>\n",
            "itemtype": "method",
            "name": "setUniform",
            "chainable": 1,
            "params": [
                {
                    "name": "uniformName",
                    "description": "<p>the name of the uniform in the\nshader program</p>\n",
                    "type": "String"
                },
                {
                    "name": "data",
                    "description": "<p>the data to be associated\nwith that uniform; type varies (could be a single numerical value, array,\nmatrix, or texture / sampler reference)</p>\n",
                    "type": "Object|Number|Boolean|Number[]"
                }
            ],
            "class": "p5.Shader",
            "module": "Lights, Camera",
            "submodule": "Shaders"
        },
        {
            "file": "src/webgl/p5.Texture.js",
            "line": 123,
            "description": "<p>Checks if the source data for this texture has changed (if it&#39;s\neasy to do so) and reuploads the texture if necessary. If it&#39;s not\npossible or to expensive to do a calculation to determine wheter or\nnot the data has occurred, this method simply re-uploads the texture.</p>\n",
            "itemtype": "method",
            "name": "update",
            "class": "p5.Texture",
            "module": "Lights, Camera",
            "submodule": "Material"
        },
        {
            "file": "src/webgl/p5.Texture.js",
            "line": 232,
            "description": "<p>Binds the texture to the appropriate GL target.</p>\n",
            "itemtype": "method",
            "name": "bindTexture",
            "class": "p5.Texture",
            "module": "Lights, Camera",
            "submodule": "Material"
        },
        {
            "file": "src/webgl/p5.Texture.js",
            "line": 245,
            "description": "<p>Unbinds the texture from the appropriate GL target.</p>\n",
            "itemtype": "method",
            "name": "unbindTexture",
            "class": "p5.Texture",
            "module": "Lights, Camera",
            "submodule": "Material"
        },
        {
            "file": "src/webgl/primitives.js",
            "line": 13,
            "description": "<p>Draw a plane with given a width and height</p>\n",
            "itemtype": "method",
            "name": "plane",
            "params": [
                {
                    "name": "width",
                    "description": "<p>width of the plane</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "height",
                    "description": "<p>height of the plane</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "detailX",
                    "description": "<p>Optional number of triangle\n                            subdivisions in x-dimension</p>\n",
                    "type": "Integer",
                    "optional": true
                },
                {
                    "name": "detailY",
                    "description": "<p>Optional number of triangle\n                            subdivisions in y-dimension</p>\n",
                    "type": "Integer",
                    "optional": true
                }
            ],
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\n//draw a plane with width 50 and height 50\nfunction setup() {\n  createCanvas(100, 100, WEBGL);\n}\n\nfunction draw() {\n  background(200);\n  plane(50, 50);\n}\n</code>\n</div>"
            ],
            "alt": "Nothing displayed on canvas\nRotating interior view of a box with sides that change color.\n3d red and green gradient.\nRotating interior view of a cylinder with sides that change color.\nRotating view of a cylinder with sides that change color.\n3d red and green gradient.\nrotating view of a multi-colored cylinder with concave sides.",
            "class": "p5",
            "module": "Shape",
            "submodule": "3D Primitives"
        },
        {
            "file": "src/webgl/primitives.js",
            "line": 94,
            "description": "<p>Draw a box with given width, height and depth</p>\n",
            "itemtype": "method",
            "name": "box",
            "params": [
                {
                    "name": "width",
                    "description": "<p>width of the box</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "Height",
                    "description": "<p>height of the box</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "depth",
                    "description": "<p>depth of the box</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "detailX",
                    "description": "<p>Optional number of triangle\n                           subdivisions in x-dimension</p>\n",
                    "type": "Integer",
                    "optional": true
                },
                {
                    "name": "detailY",
                    "description": "<p>Optional number of triangle\n                           subdivisions in y-dimension</p>\n",
                    "type": "Integer",
                    "optional": true
                }
            ],
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\n//draw a spinning box with width, height and depth 200\nfunction setup() {\n  createCanvas(100, 100, WEBGL);\n}\n\nfunction draw() {\n  background(200);\n  rotateX(frameCount * 0.01);\n  rotateY(frameCount * 0.01);\n  box(50);\n}\n</code>\n</div>"
            ],
            "class": "p5",
            "module": "Shape",
            "submodule": "3D Primitives"
        },
        {
            "file": "src/webgl/primitives.js",
            "line": 208,
            "description": "<p>Draw a sphere with given radius</p>\n",
            "itemtype": "method",
            "name": "sphere",
            "params": [
                {
                    "name": "radius",
                    "description": "<p>radius of circle</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "detailX",
                    "description": "<p>number of segments,\n                                   the more segments the smoother geometry\n                                   default is 24</p>\n",
                    "type": "Integer",
                    "optional": true
                },
                {
                    "name": "detailY",
                    "description": "<p>number of segments,\n                                   the more segments the smoother geometry\n                                   default is 16</p>\n",
                    "type": "Integer",
                    "optional": true
                }
            ],
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\n// draw a sphere with radius 200\nfunction setup() {\n  createCanvas(100, 100, WEBGL);\n}\n\nfunction draw() {\n  background(200);\n  sphere(40);\n}\n</code>\n</div>"
            ],
            "class": "p5",
            "module": "Shape",
            "submodule": "3D Primitives"
        },
        {
            "file": "src/webgl/primitives.js",
            "line": 336,
            "description": "<p>Draw a cylinder with given radius and height</p>\n",
            "itemtype": "method",
            "name": "cylinder",
            "params": [
                {
                    "name": "radius",
                    "description": "<p>radius of the surface</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "height",
                    "description": "<p>height of the cylinder</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "detailX",
                    "description": "<p>number of segments,\n                            the more segments the smoother geometry\n                            default is 24</p>\n",
                    "type": "Integer",
                    "optional": true
                },
                {
                    "name": "detailY",
                    "description": "<p>number of segments in y-dimension,\n                            the more segments the smoother geometry\n                            default is 16</p>\n",
                    "type": "Integer",
                    "optional": true
                }
            ],
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\n//draw a spinning cylinder with radius 200 and height 200\nfunction setup() {\n  createCanvas(100, 100, WEBGL);\n}\n\nfunction draw() {\n  background(200);\n  rotateX(frameCount * 0.01);\n  rotateZ(frameCount * 0.01);\n  cylinder(20, 50);\n}\n</code>\n</div>"
            ],
            "class": "p5",
            "module": "Shape",
            "submodule": "3D Primitives"
        },
        {
            "file": "src/webgl/primitives.js",
            "line": 401,
            "description": "<p>Draw a cone with given radius and height</p>\n",
            "itemtype": "method",
            "name": "cone",
            "params": [
                {
                    "name": "radius",
                    "description": "<p>radius of the bottom surface</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "height",
                    "description": "<p>height of the cone</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "detailX",
                    "description": "<p>number of segments,\n                                   the more segments the smoother geometry\n                                   default is 24</p>\n",
                    "type": "Integer",
                    "optional": true
                },
                {
                    "name": "detailY",
                    "description": "<p>number of segments,\n                                   the more segments the smoother geometry\n                                   default is 16</p>\n",
                    "type": "Integer",
                    "optional": true
                }
            ],
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\n//draw a spinning cone with radius 200 and height 200\nfunction setup() {\n  createCanvas(100, 100, WEBGL);\n}\n\nfunction draw() {\n  background(200);\n  rotateX(frameCount * 0.01);\n  rotateZ(frameCount * 0.01);\n  cone(40, 70);\n}\n</code>\n</div>"
            ],
            "class": "p5",
            "module": "Shape",
            "submodule": "3D Primitives"
        },
        {
            "file": "src/webgl/primitives.js",
            "line": 476,
            "description": "<p>Draw an ellipsoid with given radius</p>\n",
            "itemtype": "method",
            "name": "ellipsoid",
            "params": [
                {
                    "name": "radiusx",
                    "description": "<p>xradius of circle</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "radiusy",
                    "description": "<p>yradius of circle</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "radiusz",
                    "description": "<p>zradius of circle</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "detailX",
                    "description": "<p>number of segments,\n                                   the more segments the smoother geometry\n                                   default is 24. Avoid detail number above\n                                   150, it may crash the browser.</p>\n",
                    "type": "Integer",
                    "optional": true
                },
                {
                    "name": "detailY",
                    "description": "<p>number of segments,\n                                   the more segments the smoother geometry\n                                   default is 16. Avoid detail number above\n                                   150, it may crash the browser.</p>\n",
                    "type": "Integer",
                    "optional": true
                }
            ],
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\n// draw an ellipsoid with radius 20, 30 and 40.\nfunction setup() {\n  createCanvas(100, 100, WEBGL);\n}\n\nfunction draw() {\n  background(200);\n  ellipsoid(20, 30, 40);\n}\n</code>\n</div>"
            ],
            "class": "p5",
            "module": "Shape",
            "submodule": "3D Primitives"
        },
        {
            "file": "src/webgl/primitives.js",
            "line": 565,
            "description": "<p>Draw a torus with given radius and tube radius</p>\n",
            "itemtype": "method",
            "name": "torus",
            "params": [
                {
                    "name": "radius",
                    "description": "<p>radius of the whole ring</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "tubeRadius",
                    "description": "<p>radius of the tube</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "detailX",
                    "description": "<p>number of segments in x-dimension,\n                               the more segments the smoother geometry\n                               default is 24</p>\n",
                    "type": "Integer",
                    "optional": true
                },
                {
                    "name": "detailY",
                    "description": "<p>number of segments in y-dimension,\n                               the more segments the smoother geometry\n                               default is 16</p>\n",
                    "type": "Integer",
                    "optional": true
                }
            ],
            "chainable": 1,
            "example": [
                "\n<div>\n<code>\n//draw a spinning torus with radius 200 and tube radius 60\nfunction setup() {\n  createCanvas(100, 100, WEBGL);\n}\n\nfunction draw() {\n  background(200);\n  rotateX(frameCount * 0.01);\n  rotateY(frameCount * 0.01);\n  torus(50, 15);\n}\n</code>\n</div>"
            ],
            "class": "p5",
            "module": "Shape",
            "submodule": "3D Primitives"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 40,
            "description": "<p>Searches the page for an element with the given ID, class, or tag name (using the &#39;#&#39; or &#39;.&#39;\nprefixes to specify an ID or class respectively, and none for a tag) and returns it as\na p5.Element. If a class or tag name is given with more than 1 element,\nonly the first element will be returned.\nThe DOM node itself can be accessed with .elt.\nReturns null if none found. You can also specify a container to search within.</p>\n",
            "itemtype": "method",
            "name": "select",
            "params": [
                {
                    "name": "name",
                    "description": "<p>id, class, or tag name of element to search for</p>\n",
                    "type": "String"
                },
                {
                    "name": "container",
                    "description": "<p>id, p5.Element, or HTML element to search within</p>\n",
                    "type": "String",
                    "optional": true
                }
            ],
            "return": {
                "description": "p5.Element containing node found",
                "type": "Object|p5.Element|Null"
            },
            "example": [
                "\n<div ><code class='norender'>\nfunction setup() {\n  createCanvas(100, 100);\n  //translates canvas 50px down\n  select('canvas').position(100, 100);\n}\n</code></div>\n<div ><code class='norender'>\n// these are all valid calls to select()\nvar a = select('#moo');\nvar b = select('#blah', '#myContainer');\nvar c = select('#foo', b);\nvar d = document.getElementById('beep');\nvar e = select('p', d);\n[a, b, c, d, e]; // unused\n</code></div>\n"
            ],
            "class": "p5.dom",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 101,
            "description": "<p>Searches the page for elements with the given class or tag name (using the &#39;.&#39; prefix\nto specify a class and no prefix for a tag) and returns them as p5.Elements\nin an array.\nThe DOM node itself can be accessed with .elt.\nReturns an empty array if none found.\nYou can also specify a container to search within.</p>\n",
            "itemtype": "method",
            "name": "selectAll",
            "params": [
                {
                    "name": "name",
                    "description": "<p>class or tag name of elements to search for</p>\n",
                    "type": "String"
                },
                {
                    "name": "container",
                    "description": "<p>id, p5.Element, or HTML element to search within</p>\n",
                    "type": "String",
                    "optional": true
                }
            ],
            "return": {
                "description": "Array of p5.Elements containing nodes found",
                "type": "Array"
            },
            "example": [
                "\n<div class='norender'><code>\nfunction setup() {\n  createButton('btn');\n  createButton('2nd btn');\n  createButton('3rd btn');\n  var buttons = selectAll('button');\n\n  for (var i = 0; i < buttons.length; i++) {\n    buttons[i].size(100, 100);\n  }\n}\n</code></div>\n<div class='norender'><code>\n// these are all valid calls to selectAll()\nvar a = selectAll('.moo');\na = selectAll('div');\na = selectAll('button', '#myContainer');\n\nvar d = select('#container');\na = selectAll('p', d);\n\nvar f = document.getElementById('beep');\na = select('.blah', f);\n\na; // unused\n</code></div>\n"
            ],
            "class": "p5.dom",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 162,
            "description": "<p>Helper function for select and selectAll</p>\n",
            "class": "p5.dom",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 178,
            "description": "<p>Helper function for getElement and getElements.</p>\n",
            "class": "p5.dom",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 212,
            "description": "<p>Removes all elements created by p5, except any canvas / graphics\nelements created by createCanvas or createGraphics.\nEvent handlers are removed, and element is removed from the DOM.</p>\n",
            "itemtype": "method",
            "name": "removeElements",
            "example": [
                "\n<div class='norender'><code>\nfunction setup() {\n  createCanvas(100, 100);\n  createDiv('this is some text');\n  createP('this is a paragraph');\n}\nfunction mousePressed() {\n  removeElements(); // this will remove the div and p, not canvas\n}\n</code></div>\n"
            ],
            "class": "p5.dom",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 239,
            "description": "<p>Helpers for create methods.</p>\n",
            "class": "p5.dom",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 250,
            "description": "<p>Creates a &lt;div&gt;&lt;/div&gt; element in the DOM with given inner HTML.\nAppends to the container node if one is specified, otherwise\nappends to body.</p>\n",
            "itemtype": "method",
            "name": "createDiv",
            "params": [
                {
                    "name": "html",
                    "description": "<p>inner HTML for element created</p>\n",
                    "type": "String",
                    "optional": true
                }
            ],
            "return": {
                "description": "pointer to p5.Element holding created node",
                "type": "Object|p5.Element"
            },
            "example": [
                "\n<div class='norender'><code>\ncreateDiv('this is some text');\n</code></div>"
            ],
            "class": "p5.dom",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 264,
            "description": "<p>Creates a &lt;p&gt;&lt;/p&gt; element in the DOM with given inner HTML. Used\nfor paragraph length text.\nAppends to the container node if one is specified, otherwise\nappends to body.</p>\n",
            "itemtype": "method",
            "name": "createP",
            "params": [
                {
                    "name": "html",
                    "description": "<p>inner HTML for element created</p>\n",
                    "type": "String",
                    "optional": true
                }
            ],
            "return": {
                "description": "pointer to p5.Element holding created node",
                "type": "Object|p5.Element"
            },
            "example": [
                "\n<div class='norender'><code>\ncreateP('this is some text');\n</code></div>"
            ],
            "class": "p5.dom",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 279,
            "description": "<p>Creates a &lt;span&gt;&lt;/span&gt; element in the DOM with given inner HTML.\nAppends to the container node if one is specified, otherwise\nappends to body.</p>\n",
            "itemtype": "method",
            "name": "createSpan",
            "params": [
                {
                    "name": "html",
                    "description": "<p>inner HTML for element created</p>\n",
                    "type": "String",
                    "optional": true
                }
            ],
            "return": {
                "description": "pointer to p5.Element holding created node",
                "type": "Object|p5.Element"
            },
            "example": [
                "\n<div class='norender'><code>\ncreateSpan('this is some text');\n</code></div>"
            ],
            "class": "p5.dom",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 302,
            "description": "<p>Creates an &lt;img&gt; element in the DOM with given src and\nalternate text.\nAppends to the container node if one is specified, otherwise\nappends to body.</p>\n",
            "itemtype": "method",
            "name": "createImg",
            "params": [
                {
                    "name": "src",
                    "description": "<p>src path or url for image</p>\n",
                    "type": "String"
                },
                {
                    "name": "alt",
                    "description": "<p>alternate text to be used if image does not load</p>\n",
                    "type": "String",
                    "optional": true
                },
                {
                    "name": "successCallback",
                    "description": "<p>callback to be called once image data is loaded</p>\n",
                    "type": "Function",
                    "optional": true
                }
            ],
            "return": {
                "description": "pointer to p5.Element holding created node",
                "type": "Object|p5.Element"
            },
            "example": [
                "\n<div class='norender'><code>\ncreateImg('http://p5js.org/img/asterisk-01.png');\n</code></div>"
            ],
            "class": "p5.dom",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 345,
            "description": "<p>Creates an &lt;a&gt;&lt;/a&gt; element in the DOM for including a hyperlink.\nAppends to the container node if one is specified, otherwise\nappends to body.</p>\n",
            "itemtype": "method",
            "name": "createA",
            "params": [
                {
                    "name": "href",
                    "description": "<p>url of page to link to</p>\n",
                    "type": "String"
                },
                {
                    "name": "html",
                    "description": "<p>inner html of link element to display</p>\n",
                    "type": "String"
                },
                {
                    "name": "target",
                    "description": "<p>target where new link should open,\n                            could be _blank, _self, _parent, _top.</p>\n",
                    "type": "String",
                    "optional": true
                }
            ],
            "return": {
                "description": "pointer to p5.Element holding created node",
                "type": "Object|p5.Element"
            },
            "example": [
                "\n<div class='norender'><code>\ncreateA('http://p5js.org/', 'this is a link');\n</code></div>"
            ],
            "class": "p5.dom",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 370,
            "class": "p5.dom",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 372,
            "description": "<p>Creates a slider &lt;input&gt;&lt;/input&gt; element in the DOM.\nUse .size() to set the display length of the slider.\nAppends to the container node if one is specified, otherwise\nappends to body.</p>\n",
            "itemtype": "method",
            "name": "createSlider",
            "params": [
                {
                    "name": "min",
                    "description": "<p>minimum value of the slider</p>\n",
                    "type": "Number"
                },
                {
                    "name": "max",
                    "description": "<p>maximum value of the slider</p>\n",
                    "type": "Number"
                },
                {
                    "name": "value",
                    "description": "<p>default value of the slider</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "step",
                    "description": "<p>step size for each tick of the slider (if step is set to 0, the slider will move continuously from the minimum to the maximum value)</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "return": {
                "description": "pointer to p5.Element holding created node",
                "type": "Object|p5.Element"
            },
            "example": [
                "\n<div><code>\nvar slider;\nfunction setup() {\n  slider = createSlider(0, 255, 100);\n  slider.position(10, 10);\n  slider.style('width', '80px');\n}\n\nfunction draw() {\n  var val = slider.value();\n  background(val);\n}\n</code></div>\n\n<div><code>\nvar slider;\nfunction setup() {\n  colorMode(HSB);\n  slider = createSlider(0, 360, 60, 40);\n  slider.position(10, 10);\n  slider.style('width', '80px');\n}\n\nfunction draw() {\n  var val = slider.value();\n  background(val, 100, 100, 1);\n}\n</code></div>"
            ],
            "class": "p5.dom",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 429,
            "description": "<p>Creates a &lt;button&gt;&lt;/button&gt; element in the DOM.\nUse .size() to set the display size of the button.\nUse .mousePressed() to specify behavior on press.\nAppends to the container node if one is specified, otherwise\nappends to body.</p>\n",
            "itemtype": "method",
            "name": "createButton",
            "params": [
                {
                    "name": "label",
                    "description": "<p>label displayed on the button</p>\n",
                    "type": "String"
                },
                {
                    "name": "value",
                    "description": "<p>value of the button</p>\n",
                    "type": "String",
                    "optional": true
                }
            ],
            "return": {
                "description": "pointer to p5.Element holding created node",
                "type": "Object|p5.Element"
            },
            "example": [
                "\n<div class='norender'><code>\nvar button;\nfunction setup() {\n  createCanvas(100, 100);\n  background(0);\n  button = createButton('click me');\n  button.position(19, 19);\n  button.mousePressed(changeBG);\n}\n\nfunction changeBG() {\n  var val = random(255);\n  background(val);\n}\n</code></div>"
            ],
            "class": "p5.dom",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 465,
            "description": "<p>Creates a checkbox &lt;input&gt;&lt;/input&gt; element in the DOM.\nCalling .checked() on a checkbox returns if it is checked or not</p>\n",
            "itemtype": "method",
            "name": "createCheckbox",
            "params": [
                {
                    "name": "label",
                    "description": "<p>label displayed after checkbox</p>\n",
                    "type": "String",
                    "optional": true
                },
                {
                    "name": "value",
                    "description": "<p>value of the checkbox; checked is true, unchecked is false</p>\n",
                    "type": "Boolean",
                    "optional": true
                }
            ],
            "return": {
                "description": "pointer to p5.Element holding created node",
                "type": "Object|p5.Element"
            },
            "example": [
                "\n<div class='norender'><code>\nvar checkbox;\n\nfunction setup() {\n  checkbox = createCheckbox('label', false);\n  checkbox.changed(myCheckedEvent);\n}\n\nfunction myCheckedEvent() {\n  if (this.checked()) {\n    console.log('Checking!');\n  } else {\n    console.log('Unchecking!');\n  }\n}\n</code></div>"
            ],
            "class": "p5.dom",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 533,
            "description": "<p>Creates a dropdown menu &lt;select&gt;&lt;/select&gt; element in the DOM.\nIt also helps to assign select-box methods to p5.Element when selecting existing select box</p>\n",
            "itemtype": "method",
            "name": "createSelect",
            "return": {
                "description": "",
                "type": "p5.Element"
            },
            "example": [
                "\n<div><code>\nvar sel;\n\nfunction setup() {\n  textAlign(CENTER);\n  background(200);\n  sel = createSelect();\n  sel.position(10, 10);\n  sel.option('pear');\n  sel.option('kiwi');\n  sel.option('grape');\n  sel.changed(mySelectEvent);\n}\n\nfunction mySelectEvent() {\n  var item = sel.value();\n  background(200);\n  text('it is a' + item + '!', 50, 50);\n}\n</code></div>"
            ],
            "class": "p5.dom",
            "module": "p5.dom",
            "submodule": "p5.dom",
            "overloads": [
                {
                    "line": 533,
                    "params": [
                        {
                            "name": "multiple",
                            "description": "<p>true if dropdown should support multiple selections</p>\n",
                            "type": "Boolean",
                            "optional": true
                        }
                    ],
                    "return": {
                        "description": "",
                        "type": "p5.Element"
                    }
                },
                {
                    "line": 561,
                    "params": [
                        {
                            "name": "existing",
                            "description": "<p>DOM select element</p>\n",
                            "type": "Object"
                        }
                    ],
                    "return": {
                        "description": "",
                        "type": "p5.Element"
                    }
                }
            ]
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 637,
            "description": "<p>Creates a radio button &lt;input&gt;&lt;/input&gt; element in the DOM.\nThe .option() method can be used to set options for the radio after it is\ncreated. The .value() method will return the currently selected option.</p>\n",
            "itemtype": "method",
            "name": "createRadio",
            "params": [
                {
                    "name": "divId",
                    "description": "<p>the id and name of the created div and input field respectively</p>\n",
                    "type": "String",
                    "optional": true
                }
            ],
            "return": {
                "description": "pointer to p5.Element holding created node",
                "type": "Object|p5.Element"
            },
            "example": [
                "\n<div><code>\nvar radio;\n\nfunction setup() {\n  radio = createRadio();\n  radio.option('black');\n  radio.option('white');\n  radio.option('gray');\n  radio.style('width', '60px');\n  textAlign(CENTER);\n  fill(255, 0, 0);\n}\n\nfunction draw() {\n  var val = radio.value();\n  background(val);\n  text(val, width / 2, height / 2);\n}\n</code></div>\n<div><code>\nvar radio;\n\nfunction setup() {\n  radio = createRadio();\n  radio.option('apple', 1);\n  radio.option('bread', 2);\n  radio.option('juice', 3);\n  radio.style('width', '60px');\n  textAlign(CENTER);\n}\n\nfunction draw() {\n  background(200);\n  var val = radio.value();\n  if (val) {\n    text('item cost is $' + val, width / 2, height / 2);\n  }\n}\n</code></div>"
            ],
            "class": "p5.dom",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 775,
            "description": "<p>Creates an &lt;input&gt;&lt;/input&gt; element in the DOM for text input.\nUse .size() to set the display length of the box.\nAppends to the container node if one is specified, otherwise\nappends to body.</p>\n",
            "itemtype": "method",
            "name": "createInput",
            "params": [
                {
                    "name": "value",
                    "description": "<p>default value of the input box</p>\n",
                    "type": "String",
                    "optional": true
                },
                {
                    "name": "type",
                    "description": "<p>type of text, ie text, password etc. Defaults to text</p>\n",
                    "type": "String",
                    "optional": true
                }
            ],
            "return": {
                "description": "pointer to p5.Element holding created node",
                "type": "Object|p5.Element"
            },
            "example": [
                "\n<div class='norender'><code>\nfunction setup() {\n  var inp = createInput('');\n  inp.input(myInputEvent);\n}\n\nfunction myInputEvent() {\n  console.log('you are typing: ', this.value());\n}\n</code></div>"
            ],
            "class": "p5.dom",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 805,
            "description": "<p>Creates an &lt;input&gt;&lt;/input&gt; element in the DOM of type &#39;file&#39;.\nThis allows users to select local files for use in a sketch.</p>\n",
            "itemtype": "method",
            "name": "createFileInput",
            "params": [
                {
                    "name": "callback",
                    "description": "<p>callback function for when a file loaded</p>\n",
                    "type": "Function",
                    "optional": true
                },
                {
                    "name": "multiple",
                    "description": "<p>optional to allow multiple files selected</p>\n",
                    "type": "String",
                    "optional": true
                }
            ],
            "return": {
                "description": "pointer to p5.Element holding created DOM element",
                "type": "Object|p5.Element"
            },
            "example": [
                "\nvar input;\nvar img;\n\nfunction setup() {\n  input = createFileInput(handleFile);\n  input.position(0, 0);\n}\n\nfunction draw() {\n  if (img) {\n    image(img, 0, 0, width, height);\n  }\n}\n\nfunction handleFile(file) {\n  print(file);\n  if (file.type === 'image') {\n    img = createImg(file.data);\n    img.hide();\n  }\n}"
            ],
            "class": "p5.dom",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 891,
            "class": "p5.dom",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 928,
            "description": "<p>Creates an HTML5 &lt;video&gt; element in the DOM for simple playback\nof audio/video. Shown by default, can be hidden with .hide()\nand drawn into canvas using video(). Appends to the container\nnode if one is specified, otherwise appends to body. The first parameter\ncan be either a single string path to a video file, or an array of string\npaths to different formats of the same video. This is useful for ensuring\nthat your video can play across different browsers, as each supports\ndifferent formats. See <a href='https://developer.mozilla.org/en-US/docs/Web/HTML/Supported_media_formats'>this\npage</a> for further information about supported formats.</p>\n",
            "itemtype": "method",
            "name": "createVideo",
            "params": [
                {
                    "name": "src",
                    "description": "<p>path to a video file, or array of paths for\n                            supporting different browsers</p>\n",
                    "type": "String|Array"
                },
                {
                    "name": "callback",
                    "description": "<p>callback function to be called upon\n                            &#39;canplaythrough&#39; event fire, that is, when the\n                            browser can play the media, and estimates that\n                            enough data has been loaded to play the media\n                            up to its end without having to stop for\n                            further buffering of content</p>\n",
                    "type": "Object",
                    "optional": true
                }
            ],
            "return": {
                "description": "pointer to video p5.Element",
                "type": "p5.MediaElement|p5.Element"
            },
            "example": [
                "\n<div><code>\nvar vid;\nfunction setup() {\n  vid = createVideo(['small.mp4', 'small.ogv', 'small.webm'], vidLoad);\n}\n\n// This function is called when the video loads\nfunction vidLoad() {\n  vid.play();\n}\n</code></div>"
            ],
            "class": "p5.dom",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 967,
            "class": "p5.dom",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 969,
            "description": "<p>Creates a hidden HTML5 &lt;audio&gt; element in the DOM for simple audio\nplayback. Appends to the container node if one is specified,\notherwise appends to body. The first parameter\ncan be either a single string path to a audio file, or an array of string\npaths to different formats of the same audio. This is useful for ensuring\nthat your audio can play across different browsers, as each supports\ndifferent formats. See <a href='https://developer.mozilla.org/en-US/docs/Web/HTML/Supported_media_formats'>this\npage for further information about supported formats</a>.</p>\n",
            "itemtype": "method",
            "name": "createAudio",
            "params": [
                {
                    "name": "src",
                    "description": "<p>path to an audio file, or array of paths\n                            for supporting different browsers</p>\n",
                    "type": "String|String[]",
                    "optional": true
                },
                {
                    "name": "callback",
                    "description": "<p>callback function to be called upon\n                            &#39;canplaythrough&#39; event fire, that is, when the\n                            browser can play the media, and estimates that\n                            enough data has been loaded to play the media\n                            up to its end without having to stop for\n                            further buffering of content</p>\n",
                    "type": "Object",
                    "optional": true
                }
            ],
            "return": {
                "description": "pointer to audio p5.Element  /**",
                "type": "p5.MediaElement|p5.Element"
            },
            "example": [
                "\n<div><code>\nvar ele;\nfunction setup() {\n  ele = createAudio('assets/beat.mp3');\n\n  // here we set the element to autoplay\n  // The element will play as soon\n  // as it is able to do so.\n  ele.autoplay(true);\n}\n</code></div>"
            ],
            "class": "p5.dom",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 1007,
            "class": "p5.dom",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 1042,
            "description": "<p>Creates a new &lt;video&gt; element that contains the audio/video feed\nfrom a webcam. This can be drawn onto the canvas using video().</p>\n<p>More specific properties of the feed can be passing in a Constraints object.\nSee the\n<a href='http://w3c.github.io/mediacapture-main/getusermedia.html#media-track-constraints'> W3C\nspec</a> for possible properties. Note that not all of these are supported\nby all browsers.</p>\n<p>Security note: A new browser security specification requires that getUserMedia,\nwhich is behind createCapture(), only works when you&#39;re running the code locally,\nor on HTTPS. Learn more <a href='http://stackoverflow.com/questions/34197653/getusermedia-in-chrome-47-without-using-https'>here</a>\nand <a href='https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/getUserMedia'>here</a>.</p>",
            "itemtype": "method",
            "name": "createCapture",
            "params": [
                {
                    "name": "type",
                    "description": "<p>type of capture, either VIDEO or\n                                  AUDIO if none specified, default both,\n                                  or a Constraints object</p>\n",
                    "type": "String|Constant|Object"
                },
                {
                    "name": "callback",
                    "description": "<p>function to be called once\n                                  stream has loaded</p>\n",
                    "type": "Function"
                }
            ],
            "return": {
                "description": "capture video p5.Element",
                "type": "Object|p5.Element"
            },
            "example": [
                "\n<div class='norender'><code>\nvar capture;\n\nfunction setup() {\n  createCanvas(480, 120);\n  capture = createCapture(VIDEO);\n}\n\nfunction draw() {\n  image(capture, 0, 0, width, width * capture.height / capture.width);\n  filter(INVERT);\n}\n</code></div>\n<div class='norender'><code>\nfunction setup() {\n  createCanvas(480, 120);\n  var constraints = {\n    video: {\n      mandatory: {\n        minWidth: 1280,\n        minHeight: 720\n      },\n      optional: [{ maxFrameRate: 10 }]\n    },\n    audio: true\n  };\n  createCapture(constraints, function(stream) {\n    console.log(stream);\n  });\n}\n</code></div>"
            ],
            "class": "p5.dom",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 1158,
            "description": "<p>Creates element with given tag in the DOM with given content.\nAppends to the container node if one is specified, otherwise\nappends to body.</p>\n",
            "itemtype": "method",
            "name": "createElement",
            "params": [
                {
                    "name": "tag",
                    "description": "<p>tag for the new element</p>\n",
                    "type": "String"
                },
                {
                    "name": "content",
                    "description": "<p>html content to be inserted into the element</p>\n",
                    "type": "String",
                    "optional": true
                }
            ],
            "return": {
                "description": "pointer to p5.Element holding created node",
                "type": "Object|p5.Element"
            },
            "example": [
                "\n<div class='norender'><code>\ncreateElement('h2', 'im an h2 p5.element!');\n</code></div>"
            ],
            "class": "p5.dom",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 1184,
            "description": "<p>Adds specified class to the element.</p>\n",
            "itemtype": "method",
            "name": "addClass",
            "params": [
                {
                    "name": "class",
                    "description": "<p>name of class to add</p>\n",
                    "type": "String"
                }
            ],
            "return": {
                "description": "",
                "type": "Object|p5.Element"
            },
            "example": [
                "\n <div class='norender'><code>\n var div = createDiv('div');\n div.addClass('myClass');\n </code></div>"
            ],
            "class": "p5.Element",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 1211,
            "description": "<p>Removes specified class from the element.</p>\n",
            "itemtype": "method",
            "name": "removeClass",
            "params": [
                {
                    "name": "class",
                    "description": "<p>name of class to remove</p>\n",
                    "type": "String"
                }
            ],
            "return": {
                "description": "* @example\n <div class='norender'><code>\n // In this example, a class is set when the div is created\n // and removed when mouse is pressed. This could link up\n // with a CSS style rule to toggle style properties.\nvar div;\nfunction setup() {\n   div = createDiv('div');\n   div.addClass('myClass');\n }\nfunction mousePressed() {\n   div.removeClass('myClass');\n }\n </code></div>",
                "type": "Object|p5.Element"
            },
            "class": "p5.Element",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 1242,
            "description": "<p>Attaches the element  as a child to the parent specified.\n Accepts either a string ID, DOM node, or p5.Element.\n If no argument is specified, an array of children DOM nodes is returned.</p>\n",
            "itemtype": "method",
            "name": "child",
            "params": [
                {
                    "name": "child",
                    "description": "<p>the ID, DOM node, or p5.Element\n                         to add to the current element</p>\n",
                    "type": "String|Object|p5.Element",
                    "optional": true
                }
            ],
            "return": {
                "description": "",
                "type": "p5.Element"
            },
            "example": [
                "\n <div class='norender'><code>\n var div0 = createDiv('this is the parent');\n var div1 = createDiv('this is the child');\n div0.child(div1); // use p5.Element\n </code></div>\n <div class='norender'><code>\n var div0 = createDiv('this is the parent');\n var div1 = createDiv('this is the child');\n div1.id('apples');\n div0.child('apples'); // use id\n </code></div>\n <div class='norender'><code>\n var div0 = createDiv('this is the parent');\n var elt = document.getElementById('myChildDiv');\n div0.child(elt); // use element from page\n </code></div>"
            ],
            "class": "p5.Element",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 1286,
            "description": "<p>Centers a p5 Element either vertically, horizontally,\nor both, relative to its parent or according to\nthe body if the Element has no parent. If no argument is passed\nthe Element is aligned both vertically and horizontally.</p>\n",
            "itemtype": "method",
            "name": "center",
            "params": [
                {
                    "name": "align",
                    "description": "<p>passing &#39;vertical&#39;, &#39;horizontal&#39; aligns element accordingly</p>\n",
                    "type": "String",
                    "optional": true
                }
            ],
            "return": {
                "description": "pointer to p5.Element",
                "type": "Object|p5.Element"
            },
            "example": [
                "\n<div><code>\nfunction setup() {\n  var div = createDiv('').size(10, 10);\n  div.style('background-color', 'orange');\n  div.center();\n}\n</code></div>"
            ],
            "class": "p5.Element",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 1339,
            "description": "<p>If an argument is given, sets the inner HTML of the element,\n replacing any existing html. If true is included as a second\n argument, html is appended instead of replacing existing html.\n If no arguments are given, returns\n the inner HTML of the element.</p>\n",
            "itemtype": "method",
            "name": "html",
            "params": [
                {
                    "name": "html",
                    "description": "<p>the HTML to be placed inside the element</p>\n",
                    "type": "String",
                    "optional": true
                },
                {
                    "name": "append",
                    "description": "<p>whether to append HTML to existing</p>\n",
                    "type": "Boolean",
                    "optional": true
                }
            ],
            "return": {
                "description": "",
                "type": "Object|p5.Element|String"
            },
            "example": [
                "\n <div class='norender'><code>\n var div = createDiv('').size(100, 100);\n div.html('hi');\n </code></div>\n <div class='norender'><code>\n var div = createDiv('Hello ').size(100, 100);\n div.html('World', true);\n </code></div>"
            ],
            "class": "p5.Element",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 1374,
            "description": "<p>Sets the position of the element relative to (0, 0) of the\n window. Essentially, sets position:absolute and left and top\n properties of style. If no arguments given returns the x and y position\n of the element in an object.</p>\n",
            "itemtype": "method",
            "name": "position",
            "params": [
                {
                    "name": "x",
                    "description": "<p>x-position relative to upper left of window</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "y",
                    "description": "<p>y-position relative to upper left of window</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "return": {
                "description": "",
                "type": "Object|p5.Element"
            },
            "example": [
                "\n <div><code class='norender'>\n function setup() {\n   var cnv = createCanvas(100, 100);\n   // positions canvas 50px to the right and 100px\n   // below upper left corner of the window\n   cnv.position(50, 100);\n }\n </code></div>"
            ],
            "class": "p5.Element",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 1464,
            "description": "<p>Sets the given style (css) property (1st arg) of the element with the\ngiven value (2nd arg). If a single argument is given, .style()\nreturns the value of the given property; however, if the single argument\nis given in css syntax (&#39;text-align:center&#39;), .style() sets the css\nappropriatly. .style() also handles 2d and 3d css transforms. If\nthe 1st arg is &#39;rotate&#39;, &#39;translate&#39;, or &#39;position&#39;, the following arguments\naccept Numbers as values. (&#39;translate&#39;, 10, 100, 50);</p>\n",
            "itemtype": "method",
            "name": "style",
            "params": [
                {
                    "name": "property",
                    "description": "<p>property to be set</p>\n",
                    "type": "String"
                },
                {
                    "name": "value",
                    "description": "<p>value to assign to property (only String|Number for rotate/translate)</p>\n",
                    "type": "String|Number|p5.Color",
                    "optional": true
                },
                {
                    "name": "value2",
                    "description": "<p>position can take a 2nd value</p>\n",
                    "type": "String|Number|p5.Color",
                    "optional": true
                },
                {
                    "name": "value3",
                    "description": "<p>translate can take a 2nd &amp; 3rd value</p>\n",
                    "type": "String|Number|p5.Color",
                    "optional": true
                }
            ],
            "return": {
                "description": "value of property, if no value is specified\nor p5.Element",
                "type": "String|Object|p5.Element"
            },
            "example": [
                "\n<div><code class='norender'>\nvar myDiv = createDiv('I like pandas.');\nmyDiv.style('font-size', '18px');\nmyDiv.style('color', '#ff0000');\n</code></div>\n<div><code class='norender'>\nvar col = color(25, 23, 200, 50);\nvar button = createButton('button');\nbutton.style('background-color', col);\nbutton.position(10, 10);\n</code></div>\n<div><code class='norender'>\nvar myDiv = createDiv('I like lizards.');\nmyDiv.style('position', 20, 20);\nmyDiv.style('rotate', 45);\n</code></div>\n<div><code class='norender'>\nvar myDiv;\nfunction setup() {\n  background(200);\n  myDiv = createDiv('I like gray.');\n  myDiv.position(20, 20);\n}\n\nfunction draw() {\n  myDiv.style('font-size', mouseX + 'px');\n}\n</code></div>"
            ],
            "class": "p5.Element",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 1561,
            "description": "<p>Adds a new attribute or changes the value of an existing attribute\n on the specified element. If no value is specified, returns the\n value of the given attribute, or null if attribute is not set.</p>\n",
            "itemtype": "method",
            "name": "attribute",
            "params": [
                {
                    "name": "attr",
                    "description": "<p>attribute to set</p>\n",
                    "type": "String"
                },
                {
                    "name": "value",
                    "description": "<p>value to assign to attribute</p>\n",
                    "type": "String",
                    "optional": true
                }
            ],
            "return": {
                "description": "value of attribute, if no value is\n                             specified or p5.Element",
                "type": "String|Object|p5.Element"
            },
            "example": [
                "\n <div class='norender'><code>\n var myDiv = createDiv('I like pandas.');\n myDiv.attribute('align', 'center');\n </code></div>"
            ],
            "class": "p5.Element",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 1601,
            "description": "<p>Removes an attribute on the specified element.</p>\n",
            "itemtype": "method",
            "name": "removeAttribute",
            "params": [
                {
                    "name": "attr",
                    "description": "<p>attribute to remove</p>\n",
                    "type": "String"
                }
            ],
            "return": {
                "description": "",
                "type": "Object|p5.Element"
            },
            "example": [
                "\n <div><code>\n var button;\n var checkbox;\nfunction setup() {\n   checkbox = createCheckbox('enable', true);\n   checkbox.changed(enableButton);\n   button = createButton('button');\n   button.position(10, 10);\n }\nfunction enableButton() {\n   if (this.checked()) {\n     // Re-enable the button\n     button.removeAttribute('disabled');\n   } else {\n     // Disable the button\n     button.attribute('disabled', '');\n   }\n }\n </code></div>"
            ],
            "class": "p5.Element",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 1646,
            "description": "<p>Either returns the value of the element if no arguments\ngiven, or sets the value of the element.</p>\n",
            "itemtype": "method",
            "name": "value",
            "params": [
                {
                    "name": "value",
                    "description": "",
                    "type": "String|Number",
                    "optional": true
                }
            ],
            "return": {
                "description": "value of element if no value is specified or p5.Element",
                "type": "String|Object|p5.Element"
            },
            "example": [
                "\n<div class='norender'><code>\n// gets the value\nvar inp;\nfunction setup() {\n  inp = createInput('');\n}\n\nfunction mousePressed() {\n  print(inp.value());\n}\n</code></div>\n<div class='norender'><code>\n// sets the value\nvar inp;\nfunction setup() {\n  inp = createInput('myValue');\n}\n\nfunction mousePressed() {\n  inp.value('myValue');\n}\n</code></div>"
            ],
            "class": "p5.Element",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 1688,
            "description": "<p>Shows the current element. Essentially, setting display:block for the style.</p>\n",
            "itemtype": "method",
            "name": "show",
            "return": {
                "description": "",
                "type": "Object|p5.Element"
            },
            "example": [
                "\n <div class='norender'><code>\n var div = createDiv('div');\n div.style('display', 'none');\n div.show(); // turns display to block\n </code></div>"
            ],
            "class": "p5.Element",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 1706,
            "description": "<p>Hides the current element. Essentially, setting display:none for the style.</p>\n",
            "itemtype": "method",
            "name": "hide",
            "return": {
                "description": "",
                "type": "Object|p5.Element"
            },
            "example": [
                "\n<div class='norender'><code>\nvar div = createDiv('this is a div');\ndiv.hide();\n</code></div>"
            ],
            "class": "p5.Element",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 1722,
            "description": "<p>Sets the width and height of the element. AUTO can be used to\n only adjust one dimension. If no arguments given returns the width and height\n of the element in an object.</p>\n",
            "itemtype": "method",
            "name": "size",
            "params": [
                {
                    "name": "w",
                    "description": "<p>width of the element, either AUTO, or a number</p>\n",
                    "type": "Number|Constant",
                    "optional": true
                },
                {
                    "name": "h",
                    "description": "<p>height of the element, either AUTO, or a number</p>\n",
                    "type": "Number|Constant",
                    "optional": true
                }
            ],
            "return": {
                "description": "",
                "type": "Object|p5.Element"
            },
            "example": [
                "\n <div class='norender'><code>\n var div = createDiv('this is a div');\n div.size(100, 100);\n </code></div>"
            ],
            "class": "p5.Element",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 1796,
            "description": "<p>Removes the element and deregisters all listeners.</p>\n",
            "itemtype": "method",
            "name": "remove",
            "example": [
                "\n<div class='norender'><code>\nvar myDiv = createDiv('this is some text');\nmyDiv.remove();\n</code></div>"
            ],
            "class": "p5.Element",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 1842,
            "description": "<p>Path to the media element source.</p>\n",
            "itemtype": "property",
            "name": "src",
            "return": {
                "description": "src",
                "type": "String"
            },
            "example": [
                "\n<div><code>\nvar ele;\n\nfunction setup() {\n  background(250);\n\n  //p5.MediaElement objects are usually created\n  //by calling the createAudio(), createVideo(),\n  //and createCapture() functions.\n\n  //In this example we create\n  //a new p5.MediaElement via createAudio().\n  ele = createAudio('assets/beat.mp3');\n\n  //We'll set up our example so that\n  //when you click on the text,\n  //an alert box displays the MediaElement's\n  //src field.\n  textAlign(CENTER);\n  text('Click Me!', width / 2, height / 2);\n}\n\nfunction mouseClicked() {\n  //here we test if the mouse is over the\n  //canvas element when it's clicked\n  if (mouseX >= 0 && mouseX <= width && mouseY >= 0 && mouseY <= height) {\n    //Show our p5.MediaElement's src field\n    alert(ele.src);\n  }\n}\n</code></div>"
            ],
            "class": "p5.MediaElement",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 1908,
            "description": "<p>Play an HTML5 media element.</p>\n",
            "itemtype": "method",
            "name": "play",
            "return": {
                "description": "",
                "type": "Object|p5.Element"
            },
            "example": [
                "\n<div><code>\nvar ele;\n\nfunction setup() {\n  //p5.MediaElement objects are usually created\n  //by calling the createAudio(), createVideo(),\n  //and createCapture() functions.\n\n  //In this example we create\n  //a new p5.MediaElement via createAudio().\n  ele = createAudio('assets/beat.mp3');\n\n  background(250);\n  textAlign(CENTER);\n  text('Click to Play!', width / 2, height / 2);\n}\n\nfunction mouseClicked() {\n  //here we test if the mouse is over the\n  //canvas element when it's clicked\n  if (mouseX >= 0 && mouseX <= width && mouseY >= 0 && mouseY <= height) {\n    //Here we call the play() function on\n    //the p5.MediaElement we created above.\n    //This will start the audio sample.\n    ele.play();\n\n    background(200);\n    text('You clicked Play!', width / 2, height / 2);\n  }\n}\n</code></div>"
            ],
            "class": "p5.MediaElement",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 1961,
            "description": "<p>Stops an HTML5 media element (sets current time to zero).</p>\n",
            "itemtype": "method",
            "name": "stop",
            "return": {
                "description": "",
                "type": "Object|p5.Element"
            },
            "example": [
                "\n<div><code>\n//This example both starts\n//and stops a sound sample\n//when the user clicks the canvas\n\n//We will store the p5.MediaElement\n//object in here\nvar ele;\n\n//while our audio is playing,\n//this will be set to true\nvar sampleIsPlaying = false;\n\nfunction setup() {\n  //Here we create a p5.MediaElement object\n  //using the createAudio() function.\n  ele = createAudio('assets/beat.mp3');\n  background(200);\n  textAlign(CENTER);\n  text('Click to play!', width / 2, height / 2);\n}\n\nfunction mouseClicked() {\n  //here we test if the mouse is over the\n  //canvas element when it's clicked\n  if (mouseX >= 0 && mouseX <= width && mouseY >= 0 && mouseY <= height) {\n    background(200);\n\n    if (sampleIsPlaying) {\n      //if the sample is currently playing\n      //calling the stop() function on\n      //our p5.MediaElement will stop\n      //it and reset its current\n      //time to 0 (i.e. it will start\n      //at the beginning the next time\n      //you play it)\n      ele.stop();\n\n      sampleIsPlaying = false;\n      text('Click to play!', width / 2, height / 2);\n    } else {\n      //loop our sound element until we\n      //call ele.stop() on it.\n      ele.loop();\n\n      sampleIsPlaying = true;\n      text('Click to stop!', width / 2, height / 2);\n    }\n  }\n}\n</code></div>"
            ],
            "class": "p5.MediaElement",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 2025,
            "description": "<p>Pauses an HTML5 media element.</p>\n",
            "itemtype": "method",
            "name": "pause",
            "return": {
                "description": "",
                "type": "Object|p5.Element"
            },
            "example": [
                "\n<div><code>\n//This example both starts\n//and pauses a sound sample\n//when the user clicks the canvas\n\n//We will store the p5.MediaElement\n//object in here\nvar ele;\n\n//while our audio is playing,\n//this will be set to true\nvar sampleIsPlaying = false;\n\nfunction setup() {\n  //Here we create a p5.MediaElement object\n  //using the createAudio() function.\n  ele = createAudio('assets/lucky_dragons.mp3');\n  background(200);\n  textAlign(CENTER);\n  text('Click to play!', width / 2, height / 2);\n}\n\nfunction mouseClicked() {\n  //here we test if the mouse is over the\n  //canvas element when it's clicked\n  if (mouseX >= 0 && mouseX <= width && mouseY >= 0 && mouseY <= height) {\n    background(200);\n\n    if (sampleIsPlaying) {\n      //Calling pause() on our\n      //p5.MediaElement will stop it\n      //playing, but when we call the\n      //loop() or play() functions\n      //the sample will start from\n      //where we paused it.\n      ele.pause();\n\n      sampleIsPlaying = false;\n      text('Click to resume!', width / 2, height / 2);\n    } else {\n      //loop our sound element until we\n      //call ele.pause() on it.\n      ele.loop();\n\n      sampleIsPlaying = true;\n      text('Click to pause!', width / 2, height / 2);\n    }\n  }\n}\n</code></div>"
            ],
            "class": "p5.MediaElement",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 2087,
            "description": "<p>Set &#39;loop&#39; to true for an HTML5 media element, and starts playing.</p>\n",
            "itemtype": "method",
            "name": "loop",
            "return": {
                "description": "",
                "type": "Object|p5.Element"
            },
            "example": [
                "\n<div><code>\n//Clicking the canvas will loop\n//the audio sample until the user\n//clicks again to stop it\n\n//We will store the p5.MediaElement\n//object in here\nvar ele;\n\n//while our audio is playing,\n//this will be set to true\nvar sampleIsLooping = false;\n\nfunction setup() {\n  //Here we create a p5.MediaElement object\n  //using the createAudio() function.\n  ele = createAudio('assets/lucky_dragons.mp3');\n  background(200);\n  textAlign(CENTER);\n  text('Click to loop!', width / 2, height / 2);\n}\n\nfunction mouseClicked() {\n  //here we test if the mouse is over the\n  //canvas element when it's clicked\n  if (mouseX >= 0 && mouseX <= width && mouseY >= 0 && mouseY <= height) {\n    background(200);\n\n    if (!sampleIsLooping) {\n      //loop our sound element until we\n      //call ele.stop() on it.\n      ele.loop();\n\n      sampleIsLooping = true;\n      text('Click to stop!', width / 2, height / 2);\n    } else {\n      ele.stop();\n\n      sampleIsLooping = false;\n      text('Click to loop!', width / 2, height / 2);\n    }\n  }\n}\n</code></div>"
            ],
            "class": "p5.MediaElement",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 2143,
            "description": "<p>Set &#39;loop&#39; to false for an HTML5 media element. Element will stop\nwhen it reaches the end.</p>\n",
            "itemtype": "method",
            "name": "noLoop",
            "return": {
                "description": "",
                "type": "Object|p5.Element"
            },
            "example": [
                "\n<div><code>\n//This example both starts\n//and stops loop of sound sample\n//when the user clicks the canvas\n\n//We will store the p5.MediaElement\n//object in here\nvar ele;\n//while our audio is playing,\n//this will be set to true\nvar sampleIsPlaying = false;\n\nfunction setup() {\n  //Here we create a p5.MediaElement object\n  //using the createAudio() function.\n  ele = createAudio('assets/beat.mp3');\n  background(200);\n  textAlign(CENTER);\n  text('Click to play!', width / 2, height / 2);\n}\n\nfunction mouseClicked() {\n  //here we test if the mouse is over the\n  //canvas element when it's clicked\n  if (mouseX >= 0 && mouseX <= width && mouseY >= 0 && mouseY <= height) {\n    background(200);\n\n    if (sampleIsPlaying) {\n      ele.noLoop();\n      text('No more Loops!', width / 2, height / 2);\n    } else {\n      ele.loop();\n      sampleIsPlaying = true;\n      text('Click to stop looping!', width / 2, height / 2);\n    }\n  }\n}\n</code></div>\n"
            ],
            "class": "p5.MediaElement",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 2195,
            "description": "<p>Set HTML5 media element to autoplay or not.</p>\n",
            "itemtype": "method",
            "name": "autoplay",
            "params": [
                {
                    "name": "autoplay",
                    "description": "<p>whether the element should autoplay</p>\n",
                    "type": "Boolean"
                }
            ],
            "return": {
                "description": "",
                "type": "Object|p5.Element"
            },
            "class": "p5.MediaElement",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 2207,
            "description": "<p>Sets volume for this HTML5 media element. If no argument is given,\nreturns the current volume.</p>\n",
            "params": [
                {
                    "name": "val",
                    "description": "<p>volume between 0.0 and 1.0</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "return": {
                "description": "current volume or p5.MediaElement",
                "type": "Number|p5.MediaElement"
            },
            "itemtype": "method",
            "name": "volume",
            "example": [
                "\n<div><code>\nvar ele;\nfunction setup() {\n  // p5.MediaElement objects are usually created\n  // by calling the createAudio(), createVideo(),\n  // and createCapture() functions.\n  // In this example we create\n  // a new p5.MediaElement via createAudio().\n  ele = createAudio('assets/lucky_dragons.mp3');\n  background(250);\n  textAlign(CENTER);\n  text('Click to Play!', width / 2, height / 2);\n}\nfunction mouseClicked() {\n  // Here we call the volume() function\n  // on the sound element to set its volume\n  // Volume must be between 0.0 and 1.0\n  ele.volume(0.2);\n  ele.play();\n  background(200);\n  text('You clicked Play!', width / 2, height / 2);\n}\n</code></div>\n<div><code>\nvar audio;\nvar counter = 0;\n\nfunction loaded() {\n  audio.play();\n}\n\nfunction setup() {\n  audio = createAudio('assets/lucky_dragons.mp3', loaded);\n  textAlign(CENTER);\n}\n\nfunction draw() {\n  if (counter === 0) {\n    background(0, 255, 0);\n    text('volume(0.9)', width / 2, height / 2);\n  } else if (counter === 1) {\n    background(255, 255, 0);\n    text('volume(0.5)', width / 2, height / 2);\n  } else if (counter === 2) {\n    background(255, 0, 0);\n    text('volume(0.1)', width / 2, height / 2);\n  }\n}\n\nfunction mousePressed() {\n  counter++;\n  if (counter === 0) {\n    audio.volume(0.9);\n  } else if (counter === 1) {\n    audio.volume(0.5);\n  } else if (counter === 2) {\n    audio.volume(0.1);\n  } else {\n    counter = 0;\n    audio.volume(0.9);\n  }\n}\n</code>\n</div>"
            ],
            "class": "p5.MediaElement",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 2289,
            "description": "<p>If no arguments are given, returns the current playback speed of the\nelement. The speed parameter sets the speed where 2.0 will play the\nelement twice as fast, 0.5 will play at half the speed, and -1 will play\nthe element in normal speed in reverse.(Note that not all browsers support\nbackward playback and even if they do, playback might not be smooth.)</p>\n",
            "itemtype": "method",
            "name": "speed",
            "params": [
                {
                    "name": "speed",
                    "description": "<p>speed multiplier for element playback</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "return": {
                "description": "current playback speed or p5.MediaElement",
                "type": "Number|Object|p5.MediaElement"
            },
            "example": [
                "\n<div class='norender'><code>\n//Clicking the canvas will loop\n//the audio sample until the user\n//clicks again to stop it\n\n//We will store the p5.MediaElement\n//object in here\nvar ele;\nvar button;\n\nfunction setup() {\n  createCanvas(710, 400);\n  //Here we create a p5.MediaElement object\n  //using the createAudio() function.\n  ele = createAudio('assets/beat.mp3');\n  ele.loop();\n  background(200);\n\n  button = createButton('2x speed');\n  button.position(100, 68);\n  button.mousePressed(twice_speed);\n\n  button = createButton('half speed');\n  button.position(200, 68);\n  button.mousePressed(half_speed);\n\n  button = createButton('reverse play');\n  button.position(300, 68);\n  button.mousePressed(reverse_speed);\n\n  button = createButton('STOP');\n  button.position(400, 68);\n  button.mousePressed(stop_song);\n\n  button = createButton('PLAY!');\n  button.position(500, 68);\n  button.mousePressed(play_speed);\n}\n\nfunction twice_speed() {\n  ele.speed(2);\n}\n\nfunction half_speed() {\n  ele.speed(0.5);\n}\n\nfunction reverse_speed() {\n  ele.speed(-1);\n}\n\nfunction stop_song() {\n  ele.stop();\n}\n\nfunction play_speed() {\n  ele.play();\n}\n</code></div>"
            ],
            "class": "p5.MediaElement",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 2368,
            "description": "<p>If no arguments are given, returns the current time of the element.\nIf an argument is given the current time of the element is set to it.</p>\n",
            "itemtype": "method",
            "name": "time",
            "params": [
                {
                    "name": "time",
                    "description": "<p>time to jump to (in seconds)</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "return": {
                "description": "current time (in seconds)\n                                or p5.MediaElement",
                "type": "Number|Object|p5.MediaElement"
            },
            "example": [
                "\n<div><code>\nvar ele;\nvar beginning = true;\nfunction setup() {\n  //p5.MediaElement objects are usually created\n  //by calling the createAudio(), createVideo(),\n  //and createCapture() functions.\n\n  //In this example we create\n  //a new p5.MediaElement via createAudio().\n  ele = createAudio('assets/lucky_dragons.mp3');\n  background(250);\n  textAlign(CENTER);\n  text('start at beginning', width / 2, height / 2);\n}\n\n// this function fires with click anywhere\nfunction mousePressed() {\n  if (beginning === true) {\n    // here we start the sound at the beginning\n    // time(0) is not necessary here\n    // as this produces the same result as\n    // play()\n    ele.play().time(0);\n    background(200);\n    text('jump 2 sec in', width / 2, height / 2);\n    beginning = false;\n  } else {\n    // here we jump 2 seconds into the sound\n    ele.play().time(2);\n    background(250);\n    text('start at beginning', width / 2, height / 2);\n    beginning = true;\n  }\n}\n</code></div>"
            ],
            "class": "p5.MediaElement",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 2423,
            "description": "<p>Returns the duration of the HTML5 media element.</p>\n",
            "itemtype": "method",
            "name": "duration",
            "return": {
                "description": "duration",
                "type": "Number"
            },
            "example": [
                "\n<div><code>\nvar ele;\nfunction setup() {\n  //p5.MediaElement objects are usually created\n  //by calling the createAudio(), createVideo(),\n  //and createCapture() functions.\n  //In this example we create\n  //a new p5.MediaElement via createAudio().\n  ele = createAudio('assets/doorbell.mp3');\n  background(250);\n  textAlign(CENTER);\n  text('Click to know the duration!', 10, 25, 70, 80);\n}\nfunction mouseClicked() {\n  ele.play();\n  background(200);\n  //ele.duration dislpays the duration\n  text(ele.duration() + ' seconds', width / 2, height / 2);\n}\n</code></div>"
            ],
            "class": "p5.MediaElement",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 2541,
            "description": "<p>Schedule an event to be called when the audio or video\nelement reaches the end. If the element is looping,\nthis will not be called. The element is passed in\nas the argument to the onended callback.</p>\n",
            "itemtype": "method",
            "name": "onended",
            "params": [
                {
                    "name": "callback",
                    "description": "<p>function to call when the\n                            soundfile has ended. The\n                            media element will be passed\n                            in as the argument to the\n                            callback.</p>\n",
                    "type": "Function"
                }
            ],
            "return": {
                "description": "",
                "type": "Object|p5.MediaElement"
            },
            "example": [
                "\n<div><code>\nfunction setup() {\n  var audioEl = createAudio('assets/beat.mp3');\n  audioEl.showControls();\n  audioEl.onended(sayDone);\n}\n\nfunction sayDone(elt) {\n  alert('done playing ' + elt.src);\n}\n</code></div>"
            ],
            "class": "p5.MediaElement",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 2572,
            "class": "p5.MediaElement",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 2574,
            "description": "<p>Send the audio output of this element to a specified audioNode or\np5.sound object. If no element is provided, connects to p5&#39;s master\noutput. That connection is established when this method is first called.\nAll connections are removed by the .disconnect() method.</p>\n<p>This method is meant to be used with the p5.sound.js addon library.</p>\n",
            "itemtype": "method",
            "name": "connect",
            "params": [
                {
                    "name": "audioNode",
                    "description": "<p>AudioNode from the Web Audio API,\nor an object from the p5.sound library</p>\n",
                    "type": "AudioNode|Object"
                }
            ],
            "class": "p5.MediaElement",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 2623,
            "description": "<p>Disconnect all Web Audio routing, including to master output.\nThis is useful if you want to re-route the output through\naudio effects, for example.</p>\n",
            "itemtype": "method",
            "name": "disconnect",
            "class": "p5.MediaElement",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 2638,
            "class": "p5.MediaElement",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 2640,
            "description": "<p>Show the default MediaElement controls, as determined by the web browser.</p>\n",
            "itemtype": "method",
            "name": "showControls",
            "example": [
                "\n<div><code>\nvar ele;\nfunction setup() {\n  //p5.MediaElement objects are usually created\n  //by calling the createAudio(), createVideo(),\n  //and createCapture() functions.\n  //In this example we create\n  //a new p5.MediaElement via createAudio()\n  ele = createAudio('assets/lucky_dragons.mp3');\n  background(200);\n  textAlign(CENTER);\n  text('Click to Show Controls!', 10, 25, 70, 80);\n}\nfunction mousePressed() {\n  ele.showControls();\n  background(200);\n  text('Controls Shown', width / 2, height / 2);\n}\n</code></div>"
            ],
            "class": "p5.MediaElement",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 2671,
            "description": "<p>Hide the default mediaElement controls.</p>\n",
            "itemtype": "method",
            "name": "hideControls",
            "example": [
                "\n<div><code>\nvar ele;\nfunction setup() {\n  //p5.MediaElement objects are usually created\n  //by calling the createAudio(), createVideo(),\n  //and createCapture() functions.\n  //In this example we create\n  //a new p5.MediaElement via createAudio()\n  ele = createAudio('assets/lucky_dragons.mp3');\n  ele.showControls();\n  background(200);\n  textAlign(CENTER);\n  text('Click to hide Controls!', 10, 25, 70, 80);\n}\nfunction mousePressed() {\n  ele.hideControls();\n  background(200);\n  text('Controls hidden', width / 2, height / 2);\n}\n</code></div>"
            ],
            "class": "p5.MediaElement",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 2700,
            "class": "p5.MediaElement",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 2711,
            "description": "<p>Schedule events to trigger every time a MediaElement\n(audio/video) reaches a playback cue point.</p>\n<p>Accepts a callback function, a time (in seconds) at which to trigger\nthe callback, and an optional parameter for the callback.</p>\n<p>Time will be passed as the first parameter to the callback function,\nand param will be the second parameter.</p>\n",
            "itemtype": "method",
            "name": "addCue",
            "params": [
                {
                    "name": "time",
                    "description": "<p>Time in seconds, relative to this media\n                            element&#39;s playback. For example, to trigger\n                            an event every time playback reaches two\n                            seconds, pass in the number 2. This will be\n                            passed as the first parameter to\n                            the callback function.</p>\n",
                    "type": "Number"
                },
                {
                    "name": "callback",
                    "description": "<p>Name of a function that will be\n                            called at the given time. The callback will\n                            receive time and (optionally) param as its\n                            two parameters.</p>\n",
                    "type": "Function"
                },
                {
                    "name": "value",
                    "description": "<p>An object to be passed as the\n                            second parameter to the\n                            callback function.</p>\n",
                    "type": "Object",
                    "optional": true
                }
            ],
            "return": {
                "description": "id ID of this cue,\n                    useful for removeCue(id)",
                "type": "Number"
            },
            "example": [
                "\n<div><code>\nfunction setup() {\n  background(255, 255, 255);\n\n  var audioEl = createAudio('assets/beat.mp3');\n  audioEl.showControls();\n\n  // schedule three calls to changeBackground\n  audioEl.addCue(0.5, changeBackground, color(255, 0, 0));\n  audioEl.addCue(1.0, changeBackground, color(0, 255, 0));\n  audioEl.addCue(2.5, changeBackground, color(0, 0, 255));\n  audioEl.addCue(3.0, changeBackground, color(0, 255, 255));\n  audioEl.addCue(4.2, changeBackground, color(255, 255, 0));\n  audioEl.addCue(5.0, changeBackground, color(255, 255, 0));\n}\n\nfunction changeBackground(val) {\n  background(val);\n}\n</code></div>"
            ],
            "class": "p5.MediaElement",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 2773,
            "description": "<p>Remove a callback based on its ID. The ID is returned by the\naddCue method.</p>\n",
            "itemtype": "method",
            "name": "removeCue",
            "params": [
                {
                    "name": "id",
                    "description": "<p>ID of the cue, as returned by addCue</p>\n",
                    "type": "Number"
                }
            ],
            "example": [
                "\n<div><code>\nvar audioEl, id1, id2;\nfunction setup() {\n  background(255, 255, 255);\n  audioEl = createAudio('assets/beat.mp3');\n  audioEl.showControls();\n  // schedule five calls to changeBackground\n  id1 = audioEl.addCue(0.5, changeBackground, color(255, 0, 0));\n  audioEl.addCue(1.0, changeBackground, color(0, 255, 0));\n  audioEl.addCue(2.5, changeBackground, color(0, 0, 255));\n  audioEl.addCue(3.0, changeBackground, color(0, 255, 255));\n  id2 = audioEl.addCue(4.2, changeBackground, color(255, 255, 0));\n  text('Click to remove first and last Cue!', 10, 25, 70, 80);\n}\nfunction mousePressed() {\n  audioEl.removeCue(id1);\n  audioEl.removeCue(id2);\n}\nfunction changeBackground(val) {\n  background(val);\n}\n</code></div>"
            ],
            "class": "p5.MediaElement",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 2815,
            "description": "<p>Remove all of the callbacks that had originally been scheduled\nvia the addCue method.</p>\n",
            "itemtype": "method",
            "name": "clearCues",
            "params": [
                {
                    "name": "id",
                    "description": "<p>ID of the cue, as returned by addCue</p>\n",
                    "type": "Number"
                }
            ],
            "example": [
                "\n<div><code>\nvar audioEl;\nfunction setup() {\n  background(255, 255, 255);\n  audioEl = createAudio('assets/beat.mp3');\n  //Show the default MediaElement controls, as determined by the web browser\n  audioEl.showControls();\n  // schedule calls to changeBackground\n  background(200);\n  text('Click to change Cue!', 10, 25, 70, 80);\n  audioEl.addCue(0.5, changeBackground, color(255, 0, 0));\n  audioEl.addCue(1.0, changeBackground, color(0, 255, 0));\n  audioEl.addCue(2.5, changeBackground, color(0, 0, 255));\n  audioEl.addCue(3.0, changeBackground, color(0, 255, 255));\n  audioEl.addCue(4.2, changeBackground, color(255, 255, 0));\n}\nfunction mousePressed() {\n  // here we clear the scheduled callbacks\n  audioEl.clearCues();\n  // then we add some more callbacks\n  audioEl.addCue(1, changeBackground, color(2, 2, 2));\n  audioEl.addCue(3, changeBackground, color(255, 255, 0));\n}\nfunction changeBackground(val) {\n  background(val);\n}\n</code></div>"
            ],
            "class": "p5.MediaElement",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 2885,
            "description": "<p>Underlying File object. All normal File methods can be called on this.</p>\n",
            "itemtype": "property",
            "name": "file",
            "class": "p5.File",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 2897,
            "description": "<p>File type (image, text, etc.)</p>\n",
            "itemtype": "property",
            "name": "type",
            "class": "p5.File",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 2903,
            "description": "<p>File subtype (usually the file extension jpg, png, xml, etc.)</p>\n",
            "itemtype": "property",
            "name": "subtype",
            "class": "p5.File",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 2909,
            "description": "<p>File name</p>\n",
            "itemtype": "property",
            "name": "name",
            "class": "p5.File",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 2915,
            "description": "<p>File size</p>\n",
            "itemtype": "property",
            "name": "size",
            "class": "p5.File",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.dom.js",
            "line": 2922,
            "description": "<p>URL string containing image data.</p>\n",
            "itemtype": "property",
            "name": "data",
            "class": "p5.File",
            "module": "p5.dom",
            "submodule": "p5.dom"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 46,
            "description": "<p>p5.sound\n<a href=\"https://p5js.org/reference/#/libraries/p5.sound\">https://p5js.org/reference/#/libraries/p5.sound</a></p>\n<p>From the Processing Foundation and contributors\n<a href=\"https://github.com/processing/p5.js-sound/graphs/contributors\">https://github.com/processing/p5.js-sound/graphs/contributors</a></p>\n<p>MIT License (MIT)\n<a href=\"https://github.com/processing/p5.js-sound/blob/master/LICENSE\">https://github.com/processing/p5.js-sound/blob/master/LICENSE</a></p>\n<p>Some of the many audio libraries &amp; resources that inspire p5.sound:</p>\n<ul>\n<li>TONE.js (c) Yotam Mann. Licensed under The MIT License (MIT). <a href=\"https://github.com/TONEnoTONE/Tone.js\">https://github.com/TONEnoTONE/Tone.js</a></li>\n<li>buzz.js (c) Jay Salvat. Licensed under The MIT License (MIT). <a href=\"http://buzz.jaysalvat.com/\">http://buzz.jaysalvat.com/</a></li>\n<li>Boris Smus Web Audio API book, 2013. Licensed under the Apache License <a href=\"http://www.apache.org/licenses/LICENSE-2.0\">http://www.apache.org/licenses/LICENSE-2.0</a></li>\n<li>wavesurfer.js <a href=\"https://github.com/katspaugh/wavesurfer.js\">https://github.com/katspaugh/wavesurfer.js</a></li>\n<li>Web Audio Components by Jordan Santell <a href=\"https://github.com/web-audio-components\">https://github.com/web-audio-components</a></li>\n<li><p>Wilm Thoben&#39;s Sound library for Processing <a href=\"https://github.com/processing/processing/tree/master/java/libraries/sound\">https://github.com/processing/processing/tree/master/java/libraries/sound</a></p>\n<p>Web Audio API: <a href=\"http://w3.org/TR/webaudio/\">http://w3.org/TR/webaudio/</a></p>\n</li>\n</ul>\n",
            "class": "p5.sound",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 212,
            "description": "<p>Returns the Audio Context for this sketch. Useful for users\nwho would like to dig deeper into the <a target='_blank' href=\n'http://webaudio.github.io/web-audio-api/'>Web Audio API\n</a>.</p>",
            "itemtype": "method",
            "name": "getAudioContext",
            "return": {
                "description": "AudioContext for this sketch",
                "type": "Object"
            },
            "class": "p5.sound",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 226,
            "description": "<p>Determine which filetypes are supported (inspired by buzz.js)\nThe audio element (el) will only be used to test browser support for various audio formats</p>\n",
            "class": "p5.sound",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 296,
            "description": "<p>Master contains AudioContext and the master sound output.</p>\n",
            "class": "p5.sound",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 329,
            "description": "<p>Returns a number representing the master amplitude (volume) for sound\nin this sketch.</p>\n",
            "itemtype": "method",
            "name": "getMasterVolume",
            "return": {
                "description": "Master amplitude (volume) for sound in this sketch.\n                 Should be between 0.0 (silence) and 1.0.",
                "type": "Number"
            },
            "class": "p5.sound",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 340,
            "description": "<p>Scale the output of all sound in this sketch</p>\nScaled between 0.0 (silence) and 1.0 (full volume).\n1.0 is the maximum amplitude of a digital sound, so multiplying\nby greater than 1.0 may cause digital distortion. To\nfade, provide a <code>rampTime</code> parameter. For more\ncomplex fades, see the Env class.\n\nAlternately, you can pass in a signal source such as an\noscillator to modulate the amplitude with an audio signal.\n\n<p><b>How This Works</b>: When you load the p5.sound module, it\ncreates a single instance of p5sound. All sound objects in this\nmodule output to p5sound before reaching your computer&#39;s output.\nSo if you change the amplitude of p5sound, it impacts all of the\nsound in this module.</p>\n\n<p>If no value is provided, returns a Web Audio API Gain Node</p>",
            "itemtype": "method",
            "name": "masterVolume",
            "params": [
                {
                    "name": "volume",
                    "description": "<p>Volume (amplitude) between 0.0\n                                   and 1.0 or modulating signal/oscillator</p>\n",
                    "type": "Number|Object"
                },
                {
                    "name": "rampTime",
                    "description": "<p>Fade for t seconds</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "timeFromNow",
                    "description": "<p>Schedule this event to happen at\n                               t seconds in the future</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "class": "p5.sound",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 382,
            "description": "<p><code>p5.soundOut</code> is the p5.sound master output. It sends output to\nthe destination of this window&#39;s web audio context. It contains\nWeb Audio API nodes including a dyanmicsCompressor (<code>.limiter</code>),\nand Gain Nodes for <code>.input</code> and <code>.output</code>.</p>\n",
            "itemtype": "property",
            "name": "soundOut",
            "type": "Object",
            "class": "p5.sound",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 407,
            "class": "p5",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 410,
            "description": "<p>Returns a number representing the sample rate, in samples per second,\nof all sound objects in this audio context. It is determined by the\nsampling rate of your operating system&#39;s sound card, and it is not\ncurrently possile to change.\nIt is often 44100, or twice the range of human hearing.</p>\n",
            "itemtype": "method",
            "name": "sampleRate",
            "return": {
                "description": "samplerate samples per second",
                "type": "Number"
            },
            "class": "p5",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 423,
            "description": "<p>Returns the closest MIDI note value for\na given frequency.</p>\n",
            "itemtype": "method",
            "name": "freqToMidi",
            "params": [
                {
                    "name": "frequency",
                    "description": "<p>A freqeuncy, for example, the &quot;A&quot;\n                           above Middle C is 440Hz</p>\n",
                    "type": "Number"
                }
            ],
            "return": {
                "description": "MIDI note value",
                "type": "Number"
            },
            "class": "p5",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 437,
            "description": "<p>Returns the frequency value of a MIDI note value.\nGeneral MIDI treats notes as integers where middle C\nis 60, C# is 61, D is 62 etc. Useful for generating\nmusical frequencies with oscillators.</p>\n",
            "itemtype": "method",
            "name": "midiToFreq",
            "params": [
                {
                    "name": "midiNote",
                    "description": "<p>The number of a MIDI note</p>\n",
                    "type": "Number"
                }
            ],
            "return": {
                "description": "Frequency value of the given MIDI note",
                "type": "Number"
            },
            "example": [
                "\n<div><code>\nvar notes = [60, 64, 67, 72];\nvar i = 0;\n\nfunction setup() {\n  osc = new p5.Oscillator('Triangle');\n  osc.start();\n  frameRate(1);\n}\n\nfunction draw() {\n  var freq = midiToFreq(notes[i]);\n  osc.freq(freq);\n  i++;\n  if (i >= notes.length){\n    i = 0;\n  }\n}\n</code></div>"
            ],
            "class": "p5",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 470,
            "description": "<p>List the SoundFile formats that you will include. LoadSound\nwill search your directory for these extensions, and will pick\na format that is compatable with the client&#39;s web browser.\n<a href=\"http://media.io/\">Here</a> is a free online file\nconverter.</p>\n",
            "itemtype": "method",
            "name": "soundFormats",
            "params": [
                {
                    "name": "formats",
                    "description": "<p>i.e. &#39;mp3&#39;, &#39;wav&#39;, &#39;ogg&#39;</p>\n",
                    "type": "String",
                    "optional": true,
                    "multiple": true
                }
            ],
            "example": [
                "\n<div><code>\nfunction preload() {\n  // set the global sound formats\n  soundFormats('mp3', 'ogg');\n\n  // load either beatbox.mp3, or .ogg, depending on browser\n  mySound = loadSound('assets/beatbox.mp3');\n}\n\nfunction setup() {\n  mySound.play();\n}\n</code></div>"
            ],
            "class": "p5",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 583,
            "description": "<p>Used by Osc and Env to chain signal math</p>\n",
            "class": "p5",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 855,
            "description": "<p>loadSound() returns a new p5.SoundFile from a specified\npath. If called during preload(), the p5.SoundFile will be ready\nto play in time for setup() and draw(). If called outside of\npreload, the p5.SoundFile will not be ready immediately, so\nloadSound accepts a callback as the second parameter. Using a\n<a href=\"https://github.com/processing/p5.js/wiki/Local-server\">\nlocal server</a> is recommended when loading external files.</p>\n",
            "itemtype": "method",
            "name": "loadSound",
            "params": [
                {
                    "name": "path",
                    "description": "<p>Path to the sound file, or an array with\n                                  paths to soundfiles in multiple formats\n                                  i.e. [&#39;sound.ogg&#39;, &#39;sound.mp3&#39;].\n                                  Alternately, accepts an object: either\n                                  from the HTML5 File API, or a p5.File.</p>\n",
                    "type": "String|Array"
                },
                {
                    "name": "successCallback",
                    "description": "<p>Name of a function to call once file loads</p>\n",
                    "type": "Function",
                    "optional": true
                },
                {
                    "name": "errorCallback",
                    "description": "<p>Name of a function to call if there is\n                                    an error loading the file.</p>\n",
                    "type": "Function",
                    "optional": true
                },
                {
                    "name": "whileLoading",
                    "description": "<p>Name of a function to call while file is loading.\n                               This function will receive the percentage loaded\n                               so far, from 0.0 to 1.0.</p>\n",
                    "type": "Function",
                    "optional": true
                }
            ],
            "return": {
                "description": "Returns a p5.SoundFile",
                "type": "SoundFile"
            },
            "example": [
                "\n<div><code>\nfunction preload() {\n mySound = loadSound('assets/doorbell.mp3');\n}\n\nfunction setup() {\n  mySound.setVolume(0.1);\n  mySound.play();\n}\n</code></div>"
            ],
            "class": "p5.SoundFile",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 995,
            "description": "<p>Returns true if the sound file finished loading successfully.</p>\n",
            "itemtype": "method",
            "name": "isLoaded",
            "return": {
                "description": "",
                "type": "Boolean"
            },
            "class": "p5.SoundFile",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 1008,
            "description": "<p>Play the p5.SoundFile</p>\n",
            "itemtype": "method",
            "name": "play",
            "params": [
                {
                    "name": "startTime",
                    "description": "<p>(optional) schedule playback to start (in seconds from now).</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "rate",
                    "description": "<p>(optional) playback rate</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "amp",
                    "description": "<p>(optional) amplitude (volume)\n                                    of playback</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "cueStart",
                    "description": "<p>(optional) cue start time in seconds</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "duration",
                    "description": "<p>(optional) duration of playback in seconds</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "class": "p5.SoundFile",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 1109,
            "description": "<p>p5.SoundFile has two play modes: <code>restart</code> and\n<code>sustain</code>. Play Mode determines what happens to a\np5.SoundFile if it is triggered while in the middle of playback.\nIn sustain mode, playback will continue simultaneous to the\nnew playback. In restart mode, play() will stop playback\nand start over. With untilDone, a sound will play only if it&#39;s\nnot already playing. Sustain is the default mode.</p>\n",
            "itemtype": "method",
            "name": "playMode",
            "params": [
                {
                    "name": "str",
                    "description": "<p>&#39;restart&#39; or &#39;sustain&#39; or &#39;untilDone&#39;</p>\n",
                    "type": "String"
                }
            ],
            "example": [
                "\n<div><code>\nfunction setup(){\n  mySound = loadSound('assets/Damscray_DancingTiger.mp3');\n}\nfunction mouseClicked() {\n  mySound.playMode('sustain');\n  mySound.play();\n}\nfunction keyPressed() {\n  mySound.playMode('restart');\n  mySound.play();\n}\n\n </code></div>"
            ],
            "class": "p5.SoundFile",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 1152,
            "description": "<p>Pauses a file that is currently playing. If the file is not\nplaying, then nothing will happen.</p>\n<p>After pausing, .play() will resume from the paused\nposition.\nIf p5.SoundFile had been set to loop before it was paused,\nit will continue to loop after it is unpaused with .play().</p>\n",
            "itemtype": "method",
            "name": "pause",
            "params": [
                {
                    "name": "startTime",
                    "description": "<p>(optional) schedule event to occur\n                             seconds from now</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "example": [
                "\n<div><code>\nvar soundFile;\n\nfunction preload() {\n  soundFormats('ogg', 'mp3');\n  soundFile = loadSound('assets/Damscray_02.mp3');\n}\nfunction setup() {\n  background(0, 255, 0);\n  soundFile.setVolume(0.1);\n  soundFile.loop();\n}\nfunction keyTyped() {\n  if (key == 'p') {\n    soundFile.pause();\n    background(255, 0, 0);\n  }\n}\n\nfunction keyReleased() {\n  if (key == 'p') {\n    soundFile.play();\n    background(0, 255, 0);\n  }\n}\n</code>\n</div>"
            ],
            "class": "p5.SoundFile",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 1208,
            "description": "<p>Loop the p5.SoundFile. Accepts optional parameters to set the\nplayback rate, playback volume, loopStart, loopEnd.</p>\n",
            "itemtype": "method",
            "name": "loop",
            "params": [
                {
                    "name": "startTime",
                    "description": "<p>(optional) schedule event to occur\n                            seconds from now</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "rate",
                    "description": "<p>(optional) playback rate</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "amp",
                    "description": "<p>(optional) playback volume</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "cueLoopStart",
                    "description": "<p>(optional) startTime in seconds</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "duration",
                    "description": "<p>(optional) loop duration in seconds</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "class": "p5.SoundFile",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 1224,
            "description": "<p>Set a p5.SoundFile&#39;s looping flag to true or false. If the sound\nis currently playing, this change will take effect when it\nreaches the end of the current playback.</p>\n",
            "itemtype": "method",
            "name": "setLoop",
            "params": [
                {
                    "name": "Boolean",
                    "description": "<p>set looping to true or false</p>\n",
                    "type": "Boolean"
                }
            ],
            "class": "p5.SoundFile",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 1245,
            "description": "<p>Returns &#39;true&#39; if a p5.SoundFile is currently looping and playing, &#39;false&#39; if not.</p>\n",
            "itemtype": "method",
            "name": "isLooping",
            "return": {
                "description": "",
                "type": "Boolean"
            },
            "class": "p5.SoundFile",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 1260,
            "description": "<p>Returns true if a p5.SoundFile is playing, false if not (i.e.\npaused or stopped).</p>\n",
            "itemtype": "method",
            "name": "isPlaying",
            "return": {
                "description": "",
                "type": "Boolean"
            },
            "class": "p5.SoundFile",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 1270,
            "description": "<p>Returns true if a p5.SoundFile is paused, false if not (i.e.\nplaying or stopped).</p>\n",
            "itemtype": "method",
            "name": "isPaused",
            "return": {
                "description": "",
                "type": "Boolean"
            },
            "class": "p5.SoundFile",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 1280,
            "description": "<p>Stop soundfile playback.</p>\n",
            "itemtype": "method",
            "name": "stop",
            "params": [
                {
                    "name": "startTime",
                    "description": "<p>(optional) schedule event to occur\n                            in seconds from now</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "class": "p5.SoundFile",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 1326,
            "description": "<p>Multiply the output volume (amplitude) of a sound file\nbetween 0.0 (silence) and 1.0 (full volume).\n1.0 is the maximum amplitude of a digital sound, so multiplying\nby greater than 1.0 may cause digital distortion. To\nfade, provide a <code>rampTime</code> parameter. For more\ncomplex fades, see the Env class.</p>\n<p>Alternately, you can pass in a signal source such as an\noscillator to modulate the amplitude with an audio signal.</p>\n",
            "itemtype": "method",
            "name": "setVolume",
            "params": [
                {
                    "name": "volume",
                    "description": "<p>Volume (amplitude) between 0.0\n                                   and 1.0 or modulating signal/oscillator</p>\n",
                    "type": "Number|Object"
                },
                {
                    "name": "rampTime",
                    "description": "<p>Fade for t seconds</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "timeFromNow",
                    "description": "<p>Schedule this event to happen at\n                               t seconds in the future</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "class": "p5.SoundFile",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 1367,
            "description": "<p>Set the stereo panning of a p5.sound object to\na floating point number between -1.0 (left) and 1.0 (right).\nDefault is 0.0 (center).</p>\n",
            "itemtype": "method",
            "name": "pan",
            "params": [
                {
                    "name": "panValue",
                    "description": "<p>Set the stereo panner</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "timeFromNow",
                    "description": "<p>schedule this event to happen\n                                seconds from now</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "example": [
                "\n<div><code>\n\n var ball = {};\n var soundFile;\n\n function setup() {\n   soundFormats('ogg', 'mp3');\n   soundFile = loadSound('assets/beatbox.mp3');\n }\n\n function draw() {\n   background(0);\n   ball.x = constrain(mouseX, 0, width);\n   ellipse(ball.x, height/2, 20, 20)\n }\n\n function mousePressed(){\n   // map the ball's x location to a panning degree\n   // between -1.0 (left) and 1.0 (right)\n   var panning = map(ball.x, 0., width,-1.0, 1.0);\n   soundFile.pan(panning);\n   soundFile.play();\n }\n </div></code>"
            ],
            "class": "p5.SoundFile",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 1406,
            "description": "<p>Returns the current stereo pan position (-1.0 to 1.0)</p>\n",
            "itemtype": "method",
            "name": "getPan",
            "return": {
                "description": "Returns the stereo pan setting of the Oscillator\n                         as a number between -1.0 (left) and 1.0 (right).\n                         0.0 is center and default.",
                "type": "Number"
            },
            "class": "p5.SoundFile",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 1417,
            "description": "<p>Set the playback rate of a sound file. Will change the speed and the pitch.\nValues less than zero will reverse the audio buffer.</p>\n",
            "itemtype": "method",
            "name": "rate",
            "params": [
                {
                    "name": "playbackRate",
                    "description": "<p>Set the playback rate. 1.0 is normal,\n                                   .5 is half-speed, 2.0 is twice as fast.\n                                   Values less than zero play backwards.</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "example": [
                "\n<div><code>\nvar song;\n\nfunction preload() {\n  song = loadSound('assets/Damscray_DancingTiger.mp3');\n}\n\nfunction setup() {\n  song.loop();\n}\n\nfunction draw() {\n  background(200);\n\n  // Set the rate to a range between 0.1 and 4\n  // Changing the rate also alters the pitch\n  var speed = map(mouseY, 0.1, height, 0, 2);\n  speed = constrain(speed, 0.01, 4);\n  song.rate(speed);\n\n  // Draw a circle to show what is going on\n  stroke(0);\n  fill(51, 100);\n  ellipse(mouseX, 100, 48, 48);\n}\n\n </code>\n </div>\n"
            ],
            "class": "p5.SoundFile",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 1490,
            "description": "<p>Returns the duration of a sound file in seconds.</p>\n",
            "itemtype": "method",
            "name": "duration",
            "return": {
                "description": "The duration of the soundFile in seconds.",
                "type": "Number"
            },
            "class": "p5.SoundFile",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 1504,
            "description": "<p>Return the current position of the p5.SoundFile playhead, in seconds.\nTime is relative to the normal buffer direction, so if <code>reverseBuffer</code>\nhas been called, currentTime will count backwards.</p>\n",
            "itemtype": "method",
            "name": "currentTime",
            "return": {
                "description": "currentTime of the soundFile in seconds.",
                "type": "Number"
            },
            "class": "p5.SoundFile",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 1515,
            "description": "<p>Move the playhead of the song to a position, in seconds. Start timing\nand playback duration. If none are given, will reset the file to play\nentire duration from start to finish.</p>\n",
            "itemtype": "method",
            "name": "jump",
            "params": [
                {
                    "name": "cueTime",
                    "description": "<p>cueTime of the soundFile in seconds.</p>\n",
                    "type": "Number"
                },
                {
                    "name": "duration",
                    "description": "<p>duration in seconds.</p>\n",
                    "type": "Number"
                }
            ],
            "class": "p5.SoundFile",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 1538,
            "description": "<p>Return the number of channels in a sound file.\nFor example, Mono = 1, Stereo = 2.</p>\n",
            "itemtype": "method",
            "name": "channels",
            "return": {
                "description": "[channels]",
                "type": "Number"
            },
            "class": "p5.SoundFile",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 1548,
            "description": "<p>Return the sample rate of the sound file.</p>\n",
            "itemtype": "method",
            "name": "sampleRate",
            "return": {
                "description": "[sampleRate]",
                "type": "Number"
            },
            "class": "p5.SoundFile",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 1557,
            "description": "<p>Return the number of samples in a sound file.\nEqual to sampleRate * duration.</p>\n",
            "itemtype": "method",
            "name": "frames",
            "return": {
                "description": "[sampleCount]",
                "type": "Number"
            },
            "class": "p5.SoundFile",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 1567,
            "description": "<p>Returns an array of amplitude peaks in a p5.SoundFile that can be\nused to draw a static waveform. Scans through the p5.SoundFile&#39;s\naudio buffer to find the greatest amplitudes. Accepts one\nparameter, &#39;length&#39;, which determines size of the array.\nLarger arrays result in more precise waveform visualizations.</p>\n<p>Inspired by Wavesurfer.js.</p>\n",
            "itemtype": "method",
            "name": "getPeaks",
            "params": [
                {
                    "name": "length",
                    "description": "<p>length is the size of the returned array.\n                         Larger length results in more precision.\n                         Defaults to 5*width of the browser window.</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "return": {
                "description": "Array of peaks.",
                "type": "Float32Array"
            },
            "class": "p5.SoundFile",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 1619,
            "description": "<p>Reverses the p5.SoundFile&#39;s buffer source.\nPlayback must be handled separately (see example).</p>\n",
            "itemtype": "method",
            "name": "reverseBuffer",
            "example": [
                "\n<div><code>\nvar drum;\n\nfunction preload() {\n  drum = loadSound('assets/drum.mp3');\n}\n\nfunction setup() {\n  drum.reverseBuffer();\n  drum.play();\n}\n\n </code>\n </div>"
            ],
            "class": "p5.SoundFile",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 1659,
            "description": "<p>Schedule an event to be called when the soundfile\nreaches the end of a buffer. If the soundfile is\nplaying through once, this will be called when it\nends. If it is looping, it will be called when\nstop is called.</p>\n",
            "itemtype": "method",
            "name": "onended",
            "params": [
                {
                    "name": "callback",
                    "description": "<p>function to call when the\n                            soundfile has ended.</p>\n",
                    "type": "Function"
                }
            ],
            "class": "p5.SoundFile",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 1712,
            "description": "<p>Connects the output of a p5sound object to input of another\np5.sound object. For example, you may connect a p5.SoundFile to an\nFFT or an Effect. If no parameter is given, it will connect to\nthe master output. Most p5sound objects connect to the master\noutput when they are created.</p>\n",
            "itemtype": "method",
            "name": "connect",
            "params": [
                {
                    "name": "object",
                    "description": "<p>Audio object that accepts an input</p>\n",
                    "type": "Object",
                    "optional": true
                }
            ],
            "class": "p5.SoundFile",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 1733,
            "description": "<p>Disconnects the output of this p5sound object.</p>\n",
            "itemtype": "method",
            "name": "disconnect",
            "class": "p5.SoundFile",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 1741,
            "class": "p5.SoundFile",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 1746,
            "description": "<p>Reset the source for this SoundFile to a\nnew path (URL).</p>\n",
            "itemtype": "method",
            "name": "setPath",
            "params": [
                {
                    "name": "path",
                    "description": "<p>path to audio file</p>\n",
                    "type": "String"
                },
                {
                    "name": "callback",
                    "description": "<p>Callback</p>\n",
                    "type": "Function"
                }
            ],
            "class": "p5.SoundFile",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 1759,
            "description": "<p>Replace the current Audio Buffer with a new Buffer.</p>\n",
            "itemtype": "method",
            "name": "setBuffer",
            "params": [
                {
                    "name": "buf",
                    "description": "<p>Array of Float32 Array(s). 2 Float32 Arrays\n                   will create a stereo source. 1 will create\n                   a mono source.</p>\n",
                    "type": "Array"
                }
            ],
            "class": "p5.SoundFile",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 1831,
            "description": "<p>processPeaks returns an array of timestamps where it thinks there is a beat.</p>\n<p>This is an asynchronous function that processes the soundfile in an offline audio context,\nand sends the results to your callback function.</p>\n<p>The process involves running the soundfile through a lowpass filter, and finding all of the\npeaks above the initial threshold. If the total number of peaks are below the minimum number of peaks,\nit decreases the threshold and re-runs the analysis until either minPeaks or minThreshold are reached.</p>\n",
            "itemtype": "method",
            "name": "processPeaks",
            "params": [
                {
                    "name": "callback",
                    "description": "<p>a function to call once this data is returned</p>\n",
                    "type": "Function"
                },
                {
                    "name": "initThreshold",
                    "description": "<p>initial threshold defaults to 0.9</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "minThreshold",
                    "description": "<p>minimum threshold defaults to 0.22</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "minPeaks",
                    "description": "<p>minimum number of peaks defaults to 200</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "return": {
                "description": "Array of timestamped peaks",
                "type": "Array"
            },
            "class": "p5.SoundFile",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 2022,
            "class": "p5.SoundFile",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 2031,
            "description": "<p>Schedule events to trigger every time a MediaElement\n(audio/video) reaches a playback cue point.</p>\n<p>Accepts a callback function, a time (in seconds) at which to trigger\nthe callback, and an optional parameter for the callback.</p>\n<p>Time will be passed as the first parameter to the callback function,\nand param will be the second parameter.</p>\n",
            "itemtype": "method",
            "name": "addCue",
            "params": [
                {
                    "name": "time",
                    "description": "<p>Time in seconds, relative to this media\n                           element&#39;s playback. For example, to trigger\n                           an event every time playback reaches two\n                           seconds, pass in the number 2. This will be\n                           passed as the first parameter to\n                           the callback function.</p>\n",
                    "type": "Number"
                },
                {
                    "name": "callback",
                    "description": "<p>Name of a function that will be\n                           called at the given time. The callback will\n                           receive time and (optionally) param as its\n                           two parameters.</p>\n",
                    "type": "Function"
                },
                {
                    "name": "value",
                    "description": "<p>An object to be passed as the\n                           second parameter to the\n                           callback function.</p>\n",
                    "type": "Object",
                    "optional": true
                }
            ],
            "return": {
                "description": "id ID of this cue,\n                    useful for removeCue(id)",
                "type": "Number"
            },
            "example": [
                "\n<div><code>\nfunction setup() {\n  background(0);\n  noStroke();\n  fill(255);\n  textAlign(CENTER);\n  text('click to play', width/2, height/2);\n\n  mySound = loadSound('assets/beat.mp3');\n\n  // schedule calls to changeText\n  mySound.addCue(0.50, changeText, \"hello\" );\n  mySound.addCue(1.00, changeText, \"p5\" );\n  mySound.addCue(1.50, changeText, \"what\" );\n  mySound.addCue(2.00, changeText, \"do\" );\n  mySound.addCue(2.50, changeText, \"you\" );\n  mySound.addCue(3.00, changeText, \"want\" );\n  mySound.addCue(4.00, changeText, \"to\" );\n  mySound.addCue(5.00, changeText, \"make\" );\n  mySound.addCue(6.00, changeText, \"?\" );\n}\n\nfunction changeText(val) {\n  background(0);\n  text(val, width/2, height/2);\n}\n\nfunction mouseClicked() {\n  if (mouseX > 0 && mouseX < width && mouseY > 0 && mouseY < height) {\n    if (mySound.isPlaying() ) {\n      mySound.stop();\n    } else {\n      mySound.play();\n    }\n  }\n}\n</code></div>"
            ],
            "class": "p5.SoundFile",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 2106,
            "description": "<p>Remove a callback based on its ID. The ID is returned by the\naddCue method.</p>\n",
            "itemtype": "method",
            "name": "removeCue",
            "params": [
                {
                    "name": "id",
                    "description": "<p>ID of the cue, as returned by addCue</p>\n",
                    "type": "Number"
                }
            ],
            "class": "p5.SoundFile",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 2124,
            "description": "<p>Remove all of the callbacks that had originally been scheduled\nvia the addCue method.</p>\n",
            "itemtype": "method",
            "name": "clearCues",
            "class": "p5.SoundFile",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 2232,
            "description": "<p>Connects to the p5sound instance (master output) by default.\nOptionally, you can pass in a specific source (i.e. a soundfile).</p>\n",
            "itemtype": "method",
            "name": "setInput",
            "params": [
                {
                    "name": "snd",
                    "description": "<p>set the sound source\n                                     (optional, defaults to\n                                     master output)</p>\n",
                    "type": "SoundObject|undefined",
                    "optional": true
                },
                {
                    "name": "smoothing",
                    "description": "<p>a range between 0.0 and 1.0\n                                      to smooth amplitude readings</p>\n",
                    "type": "Number|undefined",
                    "optional": true
                }
            ],
            "example": [
                "\n<div><code>\nfunction preload(){\n  sound1 = loadSound('assets/beat.mp3');\n  sound2 = loadSound('assets/drum.mp3');\n}\nfunction setup(){\n  amplitude = new p5.Amplitude();\n  sound1.play();\n  sound2.play();\n  amplitude.setInput(sound2);\n}\nfunction draw() {\n  background(0);\n  fill(255);\n  var level = amplitude.getLevel();\n  var size = map(level, 0, 1, 0, 200);\n  ellipse(width/2, height/2, size, size);\n}\nfunction mouseClicked(){\n  sound1.stop();\n  sound2.stop();\n}\n</code></div>"
            ],
            "class": "p5.Amplitude",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 2337,
            "description": "<p>Returns a single Amplitude reading at the moment it is called.\nFor continuous readings, run in the draw loop.</p>\n",
            "itemtype": "method",
            "name": "getLevel",
            "params": [
                {
                    "name": "channel",
                    "description": "<p>Optionally return only channel 0 (left) or 1 (right)</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "return": {
                "description": "Amplitude as a number between 0.0 and 1.0",
                "type": "Number"
            },
            "example": [
                "\n<div><code>\nfunction preload(){\n  sound = loadSound('assets/beat.mp3');\n}\nfunction setup() {\n  amplitude = new p5.Amplitude();\n  sound.play();\n}\nfunction draw() {\n  background(0);\n  fill(255);\n  var level = amplitude.getLevel();\n  var size = map(level, 0, 1, 0, 200);\n  ellipse(width/2, height/2, size, size);\n}\nfunction mouseClicked(){\n  sound.stop();\n}\n</code></div>"
            ],
            "class": "p5.Amplitude",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 2378,
            "description": "<p>Determines whether the results of Amplitude.process() will be\nNormalized. To normalize, Amplitude finds the difference the\nloudest reading it has processed and the maximum amplitude of\n1.0. Amplitude adds this difference to all values to produce\nresults that will reliably map between 0.0 and 1.0. However,\nif a louder moment occurs, the amount that Normalize adds to\nall the values will change. Accepts an optional boolean parameter\n(true or false). Normalizing is off by default.</p>\n",
            "itemtype": "method",
            "name": "toggleNormalize",
            "params": [
                {
                    "name": "boolean",
                    "description": "<p>set normalize to true (1) or false (0)</p>\n",
                    "type": "Boolean",
                    "optional": true
                }
            ],
            "class": "p5.Amplitude",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 2398,
            "description": "<p>Smooth Amplitude analysis by averaging with the last analysis\nframe. Off by default.</p>\n",
            "itemtype": "method",
            "name": "smooth",
            "params": [
                {
                    "name": "set",
                    "description": "<p>smoothing from 0.0 &lt;= 1</p>\n",
                    "type": "Number"
                }
            ],
            "class": "p5.Amplitude",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 2567,
            "description": "<p>Set the input source for the FFT analysis. If no source is\nprovided, FFT will analyze all sound in the sketch.</p>\n",
            "itemtype": "method",
            "name": "setInput",
            "params": [
                {
                    "name": "source",
                    "description": "<p>p5.sound object (or web audio API source node)</p>\n",
                    "type": "Object",
                    "optional": true
                }
            ],
            "class": "p5.FFT",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 2586,
            "description": "<p>Returns an array of amplitude values (between -1.0 and +1.0) that represent\na snapshot of amplitude readings in a single buffer. Length will be\nequal to bins (defaults to 1024). Can be used to draw the waveform\nof a sound.</p>\n",
            "itemtype": "method",
            "name": "waveform",
            "params": [
                {
                    "name": "bins",
                    "description": "<p>Must be a power of two between\n                          16 and 1024. Defaults to 1024.</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "precision",
                    "description": "<p>If any value is provided, will return results\n                            in a Float32 Array which is more precise\n                            than a regular array.</p>\n",
                    "type": "String",
                    "optional": true
                }
            ],
            "return": {
                "description": "Array    Array of amplitude values (-1 to 1)\n                          over time. Array length = bins.",
                "type": "Array"
            },
            "class": "p5.FFT",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 2629,
            "description": "<p>Returns an array of amplitude values (between 0 and 255)\nacross the frequency spectrum. Length is equal to FFT bins\n(1024 by default). The array indices correspond to frequencies\n(i.e. pitches), from the lowest to the highest that humans can\nhear. Each value represents amplitude at that slice of the\nfrequency spectrum. Must be called prior to using\n<code>getEnergy()</code>.</p>\n",
            "itemtype": "method",
            "name": "analyze",
            "params": [
                {
                    "name": "bins",
                    "description": "<p>Must be a power of two between\n                           16 and 1024. Defaults to 1024.</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "scale",
                    "description": "<p>If &quot;dB,&quot; returns decibel\n                           float measurements between\n                           -140 and 0 (max).\n                           Otherwise returns integers from 0-255.</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "return": {
                "description": "spectrum    Array of energy (amplitude/volume)\n                            values across the frequency spectrum.\n                            Lowest energy (silence) = 0, highest\n                            possible is 255.",
                "type": "Array"
            },
            "example": [
                "\n<div><code>\nvar osc;\nvar fft;\n\nfunction setup(){\n  createCanvas(100,100);\n  osc = new p5.Oscillator();\n  osc.amp(0);\n  osc.start();\n  fft = new p5.FFT();\n}\n\nfunction draw(){\n  background(0);\n\n  var freq = map(mouseX, 0, 800, 20, 15000);\n  freq = constrain(freq, 1, 20000);\n  osc.freq(freq);\n\n  var spectrum = fft.analyze();\n  noStroke();\n  fill(0,255,0); // spectrum is green\n  for (var i = 0; i< spectrum.length; i++){\n    var x = map(i, 0, spectrum.length, 0, width);\n    var h = -height + map(spectrum[i], 0, 255, height, 0);\n    rect(x, height, width / spectrum.length, h );\n  }\n\n  stroke(255);\n  text('Freq: ' + round(freq)+'Hz', 10, 10);\n\n  isMouseOverCanvas();\n}\n\n// only play sound when mouse is over canvas\nfunction isMouseOverCanvas() {\n  var mX = mouseX, mY = mouseY;\n  if (mX > 0 && mX < width && mY < height && mY > 0) {\n    osc.amp(0.5, 0.2);\n  } else {\n    osc.amp(0, 0.2);\n  }\n}\n</code></div>\n\n"
            ],
            "class": "p5.FFT",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 2721,
            "description": "<p>Returns the amount of energy (volume) at a specific\n<a href=\"https://en.wikipedia.org/wiki/Audio_frequency\" target=\"_blank\">\nfrequency</a>, or the average amount of energy between two\nfrequencies. Accepts Number(s) corresponding\nto frequency (in Hz), or a String corresponding to predefined\nfrequency ranges (&quot;bass&quot;, &quot;lowMid&quot;, &quot;mid&quot;, &quot;highMid&quot;, &quot;treble&quot;).\nReturns a range between 0 (no energy/volume at that frequency) and\n255 (maximum energy).\n<em>NOTE: analyze() must be called prior to getEnergy(). Analyze()\ntells the FFT to analyze frequency data, and getEnergy() uses\nthe results determine the value at a specific frequency or\nrange of frequencies.</em></p></p>\n",
            "itemtype": "method",
            "name": "getEnergy",
            "params": [
                {
                    "name": "frequency1",
                    "description": "<p>Will return a value representing\n                              energy at this frequency. Alternately,\n                              the strings &quot;bass&quot;, &quot;lowMid&quot; &quot;mid&quot;,\n                              &quot;highMid&quot;, and &quot;treble&quot; will return\n                              predefined frequency ranges.</p>\n",
                    "type": "Number|String"
                },
                {
                    "name": "frequency2",
                    "description": "<p>If a second frequency is given,\n                              will return average amount of\n                              energy that exists between the\n                              two frequencies.</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "return": {
                "description": "Energy   Energy (volume/amplitude) from\n                            0 and 255.",
                "type": "Number"
            },
            "class": "p5.FFT",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 2803,
            "description": "<p>Returns the\n<a href=\"http://en.wikipedia.org/wiki/Spectral_centroid\" target=\"_blank\">\nspectral centroid</a> of the input signal.\n<em>NOTE: analyze() must be called prior to getCentroid(). Analyze()\ntells the FFT to analyze frequency data, and getCentroid() uses\nthe results determine the spectral centroid.</em></p></p>\n",
            "itemtype": "method",
            "name": "getCentroid",
            "return": {
                "description": "Spectral Centroid Frequency   Frequency of the spectral centroid in Hz.",
                "type": "Number"
            },
            "example": [
                "\n<div><code>\n\n\nfunction setup(){\ncnv = createCanvas(800,400);\nsound = new p5.AudioIn();\nsound.start();\nfft = new p5.FFT();\nsound.connect(fft);\n}\n\n\nfunction draw(){\n\nvar centroidplot = 0.0;\nvar spectralCentroid = 0;\n\n\nbackground(0);\nstroke(0,255,0);\nvar spectrum = fft.analyze();\nfill(0,255,0); // spectrum is green\n\n//draw the spectrum\n\nfor (var i = 0; i< spectrum.length; i++){\n  var x = map(log(i), 0, log(spectrum.length), 0, width);\n  var h = map(spectrum[i], 0, 255, 0, height);\n  var rectangle_width = (log(i+1)-log(i))*(width/log(spectrum.length));\n  rect(x, height, rectangle_width, -h )\n}\n\nvar nyquist = 22050;\n\n// get the centroid\nspectralCentroid = fft.getCentroid();\n\n// the mean_freq_index calculation is for the display.\nvar mean_freq_index = spectralCentroid/(nyquist/spectrum.length);\n\ncentroidplot = map(log(mean_freq_index), 0, log(spectrum.length), 0, width);\n\n\nstroke(255,0,0); // the line showing where the centroid is will be red\n\nrect(centroidplot, 0, width / spectrum.length, height)\nnoStroke();\nfill(255,255,255);  // text is white\ntextSize(40);\ntext(\"centroid: \"+round(spectralCentroid)+\" Hz\", 10, 40);\n}\n </code></div>"
            ],
            "class": "p5.FFT",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 2884,
            "description": "<p>Smooth FFT analysis by averaging with the last analysis frame.</p>\n",
            "itemtype": "method",
            "name": "smooth",
            "params": [
                {
                    "name": "smoothing",
                    "description": "<p>0.0 &lt; smoothing &lt; 1.0.\n                             Defaults to 0.8.</p>\n",
                    "type": "Number"
                }
            ],
            "class": "p5.FFT",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 2904,
            "description": "<p>Returns an array of average amplitude values for a given number\nof frequency bands split equally. N defaults to 16.\n<em>NOTE: analyze() must be called prior to linAverages(). Analyze()\ntells the FFT to analyze frequency data, and linAverages() uses\nthe results to group them into a smaller set of averages.</em></p></p>\n",
            "itemtype": "method",
            "name": "linAverages",
            "params": [
                {
                    "name": "N",
                    "description": "<p>Number of returned frequency groups</p>\n",
                    "type": "Number"
                }
            ],
            "return": {
                "description": "linearAverages   Array of average amplitude values for each group",
                "type": "Array"
            },
            "class": "p5.FFT",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 2934,
            "description": "<p>Returns an array of average amplitude values of the spectrum, for a given\nset of <a href=\"https://en.wikipedia.org/wiki/Octave_band\" target=\"_blank\">\nOctave Bands</a>\n<em>NOTE: analyze() must be called prior to logAverages(). Analyze()\ntells the FFT to analyze frequency data, and logAverages() uses\nthe results to group them into a smaller set of averages.</em></p></p>\n",
            "itemtype": "method",
            "name": "logAverages",
            "params": [
                {
                    "name": "octaveBands",
                    "description": "<p>Array of Octave Bands objects for grouping</p>\n",
                    "type": "Array"
                }
            ],
            "return": {
                "description": "logAverages    Array of average amplitude values for each group",
                "type": "Array"
            },
            "class": "p5.FFT",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 2964,
            "description": "<p>Calculates and Returns the 1/N\n<a href=\"https://en.wikipedia.org/wiki/Octave_band\" target=\"_blank\">Octave Bands</a>\nN defaults to 3 and minimum central frequency to 15.625Hz.\n(1/3 Octave Bands ~= 31 Frequency Bands)\nSetting fCtr0 to a central value of a higher octave will ignore the lower bands\nand produce less frequency groups.</p>\n",
            "itemtype": "method",
            "name": "getOctaveBands",
            "params": [
                {
                    "name": "N",
                    "description": "<p>Specifies the 1/N type of generated octave bands</p>\n",
                    "type": "Number"
                },
                {
                    "name": "fCtr0",
                    "description": "<p>Minimum central frequency for the lowest band</p>\n",
                    "type": "Number"
                }
            ],
            "return": {
                "description": "octaveBands   Array of octave band objects with their bounds",
                "type": "Array"
            },
            "class": "p5.FFT",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 3022,
            "class": "p5.FFT",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 3399,
            "class": "p5.FFT",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 3420,
            "class": "p5.FFT",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 3479,
            "class": "p5.FFT",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 3797,
            "class": "p5.FFT",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 3969,
            "class": "p5.FFT",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 4127,
            "class": "p5.FFT",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 4168,
            "class": "p5.FFT",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 4238,
            "class": "p5.FFT",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 4426,
            "class": "p5.FFT",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 4483,
            "class": "p5.FFT",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 4651,
            "class": "p5.FFT",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 4699,
            "class": "p5.FFT",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 4730,
            "class": "p5.FFT",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 4751,
            "class": "p5.FFT",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 4771,
            "class": "p5.FFT",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 4873,
            "description": "<p>Fade to value, for smooth transitions</p>\n",
            "itemtype": "method",
            "name": "fade",
            "params": [
                {
                    "name": "value",
                    "description": "<p>Value to set this signal</p>\n",
                    "type": "Number"
                },
                {
                    "name": "secondsFromNow",
                    "description": "<p>Length of fade, in seconds from now</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "class": "p5.Signal",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 4884,
            "description": "<p>Connect a p5.sound object or Web Audio node to this\np5.Signal so that its amplitude values can be scaled.</p>\n",
            "itemtype": "method",
            "name": "setInput",
            "params": [
                {
                    "name": "input",
                    "description": "",
                    "type": "Object"
                }
            ],
            "class": "p5.Signal",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 4898,
            "description": "<p>Add a constant value to this audio signal,\nand return the resulting audio signal. Does\nnot change the value of the original signal,\ninstead it returns a new p5.SignalAdd.</p>\n",
            "itemtype": "method",
            "name": "add",
            "params": [
                {
                    "name": "number",
                    "description": "",
                    "type": "Number"
                }
            ],
            "return": {
                "description": "object",
                "type": "p5.Signal"
            },
            "class": "p5.Signal",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 4917,
            "description": "<p>Multiply this signal by a constant value,\nand return the resulting audio signal. Does\nnot change the value of the original signal,\ninstead it returns a new p5.SignalMult.</p>\n",
            "itemtype": "method",
            "name": "mult",
            "params": [
                {
                    "name": "number",
                    "description": "<p>to multiply</p>\n",
                    "type": "Number"
                }
            ],
            "return": {
                "description": "object",
                "type": "p5.Signal"
            },
            "class": "p5.Signal",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 4936,
            "description": "<p>Scale this signal value to a given range,\nand return the result as an audio signal. Does\nnot change the value of the original signal,\ninstead it returns a new p5.SignalScale.</p>\n",
            "itemtype": "method",
            "name": "scale",
            "params": [
                {
                    "name": "number",
                    "description": "<p>to multiply</p>\n",
                    "type": "Number"
                },
                {
                    "name": "inMin",
                    "description": "<p>input range minumum</p>\n",
                    "type": "Number"
                },
                {
                    "name": "inMax",
                    "description": "<p>input range maximum</p>\n",
                    "type": "Number"
                },
                {
                    "name": "outMin",
                    "description": "<p>input range minumum</p>\n",
                    "type": "Number"
                },
                {
                    "name": "outMax",
                    "description": "<p>input range maximum</p>\n",
                    "type": "Number"
                }
            ],
            "return": {
                "description": "object",
                "type": "p5.Signal"
            },
            "class": "p5.Signal",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 5070,
            "description": "<p>Start an oscillator. Accepts an optional parameter to\ndetermine how long (in seconds from now) until the\noscillator starts.</p>\n",
            "itemtype": "method",
            "name": "start",
            "params": [
                {
                    "name": "time",
                    "description": "<p>startTime in seconds from now.</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "frequency",
                    "description": "<p>frequency in Hz.</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "class": "p5.Oscillator",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 5110,
            "description": "<p>Stop an oscillator. Accepts an optional parameter\nto determine how long (in seconds from now) until the\noscillator stops.</p>\n",
            "itemtype": "method",
            "name": "stop",
            "params": [
                {
                    "name": "secondsFromNow",
                    "description": "<p>Time, in seconds from now.</p>\n",
                    "type": "Number"
                }
            ],
            "class": "p5.Oscillator",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 5126,
            "description": "<p>Set the amplitude between 0 and 1.0. Or, pass in an object\nsuch as an oscillator to modulate amplitude with an audio signal.</p>\n",
            "itemtype": "method",
            "name": "amp",
            "params": [
                {
                    "name": "vol",
                    "description": "<p>between 0 and 1.0\n                            or a modulating signal/oscillator</p>\n",
                    "type": "Number|Object"
                },
                {
                    "name": "rampTime",
                    "description": "<p>create a fade that lasts rampTime</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "timeFromNow",
                    "description": "<p>schedule this event to happen\n                              seconds from now</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "return": {
                "description": "gain  If no value is provided,\n                            returns the Web Audio API\n                            AudioParam that controls\n                            this oscillator's\n                            gain/amplitude/volume)",
                "type": "AudioParam"
            },
            "class": "p5.Oscillator",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 5161,
            "description": "<p>Set frequency of an oscillator to a value. Or, pass in an object\nsuch as an oscillator to modulate the frequency with an audio signal.</p>\n",
            "itemtype": "method",
            "name": "freq",
            "params": [
                {
                    "name": "Frequency",
                    "description": "<p>Frequency in Hz\n                                      or modulating signal/oscillator</p>\n",
                    "type": "Number|Object"
                },
                {
                    "name": "rampTime",
                    "description": "<p>Ramp time (in seconds)</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "timeFromNow",
                    "description": "<p>Schedule this event to happen\n                                 at x seconds from now</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "return": {
                "description": "Frequency If no value is provided,\n                                returns the Web Audio API\n                                AudioParam that controls\n                                this oscillator's frequency",
                "type": "AudioParam"
            },
            "example": [
                "\n<div><code>\nvar osc = new p5.Oscillator(300);\nosc.start();\nosc.freq(40, 10);\n</code></div>"
            ],
            "class": "p5.Oscillator",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 5220,
            "description": "<p>Set type to &#39;sine&#39;, &#39;triangle&#39;, &#39;sawtooth&#39; or &#39;square&#39;.</p>\n",
            "itemtype": "method",
            "name": "setType",
            "params": [
                {
                    "name": "type",
                    "description": "<p>&#39;sine&#39;, &#39;triangle&#39;, &#39;sawtooth&#39; or &#39;square&#39;.</p>\n",
                    "type": "String"
                }
            ],
            "class": "p5.Oscillator",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 5232,
            "description": "<p>Connect to a p5.sound / Web Audio object.</p>\n",
            "itemtype": "method",
            "name": "connect",
            "params": [
                {
                    "name": "unit",
                    "description": "<p>A p5.sound or Web Audio object</p>\n",
                    "type": "Object"
                }
            ],
            "class": "p5.Oscillator",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 5249,
            "description": "<p>Disconnect all outputs</p>\n",
            "itemtype": "method",
            "name": "disconnect",
            "class": "p5.Oscillator",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 5260,
            "description": "<p>Pan between Left (-1) and Right (1)</p>\n",
            "itemtype": "method",
            "name": "pan",
            "params": [
                {
                    "name": "panning",
                    "description": "<p>Number between -1 and 1</p>\n",
                    "type": "Number"
                },
                {
                    "name": "timeFromNow",
                    "description": "<p>schedule this event to happen\n                              seconds from now</p>\n",
                    "type": "Number"
                }
            ],
            "class": "p5.Oscillator",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 5292,
            "description": "<p>Set the phase of an oscillator between 0.0 and 1.0.\nIn this implementation, phase is a delay time\nbased on the oscillator&#39;s current frequency.</p>\n",
            "itemtype": "method",
            "name": "phase",
            "params": [
                {
                    "name": "phase",
                    "description": "<p>float between 0.0 and 1.0</p>\n",
                    "type": "Number"
                }
            ],
            "class": "p5.Oscillator",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 5346,
            "description": "<p>Add a value to the p5.Oscillator&#39;s output amplitude,\nand return the oscillator. Calling this method again\nwill override the initial add() with a new value.</p>\n",
            "itemtype": "method",
            "name": "add",
            "params": [
                {
                    "name": "number",
                    "description": "<p>Constant number to add</p>\n",
                    "type": "Number"
                }
            ],
            "return": {
                "description": "Oscillator Returns this oscillator\n                                   with scaled output",
                "type": "p5.Oscillator"
            },
            "class": "p5.Oscillator",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 5363,
            "description": "<p>Multiply the p5.Oscillator&#39;s output amplitude\nby a fixed value (i.e. turn it up!). Calling this method\nagain will override the initial mult() with a new value.</p>\n",
            "itemtype": "method",
            "name": "mult",
            "params": [
                {
                    "name": "number",
                    "description": "<p>Constant number to multiply</p>\n",
                    "type": "Number"
                }
            ],
            "return": {
                "description": "Oscillator Returns this oscillator\n                                   with multiplied output",
                "type": "p5.Oscillator"
            },
            "class": "p5.Oscillator",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 5379,
            "description": "<p>Scale this oscillator&#39;s amplitude values to a given\nrange, and return the oscillator. Calling this method\nagain will override the initial scale() with new values.</p>\n",
            "itemtype": "method",
            "name": "scale",
            "params": [
                {
                    "name": "inMin",
                    "description": "<p>input range minumum</p>\n",
                    "type": "Number"
                },
                {
                    "name": "inMax",
                    "description": "<p>input range maximum</p>\n",
                    "type": "Number"
                },
                {
                    "name": "outMin",
                    "description": "<p>input range minumum</p>\n",
                    "type": "Number"
                },
                {
                    "name": "outMax",
                    "description": "<p>input range maximum</p>\n",
                    "type": "Number"
                }
            ],
            "return": {
                "description": "Oscillator Returns this oscillator\n                                   with scaled output",
                "type": "p5.Oscillator"
            },
            "class": "p5.Oscillator",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 5478,
            "class": "p5.SqrOsc",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 5681,
            "class": "p5.SqrOsc",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 5970,
            "description": "<p>Time until envelope reaches attackLevel</p>\n",
            "itemtype": "property",
            "name": "attackTime",
            "class": "p5.Env",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 5975,
            "description": "<p>Level once attack is complete.</p>\n",
            "itemtype": "property",
            "name": "attackLevel",
            "class": "p5.Env",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 5980,
            "description": "<p>Time until envelope reaches decayLevel.</p>\n",
            "itemtype": "property",
            "name": "decayTime",
            "class": "p5.Env",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 5985,
            "description": "<p>Level after decay. The envelope will sustain here until it is released.</p>\n",
            "itemtype": "property",
            "name": "decayLevel",
            "class": "p5.Env",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 5990,
            "description": "<p>Duration of the release portion of the envelope.</p>\n",
            "itemtype": "property",
            "name": "releaseTime",
            "class": "p5.Env",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 5995,
            "description": "<p>Level at the end of the release.</p>\n",
            "itemtype": "property",
            "name": "releaseLevel",
            "class": "p5.Env",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 6031,
            "description": "<p>Reset the envelope with a series of time/value pairs.</p>\n",
            "itemtype": "method",
            "name": "set",
            "params": [
                {
                    "name": "attackTime",
                    "description": "<p>Time (in seconds) before level\n                               reaches attackLevel</p>\n",
                    "type": "Number"
                },
                {
                    "name": "attackLevel",
                    "description": "<p>Typically an amplitude between\n                               0.0 and 1.0</p>\n",
                    "type": "Number"
                },
                {
                    "name": "decayTime",
                    "description": "<p>Time</p>\n",
                    "type": "Number"
                },
                {
                    "name": "decayLevel",
                    "description": "<p>Amplitude (In a standard ADSR envelope,\n                               decayLevel = sustainLevel)</p>\n",
                    "type": "Number"
                },
                {
                    "name": "releaseTime",
                    "description": "<p>Release Time (in seconds)</p>\n",
                    "type": "Number"
                },
                {
                    "name": "releaseLevel",
                    "description": "<p>Amplitude</p>\n",
                    "type": "Number"
                }
            ],
            "example": [
                "\n<div><code>\nvar t1 = 0.1; // attack time in seconds\nvar l1 = 0.7; // attack level 0.0 to 1.0\nvar t2 = 0.3; // decay time in seconds\nvar l2 = 0.1; // decay level  0.0 to 1.0\nvar t3 = 0.2; // sustain time in seconds\nvar l3 = dL; // sustain level  0.0 to 1.0\n// release level defaults to zero\n\nvar env;\nvar triOsc;\n\nfunction setup() {\n  background(0);\n  noStroke();\n  fill(255);\n  textAlign(CENTER);\n  text('click to play', width/2, height/2);\n\n  env = new p5.Env(t1, l1, t2, l2, t3, l3);\n  triOsc = new p5.Oscillator('triangle');\n  triOsc.amp(env); // give the env control of the triOsc's amp\n  triOsc.start();\n}\n\n// mouseClick triggers envelope if over canvas\nfunction mouseClicked() {\n  // is mouse over canvas?\n  if (mouseX > 0 && mouseX < width && mouseY > 0 && mouseY < height) {\n    env.play(triOsc);\n  }\n}\n</code></div>\n"
            ],
            "class": "p5.Env",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 6090,
            "description": "<p>Set values like a traditional\n<a href=\"https://en.wikipedia.org/wiki/Synthesizer#/media/File:ADSR_parameter.svg\">\nADSR envelope\n</a>.</p>\n",
            "itemtype": "method",
            "name": "setADSR",
            "params": [
                {
                    "name": "attackTime",
                    "description": "<p>Time (in seconds before envelope\n                              reaches Attack Level</p>\n",
                    "type": "Number"
                },
                {
                    "name": "decayTime",
                    "description": "<p>Time (in seconds) before envelope\n                              reaches Decay/Sustain Level</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "susRatio",
                    "description": "<p>Ratio between attackLevel and releaseLevel, on a scale from 0 to 1,\n                              where 1.0 = attackLevel, 0.0 = releaseLevel.\n                              The susRatio determines the decayLevel and the level at which the\n                              sustain portion of the envelope will sustain.\n                              For example, if attackLevel is 0.4, releaseLevel is 0,\n                              and susAmt is 0.5, the decayLevel would be 0.2. If attackLevel is\n                              increased to 1.0 (using <code>setRange</code>),\n                              then decayLevel would increase proportionally, to become 0.5.</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "releaseTime",
                    "description": "<p>Time in seconds from now (defaults to 0)</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "example": [
                "\n<div><code>\nvar attackLevel = 1.0;\nvar releaseLevel = 0;\n\nvar attackTime = 0.001\nvar decayTime = 0.2;\nvar susPercent = 0.2;\nvar releaseTime = 0.5;\n\nvar env, triOsc;\n\nfunction setup() {\n  var cnv = createCanvas(100, 100);\n\n  textAlign(CENTER);\n  text('click to play', width/2, height/2);\n\n  env = new p5.Env();\n  env.setADSR(attackTime, decayTime, susPercent, releaseTime);\n  env.setRange(attackLevel, releaseLevel);\n\n  triOsc = new p5.Oscillator('triangle');\n  triOsc.amp(env);\n  triOsc.start();\n  triOsc.freq(220);\n\n  cnv.mousePressed(playEnv);\n}\n\nfunction playEnv(){\n  env.play();\n}\n</code></div>"
            ],
            "class": "p5.Env",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 6155,
            "description": "<p>Set max (attackLevel) and min (releaseLevel) of envelope.</p>\n",
            "itemtype": "method",
            "name": "setRange",
            "params": [
                {
                    "name": "aLevel",
                    "description": "<p>attack level (defaults to 1)</p>\n",
                    "type": "Number"
                },
                {
                    "name": "rLevel",
                    "description": "<p>release level (defaults to 0)</p>\n",
                    "type": "Number"
                }
            ],
            "example": [
                "\n<div><code>\nvar attackLevel = 1.0;\nvar releaseLevel = 0;\n\nvar attackTime = 0.001\nvar decayTime = 0.2;\nvar susPercent = 0.2;\nvar releaseTime = 0.5;\n\nvar env, triOsc;\n\nfunction setup() {\n  var cnv = createCanvas(100, 100);\n\n  textAlign(CENTER);\n  text('click to play', width/2, height/2);\n\n  env = new p5.Env();\n  env.setADSR(attackTime, decayTime, susPercent, releaseTime);\n  env.setRange(attackLevel, releaseLevel);\n\n  triOsc = new p5.Oscillator('triangle');\n  triOsc.amp(env);\n  triOsc.start();\n  triOsc.freq(220);\n\n  cnv.mousePressed(playEnv);\n}\n\nfunction playEnv(){\n  env.play();\n}\n</code></div>"
            ],
            "class": "p5.Env",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 6234,
            "description": "<p>Assign a parameter to be controlled by this envelope.\nIf a p5.Sound object is given, then the p5.Env will control its\noutput gain. If multiple inputs are provided, the env will\ncontrol all of them.</p>\n",
            "itemtype": "method",
            "name": "setInput",
            "params": [
                {
                    "name": "inputs",
                    "description": "<p>A p5.sound object or\n                              Web Audio Param.</p>\n",
                    "type": "Object",
                    "optional": true,
                    "multiple": true
                }
            ],
            "class": "p5.Env",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 6249,
            "description": "<p>Set whether the envelope ramp is linear (default) or exponential.\nExponential ramps can be useful because we perceive amplitude\nand frequency logarithmically.</p>\n",
            "itemtype": "method",
            "name": "setExp",
            "params": [
                {
                    "name": "isExp",
                    "description": "<p>true is exponential, false is linear</p>\n",
                    "type": "Boolean"
                }
            ],
            "class": "p5.Env",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 6267,
            "description": "<p>Play tells the envelope to start acting on a given input.\nIf the input is a p5.sound object (i.e. AudioIn, Oscillator,\nSoundFile), then Env will control its output volume.\nEnvelopes can also be used to control any <a href=\"\nhttp://docs.webplatform.org/wiki/apis/webaudio/AudioParam\">\nWeb Audio Audio Param.</a></p>\n",
            "itemtype": "method",
            "name": "play",
            "params": [
                {
                    "name": "unit",
                    "description": "<p>A p5.sound object or\n                              Web Audio Param.</p>\n",
                    "type": "Object"
                },
                {
                    "name": "startTime",
                    "description": "<p>time from now (in seconds) at which to play</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "sustainTime",
                    "description": "<p>time to sustain before releasing the envelope</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "example": [
                "\n<div><code>\nvar attackLevel = 1.0;\nvar releaseLevel = 0;\n\nvar attackTime = 0.001\nvar decayTime = 0.2;\nvar susPercent = 0.2;\nvar releaseTime = 0.5;\n\nvar env, triOsc;\n\nfunction setup() {\n  var cnv = createCanvas(100, 100);\n\n  textAlign(CENTER);\n  text('click to play', width/2, height/2);\n\n  env = new p5.Env();\n  env.setADSR(attackTime, decayTime, susPercent, releaseTime);\n  env.setRange(attackLevel, releaseLevel);\n\n  triOsc = new p5.Oscillator('triangle');\n  triOsc.amp(env);\n  triOsc.start();\n  triOsc.freq(220);\n\n  cnv.mousePressed(playEnv);\n}\n\nfunction playEnv(){\n  // trigger env on triOsc, 0 seconds from now\n  // After decay, sustain for 0.2 seconds before release\n  env.play(triOsc, 0, 0.2);\n}\n</code></div>"
            ],
            "class": "p5.Env",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 6328,
            "description": "<p>Trigger the Attack, and Decay portion of the Envelope.\nSimilar to holding down a key on a piano, but it will\nhold the sustain level until you let go. Input can be\nany p5.sound object, or a <a href=\"\nhttp://docs.webplatform.org/wiki/apis/webaudio/AudioParam\">\nWeb Audio Param</a>.</p>\n",
            "itemtype": "method",
            "name": "triggerAttack",
            "params": [
                {
                    "name": "unit",
                    "description": "<p>p5.sound Object or Web Audio Param</p>\n",
                    "type": "Object"
                },
                {
                    "name": "secondsFromNow",
                    "description": "<p>time from now (in seconds)</p>\n",
                    "type": "Number"
                }
            ],
            "example": [
                "\n<div><code>\n\nvar attackLevel = 1.0;\nvar releaseLevel = 0;\n\nvar attackTime = 0.001\nvar decayTime = 0.3;\nvar susPercent = 0.4;\nvar releaseTime = 0.5;\n\nvar env, triOsc;\n\nfunction setup() {\n  var cnv = createCanvas(100, 100);\n  background(200);\n  textAlign(CENTER);\n  text('click to play', width/2, height/2);\n\n  env = new p5.Env();\n  env.setADSR(attackTime, decayTime, susPercent, releaseTime);\n  env.setRange(attackLevel, releaseLevel);\n\n  triOsc = new p5.Oscillator('triangle');\n  triOsc.amp(env);\n  triOsc.start();\n  triOsc.freq(220);\n\n  cnv.mousePressed(envAttack);\n}\n\nfunction envAttack(){\n  console.log('trigger attack');\n  env.triggerAttack();\n\n  background(0,255,0);\n  text('attack!', width/2, height/2);\n}\n\nfunction mouseReleased() {\n  env.triggerRelease();\n\n  background(200);\n  text('click to play', width/2, height/2);\n}\n</code></div>"
            ],
            "class": "p5.Env",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 6435,
            "description": "<p>Trigger the Release of the Envelope. This is similar to releasing\nthe key on a piano and letting the sound fade according to the\nrelease level and release time.</p>\n",
            "itemtype": "method",
            "name": "triggerRelease",
            "params": [
                {
                    "name": "unit",
                    "description": "<p>p5.sound Object or Web Audio Param</p>\n",
                    "type": "Object"
                },
                {
                    "name": "secondsFromNow",
                    "description": "<p>time to trigger the release</p>\n",
                    "type": "Number"
                }
            ],
            "example": [
                "\n<div><code>\n\nvar attackLevel = 1.0;\nvar releaseLevel = 0;\n\nvar attackTime = 0.001\nvar decayTime = 0.3;\nvar susPercent = 0.4;\nvar releaseTime = 0.5;\n\nvar env, triOsc;\n\nfunction setup() {\n  var cnv = createCanvas(100, 100);\n  background(200);\n  textAlign(CENTER);\n  text('click to play', width/2, height/2);\n\n  env = new p5.Env();\n  env.setADSR(attackTime, decayTime, susPercent, releaseTime);\n  env.setRange(attackLevel, releaseLevel);\n\n  triOsc = new p5.Oscillator('triangle');\n  triOsc.amp(env);\n  triOsc.start();\n  triOsc.freq(220);\n\n  cnv.mousePressed(envAttack);\n}\n\nfunction envAttack(){\n  console.log('trigger attack');\n  env.triggerAttack();\n\n  background(0,255,0);\n  text('attack!', width/2, height/2);\n}\n\nfunction mouseReleased() {\n  env.triggerRelease();\n\n  background(200);\n  text('click to play', width/2, height/2);\n}\n</code></div>"
            ],
            "class": "p5.Env",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 6532,
            "description": "<p>Exponentially ramp to a value using the first two\nvalues from <code><a href=\"#/p5.Env/setADSR\">setADSR(attackTime, decayTime)</a></code>\nas <a href=\"https://en.wikipedia.org/wiki/RC_time_constant\">\ntime constants</a> for simple exponential ramps.\nIf the value is higher than current value, it uses attackTime,\nwhile a decrease uses decayTime.</p>\n",
            "itemtype": "method",
            "name": "ramp",
            "params": [
                {
                    "name": "unit",
                    "description": "<p>p5.sound Object or Web Audio Param</p>\n",
                    "type": "Object"
                },
                {
                    "name": "secondsFromNow",
                    "description": "<p>When to trigger the ramp</p>\n",
                    "type": "Number"
                },
                {
                    "name": "v",
                    "description": "<p>Target value</p>\n",
                    "type": "Number"
                },
                {
                    "name": "v2",
                    "description": "<p>Second target value (optional)</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "example": [
                "\n<div><code>\nvar env, osc, amp, cnv;\n\nvar attackTime = 0.001;\nvar decayTime = 0.2;\nvar attackLevel = 1;\nvar decayLevel = 0;\n\nfunction setup() {\n  cnv = createCanvas(100, 100);\n  fill(0,255,0);\n  noStroke();\n\n  env = new p5.Env();\n  env.setADSR(attackTime, decayTime);\n\n  osc = new p5.Oscillator();\n  osc.amp(env);\n  osc.start();\n\n  amp = new p5.Amplitude();\n\n  cnv.mousePressed(triggerRamp);\n}\n\nfunction triggerRamp() {\n  env.ramp(osc, 0, attackLevel, decayLevel);\n}\n\nfunction draw() {\n  background(20,20,20);\n  text('click me', 10, 20);\n  var h = map(amp.getLevel(), 0, 0.4, 0, height);;\n\n  rect(0, height, width, -h);\n}\n</code></div>"
            ],
            "class": "p5.Env",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 6637,
            "description": "<p>Add a value to the p5.Oscillator&#39;s output amplitude,\nand return the oscillator. Calling this method\nagain will override the initial add() with new values.</p>\n",
            "itemtype": "method",
            "name": "add",
            "params": [
                {
                    "name": "number",
                    "description": "<p>Constant number to add</p>\n",
                    "type": "Number"
                }
            ],
            "return": {
                "description": "Envelope Returns this envelope\n                                   with scaled output",
                "type": "p5.Env"
            },
            "class": "p5.Env",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 6653,
            "description": "<p>Multiply the p5.Env&#39;s output amplitude\nby a fixed value. Calling this method\nagain will override the initial mult() with new values.</p>\n",
            "itemtype": "method",
            "name": "mult",
            "params": [
                {
                    "name": "number",
                    "description": "<p>Constant number to multiply</p>\n",
                    "type": "Number"
                }
            ],
            "return": {
                "description": "Envelope Returns this envelope\n                                   with scaled output",
                "type": "p5.Env"
            },
            "class": "p5.Env",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 6669,
            "description": "<p>Scale this envelope&#39;s amplitude values to a given\nrange, and return the envelope. Calling this method\nagain will override the initial scale() with new values.</p>\n",
            "itemtype": "method",
            "name": "scale",
            "params": [
                {
                    "name": "inMin",
                    "description": "<p>input range minumum</p>\n",
                    "type": "Number"
                },
                {
                    "name": "inMax",
                    "description": "<p>input range maximum</p>\n",
                    "type": "Number"
                },
                {
                    "name": "outMin",
                    "description": "<p>input range minumum</p>\n",
                    "type": "Number"
                },
                {
                    "name": "outMax",
                    "description": "<p>input range maximum</p>\n",
                    "type": "Number"
                }
            ],
            "return": {
                "description": "Envelope Returns this envelope\n                                   with scaled output",
                "type": "p5.Env"
            },
            "class": "p5.Env",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 6773,
            "description": "<p>Set the width of a Pulse object (an oscillator that implements\nPulse Width Modulation).</p>\n",
            "itemtype": "method",
            "name": "width",
            "params": [
                {
                    "name": "width",
                    "description": "<p>Width between the pulses (0 to 1.0,\n                       defaults to 0)</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "class": "p5.Pulse",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 6958,
            "description": "<p>Set type of noise to &#39;white&#39;, &#39;pink&#39; or &#39;brown&#39;.\nWhite is the default.</p>\n",
            "itemtype": "method",
            "name": "setType",
            "params": [
                {
                    "name": "type",
                    "description": "<p>&#39;white&#39;, &#39;pink&#39; or &#39;brown&#39;</p>\n",
                    "type": "String",
                    "optional": true
                }
            ],
            "class": "p5.Noise",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 6988,
            "description": "<p>Start the noise</p>\n",
            "itemtype": "method",
            "name": "start",
            "class": "p5.Noise",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 7005,
            "description": "<p>Stop the noise.</p>\n",
            "itemtype": "method",
            "name": "stop",
            "class": "p5.Noise",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 7017,
            "description": "<p>Pan the noise.</p>\n",
            "itemtype": "method",
            "name": "pan",
            "params": [
                {
                    "name": "panning",
                    "description": "<p>Number between -1 (left)\n                         and 1 (right)</p>\n",
                    "type": "Number"
                },
                {
                    "name": "timeFromNow",
                    "description": "<p>schedule this event to happen\n                              seconds from now</p>\n",
                    "type": "Number"
                }
            ],
            "class": "p5.Noise",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 7026,
            "description": "<p>Set the amplitude of the noise between 0 and 1.0. Or,\nmodulate amplitude with an audio signal such as an oscillator.</p>\n",
            "itemtype": "method",
            "name": "amp",
            "params": [
                {
                    "name": "volume",
                    "description": "<p>amplitude between 0 and 1.0\n                                   or modulating signal/oscillator</p>\n",
                    "type": "Number|Object"
                },
                {
                    "name": "rampTime",
                    "description": "<p>create a fade that lasts rampTime</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "timeFromNow",
                    "description": "<p>schedule this event to happen\n                              seconds from now</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "class": "p5.Noise",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 7037,
            "description": "<p>Send output to a p5.sound or web audio object</p>\n",
            "itemtype": "method",
            "name": "connect",
            "params": [
                {
                    "name": "unit",
                    "description": "",
                    "type": "Object"
                }
            ],
            "class": "p5.Noise",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 7043,
            "description": "<p>Disconnect all output.</p>\n",
            "itemtype": "method",
            "name": "disconnect",
            "class": "p5.Noise",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 7117,
            "description": "<p>Client must allow browser to access their microphone / audioin source.\nDefault: false. Will become true when the client enables acces.</p>\n",
            "itemtype": "property",
            "name": "enabled",
            "type": "Boolean",
            "class": "p5.AudioIn",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 7133,
            "description": "<p>Start processing audio input. This enables the use of other\nAudioIn methods like getLevel(). Note that by default, AudioIn\nis not connected to p5.sound&#39;s output. So you won&#39;t hear\nanything unless you use the connect() method.<br/></p>\n<p>Certain browsers limit access to the user&#39;s microphone. For example,\nChrome only allows access from localhost and over https. For this reason,\nyou may want to include an errorCallback—a function that is called in case\nthe browser won&#39;t provide mic access.</p>\n",
            "itemtype": "method",
            "name": "start",
            "params": [
                {
                    "name": "successCallback",
                    "description": "<p>Name of a function to call on\n                                  success.</p>\n",
                    "type": "Function",
                    "optional": true
                },
                {
                    "name": "errorCallback",
                    "description": "<p>Name of a function to call if\n                                  there was an error. For example,\n                                  some browsers do not support\n                                  getUserMedia.</p>\n",
                    "type": "Function",
                    "optional": true
                }
            ],
            "class": "p5.AudioIn",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 7186,
            "description": "<p>Turn the AudioIn off. If the AudioIn is stopped, it cannot getLevel().\nIf re-starting, the user may be prompted for permission access.</p>\n",
            "itemtype": "method",
            "name": "stop",
            "class": "p5.AudioIn",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 7202,
            "description": "<p>Connect to an audio unit. If no parameter is provided, will\nconnect to the master output (i.e. your speakers).<br/></p>\n",
            "itemtype": "method",
            "name": "connect",
            "params": [
                {
                    "name": "unit",
                    "description": "<p>An object that accepts audio input,\n                        such as an FFT</p>\n",
                    "type": "Object",
                    "optional": true
                }
            ],
            "class": "p5.AudioIn",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 7223,
            "description": "<p>Disconnect the AudioIn from all audio units. For example, if\nconnect() had been called, disconnect() will stop sending\nsignal to your speakers.<br/></p>\n",
            "itemtype": "method",
            "name": "disconnect",
            "class": "p5.AudioIn",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 7235,
            "description": "<p>Read the Amplitude (volume level) of an AudioIn. The AudioIn\nclass contains its own instance of the Amplitude class to help\nmake it easy to get a microphone&#39;s volume level. Accepts an\noptional smoothing value (0.0 &lt; 1.0). <em>NOTE: AudioIn must\n.start() before using .getLevel().</em><br/></p>\n",
            "itemtype": "method",
            "name": "getLevel",
            "params": [
                {
                    "name": "smoothing",
                    "description": "<p>Smoothing is 0.0 by default.\n                             Smooths values based on previous values.</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "return": {
                "description": "Volume level (between 0.0 and 1.0)",
                "type": "Number"
            },
            "class": "p5.AudioIn",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 7253,
            "description": "<p>Set amplitude (volume) of a mic input between 0 and 1.0. <br/></p>\n",
            "itemtype": "method",
            "name": "amp",
            "params": [
                {
                    "name": "vol",
                    "description": "<p>between 0 and 1.0</p>\n",
                    "type": "Number"
                },
                {
                    "name": "time",
                    "description": "<p>ramp time (optional)</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "class": "p5.AudioIn",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 7272,
            "description": "<p>Returns a list of available input sources. This is a wrapper\nfor &lt;a title=&quot;MediaDevices.enumerateDevices() - Web APIs | MDN&quot; target=&quot;_blank&quot; href=\n &quot;<a href=\"https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/enumerateDevices\">https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/enumerateDevices</a>&quot;</p>\n<blockquote>\n<p>and it returns a Promise.</p>\n</blockquote>\n",
            "itemtype": "method",
            "name": "getSources",
            "params": [
                {
                    "name": "successCallback",
                    "description": "<p>This callback function handles the sources when they\n                                     have been enumerated. The callback function\n                                     receives the deviceList array as its only argument</p>\n",
                    "type": "Function",
                    "optional": true
                },
                {
                    "name": "errorCallback",
                    "description": "<p>This optional callback receives the error\n                                   message as its argument.</p>\n",
                    "type": "Function",
                    "optional": true
                }
            ],
            "return": {
                "description": "Returns a Promise that can be used in place of the callbacks, similar\n                           to the enumerateDevices() method",
                "type": "Object"
            },
            "example": [
                "\n <div><code>\n var audiograb;\n\n function setup(){\n   //new audioIn\n   audioGrab = new p5.AudioIn();\n\n   audioGrab.getSources(function(deviceList) {\n     //print out the array of available sources\n     console.log(deviceList);\n     //set the source to the first item in the deviceList array\n     audioGrab.setSource(0);\n   });\n }\n </code></div>"
            ],
            "class": "p5.AudioIn",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 7323,
            "description": "<p>Set the input source. Accepts a number representing a\nposition in the array returned by getSources().\nThis is only available in browsers that support\n&lt;a title=&quot;MediaDevices.enumerateDevices() - Web APIs | MDN&quot; target=&quot;_blank&quot; href=\n&quot;<a href=\"https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/enumerateDevices\">https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/enumerateDevices</a>&quot;</p>\n<blockquote>\n<p>navigator.mediaDevices.enumerateDevices()</a>.<br/></p>\n</blockquote>\n",
            "itemtype": "method",
            "name": "setSource",
            "params": [
                {
                    "name": "num",
                    "description": "<p>position of input source in the array</p>\n",
                    "type": "Number"
                }
            ],
            "class": "p5.AudioIn",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 7363,
            "class": "p5.AudioIn",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 7379,
            "class": "p5.AudioIn",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 7403,
            "class": "p5.AudioIn",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 7429,
            "class": "p5.AudioIn",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 7451,
            "class": "p5.AudioIn",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 7473,
            "class": "p5.AudioIn",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 7519,
            "class": "p5.AudioIn",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 7550,
            "class": "p5.AudioIn",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 7568,
            "class": "p5.AudioIn",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 7905,
            "class": "p5.AudioIn",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 7927,
            "class": "p5.AudioIn",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 8003,
            "description": "<p>In classes that extend\np5.Effect, connect effect nodes\nto the wet parameter</p>\n",
            "class": "p5.Effect",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 8016,
            "description": "<p>Set the output volume of the filter.</p>\n",
            "itemtype": "method",
            "name": "amp",
            "params": [
                {
                    "name": "vol",
                    "description": "<p>amplitude between 0 and 1.0</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "rampTime",
                    "description": "<p>create a fade that lasts until rampTime</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "tFromNow",
                    "description": "<p>schedule this event to happen in tFromNow seconds</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "class": "p5.Effect",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 8033,
            "description": "<p>Link effects together in a chain\nExample usage: filter.chain(reverb, delay, panner);\nMay be used with an open-ended number of arguments</p>\n",
            "itemtype": "method",
            "name": "chain",
            "params": [
                {
                    "name": "arguments",
                    "description": "<p>Chain together multiple sound objects</p>\n",
                    "type": "Object",
                    "optional": true
                }
            ],
            "class": "p5.Effect",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 8050,
            "description": "<p>Adjust the dry/wet value.</p>\n",
            "itemtype": "method",
            "name": "drywet",
            "params": [
                {
                    "name": "fade",
                    "description": "<p>The desired drywet value (0 - 1.0)</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "class": "p5.Effect",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 8062,
            "description": "<p>Send output to a p5.js-sound, Web Audio Node, or use signal to\ncontrol an AudioParam</p>\n",
            "itemtype": "method",
            "name": "connect",
            "params": [
                {
                    "name": "unit",
                    "description": "",
                    "type": "Object"
                }
            ],
            "class": "p5.Effect",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 8073,
            "description": "<p>Disconnect all output.</p>\n",
            "itemtype": "method",
            "name": "disconnect",
            "class": "p5.Effect",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 8181,
            "description": "<p>The p5.Filter is built with a\n<a href=\"http://www.w3.org/TR/webaudio/#BiquadFilterNode\">\nWeb Audio BiquadFilter Node</a>.</p>\n",
            "itemtype": "property",
            "name": "biquadFilter",
            "type": "DelayNode",
            "class": "p5.Filter",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 8199,
            "description": "<p>Filter an audio signal according to a set\nof filter parameters.</p>\n",
            "itemtype": "method",
            "name": "process",
            "params": [
                {
                    "name": "Signal",
                    "description": "<p>An object that outputs audio</p>\n",
                    "type": "Object"
                },
                {
                    "name": "freq",
                    "description": "<p>Frequency in Hz, from 10 to 22050</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "res",
                    "description": "<p>Resonance/Width of the filter frequency\n                      from 0.001 to 1000</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "class": "p5.Filter",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 8213,
            "description": "<p>Set the frequency and the resonance of the filter.</p>\n",
            "itemtype": "method",
            "name": "set",
            "params": [
                {
                    "name": "freq",
                    "description": "<p>Frequency in Hz, from 10 to 22050</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "res",
                    "description": "<p>Resonance (Q) from 0.001 to 1000</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "timeFromNow",
                    "description": "<p>schedule this event to happen\n                              seconds from now</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "class": "p5.Filter",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 8230,
            "description": "<p>Set the filter frequency, in Hz, from 10 to 22050 (the range of\nhuman hearing, although in reality most people hear in a narrower\nrange).</p>\n",
            "itemtype": "method",
            "name": "freq",
            "params": [
                {
                    "name": "freq",
                    "description": "<p>Filter Frequency</p>\n",
                    "type": "Number"
                },
                {
                    "name": "timeFromNow",
                    "description": "<p>schedule this event to happen\n                              seconds from now</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "return": {
                "description": "value  Returns the current frequency value",
                "type": "Number"
            },
            "class": "p5.Filter",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 8255,
            "description": "<p>Controls either width of a bandpass frequency,\nor the resonance of a low/highpass cutoff frequency.</p>\n",
            "itemtype": "method",
            "name": "res",
            "params": [
                {
                    "name": "res",
                    "description": "<p>Resonance/Width of filter freq\n                     from 0.001 to 1000</p>\n",
                    "type": "Number"
                },
                {
                    "name": "timeFromNow",
                    "description": "<p>schedule this event to happen\n                              seconds from now</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "return": {
                "description": "value Returns the current res value",
                "type": "Number"
            },
            "class": "p5.Filter",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 8277,
            "description": "<p>Controls the gain attribute of a Biquad Filter.\nThis is distinctly different from .amp() which is inherited from p5.Effect\n.amp() controls the volume via the output gain node\np5.Filter.gain() controls the gain parameter of a Biquad Filter node.</p>\n",
            "itemtype": "method",
            "name": "gain",
            "params": [
                {
                    "name": "gain",
                    "description": "",
                    "type": "Number"
                }
            ],
            "return": {
                "description": "Returns the current or updated gain value",
                "type": "Number"
            },
            "class": "p5.Filter",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 8298,
            "description": "<p>Toggle function. Switches between the specified type and allpass</p>\n",
            "itemtype": "method",
            "name": "toggle",
            "return": {
                "description": "[Toggle value]",
                "type": "Boolean"
            },
            "class": "p5.Filter",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 8313,
            "description": "<p>Set the type of a p5.Filter. Possible types include:\n&quot;lowpass&quot; (default), &quot;highpass&quot;, &quot;bandpass&quot;,\n&quot;lowshelf&quot;, &quot;highshelf&quot;, &quot;peaking&quot;, &quot;notch&quot;,\n&quot;allpass&quot;.</p>\n",
            "itemtype": "method",
            "name": "setType",
            "params": [
                {
                    "name": "t",
                    "description": "",
                    "type": "String"
                }
            ],
            "class": "p5.Filter",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 8516,
            "description": "<p>The p5.EQ is built with abstracted p5.Filter objects.\nTo modify any bands, use methods of the <a\nhref=\"/reference/#/p5.Filter\" title=\"p5.Filter reference\">\np5.Filter</a> API, especially <code>gain</code> and <code>freq</code>.\nBands are stored in an array, with indices 0 - 3, or 0 - 7</p>\n",
            "itemtype": "property",
            "name": "bands",
            "type": "Array",
            "class": "p5.EQ",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 8551,
            "description": "<p>Process an input by connecting it to the EQ</p>\n",
            "itemtype": "method",
            "name": "process",
            "params": [
                {
                    "name": "src",
                    "description": "<p>Audio source</p>\n",
                    "type": "Object"
                }
            ],
            "class": "p5.EQ",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 8637,
            "description": "<p><a title=\"Web Audio Panner docs\"  href=\n\"https://developer.mozilla.org/en-US/docs/Web/API/PannerNode\">\nWeb Audio Spatial Panner Node</a></p>\n<p>Properties include</p>\n<ul>\n<li>&lt;a title=&quot;w3 spec for Panning Model&quot;\nhref=&quot;<a href=\"https://www.w3.org/TR/webaudio/#idl-def-PanningModelType\">https://www.w3.org/TR/webaudio/#idl-def-PanningModelType</a>&quot;<blockquote>\n<p>panningModel</a>: &quot;equal power&quot; or &quot;HRTF&quot;</p>\n</blockquote>\n</li>\n<li>&lt;a title=&quot;w3 spec for Distance Model&quot;\nhref=&quot;<a href=\"https://www.w3.org/TR/webaudio/#idl-def-DistanceModelType\">https://www.w3.org/TR/webaudio/#idl-def-DistanceModelType</a>&quot;<blockquote>\n<p>distanceModel</a>: &quot;linear&quot;, &quot;inverse&quot;, or &quot;exponential&quot;</p>\n</blockquote>\n</li>\n</ul>\n",
            "itemtype": "property",
            "name": "panner",
            "type": "AudioNode",
            "class": "p5.Panner3D",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 8660,
            "description": "<p>Connect an audio sorce</p>\n",
            "itemtype": "method",
            "name": "process",
            "params": [
                {
                    "name": "src",
                    "description": "<p>Input source</p>\n",
                    "type": "Object"
                }
            ],
            "class": "p5.Panner3D",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 8669,
            "description": "<p>Set the X,Y,Z position of the Panner</p>\n",
            "itemtype": "method",
            "name": "set",
            "params": [
                {
                    "name": "xVal",
                    "description": "",
                    "type": "Number"
                },
                {
                    "name": "yVal",
                    "description": "",
                    "type": "Number"
                },
                {
                    "name": "zVal",
                    "description": "",
                    "type": "Number"
                },
                {
                    "name": "time",
                    "description": "",
                    "type": "Number"
                }
            ],
            "return": {
                "description": "Updated x, y, z values as an array",
                "type": "Array"
            },
            "class": "p5.Panner3D",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 8688,
            "description": "<p>Getter and setter methods for position coordinates</p>\n",
            "itemtype": "method",
            "name": "positionX",
            "return": {
                "description": "updated coordinate value",
                "type": "Number"
            },
            "class": "p5.Panner3D",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 8693,
            "description": "<p>Getter and setter methods for position coordinates</p>\n",
            "itemtype": "method",
            "name": "positionY",
            "return": {
                "description": "updated coordinate value",
                "type": "Number"
            },
            "class": "p5.Panner3D",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 8698,
            "description": "<p>Getter and setter methods for position coordinates</p>\n",
            "itemtype": "method",
            "name": "positionZ",
            "return": {
                "description": "updated coordinate value",
                "type": "Number"
            },
            "class": "p5.Panner3D",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 8736,
            "description": "<p>Set the X,Y,Z position of the Panner</p>\n",
            "itemtype": "method",
            "name": "orient",
            "params": [
                {
                    "name": "xVal",
                    "description": "",
                    "type": "Number"
                },
                {
                    "name": "yVal",
                    "description": "",
                    "type": "Number"
                },
                {
                    "name": "zVal",
                    "description": "",
                    "type": "Number"
                },
                {
                    "name": "time",
                    "description": "",
                    "type": "Number"
                }
            ],
            "return": {
                "description": "Updated x, y, z values as an array",
                "type": "Array"
            },
            "class": "p5.Panner3D",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 8755,
            "description": "<p>Getter and setter methods for orient coordinates</p>\n",
            "itemtype": "method",
            "name": "orientX",
            "return": {
                "description": "updated coordinate value",
                "type": "Number"
            },
            "class": "p5.Panner3D",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 8760,
            "description": "<p>Getter and setter methods for orient coordinates</p>\n",
            "itemtype": "method",
            "name": "orientY",
            "return": {
                "description": "updated coordinate value",
                "type": "Number"
            },
            "class": "p5.Panner3D",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 8765,
            "description": "<p>Getter and setter methods for orient coordinates</p>\n",
            "itemtype": "method",
            "name": "orientZ",
            "return": {
                "description": "updated coordinate value",
                "type": "Number"
            },
            "class": "p5.Panner3D",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 8803,
            "description": "<p>Set the rolloff factor and max distance</p>\n",
            "itemtype": "method",
            "name": "setFalloff",
            "params": [
                {
                    "name": "maxDistance",
                    "description": "",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "rolloffFactor",
                    "description": "",
                    "type": "Number",
                    "optional": true
                }
            ],
            "class": "p5.Panner3D",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 8813,
            "description": "<p>Maxium distance between the source and the listener</p>\n",
            "itemtype": "method",
            "name": "maxDist",
            "params": [
                {
                    "name": "maxDistance",
                    "description": "",
                    "type": "Number"
                }
            ],
            "return": {
                "description": "updated value",
                "type": "Number"
            },
            "class": "p5.Panner3D",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 8825,
            "description": "<p>How quickly the volume is reduced as the source moves away from the listener</p>\n",
            "itemtype": "method",
            "name": "rollof",
            "params": [
                {
                    "name": "rolloffFactor",
                    "description": "",
                    "type": "Number"
                }
            ],
            "return": {
                "description": "updated value",
                "type": "Number"
            },
            "class": "p5.Panner3D",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 9128,
            "description": "<p>The p5.Delay is built with two\n<a href=\"http://www.w3.org/TR/webaudio/#DelayNode\">\nWeb Audio Delay Nodes</a>, one for each stereo channel.</p>\n",
            "itemtype": "property",
            "name": "leftDelay",
            "type": "DelayNode",
            "class": "p5.Delay",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 9136,
            "description": "<p>The p5.Delay is built with two\n<a href=\"http://www.w3.org/TR/webaudio/#DelayNode\">\nWeb Audio Delay Nodes</a>, one for each stereo channel.</p>\n",
            "itemtype": "property",
            "name": "rightDelay",
            "type": "DelayNode",
            "class": "p5.Delay",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 9168,
            "description": "<p>Add delay to an audio signal according to a set\nof delay parameters.</p>\n",
            "itemtype": "method",
            "name": "process",
            "params": [
                {
                    "name": "Signal",
                    "description": "<p>An object that outputs audio</p>\n",
                    "type": "Object"
                },
                {
                    "name": "delayTime",
                    "description": "<p>Time (in seconds) of the delay/echo.\n                             Some browsers limit delayTime to\n                             1 second.</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "feedback",
                    "description": "<p>sends the delay back through itself\n                             in a loop that decreases in volume\n                             each time.</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "lowPass",
                    "description": "<p>Cutoff frequency. Only frequencies\n                             below the lowPass will be part of the\n                             delay.</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "class": "p5.Delay",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 9203,
            "description": "<p>Set the delay (echo) time, in seconds. Usually this value will be\na floating point number between 0.0 and 1.0.</p>\n",
            "itemtype": "method",
            "name": "delayTime",
            "params": [
                {
                    "name": "delayTime",
                    "description": "<p>Time (in seconds) of the delay</p>\n",
                    "type": "Number"
                }
            ],
            "class": "p5.Delay",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 9222,
            "description": "<p>Feedback occurs when Delay sends its signal back through its input\nin a loop. The feedback amount determines how much signal to send each\ntime through the loop. A feedback greater than 1.0 is not desirable because\nit will increase the overall output each time through the loop,\ncreating an infinite feedback loop. The default value is 0.5</p>\n",
            "itemtype": "method",
            "name": "feedback",
            "params": [
                {
                    "name": "feedback",
                    "description": "<p>0.0 to 1.0, or an object such as an\n                                Oscillator that can be used to\n                                modulate this param</p>\n",
                    "type": "Number|Object"
                }
            ],
            "return": {
                "description": "Feedback value",
                "type": "Number"
            },
            "class": "p5.Delay",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 9250,
            "description": "<p>Set a lowpass filter frequency for the delay. A lowpass filter\nwill cut off any frequencies higher than the filter frequency.</p>\n",
            "itemtype": "method",
            "name": "filter",
            "params": [
                {
                    "name": "cutoffFreq",
                    "description": "<p>A lowpass filter will cut off any\n                            frequencies higher than the filter frequency.</p>\n",
                    "type": "Number|Object"
                },
                {
                    "name": "res",
                    "description": "<p>Resonance of the filter frequency\n                            cutoff, or an object (i.e. a p5.Oscillator)\n                            that can be used to modulate this parameter.\n                            High numbers (i.e. 15) will produce a resonance,\n                            low numbers (i.e. .2) will produce a slope.</p>\n",
                    "type": "Number|Object"
                }
            ],
            "class": "p5.Delay",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 9267,
            "description": "<p>Choose a preset type of delay. &#39;pingPong&#39; bounces the signal\nfrom the left to the right channel to produce a stereo effect.\nAny other parameter will revert to the default delay setting.</p>\n",
            "itemtype": "method",
            "name": "setType",
            "params": [
                {
                    "name": "type",
                    "description": "<p>&#39;pingPong&#39; (1) or &#39;default&#39; (0)</p>\n",
                    "type": "String|Number"
                }
            ],
            "class": "p5.Delay",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 9300,
            "description": "<p>Set the output level of the delay effect.</p>\n",
            "itemtype": "method",
            "name": "amp",
            "params": [
                {
                    "name": "volume",
                    "description": "<p>amplitude between 0 and 1.0</p>\n",
                    "type": "Number"
                },
                {
                    "name": "rampTime",
                    "description": "<p>create a fade that lasts rampTime</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "timeFromNow",
                    "description": "<p>schedule this event to happen\n                              seconds from now</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "class": "p5.Delay",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 9309,
            "description": "<p>Send output to a p5.sound or web audio object</p>\n",
            "itemtype": "method",
            "name": "connect",
            "params": [
                {
                    "name": "unit",
                    "description": "",
                    "type": "Object"
                }
            ],
            "class": "p5.Delay",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 9315,
            "description": "<p>Disconnect all output.</p>\n",
            "itemtype": "method",
            "name": "disconnect",
            "class": "p5.Delay",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 9394,
            "description": "<p>Connect a source to the reverb, and assign reverb parameters.</p>\n",
            "itemtype": "method",
            "name": "process",
            "params": [
                {
                    "name": "src",
                    "description": "<p>p5.sound / Web Audio object with a sound\n                         output.</p>\n",
                    "type": "Object"
                },
                {
                    "name": "seconds",
                    "description": "<p>Duration of the reverb, in seconds.\n                         Min: 0, Max: 10. Defaults to 3.</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "decayRate",
                    "description": "<p>Percentage of decay with each echo.\n                          Min: 0, Max: 100. Defaults to 2.</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "reverse",
                    "description": "<p>Play the reverb backwards or forwards.</p>\n",
                    "type": "Boolean",
                    "optional": true
                }
            ],
            "class": "p5.Reverb",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 9423,
            "description": "<p>Set the reverb settings. Similar to .process(), but without\nassigning a new input.</p>\n",
            "itemtype": "method",
            "name": "set",
            "params": [
                {
                    "name": "seconds",
                    "description": "<p>Duration of the reverb, in seconds.\n                         Min: 0, Max: 10. Defaults to 3.</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "decayRate",
                    "description": "<p>Percentage of decay with each echo.\n                          Min: 0, Max: 100. Defaults to 2.</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "reverse",
                    "description": "<p>Play the reverb backwards or forwards.</p>\n",
                    "type": "Boolean",
                    "optional": true
                }
            ],
            "class": "p5.Reverb",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 9451,
            "description": "<p>Set the output level of the reverb effect.</p>\n",
            "itemtype": "method",
            "name": "amp",
            "params": [
                {
                    "name": "volume",
                    "description": "<p>amplitude between 0 and 1.0</p>\n",
                    "type": "Number"
                },
                {
                    "name": "rampTime",
                    "description": "<p>create a fade that lasts rampTime</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "timeFromNow",
                    "description": "<p>schedule this event to happen\n                              seconds from now</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "class": "p5.Reverb",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 9460,
            "description": "<p>Send output to a p5.sound or web audio object</p>\n",
            "itemtype": "method",
            "name": "connect",
            "params": [
                {
                    "name": "unit",
                    "description": "",
                    "type": "Object"
                }
            ],
            "class": "p5.Reverb",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 9466,
            "description": "<p>Disconnect all output.</p>\n",
            "itemtype": "method",
            "name": "disconnect",
            "class": "p5.Reverb",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 9560,
            "description": "<p>Internally, the p5.Convolver uses the a\n<a href=\"http://www.w3.org/TR/webaudio/#ConvolverNode\">\nWeb Audio Convolver Node</a>.</p>\n",
            "itemtype": "property",
            "name": "convolverNod",
            "type": "ConvolverNode",
            "class": "p5.Convolver",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 9585,
            "description": "<p>Create a p5.Convolver. Accepts a path to a soundfile\nthat will be used to generate an impulse response.</p>\n",
            "itemtype": "method",
            "name": "createConvolver",
            "params": [
                {
                    "name": "path",
                    "description": "<p>path to a sound file</p>\n",
                    "type": "String"
                },
                {
                    "name": "callback",
                    "description": "<p>function to call if loading is successful.\n                              The object will be passed in as the argument\n                              to the callback function.</p>\n",
                    "type": "Function",
                    "optional": true
                },
                {
                    "name": "errorCallback",
                    "description": "<p>function to call if loading is not successful.\n                              A custom error will be passed in as the argument\n                              to the callback function.</p>\n",
                    "type": "Function",
                    "optional": true
                }
            ],
            "return": {
                "description": "",
                "type": "p5.Convolver"
            },
            "example": [
                "\n<div><code>\nvar cVerb, sound;\nfunction preload() {\n  // We have both MP3 and OGG versions of all sound assets\n  soundFormats('ogg', 'mp3');\n\n  // Try replacing 'bx-spring' with other soundfiles like\n  // 'concrete-tunnel' 'small-plate' 'drum' 'beatbox'\n  cVerb = createConvolver('assets/bx-spring.mp3');\n\n  // Try replacing 'Damscray_DancingTiger' with\n  // 'beat', 'doorbell', lucky_dragons'\n  sound = loadSound('assets/Damscray_DancingTiger.mp3');\n}\n\nfunction setup() {\n  // disconnect from master output...\n  sound.disconnect();\n\n  // ...and process with cVerb\n  // so that we only hear the convolution\n  cVerb.process(sound);\n\n  sound.play();\n}\n</code></div>"
            ],
            "class": "p5.Convolver",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 9701,
            "description": "<p>Connect a source to the reverb, and assign reverb parameters.</p>\n",
            "itemtype": "method",
            "name": "process",
            "params": [
                {
                    "name": "src",
                    "description": "<p>p5.sound / Web Audio object with a sound\n                         output.</p>\n",
                    "type": "Object"
                }
            ],
            "example": [
                "\n<div><code>\nvar cVerb, sound;\nfunction preload() {\n  soundFormats('ogg', 'mp3');\n\n  cVerb = createConvolver('assets/concrete-tunnel.mp3');\n\n  sound = loadSound('assets/beat.mp3');\n}\n\nfunction setup() {\n  // disconnect from master output...\n  sound.disconnect();\n\n  // ...and process with (i.e. connect to) cVerb\n  // so that we only hear the convolution\n  cVerb.process(sound);\n\n  sound.play();\n}\n</code></div>"
            ],
            "class": "p5.Convolver",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 9733,
            "description": "<p>If you load multiple impulse files using the .addImpulse method,\nthey will be stored as Objects in this Array. Toggle between them\nwith the <code>toggleImpulse(id)</code> method.</p>\n",
            "itemtype": "property",
            "name": "impulses",
            "type": "Array",
            "class": "p5.Convolver",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 9741,
            "description": "<p>Load and assign a new Impulse Response to the p5.Convolver.\nThe impulse is added to the <code>.impulses</code> array. Previous\nimpulses can be accessed with the <code>.toggleImpulse(id)</code>\nmethod.</p>\n",
            "itemtype": "method",
            "name": "addImpulse",
            "params": [
                {
                    "name": "path",
                    "description": "<p>path to a sound file</p>\n",
                    "type": "String"
                },
                {
                    "name": "callback",
                    "description": "<p>function (optional)</p>\n",
                    "type": "Function"
                },
                {
                    "name": "errorCallback",
                    "description": "<p>function (optional)</p>\n",
                    "type": "Function"
                }
            ],
            "class": "p5.Convolver",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 9759,
            "description": "<p>Similar to .addImpulse, except that the <code>.impulses</code>\nArray is reset to save memory. A new <code>.impulses</code>\narray is created with this impulse as the only item.</p>\n",
            "itemtype": "method",
            "name": "resetImpulse",
            "params": [
                {
                    "name": "path",
                    "description": "<p>path to a sound file</p>\n",
                    "type": "String"
                },
                {
                    "name": "callback",
                    "description": "<p>function (optional)</p>\n",
                    "type": "Function"
                },
                {
                    "name": "errorCallback",
                    "description": "<p>function (optional)</p>\n",
                    "type": "Function"
                }
            ],
            "class": "p5.Convolver",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 9777,
            "description": "<p>If you have used <code>.addImpulse()</code> to add multiple impulses\nto a p5.Convolver, then you can use this method to toggle between\nthe items in the <code>.impulses</code> Array. Accepts a parameter\nto identify which impulse you wish to use, identified either by its\noriginal filename (String) or by its position in the <code>.impulses\n</code> Array (Number).<br/>\nYou can access the objects in the .impulses Array directly. Each\nObject has two attributes: an <code>.audioBuffer</code> (type:\nWeb Audio <a href=\"\nhttp://webaudio.github.io/web-audio-api/#the-audiobuffer-interface\">\nAudioBuffer)</a> and a <code>.name</code>, a String that corresponds\nwith the original filename.</p>\n",
            "itemtype": "method",
            "name": "toggleImpulse",
            "params": [
                {
                    "name": "id",
                    "description": "<p>Identify the impulse by its original filename\n                          (String), or by its position in the\n                          <code>.impulses</code> Array (Number).</p>\n",
                    "type": "String|Number"
                }
            ],
            "class": "p5.Convolver",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 9821,
            "class": "p5.Convolver",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 9846,
            "class": "p5.Convolver",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 10041,
            "description": "<p>Set the global tempo, in beats per minute, for all\np5.Parts. This method will impact all active p5.Parts.</p>\n",
            "itemtype": "method",
            "name": "setBPM",
            "params": [
                {
                    "name": "BPM",
                    "description": "<p>Beats Per Minute</p>\n",
                    "type": "Number"
                },
                {
                    "name": "rampTime",
                    "description": "<p>Seconds from now</p>\n",
                    "type": "Number"
                }
            ],
            "class": "p5.Convolver",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 10131,
            "description": "<p>Array of values to pass into the callback\nat each step of the phrase. Depending on the callback\nfunction&#39;s requirements, these values may be numbers,\nstrings, or an object with multiple parameters.\nZero (0) indicates a rest.</p>\n",
            "itemtype": "property",
            "name": "sequence",
            "type": "Array",
            "class": "p5.Phrase",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 10219,
            "description": "<p>Set the tempo of this part, in Beats Per Minute.</p>\n",
            "itemtype": "method",
            "name": "setBPM",
            "params": [
                {
                    "name": "BPM",
                    "description": "<p>Beats Per Minute</p>\n",
                    "type": "Number"
                },
                {
                    "name": "rampTime",
                    "description": "<p>Seconds from now</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "class": "p5.Part",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 10229,
            "description": "<p>Returns the Beats Per Minute of this currently part.</p>\n",
            "itemtype": "method",
            "name": "getBPM",
            "return": {
                "description": "",
                "type": "Number"
            },
            "class": "p5.Part",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 10238,
            "description": "<p>Start playback of this part. It will play\nthrough all of its phrases at a speed\ndetermined by setBPM.</p>\n",
            "itemtype": "method",
            "name": "start",
            "params": [
                {
                    "name": "time",
                    "description": "<p>seconds from now</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "class": "p5.Part",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 10254,
            "description": "<p>Loop playback of this part. It will begin\nlooping through all of its phrases at a speed\ndetermined by setBPM.</p>\n",
            "itemtype": "method",
            "name": "loop",
            "params": [
                {
                    "name": "time",
                    "description": "<p>seconds from now</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "class": "p5.Part",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 10271,
            "description": "<p>Tell the part to stop looping.</p>\n",
            "itemtype": "method",
            "name": "noLoop",
            "class": "p5.Part",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 10283,
            "description": "<p>Stop the part and cue it to step 0.</p>\n",
            "itemtype": "method",
            "name": "stop",
            "params": [
                {
                    "name": "time",
                    "description": "<p>seconds from now</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "class": "p5.Part",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 10293,
            "description": "<p>Pause the part. Playback will resume\nfrom the current step.</p>\n",
            "itemtype": "method",
            "name": "pause",
            "params": [
                {
                    "name": "time",
                    "description": "<p>seconds from now</p>\n",
                    "type": "Number"
                }
            ],
            "class": "p5.Part",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 10305,
            "description": "<p>Add a p5.Phrase to this Part.</p>\n",
            "itemtype": "method",
            "name": "addPhrase",
            "params": [
                {
                    "name": "phrase",
                    "description": "<p>reference to a p5.Phrase</p>\n",
                    "type": "p5.Phrase"
                }
            ],
            "class": "p5.Part",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 10326,
            "description": "<p>Remove a phrase from this part, based on the name it was\ngiven when it was created.</p>\n",
            "itemtype": "method",
            "name": "removePhrase",
            "params": [
                {
                    "name": "phraseName",
                    "description": "",
                    "type": "String"
                }
            ],
            "class": "p5.Part",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 10340,
            "description": "<p>Get a phrase from this part, based on the name it was\ngiven when it was created. Now you can modify its array.</p>\n",
            "itemtype": "method",
            "name": "getPhrase",
            "params": [
                {
                    "name": "phraseName",
                    "description": "",
                    "type": "String"
                }
            ],
            "class": "p5.Part",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 10354,
            "description": "<p>Get a phrase from this part, based on the name it was\ngiven when it was created. Now you can modify its array.</p>\n",
            "itemtype": "method",
            "name": "replaceSequence",
            "params": [
                {
                    "name": "phraseName",
                    "description": "",
                    "type": "String"
                },
                {
                    "name": "sequence",
                    "description": "<p>Array of values to pass into the callback\n                          at each step of the phrase.</p>\n",
                    "type": "Array"
                }
            ],
            "class": "p5.Part",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 10382,
            "description": "<p>Fire a callback function at every step.</p>\n",
            "itemtype": "method",
            "name": "onStep",
            "params": [
                {
                    "name": "callback",
                    "description": "<p>The name of the callback\n                            you want to fire\n                            on every beat/tatum.</p>\n",
                    "type": "Function"
                }
            ],
            "class": "p5.Part",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 10435,
            "description": "<p>Start playback of the score.</p>\n",
            "itemtype": "method",
            "name": "start",
            "class": "p5.Score",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 10444,
            "description": "<p>Stop playback of the score.</p>\n",
            "itemtype": "method",
            "name": "stop",
            "class": "p5.Score",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 10454,
            "description": "<p>Pause playback of the score.</p>\n",
            "itemtype": "method",
            "name": "pause",
            "class": "p5.Score",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 10462,
            "description": "<p>Loop playback of the score.</p>\n",
            "itemtype": "method",
            "name": "loop",
            "class": "p5.Score",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 10471,
            "description": "<p>Stop looping playback of the score. If it\nis currently playing, this will go into effect\nafter the current round of playback completes.</p>\n",
            "itemtype": "method",
            "name": "noLoop",
            "class": "p5.Score",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 10496,
            "description": "<p>Set the tempo for all parts in the score</p>\n",
            "itemtype": "method",
            "name": "setBPM",
            "params": [
                {
                    "name": "BPM",
                    "description": "<p>Beats Per Minute</p>\n",
                    "type": "Number"
                },
                {
                    "name": "rampTime",
                    "description": "<p>Seconds from now</p>\n",
                    "type": "Number"
                }
            ],
            "class": "p5.Score",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 10564,
            "description": "<p>musicalTimeMode uses <a href = \"https://github.com/Tonejs/Tone.js/wiki/Time\">Tone.Time</a> convention\ntrue if string, false if number</p>\n",
            "itemtype": "property",
            "name": "musicalTimeMode",
            "type": "Boolean",
            "class": "p5.SoundLoop",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 10571,
            "description": "<p>musicalTimeMode variables\nmodify these only when the interval is specified in musicalTime format as a string</p>\n",
            "class": "p5.SoundLoop",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 10578,
            "description": "<p>Set a limit to the number of loops to play. defaults to Infinity</p>\n",
            "itemtype": "property",
            "name": "maxIterations",
            "type": "Number",
            "class": "p5.SoundLoop",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 10587,
            "description": "<p>Do not initiate the callback if timeFromNow is &lt; 0\nThis ususually occurs for a few milliseconds when the page\nis not fully loaded</p>\n<p>The callback should only be called until maxIterations is reached</p>\n",
            "class": "p5.SoundLoop",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 10601,
            "description": "<p>Start the loop</p>\n",
            "itemtype": "method",
            "name": "start",
            "params": [
                {
                    "name": "timeFromNow",
                    "description": "<p>schedule a starting time</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "class": "p5.SoundLoop",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 10614,
            "description": "<p>Stop the loop</p>\n",
            "itemtype": "method",
            "name": "stop",
            "params": [
                {
                    "name": "timeFromNow",
                    "description": "<p>schedule a stopping time</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "class": "p5.SoundLoop",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 10627,
            "description": "<p>Pause the loop</p>\n",
            "itemtype": "method",
            "name": "pause",
            "params": [
                {
                    "name": "timeFromNow",
                    "description": "<p>schedule a pausing time</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "class": "p5.SoundLoop",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 10639,
            "description": "<p>Synchronize loops. Use this method to start two more more loops in synchronization\nor to start a loop in synchronization with a loop that is already playing\nThis method will schedule the implicit loop in sync with the explicit master loop\ni.e. loopToStart.syncedStart(loopToSyncWith)</p>\n",
            "itemtype": "method",
            "name": "syncedStart",
            "params": [
                {
                    "name": "otherLoop",
                    "description": "<p>a p5.SoundLoop to sync with</p>\n",
                    "type": "Object"
                },
                {
                    "name": "timeFromNow",
                    "description": "<p>Start the loops in sync after timeFromNow seconds</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "class": "p5.SoundLoop",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 10720,
            "description": "<p>Getters and Setters, setting any paramter will result in a change in the clock&#39;s\nfrequency, that will be reflected after the next callback\nbeats per minute (defaults to 60)</p>\n",
            "itemtype": "property",
            "name": "bpm",
            "type": "Number",
            "class": "p5.SoundLoop",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 10738,
            "description": "<p>number of quarter notes in a measure (defaults to 4)</p>\n",
            "itemtype": "property",
            "name": "timeSignature",
            "type": "Number",
            "class": "p5.SoundLoop",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 10754,
            "description": "<p>length of the loops interval</p>\n",
            "itemtype": "property",
            "name": "interval",
            "type": "Number|String",
            "class": "p5.SoundLoop",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 10768,
            "description": "<p>how many times the callback has been called so far</p>\n",
            "itemtype": "property",
            "name": "iterations",
            "type": "Number",
            "readonly": "",
            "class": "p5.SoundLoop",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 10809,
            "description": "<p>The p5.Compressor is built with a <a href=\"https://www.w3.org/TR/webaudio/#the-dynamicscompressornode-interface\"\n  target=\"_blank\" title=\"W3 spec for Dynamics Compressor Node\">Web Audio Dynamics Compressor Node\n  </a></p>\n",
            "itemtype": "property",
            "name": "compressor",
            "type": "AudioNode",
            "class": "p5.Compressor",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 10820,
            "description": "<p>Performs the same function as .connect, but also accepts\noptional parameters to set compressor&#39;s audioParams</p>\n",
            "itemtype": "method",
            "name": "process",
            "params": [
                {
                    "name": "src",
                    "description": "<p>Sound source to be connected</p>\n",
                    "type": "Object"
                },
                {
                    "name": "attack",
                    "description": "<p>The amount of time (in seconds) to reduce the gain by 10dB,\n                           default = .003, range 0 - 1</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "knee",
                    "description": "<p>A decibel value representing the range above the\n                           threshold where the curve smoothly transitions to the &quot;ratio&quot; portion.\n                           default = 30, range 0 - 40</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "ratio",
                    "description": "<p>The amount of dB change in input for a 1 dB change in output\n                           default = 12, range 1 - 20</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "threshold",
                    "description": "<p>The decibel value above which the compression will start taking effect\n                           default = -24, range -100 - 0</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "release",
                    "description": "<p>The amount of time (in seconds) to increase the gain by 10dB\n                           default = .25, range 0 - 1</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "class": "p5.Compressor",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 10843,
            "description": "<p>Set the paramters of a compressor.</p>\n",
            "itemtype": "method",
            "name": "set",
            "params": [
                {
                    "name": "attack",
                    "description": "<p>The amount of time (in seconds) to reduce the gain by 10dB,\n                           default = .003, range 0 - 1</p>\n",
                    "type": "Number"
                },
                {
                    "name": "knee",
                    "description": "<p>A decibel value representing the range above the\n                           threshold where the curve smoothly transitions to the &quot;ratio&quot; portion.\n                           default = 30, range 0 - 40</p>\n",
                    "type": "Number"
                },
                {
                    "name": "ratio",
                    "description": "<p>The amount of dB change in input for a 1 dB change in output\n                           default = 12, range 1 - 20</p>\n",
                    "type": "Number"
                },
                {
                    "name": "threshold",
                    "description": "<p>The decibel value above which the compression will start taking effect\n                           default = -24, range -100 - 0</p>\n",
                    "type": "Number"
                },
                {
                    "name": "release",
                    "description": "<p>The amount of time (in seconds) to increase the gain by 10dB\n                           default = .25, range 0 - 1</p>\n",
                    "type": "Number"
                }
            ],
            "class": "p5.Compressor",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 10875,
            "description": "<p>Get current attack or set value w/ time ramp</p>\n",
            "itemtype": "method",
            "name": "attack",
            "params": [
                {
                    "name": "attack",
                    "description": "<p>Attack is the amount of time (in seconds) to reduce the gain by 10dB,\n                         default = .003, range 0 - 1</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "time",
                    "description": "<p>Assign time value to schedule the change in value</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "class": "p5.Compressor",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 10895,
            "description": "<p>Get current knee or set value w/ time ramp</p>\n",
            "itemtype": "method",
            "name": "knee",
            "params": [
                {
                    "name": "knee",
                    "description": "<p>A decibel value representing the range above the\n                       threshold where the curve smoothly transitions to the &quot;ratio&quot; portion.\n                       default = 30, range 0 - 40</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "time",
                    "description": "<p>Assign time value to schedule the change in value</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "class": "p5.Compressor",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 10915,
            "description": "<p>Get current ratio or set value w/ time ramp</p>\n",
            "itemtype": "method",
            "name": "ratio",
            "params": [
                {
                    "name": "ratio",
                    "description": "<p>The amount of dB change in input for a 1 dB change in output\n                           default = 12, range 1 - 20</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "time",
                    "description": "<p>Assign time value to schedule the change in value</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "class": "p5.Compressor",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 10934,
            "description": "<p>Get current threshold or set value w/ time ramp</p>\n",
            "itemtype": "method",
            "name": "threshold",
            "params": [
                {
                    "name": "threshold",
                    "description": "<p>The decibel value above which the compression will start taking effect\n                           default = -24, range -100 - 0</p>\n",
                    "type": "Number"
                },
                {
                    "name": "time",
                    "description": "<p>Assign time value to schedule the change in value</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "class": "p5.Compressor",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 10953,
            "description": "<p>Get current release or set value w/ time ramp</p>\n",
            "itemtype": "method",
            "name": "release",
            "params": [
                {
                    "name": "release",
                    "description": "<p>The amount of time (in seconds) to increase the gain by 10dB\n                           default = .25, range 0 - 1</p>\n",
                    "type": "Number"
                },
                {
                    "name": "time",
                    "description": "<p>Assign time value to schedule the change in value</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "class": "p5.Compressor",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 10973,
            "description": "<p>Return the current reduction value</p>\n",
            "itemtype": "method",
            "name": "reduction",
            "return": {
                "description": "Value of the amount of gain reduction that is applied to the signal",
                "type": "Number"
            },
            "class": "p5.Compressor",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 11085,
            "description": "<p>Connect a specific device to the p5.SoundRecorder.\nIf no parameter is given, p5.SoundRecorer will record\nall audible p5.sound from your sketch.</p>\n",
            "itemtype": "method",
            "name": "setInput",
            "params": [
                {
                    "name": "unit",
                    "description": "<p>p5.sound object or a web audio unit\n                       that outputs sound</p>\n",
                    "type": "Object",
                    "optional": true
                }
            ],
            "class": "p5.SoundRecorder",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 11106,
            "description": "<p>Start recording. To access the recording, provide\na p5.SoundFile as the first parameter. The p5.SoundRecorder\nwill send its recording to that p5.SoundFile for playback once\nrecording is complete. Optional parameters include duration\n(in seconds) of the recording, and a callback function that\nwill be called once the complete recording has been\ntransfered to the p5.SoundFile.</p>\n",
            "itemtype": "method",
            "name": "record",
            "params": [
                {
                    "name": "soundFile",
                    "description": "<p>p5.SoundFile</p>\n",
                    "type": "p5.SoundFile"
                },
                {
                    "name": "duration",
                    "description": "<p>Time (in seconds)</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "callback",
                    "description": "<p>The name of a function that will be\n                              called once the recording completes</p>\n",
                    "type": "Function",
                    "optional": true
                }
            ],
            "class": "p5.SoundRecorder",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 11139,
            "description": "<p>Stop the recording. Once the recording is stopped,\nthe results will be sent to the p5.SoundFile that\nwas given on .record(), and if a callback function\nwas provided on record, that function will be called.</p>\n",
            "itemtype": "method",
            "name": "stop",
            "class": "p5.SoundRecorder",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 11212,
            "description": "<p>Save a p5.SoundFile as a .wav audio file.</p>\n",
            "itemtype": "method",
            "name": "saveSound",
            "params": [
                {
                    "name": "soundFile",
                    "description": "<p>p5.SoundFile that you wish to save</p>\n",
                    "type": "p5.SoundFile"
                },
                {
                    "name": "name",
                    "description": "<p>name of the resulting .wav file.</p>\n",
                    "type": "String"
                }
            ],
            "class": "p5.SoundRecorder",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 11388,
            "description": "<p>isDetected is set to true when a peak is detected.</p>\n",
            "itemtype": "attribute",
            "name": "isDetected",
            "type": "Boolean",
            "default": "false",
            "class": "p5.PeakDetect",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 11401,
            "description": "<p>The update method is run in the draw loop.</p>\n<p>Accepts an FFT object. You must call .analyze()\non the FFT object prior to updating the peakDetect\nbecause it relies on a completed FFT analysis.</p>\n",
            "itemtype": "method",
            "name": "update",
            "params": [
                {
                    "name": "fftObject",
                    "description": "<p>A p5.FFT object</p>\n",
                    "type": "p5.FFT"
                }
            ],
            "class": "p5.PeakDetect",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 11432,
            "description": "<p>onPeak accepts two arguments: a function to call when\na peak is detected. The value of the peak,\nbetween 0.0 and 1.0, is passed to the callback.</p>\n",
            "itemtype": "method",
            "name": "onPeak",
            "params": [
                {
                    "name": "callback",
                    "description": "<p>Name of a function that will\n                            be called when a peak is\n                            detected.</p>\n",
                    "type": "Function"
                },
                {
                    "name": "val",
                    "description": "<p>Optional value to pass\n                            into the function when\n                            a peak is detected.</p>\n",
                    "type": "Object",
                    "optional": true
                }
            ],
            "example": [
                "\n<div><code>\nvar cnv, soundFile, fft, peakDetect;\nvar ellipseWidth = 0;\n\nfunction setup() {\n  cnv = createCanvas(100,100);\n  textAlign(CENTER);\n\n  soundFile = loadSound('assets/beat.mp3');\n  fft = new p5.FFT();\n  peakDetect = new p5.PeakDetect();\n\n  setupSound();\n\n  // when a beat is detected, call triggerBeat()\n  peakDetect.onPeak(triggerBeat);\n}\n\nfunction draw() {\n  background(0);\n  fill(255);\n  text('click to play', width/2, height/2);\n\n  fft.analyze();\n  peakDetect.update(fft);\n\n  ellipseWidth *= 0.95;\n  ellipse(width/2, height/2, ellipseWidth, ellipseWidth);\n}\n\n// this function is called by peakDetect.onPeak\nfunction triggerBeat() {\n  ellipseWidth = 50;\n}\n\n// mouseclick starts/stops sound\nfunction setupSound() {\n  cnv.mouseClicked( function() {\n    if (soundFile.isPlaying() ) {\n      soundFile.stop();\n    } else {\n      soundFile.play();\n    }\n  });\n}\n</code></div>"
            ],
            "class": "p5.PeakDetect",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 11578,
            "description": "<p>Connect a source to the gain node.</p>\n",
            "itemtype": "method",
            "name": "setInput",
            "params": [
                {
                    "name": "src",
                    "description": "<p>p5.sound / Web Audio object with a sound\n                         output.</p>\n",
                    "type": "Object"
                }
            ],
            "class": "p5.Gain",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 11588,
            "description": "<p>Send output to a p5.sound or web audio object</p>\n",
            "itemtype": "method",
            "name": "connect",
            "params": [
                {
                    "name": "unit",
                    "description": "",
                    "type": "Object"
                }
            ],
            "class": "p5.Gain",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 11598,
            "description": "<p>Disconnect all output.</p>\n",
            "itemtype": "method",
            "name": "disconnect",
            "class": "p5.Gain",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 11606,
            "description": "<p>Set the output level of the gain node.</p>\n",
            "itemtype": "method",
            "name": "amp",
            "params": [
                {
                    "name": "volume",
                    "description": "<p>amplitude between 0 and 1.0</p>\n",
                    "type": "Number"
                },
                {
                    "name": "rampTime",
                    "description": "<p>create a fade that lasts rampTime</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "timeFromNow",
                    "description": "<p>schedule this event to happen\n                              seconds from now</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "class": "p5.Gain",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 11684,
            "description": "<p>Connect to p5 objects or Web Audio Nodes</p>\n",
            "itemtype": "method",
            "name": "connect",
            "params": [
                {
                    "name": "unit",
                    "description": "",
                    "type": "Object"
                }
            ],
            "class": "p5.AudioVoice",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 11693,
            "description": "<p>Disconnect from soundOut</p>\n",
            "itemtype": "method",
            "name": "disconnect",
            "class": "p5.AudioVoice",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 11761,
            "description": "<p>Play tells the MonoSynth to start playing a note. This method schedules\nthe calling of .triggerAttack and .triggerRelease.</p>\n",
            "itemtype": "method",
            "name": "play",
            "params": [
                {
                    "name": "note",
                    "description": "<p>the note you want to play, specified as a\n                               frequency in Hertz (Number) or as a midi\n                               value in Note/Octave format (&quot;C4&quot;, &quot;Eb3&quot;...etc&quot;)\n                               See <a href = \"https://github.com/Tonejs/Tone.js/wiki/Instruments\">\n                               Tone</a>. Defaults to 440 hz.</p>\n",
                    "type": "String | Number"
                },
                {
                    "name": "velocity",
                    "description": "<p>velocity of the note to play (ranging from 0 to 1)</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "secondsFromNow",
                    "description": "<p>time from now (in seconds) at which to play</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "sustainTime",
                    "description": "<p>time to sustain before releasing the envelope</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "class": "p5.MonoSynth",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 11783,
            "description": "<p>Trigger the Attack, and Decay portion of the Envelope.\nSimilar to holding down a key on a piano, but it will\nhold the sustain level until you let go.</p>\n",
            "params": [
                {
                    "name": "note",
                    "description": "<p>the note you want to play, specified as a\n                               frequency in Hertz (Number) or as a midi\n                               value in Note/Octave format (&quot;C4&quot;, &quot;Eb3&quot;...etc&quot;)\n                               See <a href = \"https://github.com/Tonejs/Tone.js/wiki/Instruments\">\n                               Tone</a>. Defaults to 440 hz</p>\n",
                    "type": "String | Number"
                },
                {
                    "name": "velocity",
                    "description": "<p>velocity of the note to play (ranging from 0 to 1)</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "secondsFromNow",
                    "description": "<p>time from now (in seconds) at which to play</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "itemtype": "method",
            "name": "triggerAttack",
            "class": "p5.MonoSynth",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 11806,
            "description": "<p>Trigger the release of the Envelope. This is similar to releasing\nthe key on a piano and letting the sound fade according to the\nrelease level and release time.</p>\n",
            "params": [
                {
                    "name": "secondsFromNow",
                    "description": "<p>time to trigger the release</p>\n",
                    "type": "Number"
                }
            ],
            "itemtype": "method",
            "name": "triggerRelease",
            "class": "p5.MonoSynth",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 11819,
            "description": "<p>Set values like a traditional\n<a href=\"https://en.wikipedia.org/wiki/Synthesizer#/media/File:ADSR_parameter.svg\">\nADSR envelope\n</a>.</p>\n",
            "itemtype": "method",
            "name": "setADSR",
            "params": [
                {
                    "name": "attackTime",
                    "description": "<p>Time (in seconds before envelope\n                              reaches Attack Level</p>\n",
                    "type": "Number"
                },
                {
                    "name": "decayTime",
                    "description": "<p>Time (in seconds) before envelope\n                              reaches Decay/Sustain Level</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "susRatio",
                    "description": "<p>Ratio between attackLevel and releaseLevel, on a scale from 0 to 1,\n                              where 1.0 = attackLevel, 0.0 = releaseLevel.\n                              The susRatio determines the decayLevel and the level at which the\n                              sustain portion of the envelope will sustain.\n                              For example, if attackLevel is 0.4, releaseLevel is 0,\n                              and susAmt is 0.5, the decayLevel would be 0.2. If attackLevel is\n                              increased to 1.0 (using <code>setRange</code>),\n                              then decayLevel would increase proportionally, to become 0.5.</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "releaseTime",
                    "description": "<p>Time in seconds from now (defaults to 0)</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "class": "p5.MonoSynth",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 11843,
            "description": "<p>Getters and Setters</p>\n",
            "itemtype": "property",
            "name": "attack",
            "type": "Number",
            "class": "p5.MonoSynth",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 11847,
            "itemtype": "property",
            "name": "decay",
            "type": "Number",
            "class": "p5.MonoSynth",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 11850,
            "itemtype": "property",
            "name": "sustain",
            "type": "Number",
            "class": "p5.MonoSynth",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 11853,
            "itemtype": "property",
            "name": "release",
            "type": "Number",
            "class": "p5.MonoSynth",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 11890,
            "description": "<p>MonoSynth amp</p>\n",
            "itemtype": "method",
            "name": "amp",
            "params": [
                {
                    "name": "vol",
                    "description": "<p>desired volume</p>\n",
                    "type": "Number"
                },
                {
                    "name": "rampTime",
                    "description": "<p>Time to reach new volume</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "return": {
                "description": "new volume value",
                "type": "Number"
            },
            "class": "p5.MonoSynth",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 11904,
            "description": "<p>Connect to a p5.sound / Web Audio object.</p>\n",
            "itemtype": "method",
            "name": "connect",
            "params": [
                {
                    "name": "unit",
                    "description": "<p>A p5.sound or Web Audio object</p>\n",
                    "type": "Object"
                }
            ],
            "class": "p5.MonoSynth",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 11914,
            "description": "<p>Disconnect all outputs</p>\n",
            "itemtype": "method",
            "name": "disconnect",
            "class": "p5.MonoSynth",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 11922,
            "description": "<p>Get rid of the MonoSynth and free up its resources / memory.</p>\n",
            "itemtype": "method",
            "name": "dispose",
            "class": "p5.MonoSynth",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 11974,
            "description": "<p>An object that holds information about which notes have been played and\nwhich notes are currently being played. New notes are added as keys\non the fly. While a note has been attacked, but not released, the value of the\nkey is the audiovoice which is generating that note. When notes are released,\nthe value of the key becomes undefined.</p>\n",
            "itemtype": "property",
            "name": "notes",
            "class": "p5.PolySynth",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 11986,
            "description": "<p>A PolySynth must have at least 1 voice, defaults to 8</p>\n",
            "itemtype": "property",
            "name": "polyvalue",
            "class": "p5.PolySynth",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 11991,
            "description": "<p>Monosynth that generates the sound for each note that is triggered. The\np5.PolySynth defaults to using the p5.MonoSynth as its voice.</p>\n",
            "itemtype": "property",
            "name": "AudioVoice",
            "class": "p5.PolySynth",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 12022,
            "description": "<p>Play a note by triggering noteAttack and noteRelease with sustain time</p>\n",
            "itemtype": "method",
            "name": "play",
            "params": [
                {
                    "name": "note",
                    "description": "<p>midi note to play (ranging from 0 to 127 - 60 being a middle C)</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "velocity",
                    "description": "<p>velocity of the note to play (ranging from 0 to 1)</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "secondsFromNow",
                    "description": "<p>time from now (in seconds) at which to play</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "sustainTime",
                    "description": "<p>time to sustain before releasing the envelope</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "class": "p5.PolySynth",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 12036,
            "description": "<p>noteADSR sets the envelope for a specific note that has just been triggered.\nUsing this method modifies the envelope of whichever audiovoice is being used\nto play the desired note. The envelope should be reset before noteRelease is called\nin order to prevent the modified envelope from being used on other notes.</p>\n",
            "itemtype": "method",
            "name": "noteADSR",
            "params": [
                {
                    "name": "note",
                    "description": "<p>Midi note on which ADSR should be set.</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "attackTime",
                    "description": "<p>Time (in seconds before envelope\n                              reaches Attack Level</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "decayTime",
                    "description": "<p>Time (in seconds) before envelope\n                              reaches Decay/Sustain Level</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "susRatio",
                    "description": "<p>Ratio between attackLevel and releaseLevel, on a scale from 0 to 1,\n                              where 1.0 = attackLevel, 0.0 = releaseLevel.\n                              The susRatio determines the decayLevel and the level at which the\n                              sustain portion of the envelope will sustain.\n                              For example, if attackLevel is 0.4, releaseLevel is 0,\n                              and susAmt is 0.5, the decayLevel would be 0.2. If attackLevel is\n                              increased to 1.0 (using <code>setRange</code>),\n                              then decayLevel would increase proportionally, to become 0.5.</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "releaseTime",
                    "description": "<p>Time in seconds from now (defaults to 0)</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "class": "p5.PolySynth",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 12064,
            "description": "<p>Set the PolySynths global envelope. This method modifies the envelopes of each\nmonosynth so that all notes are played with this envelope.</p>\n",
            "itemtype": "method",
            "name": "setADSR",
            "params": [
                {
                    "name": "note",
                    "description": "<p>Midi note on which ADSR should be set.</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "attackTime",
                    "description": "<p>Time (in seconds before envelope\n                               reaches Attack Level</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "decayTime",
                    "description": "<p>Time (in seconds) before envelope\n                               reaches Decay/Sustain Level</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "susRatio",
                    "description": "<p>Ratio between attackLevel and releaseLevel, on a scale from 0 to 1,\n                               where 1.0 = attackLevel, 0.0 = releaseLevel.\n                               The susRatio determines the decayLevel and the level at which the\n                               sustain portion of the envelope will sustain.\n                               For example, if attackLevel is 0.4, releaseLevel is 0,\n                               and susAmt is 0.5, the decayLevel would be 0.2. If attackLevel is\n                               increased to 1.0 (using <code>setRange</code>),\n                               then decayLevel would increase proportionally, to become 0.5.</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "releaseTime",
                    "description": "<p>Time in seconds from now (defaults to 0)</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "class": "p5.PolySynth",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 12089,
            "description": "<p>Trigger the Attack, and Decay portion of a MonoSynth.\nSimilar to holding down a key on a piano, but it will\nhold the sustain level until you let go.</p>\n",
            "itemtype": "method",
            "name": "noteAttack",
            "params": [
                {
                    "name": "note",
                    "description": "<p>midi note on which attack should be triggered.</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "velocity",
                    "description": "<p>velocity of the note to play (ranging from 0 to 1)/</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "secondsFromNow",
                    "description": "<p>time from now (in seconds)</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "class": "p5.PolySynth",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 12162,
            "description": "<p>Trigger the Release of an AudioVoice note. This is similar to releasing\nthe key on a piano and letting the sound fade according to the\nrelease level and release time.</p>\n",
            "itemtype": "method",
            "name": "noteRelease",
            "params": [
                {
                    "name": "note",
                    "description": "<p>midi note on which attack should be triggered.</p>\n",
                    "type": "Number",
                    "optional": true
                },
                {
                    "name": "secondsFromNow",
                    "description": "<p>time to trigger the release</p>\n",
                    "type": "Number",
                    "optional": true
                }
            ],
            "class": "p5.PolySynth",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 12192,
            "description": "<p>Connect to a p5.sound / Web Audio object.</p>\n",
            "itemtype": "method",
            "name": "connect",
            "params": [
                {
                    "name": "unit",
                    "description": "<p>A p5.sound or Web Audio object</p>\n",
                    "type": "Object"
                }
            ],
            "class": "p5.PolySynth",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 12202,
            "description": "<p>Disconnect all outputs</p>\n",
            "itemtype": "method",
            "name": "disconnect",
            "class": "p5.PolySynth",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 12210,
            "description": "<p>Get rid of the MonoSynth and free up its resources / memory.</p>\n",
            "itemtype": "method",
            "name": "dispose",
            "class": "p5.PolySynth",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 12276,
            "description": "<p>The p5.Distortion is built with a\n<a href=\"http://www.w3.org/TR/webaudio/#WaveShaperNode\">\nWeb Audio WaveShaper Node</a>.</p>\n",
            "itemtype": "property",
            "name": "WaveShaperNode",
            "type": "AudioNode",
            "class": "p5.Distortion",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 12291,
            "description": "<p>Process a sound source, optionally specify amount and oversample values.</p>\n",
            "itemtype": "method",
            "name": "process",
            "params": [
                {
                    "name": "amount",
                    "description": "<p>Unbounded distortion amount.\n                               Normal values range from 0-1.</p>\n",
                    "type": "Number",
                    "optional": true,
                    "optdefault": "0.25"
                },
                {
                    "name": "oversample",
                    "description": "<p>&#39;none&#39;, &#39;2x&#39;, or &#39;4x&#39;.</p>\n",
                    "type": "String",
                    "optional": true,
                    "optdefault": "'none'"
                }
            ],
            "class": "p5.Distortion",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 12303,
            "description": "<p>Set the amount and oversample of the waveshaper distortion.</p>\n",
            "itemtype": "method",
            "name": "set",
            "params": [
                {
                    "name": "amount",
                    "description": "<p>Unbounded distortion amount.\n                               Normal values range from 0-1.</p>\n",
                    "type": "Number",
                    "optional": true,
                    "optdefault": "0.25"
                },
                {
                    "name": "oversample",
                    "description": "<p>&#39;none&#39;, &#39;2x&#39;, or &#39;4x&#39;.</p>\n",
                    "type": "String",
                    "optional": true,
                    "optdefault": "'none'"
                }
            ],
            "class": "p5.Distortion",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 12321,
            "description": "<p>Return the distortion amount, typically between 0-1.</p>\n",
            "itemtype": "method",
            "name": "getAmount",
            "return": {
                "description": "Unbounded distortion amount.\n                 Normal values range from 0-1.",
                "type": "Number"
            },
            "class": "p5.Distortion",
            "module": "p5.sound",
            "submodule": "p5.sound"
        },
        {
            "file": "lib/addons/p5.sound.js",
            "line": 12331,
            "description": "<p>Return the oversampling.</p>\n",
            "itemtype": "method",
            "name": "getOversample",
            "return": {
                "description": "Oversample can either be 'none', '2x', or '4x'.",
                "type": "String"
            },
            "class": "p5.Distortion",
            "module": "p5.sound",
            "submodule": "p5.sound"
        }
    ],
    "warnings": [
        {
            "message": "unknown tag: alt",
            "line": " src/color/creating_reading.js:16"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/color/creating_reading.js:61"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/color/creating_reading.js:91"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/color/creating_reading.js:121"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/color/creating_reading.js:320"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/color/creating_reading.js:351"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/color/creating_reading.js:388"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/color/creating_reading.js:485"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/color/creating_reading.js:515"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/color/creating_reading.js:555"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/color/p5.Color.js:54"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/color/p5.Color.js:83"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/color/p5.Color.js:110"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/color/p5.Color.js:137"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/color/p5.Color.js:164"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/color/p5.Color.js:595"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/color/setting.js:15"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/color/setting.js:185"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/color/setting.js:223"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/color/setting.js:344"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/color/setting.js:495"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/color/setting.js:536"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/color/setting.js:576"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/2d_primitives.js:16"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/2d_primitives.js:134"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/2d_primitives.js:190"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/2d_primitives.js:246"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/2d_primitives.js:281"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/2d_primitives.js:335"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/2d_primitives.js:406"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/attributes.js:14"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/attributes.js:83"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/attributes.js:111"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/attributes.js:180"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/attributes.js:209"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/attributes.js:246"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/attributes.js:313"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/constants.js:34"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/constants.js:53"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/constants.js:72"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/constants.js:91"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/constants.js:110"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/core.js:49"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/core.js:87"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/core.js:118"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/core.js:401"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/curves.js:13"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/curves.js:92"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/curves.js:119"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/curves.js:174"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/curves.js:253"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/curves.js:344"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/curves.js:371"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/curves.js:466"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/environment.js:22"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/environment.js:49"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/environment.js:77"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/environment.js:109"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/environment.js:170"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/environment.js:268"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/environment.js:293"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/environment.js:310"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/environment.js:327"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/environment.js:343"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/environment.js:359"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/environment.js:437"
        },
        {
            "message": "replacing incorrect tag: returns with return",
            "line": " src/core/environment.js:488"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/environment.js:488"
        },
        {
            "message": "replacing incorrect tag: returns with return",
            "line": " src/core/environment.js:534"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/environment.js:534"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/environment.js:591"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/environment.js:622"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/environment.js:645"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/p5.Element.js:53"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/p5.Element.js:118"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/p5.Element.js:155"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/p5.Element.js:190"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/p5.Element.js:240"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/p5.Element.js:289"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/p5.Element.js:355"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/p5.Element.js:408"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/p5.Element.js:462"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/p5.Element.js:521"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/p5.Element.js:564"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/p5.Element.js:631"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/p5.Element.js:666"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/p5.Element.js:708"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/p5.Element.js:757"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/p5.Element.js:798"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/p5.Element.js:848"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/p5.Element.js:886"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/p5.Element.js:924"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/rendering.js:16"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/rendering.js:116"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/rendering.js:169"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/rendering.js:192"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/rendering.js:231"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/structure.js:15"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/structure.js:77"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/structure.js:132"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/structure.js:211"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/structure.js:282"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/transform.js:14"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/transform.js:136"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/transform.js:162"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/transform.js:208"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/transform.js:240"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/transform.js:272"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/transform.js:304"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/transform.js:379"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/transform.js:421"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/transform.js:463"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/vertex.js:22"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/vertex.js:70"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/vertex.js:269"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/vertex.js:335"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/vertex.js:378"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/vertex.js:438"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/vertex.js:523"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/core/vertex.js:601"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/events/acceleration.js:91"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/events/acceleration.js:125"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/events/acceleration.js:158"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/events/acceleration.js:194"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/events/acceleration.js:239"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/events/acceleration.js:283"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/events/acceleration.js:376"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/events/acceleration.js:407"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/events/acceleration.js:466"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/events/keyboard.js:18"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/events/keyboard.js:45"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/events/keyboard.js:74"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/events/keyboard.js:107"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/events/keyboard.js:198"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/events/keyboard.js:254"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/events/keyboard.js:318"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/events/mouse.js:22"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/events/mouse.js:48"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/events/mouse.js:74"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/events/mouse.js:105"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/events/mouse.js:135"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/events/mouse.js:172"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/events/mouse.js:209"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/events/mouse.js:249"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/events/mouse.js:290"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/events/mouse.js:329"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/events/mouse.js:418"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/events/mouse.js:462"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/events/mouse.js:532"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/events/mouse.js:598"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/events/mouse.js:665"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/events/mouse.js:724"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/events/mouse.js:782"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/events/touch.js:57"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/events/touch.js:120"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/events/touch.js:182"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/image/image.js:18"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/image/image.js:98"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/image/image.js:178"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/image/loading_displaying.js:17"
        },
        {
            "message": "replacing incorrect tag: returns with return",
            "line": " src/image/loading_displaying.js:108"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/image/loading_displaying.js:125"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/image/loading_displaying.js:296"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/image/loading_displaying.js:391"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/image/loading_displaying.js:457"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/image/p5.Image.js:91"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/image/p5.Image.js:118"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/image/p5.Image.js:152"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/image/p5.Image.js:232"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/image/p5.Image.js:268"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/image/p5.Image.js:316"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/image/p5.Image.js:361"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/image/p5.Image.js:399"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/image/p5.Image.js:483"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/image/p5.Image.js:563"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/image/p5.Image.js:626"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/image/p5.Image.js:662"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/image/p5.Image.js:784"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/image/pixels.js:14"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/image/pixels.js:83"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/image/pixels.js:176"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/image/pixels.js:235"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/image/pixels.js:413"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/image/pixels.js:489"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/image/pixels.js:525"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/image/pixels.js:599"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/io/files.js:19"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/io/files.js:154"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/io/files.js:253"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/io/files.js:586"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/io/files.js:1290"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/io/files.js:1341"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/io/files.js:1402"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/io/p5.Table.js:57"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/io/p5.Table.js:120"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/io/p5.Table.js:168"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/io/p5.Table.js:214"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/io/p5.Table.js:263"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/io/p5.Table.js:328"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/io/p5.Table.js:491"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/io/p5.Table.js:544"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/io/p5.Table.js:586"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/io/p5.Table.js:746"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/io/p5.Table.js:812"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/io/p5.Table.js:861"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/io/p5.Table.js:922"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/io/p5.Table.js:969"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/io/p5.Table.js:1014"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/io/p5.Table.js:1063"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/io/p5.XML.js:11"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/math/calculation.js:12"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/math/calculation.js:36"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/math/calculation.js:76"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/math/calculation.js:121"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/math/calculation.js:190"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/math/calculation.js:240"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/math/calculation.js:279"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/math/calculation.js:324"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/math/calculation.js:379"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/math/calculation.js:418"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/math/calculation.js:474"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/math/calculation.js:524"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/math/calculation.js:574"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/math/calculation.js:627"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/math/calculation.js:661"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/math/calculation.js:700"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/math/calculation.js:747"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/math/math.js:12"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/math/noise.js:40"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/math/noise.js:187"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/math/noise.js:253"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/math/p5.Vector.js:13"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/math/random.js:48"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/math/random.js:79"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/math/random.js:166"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/math/trigonometry.js:134"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/math/trigonometry.js:174"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/math/trigonometry.js:206"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/math/trigonometry.js:238"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/math/trigonometry.js:320"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/typography/attributes.js:13"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/typography/attributes.js:59"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/typography/attributes.js:96"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/typography/attributes.js:127"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/typography/attributes.js:161"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/typography/loading_displaying.js:16"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/typography/loading_displaying.js:142"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/typography/loading_displaying.js:199"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/typography/p5.Font.js:45"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/utilities/conversion.js:12"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/utilities/string_functions.js:15"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/utilities/string_functions.js:44"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/utilities/string_functions.js:132"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/utilities/string_functions.js:237"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/utilities/string_functions.js:313"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/utilities/string_functions.js:375"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/utilities/string_functions.js:437"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/utilities/string_functions.js:526"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/utilities/time_date.js:12"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/utilities/time_date.js:34"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/utilities/time_date.js:56"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/utilities/time_date.js:78"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/utilities/time_date.js:101"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/utilities/time_date.js:123"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/utilities/time_date.js:145"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/webgl/camera.js:12"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/webgl/camera.js:159"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/webgl/camera.js:239"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/webgl/light.js:12"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/webgl/light.js:93"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/webgl/light.js:197"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/webgl/loading.js:14"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/webgl/loading.js:212"
        },
        {
            "message": "replacing incorrect tag: returns with return",
            "line": " src/webgl/material.js:56"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/webgl/material.js:56"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/webgl/material.js:145"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/webgl/material.js:178"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/webgl/material.js:273"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/webgl/material.js:320"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/webgl/p5.RendererGL.js:199"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/webgl/p5.RendererGL.js:438"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/webgl/p5.RendererGL.js:485"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/webgl/p5.RendererGL.js:525"
        },
        {
            "message": "unknown tag: alt",
            "line": " src/webgl/primitives.js:13"
        },
        {
            "message": "replacing incorrect tag: params with param",
            "line": " lib/addons/p5.sound.js:1567"
        },
        {
            "message": "replacing incorrect tag: returns with return",
            "line": " lib/addons/p5.sound.js:1567"
        },
        {
            "message": "replacing incorrect tag: returns with return",
            "line": " lib/addons/p5.sound.js:7272"
        },
        {
            "message": "replacing incorrect tag: returns with return",
            "line": " lib/addons/p5.sound.js:9222"
        },
        {
            "message": "Missing item type\nConversions adapted from <http://www.easyrgb.com/math.html>.\n\nIn these functions, hue is always in the range [0,1); all other components\nare in the range [0,1]. 'Brightness' and 'value' are used interchangeably.",
            "line": " src/color/color_conversion.js:10"
        },
        {
            "message": "Missing item type\nConvert an HSBA array to HSLA.",
            "line": " src/color/color_conversion.js:20"
        },
        {
            "message": "Missing item type\nConvert an HSBA array to RGBA.",
            "line": " src/color/color_conversion.js:46"
        },
        {
            "message": "Missing item type\nConvert an HSLA array to HSBA.",
            "line": " src/color/color_conversion.js:101"
        },
        {
            "message": "Missing item type\nConvert an HSLA array to RGBA.\n\nWe need to change basis from HSLA to something that can be more easily be\nprojected onto RGBA. We will choose hue and brightness as our first two\ncomponents, and pick a convenient third one ('zest') so that we don't need\nto calculate formal HSBA saturation.",
            "line": " src/color/color_conversion.js:124"
        },
        {
            "message": "Missing item type\nConvert an RGBA array to HSBA.",
            "line": " src/color/color_conversion.js:188"
        },
        {
            "message": "Missing item type\nConvert an RGBA array to HSLA.",
            "line": " src/color/color_conversion.js:227"
        },
        {
            "message": "Missing item type\nHue is the same in HSB and HSL, but the maximum value may be different.\nThis function will return the HSB-normalized saturation when supplied with\nan HSB color object, but will default to the HSL-normalized saturation\notherwise.",
            "line": " src/color/p5.Color.js:242"
        },
        {
            "message": "Missing item type\nSaturation is scaled differently in HSB and HSL. This function will return\nthe HSB saturation when supplied with an HSB color object, but will default\nto the HSL saturation otherwise.",
            "line": " src/color/p5.Color.js:273"
        },
        {
            "message": "Missing item type\nCSS named colors.",
            "line": " src/color/p5.Color.js:292"
        },
        {
            "message": "Missing item type\nThese regular expressions are used to build up the patterns for matching\nviable CSS color strings: fragmenting the regexes in this way increases the\nlegibility and comprehensibility of the code.\n\nNote that RGB values of .9 are not parsed by IE, but are supported here for\ncolor string consistency.",
            "line": " src/color/p5.Color.js:445"
        },
        {
            "message": "Missing item type\nFull color string patterns. The capture groups are necessary.",
            "line": " src/color/p5.Color.js:458"
        },
        {
            "message": "Missing item type\nFor a number of different inputs, returns a color formatted as [r, g, b, a]\narrays, with each component normalized between 0 and 1.",
            "line": " src/color/p5.Color.js:595"
        },
        {
            "message": "Missing item type\nFor HSB and HSL, interpret the gray level as a brightness/lightness\nvalue (they are equivalent when chroma is zero). For RGB, normalize the\ngray level according to the blue maximum.",
            "line": " src/color/p5.Color.js:812"
        },
        {
            "message": "Missing item type",
            "line": " src/core/canvas.js:1"
        },
        {
            "message": "Missing item type\nReturns the current framerate.",
            "line": " src/core/environment.js:242"
        },
        {
            "message": "Missing item type\nSpecifies the number of frames to be displayed every second. For example,\nthe function call frameRate(30) will attempt to refresh 30 times a second.\nIf the processor is not fast enough to maintain the specified rate, the\nframe rate will not be achieved. Setting the frame rate within setup() is\nrecommended. The default rate is 60 frames per second.\n\nCalling frameRate() with no arguments returns the current framerate.",
            "line": " src/core/environment.js:252"
        },
        {
            "message": "Missing item type",
            "line": " src/core/error_helpers.js:1"
        },
        {
            "message": "Missing item type\nPrints out a fancy, colorful message to the console log",
            "line": " src/core/error_helpers.js:65"
        },
        {
            "message": "Missing item type\nValidates parameters\nparam  {String}               func    the name of the function\nparam  {Array}                args    user input arguments\n\nexample:\n var a;\n ellipse(10,10,a,5);\nconsole ouput:\n \"It looks like ellipse received an empty variable in spot #2.\"\n\nexample:\n ellipse(10,\"foo\",5,5);\nconsole output:\n \"ellipse was expecting a number for parameter #1,\n          received \"foo\" instead.\"",
            "line": " src/core/error_helpers.js:397"
        },
        {
            "message": "Missing item type\nPrints out all the colors in the color pallete with white text.\nFor color blindness testing.",
            "line": " src/core/error_helpers.js:449"
        },
        {
            "message": "Missing item type\n_globalInit\n\nTODO: ???\nif sketch is on window\nassume \"global\" mode\nand instantiate p5 automatically\notherwise do nothing",
            "line": " src/core/init.js:5"
        },
        {
            "message": "Missing item type\nHelper fxn for sharing pixel methods",
            "line": " src/core/p5.Element.js:1059"
        },
        {
            "message": "Missing item type\nResize our canvas element.",
            "line": " src/core/p5.Renderer.js:63"
        },
        {
            "message": "Missing item type\nHelper fxn to check font type (system or otf)",
            "line": " src/core/p5.Renderer.js:132"
        },
        {
            "message": "Missing item type\nHelper fxn to measure ascent and descent.\nAdapted from http://stackoverflow.com/a/25355178",
            "line": " src/core/p5.Renderer.js:185"
        },
        {
            "message": "Missing item type\np5.Renderer2D\nThe 2D graphics canvas renderer class.\nextends p5.Renderer",
            "line": " src/core/p5.Renderer2D.js:10"
        },
        {
            "message": "Missing item type\nGenerate a cubic Bezier representing an arc on the unit circle of total\nangle `size` radians, beginning `start` radians above the x-axis. Up to\nfour of these curves are combined to make a full arc.\n\nSee www.joecridge.me/bezier.pdf for an explanation of the method.",
            "line": " src/core/p5.Renderer2D.js:404"
        },
        {
            "message": "Missing item type\nshim for Uint8ClampedArray.slice\n(allows arrayCopy to work with pixels[])\nwith thanks to http://halfpapstudios.com/blog/tag/html5-canvas/\nEnumerable set to false to protect for...in from\nUint8ClampedArray.prototype pollution.",
            "line": " src/core/shim.js:70"
        },
        {
            "message": "Missing item type\nprivate helper function to handle the user passing objects in\nduring construction or calls to create()",
            "line": " src/data/p5.TypedDict.js:187"
        },
        {
            "message": "Missing item type\nprivate helper function to ensure that the user passed in valid\nvalues for the Dictionary type",
            "line": " src/data/p5.TypedDict.js:367"
        },
        {
            "message": "Missing item type\nprivate helper function to ensure that the user passed in valid\nvalues for the Dictionary type",
            "line": " src/data/p5.TypedDict.js:414"
        },
        {
            "message": "Missing item type\nprivate helper function for finding lowest or highest value\nthe argument 'flip' is used to flip the comparison arrow\nfrom 'less than' to 'greater than'",
            "line": " src/data/p5.TypedDict.js:531"
        },
        {
            "message": "Missing item type\nprivate helper function for finding lowest or highest key\nthe argument 'flip' is used to flip the comparison arrow\nfrom 'less than' to 'greater than'",
            "line": " src/data/p5.TypedDict.js:596"
        },
        {
            "message": "Missing item type\n_updatePAccelerations updates the pAcceleration values",
            "line": " src/events/acceleration.js:80"
        },
        {
            "message": "Missing item type\nHolds the key codes of currently pressed keys.",
            "line": " src/events/keyboard.js:12"
        },
        {
            "message": "Missing item type\nThe onblur function is called when the user is no longer focused\non the p5 element. Because the keyup events will not fire if the user is\nnot focused on the element we must assume all keys currently down have\nbeen released.",
            "line": " src/events/keyboard.js:308"
        },
        {
            "message": "Missing item type\nThe checkDownKeys function returns a boolean true if any keys pressed\nand a false if no keys are currently pressed.\n\nHelps avoid instances where a multiple keys are pressed simultaneously and\nreleasing a single key will then switch the\nkeyIsPressed property to true.",
            "line": " src/events/keyboard.js:370"
        },
        {
            "message": "Missing item type\nThis module defines the filters for use with image buffers.\n\nThis module is basically a collection of functions stored in an object\nas opposed to modules. The functions are destructive, modifying\nthe passed in canvas rather than creating a copy.\n\nGenerally speaking users of this module will use the Filters.apply method\non a canvas to create an effect.\n\nA number of functions are borrowed/adapted from\nhttp://www.html5rocks.com/en/tutorials/canvas/imagefilters/\nor the java processing implementation.",
            "line": " src/image/filters.js:3"
        },
        {
            "message": "Missing item type\nReturns the pixel buffer for a canvas",
            "line": " src/image/filters.js:26"
        },
        {
            "message": "Missing item type\nReturns a 32 bit number containing ARGB data at ith pixel in the\n1D array containing pixels data.",
            "line": " src/image/filters.js:46"
        },
        {
            "message": "Missing item type\nModifies pixels RGBA values to values contained in the data object.",
            "line": " src/image/filters.js:67"
        },
        {
            "message": "Missing item type\nReturns the ImageData object for a canvas\nhttps://developer.mozilla.org/en-US/docs/Web/API/ImageData",
            "line": " src/image/filters.js:87"
        },
        {
            "message": "Missing item type\nReturns a blank ImageData object.",
            "line": " src/image/filters.js:107"
        },
        {
            "message": "Missing item type\nApplys a filter function to a canvas.\n\nThe difference between this and the actual filter functions defined below\nis that the filter functions generally modify the pixel buffer but do\nnot actually put that data back to the canvas (where it would actually\nupdate what is visible). By contrast this method does make the changes\nactually visible in the canvas.\n\nThe apply method is the method that callers of this module would generally\nuse. It has been separated from the actual filters to support an advanced\nuse case of creating a filter chain that executes without actually updating\nthe canvas in between everystep.",
            "line": " src/image/filters.js:122"
        },
        {
            "message": "Missing item type\nConverts the image to black and white pixels depending if they are above or\nbelow the threshold defined by the level parameter. The parameter must be\nbetween 0.0 (black) and 1.0 (white). If no level is specified, 0.5 is used.\n\nBorrowed from http://www.html5rocks.com/en/tutorials/canvas/imagefilters/",
            "line": " src/image/filters.js:159"
        },
        {
            "message": "Missing item type\nConverts any colors in the image to grayscale equivalents.\nNo parameter is used.\n\nBorrowed from http://www.html5rocks.com/en/tutorials/canvas/imagefilters/",
            "line": " src/image/filters.js:193"
        },
        {
            "message": "Missing item type\nSets the alpha channel to entirely opaque. No parameter is used.",
            "line": " src/image/filters.js:216"
        },
        {
            "message": "Missing item type\nSets each pixel to its inverse value. No parameter is used.",
            "line": " src/image/filters.js:232"
        },
        {
            "message": "Missing item type\nLimits each channel of the image to the number of colors specified as\nthe parameter. The parameter can be set to values between 2 and 255, but\nresults are most noticeable in the lower ranges.\n\nAdapted from java based processing implementation",
            "line": " src/image/filters.js:247"
        },
        {
            "message": "Missing item type\nreduces the bright areas in an image",
            "line": " src/image/filters.js:279"
        },
        {
            "message": "Missing item type\nincreases the bright areas in an image",
            "line": " src/image/filters.js:367"
        },
        {
            "message": "Missing item type\nThis module defines the p5 methods for the p5.Image class\nfor drawing images to the main display canvas.",
            "line": " src/image/image.js:8"
        },
        {
            "message": "Missing item type\nValidates clipping params. Per drawImage spec sWidth and sHight cannot be\nnegative or greater than image intrinsic width and height",
            "line": " src/image/loading_displaying.js:108"
        },
        {
            "message": "Missing item type\nApply the current tint color to the input image, return the resulting\ncanvas.",
            "line": " src/image/loading_displaying.js:420"
        },
        {
            "message": "Missing item type\nThis module defines the p5.Image class and P5 methods for\ndrawing images to the main display canvas.",
            "line": " src/image/p5.Image.js:9"
        },
        {
            "message": "Missing item type\nHelper fxn for sharing pixel methods",
            "line": " src/image/p5.Image.js:223"
        },
        {
            "message": "Missing item type\nGenerate a blob of file data as a url to prepare for download.\nAccepts an array of data, a filename, and an extension (optional).\nThis is a private function because it does not do any formatting,\nbut it is used by saveStrings, saveJSON, saveTable etc.",
            "line": " src/io/files.js:1527"
        },
        {
            "message": "Missing item type\nReturns a file extension, or another string\nif the provided parameter has no extension.",
            "line": " src/io/files.js:1595"
        },
        {
            "message": "Missing item type\nReturns true if the browser is Safari, false if not.\nSafari makes trouble for downloading files.",
            "line": " src/io/files.js:1628"
        },
        {
            "message": "Missing item type\nHelper function, a callback for download that deletes\nan invisible anchor element from the DOM once the file\nhas been automatically downloaded.",
            "line": " src/io/files.js:1640"
        },
        {
            "message": "Missing item type\nTable Options\n<p>Generic class for handling tabular data, typically from a\nCSV, TSV, or other sort of spreadsheet file.</p>\n<p>CSV files are\n<a href=\"http://en.wikipedia.org/wiki/Comma-separated_values\">\ncomma separated values</a>, often with the data in quotes. TSV\nfiles use tabs as separators, and usually don't bother with the\nquotes.</p>\n<p>File names should end with .csv if they're comma separated.</p>\n<p>A rough \"spec\" for CSV can be found\n<a href=\"http://tools.ietf.org/html/rfc4180\">here</a>.</p>\n<p>To load files, use the loadTable method.</p>\n<p>To save tables to your computer, use the save method\n or the saveTable method.</p>\n\nPossible options include:\n<ul>\n<li>csv - parse the table as comma-separated values\n<li>tsv - parse the table as tab-separated values\n<li>header - this table has a header (title) row\n</ul>",
            "line": " src/io/p5.Table.js:11"
        },
        {
            "message": "Missing item type\nThis method is called while the parsing of XML (when loadXML() is\ncalled). The difference between this method and the setContent()\nmethod defined later is that this one is used to set the content\nwhen the node in question has more nodes under it and so on and\nnot directly text content. While in the other one is used when\nthe node in question directly has text inside it.",
            "line": " src/io/p5.XML.js:767"
        },
        {
            "message": "Missing item type\nThis method is called while the parsing of XML (when loadXML() is\ncalled). The XML node is passed and its attributes are stored in the\np5.XML's attribute Object.",
            "line": " src/io/p5.XML.js:784"
        },
        {
            "message": "Missing item type\nMultiplies a vector by a scalar and returns a new vector.",
            "line": " src/math/p5.Vector.js:1090"
        },
        {
            "message": "Missing item type\nDivides a vector by a scalar and returns a new vector.",
            "line": " src/math/p5.Vector.js:1117"
        },
        {
            "message": "Missing item type\nCalculates the dot product of two vectors.",
            "line": " src/math/p5.Vector.js:1144"
        },
        {
            "message": "Missing item type\nCalculates the cross product of two vectors.",
            "line": " src/math/p5.Vector.js:1158"
        },
        {
            "message": "Missing item type\nCalculates the Euclidean distance between two points (considering a\npoint as a vector object).",
            "line": " src/math/p5.Vector.js:1172"
        },
        {
            "message": "Missing item type\nLinear interpolate a vector to another vector and return the result as a\nnew vector.",
            "line": " src/math/p5.Vector.js:1187"
        },
        {
            "message": "Missing item type\nHelper function to measure ascent and descent.",
            "line": " src/typography/attributes.js:251"
        },
        {
            "message": "Missing item type\nReturns the set of opentype glyphs for the supplied string.\n\nNote that there is not a strict one-to-one mapping between characters\nand glyphs, so the list of returned glyphs can be larger or smaller\n than the length of the given string.",
            "line": " src/typography/p5.Font.js:259"
        },
        {
            "message": "Missing item type\nReturns an opentype path for the supplied string and position.",
            "line": " src/typography/p5.Font.js:274"
        },
        {
            "message": "Missing item type\nParse OBJ lines into model. For reference, this is what a simple model of a\nsquare might look like:\n\nv -0.5 -0.5 0.5\nv -0.5 -0.5 -0.5\nv -0.5 0.5 -0.5\nv -0.5 0.5 0.5\n\nf 4 3 2 1",
            "line": " src/webgl/loading.js:103"
        },
        {
            "message": "Missing item type",
            "line": " src/webgl/material.js:367"
        },
        {
            "message": "Missing item type\nCreate a 2D array for establishing stroke connections",
            "line": " src/webgl/p5.Geometry.js:175"
        },
        {
            "message": "Missing item type\nCreate 4 vertices for each stroke line, two at the beginning position\nand two at the end position. These vertices are displaced relative to\nthat line's normal on the GPU",
            "line": " src/webgl/p5.Geometry.js:195"
        },
        {
            "message": "Missing item type",
            "line": " src/webgl/p5.Matrix.js:1"
        },
        {
            "message": "Missing item type\nPRIVATE",
            "line": " src/webgl/p5.Matrix.js:682"
        },
        {
            "message": "Missing item type\nWelcome to RendererGL Immediate Mode.\nImmediate mode is used for drawing custom shapes\nfrom a set of vertices.  Immediate Mode is activated\nwhen you call beginShape() & de-activated when you call endShape().\nImmediate mode is a style of programming borrowed\nfrom OpenGL's (now-deprecated) immediate mode.\nIt differs from p5.js' default, Retained Mode, which caches\ngeometries and buffers on the CPU to reduce the number of webgl\ndraw calls. Retained mode is more efficient & performative,\nhowever, Immediate Mode is useful for sketching quick\ngeometric ideas.",
            "line": " src/webgl/p5.RendererGL.Immediate.js:1"
        },
        {
            "message": "Missing item type\nEnd shape drawing and render vertices to screen.",
            "line": " src/webgl/p5.RendererGL.Immediate.js:104"
        },
        {
            "message": "Missing item type\ninitializes buffer defaults. runs each time a new geometry is\nregistered",
            "line": " src/webgl/p5.RendererGL.Retained.js:8"
        },
        {
            "message": "Missing item type\ncreateBuffers description",
            "line": " src/webgl/p5.RendererGL.Retained.js:47"
        },
        {
            "message": "Missing item type\nDraws buffers given a geometry key ID",
            "line": " src/webgl/p5.RendererGL.Retained.js:191"
        },
        {
            "message": "Missing item type\nmodel view, projection, & normal\nmatrices",
            "line": " src/webgl/p5.RendererGL.js:79"
        },
        {
            "message": "Missing item type\n[background description]",
            "line": " src/webgl/p5.RendererGL.js:416"
        },
        {
            "message": "Missing item type\n[resize description]",
            "line": " src/webgl/p5.RendererGL.js:652"
        },
        {
            "message": "Missing item type\nclears color and depth buffers\nwith r,g,b,a",
            "line": " src/webgl/p5.RendererGL.js:682"
        },
        {
            "message": "Missing item type\n[translate description]",
            "line": " src/webgl/p5.RendererGL.js:696"
        },
        {
            "message": "Missing item type\nScales the Model View Matrix by a vector",
            "line": " src/webgl/p5.RendererGL.js:715"
        },
        {
            "message": "Missing item type\npushes a copy of the model view matrix onto the\nMV Matrix stack.",
            "line": " src/webgl/p5.RendererGL.js:751"
        },
        {
            "message": "Missing item type\n[pop description]",
            "line": " src/webgl/p5.RendererGL.js:760"
        },
        {
            "message": "Missing item type\nturn a two dimensional array into one dimensional array",
            "line": " src/webgl/p5.RendererGL.js:991"
        },
        {
            "message": "Missing item type\nturn a p5.Vector Array into a one dimensional number array",
            "line": " src/webgl/p5.RendererGL.js:1028"
        },
        {
            "message": "Missing item type",
            "line": " src/webgl/primitives.js:250"
        },
        {
            "message": "Missing item type\nDraw a line given two points",
            "line": " src/webgl/primitives.js:938"
        },
        {
            "message": "Missing item type\nHelper function for select and selectAll",
            "line": " lib/addons/p5.dom.js:162"
        },
        {
            "message": "Missing item type\nHelper function for getElement and getElements.",
            "line": " lib/addons/p5.dom.js:178"
        },
        {
            "message": "Missing item type\nHelpers for create methods.",
            "line": " lib/addons/p5.dom.js:239"
        },
        {
            "message": "Missing item type",
            "line": " lib/addons/p5.dom.js:370"
        },
        {
            "message": "Missing item type",
            "line": " lib/addons/p5.dom.js:891"
        },
        {
            "message": "Missing item type",
            "line": " lib/addons/p5.dom.js:967"
        },
        {
            "message": "Missing item type",
            "line": " lib/addons/p5.dom.js:1007"
        },
        {
            "message": "Missing item type",
            "line": " lib/addons/p5.dom.js:2572"
        },
        {
            "message": "Missing item type",
            "line": " lib/addons/p5.dom.js:2638"
        },
        {
            "message": "Missing item type",
            "line": " lib/addons/p5.dom.js:2700"
        },
        {
            "message": "Missing item type\np5.sound\nhttps://p5js.org/reference/#/libraries/p5.sound\n\nFrom the Processing Foundation and contributors\nhttps://github.com/processing/p5.js-sound/graphs/contributors\n\nMIT License (MIT)\nhttps://github.com/processing/p5.js-sound/blob/master/LICENSE\n\nSome of the many audio libraries & resources that inspire p5.sound:\n - TONE.js (c) Yotam Mann. Licensed under The MIT License (MIT). https://github.com/TONEnoTONE/Tone.js\n - buzz.js (c) Jay Salvat. Licensed under The MIT License (MIT). http://buzz.jaysalvat.com/\n - Boris Smus Web Audio API book, 2013. Licensed under the Apache License http://www.apache.org/licenses/LICENSE-2.0\n - wavesurfer.js https://github.com/katspaugh/wavesurfer.js\n - Web Audio Components by Jordan Santell https://github.com/web-audio-components\n - Wilm Thoben's Sound library for Processing https://github.com/processing/processing/tree/master/java/libraries/sound\n\n Web Audio API: http://w3.org/TR/webaudio/",
            "line": " lib/addons/p5.sound.js:46"
        },
        {
            "message": "Missing item type\nDetermine which filetypes are supported (inspired by buzz.js)\nThe audio element (el) will only be used to test browser support for various audio formats",
            "line": " lib/addons/p5.sound.js:226"
        },
        {
            "message": "Missing item type\nMaster contains AudioContext and the master sound output.",
            "line": " lib/addons/p5.sound.js:296"
        },
        {
            "message": "Missing item type\na silent connection to the DesinationNode\nwhich will ensure that anything connected to it\nwill not be garbage collected",
            "line": " lib/addons/p5.sound.js:391"
        },
        {
            "message": "Missing item type",
            "line": " lib/addons/p5.sound.js:407"
        },
        {
            "message": "Missing item type\nUsed by Osc and Env to chain signal math",
            "line": " lib/addons/p5.sound.js:583"
        },
        {
            "message": "Missing item type\nThis is a helper function that the p5.SoundFile calls to load\nitself. Accepts a callback (the name of another function)\nas an optional parameter.",
            "line": " lib/addons/p5.sound.js:903"
        },
        {
            "message": "Missing item type\nStop playback on all of this soundfile's sources.",
            "line": " lib/addons/p5.sound.js:1304"
        },
        {
            "message": "Missing item type",
            "line": " lib/addons/p5.sound.js:1741"
        },
        {
            "message": "Missing item type",
            "line": " lib/addons/p5.sound.js:2022"
        },
        {
            "message": "Missing item type",
            "line": " lib/addons/p5.sound.js:3022"
        },
        {
            "message": "Missing item type",
            "line": " lib/addons/p5.sound.js:3399"
        },
        {
            "message": "Missing item type",
            "line": " lib/addons/p5.sound.js:3420"
        },
        {
            "message": "Missing item type",
            "line": " lib/addons/p5.sound.js:3479"
        },
        {
            "message": "Missing item type",
            "line": " lib/addons/p5.sound.js:3797"
        },
        {
            "message": "Missing item type",
            "line": " lib/addons/p5.sound.js:3969"
        },
        {
            "message": "Missing item type",
            "line": " lib/addons/p5.sound.js:4127"
        },
        {
            "message": "Missing item type",
            "line": " lib/addons/p5.sound.js:4168"
        },
        {
            "message": "Missing item type",
            "line": " lib/addons/p5.sound.js:4238"
        },
        {
            "message": "Missing item type",
            "line": " lib/addons/p5.sound.js:4426"
        },
        {
            "message": "Missing item type",
            "line": " lib/addons/p5.sound.js:4483"
        },
        {
            "message": "Missing item type",
            "line": " lib/addons/p5.sound.js:4651"
        },
        {
            "message": "Missing item type",
            "line": " lib/addons/p5.sound.js:4699"
        },
        {
            "message": "Missing item type",
            "line": " lib/addons/p5.sound.js:4730"
        },
        {
            "message": "Missing item type",
            "line": " lib/addons/p5.sound.js:4751"
        },
        {
            "message": "Missing item type",
            "line": " lib/addons/p5.sound.js:4771"
        },
        {
            "message": "Missing item type",
            "line": " lib/addons/p5.sound.js:5478"
        },
        {
            "message": "Missing item type",
            "line": " lib/addons/p5.sound.js:5681"
        },
        {
            "message": "Missing item type",
            "line": " lib/addons/p5.sound.js:7363"
        },
        {
            "message": "Missing item type",
            "line": " lib/addons/p5.sound.js:7379"
        },
        {
            "message": "Missing item type",
            "line": " lib/addons/p5.sound.js:7403"
        },
        {
            "message": "Missing item type",
            "line": " lib/addons/p5.sound.js:7429"
        },
        {
            "message": "Missing item type",
            "line": " lib/addons/p5.sound.js:7451"
        },
        {
            "message": "Missing item type",
            "line": " lib/addons/p5.sound.js:7473"
        },
        {
            "message": "Missing item type",
            "line": " lib/addons/p5.sound.js:7519"
        },
        {
            "message": "Missing item type",
            "line": " lib/addons/p5.sound.js:7550"
        },
        {
            "message": "Missing item type",
            "line": " lib/addons/p5.sound.js:7568"
        },
        {
            "message": "Missing item type",
            "line": " lib/addons/p5.sound.js:7905"
        },
        {
            "message": "Missing item type",
            "line": " lib/addons/p5.sound.js:7927"
        },
        {
            "message": "Missing item type\nThe p5.Effect class is built\n  using Tone.js CrossFade",
            "line": " lib/addons/p5.sound.js:7997"
        },
        {
            "message": "Missing item type\nIn classes that extend\np5.Effect, connect effect nodes\nto the wet parameter",
            "line": " lib/addons/p5.sound.js:8003"
        },
        {
            "message": "Missing item type\nEQFilter extends p5.Filter with constraints\nnecessary for the p5.EQ",
            "line": " lib/addons/p5.sound.js:8381"
        },
        {
            "message": "Missing item type\nInspired by Simple Reverb by Jordan Santell\nhttps://github.com/web-audio-components/simple-reverb/blob/master/index.js\n\nUtility function for building an impulse response\nbased on the module parameters.",
            "line": " lib/addons/p5.sound.js:9471"
        },
        {
            "message": "Missing item type\nPrivate method to load a buffer as an Impulse Response,\nassign it to the convolverNode, and add to the Array of .impulses.",
            "line": " lib/addons/p5.sound.js:9635"
        },
        {
            "message": "Missing item type",
            "line": " lib/addons/p5.sound.js:9821"
        },
        {
            "message": "Missing item type",
            "line": " lib/addons/p5.sound.js:9846"
        },
        {
            "message": "Missing item type\nmusicalTimeMode variables\nmodify these only when the interval is specified in musicalTime format as a string",
            "line": " lib/addons/p5.sound.js:10571"
        },
        {
            "message": "Missing item type\nDo not initiate the callback if timeFromNow is < 0\nThis ususually occurs for a few milliseconds when the page\nis not fully loaded\n\nThe callback should only be called until maxIterations is reached",
            "line": " lib/addons/p5.sound.js:10587"
        },
        {
            "message": "Missing item type\ncallback invoked when the recording is over",
            "line": " lib/addons/p5.sound.js:11072"
        },
        {
            "message": "Missing item type\ninternal method called on audio process",
            "line": " lib/addons/p5.sound.js:11158"
        },
        {
            "message": "Missing item type\nPrivate method to ensure accurate values of this._voicesInUse\nAny time a new value is scheduled, it is necessary to increment all subsequent\nscheduledValues after attack, and decrement all subsequent\nscheduledValues after release",
            "line": " lib/addons/p5.sound.js:12142"
        },
        {
            "message": "Missing item type\np5.sound\nhttps://p5js.org/reference/#/libraries/p5.sound\n\nFrom the Processing Foundation and contributors\nhttps://github.com/processing/p5.js-sound/graphs/contributors\n\nMIT License (MIT)\nhttps://github.com/processing/p5.js-sound/blob/master/LICENSE\n\nSome of the many audio libraries & resources that inspire p5.sound:\n - TONE.js (c) Yotam Mann. Licensed under The MIT License (MIT). https://github.com/TONEnoTONE/Tone.js\n - buzz.js (c) Jay Salvat. Licensed under The MIT License (MIT). http://buzz.jaysalvat.com/\n - Boris Smus Web Audio API book, 2013. Licensed under the Apache License http://www.apache.org/licenses/LICENSE-2.0\n - wavesurfer.js https://github.com/katspaugh/wavesurfer.js\n - Web Audio Components by Jordan Santell https://github.com/web-audio-components\n - Wilm Thoben's Sound library for Processing https://github.com/processing/processing/tree/master/java/libraries/sound\n\n Web Audio API: http://w3.org/TR/webaudio/",
            "line": " lib/addons/p5.sound.min.js:3"
        }
    ],
    "consts": {
        "RGB": [
            "p5.colorMode"
        ],
        "HSB": [
            "p5.colorMode"
        ],
        "HSL": [
            "p5.colorMode"
        ],
        "CHORD": [
            "p5.arc"
        ],
        "PIE": [
            "p5.arc"
        ],
        "OPEN": [
            "p5.arc"
        ],
        "CENTER": [
            "p5.ellipseMode",
            "p5.rectMode",
            "p5.imageMode",
            "p5.textAlign"
        ],
        "RADIUS": [
            "p5.ellipseMode",
            "p5.rectMode"
        ],
        "CORNER": [
            "p5.ellipseMode",
            "p5.rectMode",
            "p5.imageMode"
        ],
        "CORNERS": [
            "p5.ellipseMode",
            "p5.rectMode",
            "p5.imageMode"
        ],
        "SQUARE": [
            "p5.strokeCap"
        ],
        "PROJECT": [
            "p5.strokeCap"
        ],
        "ROUND": [
            "p5.strokeCap",
            "p5.strokeJoin"
        ],
        "MITER": [
            "p5.strokeJoin"
        ],
        "BEVEL": [
            "p5.strokeJoin"
        ],
        "ARROW": [
            "p5.cursor"
        ],
        "CROSS": [
            "p5.cursor"
        ],
        "HAND": [
            "p5.cursor"
        ],
        "MOVE": [
            "p5.cursor"
        ],
        "TEXT": [
            "p5.cursor"
        ],
        "WAIT": [
            "p5.cursor"
        ],
        "P2D": [
            "p5.createCanvas",
            "p5.createGraphics"
        ],
        "WEBGL": [
            "p5.createCanvas",
            "p5.createGraphics"
        ],
        "BLEND": [
            "p5.blendMode",
            "p5.Image.blend",
            "p5.blend"
        ],
        "DARKEST": [
            "p5.blendMode",
            "p5.Image.blend",
            "p5.blend"
        ],
        "LIGHTEST": [
            "p5.blendMode",
            "p5.Image.blend",
            "p5.blend"
        ],
        "DIFFERENCE": [
            "p5.blendMode",
            "p5.Image.blend",
            "p5.blend"
        ],
        "MULTIPLY": [
            "p5.blendMode",
            "p5.Image.blend",
            "p5.blend"
        ],
        "EXCLUSION": [
            "p5.blendMode",
            "p5.Image.blend",
            "p5.blend"
        ],
        "SCREEN": [
            "p5.blendMode",
            "p5.Image.blend",
            "p5.blend"
        ],
        "REPLACE": [
            "p5.blendMode",
            "p5.Image.blend",
            "p5.blend"
        ],
        "OVERLAY": [
            "p5.blendMode",
            "p5.Image.blend",
            "p5.blend"
        ],
        "HARD_LIGHT": [
            "p5.blendMode",
            "p5.Image.blend",
            "p5.blend"
        ],
        "SOFT_LIGHT": [
            "p5.blendMode",
            "p5.Image.blend",
            "p5.blend"
        ],
        "DODGE": [
            "p5.blendMode",
            "p5.Image.blend",
            "p5.blend"
        ],
        "BURN": [
            "p5.blendMode",
            "p5.Image.blend",
            "p5.blend"
        ],
        "ADD": [
            "p5.blendMode",
            "p5.Image.blend",
            "p5.blend"
        ],
        "NORMAL": [
            "p5.blendMode",
            "p5.Image.blend",
            "p5.blend",
            "p5.textStyle"
        ],
        "POINTS": [
            "p5.beginShape"
        ],
        "LINES": [
            "p5.beginShape"
        ],
        "TRIANGLES": [
            "p5.beginShape"
        ],
        "TRIANGLE_FAN": [
            "p5.beginShape"
        ],
        "TRIANGLE_STRIP": [
            "p5.beginShape"
        ],
        "QUADS": [
            "p5.beginShape"
        ],
        "QUAD_STRIP": [
            "p5.beginShape"
        ],
        "CLOSE": [
            "p5.endShape"
        ],
        "THRESHOLD": [
            "p5.Image.filter",
            "p5.filter"
        ],
        "GRAY": [
            "p5.Image.filter",
            "p5.filter"
        ],
        "OPAQUE": [
            "p5.Image.filter",
            "p5.filter"
        ],
        "INVERT": [
            "p5.Image.filter",
            "p5.filter"
        ],
        "POSTERIZE": [
            "p5.Image.filter",
            "p5.filter"
        ],
        "BLUR": [
            "p5.Image.filter",
            "p5.filter"
        ],
        "ERODE": [
            "p5.Image.filter",
            "p5.filter"
        ],
        "DILATE": [
            "p5.Image.filter",
            "p5.filter"
        ],
        "RADIANS": [
            "p5.angleMode"
        ],
        "DEGREES": [
            "p5.angleMode"
        ],
        "LEFT": [
            "p5.textAlign"
        ],
        "RIGHT": [
            "p5.textAlign"
        ],
        "TOP": [
            "p5.textAlign"
        ],
        "BOTTOM": [
            "p5.textAlign"
        ],
        "BASELINE": [
            "p5.textAlign"
        ],
        "ITALIC": [
            "p5.textStyle"
        ],
        "BOLD": [
            "p5.textStyle"
        ],
        "VIDEO": [
            "p5.dom.createCapture"
        ],
        "AUDIO": [
            "p5.dom.createCapture"
        ],
        "AUTO": [
            "p5.Element.size"
        ]
    }
}
},{}],2:[function(_dereq_,module,exports){
var lookup = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

;(function (exports) {
	'use strict';

  var Arr = (typeof Uint8Array !== 'undefined')
    ? Uint8Array
    : Array

	var PLUS   = '+'.charCodeAt(0)
	var SLASH  = '/'.charCodeAt(0)
	var NUMBER = '0'.charCodeAt(0)
	var LOWER  = 'a'.charCodeAt(0)
	var UPPER  = 'A'.charCodeAt(0)
	var PLUS_URL_SAFE = '-'.charCodeAt(0)
	var SLASH_URL_SAFE = '_'.charCodeAt(0)

	function decode (elt) {
		var code = elt.charCodeAt(0)
		if (code === PLUS ||
		    code === PLUS_URL_SAFE)
			return 62 // '+'
		if (code === SLASH ||
		    code === SLASH_URL_SAFE)
			return 63 // '/'
		if (code < NUMBER)
			return -1 //no match
		if (code < NUMBER + 10)
			return code - NUMBER + 26 + 26
		if (code < UPPER + 26)
			return code - UPPER
		if (code < LOWER + 26)
			return code - LOWER + 26
	}

	function b64ToByteArray (b64) {
		var i, j, l, tmp, placeHolders, arr

		if (b64.length % 4 > 0) {
			throw new Error('Invalid string. Length must be a multiple of 4')
		}

		// the number of equal signs (place holders)
		// if there are two placeholders, than the two characters before it
		// represent one byte
		// if there is only one, then the three characters before it represent 2 bytes
		// this is just a cheap hack to not do indexOf twice
		var len = b64.length
		placeHolders = '=' === b64.charAt(len - 2) ? 2 : '=' === b64.charAt(len - 1) ? 1 : 0

		// base64 is 4/3 + up to two characters of the original data
		arr = new Arr(b64.length * 3 / 4 - placeHolders)

		// if there are placeholders, only get up to the last complete 4 chars
		l = placeHolders > 0 ? b64.length - 4 : b64.length

		var L = 0

		function push (v) {
			arr[L++] = v
		}

		for (i = 0, j = 0; i < l; i += 4, j += 3) {
			tmp = (decode(b64.charAt(i)) << 18) | (decode(b64.charAt(i + 1)) << 12) | (decode(b64.charAt(i + 2)) << 6) | decode(b64.charAt(i + 3))
			push((tmp & 0xFF0000) >> 16)
			push((tmp & 0xFF00) >> 8)
			push(tmp & 0xFF)
		}

		if (placeHolders === 2) {
			tmp = (decode(b64.charAt(i)) << 2) | (decode(b64.charAt(i + 1)) >> 4)
			push(tmp & 0xFF)
		} else if (placeHolders === 1) {
			tmp = (decode(b64.charAt(i)) << 10) | (decode(b64.charAt(i + 1)) << 4) | (decode(b64.charAt(i + 2)) >> 2)
			push((tmp >> 8) & 0xFF)
			push(tmp & 0xFF)
		}

		return arr
	}

	function uint8ToBase64 (uint8) {
		var i,
			extraBytes = uint8.length % 3, // if we have 1 byte left, pad 2 bytes
			output = "",
			temp, length

		function encode (num) {
			return lookup.charAt(num)
		}

		function tripletToBase64 (num) {
			return encode(num >> 18 & 0x3F) + encode(num >> 12 & 0x3F) + encode(num >> 6 & 0x3F) + encode(num & 0x3F)
		}

		// go through the array every three bytes, we'll deal with trailing stuff later
		for (i = 0, length = uint8.length - extraBytes; i < length; i += 3) {
			temp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
			output += tripletToBase64(temp)
		}

		// pad the end with zeros, but make sure to not forget the extra bytes
		switch (extraBytes) {
			case 1:
				temp = uint8[uint8.length - 1]
				output += encode(temp >> 2)
				output += encode((temp << 4) & 0x3F)
				output += '=='
				break
			case 2:
				temp = (uint8[uint8.length - 2] << 8) + (uint8[uint8.length - 1])
				output += encode(temp >> 10)
				output += encode((temp >> 4) & 0x3F)
				output += encode((temp << 2) & 0x3F)
				output += '='
				break
		}

		return output
	}

	exports.toByteArray = b64ToByteArray
	exports.fromByteArray = uint8ToBase64
}(typeof exports === 'undefined' ? (this.base64js = {}) : exports))

},{}],3:[function(_dereq_,module,exports){

},{}],4:[function(_dereq_,module,exports){
(function (global){
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */

'use strict'

var base64 = _dereq_('base64-js')
var ieee754 = _dereq_('ieee754')
var isArray = _dereq_('isarray')

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50
Buffer.poolSize = 8192 // not used by this implementation

var rootParent = {}

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Safari 5-7 lacks support for changing the `Object.prototype.constructor` property
 *     on objects.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

function typedArraySupport () {
  function Bar () {}
  try {
    var arr = new Uint8Array(1)
    arr.foo = function () { return 42 }
    arr.constructor = Bar
    return arr.foo() === 42 && // typed array instances can be augmented
        arr.constructor === Bar && // constructor can be set
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

/**
 * Class: Buffer
 * =============
 *
 * The Buffer constructor returns instances of `Uint8Array` that are augmented
 * with function properties for all the node `Buffer` API functions. We use
 * `Uint8Array` so that square bracket notation works as expected -- it returns
 * a single octet.
 *
 * By augmenting the instances, we can avoid modifying the `Uint8Array`
 * prototype.
 */
function Buffer (arg) {
  if (!(this instanceof Buffer)) {
    // Avoid going through an ArgumentsAdaptorTrampoline in the common case.
    if (arguments.length > 1) return new Buffer(arg, arguments[1])
    return new Buffer(arg)
  }

  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    this.length = 0
    this.parent = undefined
  }

  // Common case.
  if (typeof arg === 'number') {
    return fromNumber(this, arg)
  }

  // Slightly less common case.
  if (typeof arg === 'string') {
    return fromString(this, arg, arguments.length > 1 ? arguments[1] : 'utf8')
  }

  // Unusual.
  return fromObject(this, arg)
}

function fromNumber (that, length) {
  that = allocate(that, length < 0 ? 0 : checked(length) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < length; i++) {
      that[i] = 0
    }
  }
  return that
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8'

  // Assumption: byteLength() return value is always < kMaxLength.
  var length = byteLength(string, encoding) | 0
  that = allocate(that, length)

  that.write(string, encoding)
  return that
}

function fromObject (that, object) {
  if (Buffer.isBuffer(object)) return fromBuffer(that, object)

  if (isArray(object)) return fromArray(that, object)

  if (object == null) {
    throw new TypeError('must start with number, buffer, array or string')
  }

  if (typeof ArrayBuffer !== 'undefined') {
    if (object.buffer instanceof ArrayBuffer) {
      return fromTypedArray(that, object)
    }
    if (object instanceof ArrayBuffer) {
      return fromArrayBuffer(that, object)
    }
  }

  if (object.length) return fromArrayLike(that, object)

  return fromJsonObject(that, object)
}

function fromBuffer (that, buffer) {
  var length = checked(buffer.length) | 0
  that = allocate(that, length)
  buffer.copy(that, 0, 0, length)
  return that
}

function fromArray (that, array) {
  var length = checked(array.length) | 0
  that = allocate(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

// Duplicate of fromArray() to keep fromArray() monomorphic.
function fromTypedArray (that, array) {
  var length = checked(array.length) | 0
  that = allocate(that, length)
  // Truncating the elements is probably not what people expect from typed
  // arrays with BYTES_PER_ELEMENT > 1 but it's compatible with the behavior
  // of the old Buffer constructor.
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array) {
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    array.byteLength
    that = Buffer._augment(new Uint8Array(array))
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromTypedArray(that, new Uint8Array(array))
  }
  return that
}

function fromArrayLike (that, array) {
  var length = checked(array.length) | 0
  that = allocate(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

// Deserialize { type: 'Buffer', data: [1,2,3,...] } into a Buffer object.
// Returns a zero-length buffer for inputs that don't conform to the spec.
function fromJsonObject (that, object) {
  var array
  var length = 0

  if (object.type === 'Buffer' && isArray(object.data)) {
    array = object.data
    length = checked(array.length) | 0
  }
  that = allocate(that, length)

  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
} else {
  // pre-set for values that may exist in the future
  Buffer.prototype.length = undefined
  Buffer.prototype.parent = undefined
}

function allocate (that, length) {
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = Buffer._augment(new Uint8Array(length))
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that.length = length
    that._isBuffer = true
  }

  var fromPool = length !== 0 && length <= Buffer.poolSize >>> 1
  if (fromPool) that.parent = rootParent

  return that
}

function checked (length) {
  // Note: cannot use `length < kMaxLength` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (subject, encoding) {
  if (!(this instanceof SlowBuffer)) return new SlowBuffer(subject, encoding)

  var buf = new Buffer(subject, encoding)
  delete buf.parent
  return buf
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  var i = 0
  var len = Math.min(x, y)
  while (i < len) {
    if (a[i] !== b[i]) break

    ++i
  }

  if (i !== len) {
    x = a[i]
    y = b[i]
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'binary':
    case 'base64':
    case 'raw':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) throw new TypeError('list argument must be an Array of Buffers.')

  if (list.length === 0) {
    return new Buffer(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; i++) {
      length += list[i].length
    }
  }

  var buf = new Buffer(length)
  var pos = 0
  for (i = 0; i < list.length; i++) {
    var item = list[i]
    item.copy(buf, pos)
    pos += item.length
  }
  return buf
}

function byteLength (string, encoding) {
  if (typeof string !== 'string') string = '' + string

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'binary':
      // Deprecated
      case 'raw':
      case 'raws':
        return len
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  start = start | 0
  end = end === undefined || end === Infinity ? this.length : end | 0

  if (!encoding) encoding = 'utf8'
  if (start < 0) start = 0
  if (end > this.length) end = this.length
  if (end <= start) return ''

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'binary':
        return binarySlice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return 0
  return Buffer.compare(this, b)
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset) {
  if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff
  else if (byteOffset < -0x80000000) byteOffset = -0x80000000
  byteOffset >>= 0

  if (this.length === 0) return -1
  if (byteOffset >= this.length) return -1

  // Negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = Math.max(this.length + byteOffset, 0)

  if (typeof val === 'string') {
    if (val.length === 0) return -1 // special case: looking for empty string always fails
    return String.prototype.indexOf.call(this, val, byteOffset)
  }
  if (Buffer.isBuffer(val)) {
    return arrayIndexOf(this, val, byteOffset)
  }
  if (typeof val === 'number') {
    if (Buffer.TYPED_ARRAY_SUPPORT && Uint8Array.prototype.indexOf === 'function') {
      return Uint8Array.prototype.indexOf.call(this, val, byteOffset)
    }
    return arrayIndexOf(this, [ val ], byteOffset)
  }

  function arrayIndexOf (arr, val, byteOffset) {
    var foundIndex = -1
    for (var i = 0; byteOffset + i < arr.length; i++) {
      if (arr[byteOffset + i] === val[foundIndex === -1 ? 0 : i - foundIndex]) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === val.length) return byteOffset + foundIndex
      } else {
        foundIndex = -1
      }
    }
    return -1
  }

  throw new TypeError('val must be string, number or Buffer')
}

// `get` is deprecated
Buffer.prototype.get = function get (offset) {
  console.log('.get() is deprecated. Access using array indexes instead.')
  return this.readUInt8(offset)
}

// `set` is deprecated
Buffer.prototype.set = function set (v, offset) {
  console.log('.set() is deprecated. Access using array indexes instead.')
  return this.writeUInt8(v, offset)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new Error('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; i++) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) throw new Error('Invalid hex string')
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function binaryWrite (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    var swap = encoding
    encoding = offset
    offset = length | 0
    length = swap
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'binary':
        return binaryWrite(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; i++) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function binarySlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; i++) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; i++) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = Buffer._augment(this.subarray(start, end))
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; i++) {
      newBuf[i] = this[i + start]
    }
  }

  if (newBuf.length) newBuf.parent = this.parent || this

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('buffer must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('value is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkInt(this, value, offset, byteLength, Math.pow(2, 8 * byteLength), 0)

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkInt(this, value, offset, byteLength, Math.pow(2, 8 * byteLength), 0)

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; i++) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; i++) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = value < 0 ? 1 : 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = value < 0 ? 1 : 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (value > max || value < min) throw new RangeError('value is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('index out of range')
  if (offset < 0) throw new RangeError('index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; i--) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; i++) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    target._set(this.subarray(start, start + len), targetStart)
  }

  return len
}

// fill(value, start=0, end=buffer.length)
Buffer.prototype.fill = function fill (value, start, end) {
  if (!value) value = 0
  if (!start) start = 0
  if (!end) end = this.length

  if (end < start) throw new RangeError('end < start')

  // Fill 0 bytes; we're done
  if (end === start) return
  if (this.length === 0) return

  if (start < 0 || start >= this.length) throw new RangeError('start out of bounds')
  if (end < 0 || end > this.length) throw new RangeError('end out of bounds')

  var i
  if (typeof value === 'number') {
    for (i = start; i < end; i++) {
      this[i] = value
    }
  } else {
    var bytes = utf8ToBytes(value.toString())
    var len = bytes.length
    for (i = start; i < end; i++) {
      this[i] = bytes[i % len]
    }
  }

  return this
}

/**
 * Creates a new `ArrayBuffer` with the *copied* memory of the buffer instance.
 * Added in Node 0.12. Only available in browsers that support ArrayBuffer.
 */
Buffer.prototype.toArrayBuffer = function toArrayBuffer () {
  if (typeof Uint8Array !== 'undefined') {
    if (Buffer.TYPED_ARRAY_SUPPORT) {
      return (new Buffer(this)).buffer
    } else {
      var buf = new Uint8Array(this.length)
      for (var i = 0, len = buf.length; i < len; i += 1) {
        buf[i] = this[i]
      }
      return buf.buffer
    }
  } else {
    throw new TypeError('Buffer.toArrayBuffer not supported in this browser')
  }
}

// HELPER FUNCTIONS
// ================

var BP = Buffer.prototype

/**
 * Augment a Uint8Array *instance* (not the Uint8Array class!) with Buffer methods
 */
Buffer._augment = function _augment (arr) {
  arr.constructor = Buffer
  arr._isBuffer = true

  // save reference to original Uint8Array set method before overwriting
  arr._set = arr.set

  // deprecated
  arr.get = BP.get
  arr.set = BP.set

  arr.write = BP.write
  arr.toString = BP.toString
  arr.toLocaleString = BP.toString
  arr.toJSON = BP.toJSON
  arr.equals = BP.equals
  arr.compare = BP.compare
  arr.indexOf = BP.indexOf
  arr.copy = BP.copy
  arr.slice = BP.slice
  arr.readUIntLE = BP.readUIntLE
  arr.readUIntBE = BP.readUIntBE
  arr.readUInt8 = BP.readUInt8
  arr.readUInt16LE = BP.readUInt16LE
  arr.readUInt16BE = BP.readUInt16BE
  arr.readUInt32LE = BP.readUInt32LE
  arr.readUInt32BE = BP.readUInt32BE
  arr.readIntLE = BP.readIntLE
  arr.readIntBE = BP.readIntBE
  arr.readInt8 = BP.readInt8
  arr.readInt16LE = BP.readInt16LE
  arr.readInt16BE = BP.readInt16BE
  arr.readInt32LE = BP.readInt32LE
  arr.readInt32BE = BP.readInt32BE
  arr.readFloatLE = BP.readFloatLE
  arr.readFloatBE = BP.readFloatBE
  arr.readDoubleLE = BP.readDoubleLE
  arr.readDoubleBE = BP.readDoubleBE
  arr.writeUInt8 = BP.writeUInt8
  arr.writeUIntLE = BP.writeUIntLE
  arr.writeUIntBE = BP.writeUIntBE
  arr.writeUInt16LE = BP.writeUInt16LE
  arr.writeUInt16BE = BP.writeUInt16BE
  arr.writeUInt32LE = BP.writeUInt32LE
  arr.writeUInt32BE = BP.writeUInt32BE
  arr.writeIntLE = BP.writeIntLE
  arr.writeIntBE = BP.writeIntBE
  arr.writeInt8 = BP.writeInt8
  arr.writeInt16LE = BP.writeInt16LE
  arr.writeInt16BE = BP.writeInt16BE
  arr.writeInt32LE = BP.writeInt32LE
  arr.writeInt32BE = BP.writeInt32BE
  arr.writeFloatLE = BP.writeFloatLE
  arr.writeFloatBE = BP.writeFloatBE
  arr.writeDoubleLE = BP.writeDoubleLE
  arr.writeDoubleBE = BP.writeDoubleBE
  arr.fill = BP.fill
  arr.inspect = BP.inspect
  arr.toArrayBuffer = BP.toArrayBuffer

  return arr
}

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; i++) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; i++) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; i++) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; i++) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"base64-js":2,"ieee754":8,"isarray":9}],5:[function(_dereq_,module,exports){
(function (process,global){
/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   4.1.1
 */

(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.ES6Promise = factory());
}(this, (function () { 'use strict';

function objectOrFunction(x) {
  var type = typeof x;
  return x !== null && (type === 'object' || type === 'function');
}

function isFunction(x) {
  return typeof x === 'function';
}

var _isArray = undefined;
if (Array.isArray) {
  _isArray = Array.isArray;
} else {
  _isArray = function (x) {
    return Object.prototype.toString.call(x) === '[object Array]';
  };
}

var isArray = _isArray;

var len = 0;
var vertxNext = undefined;
var customSchedulerFn = undefined;

var asap = function asap(callback, arg) {
  queue[len] = callback;
  queue[len + 1] = arg;
  len += 2;
  if (len === 2) {
    // If len is 2, that means that we need to schedule an async flush.
    // If additional callbacks are queued before the queue is flushed, they
    // will be processed by this flush that we are scheduling.
    if (customSchedulerFn) {
      customSchedulerFn(flush);
    } else {
      scheduleFlush();
    }
  }
};

function setScheduler(scheduleFn) {
  customSchedulerFn = scheduleFn;
}

function setAsap(asapFn) {
  asap = asapFn;
}

var browserWindow = typeof window !== 'undefined' ? window : undefined;
var browserGlobal = browserWindow || {};
var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && ({}).toString.call(process) === '[object process]';

// test for web worker but not in IE10
var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';

// node
function useNextTick() {
  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
  // see https://github.com/cujojs/when/issues/410 for details
  return function () {
    return process.nextTick(flush);
  };
}

// vertx
function useVertxTimer() {
  if (typeof vertxNext !== 'undefined') {
    return function () {
      vertxNext(flush);
    };
  }

  return useSetTimeout();
}

function useMutationObserver() {
  var iterations = 0;
  var observer = new BrowserMutationObserver(flush);
  var node = document.createTextNode('');
  observer.observe(node, { characterData: true });

  return function () {
    node.data = iterations = ++iterations % 2;
  };
}

// web worker
function useMessageChannel() {
  var channel = new MessageChannel();
  channel.port1.onmessage = flush;
  return function () {
    return channel.port2.postMessage(0);
  };
}

function useSetTimeout() {
  // Store setTimeout reference so es6-promise will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var globalSetTimeout = setTimeout;
  return function () {
    return globalSetTimeout(flush, 1);
  };
}

var queue = new Array(1000);
function flush() {
  for (var i = 0; i < len; i += 2) {
    var callback = queue[i];
    var arg = queue[i + 1];

    callback(arg);

    queue[i] = undefined;
    queue[i + 1] = undefined;
  }

  len = 0;
}

function attemptVertx() {
  try {
    var r = _dereq_;
    var vertx = r('vertx');
    vertxNext = vertx.runOnLoop || vertx.runOnContext;
    return useVertxTimer();
  } catch (e) {
    return useSetTimeout();
  }
}

var scheduleFlush = undefined;
// Decide what async method to use to triggering processing of queued callbacks:
if (isNode) {
  scheduleFlush = useNextTick();
} else if (BrowserMutationObserver) {
  scheduleFlush = useMutationObserver();
} else if (isWorker) {
  scheduleFlush = useMessageChannel();
} else if (browserWindow === undefined && typeof _dereq_ === 'function') {
  scheduleFlush = attemptVertx();
} else {
  scheduleFlush = useSetTimeout();
}

function then(onFulfillment, onRejection) {
  var _arguments = arguments;

  var parent = this;

  var child = new this.constructor(noop);

  if (child[PROMISE_ID] === undefined) {
    makePromise(child);
  }

  var _state = parent._state;

  if (_state) {
    (function () {
      var callback = _arguments[_state - 1];
      asap(function () {
        return invokeCallback(_state, child, callback, parent._result);
      });
    })();
  } else {
    subscribe(parent, child, onFulfillment, onRejection);
  }

  return child;
}

/**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/
function resolve$1(object) {
  /*jshint validthis:true */
  var Constructor = this;

  if (object && typeof object === 'object' && object.constructor === Constructor) {
    return object;
  }

  var promise = new Constructor(noop);
  resolve(promise, object);
  return promise;
}

var PROMISE_ID = Math.random().toString(36).substring(16);

function noop() {}

var PENDING = void 0;
var FULFILLED = 1;
var REJECTED = 2;

var GET_THEN_ERROR = new ErrorObject();

function selfFulfillment() {
  return new TypeError("You cannot resolve a promise with itself");
}

function cannotReturnOwn() {
  return new TypeError('A promises callback cannot return that same promise.');
}

function getThen(promise) {
  try {
    return promise.then;
  } catch (error) {
    GET_THEN_ERROR.error = error;
    return GET_THEN_ERROR;
  }
}

function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
  try {
    then$$1.call(value, fulfillmentHandler, rejectionHandler);
  } catch (e) {
    return e;
  }
}

function handleForeignThenable(promise, thenable, then$$1) {
  asap(function (promise) {
    var sealed = false;
    var error = tryThen(then$$1, thenable, function (value) {
      if (sealed) {
        return;
      }
      sealed = true;
      if (thenable !== value) {
        resolve(promise, value);
      } else {
        fulfill(promise, value);
      }
    }, function (reason) {
      if (sealed) {
        return;
      }
      sealed = true;

      reject(promise, reason);
    }, 'Settle: ' + (promise._label || ' unknown promise'));

    if (!sealed && error) {
      sealed = true;
      reject(promise, error);
    }
  }, promise);
}

function handleOwnThenable(promise, thenable) {
  if (thenable._state === FULFILLED) {
    fulfill(promise, thenable._result);
  } else if (thenable._state === REJECTED) {
    reject(promise, thenable._result);
  } else {
    subscribe(thenable, undefined, function (value) {
      return resolve(promise, value);
    }, function (reason) {
      return reject(promise, reason);
    });
  }
}

function handleMaybeThenable(promise, maybeThenable, then$$1) {
  if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) {
    handleOwnThenable(promise, maybeThenable);
  } else {
    if (then$$1 === GET_THEN_ERROR) {
      reject(promise, GET_THEN_ERROR.error);
      GET_THEN_ERROR.error = null;
    } else if (then$$1 === undefined) {
      fulfill(promise, maybeThenable);
    } else if (isFunction(then$$1)) {
      handleForeignThenable(promise, maybeThenable, then$$1);
    } else {
      fulfill(promise, maybeThenable);
    }
  }
}

function resolve(promise, value) {
  if (promise === value) {
    reject(promise, selfFulfillment());
  } else if (objectOrFunction(value)) {
    handleMaybeThenable(promise, value, getThen(value));
  } else {
    fulfill(promise, value);
  }
}

function publishRejection(promise) {
  if (promise._onerror) {
    promise._onerror(promise._result);
  }

  publish(promise);
}

function fulfill(promise, value) {
  if (promise._state !== PENDING) {
    return;
  }

  promise._result = value;
  promise._state = FULFILLED;

  if (promise._subscribers.length !== 0) {
    asap(publish, promise);
  }
}

function reject(promise, reason) {
  if (promise._state !== PENDING) {
    return;
  }
  promise._state = REJECTED;
  promise._result = reason;

  asap(publishRejection, promise);
}

function subscribe(parent, child, onFulfillment, onRejection) {
  var _subscribers = parent._subscribers;
  var length = _subscribers.length;

  parent._onerror = null;

  _subscribers[length] = child;
  _subscribers[length + FULFILLED] = onFulfillment;
  _subscribers[length + REJECTED] = onRejection;

  if (length === 0 && parent._state) {
    asap(publish, parent);
  }
}

function publish(promise) {
  var subscribers = promise._subscribers;
  var settled = promise._state;

  if (subscribers.length === 0) {
    return;
  }

  var child = undefined,
      callback = undefined,
      detail = promise._result;

  for (var i = 0; i < subscribers.length; i += 3) {
    child = subscribers[i];
    callback = subscribers[i + settled];

    if (child) {
      invokeCallback(settled, child, callback, detail);
    } else {
      callback(detail);
    }
  }

  promise._subscribers.length = 0;
}

function ErrorObject() {
  this.error = null;
}

var TRY_CATCH_ERROR = new ErrorObject();

function tryCatch(callback, detail) {
  try {
    return callback(detail);
  } catch (e) {
    TRY_CATCH_ERROR.error = e;
    return TRY_CATCH_ERROR;
  }
}

function invokeCallback(settled, promise, callback, detail) {
  var hasCallback = isFunction(callback),
      value = undefined,
      error = undefined,
      succeeded = undefined,
      failed = undefined;

  if (hasCallback) {
    value = tryCatch(callback, detail);

    if (value === TRY_CATCH_ERROR) {
      failed = true;
      error = value.error;
      value.error = null;
    } else {
      succeeded = true;
    }

    if (promise === value) {
      reject(promise, cannotReturnOwn());
      return;
    }
  } else {
    value = detail;
    succeeded = true;
  }

  if (promise._state !== PENDING) {
    // noop
  } else if (hasCallback && succeeded) {
      resolve(promise, value);
    } else if (failed) {
      reject(promise, error);
    } else if (settled === FULFILLED) {
      fulfill(promise, value);
    } else if (settled === REJECTED) {
      reject(promise, value);
    }
}

function initializePromise(promise, resolver) {
  try {
    resolver(function resolvePromise(value) {
      resolve(promise, value);
    }, function rejectPromise(reason) {
      reject(promise, reason);
    });
  } catch (e) {
    reject(promise, e);
  }
}

var id = 0;
function nextId() {
  return id++;
}

function makePromise(promise) {
  promise[PROMISE_ID] = id++;
  promise._state = undefined;
  promise._result = undefined;
  promise._subscribers = [];
}

function Enumerator$1(Constructor, input) {
  this._instanceConstructor = Constructor;
  this.promise = new Constructor(noop);

  if (!this.promise[PROMISE_ID]) {
    makePromise(this.promise);
  }

  if (isArray(input)) {
    this.length = input.length;
    this._remaining = input.length;

    this._result = new Array(this.length);

    if (this.length === 0) {
      fulfill(this.promise, this._result);
    } else {
      this.length = this.length || 0;
      this._enumerate(input);
      if (this._remaining === 0) {
        fulfill(this.promise, this._result);
      }
    }
  } else {
    reject(this.promise, validationError());
  }
}

function validationError() {
  return new Error('Array Methods must be provided an Array');
}

Enumerator$1.prototype._enumerate = function (input) {
  for (var i = 0; this._state === PENDING && i < input.length; i++) {
    this._eachEntry(input[i], i);
  }
};

Enumerator$1.prototype._eachEntry = function (entry, i) {
  var c = this._instanceConstructor;
  var resolve$$1 = c.resolve;

  if (resolve$$1 === resolve$1) {
    var _then = getThen(entry);

    if (_then === then && entry._state !== PENDING) {
      this._settledAt(entry._state, i, entry._result);
    } else if (typeof _then !== 'function') {
      this._remaining--;
      this._result[i] = entry;
    } else if (c === Promise$2) {
      var promise = new c(noop);
      handleMaybeThenable(promise, entry, _then);
      this._willSettleAt(promise, i);
    } else {
      this._willSettleAt(new c(function (resolve$$1) {
        return resolve$$1(entry);
      }), i);
    }
  } else {
    this._willSettleAt(resolve$$1(entry), i);
  }
};

Enumerator$1.prototype._settledAt = function (state, i, value) {
  var promise = this.promise;

  if (promise._state === PENDING) {
    this._remaining--;

    if (state === REJECTED) {
      reject(promise, value);
    } else {
      this._result[i] = value;
    }
  }

  if (this._remaining === 0) {
    fulfill(promise, this._result);
  }
};

Enumerator$1.prototype._willSettleAt = function (promise, i) {
  var enumerator = this;

  subscribe(promise, undefined, function (value) {
    return enumerator._settledAt(FULFILLED, i, value);
  }, function (reason) {
    return enumerator._settledAt(REJECTED, i, reason);
  });
};

/**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/
function all$1(entries) {
  return new Enumerator$1(this, entries).promise;
}

/**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/
function race$1(entries) {
  /*jshint validthis:true */
  var Constructor = this;

  if (!isArray(entries)) {
    return new Constructor(function (_, reject) {
      return reject(new TypeError('You must pass an array to race.'));
    });
  } else {
    return new Constructor(function (resolve, reject) {
      var length = entries.length;
      for (var i = 0; i < length; i++) {
        Constructor.resolve(entries[i]).then(resolve, reject);
      }
    });
  }
}

/**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/
function reject$1(reason) {
  /*jshint validthis:true */
  var Constructor = this;
  var promise = new Constructor(noop);
  reject(promise, reason);
  return promise;
}

function needsResolver() {
  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
}

function needsNew() {
  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
}

/**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {function} resolver
  Useful for tooling.
  @constructor
*/
function Promise$2(resolver) {
  this[PROMISE_ID] = nextId();
  this._result = this._state = undefined;
  this._subscribers = [];

  if (noop !== resolver) {
    typeof resolver !== 'function' && needsResolver();
    this instanceof Promise$2 ? initializePromise(this, resolver) : needsNew();
  }
}

Promise$2.all = all$1;
Promise$2.race = race$1;
Promise$2.resolve = resolve$1;
Promise$2.reject = reject$1;
Promise$2._setScheduler = setScheduler;
Promise$2._setAsap = setAsap;
Promise$2._asap = asap;

Promise$2.prototype = {
  constructor: Promise$2,

  /**
    The primary way of interacting with a promise is through its `then` method,
    which registers callbacks to receive either a promise's eventual value or the
    reason why the promise cannot be fulfilled.
  
    ```js
    findUser().then(function(user){
      // user is available
    }, function(reason){
      // user is unavailable, and you are given the reason why
    });
    ```
  
    Chaining
    --------
  
    The return value of `then` is itself a promise.  This second, 'downstream'
    promise is resolved with the return value of the first promise's fulfillment
    or rejection handler, or rejected if the handler throws an exception.
  
    ```js
    findUser().then(function (user) {
      return user.name;
    }, function (reason) {
      return 'default name';
    }).then(function (userName) {
      // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
      // will be `'default name'`
    });
  
    findUser().then(function (user) {
      throw new Error('Found user, but still unhappy');
    }, function (reason) {
      throw new Error('`findUser` rejected and we're unhappy');
    }).then(function (value) {
      // never reached
    }, function (reason) {
      // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
      // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
    });
    ```
    If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
  
    ```js
    findUser().then(function (user) {
      throw new PedagogicalException('Upstream error');
    }).then(function (value) {
      // never reached
    }).then(function (value) {
      // never reached
    }, function (reason) {
      // The `PedgagocialException` is propagated all the way down to here
    });
    ```
  
    Assimilation
    ------------
  
    Sometimes the value you want to propagate to a downstream promise can only be
    retrieved asynchronously. This can be achieved by returning a promise in the
    fulfillment or rejection handler. The downstream promise will then be pending
    until the returned promise is settled. This is called *assimilation*.
  
    ```js
    findUser().then(function (user) {
      return findCommentsByAuthor(user);
    }).then(function (comments) {
      // The user's comments are now available
    });
    ```
  
    If the assimliated promise rejects, then the downstream promise will also reject.
  
    ```js
    findUser().then(function (user) {
      return findCommentsByAuthor(user);
    }).then(function (comments) {
      // If `findCommentsByAuthor` fulfills, we'll have the value here
    }, function (reason) {
      // If `findCommentsByAuthor` rejects, we'll have the reason here
    });
    ```
  
    Simple Example
    --------------
  
    Synchronous Example
  
    ```javascript
    let result;
  
    try {
      result = findResult();
      // success
    } catch(reason) {
      // failure
    }
    ```
  
    Errback Example
  
    ```js
    findResult(function(result, err){
      if (err) {
        // failure
      } else {
        // success
      }
    });
    ```
  
    Promise Example;
  
    ```javascript
    findResult().then(function(result){
      // success
    }, function(reason){
      // failure
    });
    ```
  
    Advanced Example
    --------------
  
    Synchronous Example
  
    ```javascript
    let author, books;
  
    try {
      author = findAuthor();
      books  = findBooksByAuthor(author);
      // success
    } catch(reason) {
      // failure
    }
    ```
  
    Errback Example
  
    ```js
  
    function foundBooks(books) {
  
    }
  
    function failure(reason) {
  
    }
  
    findAuthor(function(author, err){
      if (err) {
        failure(err);
        // failure
      } else {
        try {
          findBoooksByAuthor(author, function(books, err) {
            if (err) {
              failure(err);
            } else {
              try {
                foundBooks(books);
              } catch(reason) {
                failure(reason);
              }
            }
          });
        } catch(error) {
          failure(err);
        }
        // success
      }
    });
    ```
  
    Promise Example;
  
    ```javascript
    findAuthor().
      then(findBooksByAuthor).
      then(function(books){
        // found books
    }).catch(function(reason){
      // something went wrong
    });
    ```
  
    @method then
    @param {Function} onFulfilled
    @param {Function} onRejected
    Useful for tooling.
    @return {Promise}
  */
  then: then,

  /**
    `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
    as the catch block of a try/catch statement.
  
    ```js
    function findAuthor(){
      throw new Error('couldn't find that author');
    }
  
    // synchronous
    try {
      findAuthor();
    } catch(reason) {
      // something went wrong
    }
  
    // async with promises
    findAuthor().catch(function(reason){
      // something went wrong
    });
    ```
  
    @method catch
    @param {Function} onRejection
    Useful for tooling.
    @return {Promise}
  */
  'catch': function _catch(onRejection) {
    return this.then(null, onRejection);
  }
};

/*global self*/
function polyfill$1() {
    var local = undefined;

    if (typeof global !== 'undefined') {
        local = global;
    } else if (typeof self !== 'undefined') {
        local = self;
    } else {
        try {
            local = Function('return this')();
        } catch (e) {
            throw new Error('polyfill failed because global object is unavailable in this environment');
        }
    }

    var P = local.Promise;

    if (P) {
        var promiseToString = null;
        try {
            promiseToString = Object.prototype.toString.call(P.resolve());
        } catch (e) {
            // silently ignored
        }

        if (promiseToString === '[object Promise]' && !P.cast) {
            return;
        }
    }

    local.Promise = Promise$2;
}

// Strange compat..
Promise$2.polyfill = polyfill$1;
Promise$2.Promise = Promise$2;

return Promise$2;

})));



}).call(this,_dereq_('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"_process":11}],6:[function(_dereq_,module,exports){
(function (global, factory) {
  if (typeof define === 'function' && define.amd) {
    define(['exports', 'module'], factory);
  } else if (typeof exports !== 'undefined' && typeof module !== 'undefined') {
    factory(exports, module);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, mod);
    global.fetchJsonp = mod.exports;
  }
})(this, function (exports, module) {
  'use strict';

  var defaultOptions = {
    timeout: 5000,
    jsonpCallback: 'callback',
    jsonpCallbackFunction: null
  };

  function generateCallbackFunction() {
    return 'jsonp_' + Date.now() + '_' + Math.ceil(Math.random() * 100000);
  }

  function clearFunction(functionName) {
    // IE8 throws an exception when you try to delete a property on window
    // http://stackoverflow.com/a/1824228/751089
    try {
      delete window[functionName];
    } catch (e) {
      window[functionName] = undefined;
    }
  }

  function removeScript(scriptId) {
    var script = document.getElementById(scriptId);
    if (script) {
      document.getElementsByTagName('head')[0].removeChild(script);
    }
  }

  function fetchJsonp(_url) {
    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    // to avoid param reassign
    var url = _url;
    var timeout = options.timeout || defaultOptions.timeout;
    var jsonpCallback = options.jsonpCallback || defaultOptions.jsonpCallback;

    var timeoutId = undefined;

    return new Promise(function (resolve, reject) {
      var callbackFunction = options.jsonpCallbackFunction || generateCallbackFunction();
      var scriptId = jsonpCallback + '_' + callbackFunction;

      window[callbackFunction] = function (response) {
        resolve({
          ok: true,
          // keep consistent with fetch API
          json: function json() {
            return Promise.resolve(response);
          }
        });

        if (timeoutId) clearTimeout(timeoutId);

        removeScript(scriptId);

        clearFunction(callbackFunction);
      };

      // Check if the user set their own params, and if not add a ? to start a list of params
      url += url.indexOf('?') === -1 ? '?' : '&';

      var jsonpScript = document.createElement('script');
      jsonpScript.setAttribute('src', '' + url + jsonpCallback + '=' + callbackFunction);
      if (options.charset) {
        jsonpScript.setAttribute('charset', options.charset);
      }
      jsonpScript.id = scriptId;
      document.getElementsByTagName('head')[0].appendChild(jsonpScript);

      timeoutId = setTimeout(function () {
        reject(new Error('JSONP request to ' + _url + ' timed out'));

        clearFunction(callbackFunction);
        removeScript(scriptId);
        window[callbackFunction] = function () {
          clearFunction(callbackFunction);
        };
      }, timeout);

      // Caught if got 404/500
      jsonpScript.onerror = function () {
        reject(new Error('JSONP request to ' + _url + ' failed'));

        clearFunction(callbackFunction);
        removeScript(scriptId);
        if (timeoutId) clearTimeout(timeoutId);
      };
    });
  }

  // export as global function
  /*
  let local;
  if (typeof global !== 'undefined') {
    local = global;
  } else if (typeof self !== 'undefined') {
    local = self;
  } else {
    try {
      local = Function('return this')();
    } catch (e) {
      throw new Error('polyfill failed because global object is unavailable in this environment');
    }
  }
  local.fetchJsonp = fetchJsonp;
  */

  module.exports = fetchJsonp;
});
},{}],7:[function(_dereq_,module,exports){
/* FileSaver.js
 * A saveAs() FileSaver implementation.
 * 1.3.2
 * 2016-06-16 18:25:19
 *
 * By Eli Grey, http://eligrey.com
 * License: MIT
 *   See https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md
 */

/*global self */
/*jslint bitwise: true, indent: 4, laxbreak: true, laxcomma: true, smarttabs: true, plusplus: true */

/*! @source http://purl.eligrey.com/github/FileSaver.js/blob/master/FileSaver.js */

var saveAs = saveAs || (function(view) {
	"use strict";
	// IE <10 is explicitly unsupported
	if (typeof view === "undefined" || typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) {
		return;
	}
	var
		  doc = view.document
		  // only get URL when necessary in case Blob.js hasn't overridden it yet
		, get_URL = function() {
			return view.URL || view.webkitURL || view;
		}
		, save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a")
		, can_use_save_link = "download" in save_link
		, click = function(node) {
			var event = new MouseEvent("click");
			node.dispatchEvent(event);
		}
		, is_safari = /constructor/i.test(view.HTMLElement) || view.safari
		, is_chrome_ios =/CriOS\/[\d]+/.test(navigator.userAgent)
		, throw_outside = function(ex) {
			(view.setImmediate || view.setTimeout)(function() {
				throw ex;
			}, 0);
		}
		, force_saveable_type = "application/octet-stream"
		// the Blob API is fundamentally broken as there is no "downloadfinished" event to subscribe to
		, arbitrary_revoke_timeout = 1000 * 40 // in ms
		, revoke = function(file) {
			var revoker = function() {
				if (typeof file === "string") { // file is an object URL
					get_URL().revokeObjectURL(file);
				} else { // file is a File
					file.remove();
				}
			};
			setTimeout(revoker, arbitrary_revoke_timeout);
		}
		, dispatch = function(filesaver, event_types, event) {
			event_types = [].concat(event_types);
			var i = event_types.length;
			while (i--) {
				var listener = filesaver["on" + event_types[i]];
				if (typeof listener === "function") {
					try {
						listener.call(filesaver, event || filesaver);
					} catch (ex) {
						throw_outside(ex);
					}
				}
			}
		}
		, auto_bom = function(blob) {
			// prepend BOM for UTF-8 XML and text/* types (including HTML)
			// note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
			if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) {
				return new Blob([String.fromCharCode(0xFEFF), blob], {type: blob.type});
			}
			return blob;
		}
		, FileSaver = function(blob, name, no_auto_bom) {
			if (!no_auto_bom) {
				blob = auto_bom(blob);
			}
			// First try a.download, then web filesystem, then object URLs
			var
				  filesaver = this
				, type = blob.type
				, force = type === force_saveable_type
				, object_url
				, dispatch_all = function() {
					dispatch(filesaver, "writestart progress write writeend".split(" "));
				}
				// on any filesys errors revert to saving with object URLs
				, fs_error = function() {
					if ((is_chrome_ios || (force && is_safari)) && view.FileReader) {
						// Safari doesn't allow downloading of blob urls
						var reader = new FileReader();
						reader.onloadend = function() {
							var url = is_chrome_ios ? reader.result : reader.result.replace(/^data:[^;]*;/, 'data:attachment/file;');
							var popup = view.open(url, '_blank');
							if(!popup) view.location.href = url;
							url=undefined; // release reference before dispatching
							filesaver.readyState = filesaver.DONE;
							dispatch_all();
						};
						reader.readAsDataURL(blob);
						filesaver.readyState = filesaver.INIT;
						return;
					}
					// don't create more object URLs than needed
					if (!object_url) {
						object_url = get_URL().createObjectURL(blob);
					}
					if (force) {
						view.location.href = object_url;
					} else {
						var opened = view.open(object_url, "_blank");
						if (!opened) {
							// Apple does not allow window.open, see https://developer.apple.com/library/safari/documentation/Tools/Conceptual/SafariExtensionGuide/WorkingwithWindowsandTabs/WorkingwithWindowsandTabs.html
							view.location.href = object_url;
						}
					}
					filesaver.readyState = filesaver.DONE;
					dispatch_all();
					revoke(object_url);
				}
			;
			filesaver.readyState = filesaver.INIT;

			if (can_use_save_link) {
				object_url = get_URL().createObjectURL(blob);
				setTimeout(function() {
					save_link.href = object_url;
					save_link.download = name;
					click(save_link);
					dispatch_all();
					revoke(object_url);
					filesaver.readyState = filesaver.DONE;
				});
				return;
			}

			fs_error();
		}
		, FS_proto = FileSaver.prototype
		, saveAs = function(blob, name, no_auto_bom) {
			return new FileSaver(blob, name || blob.name || "download", no_auto_bom);
		}
	;
	// IE 10+ (native saveAs)
	if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) {
		return function(blob, name, no_auto_bom) {
			name = name || blob.name || "download";

			if (!no_auto_bom) {
				blob = auto_bom(blob);
			}
			return navigator.msSaveOrOpenBlob(blob, name);
		};
	}

	FS_proto.abort = function(){};
	FS_proto.readyState = FS_proto.INIT = 0;
	FS_proto.WRITING = 1;
	FS_proto.DONE = 2;

	FS_proto.error =
	FS_proto.onwritestart =
	FS_proto.onprogress =
	FS_proto.onwrite =
	FS_proto.onabort =
	FS_proto.onerror =
	FS_proto.onwriteend =
		null;

	return saveAs;
}(
	   typeof self !== "undefined" && self
	|| typeof window !== "undefined" && window
	|| this.content
));
// `self` is undefined in Firefox for Android content script context
// while `this` is nsIContentFrameMessageManager
// with an attribute `content` that corresponds to the window

if (typeof module !== "undefined" && module.exports) {
  module.exports.saveAs = saveAs;
} else if ((typeof define !== "undefined" && define !== null) && (define.amd !== null)) {
  define("FileSaver.js", function() {
    return saveAs;
  });
}

},{}],8:[function(_dereq_,module,exports){
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}

},{}],9:[function(_dereq_,module,exports){
var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};

},{}],10:[function(_dereq_,module,exports){
(function (Buffer){
/**
 * https://opentype.js.org v0.7.3 | (c) Frederik De Bleser and other contributors | MIT License | Uses tiny-inflate by Devon Govett
 */

(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.opentype = global.opentype || {})));
}(this, (function (exports) { 'use strict';

var TINF_OK = 0;
var TINF_DATA_ERROR = -3;

function Tree() {
  this.table = new Uint16Array(16);   /* table of code length counts */
  this.trans = new Uint16Array(288);  /* code -> symbol translation table */
}

function Data(source, dest) {
  this.source = source;
  this.sourceIndex = 0;
  this.tag = 0;
  this.bitcount = 0;
  
  this.dest = dest;
  this.destLen = 0;
  
  this.ltree = new Tree();  /* dynamic length/symbol tree */
  this.dtree = new Tree();  /* dynamic distance tree */
}

/* --------------------------------------------------- *
 * -- uninitialized global data (static structures) -- *
 * --------------------------------------------------- */

var sltree = new Tree();
var sdtree = new Tree();

/* extra bits and base tables for length codes */
var length_bits = new Uint8Array(30);
var length_base = new Uint16Array(30);

/* extra bits and base tables for distance codes */
var dist_bits = new Uint8Array(30);
var dist_base = new Uint16Array(30);

/* special ordering of code length codes */
var clcidx = new Uint8Array([
  16, 17, 18, 0, 8, 7, 9, 6,
  10, 5, 11, 4, 12, 3, 13, 2,
  14, 1, 15
]);

/* used by tinf_decode_trees, avoids allocations every call */
var code_tree = new Tree();
var lengths = new Uint8Array(288 + 32);

/* ----------------------- *
 * -- utility functions -- *
 * ----------------------- */

/* build extra bits and base tables */
function tinf_build_bits_base(bits, base, delta, first) {
  var i, sum;

  /* build bits table */
  for (i = 0; i < delta; ++i) { bits[i] = 0; }
  for (i = 0; i < 30 - delta; ++i) { bits[i + delta] = i / delta | 0; }

  /* build base table */
  for (sum = first, i = 0; i < 30; ++i) {
    base[i] = sum;
    sum += 1 << bits[i];
  }
}

/* build the fixed huffman trees */
function tinf_build_fixed_trees(lt, dt) {
  var i;

  /* build fixed length tree */
  for (i = 0; i < 7; ++i) { lt.table[i] = 0; }

  lt.table[7] = 24;
  lt.table[8] = 152;
  lt.table[9] = 112;

  for (i = 0; i < 24; ++i) { lt.trans[i] = 256 + i; }
  for (i = 0; i < 144; ++i) { lt.trans[24 + i] = i; }
  for (i = 0; i < 8; ++i) { lt.trans[24 + 144 + i] = 280 + i; }
  for (i = 0; i < 112; ++i) { lt.trans[24 + 144 + 8 + i] = 144 + i; }

  /* build fixed distance tree */
  for (i = 0; i < 5; ++i) { dt.table[i] = 0; }

  dt.table[5] = 32;

  for (i = 0; i < 32; ++i) { dt.trans[i] = i; }
}

/* given an array of code lengths, build a tree */
var offs = new Uint16Array(16);

function tinf_build_tree(t, lengths, off, num) {
  var i, sum;

  /* clear code length count table */
  for (i = 0; i < 16; ++i) { t.table[i] = 0; }

  /* scan symbol lengths, and sum code length counts */
  for (i = 0; i < num; ++i) { t.table[lengths[off + i]]++; }

  t.table[0] = 0;

  /* compute offset table for distribution sort */
  for (sum = 0, i = 0; i < 16; ++i) {
    offs[i] = sum;
    sum += t.table[i];
  }

  /* create code->symbol translation table (symbols sorted by code) */
  for (i = 0; i < num; ++i) {
    if (lengths[off + i]) { t.trans[offs[lengths[off + i]]++] = i; }
  }
}

/* ---------------------- *
 * -- decode functions -- *
 * ---------------------- */

/* get one bit from source stream */
function tinf_getbit(d) {
  /* check if tag is empty */
  if (!d.bitcount--) {
    /* load next tag */
    d.tag = d.source[d.sourceIndex++];
    d.bitcount = 7;
  }

  /* shift bit out of tag */
  var bit = d.tag & 1;
  d.tag >>>= 1;

  return bit;
}

/* read a num bit value from a stream and add base */
function tinf_read_bits(d, num, base) {
  if (!num)
    { return base; }

  while (d.bitcount < 24) {
    d.tag |= d.source[d.sourceIndex++] << d.bitcount;
    d.bitcount += 8;
  }

  var val = d.tag & (0xffff >>> (16 - num));
  d.tag >>>= num;
  d.bitcount -= num;
  return val + base;
}

/* given a data stream and a tree, decode a symbol */
function tinf_decode_symbol(d, t) {
  while (d.bitcount < 24) {
    d.tag |= d.source[d.sourceIndex++] << d.bitcount;
    d.bitcount += 8;
  }
  
  var sum = 0, cur = 0, len = 0;
  var tag = d.tag;

  /* get more bits while code value is above sum */
  do {
    cur = 2 * cur + (tag & 1);
    tag >>>= 1;
    ++len;

    sum += t.table[len];
    cur -= t.table[len];
  } while (cur >= 0);
  
  d.tag = tag;
  d.bitcount -= len;

  return t.trans[sum + cur];
}

/* given a data stream, decode dynamic trees from it */
function tinf_decode_trees(d, lt, dt) {
  var hlit, hdist, hclen;
  var i, num, length;

  /* get 5 bits HLIT (257-286) */
  hlit = tinf_read_bits(d, 5, 257);

  /* get 5 bits HDIST (1-32) */
  hdist = tinf_read_bits(d, 5, 1);

  /* get 4 bits HCLEN (4-19) */
  hclen = tinf_read_bits(d, 4, 4);

  for (i = 0; i < 19; ++i) { lengths[i] = 0; }

  /* read code lengths for code length alphabet */
  for (i = 0; i < hclen; ++i) {
    /* get 3 bits code length (0-7) */
    var clen = tinf_read_bits(d, 3, 0);
    lengths[clcidx[i]] = clen;
  }

  /* build code length tree */
  tinf_build_tree(code_tree, lengths, 0, 19);

  /* decode code lengths for the dynamic trees */
  for (num = 0; num < hlit + hdist;) {
    var sym = tinf_decode_symbol(d, code_tree);

    switch (sym) {
      case 16:
        /* copy previous code length 3-6 times (read 2 bits) */
        var prev = lengths[num - 1];
        for (length = tinf_read_bits(d, 2, 3); length; --length) {
          lengths[num++] = prev;
        }
        break;
      case 17:
        /* repeat code length 0 for 3-10 times (read 3 bits) */
        for (length = tinf_read_bits(d, 3, 3); length; --length) {
          lengths[num++] = 0;
        }
        break;
      case 18:
        /* repeat code length 0 for 11-138 times (read 7 bits) */
        for (length = tinf_read_bits(d, 7, 11); length; --length) {
          lengths[num++] = 0;
        }
        break;
      default:
        /* values 0-15 represent the actual code lengths */
        lengths[num++] = sym;
        break;
    }
  }

  /* build dynamic trees */
  tinf_build_tree(lt, lengths, 0, hlit);
  tinf_build_tree(dt, lengths, hlit, hdist);
}

/* ----------------------------- *
 * -- block inflate functions -- *
 * ----------------------------- */

/* given a stream and two trees, inflate a block of data */
function tinf_inflate_block_data(d, lt, dt) {
  while (1) {
    var sym = tinf_decode_symbol(d, lt);

    /* check for end of block */
    if (sym === 256) {
      return TINF_OK;
    }

    if (sym < 256) {
      d.dest[d.destLen++] = sym;
    } else {
      var length, dist, offs;
      var i;

      sym -= 257;

      /* possibly get more bits from length code */
      length = tinf_read_bits(d, length_bits[sym], length_base[sym]);

      dist = tinf_decode_symbol(d, dt);

      /* possibly get more bits from distance code */
      offs = d.destLen - tinf_read_bits(d, dist_bits[dist], dist_base[dist]);

      /* copy match */
      for (i = offs; i < offs + length; ++i) {
        d.dest[d.destLen++] = d.dest[i];
      }
    }
  }
}

/* inflate an uncompressed block of data */
function tinf_inflate_uncompressed_block(d) {
  var length, invlength;
  var i;
  
  /* unread from bitbuffer */
  while (d.bitcount > 8) {
    d.sourceIndex--;
    d.bitcount -= 8;
  }

  /* get length */
  length = d.source[d.sourceIndex + 1];
  length = 256 * length + d.source[d.sourceIndex];

  /* get one's complement of length */
  invlength = d.source[d.sourceIndex + 3];
  invlength = 256 * invlength + d.source[d.sourceIndex + 2];

  /* check length */
  if (length !== (~invlength & 0x0000ffff))
    { return TINF_DATA_ERROR; }

  d.sourceIndex += 4;

  /* copy block */
  for (i = length; i; --i)
    { d.dest[d.destLen++] = d.source[d.sourceIndex++]; }

  /* make sure we start next block on a byte boundary */
  d.bitcount = 0;

  return TINF_OK;
}

/* inflate stream from source to dest */
function tinf_uncompress(source, dest) {
  var d = new Data(source, dest);
  var bfinal, btype, res;

  do {
    /* read final block flag */
    bfinal = tinf_getbit(d);

    /* read block type (2 bits) */
    btype = tinf_read_bits(d, 2, 0);

    /* decompress block */
    switch (btype) {
      case 0:
        /* decompress uncompressed block */
        res = tinf_inflate_uncompressed_block(d);
        break;
      case 1:
        /* decompress block with fixed huffman trees */
        res = tinf_inflate_block_data(d, sltree, sdtree);
        break;
      case 2:
        /* decompress block with dynamic huffman trees */
        tinf_decode_trees(d, d.ltree, d.dtree);
        res = tinf_inflate_block_data(d, d.ltree, d.dtree);
        break;
      default:
        res = TINF_DATA_ERROR;
    }

    if (res !== TINF_OK)
      { throw new Error('Data error'); }

  } while (!bfinal);

  if (d.destLen < d.dest.length) {
    if (typeof d.dest.slice === 'function')
      { return d.dest.slice(0, d.destLen); }
    else
      { return d.dest.subarray(0, d.destLen); }
  }
  
  return d.dest;
}

/* -------------------- *
 * -- initialization -- *
 * -------------------- */

/* build fixed huffman trees */
tinf_build_fixed_trees(sltree, sdtree);

/* build extra bits and base tables */
tinf_build_bits_base(length_bits, length_base, 4, 3);
tinf_build_bits_base(dist_bits, dist_base, 2, 1);

/* fix a special case */
length_bits[28] = 0;
length_base[28] = 258;

var index = tinf_uncompress;

// The Bounding Box object

function derive(v0, v1, v2, v3, t) {
    return Math.pow(1 - t, 3) * v0 +
        3 * Math.pow(1 - t, 2) * t * v1 +
        3 * (1 - t) * Math.pow(t, 2) * v2 +
        Math.pow(t, 3) * v3;
}
/**
 * A bounding box is an enclosing box that describes the smallest measure within which all the points lie.
 * It is used to calculate the bounding box of a glyph or text path.
 *
 * On initialization, x1/y1/x2/y2 will be NaN. Check if the bounding box is empty using `isEmpty()`.
 *
 * @exports opentype.BoundingBox
 * @class
 * @constructor
 */
function BoundingBox() {
    this.x1 = Number.NaN;
    this.y1 = Number.NaN;
    this.x2 = Number.NaN;
    this.y2 = Number.NaN;
}

/**
 * Returns true if the bounding box is empty, that is, no points have been added to the box yet.
 */
BoundingBox.prototype.isEmpty = function() {
    return isNaN(this.x1) || isNaN(this.y1) || isNaN(this.x2) || isNaN(this.y2);
};

/**
 * Add the point to the bounding box.
 * The x1/y1/x2/y2 coordinates of the bounding box will now encompass the given point.
 * @param {number} x - The X coordinate of the point.
 * @param {number} y - The Y coordinate of the point.
 */
BoundingBox.prototype.addPoint = function(x, y) {
    if (typeof x === 'number') {
        if (isNaN(this.x1) || isNaN(this.x2)) {
            this.x1 = x;
            this.x2 = x;
        }
        if (x < this.x1) {
            this.x1 = x;
        }
        if (x > this.x2) {
            this.x2 = x;
        }
    }
    if (typeof y === 'number') {
        if (isNaN(this.y1) || isNaN(this.y2)) {
            this.y1 = y;
            this.y2 = y;
        }
        if (y < this.y1) {
            this.y1 = y;
        }
        if (y > this.y2) {
            this.y2 = y;
        }
    }
};

/**
 * Add a X coordinate to the bounding box.
 * This extends the bounding box to include the X coordinate.
 * This function is used internally inside of addBezier.
 * @param {number} x - The X coordinate of the point.
 */
BoundingBox.prototype.addX = function(x) {
    this.addPoint(x, null);
};

/**
 * Add a Y coordinate to the bounding box.
 * This extends the bounding box to include the Y coordinate.
 * This function is used internally inside of addBezier.
 * @param {number} y - The Y coordinate of the point.
 */
BoundingBox.prototype.addY = function(y) {
    this.addPoint(null, y);
};

/**
 * Add a Bézier curve to the bounding box.
 * This extends the bounding box to include the entire Bézier.
 * @param {number} x0 - The starting X coordinate.
 * @param {number} y0 - The starting Y coordinate.
 * @param {number} x1 - The X coordinate of the first control point.
 * @param {number} y1 - The Y coordinate of the first control point.
 * @param {number} x2 - The X coordinate of the second control point.
 * @param {number} y2 - The Y coordinate of the second control point.
 * @param {number} x - The ending X coordinate.
 * @param {number} y - The ending Y coordinate.
 */
BoundingBox.prototype.addBezier = function(x0, y0, x1, y1, x2, y2, x, y) {
    var this$1 = this;

    // This code is based on http://nishiohirokazu.blogspot.com/2009/06/how-to-calculate-bezier-curves-bounding.html
    // and https://github.com/icons8/svg-path-bounding-box

    var p0 = [x0, y0];
    var p1 = [x1, y1];
    var p2 = [x2, y2];
    var p3 = [x, y];

    this.addPoint(x0, y0);
    this.addPoint(x, y);

    for (var i = 0; i <= 1; i++) {
        var b = 6 * p0[i] - 12 * p1[i] + 6 * p2[i];
        var a = -3 * p0[i] + 9 * p1[i] - 9 * p2[i] + 3 * p3[i];
        var c = 3 * p1[i] - 3 * p0[i];

        if (a === 0) {
            if (b === 0) { continue; }
            var t = -c / b;
            if (0 < t && t < 1) {
                if (i === 0) { this$1.addX(derive(p0[i], p1[i], p2[i], p3[i], t)); }
                if (i === 1) { this$1.addY(derive(p0[i], p1[i], p2[i], p3[i], t)); }
            }
            continue;
        }

        var b2ac = Math.pow(b, 2) - 4 * c * a;
        if (b2ac < 0) { continue; }
        var t1 = (-b + Math.sqrt(b2ac)) / (2 * a);
        if (0 < t1 && t1 < 1) {
            if (i === 0) { this$1.addX(derive(p0[i], p1[i], p2[i], p3[i], t1)); }
            if (i === 1) { this$1.addY(derive(p0[i], p1[i], p2[i], p3[i], t1)); }
        }
        var t2 = (-b - Math.sqrt(b2ac)) / (2 * a);
        if (0 < t2 && t2 < 1) {
            if (i === 0) { this$1.addX(derive(p0[i], p1[i], p2[i], p3[i], t2)); }
            if (i === 1) { this$1.addY(derive(p0[i], p1[i], p2[i], p3[i], t2)); }
        }
    }
};

/**
 * Add a quadratic curve to the bounding box.
 * This extends the bounding box to include the entire quadratic curve.
 * @param {number} x0 - The starting X coordinate.
 * @param {number} y0 - The starting Y coordinate.
 * @param {number} x1 - The X coordinate of the control point.
 * @param {number} y1 - The Y coordinate of the control point.
 * @param {number} x - The ending X coordinate.
 * @param {number} y - The ending Y coordinate.
 */
BoundingBox.prototype.addQuad = function(x0, y0, x1, y1, x, y) {
    var cp1x = x0 + 2 / 3 * (x1 - x0);
    var cp1y = y0 + 2 / 3 * (y1 - y0);
    var cp2x = cp1x + 1 / 3 * (x - x0);
    var cp2y = cp1y + 1 / 3 * (y - y0);
    this.addBezier(x0, y0, cp1x, cp1y, cp2x, cp2y, x, y);
};

// Geometric objects

/**
 * A bézier path containing a set of path commands similar to a SVG path.
 * Paths can be drawn on a context using `draw`.
 * @exports opentype.Path
 * @class
 * @constructor
 */
function Path() {
    this.commands = [];
    this.fill = 'black';
    this.stroke = null;
    this.strokeWidth = 1;
}

/**
 * @param  {number} x
 * @param  {number} y
 */
Path.prototype.moveTo = function(x, y) {
    this.commands.push({
        type: 'M',
        x: x,
        y: y
    });
};

/**
 * @param  {number} x
 * @param  {number} y
 */
Path.prototype.lineTo = function(x, y) {
    this.commands.push({
        type: 'L',
        x: x,
        y: y
    });
};

/**
 * Draws cubic curve
 * @function
 * curveTo
 * @memberof opentype.Path.prototype
 * @param  {number} x1 - x of control 1
 * @param  {number} y1 - y of control 1
 * @param  {number} x2 - x of control 2
 * @param  {number} y2 - y of control 2
 * @param  {number} x - x of path point
 * @param  {number} y - y of path point
 */

/**
 * Draws cubic curve
 * @function
 * bezierCurveTo
 * @memberof opentype.Path.prototype
 * @param  {number} x1 - x of control 1
 * @param  {number} y1 - y of control 1
 * @param  {number} x2 - x of control 2
 * @param  {number} y2 - y of control 2
 * @param  {number} x - x of path point
 * @param  {number} y - y of path point
 * @see curveTo
 */
Path.prototype.curveTo = Path.prototype.bezierCurveTo = function(x1, y1, x2, y2, x, y) {
    this.commands.push({
        type: 'C',
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2,
        x: x,
        y: y
    });
};

/**
 * Draws quadratic curve
 * @function
 * quadraticCurveTo
 * @memberof opentype.Path.prototype
 * @param  {number} x1 - x of control
 * @param  {number} y1 - y of control
 * @param  {number} x - x of path point
 * @param  {number} y - y of path point
 */

/**
 * Draws quadratic curve
 * @function
 * quadTo
 * @memberof opentype.Path.prototype
 * @param  {number} x1 - x of control
 * @param  {number} y1 - y of control
 * @param  {number} x - x of path point
 * @param  {number} y - y of path point
 */
Path.prototype.quadTo = Path.prototype.quadraticCurveTo = function(x1, y1, x, y) {
    this.commands.push({
        type: 'Q',
        x1: x1,
        y1: y1,
        x: x,
        y: y
    });
};

/**
 * Closes the path
 * @function closePath
 * @memberof opentype.Path.prototype
 */

/**
 * Close the path
 * @function close
 * @memberof opentype.Path.prototype
 */
Path.prototype.close = Path.prototype.closePath = function() {
    this.commands.push({
        type: 'Z'
    });
};

/**
 * Add the given path or list of commands to the commands of this path.
 * @param  {Array} pathOrCommands - another opentype.Path, an opentype.BoundingBox, or an array of commands.
 */
Path.prototype.extend = function(pathOrCommands) {
    if (pathOrCommands.commands) {
        pathOrCommands = pathOrCommands.commands;
    } else if (pathOrCommands instanceof BoundingBox) {
        var box = pathOrCommands;
        this.moveTo(box.x1, box.y1);
        this.lineTo(box.x2, box.y1);
        this.lineTo(box.x2, box.y2);
        this.lineTo(box.x1, box.y2);
        this.close();
        return;
    }

    Array.prototype.push.apply(this.commands, pathOrCommands);
};

/**
 * Calculate the bounding box of the path.
 * @returns {opentype.BoundingBox}
 */
Path.prototype.getBoundingBox = function() {
    var this$1 = this;

    var box = new BoundingBox();

    var startX = 0;
    var startY = 0;
    var prevX = 0;
    var prevY = 0;
    for (var i = 0; i < this.commands.length; i++) {
        var cmd = this$1.commands[i];
        switch (cmd.type) {
            case 'M':
                box.addPoint(cmd.x, cmd.y);
                startX = prevX = cmd.x;
                startY = prevY = cmd.y;
                break;
            case 'L':
                box.addPoint(cmd.x, cmd.y);
                prevX = cmd.x;
                prevY = cmd.y;
                break;
            case 'Q':
                box.addQuad(prevX, prevY, cmd.x1, cmd.y1, cmd.x, cmd.y);
                prevX = cmd.x;
                prevY = cmd.y;
                break;
            case 'C':
                box.addBezier(prevX, prevY, cmd.x1, cmd.y1, cmd.x2, cmd.y2, cmd.x, cmd.y);
                prevX = cmd.x;
                prevY = cmd.y;
                break;
            case 'Z':
                prevX = startX;
                prevY = startY;
                break;
            default:
                throw new Error('Unexpected path command ' + cmd.type);
        }
    }
    if (box.isEmpty()) {
        box.addPoint(0, 0);
    }
    return box;
};

/**
 * Draw the path to a 2D context.
 * @param {CanvasRenderingContext2D} ctx - A 2D drawing context.
 */
Path.prototype.draw = function(ctx) {
    var this$1 = this;

    ctx.beginPath();
    for (var i = 0; i < this.commands.length; i += 1) {
        var cmd = this$1.commands[i];
        if (cmd.type === 'M') {
            ctx.moveTo(cmd.x, cmd.y);
        } else if (cmd.type === 'L') {
            ctx.lineTo(cmd.x, cmd.y);
        } else if (cmd.type === 'C') {
            ctx.bezierCurveTo(cmd.x1, cmd.y1, cmd.x2, cmd.y2, cmd.x, cmd.y);
        } else if (cmd.type === 'Q') {
            ctx.quadraticCurveTo(cmd.x1, cmd.y1, cmd.x, cmd.y);
        } else if (cmd.type === 'Z') {
            ctx.closePath();
        }
    }

    if (this.fill) {
        ctx.fillStyle = this.fill;
        ctx.fill();
    }

    if (this.stroke) {
        ctx.strokeStyle = this.stroke;
        ctx.lineWidth = this.strokeWidth;
        ctx.stroke();
    }
};

/**
 * Convert the Path to a string of path data instructions
 * See http://www.w3.org/TR/SVG/paths.html#PathData
 * @param  {number} [decimalPlaces=2] - The amount of decimal places for floating-point values
 * @return {string}
 */
Path.prototype.toPathData = function(decimalPlaces) {
    var this$1 = this;

    decimalPlaces = decimalPlaces !== undefined ? decimalPlaces : 2;

    function floatToString(v) {
        if (Math.round(v) === v) {
            return '' + Math.round(v);
        } else {
            return v.toFixed(decimalPlaces);
        }
    }

    function packValues() {
        var arguments$1 = arguments;

        var s = '';
        for (var i = 0; i < arguments.length; i += 1) {
            var v = arguments$1[i];
            if (v >= 0 && i > 0) {
                s += ' ';
            }

            s += floatToString(v);
        }

        return s;
    }

    var d = '';
    for (var i = 0; i < this.commands.length; i += 1) {
        var cmd = this$1.commands[i];
        if (cmd.type === 'M') {
            d += 'M' + packValues(cmd.x, cmd.y);
        } else if (cmd.type === 'L') {
            d += 'L' + packValues(cmd.x, cmd.y);
        } else if (cmd.type === 'C') {
            d += 'C' + packValues(cmd.x1, cmd.y1, cmd.x2, cmd.y2, cmd.x, cmd.y);
        } else if (cmd.type === 'Q') {
            d += 'Q' + packValues(cmd.x1, cmd.y1, cmd.x, cmd.y);
        } else if (cmd.type === 'Z') {
            d += 'Z';
        }
    }

    return d;
};

/**
 * Convert the path to an SVG <path> element, as a string.
 * @param  {number} [decimalPlaces=2] - The amount of decimal places for floating-point values
 * @return {string}
 */
Path.prototype.toSVG = function(decimalPlaces) {
    var svg = '<path d="';
    svg += this.toPathData(decimalPlaces);
    svg += '"';
    if (this.fill && this.fill !== 'black') {
        if (this.fill === null) {
            svg += ' fill="none"';
        } else {
            svg += ' fill="' + this.fill + '"';
        }
    }

    if (this.stroke) {
        svg += ' stroke="' + this.stroke + '" stroke-width="' + this.strokeWidth + '"';
    }

    svg += '/>';
    return svg;
};

/**
 * Convert the path to a DOM element.
 * @param  {number} [decimalPlaces=2] - The amount of decimal places for floating-point values
 * @return {SVGPathElement}
 */
Path.prototype.toDOMElement = function(decimalPlaces) {
    var temporaryPath = this.toPathData(decimalPlaces);
    var newPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');

    newPath.setAttribute('d', temporaryPath);

    return newPath;
};

// Run-time checking of preconditions.

function fail(message) {
    throw new Error(message);
}

// Precondition function that checks if the given predicate is true.
// If not, it will throw an error.
function argument(predicate, message) {
    if (!predicate) {
        fail(message);
    }
}

var check = { fail: fail, argument: argument, assert: argument };

// Data types used in the OpenType font file.
// All OpenType fonts use Motorola-style byte ordering (Big Endian)

var LIMIT16 = 32768; // The limit at which a 16-bit number switches signs == 2^15
var LIMIT32 = 2147483648; // The limit at which a 32-bit number switches signs == 2 ^ 31

/**
 * @exports opentype.decode
 * @class
 */
var decode = {};
/**
 * @exports opentype.encode
 * @class
 */
var encode = {};
/**
 * @exports opentype.sizeOf
 * @class
 */
var sizeOf = {};

// Return a function that always returns the same value.
function constant(v) {
    return function() {
        return v;
    };
}

// OpenType data types //////////////////////////////////////////////////////

/**
 * Convert an 8-bit unsigned integer to a list of 1 byte.
 * @param {number}
 * @returns {Array}
 */
encode.BYTE = function(v) {
    check.argument(v >= 0 && v <= 255, 'Byte value should be between 0 and 255.');
    return [v];
};
/**
 * @constant
 * @type {number}
 */
sizeOf.BYTE = constant(1);

/**
 * Convert a 8-bit signed integer to a list of 1 byte.
 * @param {string}
 * @returns {Array}
 */
encode.CHAR = function(v) {
    return [v.charCodeAt(0)];
};

/**
 * @constant
 * @type {number}
 */
sizeOf.CHAR = constant(1);

/**
 * Convert an ASCII string to a list of bytes.
 * @param {string}
 * @returns {Array}
 */
encode.CHARARRAY = function(v) {
    var b = [];
    for (var i = 0; i < v.length; i += 1) {
        b[i] = v.charCodeAt(i);
    }

    return b;
};

/**
 * @param {Array}
 * @returns {number}
 */
sizeOf.CHARARRAY = function(v) {
    return v.length;
};

/**
 * Convert a 16-bit unsigned integer to a list of 2 bytes.
 * @param {number}
 * @returns {Array}
 */
encode.USHORT = function(v) {
    return [(v >> 8) & 0xFF, v & 0xFF];
};

/**
 * @constant
 * @type {number}
 */
sizeOf.USHORT = constant(2);

/**
 * Convert a 16-bit signed integer to a list of 2 bytes.
 * @param {number}
 * @returns {Array}
 */
encode.SHORT = function(v) {
    // Two's complement
    if (v >= LIMIT16) {
        v = -(2 * LIMIT16 - v);
    }

    return [(v >> 8) & 0xFF, v & 0xFF];
};

/**
 * @constant
 * @type {number}
 */
sizeOf.SHORT = constant(2);

/**
 * Convert a 24-bit unsigned integer to a list of 3 bytes.
 * @param {number}
 * @returns {Array}
 */
encode.UINT24 = function(v) {
    return [(v >> 16) & 0xFF, (v >> 8) & 0xFF, v & 0xFF];
};

/**
 * @constant
 * @type {number}
 */
sizeOf.UINT24 = constant(3);

/**
 * Convert a 32-bit unsigned integer to a list of 4 bytes.
 * @param {number}
 * @returns {Array}
 */
encode.ULONG = function(v) {
    return [(v >> 24) & 0xFF, (v >> 16) & 0xFF, (v >> 8) & 0xFF, v & 0xFF];
};

/**
 * @constant
 * @type {number}
 */
sizeOf.ULONG = constant(4);

/**
 * Convert a 32-bit unsigned integer to a list of 4 bytes.
 * @param {number}
 * @returns {Array}
 */
encode.LONG = function(v) {
    // Two's complement
    if (v >= LIMIT32) {
        v = -(2 * LIMIT32 - v);
    }

    return [(v >> 24) & 0xFF, (v >> 16) & 0xFF, (v >> 8) & 0xFF, v & 0xFF];
};

/**
 * @constant
 * @type {number}
 */
sizeOf.LONG = constant(4);

encode.FIXED = encode.ULONG;
sizeOf.FIXED = sizeOf.ULONG;

encode.FWORD = encode.SHORT;
sizeOf.FWORD = sizeOf.SHORT;

encode.UFWORD = encode.USHORT;
sizeOf.UFWORD = sizeOf.USHORT;

/**
 * Convert a 32-bit Apple Mac timestamp integer to a list of 8 bytes, 64-bit timestamp.
 * @param {number}
 * @returns {Array}
 */
encode.LONGDATETIME = function(v) {
    return [0, 0, 0, 0, (v >> 24) & 0xFF, (v >> 16) & 0xFF, (v >> 8) & 0xFF, v & 0xFF];
};

/**
 * @constant
 * @type {number}
 */
sizeOf.LONGDATETIME = constant(8);

/**
 * Convert a 4-char tag to a list of 4 bytes.
 * @param {string}
 * @returns {Array}
 */
encode.TAG = function(v) {
    check.argument(v.length === 4, 'Tag should be exactly 4 ASCII characters.');
    return [v.charCodeAt(0),
            v.charCodeAt(1),
            v.charCodeAt(2),
            v.charCodeAt(3)];
};

/**
 * @constant
 * @type {number}
 */
sizeOf.TAG = constant(4);

// CFF data types ///////////////////////////////////////////////////////////

encode.Card8 = encode.BYTE;
sizeOf.Card8 = sizeOf.BYTE;

encode.Card16 = encode.USHORT;
sizeOf.Card16 = sizeOf.USHORT;

encode.OffSize = encode.BYTE;
sizeOf.OffSize = sizeOf.BYTE;

encode.SID = encode.USHORT;
sizeOf.SID = sizeOf.USHORT;

// Convert a numeric operand or charstring number to a variable-size list of bytes.
/**
 * Convert a numeric operand or charstring number to a variable-size list of bytes.
 * @param {number}
 * @returns {Array}
 */
encode.NUMBER = function(v) {
    if (v >= -107 && v <= 107) {
        return [v + 139];
    } else if (v >= 108 && v <= 1131) {
        v = v - 108;
        return [(v >> 8) + 247, v & 0xFF];
    } else if (v >= -1131 && v <= -108) {
        v = -v - 108;
        return [(v >> 8) + 251, v & 0xFF];
    } else if (v >= -32768 && v <= 32767) {
        return encode.NUMBER16(v);
    } else {
        return encode.NUMBER32(v);
    }
};

/**
 * @param {number}
 * @returns {number}
 */
sizeOf.NUMBER = function(v) {
    return encode.NUMBER(v).length;
};

/**
 * Convert a signed number between -32768 and +32767 to a three-byte value.
 * This ensures we always use three bytes, but is not the most compact format.
 * @param {number}
 * @returns {Array}
 */
encode.NUMBER16 = function(v) {
    return [28, (v >> 8) & 0xFF, v & 0xFF];
};

/**
 * @constant
 * @type {number}
 */
sizeOf.NUMBER16 = constant(3);

/**
 * Convert a signed number between -(2^31) and +(2^31-1) to a five-byte value.
 * This is useful if you want to be sure you always use four bytes,
 * at the expense of wasting a few bytes for smaller numbers.
 * @param {number}
 * @returns {Array}
 */
encode.NUMBER32 = function(v) {
    return [29, (v >> 24) & 0xFF, (v >> 16) & 0xFF, (v >> 8) & 0xFF, v & 0xFF];
};

/**
 * @constant
 * @type {number}
 */
sizeOf.NUMBER32 = constant(5);

/**
 * @param {number}
 * @returns {Array}
 */
encode.REAL = function(v) {
    var value = v.toString();

    // Some numbers use an epsilon to encode the value. (e.g. JavaScript will store 0.0000001 as 1e-7)
    // This code converts it back to a number without the epsilon.
    var m = /\.(\d*?)(?:9{5,20}|0{5,20})\d{0,2}(?:e(.+)|$)/.exec(value);
    if (m) {
        var epsilon = parseFloat('1e' + ((m[2] ? +m[2] : 0) + m[1].length));
        value = (Math.round(v * epsilon) / epsilon).toString();
    }

    var nibbles = '';
    for (var i = 0, ii = value.length; i < ii; i += 1) {
        var c = value[i];
        if (c === 'e') {
            nibbles += value[++i] === '-' ? 'c' : 'b';
        } else if (c === '.') {
            nibbles += 'a';
        } else if (c === '-') {
            nibbles += 'e';
        } else {
            nibbles += c;
        }
    }

    nibbles += (nibbles.length & 1) ? 'f' : 'ff';
    var out = [30];
    for (var i$1 = 0, ii$1 = nibbles.length; i$1 < ii$1; i$1 += 2) {
        out.push(parseInt(nibbles.substr(i$1, 2), 16));
    }

    return out;
};

/**
 * @param {number}
 * @returns {number}
 */
sizeOf.REAL = function(v) {
    return encode.REAL(v).length;
};

encode.NAME = encode.CHARARRAY;
sizeOf.NAME = sizeOf.CHARARRAY;

encode.STRING = encode.CHARARRAY;
sizeOf.STRING = sizeOf.CHARARRAY;

/**
 * @param {DataView} data
 * @param {number} offset
 * @param {number} numBytes
 * @returns {string}
 */
decode.UTF8 = function(data, offset, numBytes) {
    var codePoints = [];
    var numChars = numBytes;
    for (var j = 0; j < numChars; j++, offset += 1) {
        codePoints[j] = data.getUint8(offset);
    }

    return String.fromCharCode.apply(null, codePoints);
};

/**
 * @param {DataView} data
 * @param {number} offset
 * @param {number} numBytes
 * @returns {string}
 */
decode.UTF16 = function(data, offset, numBytes) {
    var codePoints = [];
    var numChars = numBytes / 2;
    for (var j = 0; j < numChars; j++, offset += 2) {
        codePoints[j] = data.getUint16(offset);
    }

    return String.fromCharCode.apply(null, codePoints);
};

/**
 * Convert a JavaScript string to UTF16-BE.
 * @param {string}
 * @returns {Array}
 */
encode.UTF16 = function(v) {
    var b = [];
    for (var i = 0; i < v.length; i += 1) {
        var codepoint = v.charCodeAt(i);
        b[b.length] = (codepoint >> 8) & 0xFF;
        b[b.length] = codepoint & 0xFF;
    }

    return b;
};

/**
 * @param {string}
 * @returns {number}
 */
sizeOf.UTF16 = function(v) {
    return v.length * 2;
};

// Data for converting old eight-bit Macintosh encodings to Unicode.
// This representation is optimized for decoding; encoding is slower
// and needs more memory. The assumption is that all opentype.js users
// want to open fonts, but saving a font will be comparatively rare
// so it can be more expensive. Keyed by IANA character set name.
//
// Python script for generating these strings:
//
//     s = u''.join([chr(c).decode('mac_greek') for c in range(128, 256)])
//     print(s.encode('utf-8'))
/**
 * @private
 */
var eightBitMacEncodings = {
    'x-mac-croatian':  // Python: 'mac_croatian'
    'ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®Š™´¨≠ŽØ∞±≤≥∆µ∂∑∏š∫ªºΩžø' +
    '¿¡¬√ƒ≈Ć«Č… ÀÃÕŒœĐ—“”‘’÷◊©⁄€‹›Æ»–·‚„‰ÂćÁčÈÍÎÏÌÓÔđÒÚÛÙıˆ˜¯πË˚¸Êæˇ',
    'x-mac-cyrillic':  // Python: 'mac_cyrillic'
    'АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ†°Ґ£§•¶І®©™Ђђ≠Ѓѓ∞±≤≥іµґЈЄєЇїЉљЊњ' +
    'јЅ¬√ƒ≈∆«»… ЋћЌќѕ–—“”‘’÷„ЎўЏџ№Ёёяабвгдежзийклмнопрстуфхцчшщъыьэю',
    'x-mac-gaelic': // http://unicode.org/Public/MAPPINGS/VENDORS/APPLE/GAELIC.TXT
    'ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØḂ±≤≥ḃĊċḊḋḞḟĠġṀæø' +
    'ṁṖṗɼƒſṠ«»… ÀÃÕŒœ–—“”‘’ṡẛÿŸṪ€‹›Ŷŷṫ·Ỳỳ⁊ÂÊÁËÈÍÎÏÌÓÔ♣ÒÚÛÙıÝýŴŵẄẅẀẁẂẃ',
    'x-mac-greek':  // Python: 'mac_greek'
    'Ä¹²É³ÖÜ΅àâä΄¨çéèêë£™îï•½‰ôö¦€ùûü†ΓΔΘΛΞΠß®©ΣΪ§≠°·Α±≤≥¥ΒΕΖΗΙΚΜΦΫΨΩ' +
    'άΝ¬ΟΡ≈Τ«»… ΥΧΆΈœ–―“”‘’÷ΉΊΌΎέήίόΏύαβψδεφγηιξκλμνοπώρστθωςχυζϊϋΐΰ\u00AD',
    'x-mac-icelandic':  // Python: 'mac_iceland'
    'ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûüÝ°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø' +
    '¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄€ÐðÞþý·‚„‰ÂÊÁËÈÍÎÏÌÓÔÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ',
    'x-mac-inuit': // http://unicode.org/Public/MAPPINGS/VENDORS/APPLE/INUIT.TXT
    'ᐃᐄᐅᐆᐊᐋᐱᐲᐳᐴᐸᐹᑉᑎᑏᑐᑑᑕᑖᑦᑭᑮᑯᑰᑲᑳᒃᒋᒌᒍᒎᒐᒑ°ᒡᒥᒦ•¶ᒧ®©™ᒨᒪᒫᒻᓂᓃᓄᓅᓇᓈᓐᓯᓰᓱᓲᓴᓵᔅᓕᓖᓗ' +
    'ᓘᓚᓛᓪᔨᔩᔪᔫᔭ… ᔮᔾᕕᕖᕗ–—“”‘’ᕘᕙᕚᕝᕆᕇᕈᕉᕋᕌᕐᕿᖀᖁᖂᖃᖄᖅᖏᖐᖑᖒᖓᖔᖕᙱᙲᙳᙴᙵᙶᖖᖠᖡᖢᖣᖤᖥᖦᕼŁł',
    'x-mac-ce':  // Python: 'mac_latin2'
    'ÄĀāÉĄÖÜáąČäčĆćéŹźĎíďĒēĖóėôöõúĚěü†°Ę£§•¶ß®©™ę¨≠ģĮįĪ≤≥īĶ∂∑łĻļĽľĹĺŅ' +
    'ņŃ¬√ńŇ∆«»… ňŐÕőŌ–—“”‘’÷◊ōŔŕŘ‹›řŖŗŠ‚„šŚśÁŤťÍŽžŪÓÔūŮÚůŰűŲųÝýķŻŁżĢˇ',
    macintosh:  // Python: 'mac_roman'
    'ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø' +
    '¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄€‹›ﬁﬂ‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ',
    'x-mac-romanian':  // Python: 'mac_romanian'
    'ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ĂȘ∞±≤≥¥µ∂∑∏π∫ªºΩăș' +
    '¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄€‹›Țț‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ',
    'x-mac-turkish':  // Python: 'mac_turkish'
    'ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø' +
    '¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸĞğİıŞş‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔÒÚÛÙˆ˜¯˘˙˚¸˝˛ˇ'
};

/**
 * Decodes an old-style Macintosh string. Returns either a Unicode JavaScript
 * string, or 'undefined' if the encoding is unsupported. For example, we do
 * not support Chinese, Japanese or Korean because these would need large
 * mapping tables.
 * @param {DataView} dataView
 * @param {number} offset
 * @param {number} dataLength
 * @param {string} encoding
 * @returns {string}
 */
decode.MACSTRING = function(dataView, offset, dataLength, encoding) {
    var table = eightBitMacEncodings[encoding];
    if (table === undefined) {
        return undefined;
    }

    var result = '';
    for (var i = 0; i < dataLength; i++) {
        var c = dataView.getUint8(offset + i);
        // In all eight-bit Mac encodings, the characters 0x00..0x7F are
        // mapped to U+0000..U+007F; we only need to look up the others.
        if (c <= 0x7F) {
            result += String.fromCharCode(c);
        } else {
            result += table[c & 0x7F];
        }
    }

    return result;
};

// Helper function for encode.MACSTRING. Returns a dictionary for mapping
// Unicode character codes to their 8-bit MacOS equivalent. This table
// is not exactly a super cheap data structure, but we do not care because
// encoding Macintosh strings is only rarely needed in typical applications.
var macEncodingTableCache = typeof WeakMap === 'function' && new WeakMap();
var macEncodingCacheKeys;
var getMacEncodingTable = function (encoding) {
    // Since we use encoding as a cache key for WeakMap, it has to be
    // a String object and not a literal. And at least on NodeJS 2.10.1,
    // WeakMap requires that the same String instance is passed for cache hits.
    if (!macEncodingCacheKeys) {
        macEncodingCacheKeys = {};
        for (var e in eightBitMacEncodings) {
            /*jshint -W053 */  // Suppress "Do not use String as a constructor."
            macEncodingCacheKeys[e] = new String(e);
        }
    }

    var cacheKey = macEncodingCacheKeys[encoding];
    if (cacheKey === undefined) {
        return undefined;
    }

    // We can't do "if (cache.has(key)) {return cache.get(key)}" here:
    // since garbage collection may run at any time, it could also kick in
    // between the calls to cache.has() and cache.get(). In that case,
    // we would return 'undefined' even though we do support the encoding.
    if (macEncodingTableCache) {
        var cachedTable = macEncodingTableCache.get(cacheKey);
        if (cachedTable !== undefined) {
            return cachedTable;
        }
    }

    var decodingTable = eightBitMacEncodings[encoding];
    if (decodingTable === undefined) {
        return undefined;
    }

    var encodingTable = {};
    for (var i = 0; i < decodingTable.length; i++) {
        encodingTable[decodingTable.charCodeAt(i)] = i + 0x80;
    }

    if (macEncodingTableCache) {
        macEncodingTableCache.set(cacheKey, encodingTable);
    }

    return encodingTable;
};

/**
 * Encodes an old-style Macintosh string. Returns a byte array upon success.
 * If the requested encoding is unsupported, or if the input string contains
 * a character that cannot be expressed in the encoding, the function returns
 * 'undefined'.
 * @param {string} str
 * @param {string} encoding
 * @returns {Array}
 */
encode.MACSTRING = function(str, encoding) {
    var table = getMacEncodingTable(encoding);
    if (table === undefined) {
        return undefined;
    }

    var result = [];
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);

        // In all eight-bit Mac encodings, the characters 0x00..0x7F are
        // mapped to U+0000..U+007F; we only need to look up the others.
        if (c >= 0x80) {
            c = table[c];
            if (c === undefined) {
                // str contains a Unicode character that cannot be encoded
                // in the requested encoding.
                return undefined;
            }
        }
        result[i] = c;
        // result.push(c);
    }

    return result;
};

/**
 * @param {string} str
 * @param {string} encoding
 * @returns {number}
 */
sizeOf.MACSTRING = function(str, encoding) {
    var b = encode.MACSTRING(str, encoding);
    if (b !== undefined) {
        return b.length;
    } else {
        return 0;
    }
};

// Helper for encode.VARDELTAS
function isByteEncodable(value) {
    return value >= -128 && value <= 127;
}

// Helper for encode.VARDELTAS
function encodeVarDeltaRunAsZeroes(deltas, pos, result) {
    var runLength = 0;
    var numDeltas = deltas.length;
    while (pos < numDeltas && runLength < 64 && deltas[pos] === 0) {
        ++pos;
        ++runLength;
    }
    result.push(0x80 | (runLength - 1));
    return pos;
}

// Helper for encode.VARDELTAS
function encodeVarDeltaRunAsBytes(deltas, offset, result) {
    var runLength = 0;
    var numDeltas = deltas.length;
    var pos = offset;
    while (pos < numDeltas && runLength < 64) {
        var value = deltas[pos];
        if (!isByteEncodable(value)) {
            break;
        }

        // Within a byte-encoded run of deltas, a single zero is best
        // stored literally as 0x00 value. However, if we have two or
        // more zeroes in a sequence, it is better to start a new run.
        // Fore example, the sequence of deltas [15, 15, 0, 15, 15]
        // becomes 6 bytes (04 0F 0F 00 0F 0F) when storing the zero
        // within the current run, but 7 bytes (01 0F 0F 80 01 0F 0F)
        // when starting a new run.
        if (value === 0 && pos + 1 < numDeltas && deltas[pos + 1] === 0) {
            break;
        }

        ++pos;
        ++runLength;
    }
    result.push(runLength - 1);
    for (var i = offset; i < pos; ++i) {
        result.push((deltas[i] + 256) & 0xff);
    }
    return pos;
}

// Helper for encode.VARDELTAS
function encodeVarDeltaRunAsWords(deltas, offset, result) {
    var runLength = 0;
    var numDeltas = deltas.length;
    var pos = offset;
    while (pos < numDeltas && runLength < 64) {
        var value = deltas[pos];

        // Within a word-encoded run of deltas, it is easiest to start
        // a new run (with a different encoding) whenever we encounter
        // a zero value. For example, the sequence [0x6666, 0, 0x7777]
        // needs 7 bytes when storing the zero inside the current run
        // (42 66 66 00 00 77 77), and equally 7 bytes when starting a
        // new run (40 66 66 80 40 77 77).
        if (value === 0) {
            break;
        }

        // Within a word-encoded run of deltas, a single value in the
        // range (-128..127) should be encoded within the current run
        // because it is more compact. For example, the sequence
        // [0x6666, 2, 0x7777] becomes 7 bytes when storing the value
        // literally (42 66 66 00 02 77 77), but 8 bytes when starting
        // a new run (40 66 66 00 02 40 77 77).
        if (isByteEncodable(value) && pos + 1 < numDeltas && isByteEncodable(deltas[pos + 1])) {
            break;
        }

        ++pos;
        ++runLength;
    }
    result.push(0x40 | (runLength - 1));
    for (var i = offset; i < pos; ++i) {
        var val = deltas[i];
        result.push(((val + 0x10000) >> 8) & 0xff, (val + 0x100) & 0xff);
    }
    return pos;
}

/**
 * Encode a list of variation adjustment deltas.
 *
 * Variation adjustment deltas are used in ‘gvar’ and ‘cvar’ tables.
 * They indicate how points (in ‘gvar’) or values (in ‘cvar’) get adjusted
 * when generating instances of variation fonts.
 *
 * @see https://www.microsoft.com/typography/otspec/gvar.htm
 * @see https://developer.apple.com/fonts/TrueType-Reference-Manual/RM06/Chap6gvar.html
 * @param {Array}
 * @return {Array}
 */
encode.VARDELTAS = function(deltas) {
    var pos = 0;
    var result = [];
    while (pos < deltas.length) {
        var value = deltas[pos];
        if (value === 0) {
            pos = encodeVarDeltaRunAsZeroes(deltas, pos, result);
        } else if (value >= -128 && value <= 127) {
            pos = encodeVarDeltaRunAsBytes(deltas, pos, result);
        } else {
            pos = encodeVarDeltaRunAsWords(deltas, pos, result);
        }
    }
    return result;
};

// Convert a list of values to a CFF INDEX structure.
// The values should be objects containing name / type / value.
/**
 * @param {Array} l
 * @returns {Array}
 */
encode.INDEX = function(l) {
    //var offset, offsets, offsetEncoder, encodedOffsets, encodedOffset, data,
    //    i, v;
    // Because we have to know which data type to use to encode the offsets,
    // we have to go through the values twice: once to encode the data and
    // calculate the offsets, then again to encode the offsets using the fitting data type.
    var offset = 1; // First offset is always 1.
    var offsets = [offset];
    var data = [];
    for (var i = 0; i < l.length; i += 1) {
        var v = encode.OBJECT(l[i]);
        Array.prototype.push.apply(data, v);
        offset += v.length;
        offsets.push(offset);
    }

    if (data.length === 0) {
        return [0, 0];
    }

    var encodedOffsets = [];
    var offSize = (1 + Math.floor(Math.log(offset) / Math.log(2)) / 8) | 0;
    var offsetEncoder = [undefined, encode.BYTE, encode.USHORT, encode.UINT24, encode.ULONG][offSize];
    for (var i$1 = 0; i$1 < offsets.length; i$1 += 1) {
        var encodedOffset = offsetEncoder(offsets[i$1]);
        Array.prototype.push.apply(encodedOffsets, encodedOffset);
    }

    return Array.prototype.concat(encode.Card16(l.length),
                           encode.OffSize(offSize),
                           encodedOffsets,
                           data);
};

/**
 * @param {Array}
 * @returns {number}
 */
sizeOf.INDEX = function(v) {
    return encode.INDEX(v).length;
};

/**
 * Convert an object to a CFF DICT structure.
 * The keys should be numeric.
 * The values should be objects containing name / type / value.
 * @param {Object} m
 * @returns {Array}
 */
encode.DICT = function(m) {
    var d = [];
    var keys = Object.keys(m);
    var length = keys.length;

    for (var i = 0; i < length; i += 1) {
        // Object.keys() return string keys, but our keys are always numeric.
        var k = parseInt(keys[i], 0);
        var v = m[k];
        // Value comes before the key.
        d = d.concat(encode.OPERAND(v.value, v.type));
        d = d.concat(encode.OPERATOR(k));
    }

    return d;
};

/**
 * @param {Object}
 * @returns {number}
 */
sizeOf.DICT = function(m) {
    return encode.DICT(m).length;
};

/**
 * @param {number}
 * @returns {Array}
 */
encode.OPERATOR = function(v) {
    if (v < 1200) {
        return [v];
    } else {
        return [12, v - 1200];
    }
};

/**
 * @param {Array} v
 * @param {string}
 * @returns {Array}
 */
encode.OPERAND = function(v, type) {
    var d = [];
    if (Array.isArray(type)) {
        for (var i = 0; i < type.length; i += 1) {
            check.argument(v.length === type.length, 'Not enough arguments given for type' + type);
            d = d.concat(encode.OPERAND(v[i], type[i]));
        }
    } else {
        if (type === 'SID') {
            d = d.concat(encode.NUMBER(v));
        } else if (type === 'offset') {
            // We make it easy for ourselves and always encode offsets as
            // 4 bytes. This makes offset calculation for the top dict easier.
            d = d.concat(encode.NUMBER32(v));
        } else if (type === 'number') {
            d = d.concat(encode.NUMBER(v));
        } else if (type === 'real') {
            d = d.concat(encode.REAL(v));
        } else {
            throw new Error('Unknown operand type ' + type);
            // FIXME Add support for booleans
        }
    }

    return d;
};

encode.OP = encode.BYTE;
sizeOf.OP = sizeOf.BYTE;

// memoize charstring encoding using WeakMap if available
var wmm = typeof WeakMap === 'function' && new WeakMap();

/**
 * Convert a list of CharString operations to bytes.
 * @param {Array}
 * @returns {Array}
 */
encode.CHARSTRING = function(ops) {
    // See encode.MACSTRING for why we don't do "if (wmm && wmm.has(ops))".
    if (wmm) {
        var cachedValue = wmm.get(ops);
        if (cachedValue !== undefined) {
            return cachedValue;
        }
    }

    var d = [];
    var length = ops.length;

    for (var i = 0; i < length; i += 1) {
        var op = ops[i];
        d = d.concat(encode[op.type](op.value));
    }

    if (wmm) {
        wmm.set(ops, d);
    }

    return d;
};

/**
 * @param {Array}
 * @returns {number}
 */
sizeOf.CHARSTRING = function(ops) {
    return encode.CHARSTRING(ops).length;
};

// Utility functions ////////////////////////////////////////////////////////

/**
 * Convert an object containing name / type / value to bytes.
 * @param {Object}
 * @returns {Array}
 */
encode.OBJECT = function(v) {
    var encodingFunction = encode[v.type];
    check.argument(encodingFunction !== undefined, 'No encoding function for type ' + v.type);
    return encodingFunction(v.value);
};

/**
 * @param {Object}
 * @returns {number}
 */
sizeOf.OBJECT = function(v) {
    var sizeOfFunction = sizeOf[v.type];
    check.argument(sizeOfFunction !== undefined, 'No sizeOf function for type ' + v.type);
    return sizeOfFunction(v.value);
};

/**
 * Convert a table object to bytes.
 * A table contains a list of fields containing the metadata (name, type and default value).
 * The table itself has the field values set as attributes.
 * @param {opentype.Table}
 * @returns {Array}
 */
encode.TABLE = function(table) {
    var d = [];
    var length = table.fields.length;
    var subtables = [];
    var subtableOffsets = [];

    for (var i = 0; i < length; i += 1) {
        var field = table.fields[i];
        var encodingFunction = encode[field.type];
        check.argument(encodingFunction !== undefined, 'No encoding function for field type ' + field.type + ' (' + field.name + ')');
        var value = table[field.name];
        if (value === undefined) {
            value = field.value;
        }

        var bytes = encodingFunction(value);

        if (field.type === 'TABLE') {
            subtableOffsets.push(d.length);
            d = d.concat([0, 0]);
            subtables.push(bytes);
        } else {
            d = d.concat(bytes);
        }
    }

    for (var i$1 = 0; i$1 < subtables.length; i$1 += 1) {
        var o = subtableOffsets[i$1];
        var offset = d.length;
        check.argument(offset < 65536, 'Table ' + table.tableName + ' too big.');
        d[o] = offset >> 8;
        d[o + 1] = offset & 0xff;
        d = d.concat(subtables[i$1]);
    }

    return d;
};

/**
 * @param {opentype.Table}
 * @returns {number}
 */
sizeOf.TABLE = function(table) {
    var numBytes = 0;
    var length = table.fields.length;

    for (var i = 0; i < length; i += 1) {
        var field = table.fields[i];
        var sizeOfFunction = sizeOf[field.type];
        check.argument(sizeOfFunction !== undefined, 'No sizeOf function for field type ' + field.type + ' (' + field.name + ')');
        var value = table[field.name];
        if (value === undefined) {
            value = field.value;
        }

        numBytes += sizeOfFunction(value);

        // Subtables take 2 more bytes for offsets.
        if (field.type === 'TABLE') {
            numBytes += 2;
        }
    }

    return numBytes;
};

encode.RECORD = encode.TABLE;
sizeOf.RECORD = sizeOf.TABLE;

// Merge in a list of bytes.
encode.LITERAL = function(v) {
    return v;
};

sizeOf.LITERAL = function(v) {
    return v.length;
};

// Table metadata

/**
 * @exports opentype.Table
 * @class
 * @param {string} tableName
 * @param {Array} fields
 * @param {Object} options
 * @constructor
 */
function Table(tableName, fields, options) {
    var this$1 = this;

    for (var i = 0; i < fields.length; i += 1) {
        var field = fields[i];
        this$1[field.name] = field.value;
    }

    this.tableName = tableName;
    this.fields = fields;
    if (options) {
        var optionKeys = Object.keys(options);
        for (var i$1 = 0; i$1 < optionKeys.length; i$1 += 1) {
            var k = optionKeys[i$1];
            var v = options[k];
            if (this$1[k] !== undefined) {
                this$1[k] = v;
            }
        }
    }
}

/**
 * Encodes the table and returns an array of bytes
 * @return {Array}
 */
Table.prototype.encode = function() {
    return encode.TABLE(this);
};

/**
 * Get the size of the table.
 * @return {number}
 */
Table.prototype.sizeOf = function() {
    return sizeOf.TABLE(this);
};

/**
 * @private
 */
function ushortList(itemName, list, count) {
    if (count === undefined) {
        count = list.length;
    }
    var fields = new Array(list.length + 1);
    fields[0] = {name: itemName + 'Count', type: 'USHORT', value: count};
    for (var i = 0; i < list.length; i++) {
        fields[i + 1] = {name: itemName + i, type: 'USHORT', value: list[i]};
    }
    return fields;
}

/**
 * @private
 */
function tableList(itemName, records, itemCallback) {
    var count = records.length;
    var fields = new Array(count + 1);
    fields[0] = {name: itemName + 'Count', type: 'USHORT', value: count};
    for (var i = 0; i < count; i++) {
        fields[i + 1] = {name: itemName + i, type: 'TABLE', value: itemCallback(records[i], i)};
    }
    return fields;
}

/**
 * @private
 */
function recordList(itemName, records, itemCallback) {
    var count = records.length;
    var fields = [];
    fields[0] = {name: itemName + 'Count', type: 'USHORT', value: count};
    for (var i = 0; i < count; i++) {
        fields = fields.concat(itemCallback(records[i], i));
    }
    return fields;
}

// Common Layout Tables

/**
 * @exports opentype.Coverage
 * @class
 * @param {opentype.Table}
 * @constructor
 * @extends opentype.Table
 */
function Coverage(coverageTable) {
    if (coverageTable.format === 1) {
        Table.call(this, 'coverageTable',
            [{name: 'coverageFormat', type: 'USHORT', value: 1}]
            .concat(ushortList('glyph', coverageTable.glyphs))
        );
    } else {
        check.assert(false, 'Can\'t create coverage table format 2 yet.');
    }
}
Coverage.prototype = Object.create(Table.prototype);
Coverage.prototype.constructor = Coverage;

function ScriptList(scriptListTable) {
    Table.call(this, 'scriptListTable',
        recordList('scriptRecord', scriptListTable, function(scriptRecord, i) {
            var script = scriptRecord.script;
            var defaultLangSys = script.defaultLangSys;
            check.assert(!!defaultLangSys, 'Unable to write GSUB: script ' + scriptRecord.tag + ' has no default language system.');
            return [
                {name: 'scriptTag' + i, type: 'TAG', value: scriptRecord.tag},
                {name: 'script' + i, type: 'TABLE', value: new Table('scriptTable', [
                    {name: 'defaultLangSys', type: 'TABLE', value: new Table('defaultLangSys', [
                        {name: 'lookupOrder', type: 'USHORT', value: 0},
                        {name: 'reqFeatureIndex', type: 'USHORT', value: defaultLangSys.reqFeatureIndex}]
                        .concat(ushortList('featureIndex', defaultLangSys.featureIndexes)))}
                    ].concat(recordList('langSys', script.langSysRecords, function(langSysRecord, i) {
                        var langSys = langSysRecord.langSys;
                        return [
                            {name: 'langSysTag' + i, type: 'TAG', value: langSysRecord.tag},
                            {name: 'langSys' + i, type: 'TABLE', value: new Table('langSys', [
                                {name: 'lookupOrder', type: 'USHORT', value: 0},
                                {name: 'reqFeatureIndex', type: 'USHORT', value: langSys.reqFeatureIndex}
                                ].concat(ushortList('featureIndex', langSys.featureIndexes)))}
                        ];
                    })))}
            ];
        })
    );
}
ScriptList.prototype = Object.create(Table.prototype);
ScriptList.prototype.constructor = ScriptList;

/**
 * @exports opentype.FeatureList
 * @class
 * @param {opentype.Table}
 * @constructor
 * @extends opentype.Table
 */
function FeatureList(featureListTable) {
    Table.call(this, 'featureListTable',
        recordList('featureRecord', featureListTable, function(featureRecord, i) {
            var feature = featureRecord.feature;
            return [
                {name: 'featureTag' + i, type: 'TAG', value: featureRecord.tag},
                {name: 'feature' + i, type: 'TABLE', value: new Table('featureTable', [
                    {name: 'featureParams', type: 'USHORT', value: feature.featureParams} ].concat(ushortList('lookupListIndex', feature.lookupListIndexes)))}
            ];
        })
    );
}
FeatureList.prototype = Object.create(Table.prototype);
FeatureList.prototype.constructor = FeatureList;

/**
 * @exports opentype.LookupList
 * @class
 * @param {opentype.Table}
 * @param {Object}
 * @constructor
 * @extends opentype.Table
 */
function LookupList(lookupListTable, subtableMakers) {
    Table.call(this, 'lookupListTable', tableList('lookup', lookupListTable, function(lookupTable) {
        var subtableCallback = subtableMakers[lookupTable.lookupType];
        check.assert(!!subtableCallback, 'Unable to write GSUB lookup type ' + lookupTable.lookupType + ' tables.');
        return new Table('lookupTable', [
            {name: 'lookupType', type: 'USHORT', value: lookupTable.lookupType},
            {name: 'lookupFlag', type: 'USHORT', value: lookupTable.lookupFlag}
        ].concat(tableList('subtable', lookupTable.subtables, subtableCallback)));
    }));
}
LookupList.prototype = Object.create(Table.prototype);
LookupList.prototype.constructor = LookupList;

// Record = same as Table, but inlined (a Table has an offset and its data is further in the stream)
// Don't use offsets inside Records (probable bug), only in Tables.
var table = {
    Table: Table,
    Record: Table,
    Coverage: Coverage,
    ScriptList: ScriptList,
    FeatureList: FeatureList,
    LookupList: LookupList,
    ushortList: ushortList,
    tableList: tableList,
    recordList: recordList,
};

// Parsing utility functions

// Retrieve an unsigned byte from the DataView.
function getByte(dataView, offset) {
    return dataView.getUint8(offset);
}

// Retrieve an unsigned 16-bit short from the DataView.
// The value is stored in big endian.
function getUShort(dataView, offset) {
    return dataView.getUint16(offset, false);
}

// Retrieve a signed 16-bit short from the DataView.
// The value is stored in big endian.
function getShort(dataView, offset) {
    return dataView.getInt16(offset, false);
}

// Retrieve an unsigned 32-bit long from the DataView.
// The value is stored in big endian.
function getULong(dataView, offset) {
    return dataView.getUint32(offset, false);
}

// Retrieve a 32-bit signed fixed-point number (16.16) from the DataView.
// The value is stored in big endian.
function getFixed(dataView, offset) {
    var decimal = dataView.getInt16(offset, false);
    var fraction = dataView.getUint16(offset + 2, false);
    return decimal + fraction / 65535;
}

// Retrieve a 4-character tag from the DataView.
// Tags are used to identify tables.
function getTag(dataView, offset) {
    var tag = '';
    for (var i = offset; i < offset + 4; i += 1) {
        tag += String.fromCharCode(dataView.getInt8(i));
    }

    return tag;
}

// Retrieve an offset from the DataView.
// Offsets are 1 to 4 bytes in length, depending on the offSize argument.
function getOffset(dataView, offset, offSize) {
    var v = 0;
    for (var i = 0; i < offSize; i += 1) {
        v <<= 8;
        v += dataView.getUint8(offset + i);
    }

    return v;
}

// Retrieve a number of bytes from start offset to the end offset from the DataView.
function getBytes(dataView, startOffset, endOffset) {
    var bytes = [];
    for (var i = startOffset; i < endOffset; i += 1) {
        bytes.push(dataView.getUint8(i));
    }

    return bytes;
}

// Convert the list of bytes to a string.
function bytesToString(bytes) {
    var s = '';
    for (var i = 0; i < bytes.length; i += 1) {
        s += String.fromCharCode(bytes[i]);
    }

    return s;
}

var typeOffsets = {
    byte: 1,
    uShort: 2,
    short: 2,
    uLong: 4,
    fixed: 4,
    longDateTime: 8,
    tag: 4
};

// A stateful parser that changes the offset whenever a value is retrieved.
// The data is a DataView.
function Parser(data, offset) {
    this.data = data;
    this.offset = offset;
    this.relativeOffset = 0;
}

Parser.prototype.parseByte = function() {
    var v = this.data.getUint8(this.offset + this.relativeOffset);
    this.relativeOffset += 1;
    return v;
};

Parser.prototype.parseChar = function() {
    var v = this.data.getInt8(this.offset + this.relativeOffset);
    this.relativeOffset += 1;
    return v;
};

Parser.prototype.parseCard8 = Parser.prototype.parseByte;

Parser.prototype.parseUShort = function() {
    var v = this.data.getUint16(this.offset + this.relativeOffset);
    this.relativeOffset += 2;
    return v;
};

Parser.prototype.parseCard16 = Parser.prototype.parseUShort;
Parser.prototype.parseSID = Parser.prototype.parseUShort;
Parser.prototype.parseOffset16 = Parser.prototype.parseUShort;

Parser.prototype.parseShort = function() {
    var v = this.data.getInt16(this.offset + this.relativeOffset);
    this.relativeOffset += 2;
    return v;
};

Parser.prototype.parseF2Dot14 = function() {
    var v = this.data.getInt16(this.offset + this.relativeOffset) / 16384;
    this.relativeOffset += 2;
    return v;
};

Parser.prototype.parseULong = function() {
    var v = getULong(this.data, this.offset + this.relativeOffset);
    this.relativeOffset += 4;
    return v;
};

Parser.prototype.parseFixed = function() {
    var v = getFixed(this.data, this.offset + this.relativeOffset);
    this.relativeOffset += 4;
    return v;
};

Parser.prototype.parseString = function(length) {
    var dataView = this.data;
    var offset = this.offset + this.relativeOffset;
    var string = '';
    this.relativeOffset += length;
    for (var i = 0; i < length; i++) {
        string += String.fromCharCode(dataView.getUint8(offset + i));
    }

    return string;
};

Parser.prototype.parseTag = function() {
    return this.parseString(4);
};

// LONGDATETIME is a 64-bit integer.
// JavaScript and unix timestamps traditionally use 32 bits, so we
// only take the last 32 bits.
// + Since until 2038 those bits will be filled by zeros we can ignore them.
Parser.prototype.parseLongDateTime = function() {
    var v = getULong(this.data, this.offset + this.relativeOffset + 4);
    // Subtract seconds between 01/01/1904 and 01/01/1970
    // to convert Apple Mac timestamp to Standard Unix timestamp
    v -= 2082844800;
    this.relativeOffset += 8;
    return v;
};

Parser.prototype.parseVersion = function() {
    var major = getUShort(this.data, this.offset + this.relativeOffset);

    // How to interpret the minor version is very vague in the spec. 0x5000 is 5, 0x1000 is 1
    // This returns the correct number if minor = 0xN000 where N is 0-9
    var minor = getUShort(this.data, this.offset + this.relativeOffset + 2);
    this.relativeOffset += 4;
    return major + minor / 0x1000 / 10;
};

Parser.prototype.skip = function(type, amount) {
    if (amount === undefined) {
        amount = 1;
    }

    this.relativeOffset += typeOffsets[type] * amount;
};

///// Parsing lists and records ///////////////////////////////

// Parse a list of 16 bit unsigned integers. The length of the list can be read on the stream
// or provided as an argument.
Parser.prototype.parseOffset16List =
Parser.prototype.parseUShortList = function(count) {
    if (count === undefined) { count = this.parseUShort(); }
    var offsets = new Array(count);
    var dataView = this.data;
    var offset = this.offset + this.relativeOffset;
    for (var i = 0; i < count; i++) {
        offsets[i] = dataView.getUint16(offset);
        offset += 2;
    }

    this.relativeOffset += count * 2;
    return offsets;
};

// Parses a list of 16 bit signed integers.
Parser.prototype.parseShortList = function(count) {
    var list = new Array(count);
    var dataView = this.data;
    var offset = this.offset + this.relativeOffset;
    for (var i = 0; i < count; i++) {
        list[i] = dataView.getInt16(offset);
        offset += 2;
    }

    this.relativeOffset += count * 2;
    return list;
};

// Parses a list of bytes.
Parser.prototype.parseByteList = function(count) {
    var list = new Array(count);
    var dataView = this.data;
    var offset = this.offset + this.relativeOffset;
    for (var i = 0; i < count; i++) {
        list[i] = dataView.getUint8(offset++);
    }

    this.relativeOffset += count;
    return list;
};

/**
 * Parse a list of items.
 * Record count is optional, if omitted it is read from the stream.
 * itemCallback is one of the Parser methods.
 */
Parser.prototype.parseList = function(count, itemCallback) {
    var this$1 = this;

    if (!itemCallback) {
        itemCallback = count;
        count = this.parseUShort();
    }
    var list = new Array(count);
    for (var i = 0; i < count; i++) {
        list[i] = itemCallback.call(this$1);
    }
    return list;
};

/**
 * Parse a list of records.
 * Record count is optional, if omitted it is read from the stream.
 * Example of recordDescription: { sequenceIndex: Parser.uShort, lookupListIndex: Parser.uShort }
 */
Parser.prototype.parseRecordList = function(count, recordDescription) {
    var this$1 = this;

    // If the count argument is absent, read it in the stream.
    if (!recordDescription) {
        recordDescription = count;
        count = this.parseUShort();
    }
    var records = new Array(count);
    var fields = Object.keys(recordDescription);
    for (var i = 0; i < count; i++) {
        var rec = {};
        for (var j = 0; j < fields.length; j++) {
            var fieldName = fields[j];
            var fieldType = recordDescription[fieldName];
            rec[fieldName] = fieldType.call(this$1);
        }
        records[i] = rec;
    }
    return records;
};

// Parse a data structure into an object
// Example of description: { sequenceIndex: Parser.uShort, lookupListIndex: Parser.uShort }
Parser.prototype.parseStruct = function(description) {
    var this$1 = this;

    if (typeof description === 'function') {
        return description.call(this);
    } else {
        var fields = Object.keys(description);
        var struct = {};
        for (var j = 0; j < fields.length; j++) {
            var fieldName = fields[j];
            var fieldType = description[fieldName];
            struct[fieldName] = fieldType.call(this$1);
        }
        return struct;
    }
};

Parser.prototype.parsePointer = function(description) {
    var structOffset = this.parseOffset16();
    if (structOffset > 0) {                         // NULL offset => return undefined
        return new Parser(this.data, this.offset + structOffset).parseStruct(description);
    }
    return undefined;
};

/**
 * Parse a list of offsets to lists of 16-bit integers,
 * or a list of offsets to lists of offsets to any kind of items.
 * If itemCallback is not provided, a list of list of UShort is assumed.
 * If provided, itemCallback is called on each item and must parse the item.
 * See examples in tables/gsub.js
 */
Parser.prototype.parseListOfLists = function(itemCallback) {
    var this$1 = this;

    var offsets = this.parseOffset16List();
    var count = offsets.length;
    var relativeOffset = this.relativeOffset;
    var list = new Array(count);
    for (var i = 0; i < count; i++) {
        var start = offsets[i];
        if (start === 0) {                  // NULL offset
            list[i] = undefined;            // Add i as owned property to list. Convenient with assert.
            continue;
        }
        this$1.relativeOffset = start;
        if (itemCallback) {
            var subOffsets = this$1.parseOffset16List();
            var subList = new Array(subOffsets.length);
            for (var j = 0; j < subOffsets.length; j++) {
                this$1.relativeOffset = start + subOffsets[j];
                subList[j] = itemCallback.call(this$1);
            }
            list[i] = subList;
        } else {
            list[i] = this$1.parseUShortList();
        }
    }
    this.relativeOffset = relativeOffset;
    return list;
};

///// Complex tables parsing //////////////////////////////////

// Parse a coverage table in a GSUB, GPOS or GDEF table.
// https://www.microsoft.com/typography/OTSPEC/chapter2.htm
// parser.offset must point to the start of the table containing the coverage.
Parser.prototype.parseCoverage = function() {
    var this$1 = this;

    var startOffset = this.offset + this.relativeOffset;
    var format = this.parseUShort();
    var count = this.parseUShort();
    if (format === 1) {
        return {
            format: 1,
            glyphs: this.parseUShortList(count)
        };
    } else if (format === 2) {
        var ranges = new Array(count);
        for (var i = 0; i < count; i++) {
            ranges[i] = {
                start: this$1.parseUShort(),
                end: this$1.parseUShort(),
                index: this$1.parseUShort()
            };
        }
        return {
            format: 2,
            ranges: ranges
        };
    }
    throw new Error('0x' + startOffset.toString(16) + ': Coverage format must be 1 or 2.');
};

// Parse a Class Definition Table in a GSUB, GPOS or GDEF table.
// https://www.microsoft.com/typography/OTSPEC/chapter2.htm
Parser.prototype.parseClassDef = function() {
    var startOffset = this.offset + this.relativeOffset;
    var format = this.parseUShort();
    if (format === 1) {
        return {
            format: 1,
            startGlyph: this.parseUShort(),
            classes: this.parseUShortList()
        };
    } else if (format === 2) {
        return {
            format: 2,
            ranges: this.parseRecordList({
                start: Parser.uShort,
                end: Parser.uShort,
                classId: Parser.uShort
            })
        };
    }
    throw new Error('0x' + startOffset.toString(16) + ': ClassDef format must be 1 or 2.');
};

///// Static methods ///////////////////////////////////
// These convenience methods can be used as callbacks and should be called with "this" context set to a Parser instance.

Parser.list = function(count, itemCallback) {
    return function() {
        return this.parseList(count, itemCallback);
    };
};

Parser.recordList = function(count, recordDescription) {
    return function() {
        return this.parseRecordList(count, recordDescription);
    };
};

Parser.pointer = function(description) {
    return function() {
        return this.parsePointer(description);
    };
};

Parser.tag = Parser.prototype.parseTag;
Parser.byte = Parser.prototype.parseByte;
Parser.uShort = Parser.offset16 = Parser.prototype.parseUShort;
Parser.uShortList = Parser.prototype.parseUShortList;
Parser.struct = Parser.prototype.parseStruct;
Parser.coverage = Parser.prototype.parseCoverage;
Parser.classDef = Parser.prototype.parseClassDef;

///// Script, Feature, Lookup lists ///////////////////////////////////////////////
// https://www.microsoft.com/typography/OTSPEC/chapter2.htm

var langSysTable = {
    reserved: Parser.uShort,
    reqFeatureIndex: Parser.uShort,
    featureIndexes: Parser.uShortList
};

Parser.prototype.parseScriptList = function() {
    return this.parsePointer(Parser.recordList({
        tag: Parser.tag,
        script: Parser.pointer({
            defaultLangSys: Parser.pointer(langSysTable),
            langSysRecords: Parser.recordList({
                tag: Parser.tag,
                langSys: Parser.pointer(langSysTable)
            })
        })
    }));
};

Parser.prototype.parseFeatureList = function() {
    return this.parsePointer(Parser.recordList({
        tag: Parser.tag,
        feature: Parser.pointer({
            featureParams: Parser.offset16,
            lookupListIndexes: Parser.uShortList
        })
    }));
};

Parser.prototype.parseLookupList = function(lookupTableParsers) {
    return this.parsePointer(Parser.list(Parser.pointer(function() {
        var lookupType = this.parseUShort();
        check.argument(1 <= lookupType && lookupType <= 8, 'GSUB lookup type ' + lookupType + ' unknown.');
        var lookupFlag = this.parseUShort();
        var useMarkFilteringSet = lookupFlag & 0x10;
        return {
            lookupType: lookupType,
            lookupFlag: lookupFlag,
            subtables: this.parseList(Parser.pointer(lookupTableParsers[lookupType])),
            markFilteringSet: useMarkFilteringSet ? this.parseUShort() : undefined
        };
    })));
};

var parse = {
    getByte: getByte,
    getCard8: getByte,
    getUShort: getUShort,
    getCard16: getUShort,
    getShort: getShort,
    getULong: getULong,
    getFixed: getFixed,
    getTag: getTag,
    getOffset: getOffset,
    getBytes: getBytes,
    bytesToString: bytesToString,
    Parser: Parser,
};

// The `cmap` table stores the mappings from characters to glyphs.
// https://www.microsoft.com/typography/OTSPEC/cmap.htm

function parseCmapTableFormat12(cmap, p) {
    //Skip reserved.
    p.parseUShort();

    // Length in bytes of the sub-tables.
    cmap.length = p.parseULong();
    cmap.language = p.parseULong();

    var groupCount;
    cmap.groupCount = groupCount = p.parseULong();
    cmap.glyphIndexMap = {};

    for (var i = 0; i < groupCount; i += 1) {
        var startCharCode = p.parseULong();
        var endCharCode = p.parseULong();
        var startGlyphId = p.parseULong();

        for (var c = startCharCode; c <= endCharCode; c += 1) {
            cmap.glyphIndexMap[c] = startGlyphId;
            startGlyphId++;
        }
    }
}

function parseCmapTableFormat4(cmap, p, data, start, offset) {
    // Length in bytes of the sub-tables.
    cmap.length = p.parseUShort();
    cmap.language = p.parseUShort();

    // segCount is stored x 2.
    var segCount;
    cmap.segCount = segCount = p.parseUShort() >> 1;

    // Skip searchRange, entrySelector, rangeShift.
    p.skip('uShort', 3);

    // The "unrolled" mapping from character codes to glyph indices.
    cmap.glyphIndexMap = {};
    var endCountParser = new parse.Parser(data, start + offset + 14);
    var startCountParser = new parse.Parser(data, start + offset + 16 + segCount * 2);
    var idDeltaParser = new parse.Parser(data, start + offset + 16 + segCount * 4);
    var idRangeOffsetParser = new parse.Parser(data, start + offset + 16 + segCount * 6);
    var glyphIndexOffset = start + offset + 16 + segCount * 8;
    for (var i = 0; i < segCount - 1; i += 1) {
        var glyphIndex = (void 0);
        var endCount = endCountParser.parseUShort();
        var startCount = startCountParser.parseUShort();
        var idDelta = idDeltaParser.parseShort();
        var idRangeOffset = idRangeOffsetParser.parseUShort();
        for (var c = startCount; c <= endCount; c += 1) {
            if (idRangeOffset !== 0) {
                // The idRangeOffset is relative to the current position in the idRangeOffset array.
                // Take the current offset in the idRangeOffset array.
                glyphIndexOffset = (idRangeOffsetParser.offset + idRangeOffsetParser.relativeOffset - 2);

                // Add the value of the idRangeOffset, which will move us into the glyphIndex array.
                glyphIndexOffset += idRangeOffset;

                // Then add the character index of the current segment, multiplied by 2 for USHORTs.
                glyphIndexOffset += (c - startCount) * 2;
                glyphIndex = parse.getUShort(data, glyphIndexOffset);
                if (glyphIndex !== 0) {
                    glyphIndex = (glyphIndex + idDelta) & 0xFFFF;
                }
            } else {
                glyphIndex = (c + idDelta) & 0xFFFF;
            }

            cmap.glyphIndexMap[c] = glyphIndex;
        }
    }
}

// Parse the `cmap` table. This table stores the mappings from characters to glyphs.
// There are many available formats, but we only support the Windows format 4 and 12.
// This function returns a `CmapEncoding` object or null if no supported format could be found.
function parseCmapTable(data, start) {
    var cmap = {};
    cmap.version = parse.getUShort(data, start);
    check.argument(cmap.version === 0, 'cmap table version should be 0.');

    // The cmap table can contain many sub-tables, each with their own format.
    // We're only interested in a "platform 3" table. This is a Windows format.
    cmap.numTables = parse.getUShort(data, start + 2);
    var offset = -1;
    for (var i = cmap.numTables - 1; i >= 0; i -= 1) {
        var platformId = parse.getUShort(data, start + 4 + (i * 8));
        var encodingId = parse.getUShort(data, start + 4 + (i * 8) + 2);
        if (platformId === 3 && (encodingId === 0 || encodingId === 1 || encodingId === 10)) {
            offset = parse.getULong(data, start + 4 + (i * 8) + 4);
            break;
        }
    }

    if (offset === -1) {
        // There is no cmap table in the font that we support.
        throw new Error('No valid cmap sub-tables found.');
    }

    var p = new parse.Parser(data, start + offset);
    cmap.format = p.parseUShort();

    if (cmap.format === 12) {
        parseCmapTableFormat12(cmap, p);
    } else if (cmap.format === 4) {
        parseCmapTableFormat4(cmap, p, data, start, offset);
    } else {
        throw new Error('Only format 4 and 12 cmap tables are supported (found format ' + cmap.format + ').');
    }

    return cmap;
}

function addSegment(t, code, glyphIndex) {
    t.segments.push({
        end: code,
        start: code,
        delta: -(code - glyphIndex),
        offset: 0
    });
}

function addTerminatorSegment(t) {
    t.segments.push({
        end: 0xFFFF,
        start: 0xFFFF,
        delta: 1,
        offset: 0
    });
}

function makeCmapTable(glyphs) {
    var t = new table.Table('cmap', [
        {name: 'version', type: 'USHORT', value: 0},
        {name: 'numTables', type: 'USHORT', value: 1},
        {name: 'platformID', type: 'USHORT', value: 3},
        {name: 'encodingID', type: 'USHORT', value: 1},
        {name: 'offset', type: 'ULONG', value: 12},
        {name: 'format', type: 'USHORT', value: 4},
        {name: 'length', type: 'USHORT', value: 0},
        {name: 'language', type: 'USHORT', value: 0},
        {name: 'segCountX2', type: 'USHORT', value: 0},
        {name: 'searchRange', type: 'USHORT', value: 0},
        {name: 'entrySelector', type: 'USHORT', value: 0},
        {name: 'rangeShift', type: 'USHORT', value: 0}
    ]);

    t.segments = [];
    for (var i = 0; i < glyphs.length; i += 1) {
        var glyph = glyphs.get(i);
        for (var j = 0; j < glyph.unicodes.length; j += 1) {
            addSegment(t, glyph.unicodes[j], i);
        }

        t.segments = t.segments.sort(function(a, b) {
            return a.start - b.start;
        });
    }

    addTerminatorSegment(t);

    var segCount;
    segCount = t.segments.length;
    t.segCountX2 = segCount * 2;
    t.searchRange = Math.pow(2, Math.floor(Math.log(segCount) / Math.log(2))) * 2;
    t.entrySelector = Math.log(t.searchRange / 2) / Math.log(2);
    t.rangeShift = t.segCountX2 - t.searchRange;

    // Set up parallel segment arrays.
    var endCounts = [];
    var startCounts = [];
    var idDeltas = [];
    var idRangeOffsets = [];
    var glyphIds = [];

    for (var i$1 = 0; i$1 < segCount; i$1 += 1) {
        var segment = t.segments[i$1];
        endCounts = endCounts.concat({name: 'end_' + i$1, type: 'USHORT', value: segment.end});
        startCounts = startCounts.concat({name: 'start_' + i$1, type: 'USHORT', value: segment.start});
        idDeltas = idDeltas.concat({name: 'idDelta_' + i$1, type: 'SHORT', value: segment.delta});
        idRangeOffsets = idRangeOffsets.concat({name: 'idRangeOffset_' + i$1, type: 'USHORT', value: segment.offset});
        if (segment.glyphId !== undefined) {
            glyphIds = glyphIds.concat({name: 'glyph_' + i$1, type: 'USHORT', value: segment.glyphId});
        }
    }

    t.fields = t.fields.concat(endCounts);
    t.fields.push({name: 'reservedPad', type: 'USHORT', value: 0});
    t.fields = t.fields.concat(startCounts);
    t.fields = t.fields.concat(idDeltas);
    t.fields = t.fields.concat(idRangeOffsets);
    t.fields = t.fields.concat(glyphIds);

    t.length = 14 + // Subtable header
        endCounts.length * 2 +
        2 + // reservedPad
        startCounts.length * 2 +
        idDeltas.length * 2 +
        idRangeOffsets.length * 2 +
        glyphIds.length * 2;

    return t;
}

var cmap = { parse: parseCmapTable, make: makeCmapTable };

// Glyph encoding

var cffStandardStrings = [
    '.notdef', 'space', 'exclam', 'quotedbl', 'numbersign', 'dollar', 'percent', 'ampersand', 'quoteright',
    'parenleft', 'parenright', 'asterisk', 'plus', 'comma', 'hyphen', 'period', 'slash', 'zero', 'one', 'two',
    'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'colon', 'semicolon', 'less', 'equal', 'greater',
    'question', 'at', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S',
    'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'bracketleft', 'backslash', 'bracketright', 'asciicircum', 'underscore',
    'quoteleft', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't',
    'u', 'v', 'w', 'x', 'y', 'z', 'braceleft', 'bar', 'braceright', 'asciitilde', 'exclamdown', 'cent', 'sterling',
    'fraction', 'yen', 'florin', 'section', 'currency', 'quotesingle', 'quotedblleft', 'guillemotleft',
    'guilsinglleft', 'guilsinglright', 'fi', 'fl', 'endash', 'dagger', 'daggerdbl', 'periodcentered', 'paragraph',
    'bullet', 'quotesinglbase', 'quotedblbase', 'quotedblright', 'guillemotright', 'ellipsis', 'perthousand',
    'questiondown', 'grave', 'acute', 'circumflex', 'tilde', 'macron', 'breve', 'dotaccent', 'dieresis', 'ring',
    'cedilla', 'hungarumlaut', 'ogonek', 'caron', 'emdash', 'AE', 'ordfeminine', 'Lslash', 'Oslash', 'OE',
    'ordmasculine', 'ae', 'dotlessi', 'lslash', 'oslash', 'oe', 'germandbls', 'onesuperior', 'logicalnot', 'mu',
    'trademark', 'Eth', 'onehalf', 'plusminus', 'Thorn', 'onequarter', 'divide', 'brokenbar', 'degree', 'thorn',
    'threequarters', 'twosuperior', 'registered', 'minus', 'eth', 'multiply', 'threesuperior', 'copyright',
    'Aacute', 'Acircumflex', 'Adieresis', 'Agrave', 'Aring', 'Atilde', 'Ccedilla', 'Eacute', 'Ecircumflex',
    'Edieresis', 'Egrave', 'Iacute', 'Icircumflex', 'Idieresis', 'Igrave', 'Ntilde', 'Oacute', 'Ocircumflex',
    'Odieresis', 'Ograve', 'Otilde', 'Scaron', 'Uacute', 'Ucircumflex', 'Udieresis', 'Ugrave', 'Yacute',
    'Ydieresis', 'Zcaron', 'aacute', 'acircumflex', 'adieresis', 'agrave', 'aring', 'atilde', 'ccedilla', 'eacute',
    'ecircumflex', 'edieresis', 'egrave', 'iacute', 'icircumflex', 'idieresis', 'igrave', 'ntilde', 'oacute',
    'ocircumflex', 'odieresis', 'ograve', 'otilde', 'scaron', 'uacute', 'ucircumflex', 'udieresis', 'ugrave',
    'yacute', 'ydieresis', 'zcaron', 'exclamsmall', 'Hungarumlautsmall', 'dollaroldstyle', 'dollarsuperior',
    'ampersandsmall', 'Acutesmall', 'parenleftsuperior', 'parenrightsuperior', '266 ff', 'onedotenleader',
    'zerooldstyle', 'oneoldstyle', 'twooldstyle', 'threeoldstyle', 'fouroldstyle', 'fiveoldstyle', 'sixoldstyle',
    'sevenoldstyle', 'eightoldstyle', 'nineoldstyle', 'commasuperior', 'threequartersemdash', 'periodsuperior',
    'questionsmall', 'asuperior', 'bsuperior', 'centsuperior', 'dsuperior', 'esuperior', 'isuperior', 'lsuperior',
    'msuperior', 'nsuperior', 'osuperior', 'rsuperior', 'ssuperior', 'tsuperior', 'ff', 'ffi', 'ffl',
    'parenleftinferior', 'parenrightinferior', 'Circumflexsmall', 'hyphensuperior', 'Gravesmall', 'Asmall',
    'Bsmall', 'Csmall', 'Dsmall', 'Esmall', 'Fsmall', 'Gsmall', 'Hsmall', 'Ismall', 'Jsmall', 'Ksmall', 'Lsmall',
    'Msmall', 'Nsmall', 'Osmall', 'Psmall', 'Qsmall', 'Rsmall', 'Ssmall', 'Tsmall', 'Usmall', 'Vsmall', 'Wsmall',
    'Xsmall', 'Ysmall', 'Zsmall', 'colonmonetary', 'onefitted', 'rupiah', 'Tildesmall', 'exclamdownsmall',
    'centoldstyle', 'Lslashsmall', 'Scaronsmall', 'Zcaronsmall', 'Dieresissmall', 'Brevesmall', 'Caronsmall',
    'Dotaccentsmall', 'Macronsmall', 'figuredash', 'hypheninferior', 'Ogoneksmall', 'Ringsmall', 'Cedillasmall',
    'questiondownsmall', 'oneeighth', 'threeeighths', 'fiveeighths', 'seveneighths', 'onethird', 'twothirds',
    'zerosuperior', 'foursuperior', 'fivesuperior', 'sixsuperior', 'sevensuperior', 'eightsuperior', 'ninesuperior',
    'zeroinferior', 'oneinferior', 'twoinferior', 'threeinferior', 'fourinferior', 'fiveinferior', 'sixinferior',
    'seveninferior', 'eightinferior', 'nineinferior', 'centinferior', 'dollarinferior', 'periodinferior',
    'commainferior', 'Agravesmall', 'Aacutesmall', 'Acircumflexsmall', 'Atildesmall', 'Adieresissmall',
    'Aringsmall', 'AEsmall', 'Ccedillasmall', 'Egravesmall', 'Eacutesmall', 'Ecircumflexsmall', 'Edieresissmall',
    'Igravesmall', 'Iacutesmall', 'Icircumflexsmall', 'Idieresissmall', 'Ethsmall', 'Ntildesmall', 'Ogravesmall',
    'Oacutesmall', 'Ocircumflexsmall', 'Otildesmall', 'Odieresissmall', 'OEsmall', 'Oslashsmall', 'Ugravesmall',
    'Uacutesmall', 'Ucircumflexsmall', 'Udieresissmall', 'Yacutesmall', 'Thornsmall', 'Ydieresissmall', '001.000',
    '001.001', '001.002', '001.003', 'Black', 'Bold', 'Book', 'Light', 'Medium', 'Regular', 'Roman', 'Semibold'];

var cffStandardEncoding = [
    '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '',
    '', '', '', '', 'space', 'exclam', 'quotedbl', 'numbersign', 'dollar', 'percent', 'ampersand', 'quoteright',
    'parenleft', 'parenright', 'asterisk', 'plus', 'comma', 'hyphen', 'period', 'slash', 'zero', 'one', 'two',
    'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'colon', 'semicolon', 'less', 'equal', 'greater',
    'question', 'at', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S',
    'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'bracketleft', 'backslash', 'bracketright', 'asciicircum', 'underscore',
    'quoteleft', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't',
    'u', 'v', 'w', 'x', 'y', 'z', 'braceleft', 'bar', 'braceright', 'asciitilde', '', '', '', '', '', '', '', '',
    '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '',
    'exclamdown', 'cent', 'sterling', 'fraction', 'yen', 'florin', 'section', 'currency', 'quotesingle',
    'quotedblleft', 'guillemotleft', 'guilsinglleft', 'guilsinglright', 'fi', 'fl', '', 'endash', 'dagger',
    'daggerdbl', 'periodcentered', '', 'paragraph', 'bullet', 'quotesinglbase', 'quotedblbase', 'quotedblright',
    'guillemotright', 'ellipsis', 'perthousand', '', 'questiondown', '', 'grave', 'acute', 'circumflex', 'tilde',
    'macron', 'breve', 'dotaccent', 'dieresis', '', 'ring', 'cedilla', '', 'hungarumlaut', 'ogonek', 'caron',
    'emdash', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'AE', '', 'ordfeminine', '', '', '',
    '', 'Lslash', 'Oslash', 'OE', 'ordmasculine', '', '', '', '', '', 'ae', '', '', '', 'dotlessi', '', '',
    'lslash', 'oslash', 'oe', 'germandbls'];

var cffExpertEncoding = [
    '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '',
    '', '', '', '', 'space', 'exclamsmall', 'Hungarumlautsmall', '', 'dollaroldstyle', 'dollarsuperior',
    'ampersandsmall', 'Acutesmall', 'parenleftsuperior', 'parenrightsuperior', 'twodotenleader', 'onedotenleader',
    'comma', 'hyphen', 'period', 'fraction', 'zerooldstyle', 'oneoldstyle', 'twooldstyle', 'threeoldstyle',
    'fouroldstyle', 'fiveoldstyle', 'sixoldstyle', 'sevenoldstyle', 'eightoldstyle', 'nineoldstyle', 'colon',
    'semicolon', 'commasuperior', 'threequartersemdash', 'periodsuperior', 'questionsmall', '', 'asuperior',
    'bsuperior', 'centsuperior', 'dsuperior', 'esuperior', '', '', 'isuperior', '', '', 'lsuperior', 'msuperior',
    'nsuperior', 'osuperior', '', '', 'rsuperior', 'ssuperior', 'tsuperior', '', 'ff', 'fi', 'fl', 'ffi', 'ffl',
    'parenleftinferior', '', 'parenrightinferior', 'Circumflexsmall', 'hyphensuperior', 'Gravesmall', 'Asmall',
    'Bsmall', 'Csmall', 'Dsmall', 'Esmall', 'Fsmall', 'Gsmall', 'Hsmall', 'Ismall', 'Jsmall', 'Ksmall', 'Lsmall',
    'Msmall', 'Nsmall', 'Osmall', 'Psmall', 'Qsmall', 'Rsmall', 'Ssmall', 'Tsmall', 'Usmall', 'Vsmall', 'Wsmall',
    'Xsmall', 'Ysmall', 'Zsmall', 'colonmonetary', 'onefitted', 'rupiah', 'Tildesmall', '', '', '', '', '', '', '',
    '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '',
    'exclamdownsmall', 'centoldstyle', 'Lslashsmall', '', '', 'Scaronsmall', 'Zcaronsmall', 'Dieresissmall',
    'Brevesmall', 'Caronsmall', '', 'Dotaccentsmall', '', '', 'Macronsmall', '', '', 'figuredash', 'hypheninferior',
    '', '', 'Ogoneksmall', 'Ringsmall', 'Cedillasmall', '', '', '', 'onequarter', 'onehalf', 'threequarters',
    'questiondownsmall', 'oneeighth', 'threeeighths', 'fiveeighths', 'seveneighths', 'onethird', 'twothirds', '',
    '', 'zerosuperior', 'onesuperior', 'twosuperior', 'threesuperior', 'foursuperior', 'fivesuperior',
    'sixsuperior', 'sevensuperior', 'eightsuperior', 'ninesuperior', 'zeroinferior', 'oneinferior', 'twoinferior',
    'threeinferior', 'fourinferior', 'fiveinferior', 'sixinferior', 'seveninferior', 'eightinferior',
    'nineinferior', 'centinferior', 'dollarinferior', 'periodinferior', 'commainferior', 'Agravesmall',
    'Aacutesmall', 'Acircumflexsmall', 'Atildesmall', 'Adieresissmall', 'Aringsmall', 'AEsmall', 'Ccedillasmall',
    'Egravesmall', 'Eacutesmall', 'Ecircumflexsmall', 'Edieresissmall', 'Igravesmall', 'Iacutesmall',
    'Icircumflexsmall', 'Idieresissmall', 'Ethsmall', 'Ntildesmall', 'Ogravesmall', 'Oacutesmall',
    'Ocircumflexsmall', 'Otildesmall', 'Odieresissmall', 'OEsmall', 'Oslashsmall', 'Ugravesmall', 'Uacutesmall',
    'Ucircumflexsmall', 'Udieresissmall', 'Yacutesmall', 'Thornsmall', 'Ydieresissmall'];

var standardNames = [
    '.notdef', '.null', 'nonmarkingreturn', 'space', 'exclam', 'quotedbl', 'numbersign', 'dollar', 'percent',
    'ampersand', 'quotesingle', 'parenleft', 'parenright', 'asterisk', 'plus', 'comma', 'hyphen', 'period', 'slash',
    'zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'colon', 'semicolon', 'less',
    'equal', 'greater', 'question', 'at', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O',
    'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'bracketleft', 'backslash', 'bracketright',
    'asciicircum', 'underscore', 'grave', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o',
    'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'braceleft', 'bar', 'braceright', 'asciitilde',
    'Adieresis', 'Aring', 'Ccedilla', 'Eacute', 'Ntilde', 'Odieresis', 'Udieresis', 'aacute', 'agrave',
    'acircumflex', 'adieresis', 'atilde', 'aring', 'ccedilla', 'eacute', 'egrave', 'ecircumflex', 'edieresis',
    'iacute', 'igrave', 'icircumflex', 'idieresis', 'ntilde', 'oacute', 'ograve', 'ocircumflex', 'odieresis',
    'otilde', 'uacute', 'ugrave', 'ucircumflex', 'udieresis', 'dagger', 'degree', 'cent', 'sterling', 'section',
    'bullet', 'paragraph', 'germandbls', 'registered', 'copyright', 'trademark', 'acute', 'dieresis', 'notequal',
    'AE', 'Oslash', 'infinity', 'plusminus', 'lessequal', 'greaterequal', 'yen', 'mu', 'partialdiff', 'summation',
    'product', 'pi', 'integral', 'ordfeminine', 'ordmasculine', 'Omega', 'ae', 'oslash', 'questiondown',
    'exclamdown', 'logicalnot', 'radical', 'florin', 'approxequal', 'Delta', 'guillemotleft', 'guillemotright',
    'ellipsis', 'nonbreakingspace', 'Agrave', 'Atilde', 'Otilde', 'OE', 'oe', 'endash', 'emdash', 'quotedblleft',
    'quotedblright', 'quoteleft', 'quoteright', 'divide', 'lozenge', 'ydieresis', 'Ydieresis', 'fraction',
    'currency', 'guilsinglleft', 'guilsinglright', 'fi', 'fl', 'daggerdbl', 'periodcentered', 'quotesinglbase',
    'quotedblbase', 'perthousand', 'Acircumflex', 'Ecircumflex', 'Aacute', 'Edieresis', 'Egrave', 'Iacute',
    'Icircumflex', 'Idieresis', 'Igrave', 'Oacute', 'Ocircumflex', 'apple', 'Ograve', 'Uacute', 'Ucircumflex',
    'Ugrave', 'dotlessi', 'circumflex', 'tilde', 'macron', 'breve', 'dotaccent', 'ring', 'cedilla', 'hungarumlaut',
    'ogonek', 'caron', 'Lslash', 'lslash', 'Scaron', 'scaron', 'Zcaron', 'zcaron', 'brokenbar', 'Eth', 'eth',
    'Yacute', 'yacute', 'Thorn', 'thorn', 'minus', 'multiply', 'onesuperior', 'twosuperior', 'threesuperior',
    'onehalf', 'onequarter', 'threequarters', 'franc', 'Gbreve', 'gbreve', 'Idotaccent', 'Scedilla', 'scedilla',
    'Cacute', 'cacute', 'Ccaron', 'ccaron', 'dcroat'];

/**
 * This is the encoding used for fonts created from scratch.
 * It loops through all glyphs and finds the appropriate unicode value.
 * Since it's linear time, other encodings will be faster.
 * @exports opentype.DefaultEncoding
 * @class
 * @constructor
 * @param {opentype.Font}
 */
function DefaultEncoding(font) {
    this.font = font;
}

DefaultEncoding.prototype.charToGlyphIndex = function(c) {
    var code = c.charCodeAt(0);
    var glyphs = this.font.glyphs;
    if (glyphs) {
        for (var i = 0; i < glyphs.length; i += 1) {
            var glyph = glyphs.get(i);
            for (var j = 0; j < glyph.unicodes.length; j += 1) {
                if (glyph.unicodes[j] === code) {
                    return i;
                }
            }
        }
    }
    return null;
};

/**
 * @exports opentype.CmapEncoding
 * @class
 * @constructor
 * @param {Object} cmap - a object with the cmap encoded data
 */
function CmapEncoding(cmap) {
    this.cmap = cmap;
}

/**
 * @param  {string} c - the character
 * @return {number} The glyph index.
 */
CmapEncoding.prototype.charToGlyphIndex = function(c) {
    return this.cmap.glyphIndexMap[c.charCodeAt(0)] || 0;
};

/**
 * @exports opentype.CffEncoding
 * @class
 * @constructor
 * @param {string} encoding - The encoding
 * @param {Array} charset - The character set.
 */
function CffEncoding(encoding, charset) {
    this.encoding = encoding;
    this.charset = charset;
}

/**
 * @param  {string} s - The character
 * @return {number} The index.
 */
CffEncoding.prototype.charToGlyphIndex = function(s) {
    var code = s.charCodeAt(0);
    var charName = this.encoding[code];
    return this.charset.indexOf(charName);
};

/**
 * @exports opentype.GlyphNames
 * @class
 * @constructor
 * @param {Object} post
 */
function GlyphNames(post) {
    var this$1 = this;

    switch (post.version) {
        case 1:
            this.names = standardNames.slice();
            break;
        case 2:
            this.names = new Array(post.numberOfGlyphs);
            for (var i = 0; i < post.numberOfGlyphs; i++) {
                if (post.glyphNameIndex[i] < standardNames.length) {
                    this$1.names[i] = standardNames[post.glyphNameIndex[i]];
                } else {
                    this$1.names[i] = post.names[post.glyphNameIndex[i] - standardNames.length];
                }
            }

            break;
        case 2.5:
            this.names = new Array(post.numberOfGlyphs);
            for (var i$1 = 0; i$1 < post.numberOfGlyphs; i$1++) {
                this$1.names[i$1] = standardNames[i$1 + post.glyphNameIndex[i$1]];
            }

            break;
        case 3:
            this.names = [];
            break;
        default:
            this.names = [];
            break;
    }
}

/**
 * Gets the index of a glyph by name.
 * @param  {string} name - The glyph name
 * @return {number} The index
 */
GlyphNames.prototype.nameToGlyphIndex = function(name) {
    return this.names.indexOf(name);
};

/**
 * @param  {number} gid
 * @return {string}
 */
GlyphNames.prototype.glyphIndexToName = function(gid) {
    return this.names[gid];
};

/**
 * @alias opentype.addGlyphNames
 * @param {opentype.Font}
 */
function addGlyphNames(font) {
    var glyph;
    var glyphIndexMap = font.tables.cmap.glyphIndexMap;
    var charCodes = Object.keys(glyphIndexMap);

    for (var i = 0; i < charCodes.length; i += 1) {
        var c = charCodes[i];
        var glyphIndex = glyphIndexMap[c];
        glyph = font.glyphs.get(glyphIndex);
        glyph.addUnicode(parseInt(c));
    }

    for (var i$1 = 0; i$1 < font.glyphs.length; i$1 += 1) {
        glyph = font.glyphs.get(i$1);
        if (font.cffEncoding) {
            if (font.isCIDFont) {
                glyph.name = 'gid' + i$1;
            } else {
                glyph.name = font.cffEncoding.charset[i$1];
            }
        } else if (font.glyphNames.names) {
            glyph.name = font.glyphNames.glyphIndexToName(i$1);
        }
    }
}

// Drawing utility functions.

// Draw a line on the given context from point `x1,y1` to point `x2,y2`.
function line(ctx, x1, y1, x2, y2) {
    ctx.beginPath();
    ctx.moveTo(x1, y1);
    ctx.lineTo(x2, y2);
    ctx.stroke();
}

var draw = { line: line };

// The `glyf` table describes the glyphs in TrueType outline format.
// http://www.microsoft.com/typography/otspec/glyf.htm

// Parse the coordinate data for a glyph.
function parseGlyphCoordinate(p, flag, previousValue, shortVectorBitMask, sameBitMask) {
    var v;
    if ((flag & shortVectorBitMask) > 0) {
        // The coordinate is 1 byte long.
        v = p.parseByte();
        // The `same` bit is re-used for short values to signify the sign of the value.
        if ((flag & sameBitMask) === 0) {
            v = -v;
        }

        v = previousValue + v;
    } else {
        //  The coordinate is 2 bytes long.
        // If the `same` bit is set, the coordinate is the same as the previous coordinate.
        if ((flag & sameBitMask) > 0) {
            v = previousValue;
        } else {
            // Parse the coordinate as a signed 16-bit delta value.
            v = previousValue + p.parseShort();
        }
    }

    return v;
}

// Parse a TrueType glyph.
function parseGlyph(glyph, data, start) {
    var p = new parse.Parser(data, start);
    glyph.numberOfContours = p.parseShort();
    glyph._xMin = p.parseShort();
    glyph._yMin = p.parseShort();
    glyph._xMax = p.parseShort();
    glyph._yMax = p.parseShort();
    var flags;
    var flag;

    if (glyph.numberOfContours > 0) {
        // This glyph is not a composite.
        var endPointIndices = glyph.endPointIndices = [];
        for (var i = 0; i < glyph.numberOfContours; i += 1) {
            endPointIndices.push(p.parseUShort());
        }

        glyph.instructionLength = p.parseUShort();
        glyph.instructions = [];
        for (var i$1 = 0; i$1 < glyph.instructionLength; i$1 += 1) {
            glyph.instructions.push(p.parseByte());
        }

        var numberOfCoordinates = endPointIndices[endPointIndices.length - 1] + 1;
        flags = [];
        for (var i$2 = 0; i$2 < numberOfCoordinates; i$2 += 1) {
            flag = p.parseByte();
            flags.push(flag);
            // If bit 3 is set, we repeat this flag n times, where n is the next byte.
            if ((flag & 8) > 0) {
                var repeatCount = p.parseByte();
                for (var j = 0; j < repeatCount; j += 1) {
                    flags.push(flag);
                    i$2 += 1;
                }
            }
        }

        check.argument(flags.length === numberOfCoordinates, 'Bad flags.');

        if (endPointIndices.length > 0) {
            var points = [];
            var point;
            // X/Y coordinates are relative to the previous point, except for the first point which is relative to 0,0.
            if (numberOfCoordinates > 0) {
                for (var i$3 = 0; i$3 < numberOfCoordinates; i$3 += 1) {
                    flag = flags[i$3];
                    point = {};
                    point.onCurve = !!(flag & 1);
                    point.lastPointOfContour = endPointIndices.indexOf(i$3) >= 0;
                    points.push(point);
                }

                var px = 0;
                for (var i$4 = 0; i$4 < numberOfCoordinates; i$4 += 1) {
                    flag = flags[i$4];
                    point = points[i$4];
                    point.x = parseGlyphCoordinate(p, flag, px, 2, 16);
                    px = point.x;
                }

                var py = 0;
                for (var i$5 = 0; i$5 < numberOfCoordinates; i$5 += 1) {
                    flag = flags[i$5];
                    point = points[i$5];
                    point.y = parseGlyphCoordinate(p, flag, py, 4, 32);
                    py = point.y;
                }
            }

            glyph.points = points;
        } else {
            glyph.points = [];
        }
    } else if (glyph.numberOfContours === 0) {
        glyph.points = [];
    } else {
        glyph.isComposite = true;
        glyph.points = [];
        glyph.components = [];
        var moreComponents = true;
        while (moreComponents) {
            flags = p.parseUShort();
            var component = {
                glyphIndex: p.parseUShort(),
                xScale: 1,
                scale01: 0,
                scale10: 0,
                yScale: 1,
                dx: 0,
                dy: 0
            };
            if ((flags & 1) > 0) {
                // The arguments are words
                if ((flags & 2) > 0) {
                    // values are offset
                    component.dx = p.parseShort();
                    component.dy = p.parseShort();
                } else {
                    // values are matched points
                    component.matchedPoints = [p.parseUShort(), p.parseUShort()];
                }

            } else {
                // The arguments are bytes
                if ((flags & 2) > 0) {
                    // values are offset
                    component.dx = p.parseChar();
                    component.dy = p.parseChar();
                } else {
                    // values are matched points
                    component.matchedPoints = [p.parseByte(), p.parseByte()];
                }
            }

            if ((flags & 8) > 0) {
                // We have a scale
                component.xScale = component.yScale = p.parseF2Dot14();
            } else if ((flags & 64) > 0) {
                // We have an X / Y scale
                component.xScale = p.parseF2Dot14();
                component.yScale = p.parseF2Dot14();
            } else if ((flags & 128) > 0) {
                // We have a 2x2 transformation
                component.xScale = p.parseF2Dot14();
                component.scale01 = p.parseF2Dot14();
                component.scale10 = p.parseF2Dot14();
                component.yScale = p.parseF2Dot14();
            }

            glyph.components.push(component);
            moreComponents = !!(flags & 32);
        }
        if (flags & 0x100) {
            // We have instructions
            glyph.instructionLength = p.parseUShort();
            glyph.instructions = [];
            for (var i$6 = 0; i$6 < glyph.instructionLength; i$6 += 1) {
                glyph.instructions.push(p.parseByte());
            }
        }
    }
}

// Transform an array of points and return a new array.
function transformPoints(points, transform) {
    var newPoints = [];
    for (var i = 0; i < points.length; i += 1) {
        var pt = points[i];
        var newPt = {
            x: transform.xScale * pt.x + transform.scale01 * pt.y + transform.dx,
            y: transform.scale10 * pt.x + transform.yScale * pt.y + transform.dy,
            onCurve: pt.onCurve,
            lastPointOfContour: pt.lastPointOfContour
        };
        newPoints.push(newPt);
    }

    return newPoints;
}

function getContours(points) {
    var contours = [];
    var currentContour = [];
    for (var i = 0; i < points.length; i += 1) {
        var pt = points[i];
        currentContour.push(pt);
        if (pt.lastPointOfContour) {
            contours.push(currentContour);
            currentContour = [];
        }
    }

    check.argument(currentContour.length === 0, 'There are still points left in the current contour.');
    return contours;
}

// Convert the TrueType glyph outline to a Path.
function getPath(points) {
    var p = new Path();
    if (!points) {
        return p;
    }

    var contours = getContours(points);

    for (var contourIndex = 0; contourIndex < contours.length; ++contourIndex) {
        var contour = contours[contourIndex];

        var prev = null;
        var curr = contour[contour.length - 1];
        var next = contour[0];

        if (curr.onCurve) {
            p.moveTo(curr.x, curr.y);
        } else {
            if (next.onCurve) {
                p.moveTo(next.x, next.y);
            } else {
                // If both first and last points are off-curve, start at their middle.
                var start = {x: (curr.x + next.x) * 0.5, y: (curr.y + next.y) * 0.5};
                p.moveTo(start.x, start.y);
            }
        }

        for (var i = 0; i < contour.length; ++i) {
            prev = curr;
            curr = next;
            next = contour[(i + 1) % contour.length];

            if (curr.onCurve) {
                // This is a straight line.
                p.lineTo(curr.x, curr.y);
            } else {
                var prev2 = prev;
                var next2 = next;

                if (!prev.onCurve) {
                    prev2 = { x: (curr.x + prev.x) * 0.5, y: (curr.y + prev.y) * 0.5 };
                    p.lineTo(prev2.x, prev2.y);
                }

                if (!next.onCurve) {
                    next2 = { x: (curr.x + next.x) * 0.5, y: (curr.y + next.y) * 0.5 };
                }

                p.lineTo(prev2.x, prev2.y);
                p.quadraticCurveTo(curr.x, curr.y, next2.x, next2.y);
            }
        }

        p.closePath();
    }
    return p;
}

function buildPath(glyphs, glyph) {
    if (glyph.isComposite) {
        for (var j = 0; j < glyph.components.length; j += 1) {
            var component = glyph.components[j];
            var componentGlyph = glyphs.get(component.glyphIndex);
            // Force the ttfGlyphLoader to parse the glyph.
            componentGlyph.getPath();
            if (componentGlyph.points) {
                var transformedPoints = (void 0);
                if (component.matchedPoints === undefined) {
                    // component positioned by offset
                    transformedPoints = transformPoints(componentGlyph.points, component);
                } else {
                    // component positioned by matched points
                    if ((component.matchedPoints[0] > glyph.points.length - 1) ||
                        (component.matchedPoints[1] > componentGlyph.points.length - 1)) {
                        throw Error('Matched points out of range in ' + glyph.name);
                    }
                    var firstPt = glyph.points[component.matchedPoints[0]];
                    var secondPt = componentGlyph.points[component.matchedPoints[1]];
                    var transform = {
                        xScale: component.xScale, scale01: component.scale01,
                        scale10: component.scale10, yScale: component.yScale,
                        dx: 0, dy: 0
                    };
                    secondPt = transformPoints([secondPt], transform)[0];
                    transform.dx = firstPt.x - secondPt.x;
                    transform.dy = firstPt.y - secondPt.y;
                    transformedPoints = transformPoints(componentGlyph.points, transform);
                }
                glyph.points = glyph.points.concat(transformedPoints);
            }
        }
    }

    return getPath(glyph.points);
}

// Parse all the glyphs according to the offsets from the `loca` table.
function parseGlyfTable(data, start, loca, font) {
    var glyphs = new glyphset.GlyphSet(font);

    // The last element of the loca table is invalid.
    for (var i = 0; i < loca.length - 1; i += 1) {
        var offset = loca[i];
        var nextOffset = loca[i + 1];
        if (offset !== nextOffset) {
            glyphs.push(i, glyphset.ttfGlyphLoader(font, i, parseGlyph, data, start + offset, buildPath));
        } else {
            glyphs.push(i, glyphset.glyphLoader(font, i));
        }
    }

    return glyphs;
}

var glyf = { getPath: getPath, parse: parseGlyfTable };

// The Glyph object

function getPathDefinition(glyph, path) {
    var _path = path || {commands: []};
    return {
        configurable: true,

        get: function() {
            if (typeof _path === 'function') {
                _path = _path();
            }

            return _path;
        },

        set: function(p) {
            _path = p;
        }
    };
}
/**
 * @typedef GlyphOptions
 * @type Object
 * @property {string} [name] - The glyph name
 * @property {number} [unicode]
 * @property {Array} [unicodes]
 * @property {number} [xMin]
 * @property {number} [yMin]
 * @property {number} [xMax]
 * @property {number} [yMax]
 * @property {number} [advanceWidth]
 */

// A Glyph is an individual mark that often corresponds to a character.
// Some glyphs, such as ligatures, are a combination of many characters.
// Glyphs are the basic building blocks of a font.
//
// The `Glyph` class contains utility methods for drawing the path and its points.
/**
 * @exports opentype.Glyph
 * @class
 * @param {GlyphOptions}
 * @constructor
 */
function Glyph(options) {
    // By putting all the code on a prototype function (which is only declared once)
    // we reduce the memory requirements for larger fonts by some 2%
    this.bindConstructorValues(options);
}

/**
 * @param  {GlyphOptions}
 */
Glyph.prototype.bindConstructorValues = function(options) {
    this.index = options.index || 0;

    // These three values cannot be deferred for memory optimization:
    this.name = options.name || null;
    this.unicode = options.unicode || undefined;
    this.unicodes = options.unicodes || options.unicode !== undefined ? [options.unicode] : [];

    // But by binding these values only when necessary, we reduce can
    // the memory requirements by almost 3% for larger fonts.
    if (options.xMin) {
        this.xMin = options.xMin;
    }

    if (options.yMin) {
        this.yMin = options.yMin;
    }

    if (options.xMax) {
        this.xMax = options.xMax;
    }

    if (options.yMax) {
        this.yMax = options.yMax;
    }

    if (options.advanceWidth) {
        this.advanceWidth = options.advanceWidth;
    }

    // The path for a glyph is the most memory intensive, and is bound as a value
    // with a getter/setter to ensure we actually do path parsing only once the
    // path is actually needed by anything.
    Object.defineProperty(this, 'path', getPathDefinition(this, options.path));
};

/**
 * @param {number}
 */
Glyph.prototype.addUnicode = function(unicode) {
    if (this.unicodes.length === 0) {
        this.unicode = unicode;
    }

    this.unicodes.push(unicode);
};

/**
 * Calculate the minimum bounding box for this glyph.
 * @return {opentype.BoundingBox}
 */
Glyph.prototype.getBoundingBox = function() {
    return this.path.getBoundingBox();
};

/**
 * Convert the glyph to a Path we can draw on a drawing context.
 * @param  {number} [x=0] - Horizontal position of the beginning of the text.
 * @param  {number} [y=0] - Vertical position of the *baseline* of the text.
 * @param  {number} [fontSize=72] - Font size in pixels. We scale the glyph units by `1 / unitsPerEm * fontSize`.
 * @param  {Object=} options - xScale, yScale to stretch the glyph.
 * @param  {opentype.Font} if hinting is to be used, the font
 * @return {opentype.Path}
 */
Glyph.prototype.getPath = function(x, y, fontSize, options, font) {
    x = x !== undefined ? x : 0;
    y = y !== undefined ? y : 0;
    fontSize = fontSize !== undefined ? fontSize : 72;
    var commands;
    var hPoints;
    if (!options) { options = { }; }
    var xScale = options.xScale;
    var yScale = options.yScale;

    if (options.hinting && font && font.hinting) {
        // in case of hinting, the hinting engine takes care
        // of scaling the points (not the path) before hinting.
        hPoints = this.path && font.hinting.exec(this, fontSize);
        // in case the hinting engine failed hPoints is undefined
        // and thus reverts to plain rending
    }

    if (hPoints) {
        commands = glyf.getPath(hPoints).commands;
        x = Math.round(x);
        y = Math.round(y);
        // TODO in case of hinting xyScaling is not yet supported
        xScale = yScale = 1;
    } else {
        commands = this.path.commands;
        var scale = 1 / this.path.unitsPerEm * fontSize;
        if (xScale === undefined) { xScale = scale; }
        if (yScale === undefined) { yScale = scale; }
    }

    var p = new Path();
    for (var i = 0; i < commands.length; i += 1) {
        var cmd = commands[i];
        if (cmd.type === 'M') {
            p.moveTo(x + (cmd.x * xScale), y + (-cmd.y * yScale));
        } else if (cmd.type === 'L') {
            p.lineTo(x + (cmd.x * xScale), y + (-cmd.y * yScale));
        } else if (cmd.type === 'Q') {
            p.quadraticCurveTo(x + (cmd.x1 * xScale), y + (-cmd.y1 * yScale),
                               x + (cmd.x * xScale), y + (-cmd.y * yScale));
        } else if (cmd.type === 'C') {
            p.curveTo(x + (cmd.x1 * xScale), y + (-cmd.y1 * yScale),
                      x + (cmd.x2 * xScale), y + (-cmd.y2 * yScale),
                      x + (cmd.x * xScale), y + (-cmd.y * yScale));
        } else if (cmd.type === 'Z') {
            p.closePath();
        }
    }

    return p;
};

/**
 * Split the glyph into contours.
 * This function is here for backwards compatibility, and to
 * provide raw access to the TrueType glyph outlines.
 * @return {Array}
 */
Glyph.prototype.getContours = function() {
    var this$1 = this;

    if (this.points === undefined) {
        return [];
    }

    var contours = [];
    var currentContour = [];
    for (var i = 0; i < this.points.length; i += 1) {
        var pt = this$1.points[i];
        currentContour.push(pt);
        if (pt.lastPointOfContour) {
            contours.push(currentContour);
            currentContour = [];
        }
    }

    check.argument(currentContour.length === 0, 'There are still points left in the current contour.');
    return contours;
};

/**
 * Calculate the xMin/yMin/xMax/yMax/lsb/rsb for a Glyph.
 * @return {Object}
 */
Glyph.prototype.getMetrics = function() {
    var commands = this.path.commands;
    var xCoords = [];
    var yCoords = [];
    for (var i = 0; i < commands.length; i += 1) {
        var cmd = commands[i];
        if (cmd.type !== 'Z') {
            xCoords.push(cmd.x);
            yCoords.push(cmd.y);
        }

        if (cmd.type === 'Q' || cmd.type === 'C') {
            xCoords.push(cmd.x1);
            yCoords.push(cmd.y1);
        }

        if (cmd.type === 'C') {
            xCoords.push(cmd.x2);
            yCoords.push(cmd.y2);
        }
    }

    var metrics = {
        xMin: Math.min.apply(null, xCoords),
        yMin: Math.min.apply(null, yCoords),
        xMax: Math.max.apply(null, xCoords),
        yMax: Math.max.apply(null, yCoords),
        leftSideBearing: this.leftSideBearing
    };

    if (!isFinite(metrics.xMin)) {
        metrics.xMin = 0;
    }

    if (!isFinite(metrics.xMax)) {
        metrics.xMax = this.advanceWidth;
    }

    if (!isFinite(metrics.yMin)) {
        metrics.yMin = 0;
    }

    if (!isFinite(metrics.yMax)) {
        metrics.yMax = 0;
    }

    metrics.rightSideBearing = this.advanceWidth - metrics.leftSideBearing - (metrics.xMax - metrics.xMin);
    return metrics;
};

/**
 * Draw the glyph on the given context.
 * @param  {CanvasRenderingContext2D} ctx - A 2D drawing context, like Canvas.
 * @param  {number} [x=0] - Horizontal position of the beginning of the text.
 * @param  {number} [y=0] - Vertical position of the *baseline* of the text.
 * @param  {number} [fontSize=72] - Font size in pixels. We scale the glyph units by `1 / unitsPerEm * fontSize`.
 * @param  {Object=} options - xScale, yScale to stretch the glyph.
 */
Glyph.prototype.draw = function(ctx, x, y, fontSize, options) {
    this.getPath(x, y, fontSize, options).draw(ctx);
};

/**
 * Draw the points of the glyph.
 * On-curve points will be drawn in blue, off-curve points will be drawn in red.
 * @param  {CanvasRenderingContext2D} ctx - A 2D drawing context, like Canvas.
 * @param  {number} [x=0] - Horizontal position of the beginning of the text.
 * @param  {number} [y=0] - Vertical position of the *baseline* of the text.
 * @param  {number} [fontSize=72] - Font size in pixels. We scale the glyph units by `1 / unitsPerEm * fontSize`.
 */
Glyph.prototype.drawPoints = function(ctx, x, y, fontSize) {
    function drawCircles(l, x, y, scale) {
        var PI_SQ = Math.PI * 2;
        ctx.beginPath();
        for (var j = 0; j < l.length; j += 1) {
            ctx.moveTo(x + (l[j].x * scale), y + (l[j].y * scale));
            ctx.arc(x + (l[j].x * scale), y + (l[j].y * scale), 2, 0, PI_SQ, false);
        }

        ctx.closePath();
        ctx.fill();
    }

    x = x !== undefined ? x : 0;
    y = y !== undefined ? y : 0;
    fontSize = fontSize !== undefined ? fontSize : 24;
    var scale = 1 / this.path.unitsPerEm * fontSize;

    var blueCircles = [];
    var redCircles = [];
    var path = this.path;
    for (var i = 0; i < path.commands.length; i += 1) {
        var cmd = path.commands[i];
        if (cmd.x !== undefined) {
            blueCircles.push({x: cmd.x, y: -cmd.y});
        }

        if (cmd.x1 !== undefined) {
            redCircles.push({x: cmd.x1, y: -cmd.y1});
        }

        if (cmd.x2 !== undefined) {
            redCircles.push({x: cmd.x2, y: -cmd.y2});
        }
    }

    ctx.fillStyle = 'blue';
    drawCircles(blueCircles, x, y, scale);
    ctx.fillStyle = 'red';
    drawCircles(redCircles, x, y, scale);
};

/**
 * Draw lines indicating important font measurements.
 * Black lines indicate the origin of the coordinate system (point 0,0).
 * Blue lines indicate the glyph bounding box.
 * Green line indicates the advance width of the glyph.
 * @param  {CanvasRenderingContext2D} ctx - A 2D drawing context, like Canvas.
 * @param  {number} [x=0] - Horizontal position of the beginning of the text.
 * @param  {number} [y=0] - Vertical position of the *baseline* of the text.
 * @param  {number} [fontSize=72] - Font size in pixels. We scale the glyph units by `1 / unitsPerEm * fontSize`.
 */
Glyph.prototype.drawMetrics = function(ctx, x, y, fontSize) {
    var scale;
    x = x !== undefined ? x : 0;
    y = y !== undefined ? y : 0;
    fontSize = fontSize !== undefined ? fontSize : 24;
    scale = 1 / this.path.unitsPerEm * fontSize;
    ctx.lineWidth = 1;

    // Draw the origin
    ctx.strokeStyle = 'black';
    draw.line(ctx, x, -10000, x, 10000);
    draw.line(ctx, -10000, y, 10000, y);

    // This code is here due to memory optimization: by not using
    // defaults in the constructor, we save a notable amount of memory.
    var xMin = this.xMin || 0;
    var yMin = this.yMin || 0;
    var xMax = this.xMax || 0;
    var yMax = this.yMax || 0;
    var advanceWidth = this.advanceWidth || 0;

    // Draw the glyph box
    ctx.strokeStyle = 'blue';
    draw.line(ctx, x + (xMin * scale), -10000, x + (xMin * scale), 10000);
    draw.line(ctx, x + (xMax * scale), -10000, x + (xMax * scale), 10000);
    draw.line(ctx, -10000, y + (-yMin * scale), 10000, y + (-yMin * scale));
    draw.line(ctx, -10000, y + (-yMax * scale), 10000, y + (-yMax * scale));

    // Draw the advance width
    ctx.strokeStyle = 'green';
    draw.line(ctx, x + (advanceWidth * scale), -10000, x + (advanceWidth * scale), 10000);
};

// The GlyphSet object

// Define a property on the glyph that depends on the path being loaded.
function defineDependentProperty(glyph, externalName, internalName) {
    Object.defineProperty(glyph, externalName, {
        get: function() {
            // Request the path property to make sure the path is loaded.
            glyph.path; // jshint ignore:line
            return glyph[internalName];
        },
        set: function(newValue) {
            glyph[internalName] = newValue;
        },
        enumerable: true,
        configurable: true
    });
}

/**
 * A GlyphSet represents all glyphs available in the font, but modelled using
 * a deferred glyph loader, for retrieving glyphs only once they are absolutely
 * necessary, to keep the memory footprint down.
 * @exports opentype.GlyphSet
 * @class
 * @param {opentype.Font}
 * @param {Array}
 */
function GlyphSet(font, glyphs) {
    var this$1 = this;

    this.font = font;
    this.glyphs = {};
    if (Array.isArray(glyphs)) {
        for (var i = 0; i < glyphs.length; i++) {
            this$1.glyphs[i] = glyphs[i];
        }
    }

    this.length = (glyphs && glyphs.length) || 0;
}

/**
 * @param  {number} index
 * @return {opentype.Glyph}
 */
GlyphSet.prototype.get = function(index) {
    if (typeof this.glyphs[index] === 'function') {
        this.glyphs[index] = this.glyphs[index]();
    }

    return this.glyphs[index];
};

/**
 * @param  {number} index
 * @param  {Object}
 */
GlyphSet.prototype.push = function(index, loader) {
    this.glyphs[index] = loader;
    this.length++;
};

/**
 * @alias opentype.glyphLoader
 * @param  {opentype.Font} font
 * @param  {number} index
 * @return {opentype.Glyph}
 */
function glyphLoader(font, index) {
    return new Glyph({index: index, font: font});
}

/**
 * Generate a stub glyph that can be filled with all metadata *except*
 * the "points" and "path" properties, which must be loaded only once
 * the glyph's path is actually requested for text shaping.
 * @alias opentype.ttfGlyphLoader
 * @param  {opentype.Font} font
 * @param  {number} index
 * @param  {Function} parseGlyph
 * @param  {Object} data
 * @param  {number} position
 * @param  {Function} buildPath
 * @return {opentype.Glyph}
 */
function ttfGlyphLoader(font, index, parseGlyph, data, position, buildPath) {
    return function() {
        var glyph = new Glyph({index: index, font: font});

        glyph.path = function() {
            parseGlyph(glyph, data, position);
            var path = buildPath(font.glyphs, glyph);
            path.unitsPerEm = font.unitsPerEm;
            return path;
        };

        defineDependentProperty(glyph, 'xMin', '_xMin');
        defineDependentProperty(glyph, 'xMax', '_xMax');
        defineDependentProperty(glyph, 'yMin', '_yMin');
        defineDependentProperty(glyph, 'yMax', '_yMax');

        return glyph;
    };
}
/**
 * @alias opentype.cffGlyphLoader
 * @param  {opentype.Font} font
 * @param  {number} index
 * @param  {Function} parseCFFCharstring
 * @param  {string} charstring
 * @return {opentype.Glyph}
 */
function cffGlyphLoader(font, index, parseCFFCharstring, charstring) {
    return function() {
        var glyph = new Glyph({index: index, font: font});

        glyph.path = function() {
            var path = parseCFFCharstring(font, glyph, charstring);
            path.unitsPerEm = font.unitsPerEm;
            return path;
        };

        return glyph;
    };
}

var glyphset = { GlyphSet: GlyphSet, glyphLoader: glyphLoader, ttfGlyphLoader: ttfGlyphLoader, cffGlyphLoader: cffGlyphLoader };

// The `CFF` table contains the glyph outlines in PostScript format.
// https://www.microsoft.com/typography/OTSPEC/cff.htm
// http://download.microsoft.com/download/8/0/1/801a191c-029d-4af3-9642-555f6fe514ee/cff.pdf
// http://download.microsoft.com/download/8/0/1/801a191c-029d-4af3-9642-555f6fe514ee/type2.pdf

// Custom equals function that can also check lists.
function equals(a, b) {
    if (a === b) {
        return true;
    } else if (Array.isArray(a) && Array.isArray(b)) {
        if (a.length !== b.length) {
            return false;
        }

        for (var i = 0; i < a.length; i += 1) {
            if (!equals(a[i], b[i])) {
                return false;
            }
        }

        return true;
    } else {
        return false;
    }
}

// Subroutines are encoded using the negative half of the number space.
// See type 2 chapter 4.7 "Subroutine operators".
function calcCFFSubroutineBias(subrs) {
    var bias;
    if (subrs.length < 1240) {
        bias = 107;
    } else if (subrs.length < 33900) {
        bias = 1131;
    } else {
        bias = 32768;
    }

    return bias;
}

// Parse a `CFF` INDEX array.
// An index array consists of a list of offsets, then a list of objects at those offsets.
function parseCFFIndex(data, start, conversionFn) {
    var offsets = [];
    var objects = [];
    var count = parse.getCard16(data, start);
    var objectOffset;
    var endOffset;
    if (count !== 0) {
        var offsetSize = parse.getByte(data, start + 2);
        objectOffset = start + ((count + 1) * offsetSize) + 2;
        var pos = start + 3;
        for (var i = 0; i < count + 1; i += 1) {
            offsets.push(parse.getOffset(data, pos, offsetSize));
            pos += offsetSize;
        }

        // The total size of the index array is 4 header bytes + the value of the last offset.
        endOffset = objectOffset + offsets[count];
    } else {
        endOffset = start + 2;
    }

    for (var i$1 = 0; i$1 < offsets.length - 1; i$1 += 1) {
        var value = parse.getBytes(data, objectOffset + offsets[i$1], objectOffset + offsets[i$1 + 1]);
        if (conversionFn) {
            value = conversionFn(value);
        }

        objects.push(value);
    }

    return {objects: objects, startOffset: start, endOffset: endOffset};
}

// Parse a `CFF` DICT real value.
function parseFloatOperand(parser) {
    var s = '';
    var eof = 15;
    var lookup = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.', 'E', 'E-', null, '-'];
    while (true) {
        var b = parser.parseByte();
        var n1 = b >> 4;
        var n2 = b & 15;

        if (n1 === eof) {
            break;
        }

        s += lookup[n1];

        if (n2 === eof) {
            break;
        }

        s += lookup[n2];
    }

    return parseFloat(s);
}

// Parse a `CFF` DICT operand.
function parseOperand(parser, b0) {
    var b1;
    var b2;
    var b3;
    var b4;
    if (b0 === 28) {
        b1 = parser.parseByte();
        b2 = parser.parseByte();
        return b1 << 8 | b2;
    }

    if (b0 === 29) {
        b1 = parser.parseByte();
        b2 = parser.parseByte();
        b3 = parser.parseByte();
        b4 = parser.parseByte();
        return b1 << 24 | b2 << 16 | b3 << 8 | b4;
    }

    if (b0 === 30) {
        return parseFloatOperand(parser);
    }

    if (b0 >= 32 && b0 <= 246) {
        return b0 - 139;
    }

    if (b0 >= 247 && b0 <= 250) {
        b1 = parser.parseByte();
        return (b0 - 247) * 256 + b1 + 108;
    }

    if (b0 >= 251 && b0 <= 254) {
        b1 = parser.parseByte();
        return -(b0 - 251) * 256 - b1 - 108;
    }

    throw new Error('Invalid b0 ' + b0);
}

// Convert the entries returned by `parseDict` to a proper dictionary.
// If a value is a list of one, it is unpacked.
function entriesToObject(entries) {
    var o = {};
    for (var i = 0; i < entries.length; i += 1) {
        var key = entries[i][0];
        var values = entries[i][1];
        var value = (void 0);
        if (values.length === 1) {
            value = values[0];
        } else {
            value = values;
        }

        if (o.hasOwnProperty(key) && !isNaN(o[key])) {
            throw new Error('Object ' + o + ' already has key ' + key);
        }

        o[key] = value;
    }

    return o;
}

// Parse a `CFF` DICT object.
// A dictionary contains key-value pairs in a compact tokenized format.
function parseCFFDict(data, start, size) {
    start = start !== undefined ? start : 0;
    var parser = new parse.Parser(data, start);
    var entries = [];
    var operands = [];
    size = size !== undefined ? size : data.length;

    while (parser.relativeOffset < size) {
        var op = parser.parseByte();

        // The first byte for each dict item distinguishes between operator (key) and operand (value).
        // Values <= 21 are operators.
        if (op <= 21) {
            // Two-byte operators have an initial escape byte of 12.
            if (op === 12) {
                op = 1200 + parser.parseByte();
            }

            entries.push([op, operands]);
            operands = [];
        } else {
            // Since the operands (values) come before the operators (keys), we store all operands in a list
            // until we encounter an operator.
            operands.push(parseOperand(parser, op));
        }
    }

    return entriesToObject(entries);
}

// Given a String Index (SID), return the value of the string.
// Strings below index 392 are standard CFF strings and are not encoded in the font.
function getCFFString(strings, index) {
    if (index <= 390) {
        index = cffStandardStrings[index];
    } else {
        index = strings[index - 391];
    }

    return index;
}

// Interpret a dictionary and return a new dictionary with readable keys and values for missing entries.
// This function takes `meta` which is a list of objects containing `operand`, `name` and `default`.
function interpretDict(dict, meta, strings) {
    var newDict = {};
    var value;

    // Because we also want to include missing values, we start out from the meta list
    // and lookup values in the dict.
    for (var i = 0; i < meta.length; i += 1) {
        var m = meta[i];

        if (Array.isArray(m.type)) {
            var values = [];
            values.length = m.type.length;
            for (var j = 0; j < m.type.length; j++) {
                value = dict[m.op] !== undefined ? dict[m.op][j] : undefined;
                if (value === undefined) {
                    value = m.value !== undefined && m.value[j] !== undefined ? m.value[j] : null;
                }
                if (m.type[j] === 'SID') {
                    value = getCFFString(strings, value);
                }
                values[j] = value;
            }
            newDict[m.name] = values;
        } else {
            value = dict[m.op];
            if (value === undefined) {
                value = m.value !== undefined ? m.value : null;
            }

            if (m.type === 'SID') {
                value = getCFFString(strings, value);
            }
            newDict[m.name] = value;
        }
    }

    return newDict;
}

// Parse the CFF header.
function parseCFFHeader(data, start) {
    var header = {};
    header.formatMajor = parse.getCard8(data, start);
    header.formatMinor = parse.getCard8(data, start + 1);
    header.size = parse.getCard8(data, start + 2);
    header.offsetSize = parse.getCard8(data, start + 3);
    header.startOffset = start;
    header.endOffset = start + 4;
    return header;
}

var TOP_DICT_META = [
    {name: 'version', op: 0, type: 'SID'},
    {name: 'notice', op: 1, type: 'SID'},
    {name: 'copyright', op: 1200, type: 'SID'},
    {name: 'fullName', op: 2, type: 'SID'},
    {name: 'familyName', op: 3, type: 'SID'},
    {name: 'weight', op: 4, type: 'SID'},
    {name: 'isFixedPitch', op: 1201, type: 'number', value: 0},
    {name: 'italicAngle', op: 1202, type: 'number', value: 0},
    {name: 'underlinePosition', op: 1203, type: 'number', value: -100},
    {name: 'underlineThickness', op: 1204, type: 'number', value: 50},
    {name: 'paintType', op: 1205, type: 'number', value: 0},
    {name: 'charstringType', op: 1206, type: 'number', value: 2},
    {
        name: 'fontMatrix',
        op: 1207,
        type: ['real', 'real', 'real', 'real', 'real', 'real'],
        value: [0.001, 0, 0, 0.001, 0, 0]
    },
    {name: 'uniqueId', op: 13, type: 'number'},
    {name: 'fontBBox', op: 5, type: ['number', 'number', 'number', 'number'], value: [0, 0, 0, 0]},
    {name: 'strokeWidth', op: 1208, type: 'number', value: 0},
    {name: 'xuid', op: 14, type: [], value: null},
    {name: 'charset', op: 15, type: 'offset', value: 0},
    {name: 'encoding', op: 16, type: 'offset', value: 0},
    {name: 'charStrings', op: 17, type: 'offset', value: 0},
    {name: 'private', op: 18, type: ['number', 'offset'], value: [0, 0]},
    {name: 'ros', op: 1230, type: ['SID', 'SID', 'number']},
    {name: 'cidFontVersion', op: 1231, type: 'number', value: 0},
    {name: 'cidFontRevision', op: 1232, type: 'number', value: 0},
    {name: 'cidFontType', op: 1233, type: 'number', value: 0},
    {name: 'cidCount', op: 1234, type: 'number', value: 8720},
    {name: 'uidBase', op: 1235, type: 'number'},
    {name: 'fdArray', op: 1236, type: 'offset'},
    {name: 'fdSelect', op: 1237, type: 'offset'},
    {name: 'fontName', op: 1238, type: 'SID'}
];

var PRIVATE_DICT_META = [
    {name: 'subrs', op: 19, type: 'offset', value: 0},
    {name: 'defaultWidthX', op: 20, type: 'number', value: 0},
    {name: 'nominalWidthX', op: 21, type: 'number', value: 0}
];

// Parse the CFF top dictionary. A CFF table can contain multiple fonts, each with their own top dictionary.
// The top dictionary contains the essential metadata for the font, together with the private dictionary.
function parseCFFTopDict(data, strings) {
    var dict = parseCFFDict(data, 0, data.byteLength);
    return interpretDict(dict, TOP_DICT_META, strings);
}

// Parse the CFF private dictionary. We don't fully parse out all the values, only the ones we need.
function parseCFFPrivateDict(data, start, size, strings) {
    var dict = parseCFFDict(data, start, size);
    return interpretDict(dict, PRIVATE_DICT_META, strings);
}

// Returns a list of "Top DICT"s found using an INDEX list.
// Used to read both the usual high-level Top DICTs and also the FDArray
// discovered inside CID-keyed fonts.  When a Top DICT has a reference to
// a Private DICT that is read and saved into the Top DICT.
//
// In addition to the expected/optional values as outlined in TOP_DICT_META
// the following values might be saved into the Top DICT.
//
//    _subrs []        array of local CFF subroutines from Private DICT
//    _subrsBias       bias value computed from number of subroutines
//                      (see calcCFFSubroutineBias() and parseCFFCharstring())
//    _defaultWidthX   default widths for CFF characters
//    _nominalWidthX   bias added to width embedded within glyph description
//
//    _privateDict     saved copy of parsed Private DICT from Top DICT
function gatherCFFTopDicts(data, start, cffIndex, strings) {
    var topDictArray = [];
    for (var iTopDict = 0; iTopDict < cffIndex.length; iTopDict += 1) {
        var topDictData = new DataView(new Uint8Array(cffIndex[iTopDict]).buffer);
        var topDict = parseCFFTopDict(topDictData, strings);
        topDict._subrs = [];
        topDict._subrsBias = 0;
        var privateSize = topDict.private[0];
        var privateOffset = topDict.private[1];
        if (privateSize !== 0 && privateOffset !== 0) {
            var privateDict = parseCFFPrivateDict(data, privateOffset + start, privateSize, strings);
            topDict._defaultWidthX = privateDict.defaultWidthX;
            topDict._nominalWidthX = privateDict.nominalWidthX;
            if (privateDict.subrs !== 0) {
                var subrOffset = privateOffset + privateDict.subrs;
                var subrIndex = parseCFFIndex(data, subrOffset + start);
                topDict._subrs = subrIndex.objects;
                topDict._subrsBias = calcCFFSubroutineBias(topDict._subrs);
            }
            topDict._privateDict = privateDict;
        }
        topDictArray.push(topDict);
    }
    return topDictArray;
}

// Parse the CFF charset table, which contains internal names for all the glyphs.
// This function will return a list of glyph names.
// See Adobe TN #5176 chapter 13, "Charsets".
function parseCFFCharset(data, start, nGlyphs, strings) {
    var sid;
    var count;
    var parser = new parse.Parser(data, start);

    // The .notdef glyph is not included, so subtract 1.
    nGlyphs -= 1;
    var charset = ['.notdef'];

    var format = parser.parseCard8();
    if (format === 0) {
        for (var i = 0; i < nGlyphs; i += 1) {
            sid = parser.parseSID();
            charset.push(getCFFString(strings, sid));
        }
    } else if (format === 1) {
        while (charset.length <= nGlyphs) {
            sid = parser.parseSID();
            count = parser.parseCard8();
            for (var i$1 = 0; i$1 <= count; i$1 += 1) {
                charset.push(getCFFString(strings, sid));
                sid += 1;
            }
        }
    } else if (format === 2) {
        while (charset.length <= nGlyphs) {
            sid = parser.parseSID();
            count = parser.parseCard16();
            for (var i$2 = 0; i$2 <= count; i$2 += 1) {
                charset.push(getCFFString(strings, sid));
                sid += 1;
            }
        }
    } else {
        throw new Error('Unknown charset format ' + format);
    }

    return charset;
}

// Parse the CFF encoding data. Only one encoding can be specified per font.
// See Adobe TN #5176 chapter 12, "Encodings".
function parseCFFEncoding(data, start, charset) {
    var code;
    var enc = {};
    var parser = new parse.Parser(data, start);
    var format = parser.parseCard8();
    if (format === 0) {
        var nCodes = parser.parseCard8();
        for (var i = 0; i < nCodes; i += 1) {
            code = parser.parseCard8();
            enc[code] = i;
        }
    } else if (format === 1) {
        var nRanges = parser.parseCard8();
        code = 1;
        for (var i$1 = 0; i$1 < nRanges; i$1 += 1) {
            var first = parser.parseCard8();
            var nLeft = parser.parseCard8();
            for (var j = first; j <= first + nLeft; j += 1) {
                enc[j] = code;
                code += 1;
            }
        }
    } else {
        throw new Error('Unknown encoding format ' + format);
    }

    return new CffEncoding(enc, charset);
}

// Take in charstring code and return a Glyph object.
// The encoding is described in the Type 2 Charstring Format
// https://www.microsoft.com/typography/OTSPEC/charstr2.htm
function parseCFFCharstring(font, glyph, code) {
    var c1x;
    var c1y;
    var c2x;
    var c2y;
    var p = new Path();
    var stack = [];
    var nStems = 0;
    var haveWidth = false;
    var open = false;
    var x = 0;
    var y = 0;
    var subrs;
    var subrsBias;
    var defaultWidthX;
    var nominalWidthX;
    if (font.isCIDFont) {
        var fdIndex = font.tables.cff.topDict._fdSelect[glyph.index];
        var fdDict = font.tables.cff.topDict._fdArray[fdIndex];
        subrs = fdDict._subrs;
        subrsBias = fdDict._subrsBias;
        defaultWidthX = fdDict._defaultWidthX;
        nominalWidthX = fdDict._nominalWidthX;
    } else {
        subrs = font.tables.cff.topDict._subrs;
        subrsBias = font.tables.cff.topDict._subrsBias;
        defaultWidthX = font.tables.cff.topDict._defaultWidthX;
        nominalWidthX = font.tables.cff.topDict._nominalWidthX;
    }
    var width = defaultWidthX;

    function newContour(x, y) {
        if (open) {
            p.closePath();
        }

        p.moveTo(x, y);
        open = true;
    }

    function parseStems() {
        var hasWidthArg;

        // The number of stem operators on the stack is always even.
        // If the value is uneven, that means a width is specified.
        hasWidthArg = stack.length % 2 !== 0;
        if (hasWidthArg && !haveWidth) {
            width = stack.shift() + nominalWidthX;
        }

        nStems += stack.length >> 1;
        stack.length = 0;
        haveWidth = true;
    }

    function parse$$1(code) {
        var b1;
        var b2;
        var b3;
        var b4;
        var codeIndex;
        var subrCode;
        var jpx;
        var jpy;
        var c3x;
        var c3y;
        var c4x;
        var c4y;

        var i = 0;
        while (i < code.length) {
            var v = code[i];
            i += 1;
            switch (v) {
                case 1: // hstem
                    parseStems();
                    break;
                case 3: // vstem
                    parseStems();
                    break;
                case 4: // vmoveto
                    if (stack.length > 1 && !haveWidth) {
                        width = stack.shift() + nominalWidthX;
                        haveWidth = true;
                    }

                    y += stack.pop();
                    newContour(x, y);
                    break;
                case 5: // rlineto
                    while (stack.length > 0) {
                        x += stack.shift();
                        y += stack.shift();
                        p.lineTo(x, y);
                    }

                    break;
                case 6: // hlineto
                    while (stack.length > 0) {
                        x += stack.shift();
                        p.lineTo(x, y);
                        if (stack.length === 0) {
                            break;
                        }

                        y += stack.shift();
                        p.lineTo(x, y);
                    }

                    break;
                case 7: // vlineto
                    while (stack.length > 0) {
                        y += stack.shift();
                        p.lineTo(x, y);
                        if (stack.length === 0) {
                            break;
                        }

                        x += stack.shift();
                        p.lineTo(x, y);
                    }

                    break;
                case 8: // rrcurveto
                    while (stack.length > 0) {
                        c1x = x + stack.shift();
                        c1y = y + stack.shift();
                        c2x = c1x + stack.shift();
                        c2y = c1y + stack.shift();
                        x = c2x + stack.shift();
                        y = c2y + stack.shift();
                        p.curveTo(c1x, c1y, c2x, c2y, x, y);
                    }

                    break;
                case 10: // callsubr
                    codeIndex = stack.pop() + subrsBias;
                    subrCode = subrs[codeIndex];
                    if (subrCode) {
                        parse$$1(subrCode);
                    }

                    break;
                case 11: // return
                    return;
                case 12: // flex operators
                    v = code[i];
                    i += 1;
                    switch (v) {
                        case 35: // flex
                            // |- dx1 dy1 dx2 dy2 dx3 dy3 dx4 dy4 dx5 dy5 dx6 dy6 fd flex (12 35) |-
                            c1x = x   + stack.shift();    // dx1
                            c1y = y   + stack.shift();    // dy1
                            c2x = c1x + stack.shift();    // dx2
                            c2y = c1y + stack.shift();    // dy2
                            jpx = c2x + stack.shift();    // dx3
                            jpy = c2y + stack.shift();    // dy3
                            c3x = jpx + stack.shift();    // dx4
                            c3y = jpy + stack.shift();    // dy4
                            c4x = c3x + stack.shift();    // dx5
                            c4y = c3y + stack.shift();    // dy5
                            x = c4x   + stack.shift();    // dx6
                            y = c4y   + stack.shift();    // dy6
                            stack.shift();                // flex depth
                            p.curveTo(c1x, c1y, c2x, c2y, jpx, jpy);
                            p.curveTo(c3x, c3y, c4x, c4y, x, y);
                            break;
                        case 34: // hflex
                            // |- dx1 dx2 dy2 dx3 dx4 dx5 dx6 hflex (12 34) |-
                            c1x = x   + stack.shift();    // dx1
                            c1y = y;                      // dy1
                            c2x = c1x + stack.shift();    // dx2
                            c2y = c1y + stack.shift();    // dy2
                            jpx = c2x + stack.shift();    // dx3
                            jpy = c2y;                    // dy3
                            c3x = jpx + stack.shift();    // dx4
                            c3y = c2y;                    // dy4
                            c4x = c3x + stack.shift();    // dx5
                            c4y = y;                      // dy5
                            x = c4x + stack.shift();      // dx6
                            p.curveTo(c1x, c1y, c2x, c2y, jpx, jpy);
                            p.curveTo(c3x, c3y, c4x, c4y, x, y);
                            break;
                        case 36: // hflex1
                            // |- dx1 dy1 dx2 dy2 dx3 dx4 dx5 dy5 dx6 hflex1 (12 36) |-
                            c1x = x   + stack.shift();    // dx1
                            c1y = y   + stack.shift();    // dy1
                            c2x = c1x + stack.shift();    // dx2
                            c2y = c1y + stack.shift();    // dy2
                            jpx = c2x + stack.shift();    // dx3
                            jpy = c2y;                    // dy3
                            c3x = jpx + stack.shift();    // dx4
                            c3y = c2y;                    // dy4
                            c4x = c3x + stack.shift();    // dx5
                            c4y = c3y + stack.shift();    // dy5
                            x = c4x + stack.shift();      // dx6
                            p.curveTo(c1x, c1y, c2x, c2y, jpx, jpy);
                            p.curveTo(c3x, c3y, c4x, c4y, x, y);
                            break;
                        case 37: // flex1
                            // |- dx1 dy1 dx2 dy2 dx3 dy3 dx4 dy4 dx5 dy5 d6 flex1 (12 37) |-
                            c1x = x   + stack.shift();    // dx1
                            c1y = y   + stack.shift();    // dy1
                            c2x = c1x + stack.shift();    // dx2
                            c2y = c1y + stack.shift();    // dy2
                            jpx = c2x + stack.shift();    // dx3
                            jpy = c2y + stack.shift();    // dy3
                            c3x = jpx + stack.shift();    // dx4
                            c3y = jpy + stack.shift();    // dy4
                            c4x = c3x + stack.shift();    // dx5
                            c4y = c3y + stack.shift();    // dy5
                            if (Math.abs(c4x - x) > Math.abs(c4y - y)) {
                                x = c4x + stack.shift();
                            } else {
                                y = c4y + stack.shift();
                            }

                            p.curveTo(c1x, c1y, c2x, c2y, jpx, jpy);
                            p.curveTo(c3x, c3y, c4x, c4y, x, y);
                            break;
                        default:
                            console.log('Glyph ' + glyph.index + ': unknown operator ' + 1200 + v);
                            stack.length = 0;
                    }
                    break;
                case 14: // endchar
                    if (stack.length > 0 && !haveWidth) {
                        width = stack.shift() + nominalWidthX;
                        haveWidth = true;
                    }

                    if (open) {
                        p.closePath();
                        open = false;
                    }

                    break;
                case 18: // hstemhm
                    parseStems();
                    break;
                case 19: // hintmask
                case 20: // cntrmask
                    parseStems();
                    i += (nStems + 7) >> 3;
                    break;
                case 21: // rmoveto
                    if (stack.length > 2 && !haveWidth) {
                        width = stack.shift() + nominalWidthX;
                        haveWidth = true;
                    }

                    y += stack.pop();
                    x += stack.pop();
                    newContour(x, y);
                    break;
                case 22: // hmoveto
                    if (stack.length > 1 && !haveWidth) {
                        width = stack.shift() + nominalWidthX;
                        haveWidth = true;
                    }

                    x += stack.pop();
                    newContour(x, y);
                    break;
                case 23: // vstemhm
                    parseStems();
                    break;
                case 24: // rcurveline
                    while (stack.length > 2) {
                        c1x = x + stack.shift();
                        c1y = y + stack.shift();
                        c2x = c1x + stack.shift();
                        c2y = c1y + stack.shift();
                        x = c2x + stack.shift();
                        y = c2y + stack.shift();
                        p.curveTo(c1x, c1y, c2x, c2y, x, y);
                    }

                    x += stack.shift();
                    y += stack.shift();
                    p.lineTo(x, y);
                    break;
                case 25: // rlinecurve
                    while (stack.length > 6) {
                        x += stack.shift();
                        y += stack.shift();
                        p.lineTo(x, y);
                    }

                    c1x = x + stack.shift();
                    c1y = y + stack.shift();
                    c2x = c1x + stack.shift();
                    c2y = c1y + stack.shift();
                    x = c2x + stack.shift();
                    y = c2y + stack.shift();
                    p.curveTo(c1x, c1y, c2x, c2y, x, y);
                    break;
                case 26: // vvcurveto
                    if (stack.length % 2) {
                        x += stack.shift();
                    }

                    while (stack.length > 0) {
                        c1x = x;
                        c1y = y + stack.shift();
                        c2x = c1x + stack.shift();
                        c2y = c1y + stack.shift();
                        x = c2x;
                        y = c2y + stack.shift();
                        p.curveTo(c1x, c1y, c2x, c2y, x, y);
                    }

                    break;
                case 27: // hhcurveto
                    if (stack.length % 2) {
                        y += stack.shift();
                    }

                    while (stack.length > 0) {
                        c1x = x + stack.shift();
                        c1y = y;
                        c2x = c1x + stack.shift();
                        c2y = c1y + stack.shift();
                        x = c2x + stack.shift();
                        y = c2y;
                        p.curveTo(c1x, c1y, c2x, c2y, x, y);
                    }

                    break;
                case 28: // shortint
                    b1 = code[i];
                    b2 = code[i + 1];
                    stack.push(((b1 << 24) | (b2 << 16)) >> 16);
                    i += 2;
                    break;
                case 29: // callgsubr
                    codeIndex = stack.pop() + font.gsubrsBias;
                    subrCode = font.gsubrs[codeIndex];
                    if (subrCode) {
                        parse$$1(subrCode);
                    }

                    break;
                case 30: // vhcurveto
                    while (stack.length > 0) {
                        c1x = x;
                        c1y = y + stack.shift();
                        c2x = c1x + stack.shift();
                        c2y = c1y + stack.shift();
                        x = c2x + stack.shift();
                        y = c2y + (stack.length === 1 ? stack.shift() : 0);
                        p.curveTo(c1x, c1y, c2x, c2y, x, y);
                        if (stack.length === 0) {
                            break;
                        }

                        c1x = x + stack.shift();
                        c1y = y;
                        c2x = c1x + stack.shift();
                        c2y = c1y + stack.shift();
                        y = c2y + stack.shift();
                        x = c2x + (stack.length === 1 ? stack.shift() : 0);
                        p.curveTo(c1x, c1y, c2x, c2y, x, y);
                    }

                    break;
                case 31: // hvcurveto
                    while (stack.length > 0) {
                        c1x = x + stack.shift();
                        c1y = y;
                        c2x = c1x + stack.shift();
                        c2y = c1y + stack.shift();
                        y = c2y + stack.shift();
                        x = c2x + (stack.length === 1 ? stack.shift() : 0);
                        p.curveTo(c1x, c1y, c2x, c2y, x, y);
                        if (stack.length === 0) {
                            break;
                        }

                        c1x = x;
                        c1y = y + stack.shift();
                        c2x = c1x + stack.shift();
                        c2y = c1y + stack.shift();
                        x = c2x + stack.shift();
                        y = c2y + (stack.length === 1 ? stack.shift() : 0);
                        p.curveTo(c1x, c1y, c2x, c2y, x, y);
                    }

                    break;
                default:
                    if (v < 32) {
                        console.log('Glyph ' + glyph.index + ': unknown operator ' + v);
                    } else if (v < 247) {
                        stack.push(v - 139);
                    } else if (v < 251) {
                        b1 = code[i];
                        i += 1;
                        stack.push((v - 247) * 256 + b1 + 108);
                    } else if (v < 255) {
                        b1 = code[i];
                        i += 1;
                        stack.push(-(v - 251) * 256 - b1 - 108);
                    } else {
                        b1 = code[i];
                        b2 = code[i + 1];
                        b3 = code[i + 2];
                        b4 = code[i + 3];
                        i += 4;
                        stack.push(((b1 << 24) | (b2 << 16) | (b3 << 8) | b4) / 65536);
                    }
            }
        }
    }

    parse$$1(code);

    glyph.advanceWidth = width;
    return p;
}

function parseCFFFDSelect(data, start, nGlyphs, fdArrayCount) {
    var fdSelect = [];
    var fdIndex;
    var parser = new parse.Parser(data, start);
    var format = parser.parseCard8();
    if (format === 0) {
        // Simple list of nGlyphs elements
        for (var iGid = 0; iGid < nGlyphs; iGid++) {
            fdIndex = parser.parseCard8();
            if (fdIndex >= fdArrayCount) {
                throw new Error('CFF table CID Font FDSelect has bad FD index value ' + fdIndex + ' (FD count ' + fdArrayCount + ')');
            }
            fdSelect.push(fdIndex);
        }
    } else if (format === 3) {
        // Ranges
        var nRanges = parser.parseCard16();
        var first = parser.parseCard16();
        if (first !== 0) {
            throw new Error('CFF Table CID Font FDSelect format 3 range has bad initial GID ' + first);
        }
        var next;
        for (var iRange = 0; iRange < nRanges; iRange++) {
            fdIndex = parser.parseCard8();
            next = parser.parseCard16();
            if (fdIndex >= fdArrayCount) {
                throw new Error('CFF table CID Font FDSelect has bad FD index value ' + fdIndex + ' (FD count ' + fdArrayCount + ')');
            }
            if (next > nGlyphs) {
                throw new Error('CFF Table CID Font FDSelect format 3 range has bad GID ' + next);
            }
            for (; first < next; first++) {
                fdSelect.push(fdIndex);
            }
            first = next;
        }
        if (next !== nGlyphs) {
            throw new Error('CFF Table CID Font FDSelect format 3 range has bad final GID ' + next);
        }
    } else {
        throw new Error('CFF Table CID Font FDSelect table has unsupported format ' + format);
    }
    return fdSelect;
}

// Parse the `CFF` table, which contains the glyph outlines in PostScript format.
function parseCFFTable(data, start, font) {
    font.tables.cff = {};
    var header = parseCFFHeader(data, start);
    var nameIndex = parseCFFIndex(data, header.endOffset, parse.bytesToString);
    var topDictIndex = parseCFFIndex(data, nameIndex.endOffset);
    var stringIndex = parseCFFIndex(data, topDictIndex.endOffset, parse.bytesToString);
    var globalSubrIndex = parseCFFIndex(data, stringIndex.endOffset);
    font.gsubrs = globalSubrIndex.objects;
    font.gsubrsBias = calcCFFSubroutineBias(font.gsubrs);

    var topDictArray = gatherCFFTopDicts(data, start, topDictIndex.objects, stringIndex.objects);
    if (topDictArray.length !== 1) {
        throw new Error('CFF table has too many fonts in \'FontSet\' - count of fonts NameIndex.length = ' + topDictArray.length);
    }

    var topDict = topDictArray[0];
    font.tables.cff.topDict = topDict;

    if (topDict._privateDict) {
        font.defaultWidthX = topDict._privateDict.defaultWidthX;
        font.nominalWidthX = topDict._privateDict.nominalWidthX;
    }

    if (topDict.ros[0] !== undefined && topDict.ros[1] !== undefined) {
        font.isCIDFont = true;
    }

    if (font.isCIDFont) {
        var fdArrayOffset = topDict.fdArray;
        var fdSelectOffset = topDict.fdSelect;
        if (fdArrayOffset === 0 || fdSelectOffset === 0) {
            throw new Error('Font is marked as a CID font, but FDArray and/or FDSelect information is missing');
        }
        fdArrayOffset += start;
        var fdArrayIndex = parseCFFIndex(data, fdArrayOffset);
        var fdArray = gatherCFFTopDicts(data, start, fdArrayIndex.objects, stringIndex.objects);
        topDict._fdArray = fdArray;
        fdSelectOffset += start;
        topDict._fdSelect = parseCFFFDSelect(data, fdSelectOffset, font.numGlyphs, fdArray.length);
    }

    var privateDictOffset = start + topDict.private[1];
    var privateDict = parseCFFPrivateDict(data, privateDictOffset, topDict.private[0], stringIndex.objects);
    font.defaultWidthX = privateDict.defaultWidthX;
    font.nominalWidthX = privateDict.nominalWidthX;

    if (privateDict.subrs !== 0) {
        var subrOffset = privateDictOffset + privateDict.subrs;
        var subrIndex = parseCFFIndex(data, subrOffset);
        font.subrs = subrIndex.objects;
        font.subrsBias = calcCFFSubroutineBias(font.subrs);
    } else {
        font.subrs = [];
        font.subrsBias = 0;
    }

    // Offsets in the top dict are relative to the beginning of the CFF data, so add the CFF start offset.
    var charStringsIndex = parseCFFIndex(data, start + topDict.charStrings);
    font.nGlyphs = charStringsIndex.objects.length;

    var charset = parseCFFCharset(data, start + topDict.charset, font.nGlyphs, stringIndex.objects);
    if (topDict.encoding === 0) { // Standard encoding
        font.cffEncoding = new CffEncoding(cffStandardEncoding, charset);
    } else if (topDict.encoding === 1) { // Expert encoding
        font.cffEncoding = new CffEncoding(cffExpertEncoding, charset);
    } else {
        font.cffEncoding = parseCFFEncoding(data, start + topDict.encoding, charset);
    }

    // Prefer the CMAP encoding to the CFF encoding.
    font.encoding = font.encoding || font.cffEncoding;

    font.glyphs = new glyphset.GlyphSet(font);
    for (var i = 0; i < font.nGlyphs; i += 1) {
        var charString = charStringsIndex.objects[i];
        font.glyphs.push(i, glyphset.cffGlyphLoader(font, i, parseCFFCharstring, charString));
    }
}

// Convert a string to a String ID (SID).
// The list of strings is modified in place.
function encodeString(s, strings) {
    var sid;

    // Is the string in the CFF standard strings?
    var i = cffStandardStrings.indexOf(s);
    if (i >= 0) {
        sid = i;
    }

    // Is the string already in the string index?
    i = strings.indexOf(s);
    if (i >= 0) {
        sid = i + cffStandardStrings.length;
    } else {
        sid = cffStandardStrings.length + strings.length;
        strings.push(s);
    }

    return sid;
}

function makeHeader() {
    return new table.Record('Header', [
        {name: 'major', type: 'Card8', value: 1},
        {name: 'minor', type: 'Card8', value: 0},
        {name: 'hdrSize', type: 'Card8', value: 4},
        {name: 'major', type: 'Card8', value: 1}
    ]);
}

function makeNameIndex(fontNames) {
    var t = new table.Record('Name INDEX', [
        {name: 'names', type: 'INDEX', value: []}
    ]);
    t.names = [];
    for (var i = 0; i < fontNames.length; i += 1) {
        t.names.push({name: 'name_' + i, type: 'NAME', value: fontNames[i]});
    }

    return t;
}

// Given a dictionary's metadata, create a DICT structure.
function makeDict(meta, attrs, strings) {
    var m = {};
    for (var i = 0; i < meta.length; i += 1) {
        var entry = meta[i];
        var value = attrs[entry.name];
        if (value !== undefined && !equals(value, entry.value)) {
            if (entry.type === 'SID') {
                value = encodeString(value, strings);
            }

            m[entry.op] = {name: entry.name, type: entry.type, value: value};
        }
    }

    return m;
}

// The Top DICT houses the global font attributes.
function makeTopDict(attrs, strings) {
    var t = new table.Record('Top DICT', [
        {name: 'dict', type: 'DICT', value: {}}
    ]);
    t.dict = makeDict(TOP_DICT_META, attrs, strings);
    return t;
}

function makeTopDictIndex(topDict) {
    var t = new table.Record('Top DICT INDEX', [
        {name: 'topDicts', type: 'INDEX', value: []}
    ]);
    t.topDicts = [{name: 'topDict_0', type: 'TABLE', value: topDict}];
    return t;
}

function makeStringIndex(strings) {
    var t = new table.Record('String INDEX', [
        {name: 'strings', type: 'INDEX', value: []}
    ]);
    t.strings = [];
    for (var i = 0; i < strings.length; i += 1) {
        t.strings.push({name: 'string_' + i, type: 'STRING', value: strings[i]});
    }

    return t;
}

function makeGlobalSubrIndex() {
    // Currently we don't use subroutines.
    return new table.Record('Global Subr INDEX', [
        {name: 'subrs', type: 'INDEX', value: []}
    ]);
}

function makeCharsets(glyphNames, strings) {
    var t = new table.Record('Charsets', [
        {name: 'format', type: 'Card8', value: 0}
    ]);
    for (var i = 0; i < glyphNames.length; i += 1) {
        var glyphName = glyphNames[i];
        var glyphSID = encodeString(glyphName, strings);
        t.fields.push({name: 'glyph_' + i, type: 'SID', value: glyphSID});
    }

    return t;
}

function glyphToOps(glyph) {
    var ops = [];
    var path = glyph.path;
    ops.push({name: 'width', type: 'NUMBER', value: glyph.advanceWidth});
    var x = 0;
    var y = 0;
    for (var i = 0; i < path.commands.length; i += 1) {
        var dx = (void 0);
        var dy = (void 0);
        var cmd = path.commands[i];
        if (cmd.type === 'Q') {
            // CFF only supports bézier curves, so convert the quad to a bézier.
            var _13 = 1 / 3;
            var _23 = 2 / 3;

            // We're going to create a new command so we don't change the original path.
            cmd = {
                type: 'C',
                x: cmd.x,
                y: cmd.y,
                x1: _13 * x + _23 * cmd.x1,
                y1: _13 * y + _23 * cmd.y1,
                x2: _13 * cmd.x + _23 * cmd.x1,
                y2: _13 * cmd.y + _23 * cmd.y1
            };
        }

        if (cmd.type === 'M') {
            dx = Math.round(cmd.x - x);
            dy = Math.round(cmd.y - y);
            ops.push({name: 'dx', type: 'NUMBER', value: dx});
            ops.push({name: 'dy', type: 'NUMBER', value: dy});
            ops.push({name: 'rmoveto', type: 'OP', value: 21});
            x = Math.round(cmd.x);
            y = Math.round(cmd.y);
        } else if (cmd.type === 'L') {
            dx = Math.round(cmd.x - x);
            dy = Math.round(cmd.y - y);
            ops.push({name: 'dx', type: 'NUMBER', value: dx});
            ops.push({name: 'dy', type: 'NUMBER', value: dy});
            ops.push({name: 'rlineto', type: 'OP', value: 5});
            x = Math.round(cmd.x);
            y = Math.round(cmd.y);
        } else if (cmd.type === 'C') {
            var dx1 = Math.round(cmd.x1 - x);
            var dy1 = Math.round(cmd.y1 - y);
            var dx2 = Math.round(cmd.x2 - cmd.x1);
            var dy2 = Math.round(cmd.y2 - cmd.y1);
            dx = Math.round(cmd.x - cmd.x2);
            dy = Math.round(cmd.y - cmd.y2);
            ops.push({name: 'dx1', type: 'NUMBER', value: dx1});
            ops.push({name: 'dy1', type: 'NUMBER', value: dy1});
            ops.push({name: 'dx2', type: 'NUMBER', value: dx2});
            ops.push({name: 'dy2', type: 'NUMBER', value: dy2});
            ops.push({name: 'dx', type: 'NUMBER', value: dx});
            ops.push({name: 'dy', type: 'NUMBER', value: dy});
            ops.push({name: 'rrcurveto', type: 'OP', value: 8});
            x = Math.round(cmd.x);
            y = Math.round(cmd.y);
        }

        // Contours are closed automatically.
    }

    ops.push({name: 'endchar', type: 'OP', value: 14});
    return ops;
}

function makeCharStringsIndex(glyphs) {
    var t = new table.Record('CharStrings INDEX', [
        {name: 'charStrings', type: 'INDEX', value: []}
    ]);

    for (var i = 0; i < glyphs.length; i += 1) {
        var glyph = glyphs.get(i);
        var ops = glyphToOps(glyph);
        t.charStrings.push({name: glyph.name, type: 'CHARSTRING', value: ops});
    }

    return t;
}

function makePrivateDict(attrs, strings) {
    var t = new table.Record('Private DICT', [
        {name: 'dict', type: 'DICT', value: {}}
    ]);
    t.dict = makeDict(PRIVATE_DICT_META, attrs, strings);
    return t;
}

function makeCFFTable(glyphs, options) {
    var t = new table.Table('CFF ', [
        {name: 'header', type: 'RECORD'},
        {name: 'nameIndex', type: 'RECORD'},
        {name: 'topDictIndex', type: 'RECORD'},
        {name: 'stringIndex', type: 'RECORD'},
        {name: 'globalSubrIndex', type: 'RECORD'},
        {name: 'charsets', type: 'RECORD'},
        {name: 'charStringsIndex', type: 'RECORD'},
        {name: 'privateDict', type: 'RECORD'}
    ]);

    var fontScale = 1 / options.unitsPerEm;
    // We use non-zero values for the offsets so that the DICT encodes them.
    // This is important because the size of the Top DICT plays a role in offset calculation,
    // and the size shouldn't change after we've written correct offsets.
    var attrs = {
        version: options.version,
        fullName: options.fullName,
        familyName: options.familyName,
        weight: options.weightName,
        fontBBox: options.fontBBox || [0, 0, 0, 0],
        fontMatrix: [fontScale, 0, 0, fontScale, 0, 0],
        charset: 999,
        encoding: 0,
        charStrings: 999,
        private: [0, 999]
    };

    var privateAttrs = {};

    var glyphNames = [];
    var glyph;

    // Skip first glyph (.notdef)
    for (var i = 1; i < glyphs.length; i += 1) {
        glyph = glyphs.get(i);
        glyphNames.push(glyph.name);
    }

    var strings = [];

    t.header = makeHeader();
    t.nameIndex = makeNameIndex([options.postScriptName]);
    var topDict = makeTopDict(attrs, strings);
    t.topDictIndex = makeTopDictIndex(topDict);
    t.globalSubrIndex = makeGlobalSubrIndex();
    t.charsets = makeCharsets(glyphNames, strings);
    t.charStringsIndex = makeCharStringsIndex(glyphs);
    t.privateDict = makePrivateDict(privateAttrs, strings);

    // Needs to come at the end, to encode all custom strings used in the font.
    t.stringIndex = makeStringIndex(strings);

    var startOffset = t.header.sizeOf() +
        t.nameIndex.sizeOf() +
        t.topDictIndex.sizeOf() +
        t.stringIndex.sizeOf() +
        t.globalSubrIndex.sizeOf();
    attrs.charset = startOffset;

    // We use the CFF standard encoding; proper encoding will be handled in cmap.
    attrs.encoding = 0;
    attrs.charStrings = attrs.charset + t.charsets.sizeOf();
    attrs.private[1] = attrs.charStrings + t.charStringsIndex.sizeOf();

    // Recreate the Top DICT INDEX with the correct offsets.
    topDict = makeTopDict(attrs, strings);
    t.topDictIndex = makeTopDictIndex(topDict);

    return t;
}

var cff = { parse: parseCFFTable, make: makeCFFTable };

// The `head` table contains global information about the font.
// https://www.microsoft.com/typography/OTSPEC/head.htm

// Parse the header `head` table
function parseHeadTable(data, start) {
    var head = {};
    var p = new parse.Parser(data, start);
    head.version = p.parseVersion();
    head.fontRevision = Math.round(p.parseFixed() * 1000) / 1000;
    head.checkSumAdjustment = p.parseULong();
    head.magicNumber = p.parseULong();
    check.argument(head.magicNumber === 0x5F0F3CF5, 'Font header has wrong magic number.');
    head.flags = p.parseUShort();
    head.unitsPerEm = p.parseUShort();
    head.created = p.parseLongDateTime();
    head.modified = p.parseLongDateTime();
    head.xMin = p.parseShort();
    head.yMin = p.parseShort();
    head.xMax = p.parseShort();
    head.yMax = p.parseShort();
    head.macStyle = p.parseUShort();
    head.lowestRecPPEM = p.parseUShort();
    head.fontDirectionHint = p.parseShort();
    head.indexToLocFormat = p.parseShort();
    head.glyphDataFormat = p.parseShort();
    return head;
}

function makeHeadTable(options) {
    // Apple Mac timestamp epoch is 01/01/1904 not 01/01/1970
    var timestamp = Math.round(new Date().getTime() / 1000) + 2082844800;
    var createdTimestamp = timestamp;

    if (options.createdTimestamp) {
        createdTimestamp = options.createdTimestamp + 2082844800;
    }

    return new table.Table('head', [
        {name: 'version', type: 'FIXED', value: 0x00010000},
        {name: 'fontRevision', type: 'FIXED', value: 0x00010000},
        {name: 'checkSumAdjustment', type: 'ULONG', value: 0},
        {name: 'magicNumber', type: 'ULONG', value: 0x5F0F3CF5},
        {name: 'flags', type: 'USHORT', value: 0},
        {name: 'unitsPerEm', type: 'USHORT', value: 1000},
        {name: 'created', type: 'LONGDATETIME', value: createdTimestamp},
        {name: 'modified', type: 'LONGDATETIME', value: timestamp},
        {name: 'xMin', type: 'SHORT', value: 0},
        {name: 'yMin', type: 'SHORT', value: 0},
        {name: 'xMax', type: 'SHORT', value: 0},
        {name: 'yMax', type: 'SHORT', value: 0},
        {name: 'macStyle', type: 'USHORT', value: 0},
        {name: 'lowestRecPPEM', type: 'USHORT', value: 0},
        {name: 'fontDirectionHint', type: 'SHORT', value: 2},
        {name: 'indexToLocFormat', type: 'SHORT', value: 0},
        {name: 'glyphDataFormat', type: 'SHORT', value: 0}
    ], options);
}

var head = { parse: parseHeadTable, make: makeHeadTable };

// The `hhea` table contains information for horizontal layout.
// https://www.microsoft.com/typography/OTSPEC/hhea.htm

// Parse the horizontal header `hhea` table
function parseHheaTable(data, start) {
    var hhea = {};
    var p = new parse.Parser(data, start);
    hhea.version = p.parseVersion();
    hhea.ascender = p.parseShort();
    hhea.descender = p.parseShort();
    hhea.lineGap = p.parseShort();
    hhea.advanceWidthMax = p.parseUShort();
    hhea.minLeftSideBearing = p.parseShort();
    hhea.minRightSideBearing = p.parseShort();
    hhea.xMaxExtent = p.parseShort();
    hhea.caretSlopeRise = p.parseShort();
    hhea.caretSlopeRun = p.parseShort();
    hhea.caretOffset = p.parseShort();
    p.relativeOffset += 8;
    hhea.metricDataFormat = p.parseShort();
    hhea.numberOfHMetrics = p.parseUShort();
    return hhea;
}

function makeHheaTable(options) {
    return new table.Table('hhea', [
        {name: 'version', type: 'FIXED', value: 0x00010000},
        {name: 'ascender', type: 'FWORD', value: 0},
        {name: 'descender', type: 'FWORD', value: 0},
        {name: 'lineGap', type: 'FWORD', value: 0},
        {name: 'advanceWidthMax', type: 'UFWORD', value: 0},
        {name: 'minLeftSideBearing', type: 'FWORD', value: 0},
        {name: 'minRightSideBearing', type: 'FWORD', value: 0},
        {name: 'xMaxExtent', type: 'FWORD', value: 0},
        {name: 'caretSlopeRise', type: 'SHORT', value: 1},
        {name: 'caretSlopeRun', type: 'SHORT', value: 0},
        {name: 'caretOffset', type: 'SHORT', value: 0},
        {name: 'reserved1', type: 'SHORT', value: 0},
        {name: 'reserved2', type: 'SHORT', value: 0},
        {name: 'reserved3', type: 'SHORT', value: 0},
        {name: 'reserved4', type: 'SHORT', value: 0},
        {name: 'metricDataFormat', type: 'SHORT', value: 0},
        {name: 'numberOfHMetrics', type: 'USHORT', value: 0}
    ], options);
}

var hhea = { parse: parseHheaTable, make: makeHheaTable };

// The `hmtx` table contains the horizontal metrics for all glyphs.
// https://www.microsoft.com/typography/OTSPEC/hmtx.htm

// Parse the `hmtx` table, which contains the horizontal metrics for all glyphs.
// This function augments the glyph array, adding the advanceWidth and leftSideBearing to each glyph.
function parseHmtxTable(data, start, numMetrics, numGlyphs, glyphs) {
    var advanceWidth;
    var leftSideBearing;
    var p = new parse.Parser(data, start);
    for (var i = 0; i < numGlyphs; i += 1) {
        // If the font is monospaced, only one entry is needed. This last entry applies to all subsequent glyphs.
        if (i < numMetrics) {
            advanceWidth = p.parseUShort();
            leftSideBearing = p.parseShort();
        }

        var glyph = glyphs.get(i);
        glyph.advanceWidth = advanceWidth;
        glyph.leftSideBearing = leftSideBearing;
    }
}

function makeHmtxTable(glyphs) {
    var t = new table.Table('hmtx', []);
    for (var i = 0; i < glyphs.length; i += 1) {
        var glyph = glyphs.get(i);
        var advanceWidth = glyph.advanceWidth || 0;
        var leftSideBearing = glyph.leftSideBearing || 0;
        t.fields.push({name: 'advanceWidth_' + i, type: 'USHORT', value: advanceWidth});
        t.fields.push({name: 'leftSideBearing_' + i, type: 'SHORT', value: leftSideBearing});
    }

    return t;
}

var hmtx = { parse: parseHmtxTable, make: makeHmtxTable };

// The `ltag` table stores IETF BCP-47 language tags. It allows supporting
// languages for which TrueType does not assign a numeric code.
// https://developer.apple.com/fonts/TrueType-Reference-Manual/RM06/Chap6ltag.html
// http://www.w3.org/International/articles/language-tags/
// http://www.iana.org/assignments/language-subtag-registry/language-subtag-registry

function makeLtagTable(tags) {
    var result = new table.Table('ltag', [
        {name: 'version', type: 'ULONG', value: 1},
        {name: 'flags', type: 'ULONG', value: 0},
        {name: 'numTags', type: 'ULONG', value: tags.length}
    ]);

    var stringPool = '';
    var stringPoolOffset = 12 + tags.length * 4;
    for (var i = 0; i < tags.length; ++i) {
        var pos = stringPool.indexOf(tags[i]);
        if (pos < 0) {
            pos = stringPool.length;
            stringPool += tags[i];
        }

        result.fields.push({name: 'offset ' + i, type: 'USHORT', value: stringPoolOffset + pos});
        result.fields.push({name: 'length ' + i, type: 'USHORT', value: tags[i].length});
    }

    result.fields.push({name: 'stringPool', type: 'CHARARRAY', value: stringPool});
    return result;
}

function parseLtagTable(data, start) {
    var p = new parse.Parser(data, start);
    var tableVersion = p.parseULong();
    check.argument(tableVersion === 1, 'Unsupported ltag table version.');
    // The 'ltag' specification does not define any flags; skip the field.
    p.skip('uLong', 1);
    var numTags = p.parseULong();

    var tags = [];
    for (var i = 0; i < numTags; i++) {
        var tag = '';
        var offset = start + p.parseUShort();
        var length = p.parseUShort();
        for (var j = offset; j < offset + length; ++j) {
            tag += String.fromCharCode(data.getInt8(j));
        }

        tags.push(tag);
    }

    return tags;
}

var ltag = { make: makeLtagTable, parse: parseLtagTable };

// The `maxp` table establishes the memory requirements for the font.
// We need it just to get the number of glyphs in the font.
// https://www.microsoft.com/typography/OTSPEC/maxp.htm

// Parse the maximum profile `maxp` table.
function parseMaxpTable(data, start) {
    var maxp = {};
    var p = new parse.Parser(data, start);
    maxp.version = p.parseVersion();
    maxp.numGlyphs = p.parseUShort();
    if (maxp.version === 1.0) {
        maxp.maxPoints = p.parseUShort();
        maxp.maxContours = p.parseUShort();
        maxp.maxCompositePoints = p.parseUShort();
        maxp.maxCompositeContours = p.parseUShort();
        maxp.maxZones = p.parseUShort();
        maxp.maxTwilightPoints = p.parseUShort();
        maxp.maxStorage = p.parseUShort();
        maxp.maxFunctionDefs = p.parseUShort();
        maxp.maxInstructionDefs = p.parseUShort();
        maxp.maxStackElements = p.parseUShort();
        maxp.maxSizeOfInstructions = p.parseUShort();
        maxp.maxComponentElements = p.parseUShort();
        maxp.maxComponentDepth = p.parseUShort();
    }

    return maxp;
}

function makeMaxpTable(numGlyphs) {
    return new table.Table('maxp', [
        {name: 'version', type: 'FIXED', value: 0x00005000},
        {name: 'numGlyphs', type: 'USHORT', value: numGlyphs}
    ]);
}

var maxp = { parse: parseMaxpTable, make: makeMaxpTable };

// The `name` naming table.
// https://www.microsoft.com/typography/OTSPEC/name.htm

// NameIDs for the name table.
var nameTableNames = [
    'copyright',              // 0
    'fontFamily',             // 1
    'fontSubfamily',          // 2
    'uniqueID',               // 3
    'fullName',               // 4
    'version',                // 5
    'postScriptName',         // 6
    'trademark',              // 7
    'manufacturer',           // 8
    'designer',               // 9
    'description',            // 10
    'manufacturerURL',        // 11
    'designerURL',            // 12
    'license',                // 13
    'licenseURL',             // 14
    'reserved',               // 15
    'preferredFamily',        // 16
    'preferredSubfamily',     // 17
    'compatibleFullName',     // 18
    'sampleText',             // 19
    'postScriptFindFontName', // 20
    'wwsFamily',              // 21
    'wwsSubfamily'            // 22
];

var macLanguages = {
    0: 'en',
    1: 'fr',
    2: 'de',
    3: 'it',
    4: 'nl',
    5: 'sv',
    6: 'es',
    7: 'da',
    8: 'pt',
    9: 'no',
    10: 'he',
    11: 'ja',
    12: 'ar',
    13: 'fi',
    14: 'el',
    15: 'is',
    16: 'mt',
    17: 'tr',
    18: 'hr',
    19: 'zh-Hant',
    20: 'ur',
    21: 'hi',
    22: 'th',
    23: 'ko',
    24: 'lt',
    25: 'pl',
    26: 'hu',
    27: 'es',
    28: 'lv',
    29: 'se',
    30: 'fo',
    31: 'fa',
    32: 'ru',
    33: 'zh',
    34: 'nl-BE',
    35: 'ga',
    36: 'sq',
    37: 'ro',
    38: 'cz',
    39: 'sk',
    40: 'si',
    41: 'yi',
    42: 'sr',
    43: 'mk',
    44: 'bg',
    45: 'uk',
    46: 'be',
    47: 'uz',
    48: 'kk',
    49: 'az-Cyrl',
    50: 'az-Arab',
    51: 'hy',
    52: 'ka',
    53: 'mo',
    54: 'ky',
    55: 'tg',
    56: 'tk',
    57: 'mn-CN',
    58: 'mn',
    59: 'ps',
    60: 'ks',
    61: 'ku',
    62: 'sd',
    63: 'bo',
    64: 'ne',
    65: 'sa',
    66: 'mr',
    67: 'bn',
    68: 'as',
    69: 'gu',
    70: 'pa',
    71: 'or',
    72: 'ml',
    73: 'kn',
    74: 'ta',
    75: 'te',
    76: 'si',
    77: 'my',
    78: 'km',
    79: 'lo',
    80: 'vi',
    81: 'id',
    82: 'tl',
    83: 'ms',
    84: 'ms-Arab',
    85: 'am',
    86: 'ti',
    87: 'om',
    88: 'so',
    89: 'sw',
    90: 'rw',
    91: 'rn',
    92: 'ny',
    93: 'mg',
    94: 'eo',
    128: 'cy',
    129: 'eu',
    130: 'ca',
    131: 'la',
    132: 'qu',
    133: 'gn',
    134: 'ay',
    135: 'tt',
    136: 'ug',
    137: 'dz',
    138: 'jv',
    139: 'su',
    140: 'gl',
    141: 'af',
    142: 'br',
    143: 'iu',
    144: 'gd',
    145: 'gv',
    146: 'ga',
    147: 'to',
    148: 'el-polyton',
    149: 'kl',
    150: 'az',
    151: 'nn'
};

// MacOS language ID → MacOS script ID
//
// Note that the script ID is not sufficient to determine what encoding
// to use in TrueType files. For some languages, MacOS used a modification
// of a mainstream script. For example, an Icelandic name would be stored
// with smRoman in the TrueType naming table, but the actual encoding
// is a special Icelandic version of the normal Macintosh Roman encoding.
// As another example, Inuktitut uses an 8-bit encoding for Canadian Aboriginal
// Syllables but MacOS had run out of available script codes, so this was
// done as a (pretty radical) "modification" of Ethiopic.
//
// http://unicode.org/Public/MAPPINGS/VENDORS/APPLE/Readme.txt
var macLanguageToScript = {
    0: 0,  // langEnglish → smRoman
    1: 0,  // langFrench → smRoman
    2: 0,  // langGerman → smRoman
    3: 0,  // langItalian → smRoman
    4: 0,  // langDutch → smRoman
    5: 0,  // langSwedish → smRoman
    6: 0,  // langSpanish → smRoman
    7: 0,  // langDanish → smRoman
    8: 0,  // langPortuguese → smRoman
    9: 0,  // langNorwegian → smRoman
    10: 5,  // langHebrew → smHebrew
    11: 1,  // langJapanese → smJapanese
    12: 4,  // langArabic → smArabic
    13: 0,  // langFinnish → smRoman
    14: 6,  // langGreek → smGreek
    15: 0,  // langIcelandic → smRoman (modified)
    16: 0,  // langMaltese → smRoman
    17: 0,  // langTurkish → smRoman (modified)
    18: 0,  // langCroatian → smRoman (modified)
    19: 2,  // langTradChinese → smTradChinese
    20: 4,  // langUrdu → smArabic
    21: 9,  // langHindi → smDevanagari
    22: 21,  // langThai → smThai
    23: 3,  // langKorean → smKorean
    24: 29,  // langLithuanian → smCentralEuroRoman
    25: 29,  // langPolish → smCentralEuroRoman
    26: 29,  // langHungarian → smCentralEuroRoman
    27: 29,  // langEstonian → smCentralEuroRoman
    28: 29,  // langLatvian → smCentralEuroRoman
    29: 0,  // langSami → smRoman
    30: 0,  // langFaroese → smRoman (modified)
    31: 4,  // langFarsi → smArabic (modified)
    32: 7,  // langRussian → smCyrillic
    33: 25,  // langSimpChinese → smSimpChinese
    34: 0,  // langFlemish → smRoman
    35: 0,  // langIrishGaelic → smRoman (modified)
    36: 0,  // langAlbanian → smRoman
    37: 0,  // langRomanian → smRoman (modified)
    38: 29,  // langCzech → smCentralEuroRoman
    39: 29,  // langSlovak → smCentralEuroRoman
    40: 0,  // langSlovenian → smRoman (modified)
    41: 5,  // langYiddish → smHebrew
    42: 7,  // langSerbian → smCyrillic
    43: 7,  // langMacedonian → smCyrillic
    44: 7,  // langBulgarian → smCyrillic
    45: 7,  // langUkrainian → smCyrillic (modified)
    46: 7,  // langByelorussian → smCyrillic
    47: 7,  // langUzbek → smCyrillic
    48: 7,  // langKazakh → smCyrillic
    49: 7,  // langAzerbaijani → smCyrillic
    50: 4,  // langAzerbaijanAr → smArabic
    51: 24,  // langArmenian → smArmenian
    52: 23,  // langGeorgian → smGeorgian
    53: 7,  // langMoldavian → smCyrillic
    54: 7,  // langKirghiz → smCyrillic
    55: 7,  // langTajiki → smCyrillic
    56: 7,  // langTurkmen → smCyrillic
    57: 27,  // langMongolian → smMongolian
    58: 7,  // langMongolianCyr → smCyrillic
    59: 4,  // langPashto → smArabic
    60: 4,  // langKurdish → smArabic
    61: 4,  // langKashmiri → smArabic
    62: 4,  // langSindhi → smArabic
    63: 26,  // langTibetan → smTibetan
    64: 9,  // langNepali → smDevanagari
    65: 9,  // langSanskrit → smDevanagari
    66: 9,  // langMarathi → smDevanagari
    67: 13,  // langBengali → smBengali
    68: 13,  // langAssamese → smBengali
    69: 11,  // langGujarati → smGujarati
    70: 10,  // langPunjabi → smGurmukhi
    71: 12,  // langOriya → smOriya
    72: 17,  // langMalayalam → smMalayalam
    73: 16,  // langKannada → smKannada
    74: 14,  // langTamil → smTamil
    75: 15,  // langTelugu → smTelugu
    76: 18,  // langSinhalese → smSinhalese
    77: 19,  // langBurmese → smBurmese
    78: 20,  // langKhmer → smKhmer
    79: 22,  // langLao → smLao
    80: 30,  // langVietnamese → smVietnamese
    81: 0,  // langIndonesian → smRoman
    82: 0,  // langTagalog → smRoman
    83: 0,  // langMalayRoman → smRoman
    84: 4,  // langMalayArabic → smArabic
    85: 28,  // langAmharic → smEthiopic
    86: 28,  // langTigrinya → smEthiopic
    87: 28,  // langOromo → smEthiopic
    88: 0,  // langSomali → smRoman
    89: 0,  // langSwahili → smRoman
    90: 0,  // langKinyarwanda → smRoman
    91: 0,  // langRundi → smRoman
    92: 0,  // langNyanja → smRoman
    93: 0,  // langMalagasy → smRoman
    94: 0,  // langEsperanto → smRoman
    128: 0,  // langWelsh → smRoman (modified)
    129: 0,  // langBasque → smRoman
    130: 0,  // langCatalan → smRoman
    131: 0,  // langLatin → smRoman
    132: 0,  // langQuechua → smRoman
    133: 0,  // langGuarani → smRoman
    134: 0,  // langAymara → smRoman
    135: 7,  // langTatar → smCyrillic
    136: 4,  // langUighur → smArabic
    137: 26,  // langDzongkha → smTibetan
    138: 0,  // langJavaneseRom → smRoman
    139: 0,  // langSundaneseRom → smRoman
    140: 0,  // langGalician → smRoman
    141: 0,  // langAfrikaans → smRoman
    142: 0,  // langBreton → smRoman (modified)
    143: 28,  // langInuktitut → smEthiopic (modified)
    144: 0,  // langScottishGaelic → smRoman (modified)
    145: 0,  // langManxGaelic → smRoman (modified)
    146: 0,  // langIrishGaelicScript → smRoman (modified)
    147: 0,  // langTongan → smRoman
    148: 6,  // langGreekAncient → smRoman
    149: 0,  // langGreenlandic → smRoman
    150: 0,  // langAzerbaijanRoman → smRoman
    151: 0   // langNynorsk → smRoman
};

// While Microsoft indicates a region/country for all its language
// IDs, we omit the region code if it's equal to the "most likely
// region subtag" according to Unicode CLDR. For scripts, we omit
// the subtag if it is equal to the Suppress-Script entry in the
// IANA language subtag registry for IETF BCP 47.
//
// For example, Microsoft states that its language code 0x041A is
// Croatian in Croatia. We transform this to the BCP 47 language code 'hr'
// and not 'hr-HR' because Croatia is the default country for Croatian,
// according to Unicode CLDR. As another example, Microsoft states
// that 0x101A is Croatian (Latin) in Bosnia-Herzegovina. We transform
// this to 'hr-BA' and not 'hr-Latn-BA' because Latin is the default script
// for the Croatian language, according to IANA.
//
// http://www.unicode.org/cldr/charts/latest/supplemental/likely_subtags.html
// http://www.iana.org/assignments/language-subtag-registry/language-subtag-registry
var windowsLanguages = {
    0x0436: 'af',
    0x041C: 'sq',
    0x0484: 'gsw',
    0x045E: 'am',
    0x1401: 'ar-DZ',
    0x3C01: 'ar-BH',
    0x0C01: 'ar',
    0x0801: 'ar-IQ',
    0x2C01: 'ar-JO',
    0x3401: 'ar-KW',
    0x3001: 'ar-LB',
    0x1001: 'ar-LY',
    0x1801: 'ary',
    0x2001: 'ar-OM',
    0x4001: 'ar-QA',
    0x0401: 'ar-SA',
    0x2801: 'ar-SY',
    0x1C01: 'aeb',
    0x3801: 'ar-AE',
    0x2401: 'ar-YE',
    0x042B: 'hy',
    0x044D: 'as',
    0x082C: 'az-Cyrl',
    0x042C: 'az',
    0x046D: 'ba',
    0x042D: 'eu',
    0x0423: 'be',
    0x0845: 'bn',
    0x0445: 'bn-IN',
    0x201A: 'bs-Cyrl',
    0x141A: 'bs',
    0x047E: 'br',
    0x0402: 'bg',
    0x0403: 'ca',
    0x0C04: 'zh-HK',
    0x1404: 'zh-MO',
    0x0804: 'zh',
    0x1004: 'zh-SG',
    0x0404: 'zh-TW',
    0x0483: 'co',
    0x041A: 'hr',
    0x101A: 'hr-BA',
    0x0405: 'cs',
    0x0406: 'da',
    0x048C: 'prs',
    0x0465: 'dv',
    0x0813: 'nl-BE',
    0x0413: 'nl',
    0x0C09: 'en-AU',
    0x2809: 'en-BZ',
    0x1009: 'en-CA',
    0x2409: 'en-029',
    0x4009: 'en-IN',
    0x1809: 'en-IE',
    0x2009: 'en-JM',
    0x4409: 'en-MY',
    0x1409: 'en-NZ',
    0x3409: 'en-PH',
    0x4809: 'en-SG',
    0x1C09: 'en-ZA',
    0x2C09: 'en-TT',
    0x0809: 'en-GB',
    0x0409: 'en',
    0x3009: 'en-ZW',
    0x0425: 'et',
    0x0438: 'fo',
    0x0464: 'fil',
    0x040B: 'fi',
    0x080C: 'fr-BE',
    0x0C0C: 'fr-CA',
    0x040C: 'fr',
    0x140C: 'fr-LU',
    0x180C: 'fr-MC',
    0x100C: 'fr-CH',
    0x0462: 'fy',
    0x0456: 'gl',
    0x0437: 'ka',
    0x0C07: 'de-AT',
    0x0407: 'de',
    0x1407: 'de-LI',
    0x1007: 'de-LU',
    0x0807: 'de-CH',
    0x0408: 'el',
    0x046F: 'kl',
    0x0447: 'gu',
    0x0468: 'ha',
    0x040D: 'he',
    0x0439: 'hi',
    0x040E: 'hu',
    0x040F: 'is',
    0x0470: 'ig',
    0x0421: 'id',
    0x045D: 'iu',
    0x085D: 'iu-Latn',
    0x083C: 'ga',
    0x0434: 'xh',
    0x0435: 'zu',
    0x0410: 'it',
    0x0810: 'it-CH',
    0x0411: 'ja',
    0x044B: 'kn',
    0x043F: 'kk',
    0x0453: 'km',
    0x0486: 'quc',
    0x0487: 'rw',
    0x0441: 'sw',
    0x0457: 'kok',
    0x0412: 'ko',
    0x0440: 'ky',
    0x0454: 'lo',
    0x0426: 'lv',
    0x0427: 'lt',
    0x082E: 'dsb',
    0x046E: 'lb',
    0x042F: 'mk',
    0x083E: 'ms-BN',
    0x043E: 'ms',
    0x044C: 'ml',
    0x043A: 'mt',
    0x0481: 'mi',
    0x047A: 'arn',
    0x044E: 'mr',
    0x047C: 'moh',
    0x0450: 'mn',
    0x0850: 'mn-CN',
    0x0461: 'ne',
    0x0414: 'nb',
    0x0814: 'nn',
    0x0482: 'oc',
    0x0448: 'or',
    0x0463: 'ps',
    0x0415: 'pl',
    0x0416: 'pt',
    0x0816: 'pt-PT',
    0x0446: 'pa',
    0x046B: 'qu-BO',
    0x086B: 'qu-EC',
    0x0C6B: 'qu',
    0x0418: 'ro',
    0x0417: 'rm',
    0x0419: 'ru',
    0x243B: 'smn',
    0x103B: 'smj-NO',
    0x143B: 'smj',
    0x0C3B: 'se-FI',
    0x043B: 'se',
    0x083B: 'se-SE',
    0x203B: 'sms',
    0x183B: 'sma-NO',
    0x1C3B: 'sms',
    0x044F: 'sa',
    0x1C1A: 'sr-Cyrl-BA',
    0x0C1A: 'sr',
    0x181A: 'sr-Latn-BA',
    0x081A: 'sr-Latn',
    0x046C: 'nso',
    0x0432: 'tn',
    0x045B: 'si',
    0x041B: 'sk',
    0x0424: 'sl',
    0x2C0A: 'es-AR',
    0x400A: 'es-BO',
    0x340A: 'es-CL',
    0x240A: 'es-CO',
    0x140A: 'es-CR',
    0x1C0A: 'es-DO',
    0x300A: 'es-EC',
    0x440A: 'es-SV',
    0x100A: 'es-GT',
    0x480A: 'es-HN',
    0x080A: 'es-MX',
    0x4C0A: 'es-NI',
    0x180A: 'es-PA',
    0x3C0A: 'es-PY',
    0x280A: 'es-PE',
    0x500A: 'es-PR',

    // Microsoft has defined two different language codes for
    // “Spanish with modern sorting” and “Spanish with traditional
    // sorting”. This makes sense for collation APIs, and it would be
    // possible to express this in BCP 47 language tags via Unicode
    // extensions (eg., es-u-co-trad is Spanish with traditional
    // sorting). However, for storing names in fonts, the distinction
    // does not make sense, so we give “es” in both cases.
    0x0C0A: 'es',
    0x040A: 'es',

    0x540A: 'es-US',
    0x380A: 'es-UY',
    0x200A: 'es-VE',
    0x081D: 'sv-FI',
    0x041D: 'sv',
    0x045A: 'syr',
    0x0428: 'tg',
    0x085F: 'tzm',
    0x0449: 'ta',
    0x0444: 'tt',
    0x044A: 'te',
    0x041E: 'th',
    0x0451: 'bo',
    0x041F: 'tr',
    0x0442: 'tk',
    0x0480: 'ug',
    0x0422: 'uk',
    0x042E: 'hsb',
    0x0420: 'ur',
    0x0843: 'uz-Cyrl',
    0x0443: 'uz',
    0x042A: 'vi',
    0x0452: 'cy',
    0x0488: 'wo',
    0x0485: 'sah',
    0x0478: 'ii',
    0x046A: 'yo'
};

// Returns a IETF BCP 47 language code, for example 'zh-Hant'
// for 'Chinese in the traditional script'.
function getLanguageCode(platformID, languageID, ltag) {
    switch (platformID) {
        case 0:  // Unicode
            if (languageID === 0xFFFF) {
                return 'und';
            } else if (ltag) {
                return ltag[languageID];
            }

            break;

        case 1:  // Macintosh
            return macLanguages[languageID];

        case 3:  // Windows
            return windowsLanguages[languageID];
    }

    return undefined;
}

var utf16 = 'utf-16';

// MacOS script ID → encoding. This table stores the default case,
// which can be overridden by macLanguageEncodings.
var macScriptEncodings = {
    0: 'macintosh',           // smRoman
    1: 'x-mac-japanese',      // smJapanese
    2: 'x-mac-chinesetrad',   // smTradChinese
    3: 'x-mac-korean',        // smKorean
    6: 'x-mac-greek',         // smGreek
    7: 'x-mac-cyrillic',      // smCyrillic
    9: 'x-mac-devanagai',     // smDevanagari
    10: 'x-mac-gurmukhi',     // smGurmukhi
    11: 'x-mac-gujarati',     // smGujarati
    12: 'x-mac-oriya',        // smOriya
    13: 'x-mac-bengali',      // smBengali
    14: 'x-mac-tamil',        // smTamil
    15: 'x-mac-telugu',       // smTelugu
    16: 'x-mac-kannada',      // smKannada
    17: 'x-mac-malayalam',    // smMalayalam
    18: 'x-mac-sinhalese',    // smSinhalese
    19: 'x-mac-burmese',      // smBurmese
    20: 'x-mac-khmer',        // smKhmer
    21: 'x-mac-thai',         // smThai
    22: 'x-mac-lao',          // smLao
    23: 'x-mac-georgian',     // smGeorgian
    24: 'x-mac-armenian',     // smArmenian
    25: 'x-mac-chinesesimp',  // smSimpChinese
    26: 'x-mac-tibetan',      // smTibetan
    27: 'x-mac-mongolian',    // smMongolian
    28: 'x-mac-ethiopic',     // smEthiopic
    29: 'x-mac-ce',           // smCentralEuroRoman
    30: 'x-mac-vietnamese',   // smVietnamese
    31: 'x-mac-extarabic'     // smExtArabic
};

// MacOS language ID → encoding. This table stores the exceptional
// cases, which override macScriptEncodings. For writing MacOS naming
// tables, we need to emit a MacOS script ID. Therefore, we cannot
// merge macScriptEncodings into macLanguageEncodings.
//
// http://unicode.org/Public/MAPPINGS/VENDORS/APPLE/Readme.txt
var macLanguageEncodings = {
    15: 'x-mac-icelandic',    // langIcelandic
    17: 'x-mac-turkish',      // langTurkish
    18: 'x-mac-croatian',     // langCroatian
    24: 'x-mac-ce',           // langLithuanian
    25: 'x-mac-ce',           // langPolish
    26: 'x-mac-ce',           // langHungarian
    27: 'x-mac-ce',           // langEstonian
    28: 'x-mac-ce',           // langLatvian
    30: 'x-mac-icelandic',    // langFaroese
    37: 'x-mac-romanian',     // langRomanian
    38: 'x-mac-ce',           // langCzech
    39: 'x-mac-ce',           // langSlovak
    40: 'x-mac-ce',           // langSlovenian
    143: 'x-mac-inuit',       // langInuktitut
    146: 'x-mac-gaelic'       // langIrishGaelicScript
};

function getEncoding(platformID, encodingID, languageID) {
    switch (platformID) {
        case 0:  // Unicode
            return utf16;

        case 1:  // Apple Macintosh
            return macLanguageEncodings[languageID] || macScriptEncodings[encodingID];

        case 3:  // Microsoft Windows
            if (encodingID === 1 || encodingID === 10) {
                return utf16;
            }

            break;
    }

    return undefined;
}

// Parse the naming `name` table.
// FIXME: Format 1 additional fields are not supported yet.
// ltag is the content of the `ltag' table, such as ['en', 'zh-Hans', 'de-CH-1904'].
function parseNameTable(data, start, ltag) {
    var name = {};
    var p = new parse.Parser(data, start);
    var format = p.parseUShort();
    var count = p.parseUShort();
    var stringOffset = p.offset + p.parseUShort();
    for (var i = 0; i < count; i++) {
        var platformID = p.parseUShort();
        var encodingID = p.parseUShort();
        var languageID = p.parseUShort();
        var nameID = p.parseUShort();
        var property = nameTableNames[nameID] || nameID;
        var byteLength = p.parseUShort();
        var offset = p.parseUShort();
        var language = getLanguageCode(platformID, languageID, ltag);
        var encoding = getEncoding(platformID, encodingID, languageID);
        if (encoding !== undefined && language !== undefined) {
            var text = (void 0);
            if (encoding === utf16) {
                text = decode.UTF16(data, stringOffset + offset, byteLength);
            } else {
                text = decode.MACSTRING(data, stringOffset + offset, byteLength, encoding);
            }

            if (text) {
                var translations = name[property];
                if (translations === undefined) {
                    translations = name[property] = {};
                }

                translations[language] = text;
            }
        }
    }

    var langTagCount = 0;
    if (format === 1) {
        // FIXME: Also handle Microsoft's 'name' table 1.
        langTagCount = p.parseUShort();
    }

    return name;
}

// {23: 'foo'} → {'foo': 23}
// ['bar', 'baz'] → {'bar': 0, 'baz': 1}
function reverseDict(dict) {
    var result = {};
    for (var key in dict) {
        result[dict[key]] = parseInt(key);
    }

    return result;
}

function makeNameRecord(platformID, encodingID, languageID, nameID, length, offset) {
    return new table.Record('NameRecord', [
        {name: 'platformID', type: 'USHORT', value: platformID},
        {name: 'encodingID', type: 'USHORT', value: encodingID},
        {name: 'languageID', type: 'USHORT', value: languageID},
        {name: 'nameID', type: 'USHORT', value: nameID},
        {name: 'length', type: 'USHORT', value: length},
        {name: 'offset', type: 'USHORT', value: offset}
    ]);
}

// Finds the position of needle in haystack, or -1 if not there.
// Like String.indexOf(), but for arrays.
function findSubArray(needle, haystack) {
    var needleLength = needle.length;
    var limit = haystack.length - needleLength + 1;

    loop:
    for (var pos = 0; pos < limit; pos++) {
        for (; pos < limit; pos++) {
            for (var k = 0; k < needleLength; k++) {
                if (haystack[pos + k] !== needle[k]) {
                    continue loop;
                }
            }

            return pos;
        }
    }

    return -1;
}

function addStringToPool(s, pool) {
    var offset = findSubArray(s, pool);
    if (offset < 0) {
        offset = pool.length;
        var i = 0;
        var len = s.length;
        for (; i < len; ++i) {
            pool.push(s[i]);
        }

    }

    return offset;
}

function makeNameTable(names, ltag) {
    var nameID;
    var nameIDs = [];

    var namesWithNumericKeys = {};
    var nameTableIds = reverseDict(nameTableNames);
    for (var key in names) {
        var id = nameTableIds[key];
        if (id === undefined) {
            id = key;
        }

        nameID = parseInt(id);

        if (isNaN(nameID)) {
            throw new Error('Name table entry "' + key + '" does not exist, see nameTableNames for complete list.');
        }

        namesWithNumericKeys[nameID] = names[key];
        nameIDs.push(nameID);
    }

    var macLanguageIds = reverseDict(macLanguages);
    var windowsLanguageIds = reverseDict(windowsLanguages);

    var nameRecords = [];
    var stringPool = [];

    for (var i = 0; i < nameIDs.length; i++) {
        nameID = nameIDs[i];
        var translations = namesWithNumericKeys[nameID];
        for (var lang in translations) {
            var text = translations[lang];

            // For MacOS, we try to emit the name in the form that was introduced
            // in the initial version of the TrueType spec (in the late 1980s).
            // However, this can fail for various reasons: the requested BCP 47
            // language code might not have an old-style Mac equivalent;
            // we might not have a codec for the needed character encoding;
            // or the name might contain characters that cannot be expressed
            // in the old-style Macintosh encoding. In case of failure, we emit
            // the name in a more modern fashion (Unicode encoding with BCP 47
            // language tags) that is recognized by MacOS 10.5, released in 2009.
            // If fonts were only read by operating systems, we could simply
            // emit all names in the modern form; this would be much easier.
            // However, there are many applications and libraries that read
            // 'name' tables directly, and these will usually only recognize
            // the ancient form (silently skipping the unrecognized names).
            var macPlatform = 1;  // Macintosh
            var macLanguage = macLanguageIds[lang];
            var macScript = macLanguageToScript[macLanguage];
            var macEncoding = getEncoding(macPlatform, macScript, macLanguage);
            var macName = encode.MACSTRING(text, macEncoding);
            if (macName === undefined) {
                macPlatform = 0;  // Unicode
                macLanguage = ltag.indexOf(lang);
                if (macLanguage < 0) {
                    macLanguage = ltag.length;
                    ltag.push(lang);
                }

                macScript = 4;  // Unicode 2.0 and later
                macName = encode.UTF16(text);
            }

            var macNameOffset = addStringToPool(macName, stringPool);
            nameRecords.push(makeNameRecord(macPlatform, macScript, macLanguage,
                                            nameID, macName.length, macNameOffset));

            var winLanguage = windowsLanguageIds[lang];
            if (winLanguage !== undefined) {
                var winName = encode.UTF16(text);
                var winNameOffset = addStringToPool(winName, stringPool);
                nameRecords.push(makeNameRecord(3, 1, winLanguage,
                                                nameID, winName.length, winNameOffset));
            }
        }
    }

    nameRecords.sort(function(a, b) {
        return ((a.platformID - b.platformID) ||
                (a.encodingID - b.encodingID) ||
                (a.languageID - b.languageID) ||
                (a.nameID - b.nameID));
    });

    var t = new table.Table('name', [
        {name: 'format', type: 'USHORT', value: 0},
        {name: 'count', type: 'USHORT', value: nameRecords.length},
        {name: 'stringOffset', type: 'USHORT', value: 6 + nameRecords.length * 12}
    ]);

    for (var r = 0; r < nameRecords.length; r++) {
        t.fields.push({name: 'record_' + r, type: 'RECORD', value: nameRecords[r]});
    }

    t.fields.push({name: 'strings', type: 'LITERAL', value: stringPool});
    return t;
}

var _name = { parse: parseNameTable, make: makeNameTable };

// The `OS/2` table contains metrics required in OpenType fonts.
// https://www.microsoft.com/typography/OTSPEC/os2.htm

var unicodeRanges = [
    {begin: 0x0000, end: 0x007F}, // Basic Latin
    {begin: 0x0080, end: 0x00FF}, // Latin-1 Supplement
    {begin: 0x0100, end: 0x017F}, // Latin Extended-A
    {begin: 0x0180, end: 0x024F}, // Latin Extended-B
    {begin: 0x0250, end: 0x02AF}, // IPA Extensions
    {begin: 0x02B0, end: 0x02FF}, // Spacing Modifier Letters
    {begin: 0x0300, end: 0x036F}, // Combining Diacritical Marks
    {begin: 0x0370, end: 0x03FF}, // Greek and Coptic
    {begin: 0x2C80, end: 0x2CFF}, // Coptic
    {begin: 0x0400, end: 0x04FF}, // Cyrillic
    {begin: 0x0530, end: 0x058F}, // Armenian
    {begin: 0x0590, end: 0x05FF}, // Hebrew
    {begin: 0xA500, end: 0xA63F}, // Vai
    {begin: 0x0600, end: 0x06FF}, // Arabic
    {begin: 0x07C0, end: 0x07FF}, // NKo
    {begin: 0x0900, end: 0x097F}, // Devanagari
    {begin: 0x0980, end: 0x09FF}, // Bengali
    {begin: 0x0A00, end: 0x0A7F}, // Gurmukhi
    {begin: 0x0A80, end: 0x0AFF}, // Gujarati
    {begin: 0x0B00, end: 0x0B7F}, // Oriya
    {begin: 0x0B80, end: 0x0BFF}, // Tamil
    {begin: 0x0C00, end: 0x0C7F}, // Telugu
    {begin: 0x0C80, end: 0x0CFF}, // Kannada
    {begin: 0x0D00, end: 0x0D7F}, // Malayalam
    {begin: 0x0E00, end: 0x0E7F}, // Thai
    {begin: 0x0E80, end: 0x0EFF}, // Lao
    {begin: 0x10A0, end: 0x10FF}, // Georgian
    {begin: 0x1B00, end: 0x1B7F}, // Balinese
    {begin: 0x1100, end: 0x11FF}, // Hangul Jamo
    {begin: 0x1E00, end: 0x1EFF}, // Latin Extended Additional
    {begin: 0x1F00, end: 0x1FFF}, // Greek Extended
    {begin: 0x2000, end: 0x206F}, // General Punctuation
    {begin: 0x2070, end: 0x209F}, // Superscripts And Subscripts
    {begin: 0x20A0, end: 0x20CF}, // Currency Symbol
    {begin: 0x20D0, end: 0x20FF}, // Combining Diacritical Marks For Symbols
    {begin: 0x2100, end: 0x214F}, // Letterlike Symbols
    {begin: 0x2150, end: 0x218F}, // Number Forms
    {begin: 0x2190, end: 0x21FF}, // Arrows
    {begin: 0x2200, end: 0x22FF}, // Mathematical Operators
    {begin: 0x2300, end: 0x23FF}, // Miscellaneous Technical
    {begin: 0x2400, end: 0x243F}, // Control Pictures
    {begin: 0x2440, end: 0x245F}, // Optical Character Recognition
    {begin: 0x2460, end: 0x24FF}, // Enclosed Alphanumerics
    {begin: 0x2500, end: 0x257F}, // Box Drawing
    {begin: 0x2580, end: 0x259F}, // Block Elements
    {begin: 0x25A0, end: 0x25FF}, // Geometric Shapes
    {begin: 0x2600, end: 0x26FF}, // Miscellaneous Symbols
    {begin: 0x2700, end: 0x27BF}, // Dingbats
    {begin: 0x3000, end: 0x303F}, // CJK Symbols And Punctuation
    {begin: 0x3040, end: 0x309F}, // Hiragana
    {begin: 0x30A0, end: 0x30FF}, // Katakana
    {begin: 0x3100, end: 0x312F}, // Bopomofo
    {begin: 0x3130, end: 0x318F}, // Hangul Compatibility Jamo
    {begin: 0xA840, end: 0xA87F}, // Phags-pa
    {begin: 0x3200, end: 0x32FF}, // Enclosed CJK Letters And Months
    {begin: 0x3300, end: 0x33FF}, // CJK Compatibility
    {begin: 0xAC00, end: 0xD7AF}, // Hangul Syllables
    {begin: 0xD800, end: 0xDFFF}, // Non-Plane 0 *
    {begin: 0x10900, end: 0x1091F}, // Phoenicia
    {begin: 0x4E00, end: 0x9FFF}, // CJK Unified Ideographs
    {begin: 0xE000, end: 0xF8FF}, // Private Use Area (plane 0)
    {begin: 0x31C0, end: 0x31EF}, // CJK Strokes
    {begin: 0xFB00, end: 0xFB4F}, // Alphabetic Presentation Forms
    {begin: 0xFB50, end: 0xFDFF}, // Arabic Presentation Forms-A
    {begin: 0xFE20, end: 0xFE2F}, // Combining Half Marks
    {begin: 0xFE10, end: 0xFE1F}, // Vertical Forms
    {begin: 0xFE50, end: 0xFE6F}, // Small Form Variants
    {begin: 0xFE70, end: 0xFEFF}, // Arabic Presentation Forms-B
    {begin: 0xFF00, end: 0xFFEF}, // Halfwidth And Fullwidth Forms
    {begin: 0xFFF0, end: 0xFFFF}, // Specials
    {begin: 0x0F00, end: 0x0FFF}, // Tibetan
    {begin: 0x0700, end: 0x074F}, // Syriac
    {begin: 0x0780, end: 0x07BF}, // Thaana
    {begin: 0x0D80, end: 0x0DFF}, // Sinhala
    {begin: 0x1000, end: 0x109F}, // Myanmar
    {begin: 0x1200, end: 0x137F}, // Ethiopic
    {begin: 0x13A0, end: 0x13FF}, // Cherokee
    {begin: 0x1400, end: 0x167F}, // Unified Canadian Aboriginal Syllabics
    {begin: 0x1680, end: 0x169F}, // Ogham
    {begin: 0x16A0, end: 0x16FF}, // Runic
    {begin: 0x1780, end: 0x17FF}, // Khmer
    {begin: 0x1800, end: 0x18AF}, // Mongolian
    {begin: 0x2800, end: 0x28FF}, // Braille Patterns
    {begin: 0xA000, end: 0xA48F}, // Yi Syllables
    {begin: 0x1700, end: 0x171F}, // Tagalog
    {begin: 0x10300, end: 0x1032F}, // Old Italic
    {begin: 0x10330, end: 0x1034F}, // Gothic
    {begin: 0x10400, end: 0x1044F}, // Deseret
    {begin: 0x1D000, end: 0x1D0FF}, // Byzantine Musical Symbols
    {begin: 0x1D400, end: 0x1D7FF}, // Mathematical Alphanumeric Symbols
    {begin: 0xFF000, end: 0xFFFFD}, // Private Use (plane 15)
    {begin: 0xFE00, end: 0xFE0F}, // Variation Selectors
    {begin: 0xE0000, end: 0xE007F}, // Tags
    {begin: 0x1900, end: 0x194F}, // Limbu
    {begin: 0x1950, end: 0x197F}, // Tai Le
    {begin: 0x1980, end: 0x19DF}, // New Tai Lue
    {begin: 0x1A00, end: 0x1A1F}, // Buginese
    {begin: 0x2C00, end: 0x2C5F}, // Glagolitic
    {begin: 0x2D30, end: 0x2D7F}, // Tifinagh
    {begin: 0x4DC0, end: 0x4DFF}, // Yijing Hexagram Symbols
    {begin: 0xA800, end: 0xA82F}, // Syloti Nagri
    {begin: 0x10000, end: 0x1007F}, // Linear B Syllabary
    {begin: 0x10140, end: 0x1018F}, // Ancient Greek Numbers
    {begin: 0x10380, end: 0x1039F}, // Ugaritic
    {begin: 0x103A0, end: 0x103DF}, // Old Persian
    {begin: 0x10450, end: 0x1047F}, // Shavian
    {begin: 0x10480, end: 0x104AF}, // Osmanya
    {begin: 0x10800, end: 0x1083F}, // Cypriot Syllabary
    {begin: 0x10A00, end: 0x10A5F}, // Kharoshthi
    {begin: 0x1D300, end: 0x1D35F}, // Tai Xuan Jing Symbols
    {begin: 0x12000, end: 0x123FF}, // Cuneiform
    {begin: 0x1D360, end: 0x1D37F}, // Counting Rod Numerals
    {begin: 0x1B80, end: 0x1BBF}, // Sundanese
    {begin: 0x1C00, end: 0x1C4F}, // Lepcha
    {begin: 0x1C50, end: 0x1C7F}, // Ol Chiki
    {begin: 0xA880, end: 0xA8DF}, // Saurashtra
    {begin: 0xA900, end: 0xA92F}, // Kayah Li
    {begin: 0xA930, end: 0xA95F}, // Rejang
    {begin: 0xAA00, end: 0xAA5F}, // Cham
    {begin: 0x10190, end: 0x101CF}, // Ancient Symbols
    {begin: 0x101D0, end: 0x101FF}, // Phaistos Disc
    {begin: 0x102A0, end: 0x102DF}, // Carian
    {begin: 0x1F030, end: 0x1F09F}  // Domino Tiles
];

function getUnicodeRange(unicode) {
    for (var i = 0; i < unicodeRanges.length; i += 1) {
        var range = unicodeRanges[i];
        if (unicode >= range.begin && unicode < range.end) {
            return i;
        }
    }

    return -1;
}

// Parse the OS/2 and Windows metrics `OS/2` table
function parseOS2Table(data, start) {
    var os2 = {};
    var p = new parse.Parser(data, start);
    os2.version = p.parseUShort();
    os2.xAvgCharWidth = p.parseShort();
    os2.usWeightClass = p.parseUShort();
    os2.usWidthClass = p.parseUShort();
    os2.fsType = p.parseUShort();
    os2.ySubscriptXSize = p.parseShort();
    os2.ySubscriptYSize = p.parseShort();
    os2.ySubscriptXOffset = p.parseShort();
    os2.ySubscriptYOffset = p.parseShort();
    os2.ySuperscriptXSize = p.parseShort();
    os2.ySuperscriptYSize = p.parseShort();
    os2.ySuperscriptXOffset = p.parseShort();
    os2.ySuperscriptYOffset = p.parseShort();
    os2.yStrikeoutSize = p.parseShort();
    os2.yStrikeoutPosition = p.parseShort();
    os2.sFamilyClass = p.parseShort();
    os2.panose = [];
    for (var i = 0; i < 10; i++) {
        os2.panose[i] = p.parseByte();
    }

    os2.ulUnicodeRange1 = p.parseULong();
    os2.ulUnicodeRange2 = p.parseULong();
    os2.ulUnicodeRange3 = p.parseULong();
    os2.ulUnicodeRange4 = p.parseULong();
    os2.achVendID = String.fromCharCode(p.parseByte(), p.parseByte(), p.parseByte(), p.parseByte());
    os2.fsSelection = p.parseUShort();
    os2.usFirstCharIndex = p.parseUShort();
    os2.usLastCharIndex = p.parseUShort();
    os2.sTypoAscender = p.parseShort();
    os2.sTypoDescender = p.parseShort();
    os2.sTypoLineGap = p.parseShort();
    os2.usWinAscent = p.parseUShort();
    os2.usWinDescent = p.parseUShort();
    if (os2.version >= 1) {
        os2.ulCodePageRange1 = p.parseULong();
        os2.ulCodePageRange2 = p.parseULong();
    }

    if (os2.version >= 2) {
        os2.sxHeight = p.parseShort();
        os2.sCapHeight = p.parseShort();
        os2.usDefaultChar = p.parseUShort();
        os2.usBreakChar = p.parseUShort();
        os2.usMaxContent = p.parseUShort();
    }

    return os2;
}

function makeOS2Table(options) {
    return new table.Table('OS/2', [
        {name: 'version', type: 'USHORT', value: 0x0003},
        {name: 'xAvgCharWidth', type: 'SHORT', value: 0},
        {name: 'usWeightClass', type: 'USHORT', value: 0},
        {name: 'usWidthClass', type: 'USHORT', value: 0},
        {name: 'fsType', type: 'USHORT', value: 0},
        {name: 'ySubscriptXSize', type: 'SHORT', value: 650},
        {name: 'ySubscriptYSize', type: 'SHORT', value: 699},
        {name: 'ySubscriptXOffset', type: 'SHORT', value: 0},
        {name: 'ySubscriptYOffset', type: 'SHORT', value: 140},
        {name: 'ySuperscriptXSize', type: 'SHORT', value: 650},
        {name: 'ySuperscriptYSize', type: 'SHORT', value: 699},
        {name: 'ySuperscriptXOffset', type: 'SHORT', value: 0},
        {name: 'ySuperscriptYOffset', type: 'SHORT', value: 479},
        {name: 'yStrikeoutSize', type: 'SHORT', value: 49},
        {name: 'yStrikeoutPosition', type: 'SHORT', value: 258},
        {name: 'sFamilyClass', type: 'SHORT', value: 0},
        {name: 'bFamilyType', type: 'BYTE', value: 0},
        {name: 'bSerifStyle', type: 'BYTE', value: 0},
        {name: 'bWeight', type: 'BYTE', value: 0},
        {name: 'bProportion', type: 'BYTE', value: 0},
        {name: 'bContrast', type: 'BYTE', value: 0},
        {name: 'bStrokeVariation', type: 'BYTE', value: 0},
        {name: 'bArmStyle', type: 'BYTE', value: 0},
        {name: 'bLetterform', type: 'BYTE', value: 0},
        {name: 'bMidline', type: 'BYTE', value: 0},
        {name: 'bXHeight', type: 'BYTE', value: 0},
        {name: 'ulUnicodeRange1', type: 'ULONG', value: 0},
        {name: 'ulUnicodeRange2', type: 'ULONG', value: 0},
        {name: 'ulUnicodeRange3', type: 'ULONG', value: 0},
        {name: 'ulUnicodeRange4', type: 'ULONG', value: 0},
        {name: 'achVendID', type: 'CHARARRAY', value: 'XXXX'},
        {name: 'fsSelection', type: 'USHORT', value: 0},
        {name: 'usFirstCharIndex', type: 'USHORT', value: 0},
        {name: 'usLastCharIndex', type: 'USHORT', value: 0},
        {name: 'sTypoAscender', type: 'SHORT', value: 0},
        {name: 'sTypoDescender', type: 'SHORT', value: 0},
        {name: 'sTypoLineGap', type: 'SHORT', value: 0},
        {name: 'usWinAscent', type: 'USHORT', value: 0},
        {name: 'usWinDescent', type: 'USHORT', value: 0},
        {name: 'ulCodePageRange1', type: 'ULONG', value: 0},
        {name: 'ulCodePageRange2', type: 'ULONG', value: 0},
        {name: 'sxHeight', type: 'SHORT', value: 0},
        {name: 'sCapHeight', type: 'SHORT', value: 0},
        {name: 'usDefaultChar', type: 'USHORT', value: 0},
        {name: 'usBreakChar', type: 'USHORT', value: 0},
        {name: 'usMaxContext', type: 'USHORT', value: 0}
    ], options);
}

var os2 = { parse: parseOS2Table, make: makeOS2Table, unicodeRanges: unicodeRanges, getUnicodeRange: getUnicodeRange };

// The `post` table stores additional PostScript information, such as glyph names.
// https://www.microsoft.com/typography/OTSPEC/post.htm

// Parse the PostScript `post` table
function parsePostTable(data, start) {
    var post = {};
    var p = new parse.Parser(data, start);
    post.version = p.parseVersion();
    post.italicAngle = p.parseFixed();
    post.underlinePosition = p.parseShort();
    post.underlineThickness = p.parseShort();
    post.isFixedPitch = p.parseULong();
    post.minMemType42 = p.parseULong();
    post.maxMemType42 = p.parseULong();
    post.minMemType1 = p.parseULong();
    post.maxMemType1 = p.parseULong();
    switch (post.version) {
        case 1:
            post.names = standardNames.slice();
            break;
        case 2:
            post.numberOfGlyphs = p.parseUShort();
            post.glyphNameIndex = new Array(post.numberOfGlyphs);
            for (var i = 0; i < post.numberOfGlyphs; i++) {
                post.glyphNameIndex[i] = p.parseUShort();
            }

            post.names = [];
            for (var i$1 = 0; i$1 < post.numberOfGlyphs; i$1++) {
                if (post.glyphNameIndex[i$1] >= standardNames.length) {
                    var nameLength = p.parseChar();
                    post.names.push(p.parseString(nameLength));
                }
            }

            break;
        case 2.5:
            post.numberOfGlyphs = p.parseUShort();
            post.offset = new Array(post.numberOfGlyphs);
            for (var i$2 = 0; i$2 < post.numberOfGlyphs; i$2++) {
                post.offset[i$2] = p.parseChar();
            }

            break;
    }
    return post;
}

function makePostTable() {
    return new table.Table('post', [
        {name: 'version', type: 'FIXED', value: 0x00030000},
        {name: 'italicAngle', type: 'FIXED', value: 0},
        {name: 'underlinePosition', type: 'FWORD', value: 0},
        {name: 'underlineThickness', type: 'FWORD', value: 0},
        {name: 'isFixedPitch', type: 'ULONG', value: 0},
        {name: 'minMemType42', type: 'ULONG', value: 0},
        {name: 'maxMemType42', type: 'ULONG', value: 0},
        {name: 'minMemType1', type: 'ULONG', value: 0},
        {name: 'maxMemType1', type: 'ULONG', value: 0}
    ]);
}

var post = { parse: parsePostTable, make: makePostTable };

// The `GSUB` table contains ligatures, among other things.
// https://www.microsoft.com/typography/OTSPEC/gsub.htm

var subtableParsers = new Array(9);         // subtableParsers[0] is unused

// https://www.microsoft.com/typography/OTSPEC/GSUB.htm#SS
subtableParsers[1] = function parseLookup1() {
    var start = this.offset + this.relativeOffset;
    var substFormat = this.parseUShort();
    if (substFormat === 1) {
        return {
            substFormat: 1,
            coverage: this.parsePointer(Parser.coverage),
            deltaGlyphId: this.parseUShort()
        };
    } else if (substFormat === 2) {
        return {
            substFormat: 2,
            coverage: this.parsePointer(Parser.coverage),
            substitute: this.parseOffset16List()
        };
    }
    check.assert(false, '0x' + start.toString(16) + ': lookup type 1 format must be 1 or 2.');
};

// https://www.microsoft.com/typography/OTSPEC/GSUB.htm#MS
subtableParsers[2] = function parseLookup2() {
    var substFormat = this.parseUShort();
    check.argument(substFormat === 1, 'GSUB Multiple Substitution Subtable identifier-format must be 1');
    return {
        substFormat: substFormat,
        coverage: this.parsePointer(Parser.coverage),
        sequences: this.parseListOfLists()
    };
};

// https://www.microsoft.com/typography/OTSPEC/GSUB.htm#AS
subtableParsers[3] = function parseLookup3() {
    var substFormat = this.parseUShort();
    check.argument(substFormat === 1, 'GSUB Alternate Substitution Subtable identifier-format must be 1');
    return {
        substFormat: substFormat,
        coverage: this.parsePointer(Parser.coverage),
        alternateSets: this.parseListOfLists()
    };
};

// https://www.microsoft.com/typography/OTSPEC/GSUB.htm#LS
subtableParsers[4] = function parseLookup4() {
    var substFormat = this.parseUShort();
    check.argument(substFormat === 1, 'GSUB ligature table identifier-format must be 1');
    return {
        substFormat: substFormat,
        coverage: this.parsePointer(Parser.coverage),
        ligatureSets: this.parseListOfLists(function() {
            return {
                ligGlyph: this.parseUShort(),
                components: this.parseUShortList(this.parseUShort() - 1)
            };
        })
    };
};

var lookupRecordDesc = {
    sequenceIndex: Parser.uShort,
    lookupListIndex: Parser.uShort
};

// https://www.microsoft.com/typography/OTSPEC/GSUB.htm#CSF
subtableParsers[5] = function parseLookup5() {
    var start = this.offset + this.relativeOffset;
    var substFormat = this.parseUShort();

    if (substFormat === 1) {
        return {
            substFormat: substFormat,
            coverage: this.parsePointer(Parser.coverage),
            ruleSets: this.parseListOfLists(function() {
                var glyphCount = this.parseUShort();
                var substCount = this.parseUShort();
                return {
                    input: this.parseUShortList(glyphCount - 1),
                    lookupRecords: this.parseRecordList(substCount, lookupRecordDesc)
                };
            })
        };
    } else if (substFormat === 2) {
        return {
            substFormat: substFormat,
            coverage: this.parsePointer(Parser.coverage),
            classDef: this.parsePointer(Parser.classDef),
            classSets: this.parseListOfLists(function() {
                var glyphCount = this.parseUShort();
                var substCount = this.parseUShort();
                return {
                    classes: this.parseUShortList(glyphCount - 1),
                    lookupRecords: this.parseRecordList(substCount, lookupRecordDesc)
                };
            })
        };
    } else if (substFormat === 3) {
        var glyphCount = this.parseUShort();
        var substCount = this.parseUShort();
        return {
            substFormat: substFormat,
            coverages: this.parseList(glyphCount, Parser.pointer(Parser.coverage)),
            lookupRecords: this.parseRecordList(substCount, lookupRecordDesc)
        };
    }
    check.assert(false, '0x' + start.toString(16) + ': lookup type 5 format must be 1, 2 or 3.');
};

// https://www.microsoft.com/typography/OTSPEC/GSUB.htm#CC
subtableParsers[6] = function parseLookup6() {
    var start = this.offset + this.relativeOffset;
    var substFormat = this.parseUShort();
    if (substFormat === 1) {
        return {
            substFormat: 1,
            coverage: this.parsePointer(Parser.coverage),
            chainRuleSets: this.parseListOfLists(function() {
                return {
                    backtrack: this.parseUShortList(),
                    input: this.parseUShortList(this.parseShort() - 1),
                    lookahead: this.parseUShortList(),
                    lookupRecords: this.parseRecordList(lookupRecordDesc)
                };
            })
        };
    } else if (substFormat === 2) {
        return {
            substFormat: 2,
            coverage: this.parsePointer(Parser.coverage),
            backtrackClassDef: this.parsePointer(Parser.classDef),
            inputClassDef: this.parsePointer(Parser.classDef),
            lookaheadClassDef: this.parsePointer(Parser.classDef),
            chainClassSet: this.parseListOfLists(function() {
                return {
                    backtrack: this.parseUShortList(),
                    input: this.parseUShortList(this.parseShort() - 1),
                    lookahead: this.parseUShortList(),
                    lookupRecords: this.parseRecordList(lookupRecordDesc)
                };
            })
        };
    } else if (substFormat === 3) {
        return {
            substFormat: 3,
            backtrackCoverage: this.parseList(Parser.pointer(Parser.coverage)),
            inputCoverage: this.parseList(Parser.pointer(Parser.coverage)),
            lookaheadCoverage: this.parseList(Parser.pointer(Parser.coverage)),
            lookupRecords: this.parseRecordList(lookupRecordDesc)
        };
    }
    check.assert(false, '0x' + start.toString(16) + ': lookup type 6 format must be 1, 2 or 3.');
};

// https://www.microsoft.com/typography/OTSPEC/GSUB.htm#ES
subtableParsers[7] = function parseLookup7() {
    // Extension Substitution subtable
    var substFormat = this.parseUShort();
    check.argument(substFormat === 1, 'GSUB Extension Substitution subtable identifier-format must be 1');
    var extensionLookupType = this.parseUShort();
    var extensionParser = new Parser(this.data, this.offset + this.parseULong());
    return {
        substFormat: 1,
        lookupType: extensionLookupType,
        extension: subtableParsers[extensionLookupType].call(extensionParser)
    };
};

// https://www.microsoft.com/typography/OTSPEC/GSUB.htm#RCCS
subtableParsers[8] = function parseLookup8() {
    var substFormat = this.parseUShort();
    check.argument(substFormat === 1, 'GSUB Reverse Chaining Contextual Single Substitution Subtable identifier-format must be 1');
    return {
        substFormat: substFormat,
        coverage: this.parsePointer(Parser.coverage),
        backtrackCoverage: this.parseList(Parser.pointer(Parser.coverage)),
        lookaheadCoverage: this.parseList(Parser.pointer(Parser.coverage)),
        substitutes: this.parseUShortList()
    };
};

// https://www.microsoft.com/typography/OTSPEC/gsub.htm
function parseGsubTable(data, start) {
    start = start || 0;
    var p = new Parser(data, start);
    var tableVersion = p.parseVersion();
    check.argument(tableVersion === 1, 'Unsupported GSUB table version.');
    return {
        version: tableVersion,
        scripts: p.parseScriptList(),
        features: p.parseFeatureList(),
        lookups: p.parseLookupList(subtableParsers)
    };
}

// GSUB Writing //////////////////////////////////////////////
var subtableMakers = new Array(9);

subtableMakers[1] = function makeLookup1(subtable) {
    if (subtable.substFormat === 1) {
        return new table.Table('substitutionTable', [
            {name: 'substFormat', type: 'USHORT', value: 1},
            {name: 'coverage', type: 'TABLE', value: new table.Coverage(subtable.coverage)},
            {name: 'deltaGlyphID', type: 'USHORT', value: subtable.deltaGlyphId}
        ]);
    } else {
        return new table.Table('substitutionTable', [
            {name: 'substFormat', type: 'USHORT', value: 2},
            {name: 'coverage', type: 'TABLE', value: new table.Coverage(subtable.coverage)}
        ].concat(table.ushortList('substitute', subtable.substitute)));
    }
    check.fail('Lookup type 1 substFormat must be 1 or 2.');
};

subtableMakers[3] = function makeLookup3(subtable) {
    check.assert(subtable.substFormat === 1, 'Lookup type 3 substFormat must be 1.');
    return new table.Table('substitutionTable', [
        {name: 'substFormat', type: 'USHORT', value: 1},
        {name: 'coverage', type: 'TABLE', value: new table.Coverage(subtable.coverage)}
    ].concat(table.tableList('altSet', subtable.alternateSets, function(alternateSet) {
        return new table.Table('alternateSetTable', table.ushortList('alternate', alternateSet));
    })));
};

subtableMakers[4] = function makeLookup4(subtable) {
    check.assert(subtable.substFormat === 1, 'Lookup type 4 substFormat must be 1.');
    return new table.Table('substitutionTable', [
        {name: 'substFormat', type: 'USHORT', value: 1},
        {name: 'coverage', type: 'TABLE', value: new table.Coverage(subtable.coverage)}
    ].concat(table.tableList('ligSet', subtable.ligatureSets, function(ligatureSet) {
        return new table.Table('ligatureSetTable', table.tableList('ligature', ligatureSet, function(ligature) {
            return new table.Table('ligatureTable',
                [{name: 'ligGlyph', type: 'USHORT', value: ligature.ligGlyph}]
                .concat(table.ushortList('component', ligature.components, ligature.components.length + 1))
            );
        }));
    })));
};

function makeGsubTable(gsub) {
    return new table.Table('GSUB', [
        {name: 'version', type: 'ULONG', value: 0x10000},
        {name: 'scripts', type: 'TABLE', value: new table.ScriptList(gsub.scripts)},
        {name: 'features', type: 'TABLE', value: new table.FeatureList(gsub.features)},
        {name: 'lookups', type: 'TABLE', value: new table.LookupList(gsub.lookups, subtableMakers)}
    ]);
}

var gsub = { parse: parseGsubTable, make: makeGsubTable };

// The `GPOS` table contains kerning pairs, among other things.
// https://www.microsoft.com/typography/OTSPEC/gpos.htm

// Parse the metadata `meta` table.
// https://developer.apple.com/fonts/TrueType-Reference-Manual/RM06/Chap6meta.html
function parseMetaTable(data, start) {
    var p = new parse.Parser(data, start);
    var tableVersion = p.parseULong();
    check.argument(tableVersion === 1, 'Unsupported META table version.');
    p.parseULong(); // flags - currently unused and set to 0
    p.parseULong(); // tableOffset
    var numDataMaps = p.parseULong();

    var tags = {};
    for (var i = 0; i < numDataMaps; i++) {
        var tag = p.parseTag();
        var dataOffset = p.parseULong();
        var dataLength = p.parseULong();
        var text = decode.UTF8(data, start + dataOffset, dataLength);

        tags[tag] = text;
    }
    return tags;
}

function makeMetaTable(tags) {
    var numTags = Object.keys(tags).length;
    var stringPool = '';
    var stringPoolOffset = 16 + numTags * 12;

    var result = new table.Table('meta', [
        {name: 'version', type: 'ULONG', value: 1},
        {name: 'flags', type: 'ULONG', value: 0},
        {name: 'offset', type: 'ULONG', value: stringPoolOffset},
        {name: 'numTags', type: 'ULONG', value: numTags}
    ]);

    for (var tag in tags) {
        var pos = stringPool.length;
        stringPool += tags[tag];

        result.fields.push({name: 'tag ' + tag, type: 'TAG', value: tag});
        result.fields.push({name: 'offset ' + tag, type: 'ULONG', value: stringPoolOffset + pos});
        result.fields.push({name: 'length ' + tag, type: 'ULONG', value: tags[tag].length});
    }

    result.fields.push({name: 'stringPool', type: 'CHARARRAY', value: stringPool});

    return result;
}

var meta = { parse: parseMetaTable, make: makeMetaTable };

// The `sfnt` wrapper provides organization for the tables in the font.
// It is the top-level data structure in a font.
// https://www.microsoft.com/typography/OTSPEC/otff.htm
// Recommendations for creating OpenType Fonts:
// http://www.microsoft.com/typography/otspec140/recom.htm

function log2(v) {
    return Math.log(v) / Math.log(2) | 0;
}

function computeCheckSum(bytes) {
    while (bytes.length % 4 !== 0) {
        bytes.push(0);
    }

    var sum = 0;
    for (var i = 0; i < bytes.length; i += 4) {
        sum += (bytes[i] << 24) +
            (bytes[i + 1] << 16) +
            (bytes[i + 2] << 8) +
            (bytes[i + 3]);
    }

    sum %= Math.pow(2, 32);
    return sum;
}

function makeTableRecord(tag, checkSum, offset, length) {
    return new table.Record('Table Record', [
        {name: 'tag', type: 'TAG', value: tag !== undefined ? tag : ''},
        {name: 'checkSum', type: 'ULONG', value: checkSum !== undefined ? checkSum : 0},
        {name: 'offset', type: 'ULONG', value: offset !== undefined ? offset : 0},
        {name: 'length', type: 'ULONG', value: length !== undefined ? length : 0}
    ]);
}

function makeSfntTable(tables) {
    var sfnt = new table.Table('sfnt', [
        {name: 'version', type: 'TAG', value: 'OTTO'},
        {name: 'numTables', type: 'USHORT', value: 0},
        {name: 'searchRange', type: 'USHORT', value: 0},
        {name: 'entrySelector', type: 'USHORT', value: 0},
        {name: 'rangeShift', type: 'USHORT', value: 0}
    ]);
    sfnt.tables = tables;
    sfnt.numTables = tables.length;
    var highestPowerOf2 = Math.pow(2, log2(sfnt.numTables));
    sfnt.searchRange = 16 * highestPowerOf2;
    sfnt.entrySelector = log2(highestPowerOf2);
    sfnt.rangeShift = sfnt.numTables * 16 - sfnt.searchRange;

    var recordFields = [];
    var tableFields = [];

    var offset = sfnt.sizeOf() + (makeTableRecord().sizeOf() * sfnt.numTables);
    while (offset % 4 !== 0) {
        offset += 1;
        tableFields.push({name: 'padding', type: 'BYTE', value: 0});
    }

    for (var i = 0; i < tables.length; i += 1) {
        var t = tables[i];
        check.argument(t.tableName.length === 4, 'Table name' + t.tableName + ' is invalid.');
        var tableLength = t.sizeOf();
        var tableRecord = makeTableRecord(t.tableName, computeCheckSum(t.encode()), offset, tableLength);
        recordFields.push({name: tableRecord.tag + ' Table Record', type: 'RECORD', value: tableRecord});
        tableFields.push({name: t.tableName + ' table', type: 'RECORD', value: t});
        offset += tableLength;
        check.argument(!isNaN(offset), 'Something went wrong calculating the offset.');
        while (offset % 4 !== 0) {
            offset += 1;
            tableFields.push({name: 'padding', type: 'BYTE', value: 0});
        }
    }

    // Table records need to be sorted alphabetically.
    recordFields.sort(function(r1, r2) {
        if (r1.value.tag > r2.value.tag) {
            return 1;
        } else {
            return -1;
        }
    });

    sfnt.fields = sfnt.fields.concat(recordFields);
    sfnt.fields = sfnt.fields.concat(tableFields);
    return sfnt;
}

// Get the metrics for a character. If the string has more than one character
// this function returns metrics for the first available character.
// You can provide optional fallback metrics if no characters are available.
function metricsForChar(font, chars, notFoundMetrics) {
    for (var i = 0; i < chars.length; i += 1) {
        var glyphIndex = font.charToGlyphIndex(chars[i]);
        if (glyphIndex > 0) {
            var glyph = font.glyphs.get(glyphIndex);
            return glyph.getMetrics();
        }
    }

    return notFoundMetrics;
}

function average(vs) {
    var sum = 0;
    for (var i = 0; i < vs.length; i += 1) {
        sum += vs[i];
    }

    return sum / vs.length;
}

// Convert the font object to a SFNT data structure.
// This structure contains all the necessary tables and metadata to create a binary OTF file.
function fontToSfntTable(font) {
    var xMins = [];
    var yMins = [];
    var xMaxs = [];
    var yMaxs = [];
    var advanceWidths = [];
    var leftSideBearings = [];
    var rightSideBearings = [];
    var firstCharIndex;
    var lastCharIndex = 0;
    var ulUnicodeRange1 = 0;
    var ulUnicodeRange2 = 0;
    var ulUnicodeRange3 = 0;
    var ulUnicodeRange4 = 0;

    for (var i = 0; i < font.glyphs.length; i += 1) {
        var glyph = font.glyphs.get(i);
        var unicode = glyph.unicode | 0;

        if (isNaN(glyph.advanceWidth)) {
            throw new Error('Glyph ' + glyph.name + ' (' + i + '): advanceWidth is not a number.');
        }

        if (firstCharIndex > unicode || firstCharIndex === undefined) {
            // ignore .notdef char
            if (unicode > 0) {
                firstCharIndex = unicode;
            }
        }

        if (lastCharIndex < unicode) {
            lastCharIndex = unicode;
        }

        var position = os2.getUnicodeRange(unicode);
        if (position < 32) {
            ulUnicodeRange1 |= 1 << position;
        } else if (position < 64) {
            ulUnicodeRange2 |= 1 << position - 32;
        } else if (position < 96) {
            ulUnicodeRange3 |= 1 << position - 64;
        } else if (position < 123) {
            ulUnicodeRange4 |= 1 << position - 96;
        } else {
            throw new Error('Unicode ranges bits > 123 are reserved for internal usage');
        }
        // Skip non-important characters.
        if (glyph.name === '.notdef') { continue; }
        var metrics = glyph.getMetrics();
        xMins.push(metrics.xMin);
        yMins.push(metrics.yMin);
        xMaxs.push(metrics.xMax);
        yMaxs.push(metrics.yMax);
        leftSideBearings.push(metrics.leftSideBearing);
        rightSideBearings.push(metrics.rightSideBearing);
        advanceWidths.push(glyph.advanceWidth);
    }

    var globals = {
        xMin: Math.min.apply(null, xMins),
        yMin: Math.min.apply(null, yMins),
        xMax: Math.max.apply(null, xMaxs),
        yMax: Math.max.apply(null, yMaxs),
        advanceWidthMax: Math.max.apply(null, advanceWidths),
        advanceWidthAvg: average(advanceWidths),
        minLeftSideBearing: Math.min.apply(null, leftSideBearings),
        maxLeftSideBearing: Math.max.apply(null, leftSideBearings),
        minRightSideBearing: Math.min.apply(null, rightSideBearings)
    };
    globals.ascender = font.ascender;
    globals.descender = font.descender;

    var headTable = head.make({
        flags: 3, // 00000011 (baseline for font at y=0; left sidebearing point at x=0)
        unitsPerEm: font.unitsPerEm,
        xMin: globals.xMin,
        yMin: globals.yMin,
        xMax: globals.xMax,
        yMax: globals.yMax,
        lowestRecPPEM: 3,
        createdTimestamp: font.createdTimestamp
    });

    var hheaTable = hhea.make({
        ascender: globals.ascender,
        descender: globals.descender,
        advanceWidthMax: globals.advanceWidthMax,
        minLeftSideBearing: globals.minLeftSideBearing,
        minRightSideBearing: globals.minRightSideBearing,
        xMaxExtent: globals.maxLeftSideBearing + (globals.xMax - globals.xMin),
        numberOfHMetrics: font.glyphs.length
    });

    var maxpTable = maxp.make(font.glyphs.length);

    var os2Table = os2.make({
        xAvgCharWidth: Math.round(globals.advanceWidthAvg),
        usWeightClass: font.tables.os2.usWeightClass,
        usWidthClass: font.tables.os2.usWidthClass,
        usFirstCharIndex: firstCharIndex,
        usLastCharIndex: lastCharIndex,
        ulUnicodeRange1: ulUnicodeRange1,
        ulUnicodeRange2: ulUnicodeRange2,
        ulUnicodeRange3: ulUnicodeRange3,
        ulUnicodeRange4: ulUnicodeRange4,
        fsSelection: font.tables.os2.fsSelection, // REGULAR
        // See http://typophile.com/node/13081 for more info on vertical metrics.
        // We get metrics for typical characters (such as "x" for xHeight).
        // We provide some fallback characters if characters are unavailable: their
        // ordering was chosen experimentally.
        sTypoAscender: globals.ascender,
        sTypoDescender: globals.descender,
        sTypoLineGap: 0,
        usWinAscent: globals.yMax,
        usWinDescent: Math.abs(globals.yMin),
        ulCodePageRange1: 1, // FIXME: hard-code Latin 1 support for now
        sxHeight: metricsForChar(font, 'xyvw', {yMax: Math.round(globals.ascender / 2)}).yMax,
        sCapHeight: metricsForChar(font, 'HIKLEFJMNTZBDPRAGOQSUVWXY', globals).yMax,
        usDefaultChar: font.hasChar(' ') ? 32 : 0, // Use space as the default character, if available.
        usBreakChar: font.hasChar(' ') ? 32 : 0 // Use space as the break character, if available.
    });

    var hmtxTable = hmtx.make(font.glyphs);
    var cmapTable = cmap.make(font.glyphs);

    var englishFamilyName = font.getEnglishName('fontFamily');
    var englishStyleName = font.getEnglishName('fontSubfamily');
    var englishFullName = englishFamilyName + ' ' + englishStyleName;
    var postScriptName = font.getEnglishName('postScriptName');
    if (!postScriptName) {
        postScriptName = englishFamilyName.replace(/\s/g, '') + '-' + englishStyleName;
    }

    var names = {};
    for (var n in font.names) {
        names[n] = font.names[n];
    }

    if (!names.uniqueID) {
        names.uniqueID = {en: font.getEnglishName('manufacturer') + ':' + englishFullName};
    }

    if (!names.postScriptName) {
        names.postScriptName = {en: postScriptName};
    }

    if (!names.preferredFamily) {
        names.preferredFamily = font.names.fontFamily;
    }

    if (!names.preferredSubfamily) {
        names.preferredSubfamily = font.names.fontSubfamily;
    }

    var languageTags = [];
    var nameTable = _name.make(names, languageTags);
    var ltagTable = (languageTags.length > 0 ? ltag.make(languageTags) : undefined);

    var postTable = post.make();
    var cffTable = cff.make(font.glyphs, {
        version: font.getEnglishName('version'),
        fullName: englishFullName,
        familyName: englishFamilyName,
        weightName: englishStyleName,
        postScriptName: postScriptName,
        unitsPerEm: font.unitsPerEm,
        fontBBox: [0, globals.yMin, globals.ascender, globals.advanceWidthMax]
    });

    var metaTable = (font.metas && Object.keys(font.metas).length > 0) ? meta.make(font.metas) : undefined;

    // The order does not matter because makeSfntTable() will sort them.
    var tables = [headTable, hheaTable, maxpTable, os2Table, nameTable, cmapTable, postTable, cffTable, hmtxTable];
    if (ltagTable) {
        tables.push(ltagTable);
    }
    // Optional tables
    if (font.tables.gsub) {
        tables.push(gsub.make(font.tables.gsub));
    }
    if (metaTable) {
        tables.push(metaTable);
    }

    var sfntTable = makeSfntTable(tables);

    // Compute the font's checkSum and store it in head.checkSumAdjustment.
    var bytes = sfntTable.encode();
    var checkSum = computeCheckSum(bytes);
    var tableFields = sfntTable.fields;
    var checkSumAdjusted = false;
    for (var i$1 = 0; i$1 < tableFields.length; i$1 += 1) {
        if (tableFields[i$1].name === 'head table') {
            tableFields[i$1].value.checkSumAdjustment = 0xB1B0AFBA - checkSum;
            checkSumAdjusted = true;
            break;
        }
    }

    if (!checkSumAdjusted) {
        throw new Error('Could not find head table with checkSum to adjust.');
    }

    return sfntTable;
}

var sfnt = { make: makeSfntTable, fontToTable: fontToSfntTable, computeCheckSum: computeCheckSum };

// The Layout object is the prototype of Substitution objects, and provides
// utility methods to manipulate common layout tables (GPOS, GSUB, GDEF...)

function searchTag(arr, tag) {
    /* jshint bitwise: false */
    var imin = 0;
    var imax = arr.length - 1;
    while (imin <= imax) {
        var imid = (imin + imax) >>> 1;
        var val = arr[imid].tag;
        if (val === tag) {
            return imid;
        } else if (val < tag) {
            imin = imid + 1;
        } else { imax = imid - 1; }
    }
    // Not found: return -1-insertion point
    return -imin - 1;
}

function binSearch(arr, value) {
    /* jshint bitwise: false */
    var imin = 0;
    var imax = arr.length - 1;
    while (imin <= imax) {
        var imid = (imin + imax) >>> 1;
        var val = arr[imid];
        if (val === value) {
            return imid;
        } else if (val < value) {
            imin = imid + 1;
        } else { imax = imid - 1; }
    }
    // Not found: return -1-insertion point
    return -imin - 1;
}

/**
 * @exports opentype.Layout
 * @class
 */
function Layout(font, tableName) {
    this.font = font;
    this.tableName = tableName;
}

Layout.prototype = {

    /**
     * Binary search an object by "tag" property
     * @instance
     * @function searchTag
     * @memberof opentype.Layout
     * @param  {Array} arr
     * @param  {string} tag
     * @return {number}
     */
    searchTag: searchTag,

    /**
     * Binary search in a list of numbers
     * @instance
     * @function binSearch
     * @memberof opentype.Layout
     * @param  {Array} arr
     * @param  {number} value
     * @return {number}
     */
    binSearch: binSearch,

    /**
     * Get or create the Layout table (GSUB, GPOS etc).
     * @param  {boolean} create - Whether to create a new one.
     * @return {Object} The GSUB or GPOS table.
     */
    getTable: function(create) {
        var layout = this.font.tables[this.tableName];
        if (!layout && create) {
            layout = this.font.tables[this.tableName] = this.createDefaultTable();
        }
        return layout;
    },

    /**
     * Returns all scripts in the substitution table.
     * @instance
     * @return {Array}
     */
    getScriptNames: function() {
        var layout = this.getTable();
        if (!layout) { return []; }
        return layout.scripts.map(function(script) {
            return script.tag;
        });
    },

    /**
     * Returns the best bet for a script name.
     * Returns 'DFLT' if it exists.
     * If not, returns 'latn' if it exists.
     * If neither exist, returns undefined.
     */
    getDefaultScriptName: function() {
        var layout = this.getTable();
        if (!layout) { return; }
        var hasLatn = false;
        for (var i = 0; i < layout.scripts.length; i++) {
            var name = layout.scripts[i].tag;
            if (name === 'DFLT') { return name; }
            if (name === 'latn') { hasLatn = true; }
        }
        if (hasLatn) { return 'latn'; }
    },

    /**
     * Returns all LangSysRecords in the given script.
     * @instance
     * @param {string} [script='DFLT']
     * @param {boolean} create - forces the creation of this script table if it doesn't exist.
     * @return {Object} An object with tag and script properties.
     */
    getScriptTable: function(script, create) {
        var layout = this.getTable(create);
        if (layout) {
            script = script || 'DFLT';
            var scripts = layout.scripts;
            var pos = searchTag(layout.scripts, script);
            if (pos >= 0) {
                return scripts[pos].script;
            } else if (create) {
                var scr = {
                    tag: script,
                    script: {
                        defaultLangSys: {reserved: 0, reqFeatureIndex: 0xffff, featureIndexes: []},
                        langSysRecords: []
                    }
                };
                scripts.splice(-1 - pos, 0, scr);
                return scr.script;
            }
        }
    },

    /**
     * Returns a language system table
     * @instance
     * @param {string} [script='DFLT']
     * @param {string} [language='dlft']
     * @param {boolean} create - forces the creation of this langSysTable if it doesn't exist.
     * @return {Object}
     */
    getLangSysTable: function(script, language, create) {
        var scriptTable = this.getScriptTable(script, create);
        if (scriptTable) {
            if (!language || language === 'dflt' || language === 'DFLT') {
                return scriptTable.defaultLangSys;
            }
            var pos = searchTag(scriptTable.langSysRecords, language);
            if (pos >= 0) {
                return scriptTable.langSysRecords[pos].langSys;
            } else if (create) {
                var langSysRecord = {
                    tag: language,
                    langSys: {reserved: 0, reqFeatureIndex: 0xffff, featureIndexes: []}
                };
                scriptTable.langSysRecords.splice(-1 - pos, 0, langSysRecord);
                return langSysRecord.langSys;
            }
        }
    },

    /**
     * Get a specific feature table.
     * @instance
     * @param {string} [script='DFLT']
     * @param {string} [language='dlft']
     * @param {string} feature - One of the codes listed at https://www.microsoft.com/typography/OTSPEC/featurelist.htm
     * @param {boolean} create - forces the creation of the feature table if it doesn't exist.
     * @return {Object}
     */
    getFeatureTable: function(script, language, feature, create) {
        var langSysTable = this.getLangSysTable(script, language, create);
        if (langSysTable) {
            var featureRecord;
            var featIndexes = langSysTable.featureIndexes;
            var allFeatures = this.font.tables[this.tableName].features;
            // The FeatureIndex array of indices is in arbitrary order,
            // even if allFeatures is sorted alphabetically by feature tag.
            for (var i = 0; i < featIndexes.length; i++) {
                featureRecord = allFeatures[featIndexes[i]];
                if (featureRecord.tag === feature) {
                    return featureRecord.feature;
                }
            }
            if (create) {
                var index = allFeatures.length;
                // Automatic ordering of features would require to shift feature indexes in the script list.
                check.assert(index === 0 || feature >= allFeatures[index - 1].tag, 'Features must be added in alphabetical order.');
                featureRecord = {
                    tag: feature,
                    feature: { params: 0, lookupListIndexes: [] }
                };
                allFeatures.push(featureRecord);
                featIndexes.push(index);
                return featureRecord.feature;
            }
        }
    },

    /**
     * Get the lookup tables of a given type for a script/language/feature.
     * @instance
     * @param {string} [script='DFLT']
     * @param {string} [language='dlft']
     * @param {string} feature - 4-letter feature code
     * @param {number} lookupType - 1 to 8
     * @param {boolean} create - forces the creation of the lookup table if it doesn't exist, with no subtables.
     * @return {Object[]}
     */
    getLookupTables: function(script, language, feature, lookupType, create) {
        var featureTable = this.getFeatureTable(script, language, feature, create);
        var tables = [];
        if (featureTable) {
            var lookupTable;
            var lookupListIndexes = featureTable.lookupListIndexes;
            var allLookups = this.font.tables[this.tableName].lookups;
            // lookupListIndexes are in no particular order, so use naive search.
            for (var i = 0; i < lookupListIndexes.length; i++) {
                lookupTable = allLookups[lookupListIndexes[i]];
                if (lookupTable.lookupType === lookupType) {
                    tables.push(lookupTable);
                }
            }
            if (tables.length === 0 && create) {
                lookupTable = {
                    lookupType: lookupType,
                    lookupFlag: 0,
                    subtables: [],
                    markFilteringSet: undefined
                };
                var index = allLookups.length;
                allLookups.push(lookupTable);
                lookupListIndexes.push(index);
                return [lookupTable];
            }
        }
        return tables;
    },

    /**
     * Returns the list of glyph indexes of a coverage table.
     * Format 1: the list is stored raw
     * Format 2: compact list as range records.
     * @instance
     * @param  {Object} coverageTable
     * @return {Array}
     */
    expandCoverage: function(coverageTable) {
        if (coverageTable.format === 1) {
            return coverageTable.glyphs;
        } else {
            var glyphs = [];
            var ranges = coverageTable.ranges;
            for (var i = 0; i < ranges.length; i++) {
                var range = ranges[i];
                var start = range.start;
                var end = range.end;
                for (var j = start; j <= end; j++) {
                    glyphs.push(j);
                }
            }
            return glyphs;
        }
    }

};

// The Substitution object provides utility methods to manipulate
// the GSUB substitution table.

/**
 * @exports opentype.Substitution
 * @class
 * @extends opentype.Layout
 * @param {opentype.Font}
 * @constructor
 */
function Substitution(font) {
    Layout.call(this, font, 'gsub');
}

// Check if 2 arrays of primitives are equal.
function arraysEqual(ar1, ar2) {
    var n = ar1.length;
    if (n !== ar2.length) { return false; }
    for (var i = 0; i < n; i++) {
        if (ar1[i] !== ar2[i]) { return false; }
    }
    return true;
}

// Find the first subtable of a lookup table in a particular format.
function getSubstFormat(lookupTable, format, defaultSubtable) {
    var subtables = lookupTable.subtables;
    for (var i = 0; i < subtables.length; i++) {
        var subtable = subtables[i];
        if (subtable.substFormat === format) {
            return subtable;
        }
    }
    if (defaultSubtable) {
        subtables.push(defaultSubtable);
        return defaultSubtable;
    }
    return undefined;
}

Substitution.prototype = Layout.prototype;

/**
 * Create a default GSUB table.
 * @return {Object} gsub - The GSUB table.
 */
Substitution.prototype.createDefaultTable = function() {
    // Generate a default empty GSUB table with just a DFLT script and dflt lang sys.
    return {
        version: 1,
        scripts: [{
            tag: 'DFLT',
            script: {
                defaultLangSys: { reserved: 0, reqFeatureIndex: 0xffff, featureIndexes: [] },
                langSysRecords: []
            }
        }],
        features: [],
        lookups: []
    };
};

/**
 * List all single substitutions (lookup type 1) for a given script, language, and feature.
 * @param {string} [script='DFLT']
 * @param {string} [language='dflt']
 * @param {string} feature - 4-character feature name ('aalt', 'salt', 'ss01'...)
 * @return {Array} substitutions - The list of substitutions.
 */
Substitution.prototype.getSingle = function(feature, script, language) {
    var this$1 = this;

    var substitutions = [];
    var lookupTables = this.getLookupTables(script, language, feature, 1);
    for (var idx = 0; idx < lookupTables.length; idx++) {
        var subtables = lookupTables[idx].subtables;
        for (var i = 0; i < subtables.length; i++) {
            var subtable = subtables[i];
            var glyphs = this$1.expandCoverage(subtable.coverage);
            var j = (void 0);
            if (subtable.substFormat === 1) {
                var delta = subtable.deltaGlyphId;
                for (j = 0; j < glyphs.length; j++) {
                    var glyph = glyphs[j];
                    substitutions.push({ sub: glyph, by: glyph + delta });
                }
            } else {
                var substitute = subtable.substitute;
                for (j = 0; j < glyphs.length; j++) {
                    substitutions.push({ sub: glyphs[j], by: substitute[j] });
                }
            }
        }
    }
    return substitutions;
};

/**
 * List all alternates (lookup type 3) for a given script, language, and feature.
 * @param {string} [script='DFLT']
 * @param {string} [language='dflt']
 * @param {string} feature - 4-character feature name ('aalt', 'salt'...)
 * @return {Array} alternates - The list of alternates
 */
Substitution.prototype.getAlternates = function(feature, script, language) {
    var this$1 = this;

    var alternates = [];
    var lookupTables = this.getLookupTables(script, language, feature, 3);
    for (var idx = 0; idx < lookupTables.length; idx++) {
        var subtables = lookupTables[idx].subtables;
        for (var i = 0; i < subtables.length; i++) {
            var subtable = subtables[i];
            var glyphs = this$1.expandCoverage(subtable.coverage);
            var alternateSets = subtable.alternateSets;
            for (var j = 0; j < glyphs.length; j++) {
                alternates.push({ sub: glyphs[j], by: alternateSets[j] });
            }
        }
    }
    return alternates;
};

/**
 * List all ligatures (lookup type 4) for a given script, language, and feature.
 * The result is an array of ligature objects like { sub: [ids], by: id }
 * @param {string} feature - 4-letter feature name ('liga', 'rlig', 'dlig'...)
 * @param {string} [script='DFLT']
 * @param {string} [language='dflt']
 * @return {Array} ligatures - The list of ligatures.
 */
Substitution.prototype.getLigatures = function(feature, script, language) {
    var this$1 = this;

    var ligatures = [];
    var lookupTables = this.getLookupTables(script, language, feature, 4);
    for (var idx = 0; idx < lookupTables.length; idx++) {
        var subtables = lookupTables[idx].subtables;
        for (var i = 0; i < subtables.length; i++) {
            var subtable = subtables[i];
            var glyphs = this$1.expandCoverage(subtable.coverage);
            var ligatureSets = subtable.ligatureSets;
            for (var j = 0; j < glyphs.length; j++) {
                var startGlyph = glyphs[j];
                var ligSet = ligatureSets[j];
                for (var k = 0; k < ligSet.length; k++) {
                    var lig = ligSet[k];
                    ligatures.push({
                        sub: [startGlyph].concat(lig.components),
                        by: lig.ligGlyph
                    });
                }
            }
        }
    }
    return ligatures;
};

/**
 * Add or modify a single substitution (lookup type 1)
 * Format 2, more flexible, is always used.
 * @param {string} feature - 4-letter feature name ('liga', 'rlig', 'dlig'...)
 * @param {Object} substitution - { sub: id, delta: number } for format 1 or { sub: id, by: id } for format 2.
 * @param {string} [script='DFLT']
 * @param {string} [language='dflt']
 */
Substitution.prototype.addSingle = function(feature, substitution, script, language) {
    var lookupTable = this.getLookupTables(script, language, feature, 1, true)[0];
    var subtable = getSubstFormat(lookupTable, 2, {                // lookup type 1 subtable, format 2, coverage format 1
        substFormat: 2,
        coverage: {format: 1, glyphs: []},
        substitute: []
    });
    check.assert(subtable.coverage.format === 1, 'Ligature: unable to modify coverage table format ' + subtable.coverage.format);
    var coverageGlyph = substitution.sub;
    var pos = this.binSearch(subtable.coverage.glyphs, coverageGlyph);
    if (pos < 0) {
        pos = -1 - pos;
        subtable.coverage.glyphs.splice(pos, 0, coverageGlyph);
        subtable.substitute.splice(pos, 0, 0);
    }
    subtable.substitute[pos] = substitution.by;
};

/**
 * Add or modify an alternate substitution (lookup type 1)
 * @param {string} feature - 4-letter feature name ('liga', 'rlig', 'dlig'...)
 * @param {Object} substitution - { sub: id, by: [ids] }
 * @param {string} [script='DFLT']
 * @param {string} [language='dflt']
 */
Substitution.prototype.addAlternate = function(feature, substitution, script, language) {
    var lookupTable = this.getLookupTables(script, language, feature, 3, true)[0];
    var subtable = getSubstFormat(lookupTable, 1, {                // lookup type 3 subtable, format 1, coverage format 1
        substFormat: 1,
        coverage: {format: 1, glyphs: []},
        alternateSets: []
    });
    check.assert(subtable.coverage.format === 1, 'Ligature: unable to modify coverage table format ' + subtable.coverage.format);
    var coverageGlyph = substitution.sub;
    var pos = this.binSearch(subtable.coverage.glyphs, coverageGlyph);
    if (pos < 0) {
        pos = -1 - pos;
        subtable.coverage.glyphs.splice(pos, 0, coverageGlyph);
        subtable.alternateSets.splice(pos, 0, 0);
    }
    subtable.alternateSets[pos] = substitution.by;
};

/**
 * Add a ligature (lookup type 4)
 * Ligatures with more components must be stored ahead of those with fewer components in order to be found
 * @param {string} feature - 4-letter feature name ('liga', 'rlig', 'dlig'...)
 * @param {Object} ligature - { sub: [ids], by: id }
 * @param {string} [script='DFLT']
 * @param {string} [language='dflt']
 */
Substitution.prototype.addLigature = function(feature, ligature, script, language) {
    var lookupTable = this.getLookupTables(script, language, feature, 4, true)[0];
    var subtable = lookupTable.subtables[0];
    if (!subtable) {
        subtable = {                // lookup type 4 subtable, format 1, coverage format 1
            substFormat: 1,
            coverage: { format: 1, glyphs: [] },
            ligatureSets: []
        };
        lookupTable.subtables[0] = subtable;
    }
    check.assert(subtable.coverage.format === 1, 'Ligature: unable to modify coverage table format ' + subtable.coverage.format);
    var coverageGlyph = ligature.sub[0];
    var ligComponents = ligature.sub.slice(1);
    var ligatureTable = {
        ligGlyph: ligature.by,
        components: ligComponents
    };
    var pos = this.binSearch(subtable.coverage.glyphs, coverageGlyph);
    if (pos >= 0) {
        // ligatureSet already exists
        var ligatureSet = subtable.ligatureSets[pos];
        for (var i = 0; i < ligatureSet.length; i++) {
            // If ligature already exists, return.
            if (arraysEqual(ligatureSet[i].components, ligComponents)) {
                return;
            }
        }
        // ligature does not exist: add it.
        ligatureSet.push(ligatureTable);
    } else {
        // Create a new ligatureSet and add coverage for the first glyph.
        pos = -1 - pos;
        subtable.coverage.glyphs.splice(pos, 0, coverageGlyph);
        subtable.ligatureSets.splice(pos, 0, [ligatureTable]);
    }
};

/**
 * List all feature data for a given script and language.
 * @param {string} feature - 4-letter feature name
 * @param {string} [script='DFLT']
 * @param {string} [language='dflt']
 * @return {Array} substitutions - The list of substitutions.
 */
Substitution.prototype.getFeature = function(feature, script, language) {
    if (/ss\d\d/.test(feature)) {               // ss01 - ss20
        return this.getSingle(feature, script, language);
    }
    switch (feature) {
        case 'aalt':
        case 'salt':
            return this.getSingle(feature, script, language)
                    .concat(this.getAlternates(feature, script, language));
        case 'dlig':
        case 'liga':
        case 'rlig': return this.getLigatures(feature, script, language);
    }
    return undefined;
};

/**
 * Add a substitution to a feature for a given script and language.
 * @param {string} feature - 4-letter feature name
 * @param {Object} sub - the substitution to add (an object like { sub: id or [ids], by: id or [ids] })
 * @param {string} [script='DFLT']
 * @param {string} [language='dflt']
 */
Substitution.prototype.add = function(feature, sub, script, language) {
    if (/ss\d\d/.test(feature)) {               // ss01 - ss20
        return this.addSingle(feature, sub, script, language);
    }
    switch (feature) {
        case 'aalt':
        case 'salt':
            if (typeof sub.by === 'number') {
                return this.addSingle(feature, sub, script, language);
            }
            return this.addAlternate(feature, sub, script, language);
        case 'dlig':
        case 'liga':
        case 'rlig':
            return this.addLigature(feature, sub, script, language);
    }
    return undefined;
};

function isBrowser() {
    return typeof window !== 'undefined';
}

function nodeBufferToArrayBuffer(buffer) {
    var ab = new ArrayBuffer(buffer.length);
    var view = new Uint8Array(ab);
    for (var i = 0; i < buffer.length; ++i) {
        view[i] = buffer[i];
    }

    return ab;
}

function arrayBufferToNodeBuffer(ab) {
    var buffer = new Buffer(ab.byteLength);
    var view = new Uint8Array(ab);
    for (var i = 0; i < buffer.length; ++i) {
        buffer[i] = view[i];
    }

    return buffer;
}

function checkArgument(expression, message) {
    if (!expression) {
        throw message;
    }
}

/* A TrueType font hinting interpreter.
*
* (c) 2017 Axel Kittenberger
*
* This interpreter has been implemented according to this documentation:
* https://developer.apple.com/fonts/TrueType-Reference-Manual/RM05/Chap5.html
*
* According to the documentation F24DOT6 values are used for pixels.
* That means calculation is 1/64 pixel accurate and uses integer operations.
* However, Javascript has floating point operations by default and only
* those are available. One could make a case to simulate the 1/64 accuracy
* exactly by truncating after every division operation
* (for example with << 0) to get pixel exactly results as other TrueType
* implementations. It may make sense since some fonts are pixel optimized
* by hand using DELTAP instructions. The current implementation doesn't
* and rather uses full floating point precision.
*
* xScale, yScale and rotation is currently ignored.
*
* A few non-trivial instructions are missing as I didn't encounter yet
* a font that used them to test a possible implementation.
*
* Some fonts seem to use undocumented features regarding the twilight zone.
* Only some of them are implemented as they were encountered.
*
* The exports.DEBUG statements are removed on the minified distribution file.
*/
var instructionTable;
var exec;
var execGlyph;
var execComponent;

/*
* Creates a hinting object.
*
* There ought to be exactly one
* for each truetype font that is used for hinting.
*/
function Hinting(font) {
    // the font this hinting object is for
    this.font = font;

    // cached states
    this._fpgmState  =
    this._prepState  =
        undefined;

    // errorState
    // 0 ... all okay
    // 1 ... had an error in a glyf,
    //       continue working but stop spamming
    //       the console
    // 2 ... error at prep, stop hinting at this ppem
    // 3 ... error at fpeg, stop hinting for this font at all
    this._errorState = 0;
}

/*
* Not rounding.
*/
function roundOff(v) {
    return v;
}

/*
* Rounding to grid.
*/
function roundToGrid(v) {
    //Rounding in TT is supposed to "symmetrical around zero"
    return Math.sign(v) * Math.round(Math.abs(v));
}

/*
* Rounding to double grid.
*/
function roundToDoubleGrid(v) {
    return Math.sign(v) * Math.round(Math.abs(v * 2)) / 2;
}

/*
* Rounding to half grid.
*/
function roundToHalfGrid(v) {
    return Math.sign(v) * (Math.round(Math.abs(v) + 0.5) - 0.5);
}

/*
* Rounding to up to grid.
*/
function roundUpToGrid(v) {
    return Math.sign(v) * Math.ceil(Math.abs(v));
}

/*
* Rounding to down to grid.
*/
function roundDownToGrid(v) {
    return Math.sign(v) * Math.floor(Math.abs(v));
}

/*
* Super rounding.
*/
var roundSuper = function (v) {
    var period = this.srPeriod;
    var phase = this.srPhase;
    var threshold = this.srThreshold;
    var sign = 1;

    if (v < 0) {
        v = -v;
        sign = -1;
    }

    v += threshold - phase;

    v = Math.trunc(v / period) * period;

    v += phase;

    // according to http://xgridfit.sourceforge.net/round.html
    if (sign > 0 && v < 0) { return phase; }
    if (sign < 0 && v > 0) { return -phase; }

    return v * sign;
};

/*
* Unit vector of x-axis.
*/
var xUnitVector = {
    x: 1,

    y: 0,

    axis: 'x',

    // Gets the projected distance between two points.
    // o1/o2 ... if true, respective original position is used.
    distance: function (p1, p2, o1, o2) {
        return (o1 ? p1.xo : p1.x) - (o2 ? p2.xo : p2.x);
    },

    // Moves point p so the moved position has the same relative
    // position to the moved positions of rp1 and rp2 than the
    // original positions had.
    //
    // See APPENDIX on INTERPOLATE at the bottom of this file.
    interpolate: function (p, rp1, rp2, pv) {
        var do1;
        var do2;
        var doa1;
        var doa2;
        var dm1;
        var dm2;
        var dt;

        if (!pv || pv === this) {
            do1 = p.xo - rp1.xo;
            do2 = p.xo - rp2.xo;
            dm1 = rp1.x - rp1.xo;
            dm2 = rp2.x - rp2.xo;
            doa1 = Math.abs(do1);
            doa2 = Math.abs(do2);
            dt = doa1 + doa2;

            if (dt === 0) {
                p.x = p.xo + (dm1 + dm2) / 2;
                return;
            }

            p.x = p.xo + (dm1 * doa2 + dm2 * doa1) / dt;
            return;
        }

        do1 = pv.distance(p, rp1, true, true);
        do2 = pv.distance(p, rp2, true, true);
        dm1 = pv.distance(rp1, rp1, false, true);
        dm2 = pv.distance(rp2, rp2, false, true);
        doa1 = Math.abs(do1);
        doa2 = Math.abs(do2);
        dt = doa1 + doa2;

        if (dt === 0) {
            xUnitVector.setRelative(p, p, (dm1 + dm2) / 2, pv, true);
            return;
        }

        xUnitVector.setRelative(p, p, (dm1 * doa2 + dm2 * doa1) / dt, pv, true);
    },

    // Slope of line normal to this
    normalSlope: Number.NEGATIVE_INFINITY,

    // Sets the point 'p' relative to point 'rp'
    // by the distance 'd'.
    //
    // See APPENDIX on SETRELATIVE at the bottom of this file.
    //
    // p   ... point to set
    // rp  ... reference point
    // d   ... distance on projection vector
    // pv  ... projection vector (undefined = this)
    // org ... if true, uses the original position of rp as reference.
    setRelative: function (p, rp, d, pv, org) {
        if (!pv || pv === this) {
            p.x = (org ? rp.xo : rp.x) + d;
            return;
        }

        var rpx = org ? rp.xo : rp.x;
        var rpy = org ? rp.yo : rp.y;
        var rpdx = rpx + d * pv.x;
        var rpdy = rpy + d * pv.y;

        p.x = rpdx + (p.y - rpdy) / pv.normalSlope;
    },

    // Slope of vector line.
    slope: 0,

    // Touches the point p.
    touch: function (p) {
        p.xTouched = true;
    },

    // Tests if a point p is touched.
    touched: function (p) {
        return p.xTouched;
    },

    // Untouches the point p.
    untouch: function (p) {
        p.xTouched = false;
    }
};

/*
* Unit vector of y-axis.
*/
var yUnitVector = {
    x: 0,

    y: 1,

    axis: 'y',

    // Gets the projected distance between two points.
    // o1/o2 ... if true, respective original position is used.
    distance: function (p1, p2, o1, o2) {
        return (o1 ? p1.yo : p1.y) - (o2 ? p2.yo : p2.y);
    },

    // Moves point p so the moved position has the same relative
    // position to the moved positions of rp1 and rp2 than the
    // original positions had.
    //
    // See APPENDIX on INTERPOLATE at the bottom of this file.
    interpolate: function (p, rp1, rp2, pv) {
        var do1;
        var do2;
        var doa1;
        var doa2;
        var dm1;
        var dm2;
        var dt;

        if (!pv || pv === this) {
            do1 = p.yo - rp1.yo;
            do2 = p.yo - rp2.yo;
            dm1 = rp1.y - rp1.yo;
            dm2 = rp2.y - rp2.yo;
            doa1 = Math.abs(do1);
            doa2 = Math.abs(do2);
            dt = doa1 + doa2;

            if (dt === 0) {
                p.y = p.yo + (dm1 + dm2) / 2;
                return;
            }

            p.y = p.yo + (dm1 * doa2 + dm2 * doa1) / dt;
            return;
        }

        do1 = pv.distance(p, rp1, true, true);
        do2 = pv.distance(p, rp2, true, true);
        dm1 = pv.distance(rp1, rp1, false, true);
        dm2 = pv.distance(rp2, rp2, false, true);
        doa1 = Math.abs(do1);
        doa2 = Math.abs(do2);
        dt = doa1 + doa2;

        if (dt === 0) {
            yUnitVector.setRelative(p, p, (dm1 + dm2) / 2, pv, true);
            return;
        }

        yUnitVector.setRelative(p, p, (dm1 * doa2 + dm2 * doa1) / dt, pv, true);
    },

    // Slope of line normal to this.
    normalSlope: 0,

    // Sets the point 'p' relative to point 'rp'
    // by the distance 'd'
    //
    // See APPENDIX on SETRELATIVE at the bottom of this file.
    //
    // p   ... point to set
    // rp  ... reference point
    // d   ... distance on projection vector
    // pv  ... projection vector (undefined = this)
    // org ... if true, uses the original position of rp as reference.
    setRelative: function (p, rp, d, pv, org) {
        if (!pv || pv === this) {
            p.y = (org ? rp.yo : rp.y) + d;
            return;
        }

        var rpx = org ? rp.xo : rp.x;
        var rpy = org ? rp.yo : rp.y;
        var rpdx = rpx + d * pv.x;
        var rpdy = rpy + d * pv.y;

        p.y = rpdy + pv.normalSlope * (p.x - rpdx);
    },

    // Slope of vector line.
    slope: Number.POSITIVE_INFINITY,

    // Touches the point p.
    touch: function (p) {
        p.yTouched = true;
    },

    // Tests if a point p is touched.
    touched: function (p) {
        return p.yTouched;
    },

    // Untouches the point p.
    untouch: function (p) {
        p.yTouched = false;
    }
};

Object.freeze(xUnitVector);
Object.freeze(yUnitVector);

/*
* Creates a unit vector that is not x- or y-axis.
*/
function UnitVector(x, y) {
    this.x = x;
    this.y = y;
    this.axis = undefined;
    this.slope = y / x;
    this.normalSlope = -x / y;
    Object.freeze(this);
}

/*
* Gets the projected distance between two points.
* o1/o2 ... if true, respective original position is used.
*/
UnitVector.prototype.distance = function(p1, p2, o1, o2) {
    return (
        this.x * xUnitVector.distance(p1, p2, o1, o2) +
        this.y * yUnitVector.distance(p1, p2, o1, o2)
    );
};

/*
* Moves point p so the moved position has the same relative
* position to the moved positions of rp1 and rp2 than the
* original positions had.
*
* See APPENDIX on INTERPOLATE at the bottom of this file.
*/
UnitVector.prototype.interpolate = function(p, rp1, rp2, pv) {
    var dm1;
    var dm2;
    var do1;
    var do2;
    var doa1;
    var doa2;
    var dt;

    do1 = pv.distance(p, rp1, true, true);
    do2 = pv.distance(p, rp2, true, true);
    dm1 = pv.distance(rp1, rp1, false, true);
    dm2 = pv.distance(rp2, rp2, false, true);
    doa1 = Math.abs(do1);
    doa2 = Math.abs(do2);
    dt = doa1 + doa2;

    if (dt === 0) {
        this.setRelative(p, p, (dm1 + dm2) / 2, pv, true);
        return;
    }

    this.setRelative(p, p, (dm1 * doa2 + dm2 * doa1) / dt, pv, true);
};

/*
* Sets the point 'p' relative to point 'rp'
* by the distance 'd'
*
* See APPENDIX on SETRELATIVE at the bottom of this file.
*
* p   ...  point to set
* rp  ... reference point
* d   ... distance on projection vector
* pv  ... projection vector (undefined = this)
* org ... if true, uses the original position of rp as reference.
*/
UnitVector.prototype.setRelative = function(p, rp, d, pv, org) {
    pv = pv || this;

    var rpx = org ? rp.xo : rp.x;
    var rpy = org ? rp.yo : rp.y;
    var rpdx = rpx + d * pv.x;
    var rpdy = rpy + d * pv.y;

    var pvns = pv.normalSlope;
    var fvs = this.slope;

    var px = p.x;
    var py = p.y;

    p.x = (fvs * px - pvns * rpdx + rpdy - py) / (fvs - pvns);
    p.y = fvs * (p.x - px) + py;
};

/*
* Touches the point p.
*/
UnitVector.prototype.touch = function(p) {
    p.xTouched = true;
    p.yTouched = true;
};

/*
* Returns a unit vector with x/y coordinates.
*/
function getUnitVector(x, y) {
    var d = Math.sqrt(x * x + y * y);

    x /= d;
    y /= d;

    if (x === 1 && y === 0) { return xUnitVector; }
    else if (x === 0 && y === 1) { return yUnitVector; }
    else { return new UnitVector(x, y); }
}

/*
* Creates a point in the hinting engine.
*/
function HPoint(
    x,
    y,
    lastPointOfContour,
    onCurve
) {
    this.x = this.xo = Math.round(x * 64) / 64; // hinted x value and original x-value
    this.y = this.yo = Math.round(y * 64) / 64; // hinted y value and original y-value

    this.lastPointOfContour = lastPointOfContour;
    this.onCurve = onCurve;
    this.prevPointOnContour = undefined;
    this.nextPointOnContour = undefined;
    this.xTouched = false;
    this.yTouched = false;

    Object.preventExtensions(this);
}

/*
* Returns the next touched point on the contour.
*
* v  ... unit vector to test touch axis.
*/
HPoint.prototype.nextTouched = function(v) {
    var p = this.nextPointOnContour;

    while (!v.touched(p) && p !== this) { p = p.nextPointOnContour; }

    return p;
};

/*
* Returns the previous touched point on the contour
*
* v  ... unit vector to test touch axis.
*/
HPoint.prototype.prevTouched = function(v) {
    var p = this.prevPointOnContour;

    while (!v.touched(p) && p !== this) { p = p.prevPointOnContour; }

    return p;
};

/*
* The zero point.
*/
var HPZero = Object.freeze(new HPoint(0, 0));

/*
* The default state of the interpreter.
*
* Note: Freezing the defaultState and then deriving from it
* makes the V8 Javascript engine going awkward,
* so this is avoided, albeit the defaultState shouldn't
* ever change.
*/
var defaultState = {
    cvCutIn: 17 / 16,    // control value cut in
    deltaBase: 9,
    deltaShift: 0.125,
    loop: 1,             // loops some instructions
    minDis: 1,           // minimum distance
    autoFlip: true
};

/*
* The current state of the interpreter.
*
* env  ... 'fpgm' or 'prep' or 'glyf'
* prog ... the program
*/
function State(env, prog) {
    this.env = env;
    this.stack = [];
    this.prog = prog;

    switch (env) {
        case 'glyf' :
            this.zp0 = this.zp1 = this.zp2 = 1;
            this.rp0 = this.rp1 = this.rp2 = 0;
            /* fall through */
        case 'prep' :
            this.fv = this.pv = this.dpv = xUnitVector;
            this.round = roundToGrid;
    }
}

/*
* Executes a glyph program.
*
* This does the hinting for each glyph.
*
* Returns an array of moved points.
*
* glyph: the glyph to hint
* ppem: the size the glyph is rendered for
*/
Hinting.prototype.exec = function(glyph, ppem) {
    if (typeof ppem !== 'number') {
        throw new Error('Point size is not a number!');
    }

    // Received a fatal error, don't do any hinting anymore.
    if (this._errorState > 2) { return; }

    var font = this.font;
    var prepState = this._prepState;

    if (!prepState || prepState.ppem !== ppem) {
        var fpgmState = this._fpgmState;

        if (!fpgmState) {
            // Executes the fpgm state.
            // This is used by fonts to define functions.
            State.prototype = defaultState;

            fpgmState =
            this._fpgmState =
                new State('fpgm', font.tables.fpgm);

            fpgmState.funcs = [ ];
            fpgmState.font = font;

            if (exports.DEBUG) {
                console.log('---EXEC FPGM---');
                fpgmState.step = -1;
            }

            try {
                exec(fpgmState);
            } catch (e) {
                console.log('Hinting error in FPGM:' + e);
                this._errorState = 3;
                return;
            }
        }

        // Executes the prep program for this ppem setting.
        // This is used by fonts to set cvt values
        // depending on to be rendered font size.

        State.prototype = fpgmState;
        prepState =
        this._prepState =
            new State('prep', font.tables.prep);

        prepState.ppem = ppem;

        // Creates a copy of the cvt table
        // and scales it to the current ppem setting.
        var oCvt = font.tables.cvt;
        if (oCvt) {
            var cvt = prepState.cvt = new Array(oCvt.length);
            var scale = ppem / font.unitsPerEm;
            for (var c = 0; c < oCvt.length; c++) {
                cvt[c] = oCvt[c] * scale;
            }
        } else {
            prepState.cvt = [];
        }

        if (exports.DEBUG) {
            console.log('---EXEC PREP---');
            prepState.step = -1;
        }

        try {
            exec(prepState);
        } catch (e) {
            if (this._errorState < 2) {
                console.log('Hinting error in PREP:' + e);
            }
            this._errorState = 2;
        }
    }

    if (this._errorState > 1) { return; }

    try {
        return execGlyph(glyph, prepState);
    } catch (e) {
        if (this._errorState < 1) {
            console.log('Hinting error:' + e);
            console.log('Note: further hinting errors are silenced');
        }
        this._errorState = 1;
        return undefined;
    }
};

/*
* Executes the hinting program for a glyph.
*/
execGlyph = function(glyph, prepState) {
    // original point positions
    var xScale = prepState.ppem / prepState.font.unitsPerEm;
    var yScale = xScale;
    var components = glyph.components;
    var contours;
    var gZone;
    var state;

    State.prototype = prepState;
    if (!components) {
        state = new State('glyf', glyph.instructions);
        if (exports.DEBUG) {
            console.log('---EXEC GLYPH---');
            state.step = -1;
        }
        execComponent(glyph, state, xScale, yScale);
        gZone = state.gZone;
    } else {
        var font = prepState.font;
        gZone = [];
        contours = [];
        for (var i = 0; i < components.length; i++) {
            var c = components[i];
            var cg = font.glyphs.get(c.glyphIndex);

            state = new State('glyf', cg.instructions);

            if (exports.DEBUG) {
                console.log('---EXEC COMP ' + i + '---');
                state.step = -1;
            }

            execComponent(cg, state, xScale, yScale);
            // appends the computed points to the result array
            // post processes the component points
            var dx = Math.round(c.dx * xScale);
            var dy = Math.round(c.dy * yScale);
            var gz = state.gZone;
            var cc = state.contours;
            for (var pi = 0; pi < gz.length; pi++) {
                var p = gz[pi];
                p.xTouched = p.yTouched = false;
                p.xo = p.x = p.x + dx;
                p.yo = p.y = p.y + dy;
            }

            var gLen = gZone.length;
            gZone.push.apply(gZone, gz);
            for (var j = 0; j < cc.length; j++) {
                contours.push(cc[j] + gLen);
            }
        }

        if (glyph.instructions && !state.inhibitGridFit) {
            // the composite has instructions on its own
            state = new State('glyf', glyph.instructions);

            state.gZone = state.z0 = state.z1 = state.z2 = gZone;

            state.contours = contours;

            // note: HPZero cannot be used here, since
            //       the point might be modified
            gZone.push(
                new HPoint(0, 0),
                new HPoint(Math.round(glyph.advanceWidth * xScale), 0)
            );

            if (exports.DEBUG) {
                console.log('---EXEC COMPOSITE---');
                state.step = -1;
            }

            exec(state);

            gZone.length -= 2;
        }
    }

    return gZone;
};

/*
* Executes the hinting program for a component of a multi-component glyph
* or of the glyph itself by a non-component glyph.
*/
execComponent = function(glyph, state, xScale, yScale)
{
    var points = glyph.points || [];
    var pLen = points.length;
    var gZone = state.gZone = state.z0 = state.z1 = state.z2 = [];
    var contours = state.contours = [];

    // Scales the original points and
    // makes copies for the hinted points.
    var cp; // current point
    for (var i = 0; i < pLen; i++) {
        cp = points[i];

        gZone[i] = new HPoint(
            cp.x * xScale,
            cp.y * yScale,
            cp.lastPointOfContour,
            cp.onCurve
        );
    }

    // Chain links the contours.
    var sp; // start point
    var np; // next point

    for (var i$1 = 0; i$1 < pLen; i$1++) {
        cp = gZone[i$1];

        if (!sp) {
            sp = cp;
            contours.push(i$1);
        }

        if (cp.lastPointOfContour) {
            cp.nextPointOnContour = sp;
            sp.prevPointOnContour = cp;
            sp = undefined;
        } else {
            np = gZone[i$1 + 1];
            cp.nextPointOnContour = np;
            np.prevPointOnContour = cp;
        }
    }

    if (state.inhibitGridFit) { return; }

    gZone.push(
        new HPoint(0, 0),
        new HPoint(Math.round(glyph.advanceWidth * xScale), 0)
    );

    exec(state);

    // Removes the extra points.
    gZone.length -= 2;

    if (exports.DEBUG) {
        console.log('FINISHED GLYPH', state.stack);
        for (var i$2 = 0; i$2 < pLen; i$2++) {
            console.log(i$2, gZone[i$2].x, gZone[i$2].y);
        }
    }
};

/*
* Executes the program loaded in state.
*/
exec = function(state) {
    var prog = state.prog;

    if (!prog) { return; }

    var pLen = prog.length;
    var ins;

    for (state.ip = 0; state.ip < pLen; state.ip++) {
        if (exports.DEBUG) { state.step++; }
        ins = instructionTable[prog[state.ip]];

        if (!ins) {
            throw new Error(
                'unknown instruction: 0x' +
                Number(prog[state.ip]).toString(16)
            );
        }

        ins(state);

        // very extensive debugging for each step
        /*
        if (exports.DEBUG) {
            var da;
            if (state.gZone) {
                da = [];
                for (let i = 0; i < state.gZone.length; i++)
                {
                    da.push(i + ' ' +
                        state.gZone[i].x * 64 + ' ' +
                        state.gZone[i].y * 64 + ' ' +
                        (state.gZone[i].xTouched ? 'x' : '') +
                        (state.gZone[i].yTouched ? 'y' : '')
                    );
                }
                console.log('GZ', da);
            }

            if (state.tZone) {
                da = [];
                for (let i = 0; i < state.tZone.length; i++) {
                    da.push(i + ' ' +
                        state.tZone[i].x * 64 + ' ' +
                        state.tZone[i].y * 64 + ' ' +
                        (state.tZone[i].xTouched ? 'x' : '') +
                        (state.tZone[i].yTouched ? 'y' : '')
                    );
                }
                console.log('TZ', da);
            }

            if (state.stack.length > 10) {
                console.log(
                    state.stack.length,
                    '...', state.stack.slice(state.stack.length - 10)
                );
            } else {
                console.log(state.stack.length, state.stack);
            }
        }
        */
    }
};

/*
* Initializes the twilight zone.
*
* This is only done if a SZPx instruction
* refers to the twilight zone.
*/
function initTZone(state)
{
    var tZone = state.tZone = new Array(state.gZone.length);

    // no idea if this is actually correct...
    for (var i = 0; i < tZone.length; i++)
    {
        tZone[i] = new HPoint(0, 0);
    }
}

/*
* Skips the instruction pointer ahead over an IF/ELSE block.
* handleElse .. if true breaks on matching ELSE
*/
function skip(state, handleElse)
{
    var prog = state.prog;
    var ip = state.ip;
    var nesting = 1;
    var ins;

    do {
        ins = prog[++ip];
        if (ins === 0x58) // IF
            { nesting++; }
        else if (ins === 0x59) // EIF
            { nesting--; }
        else if (ins === 0x40) // NPUSHB
            { ip += prog[ip + 1] + 1; }
        else if (ins === 0x41) // NPUSHW
            { ip += 2 * prog[ip + 1] + 1; }
        else if (ins >= 0xB0 && ins <= 0xB7) // PUSHB
            { ip += ins - 0xB0 + 1; }
        else if (ins >= 0xB8 && ins <= 0xBF) // PUSHW
            { ip += (ins - 0xB8 + 1) * 2; }
        else if (handleElse && nesting === 1 && ins === 0x1B) // ELSE
            { break; }
    } while (nesting > 0);

    state.ip = ip;
}

/*----------------------------------------------------------*
*          And then a lot of instructions...                *
*----------------------------------------------------------*/

// SVTCA[a] Set freedom and projection Vectors To Coordinate Axis
// 0x00-0x01
function SVTCA(v, state) {
    if (exports.DEBUG) { console.log(state.step, 'SVTCA[' + v.axis + ']'); }

    state.fv = state.pv = state.dpv = v;
}

// SPVTCA[a] Set Projection Vector to Coordinate Axis
// 0x02-0x03
function SPVTCA(v, state) {
    if (exports.DEBUG) { console.log(state.step, 'SPVTCA[' + v.axis + ']'); }

    state.pv = state.dpv = v;
}

// SFVTCA[a] Set Freedom Vector to Coordinate Axis
// 0x04-0x05
function SFVTCA(v, state) {
    if (exports.DEBUG) { console.log(state.step, 'SFVTCA[' + v.axis + ']'); }

    state.fv = v;
}

// SPVTL[a] Set Projection Vector To Line
// 0x06-0x07
function SPVTL(a, state) {
    var stack = state.stack;
    var p2i = stack.pop();
    var p1i = stack.pop();
    var p2 = state.z2[p2i];
    var p1 = state.z1[p1i];

    if (exports.DEBUG) { console.log('SPVTL[' + a + ']', p2i, p1i); }

    var dx;
    var dy;

    if (!a) {
        dx = p1.x - p2.x;
        dy = p1.y - p2.y;
    } else {
        dx = p2.y - p1.y;
        dy = p1.x - p2.x;
    }

    state.pv = state.dpv = getUnitVector(dx, dy);
}

// SFVTL[a] Set Freedom Vector To Line
// 0x08-0x09
function SFVTL(a, state) {
    var stack = state.stack;
    var p2i = stack.pop();
    var p1i = stack.pop();
    var p2 = state.z2[p2i];
    var p1 = state.z1[p1i];

    if (exports.DEBUG) { console.log('SFVTL[' + a + ']', p2i, p1i); }

    var dx;
    var dy;

    if (!a) {
        dx = p1.x - p2.x;
        dy = p1.y - p2.y;
    } else {
        dx = p2.y - p1.y;
        dy = p1.x - p2.x;
    }

    state.fv = getUnitVector(dx, dy);
}

// SPVFS[] Set Projection Vector From Stack
// 0x0A
function SPVFS(state) {
    var stack = state.stack;
    var y = stack.pop();
    var x = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'SPVFS[]', y, x); }

    state.pv = state.dpv = getUnitVector(x, y);
}

// SFVFS[] Set Freedom Vector From Stack
// 0x0B
function SFVFS(state) {
    var stack = state.stack;
    var y = stack.pop();
    var x = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'SPVFS[]', y, x); }

    state.fv = getUnitVector(x, y);
}

// GPV[] Get Projection Vector
// 0x0C
function GPV(state) {
    var stack = state.stack;
    var pv = state.pv;

    if (exports.DEBUG) { console.log(state.step, 'GPV[]'); }

    stack.push(pv.x * 0x4000);
    stack.push(pv.y * 0x4000);
}

// GFV[] Get Freedom Vector
// 0x0C
function GFV(state) {
    var stack = state.stack;
    var fv = state.fv;

    if (exports.DEBUG) { console.log(state.step, 'GFV[]'); }

    stack.push(fv.x * 0x4000);
    stack.push(fv.y * 0x4000);
}

// SFVTPV[] Set Freedom Vector To Projection Vector
// 0x0E
function SFVTPV(state) {
    state.fv = state.pv;

    if (exports.DEBUG) { console.log(state.step, 'SFVTPV[]'); }
}

// ISECT[] moves point p to the InterSECTion of two lines
// 0x0F
function ISECT(state)
{
    var stack = state.stack;
    var pa0i = stack.pop();
    var pa1i = stack.pop();
    var pb0i = stack.pop();
    var pb1i = stack.pop();
    var pi = stack.pop();
    var z0 = state.z0;
    var z1 = state.z1;
    var pa0 = z0[pa0i];
    var pa1 = z0[pa1i];
    var pb0 = z1[pb0i];
    var pb1 = z1[pb1i];
    var p = state.z2[pi];

    if (exports.DEBUG) { console.log('ISECT[], ', pa0i, pa1i, pb0i, pb1i, pi); }

    // math from
    // en.wikipedia.org/wiki/Line%E2%80%93line_intersection#Given_two_points_on_each_line

    var x1 = pa0.x;
    var y1 = pa0.y;
    var x2 = pa1.x;
    var y2 = pa1.y;
    var x3 = pb0.x;
    var y3 = pb0.y;
    var x4 = pb1.x;
    var y4 = pb1.y;

    var div = (x1 - x2) * (y3 - y4) - (y1 - y2) * (x3 - x4);
    var f1 = x1 * y2 - y1 * x2;
    var f2 = x3 * y4 - y3 * x4;

    p.x = (f1 * (x3 - x4) - f2 * (x1 - x2)) / div;
    p.y = (f1 * (y3 - y4) - f2 * (y1 - y2)) / div;
}

// SRP0[] Set Reference Point 0
// 0x10
function SRP0(state) {
    state.rp0 = state.stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'SRP0[]', state.rp0); }
}

// SRP1[] Set Reference Point 1
// 0x11
function SRP1(state) {
    state.rp1 = state.stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'SRP1[]', state.rp1); }
}

// SRP1[] Set Reference Point 2
// 0x12
function SRP2(state) {
    state.rp2 = state.stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'SRP2[]', state.rp2); }
}

// SZP0[] Set Zone Pointer 0
// 0x13
function SZP0(state) {
    var n = state.stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'SZP0[]', n); }

    state.zp0 = n;

    switch (n) {
        case 0:
            if (!state.tZone) { initTZone(state); }
            state.z0 = state.tZone;
            break;
        case 1 :
            state.z0 = state.gZone;
            break;
        default :
            throw new Error('Invalid zone pointer');
    }
}

// SZP1[] Set Zone Pointer 1
// 0x14
function SZP1(state) {
    var n = state.stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'SZP1[]', n); }

    state.zp1 = n;

    switch (n) {
        case 0:
            if (!state.tZone) { initTZone(state); }
            state.z1 = state.tZone;
            break;
        case 1 :
            state.z1 = state.gZone;
            break;
        default :
            throw new Error('Invalid zone pointer');
    }
}

// SZP2[] Set Zone Pointer 2
// 0x15
function SZP2(state) {
    var n = state.stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'SZP2[]', n); }

    state.zp2 = n;

    switch (n) {
        case 0:
            if (!state.tZone) { initTZone(state); }
            state.z2 = state.tZone;
            break;
        case 1 :
            state.z2 = state.gZone;
            break;
        default :
            throw new Error('Invalid zone pointer');
    }
}

// SZPS[] Set Zone PointerS
// 0x16
function SZPS(state) {
    var n = state.stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'SZPS[]', n); }

    state.zp0 = state.zp1 = state.zp2 = n;

    switch (n) {
        case 0:
            if (!state.tZone) { initTZone(state); }
            state.z0 = state.z1 = state.z2 = state.tZone;
            break;
        case 1 :
            state.z0 = state.z1 = state.z2 = state.gZone;
            break;
        default :
            throw new Error('Invalid zone pointer');
    }
}

// SLOOP[] Set LOOP variable
// 0x17
function SLOOP(state) {
    state.loop = state.stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'SLOOP[]', state.loop); }
}

// RTG[] Round To Grid
// 0x18
function RTG(state) {
    if (exports.DEBUG) { console.log(state.step, 'RTG[]'); }

    state.round = roundToGrid;
}

// RTHG[] Round To Half Grid
// 0x19
function RTHG(state) {
    if (exports.DEBUG) { console.log(state.step, 'RTHG[]'); }

    state.round = roundToHalfGrid;
}

// SMD[] Set Minimum Distance
// 0x1A
function SMD(state) {
    var d = state.stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'SMD[]', d); }

    state.minDis = d / 0x40;
}

// ELSE[] ELSE clause
// 0x1B
function ELSE(state) {
    // This instruction has been reached by executing a then branch
    // so it just skips ahead until matching EIF.
    //
    // In case the IF was negative the IF[] instruction already
    // skipped forward over the ELSE[]

    if (exports.DEBUG) { console.log(state.step, 'ELSE[]'); }

    skip(state, false);
}

// JMPR[] JuMP Relative
// 0x1C
function JMPR(state) {
    var o = state.stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'JMPR[]', o); }

    // A jump by 1 would do nothing.
    state.ip += o - 1;
}

// SCVTCI[] Set Control Value Table Cut-In
// 0x1D
function SCVTCI(state) {
    var n = state.stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'SCVTCI[]', n); }

    state.cvCutIn = n / 0x40;
}

// DUP[] DUPlicate top stack element
// 0x20
function DUP(state) {
    var stack = state.stack;

    if (exports.DEBUG) { console.log(state.step, 'DUP[]'); }

    stack.push(stack[stack.length - 1]);
}

// POP[] POP top stack element
// 0x21
function POP(state) {
    if (exports.DEBUG) { console.log(state.step, 'POP[]'); }

    state.stack.pop();
}

// CLEAR[] CLEAR the stack
// 0x22
function CLEAR(state) {
    if (exports.DEBUG) { console.log(state.step, 'CLEAR[]'); }

    state.stack.length = 0;
}

// SWAP[] SWAP the top two elements on the stack
// 0x23
function SWAP(state) {
    var stack = state.stack;

    var a = stack.pop();
    var b = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'SWAP[]'); }

    stack.push(a);
    stack.push(b);
}

// DEPTH[] DEPTH of the stack
// 0x24
function DEPTH(state) {
    var stack = state.stack;

    if (exports.DEBUG) { console.log(state.step, 'DEPTH[]'); }

    stack.push(stack.length);
}

// LOOPCALL[] LOOPCALL function
// 0x2A
function LOOPCALL(state) {
    var stack = state.stack;
    var fn = stack.pop();
    var c = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'LOOPCALL[]', fn, c); }

    // saves callers program
    var cip = state.ip;
    var cprog = state.prog;

    state.prog = state.funcs[fn];

    // executes the function
    for (var i = 0; i < c; i++) {
        exec(state);

        if (exports.DEBUG) { console.log(
            ++state.step,
            i + 1 < c ? 'next loopcall' : 'done loopcall',
            i
        ); }
    }

    // restores the callers program
    state.ip = cip;
    state.prog = cprog;
}

// CALL[] CALL function
// 0x2B
function CALL(state) {
    var fn = state.stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'CALL[]', fn); }

    // saves callers program
    var cip = state.ip;
    var cprog = state.prog;

    state.prog = state.funcs[fn];

    // executes the function
    exec(state);

    // restores the callers program
    state.ip = cip;
    state.prog = cprog;

    if (exports.DEBUG) { console.log(++state.step, 'returning from', fn); }
}

// CINDEX[] Copy the INDEXed element to the top of the stack
// 0x25
function CINDEX(state) {
    var stack = state.stack;
    var k = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'CINDEX[]', k); }

    // In case of k == 1, it copies the last element after popping
    // thus stack.length - k.
    stack.push(stack[stack.length - k]);
}

// MINDEX[] Move the INDEXed element to the top of the stack
// 0x26
function MINDEX(state) {
    var stack = state.stack;
    var k = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'MINDEX[]', k); }

    stack.push(stack.splice(stack.length - k, 1)[0]);
}

// FDEF[] Function DEFinition
// 0x2C
function FDEF(state) {
    if (state.env !== 'fpgm') { throw new Error('FDEF not allowed here'); }
    var stack = state.stack;
    var prog = state.prog;
    var ip = state.ip;

    var fn = stack.pop();
    var ipBegin = ip;

    if (exports.DEBUG) { console.log(state.step, 'FDEF[]', fn); }

    while (prog[++ip] !== 0x2D){  }

    state.ip = ip;
    state.funcs[fn] = prog.slice(ipBegin + 1, ip);
}

// MDAP[a] Move Direct Absolute Point
// 0x2E-0x2F
function MDAP(round, state) {
    var pi = state.stack.pop();
    var p = state.z0[pi];
    var fv = state.fv;
    var pv = state.pv;

    if (exports.DEBUG) { console.log(state.step, 'MDAP[' + round + ']', pi); }

    var d = pv.distance(p, HPZero);

    if (round) { d = state.round(d); }

    fv.setRelative(p, HPZero, d, pv);
    fv.touch(p);

    state.rp0 = state.rp1 = pi;
}

// IUP[a] Interpolate Untouched Points through the outline
// 0x30
function IUP(v, state) {
    var z2 = state.z2;
    var pLen = z2.length - 2;
    var cp;
    var pp;
    var np;

    if (exports.DEBUG) { console.log(state.step, 'IUP[' + v.axis + ']'); }

    for (var i = 0; i < pLen; i++) {
        cp = z2[i]; // current point

        // if this point has been touched go on
        if (v.touched(cp)) { continue; }

        pp = cp.prevTouched(v);

        // no point on the contour has been touched?
        if (pp === cp) { continue; }

        np = cp.nextTouched(v);

        if (pp === np) {
            // only one point on the contour has been touched
            // so simply moves the point like that

            v.setRelative(cp, cp, v.distance(pp, pp, false, true), v, true);
        }

        v.interpolate(cp, pp, np, v);
    }
}

// SHP[] SHift Point using reference point
// 0x32-0x33
function SHP(a, state) {
    var stack = state.stack;
    var rpi = a ? state.rp1 : state.rp2;
    var rp = (a ? state.z0 : state.z1)[rpi];
    var fv = state.fv;
    var pv = state.pv;
    var loop = state.loop;
    var z2 = state.z2;

    while (loop--)
    {
        var pi = stack.pop();
        var p = z2[pi];

        var d = pv.distance(rp, rp, false, true);
        fv.setRelative(p, p, d, pv);
        fv.touch(p);

        if (exports.DEBUG) {
            console.log(
                state.step,
                (state.loop > 1 ?
                   'loop ' + (state.loop - loop) + ': ' :
                   ''
                ) +
                'SHP[' + (a ? 'rp1' : 'rp2') + ']', pi
            );
        }
    }

    state.loop = 1;
}

// SHC[] SHift Contour using reference point
// 0x36-0x37
function SHC(a, state) {
    var stack = state.stack;
    var rpi = a ? state.rp1 : state.rp2;
    var rp = (a ? state.z0 : state.z1)[rpi];
    var fv = state.fv;
    var pv = state.pv;
    var ci = stack.pop();
    var sp = state.z2[state.contours[ci]];
    var p = sp;

    if (exports.DEBUG) { console.log(state.step, 'SHC[' + a + ']', ci); }

    var d = pv.distance(rp, rp, false, true);

    do {
        if (p !== rp) { fv.setRelative(p, p, d, pv); }
        p = p.nextPointOnContour;
    } while (p !== sp);
}

// SHZ[] SHift Zone using reference point
// 0x36-0x37
function SHZ(a, state) {
    var stack = state.stack;
    var rpi = a ? state.rp1 : state.rp2;
    var rp = (a ? state.z0 : state.z1)[rpi];
    var fv = state.fv;
    var pv = state.pv;

    var e = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'SHZ[' + a + ']', e); }

    var z;
    switch (e) {
        case 0 : z = state.tZone; break;
        case 1 : z = state.gZone; break;
        default : throw new Error('Invalid zone');
    }

    var p;
    var d = pv.distance(rp, rp, false, true);
    var pLen = z.length - 2;
    for (var i = 0; i < pLen; i++)
    {
        p = z[i];
        if (p !== rp) { fv.setRelative(p, p, d, pv); }
    }
}

// SHPIX[] SHift point by a PIXel amount
// 0x38
function SHPIX(state) {
    var stack = state.stack;
    var loop = state.loop;
    var fv = state.fv;
    var d = stack.pop() / 0x40;
    var z2 = state.z2;

    while (loop--) {
        var pi = stack.pop();
        var p = z2[pi];

        if (exports.DEBUG) {
            console.log(
                state.step,
                (state.loop > 1 ? 'loop ' + (state.loop - loop) + ': ' : '') +
                'SHPIX[]', pi, d
            );
        }

        fv.setRelative(p, p, d);
        fv.touch(p);
    }

    state.loop = 1;
}

// IP[] Interpolate Point
// 0x39
function IP(state) {
    var stack = state.stack;
    var rp1i = state.rp1;
    var rp2i = state.rp2;
    var loop = state.loop;
    var rp1 = state.z0[rp1i];
    var rp2 = state.z1[rp2i];
    var fv = state.fv;
    var pv = state.dpv;
    var z2 = state.z2;

    while (loop--) {
        var pi = stack.pop();
        var p = z2[pi];

        if (exports.DEBUG) {
            console.log(
                state.step,
                (state.loop > 1 ? 'loop ' + (state.loop - loop) + ': ' : '') +
                'IP[]', pi, rp1i, '<->', rp2i
            );
        }

        fv.interpolate(p, rp1, rp2, pv);

        fv.touch(p);
    }

    state.loop = 1;
}

// MSIRP[a] Move Stack Indirect Relative Point
// 0x3A-0x3B
function MSIRP(a, state) {
    var stack = state.stack;
    var d = stack.pop() / 64;
    var pi = stack.pop();
    var p = state.z1[pi];
    var rp0 = state.z0[state.rp0];
    var fv = state.fv;
    var pv = state.pv;

    fv.setRelative(p, rp0, d, pv);
    fv.touch(p);

    if (exports.DEBUG) { console.log(state.step, 'MSIRP[' + a + ']', d, pi); }

    state.rp1 = state.rp0;
    state.rp2 = pi;
    if (a) { state.rp0 = pi; }
}

// ALIGNRP[] Align to reference point.
// 0x3C
function ALIGNRP(state) {
    var stack = state.stack;
    var rp0i = state.rp0;
    var rp0 = state.z0[rp0i];
    var loop = state.loop;
    var fv = state.fv;
    var pv = state.pv;
    var z1 = state.z1;

    while (loop--) {
        var pi = stack.pop();
        var p = z1[pi];

        if (exports.DEBUG) {
            console.log(
                state.step,
                (state.loop > 1 ? 'loop ' + (state.loop - loop) + ': ' : '') +
                'ALIGNRP[]', pi
            );
        }

        fv.setRelative(p, rp0, 0, pv);
        fv.touch(p);
    }

    state.loop = 1;
}

// RTG[] Round To Double Grid
// 0x3D
function RTDG(state) {
    if (exports.DEBUG) { console.log(state.step, 'RTDG[]'); }

    state.round = roundToDoubleGrid;
}

// MIAP[a] Move Indirect Absolute Point
// 0x3E-0x3F
function MIAP(round, state) {
    var stack = state.stack;
    var n = stack.pop();
    var pi = stack.pop();
    var p = state.z0[pi];
    var fv = state.fv;
    var pv = state.pv;
    var cv = state.cvt[n];

    // TODO cvtcutin should be considered here
    if (round) { cv = state.round(cv); }

    if (exports.DEBUG) {
        console.log(
            state.step,
            'MIAP[' + round + ']',
            n, '(', cv, ')', pi
        );
    }

    fv.setRelative(p, HPZero, cv, pv);

    if (state.zp0 === 0) {
        p.xo = p.x;
        p.yo = p.y;
    }

    fv.touch(p);

    state.rp0 = state.rp1 = pi;
}

// NPUSB[] PUSH N Bytes
// 0x40
function NPUSHB(state) {
    var prog = state.prog;
    var ip = state.ip;
    var stack = state.stack;

    var n = prog[++ip];

    if (exports.DEBUG) { console.log(state.step, 'NPUSHB[]', n); }

    for (var i = 0; i < n; i++) { stack.push(prog[++ip]); }

    state.ip = ip;
}

// NPUSHW[] PUSH N Words
// 0x41
function NPUSHW(state) {
    var ip = state.ip;
    var prog = state.prog;
    var stack = state.stack;
    var n = prog[++ip];

    if (exports.DEBUG) { console.log(state.step, 'NPUSHW[]', n); }

    for (var i = 0; i < n; i++) {
        var w = (prog[++ip] << 8) | prog[++ip];
        if (w & 0x8000) { w = -((w ^ 0xffff) + 1); }
        stack.push(w);
    }

    state.ip = ip;
}

// WS[] Write Store
// 0x42
function WS(state) {
    var stack = state.stack;
    var store = state.store;

    if (!store) { store = state.store = []; }

    var v = stack.pop();
    var l = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'WS', v, l); }

    store[l] = v;
}

// RS[] Read Store
// 0x43
function RS(state) {
    var stack = state.stack;
    var store = state.store;

    var l = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'RS', l); }

    var v = (store && store[l]) || 0;

    stack.push(v);
}

// WCVTP[] Write Control Value Table in Pixel units
// 0x44
function WCVTP(state) {
    var stack = state.stack;

    var v = stack.pop();
    var l = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'WCVTP', v, l); }

    state.cvt[l] = v / 0x40;
}

// RCVT[] Read Control Value Table entry
// 0x45
function RCVT(state) {
    var stack = state.stack;
    var cvte = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'RCVT', cvte); }

    stack.push(state.cvt[cvte] * 0x40);
}

// GC[] Get Coordinate projected onto the projection vector
// 0x46-0x47
function GC(a, state) {
    var stack = state.stack;
    var pi = stack.pop();
    var p = state.z2[pi];

    if (exports.DEBUG) { console.log(state.step, 'GC[' + a + ']', pi); }

    stack.push(state.dpv.distance(p, HPZero, a, false) * 0x40);
}

// MD[a] Measure Distance
// 0x49-0x4A
function MD(a, state) {
    var stack = state.stack;
    var pi2 = stack.pop();
    var pi1 = stack.pop();
    var p2 = state.z1[pi2];
    var p1 = state.z0[pi1];
    var d = state.dpv.distance(p1, p2, a, a);

    if (exports.DEBUG) { console.log(state.step, 'MD[' + a + ']', pi2, pi1, '->', d); }

    state.stack.push(Math.round(d * 64));
}

// MPPEM[] Measure Pixels Per EM
// 0x4B
function MPPEM(state) {
    if (exports.DEBUG) { console.log(state.step, 'MPPEM[]'); }
    state.stack.push(state.ppem);
}

// FLIPON[] set the auto FLIP Boolean to ON
// 0x4D
function FLIPON(state) {
    if (exports.DEBUG) { console.log(state.step, 'FLIPON[]'); }
    state.autoFlip = true;
}

// LT[] Less Than
// 0x50
function LT(state) {
    var stack = state.stack;
    var e2 = stack.pop();
    var e1 = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'LT[]', e2, e1); }

    stack.push(e1 < e2 ? 1 : 0);
}

// LTEQ[] Less Than or EQual
// 0x53
function LTEQ(state) {
    var stack = state.stack;
    var e2 = stack.pop();
    var e1 = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'LTEQ[]', e2, e1); }

    stack.push(e1 <= e2 ? 1 : 0);
}

// GTEQ[] Greater Than
// 0x52
function GT(state) {
    var stack = state.stack;
    var e2 = stack.pop();
    var e1 = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'GT[]', e2, e1); }

    stack.push(e1 > e2 ? 1 : 0);
}

// GTEQ[] Greater Than or EQual
// 0x53
function GTEQ(state) {
    var stack = state.stack;
    var e2 = stack.pop();
    var e1 = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'GTEQ[]', e2, e1); }

    stack.push(e1 >= e2 ? 1 : 0);
}

// EQ[] EQual
// 0x54
function EQ(state) {
    var stack = state.stack;
    var e2 = stack.pop();
    var e1 = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'EQ[]', e2, e1); }

    stack.push(e2 === e1 ? 1 : 0);
}

// NEQ[] Not EQual
// 0x55
function NEQ(state) {
    var stack = state.stack;
    var e2 = stack.pop();
    var e1 = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'NEQ[]', e2, e1); }

    stack.push(e2 !== e1 ? 1 : 0);
}

// ODD[] ODD
// 0x56
function ODD(state) {
    var stack = state.stack;
    var n = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'ODD[]', n); }

    stack.push(Math.trunc(n) % 2 ? 1 : 0);
}

// EVEN[] EVEN
// 0x57
function EVEN(state) {
    var stack = state.stack;
    var n = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'EVEN[]', n); }

    stack.push(Math.trunc(n) % 2 ? 0 : 1);
}

// IF[] IF test
// 0x58
function IF(state) {
    var test = state.stack.pop();
    var ins;

    if (exports.DEBUG) { console.log(state.step, 'IF[]', test); }

    // if test is true it just continues
    // if not the ip is skipped until matching ELSE or EIF
    if (!test) {
        skip(state, true);

        if (exports.DEBUG) { console.log(state.step, ins === 0x1B ? 'ELSE[]' : 'EIF[]'); }
    }
}

// EIF[] End IF
// 0x59
function EIF(state) {
    // this can be reached normally when
    // executing an else branch.
    // -> just ignore it

    if (exports.DEBUG) { console.log(state.step, 'EIF[]'); }
}

// AND[] logical AND
// 0x5A
function AND(state) {
    var stack = state.stack;
    var e2 = stack.pop();
    var e1 = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'AND[]', e2, e1); }

    stack.push(e2 && e1 ? 1 : 0);
}

// OR[] logical OR
// 0x5B
function OR(state) {
    var stack = state.stack;
    var e2 = stack.pop();
    var e1 = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'OR[]', e2, e1); }

    stack.push(e2 || e1 ? 1 : 0);
}

// NOT[] logical NOT
// 0x5C
function NOT(state) {
    var stack = state.stack;
    var e = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'NOT[]', e); }

    stack.push(e ? 0 : 1);
}

// DELTAP1[] DELTA exception P1
// DELTAP2[] DELTA exception P2
// DELTAP3[] DELTA exception P3
// 0x5D, 0x71, 0x72
function DELTAP123(b, state) {
    var stack = state.stack;
    var n = stack.pop();
    var fv = state.fv;
    var pv = state.pv;
    var ppem = state.ppem;
    var base = state.deltaBase + (b - 1) * 16;
    var ds = state.deltaShift;
    var z0 = state.z0;

    if (exports.DEBUG) { console.log(state.step, 'DELTAP[' + b + ']', n, stack); }

    for (var i = 0; i < n; i++)
    {
        var pi = stack.pop();
        var arg = stack.pop();
        var appem = base + ((arg & 0xF0) >> 4);
        if (appem !== ppem) { continue; }

        var mag = (arg & 0x0F) - 8;
        if (mag >= 0) { mag++; }
        if (exports.DEBUG) { console.log(state.step, 'DELTAPFIX', pi, 'by', mag * ds); }

        var p = z0[pi];
        fv.setRelative(p, p, mag * ds, pv);
    }
}

// SDB[] Set Delta Base in the graphics state
// 0x5E
function SDB(state) {
    var stack = state.stack;
    var n = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'SDB[]', n); }

    state.deltaBase = n;
}

// SDS[] Set Delta Shift in the graphics state
// 0x5F
function SDS(state) {
    var stack = state.stack;
    var n = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'SDS[]', n); }

    state.deltaShift = Math.pow(0.5, n);
}

// ADD[] ADD
// 0x60
function ADD(state) {
    var stack = state.stack;
    var n2 = stack.pop();
    var n1 = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'ADD[]', n2, n1); }

    stack.push(n1 + n2);
}

// SUB[] SUB
// 0x61
function SUB(state) {
    var stack = state.stack;
    var n2 = stack.pop();
    var n1 = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'SUB[]', n2, n1); }

    stack.push(n1 - n2);
}

// DIV[] DIV
// 0x62
function DIV(state) {
    var stack = state.stack;
    var n2 = stack.pop();
    var n1 = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'DIV[]', n2, n1); }

    stack.push(n1 * 64 / n2);
}

// MUL[] MUL
// 0x63
function MUL(state) {
    var stack = state.stack;
    var n2 = stack.pop();
    var n1 = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'MUL[]', n2, n1); }

    stack.push(n1 * n2 / 64);
}

// ABS[] ABSolute value
// 0x64
function ABS(state) {
    var stack = state.stack;
    var n = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'ABS[]', n); }

    stack.push(Math.abs(n));
}

// NEG[] NEGate
// 0x65
function NEG(state) {
    var stack = state.stack;
    var n = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'NEG[]', n); }

    stack.push(-n);
}

// FLOOR[] FLOOR
// 0x66
function FLOOR(state) {
    var stack = state.stack;
    var n = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'FLOOR[]', n); }

    stack.push(Math.floor(n / 0x40) * 0x40);
}

// CEILING[] CEILING
// 0x67
function CEILING(state) {
    var stack = state.stack;
    var n = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'CEILING[]', n); }

    stack.push(Math.ceil(n / 0x40) * 0x40);
}

// ROUND[ab] ROUND value
// 0x68-0x6B
function ROUND(dt, state) {
    var stack = state.stack;
    var n = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'ROUND[]'); }

    stack.push(state.round(n / 0x40) * 0x40);
}

// WCVTF[] Write Control Value Table in Funits
// 0x70
function WCVTF(state) {
    var stack = state.stack;
    var v = stack.pop();
    var l = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'WCVTF[]', v, l); }

    state.cvt[l] = v * state.ppem / state.font.unitsPerEm;
}

// DELTAC1[] DELTA exception C1
// DELTAC2[] DELTA exception C2
// DELTAC3[] DELTA exception C3
// 0x73, 0x74, 0x75
function DELTAC123(b, state) {
    var stack = state.stack;
    var n = stack.pop();
    var ppem = state.ppem;
    var base = state.deltaBase + (b - 1) * 16;
    var ds = state.deltaShift;

    if (exports.DEBUG) { console.log(state.step, 'DELTAC[' + b + ']', n, stack); }

    for (var i = 0; i < n; i++) {
        var c = stack.pop();
        var arg = stack.pop();
        var appem = base + ((arg & 0xF0) >> 4);
        if (appem !== ppem) { continue; }

        var mag = (arg & 0x0F) - 8;
        if (mag >= 0) { mag++; }

        var delta = mag * ds;

        if (exports.DEBUG) { console.log(state.step, 'DELTACFIX', c, 'by', delta); }

        state.cvt[c] += delta;
    }
}

// SROUND[] Super ROUND
// 0x76
function SROUND(state) {
    var n = state.stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'SROUND[]', n); }

    state.round = roundSuper;

    var period;

    switch (n & 0xC0) {
        case 0x00:
            period = 0.5;
            break;
        case 0x40:
            period = 1;
            break;
        case 0x80:
            period = 2;
            break;
        default:
            throw new Error('invalid SROUND value');
    }

    state.srPeriod = period;

    switch (n & 0x30) {
        case 0x00:
            state.srPhase = 0;
            break;
        case 0x10:
            state.srPhase = 0.25 * period;
            break;
        case 0x20:
            state.srPhase = 0.5  * period;
            break;
        case 0x30:
            state.srPhase = 0.75 * period;
            break;
        default: throw new Error('invalid SROUND value');
    }

    n &= 0x0F;

    if (n === 0) { state.srThreshold = 0; }
    else { state.srThreshold = (n / 8 - 0.5) * period; }
}

// S45ROUND[] Super ROUND 45 degrees
// 0x77
function S45ROUND(state) {
    var n = state.stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'S45ROUND[]', n); }

    state.round = roundSuper;

    var period;

    switch (n & 0xC0) {
        case 0x00:
            period = Math.sqrt(2) / 2;
            break;
        case 0x40:
            period = Math.sqrt(2);
            break;
        case 0x80:
            period = 2 * Math.sqrt(2);
            break;
        default:
            throw new Error('invalid S45ROUND value');
    }

    state.srPeriod = period;

    switch (n & 0x30) {
        case 0x00:
            state.srPhase = 0;
            break;
        case 0x10:
            state.srPhase = 0.25 * period;
            break;
        case 0x20:
            state.srPhase = 0.5  * period;
            break;
        case 0x30:
            state.srPhase = 0.75 * period;
            break;
        default:
            throw new Error('invalid S45ROUND value');
    }

    n &= 0x0F;

    if (n === 0) { state.srThreshold = 0; }
    else { state.srThreshold = (n / 8 - 0.5) * period; }
}

// ROFF[] Round Off
// 0x7A
function ROFF(state) {
    if (exports.DEBUG) { console.log(state.step, 'ROFF[]'); }

    state.round = roundOff;
}

// RUTG[] Round Up To Grid
// 0x7C
function RUTG(state) {
    if (exports.DEBUG) { console.log(state.step, 'RUTG[]'); }

    state.round = roundUpToGrid;
}

// RDTG[] Round Down To Grid
// 0x7D
function RDTG(state) {
    if (exports.DEBUG) { console.log(state.step, 'RDTG[]'); }

    state.round = roundDownToGrid;
}

// SCANCTRL[] SCAN conversion ConTRoL
// 0x85
function SCANCTRL(state) {
    var n = state.stack.pop();

    // ignored by opentype.js

    if (exports.DEBUG) { console.log(state.step, 'SCANCTRL[]', n); }
}

// SDPVTL[a] Set Dual Projection Vector To Line
// 0x86-0x87
function SDPVTL(a, state) {
    var stack = state.stack;
    var p2i = stack.pop();
    var p1i = stack.pop();
    var p2 = state.z2[p2i];
    var p1 = state.z1[p1i];

    if (exports.DEBUG) { console.log('SDPVTL[' + a + ']', p2i, p1i); }

    var dx;
    var dy;

    if (!a) {
        dx = p1.x - p2.x;
        dy = p1.y - p2.y;
    } else {
        dx = p2.y - p1.y;
        dy = p1.x - p2.x;
    }

    state.dpv = getUnitVector(dx, dy);
}

// GETINFO[] GET INFOrmation
// 0x88
function GETINFO(state) {
    var stack = state.stack;
    var sel = stack.pop();
    var r = 0;

    if (exports.DEBUG) { console.log(state.step, 'GETINFO[]', sel); }

    // v35 as in no subpixel hinting
    if (sel & 0x01) { r = 35; }

    // TODO rotation and stretch currently not supported
    // and thus those GETINFO are always 0.

    // opentype.js is always gray scaling
    if (sel & 0x20) { r |= 0x1000; }

    stack.push(r);
}

// ROLL[] ROLL the top three stack elements
// 0x8A
function ROLL(state) {
    var stack = state.stack;
    var a = stack.pop();
    var b = stack.pop();
    var c = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'ROLL[]'); }

    stack.push(b);
    stack.push(a);
    stack.push(c);
}

// MAX[] MAXimum of top two stack elements
// 0x8B
function MAX(state) {
    var stack = state.stack;
    var e2 = stack.pop();
    var e1 = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'MAX[]', e2, e1); }

    stack.push(Math.max(e1, e2));
}

// MIN[] MINimum of top two stack elements
// 0x8C
function MIN(state) {
    var stack = state.stack;
    var e2 = stack.pop();
    var e1 = stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'MIN[]', e2, e1); }

    stack.push(Math.min(e1, e2));
}

// SCANTYPE[] SCANTYPE
// 0x8D
function SCANTYPE(state) {
    var n = state.stack.pop();
    // ignored by opentype.js
    if (exports.DEBUG) { console.log(state.step, 'SCANTYPE[]', n); }
}

// INSTCTRL[] INSTCTRL
// 0x8D
function INSTCTRL(state) {
    var s = state.stack.pop();
    var v = state.stack.pop();

    if (exports.DEBUG) { console.log(state.step, 'INSTCTRL[]', s, v); }

    switch (s) {
        case 1 : state.inhibitGridFit = !!v; return;
        case 2 : state.ignoreCvt = !!v; return;
        default: throw new Error('invalid INSTCTRL[] selector');
    }
}

// PUSHB[abc] PUSH Bytes
// 0xB0-0xB7
function PUSHB(n, state) {
    var stack = state.stack;
    var prog = state.prog;
    var ip = state.ip;

    if (exports.DEBUG) { console.log(state.step, 'PUSHB[' + n + ']'); }

    for (var i = 0; i < n; i++) { stack.push(prog[++ip]); }

    state.ip = ip;
}

// PUSHW[abc] PUSH Words
// 0xB8-0xBF
function PUSHW(n, state) {
    var ip = state.ip;
    var prog = state.prog;
    var stack = state.stack;

    if (exports.DEBUG) { console.log(state.ip, 'PUSHW[' + n + ']'); }

    for (var i = 0; i < n; i++) {
        var w = (prog[++ip] << 8) | prog[++ip];
        if (w & 0x8000) { w = -((w ^ 0xffff) + 1); }
        stack.push(w);
    }

    state.ip = ip;
}

// MDRP[abcde] Move Direct Relative Point
// 0xD0-0xEF
// (if indirect is 0)
//
// and
//
// MIRP[abcde] Move Indirect Relative Point
// 0xE0-0xFF
// (if indirect is 1)

function MDRP_MIRP(indirect, setRp0, keepD, ro, dt, state) {
    var stack = state.stack;
    var cvte = indirect && stack.pop();
    var pi = stack.pop();
    var rp0i = state.rp0;
    var rp = state.z0[rp0i];
    var p = state.z1[pi];

    var md = state.minDis;
    var fv = state.fv;
    var pv = state.dpv;
    var od; // original distance
    var d; // moving distance
    var sign; // sign of distance
    var cv;

    d = od = pv.distance(p, rp, true, true);
    sign = d >= 0 ? 1 : -1; // Math.sign would be 0 in case of 0

    // TODO consider autoFlip
    d = Math.abs(d);

    if (indirect) {
        cv = state.cvt[cvte];

        if (ro && Math.abs(d - cv) < state.cvCutIn) { d = cv; }
    }

    if (keepD && d < md) { d = md; }

    if (ro) { d = state.round(d); }

    fv.setRelative(p, rp, sign * d, pv);
    fv.touch(p);

    if (exports.DEBUG) {
        console.log(
            state.step,
            (indirect ? 'MIRP[' : 'MDRP[') +
            (setRp0 ? 'M' : 'm') +
            (keepD ? '>' : '_') +
            (ro ? 'R' : '_') +
            (dt === 0 ? 'Gr' : (dt === 1 ? 'Bl' : (dt === 2 ? 'Wh' : ''))) +
            ']',
            indirect ?
                cvte + '(' + state.cvt[cvte] + ',' +  cv + ')' :
                '',
            pi,
            '(d =', od, '->', sign * d, ')'
        );
    }

    state.rp1 = state.rp0;
    state.rp2 = pi;
    if (setRp0) { state.rp0 = pi; }
}

/*
* The instruction table.
*/
instructionTable = [
    /* 0x00 */ SVTCA.bind(undefined, yUnitVector),
    /* 0x01 */ SVTCA.bind(undefined, xUnitVector),
    /* 0x02 */ SPVTCA.bind(undefined, yUnitVector),
    /* 0x03 */ SPVTCA.bind(undefined, xUnitVector),
    /* 0x04 */ SFVTCA.bind(undefined, yUnitVector),
    /* 0x05 */ SFVTCA.bind(undefined, xUnitVector),
    /* 0x06 */ SPVTL.bind(undefined, 0),
    /* 0x07 */ SPVTL.bind(undefined, 1),
    /* 0x08 */ SFVTL.bind(undefined, 0),
    /* 0x09 */ SFVTL.bind(undefined, 1),
    /* 0x0A */ SPVFS,
    /* 0x0B */ SFVFS,
    /* 0x0C */ GPV,
    /* 0x0D */ GFV,
    /* 0x0E */ SFVTPV,
    /* 0x0F */ ISECT,
    /* 0x10 */ SRP0,
    /* 0x11 */ SRP1,
    /* 0x12 */ SRP2,
    /* 0x13 */ SZP0,
    /* 0x14 */ SZP1,
    /* 0x15 */ SZP2,
    /* 0x16 */ SZPS,
    /* 0x17 */ SLOOP,
    /* 0x18 */ RTG,
    /* 0x19 */ RTHG,
    /* 0x1A */ SMD,
    /* 0x1B */ ELSE,
    /* 0x1C */ JMPR,
    /* 0x1D */ SCVTCI,
    /* 0x1E */ undefined,   // TODO SSWCI
    /* 0x1F */ undefined,   // TODO SSW
    /* 0x20 */ DUP,
    /* 0x21 */ POP,
    /* 0x22 */ CLEAR,
    /* 0x23 */ SWAP,
    /* 0x24 */ DEPTH,
    /* 0x25 */ CINDEX,
    /* 0x26 */ MINDEX,
    /* 0x27 */ undefined,   // TODO ALIGNPTS
    /* 0x28 */ undefined,
    /* 0x29 */ undefined,   // TODO UTP
    /* 0x2A */ LOOPCALL,
    /* 0x2B */ CALL,
    /* 0x2C */ FDEF,
    /* 0x2D */ undefined,   // ENDF (eaten by FDEF)
    /* 0x2E */ MDAP.bind(undefined, 0),
    /* 0x2F */ MDAP.bind(undefined, 1),
    /* 0x30 */ IUP.bind(undefined, yUnitVector),
    /* 0x31 */ IUP.bind(undefined, xUnitVector),
    /* 0x32 */ SHP.bind(undefined, 0),
    /* 0x33 */ SHP.bind(undefined, 1),
    /* 0x34 */ SHC.bind(undefined, 0),
    /* 0x35 */ SHC.bind(undefined, 1),
    /* 0x36 */ SHZ.bind(undefined, 0),
    /* 0x37 */ SHZ.bind(undefined, 1),
    /* 0x38 */ SHPIX,
    /* 0x39 */ IP,
    /* 0x3A */ MSIRP.bind(undefined, 0),
    /* 0x3B */ MSIRP.bind(undefined, 1),
    /* 0x3C */ ALIGNRP,
    /* 0x3D */ RTDG,
    /* 0x3E */ MIAP.bind(undefined, 0),
    /* 0x3F */ MIAP.bind(undefined, 1),
    /* 0x40 */ NPUSHB,
    /* 0x41 */ NPUSHW,
    /* 0x42 */ WS,
    /* 0x43 */ RS,
    /* 0x44 */ WCVTP,
    /* 0x45 */ RCVT,
    /* 0x46 */ GC.bind(undefined, 0),
    /* 0x47 */ GC.bind(undefined, 1),
    /* 0x48 */ undefined,   // TODO SCFS
    /* 0x49 */ MD.bind(undefined, 0),
    /* 0x4A */ MD.bind(undefined, 1),
    /* 0x4B */ MPPEM,
    /* 0x4C */ undefined,   // TODO MPS
    /* 0x4D */ FLIPON,
    /* 0x4E */ undefined,   // TODO FLIPOFF
    /* 0x4F */ undefined,   // TODO DEBUG
    /* 0x50 */ LT,
    /* 0x51 */ LTEQ,
    /* 0x52 */ GT,
    /* 0x53 */ GTEQ,
    /* 0x54 */ EQ,
    /* 0x55 */ NEQ,
    /* 0x56 */ ODD,
    /* 0x57 */ EVEN,
    /* 0x58 */ IF,
    /* 0x59 */ EIF,
    /* 0x5A */ AND,
    /* 0x5B */ OR,
    /* 0x5C */ NOT,
    /* 0x5D */ DELTAP123.bind(undefined, 1),
    /* 0x5E */ SDB,
    /* 0x5F */ SDS,
    /* 0x60 */ ADD,
    /* 0x61 */ SUB,
    /* 0x62 */ DIV,
    /* 0x63 */ MUL,
    /* 0x64 */ ABS,
    /* 0x65 */ NEG,
    /* 0x66 */ FLOOR,
    /* 0x67 */ CEILING,
    /* 0x68 */ ROUND.bind(undefined, 0),
    /* 0x69 */ ROUND.bind(undefined, 1),
    /* 0x6A */ ROUND.bind(undefined, 2),
    /* 0x6B */ ROUND.bind(undefined, 3),
    /* 0x6C */ undefined,   // TODO NROUND[ab]
    /* 0x6D */ undefined,   // TODO NROUND[ab]
    /* 0x6E */ undefined,   // TODO NROUND[ab]
    /* 0x6F */ undefined,   // TODO NROUND[ab]
    /* 0x70 */ WCVTF,
    /* 0x71 */ DELTAP123.bind(undefined, 2),
    /* 0x72 */ DELTAP123.bind(undefined, 3),
    /* 0x73 */ DELTAC123.bind(undefined, 1),
    /* 0x74 */ DELTAC123.bind(undefined, 2),
    /* 0x75 */ DELTAC123.bind(undefined, 3),
    /* 0x76 */ SROUND,
    /* 0x77 */ S45ROUND,
    /* 0x78 */ undefined,   // TODO JROT[]
    /* 0x79 */ undefined,   // TODO JROF[]
    /* 0x7A */ ROFF,
    /* 0x7B */ undefined,
    /* 0x7C */ RUTG,
    /* 0x7D */ RDTG,
    /* 0x7E */ POP, // actually SANGW, supposed to do only a pop though
    /* 0x7F */ POP, // actually AA, supposed to do only a pop though
    /* 0x80 */ undefined,   // TODO FLIPPT
    /* 0x81 */ undefined,   // TODO FLIPRGON
    /* 0x82 */ undefined,   // TODO FLIPRGOFF
    /* 0x83 */ undefined,
    /* 0x84 */ undefined,
    /* 0x85 */ SCANCTRL,
    /* 0x86 */ SDPVTL.bind(undefined, 0),
    /* 0x87 */ SDPVTL.bind(undefined, 1),
    /* 0x88 */ GETINFO,
    /* 0x89 */ undefined,   // TODO IDEF
    /* 0x8A */ ROLL,
    /* 0x8B */ MAX,
    /* 0x8C */ MIN,
    /* 0x8D */ SCANTYPE,
    /* 0x8E */ INSTCTRL,
    /* 0x8F */ undefined,
    /* 0x90 */ undefined,
    /* 0x91 */ undefined,
    /* 0x92 */ undefined,
    /* 0x93 */ undefined,
    /* 0x94 */ undefined,
    /* 0x95 */ undefined,
    /* 0x96 */ undefined,
    /* 0x97 */ undefined,
    /* 0x98 */ undefined,
    /* 0x99 */ undefined,
    /* 0x9A */ undefined,
    /* 0x9B */ undefined,
    /* 0x9C */ undefined,
    /* 0x9D */ undefined,
    /* 0x9E */ undefined,
    /* 0x9F */ undefined,
    /* 0xA0 */ undefined,
    /* 0xA1 */ undefined,
    /* 0xA2 */ undefined,
    /* 0xA3 */ undefined,
    /* 0xA4 */ undefined,
    /* 0xA5 */ undefined,
    /* 0xA6 */ undefined,
    /* 0xA7 */ undefined,
    /* 0xA8 */ undefined,
    /* 0xA9 */ undefined,
    /* 0xAA */ undefined,
    /* 0xAB */ undefined,
    /* 0xAC */ undefined,
    /* 0xAD */ undefined,
    /* 0xAE */ undefined,
    /* 0xAF */ undefined,
    /* 0xB0 */ PUSHB.bind(undefined, 1),
    /* 0xB1 */ PUSHB.bind(undefined, 2),
    /* 0xB2 */ PUSHB.bind(undefined, 3),
    /* 0xB3 */ PUSHB.bind(undefined, 4),
    /* 0xB4 */ PUSHB.bind(undefined, 5),
    /* 0xB5 */ PUSHB.bind(undefined, 6),
    /* 0xB6 */ PUSHB.bind(undefined, 7),
    /* 0xB7 */ PUSHB.bind(undefined, 8),
    /* 0xB8 */ PUSHW.bind(undefined, 1),
    /* 0xB9 */ PUSHW.bind(undefined, 2),
    /* 0xBA */ PUSHW.bind(undefined, 3),
    /* 0xBB */ PUSHW.bind(undefined, 4),
    /* 0xBC */ PUSHW.bind(undefined, 5),
    /* 0xBD */ PUSHW.bind(undefined, 6),
    /* 0xBE */ PUSHW.bind(undefined, 7),
    /* 0xBF */ PUSHW.bind(undefined, 8),
    /* 0xC0 */ MDRP_MIRP.bind(undefined, 0, 0, 0, 0, 0),
    /* 0xC1 */ MDRP_MIRP.bind(undefined, 0, 0, 0, 0, 1),
    /* 0xC2 */ MDRP_MIRP.bind(undefined, 0, 0, 0, 0, 2),
    /* 0xC3 */ MDRP_MIRP.bind(undefined, 0, 0, 0, 0, 3),
    /* 0xC4 */ MDRP_MIRP.bind(undefined, 0, 0, 0, 1, 0),
    /* 0xC5 */ MDRP_MIRP.bind(undefined, 0, 0, 0, 1, 1),
    /* 0xC6 */ MDRP_MIRP.bind(undefined, 0, 0, 0, 1, 2),
    /* 0xC7 */ MDRP_MIRP.bind(undefined, 0, 0, 0, 1, 3),
    /* 0xC8 */ MDRP_MIRP.bind(undefined, 0, 0, 1, 0, 0),
    /* 0xC9 */ MDRP_MIRP.bind(undefined, 0, 0, 1, 0, 1),
    /* 0xCA */ MDRP_MIRP.bind(undefined, 0, 0, 1, 0, 2),
    /* 0xCB */ MDRP_MIRP.bind(undefined, 0, 0, 1, 0, 3),
    /* 0xCC */ MDRP_MIRP.bind(undefined, 0, 0, 1, 1, 0),
    /* 0xCD */ MDRP_MIRP.bind(undefined, 0, 0, 1, 1, 1),
    /* 0xCE */ MDRP_MIRP.bind(undefined, 0, 0, 1, 1, 2),
    /* 0xCF */ MDRP_MIRP.bind(undefined, 0, 0, 1, 1, 3),
    /* 0xD0 */ MDRP_MIRP.bind(undefined, 0, 1, 0, 0, 0),
    /* 0xD1 */ MDRP_MIRP.bind(undefined, 0, 1, 0, 0, 1),
    /* 0xD2 */ MDRP_MIRP.bind(undefined, 0, 1, 0, 0, 2),
    /* 0xD3 */ MDRP_MIRP.bind(undefined, 0, 1, 0, 0, 3),
    /* 0xD4 */ MDRP_MIRP.bind(undefined, 0, 1, 0, 1, 0),
    /* 0xD5 */ MDRP_MIRP.bind(undefined, 0, 1, 0, 1, 1),
    /* 0xD6 */ MDRP_MIRP.bind(undefined, 0, 1, 0, 1, 2),
    /* 0xD7 */ MDRP_MIRP.bind(undefined, 0, 1, 0, 1, 3),
    /* 0xD8 */ MDRP_MIRP.bind(undefined, 0, 1, 1, 0, 0),
    /* 0xD9 */ MDRP_MIRP.bind(undefined, 0, 1, 1, 0, 1),
    /* 0xDA */ MDRP_MIRP.bind(undefined, 0, 1, 1, 0, 2),
    /* 0xDB */ MDRP_MIRP.bind(undefined, 0, 1, 1, 0, 3),
    /* 0xDC */ MDRP_MIRP.bind(undefined, 0, 1, 1, 1, 0),
    /* 0xDD */ MDRP_MIRP.bind(undefined, 0, 1, 1, 1, 1),
    /* 0xDE */ MDRP_MIRP.bind(undefined, 0, 1, 1, 1, 2),
    /* 0xDF */ MDRP_MIRP.bind(undefined, 0, 1, 1, 1, 3),
    /* 0xE0 */ MDRP_MIRP.bind(undefined, 1, 0, 0, 0, 0),
    /* 0xE1 */ MDRP_MIRP.bind(undefined, 1, 0, 0, 0, 1),
    /* 0xE2 */ MDRP_MIRP.bind(undefined, 1, 0, 0, 0, 2),
    /* 0xE3 */ MDRP_MIRP.bind(undefined, 1, 0, 0, 0, 3),
    /* 0xE4 */ MDRP_MIRP.bind(undefined, 1, 0, 0, 1, 0),
    /* 0xE5 */ MDRP_MIRP.bind(undefined, 1, 0, 0, 1, 1),
    /* 0xE6 */ MDRP_MIRP.bind(undefined, 1, 0, 0, 1, 2),
    /* 0xE7 */ MDRP_MIRP.bind(undefined, 1, 0, 0, 1, 3),
    /* 0xE8 */ MDRP_MIRP.bind(undefined, 1, 0, 1, 0, 0),
    /* 0xE9 */ MDRP_MIRP.bind(undefined, 1, 0, 1, 0, 1),
    /* 0xEA */ MDRP_MIRP.bind(undefined, 1, 0, 1, 0, 2),
    /* 0xEB */ MDRP_MIRP.bind(undefined, 1, 0, 1, 0, 3),
    /* 0xEC */ MDRP_MIRP.bind(undefined, 1, 0, 1, 1, 0),
    /* 0xED */ MDRP_MIRP.bind(undefined, 1, 0, 1, 1, 1),
    /* 0xEE */ MDRP_MIRP.bind(undefined, 1, 0, 1, 1, 2),
    /* 0xEF */ MDRP_MIRP.bind(undefined, 1, 0, 1, 1, 3),
    /* 0xF0 */ MDRP_MIRP.bind(undefined, 1, 1, 0, 0, 0),
    /* 0xF1 */ MDRP_MIRP.bind(undefined, 1, 1, 0, 0, 1),
    /* 0xF2 */ MDRP_MIRP.bind(undefined, 1, 1, 0, 0, 2),
    /* 0xF3 */ MDRP_MIRP.bind(undefined, 1, 1, 0, 0, 3),
    /* 0xF4 */ MDRP_MIRP.bind(undefined, 1, 1, 0, 1, 0),
    /* 0xF5 */ MDRP_MIRP.bind(undefined, 1, 1, 0, 1, 1),
    /* 0xF6 */ MDRP_MIRP.bind(undefined, 1, 1, 0, 1, 2),
    /* 0xF7 */ MDRP_MIRP.bind(undefined, 1, 1, 0, 1, 3),
    /* 0xF8 */ MDRP_MIRP.bind(undefined, 1, 1, 1, 0, 0),
    /* 0xF9 */ MDRP_MIRP.bind(undefined, 1, 1, 1, 0, 1),
    /* 0xFA */ MDRP_MIRP.bind(undefined, 1, 1, 1, 0, 2),
    /* 0xFB */ MDRP_MIRP.bind(undefined, 1, 1, 1, 0, 3),
    /* 0xFC */ MDRP_MIRP.bind(undefined, 1, 1, 1, 1, 0),
    /* 0xFD */ MDRP_MIRP.bind(undefined, 1, 1, 1, 1, 1),
    /* 0xFE */ MDRP_MIRP.bind(undefined, 1, 1, 1, 1, 2),
    /* 0xFF */ MDRP_MIRP.bind(undefined, 1, 1, 1, 1, 3)
];



/*****************************
  Mathematical Considerations
******************************

fv ... refers to freedom vector
pv ... refers to projection vector
rp ... refers to reference point
p  ... refers to to point being operated on
d  ... refers to distance

SETRELATIVE:
============

case freedom vector == x-axis:
------------------------------

                        (pv)
                     .-'
              rpd .-'
               .-*
          d .-'90°'
         .-'       '
      .-'           '
   *-'               ' b
  rp                  '
                       '
                        '
            p *----------*-------------- (fv)
                          pm

  rpdx = rpx + d * pv.x
  rpdy = rpy + d * pv.y

  equation of line b

   y - rpdy = pvns * (x- rpdx)

   y = p.y

   x = rpdx + ( p.y - rpdy ) / pvns


case freedom vector == y-axis:
------------------------------

    * pm
    |\
    | \
    |  \
    |   \
    |    \
    |     \
    |      \
    |       \
    |        \
    |         \ b
    |          \
    |           \
    |            \    .-' (pv)
    |         90° \.-'
    |           .-'* rpd
    |        .-'
    *     *-'  d
    p     rp

  rpdx = rpx + d * pv.x
  rpdy = rpy + d * pv.y

  equation of line b:
           pvns ... normal slope to pv

   y - rpdy = pvns * (x - rpdx)

   x = p.x

   y = rpdy +  pvns * (p.x - rpdx)



generic case:
-------------


                              .'(fv)
                            .'
                          .* pm
                        .' !
                      .'    .
                    .'      !
                  .'         . b
                .'           !
               *              .
              p               !
                         90°   .    ... (pv)
                           ...-*-'''
                  ...---'''    rpd
         ...---'''   d
   *--'''
  rp

    rpdx = rpx + d * pv.x
    rpdy = rpy + d * pv.y

 equation of line b:
    pvns... normal slope to pv

    y - rpdy = pvns * (x - rpdx)

 equation of freedom vector line:
    fvs ... slope of freedom vector (=fy/fx)

    y - py = fvs * (x - px)


  on pm both equations are true for same x/y

    y - rpdy = pvns * (x - rpdx)

    y - py = fvs * (x - px)

  form to y and set equal:

    pvns * (x - rpdx) + rpdy = fvs * (x - px) + py

  expand:

    pvns * x - pvns * rpdx + rpdy = fvs * x - fvs * px + py

  switch:

    fvs * x - fvs * px + py = pvns * x - pvns * rpdx + rpdy

  solve for x:

    fvs * x - pvns * x = fvs * px - pvns * rpdx - py + rpdy



          fvs * px - pvns * rpdx + rpdy - py
    x =  -----------------------------------
                 fvs - pvns

  and:

    y = fvs * (x - px) + py



INTERPOLATE:
============

Examples of point interpolation.

The weight of the movement of the reference point gets bigger
the further the other reference point is away, thus the safest
option (that is avoiding 0/0 divisions) is to weight the
original distance of the other point by the sum of both distances.

If the sum of both distances is 0, then move the point by the
arithmetic average of the movement of both reference points.




           (+6)
    rp1o *---->*rp1
         .     .                          (+12)
         .     .                  rp2o *---------->* rp2
         .     .                       .           .
         .     .                       .           .
         .    10          20           .           .
         |.........|...................|           .
               .   .                               .
               .   . (+8)                          .
                po *------>*p                      .
               .           .                       .
               .    12     .          24           .
               |...........|.......................|
                                  36


-------



           (+10)
    rp1o *-------->*rp1
         .         .                      (-10)
         .         .              rp2 *<---------* rpo2
         .         .                   .         .
         .         .                   .         .
         .    10   .          30       .         .
         |.........|.............................|
                   .                   .
                   . (+5)              .
                po *--->* p            .
                   .    .              .
                   .    .   20         .
                   |....|..............|
                     5        15


-------


           (+10)
    rp1o *-------->*rp1
         .         .
         .         .
    rp2o *-------->*rp2


                               (+10)
                          po *-------->* p

-------


           (+10)
    rp1o *-------->*rp1
         .         .
         .         .(+30)
    rp2o *---------------------------->*rp2


                                        (+25)
                          po *----------------------->* p



vim: set ts=4 sw=4 expandtab:
*****/

// The Font object

/**
 * @typedef FontOptions
 * @type Object
 * @property {Boolean} empty - whether to create a new empty font
 * @property {string} familyName
 * @property {string} styleName
 * @property {string=} fullName
 * @property {string=} postScriptName
 * @property {string=} designer
 * @property {string=} designerURL
 * @property {string=} manufacturer
 * @property {string=} manufacturerURL
 * @property {string=} license
 * @property {string=} licenseURL
 * @property {string=} version
 * @property {string=} description
 * @property {string=} copyright
 * @property {string=} trademark
 * @property {Number} unitsPerEm
 * @property {Number} ascender
 * @property {Number} descender
 * @property {Number} createdTimestamp
 * @property {string=} weightClass
 * @property {string=} widthClass
 * @property {string=} fsSelection
 */

/**
 * A Font represents a loaded OpenType font file.
 * It contains a set of glyphs and methods to draw text on a drawing context,
 * or to get a path representing the text.
 * @exports opentype.Font
 * @class
 * @param {FontOptions}
 * @constructor
 */
function Font(options) {
    options = options || {};

    if (!options.empty) {
        // Check that we've provided the minimum set of names.
        checkArgument(options.familyName, 'When creating a new Font object, familyName is required.');
        checkArgument(options.styleName, 'When creating a new Font object, styleName is required.');
        checkArgument(options.unitsPerEm, 'When creating a new Font object, unitsPerEm is required.');
        checkArgument(options.ascender, 'When creating a new Font object, ascender is required.');
        checkArgument(options.descender, 'When creating a new Font object, descender is required.');
        checkArgument(options.descender < 0, 'Descender should be negative (e.g. -512).');

        // OS X will complain if the names are empty, so we put a single space everywhere by default.
        this.names = {
            fontFamily: {en: options.familyName || ' '},
            fontSubfamily: {en: options.styleName || ' '},
            fullName: {en: options.fullName || options.familyName + ' ' + options.styleName},
            postScriptName: {en: options.postScriptName || options.familyName + options.styleName},
            designer: {en: options.designer || ' '},
            designerURL: {en: options.designerURL || ' '},
            manufacturer: {en: options.manufacturer || ' '},
            manufacturerURL: {en: options.manufacturerURL || ' '},
            license: {en: options.license || ' '},
            licenseURL: {en: options.licenseURL || ' '},
            version: {en: options.version || 'Version 0.1'},
            description: {en: options.description || ' '},
            copyright: {en: options.copyright || ' '},
            trademark: {en: options.trademark || ' '}
        };
        this.unitsPerEm = options.unitsPerEm || 1000;
        this.ascender = options.ascender;
        this.descender = options.descender;
        this.createdTimestamp = options.createdTimestamp;
        this.tables = { os2: {
            usWeightClass: options.weightClass || this.usWeightClasses.MEDIUM,
            usWidthClass: options.widthClass || this.usWidthClasses.MEDIUM,
            fsSelection: options.fsSelection || this.fsSelectionValues.REGULAR
        } };
    }

    this.supported = true; // Deprecated: parseBuffer will throw an error if font is not supported.
    this.glyphs = new glyphset.GlyphSet(this, options.glyphs || []);
    this.encoding = new DefaultEncoding(this);
    this.substitution = new Substitution(this);
    this.tables = this.tables || {};

    Object.defineProperty(this, 'hinting', {
        get: function() {
            if (this._hinting) { return this._hinting; }
            if (this.outlinesFormat === 'truetype') {
                return (this._hinting = new Hinting(this));
            }
        }
    });
}

/**
 * Check if the font has a glyph for the given character.
 * @param  {string}
 * @return {Boolean}
 */
Font.prototype.hasChar = function(c) {
    return this.encoding.charToGlyphIndex(c) !== null;
};

/**
 * Convert the given character to a single glyph index.
 * Note that this function assumes that there is a one-to-one mapping between
 * the given character and a glyph; for complex scripts this might not be the case.
 * @param  {string}
 * @return {Number}
 */
Font.prototype.charToGlyphIndex = function(s) {
    return this.encoding.charToGlyphIndex(s);
};

/**
 * Convert the given character to a single Glyph object.
 * Note that this function assumes that there is a one-to-one mapping between
 * the given character and a glyph; for complex scripts this might not be the case.
 * @param  {string}
 * @return {opentype.Glyph}
 */
Font.prototype.charToGlyph = function(c) {
    var glyphIndex = this.charToGlyphIndex(c);
    var glyph = this.glyphs.get(glyphIndex);
    if (!glyph) {
        // .notdef
        glyph = this.glyphs.get(0);
    }

    return glyph;
};

/**
 * Convert the given text to a list of Glyph objects.
 * Note that there is no strict one-to-one mapping between characters and
 * glyphs, so the list of returned glyphs can be larger or smaller than the
 * length of the given string.
 * @param  {string}
 * @param  {GlyphRenderOptions} [options]
 * @return {opentype.Glyph[]}
 */
Font.prototype.stringToGlyphs = function(s, options) {
    var this$1 = this;

    options = options || this.defaultRenderOptions;
    // Get glyph indexes
    var indexes = [];
    for (var i = 0; i < s.length; i += 1) {
        var c = s[i];
        indexes.push(this$1.charToGlyphIndex(c));
    }
    var length = indexes.length;

    // Apply substitutions on glyph indexes
    if (options.features) {
        var script = options.script || this.substitution.getDefaultScriptName();
        var manyToOne = [];
        if (options.features.liga) { manyToOne = manyToOne.concat(this.substitution.getFeature('liga', script, options.language)); }
        if (options.features.rlig) { manyToOne = manyToOne.concat(this.substitution.getFeature('rlig', script, options.language)); }
        for (var i$1 = 0; i$1 < length; i$1 += 1) {
            for (var j = 0; j < manyToOne.length; j++) {
                var ligature = manyToOne[j];
                var components = ligature.sub;
                var compCount = components.length;
                var k = 0;
                while (k < compCount && components[k] === indexes[i$1 + k]) { k++; }
                if (k === compCount) {
                    indexes.splice(i$1, compCount, ligature.by);
                    length = length - compCount + 1;
                }
            }
        }
    }

    // convert glyph indexes to glyph objects
    var glyphs = new Array(length);
    var notdef = this.glyphs.get(0);
    for (var i$2 = 0; i$2 < length; i$2 += 1) {
        glyphs[i$2] = this$1.glyphs.get(indexes[i$2]) || notdef;
    }
    return glyphs;
};

/**
 * @param  {string}
 * @return {Number}
 */
Font.prototype.nameToGlyphIndex = function(name) {
    return this.glyphNames.nameToGlyphIndex(name);
};

/**
 * @param  {string}
 * @return {opentype.Glyph}
 */
Font.prototype.nameToGlyph = function(name) {
    var glyphIndex = this.nameToGlyphIndex(name);
    var glyph = this.glyphs.get(glyphIndex);
    if (!glyph) {
        // .notdef
        glyph = this.glyphs.get(0);
    }

    return glyph;
};

/**
 * @param  {Number}
 * @return {String}
 */
Font.prototype.glyphIndexToName = function(gid) {
    if (!this.glyphNames.glyphIndexToName) {
        return '';
    }

    return this.glyphNames.glyphIndexToName(gid);
};

/**
 * Retrieve the value of the kerning pair between the left glyph (or its index)
 * and the right glyph (or its index). If no kerning pair is found, return 0.
 * The kerning value gets added to the advance width when calculating the spacing
 * between glyphs.
 * @param  {opentype.Glyph} leftGlyph
 * @param  {opentype.Glyph} rightGlyph
 * @return {Number}
 */
Font.prototype.getKerningValue = function(leftGlyph, rightGlyph) {
    leftGlyph = leftGlyph.index || leftGlyph;
    rightGlyph = rightGlyph.index || rightGlyph;
    var gposKerning = this.getGposKerningValue;
    return gposKerning ? gposKerning(leftGlyph, rightGlyph) :
        (this.kerningPairs[leftGlyph + ',' + rightGlyph] || 0);
};

/**
 * @typedef GlyphRenderOptions
 * @type Object
 * @property {string} [script] - script used to determine which features to apply. By default, 'DFLT' or 'latn' is used.
 *                               See https://www.microsoft.com/typography/otspec/scripttags.htm
 * @property {string} [language='dflt'] - language system used to determine which features to apply.
 *                                        See https://www.microsoft.com/typography/developers/opentype/languagetags.aspx
 * @property {boolean} [kerning=true] - whether to include kerning values
 * @property {object} [features] - OpenType Layout feature tags. Used to enable or disable the features of the given script/language system.
 *                                 See https://www.microsoft.com/typography/otspec/featuretags.htm
 */
Font.prototype.defaultRenderOptions = {
    kerning: true,
    features: {
        liga: true,
        rlig: true
    }
};

/**
 * Helper function that invokes the given callback for each glyph in the given text.
 * The callback gets `(glyph, x, y, fontSize, options)`.* @param  {string} text
 * @param {string} text - The text to apply.
 * @param  {number} [x=0] - Horizontal position of the beginning of the text.
 * @param  {number} [y=0] - Vertical position of the *baseline* of the text.
 * @param  {number} [fontSize=72] - Font size in pixels. We scale the glyph units by `1 / unitsPerEm * fontSize`.
 * @param  {GlyphRenderOptions=} options
 * @param  {Function} callback
 */
Font.prototype.forEachGlyph = function(text, x, y, fontSize, options, callback) {
    var this$1 = this;

    x = x !== undefined ? x : 0;
    y = y !== undefined ? y : 0;
    fontSize = fontSize !== undefined ? fontSize : 72;
    options = options || this.defaultRenderOptions;
    var fontScale = 1 / this.unitsPerEm * fontSize;
    var glyphs = this.stringToGlyphs(text, options);
    for (var i = 0; i < glyphs.length; i += 1) {
        var glyph = glyphs[i];
        callback.call(this$1, glyph, x, y, fontSize, options);
        if (glyph.advanceWidth) {
            x += glyph.advanceWidth * fontScale;
        }

        if (options.kerning && i < glyphs.length - 1) {
            var kerningValue = this$1.getKerningValue(glyph, glyphs[i + 1]);
            x += kerningValue * fontScale;
        }

        if (options.letterSpacing) {
            x += options.letterSpacing * fontSize;
        } else if (options.tracking) {
            x += (options.tracking / 1000) * fontSize;
        }
    }
    return x;
};

/**
 * Create a Path object that represents the given text.
 * @param  {string} text - The text to create.
 * @param  {number} [x=0] - Horizontal position of the beginning of the text.
 * @param  {number} [y=0] - Vertical position of the *baseline* of the text.
 * @param  {number} [fontSize=72] - Font size in pixels. We scale the glyph units by `1 / unitsPerEm * fontSize`.
 * @param  {GlyphRenderOptions=} options
 * @return {opentype.Path}
 */
Font.prototype.getPath = function(text, x, y, fontSize, options) {
    var fullPath = new Path();
    this.forEachGlyph(text, x, y, fontSize, options, function(glyph, gX, gY, gFontSize) {
        var glyphPath = glyph.getPath(gX, gY, gFontSize, options, this);
        fullPath.extend(glyphPath);
    });
    return fullPath;
};

/**
 * Create an array of Path objects that represent the glyphs of a given text.
 * @param  {string} text - The text to create.
 * @param  {number} [x=0] - Horizontal position of the beginning of the text.
 * @param  {number} [y=0] - Vertical position of the *baseline* of the text.
 * @param  {number} [fontSize=72] - Font size in pixels. We scale the glyph units by `1 / unitsPerEm * fontSize`.
 * @param  {GlyphRenderOptions=} options
 * @return {opentype.Path[]}
 */
Font.prototype.getPaths = function(text, x, y, fontSize, options) {
    var glyphPaths = [];
    this.forEachGlyph(text, x, y, fontSize, options, function(glyph, gX, gY, gFontSize) {
        var glyphPath = glyph.getPath(gX, gY, gFontSize, options, this);
        glyphPaths.push(glyphPath);
    });

    return glyphPaths;
};

/**
 * Returns the advance width of a text.
 *
 * This is something different than Path.getBoundingBox() as for example a
 * suffixed whitespace increases the advanceWidth but not the bounding box
 * or an overhanging letter like a calligraphic 'f' might have a quite larger
 * bounding box than its advance width.
 *
 * This corresponds to canvas2dContext.measureText(text).width
 *
 * @param  {string} text - The text to create.
 * @param  {number} [fontSize=72] - Font size in pixels. We scale the glyph units by `1 / unitsPerEm * fontSize`.
 * @param  {GlyphRenderOptions=} options
 * @return advance width
 */
Font.prototype.getAdvanceWidth = function(text, fontSize, options) {
    return this.forEachGlyph(text, 0, 0, fontSize, options, function() {});
};

/**
 * Draw the text on the given drawing context.
 * @param  {CanvasRenderingContext2D} ctx - A 2D drawing context, like Canvas.
 * @param  {string} text - The text to create.
 * @param  {number} [x=0] - Horizontal position of the beginning of the text.
 * @param  {number} [y=0] - Vertical position of the *baseline* of the text.
 * @param  {number} [fontSize=72] - Font size in pixels. We scale the glyph units by `1 / unitsPerEm * fontSize`.
 * @param  {GlyphRenderOptions=} options
 */
Font.prototype.draw = function(ctx, text, x, y, fontSize, options) {
    this.getPath(text, x, y, fontSize, options).draw(ctx);
};

/**
 * Draw the points of all glyphs in the text.
 * On-curve points will be drawn in blue, off-curve points will be drawn in red.
 * @param {CanvasRenderingContext2D} ctx - A 2D drawing context, like Canvas.
 * @param {string} text - The text to create.
 * @param {number} [x=0] - Horizontal position of the beginning of the text.
 * @param {number} [y=0] - Vertical position of the *baseline* of the text.
 * @param {number} [fontSize=72] - Font size in pixels. We scale the glyph units by `1 / unitsPerEm * fontSize`.
 * @param {GlyphRenderOptions=} options
 */
Font.prototype.drawPoints = function(ctx, text, x, y, fontSize, options) {
    this.forEachGlyph(text, x, y, fontSize, options, function(glyph, gX, gY, gFontSize) {
        glyph.drawPoints(ctx, gX, gY, gFontSize);
    });
};

/**
 * Draw lines indicating important font measurements for all glyphs in the text.
 * Black lines indicate the origin of the coordinate system (point 0,0).
 * Blue lines indicate the glyph bounding box.
 * Green line indicates the advance width of the glyph.
 * @param {CanvasRenderingContext2D} ctx - A 2D drawing context, like Canvas.
 * @param {string} text - The text to create.
 * @param {number} [x=0] - Horizontal position of the beginning of the text.
 * @param {number} [y=0] - Vertical position of the *baseline* of the text.
 * @param {number} [fontSize=72] - Font size in pixels. We scale the glyph units by `1 / unitsPerEm * fontSize`.
 * @param {GlyphRenderOptions=} options
 */
Font.prototype.drawMetrics = function(ctx, text, x, y, fontSize, options) {
    this.forEachGlyph(text, x, y, fontSize, options, function(glyph, gX, gY, gFontSize) {
        glyph.drawMetrics(ctx, gX, gY, gFontSize);
    });
};

/**
 * @param  {string}
 * @return {string}
 */
Font.prototype.getEnglishName = function(name) {
    var translations = this.names[name];
    if (translations) {
        return translations.en;
    }
};

/**
 * Validate
 */
Font.prototype.validate = function() {
    var warnings = [];
    var _this = this;

    function assert(predicate, message) {
        if (!predicate) {
            warnings.push(message);
        }
    }

    function assertNamePresent(name) {
        var englishName = _this.getEnglishName(name);
        assert(englishName && englishName.trim().length > 0,
               'No English ' + name + ' specified.');
    }

    // Identification information
    assertNamePresent('fontFamily');
    assertNamePresent('weightName');
    assertNamePresent('manufacturer');
    assertNamePresent('copyright');
    assertNamePresent('version');

    // Dimension information
    assert(this.unitsPerEm > 0, 'No unitsPerEm specified.');
};

/**
 * Convert the font object to a SFNT data structure.
 * This structure contains all the necessary tables and metadata to create a binary OTF file.
 * @return {opentype.Table}
 */
Font.prototype.toTables = function() {
    return sfnt.fontToTable(this);
};
/**
 * @deprecated Font.toBuffer is deprecated. Use Font.toArrayBuffer instead.
 */
Font.prototype.toBuffer = function() {
    console.warn('Font.toBuffer is deprecated. Use Font.toArrayBuffer instead.');
    return this.toArrayBuffer();
};
/**
 * Converts a `opentype.Font` into an `ArrayBuffer`
 * @return {ArrayBuffer}
 */
Font.prototype.toArrayBuffer = function() {
    var sfntTable = this.toTables();
    var bytes = sfntTable.encode();
    var buffer = new ArrayBuffer(bytes.length);
    var intArray = new Uint8Array(buffer);
    for (var i = 0; i < bytes.length; i++) {
        intArray[i] = bytes[i];
    }

    return buffer;
};

/**
 * Initiate a download of the OpenType font.
 */
Font.prototype.download = function(fileName) {
    var familyName = this.getEnglishName('fontFamily');
    var styleName = this.getEnglishName('fontSubfamily');
    fileName = fileName || familyName.replace(/\s/g, '') + '-' + styleName + '.otf';
    var arrayBuffer = this.toArrayBuffer();

    if (isBrowser()) {
        window.requestFileSystem = window.requestFileSystem || window.webkitRequestFileSystem;
        window.requestFileSystem(window.TEMPORARY, arrayBuffer.byteLength, function(fs) {
            fs.root.getFile(fileName, {create: true}, function(fileEntry) {
                fileEntry.createWriter(function(writer) {
                    var dataView = new DataView(arrayBuffer);
                    var blob = new Blob([dataView], {type: 'font/opentype'});
                    writer.write(blob);

                    writer.addEventListener('writeend', function() {
                        // Navigating to the file will download it.
                        location.href = fileEntry.toURL();
                    }, false);
                });
            });
        },
        function(err) {
            throw new Error(err.name + ': ' + err.message);
        });
    } else {
        var fs = _dereq_('fs');
        var buffer = arrayBufferToNodeBuffer(arrayBuffer);
        fs.writeFileSync(fileName, buffer);
    }
};
/**
 * @private
 */
Font.prototype.fsSelectionValues = {
    ITALIC:              0x001, //1
    UNDERSCORE:          0x002, //2
    NEGATIVE:            0x004, //4
    OUTLINED:            0x008, //8
    STRIKEOUT:           0x010, //16
    BOLD:                0x020, //32
    REGULAR:             0x040, //64
    USER_TYPO_METRICS:   0x080, //128
    WWS:                 0x100, //256
    OBLIQUE:             0x200  //512
};

/**
 * @private
 */
Font.prototype.usWidthClasses = {
    ULTRA_CONDENSED: 1,
    EXTRA_CONDENSED: 2,
    CONDENSED: 3,
    SEMI_CONDENSED: 4,
    MEDIUM: 5,
    SEMI_EXPANDED: 6,
    EXPANDED: 7,
    EXTRA_EXPANDED: 8,
    ULTRA_EXPANDED: 9
};

/**
 * @private
 */
Font.prototype.usWeightClasses = {
    THIN: 100,
    EXTRA_LIGHT: 200,
    LIGHT: 300,
    NORMAL: 400,
    MEDIUM: 500,
    SEMI_BOLD: 600,
    BOLD: 700,
    EXTRA_BOLD: 800,
    BLACK:    900
};

// The `fvar` table stores font variation axes and instances.
// https://developer.apple.com/fonts/TrueType-Reference-Manual/RM06/Chap6fvar.html

function addName(name, names) {
    var nameString = JSON.stringify(name);
    var nameID = 256;
    for (var nameKey in names) {
        var n = parseInt(nameKey);
        if (!n || n < 256) {
            continue;
        }

        if (JSON.stringify(names[nameKey]) === nameString) {
            return n;
        }

        if (nameID <= n) {
            nameID = n + 1;
        }
    }

    names[nameID] = name;
    return nameID;
}

function makeFvarAxis(n, axis, names) {
    var nameID = addName(axis.name, names);
    return [
        {name: 'tag_' + n, type: 'TAG', value: axis.tag},
        {name: 'minValue_' + n, type: 'FIXED', value: axis.minValue << 16},
        {name: 'defaultValue_' + n, type: 'FIXED', value: axis.defaultValue << 16},
        {name: 'maxValue_' + n, type: 'FIXED', value: axis.maxValue << 16},
        {name: 'flags_' + n, type: 'USHORT', value: 0},
        {name: 'nameID_' + n, type: 'USHORT', value: nameID}
    ];
}

function parseFvarAxis(data, start, names) {
    var axis = {};
    var p = new parse.Parser(data, start);
    axis.tag = p.parseTag();
    axis.minValue = p.parseFixed();
    axis.defaultValue = p.parseFixed();
    axis.maxValue = p.parseFixed();
    p.skip('uShort', 1);  // reserved for flags; no values defined
    axis.name = names[p.parseUShort()] || {};
    return axis;
}

function makeFvarInstance(n, inst, axes, names) {
    var nameID = addName(inst.name, names);
    var fields = [
        {name: 'nameID_' + n, type: 'USHORT', value: nameID},
        {name: 'flags_' + n, type: 'USHORT', value: 0}
    ];

    for (var i = 0; i < axes.length; ++i) {
        var axisTag = axes[i].tag;
        fields.push({
            name: 'axis_' + n + ' ' + axisTag,
            type: 'FIXED',
            value: inst.coordinates[axisTag] << 16
        });
    }

    return fields;
}

function parseFvarInstance(data, start, axes, names) {
    var inst = {};
    var p = new parse.Parser(data, start);
    inst.name = names[p.parseUShort()] || {};
    p.skip('uShort', 1);  // reserved for flags; no values defined

    inst.coordinates = {};
    for (var i = 0; i < axes.length; ++i) {
        inst.coordinates[axes[i].tag] = p.parseFixed();
    }

    return inst;
}

function makeFvarTable(fvar, names) {
    var result = new table.Table('fvar', [
        {name: 'version', type: 'ULONG', value: 0x10000},
        {name: 'offsetToData', type: 'USHORT', value: 0},
        {name: 'countSizePairs', type: 'USHORT', value: 2},
        {name: 'axisCount', type: 'USHORT', value: fvar.axes.length},
        {name: 'axisSize', type: 'USHORT', value: 20},
        {name: 'instanceCount', type: 'USHORT', value: fvar.instances.length},
        {name: 'instanceSize', type: 'USHORT', value: 4 + fvar.axes.length * 4}
    ]);
    result.offsetToData = result.sizeOf();

    for (var i = 0; i < fvar.axes.length; i++) {
        result.fields = result.fields.concat(makeFvarAxis(i, fvar.axes[i], names));
    }

    for (var j = 0; j < fvar.instances.length; j++) {
        result.fields = result.fields.concat(makeFvarInstance(j, fvar.instances[j], fvar.axes, names));
    }

    return result;
}

function parseFvarTable(data, start, names) {
    var p = new parse.Parser(data, start);
    var tableVersion = p.parseULong();
    check.argument(tableVersion === 0x00010000, 'Unsupported fvar table version.');
    var offsetToData = p.parseOffset16();
    // Skip countSizePairs.
    p.skip('uShort', 1);
    var axisCount = p.parseUShort();
    var axisSize = p.parseUShort();
    var instanceCount = p.parseUShort();
    var instanceSize = p.parseUShort();

    var axes = [];
    for (var i = 0; i < axisCount; i++) {
        axes.push(parseFvarAxis(data, start + offsetToData + i * axisSize, names));
    }

    var instances = [];
    var instanceStart = start + offsetToData + axisCount * axisSize;
    for (var j = 0; j < instanceCount; j++) {
        instances.push(parseFvarInstance(data, instanceStart + j * instanceSize, axes, names));
    }

    return {axes: axes, instances: instances};
}

var fvar = { make: makeFvarTable, parse: parseFvarTable };

// The `GPOS` table contains kerning pairs, among other things.
// https://www.microsoft.com/typography/OTSPEC/gpos.htm

// Parse ScriptList and FeatureList tables of GPOS, GSUB, GDEF, BASE, JSTF tables.
// These lists are unused by now, this function is just the basis for a real parsing.
function parseTaggedListTable(data, start) {
    var p = new parse.Parser(data, start);
    var n = p.parseUShort();
    var list = [];
    for (var i = 0; i < n; i++) {
        list[p.parseTag()] = { offset: p.parseUShort() };
    }

    return list;
}

// Parse a coverage table in a GSUB, GPOS or GDEF table.
// Format 1 is a simple list of glyph ids,
// Format 2 is a list of ranges. It is expanded in a list of glyphs, maybe not the best idea.
function parseCoverageTable(data, start) {
    var p = new parse.Parser(data, start);
    var format = p.parseUShort();
    var count = p.parseUShort();
    if (format === 1) {
        return p.parseUShortList(count);
    } else if (format === 2) {
        var coverage = [];
        for (; count--;) {
            var begin = p.parseUShort();
            var end = p.parseUShort();
            var index = p.parseUShort();
            for (var i = begin; i <= end; i++) {
                coverage[index++] = i;
            }
        }

        return coverage;
    }
}

// Parse a Class Definition Table in a GSUB, GPOS or GDEF table.
// Returns a function that gets a class value from a glyph ID.
function parseClassDefTable(data, start) {
    var p = new parse.Parser(data, start);
    var format = p.parseUShort();
    if (format === 1) {
        // Format 1 specifies a range of consecutive glyph indices, one class per glyph ID.
        var startGlyph = p.parseUShort();
        var glyphCount = p.parseUShort();
        var classes = p.parseUShortList(glyphCount);
        return function(glyphID) {
            return classes[glyphID - startGlyph] || 0;
        };
    } else if (format === 2) {
        // Format 2 defines multiple groups of glyph indices that belong to the same class.
        var rangeCount = p.parseUShort();
        var startGlyphs = [];
        var endGlyphs = [];
        var classValues = [];
        for (var i = 0; i < rangeCount; i++) {
            startGlyphs[i] = p.parseUShort();
            endGlyphs[i] = p.parseUShort();
            classValues[i] = p.parseUShort();
        }

        return function(glyphID) {
            var l = 0;
            var r = startGlyphs.length - 1;
            while (l < r) {
                var c = (l + r + 1) >> 1;
                if (glyphID < startGlyphs[c]) {
                    r = c - 1;
                } else {
                    l = c;
                }
            }

            if (startGlyphs[l] <= glyphID && glyphID <= endGlyphs[l]) {
                return classValues[l] || 0;
            }

            return 0;
        };
    }
}

// Parse a pair adjustment positioning subtable, format 1 or format 2
// The subtable is returned in the form of a lookup function.
function parsePairPosSubTable(data, start) {
    var p = new parse.Parser(data, start);
    // This part is common to format 1 and format 2 subtables
    var format = p.parseUShort();
    var coverageOffset = p.parseUShort();
    var coverage = parseCoverageTable(data, start + coverageOffset);
    // valueFormat 4: XAdvance only, 1: XPlacement only, 0: no ValueRecord for second glyph
    // Only valueFormat1=4 and valueFormat2=0 is supported.
    var valueFormat1 = p.parseUShort();
    var valueFormat2 = p.parseUShort();
    var value1;
    var value2;
    if (valueFormat1 !== 4 || valueFormat2 !== 0) { return; }
    var sharedPairSets = {};
    if (format === 1) {
        // Pair Positioning Adjustment: Format 1
        var pairSetCount = p.parseUShort();
        var pairSet = [];
        // Array of offsets to PairSet tables-from beginning of PairPos subtable-ordered by Coverage Index
        var pairSetOffsets = p.parseOffset16List(pairSetCount);
        for (var firstGlyph = 0; firstGlyph < pairSetCount; firstGlyph++) {
            var pairSetOffset = pairSetOffsets[firstGlyph];
            var sharedPairSet = sharedPairSets[pairSetOffset];
            if (!sharedPairSet) {
                // Parse a pairset table in a pair adjustment subtable format 1
                sharedPairSet = {};
                p.relativeOffset = pairSetOffset;
                var pairValueCount = p.parseUShort();
                for (; pairValueCount--;) {
                    var secondGlyph = p.parseUShort();
                    if (valueFormat1) { value1 = p.parseShort(); }
                    if (valueFormat2) { value2 = p.parseShort(); }
                    // We only support valueFormat1 = 4 and valueFormat2 = 0,
                    // so value1 is the XAdvance and value2 is empty.
                    sharedPairSet[secondGlyph] = value1;
                }
            }

            pairSet[coverage[firstGlyph]] = sharedPairSet;
        }

        return function(leftGlyph, rightGlyph) {
            var pairs = pairSet[leftGlyph];
            if (pairs) { return pairs[rightGlyph]; }
        };
    } else if (format === 2) {
        // Pair Positioning Adjustment: Format 2
        var classDef1Offset = p.parseUShort();
        var classDef2Offset = p.parseUShort();
        var class1Count = p.parseUShort();
        var class2Count = p.parseUShort();
        var getClass1 = parseClassDefTable(data, start + classDef1Offset);
        var getClass2 = parseClassDefTable(data, start + classDef2Offset);

        // Parse kerning values by class pair.
        var kerningMatrix = [];
        for (var i = 0; i < class1Count; i++) {
            var kerningRow = kerningMatrix[i] = [];
            for (var j = 0; j < class2Count; j++) {
                if (valueFormat1) { value1 = p.parseShort(); }
                if (valueFormat2) { value2 = p.parseShort(); }
                // We only support valueFormat1 = 4 and valueFormat2 = 0,
                // so value1 is the XAdvance and value2 is empty.
                kerningRow[j] = value1;
            }
        }

        // Convert coverage list to a hash
        var covered = {};
        for (var i$1 = 0; i$1 < coverage.length; i$1++) {
            covered[coverage[i$1]] = 1;
        }

        // Get the kerning value for a specific glyph pair.
        return function(leftGlyph, rightGlyph) {
            if (!covered[leftGlyph]) { return; }
            var class1 = getClass1(leftGlyph);
            var class2 = getClass2(rightGlyph);
            var kerningRow = kerningMatrix[class1];

            if (kerningRow) {
                return kerningRow[class2];
            }
        };
    }
}

// Parse a LookupTable (present in of GPOS, GSUB, GDEF, BASE, JSTF tables).
function parseLookupTable(data, start) {
    var p = new parse.Parser(data, start);
    var lookupType = p.parseUShort();
    var lookupFlag = p.parseUShort();
    var useMarkFilteringSet = lookupFlag & 0x10;
    var subTableCount = p.parseUShort();
    var subTableOffsets = p.parseOffset16List(subTableCount);
    var table = {
        lookupType: lookupType,
        lookupFlag: lookupFlag,
        markFilteringSet: useMarkFilteringSet ? p.parseUShort() : -1
    };
    // LookupType 2, Pair adjustment
    if (lookupType === 2) {
        var subtables = [];
        for (var i = 0; i < subTableCount; i++) {
            var pairPosSubTable = parsePairPosSubTable(data, start + subTableOffsets[i]);
            if (pairPosSubTable) { subtables.push(pairPosSubTable); }
        }
        // Return a function which finds the kerning values in the subtables.
        table.getKerningValue = function(leftGlyph, rightGlyph) {
            for (var i = subtables.length; i--;) {
                var value = subtables[i](leftGlyph, rightGlyph);
                if (value !== undefined) { return value; }
            }

            return 0;
        };
    }

    return table;
}

// Parse the `GPOS` table which contains, among other things, kerning pairs.
// https://www.microsoft.com/typography/OTSPEC/gpos.htm
function parseGposTable(data, start, font) {
    var p = new parse.Parser(data, start);
    var tableVersion = p.parseFixed();
    check.argument(tableVersion === 1, 'Unsupported GPOS table version.');

    // ScriptList and FeatureList - ignored for now
    parseTaggedListTable(data, start + p.parseUShort());
    // 'kern' is the feature we are looking for.
    parseTaggedListTable(data, start + p.parseUShort());

    // LookupList
    var lookupListOffset = p.parseUShort();
    p.relativeOffset = lookupListOffset;
    var lookupCount = p.parseUShort();
    var lookupTableOffsets = p.parseOffset16List(lookupCount);
    var lookupListAbsoluteOffset = start + lookupListOffset;
    for (var i = 0; i < lookupCount; i++) {
        var table = parseLookupTable(data, lookupListAbsoluteOffset + lookupTableOffsets[i]);
        if (table.lookupType === 2 && !font.getGposKerningValue) { font.getGposKerningValue = table.getKerningValue; }
    }
}

var gpos = { parse: parseGposTable };

// The `kern` table contains kerning pairs.
// Note that some fonts use the GPOS OpenType layout table to specify kerning.
// https://www.microsoft.com/typography/OTSPEC/kern.htm

function parseWindowsKernTable(p) {
    var pairs = {};
    // Skip nTables.
    p.skip('uShort');
    var subtableVersion = p.parseUShort();
    check.argument(subtableVersion === 0, 'Unsupported kern sub-table version.');
    // Skip subtableLength, subtableCoverage
    p.skip('uShort', 2);
    var nPairs = p.parseUShort();
    // Skip searchRange, entrySelector, rangeShift.
    p.skip('uShort', 3);
    for (var i = 0; i < nPairs; i += 1) {
        var leftIndex = p.parseUShort();
        var rightIndex = p.parseUShort();
        var value = p.parseShort();
        pairs[leftIndex + ',' + rightIndex] = value;
    }
    return pairs;
}

function parseMacKernTable(p) {
    var pairs = {};
    // The Mac kern table stores the version as a fixed (32 bits) but we only loaded the first 16 bits.
    // Skip the rest.
    p.skip('uShort');
    var nTables = p.parseULong();
    //check.argument(nTables === 1, 'Only 1 subtable is supported (got ' + nTables + ').');
    if (nTables > 1) {
        console.warn('Only the first kern subtable is supported.');
    }
    p.skip('uLong');
    var coverage = p.parseUShort();
    var subtableVersion = coverage & 0xFF;
    p.skip('uShort');
    if (subtableVersion === 0) {
        var nPairs = p.parseUShort();
        // Skip searchRange, entrySelector, rangeShift.
        p.skip('uShort', 3);
        for (var i = 0; i < nPairs; i += 1) {
            var leftIndex = p.parseUShort();
            var rightIndex = p.parseUShort();
            var value = p.parseShort();
            pairs[leftIndex + ',' + rightIndex] = value;
        }
    }
    return pairs;
}

// Parse the `kern` table which contains kerning pairs.
function parseKernTable(data, start) {
    var p = new parse.Parser(data, start);
    var tableVersion = p.parseUShort();
    if (tableVersion === 0) {
        return parseWindowsKernTable(p);
    } else if (tableVersion === 1) {
        return parseMacKernTable(p);
    } else {
        throw new Error('Unsupported kern table version (' + tableVersion + ').');
    }
}

var kern = { parse: parseKernTable };

// The `loca` table stores the offsets to the locations of the glyphs in the font.
// https://www.microsoft.com/typography/OTSPEC/loca.htm

// Parse the `loca` table. This table stores the offsets to the locations of the glyphs in the font,
// relative to the beginning of the glyphData table.
// The number of glyphs stored in the `loca` table is specified in the `maxp` table (under numGlyphs)
// The loca table has two versions: a short version where offsets are stored as uShorts, and a long
// version where offsets are stored as uLongs. The `head` table specifies which version to use
// (under indexToLocFormat).
function parseLocaTable(data, start, numGlyphs, shortVersion) {
    var p = new parse.Parser(data, start);
    var parseFn = shortVersion ? p.parseUShort : p.parseULong;
    // There is an extra entry after the last index element to compute the length of the last glyph.
    // That's why we use numGlyphs + 1.
    var glyphOffsets = [];
    for (var i = 0; i < numGlyphs + 1; i += 1) {
        var glyphOffset = parseFn.call(p);
        if (shortVersion) {
            // The short table version stores the actual offset divided by 2.
            glyphOffset *= 2;
        }

        glyphOffsets.push(glyphOffset);
    }

    return glyphOffsets;
}

var loca = { parse: parseLocaTable };

// opentype.js
// https://github.com/nodebox/opentype.js
// (c) 2015 Frederik De Bleser
// opentype.js may be freely distributed under the MIT license.

/* global DataView, Uint8Array, XMLHttpRequest  */

/**
 * The opentype library.
 * @namespace opentype
 */

// File loaders /////////////////////////////////////////////////////////
/**
 * Loads a font from a file. The callback throws an error message as the first parameter if it fails
 * and the font as an ArrayBuffer in the second parameter if it succeeds.
 * @param  {string} path - The path of the file
 * @param  {Function} callback - The function to call when the font load completes
 */
function loadFromFile(path, callback) {
    var fs = _dereq_('fs');
    fs.readFile(path, function(err, buffer) {
        if (err) {
            return callback(err.message);
        }

        callback(null, nodeBufferToArrayBuffer(buffer));
    });
}
/**
 * Loads a font from a URL. The callback throws an error message as the first parameter if it fails
 * and the font as an ArrayBuffer in the second parameter if it succeeds.
 * @param  {string} url - The URL of the font file.
 * @param  {Function} callback - The function to call when the font load completes
 */
function loadFromUrl(url, callback) {
    var request = new XMLHttpRequest();
    request.open('get', url, true);
    request.responseType = 'arraybuffer';
    request.onload = function() {
        if (request.status !== 200) {
            return callback('Font could not be loaded: ' + request.statusText);
        }

        return callback(null, request.response);
    };

    request.onerror = function () {
        callback('Font could not be loaded');
    };

    request.send();
}

// Table Directory Entries //////////////////////////////////////////////
/**
 * Parses OpenType table entries.
 * @param  {DataView}
 * @param  {Number}
 * @return {Object[]}
 */
function parseOpenTypeTableEntries(data, numTables) {
    var tableEntries = [];
    var p = 12;
    for (var i = 0; i < numTables; i += 1) {
        var tag = parse.getTag(data, p);
        var checksum = parse.getULong(data, p + 4);
        var offset = parse.getULong(data, p + 8);
        var length = parse.getULong(data, p + 12);
        tableEntries.push({tag: tag, checksum: checksum, offset: offset, length: length, compression: false});
        p += 16;
    }

    return tableEntries;
}

/**
 * Parses WOFF table entries.
 * @param  {DataView}
 * @param  {Number}
 * @return {Object[]}
 */
function parseWOFFTableEntries(data, numTables) {
    var tableEntries = [];
    var p = 44; // offset to the first table directory entry.
    for (var i = 0; i < numTables; i += 1) {
        var tag = parse.getTag(data, p);
        var offset = parse.getULong(data, p + 4);
        var compLength = parse.getULong(data, p + 8);
        var origLength = parse.getULong(data, p + 12);
        var compression = (void 0);
        if (compLength < origLength) {
            compression = 'WOFF';
        } else {
            compression = false;
        }

        tableEntries.push({tag: tag, offset: offset, compression: compression,
            compressedLength: compLength, length: origLength});
        p += 20;
    }

    return tableEntries;
}

/**
 * @typedef TableData
 * @type Object
 * @property {DataView} data - The DataView
 * @property {number} offset - The data offset.
 */

/**
 * @param  {DataView}
 * @param  {Object}
 * @return {TableData}
 */
function uncompressTable(data, tableEntry) {
    if (tableEntry.compression === 'WOFF') {
        var inBuffer = new Uint8Array(data.buffer, tableEntry.offset + 2, tableEntry.compressedLength - 2);
        var outBuffer = new Uint8Array(tableEntry.length);
        index(inBuffer, outBuffer);
        if (outBuffer.byteLength !== tableEntry.length) {
            throw new Error('Decompression error: ' + tableEntry.tag + ' decompressed length doesn\'t match recorded length');
        }

        var view = new DataView(outBuffer.buffer, 0);
        return {data: view, offset: 0};
    } else {
        return {data: data, offset: tableEntry.offset};
    }
}

// Public API ///////////////////////////////////////////////////////////

/**
 * Parse the OpenType file data (as an ArrayBuffer) and return a Font object.
 * Throws an error if the font could not be parsed.
 * @param  {ArrayBuffer}
 * @return {opentype.Font}
 */
function parseBuffer(buffer) {
    var indexToLocFormat;
    var ltagTable;

    // Since the constructor can also be called to create new fonts from scratch, we indicate this
    // should be an empty font that we'll fill with our own data.
    var font = new Font({empty: true});

    // OpenType fonts use big endian byte ordering.
    // We can't rely on typed array view types, because they operate with the endianness of the host computer.
    // Instead we use DataViews where we can specify endianness.
    var data = new DataView(buffer, 0);
    var numTables;
    var tableEntries = [];
    var signature = parse.getTag(data, 0);
    if (signature === String.fromCharCode(0, 1, 0, 0) || signature === 'true' || signature === 'typ1') {
        font.outlinesFormat = 'truetype';
        numTables = parse.getUShort(data, 4);
        tableEntries = parseOpenTypeTableEntries(data, numTables);
    } else if (signature === 'OTTO') {
        font.outlinesFormat = 'cff';
        numTables = parse.getUShort(data, 4);
        tableEntries = parseOpenTypeTableEntries(data, numTables);
    } else if (signature === 'wOFF') {
        var flavor = parse.getTag(data, 4);
        if (flavor === String.fromCharCode(0, 1, 0, 0)) {
            font.outlinesFormat = 'truetype';
        } else if (flavor === 'OTTO') {
            font.outlinesFormat = 'cff';
        } else {
            throw new Error('Unsupported OpenType flavor ' + signature);
        }

        numTables = parse.getUShort(data, 12);
        tableEntries = parseWOFFTableEntries(data, numTables);
    } else {
        throw new Error('Unsupported OpenType signature ' + signature);
    }

    var cffTableEntry;
    var fvarTableEntry;
    var glyfTableEntry;
    var gposTableEntry;
    var gsubTableEntry;
    var hmtxTableEntry;
    var kernTableEntry;
    var locaTableEntry;
    var nameTableEntry;
    var metaTableEntry;
    var p;

    for (var i = 0; i < numTables; i += 1) {
        var tableEntry = tableEntries[i];
        var table = (void 0);
        switch (tableEntry.tag) {
            case 'cmap':
                table = uncompressTable(data, tableEntry);
                font.tables.cmap = cmap.parse(table.data, table.offset);
                font.encoding = new CmapEncoding(font.tables.cmap);
                break;
            case 'cvt ' :
                table = uncompressTable(data, tableEntry);
                p = new parse.Parser(table.data, table.offset);
                font.tables.cvt = p.parseShortList(tableEntry.length / 2);
                break;
            case 'fvar':
                fvarTableEntry = tableEntry;
                break;
            case 'fpgm' :
                table = uncompressTable(data, tableEntry);
                p = new parse.Parser(table.data, table.offset);
                font.tables.fpgm = p.parseByteList(tableEntry.length);
                break;
            case 'head':
                table = uncompressTable(data, tableEntry);
                font.tables.head = head.parse(table.data, table.offset);
                font.unitsPerEm = font.tables.head.unitsPerEm;
                indexToLocFormat = font.tables.head.indexToLocFormat;
                break;
            case 'hhea':
                table = uncompressTable(data, tableEntry);
                font.tables.hhea = hhea.parse(table.data, table.offset);
                font.ascender = font.tables.hhea.ascender;
                font.descender = font.tables.hhea.descender;
                font.numberOfHMetrics = font.tables.hhea.numberOfHMetrics;
                break;
            case 'hmtx':
                hmtxTableEntry = tableEntry;
                break;
            case 'ltag':
                table = uncompressTable(data, tableEntry);
                ltagTable = ltag.parse(table.data, table.offset);
                break;
            case 'maxp':
                table = uncompressTable(data, tableEntry);
                font.tables.maxp = maxp.parse(table.data, table.offset);
                font.numGlyphs = font.tables.maxp.numGlyphs;
                break;
            case 'name':
                nameTableEntry = tableEntry;
                break;
            case 'OS/2':
                table = uncompressTable(data, tableEntry);
                font.tables.os2 = os2.parse(table.data, table.offset);
                break;
            case 'post':
                table = uncompressTable(data, tableEntry);
                font.tables.post = post.parse(table.data, table.offset);
                font.glyphNames = new GlyphNames(font.tables.post);
                break;
            case 'prep' :
                table = uncompressTable(data, tableEntry);
                p = new parse.Parser(table.data, table.offset);
                font.tables.prep = p.parseByteList(tableEntry.length);
                break;
            case 'glyf':
                glyfTableEntry = tableEntry;
                break;
            case 'loca':
                locaTableEntry = tableEntry;
                break;
            case 'CFF ':
                cffTableEntry = tableEntry;
                break;
            case 'kern':
                kernTableEntry = tableEntry;
                break;
            case 'GPOS':
                gposTableEntry = tableEntry;
                break;
            case 'GSUB':
                gsubTableEntry = tableEntry;
                break;
            case 'meta':
                metaTableEntry = tableEntry;
                break;
        }
    }

    var nameTable = uncompressTable(data, nameTableEntry);
    font.tables.name = _name.parse(nameTable.data, nameTable.offset, ltagTable);
    font.names = font.tables.name;

    if (glyfTableEntry && locaTableEntry) {
        var shortVersion = indexToLocFormat === 0;
        var locaTable = uncompressTable(data, locaTableEntry);
        var locaOffsets = loca.parse(locaTable.data, locaTable.offset, font.numGlyphs, shortVersion);
        var glyfTable = uncompressTable(data, glyfTableEntry);
        font.glyphs = glyf.parse(glyfTable.data, glyfTable.offset, locaOffsets, font);
    } else if (cffTableEntry) {
        var cffTable = uncompressTable(data, cffTableEntry);
        cff.parse(cffTable.data, cffTable.offset, font);
    } else {
        throw new Error('Font doesn\'t contain TrueType or CFF outlines.');
    }

    var hmtxTable = uncompressTable(data, hmtxTableEntry);
    hmtx.parse(hmtxTable.data, hmtxTable.offset, font.numberOfHMetrics, font.numGlyphs, font.glyphs);
    addGlyphNames(font);

    if (kernTableEntry) {
        var kernTable = uncompressTable(data, kernTableEntry);
        font.kerningPairs = kern.parse(kernTable.data, kernTable.offset);
    } else {
        font.kerningPairs = {};
    }

    if (gposTableEntry) {
        var gposTable = uncompressTable(data, gposTableEntry);
        gpos.parse(gposTable.data, gposTable.offset, font);
    }

    if (gsubTableEntry) {
        var gsubTable = uncompressTable(data, gsubTableEntry);
        font.tables.gsub = gsub.parse(gsubTable.data, gsubTable.offset);
    }

    if (fvarTableEntry) {
        var fvarTable = uncompressTable(data, fvarTableEntry);
        font.tables.fvar = fvar.parse(fvarTable.data, fvarTable.offset, font.names);
    }

    if (metaTableEntry) {
        var metaTable = uncompressTable(data, metaTableEntry);
        font.tables.meta = meta.parse(metaTable.data, metaTable.offset);
        font.metas = font.tables.meta;
    }

    return font;
}

/**
 * Asynchronously load the font from a URL or a filesystem. When done, call the callback
 * with two arguments `(err, font)`. The `err` will be null on success,
 * the `font` is a Font object.
 * We use the node.js callback convention so that
 * opentype.js can integrate with frameworks like async.js.
 * @alias opentype.load
 * @param  {string} url - The URL of the font to load.
 * @param  {Function} callback - The callback.
 */
function load(url, callback) {
    var isNode$$1 = typeof window === 'undefined';
    var loadFn = isNode$$1 ? loadFromFile : loadFromUrl;
    loadFn(url, function(err, arrayBuffer) {
        if (err) {
            return callback(err);
        }
        var font;
        try {
            font = parseBuffer(arrayBuffer);
        } catch (e) {
            return callback(e, null);
        }
        return callback(null, font);
    });
}

/**
 * Synchronously load the font from a URL or file.
 * When done, returns the font object or throws an error.
 * @alias opentype.loadSync
 * @param  {string} url - The URL of the font to load.
 * @return {opentype.Font}
 */
function loadSync(url) {
    var fs = _dereq_('fs');
    var buffer = fs.readFileSync(url);
    return parseBuffer(nodeBufferToArrayBuffer(buffer));
}

exports.Font = Font;
exports.Glyph = Glyph;
exports.Path = Path;
exports.BoundingBox = BoundingBox;
exports._parse = parse;
exports.parse = parseBuffer;
exports.load = load;
exports.loadSync = loadSync;

Object.defineProperty(exports, '__esModule', { value: true });

})));


}).call(this,_dereq_("buffer").Buffer)
},{"buffer":4,"fs":3}],11:[function(_dereq_,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],12:[function(_dereq_,module,exports){
(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);

},{}],13:[function(_dereq_,module,exports){
'use strict';

var p5 = _dereq_('./core/core');
_dereq_('./color/p5.Color');
_dereq_('./core/p5.Element');
_dereq_('./typography/p5.Font');
_dereq_('./core/p5.Graphics');
_dereq_('./core/p5.Renderer2D');

_dereq_('./image/p5.Image');
_dereq_('./math/p5.Vector');
_dereq_('./io/p5.TableRow');
_dereq_('./io/p5.Table');
_dereq_('./io/p5.XML');

_dereq_('./color/creating_reading');
_dereq_('./color/setting');
_dereq_('./core/constants');
_dereq_('./utilities/conversion');
_dereq_('./utilities/array_functions');
_dereq_('./utilities/string_functions');
_dereq_('./core/environment');
_dereq_('./image/image');
_dereq_('./image/loading_displaying');
_dereq_('./image/pixels');
_dereq_('./io/files');
_dereq_('./events/keyboard');
_dereq_('./events/acceleration'); //john
_dereq_('./events/mouse');
_dereq_('./utilities/time_date');
_dereq_('./events/touch');
_dereq_('./math/math');
_dereq_('./math/calculation');
_dereq_('./math/random');
_dereq_('./math/noise');
_dereq_('./math/trigonometry');
_dereq_('./core/rendering');
_dereq_('./core/2d_primitives');

_dereq_('./core/attributes');
_dereq_('./core/curves');
_dereq_('./core/vertex');
_dereq_('./core/structure');
_dereq_('./core/transform');
_dereq_('./typography/attributes');
_dereq_('./typography/loading_displaying');

_dereq_('./data/p5.TypedDict');

_dereq_('./webgl/p5.RendererGL');
_dereq_('./webgl/p5.Geometry');
_dereq_('./webgl/p5.RendererGL.Retained');
_dereq_('./webgl/p5.RendererGL.Immediate');
_dereq_('./webgl/primitives');
_dereq_('./webgl/loading');
_dereq_('./webgl/p5.Matrix');
_dereq_('./webgl/material');
_dereq_('./webgl/light');
_dereq_('./webgl/p5.Shader');
_dereq_('./webgl/camera');
_dereq_('./webgl/interaction');

_dereq_('./core/init.js');

module.exports = p5;

},{"./color/creating_reading":15,"./color/p5.Color":16,"./color/setting":17,"./core/2d_primitives":18,"./core/attributes":19,"./core/constants":21,"./core/core":22,"./core/curves":23,"./core/environment":24,"./core/init.js":26,"./core/p5.Element":27,"./core/p5.Graphics":28,"./core/p5.Renderer2D":30,"./core/rendering":31,"./core/structure":33,"./core/transform":34,"./core/vertex":35,"./data/p5.TypedDict":36,"./events/acceleration":37,"./events/keyboard":38,"./events/mouse":39,"./events/touch":40,"./image/image":42,"./image/loading_displaying":43,"./image/p5.Image":44,"./image/pixels":45,"./io/files":46,"./io/p5.Table":47,"./io/p5.TableRow":48,"./io/p5.XML":49,"./math/calculation":50,"./math/math":51,"./math/noise":52,"./math/p5.Vector":53,"./math/random":55,"./math/trigonometry":56,"./typography/attributes":57,"./typography/loading_displaying":58,"./typography/p5.Font":59,"./utilities/array_functions":60,"./utilities/conversion":61,"./utilities/string_functions":62,"./utilities/time_date":63,"./webgl/camera":64,"./webgl/interaction":65,"./webgl/light":66,"./webgl/loading":67,"./webgl/material":68,"./webgl/p5.Geometry":69,"./webgl/p5.Matrix":70,"./webgl/p5.RendererGL":73,"./webgl/p5.RendererGL.Immediate":71,"./webgl/p5.RendererGL.Retained":72,"./webgl/p5.Shader":74,"./webgl/primitives":76}],14:[function(_dereq_,module,exports){
/**
 * @module Conversion
 * @submodule Color Conversion
 * @for p5
 * @requires core
 */

'use strict';

/**
 * Conversions adapted from <http://www.easyrgb.com/math.html>.
 *
 * In these functions, hue is always in the range [0,1); all other components
 * are in the range [0,1]. 'Brightness' and 'value' are used interchangeably.
 */

var p5 = _dereq_('../core/core');
p5.ColorConversion = {};

/**
 * Convert an HSBA array to HSLA.
 */
p5.ColorConversion._hsbaToHSLA = function(hsba) {
  var hue = hsba[0];
  var sat = hsba[1];
  var val = hsba[2];

  // Calculate lightness.
  var li = (2 - sat) * val / 2;

  // Convert saturation.
  if (li !== 0) {
    if (li === 1) {
      sat = 0;
    } else if (li < 0.5) {
      sat = sat / (2 - sat);
    } else {
      sat = sat * val / (2 - li * 2);
    }
  }

  // Hue and alpha stay the same.
  return [hue, sat, li, hsba[3]];
};

/**
 * Convert an HSBA array to RGBA.
 */
p5.ColorConversion._hsbaToRGBA = function(hsba) {
  var hue = hsba[0] * 6; // We will split hue into 6 sectors.
  var sat = hsba[1];
  var val = hsba[2];

  var RGBA = [];

  if (sat === 0) {
    RGBA = [val, val, val, hsba[3]]; // Return early if grayscale.
  } else {
    var sector = Math.floor(hue);
    var tint1 = val * (1 - sat);
    var tint2 = val * (1 - sat * (hue - sector));
    var tint3 = val * (1 - sat * (1 + sector - hue));
    var red, green, blue;
    if (sector === 1) {
      // Yellow to green.
      red = tint2;
      green = val;
      blue = tint1;
    } else if (sector === 2) {
      // Green to cyan.
      red = tint1;
      green = val;
      blue = tint3;
    } else if (sector === 3) {
      // Cyan to blue.
      red = tint1;
      green = tint2;
      blue = val;
    } else if (sector === 4) {
      // Blue to magenta.
      red = tint3;
      green = tint1;
      blue = val;
    } else if (sector === 5) {
      // Magenta to red.
      red = val;
      green = tint1;
      blue = tint2;
    } else {
      // Red to yellow (sector could be 0 or 6).
      red = val;
      green = tint3;
      blue = tint1;
    }
    RGBA = [red, green, blue, hsba[3]];
  }

  return RGBA;
};

/**
 * Convert an HSLA array to HSBA.
 */
p5.ColorConversion._hslaToHSBA = function(hsla) {
  var hue = hsla[0];
  var sat = hsla[1];
  var li = hsla[2];

  // Calculate brightness.
  var val;
  if (li < 0.5) {
    val = (1 + sat) * li;
  } else {
    val = li + sat - li * sat;
  }

  // Convert saturation.
  sat = 2 * (val - li) / val;

  // Hue and alpha stay the same.
  return [hue, sat, val, hsla[3]];
};

/**
 * Convert an HSLA array to RGBA.
 *
 * We need to change basis from HSLA to something that can be more easily be
 * projected onto RGBA. We will choose hue and brightness as our first two
 * components, and pick a convenient third one ('zest') so that we don't need
 * to calculate formal HSBA saturation.
 */
p5.ColorConversion._hslaToRGBA = function(hsla) {
  var hue = hsla[0] * 6; // We will split hue into 6 sectors.
  var sat = hsla[1];
  var li = hsla[2];

  var RGBA = [];

  if (sat === 0) {
    RGBA = [li, li, li, hsla[3]]; // Return early if grayscale.
  } else {
    // Calculate brightness.
    var val;
    if (li < 0.5) {
      val = (1 + sat) * li;
    } else {
      val = li + sat - li * sat;
    }

    // Define zest.
    var zest = 2 * li - val;

    // Implement projection (project onto green by default).
    var hzvToRGB = function(hue, zest, val) {
      if (hue < 0) {
        // Hue must wrap to allow projection onto red and blue.
        hue += 6;
      } else if (hue >= 6) {
        hue -= 6;
      }
      if (hue < 1) {
        // Red to yellow (increasing green).
        return zest + (val - zest) * hue;
      } else if (hue < 3) {
        // Yellow to cyan (greatest green).
        return val;
      } else if (hue < 4) {
        // Cyan to blue (decreasing green).
        return zest + (val - zest) * (4 - hue);
      } else {
        // Blue to red (least green).
        return zest;
      }
    };

    // Perform projections, offsetting hue as necessary.
    RGBA = [
      hzvToRGB(hue + 2, zest, val),
      hzvToRGB(hue, zest, val),
      hzvToRGB(hue - 2, zest, val),
      hsla[3]
    ];
  }

  return RGBA;
};

/**
 * Convert an RGBA array to HSBA.
 */
p5.ColorConversion._rgbaToHSBA = function(rgba) {
  var red = rgba[0];
  var green = rgba[1];
  var blue = rgba[2];

  var val = Math.max(red, green, blue);
  var chroma = val - Math.min(red, green, blue);

  var hue, sat;
  if (chroma === 0) {
    // Return early if grayscale.
    hue = 0;
    sat = 0;
  } else {
    sat = chroma / val;
    if (red === val) {
      // Magenta to yellow.
      hue = (green - blue) / chroma;
    } else if (green === val) {
      // Yellow to cyan.
      hue = 2 + (blue - red) / chroma;
    } else if (blue === val) {
      // Cyan to magenta.
      hue = 4 + (red - green) / chroma;
    }
    if (hue < 0) {
      // Confine hue to the interval [0, 1).
      hue += 6;
    } else if (hue >= 6) {
      hue -= 6;
    }
  }

  return [hue / 6, sat, val, rgba[3]];
};

/**
 * Convert an RGBA array to HSLA.
 */
p5.ColorConversion._rgbaToHSLA = function(rgba) {
  var red = rgba[0];
  var green = rgba[1];
  var blue = rgba[2];

  var val = Math.max(red, green, blue);
  var min = Math.min(red, green, blue);
  var li = val + min; // We will halve this later.
  var chroma = val - min;

  var hue, sat;
  if (chroma === 0) {
    // Return early if grayscale.
    hue = 0;
    sat = 0;
  } else {
    if (li < 1) {
      sat = chroma / li;
    } else {
      sat = chroma / (2 - li);
    }
    if (red === val) {
      // Magenta to yellow.
      hue = (green - blue) / chroma;
    } else if (green === val) {
      // Yellow to cyan.
      hue = 2 + (blue - red) / chroma;
    } else if (blue === val) {
      // Cyan to magenta.
      hue = 4 + (red - green) / chroma;
    }
    if (hue < 0) {
      // Confine hue to the interval [0, 1).
      hue += 6;
    } else if (hue >= 6) {
      hue -= 6;
    }
  }

  return [hue / 6, sat, li / 2, rgba[3]];
};

module.exports = p5.ColorConversion;

},{"../core/core":22}],15:[function(_dereq_,module,exports){
/**
 * @module Color
 * @submodule Creating & Reading
 * @for p5
 * @requires core
 * @requires constants
 */

'use strict';

var p5 = _dereq_('../core/core');
var constants = _dereq_('../core/constants');
_dereq_('./p5.Color');
_dereq_('../core/error_helpers');

/**
 * Extracts the alpha value from a color or pixel array.
 *
 * @method alpha
 * @param {p5.Color|Number[]|String} color p5.Color object, color components,
 *                                         or CSS color
 * @return {Number} the alpha value
 * @example
 * <div>
 * <code>
 * noStroke();
 * var c = color(0, 126, 255, 102);
 * fill(c);
 * rect(15, 15, 35, 70);
 * var value = alpha(c); // Sets 'value' to 102
 * fill(value);
 * rect(50, 15, 35, 70);
 * </code>
 * </div>
 *
 * @alt
 * Left half of canvas light blue and right half light charcoal grey.
 * Left half of canvas light purple and right half a royal blue.
 * Left half of canvas salmon pink and the right half white.
 * Yellow rect in middle right of canvas, with 55 pixel width and height.
 * Yellow ellipse in top left canvas, black ellipse in bottom right,both 80x80.
 * Bright fuschia rect in middle of canvas, 60 pixel width and height.
 * Two bright green rects on opposite sides of the canvas, both 45x80.
 * Four blue rects in each corner of the canvas, each are 35x35.
 * Bright sea green rect on left and darker rect on right of canvas, both 45x80.
 * Dark green rect on left and light green rect on right of canvas, both 45x80.
 * Dark blue rect on left and light teal rect on right of canvas, both 45x80.
 * blue rect on left and green on right, both with black outlines & 35x60.
 * salmon pink rect on left and black on right, both 35x60.
 * 4 rects, tan, brown, brownish purple and purple, with white outlines & 20x60.
 * light pastel green rect on left and dark grey rect on right, both 35x60.
 * yellow rect on left and red rect on right, both with black outlines & 35x60.
 * grey canvas
 * deep pink rect on left and grey rect on right, both 35x60.
 */
p5.prototype.alpha = function(c) {
  p5._validateParameters('alpha', arguments);
  return this.color(c)._getAlpha();
};

/**
 * Extracts the blue value from a color or pixel array.
 *
 * @method blue
 * @param {p5.Color|Number[]|String} color p5.Color object, color components,
 *                                         or CSS color
 * @return {Number} the blue value
 * @example
 * <div>
 * <code>
 * var c = color(175, 100, 220); // Define color 'c'
 * fill(c); // Use color variable 'c' as fill color
 * rect(15, 20, 35, 60); // Draw left rectangle
 *
 * var blueValue = blue(c); // Get blue in 'c'
 * print(blueValue); // Prints "220.0"
 * fill(0, 0, blueValue); // Use 'blueValue' in new fill
 * rect(50, 20, 35, 60); // Draw right rectangle
 * </code>
 * </div>
 *
 * @alt
 * Left half of canvas light purple and right half a royal blue.
 *
 */
p5.prototype.blue = function(c) {
  p5._validateParameters('blue', arguments);
  return this.color(c)._getBlue();
};

/**
 * Extracts the HSB brightness value from a color or pixel array.
 *
 * @method brightness
 * @param {p5.Color|Number[]|String} color p5.Color object, color components,
 *                                         or CSS color
 * @return {Number} the brightness value
 * @example
 * <div>
 * <code>
 * noStroke();
 * colorMode(HSB, 255);
 * var c = color(0, 126, 255);
 * fill(c);
 * rect(15, 20, 35, 60);
 * var value = brightness(c); // Sets 'value' to 255
 * fill(value);
 * rect(50, 20, 35, 60);
 * </code>
 * </div>
 *
 * @alt
 * Left half of canvas salmon pink and the right half white.
 *
 */
p5.prototype.brightness = function(c) {
  p5._validateParameters('brightness', arguments);
  return this.color(c)._getBrightness();
};

/**
 * Creates colors for storing in variables of the color datatype. The
 * parameters are interpreted as RGB or HSB values depending on the
 * current colorMode(). The default mode is RGB values from 0 to 255
 * and, therefore, the function call color(255, 204, 0) will return a
 * bright yellow color.
 * <br><br>
 * Note that if only one value is provided to color(), it will be interpreted
 * as a grayscale value. Add a second value, and it will be used for alpha
 * transparency. When three values are specified, they are interpreted as
 * either RGB or HSB values. Adding a fourth value applies alpha
 * transparency.
 * <br><br>
 * If a single string argument is provided, RGB, RGBA and Hex CSS color
 * strings and all named color strings are supported. In this case, an alpha
 * number value as a second argument is not supported, the RGBA form should be
 * used.
 *
 * @method color
 * @param  {Number}        gray    number specifying value between white
 *                                 and black.
 * @param  {Number}        [alpha] alpha value relative to current color range
 *                                 (default is 0-255)
 * @return {p5.Color}              resulting color
 *
 * @example
 * <div>
 * <code>
 * var c = color(255, 204, 0); // Define color 'c'
 * fill(c); // Use color variable 'c' as fill color
 * noStroke(); // Don't draw a stroke around shapes
 * rect(30, 20, 55, 55); // Draw rectangle
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * var c = color(255, 204, 0); // Define color 'c'
 * fill(c); // Use color variable 'c' as fill color
 * noStroke(); // Don't draw a stroke around shapes
 * ellipse(25, 25, 80, 80); // Draw left circle
 *
 * // Using only one value with color()
 * // generates a grayscale value.
 * c = color(65); // Update 'c' with grayscale value
 * fill(c); // Use updated 'c' as fill color
 * ellipse(75, 75, 80, 80); // Draw right circle
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // Named SVG & CSS colors may be used,
 * var c = color('magenta');
 * fill(c); // Use 'c' as fill color
 * noStroke(); // Don't draw a stroke around shapes
 * rect(20, 20, 60, 60); // Draw rectangle
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // as can hex color codes:
 * noStroke(); // Don't draw a stroke around shapes
 * var c = color('#0f0');
 * fill(c); // Use 'c' as fill color
 * rect(0, 10, 45, 80); // Draw rectangle
 *
 * c = color('#00ff00');
 * fill(c); // Use updated 'c' as fill color
 * rect(55, 10, 45, 80); // Draw rectangle
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // RGB and RGBA color strings are also supported:
 * // these all set to the same color (solid blue)
 * var c;
 * noStroke(); // Don't draw a stroke around shapes
 * c = color('rgb(0,0,255)');
 * fill(c); // Use 'c' as fill color
 * rect(10, 10, 35, 35); // Draw rectangle
 *
 * c = color('rgb(0%, 0%, 100%)');
 * fill(c); // Use updated 'c' as fill color
 * rect(55, 10, 35, 35); // Draw rectangle
 *
 * c = color('rgba(0, 0, 255, 1)');
 * fill(c); // Use updated 'c' as fill color
 * rect(10, 55, 35, 35); // Draw rectangle
 *
 * c = color('rgba(0%, 0%, 100%, 1)');
 * fill(c); // Use updated 'c' as fill color
 * rect(55, 55, 35, 35); // Draw rectangle
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // HSL color is also supported and can be specified
 * // by value
 * var c;
 * noStroke(); // Don't draw a stroke around shapes
 * c = color('hsl(160, 100%, 50%)');
 * fill(c); // Use 'c' as fill color
 * rect(0, 10, 45, 80); // Draw rectangle
 *
 * c = color('hsla(160, 100%, 50%, 0.5)');
 * fill(c); // Use updated 'c' as fill color
 * rect(55, 10, 45, 80); // Draw rectangle
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // HSB color is also supported and can be specified
 * // by value
 * var c;
 * noStroke(); // Don't draw a stroke around shapes
 * c = color('hsb(160, 100%, 50%)');
 * fill(c); // Use 'c' as fill color
 * rect(0, 10, 45, 80); // Draw rectangle
 *
 * c = color('hsba(160, 100%, 50%, 0.5)');
 * fill(c); // Use updated 'c' as fill color
 * rect(55, 10, 45, 80); // Draw rectangle
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * var c; // Declare color 'c'
 * noStroke(); // Don't draw a stroke around shapes
 *
 * // If no colorMode is specified, then the
 * // default of RGB with scale of 0-255 is used.
 * c = color(50, 55, 100); // Create a color for 'c'
 * fill(c); // Use color variable 'c' as fill color
 * rect(0, 10, 45, 80); // Draw left rect
 *
 * colorMode(HSB, 100); // Use HSB with scale of 0-100
 * c = color(50, 55, 100); // Update 'c' with new color
 * fill(c); // Use updated 'c' as fill color
 * rect(55, 10, 45, 80); // Draw right rect
 * </code>
 * </div>
 *
 * @alt
 * Yellow rect in middle right of canvas, with 55 pixel width and height.
 * Yellow ellipse in top left of canvas, black ellipse in bottom right,both 80x80.
 * Bright fuschia rect in middle of canvas, 60 pixel width and height.
 * Two bright green rects on opposite sides of the canvas, both 45x80.
 * Four blue rects in each corner of the canvas, each are 35x35.
 * Bright sea green rect on left and darker rect on right of canvas, both 45x80.
 * Dark green rect on left and lighter green rect on right of canvas, both 45x80.
 * Dark blue rect on left and light teal rect on right of canvas, both 45x80.
 *
 */
/**
 * @method color
 * @param  {Number}        v1      red or hue value relative to
 *                                 the current color range
 * @param  {Number}        v2      green or saturation value
 *                                 relative to the current color range
 * @param  {Number}        v3      blue or brightness value
 *                                 relative to the current color range
 * @param  {Number}        [alpha]
 * @return {p5.Color}
 */

/**
 * @method color
 * @param  {String}        value   a color string
 * @param  {Number}        [alpha]
 * @return {p5.Color}
 */
/**
 * @method color
 * @param  {Number[]}      values  an array containing the red,green,blue &
 *                                 and alpha components of the color
 * @return {p5.Color}
 */
/**
 * @method color
 * @param  {p5.Color}     color
 * @return {p5.Color}
 */

p5.prototype.color = function() {
  p5._validateParameters('color', arguments);
  if (arguments[0] instanceof p5.Color) {
    return arguments[0]; // Do nothing if argument is already a color object.
  }

  var args = arguments[0] instanceof Array ? arguments[0] : arguments;
  return new p5.Color(this, args);
};

/**
 * Extracts the green value from a color or pixel array.
 *
 * @method green
 * @param {p5.Color|Number[]|String} color p5.Color object, color components,
 *                                         or CSS color
 * @return {Number} the green value
 * @example
 * <div>
 * <code>
 * var c = color(20, 75, 200); // Define color 'c'
 * fill(c); // Use color variable 'c' as fill color
 * rect(15, 20, 35, 60); // Draw left rectangle
 *
 * var greenValue = green(c); // Get green in 'c'
 * print(greenValue); // Print "75.0"
 * fill(0, greenValue, 0); // Use 'greenValue' in new fill
 * rect(50, 20, 35, 60); // Draw right rectangle
 * </code>
 * </div>
 *
 * @alt
 * blue rect on left and green on right, both with black outlines & 35x60.
 *
 */

p5.prototype.green = function(c) {
  p5._validateParameters('green', arguments);
  return this.color(c)._getGreen();
};

/**
 * Extracts the hue value from a color or pixel array.
 *
 * Hue exists in both HSB and HSL. This function will return the
 * HSB-normalized hue when supplied with an HSB color object (or when supplied
 * with a pixel array while the color mode is HSB), but will default to the
 * HSL-normalized hue otherwise. (The values will only be different if the
 * maximum hue setting for each system is different.)
 *
 * @method hue
 * @param {p5.Color|Number[]|String} color p5.Color object, color components,
 *                                         or CSS color
 * @return {Number} the hue
 * @example
 * <div>
 * <code>
 * noStroke();
 * colorMode(HSB, 255);
 * var c = color(0, 126, 255);
 * fill(c);
 * rect(15, 20, 35, 60);
 * var value = hue(c); // Sets 'value' to "0"
 * fill(value);
 * rect(50, 20, 35, 60);
 * </code>
 * </div>
 *
 * @alt
 * salmon pink rect on left and black on right, both 35x60.
 *
 */

p5.prototype.hue = function(c) {
  p5._validateParameters('hue', arguments);
  return this.color(c)._getHue();
};

/**
 * Blends two colors to find a third color somewhere between them. The amt
 * parameter is the amount to interpolate between the two values where 0.0
 * equal to the first color, 0.1 is very near the first color, 0.5 is halfway
 * in between, etc. An amount below 0 will be treated as 0. Likewise, amounts
 * above 1 will be capped at 1. This is different from the behavior of lerp(),
 * but necessary because otherwise numbers outside the range will produce
 * strange and unexpected colors.
 * <br><br>
 * The way that colours are interpolated depends on the current color mode.
 *
 * @method lerpColor
 * @param  {p5.Color} c1  interpolate from this color
 * @param  {p5.Color} c2  interpolate to this color
 * @param  {Number}       amt number between 0 and 1
 * @return {p5.Color}     interpolated color
 * @example
 * <div>
 * <code>
 * colorMode(RGB);
 * stroke(255);
 * background(51);
 * var from = color(218, 165, 32);
 * var to = color(72, 61, 139);
 * colorMode(RGB); // Try changing to HSB.
 * var interA = lerpColor(from, to, 0.33);
 * var interB = lerpColor(from, to, 0.66);
 * fill(from);
 * rect(10, 20, 20, 60);
 * fill(interA);
 * rect(30, 20, 20, 60);
 * fill(interB);
 * rect(50, 20, 20, 60);
 * fill(to);
 * rect(70, 20, 20, 60);
 * </code>
 * </div>
 *
 * @alt
 * 4 rects one tan, brown, brownish purple, purple, with white outlines & 20x60
 *
 */

p5.prototype.lerpColor = function(c1, c2, amt) {
  p5._validateParameters('lerpColor', arguments);
  var mode = this._colorMode;
  var maxes = this._colorMaxes;
  var l0, l1, l2, l3;
  var fromArray, toArray;

  if (mode === constants.RGB) {
    fromArray = c1.levels.map(function(level) {
      return level / 255;
    });
    toArray = c2.levels.map(function(level) {
      return level / 255;
    });
  } else if (mode === constants.HSB) {
    c1._getBrightness(); // Cache hsba so it definitely exists.
    c2._getBrightness();
    fromArray = c1.hsba;
    toArray = c2.hsba;
  } else if (mode === constants.HSL) {
    c1._getLightness(); // Cache hsla so it definitely exists.
    c2._getLightness();
    fromArray = c1.hsla;
    toArray = c2.hsla;
  } else {
    throw new Error(mode + 'cannot be used for interpolation.');
  }

  // Prevent extrapolation.
  amt = Math.max(Math.min(amt, 1), 0);

  // Define lerp here itself if user isn't using math module.
  // Maintains the definition as found in math/calculation.js
  if (typeof this.lerp === 'undefined') {
    this.lerp = function(start, stop, amt) {
      return amt * (stop - start) + start;
    };
  }

  // Perform interpolation.
  l0 = this.lerp(fromArray[0], toArray[0], amt);
  l1 = this.lerp(fromArray[1], toArray[1], amt);
  l2 = this.lerp(fromArray[2], toArray[2], amt);
  l3 = this.lerp(fromArray[3], toArray[3], amt);

  // Scale components.
  l0 *= maxes[mode][0];
  l1 *= maxes[mode][1];
  l2 *= maxes[mode][2];
  l3 *= maxes[mode][3];

  return this.color(l0, l1, l2, l3);
};

/**
 * Extracts the HSL lightness value from a color or pixel array.
 *
 * @method lightness
 * @param {p5.Color|Number[]|String} color p5.Color object, color components,
 *                                         or CSS color
 * @return {Number} the lightness
 * @example
 * <div>
 * <code>
 * noStroke();
 * colorMode(HSL);
 * var c = color(156, 100, 50, 1);
 * fill(c);
 * rect(15, 20, 35, 60);
 * var value = lightness(c); // Sets 'value' to 50
 * fill(value);
 * rect(50, 20, 35, 60);
 * </code>
 * </div>
 *
 * @alt
 * light pastel green rect on left and dark grey rect on right, both 35x60.
 *
 */
p5.prototype.lightness = function(c) {
  p5._validateParameters('lightness', arguments);
  return this.color(c)._getLightness();
};

/**
 * Extracts the red value from a color or pixel array.
 *
 * @method red
 * @param {p5.Color|Number[]|String} color p5.Color object, color components,
 *                                         or CSS color
 * @return {Number} the red value
 * @example
 * <div>
 * <code>
 * var c = color(255, 204, 0); // Define color 'c'
 * fill(c); // Use color variable 'c' as fill color
 * rect(15, 20, 35, 60); // Draw left rectangle
 *
 * var redValue = red(c); // Get red in 'c'
 * print(redValue); // Print "255.0"
 * fill(redValue, 0, 0); // Use 'redValue' in new fill
 * rect(50, 20, 35, 60); // Draw right rectangle
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * colorMode(RGB, 255);
 * var c = color(127, 255, 0);
 * colorMode(RGB, 1);
 * var myColor = red(c);
 * print(myColor);
 * </code>
 * </div>
 *
 * @alt
 * yellow rect on left and red rect on right, both with black outlines and 35x60.
 * grey canvas
 */
p5.prototype.red = function(c) {
  p5._validateParameters('red', arguments);
  return this.color(c)._getRed();
};

/**
 * Extracts the saturation value from a color or pixel array.
 *
 * Saturation is scaled differently in HSB and HSL. This function will return
 * the HSB saturation when supplied with an HSB color object (or when supplied
 * with a pixel array while the color mode is HSB), but will default to the
 * HSL saturation otherwise.
 *
 * @method saturation
 * @param {p5.Color|Number[]|String} color p5.Color object, color components,
 *                                         or CSS color
 * @return {Number} the saturation value
 * @example
 * <div>
 * <code>
 * noStroke();
 * colorMode(HSB, 255);
 * var c = color(0, 126, 255);
 * fill(c);
 * rect(15, 20, 35, 60);
 * var value = saturation(c); // Sets 'value' to 126
 * fill(value);
 * rect(50, 20, 35, 60);
 * </code>
 * </div>
 *
 * @alt
 *deep pink rect on left and grey rect on right, both 35x60.
 *
 */

p5.prototype.saturation = function(c) {
  p5._validateParameters('saturation', arguments);
  return this.color(c)._getSaturation();
};

module.exports = p5;

},{"../core/constants":21,"../core/core":22,"../core/error_helpers":25,"./p5.Color":16}],16:[function(_dereq_,module,exports){
/**
 * @module Color
 * @submodule Creating & Reading
 * @for p5
 * @requires core
 * @requires constants
 * @requires color_conversion
 */

'use strict';

var p5 = _dereq_('../core/core');
var constants = _dereq_('../core/constants');
var color_conversion = _dereq_('./color_conversion');

/**
 * Each color stores the color mode and level maxes that applied at the
 * time of its construction. These are used to interpret the input arguments
 * (at construction and later for that instance of color) and to format the
 * output e.g. when saturation() is requested.
 *
 * Internally we store an array representing the ideal RGBA values in floating
 * point form, normalized from 0 to 1. From this we calculate the closest
 * screen color (RGBA levels from 0 to 255) and expose this to the renderer.
 *
 * We also cache normalized, floating point components of the color in various
 * representations as they are calculated. This is done to prevent repeating a
 * conversion that has already been performed.
 *
 * @class p5.Color
 * @constructor
 */
p5.Color = function(pInst, vals) {
  // Record color mode and maxes at time of construction.
  this._storeModeAndMaxes(pInst._colorMode, pInst._colorMaxes);

  // Calculate normalized RGBA values.
  if (
    this.mode !== constants.RGB &&
    this.mode !== constants.HSL &&
    this.mode !== constants.HSB
  ) {
    throw new Error(this.mode + ' is an invalid colorMode.');
  } else {
    this._array = p5.Color._parseInputs.apply(this, vals);
  }

  // Expose closest screen color.
  this._calculateLevels();
  this.name = 'p5.Color'; // for friendly debugger system
  return this;
};

/**
 * @method toString
 * @return {String}
 * @example
 * <div>
 * <code>
 * var myColor;
 * function setup() {
 *   createCanvas(200, 200);
 *   stroke(255);
 *   myColor = color(100, 100, 250);
 *   fill(myColor);
 * }
 *
 * function draw() {
 *   text(myColor.toString(), 10, 10);
 * }
 * </code>
 * </div>
 *
 * @alt
 * canvas with text representation of color
 */
p5.Color.prototype.toString = function() {
  var a = this.levels;
  var alpha = this._array[3]; // String representation uses normalized alpha.
  return 'rgba(' + a[0] + ',' + a[1] + ',' + a[2] + ',' + alpha + ')';
};

/**
 * @method setRed
 * @param {Number} red the new red value
 * @example
 * <div>
 * <code>
 * var backgroundColor;
 *
 * function setup() {
 *   backgroundColor = color(100, 50, 150);
 * }
 *
 * function draw() {
 *   backgroundColor.setRed(128 + 128 * sin(millis() / 1000));
 *   background(backgroundColor);
 * }
 * </code>
 * </div>
 *
 * @alt
 * canvas with gradually changing background color
 */
p5.Color.prototype.setRed = function(new_red) {
  this._array[0] = new_red / this.maxes[constants.RGB][0];
  this._calculateLevels();
};

/**
 * @method setGreen
 * @param {Number} green the new green value
 * @example
 * <div>
 * <code>
 * var backgroundColor;
 *
 * function setup() {
 *   backgroundColor = color(100, 50, 150);
 * }
 *
 * function draw() {
 *   backgroundColor.setGreen(128 + 128 * sin(millis() / 1000));
 *   background(backgroundColor);
 * }
 * </code>
 * </div>
 *
 * @alt
 * canvas with gradually changing background color
 **/
p5.Color.prototype.setGreen = function(new_green) {
  this._array[1] = new_green / this.maxes[constants.RGB][1];
  this._calculateLevels();
};

/**
 * @method setBlue
 * @param {Number} blue the new blue value
 * @example
 * <div>
 * <code>
 * var backgroundColor;
 *
 * function setup() {
 *   backgroundColor = color(100, 50, 150);
 * }
 *
 * function draw() {
 *   backgroundColor.setBlue(128 + 128 * sin(millis() / 1000));
 *   background(backgroundColor);
 * }
 * </code>
 * </div>
 *
 * @alt
 * canvas with gradually changing background color
 **/
p5.Color.prototype.setBlue = function(new_blue) {
  this._array[2] = new_blue / this.maxes[constants.RGB][2];
  this._calculateLevels();
};

/**
 * @method setAlpha
 * @param {Number} alpha the new alpha value
 * @example
 * <div>
 * <code>
 * var squareColor;
 *
 * function setup() {
 *   ellipseMode(CORNERS);
 *   strokeWeight(4);
 *   squareColor = color(100, 50, 150);
 * }
 *
 * function draw() {
 *   background(255);
 *
 *   noFill();
 *   stroke(0);
 *   ellipse(10, 10, width - 10, height - 10);
 *
 *   squareColor.setAlpha(128 + 128 * sin(millis() / 1000));
 *   fill(squareColor);
 *   noStroke();
 *   rect(13, 13, width - 26, height - 26);
 * }
 * </code>
 * </div>
 *
 * @alt
 * circle behind a square with gradually changing opacity
 **/
p5.Color.prototype.setAlpha = function(new_alpha) {
  this._array[3] = new_alpha / this.maxes[this.mode][3];
  this._calculateLevels();
};

// calculates and stores the closest screen levels
p5.Color.prototype._calculateLevels = function() {
  this.levels = this._array.map(function(level) {
    return Math.round(level * 255);
  });
};

p5.Color.prototype._getAlpha = function() {
  return this._array[3] * this.maxes[this.mode][3];
};

// stores the color mode and maxes in this instance of Color
// for later use (by _parseInputs())
p5.Color.prototype._storeModeAndMaxes = function(new_mode, new_maxes) {
  this.mode = new_mode;
  this.maxes = new_maxes;
};

p5.Color.prototype._getMode = function() {
  return this.mode;
};

p5.Color.prototype._getMaxes = function() {
  return this.maxes;
};

p5.Color.prototype._getBlue = function() {
  return this._array[2] * this.maxes[constants.RGB][2];
};

p5.Color.prototype._getBrightness = function() {
  if (!this.hsba) {
    this.hsba = color_conversion._rgbaToHSBA(this._array);
  }
  return this.hsba[2] * this.maxes[constants.HSB][2];
};

p5.Color.prototype._getGreen = function() {
  return this._array[1] * this.maxes[constants.RGB][1];
};

/**
 * Hue is the same in HSB and HSL, but the maximum value may be different.
 * This function will return the HSB-normalized saturation when supplied with
 * an HSB color object, but will default to the HSL-normalized saturation
 * otherwise.
 */
p5.Color.prototype._getHue = function() {
  if (this.mode === constants.HSB) {
    if (!this.hsba) {
      this.hsba = color_conversion._rgbaToHSBA(this._array);
    }
    return this.hsba[0] * this.maxes[constants.HSB][0];
  } else {
    if (!this.hsla) {
      this.hsla = color_conversion._rgbaToHSLA(this._array);
    }
    return this.hsla[0] * this.maxes[constants.HSL][0];
  }
};

p5.Color.prototype._getLightness = function() {
  if (!this.hsla) {
    this.hsla = color_conversion._rgbaToHSLA(this._array);
  }
  return this.hsla[2] * this.maxes[constants.HSL][2];
};

p5.Color.prototype._getRed = function() {
  return this._array[0] * this.maxes[constants.RGB][0];
};

/**
 * Saturation is scaled differently in HSB and HSL. This function will return
 * the HSB saturation when supplied with an HSB color object, but will default
 * to the HSL saturation otherwise.
 */
p5.Color.prototype._getSaturation = function() {
  if (this.mode === constants.HSB) {
    if (!this.hsba) {
      this.hsba = color_conversion._rgbaToHSBA(this._array);
    }
    return this.hsba[1] * this.maxes[constants.HSB][1];
  } else {
    if (!this.hsla) {
      this.hsla = color_conversion._rgbaToHSLA(this._array);
    }
    return this.hsla[1] * this.maxes[constants.HSL][1];
  }
};

/**
 * CSS named colors.
 */
var namedColors = {
  aliceblue: '#f0f8ff',
  antiquewhite: '#faebd7',
  aqua: '#00ffff',
  aquamarine: '#7fffd4',
  azure: '#f0ffff',
  beige: '#f5f5dc',
  bisque: '#ffe4c4',
  black: '#000000',
  blanchedalmond: '#ffebcd',
  blue: '#0000ff',
  blueviolet: '#8a2be2',
  brown: '#a52a2a',
  burlywood: '#deb887',
  cadetblue: '#5f9ea0',
  chartreuse: '#7fff00',
  chocolate: '#d2691e',
  coral: '#ff7f50',
  cornflowerblue: '#6495ed',
  cornsilk: '#fff8dc',
  crimson: '#dc143c',
  cyan: '#00ffff',
  darkblue: '#00008b',
  darkcyan: '#008b8b',
  darkgoldenrod: '#b8860b',
  darkgray: '#a9a9a9',
  darkgreen: '#006400',
  darkgrey: '#a9a9a9',
  darkkhaki: '#bdb76b',
  darkmagenta: '#8b008b',
  darkolivegreen: '#556b2f',
  darkorange: '#ff8c00',
  darkorchid: '#9932cc',
  darkred: '#8b0000',
  darksalmon: '#e9967a',
  darkseagreen: '#8fbc8f',
  darkslateblue: '#483d8b',
  darkslategray: '#2f4f4f',
  darkslategrey: '#2f4f4f',
  darkturquoise: '#00ced1',
  darkviolet: '#9400d3',
  deeppink: '#ff1493',
  deepskyblue: '#00bfff',
  dimgray: '#696969',
  dimgrey: '#696969',
  dodgerblue: '#1e90ff',
  firebrick: '#b22222',
  floralwhite: '#fffaf0',
  forestgreen: '#228b22',
  fuchsia: '#ff00ff',
  gainsboro: '#dcdcdc',
  ghostwhite: '#f8f8ff',
  gold: '#ffd700',
  goldenrod: '#daa520',
  gray: '#808080',
  green: '#008000',
  greenyellow: '#adff2f',
  grey: '#808080',
  honeydew: '#f0fff0',
  hotpink: '#ff69b4',
  indianred: '#cd5c5c',
  indigo: '#4b0082',
  ivory: '#fffff0',
  khaki: '#f0e68c',
  lavender: '#e6e6fa',
  lavenderblush: '#fff0f5',
  lawngreen: '#7cfc00',
  lemonchiffon: '#fffacd',
  lightblue: '#add8e6',
  lightcoral: '#f08080',
  lightcyan: '#e0ffff',
  lightgoldenrodyellow: '#fafad2',
  lightgray: '#d3d3d3',
  lightgreen: '#90ee90',
  lightgrey: '#d3d3d3',
  lightpink: '#ffb6c1',
  lightsalmon: '#ffa07a',
  lightseagreen: '#20b2aa',
  lightskyblue: '#87cefa',
  lightslategray: '#778899',
  lightslategrey: '#778899',
  lightsteelblue: '#b0c4de',
  lightyellow: '#ffffe0',
  lime: '#00ff00',
  limegreen: '#32cd32',
  linen: '#faf0e6',
  magenta: '#ff00ff',
  maroon: '#800000',
  mediumaquamarine: '#66cdaa',
  mediumblue: '#0000cd',
  mediumorchid: '#ba55d3',
  mediumpurple: '#9370db',
  mediumseagreen: '#3cb371',
  mediumslateblue: '#7b68ee',
  mediumspringgreen: '#00fa9a',
  mediumturquoise: '#48d1cc',
  mediumvioletred: '#c71585',
  midnightblue: '#191970',
  mintcream: '#f5fffa',
  mistyrose: '#ffe4e1',
  moccasin: '#ffe4b5',
  navajowhite: '#ffdead',
  navy: '#000080',
  oldlace: '#fdf5e6',
  olive: '#808000',
  olivedrab: '#6b8e23',
  orange: '#ffa500',
  orangered: '#ff4500',
  orchid: '#da70d6',
  palegoldenrod: '#eee8aa',
  palegreen: '#98fb98',
  paleturquoise: '#afeeee',
  palevioletred: '#db7093',
  papayawhip: '#ffefd5',
  peachpuff: '#ffdab9',
  peru: '#cd853f',
  pink: '#ffc0cb',
  plum: '#dda0dd',
  powderblue: '#b0e0e6',
  purple: '#800080',
  red: '#ff0000',
  rosybrown: '#bc8f8f',
  royalblue: '#4169e1',
  saddlebrown: '#8b4513',
  salmon: '#fa8072',
  sandybrown: '#f4a460',
  seagreen: '#2e8b57',
  seashell: '#fff5ee',
  sienna: '#a0522d',
  silver: '#c0c0c0',
  skyblue: '#87ceeb',
  slateblue: '#6a5acd',
  slategray: '#708090',
  slategrey: '#708090',
  snow: '#fffafa',
  springgreen: '#00ff7f',
  steelblue: '#4682b4',
  tan: '#d2b48c',
  teal: '#008080',
  thistle: '#d8bfd8',
  tomato: '#ff6347',
  turquoise: '#40e0d0',
  violet: '#ee82ee',
  wheat: '#f5deb3',
  white: '#ffffff',
  whitesmoke: '#f5f5f5',
  yellow: '#ffff00',
  yellowgreen: '#9acd32'
};

/**
 * These regular expressions are used to build up the patterns for matching
 * viable CSS color strings: fragmenting the regexes in this way increases the
 * legibility and comprehensibility of the code.
 *
 * Note that RGB values of .9 are not parsed by IE, but are supported here for
 * color string consistency.
 */
var WHITESPACE = /\s*/; // Match zero or more whitespace characters.
var INTEGER = /(\d{1,3})/; // Match integers: 79, 255, etc.
var DECIMAL = /((?:\d+(?:\.\d+)?)|(?:\.\d+))/; // Match 129.6, 79, .9, etc.
var PERCENT = new RegExp(DECIMAL.source + '%'); // Match 12.9%, 79%, .9%, etc.

/**
 * Full color string patterns. The capture groups are necessary.
 */
var colorPatterns = {
  // Match colors in format #XXX, e.g. #416.
  HEX3: /^#([a-f0-9])([a-f0-9])([a-f0-9])$/i,

  // Match colors in format #XXXX, e.g. #5123.
  HEX4: /^#([a-f0-9])([a-f0-9])([a-f0-9])([a-f0-9])$/i,

  // Match colors in format #XXXXXX, e.g. #b4d455.
  HEX6: /^#([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})$/i,

  // Match colors in format #XXXXXXXX, e.g. #b4d45535.
  HEX8: /^#([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})$/i,

  // Match colors in format rgb(R, G, B), e.g. rgb(255, 0, 128).
  RGB: new RegExp(
    [
      '^rgb\\(',
      INTEGER.source,
      ',',
      INTEGER.source,
      ',',
      INTEGER.source,
      '\\)$'
    ].join(WHITESPACE.source),
    'i'
  ),

  // Match colors in format rgb(R%, G%, B%), e.g. rgb(100%, 0%, 28.9%).
  RGB_PERCENT: new RegExp(
    [
      '^rgb\\(',
      PERCENT.source,
      ',',
      PERCENT.source,
      ',',
      PERCENT.source,
      '\\)$'
    ].join(WHITESPACE.source),
    'i'
  ),

  // Match colors in format rgb(R, G, B, A), e.g. rgb(255, 0, 128, 0.25).
  RGBA: new RegExp(
    [
      '^rgba\\(',
      INTEGER.source,
      ',',
      INTEGER.source,
      ',',
      INTEGER.source,
      ',',
      DECIMAL.source,
      '\\)$'
    ].join(WHITESPACE.source),
    'i'
  ),

  // Match colors in format rgb(R%, G%, B%, A), e.g. rgb(100%, 0%, 28.9%, 0.5).
  RGBA_PERCENT: new RegExp(
    [
      '^rgba\\(',
      PERCENT.source,
      ',',
      PERCENT.source,
      ',',
      PERCENT.source,
      ',',
      DECIMAL.source,
      '\\)$'
    ].join(WHITESPACE.source),
    'i'
  ),

  // Match colors in format hsla(H, S%, L%), e.g. hsl(100, 40%, 28.9%).
  HSL: new RegExp(
    [
      '^hsl\\(',
      INTEGER.source,
      ',',
      PERCENT.source,
      ',',
      PERCENT.source,
      '\\)$'
    ].join(WHITESPACE.source),
    'i'
  ),

  // Match colors in format hsla(H, S%, L%, A), e.g. hsla(100, 40%, 28.9%, 0.5).
  HSLA: new RegExp(
    [
      '^hsla\\(',
      INTEGER.source,
      ',',
      PERCENT.source,
      ',',
      PERCENT.source,
      ',',
      DECIMAL.source,
      '\\)$'
    ].join(WHITESPACE.source),
    'i'
  ),

  // Match colors in format hsb(H, S%, B%), e.g. hsb(100, 40%, 28.9%).
  HSB: new RegExp(
    [
      '^hsb\\(',
      INTEGER.source,
      ',',
      PERCENT.source,
      ',',
      PERCENT.source,
      '\\)$'
    ].join(WHITESPACE.source),
    'i'
  ),

  // Match colors in format hsba(H, S%, B%, A), e.g. hsba(100, 40%, 28.9%, 0.5).
  HSBA: new RegExp(
    [
      '^hsba\\(',
      INTEGER.source,
      ',',
      PERCENT.source,
      ',',
      PERCENT.source,
      ',',
      DECIMAL.source,
      '\\)$'
    ].join(WHITESPACE.source),
    'i'
  )
};

/**
 * For a number of different inputs, returns a color formatted as [r, g, b, a]
 * arrays, with each component normalized between 0 and 1.
 *
 * @private
 * @param {Array} [...args] An 'array-like' object that represents a list of
 *                          arguments
 * @return {Number[]}       a color formatted as [r, g, b, a]
 *                          Example:
 *                          input        ==> output
 *                          g            ==> [g, g, g, 255]
 *                          g,a          ==> [g, g, g, a]
 *                          r, g, b      ==> [r, g, b, 255]
 *                          r, g, b, a   ==> [r, g, b, a]
 *                          [g]          ==> [g, g, g, 255]
 *                          [g, a]       ==> [g, g, g, a]
 *                          [r, g, b]    ==> [r, g, b, 255]
 *                          [r, g, b, a] ==> [r, g, b, a]
 * @example
 * <div>
 * <code>
 * // todo
 * </code>
 * </div>
 *
 * @alt
 * //todo
 *
 */
p5.Color._parseInputs = function(r, g, b, a) {
  var numArgs = arguments.length;
  var mode = this.mode;
  var maxes = this.maxes;
  var results = [];

  if (numArgs >= 3) {
    // Argument is a list of component values.

    results[0] = r / maxes[mode][0];
    results[1] = g / maxes[mode][1];
    results[2] = b / maxes[mode][2];

    // Alpha may be undefined, so default it to 100%.
    if (typeof a === 'number') {
      results[3] = a / maxes[mode][3];
    } else {
      results[3] = 1;
    }

    // Constrain components to the range [0,1].
    results = results.map(function(value) {
      return Math.max(Math.min(value, 1), 0);
    });

    // Convert to RGBA and return.
    if (mode === constants.HSL) {
      return color_conversion._hslaToRGBA(results);
    } else if (mode === constants.HSB) {
      return color_conversion._hsbaToRGBA(results);
    } else {
      return results;
    }
  } else if (numArgs === 1 && typeof r === 'string') {
    var str = r.trim().toLowerCase();

    // Return if string is a named colour.
    if (namedColors[str]) {
      return p5.Color._parseInputs.call(this, namedColors[str]);
    }

    // Try RGBA pattern matching.
    if (colorPatterns.HEX3.test(str)) {
      // #rgb
      results = colorPatterns.HEX3.exec(str)
        .slice(1)
        .map(function(color) {
          return parseInt(color + color, 16) / 255;
        });
      results[3] = 1;
      return results;
    } else if (colorPatterns.HEX6.test(str)) {
      // #rrggbb
      results = colorPatterns.HEX6.exec(str)
        .slice(1)
        .map(function(color) {
          return parseInt(color, 16) / 255;
        });
      results[3] = 1;
      return results;
    } else if (colorPatterns.HEX4.test(str)) {
      // #rgba
      results = colorPatterns.HEX4.exec(str)
        .slice(1)
        .map(function(color) {
          return parseInt(color + color, 16) / 255;
        });
      return results;
    } else if (colorPatterns.HEX8.test(str)) {
      // #rrggbbaa
      results = colorPatterns.HEX8.exec(str)
        .slice(1)
        .map(function(color) {
          return parseInt(color, 16) / 255;
        });
      return results;
    } else if (colorPatterns.RGB.test(str)) {
      // rgb(R,G,B)
      results = colorPatterns.RGB.exec(str)
        .slice(1)
        .map(function(color) {
          return color / 255;
        });
      results[3] = 1;
      return results;
    } else if (colorPatterns.RGB_PERCENT.test(str)) {
      // rgb(R%,G%,B%)
      results = colorPatterns.RGB_PERCENT.exec(str)
        .slice(1)
        .map(function(color) {
          return parseFloat(color) / 100;
        });
      results[3] = 1;
      return results;
    } else if (colorPatterns.RGBA.test(str)) {
      // rgba(R,G,B,A)
      results = colorPatterns.RGBA.exec(str)
        .slice(1)
        .map(function(color, idx) {
          if (idx === 3) {
            return parseFloat(color);
          }
          return color / 255;
        });
      return results;
    } else if (colorPatterns.RGBA_PERCENT.test(str)) {
      // rgba(R%,G%,B%,A%)
      results = colorPatterns.RGBA_PERCENT.exec(str)
        .slice(1)
        .map(function(color, idx) {
          if (idx === 3) {
            return parseFloat(color);
          }
          return parseFloat(color) / 100;
        });
      return results;
    }

    // Try HSLA pattern matching.
    if (colorPatterns.HSL.test(str)) {
      // hsl(H,S,L)
      results = colorPatterns.HSL.exec(str)
        .slice(1)
        .map(function(color, idx) {
          if (idx === 0) {
            return parseInt(color, 10) / 360;
          }
          return parseInt(color, 10) / 100;
        });
      results[3] = 1;
    } else if (colorPatterns.HSLA.test(str)) {
      // hsla(H,S,L,A)
      results = colorPatterns.HSLA.exec(str)
        .slice(1)
        .map(function(color, idx) {
          if (idx === 0) {
            return parseInt(color, 10) / 360;
          } else if (idx === 3) {
            return parseFloat(color);
          }
          return parseInt(color, 10) / 100;
        });
    }
    results = results.map(function(value) {
      return Math.max(Math.min(value, 1), 0);
    });
    if (results.length) {
      return color_conversion._hslaToRGBA(results);
    }

    // Try HSBA pattern matching.
    if (colorPatterns.HSB.test(str)) {
      // hsb(H,S,B)
      results = colorPatterns.HSB.exec(str)
        .slice(1)
        .map(function(color, idx) {
          if (idx === 0) {
            return parseInt(color, 10) / 360;
          }
          return parseInt(color, 10) / 100;
        });
      results[3] = 1;
    } else if (colorPatterns.HSBA.test(str)) {
      // hsba(H,S,B,A)
      results = colorPatterns.HSBA.exec(str)
        .slice(1)
        .map(function(color, idx) {
          if (idx === 0) {
            return parseInt(color, 10) / 360;
          } else if (idx === 3) {
            return parseFloat(color);
          }
          return parseInt(color, 10) / 100;
        });
    }
    results = results.map(function(value) {
      return Math.max(Math.min(value, 1), 0);
    });

    if (results.length) {
      return color_conversion._hsbaToRGBA(results);
    }

    // Input did not match any CSS color pattern: default to white.
    results = [1, 1, 1, 1];
  } else if ((numArgs === 1 || numArgs === 2) && typeof r === 'number') {
    // 'Grayscale' mode.

    /**
     * For HSB and HSL, interpret the gray level as a brightness/lightness
     * value (they are equivalent when chroma is zero). For RGB, normalize the
     * gray level according to the blue maximum.
     */
    results[0] = r / maxes[mode][2];
    results[1] = r / maxes[mode][2];
    results[2] = r / maxes[mode][2];

    // Alpha may be undefined, so default it to 100%.
    if (typeof g === 'number') {
      results[3] = g / maxes[mode][3];
    } else {
      results[3] = 1;
    }

    // Constrain components to the range [0,1].
    results = results.map(function(value) {
      return Math.max(Math.min(value, 1), 0);
    });
  } else {
    throw new Error(arguments + 'is not a valid color representation.');
  }

  return results;
};

module.exports = p5.Color;

},{"../core/constants":21,"../core/core":22,"./color_conversion":14}],17:[function(_dereq_,module,exports){
/**
 * @module Color
 * @submodule Setting
 * @for p5
 * @requires core
 * @requires constants
 */

'use strict';

var p5 = _dereq_('../core/core');
var constants = _dereq_('../core/constants');
_dereq_('./p5.Color');

/**
 * The background() function sets the color used for the background of the
 * p5.js canvas. The default background is light gray. This function is
 * typically used within draw() to clear the display window at the beginning
 * of each frame, but it can be used inside setup() to set the background on
 * the first frame of animation or if the background need only be set once.
 * <br><br>
 * The color is either specified in terms of the RGB, HSB, or HSL color
 * depending on the current colorMode. (The default color space is RGB, with
 * each value in the range from 0 to 255). The alpha range by default is also 0 to 255.
 * <br><br>
 * If a single string argument is provided, RGB, RGBA and Hex CSS color strings
 * and all named color strings are supported. In this case, an alpha number
 * value as a second argument is not supported, the RGBA form should be used.
 * <br><br>
 * A p5.Color object can also be provided to set the background color.
 * <br><br>
 * A p5.Image can also be provided to set the background iamge.
 *
 * @method background
 * @param {p5.Color} color     any value created by the color() function
 * @chainable
 *
 * @example
 * <div>
 * <code>
 * // Grayscale integer value
 * background(51);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // R, G & B integer values
 * background(255, 204, 0);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // H, S & B integer values
 * colorMode(HSB);
 * background(255, 204, 100);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // Named SVG/CSS color string
 * background('red');
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // three-digit hexadecimal RGB notation
 * background('#fae');
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // six-digit hexadecimal RGB notation
 * background('#222222');
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // integer RGB notation
 * background('rgb(0,255,0)');
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // integer RGBA notation
 * background('rgba(0,255,0, 0.25)');
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // percentage RGB notation
 * background('rgb(100%,0%,10%)');
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // percentage RGBA notation
 * background('rgba(100%,0%,100%,0.5)');
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // p5 Color object
 * background(color(0, 0, 255));
 * </code>
 * </div>
 *
 * @alt
 * canvas with darkest charcoal grey background.
 * canvas with yellow background.
 * canvas with royal blue background.
 * canvas with red background.
 * canvas with pink background.
 * canvas with black background.
 * canvas with bright green background.
 * canvas with soft green background.
 * canvas with red background.
 * canvas with light purple background.
 * canvas with blue background.
 */

/**
 * @method background
 * @param {String} colorstring color string, possible formats include: integer
 *                         rgb() or rgba(), percentage rgb() or rgba(),
 *                         3-digit hex, 6-digit hex
 * @param {Number} [a]         opacity of the background relative to current
 *                             color range (default is 0-255)
 * @chainable
 */

/**
 * @method background
 * @param {Number} gray   specifies a value between white and black
 * @param {Number} [a]
 * @chainable
 */

/**
 * @method background
 * @param {Number} v1     red or hue value (depending on the current color
 *                        mode)
 * @param {Number} v2     green or saturation value (depending on the current
 *                        color mode)
 * @param {Number} v3     blue or brightness value (depending on the current
 *                        color mode)
 * @param  {Number} [a]
 * @chainable
 */

/**
 * @method background
 * @param  {Number[]}      values  an array containing the red,green,blue &
 *                                 and alpha components of the color
 * @chainable
 */

/**
 * @method background
 * @param {p5.Image} image     image created with loadImage() or createImage(),
 *                             to set as background
 *                             (must be same size as the sketch window)
 * @param  {Number}  [a]
 * @chainable
 */

p5.prototype.background = function() {
  if (arguments[0] instanceof p5.Image) {
    this.image(arguments[0], 0, 0, this.width, this.height);
  } else {
    this._renderer.background.apply(this._renderer, arguments);
  }
  return this;
};

/**
 * Clears the pixels within a buffer. This function only works on p5.Canvas
 * objects created with the createCanvas() function; it won't work with the
 * main display window. Unlike the main graphics context, pixels in
 * additional graphics areas created with createGraphics() can be entirely
 * or partially transparent. This function clears everything to make all of
 * the pixels 100% transparent.
 *
 * @method clear
 * @chainable
 * @example
 * <div>
 * <code>
 * // Clear the screen on mouse press.
 * function setup() {
 *   createCanvas(100, 100);
 * }
 *
 * function draw() {
 *   ellipse(mouseX, mouseY, 20, 20);
 * }
 *
 * function mousePressed() {
 *   clear();
 * }
 * </code>
 * </div>
 *
 * @alt
 * 20x20 white ellipses are continually drawn at mouse x and y coordinates.
 *
 */

p5.prototype.clear = function() {
  this._renderer.clear();
  return this;
};

/**
 * colorMode() changes the way p5.js interprets color data. By default, the
 * parameters for fill(), stroke(), background(), and color() are defined by
 * values between 0 and 255 using the RGB color model. This is equivalent to
 * setting colorMode(RGB, 255). Setting colorMode(HSB) lets you use the HSB
 * system instead. By default, this is colorMode(HSB, 360, 100, 100, 1). You
 * can also use HSL.
 * <br><br>
 * Note: existing color objects remember the mode that they were created in,
 * so you can change modes as you like without affecting their appearance.
 *
 *
 * @method colorMode
 * @param {Constant} mode   either RGB, HSB or HSL, corresponding to
 *                          Red/Green/Blue and Hue/Saturation/Brightness
 *                          (or Lightness)
 * @param {Number}  [max]  range for all values
 * @chainable
 *
 * @example
 * <div>
 * <code>
 * noStroke();
 * colorMode(RGB, 100);
 * for (var i = 0; i < 100; i++) {
 *   for (var j = 0; j < 100; j++) {
 *     stroke(i, j, 0);
 *     point(i, j);
 *   }
 * }
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * noStroke();
 * colorMode(HSB, 100);
 * for (var i = 0; i < 100; i++) {
 *   for (var j = 0; j < 100; j++) {
 *     stroke(i, j, 100);
 *     point(i, j);
 *   }
 * }
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * colorMode(RGB, 255);
 * var c = color(127, 255, 0);
 *
 * colorMode(RGB, 1);
 * var myColor = c._getRed();
 * text(myColor, 10, 10, 80, 80);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * noFill();
 * colorMode(RGB, 255, 255, 255, 1);
 * background(255);
 *
 * strokeWeight(4);
 * stroke(255, 0, 10, 0.3);
 * ellipse(40, 40, 50, 50);
 * ellipse(50, 50, 40, 40);
 * </code>
 * </div>
 *
 * @alt
 *Green to red gradient from bottom L to top R. shading originates from top left.
 *Rainbow gradient from left to right. Brightness increasing to white at top.
 *unknown image.
 *50x50 ellipse at middle L & 40x40 ellipse at center. Transluscent pink outlines.
 *
 */
/**
 * @method colorMode
 * @param {Constant} mode
 * @param {Number} max1     range for the red or hue depending on the
 *                              current color mode
 * @param {Number} max2     range for the green or saturation depending
 *                              on the current color mode
 * @param {Number} max3     range for the blue or brightness/lighntess
 *                              depending on the current color mode
 * @param {Number} [maxA]   range for the alpha
 * @chainable
 */
p5.prototype.colorMode = function(mode, max1, max2, max3, maxA) {
  p5._validateParameters('colorMode', arguments);
  if (
    mode === constants.RGB ||
    mode === constants.HSB ||
    mode === constants.HSL
  ) {
    // Set color mode.
    this._colorMode = mode;

    // Set color maxes.
    var maxes = this._colorMaxes[mode];
    if (arguments.length === 2) {
      maxes[0] = max1; // Red
      maxes[1] = max1; // Green
      maxes[2] = max1; // Blue
      maxes[3] = max1; // Alpha
    } else if (arguments.length === 4) {
      maxes[0] = max1; // Red
      maxes[1] = max2; // Green
      maxes[2] = max3; // Blue
    } else if (arguments.length === 5) {
      maxes[0] = max1; // Red
      maxes[1] = max2; // Green
      maxes[2] = max3; // Blue
      maxes[3] = maxA; // Alpha
    }
  }

  return this;
};

/**
 * Sets the color used to fill shapes. For example, if you run
 * fill(204, 102, 0), all subsequent shapes will be filled with orange. This
 * color is either specified in terms of the RGB or HSB color depending on
 * the current colorMode(). (The default color space is RGB, with each value
 * in the range from 0 to 255). The alpha range by default is also 0 to 255.
 * <br><br>
 * If a single string argument is provided, RGB, RGBA and Hex CSS color strings
 * and all named color strings are supported. In this case, an alpha number
 * value as a second argument is not supported, the RGBA form should be used.
 * <br><br>
 * A p5 Color object can also be provided to set the fill color.
 *
 * @method fill
 * @param  {Number}        v1      red or hue value relative to
 *                                 the current color range
 * @param  {Number}        v2      green or saturation value
 *                                 relative to the current color range
 * @param  {Number}        v3      blue or brightness value
 *                                 relative to the current color range
 * @param  {Number}        [alpha]
 * @chainable
 * @example
 * <div>
 * <code>
 * // Grayscale integer value
 * fill(51);
 * rect(20, 20, 60, 60);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // R, G & B integer values
 * fill(255, 204, 0);
 * rect(20, 20, 60, 60);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // H, S & B integer values
 * colorMode(HSB);
 * fill(255, 204, 100);
 * rect(20, 20, 60, 60);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // Named SVG/CSS color string
 * fill('red');
 * rect(20, 20, 60, 60);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // three-digit hexadecimal RGB notation
 * fill('#fae');
 * rect(20, 20, 60, 60);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // six-digit hexadecimal RGB notation
 * fill('#222222');
 * rect(20, 20, 60, 60);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // integer RGB notation
 * fill('rgb(0,255,0)');
 * rect(20, 20, 60, 60);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // integer RGBA notation
 * fill('rgba(0,255,0, 0.25)');
 * rect(20, 20, 60, 60);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // percentage RGB notation
 * fill('rgb(100%,0%,10%)');
 * rect(20, 20, 60, 60);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // percentage RGBA notation
 * fill('rgba(100%,0%,100%,0.5)');
 * rect(20, 20, 60, 60);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // p5 Color object
 * fill(color(0, 0, 255));
 * rect(20, 20, 60, 60);
 * </code>
 * </div>
 * @alt
 * 60x60 dark charcoal grey rect with black outline in center of canvas.
 * 60x60 yellow rect with black outline in center of canvas.
 * 60x60 royal blue rect with black outline in center of canvas.
 * 60x60 red rect with black outline in center of canvas.
 * 60x60 pink rect with black outline in center of canvas.
 * 60x60 black rect with black outline in center of canvas.
 * 60x60 light green rect with black outline in center of canvas.
 * 60x60 soft green rect with black outline in center of canvas.
 * 60x60 red rect with black outline in center of canvas.
 * 60x60 dark fushcia rect with black outline in center of canvas.
 * 60x60 blue rect with black outline in center of canvas.
 */

/**
 * @method fill
 * @param  {String}        value   a color string
 * @param  {Number}        [alpha]
 * @chainable
 */

/**
 * @method fill
 * @param  {Number[]}      values  an array containing the red,green,blue &
 *                                 and alpha components of the color
 * @chainable
 */

/**
 * @method fill
 * @param  {p5.Color}      color   the fill color
 * @chainable
 */
p5.prototype.fill = function() {
  this._renderer._setProperty('_fillSet', true);
  this._renderer._setProperty('_doFill', true);
  this._renderer.fill.apply(this._renderer, arguments);
  return this;
};

/**
 * Disables filling geometry. If both noStroke() and noFill() are called,
 * nothing will be drawn to the screen.
 *
 * @method noFill
 * @chainable
 * @example
 * <div>
 * <code>
 * rect(15, 10, 55, 55);
 * noFill();
 * rect(20, 20, 60, 60);
 * </code>
 * </div>
 *
 * <div modernizr='webgl'>
 * <code>
 * function setup() {
 *   createCanvas(100, 100, WEBGL);
 * }
 *
 * function draw() {
 *   background(0);
 *   noFill();
 *   stroke(100, 100, 240);
 *   rotateX(frameCount * 0.01);
 *   rotateY(frameCount * 0.01);
 *   box(45, 45, 45);
 * }
 * </code>
 * </div>
 *
 * @alt
 * white rect top middle and noFill rect center. Both 60x60 with black outlines.
 * black canvas with purple cube wireframe spinning
 */
p5.prototype.noFill = function() {
  this._renderer._setProperty('_doFill', false);
  return this;
};

/**
 * Disables drawing the stroke (outline). If both noStroke() and noFill()
 * are called, nothing will be drawn to the screen.
 *
 * @method noStroke
 * @chainable
 * @example
 * <div>
 * <code>
 * noStroke();
 * rect(20, 20, 60, 60);
 * </code>
 * </div>
 *
 * <div modernizr='webgl'>
 * <code>
 * function setup() {
 *   createCanvas(100, 100, WEBGL);
 * }
 *
 * function draw() {
 *   background(0);
 *   noStroke();
 *   fill(240, 150, 150);
 *   rotateX(frameCount * 0.01);
 *   rotateY(frameCount * 0.01);
 *   box(45, 45, 45);
 * }
 * </code>
 * </div>
 *
 * @alt
 * 60x60 white rect at center. no outline.
 * black canvas with pink cube spinning
 */
p5.prototype.noStroke = function() {
  this._renderer._setProperty('_doStroke', false);
  return this;
};

/**
 * Sets the color used to draw lines and borders around shapes. This color
 * is either specified in terms of the RGB or HSB color depending on the
 * current colorMode() (the default color space is RGB, with each value in
 * the range from 0 to 255). The alpha range by default is also 0 to 255.
 * <br><br>
 * If a single string argument is provided, RGB, RGBA and Hex CSS color
 * strings and all named color strings are supported. In this case, an alpha
 * number value as a second argument is not supported, the RGBA form should be
 * used.
 * <br><br>
 * A p5 Color object can also be provided to set the stroke color.
 *
 *
 * @method stroke
 * @param  {Number}        v1      red or hue value relative to
 *                                 the current color range
 * @param  {Number}        v2      green or saturation value
 *                                 relative to the current color range
 * @param  {Number}        v3      blue or brightness value
 *                                 relative to the current color range
 * @param  {Number}        [alpha]
 * @chainable
 *
 * @example
 * <div>
 * <code>
 * // Grayscale integer value
 * strokeWeight(4);
 * stroke(51);
 * rect(20, 20, 60, 60);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // R, G & B integer values
 * stroke(255, 204, 0);
 * strokeWeight(4);
 * rect(20, 20, 60, 60);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // H, S & B integer values
 * colorMode(HSB);
 * strokeWeight(4);
 * stroke(255, 204, 100);
 * rect(20, 20, 60, 60);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // Named SVG/CSS color string
 * stroke('red');
 * strokeWeight(4);
 * rect(20, 20, 60, 60);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // three-digit hexadecimal RGB notation
 * stroke('#fae');
 * strokeWeight(4);
 * rect(20, 20, 60, 60);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // six-digit hexadecimal RGB notation
 * stroke('#222222');
 * strokeWeight(4);
 * rect(20, 20, 60, 60);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // integer RGB notation
 * stroke('rgb(0,255,0)');
 * strokeWeight(4);
 * rect(20, 20, 60, 60);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // integer RGBA notation
 * stroke('rgba(0,255,0,0.25)');
 * strokeWeight(4);
 * rect(20, 20, 60, 60);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // percentage RGB notation
 * stroke('rgb(100%,0%,10%)');
 * strokeWeight(4);
 * rect(20, 20, 60, 60);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // percentage RGBA notation
 * stroke('rgba(100%,0%,100%,0.5)');
 * strokeWeight(4);
 * rect(20, 20, 60, 60);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // p5 Color object
 * stroke(color(0, 0, 255));
 * strokeWeight(4);
 * rect(20, 20, 60, 60);
 * </code>
 * </div>
 *
 * @alt
 * 60x60 white rect at center. Dark charcoal grey outline.
 * 60x60 white rect at center. Yellow outline.
 * 60x60 white rect at center. Royal blue outline.
 * 60x60 white rect at center. Red outline.
 * 60x60 white rect at center. Pink outline.
 * 60x60 white rect at center. Black outline.
 * 60x60 white rect at center. Bright green outline.
 * 60x60 white rect at center. Soft green outline.
 * 60x60 white rect at center. Red outline.
 * 60x60 white rect at center. Dark fushcia outline.
 * 60x60 white rect at center. Blue outline.
 */

/**
 * @method stroke
 * @param  {String}        value   a color string
 * @param  {Number}        [alpha]
 * @chainable
 */

/**
 * @method stroke
 * @param  {Number[]}      values  an array containing the red,green,blue &
 *                                 and alpha components of the color
 * @chainable
 */

/**
 * @method stroke
 * @param  {p5.Color}      color   the stroke color
 * @chainable
 */

p5.prototype.stroke = function() {
  this._renderer._setProperty('_strokeSet', true);
  this._renderer._setProperty('_doStroke', true);
  this._renderer.stroke.apply(this._renderer, arguments);
  return this;
};

module.exports = p5;

},{"../core/constants":21,"../core/core":22,"./p5.Color":16}],18:[function(_dereq_,module,exports){
/**
 * @module Shape
 * @submodule 2D Primitives
 * @for p5
 * @requires core
 * @requires constants
 */

'use strict';

var p5 = _dereq_('./core');
var constants = _dereq_('./constants');
var canvas = _dereq_('./canvas');
_dereq_('./error_helpers');

/**
 * Draw an arc to the screen. If called with only x, y, w, h, start, and
 * stop, the arc will be drawn and filled as an open pie segment. If a mode parameter is provided, the arc
 * will be filled like an open semi-circle (OPEN) , a closed semi-circle (CHORD), or as a closed pie segment (PIE). The
 * origin may be changed with the ellipseMode() function.<br><br>
 * Note that drawing a full circle (ex: 0 to TWO_PI) will appear blank
 * because 0 and TWO_PI are the same position on the unit circle. The
 * best way to handle this is by using the ellipse() function instead
 * to create a closed ellipse, and to use the arc() function
 * only to draw parts of an ellipse.
 *
 * @method arc
 * @param  {Number} x      x-coordinate of the arc's ellipse
 * @param  {Number} y      y-coordinate of the arc's ellipse
 * @param  {Number} w      width of the arc's ellipse by default
 * @param  {Number} h      height of the arc's ellipse by default
 * @param  {Number} start  angle to start the arc, specified in radians
 * @param  {Number} stop   angle to stop the arc, specified in radians
 * @param  {Constant} [mode] optional parameter to determine the way of drawing
 *                         the arc. either CHORD, PIE or OPEN
 * @chainable
 * @example
 * <div>
 * <code>
 * arc(50, 55, 50, 50, 0, HALF_PI);
 * noFill();
 * arc(50, 55, 60, 60, HALF_PI, PI);
 * arc(50, 55, 70, 70, PI, PI + QUARTER_PI);
 * arc(50, 55, 80, 80, PI + QUARTER_PI, TWO_PI);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * arc(50, 50, 80, 80, 0, PI + QUARTER_PI);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * arc(50, 50, 80, 80, 0, PI + QUARTER_PI, OPEN);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * arc(50, 50, 80, 80, 0, PI + QUARTER_PI, CHORD);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * arc(50, 50, 80, 80, 0, PI + QUARTER_PI, PIE);
 * </code>
 * </div>
 *
 * @alt
 *shattered outline of an ellipse with a quarter of a white circle bottom-right.
 *white ellipse with top right quarter missing.
 *white ellipse with black outline with top right missing.
 *white ellipse with top right missing with black outline around shape.
 *white ellipse with top right quarter missing with black outline around the shape.
 *
 */
p5.prototype.arc = function(x, y, w, h, start, stop, mode) {
  p5._validateParameters('arc', arguments);
  if (!this._renderer._doStroke && !this._renderer._doFill) {
    return this;
  }
  if (this._angleMode === constants.DEGREES) {
    start = this.radians(start);
    stop = this.radians(stop);
  }

  // Make all angles positive...
  while (start < 0) {
    start += constants.TWO_PI;
  }
  while (stop < 0) {
    stop += constants.TWO_PI;
  }
  // ...and confine them to the interval [0,TWO_PI).
  start %= constants.TWO_PI;
  stop %= constants.TWO_PI;

  // account for full circle
  if (stop === start) {
    stop += constants.TWO_PI;
  }

  // Adjust angles to counter linear scaling.
  if (start <= constants.HALF_PI) {
    start = Math.atan(w / h * Math.tan(start));
  } else if (start > constants.HALF_PI && start <= 3 * constants.HALF_PI) {
    start = Math.atan(w / h * Math.tan(start)) + constants.PI;
  } else {
    start = Math.atan(w / h * Math.tan(start)) + constants.TWO_PI;
  }
  if (stop <= constants.HALF_PI) {
    stop = Math.atan(w / h * Math.tan(stop));
  } else if (stop > constants.HALF_PI && stop <= 3 * constants.HALF_PI) {
    stop = Math.atan(w / h * Math.tan(stop)) + constants.PI;
  } else {
    stop = Math.atan(w / h * Math.tan(stop)) + constants.TWO_PI;
  }

  // Exceed the interval if necessary in order to preserve the size and
  // orientation of the arc.
  if (start > stop) {
    stop += constants.TWO_PI;
  }
  // p5 supports negative width and heights for ellipses
  w = Math.abs(w);
  h = Math.abs(h);
  this._renderer.arc(x, y, w, h, start, stop, mode);
  return this;
};

/**
 * Draws an ellipse (oval) to the screen. An ellipse with equal width and
 * height is a circle. By default, the first two parameters set the location,
 * and the third and fourth parameters set the shape's width and height. If
 * no height is specified, the value of width is used for both the width and
 * height. If a negative height or width is specified, the absolute value is taken.
 * The origin may be changed with the ellipseMode() function.
 *
 * @method ellipse
 * @param  {Number} x x-coordinate of the ellipse.
 * @param  {Number} y y-coordinate of the ellipse.
 * @param  {Number} w width of the ellipse.
 * @param  {Number} [h] height of the ellipse.
 * @chainable
 * @example
 * <div>
 * <code>
 * ellipse(56, 46, 55, 55);
 * </code>
 * </div>
 *
 * @alt
 *white ellipse with black outline in middle-right of canvas that is 55x55.
 *
 */
/**
 * @method ellipse
 * @param  {Number} x
 * @param  {Number} y
 * @param  {Number} w
 * @param  {Number} h
 * @param  {Integer} detailX number of segments in the x-direction
 * @param  {Integer} [detailY] number of segments in the y-direction
 */
p5.prototype.ellipse = function(x, y, w, h, detailX, detailY) {
  p5._validateParameters('ellipse', arguments);

  // p5 supports negative width and heights for rects
  if (w < 0) {
    w = Math.abs(w);
  }

  if (typeof h === 'undefined') {
    // Duplicate 3rd argument if only 3 given.
    h = w;
  } else if (h < 0) {
    h = Math.abs(h);
  }

  if (this._renderer._doStroke || this._renderer._doFill) {
    var vals = canvas.modeAdjust(x, y, w, h, this._renderer._ellipseMode);
    this._renderer.ellipse([vals.x, vals.y, vals.w, vals.h, detailX, detailY]);
  }

  return this;
};
/**
 * Draws a line (a direct path between two points) to the screen. The version
 * of line() with four parameters draws the line in 2D. To color a line, use
 * the stroke() function. A line cannot be filled, therefore the fill()
 * function will not affect the color of a line. 2D lines are drawn with a
 * width of one pixel by default, but this can be changed with the
 * strokeWeight() function.
 *
 * @method line
 * @param  {Number} x1 the x-coordinate of the first point
 * @param  {Number} y1 the y-coordinate of the first point
 * @param  {Number} x2 the x-coordinate of the second point
 * @param  {Number} y2 the y-coordinate of the second point
 * @chainable
 * @example
 * <div>
 * <code>
 * line(30, 20, 85, 75);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * line(30, 20, 85, 20);
 * stroke(126);
 * line(85, 20, 85, 75);
 * stroke(255);
 * line(85, 75, 30, 75);
 * </code>
 * </div>
 *
 * @alt
 *line 78 pixels long running from mid-top to bottom-right of canvas.
 *3 lines of various stroke sizes. Form top, bottom and right sides of a square.
 *
 */
/**
 * @method line
 * @param  {Number} x1
 * @param  {Number} y1
 * @param  {Number} z1 the z-coordinate of the first point
 * @param  {Number} x2
 * @param  {Number} y2
 * @param  {Number} z2 the z-coordinate of the second point
 * @chainable
 */
p5.prototype.line = function() {
  p5._validateParameters('line', arguments);

  if (this._renderer._doStroke) {
    this._renderer.line.apply(this._renderer, arguments);
  }

  return this;
};

/**
 * Draws a point, a coordinate in space at the dimension of one pixel.
 * The first parameter is the horizontal value for the point, the second
 * value is the vertical value for the point. The color of the point is
 * determined by the current stroke.
 *
 * @method point
 * @param  {Number} x the x-coordinate
 * @param  {Number} y the y-coordinate
 * @param  {Number} [z] the z-coordinate (for WEBGL mode)
 * @chainable
 * @example
 * <div>
 * <code>
 * point(30, 20);
 * point(85, 20);
 * point(85, 75);
 * point(30, 75);
 * </code>
 * </div>
 *
 * @alt
 *4 points centered in the middle-right of the canvas.
 *
 */
p5.prototype.point = function() {
  p5._validateParameters('point', arguments);

  if (this._renderer._doStroke) {
    this._renderer.point.apply(this._renderer, arguments);
  }

  return this;
};

/**
 * Draw a quad. A quad is a quadrilateral, a four sided polygon. It is
 * similar to a rectangle, but the angles between its edges are not
 * constrained to ninety degrees. The first pair of parameters (x1,y1)
 * sets the first vertex and the subsequent pairs should proceed
 * clockwise or counter-clockwise around the defined shape.
 *
 * @method quad
 * @param {Number} x1 the x-coordinate of the first point
 * @param {Number} y1 the y-coordinate of the first point
 * @param {Number} x2 the x-coordinate of the second point
 * @param {Number} y2 the y-coordinate of the second point
 * @param {Number} x3 the x-coordinate of the third point
 * @param {Number} y3 the y-coordinate of the third point
 * @param {Number} x4 the x-coordinate of the fourth point
 * @param {Number} y4 the y-coordinate of the fourth point
 * @chainable
 * @example
 * <div>
 * <code>
 * quad(38, 31, 86, 20, 69, 63, 30, 76);
 * </code>
 * </div>
 *
 * @alt
 *irregular white quadrilateral shape with black outline mid-right of canvas.
 *
 */
/**
 * @method quad
 * @param {Number} x1
 * @param {Number} y1
 * @param {Number} z1
 * @param {Number} x2
 * @param {Number} y2
 * @param {Number} z2
 * @param {Number} x3
 * @param {Number} y3
 * @param {Number} z3
 * @param {Number} x4
 * @param {Number} y4
 * @param {Number} z4
 * @chainable
 */
p5.prototype.quad = function() {
  p5._validateParameters('quad', arguments);

  if (this._renderer._doStroke || this._renderer._doFill) {
    this._renderer.quad.apply(this._renderer, arguments);
  }

  return this;
};

/**
 * Draws a rectangle to the screen. A rectangle is a four-sided shape with
 * every angle at ninety degrees. By default, the first two parameters set
 * the location of the upper-left corner, the third sets the width, and the
 * fourth sets the height. The way these parameters are interpreted, however,
 * may be changed with the rectMode() function.
 * <br><br>
 * The fifth, sixth, seventh and eighth parameters, if specified,
 * determine corner radius for the top-right, top-left, lower-right and
 * lower-left corners, respectively. An omitted corner radius parameter is set
 * to the value of the previously specified radius value in the parameter list.
 *
 * @method rect
 * @param  {Number} x  x-coordinate of the rectangle.
 * @param  {Number} y  y-coordinate of the rectangle.
 * @param  {Number} w  width of the rectangle.
 * @param  {Number} h  height of the rectangle.
 * @param  {Number} [tl] optional radius of top-left corner.
 * @param  {Number} [tr] optional radius of top-right corner.
 * @param  {Number} [br] optional radius of bottom-right corner.
 * @param  {Number} [bl] optional radius of bottom-left corner.
 * @chainable
 * @example
 * <div>
 * <code>
 * // Draw a rectangle at location (30, 20) with a width and height of 55.
 * rect(30, 20, 55, 55);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // Draw a rectangle with rounded corners, each having a radius of 20.
 * rect(30, 20, 55, 55, 20);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // Draw a rectangle with rounded corners having the following radii:
 * // top-left = 20, top-right = 15, bottom-right = 10, bottom-left = 5.
 * rect(30, 20, 55, 55, 20, 15, 10, 5);
 * </code>
 * </div>
 *
 * @alt
 * 55x55 white rect with black outline in mid-right of canvas.
 * 55x55 white rect with black outline and rounded edges in mid-right of canvas.
 * 55x55 white rect with black outline and rounded edges of different radii.
 */
/**
 * @method rect
 * @param  {Number} x
 * @param  {Number} y
 * @param  {Number} w
 * @param  {Number} h
 * @param  {Integer} [detailX] number of segments in the x-direction
 * @param  {Integer} [detailY] number of segments in the y-direction
 * @chainable
 */
p5.prototype.rect = function(x, y, w, h, detailX, detailY) {
  p5._validateParameters('rect', arguments);

  if (this._renderer._doStroke || this._renderer._doFill) {
    var vals = canvas.modeAdjust(x, y, w, h, this._renderer._rectMode);
    this._renderer.rect([vals.x, vals.y, vals.w, vals.h, detailX, detailY]);
  }

  return this;
};

/**
 * A triangle is a plane created by connecting three points. The first two
 * arguments specify the first point, the middle two arguments specify the
 * second point, and the last two arguments specify the third point.
 *
 * @method triangle
 * @param  {Number} x1 x-coordinate of the first point
 * @param  {Number} y1 y-coordinate of the first point
 * @param  {Number} x2 x-coordinate of the second point
 * @param  {Number} y2 y-coordinate of the second point
 * @param  {Number} x3 x-coordinate of the third point
 * @param  {Number} y3 y-coordinate of the third point
 * @chainable
 * @example
 * <div>
 * <code>
 * triangle(30, 75, 58, 20, 86, 75);
 * </code>
 * </div>
 *
 *@alt
 * white triangle with black outline in mid-right of canvas.
 *
 */
p5.prototype.triangle = function() {
  p5._validateParameters('triangle', arguments);

  if (this._renderer._doStroke || this._renderer._doFill) {
    this._renderer.triangle(arguments);
  }

  return this;
};

module.exports = p5;

},{"./canvas":20,"./constants":21,"./core":22,"./error_helpers":25}],19:[function(_dereq_,module,exports){
/**
 * @module Shape
 * @submodule Attributes
 * @for p5
 * @requires core
 * @requires constants
 */

'use strict';

var p5 = _dereq_('./core');
var constants = _dereq_('./constants');

/**
 * Modifies the location from which ellipses are drawn by changing the way
 * in which parameters given to ellipse() are interpreted.
 * <br><br>
 * The default mode is ellipseMode(CENTER), which interprets the first two
 * parameters of ellipse() as the shape's center point, while the third and
 * fourth parameters are its width and height.
 * <br><br>
 * ellipseMode(RADIUS) also uses the first two parameters of ellipse() as
 * the shape's center point, but uses the third and fourth parameters to
 * specify half of the shapes's width and height.
 * <br><br>
 * ellipseMode(CORNER) interprets the first two parameters of ellipse() as
 * the upper-left corner of the shape, while the third and fourth parameters
 * are its width and height.
 * <br><br>
 * ellipseMode(CORNERS) interprets the first two parameters of ellipse() as
 * the location of one corner of the ellipse's bounding box, and the third
 * and fourth parameters as the location of the opposite corner.
 * <br><br>
 * The parameter must be written in ALL CAPS because Javascript is a
 * case-sensitive language.
 *
 * @method ellipseMode
 * @param  {Constant} mode either CENTER, RADIUS, CORNER, or CORNERS
 * @chainable
 * @example
 * <div>
 * <code>
 * ellipseMode(RADIUS); // Set ellipseMode to RADIUS
 * fill(255); // Set fill to white
 * ellipse(50, 50, 30, 30); // Draw white ellipse using RADIUS mode
 *
 * ellipseMode(CENTER); // Set ellipseMode to CENTER
 * fill(100); // Set fill to gray
 * ellipse(50, 50, 30, 30); // Draw gray ellipse using CENTER mode
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * ellipseMode(CORNER); // Set ellipseMode is CORNER
 * fill(255); // Set fill to white
 * ellipse(25, 25, 50, 50); // Draw white ellipse using CORNER mode
 *
 * ellipseMode(CORNERS); // Set ellipseMode to CORNERS
 * fill(100); // Set fill to gray
 * ellipse(25, 25, 50, 50); // Draw gray ellipse using CORNERS mode
 * </code>
 * </div>
 *
 * @alt
 * 60x60 white ellipse and 30x30 grey ellipse with black outlines at center.
 * 60x60 white ellipse @center and 30x30 grey ellipse top-right, black outlines.
 *
 */
p5.prototype.ellipseMode = function(m) {
  p5._validateParameters('ellipseMode', arguments);
  if (
    m === constants.CORNER ||
    m === constants.CORNERS ||
    m === constants.RADIUS ||
    m === constants.CENTER
  ) {
    this._renderer._ellipseMode = m;
  }
  return this;
};

/**
 * Draws all geometry with jagged (aliased) edges. Note that smooth() is
 * active by default, so it is necessary to call noSmooth() to disable
 * smoothing of geometry, images, and fonts.
 *
 * @method noSmooth
 * @chainable
 * @example
 * <div>
 * <code>
 * background(0);
 * noStroke();
 * smooth();
 * ellipse(30, 48, 36, 36);
 * noSmooth();
 * ellipse(70, 48, 36, 36);
 * </code>
 * </div>
 *
 * @alt
 * 2 pixelated 36x36 white ellipses to left & right of center, black background
 *
 */
p5.prototype.noSmooth = function() {
  this._renderer.noSmooth();
  return this;
};

/**
 * Modifies the location from which rectangles are drawn by changing the way
 * in which parameters given to rect() are interpreted.
 * <br><br>
 * The default mode is rectMode(CORNER), which interprets the first two
 * parameters of rect() as the upper-left corner of the shape, while the
 * third and fourth parameters are its width and height.
 * <br><br>
 * rectMode(CORNERS) interprets the first two parameters of rect() as the
 * location of one corner, and the third and fourth parameters as the
 * location of the opposite corner.
 * <br><br>
 * rectMode(CENTER) interprets the first two parameters of rect() as the
 * shape's center point, while the third and fourth parameters are its
 * width and height.
 * <br><br>
 * rectMode(RADIUS) also uses the first two parameters of rect() as the
 * shape's center point, but uses the third and fourth parameters to specify
 * half of the shapes's width and height.
 * <br><br>
 * The parameter must be written in ALL CAPS because Javascript is a
 * case-sensitive language.
 *
 * @method rectMode
 * @param  {Constant} mode either CORNER, CORNERS, CENTER, or RADIUS
 * @chainable
 * @example
 * <div>
 * <code>
 * rectMode(CORNER); // Default rectMode is CORNER
 * fill(255); // Set fill to white
 * rect(25, 25, 50, 50); // Draw white rect using CORNER mode
 *
 * rectMode(CORNERS); // Set rectMode to CORNERS
 * fill(100); // Set fill to gray
 * rect(25, 25, 50, 50); // Draw gray rect using CORNERS mode
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * rectMode(RADIUS); // Set rectMode to RADIUS
 * fill(255); // Set fill to white
 * rect(50, 50, 30, 30); // Draw white rect using RADIUS mode
 *
 * rectMode(CENTER); // Set rectMode to CENTER
 * fill(100); // Set fill to gray
 * rect(50, 50, 30, 30); // Draw gray rect using CENTER mode
 * </code>
 * </div>
 *
 * @alt
 * 50x50 white rect at center and 25x25 grey rect in the top left of the other.
 * 50x50 white rect at center and 25x25 grey rect in the center of the other.
 *
 */
p5.prototype.rectMode = function(m) {
  p5._validateParameters('rectMode', arguments);
  if (
    m === constants.CORNER ||
    m === constants.CORNERS ||
    m === constants.RADIUS ||
    m === constants.CENTER
  ) {
    this._renderer._rectMode = m;
  }
  return this;
};

/**
 * Draws all geometry with smooth (anti-aliased) edges. smooth() will also
 * improve image quality of resized images. Note that smooth() is active by
 * default; noSmooth() can be used to disable smoothing of geometry,
 * images, and fonts.
 *
 * @method smooth
 * @chainable
 * @example
 * <div>
 * <code>
 * background(0);
 * noStroke();
 * smooth();
 * ellipse(30, 48, 36, 36);
 * noSmooth();
 * ellipse(70, 48, 36, 36);
 * </code>
 * </div>
 *
 * @alt
 * 2 pixelated 36x36 white ellipses one left one right of center. On black.
 *
 */
p5.prototype.smooth = function() {
  this._renderer.smooth();
  return this;
};

/**
 * Sets the style for rendering line endings. These ends are either squared,
 * extended, or rounded, each of which specified with the corresponding
 * parameters: SQUARE, PROJECT, and ROUND. The default cap is ROUND.
 *
 * @method strokeCap
 * @param  {Constant} cap either SQUARE, PROJECT, or ROUND
 * @chainable
 * @example
 * <div>
 * <code>
 * strokeWeight(12.0);
 * strokeCap(ROUND);
 * line(20, 30, 80, 30);
 * strokeCap(SQUARE);
 * line(20, 50, 80, 50);
 * strokeCap(PROJECT);
 * line(20, 70, 80, 70);
 * </code>
 * </div>
 *
 * @alt
 * 3 lines. Top line: rounded ends, mid: squared, bottom:longer squared ends.
 *
 */
p5.prototype.strokeCap = function(cap) {
  p5._validateParameters('strokeCap', arguments);
  if (
    cap === constants.ROUND ||
    cap === constants.SQUARE ||
    cap === constants.PROJECT
  ) {
    this._renderer.strokeCap(cap);
  }
  return this;
};

/**
 * Sets the style of the joints which connect line segments. These joints
 * are either mitered, beveled, or rounded and specified with the
 * corresponding parameters MITER, BEVEL, and ROUND. The default joint is
 * MITER.
 *
 * @method strokeJoin
 * @param  {Constant} join either MITER, BEVEL, ROUND
 * @chainable
 * @example
 * <div>
 * <code>
 * noFill();
 * strokeWeight(10.0);
 * strokeJoin(MITER);
 * beginShape();
 * vertex(35, 20);
 * vertex(65, 50);
 * vertex(35, 80);
 * endShape();
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * noFill();
 * strokeWeight(10.0);
 * strokeJoin(BEVEL);
 * beginShape();
 * vertex(35, 20);
 * vertex(65, 50);
 * vertex(35, 80);
 * endShape();
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * noFill();
 * strokeWeight(10.0);
 * strokeJoin(ROUND);
 * beginShape();
 * vertex(35, 20);
 * vertex(65, 50);
 * vertex(35, 80);
 * endShape();
 * </code>
 * </div>
 *
 * @alt
 * Right-facing arrowhead shape with pointed tip in center of canvas.
 * Right-facing arrowhead shape with flat tip in center of canvas.
 * Right-facing arrowhead shape with rounded tip in center of canvas.
 *
 */
p5.prototype.strokeJoin = function(join) {
  p5._validateParameters('strokeJoin', arguments);
  if (
    join === constants.ROUND ||
    join === constants.BEVEL ||
    join === constants.MITER
  ) {
    this._renderer.strokeJoin(join);
  }
  return this;
};

/**
 * Sets the width of the stroke used for lines, points, and the border
 * around shapes. All widths are set in units of pixels.
 *
 * @method strokeWeight
 * @param  {Number} weight the weight (in pixels) of the stroke
 * @chainable
 * @example
 * <div>
 * <code>
 * strokeWeight(1); // Default
 * line(20, 20, 80, 20);
 * strokeWeight(4); // Thicker
 * line(20, 40, 80, 40);
 * strokeWeight(10); // Beastly
 * line(20, 70, 80, 70);
 * </code>
 * </div>
 *
 * @alt
 * 3 horizontal black lines. Top line: thin, mid: medium, bottom:thick.
 *
 */
p5.prototype.strokeWeight = function(w) {
  p5._validateParameters('strokeWeight', arguments);
  this._renderer.strokeWeight(w);
  return this;
};

module.exports = p5;

},{"./constants":21,"./core":22}],20:[function(_dereq_,module,exports){
/**
 * @requires constants
 */

'use strict';

var constants = _dereq_('./constants');

module.exports = {
  modeAdjust: function(a, b, c, d, mode) {
    if (mode === constants.CORNER) {
      return { x: a, y: b, w: c, h: d };
    } else if (mode === constants.CORNERS) {
      return { x: a, y: b, w: c - a, h: d - b };
    } else if (mode === constants.RADIUS) {
      return { x: a - c, y: b - d, w: 2 * c, h: 2 * d };
    } else if (mode === constants.CENTER) {
      return { x: a - c * 0.5, y: b - d * 0.5, w: c, h: d };
    }
  },

  arcModeAdjust: function(a, b, c, d, mode) {
    if (mode === constants.CORNER) {
      return { x: a + c * 0.5, y: b + d * 0.5, w: c, h: d };
    } else if (mode === constants.CORNERS) {
      return { x: a, y: b, w: c + a, h: d + b };
    } else if (mode === constants.RADIUS) {
      return { x: a, y: b, w: 2 * c, h: 2 * d };
    } else if (mode === constants.CENTER) {
      return { x: a, y: b, w: c, h: d };
    }
  }
};

},{"./constants":21}],21:[function(_dereq_,module,exports){
/**
 * @module Constants
 * @submodule Constants
 * @for p5
 */

'use strict';

var PI = Math.PI;

module.exports = {
  // GRAPHICS RENDERER
  /**
   * @property {String} P2D
   * @final
   */
  P2D: 'p2d',
  /**
   * @property {String} WEBGL
   * @final
   */
  WEBGL: 'webgl',

  // ENVIRONMENT
  ARROW: 'default',
  CROSS: 'crosshair',
  HAND: 'pointer',
  MOVE: 'move',
  TEXT: 'text',
  WAIT: 'wait',

  // TRIGONOMETRY

  /**
   * HALF_PI is a mathematical constant with the value
   * 1.57079632679489661923. It is half the ratio of the
   * circumference of a circle to its diameter. It is useful in
   * combination with the trigonometric functions sin() and cos().
   *
   * @property {Number} HALF_PI
   * @final
   *
   * @example
   * <div><code>
   * arc(50, 50, 80, 80, 0, HALF_PI);
   * </code></div>
   *
   * @alt
   * 80x80 white quarter-circle with curve toward bottom right of canvas.
   *
   */
  HALF_PI: PI / 2,
  /**
   * PI is a mathematical constant with the value
   * 3.14159265358979323846. It is the ratio of the circumference
   * of a circle to its diameter. It is useful in combination with
   * the trigonometric functions sin() and cos().
   *
   * @property {Number} PI
   * @final
   *
   * @example
   * <div><code>
   * arc(50, 50, 80, 80, 0, PI);
   * </code></div>
   *
   * @alt
   * white half-circle with curve toward bottom of canvas.
   *
   */
  PI: PI,
  /**
   * QUARTER_PI is a mathematical constant with the value 0.7853982.
   * It is one quarter the ratio of the circumference of a circle to
   * its diameter. It is useful in combination with the trigonometric
   * functions sin() and cos().
   *
   * @property {Number} QUARTER_PI
   * @final
   *
   * @example
   * <div><code>
   * arc(50, 50, 80, 80, 0, QUARTER_PI);
   * </code></div>
   *
   * @alt
   * white eighth-circle rotated about 40 degrees with curve bottom right canvas.
   *
   */
  QUARTER_PI: PI / 4,
  /**
   * TAU is an alias for TWO_PI, a mathematical constant with the
   * value 6.28318530717958647693. It is twice the ratio of the
   * circumference of a circle to its diameter. It is useful in
   * combination with the trigonometric functions sin() and cos().
   *
   * @property {Number} TAU
   * @final
   *
   * @example
   * <div><code>
   * arc(50, 50, 80, 80, 0, TAU);
   * </code></div>
   *
   * @alt
   * 80x80 white ellipse shape in center of canvas.
   *
   */
  TAU: PI * 2,
  /**
   * TWO_PI is a mathematical constant with the value
   * 6.28318530717958647693. It is twice the ratio of the
   * circumference of a circle to its diameter. It is useful in
   * combination with the trigonometric functions sin() and cos().
   *
   * @property {Number} TWO_PI
   * @final
   *
   * @example
   * <div><code>
   * arc(50, 50, 80, 80, 0, TWO_PI);
   * </code></div>
   *
   * @alt
   * 80x80 white ellipse shape in center of canvas.
   *
   */
  TWO_PI: PI * 2,
  /**
   * Constant to be used with angleMode() function, to set the mode which
   * p5.js interprates and calculates angles (either DEGREES or RADIANS).
   * @property {String} DEGREES
   * @final
   *
   * @example
   * <div class='norender'><code>
   * function setup() {
   *   angleMode(DEGREES);
   * }
   * </code></div>
   */
  DEGREES: 'degrees',
  /**
   * Constant to be used with angleMode() function, to set the mode which
   * p5.js interprates and calculates angles (either RADIANS or DEGREES).
   * @property {String} RADIANS
   * @final
   *
   * @example
   * <div class='norender'><code>
   * function setup() {
   *   angleMode(RADIANS);
   * }
   * </code></div>
   */
  RADIANS: 'radians',
  DEG_TO_RAD: PI / 180.0,
  RAD_TO_DEG: 180.0 / PI,

  // SHAPE
  /**
   * @property {String} CORNER
   * @final
   */
  CORNER: 'corner',
  /**
   * @property {String} CORNERS
   * @final
   */
  CORNERS: 'corners',
  /**
   * @property {String} RADIUS
   * @final
   */
  RADIUS: 'radius',
  /**
   * @property {String} RIGHT
   * @final
   */
  RIGHT: 'right',
  /**
   * @property {String} LEFT
   * @final
   */
  LEFT: 'left',
  /**
   * @property {String} CENTER
   * @final
   */
  CENTER: 'center',
  /**
   * @property {String} TOP
   * @final
   */
  TOP: 'top',
  /**
   * @property {String} BOTTOM
   * @final
   */
  BOTTOM: 'bottom',
  /**
   * @property {String} BASELINE
   * @final
   * @default alphabetic
   */
  BASELINE: 'alphabetic',
  /**
   * @property {Number} POINTS
   * @final
   * @default 0x0000
   */
  POINTS: 0x0000,
  /**
   * @property {Number} LINES
   * @final
   * @default 0x0001
   */
  LINES: 0x0001,
  /**
   * @property {Number} LINE_STRIP
   * @final
   * @default 0x0003
   */
  LINE_STRIP: 0x0003,
  /**
   * @property {Number} LINE_LOOP
   * @final
   * @default 0x0002
   */
  LINE_LOOP: 0x0002,
  /**
   * @property {Number} TRIANGLES
   * @final
   * @default 0x0004
   */
  TRIANGLES: 0x0004,
  /**
   * @property {Number} TRIANGLE_FAN
   * @final
   * @default 0x0006
   */
  TRIANGLE_FAN: 0x0006,
  /**
   * @property {Number} TRIANGLE_STRIP
   * @final
   * @default 0x0005
   */
  TRIANGLE_STRIP: 0x0005,
  /**
   * @property {String} QUADS
   * @final
   */
  QUADS: 'quads',
  /**
   * @property {String} QUAD_STRIP
   * @final
   * @default quad_strip
   */
  QUAD_STRIP: 'quad_strip',
  /**
   * @property {String} CLOSE
   * @final
   */
  CLOSE: 'close',
  /**
   * @property {String} OPEN
   * @final
   */
  OPEN: 'open',
  /**
   * @property {String} CHORD
   * @final
   */
  CHORD: 'chord',
  /**
   * @property {String} PIE
   * @final
   */
  PIE: 'pie',
  /**
   * @property {String} PROJECT
   * @final
   * @default square
   */
  PROJECT: 'square', // PEND: careful this is counterintuitive
  /**
   * @property {String} SQUARE
   * @final
   * @default butt
   */
  SQUARE: 'butt',
  /**
   * @property {String} ROUND
   * @final
   */
  ROUND: 'round',
  /**
   * @property {String} BEVEL
   * @final
   */
  BEVEL: 'bevel',
  /**
   * @property {String} MITER
   * @final
   */
  MITER: 'miter',

  // COLOR
  /**
   * @property {String} RGB
   * @final
   */
  RGB: 'rgb',
  /**
   * @property {String} HSB
   * @final
   */
  HSB: 'hsb',
  /**
   * @property {String} HSL
   * @final
   */
  HSL: 'hsl',

  // DOM EXTENSION
  AUTO: 'auto',

  // INPUT
  ALT: 18,
  BACKSPACE: 8,
  CONTROL: 17,
  DELETE: 46,
  DOWN_ARROW: 40,
  ENTER: 13,
  ESCAPE: 27,
  LEFT_ARROW: 37,
  OPTION: 18,
  RETURN: 13,
  RIGHT_ARROW: 39,
  SHIFT: 16,
  TAB: 9,
  UP_ARROW: 38,

  // RENDERING
  /**
   * @property {String} BLEND
   * @final
   * @default source-over
   */
  BLEND: 'source-over',
  /**
   * @property {String} ADD
   * @final
   * @default lighter
   */
  ADD: 'lighter',
  //ADD: 'add', //
  //SUBTRACT: 'subtract', //
  /**
   * @property {String} DARKEST
   * @final
   */
  DARKEST: 'darken',
  /**
   * @property {String} LIGHTEST
   * @final
   * @default lighten
   */
  LIGHTEST: 'lighten',
  /**
   * @property {String} DIFFERENCE
   * @final
   */
  DIFFERENCE: 'difference',
  /**
   * @property {String} EXCLUSION
   * @final
   */
  EXCLUSION: 'exclusion',
  /**
   * @property {String} MULTIPLY
   * @final
   */
  MULTIPLY: 'multiply',
  /**
   * @property {String} SCREEN
   * @final
   */
  SCREEN: 'screen',
  /**
   * @property {String} REPLACE
   * @final
   * @default copy
   */
  REPLACE: 'copy',
  /**
   * @property {String} OVERLAY
   * @final
   */
  OVERLAY: 'overlay',
  /**
   * @property {String} HARD_LIGHT
   * @final
   */
  HARD_LIGHT: 'hard-light',
  /**
   * @property {String} SOFT_LIGHT
   * @final
   */
  SOFT_LIGHT: 'soft-light',
  /**
   * @property {String} DODGE
   * @final
   * @default color-dodge
   */
  DODGE: 'color-dodge',
  /**
   * @property {String} BURN
   * @final
   * @default color-burn
   */
  BURN: 'color-burn',

  // FILTERS
  /**
   * @property {String} THRESHOLD
   * @final
   */
  THRESHOLD: 'threshold',
  /**
   * @property {String} GRAY
   * @final
   */
  GRAY: 'gray',
  /**
   * @property {String} OPAQUE
   * @final
   */
  OPAQUE: 'opaque',
  /**
   * @property {String} INVERT
   * @final
   */
  INVERT: 'invert',
  /**
   * @property {String} POSTERIZE
   * @final
   */
  POSTERIZE: 'posterize',
  /**
   * @property {String} DILATE
   * @final
   */
  DILATE: 'dilate',
  /**
   * @property {String} ERODE
   * @final
   */
  ERODE: 'erode',
  /**
   * @property {String} BLUR
   * @final
   */
  BLUR: 'blur',

  // TYPOGRAPHY
  /**
   * @property {String} NORMAL
   * @final
   */
  NORMAL: 'normal',
  /**
   * @property {String} ITALIC
   * @final
   */
  ITALIC: 'italic',
  /**
   * @property {String} BOLD
   * @final
   */
  BOLD: 'bold',

  // TYPOGRAPHY-INTERNAL
  _DEFAULT_TEXT_FILL: '#000000',
  _DEFAULT_LEADMULT: 1.25,
  _CTX_MIDDLE: 'middle',

  // VERTICES
  LINEAR: 'linear',
  QUADRATIC: 'quadratic',
  BEZIER: 'bezier',
  CURVE: 'curve',

  // WEBGL DRAWMODES
  STROKE: 'stroke',
  FILL: 'fill',
  TEXTURE: 'texture',
  IMMEDIATE: 'immediate',

  // DEVICE-ORIENTATION
  /**
   * @property {String} LANDSCAPE
   * @final
   */
  LANDSCAPE: 'landscape',
  /**
   * @property {String} PORTRAIT
   * @final
   */
  PORTRAIT: 'portrait',

  // DEFAULTS
  _DEFAULT_STROKE: '#000000',
  _DEFAULT_FILL: '#FFFFFF'
};

},{}],22:[function(_dereq_,module,exports){
/**
 * @module Structure
 * @submodule Structure
 * @for p5
 * @requires constants
 */

'use strict';

_dereq_('./shim');

// Core needs the PVariables object
var constants = _dereq_('./constants');

/**
 * This is the p5 instance constructor.
 *
 * A p5 instance holds all the properties and methods related to
 * a p5 sketch.  It expects an incoming sketch closure and it can also
 * take an optional node parameter for attaching the generated p5 canvas
 * to a node.  The sketch closure takes the newly created p5 instance as
 * its sole argument and may optionally set preload(), setup(), and/or
 * draw() properties on it for running a sketch.
 *
 * A p5 sketch can run in "global" or "instance" mode:
 * "global"   - all properties and methods are attached to the window
 * "instance" - all properties and methods are bound to this p5 object
 *
 * @class p5
 * @constructor
 * @param  {function}    sketch a closure that can set optional preload(),
 *                              setup(), and/or draw() properties on the
 *                              given p5 instance
 * @param  {HTMLElement|Boolean} [node] element to attach canvas to, if a
 *                                      boolean is passed in use it as sync
 * @param  {Boolean}     [sync] start synchronously (optional)
 * @return {p5}                 a p5 instance
 */
var p5 = function(sketch, node, sync) {
  if (typeof node === 'boolean' && typeof sync === 'undefined') {
    sync = node;
    node = undefined;
  }

  //////////////////////////////////////////////
  // PUBLIC p5 PROPERTIES AND METHODS
  //////////////////////////////////////////////

  /**
   * Called directly before setup(), the preload() function is used to handle
   * asynchronous loading of external files. If a preload function is
   * defined, setup() will wait until any load calls within have finished.
   * Nothing besides load calls should be inside preload (loadImage,
   * loadJSON, loadFont, loadStrings, etc).<br><br>
   * By default the text "loading..." will be displayed. To make your own
   * loading page, include an HTML element with id "p5_loading" in your
   * page. More information <a href="http://bit.ly/2kQ6Nio">here</a>.
   *
   * @method preload
   * @example
   * <div><code>
   * var img;
   * var c;
   * function preload() {
  // preload() runs once
   *   img = loadImage('assets/laDefense.jpg');
   * }
   *
   * function setup() {
  // setup() waits until preload() is done
   *   img.loadPixels();
   *   // get color of middle pixel
   *   c = img.get(img.width / 2, img.height / 2);
   * }
   *
   * function draw() {
   *   background(c);
   *   image(img, 25, 25, 50, 50);
   * }
   * </code></div>
   *
   * @alt
   * nothing displayed
   *
   */

  /**
   * The setup() function is called once when the program starts. It's used to
   * define initial environment properties such as screen size and background
   * color and to load media such as images and fonts as the program starts.
   * There can only be one setup() function for each program and it shouldn't
   * be called again after its initial execution.
   * <br><br>
   * Note: Variables declared within setup() are not accessible within other
   * functions, including draw().
   *
   * @method setup
   * @example
   * <div><code>
   * var a = 0;
   *
   * function setup() {
   *   background(0);
   *   noStroke();
   *   fill(102);
   * }
   *
   * function draw() {
   *   rect(a++ % width, 10, 2, 80);
   * }
   * </code></div>
   *
   * @alt
   * nothing displayed
   *
   */

  /**
   * Called directly after setup(), the draw() function continuously executes
   * the lines of code contained inside its block until the program is stopped
   * or noLoop() is called. Note if noLoop() is called in setup(), draw() will
   * still be executed once before stopping. draw() is called automatically and
   * should never be called explicitly.
   * <br><br>
   * It should always be controlled with noLoop(), redraw() and loop(). After
   * noLoop() stops the code in draw() from executing, redraw() causes the
   * code inside draw() to execute once, and loop() will cause the code
   * inside draw() to resume executing continuously.
   * <br><br>
   * The number of times draw() executes in each second may be controlled with
   * the frameRate() function.
   * <br><br>
   * There can only be one draw() function for each sketch, and draw() must
   * exist if you want the code to run continuously, or to process events such
   * as mousePressed(). Sometimes, you might have an empty call to draw() in
   * your program, as shown in the above example.
   * <br><br>
   * It is important to note that the drawing coordinate system will be reset
   * at the beginning of each draw() call. If any transformations are performed
   * within draw() (ex: scale, rotate, translate, their effects will be
   * undone at the beginning of draw(), so transformations will not accumulate
   * over time. On the other hand, styling applied (ex: fill, stroke, etc) will
   * remain in effect.
   *
   * @method draw
   * @example
   * <div><code>
   * var yPos = 0;
   * function setup() {
  // setup() runs once
   *   frameRate(30);
   * }
   * function draw() {
  // draw() loops forever, until stopped
   *   background(204);
   *   yPos = yPos - 1;
   *   if (yPos < 0) {
   *     yPos = height;
   *   }
   *   line(0, yPos, width, yPos);
   * }
   * </code></div>
   *
   * @alt
   * nothing displayed
   *
   */

  //////////////////////////////////////////////
  // PRIVATE p5 PROPERTIES AND METHODS
  //////////////////////////////////////////////

  this._setupDone = false;
  // for handling hidpi
  this._pixelDensity = Math.ceil(window.devicePixelRatio) || 1;
  this._userNode = node;
  this._curElement = null;
  this._elements = [];
  this._requestAnimId = 0;
  this._preloadCount = 0;
  this._isGlobal = false;
  this._loop = true;
  this._initializeInstanceVariables();
  this._defaultCanvasSize = {
    width: 100,
    height: 100
  };
  this._events = {
    // keep track of user-events for unregistering later
    mousemove: null,
    mousedown: null,
    mouseup: null,
    dragend: null,
    dragover: null,
    click: null,
    dblclick: null,
    mouseover: null,
    mouseout: null,
    keydown: null,
    keyup: null,
    keypress: null,
    touchstart: null,
    touchmove: null,
    touchend: null,
    resize: null,
    blur: null
  };

  this._events.wheel = null;
  this._loadingScreenId = 'p5_loading';

  // Allows methods to be registered on an instance that
  // are instance-specific.
  this._registeredMethods = {};
  var methods = Object.getOwnPropertyNames(p5.prototype._registeredMethods);
  for (var i = 0; i < methods.length; i++) {
    var prop = methods[i];
    this._registeredMethods[prop] = p5.prototype._registeredMethods[
      prop
    ].slice();
  }

  if (window.DeviceOrientationEvent) {
    this._events.deviceorientation = null;
  }
  if (window.DeviceMotionEvent && !window._isNodeWebkit) {
    this._events.devicemotion = null;
  }

  this._start = function() {
    // Find node if id given
    if (this._userNode) {
      if (typeof this._userNode === 'string') {
        this._userNode = document.getElementById(this._userNode);
      }
    }

    var userPreload = this.preload || window.preload; // look for "preload"
    if (userPreload) {
      // Setup loading screen
      // Set loading scfeen into dom if not present
      // Otherwise displays and removes user provided loading screen
      var loadingScreen = document.getElementById(this._loadingScreenId);
      if (!loadingScreen) {
        loadingScreen = document.createElement('div');
        loadingScreen.innerHTML = 'Loading...';
        loadingScreen.style.position = 'absolute';
        loadingScreen.id = this._loadingScreenId;
        var node = this._userNode || document.body;
        node.appendChild(loadingScreen);
      }
      // var methods = this._preloadMethods;
      for (var method in this._preloadMethods) {
        // default to p5 if no object defined
        this._preloadMethods[method] = this._preloadMethods[method] || p5;
        var obj = this._preloadMethods[method];
        //it's p5, check if it's global or instance
        if (obj === p5.prototype || obj === p5) {
          obj = this._isGlobal ? window : this;
        }
        this._registeredPreloadMethods[method] = obj[method];
        obj[method] = this._wrapPreload(obj, method);
      }

      userPreload();
      this._runIfPreloadsAreDone();
    } else {
      this._setup();
      this._runFrames();
      this._draw();
    }
  }.bind(this);

  this._runIfPreloadsAreDone = function() {
    var context = this._isGlobal ? window : this;
    if (context._preloadCount === 0) {
      var loadingScreen = document.getElementById(context._loadingScreenId);
      if (loadingScreen) {
        loadingScreen.parentNode.removeChild(loadingScreen);
      }
      context._setup();
      context._runFrames();
      context._draw();
    }
  };

  this._decrementPreload = function() {
    var context = this._isGlobal ? window : this;
    if (typeof context.preload === 'function') {
      context._setProperty('_preloadCount', context._preloadCount - 1);
      context._runIfPreloadsAreDone();
    }
  };

  this._wrapPreload = function(obj, fnName) {
    return function() {
      //increment counter
      this._incrementPreload();
      //call original function
      return this._registeredPreloadMethods[fnName].apply(obj, arguments);
    }.bind(this);
  };

  this._incrementPreload = function() {
    var context = this._isGlobal ? window : this;
    context._setProperty('_preloadCount', context._preloadCount + 1);
  };

  this._setup = function() {
    // Always create a default canvas.
    // Later on if the user calls createCanvas, this default one
    // will be replaced
    this.createCanvas(
      this._defaultCanvasSize.width,
      this._defaultCanvasSize.height,
      'p2d'
    );

    // return preload functions to their normal vals if switched by preload
    var context = this._isGlobal ? window : this;
    if (typeof context.preload === 'function') {
      for (var f in this._preloadMethods) {
        context[f] = this._preloadMethods[f][f];
        if (context[f] && this) {
          context[f] = context[f].bind(this);
        }
      }
    }

    // Short-circuit on this, in case someone used the library in "global"
    // mode earlier
    if (typeof context.setup === 'function') {
      context.setup();
    }

    // unhide any hidden canvases that were created
    var canvases = document.getElementsByTagName('canvas');
    for (var i = 0; i < canvases.length; i++) {
      var k = canvases[i];
      if (k.dataset.hidden === 'true') {
        k.style.visibility = '';
        delete k.dataset.hidden;
      }
    }
    this._setupDone = true;
  }.bind(this);

  this._draw = function() {
    var now = window.performance.now();
    var time_since_last = now - this._lastFrameTime;
    var target_time_between_frames = 1000 / this._targetFrameRate;

    // only draw if we really need to; don't overextend the browser.
    // draw if we're within 5ms of when our next frame should paint
    // (this will prevent us from giving up opportunities to draw
    // again when it's really about time for us to do so). fixes an
    // issue where the frameRate is too low if our refresh loop isn't
    // in sync with the browser. note that we have to draw once even
    // if looping is off, so we bypass the time delay if that
    // is the case.
    var epsilon = 5;
    if (
      !this._loop ||
      time_since_last >= target_time_between_frames - epsilon
    ) {
      //mandatory update values(matrixs and stack)

      this.redraw();
      this._frameRate = 1000.0 / (now - this._lastFrameTime);
      this._lastFrameTime = now;

      // If the user is actually using mouse module, then update
      // coordinates, otherwise skip. We can test this by simply
      // checking if any of the mouse functions are available or not.
      // NOTE : This reflects only in complete build or modular build.
      if (typeof this._updateMouseCoords !== 'undefined') {
        this._updateMouseCoords();
      }
    }

    // get notified the next time the browser gives us
    // an opportunity to draw.
    if (this._loop) {
      this._requestAnimId = window.requestAnimationFrame(this._draw);
    }
  }.bind(this);

  this._runFrames = function() {
    if (this._updateInterval) {
      clearInterval(this._updateInterval);
    }
  }.bind(this);

  this._setProperty = function(prop, value) {
    this[prop] = value;
    if (this._isGlobal) {
      window[prop] = value;
    }
  }.bind(this);

  /**
   * Removes the entire p5 sketch. This will remove the canvas and any
   * elements created by p5.js. It will also stop the draw loop and unbind
   * any properties or methods from the window global scope. It will
   * leave a variable p5 in case you wanted to create a new p5 sketch.
   * If you like, you can set p5 = null to erase it. While all functions and
   * variables and objects created by the p5 library will be removed, any
   * other global variables created by your code will remain.
   *
   * @method remove
   * @example
   * <div class='norender'><code>
   * function draw() {
   *   ellipse(50, 50, 10, 10);
   * }
   *
   * function mousePressed() {
   *   remove(); // remove whole sketch on mouse press
   * }
   * </code></div>
   *
   * @alt
   * nothing displayed
   *
   */
  this.remove = function() {
    if (this._curElement) {
      // stop draw
      this._loop = false;
      if (this._requestAnimId) {
        window.cancelAnimationFrame(this._requestAnimId);
      }

      // unregister events sketch-wide
      for (var ev in this._events) {
        window.removeEventListener(ev, this._events[ev]);
      }

      // remove DOM elements created by p5, and listeners
      for (var i = 0; i < this._elements.length; i++) {
        var e = this._elements[i];
        if (e.elt.parentNode) {
          e.elt.parentNode.removeChild(e.elt);
        }
        for (var elt_ev in e._events) {
          e.elt.removeEventListener(elt_ev, e._events[elt_ev]);
        }
      }

      // call any registered remove functions
      var self = this;
      this._registeredMethods.remove.forEach(function(f) {
        if (typeof f !== 'undefined') {
          f.call(self);
        }
      });

      // remove window bound properties and methods
      if (this._isGlobal) {
        for (var p in p5.prototype) {
          try {
            delete window[p];
          } catch (x) {
            window[p] = undefined;
          }
        }
        for (var p2 in this) {
          if (this.hasOwnProperty(p2)) {
            try {
              delete window[p2];
            } catch (x) {
              window[p2] = undefined;
            }
          }
        }
      }
    }
    // window.p5 = undefined;
  }.bind(this);

  // call any registered init functions
  this._registeredMethods.init.forEach(function(f) {
    if (typeof f !== 'undefined') {
      f.call(this);
    }
  }, this);

  var friendlyBindGlobal = this._createFriendlyGlobalFunctionBinder();

  // If the user has created a global setup or draw function,
  // assume "global" mode and make everything global (i.e. on the window)
  if (!sketch) {
    this._isGlobal = true;
    p5.instance = this;
    // Loop through methods on the prototype and attach them to the window
    for (var p in p5.prototype) {
      if (typeof p5.prototype[p] === 'function') {
        var ev = p.substring(2);
        if (!this._events.hasOwnProperty(ev)) {
          if (Math.hasOwnProperty(p) && Math[p] === p5.prototype[p]) {
            // Multiple p5 methods are just native Math functions. These can be
            // called without any binding.
            friendlyBindGlobal(p, p5.prototype[p]);
          } else {
            friendlyBindGlobal(p, p5.prototype[p].bind(this));
          }
        }
      } else {
        friendlyBindGlobal(p, p5.prototype[p]);
      }
    }
    // Attach its properties to the window
    for (var p2 in this) {
      if (this.hasOwnProperty(p2)) {
        friendlyBindGlobal(p2, this[p2]);
      }
    }
  } else {
    // Else, the user has passed in a sketch closure that may set
    // user-provided 'setup', 'draw', etc. properties on this instance of p5
    sketch(this);
  }

  // Bind events to window (not using container div bc key events don't work)

  for (var e in this._events) {
    var f = this['_on' + e];
    if (f) {
      var m = f.bind(this);
      window.addEventListener(e, m, { passive: false });
      this._events[e] = m;
    }
  }

  var focusHandler = function() {
    this._setProperty('focused', true);
  }.bind(this);
  var blurHandler = function() {
    this._setProperty('focused', false);
  }.bind(this);
  window.addEventListener('focus', focusHandler);
  window.addEventListener('blur', blurHandler);
  this.registerMethod('remove', function() {
    window.removeEventListener('focus', focusHandler);
    window.removeEventListener('blur', blurHandler);
  });

  if (sync) {
    this._start();
  } else {
    if (document.readyState === 'complete') {
      this._start();
    } else {
      window.addEventListener('load', this._start.bind(this), false);
    }
  }
};

p5.prototype._initializeInstanceVariables = function() {
  this._styles = [];

  this._bezierDetail = 20;
  this._curveDetail = 20;

  this._colorMode = constants.RGB;
  this._colorMaxes = {
    rgb: [255, 255, 255, 255],
    hsb: [360, 100, 100, 1],
    hsl: [360, 100, 100, 1]
  };
};

// This is a pointer to our global mode p5 instance, if we're in
// global mode.
p5.instance = null;

// Allows for the friendly error system to be turned off when creating a sketch,
// which can give a significant boost to performance when needed.
p5.disableFriendlyErrors = false;

// attach constants to p5 prototype
for (var k in constants) {
  p5.prototype[k] = constants[k];
}

// functions that cause preload to wait
// more can be added by using registerPreloadMethod(func)
p5.prototype._preloadMethods = {
  loadJSON: p5.prototype,
  loadImage: p5.prototype,
  loadStrings: p5.prototype,
  loadXML: p5.prototype,
  loadShape: p5.prototype,
  loadTable: p5.prototype,
  loadFont: p5.prototype,
  loadModel: p5.prototype,
  loadShader: p5.prototype
};

p5.prototype._registeredMethods = { init: [], pre: [], post: [], remove: [] };

p5.prototype._registeredPreloadMethods = {};

p5.prototype.registerPreloadMethod = function(fnString, obj) {
  // obj = obj || p5.prototype;
  if (!p5.prototype._preloadMethods.hasOwnProperty(fnString)) {
    p5.prototype._preloadMethods[fnString] = obj;
  }
};

p5.prototype.registerMethod = function(name, m) {
  var target = this || p5.prototype;
  if (!target._registeredMethods.hasOwnProperty(name)) {
    target._registeredMethods[name] = [];
  }
  target._registeredMethods[name].push(m);
};

p5.prototype._createFriendlyGlobalFunctionBinder = function(options) {
  options = options || {};

  var globalObject = options.globalObject || window;
  var log = options.log || console.log.bind(console);
  var propsToForciblyOverwrite = {
    // p5.print actually always overwrites an existing global function,
    // albeit one that is very unlikely to be used:
    //
    //   https://developer.mozilla.org/en-US/docs/Web/API/Window/print
    print: true
  };

  return function(prop, value) {
    if (
      !p5.disableFriendlyErrors &&
      typeof IS_MINIFIED === 'undefined' &&
      typeof value === 'function' &&
      !(prop in p5.prototype._preloadMethods)
    ) {
      try {
        // Because p5 has so many common function names, it's likely
        // that users may accidentally overwrite global p5 functions with
        // their own variables. Let's allow this but log a warning to
        // help users who may be doing this unintentionally.
        //
        // For more information, see:
        //
        //   https://github.com/processing/p5.js/issues/1317

        if (prop in globalObject && !(prop in propsToForciblyOverwrite)) {
          throw new Error('global "' + prop + '" already exists');
        }

        // It's possible that this might throw an error because there
        // are a lot of edge-cases in which `Object.defineProperty` might
        // not succeed; since this functionality is only intended to
        // help beginners anyways, we'll just catch such an exception
        // if it occurs, and fall back to legacy behavior.
        Object.defineProperty(globalObject, prop, {
          configurable: true,
          enumerable: true,
          get: function() {
            return value;
          },
          set: function(newValue) {
            Object.defineProperty(globalObject, prop, {
              configurable: true,
              enumerable: true,
              value: newValue,
              writable: true
            });
            log(
              'You just changed the value of "' +
                prop +
                '", which was ' +
                "a p5 function. This could cause problems later if you're " +
                'not careful.'
            );
          }
        });
      } catch (e) {
        log(
          'p5 had problems creating the global function "' +
            prop +
            '", ' +
            'possibly because your code is already using that name as ' +
            'a variable. You may want to rename your variable to something ' +
            'else.'
        );
        globalObject[prop] = value;
      }
    } else {
      globalObject[prop] = value;
    }
  };
};

module.exports = p5;

},{"./constants":21,"./shim":32}],23:[function(_dereq_,module,exports){
/**
 * @module Shape
 * @submodule Curves
 * @for p5
 * @requires core
 */

'use strict';

var p5 = _dereq_('./core');
_dereq_('./error_helpers');

/**
 * Draws a cubic Bezier curve on the screen. These curves are defined by a
 * series of anchor and control points. The first two parameters specify
 * the first anchor point and the last two parameters specify the other
 * anchor point, which become the first and last points on the curve. The
 * middle parameters specify the two control points which define the shape
 * of the curve. Approximately speaking, control points "pull" the curve
 * towards them.<br /><br />Bezier curves were developed by French
 * automotive engineer Pierre Bezier, and are commonly used in computer
 * graphics to define gently sloping curves. See also curve().
 *
 * @method bezier
 * @param  {Number} x1 x-coordinate for the first anchor point
 * @param  {Number} y1 y-coordinate for the first anchor point
 * @param  {Number} x2 x-coordinate for the first control point
 * @param  {Number} y2 y-coordinate for the first control point
 * @param  {Number} x3 x-coordinate for the second control point
 * @param  {Number} y3 y-coordinate for the second control point
 * @param  {Number} x4 x-coordinate for the second anchor point
 * @param  {Number} y4 y-coordinate for the second anchor point
 * @chainable
 * @example
 * <div>
 * <code>
 * noFill();
 * stroke(255, 102, 0);
 * line(85, 20, 10, 10);
 * line(90, 90, 15, 80);
 * stroke(0, 0, 0);
 * bezier(85, 20, 10, 10, 90, 90, 15, 80);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * background(0, 0, 0);
 * noFill();
 * stroke(255);
 * bezier(250, 250, 0, 100, 100, 0, 100, 0, 0, 0, 100, 0);
 * </code>
 * </div>
 *
 * @alt
 * stretched black s-shape in center with orange lines extending from end points.
 * stretched black s-shape with 10 5x5 white ellipses along the shape.
 * stretched black s-shape with 7 5x5 ellipses and orange lines along the shape.
 * stretched black s-shape with 17 small orange lines extending from under shape.
 * horseshoe shape with orange ends facing left and black curved center.
 * horseshoe shape with orange ends facing left and black curved center.
 * Line shaped like right-facing arrow,points move with mouse-x and warp shape.
 * horizontal line that hooks downward on the right and 13 5x5 ellipses along it.
 * right curving line mid-right of canvas with 7 short lines radiating from it.
 */
/**
 * @method bezier
 * @param  {Number} x1
 * @param  {Number} y1
 * @param  {Number} z1 z-coordinate for the first anchor point
 * @param  {Number} x2
 * @param  {Number} y2
 * @param  {Number} z2 z-coordinate for the first control point
 * @param  {Number} x3
 * @param  {Number} y3
 * @param  {Number} z3 z-coordinate for the second control point
 * @param  {Number} x4
 * @param  {Number} y4
 * @param  {Number} z4 z-coordinate for the second anchor point
 * @chainable
 */
p5.prototype.bezier = function() {
  p5._validateParameters('bezier', arguments);

  if (this._renderer._doStroke || this._renderer._doFill) {
    this._renderer.bezier.apply(this._renderer, arguments);
  }

  return this;
};

/**
 * Sets the resolution at which Beziers display.
 *
 * The default value is 20.
 *
 * @method bezierDetail
 * @param {Number} detail resolution of the curves
 * @chainable
 * @example
 * <div>
 * <code>
 * background(204);
 * bezierDetail(50);
 * bezier(85, 20, 10, 10, 90, 90, 15, 80);
 * </code>
 * </div>
 *
 * @alt
 * stretched black s-shape with 7 5x5 ellipses and orange lines along the shape.
 *
 */
p5.prototype.bezierDetail = function(d) {
  p5._validateParameters('bezierDetail', arguments);
  this._bezierDetail = d;
  return this;
};

/**
 * Evaluates the Bezier at position t for points a, b, c, d.
 * The parameters a and d are the first and last points
 * on the curve, and b and c are the control points.
 * The final parameter t varies between 0 and 1.
 * This can be done once with the x coordinates and a second time
 * with the y coordinates to get the location of a bezier curve at t.
 *
 * @method bezierPoint
 * @param {Number} a coordinate of first point on the curve
 * @param {Number} b coordinate of first control point
 * @param {Number} c coordinate of second control point
 * @param {Number} d coordinate of second point on the curve
 * @param {Number} t value between 0 and 1
 * @return {Number} the value of the Bezier at position t
 * @example
 * <div>
 * <code>
 * noFill();
 * var x1 = 85,
  x2 = 10,
  x3 = 90,
  x4 = 15;
 * var y1 = 20,
  y2 = 10,
  y3 = 90,
  y4 = 80;
 * bezier(x1, y1, x2, y2, x3, y3, x4, y4);
 * fill(255);
 * var steps = 10;
 * for (var i = 0; i <= steps; i++) {
 *   var t = i / steps;
 *   var x = bezierPoint(x1, x2, x3, x4, t);
 *   var y = bezierPoint(y1, y2, y3, y4, t);
 *   ellipse(x, y, 5, 5);
 * }
 * </code>
 * </div>
 *
 * @alt
 * stretched black s-shape with 17 small orange lines extending from under shape.
 *
 */
p5.prototype.bezierPoint = function(a, b, c, d, t) {
  p5._validateParameters('bezierPoint', arguments);

  var adjustedT = 1 - t;
  return (
    Math.pow(adjustedT, 3) * a +
    3 * Math.pow(adjustedT, 2) * t * b +
    3 * adjustedT * Math.pow(t, 2) * c +
    Math.pow(t, 3) * d
  );
};

/**
 * Evaluates the tangent to the Bezier at position t for points a, b, c, d.
 * The parameters a and d are the first and last points
 * on the curve, and b and c are the control points.
 * The final parameter t varies between 0 and 1.
 *
 * @method bezierTangent
 * @param {Number} a coordinate of first point on the curve
 * @param {Number} b coordinate of first control point
 * @param {Number} c coordinate of second control point
 * @param {Number} d coordinate of second point on the curve
 * @param {Number} t value between 0 and 1
 * @return {Number} the tangent at position t
 * @example
 * <div>
 * <code>
 * noFill();
 * bezier(85, 20, 10, 10, 90, 90, 15, 80);
 * var steps = 6;
 * fill(255);
 * for (var i = 0; i <= steps; i++) {
 *   var t = i / steps;
 *   // Get the location of the point
 *   var x = bezierPoint(85, 10, 90, 15, t);
 *   var y = bezierPoint(20, 10, 90, 80, t);
 *   // Get the tangent points
 *   var tx = bezierTangent(85, 10, 90, 15, t);
 *   var ty = bezierTangent(20, 10, 90, 80, t);
 *   // Calculate an angle from the tangent points
 *   var a = atan2(ty, tx);
 *   a += PI;
 *   stroke(255, 102, 0);
 *   line(x, y, cos(a) * 30 + x, sin(a) * 30 + y);
 *   // The following line of code makes a line
 *   // inverse of the above line
 *   //line(x, y, cos(a)*-30 + x, sin(a)*-30 + y);
 *   stroke(0);
 *   ellipse(x, y, 5, 5);
 * }
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * noFill();
 * bezier(85, 20, 10, 10, 90, 90, 15, 80);
 * stroke(255, 102, 0);
 * var steps = 16;
 * for (var i = 0; i <= steps; i++) {
 *   var t = i / steps;
 *   var x = bezierPoint(85, 10, 90, 15, t);
 *   var y = bezierPoint(20, 10, 90, 80, t);
 *   var tx = bezierTangent(85, 10, 90, 15, t);
 *   var ty = bezierTangent(20, 10, 90, 80, t);
 *   var a = atan2(ty, tx);
 *   a -= HALF_PI;
 *   line(x, y, cos(a) * 8 + x, sin(a) * 8 + y);
 * }
 * </code>
 * </div>
 *
 * @alt
 * s-shaped line with 17 short orange lines extending from underside of shape
 *
 */
p5.prototype.bezierTangent = function(a, b, c, d, t) {
  p5._validateParameters('bezierTangent', arguments);

  var adjustedT = 1 - t;
  return (
    3 * d * Math.pow(t, 2) -
    3 * c * Math.pow(t, 2) +
    6 * c * adjustedT * t -
    6 * b * adjustedT * t +
    3 * b * Math.pow(adjustedT, 2) -
    3 * a * Math.pow(adjustedT, 2)
  );
};

/**
 * Draws a curved line on the screen between two points, given as the
 * middle four parameters. The first two parameters are a control point, as
 * if the curve came from this point even though it's not drawn. The last
 * two parameters similarly describe the other control point. <br /><br />
 * Longer curves can be created by putting a series of curve() functions
 * together or using curveVertex(). An additional function called
 * curveTightness() provides control for the visual quality of the curve.
 * The curve() function is an implementation of Catmull-Rom splines.
 *
 * @method curve
 * @param  {Number} x1 x-coordinate for the beginning control point
 * @param  {Number} y1 y-coordinate for the beginning control point
 * @param  {Number} x2 x-coordinate for the first point
 * @param  {Number} y2 y-coordinate for the first point
 * @param  {Number} x3 x-coordinate for the second point
 * @param  {Number} y3 y-coordinate for the second point
 * @param  {Number} x4 x-coordinate for the ending control point
 * @param  {Number} y4 y-coordinate for the ending control point
 * @chainable
 * @example
 * <div>
 * <code>
 * noFill();
 * stroke(255, 102, 0);
 * curve(5, 26, 5, 26, 73, 24, 73, 61);
 * stroke(0);
 * curve(5, 26, 73, 24, 73, 61, 15, 65);
 * stroke(255, 102, 0);
 * curve(73, 24, 73, 61, 15, 65, 15, 65);
 * </code>
 * </div>
 * <div>
 * <code>
 * // Define the curve points as JavaScript objects
 * var p1 = { x: 5, y: 26 },
  p2 = { x: 73, y: 24 };
 * var p3 = { x: 73, y: 61 },
  p4 = { x: 15, y: 65 };
 * noFill();
 * stroke(255, 102, 0);
 * curve(p1.x, p1.y, p1.x, p1.y, p2.x, p2.y, p3.x, p3.y);
 * stroke(0);
 * curve(p1.x, p1.y, p2.x, p2.y, p3.x, p3.y, p4.x, p4.y);
 * stroke(255, 102, 0);
 * curve(p2.x, p2.y, p3.x, p3.y, p4.x, p4.y, p4.x, p4.y);
 * </code>
 * </div>
 * <div>
 * <code>
 * noFill();
 * stroke(255, 102, 0);
 * curve(5, 26, 0, 5, 26, 0, 73, 24, 0, 73, 61, 0);
 * stroke(0);
 * curve(5, 26, 0, 73, 24, 0, 73, 61, 0, 15, 65, 0);
 * stroke(255, 102, 0);
 * curve(73, 24, 0, 73, 61, 0, 15, 65, 0, 15, 65, 0);
 * </code>
 * </div>
 *
 * @alt
 * horseshoe shape with orange ends facing left and black curved center.
 * horseshoe shape with orange ends facing left and black curved center.
 * curving black and orange lines.
 */
/**
 * @method curve
 * @param  {Number} x1
 * @param  {Number} y1
 * @param  {Number} z1 z-coordinate for the beginning control point
 * @param  {Number} x2
 * @param  {Number} y2
 * @param  {Number} z2 z-coordinate for the first point
 * @param  {Number} x3
 * @param  {Number} y3
 * @param  {Number} z3 z-coordinate for the second point
 * @param  {Number} x4
 * @param  {Number} y4
 * @param  {Number} z4 z-coordinate for the ending control point
 * @chainable
 */
p5.prototype.curve = function() {
  p5._validateParameters('curve', arguments);

  if (this._renderer._doStroke) {
    this._renderer.curve.apply(this._renderer, arguments);
  }

  return this;
};

/**
 * Sets the resolution at which curves display.
 *
 * The default value is 20.
 *
 * @method curveDetail
 * @param {Number} resolution of the curves
 * @chainable
 * @example
 * <div>
 * <code>
 * background(204);
 * curveDetail(20);
 * curve(5, 26, 5, 26, 73, 24, 73, 61);
 * </code>
 * </div>
 *
 * @alt
 * white arch shape in top-mid canvas.
 *
 */
p5.prototype.curveDetail = function(d) {
  p5._validateParameters('curveDetail', arguments);
  this._curveDetail = d;
  return this;
};

/**
 * Modifies the quality of forms created with curve() and curveVertex().
 * The parameter tightness determines how the curve fits to the vertex
 * points. The value 0.0 is the default value for tightness (this value
 * defines the curves to be Catmull-Rom splines) and the value 1.0 connects
 * all the points with straight lines. Values within the range -5.0 and 5.0
 * will deform the curves but will leave them recognizable and as values
 * increase in magnitude, they will continue to deform.
 *
 * @method curveTightness
 * @param {Number} amount of deformation from the original vertices
 * @chainable
 * @example
 * <div>
 * <code>
 * // Move the mouse left and right to see the curve change
 *
 * function setup() {
 *   createCanvas(100, 100);
 *   noFill();
 * }
 *
 * function draw() {
 *   background(204);
 *   var t = map(mouseX, 0, width, -5, 5);
 *   curveTightness(t);
 *   beginShape();
 *   curveVertex(10, 26);
 *   curveVertex(10, 26);
 *   curveVertex(83, 24);
 *   curveVertex(83, 61);
 *   curveVertex(25, 65);
 *   curveVertex(25, 65);
 *   endShape();
 * }
 * </code>
 * </div>
 *
 * @alt
 * Line shaped like right-facing arrow,points move with mouse-x and warp shape.
 */
p5.prototype.curveTightness = function(t) {
  p5._validateParameters('curveTightness', arguments);
  this._renderer._curveTightness = t;
};

/**
 * Evaluates the curve at position t for points a, b, c, d.
 * The parameter t varies between 0 and 1, a and d are points
 * on the curve, and b and c are the control points.
 * This can be done once with the x coordinates and a second time
 * with the y coordinates to get the location of a curve at t.
 *
 * @method curvePoint
 * @param {Number} a coordinate of first point on the curve
 * @param {Number} b coordinate of first control point
 * @param {Number} c coordinate of second control point
 * @param {Number} d coordinate of second point on the curve
 * @param {Number} t value between 0 and 1
 * @return {Number} bezier value at position t
 * @example
 * <div>
 * <code>
 * noFill();
 * curve(5, 26, 5, 26, 73, 24, 73, 61);
 * curve(5, 26, 73, 24, 73, 61, 15, 65);
 * fill(255);
 * ellipseMode(CENTER);
 * var steps = 6;
 * for (var i = 0; i <= steps; i++) {
 *   var t = i / steps;
 *   var x = curvePoint(5, 5, 73, 73, t);
 *   var y = curvePoint(26, 26, 24, 61, t);
 *   ellipse(x, y, 5, 5);
 *   x = curvePoint(5, 73, 73, 15, t);
 *   y = curvePoint(26, 24, 61, 65, t);
 *   ellipse(x, y, 5, 5);
 * }
 * </code>
 * </div>
 *
 *line hooking down to right-bottom with 13 5x5 white ellipse points
 */
p5.prototype.curvePoint = function(a, b, c, d, t) {
  p5._validateParameters('curvePoint', arguments);

  var t3 = t * t * t,
    t2 = t * t,
    f1 = -0.5 * t3 + t2 - 0.5 * t,
    f2 = 1.5 * t3 - 2.5 * t2 + 1.0,
    f3 = -1.5 * t3 + 2.0 * t2 + 0.5 * t,
    f4 = 0.5 * t3 - 0.5 * t2;
  return a * f1 + b * f2 + c * f3 + d * f4;
};

/**
 * Evaluates the tangent to the curve at position t for points a, b, c, d.
 * The parameter t varies between 0 and 1, a and d are points on the curve,
 * and b and c are the control points.
 *
 * @method curveTangent
 * @param {Number} a coordinate of first point on the curve
 * @param {Number} b coordinate of first control point
 * @param {Number} c coordinate of second control point
 * @param {Number} d coordinate of second point on the curve
 * @param {Number} t value between 0 and 1
 * @return {Number} the tangent at position t
 * @example
 * <div>
 * <code>
 * noFill();
 * curve(5, 26, 73, 24, 73, 61, 15, 65);
 * var steps = 6;
 * for (var i = 0; i <= steps; i++) {
 *   var t = i / steps;
 *   var x = curvePoint(5, 73, 73, 15, t);
 *   var y = curvePoint(26, 24, 61, 65, t);
 *   //ellipse(x, y, 5, 5);
 *   var tx = curveTangent(5, 73, 73, 15, t);
 *   var ty = curveTangent(26, 24, 61, 65, t);
 *   var a = atan2(ty, tx);
 *   a -= PI / 2.0;
 *   line(x, y, cos(a) * 8 + x, sin(a) * 8 + y);
 * }
 * </code>
 * </div>
 *
 * @alt
 *right curving line mid-right of canvas with 7 short lines radiating from it.
 */
p5.prototype.curveTangent = function(a, b, c, d, t) {
  p5._validateParameters('curveTangent', arguments);

  var t2 = t * t,
    f1 = -3 * t2 / 2 + 2 * t - 0.5,
    f2 = 9 * t2 / 2 - 5 * t,
    f3 = -9 * t2 / 2 + 4 * t + 0.5,
    f4 = 3 * t2 / 2 - t;
  return a * f1 + b * f2 + c * f3 + d * f4;
};

module.exports = p5;

},{"./core":22,"./error_helpers":25}],24:[function(_dereq_,module,exports){
/**
 * @module Environment
 * @submodule Environment
 * @for p5
 * @requires core
 * @requires constants
 */

'use strict';

var p5 = _dereq_('./core');
var C = _dereq_('./constants');

var standardCursors = [C.ARROW, C.CROSS, C.HAND, C.MOVE, C.TEXT, C.WAIT];

p5.prototype._frameRate = 0;
p5.prototype._lastFrameTime = window.performance.now();
p5.prototype._targetFrameRate = 60;

var _windowPrint = window.print;

/**
 * The print() function writes to the console area of your browser.
 * This function is often helpful for looking at the data a program is
 * producing. This function creates a new line of text for each call to
 * the function. Individual elements can be
 * separated with quotes ("") and joined with the addition operator (+).
 *
 * @method print
 * @param {Any} contents any combination of Number, String, Object, Boolean,
 *                       Array to print
 * @example
 * <div><code class='norender'>
 * var x = 10;
 * print('The value of x is ' + x);
 * // prints "The value of x is 10"
 * </code></div>
 * @alt
 * default grey canvas
 */
p5.prototype.print = function(args) {
  if (typeof args === 'undefined') {
    _windowPrint();
  } else {
    console.log.apply(console, arguments);
  }
};

/**
 * The system variable frameCount contains the number of frames that have
 * been displayed since the program started. Inside setup() the value is 0,
 * after the first iteration of draw it is 1, etc.
 *
 * @property {Integer} frameCount
 * @readOnly
 * @example
 *   <div><code>
 * function setup() {
 *   frameRate(30);
 *   textSize(20);
 *   textSize(30);
 *   textAlign(CENTER);
 * }
 *
 * function draw() {
 *   background(200);
 *   text(frameCount, width / 2, height / 2);
 * }
</code></div>
 *
 * @alt
 * numbers rapidly counting upward with frame count set to 30.
 *
 */
p5.prototype.frameCount = 0;

/**
 * Confirms if the window a p5.js program is in is "focused," meaning that
 * the sketch will accept mouse or keyboard input. This variable is
 * "true" if the window is focused and "false" if not.
 *
 * @property {Boolean} focused
 * @readOnly
 * @example
 * <div><code>
 * // To demonstrate, put two windows side by side.
 * // Click on the window that the p5 sketch isn't in!
 * function draw() {
 *   background(200);
 *   noStroke();
 *   fill(0, 200, 0);
 *   ellipse(25, 25, 50, 50);
 *
 *   if (!focused) {
    // or "if (focused === false)"
 *     stroke(200, 0, 0);
 *     line(0, 0, 100, 100);
 *     line(100, 0, 0, 100);
 *   }
 * }
 * </code></div>
 *
 * @alt
 * green 50x50 ellipse at top left. Red X covers canvas when page focus changes
 *
 */
p5.prototype.focused = document.hasFocus();

/**
 * Sets the cursor to a predefined symbol or an image, or makes it visible
 * if already hidden. If you are trying to set an image as the cursor, the
 * recommended size is 16x16 or 32x32 pixels. It is not possible to load an
 * image as the cursor if you are exporting your program for the Web, and not
 * all MODES work with all browsers. The values for parameters x and y must
 * be less than the dimensions of the image.
 *
 * @method cursor
 * @param {String|Constant} type either ARROW, CROSS, HAND, MOVE, TEXT, or
 *                               WAIT, or path for image
 * @param {Number}          [x]  the horizontal active spot of the cursor
 * @param {Number}          [y]  the vertical active spot of the cursor
 * @example
 * <div><code>
 * // Move the mouse left and right across the image
 * // to see the cursor change from a cross to a hand
 * function draw() {
 *   line(width / 2, 0, width / 2, height);
 *   if (mouseX < 50) {
 *     cursor(CROSS);
 *   } else {
 *     cursor(HAND);
 *   }
 * }
 * </code></div>
 *
 * @alt
 * horizontal line divides canvas. cursor on left is a cross, right is hand.
 *
 */
p5.prototype.cursor = function(type, x, y) {
  var cursor = 'auto';
  var canvas = this._curElement.elt;
  if (standardCursors.indexOf(type) > -1) {
    // Standard css cursor
    cursor = type;
  } else if (typeof type === 'string') {
    var coords = '';
    if (x && y && (typeof x === 'number' && typeof y === 'number')) {
      // Note that x and y values must be unit-less positive integers < 32
      // https://developer.mozilla.org/en-US/docs/Web/CSS/cursor
      coords = x + ' ' + y;
    }
    if (
      type.substring(0, 7) === 'http://' ||
      type.substring(0, 8) === 'https://'
    ) {
      // Image (absolute url)
      cursor = 'url(' + type + ') ' + coords + ', auto';
    } else if (/\.(cur|jpg|jpeg|gif|png|CUR|JPG|JPEG|GIF|PNG)$/.test(type)) {
      // Image file (relative path) - Separated for performance reasons
      cursor = 'url(' + type + ') ' + coords + ', auto';
    } else {
      // Any valid string for the css cursor property
      cursor = type;
    }
  }
  canvas.style.cursor = cursor;
};

/**
 * Specifies the number of frames to be displayed every second. For example,
 * the function call frameRate(30) will attempt to refresh 30 times a second.
 * If the processor is not fast enough to maintain the specified rate, the
 * frame rate will not be achieved. Setting the frame rate within setup() is
 * recommended. The default rate is 60 frames per second. This is the same as
 * setFrameRate(val).
 * <br><br>
 * Calling frameRate() with no arguments returns the current framerate. The
 * draw function must run at least once before it will return a value. This
 * is the same as getFrameRate().
 * <br><br>
 * Calling frameRate() with arguments that are not of the type numbers
 * or are non positive also returns current framerate.
 *
 * @method frameRate
 * @param  {Number} fps number of frames to be displayed every second
 * @chainable
 *
 * @example
 *
 * <div><code>
 * var rectX = 0;
 * var fr = 30; //starting FPS
 * var clr;
 *
 * function setup() {
 *   background(200);
 *   frameRate(fr); // Attempt to refresh at starting FPS
 *   clr = color(255, 0, 0);
 * }
 *
 * function draw() {
 *   background(200);
 *   rectX = rectX += 1; // Move Rectangle
 *
 *   if (rectX >= width) {
    // If you go off screen.
 *     if (fr === 30) {
 *       clr = color(0, 0, 255);
 *       fr = 10;
 *       frameRate(fr); // make frameRate 10 FPS
 *     } else {
 *       clr = color(255, 0, 0);
 *       fr = 30;
 *       frameRate(fr); // make frameRate 30 FPS
 *     }
 *     rectX = 0;
 *   }
 *   fill(clr);
 *   rect(rectX, 40, 20, 20);
 * }
 * </code></div>
 *
 * @alt
 * blue rect moves left to right, followed by red rect moving faster. Loops.
 *
 */
/**
 * @method frameRate
 * @return {Number}       current frameRate
 */
p5.prototype.frameRate = function(fps) {
  p5._validateParameters('frameRate', arguments);
  if (typeof fps !== 'number' || fps < 0) {
    return this._frameRate;
  } else {
    this._setProperty('_targetFrameRate', fps);
    this._runFrames();
    return this;
  }
};
/**
 * Returns the current framerate.
 *
 * @private
 * @return {Number} current frameRate
 */
p5.prototype.getFrameRate = function() {
  return this.frameRate();
};

/**
 * Specifies the number of frames to be displayed every second. For example,
 * the function call frameRate(30) will attempt to refresh 30 times a second.
 * If the processor is not fast enough to maintain the specified rate, the
 * frame rate will not be achieved. Setting the frame rate within setup() is
 * recommended. The default rate is 60 frames per second.
 *
 * Calling frameRate() with no arguments returns the current framerate.
 *
 * @private
 * @param {Number} [fps] number of frames to be displayed every second
 */
p5.prototype.setFrameRate = function(fps) {
  return this.frameRate(fps);
};

/**
 * Hides the cursor from view.
 *
 * @method noCursor
 * @example
 * <div><code>
 * function setup() {
 *   noCursor();
 * }
 *
 * function draw() {
 *   background(200);
 *   ellipse(mouseX, mouseY, 10, 10);
 * }
 * </code></div>
 *
 *
 * @alt
 * cursor becomes 10x 10 white ellipse the moves with mouse x and y.
 *
 */
p5.prototype.noCursor = function() {
  this._curElement.elt.style.cursor = 'none';
};

/**
 * System variable that stores the width of the entire screen display. This
 * is used to run a full-screen program on any display size.
 *
 * @property {Number} displayWidth
 * @readOnly
 * @example
 * <div class="norender"><code>
 * createCanvas(displayWidth, displayHeight);
 * </code></div>
 *
 * @alt
 * cursor becomes 10x 10 white ellipse the moves with mouse x and y.
 *
 */
p5.prototype.displayWidth = screen.width;

/**
 * System variable that stores the height of the entire screen display. This
 * is used to run a full-screen program on any display size.
 *
 * @property {Number} displayHeight
 * @readOnly
 * @example
 * <div class="norender"><code>
 * createCanvas(displayWidth, displayHeight);
 * </code></div>
 *
 * @alt
 * no display.
 *
 */
p5.prototype.displayHeight = screen.height;

/**
 * System variable that stores the width of the inner window, it maps to
 * window.innerWidth.
 *
 * @property {Number} windowWidth
 * @readOnly
 * @example
 * <div class="norender"><code>
 * createCanvas(windowWidth, windowHeight);
 * </code></div>
 *
 * @alt
 * no display.
 *
 */
p5.prototype.windowWidth = getWindowWidth();
/**
 * System variable that stores the height of the inner window, it maps to
 * window.innerHeight.
 *
 * @property {Number} windowHeight
 * @readOnly
 * @example
 * <div class="norender"><code>
 * createCanvas(windowWidth, windowHeight);
 * </code></div>
 *@alt
 * no display.
 *
 */
p5.prototype.windowHeight = getWindowHeight();

/**
 * The windowResized() function is called once every time the browser window
 * is resized. This is a good place to resize the canvas or do any other
 * adjustments to accommodate the new window size.
 *
 * @method windowResized
 * @example
 * <div class="norender"><code>
 * function setup() {
 *   createCanvas(windowWidth, windowHeight);
 * }
 *
 * function draw() {
 *   background(0, 100, 200);
 * }
 *
 * function windowResized() {
 *   resizeCanvas(windowWidth, windowHeight);
 * }
 * </code></div>
 * @alt
 * no display.
 */
p5.prototype._onresize = function(e) {
  this._setProperty('windowWidth', getWindowWidth());
  this._setProperty('windowHeight', getWindowHeight());
  var context = this._isGlobal ? window : this;
  var executeDefault;
  if (typeof context.windowResized === 'function') {
    executeDefault = context.windowResized(e);
    if (executeDefault !== undefined && !executeDefault) {
      e.preventDefault();
    }
  }
};

function getWindowWidth() {
  return (
    window.innerWidth ||
    (document.documentElement && document.documentElement.clientWidth) ||
    (document.body && document.body.clientWidth) ||
    0
  );
}

function getWindowHeight() {
  return (
    window.innerHeight ||
    (document.documentElement && document.documentElement.clientHeight) ||
    (document.body && document.body.clientHeight) ||
    0
  );
}

/**
 * System variable that stores the width of the drawing canvas. This value
 * is set by the first parameter of the createCanvas() function.
 * For example, the function call createCanvas(320, 240) sets the width
 * variable to the value 320. The value of width defaults to 100 if
 * createCanvas() is not used in a program.
 *
 * @property {Number} width
 * @readOnly
 */
p5.prototype.width = 0;

/**
 * System variable that stores the height of the drawing canvas. This value
 * is set by the second parameter of the createCanvas() function. For
 * example, the function call createCanvas(320, 240) sets the height
 * variable to the value 240. The value of height defaults to 100 if
 * createCanvas() is not used in a program.
 *
 * @property {Number} height
 * @readOnly
 */
p5.prototype.height = 0;

/**
 * If argument is given, sets the sketch to fullscreen or not based on the
 * value of the argument. If no argument is given, returns the current
 * fullscreen state. Note that due to browser restrictions this can only
 * be called on user input, for example, on mouse press like the example
 * below.
 *
 * @method fullscreen
 * @param  {Boolean} [val] whether the sketch should be in fullscreen mode
 * or not
 * @return {Boolean} current fullscreen state
 * @example
 * <div>
 * <code>
 * // Clicking in the box toggles fullscreen on and off.
 * function setup() {
 *   background(200);
 * }
 * function mousePressed() {
 *   if (mouseX > 0 && mouseX < 100 && mouseY > 0 && mouseY < 100) {
 *     var fs = fullscreen();
 *     fullscreen(!fs);
 *   }
 * }
 * </code>
 * </div>
 *
 * @alt
 * no display.
 *
 */
p5.prototype.fullscreen = function(val) {
  p5._validateParameters('fullscreen', arguments);
  // no arguments, return fullscreen or not
  if (typeof val === 'undefined') {
    return (
      document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.mozFullScreenElement ||
      document.msFullscreenElement
    );
  } else {
    // otherwise set to fullscreen or not
    if (val) {
      launchFullscreen(document.documentElement);
    } else {
      exitFullscreen();
    }
  }
};

/**
 * Sets the pixel scaling for high pixel density displays. By default
 * pixel density is set to match display density, call pixelDensity(1)
 * to turn this off. Calling pixelDensity() with no arguments returns
 * the current pixel density of the sketch.
 *
 *
 * @method pixelDensity
 * @param  {Number} [val] whether or how much the sketch should scale
 * @returns {Number} current pixel density of the sketch
 * @example
 * <div>
 * <code>
 * function setup() {
 *   pixelDensity(1);
 *   createCanvas(100, 100);
 *   background(200);
 *   ellipse(width / 2, height / 2, 50, 50);
 * }
 * </code>
 * </div>
 * <div>
 * <code>
 * function setup() {
 *   pixelDensity(3.0);
 *   createCanvas(100, 100);
 *   background(200);
 *   ellipse(width / 2, height / 2, 50, 50);
 * }
 * </code>
 * </div>
 *
 * @alt
 * fuzzy 50x50 white ellipse with black outline in center of canvas.
 * sharp 50x50 white ellipse with black outline in center of canvas.
 */
p5.prototype.pixelDensity = function(val) {
  p5._validateParameters('pixelDensity', arguments);
  if (typeof val === 'number') {
    this._pixelDensity = val;
  } else {
    return this._pixelDensity;
  }
  this.resizeCanvas(this.width, this.height, true);
};

/**
 * Returns the pixel density of the current display the sketch is running on.
 *
 * @method displayDensity
 * @returns {Number} current pixel density of the display
 * @example
 * <div>
 * <code>
 * function setup() {
 *   var density = displayDensity();
 *   pixelDensity(density);
 *   createCanvas(100, 100);
 *   background(200);
 *   ellipse(width / 2, height / 2, 50, 50);
 * }
 * </code>
 * </div>
 *
 * @alt
 * 50x50 white ellipse with black outline in center of canvas.
 */
p5.prototype.displayDensity = function() {
  return window.devicePixelRatio;
};

function launchFullscreen(element) {
  var enabled =
    document.fullscreenEnabled ||
    document.webkitFullscreenEnabled ||
    document.mozFullScreenEnabled ||
    document.msFullscreenEnabled;
  if (!enabled) {
    throw new Error('Fullscreen not enabled in this browser.');
  }
  if (element.requestFullscreen) {
    element.requestFullscreen();
  } else if (element.mozRequestFullScreen) {
    element.mozRequestFullScreen();
  } else if (element.webkitRequestFullscreen) {
    element.webkitRequestFullscreen();
  } else if (element.msRequestFullscreen) {
    element.msRequestFullscreen();
  }
}

function exitFullscreen() {
  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen();
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen();
  } else if (document.msExitFullscreen) {
    document.msExitFullscreen();
  }
}

/**
 * Gets the current URL.
 * @method getURL
 * @return {String} url
 * @example
 * <div>
 * <code>
 * var url;
 * var x = 100;
 *
 * function setup() {
 *   fill(0);
 *   noStroke();
 *   url = getURL();
 * }
 *
 * function draw() {
 *   background(200);
 *   text(url, x, height / 2);
 *   x--;
 * }
 * </code>
 * </div>
 *
 * @alt
 * current url (http://p5js.org/reference/#/p5/getURL) moves right to left.
 *
 */
p5.prototype.getURL = function() {
  return location.href;
};
/**
 * Gets the current URL path as an array.
 * @method getURLPath
 * @return {String[]} path components
 * @example
 * <div class='norender'><code>
 * function setup() {
 *   var urlPath = getURLPath();
 *   for (var i = 0; i < urlPath.length; i++) {
 *     text(urlPath[i], 10, i * 20 + 20);
 *   }
 * }
 * </code></div>
 *
 * @alt
 *no display
 *
 */
p5.prototype.getURLPath = function() {
  return location.pathname.split('/').filter(function(v) {
    return v !== '';
  });
};
/**
 * Gets the current URL params as an Object.
 * @method getURLParams
 * @return {Object} URL params
 * @example
 * <div class='norender'>
 * <code>
 * // Example: http://p5js.org?year=2014&month=May&day=15
 *
 * function setup() {
 *   var params = getURLParams();
 *   text(params.day, 10, 20);
 *   text(params.month, 10, 40);
 *   text(params.year, 10, 60);
 * }
 * </code>
 * </div>
 * @alt
 * no display.
 *
 */
p5.prototype.getURLParams = function() {
  var re = /[?&]([^&=]+)(?:[&=])([^&=]+)/gim;
  var m;
  var v = {};
  while ((m = re.exec(location.search)) != null) {
    if (m.index === re.lastIndex) {
      re.lastIndex++;
    }
    v[m[1]] = m[2];
  }
  return v;
};

module.exports = p5;

},{"./constants":21,"./core":22}],25:[function(_dereq_,module,exports){
/**
 * @for p5
 * @requires core
 */

'use strict';

var p5 = _dereq_('./core');
var constants = _dereq_('./constants');

if (typeof IS_MINIFIED !== 'undefined') {
  p5._validateParameters = p5._friendlyFileLoadError = function() {};
} else {
  var doFriendlyWelcome = false; // TEMP until we get it all working LM
  // for parameter validation
  var dataDoc = _dereq_('../../docs/reference/data.json');
  var arrDoc = JSON.parse(JSON.stringify(dataDoc));

  // -- Borrowed from jQuery 1.11.3 --
  var class2type = {};
  var toString = class2type.toString;
  var names = [
    'Boolean',
    'Number',
    'String',
    'Function',
    'Array',
    'Date',
    'RegExp',
    'Object',
    'Error'
  ];
  for (var n = 0; n < names.length; n++) {
    class2type['[object ' + names[n] + ']'] = names[n].toLowerCase();
  }
  var getType = function(obj) {
    if (obj == null) {
      return obj + '';
    }
    return typeof obj === 'object' || typeof obj === 'function'
      ? class2type[toString.call(obj)] || 'object'
      : typeof obj;
  };

  // -- End borrow --

  var friendlyWelcome = function() {
    // p5.js brand - magenta: #ED225D
    //var astrixBgColor = 'transparent';
    //var astrixTxtColor = '#ED225D';
    //var welcomeBgColor = '#ED225D';
    //var welcomeTextColor = 'white';
    console.log(
      '    _ \n' +
        ' /\\| |/\\ \n' +
        " \\ ` ' /  \n" +
        ' / , . \\  \n' +
        ' \\/|_|\\/ ' +
        '\n\n> p5.js says: Welcome! ' +
        'This is your friendly debugger. ' +
        'To turn me off switch to using “p5.min.js”.'
    );
  };

  /**
   * Prints out a fancy, colorful message to the console log
   *
   * @private
   * @param  {String}               message the words to be said
   * @param  {String}               func    the name of the function to link
   * @param  {Number|String} color   CSS color string or error type
   *
   * @return console logs
   */
  // Wrong number of params, undefined param, wrong type
  var FILE_LOAD = 3;
  var ERR_PARAMS = 3;
  // p5.js blue, p5.js orange, auto dark green; fallback p5.js darkened magenta
  // See testColors below for all the color codes and names
  var typeColors = ['#2D7BB6', '#EE9900', '#4DB200', '#C83C00'];
  var report = function(message, func, color) {
    if (doFriendlyWelcome) {
      friendlyWelcome();
      doFriendlyWelcome = false;
    }
    if ('undefined' === getType(color)) {
      color = '#B40033'; // dark magenta
    } else if (getType(color) === 'number') {
      // Type to color
      color = typeColors[color];
    }
    if (func.substring(0, 4) === 'load') {
      console.log(
        '> p5.js says: ' +
          message +
          '[https://github.com/processing/p5.js/wiki/Local-server]'
      );
    } else {
      console.log(
        '> p5.js says: ' +
          message +
          ' [http://p5js.org/reference/#p5/' +
          func +
          ']'
      );
    }
  };

  var errorCases = {
    '0': {
      fileType: 'image',
      method: 'loadImage',
      message: ' hosting the image online,'
    },
    '1': {
      fileType: 'XML file',
      method: 'loadXML'
    },
    '2': {
      fileType: 'table file',
      method: 'loadTable'
    },
    '3': {
      fileType: 'text file',
      method: 'loadStrings'
    },
    '4': {
      fileType: 'font',
      method: 'loadFont',
      message: ' hosting the font online,'
    }
  };
  p5._friendlyFileLoadError = function(errorType, filePath) {
    var errorInfo = errorCases[errorType];
    var message =
      'It looks like there was a problem' +
      ' loading your ' +
      errorInfo.fileType +
      '.' +
      ' Try checking if the file path [' +
      filePath +
      '] is correct,' +
      (errorInfo.message || '') +
      ' or running a local server.';
    report(message, errorInfo.method, FILE_LOAD);
  };

  var docCache = {};
  var builtinTypes = [
    'number',
    'string',
    'boolean',
    'constant',
    'function',
    'any',
    'integer'
  ];

  // validateParameters() helper functions:
  // lookupParamDoc() for querying data.json
  var lookupParamDoc = function(func) {
    var queryResult = arrDoc.classitems.filter(function(x) {
      return x.name === func;
    });
    // different JSON structure for funct with multi-format
    var overloads = [];
    if (queryResult[0].hasOwnProperty('overloads')) {
      for (var i = 0; i < queryResult[0].overloads.length; i++) {
        overloads.push(queryResult[0].overloads[i].params);
      }
    } else {
      overloads.push(queryResult[0].params);
    }

    var mapConstants = {};
    var maxParams = 0;
    overloads.forEach(function(formats) {
      if (maxParams < formats.length) {
        maxParams = formats.length;
      }
      formats.forEach(function(format) {
        format.types = format.type.split('|').map(function ct(type) {
          // array
          if (type.substr(type.length - 2, 2) === '[]') {
            return {
              name: type,
              array: ct(type.substr(0, type.length - 2))
            };
          }

          var lowerType = type.toLowerCase();

          // contant
          if (lowerType === 'constant') {
            var constant;
            if (mapConstants.hasOwnProperty(format.name)) {
              constant = mapConstants[format.name];
            } else {
              // parse possible constant values from description
              var myRe = /either\s+(?:[A-Z0-9_]+\s*,?\s*(?:or)?\s*)+/g;
              var values = {};
              var names = [];

              constant = mapConstants[format.name] = {
                values: values,
                names: names
              };

              var myArray = myRe.exec(format.description);
              if (func === 'endShape' && format.name === 'mode') {
                values[constants.CLOSE] = true;
                names.push('CLOSE');
              } else {
                var match = myArray[0];
                var reConst = /[A-Z0-9_]+/g;
                var matchConst;
                while ((matchConst = reConst.exec(match)) !== null) {
                  var name = matchConst[0];
                  if (constants.hasOwnProperty(name)) {
                    values[constants[name]] = true;
                    names.push(name);
                  }
                }
              }
            }
            return {
              name: type,
              builtin: lowerType,
              names: constant.names,
              values: constant.values
            };
          }

          // function
          if (lowerType.substr(0, 'function'.length) === 'function') {
            lowerType = 'function';
          }
          // builtin
          if (builtinTypes.indexOf(lowerType) >= 0) {
            return { name: type, builtin: lowerType };
          }

          // p5 class type
          var t = window;
          type.split('.').forEach(function(p) {
            t = t && t[p];
          });
          if (t) {
            return { name: type, prototype: t };
          }

          return { name: type, type: lowerType };
        });
      });
    });
    return {
      overloads: overloads,
      maxParams: maxParams
    };
  };

  var testParamType = function(param, type) {
    var isArray = param instanceof Array;
    if (type.array && isArray) {
      for (var i = 0; i < param.length; i++) {
        if (!testParamType(param[i], type.array)) {
          return false;
        }
      }
      return true;
    } else if (type.prototype) {
      return param instanceof type.prototype;
    } else if (type.builtin) {
      switch (type.builtin) {
        case 'number':
          return typeof param === 'number' || (!!param && !isNaN(param));
        case 'integer':
          return (
            (typeof param === 'number' || (!!param && !isNaN(param))) &&
            Number(param) === Math.floor(param)
          );
        case 'boolean':
        case 'any':
          return true;
        case 'array':
          return isArray;
        case 'string':
          return typeof param === 'number' || typeof param === 'string';
        case 'constant':
          return type.values.hasOwnProperty(param);
        case 'function':
          return param instanceof Function;
      }
    }

    return typeof param === type.t;
  };

  // testType() for non-object type parameter validation
  // Returns true if PASS, false if FAIL
  var testParamTypes = function(param, types) {
    for (var i = 0; i < types.length; i++) {
      if (testParamType(param, types[i])) {
        return true;
      }
    }
    return false;
  };

  var testParamFormat = function(args, formats) {
    var errorArray = [];
    for (var p = 0; p < formats.length; p++) {
      var arg = args[p];
      var format = formats[p];
      var argType = typeof arg;
      if ('undefined' === argType || null === arg) {
        if (format.optional !== true) {
          errorArray.push({
            type: 'EMPTY_VAR',
            position: p,
            format: format
          });
        }
      } else if (!testParamTypes(arg, format.types)) {
        errorArray.push({
          type: 'WRONG_TYPE',
          position: p,
          format: format,
          arg: arg
        });
      }
    }
    return errorArray;
  };

  // function for generating console.log() msg
  p5._friendlyParamError = function(errorObj, func) {
    var message;

    function formatType() {
      var format = errorObj.format;
      return format.types
        .map(function(type) {
          return type.names ? type.names.join('|') : type.name;
        })
        .join('|');
    }

    switch (errorObj.type) {
      case 'EMPTY_VAR':
        message =
          func +
          '() was expecting ' +
          formatType() +
          ' for parameter #' +
          errorObj.position +
          ' (zero-based index), received an empty variable instead.' +
          ' If not intentional, this is often a problem with scope:' +
          ' [https://p5js.org/examples/data-variable-scope.html]';
        break;
      case 'WRONG_TYPE':
        var arg = errorObj.arg;
        var argType = arg instanceof Array ? 'array' : arg.name || typeof arg;
        message =
          func +
          '() was expecting ' +
          formatType() +
          ' for parameter #' +
          errorObj.position +
          ' (zero-based index), received ' +
          argType +
          ' instead';
        break;
      case 'WRONG_ARGUMENT_COUNT':
        message =
          func +
          '() was expecting ' +
          errorObj.maxParams +
          ' arguments, but received ' +
          errorObj.argCount;
        break;
    }

    if (message) {
      try {
        var re = /Function\.validateParameters.*[\r\n].*[\r\n].*\(([^)]*)/;
        var location = re.exec(new Error().stack)[1];
        if (location) {
          message += ' at ' + location;
        }
      } catch (err) {}

      report(message + '.', func, ERR_PARAMS);
    }
  };

  /**
   * Validates parameters
   * param  {String}               func    the name of the function
   * param  {Array}                args    user input arguments
   *
   * example:
   *  var a;
   *  ellipse(10,10,a,5);
   * console ouput:
   *  "It looks like ellipse received an empty variable in spot #2."
   *
   * example:
   *  ellipse(10,"foo",5,5);
   * console output:
   *  "ellipse was expecting a number for parameter #1,
   *           received "foo" instead."
   */
  p5._validateParameters = function validateParameters(func, args) {
    if (p5.disableFriendlyErrors) {
      return; // skip FES
    }

    var docs = docCache[func] || (docCache[func] = lookupParamDoc(func));
    var errorArray = [];
    var minErrCount = 999999;
    var overloads = docs.overloads;
    for (var i = 0; i < overloads.length; i++) {
      var arrError = testParamFormat(args, overloads[i]);
      // see if this is the format with min number of err
      if (minErrCount > arrError.length) {
        minErrCount = arrError.length;
        errorArray = arrError;
      }
      if (arrError.length === 0) {
        break; // no error
      }
    }

    if (!errorArray.length && args.length > docs.maxParams) {
      errorArray.push({
        type: 'WRONG_ARGUMENT_COUNT',
        argCount: args.length,
        maxParams: docs.maxParams
      });
    }

    // generate err msg
    for (var n = 0; n < errorArray.length; n++) {
      p5._friendlyParamError(errorArray[n], func);
    }
  };

  /**
   * Prints out all the colors in the color pallete with white text.
   * For color blindness testing.
   */
  /* function testColors() {
    var str = 'A box of biscuits, a box of mixed biscuits and a biscuit mixer';
    report(str, 'print', '#ED225D'); // p5.js magenta
    report(str, 'print', '#2D7BB6'); // p5.js blue
    report(str, 'print', '#EE9900'); // p5.js orange
    report(str, 'print', '#A67F59'); // p5.js light brown
    report(str, 'print', '#704F21'); // p5.js gold
    report(str, 'print', '#1CC581'); // auto cyan
    report(str, 'print', '#FF6625'); // auto orange
    report(str, 'print', '#79EB22'); // auto green
    report(str, 'print', '#B40033'); // p5.js darkened magenta
    report(str, 'print', '#084B7F'); // p5.js darkened blue
    report(str, 'print', '#945F00'); // p5.js darkened orange
    report(str, 'print', '#6B441D'); // p5.js darkened brown
    report(str, 'print', '#2E1B00'); // p5.js darkened gold
    report(str, 'print', '#008851'); // auto dark cyan
    report(str, 'print', '#C83C00'); // auto dark orange
    report(str, 'print', '#4DB200'); // auto dark green
  } */

  p5.prototype._validateParameters = p5.validateParameters;
}

// This is a lazily-defined list of p5 symbols that may be
// misused by beginners at top-level code, outside of setup/draw. We'd like
// to detect these errors and help the user by suggesting they move them
// into setup/draw.
//
// For more details, see https://github.com/processing/p5.js/issues/1121.
var misusedAtTopLevelCode = null;
var FAQ_URL =
  'https://github.com/processing/p5.js/wiki/' +
  'Frequently-Asked-Questions' +
  '#why-cant-i-assign-variables-using-p5-functions-and-' +
  'variables-before-setup';

var defineMisusedAtTopLevelCode = function() {
  var uniqueNamesFound = {};

  var getSymbols = function(obj) {
    return Object.getOwnPropertyNames(obj)
      .filter(function(name) {
        if (name[0] === '_') {
          return false;
        }
        if (name in uniqueNamesFound) {
          return false;
        }

        uniqueNamesFound[name] = true;

        return true;
      })
      .map(function(name) {
        var type;

        if (typeof obj[name] === 'function') {
          type = 'function';
        } else if (name === name.toUpperCase()) {
          type = 'constant';
        } else {
          type = 'variable';
        }

        return { name: name, type: type };
      });
  };

  misusedAtTopLevelCode = [].concat(
    getSymbols(p5.prototype),
    // At present, p5 only adds its constants to p5.prototype during
    // construction, which may not have happened at the time a
    // ReferenceError is thrown, so we'll manually add them to our list.
    getSymbols(_dereq_('./constants'))
  );

  // This will ultimately ensure that we report the most specific error
  // possible to the user, e.g. advising them about HALF_PI instead of PI
  // when their code misuses the former.
  misusedAtTopLevelCode.sort(function(a, b) {
    return b.name.length - a.name.length;
  });
};

var helpForMisusedAtTopLevelCode = function(e, log) {
  if (!log) {
    log = console.log.bind(console);
  }

  if (!misusedAtTopLevelCode) {
    defineMisusedAtTopLevelCode();
  }

  // If we find that we're logging lots of false positives, we can
  // uncomment the following code to avoid displaying anything if the
  // user's code isn't likely to be using p5's global mode. (Note that
  // setup/draw are more likely to be defined due to JS function hoisting.)
  //
  //if (!('setup' in window || 'draw' in window)) {
  //  return;
  //}

  misusedAtTopLevelCode.some(function(symbol) {
    // Note that while just checking for the occurrence of the
    // symbol name in the error message could result in false positives,
    // a more rigorous test is difficult because different browsers
    // log different messages, and the format of those messages may
    // change over time.
    //
    // For example, if the user uses 'PI' in their code, it may result
    // in any one of the following messages:
    //
    //   * 'PI' is undefined                           (Microsoft Edge)
    //   * ReferenceError: PI is undefined             (Firefox)
    //   * Uncaught ReferenceError: PI is not defined  (Chrome)

    if (e.message && e.message.match('\\W?' + symbol.name + '\\W') !== null) {
      log(
        "Did you just try to use p5.js's " +
          symbol.name +
          (symbol.type === 'function' ? '() ' : ' ') +
          symbol.type +
          '? If so, you may want to ' +
          "move it into your sketch's setup() function.\n\n" +
          'For more details, see: ' +
          FAQ_URL
      );
      return true;
    }
  });
};

// Exposing this primarily for unit testing.
p5.prototype._helpForMisusedAtTopLevelCode = helpForMisusedAtTopLevelCode;

if (document.readyState !== 'complete') {
  window.addEventListener('error', helpForMisusedAtTopLevelCode, false);

  // Our job is only to catch ReferenceErrors that are thrown when
  // global (non-instance mode) p5 APIs are used at the top-level
  // scope of a file, so we'll unbind our error listener now to make
  // sure we don't log false positives later.
  window.addEventListener('load', function() {
    window.removeEventListener('error', helpForMisusedAtTopLevelCode, false);
  });
}

module.exports = p5;

},{"../../docs/reference/data.json":1,"./constants":21,"./core":22}],26:[function(_dereq_,module,exports){
'use strict';

var p5 = _dereq_('../core/core');

/**
 * _globalInit
 *
 * TODO: ???
 * if sketch is on window
 * assume "global" mode
 * and instantiate p5 automatically
 * otherwise do nothing
 *
 * @private
 * @return {Undefined}
 */
var _globalInit = function() {
  if (!window.PHANTOMJS && !window.mocha) {
    // If there is a setup or draw function on the window
    // then instantiate p5 in "global" mode
    if (
      ((window.setup && typeof window.setup === 'function') ||
        (window.draw && typeof window.draw === 'function')) &&
      !p5.instance
    ) {
      new p5();
    }
  }
};

// TODO: ???
if (document.readyState === 'complete') {
  _globalInit();
} else {
  window.addEventListener('load', _globalInit, false);
}

},{"../core/core":22}],27:[function(_dereq_,module,exports){
/**
 * @module DOM
 * @submodule DOM
 * @for p5.Element
 */

'use strict';

var p5 = _dereq_('./core');

/**
 * Base class for all elements added to a sketch, including canvas,
 * graphics buffers, and other HTML elements. Methods in blue are
 * included in the core functionality, methods in brown are added
 * with the <a href="http://p5js.org/reference/#/libraries/p5.dom">p5.dom
 * library</a>.
 * It is not called directly, but p5.Element
 * objects are created by calling createCanvas, createGraphics,
 * or in the p5.dom library, createDiv, createImg, createInput, etc.
 *
 * @class p5.Element
 * @constructor
 * @param {String} elt DOM node that is wrapped
 * @param {p5} [pInst] pointer to p5 instance
 */
p5.Element = function(elt, pInst) {
  /**
   * Underlying HTML element. All normal HTML methods can be called on this.
   * @example
   * <div>
   * <code>
   * createCanvas(300, 500);
   * background(0, 0, 0, 0);
   * var input = createInput();
   * input.position(20, 225);
   * var inputElem = new p5.Element(input.elt);
   * inputElem.style('width:450px;');
   * inputElem.value('some string');
   * </code>
   * </div>
   *
   * @property elt
   * @readOnly
   */
  this.elt = elt;
  this._pInst = pInst;
  this._events = {};
  this.width = this.elt.offsetWidth;
  this.height = this.elt.offsetHeight;
  this.name = 'p5.Element'; // for friendly debugger system
};

/**
 *
 * Attaches the element to the parent specified. A way of setting
 * the container for the element. Accepts either a string ID, DOM
 * node, or p5.Element. If no arguments given, parent node is returned.
 * For more ways to position the canvas, see the
 * <a href='https://github.com/processing/p5.js/wiki/Positioning-your-canvas'>
 * positioning the canvas</a> wiki page.
 *
 * @method parent
 * @param  {String|p5.Element|Object} parent the ID, DOM node, or p5.Element
 *                         of desired parent element
 * @chainable
 *
 * @example
 * <div class="norender"><code>
 * // in the html file:
 * // &lt;div id="myContainer">&lt;/div>
 *
 * // in the js file:
 * var cnv = createCanvas(100, 100);
 * cnv.parent('myContainer');
 * </code></div>
 * <div class='norender'><code>
 * var div0 = createDiv('this is the parent');
 * var div1 = createDiv('this is the child');
 * div1.parent(div0); // use p5.Element
 * </code></div>
 * <div class='norender'><code>
 * var div0 = createDiv('this is the parent');
 * div0.id('apples');
 * var div1 = createDiv('this is the child');
 * div1.parent('apples'); // use id
 * </code></div>
 * <div class='norender'><code>
 * var elt = document.getElementById('myParentDiv');
 * var div1 = createDiv('this is the child');
 * div1.parent(elt); // use element from page
 * </code></div>
 *
 * @alt
 * no display.
 */
/**
 * @method parent
 * @return {p5.Element}
 *
 */
p5.Element.prototype.parent = function(p) {
  if (typeof p === 'undefined') {
    return this.elt.parentNode;
  }

  if (typeof p === 'string') {
    if (p[0] === '#') {
      p = p.substring(1);
    }
    p = document.getElementById(p);
  } else if (p instanceof p5.Element) {
    p = p.elt;
  }
  p.appendChild(this.elt);
  return this;
};

/**
 *
 * Sets the ID of the element. If no ID argument is passed in, it instead
 * returns the current ID of the element.
 *
 * @method id
 * @param  {String} id ID of the element
 * @chainable
 *
 * @example
 * <div class='norender'><code>
 * function setup() {
 *   var cnv = createCanvas(100, 100);
 *   // Assigns a CSS selector ID to
 *   // the canvas element.
 *   cnv.id('mycanvas');
 * }
 * </code></div>
 *
 * @alt
 * no display.
 */
/**
 * @method id
 * @return {String} the id of the element
 */
p5.Element.prototype.id = function(id) {
  if (typeof id === 'undefined') {
    return this.elt.id;
  }

  this.elt.id = id;
  this.width = this.elt.offsetWidth;
  this.height = this.elt.offsetHeight;
  return this;
};

/**
 *
 * Adds given class to the element. If no class argument is passed in, it
 * instead returns a string containing the current class(es) of the element.
 *
 * @method class
 * @param  {String} class class to add
 * @chainable
 *
 * @example
 * <div class='norender'><code>
 * function setup() {
 *   var cnv = createCanvas(100, 100);
 *   // Assigns a CSS selector class 'small'
 *   // to the canvas element.
 *   cnv.class('small');
 * }
 * </code></div>
 *
 * @alt
 * no display.
 */
/**
 * @method class
 * @return {String} the class of the element
 */
p5.Element.prototype.class = function(c) {
  if (typeof c === 'undefined') {
    return this.elt.className;
  }

  this.elt.className = c;
  return this;
};

/**
 * The .mousePressed() function is called once after every time a
 * mouse button is pressed over the element. This can be used to
 * attach element specific event listeners.
 *
 * @method mousePressed
 * @param  {Function|Boolean} fxn function to be fired when mouse is
 *                                pressed over the element.
 *                                if `false` is passed instead, the previously
 *                                firing function will no longer fire.
 * @chainable
 * @example
 * <div class='norender'><code>
 * var cnv;
 * var d;
 * var g;
 * function setup() {
 *   cnv = createCanvas(100, 100);
 *   cnv.mousePressed(changeGray); // attach listener for
 *   // canvas click only
 *   d = 10;
 *   g = 100;
 * }
 *
 * function draw() {
 *   background(g);
 *   ellipse(width / 2, height / 2, d, d);
 * }
 *
 * // this function fires with any click anywhere
 * function mousePressed() {
 *   d = d + 10;
 * }
 *
 * // this function fires only when cnv is clicked
 * function changeGray() {
 *   g = random(0, 255);
 * }
 * </code></div>
 *
 * @alt
 * no display.
 *
 */
p5.Element.prototype.mousePressed = function(fxn) {
  adjustListener('mousedown', fxn, this);
  adjustListener('touchstart', fxn, this);
  return this;
};

/**
 * The .doubleClicked() function is called once after every time a
 * mouse button is pressed twice over the element. This can be used to
 * attach element and action specific event listeners.
 *
 * @method doubleClicked
 * @param  {Function|Boolean} fxn function to be fired when mouse is
 *                                double clicked over the element.
 *                                if `false` is passed instead, the previously
 *                                firing function will no longer fire.
 * @return {p5.Element}
 * @example
 * <div class='norender'><code>
 * var cnv;
 * var d;
 * var g;
 * function setup() {
 *   cnv = createCanvas(100, 100);
 *   cnv.doubleClicked(changeGray); // attach listener for
 *   // canvas double click only
 *   d = 10;
 *   g = 100;
 * }
 *
 * function draw() {
 *   background(g);
 *   ellipse(width / 2, height / 2, d, d);
 * }
 *
 * // this function fires with any double click anywhere
 * function doubleClicked() {
 *   d = d + 10;
 * }
 *
 * // this function fires only when cnv is double clicked
 * function changeGray() {
 *   g = random(0, 255);
 * }
 * </code></div>
 *
 * @alt
 * no display.
 *
 */
p5.Element.prototype.doubleClicked = function(fxn) {
  adjustListener('dblclick', fxn, this);
  return this;
};

/**
 * The .mouseWheel() function is called once after every time a
 * mouse wheel is scrolled over the element. This can be used to
 * attach element specific event listeners.
 * <br><br>
 * The function accepts a callback function as argument which will be executed
 * when the `wheel` event is triggered on the element, the callback function is
 * passed one argument `event`. The `event.deltaY` property returns negative
 * values if the mouse wheel is rotated up or away from the user and positive
 * in the other direction. The `event.deltaX` does the same as `event.deltaY`
 * except it reads the horizontal wheel scroll of the mouse wheel.
 * <br><br>
 * On OS X with "natural" scrolling enabled, the `event.deltaY` values are
 * reversed.
 *
 * @method mouseWheel
 * @param  {Function|Boolean} fxn function to be fired when mouse is
 *                                scrolled over the element.
 *                                if `false` is passed instead, the previously
 *                                firing function will no longer fire.
 * @chainable
 * @example
 * <div class='norender'><code>
 * var cnv;
 * var d;
 * var g;
 * function setup() {
 *   cnv = createCanvas(100, 100);
 *   cnv.mouseWheel(changeSize); // attach listener for
 *   // activity on canvas only
 *   d = 10;
 *   g = 100;
 * }
 *
 * function draw() {
 *   background(g);
 *   ellipse(width / 2, height / 2, d, d);
 * }
 *
 * // this function fires with mousewheel movement
 * // anywhere on screen
 * function mouseWheel() {
 *   g = g + 10;
 * }
 *
 * // this function fires with mousewheel movement
 * // over canvas only
 * function changeSize(event) {
 *   if (event.deltaY > 0) {
 *     d = d + 10;
 *   } else {
 *     d = d - 10;
 *   }
 * }
 * </code></div>
 *
 *
 * @alt
 * no display.
 *
 */
p5.Element.prototype.mouseWheel = function(fxn) {
  adjustListener('wheel', fxn, this);
  return this;
};

/**
 * The .mouseReleased() function is called once after every time a
 * mouse button is released over the element. This can be used to
 * attach element specific event listeners.
 *
 * @method mouseReleased
 * @param  {Function|Boolean} fxn function to be fired when mouse is
 *                                released over the element.
 *                                if `false` is passed instead, the previously
 *                                firing function will no longer fire.
 * @chainable
 * @example
 * <div class='norender'><code>
 * var cnv;
 * var d;
 * var g;
 * function setup() {
 *   cnv = createCanvas(100, 100);
 *   cnv.mouseReleased(changeGray); // attach listener for
 *   // activity on canvas only
 *   d = 10;
 *   g = 100;
 * }
 *
 * function draw() {
 *   background(g);
 *   ellipse(width / 2, height / 2, d, d);
 * }
 *
 * // this function fires after the mouse has been
 * // released
 * function mouseReleased() {
 *   d = d + 10;
 * }
 *
 * // this function fires after the mouse has been
 * // released while on canvas
 * function changeGray() {
 *   g = random(0, 255);
 * }
 * </code></div>
 *
 *
 * @alt
 * no display.
 *
 */
p5.Element.prototype.mouseReleased = function(fxn) {
  adjustListener('mouseup', fxn, this);
  adjustListener('touchend', fxn, this);
  return this;
};

/**
 * The .mouseClicked() function is called once after a mouse button is
 * pressed and released over the element. This can be used to
 * attach element specific event listeners.
 *
 * @method mouseClicked
 * @param  {Function|Boolean} fxn function to be fired when mouse is
 *                                clicked over the element.
 *                                if `false` is passed instead, the previously
 *                                firing function will no longer fire.
 * @chainable
 * @example
 * <div class="norender">
 * <code>
 * var cnv;
 * var d;
 * var g;
 *
 * function setup() {
 *   cnv = createCanvas(100, 100);
 *   cnv.mouseClicked(changeGray); // attach listener for
 *   // activity on canvas only
 *   d = 10;
 *   g = 100;
 * }
 *
 * function draw() {
 *   background(g);
 *   ellipse(width / 2, height / 2, d, d);
 * }
 *
 * // this function fires after the mouse has been
 * // clicked anywhere
 * function mouseClicked() {
 *   d = d + 10;
 * }
 *
 * // this function fires after the mouse has been
 * // clicked on canvas
 * function changeGray() {
 *   g = random(0, 255);
 * }
 * </code>
 * </div>
 *
 * @alt
 * no display.
 *
 */
p5.Element.prototype.mouseClicked = function(fxn) {
  adjustListener('click', fxn, this);
  return this;
};

/**
 * The .mouseMoved() function is called once every time a
 * mouse moves over the element. This can be used to attach an
 * element specific event listener.
 *
 * @method mouseMoved
 * @param  {Function|Boolean} fxn function to be fired when a mouse moves
 *                                over the element.
 *                                if `false` is passed instead, the previously
 *                                firing function will no longer fire.
 * @chainable
 * @example
 * <div class='norender'><code>
 * var cnv;
 * var d = 30;
 * var g;
 * function setup() {
 *   cnv = createCanvas(100, 100);
 *   cnv.mouseMoved(changeSize); // attach listener for
 *   // activity on canvas only
 *   d = 10;
 *   g = 100;
 * }
 *
 * function draw() {
 *   background(g);
 *   fill(200);
 *   ellipse(width / 2, height / 2, d, d);
 * }
 *
 * // this function fires when mouse moves anywhere on
 * // page
 * function mouseMoved() {
 *   g = g + 5;
 *   if (g > 255) {
 *     g = 0;
 *   }
 * }
 *
 * // this function fires when mouse moves over canvas
 * function changeSize() {
 *   d = d + 2;
 *   if (d > 100) {
 *     d = 0;
 *   }
 * }
 * </code></div>
 *
 *
 * @alt
 * no display.
 *
 */
p5.Element.prototype.mouseMoved = function(fxn) {
  adjustListener('mousemove', fxn, this);
  adjustListener('touchmove', fxn, this);
  return this;
};

/**
 * The .mouseOver() function is called once after every time a
 * mouse moves onto the element. This can be used to attach an
 * element specific event listener.
 *
 * @method mouseOver
 * @param  {Function|Boolean} fxn function to be fired when a mouse moves
 *                                onto the element.
 *                                if `false` is passed instead, the previously
 *                                firing function will no longer fire.
 * @chainable
 * @example
 * <div class='norender'><code>
 * var cnv;
 * var d;
 * function setup() {
 *   cnv = createCanvas(100, 100);
 *   cnv.mouseOver(changeGray);
 *   d = 10;
 * }
 *
 * function draw() {
 *   ellipse(width / 2, height / 2, d, d);
 * }
 *
 * function changeGray() {
 *   d = d + 10;
 *   if (d > 100) {
 *     d = 0;
 *   }
 * }
 * </code></div>
 *
 *
 * @alt
 * no display.
 *
 */
p5.Element.prototype.mouseOver = function(fxn) {
  adjustListener('mouseover', fxn, this);
  return this;
};

/**
 * The .changed() function is called when the value of an
 * element changes.
 * This can be used to attach an element specific event listener.
 *
 * @method changed
 * @param  {Function|Boolean} fxn function to be fired when the value of
 *                                an element changes.
 *                                if `false` is passed instead, the previously
 *                                firing function will no longer fire.
 * @chainable
 * @example
 * <div><code>
 * var sel;
 *
 * function setup() {
 *   textAlign(CENTER);
 *   background(200);
 *   sel = createSelect();
 *   sel.position(10, 10);
 *   sel.option('pear');
 *   sel.option('kiwi');
 *   sel.option('grape');
 *   sel.changed(mySelectEvent);
 * }
 *
 * function mySelectEvent() {
 *   var item = sel.value();
 *   background(200);
 *   text("it's a " + item + '!', 50, 50);
 * }
 * </code></div>
 * <div><code>
 * var checkbox;
 * var cnv;
 *
 * function setup() {
 *   checkbox = createCheckbox(' fill');
 *   checkbox.changed(changeFill);
 *   cnv = createCanvas(100, 100);
 *   cnv.position(0, 30);
 *   noFill();
 * }
 *
 * function draw() {
 *   background(200);
 *   ellipse(50, 50, 50, 50);
 * }
 *
 * function changeFill() {
 *   if (checkbox.checked()) {
 *     fill(0);
 *   } else {
 *     noFill();
 *   }
 * }
 * </code></div>
 *
 * @alt
 * dropdown: pear, kiwi, grape. When selected text "its a" + selection shown.
 *
 */
p5.Element.prototype.changed = function(fxn) {
  adjustListener('change', fxn, this);
  return this;
};

/**
 * The .input() function is called when any user input is
 * detected with an element. The input event is often used
 * to detect keystrokes in a input element, or changes on a
 * slider element. This can be used to attach an element specific
 * event listener.
 *
 * @method input
 * @param  {Function|Boolean} fxn function to be fired when any user input is
 *                                detected within the element.
 *                                if `false` is passed instead, the previously
 *                                firing function will no longer fire.
 * @chainable
 * @example
 * <div class='norender'><code>
 * // Open your console to see the output
 * function setup() {
 *   var inp = createInput('');
 *   inp.input(myInputEvent);
 * }
 *
 * function myInputEvent() {
 *   console.log('you are typing: ', this.value());
 * }
 * </code></div>
 *
 * @alt
 * no display.
 *
 */
p5.Element.prototype.input = function(fxn) {
  adjustListener('input', fxn, this);
  return this;
};

/**
 * The .mouseOut() function is called once after every time a
 * mouse moves off the element. This can be used to attach an
 * element specific event listener.
 *
 * @method mouseOut
 * @param  {Function|Boolean} fxn function to be fired when a mouse
 *                                moves off of an element.
 *                                if `false` is passed instead, the previously
 *                                firing function will no longer fire.
 * @chainable
 * @example
 * <div class='norender'><code>
 * var cnv;
 * var d;
 * function setup() {
 *   cnv = createCanvas(100, 100);
 *   cnv.mouseOut(changeGray);
 *   d = 10;
 * }
 *
 * function draw() {
 *   ellipse(width / 2, height / 2, d, d);
 * }
 *
 * function changeGray() {
 *   d = d + 10;
 *   if (d > 100) {
 *     d = 0;
 *   }
 * }
 * </code></div>
 *
 * @alt
 * no display.
 *
 */
p5.Element.prototype.mouseOut = function(fxn) {
  adjustListener('mouseout', fxn, this);
  return this;
};

/**
 * The .touchStarted() function is called once after every time a touch is
 * registered. This can be used to attach element specific event listeners.
 *
 * @method touchStarted
 * @param  {Function|Boolean} fxn function to be fired when a touch
 *                                starts over the element.
 *                                if `false` is passed instead, the previously
 *                                firing function will no longer fire.
 * @chainable
 * @example
 * <div class='norender'><code>
 * var cnv;
 * var d;
 * var g;
 * function setup() {
 *   cnv = createCanvas(100, 100);
 *   cnv.touchStarted(changeGray); // attach listener for
 *   // canvas click only
 *   d = 10;
 *   g = 100;
 * }
 *
 * function draw() {
 *   background(g);
 *   ellipse(width / 2, height / 2, d, d);
 * }
 *
 * // this function fires with any touch anywhere
 * function touchStarted() {
 *   d = d + 10;
 * }
 *
 * // this function fires only when cnv is clicked
 * function changeGray() {
 *   g = random(0, 255);
 * }
 * </code></div>
 *
 * @alt
 * no display.
 *
 */
p5.Element.prototype.touchStarted = function(fxn) {
  adjustListener('touchstart', fxn, this);
  adjustListener('mousedown', fxn, this);
  return this;
};

/**
 * The .touchMoved() function is called once after every time a touch move is
 * registered. This can be used to attach element specific event listeners.
 *
 * @method touchMoved
 * @param  {Function|Boolean} fxn function to be fired when a touch moves over
 *                                the element.
 *                                if `false` is passed instead, the previously
 *                                firing function will no longer fire.
 * @chainable
 * @example
 * <div class='norender'><code>
 * var cnv;
 * var g;
 * function setup() {
 *   cnv = createCanvas(100, 100);
 *   cnv.touchMoved(changeGray); // attach listener for
 *   // canvas click only
 *   g = 100;
 * }
 *
 * function draw() {
 *   background(g);
 * }
 *
 * // this function fires only when cnv is clicked
 * function changeGray() {
 *   g = random(0, 255);
 * }
 * </code></div>
 *
 * @alt
 * no display.
 *
 */
p5.Element.prototype.touchMoved = function(fxn) {
  adjustListener('touchmove', fxn, this);
  adjustListener('mousemove', fxn, this);
  return this;
};

/**
 * The .touchEnded() function is called once after every time a touch is
 * registered. This can be used to attach element specific event listeners.
 *
 * @method touchEnded
 * @param  {Function|Boolean} fxn function to be fired when a touch ends
 *                                over the element.
 *                                if `false` is passed instead, the previously
 *                                firing function will no longer fire.
 * @chainable
 * @example
 * <div class='norender'><code>
 * var cnv;
 * var d;
 * var g;
 * function setup() {
 *   cnv = createCanvas(100, 100);
 *   cnv.touchEnded(changeGray); // attach listener for
 *   // canvas click only
 *   d = 10;
 *   g = 100;
 * }
 *
 * function draw() {
 *   background(g);
 *   ellipse(width / 2, height / 2, d, d);
 * }
 *
 * // this function fires with any touch anywhere
 * function touchEnded() {
 *   d = d + 10;
 * }
 *
 * // this function fires only when cnv is clicked
 * function changeGray() {
 *   g = random(0, 255);
 * }
 * </code></div>
 *
 *
 * @alt
 * no display.
 *
 */
p5.Element.prototype.touchEnded = function(fxn) {
  adjustListener('touchend', fxn, this);
  adjustListener('mouseup', fxn, this);
  return this;
};

/**
 * The .dragOver() function is called once after every time a
 * file is dragged over the element. This can be used to attach an
 * element specific event listener.
 *
 * @method dragOver
 * @param  {Function|Boolean} fxn function to be fired when a file is
 *                                dragged over the element.
 *                                if `false` is passed instead, the previously
 *                                firing function will no longer fire.
 * @chainable
 * @example
 * <div><code>
 * // To test this sketch, simply drag a
 * // file over the canvas
 * function setup() {
 *   var c = createCanvas(100, 100);
 *   background(200);
 *   textAlign(CENTER);
 *   text('Drag file', width / 2, height / 2);
 *   c.dragOver(dragOverCallback);
 * }
 *
 * // This function will be called whenever
 * // a file is dragged over the canvas
 * function dragOverCallback() {
 *   background(240);
 *   text('Dragged over', width / 2, height / 2);
 * }
 * </code></div>
 * @alt
 * nothing displayed
 */
p5.Element.prototype.dragOver = function(fxn) {
  adjustListener('dragover', fxn, this);
  return this;
};

/**
 * The .dragLeave() function is called once after every time a
 * dragged file leaves the element area. This can be used to attach an
 * element specific event listener.
 *
 * @method dragLeave
 * @param  {Function|Boolean} fxn function to be fired when a file is
 *                                dragged off the element.
 *                                if `false` is passed instead, the previously
 *                                firing function will no longer fire.
 * @chainable
 * @example
 * <div><code>
 * // To test this sketch, simply drag a file
 * // over and then out of the canvas area
 * function setup() {
 *   var c = createCanvas(100, 100);
 *   background(200);
 *   textAlign(CENTER);
 *   text('Drag file', width / 2, height / 2);
 *   c.dragLeave(dragLeaveCallback);
 * }
 *
 * // This function will be called whenever
 * // a file is dragged out of the canvas
 * function dragLeaveCallback() {
 *   background(240);
 *   text('Dragged off', width / 2, height / 2);
 * }
 * </code></div>
 * @alt
 * nothing displayed
 */
p5.Element.prototype.dragLeave = function(fxn) {
  adjustListener('dragleave', fxn, this);
  return this;
};

/**
 * The .drop() function is called for each file dropped on the element.
 * It requires a callback that is passed a p5.File object.  You can
 * optionally pass two callbacks, the first one (required) is triggered
 * for each file dropped when the file is loaded.  The second (optional)
 * is triggered just once when a file (or files) are dropped.
 *
 * @method drop
 * @param  {Function} callback  callback triggered when files are dropped.
 * @param  {Function} [fxn]       callback to receive loaded file.
 * @chainable
 * @example
 * <div><code>
 * function setup() {
 *   var c = createCanvas(100, 100);
 *   background(200);
 *   textAlign(CENTER);
 *   text('drop image', width / 2, height / 2);
 *   c.drop(gotFile);
 * }
 *
 * function gotFile(file) {
 *   var img = createImg(file.data).hide();
 *   // Draw the image onto the canvas
 *   image(img, 0, 0, width, height);
 * }
 * </code></div>
 *
 * @alt
 * Canvas turns into whatever image is dragged/dropped onto it.
 *
 */
p5.Element.prototype.drop = function(callback, fxn) {
  // Make a file loader callback and trigger user's callback
  function makeLoader(theFile) {
    // Making a p5.File object
    var p5file = new p5.File(theFile);
    return function(e) {
      p5file.data = e.target.result;
      callback(p5file);
    };
  }

  // Is the file stuff supported?
  if (window.File && window.FileReader && window.FileList && window.Blob) {
    // If you want to be able to drop you've got to turn off
    // a lot of default behavior
    attachListener(
      'dragover',
      function(evt) {
        evt.stopPropagation();
        evt.preventDefault();
      },
      this
    );

    // If this is a drag area we need to turn off the default behavior
    attachListener(
      'dragleave',
      function(evt) {
        evt.stopPropagation();
        evt.preventDefault();
      },
      this
    );

    // If just one argument it's the callback for the files
    if (typeof fxn !== 'undefined') {
      attachListener('drop', fxn, this);
    }

    // Deal with the files
    attachListener(
      'drop',
      function(evt) {
        evt.stopPropagation();
        evt.preventDefault();

        // A FileList
        var files = evt.dataTransfer.files;

        // Load each one and trigger the callback
        for (var i = 0; i < files.length; i++) {
          var f = files[i];
          var reader = new FileReader();
          reader.onload = makeLoader(f);

          // Text or data?
          // This should likely be improved
          if (f.type.indexOf('text') > -1) {
            reader.readAsText(f);
          } else {
            reader.readAsDataURL(f);
          }
        }
      },
      this
    );
  } else {
    console.log('The File APIs are not fully supported in this browser.');
  }

  return this;
};

// General handler for event attaching and detaching
function adjustListener(ev, fxn, ctx) {
  if (fxn === false) {
    detachListener(ev, ctx);
  } else {
    attachListener(ev, fxn, ctx);
  }
  return this;
}

function attachListener(ev, fxn, ctx) {
  // LM removing, not sure why we had this?
  // var _this = ctx;
  // var f = function (e) { fxn(e, _this); };

  // detach the old listener if there was one
  if (ctx._events[ev]) {
    detachListener(ev, ctx);
  }
  var f = fxn.bind(ctx);
  ctx.elt.addEventListener(ev, f, false);
  ctx._events[ev] = f;
}

function detachListener(ev, ctx) {
  var f = ctx._events[ev];
  ctx.elt.removeEventListener(ev, f, false);
  ctx._events[ev] = null;
}

/**
 * Helper fxn for sharing pixel methods
 *
 */
p5.Element.prototype._setProperty = function(prop, value) {
  this[prop] = value;
};

module.exports = p5.Element;

},{"./core":22}],28:[function(_dereq_,module,exports){
/**
 * @module Rendering
 * @submodule Rendering
 * @for p5
 */

'use strict';

var p5 = _dereq_('./core');
var constants = _dereq_('./constants');

/**
 * Thin wrapper around a renderer, to be used for creating a
 * graphics buffer object. Use this class if you need
 * to draw into an off-screen graphics buffer. The two parameters define the
 * width and height in pixels. The fields and methods for this class are
 * extensive, but mirror the normal drawing API for p5.
 *
 * @class p5.Graphics
 * @constructor
 * @extends p5.Element
 * @param {Number} w            width
 * @param {Number} h            height
 * @param {Constant} renderer   the renderer to use, either P2D or WEBGL
 * @param {p5} [pInst]          pointer to p5 instance
 */
p5.Graphics = function(w, h, renderer, pInst) {
  var r = renderer || constants.P2D;

  this.canvas = document.createElement('canvas');
  var node = pInst._userNode || document.body;
  node.appendChild(this.canvas);

  p5.Element.call(this, this.canvas, pInst, false);

  // bind methods and props of p5 to the new object
  for (var p in p5.prototype) {
    if (!this[p]) {
      if (typeof p5.prototype[p] === 'function') {
        this[p] = p5.prototype[p].bind(this);
      } else {
        this[p] = p5.prototype[p];
      }
    }
  }

  p5.prototype._initializeInstanceVariables.apply(this);
  this.width = w;
  this.height = h;
  this._pixelDensity = pInst._pixelDensity;

  if (r === constants.WEBGL) {
    this._renderer = new p5.RendererGL(this.canvas, this, false);
  } else {
    this._renderer = new p5.Renderer2D(this.canvas, this, false);
  }
  pInst._elements.push(this);

  this._renderer.resize(w, h);
  this._renderer._applyDefaults();

  this.name = 'p5.Graphics'; // for friendly debugger system
  return this;
};

p5.Graphics.prototype = Object.create(p5.Element.prototype);

/**
 * @method remove
 */
p5.Graphics.prototype.remove = function() {
  if (this.elt.parentNode) {
    this.elt.parentNode.removeChild(this.elt);
  }
  for (var elt_ev in this._events) {
    this.elt.removeEventListener(elt_ev, this._events[elt_ev]);
  }
};

module.exports = p5.Graphics;

},{"./constants":21,"./core":22}],29:[function(_dereq_,module,exports){
/**
 * @module Rendering
 * @submodule Rendering
 * @for p5
 */

'use strict';

var p5 = _dereq_('./core');
var constants = _dereq_('../core/constants');

/**
 * Main graphics and rendering context, as well as the base API
 * implementation for p5.js "core". To be used as the superclass for
 * Renderer2D and Renderer3D classes, respecitvely.
 *
 * @class p5.Renderer
 * @constructor
 * @extends p5.Element
 * @param {String} elt DOM node that is wrapped
 * @param {p5} [pInst] pointer to p5 instance
 * @param {Boolean} [isMainCanvas] whether we're using it as main canvas
 */
p5.Renderer = function(elt, pInst, isMainCanvas) {
  p5.Element.call(this, elt, pInst);
  this.name = 'p5.Renderer'; // for friendly debugger system
  this.canvas = elt;
  this._pInst = pInst;
  if (isMainCanvas) {
    this._isMainCanvas = true;
    // for pixel method sharing with pimage
    this._pInst._setProperty('_curElement', this);
    this._pInst._setProperty('canvas', this.canvas);
    this._pInst._setProperty('width', this.width);
    this._pInst._setProperty('height', this.height);
  } else {
    // hide if offscreen buffer by default
    this.canvas.style.display = 'none';
    this._styles = []; // non-main elt styles stored in p5.Renderer
  }

  this._textSize = 12;
  this._textLeading = 15;
  this._textFont = 'sans-serif';
  this._textStyle = constants.NORMAL;
  this._textAscent = null;
  this._textDescent = null;

  this._rectMode = constants.CORNER;
  this._ellipseMode = constants.CENTER;
  this._curveTightness = 0;
  this._imageMode = constants.CORNER;

  this._tint = null;
  this._doStroke = true;
  this._doFill = true;
  this._strokeSet = false;
  this._fillSet = false;
};

p5.Renderer.prototype = Object.create(p5.Element.prototype);

/**
 * Resize our canvas element.
 */
p5.Renderer.prototype.resize = function(w, h) {
  this.width = w;
  this.height = h;
  this.elt.width = w * this._pInst._pixelDensity;
  this.elt.height = h * this._pInst._pixelDensity;
  this.elt.style.width = w + 'px';
  this.elt.style.height = h + 'px';
  if (this._isMainCanvas) {
    this._pInst._setProperty('width', this.width);
    this._pInst._setProperty('height', this.height);
  }
};

p5.Renderer.prototype.textLeading = function(l) {
  if (typeof l === 'number') {
    this._setProperty('_textLeading', l);
    return this;
  }

  return this._textLeading;
};

p5.Renderer.prototype.textSize = function(s) {
  if (typeof s === 'number') {
    this._setProperty('_textSize', s);
    this._setProperty('_textLeading', s * constants._DEFAULT_LEADMULT);
    return this._applyTextProperties();
  }

  return this._textSize;
};

p5.Renderer.prototype.textStyle = function(s) {
  if (s) {
    if (
      s === constants.NORMAL ||
      s === constants.ITALIC ||
      s === constants.BOLD
    ) {
      this._setProperty('_textStyle', s);
    }

    return this._applyTextProperties();
  }

  return this._textStyle;
};

p5.Renderer.prototype.textAscent = function() {
  if (this._textAscent === null) {
    this._updateTextMetrics();
  }
  return this._textAscent;
};

p5.Renderer.prototype.textDescent = function() {
  if (this._textDescent === null) {
    this._updateTextMetrics();
  }
  return this._textDescent;
};

p5.Renderer.prototype._applyDefaults = function() {
  return this;
};

/**
 * Helper fxn to check font type (system or otf)
 */
p5.Renderer.prototype._isOpenType = function(f) {
  f = f || this._textFont;
  return typeof f === 'object' && f.font && f.font.supported;
};

p5.Renderer.prototype._updateTextMetrics = function() {
  if (this._isOpenType()) {
    this._setProperty('_textAscent', this._textFont._textAscent());
    this._setProperty('_textDescent', this._textFont._textDescent());
    return this;
  }

  // Adapted from http://stackoverflow.com/a/25355178
  var text = document.createElement('span');
  text.style.fontFamily = this._textFont;
  text.style.fontSize = this._textSize + 'px';
  text.innerHTML = 'ABCjgq|';

  var block = document.createElement('div');
  block.style.display = 'inline-block';
  block.style.width = '1px';
  block.style.height = '0px';

  var container = document.createElement('div');
  container.appendChild(text);
  container.appendChild(block);

  container.style.height = '0px';
  container.style.overflow = 'hidden';
  document.body.appendChild(container);

  block.style.verticalAlign = 'baseline';
  var blockOffset = calculateOffset(block);
  var textOffset = calculateOffset(text);
  var ascent = blockOffset[1] - textOffset[1];

  block.style.verticalAlign = 'bottom';
  blockOffset = calculateOffset(block);
  textOffset = calculateOffset(text);
  var height = blockOffset[1] - textOffset[1];
  var descent = height - ascent;

  document.body.removeChild(container);

  this._setProperty('_textAscent', ascent);
  this._setProperty('_textDescent', descent);

  return this;
};

/**
 * Helper fxn to measure ascent and descent.
 * Adapted from http://stackoverflow.com/a/25355178
 */
function calculateOffset(object) {
  var currentLeft = 0,
    currentTop = 0;
  if (object.offsetParent) {
    do {
      currentLeft += object.offsetLeft;
      currentTop += object.offsetTop;
    } while ((object = object.offsetParent));
  } else {
    currentLeft += object.offsetLeft;
    currentTop += object.offsetTop;
  }
  return [currentLeft, currentTop];
}

module.exports = p5.Renderer;

},{"../core/constants":21,"./core":22}],30:[function(_dereq_,module,exports){
'use strict';

var p5 = _dereq_('./core');
var canvas = _dereq_('./canvas');
var constants = _dereq_('./constants');
var filters = _dereq_('../image/filters');

_dereq_('./p5.Renderer');

/**
 * p5.Renderer2D
 * The 2D graphics canvas renderer class.
 * extends p5.Renderer
 */
var styleEmpty = 'rgba(0,0,0,0)';
// var alphaThreshold = 0.00125; // minimum visible

p5.Renderer2D = function(elt, pInst, isMainCanvas) {
  p5.Renderer.call(this, elt, pInst, isMainCanvas);
  this.name = 'p5.Renderer2D'; // for friendly debugger system
  this.drawingContext = this.canvas.getContext('2d');
  this._pInst._setProperty('drawingContext', this.drawingContext);
  return this;
};

p5.Renderer2D.prototype = Object.create(p5.Renderer.prototype);

p5.Renderer2D.prototype._applyDefaults = function() {
  this._cachedFillStyle = this._cachedStrokeStyle = undefined;
  this._setFill(constants._DEFAULT_FILL);
  this._setStroke(constants._DEFAULT_STROKE);
  this.drawingContext.lineCap = constants.ROUND;
  this.drawingContext.font = 'normal 12px sans-serif';
};

p5.Renderer2D.prototype.resize = function(w, h) {
  p5.Renderer.prototype.resize.call(this, w, h);
  this.drawingContext.scale(
    this._pInst._pixelDensity,
    this._pInst._pixelDensity
  );
};

//////////////////////////////////////////////
// COLOR | Setting
//////////////////////////////////////////////

p5.Renderer2D.prototype.background = function() {
  this.drawingContext.save();
  this.drawingContext.setTransform(1, 0, 0, 1, 0, 0);
  this.drawingContext.scale(
    this._pInst._pixelDensity,
    this._pInst._pixelDensity
  );

  if (arguments[0] instanceof p5.Image) {
    this._pInst.image(arguments[0], 0, 0, this.width, this.height);
  } else {
    var curFill = this._getFill();
    // create background rect
    var color = this._pInst.color.apply(this._pInst, arguments);
    var newFill = color.toString();
    this._setFill(newFill);
    this.drawingContext.fillRect(0, 0, this.width, this.height);
    // reset fill
    this._setFill(curFill);
  }
  this.drawingContext.restore();
};

p5.Renderer2D.prototype.clear = function() {
  this.drawingContext.clearRect(0, 0, this.width, this.height);
};

p5.Renderer2D.prototype.fill = function() {
  var color = this._pInst.color.apply(this._pInst, arguments);
  this._setFill(color.toString());
};

p5.Renderer2D.prototype.stroke = function() {
  var color = this._pInst.color.apply(this._pInst, arguments);
  this._setStroke(color.toString());
};

//////////////////////////////////////////////
// IMAGE | Loading & Displaying
//////////////////////////////////////////////

p5.Renderer2D.prototype.image = function(
  img,
  sx,
  sy,
  sWidth,
  sHeight,
  dx,
  dy,
  dWidth,
  dHeight
) {
  var cnv;
  try {
    if (this._tint) {
      if (p5.MediaElement && img instanceof p5.MediaElement) {
        img.loadPixels();
      }
      if (img.canvas) {
        cnv = this._getTintedImageCanvas(img);
      }
    }
    if (!cnv) {
      cnv = img.canvas || img.elt;
    }
    this.drawingContext.drawImage(
      cnv,
      sx,
      sy,
      sWidth,
      sHeight,
      dx,
      dy,
      dWidth,
      dHeight
    );
  } catch (e) {
    if (e.name !== 'NS_ERROR_NOT_AVAILABLE') {
      throw e;
    }
  }
};

p5.Renderer2D.prototype._getTintedImageCanvas = function(img) {
  if (!img.canvas) {
    return img;
  }
  var pixels = filters._toPixels(img.canvas);
  var tmpCanvas = document.createElement('canvas');
  tmpCanvas.width = img.canvas.width;
  tmpCanvas.height = img.canvas.height;
  var tmpCtx = tmpCanvas.getContext('2d');
  var id = tmpCtx.createImageData(img.canvas.width, img.canvas.height);
  var newPixels = id.data;
  for (var i = 0; i < pixels.length; i += 4) {
    var r = pixels[i];
    var g = pixels[i + 1];
    var b = pixels[i + 2];
    var a = pixels[i + 3];
    newPixels[i] = r * this._tint[0] / 255;
    newPixels[i + 1] = g * this._tint[1] / 255;
    newPixels[i + 2] = b * this._tint[2] / 255;
    newPixels[i + 3] = a * this._tint[3] / 255;
  }
  tmpCtx.putImageData(id, 0, 0);
  return tmpCanvas;
};

//////////////////////////////////////////////
// IMAGE | Pixels
//////////////////////////////////////////////

p5.Renderer2D.prototype.blendMode = function(mode) {
  this.drawingContext.globalCompositeOperation = mode;
};
p5.Renderer2D.prototype.blend = function() {
  var currBlend = this.drawingContext.globalCompositeOperation;
  var blendMode = arguments[arguments.length - 1];

  var copyArgs = Array.prototype.slice.call(arguments, 0, arguments.length - 1);

  this.drawingContext.globalCompositeOperation = blendMode;
  if (this._pInst) {
    this._pInst.copy.apply(this._pInst, copyArgs);
  } else {
    this.copy.apply(this, copyArgs);
  }
  this.drawingContext.globalCompositeOperation = currBlend;
};

p5.Renderer2D.prototype.copy = function() {
  var srcImage, sx, sy, sw, sh, dx, dy, dw, dh;
  if (arguments.length === 9) {
    srcImage = arguments[0];
    sx = arguments[1];
    sy = arguments[2];
    sw = arguments[3];
    sh = arguments[4];
    dx = arguments[5];
    dy = arguments[6];
    dw = arguments[7];
    dh = arguments[8];
  } else if (arguments.length === 8) {
    srcImage = this._pInst;
    sx = arguments[0];
    sy = arguments[1];
    sw = arguments[2];
    sh = arguments[3];
    dx = arguments[4];
    dy = arguments[5];
    dw = arguments[6];
    dh = arguments[7];
  } else {
    throw new Error('Signature not supported');
  }
  p5.Renderer2D._copyHelper(this, srcImage, sx, sy, sw, sh, dx, dy, dw, dh);
};

p5.Renderer2D._copyHelper = function(
  dstImage,
  srcImage,
  sx,
  sy,
  sw,
  sh,
  dx,
  dy,
  dw,
  dh
) {
  srcImage.loadPixels();
  var s = srcImage.canvas.width / srcImage.width;
  dstImage.drawingContext.drawImage(
    srcImage.canvas,
    s * sx,
    s * sy,
    s * sw,
    s * sh,
    dx,
    dy,
    dw,
    dh
  );
};

p5.Renderer2D.prototype.get = function(x, y, w, h) {
  if (
    x === undefined &&
    y === undefined &&
    w === undefined &&
    h === undefined
  ) {
    x = 0;
    y = 0;
    w = this.width;
    h = this.height;
  } else if (w === undefined && h === undefined) {
    w = 1;
    h = 1;
  }

  // if the section does not overlap the canvas
  if (x + w < 0 || y + h < 0 || x > this.width || y > this.height) {
    return [0, 0, 0, 255];
  }

  var ctx = this._pInst || this;
  ctx.loadPixels();

  var pd = ctx._pixelDensity;

  // round down to get integer numbers
  x = Math.floor(x);
  y = Math.floor(y);
  w = Math.floor(w);
  h = Math.floor(h);

  var sx = x * pd;
  var sy = y * pd;
  if (w === 1 && h === 1 && !(this instanceof p5.RendererGL)) {
    var imageData = this.drawingContext.getImageData(sx, sy, 1, 1).data;
    //imageData = [0,0,0,0];
    return [imageData[0], imageData[1], imageData[2], imageData[3]];
  } else {
    //auto constrain the width and height to
    //dimensions of the source image
    var dw = Math.min(w, ctx.width);
    var dh = Math.min(h, ctx.height);
    var sw = dw * pd;
    var sh = dh * pd;

    var region = new p5.Image(dw, dh);
    region.canvas
      .getContext('2d')
      .drawImage(this.canvas, sx, sy, sw, sh, 0, 0, dw, dh);

    return region;
  }
};

p5.Renderer2D.prototype.loadPixels = function() {
  var pd = this._pixelDensity || this._pInst._pixelDensity;
  var w = this.width * pd;
  var h = this.height * pd;
  var imageData = this.drawingContext.getImageData(0, 0, w, h);
  // @todo this should actually set pixels per object, so diff buffers can
  // have diff pixel arrays.
  if (this._pInst) {
    this._pInst._setProperty('imageData', imageData);
    this._pInst._setProperty('pixels', imageData.data);
  } else {
    // if called by p5.Image
    this._setProperty('imageData', imageData);
    this._setProperty('pixels', imageData.data);
  }
};

p5.Renderer2D.prototype.set = function(x, y, imgOrCol) {
  // round down to get integer numbers
  x = Math.floor(x);
  y = Math.floor(y);
  if (imgOrCol instanceof p5.Image) {
    this.drawingContext.save();
    this.drawingContext.setTransform(1, 0, 0, 1, 0, 0);
    this.drawingContext.scale(
      this._pInst._pixelDensity,
      this._pInst._pixelDensity
    );
    this.drawingContext.drawImage(imgOrCol.canvas, x, y);
    this.loadPixels.call(this._pInst);
    this.drawingContext.restore();
  } else {
    var ctx = this._pInst || this;
    var r = 0,
      g = 0,
      b = 0,
      a = 0;
    var idx =
      4 *
      (y * ctx._pixelDensity * (this.width * ctx._pixelDensity) +
        x * ctx._pixelDensity);
    if (!ctx.imageData) {
      ctx.loadPixels.call(ctx);
    }
    if (typeof imgOrCol === 'number') {
      if (idx < ctx.pixels.length) {
        r = imgOrCol;
        g = imgOrCol;
        b = imgOrCol;
        a = 255;
        //this.updatePixels.call(this);
      }
    } else if (imgOrCol instanceof Array) {
      if (imgOrCol.length < 4) {
        throw new Error('pixel array must be of the form [R, G, B, A]');
      }
      if (idx < ctx.pixels.length) {
        r = imgOrCol[0];
        g = imgOrCol[1];
        b = imgOrCol[2];
        a = imgOrCol[3];
        //this.updatePixels.call(this);
      }
    } else if (imgOrCol instanceof p5.Color) {
      if (idx < ctx.pixels.length) {
        r = imgOrCol.levels[0];
        g = imgOrCol.levels[1];
        b = imgOrCol.levels[2];
        a = imgOrCol.levels[3];
        //this.updatePixels.call(this);
      }
    }
    // loop over pixelDensity * pixelDensity
    for (var i = 0; i < ctx._pixelDensity; i++) {
      for (var j = 0; j < ctx._pixelDensity; j++) {
        // loop over
        idx =
          4 *
          ((y * ctx._pixelDensity + j) * this.width * ctx._pixelDensity +
            (x * ctx._pixelDensity + i));
        ctx.pixels[idx] = r;
        ctx.pixels[idx + 1] = g;
        ctx.pixels[idx + 2] = b;
        ctx.pixels[idx + 3] = a;
      }
    }
  }
};

p5.Renderer2D.prototype.updatePixels = function(x, y, w, h) {
  var pd = this._pixelDensity || this._pInst._pixelDensity;
  if (
    x === undefined &&
    y === undefined &&
    w === undefined &&
    h === undefined
  ) {
    x = 0;
    y = 0;
    w = this.width;
    h = this.height;
  }
  w *= pd;
  h *= pd;

  if (this._pInst) {
    this.drawingContext.putImageData(this._pInst.imageData, x, y, 0, 0, w, h);
  } else {
    this.drawingContext.putImageData(this.imageData, x, y, 0, 0, w, h);
  }
};

//////////////////////////////////////////////
// SHAPE | 2D Primitives
//////////////////////////////////////////////

/**
 * Generate a cubic Bezier representing an arc on the unit circle of total
 * angle `size` radians, beginning `start` radians above the x-axis. Up to
 * four of these curves are combined to make a full arc.
 *
 * See www.joecridge.me/bezier.pdf for an explanation of the method.
 */
p5.Renderer2D.prototype._acuteArcToBezier = function _acuteArcToBezier(
  start,
  size
) {
  // Evauate constants.
  var alpha = size / 2.0,
    cos_alpha = Math.cos(alpha),
    sin_alpha = Math.sin(alpha),
    cot_alpha = 1.0 / Math.tan(alpha),
    phi = start + alpha, // This is how far the arc needs to be rotated.
    cos_phi = Math.cos(phi),
    sin_phi = Math.sin(phi),
    lambda = (4.0 - cos_alpha) / 3.0,
    mu = sin_alpha + (cos_alpha - lambda) * cot_alpha;

  // Return rotated waypoints.
  return {
    ax: Math.cos(start),
    ay: Math.sin(start),
    bx: lambda * cos_phi + mu * sin_phi,
    by: lambda * sin_phi - mu * cos_phi,
    cx: lambda * cos_phi - mu * sin_phi,
    cy: lambda * sin_phi + mu * cos_phi,
    dx: Math.cos(start + size),
    dy: Math.sin(start + size)
  };
};

p5.Renderer2D.prototype.arc = function(x, y, w, h, start, stop, mode) {
  var ctx = this.drawingContext;
  var vals = canvas.arcModeAdjust(x, y, w, h, this._ellipseMode);
  var rx = vals.w / 2.0;
  var ry = vals.h / 2.0;
  var epsilon = 0.00001; // Smallest visible angle on displays up to 4K.
  var arcToDraw = 0;
  var curves = [];

  // Create curves
  while (stop - start > epsilon) {
    arcToDraw = Math.min(stop - start, constants.HALF_PI);
    curves.push(this._acuteArcToBezier(start, arcToDraw));
    start += arcToDraw;
  }

  // Fill curves
  if (this._doFill) {
    ctx.beginPath();
    curves.forEach(function(curve, index) {
      if (index === 0) {
        ctx.moveTo(vals.x + curve.ax * rx, vals.y + curve.ay * ry);
      }
      // prettier-ignore
      ctx.bezierCurveTo(vals.x + curve.bx * rx, vals.y + curve.by * ry,
                          vals.x + curve.cx * rx, vals.y + curve.cy * ry,
                          vals.x + curve.dx * rx, vals.y + curve.dy * ry);
    });
    if (mode === constants.PIE || mode == null) {
      ctx.lineTo(vals.x, vals.y);
    }
    ctx.closePath();
    ctx.fill();
  }

  // Stroke curves
  if (this._doStroke) {
    ctx.beginPath();
    curves.forEach(function(curve, index) {
      if (index === 0) {
        ctx.moveTo(vals.x + curve.ax * rx, vals.y + curve.ay * ry);
      }
      // prettier-ignore
      ctx.bezierCurveTo(vals.x + curve.bx * rx, vals.y + curve.by * ry,
                          vals.x + curve.cx * rx, vals.y + curve.cy * ry,
                          vals.x + curve.dx * rx, vals.y + curve.dy * ry);
    });
    if (mode === constants.PIE) {
      ctx.lineTo(vals.x, vals.y);
      ctx.closePath();
    } else if (mode === constants.CHORD) {
      ctx.closePath();
    }
    ctx.stroke();
  }
  return this;
};

p5.Renderer2D.prototype.ellipse = function(args) {
  var ctx = this.drawingContext;
  var doFill = this._doFill,
    doStroke = this._doStroke;
  var x = args[0],
    y = args[1],
    w = args[2],
    h = args[3];
  if (doFill && !doStroke) {
    if (this._getFill() === styleEmpty) {
      return this;
    }
  } else if (!doFill && doStroke) {
    if (this._getStroke() === styleEmpty) {
      return this;
    }
  }
  var kappa = 0.5522847498,
    ox = w / 2 * kappa, // control point offset horizontal
    oy = h / 2 * kappa, // control point offset vertical
    xe = x + w, // x-end
    ye = y + h, // y-end
    xm = x + w / 2, // x-middle
    ym = y + h / 2; // y-middle
  ctx.beginPath();
  ctx.moveTo(x, ym);
  ctx.bezierCurveTo(x, ym - oy, xm - ox, y, xm, y);
  ctx.bezierCurveTo(xm + ox, y, xe, ym - oy, xe, ym);
  ctx.bezierCurveTo(xe, ym + oy, xm + ox, ye, xm, ye);
  ctx.bezierCurveTo(xm - ox, ye, x, ym + oy, x, ym);
  ctx.closePath();
  if (doFill) {
    ctx.fill();
  }
  if (doStroke) {
    ctx.stroke();
  }
};

p5.Renderer2D.prototype.line = function(x1, y1, x2, y2) {
  var ctx = this.drawingContext;
  if (!this._doStroke) {
    return this;
  } else if (this._getStroke() === styleEmpty) {
    return this;
  }
  // Translate the line by (0.5, 0.5) to draw it crisp
  if (ctx.lineWidth % 2 === 1) {
    ctx.translate(0.5, 0.5);
  }
  ctx.beginPath();
  ctx.moveTo(x1, y1);
  ctx.lineTo(x2, y2);
  ctx.stroke();
  if (ctx.lineWidth % 2 === 1) {
    ctx.translate(-0.5, -0.5);
  }
  return this;
};

p5.Renderer2D.prototype.point = function(x, y) {
  var ctx = this.drawingContext;
  if (!this._doStroke) {
    return this;
  } else if (this._getStroke() === styleEmpty) {
    return this;
  }
  var s = this._getStroke();
  var f = this._getFill();
  x = Math.round(x);
  y = Math.round(y);
  // swapping fill color to stroke and back after for correct point rendering
  this._setFill(s);
  if (ctx.lineWidth > 1) {
    ctx.beginPath();
    ctx.arc(x, y, ctx.lineWidth / 2, 0, constants.TWO_PI, false);
    ctx.fill();
  } else {
    ctx.fillRect(x, y, 1, 1);
  }
  this._setFill(f);
};

p5.Renderer2D.prototype.quad = function(x1, y1, x2, y2, x3, y3, x4, y4) {
  var ctx = this.drawingContext;
  var doFill = this._doFill,
    doStroke = this._doStroke;
  if (doFill && !doStroke) {
    if (this._getFill() === styleEmpty) {
      return this;
    }
  } else if (!doFill && doStroke) {
    if (this._getStroke() === styleEmpty) {
      return this;
    }
  }
  ctx.beginPath();
  ctx.moveTo(x1, y1);
  ctx.lineTo(x2, y2);
  ctx.lineTo(x3, y3);
  ctx.lineTo(x4, y4);
  ctx.closePath();
  if (doFill) {
    ctx.fill();
  }
  if (doStroke) {
    ctx.stroke();
  }
  return this;
};

p5.Renderer2D.prototype.rect = function(args) {
  var x = args[0],
    y = args[1],
    w = args[2],
    h = args[3],
    tl = args[4],
    tr = args[5],
    br = args[6],
    bl = args[7];
  var ctx = this.drawingContext;
  var doFill = this._doFill,
    doStroke = this._doStroke;
  if (doFill && !doStroke) {
    if (this._getFill() === styleEmpty) {
      return this;
    }
  } else if (!doFill && doStroke) {
    if (this._getStroke() === styleEmpty) {
      return this;
    }
  }
  // Translate the line by (0.5, 0.5) to draw a crisp rectangle border
  if (this._doStroke && ctx.lineWidth % 2 === 1) {
    ctx.translate(0.5, 0.5);
  }
  ctx.beginPath();

  if (typeof tl === 'undefined') {
    // No rounded corners
    ctx.rect(x, y, w, h);
  } else {
    // At least one rounded corner
    // Set defaults when not specified
    if (typeof tr === 'undefined') {
      tr = tl;
    }
    if (typeof br === 'undefined') {
      br = tr;
    }
    if (typeof bl === 'undefined') {
      bl = br;
    }

    var hw = w / 2;
    var hh = h / 2;

    // Clip radii
    if (w < 2 * tl) {
      tl = hw;
    }
    if (h < 2 * tl) {
      tl = hh;
    }
    if (w < 2 * tr) {
      tr = hw;
    }
    if (h < 2 * tr) {
      tr = hh;
    }
    if (w < 2 * br) {
      br = hw;
    }
    if (h < 2 * br) {
      br = hh;
    }
    if (w < 2 * bl) {
      bl = hw;
    }
    if (h < 2 * bl) {
      bl = hh;
    }

    // Draw shape
    ctx.beginPath();
    ctx.moveTo(x + tl, y);
    ctx.arcTo(x + w, y, x + w, y + h, tr);
    ctx.arcTo(x + w, y + h, x, y + h, br);
    ctx.arcTo(x, y + h, x, y, bl);
    ctx.arcTo(x, y, x + w, y, tl);
    ctx.closePath();
  }
  if (this._doFill) {
    ctx.fill();
  }
  if (this._doStroke) {
    ctx.stroke();
  }
  if (this._doStroke && ctx.lineWidth % 2 === 1) {
    ctx.translate(-0.5, -0.5);
  }
  return this;
};

p5.Renderer2D.prototype.triangle = function(args) {
  var ctx = this.drawingContext;
  var doFill = this._doFill,
    doStroke = this._doStroke;
  var x1 = args[0],
    y1 = args[1];
  var x2 = args[2],
    y2 = args[3];
  var x3 = args[4],
    y3 = args[5];
  if (doFill && !doStroke) {
    if (this._getFill() === styleEmpty) {
      return this;
    }
  } else if (!doFill && doStroke) {
    if (this._getStroke() === styleEmpty) {
      return this;
    }
  }
  ctx.beginPath();
  ctx.moveTo(x1, y1);
  ctx.lineTo(x2, y2);
  ctx.lineTo(x3, y3);
  ctx.closePath();
  if (doFill) {
    ctx.fill();
  }
  if (doStroke) {
    ctx.stroke();
  }
};

p5.Renderer2D.prototype.endShape = function(
  mode,
  vertices,
  isCurve,
  isBezier,
  isQuadratic,
  isContour,
  shapeKind
) {
  if (vertices.length === 0) {
    return this;
  }
  if (!this._doStroke && !this._doFill) {
    return this;
  }
  var closeShape = mode === constants.CLOSE;
  var v;
  if (closeShape && !isContour) {
    vertices.push(vertices[0]);
  }
  var i, j;
  var numVerts = vertices.length;
  if (isCurve && (shapeKind === constants.POLYGON || shapeKind === null)) {
    if (numVerts > 3) {
      var b = [],
        s = 1 - this._curveTightness;
      this.drawingContext.beginPath();
      this.drawingContext.moveTo(vertices[1][0], vertices[1][1]);
      for (i = 1; i + 2 < numVerts; i++) {
        v = vertices[i];
        b[0] = [v[0], v[1]];
        b[1] = [
          v[0] + (s * vertices[i + 1][0] - s * vertices[i - 1][0]) / 6,
          v[1] + (s * vertices[i + 1][1] - s * vertices[i - 1][1]) / 6
        ];
        b[2] = [
          vertices[i + 1][0] +
            (s * vertices[i][0] - s * vertices[i + 2][0]) / 6,
          vertices[i + 1][1] + (s * vertices[i][1] - s * vertices[i + 2][1]) / 6
        ];
        b[3] = [vertices[i + 1][0], vertices[i + 1][1]];
        this.drawingContext.bezierCurveTo(
          b[1][0],
          b[1][1],
          b[2][0],
          b[2][1],
          b[3][0],
          b[3][1]
        );
      }
      if (closeShape) {
        this.drawingContext.lineTo(vertices[i + 1][0], vertices[i + 1][1]);
      }
      this._doFillStrokeClose();
    }
  } else if (
    isBezier &&
    (shapeKind === constants.POLYGON || shapeKind === null)
  ) {
    this.drawingContext.beginPath();
    for (i = 0; i < numVerts; i++) {
      if (vertices[i].isVert) {
        if (vertices[i].moveTo) {
          this.drawingContext.moveTo(vertices[i][0], vertices[i][1]);
        } else {
          this.drawingContext.lineTo(vertices[i][0], vertices[i][1]);
        }
      } else {
        this.drawingContext.bezierCurveTo(
          vertices[i][0],
          vertices[i][1],
          vertices[i][2],
          vertices[i][3],
          vertices[i][4],
          vertices[i][5]
        );
      }
    }
    this._doFillStrokeClose();
  } else if (
    isQuadratic &&
    (shapeKind === constants.POLYGON || shapeKind === null)
  ) {
    this.drawingContext.beginPath();
    for (i = 0; i < numVerts; i++) {
      if (vertices[i].isVert) {
        if (vertices[i].moveTo) {
          this.drawingContext.moveTo([0], vertices[i][1]);
        } else {
          this.drawingContext.lineTo(vertices[i][0], vertices[i][1]);
        }
      } else {
        this.drawingContext.quadraticCurveTo(
          vertices[i][0],
          vertices[i][1],
          vertices[i][2],
          vertices[i][3]
        );
      }
    }
    this._doFillStrokeClose();
  } else {
    if (shapeKind === constants.POINTS) {
      for (i = 0; i < numVerts; i++) {
        v = vertices[i];
        if (this._doStroke) {
          this._pInst.stroke(v[6]);
        }
        this._pInst.point(v[0], v[1]);
      }
    } else if (shapeKind === constants.LINES) {
      for (i = 0; i + 1 < numVerts; i += 2) {
        v = vertices[i];
        if (this._doStroke) {
          this._pInst.stroke(vertices[i + 1][6]);
        }
        this._pInst.line(v[0], v[1], vertices[i + 1][0], vertices[i + 1][1]);
      }
    } else if (shapeKind === constants.TRIANGLES) {
      for (i = 0; i + 2 < numVerts; i += 3) {
        v = vertices[i];
        this.drawingContext.beginPath();
        this.drawingContext.moveTo(v[0], v[1]);
        this.drawingContext.lineTo(vertices[i + 1][0], vertices[i + 1][1]);
        this.drawingContext.lineTo(vertices[i + 2][0], vertices[i + 2][1]);
        this.drawingContext.lineTo(v[0], v[1]);
        if (this._doFill) {
          this._pInst.fill(vertices[i + 2][5]);
          this.drawingContext.fill();
        }
        if (this._doStroke) {
          this._pInst.stroke(vertices[i + 2][6]);
          this.drawingContext.stroke();
        }
        this.drawingContext.closePath();
      }
    } else if (shapeKind === constants.TRIANGLE_STRIP) {
      for (i = 0; i + 1 < numVerts; i++) {
        v = vertices[i];
        this.drawingContext.beginPath();
        this.drawingContext.moveTo(vertices[i + 1][0], vertices[i + 1][1]);
        this.drawingContext.lineTo(v[0], v[1]);
        if (this._doStroke) {
          this._pInst.stroke(vertices[i + 1][6]);
        }
        if (this._doFill) {
          this._pInst.fill(vertices[i + 1][5]);
        }
        if (i + 2 < numVerts) {
          this.drawingContext.lineTo(vertices[i + 2][0], vertices[i + 2][1]);
          if (this._doStroke) {
            this._pInst.stroke(vertices[i + 2][6]);
          }
          if (this._doFill) {
            this._pInst.fill(vertices[i + 2][5]);
          }
        }
        this._doFillStrokeClose();
      }
    } else if (shapeKind === constants.TRIANGLE_FAN) {
      if (numVerts > 2) {
        // For performance reasons, try to batch as many of the
        // fill and stroke calls as possible.
        this.drawingContext.beginPath();
        for (i = 2; i < numVerts; i++) {
          v = vertices[i];
          this.drawingContext.moveTo(vertices[0][0], vertices[0][1]);
          this.drawingContext.lineTo(vertices[i - 1][0], vertices[i - 1][1]);
          this.drawingContext.lineTo(v[0], v[1]);
          this.drawingContext.lineTo(vertices[0][0], vertices[0][1]);
          // If the next colour is going to be different, stroke / fill now
          if (i < numVerts - 1) {
            if (
              (this._doFill && v[5] !== vertices[i + 1][5]) ||
              (this._doStroke && v[6] !== vertices[i + 1][6])
            ) {
              if (this._doFill) {
                this._pInst.fill(v[5]);
                this.drawingContext.fill();
                this._pInst.fill(vertices[i + 1][5]);
              }
              if (this._doStroke) {
                this._pInst.stroke(v[6]);
                this.drawingContext.stroke();
                this._pInst.stroke(vertices[i + 1][6]);
              }
              this.drawingContext.closePath();
              this.drawingContext.beginPath(); // Begin the next one
            }
          }
        }
        this._doFillStrokeClose();
      }
    } else if (shapeKind === constants.QUADS) {
      for (i = 0; i + 3 < numVerts; i += 4) {
        v = vertices[i];
        this.drawingContext.beginPath();
        this.drawingContext.moveTo(v[0], v[1]);
        for (j = 1; j < 4; j++) {
          this.drawingContext.lineTo(vertices[i + j][0], vertices[i + j][1]);
        }
        this.drawingContext.lineTo(v[0], v[1]);
        if (this._doFill) {
          this._pInst.fill(vertices[i + 3][5]);
        }
        if (this._doStroke) {
          this._pInst.stroke(vertices[i + 3][6]);
        }
        this._doFillStrokeClose();
      }
    } else if (shapeKind === constants.QUAD_STRIP) {
      if (numVerts > 3) {
        for (i = 0; i + 1 < numVerts; i += 2) {
          v = vertices[i];
          this.drawingContext.beginPath();
          if (i + 3 < numVerts) {
            this.drawingContext.moveTo(vertices[i + 2][0], vertices[i + 2][1]);
            this.drawingContext.lineTo(v[0], v[1]);
            this.drawingContext.lineTo(vertices[i + 1][0], vertices[i + 1][1]);
            this.drawingContext.lineTo(vertices[i + 3][0], vertices[i + 3][1]);
            if (this._doFill) {
              this._pInst.fill(vertices[i + 3][5]);
            }
            if (this._doStroke) {
              this._pInst.stroke(vertices[i + 3][6]);
            }
          } else {
            this.drawingContext.moveTo(v[0], v[1]);
            this.drawingContext.lineTo(vertices[i + 1][0], vertices[i + 1][1]);
          }
          this._doFillStrokeClose();
        }
      }
    } else {
      this.drawingContext.beginPath();
      this.drawingContext.moveTo(vertices[0][0], vertices[0][1]);
      for (i = 1; i < numVerts; i++) {
        v = vertices[i];
        if (v.isVert) {
          if (v.moveTo) {
            this.drawingContext.moveTo(v[0], v[1]);
          } else {
            this.drawingContext.lineTo(v[0], v[1]);
          }
        }
      }
      this._doFillStrokeClose();
    }
  }
  isCurve = false;
  isBezier = false;
  isQuadratic = false;
  isContour = false;
  if (closeShape) {
    vertices.pop();
  }
  return this;
};
//////////////////////////////////////////////
// SHAPE | Attributes
//////////////////////////////////////////////

p5.Renderer2D.prototype.noSmooth = function() {
  if ('imageSmoothingEnabled' in this.drawingContext) {
    this.drawingContext.imageSmoothingEnabled = false;
  }
  return this;
};

p5.Renderer2D.prototype.smooth = function() {
  if ('imageSmoothingEnabled' in this.drawingContext) {
    this.drawingContext.imageSmoothingEnabled = true;
  }
  return this;
};

p5.Renderer2D.prototype.strokeCap = function(cap) {
  if (
    cap === constants.ROUND ||
    cap === constants.SQUARE ||
    cap === constants.PROJECT
  ) {
    this.drawingContext.lineCap = cap;
  }
  return this;
};

p5.Renderer2D.prototype.strokeJoin = function(join) {
  if (
    join === constants.ROUND ||
    join === constants.BEVEL ||
    join === constants.MITER
  ) {
    this.drawingContext.lineJoin = join;
  }
  return this;
};

p5.Renderer2D.prototype.strokeWeight = function(w) {
  if (typeof w === 'undefined' || w === 0) {
    // hack because lineWidth 0 doesn't work
    this.drawingContext.lineWidth = 0.0001;
  } else {
    this.drawingContext.lineWidth = w;
  }
  return this;
};

p5.Renderer2D.prototype._getFill = function() {
  if (!this._cachedFillStyle) {
    this._cachedFillStyle = this.drawingContext.fillStyle;
  }
  return this._cachedFillStyle;
};

p5.Renderer2D.prototype._setFill = function(fillStyle) {
  if (fillStyle !== this._cachedFillStyle) {
    this.drawingContext.fillStyle = fillStyle;
    this._cachedFillStyle = fillStyle;
  }
};

p5.Renderer2D.prototype._getStroke = function() {
  if (!this._cachedStrokeStyle) {
    this._cachedStrokeStyle = this.drawingContext.strokeStyle;
  }
  return this._cachedStrokeStyle;
};

p5.Renderer2D.prototype._setStroke = function(strokeStyle) {
  if (strokeStyle !== this._cachedStrokeStyle) {
    this.drawingContext.strokeStyle = strokeStyle;
    this._cachedStrokeStyle = strokeStyle;
  }
};

//////////////////////////////////////////////
// SHAPE | Curves
//////////////////////////////////////////////
p5.Renderer2D.prototype.bezier = function(x1, y1, x2, y2, x3, y3, x4, y4) {
  this._pInst.beginShape();
  this._pInst.vertex(x1, y1);
  this._pInst.bezierVertex(x2, y2, x3, y3, x4, y4);
  this._pInst.endShape();
  return this;
};

p5.Renderer2D.prototype.curve = function(x1, y1, x2, y2, x3, y3, x4, y4) {
  this._pInst.beginShape();
  this._pInst.curveVertex(x1, y1);
  this._pInst.curveVertex(x2, y2);
  this._pInst.curveVertex(x3, y3);
  this._pInst.curveVertex(x4, y4);
  this._pInst.endShape();
  return this;
};

//////////////////////////////////////////////
// SHAPE | Vertex
//////////////////////////////////////////////

p5.Renderer2D.prototype._doFillStrokeClose = function() {
  if (this._doFill) {
    this.drawingContext.fill();
  }
  if (this._doStroke) {
    this.drawingContext.stroke();
  }
  this.drawingContext.closePath();
};

//////////////////////////////////////////////
// TRANSFORM
//////////////////////////////////////////////

p5.Renderer2D.prototype.applyMatrix = function(a, b, c, d, e, f) {
  this.drawingContext.transform(a, b, c, d, e, f);
};

p5.Renderer2D.prototype.resetMatrix = function() {
  this.drawingContext.setTransform(1, 0, 0, 1, 0, 0);
  this.drawingContext.scale(
    this._pInst._pixelDensity,
    this._pInst._pixelDensity
  );
  return this;
};

p5.Renderer2D.prototype.rotate = function(r) {
  this.drawingContext.rotate(r);
};

p5.Renderer2D.prototype.scale = function(x, y) {
  this.drawingContext.scale(x, y);
  return this;
};

p5.Renderer2D.prototype.shearX = function(angle) {
  if (this._pInst._angleMode === constants.DEGREES) {
    // undoing here, because it gets redone in tan()
    angle = this._pInst.degrees(angle);
  }
  this.drawingContext.transform(1, 0, this._pInst.tan(angle), 1, 0, 0);
  return this;
};

p5.Renderer2D.prototype.shearY = function(angle) {
  if (this._pInst._angleMode === constants.DEGREES) {
    // undoing here, because it gets redone in tan()
    angle = this._pInst.degrees(angle);
  }
  this.drawingContext.transform(1, this._pInst.tan(angle), 0, 1, 0, 0);
  return this;
};

p5.Renderer2D.prototype.translate = function(x, y) {
  this.drawingContext.translate(x, y);
  return this;
};

//////////////////////////////////////////////
// TYPOGRAPHY
//
//////////////////////////////////////////////

p5.Renderer2D.prototype.text = function(str, x, y, maxWidth, maxHeight) {
  var p = this._pInst,
    cars,
    n,
    ii,
    jj,
    line,
    testLine,
    testWidth,
    words,
    totalHeight,
    baselineHacked,
    finalMaxHeight = Number.MAX_VALUE;

  // baselineHacked: (HACK)
  // A temporary fix to conform to Processing's implementation
  // of BASELINE vertical alignment in a bounding box

  if (!(this._doFill || this._doStroke)) {
    return;
  }

  if (typeof str !== 'string') {
    str = str.toString();
  }

  str = str.replace(/(\t)/g, '  ');
  cars = str.split('\n');

  if (typeof maxWidth !== 'undefined') {
    totalHeight = 0;
    for (ii = 0; ii < cars.length; ii++) {
      line = '';
      words = cars[ii].split(' ');
      for (n = 0; n < words.length; n++) {
        testLine = line + words[n] + ' ';
        testWidth = this.textWidth(testLine);
        if (testWidth > maxWidth) {
          line = words[n] + ' ';
          totalHeight += p.textLeading();
        } else {
          line = testLine;
        }
      }
    }

    if (this._rectMode === constants.CENTER) {
      x -= maxWidth / 2;
      y -= maxHeight / 2;
    }

    switch (this.drawingContext.textAlign) {
      case constants.CENTER:
        x += maxWidth / 2;
        break;
      case constants.RIGHT:
        x += maxWidth;
        break;
    }

    if (typeof maxHeight !== 'undefined') {
      switch (this.drawingContext.textBaseline) {
        case constants.BOTTOM:
          y += maxHeight - totalHeight;
          break;
        case constants._CTX_MIDDLE: // CENTER?
          y += (maxHeight - totalHeight) / 2;
          break;
        case constants.BASELINE:
          baselineHacked = true;
          this.drawingContext.textBaseline = constants.TOP;
          break;
      }

      // remember the max-allowed y-position for any line (fix to #928)
      finalMaxHeight = y + maxHeight - p.textAscent();
    }

    for (ii = 0; ii < cars.length; ii++) {
      line = '';
      words = cars[ii].split(' ');
      for (n = 0; n < words.length; n++) {
        testLine = line + words[n] + ' ';
        testWidth = this.textWidth(testLine);
        if (testWidth > maxWidth && line.length > 0) {
          this._renderText(p, line, x, y, finalMaxHeight);
          line = words[n] + ' ';
          y += p.textLeading();
        } else {
          line = testLine;
        }
      }

      this._renderText(p, line, x, y, finalMaxHeight);
      y += p.textLeading();
    }
  } else {
    // Offset to account for vertically centering multiple lines of text - no
    // need to adjust anything for vertical align top or baseline
    var offset = 0,
      vAlign = p.textAlign().vertical;
    if (vAlign === constants.CENTER) {
      offset = (cars.length - 1) * p.textLeading() / 2;
    } else if (vAlign === constants.BOTTOM) {
      offset = (cars.length - 1) * p.textLeading();
    }

    for (jj = 0; jj < cars.length; jj++) {
      this._renderText(p, cars[jj], x, y - offset, finalMaxHeight);
      y += p.textLeading();
    }
  }

  if (baselineHacked) {
    this.drawingContext.textBaseline = constants.BASELINE;
  }

  return p;
};

p5.Renderer2D.prototype._renderText = function(p, line, x, y, maxY) {
  if (y >= maxY) {
    return; // don't render lines beyond our maxY position
  }

  p.push(); // fix to #803

  if (!this._isOpenType()) {
    // a system/browser font

    // no stroke unless specified by user
    if (this._doStroke && this._strokeSet) {
      this.drawingContext.strokeText(line, x, y);
    }

    if (this._doFill) {
      // if fill hasn't been set by user, use default text fill
      if (!this._fillSet) {
        this._setFill(constants._DEFAULT_TEXT_FILL);
      }

      this.drawingContext.fillText(line, x, y);
    }
  } else {
    // an opentype font, let it handle the rendering

    this._textFont._renderPath(line, x, y, { renderer: this });
  }

  p.pop();

  return p;
};

p5.Renderer2D.prototype.textWidth = function(s) {
  if (this._isOpenType()) {
    return this._textFont._textWidth(s, this._textSize);
  }

  return this.drawingContext.measureText(s).width;
};

p5.Renderer2D.prototype.textAlign = function(h, v) {
  if (typeof h !== 'undefined') {
    if (
      h === constants.LEFT ||
      h === constants.RIGHT ||
      h === constants.CENTER
    ) {
      this.drawingContext.textAlign = h;
    }

    if (
      v === constants.TOP ||
      v === constants.BOTTOM ||
      v === constants.CENTER ||
      v === constants.BASELINE
    ) {
      if (v === constants.CENTER) {
        this.drawingContext.textBaseline = constants._CTX_MIDDLE;
      } else {
        this.drawingContext.textBaseline = v;
      }
    }

    return this._pInst;
  } else {
    var valign = this.drawingContext.textBaseline;

    if (valign === constants._CTX_MIDDLE) {
      valign = constants.CENTER;
    }

    return {
      horizontal: this.drawingContext.textAlign,
      vertical: valign
    };
  }
};

p5.Renderer2D.prototype._applyTextProperties = function() {
  var font,
    p = this._pInst;

  this._setProperty('_textAscent', null);
  this._setProperty('_textDescent', null);

  font = this._textFont;

  if (this._isOpenType()) {
    font = this._textFont.font.familyName;
    this._setProperty('_textStyle', this._textFont.font.styleName);
  }

  this.drawingContext.font =
    (this._textStyle || 'normal') +
    ' ' +
    (this._textSize || 12) +
    'px ' +
    (font || 'sans-serif');

  return p;
};

//////////////////////////////////////////////
// STRUCTURE
//////////////////////////////////////////////

p5.Renderer2D.prototype.push = function() {
  this.drawingContext.save();
};

p5.Renderer2D.prototype.pop = function() {
  this.drawingContext.restore();
  // Re-cache the fill / stroke state
  this._cachedFillStyle = this.drawingContext.fillStyle;
  this._cachedStrokeStyle = this.drawingContext.strokeStyle;
};

module.exports = p5.Renderer2D;

},{"../image/filters":41,"./canvas":20,"./constants":21,"./core":22,"./p5.Renderer":29}],31:[function(_dereq_,module,exports){
/**
 * @module Rendering
 * @submodule Rendering
 * @for p5
 */

'use strict';

var p5 = _dereq_('./core');
var constants = _dereq_('./constants');
_dereq_('./p5.Graphics');
_dereq_('./p5.Renderer2D');
_dereq_('../webgl/p5.RendererGL');
var defaultId = 'defaultCanvas0'; // this gets set again in createCanvas

/**
 * Creates a canvas element in the document, and sets the dimensions of it
 * in pixels. This method should be called only once at the start of setup.
 * Calling createCanvas more than once in a sketch will result in very
 * unpredictable behavior. If you want more than one drawing canvas
 * you could use createGraphics (hidden by default but it can be shown).
 * <br><br>
 * The system variables width and height are set by the parameters passed
 * to this function. If createCanvas() is not used, the window will be
 * given a default size of 100x100 pixels.
 * <br><br>
 * For more ways to position the canvas, see the
 * <a href='https://github.com/processing/p5.js/wiki/Positioning-your-canvas'>
 * positioning the canvas</a> wiki page.
 *
 * @method createCanvas
 * @param  {Number} w width of the canvas
 * @param  {Number} h height of the canvas
 * @param  {Constant} [renderer] either P2D or WEBGL
 * @return {HTMLCanvasElement} canvas generated
 * @example
 * <div>
 * <code>
 * function setup() {
 *   createCanvas(100, 50);
 *   background(153);
 *   line(0, 0, width, height);
 * }
 * </code>
 * </div>
 *
 * @alt
 * Black line extending from top-left of canvas to bottom right.
 *
 */

p5.prototype.createCanvas = function(w, h, renderer) {
  p5._validateParameters('createCanvas', arguments);
  //optional: renderer, otherwise defaults to p2d
  var r = renderer || constants.P2D;
  var c;

  if (r === constants.WEBGL) {
    c = document.getElementById(defaultId);
    if (c) {
      //if defaultCanvas already exists
      c.parentNode.removeChild(c); //replace the existing defaultCanvas
      var thisRenderer = this._renderer;
      this._elements = this._elements.filter(function(e) {
        return e !== thisRenderer;
      });
    }
    c = document.createElement('canvas');
    c.id = defaultId;
  } else {
    if (!this._defaultGraphicsCreated) {
      c = document.createElement('canvas');
      var i = 0;
      while (document.getElementById('defaultCanvas' + i)) {
        i++;
      }
      defaultId = 'defaultCanvas' + i;
      c.id = defaultId;
    } else {
      // resize the default canvas if new one is created
      c = this.canvas;
    }
  }

  // set to invisible if still in setup (to prevent flashing with manipulate)
  if (!this._setupDone) {
    c.dataset.hidden = true; // tag to show later
    c.style.visibility = 'hidden';
  }

  if (this._userNode) {
    // user input node case
    this._userNode.appendChild(c);
  } else {
    document.body.appendChild(c);
  }

  // Init our graphics renderer
  //webgl mode
  if (r === constants.WEBGL) {
    this._setProperty('_renderer', new p5.RendererGL(c, this, true));
    this._elements.push(this._renderer);
  } else {
    //P2D mode
    if (!this._defaultGraphicsCreated) {
      this._setProperty('_renderer', new p5.Renderer2D(c, this, true));
      this._defaultGraphicsCreated = true;
      this._elements.push(this._renderer);
    }
  }
  this._renderer.resize(w, h);
  this._renderer._applyDefaults();
  return this._renderer;
};

/**
 * Resizes the canvas to given width and height. The canvas will be cleared
 * and draw will be called immediately, allowing the sketch to re-render itself
 * in the resized canvas.
 * @method resizeCanvas
 * @param  {Number} w width of the canvas
 * @param  {Number} h height of the canvas
 * @param  {Boolean} [noRedraw] don't redraw the canvas immediately
 * @example
 * <div class="norender"><code>
 * function setup() {
 *   createCanvas(windowWidth, windowHeight);
 * }
 *
 * function draw() {
 *   background(0, 100, 200);
 * }
 *
 * function windowResized() {
 *   resizeCanvas(windowWidth, windowHeight);
 * }
 * </code></div>
 *
 * @alt
 * No image displayed.
 *
 */
p5.prototype.resizeCanvas = function(w, h, noRedraw) {
  p5._validateParameters('resizeCanvas', arguments);
  if (this._renderer) {
    // save canvas properties
    var props = {};
    for (var key in this.drawingContext) {
      var val = this.drawingContext[key];
      if (typeof val !== 'object' && typeof val !== 'function') {
        props[key] = val;
      }
    }
    this._renderer.resize(w, h);
    // reset canvas properties
    for (var savedKey in props) {
      try {
        this.drawingContext[savedKey] = props[savedKey];
      } catch (err) {
        // ignore read-only property errors
      }
    }
    if (!noRedraw) {
      this.redraw();
    }
  }
};

/**
 * Removes the default canvas for a p5 sketch that doesn't
 * require a canvas
 * @method noCanvas
 * @example
 * <div>
 * <code>
 * function setup() {
 *   noCanvas();
 * }
 * </code>
 * </div>
 *
 * @alt
 * no image displayed
 *
 */
p5.prototype.noCanvas = function() {
  if (this.canvas) {
    this.canvas.parentNode.removeChild(this.canvas);
  }
};

/**
 * Creates and returns a new p5.Renderer object. Use this class if you need
 * to draw into an off-screen graphics buffer. The two parameters define the
 * width and height in pixels.
 *
 * @method createGraphics
 * @param  {Number} w width of the offscreen graphics buffer
 * @param  {Number} h height of the offscreen graphics buffer
 * @param  {Constant} [renderer] either P2D or WEBGL
 * undefined defaults to p2d
 * @return {p5.Graphics} offscreen graphics buffer
 * @example
 * <div>
 * <code>
 * var pg;
 * function setup() {
 *   createCanvas(100, 100);
 *   pg = createGraphics(100, 100);
 * }
 * function draw() {
 *   background(200);
 *   pg.background(100);
 *   pg.noStroke();
 *   pg.ellipse(pg.width / 2, pg.height / 2, 50, 50);
 *   image(pg, 50, 50);
 *   image(pg, 0, 0, 50, 50);
 * }
 * </code>
 * </div>
 *
 * @alt
 * 4 grey squares alternating light and dark grey. White quarter circle mid-left.
 *
 */
p5.prototype.createGraphics = function(w, h, renderer) {
  p5._validateParameters('createGraphics', arguments);
  return new p5.Graphics(w, h, renderer, this);
};

/**
 * Blends the pixels in the display window according to the defined mode.
 * There is a choice of the following modes to blend the source pixels (A)
 * with the ones of pixels already in the display window (B):
 * <ul>
 * <li><code>BLEND</code> - linear interpolation of colours: C =
 * A*factor + B. This is the default blending mode.</li>
 * <li><code>ADD</code> - sum of A and B</li>
 * <li><code>DARKEST</code> - only the darkest colour succeeds: C =
 * min(A*factor, B).</li>
 * <li><code>LIGHTEST</code> - only the lightest colour succeeds: C =
 * max(A*factor, B).</li>
 * <li><code>DIFFERENCE</code> - subtract colors from underlying image.</li>
 * <li><code>EXCLUSION</code> - similar to <code>DIFFERENCE</code>, but less
 * extreme.</li>
 * <li><code>MULTIPLY</code> - multiply the colors, result will always be
 * darker.</li>
 * <li><code>SCREEN</code> - opposite multiply, uses inverse values of the
 * colors.</li>
 * <li><code>REPLACE</code> - the pixels entirely replace the others and
 * don't utilize alpha (transparency) values.</li>
 * <li><code>OVERLAY</code> - mix of <code>MULTIPLY</code> and <code>SCREEN
 * </code>. Multiplies dark values, and screens light values.</li>
 * <li><code>HARD_LIGHT</code> - <code>SCREEN</code> when greater than 50%
 * gray, <code>MULTIPLY</code> when lower.</li>
 * <li><code>SOFT_LIGHT</code> - mix of <code>DARKEST</code> and
 * <code>LIGHTEST</code>. Works like <code>OVERLAY</code>, but not as harsh.
 * </li>
 * <li><code>DODGE</code> - lightens light tones and increases contrast,
 * ignores darks.</li>
 * <li><code>BURN</code> - darker areas are applied, increasing contrast,
 * ignores lights.</li>
 * </ul>
 *
 * @method blendMode
 * @param  {Constant} mode blend mode to set for canvas.
 *                either BLEND, DARKEST, LIGHTEST, DIFFERENCE, MULTIPLY,
 *                EXCLUSION, SCREEN, REPLACE, OVERLAY, HARD_LIGHT,
 *                SOFT_LIGHT, DODGE, BURN, ADD or NORMAL
 * @example
 * <div>
 * <code>
 * blendMode(LIGHTEST);
 * strokeWeight(30);
 * stroke(80, 150, 255);
 * line(25, 25, 75, 75);
 * stroke(255, 50, 50);
 * line(75, 25, 25, 75);
 * </code>
 * </div>
 * <div>
 * <code>
 * blendMode(MULTIPLY);
 * strokeWeight(30);
 * stroke(80, 150, 255);
 * line(25, 25, 75, 75);
 * stroke(255, 50, 50);
 * line(75, 25, 25, 75);
 * </code>
 * </div>
 * @alt
 * translucent image thick red & blue diagonal rounded lines intersecting center
 * Thick red & blue diagonal rounded lines intersecting center. dark at overlap
 *
 */
p5.prototype.blendMode = function(mode) {
  p5._validateParameters('blendMode', arguments);
  if (
    mode === constants.BLEND ||
    mode === constants.DARKEST ||
    mode === constants.LIGHTEST ||
    mode === constants.DIFFERENCE ||
    mode === constants.MULTIPLY ||
    mode === constants.EXCLUSION ||
    mode === constants.SCREEN ||
    mode === constants.REPLACE ||
    mode === constants.OVERLAY ||
    mode === constants.HARD_LIGHT ||
    mode === constants.SOFT_LIGHT ||
    mode === constants.DODGE ||
    mode === constants.BURN ||
    mode === constants.ADD ||
    mode === constants.NORMAL
  ) {
    this._renderer.blendMode(mode);
  } else {
    throw new Error('Mode ' + mode + ' not recognized.');
  }
};

module.exports = p5;

},{"../webgl/p5.RendererGL":73,"./constants":21,"./core":22,"./p5.Graphics":28,"./p5.Renderer2D":30}],32:[function(_dereq_,module,exports){
'use strict';

// requestAnim shim layer by Paul Irish
window.requestAnimationFrame = (function() {
  return (
    window.requestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    window.oRequestAnimationFrame ||
    window.msRequestAnimationFrame ||
    function(callback, element) {
      // should '60' here be framerate?
      window.setTimeout(callback, 1000 / 60);
    }
  );
})();

// use window.performance() to get max fast and accurate time in milliseconds
window.performance = window.performance || {};
window.performance.now = (function() {
  var load_date = Date.now();
  return (
    window.performance.now ||
    window.performance.mozNow ||
    window.performance.msNow ||
    window.performance.oNow ||
    window.performance.webkitNow ||
    function() {
      return Date.now() - load_date;
    }
  );
})();

/*
// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
// http://my.opera.com/emoller/blog/2011/12/20/
// requestanimationframe-for-smart-er-animating
// requestAnimationFrame polyfill by Erik Möller
// fixes from Paul Irish and Tino Zijdel
(function() {
  var lastTime = 0;
  var vendors = ['ms', 'moz', 'webkit', 'o'];
  for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
    window.requestAnimationFrame =
      window[vendors[x]+'RequestAnimationFrame'];
    window.cancelAnimationFrame =
      window[vendors[x]+'CancelAnimationFrame'] ||
      window[vendors[x]+'CancelRequestAnimationFrame'];
  }

  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = function(callback, element) {
      var currTime = new Date().getTime();
      var timeToCall = Math.max(0, 16 - (currTime - lastTime));
      var id = window.setTimeout(function()
        { callback(currTime + timeToCall); }, timeToCall);
      lastTime = currTime + timeToCall;
      return id;
    };
  }

  if (!window.cancelAnimationFrame) {
    window.cancelAnimationFrame = function(id) {
      clearTimeout(id);
    };
  }
}());
*/

/**
 * shim for Uint8ClampedArray.slice
 * (allows arrayCopy to work with pixels[])
 * with thanks to http://halfpapstudios.com/blog/tag/html5-canvas/
 * Enumerable set to false to protect for...in from
 * Uint8ClampedArray.prototype pollution.
 */
(function() {
  'use strict';
  if (
    typeof Uint8ClampedArray !== 'undefined' &&
    !Uint8ClampedArray.prototype.slice
  ) {
    Object.defineProperty(Uint8ClampedArray.prototype, 'slice', {
      value: Array.prototype.slice,
      writable: true,
      configurable: true,
      enumerable: false
    });
  }
})();

},{}],33:[function(_dereq_,module,exports){
/**
 * @module Structure
 * @submodule Structure
 * @for p5
 * @requires core
 */

'use strict';

var p5 = _dereq_('./core');

p5.prototype.exit = function() {
  throw 'exit() not implemented, see remove()';
};
/**
 * Stops p5.js from continuously executing the code within draw().
 * If loop() is called, the code in draw() begins to run continuously again.
 * If using noLoop() in setup(), it should be the last line inside the block.
 * <br><br>
 * When noLoop() is used, it's not possible to manipulate or access the
 * screen inside event handling functions such as mousePressed() or
 * keyPressed(). Instead, use those functions to call redraw() or loop(),
 * which will run draw(), which can update the screen properly. This means
 * that when noLoop() has been called, no drawing can happen, and functions
 * like saveFrame() or loadPixels() may not be used.
 * <br><br>
 * Note that if the sketch is resized, redraw() will be called to update
 * the sketch, even after noLoop() has been specified. Otherwise, the sketch
 * would enter an odd state until loop() was called.
 *
 * @method noLoop
 * @example
 * <div><code>
 * function setup() {
 *   createCanvas(100, 100);
 *   background(200);
 *   noLoop();
 * }

 * function draw() {
 *   line(10, 10, 90, 90);
 * }
 * </code></div>
 *
 * <div><code>
 * var x = 0;
 * function setup() {
 *   createCanvas(100, 100);
 * }
 *
 * function draw() {
 *   background(204);
 *   x = x + 0.1;
 *   if (x > width) {
 *     x = 0;
 *   }
 *   line(x, 0, x, height);
 * }
 *
 * function mousePressed() {
 *   noLoop();
 * }
 *
 * function mouseReleased() {
 *   loop();
 * }
 * </code></div>
 *
 * @alt
 * 113 pixel long line extending from top-left to bottom right of canvas.
 * horizontal line moves slowly from left. Loops but stops on mouse press.
 *
 */
p5.prototype.noLoop = function() {
  this._loop = false;
};
/**
 * By default, p5.js loops through draw() continuously, executing the code
 * within it. However, the draw() loop may be stopped by calling noLoop().
 * In that case, the draw() loop can be resumed with loop().
 *
 * @method loop
 * @example
 * <div><code>
 * var x = 0;
 * function setup() {
 *   createCanvas(100, 100);
 *   noLoop();
 * }
 *
 * function draw() {
 *   background(204);
 *   x = x + 0.1;
 *   if (x > width) {
 *     x = 0;
 *   }
 *   line(x, 0, x, height);
 * }
 *
 * function mousePressed() {
 *   loop();
 * }
 *
 * function mouseReleased() {
 *   noLoop();
 * }
 * </code></div>
 *
 * @alt
 * horizontal line moves slowly from left. Loops but stops on mouse press.
 *
 */

p5.prototype.loop = function() {
  this._loop = true;
  this._draw();
};

function assign(dest, varArgs) {
  for (var index = 1; index < arguments.length; index++) {
    var src = arguments[index];
    if (src != null) {
      for (var key in src) {
        if (src.hasOwnProperty(key)) {
          dest[key] = src[key];
        }
      }
    }
  }
}

/**
 * The push() function saves the current drawing style settings and
 * transformations, while pop() restores these settings. Note that these
 * functions are always used together. They allow you to change the style
 * and transformation settings and later return to what you had. When a new
 * state is started with push(), it builds on the current style and transform
 * information. The push() and pop() functions can be embedded to provide
 * more control. (See the second example for a demonstration.)
 * <br><br>
 * push() stores information related to the current transformation state
 * and style settings controlled by the following functions: fill(),
 * stroke(), tint(), strokeWeight(), strokeCap(), strokeJoin(),
 * imageMode(), rectMode(), ellipseMode(), colorMode(), textAlign(),
 * textFont(), textMode(), textSize(), textLeading().
 *
 * @method push
 * @example
 * <div>
 * <code>
 * ellipse(0, 50, 33, 33); // Left circle
 *
 * push(); // Start a new drawing state
 * strokeWeight(10);
 * fill(204, 153, 0);
 * translate(50, 0);
 * ellipse(0, 50, 33, 33); // Middle circle
 * pop(); // Restore original state
 *
 * ellipse(100, 50, 33, 33); // Right circle
 * </code>
 * </div>
 * <div>
 * <code>
 * ellipse(0, 50, 33, 33); // Left circle
 *
 * push(); // Start a new drawing state
 * strokeWeight(10);
 * fill(204, 153, 0);
 * ellipse(33, 50, 33, 33); // Left-middle circle
 *
 * push(); // Start another new drawing state
 * stroke(0, 102, 153);
 * ellipse(66, 50, 33, 33); // Right-middle circle
 * pop(); // Restore previous state
 *
 * pop(); // Restore original state
 *
 * ellipse(100, 50, 33, 33); // Right circle
 * </code>
 * </div>
 *
 * @alt
 * Gold ellipse + thick black outline @center 2 white ellipses on left and right.
 * 2 Gold ellipses left black right blue stroke. 2 white ellipses on left+right.
 *
 */
p5.prototype.push = function() {
  this._renderer.push();
  this._styles.push({
    props: {
      _colorMode: this._colorMode
    },
    renderer: {
      _doStroke: this._renderer._doStroke,
      _strokeSet: this._renderer._strokeSet,
      _doFill: this._renderer._doFill,
      _fillSet: this._renderer._fillSet,
      _tint: this._renderer._tint,
      _imageMode: this._renderer._imageMode,
      _rectMode: this._renderer._rectMode,
      _ellipseMode: this._renderer._ellipseMode,
      _textFont: this._renderer._textFont,
      _textLeading: this._renderer._textLeading,
      _textSize: this._renderer._textSize,
      _textStyle: this._renderer._textStyle
    }
  });
};

/**
 * The push() function saves the current drawing style settings and
 * transformations, while pop() restores these settings. Note that these
 * functions are always used together. They allow you to change the style
 * and transformation settings and later return to what you had. When a new
 * state is started with push(), it builds on the current style and transform
 * information. The push() and pop() functions can be embedded to provide
 * more control. (See the second example for a demonstration.)
 * <br><br>
 * push() stores information related to the current transformation state
 * and style settings controlled by the following functions: fill(),
 * stroke(), tint(), strokeWeight(), strokeCap(), strokeJoin(),
 * imageMode(), rectMode(), ellipseMode(), colorMode(), textAlign(),
 * textFont(), textMode(), textSize(), textLeading().
 *
 * @method pop
 * @example
 * <div>
 * <code>
 * ellipse(0, 50, 33, 33); // Left circle
 *
 * push(); // Start a new drawing state
 * translate(50, 0);
 * strokeWeight(10);
 * fill(204, 153, 0);
 * ellipse(0, 50, 33, 33); // Middle circle
 * pop(); // Restore original state
 *
 * ellipse(100, 50, 33, 33); // Right circle
 * </code>
 * </div>
 * <div>
 * <code>
 * ellipse(0, 50, 33, 33); // Left circle
 *
 * push(); // Start a new drawing state
 * strokeWeight(10);
 * fill(204, 153, 0);
 * ellipse(33, 50, 33, 33); // Left-middle circle
 *
 * push(); // Start another new drawing state
 * stroke(0, 102, 153);
 * ellipse(66, 50, 33, 33); // Right-middle circle
 * pop(); // Restore previous state
 *
 * pop(); // Restore original state
 *
 * ellipse(100, 50, 33, 33); // Right circle
 * </code>
 * </div>
 *
 * @alt
 * Gold ellipse + thick black outline @center 2 white ellipses on left and right.
 * 2 Gold ellipses left black right blue stroke. 2 white ellipses on left+right.
 *
 */
p5.prototype.pop = function() {
  this._renderer.pop();
  var lastS = this._styles.pop();
  assign(this._renderer, lastS.renderer);
  assign(this, lastS.props);
};

p5.prototype.pushStyle = function() {
  throw new Error('pushStyle() not used, see push()');
};

p5.prototype.popStyle = function() {
  throw new Error('popStyle() not used, see pop()');
};

/**
 *
 * Executes the code within draw() one time. This functions allows the
 * program to update the display window only when necessary, for example
 * when an event registered by mousePressed() or keyPressed() occurs.
 * <br><br>
 * In structuring a program, it only makes sense to call redraw() within
 * events such as mousePressed(). This is because redraw() does not run
 * draw() immediately (it only sets a flag that indicates an update is
 * needed).
 * <br><br>
 * The redraw() function does not work properly when called inside draw().
 * To enable/disable animations, use loop() and noLoop().
 * <br><br>
 * In addition you can set the number of redraws per method call. Just
 * add an integer as single parameter for the number of redraws.
 *
 * @method redraw
 * @param  {Integer} [n] Redraw for n-times. The default value is 1.
 * @example
 * <div><code>
 * var x = 0;
 *
 * function setup() {
 *   createCanvas(100, 100);
 *   noLoop();
 * }
 *
 * function draw() {
 *   background(204);
 *   line(x, 0, x, height);
 * }
 *
 * function mousePressed() {
 *   x += 1;
 *   redraw();
 * }
 * </code></div>
 *
 * <div class='norender'><code>
 * var x = 0;
 *
 * function setup() {
 *   createCanvas(100, 100);
 *   noLoop();
 * }
 *
 * function draw() {
 *   background(204);
 *   x += 1;
 *   line(x, 0, x, height);
 * }
 *
 * function mousePressed() {
 *   redraw(5);
 * }
 * </code></div>
 *
 * @alt
 * black line on far left of canvas
 * black line on far left of canvas
 *
 */
p5.prototype.redraw = function(n) {
  this.resetMatrix();
  if (this._renderer.isP3D) {
    this._renderer._update();
  }

  var numberOfRedraws = parseInt(n);
  if (isNaN(numberOfRedraws) || numberOfRedraws < 1) {
    numberOfRedraws = 1;
  }

  var userSetup = this.setup || window.setup;
  var userDraw = this.draw || window.draw;
  if (typeof userDraw === 'function') {
    if (typeof userSetup === 'undefined') {
      this.scale(this._pixelDensity, this._pixelDensity);
    }
    var self = this;
    var callMethod = function(f) {
      f.call(self);
    };
    for (var idxRedraw = 0; idxRedraw < numberOfRedraws; idxRedraw++) {
      this._setProperty('frameCount', this.frameCount + 1);
      this._registeredMethods.pre.forEach(callMethod);
      userDraw();
      this._registeredMethods.post.forEach(callMethod);
    }
  }
};

p5.prototype.size = function() {
  var s = 'size() is not a valid p5 function, to set the size of the ';
  s += 'drawing canvas, please use createCanvas() instead';
  throw s;
};

module.exports = p5;

},{"./core":22}],34:[function(_dereq_,module,exports){
/**
 * @module Transform
 * @submodule Transform
 * @for p5
 * @requires core
 * @requires constants
 */

'use strict';

var p5 = _dereq_('./core');
var constants = _dereq_('./constants');

/**
 * Multiplies the current matrix by the one specified through the parameters.
 * This is a powerful operation that can perform the equivalent of translate,
 * scale, shear and rotate all at once. You can learn more about transformation
 * matrices on <a href="https://en.wikipedia.org/wiki/Transformation_matrix">
 * Wikipedia</a>.
 *
 * The naming of the arguments here follows the naming of the <a href=
 * "https://html.spec.whatwg.org/multipage/canvas.html#dom-context-2d-transform">
 * WHATWG specification</a> and corresponds to a
 * transformation matrix of the
 * form:
 *
 * > <img style="max-width: 150px" src="assets/transformation-matrix.png"
 * alt="The transformation matrix used when applyMatrix is called"/>
 *
 * @method applyMatrix
 * @param  {Number} a numbers which define the 2x3 matrix to be multiplied
 * @param  {Number} b numbers which define the 2x3 matrix to be multiplied
 * @param  {Number} c numbers which define the 2x3 matrix to be multiplied
 * @param  {Number} d numbers which define the 2x3 matrix to be multiplied
 * @param  {Number} e numbers which define the 2x3 matrix to be multiplied
 * @param  {Number} f numbers which define the 2x3 matrix to be multiplied
 * @chainable
 * @example
 * <div>
 * <code>
 * function setup() {
 *   frameRate(10);
 *   rectMode(CENTER);
 * }
 *
 * function draw() {
 *   var step = frameCount % 20;
 *   background(200);
 *   // Equivalent to translate(x, y);
 *   applyMatrix(1, 0, 0, 1, 40 + step, 50);
 *   rect(0, 0, 50, 50);
 * }
 * </code>
 * </div>
 * <div>
 * <code>
 * function setup() {
 *   frameRate(10);
 *   rectMode(CENTER);
 * }
 *
 * function draw() {
 *   var step = frameCount % 20;
 *   background(200);
 *   translate(50, 50);
 *   // Equivalent to scale(x, y);
 *   applyMatrix(1 / step, 0, 0, 1 / step, 0, 0);
 *   rect(0, 0, 50, 50);
 * }
 * </code>
 * </div>
 * <div>
 * <code>
 * function setup() {
 *   frameRate(10);
 *   rectMode(CENTER);
 * }
 *
 * function draw() {
 *   var step = frameCount % 20;
 *   var angle = map(step, 0, 20, 0, TWO_PI);
 *   var cos_a = cos(angle);
 *   var sin_a = sin(angle);
 *   background(200);
 *   translate(50, 50);
 *   // Equivalent to rotate(angle);
 *   applyMatrix(cos_a, sin_a, -sin_a, cos_a, 0, 0);
 *   rect(0, 0, 50, 50);
 * }
 * </code>
 * </div>
 * <div>
 * <code>
 * function setup() {
 *   frameRate(10);
 *   rectMode(CENTER);
 * }
 *
 * function draw() {
 *   var step = frameCount % 20;
 *   var angle = map(step, 0, 20, -PI / 4, PI / 4);
 *   background(200);
 *   translate(50, 50);
 *   // equivalent to shearX(angle);
 *   var shear_factor = 1 / tan(PI / 2 - angle);
 *   applyMatrix(1, 0, shear_factor, 1, 0, 0);
 *   rect(0, 0, 50, 50);
 * }
 * </code>
 * </div>
 *
 * @alt
 * A rectangle translating to the right
 * A rectangle shrinking to the center
 * A rectangle rotating clockwise about the center
 * A rectangle shearing
 *
 */
p5.prototype.applyMatrix = function(a, b, c, d, e, f) {
  this._renderer.applyMatrix(a, b, c, d, e, f);
  return this;
};

p5.prototype.popMatrix = function() {
  throw new Error('popMatrix() not used, see pop()');
};

p5.prototype.printMatrix = function() {
  throw new Error('printMatrix() not implemented');
};

p5.prototype.pushMatrix = function() {
  throw new Error('pushMatrix() not used, see push()');
};

/**
 * Replaces the current matrix with the identity matrix.
 *
 * @method resetMatrix
 * @chainable
 * @example
 * <div>
 * <code>
 * translate(50, 50);
 * applyMatrix(0.5, 0.5, -0.5, 0.5, 0, 0);
 * rect(0, 0, 20, 20);
 * // Note that the translate is also reset.
 * resetMatrix();
 * rect(0, 0, 20, 20);
 * </code>
 * </div>
 *
 * @alt
 * A rotated retangle in the center with another at the top left corner
 *
 */
p5.prototype.resetMatrix = function() {
  this._renderer.resetMatrix();
  return this;
};

/**
 * Rotates a shape the amount specified by the angle parameter. This
 * function accounts for angleMode, so angles can be entered in either
 * RADIANS or DEGREES.
 * <br><br>
 * Objects are always rotated around their relative position to the
 * origin and positive numbers rotate objects in a clockwise direction.
 * Transformations apply to everything that happens after and subsequent
 * calls to the function accumulates the effect. For example, calling
 * rotate(HALF_PI) and then rotate(HALF_PI) is the same as rotate(PI).
 * All tranformations are reset when draw() begins again.
 * <br><br>
 * Technically, rotate() multiplies the current transformation matrix
 * by a rotation matrix. This function can be further controlled by
 * the push() and pop().
 *
 * @method rotate
 * @param  {Number} angle the angle of rotation, specified in radians
 *                        or degrees, depending on current angleMode
 * @param  {p5.Vector|Number[]} [axis] (in 3d) the axis to rotate around
 * @chainable
 * @example
 * <div>
 * <code>
 * translate(width / 2, height / 2);
 * rotate(PI / 3.0);
 * rect(-26, -26, 52, 52);
 * </code>
 * </div>
 *
 * @alt
 * white 52x52 rect with black outline at center rotated counter 45 degrees
 *
 */
p5.prototype.rotate = function(angle, axis) {
  p5._validateParameters('rotate', arguments);
  var r;
  if (this._angleMode === constants.DEGREES) {
    r = this.radians(angle);
  } else if (this._angleMode === constants.RADIANS) {
    r = angle;
  }
  this._renderer.rotate(r, axis);
  return this;
};

/**
 * Rotates around X axis.
 * @method  rotateX
 * @param  {Number} rad angles in radians
 * @chainable
 * @example
 * <div modernizr='webgl'>
 * <code>
 * function setup() {
 *   createCanvas(100, 100, WEBGL);
 * }
 * function draw() {
 *   background(255);
 *   rotateX(millis() / 1000);
 *   box();
 * }
 * </code>
 * </div>
 *
 * @alt
 * 3d box rotating around the x axis.
 */
p5.prototype.rotateX = function(rad) {
  p5._validateParameters('rotateX', arguments);
  if (this._renderer.isP3D) {
    this._renderer.rotateX(rad);
  } else {
    throw 'not supported in p2d. Please use webgl mode';
  }
  return this;
};

/**
 * Rotates around Y axis.
 * @method rotateY
 * @param  {Number} rad angles in radians
 * @chainable
 * @example
 * <div modernizr='webgl'>
 * <code>
 * function setup() {
 *   createCanvas(100, 100, WEBGL);
 * }
 * function draw() {
 *   background(255);
 *   rotateY(millis() / 1000);
 *   box();
 * }
 * </code>
 * </div>
 *
 * @alt
 * 3d box rotating around the y axis.
 */
p5.prototype.rotateY = function(rad) {
  p5._validateParameters('rotateY', arguments);
  if (this._renderer.isP3D) {
    this._renderer.rotateY(rad);
  } else {
    throw 'not supported in p2d. Please use webgl mode';
  }
  return this;
};

/**
 * Rotates around Z axis. Webgl mode only.
 * @method rotateZ
 * @param  {Number} rad angles in radians
 * @chainable
 * @example
 * <div modernizr='webgl'>
 * <code>
 * function setup() {
 *   createCanvas(100, 100, WEBGL);
 * }
 * function draw() {
 *   background(255);
 *   rotateZ(millis() / 1000);
 *   box();
 * }
 * </code>
 * </div>
 *
 * @alt
 * 3d box rotating around the z axis.
 */
p5.prototype.rotateZ = function(rad) {
  p5._validateParameters('rotateZ', arguments);
  if (this._renderer.isP3D) {
    this._renderer.rotateZ(rad);
  } else {
    throw 'not supported in p2d. Please use webgl mode';
  }
  return this;
};

/**
 * Increases or decreases the size of a shape by expanding and contracting
 * vertices. Objects always scale from their relative origin to the
 * coordinate system. Scale values are specified as decimal percentages.
 * For example, the function call scale(2.0) increases the dimension of a
 * shape by 200%.
 * <br><br>
 * Transformations apply to everything that happens after and subsequent
 * calls to the function multiply the effect. For example, calling scale(2.0)
 * and then scale(1.5) is the same as scale(3.0). If scale() is called
 * within draw(), the transformation is reset when the loop begins again.
 * <br><br>
 * Using this function with the z parameter is only available in WEBGL mode.
 * This function can be further controlled with push() and pop().
 *
 * @method scale
 * @param  {Number|p5.Vector|Number[]} s
 *                      percent to scale the object, or percentage to
 *                      scale the object in the x-axis if multiple arguments
 *                      are given
 * @param  {Number} [y] percent to scale the object in the y-axis
 * @param  {Number} [z] percent to scale the object in the z-axis (webgl only)
 * @chainable
 * @example
 * <div>
 * <code>
 * translate(width / 2, height / 2);
 * rotate(PI / 3.0);
 * rect(-26, -26, 52, 52);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * rect(30, 20, 50, 50);
 * scale(0.5, 1.3);
 * rect(30, 20, 50, 50);
 * </code>
 * </div>
 *
 * @alt
 * white 52x52 rect with black outline at center rotated counter 45 degrees
 * 2 white rects with black outline- 1 50x50 at center. other 25x65 bottom left
 *
 */
/**
 * @method scale
 * @param  {p5.Vector|Number[]} scales per-axis percents to scale the object
 * @chainable
 */
p5.prototype.scale = function(x, y, z) {
  p5._validateParameters('scale', arguments);
  // Only check for Vector argument type if Vector is available
  if (x instanceof p5.Vector) {
    var v = x;
    x = v.x;
    y = v.y;
    z = v.z;
  } else if (x instanceof Array) {
    var rg = x;
    x = rg[0];
    y = rg[1];
    z = rg[2] || 1;
  }
  if (isNaN(y)) {
    y = z = x;
  } else if (isNaN(z)) {
    z = 1;
  }

  this._renderer.scale.call(this._renderer, x, y, z);

  return this;
};

/**
 * Shears a shape around the x-axis the amount specified by the angle
 * parameter. Angles should be specified in the current angleMode.
 * Objects are always sheared around their relative position to the origin
 * and positive numbers shear objects in a clockwise direction.
 * <br><br>
 * Transformations apply to everything that happens after and subsequent
 * calls to the function accumulates the effect. For example, calling
 * shearX(PI/2) and then shearX(PI/2) is the same as shearX(PI).
 * If shearX() is called within the draw(), the transformation is reset when
 * the loop begins again.
 * <br><br>
 * Technically, shearX() multiplies the current transformation matrix by a
 * rotation matrix. This function can be further controlled by the
 * push() and pop() functions.
 *
 * @method shearX
 * @param  {Number} angle angle of shear specified in radians or degrees,
 *                        depending on current angleMode
 * @chainable
 * @example
 * <div>
 * <code>
 * translate(width / 4, height / 4);
 * shearX(PI / 4.0);
 * rect(0, 0, 30, 30);
 * </code>
 * </div>
 *
 * @alt
 * white irregular quadrilateral with black outline at top middle.
 *
 */
p5.prototype.shearX = function(angle) {
  p5._validateParameters('shearX', arguments);
  if (this._angleMode === constants.DEGREES) {
    angle = this.radians(angle);
  }
  this._renderer.shearX(angle);
  return this;
};

/**
 * Shears a shape around the y-axis the amount specified by the angle
 * parameter. Angles should be specified in the current angleMode. Objects
 * are always sheared around their relative position to the origin and
 * positive numbers shear objects in a clockwise direction.
 * <br><br>
 * Transformations apply to everything that happens after and subsequent
 * calls to the function accumulates the effect. For example, calling
 * shearY(PI/2) and then shearY(PI/2) is the same as shearY(PI). If
 * shearY() is called within the draw(), the transformation is reset when
 * the loop begins again.
 * <br><br>
 * Technically, shearY() multiplies the current transformation matrix by a
 * rotation matrix. This function can be further controlled by the
 * push() and pop() functions.
 *
 * @method shearY
 * @param  {Number} angle angle of shear specified in radians or degrees,
 *                        depending on current angleMode
 * @chainable
 * @example
 * <div>
 * <code>
 * translate(width / 4, height / 4);
 * shearY(PI / 4.0);
 * rect(0, 0, 30, 30);
 * </code>
 * </div>
 *
 * @alt
 * white irregular quadrilateral with black outline at middle bottom.
 *
 */
p5.prototype.shearY = function(angle) {
  p5._validateParameters('shearY', arguments);
  if (this._angleMode === constants.DEGREES) {
    angle = this.radians(angle);
  }
  this._renderer.shearY(angle);
  return this;
};

/**
 * Specifies an amount to displace objects within the display window.
 * The x parameter specifies left/right translation, the y parameter
 * specifies up/down translation.
 * <br><br>
 * Transformations are cumulative and apply to everything that happens after
 * and subsequent calls to the function accumulates the effect. For example,
 * calling translate(50, 0) and then translate(20, 0) is the same as
 * translate(70, 0). If translate() is called within draw(), the
 * transformation is reset when the loop begins again. This function can be
 * further controlled by using push() and pop().
 *
 * @method translate
 * @param  {Number} x left/right translation
 * @param  {Number} y up/down translation
 * @param  {Number} [z] forward/backward translation (webgl only)
 * @chainable
 * @example
 * <div>
 * <code>
 * translate(30, 20);
 * rect(0, 0, 55, 55);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * rect(0, 0, 55, 55); // Draw rect at original 0,0
 * translate(30, 20);
 * rect(0, 0, 55, 55); // Draw rect at new 0,0
 * translate(14, 14);
 * rect(0, 0, 55, 55); // Draw rect at new 0,0
 * </code>
 * </div>
 *
 * @alt
 * white 55x55 rect with black outline at center right.
 * 3 white 55x55 rects with black outlines at top-l, center-r and bottom-r.
 *
 */
p5.prototype.translate = function(x, y, z) {
  p5._validateParameters('translate', arguments);
  if (this._renderer.isP3D) {
    this._renderer.translate(x, y, z);
  } else {
    this._renderer.translate(x, y);
  }
  return this;
};

module.exports = p5;

},{"./constants":21,"./core":22}],35:[function(_dereq_,module,exports){
/**
 * @module Shape
 * @submodule Vertex
 * @for p5
 * @requires core
 * @requires constants
 */

'use strict';

var p5 = _dereq_('./core');
var constants = _dereq_('./constants');
var shapeKind = null;
var vertices = [];
var contourVertices = [];
var isBezier = false;
var isCurve = false;
var isQuadratic = false;
var isContour = false;
var isFirstContour = true;

/**
 * Use the beginContour() and endContour() functions to create negative
 * shapes within shapes such as the center of the letter 'O'. beginContour()
 * begins recording vertices for the shape and endContour() stops recording.
 * The vertices that define a negative shape must "wind" in the opposite
 * direction from the exterior shape. First draw vertices for the exterior
 * clockwise order, then for internal shapes, draw vertices
 * shape in counter-clockwise.
 * <br><br>
 * These functions can only be used within a beginShape()/endShape() pair and
 * transformations such as translate(), rotate(), and scale() do not work
 * within a beginContour()/endContour() pair. It is also not possible to use
 * other shapes, such as ellipse() or rect() within.
 *
 * @method beginContour
 * @chainable
 * @example
 * <div>
 * <code>
 * translate(50, 50);
 * stroke(255, 0, 0);
 * beginShape();
 * // Exterior part of shape, clockwise winding
 * vertex(-40, -40);
 * vertex(40, -40);
 * vertex(40, 40);
 * vertex(-40, 40);
 * // Interior part of shape, counter-clockwise winding
 * beginContour();
 * vertex(-20, -20);
 * vertex(-20, 20);
 * vertex(20, 20);
 * vertex(20, -20);
 * endContour();
 * endShape(CLOSE);
 * </code>
 * </div>
 *
 * @alt
 * white rect and smaller grey rect with red outlines in center of canvas.
 *
 */
p5.prototype.beginContour = function() {
  contourVertices = [];
  isContour = true;
  return this;
};

/**
 * Using the beginShape() and endShape() functions allow creating more
 * complex forms. beginShape() begins recording vertices for a shape and
 * endShape() stops recording. The value of the kind parameter tells it which
 * types of shapes to create from the provided vertices. With no mode
 * specified, the shape can be any irregular polygon.
 * <br><br>
 * The parameters available for beginShape() are POINTS, LINES, TRIANGLES,
 * TRIANGLE_FAN, TRIANGLE_STRIP, QUADS, and QUAD_STRIP. After calling the
 * beginShape() function, a series of vertex() commands must follow. To stop
 * drawing the shape, call endShape(). Each shape will be outlined with the
 * current stroke color and filled with the fill color.
 * <br><br>
 * Transformations such as translate(), rotate(), and scale() do not work
 * within beginShape(). It is also not possible to use other shapes, such as
 * ellipse() or rect() within beginShape().
 *
 * @method beginShape
 * @param  {Constant} [kind] either POINTS, LINES, TRIANGLES, TRIANGLE_FAN
 *                                TRIANGLE_STRIP, QUADS, or QUAD_STRIP
 * @chainable
 * @example
 * <div>
 * <code>
 * beginShape();
 * vertex(30, 20);
 * vertex(85, 20);
 * vertex(85, 75);
 * vertex(30, 75);
 * endShape(CLOSE);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * beginShape(POINTS);
 * vertex(30, 20);
 * vertex(85, 20);
 * vertex(85, 75);
 * vertex(30, 75);
 * endShape();
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * beginShape(LINES);
 * vertex(30, 20);
 * vertex(85, 20);
 * vertex(85, 75);
 * vertex(30, 75);
 * endShape();
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * noFill();
 * beginShape();
 * vertex(30, 20);
 * vertex(85, 20);
 * vertex(85, 75);
 * vertex(30, 75);
 * endShape();
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * noFill();
 * beginShape();
 * vertex(30, 20);
 * vertex(85, 20);
 * vertex(85, 75);
 * vertex(30, 75);
 * endShape(CLOSE);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * beginShape(TRIANGLES);
 * vertex(30, 75);
 * vertex(40, 20);
 * vertex(50, 75);
 * vertex(60, 20);
 * vertex(70, 75);
 * vertex(80, 20);
 * endShape();
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * beginShape(TRIANGLE_STRIP);
 * vertex(30, 75);
 * vertex(40, 20);
 * vertex(50, 75);
 * vertex(60, 20);
 * vertex(70, 75);
 * vertex(80, 20);
 * vertex(90, 75);
 * endShape();
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * beginShape(TRIANGLE_FAN);
 * vertex(57.5, 50);
 * vertex(57.5, 15);
 * vertex(92, 50);
 * vertex(57.5, 85);
 * vertex(22, 50);
 * vertex(57.5, 15);
 * endShape();
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * beginShape(QUADS);
 * vertex(30, 20);
 * vertex(30, 75);
 * vertex(50, 75);
 * vertex(50, 20);
 * vertex(65, 20);
 * vertex(65, 75);
 * vertex(85, 75);
 * vertex(85, 20);
 * endShape();
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * beginShape(QUAD_STRIP);
 * vertex(30, 20);
 * vertex(30, 75);
 * vertex(50, 20);
 * vertex(50, 75);
 * vertex(65, 20);
 * vertex(65, 75);
 * vertex(85, 20);
 * vertex(85, 75);
 * endShape();
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * beginShape();
 * vertex(20, 20);
 * vertex(40, 20);
 * vertex(40, 40);
 * vertex(60, 40);
 * vertex(60, 60);
 * vertex(20, 60);
 * endShape(CLOSE);
 * </code>
 * </div>
 * @alt
 * white square-shape with black outline in middle-right of canvas.
 * 4 black points in a square shape in middle-right of canvas.
 * 2 horizontal black lines. In the top-right and bottom-right of canvas.
 * 3 line shape with horizontal on top, vertical in middle and horizontal bottom.
 * square line shape in middle-right of canvas.
 * 2 white triangle shapes mid-right canvas. left one pointing up and right down.
 * 5 horizontal interlocking and alternating white triangles in mid-right canvas.
 * 4 interlocking white triangles in 45 degree rotated square-shape.
 * 2 white rectangle shapes in mid-right canvas. Both 20x55.
 * 3 side-by-side white rectangles center rect is smaller in mid-right canvas.
 * Thick white l-shape with black outline mid-top-left of canvas.
 *
 */
p5.prototype.beginShape = function(kind) {
  if (this._renderer.isP3D) {
    this._renderer.beginShape.apply(this._renderer, arguments);
  } else {
    if (
      kind === constants.POINTS ||
      kind === constants.LINES ||
      kind === constants.TRIANGLES ||
      kind === constants.TRIANGLE_FAN ||
      kind === constants.TRIANGLE_STRIP ||
      kind === constants.QUADS ||
      kind === constants.QUAD_STRIP
    ) {
      shapeKind = kind;
    } else {
      shapeKind = null;
    }

    vertices = [];
    contourVertices = [];
  }
  return this;
};

/**
 * Specifies vertex coordinates for Bezier curves. Each call to
 * bezierVertex() defines the position of two control points and
 * one anchor point of a Bezier curve, adding a new segment to a
 * line or shape.
 * <br><br>
 * The first time bezierVertex() is used within a
 * beginShape() call, it must be prefaced with a call to vertex()
 * to set the first anchor point. This function must be used between
 * beginShape() and endShape() and only when there is no MODE
 * parameter specified to beginShape().
 *
 * @method bezierVertex
 * @param  {Number} x2 x-coordinate for the first control point
 * @param  {Number} y2 y-coordinate for the first control point
 * @param  {Number} x3 x-coordinate for the second control point
 * @param  {Number} y3 y-coordinate for the second control point
 * @param  {Number} x4 x-coordinate for the anchor point
 * @param  {Number} y4 y-coordinate for the anchor point
 * @chainable
 * @example
 * <div>
 * <code>
 * noFill();
 * beginShape();
 * vertex(30, 20);
 * bezierVertex(80, 0, 80, 75, 30, 75);
 * endShape();
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * beginShape();
 * vertex(30, 20);
 * bezierVertex(80, 0, 80, 75, 30, 75);
 * bezierVertex(50, 80, 60, 25, 30, 20);
 * endShape();
 * </code>
 * </div>
 *
 * @alt
 * crescent-shaped line in middle of canvas. Points facing left.
 * white crescent shape in middle of canvas. Points facing left.
 *
 */
p5.prototype.bezierVertex = function(x2, y2, x3, y3, x4, y4) {
  p5._validateParameters('bezierVertex', arguments);
  if (vertices.length === 0) {
    throw 'vertex() must be used once before calling bezierVertex()';
  } else {
    isBezier = true;
    var vert = [];
    for (var i = 0; i < arguments.length; i++) {
      vert[i] = arguments[i];
    }
    vert.isVert = false;
    if (isContour) {
      contourVertices.push(vert);
    } else {
      vertices.push(vert);
    }
  }
  return this;
};

/**
 * Specifies vertex coordinates for curves. This function may only
 * be used between beginShape() and endShape() and only when there
 * is no MODE parameter specified to beginShape().
 * <br><br>
 * The first and last points in a series of curveVertex() lines will be used to
 * guide the beginning and end of a the curve. A minimum of four
 * points is required to draw a tiny curve between the second and
 * third points. Adding a fifth point with curveVertex() will draw
 * the curve between the second, third, and fourth points. The
 * curveVertex() function is an implementation of Catmull-Rom
 * splines.
 *
 * @method curveVertex
 * @param {Number} x x-coordinate of the vertex
 * @param {Number} y y-coordinate of the vertex
 * @chainable
 * @example
 * <div>
 * <code>
 * noFill();
 * beginShape();
 * curveVertex(84, 91);
 * curveVertex(84, 91);
 * curveVertex(68, 19);
 * curveVertex(21, 17);
 * curveVertex(32, 100);
 * curveVertex(32, 100);
 * endShape();
 * </code>
 * </div>
 *
 * @alt
 * Upside-down u-shape line, mid canvas. left point extends beyond canvas view.
 *
 */
p5.prototype.curveVertex = function(x, y) {
  p5._validateParameters('curveVertex', arguments);
  isCurve = true;
  this.vertex(x, y);
  return this;
};

/**
 * Use the beginContour() and endContour() functions to create negative
 * shapes within shapes such as the center of the letter 'O'. beginContour()
 * begins recording vertices for the shape and endContour() stops recording.
 * The vertices that define a negative shape must "wind" in the opposite
 * direction from the exterior shape. First draw vertices for the exterior
 * clockwise order, then for internal shapes, draw vertices
 * shape in counter-clockwise.
 * <br><br>
 * These functions can only be used within a beginShape()/endShape() pair and
 * transformations such as translate(), rotate(), and scale() do not work
 * within a beginContour()/endContour() pair. It is also not possible to use
 * other shapes, such as ellipse() or rect() within.
 *
 * @method endContour
 * @chainable
 * @example
 * <div>
 * <code>
 * translate(50, 50);
 * stroke(255, 0, 0);
 * beginShape();
 * // Exterior part of shape, clockwise winding
 * vertex(-40, -40);
 * vertex(40, -40);
 * vertex(40, 40);
 * vertex(-40, 40);
 * // Interior part of shape, counter-clockwise winding
 * beginContour();
 * vertex(-20, -20);
 * vertex(-20, 20);
 * vertex(20, 20);
 * vertex(20, -20);
 * endContour();
 * endShape(CLOSE);
 * </code>
 * </div>
 *
 * @alt
 * white rect and smaller grey rect with red outlines in center of canvas.
 *
 */
p5.prototype.endContour = function() {
  var vert = contourVertices[0].slice(); // copy all data
  vert.isVert = contourVertices[0].isVert;
  vert.moveTo = false;
  contourVertices.push(vert);

  // prevent stray lines with multiple contours
  if (isFirstContour) {
    vertices.push(vertices[0]);
    isFirstContour = false;
  }

  for (var i = 0; i < contourVertices.length; i++) {
    vertices.push(contourVertices[i]);
  }
  return this;
};

/**
 * The endShape() function is the companion to beginShape() and may only be
 * called after beginShape(). When endshape() is called, all of image data
 * defined since the previous call to beginShape() is written into the image
 * buffer. The constant CLOSE as the value for the MODE parameter to close
 * the shape (to connect the beginning and the end).
 *
 * @method endShape
 * @param  {Constant} [mode] use CLOSE to close the shape
 * @chainable
 * @example
 * <div>
 * <code>
 * noFill();
 *
 * beginShape();
 * vertex(20, 20);
 * vertex(45, 20);
 * vertex(45, 80);
 * endShape(CLOSE);
 *
 * beginShape();
 * vertex(50, 20);
 * vertex(75, 20);
 * vertex(75, 80);
 * endShape();
 * </code>
 * </div>
 *
 * @alt
 * Triangle line shape with smallest interior angle on bottom and upside-down L.
 *
 */
p5.prototype.endShape = function(mode) {
  if (this._renderer.isP3D) {
    this._renderer.endShape(
      mode,
      isCurve,
      isBezier,
      isQuadratic,
      isContour,
      shapeKind
    );
  } else {
    if (vertices.length === 0) {
      return this;
    }
    if (!this._renderer._doStroke && !this._renderer._doFill) {
      return this;
    }

    var closeShape = mode === constants.CLOSE;

    // if the shape is closed, the first element is also the last element
    if (closeShape && !isContour) {
      vertices.push(vertices[0]);
    }

    this._renderer.endShape(
      mode,
      vertices,
      isCurve,
      isBezier,
      isQuadratic,
      isContour,
      shapeKind
    );

    // Reset some settings
    isCurve = false;
    isBezier = false;
    isQuadratic = false;
    isContour = false;
    isFirstContour = true;

    // If the shape is closed, the first element was added as last element.
    // We must remove it again to prevent the list of vertices from growing
    // over successive calls to endShape(CLOSE)
    if (closeShape) {
      vertices.pop();
    }
  }
  return this;
};

/**
 * Specifies vertex coordinates for quadratic Bezier curves. Each call to
 * quadraticVertex() defines the position of one control points and one
 * anchor point of a Bezier curve, adding a new segment to a line or shape.
 * The first time quadraticVertex() is used within a beginShape() call, it
 * must be prefaced with a call to vertex() to set the first anchor point.
 * This function must be used between beginShape() and endShape() and only
 * when there is no MODE parameter specified to beginShape().
 *
 * @method quadraticVertex
 * @param  {Number} cx x-coordinate for the control point
 * @param  {Number} cy y-coordinate for the control point
 * @param  {Number} x3 x-coordinate for the anchor point
 * @param  {Number} y3 y-coordinate for the anchor point
 * @chainable
 * @example
 * <div>
 * <code>
 * noFill();
 * strokeWeight(4);
 * beginShape();
 * vertex(20, 20);
 * quadraticVertex(80, 20, 50, 50);
 * endShape();
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * noFill();
 * strokeWeight(4);
 * beginShape();
 * vertex(20, 20);
 * quadraticVertex(80, 20, 50, 50);
 * quadraticVertex(20, 80, 80, 80);
 * vertex(80, 60);
 * endShape();
 * </code>
 * </div>
 *
 * @alt
 * arched-shaped black line with 4 pixel thick stroke weight.
 * backwards s-shaped black line with 4 pixel thick stroke weight.
 *
 */
p5.prototype.quadraticVertex = function(cx, cy, x3, y3) {
  p5._validateParameters('quadraticVertex', arguments);
  //if we're drawing a contour, put the points into an
  // array for inside drawing
  if (this._contourInited) {
    var pt = {};
    pt.x = cx;
    pt.y = cy;
    pt.x3 = x3;
    pt.y3 = y3;
    pt.type = constants.QUADRATIC;
    this._contourVertices.push(pt);

    return this;
  }
  if (vertices.length > 0) {
    isQuadratic = true;
    var vert = [];
    for (var i = 0; i < arguments.length; i++) {
      vert[i] = arguments[i];
    }
    vert.isVert = false;
    if (isContour) {
      contourVertices.push(vert);
    } else {
      vertices.push(vert);
    }
  } else {
    throw 'vertex() must be used once before calling quadraticVertex()';
  }
  return this;
};

/**
 * All shapes are constructed by connecting a series of vertices. vertex()
 * is used to specify the vertex coordinates for points, lines, triangles,
 * quads, and polygons. It is used exclusively within the beginShape() and
 * endShape() functions.
 *
 * @method vertex
 * @param  {Number} x x-coordinate of the vertex
 * @param  {Number} y y-coordinate of the vertex
 * @chainable
 * @example
 * <div>
 * <code>
 * beginShape(POINTS);
 * vertex(30, 20);
 * vertex(85, 20);
 * vertex(85, 75);
 * vertex(30, 75);
 * endShape();
 * </code>
 * </div>
 *
 * @alt
 * 4 black points in a square shape in middle-right of canvas.
 *
 */
/**
 * @method vertex
 * @param  {Number} x
 * @param  {Number} y
 * @param  {Number} [z] z-coordinate of the vertex
 * @param  {Number} [u] the vertex's texture u-coordinate
 * @param  {Number} [v] the vertex's texture v-coordinate
 */
p5.prototype.vertex = function(x, y, moveTo, u, v) {
  if (this._renderer.isP3D) {
    this._renderer.vertex.apply(this._renderer, arguments);
  } else {
    var vert = [];
    vert.isVert = true;
    vert[0] = x;
    vert[1] = y;
    vert[2] = 0;
    vert[3] = 0;
    vert[4] = 0;
    vert[5] = this._renderer._getFill();
    vert[6] = this._renderer._getStroke();

    if (moveTo) {
      vert.moveTo = moveTo;
    }
    if (isContour) {
      if (contourVertices.length === 0) {
        vert.moveTo = true;
      }
      contourVertices.push(vert);
    } else {
      vertices.push(vert);
    }
  }
  return this;
};

module.exports = p5;

},{"./constants":21,"./core":22}],36:[function(_dereq_,module,exports){
/**
 * @module Data
 * @submodule Dictionary
 * @for p5.TypedDict
 * @requires core
 *
 * This module defines the p5 methods for the p5 Dictionary classes
 * these classes StringDict and NumberDict are for storing and working
 * with key, value pairs
 */

'use strict';

var p5 = _dereq_('../core/core');

/**
 *
 * Creates a new instance of p5.StringDict using the key, value pair
 * or object you provide.
 *
 * @method createStringDict
 * @for p5
 * @param {String|Object} key or object
 * @param {String} value
 * @return {p5.StringDict}
 *
 * @example
 * <div class="norender">
 * <code>
 * function setup() {
 *   var myDictionary = createStringDict('p5', 'js');
 *   print(myDictionary.hasKey('p5')); // logs true to console
 * }
 * </code></div>
 */

p5.prototype.createStringDict = function(key, value) {
  return new p5.StringDict(key, value);
};

/**
 *
 * Creates a new instance of p5.NumberDict using the key, value pair
 * or object you provide.
 *
 * @method createNumberDict
 * @for p5
 * @param {Number|Object} key or object
 * @param {Number} value
 * @return {p5.NumberDict}
 *
 * @example
 * <div class="norender">
 * <code>
 * function setup() {
 *   var myDictionary = createNumberDict('p5', 42);
 *   print(myDictionary.hasKey('p5')); // logs true to console
 * }
 * </code></div>
 */

p5.prototype.createNumberDict = function(key, value) {
  return new p5.NumberDict(key, value);
};

/**
 *
 * Base class for all p5.Dictionary types. More specifically
 * typed Dictionary objects inherit from this
 *
 * @class p5.TypedDict
 * @constructor
 *
 */

p5.TypedDict = function(key, value) {
  if (key instanceof Object) {
    this.data = key;
  } else {
    this.data = {};
    this.data[key] = value;
  }
  return this;
};

/**
 * Returns the number of key-value pairs currently in Dictionary object
 *
 * @method size
 * @return {Integer} the number of key-value pairs in Dictionary object
 *
 * @example
 * <div class="norender">
 * <code>
 * function setup() {
 *   var myDictionary = createNumberDict(1, 10);
 *   myDictionary.create(2, 20);
 *   myDictionary.create(3, 30);
 *   print(myDictionary.size()); // value of amt is 3
 * }
 * </code></div>
 *
 */
p5.TypedDict.prototype.size = function() {
  return Object.keys(this.data).length;
};

/**
 * Returns true if key exists in Dictionary
 * otherwise returns false
 *
 * @method hasKey
 * @param {Number|String} key that you want to access
 * @return {Boolean} whether that key exists in Dictionary
 *
 * @example
 * <div class="norender">
 * <code>
 * function setup() {
 *   var myDictionary = createStringDict('p5', 'js');
 *   print(myDictionary.hasKey('p5')); // logs true to console
 * }
 * </code></div>
 *
 */

p5.TypedDict.prototype.hasKey = function(key) {
  return this.data.hasOwnProperty(key);
};

/**
 * Returns value stored at supplied key.
 *
 * @method get
 * @param {Number|String} key that you want to access
 * @return {Number|String} the value stored at that key
 *
 * @example
 * <div class="norender">
 * <code>
 * function setup() {
 *   var myDictionary = createStringDict('p5', 'js');
 *   var myValue = myDictionary.get('p5');
 *   print(myValue === 'js'); // logs true to console
 * }
 * </code></div>
 *
 */

p5.TypedDict.prototype.get = function(key) {
  if (this.data.hasOwnProperty(key)) {
    return this.data[key];
  } else {
    console.log(key + ' does not exist in this Dictionary');
  }
};

/**
 * Changes the value of key if in it already exists in
 * in the Dictionary otherwise makes a new key-value pair
 *
 * @method set
 * @param {Number|String} key
 * @param {Number|String} value
 *
 * @example
 * <div class="norender">
 * <code>
 * function setup() {
 *   var myDictionary = createStringDict('p5', 'js');
 *   myDictionary.set('p5', 'JS');
 *   myDictionary.print();
 *   // above logs "key: p5 - value: JS" to console
 * }
 * </code></div>
 *
 */

p5.TypedDict.prototype.set = function(key, value) {
  if (this._validate(value)) {
    this.data[key] = value;
  } else {
    console.log('Those values dont work for this dictionary type.');
  }
};

/**
 * private helper function to handle the user passing objects in
 * during construction or calls to create()
 */

p5.TypedDict.prototype._addObj = function(obj) {
  for (var key in obj) {
    this.set(key, obj[key]);
  }
};

/**
 * Creates a key-value pair in the Dictionary
 *
 * @method create
 * @param {Number|String} key
 * @param {Number|String} value
 *
 * @example
 * <div class="norender">
 * <code>
 * function setup() {
 *   var myDictionary = createStringDict('p5', 'js');
 *   myDictionary.create('happy', 'coding');
 *   myDictionary.print();
 *   // above logs "key: p5 - value: js, key: happy - value: coding" to console
 * }
 * </code></div>
 */
/**
 * @method create
 * @param {Object} obj key/value pair
 */

p5.TypedDict.prototype.create = function(key, value) {
  if (key instanceof Object && typeof value === 'undefined') {
    this._addObj(key);
  } else if (typeof key !== 'undefined') {
    this.set(key, value);
  } else {
    console.log(
      'In order to create a new Dictionary entry you must pass ' +
        'an object or a key, value pair'
    );
  }
};

/**
 * Empties Dictionary of all key-value pairs
 * @method clear
 * @example
 * <div class="norender">
 * <code>
 * function setup() {
 *   var myDictionary = createStringDict('p5', 'js');
 *   print(myDictionary.hasKey('p5')); // prints 'true'
 *   myDictionary.clear();
 *   print(myDictionary.hasKey('p5')); // prints 'false'
 * }
 * </code>
 * </div>
 */

p5.TypedDict.prototype.clear = function() {
  this.data = {};
};

/**
 * Removes a key-value pair in the Dictionary
 *
 * @method remove
 * @param {Number|String} key for the pair to remove
 *
 * @example
 * <div class="norender">
 * <code>
 * function setup() {
 *   var myDictionary = createStringDict('p5', 'js');
 *   myDictionary.create('happy', 'coding');
 *   myDictionary.print();
 *   // above logs "key: p5 - value: js, key: happy - value: coding" to console
 *   myDictionary.remove('p5');
 *   myDictionary.print();
 *   // above logs "key: happy value: coding" to console
 * }
 * </code></div>
 *
 */

p5.TypedDict.prototype.remove = function(key) {
  if (this.data.hasOwnProperty(key)) {
    delete this.data[key];
  } else {
    throw key + ' does not exist in this Dictionary';
  }
};

/**
 * Logs the list of items currently in the Dictionary to the console
 *
 * @method print
 *
 * @example
 * <div class="norender">
 * <code>
 * function setup() {
 *   var myDictionary = createStringDict('p5', 'js');
 *   myDictionary.create('happy', 'coding');
 *   myDictionary.print();
 *   // above logs "key: p5 - value: js, key: happy - value: coding" to console
 * }
 * </code>
 * </div>
 */

p5.TypedDict.prototype.print = function() {
  for (var item in this.data) {
    console.log('key:' + item + ' value:' + this.data[item]);
  }
};

/**
 * Converts the Dictionary into a CSV file for local
 * storage.
 *
 * @method saveTable
 * @example
 * <div>
 * <code>
 * createButton('save')
 *   .position(10, 10)
 *   .mousePressed(function() {
 *     createNumberDict({
 *       john: 1940,
      paul: 1942,
      george: 1943,
      ringo: 1940
 *     }).saveTable('beatles');
 *   });
 * </code>
 * </div>
 */

p5.TypedDict.prototype.saveTable = function(filename) {
  var output = '';

  for (var key in this.data) {
    output += key + ',' + this.data[key] + '\n';
  }

  var blob = new Blob([output], { type: 'text/csv' });
  p5.prototype.downloadFile(blob, filename || 'mycsv', 'csv');
};

/**
 * Converts the Dictionary into a JSON file for local
 * storage.
 *
 * @method saveJSON
 * @example
 * <div>
 * <code>
 * createButton('save')
 *   .position(10, 10)
 *   .mousePressed(function() {
 *     createNumberDict({
 *       john: 1940,
      paul: 1942,
      george: 1943,
      ringo: 1940
 *     }).saveJSON('beatles');
 *   });
 * </code>
 * </div>
 */

p5.TypedDict.prototype.saveJSON = function(filename, opt) {
  p5.prototype.saveJSON(this.data, filename, opt);
};

/**
 * private helper function to ensure that the user passed in valid
 * values for the Dictionary type
 */

p5.TypedDict.prototype._validate = function(value) {
  return true;
};

/**
 *
 * A  Dictionary class for Strings.
 *
 *
 * @class p5.StringDict
 * @constructor
 * @extends p5.TypedDict
 *
 */

p5.StringDict = function() {
  p5.TypedDict.apply(this, arguments);
};

p5.StringDict.prototype = Object.create(p5.TypedDict.prototype);

p5.StringDict.prototype._validate = function(value) {
  return typeof value === 'string';
};

/**
 *
 * A simple Dictionary class for Numbers.
 *
 *
 * @class p5.NumberDict
 * @constructor
 * @extends p5.TypedDict
 *
 */

p5.NumberDict = function() {
  p5.TypedDict.apply(this, arguments);
};

p5.NumberDict.prototype = Object.create(p5.TypedDict.prototype);

/**
 * private helper function to ensure that the user passed in valid
 * values for the Dictionary type
 */

p5.NumberDict.prototype._validate = function(value) {
  return typeof value === 'number';
};

/**
 * Add to a value stored at a certain key
 * The sum is stored in that location in the Dictionary.
 *
 * @method add
 * @param {Number} Key for value you wish to add to
 * @param {Number} Amount to add to the value
 * @example
 * <div class='norender'>
 * <code>
 * function setup() {
 *   var myDictionary = createNumberDict(2, 5);
 *   myDictionary.add(2, 2);
 *   console.log(myDictionary.get(2)); // logs 7 to console.
 * }
 * </code></div>
 *
 *
 */

p5.NumberDict.prototype.add = function(key, amount) {
  if (this.data.hasOwnProperty(key)) {
    this.data[key] += amount;
  } else {
    console.log('The key - ' + key + ' does not exist in this dictionary.');
  }
};

/**
 * Subtract from a value stored at a certain key
 * The difference is stored in that location in the Dictionary.
 *
 * @method sub
 * @param {Number} Key for value you wish to subtract from
 * @param {Number} Amount to subtract from the value
 * @example
 * <div class='norender'>
 * <code>
 * function setup() {
 *   var myDictionary = createNumberDict(2, 5);
 *   myDictionary.sub(2, 2);
 *   console.log(myDictionary.get(2)); // logs 3 to console.
 * }
 * </code></div>
 *
 *
 */

p5.NumberDict.prototype.sub = function(key, amount) {
  this.add(key, -amount);
};

/**
 * Multiply a value stored at a certain key
 * The product is stored in that location in the Dictionary.
 *
 * @method mult
 * @param {Number} Key for value you wish to multiply
 * @param {Number} Amount to multiply the value by
 * @example
 * <div class='norender'>
 * <code>
 * function setup() {
 *   var myDictionary = createNumberDict(2, 4);
 *   myDictionary.mult(2, 2);
 *   console.log(myDictionary.get(2)); // logs 8 to console.
 * }
 * </code></div>
 *
 *
 */

p5.NumberDict.prototype.mult = function(key, amount) {
  if (this.data.hasOwnProperty(key)) {
    this.data[key] *= amount;
  } else {
    console.log('The key - ' + key + ' does not exist in this dictionary.');
  }
};

/**
 * Divide a value stored at a certain key
 * The quotient is stored in that location in the Dictionary.
 *
 * @method div
 * @param {Number} Key for value you wish to divide
 * @param {Number} Amount to divide the value by
 * @example
 * <div class='norender'>
 * <code>
 * function setup() {
 *   var myDictionary = createNumberDict(2, 8);
 *   myDictionary.div(2, 2);
 *   console.log(myDictionary.get(2)); // logs 4 to console.
 * }
 * </code></div>
 *
 *
 */

p5.NumberDict.prototype.div = function(key, amount) {
  if (this.data.hasOwnProperty(key)) {
    this.data[key] /= amount;
  } else {
    console.log('The key - ' + key + ' does not exist in this dictionary.');
  }
};

/**
 * private helper function for finding lowest or highest value
 * the argument 'flip' is used to flip the comparison arrow
 * from 'less than' to 'greater than'
 *
 */

p5.NumberDict.prototype._valueTest = function(flip) {
  if (Object.keys(this.data).length === 0) {
    throw 'Unable to search for a minimum or maximum value on an empty NumberDict';
  } else if (Object.keys(this.data).length === 1) {
    return this.data[Object.keys(this.data)[0]];
  } else {
    var result = this.data[Object.keys(this.data)[0]];
    for (var key in this.data) {
      if (this.data[key] * flip < result * flip) {
        result = this.data[key];
      }
    }
    return result;
  }
};

/**
 * Return the lowest value.
 *
 * @method minValue
 * @return {Number}
 * @example
 * <div class='norender'>
 * <code>
 * function setup() {
 *   var myDictionary = createNumberDict({ 2: -10, 4: 0.65, 1.2: 3 });
 *   var lowestValue = myDictionary.minValue(); // value is -10
 *   print(lowestValue);
 * }
 * </code></div>
 *
 */

p5.NumberDict.prototype.minValue = function() {
  return this._valueTest(1);
};

/**
 * Return the highest value.
 *
 * @method maxValue
 * @return {Number}
 * @example
 * <div class='norender'>
 * <code>
 * function setup() {
 *   var myDictionary = createNumberDict({ 2: -10, 4: 0.65, 1.2: 3 });
 *   var highestValue = myDictionary.maxValue(); // value is 3
 *   print(highestValue);
 * }
 * </code></div>
 *
 */

p5.NumberDict.prototype.maxValue = function() {
  return this._valueTest(-1);
};

/**
 * private helper function for finding lowest or highest key
 * the argument 'flip' is used to flip the comparison arrow
 * from 'less than' to 'greater than'
 *
 */

p5.NumberDict.prototype._keyTest = function(flip) {
  if (Object.keys(this.data).length === 0) {
    throw 'Unable to use minValue on an empty NumberDict';
  } else if (Object.keys(this.data).length === 1) {
    return Object.keys(this.data)[0];
  } else {
    var result = Object.keys(this.data)[0];
    for (var i = 1; i < Object.keys(this.data).length; i++) {
      if (Object.keys(this.data)[i] * flip < result * flip) {
        result = Object.keys(this.data)[i];
      }
    }
    return result;
  }
};

/**
 * Return the lowest key.
 *
 * @method minKey
 * @return {Number}
 * @example
 * <div class='norender'>
 * <code>
 * function setup() {
 *   var myDictionary = createNumberDict({ 2: 4, 4: 6, 1.2: 3 });
 *   var lowestKey = myDictionary.minKey(); // value is 1.2
 *   print(lowestKey);
 * }
 * </code></div>
 *
 */

p5.NumberDict.prototype.minKey = function() {
  return this._keyTest(1);
};

/**
 * Return the highest key.
 *
 * @method maxKey
 * @return {Number}
 * @example
 * <div class='norender'>
 * <code>
 * function setup() {
 *   var myDictionary = createNumberDict({ 2: 4, 4: 6, 1.2: 3 });
 *   var highestKey = myDictionary.maxKey(); // value is 4
 *   print(highestKey);
 * }
 * </code></div>
 *
 */

p5.NumberDict.prototype.maxKey = function() {
  return this._keyTest(-1);
};

module.exports = p5.TypedDict;

},{"../core/core":22}],37:[function(_dereq_,module,exports){
/**
 * @module Events
 * @submodule Acceleration
 * @for p5
 * @requires core
 */

'use strict';

var p5 = _dereq_('../core/core');

/**
 * The system variable deviceOrientation always contains the orientation of
 * the device. The value of this variable will either be set 'landscape'
 * or 'portrait'. If no data is available it will be set to 'undefined'.
 * either LANDSCAPE or PORTRAIT.
 *
 * @property {Constant} deviceOrientation
 * @readOnly
 */
p5.prototype.deviceOrientation = undefined;

/**
 * The system variable accelerationX always contains the acceleration of the
 * device along the x axis. Value is represented as meters per second squared.
 *
 * @property {Number} accelerationX
 * @readOnly
 */
p5.prototype.accelerationX = 0;

/**
 * The system variable accelerationY always contains the acceleration of the
 * device along the y axis. Value is represented as meters per second squared.
 *
 * @property {Number} accelerationY
 * @readOnly
 */
p5.prototype.accelerationY = 0;

/**
 * The system variable accelerationZ always contains the acceleration of the
 * device along the z axis. Value is represented as meters per second squared.
 *
 * @property {Number} accelerationZ
 * @readOnly
 */
p5.prototype.accelerationZ = 0;

/**
 * The system variable pAccelerationX always contains the acceleration of the
 * device along the x axis in the frame previous to the current frame. Value
 * is represented as meters per second squared.
 *
 * @property {Number} pAccelerationX
 * @readOnly
 */
p5.prototype.pAccelerationX = 0;

/**
 * The system variable pAccelerationY always contains the acceleration of the
 * device along the y axis in the frame previous to the current frame. Value
 * is represented as meters per second squared.
 *
 * @property {Number} pAccelerationY
 * @readOnly
 */
p5.prototype.pAccelerationY = 0;

/**
 * The system variable pAccelerationZ always contains the acceleration of the
 * device along the z axis in the frame previous to the current frame. Value
 * is represented as meters per second squared.
 *
 * @property {Number} pAccelerationZ
 * @readOnly
 */
p5.prototype.pAccelerationZ = 0;

/**
 * _updatePAccelerations updates the pAcceleration values
 *
 * @private
 */
p5.prototype._updatePAccelerations = function() {
  this._setProperty('pAccelerationX', this.accelerationX);
  this._setProperty('pAccelerationY', this.accelerationY);
  this._setProperty('pAccelerationZ', this.accelerationZ);
};

/**
 * The system variable rotationX always contains the rotation of the
 * device along the x axis. Value is represented as 0 to +/-180 degrees.
 * <br><br>
 * Note: The order the rotations are called is important, ie. if used
 * together, it must be called in the order Z-X-Y or there might be
 * unexpected behaviour.
 *
 * @example
 * <div>
 * <code>
 * function setup() {
 *   createCanvas(100, 100, WEBGL);
 * }
 *
 * function draw() {
 *   background(200);
 *   //rotateZ(radians(rotationZ));
 *   rotateX(radians(rotationX));
 *   //rotateY(radians(rotationY));
 *   box(200, 200, 200);
 * }
 * </code>
 * </div>
 *
 * @property {Number} rotationX
 * @readOnly
 *
 * @alt
 * red horizontal line right, green vertical line bottom. black background.
 *
 */
p5.prototype.rotationX = 0;

/**
 * The system variable rotationY always contains the rotation of the
 * device along the y axis. Value is represented as 0 to +/-90 degrees.
 * <br><br>
 * Note: The order the rotations are called is important, ie. if used
 * together, it must be called in the order Z-X-Y or there might be
 * unexpected behaviour.
 *
 * @example
 * <div>
 * <code>
 * function setup() {
 *   createCanvas(100, 100, WEBGL);
 * }
 *
 * function draw() {
 *   background(200);
 *   //rotateZ(radians(rotationZ));
 *   //rotateX(radians(rotationX));
 *   rotateY(radians(rotationY));
 *   box(200, 200, 200);
 * }
 * </code>
 * </div>
 *
 * @property {Number} rotationY
 * @readOnly
 *
 * @alt
 * red horizontal line right, green vertical line bottom. black background.
 */
p5.prototype.rotationY = 0;

/**
 * The system variable rotationZ always contains the rotation of the
 * device along the z axis. Value is represented as 0 to 359 degrees.
 * <br><br>
 * Unlike rotationX and rotationY, this variable is available for devices
 * with a built-in compass only.
 * <br><br>
 * Note: The order the rotations are called is important, ie. if used
 * together, it must be called in the order Z-X-Y or there might be
 * unexpected behaviour.
 *
 * @example
 * <div>
 * <code>
 * function setup() {
 *   createCanvas(100, 100, WEBGL);
 * }
 *
 * function draw() {
 *   background(200);
 *   rotateZ(radians(rotationZ));
 *   //rotateX(radians(rotationX));
 *   //rotateY(radians(rotationY));
 *   box(200, 200, 200);
 * }
 * </code>
 * </div>
 *
 * @property {Number} rotationZ
 * @readOnly
 *
 * @alt
 * red horizontal line right, green vertical line bottom. black background.
 */
p5.prototype.rotationZ = 0;

/**
 * The system variable pRotationX always contains the rotation of the
 * device along the x axis in the frame previous to the current frame. Value
 * is represented as 0 to +/-180 degrees.
 * <br><br>
 * pRotationX can also be used with rotationX to determine the rotate
 * direction of the device along the X-axis.
 * @example
 * <div class='norender'>
 * <code>
 * // A simple if statement looking at whether
 * // rotationX - pRotationX < 0 is true or not will be
 * // sufficient for determining the rotate direction
 * // in most cases.
 *
 * // Some extra logic is needed to account for cases where
 * // the angles wrap around.
 * var rotateDirection = 'clockwise';
 *
 * // Simple range conversion to make things simpler.
 * // This is not absolutely necessary but the logic
 * // will be different in that case.
 *
 * var rX = rotationX + 180;
 * var pRX = pRotationX + 180;
 *
 * if ((rX - pRX > 0 && rX - pRX < 270) || rX - pRX < -270) {
 *   rotateDirection = 'clockwise';
 * } else if (rX - pRX < 0 || rX - pRX > 270) {
 *   rotateDirection = 'counter-clockwise';
 * }
 *
 * print(rotateDirection);
 * </code>
 * </div>
 *
 * @alt
 * no image to display.
 *
 *
 * @property {Number} pRotationX
 * @readOnly
 */
p5.prototype.pRotationX = 0;

/**
 * The system variable pRotationY always contains the rotation of the
 * device along the y axis in the frame previous to the current frame. Value
 * is represented as 0 to +/-90 degrees.
 * <br><br>
 * pRotationY can also be used with rotationY to determine the rotate
 * direction of the device along the Y-axis.
 * @example
 * <div class='norender'>
 * <code>
 * // A simple if statement looking at whether
 * // rotationY - pRotationY < 0 is true or not will be
 * // sufficient for determining the rotate direction
 * // in most cases.
 *
 * // Some extra logic is needed to account for cases where
 * // the angles wrap around.
 * var rotateDirection = 'clockwise';
 *
 * // Simple range conversion to make things simpler.
 * // This is not absolutely necessary but the logic
 * // will be different in that case.
 *
 * var rY = rotationY + 180;
 * var pRY = pRotationY + 180;
 *
 * if ((rY - pRY > 0 && rY - pRY < 270) || rY - pRY < -270) {
 *   rotateDirection = 'clockwise';
 * } else if (rY - pRY < 0 || rY - pRY > 270) {
 *   rotateDirection = 'counter-clockwise';
 * }
 * print(rotateDirection);
 * </code>
 * </div>
 *
 * @alt
 * no image to display.
 *
 *
 * @property {Number} pRotationY
 * @readOnly
 */
p5.prototype.pRotationY = 0;

/**
 * The system variable pRotationZ always contains the rotation of the
 * device along the z axis in the frame previous to the current frame. Value
 * is represented as 0 to 359 degrees.
 * <br><br>
 * pRotationZ can also be used with rotationZ to determine the rotate
 * direction of the device along the Z-axis.
 * @example
 * <div class='norender'>
 * <code>
 * // A simple if statement looking at whether
 * // rotationZ - pRotationZ < 0 is true or not will be
 * // sufficient for determining the rotate direction
 * // in most cases.
 *
 * // Some extra logic is needed to account for cases where
 * // the angles wrap around.
 * var rotateDirection = 'clockwise';
 *
 * if (
 *   (rotationZ - pRotationZ > 0 && rotationZ - pRotationZ < 270) ||
 *   rotationZ - pRotationZ < -270
 * ) {
 *   rotateDirection = 'clockwise';
 * } else if (rotationZ - pRotationZ < 0 || rotationZ - pRotationZ > 270) {
 *   rotateDirection = 'counter-clockwise';
 * }
 * print(rotateDirection);
 * </code>
 * </div>
 *
 * @alt
 * no image to display.
 *
 *
 * @property {Number} pRotationZ
 * @readOnly
 */
p5.prototype.pRotationZ = 0;

var startAngleX = 0;
var startAngleY = 0;
var startAngleZ = 0;

var rotateDirectionX = 'clockwise';
var rotateDirectionY = 'clockwise';
var rotateDirectionZ = 'clockwise';

var pRotateDirectionX;
var pRotateDirectionY;
var pRotateDirectionZ;

p5.prototype._updatePRotations = function() {
  this._setProperty('pRotationX', this.rotationX);
  this._setProperty('pRotationY', this.rotationY);
  this._setProperty('pRotationZ', this.rotationZ);
};

/**
 * @property {String} turnAxis
 * @readOnly
 */
p5.prototype.turnAxis = undefined;

var move_threshold = 0.5;
var shake_threshold = 30;

/**
 * The setMoveThreshold() function is used to set the movement threshold for
 * the deviceMoved() function. The default threshold is set to 0.5.
 *
 * @method setMoveThreshold
 * @param {number} value The threshold value
 */
p5.prototype.setMoveThreshold = function(val) {
  if (typeof val === 'number') {
    move_threshold = val;
  }
};

/**
 * The setShakeThreshold() function is used to set the movement threshold for
 * the deviceShaken() function. The default threshold is set to 30.
 *
 * @method setShakeThreshold
 * @param {number} value The threshold value
 */
p5.prototype.setShakeThreshold = function(val) {
  if (typeof val === 'number') {
    shake_threshold = val;
  }
};

/**
 * The deviceMoved() function is called when the device is moved by more than
 * the threshold value along X, Y or Z axis. The default threshold is set to
 * 0.5.
 * @method deviceMoved
 * @example
 * <div class="norender">
 * <code>
 * // Run this example on a mobile device
 * // Move the device around
 * // to change the value.
 *
 * var value = 0;
 * function draw() {
 *   fill(value);
 *   rect(25, 25, 50, 50);
 * }
 * function deviceMoved() {
 *   value = value + 5;
 *   if (value > 255) {
 *     value = 0;
 *   }
 * }
 * </code>
 * </div>
 *
 * @alt
 * 50x50 black rect in center of canvas. turns white on mobile when device moves
 *
 */

/**
 * The deviceTurned() function is called when the device rotates by
 * more than 90 degrees continuously.
 * <br><br>
 * The axis that triggers the deviceTurned() method is stored in the turnAxis
 * variable. The deviceTurned() method can be locked to trigger on any axis:
 * X, Y or Z by comparing the turnAxis variable to 'X', 'Y' or 'Z'.
 *
 * @method deviceTurned
 * @example
 * <div class="norender">
 * <code>
 * // Run this example on a mobile device
 * // Rotate the device by 90 degrees
 * // to change the value.
 *
 * var value = 0;
 * function draw() {
 *   fill(value);
 *   rect(25, 25, 50, 50);
 * }
 * function deviceTurned() {
 *   if (value === 0) {
 *     value = 255;
 *   } else if (value === 255) {
 *     value = 0;
 *   }
 * }
 * </code>
 * </div>
 * <div>
 * <code>
 * // Run this example on a mobile device
 * // Rotate the device by 90 degrees in the
 * // X-axis to change the value.
 *
 * var value = 0;
 * function draw() {
 *   fill(value);
 *   rect(25, 25, 50, 50);
 * }
 * function deviceTurned() {
 *   if (turnAxis === 'X') {
 *     if (value === 0) {
 *       value = 255;
 *     } else if (value === 255) {
 *       value = 0;
 *     }
 *   }
 * }
 * </code>
 * </div>
 *
 * @alt
 * 50x50 black rect in center of canvas. turns white on mobile when device turns
 * 50x50 black rect in center of canvas. turns white on mobile when x-axis turns
 *
 */

/**
 * The deviceShaken() function is called when the device total acceleration
 * changes of accelerationX and accelerationY values is more than
 * the threshold value. The default threshold is set to 30.
 * @method deviceShaken
 * @example
 * <div class="norender">
 * <code>
 * // Run this example on a mobile device
 * // Shake the device to change the value.
 *
 * var value = 0;
 * function draw() {
 *   fill(value);
 *   rect(25, 25, 50, 50);
 * }
 * function deviceShaken() {
 *   value = value + 5;
 *   if (value > 255) {
 *     value = 0;
 *   }
 * }
 * </code>
 * </div>
 *
 * @alt
 * 50x50 black rect in center of canvas. turns white on mobile when device shakes
 *
 */

p5.prototype._ondeviceorientation = function(e) {
  this._updatePRotations();
  this._setProperty('rotationX', e.beta);
  this._setProperty('rotationY', e.gamma);
  this._setProperty('rotationZ', e.alpha);
  this._handleMotion();
};
p5.prototype._ondevicemotion = function(e) {
  this._updatePAccelerations();
  this._setProperty('accelerationX', e.acceleration.x * 2);
  this._setProperty('accelerationY', e.acceleration.y * 2);
  this._setProperty('accelerationZ', e.acceleration.z * 2);
  this._handleMotion();
};
p5.prototype._handleMotion = function() {
  if (window.orientation === 90 || window.orientation === -90) {
    this._setProperty('deviceOrientation', 'landscape');
  } else if (window.orientation === 0) {
    this._setProperty('deviceOrientation', 'portrait');
  } else if (window.orientation === undefined) {
    this._setProperty('deviceOrientation', 'undefined');
  }
  var deviceMoved = this.deviceMoved || window.deviceMoved;
  if (typeof deviceMoved === 'function') {
    if (
      Math.abs(this.accelerationX - this.pAccelerationX) > move_threshold ||
      Math.abs(this.accelerationY - this.pAccelerationY) > move_threshold ||
      Math.abs(this.accelerationZ - this.pAccelerationZ) > move_threshold
    ) {
      deviceMoved();
    }
  }
  var deviceTurned = this.deviceTurned || window.deviceTurned;
  if (typeof deviceTurned === 'function') {
    // The angles given by rotationX etc is from range -180 to 180.
    // The following will convert them to 0 to 360 for ease of calculation
    // of cases when the angles wrapped around.
    // _startAngleX will be converted back at the end and updated.
    var wRX = this.rotationX + 180;
    var wPRX = this.pRotationX + 180;
    var wSAX = startAngleX + 180;
    if ((wRX - wPRX > 0 && wRX - wPRX < 270) || wRX - wPRX < -270) {
      rotateDirectionX = 'clockwise';
    } else if (wRX - wPRX < 0 || wRX - wPRX > 270) {
      rotateDirectionX = 'counter-clockwise';
    }
    if (rotateDirectionX !== pRotateDirectionX) {
      wSAX = wRX;
    }
    if (Math.abs(wRX - wSAX) > 90 && Math.abs(wRX - wSAX) < 270) {
      wSAX = wRX;
      this._setProperty('turnAxis', 'X');
      deviceTurned();
    }
    pRotateDirectionX = rotateDirectionX;
    startAngleX = wSAX - 180;

    // Y-axis is identical to X-axis except for changing some names.
    var wRY = this.rotationY + 180;
    var wPRY = this.pRotationY + 180;
    var wSAY = startAngleY + 180;
    if ((wRY - wPRY > 0 && wRY - wPRY < 270) || wRY - wPRY < -270) {
      rotateDirectionY = 'clockwise';
    } else if (wRY - wPRY < 0 || wRY - this.pRotationY > 270) {
      rotateDirectionY = 'counter-clockwise';
    }
    if (rotateDirectionY !== pRotateDirectionY) {
      wSAY = wRY;
    }
    if (Math.abs(wRY - wSAY) > 90 && Math.abs(wRY - wSAY) < 270) {
      wSAY = wRY;
      this._setProperty('turnAxis', 'Y');
      deviceTurned();
    }
    pRotateDirectionY = rotateDirectionY;
    startAngleY = wSAY - 180;

    // Z-axis is already in the range 0 to 360
    // so no conversion is needed.
    if (
      (this.rotationZ - this.pRotationZ > 0 &&
        this.rotationZ - this.pRotationZ < 270) ||
      this.rotationZ - this.pRotationZ < -270
    ) {
      rotateDirectionZ = 'clockwise';
    } else if (
      this.rotationZ - this.pRotationZ < 0 ||
      this.rotationZ - this.pRotationZ > 270
    ) {
      rotateDirectionZ = 'counter-clockwise';
    }
    if (rotateDirectionZ !== pRotateDirectionZ) {
      startAngleZ = this.rotationZ;
    }
    if (
      Math.abs(this.rotationZ - startAngleZ) > 90 &&
      Math.abs(this.rotationZ - startAngleZ) < 270
    ) {
      startAngleZ = this.rotationZ;
      this._setProperty('turnAxis', 'Z');
      deviceTurned();
    }
    pRotateDirectionZ = rotateDirectionZ;
    this._setProperty('turnAxis', undefined);
  }
  var deviceShaken = this.deviceShaken || window.deviceShaken;
  if (typeof deviceShaken === 'function') {
    var accelerationChangeX;
    var accelerationChangeY;
    // Add accelerationChangeZ if acceleration change on Z is needed
    if (this.pAccelerationX !== null) {
      accelerationChangeX = Math.abs(this.accelerationX - this.pAccelerationX);
      accelerationChangeY = Math.abs(this.accelerationY - this.pAccelerationY);
    }
    if (accelerationChangeX + accelerationChangeY > shake_threshold) {
      deviceShaken();
    }
  }
};

module.exports = p5;

},{"../core/core":22}],38:[function(_dereq_,module,exports){
/**
 * @module Events
 * @submodule Keyboard
 * @for p5
 * @requires core
 */

'use strict';

var p5 = _dereq_('../core/core');

/**
 * Holds the key codes of currently pressed keys.
 * @private
 */
var downKeys = {};

/**
 * The boolean system variable keyIsPressed is true if any key is pressed
 * and false if no keys are pressed.
 *
 * @property {Boolean} keyIsPressed
 * @readOnly
 * @example
 * <div>
 * <code>
 * function draw() {
 *   if (keyIsPressed === true) {
 *     fill(0);
 *   } else {
 *     fill(255);
 *   }
 *   rect(25, 25, 50, 50);
 * }
 * </code>
 * </div>
 *
 * @alt
 * 50x50 white rect that turns black on keypress.
 *
 */
p5.prototype.isKeyPressed = false;
p5.prototype.keyIsPressed = false; // khan

/**
 * The system variable key always contains the value of the most recent
 * key on the keyboard that was typed. To get the proper capitalization, it
 * is best to use it within keyTyped(). For non-ASCII keys, use the keyCode
 * variable.
 *
 * @property {String} key
 * @readOnly
 * @example
 * <div><code>
 * // Click any key to display it!
 * // (Not Guaranteed to be Case Sensitive)
 * function setup() {
 *   fill(245, 123, 158);
 *   textSize(50);
 * }
 *
 * function draw() {
 *   background(200);
 *   text(key, 33, 65); // Display last key pressed.
 * }
 * </code></div>
 *
 * @alt
 * canvas displays any key value that is pressed in pink font.
 *
 */
p5.prototype.key = '';

/**
 * The variable keyCode is used to detect special keys such as BACKSPACE,
 * DELETE, ENTER, RETURN, TAB, ESCAPE, SHIFT, CONTROL, OPTION, ALT, UP_ARROW,
 * DOWN_ARROW, LEFT_ARROW, RIGHT_ARROW.
 * You can also check for custom keys by looking up the keyCode of any key
 * on a site like this: <a href="http://keycode.info/">keycode.info</a>.
 *
 * @property {Integer} keyCode
 * @readOnly
 * @example
 * <div><code>
 * var fillVal = 126;
 * function draw() {
 *   fill(fillVal);
 *   rect(25, 25, 50, 50);
 * }
 *
 * function keyPressed() {
 *   if (keyCode === UP_ARROW) {
 *     fillVal = 255;
 *   } else if (keyCode === DOWN_ARROW) {
 *     fillVal = 0;
 *   }
 *   return false; // prevent default
 * }
 * </code></div>
 *
 * @alt
 * Grey rect center. turns white when up arrow pressed and black when down
 *
 */
p5.prototype.keyCode = 0;

/**
 * The keyPressed() function is called once every time a key is pressed. The
 * keyCode for the key that was pressed is stored in the keyCode variable.
 * <br><br>
 * For non-ASCII keys, use the keyCode variable. You can check if the keyCode
 * equals BACKSPACE, DELETE, ENTER, RETURN, TAB, ESCAPE, SHIFT, CONTROL,
 * OPTION, ALT, UP_ARROW, DOWN_ARROW, LEFT_ARROW, RIGHT_ARROW.
 * <br><br>
 * For ASCII keys that was pressed is stored in the key variable. However, it
 * does not distinguish between uppercase and lowercase. For this reason, it
 * is recommended to use keyTyped() to read the key variable, in which the
 * case of the variable will be distinguished.
 * <br><br>
 * Because of how operating systems handle key repeats, holding down a key
 * may cause multiple calls to keyTyped() (and keyReleased() as well). The
 * rate of repeat is set by the operating system and how each computer is
 * configured.<br><br>
 * Browsers may have different default
 * behaviors attached to various key events. To prevent any default
 * behavior for this event, add "return false" to the end of the method.
 *
 * @method keyPressed
 * @example
 * <div>
 * <code>
 * var value = 0;
 * function draw() {
 *   fill(value);
 *   rect(25, 25, 50, 50);
 * }
 * function keyPressed() {
 *   if (value === 0) {
 *     value = 255;
 *   } else {
 *     value = 0;
 *   }
 * }
 * </code>
 * </div>
 * <div>
 * <code>
 * var value = 0;
 * function draw() {
 *   fill(value);
 *   rect(25, 25, 50, 50);
 * }
 * function keyPressed() {
 *   if (keyCode === LEFT_ARROW) {
 *     value = 255;
 *   } else if (keyCode === RIGHT_ARROW) {
 *     value = 0;
 *   }
 * }
 * </code>
 * </div>
 * <div class="norender">
 * <code>
 * function keyPressed() {
 *   // Do something
 *   return false; // prevent any default behaviour
 * }
 * </code>
 * </div>
 *
 * @alt
 * black rect center. turns white when key pressed and black when released
 * black rect center. turns white when left arrow pressed and black when right.
 *
 */
p5.prototype._onkeydown = function(e) {
  if (downKeys[e.which]) {
    // prevent multiple firings
    return;
  }
  this._setProperty('isKeyPressed', true);
  this._setProperty('keyIsPressed', true);
  this._setProperty('keyCode', e.which);
  downKeys[e.which] = true;
  var key = String.fromCharCode(e.which);
  if (!key) {
    key = e.which;
  }
  this._setProperty('key', key);
  var keyPressed = this.keyPressed || window.keyPressed;
  if (typeof keyPressed === 'function' && !e.charCode) {
    var executeDefault = keyPressed(e);
    if (executeDefault === false) {
      e.preventDefault();
    }
  }
};
/**
 * The keyReleased() function is called once every time a key is released.
 * See key and keyCode for more information.<br><br>
 * Browsers may have different default
 * behaviors attached to various key events. To prevent any default
 * behavior for this event, add "return false" to the end of the method.
 *
 * @method keyReleased
 * @example
 * <div>
 * <code>
 * var value = 0;
 * function draw() {
 *   fill(value);
 *   rect(25, 25, 50, 50);
 * }
 * function keyReleased() {
 *   if (value === 0) {
 *     value = 255;
 *   } else {
 *     value = 0;
 *   }
 *   return false; // prevent any default behavior
 * }
 * </code>
 * </div>
 *
 * @alt
 * black rect center. turns white when key pressed and black when pressed again
 *
 */
p5.prototype._onkeyup = function(e) {
  var keyReleased = this.keyReleased || window.keyReleased;
  downKeys[e.which] = false;

  if (!areDownKeys()) {
    this._setProperty('isKeyPressed', false);
    this._setProperty('keyIsPressed', false);
  }

  this._setProperty('_lastKeyCodeTyped', null);

  var key = String.fromCharCode(e.which);
  if (!key) {
    key = e.which;
  }
  this._setProperty('key', key);
  this._setProperty('keyCode', e.which);
  if (typeof keyReleased === 'function') {
    var executeDefault = keyReleased(e);
    if (executeDefault === false) {
      e.preventDefault();
    }
  }
};

/**
 * The keyTyped() function is called once every time a key is pressed, but
 * action keys such as Ctrl, Shift, and Alt are ignored. The most recent
 * key pressed will be stored in the key variable.
 * <br><br>
 * Because of how operating systems handle key repeats, holding down a key
 * will cause multiple calls to keyTyped() (and keyReleased() as well). The
 * rate of repeat is set by the operating system and how each computer is
 * configured.<br><br>
 * Browsers may have different default behaviors attached to various key
 * events. To prevent any default behavior for this event, add "return false"
 * to the end of the method.
 *
 * @method keyTyped
 * @example
 * <div>
 * <code>
 * var value = 0;
 * function draw() {
 *   fill(value);
 *   rect(25, 25, 50, 50);
 * }
 * function keyTyped() {
 *   if (key === 'a') {
 *     value = 255;
 *   } else if (key === 'b') {
 *     value = 0;
 *   }
 *   // uncomment to prevent any default behavior
 *   // return false;
 * }
 * </code>
 * </div>
 *
 * @alt
 * black rect center. turns white when 'a' key typed and black when 'b' pressed
 *
 */
p5.prototype._onkeypress = function(e) {
  if (e.which === this._lastKeyCodeTyped) {
    // prevent multiple firings
    return;
  }
  this._setProperty('keyCode', e.which);
  this._setProperty('_lastKeyCodeTyped', e.which); // track last keyCode
  this._setProperty('key', String.fromCharCode(e.which));
  var keyTyped = this.keyTyped || window.keyTyped;
  if (typeof keyTyped === 'function') {
    var executeDefault = keyTyped(e);
    if (executeDefault === false) {
      e.preventDefault();
    }
  }
};
/**
 * The onblur function is called when the user is no longer focused
 * on the p5 element. Because the keyup events will not fire if the user is
 * not focused on the element we must assume all keys currently down have
 * been released.
 */
p5.prototype._onblur = function(e) {
  downKeys = {};
};

/**
 * The keyIsDown() function checks if the key is currently down, i.e. pressed.
 * It can be used if you have an object that moves, and you want several keys
 * to be able to affect its behaviour simultaneously, such as moving a
 * sprite diagonally. You can put in any number representing the keyCode of
 * the key, or use any of the variable keyCode names listed
 * <a href="http://p5js.org/reference/#p5/keyCode">here</a>.
 *
 * @method keyIsDown
 * @param {Number}          code The key to check for.
 * @return {Boolean}        whether key is down or not
 * @example
 * <div><code>
 * var x = 100;
 * var y = 100;
 *
 * function setup() {
 *   createCanvas(512, 512);
 * }
 *
 * function draw() {
 *   if (keyIsDown(LEFT_ARROW)) {
 *     x -= 5;
 *   }
 *
 *   if (keyIsDown(RIGHT_ARROW)) {
 *     x += 5;
 *   }
 *
 *   if (keyIsDown(UP_ARROW)) {
 *     y -= 5;
 *   }
 *
 *   if (keyIsDown(DOWN_ARROW)) {
 *     y += 5;
 *   }
 *
 *   clear();
 *   fill(255, 0, 0);
 *   ellipse(x, y, 50, 50);
 * }
 * </code></div>
 *
 * @alt
 * 50x50 red ellipse moves left, right, up and down with arrow presses.
 *
 */
p5.prototype.keyIsDown = function(code) {
  p5._validateParameters('keyIsDown', arguments);
  return downKeys[code];
};

/**
 * The checkDownKeys function returns a boolean true if any keys pressed
 * and a false if no keys are currently pressed.

 * Helps avoid instances where a multiple keys are pressed simultaneously and
 * releasing a single key will then switch the
 * keyIsPressed property to true.
 * @private
**/
function areDownKeys() {
  for (var key in downKeys) {
    if (downKeys.hasOwnProperty(key) && downKeys[key] === true) {
      return true;
    }
  }
  return false;
}

module.exports = p5;

},{"../core/core":22}],39:[function(_dereq_,module,exports){
/**
 * @module Events
 * @submodule Mouse
 * @for p5
 * @requires core
 * @requires constants
 */

'use strict';

var p5 = _dereq_('../core/core');
var constants = _dereq_('../core/constants');

/*
 * This is a flag which is false until the first time
 * we receive a mouse event. The pmouseX and pmouseY
 * values will match the mouseX and mouseY values until
 * this interaction takes place.
 */
p5.prototype._hasMouseInteracted = false;

/**
 * The system variable mouseX always contains the current horizontal
 * position of the mouse, relative to (0, 0) of the canvas. If touch is
 * used instead of mouse input, mouseX will hold the x value of the most
 * recent touch point.
 *
 * @property {Number} mouseX
 * @readOnly
 *
 * @example
 * <div>
 * <code>
 * // Move the mouse across the canvas
 * function draw() {
 *   background(244, 248, 252);
 *   line(mouseX, 0, mouseX, 100);
 * }
 * </code>
 * </div>
 *
 * @alt
 * horizontal black line moves left and right with mouse x-position
 *
 */
p5.prototype.mouseX = 0;

/**
 * The system variable mouseY always contains the current vertical position
 * of the mouse, relative to (0, 0) of the canvas. If touch is
 * used instead of mouse input, mouseY will hold the y value of the most
 * recent touch point.
 *
 * @property {Number} mouseY
 * @readOnly
 *
 * @example
 * <div>
 * <code>
 * // Move the mouse across the canvas
 * function draw() {
 *   background(244, 248, 252);
 *   line(0, mouseY, 100, mouseY);
 * }
 * </code>
 * </div>
 *
 * @alt
 * vertical black line moves up and down with mouse y-position
 *
 */
p5.prototype.mouseY = 0;

/**
 * The system variable pmouseX always contains the horizontal position of
 * the mouse or finger in the frame previous to the current frame, relative to
 * (0, 0) of the canvas.
 *
 * @property {Number} pmouseX
 * @readOnly
 *
 * @example
 * <div>
 * <code>
 * // Move the mouse across the canvas to leave a trail
 * function setup() {
 *   //slow down the frameRate to make it more visible
 *   frameRate(10);
 * }
 *
 * function draw() {
 *   background(244, 248, 252);
 *   line(mouseX, mouseY, pmouseX, pmouseY);
 *   print(pmouseX + ' -> ' + mouseX);
 * }
 * </code>
 * </div>
 *
 * @alt
 * line trail is created from cursor movements. faster movement make longer line.
 *
 */
p5.prototype.pmouseX = 0;

/**
 * The system variable pmouseY always contains the vertical position of the
 * mouse or finger in the frame previous to the current frame, relative to
 * (0, 0) of the canvas.
 *
 * @property {Number} pmouseY
 * @readOnly
 *
 * @example
 * <div>
 * <code>
 * function draw() {
 *   background(237, 34, 93);
 *   fill(0);
 *   //draw a square only if the mouse is not moving
 *   if (mouseY === pmouseY && mouseX === pmouseX) {
 *     rect(20, 20, 60, 60);
 *   }
 *
 *   print(pmouseY + ' -> ' + mouseY);
 * }
 * </code>
 * </div>
 *
 * @alt
 * 60x60 black rect center, fuschia background. rect flickers on mouse movement
 *
 */
p5.prototype.pmouseY = 0;

/**
 * The system variable winMouseX always contains the current horizontal
 * position of the mouse, relative to (0, 0) of the window.
 *
 * @property {Number} winMouseX
 * @readOnly
 *
 * @example
 * <div>
 * <code>
 * var myCanvas;
 *
 * function setup() {
 *   //use a variable to store a pointer to the canvas
 *   myCanvas = createCanvas(100, 100);
 * }
 *
 * function draw() {
 *   background(237, 34, 93);
 *   fill(0);
 *
 *   //move the canvas to the horizontal mouse position
 *   //rela                    tive to the window
 *   myCanvas.position(winMouseX + 1, windowHeight / 2);
 *
 *   //the y of the square is relative to the canvas
 *   rect(20, mouseY, 60, 60);
 * }
 * </code>
 * </div>
 *
 * @alt
 * 60x60 black rect y moves with mouse y and fuschia canvas moves with mouse x
 *
 */
p5.prototype.winMouseX = 0;

/**
 * The system variable winMouseY always contains the current vertical
 * position of the mouse, relative to (0, 0) of the window.
 *
 * @property {Number} winMouseY
 * @readOnly
 *
 * @example
 * <div>
 * <code>
 * var myCanvas;
 *
 * function setup() {
 *   //use a variable to store a pointer to the canvas
 *   myCanvas = createCanvas(100, 100);
 * }
 *
 * function draw() {
 *   background(237, 34, 93);
 *   fill(0);
 *
 *   //move the canvas to the vertical mouse position
 *   //rel                    ative to the window
 *   myCanvas.position(windowWidth / 2, winMouseY + 1);
 *
 *   //the x of the square is relative to the canvas
 *   rect(mouseX, 20, 60, 60);
 * }
 * </code>
 * </div>
 *
 * @alt
 * 60x60 black rect x moves with mouse x and fuschia canvas y moves with mouse y
 *
 */
p5.prototype.winMouseY = 0;

/**
 * The system variable pwinMouseX always contains the horizontal position
 * of the mouse in the frame previous to the current frame, relative to
 * (0, 0) of the window.
 *
 * @property {Number} pwinMouseX
 * @readOnly
 *
 * @example
 * <div>
 * <code>
 * var myCanvas;
 *
 * function setup() {
 *   //use a variable to store a pointer to the canvas
 *   myCanvas = createCanvas(100, 100);
 *   noStroke();
 *   fill(237, 34, 93);
 * }
 *
 * function draw() {
 *   clear();
 *   //the difference between previous and
 *   //current x position is the horizontal mouse speed
 *   var speed = abs(winMouseX - pwinMouseX);
 *   //change the size of the circle
 *   //according to the horizontal speed
 *   ellipse(50, 50, 10 + speed * 5, 10 + speed * 5);
 *   //move the canvas to the mouse position
 *   myCanvas.position(winMouseX + 1, winMouseY + 1);
 * }
 * </code>
 * </div>
 *
 * @alt
 * fuschia ellipse moves with mouse x and y. Grows and shrinks with mouse speed
 *
 */
p5.prototype.pwinMouseX = 0;

/**
 * The system variable pwinMouseY always contains the vertical position of
 * the mouse in the frame previous to the current frame, relative to (0, 0)
 * of the window.
 *
 * @property {Number} pwinMouseY
 * @readOnly
 *
 *
 * @example
 * <div>
 * <code>
 * var myCanvas;
 *
 * function setup() {
 *   //use a variable to store a pointer to the canvas
 *   myCanvas = createCanvas(100, 100);
 *   noStroke();
 *   fill(237, 34, 93);
 * }
 *
 * function draw() {
 *   clear();
 *   //the difference between previous and
 *   //current y position is the vertical mouse speed
 *   var speed = abs(winMouseY - pwinMouseY);
 *   //change the size of the circle
 *   //according to the vertical speed
 *   ellipse(50, 50, 10 + speed * 5, 10 + speed * 5);
 *   //move the canvas to the mouse position
 *   myCanvas.position(winMouseX + 1, winMouseY + 1);
 * }
 * </code>
 * </div>
 *
 * @alt
 * fuschia ellipse moves with mouse x and y. Grows and shrinks with mouse speed
 *
 */
p5.prototype.pwinMouseY = 0;

/**
 * Processing automatically tracks if the mouse button is pressed and which
 * button is pressed. The value of the system variable mouseButton is either
 * LEFT, RIGHT, or CENTER depending on which button was pressed last.
 * Warning: different browsers may track mouseButton differently.
 *
 * @property {Constant} mouseButton
 * @readOnly
 *
 * @example
 * <div>
 * <code>
 * function draw() {
 *   background(237, 34, 93);
 *   fill(0);
 *
 *   if (mouseIsPressed) {
 *     if (mouseButton === LEFT) {
 *       ellipse(50, 50, 50, 50);
 *     }
 *     if (mouseButton === RIGHT) {
 *       rect(25, 25, 50, 50);
 *     }
 *     if (mouseButton === CENTER) {
 *       triangle(23, 75, 50, 20, 78, 75);
 *     }
 *   }
 *
 *   print(mouseButton);
 * }
 * </code>
 * </div>
 *
 * @alt
 * 50x50 black ellipse appears on center of fuschia canvas on mouse click/press.
 *
 */
p5.prototype.mouseButton = 0;

/**
 * The boolean system variable mouseIsPressed is true if the mouse is pressed
 * and false if not.
 *
 * @property {Boolean} mouseIsPressed
 * @readOnly
 *
 * @example
 * <div>
 * <code>
 * function draw() {
 *   background(237, 34, 93);
 *   fill(0);
 *
 *   if (mouseIsPressed) {
 *     ellipse(50, 50, 50, 50);
 *   } else {
 *     rect(25, 25, 50, 50);
 *   }
 *
 *   print(mouseIsPressed);
 * }
 * </code>
 * </div>
 *
 * @alt
 * black 50x50 rect becomes ellipse with mouse click/press. fuschia background.
 *
 */
p5.prototype.mouseIsPressed = false;

p5.prototype._updateNextMouseCoords = function(e) {
  if (this._curElement !== null && (!e.touches || e.touches.length > 0)) {
    var mousePos = getMousePos(
      this._curElement.elt,
      this.width,
      this.height,
      e
    );
    this._setProperty('mouseX', mousePos.x);
    this._setProperty('mouseY', mousePos.y);
    this._setProperty('winMouseX', mousePos.winX);
    this._setProperty('winMouseY', mousePos.winY);
  }
  if (!this._hasMouseInteracted) {
    // For first draw, make previous and next equal
    this._updateMouseCoords();
    this._setProperty('_hasMouseInteracted', true);
  }
};

p5.prototype._updateMouseCoords = function() {
  this._setProperty('pmouseX', this.mouseX);
  this._setProperty('pmouseY', this.mouseY);
  this._setProperty('pwinMouseX', this.winMouseX);
  this._setProperty('pwinMouseY', this.winMouseY);
};

function getMousePos(canvas, w, h, evt) {
  if (evt && !evt.clientX) {
    // use touches if touch and not mouse
    if (evt.touches) {
      evt = evt.touches[0];
    } else if (evt.changedTouches) {
      evt = evt.changedTouches[0];
    }
  }
  var rect = canvas.getBoundingClientRect();
  var sx = canvas.scrollWidth / w;
  var sy = canvas.scrollHeight / h;
  return {
    x: (evt.clientX - rect.left) / sx,
    y: (evt.clientY - rect.top) / sy,
    winX: evt.clientX,
    winY: evt.clientY,
    id: evt.identifier
  };
}

p5.prototype._setMouseButton = function(e) {
  if (e.button === 1) {
    this._setProperty('mouseButton', constants.CENTER);
  } else if (e.button === 2) {
    this._setProperty('mouseButton', constants.RIGHT);
  } else {
    this._setProperty('mouseButton', constants.LEFT);
  }
};

/**
 * The mouseMoved() function is called every time the mouse moves and a mouse
 * button is not pressed.<br><br>
 * Browsers may have different default
 * behaviors attached to various mouse events. To prevent any default
 * behavior for this event, add "return false" to the end of the method.
 *
 * @method mouseMoved
 * @example
 * <div>
 * <code>
 * // Move the mouse across the page
 * // to change its value
 *
 * var value = 0;
 * function draw() {
 *   fill(value);
 *   rect(25, 25, 50, 50);
 * }
 * function mouseMoved() {
 *   value = value + 5;
 *   if (value > 255) {
 *     value = 0;
 *   }
 * }
 * </code>
 * </div>
 *
 * <div class="norender">
 * <code>
 * function mouseMoved() {
 *   ellipse(mouseX, mouseY, 5, 5);
 *   // prevent default
 *   return false;
 * }
 * </code>
 * </div>
 *
 * @alt
 * black 50x50 rect becomes lighter with mouse movements until white then resets
 * no image displayed
 *
 */

/**
 * The mouseDragged() function is called once every time the mouse moves and
 * a mouse button is pressed. If no mouseDragged() function is defined, the
 * touchMoved() function will be called instead if it is defined.<br><br>
 * Browsers may have different default
 * behaviors attached to various mouse events. To prevent any default
 * behavior for this event, add "return false" to the end of the method.
 *
 * @method mouseDragged
 * @example
 * <div>
 * <code>
 * // Drag the mouse across the page
 * // to change its value
 *
 * var value = 0;
 * function draw() {
 *   fill(value);
 *   rect(25, 25, 50, 50);
 * }
 * function mouseDragged() {
 *   value = value + 5;
 *   if (value > 255) {
 *     value = 0;
 *   }
 * }
 * </code>
 * </div>
 *
 * <div class="norender">
 * <code>
 * function mouseDragged() {
 *   ellipse(mouseX, mouseY, 5, 5);
 *   // prevent default
 *   return false;
 * }
 * </code>
 * </div>
 *
 * @alt
 * black 50x50 rect turns lighter with mouse click and drag until white, resets
 * no image displayed
 *
 */
p5.prototype._onmousemove = function(e) {
  var context = this._isGlobal ? window : this;
  var executeDefault;
  this._updateNextMouseCoords(e);
  if (!this.mouseIsPressed) {
    if (typeof context.mouseMoved === 'function') {
      executeDefault = context.mouseMoved(e);
      if (executeDefault === false) {
        e.preventDefault();
      }
    }
  } else {
    if (typeof context.mouseDragged === 'function') {
      executeDefault = context.mouseDragged(e);
      if (executeDefault === false) {
        e.preventDefault();
      }
    } else if (typeof context.touchMoved === 'function') {
      executeDefault = context.touchMoved(e);
      if (executeDefault === false) {
        e.preventDefault();
      }
    }
  }
};

/**
 * The mousePressed() function is called once after every time a mouse button
 * is pressed. The mouseButton variable (see the related reference entry)
 * can be used to determine which button has been pressed. If no
 * mousePressed() function is defined, the touchStarted() function will be
 * called instead if it is defined.<br><br>
 * Browsers may have different default
 * behaviors attached to various mouse events. To prevent any default
 * behavior for this event, add "return false" to the end of the method.
 *
 * @method mousePressed
 * @example
 * <div>
 * <code>
 * // Click within the image to change
 * // the value of the rectangle
 *
 * var value = 0;
 * function draw() {
 *   fill(value);
 *   rect(25, 25, 50, 50);
 * }
 * function mousePressed() {
 *   if (value === 0) {
 *     value = 255;
 *   } else {
 *     value = 0;
 *   }
 * }
 * </code>
 * </div>
 *
 * <div class="norender">
 * <code>
 * function mousePressed() {
 *   ellipse(mouseX, mouseY, 5, 5);
 *   // prevent default
 *   return false;
 * }
 * </code>
 * </div>
 *
 * @alt
 * black 50x50 rect turns white with mouse click/press.
 * no image displayed
 *
 */
p5.prototype._onmousedown = function(e) {
  var context = this._isGlobal ? window : this;
  var executeDefault;
  this._setProperty('mouseIsPressed', true);
  this._setMouseButton(e);
  this._updateNextMouseCoords(e);
  if (typeof context.mousePressed === 'function') {
    executeDefault = context.mousePressed(e);
    if (executeDefault === false) {
      e.preventDefault();
    }
  } else if (typeof context.touchStarted === 'function') {
    executeDefault = context.touchStarted(e);
    if (executeDefault === false) {
      e.preventDefault();
    }
  }
};

/**
 * The mouseReleased() function is called every time a mouse button is
 * released. If no mouseReleased() function is defined, the touchEnded()
 * function will be called instead if it is defined.<br><br>
 * Browsers may have different default
 * behaviors attached to various mouse events. To prevent any default
 * behavior for this event, add "return false" to the end of the method.
 *
 *
 * @method mouseReleased
 * @example
 * <div>
 * <code>
 * // Click within the image to change
 * // the value of the rectangle
 * // after the mouse has been clicked
 *
 * var value = 0;
 * function draw() {
 *   fill(value);
 *   rect(25, 25, 50, 50);
 * }
 * function mouseReleased() {
 *   if (value === 0) {
 *     value = 255;
 *   } else {
 *     value = 0;
 *   }
 * }
 * </code>
 * </div>
 *
 * <div class="norender">
 * <code>
 * function mouseReleased() {
 *   ellipse(mouseX, mouseY, 5, 5);
 *   // prevent default
 *   return false;
 * }
 * </code>
 * </div>
 *
 * @alt
 * black 50x50 rect turns white with mouse click/press.
 * no image displayed
 *
 */
p5.prototype._onmouseup = function(e) {
  var context = this._isGlobal ? window : this;
  var executeDefault;
  this._setProperty('mouseIsPressed', false);
  if (typeof context.mouseReleased === 'function') {
    executeDefault = context.mouseReleased(e);
    if (executeDefault === false) {
      e.preventDefault();
    }
  } else if (typeof context.touchEnded === 'function') {
    executeDefault = context.touchEnded(e);
    if (executeDefault === false) {
      e.preventDefault();
    }
  }
};

p5.prototype._ondragend = p5.prototype._onmouseup;
p5.prototype._ondragover = p5.prototype._onmousemove;

/**
 * The mouseClicked() function is called once after a mouse button has been
 * pressed and then released.<br><br>
 * Browsers handle clicks differently, so this function is only guaranteed to be
 * run when the left mouse button is clicked. To handle other mouse buttons
 * being pressed or released, see mousePressed() or mouseReleased().<br><br>
 * Browsers may have different default
 * behaviors attached to various mouse events. To prevent any default
 * behavior for this event, add "return false" to the end of the method.
 *
 * @method mouseClicked
 * @example
 * <div>
 * <code>
 * // Click within the image to change
 * // the value of the rectangle
 * // after the mouse has been clicked
 *
 * var value = 0;
 * function draw() {
 *   fill(value);
 *   rect(25, 25, 50, 50);
 * }
 *
 * function mouseClicked() {
 *   if (value === 0) {
 *     value = 255;
 *   } else {
 *     value = 0;
 *   }
 * }
 * </code>
 * </div>
 *
 * <div class="norender">
 * <code>
 * function mouseClicked() {
 *   ellipse(mouseX, mouseY, 5, 5);
 *   // prevent default
 *   return false;
 * }
 * </code>
 * </div>
 *
 * @alt
 * black 50x50 rect turns white with mouse click/press.
 * no image displayed
 *
 */
p5.prototype._onclick = function(e) {
  var context = this._isGlobal ? window : this;
  if (typeof context.mouseClicked === 'function') {
    var executeDefault = context.mouseClicked(e);
    if (executeDefault === false) {
      e.preventDefault();
    }
  }
};

/**
 * The doubleClicked() function is executed every time a event
 * listener has detected a dblclick event which is a part of the
 * DOM L3 specification. The doubleClicked event is fired when a
 * pointing device button (usually a mouse's primary button)
 * is clicked twice on a single element. For more info on the
 * dblclick event refer to mozilla's documentation here:
 * https://developer.mozilla.org/en-US/docs/Web/Events/dblclick
 *
 * @method doubleClicked
 * @example
 * <div>
 * <code>
 * // Click within the image to change
 * // the value of the rectangle
 * // after the mouse has been double clicked
 *
 * var value = 0;
 * function draw() {
 *   fill(value);
 *   rect(25, 25, 50, 50);
 * }
 *
 * function doubleClicked() {
 *   if (value === 0) {
 *     value = 255;
 *   } else {
 *     value = 0;
 *   }
 * }
 * </code>
 * </div>
 *
 * <div class="norender">
 * <code>
 * function doubleClicked() {
 *   ellipse(mouseX, mouseY, 5, 5);
 *   // prevent default
 *   return false;
 * }
 * </code>
 * </div>
 *
 * @alt
 * black 50x50 rect turns white with mouse doubleClick/press.
 * no image displayed
 */

p5.prototype._ondblclick = function(e) {
  var context = this._isGlobal ? window : this;
  if (typeof context.doubleClicked === 'function') {
    var executeDefault = context.doubleClicked(e);
    if (executeDefault === false) {
      e.preventDefault();
    }
  }
};

/**
 * The function mouseWheel() is executed every time a vertical mouse wheel
 * event is detected either triggered by an actual mouse wheel or by a
 * touchpad.<br><br>
 * The event.delta property returns the amount the mouse wheel
 * have scrolled. The values can be positive or negative depending on the
 * scroll direction (on OS X with "natural" scrolling enabled, the signs
 * are inverted).<br><br>
 * Browsers may have different default behaviors attached to various
 * mouse events. To prevent any default behavior for this event, add
 * "return false" to the end of the method.<br><br>
 * Due to the current support of the "wheel" event on Safari, the function
 * may only work as expected if "return false" is included while using Safari.
 *
 * @method mouseWheel
 *
 * @example
 * <div>
 * <code>
 * var pos = 25;
 *
 * function draw() {
 *   background(237, 34, 93);
 *   fill(0);
 *   rect(25, pos, 50, 50);
 * }
 *
 * function mouseWheel(event) {
 *   print(event.delta);
 *   //move the square according to the vertical scroll amount
 *   pos += event.delta;
 *   //uncomment to block page scrolling
 *   //return false;
 * }
 * </code>
 * </div>
 *
 * @alt
 * black 50x50 rect moves up and down with vertical scroll. fuschia background
 *
 */
p5.prototype._onwheel = function(e) {
  var context = this._isGlobal ? window : this;
  if (typeof context.mouseWheel === 'function') {
    e.delta = e.deltaY;
    var executeDefault = context.mouseWheel(e);
    if (executeDefault === false) {
      e.preventDefault();
    }
  }
};

module.exports = p5;

},{"../core/constants":21,"../core/core":22}],40:[function(_dereq_,module,exports){
/**
 * @module Events
 * @submodule Touch
 * @for p5
 * @requires core
 */

'use strict';

var p5 = _dereq_('../core/core');

/**
 * The system variable touches[] contains an array of the positions of all
 * current touch points, relative to (0, 0) of the canvas, and IDs identifying a
 * unique touch as it moves. Each element in the array is an object with x, y,
 * and id properties.
 *
 * The touches[] array is not supported on Safari and IE on touch-based
 * desktops (laptops).
 *
 * @property {Object[]} touches
 * @readOnly
 */
p5.prototype.touches = [];

p5.prototype._updateTouchCoords = function(e) {
  if (this._curElement !== null) {
    var touches = [];
    for (var i = 0; i < e.touches.length; i++) {
      touches[i] = getTouchInfo(
        this._curElement.elt,
        this.width,
        this.height,
        e,
        i
      );
    }
    this._setProperty('touches', touches);
  }
};

function getTouchInfo(canvas, w, h, e, i) {
  i = i || 0;
  var rect = canvas.getBoundingClientRect();
  var sx = canvas.scrollWidth / w;
  var sy = canvas.scrollHeight / h;
  var touch = e.touches[i] || e.changedTouches[i];
  return {
    x: (touch.clientX - rect.left) / sx,
    y: (touch.clientY - rect.top) / sy,
    winX: touch.clientX,
    winY: touch.clientY,
    id: touch.identifier
  };
}

/**
 * The touchStarted() function is called once after every time a touch is
 * registered. If no touchStarted() function is defined, the mousePressed()
 * function will be called instead if it is defined.<br><br>
 * Browsers may have different default behaviors attached to various touch
 * events. To prevent any default behavior for this event, add "return false"
 * to the end of the method.
 *
 * @method touchStarted
 * @example
 * <div>
 * <code>
 * // Touch within the image to change
 * // the value of the rectangle
 *
 * var value = 0;
 * function draw() {
 *   fill(value);
 *   rect(25, 25, 50, 50);
 * }
 * function touchStarted() {
 *   if (value === 0) {
 *     value = 255;
 *   } else {
 *     value = 0;
 *   }
 * }
 * </code>
 * </div>
 *
 * <div class="norender">
 * <code>
 * function touchStarted() {
 *   ellipse(mouseX, mouseY, 5, 5);
 *   // prevent default
 *   return false;
 * }
 * </code>
 * </div>
 *
 * @alt
 * 50x50 black rect turns white with touch event.
 * no image displayed
 */
p5.prototype._ontouchstart = function(e) {
  var context = this._isGlobal ? window : this;
  var executeDefault;
  this._setProperty('mouseIsPressed', true);
  this._updateTouchCoords(e);
  this._updateNextMouseCoords(e);
  if (typeof context.touchStarted === 'function') {
    executeDefault = context.touchStarted(e);
    if (executeDefault === false) {
      e.preventDefault();
    }
  } else if (typeof context.mousePressed === 'function') {
    executeDefault = context.mousePressed(e);
    if (executeDefault === false) {
      e.preventDefault();
    }
  }
};

/**
 * The touchMoved() function is called every time a touch move is registered.
 * If no touchMoved() function is defined, the mouseDragged() function will
 * be called instead if it is defined.<br><br>
 * Browsers may have different default behaviors attached to various touch
 * events. To prevent any default behavior for this event, add "return false"
 * to the end of the method.
 *
 * @method touchMoved
 * @example
 * <div>
 * <code>
 * // Move your finger across the page
 * // to change its value
 *
 * var value = 0;
 * function draw() {
 *   fill(value);
 *   rect(25, 25, 50, 50);
 * }
 * function touchMoved() {
 *   value = value + 5;
 *   if (value > 255) {
 *     value = 0;
 *   }
 * }
 * </code>
 * </div>
 *
 * <div class="norender">
 * <code>
 * function touchMoved() {
 *   ellipse(mouseX, mouseY, 5, 5);
 *   // prevent default
 *   return false;
 * }
 * </code>
 * </div>
 *
 * @alt
 * 50x50 black rect turns lighter with touch until white. resets
 * no image displayed
 *
 */
p5.prototype._ontouchmove = function(e) {
  var context = this._isGlobal ? window : this;
  var executeDefault;
  this._updateTouchCoords(e);
  this._updateNextMouseCoords(e);
  if (typeof context.touchMoved === 'function') {
    executeDefault = context.touchMoved(e);
    if (executeDefault === false) {
      e.preventDefault();
    }
  } else if (typeof context.mouseDragged === 'function') {
    executeDefault = context.mouseDragged(e);
    if (executeDefault === false) {
      e.preventDefault();
    }
  }
};

/**
 * The touchEnded() function is called every time a touch ends. If no
 * touchEnded() function is defined, the mouseReleased() function will be
 * called instead if it is defined.<br><br>
 * Browsers may have different default behaviors attached to various touch
 * events. To prevent any default behavior for this event, add "return false"
 * to the end of the method.
 *
 * @method touchEnded
 * @example
 * <div>
 * <code>
 * // Release touch within the image to
 * // change the value of the rectangle
 *
 * var value = 0;
 * function draw() {
 *   fill(value);
 *   rect(25, 25, 50, 50);
 * }
 * function touchEnded() {
 *   if (value === 0) {
 *     value = 255;
 *   } else {
 *     value = 0;
 *   }
 * }
 * </code>
 * </div>
 *
 * <div class="norender">
 * <code>
 * function touchEnded() {
 *   ellipse(mouseX, mouseY, 5, 5);
 *   // prevent default
 *   return false;
 * }
 * </code>
 * </div>
 *
 * @alt
 * 50x50 black rect turns white with touch.
 * no image displayed
 *
 */
p5.prototype._ontouchend = function(e) {
  this._setProperty('mouseIsPressed', false);
  this._updateTouchCoords(e);
  this._updateNextMouseCoords(e);
  var context = this._isGlobal ? window : this;
  var executeDefault;
  if (typeof context.touchEnded === 'function') {
    executeDefault = context.touchEnded(e);
    if (executeDefault === false) {
      e.preventDefault();
    }
  } else if (typeof context.mouseReleased === 'function') {
    executeDefault = context.mouseReleased(e);
    if (executeDefault === false) {
      e.preventDefault();
    }
  }
};

module.exports = p5;

},{"../core/core":22}],41:[function(_dereq_,module,exports){
/*global ImageData:false */

/**
 * This module defines the filters for use with image buffers.
 *
 * This module is basically a collection of functions stored in an object
 * as opposed to modules. The functions are destructive, modifying
 * the passed in canvas rather than creating a copy.
 *
 * Generally speaking users of this module will use the Filters.apply method
 * on a canvas to create an effect.
 *
 * A number of functions are borrowed/adapted from
 * http://www.html5rocks.com/en/tutorials/canvas/imagefilters/
 * or the java processing implementation.
 */

'use strict';

var Filters = {};

/*
 * Helper functions
 */

/**
 * Returns the pixel buffer for a canvas
 *
 * @private
 *
 * @param  {Canvas|ImageData} canvas the canvas to get pixels from
 * @return {Uint8ClampedArray}       a one-dimensional array containing
 *                                   the data in thc RGBA order, with integer
 *                                   values between 0 and 255
 */
Filters._toPixels = function(canvas) {
  if (canvas instanceof ImageData) {
    return canvas.data;
  } else {
    return canvas
      .getContext('2d')
      .getImageData(0, 0, canvas.width, canvas.height).data;
  }
};

/**
 * Returns a 32 bit number containing ARGB data at ith pixel in the
 * 1D array containing pixels data.
 *
 * @private
 *
 * @param  {Uint8ClampedArray} data array returned by _toPixels()
 * @param  {Integer}           i    index of a 1D Image Array
 * @return {Integer}                32 bit integer value representing
 *                                  ARGB value.
 */
Filters._getARGB = function(data, i) {
  var offset = i * 4;
  return (
    ((data[offset + 3] << 24) & 0xff000000) |
    ((data[offset] << 16) & 0x00ff0000) |
    ((data[offset + 1] << 8) & 0x0000ff00) |
    (data[offset + 2] & 0x000000ff)
  );
};

/**
 * Modifies pixels RGBA values to values contained in the data object.
 *
 * @private
 *
 * @param {Uint8ClampedArray} pixels array returned by _toPixels()
 * @param {Int32Array}        data   source 1D array where each value
 *                                   represents ARGB values
 */
Filters._setPixels = function(pixels, data) {
  var offset = 0;
  for (var i = 0, al = pixels.length; i < al; i++) {
    offset = i * 4;
    pixels[offset + 0] = (data[i] & 0x00ff0000) >>> 16;
    pixels[offset + 1] = (data[i] & 0x0000ff00) >>> 8;
    pixels[offset + 2] = data[i] & 0x000000ff;
    pixels[offset + 3] = (data[i] & 0xff000000) >>> 24;
  }
};

/**
 * Returns the ImageData object for a canvas
 * https://developer.mozilla.org/en-US/docs/Web/API/ImageData
 *
 * @private
 *
 * @param  {Canvas|ImageData} canvas canvas to get image data from
 * @return {ImageData}               Holder of pixel data (and width and
 *                                   height) for a canvas
 */
Filters._toImageData = function(canvas) {
  if (canvas instanceof ImageData) {
    return canvas;
  } else {
    return canvas
      .getContext('2d')
      .getImageData(0, 0, canvas.width, canvas.height);
  }
};

/**
 * Returns a blank ImageData object.
 *
 * @private
 *
 * @param  {Integer} width
 * @param  {Integer} height
 * @return {ImageData}
 */
Filters._createImageData = function(width, height) {
  Filters._tmpCanvas = document.createElement('canvas');
  Filters._tmpCtx = Filters._tmpCanvas.getContext('2d');
  return this._tmpCtx.createImageData(width, height);
};

/**
 * Applys a filter function to a canvas.
 *
 * The difference between this and the actual filter functions defined below
 * is that the filter functions generally modify the pixel buffer but do
 * not actually put that data back to the canvas (where it would actually
 * update what is visible). By contrast this method does make the changes
 * actually visible in the canvas.
 *
 * The apply method is the method that callers of this module would generally
 * use. It has been separated from the actual filters to support an advanced
 * use case of creating a filter chain that executes without actually updating
 * the canvas in between everystep.
 *
 * @private
 * @param  {HTMLCanvasElement} canvas [description]
 * @param  {function(ImageData,Object)} func   [description]
 * @param  {Object} filterParam  [description]
 */
Filters.apply = function(canvas, func, filterParam) {
  var ctx = canvas.getContext('2d');
  var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);

  //Filters can either return a new ImageData object, or just modify
  //the one they received.
  var newImageData = func(imageData, filterParam);
  if (newImageData instanceof ImageData) {
    ctx.putImageData(newImageData, 0, 0, 0, 0, canvas.width, canvas.height);
  } else {
    ctx.putImageData(imageData, 0, 0, 0, 0, canvas.width, canvas.height);
  }
};

/*
 * Filters
 */

/**
 * Converts the image to black and white pixels depending if they are above or
 * below the threshold defined by the level parameter. The parameter must be
 * between 0.0 (black) and 1.0 (white). If no level is specified, 0.5 is used.
 *
 * Borrowed from http://www.html5rocks.com/en/tutorials/canvas/imagefilters/
 *
 * @private
 * @param  {Canvas} canvas
 * @param  {Float} level
 */
Filters.threshold = function(canvas, level) {
  var pixels = Filters._toPixels(canvas);

  if (level === undefined) {
    level = 0.5;
  }
  var thresh = Math.floor(level * 255);

  for (var i = 0; i < pixels.length; i += 4) {
    var r = pixels[i];
    var g = pixels[i + 1];
    var b = pixels[i + 2];
    var gray = 0.2126 * r + 0.7152 * g + 0.0722 * b;
    var val;
    if (gray >= thresh) {
      val = 255;
    } else {
      val = 0;
    }
    pixels[i] = pixels[i + 1] = pixels[i + 2] = val;
  }
};

/**
 * Converts any colors in the image to grayscale equivalents.
 * No parameter is used.
 *
 * Borrowed from http://www.html5rocks.com/en/tutorials/canvas/imagefilters/
 *
 * @private
 * @param {Canvas} canvas
 */
Filters.gray = function(canvas) {
  var pixels = Filters._toPixels(canvas);

  for (var i = 0; i < pixels.length; i += 4) {
    var r = pixels[i];
    var g = pixels[i + 1];
    var b = pixels[i + 2];

    // CIE luminance for RGB
    var gray = 0.2126 * r + 0.7152 * g + 0.0722 * b;
    pixels[i] = pixels[i + 1] = pixels[i + 2] = gray;
  }
};

/**
 * Sets the alpha channel to entirely opaque. No parameter is used.
 *
 * @private
 * @param {Canvas} canvas
 */
Filters.opaque = function(canvas) {
  var pixels = Filters._toPixels(canvas);

  for (var i = 0; i < pixels.length; i += 4) {
    pixels[i + 3] = 255;
  }

  return pixels;
};

/**
 * Sets each pixel to its inverse value. No parameter is used.
 * @private
 * @param  {Canvas} canvas
 */
Filters.invert = function(canvas) {
  var pixels = Filters._toPixels(canvas);

  for (var i = 0; i < pixels.length; i += 4) {
    pixels[i] = 255 - pixels[i];
    pixels[i + 1] = 255 - pixels[i + 1];
    pixels[i + 2] = 255 - pixels[i + 2];
  }
};

/**
 * Limits each channel of the image to the number of colors specified as
 * the parameter. The parameter can be set to values between 2 and 255, but
 * results are most noticeable in the lower ranges.
 *
 * Adapted from java based processing implementation
 *
 * @private
 * @param  {Canvas} canvas
 * @param  {Integer} level
 */
Filters.posterize = function(canvas, level) {
  var pixels = Filters._toPixels(canvas);

  if (level < 2 || level > 255) {
    throw new Error(
      'Level must be greater than 2 and less than 255 for posterize'
    );
  }

  var levels1 = level - 1;
  for (var i = 0; i < pixels.length; i += 4) {
    var rlevel = pixels[i];
    var glevel = pixels[i + 1];
    var blevel = pixels[i + 2];

    pixels[i] = ((rlevel * level) >> 8) * 255 / levels1;
    pixels[i + 1] = ((glevel * level) >> 8) * 255 / levels1;
    pixels[i + 2] = ((blevel * level) >> 8) * 255 / levels1;
  }
};

/**
 * reduces the bright areas in an image
 * @private
 * @param  {Canvas} canvas
 *
 */
Filters.dilate = function(canvas) {
  var pixels = Filters._toPixels(canvas);
  var currIdx = 0;
  var maxIdx = pixels.length ? pixels.length / 4 : 0;
  var out = new Int32Array(maxIdx);
  var currRowIdx, maxRowIdx, colOrig, colOut, currLum;

  var idxRight, idxLeft, idxUp, idxDown;
  var colRight, colLeft, colUp, colDown;
  var lumRight, lumLeft, lumUp, lumDown;

  while (currIdx < maxIdx) {
    currRowIdx = currIdx;
    maxRowIdx = currIdx + canvas.width;
    while (currIdx < maxRowIdx) {
      colOrig = colOut = Filters._getARGB(pixels, currIdx);
      idxLeft = currIdx - 1;
      idxRight = currIdx + 1;
      idxUp = currIdx - canvas.width;
      idxDown = currIdx + canvas.width;

      if (idxLeft < currRowIdx) {
        idxLeft = currIdx;
      }
      if (idxRight >= maxRowIdx) {
        idxRight = currIdx;
      }
      if (idxUp < 0) {
        idxUp = 0;
      }
      if (idxDown >= maxIdx) {
        idxDown = currIdx;
      }
      colUp = Filters._getARGB(pixels, idxUp);
      colLeft = Filters._getARGB(pixels, idxLeft);
      colDown = Filters._getARGB(pixels, idxDown);
      colRight = Filters._getARGB(pixels, idxRight);

      //compute luminance
      currLum =
        77 * ((colOrig >> 16) & 0xff) +
        151 * ((colOrig >> 8) & 0xff) +
        28 * (colOrig & 0xff);
      lumLeft =
        77 * ((colLeft >> 16) & 0xff) +
        151 * ((colLeft >> 8) & 0xff) +
        28 * (colLeft & 0xff);
      lumRight =
        77 * ((colRight >> 16) & 0xff) +
        151 * ((colRight >> 8) & 0xff) +
        28 * (colRight & 0xff);
      lumUp =
        77 * ((colUp >> 16) & 0xff) +
        151 * ((colUp >> 8) & 0xff) +
        28 * (colUp & 0xff);
      lumDown =
        77 * ((colDown >> 16) & 0xff) +
        151 * ((colDown >> 8) & 0xff) +
        28 * (colDown & 0xff);

      if (lumLeft > currLum) {
        colOut = colLeft;
        currLum = lumLeft;
      }
      if (lumRight > currLum) {
        colOut = colRight;
        currLum = lumRight;
      }
      if (lumUp > currLum) {
        colOut = colUp;
        currLum = lumUp;
      }
      if (lumDown > currLum) {
        colOut = colDown;
        currLum = lumDown;
      }
      out[currIdx++] = colOut;
    }
  }
  Filters._setPixels(pixels, out);
};

/**
 * increases the bright areas in an image
 * @private
 * @param  {Canvas} canvas
 *
 */
Filters.erode = function(canvas) {
  var pixels = Filters._toPixels(canvas);
  var currIdx = 0;
  var maxIdx = pixels.length ? pixels.length / 4 : 0;
  var out = new Int32Array(maxIdx);
  var currRowIdx, maxRowIdx, colOrig, colOut, currLum;
  var idxRight, idxLeft, idxUp, idxDown;
  var colRight, colLeft, colUp, colDown;
  var lumRight, lumLeft, lumUp, lumDown;

  while (currIdx < maxIdx) {
    currRowIdx = currIdx;
    maxRowIdx = currIdx + canvas.width;
    while (currIdx < maxRowIdx) {
      colOrig = colOut = Filters._getARGB(pixels, currIdx);
      idxLeft = currIdx - 1;
      idxRight = currIdx + 1;
      idxUp = currIdx - canvas.width;
      idxDown = currIdx + canvas.width;

      if (idxLeft < currRowIdx) {
        idxLeft = currIdx;
      }
      if (idxRight >= maxRowIdx) {
        idxRight = currIdx;
      }
      if (idxUp < 0) {
        idxUp = 0;
      }
      if (idxDown >= maxIdx) {
        idxDown = currIdx;
      }
      colUp = Filters._getARGB(pixels, idxUp);
      colLeft = Filters._getARGB(pixels, idxLeft);
      colDown = Filters._getARGB(pixels, idxDown);
      colRight = Filters._getARGB(pixels, idxRight);

      //compute luminance
      currLum =
        77 * ((colOrig >> 16) & 0xff) +
        151 * ((colOrig >> 8) & 0xff) +
        28 * (colOrig & 0xff);
      lumLeft =
        77 * ((colLeft >> 16) & 0xff) +
        151 * ((colLeft >> 8) & 0xff) +
        28 * (colLeft & 0xff);
      lumRight =
        77 * ((colRight >> 16) & 0xff) +
        151 * ((colRight >> 8) & 0xff) +
        28 * (colRight & 0xff);
      lumUp =
        77 * ((colUp >> 16) & 0xff) +
        151 * ((colUp >> 8) & 0xff) +
        28 * (colUp & 0xff);
      lumDown =
        77 * ((colDown >> 16) & 0xff) +
        151 * ((colDown >> 8) & 0xff) +
        28 * (colDown & 0xff);

      if (lumLeft < currLum) {
        colOut = colLeft;
        currLum = lumLeft;
      }
      if (lumRight < currLum) {
        colOut = colRight;
        currLum = lumRight;
      }
      if (lumUp < currLum) {
        colOut = colUp;
        currLum = lumUp;
      }
      if (lumDown < currLum) {
        colOut = colDown;
        currLum = lumDown;
      }

      out[currIdx++] = colOut;
    }
  }
  Filters._setPixels(pixels, out);
};

// BLUR

// internal kernel stuff for the gaussian blur filter
var blurRadius;
var blurKernelSize;
var blurKernel;
var blurMult;

/*
 * Port of https://github.com/processing/processing/blob/
 * master/core/src/processing/core/PImage.java#L1250
 *
 * Optimized code for building the blur kernel.
 * further optimized blur code (approx. 15% for radius=20)
 * bigger speed gains for larger radii (~30%)
 * added support for various image types (ALPHA, RGB, ARGB)
 * [toxi 050728]
 */
function buildBlurKernel(r) {
  var radius = (r * 3.5) | 0;
  radius = radius < 1 ? 1 : radius < 248 ? radius : 248;

  if (blurRadius !== radius) {
    blurRadius = radius;
    blurKernelSize = (1 + blurRadius) << 1;
    blurKernel = new Int32Array(blurKernelSize);
    blurMult = new Array(blurKernelSize);
    for (var l = 0; l < blurKernelSize; l++) {
      blurMult[l] = new Int32Array(256);
    }

    var bk, bki;
    var bm, bmi;

    for (var i = 1, radiusi = radius - 1; i < radius; i++) {
      blurKernel[radius + i] = blurKernel[radiusi] = bki = radiusi * radiusi;
      bm = blurMult[radius + i];
      bmi = blurMult[radiusi--];
      for (var j = 0; j < 256; j++) {
        bm[j] = bmi[j] = bki * j;
      }
    }
    bk = blurKernel[radius] = radius * radius;
    bm = blurMult[radius];

    for (var k = 0; k < 256; k++) {
      bm[k] = bk * k;
    }
  }
}

// Port of https://github.com/processing/processing/blob/
// master/core/src/processing/core/PImage.java#L1433
function blurARGB(canvas, radius) {
  var pixels = Filters._toPixels(canvas);
  var width = canvas.width;
  var height = canvas.height;
  var numPackedPixels = width * height;
  var argb = new Int32Array(numPackedPixels);
  for (var j = 0; j < numPackedPixels; j++) {
    argb[j] = Filters._getARGB(pixels, j);
  }
  var sum, cr, cg, cb, ca;
  var read, ri, ym, ymi, bk0;
  var a2 = new Int32Array(numPackedPixels);
  var r2 = new Int32Array(numPackedPixels);
  var g2 = new Int32Array(numPackedPixels);
  var b2 = new Int32Array(numPackedPixels);
  var yi = 0;
  buildBlurKernel(radius);
  var x, y, i;
  var bm;
  for (y = 0; y < height; y++) {
    for (x = 0; x < width; x++) {
      cb = cg = cr = ca = sum = 0;
      read = x - blurRadius;
      if (read < 0) {
        bk0 = -read;
        read = 0;
      } else {
        if (read >= width) {
          break;
        }
        bk0 = 0;
      }
      for (i = bk0; i < blurKernelSize; i++) {
        if (read >= width) {
          break;
        }
        var c = argb[read + yi];
        bm = blurMult[i];
        ca += bm[(c & -16777216) >>> 24];
        cr += bm[(c & 16711680) >> 16];
        cg += bm[(c & 65280) >> 8];
        cb += bm[c & 255];
        sum += blurKernel[i];
        read++;
      }
      ri = yi + x;
      a2[ri] = ca / sum;
      r2[ri] = cr / sum;
      g2[ri] = cg / sum;
      b2[ri] = cb / sum;
    }
    yi += width;
  }
  yi = 0;
  ym = -blurRadius;
  ymi = ym * width;
  for (y = 0; y < height; y++) {
    for (x = 0; x < width; x++) {
      cb = cg = cr = ca = sum = 0;
      if (ym < 0) {
        bk0 = ri = -ym;
        read = x;
      } else {
        if (ym >= height) {
          break;
        }
        bk0 = 0;
        ri = ym;
        read = x + ymi;
      }
      for (i = bk0; i < blurKernelSize; i++) {
        if (ri >= height) {
          break;
        }
        bm = blurMult[i];
        ca += bm[a2[read]];
        cr += bm[r2[read]];
        cg += bm[g2[read]];
        cb += bm[b2[read]];
        sum += blurKernel[i];
        ri++;
        read += width;
      }
      argb[x + yi] =
        ((ca / sum) << 24) |
        ((cr / sum) << 16) |
        ((cg / sum) << 8) |
        (cb / sum);
    }
    yi += width;
    ymi += width;
    ym++;
  }
  Filters._setPixels(pixels, argb);
}

Filters.blur = function(canvas, radius) {
  blurARGB(canvas, radius);
};

module.exports = Filters;

},{}],42:[function(_dereq_,module,exports){
/**
 * @module Image
 * @submodule Image
 * @for p5
 * @requires core
 */

/**
 * This module defines the p5 methods for the p5.Image class
 * for drawing images to the main display canvas.
 */
'use strict';

var p5 = _dereq_('../core/core'); // This is not global, but JSHint is not aware that // this module is implicitly enclosed with Browserify: this overrides the // redefined-global error and permits using the name "frames" for the array // of saved animation frames.

/* global frames:true */ var frames = [];

/**
 * Creates a new p5.Image (the datatype for storing images). This provides a
 * fresh buffer of pixels to play with. Set the size of the buffer with the
 * width and height parameters.
 * <br><br>
 * .pixels gives access to an array containing the values for all the pixels
 * in the display window.
 * These values are numbers. This array is the size (including an appropriate
 * factor for the pixelDensity) of the display window x4,
 * representing the R, G, B, A values in order for each pixel, moving from
 * left to right across each row, then down each column. See .pixels for
 * more info. It may also be simpler to use set() or get().
 * <br><br>
 * Before accessing the pixels of an image, the data must loaded with the
 * loadPixels() function. After the array data has been modified, the
 * updatePixels() function must be run to update the changes.
 *
 * @method createImage
 * @param  {Integer} width  width in pixels
 * @param  {Integer} height height in pixels
 * @return {p5.Image}       the p5.Image object
 * @example
 * <div>
 * <code>
 * var img = createImage(66, 66);
 * img.loadPixels();
 * for (var i = 0; i < img.width; i++) {
 *   for (var j = 0; j < img.height; j++) {
 *     img.set(i, j, color(0, 90, 102));
 *   }
 * }
 * img.updatePixels();
 * image(img, 17, 17);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * var img = createImage(66, 66);
 * img.loadPixels();
 * for (var i = 0; i < img.width; i++) {
 *   for (var j = 0; j < img.height; j++) {
 *     img.set(i, j, color(0, 90, 102, (i % img.width) * 2));
 *   }
 * }
 * img.updatePixels();
 * image(img, 17, 17);
 * image(img, 34, 34);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * var pink = color(255, 102, 204);
 * var img = createImage(66, 66);
 * img.loadPixels();
 * var d = pixelDensity();
 * var halfImage = 4 * (width * d) * (height / 2 * d);
 * for (var i = 0; i < halfImage; i += 4) {
 *   img.pixels[i] = red(pink);
 *   img.pixels[i + 1] = green(pink);
 *   img.pixels[i + 2] = blue(pink);
 *   img.pixels[i + 3] = alpha(pink);
 * }
 * img.updatePixels();
 * image(img, 17, 17);
 * </code>
 * </div>
 *
 * @alt
 * 66x66 dark turquoise rect in center of canvas.
 * 2 gradated dark turquoise rects fade left. 1 center 1 bottom right of canvas
 * no image displayed
 *
 */
p5.prototype.createImage = function(width, height) {
  p5._validateParameters('createImage', arguments);
  return new p5.Image(width, height);
};

/**
 *  Save the current canvas as an image. In Safari, this will open the
 *  image in the window and the user must provide their own
 *  filename on save-as. Other browsers will either save the
 *  file immediately, or prompt the user with a dialogue window.
 *
 *  @method saveCanvas
 *  @param  {p5.Element|HTMLCanvasElement} selectedCanvas   a variable
 *                                  representing a specific html5 canvas (optional)
 *  @param  {String} [filename]
 *  @param  {String} [extension]      'jpg' or 'png'
 *
 *  @example
 * <div class='norender'><code>
 * function setup() {
 *   var c = createCanvas(100, 100);
 *   background(255, 0, 0);
 *   saveCanvas(c, 'myCanvas', 'jpg');
 * }
 * </code></div>
 * <div class='norender'><code>
 * // note that this example has the same result as above
 * // if no canvas is specified, defaults to main canvas
 * function setup() {
 *   var c = createCanvas(100, 100);
 *   background(255, 0, 0);
 *   saveCanvas('myCanvas', 'jpg');
 *
 *   // all of the following are valid
 *   saveCanvas(c, 'myCanvas', 'jpg');
 *   saveCanvas(c, 'myCanvas');
 *   saveCanvas(c);
 *   saveCanvas('myCanvas', 'png');
 *   saveCanvas('myCanvas');
 *   saveCanvas();
 * }
 * </code></div>
 *
 * @alt
 * no image displayed
 * no image displayed
 * no image displayed
 */
/**
 *  @method saveCanvas
 *  @param  {String} [filename]
 *  @param  {String} [extension]
 */
p5.prototype.saveCanvas = function(cnv, filename, extension) {
  p5._validateParameters('saveCanvas', arguments);
  if (cnv instanceof p5.Element) {
    cnv = cnv.elt;
  } else if (!(cnv instanceof HTMLCanvasElement)) {
    filename = cnv;
    extension = filename;
    cnv = this._curElement && this._curElement.elt;
  }

  extension =
    extension ||
    p5.prototype._checkFileExtension(filename, extension)[1] ||
    'png';

  var mimeType;
  switch (extension) {
    default:
      //case 'png':
      mimeType = 'image/png';
      break;
    case 'jpeg':
    case 'jpg':
      mimeType = 'image/jpeg';
      break;
  }

  cnv.toBlob(function(blob) {
    p5.prototype.downloadFile(blob, filename, extension);
  }, mimeType);
};

/**
 *  Capture a sequence of frames that can be used to create a movie.
 *  Accepts a callback. For example, you may wish to send the frames
 *  to a server where they can be stored or converted into a movie.
 *  If no callback is provided, the browser will pop up save dialogues in an
 *  attempt to download all of the images that have just been created. With the
 *  callback provided the image data isn't saved by default but instead passed
 *  as an argument to the callback function as an array of objects, with the
 *  size of array equal to the total number of frames.
 *
 *  Note that saveFrames() will only save the first 15 frames of an animation.
 *  To export longer animations, you might look into a library like
 *  <a href="https://github.com/spite/ccapture.js/">ccapture.js</a>.
 *
 *  @method saveFrames
 *  @param  {String}   filename
 *  @param  {String}   extension 'jpg' or 'png'
 *  @param  {Number}   duration  Duration in seconds to save the frames for.
 *  @param  {Number}   framerate  Framerate to save the frames in.
 *  @param  {function(Array)} [callback] A callback function that will be executed
                                  to handle the image data. This function
                                  should accept an array as argument. The
                                  array will contain the specified number of
                                  frames of objects. Each object has three
                                  properties: imageData - an
                                  image/octet-stream, filename and extension.
 *  @example
 *  <div><code>
 * function draw() {
 *   background(mouseX);
 * }
 *
 * function mousePressed() {
 *   saveFrames('out', 'png', 1, 25, function(data) {
 *     print(data);
 *   });
 * }
</code></div>
 *
 * @alt
 * canvas background goes from light to dark with mouse x.
 *
 */
p5.prototype.saveFrames = function(fName, ext, _duration, _fps, callback) {
  p5._validateParameters('saveFrames', arguments);
  var duration = _duration || 3;
  duration = p5.prototype.constrain(duration, 0, 15);
  duration = duration * 1000;
  var fps = _fps || 15;
  fps = p5.prototype.constrain(fps, 0, 22);
  var count = 0;

  var makeFrame = p5.prototype._makeFrame;
  var cnv = this._curElement.elt;
  var frameFactory = setInterval(function() {
    makeFrame(fName + count, ext, cnv);
    count++;
  }, 1000 / fps);

  setTimeout(function() {
    clearInterval(frameFactory);
    if (callback) {
      callback(frames);
    } else {
      for (var i = 0; i < frames.length; i++) {
        var f = frames[i];
        p5.prototype.downloadFile(f.imageData, f.filename, f.ext);
      }
    }
    frames = []; // clear frames
  }, duration + 0.01);
};

p5.prototype._makeFrame = function(filename, extension, _cnv) {
  var cnv;
  if (this) {
    cnv = this._curElement.elt;
  } else {
    cnv = _cnv;
  }
  var mimeType;
  if (!extension) {
    extension = 'png';
    mimeType = 'image/png';
  } else {
    switch (extension.toLowerCase()) {
      case 'png':
        mimeType = 'image/png';
        break;
      case 'jpeg':
        mimeType = 'image/jpeg';
        break;
      case 'jpg':
        mimeType = 'image/jpeg';
        break;
      default:
        mimeType = 'image/png';
        break;
    }
  }
  var downloadMime = 'image/octet-stream';
  var imageData = cnv.toDataURL(mimeType);
  imageData = imageData.replace(mimeType, downloadMime);

  var thisFrame = {};
  thisFrame.imageData = imageData;
  thisFrame.filename = filename;
  thisFrame.ext = extension;
  frames.push(thisFrame);
};

module.exports = p5;

},{"../core/core":22}],43:[function(_dereq_,module,exports){
/**
 * @module Image
 * @submodule Loading & Displaying
 * @for p5
 * @requires core
 */

'use strict';

var p5 = _dereq_('../core/core');
var Filters = _dereq_('./filters');
var canvas = _dereq_('../core/canvas');
var constants = _dereq_('../core/constants');

_dereq_('../core/error_helpers');

/**
 * Loads an image from a path and creates a p5.Image from it.
 * <br><br>
 * The image may not be immediately available for rendering
 * If you want to ensure that the image is ready before doing
 * anything with it, place the loadImage() call in preload().
 * You may also supply a callback function to handle the image when it's ready.
 * <br><br>
 * The path to the image should be relative to the HTML file
 * that links in your sketch. Loading an image from a URL or other
 * remote location may be blocked due to your browser's built-in
 * security.
 *
 * @method loadImage
 * @param  {String} path Path of the image to be loaded
 * @param  {function(p5.Image)} [successCallback] Function to be called once
 *                                the image is loaded. Will be passed the
 *                                p5.Image.
 * @param  {function(Event)}    [failureCallback] called with event error if
 *                                the image fails to load.
 * @return {p5.Image}             the p5.Image object
 * @example
 * <div>
 * <code>
 * var img;
 * function preload() {
 *   img = loadImage('assets/laDefense.jpg');
 * }
 * function setup() {
 *   image(img, 0, 0);
 * }
 * </code>
 * </div>
 * <div>
 * <code>
 * function setup() {
 *   // here we use a callback to display the image after loading
 *   loadImage('assets/laDefense.jpg', function(img) {
 *     image(img, 0, 0);
 *   });
 * }
 * </code>
 * </div>
 *
 * @alt
 * image of the underside of a white umbrella and grided ceililng above
 * image of the underside of a white umbrella and grided ceililng above
 *
 */
p5.prototype.loadImage = function(path, successCallback, failureCallback) {
  p5._validateParameters('loadImage', arguments);
  var img = new Image();
  var pImg = new p5.Image(1, 1, this);

  var self = this;
  img.onload = function() {
    pImg.width = pImg.canvas.width = img.width;
    pImg.height = pImg.canvas.height = img.height;

    // Draw the image into the backing canvas of the p5.Image
    pImg.drawingContext.drawImage(img, 0, 0);
    pImg.modified = true;

    if (typeof successCallback === 'function') {
      successCallback(pImg);
    }

    self._decrementPreload();
  };
  img.onerror = function(e) {
    p5._friendlyFileLoadError(0, img.src);
    if (typeof failureCallback === 'function') {
      failureCallback(e);
    }
  };

  //set crossOrigin in case image is served which CORS headers
  //this will let us draw to canvas without tainting it.
  //see https://developer.mozilla.org/en-US/docs/HTML/CORS_Enabled_Image
  // When using data-uris the file will be loaded locally
  // so we don't need to worry about crossOrigin with base64 file types
  if (path.indexOf('data:image/') !== 0) {
    img.crossOrigin = 'Anonymous';
  }

  //start loading the image
  img.src = path;

  return pImg;
};

/**
 * Validates clipping params. Per drawImage spec sWidth and sHight cannot be
 * negative or greater than image intrinsic width and height
 * @private
 * @param {Number} sVal
 * @param {Number} iVal
 * @returns {Number}
 * @private
 */
function _sAssign(sVal, iVal) {
  if (sVal > 0 && sVal < iVal) {
    return sVal;
  } else {
    return iVal;
  }
}

/**
 * Draw an image to the p5.js canvas.
 *
 * This function can be used with different numbers of parameters. The
 * simplest use requires only three parameters: img, x, and y—where (x, y) is
 * the position of the image. Two more parameters can optionally be added to
 * specify the width and height of the image.
 *
 * This function can also be used with all eight Number parameters. To
 * differentiate between all these parameters, p5.js uses the language of
 * "destination rectangle" (which corresponds to "dx", "dy", etc.) and "source
 * image" (which corresponds to "sx", "sy", etc.) below. Specifying the
 * "source image" dimensions can be useful when you want to display a
 * subsection of the source image instead of the whole thing. Here's a diagram
 * to explain further:
 * <img src="assets/drawImage.png"></img>
 *
 * @method image
 * @param  {p5.Image|p5.Element} img    the image to display
 * @param  {Number}   x     the x-coordinate of the top-left corner of the image
 * @param  {Number}   y     the y-coordinate of the top-left corner of the image
 * @param  {Number}   [width]  the width to draw the image
 * @param  {Number}   [height] the height to draw the image
 * @example
 * <div>
 * <code>
 * var img;
 * function preload() {
 *   img = loadImage('assets/laDefense.jpg');
 * }
 * function setup() {
 *   // Top-left corner of the img is at (0, 0)
 *   // Width and height are the img's original width and height
 *   image(img, 0, 0);
 * }
 * </code>
 * </div>
 * <div>
 * <code>
 * var img;
 * function preload() {
 *   img = loadImage('assets/laDefense.jpg');
 * }
 * function setup() {
 *   background(50);
 *   // Top-left corner of the img is at (10, 10)
 *   // Width and height are 50 x 50
 *   image(img, 10, 10, 50, 50);
 * }
 * </code>
 * </div>
 * <div>
 * <code>
 * function setup() {
 *   // Here, we use a callback to display the image after loading
 *   loadImage('assets/laDefense.jpg', function(img) {
 *     image(img, 0, 0);
 *   });
 * }
 * </code>
 * </div>
 * <div>
 * <code>
 * var img;
 * function preload() {
 *   img = loadImage('assets/gradient.png');
 * }
 * function setup() {
 *   // 1. Background image
 *   // Top-left corner of the img is at (0, 0)
 *   // Width and height are the img's original width and height, 100 x 100
 *   image(img, 0, 0);
 *   // 2. Top right image
 *   // Top-left corner of destination rectangle is at (50, 0)
 *   // Destination rectangle width and height are 40 x 20
 *   // The next parameters are relative to the source image:
 *   // - Starting at position (50, 50) on the source image, capture a 50 x 50
 *   // subsection
 *   // - Draw this subsection to fill the dimensions of the destination rectangle
 *   image(img, 50, 0, 40, 20, 50, 50, 50, 50);
 * }
 * </code>
 * </div>
 * @alt
 * image of the underside of a white umbrella and gridded ceiling above
 * image of the underside of a white umbrella and gridded ceiling above
 *
 */
/**
 * @method image
 * @param  {p5.Image|p5.Element} img
 * @param  {Number}   dx     the x-coordinate of the destination
 *                           rectangle in which to draw the source image
 * @param  {Number}   dy     the y-coordinate of the destination
 *                           rectangle in which to draw the source image
 * @param  {Number}   dWidth  the width of the destination rectangle
 * @param  {Number}   dHeight the height of the destination rectangle
 * @param  {Number}   sx     the x-coordinate of the subsection of the source
 * image to draw into the destination rectangle
 * @param  {Number}   sy     the y-coordinate of the subsection of the source
 * image to draw into the destination rectangle
 * @param {Number}    [sWidth] the width of the subsection of the
 *                           source image to draw into the destination
 *                           rectangle
 * @param {Number}    [sHeight] the height of the subsection of the
 *                            source image to draw into the destination rectangle
 */
p5.prototype.image = function(
  img,
  dx,
  dy,
  dWidth,
  dHeight,
  sx,
  sy,
  sWidth,
  sHeight
) {
  // set defaults per spec: https://goo.gl/3ykfOq

  p5._validateParameters('image', arguments);

  var defW = img.width;
  var defH = img.height;

  if (img.elt && img.elt.videoWidth && !img.canvas) {
    // video no canvas
    defW = img.elt.videoWidth;
    defH = img.elt.videoHeight;
  }

  var _dx = dx;
  var _dy = dy;
  var _dw = dWidth || defW;
  var _dh = dHeight || defH;
  var _sx = sx || 0;
  var _sy = sy || 0;
  var _sw = sWidth || defW;
  var _sh = sHeight || defH;

  _sw = _sAssign(_sw, defW);
  _sh = _sAssign(_sh, defH);

  // This part needs cleanup and unit tests
  // see issues https://github.com/processing/p5.js/issues/1741
  // and https://github.com/processing/p5.js/issues/1673
  var pd = 1;

  if (img.elt && !img.canvas && img.elt.style.width) {
    //if img is video and img.elt.size() has been used and
    //no width passed to image()
    if (img.elt.videoWidth && !dWidth) {
      pd = img.elt.videoWidth;
    } else {
      //all other cases
      pd = img.elt.width;
    }
    pd /= parseInt(img.elt.style.width, 10);
  }

  _sx *= pd;
  _sy *= pd;
  _sh *= pd;
  _sw *= pd;

  var vals = canvas.modeAdjust(_dx, _dy, _dw, _dh, this._renderer._imageMode);

  // tint the image if there is a tint
  this._renderer.image(img, _sx, _sy, _sw, _sh, vals.x, vals.y, vals.w, vals.h);
};

/**
 * Sets the fill value for displaying images. Images can be tinted to
 * specified colors or made transparent by including an alpha value.
 * <br><br>
 * To apply transparency to an image without affecting its color, use
 * white as the tint color and specify an alpha value. For instance,
 * tint(255, 128) will make an image 50% transparent (assuming the default
 * alpha range of 0-255, which can be changed with colorMode()).
 * <br><br>
 * The value for the gray parameter must be less than or equal to the current
 * maximum value as specified by colorMode(). The default maximum value is
 * 255.
 *
 *
 * @method tint
 * @param  {Number}        v1      red or hue value relative to
 *                                 the current color range
 * @param  {Number}        v2      green or saturation value
 *                                 relative to the current color range
 * @param  {Number}        v3      blue or brightness value
 *                                 relative to the current color range
 * @param  {Number}        [alpha]
 *
 * @example
 * <div>
 * <code>
 * var img;
 * function preload() {
 *   img = loadImage('assets/laDefense.jpg');
 * }
 * function setup() {
 *   image(img, 0, 0);
 *   tint(0, 153, 204); // Tint blue
 *   image(img, 50, 0);
 * }
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * var img;
 * function preload() {
 *   img = loadImage('assets/laDefense.jpg');
 * }
 * function setup() {
 *   image(img, 0, 0);
 *   tint(0, 153, 204, 126); // Tint blue and set transparency
 *   image(img, 50, 0);
 * }
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * var img;
 * function preload() {
 *   img = loadImage('assets/laDefense.jpg');
 * }
 * function setup() {
 *   image(img, 0, 0);
 *   tint(255, 126); // Apply transparency without changing color
 *   image(img, 50, 0);
 * }
 * </code>
 * </div>
 *
 * @alt
 * 2 side by side images of umbrella and ceiling, one image with blue tint
 * Images of umbrella and ceiling, one half of image with blue tint
 * 2 side by side images of umbrella and ceiling, one image translucent
 *
 */

/**
 * @method tint
 * @param  {String}        value   a color string
 * @param  {Number}        [alpha]
 */

/**
 * @method tint
 * @param  {Number[]}      values  an array containing the red,green,blue &
 *                                 and alpha components of the color
 */

/**
 * @method tint
 * @param  {p5.Color}      color   the tint color
 */
p5.prototype.tint = function() {
  p5._validateParameters('tint', arguments);
  var c = this.color.apply(this, arguments);
  this._renderer._tint = c.levels;
};

/**
 * Removes the current fill value for displaying images and reverts to
 * displaying images with their original hues.
 *
 * @method noTint
 * @example
 * <div>
 * <code>
 * var img;
 * function preload() {
 *   img = loadImage('assets/bricks.jpg');
 * }
 * function setup() {
 *   tint(0, 153, 204); // Tint blue
 *   image(img, 0, 0);
 *   noTint(); // Disable tint
 *   image(img, 50, 0);
 * }
 * </code>
 * </div>
 *
 * @alt
 * 2 side by side images of bricks, left image with blue tint
 *
 */
p5.prototype.noTint = function() {
  this._renderer._tint = null;
};

/**
 * Apply the current tint color to the input image, return the resulting
 * canvas.
 *
 * @private
 * @param {p5.Image} The image to be tinted
 * @return {canvas} The resulting tinted canvas
 *
 */
p5.prototype._getTintedImageCanvas = function(img) {
  if (!img.canvas) {
    return img;
  }
  var pixels = Filters._toPixels(img.canvas);
  var tmpCanvas = document.createElement('canvas');
  tmpCanvas.width = img.canvas.width;
  tmpCanvas.height = img.canvas.height;
  var tmpCtx = tmpCanvas.getContext('2d');
  var id = tmpCtx.createImageData(img.canvas.width, img.canvas.height);
  var newPixels = id.data;

  for (var i = 0; i < pixels.length; i += 4) {
    var r = pixels[i];
    var g = pixels[i + 1];
    var b = pixels[i + 2];
    var a = pixels[i + 3];

    newPixels[i] = r * this._renderer._tint[0] / 255;
    newPixels[i + 1] = g * this._renderer._tint[1] / 255;
    newPixels[i + 2] = b * this._renderer._tint[2] / 255;
    newPixels[i + 3] = a * this._renderer._tint[3] / 255;
  }

  tmpCtx.putImageData(id, 0, 0);
  return tmpCanvas;
};

/**
 * Set image mode. Modifies the location from which images are drawn by
 * changing the way in which parameters given to image() are interpreted.
 * The default mode is imageMode(CORNER), which interprets the second and
 * third parameters of image() as the upper-left corner of the image. If
 * two additional parameters are specified, they are used to set the image's
 * width and height.
 * <br><br>
 * imageMode(CORNERS) interprets the second and third parameters of image()
 * as the location of one corner, and the fourth and fifth parameters as the
 * opposite corner.
 * <br><br>
 * imageMode(CENTER) interprets the second and third parameters of image()
 * as the image's center point. If two additional parameters are specified,
 * they are used to set the image's width and height.
 *
 * @method imageMode
 * @param {Constant} mode either CORNER, CORNERS, or CENTER
 * @example
 *
 * <div>
 * <code>
 * var img;
 * function preload() {
 *   img = loadImage('assets/bricks.jpg');
 * }
 * function setup() {
 *   imageMode(CORNER);
 *   image(img, 10, 10, 50, 50);
 * }
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * var img;
 * function preload() {
 *   img = loadImage('assets/bricks.jpg');
 * }
 * function setup() {
 *   imageMode(CORNERS);
 *   image(img, 10, 10, 90, 40);
 * }
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * var img;
 * function preload() {
 *   img = loadImage('assets/bricks.jpg');
 * }
 * function setup() {
 *   imageMode(CENTER);
 *   image(img, 50, 50, 80, 80);
 * }
 * </code>
 * </div>
 *
 * @alt
 * small square image of bricks
 * horizontal rectangle image of bricks
 * large square image of bricks
 *
 */
p5.prototype.imageMode = function(m) {
  p5._validateParameters('imageMode', arguments);
  if (
    m === constants.CORNER ||
    m === constants.CORNERS ||
    m === constants.CENTER
  ) {
    this._renderer._imageMode = m;
  }
};

module.exports = p5;

},{"../core/canvas":20,"../core/constants":21,"../core/core":22,"../core/error_helpers":25,"./filters":41}],44:[function(_dereq_,module,exports){
/**
 * @module Image
 * @submodule Image
 * @requires core
 * @requires constants
 * @requires filters
 */

/**
 * This module defines the p5.Image class and P5 methods for
 * drawing images to the main display canvas.
 */

'use strict';

var p5 = _dereq_('../core/core');
var Filters = _dereq_('./filters');

/*
 * Class methods
 */

/**
 * Creates a new p5.Image. A p5.Image is a canvas backed representation of an
 * image.
 * <br><br>
 * p5 can display .gif, .jpg and .png images. Images may be displayed
 * in 2D and 3D space. Before an image is used, it must be loaded with the
 * loadImage() function. The p5.Image class contains fields for the width and
 * height of the image, as well as an array called pixels[] that contains the
 * values for every pixel in the image.
 * <br><br>
 * The methods described below allow easy access to the image's pixels and
 * alpha channel and simplify the process of compositing.
 * <br><br>
 * Before using the pixels[] array, be sure to use the loadPixels() method on
 * the image to make sure that the pixel data is properly loaded.
 * @example
 * <div><code>
 * function setup() {
 *   var img = createImage(100, 100); // same as new p5.Image(100, 100);
 *   img.loadPixels();
 *   createCanvas(100, 100);
 *   background(0);
 *
 *   // helper for writing color to array
 *   function writeColor(image, x, y, red, green, blue, alpha) {
 *     var index = (x + y * width) * 4;
 *     image.pixels[index] = red;
 *     image.pixels[index + 1] = green;
 *     image.pixels[index + 2] = blue;
 *     image.pixels[index + 3] = alpha;
 *   }
 *
 *   var x, y;
 *   // fill with random colors
 *   for (y = 0; y < img.height; y++) {
 *     for (x = 0; x < img.width; x++) {
 *       var red = random(255);
 *       var green = random(255);
 *       var blue = random(255);
 *       var alpha = 255;
 *       writeColor(img, x, y, red, green, blue, alpha);
 *     }
 *   }
 *
 *   // draw a red line
 *   y = 0;
 *   for (x = 0; x < img.width; x++) {
 *     writeColor(img, x, y, 255, 0, 0, 255);
 *   }
 *
 *   // draw a green line
 *   y = img.height - 1;
 *   for (x = 0; x < img.width; x++) {
 *     writeColor(img, x, y, 0, 255, 0, 255);
 *   }
 *
 *   img.updatePixels();
 *   image(img, 0, 0);
 * }
 * </code></div>
 *
 *
 * @class p5.Image
 * @constructor
 * @param {Number} width
 * @param {Number} height
 */
p5.Image = function(width, height) {
  /**
   * Image width.
   * @property {Number} width
   * @readOnly
   * @example
   * <div><code>
   * var img;
   * function preload() {
   *   img = loadImage('assets/rockies.jpg');
   * }
   *
   * function setup() {
   *   createCanvas(100, 100);
   *   image(img, 0, 0);
   *   for (var i = 0; i < img.width; i++) {
   *     var c = img.get(i, img.height / 2);
   *     stroke(c);
   *     line(i, height / 2, i, height);
   *   }
   * }
   * </code></div>
   *
   * @alt
   * rocky mountains in top and horizontal lines in corresponding colors in bottom.
   *
   */
  this.width = width;
  /**
   * Image height.
   * @property {Number} height
   * @readOnly
   * @example
   * <div><code>
   * var img;
   * function preload() {
   *   img = loadImage('assets/rockies.jpg');
   * }
   *
   * function setup() {
   *   createCanvas(100, 100);
   *   image(img, 0, 0);
   *   for (var i = 0; i < img.height; i++) {
   *     var c = img.get(img.width / 2, i);
   *     stroke(c);
   *     line(0, i, width / 2, i);
   *   }
   * }
   * </code></div>
   *
   * @alt
   * rocky mountains on right and vertical lines in corresponding colors on left.
   *
   */
  this.height = height;
  this.canvas = document.createElement('canvas');
  this.canvas.width = this.width;
  this.canvas.height = this.height;
  this.drawingContext = this.canvas.getContext('2d');
  this._pixelDensity = 1;
  //used for webgl texturing only
  this._modified = false;
  /**
   * Array containing the values for all the pixels in the display window.
   * These values are numbers. This array is the size (include an appropriate
   * factor for pixelDensity) of the display window x4,
   * representing the R, G, B, A values in order for each pixel, moving from
   * left to right across each row, then down each column. Retina and other
   * high denisty displays may have more pixels[] (by a factor of
   * pixelDensity^2).
   * For example, if the image is 100x100 pixels, there will be 40,000. With
   * pixelDensity = 2, there will be 160,000. The first four values
   * (indices 0-3) in the array will be the R, G, B, A values of the pixel at
   * (0, 0). The second four values (indices 4-7) will contain the R, G, B, A
   * values of the pixel at (1, 0). More generally, to set values for a pixel
   * at (x, y):
   * ```javascript
   * var d = pixelDensity();
   * for (var i = 0; i < d; i++) {
   *   for (var j = 0; j < d; j++) {
   *     // loop over
   *     idx = 4 * ((y * d + j) * width * d + (x * d + i));
   *     pixels[idx] = r;
   *     pixels[idx+1] = g;
   *     pixels[idx+2] = b;
   *     pixels[idx+3] = a;
   *   }
   * }
   * ```
   * <br><br>
   * Before accessing this array, the data must loaded with the loadPixels()
   * function. After the array data has been modified, the updatePixels()
   * function must be run to update the changes.
   * @property {Number[]} pixels
   * @example
   * <div>
   * <code>
   * var img = createImage(66, 66);
   * img.loadPixels();
   * for (var i = 0; i < img.width; i++) {
   *   for (var j = 0; j < img.height; j++) {
   *     img.set(i, j, color(0, 90, 102));
   *   }
   * }
   * img.updatePixels();
   * image(img, 17, 17);
   * </code>
   * </div>
   * <div>
   * <code>
   * var pink = color(255, 102, 204);
   * var img = createImage(66, 66);
   * img.loadPixels();
   * for (var i = 0; i < 4 * (width * height / 2); i += 4) {
   *   img.pixels[i] = red(pink);
   *   img.pixels[i + 1] = green(pink);
   *   img.pixels[i + 2] = blue(pink);
   *   img.pixels[i + 3] = alpha(pink);
   * }
   * img.updatePixels();
   * image(img, 17, 17);
   * </code>
   * </div>
   *
   * @alt
   * 66x66 turquoise rect in center of canvas
   * 66x66 pink rect in center of canvas
   *
   */
  this.pixels = [];
  this.name = 'p5.Image'; // for friendly debugger system
};

/**
 * Helper fxn for sharing pixel methods
 *
 */
p5.Image.prototype._setProperty = function(prop, value) {
  this[prop] = value;
  this.setModified(true);
};

/**
 * Loads the pixels data for this image into the [pixels] attribute.
 *
 * @method loadPixels
 * @example
 * <div><code>
 * var myImage;
 * var halfImage;
 *
 * function preload() {
 *   myImage = loadImage('assets/rockies.jpg');
 * }
 *
 * function setup() {
 *   myImage.loadPixels();
 *   halfImage = 4 * width * height / 2;
 *   for (var i = 0; i < halfImage; i++) {
 *     myImage.pixels[i + halfImage] = myImage.pixels[i];
 *   }
 *   myImage.updatePixels();
 * }
 *
 * function draw() {
 *   image(myImage, 0, 0);
 * }
 * </code></div>
 *
 * @alt
 * 2 images of rocky mountains vertically stacked
 *
 */
p5.Image.prototype.loadPixels = function() {
  p5.Renderer2D.prototype.loadPixels.call(this);
  this.setModified(true);
};

/**
 * Updates the backing canvas for this image with the contents of
 * the [pixels] array.
 *
 * @method updatePixels
 * @param {Integer} x x-offset of the target update area for the
 *                              underlying canvas
 * @param {Integer} y y-offset of the target update area for the
 *                              underlying canvas
 * @param {Integer} w height of the target update area for the
 *                              underlying canvas
 * @param {Integer} h height of the target update area for the
 *                              underlying canvas
 * @example
 * <div><code>
 * var myImage;
 * var halfImage;
 *
 * function preload() {
 *   myImage = loadImage('assets/rockies.jpg');
 * }
 *
 * function setup() {
 *   myImage.loadPixels();
 *   halfImage = 4 * width * height / 2;
 *   for (var i = 0; i < halfImage; i++) {
 *     myImage.pixels[i + halfImage] = myImage.pixels[i];
 *   }
 *   myImage.updatePixels();
 * }
 *
 * function draw() {
 *   image(myImage, 0, 0);
 * }
 * </code></div>
 *
 * @alt
 * 2 images of rocky mountains vertically stacked
 *
 */
/**
 * @method updatePixels
 */
p5.Image.prototype.updatePixels = function(x, y, w, h) {
  p5.Renderer2D.prototype.updatePixels.call(this, x, y, w, h);
  this.setModified(true);
};

/**
 * Get a region of pixels from an image.
 *
 * If no params are passed, those whole image is returned,
 * if x and y are the only params passed a single pixel is extracted
 * if all params are passed a rectangle region is extracted and a p5.Image
 * is returned.
 *
 * Returns undefined if the region is outside the bounds of the image
 *
 * @method get
 * @param  {Number}               [x] x-coordinate of the pixel
 * @param  {Number}               [y] y-coordinate of the pixel
 * @param  {Number}               [w] width
 * @param  {Number}               [h] height
 * @return {Number[]|Color|p5.Image}  color of pixel at x,y in array format
 *                                    [R, G, B, A] or p5.Image
 * @example
 * <div><code>
 * var myImage;
 * var c;
 *
 * function preload() {
 *   myImage = loadImage('assets/rockies.jpg');
 * }
 *
 * function setup() {
 *   background(myImage);
 *   noStroke();
 *   c = myImage.get(60, 90);
 *   fill(c);
 *   rect(25, 25, 50, 50);
 * }
 *
 * //get() returns color here
 * </code></div>
 *
 * @alt
 * image of rocky mountains with 50x50 green rect in front
 *
 */
p5.Image.prototype.get = function(x, y, w, h) {
  return p5.Renderer2D.prototype.get.call(this, x, y, w, h);
};

/**
 * Set the color of a single pixel or write an image into
 * this p5.Image.
 *
 * Note that for a large number of pixels this will
 * be slower than directly manipulating the pixels array
 * and then calling updatePixels().
 *
 * @method set
 * @param {Number}              x x-coordinate of the pixel
 * @param {Number}              y y-coordinate of the pixel
 * @param {Number|Number[]|Object}   a grayscale value | pixel array |
 *                                a p5.Color | image to copy
 * @example
 * <div>
 * <code>
 * var img = createImage(66, 66);
 * img.loadPixels();
 * for (var i = 0; i < img.width; i++) {
 *   for (var j = 0; j < img.height; j++) {
 *     img.set(i, j, color(0, 90, 102, (i % img.width) * 2));
 *   }
 * }
 * img.updatePixels();
 * image(img, 17, 17);
 * image(img, 34, 34);
 * </code>
 * </div>
 *
 * @alt
 * 2 gradated dark turquoise rects fade left. 1 center 1 bottom right of canvas
 *
 */
p5.Image.prototype.set = function(x, y, imgOrCol) {
  p5.Renderer2D.prototype.set.call(this, x, y, imgOrCol);
  this.setModified(true);
};

/**
 * Resize the image to a new width and height. To make the image scale
 * proportionally, use 0 as the value for the wide or high parameter.
 * For instance, to make the width of an image 150 pixels, and change
 * the height using the same proportion, use resize(150, 0).
 *
 * @method resize
 * @param {Number} width the resized image width
 * @param {Number} height the resized image height
 * @example
 * <div><code>
 * var img;
 *
 * function preload() {
 *   img = loadImage('assets/rockies.jpg');
 * }

 * function draw() {
 *   image(img, 0, 0);
 * }
 *
 * function mousePressed() {
 *   img.resize(50, 100);
 * }
 * </code></div>
 *
 * @alt
 * image of rocky mountains. zoomed in
 *
 */
p5.Image.prototype.resize = function(width, height) {
  // Copy contents to a temporary canvas, resize the original
  // and then copy back.
  //
  // There is a faster approach that involves just one copy and swapping the
  // this.canvas reference. We could switch to that approach if (as i think
  // is the case) there an expectation that the user would not hold a
  // reference to the backing canvas of a p5.Image. But since we do not
  // enforce that at the moment, I am leaving in the slower, but safer
  // implementation.

  // auto-resize
  if (width === 0 && height === 0) {
    width = this.canvas.width;
    height = this.canvas.height;
  } else if (width === 0) {
    width = this.canvas.width * height / this.canvas.height;
  } else if (height === 0) {
    height = this.canvas.height * width / this.canvas.width;
  }

  width = Math.floor(width);
  height = Math.floor(height);

  var tempCanvas = document.createElement('canvas');
  tempCanvas.width = width;
  tempCanvas.height = height;
  // prettier-ignore
  tempCanvas.getContext('2d').drawImage(
    this.canvas,
    0, 0, this.canvas.width, this.canvas.height,
    0, 0, tempCanvas.width, tempCanvas.height
  );

  // Resize the original canvas, which will clear its contents
  this.canvas.width = this.width = width;
  this.canvas.height = this.height = height;

  //Copy the image back

  // prettier-ignore
  this.drawingContext.drawImage(
    tempCanvas,
    0, 0, width, height,
    0, 0, width, height
  );

  if (this.pixels.length > 0) {
    this.loadPixels();
  }

  this.setModified(true);
};

/**
 * Copies a region of pixels from one image to another. If no
 * srcImage is specified this is used as the source. If the source
 * and destination regions aren't the same size, it will
 * automatically resize source pixels to fit the specified
 * target region.
 *
 * @method copy
 * @param  {p5.Image|p5.Element} srcImage source image
 * @param  {Integer} sx X coordinate of the source's upper left corner
 * @param  {Integer} sy Y coordinate of the source's upper left corner
 * @param  {Integer} sw source image width
 * @param  {Integer} sh source image height
 * @param  {Integer} dx X coordinate of the destination's upper left corner
 * @param  {Integer} dy Y coordinate of the destination's upper left corner
 * @param  {Integer} dw destination image width
 * @param  {Integer} dh destination image height
 * @example
 * <div><code>
 * var photo;
 * var bricks;
 * var x;
 * var y;
 *
 * function preload() {
 *   photo = loadImage('assets/rockies.jpg');
 *   bricks = loadImage('assets/bricks.jpg');
 * }
 *
 * function setup() {
 *   x = bricks.width / 2;
 *   y = bricks.height / 2;
 *   photo.copy(bricks, 0, 0, x, y, 0, 0, x, y);
 *   image(photo, 0, 0);
 * }
 * </code></div>
 *
 * @alt
 * image of rocky mountains and smaller image on top of bricks at top left
 *
 */
/**
 * @method copy
 * @param  {Integer} sx
 * @param  {Integer} sy
 * @param  {Integer} sw
 * @param  {Integer} sh
 * @param  {Integer} dx
 * @param  {Integer} dy
 * @param  {Integer} dw
 * @param  {Integer} dh
 */
p5.Image.prototype.copy = function() {
  var srcImage, sx, sy, sw, sh, dx, dy, dw, dh;
  if (arguments.length === 9) {
    srcImage = arguments[0];
    sx = arguments[1];
    sy = arguments[2];
    sw = arguments[3];
    sh = arguments[4];
    dx = arguments[5];
    dy = arguments[6];
    dw = arguments[7];
    dh = arguments[8];
  } else if (arguments.length === 8) {
    srcImage = this;
    sx = arguments[0];
    sy = arguments[1];
    sw = arguments[2];
    sh = arguments[3];
    dx = arguments[4];
    dy = arguments[5];
    dw = arguments[6];
    dh = arguments[7];
  } else {
    throw new Error('Signature not supported');
  }
  p5.Renderer2D._copyHelper(this, srcImage, sx, sy, sw, sh, dx, dy, dw, dh);
};

/**
 * Masks part of an image from displaying by loading another
 * image and using it's alpha channel as an alpha channel for
 * this image.
 *
 * @method mask
 * @param {p5.Image} srcImage source image
 * @example
 * <div><code>
 * var photo, maskImage;
 * function preload() {
 *   photo = loadImage('assets/rockies.jpg');
 *   maskImage = loadImage('assets/mask2.png');
 * }
 *
 * function setup() {
 *   createCanvas(100, 100);
 *   photo.mask(maskImage);
 *   image(photo, 0, 0);
 * }
 * </code></div>
 *
 * @alt
 * image of rocky mountains with white at right
 *
 *
 * http://blogs.adobe.com/webplatform/2013/01/28/blending-features-in-canvas/
 *
 */
// TODO: - Accept an array of alpha values.
//       - Use other channels of an image. p5 uses the
//       blue channel (which feels kind of arbitrary). Note: at the
//       moment this method does not match native processings original
//       functionality exactly.
p5.Image.prototype.mask = function(p5Image) {
  if (p5Image === undefined) {
    p5Image = this;
  }
  var currBlend = this.drawingContext.globalCompositeOperation;

  var scaleFactor = 1;
  if (p5Image instanceof p5.Renderer) {
    scaleFactor = p5Image._pInst._pixelDensity;
  }

  var copyArgs = [
    p5Image,
    0,
    0,
    scaleFactor * p5Image.width,
    scaleFactor * p5Image.height,
    0,
    0,
    this.width,
    this.height
  ];

  this.drawingContext.globalCompositeOperation = 'destination-in';
  p5.Image.prototype.copy.apply(this, copyArgs);
  this.drawingContext.globalCompositeOperation = currBlend;
  this.setModified(true);
};

/**
 * Applies an image filter to a p5.Image
 *
 * @method filter
 * @param  {Constant} filterType  either THRESHOLD, GRAY, OPAQUE, INVERT,
 *                                POSTERIZE, BLUR, ERODE, DILATE or BLUR.
 *                                See Filters.js for docs on
 *                                each available filter
 * @param  {Number} [filterParam] an optional parameter unique
 *                                to each filter, see above
 * @example
 * <div><code>
 * var photo1;
 * var photo2;
 *
 * function preload() {
 *   photo1 = loadImage('assets/rockies.jpg');
 *   photo2 = loadImage('assets/rockies.jpg');
 * }
 *
 * function setup() {
 *   photo2.filter('gray');
 *   image(photo1, 0, 0);
 *   image(photo2, width / 2, 0);
 * }
 * </code></div>
 *
 * @alt
 * 2 images of rocky mountains left one in color, right in black and white
 *
 */
p5.Image.prototype.filter = function(operation, value) {
  Filters.apply(this.canvas, Filters[operation.toLowerCase()], value);
  this.setModified(true);
};

/**
 * Copies a region of pixels from one image to another, using a specified
 * blend mode to do the operation.
 *
 * @method blend
 * @param  {p5.Image} srcImage source image
 * @param  {Integer} sx X coordinate of the source's upper left corner
 * @param  {Integer} sy Y coordinate of the source's upper left corner
 * @param  {Integer} sw source image width
 * @param  {Integer} sh source image height
 * @param  {Integer} dx X coordinate of the destination's upper left corner
 * @param  {Integer} dy Y coordinate of the destination's upper left corner
 * @param  {Integer} dw destination image width
 * @param  {Integer} dh destination image height
 * @param  {Constant} blendMode the blend mode. either
 *     BLEND, DARKEST, LIGHTEST, DIFFERENCE,
 *     MULTIPLY, EXCLUSION, SCREEN, REPLACE, OVERLAY, HARD_LIGHT,
 *     SOFT_LIGHT, DODGE, BURN, ADD or NORMAL.
 *
 * Available blend modes are: normal | multiply | screen | overlay |
 *            darken | lighten | color-dodge | color-burn | hard-light |
 *            soft-light | difference | exclusion | hue | saturation |
 *            color | luminosity
 *
 *
 * http://blogs.adobe.com/webplatform/2013/01/28/blending-features-in-canvas/
 * @example
 * <div><code>
 * var mountains;
 * var bricks;
 *
 * function preload() {
 *   mountains = loadImage('assets/rockies.jpg');
 *   bricks = loadImage('assets/bricks_third.jpg');
 * }
 *
 * function setup() {
 *   mountains.blend(bricks, 0, 0, 33, 100, 67, 0, 33, 100, ADD);
 *   image(mountains, 0, 0);
 *   image(bricks, 0, 0);
 * }
 * </code></div>
 * <div><code>
 * var mountains;
 * var bricks;
 *
 * function preload() {
 *   mountains = loadImage('assets/rockies.jpg');
 *   bricks = loadImage('assets/bricks_third.jpg');
 * }
 *
 * function setup() {
 *   mountains.blend(bricks, 0, 0, 33, 100, 67, 0, 33, 100, DARKEST);
 *   image(mountains, 0, 0);
 *   image(bricks, 0, 0);
 * }
 * </code></div>
 * <div><code>
 * var mountains;
 * var bricks;
 *
 * function preload() {
 *   mountains = loadImage('assets/rockies.jpg');
 *   bricks = loadImage('assets/bricks_third.jpg');
 * }
 *
 * function setup() {
 *   mountains.blend(bricks, 0, 0, 33, 100, 67, 0, 33, 100, LIGHTEST);
 *   image(mountains, 0, 0);
 *   image(bricks, 0, 0);
 * }
 * </code></div>
 *
 * @alt
 * image of rocky mountains. Brick images on left and right. Right overexposed
 * image of rockies. Brickwall images on left and right. Right mortar transparent
 * image of rockies. Brickwall images on left and right. Right translucent
 *
 */
/**
 * @method blend
 * @param  {Integer} sx
 * @param  {Integer} sy
 * @param  {Integer} sw
 * @param  {Integer} sh
 * @param  {Integer} dx
 * @param  {Integer} dy
 * @param  {Integer} dw
 * @param  {Integer} dh
 * @param  {Constant} blendMode
 */
p5.Image.prototype.blend = function() {
  p5.prototype.blend.apply(this, arguments);
  this.setModified(true);
};

/**
 * helper method for web GL mode to indicate that an image has been
 * changed or unchanged since last upload. gl texture upload will
 * set this value to false after uploading the texture.
 * @method setModified
 * @param {boolean} val sets whether or not the image has been
 * modified.
 * @private
 */
p5.Image.prototype.setModified = function(val) {
  this._modified = val; //enforce boolean?
};

/**
 * helper method for web GL mode to figure out if the image
 * has been modified and might need to be re-uploaded to texture
 * memory between frames.
 * @method isModified
 * @private
 * @return {boolean} a boolean indicating whether or not the
 * image has been updated or modified since last texture upload.
 */
p5.Image.prototype.isModified = function() {
  return this._modified;
};

/**
 * Saves the image to a file and force the browser to download it.
 * Accepts two strings for filename and file extension
 * Supports png (default) and jpg.
 *
 * @method save
 * @param {String} filename give your file a name
 * @param  {String} extension 'png' or 'jpg'
 * @example
 * <div><code>
 * var photo;
 *
 * function preload() {
 *   photo = loadImage('assets/rockies.jpg');
 * }
 *
 * function draw() {
 *   image(photo, 0, 0);
 * }
 *
 * function keyTyped() {
 *   if (key === 's') {
 *     photo.save('photo', 'png');
 *   }
 * }
 * </code></div>
 *
 * @alt
 * image of rocky mountains.
 *
 */
p5.Image.prototype.save = function(filename, extension) {
  p5.prototype.saveCanvas(this.canvas, filename, extension);
};

module.exports = p5.Image;

},{"../core/core":22,"./filters":41}],45:[function(_dereq_,module,exports){
/**
 * @module Image
 * @submodule Pixels
 * @for p5
 * @requires core
 */

'use strict';

var p5 = _dereq_('../core/core');
var Filters = _dereq_('./filters');
_dereq_('../color/p5.Color');

/**
 * <a href='https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference
 * /Global_Objects/Uint8ClampedArray' target='_blank'>Uint8ClampedArray</a>
 * containing the values for all the pixels in the display window.
 * These values are numbers. This array is the size (include an appropriate
 * factor for pixelDensity) of the display window x4,
 * representing the R, G, B, A values in order for each pixel, moving from
 * left to right across each row, then down each column. Retina and other
 * high density displays will have more pixels[] (by a factor of
 * pixelDensity^2).
 * For example, if the image is 100x100 pixels, there will be 40,000. On a
 * retina display, there will be 160,000.
 * <br><br>
 * The first four values (indices 0-3) in the array will be the R, G, B, A
 * values of the pixel at (0, 0). The second four values (indices 4-7) will
 * contain the R, G, B, A values of the pixel at (1, 0). More generally, to
 * set values for a pixel at (x, y):
 * ```javascript
 * var d = pixelDensity();
 * for (var i = 0; i < d; i++) {
 *   for (var j = 0; j < d; j++) {
 *     // loop over
 *     idx = 4 * ((y * d + j) * width * d + (x * d + i));
 *     pixels[idx] = r;
 *     pixels[idx+1] = g;
 *     pixels[idx+2] = b;
 *     pixels[idx+3] = a;
 *   }
 * }
 * ```
 * <p>While the above method is complex, it is flexible enough to work with
 * any pixelDensity. Note that set() will automatically take care of
 * setting all the appropriate values in pixels[] for a given (x, y) at
 * any pixelDensity, but the performance may not be as fast when lots of
 * modifications are made to the pixel array.
 * <br><br>
 * Before accessing this array, the data must loaded with the loadPixels()
 * function. After the array data has been modified, the updatePixels()
 * function must be run to update the changes.
 * <br><br>
 * Note that this is not a standard javascript array.  This means that
 * standard javascript functions such as <code>slice()</code> or
 * <code>arrayCopy()</code> do not
 * work.</p>
 *
 * @property {Number[]} pixels
 * @example
 * <div>
 * <code>
 * var pink = color(255, 102, 204);
 * loadPixels();
 * var d = pixelDensity();
 * var halfImage = 4 * (width * d) * (height / 2 * d);
 * for (var i = 0; i < halfImage; i += 4) {
 *   pixels[i] = red(pink);
 *   pixels[i + 1] = green(pink);
 *   pixels[i + 2] = blue(pink);
 *   pixels[i + 3] = alpha(pink);
 * }
 * updatePixels();
 * </code>
 * </div>
 *
 * @alt
 * top half of canvas pink, bottom grey
 *
 */
p5.prototype.pixels = [];

/**
 * Copies a region of pixels from one image to another, using a specified
 * blend mode to do the operation.
 *
 * @method blend
 * @param  {p5.Image} srcImage source image
 * @param  {Integer} sx X coordinate of the source's upper left corner
 * @param  {Integer} sy Y coordinate of the source's upper left corner
 * @param  {Integer} sw source image width
 * @param  {Integer} sh source image height
 * @param  {Integer} dx X coordinate of the destination's upper left corner
 * @param  {Integer} dy Y coordinate of the destination's upper left corner
 * @param  {Integer} dw destination image width
 * @param  {Integer} dh destination image height
 * @param  {Constant} blendMode the blend mode. either
 *     BLEND, DARKEST, LIGHTEST, DIFFERENCE,
 *     MULTIPLY, EXCLUSION, SCREEN, REPLACE, OVERLAY, HARD_LIGHT,
 *     SOFT_LIGHT, DODGE, BURN, ADD or NORMAL.
 *
 * @example
 * <div><code>
 * var img0;
 * var img1;
 *
 * function preload() {
 *   img0 = loadImage('assets/rockies.jpg');
 *   img1 = loadImage('assets/bricks_third.jpg');
 * }
 *
 * function setup() {
 *   background(img0);
 *   image(img1, 0, 0);
 *   blend(img1, 0, 0, 33, 100, 67, 0, 33, 100, LIGHTEST);
 * }
 * </code></div>
 * <div><code>
 * var img0;
 * var img1;
 *
 * function preload() {
 *   img0 = loadImage('assets/rockies.jpg');
 *   img1 = loadImage('assets/bricks_third.jpg');
 * }
 *
 * function setup() {
 *   background(img0);
 *   image(img1, 0, 0);
 *   blend(img1, 0, 0, 33, 100, 67, 0, 33, 100, DARKEST);
 * }
 * </code></div>
 * <div><code>
 * var img0;
 * var img1;
 *
 * function preload() {
 *   img0 = loadImage('assets/rockies.jpg');
 *   img1 = loadImage('assets/bricks_third.jpg');
 * }
 *
 * function setup() {
 *   background(img0);
 *   image(img1, 0, 0);
 *   blend(img1, 0, 0, 33, 100, 67, 0, 33, 100, ADD);
 * }
 * </code></div>
 *
 * @alt
 * image of rocky mountains. Brick images on left and right. Right overexposed
 * image of rockies. Brickwall images on left and right. Right mortar transparent
 * image of rockies. Brickwall images on left and right. Right translucent
 *
 *
 */
/**
 * @method blend
 * @param  {Integer} sx
 * @param  {Integer} sy
 * @param  {Integer} sw
 * @param  {Integer} sh
 * @param  {Integer} dx
 * @param  {Integer} dy
 * @param  {Integer} dw
 * @param  {Integer} dh
 * @param  {Constant} blendMode
 */
p5.prototype.blend = function() {
  if (this._renderer) {
    this._renderer.blend.apply(this._renderer, arguments);
  } else {
    p5.Renderer2D.prototype.blend.apply(this, arguments);
  }
};

/**
 * Copies a region of the canvas to another region of the canvas
 * and copies a region of pixels from an image used as the srcImg parameter
 * into the canvas srcImage is specified this is used as the source. If
 * the source and destination regions aren't the same size, it will
 * automatically resize source pixels to fit the specified
 * target region.
 *
 * @method copy
 * @param  {p5.Image|p5.Element} srcImage source image
 * @param  {Integer} sx X coordinate of the source's upper left corner
 * @param  {Integer} sy Y coordinate of the source's upper left corner
 * @param  {Integer} sw source image width
 * @param  {Integer} sh source image height
 * @param  {Integer} dx X coordinate of the destination's upper left corner
 * @param  {Integer} dy Y coordinate of the destination's upper left corner
 * @param  {Integer} dw destination image width
 * @param  {Integer} dh destination image height
 *
 * @example
 * <div><code>
 * var img;
 *
 * function preload() {
 *   img = loadImage('assets/rockies.jpg');
 * }
 *
 * function setup() {
 *   background(img);
 *   copy(img, 7, 22, 10, 10, 35, 25, 50, 50);
 *   stroke(255);
 *   noFill();
 *   // Rectangle shows area being copied
 *   rect(7, 22, 10, 10);
 * }
 * </code></div>
 *
 * @alt
 * image of rocky mountains. Brick images on left and right. Right overexposed
 * image of rockies. Brickwall images on left and right. Right mortar transparent
 * image of rockies. Brickwall images on left and right. Right translucent
 *
 */
/**
 * @method copy
 * @param  {Integer} sx
 * @param  {Integer} sy
 * @param  {Integer} sw
 * @param  {Integer} sh
 * @param  {Integer} dx
 * @param  {Integer} dy
 * @param  {Integer} dw
 * @param  {Integer} dh
 */
p5.prototype.copy = function() {
  p5._validateParameters('copy', arguments);
  p5.Renderer2D.prototype.copy.apply(this._renderer, arguments);
};

/**
 * Applies a filter to the canvas.
 * <br><br>
 *
 * The presets options are:
 * <br><br>
 *
 * THRESHOLD
 * Converts the image to black and white pixels depending if they are above or
 * below the threshold defined by the level parameter. The parameter must be
 * between 0.0 (black) and 1.0 (white). If no level is specified, 0.5 is used.
 * <br><br>
 *
 * GRAY
 * Converts any colors in the image to grayscale equivalents. No parameter
 * is used.
 * <br><br>
 *
 * OPAQUE
 * Sets the alpha channel to entirely opaque. No parameter is used.
 * <br><br>
 *
 * INVERT
 * Sets each pixel to its inverse value. No parameter is used.
 * <br><br>
 *
 * POSTERIZE
 * Limits each channel of the image to the number of colors specified as the
 * parameter. The parameter can be set to values between 2 and 255, but
 * results are most noticeable in the lower ranges.
 * <br><br>
 *
 * BLUR
 * Executes a Gaussian blur with the level parameter specifying the extent
 * of the blurring. If no parameter is used, the blur is equivalent to
 * Gaussian blur of radius 1. Larger values increase the blur.
 * <br><br>
 *
 * ERODE
 * Reduces the light areas. No parameter is used.
 * <br><br>
 *
 * DILATE
 * Increases the light areas. No parameter is used.
 *
 * @method filter
 * @param  {Constant} filterType  either THRESHOLD, GRAY, OPAQUE, INVERT,
 *                                POSTERIZE, BLUR, ERODE, DILATE or BLUR.
 *                                See Filters.js for docs on
 *                                each available filter
 * @param  {Number} [filterParam] an optional parameter unique
 *                                to each filter, see above
 *
 * @example
 * <div>
 * <code>
 * var img;
 * function preload() {
 *   img = loadImage('assets/bricks.jpg');
 * }
 * function setup() {
 *   image(img, 0, 0);
 *   filter(THRESHOLD);
 * }
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * var img;
 * function preload() {
 *   img = loadImage('assets/bricks.jpg');
 * }
 * function setup() {
 *   image(img, 0, 0);
 *   filter(GRAY);
 * }
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * var img;
 * function preload() {
 *   img = loadImage('assets/bricks.jpg');
 * }
 * function setup() {
 *   image(img, 0, 0);
 *   filter(OPAQUE);
 * }
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * var img;
 * function preload() {
 *   img = loadImage('assets/bricks.jpg');
 * }
 * function setup() {
 *   image(img, 0, 0);
 *   filter(INVERT);
 * }
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * var img;
 * function preload() {
 *   img = loadImage('assets/bricks.jpg');
 * }
 * function setup() {
 *   image(img, 0, 0);
 *   filter(POSTERIZE, 3);
 * }
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * var img;
 * function preload() {
 *   img = loadImage('assets/bricks.jpg');
 * }
 * function setup() {
 *   image(img, 0, 0);
 *   filter(DILATE);
 * }
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * var img;
 * function preload() {
 *   img = loadImage('assets/bricks.jpg');
 * }
 * function setup() {
 *   image(img, 0, 0);
 *   filter(BLUR, 3);
 * }
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * var img;
 * function preload() {
 *   img = loadImage('assets/bricks.jpg');
 * }
 * function setup() {
 *   image(img, 0, 0);
 *   filter(ERODE);
 * }
 * </code>
 * </div>
 *
 * @alt
 * black and white image of a brick wall.
 * greyscale image of a brickwall
 * image of a brickwall
 * jade colored image of a brickwall
 * red and pink image of a brickwall
 * image of a brickwall
 * blurry image of a brickwall
 * image of a brickwall
 * image of a brickwall with less detail
 *
 */
p5.prototype.filter = function(operation, value) {
  if (this.canvas !== undefined) {
    Filters.apply(this.canvas, Filters[operation.toLowerCase()], value);
  } else {
    Filters.apply(this.elt, Filters[operation.toLowerCase()], value);
  }
};

/**
 * Returns an array of [R,G,B,A] values for any pixel or grabs a section of
 * an image. If no parameters are specified, the entire image is returned.
 * Use the x and y parameters to get the value of one pixel. Get a section of
 * the display window by specifying additional w and h parameters. When
 * getting an image, the x and y parameters define the coordinates for the
 * upper-left corner of the image, regardless of the current imageMode().
 * <br><br>
 * If the pixel requested is outside of the image window, [0,0,0,255] is
 * returned. To get the numbers scaled according to the current color ranges
 * and taking into account colorMode, use getColor instead of get.
 * <br><br>
 * Getting the color of a single pixel with get(x, y) is easy, but not as fast
 * as grabbing the data directly from pixels[]. The equivalent statement to
 * get(x, y) using pixels[] with pixel density d is
 * <code>
 * var x, y, d; // set these to the coordinates
 * var off = (y * width + x) * d * 4;
 * var components = [
 *   pixels[off],
 *   pixels[off + 1],
 *   pixels[off + 2],
 *   pixels[off + 3]
 * ];
 * print(components);
 * </code>
 * <br><br>
 * See the reference for pixels[] for more information.
 *
 * @method get
 * @param  {Number}         [x] x-coordinate of the pixel
 * @param  {Number}         [y] y-coordinate of the pixel
 * @param  {Number}         [w] width
 * @param  {Number}         [h] height
 * @return {Number[]|p5.Image}  values of pixel at x,y in array format
 *                              [R, G, B, A] or p5.Image
 * @example
 * <div>
 * <code>
 * var img;
 * function preload() {
 *   img = loadImage('assets/rockies.jpg');
 * }
 * function setup() {
 *   image(img, 0, 0);
 *   var c = get();
 *   image(c, width / 2, 0);
 * }
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * var img;
 * function preload() {
 *   img = loadImage('assets/rockies.jpg');
 * }
 * function setup() {
 *   image(img, 0, 0);
 *   var c = get(50, 90);
 *   fill(c);
 *   noStroke();
 *   rect(25, 25, 50, 50);
 * }
 * </code>
 * </div>
 *
 * @alt
 * 2 images of the rocky mountains, side-by-side
 * Image of the rocky mountains with 50x50 green rect in center of canvas
 *
 */
p5.prototype.get = function(x, y, w, h) {
  return this._renderer.get(x, y, w, h);
};

/**
 * Loads the pixel data for the display window into the pixels[] array. This
 * function must always be called before reading from or writing to pixels[].
 * Note that only changes made with set() or direct manipulation of pixels[]
 * will occur.
 *
 * @method loadPixels
 * @example
 * <div>
 * <code>
 * var img;
 * function preload() {
 *   img = loadImage('assets/rockies.jpg');
 * }
 *
 * function setup() {
 *   image(img, 0, 0);
 *   var d = pixelDensity();
 *   var halfImage = 4 * (img.width * d) * (img.height * d / 2);
 *   loadPixels();
 *   for (var i = 0; i < halfImage; i++) {
 *     pixels[i + halfImage] = pixels[i];
 *   }
 *   updatePixels();
 * }
 * </code>
 * </div>
 *
 * @alt
 * two images of the rocky mountains. one on top, one on bottom of canvas.
 *
 */
p5.prototype.loadPixels = function() {
  this._renderer.loadPixels();
};

/**
 * <p>Changes the color of any pixel, or writes an image directly to the
 * display window.</p>
 * <p>The x and y parameters specify the pixel to change and the c parameter
 * specifies the color value. This can be a p5.Color object, or [R, G, B, A]
 * pixel array. It can also be a single grayscale value.
 * When setting an image, the x and y parameters define the coordinates for
 * the upper-left corner of the image, regardless of the current imageMode().
 * </p>
 * <p>
 * After using set(), you must call updatePixels() for your changes to appear.
 * This should be called once all pixels have been set, and must be called before
 * calling .get() or drawing the image.
 * </p>
 * <p>Setting the color of a single pixel with set(x, y) is easy, but not as
 * fast as putting the data directly into pixels[]. Setting the pixels[]
 * values directly may be complicated when working with a retina display,
 * but will perform better when lots of pixels need to be set directly on
 * every loop.</p>
 * <p>See the reference for pixels[] for more information.</p>
 *
 * @method set
 * @param {Number}              x x-coordinate of the pixel
 * @param {Number}              y y-coordinate of the pixel
 * @param {Number|Number[]|Object} c insert a grayscale value | a pixel array |
 *                                a p5.Color object | a p5.Image to copy
 * @example
 * <div>
 * <code>
 * var black = color(0);
 * set(30, 20, black);
 * set(85, 20, black);
 * set(85, 75, black);
 * set(30, 75, black);
 * updatePixels();
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * for (var i = 30; i < width - 15; i++) {
 *   for (var j = 20; j < height - 25; j++) {
 *     var c = color(204 - j, 153 - i, 0);
 *     set(i, j, c);
 *   }
 * }
 * updatePixels();
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * var img;
 * function preload() {
 *   img = loadImage('assets/rockies.jpg');
 * }
 *
 * function setup() {
 *   set(0, 0, img);
 *   updatePixels();
 *   line(0, 0, width, height);
 *   line(0, height, width, 0);
 * }
 * </code>
 * </div>
 *
 * @alt
 * 4 black points in the shape of a square middle-right of canvas.
 * square with orangey-brown gradient lightening at bottom right.
 * image of the rocky mountains. with lines like an 'x' through the center.
 */
p5.prototype.set = function(x, y, imgOrCol) {
  this._renderer.set(x, y, imgOrCol);
};
/**
 * Updates the display window with the data in the pixels[] array.
 * Use in conjunction with loadPixels(). If you're only reading pixels from
 * the array, there's no need to call updatePixels() — updating is only
 * necessary to apply changes. updatePixels() should be called anytime the
 * pixels array is manipulated or set() is called, and only changes made with
 * set() or direct changes to pixels[] will occur.
 *
 * @method updatePixels
 * @param  {Number} [x]    x-coordinate of the upper-left corner of region
 *                         to update
 * @param  {Number} [y]    y-coordinate of the upper-left corner of region
 *                         to update
 * @param  {Number} [w]    width of region to update
 * @param  {Number} [h]    height of region to update
 * @example
 * <div>
 * <code>
 * var img;
 * function preload() {
 *   img = loadImage('assets/rockies.jpg');
 * }
 *
 * function setup() {
 *   image(img, 0, 0);
 *   var d = pixelDensity();
 *   var halfImage = 4 * (img.width * d) * (img.height * d / 2);
 *   loadPixels();
 *   for (var i = 0; i < halfImage; i++) {
 *     pixels[i + halfImage] = pixels[i];
 *   }
 *   updatePixels();
 * }
 * </code>
 * </div>
 * @alt
 * two images of the rocky mountains. one on top, one on bottom of canvas.
 */
p5.prototype.updatePixels = function(x, y, w, h) {
  // graceful fail - if loadPixels() or set() has not been called, pixel
  // array will be empty, ignore call to updatePixels()
  if (this.pixels.length === 0) {
    return;
  }
  this._renderer.updatePixels(x, y, w, h);
};

module.exports = p5;

},{"../color/p5.Color":16,"../core/core":22,"./filters":41}],46:[function(_dereq_,module,exports){
/**
 * @module IO
 * @submodule Input
 * @for p5
 * @requires core
 */

/* globals Request: false */
/* globals Headers: false */

'use strict';

var p5 = _dereq_('../core/core');
_dereq_('whatwg-fetch');
_dereq_('es6-promise').polyfill();
var fetchJsonp = _dereq_('fetch-jsonp');
_dereq_('../core/error_helpers');

/**
 * Loads a JSON file from a file or a URL, and returns an Object.
 * Note that even if the JSON file contains an Array, an Object will be
 * returned with index numbers as keys.
 *
 * This method is asynchronous, meaning it may not finish before the next
 * line in your sketch is executed. JSONP is supported via a polyfill and you
 * can pass in as the second argument an object with definitions of the json
 * callback following the syntax specified <a href="https://github.com/camsong/
 * fetch-jsonp">here</a>.
 *
 * @method loadJSON
 * @param  {String}        path       name of the file or url to load
 * @param  {Object}        [jsonpOptions] options object for jsonp related settings
 * @param  {String}        [datatype] "json" or "jsonp"
 * @param  {function}      [callback] function to be executed after
 *                                    loadJSON() completes, data is passed
 *                                    in as first argument
 * @param  {function}      [errorCallback] function to be executed if
 *                                    there is an error, response is passed
 *                                    in as first argument
 * @return {Object|Array}             JSON data
 * @example
 *
 * <p>Calling loadJSON() inside preload() guarantees to complete the
 * operation before setup() and draw() are called.</p>
 *
 * <div><code>
 * // Examples use USGS Earthquake API:
 * //   https://earthquake.usgs.gov/fdsnws/event/1/#methods
 * var earthquakes;
 * function preload() {
 *   // Get the most recent earthquake in the database
 *   var url =
    'https://earthquake.usgs.gov/earthquakes/feed/v1.0/' +
 *     'summary/all_day.geojson';
 *   earthquakes = loadJSON(url);
 * }
 *
 * function setup() {
 *   noLoop();
 * }
 *
 * function draw() {
 *   background(200);
 *   // Get the magnitude and name of the earthquake out of the loaded JSON
 *   var earthquakeMag = earthquakes.features[0].properties.mag;
 *   var earthquakeName = earthquakes.features[0].properties.place;
 *   ellipse(width / 2, height / 2, earthquakeMag * 10, earthquakeMag * 10);
 *   textAlign(CENTER);
 *   text(earthquakeName, 0, height - 30, width, 30);
 * }
 * </code></div>
 *
 *
 * <p>Outside of preload(), you may supply a callback function to handle the
 * object:</p>
 * <div><code>
 * function setup() {
 *   noLoop();
 *   var url =
    'https://earthquake.usgs.gov/earthquakes/feed/v1.0/' +
 *     'summary/all_day.geojson';
 *   loadJSON(url, drawEarthquake);
 * }
 *
 * function draw() {
 *   background(200);
 * }
 *
 * function drawEarthquake(earthquakes) {
 *   // Get the magnitude and name of the earthquake out of the loaded JSON
 *   var earthquakeMag = earthquakes.features[0].properties.mag;
 *   var earthquakeName = earthquakes.features[0].properties.place;
 *   ellipse(width / 2, height / 2, earthquakeMag * 10, earthquakeMag * 10);
 *   textAlign(CENTER);
 *   text(earthquakeName, 0, height - 30, width, 30);
 * }
 * </code></div>
 *
 * @alt
 * 50x50 ellipse that changes from black to white depending on the current humidity
 * 50x50 ellipse that changes from black to white depending on the current humidity
 *
 */
p5.prototype.loadJSON = function() {
  var path = arguments[0];
  var callback;
  var errorCallback;
  var options;

  var ret = {}; // object needed for preload
  var t = 'json';

  // check for explicit data type argument
  for (var i = 1; i < arguments.length; i++) {
    var arg = arguments[i];
    if (typeof arg === 'string') {
      if (arg === 'jsonp' || arg === 'json') {
        t = arg;
      }
    } else if (typeof arg === 'function') {
      if (!callback) {
        callback = arg;
      } else {
        errorCallback = arg;
      }
    } else if (typeof arg === 'object' && arg.hasOwnProperty('jsonpCallback')) {
      t = 'jsonp';
      options = arg;
    }
  }

  var self = this;
  this.httpDo(
    path,
    'GET',
    options,
    t,
    function(resp) {
      for (var k in resp) {
        ret[k] = resp[k];
      }
      if (typeof callback !== 'undefined') {
        callback(resp);
      }

      self._decrementPreload();
    },
    errorCallback
  );

  return ret;
};

/**
 * Reads the contents of a file and creates a String array of its individual
 * lines. If the name of the file is used as the parameter, as in the above
 * example, the file must be located in the sketch directory/folder.
 * <br><br>
 * Alternatively, the file maybe be loaded from anywhere on the local
 * computer using an absolute path (something that starts with / on Unix and
 * Linux, or a drive letter on Windows), or the filename parameter can be a
 * URL for a file found on a network.
 * <br><br>
 * This method is asynchronous, meaning it may not finish before the next
 * line in your sketch is executed.
 *
 * @method loadStrings
 * @param  {String}   filename   name of the file or url to load
 * @param  {function} [callback] function to be executed after loadStrings()
 *                               completes, Array is passed in as first
 *                               argument
 * @param  {function} [errorCallback] function to be executed if
 *                               there is an error, response is passed
 *                               in as first argument
 * @return {String[]}            Array of Strings
 * @example
 *
 * <p>Calling loadStrings() inside preload() guarantees to complete the
 * operation before setup() and draw() are called.</p>
 *
 * <div><code>
 * var result;
 * function preload() {
 *   result = loadStrings('assets/test.txt');
 * }

 * function setup() {
 *   background(200);
 *   var ind = floor(random(result.length));
 *   text(result[ind], 10, 10, 80, 80);
 * }
 * </code></div>
 *
 * <p>Outside of preload(), you may supply a callback function to handle the
 * object:</p>
 *
 * <div><code>
 * function setup() {
 *   loadStrings('assets/test.txt', pickString);
 * }
 *
 * function pickString(result) {
 *   background(200);
 *   var ind = floor(random(result.length));
 *   text(result[ind], 10, 10, 80, 80);
 * }
 * </code></div>
 *
 * @alt
 * randomly generated text from a file, for example "i smell like butter"
 * randomly generated text from a file, for example "i have three feet"
 *
 */
p5.prototype.loadStrings = function() {
  var ret = [];
  var callback, errorCallback;

  for (var i = 1; i < arguments.length; i++) {
    var arg = arguments[i];
    if (typeof arg === 'function') {
      if (typeof callback === 'undefined') {
        callback = arg;
      } else if (typeof errorCallback === 'undefined') {
        errorCallback = arg;
      }
    }
  }

  var self = this;
  p5.prototype.httpDo.call(
    this,
    arguments[0],
    'GET',
    'text',
    function(data) {
      var arr = data.match(/[^\r\n]+/g);
      for (var k in arr) {
        ret[k] = arr[k];
      }

      if (typeof callback !== 'undefined') {
        callback(ret);
      }

      self._decrementPreload();
    },
    errorCallback
  );

  return ret;
};

/**
 * <p>Reads the contents of a file or URL and creates a p5.Table object with
 * its values. If a file is specified, it must be located in the sketch's
 * "data" folder. The filename parameter can also be a URL to a file found
 * online. By default, the file is assumed to be comma-separated (in CSV
 * format). Table only looks for a header row if the 'header' option is
 * included.</p>
 *
 * <p>Possible options include:
 * <ul>
 * <li>csv - parse the table as comma-separated values</li>
 * <li>tsv - parse the table as tab-separated values</li>
 * <li>header - this table has a header (title) row</li>
 * </ul>
 * </p>
 *
 * <p>When passing in multiple options, pass them in as separate parameters,
 * seperated by commas. For example:
 * <br><br>
 * <code>
 * loadTable('my_csv_file.csv', 'csv', 'header');
 * </code>
 * </p>
 *
 * <p> All files loaded and saved use UTF-8 encoding.</p>
 *
 * <p>This method is asynchronous, meaning it may not finish before the next
 * line in your sketch is executed. Calling loadTable() inside preload()
 * guarantees to complete the operation before setup() and draw() are called.
 * <p>Outside of preload(), you may supply a callback function to handle the
 * object:</p>
 * </p>
 *
 * @method loadTable
 * @param  {String}         filename   name of the file or URL to load
 * @param  {String}         options  "header" "csv" "tsv"
 * @param  {function}       [callback] function to be executed after
 *                                     loadTable() completes. On success, the
 *                                     Table object is passed in as the
 *                                     first argument.
 * @param  {function}  [errorCallback] function to be executed if
 *                                     there is an error, response is passed
 *                                     in as first argument
 * @return {Object}                    Table object containing data
 *
 * @example
 * <div class="norender">
 * <code>
 * // Given the following CSV file called "mammals.csv"
 * // located in the project's "assets" folder:
 * //
 * // id,species,name
 * // 0,Capra hircus,Goat
 * // 1,Panthera pardus,Leopard
 * // 2,Equus zebra,Zebra
 *
 * var table;
 *
 * function preload() {
 *   //my table is comma separated value "csv"
 *   //and has a header specifying the columns labels
 *   table = loadTable('assets/mammals.csv', 'csv', 'header');
 *   //the file can be remote
 *   //table = loadTable("http://p5js.org/reference/assets/mammals.csv",
 *   //                  "csv", "header");
 * }
 *
 * function setup() {
 *   //count the columns
 *   print(table.getRowCount() + ' total rows in table');
 *   print(table.getColumnCount() + ' total columns in table');
 *
 *   print(table.getColumn('name'));
 *   //["Goat", "Leopard", "Zebra"]
 *
 *   //cycle through the table
 *   for (var r = 0; r < table.getRowCount(); r++)
 *     for (var c = 0; c < table.getColumnCount(); c++) {
 *       print(table.getString(r, c));
 *     }
 * }
 * </code>
 * </div>
 *
 * @alt
 * randomly generated text from a file, for example "i smell like butter"
 * randomly generated text from a file, for example "i have three feet"
 *
 */
/**
 * @method loadTable
 * @param  {String}         filename
 * @param  {function}       [callback]
 * @param  {function}  [errorCallback]
 * @return {Object}
 */
p5.prototype.loadTable = function(path) {
  var callback;
  var errorCallback;
  var options = [];
  var header = false;
  var ext = path.substring(path.lastIndexOf('.') + 1, path.length);
  var sep = ',';
  var separatorSet = false;

  if (ext === 'tsv') {
    //Only need to check extension is tsv because csv is default
    sep = '\t';
  }

  for (var i = 1; i < arguments.length; i++) {
    if (typeof arguments[i] === 'function') {
      if (typeof callback === 'undefined') {
        callback = arguments[i];
      } else if (typeof errorCallback === 'undefined') {
        errorCallback = arguments[i];
      }
    } else if (typeof arguments[i] === 'string') {
      options.push(arguments[i]);
      if (arguments[i] === 'header') {
        header = true;
      }
      if (arguments[i] === 'csv') {
        if (separatorSet) {
          throw new Error('Cannot set multiple separator types.');
        } else {
          sep = ',';
          separatorSet = true;
        }
      } else if (arguments[i] === 'tsv') {
        if (separatorSet) {
          throw new Error('Cannot set multiple separator types.');
        } else {
          sep = '\t';
          separatorSet = true;
        }
      }
    }
  }

  var t = new p5.Table();

  var self = this;
  this.httpDo(
    path,
    'GET',
    'text',
    function(resp) {
      var state = {};

      // define constants
      var PRE_TOKEN = 0,
        MID_TOKEN = 1,
        POST_TOKEN = 2,
        POST_RECORD = 4;

      var QUOTE = '"',
        CR = '\r',
        LF = '\n';

      var records = [];
      var offset = 0;
      var currentRecord = null;
      var currentChar;

      var tokenBegin = function() {
        state.currentState = PRE_TOKEN;
        state.token = '';
      };

      var tokenEnd = function() {
        currentRecord.push(state.token);
        tokenBegin();
      };

      var recordBegin = function() {
        state.escaped = false;
        currentRecord = [];
        tokenBegin();
      };

      var recordEnd = function() {
        state.currentState = POST_RECORD;
        records.push(currentRecord);
        currentRecord = null;
      };

      for (;;) {
        currentChar = resp[offset++];

        // EOF
        if (currentChar == null) {
          if (state.escaped) {
            throw new Error('Unclosed quote in file.');
          }
          if (currentRecord) {
            tokenEnd();
            recordEnd();
            break;
          }
        }
        if (currentRecord === null) {
          recordBegin();
        }

        // Handle opening quote
        if (state.currentState === PRE_TOKEN) {
          if (currentChar === QUOTE) {
            state.escaped = true;
            state.currentState = MID_TOKEN;
            continue;
          }
          state.currentState = MID_TOKEN;
        }

        // mid-token and escaped, look for sequences and end quote
        if (state.currentState === MID_TOKEN && state.escaped) {
          if (currentChar === QUOTE) {
            if (resp[offset] === QUOTE) {
              state.token += QUOTE;
              offset++;
            } else {
              state.escaped = false;
              state.currentState = POST_TOKEN;
            }
          } else if (currentChar === CR) {
            continue;
          } else {
            state.token += currentChar;
          }
          continue;
        }

        // fall-through: mid-token or post-token, not escaped
        if (currentChar === CR) {
          if (resp[offset] === LF) {
            offset++;
          }
          tokenEnd();
          recordEnd();
        } else if (currentChar === LF) {
          tokenEnd();
          recordEnd();
        } else if (currentChar === sep) {
          tokenEnd();
        } else if (state.currentState === MID_TOKEN) {
          state.token += currentChar;
        }
      }

      // set up column names
      if (header) {
        t.columns = records.shift();
      } else {
        for (i = 0; i < records[0].length; i++) {
          t.columns[i] = 'null';
        }
      }
      var row;
      for (i = 0; i < records.length; i++) {
        //Handles row of 'undefined' at end of some CSVs
        if (records[i].length === 1) {
          if (records[i][0] === 'undefined' || records[i][0] === '') {
            continue;
          }
        }
        row = new p5.TableRow();
        row.arr = records[i];
        row.obj = makeObject(records[i], t.columns);
        t.addRow(row);
      }
      if (typeof callback === 'function') {
        callback(t);
      }

      self._decrementPreload();
    },
    function(err) {
      // Error handling
      p5._friendlyFileLoadError(2, path);

      if (errorCallback) {
        errorCallback(err);
      } else {
        throw err;
      }
    }
  );

  return t;
};

// helper function to turn a row into a JSON object
function makeObject(row, headers) {
  var ret = {};
  headers = headers || [];
  if (typeof headers === 'undefined') {
    for (var j = 0; j < row.length; j++) {
      headers[j.toString()] = j;
    }
  }
  for (var i = 0; i < headers.length; i++) {
    var key = headers[i];
    var val = row[i];
    ret[key] = val;
  }
  return ret;
}

/*global parseXML */
p5.prototype.parseXML = function(two) {
  var one = new p5.XML();
  var i;
  if (two.children.length) {
    for (i = 0; i < two.children.length; i++) {
      var node = parseXML(two.children[i]);
      one.addChild(node);
    }
    one.setName(two.nodeName);
    one._setCont(two.textContent);
    one._setAttributes(two);
    for (var j = 0; j < one.children.length; j++) {
      one.children[j].parent = one;
    }
    return one;
  } else {
    one.setName(two.nodeName);
    one._setCont(two.textContent);
    one._setAttributes(two);
    return one;
  }
};

/**
 * Reads the contents of a file and creates an XML object with its values.
 * If the name of the file is used as the parameter, as in the above example,
 * the file must be located in the sketch directory/folder.
 *
 * Alternatively, the file maybe be loaded from anywhere on the local
 * computer using an absolute path (something that starts with / on Unix and
 * Linux, or a drive letter on Windows), or the filename parameter can be a
 * URL for a file found on a network.
 *
 * This method is asynchronous, meaning it may not finish before the next
 * line in your sketch is executed. Calling loadXML() inside preload()
 * guarantees to complete the operation before setup() and draw() are called.
 *
 * Outside of preload(), you may supply a callback function to handle the
 * object.
 *
 * @method loadXML
 * @param  {String}   filename   name of the file or URL to load
 * @param  {function} [callback] function to be executed after loadXML()
 *                               completes, XML object is passed in as
 *                               first argument
 * @param  {function} [errorCallback] function to be executed if
 *                               there is an error, response is passed
 *                               in as first argument
 * @return {Object}              XML object containing data
 * @example
 * <div class='norender'><code>
 * // The following short XML file called "mammals.xml" is parsed
 * // in the code below.
 * //
 * // <?xml version="1.0"?>
 * // &lt;mammals&gt;
 * //   &lt;animal id="0" species="Capra hircus">Goat&lt;/animal&gt;
 * //   &lt;animal id="1" species="Panthera pardus">Leopard&lt;/animal&gt;
 * //   &lt;animal id="2" species="Equus zebra">Zebra&lt;/animal&gt;
 * // &lt;/mammals&gt;
 *
 * var xml;
 *
 * function preload() {
 *   xml = loadXML('assets/mammals.xml');
 * }
 *
 * function setup() {
 *   var children = xml.getChildren('animal');
 *
 *   for (var i = 0; i < children.length; i++) {
 *     var id = children[i].getNum('id');
 *     var coloring = children[i].getString('species');
 *     var name = children[i].getContent();
 *     print(id + ', ' + coloring + ', ' + name);
 *   }
 * }
 *
 * // Sketch prints:
 * // 0, Capra hircus, Goat
 * // 1, Panthera pardus, Leopard
 * // 2, Equus zebra, Zebra
 * </code></div>
 *
 * @alt
 * no image displayed
 *
 */
p5.prototype.loadXML = function() {
  var ret = {};
  var callback, errorCallback;

  for (var i = 1; i < arguments.length; i++) {
    var arg = arguments[i];
    if (typeof arg === 'function') {
      if (typeof callback === 'undefined') {
        callback = arg;
      } else if (typeof errorCallback === 'undefined') {
        errorCallback = arg;
      }
    }
  }

  var self = this;
  this.httpDo(
    arguments[0],
    'GET',
    'xml',
    function(xml) {
      for (var key in xml) {
        ret[key] = xml[key];
      }
      if (typeof callback !== 'undefined') {
        callback(ret);
      }

      self._decrementPreload();
    },
    errorCallback
  );

  return ret;
};

/**
 * Method for executing an HTTP GET request. If data type is not specified,
 * p5 will try to guess based on the URL, defaulting to text. This is equivalent to
 * calling <code>httpDo(path, 'GET')</code>.
 *
 * @method httpGet
 * @param  {String}        path       name of the file or url to load
 * @param  {String}        [datatype] "json", "jsonp", "xml", or "text"
 * @param  {Object}        [data]     param data passed sent with request
 * @param  {function}      [callback] function to be executed after
 *                                    httpGet() completes, data is passed in
 *                                    as first argument
 * @param  {function}      [errorCallback] function to be executed if
 *                                    there is an error, response is passed
 *                                    in as first argument
 * @example
 * <div class='norender'><code>
 * // Examples use USGS Earthquake API:
 * //   https://earthquake.usgs.gov/fdsnws/event/1/#methods
 * var earthquakes;
 * function preload() {
 *   // Get the most recent earthquake in the database
 *   var url =
    'https://earthquake.usgs.gov/fdsnws/event/1/query?' +
 *     'format=geojson&limit=1&orderby=time';
 *   httpGet(url, 'jsonp', false, function(response) {
 *     // when the HTTP request completes, populate the variable that holds the
 *     // earthquake data used in the visualization.
 *     earthquakes = response;
 *   });
 * }
 *
 * function draw() {
 *   if (!earthquakes) {
 *     // Wait until the earthquake data has loaded before drawing.
 *     return;
 *   }
 *   background(200);
 *   // Get the magnitude and name of the earthquake out of the loaded JSON
 *   var earthquakeMag = earthquakes.features[0].properties.mag;
 *   var earthquakeName = earthquakes.features[0].properties.place;
 *   ellipse(width / 2, height / 2, earthquakeMag * 10, earthquakeMag * 10);
 *   textAlign(CENTER);
 *   text(earthquakeName, 0, height - 30, width, 30);
 *   noLoop();
 * }
 * </code></div>
 */
p5.prototype.httpGet = function() {
  var args = Array.prototype.slice.call(arguments);
  args.splice(1, 0, 'GET');
  p5.prototype.httpDo.apply(this, args);
};

/**
 * Method for executing an HTTP POST request. If data type is not specified,
 * p5 will try to guess based on the URL, defaulting to text. This is equivalent to
 * calling <code>httpDo(path, 'POST')</code>.
 *
 * @method httpPost
 * @param  {String}        path       name of the file or url to load
 * @param  {String}        [datatype] "json", "jsonp", "xml", or "text".
 *                                    If omitted, httpPost() will guess.
 * @param  {Object}        [data]     param data passed sent with request
 * @param  {function}      [callback] function to be executed after
 *                                    httpPost() completes, data is passed in
 *                                    as first argument
 * @param  {function}      [errorCallback] function to be executed if
 *                                    there is an error, response is passed
 *                                    in as first argument
 *
 * @example
 * <div>
 * <code>
 * // Examples use jsonplaceholder.typicode.com for a Mock Data API
 *
 * var url = 'https://jsonplaceholder.typicode.com/posts';
 * var postData = { userId: 1, title: 'p5 Clicked!', body: 'p5.js is way cool.' };
 *
 * function setup() {
 *   createCanvas(800, 800);
 * }
 *
 * function mousePressed() {
 *   // Pick new random color values
 *   var r = random(255);
 *   var g = random(255);
 *   var b = random(255);
 *
 *   httpPost(url, 'json', postData, function(result) {
 *     strokeWeight(2);
 *     stroke(r, g, b);
 *     fill(r, g, b, 127);
 *     ellipse(mouseX, mouseY, 200, 200);
 *     text(result.body, mouseX, mouseY);
 *   });
 * }
 * </code>
 * </div>
 *
 *
 * <div><code>
 * var url = 'https://invalidURL'; // A bad URL that will cause errors
 * var postData = { title: 'p5 Clicked!', body: 'p5.js is way cool.' };
 *
 * function setup() {
 *   createCanvas(800, 800);
 * }
 *
 * function mousePressed() {
 *   // Pick new random color values
 *   var r = random(255);
 *   var g = random(255);
 *   var b = random(255);
 *
 *   httpPost(
 *     url,
 *     'json',
 *     postData,
 *     function(result) {
 *       // ... won't be called
 *     },
 *     function(error) {
 *       strokeWeight(2);
 *       stroke(r, g, b);
 *       fill(r, g, b, 127);
 *       text(error.toString(), mouseX, mouseY);
 *     }
 *   );
 * }
 * </code></div>
 *
 */
p5.prototype.httpPost = function() {
  var args = Array.prototype.slice.call(arguments);
  args.splice(1, 0, 'POST');
  p5.prototype.httpDo.apply(this, args);
};

/**
 * Method for executing an HTTP request. If data type is not specified,
 * p5 will try to guess based on the URL, defaulting to text.<br><br>
 * For more advanced use, you may also pass in the path as the first argument
 * and a object as the second argument, the signature follows the one specified
 * in the Fetch API specification.
 *
 * @method httpDo
 * @param  {String}        path       name of the file or url to load
 * @param  {String}        [method]   either "GET", "POST", or "PUT",
 *                                    defaults to "GET"
 * @param  {String}        [datatype] "json", "jsonp", "xml", or "text"
 * @param  {Object}        [data]     param data passed sent with request
 * @param  {function}      [callback] function to be executed after
 *                                    httpGet() completes, data is passed in
 *                                    as first argument
 * @param  {function}      [errorCallback] function to be executed if
 *                                    there is an error, response is passed
 *                                    in as first argument
 *
 *
 * @example
 * <div>
 * <code>
 * // Examples use USGS Earthquake API:
 * // https://earthquake.usgs.gov/fdsnws/event/1/#methods
 *
 * // displays an animation of all USGS earthquakes
 * var earthquakes;
 * var eqFeatureIndex = 0;
 *
 * function preload() {
 *   var url = 'https://earthquake.usgs.gov/fdsnws/event/1/query?format=geojson';
 *   httpDo(
 *     url,
 *     {
 *       method: 'GET',
 *       // Other Request options, like special headers for apis
 *       headers: { authorization: 'Bearer secretKey' }
 *     },
 *     function(res) {
 *       earthquakes = res;
 *     }
 *   );
 * }
 *
 * function draw() {
 *   // wait until the data is loaded
 *   if (!earthquakes || !earthquakes.features[eqFeatureIndex]) {
 *     return;
 *   }
 *   clear();
 *
 *   var feature = earthquakes.features[eqFeatureIndex];
 *   var mag = feature.properties.mag;
 *   var rad = mag / 11 * ((width + height) / 2);
 *   fill(255, 0, 0, 100);
 *   ellipse(width / 2 + random(-2, 2), height / 2 + random(-2, 2), rad, rad);
 *
 *   if (eqFeatureIndex >= earthquakes.features.length) {
 *     eqFeatureIndex = 0;
 *   } else {
 *     eqFeatureIndex += 1;
 *   }
 * }
 * </code>
 * </div>
 */

/**
 * @method httpDo
 * @param  {String}        path
 * @param  {Object}        options   Request object options as documented in the
 *                                    "fetch" API
 * <a href="https://developer.mozilla.org/en/docs/Web/API/Fetch_API">reference</a>
 * @param  {function}      [callback]
 * @param  {function}      [errorCallback]
 */
p5.prototype.httpDo = function() {
  var type = '';
  var callback;
  var errorCallback;
  var request;
  var jsonpOptions = {};
  var cbCount = 0;
  var contentType = 'text/plain';
  // Trim the callbacks off the end to get an idea of how many arguments are passed
  for (var i = arguments.length - 1; i > 0; i--) {
    if (typeof arguments[i] === 'function') {
      cbCount++;
    } else {
      break;
    }
  }
  // The number of arguments minus callbacks
  var argsCount = arguments.length - cbCount;
  if (
    argsCount === 2 &&
    typeof arguments[0] === 'string' &&
    typeof arguments[1] === 'object'
  ) {
    // Intended for more advanced use, pass in Request parameters directly
    request = new Request(arguments[0], arguments[1]);
    callback = arguments[2];
    errorCallback = arguments[3];

    // do some sort of smart type checking
    if (type === '') {
      if (request.url.indexOf('json') !== -1) {
        type = 'json';
      } else if (request.url.indexOf('xml') !== -1) {
        type = 'xml';
      } else {
        type = 'text';
      }
    }
  } else {
    // Provided with arguments
    var path = arguments[0];
    var method = 'GET';
    var data;

    for (var j = 1; j < arguments.length; j++) {
      var a = arguments[j];
      if (typeof a === 'string') {
        if (a === 'GET' || a === 'POST' || a === 'PUT' || a === 'DELETE') {
          method = a;
        } else if (
          a === 'json' ||
          a === 'jsonp' ||
          a === 'xml' ||
          a === 'text'
        ) {
          type = a;
        } else {
          data = a;
        }
      } else if (typeof a === 'number') {
        data = a.toString();
      } else if (typeof a === 'object') {
        if (a.hasOwnProperty('jsonpCallback')) {
          for (var attr in a) {
            jsonpOptions[attr] = a[attr];
          }
        } else {
          data = JSON.stringify(a);
          contentType = 'application/json';
        }
      } else if (typeof a === 'function') {
        if (!callback) {
          callback = a;
        } else {
          errorCallback = a;
        }
      }
    }
    // do some sort of smart type checking
    if (type === '') {
      if (path.indexOf('json') !== -1) {
        type = 'json';
      } else if (path.indexOf('xml') !== -1) {
        type = 'xml';
      } else {
        type = 'text';
      }
    }

    request = new Request(path, {
      method: method,
      mode: 'cors',
      body: data,
      headers: new Headers({
        'Content-Type': contentType
      })
    });
  }

  if (type === 'jsonp') {
    fetchJsonp(arguments[0], jsonpOptions)
      .then(function(res) {
        if (res.ok) {
          return res.json();
        }
        throw res;
      })
      .then(function(resp) {
        callback(resp);
      })
      .catch(function(err) {
        if (errorCallback) {
          errorCallback(err);
        } else {
          throw err;
        }
      });
  } else {
    fetch(request)
      .then(function(res) {
        if (res.ok) {
          if (type === 'json') {
            return res.json();
          } else {
            return res.text();
          }
        }

        throw res;
      })
      .then(function(resp) {
        if (type === 'xml') {
          var parser = new DOMParser();
          resp = parser.parseFromString(resp, 'text/xml');
          resp = parseXML(resp.documentElement);
        }
        callback(resp);
      })
      .catch(function(err, msg) {
        if (errorCallback) {
          errorCallback(err);
        } else {
          throw err;
        }
      });
  }
};

/**
 * @module IO
 * @submodule Output
 * @for p5
 */

window.URL = window.URL || window.webkitURL;

// private array of p5.PrintWriter objects
p5.prototype._pWriters = [];

/**
 * @method createWriter
 * @param {String} name name of the file to be created
 * @param {String} [extension]
 * @return {p5.PrintWriter}
 * @example
 * <div>
 * <code>
 * createButton('save')
 *   .position(10, 10)
 *   .mousePressed(function() {
 *     var writer = createWriter('squares.txt');
 *     for (var i = 0; i < 10; i++) {
 *       writer.print(i * i);
 *     }
 *     writer.close();
 *     writer.flush();
 *   });
 * </code>
 * </div>
 */
p5.prototype.createWriter = function(name, extension) {
  var newPW;
  // check that it doesn't already exist
  for (var i in p5.prototype._pWriters) {
    if (p5.prototype._pWriters[i].name === name) {
      // if a p5.PrintWriter w/ this name already exists...
      // return p5.prototype._pWriters[i]; // return it w/ contents intact.
      // or, could return a new, empty one with a unique name:
      newPW = new p5.PrintWriter(name + window.millis(), extension);
      p5.prototype._pWriters.push(newPW);
      return newPW;
    }
  }
  newPW = new p5.PrintWriter(name, extension);
  p5.prototype._pWriters.push(newPW);
  return newPW;
};

/**
 *  @class p5.PrintWriter
 *  @constructor
 *  @param  {String}     filename
 *  @param  {String}     [extension]
 */
p5.PrintWriter = function(filename, extension) {
  var self = this;
  this.name = filename;
  this.content = '';
  //Changed to write because it was being overloaded by function below.
  /**
   * @method write
   * @param {Array} data
   */
  this.write = function(data) {
    this.content += data;
  };
  /**
   * @method print
   * @param {Array} data
   */
  this.print = function(data) {
    this.content += data + '\n';
  };
  /**
   * @method flush
   */
  this.flush = function() {
    this.content = '';
  };
  /**
   * @method close
   */
  this.close = function() {
    // convert String to Array for the writeFile Blob
    var arr = [];
    arr.push(this.content);
    p5.prototype.writeFile(arr, filename, extension);
    // remove from _pWriters array and delete self
    for (var i in p5.prototype._pWriters) {
      if (p5.prototype._pWriters[i].name === this.name) {
        // remove from _pWriters array
        p5.prototype._pWriters.splice(i, 1);
      }
    }
    self.flush();
    self = {};
  };
};

/**
 * @module IO
 * @submodule Output
 * @for p5
 */

// object, filename, options --> saveJSON, saveStrings,
// filename, [extension] [canvas] --> saveImage

/**
 *  <p>Save an image, text, json, csv, wav, or html. Prompts download to
 *  the client's computer. <b>Note that it is not recommended to call save()
 *  within draw if it's looping, as the save() function will open a new save
 *  dialog every frame.</b></p>
 *  <p>The default behavior is to save the canvas as an image. You can
 *  optionally specify a filename.
 *  For example:</p>
 * <pre class='language-javascript'><code>
 * save();
 * save('myCanvas.jpg'); // save a specific canvas with a filename
 * </code></pre>
 *
 *  <p>Alternately, the first parameter can be a pointer to a canvas
 *  p5.Element, an Array of Strings,
 *  an Array of JSON, a JSON object, a p5.Table, a p5.Image, or a
 *  p5.SoundFile (requires p5.sound). The second parameter is a filename
 *  (including extension). The third parameter is for options specific
 *  to this type of object. This method will save a file that fits the
 *  given paramaters. For example:</p>
 *
 * <pre class='language-javascript'><code>
 * // Saves canvas as an image
 * save('myCanvas.jpg');
 *
 * // Saves pImage as a png image
 * var img = createImage(10, 10);
 * save(img, 'my.png');
 *
 * // Saves canvas as an image
 * var cnv = createCanvas(100, 100);
 * save(cnv, 'myCanvas.jpg');
 *
 * // Saves p5.Renderer object as an image
 * var gb = createGraphics(100, 100);
 * save(gb, 'myGraphics.jpg');
 *
 * var myTable = new p5.Table();
 *
 * // Saves table as html file
 * save(myTable, 'myTable.html');
 *
 * // Comma Separated Values
 * save(myTable, 'myTable.csv');
 *
 * // Tab Separated Values
 * save(myTable, 'myTable.tsv');
 *
 * var myJSON = { a: 1, b: true };
 *
 * // Saves pretty JSON
 * save(myJSON, 'my.json');
 *
 * // Optimizes JSON filesize
 * save(myJSON, 'my.json', true);
 *
 * // Saves array of strings to a text file with line breaks after each item
 * var arrayOfStrings = ['a', 'b'];
 * save(arrayOfStrings, 'my.txt');
 * </code></pre>
 *
 *  @method save
 *  @param  {Object|String} [objectOrFilename]  If filename is provided, will
 *                                             save canvas as an image with
 *                                             either png or jpg extension
 *                                             depending on the filename.
 *                                             If object is provided, will
 *                                             save depending on the object
 *                                             and filename (see examples
 *                                             above).
 *  @param  {String} [filename] If an object is provided as the first
 *                               parameter, then the second parameter
 *                               indicates the filename,
 *                               and should include an appropriate
 *                               file extension (see examples above).
 *  @param  {Boolean|String} [options]  Additional options depend on
 *                            filetype. For example, when saving JSON,
 *                            <code>true</code> indicates that the
 *                            output will be optimized for filesize,
 *                            rather than readability.
 */
p5.prototype.save = function(object, _filename, _options) {
  // parse the arguments and figure out which things we are saving
  var args = arguments;
  // =================================================
  // OPTION 1: saveCanvas...

  // if no arguments are provided, save canvas
  var cnv = this._curElement.elt;
  if (args.length === 0) {
    p5.prototype.saveCanvas(cnv);
    return;
  } else if (args[0] instanceof p5.Renderer || args[0] instanceof p5.Graphics) {
    // otherwise, parse the arguments

    // if first param is a p5Graphics, then saveCanvas
    p5.prototype.saveCanvas(args[0].elt, args[1], args[2]);
    return;
  } else if (args.length === 1 && typeof args[0] === 'string') {
    // if 1st param is String and only one arg, assume it is canvas filename
    p5.prototype.saveCanvas(cnv, args[0]);
  } else {
    // =================================================
    // OPTION 2: extension clarifies saveStrings vs. saveJSON
    var extension = _checkFileExtension(args[1], args[2])[1];
    switch (extension) {
      case 'json':
        p5.prototype.saveJSON(args[0], args[1], args[2]);
        return;
      case 'txt':
        p5.prototype.saveStrings(args[0], args[1], args[2]);
        return;
      // =================================================
      // OPTION 3: decide based on object...
      default:
        if (args[0] instanceof Array) {
          p5.prototype.saveStrings(args[0], args[1], args[2]);
        } else if (args[0] instanceof p5.Table) {
          p5.prototype.saveTable(args[0], args[1], args[2]);
        } else if (args[0] instanceof p5.Image) {
          p5.prototype.saveCanvas(args[0].canvas, args[1]);
        } else if (args[0] instanceof p5.SoundFile) {
          p5.prototype.saveSound(args[0], args[1], args[2], args[3]);
        }
    }
  }
};

/**
 *  Writes the contents of an Array or a JSON object to a .json file.
 *  The file saving process and location of the saved file will
 *  vary between web browsers.
 *
 *  @method saveJSON
 *  @param  {Array|Object} json
 *  @param  {String} filename
 *  @param  {Boolean} [optimize]   If true, removes line breaks
 *                                 and spaces from the output
 *                                 file to optimize filesize
 *                                 (but not readability).
 *  @example
 * <div><code>
 * var json = {}; // new  JSON Object
 *
 * json.id = 0;
 * json.species = 'Panthera leo';
 * json.name = 'Lion';
 *
 * createButton('save')
 *   .position(10, 10)
 *   .mousePressed(function() {
 *     saveJSON(json, 'lion.json');
 *   });
 *
 * // saves the following to a file called "lion.json":
 * // {
 * //   "id": 0,
 * //   "species": "Panthera leo",
 * //   "name": "Lion"
 * // }
 * </code></div>
 *
 * @alt
 * no image displayed
 *
 */
p5.prototype.saveJSON = function(json, filename, opt) {
  var stringify;
  if (opt) {
    stringify = JSON.stringify(json);
  } else {
    stringify = JSON.stringify(json, undefined, 2);
  }
  this.saveStrings(stringify.split('\n'), filename, 'json');
};

p5.prototype.saveJSONObject = p5.prototype.saveJSON;
p5.prototype.saveJSONArray = p5.prototype.saveJSON;

/**
 *  Writes an array of Strings to a text file, one line per String.
 *  The file saving process and location of the saved file will
 *  vary between web browsers.
 *
 *  @method saveStrings
 *  @param  {String[]} list   string array to be written
 *  @param  {String} filename filename for output
 *  @param  {String} [extension] the filename's extension
 *  @example
 * <div><code>
 * var words = 'apple bear cat dog';
 *
 * // .split() outputs an Array
 * var list = split(words, ' ');
 *
 * createButton('save')
 *   .position(10, 10)
 *   .mousePressed(function() {
 *     saveStrings(list, 'nouns.txt');
 *   });
 *
 * // Saves the following to a file called 'nouns.txt':
 * //
 * // apple
 * // bear
 * // cat
 * // dog
 * </code></div>
 *
 * @alt
 * no image displayed
 *
 */
p5.prototype.saveStrings = function(list, filename, extension) {
  var ext = extension || 'txt';
  var pWriter = this.createWriter(filename, ext);
  for (var i = 0; i < list.length; i++) {
    if (i < list.length - 1) {
      pWriter.print(list[i]);
    } else {
      pWriter.print(list[i]);
    }
  }
  pWriter.close();
  pWriter.flush();
};

// =======
// HELPERS
// =======

function escapeHelper(content) {
  return content
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

/**
 *  Writes the contents of a Table object to a file. Defaults to a
 *  text file with comma-separated-values ('csv') but can also
 *  use tab separation ('tsv'), or generate an HTML table ('html').
 *  The file saving process and location of the saved file will
 *  vary between web browsers.
 *
 *  @method saveTable
 *  @param  {p5.Table} Table  the Table object to save to a file
 *  @param  {String} filename the filename to which the Table should be saved
 *  @param  {String} [options]  can be one of "tsv", "csv", or "html"
 *  @example
 *  <div><code>
 * var table;
 *
 * function setup() {
 *   table = new p5.Table();
 *
 *   table.addColumn('id');
 *   table.addColumn('species');
 *   table.addColumn('name');
 *
 *   var newRow = table.addRow();
 *   newRow.setNum('id', table.getRowCount() - 1);
 *   newRow.setString('species', 'Panthera leo');
 *   newRow.setString('name', 'Lion');
 *
 *   // To save, un-comment next line then click 'run'
 *   // saveTable(table, 'new.csv');
 * }
 *
 * // Saves the following to a file called 'new.csv':
 * // id,species,name
 * // 0,Panthera leo,Lion
 * </code></div>
 *
 * @alt
 * no image displayed
 *
 */
p5.prototype.saveTable = function(table, filename, options) {
  var ext;
  if (options === undefined) {
    ext = filename.substring(filename.lastIndexOf('.') + 1, filename.length);
  } else {
    ext = options;
  }
  var pWriter = this.createWriter(filename, ext);

  var header = table.columns;

  var sep = ','; // default to CSV
  if (ext === 'tsv') {
    sep = '\t';
  }
  if (ext !== 'html') {
    // make header if it has values
    if (header[0] !== '0') {
      for (var h = 0; h < header.length; h++) {
        if (h < header.length - 1) {
          pWriter.write(header[h] + sep);
        } else {
          pWriter.write(header[h]);
        }
      }
      pWriter.write('\n');
    }

    // make rows
    for (var i = 0; i < table.rows.length; i++) {
      var j;
      for (j = 0; j < table.rows[i].arr.length; j++) {
        if (j < table.rows[i].arr.length - 1) {
          pWriter.write(table.rows[i].arr[j] + sep);
        } else if (i < table.rows.length - 1) {
          pWriter.write(table.rows[i].arr[j]);
        } else {
          pWriter.write(table.rows[i].arr[j]);
        }
      }
      pWriter.write('\n');
    }
  } else {
    // otherwise, make HTML
    pWriter.print('<html>');
    pWriter.print('<head>');
    var str = '  <meta http-equiv="content-type" content';
    str += '="text/html;charset=utf-8" />';
    pWriter.print(str);
    pWriter.print('</head>');

    pWriter.print('<body>');
    pWriter.print('  <table>');

    // make header if it has values
    if (header[0] !== '0') {
      pWriter.print('    <tr>');
      for (var k = 0; k < header.length; k++) {
        var e = escapeHelper(header[k]);
        pWriter.print('      <td>' + e);
        pWriter.print('      </td>');
      }
      pWriter.print('    </tr>');
    }

    // make rows
    for (var row = 0; row < table.rows.length; row++) {
      pWriter.print('    <tr>');
      for (var col = 0; col < table.columns.length; col++) {
        var entry = table.rows[row].getString(col);
        var htmlEntry = escapeHelper(entry);
        pWriter.print('      <td>' + htmlEntry);
        pWriter.print('      </td>');
      }
      pWriter.print('    </tr>');
    }
    pWriter.print('  </table>');
    pWriter.print('</body>');
    pWriter.print('</html>');
  }
  // close and flush the pWriter
  pWriter.close();
  pWriter.flush();
}; // end saveTable()

/**
 *  Generate a blob of file data as a url to prepare for download.
 *  Accepts an array of data, a filename, and an extension (optional).
 *  This is a private function because it does not do any formatting,
 *  but it is used by saveStrings, saveJSON, saveTable etc.
 *
 *  @param  {Array} dataToDownload
 *  @param  {String} filename
 *  @param  {String} [extension]
 *  @private
 */
p5.prototype.writeFile = function(dataToDownload, filename, extension) {
  var type = 'application/octet-stream';
  if (p5.prototype._isSafari()) {
    type = 'text/plain';
  }
  var blob = new Blob(dataToDownload, {
    type: type
  });
  p5.prototype.downloadFile(blob, filename, extension);
};

/**
 *  Forces download. Accepts a url to filedata/blob, a filename,
 *  and an extension (optional).
 *  This is a private function because it does not do any formatting,
 *  but it is used by saveStrings, saveJSON, saveTable etc.
 *
 *  @method downloadFile
 *  @param  {String|Blob} data    either an href generated by createObjectURL,
 *                                or a Blob object containing the data
 *  @param  {String} [filename]
 *  @param  {String} [extension]
 */
p5.prototype.downloadFile = function(data, fName, extension) {
  var fx = _checkFileExtension(fName, extension);
  var filename = fx[0];

  if (data instanceof Blob) {
    var fileSaver = _dereq_('file-saver');
    fileSaver.saveAs(data, filename);
    return;
  }

  var a = document.createElement('a');
  a.href = data;
  a.download = filename;

  // Firefox requires the link to be added to the DOM before click()
  a.onclick = function(e) {
    destroyClickedElement(e);
    e.stopPropagation();
  };

  a.style.display = 'none';
  document.body.appendChild(a);

  // Safari will open this file in the same page as a confusing Blob.
  if (p5.prototype._isSafari()) {
    var aText = 'Hello, Safari user! To download this file...\n';
    aText += '1. Go to File --> Save As.\n';
    aText += '2. Choose "Page Source" as the Format.\n';
    aText += '3. Name it with this extension: ."' + fx[1] + '"';
    alert(aText);
  }
  a.click();
};

/**
 *  Returns a file extension, or another string
 *  if the provided parameter has no extension.
 *
 *  @param   {String} filename
 *  @param   {String} [extension]
 *  @return  {String[]} [fileName, fileExtension]
 *
 *  @private
 */
function _checkFileExtension(filename, extension) {
  if (!extension || extension === true || extension === 'true') {
    extension = '';
  }
  if (!filename) {
    filename = 'untitled';
  }
  var ext = '';
  // make sure the file will have a name, see if filename needs extension
  if (filename && filename.indexOf('.') > -1) {
    ext = filename.split('.').pop();
  }
  // append extension if it doesn't exist
  if (extension) {
    if (ext !== extension) {
      ext = extension;
      filename = filename + '.' + ext;
    }
  }
  return [filename, ext];
}
p5.prototype._checkFileExtension = _checkFileExtension;

/**
 *  Returns true if the browser is Safari, false if not.
 *  Safari makes trouble for downloading files.
 *
 *  @return  {Boolean} [description]
 *  @private
 */
p5.prototype._isSafari = function() {
  var x = Object.prototype.toString.call(window.HTMLElement);
  return x.indexOf('Constructor') > 0;
};

/**
 *  Helper function, a callback for download that deletes
 *  an invisible anchor element from the DOM once the file
 *  has been automatically downloaded.
 *
 *  @private
 */
function destroyClickedElement(event) {
  document.body.removeChild(event.target);
}

module.exports = p5;

},{"../core/core":22,"../core/error_helpers":25,"es6-promise":5,"fetch-jsonp":6,"file-saver":7,"whatwg-fetch":12}],47:[function(_dereq_,module,exports){
/**
 * @module IO
 * @submodule Table
 * @requires core
 */

'use strict';

var p5 = _dereq_('../core/core');

/**
 *  Table Options
 *  <p>Generic class for handling tabular data, typically from a
 *  CSV, TSV, or other sort of spreadsheet file.</p>
 *  <p>CSV files are
 *  <a href="http://en.wikipedia.org/wiki/Comma-separated_values">
 *  comma separated values</a>, often with the data in quotes. TSV
 *  files use tabs as separators, and usually don't bother with the
 *  quotes.</p>
 *  <p>File names should end with .csv if they're comma separated.</p>
 *  <p>A rough "spec" for CSV can be found
 *  <a href="http://tools.ietf.org/html/rfc4180">here</a>.</p>
 *  <p>To load files, use the loadTable method.</p>
 *  <p>To save tables to your computer, use the save method
 *   or the saveTable method.</p>
 *
 *  Possible options include:
 *  <ul>
 *  <li>csv - parse the table as comma-separated values
 *  <li>tsv - parse the table as tab-separated values
 *  <li>header - this table has a header (title) row
 *  </ul>
 */

/**
 *  Table objects store data with multiple rows and columns, much
 *  like in a traditional spreadsheet. Tables can be generated from
 *  scratch, dynamically, or using data from an existing file.
 *
 *  @class p5.Table
 *  @constructor
 *  @param  {p5.TableRow[]}     [rows] An array of p5.TableRow objects
 */
p5.Table = function(rows) {
  /**
   *  @property columns {String[]}
   */
  this.columns = [];

  /**
   *  @property rows {p5.TableRow[]}
   */
  this.rows = [];
  this.name = 'p5.Table'; // for friendly debugger system
};

/**
 *  Use addRow() to add a new row of data to a p5.Table object. By default,
 *  an empty row is created. Typically, you would store a reference to
 *  the new row in a TableRow object (see newRow in the example above),
 *  and then set individual values using set().
 *
 *  If a p5.TableRow object is included as a parameter, then that row is
 *  duplicated and added to the table.
 *
 *  @method  addRow
 *  @param   {p5.TableRow} [row] row to be added to the table
 *
 * @example
 * <div class="norender">
 * <code>
 * // Given the CSV file "mammals.csv"
 * // in the project's "assets" folder:
 * //
 * // id,species,name
 * // 0,Capra hircus,Goat
 * // 1,Panthera pardus,Leopard
 * // 2,Equus zebra,Zebra
 *
 * var table;
 *
 * function preload() {
 *   //my table is comma separated value "csv"
 *   //and has a header specifying the columns labels
 *   table = loadTable('assets/mammals.csv', 'csv', 'header');
 * }
 *
 * function setup() {
 *   //add a row
 *   var newRow = table.addRow();
 *   newRow.setString('id', table.getRowCount() - 1);
 *   newRow.setString('species', 'Canis Lupus');
 *   newRow.setString('name', 'Wolf');
 *
 *   //print the results
 *   for (var r = 0; r < table.getRowCount(); r++)
 *     for (var c = 0; c < table.getColumnCount(); c++)
 *       print(table.getString(r, c));
 * }
 * </code>
 * </div>
 *
 * @alt
 * no image displayed
 *
 */
p5.Table.prototype.addRow = function(row) {
  // make sure it is a valid TableRow
  var r = row || new p5.TableRow();

  if (typeof r.arr === 'undefined' || typeof r.obj === 'undefined') {
    //r = new p5.prototype.TableRow(r);
    throw 'invalid TableRow: ' + r;
  }
  r.table = this;
  this.rows.push(r);
  return r;
};

/**
 * Removes a row from the table object.
 *
 * @method  removeRow
 * @param   {Integer} id ID number of the row to remove
 *
 * @example
 * <div class="norender">
 * <code>
 * // Given the CSV file "mammals.csv"
 * // in the project's "assets" folder:
 * //
 * // id,species,name
 * // 0,Capra hircus,Goat
 * // 1,Panthera pardus,Leopard
 * // 2,Equus zebra,Zebra
 *
 * var table;
 *
 * function preload() {
 *   //my table is comma separated value "csv"
 *   //and has a header specifying the columns labels
 *   table = loadTable('assets/mammals.csv', 'csv', 'header');
 * }
 *
 * function setup() {
 *   //remove the first row
 *   table.removeRow(0);
 *
 *   //print the results
 *   for (var r = 0; r < table.getRowCount(); r++)
 *     for (var c = 0; c < table.getColumnCount(); c++)
 *       print(table.getString(r, c));
 * }
 * </code>
 * </div>
 *
 * @alt
 * no image displayed
 *
 */
p5.Table.prototype.removeRow = function(id) {
  this.rows[id].table = null; // remove reference to table
  var chunk = this.rows.splice(id + 1, this.rows.length);
  this.rows.pop();
  this.rows = this.rows.concat(chunk);
};

/**
 * Returns a reference to the specified p5.TableRow. The reference
 * can then be used to get and set values of the selected row.
 *
 * @method  getRow
 * @param  {Integer}   rowID ID number of the row to get
 * @return {p5.TableRow} p5.TableRow object
 *
 * @example
 * <div class="norender">
 * <code>
 * // Given the CSV file "mammals.csv"
 * // in the project's "assets" folder:
 * //
 * // id,species,name
 * // 0,Capra hircus,Goat
 * // 1,Panthera pardus,Leopard
 * // 2,Equus zebra,Zebra
 *
 * var table;
 *
 * function preload() {
 *   //my table is comma separated value "csv"
 *   //and has a header specifying the columns labels
 *   table = loadTable('assets/mammals.csv', 'csv', 'header');
 * }
 *
 * function setup() {
 *   var row = table.getRow(1);
 *   //print it column by column
 *   //note: a row is an object, not an array
 *   for (var c = 0; c < table.getColumnCount(); c++) {
 *     print(row.getString(c));
 *   }
 * }
 * </code>
 * </div>
 *
 *@alt
 * no image displayed
 *
 */
p5.Table.prototype.getRow = function(r) {
  return this.rows[r];
};

/**
 *  Gets all rows from the table. Returns an array of p5.TableRows.
 *
 *  @method  getRows
 *  @return {p5.TableRow[]}   Array of p5.TableRows
 *
 * @example
 * <div class="norender">
 * <code>
 * // Given the CSV file "mammals.csv"
 * // in the project's "assets" folder:
 * //
 * // id,species,name
 * // 0,Capra hircus,Goat
 * // 1,Panthera pardus,Leopard
 * // 2,Equus zebra,Zebra
 *
 * var table;
 *
 * function preload() {
 *   //my table is comma separated value "csv"
 *   //and has a header specifying the columns labels
 *   table = loadTable('assets/mammals.csv', 'csv', 'header');
 * }
 *
 * function setup() {
 *   var rows = table.getRows();
 *
 *   //warning: rows is an array of objects
 *   for (var r = 0; r < rows.length; r++) {
 *     rows[r].set('name', 'Unicorn');
 *   }
 *
 *   //print the results
 *   for (r = 0; r < table.getRowCount(); r++)
 *     for (var c = 0; c < table.getColumnCount(); c++)
 *       print(table.getString(r, c));
 * }
 * </code>
 * </div>
 *
 * @alt
 * no image displayed
 *
 */
p5.Table.prototype.getRows = function() {
  return this.rows;
};

/**
 *  Finds the first row in the Table that contains the value
 *  provided, and returns a reference to that row. Even if
 *  multiple rows are possible matches, only the first matching
 *  row is returned. The column to search may be specified by
 *  either its ID or title.
 *
 *  @method  findRow
 *  @param  {String} value  The value to match
 *  @param  {Integer|String} column ID number or title of the
 *                                 column to search
 *  @return {p5.TableRow}
 *
 * @example
 * <div class="norender">
 * <code>
 * // Given the CSV file "mammals.csv"
 * // in the project's "assets" folder:
 * //
 * // id,species,name
 * // 0,Capra hircus,Goat
 * // 1,Panthera pardus,Leopard
 * // 2,Equus zebra,Zebra
 *
 * var table;
 *
 * function preload() {
 *   //my table is comma separated value "csv"
 *   //and has a header specifying the columns labels
 *   table = loadTable('assets/mammals.csv', 'csv', 'header');
 * }
 *
 * function setup() {
 *   //find the animal named zebra
 *   var row = table.findRow('Zebra', 'name');
 *   //find the corresponding species
 *   print(row.getString('species'));
 * }
 * </code>
 * </div>
 *
 * @alt
 * no image displayed
 *
 */
p5.Table.prototype.findRow = function(value, column) {
  // try the Object
  if (typeof column === 'string') {
    for (var i = 0; i < this.rows.length; i++) {
      if (this.rows[i].obj[column] === value) {
        return this.rows[i];
      }
    }
  } else {
    // try the Array
    for (var j = 0; j < this.rows.length; j++) {
      if (this.rows[j].arr[column] === value) {
        return this.rows[j];
      }
    }
  }
  // otherwise...
  return null;
};

/**
 *  Finds the rows in the Table that contain the value
 *  provided, and returns references to those rows. Returns an
 *  Array, so for must be used to iterate through all the rows,
 *  as shown in the example above. The column to search may be
 *  specified by either its ID or title.
 *
 *  @method  findRows
 *  @param  {String} value  The value to match
 *  @param  {Integer|String} column ID number or title of the
 *                                 column to search
 *  @return {p5.TableRow[]}        An Array of TableRow objects
 *
 * @example
 * <div class="norender">
 * <code>
 * // Given the CSV file "mammals.csv"
 * // in the project's "assets" folder:
 * //
 * // id,species,name
 * // 0,Capra hircus,Goat
 * // 1,Panthera pardus,Leopard
 * // 2,Equus zebra,Zebra
 *
 * var table;
 *
 * function preload() {
 *   //my table is comma separated value "csv"
 *   //and has a header specifying the columns labels
 *   table = loadTable('assets/mammals.csv', 'csv', 'header');
 * }
 *
 * function setup() {
 *   //add another goat
 *   var newRow = table.addRow();
 *   newRow.setString('id', table.getRowCount() - 1);
 *   newRow.setString('species', 'Scape Goat');
 *   newRow.setString('name', 'Goat');
 *
 *   //find the rows containing animals named Goat
 *   var rows = table.findRows('Goat', 'name');
 *   print(rows.length + ' Goats found');
 * }
 * </code>
 * </div>
 *
 *@alt
 * no image displayed
 *
 */
p5.Table.prototype.findRows = function(value, column) {
  var ret = [];
  if (typeof column === 'string') {
    for (var i = 0; i < this.rows.length; i++) {
      if (this.rows[i].obj[column] === value) {
        ret.push(this.rows[i]);
      }
    }
  } else {
    // try the Array
    for (var j = 0; j < this.rows.length; j++) {
      if (this.rows[j].arr[column] === value) {
        ret.push(this.rows[j]);
      }
    }
  }
  return ret;
};

/**
 *  Finds the first row in the Table that matches the regular
 *  expression provided, and returns a reference to that row.
 *  Even if multiple rows are possible matches, only the first
 *  matching row is returned. The column to search may be
 *  specified by either its ID or title.
 *
 *  @method  matchRow
 *  @param  {String} regexp The regular expression to match
 *  @param  {String|Integer} column The column ID (number) or
 *                                   title (string)
 *  @return {p5.TableRow}        TableRow object
 */
p5.Table.prototype.matchRow = function(regexp, column) {
  if (typeof column === 'number') {
    for (var j = 0; j < this.rows.length; j++) {
      if (this.rows[j].arr[column].match(regexp)) {
        return this.rows[j];
      }
    }
  } else {
    for (var i = 0; i < this.rows.length; i++) {
      if (this.rows[i].obj[column].match(regexp)) {
        return this.rows[i];
      }
    }
  }
  return null;
};

/**
 *  Finds the rows in the Table that match the regular expression provided,
 *  and returns references to those rows. Returns an array, so for must be
 *  used to iterate through all the rows, as shown in the example. The
 *  column to search may be specified by either its ID or title.
 *
 *  @method  matchRows
 *  @param  {String} regexp The regular expression to match
 *  @param  {String|Integer} [column] The column ID (number) or
 *                                   title (string)
 *  @return {p5.TableRow[]}          An Array of TableRow objects
 *  @example
 *  var table;
 *
 *  function setup() {
 *
 *    table = new p5.Table();
 *
 *    table.addColumn('name');
 *    table.addColumn('type');
 *
 *    var newRow = table.addRow();
 *    newRow.setString('name', 'Lion');
 *    newRow.setString('type', 'Mammal');
 *
 *    newRow = table.addRow();
 *    newRow.setString('name', 'Snake');
 *    newRow.setString('type', 'Reptile');
 *
 *    newRow = table.addRow();
 *    newRow.setString('name', 'Mosquito');
 *    newRow.setString('type', 'Insect');
 *
 *    newRow = table.addRow();
 *    newRow.setString('name', 'Lizard');
 *    newRow.setString('type', 'Reptile');
 *
 *    var rows = table.matchRows('R.*', 'type');
 *    for (var i = 0; i < rows.length; i++) {
 *      print(rows[i].getString('name') + ': ' + rows[i].getString('type'));
 *    }
 *  }
 *  // Sketch prints:
 *  // Snake: Reptile
 *  // Lizard: Reptile
 */
p5.Table.prototype.matchRows = function(regexp, column) {
  var ret = [];
  if (typeof column === 'number') {
    for (var j = 0; j < this.rows.length; j++) {
      if (this.rows[j].arr[column].match(regexp)) {
        ret.push(this.rows[j]);
      }
    }
  } else {
    for (var i = 0; i < this.rows.length; i++) {
      if (this.rows[i].obj[column].match(regexp)) {
        ret.push(this.rows[i]);
      }
    }
  }
  return ret;
};

/**
 *  Retrieves all values in the specified column, and returns them
 *  as an array. The column may be specified by either its ID or title.
 *
 *  @method  getColumn
 *  @param  {String|Number} column String or Number of the column to return
 *  @return {Array}       Array of column values
 *
 * @example
 * <div class="norender">
 * <code>
 * // Given the CSV file "mammals.csv"
 * // in the project's "assets" folder:
 * //
 * // id,species,name
 * // 0,Capra hircus,Goat
 * // 1,Panthera pardus,Leopard
 * // 2,Equus zebra,Zebra
 *
 * var table;
 *
 * function preload() {
 *   //my table is comma separated value "csv"
 *   //and has a header specifying the columns labels
 *   table = loadTable('assets/mammals.csv', 'csv', 'header');
 * }
 *
 * function setup() {
 *   //getColumn returns an array that can be printed directly
 *   print(table.getColumn('species'));
 *   //outputs ["Capra hircus", "Panthera pardus", "Equus zebra"]
 * }
 * </code>
 * </div>
 *
 *@alt
 * no image displayed
 *
 */
p5.Table.prototype.getColumn = function(value) {
  var ret = [];
  if (typeof value === 'string') {
    for (var i = 0; i < this.rows.length; i++) {
      ret.push(this.rows[i].obj[value]);
    }
  } else {
    for (var j = 0; j < this.rows.length; j++) {
      ret.push(this.rows[j].arr[value]);
    }
  }
  return ret;
};

/**
 *  Removes all rows from a Table. While all rows are removed,
 *  columns and column titles are maintained.
 *
 *  @method  clearRows
 *
 * @example
 * <div class="norender">
 * <code>
 * // Given the CSV file "mammals.csv"
 * // in the project's "assets" folder:
 * //
 * // id,species,name
 * // 0,Capra hircus,Goat
 * // 1,Panthera pardus,Leopard
 * // 2,Equus zebra,Zebra
 *
 * var table;
 *
 * function preload() {
 *   //my table is comma separated value "csv"
 *   //and has a header specifying the columns labels
 *   table = loadTable('assets/mammals.csv', 'csv', 'header');
 * }
 *
 * function setup() {
 *   table.clearRows();
 *   print(table.getRowCount() + ' total rows in table');
 *   print(table.getColumnCount() + ' total columns in table');
 * }
 * </code>
 * </div>
 *
 *@alt
 * no image displayed
 *
 */
p5.Table.prototype.clearRows = function() {
  delete this.rows;
  this.rows = [];
};

/**
 *  Use addColumn() to add a new column to a Table object.
 *  Typically, you will want to specify a title, so the column
 *  may be easily referenced later by name. (If no title is
 *  specified, the new column's title will be null.)
 *
 *  @method  addColumn
 *  @param {String} [title] title of the given column
 *
 * @example
 * <div class="norender">
 * <code>
 * // Given the CSV file "mammals.csv"
 * // in the project's "assets" folder:
 * //
 * // id,species,name
 * // 0,Capra hircus,Goat
 * // 1,Panthera pardus,Leopard
 * // 2,Equus zebra,Zebra
 *
 * var table;
 *
 * function preload() {
 *   //my table is comma separated value "csv"
 *   //and has a header specifying the columns labels
 *   table = loadTable('assets/mammals.csv', 'csv', 'header');
 * }
 *
 * function setup() {
 *   table.addColumn('carnivore');
 *   table.set(0, 'carnivore', 'no');
 *   table.set(1, 'carnivore', 'yes');
 *   table.set(2, 'carnivore', 'no');
 *
 *   //print the results
 *   for (var r = 0; r < table.getRowCount(); r++)
 *     for (var c = 0; c < table.getColumnCount(); c++)
 *       print(table.getString(r, c));
 * }
 * </code>
 * </div>
 *
 *@alt
 * no image displayed
 *
 */
p5.Table.prototype.addColumn = function(title) {
  var t = title || null;
  this.columns.push(t);
};

/**
 *  Returns the total number of columns in a Table.
 *
 *  @method  getColumnCount
 *  @return {Integer} Number of columns in this table
 */
p5.Table.prototype.getColumnCount = function() {
  return this.columns.length;
};

/**
 *  Returns the total number of rows in a Table.
 *
 *  @method  getRowCount
 *  @return {Integer} Number of rows in this table
 */
p5.Table.prototype.getRowCount = function() {
  return this.rows.length;
};

/**
 *  <p>Removes any of the specified characters (or "tokens").</p>
 *
 *  <p>If no column is specified, then the values in all columns and
 *  rows are processed. A specific column may be referenced by
 *  either its ID or title.</p>
 *
 *  @method  removeTokens
 *  @param  {String} chars  String listing characters to be removed
 *  @param  {String|Integer} [column] Column ID (number)
 *                                   or name (string)
 */
p5.Table.prototype.removeTokens = function(chars, column) {
  var escape = function(s) {
    return s.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
  };
  var charArray = [];
  for (var i = 0; i < chars.length; i++) {
    charArray.push(escape(chars.charAt(i)));
  }
  var regex = new RegExp(charArray.join('|'), 'g');

  if (typeof column === 'undefined') {
    for (var c = 0; c < this.columns.length; c++) {
      for (var d = 0; d < this.rows.length; d++) {
        var s = this.rows[d].arr[c];
        s = s.replace(regex, '');
        this.rows[d].arr[c] = s;
        this.rows[d].obj[this.columns[c]] = s;
      }
    }
  } else if (typeof column === 'string') {
    for (var j = 0; j < this.rows.length; j++) {
      var val = this.rows[j].obj[column];
      val = val.replace(regex, '');
      this.rows[j].obj[column] = val;
      var pos = this.columns.indexOf(column);
      this.rows[j].arr[pos] = val;
    }
  } else {
    for (var k = 0; k < this.rows.length; k++) {
      var str = this.rows[k].arr[column];
      str = str.replace(regex, '');
      this.rows[k].arr[column] = str;
      this.rows[k].obj[this.columns[column]] = str;
    }
  }
};

/**
 *  Trims leading and trailing whitespace, such as spaces and tabs,
 *  from String table values. If no column is specified, then the
 *  values in all columns and rows are trimmed. A specific column
 *  may be referenced by either its ID or title.
 *
 *  @method  trim
 *  @param  {String|Integer} [column] Column ID (number)
 *                                   or name (string)
 */
p5.Table.prototype.trim = function(column) {
  var regex = new RegExp(' ', 'g');

  if (typeof column === 'undefined') {
    for (var c = 0; c < this.columns.length; c++) {
      for (var d = 0; d < this.rows.length; d++) {
        var s = this.rows[d].arr[c];
        s = s.replace(regex, '');
        this.rows[d].arr[c] = s;
        this.rows[d].obj[this.columns[c]] = s;
      }
    }
  } else if (typeof column === 'string') {
    for (var j = 0; j < this.rows.length; j++) {
      var val = this.rows[j].obj[column];
      val = val.replace(regex, '');
      this.rows[j].obj[column] = val;
      var pos = this.columns.indexOf(column);
      this.rows[j].arr[pos] = val;
    }
  } else {
    for (var k = 0; k < this.rows.length; k++) {
      var str = this.rows[k].arr[column];
      str = str.replace(regex, '');
      this.rows[k].arr[column] = str;
      this.rows[k].obj[this.columns[column]] = str;
    }
  }
};

/**
 *  Use removeColumn() to remove an existing column from a Table
 *  object. The column to be removed may be identified by either
 *  its title (a String) or its index value (an int).
 *  removeColumn(0) would remove the first column, removeColumn(1)
 *  would remove the second column, and so on.
 *
 *  @method  removeColumn
 *  @param  {String|Integer} column columnName (string) or ID (number)
 *
 * @example
 * <div class="norender">
 * <code>
 * // Given the CSV file "mammals.csv"
 * // in the project's "assets" folder:
 * //
 * // id,species,name
 * // 0,Capra hircus,Goat
 * // 1,Panthera pardus,Leopard
 * // 2,Equus zebra,Zebra
 *
 * var table;
 *
 * function preload() {
 *   //my table is comma separated value "csv"
 *   //and has a header specifying the columns labels
 *   table = loadTable('assets/mammals.csv', 'csv', 'header');
 * }
 *
 * function setup() {
 *   table.removeColumn('id');
 *   print(table.getColumnCount());
 * }
 * </code>
 * </div>
 *
 *@alt
 * no image displayed
 *
 */
p5.Table.prototype.removeColumn = function(c) {
  var cString;
  var cNumber;
  if (typeof c === 'string') {
    // find the position of c in the columns
    cString = c;
    cNumber = this.columns.indexOf(c);
    console.log('string');
  } else {
    cNumber = c;
    cString = this.columns[c];
  }

  var chunk = this.columns.splice(cNumber + 1, this.columns.length);
  this.columns.pop();
  this.columns = this.columns.concat(chunk);

  for (var i = 0; i < this.rows.length; i++) {
    var tempR = this.rows[i].arr;
    var chip = tempR.splice(cNumber + 1, tempR.length);
    tempR.pop();
    this.rows[i].arr = tempR.concat(chip);
    delete this.rows[i].obj[cString];
  }
};

/**
 * Stores a value in the Table's specified row and column.
 * The row is specified by its ID, while the column may be specified
 * by either its ID or title.
 *
 * @method  set
 * @param {String|Integer} column column ID (Number)
 *                               or title (String)
 * @param {String|Number} value  value to assign
 *
 * @example
 * <div class="norender">
 * <code>
 * // Given the CSV file "mammals.csv"
 * // in the project's "assets" folder:
 * //
 * // id,species,name
 * // 0,Capra hircus,Goat
 * // 1,Panthera pardus,Leopard
 * // 2,Equus zebra,Zebra
 *
 * var table;
 *
 * function preload() {
 *   //my table is comma separated value "csv"
 *   //and has a header specifying the columns labels
 *   table = loadTable('assets/mammals.csv', 'csv', 'header');
 * }
 *
 * function setup() {
 *   table.set(0, 'species', 'Canis Lupus');
 *   table.set(0, 'name', 'Wolf');
 *
 *   //print the results
 *   for (var r = 0; r < table.getRowCount(); r++)
 *     for (var c = 0; c < table.getColumnCount(); c++)
 *       print(table.getString(r, c));
 * }
 * </code>
 * </div>
 *
 *@alt
 * no image displayed
 *
 */
p5.Table.prototype.set = function(row, column, value) {
  this.rows[row].set(column, value);
};

/**
 * Stores a Float value in the Table's specified row and column.
 * The row is specified by its ID, while the column may be specified
 * by either its ID or title.
 *
 * @method setNum
 * @param {Integer} row row ID
 * @param {String|Integer} column column ID (Number)
 *                               or title (String)
 * @param {Number} value  value to assign
 *
 * @example
 * <div class="norender">
 * <code>
 * // Given the CSV file "mammals.csv"
 * // in the project's "assets" folder:
 * //
 * // id,species,name
 * // 0,Capra hircus,Goat
 * // 1,Panthera pardus,Leopard
 * // 2,Equus zebra,Zebra
 *
 * var table;
 *
 * function preload() {
 *   //my table is comma separated value "csv"
 *   //and has a header specifying the columns labels
 *   table = loadTable('assets/mammals.csv', 'csv', 'header');
 * }
 *
 * function setup() {
 *   table.setNum(1, 'id', 1);
 *
 *   print(table.getColumn(0));
 *   //["0", 1, "2"]
 * }
 * </code>
 * </div>
 *
 *@alt
 * no image displayed
 */
p5.Table.prototype.setNum = function(row, column, value) {
  this.rows[row].setNum(column, value);
};

/**
 * Stores a String value in the Table's specified row and column.
 * The row is specified by its ID, while the column may be specified
 * by either its ID or title.
 *
 * @method  setString
 * @param {Integer} row row ID
 * @param {String|Integer} column column ID (Number)
 *                               or title (String)
 * @param {String} value  value to assign
 */
p5.Table.prototype.setString = function(row, column, value) {
  this.rows[row].setString(column, value);
};

/**
 * Retrieves a value from the Table's specified row and column.
 * The row is specified by its ID, while the column may be specified by
 * either its ID or title.
 *
 * @method  get
 * @param {Integer} row row ID
 * @param  {String|Integer} column columnName (string) or
 *                                   ID (number)
 * @return {String|Number}
 *
 * @example
 * <div class="norender">
 * <code>
 * // Given the CSV file "mammals.csv"
 * // in the project's "assets" folder:
 * //
 * // id,species,name
 * // 0,Capra hircus,Goat
 * // 1,Panthera pardus,Leopard
 * // 2,Equus zebra,Zebra
 *
 * var table;
 *
 * function preload() {
 *   //my table is comma separated value "csv"
 *   //and has a header specifying the columns labels
 *   table = loadTable('assets/mammals.csv', 'csv', 'header');
 * }
 *
 * function setup() {
 *   print(table.get(0, 1));
 *   //Capra hircus
 *   print(table.get(0, 'species'));
 *   //Capra hircus
 * }
 * </code>
 * </div>
 *
 *@alt
 * no image displayed
 *
 */
p5.Table.prototype.get = function(row, column) {
  return this.rows[row].get(column);
};

/**
 * Retrieves a Float value from the Table's specified row and column.
 * The row is specified by its ID, while the column may be specified by
 * either its ID or title.
 *
 * @method  getNum
 * @param {Integer} row row ID
 * @param  {String|Integer} column columnName (string) or
 *                                   ID (number)
 * @return {Number}
 *
 * @example
 * <div class="norender">
 * <code>
 * // Given the CSV file "mammals.csv"
 * // in the project's "assets" folder:
 * //
 * // id,species,name
 * // 0,Capra hircus,Goat
 * // 1,Panthera pardus,Leopard
 * // 2,Equus zebra,Zebra
 *
 * var table;
 *
 * function preload() {
 *   //my table is comma separated value "csv"
 *   //and has a header specifying the columns labels
 *   table = loadTable('assets/mammals.csv', 'csv', 'header');
 * }
 *
 * function setup() {
 *   print(table.getNum(1, 0) + 100);
 *   //id 1 + 100 = 101
 * }
 * </code>
 * </div>
 *
 *@alt
 * no image displayed
 *
 */
p5.Table.prototype.getNum = function(row, column) {
  return this.rows[row].getNum(column);
};

/**
 * Retrieves a String value from the Table's specified row and column.
 * The row is specified by its ID, while the column may be specified by
 * either its ID or title.
 *
 * @method  getString
 * @param {Integer} row row ID
 * @param  {String|Integer} column columnName (string) or
 *                                   ID (number)
 * @return {String}
 *
 * @example
 * <div class="norender">
 * <code>
 * // Given the CSV file "mammals.csv"
 * // in the project's "assets" folder:
 * //
 * // id,species,name
 * // 0,Capra hircus,Goat
 * // 1,Panthera pardus,Leopard
 * // 2,Equus zebra,Zebra
 *
 * var table;
 *
 * function preload() {
 *   //my table is comma separated value "csv"
 *   //and has a header specifying the columns labels
 *   table = loadTable('assets/mammals.csv', 'csv', 'header');
 * }
 *
 * function setup() {
 *   var tableArray = table.getArray();
 *
 *   //output each row as array
 *   for (var i = 0; i < tableArray.length; i++) {
 *     print(tableArray[i]);
 *   }
 * }
 * </code>
 * </div>
 *
 *@alt
 * no image displayed
 *
 */
p5.Table.prototype.getString = function(row, column) {
  return this.rows[row].getString(column);
};

/**
 * Retrieves all table data and returns as an object. If a column name is
 * passed in, each row object will be stored with that attribute as its
 * title.
 *
 * @method  getObject
 * @param {String} [headerColumn] Name of the column which should be used to
 *                              title each row object (optional)
 * @return {Object}
 *
 * @example
 * <div class="norender">
 * <code>
 * // Given the CSV file "mammals.csv"
 * // in the project's "assets" folder:
 * //
 * // id,species,name
 * // 0,Capra hircus,Goat
 * // 1,Panthera pardus,Leopard
 * // 2,Equus zebra,Zebra
 *
 * var table;
 *
 * function preload() {
 *   //my table is comma separated value "csv"
 *   //and has a header specifying the columns labels
 *   table = loadTable('assets/mammals.csv', 'csv', 'header');
 * }
 *
 * function setup() {
 *   var tableObject = table.getObject();
 *
 *   print(tableObject);
 *   //outputs an object
 * }
 * </code>
 * </div>
 *
 *@alt
 * no image displayed
 *
 */
p5.Table.prototype.getObject = function(headerColumn) {
  var tableObject = {};
  var obj, cPos, index;

  for (var i = 0; i < this.rows.length; i++) {
    obj = this.rows[i].obj;

    if (typeof headerColumn === 'string') {
      cPos = this.columns.indexOf(headerColumn); // index of columnID
      if (cPos >= 0) {
        index = obj[headerColumn];
        tableObject[index] = obj;
      } else {
        throw 'This table has no column named "' + headerColumn + '"';
      }
    } else {
      tableObject[i] = this.rows[i].obj;
    }
  }
  return tableObject;
};

/**
 * Retrieves all table data and returns it as a multidimensional array.
 *
 * @method  getArray
 * @return {Array}
 */
p5.Table.prototype.getArray = function() {
  var tableArray = [];
  for (var i = 0; i < this.rows.length; i++) {
    tableArray.push(this.rows[i].arr);
  }
  return tableArray;
};

module.exports = p5;

},{"../core/core":22}],48:[function(_dereq_,module,exports){
/**
 * @module IO
 * @submodule Table
 * @requires core
 */

'use strict';

var p5 = _dereq_('../core/core');

/**
 *  A TableRow object represents a single row of data values,
 *  stored in columns, from a table.
 *
 *  A Table Row contains both an ordered array, and an unordered
 *  JSON object.
 *
 *  @class p5.TableRow
 *  @constructor
 *  @param {String} [str]       optional: populate the row with a
 *                              string of values, separated by the
 *                              separator
 *  @param {String} [separator] comma separated values (csv) by default
 */
p5.TableRow = function(str, separator) {
  var arr = [];
  var obj = {};
  if (str) {
    separator = separator || ',';
    arr = str.split(separator);
  }
  for (var i = 0; i < arr.length; i++) {
    var key = i;
    var val = arr[i];
    obj[key] = val;
  }
  this.arr = arr;
  this.obj = obj;
  this.table = null;
  this.name = 'p5.TableRow'; // for friendly debugger system
};

/**
 *  Stores a value in the TableRow's specified column.
 *  The column may be specified by either its ID or title.
 *
 *  @method  set
 *  @param {String|Integer} column Column ID (Number)
 *                                or Title (String)
 *  @param {String|Number} value  The value to be stored
 */
p5.TableRow.prototype.set = function(column, value) {
  // if typeof column is string, use .obj
  if (typeof column === 'string') {
    var cPos = this.table.columns.indexOf(column); // index of columnID
    if (cPos >= 0) {
      this.obj[column] = value;
      this.arr[cPos] = value;
    } else {
      throw 'This table has no column named "' + column + '"';
    }
  } else {
    // if typeof column is number, use .arr
    if (column < this.table.columns.length) {
      this.arr[column] = value;
      var cTitle = this.table.columns[column];
      this.obj[cTitle] = value;
    } else {
      throw 'Column #' + column + ' is out of the range of this table';
    }
  }
};

/**
 *  Stores a Float value in the TableRow's specified column.
 *  The column may be specified by either its ID or title.
 *
 *  @method  setNum
 *  @param {String|Integer} column Column ID (Number)
 *                                or Title (String)
 *  @param {Number} value  The value to be stored
 *                                as a Float
 */
p5.TableRow.prototype.setNum = function(column, value) {
  var floatVal = parseFloat(value);
  this.set(column, floatVal);
};

/**
 *  Stores a String value in the TableRow's specified column.
 *  The column may be specified by either its ID or title.
 *
 *  @method  setString
 *  @param {String|Integer} column Column ID (Number)
 *                                or Title (String)
 *  @param {String} value  The value to be stored
 *                                as a String
 */
p5.TableRow.prototype.setString = function(column, value) {
  var stringVal = value.toString();
  this.set(column, stringVal);
};

/**
 *  Retrieves a value from the TableRow's specified column.
 *  The column may be specified by either its ID or title.
 *
 *  @method  get
 *  @param  {String|Integer} column columnName (string) or
 *                                   ID (number)
 *  @return {String|Number}
 */
p5.TableRow.prototype.get = function(column) {
  if (typeof column === 'string') {
    return this.obj[column];
  } else {
    return this.arr[column];
  }
};

/**
 *  Retrieves a Float value from the TableRow's specified
 *  column. The column may be specified by either its ID or
 *  title.
 *
 *  @method  getNum
 *  @param  {String|Integer} column columnName (string) or
 *                                   ID (number)
 *  @return {Number}  Float Floating point number
 */
p5.TableRow.prototype.getNum = function(column) {
  var ret;
  if (typeof column === 'string') {
    ret = parseFloat(this.obj[column]);
  } else {
    ret = parseFloat(this.arr[column]);
  }

  if (ret.toString() === 'NaN') {
    throw 'Error: ' + this.obj[column] + ' is NaN (Not a Number)';
  }
  return ret;
};

/**
 *  Retrieves an String value from the TableRow's specified
 *  column. The column may be specified by either its ID or
 *  title.
 *
 *  @method  getString
 *  @param  {String|Integer} column columnName (string) or
 *                                   ID (number)
 *  @return {String}  String
 */
p5.TableRow.prototype.getString = function(column) {
  if (typeof column === 'string') {
    return this.obj[column].toString();
  } else {
    return this.arr[column].toString();
  }
};

module.exports = p5;

},{"../core/core":22}],49:[function(_dereq_,module,exports){
/**
 * @module IO
 * @submodule XML
 * @requires core
 */

'use strict';

var p5 = _dereq_('../core/core');

/**
 * XML is a representation of an XML object, able to parse XML code. Use
 * loadXML() to load external XML files and create XML objects.
 *
 * @class p5.XML
 * @constructor
 * @example
 * <div class='norender'><code>
 * // The following short XML file called "mammals.xml" is parsed
 * // in the code below.
 * //
 * // <?xml version="1.0"?>
 * // &lt;mammals&gt;
 * //   &lt;animal id="0" species="Capra hircus">Goat&lt;/animal&gt;
 * //   &lt;animal id="1" species="Panthera pardus">Leopard&lt;/animal&gt;
 * //   &lt;animal id="2" species="Equus zebra">Zebra&lt;/animal&gt;
 * // &lt;/mammals&gt;
 *
 * var xml;
 *
 * function preload() {
 *   xml = loadXML('assets/mammals.xml');
 * }
 *
 * function setup() {
 *   var children = xml.getChildren('animal');
 *
 *   for (var i = 0; i < children.length; i++) {
 *     var id = children[i].getNum('id');
 *     var coloring = children[i].getString('species');
 *     var name = children[i].getContent();
 *     print(id + ', ' + coloring + ', ' + name);
 *   }
 * }
 *
 * // Sketch prints:
 * // 0, Capra hircus, Goat
 * // 1, Panthera pardus, Leopard
 * // 2, Equus zebra, Zebra
 * </code></div>
 *
 * @alt
 * no image displayed
 *
 */
p5.XML = function() {
  this.name = null; //done
  this.attributes = {}; //done
  this.children = [];
  this.parent = null;
  this.content = null; //done
  this.name = 'p5.XML'; // for friendly debugger system
};

/**
 * Gets a copy of the element's parent. Returns the parent as another
 * p5.XML object.
 *
 * @method getParent
 * @return {p5.XML}   element parent
 * @example
 * <div class='norender'><code>
 * // The following short XML file called "mammals.xml" is parsed
 * // in the code below.
 * //
 * // <?xml version="1.0"?>
 * // &lt;mammals&gt;
 * //   &lt;animal id="0" species="Capra hircus">Goat&lt;/animal&gt;
 * //   &lt;animal id="1" species="Panthera pardus">Leopard&lt;/animal&gt;
 * //   &lt;animal id="2" species="Equus zebra">Zebra&lt;/animal&gt;
 * // &lt;/mammals&gt;
 *
 * var xml;
 *
 * function preload() {
 *   xml = loadXML('assets/mammals.xml');
 * }
 *
 * function setup() {
 *   var children = xml.getChildren('animal');
 *   var parent = children[1].getParent();
 *   print(parent.getName());
 * }
 *
 * // Sketch prints:
 * // mammals
 * </code></div>
 */
p5.XML.prototype.getParent = function() {
  return this.parent;
};

/**
 *  Gets the element's full name, which is returned as a String.
 *
 * @method getName
 * @return {String} the name of the node
 * @example&lt;animal
 * <div class='norender'><code>
 * // The following short XML file called "mammals.xml" is parsed
 * // in the code below.
 * //
 * // <?xml version="1.0"?>
 * // &lt;mammals&gt;
 * //   &lt;animal id="0" species="Capra hircus">Goat&lt;/animal&gt;
 * //   &lt;animal id="1" species="Panthera pardus">Leopard&lt;/animal&gt;
 * //   &lt;animal id="2" species="Equus zebra">Zebra&lt;/animal&gt;
 * // &lt;/mammals&gt;
 *
 * var xml;
 *
 * function preload() {
 *   xml = loadXML('assets/mammals.xml');
 * }
 *
 * function setup() {
 *   print(xml.getName());
 * }
 *
 * // Sketch prints:
 * // mammals
 * </code></div>
 */
p5.XML.prototype.getName = function() {
  return this.name;
};

/**
 * Sets the element's name, which is specified as a String.
 *
 * @method setName
 * @param {String} the new name of the node
 * @example&lt;animal
 * <div class='norender'><code>
 * // The following short XML file called "mammals.xml" is parsed
 * // in the code below.
 * //
 * // <?xml version="1.0"?>
 * // &lt;mammals&gt;
 * //   &lt;animal id="0" species="Capra hircus">Goat&lt;/animal&gt;
 * //   &lt;animal id="1" species="Panthera pardus">Leopard&lt;/animal&gt;
 * //   &lt;animal id="2" species="Equus zebra">Zebra&lt;/animal&gt;
 * // &lt;/mammals&gt;
 *
 * var xml;
 *
 * function preload() {
 *   xml = loadXML('assets/mammals.xml');
 * }
 *
 * function setup() {
 *   print(xml.getName());
 *   xml.setName('fish');
 *   print(xml.getName());
 * }
 *
 * // Sketch prints:
 * // mammals
 * // fish
 * </code></div>
 */
p5.XML.prototype.setName = function(name) {
  this.name = name;
};

/**
 * Checks whether or not the element has any children, and returns the result
 * as a boolean.
 *
 * @method hasChildren
 * @return {boolean}
 * @example&lt;animal
 * <div class='norender'><code>
 * // The following short XML file called "mammals.xml" is parsed
 * // in the code below.
 * //
 * // <?xml version="1.0"?>
 * // &lt;mammals&gt;
 * //   &lt;animal id="0" species="Capra hircus">Goat&lt;/animal&gt;
 * //   &lt;animal id="1" species="Panthera pardus">Leopard&lt;/animal&gt;
 * //   &lt;animal id="2" species="Equus zebra">Zebra&lt;/animal&gt;
 * // &lt;/mammals&gt;
 *
 * var xml;
 *
 * function preload() {
 *   xml = loadXML('assets/mammals.xml');
 * }
 *
 * function setup() {
 *   print(xml.hasChildren());
 * }
 *
 * // Sketch prints:
 * // true
 * </code></div>
 */
p5.XML.prototype.hasChildren = function() {
  return this.children.length > 0;
};

/**
 * Get the names of all of the element's children, and returns the names as an
 * array of Strings. This is the same as looping through and calling getName()
 * on each child element individually.
 *
 * @method listChildren
 * @return {String[]} names of the children of the element
 * @example&lt;animal
 * <div class='norender'><code>
 * // The following short XML file called "mammals.xml" is parsed
 * // in the code below.
 * //
 * // <?xml version="1.0"?>
 * // &lt;mammals&gt;
 * //   &lt;animal id="0" species="Capra hircus">Goat&lt;/animal&gt;
 * //   &lt;animal id="1" species="Panthera pardus">Leopard&lt;/animal&gt;
 * //   &lt;animal id="2" species="Equus zebra">Zebra&lt;/animal&gt;
 * // &lt;/mammals&gt;
 *
 * var xml;
 *
 * function preload() {
 *   xml = loadXML('assets/mammals.xml');
 * }
 *
 * function setup() {
 *   print(xml.listChildren());
 * }
 *
 * // Sketch prints:
 * // ["animal", "animal", "animal"]
 * </code></div>
 */
p5.XML.prototype.listChildren = function() {
  return this.children.map(function(c) {
    return c.name;
  });
};

/**
 * Returns all of the element's children as an array of p5.XML objects. When
 * the name parameter is specified, then it will return all children that match
 * that name.
 *
 * @method getChildren
 * @param {String} [name] element name
 * @return {p5.XML[]} children of the element
 * @example&lt;animal
 * <div class='norender'><code>
 * // The following short XML file called "mammals.xml" is parsed
 * // in the code below.
 * //
 * // <?xml version="1.0"?>
 * // &lt;mammals&gt;
 * //   &lt;animal id="0" species="Capra hircus">Goat&lt;/animal&gt;
 * //   &lt;animal id="1" species="Panthera pardus">Leopard&lt;/animal&gt;
 * //   &lt;animal id="2" species="Equus zebra">Zebra&lt;/animal&gt;
 * // &lt;/mammals&gt;
 *
 * var xml;
 *
 * function preload() {
 *   xml = loadXML('assets/mammals.xml');
 * }
 *
 * function setup() {
 *   var animals = xml.getChildren('animal');
 *
 *   for (var i = 0; i < animals.length; i++) {
 *     print(animals[i].getContent());
 *   }
 * }
 *
 * // Sketch prints:
 * // "Goat"
 * // "Leopard"
 * // "Zebra"
 * </code></div>
 */
p5.XML.prototype.getChildren = function(param) {
  if (param) {
    return this.children.filter(function(c) {
      return c.name === param;
    });
  } else {
    return this.children;
  }
};

/**
 * Returns the first of the element's children that matches the name parameter
 * or the child of the given index.It returns undefined if no matching
 * child is found.
 *
 * @method getChild
 * @param {String|Integer} name element name or index
 * @return {p5.XML}
 * @example&lt;animal
 * <div class='norender'><code>
 * // The following short XML file called "mammals.xml" is parsed
 * // in the code below.
 * //
 * // <?xml version="1.0"?>
 * // &lt;mammals&gt;
 * //   &lt;animal id="0" species="Capra hircus">Goat&lt;/animal&gt;
 * //   &lt;animal id="1" species="Panthera pardus">Leopard&lt;/animal&gt;
 * //   &lt;animal id="2" species="Equus zebra">Zebra&lt;/animal&gt;
 * // &lt;/mammals&gt;
 *
 * var xml;
 *
 * function preload() {
 *   xml = loadXML('assets/mammals.xml');
 * }
 *
 * function setup() {
 *   var firstChild = xml.getChild('animal');
 *   print(firstChild.getContent());
 * }
 *
 * // Sketch prints:
 * // "Goat"
 * </code></div>
 * <div class='norender'><code>
 * var xml;
 *
 * function preload() {
 *   xml = loadXML('assets/mammals.xml');
 * }
 *
 * function setup() {
 *   var secondChild = xml.getChild(1);
 *   print(secondChild.getContent());
 * }
 *
 * // Sketch prints:
 * // "Leopard"
 * </code></div>
 */
p5.XML.prototype.getChild = function(param) {
  if (typeof param === 'string') {
    return this.children.find(function(c) {
      return c.name === param;
    });
  } else {
    return this.children[param];
  }
};

/**
 * Appends a new child to the element. The child can be specified with
 * either a String, which will be used as the new tag's name, or as a
 * reference to an existing p5.XML object.
 * A reference to the newly created child is returned as an p5.XML object.
 *
 * @method addChild
 * @param {p5.XML} a p5.XML Object which will be the child to be added
 */
p5.XML.prototype.addChild = function(node) {
  if (node instanceof p5.XML) {
    this.children.push(node);
  } else {
    // PEND
  }
};

/**
 * Removes the element specified by name or index.
 *
 * @method removeChild
 * @param {String|Integer} name element name or index
 * @example
 * <div class='norender'><code>
 * // The following short XML file called "mammals.xml" is parsed
 * // in the code below.
 * //
 * // <?xml version="1.0"?>
 * // &lt;mammals&gt;
 * //   &lt;animal id="0" species="Capra hircus">Goat&lt;/animal&gt;
 * //   &lt;animal id="1" species="Panthera pardus">Leopard&lt;/animal&gt;
 * //   &lt;animal id="2" species="Equus zebra">Zebra&lt;/animal&gt;
 * // &lt;/mammals&gt;
 *
 * var xml;
 *
 * function preload() {
 *   xml = loadXML('assets/mammals.xml');
 * }
 *
 * function setup() {
 *   xml.removeChild('animal');
 *   var children = xml.getChildren();
 *   for (var i = 0; i < children.length; i++) {
 *     print(children[i].getContent());
 *   }
 * }
 *
 * // Sketch prints:
 * // "Leopard"
 * // "Zebra"
 * </code></div>
 * <div class='norender'><code>
 * var xml;
 *
 * function preload() {
 *   xml = loadXML('assets/mammals.xml');
 * }
 *
 * function setup() {
 *   xml.removeChild(1);
 *   var children = xml.getChildren();
 *   for (var i = 0; i < children.length; i++) {
 *     print(children[i].getContent());
 *   }
 * }
 *
 * // Sketch prints:
 * // "Goat"
 * // "Zebra"
 * </code></div>
 */
p5.XML.prototype.removeChild = function(param) {
  var ind = -1;
  if (typeof param === 'string') {
    for (var i = 0; i < this.children.length; i++) {
      if (this.children[i].name === param) {
        ind = i;
        break;
      }
    }
  } else {
    ind = param;
  }
  if (ind !== -1) {
    this.children.splice(ind, 1);
  }
};

/**
 * Counts the specified element's number of attributes, returned as an Number.
 *
 * @method getAttributeCount
 * @return {Integer}
 * @example
 * <div class='norender'><code>
 * // The following short XML file called "mammals.xml" is parsed
 * // in the code below.
 * //
 * // <?xml version="1.0"?>
 * // &lt;mammals&gt;
 * //   &lt;animal id="0" species="Capra hircus">Goat&lt;/animal&gt;
 * //   &lt;animal id="1" species="Panthera pardus">Leopard&lt;/animal&gt;
 * //   &lt;animal id="2" species="Equus zebra">Zebra&lt;/animal&gt;
 * // &lt;/mammals&gt;
 *
 * var xml;
 *
 * function preload() {
 *   xml = loadXML('assets/mammals.xml');
 * }
 *
 * function setup() {
 *   var firstChild = xml.getChild('animal');
 *   print(firstChild.getAttributeCount());
 * }
 *
 * // Sketch prints:
 * // 2
 * </code></div>
 */
p5.XML.prototype.getAttributeCount = function() {
  return Object.keys(this.attributes).length;
};

/**
 * Gets all of the specified element's attributes, and returns them as an
 * array of Strings.
 *
 * @method listAttributes
 * @return {String[]} an array of strings containing the names of attributes
 * @example
 * <div class='norender'><code>
 * // The following short XML file called "mammals.xml" is parsed
 * // in the code below.
 * //
 * // <?xml version="1.0"?>
 * // &lt;mammals&gt;
 * //   &lt;animal id="0" species="Capra hircus">Goat&lt;/animal&gt;
 * //   &lt;animal id="1" species="Panthera pardus">Leopard&lt;/animal&gt;
 * //   &lt;animal id="2" species="Equus zebra">Zebra&lt;/animal&gt;
 * // &lt;/mammals&gt;
 *
 * var xml;
 *
 * function preload() {
 *   xml = loadXML('assets/mammals.xml');
 * }
 *
 * function setup() {
 *   var firstChild = xml.getChild('animal');
 *   print(firstChild.listAttributes());
 * }
 *
 * // Sketch prints:
 * // ["id", "species"]
 * </code></div>
 */
p5.XML.prototype.listAttributes = function() {
  return Object.keys(this.attributes);
};

/**
 *  Checks whether or not an element has the specified attribute.
 *
 * @method hasAttribute
 * @param {String} the attribute to be checked
 * @return {boolean} true if attribute found else false
 * @example
 * <div class='norender'><code>
 * // The following short XML file called "mammals.xml" is parsed
 * // in the code below.
 * //
 * // <?xml version="1.0"?>
 * // &lt;mammals&gt;
 * //   &lt;animal id="0" species="Capra hircus">Goat&lt;/animal&gt;
 * //   &lt;animal id="1" species="Panthera pardus">Leopard&lt;/animal&gt;
 * //   &lt;animal id="2" species="Equus zebra">Zebra&lt;/animal&gt;
 * // &lt;/mammals&gt;
 *
 * var xml;
 *
 * function preload() {
 *   xml = loadXML('assets/mammals.xml');
 * }
 *
 * function setup() {
 *   var firstChild = xml.getChild('animal');
 *   print(firstChild.hasAttribute('species'));
 *   print(firstChild.hasAttribute('color'));
 * }
 *
 * // Sketch prints:
 * // true
 * // false
 * </code></div>
 */
p5.XML.prototype.hasAttribute = function(name) {
  return this.attributes[name] ? true : false;
};

/**
 * Returns an attribute value of the element as an Number. If the defaultValue
 * parameter is specified and the attribute doesn't exist, then defaultValue
 * is returned. If no defaultValue is specified and the attribute doesn't
 * exist, the value 0 is returned.
 *
 * @method getNum
 * @param {String} name            the non-null full name of the attribute
 * @param {Number} [defaultValue]  the default value of the attribute
 * @return {Number}
 * @example
 * <div class='norender'><code>
 * // The following short XML file called "mammals.xml" is parsed
 * // in the code below.
 * //
 * // <?xml version="1.0"?>
 * // &lt;mammals&gt;
 * //   &lt;animal id="0" species="Capra hircus">Goat&lt;/animal&gt;
 * //   &lt;animal id="1" species="Panthera pardus">Leopard&lt;/animal&gt;
 * //   &lt;animal id="2" species="Equus zebra">Zebra&lt;/animal&gt;
 * // &lt;/mammals&gt;
 *
 * var xml;
 *
 * function preload() {
 *   xml = loadXML('assets/mammals.xml');
 * }
 *
 * function setup() {
 *   var firstChild = xml.getChild('animal');
 *   print(firstChild.getNum('id'));
 * }
 *
 * // Sketch prints:
 * // 0
 * </code></div>
 */
p5.XML.prototype.getNum = function(name, defaultValue) {
  return Number(this.attributes[name]) || defaultValue || 0;
};

/**
 * Returns an attribute value of the element as an String. If the defaultValue
 * parameter is specified and the attribute doesn't exist, then defaultValue
 * is returned. If no defaultValue is specified and the attribute doesn't
 * exist, null is returned.
 *
 * @method getString
 * @param {String} name            the non-null full name of the attribute
 * @param {Number} [defaultValue]  the default value of the attribute
 * @return {Number}
 * @example
 * <div class='norender'><code>
 * // The following short XML file called "mammals.xml" is parsed
 * // in the code below.
 * //
 * // <?xml version="1.0"?>
 * // &lt;mammals&gt;
 * //   &lt;animal id="0" species="Capra hircus">Goat&lt;/animal&gt;
 * //   &lt;animal id="1" species="Panthera pardus">Leopard&lt;/animal&gt;
 * //   &lt;animal id="2" species="Equus zebra">Zebra&lt;/animal&gt;
 * // &lt;/mammals&gt;
 *
 * var xml;
 *
 * function preload() {
 *   xml = loadXML('assets/mammals.xml');
 * }
 *
 * function setup() {
 *   var firstChild = xml.getChild('animal');
 *   print(firstChild.getString('species'));
 * }
 *
 * // Sketch prints:
 * // "Capra hircus"
 * </code></div>
 */
p5.XML.prototype.getString = function(name, defaultValue) {
  return String(this.attributes[name]) || defaultValue || null;
};

/**
 * Sets the content of an element's attribute. The first parameter specifies
 * the attribute name, while the second specifies the new content.
 *
 * @method setAttribute
 * @param {String} name            the full name of the attribute
 * @param {Number} value           the value of the attribute
 * @example
 * <div class='norender'><code>
 * // The following short XML file called "mammals.xml" is parsed
 * // in the code below.
 * //
 * // <?xml version="1.0"?>
 * // &lt;mammals&gt;
 * //   &lt;animal id="0" species="Capra hircus">Goat&lt;/animal&gt;
 * //   &lt;animal id="1" species="Panthera pardus">Leopard&lt;/animal&gt;
 * //   &lt;animal id="2" species="Equus zebra">Zebra&lt;/animal&gt;
 * // &lt;/mammals&gt;
 *
 * var xml;
 *
 * function preload() {
 *   xml = loadXML('assets/mammals.xml');
 * }
 *
 * function setup() {
 *   var firstChild = xml.getChild('animal');
 *   print(firstChild.getString('species'));
 *   firstChild.setAttribute('species', 'Jamides zebra');
 *   print(firstChild.getString('species'));
 * }
 *
 * // Sketch prints:
 * // "Capra hircus"
 * // "Jamides zebra"
 * </code></div>
 */
p5.XML.prototype.setAttribute = function(name, value) {
  if (this.attributes[name]) {
    this.attributes[name] = value;
  }
};

/**
 * Returns the content of an element. If there is no such content,
 * defaultValue is returned if specified, otherwise null is returned.
 *
 * @method getContent
 * @param {String} [defaultValue] value returned if no content is found
 * @return {String}
 * @example
 * <div class='norender'><code>
 * // The following short XML file called "mammals.xml" is parsed
 * // in the code below.
 * //
 * // <?xml version="1.0"?>
 * // &lt;mammals&gt;
 * //   &lt;animal id="0" species="Capra hircus">Goat&lt;/animal&gt;
 * //   &lt;animal id="1" species="Panthera pardus">Leopard&lt;/animal&gt;
 * //   &lt;animal id="2" species="Equus zebra">Zebra&lt;/animal&gt;
 * // &lt;/mammals&gt;
 *
 * var xml;
 *
 * function preload() {
 *   xml = loadXML('assets/mammals.xml');
 * }
 *
 * function setup() {
 *   var firstChild = xml.getChild('animal');
 *   print(firstChild.getContent());
 * }
 *
 * // Sketch prints:
 * // "Goat"
 * </code></div>
 */
p5.XML.prototype.getContent = function(defaultValue) {
  return this.content || defaultValue || null;
};

/**
 * Sets the element's content.
 *
 * @method setContent
 * @param {String} text the new content
 * @example
 * <div class='norender'><code>
 * // The following short XML file called "mammals.xml" is parsed
 * // in the code below.
 * //
 * // <?xml version="1.0"?>
 * // &lt;mammals&gt;
 * //   &lt;animal id="0" species="Capra hircus">Goat&lt;/animal&gt;
 * //   &lt;animal id="1" species="Panthera pardus">Leopard&lt;/animal&gt;
 * //   &lt;animal id="2" species="Equus zebra">Zebra&lt;/animal&gt;
 * // &lt;/mammals&gt;
 *
 * var xml;
 *
 * function preload() {
 *   xml = loadXML('assets/mammals.xml');
 * }
 *
 * function setup() {
 *   var firstChild = xml.getChild('animal');
 *   print(firstChild.getContent());
 *   firstChild.setContent('Mountain Goat');
 *   print(firstChild.getContent());
 * }
 *
 * // Sketch prints:
 * // "Goat"
 * // "Mountain Goat"
 * </code></div>
 */
p5.XML.prototype.setContent = function(content) {
  if (!this.children.length) {
    this.content = content;
  }
};

/* HELPERS */
/**
 * This method is called while the parsing of XML (when loadXML() is
 * called). The difference between this method and the setContent()
 * method defined later is that this one is used to set the content
 * when the node in question has more nodes under it and so on and
 * not directly text content. While in the other one is used when
 * the node in question directly has text inside it.
 *
 */
p5.XML.prototype._setCont = function(content) {
  var str;
  str = content;
  str = str.replace(/\s\s+/g, ',');
  //str = str.split(',');
  this.content = str;
};

/**
 * This method is called while the parsing of XML (when loadXML() is
 * called). The XML node is passed and its attributes are stored in the
 * p5.XML's attribute Object.
 *
 */
p5.XML.prototype._setAttributes = function(node) {
  var i,
    att = {};
  for (i = 0; i < node.attributes.length; i++) {
    att[node.attributes[i].nodeName] = node.attributes[i].nodeValue;
  }
  this.attributes = att;
};

module.exports = p5;

},{"../core/core":22}],50:[function(_dereq_,module,exports){
/**
 * @module Math
 * @submodule Calculation
 * @for p5
 * @requires core
 */

'use strict';

var p5 = _dereq_('../core/core');

/**
 * Calculates the absolute value (magnitude) of a number. Maps to Math.abs().
 * The absolute value of a number is always positive.
 *
 * @method abs
 * @param  {Number} n number to compute
 * @return {Number}   absolute value of given number
 * @example
 * <div class = "norender"><code>
 * function setup() {
 *   var x = -3;
 *   var y = abs(x);
 *
 *   print(x); // -3
 *   print(y); // 3
 * }
 * </code></div>
 *
 * @alt
 * no image displayed
 *
 */
p5.prototype.abs = Math.abs;

/**
 * Calculates the closest int value that is greater than or equal to the
 * value of the parameter. Maps to Math.ceil(). For example, ceil(9.03)
 * returns the value 10.
 *
 * @method ceil
 * @param  {Number} n number to round up
 * @return {Integer}   rounded up number
 * @example
 * <div><code>
 * function draw() {
 *   background(200);
 *   // map, mouseX between 0 and 5.
 *   var ax = map(mouseX, 0, 100, 0, 5);
 *   var ay = 66;
 *
 *   //Get the ceiling of the mapped number.
 *   var bx = ceil(map(mouseX, 0, 100, 0, 5));
 *   var by = 33;
 *
 *   // Multiply the mapped numbers by 20 to more easily
 *   // see the changes.
 *   stroke(0);
 *   fill(0);
 *   line(0, ay, ax * 20, ay);
 *   line(0, by, bx * 20, by);
 *
 *   // Reformat the float returned by map and draw it.
 *   noStroke();
 *   text(nfc(ax, 2), ax, ay - 5);
 *   text(nfc(bx, 1), bx, by - 5);
 * }
 * </code></div>
 *
 * @alt
 * 2 horizontal lines & number sets. increase with mouse x. bottom to 2 decimals
 *
 */
p5.prototype.ceil = Math.ceil;

/**
 * Constrains a value between a minimum and maximum value.
 *
 * @method constrain
 * @param  {Number} n    number to constrain
 * @param  {Number} low  minimum limit
 * @param  {Number} high maximum limit
 * @return {Number}      constrained number
 * @example
 * <div><code>
 * function draw() {
 *   background(200);
 *
 *   var leftWall = 25;
 *   var rightWall = 75;
 *
 *   // xm is just the mouseX, while
 *   // xc is the mouseX, but constrained
 *   // between the leftWall and rightWall!
 *   var xm = mouseX;
 *   var xc = constrain(mouseX, leftWall, rightWall);
 *
 *   // Draw the walls.
 *   stroke(150);
 *   line(leftWall, 0, leftWall, height);
 *   line(rightWall, 0, rightWall, height);
 *
 *   // Draw xm and xc as circles.
 *   noStroke();
 *   fill(150);
 *   ellipse(xm, 33, 9, 9); // Not Constrained
 *   fill(0);
 *   ellipse(xc, 66, 9, 9); // Constrained
 * }
 * </code></div>
 *
 * @alt
 * 2 vertical lines. 2 ellipses move with mouse X 1 does not move passed lines
 *
 */
p5.prototype.constrain = function(n, low, high) {
  p5._validateParameters('constrain', arguments);
  return Math.max(Math.min(n, high), low);
};

/**
 * Calculates the distance between two points.
 *
 * @method dist
 * @param  {Number} x1 x-coordinate of the first point
 * @param  {Number} y1 y-coordinate of the first point
 * @param  {Number} x2 x-coordinate of the second point
 * @param  {Number} y2 y-coordinate of the second point
 * @return {Number}    distance between the two points
 *
 * @example
 * <div><code>
 * // Move your mouse inside the canvas to see the
 * // change in distance between two points!
 * function draw() {
 *   background(200);
 *   fill(0);
 *
 *   var x1 = 10;
 *   var y1 = 90;
 *   var x2 = mouseX;
 *   var y2 = mouseY;
 *
 *   line(x1, y1, x2, y2);
 *   ellipse(x1, y1, 7, 7);
 *   ellipse(x2, y2, 7, 7);
 *
 *   // d is the length of the line
 *   // the distance from point 1 to point 2.
 *   var d = int(dist(x1, y1, x2, y2));
 *
 *   // Let's write d along the line we are drawing!
 *   push();
 *   translate((x1 + x2) / 2, (y1 + y2) / 2);
 *   rotate(atan2(y2 - y1, x2 - x1));
 *   text(nfc(d, 1), 0, -5);
 *   pop();
 *   // Fancy!
 * }
 * </code></div>
 *
 * @alt
 * 2 ellipses joined by line. 1 ellipse moves with mouse X&Y. Distance displayed.
 */
/**
 * @method dist
 * @param  {Number} x1
 * @param  {Number} y1
 * @param  {Number} z1 z-coordinate of the first point
 * @param  {Number} x2
 * @param  {Number} y2
 * @param  {Number} z2 z-coordinate of the second point
 * @return {Number}    distance between the two points
 */
p5.prototype.dist = function() {
  p5._validateParameters('dist', arguments);
  if (arguments.length === 4) {
    //2D
    return hypot(arguments[2] - arguments[0], arguments[3] - arguments[1]);
  } else if (arguments.length === 6) {
    //3D
    return hypot(
      arguments[3] - arguments[0],
      arguments[4] - arguments[1],
      arguments[5] - arguments[2]
    );
  }
};

/**
 * Returns Euler's number e (2.71828...) raised to the power of the n
 * parameter. Maps to Math.exp().
 *
 * @method exp
 * @param  {Number} n exponent to raise
 * @return {Number}   e^n
 * @example
 * <div><code>
 * function draw() {
 *   background(200);
 *
 *   // Compute the exp() function with a value between 0 and 2
 *   var xValue = map(mouseX, 0, width, 0, 2);
 *   var yValue = exp(xValue);
 *
 *   var y = map(yValue, 0, 8, height, 0);
 *
 *   var legend = 'exp (' + nfc(xValue, 3) + ')\n= ' + nf(yValue, 1, 4);
 *   stroke(150);
 *   line(mouseX, y, mouseX, height);
 *   fill(0);
 *   text(legend, 5, 15);
 *   noStroke();
 *   ellipse(mouseX, y, 7, 7);
 *
 *   // Draw the exp(x) curve,
 *   // over the domain of x from 0 to 2
 *   noFill();
 *   stroke(0);
 *   beginShape();
 *   for (var x = 0; x < width; x++) {
 *     xValue = map(x, 0, width, 0, 2);
 *     yValue = exp(xValue);
 *     y = map(yValue, 0, 8, height, 0);
 *     vertex(x, y);
 *   }
 *
 *   endShape();
 *   line(0, 0, 0, height);
 *   line(0, height - 1, width, height - 1);
 * }
 * </code></div>
 *
 * @alt
 * ellipse moves along a curve with mouse x. e^n displayed.
 *
 */
p5.prototype.exp = Math.exp;

/**
 * Calculates the closest int value that is less than or equal to the
 * value of the parameter. Maps to Math.floor().
 *
 * @method floor
 * @param  {Number} n number to round down
 * @return {Integer}  rounded down number
 * @example
 * <div><code>
 * function draw() {
 *   background(200);
 *   //map, mouseX between 0 and 5.
 *   var ax = map(mouseX, 0, 100, 0, 5);
 *   var ay = 66;
 *
 *   //Get the floor of the mapped number.
 *   var bx = floor(map(mouseX, 0, 100, 0, 5));
 *   var by = 33;
 *
 *   // Multiply the mapped numbers by 20 to more easily
 *   // see the changes.
 *   stroke(0);
 *   fill(0);
 *   line(0, ay, ax * 20, ay);
 *   line(0, by, bx * 20, by);
 *
 *   // Reformat the float returned by map and draw it.
 *   noStroke();
 *   text(nfc(ax, 2), ax, ay - 5);
 *   text(nfc(bx, 1), bx, by - 5);
 * }
 * </code></div>
 *
 * @alt
 * 2 horizontal lines & number sets. increase with mouse x. bottom to 2 decimals
 *
 */
p5.prototype.floor = Math.floor;

/**
 * Calculates a number between two numbers at a specific increment. The amt
 * parameter is the amount to interpolate between the two values where 0.0
 * equal to the first point, 0.1 is very near the first point, 0.5 is
 * half-way in between, etc. The lerp function is convenient for creating
 * motion along a straight path and for drawing dotted lines.
 *
 * @method lerp
 * @param  {Number} start first value
 * @param  {Number} stop  second value
 * @param  {Number} amt   number between 0.0 and 1.0
 * @return {Number}       lerped value
 * @example
 * <div><code>
 * function setup() {
 *   background(200);
 *   var a = 20;
 *   var b = 80;
 *   var c = lerp(a, b, 0.2);
 *   var d = lerp(a, b, 0.5);
 *   var e = lerp(a, b, 0.8);
 *
 *   var y = 50;
 *
 *   strokeWeight(5);
 *   stroke(0); // Draw the original points in black
 *   point(a, y);
 *   point(b, y);
 *
 *   stroke(100); // Draw the lerp points in gray
 *   point(c, y);
 *   point(d, y);
 *   point(e, y);
 * }
 * </code></div>
 *
 * @alt
 * 5 points horizontally staggered mid-canvas. mid 3 are grey, outer black
 *
 */
p5.prototype.lerp = function(start, stop, amt) {
  p5._validateParameters('lerp', arguments);
  return amt * (stop - start) + start;
};

/**
 * Calculates the natural logarithm (the base-e logarithm) of a number. This
 * function expects the n parameter to be a value greater than 0.0. Maps to
 * Math.log().
 *
 * @method log
 * @param  {Number} n number greater than 0
 * @return {Number}   natural logarithm of n
 * @example
 * <div><code>
 * function draw() {
 *   background(200);
 *   var maxX = 2.8;
 *   var maxY = 1.5;
 *
 *   // Compute the natural log of a value between 0 and maxX
 *   var xValue = map(mouseX, 0, width, 0, maxX);
 *   if (xValue > 0) {
    // Cannot take the log of a negative number.
 *     var yValue = log(xValue);
 *     var y = map(yValue, -maxY, maxY, height, 0);
 *
 *     // Display the calculation occurring.
 *     var legend = 'log(' + nf(xValue, 1, 2) + ')\n= ' + nf(yValue, 1, 3);
 *     stroke(150);
 *     line(mouseX, y, mouseX, height);
 *     fill(0);
 *     text(legend, 5, 15);
 *     noStroke();
 *     ellipse(mouseX, y, 7, 7);
 *   }
 *
 *   // Draw the log(x) curve,
 *   // over the domain of x from 0 to maxX
 *   noFill();
 *   stroke(0);
 *   beginShape();
 *   for (var x = 0; x < width; x++) {
 *     xValue = map(x, 0, width, 0, maxX);
 *     yValue = log(xValue);
 *     y = map(yValue, -maxY, maxY, height, 0);
 *     vertex(x, y);
 *   }
 *   endShape();
 *   line(0, 0, 0, height);
 *   line(0, height / 2, width, height / 2);
 * }
 * </code></div>
 *
 * @alt
 * ellipse moves along a curve with mouse x. natural logarithm of n displayed.
 *
 */
p5.prototype.log = Math.log;

/**
 * Calculates the magnitude (or length) of a vector. A vector is a direction
 * in space commonly used in computer graphics and linear algebra. Because it
 * has no "start" position, the magnitude of a vector can be thought of as
 * the distance from the coordinate 0,0 to its x,y value. Therefore, mag() is
 * a shortcut for writing dist(0, 0, x, y).
 *
 * @method mag
 * @param  {Number} a first value
 * @param  {Number} b second value
 * @return {Number}   magnitude of vector from (0,0) to (a,b)
 * @example
 * <div><code>
 * function setup() {
 *   var x1 = 20;
 *   var x2 = 80;
 *   var y1 = 30;
 *   var y2 = 70;
 *
 *   line(0, 0, x1, y1);
 *   print(mag(x1, y1)); // Prints "36.05551275463989"
 *   line(0, 0, x2, y1);
 *   print(mag(x2, y1)); // Prints "85.44003745317531"
 *   line(0, 0, x1, y2);
 *   print(mag(x1, y2)); // Prints "72.80109889280519"
 *   line(0, 0, x2, y2);
 *   print(mag(x2, y2)); // Prints "106.3014581273465"
 * }
 * </code></div>
 *
 * @alt
 * 4 lines of different length radiate from top left of canvas.
 *
 */
p5.prototype.mag = function(x, y) {
  p5._validateParameters('mag', arguments);
  return hypot(x, y);
};

/**
 * Re-maps a number from one range to another.
 * <br><br>
 * In the first example above, the number 25 is converted from a value in the
 * range of 0 to 100 into a value that ranges from the left edge of the
 * window (0) to the right edge (width).
 *
 * @method map
 * @param  {Number} value  the incoming value to be converted
 * @param  {Number} start1 lower bound of the value's current range
 * @param  {Number} stop1  upper bound of the value's current range
 * @param  {Number} start2 lower bound of the value's target range
 * @param  {Number} stop2  upper bound of the value's target range
 * @param  {Boolean} [withinBounds] constrain the value to the newly mapped range
 * @return {Number}        remapped number
 * @example
 *   <div><code>
 * var value = 25;
 * var m = map(value, 0, 100, 0, width);
 * ellipse(m, 50, 10, 10);
</code></div>
 *
 *   <div><code>
 * function setup() {
 *   noStroke();
 * }
 *
 * function draw() {
 *   background(204);
 *   var x1 = map(mouseX, 0, width, 25, 75);
 *   ellipse(x1, 25, 25, 25);
 *   //This ellipse is constrained to the 0-100 range
 *   //after setting withinBounds to true
 *   var x2 = map(mouseX, 0, width, 0, 100, true);
 *   ellipse(x2, 75, 25, 25);
 * }
</code></div>
 *
 * @alt
 * 10 by 10 white ellipse with in mid left canvas
 * 2 25 by 25 white ellipses move with mouse x. Bottom has more range from X
 *
 */
p5.prototype.map = function(n, start1, stop1, start2, stop2, withinBounds) {
  p5._validateParameters('map', arguments);
  var newval = (n - start1) / (stop1 - start1) * (stop2 - start2) + start2;
  if (!withinBounds) {
    return newval;
  }
  if (start2 < stop2) {
    return this.constrain(newval, start2, stop2);
  } else {
    return this.constrain(newval, stop2, start2);
  }
};

/**
 * Determines the largest value in a sequence of numbers, and then returns
 * that value. max() accepts any number of Number parameters, or an Array
 * of any length.
 *
 * @method max
 * @param  {Number} n0 Number to compare
 * @param  {Number} n1 Number to compare
 * @return {Number}             maximum Number
 * @example
 * <div><code>
 * function setup() {
 *   // Change the elements in the array and run the sketch
 *   // to show how max() works!
 *   var numArray = [2, 1, 5, 4, 8, 9];
 *   fill(0);
 *   noStroke();
 *   text('Array Elements', 0, 10);
 *   // Draw all numbers in the array
 *   var spacing = 15;
 *   var elemsY = 25;
 *   for (var i = 0; i < numArray.length; i++) {
 *     text(numArray[i], i * spacing, elemsY);
 *   }
 *   var maxX = 33;
 *   var maxY = 80;
 *   // Draw the Maximum value in the array.
 *   textSize(32);
 *   text(max(numArray), maxX, maxY);
 * }
 * </code></div>
 *
 * @alt
 * Small text at top reads: Array Elements 2 1 5 4 8 9. Large text at center: 9
 *
 */
/**
 * @method max
 * @param  {Number[]} nums Numbers to compare
 * @return {Number}
 */
p5.prototype.max = function() {
  p5._validateParameters('max', arguments);
  if (arguments[0] instanceof Array) {
    return Math.max.apply(null, arguments[0]);
  } else {
    return Math.max.apply(null, arguments);
  }
};

/**
 * Determines the smallest value in a sequence of numbers, and then returns
 * that value. min() accepts any number of Number parameters, or an Array
 * of any length.
 *
 * @method min
 * @param  {Number} n0 Number to compare
 * @param  {Number} n1 Number to compare
 * @return {Number}             minimum Number
 * @example
 * <div><code>
 * function setup() {
 *   // Change the elements in the array and run the sketch
 *   // to show how min() works!
 *   var numArray = [2, 1, 5, 4, 8, 9];
 *   fill(0);
 *   noStroke();
 *   text('Array Elements', 0, 10);
 *   // Draw all numbers in the array
 *   var spacing = 15;
 *   var elemsY = 25;
 *   for (var i = 0; i < numArray.length; i++) {
 *     text(numArray[i], i * spacing, elemsY);
 *   }
 *   var maxX = 33;
 *   var maxY = 80;
 *   // Draw the Minimum value in the array.
 *   textSize(32);
 *   text(min(numArray), maxX, maxY);
 * }
 * </code></div>
 *
 * @alt
 * Small text at top reads: Array Elements 2 1 5 4 8 9. Large text at center: 1
 *
 */
/**
 * @method min
 * @param  {Number[]} nums Numbers to compare
 * @return {Number}
 */
p5.prototype.min = function() {
  p5._validateParameters('min', arguments);
  if (arguments[0] instanceof Array) {
    return Math.min.apply(null, arguments[0]);
  } else {
    return Math.min.apply(null, arguments);
  }
};

/**
 * Normalizes a number from another range into a value between 0 and 1.
 * Identical to map(value, low, high, 0, 1).
 * Numbers outside of the range are not clamped to 0 and 1, because
 * out-of-range values are often intentional and useful. (See the second
 * example above.)
 *
 * @method norm
 * @param  {Number} value incoming value to be normalized
 * @param  {Number} start lower bound of the value's current range
 * @param  {Number} stop  upper bound of the value's current range
 * @return {Number}       normalized number
 * @example
 * <div><code>
 * function draw() {
 *   background(200);
 *   var currentNum = mouseX;
 *   var lowerBound = 0;
 *   var upperBound = width; //100;
 *   var normalized = norm(currentNum, lowerBound, upperBound);
 *   var lineY = 70;
 *   line(0, lineY, width, lineY);
 *   //Draw an ellipse mapped to the non-normalized value.
 *   noStroke();
 *   fill(50);
 *   var s = 7; // ellipse size
 *   ellipse(currentNum, lineY, s, s);
 *
 *   // Draw the guide
 *   var guideY = lineY + 15;
 *   text('0', 0, guideY);
 *   textAlign(RIGHT);
 *   text('100', width, guideY);
 *
 *   // Draw the normalized value
 *   textAlign(LEFT);
 *   fill(0);
 *   textSize(32);
 *   var normalY = 40;
 *   var normalX = 20;
 *   text(normalized, normalX, normalY);
 * }
 * </code></div>
 *
 * @alt
 * ellipse moves with mouse. 0 shown left & 100 right and updating values center
 *
 */
p5.prototype.norm = function(n, start, stop) {
  p5._validateParameters('norm', arguments);
  return this.map(n, start, stop, 0, 1);
};

/**
 * Facilitates exponential expressions. The pow() function is an efficient
 * way of multiplying numbers by themselves (or their reciprocals) in large
 * quantities. For example, pow(3, 5) is equivalent to the expression
 * 3*3*3*3*3 and pow(3, -5) is equivalent to 1 / 3*3*3*3*3. Maps to
 * Math.pow().
 *
 * @method pow
 * @param  {Number} n base of the exponential expression
 * @param  {Number} e power by which to raise the base
 * @return {Number}   n^e
 * @example
 * <div><code>
 * function setup() {
 *   //Exponentially increase the size of an ellipse.
 *   var eSize = 3; // Original Size
 *   var eLoc = 10; // Original Location
 *
 *   ellipse(eLoc, eLoc, eSize, eSize);
 *
 *   ellipse(eLoc * 2, eLoc * 2, pow(eSize, 2), pow(eSize, 2));
 *
 *   ellipse(eLoc * 4, eLoc * 4, pow(eSize, 3), pow(eSize, 3));
 *
 *   ellipse(eLoc * 8, eLoc * 8, pow(eSize, 4), pow(eSize, 4));
 * }
 * </code></div>
 *
 * @alt
 * small to large ellipses radiating from top left of canvas
 *
 */
p5.prototype.pow = Math.pow;

/**
 * Calculates the integer closest to the n parameter. For example,
 * round(133.8) returns the value 134. Maps to Math.round().
 *
 * @method round
 * @param  {Number} n number to round
 * @return {Integer}  rounded number
 * @example
 * <div><code>
 * function draw() {
 *   background(200);
 *   //map, mouseX between 0 and 5.
 *   var ax = map(mouseX, 0, 100, 0, 5);
 *   var ay = 66;
 *
 *   // Round the mapped number.
 *   var bx = round(map(mouseX, 0, 100, 0, 5));
 *   var by = 33;
 *
 *   // Multiply the mapped numbers by 20 to more easily
 *   // see the changes.
 *   stroke(0);
 *   fill(0);
 *   line(0, ay, ax * 20, ay);
 *   line(0, by, bx * 20, by);
 *
 *   // Reformat the float returned by map and draw it.
 *   noStroke();
 *   text(nfc(ax, 2), ax, ay - 5);
 *   text(nfc(bx, 1), bx, by - 5);
 * }
 * </code></div>
 *
 * @alt
 * horizontal center line squared values displayed on top and regular on bottom.
 *
 */
p5.prototype.round = Math.round;

/**
 * Squares a number (multiplies a number by itself). The result is always a
 * positive number, as multiplying two negative numbers always yields a
 * positive result. For example, -1 * -1 = 1.
 *
 * @method sq
 * @param  {Number} n number to square
 * @return {Number}   squared number
 * @example
 * <div><code>
 * function draw() {
 *   background(200);
 *   var eSize = 7;
 *   var x1 = map(mouseX, 0, width, 0, 10);
 *   var y1 = 80;
 *   var x2 = sq(x1);
 *   var y2 = 20;
 *
 *   // Draw the non-squared.
 *   line(0, y1, width, y1);
 *   ellipse(x1, y1, eSize, eSize);
 *
 *   // Draw the squared.
 *   line(0, y2, width, y2);
 *   ellipse(x2, y2, eSize, eSize);
 *
 *   // Draw dividing line.
 *   stroke(100);
 *   line(0, height / 2, width, height / 2);
 *
 *   // Draw text.
 *   var spacing = 15;
 *   noStroke();
 *   fill(0);
 *   text('x = ' + x1, 0, y1 + spacing);
 *   text('sq(x) = ' + x2, 0, y2 + spacing);
 * }
 * </code></div>
 *
 * @alt
 * horizontal center line squared values displayed on top and regular on bottom.
 *
 */
p5.prototype.sq = function(n) {
  return n * n;
};

/**
 * Calculates the square root of a number. The square root of a number is
 * always positive, even though there may be a valid negative root. The
 * square root s of number a is such that s*s = a. It is the opposite of
 * squaring. Maps to Math.sqrt().
 *
 * @method sqrt
 * @param  {Number} n non-negative number to square root
 * @return {Number}   square root of number
 * @example
 * <div><code>
 * function draw() {
 *   background(200);
 *   var eSize = 7;
 *   var x1 = mouseX;
 *   var y1 = 80;
 *   var x2 = sqrt(x1);
 *   var y2 = 20;
 *
 *   // Draw the non-squared.
 *   line(0, y1, width, y1);
 *   ellipse(x1, y1, eSize, eSize);
 *
 *   // Draw the squared.
 *   line(0, y2, width, y2);
 *   ellipse(x2, y2, eSize, eSize);
 *
 *   // Draw dividing line.
 *   stroke(100);
 *   line(0, height / 2, width, height / 2);
 *
 *   // Draw text.
 *   noStroke();
 *   fill(0);
 *   var spacing = 15;
 *   text('x = ' + x1, 0, y1 + spacing);
 *   text('sqrt(x) = ' + x2, 0, y2 + spacing);
 * }
 * </code></div>
 *
 * @alt
 * horizontal center line squareroot values displayed on top and regular on bottom.
 *
 */
p5.prototype.sqrt = Math.sqrt;

// Calculate the length of the hypotenuse of a right triangle
// This won't under- or overflow in intermediate steps
// https://en.wikipedia.org/wiki/Hypot
function hypot(x, y, z) {
  // Use the native implementation if it's available
  if (typeof Math.hypot === 'function') {
    return Math.hypot.apply(null, arguments);
  }

  // Otherwise use the V8 implementation
  // https://github.com/v8/v8/blob/8cd3cf297287e581a49e487067f5cbd991b27123/src/js/math.js#L217
  var length = arguments.length;
  var args = [];
  var max = 0;
  for (var i = 0; i < length; i++) {
    var n = arguments[i];
    n = +n;
    if (n === Infinity || n === -Infinity) {
      return Infinity;
    }
    n = Math.abs(n);
    if (n > max) {
      max = n;
    }
    args[i] = n;
  }

  if (max === 0) {
    max = 1;
  }
  var sum = 0;
  var compensation = 0;
  for (var j = 0; j < length; j++) {
    var m = args[j] / max;
    var summand = m * m - compensation;
    var preliminary = sum + summand;
    compensation = preliminary - sum - summand;
    sum = preliminary;
  }
  return Math.sqrt(sum) * max;
}

module.exports = p5;

},{"../core/core":22}],51:[function(_dereq_,module,exports){
/**
 * @module Math
 * @submodule Math
 * @for p5
 * @requires core
 */

'use strict';

var p5 = _dereq_('../core/core');

/**
 * Creates a new p5.Vector (the datatype for storing vectors). This provides a
 * two or three dimensional vector, specifically a Euclidean (also known as
 * geometric) vector. A vector is an entity that has both magnitude and
 * direction.
 *
 * @method createVector
 * @param {Number} [x] x component of the vector
 * @param {Number} [y] y component of the vector
 * @param {Number} [z] z component of the vector
 * @return {p5.Vector}
 * @example
 * <div modernizr='webgl'><code>
 * function setup() {
 *   createCanvas(100, 100, WEBGL);
 *   noStroke();
 *   fill(255, 102, 204);
 * }
 *
 * function draw() {
 *   background(255);
 *   pointLight(color(255), createVector(sin(millis() / 1000) * 20, -40, -10));
 *   scale(0.75);
 *   sphere();
 * }
 * </code></div>
 *
 * @alt
 * a purple sphere lit by a point light oscillating horizontally
 */
p5.prototype.createVector = function(x, y, z) {
  if (this instanceof p5) {
    return new p5.Vector(this, arguments);
  } else {
    return new p5.Vector(x, y, z);
  }
};

module.exports = p5;

},{"../core/core":22}],52:[function(_dereq_,module,exports){
//////////////////////////////////////////////////////////////

// http://mrl.nyu.edu/~perlin/noise/
// Adapting from PApplet.java
// which was adapted from toxi
// which was adapted from the german demo group farbrausch
// as used in their demo "art": http://www.farb-rausch.de/fr010src.zip

// someday we might consider using "improved noise"
// http://mrl.nyu.edu/~perlin/paper445.pdf
// See: https://github.com/shiffman/The-Nature-of-Code-Examples-p5.js/
//      blob/master/introduction/Noise1D/noise.js

/**
 * @module Math
 * @submodule Noise
 * @for p5
 * @requires core
 */

'use strict';

var p5 = _dereq_('../core/core');

var PERLIN_YWRAPB = 4;
var PERLIN_YWRAP = 1 << PERLIN_YWRAPB;
var PERLIN_ZWRAPB = 8;
var PERLIN_ZWRAP = 1 << PERLIN_ZWRAPB;
var PERLIN_SIZE = 4095;

var perlin_octaves = 4; // default to medium smooth
var perlin_amp_falloff = 0.5; // 50% reduction/octave

var scaled_cosine = function(i) {
  return 0.5 * (1.0 - Math.cos(i * Math.PI));
};

var perlin; // will be initialized lazily by noise() or noiseSeed()

/**
 * Returns the Perlin noise value at specified coordinates. Perlin noise is
 * a random sequence generator producing a more natural ordered, harmonic
 * succession of numbers compared to the standard <b>random()</b> function.
 * It was invented by Ken Perlin in the 1980s and been used since in
 * graphical applications to produce procedural textures, natural motion,
 * shapes, terrains etc.<br /><br /> The main difference to the
 * <b>random()</b> function is that Perlin noise is defined in an infinite
 * n-dimensional space where each pair of coordinates corresponds to a
 * fixed semi-random value (fixed only for the lifespan of the program; see
 * the noiseSeed() function). p5.js can compute 1D, 2D and 3D noise,
 * depending on the number of coordinates given. The resulting value will
 * always be between 0.0 and 1.0. The noise value can be animated by moving
 * through the noise space as demonstrated in the example above. The 2nd
 * and 3rd dimension can also be interpreted as time.<br /><br />The actual
 * noise is structured similar to an audio signal, in respect to the
 * function's use of frequencies. Similar to the concept of harmonics in
 * physics, perlin noise is computed over several octaves which are added
 * together for the final result. <br /><br />Another way to adjust the
 * character of the resulting sequence is the scale of the input
 * coordinates. As the function works within an infinite space the value of
 * the coordinates doesn't matter as such, only the distance between
 * successive coordinates does (eg. when using <b>noise()</b> within a
 * loop). As a general rule the smaller the difference between coordinates,
 * the smoother the resulting noise sequence will be. Steps of 0.005-0.03
 * work best for most applications, but this will differ depending on use.
 *
 *
 * @method noise
 * @param  {Number} x   x-coordinate in noise space
 * @param  {Number} [y] y-coordinate in noise space
 * @param  {Number} [z] z-coordinate in noise space
 * @return {Number}     Perlin noise value (between 0 and 1) at specified
 *                      coordinates
 * @example
 * <div>
 * <code>
 * var xoff = 0.0;
 *
 * function draw() {
 *   background(204);
 *   xoff = xoff + 0.01;
 *   var n = noise(xoff) * width;
 *   line(n, 0, n, height);
 * }
 * </code>
 * </div>
 * <div>
 * <code>var noiseScale=0.02;
 *
 * function draw() {
 *   background(0);
 *   for (var x=0; x < width; x++) {
 *     var noiseVal = noise((mouseX+x)*noiseScale, mouseY*noiseScale);
 *     stroke(noiseVal*255);
 *     line(x, mouseY+noiseVal*80, x, height);
 *   }
 * }
 * </code>
 * </div>
 *
 * @alt
 * vertical line moves left to right with updating noise values.
 * horizontal wave pattern effected by mouse x-position & updating noise values.
 *
 */

p5.prototype.noise = function(x, y, z) {
  y = y || 0;
  z = z || 0;

  if (perlin == null) {
    perlin = new Array(PERLIN_SIZE + 1);
    for (var i = 0; i < PERLIN_SIZE + 1; i++) {
      perlin[i] = Math.random();
    }
  }

  if (x < 0) {
    x = -x;
  }
  if (y < 0) {
    y = -y;
  }
  if (z < 0) {
    z = -z;
  }

  var xi = Math.floor(x),
    yi = Math.floor(y),
    zi = Math.floor(z);
  var xf = x - xi;
  var yf = y - yi;
  var zf = z - zi;
  var rxf, ryf;

  var r = 0;
  var ampl = 0.5;

  var n1, n2, n3;

  for (var o = 0; o < perlin_octaves; o++) {
    var of = xi + (yi << PERLIN_YWRAPB) + (zi << PERLIN_ZWRAPB);

    rxf = scaled_cosine(xf);
    ryf = scaled_cosine(yf);

    n1 = perlin[of & PERLIN_SIZE];
    n1 += rxf * (perlin[(of + 1) & PERLIN_SIZE] - n1);
    n2 = perlin[(of + PERLIN_YWRAP) & PERLIN_SIZE];
    n2 += rxf * (perlin[(of + PERLIN_YWRAP + 1) & PERLIN_SIZE] - n2);
    n1 += ryf * (n2 - n1);

    of += PERLIN_ZWRAP;
    n2 = perlin[of & PERLIN_SIZE];
    n2 += rxf * (perlin[(of + 1) & PERLIN_SIZE] - n2);
    n3 = perlin[(of + PERLIN_YWRAP) & PERLIN_SIZE];
    n3 += rxf * (perlin[(of + PERLIN_YWRAP + 1) & PERLIN_SIZE] - n3);
    n2 += ryf * (n3 - n2);

    n1 += scaled_cosine(zf) * (n2 - n1);

    r += n1 * ampl;
    ampl *= perlin_amp_falloff;
    xi <<= 1;
    xf *= 2;
    yi <<= 1;
    yf *= 2;
    zi <<= 1;
    zf *= 2;

    if (xf >= 1.0) {
      xi++;
      xf--;
    }
    if (yf >= 1.0) {
      yi++;
      yf--;
    }
    if (zf >= 1.0) {
      zi++;
      zf--;
    }
  }
  return r;
};

/**
 *
 * Adjusts the character and level of detail produced by the Perlin noise
 * function. Similar to harmonics in physics, noise is computed over
 * several octaves. Lower octaves contribute more to the output signal and
 * as such define the overall intensity of the noise, whereas higher octaves
 * create finer grained details in the noise sequence.
 * <br><br>
 * By default, noise is computed over 4 octaves with each octave contributing
 * exactly half than its predecessor, starting at 50% strength for the 1st
 * octave. This falloff amount can be changed by adding an additional function
 * parameter. Eg. a falloff factor of 0.75 means each octave will now have
 * 75% impact (25% less) of the previous lower octave. Any value between
 * 0.0 and 1.0 is valid, however note that values greater than 0.5 might
 * result in greater than 1.0 values returned by <b>noise()</b>.
 * <br><br>
 * By changing these parameters, the signal created by the <b>noise()</b>
 * function can be adapted to fit very specific needs and characteristics.
 *
 * @method noiseDetail
 * @param {Number} lod number of octaves to be used by the noise
 * @param {Number} falloff falloff factor for each octave
 * @example
 * <div>
 * <code>
 * var noiseVal;
 * var noiseScale = 0.02;
 *
 * function setup() {
 *   createCanvas(100, 100);
 * }
 *
 * function draw() {
 *   background(0);
 *   for (var y = 0; y < height; y++) {
 *     for (var x = 0; x < width / 2; x++) {
 *       noiseDetail(2, 0.2);
 *       noiseVal = noise((mouseX + x) * noiseScale, (mouseY + y) * noiseScale);
 *       stroke(noiseVal * 255);
 *       point(x, y);
 *       noiseDetail(8, 0.65);
 *       noiseVal = noise(
 *         (mouseX + x + width / 2) * noiseScale,
 *         (mouseY + y) * noiseScale
 *       );
 *       stroke(noiseVal * 255);
 *       point(x + width / 2, y);
 *     }
 *   }
 * }
 * </code>
 * </div>
 *
 * @alt
 * 2 vertical grey smokey patterns affected my mouse x-position and noise.
 *
 */
p5.prototype.noiseDetail = function(lod, falloff) {
  if (lod > 0) {
    perlin_octaves = lod;
  }
  if (falloff > 0) {
    perlin_amp_falloff = falloff;
  }
};

/**
 * Sets the seed value for <b>noise()</b>. By default, <b>noise()</b>
 * produces different results each time the program is run. Set the
 * <b>value</b> parameter to a constant to return the same pseudo-random
 * numbers each time the software is run.
 *
 * @method noiseSeed
 * @param {Number} seed   the seed value
 * @example
 * <div>
 * <code>var xoff = 0.0;
 *
 * function setup() {
 *   noiseSeed(99);
 *   stroke(0, 10);
 * }
 *
 * function draw() {
 *   xoff = xoff + .01;
 *   var n = noise(xoff) * width;
 *   line(n, 0, n, height);
 * }
 * </code>
 * </div>
 *
 * @alt
 * vertical grey lines drawing in pattern affected by noise.
 *
 */
p5.prototype.noiseSeed = function(seed) {
  // Linear Congruential Generator
  // Variant of a Lehman Generator
  var lcg = (function() {
    // Set to values from http://en.wikipedia.org/wiki/Numerical_Recipes
    // m is basically chosen to be large (as it is the max period)
    // and for its relationships to a and c
    var m = 4294967296;
    // a - 1 should be divisible by m's prime factors
    var a = 1664525;
    // c and m should be co-prime
    var c = 1013904223;
    var seed, z;
    return {
      setSeed: function(val) {
        // pick a random seed if val is undefined or null
        // the >>> 0 casts the seed to an unsigned 32-bit integer
        z = seed = (val == null ? Math.random() * m : val) >>> 0;
      },
      getSeed: function() {
        return seed;
      },
      rand: function() {
        // define the recurrence relationship
        z = (a * z + c) % m;
        // return a float in [0, 1)
        // if z = m then z / m = 0 therefore (z % m) / m < 1 always
        return z / m;
      }
    };
  })();

  lcg.setSeed(seed);
  perlin = new Array(PERLIN_SIZE + 1);
  for (var i = 0; i < PERLIN_SIZE + 1; i++) {
    perlin[i] = lcg.rand();
  }
};

module.exports = p5;

},{"../core/core":22}],53:[function(_dereq_,module,exports){
/**
 * @module Math
 * @submodule Math
 * @requires constants
 */

'use strict';

var p5 = _dereq_('../core/core');
var polarGeometry = _dereq_('./polargeometry');
var constants = _dereq_('../core/constants');

/**
 * A class to describe a two or three dimensional vector, specifically
 * a Euclidean (also known as geometric) vector. A vector is an entity
 * that has both magnitude and direction. The datatype, however, stores
 * the components of the vector (x, y for 2D, and x, y, z for 3D). The magnitude
 * and direction can be accessed via the methods mag() and heading().
 * <br><br>
 * In many of the p5.js examples, you will see p5.Vector used to describe a
 * position, velocity, or acceleration. For example, if you consider a rectangle
 * moving across the screen, at any given instant it has a position (a vector
 * that points from the origin to its location), a velocity (the rate at which
 * the object's position changes per time unit, expressed as a vector), and
 * acceleration (the rate at which the object's velocity changes per time
 * unit, expressed as a vector).
 * <br><br>
 * Since vectors represent groupings of values, we cannot simply use
 * traditional addition/multiplication/etc. Instead, we'll need to do some
 * "vector" math, which is made easy by the methods inside the p5.Vector class.
 *
 * @class p5.Vector
 * @constructor
 * @param {Number} [x] x component of the vector
 * @param {Number} [y] y component of the vector
 * @param {Number} [z] z component of the vector
 * @example
 * <div>
 * <code>
 * var v1 = createVector(40, 50);
 * var v2 = createVector(40, 50);
 *
 * ellipse(v1.x, v1.y, 50, 50);
 * ellipse(v2.x, v2.y, 50, 50);
 * v1.add(v2);
 * ellipse(v1.x, v1.y, 50, 50);
 * </code>
 * </div>
 *
 * @alt
 * 2 white ellipses. One center-left the other bottom right and off canvas
 *
 */
p5.Vector = function Vector() {
  var x, y, z;
  // This is how it comes in with createVector()
  if (arguments[0] instanceof p5) {
    // save reference to p5 if passed in
    this.p5 = arguments[0];
    x = arguments[1][0] || 0;
    y = arguments[1][1] || 0;
    z = arguments[1][2] || 0;
    // This is what we'll get with new p5.Vector()
  } else {
    x = arguments[0] || 0;
    y = arguments[1] || 0;
    z = arguments[2] || 0;
  }
  /**
   * The x component of the vector
   * @property x {Number}
   */
  this.x = x;
  /**
   * The y component of the vector
   * @property y {Number}
   */
  this.y = y;
  /**
   * The z component of the vector
   * @property z {Number}
   */
  this.z = z;
  this.name = 'p5.Vector'; // for friendly debugger system
};

/**
 * Returns a string representation of a vector v by calling String(v)
 * or v.toString(). This method is useful for logging vectors in the
 * console.
 * @method  toString
 * @return {String}
 * @example
 * <div class = "norender">
 * <code>
 * function setup() {
 *   var v = createVector(20, 30);
 *   print(String(v)); // prints "p5.Vector Object : [20, 30, 0]"
 * }
 * </code>
 * </div>
 */
p5.Vector.prototype.toString = function p5VectorToString() {
  return 'p5.Vector Object : [' + this.x + ', ' + this.y + ', ' + this.z + ']';
};

/**
 * Sets the x, y, and z component of the vector using two or three separate
 * variables, the data from a p5.Vector, or the values from a float array.
 * @method set
 * @param {Number} [x] the x component of the vector
 * @param {Number} [y] the y component of the vector
 * @param {Number} [z] the z component of the vector
 * @chainable
 * @example
 * <div class="norender">
 * <code>
 * function setup() {
 *   var v = createVector(1, 2, 3);
 *   v.set(4, 5, 6); // Sets vector to [4, 5, 6]
 *
 *   var v1 = createVector(0, 0, 0);
 *   var arr = [1, 2, 3];
 *   v1.set(arr); // Sets vector to [1, 2, 3]
 * }
 * </code>
 * </div>
 */
/**
 * @method set
 * @param {p5.Vector|Number[]} value the vector to set
 * @chainable
 */
p5.Vector.prototype.set = function set(x, y, z) {
  if (x instanceof p5.Vector) {
    this.x = x.x || 0;
    this.y = x.y || 0;
    this.z = x.z || 0;
    return this;
  }
  if (x instanceof Array) {
    this.x = x[0] || 0;
    this.y = x[1] || 0;
    this.z = x[2] || 0;
    return this;
  }
  this.x = x || 0;
  this.y = y || 0;
  this.z = z || 0;
  return this;
};

/**
 * Gets a copy of the vector, returns a p5.Vector object.
 *
 * @method copy
 * @return {p5.Vector} the copy of the p5.Vector object
 * @example
 * <div class="norender">
 * <code>
 * var v1 = createVector(1, 2, 3);
 * var v2 = v1.copy();
 * print(v1.x === v2.x && v1.y === v2.y && v1.z === v2.z);
 * // Prints "true"
 * </code>
 * </div>
 */
p5.Vector.prototype.copy = function copy() {
  if (this.p5) {
    return new p5.Vector(this.p5, [this.x, this.y, this.z]);
  } else {
    return new p5.Vector(this.x, this.y, this.z);
  }
};

/**
 * Adds x, y, and z components to a vector, adds one vector to another, or
 * adds two independent vectors together. The version of the method that adds
 * two vectors together is a static method and returns a p5.Vector, the others
 * acts directly on the vector. See the examples for more context.
 *
 * @method add
 * @param  {Number} x   the x component of the vector to be added
 * @param  {Number} [y] the y component of the vector to be added
 * @param  {Number} [z] the z component of the vector to be added
 * @chainable
 * @example
 * <div class="norender">
 * <code>
 * var v = createVector(1, 2, 3);
 * v.add(4, 5, 6);
 * // v's components are set to [5, 7, 9]
 * </code>
 * </div>
 *
 * <div class="norender">
 * <code>
 * // Static method
 * var v1 = createVector(1, 2, 3);
 * var v2 = createVector(2, 3, 4);
 *
 * var v3 = p5.Vector.add(v1, v2);
 * // v3 has components [3, 5, 7]
 * print(v3);
 * </code>
 * </div>
 */
/**
 * @method add
 * @param  {p5.Vector|Number[]} value the vector to add
 * @chainable
 */
p5.Vector.prototype.add = function add(x, y, z) {
  if (x instanceof p5.Vector) {
    this.x += x.x || 0;
    this.y += x.y || 0;
    this.z += x.z || 0;
    return this;
  }
  if (x instanceof Array) {
    this.x += x[0] || 0;
    this.y += x[1] || 0;
    this.z += x[2] || 0;
    return this;
  }
  this.x += x || 0;
  this.y += y || 0;
  this.z += z || 0;
  return this;
};

/**
 * Subtracts x, y, and z components from a vector, subtracts one vector from
 * another, or subtracts two independent vectors. The version of the method
 * that subtracts two vectors is a static method and returns a p5.Vector, the
 * other acts directly on the vector. See the examples for more context.
 *
 * @method sub
 * @param  {Number} x   the x component of the vector to subtract
 * @param  {Number} [y] the y component of the vector to subtract
 * @param  {Number} [z] the z component of the vector to subtract
 * @chainable
 * @example
 * <div class="norender">
 * <code>
 * var v = createVector(4, 5, 6);
 * v.sub(1, 1, 1);
 * // v's components are set to [3, 4, 5]
 * </code>
 * </div>
 *
 * <div class="norender">
 * <code>
 * // Static method
 * var v1 = createVector(2, 3, 4);
 * var v2 = createVector(1, 2, 3);
 *
 * var v3 = p5.Vector.sub(v1, v2);
 * // v3 has components [1, 1, 1]
 * print(v3);
 * </code>
 * </div>
 */
/**
 * @method sub
 * @param  {p5.Vector|Number[]} value the vector to subtract
 * @chainable
 */
p5.Vector.prototype.sub = function sub(x, y, z) {
  if (x instanceof p5.Vector) {
    this.x -= x.x || 0;
    this.y -= x.y || 0;
    this.z -= x.z || 0;
    return this;
  }
  if (x instanceof Array) {
    this.x -= x[0] || 0;
    this.y -= x[1] || 0;
    this.z -= x[2] || 0;
    return this;
  }
  this.x -= x || 0;
  this.y -= y || 0;
  this.z -= z || 0;
  return this;
};

/**
 * Multiply the vector by a scalar. The static version of this method
 * creates a new p5.Vector while the non static version acts on the vector
 * directly. See the examples for more context.
 *
 * @method mult
 * @param  {Number}    n the number to multiply with the vector
 * @chainable
 * @example
 * <div class="norender">
 * <code>
 * var v = createVector(1, 2, 3);
 * v.mult(2);
 * // v's components are set to [2, 4, 6]
 * </code>
 * </div>
 *
 * <div class="norender">
 * <code>
 * // Static method
 * var v1 = createVector(1, 2, 3);
 * var v2 = p5.Vector.mult(v1, 2);
 * // v2 has components [2, 4, 6]
 * print(v2);
 * </code>
 * </div>
 */
p5.Vector.prototype.mult = function mult(n) {
  if (!(typeof n === 'number' && isFinite(n))) {
    console.warn(
      'p5.Vector.prototype.mult:',
      'n is undefined or not a finite number'
    );
    return this;
  }
  this.x *= n;
  this.y *= n;
  this.z *= n;
  return this;
};

/**
 * Divide the vector by a scalar. The static version of this method creates a
 * new p5.Vector while the non static version acts on the vector directly.
 * See the examples for more context.
 *
 * @method div
 * @param  {number}    n the number to divide the vector by
 * @chainable
 * @example
 * <div class="norender">
 * <code>
 * var v = createVector(6, 4, 2);
 * v.div(2); //v's components are set to [3, 2, 1]
 * </code>
 * </div>
 *
 * <div class="norender">
 * <code>
 * // Static method
 * var v1 = createVector(6, 4, 2);
 * var v2 = p5.Vector.div(v1, 2);
 * // v2 has components [3, 2, 1]
 * print(v2);
 * </code>
 * </div>
 */
p5.Vector.prototype.div = function div(n) {
  if (!(typeof n === 'number' && isFinite(n))) {
    console.warn(
      'p5.Vector.prototype.div:',
      'n is undefined or not a finite number'
    );
    return this;
  }
  if (n === 0) {
    console.warn('p5.Vector.prototype.div:', 'divide by 0');
    return this;
  }
  this.x /= n;
  this.y /= n;
  this.z /= n;
  return this;
};

/**
 * Calculates the magnitude (length) of the vector and returns the result as
 * a float (this is simply the equation sqrt(x*x + y*y + z*z).)
 *
 * @method mag
 * @return {Number} magnitude of the vector
 * @example
 * <div class="norender">
 * <code>
 * var v = createVector(20.0, 30.0, 40.0);
 * var m = v.mag();
 * print(m); // Prints "53.85164807134504"
 * </code>
 * </div>
 */
p5.Vector.prototype.mag = function mag() {
  return Math.sqrt(this.magSq());
};

/**
 * Calculates the squared magnitude of the vector and returns the result
 * as a float (this is simply the equation <em>(x*x + y*y + z*z)</em>.)
 * Faster if the real length is not required in the
 * case of comparing vectors, etc.
 *
 * @method magSq
 * @return {number} squared magnitude of the vector
 * @example
 * <div class="norender">
 * <code>
 * // Static method
 * var v1 = createVector(6, 4, 2);
 * print(v1.magSq()); // Prints "56"
 * </code>
 * </div>
 */
p5.Vector.prototype.magSq = function magSq() {
  var x = this.x;
  var y = this.y;
  var z = this.z;
  return x * x + y * y + z * z;
};

/**
 * Calculates the dot product of two vectors. The version of the method
 * that computes the dot product of two independent vectors is a static
 * method. See the examples for more context.
 *
 *
 * @method dot
 * @param  {Number} x   x component of the vector
 * @param  {Number} [y] y component of the vector
 * @param  {Number} [z] z component of the vector
 * @return {Number}       the dot product
 *
 * @example
 * <div class="norender">
 * <code>
 * var v1 = createVector(1, 2, 3);
 * var v2 = createVector(2, 3, 4);
 *
 * print(v1.dot(v2)); // Prints "20"
 * </code>
 * </div>
 *
 * <div class="norender">
 * <code>
 * //Static method
 * var v1 = createVector(1, 2, 3);
 * var v2 = createVector(3, 2, 1);
 * print(p5.Vector.dot(v1, v2)); // Prints "10"
 * </code>
 * </div>
 */
/**
 * @method dot
 * @param  {p5.Vector} value value component of the vector or a p5.Vector
 * @return {Number}
 */
p5.Vector.prototype.dot = function dot(x, y, z) {
  if (x instanceof p5.Vector) {
    return this.dot(x.x, x.y, x.z);
  }
  return this.x * (x || 0) + this.y * (y || 0) + this.z * (z || 0);
};

/**
 * Calculates and returns a vector composed of the cross product between
 * two vectors. Both the static and non static methods return a new p5.Vector.
 * See the examples for more context.
 *
 * @method cross
 * @param  {p5.Vector} v p5.Vector to be crossed
 * @return {p5.Vector}   p5.Vector composed of cross product
 * @example
 * <div class="norender">
 * <code>
 * var v1 = createVector(1, 2, 3);
 * var v2 = createVector(1, 2, 3);
 *
 * v1.cross(v2); // v's components are [0, 0, 0]
 * </code>
 * </div>
 *
 * <div class="norender">
 * <code>
 * // Static method
 * var v1 = createVector(1, 0, 0);
 * var v2 = createVector(0, 1, 0);
 *
 * var crossProduct = p5.Vector.cross(v1, v2);
 * // crossProduct has components [0, 0, 1]
 * print(crossProduct);
 * </code>
 * </div>
 */
p5.Vector.prototype.cross = function cross(v) {
  var x = this.y * v.z - this.z * v.y;
  var y = this.z * v.x - this.x * v.z;
  var z = this.x * v.y - this.y * v.x;
  if (this.p5) {
    return new p5.Vector(this.p5, [x, y, z]);
  } else {
    return new p5.Vector(x, y, z);
  }
};

/**
 * Calculates the Euclidean distance between two points (considering a
 * point as a vector object).
 *
 * @method dist
 * @param  {p5.Vector} v the x, y, and z coordinates of a p5.Vector
 * @return {Number}      the distance
 * @example
 * <div class="norender">
 * <code>
 * var v1 = createVector(1, 0, 0);
 * var v2 = createVector(0, 1, 0);
 *
 * var distance = v1.dist(v2); // distance is 1.4142...
 * print(distance);
 * </code>
 * </div>
 *
 * <div class="norender">
 * <code>
 * // Static method
 * var v1 = createVector(1, 0, 0);
 * var v2 = createVector(0, 1, 0);
 *
 * var distance = p5.Vector.dist(v1, v2);
 * // distance is 1.4142...
 * print(distance);
 * </code>
 * </div>
 */
p5.Vector.prototype.dist = function dist(v) {
  return v
    .copy()
    .sub(this)
    .mag();
};

/**
 * Normalize the vector to length 1 (make it a unit vector).
 *
 * @method normalize
 * @return {p5.Vector} normalized p5.Vector
 * @example
 * <div class="norender">
 * <code>
 * var v = createVector(10, 20, 2);
 * // v has components [10.0, 20.0, 2.0]
 * v.normalize();
 * // v's components are set to
 * // [0.4454354, 0.8908708, 0.089087084]
 * </code>
 * </div>
 */
p5.Vector.prototype.normalize = function normalize() {
  return this.mag() === 0 ? this : this.div(this.mag());
};

/**
 * Limit the magnitude of this vector to the value used for the <b>max</b>
 * parameter.
 *
 * @method limit
 * @param  {Number}    max the maximum magnitude for the vector
 * @chainable
 * @example
 * <div class="norender">
 * <code>
 * var v = createVector(10, 20, 2);
 * // v has components [10.0, 20.0, 2.0]
 * v.limit(5);
 * // v's components are set to
 * // [2.2271771, 4.4543543, 0.4454354]
 * </code>
 * </div>
 */
p5.Vector.prototype.limit = function limit(max) {
  var mSq = this.magSq();
  if (mSq > max * max) {
    this.div(Math.sqrt(mSq)) //normalize it
      .mult(max);
  }
  return this;
};

/**
 * Set the magnitude of this vector to the value used for the <b>len</b>
 * parameter.
 *
 * @method setMag
 * @param  {number}    len the new length for this vector
 * @chainable
 * @example
 * <div class="norender">
 * <code>
 * var v = createVector(10, 20, 2);
 * // v has components [10.0, 20.0, 2.0]
 * v.setMag(10);
 * // v's components are set to [6.0, 8.0, 0.0]
 * </code>
 * </div>
 */
p5.Vector.prototype.setMag = function setMag(n) {
  return this.normalize().mult(n);
};

/**
 * Calculate the angle of rotation for this vector (only 2D vectors)
 *
 * @method heading
 * @return {Number} the angle of rotation
 * @example
 * <div class = "norender">
 * <code>
 * function setup() {
 *   var v1 = createVector(30, 50);
 *   print(v1.heading()); // 1.0303768265243125
 *
 *   v1 = createVector(40, 50);
 *   print(v1.heading()); // 0.8960553845713439
 *
 *   v1 = createVector(30, 70);
 *   print(v1.heading()); // 1.1659045405098132
 * }
 * </code>
 * </div>
 */
p5.Vector.prototype.heading = function heading() {
  var h = Math.atan2(this.y, this.x);
  if (this.p5) {
    if (this.p5._angleMode === constants.RADIANS) {
      return h;
    }
    return polarGeometry.radiansToDegrees(h);
  }
  return h;
};

/**
 * Rotate the vector by an angle (only 2D vectors), magnitude remains the
 * same
 *
 * @method rotate
 * @param  {number}    angle the angle of rotation
 * @chainable
 * @example
 * <div class="norender">
 * <code>
 * var v = createVector(10.0, 20.0);
 * // v has components [10.0, 20.0, 0.0]
 * v.rotate(HALF_PI);
 * // v's components are set to [-20.0, 9.999999, 0.0]
 * </code>
 * </div>
 */
p5.Vector.prototype.rotate = function rotate(a) {
  var newHeading = this.heading() + a;
  if (this.p5) {
    if (this.p5._angleMode === constants.DEGREES) {
      newHeading = polarGeometry.degreesToRadians(newHeading);
    }
  }
  var mag = this.mag();
  this.x = Math.cos(newHeading) * mag;
  this.y = Math.sin(newHeading) * mag;
  return this;
};

/**
 * Calculates and returns the angle (in radians) between two vectors.
 * @method angleBetween
 * @param  {p5.Vector}    the x, y, and z components of a p5.Vector
 * @return {Number}       the angle between (in radians)
 * @example
 * <div class="norender">
 * <code>
 * var v1 = createVector(1, 0, 0);
 * var v2 = createVector(0, 1, 0);
 *
 * var angle = v1.angleBetween(v2);
 * // angle is PI/2
 * print(angle);
 * </code>
 * </div>
 */
p5.Vector.prototype.angleBetween = function angleBetween(v) {
  var dotmagmag = this.dot(v) / (this.mag() * v.mag());
  // Mathematically speaking: the dotmagmag variable will be between -1 and 1
  // inclusive. Practically though it could be slightly outside this range due
  // to floating-point rounding issues. This can make Math.acos return NaN.
  //
  // Solution: we'll clamp the value to the -1,1 range
  var angle = Math.acos(Math.min(1, Math.max(-1, dotmagmag)));
  if (this.p5) {
    if (this.p5._angleMode === constants.DEGREES) {
      angle = polarGeometry.radiansToDegrees(angle);
    }
  }
  return angle;
};

/**
 * Linear interpolate the vector to another vector
 *
 * @method lerp
 * @param  {Number}    x   the x component
 * @param  {Number}    y   the y component
 * @param  {Number}    z   the z component
 * @param  {Number}    amt the amount of interpolation; some value between 0.0
 *                         (old vector) and 1.0 (new vector). 0.9 is very near
 *                         the new vector. 0.5 is halfway in between.
 * @chainable
 *
 * @example
 * <div class="norender">
 * <code>
 * var v = createVector(1, 1, 0);
 *
 * v.lerp(3, 3, 0, 0.5); // v now has components [2,2,0]
 * </code>
 * </div>
 *
 * <div class="norender">
 * <code>
 * var v1 = createVector(0, 0, 0);
 * var v2 = createVector(100, 100, 0);
 *
 * var v3 = p5.Vector.lerp(v1, v2, 0.5);
 * // v3 has components [50,50,0]
 * print(v3);
 * </code>
 * </div>
 */
/**
 * @method lerp
 * @param  {p5.Vector} v   the p5.Vector to lerp to
 * @param  {Number}    amt
 * @chainable
 */
p5.Vector.prototype.lerp = function lerp(x, y, z, amt) {
  if (x instanceof p5.Vector) {
    return this.lerp(x.x, x.y, x.z, y);
  }
  this.x += (x - this.x) * amt || 0;
  this.y += (y - this.y) * amt || 0;
  this.z += (z - this.z) * amt || 0;
  return this;
};

/**
 * Return a representation of this vector as a float array. This is only
 * for temporary use. If used in any other fashion, the contents should be
 * copied by using the <b>p5.Vector.copy()</b> method to copy into your own
 * array.
 *
 * @method array
 * @return {Number[]} an Array with the 3 values
 * @example
 * <div class = "norender">
 * <code>
 * function setup() {
 *   var v = createVector(20, 30);
 *   print(v.array()); // Prints : Array [20, 30, 0]
 * }
 * </code>
 * </div>
 *
 * <div class="norender">
 * <code>
 * var v = createVector(10.0, 20.0, 30.0);
 * var f = v.array();
 * print(f[0]); // Prints "10.0"
 * print(f[1]); // Prints "20.0"
 * print(f[2]); // Prints "30.0"
 * </code>
 * </div>
 */
p5.Vector.prototype.array = function array() {
  return [this.x || 0, this.y || 0, this.z || 0];
};

/**
 * Equality check against a p5.Vector
 *
 * @method equals
 * @param {Number} [x] the x component of the vector
 * @param {Number} [y] the y component of the vector
 * @param {Number} [z] the z component of the vector
 * @return {Boolean} whether the vectors are equals
 * @example
 * <div class = "norender">
 * <code>
 * var v1 = createVector(5, 10, 20);
 * var v2 = createVector(5, 10, 20);
 * var v3 = createVector(13, 10, 19);
 *
 * print(v1.equals(v2.x, v2.y, v2.z)); // true
 * print(v1.equals(v3.x, v3.y, v3.z)); // false
 * </code>
 * </div>
 *
 * <div class="norender">
 * <code>
 * var v1 = createVector(10.0, 20.0, 30.0);
 * var v2 = createVector(10.0, 20.0, 30.0);
 * var v3 = createVector(0.0, 0.0, 0.0);
 * print(v1.equals(v2)); // true
 * print(v1.equals(v3)); // false
 * </code>
 * </div>
 */
/**
 * @method equals
 * @param {p5.Vector|Array} value the vector to compare
 * @return {Boolean}
 */
p5.Vector.prototype.equals = function equals(x, y, z) {
  var a, b, c;
  if (x instanceof p5.Vector) {
    a = x.x || 0;
    b = x.y || 0;
    c = x.z || 0;
  } else if (x instanceof Array) {
    a = x[0] || 0;
    b = x[1] || 0;
    c = x[2] || 0;
  } else {
    a = x || 0;
    b = y || 0;
    c = z || 0;
  }
  return this.x === a && this.y === b && this.z === c;
};

// Static Methods

/**
 * Make a new 2D vector from an angle
 *
 * @method fromAngle
 * @static
 * @param {Number}     angle the desired angle
 * @param {Number}     [length] the length of the new vector (defaults to 1)
 * @return {p5.Vector}       the new p5.Vector object
 * @example
 * <div>
 * <code>
 * function draw() {
 *   background(200);
 *
 *   // Create a variable, proportional to the mouseX,
 *   // varying from 0-360, to represent an angle in degrees.
 *   angleMode(DEGREES);
 *   var myDegrees = map(mouseX, 0, width, 0, 360);
 *
 *   // Display that variable in an onscreen text.
 *   // (Note the nfc() function to truncate additional decimal places,
 *   // and the "\xB0" character for the degree symbol.)
 *   var readout = 'angle = ' + nfc(myDegrees, 1) + '\xB0';
 *   noStroke();
 *   fill(0);
 *   text(readout, 5, 15);
 *
 *   // Create a p5.Vector using the fromAngle function,
 *   // and extract its x and y components.
 *   var v = p5.Vector.fromAngle(radians(myDegrees), 30);
 *   var vx = v.x;
 *   var vy = v.y;
 *
 *   push();
 *   translate(width / 2, height / 2);
 *   noFill();
 *   stroke(150);
 *   line(0, 0, 30, 0);
 *   stroke(0);
 *   line(0, 0, vx, vy);
 *   pop();
 * }
 * </code>
 * </div>
 */
p5.Vector.fromAngle = function fromAngle(angle, length) {
  if (this.p5) {
    if (this.p5._angleMode === constants.DEGREES) {
      angle = polarGeometry.degreesToRadians(angle);
    }
  }
  if (typeof length === 'undefined') {
    length = 1;
  }
  if (this.p5) {
    return new p5.Vector(this.p5, [
      length * Math.cos(angle),
      length * Math.sin(angle),
      0
    ]);
  } else {
    return new p5.Vector(length * Math.cos(angle), length * Math.sin(angle), 0);
  }
};

/**
 * Make a new 3D vector from a pair of ISO spherical angles
 *
 * @method fromAngles
 * @static
 * @param {Number}     theta the polar angle (zero is up)
 * @param {Number}     phi the azimuthal angle (zero is out of the screen)
 * @param {Number}     [length] the length of the new vector (defaults to 1)
 * @return {p5.Vector}       the new p5.Vector object
 * @example
 * <div modernizr='webgl'>
 * <code>
 * function setup() {
 *   createCanvas(100, 100, WEBGL);
 *   fill(255);
 *   noStroke();
 * }
 * function draw() {
 *   background(255);
 *
 *   var t = millis() / 1000;
 *
 *   // add three point lights
 *   pointLight(color('#f00'), p5.Vector.fromAngles(t * 1.0, t * 1.3, 100));
 *   pointLight(color('#0f0'), p5.Vector.fromAngles(t * 1.1, t * 1.2, 100));
 *   pointLight(color('#00f'), p5.Vector.fromAngles(t * 1.2, t * 1.1, 100));
 *
 *   sphere(35);
 * }
 * </code>
 * </div>
 */
p5.Vector.fromAngles = function(theta, phi, length) {
  if (this.p5) {
    if (this.p5._angleMode === constants.DEGREES) {
      theta = polarGeometry.degreesToRadians(theta);
      phi = polarGeometry.degreesToRadians(phi);
    }
  }
  if (typeof length === 'undefined') {
    length = 1;
  }
  var cosPhi = Math.cos(phi);
  var sinPhi = Math.sin(phi);
  var cosTheta = Math.cos(theta);
  var sinTheta = Math.sin(theta);

  if (this.p5) {
    return new new p5.Vector(
      this.p5,
      length * sinTheta * sinPhi,
      -length * cosTheta,
      length * sinTheta * cosPhi
    )();
  } else {
    return new p5.Vector(
      length * sinTheta * sinPhi,
      -length * cosTheta,
      length * sinTheta * cosPhi
    );
  }
};

/**
 * Make a new 2D unit vector from a random angle
 *
 * @method random2D
 * @static
 * @return {p5.Vector} the new p5.Vector object
 * @example
 * <div class="norender">
 * <code>
 * var v = p5.Vector.random2D();
 * // May make v's attributes something like:
 * // [0.61554617, -0.51195765, 0.0] or
 * // [-0.4695841, -0.14366731, 0.0] or
 * // [0.6091097, -0.22805278, 0.0]
 * print(v);
 * </code>
 * </div>
 */
p5.Vector.random2D = function random2D() {
  var angle;
  // A lot of nonsense to determine if we know about a
  // p5 sketch and whether we should make a random angle in degrees or radians
  if (this.p5) {
    if (this.p5._angleMode === constants.DEGREES) {
      angle = this.p5.random(360);
    } else {
      angle = this.p5.random(constants.TWO_PI);
    }
  } else {
    angle = Math.random() * constants.TWO_PI;
  }
  return this.fromAngle(angle);
};

/**
 * Make a new random 3D unit vector.
 *
 * @method random3D
 * @static
 * @return {p5.Vector} the new p5.Vector object
 * @example
 * <div class="norender">
 * <code>
 * var v = p5.Vector.random3D();
 * // May make v's attributes something like:
 * // [0.61554617, -0.51195765, 0.599168] or
 * // [-0.4695841, -0.14366731, -0.8711202] or
 * // [0.6091097, -0.22805278, -0.7595902]
 * print(v);
 * </code>
 * </div>
 */
p5.Vector.random3D = function random3D() {
  var angle, vz;
  // If we know about p5
  if (this.p5) {
    angle = this.p5.random(0, constants.TWO_PI);
    vz = this.p5.random(-1, 1);
  } else {
    angle = Math.random() * constants.TWO_PI;
    vz = Math.random() * 2 - 1;
  }
  var vzBase = Math.sqrt(1 - vz * vz);
  var vx = vzBase * Math.cos(angle);
  var vy = vzBase * Math.sin(angle);
  if (this.p5) {
    return new p5.Vector(this.p5, [vx, vy, vz]);
  }
  return new p5.Vector(vx, vy, vz);
};

// Adds two vectors together and returns a new one.
/**
 * @method add
 * @static
 * @param  {p5.Vector} v1 a p5.Vector to add
 * @param  {p5.Vector} v2 a p5.Vector to add
 * @param  {p5.Vector} target the vector to receive the result
 */
/**
 * @method add
 * @static
 * @param  {p5.Vector} v1
 * @param  {p5.Vector} v2
 * @return {p5.Vector} the resulting p5.Vector
 *
 */

p5.Vector.add = function add(v1, v2, target) {
  if (!target) {
    target = v1.copy();
  } else {
    target.set(v1);
  }
  target.add(v2);
  return target;
};

/*
 * Subtracts one p5.Vector from another and returns a new one.  The second
 * vector (v2) is subtracted from the first (v1), resulting in v1-v2.
 */
/**
 * @method sub
 * @static
 * @param  {p5.Vector} v1 a p5.Vector to subtract from
 * @param  {p5.Vector} v2 a p5.Vector to subtract
 * @param  {p5.Vector} target if undefined a new vector will be created
 */
/**
 * @method sub
 * @static
 * @param  {p5.Vector} v1
 * @param  {p5.Vector} v2
 * @return {p5.Vector} the resulting p5.Vector
 */

p5.Vector.sub = function sub(v1, v2, target) {
  if (!target) {
    target = v1.copy();
  } else {
    target.set(v1);
  }
  target.sub(v2);
  return target;
};

/**
 * Multiplies a vector by a scalar and returns a new vector.
 */
/**
 * @method mult
 * @static
 * @param  {p5.Vector} v the vector to multiply
 * @param  {Number}  n
 * @param  {p5.Vector} target if undefined a new vector will be created
 */
/**
 * @method mult
 * @static
 * @param  {p5.Vector} v
 * @param  {Number}  n
 * @return {p5.Vector}  the resulting new p5.Vector
 */
p5.Vector.mult = function mult(v, n, target) {
  if (!target) {
    target = v.copy();
  } else {
    target.set(v);
  }
  target.mult(n);
  return target;
};

/**
 * Divides a vector by a scalar and returns a new vector.
 */
/**
 * @method div
 * @static
 * @param  {p5.Vector} v the vector to divide
 * @param  {Number}  n
 * @param  {p5.Vector} target if undefined a new vector will be created
 */
/**
 * @method div
 * @static
 * @param  {p5.Vector} v
 * @param  {Number}  n
 * @return {p5.Vector} the resulting new p5.Vector
 */
p5.Vector.div = function div(v, n, target) {
  if (!target) {
    target = v.copy();
  } else {
    target.set(v);
  }
  target.div(n);
  return target;
};

/**
 * Calculates the dot product of two vectors.
 */
/**
 * @method dot
 * @static
 * @param  {p5.Vector} v1 the first p5.Vector
 * @param  {p5.Vector} v2 the second p5.Vector
 * @return {Number}     the dot product
 */
p5.Vector.dot = function dot(v1, v2) {
  return v1.dot(v2);
};

/**
 * Calculates the cross product of two vectors.
 */
/**
 * @method cross
 * @static
 * @param  {p5.Vector} v1 the first p5.Vector
 * @param  {p5.Vector} v2 the second p5.Vector
 * @return {Number}     the cross product
 */
p5.Vector.cross = function cross(v1, v2) {
  return v1.cross(v2);
};

/**
 * Calculates the Euclidean distance between two points (considering a
 * point as a vector object).
 */
/**
 * @method dist
 * @static
 * @param  {p5.Vector} v1 the first p5.Vector
 * @param  {p5.Vector} v2 the second p5.Vector
 * @return {Number}     the distance
 */
p5.Vector.dist = function dist(v1, v2) {
  return v1.dist(v2);
};

/**
 * Linear interpolate a vector to another vector and return the result as a
 * new vector.
 */
/**
 * @method lerp
 * @static
 * @param {p5.Vector} v1
 * @param {p5.Vector} v2
 * @param {Number} amt
 * @param {p5.Vector} target if undefined a new vector will be created
 */
/**
 * @method lerp
 * @static
 * @param {p5.Vector} v1
 * @param {p5.Vector} v2
 * @param {Number} amt
 * @return {Number}      the lerped value
 */
p5.Vector.lerp = function lerp(v1, v2, amt, target) {
  if (!target) {
    target = v1.copy();
  } else {
    target.set(v1);
  }
  target.lerp(v2, amt);
  return target;
};

/**
 * @method mag
 * @param {p5.Vector} vecT the vector to return the magnitude of
 * @return {Number}        the magnitude of vecT
 * @static
 */
p5.Vector.mag = function mag(vecT) {
  var x = vecT.x,
    y = vecT.y,
    z = vecT.z;
  var magSq = x * x + y * y + z * z;
  return Math.sqrt(magSq);
};

module.exports = p5.Vector;

},{"../core/constants":21,"../core/core":22,"./polargeometry":54}],54:[function(_dereq_,module,exports){
'use strict';

module.exports = {
  degreesToRadians: function(x) {
    return 2 * Math.PI * x / 360;
  },

  radiansToDegrees: function(x) {
    return 360 * x / (2 * Math.PI);
  }
};

},{}],55:[function(_dereq_,module,exports){
/**
 * @module Math
 * @submodule Random
 * @for p5
 * @requires core
 */

'use strict';

var p5 = _dereq_('../core/core');

var seeded = false;
var previous = false;
var y2 = 0;

// Linear Congruential Generator
// Variant of a Lehman Generator
var lcg = (function() {
  // Set to values from http://en.wikipedia.org/wiki/Numerical_Recipes
  // m is basically chosen to be large (as it is the max period)
  // and for its relationships to a and c
  var m = 4294967296,
    // a - 1 should be divisible by m's prime factors
    a = 1664525,
    // c and m should be co-prime
    c = 1013904223,
    seed,
    z;
  return {
    setSeed: function(val) {
      // pick a random seed if val is undefined or null
      // the >>> 0 casts the seed to an unsigned 32-bit integer
      z = seed = (val == null ? Math.random() * m : val) >>> 0;
    },
    getSeed: function() {
      return seed;
    },
    rand: function() {
      // define the recurrence relationship
      z = (a * z + c) % m;
      // return a float in [0, 1)
      // if z = m then z / m = 0 therefore (z % m) / m < 1 always
      return z / m;
    }
  };
})();

/**
 * Sets the seed value for random().
 *
 * By default, random() produces different results each time the program
 * is run. Set the seed parameter to a constant to return the same
 * pseudo-random numbers each time the software is run.
 *
 * @method randomSeed
 * @param {Number} seed   the seed value
 * @example
 * <div>
 * <code>
 * randomSeed(99);
 * for (var i = 0; i < 100; i++) {
 *   var r = random(0, 255);
 *   stroke(r);
 *   line(i, 0, i, 100);
 * }
 * </code>
 * </div>
 *
 * @alt
 * many vertical lines drawn in white, black or grey.
 *
 */
p5.prototype.randomSeed = function(seed) {
  lcg.setSeed(seed);
  seeded = true;
  previous = false;
};

/**
 * Return a random floating-point number.
 *
 * Takes either 0, 1 or 2 arguments.
 *
 * If no argument is given, returns a random number from 0
 * up to (but not including) 1.
 *
 * If one argument is given and it is a number, returns a random number from 0
 * up to (but not including) the number.
 *
 * If one argument is given and it is an array, returns a random element from
 * that array.
 *
 * If two arguments are given, returns a random number from the
 * first argument up to (but not including) the second argument.
 *
 * @method random
 * @param  {Number} [min]   the lower bound (inclusive)
 * @param  {Number} [max]   the upper bound (exclusive)
 * @return {Number} the random number
 * @example
 * <div>
 * <code>
 * for (var i = 0; i < 100; i++) {
 *   var r = random(50);
 *   stroke(r * 5);
 *   line(50, i, 50 + r, i);
 * }
 * </code>
 * </div>
 * <div>
 * <code>
 * for (var i = 0; i < 100; i++) {
 *   var r = random(-50, 50);
 *   line(50, i, 50 + r, i);
 * }
 * </code>
 * </div>
 * <div>
 * <code>
 * // Get a random element from an array using the random(Array) syntax
 * var words = ['apple', 'bear', 'cat', 'dog'];
 * var word = random(words); // select random word
 * text(word, 10, 50); // draw the word
 * </code>
 * </div>
 *
 * @alt
 * 100 horizontal lines from center canvas to right. size+fill change each time
 * 100 horizontal lines from center of canvas. height & side change each render
 * word displayed at random. Either apple, bear, cat, or dog
 *
 */
/**
 * @method random
 * @param  {Array} choices   the array to choose from
 * @return {*} the random element from the array
 * @example
 */
p5.prototype.random = function(min, max) {
  var rand;

  if (seeded) {
    rand = lcg.rand();
  } else {
    rand = Math.random();
  }
  if (typeof min === 'undefined') {
    return rand;
  } else if (typeof max === 'undefined') {
    if (min instanceof Array) {
      return min[Math.floor(rand * min.length)];
    } else {
      return rand * min;
    }
  } else {
    if (min > max) {
      var tmp = min;
      min = max;
      max = tmp;
    }

    return rand * (max - min) + min;
  }
};

/**
 *
 * Returns a random number fitting a Gaussian, or
 * normal, distribution. There is theoretically no minimum or maximum
 * value that randomGaussian() might return. Rather, there is
 * just a very low probability that values far from the mean will be
 * returned; and a higher probability that numbers near the mean will
 * be returned.
 * <br><br>
 * Takes either 0, 1 or 2 arguments.<br>
 * If no args, returns a mean of 0 and standard deviation of 1.<br>
 * If one arg, that arg is the mean (standard deviation is 1).<br>
 * If two args, first is mean, second is standard deviation.
 *
 * @method randomGaussian
 * @param  {Number} mean  the mean
 * @param  {Number} sd    the standard deviation
 * @return {Number} the random number
 * @example
 * <div>
 * <code>
 * for (var y = 0; y < 100; y++) {
 *   var x = randomGaussian(50, 15);
 *   line(50, y, x, y);
 * }
 * </code>
 * </div>
 * <div>
 * <code>
 * var distribution = new Array(360);
 *
 * function setup() {
 *   createCanvas(100, 100);
 *   for (var i = 0; i < distribution.length; i++) {
 *     distribution[i] = floor(randomGaussian(0, 15));
 *   }
 * }
 *
 * function draw() {
 *   background(204);
 *
 *   translate(width / 2, width / 2);
 *
 *   for (var i = 0; i < distribution.length; i++) {
 *     rotate(TWO_PI / distribution.length);
 *     stroke(0);
 *     var dist = abs(distribution[i]);
 *     line(0, 0, dist, 0);
 *   }
 * }
 * </code>
 * </div>
 * @alt
 * 100 horizontal lines from center of canvas. height & side change each render
 * black lines radiate from center of canvas. size determined each render
 */
p5.prototype.randomGaussian = function(mean, sd) {
  var y1, x1, x2, w;
  if (previous) {
    y1 = y2;
    previous = false;
  } else {
    do {
      x1 = this.random(2) - 1;
      x2 = this.random(2) - 1;
      w = x1 * x1 + x2 * x2;
    } while (w >= 1);
    w = Math.sqrt(-2 * Math.log(w) / w);
    y1 = x1 * w;
    y2 = x2 * w;
    previous = true;
  }

  var m = mean || 0;
  var s = sd || 1;
  return y1 * s + m;
};

module.exports = p5;

},{"../core/core":22}],56:[function(_dereq_,module,exports){
/**
 * @module Math
 * @submodule Trigonometry
 * @for p5
 * @requires core
 * @requires polargeometry
 * @requires constants
 */

'use strict';

var p5 = _dereq_('../core/core');
var polarGeometry = _dereq_('./polargeometry');
var constants = _dereq_('../core/constants');

p5.prototype._angleMode = constants.RADIANS;

/**
 * The inverse of cos(), returns the arc cosine of a value. This function
 * expects the values in the range of -1 to 1 and values are returned in
 * the range 0 to PI (3.1415927).
 *
 * @method acos
 * @param  {Number} value the value whose arc cosine is to be returned
 * @return {Number}       the arc cosine of the given value
 *
 * @example
 * <div class= “norender">
 * <code>
 * var a = PI;
 * var c = cos(a);
 * var ac = acos(c);
 * // Prints: "3.1415927 : -1.0 : 3.1415927"
 * print(a + ' : ' + c + ' : ' + ac);
 * </code>
 * </div>
 *
 * <div class= “norender">
 * <code>
 * var a = PI + PI / 4.0;
 * var c = cos(a);
 * var ac = acos(c);
 * // Prints: "3.926991 : -0.70710665 : 2.3561943"
 * print(a + ' : ' + c + ' : ' + ac);
 * </code>
 * </div>
 */
p5.prototype.acos = function(ratio) {
  if (this._angleMode === constants.RADIANS) {
    return Math.acos(ratio);
  } else {
    return polarGeometry.radiansToDegrees(Math.acos(ratio));
  }
};

/**
 * The inverse of sin(), returns the arc sine of a value. This function
 * expects the values in the range of -1 to 1 and values are returned
 * in the range -PI/2 to PI/2.
 *
 * @method asin
 * @param  {Number} value the value whose arc sine is to be returned
 * @return {Number}       the arc sine of the given value
 *
 * @example
 * <div class= “norender">
 * <code>
 * var a = PI + PI / 3;
 * var s = sin(a);
 * var as = asin(s);
 * // Prints: "1.0471976 : 0.86602545 : 1.0471976"
 * print(a + ' : ' + s + ' : ' + as);
 * </code>
 * </div>
 *
 * <div class= “norender">
 * <code>
 * var a = PI + PI / 3.0;
 * var s = sin(a);
 * var as = asin(s);
 * // Prints: "4.1887903 : -0.86602545 : -1.0471976"
 * print(a + ' : ' + s + ' : ' + as);
 * </code>
 * </div>
 *
 */
p5.prototype.asin = function(ratio) {
  if (this._angleMode === constants.RADIANS) {
    return Math.asin(ratio);
  } else {
    return polarGeometry.radiansToDegrees(Math.asin(ratio));
  }
};

/**
 * The inverse of tan(), returns the arc tangent of a value. This function
 * expects the values in the range of -Infinity to Infinity (exclusive) and
 * values are returned in the range -PI/2 to PI/2.
 *
 * @method atan
 * @param  {Number} value the value whose arc tangent is to be returned
 * @return {Number}       the arc tangent of the given value
 *
 * @example
 * <div class= “norender">
 * <code>
 * var a = PI + PI / 3;
 * var t = tan(a);
 * var at = atan(t);
 * // Prints: "1.0471976 : 1.7320509 : 1.0471976"
 * print(a + ' : ' + t + ' : ' + at);
 * </code>
 * </div>
 *
 * <div class= “norender">
 * <code>
 * var a = PI + PI / 3.0;
 * var t = tan(a);
 * var at = atan(t);
 * // Prints: "4.1887903 : 1.7320513 : 1.0471977"
 * print(a + ' : ' + t + ' : ' + at);
 * </code>
 * </div>
 *
 */
p5.prototype.atan = function(ratio) {
  if (this._angleMode === constants.RADIANS) {
    return Math.atan(ratio);
  } else {
    return polarGeometry.radiansToDegrees(Math.atan(ratio));
  }
};

/**
 * Calculates the angle (in radians) from a specified point to the coordinate
 * origin as measured from the positive x-axis. Values are returned as a
 * float in the range from PI to -PI. The atan2() function is most often used
 * for orienting geometry to the position of the cursor.
 * <br><br>
 * Note: The y-coordinate of the point is the first parameter, and the
 * x-coordinate is the second parameter, due the the structure of calculating
 * the tangent.
 *
 * @method atan2
 * @param  {Number} y y-coordinate of the point
 * @param  {Number} x x-coordinate of the point
 * @return {Number}   the arc tangent of the given point
 *
 * @example
 * <div>
 * <code>
 * function draw() {
 *   background(204);
 *   translate(width / 2, height / 2);
 *   var a = atan2(mouseY - height / 2, mouseX - width / 2);
 *   rotate(a);
 *   rect(-30, -5, 60, 10);
 * }
 * </code>
 * </div>
 *
 * @alt
 * 60 by 10 rect at center of canvas rotates with mouse movements
 *
 */
p5.prototype.atan2 = function(y, x) {
  if (this._angleMode === constants.RADIANS) {
    return Math.atan2(y, x);
  } else {
    return polarGeometry.radiansToDegrees(Math.atan2(y, x));
  }
};

/**
 * Calculates the cosine of an angle. This function takes into account the
 * current angleMode. Values are returned in the range -1 to 1.
 *
 * @method cos
 * @param  {Number} angle the angle
 * @return {Number}       the cosine of the angle
 *
 * @example
 * <div>
 * <code>
 * var a = 0.0;
 * var inc = TWO_PI / 25.0;
 * for (var i = 0; i < 25; i++) {
 *   line(i * 4, 50, i * 4, 50 + cos(a) * 40.0);
 *   a = a + inc;
 * }
 * </code>
 * </div>
 *
 * @alt
 * vertical black lines form wave patterns, extend-down on left and right side
 *
 */
p5.prototype.cos = function(angle) {
  if (this._angleMode === constants.RADIANS) {
    return Math.cos(angle);
  } else {
    return Math.cos(this.radians(angle));
  }
};

/**
 * Calculates the sine of an angle. This function takes into account the
 * current angleMode. Values are returned in the range -1 to 1.
 *
 * @method sin
 * @param  {Number} angle the angle
 * @return {Number}       the sine of the angle
 *
 * @example
 * <div>
 * <code>
 * var a = 0.0;
 * var inc = TWO_PI / 25.0;
 * for (var i = 0; i < 25; i++) {
 *   line(i * 4, 50, i * 4, 50 + sin(a) * 40.0);
 *   a = a + inc;
 * }
 * </code>
 * </div>
 *
 * @alt
 * vertical black lines extend down and up from center to form wave pattern
 *
 */
p5.prototype.sin = function(angle) {
  if (this._angleMode === constants.RADIANS) {
    return Math.sin(angle);
  } else {
    return Math.sin(this.radians(angle));
  }
};

/**
 * Calculates the tangent of an angle. This function takes into account
 * the current angleMode. Values are returned in the range -1 to 1.
 *
 * @method tan
 * @param  {Number} angle the angle
 * @return {Number}       the tangent of the angle
 *
 * @example
 * <div>
 * <code>
 * var a = 0.0;
 * var inc = TWO_PI / 50.0;
 * for (var i = 0; i < 100; i = i + 2) {
 *   line(i, 50, i, 50 + tan(a) * 2.0);
 *   a = a + inc;
 * }
 * </code>
 *
 *
 * @alt
 * vertical black lines end down and up from center to form spike pattern
 *
 */
p5.prototype.tan = function(angle) {
  if (this._angleMode === constants.RADIANS) {
    return Math.tan(angle);
  } else {
    return Math.tan(this.radians(angle));
  }
};

/**
 * Converts a radian measurement to its corresponding value in degrees.
 * Radians and degrees are two ways of measuring the same thing. There are
 * 360 degrees in a circle and 2*PI radians in a circle. For example,
 * 90° = PI/2 = 1.5707964.
 *
 * @method degrees
 * @param  {Number} radians the radians value to convert to degrees
 * @return {Number}         the converted angle
 *
 *
 * @example
 * <div class= “norender">
 * <code>
 * var rad = PI / 4;
 * var deg = degrees(rad);
 * print(rad + ' radians is ' + deg + ' degrees');
 * // Prints: 0.7853981633974483 radians is 45 degrees
 * </code>
 * </div>
 *
 */
p5.prototype.degrees = function(angle) {
  return polarGeometry.radiansToDegrees(angle);
};

/**
 * Converts a degree measurement to its corresponding value in radians.
 * Radians and degrees are two ways of measuring the same thing. There are
 * 360 degrees in a circle and 2*PI radians in a circle. For example,
 * 90° = PI/2 = 1.5707964.
 *
 * @method radians
 * @param  {Number} degrees the degree value to convert to radians
 * @return {Number}         the converted angle
 *
 * @example
 * <div class= “norender">
 * <code>
 * var deg = 45.0;
 * var rad = radians(deg);
 * print(deg + ' degrees is ' + rad + ' radians');
 * // Prints: 45 degrees is 0.7853981633974483 radians
 * </code>
 * </div>
 */
p5.prototype.radians = function(angle) {
  return polarGeometry.degreesToRadians(angle);
};

/**
 * Sets the current mode of p5 to given mode. Default mode is RADIANS.
 *
 * @method angleMode
 * @param {Constant} mode either RADIANS or DEGREES
 *
 * @example
 * <div>
 * <code>
 * function draw() {
 *   background(204);
 *   angleMode(DEGREES); // Change the mode to DEGREES
 *   var a = atan2(mouseY - height / 2, mouseX - width / 2);
 *   translate(width / 2, height / 2);
 *   push();
 *   rotate(a);
 *   rect(-20, -5, 40, 10); // Larger rectangle is rotating in degrees
 *   pop();
 *   angleMode(RADIANS); // Change the mode to RADIANS
 *   rotate(a); // var a stays the same
 *   rect(-40, -5, 20, 10); // Smaller rectangle is rotating in radians
 * }
 * </code>
 * </div>
 *
 * @alt
 * 40 by 10 rect in center rotates with mouse moves. 20 by 10 rect moves faster.
 *
 *
 */
p5.prototype.angleMode = function(mode) {
  if (mode === constants.DEGREES || mode === constants.RADIANS) {
    this._angleMode = mode;
  }
};

module.exports = p5;

},{"../core/constants":21,"../core/core":22,"./polargeometry":54}],57:[function(_dereq_,module,exports){
/**
 * @module Typography
 * @submodule Attributes
 * @for p5
 * @requires core
 * @requires constants
 */

'use strict';

var p5 = _dereq_('../core/core');

/**
 * Sets the current alignment for drawing text. Accepts two
 * arguments: horizAlign (LEFT, CENTER, or RIGHT) and
 * vertAlign (TOP, BOTTOM, CENTER, or BASELINE).
 *
 * The horizAlign parameter is in reference to the x value
 * of the text() function, while the vertAlign parameter is
 * in reference to the y value.
 *
 * So if you write textAlign(LEFT), you are aligning the left
 * edge of your text to the x value you give in text(). If you
 * write textAlign(RIGHT, TOP), you are aligning the right edge
 * of your text to the x value and the top of edge of the text
 * to the y value.
 *
 * @method textAlign
 * @param {Constant} horizAlign horizontal alignment, either LEFT,
 *                            CENTER, or RIGHT
 * @param {Constant} [vertAlign] vertical alignment, either TOP,
 *                            BOTTOM, CENTER, or BASELINE
 * @chainable
 * @example
 * <div>
 * <code>
 * textSize(16);
 * textAlign(RIGHT);
 * text('ABCD', 50, 30);
 * textAlign(CENTER);
 * text('EFGH', 50, 50);
 * textAlign(LEFT);
 * text('IJKL', 50, 70);
 * </code>
 * </div>
 *
 * @alt
 *Letters ABCD displayed at top right, EFGH at center and IJKL at bottom left.
 *
 */
/**
 * @method textAlign
 * @return {Object}
 */
p5.prototype.textAlign = function(horizAlign, vertAlign) {
  return this._renderer.textAlign.apply(this._renderer, arguments);
};

/**
 * Sets/gets the spacing, in pixels, between lines of text. This
 * setting will be used in all subsequent calls to the text() function.
 *
 * @method textLeading
 * @param {Number} leading the size in pixels for spacing between lines
 * @chainable
 *
 * @example
 * <div>
 * <code>
 * // Text to display. The "\n" is a "new line" character
 * var lines = 'L1\nL2\nL3';
 * textSize(12);
 *
 * textLeading(10); // Set leading to 10
 * text(lines, 10, 25);
 *
 * textLeading(20); // Set leading to 20
 * text(lines, 40, 25);
 *
 * textLeading(30); // Set leading to 30
 * text(lines, 70, 25);
 * </code>
 * </div>
 *
 * @alt
 *set L1 L2 & L3 displayed vertically 3 times. spacing increases for each set
 */
/**
 * @method textLeading
 * @return {Number}
 */
p5.prototype.textLeading = function(theLeading) {
  return this._renderer.textLeading.apply(this._renderer, arguments);
};

/**
 * Sets/gets the current font size. This size will be used in all subsequent
 * calls to the text() function. Font size is measured in pixels.
 *
 * @method textSize
 * @param {Number} theSize the size of the letters in units of pixels
 * @chainable
 *
 * @example
 * <div>
 * <code>
 * textSize(12);
 * text('Font Size 12', 10, 30);
 * textSize(14);
 * text('Font Size 14', 10, 60);
 * textSize(16);
 * text('Font Size 16', 10, 90);
 * </code>
 * </div>
 *
 * @alt
 *Font Size 12 displayed small, Font Size 14 medium & Font Size 16 large
 */
/**
 * @method textSize
 * @return {Number}
 */
p5.prototype.textSize = function(theSize) {
  return this._renderer.textSize.apply(this._renderer, arguments);
};

/**
 * Sets/gets the style of the text for system fonts to NORMAL, ITALIC, or BOLD.
 * Note: this may be is overridden by CSS styling. For non-system fonts
 * (opentype, truetype, etc.) please load styled fonts instead.
 *
 * @method textStyle
 * @param {Constant} theStyle styling for text, either NORMAL,
 *                            ITALIC, or BOLD
 * @chainable
 * @example
 * <div>
 * <code>
 * strokeWeight(0);
 * textSize(12);
 * textStyle(NORMAL);
 * text('Font Style Normal', 10, 30);
 * textStyle(ITALIC);
 * text('Font Style Italic', 10, 60);
 * textStyle(BOLD);
 * text('Font Style Bold', 10, 90);
 * </code>
 * </div>
 *
 * @alt
 *words Font Style Normal displayed normally, Italic in italic and bold in bold
 */
/**
 * @method textStyle
 * @return {String}
 */
p5.prototype.textStyle = function(theStyle) {
  return this._renderer.textStyle.apply(this._renderer, arguments);
};

/**
 * Calculates and returns the width of any character or text string.
 *
 * @method textWidth
 * @param {String} theText the String of characters to measure
 * @return {Number}
 * @example
 * <div>
 * <code>
 * textSize(28);
 *
 * var aChar = 'P';
 * var cWidth = textWidth(aChar);
 * text(aChar, 0, 40);
 * line(cWidth, 0, cWidth, 50);
 *
 * var aString = 'p5.js';
 * var sWidth = textWidth(aString);
 * text(aString, 0, 85);
 * line(sWidth, 50, sWidth, 100);
 * </code>
 * </div>
 *
 * @alt
 *Letter P and p5.js are displayed with vertical lines at end. P is wide
 *
 */
p5.prototype.textWidth = function(theText) {
  if (theText.length === 0) {
    return 0;
  }
  return this._renderer.textWidth.apply(this._renderer, arguments);
};

/**
 * Returns the ascent of the current font at its current size. The ascent
 * represents the distance, in pixels, of the tallest character above
 * the baseline.
 * @method textAscent
 * @return {Number}
 * @example
 * <div>
 * <code>
 * var base = height * 0.75;
 * var scalar = 0.8; // Different for each font
 *
 * textSize(32); // Set initial text size
 * var asc = textAscent() * scalar; // Calc ascent
 * line(0, base - asc, width, base - asc);
 * text('dp', 0, base); // Draw text on baseline
 *
 * textSize(64); // Increase text size
 * asc = textAscent() * scalar; // Recalc ascent
 * line(40, base - asc, width, base - asc);
 * text('dp', 40, base); // Draw text on baseline
 * </code>
 * </div>
 */
p5.prototype.textAscent = function() {
  return this._renderer.textAscent();
};

/**
 * Returns the descent of the current font at its current size. The descent
 * represents the distance, in pixels, of the character with the longest
 * descender below the baseline.
 * @method textDescent
 * @return {Number}
 * @example
 * <div>
 * <code>
 * var base = height * 0.75;
 * var scalar = 0.8; // Different for each font
 *
 * textSize(32); // Set initial text size
 * var desc = textDescent() * scalar; // Calc ascent
 * line(0, base + desc, width, base + desc);
 * text('dp', 0, base); // Draw text on baseline
 *
 * textSize(64); // Increase text size
 * desc = textDescent() * scalar; // Recalc ascent
 * line(40, base + desc, width, base + desc);
 * text('dp', 40, base); // Draw text on baseline
 * </code>
 * </div>
 */
p5.prototype.textDescent = function() {
  return this._renderer.textDescent();
};

/**
 * Helper function to measure ascent and descent.
 */
p5.prototype._updateTextMetrics = function() {
  return this._renderer._updateTextMetrics();
};

module.exports = p5;

},{"../core/core":22}],58:[function(_dereq_,module,exports){
/**
 * @module Typography
 * @submodule Loading & Displaying
 * @for p5
 * @requires core
 */

'use strict';

var p5 = _dereq_('../core/core');
var constants = _dereq_('../core/constants');
var opentype = _dereq_('opentype.js');

_dereq_('../core/error_helpers');

/**
 * Loads an opentype font file (.otf, .ttf) from a file or a URL,
 * and returns a PFont Object. This method is asynchronous,
 * meaning it may not finish before the next line in your sketch
 * is executed.
 * <br><br>
 * The path to the font should be relative to the HTML file
 * that links in your sketch. Loading an from a URL or other
 * remote location may be blocked due to your browser's built-in
 * security.
 *
 * @method loadFont
 * @param  {String}        path       name of the file or url to load
 * @param  {Function}      [callback] function to be executed after
 *                                    loadFont() completes
 * @param  {Function}      [onError]  function to be executed if
 *                                    an error occurs
 * @return {p5.Font}                  p5.Font object
 * @example
 *
 * <p>Calling loadFont() inside preload() guarantees that the load
 * operation will have completed before setup() and draw() are called.</p>
 *
 * <div><code>
 * var myFont;
 * function preload() {
 *   myFont = loadFont('assets/AvenirNextLTPro-Demi.otf');
 * }
 *
 * function setup() {
 *   fill('#ED225D');
 *   textFont(myFont);
 *   textSize(36);
 *   text('p5*js', 10, 50);
 * }
 * </code></div>
 *
 * Outside of preload(), you may supply a callback function to handle the
 * object:
 *
 * <div><code>
 * function setup() {
 *   loadFont('assets/AvenirNextLTPro-Demi.otf', drawText);
 * }
 *
 * function drawText(font) {
 *   fill('#ED225D');
 *   textFont(font, 36);
 *   text('p5*js', 10, 50);
 * }
 * </code></div>
 *
 * <p>You can also use the string name of the font to style other HTML
 * elements.</p>
 *
 * <div><code>
 * function preload() {
 *   loadFont('assets/Avenir.otf');
 * }
 *
 * function setup() {
 *   var myDiv = createDiv('hello there');
 *   myDiv.style('font-family', 'Avenir');
 * }
 * </code></div>
 *
 * @alt
 * p5*js in p5's theme dark pink
 * p5*js in p5's theme dark pink
 *
 */
p5.prototype.loadFont = function(path, onSuccess, onError) {
  var p5Font = new p5.Font(this);

  var self = this;
  opentype.load(path, function(err, font) {
    if (err) {
      if (typeof onError !== 'undefined') {
        return onError(err);
      }
      p5._friendlyFileLoadError(4, path);
      console.error(err, path);
      return;
    }

    p5Font.font = font;

    if (typeof onSuccess !== 'undefined') {
      onSuccess(p5Font);
    }

    self._decrementPreload();

    // check that we have an acceptable font type
    var validFontTypes = ['ttf', 'otf', 'woff', 'woff2'],
      fileNoPath = path
        .split('\\')
        .pop()
        .split('/')
        .pop(),
      lastDotIdx = fileNoPath.lastIndexOf('.'),
      fontFamily,
      newStyle,
      fileExt = lastDotIdx < 1 ? null : fileNoPath.substr(lastDotIdx + 1);

    // if so, add it to the DOM (name-only) for use with p5.dom
    if (validFontTypes.indexOf(fileExt) > -1) {
      fontFamily = fileNoPath.substr(0, lastDotIdx);
      newStyle = document.createElement('style');
      newStyle.appendChild(
        document.createTextNode(
          '\n@font-face {' +
            '\nfont-family: ' +
            fontFamily +
            ';\nsrc: url(' +
            path +
            ');\n}\n'
        )
      );
      document.head.appendChild(newStyle);
    }
  });

  return p5Font;
};

/**
 * Draws text to the screen. Displays the information specified in the first
 * parameter on the screen in the position specified by the additional
 * parameters. A default font will be used unless a font is set with the
 * textFont() function and a default size will be used unless a font is set
 * with textSize(). Change the color of the text with the fill() function.
 * Change the outline of the text with the stroke() and strokeWeight()
 * functions.
 * <br><br>
 * The text displays in relation to the textAlign() function, which gives the
 * option to draw to the left, right, and center of the coordinates.
 * <br><br>
 * The x2 and y2 parameters define a rectangular area to display within and
 * may only be used with string data. When these parameters are specified,
 * they are interpreted based on the current rectMode() setting. Text that
 * does not fit completely within the rectangle specified will not be drawn
 * to the screen.
 *
 * @method text
 * @param {String|Object|Array} str the alphanumeric symbols to be displayed
 * @param {Number} x   x-coordinate of text
 * @param {Number} y   y-coordinate of text
 * @param {Number} [x2]  by default, the width of the text box,
 *                     see rectMode() for more info
 * @param {Number} [y2]  by default, the height of the text box,
 *                     see rectMode() for more info
 * @chainable
 * @example
 * <div>
 * <code>
 * textSize(32);
 * text('word', 10, 30);
 * fill(0, 102, 153);
 * text('word', 10, 60);
 * fill(0, 102, 153, 51);
 * text('word', 10, 90);
 * </code>
 * </div>
 * <div>
 * <code>
 * var s = 'The quick brown fox jumped over the lazy dog.';
 * fill(50);
 * text(s, 10, 10, 70, 80); // Text wraps within text box
 * </code>
 * </div>
 *
 * @alt
 *'word' displayed 3 times going from black, blue to translucent blue
 * The quick brown fox jumped over the lazy dog.
 *
 */
p5.prototype.text = function(str, x, y, maxWidth, maxHeight) {
  return !(this._renderer._doFill || this._renderer._doStroke)
    ? this
    : this._renderer.text.apply(this._renderer, arguments);
};

/**
 * Sets the current font that will be drawn with the text() function.
 *
 * @method textFont
 * @return {Object} the current font
 *
 * @example
 * <div>
 * <code>
 * fill(0);
 * textSize(12);
 * textFont('Georgia');
 * text('Georgia', 12, 30);
 * textFont('Helvetica');
 * text('Helvetica', 12, 60);
 * </code>
 * </div>
 * <div>
 * <code>
 * var fontRegular, fontItalic, fontBold;
 * function preload() {
 *   fontRegular = loadFont('assets/Regular.otf');
 *   fontItalic = loadFont('assets/Italic.ttf');
 *   fontBold = loadFont('assets/Bold.ttf');
 * }
 * function setup() {
 *   background(210);
 *   fill(0)
    .strokeWeight(0)
    .textSize(10);
 *   textFont(fontRegular);
 *   text('Font Style Normal', 10, 30);
 *   textFont(fontItalic);
 *   text('Font Style Italic', 10, 50);
 *   textFont(fontBold);
 *   text('Font Style Bold', 10, 70);
 * }
 * </code>
 * </div>
 *
 * @alt
 *words Font Style Normal displayed normally, Italic in italic and bold in bold
 */
/**
 * @method textFont
 * @param {Object|String} font a font loaded via loadFont(), or a String
 * representing a <a href="https://mzl.la/2dOw8WD">web safe font</a> (a font
 * that is generally available across all systems)
 * @param {Number} [size] the font size to use
 * @chainable
 */
p5.prototype.textFont = function(theFont, theSize) {
  if (arguments.length) {
    if (!theFont) {
      throw Error('null font passed to textFont');
    }

    this._renderer._setProperty('_textFont', theFont);

    if (theSize) {
      this._renderer._setProperty('_textSize', theSize);
      this._renderer._setProperty(
        '_textLeading',
        theSize * constants._DEFAULT_LEADMULT
      );
    }

    return this._renderer._applyTextProperties();
  }

  return this._renderer._textFont;
};

module.exports = p5;

},{"../core/constants":21,"../core/core":22,"../core/error_helpers":25,"opentype.js":10}],59:[function(_dereq_,module,exports){
/**
 * This module defines the p5.Font class and functions for
 * drawing text to the display canvas.
 * @module Typography
 * @submodule Font
 * @requires core
 * @requires constants
 */

'use strict';

var p5 = _dereq_('../core/core');
var constants = _dereq_('../core/constants');

/*
 * TODO:
 * -- kerning
 * -- alignment: justified?
 */

/**
 * Base class for font handling
 * @class p5.Font
 * @constructor
 * @param {p5} [pInst] pointer to p5 instance
 */
p5.Font = function(p) {
  this.parent = p;

  this.cache = {};

  /**
   * Underlying opentype font implementation
   * @property font
   */
  this.font = undefined;
  this.name = 'p5.Font'; // for friendly debugger system
};

p5.Font.prototype.list = function() {
  // TODO
  throw 'not yet implemented';
};

/**
 * Returns a tight bounding box for the given text string using this
 * font (currently only supports single lines)
 *
 * @method textBounds
 * @param  {String} line     a line of text
 * @param  {Number} x        x-position
 * @param  {Number} y        y-position
 * @param  {Number} [fontSize] font size to use (optional)
 * @param  {Object} [options] opentype options (optional)
 *
 * @return {Object}          a rectangle object with properties: x, y, w, h
 *
 * @example
 * <div>
 * <code>
 * var font;
 * var textString = 'Lorem ipsum dolor sit amet.';
 * function preload() {
 *   font = loadFont('./assets/Regular.otf');
 * }
 * function setup() {
 *   background(210);
 *
 *   var bbox = font.textBounds(textString, 10, 30, 12);
 *   fill(255);
 *   stroke(0);
 *   rect(bbox.x, bbox.y, bbox.w, bbox.h);
 *   fill(0);
 *   noStroke();
 *
 *   textFont(font);
 *   textSize(12);
 *   text(textString, 10, 30);
 * }
 * </code>
 * </div>
 *
 * @alt
 *words Lorem ipsum dol go off canvas and contained by white bounding box
 *
 */
p5.Font.prototype.textBounds = function(str, x, y, fontSize, options) {
  x = x !== undefined ? x : 0;
  y = y !== undefined ? y : 0;
  fontSize = fontSize || this.parent._renderer._textSize;

  // Check cache for existing bounds. Take into consideration the text alignment
  // settings. Default alignment should match opentype's origin: left-aligned &
  // alphabetic baseline.
  var p =
      (options && options.renderer && options.renderer._pInst) || this.parent,
    ctx = p._renderer.drawingContext,
    alignment = ctx.textAlign || constants.LEFT,
    baseline = ctx.textBaseline || constants.BASELINE,
    key = cacheKey('textBounds', str, x, y, fontSize, alignment, baseline),
    result = this.cache[key];

  if (!result) {
    var minX,
      minY,
      maxX,
      maxY,
      pos,
      xCoords = [],
      yCoords = [],
      scale = this._scale(fontSize);

    this.font.forEachGlyph(str, x, y, fontSize, options, function(
      glyph,
      gX,
      gY,
      gFontSize
    ) {
      var gm = glyph.getMetrics();
      xCoords.push(gX + gm.xMin * scale);
      xCoords.push(gX + gm.xMax * scale);
      yCoords.push(gY + -gm.yMin * scale);
      yCoords.push(gY + -gm.yMax * scale);
    });

    minX = Math.min.apply(null, xCoords);
    minY = Math.min.apply(null, yCoords);
    maxX = Math.max.apply(null, xCoords);
    maxY = Math.max.apply(null, yCoords);

    result = {
      x: minX,
      y: minY,
      h: maxY - minY,
      w: maxX - minX,
      advance: minX - x
    };

    // Bounds are now calculated, so shift the x & y to match alignment settings
    pos = this._handleAlignment(
      p,
      ctx,
      str,
      result.x,
      result.y,
      result.w + result.advance
    );

    result.x = pos.x;
    result.y = pos.y;

    this.cache[
      cacheKey('textBounds', str, x, y, fontSize, alignment, baseline)
    ] = result;
  }

  return result;
};

/**
 * Computes an array of points following the path for specified text
 *
 * @method textToPoints
 * @param  {String} txt     a line of text
 * @param  {Number} x        x-position
 * @param  {Number} y        y-position
 * @param  {Number} fontSize font size to use (optional)
 * @param  {Object} [options] an (optional) object that can contain:
 *
 * <br>sampleFactor - the ratio of path-length to number of samples
 * (default=.25); higher values yield more points and are therefore
 * more precise
 *
 * <br>simplifyThreshold - if set to a non-zero value, collinear points will be
 * be removed from the polygon; the value represents the threshold angle to use
 * when determining whether two edges are collinear
 *
 * @return {Array}  an array of points, each with x, y, alpha (the path angle)
 * @example
 * <div>
 * <code>
 * var font;
 * function preload() {
 *   font = loadFont('./assets/Avenir.otf');
 * }
 *
 * var points;
 * var bounds;
 * function setup() {
 *   createCanvas(100, 100);
 *   stroke(0);
 *   fill(255, 104, 204);
 *
 *   points = font.textToPoints('p5', 0, 0, 10, {
 *     sampleFactor: 5,
 *     simplifyThreshold: 0
 *   });
 *   bounds = font.textBounds(' p5 ', 0, 0, 10);
 * }
 *
 * function draw() {
 *   background(255);
 *   beginShape();
 *   translate(-bounds.x * width / bounds.w, -bounds.y * height / bounds.h);
 *   for (var i = 0; i < points.length; i++) {
 *     var p = points[i];
 *     vertex(
 *       p.x * width / bounds.w +
 *         sin(20 * p.y / bounds.h + millis() / 1000) * width / 30,
 *       p.y * height / bounds.h
 *     );
 *   }
 *   endShape(CLOSE);
 * }
 * </code>
 * </div>
 *
 */
p5.Font.prototype.textToPoints = function(txt, x, y, fontSize, options) {
  var xoff = 0,
    result = [],
    glyphs = this._getGlyphs(txt);

  function isSpace(i) {
    return (
      (glyphs[i].name && glyphs[i].name === 'space') ||
      (txt.length === glyphs.length && txt[i] === ' ') ||
      (glyphs[i].index && glyphs[i].index === 3)
    );
  }

  fontSize = fontSize || this.parent._renderer._textSize;

  for (var i = 0; i < glyphs.length; i++) {
    if (!isSpace(i)) {
      // fix to #1817, #2069

      var gpath = glyphs[i].getPath(x, y, fontSize),
        paths = splitPaths(gpath.commands);

      for (var j = 0; j < paths.length; j++) {
        var pts = pathToPoints(paths[j], options);

        for (var k = 0; k < pts.length; k++) {
          pts[k].x += xoff;
          result.push(pts[k]);
        }
      }
    }

    xoff += glyphs[i].advanceWidth * this._scale(fontSize);
  }

  return result;
};

// ----------------------------- End API ------------------------------

/**
 * Returns the set of opentype glyphs for the supplied string.
 *
 * Note that there is not a strict one-to-one mapping between characters
 * and glyphs, so the list of returned glyphs can be larger or smaller
 *  than the length of the given string.
 *
 * @private
 * @param  {String} str the string to be converted
 * @return {Array}     the opentype glyphs
 */
p5.Font.prototype._getGlyphs = function(str) {
  return this.font.stringToGlyphs(str);
};

/**
 * Returns an opentype path for the supplied string and position.
 *
 * @private
 * @param  {String} line     a line of text
 * @param  {Number} x        x-position
 * @param  {Number} y        y-position
 * @param  {Object} options opentype options (optional)
 * @return {Object}     the opentype path
 */
p5.Font.prototype._getPath = function(line, x, y, options) {
  var p =
      (options && options.renderer && options.renderer._pInst) || this.parent,
    ctx = p._renderer.drawingContext,
    pos = this._handleAlignment(p, ctx, line, x, y);

  return this.font.getPath(line, pos.x, pos.y, p._renderer._textSize, options);
};

/*
 * Creates an SVG-formatted path-data string
 * (See http://www.w3.org/TR/SVG/paths.html#PathData)
 * from the given opentype path or string/position
 *
 * @param  {Object} path    an opentype path, OR the following:
 *
 * @param  {String} line     a line of text
 * @param  {Number} x        x-position
 * @param  {Number} y        y-position
 * @param  {Object} options opentype options (optional), set options.decimals
 * to set the decimal precision of the path-data
 *
 * @return {Object}     this p5.Font object
 */
p5.Font.prototype._getPathData = function(line, x, y, options) {
  var decimals = 3;

  // create path from string/position
  if (typeof line === 'string' && arguments.length > 2) {
    line = this._getPath(line, x, y, options);
  } else if (typeof x === 'object') {
    // handle options specified in 2nd arg
    options = x;
  }

  // handle svg arguments
  if (options && typeof options.decimals === 'number') {
    decimals = options.decimals;
  }

  return line.toPathData(decimals);
};

/*
 * Creates an SVG <path> element, as a string,
 * from the given opentype path or string/position
 *
 * @param  {Object} path    an opentype path, OR the following:
 *
 * @param  {String} line     a line of text
 * @param  {Number} x        x-position
 * @param  {Number} y        y-position
 * @param  {Object} options opentype options (optional), set options.decimals
 * to set the decimal precision of the path-data in the <path> element,
 *  options.fill to set the fill color for the <path> element,
 *  options.stroke to set the stroke color for the <path> element,
 *  options.strokeWidth to set the strokeWidth for the <path> element.
 *
 * @return {Object}     this p5.Font object
 */
p5.Font.prototype._getSVG = function(line, x, y, options) {
  var decimals = 3;

  // create path from string/position
  if (typeof line === 'string' && arguments.length > 2) {
    line = this._getPath(line, x, y, options);
  } else if (typeof x === 'object') {
    // handle options specified in 2nd arg
    options = x;
  }

  // handle svg arguments
  if (options) {
    if (typeof options.decimals === 'number') {
      decimals = options.decimals;
    }
    if (typeof options.strokeWidth === 'number') {
      line.strokeWidth = options.strokeWidth;
    }
    if (typeof options.fill !== 'undefined') {
      line.fill = options.fill;
    }
    if (typeof options.stroke !== 'undefined') {
      line.stroke = options.stroke;
    }
  }

  return line.toSVG(decimals);
};

/*
 * Renders an opentype path or string/position
 * to the current graphics context
 *
 * @param  {Object} path    an opentype path, OR the following:
 *
 * @param  {String} line     a line of text
 * @param  {Number} x        x-position
 * @param  {Number} y        y-position
 * @param  {Object} options opentype options (optional)
 *
 * @return {p5.Font}     this p5.Font object
 */
p5.Font.prototype._renderPath = function(line, x, y, options) {
  var pdata,
    pg = (options && options.renderer) || this.parent._renderer,
    ctx = pg.drawingContext;

  if (typeof line === 'object' && line.commands) {
    pdata = line.commands;
  } else {
    //pos = handleAlignment(p, ctx, line, x, y);
    pdata = this._getPath(line, x, y, options).commands;
  }

  ctx.beginPath();
  for (var i = 0; i < pdata.length; i += 1) {
    var cmd = pdata[i];
    if (cmd.type === 'M') {
      ctx.moveTo(cmd.x, cmd.y);
    } else if (cmd.type === 'L') {
      ctx.lineTo(cmd.x, cmd.y);
    } else if (cmd.type === 'C') {
      ctx.bezierCurveTo(cmd.x1, cmd.y1, cmd.x2, cmd.y2, cmd.x, cmd.y);
    } else if (cmd.type === 'Q') {
      ctx.quadraticCurveTo(cmd.x1, cmd.y1, cmd.x, cmd.y);
    } else if (cmd.type === 'Z') {
      ctx.closePath();
    }
  }

  // only draw stroke if manually set by user
  if (pg._doStroke && pg._strokeSet) {
    ctx.stroke();
  }

  if (pg._doFill) {
    // if fill hasn't been set by user, use default-text-fill
    if (!pg._fillSet) {
      pg._setFill(constants._DEFAULT_TEXT_FILL);
    }
    ctx.fill();
  }

  return this;
};

p5.Font.prototype._textWidth = function(str, fontSize) {
  return this.font.getAdvanceWidth(str, fontSize);
};

p5.Font.prototype._textAscent = function(fontSize) {
  return this.font.ascender * this._scale(fontSize);
};

p5.Font.prototype._textDescent = function(fontSize) {
  return -this.font.descender * this._scale(fontSize);
};

p5.Font.prototype._scale = function(fontSize) {
  return (
    1 / this.font.unitsPerEm * (fontSize || this.parent._renderer._textSize)
  );
};

p5.Font.prototype._handleAlignment = function(p, ctx, line, x, y, textWidth) {
  var fontSize = p._renderer._textSize,
    textAscent = this._textAscent(fontSize),
    textDescent = this._textDescent(fontSize);

  textWidth =
    textWidth !== undefined ? textWidth : this._textWidth(line, fontSize);

  if (ctx.textAlign === constants.CENTER) {
    x -= textWidth / 2;
  } else if (ctx.textAlign === constants.RIGHT) {
    x -= textWidth;
  }

  if (ctx.textBaseline === constants.TOP) {
    y += textAscent;
  } else if (ctx.textBaseline === constants._CTX_MIDDLE) {
    y += textAscent / 2;
  } else if (ctx.textBaseline === constants.BOTTOM) {
    y -= textDescent;
  }

  return { x: x, y: y };
};

// path-utils

function pathToPoints(cmds, options) {
  var opts = parseOpts(options, {
    sampleFactor: 0.1,
    simplifyThreshold: 0
  });

  var len = pointAtLength(cmds, 0, 1), // total-length
    t = len / (len * opts.sampleFactor),
    pts = [];

  for (var i = 0; i < len; i += t) {
    pts.push(pointAtLength(cmds, i));
  }

  if (opts.simplifyThreshold) {
    /*var count = */ simplify(pts, opts.simplifyThreshold);
    //console.log('Simplify: removed ' + count + ' pts');
  }

  return pts;
}

function simplify(pts, angle) {
  angle = typeof angle === 'undefined' ? 0 : angle;

  var num = 0;
  for (var i = pts.length - 1; pts.length > 3 && i >= 0; --i) {
    if (collinear(at(pts, i - 1), at(pts, i), at(pts, i + 1), angle)) {
      // Remove the middle point
      pts.splice(i % pts.length, 1);
      num++;
    }
  }
  return num;
}

function splitPaths(cmds) {
  var paths = [],
    current;
  for (var i = 0; i < cmds.length; i++) {
    if (cmds[i].type === 'M') {
      if (current) {
        paths.push(current);
      }
      current = [];
    }
    current.push(cmdToArr(cmds[i]));
  }
  paths.push(current);

  return paths;
}

function cmdToArr(cmd) {
  var arr = [cmd.type];
  if (cmd.type === 'M' || cmd.type === 'L') {
    // moveto or lineto
    arr.push(cmd.x, cmd.y);
  } else if (cmd.type === 'C') {
    arr.push(cmd.x1, cmd.y1, cmd.x2, cmd.y2, cmd.x, cmd.y);
  } else if (cmd.type === 'Q') {
    arr.push(cmd.x1, cmd.y1, cmd.x, cmd.y);
  }
  // else if (cmd.type === 'Z') { /* no-op */ }
  return arr;
}

function parseOpts(options, defaults) {
  if (typeof options !== 'object') {
    options = defaults;
  } else {
    for (var key in defaults) {
      if (typeof options[key] === 'undefined') {
        options[key] = defaults[key];
      }
    }
  }
  return options;
}

//////////////////////// Helpers ////////////////////////////

function at(v, i) {
  var s = v.length;
  return v[i < 0 ? i % s + s : i % s];
}

function collinear(a, b, c, thresholdAngle) {
  if (!thresholdAngle) {
    return areaTriangle(a, b, c) === 0;
  }

  if (typeof collinear.tmpPoint1 === 'undefined') {
    collinear.tmpPoint1 = [];
    collinear.tmpPoint2 = [];
  }

  var ab = collinear.tmpPoint1,
    bc = collinear.tmpPoint2;
  ab.x = b.x - a.x;
  ab.y = b.y - a.y;
  bc.x = c.x - b.x;
  bc.y = c.y - b.y;

  var dot = ab.x * bc.x + ab.y * bc.y,
    magA = Math.sqrt(ab.x * ab.x + ab.y * ab.y),
    magB = Math.sqrt(bc.x * bc.x + bc.y * bc.y),
    angle = Math.acos(dot / (magA * magB));

  return angle < thresholdAngle;
}

function areaTriangle(a, b, c) {
  return (b[0] - a[0]) * (c[1] - a[1]) - (c[0] - a[0]) * (b[1] - a[1]);
}

// Portions of below code copyright 2008 Dmitry Baranovskiy (via MIT license)

function findDotsAtSegment(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, t) {
  var t1 = 1 - t,
    t13 = Math.pow(t1, 3),
    t12 = Math.pow(t1, 2),
    t2 = t * t,
    t3 = t2 * t,
    x = t13 * p1x + t12 * 3 * t * c1x + t1 * 3 * t * t * c2x + t3 * p2x,
    y = t13 * p1y + t12 * 3 * t * c1y + t1 * 3 * t * t * c2y + t3 * p2y,
    mx = p1x + 2 * t * (c1x - p1x) + t2 * (c2x - 2 * c1x + p1x),
    my = p1y + 2 * t * (c1y - p1y) + t2 * (c2y - 2 * c1y + p1y),
    nx = c1x + 2 * t * (c2x - c1x) + t2 * (p2x - 2 * c2x + c1x),
    ny = c1y + 2 * t * (c2y - c1y) + t2 * (p2y - 2 * c2y + c1y),
    ax = t1 * p1x + t * c1x,
    ay = t1 * p1y + t * c1y,
    cx = t1 * c2x + t * p2x,
    cy = t1 * c2y + t * p2y,
    alpha = 90 - Math.atan2(mx - nx, my - ny) * 180 / Math.PI;

  if (mx > nx || my < ny) {
    alpha += 180;
  }

  return {
    x: x,
    y: y,
    m: { x: mx, y: my },
    n: { x: nx, y: ny },
    start: { x: ax, y: ay },
    end: { x: cx, y: cy },
    alpha: alpha
  };
}

function getPointAtSegmentLength(
  p1x,
  p1y,
  c1x,
  c1y,
  c2x,
  c2y,
  p2x,
  p2y,
  length
) {
  return length == null
    ? bezlen(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y)
    : findDotsAtSegment(
        p1x,
        p1y,
        c1x,
        c1y,
        c2x,
        c2y,
        p2x,
        p2y,
        getTatLen(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, length)
      );
}

function pointAtLength(path, length, istotal) {
  path = path2curve(path);
  var x,
    y,
    p,
    l,
    sp = '',
    subpaths = {},
    point,
    len = 0;
  for (var i = 0, ii = path.length; i < ii; i++) {
    p = path[i];
    if (p[0] === 'M') {
      x = +p[1];
      y = +p[2];
    } else {
      l = getPointAtSegmentLength(x, y, p[1], p[2], p[3], p[4], p[5], p[6]);
      if (len + l > length) {
        if (!istotal) {
          point = getPointAtSegmentLength(
            x,
            y,
            p[1],
            p[2],
            p[3],
            p[4],
            p[5],
            p[6],
            length - len
          );
          return { x: point.x, y: point.y, alpha: point.alpha };
        }
      }
      len += l;
      x = +p[5];
      y = +p[6];
    }
    sp += p.shift() + p;
  }
  subpaths.end = sp;

  point = istotal
    ? len
    : findDotsAtSegment(x, y, p[0], p[1], p[2], p[3], p[4], p[5], 1);

  if (point.alpha) {
    point = { x: point.x, y: point.y, alpha: point.alpha };
  }

  return point;
}

function pathToAbsolute(pathArray) {
  var res = [],
    x = 0,
    y = 0,
    mx = 0,
    my = 0,
    start = 0;
  if (!pathArray) {
    // console.warn("Unexpected state: undefined pathArray"); // shouldn't happen
    return res;
  }
  if (pathArray[0][0] === 'M') {
    x = +pathArray[0][1];
    y = +pathArray[0][2];
    mx = x;
    my = y;
    start++;
    res[0] = ['M', x, y];
  }

  var dots,
    crz =
      pathArray.length === 3 &&
      pathArray[0][0] === 'M' &&
      pathArray[1][0].toUpperCase() === 'R' &&
      pathArray[2][0].toUpperCase() === 'Z';

  for (var r, pa, i = start, ii = pathArray.length; i < ii; i++) {
    res.push((r = []));
    pa = pathArray[i];
    if (pa[0] !== String.prototype.toUpperCase.call(pa[0])) {
      r[0] = String.prototype.toUpperCase.call(pa[0]);
      switch (r[0]) {
        case 'A':
          r[1] = pa[1];
          r[2] = pa[2];
          r[3] = pa[3];
          r[4] = pa[4];
          r[5] = pa[5];
          r[6] = +(pa[6] + x);
          r[7] = +(pa[7] + y);
          break;
        case 'V':
          r[1] = +pa[1] + y;
          break;
        case 'H':
          r[1] = +pa[1] + x;
          break;
        case 'R':
          dots = [x, y].concat(pa.slice(1));
          for (var j = 2, jj = dots.length; j < jj; j++) {
            dots[j] = +dots[j] + x;
            dots[++j] = +dots[j] + y;
          }
          res.pop();
          res = res.concat(catmullRom2bezier(dots, crz));
          break;
        case 'M':
          mx = +pa[1] + x;
          my = +pa[2] + y;
          break;
        default:
          for (j = 1, jj = pa.length; j < jj; j++) {
            r[j] = +pa[j] + (j % 2 ? x : y);
          }
      }
    } else if (pa[0] === 'R') {
      dots = [x, y].concat(pa.slice(1));
      res.pop();
      res = res.concat(catmullRom2bezier(dots, crz));
      r = ['R'].concat(pa.slice(-2));
    } else {
      for (var k = 0, kk = pa.length; k < kk; k++) {
        r[k] = pa[k];
      }
    }
    switch (r[0]) {
      case 'Z':
        x = mx;
        y = my;
        break;
      case 'H':
        x = r[1];
        break;
      case 'V':
        y = r[1];
        break;
      case 'M':
        mx = r[r.length - 2];
        my = r[r.length - 1];
        break;
      default:
        x = r[r.length - 2];
        y = r[r.length - 1];
    }
  }
  return res;
}

function path2curve(path, path2) {
  var p = pathToAbsolute(path),
    p2 = path2 && pathToAbsolute(path2);
  var attrs = { x: 0, y: 0, bx: 0, by: 0, X: 0, Y: 0, qx: null, qy: null };
  var attrs2 = { x: 0, y: 0, bx: 0, by: 0, X: 0, Y: 0, qx: null, qy: null };
  var pcoms1 = []; // path commands of original path p
  var pcoms2 = []; // path commands of original path p2
  var ii;

  var processPath = function(path, d, pcom) {
      var nx,
        ny,
        tq = { T: 1, Q: 1 };
      if (!path) {
        return ['C', d.x, d.y, d.x, d.y, d.x, d.y];
      }
      if (!(path[0] in tq)) {
        d.qx = d.qy = null;
      }
      switch (path[0]) {
        case 'M':
          d.X = path[1];
          d.Y = path[2];
          break;
        case 'A':
          path = ['C'].concat(a2c.apply(0, [d.x, d.y].concat(path.slice(1))));
          break;
        case 'S':
          if (pcom === 'C' || pcom === 'S') {
            nx = d.x * 2 - d.bx;
            ny = d.y * 2 - d.by;
          } else {
            nx = d.x;
            ny = d.y;
          }
          path = ['C', nx, ny].concat(path.slice(1));
          break;
        case 'T':
          if (pcom === 'Q' || pcom === 'T') {
            d.qx = d.x * 2 - d.qx;
            d.qy = d.y * 2 - d.qy;
          } else {
            d.qx = d.x;
            d.qy = d.y;
          }
          path = ['C'].concat(q2c(d.x, d.y, d.qx, d.qy, path[1], path[2]));
          break;
        case 'Q':
          d.qx = path[1];
          d.qy = path[2];
          path = ['C'].concat(
            q2c(d.x, d.y, path[1], path[2], path[3], path[4])
          );
          break;
        case 'L':
          path = ['C'].concat(l2c(d.x, d.y, path[1], path[2]));
          break;
        case 'H':
          path = ['C'].concat(l2c(d.x, d.y, path[1], d.y));
          break;
        case 'V':
          path = ['C'].concat(l2c(d.x, d.y, d.x, path[1]));
          break;
        case 'Z':
          path = ['C'].concat(l2c(d.x, d.y, d.X, d.Y));
          break;
      }
      return path;
    },
    fixArc = function(pp, i) {
      if (pp[i].length > 7) {
        pp[i].shift();
        var pi = pp[i];
        while (pi.length) {
          pcoms1[i] = 'A';
          if (p2) {
            pcoms2[i] = 'A';
          }
          pp.splice(i++, 0, ['C'].concat(pi.splice(0, 6)));
        }
        pp.splice(i, 1);
        ii = Math.max(p.length, (p2 && p2.length) || 0);
      }
    },
    fixM = function(path1, path2, a1, a2, i) {
      if (path1 && path2 && path1[i][0] === 'M' && path2[i][0] !== 'M') {
        path2.splice(i, 0, ['M', a2.x, a2.y]);
        a1.bx = 0;
        a1.by = 0;
        a1.x = path1[i][1];
        a1.y = path1[i][2];
        ii = Math.max(p.length, (p2 && p2.length) || 0);
      }
    };

  var pfirst = ''; // temporary holder for original path command
  var pcom = ''; // holder for previous path command of original path

  ii = Math.max(p.length, (p2 && p2.length) || 0);
  for (var i = 0; i < ii; i++) {
    if (p[i]) {
      pfirst = p[i][0];
    } // save current path command

    if (pfirst !== 'C') {
      pcoms1[i] = pfirst; // Save current path command
      if (i) {
        pcom = pcoms1[i - 1];
      } // Get previous path command pcom
    }
    p[i] = processPath(p[i], attrs, pcom);

    if (pcoms1[i] !== 'A' && pfirst === 'C') {
      pcoms1[i] = 'C';
    }

    fixArc(p, i); // fixArc adds also the right amount of A:s to pcoms1

    if (p2) {
      // the same procedures is done to p2
      if (p2[i]) {
        pfirst = p2[i][0];
      }
      if (pfirst !== 'C') {
        pcoms2[i] = pfirst;
        if (i) {
          pcom = pcoms2[i - 1];
        }
      }
      p2[i] = processPath(p2[i], attrs2, pcom);

      if (pcoms2[i] !== 'A' && pfirst === 'C') {
        pcoms2[i] = 'C';
      }

      fixArc(p2, i);
    }
    fixM(p, p2, attrs, attrs2, i);
    fixM(p2, p, attrs2, attrs, i);
    var seg = p[i],
      seg2 = p2 && p2[i],
      seglen = seg.length,
      seg2len = p2 && seg2.length;
    attrs.x = seg[seglen - 2];
    attrs.y = seg[seglen - 1];
    attrs.bx = parseFloat(seg[seglen - 4]) || attrs.x;
    attrs.by = parseFloat(seg[seglen - 3]) || attrs.y;
    attrs2.bx = p2 && (parseFloat(seg2[seg2len - 4]) || attrs2.x);
    attrs2.by = p2 && (parseFloat(seg2[seg2len - 3]) || attrs2.y);
    attrs2.x = p2 && seg2[seg2len - 2];
    attrs2.y = p2 && seg2[seg2len - 1];
  }

  return p2 ? [p, p2] : p;
}

function a2c(x1, y1, rx, ry, angle, lac, sweep_flag, x2, y2, recursive) {
  // for more information of where this Math came from visit:
  // http://www.w3.org/TR/SVG11/implnote.html#ArcImplementationNotes
  var PI = Math.PI,
    _120 = PI * 120 / 180,
    f1,
    f2,
    cx,
    cy,
    rad = PI / 180 * (+angle || 0),
    res = [],
    xy,
    rotate = function(x, y, rad) {
      var X = x * Math.cos(rad) - y * Math.sin(rad),
        Y = x * Math.sin(rad) + y * Math.cos(rad);
      return { x: X, y: Y };
    };
  if (!recursive) {
    xy = rotate(x1, y1, -rad);
    x1 = xy.x;
    y1 = xy.y;
    xy = rotate(x2, y2, -rad);
    x2 = xy.x;
    y2 = xy.y;
    var x = (x1 - x2) / 2,
      y = (y1 - y2) / 2,
      h = x * x / (rx * rx) + y * y / (ry * ry);
    if (h > 1) {
      h = Math.sqrt(h);
      rx = h * rx;
      ry = h * ry;
    }
    var rx2 = rx * rx,
      ry2 = ry * ry;
    var k =
      (lac === sweep_flag ? -1 : 1) *
      Math.sqrt(
        Math.abs(
          (rx2 * ry2 - rx2 * y * y - ry2 * x * x) / (rx2 * y * y + ry2 * x * x)
        )
      );

    cx = k * rx * y / ry + (x1 + x2) / 2;
    cy = k * -ry * x / rx + (y1 + y2) / 2;
    f1 = Math.asin(((y1 - cy) / ry).toFixed(9));
    f2 = Math.asin(((y2 - cy) / ry).toFixed(9));

    f1 = x1 < cx ? PI - f1 : f1;
    f2 = x2 < cx ? PI - f2 : f2;

    if (f1 < 0) {
      f1 = PI * 2 + f1;
    }
    if (f2 < 0) {
      f2 = PI * 2 + f2;
    }

    if (sweep_flag && f1 > f2) {
      f1 = f1 - PI * 2;
    }
    if (!sweep_flag && f2 > f1) {
      f2 = f2 - PI * 2;
    }
  } else {
    f1 = recursive[0];
    f2 = recursive[1];
    cx = recursive[2];
    cy = recursive[3];
  }
  var df = f2 - f1;
  if (Math.abs(df) > _120) {
    var f2old = f2,
      x2old = x2,
      y2old = y2;
    f2 = f1 + _120 * (sweep_flag && f2 > f1 ? 1 : -1);
    x2 = cx + rx * Math.cos(f2);
    y2 = cy + ry * Math.sin(f2);
    res = a2c(x2, y2, rx, ry, angle, 0, sweep_flag, x2old, y2old, [
      f2,
      f2old,
      cx,
      cy
    ]);
  }
  df = f2 - f1;
  var c1 = Math.cos(f1),
    s1 = Math.sin(f1),
    c2 = Math.cos(f2),
    s2 = Math.sin(f2),
    t = Math.tan(df / 4),
    hx = 4 / 3 * rx * t,
    hy = 4 / 3 * ry * t,
    m1 = [x1, y1],
    m2 = [x1 + hx * s1, y1 - hy * c1],
    m3 = [x2 + hx * s2, y2 - hy * c2],
    m4 = [x2, y2];
  m2[0] = 2 * m1[0] - m2[0];
  m2[1] = 2 * m1[1] - m2[1];
  if (recursive) {
    return [m2, m3, m4].concat(res);
  } else {
    res = [m2, m3, m4]
      .concat(res)
      .join()
      .split(',');
    var newres = [];
    for (var i = 0, ii = res.length; i < ii; i++) {
      newres[i] =
        i % 2
          ? rotate(res[i - 1], res[i], rad).y
          : rotate(res[i], res[i + 1], rad).x;
    }
    return newres;
  }
}

// http://schepers.cc/getting-to-the-point
function catmullRom2bezier(crp, z) {
  var d = [];
  for (var i = 0, iLen = crp.length; iLen - 2 * !z > i; i += 2) {
    var p = [
      {
        x: +crp[i - 2],
        y: +crp[i - 1]
      },
      {
        x: +crp[i],
        y: +crp[i + 1]
      },
      {
        x: +crp[i + 2],
        y: +crp[i + 3]
      },
      {
        x: +crp[i + 4],
        y: +crp[i + 5]
      }
    ];
    if (z) {
      if (!i) {
        p[0] = {
          x: +crp[iLen - 2],
          y: +crp[iLen - 1]
        };
      } else if (iLen - 4 === i) {
        p[3] = {
          x: +crp[0],
          y: +crp[1]
        };
      } else if (iLen - 2 === i) {
        p[2] = {
          x: +crp[0],
          y: +crp[1]
        };
        p[3] = {
          x: +crp[2],
          y: +crp[3]
        };
      }
    } else {
      if (iLen - 4 === i) {
        p[3] = p[2];
      } else if (!i) {
        p[0] = {
          x: +crp[i],
          y: +crp[i + 1]
        };
      }
    }
    d.push([
      'C',
      (-p[0].x + 6 * p[1].x + p[2].x) / 6,
      (-p[0].y + 6 * p[1].y + p[2].y) / 6,
      (p[1].x + 6 * p[2].x - p[3].x) / 6,
      (p[1].y + 6 * p[2].y - p[3].y) / 6,
      p[2].x,
      p[2].y
    ]);
  }

  return d;
}

function l2c(x1, y1, x2, y2) {
  return [x1, y1, x2, y2, x2, y2];
}

function q2c(x1, y1, ax, ay, x2, y2) {
  var _13 = 1 / 3,
    _23 = 2 / 3;
  return [
    _13 * x1 + _23 * ax,
    _13 * y1 + _23 * ay,
    _13 * x2 + _23 * ax,
    _13 * y2 + _23 * ay,
    x2,
    y2
  ];
}

function bezlen(x1, y1, x2, y2, x3, y3, x4, y4, z) {
  if (z == null) {
    z = 1;
  }
  z = z > 1 ? 1 : z < 0 ? 0 : z;
  var z2 = z / 2;
  var n = 12;
  var Tvalues = [
    -0.1252,
    0.1252,
    -0.3678,
    0.3678,
    -0.5873,
    0.5873,
    -0.7699,
    0.7699,
    -0.9041,
    0.9041,
    -0.9816,
    0.9816
  ];

  var sum = 0;
  var Cvalues = [
    0.2491,
    0.2491,
    0.2335,
    0.2335,
    0.2032,
    0.2032,
    0.1601,
    0.1601,
    0.1069,
    0.1069,
    0.0472,
    0.0472
  ];

  for (var i = 0; i < n; i++) {
    var ct = z2 * Tvalues[i] + z2,
      xbase = base3(ct, x1, x2, x3, x4),
      ybase = base3(ct, y1, y2, y3, y4),
      comb = xbase * xbase + ybase * ybase;
    sum += Cvalues[i] * Math.sqrt(comb);
  }
  return z2 * sum;
}

function getTatLen(x1, y1, x2, y2, x3, y3, x4, y4, ll) {
  if (ll < 0 || bezlen(x1, y1, x2, y2, x3, y3, x4, y4) < ll) {
    return;
  }
  var t = 1,
    step = t / 2,
    t2 = t - step,
    l,
    e = 0.01;
  l = bezlen(x1, y1, x2, y2, x3, y3, x4, y4, t2);
  while (Math.abs(l - ll) > e) {
    step /= 2;
    t2 += (l < ll ? 1 : -1) * step;
    l = bezlen(x1, y1, x2, y2, x3, y3, x4, y4, t2);
  }
  return t2;
}

function base3(t, p1, p2, p3, p4) {
  var t1 = -3 * p1 + 9 * p2 - 9 * p3 + 3 * p4,
    t2 = t * t1 + 6 * p1 - 12 * p2 + 6 * p3;
  return t * t2 - 3 * p1 + 3 * p2;
}

function cacheKey() {
  var hash = '';
  for (var i = arguments.length - 1; i >= 0; --i) {
    var v = arguments[i];
    hash += v === Object(v) ? JSON.stringify(v) : v;
  }
  return hash;
}

module.exports = p5;

},{"../core/constants":21,"../core/core":22}],60:[function(_dereq_,module,exports){
/**
 * @module Data
 * @submodule Array Functions
 * @for p5
 * @requires core
 */

'use strict';

var p5 = _dereq_('../core/core');

/**
 * Adds a value to the end of an array. Extends the length of
 * the array by one. Maps to Array.push().
 *
 * @method append
 * @param {Array} array Array to append
 * @param {any} value to be added to the Array
 * @example
 * <div class='norender'><code>
 * function setup() {
 *   var myArray = ['Mango', 'Apple', 'Papaya'];
 *   print(myArray); // ['Mango', 'Apple', 'Papaya']
 *
 *   append(myArray, 'Peach');
 *   print(myArray); // ['Mango', 'Apple', 'Papaya', 'Peach']
 * }
 * </code></div>
 */
p5.prototype.append = function(array, value) {
  array.push(value);
  return array;
};

/**
 * Copies an array (or part of an array) to another array. The src array is
 * copied to the dst array, beginning at the position specified by
 * srcPosition and into the position specified by dstPosition. The number of
 * elements to copy is determined by length. Note that copying values
 * overwrites existing values in the destination array. To append values
 * instead of overwriting them, use concat().
 * <br><br>
 * The simplified version with only two arguments, arrayCopy(src, dst),
 * copies an entire array to another of the same size. It is equivalent to
 * arrayCopy(src, 0, dst, 0, src.length).
 * <br><br>
 * Using this function is far more efficient for copying array data than
 * iterating through a for() loop and copying each element individually.
 *
 * @method arrayCopy
 * @param {Array}  src           the source Array
 * @param {Integer} srcPosition  starting position in the source Array
 * @param {Array}  dst           the destination Array
 * @param {Integer} dstPosition   starting position in the destination Array
 * @param {Integer} length        number of Array elements to be copied
 *
 * @example
 * <div class='norender'><code>
 * var src = ['A', 'B', 'C'];
 * var dst = [1, 2, 3];
 * var srcPosition = 1;
 * var dstPosition = 0;
 * var length = 2;
 *
 * print(src); // ['A', 'B', 'C']
 * print(dst); // [ 1 ,  2 ,  3 ]
 *
 * arrayCopy(src, srcPosition, dst, dstPosition, length);
 * print(dst); // ['B', 'C', 3]
 * </code></div>
 */
/**
 * @method arrayCopy
 * @param {Array}  src
 * @param {Array}  dst
 * @param {Integer} [length]
 */
p5.prototype.arrayCopy = function(src, srcPosition, dst, dstPosition, length) {
  // the index to begin splicing from dst array
  var start;
  var end;

  if (typeof length !== 'undefined') {
    end = Math.min(length, src.length);
    start = dstPosition;
    src = src.slice(srcPosition, end + srcPosition);
  } else {
    if (typeof dst !== 'undefined') {
      // src, dst, length
      // rename  so we don't get confused
      end = dst;
      end = Math.min(end, src.length);
    } else {
      // src, dst
      end = src.length;
    }

    start = 0;
    // rename  so we don't get confused
    dst = srcPosition;
    src = src.slice(0, end);
  }

  // Since we are not returning the array and JavaScript is pass by reference
  // we must modify the actual values of the array
  // instead of reassigning arrays
  Array.prototype.splice.apply(dst, [start, end].concat(src));
};

/**
 * Concatenates two arrays, maps to Array.concat(). Does not modify the
 * input arrays.
 *
 * @method concat
 * @param {Array} a first Array to concatenate
 * @param {Array} b second Array to concatenate
 * @return {Array} concatenated array
 *
 * @example
 * <div class = 'norender'><code>
 * function setup() {
 *   var arr1 = ['A', 'B', 'C'];
 *   var arr2 = [1, 2, 3];
 *
 *   print(arr1); // ['A','B','C']
 *   print(arr2); // [1,2,3]
 *
 *   var arr3 = concat(arr1, arr2);
 *
 *   print(arr1); // ['A','B','C']
 *   print(arr2); // [1, 2, 3]
 *   print(arr3); // ['A','B','C', 1, 2, 3]
 * }
 * </code></div>
 */
p5.prototype.concat = function(list0, list1) {
  return list0.concat(list1);
};

/**
 * Reverses the order of an array, maps to Array.reverse()
 *
 * @method reverse
 * @param {Array} list Array to reverse
 * @example
 * <div class='norender'><code>
 * function setup() {
 *   var myArray = ['A', 'B', 'C'];
 *   print(myArray); // ['A','B','C']
 *
 *   reverse(myArray);
 *   print(myArray); // ['C','B','A']
 * }
 * </code></div>
 */
p5.prototype.reverse = function(list) {
  return list.reverse();
};

/**
 * Decreases an array by one element and returns the shortened array,
 * maps to Array.pop().
 *
 * @method shorten
 * @param  {Array} list Array to shorten
 * @return {Array} shortened Array
 * @example
 * <div class = 'norender'><code>
 * function setup() {
 *   var myArray = ['A', 'B', 'C'];
 *   print(myArray); // ['A', 'B', 'C']
 *   var newArray = shorten(myArray);
 *   print(myArray); // ['A','B','C']
 *   print(newArray); // ['A','B']
 * }
 * </code></div>
 */
p5.prototype.shorten = function(list) {
  list.pop();
  return list;
};

/**
 * Randomizes the order of the elements of an array. Implements
 * <a href='http://Bost.Ocks.org/mike/shuffle/' target=_blank>
 * Fisher-Yates Shuffle Algorithm</a>.
 *
 * @method shuffle
 * @param  {Array}   array  Array to shuffle
 * @param  {Boolean} [bool] modify passed array
 * @return {Array}   shuffled Array
 * @example
 * <div><code>
 * function setup() {
 *   var regularArr = ['ABC', 'def', createVector(), TAU, Math.E];
 *   print(regularArr);
 *   shuffle(regularArr, true); // force modifications to passed array
 *   print(regularArr);
 *
 *   // By default shuffle() returns a shuffled cloned array:
 *   var newArr = shuffle(regularArr);
 *   print(regularArr);
 *   print(newArr);
 * }
 * </code></div>
 */
p5.prototype.shuffle = function(arr, bool) {
  var isView = ArrayBuffer && ArrayBuffer.isView && ArrayBuffer.isView(arr);
  arr = bool || isView ? arr : arr.slice();

  var rnd,
    tmp,
    idx = arr.length;
  while (idx > 1) {
    rnd = (Math.random() * idx) | 0;

    tmp = arr[--idx];
    arr[idx] = arr[rnd];
    arr[rnd] = tmp;
  }

  return arr;
};

/**
 * Sorts an array of numbers from smallest to largest, or puts an array of
 * words in alphabetical order. The original array is not modified; a
 * re-ordered array is returned. The count parameter states the number of
 * elements to sort. For example, if there are 12 elements in an array and
 * count is set to 5, only the first 5 elements in the array will be sorted.
 *
 * @method sort
 * @param {Array} list Array to sort
 * @param {Integer} [count] number of elements to sort, starting from 0
 *
 * @example
 * <div class = 'norender'><code>
 * function setup() {
 *   var words = ['banana', 'apple', 'pear', 'lime'];
 *   print(words); // ['banana', 'apple', 'pear', 'lime']
 *   var count = 4; // length of array
 *
 *   words = sort(words, count);
 *   print(words); // ['apple', 'banana', 'lime', 'pear']
 * }
 * </code></div>
 * <div class = 'norender'><code>
 * function setup() {
 *   var numbers = [2, 6, 1, 5, 14, 9, 8, 12];
 *   print(numbers); // [2, 6, 1, 5, 14, 9, 8, 12]
 *   var count = 5; // Less than the length of the array
 *
 *   numbers = sort(numbers, count);
 *   print(numbers); // [1,2,5,6,14,9,8,12]
 * }
 * </code></div>
 */
p5.prototype.sort = function(list, count) {
  var arr = count ? list.slice(0, Math.min(count, list.length)) : list;
  var rest = count ? list.slice(Math.min(count, list.length)) : [];
  if (typeof arr[0] === 'string') {
    arr = arr.sort();
  } else {
    arr = arr.sort(function(a, b) {
      return a - b;
    });
  }
  return arr.concat(rest);
};

/**
 * Inserts a value or an array of values into an existing array. The first
 * parameter specifies the initial array to be modified, and the second
 * parameter defines the data to be inserted. The third parameter is an index
 * value which specifies the array position from which to insert data.
 * (Remember that array index numbering starts at zero, so the first position
 * is 0, the second position is 1, and so on.)
 *
 * @method splice
 * @param {Array}  list Array to splice into
 * @param {any}    value value to be spliced in
 * @param {Integer} position in the array from which to insert data
 *
 * @example
 * <div class = 'norender'><code>
 * function setup() {
 *   var myArray = [0, 1, 2, 3, 4];
 *   var insArray = ['A', 'B', 'C'];
 *   print(myArray); // [0, 1, 2, 3, 4]
 *   print(insArray); // ['A','B','C']
 *
 *   splice(myArray, insArray, 3);
 *   print(myArray); // [0,1,2,'A','B','C',3,4]
 * }
 * </code></div>
 */
p5.prototype.splice = function(list, value, index) {
  // note that splice returns spliced elements and not an array
  Array.prototype.splice.apply(list, [index, 0].concat(value));

  return list;
};

/**
 * Extracts an array of elements from an existing array. The list parameter
 * defines the array from which the elements will be copied, and the start
 * and count parameters specify which elements to extract. If no count is
 * given, elements will be extracted from the start to the end of the array.
 * When specifying the start, remember that the first array element is 0.
 * This function does not change the source array.
 *
 * @method subset
 * @param  {Array}  list    Array to extract from
 * @param  {Integer} start   position to begin
 * @param  {Integer} [count] number of values to extract
 * @return {Array}          Array of extracted elements
 *
 * @example
 * <div class = 'norender'><code>
 * function setup() {
 *   var myArray = [1, 2, 3, 4, 5];
 *   print(myArray); // [1, 2, 3, 4, 5]
 *
 *   var sub1 = subset(myArray, 0, 3);
 *   var sub2 = subset(myArray, 2, 2);
 *   print(sub1); // [1,2,3]
 *   print(sub2); // [3,4]
 * }
 * </code></div>
 */
p5.prototype.subset = function(list, start, count) {
  if (typeof count !== 'undefined') {
    return list.slice(start, start + count);
  } else {
    return list.slice(start, list.length);
  }
};

module.exports = p5;

},{"../core/core":22}],61:[function(_dereq_,module,exports){
/**
 * @module Data
 * @submodule Conversion
 * @for p5
 * @requires core
 */

'use strict';

var p5 = _dereq_('../core/core');

/**
 * Converts a string to its floating point representation. The contents of a
 * string must resemble a number, or NaN (not a number) will be returned.
 * For example, float("1234.56") evaluates to 1234.56, but float("giraffe")
 * will return NaN.
 *
 * When an array of values is passed in, then an array of floats of the same
 * length is returned.
 *
 * @method float
 * @param {String}  str float string to parse
 * @return {Number}     floating point representation of string
 * @example
 * <div><code>
 * var str = '20';
 * var diameter = float(str);
 * ellipse(width / 2, height / 2, diameter, diameter);
 * </code></div>
 *
 * @alt
 * 20 by 20 white ellipse in the center of the canvas
 *
 */
p5.prototype.float = function(str) {
  if (str instanceof Array) {
    return str.map(parseFloat);
  }
  return parseFloat(str);
};

/**
 * Converts a boolean, string, or float to its integer representation.
 * When an array of values is passed in, then an int array of the same length
 * is returned.
 *
 * @method int
 * @param {String|Boolean|Number}       n value to parse
 * @return {Number}                     integer representation of value
 *
 * @example
 * <div class='norender'><code>
 * print(int('10')); // 10
 * print(int(10.31)); // 10
 * print(int(-10)); // -10
 * print(int(true)); // 1
 * print(int(false)); // 0
 * print(int([false, true, '10.3', 9.8])); // [0, 1, 10, 9]
 * </code></div>
 */
/**
 * @method int
 * @param {Array} ns                    values to parse
 * @return {Number[]}                   integer representation of values
 */
p5.prototype.int = function(n, radix) {
  radix = radix || 10;
  if (typeof n === 'string') {
    return parseInt(n, radix);
  } else if (typeof n === 'number') {
    return n | 0;
  } else if (typeof n === 'boolean') {
    return n ? 1 : 0;
  } else if (n instanceof Array) {
    return n.map(function(n) {
      return p5.prototype.int(n, radix);
    });
  }
};

/**
 * Converts a boolean, string or number to its string representation.
 * When an array of values is passed in, then an array of strings of the same
 * length is returned.
 *
 * @method str
 * @param {String|Boolean|Number|Array} n value to parse
 * @return {String}                     string representation of value
 * @example
 * <div class='norender'><code>
 * print(str('10')); // "10"
 * print(str(10.31)); // "10.31"
 * print(str(-10)); // "-10"
 * print(str(true)); // "true"
 * print(str(false)); // "false"
 * print(str([true, '10.3', 9.8])); // [ "true", "10.3", "9.8" ]
 * </code></div>
 */
p5.prototype.str = function(n) {
  if (n instanceof Array) {
    return n.map(p5.prototype.str);
  } else {
    return String(n);
  }
};

/**
 * Converts a number or string to its boolean representation.
 * For a number, any non-zero value (positive or negative) evaluates to true,
 * while zero evaluates to false. For a string, the value "true" evaluates to
 * true, while any other value evaluates to false. When an array of number or
 * string values is passed in, then a array of booleans of the same length is
 * returned.
 *
 * @method boolean
 * @param {String|Boolean|Number|Array} n value to parse
 * @return {Boolean}                    boolean representation of value
 * @example
 * <div class='norender'><code>
 * print(boolean(0)); // false
 * print(boolean(1)); // true
 * print(boolean('true')); // true
 * print(boolean('abcd')); // false
 * print(boolean([0, 12, 'true'])); // [false, true, false]
 * </code></div>
 */
p5.prototype.boolean = function(n) {
  if (typeof n === 'number') {
    return n !== 0;
  } else if (typeof n === 'string') {
    return n.toLowerCase() === 'true';
  } else if (typeof n === 'boolean') {
    return n;
  } else if (n instanceof Array) {
    return n.map(p5.prototype.boolean);
  }
};

/**
 * Converts a number, string representation of a number, or boolean to its byte
 * representation. A byte can be only a whole number between -128 and 127, so
 * when a value outside of this range is converted, it wraps around to the
 * corresponding byte representation. When an array of number, string or boolean
 * values is passed in, then an array of bytes the same length is returned.
 *
 * @method byte
 * @param {String|Boolean|Number}       n value to parse
 * @return {Number}                     byte representation of value
 *
 * @example
 * <div class='norender'><code>
 * print(byte(127)); // 127
 * print(byte(128)); // -128
 * print(byte(23.4)); // 23
 * print(byte('23.4')); // 23
 * print(byte('hello')); // NaN
 * print(byte(true)); // 1
 * print(byte([0, 255, '100'])); // [0, -1, 100]
 * </code></div>
 */
/**
 * @method byte
 * @param {Array} ns                   values to parse
 * @return {Number[]}                  array of byte representation of values
 */
p5.prototype.byte = function(n) {
  var nn = p5.prototype.int(n, 10);
  if (typeof nn === 'number') {
    return (nn + 128) % 256 - 128;
  } else if (nn instanceof Array) {
    return nn.map(p5.prototype.byte);
  }
};

/**
 * Converts a number or string to its corresponding single-character
 * string representation. If a string parameter is provided, it is first
 * parsed as an integer and then translated into a single-character string.
 * When an array of number or string values is passed in, then an array of
 * single-character strings of the same length is returned.
 *
 * @method char
 * @param {String|Number}       n value to parse
 * @return {String}             string representation of value
 *
 * @example
 * <div class='norender'><code>
 * print(char(65)); // "A"
 * print(char('65')); // "A"
 * print(char([65, 66, 67])); // [ "A", "B", "C" ]
 * print(join(char([65, 66, 67]), '')); // "ABC"
 * </code></div>
 */
/**
 * @method char
 * @param {Array} ns              values to parse
 * @return {String[]}             array of string representation of values
 */
p5.prototype.char = function(n) {
  if (typeof n === 'number' && !isNaN(n)) {
    return String.fromCharCode(n);
  } else if (n instanceof Array) {
    return n.map(p5.prototype.char);
  } else if (typeof n === 'string') {
    return p5.prototype.char(parseInt(n, 10));
  }
};

/**
 * Converts a single-character string to its corresponding integer
 * representation. When an array of single-character string values is passed
 * in, then an array of integers of the same length is returned.
 *
 * @method unchar
 * @param {String} n     value to parse
 * @return {Number}      integer representation of value
 *
 * @example
 * <div class='norender'><code>
 * print(unchar('A')); // 65
 * print(unchar(['A', 'B', 'C'])); // [ 65, 66, 67 ]
 * print(unchar(split('ABC', ''))); // [ 65, 66, 67 ]
 * </code></div>
 */
/**
 * @method unchar
 * @param {Array} ns       values to parse
 * @return {Number[]}      integer representation of values
 */
p5.prototype.unchar = function(n) {
  if (typeof n === 'string' && n.length === 1) {
    return n.charCodeAt(0);
  } else if (n instanceof Array) {
    return n.map(p5.prototype.unchar);
  }
};

/**
 * Converts a number to a string in its equivalent hexadecimal notation. If a
 * second parameter is passed, it is used to set the number of characters to
 * generate in the hexadecimal notation. When an array is passed in, an
 * array of strings in hexadecimal notation of the same length is returned.
 *
 * @method hex
 * @param {Number} n     value to parse
 * @param {Number} [digits]
 * @return {String}      hexadecimal string representation of value
 *
 * @example
 * <div class='norender'><code>
 * print(hex(255)); // "000000FF"
 * print(hex(255, 6)); // "0000FF"
 * print(hex([0, 127, 255], 6)); // [ "000000", "00007F", "0000FF" ]
 * </code></div>
 */
/**
 * @method hex
 * @param {Number[]} ns    array of values to parse
 * @param {Number} [digits]
 * @return {String[]}      hexadecimal string representation of values
 */
p5.prototype.hex = function(n, digits) {
  digits = digits === undefined || digits === null ? (digits = 8) : digits;
  if (n instanceof Array) {
    return n.map(function(n) {
      return p5.prototype.hex(n, digits);
    });
  } else if (typeof n === 'number') {
    if (n < 0) {
      n = 0xffffffff + n + 1;
    }
    var hex = Number(n)
      .toString(16)
      .toUpperCase();
    while (hex.length < digits) {
      hex = '0' + hex;
    }
    if (hex.length >= digits) {
      hex = hex.substring(hex.length - digits, hex.length);
    }
    return hex;
  }
};

/**
 * Converts a string representation of a hexadecimal number to its equivalent
 * integer value. When an array of strings in hexadecimal notation is passed
 * in, an array of integers of the same length is returned.
 *
 * @method unhex
 * @param {String} n value to parse
 * @return {Number}      integer representation of hexadecimal value
 *
 * @example
 * <div class='norender'><code>
 * print(unhex('A')); // 10
 * print(unhex('FF')); // 255
 * print(unhex(['FF', 'AA', '00'])); // [ 255, 170, 0 ]
 * </code></div>
 */
/**
 * @method unhex
 * @param {Array} ns values to parse
 * @return {Number[]}      integer representations of hexadecimal value
 */
p5.prototype.unhex = function(n) {
  if (n instanceof Array) {
    return n.map(p5.prototype.unhex);
  } else {
    return parseInt('0x' + n, 16);
  }
};

module.exports = p5;

},{"../core/core":22}],62:[function(_dereq_,module,exports){
/**
 * @module Data
 * @submodule String Functions
 * @for p5
 * @requires core
 */

'use strict';

var p5 = _dereq_('../core/core');
_dereq_('../core/error_helpers');

//return p5; //LM is this a mistake?

/**
 * Combines an array of Strings into one String, each separated by the
 * character(s) used for the separator parameter. To join arrays of ints or
 * floats, it's necessary to first convert them to Strings using nf() or
 * nfs().
 *
 * @method join
 * @param  {Array}  list      array of Strings to be joined
 * @param  {String} separator String to be placed between each item
 * @return {String}           joined String
 * @example
 * <div>
 * <code>
 * var array = ['Hello', 'world!'];
 * var separator = ' ';
 * var message = join(array, separator);
 * text(message, 5, 50);
 * </code>
 * </div>
 *
 * @alt
 * "hello world!" displayed middle left of canvas.
 *
 */
p5.prototype.join = function(list, separator) {
  p5._validateParameters('join', arguments);
  return list.join(separator);
};

/**
 * This function is used to apply a regular expression to a piece of text,
 * and return matching groups (elements found inside parentheses) as a
 * String array. If there are no matches, a null value will be returned.
 * If no groups are specified in the regular expression, but the sequence
 * matches, an array of length 1 (with the matched text as the first element
 * of the array) will be returned.
 * <br><br>
 * To use the function, first check to see if the result is null. If the
 * result is null, then the sequence did not match at all. If the sequence
 * did match, an array is returned.
 * <br><br>
 * If there are groups (specified by sets of parentheses) in the regular
 * expression, then the contents of each will be returned in the array.
 * Element [0] of a regular expression match returns the entire matching
 * string, and the match groups start at element [1] (the first group is [1],
 * the second [2], and so on).
 *
 * @method match
 * @param  {String} str    the String to be searched
 * @param  {String} regexp the regexp to be used for matching
 * @return {String[]}      Array of Strings found
 * @example
 * <div>
 * <code>
 * var string = 'Hello p5js*!';
 * var regexp = 'p5js\\*';
 * var m = match(string, regexp);
 * text(m, 5, 50);
 * </code>
 * </div>
 *
 * @alt
 * "p5js*" displayed middle left of canvas.
 *
 */
p5.prototype.match = function(str, reg) {
  p5._validateParameters('match', arguments);
  return str.match(reg);
};

/**
 * This function is used to apply a regular expression to a piece of text,
 * and return a list of matching groups (elements found inside parentheses)
 * as a two-dimensional String array. If there are no matches, a null value
 * will be returned. If no groups are specified in the regular expression,
 * but the sequence matches, a two dimensional array is still returned, but
 * the second dimension is only of length one.
 * <br><br>
 * To use the function, first check to see if the result is null. If the
 * result is null, then the sequence did not match at all. If the sequence
 * did match, a 2D array is returned.
 * <br><br>
 * If there are groups (specified by sets of parentheses) in the regular
 * expression, then the contents of each will be returned in the array.
 * Assuming a loop with counter variable i, element [i][0] of a regular
 * expression match returns the entire matching string, and the match groups
 * start at element [i][1] (the first group is [i][1], the second [i][2],
 * and so on).
 *
 * @method matchAll
 * @param  {String} str    the String to be searched
 * @param  {String} regexp the regexp to be used for matching
 * @return {String[]}         2d Array of Strings found
 * @example
 * <div class="norender">
 * <code>
 * var string = 'Hello p5js*! Hello world!';
 * var regexp = 'Hello';
 * matchAll(string, regexp);
 * </code>
 * </div>
 */
p5.prototype.matchAll = function(str, reg) {
  p5._validateParameters('matchAll', arguments);
  var re = new RegExp(reg, 'g');
  var match = re.exec(str);
  var matches = [];
  while (match !== null) {
    matches.push(match);
    // matched text: match[0]
    // match start: match.index
    // capturing group n: match[n]
    match = re.exec(str);
  }
  return matches;
};

/**
 * Utility function for formatting numbers into strings. There are two
 * versions: one for formatting floats, and one for formatting ints.
 * The values for the digits, left, and right parameters should always
 * be positive integers.
 *
 * @method nf
 * @param {Number|String}       num      the Number to format
 * @param {Integer|String}      [left]   number of digits to the left of the
 *                                decimal point
 * @param {Integer|String}      [right]  number of digits to the right of the
 *                                decimal point
 * @return {String}               formatted String
 *
 * @example
 * <div>
 * <code>
 * function setup() {
 *   background(200);
 *   var num = 112.53106115;
 *
 *   noStroke();
 *   fill(0);
 *   textSize(14);
 *   // Draw formatted numbers
 *   text(nf(num, 5, 2), 10, 20);
 *
 *   text(nf(num, 4, 3), 10, 55);
 *
 *   text(nf(num, 3, 6), 10, 85);
 *
 *   // Draw dividing lines
 *   stroke(120);
 *   line(0, 30, width, 30);
 *   line(0, 65, width, 65);
 * }
 * </code>
 * </div>
 *
 * @alt
 * "0011253" top left, "0112.531" mid left, "112.531061" bottom left canvas
 */
/**
 * @method nf
 * @param {Array}        nums     the Numbers to format
 * @param {Integer|String}      [left]
 * @param {Integer|String}      [right]
 * @return {String[]}                formatted Strings
 */
p5.prototype.nf = function(nums, left, right) {
  p5._validateParameters('nf', arguments);
  if (nums instanceof Array) {
    return nums.map(function(x) {
      return doNf(x, left, right);
    });
  } else {
    var typeOfFirst = Object.prototype.toString.call(nums);
    if (typeOfFirst === '[object Arguments]') {
      if (nums.length === 3) {
        return this.nf(nums[0], nums[1], nums[2]);
      } else if (nums.length === 2) {
        return this.nf(nums[0], nums[1]);
      } else {
        return this.nf(nums[0]);
      }
    } else {
      return doNf(nums, left, right);
    }
  }
};

function doNf(num, left, right) {
  var neg = num < 0;
  var n = neg ? num.toString().substring(1) : num.toString();
  var decimalInd = n.indexOf('.');
  var intPart = decimalInd !== -1 ? n.substring(0, decimalInd) : n;
  var decPart = decimalInd !== -1 ? n.substring(decimalInd + 1) : '';
  var str = neg ? '-' : '';
  if (typeof right !== 'undefined') {
    var decimal = '';
    if (decimalInd !== -1 || right - decPart.length > 0) {
      decimal = '.';
    }
    if (decPart.length > right) {
      decPart = decPart.substring(0, right);
    }
    for (var i = 0; i < left - intPart.length; i++) {
      str += '0';
    }
    str += intPart;
    str += decimal;
    str += decPart;
    for (var j = 0; j < right - decPart.length; j++) {
      str += '0';
    }
    return str;
  } else {
    for (var k = 0; k < Math.max(left - intPart.length, 0); k++) {
      str += '0';
    }
    str += n;
    return str;
  }
}

/**
 * Utility function for formatting numbers into strings and placing
 * appropriate commas to mark units of 1000. There are two versions: one
 * for formatting ints, and one for formatting an array of ints. The value
 * for the right parameter should always be a positive integer.
 *
 * @method nfc
 * @param  {Number|String}   num     the Number to format
 * @param  {Integer|String}  [right] number of digits to the right of the
 *                                  decimal point
 * @return {String}           formatted String
 *
 * @example
 * <div>
 * <code>
 * function setup() {
 *   background(200);
 *   var num = 11253106.115;
 *   var numArr = [1, 1, 2];
 *
 *   noStroke();
 *   fill(0);
 *   textSize(12);
 *
 *   // Draw formatted numbers
 *   text(nfc(num, 4), 10, 30);
 *   text(nfc(numArr, 2), 10, 80);
 *
 *   // Draw dividing line
 *   stroke(120);
 *   line(0, 50, width, 50);
 * }
 * </code>
 * </div>
 *
 * @alt
 * "11,253,106.115" top middle and "1.00,1.00,2.00" displayed bottom mid
 */
/**
 * @method nfc
 * @param  {Array}    nums     the Numbers to format
 * @param  {Integer|String}  [right]
 * @return {String[]}           formatted Strings
 */
p5.prototype.nfc = function(num, right) {
  p5._validateParameters('nfc', arguments);
  if (num instanceof Array) {
    return num.map(function(x) {
      return doNfc(x, right);
    });
  } else {
    return doNfc(num, right);
  }
};
function doNfc(num, right) {
  num = num.toString();
  var dec = num.indexOf('.');
  var rem = dec !== -1 ? num.substring(dec) : '';
  var n = dec !== -1 ? num.substring(0, dec) : num;
  n = n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  if (right === 0) {
    rem = '';
  } else if (typeof right !== 'undefined') {
    if (right > rem.length) {
      rem += dec === -1 ? '.' : '';
      var len = right - rem.length + 1;
      for (var i = 0; i < len; i++) {
        rem += '0';
      }
    } else {
      rem = rem.substring(0, right + 1);
    }
  }
  return n + rem;
}

/**
 * Utility function for formatting numbers into strings. Similar to nf() but
 * puts a "+" in front of positive numbers and a "-" in front of negative
 * numbers. There are two versions: one for formatting floats, and one for
 * formatting ints. The values for left, and right parameters
 * should always be positive integers.
 *
 * @method nfp
 * @param {Number} num      the Number to format
 * @param {Integer}      [left]   number of digits to the left of the decimal
 *                                point
 * @param {Integer}      [right]  number of digits to the right of the
 *                                decimal point
 * @return {String}         formatted String
 *
 * @example
 * <div>
 * <code>
 * function setup() {
 *   background(200);
 *   var num1 = 11253106.115;
 *   var num2 = -11253106.115;
 *
 *   noStroke();
 *   fill(0);
 *   textSize(12);
 *
 *   // Draw formatted numbers
 *   text(nfp(num1, 4, 2), 10, 30);
 *   text(nfp(num2, 4, 2), 10, 80);
 *
 *   // Draw dividing line
 *   stroke(120);
 *   line(0, 50, width, 50);
 * }
 * </code>
 * </div>
 *
 * @alt
 * "+11253106.11" top middle and "-11253106.11" displayed bottom middle
 */
/**
 * @method nfp
 * @param {Number[]} nums      the Numbers to format
 * @param {Integer}      [left]
 * @param {Integer}      [right]
 * @return {String[]}         formatted Strings
 */
p5.prototype.nfp = function() {
  p5._validateParameters('nfp', arguments);
  var nfRes = p5.prototype.nf.apply(this, arguments);
  if (nfRes instanceof Array) {
    return nfRes.map(addNfp);
  } else {
    return addNfp(nfRes);
  }
};

function addNfp(num) {
  return parseFloat(num) > 0 ? '+' + num.toString() : num.toString();
}

/**
 * Utility function for formatting numbers into strings. Similar to nf() but
 * puts a " " (space) in front of positive numbers and a "-" in front of
 * negative numbers. There are two versions: one for formatting floats, and
 * one for formatting ints. The values for the digits, left, and right
 * parameters should always be positive integers.
 *
 * @method nfs
 * @param {Number}       num      the Number to format
 * @param {Integer}      [left]   number of digits to the left of the decimal
 *                                point
 * @param {Integer}      [right]  number of digits to the right of the
 *                                decimal point
 * @return {String}         formatted String
 *
 * @example
 * <div>
 * <code>
 * function setup() {
 *   background(200);
 *   var num1 = 11253106.115;
 *   var num2 = -11253106.115;
 *
 *   noStroke();
 *   fill(0);
 *   textSize(12);
 *   // Draw formatted numbers
 *   text(nfs(num1, 4, 2), 10, 30);
 *
 *   text(nfs(num2, 4, 2), 10, 80);
 *
 *   // Draw dividing line
 *   stroke(120);
 *   line(0, 50, width, 50);
 * }
 * </code>
 * </div>
 *
 * @alt
 * "11253106.11" top middle and "-11253106.11" displayed bottom middle
 */
/**
 * @method nfs
 * @param {Array}        nums     the Numbers to format
 * @param {Integer}      [left]
 * @param {Integer}      [right]
 * @return {String[]}         formatted Strings
 */
p5.prototype.nfs = function() {
  p5._validateParameters('nfs', arguments);
  var nfRes = p5.prototype.nf.apply(this, arguments);
  if (nfRes instanceof Array) {
    return nfRes.map(addNfs);
  } else {
    return addNfs(nfRes);
  }
};

function addNfs(num) {
  return parseFloat(num) > 0 ? ' ' + num.toString() : num.toString();
}

/**
 * The split() function maps to String.split(), it breaks a String into
 * pieces using a character or string as the delimiter. The delim parameter
 * specifies the character or characters that mark the boundaries between
 * each piece. A String[] array is returned that contains each of the pieces.
 *
 * The splitTokens() function works in a similar fashion, except that it
 * splits using a range of characters instead of a specific character or
 * sequence.
 *
 * @method split
 * @param  {String} value the String to be split
 * @param  {String} delim the String used to separate the data
 * @return {String[]}  Array of Strings
 * @example
 * <div>
 * <code>
 * var names = 'Pat,Xio,Alex';
 * var splitString = split(names, ',');
 * text(splitString[0], 5, 30);
 * text(splitString[1], 5, 50);
 * text(splitString[2], 5, 70);
 * </code>
 * </div>
 *
 * @alt
 * "pat" top left, "Xio" mid left and "Alex" displayed bottom left
 *
 */
p5.prototype.split = function(str, delim) {
  p5._validateParameters('split', arguments);
  return str.split(delim);
};

/**
 * The splitTokens() function splits a String at one or many character
 * delimiters or "tokens." The delim parameter specifies the character or
 * characters to be used as a boundary.
 * <br><br>
 * If no delim characters are specified, any whitespace character is used to
 * split. Whitespace characters include tab (\t), line feed (\n), carriage
 * return (\r), form feed (\f), and space.
 *
 * @method splitTokens
 * @param  {String} value   the String to be split
 * @param  {String} [delim] list of individual Strings that will be used as
 *                          separators
 * @return {String[]}          Array of Strings
 * @example
 * <div class = "norender">
 * <code>
 * function setup() {
 *   var myStr = 'Mango, Banana, Lime';
 *   var myStrArr = splitTokens(myStr, ',');
 *
 *   print(myStrArr); // prints : ["Mango"," Banana"," Lime"]
 * }
 * </code>
 * </div>
 */
p5.prototype.splitTokens = function(value, delims) {
  p5._validateParameters('splitTokens', arguments);
  var d;
  if (typeof delims !== 'undefined') {
    var str = delims;
    var sqc = /\]/g.exec(str);
    var sqo = /\[/g.exec(str);
    if (sqo && sqc) {
      str = str.slice(0, sqc.index) + str.slice(sqc.index + 1);
      sqo = /\[/g.exec(str);
      str = str.slice(0, sqo.index) + str.slice(sqo.index + 1);
      d = new RegExp('[\\[' + str + '\\]]', 'g');
    } else if (sqc) {
      str = str.slice(0, sqc.index) + str.slice(sqc.index + 1);
      d = new RegExp('[' + str + '\\]]', 'g');
    } else if (sqo) {
      str = str.slice(0, sqo.index) + str.slice(sqo.index + 1);
      d = new RegExp('[' + str + '\\[]', 'g');
    } else {
      d = new RegExp('[' + str + ']', 'g');
    }
  } else {
    d = /\s/g;
  }
  return value.split(d).filter(function(n) {
    return n;
  });
};

/**
 * Removes whitespace characters from the beginning and end of a String. In
 * addition to standard whitespace characters such as space, carriage return,
 * and tab, this function also removes the Unicode "nbsp" character.
 *
 * @method trim
 * @param  {String} str a String to be trimmed
 * @return {String}       a trimmed String
 *
 * @example
 * <div>
 * <code>
 * var string = trim('  No new lines\n   ');
 * text(string + ' here', 2, 50);
 * </code>
 * </div>
 *
 * @alt
 * "No new lines here" displayed center canvas
 */
/**
 * @method trim
 * @param  {Array} strs an Array of Strings to be trimmed
 * @return {String[]}   an Array of trimmed Strings
 */
p5.prototype.trim = function(str) {
  p5._validateParameters('trim', arguments);
  if (str instanceof Array) {
    return str.map(this.trim);
  } else {
    return str.trim();
  }
};

module.exports = p5;

},{"../core/core":22,"../core/error_helpers":25}],63:[function(_dereq_,module,exports){
/**
 * @module IO
 * @submodule Time & Date
 * @for p5
 * @requires core
 */

'use strict';

var p5 = _dereq_('../core/core');

/**
 * p5.js communicates with the clock on your computer. The day() function
 * returns the current day as a value from 1 - 31.
 *
 * @method day
 * @return {Integer} the current day
 * @example
 * <div>
 * <code>
 * var d = day();
 * text('Current day: \n' + d, 5, 50);
 * </code>
 * </div>
 *
 * @alt
 * Current day is displayed
 *
 */
p5.prototype.day = function() {
  return new Date().getDate();
};

/**
 * p5.js communicates with the clock on your computer. The hour() function
 * returns the current hour as a value from 0 - 23.
 *
 * @method hour
 * @return {Integer} the current hour
 * @example
 * <div>
 * <code>
 * var h = hour();
 * text('Current hour:\n' + h, 5, 50);
 * </code>
 * </div>
 *
 * @alt
 * Current hour is displayed
 *
 */
p5.prototype.hour = function() {
  return new Date().getHours();
};

/**
 * p5.js communicates with the clock on your computer. The minute() function
 * returns the current minute as a value from 0 - 59.
 *
 * @method minute
 * @return {Integer} the current minute
 * @example
 * <div>
 * <code>
 * var m = minute();
 * text('Current minute: \n' + m, 5, 50);
 * </code>
 * </div>
 *
 * @alt
 * Current minute is displayed
 *
 */
p5.prototype.minute = function() {
  return new Date().getMinutes();
};

/**
 * Returns the number of milliseconds (thousandths of a second) since
 * starting the program. This information is often used for timing events and
 * animation sequences.
 *
 * @method millis
 * @return {Number} the number of milliseconds since starting the program
 * @example
 * <div>
 * <code>
 * var millisecond = millis();
 * text('Milliseconds \nrunning: \n' + millisecond, 5, 40);
 * </code>
 * </div>
 *
 * @alt
 * number of milliseconds since program has started displayed
 *
 */
p5.prototype.millis = function() {
  return window.performance.now();
};

/**
 * p5.js communicates with the clock on your computer. The month() function
 * returns the current month as a value from 1 - 12.
 *
 * @method month
 * @return {Integer} the current month
 * @example
 * <div>
 * <code>
 * var m = month();
 * text('Current month: \n' + m, 5, 50);
 * </code>
 * </div>
 *
 * @alt
 * Current month is displayed
 *
 */
p5.prototype.month = function() {
  return new Date().getMonth() + 1; //January is 0!
};

/**
 * p5.js communicates with the clock on your computer. The second() function
 * returns the current second as a value from 0 - 59.
 *
 * @method second
 * @return {Integer} the current second
 * @example
 * <div>
 * <code>
 * var s = second();
 * text('Current second: \n' + s, 5, 50);
 * </code>
 * </div>
 *
 * @alt
 * Current second is displayed
 *
 */
p5.prototype.second = function() {
  return new Date().getSeconds();
};

/**
 * p5.js communicates with the clock on your computer. The year() function
 * returns the current year as an integer (2014, 2015, 2016, etc).
 *
 * @method year
 * @return {Integer} the current year
 * @example
 * <div>
 * <code>
 * var y = year();
 * text('Current year: \n' + y, 5, 50);
 * </code>
 * </div>
 *
 * @alt
 * Current year is displayed
 *
 */
p5.prototype.year = function() {
  return new Date().getFullYear();
};

module.exports = p5;

},{"../core/core":22}],64:[function(_dereq_,module,exports){
/**
 * @module Lights, Camera
 * @submodule Camera
 * @for p5
 * @requires core
 */

'use strict';

var p5 = _dereq_('../core/core');

/**
 * Sets camera position for a 3D sketch. The function behaves similarly
 * gluLookAt, except that it replaces the existing modelview matrix instead
 * of applying any transformations calculated here on top of the existing
 * model view.
 * When called with no arguments, this function
 * sets a default camera equivalent to calling
 * camera(0, 0, (height/2.0) / tan(PI*30.0 / 180.0), 0, 0, 0, 0, 1, 0);
 * @method camera
 * @param  {Number} [x]        camera position value on x axis
 * @param  {Number} [y]        camera position value on y axis
 * @param  {Number} [z]        camera position value on z axis
 * @param  {Number} [centerX]  x coordinate representing center of the sketch
 * @param  {Number} [centerY]  y coordinate representing center of the sketch
 * @param  {Number} [centerZ]  z coordinate representing center of the sketch
 * @param  {Number} [upX]      x component of direction 'up' from camera
 * @param  {Number} [upY]      y component of direction 'up' from camera
 * @param  {Number} [upZ]      z component of direction 'up' from camera
 * @chainable
 * @example
 * <div>
 * <code>
 * function setup() {
 *   createCanvas(100, 100, WEBGL);
 * }
 * function draw() {
 *   //move the camera away from the plane by a sin wave
 *   camera(0, 0, sin(frameCount * 0.01) * 100, 0, 0, 0, 0, 1, 0);
 *   plane(120, 120);
 * }
 * </code>
 * </div>
 *
 * @alt
 * blue square shrinks in size grows to fill canvas. disappears then loops.
 *
 */
p5.prototype.camera = function() {
  this._renderer.camera.apply(this._renderer, arguments);
  return this;
};

p5.RendererGL.prototype.camera = function(
  eyeX,
  eyeY,
  eyeZ,
  centerX,
  centerY,
  centerZ,
  upX,
  upY,
  upZ
) {
  if (typeof eyeX === 'undefined') {
    eyeX = this.defaultCameraX;
    eyeY = this.defaultCameraY;
    eyeZ = this.defaultCameraZ;
    centerX = eyeX;
    centerY = eyeY;
    centerZ = 0;
    upX = 0;
    upY = 1;
    upZ = 0;
  }

  this.cameraX = eyeX;
  this.cameraY = eyeY;
  this.cameraZ = eyeZ;

  // calculate camera Z vector
  var z0 = eyeX - centerX;
  var z1 = eyeY - centerY;
  var z2 = eyeZ - centerZ;

  this.eyeDist = Math.sqrt(z0 * z0 + z1 * z1 + z2 * z2);
  if (this.eyeDist !== 0) {
    z0 /= this.eyeDist;
    z1 /= this.eyeDist;
    z2 /= this.eyeDist;
  }

  // calculate camera Y vector
  var y0 = upX;
  var y1 = upY;
  var y2 = upZ;

  // computer x vector as y cross z
  var x0 = y1 * z2 - y2 * z1;
  var x1 = -y0 * z2 + y2 * z0;
  var x2 = y0 * z1 - y1 * z0;

  // recomputer y = z cross x
  y0 = z1 * x2 - z2 * x1;
  y1 = -z0 * x2 + z2 * x0;
  y2 = z0 * x1 - z1 * x0;

  // cross product gives area of parallelogram, which is < 1.0 for
  // non-perpendicular unit-length vectors; so normalize x, y here:
  var xmag = Math.sqrt(x0 * x0 + x1 * x1 + x2 * x2);
  if (xmag !== 0) {
    x0 /= xmag;
    x1 /= xmag;
    x2 /= xmag;
  }

  var ymag = Math.sqrt(y0 * y0 + y1 * y1 + y2 * y2);
  if (ymag !== 0) {
    y0 /= ymag;
    y1 /= ymag;
    y2 /= ymag;
  }

  // the camera affects the model view matrix, insofar as it
  // inverse translates the world to the eye position of the camera
  // and rotates it.
  // prettier-ignore
  this.cameraMatrix.set(x0, y0, z0, 0,
                        x1, y1, z1, 0,
                        x2, y2, z2, 0,
                        0,   0,  0, 1);

  var tx = -eyeX;
  var ty = -eyeY;
  var tz = -eyeZ;

  this.cameraMatrix.translate([tx, ty, tz]);
  this.uMVMatrix.set(
    this.cameraMatrix.mat4[0],
    this.cameraMatrix.mat4[1],
    this.cameraMatrix.mat4[2],
    this.cameraMatrix.mat4[3],
    this.cameraMatrix.mat4[4],
    this.cameraMatrix.mat4[5],
    this.cameraMatrix.mat4[6],
    this.cameraMatrix.mat4[7],
    this.cameraMatrix.mat4[8],
    this.cameraMatrix.mat4[9],
    this.cameraMatrix.mat4[10],
    this.cameraMatrix.mat4[11],
    this.cameraMatrix.mat4[12],
    this.cameraMatrix.mat4[13],
    this.cameraMatrix.mat4[14],
    this.cameraMatrix.mat4[15]
  );
  return this;
};

/**
 * Sets perspective camera. When called with no arguments, the defaults
 * provided are equivalent to
 * perspective(PI/3.0, width/height, cameraZ/10.0, cameraZ*10.0)
 * where cameraZ is ((height/2.0) / tan(PI*60.0/360.0));
 * @method  perspective
 * @param  {Number} [fovy]   camera frustum vertical field of view,
 *                           from bottom to top of view, in degrees
 * @param  {Number} [aspect] camera frustum aspect ratio
 * @param  {Number} [near]   frustum near plane length
 * @param  {Number} [far]    frustum far plane length
 * @chainable
 * @example
 * <div>
 * <code>
 * //drag mouse to toggle the world!
 * //you will see there's a vanish point
 * function setup() {
 *   createCanvas(100, 100, WEBGL);
 *   var fov = 60 / 180 * PI;
 *   var cameraZ = height / 2.0 / tan(fov / 2.0);
 *   perspective(60 / 180 * PI, width / height, cameraZ * 0.1, cameraZ * 10);
 * }
 * function draw() {
 *   background(200);
 *   orbitControl();
 *   for (var i = -1; i < 2; i++) {
 *     for (var j = -2; j < 3; j++) {
 *       push();
 *       translate(i * 160, 0, j * 160);
 *       box(40, 40, 40);
 *       pop();
 *     }
 *   }
 * }
 * </code>
 * </div>
 *
 * @alt
 * colored 3d boxes toggleable with mouse position
 *
 */
p5.prototype.perspective = function() {
  this._renderer.perspective.apply(this._renderer, arguments);
  return this;
};

p5.RendererGL.prototype.perspective = function(fovy, aspect, near, far) {
  if (typeof fovy === 'undefined') {
    fovy = this.defaultCameraFOV;
  }
  if (typeof aspect === 'undefined') {
    aspect = this.defaultCameraAspect;
  }
  if (typeof near === 'undefined') {
    near = this.defaultCameraNear;
  }
  if (typeof far === 'undefined') {
    far = this.defaultCameraFar;
  }

  this.cameraFOV = fovy;
  this.cameraAspect = aspect;
  this.cameraNear = near;
  this.cameraFar = far;

  this.uPMatrix = p5.Matrix.identity(this.pInst);

  var f = 1.0 / Math.tan(this.cameraFOV / 2);
  var nf = 1.0 / (this.cameraNear - this.cameraFar);

  // prettier-ignore
  this.uPMatrix.set(f / aspect,  0,                     0,  0,
                    0,          -f,                     0,  0,
                    0,           0,     (far + near) * nf, -1,
                    0,           0, (2 * far * near) * nf,  0);

  this._curCamera = 'custom';
};

/**
 * Setup ortho camera
 * @method  ortho
 * @param  {Number} [left]   camera frustum left plane
 * @param  {Number} [right]  camera frustum right plane
 * @param  {Number} [bottom] camera frustum bottom plane
 * @param  {Number} [top]    camera frustum top plane
 * @param  {Number} [near]   camera frustum near plane
 * @param  {Number} [far]    camera frustum far plane
 * @chainable
 * @example
 * <div>
 * <code>
 * //drag mouse to toggle the world!
 * //there's no vanish point
 * function setup() {
 *   createCanvas(100, 100, WEBGL);
 *   ortho(-width / 2, width / 2, height / 2, -height / 2, 0, 500);
 * }
 * function draw() {
 *   background(200);
 *   orbitControl();
 *   strokeWeight(0.1);
 *   for (var i = -1; i < 2; i++) {
 *     for (var j = -2; j < 3; j++) {
 *       push();
 *       translate(i * 160, 0, j * 160);
 *       box(40, 40, 40);
 *       pop();
 *     }
 *   }
 * }
 * </code>
 * </div>
 *
 * @alt
 * 3 3d boxes, reveal several more boxes on 3d plane when mouse used to toggle
 *
 */
p5.prototype.ortho = function() {
  this._renderer.ortho.apply(this._renderer, arguments);
  return this;
};

p5.RendererGL.prototype.ortho = function(left, right, bottom, top, near, far) {
  if (left === undefined) left = -this.width / 2;
  if (right === undefined) right = +this.width / 2;
  if (bottom === undefined) bottom = -this.height / 2;
  if (top === undefined) top = +this.height / 2;
  if (near === undefined) near = 0;
  if (far === undefined) far = Math.max(this.width, this.height);
  this.uPMatrix = p5.Matrix.identity(this._pInst);
  //this.uPMatrix.ortho(left,right,bottom,top,near,far);

  var w = right - left;
  var h = top - bottom;
  var d = far - near;

  var x = +2.0 / w;
  var y = +2.0 / h;
  var z = -2.0 / d;

  var tx = -(right + left) / w;
  var ty = -(top + bottom) / h;
  var tz = -(far + near) / d;

  this.uPMatrix = p5.Matrix.identity();

  // prettier-ignore
  this.uPMatrix.set(  x,  0,  0,  0, 
                      0, -y,  0,  0, 
                      0,  0,  z,  0, 
                     tx, ty, tz,  1);

  this._curCamera = 'custom';
};

module.exports = p5;

},{"../core/core":22}],65:[function(_dereq_,module,exports){
'use strict';

var p5 = _dereq_('../core/core');

/**
 * @method orbitControl
 * @for p5
 * @chainable
 */
//@TODO: implement full orbit controls including
//pan, zoom, quaternion rotation, etc.
p5.prototype.orbitControl = function() {
  if (this.mouseIsPressed) {
    this.rotateY((this.mouseX - this.width / 2) / (this.width / 2));
    this.rotateX((this.mouseY - this.height / 2) / (this.width / 2));
  }
  return this;
};

module.exports = p5;

},{"../core/core":22}],66:[function(_dereq_,module,exports){
/**
 * @module Lights, Camera
 * @submodule Lights
 * @for p5
 * @requires core
 */

'use strict';

var p5 = _dereq_('../core/core');

/**
 * Creates an ambient light with a color
 *
 * @method ambientLight
 * @param  {Number}        v1      red or hue value relative to
 *                                 the current color range
 * @param  {Number}        v2      green or saturation value
 *                                 relative to the current color range
 * @param  {Number}        v3      blue or brightness value
 *                                 relative to the current color range
 * @param  {Number}        [alpha]
 * @chainable
 *
 * @example
 * <div>
 * <code>
 * function setup() {
 *   createCanvas(100, 100, WEBGL);
 * }
 * function draw() {
 *   background(0);
 *   ambientLight(150);
 *   ambientMaterial(250);
 *   noStroke();
 *   sphere(25);
 * }
 * </code>
 * </div>
 *
 * @alt
 * evenly distributed light across a sphere
 *
 */

/**
 * @method ambientLight
 * @param  {String}        value   a color string
 * @param  {Number}        [alpha]
 * @chainable
 */

/**
 * @method ambientLight
 * @param  {Number[]}      values  an array containing the red,green,blue &
 *                                 and alpha components of the color
 * @chainable
 */

/**
 * @method ambientLight
 * @param  {p5.Color}      color   the ambient light color
 * @chainable
 */
p5.prototype.ambientLight = function(v1, v2, v3, a) {
  var color = this.color.apply(this, arguments);

  var shader = this._renderer._useLightShader();

  //@todo this is a bit icky. array uniforms have
  //to be multiples of the type 3(rgb) in this case.
  //a preallocated Float32Array(24) that we copy into
  //would be better
  shader.setUniform('uUseLighting', true);
  //in case there's no material color for the geometry
  shader.setUniform('uMaterialColor', this._renderer.curFillColor);

  this._renderer.ambientLightColors.push(
    color._array[0],
    color._array[1],
    color._array[2]
  );
  shader.setUniform('uAmbientColor', this._renderer.ambientLightColors);

  shader.setUniform(
    'uAmbientLightCount',
    this._renderer.ambientLightColors.length / 3
  );

  return this;
};

/**
 * Creates a directional light with a color and a direction
 * @method directionalLight
 * @param  {Number}    v1       red or hue value (depending on the current
 * color mode),
 * @param  {Number}    v2       green or saturation value
 * @param  {Number}    v3       blue or brightness value
 * @param  {p5.Vector} position the direction of the light
 * @chainable
 * @example
 * <div>
 * <code>
 * function setup() {
 *   createCanvas(100, 100, WEBGL);
 * }
 * function draw() {
 *   background(0);
 *   //move your mouse to change light direction
 *   var dirX = (mouseX / width - 0.5) * 2;
 *   var dirY = (mouseY / height - 0.5) * 2;
 *   directionalLight(250, 250, 250, -dirX, -dirY, 0.25);
 *   ambientMaterial(250);
 *   noStroke();
 *   sphere(25);
 * }
 * </code>
 * </div>
 *
 * @alt
 * light source on canvas changeable with mouse position
 *
 */

/**
 * @method directionalLight
 * @param  {Number[]|String|p5.Color} color   color Array, CSS color string,
 *                                             or p5.Color value
 * @param  {Number}                   x       x axis direction
 * @param  {Number}                   y       y axis direction
 * @param  {Number}                   z       z axis direction
 * @chainable
 */

/**
 * @method directionalLight
 * @param  {Number[]|String|p5.Color} color
 * @param  {p5.Vector}                position
 * @chainable
 */

/**
 * @method directionalLight
 * @param  {Number}    v1
 * @param  {Number}    v2
 * @param  {Number}    v3
 * @param  {Number}    x
 * @param  {Number}    y
 * @param  {Number}    z
 * @chainable
 */
p5.prototype.directionalLight = function(v1, v2, v3, x, y, z) {
  var shader = this._renderer._useLightShader();

  //@TODO: check parameters number
  var color = this.color.apply(this, [v1, v2, v3]);

  var _x, _y, _z;
  var v = arguments[arguments.length - 1];
  if (typeof v === 'number') {
    _x = arguments[arguments.length - 3];
    _y = arguments[arguments.length - 2];
    _z = arguments[arguments.length - 1];
  } else {
    _x = v.x;
    _y = v.y;
    _z = v.z;
  }
  shader.setUniform('uUseLighting', true);
  //in case there's no material color for the geometry
  shader.setUniform('uMaterialColor', this._renderer.curFillColor);

  // normalize direction
  var l = Math.sqrt(_x * _x + _y * _y + _z * _z);
  this._renderer.directionalLightDirections.push(_x / l, _y / l, _z / l);
  shader.setUniform(
    'uLightingDirection',
    this._renderer.directionalLightDirections
  );

  this._renderer.directionalLightColors.push(
    color._array[0],
    color._array[1],
    color._array[2]
  );
  shader.setUniform('uDirectionalColor', this._renderer.directionalLightColors);

  shader.setUniform(
    'uDirectionalLightCount',
    this._renderer.directionalLightColors.length / 3
  );

  return this;
};

/**
 * Creates a point light with a color and a light position
 * @method pointLight
 * @param  {Number}    v1       red or hue value (depending on the current
 * color mode),
 * @param  {Number}    v2       green or saturation value
 * @param  {Number}    v3       blue or brightness value
 * @param  {Number}    x        x axis position
 * @param  {Number}    y        y axis position
 * @param  {Number}    z        z axis position
 * @chainable
 * @example
 * <div>
 * <code>
 * function setup() {
 *   createCanvas(100, 100, WEBGL);
 * }
 * function draw() {
 *   background(0);
 *   //move your mouse to change light position
 *   var locX = mouseX - width / 2;
 *   var locY = mouseY - height / 2;
 *   // to set the light position,
 *   // think of the world's coordinate as:
 *   // -width/2,-height/2 -------- width/2,-height/2
 *   //                |            |
 *   //                |     0,0    |
 *   //                |            |
 *   // -width/2,height/2--------width/2,height/2
 *   pointLight(250, 250, 250, locX, locY, 50);
 *   ambientMaterial(250);
 *   noStroke();
 *   sphere(25);
 * }
 * </code>
 * </div>
 *
 * @alt
 * spot light on canvas changes position with mouse
 *
 */

/**
 * @method pointLight
 * @param  {Number}    v1
 * @param  {Number}    v2
 * @param  {Number}    v3
 * @param  {p5.Vector} position the position of the light
 * @chainable
 */

/**
 * @method pointLight
 * @param  {Number[]|String|p5.Color} color   color Array, CSS color string,
 * or p5.Color value
 * @param  {Number}                   x
 * @param  {Number}                   y
 * @param  {Number}                   z
 * @chainable
 */

/**
 * @method pointLight
 * @param  {Number[]|String|p5.Color} color
 * @param  {p5.Vector}                position
 * @chainable
 */
p5.prototype.pointLight = function(v1, v2, v3, x, y, z) {
  //@TODO: check parameters number
  var color = this._renderer._pInst.color.apply(this, [v1, v2, v3]);

  var _x, _y, _z;
  var v = arguments[arguments.length - 1];
  if (typeof v === 'number') {
    _x = arguments[arguments.length - 3];
    _y = arguments[arguments.length - 2];
    _z = arguments[arguments.length - 1];
  } else {
    _x = v.x;
    _y = v.y;
    _z = v.z;
  }

  var shader = this._renderer._useLightShader();
  shader.setUniform('uUseLighting', true);
  //in case there's no material color for the geometry
  shader.setUniform('uMaterialColor', this._renderer.curFillColor);

  this._renderer.pointLightPositions.push(_x, _y, _z);
  shader.setUniform('uPointLightLocation', this._renderer.pointLightPositions);

  this._renderer.pointLightColors.push(
    color._array[0],
    color._array[1],
    color._array[2]
  );
  shader.setUniform('uPointLightColor', this._renderer.pointLightColors);

  shader.setUniform(
    'uPointLightCount',
    this._renderer.pointLightColors.length / 3
  );

  return this;
};

module.exports = p5;

},{"../core/core":22}],67:[function(_dereq_,module,exports){
/**
 * @module Shape
 * @submodule 3D Models
 * @for p5
 * @requires core
 * @requires p5.Geometry
 */

'use strict';

var p5 = _dereq_('../core/core');
_dereq_('./p5.Geometry');

/**
 * Load a 3d model from an OBJ file.
 * <br><br>
 * One of the limitations of the OBJ format is that it doesn't have a built-in
 * sense of scale. This means that models exported from different programs might
 * be very different sizes. If your model isn't displaying, try calling
 * loadModel() with the normalized parameter set to true. This will resize the
 * model to a scale appropriate for p5. You can also make additional changes to
 * the final size of your model with the scale() function.
 *
 * @method loadModel
 * @param  {String} path              Path of the model to be loaded
 * @param  {Boolean} normalize        If true, scale the model to a
 *                                      standardized size when loading
 * @param  {function(p5.Geometry)} [successCallback] Function to be called
 *                                     once the model is loaded. Will be passed
 *                                     the 3D model object.
 * @param  {function(Event)} [failureCallback] called with event error if
 *                                         the image fails to load.
 * @return {p5.Geometry} the p5.Geometry object
 *
 * @example
 * <div>
 * <code>
 * //draw a spinning teapot
 * var teapot;
 *
 * function preload() {
 *   teapot = loadModel('assets/teapot.obj');
 * }
 *
 * function setup() {
 *   createCanvas(100, 100, WEBGL);
 * }
 *
 * function draw() {
 *   background(200);
 *   rotateX(frameCount * 0.01);
 *   rotateY(frameCount * 0.01);
 *   model(teapot);
 * }
 * </code>
 * </div>
 *
 * @alt
 * Vertically rotating 3-d teapot with red, green and blue gradient.
 */
/**
 * @method loadModel
 * @param  {String} path
 * @param  {function(p5.Geometry)} [successCallback]
 * @param  {function(Event)} [failureCallback]
 * @return {p5.Geometry} the p5.Geometry object
 */
p5.prototype.loadModel = function(path) {
  var normalize;
  var successCallback;
  var failureCallback;
  if (typeof arguments[1] === 'boolean') {
    normalize = arguments[1];
    successCallback = arguments[2];
    failureCallback = arguments[3];
  } else {
    normalize = false;
    successCallback = arguments[1];
    failureCallback = arguments[2];
  }

  var model = new p5.Geometry();
  model.gid = path + '|' + normalize;
  this.loadStrings(
    path,
    function(strings) {
      parseObj(model, strings);

      if (normalize) {
        model.normalize();
      }

      if (typeof successCallback === 'function') {
        successCallback(model);
      }
    }.bind(this),
    failureCallback
  );

  return model;
};

/**
 * Parse OBJ lines into model. For reference, this is what a simple model of a
 * square might look like:
 *
 * v -0.5 -0.5 0.5
 * v -0.5 -0.5 -0.5
 * v -0.5 0.5 -0.5
 * v -0.5 0.5 0.5
 *
 * f 4 3 2 1
 */
function parseObj(model, lines) {
  // OBJ allows a face to specify an index for a vertex (in the above example),
  // but it also allows you to specify a custom combination of vertex, UV
  // coordinate, and vertex normal. So, "3/4/3" would mean, "use vertex 3 with
  // UV coordinate 4 and vertex normal 3". In WebGL, every vertex with different
  // parameters must be a different vertex, so loadedVerts is used to
  // temporarily store the parsed vertices, normals, etc., and indexedVerts is
  // used to map a specific combination (keyed on, for example, the string
  // "3/4/3"), to the actual index of the newly created vertex in the final
  // object.
  var loadedVerts = {
    v: [],
    vt: [],
    vn: []
  };
  var indexedVerts = {};

  for (var line = 0; line < lines.length; ++line) {
    // Each line is a separate object (vertex, face, vertex normal, etc)
    // For each line, split it into tokens on whitespace. The first token
    // describes the type.
    var tokens = lines[line].trim().split(/\b\s+/);

    if (tokens.length > 0) {
      if (tokens[0] === 'v' || tokens[0] === 'vn') {
        // Check if this line describes a vertex or vertex normal.
        // It will have three numeric parameters.
        var vertex = new p5.Vector(
          parseFloat(tokens[1]),
          parseFloat(tokens[2]),
          parseFloat(tokens[3])
        );
        loadedVerts[tokens[0]].push(vertex);
      } else if (tokens[0] === 'vt') {
        // Check if this line describes a texture coordinate.
        // It will have two numeric parameters.
        var texVertex = [parseFloat(tokens[1]), parseFloat(tokens[2])];
        loadedVerts[tokens[0]].push(texVertex);
      } else if (tokens[0] === 'f') {
        // Check if this line describes a face.
        // OBJ faces can have more than three points. Triangulate points.
        for (var tri = 3; tri < tokens.length; ++tri) {
          var face = [];

          var vertexTokens = [1, tri - 1, tri];

          for (var tokenInd = 0; tokenInd < vertexTokens.length; ++tokenInd) {
            // Now, convert the given token into an index
            var vertString = tokens[vertexTokens[tokenInd]];
            var vertIndex = 0;

            // TODO: Faces can technically use negative numbers to refer to the
            // previous nth vertex. I haven't seen this used in practice, but
            // it might be good to implement this in the future.

            if (indexedVerts[vertString] !== undefined) {
              vertIndex = indexedVerts[vertString];
            } else {
              var vertParts = vertString.split('/');
              for (var i = 0; i < vertParts.length; i++) {
                vertParts[i] = parseInt(vertParts[i]) - 1;
              }

              vertIndex = indexedVerts[vertString] = model.vertices.length;
              model.vertices.push(loadedVerts.v[vertParts[0]].copy());
              if (loadedVerts.vt[vertParts[1]]) {
                model.uvs.push(loadedVerts.vt[vertParts[1]].slice());
              } else {
                model.uvs.push([0, 0]);
              }

              if (loadedVerts.vn[vertParts[2]]) {
                model.vertexNormals.push(loadedVerts.vn[vertParts[2]].copy());
              }
            }

            face.push(vertIndex);
          }

          if (
            face[0] !== face[1] &&
            face[0] !== face[2] &&
            face[1] !== face[2]
          ) {
            model.faces.push(face);
          }
        }
      }
    }
  }
  // If the model doesn't have normals, compute the normals
  if (model.vertexNormals.length === 0) {
    model.computeNormals();
  }

  return model;
}

/**
 * Render a 3d model to the screen.
 *
 * @method model
 * @param  {p5.Geometry} model Loaded 3d model to be rendered
 * @example
 * <div>
 * <code>
 * //draw a spinning teapot
 * var teapot;
 *
 * function preload() {
 *   teapot = loadModel('assets/teapot.obj');
 * }
 *
 * function setup() {
 *   createCanvas(100, 100, WEBGL);
 * }
 *
 * function draw() {
 *   background(200);
 *   rotateX(frameCount * 0.01);
 *   rotateY(frameCount * 0.01);
 *   model(teapot);
 * }
 * </code>
 * </div>
 *
 * @alt
 * Vertically rotating 3-d teapot with red, green and blue gradient.
 *
 */
p5.prototype.model = function(model) {
  if (model.vertices.length > 0) {
    if (!this._renderer.geometryInHash(model.gid)) {
      model._makeTriangleEdges();
      this._renderer._edgesToVertices(model);
      this._renderer.createBuffers(model.gid, model);
    }

    this._renderer.drawBuffers(model.gid);
  }
};

module.exports = p5;

},{"../core/core":22,"./p5.Geometry":69}],68:[function(_dereq_,module,exports){
/**
 * @module Lights, Camera
 * @submodule Material
 * @for p5
 * @requires core
 */

'use strict';

var p5 = _dereq_('../core/core');
var constants = _dereq_('../core/constants');
_dereq_('./p5.Texture');

/**
 * Loads a custom shader from the provided vertex and fragment
 * shader paths. The shader files are loaded asynchronously in the
 * background, so this method should be used in preload().
 *
 * For now, there are three main types of shaders. p5 will automatically
 * supply appropriate vertices, normals, colors, and lighting attributes
 * if the parameters defined in the shader match the names.
 *
 * @method loadShader
 * @param {String} [vertFilename] path to file containing vertex shader
 * source code
 * @param {String} [fragFilename] path to file containing fragment shader
 * source code
 * @return {p5.Shader} a shader object created from the provided
 * vertex and fragment shader files.
 */
p5.prototype.loadShader = function(vertFilename, fragFilename) {
  var loadedShader = new p5.Shader();

  var self = this;
  var loadedFrag = false;
  var loadedVert = false;

  this.loadStrings(fragFilename, function(result) {
    loadedShader._fragSrc = result.join('\n');
    loadedFrag = true;
    if (!loadedVert) {
      self._incrementPreload();
    }
  });
  this.loadStrings(vertFilename, function(result) {
    loadedShader._vertSrc = result.join('\n');
    loadedVert = true;
    if (!loadedFrag) {
      self._incrementPreload();
    }
  });

  return loadedShader;
};

/**
 * @method createShader
 * @param {String} vertSrc source code for the vertex shader
 * @param {String} fragSrc source code for the fragment shader
 * @returns {p5.Shader} a shader object created from the provided
 * vertex and fragment shaders.
 *
 * @example
 * <div modernizr='webgl'>
 * <code>
 * // the 'varying's are shared between both vertex & fragment shaders
 * var varying = 'precision highp float; varying vec2 vPos;';
 *
 * // the vertex shader is called for each vertex
 * var vs =
 *   varying +
 *   'attribute vec3 aPosition;' +
 *   'void main() { vPos = (gl_Position = vec4(aPosition,1.0)).xy; }';
 *
 * // the fragment shader is called for each pixel
 * var fs =
 *   varying +
 *   'uniform vec2 p;' +
 *   'uniform float r;' +
 *   'const int I = 500;' +
 *   'void main() {' +
 *   '  vec2 c = p + vPos * r, z = c;' +
 *   '  float n = 0.0;' +
 *   '  for (int i = I; i > 0; i --) {' +
 *   '    if(z.x*z.x+z.y*z.y > 4.0) {' +
 *   '      n = float(i)/float(I);' +
 *   '      break;' +
 *   '    }' +
 *   '    z = vec2(z.x*z.x-z.y*z.y, 2.0*z.x*z.y) + c;' +
 *   '  }' +
 *   '  gl_FragColor = vec4(0.5-cos(n*17.0)/2.0,0.5-cos(n*13.0)/2.0,0.5-cos(n*23.0)/2.0,1.0);' +
 *   '}';
 *
 * var mandel;
 * function setup() {
 *   createCanvas(100, 100, WEBGL);
 *
 *   // create and initialize the shader
 *   mandel = createShader(vs, fs);
 *   shader(mandel);
 *   noStroke();
 *
 *   // 'p' is the center point of the Mandelbrot image
 *   mandel.setUniform('p', [-0.74364388703, 0.13182590421]);
 * }
 *
 * function draw() {
 *   // 'r' is the size of the image in Mandelbrot-space
 *   mandel.setUniform('r', 1.5 * exp(-6.5 * (1 + sin(millis() / 2000))));
 *   quad(-1, -1, 1, -1, 1, 1, -1, 1);
 * }
 * </code>
 * </div>
 *
 * @alt
 * zooming Mandelbrot set. a colorful, infinitely detailed fractal.
 */
p5.prototype.createShader = function(vertSrc, fragSrc) {
  return new p5.Shader(this._renderer, vertSrc, fragSrc);
};

/**
 * The shader() function lets the user provide a custom shader
 * to fill in shapes in WEBGL mode. Users can create their
 * own shaders by loading vertex and fragment shaders with
 * loadShader().
 *
 * @method shader
 * @chainable
 * @param {p5.Shader} [s] the desired p5.Shader to use for rendering
 * shapes.
 */
p5.prototype.shader = function(s) {
  if (s._renderer === undefined) {
    s._renderer = this._renderer;
  }
  if (s.isStrokeShader()) {
    this._renderer.setStrokeShader(s);
  } else {
    this._renderer.setFillShader(s);
  }
  return this;
};

/**
 * Normal material for geometry. You can view all
 * possible materials in this
 * <a href="https://p5js.org/examples/3d-materials.html">example</a>.
 * @method normalMaterial
 * @chainable
 * @example
 * <div>
 * <code>
 * function setup() {
 *   createCanvas(100, 100, WEBGL);
 * }
 *
 * function draw() {
 *   background(200);
 *   normalMaterial();
 *   sphere(50);
 * }
 * </code>
 * </div>
 *
 * @alt
 * Red, green and blue gradient.
 *
 */
p5.prototype.normalMaterial = function() {
  this._renderer.drawMode = constants.FILL;
  this._renderer.setFillShader(this._renderer._getNormalShader());
  this._renderer.curFillColor = [1, 1, 1, 1];
  this.noStroke();
  return this;
};

/**
 * Texture for geometry.  You can view other possible materials in this
 * <a href="https://p5js.org/examples/3d-materials.html">example</a>.
 * @method texture
 * @param {p5.Image|p5.MediaElement|p5.Graphics} tex 2-dimensional graphics
 *                    to render as texture
 * @chainable
 * @example
 * <div>
 * <code>
 * var img;
 * function preload() {
 *   img = loadImage('assets/laDefense.jpg');
 * }
 *
 * function setup() {
 *   createCanvas(100, 100, WEBGL);
 * }
 *
 * function draw() {
 *   background(0);
 *   rotateZ(frameCount * 0.01);
 *   rotateX(frameCount * 0.01);
 *   rotateY(frameCount * 0.01);
 *   //pass image as texture
 *   texture(img);
 *   box(200, 200, 200);
 * }
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * var pg;
 * function setup() {
 *   createCanvas(100, 100, WEBGL);
 *   pg = createGraphics(200, 200);
 *   pg.textSize(100);
 * }
 *
 * function draw() {
 *   background(0);
 *   pg.background(255);
 *   pg.text('hello!', 0, 100);
 *   //pass image as texture
 *   texture(pg);
 *   plane(200);
 * }
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * var vid;
 * function preload() {
 *   vid = createVideo('assets/fingers.mov');
 *   vid.hide();
 *   vid.loop();
 * }
 * function setup() {
 *   createCanvas(100, 100, WEBGL);
 * }
 *
 * function draw() {
 *   background(0);
 *   //pass video frame as texture
 *   texture(vid);
 *   plane(200);
 * }
 * </code>
 * </div>
 *
 * @alt
 * Rotating view of many images umbrella and grid roof on a 3d plane
 * black canvas
 * black canvas
 *
 */
p5.prototype.texture = function(tex) {
  this._renderer.GL.depthMask(true);
  this._renderer.GL.enable(this._renderer.GL.BLEND);
  this._renderer.GL.blendFunc(
    this._renderer.GL.SRC_ALPHA,
    this._renderer.GL.ONE_MINUS_SRC_ALPHA
  );

  this._renderer.drawMode = constants.TEXTURE;
  var shader = this._renderer._useLightShader();
  shader.setUniform('uSpecular', false);
  shader.setUniform('isTexture', true);
  shader.setUniform('uSampler', tex);
  this.noStroke();
  return this;
};

/**
 * Ambient material for geometry with a given color. You can view all
 * possible materials in this
 * <a href="https://p5js.org/examples/3d-materials.html">example</a>.
 * @method  ambientMaterial
 * @param  {Number} v1  gray value, red or hue value
 *                         (depending on the current color mode),
 * @param  {Number} [v2] green or saturation value
 * @param  {Number} [v3] blue or brightness value
 * @param  {Number} [a]  opacity
 * @chainable
 * @example
 * <div>
 * <code>
 * function setup() {
 *   createCanvas(100, 100, WEBGL);
 * }
 * function draw() {
 *   background(0);
 *   ambientLight(100);
 *   pointLight(250, 250, 250, 100, 100, 0);
 *   ambientMaterial(250);
 *   sphere(50);
 * }
 * </code>
 * </div>
 *
 * @alt
 * radiating light source from top right of canvas
 *
 */
/**
 * @method  ambientMaterial
 * @param  {Number[]|String|p5.Color} color  color, color Array, or CSS color string
 * @chainable
 */
p5.prototype.ambientMaterial = function(v1, v2, v3, a) {
  var color = p5.prototype.color.apply(this, arguments);
  this._renderer.curFillColor = color._array;

  var shader = this._renderer._useLightShader();
  shader.setUniform('uMaterialColor', this._renderer.curFillColor);
  shader.setUniform('uSpecular', false);
  shader.setUniform('isTexture', false);
  return this;
};

/**
 * Specular material for geometry with a given color. You can view all
 * possible materials in this
 * <a href="https://p5js.org/examples/3d-materials.html">example</a>.
 * @method specularMaterial
 * @param  {Number} v1  gray value, red or hue value
 *                       (depending on the current color mode),
 * @param  {Number} [v2] green or saturation value
 * @param  {Number} [v3] blue or brightness value
 * @param  {Number} [a]  opacity
 * @chainable
 * @example
 * <div>
 * <code>
 * function setup() {
 *   createCanvas(100, 100, WEBGL);
 * }
 * function draw() {
 *   background(0);
 *   ambientLight(100);
 *   pointLight(250, 250, 250, 100, 100, 0);
 *   specularMaterial(250);
 *   sphere(50);
 * }
 * </code>
 * </div>
 *
 * @alt
 * diffused radiating light source from top right of canvas
 *
 */
/**
 * @method specularMaterial
 * @param  {Number[]|String|p5.Color} color color Array, or CSS color string
 * @chainable
 */
p5.prototype.specularMaterial = function(v1, v2, v3, a) {
  var color = p5.prototype.color.apply(this, arguments);
  this._renderer.curFillColor = color._array;

  var shader = this._renderer._useLightShader();
  shader.setUniform('uMaterialColor', this._renderer.curFillColor);
  shader.setUniform('uSpecular', true);
  shader.setUniform('isTexture', false);
  return this;
};

/**
 * @private blends colors according to color components.
 * If alpha value is less than 1, we need to enable blending
 * on our gl context.  Otherwise opaque objects need to a depthMask.
 * @param  {Number[]} color [description]
 * @return {Number[]]}  Normalized numbers array
 */
p5.RendererGL.prototype._applyColorBlend = function(colors) {
  var gl = this.GL;
  if (colors[colors.length - 1] < 1.0) {
    gl.depthMask(false);
    gl.enable(gl.BLEND);
    gl.blendEquation(gl.FUNC_ADD);
    gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);
  } else {
    gl.depthMask(true);
    gl.disable(gl.BLEND);
  }
  return colors;
};

module.exports = p5;

},{"../core/constants":21,"../core/core":22,"./p5.Texture":75}],69:[function(_dereq_,module,exports){
//some of the functions are adjusted from Three.js(http://threejs.org)

'use strict';

var p5 = _dereq_('../core/core');
/**
 * p5 Geometry class
 * @class p5.Geometry
 * @constructor
 * @param  {function | Object} vertData callback function or Object
 *                     containing routine(s) for vertex data generation
 * @param  {Integer} [detailX] number of vertices on horizontal surface
 * @param  {Integer} [detailY] number of vertices on horizontal surface
 * @param {function} [callback] function to call upon object instantiation.
 *
 */
p5.Geometry = function(detailX, detailY, callback) {
  //an array containing every vertex
  //@type [p5.Vector]
  this.vertices = [];

  //an array containing every vertex for stroke drawing
  this.lineVertices = [];

  //an array 1 normal per lineVertex with
  //final position representing which direction to
  //displace for strokeWeight
  //[[0,0,-1,1], [0,1,0,-1] ...];
  this.lineNormals = [];

  //an array containing 1 normal per vertex
  //@type [p5.Vector]
  //[p5.Vector, p5.Vector, p5.Vector,p5.Vector, p5.Vector, p5.Vector,...]
  this.vertexNormals = [];
  //an array containing each three vertex indices that form a face
  //[[0, 1, 2], [2, 1, 3], ...]
  this.faces = [];
  //a 2D array containing uvs for every vertex
  //[[0.0,0.0],[1.0,0.0], ...]
  this.uvs = [];
  // a 2D array containing edge connectivity pattern for create line vertices
  //based on faces for most objects;
  this.edges = [];
  this.detailX = detailX !== undefined ? detailX : 1;
  this.detailY = detailY !== undefined ? detailY : 1;
  if (callback instanceof Function) {
    callback.call(this);
  }
  this.name = 'p5.Geometry'; // for friendly debugger system

  return this; // TODO: is this a constructor?
};

/**
 * @method computeFaces
 * @chainable
 */
p5.Geometry.prototype.computeFaces = function() {
  var sliceCount = this.detailX + 1;
  var a, b, c, d;
  for (var i = 0; i < this.detailY; i++) {
    for (var j = 0; j < this.detailX; j++) {
      a = i * sliceCount + j; // + offset;
      b = i * sliceCount + j + 1; // + offset;
      c = (i + 1) * sliceCount + j + 1; // + offset;
      d = (i + 1) * sliceCount + j; // + offset;
      this.faces.push([a, b, d]);
      this.faces.push([d, b, c]);
    }
  }
  return this;
};

p5.Geometry.prototype._getFaceNormal = function(faceId) {
  //This assumes that vA->vB->vC is a counter-clockwise ordering
  var face = this.faces[faceId];
  var vA = this.vertices[face[0]];
  var vB = this.vertices[face[1]];
  var vC = this.vertices[face[2]];
  var ab = p5.Vector.sub(vB, vA);
  var ac = p5.Vector.sub(vC, vA);
  var n = p5.Vector.cross(ab, ac);
  var ln = p5.Vector.mag(n);
  var sinAlpha = ln / (p5.Vector.mag(ab) * p5.Vector.mag(ac));
  return n.mult(Math.asin(sinAlpha) / ln);
};
/**
 * computes smooth normals per vertex as an average of each
 * face.
 * @method computeNormals
 * @chainable
 */
p5.Geometry.prototype.computeNormals = function() {
  var normals = [];
  for (var v = 0; v < this.vertices.length; v++) {
    var normal = new p5.Vector();
    for (var i = 0; i < this.faces.length; i++) {
      //if our face contains a given vertex
      //calculate an average of the normals
      //of the triangles adjacent to that vertex
      if (
        this.faces[i][0] === v ||
        this.faces[i][1] === v ||
        this.faces[i][2] === v
      ) {
        var faceNormal = normals[i] || (normals[i] = this._getFaceNormal(i));
        normal = normal.add(faceNormal);
      }
    }
    normal = normal.normalize();
    this.vertexNormals.push(normal);
  }
  return this;
};

/**
 * Averages the vertex normals. Used in curved
 * surfaces
 * @method averageNormals
 * @chainable
 */
p5.Geometry.prototype.averageNormals = function() {
  for (var i = 0; i <= this.detailY; i++) {
    var offset = this.detailX + 1;
    var temp = p5.Vector.add(
      this.vertexNormals[i * offset],
      this.vertexNormals[i * offset + this.detailX]
    );

    temp = p5.Vector.div(temp, 2);
    this.vertexNormals[i * offset] = temp;
    this.vertexNormals[i * offset + this.detailX] = temp;
  }
  return this;
};

/**
 * Averages pole normals.  Used in spherical primitives
 * @method averagePoleNormals
 * @chainable
 */
p5.Geometry.prototype.averagePoleNormals = function() {
  //average the north pole
  var sum = new p5.Vector(0, 0, 0);
  for (var i = 0; i < this.detailX; i++) {
    sum.add(this.vertexNormals[i]);
  }
  sum = p5.Vector.div(sum, this.detailX);

  for (i = 0; i < this.detailX; i++) {
    this.vertexNormals[i] = sum;
  }

  //average the south pole
  sum = new p5.Vector(0, 0, 0);
  for (
    i = this.vertices.length - 1;
    i > this.vertices.length - 1 - this.detailX;
    i--
  ) {
    sum.add(this.vertexNormals[i]);
  }
  sum = p5.Vector.div(sum, this.detailX);

  for (
    i = this.vertices.length - 1;
    i > this.vertices.length - 1 - this.detailX;
    i--
  ) {
    this.vertexNormals[i] = sum;
  }
  return this;
};

/**
 * Create a 2D array for establishing stroke connections
 * @private
 * @return {p5.Geometry}
 */
p5.Geometry.prototype._makeTriangleEdges = function() {
  if (Array.isArray(this.strokeIndices)) {
    for (var i = 0, max = this.strokeIndices.length; i < max; i++) {
      this.edges.push(this.strokeIndices[i]);
    }
  } else {
    for (var j = 0; j < this.faces.length; j++) {
      this.edges.push([this.faces[j][0], this.faces[j][1]]);
      this.edges.push([this.faces[j][1], this.faces[j][2]]);
      this.edges.push([this.faces[j][2], this.faces[j][0]]);
    }
  }
  return this;
};

/**
 * Create 4 vertices for each stroke line, two at the beginning position
 * and two at the end position. These vertices are displaced relative to
 * that line's normal on the GPU
 * @private
 * @return {p5.Geometry}
 */
p5.RendererGL.prototype._edgesToVertices = function(geom) {
  geom.lineVertices = [];
  for (var i = 0; i < geom.edges.length; i++) {
    var begin = geom.vertices[geom.edges[i][0]];
    var end = geom.vertices[geom.edges[i][1]];
    var dir = end
      .copy()
      .sub(begin)
      .normalize();
    var a = begin.array();
    var b = begin.array();
    var c = end.array();
    var d = end.array();
    var dirAdd = dir.array();
    var dirSub = dir.array();
    // below is used to displace the pair of vertices at beginning and end
    // in opposite directions
    dirAdd.push(1);
    dirSub.push(-1);
    geom.lineNormals.push(dirAdd, dirSub, dirAdd, dirAdd, dirSub, dirSub);
    geom.lineVertices.push(a, b, c, c, b, d);
  }
};

/**
 * Modifies all vertices to be centered within the range -100 to 100.
 * @method normalize
 * @chainable
 */
p5.Geometry.prototype.normalize = function() {
  if (this.vertices.length > 0) {
    // Find the corners of our bounding box
    var maxPosition = this.vertices[0].copy();
    var minPosition = this.vertices[0].copy();

    for (var i = 0; i < this.vertices.length; i++) {
      maxPosition.x = Math.max(maxPosition.x, this.vertices[i].x);
      minPosition.x = Math.min(minPosition.x, this.vertices[i].x);
      maxPosition.y = Math.max(maxPosition.y, this.vertices[i].y);
      minPosition.y = Math.min(minPosition.y, this.vertices[i].y);
      maxPosition.z = Math.max(maxPosition.z, this.vertices[i].z);
      minPosition.z = Math.min(minPosition.z, this.vertices[i].z);
    }

    var center = p5.Vector.lerp(maxPosition, minPosition, 0.5);
    var dist = p5.Vector.sub(maxPosition, minPosition);
    var longestDist = Math.max(Math.max(dist.x, dist.y), dist.z);
    var scale = 200 / longestDist;

    for (i = 0; i < this.vertices.length; i++) {
      this.vertices[i].sub(center);
      this.vertices[i].mult(scale);
    }
  }
  return this;
};

module.exports = p5.Geometry;

},{"../core/core":22}],70:[function(_dereq_,module,exports){
/**
 * @requires constants
 * @todo see methods below needing further implementation.
 * future consideration: implement SIMD optimizations
 * when browser compatibility becomes available
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/
 *   Reference/Global_Objects/SIMD
 */

'use strict';

var p5 = _dereq_('../core/core');
var polarGeometry = _dereq_('../math/polargeometry');
var constants = _dereq_('../core/constants');

var GLMAT_ARRAY_TYPE = Array;
var isMatrixArray = function(x) {
  return x instanceof Array;
};
if (typeof Float32Array !== 'undefined') {
  GLMAT_ARRAY_TYPE = Float32Array;
  isMatrixArray = function(x) {
    return x instanceof Array || x instanceof Float32Array;
  };
}

/**
 * A class to describe a 4x4 matrix
 * for model and view matrix manipulation in the p5js webgl renderer.
 * @class p5.Matrix
 * @private
 * @constructor
 * @param {Array} [mat4] array literal of our 4x4 matrix
 */
p5.Matrix = function() {
  var args = new Array(arguments.length);
  for (var i = 0; i < args.length; ++i) {
    args[i] = arguments[i];
  }

  // This is default behavior when object
  // instantiated using createMatrix()
  // @todo implement createMatrix() in core/math.js
  if (args.length && args[args.length - 1] instanceof p5) {
    this.p5 = args[args.length - 1];
  }

  if (args[0] === 'mat3') {
    this.mat3 = Array.isArray(args[1])
      ? args[1]
      : new GLMAT_ARRAY_TYPE([1, 0, 0, 0, 1, 0, 0, 0, 1]);
  } else {
    this.mat4 = Array.isArray(args[0])
      ? args[0]
      : new GLMAT_ARRAY_TYPE([1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]);
  }

  this.name = 'p5.Matrix'; // for friendly debugger system
  return this;
};

/**
 * Sets the x, y, and z component of the vector using two or three separate
 * variables, the data from a p5.Matrix, or the values from a float array.
 *
 * @method set
 * @param {p5.Matrix|Float32Array|Number[]} [inMatrix] the input p5.Matrix or
 *                                     an Array of length 16
 * @chainable
 */
/**
 * @method set
 * @param {Number[]} elements 16 numbers passed by value to avoid
 *                                     array copying.
 * @chainable
 */
p5.Matrix.prototype.set = function(inMatrix) {
  if (inMatrix instanceof p5.Matrix) {
    this.mat4 = inMatrix.mat4;
    return this;
  } else if (isMatrixArray(inMatrix)) {
    this.mat4 = inMatrix;
    return this;
  } else if (arguments.length === 16) {
    this.mat4[0] = arguments[0];
    this.mat4[1] = arguments[1];
    this.mat4[2] = arguments[2];
    this.mat4[3] = arguments[3];
    this.mat4[4] = arguments[4];
    this.mat4[5] = arguments[5];
    this.mat4[6] = arguments[6];
    this.mat4[7] = arguments[7];
    this.mat4[8] = arguments[8];
    this.mat4[9] = arguments[9];
    this.mat4[10] = arguments[10];
    this.mat4[11] = arguments[11];
    this.mat4[12] = arguments[12];
    this.mat4[13] = arguments[13];
    this.mat4[14] = arguments[14];
    this.mat4[15] = arguments[15];
  }
  return this;
};

/**
 * Gets a copy of the vector, returns a p5.Matrix object.
 *
 * @method get
 * @return {p5.Matrix} the copy of the p5.Matrix object
 */
p5.Matrix.prototype.get = function() {
  return new p5.Matrix(this.mat4, this.p5);
};

/**
 * return a copy of a matrix
 * @method copy
 * @return {p5.Matrix}   the result matrix
 */
p5.Matrix.prototype.copy = function() {
  var copied = new p5.Matrix(this.p5);
  copied.mat4[0] = this.mat4[0];
  copied.mat4[1] = this.mat4[1];
  copied.mat4[2] = this.mat4[2];
  copied.mat4[3] = this.mat4[3];
  copied.mat4[4] = this.mat4[4];
  copied.mat4[5] = this.mat4[5];
  copied.mat4[6] = this.mat4[6];
  copied.mat4[7] = this.mat4[7];
  copied.mat4[8] = this.mat4[8];
  copied.mat4[9] = this.mat4[9];
  copied.mat4[10] = this.mat4[10];
  copied.mat4[11] = this.mat4[11];
  copied.mat4[12] = this.mat4[12];
  copied.mat4[13] = this.mat4[13];
  copied.mat4[14] = this.mat4[14];
  copied.mat4[15] = this.mat4[15];
  return copied;
};

/**
 * return an identity matrix
 * @method identity
 * @return {p5.Matrix}   the result matrix
 */
p5.Matrix.identity = function(pInst) {
  return new p5.Matrix(pInst);
};

/**
 * transpose according to a given matrix
 * @method transpose
 * @param  {p5.Matrix|Float32Array|Number[]} a  the matrix to be
 *                                               based on to transpose
 * @chainable
 */
p5.Matrix.prototype.transpose = function(a) {
  var a01, a02, a03, a12, a13, a23;
  if (a instanceof p5.Matrix) {
    a01 = a.mat4[1];
    a02 = a.mat4[2];
    a03 = a.mat4[3];
    a12 = a.mat4[6];
    a13 = a.mat4[7];
    a23 = a.mat4[11];

    this.mat4[0] = a.mat4[0];
    this.mat4[1] = a.mat4[4];
    this.mat4[2] = a.mat4[8];
    this.mat4[3] = a.mat4[12];
    this.mat4[4] = a01;
    this.mat4[5] = a.mat4[5];
    this.mat4[6] = a.mat4[9];
    this.mat4[7] = a.mat4[13];
    this.mat4[8] = a02;
    this.mat4[9] = a12;
    this.mat4[10] = a.mat4[10];
    this.mat4[11] = a.mat4[14];
    this.mat4[12] = a03;
    this.mat4[13] = a13;
    this.mat4[14] = a23;
    this.mat4[15] = a.mat4[15];
  } else if (isMatrixArray(a)) {
    a01 = a[1];
    a02 = a[2];
    a03 = a[3];
    a12 = a[6];
    a13 = a[7];
    a23 = a[11];

    this.mat4[0] = a[0];
    this.mat4[1] = a[4];
    this.mat4[2] = a[8];
    this.mat4[3] = a[12];
    this.mat4[4] = a01;
    this.mat4[5] = a[5];
    this.mat4[6] = a[9];
    this.mat4[7] = a[13];
    this.mat4[8] = a02;
    this.mat4[9] = a12;
    this.mat4[10] = a[10];
    this.mat4[11] = a[14];
    this.mat4[12] = a03;
    this.mat4[13] = a13;
    this.mat4[14] = a23;
    this.mat4[15] = a[15];
  }
  return this;
};

/**
 * invert  matrix according to a give matrix
 * @method invert
 * @param  {p5.Matrix|Float32Array|Number[]} a   the matrix to be
 *                                                based on to invert
 * @chainable
 */
p5.Matrix.prototype.invert = function(a) {
  var a00, a01, a02, a03, a10, a11, a12, a13;
  var a20, a21, a22, a23, a30, a31, a32, a33;
  if (a instanceof p5.Matrix) {
    a00 = a.mat4[0];
    a01 = a.mat4[1];
    a02 = a.mat4[2];
    a03 = a.mat4[3];
    a10 = a.mat4[4];
    a11 = a.mat4[5];
    a12 = a.mat4[6];
    a13 = a.mat4[7];
    a20 = a.mat4[8];
    a21 = a.mat4[9];
    a22 = a.mat4[10];
    a23 = a.mat4[11];
    a30 = a.mat4[12];
    a31 = a.mat4[13];
    a32 = a.mat4[14];
    a33 = a.mat4[15];
  } else if (isMatrixArray(a)) {
    a00 = a[0];
    a01 = a[1];
    a02 = a[2];
    a03 = a[3];
    a10 = a[4];
    a11 = a[5];
    a12 = a[6];
    a13 = a[7];
    a20 = a[8];
    a21 = a[9];
    a22 = a[10];
    a23 = a[11];
    a30 = a[12];
    a31 = a[13];
    a32 = a[14];
    a33 = a[15];
  }
  var b00 = a00 * a11 - a01 * a10;
  var b01 = a00 * a12 - a02 * a10;
  var b02 = a00 * a13 - a03 * a10;
  var b03 = a01 * a12 - a02 * a11;
  var b04 = a01 * a13 - a03 * a11;
  var b05 = a02 * a13 - a03 * a12;
  var b06 = a20 * a31 - a21 * a30;
  var b07 = a20 * a32 - a22 * a30;
  var b08 = a20 * a33 - a23 * a30;
  var b09 = a21 * a32 - a22 * a31;
  var b10 = a21 * a33 - a23 * a31;
  var b11 = a22 * a33 - a23 * a32;

  // Calculate the determinant
  var det =
    b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;

  if (!det) {
    return null;
  }
  det = 1.0 / det;

  this.mat4[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
  this.mat4[1] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
  this.mat4[2] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
  this.mat4[3] = (a22 * b04 - a21 * b05 - a23 * b03) * det;
  this.mat4[4] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
  this.mat4[5] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
  this.mat4[6] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
  this.mat4[7] = (a20 * b05 - a22 * b02 + a23 * b01) * det;
  this.mat4[8] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
  this.mat4[9] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
  this.mat4[10] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
  this.mat4[11] = (a21 * b02 - a20 * b04 - a23 * b00) * det;
  this.mat4[12] = (a11 * b07 - a10 * b09 - a12 * b06) * det;
  this.mat4[13] = (a00 * b09 - a01 * b07 + a02 * b06) * det;
  this.mat4[14] = (a31 * b01 - a30 * b03 - a32 * b00) * det;
  this.mat4[15] = (a20 * b03 - a21 * b01 + a22 * b00) * det;

  return this;
};

/**
 * Inverts a 3x3 matrix
 * @method invert3x3
 * @chainable
 */
p5.Matrix.prototype.invert3x3 = function() {
  var a00 = this.mat3[0];
  var a01 = this.mat3[1];
  var a02 = this.mat3[2];
  var a10 = this.mat3[3];
  var a11 = this.mat3[4];
  var a12 = this.mat3[5];
  var a20 = this.mat3[6];
  var a21 = this.mat3[7];
  var a22 = this.mat3[8];
  var b01 = a22 * a11 - a12 * a21;
  var b11 = -a22 * a10 + a12 * a20;
  var b21 = a21 * a10 - a11 * a20;

  // Calculate the determinant
  var det = a00 * b01 + a01 * b11 + a02 * b21;
  if (!det) {
    return null;
  }
  det = 1.0 / det;
  this.mat3[0] = b01 * det;
  this.mat3[1] = (-a22 * a01 + a02 * a21) * det;
  this.mat3[2] = (a12 * a01 - a02 * a11) * det;
  this.mat3[3] = b11 * det;
  this.mat3[4] = (a22 * a00 - a02 * a20) * det;
  this.mat3[5] = (-a12 * a00 + a02 * a10) * det;
  this.mat3[6] = b21 * det;
  this.mat3[7] = (-a21 * a00 + a01 * a20) * det;
  this.mat3[8] = (a11 * a00 - a01 * a10) * det;
  return this;
};

/**
 * transposes a 3x3 p5.Matrix by a mat3
 * @method transpose3x3
 * @param  {Number[]} mat3 1-dimensional array
 * @chainable
 */
p5.Matrix.prototype.transpose3x3 = function(mat3) {
  var a01 = mat3[1],
    a02 = mat3[2],
    a12 = mat3[5];
  this.mat3[1] = mat3[3];
  this.mat3[2] = mat3[6];
  this.mat3[3] = a01;
  this.mat3[5] = mat3[7];
  this.mat3[6] = a02;
  this.mat3[7] = a12;
  return this;
};

/**
 * converts a 4x4 matrix to its 3x3 inverse tranform
 * commonly used in MVMatrix to NMatrix conversions.
 * @method invertTranspose
 * @param  {p5.Matrix} mat4 the matrix to be based on to invert
 * @chainable
 * @todo  finish implementation
 */
p5.Matrix.prototype.inverseTranspose = function(matrix) {
  if (this.mat3 === undefined) {
    console.error('sorry, this function only works with mat3');
  } else {
    //convert mat4 -> mat3
    this.mat3[0] = matrix.mat4[0];
    this.mat3[1] = matrix.mat4[1];
    this.mat3[2] = matrix.mat4[2];
    this.mat3[3] = matrix.mat4[4];
    this.mat3[4] = matrix.mat4[5];
    this.mat3[5] = matrix.mat4[6];
    this.mat3[6] = matrix.mat4[8];
    this.mat3[7] = matrix.mat4[9];
    this.mat3[8] = matrix.mat4[10];
  }

  var inverse = this.invert3x3();
  // check inverse succeded
  if (inverse) {
    inverse.transpose3x3(this.mat3);
  } else {
    // in case of singularity, just zero the matrix
    for (var i = 0; i < 9; i++) {
      this.mat3[i] = 0;
    }
  }
  return this;
};

/**
 * inspired by Toji's mat4 determinant
 * @method determinant
 * @return {Number} Determinant of our 4x4 matrix
 */
p5.Matrix.prototype.determinant = function() {
  var d00 = this.mat4[0] * this.mat4[5] - this.mat4[1] * this.mat4[4],
    d01 = this.mat4[0] * this.mat4[6] - this.mat4[2] * this.mat4[4],
    d02 = this.mat4[0] * this.mat4[7] - this.mat4[3] * this.mat4[4],
    d03 = this.mat4[1] * this.mat4[6] - this.mat4[2] * this.mat4[5],
    d04 = this.mat4[1] * this.mat4[7] - this.mat4[3] * this.mat4[5],
    d05 = this.mat4[2] * this.mat4[7] - this.mat4[3] * this.mat4[6],
    d06 = this.mat4[8] * this.mat4[13] - this.mat4[9] * this.mat4[12],
    d07 = this.mat4[8] * this.mat4[14] - this.mat4[10] * this.mat4[12],
    d08 = this.mat4[8] * this.mat4[15] - this.mat4[11] * this.mat4[12],
    d09 = this.mat4[9] * this.mat4[14] - this.mat4[10] * this.mat4[13],
    d10 = this.mat4[9] * this.mat4[15] - this.mat4[11] * this.mat4[13],
    d11 = this.mat4[10] * this.mat4[15] - this.mat4[11] * this.mat4[14];

  // Calculate the determinant
  return d00 * d11 - d01 * d10 + d02 * d09 + d03 * d08 - d04 * d07 + d05 * d06;
};

/**
 * multiply two mat4s
 * @method mult
 * @param {p5.Matrix|Float32Array|Number[]} multMatrix The matrix
 *                                                we want to multiply by
 * @chainable
 */
p5.Matrix.prototype.mult = function(multMatrix) {
  var _src;

  if (multMatrix === this || multMatrix === this.mat4) {
    _src = this.copy().mat4; // only need to allocate in this rare case
  } else if (multMatrix instanceof p5.Matrix) {
    _src = multMatrix.mat4;
  } else if (isMatrixArray(multMatrix)) {
    _src = multMatrix;
  } else {
    return; // nothing to do.
  }

  // each row is used for the multiplier
  var b0 = this.mat4[0],
    b1 = this.mat4[1],
    b2 = this.mat4[2],
    b3 = this.mat4[3];
  this.mat4[0] = b0 * _src[0] + b1 * _src[4] + b2 * _src[8] + b3 * _src[12];
  this.mat4[1] = b0 * _src[1] + b1 * _src[5] + b2 * _src[9] + b3 * _src[13];
  this.mat4[2] = b0 * _src[2] + b1 * _src[6] + b2 * _src[10] + b3 * _src[14];
  this.mat4[3] = b0 * _src[3] + b1 * _src[7] + b2 * _src[11] + b3 * _src[15];

  b0 = this.mat4[4];
  b1 = this.mat4[5];
  b2 = this.mat4[6];
  b3 = this.mat4[7];
  this.mat4[4] = b0 * _src[0] + b1 * _src[4] + b2 * _src[8] + b3 * _src[12];
  this.mat4[5] = b0 * _src[1] + b1 * _src[5] + b2 * _src[9] + b3 * _src[13];
  this.mat4[6] = b0 * _src[2] + b1 * _src[6] + b2 * _src[10] + b3 * _src[14];
  this.mat4[7] = b0 * _src[3] + b1 * _src[7] + b2 * _src[11] + b3 * _src[15];

  b0 = this.mat4[8];
  b1 = this.mat4[9];
  b2 = this.mat4[10];
  b3 = this.mat4[11];
  this.mat4[8] = b0 * _src[0] + b1 * _src[4] + b2 * _src[8] + b3 * _src[12];
  this.mat4[9] = b0 * _src[1] + b1 * _src[5] + b2 * _src[9] + b3 * _src[13];
  this.mat4[10] = b0 * _src[2] + b1 * _src[6] + b2 * _src[10] + b3 * _src[14];
  this.mat4[11] = b0 * _src[3] + b1 * _src[7] + b2 * _src[11] + b3 * _src[15];

  b0 = this.mat4[12];
  b1 = this.mat4[13];
  b2 = this.mat4[14];
  b3 = this.mat4[15];
  this.mat4[12] = b0 * _src[0] + b1 * _src[4] + b2 * _src[8] + b3 * _src[12];
  this.mat4[13] = b0 * _src[1] + b1 * _src[5] + b2 * _src[9] + b3 * _src[13];
  this.mat4[14] = b0 * _src[2] + b1 * _src[6] + b2 * _src[10] + b3 * _src[14];
  this.mat4[15] = b0 * _src[3] + b1 * _src[7] + b2 * _src[11] + b3 * _src[15];

  return this;
};

/**
 * scales a p5.Matrix by scalars or a vector
 * @method scale
 * @param  {p5.Vector|Float32Array|Number[]} s vector to scale by
 * @chainable
 */
p5.Matrix.prototype.scale = function(x, y, z) {
  if (x instanceof p5.Vector) {
    // x is a vector, extract the components from it.
    y = x.y;
    z = x.z;
    x = x.x; // must be last
  } else if (x instanceof Array) {
    // x is an array, extract the components from it.
    y = x[1];
    z = x[2];
    x = x[0]; // must be last
  }

  this.mat4[0] *= x;
  this.mat4[1] *= x;
  this.mat4[2] *= x;
  this.mat4[3] *= x;
  this.mat4[4] *= y;
  this.mat4[5] *= y;
  this.mat4[6] *= y;
  this.mat4[7] *= y;
  this.mat4[8] *= z;
  this.mat4[9] *= z;
  this.mat4[10] *= z;
  this.mat4[11] *= z;

  return this;
};

/**
 * rotate our Matrix around an axis by the given angle.
 * @method rotate
 * @param  {Number} a The angle of rotation in radians
 * @param  {p5.Vector|Number[]} axis  the axis(es) to rotate around
 * @chainable
 * inspired by Toji's gl-matrix lib, mat4 rotation
 */
p5.Matrix.prototype.rotate = function(a, x, y, z) {
  var _a, len;

  if (this.p5 && this.p5._angleMode === constants.DEGREES) {
    _a = polarGeometry.degreesToRadians(a);
  } else {
    _a = a;
  }
  if (x instanceof p5.Vector) {
    // x is a vector, extract the components from it.
    y = x.y;
    z = x.z;
    x = x.x; //must be last
  } else if (x instanceof Array) {
    // x is an array, extract the components from it.
    y = x[1];
    z = x[2];
    x = x[0]; //must be last
  }

  len = Math.sqrt(x * x + y * y + z * z);
  x *= 1 / len;
  y *= 1 / len;
  z *= 1 / len;

  var a00 = this.mat4[0];
  var a01 = this.mat4[1];
  var a02 = this.mat4[2];
  var a03 = this.mat4[3];
  var a10 = this.mat4[4];
  var a11 = this.mat4[5];
  var a12 = this.mat4[6];
  var a13 = this.mat4[7];
  var a20 = this.mat4[8];
  var a21 = this.mat4[9];
  var a22 = this.mat4[10];
  var a23 = this.mat4[11];

  //sin,cos, and tan of respective angle
  var sA = Math.sin(_a);
  var cA = Math.cos(_a);
  var tA = 1 - cA;
  // Construct the elements of the rotation matrix
  var b00 = x * x * tA + cA;
  var b01 = y * x * tA + z * sA;
  var b02 = z * x * tA - y * sA;
  var b10 = x * y * tA - z * sA;
  var b11 = y * y * tA + cA;
  var b12 = z * y * tA + x * sA;
  var b20 = x * z * tA + y * sA;
  var b21 = y * z * tA - x * sA;
  var b22 = z * z * tA + cA;

  // rotation-specific matrix multiplication
  this.mat4[0] = a00 * b00 + a10 * b01 + a20 * b02;
  this.mat4[1] = a01 * b00 + a11 * b01 + a21 * b02;
  this.mat4[2] = a02 * b00 + a12 * b01 + a22 * b02;
  this.mat4[3] = a03 * b00 + a13 * b01 + a23 * b02;
  this.mat4[4] = a00 * b10 + a10 * b11 + a20 * b12;
  this.mat4[5] = a01 * b10 + a11 * b11 + a21 * b12;
  this.mat4[6] = a02 * b10 + a12 * b11 + a22 * b12;
  this.mat4[7] = a03 * b10 + a13 * b11 + a23 * b12;
  this.mat4[8] = a00 * b20 + a10 * b21 + a20 * b22;
  this.mat4[9] = a01 * b20 + a11 * b21 + a21 * b22;
  this.mat4[10] = a02 * b20 + a12 * b21 + a22 * b22;
  this.mat4[11] = a03 * b20 + a13 * b21 + a23 * b22;

  return this;
};

/**
 * @todo  finish implementing this method!
 * translates
 * @method translate
 * @param  {Number[]} v vector to translate by
 * @chainable
 */
p5.Matrix.prototype.translate = function(v) {
  var x = v[0],
    y = v[1],
    z = v[2] || 0;
  this.mat4[12] += this.mat4[0] * x + this.mat4[4] * y + this.mat4[8] * z;
  this.mat4[13] += this.mat4[1] * x + this.mat4[5] * y + this.mat4[9] * z;
  this.mat4[14] += this.mat4[2] * x + this.mat4[6] * y + this.mat4[10] * z;
  this.mat4[15] += this.mat4[3] * x + this.mat4[7] * y + this.mat4[11] * z;
};

p5.Matrix.prototype.rotateX = function(a) {
  this.rotate(a, 1, 0, 0);
};
p5.Matrix.prototype.rotateY = function(a) {
  this.rotate(a, 0, 1, 0);
};
p5.Matrix.prototype.rotateZ = function(a) {
  this.rotate(a, 0, 0, 1);
};

/**
 * sets the perspective matrix
 * @method perspective
 * @param  {Number} fovy   [description]
 * @param  {Number} aspect [description]
 * @param  {Number} near   near clipping plane
 * @param  {Number} far    far clipping plane
 * @chainable
 */
p5.Matrix.prototype.perspective = function(fovy, aspect, near, far) {
  var f = 1.0 / Math.tan(fovy / 2),
    nf = 1 / (near - far);

  this.mat4[0] = f / aspect;
  this.mat4[1] = 0;
  this.mat4[2] = 0;
  this.mat4[3] = 0;
  this.mat4[4] = 0;
  this.mat4[5] = f;
  this.mat4[6] = 0;
  this.mat4[7] = 0;
  this.mat4[8] = 0;
  this.mat4[9] = 0;
  this.mat4[10] = (far + near) * nf;
  this.mat4[11] = -1;
  this.mat4[12] = 0;
  this.mat4[13] = 0;
  this.mat4[14] = 2 * far * near * nf;
  this.mat4[15] = 0;

  return this;
};

/**
 * sets the ortho matrix
 * @method ortho
 * @param  {Number} left   [description]
 * @param  {Number} right  [description]
 * @param  {Number} bottom [description]
 * @param  {Number} top    [description]
 * @param  {Number} near   near clipping plane
 * @param  {Number} far    far clipping plane
 * @chainable
 */
p5.Matrix.prototype.ortho = function(left, right, bottom, top, near, far) {
  var lr = 1 / (left - right),
    bt = 1 / (bottom - top),
    nf = 1 / (near - far);
  this.mat4[0] = -2 * lr;
  this.mat4[1] = 0;
  this.mat4[2] = 0;
  this.mat4[3] = 0;
  this.mat4[4] = 0;
  this.mat4[5] = -2 * bt;
  this.mat4[6] = 0;
  this.mat4[7] = 0;
  this.mat4[8] = 0;
  this.mat4[9] = 0;
  this.mat4[10] = 2 * nf;
  this.mat4[11] = 0;
  this.mat4[12] = (left + right) * lr;
  this.mat4[13] = (top + bottom) * bt;
  this.mat4[14] = (far + near) * nf;
  this.mat4[15] = 1;

  return this;
};

/**
 * PRIVATE
 */
// matrix methods adapted from:
// https://developer.mozilla.org/en-US/docs/Web/WebGL/
// gluPerspective
//
// function _makePerspective(fovy, aspect, znear, zfar){
//    var ymax = znear * Math.tan(fovy * Math.PI / 360.0);
//    var ymin = -ymax;
//    var xmin = ymin * aspect;
//    var xmax = ymax * aspect;
//    return _makeFrustum(xmin, xmax, ymin, ymax, znear, zfar);
//  }

////
//// glFrustum
////
//function _makeFrustum(left, right, bottom, top, znear, zfar){
//  var X = 2*znear/(right-left);
//  var Y = 2*znear/(top-bottom);
//  var A = (right+left)/(right-left);
//  var B = (top+bottom)/(top-bottom);
//  var C = -(zfar+znear)/(zfar-znear);
//  var D = -2*zfar*znear/(zfar-znear);
//  var frustrumMatrix =[
//  X, 0, A, 0,
//  0, Y, B, 0,
//  0, 0, C, D,
//  0, 0, -1, 0
//];
//return frustrumMatrix;
// }

// function _setMVPMatrices(){
////an identity matrix
////@TODO use the p5.Matrix class to abstract away our MV matrices and
///other math
//var _mvMatrix =
//[
//  1.0,0.0,0.0,0.0,
//  0.0,1.0,0.0,0.0,
//  0.0,0.0,1.0,0.0,
//  0.0,0.0,0.0,1.0
//];

module.exports = p5.Matrix;

},{"../core/constants":21,"../core/core":22,"../math/polargeometry":54}],71:[function(_dereq_,module,exports){
/**
 * Welcome to RendererGL Immediate Mode.
 * Immediate mode is used for drawing custom shapes
 * from a set of vertices.  Immediate Mode is activated
 * when you call beginShape() & de-activated when you call endShape().
 * Immediate mode is a style of programming borrowed
 * from OpenGL's (now-deprecated) immediate mode.
 * It differs from p5.js' default, Retained Mode, which caches
 * geometries and buffers on the CPU to reduce the number of webgl
 * draw calls. Retained mode is more efficient & performative,
 * however, Immediate Mode is useful for sketching quick
 * geometric ideas.
 */
'use strict';

var p5 = _dereq_('../core/core');
var constants = _dereq_('../core/constants');

/**
 * Begin shape drawing.  This is a helpful way of generating
 * custom shapes quickly.  However in WEBGL mode, application
 * performance will likely drop as a result of too many calls to
 * beginShape() / endShape().  As a high performance alternative,
 * please use p5.js geometry primitives.
 * @method beginShape
 * @param  {Number} mode webgl primitives mode.  beginShape supports the
 *                       following modes:
 *                       POINTS,LINES,LINE_STRIP,LINE_LOOP,TRIANGLES,
 *                       TRIANGLE_STRIP,and TRIANGLE_FAN.
 * @chainable
 */
p5.RendererGL.prototype.beginShape = function(mode) {
  //default shape mode is line_strip
  this.immediateMode.shapeMode =
    mode !== undefined ? mode : constants.LINE_STRIP;
  //if we haven't yet initialized our
  //immediateMode vertices & buffers, create them now!
  if (this.immediateMode.vertices === undefined) {
    this.immediateMode.vertices = [];
    this.immediateMode.edges = [];
    this.immediateMode.lineVertices = [];
    this.immediateMode.vertexColors = [];
    this.immediateMode.lineNormals = [];
    this.immediateMode.uvCoords = [];
    this.immediateMode.vertexBuffer = this.GL.createBuffer();
    this.immediateMode.colorBuffer = this.GL.createBuffer();
    this.immediateMode.uvBuffer = this.GL.createBuffer();
    this.immediateMode.lineVertexBuffer = this.GL.createBuffer();
    this.immediateMode.lineNormalBuffer = this.GL.createBuffer();
  } else {
    this.immediateMode.vertices.length = 0;
    this.immediateMode.edges.length = 0;
    this.immediateMode.lineVertices.length = 0;
    this.immediateMode.lineNormals.length = 0;
    this.immediateMode.vertexColors.length = 0;
    this.immediateMode.uvCoords.length = 0;
  }
  this.isImmediateDrawing = true;
  return this;
};
/**
 * adds a vertex to be drawn in a custom Shape.
 * @method vertex
 * @param  {Number} x x-coordinate of vertex
 * @param  {Number} y y-coordinate of vertex
 * @param  {Number} z z-coordinate of vertex
 * @chainable
 * @TODO implement handling of p5.Vector args
 */
p5.RendererGL.prototype.vertex = function(x, y) {
  var z, u, v;

  // default to (x, y) mode: all other arugments assumed to be 0.
  z = u = v = 0;

  if (arguments.length === 3) {
    // (x, y, z) mode: (u, v) assumed to be 0.
    z = arguments[2];
  } else if (arguments.length === 4) {
    // (x, y, u, v) mode: z assumed to be 0.
    u = arguments[2];
    v = arguments[3];
  } else if (arguments.length === 5) {
    // (x, y, z, u, v) mode
    z = arguments[2];
    u = arguments[3];
    v = arguments[4];
  }
  var vert = new p5.Vector(x, y, z);
  this.immediateMode.vertices.push(vert);
  var vertexColor = this.curFillColor || [0.5, 0.5, 0.5, 1.0];
  this.immediateMode.vertexColors.push(
    vertexColor[0],
    vertexColor[1],
    vertexColor[2],
    vertexColor[3]
  );

  this.immediateMode.uvCoords.push(u, v);

  return this;
};

/**
 * End shape drawing and render vertices to screen.
 * @chainable
 */
p5.RendererGL.prototype.endShape = function(
  mode,
  isCurve,
  isBezier,
  isQuadratic,
  isContour,
  shapeKind
) {
  this._useImmediateModeShader();

  if (this._doStroke && this.drawMode !== constants.TEXTURE) {
    for (var i = 0; i < this.immediateMode.vertices.length - 1; i++) {
      this.immediateMode.edges.push([i, i + 1]);
    }
    if (mode === constants.CLOSE) {
      this.immediateMode.edges.push([
        this.immediateMode.vertices.length - 1,
        0
      ]);
    }

    this._edgesToVertices(this.immediateMode);
    this._drawStrokeImmediateMode();
  }
  if (this._doFill) {
    this._drawFillImmediateMode(
      mode,
      isCurve,
      isBezier,
      isQuadratic,
      isContour,
      shapeKind
    );
  }
  //clear out our vertexPositions & colors arrays
  //after rendering
  this.immediateMode.vertices.length = 0;
  this.immediateMode.vertexColors.length = 0;
  this.immediateMode.uvCoords.length = 0;
  this.isImmediateDrawing = false;

  return this;
};

p5.RendererGL.prototype._drawFillImmediateMode = function(
  mode,
  isCurve,
  isBezier,
  isQuadratic,
  isContour,
  shapeKind
) {
  var gl = this.GL;
  this.curFillShader.bindShader();

  // initialize the fill shader's 'aPosition' buffer
  if (this.curFillShader.attributes.aPosition) {
    //vertex position Attribute
    this._bindBuffer(
      this.immediateMode.vertexBuffer,
      gl.ARRAY_BUFFER,
      this._vToNArray(this.immediateMode.vertices),
      Float32Array,
      gl.DYNAMIC_DRAW
    );

    this.curFillShader.enableAttrib(
      this.curFillShader.attributes.aPosition.location,
      3,
      gl.FLOAT,
      false,
      0,
      0
    );
  }

  // initialize the fill shader's 'aVertexColor' buffer
  if (
    this.drawMode === constants.FILL &&
    this.curFillShader.attributes.aVertexColor
  ) {
    this._bindBuffer(
      this.immediateMode.colorBuffer,
      gl.ARRAY_BUFFER,
      this.immediateMode.vertexColors,
      Float32Array,
      gl.DYNAMIC_DRAW
    );

    this.curFillShader.enableAttrib(
      this.curFillShader.attributes.aVertexColor.location,
      4,
      gl.FLOAT,
      false,
      0,
      0
    );
  }

  // initialize the fill shader's 'aTexCoord' buffer
  if (
    this.drawMode === constants.TEXTURE &&
    this.curFillShader.attributes.aTexCoord
  ) {
    //texture coordinate Attribute
    this._bindBuffer(
      this.immediateMode.uvBuffer,
      gl.ARRAY_BUFFER,
      this.immediateMode.uvCoords,
      Float32Array,
      gl.DYNAMIC_DRAW
    );

    this.curFillShader.enableAttrib(
      this.curFillShader.attributes.aTexCoord.location,
      2,
      gl.FLOAT,
      false,
      0,
      0
    );
  }

  //if (true || mode) {
  if (this.drawMode === constants.FILL || this.drawMode === constants.TEXTURE) {
    switch (this.immediateMode.shapeMode) {
      case constants.LINE_STRIP:
      case constants.LINES:
      case constants.TRIANGLES:
        this.immediateMode.shapeMode = constants.TRIANGLE_FAN;
        break;
    }
  } else {
    switch (this.immediateMode.shapeMode) {
      case constants.LINE_STRIP:
      case constants.LINES:
        this.immediateMode.shapeMode = constants.LINE_LOOP;
        break;
    }
  }
  //}
  //QUADS & QUAD_STRIP are not supported primitives modes
  //in webgl.
  if (
    this.immediateMode.shapeMode === constants.QUADS ||
    this.immediateMode.shapeMode === constants.QUAD_STRIP
  ) {
    throw new Error(
      'sorry, ' +
        this.immediateMode.shapeMode +
        ' not yet implemented in webgl mode.'
    );
  } else {
    this._applyColorBlend(this.curFillColor);
    gl.enable(gl.BLEND);
    gl.drawArrays(
      this.immediateMode.shapeMode,
      0,
      this.immediateMode.vertices.length
    );
  }
  // todo / optimizations? leave bound until another shader is set?
  this.curFillShader.unbindShader();
};

p5.RendererGL.prototype._drawStrokeImmediateMode = function() {
  var gl = this.GL;
  this.curStrokeShader.bindShader();

  // initialize the stroke shader's 'aPosition' buffer
  if (this.curStrokeShader.attributes.aPosition) {
    this._bindBuffer(
      this.immediateMode.lineVertexBuffer,
      gl.ARRAY_BUFFER,
      this._flatten(this.immediateMode.lineVertices),
      Float32Array,
      gl.STATIC_DRAW
    );

    this.curStrokeShader.enableAttrib(
      this.curStrokeShader.attributes.aPosition.location,
      3,
      gl.FLOAT,
      false,
      0,
      0
    );
  }

  // initialize the stroke shader's 'aDirection' buffer
  if (this.curStrokeShader.attributes.aDirection) {
    this._bindBuffer(
      this.immediateMode.lineNormalBuffer,
      gl.ARRAY_BUFFER,
      this._flatten(this.immediateMode.lineNormals),
      Float32Array,
      gl.STATIC_DRAW
    );
    this.curStrokeShader.enableAttrib(
      this.curStrokeShader.attributes.aDirection.location,
      4,
      gl.FLOAT,
      false,
      0,
      0
    );
  }

  this._applyColorBlend(this.curStrokeColor);
  gl.drawArrays(gl.TRIANGLES, 0, this.immediateMode.lineVertices.length);

  // todo / optimizations? leave bound until another shader is set?
  this.curStrokeShader.unbindShader();
};

module.exports = p5.RendererGL;

},{"../core/constants":21,"../core/core":22}],72:[function(_dereq_,module,exports){
//Retained Mode. The default mode for rendering 3D primitives
//in WEBGL.
'use strict';

var p5 = _dereq_('../core/core');

var hashCount = 0;
/**
 * _initBufferDefaults
 * @private
 * @description initializes buffer defaults. runs each time a new geometry is
 * registered
 * @param  {String} gId  key of the geometry object
 */
p5.RendererGL.prototype._initBufferDefaults = function(gId) {
  this._freeBuffers(gId);

  //@TODO remove this limit on hashes in gHash
  hashCount++;
  if (hashCount > 1000) {
    var key = Object.keys(this.gHash)[0];
    delete this.gHash[key];
    hashCount--;
  }

  //create a new entry in our gHash
  this.gHash[gId] = {};
};

p5.RendererGL.prototype._freeBuffers = function(gId) {
  var geometry = this.gHash[gId];
  if (!geometry) {
    return;
  }

  delete this.gHash[gId];
  hashCount--;

  var gl = this.GL;
  geometry.vertexBuffer && gl.deleteBuffer(geometry.vertexBuffer);
  geometry.normalBuffer && gl.deleteBuffer(geometry.normalBuffer);
  geometry.lineNormalBuffer && gl.deleteBuffer(geometry.lineNormalBuffer);
  geometry.uvBuffer && gl.deleteBuffer(geometry.uvBuffer);
  geometry.indexBuffer && gl.deleteBuffer(geometry.indexBuffer);
  geometry.lineVertexBuffer && gl.deleteBuffer(geometry.lineVertexBuffer);
};
/**
 * createBuffers description
 * @private
 * @param  {String} gId    key of the geometry object
 * @param  {p5.Geometry}  obj contains geometry data
 */
p5.RendererGL.prototype.createBuffers = function(gId, obj) {
  var gl = this.GL;
  this._setDefaultCamera();
  //initialize the gl buffers for our geom groups
  this._initBufferDefaults(gId);

  var geometry = this.gHash[gId];

  geometry.numberOfItems = obj.faces.length * 3;
  geometry.lineVertexCount = obj.lineVertices.length;

  this._useColorShader();

  // initialize the stroke shader's 'aPosition' buffer, if used
  if (this.curStrokeShader.attributes.aPosition) {
    geometry.lineVertexBuffer = gl.createBuffer();

    this._bindBuffer(
      geometry.lineVertexBuffer,
      gl.ARRAY_BUFFER,
      this._flatten(obj.lineVertices),
      Float32Array,
      gl.STATIC_DRAW
    );

    this.curStrokeShader.enableAttrib(
      this.curStrokeShader.attributes.aPosition.location,
      3,
      gl.FLOAT,
      false,
      0,
      0
    );
  }

  // initialize the stroke shader's 'aDirection' buffer, if used
  if (this.curStrokeShader.attributes.aDirection) {
    geometry.lineNormalBuffer = gl.createBuffer();

    this._bindBuffer(
      geometry.lineNormalBuffer,
      gl.ARRAY_BUFFER,
      this._flatten(obj.lineNormals),
      Float32Array,
      gl.STATIC_DRAW
    );

    this.curStrokeShader.enableAttrib(
      this.curStrokeShader.attributes.aDirection.location,
      4,
      gl.FLOAT,
      false,
      0,
      0
    );
  }

  // initialize the fill shader's 'aPosition' buffer, if used
  if (this.curFillShader.attributes.aPosition) {
    geometry.vertexBuffer = gl.createBuffer();

    // allocate space for vertex positions
    this._bindBuffer(
      geometry.vertexBuffer,
      gl.ARRAY_BUFFER,
      this._vToNArray(obj.vertices),
      Float32Array,
      gl.STATIC_DRAW
    );

    this.curFillShader.enableAttrib(
      this.curFillShader.attributes.aPosition.location,
      3,
      gl.FLOAT,
      false,
      0,
      0
    );
  }

  // allocate space for faces
  geometry.indexBuffer = gl.createBuffer();
  this._bindBuffer(
    geometry.indexBuffer,
    gl.ELEMENT_ARRAY_BUFFER,
    this._flatten(obj.faces),
    Uint16Array,
    gl.STATIC_DRAW
  );

  // initialize the fill shader's 'aNormal' buffer, if used
  if (this.curFillShader.attributes.aNormal) {
    geometry.normalBuffer = gl.createBuffer();

    // allocate space for normals
    this._bindBuffer(
      geometry.normalBuffer,
      gl.ARRAY_BUFFER,
      this._vToNArray(obj.vertexNormals),
      Float32Array,
      gl.STATIC_DRAW
    );

    this.curFillShader.enableAttrib(
      this.curFillShader.attributes.aNormal.location,
      3,
      gl.FLOAT,
      false,
      0,
      0
    );
  }

  // initialize the fill shader's 'aTexCoord' buffer, if used
  if (this.curFillShader.attributes.aTexCoord) {
    geometry.uvBuffer = gl.createBuffer();

    // tex coords
    this._bindBuffer(
      geometry.uvBuffer,
      gl.ARRAY_BUFFER,
      this._flatten(obj.uvs),
      Float32Array,
      gl.STATIC_DRAW
    );

    this.curFillShader.enableAttrib(
      this.curFillShader.attributes.aTexCoord.location,
      2,
      gl.FLOAT,
      false,
      0,
      0
    );
  }
  //}
};

/**
 * Draws buffers given a geometry key ID
 * @private
 * @param  {String} gId     ID in our geom hash
 * @chainable
 */
p5.RendererGL.prototype.drawBuffers = function(gId) {
  this._setDefaultCamera();
  var gl = this.GL;
  this._useColorShader();
  var geometry = this.gHash[gId];

  if (this._doStroke && geometry.lineVertexCount > 0) {
    this.curStrokeShader.bindShader();

    // bind the stroke shader's 'aPosition' buffer
    if (geometry.lineVertexBuffer) {
      this._bindBuffer(geometry.lineVertexBuffer, gl.ARRAY_BUFFER);
      this.curStrokeShader.enableAttrib(
        this.curStrokeShader.attributes.aPosition.location,
        3,
        gl.FLOAT,
        false,
        0,
        0
      );
    }

    // bind the stroke shader's 'aDirection' buffer
    if (geometry.lineNormalBuffer) {
      this._bindBuffer(geometry.lineNormalBuffer, gl.ARRAY_BUFFER);
      this.curStrokeShader.enableAttrib(
        this.curStrokeShader.attributes.aDirection.location,
        4,
        gl.FLOAT,
        false,
        0,
        0
      );
    }

    this._applyColorBlend(this.curStrokeColor);
    this._drawArrays(gl.TRIANGLES, gId);
    this.curStrokeShader.unbindShader();
  }

  if (this._doFill !== false) {
    this.curFillShader.bindShader();

    // bind the fill shader's 'aPosition' buffer
    if (geometry.vertexBuffer) {
      //vertex position buffer
      this._bindBuffer(geometry.vertexBuffer, gl.ARRAY_BUFFER);
      this.curFillShader.enableAttrib(
        this.curFillShader.attributes.aPosition.location,
        3,
        gl.FLOAT,
        false,
        0,
        0
      );
    }

    if (geometry.indexBuffer) {
      //vertex index buffer
      this._bindBuffer(geometry.indexBuffer, gl.ELEMENT_ARRAY_BUFFER);
    }

    // bind the fill shader's 'aNormal' buffer
    if (geometry.normalBuffer) {
      this._bindBuffer(geometry.normalBuffer, gl.ARRAY_BUFFER);
      this.curFillShader.enableAttrib(
        this.curFillShader.attributes.aNormal.location,
        3,
        gl.FLOAT,
        false,
        0,
        0
      );
    }

    // bind the fill shader's 'aTexCoord' buffer
    if (geometry.uvBuffer) {
      // uv buffer
      this._bindBuffer(geometry.uvBuffer, gl.ARRAY_BUFFER);
      this.curFillShader.enableAttrib(
        this.curFillShader.attributes.aTexCoord.location,
        2,
        gl.FLOAT,
        false,
        0,
        0
      );
    }

    this._applyColorBlend(this.curFillColor);
    this._drawElements(gl.TRIANGLES, gId);
    this.curFillShader.unbindShader();
  }
  return this;
};

/**
 * Calls drawBuffers() with a scaled model/view matrix.
 *
 * This is used by various 3d primitive methods (in primitives.js, eg. plane,
 * box, torus, etc...) to allow caching of un-scaled geometries. Those
 * geometries are generally created with unit-length dimensions, cached as
 * such, and then scaled appropriately in this method prior to rendering.
 *
 * @private
 * @method drawBuffersScaled
 * @param {String} gId     ID in our geom hash
 * @param {Number} scaleX  the amount to scale in the X direction
 * @param {Number} scaleY  the amount to scale in the Y direction
 * @param {Number} scaleZ  the amount to scale in the Z direction
 */
p5.RendererGL.prototype.drawBuffersScaled = function(
  gId,
  scaleX,
  scaleY,
  scaleZ
) {
  var uMVMatrix = this.uMVMatrix.copy();
  try {
    this.uMVMatrix.scale(scaleX, scaleY, scaleZ);
    this.drawBuffers(gId);
  } finally {
    this.uMVMatrix = uMVMatrix;
  }
};

p5.RendererGL.prototype._drawArrays = function(drawMode, gId) {
  this.GL.drawArrays(drawMode, 0, this.gHash[gId].lineVertexCount);
  return this;
};

p5.RendererGL.prototype._drawElements = function(drawMode, gId) {
  this.GL.drawElements(
    drawMode,
    this.gHash[gId].numberOfItems,
    this.GL.UNSIGNED_SHORT,
    0
  );
};

module.exports = p5.RendererGL;

},{"../core/core":22}],73:[function(_dereq_,module,exports){
'use strict';

var p5 = _dereq_('../core/core');
var constants = _dereq_('../core/constants');
_dereq_('./p5.Shader');
_dereq_('../core/p5.Renderer');
_dereq_('./p5.Matrix');


var uMVMatrixStack = [];
var cameraMatrixStack = [];

var defaultShaders = {
  immediateVert: "attribute vec3 aPosition;\nattribute vec4 aVertexColor;\n\nuniform mat4 uModelViewMatrix;\nuniform mat4 uProjectionMatrix;\nuniform float uResolution;\nuniform float uPointSize;\n\nvarying vec4 vColor;\nvoid main(void) {\n  vec4 positionVec4 = vec4(aPosition, 1.0);\n  gl_Position = uProjectionMatrix * uModelViewMatrix * positionVec4;\n  vColor = aVertexColor;\n  gl_PointSize = uPointSize;\n}\n",
  vertexColorVert: "attribute vec3 aPosition;\nattribute vec4 aVertexColor;\n\nuniform mat4 uModelViewMatrix;\nuniform mat4 uProjectionMatrix;\n\nvarying vec4 vColor;\n\nvoid main(void) {\n  vec4 positionVec4 = vec4(aPosition, 1.0);\n  gl_Position = uProjectionMatrix * uModelViewMatrix * positionVec4;\n  vColor = aVertexColor;\n}\n",
  vertexColorFrag: "precision mediump float;\nvarying vec4 vColor;\nvoid main(void) {\n  gl_FragColor = vColor;\n}",
  normalVert: "attribute vec3 aPosition;\nattribute vec3 aNormal;\nattribute vec2 aTexCoord;\n\nuniform mat4 uModelViewMatrix;\nuniform mat4 uProjectionMatrix;\nuniform mat3 uNormalMatrix;\n\nvarying vec3 vVertexNormal;\nvarying highp vec2 vVertTexCoord;\n\nvoid main(void) {\n  vec4 positionVec4 = vec4(aPosition, 1.0);\n  gl_Position = uProjectionMatrix * uModelViewMatrix * positionVec4;\n  vVertexNormal = normalize(vec3( uNormalMatrix * aNormal ));\n  vVertTexCoord = aTexCoord;\n}\n",
  normalFrag: "precision mediump float;\nvarying vec3 vVertexNormal;\nvoid main(void) {\n  gl_FragColor = vec4(vVertexNormal, 1.0);\n}",
  basicFrag: "precision mediump float;\nvarying vec3 vVertexNormal;\nuniform vec4 uMaterialColor;\nvoid main(void) {\n  gl_FragColor = uMaterialColor;\n}",
  lightVert: "attribute vec3 aPosition;\nattribute vec3 aNormal;\nattribute vec2 aTexCoord;\n\nuniform mat4 uViewMatrix;\nuniform mat4 uModelViewMatrix;\nuniform mat4 uProjectionMatrix;\nuniform mat3 uNormalMatrix;\nuniform int uAmbientLightCount;\nuniform int uDirectionalLightCount;\nuniform int uPointLightCount;\n\nuniform vec3 uAmbientColor[8];\nuniform vec3 uLightingDirection[8];\nuniform vec3 uDirectionalColor[8];\nuniform vec3 uPointLightLocation[8];\nuniform vec3 uPointLightColor[8];\nuniform bool uSpecular;\n\nvarying vec3 vVertexNormal;\nvarying vec2 vVertTexCoord;\nvarying vec3 vLightWeighting;\n\nvoid main(void){\n\n  vec4 positionVec4 = vec4(aPosition, 1.0);\n  gl_Position = uProjectionMatrix * uModelViewMatrix * positionVec4;\n\n  vec3 vertexNormal = normalize(vec3( uNormalMatrix * aNormal ));\n  vVertexNormal = vertexNormal;\n  vVertTexCoord = aTexCoord;\n\n  vec4 mvPosition = uModelViewMatrix * vec4(aPosition, 1.0);\n  vec3 eyeDirection = normalize(-mvPosition.xyz);\n\n  float shininess = 32.0;\n  float specularFactor = 2.0;\n  float diffuseFactor = 0.3;\n\n  vec3 ambientLightFactor = vec3(0.0);\n\n  for (int i = 0; i < 8; i++) {\n    if (uAmbientLightCount == i) break;\n    ambientLightFactor += uAmbientColor[i];\n  }\n\n\n  vec3 directionalLightFactor = vec3(0.0);\n\n  for (int j = 0; j < 8; j++) {\n    if (uDirectionalLightCount == j) break;\n    vec3 dir = uLightingDirection[j];\n    float directionalLightWeighting = max(dot(vertexNormal, -dir), 0.0);\n    directionalLightFactor += uDirectionalColor[j] * directionalLightWeighting;\n  }\n\n\n  vec3 pointLightFactor = vec3(0.0);\n\n  for (int k = 0; k < 8; k++) {\n    if (uPointLightCount == k) break;\n    vec3 loc = (uViewMatrix * vec4(uPointLightLocation[k], 1.0)).xyz;\n    vec3 lightDirection = normalize(loc - mvPosition.xyz);\n\n    float directionalLightWeighting = max(dot(vertexNormal, lightDirection), 0.0);\n\n    float specularLightWeighting = 0.0;\n    if (uSpecular ){\n      vec3 reflectionDirection = reflect(-lightDirection, vertexNormal);\n      specularLightWeighting = pow(max(dot(reflectionDirection, eyeDirection), 0.0), shininess);\n    }\n\n    pointLightFactor += uPointLightColor[k] * (specularFactor * specularLightWeighting\n      + directionalLightWeighting * diffuseFactor);\n  }\n\n  vLightWeighting =  ambientLightFactor + directionalLightFactor + pointLightFactor;\n}\n",
  lightTextureFrag: "precision mediump float;\n\nuniform vec4 uMaterialColor;\nuniform sampler2D uSampler;\nuniform bool isTexture;\nuniform bool uUseLighting;\n\nvarying vec3 vLightWeighting;\nvarying highp vec2 vVertTexCoord;\n\nvoid main(void) {\n  gl_FragColor = isTexture ? texture2D(uSampler, vVertTexCoord) : uMaterialColor;\n  if (uUseLighting)\n    gl_FragColor.rgb *= vLightWeighting;\n}",
  phongVert: "precision mediump float;\n\nattribute vec3 aPosition;\nattribute vec3 aNormal;\nattribute vec2 aTexCoord;\n\nuniform vec3 uAmbientColor[8];\n\nuniform mat4 uModelViewMatrix;\nuniform mat4 uProjectionMatrix;\nuniform mat3 uNormalMatrix;\nuniform int uAmbientLightCount;\n\nvarying vec3 vNormal;\nvarying vec2 vTexCoord;\nvarying vec3 vViewPosition;\nvarying vec3 vAmbientColor;\n\nvoid main(void){\n\n  vec4 viewModelPosition = uModelViewMatrix * vec4(aPosition, 1.0);\n\n  // Pass varyings to fragment shader\n  vViewPosition = viewModelPosition.xyz;\n  gl_Position = uProjectionMatrix * viewModelPosition;  \n\n  vNormal = normalize(uNormalMatrix * normalize(aNormal));\n  vTexCoord = aTexCoord;\n\n  vAmbientColor = vec3(0.0);\n  for (int i = 0; i < 8; i++) {\n    if (uAmbientLightCount == i) break;\n    vAmbientColor += uAmbientColor[i];\n  }\n}\n",
  phongFrag: "precision mediump float;\n\n//uniform mat4 uModelViewMatrix;\nuniform mat4 uViewMatrix;\n\nuniform vec4 uMaterialColor;\nuniform sampler2D uSampler;\nuniform bool isTexture;\nuniform bool uUseLighting;\n\nuniform vec3 uLightingDirection[8];\nuniform vec3 uDirectionalColor[8];\nuniform vec3 uPointLightLocation[8];\nuniform vec3 uPointLightColor[8];\nuniform bool uSpecular;\n\nuniform int uDirectionalLightCount;\nuniform int uPointLightCount;\n\nvarying vec3 vNormal;\nvarying vec2 vTexCoord;\nvarying vec3 vViewPosition;\nvarying vec3 vAmbientColor;\n\nvec3 V;\nvec3 N;\n\nconst float shininess = 32.0;\nconst float specularFactor = 2.0;\nconst float diffuseFactor = 0.73;\n\nstruct LightResult {\n\tfloat specular;\n\tfloat diffuse;\n};\n\nfloat phongSpecular(\n  vec3 lightDirection,\n  vec3 viewDirection,\n  vec3 surfaceNormal,\n  float shininess) {\n\n  vec3 R = normalize(reflect(-lightDirection, surfaceNormal));  \n  return pow(max(0.0, dot(R, viewDirection)), shininess);\n}\n\nfloat lambertDiffuse(\n  vec3 lightDirection,\n  vec3 surfaceNormal) {\n  return max(0.0, dot(-lightDirection, surfaceNormal));\n}\n\nLightResult light(vec3 lightVector) {\n\n  vec3 L = normalize(lightVector);\n\n  //compute our diffuse & specular terms\n  LightResult lr;\n  if (uSpecular)\n    lr.specular = phongSpecular(L, V, N, shininess);\n  lr.diffuse = lambertDiffuse(L, N);\n  return lr;\n}\n\nvoid main(void) {\n\n  V = normalize(vViewPosition);\n  N = vNormal;\n\n  vec3 diffuse = vec3(0.0);\n  float specular = 0.0;\n\n  for (int j = 0; j < 8; j++) {\n    if (uDirectionalLightCount == j) break;\n\n    LightResult result = light(uLightingDirection[j]);\n    diffuse += result.diffuse * uDirectionalColor[j];\n    specular += result.specular;\n  }\n\n  for (int k = 0; k < 8; k++) {\n    if (uPointLightCount == k) break;\n\n    vec3 lightPosition = (uViewMatrix * vec4(uPointLightLocation[k], 1.0)).xyz;\n    vec3 lightVector = vViewPosition - lightPosition;\n\t\n    //calculate attenuation\n    float lightDistance = length(lightVector);\n    float falloff = 500.0 / (lightDistance + 500.0);\n\n    LightResult result = light(lightVector);\n    diffuse += result.diffuse * falloff * uPointLightColor[k];\n    specular += result.specular * falloff;\n  }\n\n  gl_FragColor = isTexture ? texture2D(uSampler, vTexCoord) : uMaterialColor;\n  gl_FragColor.rgb = gl_FragColor.rgb * (diffuse * diffuseFactor + vAmbientColor) + specular * specularFactor;\n}",
  lineVert: "/*\n  Part of the Processing project - http://processing.org\n  Copyright (c) 2012-15 The Processing Foundation\n  Copyright (c) 2004-12 Ben Fry and Casey Reas\n  Copyright (c) 2001-04 Massachusetts Institute of Technology\n  This library is free software; you can redistribute it and/or\n  modify it under the terms of the GNU Lesser General Public\n  License as published by the Free Software Foundation, version 2.1.\n  This library is distributed in the hope that it will be useful,\n  but WITHOUT ANY WARRANTY; without even the implied warranty of\n  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU\n  Lesser General Public License for more details.\n  You should have received a copy of the GNU Lesser General\n  Public License along with this library; if not, write to the\n  Free Software Foundation, Inc., 59 Temple Place, Suite 330,\n  Boston, MA  02111-1307  USA\n*/\n\n#define PROCESSING_LINE_SHADER\n\nuniform mat4 uModelViewMatrix;\nuniform mat4 uProjectionMatrix;\nuniform float uStrokeWeight;\n\nuniform vec4 uViewport;\nvec3 scale = vec3(1.0);\n\nattribute vec4 aPosition;\nattribute vec4 aDirection;\n  \nvoid main() {\n  vec4 posp = uModelViewMatrix * aPosition;\n  vec4 posq = uModelViewMatrix * (aPosition + vec4(aDirection.xyz, 0));\n\n  // Moving vertices slightly toward the camera\n  // to avoid depth-fighting with the fill triangles.\n  // Discussed here:\n  // http://www.opengl.org/discussion_boards/ubbthreads.php?ubb=showflat&Number=252848  \n  posp.xyz = posp.xyz * scale;\n  posq.xyz = posq.xyz * scale;\n\n  vec4 p = uProjectionMatrix * posp;\n  vec4 q = uProjectionMatrix * posq;\n\n  // formula to convert from clip space (range -1..1) to screen space (range 0..[width or height])\n  // screen_p = (p.xy/p.w + <1,1>) * 0.5 * uViewport.zw\n\n  // prevent division by W by transforming the tangent formula (div by 0 causes\n  // the line to disappear, see https://github.com/processing/processing/issues/5183)\n  // t = screen_q - screen_p\n  //\n  // tangent is normalized and we don't care which aDirection it points to (+-)\n  // t = +- normalize( screen_q - screen_p )\n  // t = +- normalize( (q.xy/q.w+<1,1>)*0.5*uViewport.zw - (p.xy/p.w+<1,1>)*0.5*uViewport.zw )\n  //\n  // extract common factor, <1,1> - <1,1> cancels out\n  // t = +- normalize( (q.xy/q.w - p.xy/p.w) * 0.5 * uViewport.zw )\n  //\n  // convert to common divisor\n  // t = +- normalize( ((q.xy*p.w - p.xy*q.w) / (p.w*q.w)) * 0.5 * uViewport.zw )\n  //\n  // remove the common scalar divisor/factor, not needed due to normalize and +-\n  // (keep uViewport - can't remove because it has different components for x and y\n  //  and corrects for aspect ratio, see https://github.com/processing/processing/issues/5181)\n  // t = +- normalize( (q.xy*p.w - p.xy*q.w) * uViewport.zw )\n\n  vec2 tangent = normalize((q.xy*p.w - p.xy*q.w) * uViewport.zw);\n\n  // flip tangent to normal (it's already normalized)\n  vec2 normal = vec2(-tangent.y, tangent.x);\n\n  float thickness = aDirection.w * uStrokeWeight;\n  vec2 offset = normal * thickness / 2.0;\n\n  // Perspective ---\n  // convert from world to clip by multiplying with projection scaling factor\n  // to get the right thickness (see https://github.com/processing/processing/issues/5182)\n  // invert Y, projections in Processing invert Y\n  vec2 perspScale = (uProjectionMatrix * vec4(1, -1, 0, 0)).xy;\n\n  // No Perspective ---\n  // multiply by W (to cancel out division by W later in the pipeline) and\n  // convert from screen to clip (derived from clip to screen above)\n  vec2 noPerspScale = p.w / (0.5 * uViewport.zw);\n\n  //gl_Position.xy = p.xy + offset.xy * mix(noPerspScale, perspScale, float(perspective > 0));\n  gl_Position.xy = p.xy + offset.xy * perspScale;\n  gl_Position.zw = p.zw;\n}\n",
  lineFrag: "precision mediump float;\nprecision mediump int;\n\nuniform vec4 uMaterialColor;\n\nvoid main() {\n  gl_FragColor = uMaterialColor;\n}"
};

/**
 * 3D graphics class
 * @class p5.RendererGL
 * @constructor
 * @extends p5.Renderer
 * @todo extend class to include public method for offscreen
 * rendering (FBO).
 *
 */
p5.RendererGL = function(elt, pInst, isMainCanvas, attr) {
  p5.Renderer.call(this, elt, pInst, isMainCanvas);
  this.attributes = {};
  attr = attr || {};
  this.attributes.alpha = attr.alpha === undefined ? true : attr.alpha;
  this.attributes.depth = attr.depth === undefined ? true : attr.depth;
  this.attributes.stencil = attr.stencil === undefined ? true : attr.stencil;
  this.attributes.antialias =
    attr.antialias === undefined ? false : attr.antialias;
  this.attributes.premultipliedAlpha =
    attr.premultipliedAlpha === undefined ? false : attr.premultipliedAlpha;
  this.attributes.preserveDrawingBuffer =
    attr.preserveDrawingBuffer === undefined
      ? true
      : attr.preserveDrawingBuffer;
  this.attributes.perPixelLighting =
    attr.perPixelLighting === undefined ? false : attr.perPixelLighting;
  this._initContext();
  this.isP3D = true; //lets us know we're in 3d mode
  this.GL = this.drawingContext;

  // lights

  this.ambientLightColors = [];
  this.directionalLightDirections = [];
  this.directionalLightColors = [];

  this.pointLightPositions = [];
  this.pointLightColors = [];

  /**
   * model view, projection, & normal
   * matrices
   */
  this.uMVMatrix = new p5.Matrix();
  this.uPMatrix = new p5.Matrix();
  this.uNMatrix = new p5.Matrix('mat3');

  // Camera
  this._curCamera = null;
  // default camera settings, then use those to populate camera fields.
  this._computeCameraDefaultSettings();
  this.cameraFOV = this.defaultCameraFOV;
  this.cameraAspect = this.defaultAspect;
  this.cameraX = this.defaultCameraX;
  this.cameraY = this.defaultCameraY;
  this.cameraZ = this.defaultCameraZ;
  this.cameraNear = this.defaultCameraNear;
  this.cameraFar = this.defaultCameraFar;
  this.cameraMatrix = new p5.Matrix(pInst);
  this.camera(); // set default camera matrices

  //Geometry & Material hashes
  this.gHash = {};

  this._defaultLightShader = undefined;
  this._defaultImmediateModeShader = undefined;
  this._defaultNormalShader = undefined;
  this._defaultColorShader = undefined;

  this.curFillShader = undefined;
  this.curStrokeShader = undefined;

  this._useColorShader();
  this.setStrokeShader(this._getLineShader());

  //Imediate Mode
  //default drawing is done in Retained Mode
  this.isImmediateDrawing = false;
  this.immediateMode = {};

  // note: must call fill() and stroke () AFTER
  // default shader has been set.
  this.fill(255, 255, 255, 255);
  //this.stroke(0, 0, 0, 255);
  this.pointSize = 5.0; //default point size
  this.strokeWeight(2);
  this.stroke(0, 0, 0);
  // array of textures created in this gl context via this.getTexture(src)
  this.textures = [];
  this.name = 'p5.RendererGL'; // for friendly debugger system

  return this;
};

p5.RendererGL.prototype = Object.create(p5.Renderer.prototype);

//////////////////////////////////////////////
// Setting
//////////////////////////////////////////////

p5.RendererGL.prototype._initContext = function() {
  try {
    this.drawingContext =
      this.canvas.getContext('webgl', this.attributes) ||
      this.canvas.getContext('experimental-webgl', this.attributes);
    if (this.drawingContext === null) {
      throw new Error('Error creating webgl context');
    } else {
      console.log('p5.RendererGL: enabled webgl context');
      var gl = this.drawingContext;
      gl.enable(gl.DEPTH_TEST);
      gl.depthFunc(gl.LEQUAL);
      gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);
      this._viewport = this.drawingContext.getParameter(
        this.drawingContext.VIEWPORT
      );
    }
  } catch (er) {
    throw new Error(er);
  }
};

//This is helper function to reset the context anytime the attributes
//are changed with setAttributes()

p5.RendererGL.prototype._resetContext = function(attr, options, callback) {
  var w = this.width;
  var h = this.height;
  var defaultId = this.canvas.id;
  var c = this.canvas;
  if (c) {
    c.parentNode.removeChild(c);
  }
  c = document.createElement('canvas');
  c.id = defaultId;
  if (this._pInst._userNode) {
    this._pInst._userNode.appendChild(c);
  } else {
    document.body.appendChild(c);
  }
  this._pInst.canvas = c;
  var renderer = new p5.RendererGL(this._pInst.canvas, this._pInst, true, attr);
  this._pInst._setProperty('_renderer', renderer);
  renderer.resize(w, h);
  renderer._applyDefaults();
  this._pInst._elements.push(renderer);
  if (typeof callback === 'function') {
    //setTimeout with 0 forces the task to the back of the queue, this ensures that
    //we finish switching out the renderer
    setTimeout(function() {
      callback.apply(window._renderer, options);
    }, 0);
  }
};
/**
 * @module Rendering
 * @submodule Rendering
 * @for p5
 */
/**
 * Set attributes for the WebGL Drawing context.
 * This is a way of adjusting ways that the WebGL
 * renderer works to fine-tune the display and performance.
 * This should be put in setup().
 * The available attributes are:
 * <br>
 * alpha - indicates if the canvas contains an alpha buffer
 * default is true
 * <br><br>
 * depth - indicates whether the drawing buffer has a depth buffer
 * of at least 16 bits - default is true
 * <br><br>
 * stencil - indicates whether the drawing buffer has a stencil buffer
 * of at least 8 bits
 * <br><br>
 * antialias - indicates whether or not to perform anti-aliasing
 * default is false
 * <br><br>
 * premultipliedAlpha - indicates that the page compositor will assume
 * the drawing buffer contains colors with pre-multiplied alpha
 * default is false
 * <br><br>
 * preserveDrawingBuffer - if true the buffers will not be cleared and
 * and will preserve their values until cleared or overwritten by author
 * (note that p5 clears automatically on draw loop)
 * default is true
 * <br><br>
 * perPixelLighting - if true, per-pixel lighting will be used in the
 * lighting shader.
 * default is false
 * <br><br>
 * @method setAttributes
 * @for p5
 * @param  {String}  key Name of attribute
 * @param  {Boolean}        value New value of named attribute
 * @example
 * <div>
 * <code>
 * function setup() {
 *   createCanvas(100, 100, WEBGL);
 * }
 *
 * function draw() {
 *   background(255);
 *   push();
 *   rotateZ(frameCount * 0.02);
 *   rotateX(frameCount * 0.02);
 *   rotateY(frameCount * 0.02);
 *   fill(0, 0, 0);
 *   box(50);
 *   pop();
 * }
 * </code>
 * </div>
 * <br>
 * Now with the antialias attribute set to true.
 * <br>
 * <div>
 * <code>
 * function setup() {
 *   createCanvas(100, 100, WEBGL);
 *   setAttributes('antialias', true);
 * }
 *
 * function draw() {
 *   background(255);
 *   push();
 *   rotateZ(frameCount * 0.02);
 *   rotateX(frameCount * 0.02);
 *   rotateY(frameCount * 0.02);
 *   fill(0, 0, 0);
 *   box(50);
 *   pop();
 * }
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // press the mouse button to enable perPixelLighting
 * function setup() {
 *   createCanvas(100, 100, WEBGL);
 *   noStroke();
 *   fill(255);
 * }
 *
 * var lights = [
 *   { c: '#f00', t: 1.12, p: 1.91, r: 0.2 },
 *   { c: '#0f0', t: 1.21, p: 1.31, r: 0.2 },
 *   { c: '#00f', t: 1.37, p: 1.57, r: 0.2 },
 *   { c: '#ff0', t: 1.12, p: 1.91, r: 0.7 },
 *   { c: '#0ff', t: 1.21, p: 1.31, r: 0.7 },
 *   { c: '#f0f', t: 1.37, p: 1.57, r: 0.7 }
 * ];
 *
 * function draw() {
 *   var t = millis() / 1000 + 1000;
 *   background(0);
 *   directionalLight(color('#222'), 1, 1, 1);
 *
 *   for (var i = 0; i < lights.length; i++) {
 *     var light = lights[i];
 *     pointLight(
 *       color(light.c),
 *       p5.Vector.fromAngles(t * light.t, t * light.p, width * light.r)
 *     );
 *   }
 *
 *   specularMaterial(255);
 *   sphere(width * 0.1);
 *
 *   rotateX(t * 0.77);
 *   rotateY(t * 0.83);
 *   rotateZ(t * 0.91);
 *   torus(width * 0.3, width * 0.07, 30, 10);
 * }
 *
 * function mousePressed() {
 *   setAttributes('perPixelLighting', true);
 *   noStroke();
 *   fill(255);
 * }
 * function mouseReleased() {
 *   setAttributes('perPixelLighting', false);
 *   noStroke();
 *   fill(255);
 * }
 * </code>
 * </div>
 *
 * @alt a rotating cube with smoother edges
 */
/**
 * @method setAttributes
 * @for p5
 * @param  {Object}  obj object with key-value pairs
 */

p5.prototype.setAttributes = function(key, value) {
  //@todo_FES
  var attr;
  if (typeof value !== 'undefined') {
    attr = {};
    attr[key] = value;
  } else if (key instanceof Object) {
    attr = key;
  }
  this._renderer._resetContext(attr);
};

/**
 * @class p5.RendererGL
 */

p5.RendererGL.prototype._computeCameraDefaultSettings = function() {
  this.defaultCameraFOV = 60 / 180 * Math.PI;
  this.defaultCameraAspect = this.width / this.height;
  this.defaultCameraX = 0;
  this.defaultCameraY = 0;
  this.defaultCameraZ =
    this.height / 2.0 / Math.tan(this.defaultCameraFOV / 2.0);
  this.defaultCameraNear = this.defaultCameraZ * 0.1;
  this.defaultCameraFar = this.defaultCameraZ * 10;
};

//detect if user didn't set the camera
//then call this function below
p5.RendererGL.prototype._setDefaultCamera = function() {
  if (this._curCamera === null) {
    this._computeCameraDefaultSettings();
    this.cameraFOV = this.defaultCameraFOV;
    this.cameraAspect = this.defaultAspect;
    this.cameraX = this.defaultCameraX;
    this.cameraY = this.defaultCameraY;
    this.cameraZ = this.defaultCameraZ;
    this.cameraNear = this.defaultCameraNear;
    this.cameraFar = this.defaultCameraFar;

    this.perspective();
    this.camera();
    this._curCamera = 'default';
  }
};

p5.RendererGL.prototype._update = function() {
  // reset model view and apply initial camera transform
  // (containing only look at info; no projection).
  this.uMVMatrix.set(
    this.cameraMatrix.mat4[0],
    this.cameraMatrix.mat4[1],
    this.cameraMatrix.mat4[2],
    this.cameraMatrix.mat4[3],
    this.cameraMatrix.mat4[4],
    this.cameraMatrix.mat4[5],
    this.cameraMatrix.mat4[6],
    this.cameraMatrix.mat4[7],
    this.cameraMatrix.mat4[8],
    this.cameraMatrix.mat4[9],
    this.cameraMatrix.mat4[10],
    this.cameraMatrix.mat4[11],
    this.cameraMatrix.mat4[12],
    this.cameraMatrix.mat4[13],
    this.cameraMatrix.mat4[14],
    this.cameraMatrix.mat4[15]
  );

  // reset light data for new frame.

  this.ambientLightColors.length = 0;
  this.directionalLightDirections.length = 0;
  this.directionalLightColors.length = 0;

  this.pointLightPositions.length = 0;
  this.pointLightColors.length = 0;
};

/**
 * [background description]
 */
p5.RendererGL.prototype.background = function() {
  var _col = this._pInst.color.apply(this._pInst, arguments);
  var _r = _col.levels[0] / 255;
  var _g = _col.levels[1] / 255;
  var _b = _col.levels[2] / 255;
  var _a = _col.levels[3] / 255;
  this.GL.clearColor(_r, _g, _b, _a);
  this.GL.depthMask(true);
  this.GL.clear(this.GL.COLOR_BUFFER_BIT | this.GL.DEPTH_BUFFER_BIT);
};

//@TODO implement this
// p5.RendererGL.prototype.clear = function() {
//@TODO
// };

//////////////////////////////////////////////
// COLOR
//////////////////////////////////////////////
/**
 * Basic fill material for geometry with a given color
 * @method  fill
 * @class p5.RendererGL
 * @param  {Number|Number[]|String|p5.Color} v1  gray value,
 * red or hue value (depending on the current color mode),
 * or color Array, or CSS color string
 * @param  {Number}            [v2] green or saturation value
 * @param  {Number}            [v3] blue or brightness value
 * @param  {Number}            [a]  opacity
 * @chainable
 * @example
 * <div>
 * <code>
 * function setup() {
 *   createCanvas(200, 200, WEBGL);
 * }
 *
 * function draw() {
 *   background(0);
 *   noStroke();
 *   fill(100, 100, 240);
 *   rotateX(frameCount * 0.01);
 *   rotateY(frameCount * 0.01);
 *   box(75, 75, 75);
 * }
 * </code>
 * </div>
 *
 * @alt
 * black canvas with purple cube spinning
 *
 */
p5.RendererGL.prototype.fill = function(v1, v2, v3, a) {
  //see material.js for more info on color blending in webgl
  var color = p5.prototype.color.apply(this._pInst, arguments);
  this.curFillColor = color._array;

  if (this.isImmediateDrawing) {
    this.setFillShader(this._getImmediateModeShader());
  } else {
    this.setFillShader(this._getColorShader());
  }
  this.drawMode = constants.FILL;
  this.curFillShader.setUniform('uMaterialColor', this.curFillColor);
};

/**
 * Basic stroke material for geometry with a given color
 * @method  stroke
 * @param  {Number|Number[]|String|p5.Color} v1  gray value,
 * red or hue value (depending on the current color mode),
 * or color Array, or CSS color string
 * @param  {Number}            [v2] green or saturation value
 * @param  {Number}            [v3] blue or brightness value
 * @param  {Number}            [a]  opacity
 * @example
 * <div>
 * <code>
 * function setup() {
 *   createCanvas(200, 200, WEBGL);
 * }
 *
 * function draw() {
 *   background(0);
 *   stroke(240, 150, 150);
 *   fill(100, 100, 240);
 *   rotateX(frameCount * 0.01);
 *   rotateY(frameCount * 0.01);
 *   box(75, 75, 75);
 * }
 * </code>
 * </div>
 *
 * @alt
 * black canvas with purple cube with pink outline spinning
 *
 */
p5.RendererGL.prototype.stroke = function(r, g, b, a) {
  //@todo allow transparency in stroking currently doesn't have
  //any impact and causes problems with specularMaterial
  arguments[3] = 255;
  var color = p5.prototype.color.apply(this._pInst, arguments);
  this.curStrokeColor = color._array;
  this.curStrokeShader.setUniform('uMaterialColor', this.curStrokeColor);
};

/**
 * Change weight of stroke
 * @method  strokeWeight
 * @param  {Number} stroke weight to be used for drawing
 * @example
 * <div>
 * <code>
 * function setup() {
 *   createCanvas(200, 400, WEBGL);
 *   setAttributes('antialias', true);
 * }
 *
 * function draw() {
 *   background(0);
 *   noStroke();
 *   translate(0, -100, 0);
 *   stroke(240, 150, 150);
 *   fill(100, 100, 240);
 *   push();
 *   strokeWeight(8);
 *   rotateX(frameCount * 0.01);
 *   rotateY(frameCount * 0.01);
 *   sphere(75);
 *   pop();
 *   push();
 *   translate(0, 200, 0);
 *   strokeWeight(1);
 *   rotateX(frameCount * 0.01);
 *   rotateY(frameCount * 0.01);
 *   sphere(75);
 *   pop();
 * }
 * </code>
 * </div>
 *
 * @alt
 * black canvas with two purple rotating spheres with pink
 * outlines the sphere on top has much heavier outlines,
 *
 */
p5.RendererGL.prototype.strokeWeight = function(w) {
  if (this.curStrokeWeight !== w) {
    this.pointSize = w;
    this.curStrokeWeight = w;
    this.curStrokeShader.setUniform('uStrokeWeight', w);
  }
};

/**
 * Returns an array of [R,G,B,A] values for any pixel or grabs a section of
 * an image. If no parameters are specified, the entire image is returned.
 * Use the x and y parameters to get the value of one pixel. Get a section of
 * the display window by specifying additional w and h parameters. When
 * getting an image, the x and y parameters define the coordinates for the
 * upper-left corner of the image, regardless of the current imageMode().
 * <br><br>
 * If the pixel requested is outside of the image window, [0,0,0,255] is
 * returned.
 * <br><br>
 * Getting the color of a single pixel with get(x, y) is easy, but not as fast
 * as grabbing the data directly from pixels[]. The equivalent statement to
 * get(x, y) is using pixels[] with pixel density d
 *
 *
 * @method get
 * @param  {Number}               [x] x-coordinate of the pixel
 * @param  {Number}               [y] y-coordinate of the pixel
 * @param  {Number}               [w] width
 * @param  {Number}               [h] height
 * @return {Number[]|Color|p5.Image}  color of pixel at x,y in array format
 *                                    [R, G, B, A] or p5.Image
 */
p5.RendererGL.prototype.get = function(x, y, w, h) {
  return p5.Renderer2D.prototype.get.apply(this, [x, y, w, h]);
};

/**
 * Loads the pixels data for this canvas into the pixels[] attribute.
 * Note that updatePixels() and set() do not work.
 * Any pixel manipulation must be done directly to the pixels[] array.
 *
 * @method loadPixels
 *
 */

p5.RendererGL.prototype.loadPixels = function() {
  //@todo_FES
  if (this.attributes.preserveDrawingBuffer !== true) {
    console.log(
      'loadPixels only works in WebGL when preserveDrawingBuffer ' + 'is true.'
    );
    return;
  }
  var pd = this._pInst._pixelDensity;
  var x = 0;
  var y = 0;
  var w = this.width;
  var h = this.height;
  w *= pd;
  h *= pd;
  //if there isn't a renderer-level temporary pixels buffer
  //make a new one
  if (typeof this.pixels === 'undefined') {
    this.pixels = new Uint8Array(
      this.GL.drawingBufferWidth * this.GL.drawingBufferHeight * 4
    );
  }
  this.GL.readPixels(
    x,
    y,
    w,
    h,
    this.GL.RGBA,
    this.GL.UNSIGNED_BYTE,
    this.pixels
  );
  this._pInst._setProperty('pixels', this.pixels);
};

//////////////////////////////////////////////
// HASH | for geometry
//////////////////////////////////////////////

p5.RendererGL.prototype.geometryInHash = function(gId) {
  return this.gHash[gId] !== undefined;
};

/**
 * [resize description]
 * @private
 * @param  {Number} w [description]
 * @param  {Number} h [description]
 */
p5.RendererGL.prototype.resize = function(w, h) {
  p5.Renderer.prototype.resize.call(this, w, h);
  this.GL.viewport(
    0,
    0,
    this.GL.drawingBufferWidth,
    this.GL.drawingBufferHeight
  );
  this._viewport = this.GL.getParameter(this.GL.VIEWPORT);
  // If we're using the default camera, update the aspect ratio
  if (this._curCamera === null || this._curCamera === 'default') {
    this._curCamera = null;
    // camera defaults are dependent on the width & height of the screen,
    // so we'll want to update them if the size of the screen changes.
    this._setDefaultCamera();
  }
  //resize pixels buffer
  if (typeof this.pixels !== 'undefined') {
    this.pixels = new Uint8Array(
      this.GL.drawingBufferWidth * this.GL.drawingBufferHeight * 4
    );
  }
};

/**
 * clears color and depth buffers
 * with r,g,b,a
 * @private
 * @param {Number} r normalized red val.
 * @param {Number} g normalized green val.
 * @param {Number} b normalized blue val.
 * @param {Number} a normalized alpha val.
 */
p5.RendererGL.prototype.clear = function() {
  this.GL.clearColor(arguments[0], arguments[1], arguments[2], arguments[3]);
  this.GL.clear(this.GL.COLOR_BUFFER_BIT | this.GL.DEPTH_BUFFER_BIT);
};

/**
 * [translate description]
 * @private
 * @param  {Number} x [description]
 * @param  {Number} y [description]
 * @param  {Number} z [description]
 * @chainable
 * @todo implement handle for components or vector as args
 */
p5.RendererGL.prototype.translate = function(x, y, z) {
  if (x instanceof p5.Vector) {
    z = x.z;
    y = x.y;
    x = x.x;
  }
  this.uMVMatrix.translate([x, y, z]);
  return this;
};

/**
 * Scales the Model View Matrix by a vector
 * @private
 * @param  {Number | p5.Vector | Array} x [description]
 * @param  {Number} [y] y-axis scalar
 * @param  {Number} [z] z-axis scalar
 * @chainable
 */
p5.RendererGL.prototype.scale = function(x, y, z) {
  this.uMVMatrix.scale(x, y, z);
  return this;
};

p5.RendererGL.prototype.rotate = function(rad, axis) {
  if (typeof axis === 'undefined') {
    return this.rotateZ(rad);
  }
  p5.Matrix.prototype.rotate.apply(this.uMVMatrix, arguments);
  return this;
};

p5.RendererGL.prototype.rotateX = function(rad) {
  this.rotate(rad, 1, 0, 0);
  return this;
};

p5.RendererGL.prototype.rotateY = function(rad) {
  this.rotate(rad, 0, 1, 0);
  return this;
};

p5.RendererGL.prototype.rotateZ = function(rad) {
  this.rotate(rad, 0, 0, 1);
  return this;
};

/**
 * pushes a copy of the model view matrix onto the
 * MV Matrix stack.
 */
p5.RendererGL.prototype.push = function() {
  uMVMatrixStack.push(this.uMVMatrix.copy());
  cameraMatrixStack.push(this.cameraMatrix.copy());
};

/**
 * [pop description]
 */
p5.RendererGL.prototype.pop = function() {
  if (uMVMatrixStack.length === 0) {
    throw new Error('Invalid popMatrix!');
  }
  this.uMVMatrix = uMVMatrixStack.pop();
  if (cameraMatrixStack.length === 0) {
    throw new Error('Invalid popMatrix!');
  }
  this.cameraMatrix = cameraMatrixStack.pop();
};

p5.RendererGL.prototype.resetMatrix = function() {
  this.uMVMatrix = p5.Matrix.identity(this._pInst);
  return this;
};

// Text/Typography
// @TODO:
p5.RendererGL.prototype._applyTextProperties = function() {
  //@TODO finish implementation
  console.error('text commands not yet implemented in webgl');
};

//////////////////////////////////////////////
// SHADER
//////////////////////////////////////////////

/*
 * Initializes and uses the specified shader, then returns
 * that shader. Note: initialization and resetting the program
 * is only used if needed (say, if a new value is provided)
 * so it is safe to call this method with the same shader multiple
 * times without a signficant performance hit).
 *
 * @method setFillShader
 * @param {p5.Shader} [s] a p5.Shader object
 * @return {p5.Shader} the current, updated fill shader
 */
p5.RendererGL.prototype.setFillShader = function(s) {
  if (this.curFillShader !== s) {
    // only do setup etc. if shader is actually new.
    this.curFillShader = s;

    // safe to do this multiple times;
    // init() will bail early if has already been run.
    this.curFillShader.init();
    //this.curFillShader.useProgram();
  }
  // always return this.curFillShader, even if no change was made.
  return this.curFillShader;
};

/*
 * @method setStrokeShader
 * @param {p5.Shader} [s] a p5.Shader object
 * @return {p5.Shader} the current, updated stroke shader
 */
p5.RendererGL.prototype.setStrokeShader = function(s) {
  if (this.curStrokeShader !== s) {
    // only do setup etc. if shader is actually new.
    this.curStrokeShader = s;
    // safe to do this multiple times;
    // init() will bail early if has already been run.
    this.curStrokeShader.init();
    //this.curStrokeShader.useProgram();
  }
  // always return this.curLineShader, even if no change was made.
  return this.curStrokeShader;
};

/*
 * shaders are created and cached on a per-renderer basis,
 * on the grounds that each renderer will have its own gl context
 * and the shader must be valid in that context.
 *
 *
 */

p5.RendererGL.prototype._useLightShader = function() {
  if (!this.curFillShader || !this.curFillShader.isLightShader()) {
    this.setFillShader(this._getLightShader());
  }
  return this.curFillShader;
};

p5.RendererGL.prototype._useColorShader = function() {
  // looking at the code within the glsl files, I'm not really
  // sure why these are two different shaders. but, they are,
  // and if we're drawing in retain mode but the shader is the
  // immediate mode one, we need to switch.

  // TODO: what if curFillShader is _any_ other shader?
  if (
    !this.curFillShader ||
    this.curFillShader === this._defaultImmediateModeShader
  ) {
    // there are different immediate mode and retain mode color shaders.
    // if we're using the immediate mode one, we need to switch to
    // one that works for retain mode.
    this.setFillShader(this._getColorShader());
  }
  return this.curFillShader;
};

p5.RendererGL.prototype._useImmediateModeShader = function() {
  // TODO: what if curFillShader is _any_ other shader?
  if (!this.curFillShader || this.curFillShader === this._defaultColorShader) {
    // this is the fill/stroke shader for retain mode.
    // must switch to immediate mode shader before drawing!
    this.setFillShader(this._getImmediateModeShader());
    // note that if we're using the texture shader...
    // this shouldn't change. :)
  }
  return this.curFillShader;
};

p5.RendererGL.prototype._getLightShader = function() {
  if (!this._defaultLightShader) {
    if (this.attributes.perPixelLighting) {
      this._defaultLightShader = new p5.Shader(
        this,
        defaultShaders.phongVert,
        defaultShaders.phongFrag
      );
    } else {
      this._defaultLightShader = new p5.Shader(
        this,
        defaultShaders.lightVert,
        defaultShaders.lightTextureFrag
      );
    }
  }
  //this.drawMode = constants.FILL;
  return this._defaultLightShader;
};

p5.RendererGL.prototype._getImmediateModeShader = function() {
  if (!this._defaultImmediateModeShader) {
    this._defaultImmediateModeShader = new p5.Shader(
      this,
      defaultShaders.immediateVert,
      defaultShaders.vertexColorFrag
    );
  }
  //this.drawMode = constants.FILL;
  return this._defaultImmediateModeShader;
};

p5.RendererGL.prototype._getNormalShader = function() {
  if (!this._defaultNormalShader) {
    this._defaultNormalShader = new p5.Shader(
      this,
      defaultShaders.normalVert,
      defaultShaders.normalFrag
    );
  }
  //this.drawMode = constants.FILL;
  return this._defaultNormalShader;
};

p5.RendererGL.prototype._getColorShader = function() {
  if (!this._defaultColorShader) {
    this._defaultColorShader = new p5.Shader(
      this,
      defaultShaders.normalVert,
      defaultShaders.basicFrag
    );
  }
  //this.drawMode = constants.FILL;
  return this._defaultColorShader;
};

p5.RendererGL.prototype._getLineShader = function() {
  if (!this._defaultLineShader) {
    this._defaultLineShader = new p5.Shader(
      this,
      defaultShaders.lineVert,
      defaultShaders.lineFrag
    );
  }
  //this.drawMode = constants.STROKE;
  return this._defaultLineShader;
};

p5.RendererGL.prototype._getEmptyTexture = function() {
  if (!this._emptyTexture) {
    // a plain white texture RGBA, full alpha, single pixel.
    var im = new p5.Image(1, 1);
    im.set(0, 0, 255);
    this._emptyTexture = new p5.Texture(this, im);
  }
  return this._emptyTexture;
};

p5.RendererGL.prototype.getTexture = function(img) {
  var checkSource = function(element) {
    return element.src === img;
  };
  //this.drawMode = constants.TEXTURE;
  var tex = this.textures.find(checkSource);
  if (!tex) {
    tex = new p5.Texture(this, img);
    this.textures.push(tex);
  }

  return tex;
};

//Binds a buffer to the drawing context
//when passed more than two arguments it also updates or initializes
//the data associated with the buffer
p5.RendererGL.prototype._bindBuffer = function(
  buffer,
  target,
  values,
  type,
  usage
) {
  this.GL.bindBuffer(target, buffer);
  if (values !== undefined) {
    var data = new type(values);
    this.GL.bufferData(target, data, usage);
  }
};

///////////////////////////////
//// UTILITY FUNCTIONS
//////////////////////////////
/**
 * turn a two dimensional array into one dimensional array
 * @private
 * @param  {Array} arr 2-dimensional array
 * @return {Array}     1-dimensional array
 * [[1, 2, 3],[4, 5, 6]] -> [1, 2, 3, 4, 5, 6]
 */
p5.RendererGL.prototype._flatten = function(arr) {
  //when empty, return empty
  if (arr.length === 0) {
    return [];
  } else if (arr.length > 20000) {
    //big models , load slower to avoid stack overflow
    //faster non-recursive flatten via axelduch
    //stackoverflow.com/questions/27266550/how-to-flatten-nested-array-in-javascript
    var toString = Object.prototype.toString;
    var arrayTypeStr = '[object Array]';
    var result = [];
    var nodes = arr.slice();
    var node;
    node = nodes.pop();
    do {
      if (toString.call(node) === arrayTypeStr) {
        nodes.push.apply(nodes, node);
      } else {
        result.push(node);
      }
    } while (nodes.length && (node = nodes.pop()) !== undefined);
    result.reverse(); // we reverse result to restore the original order
    return result;
  } else {
    //otherwise if model within limits for browser
    //use faster recursive loading
    return [].concat.apply([], arr);
  }
};

/**
 * turn a p5.Vector Array into a one dimensional number array
 * @private
 * @param  {p5.Vector[]} arr  an array of p5.Vector
 * @return {Number[]}     a one dimensional array of numbers
 * [p5.Vector(1, 2, 3), p5.Vector(4, 5, 6)] ->
 * [1, 2, 3, 4, 5, 6]
 */
p5.RendererGL.prototype._vToNArray = function(arr) {
  return this._flatten(
    arr.map(function(item) {
      return [item.x, item.y, item.z];
    })
  );
};

module.exports = p5.RendererGL;

},{"../core/constants":21,"../core/core":22,"../core/p5.Renderer":29,"./p5.Matrix":70,"./p5.Shader":74}],74:[function(_dereq_,module,exports){
/**
 * This module defines the p5.Shader class
 * @module Lights, Camera
 * @submodule Shaders
 * @for p5
 * @requires core
 */

'use strict';

var p5 = _dereq_('../core/core');

/**
 * Shader class for WEBGL Mode
 * @class p5.Shader
 * @constructor
 * @param {p5.RendererGL} renderer an instance of p5.RendererGL that
 * will provide the GL context for this new p5.Shader
 * @param {String} vertSrc source code for the vertex shader (as a string)
 * @param {String} fragSrc source code for the fragment shader (as a string)
 */
p5.Shader = function(renderer, vertSrc, fragSrc) {
  // TODO: adapt this to not take ids, but rather,
  // to take the source for a vertex and fragment shader
  // to enable custom shaders at some later date
  this._renderer = renderer;
  this._vertSrc = vertSrc;
  this._fragSrc = fragSrc;
  this._vertShader = -1;
  this._fragShader = -1;
  this._glProgram = 0;
  this._loadedAttributes = false;
  this.attributes = {};
  this._loadedUniforms = false;
  this.uniforms = {};
  this._bound = false;
  this.samplers = [];

  return this;
};

/**
 * Creates, compiles, and links the shader based on its
 * sources for the vertex and fragment shaders (provided
 * to the constructor). Populates known attributes and
 * uniforms from the shader.
 * @method init
 * @chainable
 * @private
 */
p5.Shader.prototype.init = function() {
  if (this._glProgram === 0 /* or context is stale? */) {
    var gl = this._renderer.GL;

    // @todo: once custom shading is allowed,
    // friendly error messages should be used here to share
    // compiler and linker errors.

    //set up the shader by
    // 1. creating and getting a gl id for the shader program,
    // 2. compliling its vertex & fragment sources,
    // 3. linking the vertex and fragment shaders
    this._vertShader = gl.createShader(gl.VERTEX_SHADER);
    //load in our default vertex shader
    gl.shaderSource(this._vertShader, this._vertSrc);
    gl.compileShader(this._vertShader);
    // if our vertex shader failed compilation?
    if (!gl.getShaderParameter(this._vertShader, gl.COMPILE_STATUS)) {
      console.error(
        'Yikes! An error occurred compiling the vertex shader:' +
          gl.getShaderInfoLog(this._vertShader)
      );
      return null;
    }

    this._fragShader = gl.createShader(gl.FRAGMENT_SHADER);
    //load in our material frag shader
    gl.shaderSource(this._fragShader, this._fragSrc);
    gl.compileShader(this._fragShader);
    // if our frag shader failed compilation?
    if (!gl.getShaderParameter(this._fragShader, gl.COMPILE_STATUS)) {
      console.error(
        'Darn! An error occurred compiling the fragment shader:' +
          gl.getShaderInfoLog(this._fragShader)
      );
      return null;
    }

    this._glProgram = gl.createProgram();
    gl.attachShader(this._glProgram, this._vertShader);
    gl.attachShader(this._glProgram, this._fragShader);
    gl.linkProgram(this._glProgram);
    if (!gl.getProgramParameter(this._glProgram, gl.LINK_STATUS)) {
      console.error(
        'Snap! Error linking shader program: ' +
          gl.getProgramInfoLog(this._glProgram)
      );
    }

    this._loadAttributes();
    this._loadUniforms();
  }
  return this;
};

/**
 * Queries the active attributes for this shader and loads
 * their names and locations into the attributes array.
 * @method _loadAttributes
 * @private
 */
p5.Shader.prototype._loadAttributes = function() {
  if (this._loadedAttributes) {
    return;
  }

  this.attributes = {};

  var gl = this._renderer.GL;

  var numAttributes = gl.getProgramParameter(
    this._glProgram,
    gl.ACTIVE_ATTRIBUTES
  );
  for (var i = 0; i < numAttributes; ++i) {
    var attributeInfo = gl.getActiveAttrib(this._glProgram, i);
    var name = attributeInfo.name;
    var location = gl.getAttribLocation(this._glProgram, name);
    var attribute = {};
    attribute.name = name;
    attribute.location = location;
    attribute.type = attributeInfo.type;
    attribute.size = attributeInfo.size;
    this.attributes[name] = attribute;
  }

  this._loadedAttributes = true;
};

/**
 * Queries the active uniforms for this shader and loads
 * their names and locations into the uniforms array.
 * @method _loadUniforms
 * @private
 */
p5.Shader.prototype._loadUniforms = function() {
  if (this._loadedUniforms) {
    return;
  }

  var gl = this._renderer.GL;

  // Inspect shader and cache uniform info
  var numUniforms = gl.getProgramParameter(this._glProgram, gl.ACTIVE_UNIFORMS);

  var samplerIndex = 0;
  for (var i = 0; i < numUniforms; ++i) {
    var uniformInfo = gl.getActiveUniform(this._glProgram, i);
    var uniform = {};
    uniform.location = gl.getUniformLocation(this._glProgram, uniformInfo.name);
    uniform.size = uniformInfo.size;
    var uniformName = uniformInfo.name;
    //uniforms thats are arrays have their name returned as
    //someUniform[0] which is a bit silly so we trim it
    //off here. The size property tells us that its an array
    //so we dont lose any information by doing this
    if (uniformInfo.size > 1) {
      uniformName = uniformName.substring(0, uniformName.indexOf('[0]'));
    }
    uniform.name = uniformName;
    uniform.type = uniformInfo.type;
    if (uniform.type === gl.SAMPLER_2D) {
      uniform.samplerIndex = samplerIndex;
      samplerIndex++;
      this.samplers.push(uniform);
    }
    this.uniforms[uniformName] = uniform;
  }
  this._loadedUniforms = true;
};

p5.Shader.prototype.compile = function() {
  // TODO
};

/**
 * initializes (if needed) and binds the shader program.
 * @method bindShader
 * @private
 */
p5.Shader.prototype.bindShader = function() {
  this.init();
  if (!this._bound) {
    this.useProgram();
    this._bound = true;
    this.bindTextures();

    this._loadAttributes();
    this._loadUniforms();

    this._renderer._setDefaultCamera();
    this._setMatrixUniforms();
    if (this === this._renderer.curStrokeShader) {
      this._setViewportUniform();
    }
  }
};

/**
 * @method unbindShader
 * @chainable
 * @private
 */
p5.Shader.prototype.unbindShader = function() {
  if (this._bound) {
    this.unbindTextures();
    //this._renderer.GL.useProgram(0); ??
    this._bound = false;
  }
  return this;
};

p5.Shader.prototype.bindTextures = function() {
  var gl = this._renderer.GL;
  for (var i = 0; i < this.samplers.length; i++) {
    var uniform = this.samplers[i];
    var tex = uniform.texture;
    if (tex === undefined) {
      // user hasn't yet supplied a texture for this slot.
      // (or there may not be one--maybe just lighting),
      // so we supply a default texture instead.
      tex = this._renderer._getEmptyTexture();
    }
    gl.activeTexture(gl.TEXTURE0 + uniform.samplerIndex);
    tex.bindTexture();
    tex.update();
    gl.uniform1i(uniform.location, uniform.samplerIndex);
  }
};

p5.Shader.prototype.unbindTextures = function() {
  // TODO: migrate stuff from material.js here
  // - OR - have material.js define this function
};

p5.Shader.prototype._setMatrixUniforms = function() {
  this.setUniform('uProjectionMatrix', this._renderer.uPMatrix.mat4);
  this.setUniform('uModelViewMatrix', this._renderer.uMVMatrix.mat4);
  this.setUniform('uViewMatrix', this._renderer.cameraMatrix.mat4);
  if (this === this._renderer.curFillShader) {
    this._renderer.uNMatrix.inverseTranspose(this._renderer.uMVMatrix);
    this.setUniform('uNormalMatrix', this._renderer.uNMatrix.mat3);
  }
};

p5.Shader.prototype._setViewportUniform = function() {
  this.setUniform('uViewport', this._renderer._viewport);
};

/**
 * @method useProgram
 * @chainable
 * @private
 */
p5.Shader.prototype.useProgram = function() {
  var gl = this._renderer.GL;
  gl.useProgram(this._glProgram);
  return this;
};

/**
 * Wrapper around gl.uniform functions.
 * As we store uniform info in the shader we can use that
 * to do type checking on the supplied data and call
 * the appropriate function.
 * @method setUniform
 * @chainable
 * @param {String} uniformName the name of the uniform in the
 * shader program
 * @param {Object|Number|Boolean|Number[]} data the data to be associated
 * with that uniform; type varies (could be a single numerical value, array,
 * matrix, or texture / sampler reference)
 */
p5.Shader.prototype.setUniform = function(uniformName, data) {
  //@todo update all current gl.uniformXX calls

  var uniform = this.uniforms[uniformName];
  if (!uniform) {
    //@todo warning?
    return;
  }
  var location = uniform.location;

  var gl = this._renderer.GL;
  // todo: is this safe to do here?
  // todo: store the values another way?
  this.useProgram();

  // TODO BIND?

  switch (uniform.type) {
    case gl.BOOL:
      if (data === true) {
        gl.uniform1i(location, 1);
      } else {
        gl.uniform1i(location, 0);
      }
      break;
    case gl.INT:
      if (uniform.size > 1) {
        gl.uniform1iv(location, data);
      } else {
        gl.uniform1i(location, data);
      }
      break;
    case gl.FLOAT:
      if (uniform.size > 1) {
        gl.uniform1fv(location, data);
      } else {
        gl.uniform1f(location, data);
      }
      break;
    case gl.FLOAT_MAT3:
      gl.uniformMatrix3fv(location, false, data);
      break;
    case gl.FLOAT_MAT4:
      gl.uniformMatrix4fv(location, false, data);
      break;
    case gl.FLOAT_VEC2:
      if (uniform.size > 1) {
        gl.uniform2fv(location, data);
      } else {
        gl.uniform2f(location, data[0], data[1]);
      }
      break;
    case gl.FLOAT_VEC3:
      if (uniform.size > 1) {
        gl.uniform3fv(location, data);
      } else {
        gl.uniform3f(location, data[0], data[1], data[2]);
      }
      break;
    case gl.FLOAT_VEC4:
      if (uniform.size > 1) {
        gl.uniform4fv(location, data);
      } else {
        gl.uniform4f(location, data[0], data[1], data[2], data[3]);
      }
      break;
    case gl.SAMPLER_2D:
      gl.activeTexture(gl.TEXTURE0 + uniform.samplerIndex);
      uniform.texture = this._renderer.getTexture(data);
      gl.uniform1i(uniform.location, uniform.samplerIndex);
      break;
    //@todo complete all types
  }
  return this;
};

/* NONE OF THIS IS FAST OR EFFICIENT BUT BEAR WITH ME
 *
 * these shader "type" query methods are used by various
 * facilities of the renderer to determine if changing
 * the shader type for the required action (for example,
 * do we need to load the default lighting shader if the
 * current shader cannot handle lighting?)
 *
 **/

p5.Shader.prototype.isLightShader = function() {
  return (
    this.uniforms.uUseLighting !== undefined ||
    this.uniforms.uAmbientLightCount !== undefined ||
    this.uniforms.uDirectionalLightCount !== undefined ||
    this.uniforms.uPointLightCount !== undefined ||
    this.uniforms.uAmbientColor !== undefined ||
    this.uniforms.uDirectionalColor !== undefined ||
    this.uniforms.uPointLightLocation !== undefined ||
    this.uniforms.uPointLightColor !== undefined ||
    this.uniforms.uLightingDirection !== undefined ||
    this.uniforms.uSpecular !== undefined
  );
};

p5.Shader.prototype.isTextureShader = function() {
  return this.samplerIndex > 0;
};

p5.Shader.prototype.isColorShader = function() {
  return (
    this.attributes.aVertexColor !== undefined ||
    this.uniforms.uMaterialColor !== undefined
  );
};

p5.Shader.prototype.isTexLightShader = function() {
  return this.isLightShader() && this.isTextureShader();
};

p5.Shader.prototype.isStrokeShader = function() {
  return this.uniforms.uStrokeWeight !== undefined;
};

/**
 * @method enableAttrib
 * @chainable
 * @private
 */
p5.Shader.prototype.enableAttrib = function(
  loc,
  size,
  type,
  normalized,
  stride,
  offset
) {
  var gl = this._renderer.GL;
  if (loc !== -1) {
    gl.enableVertexAttribArray(loc);
    gl.vertexAttribPointer(loc, size, type, normalized, stride, offset);
  }
  return this;
};

module.exports = p5.Shader;

},{"../core/core":22}],75:[function(_dereq_,module,exports){
/**
 * This module defines the p5.Texture class
 * @module Lights, Camera
 * @submodule Material
 * @for p5
 * @requires core
 */

'use strict';

var p5 = _dereq_('../core/core');

/**
 * Texture class for WEBGL Mode
 * @class p5.Texture
 * @constructor
 * @param {p5.RendererGL} renderer an instance of p5.RendererGL that
 * will provide the GL context for this new p5.Texture
 * @param {p5.Image|p5.Graphics|p5.Element|p5.MediaElement} [obj] the
 * object containing the image data to store in the texture.
 */
p5.Texture = function(renderer, obj) {
  this._renderer = renderer;

  var gl = this._renderer.GL;

  this.src = obj;
  this.glTex = undefined;
  this.glTarget = gl.TEXTURE_2D;
  this.glFormat = gl.RGBA;
  this.mipmaps = false;
  this.glMinFilter = gl.LINEAR;
  this.glMagFilter = gl.LINEAR;
  this.glWrapS = gl.CLAMP_TO_EDGE;
  this.glWrapT = gl.CLAMP_TO_EDGE;

  // used to determine if this texture might need constant updating
  // because it is a video or gif.
  this.isSrcMediaElement =
    typeof p5.MediaElement !== 'undefined' && obj instanceof p5.MediaElement;
  this._videoPrevUpdateTime = 0;
  this.isSrcHTMLElement =
    typeof p5.Element !== 'undefined' &&
    obj instanceof p5.Element &&
    !(obj instanceof p5.Graphics);
  this.isSrcP5Image = obj instanceof p5.Image;
  this.isSrcP5Graphics = obj instanceof p5.Graphics;

  var textureData = this._getTextureDataFromSource();
  this.width = textureData.width;
  this.height = textureData.height;

  this.init(textureData);
  return this;
};

p5.Texture.prototype._getTextureDataFromSource = function() {
  var textureData;
  if (this.isSrcP5Image) {
    // param is a p5.Image
    textureData = this.src.canvas;
  } else if (
    this.isSrcMediaElement ||
    this.isSrcP5Graphics ||
    this.isSrcHTMLElement
  ) {
    // if param is a video HTML element
    textureData = this.src.elt;
  }
  return textureData;
};

/**
 * Initializes common texture parameters, creates a gl texture,
 * tries to upload the texture for the first time if data is
 * already available.
 * @private
 * @method init
 */
p5.Texture.prototype.init = function(data) {
  var gl = this._renderer.GL;
  this.glTex = gl.createTexture();
  this.bindTexture();

  //gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, this.glMagFilter);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, this.glMinFilter);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, this.glWrapS);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, this.glWrapT);

  if (
    this.width === 0 ||
    this.height === 0 ||
    (this.isSrcMediaElement && !this.src.loadedmetadata)
  ) {
    // assign a 1x1 empty texture initially, because data is not yet ready,
    // so that no errors occur in gl console!
    var tmpdata = new Uint8Array([1, 1, 1, 1]);
    gl.texImage2D(
      this.glTarget,
      0,
      gl.RGBA,
      1,
      1,
      0,
      this.glFormat,
      gl.UNSIGNED_BYTE,
      tmpdata
    );
  } else {
    // data is ready: just push the texture!
    gl.texImage2D(
      this.glTarget,
      0,
      this.glFormat,
      this.glFormat,
      gl.UNSIGNED_BYTE,
      data
    );
  }
};

/**
 * Checks if the source data for this texture has changed (if it's
 * easy to do so) and reuploads the texture if necessary. If it's not
 * possible or to expensive to do a calculation to determine wheter or
 * not the data has occurred, this method simply re-uploads the texture.
 * @method update
 */
p5.Texture.prototype.update = function() {
  var data = this.src;
  if (data.width === 0 || data.height === 0) {
    return; // nothing to do!
  }

  var textureData = this._getTextureDataFromSource();

  var gl = this._renderer.GL;
  // pull texture from data, make sure width & height are appropriate
  if (textureData.width !== this.width || textureData.height !== this.height) {
    // make sure that if the width and height of this.src have changed
    // for some reason, we update our metadata and upload the texture again
    this.width = textureData.width;
    this.height = textureData.height;

    this.bindTexture();
    gl.texImage2D(
      this.glTarget,
      0,
      this.glFormat,
      this.glFormat,
      gl.UNSIGNED_BYTE,
      textureData
    );

    if (this.isSrcP5Image) {
      data.setModified(false);
    } else if (this.isSrcMediaElement || this.isSrcHTMLElement) {
      // on the first frame the metadata comes in, the size will be changed
      // from 0 to actual size, but pixels may not be available.
      // flag for update in a future frame.
      // if we don't do this, a paused video, for example, may not
      // send the first frame to texture memory.
      data.setModified(true);
    }
  } else if (this.isSrcP5Image) {
    // for an image, we only update if the modified field has been set,
    // for example, by a call to p5.Image.set
    if (data.isModified()) {
      this.bindTexture();
      gl.texImage2D(
        this.glTarget,
        0,
        this.glFormat,
        this.glFormat,
        gl.UNSIGNED_BYTE,
        textureData
      );
      data.setModified(false);
    }
  } else if (this.isSrcMediaElement) {
    var shouldUpdate = false;

    // for a media element (video), we'll check if the current time in
    // the video frame matches the last time. if it doesn't match, the
    // video has advanced or otherwise been taken to a new frame,
    // and we need to upload it.
    if (data.isModified()) {
      // p5.MediaElement may have also had set/updatePixels, etc. called
      // on it and should be updated, or may have been set for the first
      // time!
      shouldUpdate = true;
      data.setModified(false);
    } else if (data.loadedmetadata) {
      // if the meta data has been loaded, we can ask the video
      // what it's current position (in time) is.
      if (this._videoPrevUpdateTime !== data.time()) {
        // update the texture in gpu mem only if the current
        // video timestamp does not match the timestamp of the last
        // time we uploaded this texture (and update the time we
        // last uploaded, too)
        this._videoPrevUpdateTime = data.time();
        shouldUpdate = true;
      }
    }

    if (shouldUpdate) {
      this.bindTexture();
      gl.texImage2D(
        this.glTarget,
        0,
        this.glFormat,
        this.glFormat,
        gl.UNSIGNED_BYTE,
        textureData
      );
    }
  } else {
    /* data instanceof p5.Graphics, probably */ // there is not enough information to tell if the texture can be
    // conditionally updated; so to be safe, we just go ahead and upload it.
    gl.texImage2D(
      this.glTarget,
      0,
      this.glFormat,
      this.glFormat,
      gl.UNSIGNED_BYTE,
      textureData
    );
  }
};

/**
 * Binds the texture to the appropriate GL target.
 * @method bindTexture
 */
p5.Texture.prototype.bindTexture = function() {
  // bind texture using gl context + glTarget and
  // generated gl texture object
  var gl = this._renderer.GL;
  gl.bindTexture(this.glTarget, this.glTex);

  return this;
};

/**
 * Unbinds the texture from the appropriate GL target.
 * @method unbindTexture
 */
p5.Texture.prototype.unbindTexture = function() {
  // unbind per above, disable texturing on glTarget
  var gl = this._renderer.GL;
  gl.bindTexture(this.glTarget, null);
};

module.exports = p5.Texture;

},{"../core/core":22}],76:[function(_dereq_,module,exports){
/**
 * @module Shape
 * @submodule 3D Primitives
 * @for p5
 * @requires core
 * @requires p5.Geometry
 */

'use strict';

var p5 = _dereq_('../core/core');
_dereq_('./p5.Geometry');
/**
 * Draw a plane with given a width and height
 * @method plane
 * @param  {Number} [width]    width of the plane
 * @param  {Number} [height]   height of the plane
 * @param  {Integer} [detailX]  Optional number of triangle
 *                             subdivisions in x-dimension
 * @param {Integer} [detailY]   Optional number of triangle
 *                             subdivisions in y-dimension
 * @chainable
 * @example
 * <div>
 * <code>
 * //draw a plane with width 50 and height 50
 * function setup() {
 *   createCanvas(100, 100, WEBGL);
 * }
 *
 * function draw() {
 *   background(200);
 *   plane(50, 50);
 * }
 * </code>
 * </div>
 *
 * @alt
 * Nothing displayed on canvas
 * Rotating interior view of a box with sides that change color.
 * 3d red and green gradient.
 * Rotating interior view of a cylinder with sides that change color.
 * Rotating view of a cylinder with sides that change color.
 * 3d red and green gradient.
 * rotating view of a multi-colored cylinder with concave sides.
 */
p5.prototype.plane = function(width, height, detailX, detailY) {
  if (typeof width === 'undefined') {
    width = 50;
  }
  if (typeof height === 'undefined') {
    height = width;
  }

  if (typeof detailX === 'undefined') {
    detailX = 1;
  }
  if (typeof detailY === 'undefined') {
    detailY = 1;
  }

  var gId = 'plane|' + detailX + '|' + detailY;

  if (!this._renderer.geometryInHash(gId)) {
    var _plane = function() {
      var u, v, p;
      for (var i = 0; i <= this.detailY; i++) {
        v = i / this.detailY;
        for (var j = 0; j <= this.detailX; j++) {
          u = j / this.detailX;
          p = new p5.Vector(u - 0.5, v - 0.5, 0);
          this.vertices.push(p);
          this.uvs.push([u, v]);
        }
      }
    };
    var planeGeom = new p5.Geometry(detailX, detailY, _plane);
    planeGeom.computeFaces().computeNormals();
    if (detailX <= 1 && detailY <= 1) {
      planeGeom._makeTriangleEdges();
      this._renderer._edgesToVertices(planeGeom);
    } else {
      console.log(
        'Cannot draw stroke on plane objects with more' +
          ' than 1 detailX or 1 detailY'
      );
    }
    this._renderer.createBuffers(gId, planeGeom);
  }

  this._renderer.drawBuffersScaled(gId, width, height, 0);
};

/**
 * Draw a box with given width, height and depth
 * @method  box
 * @param  {Number} [width]     width of the box
 * @param  {Number} [Height]    height of the box
 * @param  {Number} [depth]     depth of the box
 * @param {Integer} [detailX]  Optional number of triangle
 *                            subdivisions in x-dimension
 * @param {Integer} [detailY]  Optional number of triangle
 *                            subdivisions in y-dimension
 * @chainable
 * @example
 * <div>
 * <code>
 * //draw a spinning box with width, height and depth 200
 * function setup() {
 *   createCanvas(100, 100, WEBGL);
 * }
 *
 * function draw() {
 *   background(200);
 *   rotateX(frameCount * 0.01);
 *   rotateY(frameCount * 0.01);
 *   box(50);
 * }
 * </code>
 * </div>
 */
p5.prototype.box = function(width, height, depth, detailX, detailY) {
  if (typeof width === 'undefined') {
    width = 50;
  }
  if (typeof height === 'undefined') {
    height = width;
  }
  if (typeof depth === 'undefined') {
    depth = height;
  }

  if (typeof detailX === 'undefined') {
    detailX = 4;
  }
  if (typeof detailY === 'undefined') {
    detailY = 4;
  }

  var gId = 'box|' + detailX + '|' + detailY;
  if (!this._renderer.geometryInHash(gId)) {
    var _box = function() {
      var cubeIndices = [
        [0, 4, 2, 6], // -1, 0, 0],// -x
        [1, 3, 5, 7], // +1, 0, 0],// +x
        [0, 1, 4, 5], // 0, -1, 0],// -y
        [2, 6, 3, 7], // 0, +1, 0],// +y
        [0, 2, 1, 3], // 0, 0, -1],// -z
        [4, 5, 6, 7] // 0, 0, +1] // +z
      ];
      //using strokeIndices instead of faces for strokes
      //to avoid diagonal stroke lines across face of box
      this.strokeIndices = [
        [0, 1],
        [1, 3],
        [3, 2],
        [6, 7],
        [8, 9],
        [9, 11],
        [14, 15],
        [16, 17],
        [17, 19],
        [18, 19],
        [20, 21],
        [22, 23]
      ];
      for (var i = 0; i < cubeIndices.length; i++) {
        var cubeIndex = cubeIndices[i];
        var v = i * 4;
        for (var j = 0; j < 4; j++) {
          var d = cubeIndex[j];
          //inspired by lightgl:
          //https://github.com/evanw/lightgl.js
          //octants:https://en.wikipedia.org/wiki/Octant_(solid_geometry)
          var octant = new p5.Vector(
            ((d & 1) * 2 - 1) / 2,
            ((d & 2) - 1) / 2,
            ((d & 4) / 2 - 1) / 2
          );
          this.vertices.push(octant);
          this.uvs.push([j & 1, (j & 2) / 2]);
        }
        this.faces.push([v, v + 1, v + 2]);
        this.faces.push([v + 2, v + 1, v + 3]);
      }
    };
    var boxGeom = new p5.Geometry(detailX, detailY, _box);
    boxGeom.computeNormals();
    if (detailX <= 4 && detailY <= 4) {
      boxGeom._makeTriangleEdges();
      this._renderer._edgesToVertices(boxGeom);
    } else {
      console.log(
        'Cannot draw stroke on box objects with more' +
          ' than 4 detailX or 4 detailY'
      );
    }
    //initialize our geometry buffer with
    //the key val pair:
    //geometry Id, Geom object
    this._renderer.createBuffers(gId, boxGeom);
  }
  this._renderer.drawBuffersScaled(gId, width, height, depth);

  return this;
};

/**
 * Draw a sphere with given radius
 * @method sphere
 * @param  {Number} [radius]          radius of circle
 * @param  {Integer} [detailX]        number of segments,
 *                                    the more segments the smoother geometry
 *                                    default is 24
 * @param  {Integer} [detailY]        number of segments,
 *                                    the more segments the smoother geometry
 *                                    default is 16
 * @chainable
 * @example
 * <div>
 * <code>
 * // draw a sphere with radius 200
 * function setup() {
 *   createCanvas(100, 100, WEBGL);
 * }
 *
 * function draw() {
 *   background(200);
 *   sphere(40);
 * }
 * </code>
 * </div>
 */
p5.prototype.sphere = function(radius, detailX, detailY) {
  if (typeof radius === 'undefined') {
    radius = 50;
  }
  if (typeof detailX === 'undefined') {
    detailX = 24;
  }
  if (typeof detailY === 'undefined') {
    detailY = 16;
  }

  this.ellipsoid(radius, radius, radius, detailX, detailY);

  return this;
};

/**
 * @private
 * helper function for creating both cones and cyllinders
 */
var _truncatedCone = function(
  bottomRadius,
  topRadius,
  height,
  detailX,
  detailY,
  topCap,
  bottomCap
) {
  detailX = detailX < 3 ? 3 : detailX;
  detailY = detailY < 1 ? 1 : detailY;
  topCap = topCap === undefined ? true : topCap;
  bottomCap = bottomCap === undefined ? true : bottomCap;
  var extra = (topCap ? 2 : 0) + (bottomCap ? 2 : 0);
  var vertsAroundEdge = detailX + 1;

  // ensure constant slant
  var slant = Math.atan2(bottomRadius - topRadius, height);
  var start = topCap ? -2 : 0;
  var end = detailY + (bottomCap ? 2 : 0);
  var yy, ii;
  for (yy = start; yy <= end; ++yy) {
    var v = yy / detailY;
    var y = height * v;
    var ringRadius;
    if (yy < 0) {
      y = 0;
      v = 1;
      ringRadius = bottomRadius;
    } else if (yy > detailY) {
      y = height;
      v = 1;
      ringRadius = topRadius;
    } else {
      ringRadius = bottomRadius + (topRadius - bottomRadius) * (yy / detailY);
    }
    if (yy === -2 || yy === detailY + 2) {
      ringRadius = 0;
      v = 0;
    }
    y -= height / 2;
    for (ii = 0; ii < vertsAroundEdge; ++ii) {
      //VERTICES
      this.vertices.push(
        new p5.Vector(
          Math.sin(ii * Math.PI * 2 / detailX) * ringRadius,
          y,
          Math.cos(ii * Math.PI * 2 / detailX) * ringRadius
        )
      );
      //VERTEX NORMALS
      this.vertexNormals.push(
        new p5.Vector(
          yy < 0 || yy > detailY
            ? 0
            : Math.sin(ii * Math.PI * 2 / detailX) * Math.cos(slant),
          yy < 0 ? -1 : yy > detailY ? 1 : Math.sin(slant),
          yy < 0 || yy > detailY
            ? 0
            : Math.cos(ii * Math.PI * 2 / detailX) * Math.cos(slant)
        )
      );
      //UVs
      this.uvs.push([ii / detailX, v]);
    }
  }
  for (yy = 0; yy < detailY + extra; ++yy) {
    for (ii = 0; ii < detailX; ++ii) {
      this.faces.push([
        vertsAroundEdge * (yy + 0) + 0 + ii,
        vertsAroundEdge * (yy + 0) + 1 + ii,
        vertsAroundEdge * (yy + 1) + 1 + ii
      ]);
      this.faces.push([
        vertsAroundEdge * (yy + 0) + 0 + ii,
        vertsAroundEdge * (yy + 1) + 1 + ii,
        vertsAroundEdge * (yy + 1) + 0 + ii
      ]);
    }
  }
};

/**
 * Draw a cylinder with given radius and height
 * @method  cylinder
 * @param  {Number} [radius]   radius of the surface
 * @param  {Number} [height]   height of the cylinder
 * @param  {Integer} [detailX] number of segments,
 *                             the more segments the smoother geometry
 *                             default is 24
 * @param {Integer} [detailY]  number of segments in y-dimension,
 *                             the more segments the smoother geometry
 *                             default is 16
 * @chainable
 * @example
 * <div>
 * <code>
 * //draw a spinning cylinder with radius 200 and height 200
 * function setup() {
 *   createCanvas(100, 100, WEBGL);
 * }
 *
 * function draw() {
 *   background(200);
 *   rotateX(frameCount * 0.01);
 *   rotateZ(frameCount * 0.01);
 *   cylinder(20, 50);
 * }
 * </code>
 * </div>
 */
p5.prototype.cylinder = function(radius, height, detailX, detailY) {
  if (typeof radius === 'undefined') {
    radius = 50;
  }
  if (typeof height === 'undefined') {
    height = radius;
  }
  if (typeof detailX === 'undefined') {
    detailX = 24;
  }
  if (typeof detailY === 'undefined') {
    detailY = 16;
  }

  var gId = 'cylinder|' + detailX + '|' + detailY;
  if (!this._renderer.geometryInHash(gId)) {
    var cylinderGeom = new p5.Geometry(detailX, detailY);
    _truncatedCone.call(cylinderGeom, 1, 1, 1, detailX, detailY, true, true);
    cylinderGeom.computeNormals();
    if (detailX <= 24 && detailY <= 16) {
      cylinderGeom._makeTriangleEdges();
      this._renderer._edgesToVertices(cylinderGeom);
    } else {
      console.log(
        'Cannot draw stroke on cylinder objects with more' +
          ' than 24 detailX or 16 detailY'
      );
    }
    this._renderer.createBuffers(gId, cylinderGeom);
  }

  this._renderer.drawBuffersScaled(gId, radius, radius, height);

  return this;
};

/**
 * Draw a cone with given radius and height
 * @method cone
 * @param  {Number} [radius]          radius of the bottom surface
 * @param  {Number} [height]          height of the cone
 * @param  {Integer} [detailX]        number of segments,
 *                                    the more segments the smoother geometry
 *                                    default is 24
 * @param  {Integer} [detailY]        number of segments,
 *                                    the more segments the smoother geometry
 *                                    default is 16
 * @chainable
 * @example
 * <div>
 * <code>
 * //draw a spinning cone with radius 200 and height 200
 * function setup() {
 *   createCanvas(100, 100, WEBGL);
 * }
 *
 * function draw() {
 *   background(200);
 *   rotateX(frameCount * 0.01);
 *   rotateZ(frameCount * 0.01);
 *   cone(40, 70);
 * }
 * </code>
 * </div>
 */
p5.prototype.cone = function(radius, height, detailX, detailY) {
  if (typeof radius === 'undefined') {
    radius = 50;
  }
  if (typeof height === 'undefined') {
    height = radius;
  }
  if (typeof detailX === 'undefined') {
    detailX = 24;
  }
  if (typeof detailY === 'undefined') {
    detailY = 16;
  }

  var gId = 'cone|' + radius + '|' + height + '|' + detailX + '|' + detailY;
  if (!this._renderer.geometryInHash(gId)) {
    var coneGeom = new p5.Geometry(detailX, detailY);
    _truncatedCone.call(
      coneGeom,
      radius,
      0, //top radius 0
      height,
      detailX,
      detailY,
      true,
      true
    );
    //for cones we need to average Normals
    coneGeom.computeNormals();
    if (detailX <= 24 && detailY <= 16) {
      coneGeom._makeTriangleEdges();
      this._renderer._edgesToVertices(coneGeom);
    } else {
      console.log(
        'Cannot draw stroke on cone objects with more' +
          ' than 24 detailX or 16 detailY'
      );
    }
    this._renderer.createBuffers(gId, coneGeom);
  }

  this._renderer.drawBuffers(gId);

  return this;
};

/**
 * Draw an ellipsoid with given radius
 * @method ellipsoid
 * @param  {Number} [radiusx]         xradius of circle
 * @param  {Number} [radiusy]         yradius of circle
 * @param  {Number} [radiusz]         zradius of circle
 * @param  {Integer} [detailX]        number of segments,
 *                                    the more segments the smoother geometry
 *                                    default is 24. Avoid detail number above
 *                                    150, it may crash the browser.
 * @param  {Integer} [detailY]        number of segments,
 *                                    the more segments the smoother geometry
 *                                    default is 16. Avoid detail number above
 *                                    150, it may crash the browser.
 * @chainable
 * @example
 * <div>
 * <code>
 * // draw an ellipsoid with radius 20, 30 and 40.
 * function setup() {
 *   createCanvas(100, 100, WEBGL);
 * }
 *
 * function draw() {
 *   background(200);
 *   ellipsoid(20, 30, 40);
 * }
 * </code>
 * </div>
 */
p5.prototype.ellipsoid = function(radiusX, radiusY, radiusZ, detailX, detailY) {
  if (typeof radiusX === 'undefined') {
    radiusX = 50;
  }
  if (typeof radiusY === 'undefined') {
    radiusY = radiusX;
  }
  if (typeof radiusZ === 'undefined') {
    radiusZ = radiusX;
  }

  if (typeof detailX === 'undefined') {
    detailX = 24;
  }
  if (typeof detailY === 'undefined') {
    detailY = 16;
  }

  var gId = 'ellipsoid|' + detailX + '|' + detailY;

  if (!this._renderer.geometryInHash(gId)) {
    var _ellipsoid = function() {
      for (var i = 0; i <= this.detailY; i++) {
        var v = i / this.detailY;
        var phi = Math.PI * v - Math.PI / 2;
        var cosPhi = Math.cos(phi);
        var sinPhi = Math.sin(phi);

        for (var j = 0; j <= this.detailX; j++) {
          var u = j / this.detailX;
          var theta = 2 * Math.PI * u;
          var cosTheta = Math.cos(theta);
          var sinTheta = Math.sin(theta);
          var p = new p5.Vector(cosPhi * sinTheta, sinPhi, cosPhi * cosTheta);
          this.vertices.push(p);
          this.vertexNormals.push(p);
          this.uvs.push([u, v]);
        }
      }
    };
    var ellipsoidGeom = new p5.Geometry(detailX, detailY, _ellipsoid);
    ellipsoidGeom.computeFaces();
    if (detailX <= 24 && detailY <= 24) {
      ellipsoidGeom._makeTriangleEdges();
      this._renderer._edgesToVertices(ellipsoidGeom);
    } else {
      console.log(
        'Cannot draw stroke on ellipsoids with more' +
          ' than 24 detailX or 24 detailY'
      );
    }
    this._renderer.createBuffers(gId, ellipsoidGeom);
  }

  this._renderer.drawBuffersScaled(gId, radiusX, radiusY, radiusZ);

  return this;
};

/**
 * Draw a torus with given radius and tube radius
 * @method torus
 * @param  {Number} [radius]      radius of the whole ring
 * @param  {Number} [tubeRadius]  radius of the tube
 * @param  {Integer} [detailX]    number of segments in x-dimension,
 *                                the more segments the smoother geometry
 *                                default is 24
 * @param  {Integer} [detailY]    number of segments in y-dimension,
 *                                the more segments the smoother geometry
 *                                default is 16
 * @chainable
 * @example
 * <div>
 * <code>
 * //draw a spinning torus with radius 200 and tube radius 60
 * function setup() {
 *   createCanvas(100, 100, WEBGL);
 * }
 *
 * function draw() {
 *   background(200);
 *   rotateX(frameCount * 0.01);
 *   rotateY(frameCount * 0.01);
 *   torus(50, 15);
 * }
 * </code>
 * </div>
 */
p5.prototype.torus = function(radius, tubeRadius, detailX, detailY) {
  if (typeof radius === 'undefined') {
    radius = 50;
  } else if (!radius) {
    return; // nothing to draw
  }

  if (typeof tubeRadius === 'undefined') {
    tubeRadius = 10;
  } else if (!tubeRadius) {
    return; // nothing to draw
  }

  if (typeof detailX === 'undefined') {
    detailX = 24;
  }
  if (typeof detailY === 'undefined') {
    detailY = 16;
  }

  var tubeRatio = (tubeRadius / radius).toPrecision(4);
  var gId = 'torus|' + tubeRatio + '|' + detailX + '|' + detailY;

  if (!this._renderer.geometryInHash(gId)) {
    var _torus = function() {
      for (var i = 0; i <= this.detailY; i++) {
        var v = i / this.detailY;
        var phi = 2 * Math.PI * v;
        var cosPhi = Math.cos(phi);
        var sinPhi = Math.sin(phi);
        var r = 1 + tubeRatio * cosPhi;

        for (var j = 0; j <= this.detailX; j++) {
          var u = j / this.detailX;
          var theta = 2 * Math.PI * u;
          var cosTheta = Math.cos(theta);
          var sinTheta = Math.sin(theta);

          var p = new p5.Vector(r * cosTheta, r * sinTheta, tubeRatio * sinPhi);

          var n = new p5.Vector(cosPhi * cosTheta, cosPhi * sinTheta, sinPhi);

          this.vertices.push(p);
          this.vertexNormals.push(n);
          this.uvs.push([u, v]);
        }
      }
    };
    var torusGeom = new p5.Geometry(detailX, detailY, _torus);
    torusGeom.computeFaces();
    if (detailX <= 24 && detailY <= 16) {
      torusGeom._makeTriangleEdges();
      this._renderer._edgesToVertices(torusGeom);
    } else {
      console.log(
        'Cannot draw strokes on torus object with more' +
          ' than 24 detailX or 16 detailY'
      );
    }
    this._renderer.createBuffers(gId, torusGeom);
  }
  this._renderer.drawBuffersScaled(gId, radius, radius, radius);

  return this;
};

///////////////////////
/// 2D primitives
/////////////////////////

//@TODO
p5.RendererGL.prototype.point = function(x, y, z) {
  console.log('point not yet implemented in webgl');
  return this;
};

p5.RendererGL.prototype.triangle = function(args) {
  var x1 = args[0],
    y1 = args[1];
  var x2 = args[2],
    y2 = args[3];
  var x3 = args[4],
    y3 = args[5];

  var gId = 'tri';
  if (!this.geometryInHash(gId)) {
    var _triangle = function() {
      var vertices = [];
      vertices.push(new p5.Vector(0, 0, 0));
      vertices.push(new p5.Vector(0, 1, 0));
      vertices.push(new p5.Vector(1, 0, 0));
      this.strokeIndices = [[0, 1], [1, 2], [2, 0]];
      this.vertices = vertices;
      this.faces = [[0, 1, 2]];
      this.uvs = [[0, 0], [0, 1], [1, 1]];
    };
    var triGeom = new p5.Geometry(1, 1, _triangle);
    triGeom._makeTriangleEdges();
    this._edgesToVertices(triGeom);
    triGeom.computeNormals();
    this.createBuffers(gId, triGeom);
  }

  // only one triangle is cached, one point is at the origin, and the
  // two adjacent sides are tne unit vectors along the X & Y axes.
  //
  // this matrix multiplication transforms those two unit vectors
  // onto the required vector prior to rendering, and moves the
  // origin appropriately.
  var uMVMatrix = this.uMVMatrix.copy();
  try {
    // prettier-ignore
    var mult = new p5.Matrix([
      x2 - x1, y2 - y1, 0, 0, // the resulting unit X-axis
      x3 - x1, y3 - y1, 0, 0, // the resulting unit Y-axis
      0, 0, 1, 0,             // the resulting unit Z-axis (unchanged)
      x1, y1, 0, 1            // the resulting origin
    ]).mult(this.uMVMatrix);

    this.uMVMatrix = mult;

    this.drawBuffers(gId);
  } finally {
    this.uMVMatrix = uMVMatrix;
  }

  return this;
};

p5.RendererGL.prototype.ellipse = function(args) {
  var x = args[0];
  var y = args[1];
  var width = args[2];
  var height = args[3];
  //detailX and Y are optional 6th & 7th
  //arguments
  var detailX = args[4] || 24;
  var gId = 'ellipse|' + detailX;
  if (!this.geometryInHash(gId)) {
    var _ellipse = function() {
      this.vertices.push(new p5.Vector(0.5, 0.5, 0));
      this.uvs.push([0.5, 0.5]);

      for (var i = 0; i <= this.detailX; i++) {
        var u = i / this.detailX;
        var theta = 2 * Math.PI * u;

        var _x = 0.5 + Math.cos(theta) / 2;
        var _y = 0.5 + Math.sin(theta) / 2;

        this.vertices.push(new p5.Vector(_x, _y, 0));
        this.uvs.push([_x, _y]);

        this.faces.push([0, (i + 1) % this.detailX + 1, i + 1]);
      }
    };
    var ellipseGeom = new p5.Geometry(detailX, 1, _ellipse);
    ellipseGeom.computeNormals();
    if (detailX <= 50) {
      ellipseGeom._makeTriangleEdges();
      this._edgesToVertices(ellipseGeom);
    } else {
      console.log('Cannot stroke ellipse with more than 50 detailX');
    }

    this.createBuffers(gId, ellipseGeom);
  }

  // only a single ellipse (of a given detail) is cached: a circle of
  // _diameter_ 1 (radius 0.5).
  //
  // before rendering, this circle is squished (technical term ;)
  // appropriately and moved to the required location.
  var uMVMatrix = this.uMVMatrix.copy();
  try {
    this.uMVMatrix.translate([x, y, 0]);
    this.uMVMatrix.scale(width, height, 1);

    this.drawBuffers(gId);
  } finally {
    this.uMVMatrix = uMVMatrix;
  }
  return this;
};

p5.RendererGL.prototype.rect = function(args) {
  var x = args[0];
  var y = args[1];
  var width = args[2];
  var height = args[3];
  var detailX = args[4] || 24;
  var detailY = args[5] || 16;
  var gId = 'rect|' + detailX + '|' + detailY;
  if (!this.geometryInHash(gId)) {
    var _rect = function() {
      for (var i = 0; i <= this.detailY; i++) {
        var v = i / this.detailY;
        for (var j = 0; j <= this.detailX; j++) {
          var u = j / this.detailX;
          var p = new p5.Vector(u, v, 0);
          this.vertices.push(p);
          this.uvs.push([u, v]);
        }
      }
    };
    var rectGeom = new p5.Geometry(detailX, detailY, _rect);
    rectGeom
      .computeFaces()
      .computeNormals()
      ._makeTriangleEdges();
    this._edgesToVertices(rectGeom);
    this.createBuffers(gId, rectGeom);
  }

  // only a single rectangle (of a given detail) is cached: a square with
  // opposite corners at (0,0) & (1,1).
  //
  // before rendering, this square is scaled & moved to the required location.
  var uMVMatrix = this.uMVMatrix.copy();
  try {
    this.uMVMatrix.translate([x, y, 0]);
    this.uMVMatrix.scale(width, height, 1);

    this.drawBuffers(gId);
  } finally {
    this.uMVMatrix = uMVMatrix;
  }
  return this;
};

p5.RendererGL.prototype.quad = function(x1, y1, x2, y2, x3, y3, x4, y4) {
  var gId =
    'quad|' +
    x1 +
    '|' +
    y1 +
    '|' +
    x2 +
    '|' +
    y2 +
    '|' +
    x3 +
    '|' +
    y3 +
    '|' +
    x4 +
    '|' +
    y4;
  if (!this.geometryInHash(gId)) {
    var _quad = function() {
      this.vertices.push(new p5.Vector(x1, y1, 0));
      this.vertices.push(new p5.Vector(x2, y2, 0));
      this.vertices.push(new p5.Vector(x3, y3, 0));
      this.vertices.push(new p5.Vector(x4, y4, 0));
      this.uvs.push([0, 0], [1, 0], [1, 1], [0, 1]);
      this.strokeIndices = [[0, 1], [1, 2], [2, 3], [3, 0]];
    };
    var quadGeom = new p5.Geometry(2, 2, _quad);
    quadGeom.computeNormals()._makeTriangleEdges();
    this._edgesToVertices(quadGeom);
    quadGeom.faces = [[0, 1, 2], [2, 3, 0]];
    this.createBuffers(gId, quadGeom);
  }
  this.drawBuffers(gId);
  return this;
};

//this implementation of bezier curve
//is based on Bernstein polynomial
// pretier-ignore
p5.RendererGL.prototype.bezier = function(
  x1,
  y1,
  z1,
  x2,
  y2,
  z2,
  x3,
  y3,
  z3,
  x4,
  y4,
  z4
) {
  var bezierDetail = this._pInst._bezierDetail || 20; //value of Bezier detail
  this.beginShape();
  for (var i = 0; i <= bezierDetail; i++) {
    var c1 = Math.pow(1 - i / bezierDetail, 3);
    var c2 = 3 * (i / bezierDetail) * Math.pow(1 - i / bezierDetail, 2);
    var c3 = 3 * Math.pow(i / bezierDetail, 2) * (1 - i / bezierDetail);
    var c4 = Math.pow(i / bezierDetail, 3);
    this.vertex(
      x1 * c1 + x2 * c2 + x3 * c3 + x4 * c4,
      y1 * c1 + y2 * c2 + y3 * c3 + y4 * c4,
      z1 * c1 + z2 * c2 + z3 * c3 + z4 * c4
    );
  }
  this.endShape();
  return this;
};

// pretier-ignore
p5.RendererGL.prototype.curve = function(
  x1,
  y1,
  z1,
  x2,
  y2,
  z2,
  x3,
  y3,
  z3,
  x4,
  y4,
  z4
) {
  var curveDetail = this._pInst._curveDetail;
  this.beginShape();
  for (var i = 0; i <= curveDetail; i++) {
    var c1 = Math.pow(i / curveDetail, 3) * 0.5;
    var c2 = Math.pow(i / curveDetail, 2) * 0.5;
    var c3 = i / curveDetail * 0.5;
    var c4 = 0.5;
    var vx =
      c1 * (-x1 + 3 * x2 - 3 * x3 + x4) +
      c2 * (2 * x1 - 5 * x2 + 4 * x3 - x4) +
      c3 * (-x1 + x3) +
      c4 * (2 * x2);
    var vy =
      c1 * (-y1 + 3 * y2 - 3 * y3 + y4) +
      c2 * (2 * y1 - 5 * y2 + 4 * y3 - y4) +
      c3 * (-y1 + y3) +
      c4 * (2 * y2);
    var vz =
      c1 * (-z1 + 3 * z2 - 3 * z3 + z4) +
      c2 * (2 * z1 - 5 * z2 + 4 * z3 - z4) +
      c3 * (-z1 + z3) +
      c4 * (2 * z2);
    this.vertex(vx, vy, vz);
  }
  this.endShape();
  return this;
};

/**
 * Draw a line given two points
 * @private
 * @param {Number} x0 x-coordinate of first vertex
 * @param {Number} y0 y-coordinate of first vertex
 * @param {Number} z0 z-coordinate of first vertex
 * @param {Number} x1 x-coordinate of second vertex
 * @param {Number} y1 y-coordinate of second vertex
 * @param {Number} z1 z-coordinate of second vertex
 * @chainable
 * @example
 * <div>
 * <code>
 * //draw a line
 * function setup() {
 *   createCanvas(100, 100, WEBGL);
 * }
 *
 * function draw() {
 *   background(200);
 *   rotateX(frameCount * 0.01);
 *   rotateY(frameCount * 0.01);
 *   // Use fill instead of stroke to change the color of shape.
 *   fill(255, 0, 0);
 *   line(10, 10, 0, 60, 60, 20);
 * }
 * </code>
 * </div>
 */
p5.RendererGL.prototype.line = function() {
  if (arguments.length === 6) {
    this.beginShape();
    this.vertex(arguments[0], arguments[1], arguments[2]);
    this.vertex(arguments[3], arguments[4], arguments[5]);
    this.endShape();
  } else if (arguments.length === 4) {
    this.beginShape();
    this.vertex(arguments[0], arguments[1], 0);
    this.vertex(arguments[2], arguments[3], 0);
    this.endShape();
  }
  return this;
};

module.exports = p5;

},{"../core/core":22,"./p5.Geometry":69}]},{},[13])(13)
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(96);

__webpack_require__(479);

var _reactRouter = __webpack_require__(18);

var _Navigation = __webpack_require__(42);

var _Navigation2 = _interopRequireDefault(_Navigation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = _react2.default.createElement("div", { className: "app-image" });

var _ref2 = _react2.default.createElement(_Navigation2.default, null);

var Home = function (_React$Component) {
  _inherits(Home, _React$Component);

  function Home() {
    _classCallCheck(this, Home);

    return _possibleConstructorReturn(this, (Home.__proto__ || Object.getPrototypeOf(Home)).apply(this, arguments));
  }

  _createClass(Home, [{
    key: "render",
    value: function render() {
      var apps = [{
        name: "LinkedIn",
        url: "https://www.linkedin.com/in/eric-dudley-894721106",
        icon: "fab fa-linkedin",
        same_page: false,
        internal: false
      }, {
        name: "Resume",
        url: "/resume",
        icon: "fas fa-user",
        same_page: true,
        internal: true
      }, {
        name: "Email",
        url: "mailto:contact@ericdudley.com",
        icon: "fas fa-envelope",
        same_page: false,
        internal: false
      }, {
        name: "GitHub",
        url: "https://github.com/ericdudley",
        icon: "fab fa-github",
        same_page: false
      }, {
        image: "../images/me.jpg"
      }, {
        name: "GitLab",
        url: "https://gitlab.com/ericdudley/personal-website",
        icon: "fab fa-gitlab",
        same_page: false,
        internal: false
      }, {
        name: "Photos",
        url: "/photographer",
        icon: "fas fa-camera",
        same_page: true,
        internal: true
      }, {
        name: "Stretch",
        url: "/stretch",
        icon: "fas fa-child",
        same_page: true,
        internal: true
      }, {
        name: "Instagram",
        url: "https://www.instagram.com/ericdudleyphotography/",
        icon: "fab fa-instagram",
        same_page: false,
        internal: false
      }];

      var apps_markup = [];
      for (var i = 0; i < apps.length; i++) {
        var app = apps[i];
        var app_content = _react2.default.createElement(
          "div",
          { className: "app-wrapper" },
          app.image && _ref,
          app.icon && _react2.default.createElement(
            "div",
            null,
            _react2.default.createElement("i", { className: "app-icon " + app.icon }),
            _react2.default.createElement(
              "span",
              { className: "app-name" },
              app.name
            )
          )
        );
        apps_markup.push(_react2.default.createElement(
          "div",
          { className: "app-grid-item", key: "app" + i },
          app.internal ? _react2.default.createElement(
            _reactRouter.Link,
            { to: app.url },
            app_content
          ) : _react2.default.createElement(
            "a",
            {
              href: app.url,
              target: app.same_page ? "_self" : "_blank",
              key: "app" + i
            },
            app_content
          )
        ));
      }

      return _react2.default.createElement(
        "div",
        { id: "home" },
        _ref2,
        _react2.default.createElement(
          "section",
          null,
          apps_markup
        )
      );
    }
  }]);

  return Home;
}(_react2.default.Component);

exports.default = Home;

/***/ }),
/* 479 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 480 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(18);

var _Navigation = __webpack_require__(42);

var _Navigation2 = _interopRequireDefault(_Navigation);

__webpack_require__(482);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = _react2.default.createElement(_Navigation2.default, null);

var _ref2 = _react2.default.createElement(
    "div",
    { id: "form-wrapper" },
    _react2.default.createElement(
        "iframe",
        { src: "https://docs.google.com/forms/d/e/1FAIpQLSez5iKaq3HPLxuyaanSlatcdAyjuJJFGfVSsbmy5Hpy5uia0Q/viewform?embedded=true", frameBorder: "0", marginHeight: "0", marginWidth: "0" },
        _react2.default.createElement(
            "p",
            null,
            "Loading..."
        )
    )
);

var _ref3 = _react2.default.createElement("i", { className: "fa fa-arrow-left" });

var Tutor = function (_React$Component) {
    _inherits(Tutor, _React$Component);

    function Tutor() {
        _classCallCheck(this, Tutor);

        return _possibleConstructorReturn(this, (Tutor.__proto__ || Object.getPrototypeOf(Tutor)).apply(this, arguments));
    }

    _createClass(Tutor, [{
        key: "render",
        value: function render() {
            return _react2.default.createElement(
                "div",
                { id: "tutor" },
                _ref,
                _ref2,
                _react2.default.createElement(
                    _reactRouter.Link,
                    { to: "/", className: "link back-link" },
                    _ref3,
                    " back"
                )
            );
        }
    }]);

    return Tutor;
}(_react2.default.Component);

exports.default = Tutor;

/***/ }),
/* 482 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(18);

var _GalleryImage = __webpack_require__(484);

var _GalleryImage2 = _interopRequireDefault(_GalleryImage);

var _Navigation = __webpack_require__(42);

var _Navigation2 = _interopRequireDefault(_Navigation);

__webpack_require__(485);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = _react2.default.createElement(_Navigation2.default, null);

var _ref2 = _react2.default.createElement("i", { className: "fa fa-arrow-left" });

var Gallery = function (_React$Component) {
    _inherits(Gallery, _React$Component);

    function Gallery(props) {
        _classCallCheck(this, Gallery);

        var _this = _possibleConstructorReturn(this, (Gallery.__proto__ || Object.getPrototypeOf(Gallery)).call(this, props));

        _this.toggleClass = _this.toggleClass.bind(_this);
        _this.state = {
            active: false
        };
        return _this;
    }

    _createClass(Gallery, [{
        key: "toggleClass",
        value: function toggleClass() {
            var currentState = this.state.active;
            this.setState({ active: !currentState });
        }
    }, {
        key: "render",
        value: function render() {
            var imgs = [];
            var img_urls = ['', 'https://farm5.staticflickr.com/4671/40345782811_946266acf4_z_d.jpg', 'https://farm5.staticflickr.com/4768/38536175000_0206dbefb0_z_d.jpg', 'https://farm5.staticflickr.com/4614/39058022605_125dac47f7_z_d.jpg', 'https://farm5.staticflickr.com/4654/39074618174_5997d5f1ff_z_d.jpg', 'https://farm5.staticflickr.com/4668/27914325389_49f087381e_z_d.jpg', 'https://farm5.staticflickr.com/4742/27953826449_a7319f71a4_z_d.jpg', 'https://farm5.staticflickr.com/4648/27914320439_1485814a29_z_d.jpg', 'https://farm5.staticflickr.com/4678/28006486799_b758508e36_z_d.jpg', 'https://farm5.staticflickr.com/4629/24824385937_76ccdcac2b_z_d.jpg'];
            for (var i = 1; i <= 9; i++) {
                imgs.push(_react2.default.createElement(_GalleryImage2.default, { url: img_urls[i], num: i, key: "img" + i }));
            }
            return _react2.default.createElement(
                "div",
                { id: "gallery" },
                _ref,
                _react2.default.createElement(
                    "section",
                    { id: "images" },
                    imgs
                ),
                _react2.default.createElement(
                    "section",
                    { id: "bottom-buttons" },
                    _react2.default.createElement(
                        _reactRouter.Link,
                        { to: "/", className: "link back-link" },
                        _ref2,
                        " back"
                    )
                )
            );
        }
    }]);

    return Gallery;
}(_react2.default.Component);

exports.default = Gallery;

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GalleryImage = function (_React$Component) {
    _inherits(GalleryImage, _React$Component);

    function GalleryImage(props) {
        _classCallCheck(this, GalleryImage);

        var _this = _possibleConstructorReturn(this, (GalleryImage.__proto__ || Object.getPrototypeOf(GalleryImage)).call(this, props));

        _this.toggleClass = _this.toggleClass.bind(_this);
        _this.state = {
            active: false
        };
        return _this;
    }

    _createClass(GalleryImage, [{
        key: "toggleClass",
        value: function toggleClass() {
            var currentState = this.state.active;
            this.setState({ active: !currentState });
        }
    }, {
        key: "render",
        value: function render() {
            return _react2.default.createElement("img", { className: "gimg" + this.props.num + (this.state.active ? ' selected' : ""), src: this.props.url, onClick: this.toggleClass });
        }
    }]);

    return GalleryImage;
}(_react2.default.Component);

GalleryImage.PropTypes = {
    num: _propTypes2.default.number
};

exports.default = GalleryImage;

/***/ }),
/* 485 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(18);

var _Navigation = __webpack_require__(42);

var _Navigation2 = _interopRequireDefault(_Navigation);

__webpack_require__(487);

var _reactColor = __webpack_require__(488);

var _Visualizer = __webpack_require__(643);

var _Visualizer2 = _interopRequireDefault(_Visualizer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// import "../images/tiger.mp4";


// import "../sounds/jazzy.mp3";
var _ref = _react2.default.createElement(_Navigation2.default, null);

var _ref2 = _react2.default.createElement(
    "h1",
    { className: "no-mobile" },
    "Not currently supported on mobile!"
);

var _ref3 = _react2.default.createElement(
    "video",
    { id: "video", width: "480", height: "270", autoPlay: true, loop: true, muted: true },
    _react2.default.createElement("source", { src: "tiger.mp4", type: "video/mp4" })
);

var _ref4 = _react2.default.createElement("br", null);

var _ref5 = _react2.default.createElement("canvas", { width: "480", height: "270", id: "vcanvas1" });

var _ref6 = _react2.default.createElement("br", null);

var _ref7 = _react2.default.createElement("i", { className: "fa fa-arrow-left" });

var Performer = function (_React$Component) {
    _inherits(Performer, _React$Component);

    function Performer() {
        _classCallCheck(this, Performer);

        return _possibleConstructorReturn(this, (Performer.__proto__ || Object.getPrototypeOf(Performer)).apply(this, arguments));
    }

    _createClass(Performer, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            var self = this;
            self.initframe = null;
            self.sr = 0;
            self.sg = 0;
            self.sb = 0;
            self.tolerance = 50;
            var v = document.getElementById('video');
            v.playbackRate = 1.08;
            var canvas = document.getElementById('vcanvas1');
            var context = canvas.getContext('2d');

            canvas.width = v.width;
            canvas.height = v.height;

            if (window.innerWidth >= 768) {
                self.resetColor();
                v.addEventListener('play', function () {
                    self.draw(this, context, canvas.width, canvas.height);
                }, false);
            }
        }
    }, {
        key: "draw",
        value: function draw(v, c, w, h) {
            var self = this;
            if (v.paused || v.ended) return false;
            c.drawImage(v, 0, 0, w, h);
            if (self.initframe == null) {
                self.initframe = c.getImageData(0, 0, w, h).data;
            }
            var idata = c.getImageData(0, 0, w, h);
            var data = idata.data;
            for (var i = 0; i < data.length; i += 4) {
                var r = data[i];
                var g = data[i + 1];
                var b = data[i + 2];
                // let ir = self.initframe[i];
                // let ig = self.initframe[i+1];
                // let ib = self.initframe[i+2];
                // let pr = self.prevframe[i];
                // let pg = self.prevframe[i+1];
                // let pb = self.prevframe[i+2];
                var brightness = 3 * r + 4 * g + b >>> 3;
                // let ibrightness = (3*ir+4*ig+ib)>>>3;
                // let pbrightness = (3*pr+4*pg+pb)>>>3;
                if (data[i] <= self.sr + self.tolerance && data[i] >= self.sr - self.tolerance && data[i + 1] <= self.sg + self.tolerance && data[i + 1] >= self.sg - self.tolerance && data[i + 2] <= self.sb + self.tolerance && data[i + 2] >= self.sb - self.tolerance) {
                    data[i] = 0;
                    data[i + 1] = 0;
                    data[i + 2] = 0;
                    data[i + 3] = 0;
                }
                if (self.tolerance < 100) {
                    self.tolerance += 0.001;
                }
            }
            idata.data.set(data);
            c.putImageData(idata, 0, 0);
            self.prevframe = data;
            setTimeout(function () {
                self.draw(v, c, w, h);
            }, 30);
        }
    }, {
        key: "colorChange",
        value: function colorChange(color) {
            this.sr = color.rgb.r;
            this.sg = color.rgb.g;
            this.sb = color.rgb.b;
        }
    }, {
        key: "resetColor",
        value: function resetColor() {
            this.sr = 0;
            this.sg = 255;
            this.sb = 0;
        }
    }, {
        key: "render",
        value: function render() {
            return _react2.default.createElement(
                "div",
                { id: "performer" },
                _ref,
                _ref2,
                _react2.default.createElement(_reactColor.SliderPicker, { onChange: this.colorChange.bind(this), color: "rgb(0,255,0)" }),
                _react2.default.createElement("div", { className: "green-screen", onClick: this.resetColor.bind(this) }),
                _ref3,
                _ref4,
                _ref5,
                _ref6,
                _react2.default.createElement(_Visualizer2.default, {
                    model: {
                        path: 'jazzy.mp3',
                        author: 'Ben Sound',
                        title: 'Jazzy'
                    },
                    options: {
                        autoplay: window.innerWidth >= 768
                    },
                    width: "480px",
                    height: "400px"
                }),
                _react2.default.createElement(
                    _reactRouter.Link,
                    { to: "/", className: "link back-link" },
                    _ref7,
                    " back"
                )
            );
        }
    }]);

    return Performer;
}(_react2.default.Component);

exports.default = Performer;

/***/ }),
/* 487 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomPicker = exports.TwitterPicker = exports.SwatchesPicker = exports.SliderPicker = exports.SketchPicker = exports.PhotoshopPicker = exports.MaterialPicker = exports.HuePicker = exports.GithubPicker = exports.CompactPicker = exports.ChromePicker = exports.default = exports.CirclePicker = exports.BlockPicker = exports.AlphaPicker = undefined;

var _Alpha = __webpack_require__(489);

Object.defineProperty(exports, 'AlphaPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Alpha).default;
  }
});

var _Block = __webpack_require__(610);

Object.defineProperty(exports, 'BlockPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Block).default;
  }
});

var _Circle = __webpack_require__(612);

Object.defineProperty(exports, 'CirclePicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Circle).default;
  }
});

var _Chrome = __webpack_require__(614);

Object.defineProperty(exports, 'ChromePicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Chrome).default;
  }
});

var _Compact = __webpack_require__(618);

Object.defineProperty(exports, 'CompactPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Compact).default;
  }
});

var _Github = __webpack_require__(621);

Object.defineProperty(exports, 'GithubPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Github).default;
  }
});

var _Hue = __webpack_require__(623);

Object.defineProperty(exports, 'HuePicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Hue).default;
  }
});

var _Material = __webpack_require__(625);

Object.defineProperty(exports, 'MaterialPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Material).default;
  }
});

var _Photoshop = __webpack_require__(626);

Object.defineProperty(exports, 'PhotoshopPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Photoshop).default;
  }
});

var _Sketch = __webpack_require__(632);

Object.defineProperty(exports, 'SketchPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Sketch).default;
  }
});

var _Slider = __webpack_require__(635);

Object.defineProperty(exports, 'SliderPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Slider).default;
  }
});

var _Swatches = __webpack_require__(639);

Object.defineProperty(exports, 'SwatchesPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Swatches).default;
  }
});

var _Twitter = __webpack_require__(642);

Object.defineProperty(exports, 'TwitterPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Twitter).default;
  }
});

var _ColorWrap = __webpack_require__(192);

Object.defineProperty(exports, 'CustomPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ColorWrap).default;
  }
});

var _Chrome2 = _interopRequireDefault(_Chrome);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Chrome2.default;

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlphaPicker = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(3);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _common = __webpack_require__(7);

var _AlphaPointer = __webpack_require__(609);

var _AlphaPointer2 = _interopRequireDefault(_AlphaPointer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlphaPicker = exports.AlphaPicker = function AlphaPicker(_ref) {
  var rgb = _ref.rgb,
      hsl = _ref.hsl,
      width = _ref.width,
      height = _ref.height,
      onChange = _ref.onChange,
      direction = _ref.direction,
      style = _ref.style,
      renderers = _ref.renderers,
      pointer = _ref.pointer,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)({
    'default': {
      picker: {
        position: 'relative',
        width: width,
        height: height
      },
      alpha: {
        radius: '2px',
        style: style
      }
    }
  });

  return _react2.default.createElement(
    'div',
    { style: styles.picker, className: 'alpha-picker ' + className },
    _react2.default.createElement(_common.Alpha, _extends({}, styles.alpha, {
      rgb: rgb,
      hsl: hsl,
      pointer: pointer,
      renderers: renderers,
      onChange: onChange,
      direction: direction
    }))
  );
};

AlphaPicker.defaultProps = {
  width: '316px',
  height: '16px',
  direction: 'horizontal',
  pointer: _AlphaPointer2.default
};

exports.default = (0, _common.ColorWrap)(AlphaPicker);

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.flattenNames = undefined;

var _isString2 = __webpack_require__(491);

var _isString3 = _interopRequireDefault(_isString2);

var _forOwn2 = __webpack_require__(97);

var _forOwn3 = _interopRequireDefault(_forOwn2);

var _isPlainObject2 = __webpack_require__(504);

var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);

var _map2 = __webpack_require__(26);

var _map3 = _interopRequireDefault(_map2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var flattenNames = exports.flattenNames = function flattenNames() {
  var things = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var names = [];

  (0, _map3.default)(things, function (thing) {
    if (Array.isArray(thing)) {
      flattenNames(thing).map(function (name) {
        return names.push(name);
      });
    } else if ((0, _isPlainObject3.default)(thing)) {
      (0, _forOwn3.default)(thing, function (value, key) {
        value === true && names.push(key);
        names.push(key + '-' + value);
      });
    } else if ((0, _isString3.default)(thing)) {
      names.push(thing);
    }
  });

  return names;
};

exports.default = flattenNames;

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(29),
    isArray = __webpack_require__(13),
    isObjectLike = __webpack_require__(30);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(49);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 493 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(495);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 495 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 496 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(29),
    isObjectLike = __webpack_require__(30);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 498 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(29),
    isLength = __webpack_require__(99),
    isObjectLike = __webpack_require__(30);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 500 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(157);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(48)(module)))

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(100),
    nativeKeys = __webpack_require__(503);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(163);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(29),
    getPrototype = __webpack_require__(101),
    isObjectLike = __webpack_require__(30);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(506),
    baseMatchesProperty = __webpack_require__(548),
    identity = __webpack_require__(166),
    isArray = __webpack_require__(13),
    property = __webpack_require__(558);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(507),
    getMatchData = __webpack_require__(547),
    matchesStrictComparable = __webpack_require__(180);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(102),
    baseIsEqual = __webpack_require__(169);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 508 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(60);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(60);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(60);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(60);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(59);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 514 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 515 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 516 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(59),
    Map = __webpack_require__(104),
    MapCache = __webpack_require__(105);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(164),
    isMasked = __webpack_require__(519),
    isObject = __webpack_require__(22),
    toSource = __webpack_require__(168);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(520);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(15);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 521 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(523),
    ListCache = __webpack_require__(59),
    Map = __webpack_require__(104);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(524),
    hashDelete = __webpack_require__(525),
    hashGet = __webpack_require__(526),
    hashHas = __webpack_require__(527),
    hashSet = __webpack_require__(528);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(61);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 525 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(61);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(61);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(61);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(62);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 530 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(62);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(62);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(62);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(102),
    equalArrays = __webpack_require__(170),
    equalByTag = __webpack_require__(540),
    equalObjects = __webpack_require__(541),
    getTag = __webpack_require__(178),
    isArray = __webpack_require__(13),
    isBuffer = __webpack_require__(98),
    isTypedArray = __webpack_require__(162);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(105),
    setCacheAdd = __webpack_require__(536),
    setCacheHas = __webpack_require__(537);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 536 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 537 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 538 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 539 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(49),
    Uint8Array = __webpack_require__(171),
    eq = __webpack_require__(103),
    equalArrays = __webpack_require__(170),
    mapToArray = __webpack_require__(172),
    setToArray = __webpack_require__(173);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(174);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 542 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(31),
    root = __webpack_require__(15);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(31),
    root = __webpack_require__(15);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(31),
    root = __webpack_require__(15);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(31),
    root = __webpack_require__(15);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(179),
    keys = __webpack_require__(50);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(169),
    get = __webpack_require__(549),
    hasIn = __webpack_require__(555),
    isKey = __webpack_require__(107),
    isStrictComparable = __webpack_require__(179),
    matchesStrictComparable = __webpack_require__(180),
    toKey = __webpack_require__(64);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(181);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(551);

/** Used to match property names within property paths. */
var reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(552);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(105);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(554);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(49),
    arrayMap = __webpack_require__(167),
    isArray = __webpack_require__(13),
    isSymbol = __webpack_require__(63);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(556),
    hasPath = __webpack_require__(557);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 556 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(182),
    isArguments = __webpack_require__(160),
    isArray = __webpack_require__(13),
    isIndex = __webpack_require__(161),
    isLength = __webpack_require__(99),
    toKey = __webpack_require__(64);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(559),
    basePropertyDeep = __webpack_require__(560),
    isKey = __webpack_require__(107),
    toKey = __webpack_require__(64);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 559 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(181);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(183),
    isArrayLike = __webpack_require__(58);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(58);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeClasses = undefined;

var _forOwn2 = __webpack_require__(97);

var _forOwn3 = _interopRequireDefault(_forOwn2);

var _cloneDeep2 = __webpack_require__(564);

var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mergeClasses = exports.mergeClasses = function mergeClasses(classes) {
  var activeNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var styles = classes.default && (0, _cloneDeep3.default)(classes.default) || {};
  activeNames.map(function (name) {
    var toMerge = classes[name];
    if (toMerge) {
      (0, _forOwn3.default)(toMerge, function (value, key) {
        if (!styles[key]) {
          styles[key] = {};
        }

        styles[key] = _extends({}, styles[key], toMerge[key]);
      });
    }

    return name;
  });
  return styles;
};

exports.default = mergeClasses;

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(565);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

module.exports = cloneDeep;


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(102),
    arrayEach = __webpack_require__(184),
    assignValue = __webpack_require__(185),
    baseAssign = __webpack_require__(567),
    baseAssignIn = __webpack_require__(568),
    cloneBuffer = __webpack_require__(571),
    copyArray = __webpack_require__(572),
    copySymbols = __webpack_require__(573),
    copySymbolsIn = __webpack_require__(574),
    getAllKeys = __webpack_require__(174),
    getAllKeysIn = __webpack_require__(575),
    getTag = __webpack_require__(178),
    initCloneArray = __webpack_require__(576),
    initCloneByTag = __webpack_require__(577),
    initCloneObject = __webpack_require__(586),
    isArray = __webpack_require__(13),
    isBuffer = __webpack_require__(98),
    isObject = __webpack_require__(22),
    keys = __webpack_require__(50);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, baseClone, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(31);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(65),
    keys = __webpack_require__(50);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(65),
    keysIn = __webpack_require__(187);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(22),
    isPrototype = __webpack_require__(100),
    nativeKeysIn = __webpack_require__(570);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 570 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(15);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(48)(module)))

/***/ }),
/* 572 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(65),
    getSymbols = __webpack_require__(106);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(65),
    getSymbolsIn = __webpack_require__(188);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(175),
    getSymbolsIn = __webpack_require__(188),
    keysIn = __webpack_require__(187);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),
/* 576 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(108),
    cloneDataView = __webpack_require__(578),
    cloneMap = __webpack_require__(579),
    cloneRegExp = __webpack_require__(581),
    cloneSet = __webpack_require__(582),
    cloneSymbol = __webpack_require__(584),
    cloneTypedArray = __webpack_require__(585);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, cloneFunc, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return cloneMap(object, isDeep, cloneFunc);

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return cloneSet(object, isDeep, cloneFunc);

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(108);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

var addMapEntry = __webpack_require__(580),
    arrayReduce = __webpack_require__(189),
    mapToArray = __webpack_require__(172);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1;

/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */
function cloneMap(map, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
  return arrayReduce(array, addMapEntry, new map.constructor);
}

module.exports = cloneMap;


/***/ }),
/* 580 */
/***/ (function(module, exports) {

/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */
function addMapEntry(map, pair) {
  // Don't return `map.set` because it's not chainable in IE 11.
  map.set(pair[0], pair[1]);
  return map;
}

module.exports = addMapEntry;


/***/ }),
/* 581 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

var addSetEntry = __webpack_require__(583),
    arrayReduce = __webpack_require__(189),
    setToArray = __webpack_require__(173);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1;

/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */
function cloneSet(set, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
  return arrayReduce(array, addSetEntry, new set.constructor);
}

module.exports = cloneSet;


/***/ }),
/* 583 */
/***/ (function(module, exports) {

/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */
function addSetEntry(set, value) {
  // Don't return `set.add` because it's not chainable in IE 11.
  set.add(value);
  return set;
}

module.exports = addSetEntry;


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(49);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(108);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(587),
    getPrototype = __webpack_require__(101),
    isPrototype = __webpack_require__(100);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(22);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.autoprefix = undefined;

var _forOwn2 = __webpack_require__(97);

var _forOwn3 = _interopRequireDefault(_forOwn2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var transforms = {
  borderRadius: function borderRadius(value) {
    return {
      msBorderRadius: value,
      MozBorderRadius: value,
      OBorderRadius: value,
      WebkitBorderRadius: value,
      borderRadius: value
    };
  },
  boxShadow: function boxShadow(value) {
    return {
      msBoxShadow: value,
      MozBoxShadow: value,
      OBoxShadow: value,
      WebkitBoxShadow: value,
      boxShadow: value
    };
  },
  userSelect: function userSelect(value) {
    return {
      WebkitTouchCallout: value,
      KhtmlUserSelect: value,
      MozUserSelect: value,
      msUserSelect: value,
      WebkitUserSelect: value,
      userSelect: value
    };
  },

  flex: function flex(value) {
    return {
      WebkitBoxFlex: value,
      MozBoxFlex: value,
      WebkitFlex: value,
      msFlex: value,
      flex: value
    };
  },
  flexBasis: function flexBasis(value) {
    return {
      WebkitFlexBasis: value,
      flexBasis: value
    };
  },
  justifyContent: function justifyContent(value) {
    return {
      WebkitJustifyContent: value,
      justifyContent: value
    };
  },

  transition: function transition(value) {
    return {
      msTransition: value,
      MozTransition: value,
      OTransition: value,
      WebkitTransition: value,
      transition: value
    };
  },

  transform: function transform(value) {
    return {
      msTransform: value,
      MozTransform: value,
      OTransform: value,
      WebkitTransform: value,
      transform: value
    };
  },
  absolute: function absolute(value) {
    var direction = value && value.split(' ');
    return {
      position: 'absolute',
      top: direction && direction[0],
      right: direction && direction[1],
      bottom: direction && direction[2],
      left: direction && direction[3]
    };
  },
  extend: function extend(name, otherElementStyles) {
    var otherStyle = otherElementStyles[name];
    if (otherStyle) {
      return otherStyle;
    }
    return {
      'extend': name
    };
  }
};

var autoprefix = exports.autoprefix = function autoprefix(elements) {
  var prefixed = {};
  (0, _forOwn3.default)(elements, function (styles, element) {
    var expanded = {};
    (0, _forOwn3.default)(styles, function (value, key) {
      var transform = transforms[key];
      if (transform) {
        expanded = _extends({}, expanded, transform(value));
      } else {
        expanded[key] = value;
      }
    });
    prefixed[element] = expanded;
  });
  return prefixed;
};

exports.default = autoprefix;

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hover = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var hover = exports.hover = function hover(Component) {
  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';

  return function (_React$Component) {
    _inherits(Hover, _React$Component);

    function Hover() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Hover);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Hover.__proto__ || Object.getPrototypeOf(Hover)).call.apply(_ref, [this].concat(args))), _this), _this.state = { hover: false }, _this.handleMouseOver = function () {
        return _this.setState({ hover: true });
      }, _this.handleMouseOut = function () {
        return _this.setState({ hover: false });
      }, _this.render = function () {
        return _react2.default.createElement(
          Span,
          { onMouseOver: _this.handleMouseOver, onMouseOut: _this.handleMouseOut },
          _react2.default.createElement(Component, _extends({}, _this.props, _this.state))
        );
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    return Hover;
  }(_react2.default.Component);
};

exports.default = hover;

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.active = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var active = exports.active = function active(Component) {
  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';

  return function (_React$Component) {
    _inherits(Active, _React$Component);

    function Active() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Active);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Active.__proto__ || Object.getPrototypeOf(Active)).call.apply(_ref, [this].concat(args))), _this), _this.state = { active: false }, _this.handleMouseDown = function () {
        return _this.setState({ active: true });
      }, _this.handleMouseUp = function () {
        return _this.setState({ active: false });
      }, _this.render = function () {
        return _react2.default.createElement(
          Span,
          { onMouseDown: _this.handleMouseDown, onMouseUp: _this.handleMouseUp },
          _react2.default.createElement(Component, _extends({}, _this.props, _this.state))
        );
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    return Active;
  }(_react2.default.Component);
};

exports.default = active;

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var loopable = function loopable(i, length) {
  var props = {};
  var setProp = function setProp(name) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    props[name] = value;
  };

  i === 0 && setProp('first-child');
  i === length - 1 && setProp('last-child');
  (i === 0 || i % 2 === 0) && setProp('even');
  Math.abs(i % 2) === 1 && setProp('odd');
  setProp('nth-child', i);

  return props;
};

exports.default = loopable;

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Alpha = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(3);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _alpha = __webpack_require__(593);

var alpha = _interopRequireWildcard(_alpha);

var _Checkboard = __webpack_require__(190);

var _Checkboard2 = _interopRequireDefault(_Checkboard);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Alpha = exports.Alpha = function (_ref) {
  _inherits(Alpha, _ref);

  function Alpha() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, Alpha);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Alpha.__proto__ || Object.getPrototypeOf(Alpha)).call.apply(_ref2, [this].concat(args))), _this), _this.handleChange = function (e, skip) {
      var change = alpha.calculateChange(e, skip, _this.props, _this.container);
      change && _this.props.onChange && _this.props.onChange(change, e);
    }, _this.handleMouseDown = function (e) {
      _this.handleChange(e, true);
      window.addEventListener('mousemove', _this.handleChange);
      window.addEventListener('mouseup', _this.handleMouseUp);
    }, _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    }, _this.unbindEventListeners = function () {
      window.removeEventListener('mousemove', _this.handleChange);
      window.removeEventListener('mouseup', _this.handleMouseUp);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Alpha, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var rgb = this.props.rgb;
      var styles = (0, _reactcss2.default)({
        'default': {
          alpha: {
            absolute: '0px 0px 0px 0px',
            borderRadius: this.props.radius
          },
          checkboard: {
            absolute: '0px 0px 0px 0px',
            overflow: 'hidden',
            borderRadius: this.props.radius
          },
          gradient: {
            absolute: '0px 0px 0px 0px',
            background: 'linear-gradient(to right, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)',
            boxShadow: this.props.shadow,
            borderRadius: this.props.radius
          },
          container: {
            position: 'relative',
            height: '100%',
            margin: '0 3px'
          },
          pointer: {
            position: 'absolute',
            left: rgb.a * 100 + '%'
          },
          slider: {
            width: '4px',
            borderRadius: '1px',
            height: '8px',
            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
            background: '#fff',
            marginTop: '1px',
            transform: 'translateX(-2px)'
          }
        },
        'vertical': {
          gradient: {
            background: 'linear-gradient(to bottom, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)'
          },
          pointer: {
            left: 0,
            top: rgb.a * 100 + '%'
          }
        },
        'overwrite': _extends({}, this.props.style)
      }, {
        vertical: this.props.direction === 'vertical',
        overwrite: true
      });

      return _react2.default.createElement(
        'div',
        { style: styles.alpha },
        _react2.default.createElement(
          'div',
          { style: styles.checkboard },
          _react2.default.createElement(_Checkboard2.default, { renderers: this.props.renderers })
        ),
        _react2.default.createElement('div', { style: styles.gradient }),
        _react2.default.createElement(
          'div',
          {
            style: styles.container,
            ref: function ref(container) {
              return _this2.container = container;
            },
            onMouseDown: this.handleMouseDown,
            onTouchMove: this.handleChange,
            onTouchStart: this.handleChange
          },
          _react2.default.createElement(
            'div',
            { style: styles.pointer },
            this.props.pointer ? _react2.default.createElement(this.props.pointer, this.props) : _react2.default.createElement('div', { style: styles.slider })
          )
        )
      );
    }
  }]);

  return Alpha;
}(_react.PureComponent || _react.Component);

exports.default = Alpha;

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var calculateChange = exports.calculateChange = function calculateChange(e, skip, props, container) {
  e.preventDefault();
  var containerWidth = container.clientWidth;
  var containerHeight = container.clientHeight;
  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);

  if (props.direction === 'vertical') {
    var a = void 0;
    if (top < 0) {
      a = 0;
    } else if (top > containerHeight) {
      a = 1;
    } else {
      a = Math.round(top * 100 / containerHeight) / 100;
    }

    if (props.hsl.a !== a) {
      return {
        h: props.hsl.h,
        s: props.hsl.s,
        l: props.hsl.l,
        a: a,
        source: 'rgb'
      };
    }
  } else {
    var _a = void 0;
    if (left < 0) {
      _a = 0;
    } else if (left > containerWidth) {
      _a = 1;
    } else {
      _a = Math.round(left * 100 / containerWidth) / 100;
    }

    if (props.a !== _a) {
      return {
        h: props.hsl.h,
        s: props.hsl.s,
        l: props.hsl.l,
        a: _a,
        source: 'rgb'
      };
    }
  }
  return null;
};

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var checkboardCache = {};

var render = exports.render = function render(c1, c2, size, serverCanvas) {
  if (typeof document === 'undefined' && !serverCanvas) {
    return null;
  }
  var canvas = serverCanvas ? new serverCanvas() : document.createElement('canvas');
  canvas.width = size * 2;
  canvas.height = size * 2;
  var ctx = canvas.getContext('2d');
  if (!ctx) {
    return null;
  } // If no context can be found, return early.
  ctx.fillStyle = c1;
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.fillStyle = c2;
  ctx.fillRect(0, 0, size, size);
  ctx.translate(size, size);
  ctx.fillRect(0, 0, size, size);
  return canvas.toDataURL();
};

var get = exports.get = function get(c1, c2, size, serverCanvas) {
  var key = c1 + '-' + c2 + '-' + size + (serverCanvas ? '-server' : '');
  var checkboard = render(c1, c2, size, serverCanvas);

  if (checkboardCache[key]) {
    return checkboardCache[key];
  }
  checkboardCache[key] = checkboard;
  return checkboard;
};

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditableInput = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(3);

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditableInput = exports.EditableInput = function (_ref) {
  _inherits(EditableInput, _ref);

  function EditableInput(props) {
    _classCallCheck(this, EditableInput);

    var _this = _possibleConstructorReturn(this, (EditableInput.__proto__ || Object.getPrototypeOf(EditableInput)).call(this));

    _this.handleBlur = function () {
      if (_this.state.blurValue) {
        _this.setState({ value: _this.state.blurValue, blurValue: null });
      }
    };

    _this.handleChange = function (e) {
      if (_this.props.label) {
        _this.props.onChange && _this.props.onChange(_defineProperty({}, _this.props.label, e.target.value), e);
      } else {
        _this.props.onChange && _this.props.onChange(e.target.value, e);
      }

      _this.setState({ value: e.target.value });
    };

    _this.handleKeyDown = function (e) {
      // In case `e.target.value` is a percentage remove the `%` character
      // and update accordingly with a percentage
      // https://github.com/casesandberg/react-color/issues/383
      var stringValue = String(e.target.value);
      var isPercentage = stringValue.indexOf('%') > -1;
      var number = Number(stringValue.replace(/%/g, ''));
      if (!isNaN(number)) {
        var amount = _this.props.arrowOffset || 1;

        // Up
        if (e.keyCode === 38) {
          if (_this.props.label !== null) {
            _this.props.onChange && _this.props.onChange(_defineProperty({}, _this.props.label, number + amount), e);
          } else {
            _this.props.onChange && _this.props.onChange(number + amount, e);
          }

          if (isPercentage) {
            _this.setState({ value: number + amount + '%' });
          } else {
            _this.setState({ value: number + amount });
          }
        }

        // Down
        if (e.keyCode === 40) {
          if (_this.props.label !== null) {
            _this.props.onChange && _this.props.onChange(_defineProperty({}, _this.props.label, number - amount), e);
          } else {
            _this.props.onChange && _this.props.onChange(number - amount, e);
          }

          if (isPercentage) {
            _this.setState({ value: number - amount + '%' });
          } else {
            _this.setState({ value: number - amount });
          }
        }
      }
    };

    _this.handleDrag = function (e) {
      if (_this.props.dragLabel) {
        var newValue = Math.round(_this.props.value + e.movementX);
        if (newValue >= 0 && newValue <= _this.props.dragMax) {
          _this.props.onChange && _this.props.onChange(_defineProperty({}, _this.props.label, newValue), e);
        }
      }
    };

    _this.handleMouseDown = function (e) {
      if (_this.props.dragLabel) {
        e.preventDefault();
        _this.handleDrag(e);
        window.addEventListener('mousemove', _this.handleDrag);
        window.addEventListener('mouseup', _this.handleMouseUp);
      }
    };

    _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    };

    _this.unbindEventListeners = function () {
      window.removeEventListener('mousemove', _this.handleDrag);
      window.removeEventListener('mouseup', _this.handleMouseUp);
    };

    _this.state = {
      value: String(props.value).toUpperCase(),
      blurValue: String(props.value).toUpperCase()
    };
    return _this;
  }

  _createClass(EditableInput, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var input = this.input;
      if (nextProps.value !== this.state.value) {
        if (input === document.activeElement) {
          this.setState({ blurValue: String(nextProps.value).toUpperCase() });
        } else {
          this.setState({ value: String(nextProps.value).toUpperCase(), blurValue: !this.state.blurValue && String(nextProps.value).toUpperCase() });
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = (0, _reactcss2.default)({
        'default': {
          wrap: {
            position: 'relative'
          }
        },
        'user-override': {
          wrap: this.props.style && this.props.style.wrap ? this.props.style.wrap : {},
          input: this.props.style && this.props.style.input ? this.props.style.input : {},
          label: this.props.style && this.props.style.label ? this.props.style.label : {}
        },
        'dragLabel-true': {
          label: {
            cursor: 'ew-resize'
          }
        }
      }, {
        'user-override': true
      }, this.props);

      return _react2.default.createElement(
        'div',
        { style: styles.wrap },
        _react2.default.createElement('input', {
          style: styles.input,
          ref: function ref(input) {
            return _this2.input = input;
          },
          value: this.state.value,
          onKeyDown: this.handleKeyDown,
          onChange: this.handleChange,
          onBlur: this.handleBlur,
          placeholder: this.props.placeholder,
          spellCheck: 'false'
        }),
        this.props.label && !this.props.hideLabel ? _react2.default.createElement(
          'span',
          { style: styles.label, onMouseDown: this.handleMouseDown },
          this.props.label
        ) : null
      );
    }
  }]);

  return EditableInput;
}(_react.PureComponent || _react.Component);

exports.default = EditableInput;

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Hue = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(3);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _hue = __webpack_require__(597);

var hue = _interopRequireWildcard(_hue);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Hue = exports.Hue = function (_ref) {
  _inherits(Hue, _ref);

  function Hue() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, Hue);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Hue.__proto__ || Object.getPrototypeOf(Hue)).call.apply(_ref2, [this].concat(args))), _this), _this.handleChange = function (e, skip) {
      var change = hue.calculateChange(e, skip, _this.props, _this.container);
      change && _this.props.onChange && _this.props.onChange(change, e);
    }, _this.handleMouseDown = function (e) {
      _this.handleChange(e, true);
      window.addEventListener('mousemove', _this.handleChange);
      window.addEventListener('mouseup', _this.handleMouseUp);
    }, _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Hue, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: 'unbindEventListeners',
    value: function unbindEventListeners() {
      window.removeEventListener('mousemove', this.handleChange);
      window.removeEventListener('mouseup', this.handleMouseUp);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props$direction = this.props.direction,
          direction = _props$direction === undefined ? 'horizontal' : _props$direction;


      var styles = (0, _reactcss2.default)({
        'default': {
          hue: {
            absolute: '0px 0px 0px 0px',
            borderRadius: this.props.radius,
            boxShadow: this.props.shadow
          },
          container: {
            padding: '0 2px',
            position: 'relative',
            height: '100%',
            borderRadius: this.props.radius
          },
          pointer: {
            position: 'absolute',
            left: this.props.hsl.h * 100 / 360 + '%'
          },
          slider: {
            marginTop: '1px',
            width: '4px',
            borderRadius: '1px',
            height: '8px',
            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
            background: '#fff',
            transform: 'translateX(-2px)'
          }
        },
        'vertical': {
          pointer: {
            left: '0px',
            top: -(this.props.hsl.h * 100 / 360) + 100 + '%'
          }
        }
      }, { vertical: direction === 'vertical' });

      return _react2.default.createElement(
        'div',
        { style: styles.hue },
        _react2.default.createElement(
          'div',
          {
            className: 'hue-' + direction,
            style: styles.container,
            ref: function ref(container) {
              return _this2.container = container;
            },
            onMouseDown: this.handleMouseDown,
            onTouchMove: this.handleChange,
            onTouchStart: this.handleChange
          },
          _react2.default.createElement(
            'style',
            null,
            '\n            .hue-horizontal {\n              background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0\n                33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to right, #f00 0%, #ff0\n                17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n\n            .hue-vertical {\n              background: linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%,\n                #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to top, #f00 0%, #ff0 17%,\n                #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n          '
          ),
          _react2.default.createElement(
            'div',
            { style: styles.pointer },
            this.props.pointer ? _react2.default.createElement(this.props.pointer, this.props) : _react2.default.createElement('div', { style: styles.slider })
          )
        )
      );
    }
  }]);

  return Hue;
}(_react.PureComponent || _react.Component);

exports.default = Hue;

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var calculateChange = exports.calculateChange = function calculateChange(e, skip, props, container) {
  e.preventDefault();
  var containerWidth = container.clientWidth;
  var containerHeight = container.clientHeight;
  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);

  if (props.direction === 'vertical') {
    var h = void 0;
    if (top < 0) {
      h = 359;
    } else if (top > containerHeight) {
      h = 0;
    } else {
      var percent = -(top * 100 / containerHeight) + 100;
      h = 360 * percent / 100;
    }

    if (props.hsl.h !== h) {
      return {
        h: h,
        s: props.hsl.s,
        l: props.hsl.l,
        a: props.hsl.a,
        source: 'rgb'
      };
    }
  } else {
    var _h = void 0;
    if (left < 0) {
      _h = 0;
    } else if (left > containerWidth) {
      _h = 359;
    } else {
      var _percent = left * 100 / containerWidth;
      _h = 360 * _percent / 100;
    }

    if (props.hsl.h !== _h) {
      return {
        h: _h,
        s: props.hsl.s,
        l: props.hsl.l,
        a: props.hsl.a,
        source: 'rgb'
      };
    }
  }
  return null;
};

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Raised = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = __webpack_require__(3);

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Raised = exports.Raised = function Raised(_ref) {
  var zDepth = _ref.zDepth,
      radius = _ref.radius,
      background = _ref.background,
      children = _ref.children;

  var styles = (0, _reactcss2.default)({
    'default': {
      wrap: {
        position: 'relative',
        display: 'inline-block'
      },
      content: {
        position: 'relative'
      },
      bg: {
        absolute: '0px 0px 0px 0px',
        boxShadow: '0 ' + zDepth + 'px ' + zDepth * 4 + 'px rgba(0,0,0,.24)',
        borderRadius: radius,
        background: background
      }
    },
    'zDepth-0': {
      bg: {
        boxShadow: 'none'
      }
    },

    'zDepth-1': {
      bg: {
        boxShadow: '0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16)'
      }
    },
    'zDepth-2': {
      bg: {
        boxShadow: '0 6px 20px rgba(0,0,0,.19), 0 8px 17px rgba(0,0,0,.2)'
      }
    },
    'zDepth-3': {
      bg: {
        boxShadow: '0 17px 50px rgba(0,0,0,.19), 0 12px 15px rgba(0,0,0,.24)'
      }
    },
    'zDepth-4': {
      bg: {
        boxShadow: '0 25px 55px rgba(0,0,0,.21), 0 16px 28px rgba(0,0,0,.22)'
      }
    },
    'zDepth-5': {
      bg: {
        boxShadow: '0 40px 77px rgba(0,0,0,.22), 0 27px 24px rgba(0,0,0,.2)'
      }
    },
    'square': {
      bg: {
        borderRadius: '0'
      }
    },
    'circle': {
      bg: {
        borderRadius: '50%'
      }
    }
  }, { 'zDepth-1': zDepth === 1 });

  return _react2.default.createElement(
    'div',
    { style: styles.wrap },
    _react2.default.createElement('div', { style: styles.bg }),
    _react2.default.createElement(
      'div',
      { style: styles.content },
      children
    )
  );
};

Raised.propTypes = {
  background: _propTypes2.default.string,
  zDepth: _propTypes2.default.oneOf([0, 1, 2, 3, 4, 5]),
  radius: _propTypes2.default.number
};

Raised.defaultProps = {
  background: '#fff',
  zDepth: 1,
  radius: 2
};

exports.default = Raised;

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Saturation = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(3);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _throttle = __webpack_require__(600);

var _throttle2 = _interopRequireDefault(_throttle);

var _saturation = __webpack_require__(603);

var saturation = _interopRequireWildcard(_saturation);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Saturation = exports.Saturation = function (_ref) {
  _inherits(Saturation, _ref);

  function Saturation(props) {
    _classCallCheck(this, Saturation);

    var _this = _possibleConstructorReturn(this, (Saturation.__proto__ || Object.getPrototypeOf(Saturation)).call(this, props));

    _this.handleChange = function (e, skip) {
      _this.props.onChange && _this.throttle(_this.props.onChange, saturation.calculateChange(e, skip, _this.props, _this.container), e);
    };

    _this.handleMouseDown = function (e) {
      _this.handleChange(e, true);
      window.addEventListener('mousemove', _this.handleChange);
      window.addEventListener('mouseup', _this.handleMouseUp);
    };

    _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    };

    _this.throttle = (0, _throttle2.default)(function (fn, data, e) {
      fn(data, e);
    }, 50);
    return _this;
  }

  _createClass(Saturation, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: 'unbindEventListeners',
    value: function unbindEventListeners() {
      window.removeEventListener('mousemove', this.handleChange);
      window.removeEventListener('mouseup', this.handleMouseUp);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _ref2 = this.props.style || {},
          color = _ref2.color,
          white = _ref2.white,
          black = _ref2.black,
          pointer = _ref2.pointer,
          circle = _ref2.circle;

      var styles = (0, _reactcss2.default)({
        'default': {
          color: {
            absolute: '0px 0px 0px 0px',
            background: 'hsl(' + this.props.hsl.h + ',100%, 50%)',
            borderRadius: this.props.radius
          },
          white: {
            absolute: '0px 0px 0px 0px',
            borderRadius: this.props.radius
          },
          black: {
            absolute: '0px 0px 0px 0px',
            boxShadow: this.props.shadow,
            borderRadius: this.props.radius
          },
          pointer: {
            position: 'absolute',
            top: -(this.props.hsv.v * 100) + 100 + '%',
            left: this.props.hsv.s * 100 + '%',
            cursor: 'default'
          },
          circle: {
            width: '4px',
            height: '4px',
            boxShadow: '0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3),\n            0 0 1px 2px rgba(0,0,0,.4)',
            borderRadius: '50%',
            cursor: 'hand',
            transform: 'translate(-2px, -2px)'
          }
        },
        'custom': {
          color: color,
          white: white,
          black: black,
          pointer: pointer,
          circle: circle
        }
      }, { 'custom': !!this.props.style });

      return _react2.default.createElement(
        'div',
        {
          style: styles.color,
          ref: function ref(container) {
            return _this2.container = container;
          },
          onMouseDown: this.handleMouseDown,
          onTouchMove: this.handleChange,
          onTouchStart: this.handleChange
        },
        _react2.default.createElement(
          'style',
          null,
          '\n          .saturation-white {\n            background: -webkit-linear-gradient(to right, #fff, rgba(255,255,255,0));\n            background: linear-gradient(to right, #fff, rgba(255,255,255,0));\n          }\n          .saturation-black {\n            background: -webkit-linear-gradient(to top, #000, rgba(0,0,0,0));\n            background: linear-gradient(to top, #000, rgba(0,0,0,0));\n          }\n        '
        ),
        _react2.default.createElement(
          'div',
          { style: styles.white, className: 'saturation-white' },
          _react2.default.createElement('div', { style: styles.black, className: 'saturation-black' }),
          _react2.default.createElement(
            'div',
            { style: styles.pointer },
            this.props.pointer ? _react2.default.createElement(this.props.pointer, this.props) : _react2.default.createElement('div', { style: styles.circle })
          )
        )
      );
    }
  }]);

  return Saturation;
}(_react.PureComponent || _react.Component);

exports.default = Saturation;

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

var debounce = __webpack_require__(191),
    isObject = __webpack_require__(22);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(15);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(22),
    isSymbol = __webpack_require__(63);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var calculateChange = exports.calculateChange = function calculateChange(e, skip, props, container) {
  e.preventDefault();

  var _container$getBoundin = container.getBoundingClientRect(),
      containerWidth = _container$getBoundin.width,
      containerHeight = _container$getBoundin.height;

  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);

  if (left < 0) {
    left = 0;
  } else if (left > containerWidth) {
    left = containerWidth;
  } else if (top < 0) {
    top = 0;
  } else if (top > containerHeight) {
    top = containerHeight;
  }

  var saturation = left * 100 / containerWidth;
  var bright = -(top * 100 / containerHeight) + 100;

  return {
    h: props.hsl.h,
    s: saturation,
    v: bright,
    a: props.hsl.a,
    source: 'rgb'
  };
};

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(605);


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(184),
    baseEach = __webpack_require__(183),
    castFunction = __webpack_require__(165),
    isArray = __webpack_require__(13);

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

module.exports = forEach;


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;// TinyColor v1.4.1
// https://github.com/bgrins/TinyColor
// Brian Grinstead, MIT License

(function(Math) {

var trimLeft = /^\s+/,
    trimRight = /\s+$/,
    tinyCounter = 0,
    mathRound = Math.round,
    mathMin = Math.min,
    mathMax = Math.max,
    mathRandom = Math.random;

function tinycolor (color, opts) {

    color = (color) ? color : '';
    opts = opts || { };

    // If input is already a tinycolor, return itself
    if (color instanceof tinycolor) {
       return color;
    }
    // If we are called as a function, call using new instead
    if (!(this instanceof tinycolor)) {
        return new tinycolor(color, opts);
    }

    var rgb = inputToRGB(color);
    this._originalInput = color,
    this._r = rgb.r,
    this._g = rgb.g,
    this._b = rgb.b,
    this._a = rgb.a,
    this._roundA = mathRound(100*this._a) / 100,
    this._format = opts.format || rgb.format;
    this._gradientType = opts.gradientType;

    // Don't let the range of [0,255] come back in [0,1].
    // Potentially lose a little bit of precision here, but will fix issues where
    // .5 gets interpreted as half of the total, instead of half of 1
    // If it was supposed to be 128, this was already taken care of by `inputToRgb`
    if (this._r < 1) { this._r = mathRound(this._r); }
    if (this._g < 1) { this._g = mathRound(this._g); }
    if (this._b < 1) { this._b = mathRound(this._b); }

    this._ok = rgb.ok;
    this._tc_id = tinyCounter++;
}

tinycolor.prototype = {
    isDark: function() {
        return this.getBrightness() < 128;
    },
    isLight: function() {
        return !this.isDark();
    },
    isValid: function() {
        return this._ok;
    },
    getOriginalInput: function() {
      return this._originalInput;
    },
    getFormat: function() {
        return this._format;
    },
    getAlpha: function() {
        return this._a;
    },
    getBrightness: function() {
        //http://www.w3.org/TR/AERT#color-contrast
        var rgb = this.toRgb();
        return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
    },
    getLuminance: function() {
        //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
        var rgb = this.toRgb();
        var RsRGB, GsRGB, BsRGB, R, G, B;
        RsRGB = rgb.r/255;
        GsRGB = rgb.g/255;
        BsRGB = rgb.b/255;

        if (RsRGB <= 0.03928) {R = RsRGB / 12.92;} else {R = Math.pow(((RsRGB + 0.055) / 1.055), 2.4);}
        if (GsRGB <= 0.03928) {G = GsRGB / 12.92;} else {G = Math.pow(((GsRGB + 0.055) / 1.055), 2.4);}
        if (BsRGB <= 0.03928) {B = BsRGB / 12.92;} else {B = Math.pow(((BsRGB + 0.055) / 1.055), 2.4);}
        return (0.2126 * R) + (0.7152 * G) + (0.0722 * B);
    },
    setAlpha: function(value) {
        this._a = boundAlpha(value);
        this._roundA = mathRound(100*this._a) / 100;
        return this;
    },
    toHsv: function() {
        var hsv = rgbToHsv(this._r, this._g, this._b);
        return { h: hsv.h * 360, s: hsv.s, v: hsv.v, a: this._a };
    },
    toHsvString: function() {
        var hsv = rgbToHsv(this._r, this._g, this._b);
        var h = mathRound(hsv.h * 360), s = mathRound(hsv.s * 100), v = mathRound(hsv.v * 100);
        return (this._a == 1) ?
          "hsv("  + h + ", " + s + "%, " + v + "%)" :
          "hsva(" + h + ", " + s + "%, " + v + "%, "+ this._roundA + ")";
    },
    toHsl: function() {
        var hsl = rgbToHsl(this._r, this._g, this._b);
        return { h: hsl.h * 360, s: hsl.s, l: hsl.l, a: this._a };
    },
    toHslString: function() {
        var hsl = rgbToHsl(this._r, this._g, this._b);
        var h = mathRound(hsl.h * 360), s = mathRound(hsl.s * 100), l = mathRound(hsl.l * 100);
        return (this._a == 1) ?
          "hsl("  + h + ", " + s + "%, " + l + "%)" :
          "hsla(" + h + ", " + s + "%, " + l + "%, "+ this._roundA + ")";
    },
    toHex: function(allow3Char) {
        return rgbToHex(this._r, this._g, this._b, allow3Char);
    },
    toHexString: function(allow3Char) {
        return '#' + this.toHex(allow3Char);
    },
    toHex8: function(allow4Char) {
        return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
    },
    toHex8String: function(allow4Char) {
        return '#' + this.toHex8(allow4Char);
    },
    toRgb: function() {
        return { r: mathRound(this._r), g: mathRound(this._g), b: mathRound(this._b), a: this._a };
    },
    toRgbString: function() {
        return (this._a == 1) ?
          "rgb("  + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ")" :
          "rgba(" + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ", " + this._roundA + ")";
    },
    toPercentageRgb: function() {
        return { r: mathRound(bound01(this._r, 255) * 100) + "%", g: mathRound(bound01(this._g, 255) * 100) + "%", b: mathRound(bound01(this._b, 255) * 100) + "%", a: this._a };
    },
    toPercentageRgbString: function() {
        return (this._a == 1) ?
          "rgb("  + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%)" :
          "rgba(" + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
    },
    toName: function() {
        if (this._a === 0) {
            return "transparent";
        }

        if (this._a < 1) {
            return false;
        }

        return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
    },
    toFilter: function(secondColor) {
        var hex8String = '#' + rgbaToArgbHex(this._r, this._g, this._b, this._a);
        var secondHex8String = hex8String;
        var gradientType = this._gradientType ? "GradientType = 1, " : "";

        if (secondColor) {
            var s = tinycolor(secondColor);
            secondHex8String = '#' + rgbaToArgbHex(s._r, s._g, s._b, s._a);
        }

        return "progid:DXImageTransform.Microsoft.gradient("+gradientType+"startColorstr="+hex8String+",endColorstr="+secondHex8String+")";
    },
    toString: function(format) {
        var formatSet = !!format;
        format = format || this._format;

        var formattedString = false;
        var hasAlpha = this._a < 1 && this._a >= 0;
        var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");

        if (needsAlphaFormat) {
            // Special case for "transparent", all other non-alpha formats
            // will return rgba when there is transparency.
            if (format === "name" && this._a === 0) {
                return this.toName();
            }
            return this.toRgbString();
        }
        if (format === "rgb") {
            formattedString = this.toRgbString();
        }
        if (format === "prgb") {
            formattedString = this.toPercentageRgbString();
        }
        if (format === "hex" || format === "hex6") {
            formattedString = this.toHexString();
        }
        if (format === "hex3") {
            formattedString = this.toHexString(true);
        }
        if (format === "hex4") {
            formattedString = this.toHex8String(true);
        }
        if (format === "hex8") {
            formattedString = this.toHex8String();
        }
        if (format === "name") {
            formattedString = this.toName();
        }
        if (format === "hsl") {
            formattedString = this.toHslString();
        }
        if (format === "hsv") {
            formattedString = this.toHsvString();
        }

        return formattedString || this.toHexString();
    },
    clone: function() {
        return tinycolor(this.toString());
    },

    _applyModification: function(fn, args) {
        var color = fn.apply(null, [this].concat([].slice.call(args)));
        this._r = color._r;
        this._g = color._g;
        this._b = color._b;
        this.setAlpha(color._a);
        return this;
    },
    lighten: function() {
        return this._applyModification(lighten, arguments);
    },
    brighten: function() {
        return this._applyModification(brighten, arguments);
    },
    darken: function() {
        return this._applyModification(darken, arguments);
    },
    desaturate: function() {
        return this._applyModification(desaturate, arguments);
    },
    saturate: function() {
        return this._applyModification(saturate, arguments);
    },
    greyscale: function() {
        return this._applyModification(greyscale, arguments);
    },
    spin: function() {
        return this._applyModification(spin, arguments);
    },

    _applyCombination: function(fn, args) {
        return fn.apply(null, [this].concat([].slice.call(args)));
    },
    analogous: function() {
        return this._applyCombination(analogous, arguments);
    },
    complement: function() {
        return this._applyCombination(complement, arguments);
    },
    monochromatic: function() {
        return this._applyCombination(monochromatic, arguments);
    },
    splitcomplement: function() {
        return this._applyCombination(splitcomplement, arguments);
    },
    triad: function() {
        return this._applyCombination(triad, arguments);
    },
    tetrad: function() {
        return this._applyCombination(tetrad, arguments);
    }
};

// If input is an object, force 1 into "1.0" to handle ratios properly
// String input requires "1.0" as input, so 1 will be treated as 1
tinycolor.fromRatio = function(color, opts) {
    if (typeof color == "object") {
        var newColor = {};
        for (var i in color) {
            if (color.hasOwnProperty(i)) {
                if (i === "a") {
                    newColor[i] = color[i];
                }
                else {
                    newColor[i] = convertToPercentage(color[i]);
                }
            }
        }
        color = newColor;
    }

    return tinycolor(color, opts);
};

// Given a string or object, convert that input to RGB
// Possible string inputs:
//
//     "red"
//     "#f00" or "f00"
//     "#ff0000" or "ff0000"
//     "#ff000000" or "ff000000"
//     "rgb 255 0 0" or "rgb (255, 0, 0)"
//     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
//     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
//     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
//     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
//     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
//     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
//
function inputToRGB(color) {

    var rgb = { r: 0, g: 0, b: 0 };
    var a = 1;
    var s = null;
    var v = null;
    var l = null;
    var ok = false;
    var format = false;

    if (typeof color == "string") {
        color = stringInputToObject(color);
    }

    if (typeof color == "object") {
        if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
            rgb = rgbToRgb(color.r, color.g, color.b);
            ok = true;
            format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
        }
        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
            s = convertToPercentage(color.s);
            v = convertToPercentage(color.v);
            rgb = hsvToRgb(color.h, s, v);
            ok = true;
            format = "hsv";
        }
        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
            s = convertToPercentage(color.s);
            l = convertToPercentage(color.l);
            rgb = hslToRgb(color.h, s, l);
            ok = true;
            format = "hsl";
        }

        if (color.hasOwnProperty("a")) {
            a = color.a;
        }
    }

    a = boundAlpha(a);

    return {
        ok: ok,
        format: color.format || format,
        r: mathMin(255, mathMax(rgb.r, 0)),
        g: mathMin(255, mathMax(rgb.g, 0)),
        b: mathMin(255, mathMax(rgb.b, 0)),
        a: a
    };
}


// Conversion Functions
// --------------------

// `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
// <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>

// `rgbToRgb`
// Handle bounds / percentage checking to conform to CSS color spec
// <http://www.w3.org/TR/css3-color/>
// *Assumes:* r, g, b in [0, 255] or [0, 1]
// *Returns:* { r, g, b } in [0, 255]
function rgbToRgb(r, g, b){
    return {
        r: bound01(r, 255) * 255,
        g: bound01(g, 255) * 255,
        b: bound01(b, 255) * 255
    };
}

// `rgbToHsl`
// Converts an RGB color value to HSL.
// *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
// *Returns:* { h, s, l } in [0,1]
function rgbToHsl(r, g, b) {

    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);

    var max = mathMax(r, g, b), min = mathMin(r, g, b);
    var h, s, l = (max + min) / 2;

    if(max == min) {
        h = s = 0; // achromatic
    }
    else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }

        h /= 6;
    }

    return { h: h, s: s, l: l };
}

// `hslToRgb`
// Converts an HSL color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
function hslToRgb(h, s, l) {
    var r, g, b;

    h = bound01(h, 360);
    s = bound01(s, 100);
    l = bound01(l, 100);

    function hue2rgb(p, q, t) {
        if(t < 0) t += 1;
        if(t > 1) t -= 1;
        if(t < 1/6) return p + (q - p) * 6 * t;
        if(t < 1/2) return q;
        if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
        return p;
    }

    if(s === 0) {
        r = g = b = l; // achromatic
    }
    else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1/3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1/3);
    }

    return { r: r * 255, g: g * 255, b: b * 255 };
}

// `rgbToHsv`
// Converts an RGB color value to HSV
// *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
// *Returns:* { h, s, v } in [0,1]
function rgbToHsv(r, g, b) {

    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);

    var max = mathMax(r, g, b), min = mathMin(r, g, b);
    var h, s, v = max;

    var d = max - min;
    s = max === 0 ? 0 : d / max;

    if(max == min) {
        h = 0; // achromatic
    }
    else {
        switch(max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }
        h /= 6;
    }
    return { h: h, s: s, v: v };
}

// `hsvToRgb`
// Converts an HSV color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
 function hsvToRgb(h, s, v) {

    h = bound01(h, 360) * 6;
    s = bound01(s, 100);
    v = bound01(v, 100);

    var i = Math.floor(h),
        f = h - i,
        p = v * (1 - s),
        q = v * (1 - f * s),
        t = v * (1 - (1 - f) * s),
        mod = i % 6,
        r = [v, q, p, p, t, v][mod],
        g = [t, v, v, q, p, p][mod],
        b = [p, p, t, v, v, q][mod];

    return { r: r * 255, g: g * 255, b: b * 255 };
}

// `rgbToHex`
// Converts an RGB color to hex
// Assumes r, g, and b are contained in the set [0, 255]
// Returns a 3 or 6 character hex
function rgbToHex(r, g, b, allow3Char) {

    var hex = [
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16))
    ];

    // Return a 3 character hex if possible
    if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
    }

    return hex.join("");
}

// `rgbaToHex`
// Converts an RGBA color plus alpha transparency to hex
// Assumes r, g, b are contained in the set [0, 255] and
// a in [0, 1]. Returns a 4 or 8 character rgba hex
function rgbaToHex(r, g, b, a, allow4Char) {

    var hex = [
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16)),
        pad2(convertDecimalToHex(a))
    ];

    // Return a 4 character hex if possible
    if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) {
        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
    }

    return hex.join("");
}

// `rgbaToArgbHex`
// Converts an RGBA color to an ARGB Hex8 string
// Rarely used, but required for "toFilter()"
function rgbaToArgbHex(r, g, b, a) {

    var hex = [
        pad2(convertDecimalToHex(a)),
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16))
    ];

    return hex.join("");
}

// `equals`
// Can be called with any tinycolor input
tinycolor.equals = function (color1, color2) {
    if (!color1 || !color2) { return false; }
    return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
};

tinycolor.random = function() {
    return tinycolor.fromRatio({
        r: mathRandom(),
        g: mathRandom(),
        b: mathRandom()
    });
};


// Modification Functions
// ----------------------
// Thanks to less.js for some of the basics here
// <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>

function desaturate(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.s -= amount / 100;
    hsl.s = clamp01(hsl.s);
    return tinycolor(hsl);
}

function saturate(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.s += amount / 100;
    hsl.s = clamp01(hsl.s);
    return tinycolor(hsl);
}

function greyscale(color) {
    return tinycolor(color).desaturate(100);
}

function lighten (color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.l += amount / 100;
    hsl.l = clamp01(hsl.l);
    return tinycolor(hsl);
}

function brighten(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var rgb = tinycolor(color).toRgb();
    rgb.r = mathMax(0, mathMin(255, rgb.r - mathRound(255 * - (amount / 100))));
    rgb.g = mathMax(0, mathMin(255, rgb.g - mathRound(255 * - (amount / 100))));
    rgb.b = mathMax(0, mathMin(255, rgb.b - mathRound(255 * - (amount / 100))));
    return tinycolor(rgb);
}

function darken (color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.l -= amount / 100;
    hsl.l = clamp01(hsl.l);
    return tinycolor(hsl);
}

// Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
// Values outside of this range will be wrapped into this range.
function spin(color, amount) {
    var hsl = tinycolor(color).toHsl();
    var hue = (hsl.h + amount) % 360;
    hsl.h = hue < 0 ? 360 + hue : hue;
    return tinycolor(hsl);
}

// Combination Functions
// ---------------------
// Thanks to jQuery xColor for some of the ideas behind these
// <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>

function complement(color) {
    var hsl = tinycolor(color).toHsl();
    hsl.h = (hsl.h + 180) % 360;
    return tinycolor(hsl);
}

function triad(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 120) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 240) % 360, s: hsl.s, l: hsl.l })
    ];
}

function tetrad(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 90) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 180) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 270) % 360, s: hsl.s, l: hsl.l })
    ];
}

function splitcomplement(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 72) % 360, s: hsl.s, l: hsl.l}),
        tinycolor({ h: (h + 216) % 360, s: hsl.s, l: hsl.l})
    ];
}

function analogous(color, results, slices) {
    results = results || 6;
    slices = slices || 30;

    var hsl = tinycolor(color).toHsl();
    var part = 360 / slices;
    var ret = [tinycolor(color)];

    for (hsl.h = ((hsl.h - (part * results >> 1)) + 720) % 360; --results; ) {
        hsl.h = (hsl.h + part) % 360;
        ret.push(tinycolor(hsl));
    }
    return ret;
}

function monochromatic(color, results) {
    results = results || 6;
    var hsv = tinycolor(color).toHsv();
    var h = hsv.h, s = hsv.s, v = hsv.v;
    var ret = [];
    var modification = 1 / results;

    while (results--) {
        ret.push(tinycolor({ h: h, s: s, v: v}));
        v = (v + modification) % 1;
    }

    return ret;
}

// Utility Functions
// ---------------------

tinycolor.mix = function(color1, color2, amount) {
    amount = (amount === 0) ? 0 : (amount || 50);

    var rgb1 = tinycolor(color1).toRgb();
    var rgb2 = tinycolor(color2).toRgb();

    var p = amount / 100;

    var rgba = {
        r: ((rgb2.r - rgb1.r) * p) + rgb1.r,
        g: ((rgb2.g - rgb1.g) * p) + rgb1.g,
        b: ((rgb2.b - rgb1.b) * p) + rgb1.b,
        a: ((rgb2.a - rgb1.a) * p) + rgb1.a
    };

    return tinycolor(rgba);
};


// Readability Functions
// ---------------------
// <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)

// `contrast`
// Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
tinycolor.readability = function(color1, color2) {
    var c1 = tinycolor(color1);
    var c2 = tinycolor(color2);
    return (Math.max(c1.getLuminance(),c2.getLuminance())+0.05) / (Math.min(c1.getLuminance(),c2.getLuminance())+0.05);
};

// `isReadable`
// Ensure that foreground and background color combinations meet WCAG2 guidelines.
// The third argument is an optional Object.
//      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
//      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
// If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.

// *Example*
//    tinycolor.isReadable("#000", "#111") => false
//    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
tinycolor.isReadable = function(color1, color2, wcag2) {
    var readability = tinycolor.readability(color1, color2);
    var wcag2Parms, out;

    out = false;

    wcag2Parms = validateWCAG2Parms(wcag2);
    switch (wcag2Parms.level + wcag2Parms.size) {
        case "AAsmall":
        case "AAAlarge":
            out = readability >= 4.5;
            break;
        case "AAlarge":
            out = readability >= 3;
            break;
        case "AAAsmall":
            out = readability >= 7;
            break;
    }
    return out;

};

// `mostReadable`
// Given a base color and a list of possible foreground or background
// colors for that base, returns the most readable color.
// Optionally returns Black or White if the most readable color is unreadable.
// *Example*
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
tinycolor.mostReadable = function(baseColor, colorList, args) {
    var bestColor = null;
    var bestScore = 0;
    var readability;
    var includeFallbackColors, level, size ;
    args = args || {};
    includeFallbackColors = args.includeFallbackColors ;
    level = args.level;
    size = args.size;

    for (var i= 0; i < colorList.length ; i++) {
        readability = tinycolor.readability(baseColor, colorList[i]);
        if (readability > bestScore) {
            bestScore = readability;
            bestColor = tinycolor(colorList[i]);
        }
    }

    if (tinycolor.isReadable(baseColor, bestColor, {"level":level,"size":size}) || !includeFallbackColors) {
        return bestColor;
    }
    else {
        args.includeFallbackColors=false;
        return tinycolor.mostReadable(baseColor,["#fff", "#000"],args);
    }
};


// Big List of Colors
// ------------------
// <http://www.w3.org/TR/css3-color/#svg-color>
var names = tinycolor.names = {
    aliceblue: "f0f8ff",
    antiquewhite: "faebd7",
    aqua: "0ff",
    aquamarine: "7fffd4",
    azure: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "000",
    blanchedalmond: "ffebcd",
    blue: "00f",
    blueviolet: "8a2be2",
    brown: "a52a2a",
    burlywood: "deb887",
    burntsienna: "ea7e5d",
    cadetblue: "5f9ea0",
    chartreuse: "7fff00",
    chocolate: "d2691e",
    coral: "ff7f50",
    cornflowerblue: "6495ed",
    cornsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "0ff",
    darkblue: "00008b",
    darkcyan: "008b8b",
    darkgoldenrod: "b8860b",
    darkgray: "a9a9a9",
    darkgreen: "006400",
    darkgrey: "a9a9a9",
    darkkhaki: "bdb76b",
    darkmagenta: "8b008b",
    darkolivegreen: "556b2f",
    darkorange: "ff8c00",
    darkorchid: "9932cc",
    darkred: "8b0000",
    darksalmon: "e9967a",
    darkseagreen: "8fbc8f",
    darkslateblue: "483d8b",
    darkslategray: "2f4f4f",
    darkslategrey: "2f4f4f",
    darkturquoise: "00ced1",
    darkviolet: "9400d3",
    deeppink: "ff1493",
    deepskyblue: "00bfff",
    dimgray: "696969",
    dimgrey: "696969",
    dodgerblue: "1e90ff",
    firebrick: "b22222",
    floralwhite: "fffaf0",
    forestgreen: "228b22",
    fuchsia: "f0f",
    gainsboro: "dcdcdc",
    ghostwhite: "f8f8ff",
    gold: "ffd700",
    goldenrod: "daa520",
    gray: "808080",
    green: "008000",
    greenyellow: "adff2f",
    grey: "808080",
    honeydew: "f0fff0",
    hotpink: "ff69b4",
    indianred: "cd5c5c",
    indigo: "4b0082",
    ivory: "fffff0",
    khaki: "f0e68c",
    lavender: "e6e6fa",
    lavenderblush: "fff0f5",
    lawngreen: "7cfc00",
    lemonchiffon: "fffacd",
    lightblue: "add8e6",
    lightcoral: "f08080",
    lightcyan: "e0ffff",
    lightgoldenrodyellow: "fafad2",
    lightgray: "d3d3d3",
    lightgreen: "90ee90",
    lightgrey: "d3d3d3",
    lightpink: "ffb6c1",
    lightsalmon: "ffa07a",
    lightseagreen: "20b2aa",
    lightskyblue: "87cefa",
    lightslategray: "789",
    lightslategrey: "789",
    lightsteelblue: "b0c4de",
    lightyellow: "ffffe0",
    lime: "0f0",
    limegreen: "32cd32",
    linen: "faf0e6",
    magenta: "f0f",
    maroon: "800000",
    mediumaquamarine: "66cdaa",
    mediumblue: "0000cd",
    mediumorchid: "ba55d3",
    mediumpurple: "9370db",
    mediumseagreen: "3cb371",
    mediumslateblue: "7b68ee",
    mediumspringgreen: "00fa9a",
    mediumturquoise: "48d1cc",
    mediumvioletred: "c71585",
    midnightblue: "191970",
    mintcream: "f5fffa",
    mistyrose: "ffe4e1",
    moccasin: "ffe4b5",
    navajowhite: "ffdead",
    navy: "000080",
    oldlace: "fdf5e6",
    olive: "808000",
    olivedrab: "6b8e23",
    orange: "ffa500",
    orangered: "ff4500",
    orchid: "da70d6",
    palegoldenrod: "eee8aa",
    palegreen: "98fb98",
    paleturquoise: "afeeee",
    palevioletred: "db7093",
    papayawhip: "ffefd5",
    peachpuff: "ffdab9",
    peru: "cd853f",
    pink: "ffc0cb",
    plum: "dda0dd",
    powderblue: "b0e0e6",
    purple: "800080",
    rebeccapurple: "663399",
    red: "f00",
    rosybrown: "bc8f8f",
    royalblue: "4169e1",
    saddlebrown: "8b4513",
    salmon: "fa8072",
    sandybrown: "f4a460",
    seagreen: "2e8b57",
    seashell: "fff5ee",
    sienna: "a0522d",
    silver: "c0c0c0",
    skyblue: "87ceeb",
    slateblue: "6a5acd",
    slategray: "708090",
    slategrey: "708090",
    snow: "fffafa",
    springgreen: "00ff7f",
    steelblue: "4682b4",
    tan: "d2b48c",
    teal: "008080",
    thistle: "d8bfd8",
    tomato: "ff6347",
    turquoise: "40e0d0",
    violet: "ee82ee",
    wheat: "f5deb3",
    white: "fff",
    whitesmoke: "f5f5f5",
    yellow: "ff0",
    yellowgreen: "9acd32"
};

// Make it easy to access colors via `hexNames[hex]`
var hexNames = tinycolor.hexNames = flip(names);


// Utilities
// ---------

// `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
function flip(o) {
    var flipped = { };
    for (var i in o) {
        if (o.hasOwnProperty(i)) {
            flipped[o[i]] = i;
        }
    }
    return flipped;
}

// Return a valid alpha value [0,1] with all invalid values being set to 1
function boundAlpha(a) {
    a = parseFloat(a);

    if (isNaN(a) || a < 0 || a > 1) {
        a = 1;
    }

    return a;
}

// Take input from [0, n] and return it as [0, 1]
function bound01(n, max) {
    if (isOnePointZero(n)) { n = "100%"; }

    var processPercent = isPercentage(n);
    n = mathMin(max, mathMax(0, parseFloat(n)));

    // Automatically convert percentage into number
    if (processPercent) {
        n = parseInt(n * max, 10) / 100;
    }

    // Handle floating point rounding errors
    if ((Math.abs(n - max) < 0.000001)) {
        return 1;
    }

    // Convert into [0, 1] range if it isn't already
    return (n % max) / parseFloat(max);
}

// Force a number between 0 and 1
function clamp01(val) {
    return mathMin(1, mathMax(0, val));
}

// Parse a base-16 hex value into a base-10 integer
function parseIntFromHex(val) {
    return parseInt(val, 16);
}

// Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
// <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
function isOnePointZero(n) {
    return typeof n == "string" && n.indexOf('.') != -1 && parseFloat(n) === 1;
}

// Check to see if string passed in is a percentage
function isPercentage(n) {
    return typeof n === "string" && n.indexOf('%') != -1;
}

// Force a hex value to have 2 characters
function pad2(c) {
    return c.length == 1 ? '0' + c : '' + c;
}

// Replace a decimal with it's percentage value
function convertToPercentage(n) {
    if (n <= 1) {
        n = (n * 100) + "%";
    }

    return n;
}

// Converts a decimal to a hex value
function convertDecimalToHex(d) {
    return Math.round(parseFloat(d) * 255).toString(16);
}
// Converts a hex value to a decimal
function convertHexToDecimal(h) {
    return (parseIntFromHex(h) / 255);
}

var matchers = (function() {

    // <http://www.w3.org/TR/css3-values/#integers>
    var CSS_INTEGER = "[-\\+]?\\d+%?";

    // <http://www.w3.org/TR/css3-values/#number-value>
    var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";

    // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
    var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";

    // Actual matching.
    // Parentheses and commas are optional, but not required.
    // Whitespace can take the place of commas or opening paren
    var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
    var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";

    return {
        CSS_UNIT: new RegExp(CSS_UNIT),
        rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
        rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
        hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
        hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
        hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
        hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
        hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
        hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
    };
})();

// `isValidCSSUnit`
// Take in a single string / number and check to see if it looks like a CSS unit
// (see `matchers` above for definition).
function isValidCSSUnit(color) {
    return !!matchers.CSS_UNIT.exec(color);
}

// `stringInputToObject`
// Permissive string parsing.  Take in a number of formats, and output an object
// based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
function stringInputToObject(color) {

    color = color.replace(trimLeft,'').replace(trimRight, '').toLowerCase();
    var named = false;
    if (names[color]) {
        color = names[color];
        named = true;
    }
    else if (color == 'transparent') {
        return { r: 0, g: 0, b: 0, a: 0, format: "name" };
    }

    // Try to match string input using regular expressions.
    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
    // Just return an object and let the conversion functions handle that.
    // This way the result will be the same whether the tinycolor is initialized with string or object.
    var match;
    if ((match = matchers.rgb.exec(color))) {
        return { r: match[1], g: match[2], b: match[3] };
    }
    if ((match = matchers.rgba.exec(color))) {
        return { r: match[1], g: match[2], b: match[3], a: match[4] };
    }
    if ((match = matchers.hsl.exec(color))) {
        return { h: match[1], s: match[2], l: match[3] };
    }
    if ((match = matchers.hsla.exec(color))) {
        return { h: match[1], s: match[2], l: match[3], a: match[4] };
    }
    if ((match = matchers.hsv.exec(color))) {
        return { h: match[1], s: match[2], v: match[3] };
    }
    if ((match = matchers.hsva.exec(color))) {
        return { h: match[1], s: match[2], v: match[3], a: match[4] };
    }
    if ((match = matchers.hex8.exec(color))) {
        return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            a: convertHexToDecimal(match[4]),
            format: named ? "name" : "hex8"
        };
    }
    if ((match = matchers.hex6.exec(color))) {
        return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            format: named ? "name" : "hex"
        };
    }
    if ((match = matchers.hex4.exec(color))) {
        return {
            r: parseIntFromHex(match[1] + '' + match[1]),
            g: parseIntFromHex(match[2] + '' + match[2]),
            b: parseIntFromHex(match[3] + '' + match[3]),
            a: convertHexToDecimal(match[4] + '' + match[4]),
            format: named ? "name" : "hex8"
        };
    }
    if ((match = matchers.hex3.exec(color))) {
        return {
            r: parseIntFromHex(match[1] + '' + match[1]),
            g: parseIntFromHex(match[2] + '' + match[2]),
            b: parseIntFromHex(match[3] + '' + match[3]),
            format: named ? "name" : "hex"
        };
    }

    return false;
}

function validateWCAG2Parms(parms) {
    // return valid WCAG2 parms for isReadable.
    // If input parms are invalid, return {"level":"AA", "size":"small"}
    var level, size;
    parms = parms || {"level":"AA", "size":"small"};
    level = (parms.level || "AA").toUpperCase();
    size = (parms.size || "small").toLowerCase();
    if (level !== "AA" && level !== "AAA") {
        level = "AA";
    }
    if (size !== "small" && size !== "large") {
        size = "small";
    }
    return {"level":level, "size":size};
}

// Node: Export function
if (typeof module !== "undefined" && module.exports) {
    module.exports = tinycolor;
}
// AMD/requirejs: Define the module
else if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {return tinycolor;}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}
// Browser: Expose to window
else {
    window.tinycolor = tinycolor;
}

})(Math);


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Swatch = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(3);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _interaction = __webpack_require__(608);

var _ = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ENTER = 13;

var Swatch = exports.Swatch = function Swatch(_ref) {
  var color = _ref.color,
      style = _ref.style,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      onHover = _ref.onHover,
      _ref$title = _ref.title,
      title = _ref$title === undefined ? color : _ref$title,
      children = _ref.children,
      focus = _ref.focus,
      _ref$focusStyle = _ref.focusStyle,
      focusStyle = _ref$focusStyle === undefined ? {} : _ref$focusStyle;

  var transparent = color === 'transparent';
  var styles = (0, _reactcss2.default)({
    default: {
      swatch: _extends({
        background: color,
        height: '100%',
        width: '100%',
        cursor: 'pointer',
        position: 'relative',
        outline: 'none'
      }, style, focus ? focusStyle : {})
    }
  });

  var handleClick = function handleClick(e) {
    return onClick(color, e);
  };
  var handleKeyDown = function handleKeyDown(e) {
    return e.keyCode === ENTER && onClick(color, e);
  };
  var handleHover = function handleHover(e) {
    return onHover(color, e);
  };

  var optionalEvents = {};
  if (onHover) {
    optionalEvents.onMouseOver = handleHover;
  }

  return _react2.default.createElement(
    'div',
    _extends({
      style: styles.swatch,
      onClick: handleClick,
      title: title,
      tabIndex: 0,
      onKeyDown: handleKeyDown
    }, optionalEvents),
    children,
    transparent && _react2.default.createElement(_.Checkboard, {
      borderRadius: styles.swatch.borderRadius,
      boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.1)'
    })
  );
};

exports.default = (0, _interaction.handleFocus)(Swatch);

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleFocus = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-invalid-this */


var handleFocus = exports.handleFocus = function handleFocus(Component) {
  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
  return function (_React$Component) {
    _inherits(Focus, _React$Component);

    function Focus() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Focus);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Focus.__proto__ || Object.getPrototypeOf(Focus)).call.apply(_ref, [this].concat(args))), _this), _this.state = { focus: false }, _this.handleFocus = function () {
        return _this.setState({ focus: true });
      }, _this.handleBlur = function () {
        return _this.setState({ focus: false });
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Focus, [{
      key: 'render',
      value: function render() {
        return _react2.default.createElement(
          Span,
          { onFocus: this.handleFocus, onBlur: this.handleBlur },
          _react2.default.createElement(Component, _extends({}, this.props, this.state))
        );
      }
    }]);

    return Focus;
  }(_react2.default.Component);
};

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlphaPointer = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(3);

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlphaPointer = exports.AlphaPointer = function AlphaPointer(_ref) {
  var direction = _ref.direction;

  var styles = (0, _reactcss2.default)({
    'default': {
      picker: {
        width: '18px',
        height: '18px',
        borderRadius: '50%',
        transform: 'translate(-9px, -1px)',
        backgroundColor: 'rgb(248, 248, 248)',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
      }
    },
    'vertical': {
      picker: {
        transform: 'translate(-3px, -9px)'
      }
    }
  }, { vertical: direction === 'vertical' });

  return _react2.default.createElement('div', { style: styles.picker });
};

exports.default = AlphaPointer;

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Block = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = __webpack_require__(3);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _color = __webpack_require__(16);

var _color2 = _interopRequireDefault(_color);

var _common = __webpack_require__(7);

var _BlockSwatches = __webpack_require__(611);

var _BlockSwatches2 = _interopRequireDefault(_BlockSwatches);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Block = exports.Block = function Block(_ref) {
  var onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      hex = _ref.hex,
      colors = _ref.colors,
      width = _ref.width,
      triangle = _ref.triangle,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var transparent = hex === 'transparent';
  var handleChange = function handleChange(hexCode, e) {
    _color2.default.isValidHex(hexCode) && onChange({
      hex: hexCode,
      source: 'hex'
    }, e);
  };

  var styles = (0, _reactcss2.default)({
    'default': {
      card: {
        width: width,
        background: '#fff',
        boxShadow: '0 1px rgba(0,0,0,.1)',
        borderRadius: '6px',
        position: 'relative'
      },
      head: {
        height: '110px',
        background: hex,
        borderRadius: '6px 6px 0 0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative'
      },
      body: {
        padding: '10px'
      },
      label: {
        fontSize: '18px',
        color: _color2.default.getContrastingColor(hex),
        position: 'relative'
      },
      triangle: {
        width: '0px',
        height: '0px',
        borderStyle: 'solid',
        borderWidth: '0 10px 10px 10px',
        borderColor: 'transparent transparent ' + hex + ' transparent',
        position: 'absolute',
        top: '-10px',
        left: '50%',
        marginLeft: '-10px'
      },
      input: {
        width: '100%',
        fontSize: '12px',
        color: '#666',
        border: '0px',
        outline: 'none',
        height: '22px',
        boxShadow: 'inset 0 0 0 1px #ddd',
        borderRadius: '4px',
        padding: '0 7px',
        boxSizing: 'border-box'
      }
    },
    'hide-triangle': {
      triangle: {
        display: 'none'
      }
    }
  }, { 'hide-triangle': triangle === 'hide' });

  return _react2.default.createElement(
    'div',
    { style: styles.card, className: 'block-picker ' + className },
    _react2.default.createElement('div', { style: styles.triangle }),
    _react2.default.createElement(
      'div',
      { style: styles.head },
      transparent && _react2.default.createElement(_common.Checkboard, { borderRadius: '6px 6px 0 0' }),
      _react2.default.createElement(
        'div',
        { style: styles.label },
        hex
      )
    ),
    _react2.default.createElement(
      'div',
      { style: styles.body },
      _react2.default.createElement(_BlockSwatches2.default, { colors: colors, onClick: handleChange, onSwatchHover: onSwatchHover }),
      _react2.default.createElement(_common.EditableInput, {
        style: { input: styles.input },
        value: hex,
        onChange: handleChange
      })
    )
  );
};

Block.propTypes = {
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  colors: _propTypes2.default.arrayOf(_propTypes2.default.string),
  triangle: _propTypes2.default.oneOf(['top', 'hide'])
};

Block.defaultProps = {
  width: 170,
  colors: ['#D9E3F0', '#F47373', '#697689', '#37D67A', '#2CCCE4', '#555555', '#dce775', '#ff8a65', '#ba68c8'],
  triangle: 'top'
};

exports.default = (0, _common.ColorWrap)(Block);

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BlockSwatches = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(3);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _map = __webpack_require__(26);

var _map2 = _interopRequireDefault(_map);

var _common = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BlockSwatches = exports.BlockSwatches = function BlockSwatches(_ref) {
  var colors = _ref.colors,
      onClick = _ref.onClick,
      onSwatchHover = _ref.onSwatchHover;

  var styles = (0, _reactcss2.default)({
    'default': {
      swatches: {
        marginRight: '-10px'
      },
      swatch: {
        width: '22px',
        height: '22px',
        float: 'left',
        marginRight: '10px',
        marginBottom: '10px',
        borderRadius: '4px'
      },
      clear: {
        clear: 'both'
      }
    }
  });

  return _react2.default.createElement(
    'div',
    { style: styles.swatches },
    (0, _map2.default)(colors, function (c) {
      return _react2.default.createElement(_common.Swatch, {
        key: c,
        color: c,
        style: styles.swatch,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: {
          boxShadow: '0 0 4px ' + c
        }
      });
    }),
    _react2.default.createElement('div', { style: styles.clear })
  );
};

exports.default = BlockSwatches;

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Circle = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = __webpack_require__(3);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _map = __webpack_require__(26);

var _map2 = _interopRequireDefault(_map);

var _materialColors = __webpack_require__(193);

var material = _interopRequireWildcard(_materialColors);

var _common = __webpack_require__(7);

var _CircleSwatch = __webpack_require__(613);

var _CircleSwatch2 = _interopRequireDefault(_CircleSwatch);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Circle = exports.Circle = function Circle(_ref) {
  var width = _ref.width,
      onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      colors = _ref.colors,
      hex = _ref.hex,
      circleSize = _ref.circleSize,
      circleSpacing = _ref.circleSpacing,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)({
    'default': {
      card: {
        width: width,
        display: 'flex',
        flexWrap: 'wrap',
        marginRight: -circleSpacing,
        marginBottom: -circleSpacing
      }
    }
  });

  var handleChange = function handleChange(hexCode, e) {
    return onChange({ hex: hexCode, source: 'hex' }, e);
  };

  return _react2.default.createElement(
    'div',
    { style: styles.card, className: 'circle-picker ' + className },
    (0, _map2.default)(colors, function (c) {
      return _react2.default.createElement(_CircleSwatch2.default, {
        key: c,
        color: c,
        onClick: handleChange,
        onSwatchHover: onSwatchHover,
        active: hex === c.toLowerCase(),
        circleSize: circleSize,
        circleSpacing: circleSpacing
      });
    })
  );
};

Circle.propTypes = {
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  circleSize: _propTypes2.default.number,
  circleSpacing: _propTypes2.default.number
};

Circle.defaultProps = {
  width: 252,
  circleSize: 28,
  circleSpacing: 14,
  colors: [material.red['500'], material.pink['500'], material.purple['500'], material.deepPurple['500'], material.indigo['500'], material.blue['500'], material.lightBlue['500'], material.cyan['500'], material.teal['500'], material.green['500'], material.lightGreen['500'], material.lime['500'], material.yellow['500'], material.amber['500'], material.orange['500'], material.deepOrange['500'], material.brown['500'], material.blueGrey['500']]
};

exports.default = (0, _common.ColorWrap)(Circle);

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CircleSwatch = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(3);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _common = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CircleSwatch = exports.CircleSwatch = function CircleSwatch(_ref) {
  var color = _ref.color,
      onClick = _ref.onClick,
      onSwatchHover = _ref.onSwatchHover,
      hover = _ref.hover,
      active = _ref.active,
      circleSize = _ref.circleSize,
      circleSpacing = _ref.circleSpacing;

  var styles = (0, _reactcss2.default)({
    'default': {
      swatch: {
        width: circleSize,
        height: circleSize,
        marginRight: circleSpacing,
        marginBottom: circleSpacing,
        transform: 'scale(1)',
        transition: '100ms transform ease'
      },
      Swatch: {
        borderRadius: '50%',
        background: 'transparent',
        boxShadow: 'inset 0 0 0 ' + circleSize / 2 + 'px ' + color,
        transition: '100ms box-shadow ease'
      }
    },
    'hover': {
      swatch: {
        transform: 'scale(1.2)'
      }
    },
    'active': {
      Swatch: {
        boxShadow: 'inset 0 0 0 3px ' + color
      }
    }
  }, { hover: hover, active: active });

  return _react2.default.createElement(
    'div',
    { style: styles.swatch },
    _react2.default.createElement(_common.Swatch, {
      style: styles.Swatch,
      color: color,
      onClick: onClick,
      onHover: onSwatchHover,
      focusStyle: { boxShadow: styles.Swatch.boxShadow + ', 0 0 5px ' + color }
    })
  );
};

CircleSwatch.defaultProps = {
  circleSize: 28,
  circleSpacing: 14
};

exports.default = (0, _reactcss.handleHover)(CircleSwatch);

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Chrome = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = __webpack_require__(3);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _common = __webpack_require__(7);

var _ChromeFields = __webpack_require__(615);

var _ChromeFields2 = _interopRequireDefault(_ChromeFields);

var _ChromePointer = __webpack_require__(616);

var _ChromePointer2 = _interopRequireDefault(_ChromePointer);

var _ChromePointerCircle = __webpack_require__(617);

var _ChromePointerCircle2 = _interopRequireDefault(_ChromePointerCircle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Chrome = exports.Chrome = function Chrome(_ref) {
  var onChange = _ref.onChange,
      disableAlpha = _ref.disableAlpha,
      rgb = _ref.rgb,
      hsl = _ref.hsl,
      hsv = _ref.hsv,
      hex = _ref.hex,
      renderers = _ref.renderers,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)({
    'default': {
      picker: {
        background: '#fff',
        borderRadius: '2px',
        boxShadow: '0 0 2px rgba(0,0,0,.3), 0 4px 8px rgba(0,0,0,.3)',
        boxSizing: 'initial',
        width: '225px',
        fontFamily: 'Menlo'
      },
      saturation: {
        width: '100%',
        paddingBottom: '55%',
        position: 'relative',
        borderRadius: '2px 2px 0 0',
        overflow: 'hidden'
      },
      Saturation: {
        radius: '2px 2px 0 0'
      },
      body: {
        padding: '16px 16px 12px'
      },
      controls: {
        display: 'flex'
      },
      color: {
        width: '32px'
      },
      swatch: {
        marginTop: '6px',
        width: '16px',
        height: '16px',
        borderRadius: '8px',
        position: 'relative',
        overflow: 'hidden'
      },
      active: {
        absolute: '0px 0px 0px 0px',
        borderRadius: '8px',
        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.1)',
        background: 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', ' + rgb.a + ')',
        zIndex: '2'
      },
      toggles: {
        flex: '1'
      },
      hue: {
        height: '10px',
        position: 'relative',
        marginBottom: '8px'
      },
      Hue: {
        radius: '2px'
      },
      alpha: {
        height: '10px',
        position: 'relative'
      },
      Alpha: {
        radius: '2px'
      }
    },
    'disableAlpha': {
      color: {
        width: '22px'
      },
      alpha: {
        display: 'none'
      },
      hue: {
        marginBottom: '0px'
      },
      swatch: {
        width: '10px',
        height: '10px',
        marginTop: '0px'
      }
    }
  }, { disableAlpha: disableAlpha });

  return _react2.default.createElement(
    'div',
    { style: styles.picker, className: 'chrome-picker ' + className },
    _react2.default.createElement(
      'div',
      { style: styles.saturation },
      _react2.default.createElement(_common.Saturation, {
        style: styles.Saturation,
        hsl: hsl,
        hsv: hsv,
        pointer: _ChromePointerCircle2.default,
        onChange: onChange
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.body },
      _react2.default.createElement(
        'div',
        { style: styles.controls, className: 'flexbox-fix' },
        _react2.default.createElement(
          'div',
          { style: styles.color },
          _react2.default.createElement(
            'div',
            { style: styles.swatch },
            _react2.default.createElement('div', { style: styles.active }),
            _react2.default.createElement(_common.Checkboard, { renderers: renderers })
          )
        ),
        _react2.default.createElement(
          'div',
          { style: styles.toggles },
          _react2.default.createElement(
            'div',
            { style: styles.hue },
            _react2.default.createElement(_common.Hue, {
              style: styles.Hue,
              hsl: hsl,
              pointer: _ChromePointer2.default,
              onChange: onChange
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.alpha },
            _react2.default.createElement(_common.Alpha, {
              style: styles.Alpha,
              rgb: rgb,
              hsl: hsl,
              pointer: _ChromePointer2.default,
              renderers: renderers,
              onChange: onChange
            })
          )
        )
      ),
      _react2.default.createElement(_ChromeFields2.default, {
        rgb: rgb,
        hsl: hsl,
        hex: hex,
        onChange: onChange,
        disableAlpha: disableAlpha
      })
    )
  );
};

Chrome.propTypes = {
  disableAlpha: _propTypes2.default.bool
};

Chrome.defaultProps = {
  disableAlpha: false
};

exports.default = (0, _common.ColorWrap)(Chrome);

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChromeFields = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(3);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _color = __webpack_require__(16);

var _color2 = _interopRequireDefault(_color);

var _common = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/no-did-mount-set-state, no-param-reassign */

var ChromeFields = exports.ChromeFields = function (_React$Component) {
  _inherits(ChromeFields, _React$Component);

  function ChromeFields() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ChromeFields);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ChromeFields.__proto__ || Object.getPrototypeOf(ChromeFields)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      view: ''
    }, _this.toggleViews = function () {
      if (_this.state.view === 'hex') {
        _this.setState({ view: 'rgb' });
      } else if (_this.state.view === 'rgb') {
        _this.setState({ view: 'hsl' });
      } else if (_this.state.view === 'hsl') {
        if (_this.props.hsl.a === 1) {
          _this.setState({ view: 'hex' });
        } else {
          _this.setState({ view: 'rgb' });
        }
      }
    }, _this.handleChange = function (data, e) {
      if (data.hex) {
        _color2.default.isValidHex(data.hex) && _this.props.onChange({
          hex: data.hex,
          source: 'hex'
        }, e);
      } else if (data.r || data.g || data.b) {
        _this.props.onChange({
          r: data.r || _this.props.rgb.r,
          g: data.g || _this.props.rgb.g,
          b: data.b || _this.props.rgb.b,
          source: 'rgb'
        }, e);
      } else if (data.a) {
        if (data.a < 0) {
          data.a = 0;
        } else if (data.a > 1) {
          data.a = 1;
        }

        _this.props.onChange({
          h: _this.props.hsl.h,
          s: _this.props.hsl.s,
          l: _this.props.hsl.l,
          a: Math.round(data.a * 100) / 100,
          source: 'rgb'
        }, e);
      } else if (data.h || data.s || data.l) {
        _this.props.onChange({
          h: data.h || _this.props.hsl.h,
          s: Number(data.s && data.s || _this.props.hsl.s),
          l: Number(data.l && data.l || _this.props.hsl.l),
          source: 'hsl'
        }, e);
      }
    }, _this.showHighlight = function (e) {
      e.target.style.background = '#eee';
    }, _this.hideHighlight = function (e) {
      e.target.style.background = 'transparent';
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ChromeFields, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.hsl.a === 1 && this.state.view !== 'hex') {
        this.setState({ view: 'hex' });
      } else if (this.state.view !== 'rgb' && this.state.view !== 'hsl') {
        this.setState({ view: 'rgb' });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.hsl.a !== 1 && this.state.view === 'hex') {
        this.setState({ view: 'rgb' });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = (0, _reactcss2.default)({
        'default': {
          wrap: {
            paddingTop: '16px',
            display: 'flex'
          },
          fields: {
            flex: '1',
            display: 'flex',
            marginLeft: '-6px'
          },
          field: {
            paddingLeft: '6px',
            width: '100%'
          },
          alpha: {
            paddingLeft: '6px',
            width: '100%'
          },
          toggle: {
            width: '32px',
            textAlign: 'right',
            position: 'relative'
          },
          icon: {
            marginRight: '-4px',
            marginTop: '12px',
            cursor: 'pointer',
            position: 'relative'
          },
          iconHighlight: {
            position: 'absolute',
            width: '24px',
            height: '28px',
            background: '#eee',
            borderRadius: '4px',
            top: '10px',
            left: '12px',
            display: 'none'
          },
          input: {
            fontSize: '11px',
            color: '#333',
            width: '100%',
            borderRadius: '2px',
            border: 'none',
            boxShadow: 'inset 0 0 0 1px #dadada',
            height: '21px',
            textAlign: 'center'
          },
          label: {
            textTransform: 'uppercase',
            fontSize: '11px',
            lineHeight: '11px',
            color: '#969696',
            textAlign: 'center',
            display: 'block',
            marginTop: '12px'
          },
          svg: {
            width: '24px',
            height: '24px',
            border: '1px transparent solid',
            borderRadius: '5px'
          }
        },
        'disableAlpha': {
          alpha: {
            display: 'none'
          }
        }
      }, this.props, this.state);

      var fields = void 0;
      if (this.state.view === 'hex') {
        fields = _react2.default.createElement(
          'div',
          { style: styles.fields, className: 'flexbox-fix' },
          _react2.default.createElement(
            'div',
            { style: styles.field },
            _react2.default.createElement(_common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'hex', value: this.props.hex,
              onChange: this.handleChange
            })
          )
        );
      } else if (this.state.view === 'rgb') {
        fields = _react2.default.createElement(
          'div',
          { style: styles.fields, className: 'flexbox-fix' },
          _react2.default.createElement(
            'div',
            { style: styles.field },
            _react2.default.createElement(_common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'r',
              value: this.props.rgb.r,
              onChange: this.handleChange
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.field },
            _react2.default.createElement(_common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'g',
              value: this.props.rgb.g,
              onChange: this.handleChange
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.field },
            _react2.default.createElement(_common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'b',
              value: this.props.rgb.b,
              onChange: this.handleChange
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.alpha },
            _react2.default.createElement(_common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'a',
              value: this.props.rgb.a,
              arrowOffset: 0.01,
              onChange: this.handleChange
            })
          )
        );
      } else if (this.state.view === 'hsl') {
        fields = _react2.default.createElement(
          'div',
          { style: styles.fields, className: 'flexbox-fix' },
          _react2.default.createElement(
            'div',
            { style: styles.field },
            _react2.default.createElement(_common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'h',
              value: Math.round(this.props.hsl.h),
              onChange: this.handleChange
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.field },
            _react2.default.createElement(_common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 's',
              value: Math.round(this.props.hsl.s * 100) + '%',
              onChange: this.handleChange
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.field },
            _react2.default.createElement(_common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'l',
              value: Math.round(this.props.hsl.l * 100) + '%',
              onChange: this.handleChange
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.alpha },
            _react2.default.createElement(_common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'a',
              value: this.props.hsl.a,
              arrowOffset: 0.01,
              onChange: this.handleChange
            })
          )
        );
      }

      return _react2.default.createElement(
        'div',
        { style: styles.wrap, className: 'flexbox-fix' },
        fields,
        _react2.default.createElement(
          'div',
          { style: styles.toggle },
          _react2.default.createElement(
            'div',
            { style: styles.icon, onClick: this.toggleViews, ref: function ref(icon) {
                return _this2.icon = icon;
              } },
            _react2.default.createElement(
              'svg',
              {
                style: styles.svg,
                viewBox: '0 0 24 24',
                onMouseOver: this.showHighlight,
                onMouseEnter: this.showHighlight,
                onMouseOut: this.hideHighlight
              },
              _react2.default.createElement('path', {
                ref: function ref(iconUp) {
                  return _this2.iconUp = iconUp;
                },
                fill: '#333',
                d: 'M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z'
              }),
              _react2.default.createElement('path', {
                ref: function ref(iconDown) {
                  return _this2.iconDown = iconDown;
                },
                fill: '#333',
                d: 'M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15Z'
              })
            )
          )
        )
      );
    }
  }]);

  return ChromeFields;
}(_react2.default.Component);

exports.default = ChromeFields;

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChromePointer = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(3);

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChromePointer = exports.ChromePointer = function ChromePointer() {
  var styles = (0, _reactcss2.default)({
    'default': {
      picker: {
        width: '12px',
        height: '12px',
        borderRadius: '6px',
        transform: 'translate(-6px, -1px)',
        backgroundColor: 'rgb(248, 248, 248)',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
      }
    }
  });

  return _react2.default.createElement('div', { style: styles.picker });
};

exports.default = ChromePointer;

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChromePointerCircle = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(3);

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChromePointerCircle = exports.ChromePointerCircle = function ChromePointerCircle() {
  var styles = (0, _reactcss2.default)({
    'default': {
      picker: {
        width: '12px',
        height: '12px',
        borderRadius: '6px',
        boxShadow: 'inset 0 0 0 1px #fff',
        transform: 'translate(-6px, -6px)'
      }
    }
  });

  return _react2.default.createElement('div', { style: styles.picker });
};

exports.default = ChromePointerCircle;

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Compact = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = __webpack_require__(3);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _map = __webpack_require__(26);

var _map2 = _interopRequireDefault(_map);

var _color = __webpack_require__(16);

var _color2 = _interopRequireDefault(_color);

var _common = __webpack_require__(7);

var _CompactColor = __webpack_require__(619);

var _CompactColor2 = _interopRequireDefault(_CompactColor);

var _CompactFields = __webpack_require__(620);

var _CompactFields2 = _interopRequireDefault(_CompactFields);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Compact = exports.Compact = function Compact(_ref) {
  var onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      colors = _ref.colors,
      hex = _ref.hex,
      rgb = _ref.rgb,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)({
    'default': {
      Compact: {
        background: '#f6f6f6',
        radius: '4px'
      },
      compact: {
        paddingTop: '5px',
        paddingLeft: '5px',
        boxSizing: 'initial',
        width: '240px'
      },
      clear: {
        clear: 'both'
      }
    }
  });

  var handleChange = function handleChange(data, e) {
    if (data.hex) {
      _color2.default.isValidHex(data.hex) && onChange({
        hex: data.hex,
        source: 'hex'
      }, e);
    } else {
      onChange(data, e);
    }
  };

  return _react2.default.createElement(
    _common.Raised,
    { style: styles.Compact },
    _react2.default.createElement(
      'div',
      { style: styles.compact, className: 'compact-picker ' + className },
      _react2.default.createElement(
        'div',
        null,
        (0, _map2.default)(colors, function (c) {
          return _react2.default.createElement(_CompactColor2.default, {
            key: c,
            color: c,
            active: c.toLowerCase() === hex,
            onClick: handleChange,
            onSwatchHover: onSwatchHover
          });
        }),
        _react2.default.createElement('div', { style: styles.clear })
      ),
      _react2.default.createElement(_CompactFields2.default, { hex: hex, rgb: rgb, onChange: handleChange })
    )
  );
};

Compact.propTypes = {
  colors: _propTypes2.default.arrayOf(_propTypes2.default.string)
};

Compact.defaultProps = {
  colors: ['#4D4D4D', '#999999', '#FFFFFF', '#F44E3B', '#FE9200', '#FCDC00', '#DBDF00', '#A4DD00', '#68CCCA', '#73D8FF', '#AEA1FF', '#FDA1FF', '#333333', '#808080', '#cccccc', '#D33115', '#E27300', '#FCC400', '#B0BC00', '#68BC00', '#16A5A5', '#009CE0', '#7B64FF', '#FA28FF', '#000000', '#666666', '#B3B3B3', '#9F0500', '#C45100', '#FB9E00', '#808900', '#194D33', '#0C797D', '#0062B1', '#653294', '#AB149E']
};

exports.default = (0, _common.ColorWrap)(Compact);

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CompactColor = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(3);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _color = __webpack_require__(16);

var _color2 = _interopRequireDefault(_color);

var _common = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CompactColor = exports.CompactColor = function CompactColor(_ref) {
  var color = _ref.color,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      onSwatchHover = _ref.onSwatchHover,
      active = _ref.active;

  var styles = (0, _reactcss2.default)({
    'default': {
      color: {
        background: color,
        width: '15px',
        height: '15px',
        float: 'left',
        marginRight: '5px',
        marginBottom: '5px',
        position: 'relative',
        cursor: 'pointer'
      },
      dot: {
        absolute: '5px 5px 5px 5px',
        background: _color2.default.getContrastingColor(color),
        borderRadius: '50%',
        opacity: '0'
      }
    },
    'active': {
      dot: {
        opacity: '1'
      }
    },
    'color-#FFFFFF': {
      color: {
        boxShadow: 'inset 0 0 0 1px #ddd'
      },
      dot: {
        background: '#000'
      }
    },
    'transparent': {
      dot: {
        background: '#000'
      }
    }
  }, { active: active, 'color-#FFFFFF': color === '#FFFFFF', 'transparent': color === 'transparent' });

  return _react2.default.createElement(
    _common.Swatch,
    {
      style: styles.color,
      color: color,
      onClick: onClick,
      onHover: onSwatchHover,
      focusStyle: { boxShadow: '0 0 4px ' + color }
    },
    _react2.default.createElement('div', { style: styles.dot })
  );
};

exports.default = CompactColor;

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CompactFields = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(3);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _common = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CompactFields = exports.CompactFields = function CompactFields(_ref) {
  var hex = _ref.hex,
      rgb = _ref.rgb,
      onChange = _ref.onChange;

  var styles = (0, _reactcss2.default)({
    'default': {
      fields: {
        display: 'flex',
        paddingBottom: '6px',
        paddingRight: '5px',
        position: 'relative'
      },
      active: {
        position: 'absolute',
        top: '6px',
        left: '5px',
        height: '9px',
        width: '9px',
        background: hex
      },
      HEXwrap: {
        flex: '6',
        position: 'relative'
      },
      HEXinput: {
        width: '80%',
        padding: '0px',
        paddingLeft: '20%',
        border: 'none',
        outline: 'none',
        background: 'none',
        fontSize: '12px',
        color: '#333',
        height: '16px'
      },
      HEXlabel: {
        display: 'none'
      },
      RGBwrap: {
        flex: '3',
        position: 'relative'
      },
      RGBinput: {
        width: '70%',
        padding: '0px',
        paddingLeft: '30%',
        border: 'none',
        outline: 'none',
        background: 'none',
        fontSize: '12px',
        color: '#333',
        height: '16px'
      },
      RGBlabel: {
        position: 'absolute',
        top: '3px',
        left: '0px',
        lineHeight: '16px',
        textTransform: 'uppercase',
        fontSize: '12px',
        color: '#999'
      }
    }
  });

  var handleChange = function handleChange(data, e) {
    if (data.r || data.g || data.b) {
      onChange({
        r: data.r || rgb.r,
        g: data.g || rgb.g,
        b: data.b || rgb.b,
        source: 'rgb'
      }, e);
    } else {
      onChange({
        hex: data.hex,
        source: 'hex'
      }, e);
    }
  };

  return _react2.default.createElement(
    'div',
    { style: styles.fields, className: 'flexbox-fix' },
    _react2.default.createElement('div', { style: styles.active }),
    _react2.default.createElement(_common.EditableInput, {
      style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel },
      label: 'hex',
      value: hex,
      onChange: handleChange
    }),
    _react2.default.createElement(_common.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'r',
      value: rgb.r,
      onChange: handleChange
    }),
    _react2.default.createElement(_common.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'g',
      value: rgb.g,
      onChange: handleChange
    }),
    _react2.default.createElement(_common.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'b',
      value: rgb.b,
      onChange: handleChange
    })
  );
};

exports.default = CompactFields;

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Github = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = __webpack_require__(3);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _map = __webpack_require__(26);

var _map2 = _interopRequireDefault(_map);

var _common = __webpack_require__(7);

var _GithubSwatch = __webpack_require__(622);

var _GithubSwatch2 = _interopRequireDefault(_GithubSwatch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Github = exports.Github = function Github(_ref) {
  var width = _ref.width,
      colors = _ref.colors,
      onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      triangle = _ref.triangle,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)({
    'default': {
      card: {
        width: width,
        background: '#fff',
        border: '1px solid rgba(0,0,0,0.2)',
        boxShadow: '0 3px 12px rgba(0,0,0,0.15)',
        borderRadius: '4px',
        position: 'relative',
        padding: '5px',
        display: 'flex',
        flexWrap: 'wrap'
      },
      triangle: {
        position: 'absolute',
        border: '7px solid transparent',
        borderBottomColor: '#fff'
      },
      triangleShadow: {
        position: 'absolute',
        border: '8px solid transparent',
        borderBottomColor: 'rgba(0,0,0,0.15)'
      }
    },
    'hide-triangle': {
      triangle: {
        display: 'none'
      },
      triangleShadow: {
        display: 'none'
      }
    },
    'top-left-triangle': {
      triangle: {
        top: '-14px',
        left: '10px'
      },
      triangleShadow: {
        top: '-16px',
        left: '9px'
      }
    },
    'top-right-triangle': {
      triangle: {
        top: '-14px',
        right: '10px'
      },
      triangleShadow: {
        top: '-16px',
        right: '9px'
      }
    },
    'bottom-left-triangle': {
      triangle: {
        top: '35px',
        left: '10px',
        transform: 'rotate(180deg)'
      },
      triangleShadow: {
        top: '37px',
        left: '9px',
        transform: 'rotate(180deg)'
      }
    },
    'bottom-right-triangle': {
      triangle: {
        top: '35px',
        right: '10px',
        transform: 'rotate(180deg)'
      },
      triangleShadow: {
        top: '37px',
        right: '9px',
        transform: 'rotate(180deg)'
      }
    }
  }, {
    'hide-triangle': triangle === 'hide',
    'top-left-triangle': triangle === 'top-left',
    'top-right-triangle': triangle === 'top-right',
    'bottom-left-triangle': triangle == 'bottom-left',
    'bottom-right-triangle': triangle === 'bottom-right'
  });

  var handleChange = function handleChange(hex, e) {
    return onChange({ hex: hex, source: 'hex' }, e);
  };

  return _react2.default.createElement(
    'div',
    { style: styles.card, className: 'github-picker ' + className },
    _react2.default.createElement('div', { style: styles.triangleShadow }),
    _react2.default.createElement('div', { style: styles.triangle }),
    (0, _map2.default)(colors, function (c) {
      return _react2.default.createElement(_GithubSwatch2.default, {
        color: c,
        key: c,
        onClick: handleChange,
        onSwatchHover: onSwatchHover
      });
    })
  );
};

Github.propTypes = {
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  colors: _propTypes2.default.arrayOf(_propTypes2.default.string),
  triangle: _propTypes2.default.oneOf(['hide', 'top-left', 'top-right', 'bottom-left', 'bottom-right'])
};

Github.defaultProps = {
  width: 200,
  colors: ['#B80000', '#DB3E00', '#FCCB00', '#008B02', '#006B76', '#1273DE', '#004DCF', '#5300EB', '#EB9694', '#FAD0C3', '#FEF3BD', '#C1E1C5', '#BEDADC', '#C4DEF6', '#BED3F3', '#D4C4FB'],
  triangle: 'top-left'
};

exports.default = (0, _common.ColorWrap)(Github);

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GithubSwatch = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(3);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _common = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GithubSwatch = exports.GithubSwatch = function GithubSwatch(_ref) {
  var hover = _ref.hover,
      color = _ref.color,
      onClick = _ref.onClick,
      onSwatchHover = _ref.onSwatchHover;

  var hoverSwatch = {
    position: 'relative',
    zIndex: '2',
    outline: '2px solid #fff',
    boxShadow: '0 0 5px 2px rgba(0,0,0,0.25)'
  };

  var styles = (0, _reactcss2.default)({
    'default': {
      swatch: {
        width: '25px',
        height: '25px',
        fontSize: '0'
      }
    },
    'hover': {
      swatch: hoverSwatch
    }
  }, { hover: hover });

  return _react2.default.createElement(
    'div',
    { style: styles.swatch },
    _react2.default.createElement(_common.Swatch, {
      color: color,
      onClick: onClick,
      onHover: onSwatchHover,
      focusStyle: hoverSwatch
    })
  );
};

exports.default = (0, _reactcss.handleHover)(GithubSwatch);

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HuePicker = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(3);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _common = __webpack_require__(7);

var _HuePointer = __webpack_require__(624);

var _HuePointer2 = _interopRequireDefault(_HuePointer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HuePicker = exports.HuePicker = function HuePicker(_ref) {
  var width = _ref.width,
      height = _ref.height,
      onChange = _ref.onChange,
      hsl = _ref.hsl,
      direction = _ref.direction,
      pointer = _ref.pointer,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)({
    'default': {
      picker: {
        position: 'relative',
        width: width,
        height: height
      },
      hue: {
        radius: '2px'
      }
    }
  });

  // Overwrite to provide pure hue color
  var handleChange = function handleChange(data) {
    return onChange({ a: 1, h: data.h, l: 0.5, s: 1 });
  };

  return _react2.default.createElement(
    'div',
    { style: styles.picker, className: 'hue-picker ' + className },
    _react2.default.createElement(_common.Hue, _extends({}, styles.hue, {
      hsl: hsl,
      pointer: pointer,
      onChange: handleChange,
      direction: direction
    }))
  );
};

HuePicker.defaultProps = {
  width: '316px',
  height: '16px',
  direction: 'horizontal',
  pointer: _HuePointer2.default
};

exports.default = (0, _common.ColorWrap)(HuePicker);

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SliderPointer = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(3);

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SliderPointer = exports.SliderPointer = function SliderPointer(_ref) {
  var direction = _ref.direction;

  var styles = (0, _reactcss2.default)({
    'default': {
      picker: {
        width: '18px',
        height: '18px',
        borderRadius: '50%',
        transform: 'translate(-9px, -1px)',
        backgroundColor: 'rgb(248, 248, 248)',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
      }
    },
    'vertical': {
      picker: {
        transform: 'translate(-3px, -9px)'
      }
    }
  }, { vertical: direction === 'vertical' });

  return _react2.default.createElement('div', { style: styles.picker });
};

exports.default = SliderPointer;

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Material = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(3);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _color = __webpack_require__(16);

var _color2 = _interopRequireDefault(_color);

var _common = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Material = exports.Material = function Material(_ref) {
  var onChange = _ref.onChange,
      hex = _ref.hex,
      rgb = _ref.rgb,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)({
    'default': {
      material: {
        width: '98px',
        height: '98px',
        padding: '16px',
        fontFamily: 'Roboto'
      },
      HEXwrap: {
        position: 'relative'
      },
      HEXinput: {
        width: '100%',
        marginTop: '12px',
        fontSize: '15px',
        color: '#333',
        padding: '0px',
        border: '0px',
        borderBottom: '2px solid ' + hex,
        outline: 'none',
        height: '30px'
      },
      HEXlabel: {
        position: 'absolute',
        top: '0px',
        left: '0px',
        fontSize: '11px',
        color: '#999999',
        textTransform: 'capitalize'
      },
      Hex: {
        style: {}
      },
      RGBwrap: {
        position: 'relative'
      },
      RGBinput: {
        width: '100%',
        marginTop: '12px',
        fontSize: '15px',
        color: '#333',
        padding: '0px',
        border: '0px',
        borderBottom: '1px solid #eee',
        outline: 'none',
        height: '30px'
      },
      RGBlabel: {
        position: 'absolute',
        top: '0px',
        left: '0px',
        fontSize: '11px',
        color: '#999999',
        textTransform: 'capitalize'
      },
      split: {
        display: 'flex',
        marginRight: '-10px',
        paddingTop: '11px'
      },
      third: {
        flex: '1',
        paddingRight: '10px'
      }
    }
  });

  var handleChange = function handleChange(data, e) {
    if (data.hex) {
      _color2.default.isValidHex(data.hex) && onChange({
        hex: data.hex,
        source: 'hex'
      }, e);
    } else if (data.r || data.g || data.b) {
      onChange({
        r: data.r || rgb.r,
        g: data.g || rgb.g,
        b: data.b || rgb.b,
        source: 'rgb'
      }, e);
    }
  };

  return _react2.default.createElement(
    _common.Raised,
    null,
    _react2.default.createElement(
      'div',
      { style: styles.material, className: 'material-picker ' + className },
      _react2.default.createElement(_common.EditableInput, {
        style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel },
        label: 'hex',
        value: hex,
        onChange: handleChange
      }),
      _react2.default.createElement(
        'div',
        { style: styles.split, className: 'flexbox-fix' },
        _react2.default.createElement(
          'div',
          { style: styles.third },
          _react2.default.createElement(_common.EditableInput, {
            style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
            label: 'r', value: rgb.r,
            onChange: handleChange
          })
        ),
        _react2.default.createElement(
          'div',
          { style: styles.third },
          _react2.default.createElement(_common.EditableInput, {
            style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
            label: 'g',
            value: rgb.g,
            onChange: handleChange
          })
        ),
        _react2.default.createElement(
          'div',
          { style: styles.third },
          _react2.default.createElement(_common.EditableInput, {
            style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
            label: 'b',
            value: rgb.b,
            onChange: handleChange
          })
        )
      )
    )
  );
};

exports.default = (0, _common.ColorWrap)(Material);

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Photoshop = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = __webpack_require__(3);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _common = __webpack_require__(7);

var _PhotoshopFields = __webpack_require__(627);

var _PhotoshopFields2 = _interopRequireDefault(_PhotoshopFields);

var _PhotoshopPointerCircle = __webpack_require__(628);

var _PhotoshopPointerCircle2 = _interopRequireDefault(_PhotoshopPointerCircle);

var _PhotoshopPointer = __webpack_require__(629);

var _PhotoshopPointer2 = _interopRequireDefault(_PhotoshopPointer);

var _PhotoshopButton = __webpack_require__(630);

var _PhotoshopButton2 = _interopRequireDefault(_PhotoshopButton);

var _PhotoshopPreviews = __webpack_require__(631);

var _PhotoshopPreviews2 = _interopRequireDefault(_PhotoshopPreviews);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Photoshop = exports.Photoshop = function (_React$Component) {
  _inherits(Photoshop, _React$Component);

  function Photoshop(props) {
    _classCallCheck(this, Photoshop);

    var _this = _possibleConstructorReturn(this, (Photoshop.__proto__ || Object.getPrototypeOf(Photoshop)).call(this));

    _this.state = {
      currentColor: props.hex
    };
    return _this;
  }

  _createClass(Photoshop, [{
    key: 'render',
    value: function render() {
      var _props$className = this.props.className,
          className = _props$className === undefined ? '' : _props$className;

      var styles = (0, _reactcss2.default)({
        'default': {
          picker: {
            background: '#DCDCDC',
            borderRadius: '4px',
            boxShadow: '0 0 0 1px rgba(0,0,0,.25), 0 8px 16px rgba(0,0,0,.15)',
            boxSizing: 'initial',
            width: '513px'
          },
          head: {
            backgroundImage: 'linear-gradient(-180deg, #F0F0F0 0%, #D4D4D4 100%)',
            borderBottom: '1px solid #B1B1B1',
            boxShadow: 'inset 0 1px 0 0 rgba(255,255,255,.2), inset 0 -1px 0 0 rgba(0,0,0,.02)',
            height: '23px',
            lineHeight: '24px',
            borderRadius: '4px 4px 0 0',
            fontSize: '13px',
            color: '#4D4D4D',
            textAlign: 'center'
          },
          body: {
            padding: '15px 15px 0',
            display: 'flex'
          },
          saturation: {
            width: '256px',
            height: '256px',
            position: 'relative',
            border: '2px solid #B3B3B3',
            borderBottom: '2px solid #F0F0F0',
            overflow: 'hidden'
          },
          hue: {
            position: 'relative',
            height: '256px',
            width: '19px',
            marginLeft: '10px',
            border: '2px solid #B3B3B3',
            borderBottom: '2px solid #F0F0F0'
          },
          controls: {
            width: '180px',
            marginLeft: '10px'
          },
          top: {
            display: 'flex'
          },
          previews: {
            width: '60px'
          },
          actions: {
            flex: '1',
            marginLeft: '20px'
          }
        }
      });

      return _react2.default.createElement(
        'div',
        { style: styles.picker, className: 'photoshop-picker ' + className },
        _react2.default.createElement(
          'div',
          { style: styles.head },
          this.props.header
        ),
        _react2.default.createElement(
          'div',
          { style: styles.body, className: 'flexbox-fix' },
          _react2.default.createElement(
            'div',
            { style: styles.saturation },
            _react2.default.createElement(_common.Saturation, {
              hsl: this.props.hsl,
              hsv: this.props.hsv,
              pointer: _PhotoshopPointerCircle2.default,
              onChange: this.props.onChange
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.hue },
            _react2.default.createElement(_common.Hue, {
              direction: 'vertical',
              hsl: this.props.hsl,
              pointer: _PhotoshopPointer2.default,
              onChange: this.props.onChange
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.controls },
            _react2.default.createElement(
              'div',
              { style: styles.top, className: 'flexbox-fix' },
              _react2.default.createElement(
                'div',
                { style: styles.previews },
                _react2.default.createElement(_PhotoshopPreviews2.default, {
                  rgb: this.props.rgb,
                  currentColor: this.state.currentColor
                })
              ),
              _react2.default.createElement(
                'div',
                { style: styles.actions },
                _react2.default.createElement(_PhotoshopButton2.default, { label: 'OK', onClick: this.props.onAccept, active: true }),
                _react2.default.createElement(_PhotoshopButton2.default, { label: 'Cancel', onClick: this.props.onCancel }),
                _react2.default.createElement(_PhotoshopFields2.default, {
                  onChange: this.props.onChange,
                  rgb: this.props.rgb,
                  hsv: this.props.hsv,
                  hex: this.props.hex
                })
              )
            )
          )
        )
      );
    }
  }]);

  return Photoshop;
}(_react2.default.Component);

Photoshop.propTypes = {
  header: _propTypes2.default.string
};

Photoshop.defaultProps = {
  header: 'Color Picker'
};

exports.default = (0, _common.ColorWrap)(Photoshop);

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhotoshopPicker = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(3);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _color = __webpack_require__(16);

var _color2 = _interopRequireDefault(_color);

var _common = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PhotoshopPicker = exports.PhotoshopPicker = function PhotoshopPicker(_ref) {
  var onChange = _ref.onChange,
      rgb = _ref.rgb,
      hsv = _ref.hsv,
      hex = _ref.hex;

  var styles = (0, _reactcss2.default)({
    'default': {
      fields: {
        paddingTop: '5px',
        paddingBottom: '9px',
        width: '80px',
        position: 'relative'
      },
      divider: {
        height: '5px'
      },
      RGBwrap: {
        position: 'relative'
      },
      RGBinput: {
        marginLeft: '40%',
        width: '40%',
        height: '18px',
        border: '1px solid #888888',
        boxShadow: 'inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC',
        marginBottom: '5px',
        fontSize: '13px',
        paddingLeft: '3px',
        marginRight: '10px'
      },
      RGBlabel: {
        left: '0px',
        width: '34px',
        textTransform: 'uppercase',
        fontSize: '13px',
        height: '18px',
        lineHeight: '22px',
        position: 'absolute'
      },
      HEXwrap: {
        position: 'relative'
      },
      HEXinput: {
        marginLeft: '20%',
        width: '80%',
        height: '18px',
        border: '1px solid #888888',
        boxShadow: 'inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC',
        marginBottom: '6px',
        fontSize: '13px',
        paddingLeft: '3px'
      },
      HEXlabel: {
        position: 'absolute',
        top: '0px',
        left: '0px',
        width: '14px',
        textTransform: 'uppercase',
        fontSize: '13px',
        height: '18px',
        lineHeight: '22px'
      },
      fieldSymbols: {
        position: 'absolute',
        top: '5px',
        right: '-7px',
        fontSize: '13px'
      },
      symbol: {
        height: '20px',
        lineHeight: '22px',
        paddingBottom: '7px'
      }
    }
  });

  var handleChange = function handleChange(data, e) {
    if (data['#']) {
      _color2.default.isValidHex(data['#']) && onChange({
        hex: data['#'],
        source: 'hex'
      }, e);
    } else if (data.r || data.g || data.b) {
      onChange({
        r: data.r || rgb.r,
        g: data.g || rgb.g,
        b: data.b || rgb.b,
        source: 'rgb'
      }, e);
    } else if (data.h || data.s || data.v) {
      onChange({
        h: data.h || hsv.h,
        s: data.s || hsv.s,
        v: data.v || hsv.v,
        source: 'hsv'
      }, e);
    }
  };

  return _react2.default.createElement(
    'div',
    { style: styles.fields },
    _react2.default.createElement(_common.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'h',
      value: Math.round(hsv.h),
      onChange: handleChange
    }),
    _react2.default.createElement(_common.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 's',
      value: Math.round(hsv.s * 100),
      onChange: handleChange
    }),
    _react2.default.createElement(_common.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'v',
      value: Math.round(hsv.v * 100),
      onChange: handleChange
    }),
    _react2.default.createElement('div', { style: styles.divider }),
    _react2.default.createElement(_common.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'r',
      value: rgb.r,
      onChange: handleChange
    }),
    _react2.default.createElement(_common.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'g',
      value: rgb.g,
      onChange: handleChange
    }),
    _react2.default.createElement(_common.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'b',
      value: rgb.b,
      onChange: handleChange
    }),
    _react2.default.createElement('div', { style: styles.divider }),
    _react2.default.createElement(_common.EditableInput, {
      style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel },
      label: '#',
      value: hex.replace('#', ''),
      onChange: handleChange
    }),
    _react2.default.createElement(
      'div',
      { style: styles.fieldSymbols },
      _react2.default.createElement(
        'div',
        { style: styles.symbol },
        '\xB0'
      ),
      _react2.default.createElement(
        'div',
        { style: styles.symbol },
        '%'
      ),
      _react2.default.createElement(
        'div',
        { style: styles.symbol },
        '%'
      )
    )
  );
};

exports.default = PhotoshopPicker;

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhotoshopPointerCircle = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(3);

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PhotoshopPointerCircle = exports.PhotoshopPointerCircle = function PhotoshopPointerCircle(_ref) {
  var hsl = _ref.hsl;

  var styles = (0, _reactcss2.default)({
    'default': {
      picker: {
        width: '12px',
        height: '12px',
        borderRadius: '6px',
        boxShadow: 'inset 0 0 0 1px #fff',
        transform: 'translate(-6px, -6px)'
      }
    },
    'black-outline': {
      picker: {
        boxShadow: 'inset 0 0 0 1px #000'
      }
    }
  }, { 'black-outline': hsl.l > 0.5 });

  return _react2.default.createElement('div', { style: styles.picker });
};

exports.default = PhotoshopPointerCircle;

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhotoshopPointerCircle = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(3);

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PhotoshopPointerCircle = exports.PhotoshopPointerCircle = function PhotoshopPointerCircle() {
  var styles = (0, _reactcss2.default)({
    'default': {
      triangle: {
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '4px 0 4px 6px',
        borderColor: 'transparent transparent transparent #fff',
        position: 'absolute',
        top: '1px',
        left: '1px'
      },
      triangleBorder: {
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '5px 0 5px 8px',
        borderColor: 'transparent transparent transparent #555'
      },

      left: {
        Extend: 'triangleBorder',
        transform: 'translate(-13px, -4px)'
      },
      leftInside: {
        Extend: 'triangle',
        transform: 'translate(-8px, -5px)'
      },

      right: {
        Extend: 'triangleBorder',
        transform: 'translate(20px, -14px) rotate(180deg)'
      },
      rightInside: {
        Extend: 'triangle',
        transform: 'translate(-8px, -5px)'
      }
    }
  });

  return _react2.default.createElement(
    'div',
    { style: styles.pointer },
    _react2.default.createElement(
      'div',
      { style: styles.left },
      _react2.default.createElement('div', { style: styles.leftInside })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.right },
      _react2.default.createElement('div', { style: styles.rightInside })
    )
  );
};

exports.default = PhotoshopPointerCircle;

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhotoshopBotton = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(3);

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PhotoshopBotton = exports.PhotoshopBotton = function PhotoshopBotton(_ref) {
  var onClick = _ref.onClick,
      label = _ref.label,
      children = _ref.children,
      active = _ref.active;

  var styles = (0, _reactcss2.default)({
    'default': {
      button: {
        backgroundImage: 'linear-gradient(-180deg, #FFFFFF 0%, #E6E6E6 100%)',
        border: '1px solid #878787',
        borderRadius: '2px',
        height: '20px',
        boxShadow: '0 1px 0 0 #EAEAEA',
        fontSize: '14px',
        color: '#000',
        lineHeight: '20px',
        textAlign: 'center',
        marginBottom: '10px',
        cursor: 'pointer'
      }
    },
    'active': {
      button: {
        boxShadow: '0 0 0 1px #878787'
      }
    }
  }, { active: active });

  return _react2.default.createElement(
    'div',
    { style: styles.button, onClick: onClick },
    label || children
  );
};

exports.default = PhotoshopBotton;

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhotoshopPreviews = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(3);

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PhotoshopPreviews = exports.PhotoshopPreviews = function PhotoshopPreviews(_ref) {
  var rgb = _ref.rgb,
      currentColor = _ref.currentColor;

  var styles = (0, _reactcss2.default)({
    'default': {
      swatches: {
        border: '1px solid #B3B3B3',
        borderBottom: '1px solid #F0F0F0',
        marginBottom: '2px',
        marginTop: '1px'
      },
      new: {
        height: '34px',
        background: 'rgb(' + rgb.r + ',' + rgb.g + ', ' + rgb.b + ')',
        boxShadow: 'inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 1px 0 #000'
      },
      current: {
        height: '34px',
        background: currentColor,
        boxShadow: 'inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 -1px 0 #000'
      },
      label: {
        fontSize: '14px',
        color: '#000',
        textAlign: 'center'
      }
    }
  });

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      { style: styles.label },
      'new'
    ),
    _react2.default.createElement(
      'div',
      { style: styles.swatches },
      _react2.default.createElement('div', { style: styles.new }),
      _react2.default.createElement('div', { style: styles.current })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.label },
      'current'
    )
  );
};

exports.default = PhotoshopPreviews;

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Sketch = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = __webpack_require__(3);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _common = __webpack_require__(7);

var _SketchFields = __webpack_require__(633);

var _SketchFields2 = _interopRequireDefault(_SketchFields);

var _SketchPresetColors = __webpack_require__(634);

var _SketchPresetColors2 = _interopRequireDefault(_SketchPresetColors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Sketch = exports.Sketch = function Sketch(_ref) {
  var width = _ref.width,
      rgb = _ref.rgb,
      hex = _ref.hex,
      hsv = _ref.hsv,
      hsl = _ref.hsl,
      onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      disableAlpha = _ref.disableAlpha,
      presetColors = _ref.presetColors,
      renderers = _ref.renderers,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)({
    'default': {
      picker: {
        width: width,
        padding: '10px 10px 0',
        boxSizing: 'initial',
        background: '#fff',
        borderRadius: '4px',
        boxShadow: '0 0 0 1px rgba(0,0,0,.15), 0 8px 16px rgba(0,0,0,.15)'
      },
      saturation: {
        width: '100%',
        paddingBottom: '75%',
        position: 'relative',
        overflow: 'hidden'
      },
      Saturation: {
        radius: '3px',
        shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
      },
      controls: {
        display: 'flex'
      },
      sliders: {
        padding: '4px 0',
        flex: '1'
      },
      color: {
        width: '24px',
        height: '24px',
        position: 'relative',
        marginTop: '4px',
        marginLeft: '4px',
        borderRadius: '3px'
      },
      activeColor: {
        absolute: '0px 0px 0px 0px',
        borderRadius: '2px',
        background: 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',' + rgb.a + ')',
        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
      },
      hue: {
        position: 'relative',
        height: '10px',
        overflow: 'hidden'
      },
      Hue: {
        radius: '2px',
        shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
      },

      alpha: {
        position: 'relative',
        height: '10px',
        marginTop: '4px',
        overflow: 'hidden'
      },
      Alpha: {
        radius: '2px',
        shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
      }
    },
    'disableAlpha': {
      color: {
        height: '10px'
      },
      hue: {
        height: '10px'
      },
      alpha: {
        display: 'none'
      }
    }
  }, { disableAlpha: disableAlpha });

  return _react2.default.createElement(
    'div',
    { style: styles.picker, className: 'sketch-picker ' + className },
    _react2.default.createElement(
      'div',
      { style: styles.saturation },
      _react2.default.createElement(_common.Saturation, {
        style: styles.Saturation,
        hsl: hsl,
        hsv: hsv,
        onChange: onChange
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.controls, className: 'flexbox-fix' },
      _react2.default.createElement(
        'div',
        { style: styles.sliders },
        _react2.default.createElement(
          'div',
          { style: styles.hue },
          _react2.default.createElement(_common.Hue, {
            style: styles.Hue,
            hsl: hsl,
            onChange: onChange
          })
        ),
        _react2.default.createElement(
          'div',
          { style: styles.alpha },
          _react2.default.createElement(_common.Alpha, {
            style: styles.Alpha,
            rgb: rgb,
            hsl: hsl,
            renderers: renderers,
            onChange: onChange
          })
        )
      ),
      _react2.default.createElement(
        'div',
        { style: styles.color },
        _react2.default.createElement(_common.Checkboard, null),
        _react2.default.createElement('div', { style: styles.activeColor })
      )
    ),
    _react2.default.createElement(_SketchFields2.default, {
      rgb: rgb,
      hsl: hsl,
      hex: hex,
      onChange: onChange,
      disableAlpha: disableAlpha
    }),
    _react2.default.createElement(_SketchPresetColors2.default, {
      colors: presetColors,
      onClick: onChange,
      onSwatchHover: onSwatchHover
    })
  );
};

Sketch.propTypes = {
  disableAlpha: _propTypes2.default.bool,
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
};

Sketch.defaultProps = {
  disableAlpha: false,
  width: 200,
  presetColors: ['#D0021B', '#F5A623', '#F8E71C', '#8B572A', '#7ED321', '#417505', '#BD10E0', '#9013FE', '#4A90E2', '#50E3C2', '#B8E986', '#000000', '#4A4A4A', '#9B9B9B', '#FFFFFF']
};

exports.default = (0, _common.ColorWrap)(Sketch);

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SketchFields = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(3);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _color = __webpack_require__(16);

var _color2 = _interopRequireDefault(_color);

var _common = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-param-reassign */

var SketchFields = exports.SketchFields = function SketchFields(_ref) {
  var onChange = _ref.onChange,
      rgb = _ref.rgb,
      hsl = _ref.hsl,
      hex = _ref.hex,
      disableAlpha = _ref.disableAlpha;

  var styles = (0, _reactcss2.default)({
    'default': {
      fields: {
        display: 'flex',
        paddingTop: '4px'
      },
      single: {
        flex: '1',
        paddingLeft: '6px'
      },
      alpha: {
        flex: '1',
        paddingLeft: '6px'
      },
      double: {
        flex: '2'
      },
      input: {
        width: '80%',
        padding: '4px 10% 3px',
        border: 'none',
        boxShadow: 'inset 0 0 0 1px #ccc',
        fontSize: '11px'
      },
      label: {
        display: 'block',
        textAlign: 'center',
        fontSize: '11px',
        color: '#222',
        paddingTop: '3px',
        paddingBottom: '4px',
        textTransform: 'capitalize'
      }
    },
    'disableAlpha': {
      alpha: {
        display: 'none'
      }
    }
  }, { disableAlpha: disableAlpha });

  var handleChange = function handleChange(data, e) {
    if (data.hex) {
      _color2.default.isValidHex(data.hex) && onChange({
        hex: data.hex,
        source: 'hex'
      }, e);
    } else if (data.r || data.g || data.b) {
      onChange({
        r: data.r || rgb.r,
        g: data.g || rgb.g,
        b: data.b || rgb.b,
        a: rgb.a,
        source: 'rgb'
      }, e);
    } else if (data.a) {
      if (data.a < 0) {
        data.a = 0;
      } else if (data.a > 100) {
        data.a = 100;
      }

      data.a /= 100;
      onChange({
        h: hsl.h,
        s: hsl.s,
        l: hsl.l,
        a: data.a,
        source: 'rgb'
      }, e);
    }
  };

  return _react2.default.createElement(
    'div',
    { style: styles.fields, className: 'flexbox-fix' },
    _react2.default.createElement(
      'div',
      { style: styles.double },
      _react2.default.createElement(_common.EditableInput, {
        style: { input: styles.input, label: styles.label },
        label: 'hex',
        value: hex.replace('#', ''),
        onChange: handleChange
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.single },
      _react2.default.createElement(_common.EditableInput, {
        style: { input: styles.input, label: styles.label },
        label: 'r',
        value: rgb.r,
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '255'
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.single },
      _react2.default.createElement(_common.EditableInput, {
        style: { input: styles.input, label: styles.label },
        label: 'g',
        value: rgb.g,
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '255'
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.single },
      _react2.default.createElement(_common.EditableInput, {
        style: { input: styles.input, label: styles.label },
        label: 'b',
        value: rgb.b,
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '255'
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.alpha },
      _react2.default.createElement(_common.EditableInput, {
        style: { input: styles.input, label: styles.label },
        label: 'a',
        value: Math.round(rgb.a * 100),
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '100'
      })
    )
  );
};

exports.default = SketchFields;

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SketchPresetColors = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = __webpack_require__(3);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _common = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SketchPresetColors = exports.SketchPresetColors = function SketchPresetColors(_ref) {
  var colors = _ref.colors,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      onSwatchHover = _ref.onSwatchHover;

  var styles = (0, _reactcss2.default)({
    'default': {
      colors: {
        margin: '0 -10px',
        padding: '10px 0 0 10px',
        borderTop: '1px solid #eee',
        display: 'flex',
        flexWrap: 'wrap',
        position: 'relative'
      },
      swatchWrap: {
        width: '16px',
        height: '16px',
        margin: '0 10px 10px 0'
      },
      swatch: {
        borderRadius: '3px',
        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15)'
      }
    },
    'no-presets': {
      colors: {
        display: 'none'
      }
    }
  }, {
    'no-presets': !colors || !colors.length
  });

  var handleClick = function handleClick(hex, e) {
    onClick({
      hex: hex,
      source: 'hex'
    }, e);
  };

  return _react2.default.createElement(
    'div',
    { style: styles.colors, className: 'flexbox-fix' },
    colors.map(function (colorObjOrString) {
      var c = typeof colorObjOrString === 'string' ? { color: colorObjOrString } : colorObjOrString;
      var key = '' + c.color + (c.title || '');
      return _react2.default.createElement(
        'div',
        { key: key, style: styles.swatchWrap },
        _react2.default.createElement(_common.Swatch, _extends({}, c, {
          style: styles.swatch,
          onClick: handleClick,
          onHover: onSwatchHover,
          focusStyle: {
            boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15), 0 0 4px ' + c.color
          }
        }))
      );
    })
  );
};

SketchPresetColors.propTypes = {
  colors: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    color: _propTypes2.default.string,
    title: _propTypes2.default.string
  })])).isRequired
};

exports.default = SketchPresetColors;

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Slider = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(3);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _common = __webpack_require__(7);

var _SliderSwatches = __webpack_require__(636);

var _SliderSwatches2 = _interopRequireDefault(_SliderSwatches);

var _SliderPointer = __webpack_require__(638);

var _SliderPointer2 = _interopRequireDefault(_SliderPointer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Slider = exports.Slider = function Slider(_ref) {
  var hsl = _ref.hsl,
      onChange = _ref.onChange,
      pointer = _ref.pointer,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)({
    'default': {
      hue: {
        height: '12px',
        position: 'relative'
      },
      Hue: {
        radius: '2px'
      }
    }
  });

  return _react2.default.createElement(
    'div',
    { className: 'slider-picker ' + className },
    _react2.default.createElement(
      'div',
      { style: styles.hue },
      _react2.default.createElement(_common.Hue, {
        style: styles.Hue,
        hsl: hsl,
        pointer: pointer,
        onChange: onChange
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.swatches },
      _react2.default.createElement(_SliderSwatches2.default, { hsl: hsl, onClick: onChange })
    )
  );
};

Slider.defaultProps = {
  pointer: _SliderPointer2.default
};

exports.default = (0, _common.ColorWrap)(Slider);

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SliderSwatches = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(3);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _SliderSwatch = __webpack_require__(637);

var _SliderSwatch2 = _interopRequireDefault(_SliderSwatch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SliderSwatches = exports.SliderSwatches = function SliderSwatches(_ref) {
  var onClick = _ref.onClick,
      hsl = _ref.hsl;

  var styles = (0, _reactcss2.default)({
    'default': {
      swatches: {
        marginTop: '20px'
      },
      swatch: {
        boxSizing: 'border-box',
        width: '20%',
        paddingRight: '1px',
        float: 'left'
      },
      clear: {
        clear: 'both'
      }
    }
  });

  return _react2.default.createElement(
    'div',
    { style: styles.swatches },
    _react2.default.createElement(
      'div',
      { style: styles.swatch },
      _react2.default.createElement(_SliderSwatch2.default, {
        hsl: hsl,
        offset: '.80',
        active: Math.round(hsl.l * 100) / 100 === 0.80 && Math.round(hsl.s * 100) / 100 === 0.50,
        onClick: onClick,
        first: true
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.swatch },
      _react2.default.createElement(_SliderSwatch2.default, {
        hsl: hsl,
        offset: '.65',
        active: Math.round(hsl.l * 100) / 100 === 0.65 && Math.round(hsl.s * 100) / 100 === 0.50,
        onClick: onClick
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.swatch },
      _react2.default.createElement(_SliderSwatch2.default, {
        hsl: hsl,
        offset: '.50',
        active: Math.round(hsl.l * 100) / 100 === 0.50 && Math.round(hsl.s * 100) / 100 === 0.50,
        onClick: onClick
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.swatch },
      _react2.default.createElement(_SliderSwatch2.default, {
        hsl: hsl,
        offset: '.35',
        active: Math.round(hsl.l * 100) / 100 === 0.35 && Math.round(hsl.s * 100) / 100 === 0.50,
        onClick: onClick
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.swatch },
      _react2.default.createElement(_SliderSwatch2.default, {
        hsl: hsl,
        offset: '.20',
        active: Math.round(hsl.l * 100) / 100 === 0.20 && Math.round(hsl.s * 100) / 100 === 0.50,
        onClick: onClick,
        last: true
      })
    ),
    _react2.default.createElement('div', { style: styles.clear })
  );
};

exports.default = SliderSwatches;

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SliderSwatch = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(3);

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SliderSwatch = exports.SliderSwatch = function SliderSwatch(_ref) {
  var hsl = _ref.hsl,
      offset = _ref.offset,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      active = _ref.active,
      first = _ref.first,
      last = _ref.last;

  var styles = (0, _reactcss2.default)({
    'default': {
      swatch: {
        height: '12px',
        background: 'hsl(' + hsl.h + ', 50%, ' + offset * 100 + '%)',
        cursor: 'pointer'
      }
    },
    'first': {
      swatch: {
        borderRadius: '2px 0 0 2px'
      }
    },
    'last': {
      swatch: {
        borderRadius: '0 2px 2px 0'
      }
    },
    'active': {
      swatch: {
        transform: 'scaleY(1.8)',
        borderRadius: '3.6px/2px'
      }
    }
  }, { active: active, first: first, last: last });

  var handleClick = function handleClick(e) {
    return onClick({
      h: hsl.h,
      s: 0.5,
      l: offset,
      source: 'hsl'
    }, e);
  };

  return _react2.default.createElement('div', { style: styles.swatch, onClick: handleClick });
};

exports.default = SliderSwatch;

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SliderPointer = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(3);

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SliderPointer = exports.SliderPointer = function SliderPointer() {
  var styles = (0, _reactcss2.default)({
    'default': {
      picker: {
        width: '14px',
        height: '14px',
        borderRadius: '6px',
        transform: 'translate(-7px, -1px)',
        backgroundColor: 'rgb(248, 248, 248)',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
      }
    }
  });

  return _react2.default.createElement('div', { style: styles.picker });
};

exports.default = SliderPointer;

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Swatches = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = __webpack_require__(3);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _map = __webpack_require__(26);

var _map2 = _interopRequireDefault(_map);

var _color = __webpack_require__(16);

var _color2 = _interopRequireDefault(_color);

var _materialColors = __webpack_require__(193);

var material = _interopRequireWildcard(_materialColors);

var _common = __webpack_require__(7);

var _SwatchesGroup = __webpack_require__(640);

var _SwatchesGroup2 = _interopRequireDefault(_SwatchesGroup);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Swatches = exports.Swatches = function Swatches(_ref) {
  var width = _ref.width,
      height = _ref.height,
      onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      colors = _ref.colors,
      hex = _ref.hex,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)({
    'default': {
      picker: {
        width: width,
        height: height
      },
      overflow: {
        height: height,
        overflowY: 'scroll'
      },
      body: {
        padding: '16px 0 6px 16px'
      },
      clear: {
        clear: 'both'
      }
    }
  });

  var handleChange = function handleChange(data, e) {
    _color2.default.isValidHex(data) && onChange({
      hex: data,
      source: 'hex'
    }, e);
  };

  return _react2.default.createElement(
    'div',
    { style: styles.picker, className: 'swatches-picker ' + className },
    _react2.default.createElement(
      _common.Raised,
      null,
      _react2.default.createElement(
        'div',
        { style: styles.overflow },
        _react2.default.createElement(
          'div',
          { style: styles.body },
          (0, _map2.default)(colors, function (group) {
            return _react2.default.createElement(_SwatchesGroup2.default, {
              key: group.toString(),
              group: group,
              active: hex,
              onClick: handleChange,
              onSwatchHover: onSwatchHover
            });
          }),
          _react2.default.createElement('div', { style: styles.clear })
        )
      )
    )
  );
};

Swatches.propTypes = {
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  colors: _propTypes2.default.arrayOf(_propTypes2.default.arrayOf(_propTypes2.default.string))

  /* eslint-disable max-len */
};Swatches.defaultProps = {
  width: 320,
  height: 240,
  colors: [[material.red['900'], material.red['700'], material.red['500'], material.red['300'], material.red['100']], [material.pink['900'], material.pink['700'], material.pink['500'], material.pink['300'], material.pink['100']], [material.purple['900'], material.purple['700'], material.purple['500'], material.purple['300'], material.purple['100']], [material.deepPurple['900'], material.deepPurple['700'], material.deepPurple['500'], material.deepPurple['300'], material.deepPurple['100']], [material.indigo['900'], material.indigo['700'], material.indigo['500'], material.indigo['300'], material.indigo['100']], [material.blue['900'], material.blue['700'], material.blue['500'], material.blue['300'], material.blue['100']], [material.lightBlue['900'], material.lightBlue['700'], material.lightBlue['500'], material.lightBlue['300'], material.lightBlue['100']], [material.cyan['900'], material.cyan['700'], material.cyan['500'], material.cyan['300'], material.cyan['100']], [material.teal['900'], material.teal['700'], material.teal['500'], material.teal['300'], material.teal['100']], ['#194D33', material.green['700'], material.green['500'], material.green['300'], material.green['100']], [material.lightGreen['900'], material.lightGreen['700'], material.lightGreen['500'], material.lightGreen['300'], material.lightGreen['100']], [material.lime['900'], material.lime['700'], material.lime['500'], material.lime['300'], material.lime['100']], [material.yellow['900'], material.yellow['700'], material.yellow['500'], material.yellow['300'], material.yellow['100']], [material.amber['900'], material.amber['700'], material.amber['500'], material.amber['300'], material.amber['100']], [material.orange['900'], material.orange['700'], material.orange['500'], material.orange['300'], material.orange['100']], [material.deepOrange['900'], material.deepOrange['700'], material.deepOrange['500'], material.deepOrange['300'], material.deepOrange['100']], [material.brown['900'], material.brown['700'], material.brown['500'], material.brown['300'], material.brown['100']], [material.blueGrey['900'], material.blueGrey['700'], material.blueGrey['500'], material.blueGrey['300'], material.blueGrey['100']], ['#000000', '#525252', '#969696', '#D9D9D9', '#FFFFFF']]
};

exports.default = (0, _common.ColorWrap)(Swatches);

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SwatchesGroup = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(3);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _map = __webpack_require__(26);

var _map2 = _interopRequireDefault(_map);

var _SwatchesColor = __webpack_require__(641);

var _SwatchesColor2 = _interopRequireDefault(_SwatchesColor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SwatchesGroup = exports.SwatchesGroup = function SwatchesGroup(_ref) {
  var onClick = _ref.onClick,
      onSwatchHover = _ref.onSwatchHover,
      group = _ref.group,
      active = _ref.active;

  var styles = (0, _reactcss2.default)({
    'default': {
      group: {
        paddingBottom: '10px',
        width: '40px',
        float: 'left',
        marginRight: '10px'
      }
    }
  });

  return _react2.default.createElement(
    'div',
    { style: styles.group },
    (0, _map2.default)(group, function (color, i) {
      return _react2.default.createElement(_SwatchesColor2.default, {
        key: color,
        color: color,
        active: color.toLowerCase() === active,
        first: i === 0,
        last: i === group.length - 1,
        onClick: onClick,
        onSwatchHover: onSwatchHover
      });
    })
  );
};

exports.default = SwatchesGroup;

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SwatchesColor = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(3);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _color = __webpack_require__(16);

var _color2 = _interopRequireDefault(_color);

var _common = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SwatchesColor = exports.SwatchesColor = function SwatchesColor(_ref) {
  var color = _ref.color,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      onSwatchHover = _ref.onSwatchHover,
      first = _ref.first,
      last = _ref.last,
      active = _ref.active;

  var styles = (0, _reactcss2.default)({
    'default': {
      color: {
        width: '40px',
        height: '24px',
        cursor: 'pointer',
        background: color,
        marginBottom: '1px'
      },
      check: {
        fill: _color2.default.getContrastingColor(color),
        marginLeft: '8px',
        display: 'none'
      }
    },
    'first': {
      color: {
        overflow: 'hidden',
        borderRadius: '2px 2px 0 0'
      }
    },
    'last': {
      color: {
        overflow: 'hidden',
        borderRadius: '0 0 2px 2px'
      }
    },
    'active': {
      check: {
        display: 'block'
      }
    },
    'color-#FFFFFF': {
      color: {
        boxShadow: 'inset 0 0 0 1px #ddd'
      },
      check: {
        fill: '#333'
      }
    },
    'transparent': {
      check: {
        fill: '#333'
      }
    }
  }, {
    first: first,
    last: last,
    active: active,
    'color-#FFFFFF': color === '#FFFFFF',
    'transparent': color === 'transparent'
  });

  return _react2.default.createElement(
    _common.Swatch,
    {
      color: color,
      style: styles.color,
      onClick: onClick,
      onHover: onSwatchHover,
      focusStyle: { boxShadow: '0 0 4px ' + color }
    },
    _react2.default.createElement(
      'div',
      { style: styles.check },
      _react2.default.createElement(
        'svg',
        { style: { width: '24px', height: '24px' }, viewBox: '0 0 24 24' },
        _react2.default.createElement('path', { d: 'M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z' })
      )
    )
  );
};

exports.default = SwatchesColor;

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Twitter = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = __webpack_require__(3);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _map = __webpack_require__(26);

var _map2 = _interopRequireDefault(_map);

var _color = __webpack_require__(16);

var _color2 = _interopRequireDefault(_color);

var _common = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Twitter = exports.Twitter = function Twitter(_ref) {
  var onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      hex = _ref.hex,
      colors = _ref.colors,
      width = _ref.width,
      triangle = _ref.triangle,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)({
    'default': {
      card: {
        width: width,
        background: '#fff',
        border: '0 solid rgba(0,0,0,0.25)',
        boxShadow: '0 1px 4px rgba(0,0,0,0.25)',
        borderRadius: '4px',
        position: 'relative'
      },
      body: {
        padding: '15px 9px 9px 15px'
      },
      label: {
        fontSize: '18px',
        color: '#fff'
      },
      triangle: {
        width: '0px',
        height: '0px',
        borderStyle: 'solid',
        borderWidth: '0 9px 10px 9px',
        borderColor: 'transparent transparent #fff transparent',
        position: 'absolute'
      },
      triangleShadow: {
        width: '0px',
        height: '0px',
        borderStyle: 'solid',
        borderWidth: '0 9px 10px 9px',
        borderColor: 'transparent transparent rgba(0,0,0,.1) transparent',
        position: 'absolute'
      },
      hash: {
        background: '#F0F0F0',
        height: '30px',
        width: '30px',
        borderRadius: '4px 0 0 4px',
        float: 'left',
        color: '#98A1A4',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      },
      input: {
        width: '100px',
        fontSize: '14px',
        color: '#666',
        border: '0px',
        outline: 'none',
        height: '28px',
        boxShadow: 'inset 0 0 0 1px #F0F0F0',
        boxSizing: 'content-box',
        borderRadius: '0 4px 4px 0',
        float: 'left',
        paddingLeft: '8px'
      },
      swatch: {
        width: '30px',
        height: '30px',
        float: 'left',
        borderRadius: '4px',
        margin: '0 6px 6px 0'
      },
      clear: {
        clear: 'both'
      }
    },
    'hide-triangle': {
      triangle: {
        display: 'none'
      },
      triangleShadow: {
        display: 'none'
      }
    },
    'top-left-triangle': {
      triangle: {
        top: '-10px',
        left: '12px'
      },
      triangleShadow: {
        top: '-11px',
        left: '12px'
      }
    },
    'top-right-triangle': {
      triangle: {
        top: '-10px',
        right: '12px'
      },
      triangleShadow: {
        top: '-11px',
        right: '12px'
      }
    }
  }, {
    'hide-triangle': triangle === 'hide',
    'top-left-triangle': triangle === 'top-left',
    'top-right-triangle': triangle === 'top-right'
  });

  var handleChange = function handleChange(hexcode, e) {
    _color2.default.isValidHex(hexcode) && onChange({
      hex: hexcode,
      source: 'hex'
    }, e);
  };

  return _react2.default.createElement(
    'div',
    { style: styles.card, className: 'twitter-picker ' + className },
    _react2.default.createElement('div', { style: styles.triangleShadow }),
    _react2.default.createElement('div', { style: styles.triangle }),
    _react2.default.createElement(
      'div',
      { style: styles.body },
      (0, _map2.default)(colors, function (c, i) {
        return _react2.default.createElement(_common.Swatch, {
          key: i,
          color: c,
          hex: c,
          style: styles.swatch,
          onClick: handleChange,
          onHover: onSwatchHover,
          focusStyle: {
            boxShadow: '0 0 4px ' + c
          }
        });
      }),
      _react2.default.createElement(
        'div',
        { style: styles.hash },
        '#'
      ),
      _react2.default.createElement(_common.EditableInput, {
        style: { input: styles.input },
        value: hex.replace('#', ''),
        onChange: handleChange
      }),
      _react2.default.createElement('div', { style: styles.clear })
    )
  );
};

Twitter.propTypes = {
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  triangle: _propTypes2.default.oneOf(['hide', 'top-left', 'top-right']),
  colors: _propTypes2.default.arrayOf(_propTypes2.default.string)
};

Twitter.defaultProps = {
  width: 276,
  colors: ['#FF6900', '#FCB900', '#7BDCB5', '#00D084', '#8ED1FC', '#0693E3', '#ABB8C3', '#EB144C', '#F78DA7', '#9900EF'],
  triangle: 'top-left'
};

exports.default = (0, _common.ColorWrap)(Twitter);

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var STATES = ['ENDED', 'PLAYING', 'PAUSED', 'BUFFERING'];

var OPTIONS_ANALYSER = {
  smoothingTime: 0.6,
  fftSize: 512
};

var OPTIONS_DEFAULT = {
  autoplay: false,
  shadowBlur: 20,
  shadowColor: '#ffffff',
  barColor: '#16ffff',
  barWidth: 4,
  barHeight: 4,
  barSpacing: 14,
  font: ['12px', 'Roboto']
};

var Visualizer = function () {
  function Visualizer() {
    _classCallCheck(this, Visualizer);
  }

  _createClass(Visualizer, [{
    key: 'getInitialState',
    value: function getInitialState() {
      return {
        playing: false,
        requestAnimationFrame: null,
        animFrameId: null,
        ctx: null,
        analyser: null,
        frequencyData: 0,
        sourceNode: null,
        gradient: null,
        canvasCtx: null,
        interval: null,
        duration: null,
        minutes: '00',
        seconds: '00',
        options: OPTIONS_DEFAULT,
        extensions: {},
        model: null
      };
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this = this;

      this._setContext().then(function () {
        _this._setAnalyser();
      }).then(function () {
        _this._setFrequencyData();
      }).then(function () {
        _this._setRequestAnimationFrame();
      }).catch(function (error) {
        _this._onDisplayError(error);
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this._extend().then(function () {
        _this2._setBufferSourceNode();
      }).then(function () {
        _this2._setCanvasContext();
      }).then(function () {
        _this2._setCanvasStyles();
      }).then(function () {
        _this2._onResetTimer().then(function () {
          _this2._onRender({
            renderText: _this2.state.extensions.renderText,
            renderTime: _this2.state.extensions.renderTime
          });
          _this2.state.options.autoplay && _this2._onResolvePlayState();
        });
      }).catch(function (error) {
        _this2._onDisplayError(error);
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      if (this.state.model !== nextProps.model) {
        this._onAudioStop().then(function () {
          _this3.setState({ model: nextProps.model }, function () {
            _this3.componentDidMount();
          });
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var ctx = this.state.ctx;


      ctx.close();
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return false;
    }

    /**
     * @description
     * Display visualizer error.
     *
     * @param {Object} error
     * @return {Function}
     * @private
     */

  }, {
    key: '_onDisplayError',
    value: function _onDisplayError(error) {
      return window.console.table(error);
    }

    /**
     * @description
     * Extend constructor options.
     *
     * @return {Object}
     * @private
     */

  }, {
    key: '_extend',
    value: function _extend() {
      var _this4 = this;

      var options = Object.assign(OPTIONS_DEFAULT, this.props.options);
      var extensions = Object.assign({}, this.props.extensions || {
        renderStyle: this._onRenderStyleDefault,
        renderText: this._onRenderTextDefault,
        renderTime: this._onRenderTimeDefault
      });

      return new Promise(function (resolve, reject) {
        _this4.setState({
          options: options,
          model: _this4.props.model,
          extensions: extensions
        }, function () {
          return resolve();
        });
      });
    }

    /**
    * @description
    * Set canvas context.
    *
    * @return {Object}
    * @private
    */

  }, {
    key: '_setCanvasContext',
    value: function _setCanvasContext() {
      var _this5 = this;

      var canvasCtx = this.refs.canvas.getContext('2d');

      return new Promise(function (resolve, reject) {
        _this5.setState({ canvasCtx: canvasCtx }, function () {
          return resolve();
        });
      });
    }

    /**
    * @description
    * Set audio context.
    *
    * @return {Object}
    * @private
    */

  }, {
    key: '_setContext',
    value: function _setContext() {
      var _this6 = this;

      var error = { message: 'Web Audio API is not supported.' };

      return new Promise(function (resolve, reject) {
        try {
          window.AudioContext = window.AudioContext || window.webkitAudioContext;
          _this6.setState({ ctx: new window.AudioContext() }, function () {
            return resolve();
          });
        } catch (e) {
          return reject(error);
        }
      });
    }

    /**
    * @description
    * Set audio buffer analyser.
    *
    * @return {Object}
    * @private
    */

  }, {
    key: '_setAnalyser',
    value: function _setAnalyser() {
      var _this7 = this;

      var ctx = this.state.ctx;


      return new Promise(function (resolve, reject) {
        var analyser = ctx.createAnalyser();

        analyser.smoothingTimeConstant = OPTIONS_ANALYSER.smoothingTime;
        analyser.fftSize = OPTIONS_ANALYSER.fftSize;

        _this7.setState({ analyser: analyser }, function () {
          return resolve();
        });
      });
    }

    /**
    * @description
    * Set frequency data.
    *
    * @return {Object}
    * @private
    */

  }, {
    key: '_setFrequencyData',
    value: function _setFrequencyData() {
      var _this8 = this;

      var analyser = this.state.analyser;


      return new Promise(function (resolve, reject) {
        var frequencyData = new Uint8Array(analyser.frequencyBinCount);

        _this8.setState({ frequencyData: frequencyData }, function () {
          return resolve();
        });
      });
    }

    /**
    * @description
    * Set source buffer and connect processor and analyser.
    *
    * @return {Object}
    * @private
    */

  }, {
    key: '_setBufferSourceNode',
    value: function _setBufferSourceNode() {
      var _this9 = this;

      var _state = this.state,
          ctx = _state.ctx,
          analyser = _state.analyser;


      return new Promise(function (resolve, reject) {
        var sourceNode = ctx.createBufferSource();

        sourceNode.connect(analyser);
        sourceNode.connect(ctx.destination);
        sourceNode.onended = function () {
          _this9._onAudioStop();
          _this9._onAudioPlay();
        };

        _this9.setState({ sourceNode: sourceNode }, function () {
          return resolve();
        });
      });
    }

    /**
    * @description
    * Set request animation frame fn.
    *
    * @return {Object}
    * @private
    */

  }, {
    key: '_setRequestAnimationFrame',
    value: function _setRequestAnimationFrame() {
      var _this10 = this;

      return new Promise(function (resolve, reject) {
        var requestAnimationFrame = function () {
          return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function (callback) {
            window.setTimeout(callback, 1000 / 60);
          };
        }();

        _this10.setState({ requestAnimationFrame: requestAnimationFrame }, function () {
          return resolve();
        });
      });
    }

    /**
    * @description
    * Set canvas gradient color.
    *
    * @return {Object}
    * @private
    */

  }, {
    key: '_setCanvasStyles',
    value: function _setCanvasStyles() {
      var _this11 = this;

      var canvasCtx = this.state.canvasCtx;
      var _state$options = this.state.options,
          barColor = _state$options.barColor,
          shadowBlur = _state$options.shadowBlur,
          shadowColor = _state$options.shadowColor,
          font = _state$options.font;


      var gradient = canvasCtx.createLinearGradient(0, 0, 0, 300);
      gradient.addColorStop(1, barColor);

      var ctx = Object.assign(canvasCtx, {
        fillStyle: gradient,
        shadowBlur: shadowBlur,
        shadowColor: shadowColor,
        font: font.join(' '),
        textAlign: 'center'
      });

      return new Promise(function (resolve, reject) {
        _this11.setState({
          gradient: gradient,
          canvasCtx: ctx
        }, function () {
          return resolve();
        });
      });
    }

    /**
    * @description
    * On playstate change.
    *
    * @param {String} state
    * @return {Function<Object>}
    * @private
    */

  }, {
    key: '_onChange',
    value: function _onChange(state) {
      var onChange = this.props.onChange;


      return onChange && onChange.call(this, { status: state });
    }

    /**
    * @description
    * Resolve play state.
    *
    * @return {Function}
    * @private
    */

  }, {
    key: '_onResolvePlayState',
    value: function _onResolvePlayState() {
      var ctx = this.state.ctx;


      if (!this.state.playing) {
        return ctx.state === 'suspended' ? this._onAudioPlay() : this._onAudioLoad();
      } else {
        return this._onAudioPause();
      }
    }

    /**
    * @description
    * Load audio file fn.
    *
    * @return {Object}
    * @private
    */

  }, {
    key: '_onAudioLoad',
    value: function _onAudioLoad() {
      var _this12 = this;

      var _state2 = this.state,
          ctx = _state2.ctx,
          canvasCtx = _state2.canvasCtx,
          model = _state2.model;
      var canvas = this.refs.canvas;


      canvasCtx.fillText('Loading...', canvas.width / 2 + 10, canvas.height / 2 - 25);
      this._onChange(STATES[3]);

      this._httpGet().then(function (response) {
        ctx.decodeAudioData(response, function (buffer) {
          model === _this12.state.model && _this12._onAudioPlay(buffer);
        }, function (error) {
          _this12._onDisplayError(error);
        });
      });

      return this;
    }

    /**
    * @description
    * Http GET method.
    *
    * @return {Object}
    * @private
    */

  }, {
    key: '_httpGet',
    value: function _httpGet() {
      var model = this.state.model;


      return new Promise(function (resolve, reject) {
        var req = new XMLHttpRequest();
        req.open('GET', model.path, true);
        req.responseType = 'arraybuffer';

        req.onload = function () {
          return resolve(req.response);
        };

        req.send();
      });
    }

    /**
    * @description
    * Audio pause fn.
    *
    * @return {Object}
    * @private
    */

  }, {
    key: '_onAudioPause',
    value: function _onAudioPause() {
      var _this13 = this;

      var ctx = this.state.ctx;


      this.setState({ playing: false }, function () {
        ctx.suspend().then(function () {
          _this13._onChange(STATES[2]);
        });
      });

      return this;
    }

    /**
    * @description
    * Audio stop fn.
    *
    * @return {Object}
    * @private
    */

  }, {
    key: '_onAudioStop',
    value: function _onAudioStop() {
      var _this14 = this;

      var _state3 = this.state,
          canvasCtx = _state3.canvasCtx,
          ctx = _state3.ctx;
      var canvas = this.refs.canvas;


      return new Promise(function (resolve, reject) {
        window.cancelAnimationFrame(_this14.state.animFrameId);
        clearInterval(_this14.state.interval);
        _this14.state.sourceNode.disconnect();
        canvasCtx.clearRect(0, 0, canvas.width, canvas.height);
        _this14._onChange(STATES[0]);

        _this14._onResetTimer().then(function () {
          ctx.resume();
        }).then(function () {
          _this14._setBufferSourceNode();
        }).then(function () {
          _this14.setState({
            playing: false,
            animFrameId: null
          }, function () {
            return resolve();
          });
        });
      });
    }

    /**
    * @description
    * Audio play fn.
    *
    * @return {Object}
    * @private
    */

  }, {
    key: '_onAudioPlay',
    value: function _onAudioPlay(buffer) {
      var _this15 = this;

      var _state4 = this.state,
          ctx = _state4.ctx,
          sourceNode = _state4.sourceNode;


      this.setState({ playing: true }, function () {
        _this15._onChange(STATES[1]);

        if (ctx.state === 'suspended') {
          ctx.resume();
          return _this15._onRenderFrame();
        }

        sourceNode.buffer = buffer;
        sourceNode.start(0);
        _this15._onResetTimer().then(function () {
          _this15._onStartTimer()._onRenderFrame();
        });
      });

      return this;
    }

    /**
    * @description
    * Reset audio timer fn.
    *
    * @return {Object}
    * @private
    */

  }, {
    key: '_onResetTimer',
    value: function _onResetTimer() {
      var _this16 = this;

      return new Promise(function (resolve, reject) {
        _this16.setState({
          duration: new Date(0, 0).getTime(),
          minutes: '00',
          seconds: '00'
        }, function () {
          return resolve();
        });
      });
    }

    /**
    * @description
    * Start audio timer fn.
    *
    * @return {Object}
    * @private
    */

  }, {
    key: '_onStartTimer',
    value: function _onStartTimer() {
      var _this17 = this;

      var interval = setInterval(function () {
        if (_this17.state.playing) {
          var now = new Date(_this17.state.duration);
          var min = now.getHours();
          var sec = now.getMinutes() + 1;

          _this17.setState({
            minutes: min < 10 ? '0' + min : min,
            seconds: sec < 10 ? '0' + sec : sec,
            duration: now.setMinutes(sec)
          });
        }
      }, 1000);

      this.setState({ interval: interval });
      return this;
    }

    /**
    * @description
    * Render canvas frame.
    *
    * @return {Object}
    * @private
    */

  }, {
    key: '_onRenderFrame',
    value: function _onRenderFrame() {
      var _this18 = this;

      var _state5 = this.state,
          analyser = _state5.analyser,
          frequencyData = _state5.frequencyData,
          requestAnimationFrame = _state5.requestAnimationFrame,
          animFrameId = _state5.animFrameId;


      if (this.state.playing) {
        var _animFrameId = requestAnimationFrame(this._onRenderFrame);

        this.setState({ animFrameId: _animFrameId }, function () {
          analyser.getByteFrequencyData(frequencyData);
          _this18._onRender(_this18.state.extensions);
        });
      }

      return this;
    }

    /**
    * @description
    * On render frame fn.
    * Invoke each of the render extensions.
    *
    * @param {Object} extensions
    * @return {Function}
    * @private
    */

  }, {
    key: '_onRender',
    value: function _onRender(extensions) {
      var _this19 = this;

      var canvasCtx = this.state.canvasCtx;
      var canvas = this.refs.canvas;


      canvasCtx.clearRect(0, 0, canvas.width, canvas.height);
      Object.keys(extensions).forEach(function (extension) {
        return extensions[extension] && extensions[extension].call(_this19, _this19);
      });
    }

    /**
    * @description
    * Render audio time fn.
    * Default time rendering fn.
    *
    * @return {Object}
    * @private
    */

  }, {
    key: '_onRenderTimeDefault',
    value: function _onRenderTimeDefault() {
      var canvasCtx = this.state.canvasCtx;
      var canvas = this.refs.canvas;


      var time = this.state.minutes + ':' + this.state.seconds;
      canvasCtx.fillText(time, canvas.width / 2 + 10, canvas.height / 2 + 40);
      return this;
    }

    /**
    * @description
    * Render audio author and title fn.
    * Default text rendering fn.
    *
    * @return {Object}
    * @private
    */

  }, {
    key: '_onRenderTextDefault',
    value: function _onRenderTextDefault() {
      var canvasCtx = this.state.canvasCtx;
      var canvas = this.refs.canvas;
      var model = this.state.model;
      var font = this.state.options.font;


      var cx = canvas.width / 2;
      var cy = canvas.height / 2;
      var fontAdjustment = 6;
      var alignAdjustment = 8;

      canvasCtx.textBaseline = 'top';
      canvasCtx.fillText('by ' + model.author, cx + alignAdjustment, cy);
      canvasCtx.font = parseInt(font[0], 10) + fontAdjustment + 'px ' + font[1];
      canvasCtx.textBaseline = 'bottom';
      canvasCtx.fillText(model.title, cx + alignAdjustment, cy);
      canvasCtx.font = font.join(' ');

      return this;
    }

    /**
    * @description
    * Render lounge style type.
    * Default rendering style.
    *
    * @return {Object}
    * @private
    */

  }, {
    key: '_onRenderStyleDefault',
    value: function _onRenderStyleDefault() {
      var _state6 = this.state,
          frequencyData = _state6.frequencyData,
          canvasCtx = _state6.canvasCtx;
      var canvas = this.refs.canvas;
      var _state$options2 = this.state.options,
          barWidth = _state$options2.barWidth,
          barHeight = _state$options2.barHeight,
          barSpacing = _state$options2.barSpacing;


      var radiusReduction = 70;
      var amplitudeReduction = 6;

      var cx = canvas.width / 2;
      var cy = canvas.height / 2;
      var radius = Math.min(cx, cy) - radiusReduction;
      var maxBarNum = Math.floor(radius * 2 * Math.PI / (barWidth + barSpacing));
      var slicedPercent = Math.floor(maxBarNum * 25 / 100);
      var barNum = maxBarNum - slicedPercent;
      var freqJump = Math.floor(frequencyData.length / maxBarNum);

      for (var i = 0; i < barNum; i++) {
        var amplitude = frequencyData[i * freqJump];
        var theta = i * 2 * Math.PI / maxBarNum;
        var delta = (3 * 45 - barWidth) * Math.PI / 180;
        var x = 0;
        var y = radius - (amplitude / 12 - barHeight);
        var w = barWidth;
        var h = amplitude / amplitudeReduction + barHeight;

        canvasCtx.save();
        canvasCtx.translate(cx + barSpacing, cy + barSpacing);
        canvasCtx.rotate(theta - delta);
        canvasCtx.fillRect(x, y, w, h);
        canvasCtx.restore();
      }

      return this;
    }

    /**
    * @return {Object}
    * @public
    */

  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          model = _props.model,
          width = _props.width,
          height = _props.height;

      var classes = ['visualizer', this.props.className].join(' ');

      return _react2.default.createElement(
        'div',
        { className: classes, onClick: this._onResolvePlayState },
        _react2.default.createElement('audio', { className: 'visualizer__audio', src: model.path }),
        _react2.default.createElement(
          'div',
          { className: 'visualizer__canvas-wrapper' },
          _react2.default.createElement('canvas', {
            ref: 'canvas',
            className: 'visualizer__canvas',
            width: width,
            height: height })
        )
      );
    }
  }]);

  return Visualizer;
}();

Visualizer.PropTypes = {
  model: _react.PropTypes.object.isRequired,
  options: _react.PropTypes.object,
  className: _react.PropTypes.string,
  extensions: _react.PropTypes.object,
  onChange: _react.PropTypes.func,
  width: _react.PropTypes.string,
  height: _react.PropTypes.string
};

exports.default = Visualizer;

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(18);

var _Navigation = __webpack_require__(42);

var _Navigation2 = _interopRequireDefault(_Navigation);

var _reactLiveClock = __webpack_require__(645);

var _reactLiveClock2 = _interopRequireDefault(_reactLiveClock);

var _reactNumberPicker = __webpack_require__(651);

var _reactNumberPicker2 = _interopRequireDefault(_reactNumberPicker);

__webpack_require__(652);

__webpack_require__(653);

var _localStorage = __webpack_require__(654);

var _localStorage2 = _interopRequireDefault(_localStorage);

var _mespeak = __webpack_require__(657);

var _mespeak2 = _interopRequireDefault(_mespeak);

var _good_job_ = __webpack_require__(663);

var _good_job_2 = _interopRequireDefault(_good_job_);

var _good_job_3 = __webpack_require__(664);

var _good_job_4 = _interopRequireDefault(_good_job_3);

var _cheer = __webpack_require__(665);

var _cheer2 = _interopRequireDefault(_cheer);

var _cable = __webpack_require__(666);

var _cable2 = _interopRequireDefault(_cable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_mespeak2.default.loadVoice(__webpack_require__(667));
_mespeak2.default.loadConfig(__webpack_require__(668));

function speak(text, options) {
  if (!_mespeak2.default.isConfigLoaded()) {
    console.error("meSpeak not configured");
    return;
  }
  if (!_mespeak2.default.isVoiceLoaded("en/en-us")) {
    console.error("meSpeak voice not loaded");
    return;
  }
  _mespeak2.default.speak(text, undefined, options && options.onend ? options.onend : undefined);
}

var _ref = _react2.default.createElement(
  "span",
  null,
  "stretches"
);

var _ref2 = _react2.default.createElement(
  "span",
  null,
  "reps"
);

var _ref3 = _react2.default.createElement(
  "span",
  null,
  "interval"
);

var _ref4 = _react2.default.createElement("span", { className: "total-time-title" });

var _ref5 = _react2.default.createElement(
  "span",
  { className: "total-time-title" },
  "minutes remaining"
);

var _ref6 = _react2.default.createElement(
  "span",
  { className: "total-time-title" },
  "session length"
);

var _ref7 = _react2.default.createElement(
  "span",
  { className: "total-time-title" },
  "minutes"
);

var _ref8 = _react2.default.createElement("audio", { id: "good_job_01", src: _good_job_2.default });

var _ref9 = _react2.default.createElement("audio", { id: "good_job_02", src: _good_job_4.default });

var _ref10 = _react2.default.createElement("audio", { id: "cheer", src: _cheer2.default });

var _ref11 = _react2.default.createElement("audio", { id: "cable", src: _cable2.default });

var _ref12 = _react2.default.createElement("div", null);

var _ref13 = _react2.default.createElement(_Navigation2.default, null);

var _ref14 = _react2.default.createElement(
  "div",
  { className: "live-clock" },
  _react2.default.createElement(_reactLiveClock2.default, { format: "hh:mm:ss A", ticking: true })
);

var _ref15 = _react2.default.createElement("i", { className: "fa fa-arrow-left" });

var Stretch = function (_React$Component) {
  _inherits(Stretch, _React$Component);

  function Stretch(props) {
    _classCallCheck(this, Stretch);

    var _this = _possibleConstructorReturn(this, (Stretch.__proto__ || Object.getPrototypeOf(Stretch)).call(this, props));

    _this.INBETWEENREPSTIME = 7;
    _this.INBETWEENSTRETCHESTIME = 15;
    _this.INCREMENTTIME = 1000;
    _this.lastIncrementTime = 0;
    _this.state = {
      numStretches: 3, // 3
      numReps: 5, // 5
      repInterval: 30, // 30
      currStretch: 1,
      currRep: 1,
      currTime: 0,
      currLeg: "R",
      started: false,
      paused: false,
      pauseTime: _this.INBETWEENSTRETCHESTIME
    };

    _this.encouragements = ["nice work!", "keep going!", "great form!", "you're doing great!", "hashtag best stretcher", "hashtag stretcher of the year", "don't forget to smile", "you look great", "you can do it", "never give up", "stay focused", "stretch it out", "fx dark christmas is my favorite movie", "play Dizzy Gillespie", "you don't need two monitors"];

    _this.audioIds = [["good_job_01", 0.75], ["good_job_02", 0.8], ["cheer", 0.5], ["cable", 0.75]];
    return _this;
  }

  _createClass(Stretch, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.reset();
      this.state = {
        numStretches: parseInt(_localStorage2.default.get("numStretches")) || 3, // 3
        numReps: parseInt(_localStorage2.default.get("numReps")) || 5, // 5
        repInterval: parseInt(_localStorage2.default.get("repInterval")) || 30 // 30
      };
    }
  }, {
    key: "reset",
    value: function reset() {
      this.setState({
        currStretch: 1,
        currRep: 1,
        currTime: 0,
        currLeg: "R",
        started: false,
        paused: false,
        pauseTime: this.INBETWEENSTRETCHESTIME
      });
    }
  }, {
    key: "increment",
    value: function increment() {
      var now = performance.now();
      if (now - this.lastIncrementTime > this.INCREMENTTIME) {
        this.lastIncrementTime = now;
        if (!this.state.started) {
          speak("session stopped");
          this.reset();
          return;
        } else if (!this.state.paused) {
          var nextTime = this.state.currTime + 1;
          var nextStretch = this.state.currStretch;
          var nextRep = this.state.currRep;
          var nextLeg = this.state.currLeg;
          var nextPauseTime = this.state.pauseTime;
          var speech = "";
          if (nextTime == 0) {
            speech = "begin stretching";
            if (nextRep == this.state.numReps && nextLeg == "L") {
              speech += "; this is the last one";
            }
          }
          if (nextTime >= this.state.repInterval) {
            nextTime = -this.INBETWEENREPSTIME;
            nextPauseTime = this.INBETWEENREPSTIME;
            nextLeg = nextLeg === "L" ? "R" : "L";
            if (nextLeg === "R") {
              speech = "stop; rep number " + this.state.currRep + " completed";
              nextRep++;
            } else {
              speech = "stop; switch sides";
            }
            if (nextLeg === "R" && nextRep > this.state.numReps) {
              nextRep = 1;
              nextStretch++;
              if (nextStretch > this.state.numStretches) {
                speak("session completed");
                this.reset();
                return;
              } else {
                nextTime = -this.INBETWEENSTRETCHESTIME;
                nextPauseTime = this.INBETWEENSTRETCHESTIME;
                speech = "stop; stretch number" + this.state.currStretch.toString() + "completed; beginning stretch " + nextStretch.toString() + " in " + this.INBETWEENSTRETCHESTIME.toString() + " seconds";
              }
            }
          }
          if (speech !== "") {
            if (Math.random() < 0.05) {
              if (Math.random() > 0.6) {
                speech += "; " + this.encouragements[Math.floor(Math.random() * this.encouragements.length)];
              } else {
                var chosen = this.audioIds[Math.floor(Math.random() * this.audioIds.length)];
                var audioElement = document.getElementById(chosen[0]);
                if (audioElement) {
                  audioElement.volume = chosen[1];
                  audioElement.play();
                }
              }
            }
            speak(speech);
          }
          this.setState({
            currStretch: nextStretch,
            currRep: nextRep,
            currTime: nextTime,
            currLeg: nextLeg,
            pauseTime: nextPauseTime
          });
        }
      }
      requestAnimationFrame(this.increment.bind(this));
    }
  }, {
    key: "clicked1",
    value: function clicked1() {
      if (!this.state.started) {
        var self = this;
        self.setState({
          started: true,
          paused: false
        });
        speak("starting session in " + this.INBETWEENSTRETCHESTIME + " seconds", {
          onend: function onend() {
            self.setState({
              currTime: -self.INBETWEENSTRETCHESTIME
            }, self.increment.bind(self));
          }
        });
      } else {
        this.setState({
          started: false
        });
      }
    }
  }, {
    key: "clicked2",
    value: function clicked2() {
      if (!this.state.started) {
        this.reset();
      } else {
        if (this.state.paused) {
          speak("session resumed");
          this.setState({
            paused: false
          });
        } else {
          speak("session paused");
          this.setState({
            paused: true
          });
        }
      }
    }
  }, {
    key: "updatenumStretches",
    value: function updatenumStretches(new_value) {
      _localStorage2.default.set("numStretches", new_value);
      this.setState({ numStretches: new_value });
    }
  }, {
    key: "updatenumReps",
    value: function updatenumReps(new_value) {
      _localStorage2.default.set("numReps", new_value);
      this.setState({ numReps: new_value });
    }
  }, {
    key: "updaterepInterval",
    value: function updaterepInterval(new_value) {
      _localStorage2.default.set("repInterval", new_value);
      this.setState({ repInterval: new_value });
    }
  }, {
    key: "render",
    value: function render() {
      var button2 = this.state.started ? _react2.default.createElement(
        "a",
        { className: "btn", onClick: this.clicked2.bind(this) },
        !this.state.started ? "reset" : this.state.paused ? "resume" : "pause"
      ) : null;

      var progress_bar_wrapper = this.state.started ? _react2.default.createElement(
        "div",
        { className: "progressbar-wrapper" },
        _react2.default.createElement(
          "div",
          {
            style: {
              width: 100 * (this.state.currTime > 0 ? this.state.currTime : -this.state.currTime) / (this.state.currTime < 0 ? this.state.pauseTime : this.state.repInterval) + "%"
            }
          },
          _react2.default.createElement(
            "span",
            { className: "progressbar-time" },
            this.state.currTime > 0 && this.state.currTime >= this.state.repInterval * 0.5 ? this.state.repInterval - this.state.currTime : ""
          )
        )
      ) : null;

      var status_wrapper = this.state.started ? _react2.default.createElement(
        "div",
        { className: "status-wrapper" },
        _react2.default.createElement(
          "p",
          null,
          "set ",
          _react2.default.createElement(
            "span",
            { className: "curr-stretch" },
            this.state.currStretch
          )
        ),
        _react2.default.createElement(
          "p",
          null,
          "rep ",
          _react2.default.createElement(
            "span",
            { className: "curr-rep" },
            this.state.currRep
          )
        ),
        _react2.default.createElement(
          "p",
          null,
          "side ",
          _react2.default.createElement(
            "span",
            { className: "curr-leg" },
            this.state.currLeg
          )
        ),
        _react2.default.createElement(
          "p",
          null,
          "time",
          " ",
          _react2.default.createElement(
            "span",
            { className: "curr-time" },
            Math.abs(this.state.currTime)
          )
        )
      ) : null;

      var num_selectors = !this.state.started ? _react2.default.createElement(
        "div",
        { className: "control-num-selectors-wrapper" },
        _react2.default.createElement(
          "div",
          { className: "num-selector-wrapper" },
          _ref,
          _react2.default.createElement(_reactNumberPicker2.default, {
            value: this.state.numStretches,
            onChange: this.updatenumStretches.bind(this),
            digits: 2
          })
        ),
        _react2.default.createElement(
          "div",
          { className: "num-selector-wrapper" },
          _ref2,
          _react2.default.createElement(_reactNumberPicker2.default, {
            value: this.state.numReps,
            onChange: this.updatenumReps.bind(this),
            digits: 2
          })
        ),
        _react2.default.createElement(
          "div",
          { className: "num-selector-wrapper" },
          _ref3,
          _react2.default.createElement(_reactNumberPicker2.default, {
            value: this.state.repInterval,
            onChange: this.updaterepInterval.bind(this),
            digits: 2
          })
        )
      ) : null;

      var calculate_seconds = function calculate_seconds(stretches, reps) {
        return stretches * this.INBETWEENSTRETCHESTIME + stretches * (reps * 2 - 1) * this.INBETWEENREPSTIME + stretches * reps * 2 * this.state.repInterval;
      };
      var total_seconds = calculate_seconds.bind(this)(this.state.numStretches, this.state.numReps);
      var total_minutes = Math.round(total_seconds / 60);
      var remaining_seconds = total_seconds - calculate_seconds.bind(this)(this.state.currStretch, this.state.numReps) + (this.state.numReps - this.state.currRep) * 2 * this.state.repInterval;
      var remaining_minutes = Math.round(remaining_seconds / 60);
      var total_time = this.state.started ? _react2.default.createElement(
        "div",
        { className: "total-time-wrapper" },
        _react2.default.createElement(
          "p",
          null,
          _ref4,
          _react2.default.createElement(
            "span",
            { className: "total-time-number" },
            " ",
            remaining_minutes,
            " "
          ),
          _ref5
        )
      ) : _react2.default.createElement(
        "div",
        { className: "total-time-wrapper" },
        _react2.default.createElement(
          "p",
          null,
          _ref6,
          _react2.default.createElement(
            "span",
            { className: "total-time-number" },
            " ",
            total_minutes,
            " "
          ),
          _ref7
        )
      );
      return _react2.default.createElement(
        "div",
        { id: "stretch", className: !this.state.started ? "not-active" : "" },
        _ref8,
        _ref9,
        _ref10,
        _ref11,
        _ref12,
        _ref13,
        progress_bar_wrapper,
        status_wrapper,
        _react2.default.createElement(
          "div",
          { className: "control-buttons-wrapper" },
          _react2.default.createElement(
            "a",
            { className: "btn", onClick: this.clicked1.bind(this) },
            !this.state.started ? "start" : "stop"
          ),
          button2
        ),
        num_selectors,
        total_time,
        _ref14,
        _react2.default.createElement(
          _reactRouter.Link,
          { to: "/", className: "link back-link" },
          _ref15,
          " back"
        )
      );
    }
  }]);

  return Stretch;
}(_react2.default.Component);

exports.default = Stretch;

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Babel6 does not hack the default behaviour of ES Modules anymore, so we should export

var ReactLiveClock = __webpack_require__(646).default;

module.exports = ReactLiveClock;
//# sourceMappingURL=index.js.map

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _momentTimezone = __webpack_require__(647);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BASE_UNIT = 'milliseconds';

var ReactLiveClock = function (_React$Component) {
  _inherits(ReactLiveClock, _React$Component);

  function ReactLiveClock(props) {
    _classCallCheck(this, ReactLiveClock);

    var _this = _possibleConstructorReturn(this, (ReactLiveClock.__proto__ || Object.getPrototypeOf(ReactLiveClock)).call(this, props));

    var date = props.date || props.children || null;
    var timesatmp = (0, _momentTimezone2.default)();
    var baseTime = date ? (0, _momentTimezone2.default)(new Date(date).getTime()) : timesatmp;

    _this.state = {
      realTime: !date,
      now: baseTime,
      baseTime: baseTime,
      startTime: timesatmp
    };
    return _this;
  }

  _createClass(ReactLiveClock, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var _props = this.props,
          ticking = _props.ticking,
          interval = _props.interval;


      if (ticking && interval) {
        this.tickTimer = setInterval(function () {
          _this2.updateClock();
        }, interval);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.tickTimer) {
        clearInterval(this.tickTimer);
      }
    }
  }, {
    key: 'updateClock',
    value: function updateClock() {
      var realTime = this.state.realTime;


      if (realTime) {
        this.setState({
          now: (0, _momentTimezone2.default)()
        });
      } else {
        var _state = this.state,
            baseTime = _state.baseTime,
            startTime = _state.startTime;

        var newTime = (0, _momentTimezone2.default)();
        var diff = newTime.diff(startTime, BASE_UNIT);

        this.setState({
          now: baseTime.clone().add(diff, BASE_UNIT)
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          format = _props2.format,
          timezone = _props2.timezone,
          restProps = _objectWithoutProperties(_props2, ['format', 'timezone']);

      var now = this.state.now;

      var localizedTime = now;

      if (timezone) {
        localizedTime.tz(timezone);
      }

      var formattedTime = localizedTime.format(format);

      var childProps = Object.keys(restProps).filter(function (key) {
        return !['date', 'interval', 'ticking'].includes(key);
      }).reduce(function (acc, key) {
        acc[key] = restProps[key];
        return acc;
      }, {});

      return _react2.default.createElement(
        'time',
        childProps,
        formattedTime
      );
    }
  }]);

  return ReactLiveClock;
}(_react2.default.Component);

exports.default = ReactLiveClock;


ReactLiveClock.propTypes = {
  children: _propTypes2.default.string,
  date: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  format: _propTypes2.default.string,
  interval: _propTypes2.default.number,
  ticking: _propTypes2.default.bool,
  timezone: _propTypes2.default.string
};

ReactLiveClock.defaultProps = {
  date: null,
  format: 'HH:mm',
  interval: 1000,
  ticking: false,
  timezone: null
};
//# sourceMappingURL=Component.js.map

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

var moment = module.exports = __webpack_require__(648);
moment.tz.load(__webpack_require__(650));


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//! moment-timezone.js
//! version : 0.5.13
//! Copyright (c) JS Foundation and other contributors
//! license : MIT
//! github.com/moment/moment-timezone

(function (root, factory) {
	"use strict";

	/*global define*/
	if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));                 // AMD
	} else if (typeof module === 'object' && module.exports) {
		module.exports = factory(require('moment')); // Node
	} else {
		factory(root.moment);                        // Browser
	}
}(this, function (moment) {
	"use strict";

	// Do not load moment-timezone a second time.
	// if (moment.tz !== undefined) {
	// 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
	// 	return moment;
	// }

	var VERSION = "0.5.13",
		zones = {},
		links = {},
		names = {},
		guesses = {},
		cachedGuess,

		momentVersion = moment.version.split('.'),
		major = +momentVersion[0],
		minor = +momentVersion[1];

	// Moment.js version check
	if (major < 2 || (major === 2 && minor < 6)) {
		logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
	}

	/************************************
		Unpacking
	************************************/

	function charCodeToInt(charCode) {
		if (charCode > 96) {
			return charCode - 87;
		} else if (charCode > 64) {
			return charCode - 29;
		}
		return charCode - 48;
	}

	function unpackBase60(string) {
		var i = 0,
			parts = string.split('.'),
			whole = parts[0],
			fractional = parts[1] || '',
			multiplier = 1,
			num,
			out = 0,
			sign = 1;

		// handle negative numbers
		if (string.charCodeAt(0) === 45) {
			i = 1;
			sign = -1;
		}

		// handle digits before the decimal
		for (i; i < whole.length; i++) {
			num = charCodeToInt(whole.charCodeAt(i));
			out = 60 * out + num;
		}

		// handle digits after the decimal
		for (i = 0; i < fractional.length; i++) {
			multiplier = multiplier / 60;
			num = charCodeToInt(fractional.charCodeAt(i));
			out += num * multiplier;
		}

		return out * sign;
	}

	function arrayToInt (array) {
		for (var i = 0; i < array.length; i++) {
			array[i] = unpackBase60(array[i]);
		}
	}

	function intToUntil (array, length) {
		for (var i = 0; i < length; i++) {
			array[i] = Math.round((array[i - 1] || 0) + (array[i] * 60000)); // minutes to milliseconds
		}

		array[length - 1] = Infinity;
	}

	function mapIndices (source, indices) {
		var out = [], i;

		for (i = 0; i < indices.length; i++) {
			out[i] = source[indices[i]];
		}

		return out;
	}

	function unpack (string) {
		var data = string.split('|'),
			offsets = data[2].split(' '),
			indices = data[3].split(''),
			untils  = data[4].split(' ');

		arrayToInt(offsets);
		arrayToInt(indices);
		arrayToInt(untils);

		intToUntil(untils, indices.length);

		return {
			name       : data[0],
			abbrs      : mapIndices(data[1].split(' '), indices),
			offsets    : mapIndices(offsets, indices),
			untils     : untils,
			population : data[5] | 0
		};
	}

	/************************************
		Zone object
	************************************/

	function Zone (packedString) {
		if (packedString) {
			this._set(unpack(packedString));
		}
	}

	Zone.prototype = {
		_set : function (unpacked) {
			this.name       = unpacked.name;
			this.abbrs      = unpacked.abbrs;
			this.untils     = unpacked.untils;
			this.offsets    = unpacked.offsets;
			this.population = unpacked.population;
		},

		_index : function (timestamp) {
			var target = +timestamp,
				untils = this.untils,
				i;

			for (i = 0; i < untils.length; i++) {
				if (target < untils[i]) {
					return i;
				}
			}
		},

		parse : function (timestamp) {
			var target  = +timestamp,
				offsets = this.offsets,
				untils  = this.untils,
				max     = untils.length - 1,
				offset, offsetNext, offsetPrev, i;

			for (i = 0; i < max; i++) {
				offset     = offsets[i];
				offsetNext = offsets[i + 1];
				offsetPrev = offsets[i ? i - 1 : i];

				if (offset < offsetNext && tz.moveAmbiguousForward) {
					offset = offsetNext;
				} else if (offset > offsetPrev && tz.moveInvalidForward) {
					offset = offsetPrev;
				}

				if (target < untils[i] - (offset * 60000)) {
					return offsets[i];
				}
			}

			return offsets[max];
		},

		abbr : function (mom) {
			return this.abbrs[this._index(mom)];
		},

		offset : function (mom) {
			return this.offsets[this._index(mom)];
		}
	};

	/************************************
		Current Timezone
	************************************/

	function OffsetAt(at) {
		var timeString = at.toTimeString();
		var abbr = timeString.match(/\([a-z ]+\)/i);
		if (abbr && abbr[0]) {
			// 17:56:31 GMT-0600 (CST)
			// 17:56:31 GMT-0600 (Central Standard Time)
			abbr = abbr[0].match(/[A-Z]/g);
			abbr = abbr ? abbr.join('') : undefined;
		} else {
			// 17:56:31 CST
			// 17:56:31 GMT+0800 (台北標準時間)
			abbr = timeString.match(/[A-Z]{3,5}/g);
			abbr = abbr ? abbr[0] : undefined;
		}

		if (abbr === 'GMT') {
			abbr = undefined;
		}

		this.at = +at;
		this.abbr = abbr;
		this.offset = at.getTimezoneOffset();
	}

	function ZoneScore(zone) {
		this.zone = zone;
		this.offsetScore = 0;
		this.abbrScore = 0;
	}

	ZoneScore.prototype.scoreOffsetAt = function (offsetAt) {
		this.offsetScore += Math.abs(this.zone.offset(offsetAt.at) - offsetAt.offset);
		if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) {
			this.abbrScore++;
		}
	};

	function findChange(low, high) {
		var mid, diff;

		while ((diff = ((high.at - low.at) / 12e4 | 0) * 6e4)) {
			mid = new OffsetAt(new Date(low.at + diff));
			if (mid.offset === low.offset) {
				low = mid;
			} else {
				high = mid;
			}
		}

		return low;
	}

	function userOffsets() {
		var startYear = new Date().getFullYear() - 2,
			last = new OffsetAt(new Date(startYear, 0, 1)),
			offsets = [last],
			change, next, i;

		for (i = 1; i < 48; i++) {
			next = new OffsetAt(new Date(startYear, i, 1));
			if (next.offset !== last.offset) {
				change = findChange(last, next);
				offsets.push(change);
				offsets.push(new OffsetAt(new Date(change.at + 6e4)));
			}
			last = next;
		}

		for (i = 0; i < 4; i++) {
			offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
			offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
		}

		return offsets;
	}

	function sortZoneScores (a, b) {
		if (a.offsetScore !== b.offsetScore) {
			return a.offsetScore - b.offsetScore;
		}
		if (a.abbrScore !== b.abbrScore) {
			return a.abbrScore - b.abbrScore;
		}
		return b.zone.population - a.zone.population;
	}

	function addToGuesses (name, offsets) {
		var i, offset;
		arrayToInt(offsets);
		for (i = 0; i < offsets.length; i++) {
			offset = offsets[i];
			guesses[offset] = guesses[offset] || {};
			guesses[offset][name] = true;
		}
	}

	function guessesForUserOffsets (offsets) {
		var offsetsLength = offsets.length,
			filteredGuesses = {},
			out = [],
			i, j, guessesOffset;

		for (i = 0; i < offsetsLength; i++) {
			guessesOffset = guesses[offsets[i].offset] || {};
			for (j in guessesOffset) {
				if (guessesOffset.hasOwnProperty(j)) {
					filteredGuesses[j] = true;
				}
			}
		}

		for (i in filteredGuesses) {
			if (filteredGuesses.hasOwnProperty(i)) {
				out.push(names[i]);
			}
		}

		return out;
	}

	function rebuildGuess () {

		// use Intl API when available and returning valid time zone
		try {
			var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
			if (intlName){
				var name = names[normalizeName(intlName)];
				if (name) {
					return name;
				}
				logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
			}
		} catch (e) {
			// Intl unavailable, fall back to manual guessing.
		}

		var offsets = userOffsets(),
			offsetsLength = offsets.length,
			guesses = guessesForUserOffsets(offsets),
			zoneScores = [],
			zoneScore, i, j;

		for (i = 0; i < guesses.length; i++) {
			zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
			for (j = 0; j < offsetsLength; j++) {
				zoneScore.scoreOffsetAt(offsets[j]);
			}
			zoneScores.push(zoneScore);
		}

		zoneScores.sort(sortZoneScores);

		return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
	}

	function guess (ignoreCache) {
		if (!cachedGuess || ignoreCache) {
			cachedGuess = rebuildGuess();
		}
		return cachedGuess;
	}

	/************************************
		Global Methods
	************************************/

	function normalizeName (name) {
		return (name || '').toLowerCase().replace(/\//g, '_');
	}

	function addZone (packed) {
		var i, name, split, normalized;

		if (typeof packed === "string") {
			packed = [packed];
		}

		for (i = 0; i < packed.length; i++) {
			split = packed[i].split('|');
			name = split[0];
			normalized = normalizeName(name);
			zones[normalized] = packed[i];
			names[normalized] = name;
			if (split[5]) {
				addToGuesses(normalized, split[2].split(' '));
			}
		}
	}

	function getZone (name, caller) {
		name = normalizeName(name);

		var zone = zones[name];
		var link;

		if (zone instanceof Zone) {
			return zone;
		}

		if (typeof zone === 'string') {
			zone = new Zone(zone);
			zones[name] = zone;
			return zone;
		}

		// Pass getZone to prevent recursion more than 1 level deep
		if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
			zone = zones[name] = new Zone();
			zone._set(link);
			zone.name = names[name];
			return zone;
		}

		return null;
	}

	function getNames () {
		var i, out = [];

		for (i in names) {
			if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
				out.push(names[i]);
			}
		}

		return out.sort();
	}

	function addLink (aliases) {
		var i, alias, normal0, normal1;

		if (typeof aliases === "string") {
			aliases = [aliases];
		}

		for (i = 0; i < aliases.length; i++) {
			alias = aliases[i].split('|');

			normal0 = normalizeName(alias[0]);
			normal1 = normalizeName(alias[1]);

			links[normal0] = normal1;
			names[normal0] = alias[0];

			links[normal1] = normal0;
			names[normal1] = alias[1];
		}
	}

	function loadData (data) {
		addZone(data.zones);
		addLink(data.links);
		tz.dataVersion = data.version;
	}

	function zoneExists (name) {
		if (!zoneExists.didShowError) {
			zoneExists.didShowError = true;
				logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
		}
		return !!getZone(name);
	}

	function needsOffset (m) {
		return !!(m._a && (m._tzm === undefined));
	}

	function logError (message) {
		if (typeof console !== 'undefined' && typeof console.error === 'function') {
			console.error(message);
		}
	}

	/************************************
		moment.tz namespace
	************************************/

	function tz (input) {
		var args = Array.prototype.slice.call(arguments, 0, -1),
			name = arguments[arguments.length - 1],
			zone = getZone(name),
			out  = moment.utc.apply(null, args);

		if (zone && !moment.isMoment(input) && needsOffset(out)) {
			out.add(zone.parse(out), 'minutes');
		}

		out.tz(name);

		return out;
	}

	tz.version      = VERSION;
	tz.dataVersion  = '';
	tz._zones       = zones;
	tz._links       = links;
	tz._names       = names;
	tz.add          = addZone;
	tz.link         = addLink;
	tz.load         = loadData;
	tz.zone         = getZone;
	tz.zoneExists   = zoneExists; // deprecated in 0.1.0
	tz.guess        = guess;
	tz.names        = getNames;
	tz.Zone         = Zone;
	tz.unpack       = unpack;
	tz.unpackBase60 = unpackBase60;
	tz.needsOffset  = needsOffset;
	tz.moveInvalidForward   = true;
	tz.moveAmbiguousForward = false;

	/************************************
		Interface with Moment.js
	************************************/

	var fn = moment.fn;

	moment.tz = tz;

	moment.defaultZone = null;

	moment.updateOffset = function (mom, keepTime) {
		var zone = moment.defaultZone,
			offset;

		if (mom._z === undefined) {
			if (zone && needsOffset(mom) && !mom._isUTC) {
				mom._d = moment.utc(mom._a)._d;
				mom.utc().add(zone.parse(mom), 'minutes');
			}
			mom._z = zone;
		}
		if (mom._z) {
			offset = mom._z.offset(mom);
			if (Math.abs(offset) < 16) {
				offset = offset / 60;
			}
			if (mom.utcOffset !== undefined) {
				mom.utcOffset(-offset, keepTime);
			} else {
				mom.zone(offset, keepTime);
			}
		}
	};

	fn.tz = function (name) {
		if (name) {
			this._z = getZone(name);
			if (this._z) {
				moment.updateOffset(this);
			} else {
				logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
			}
			return this;
		}
		if (this._z) { return this._z.name; }
	};

	function abbrWrap (old) {
		return function () {
			if (this._z) { return this._z.abbr(this); }
			return old.call(this);
		};
	}

	function resetZoneWrap (old) {
		return function () {
			this._z = null;
			return old.apply(this, arguments);
		};
	}

	fn.zoneName = abbrWrap(fn.zoneName);
	fn.zoneAbbr = abbrWrap(fn.zoneAbbr);
	fn.utc      = resetZoneWrap(fn.utc);

	moment.tz.setDefault = function(name) {
		if (major < 2 || (major === 2 && minor < 9)) {
			logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
		}
		moment.defaultZone = name ? getZone(name) : null;
		return moment;
	};

	// Cloning a moment should include the _z property.
	var momentProperties = moment.momentProperties;
	if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
		// moment 2.8.1+
		momentProperties.push('_z');
		momentProperties.push('_a');
	} else if (momentProperties) {
		// moment 2.7.0
		momentProperties._z = null;
	}

	// INJECT DATA

	return moment;
}));


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 194,
	"./af.js": 194,
	"./ar": 195,
	"./ar-dz": 196,
	"./ar-dz.js": 196,
	"./ar-kw": 197,
	"./ar-kw.js": 197,
	"./ar-ly": 198,
	"./ar-ly.js": 198,
	"./ar-ma": 199,
	"./ar-ma.js": 199,
	"./ar-sa": 200,
	"./ar-sa.js": 200,
	"./ar-tn": 201,
	"./ar-tn.js": 201,
	"./ar.js": 195,
	"./az": 202,
	"./az.js": 202,
	"./be": 203,
	"./be.js": 203,
	"./bg": 204,
	"./bg.js": 204,
	"./bm": 205,
	"./bm.js": 205,
	"./bn": 206,
	"./bn.js": 206,
	"./bo": 207,
	"./bo.js": 207,
	"./br": 208,
	"./br.js": 208,
	"./bs": 209,
	"./bs.js": 209,
	"./ca": 210,
	"./ca.js": 210,
	"./cs": 211,
	"./cs.js": 211,
	"./cv": 212,
	"./cv.js": 212,
	"./cy": 213,
	"./cy.js": 213,
	"./da": 214,
	"./da.js": 214,
	"./de": 215,
	"./de-at": 216,
	"./de-at.js": 216,
	"./de-ch": 217,
	"./de-ch.js": 217,
	"./de.js": 215,
	"./dv": 218,
	"./dv.js": 218,
	"./el": 219,
	"./el.js": 219,
	"./en-au": 220,
	"./en-au.js": 220,
	"./en-ca": 221,
	"./en-ca.js": 221,
	"./en-gb": 222,
	"./en-gb.js": 222,
	"./en-ie": 223,
	"./en-ie.js": 223,
	"./en-nz": 224,
	"./en-nz.js": 224,
	"./eo": 225,
	"./eo.js": 225,
	"./es": 226,
	"./es-do": 227,
	"./es-do.js": 227,
	"./es-us": 228,
	"./es-us.js": 228,
	"./es.js": 226,
	"./et": 229,
	"./et.js": 229,
	"./eu": 230,
	"./eu.js": 230,
	"./fa": 231,
	"./fa.js": 231,
	"./fi": 232,
	"./fi.js": 232,
	"./fo": 233,
	"./fo.js": 233,
	"./fr": 234,
	"./fr-ca": 235,
	"./fr-ca.js": 235,
	"./fr-ch": 236,
	"./fr-ch.js": 236,
	"./fr.js": 234,
	"./fy": 237,
	"./fy.js": 237,
	"./gd": 238,
	"./gd.js": 238,
	"./gl": 239,
	"./gl.js": 239,
	"./gom-latn": 240,
	"./gom-latn.js": 240,
	"./gu": 241,
	"./gu.js": 241,
	"./he": 242,
	"./he.js": 242,
	"./hi": 243,
	"./hi.js": 243,
	"./hr": 244,
	"./hr.js": 244,
	"./hu": 245,
	"./hu.js": 245,
	"./hy-am": 246,
	"./hy-am.js": 246,
	"./id": 247,
	"./id.js": 247,
	"./is": 248,
	"./is.js": 248,
	"./it": 249,
	"./it.js": 249,
	"./ja": 250,
	"./ja.js": 250,
	"./jv": 251,
	"./jv.js": 251,
	"./ka": 252,
	"./ka.js": 252,
	"./kk": 253,
	"./kk.js": 253,
	"./km": 254,
	"./km.js": 254,
	"./kn": 255,
	"./kn.js": 255,
	"./ko": 256,
	"./ko.js": 256,
	"./ky": 257,
	"./ky.js": 257,
	"./lb": 258,
	"./lb.js": 258,
	"./lo": 259,
	"./lo.js": 259,
	"./lt": 260,
	"./lt.js": 260,
	"./lv": 261,
	"./lv.js": 261,
	"./me": 262,
	"./me.js": 262,
	"./mi": 263,
	"./mi.js": 263,
	"./mk": 264,
	"./mk.js": 264,
	"./ml": 265,
	"./ml.js": 265,
	"./mr": 266,
	"./mr.js": 266,
	"./ms": 267,
	"./ms-my": 268,
	"./ms-my.js": 268,
	"./ms.js": 267,
	"./my": 269,
	"./my.js": 269,
	"./nb": 270,
	"./nb.js": 270,
	"./ne": 271,
	"./ne.js": 271,
	"./nl": 272,
	"./nl-be": 273,
	"./nl-be.js": 273,
	"./nl.js": 272,
	"./nn": 274,
	"./nn.js": 274,
	"./pa-in": 275,
	"./pa-in.js": 275,
	"./pl": 276,
	"./pl.js": 276,
	"./pt": 277,
	"./pt-br": 278,
	"./pt-br.js": 278,
	"./pt.js": 277,
	"./ro": 279,
	"./ro.js": 279,
	"./ru": 280,
	"./ru.js": 280,
	"./sd": 281,
	"./sd.js": 281,
	"./se": 282,
	"./se.js": 282,
	"./si": 283,
	"./si.js": 283,
	"./sk": 284,
	"./sk.js": 284,
	"./sl": 285,
	"./sl.js": 285,
	"./sq": 286,
	"./sq.js": 286,
	"./sr": 287,
	"./sr-cyrl": 288,
	"./sr-cyrl.js": 288,
	"./sr.js": 287,
	"./ss": 289,
	"./ss.js": 289,
	"./sv": 290,
	"./sv.js": 290,
	"./sw": 291,
	"./sw.js": 291,
	"./ta": 292,
	"./ta.js": 292,
	"./te": 293,
	"./te.js": 293,
	"./tet": 294,
	"./tet.js": 294,
	"./th": 295,
	"./th.js": 295,
	"./tl-ph": 296,
	"./tl-ph.js": 296,
	"./tlh": 297,
	"./tlh.js": 297,
	"./tr": 298,
	"./tr.js": 298,
	"./tzl": 299,
	"./tzl.js": 299,
	"./tzm": 300,
	"./tzm-latn": 301,
	"./tzm-latn.js": 301,
	"./tzm.js": 300,
	"./uk": 302,
	"./uk.js": 302,
	"./ur": 303,
	"./ur.js": 303,
	"./uz": 304,
	"./uz-latn": 305,
	"./uz-latn.js": 305,
	"./uz.js": 304,
	"./vi": 306,
	"./vi.js": 306,
	"./x-pseudo": 307,
	"./x-pseudo.js": 307,
	"./yo": 308,
	"./yo.js": 308,
	"./zh-cn": 309,
	"./zh-cn.js": 309,
	"./zh-hk": 310,
	"./zh-hk.js": 310,
	"./zh-tw": 311,
	"./zh-tw.js": 311
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 649;

/***/ }),
/* 650 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2017b",
	"zones": [
		"Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5",
		"Africa/Accra|LMT GMT +0020|.Q 0 -k|012121212121212121212121212121212121212121212121|-26BbX.8 6tzX.8 MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE|41e5",
		"Africa/Nairobi|LMT EAT +0230 +0245|-2r.g -30 -2u -2J|01231|-1F3Cr.g 3Dzr.g okMu MFXJ|47e5",
		"Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5",
		"Africa/Lagos|LMT WAT|-d.A -10|01|-22y0d.A|17e6",
		"Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldWV.E 2xonV.E|39e4",
		"Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5",
		"Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6",
		"Africa/Casablanca|LMT WET WEST CET|u.k 0 -10 -10|0121212121212121213121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0|32e5",
		"Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3",
		"Africa/El_Aaiun|LMT -01 WET WEST|Q.M 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0|20e4",
		"Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5",
		"Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|01212121212121212121212121212121213|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0|51e5",
		"Africa/Monrovia|MMT MMT GMT|H.8 I.u 0|012|-23Lzg.Q 28G01.m|11e5",
		"Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5",
		"Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5",
		"Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5",
		"Africa/Windhoek|+0130 SAST SAST CAT WAT WAST|-1u -20 -30 -20 -10 -20|012134545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2GJdu 1Ajdu 1cL0 1SqL0 9NA0 11D0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0|32e4",
		"America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326",
		"America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4",
		"America/Port_of_Spain|LMT AST|46.4 40|01|-2kNvR.U|43e3",
		"America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4",
		"America/Argentina/Buenos_Aires|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0",
		"America/Argentina/Catamarca|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0",
		"America/Argentina/Cordoba|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0",
		"America/Argentina/Jujuy|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0",
		"America/Argentina/La_Rioja|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0",
		"America/Argentina/Mendoza|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232312121321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0",
		"America/Argentina/Rio_Gallegos|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0",
		"America/Argentina/Salta|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0",
		"America/Argentina/San_Juan|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0",
		"America/Argentina/San_Luis|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121212321212|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0",
		"America/Argentina/Tucuman|CMT -04 -03 -02|4g.M 40 30 20|0121212121212121212121212121212121212121212323232313232123232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0",
		"America/Argentina/Ushuaia|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0",
		"America/Curacao|LMT -0430 AST|4z.L 4u 40|012|-2kV7o.d 28KLS.d|15e4",
		"America/Asuncion|AMT -04 -03|3O.E 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5",
		"America/Atikokan|CST CDT CWT CPT EST|60 50 50 50 50|0101234|-25TQ0 1in0 Rnb0 3je0 8x30 iw0|28e2",
		"America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5",
		"America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3",
		"America/Barbados|LMT BMT AST ADT|3W.t 3W.t 40 30|01232323232|-1Q0I1.v jsM0 1ODC1.v IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4",
		"America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5",
		"America/Belize|LMT CST -0530 CDT|5Q.M 60 5u 50|01212121212121212121212121212121212121212121212121213131|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1f0Mu qn0 lxB0 mn0|57e3",
		"America/Blanc-Sablon|AST ADT AWT APT|40 30 30 30|010230|-25TS0 1in0 UGp0 8x50 iu0|11e2",
		"America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2",
		"America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5",
		"America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4",
		"America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2",
		"America/Campo_Grande|LMT -04 -03|3C.s 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|77e4",
		"America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4",
		"America/Caracas|CMT -0430 -04|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5",
		"America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3",
		"America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5",
		"America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5",
		"America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4",
		"America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5",
		"America/Creston|MST PST|70 80|010|-29DR0 43B0|53e2",
		"America/Cuiaba|LMT -04 -03|3I.k 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|54e4",
		"America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8",
		"America/Dawson|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|13e2",
		"America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3",
		"America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5",
		"America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|01234252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 Jy10 SL0 dnB0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5",
		"America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|01212121212121341212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 LFB0 1cL0 3Cp0 1cL0 66N0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5",
		"America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3",
		"America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5",
		"America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5",
		"America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2",
		"America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5",
		"America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3",
		"America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3",
		"America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2",
		"America/Grand_Turk|KMT EST EDT AST|57.b 50 40 40|0121212121212121212121212121212121212121212121212121212121212121212121212123|-2l1uQ.N 2HHBQ.N 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2",
		"America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5",
		"America/Guayaquil|QMT -05 -04|5e 50 40|0121|-1yVSK 2uILK rz0|27e5",
		"America/Guyana|LMT -0345 -03 -04|3Q.E 3J 30 40|0123|-2dvU7.k 2r6LQ.k Bxbf|80e4",
		"America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4",
		"America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5",
		"America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4",
		"America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2",
		"America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2",
		"America/Jamaica|KMT EST EDT|57.b 50 40|0121212121212121212121|-2l1uQ.N 2uM1Q.N 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4",
		"America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3",
		"America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 Bb0 10N0 2bB0 8in0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"America/La_Paz|CMT BOST -04|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5",
		"America/Lima|LMT -05 -04|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6",
		"America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6",
		"America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4",
		"America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5",
		"America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5",
		"America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4",
		"America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4",
		"America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4",
		"America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2",
		"America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5",
		"America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|0120303030303030303030303030303030454545454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2",
		"America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6",
		"America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2",
		"America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3",
		"America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5",
		"America/Montevideo|MMT -0330 -03 -02 -0230|3I.I 3u 30 20 2u|012121212121212121212121213232323232324242423243232323232323232323232323232323232323232|-20UIf.g 8jzJ.g 1cLu 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1qMu WLu 1qMu 11zu 1o0u 11zu NAu 11bu 2iMu zWu Dq10 19X0 pd0 jz0 cm10 19X0 1fB0 1on0 11d0 1oL0 1nB0 1fzu 1aou 1fzu 1aou 1fzu 3nAu Jb0 3MN0 1SLu 4jzu 2PB0 Lb0 3Dd0 1pb0 ixd0 An0 1MN0 An0 1wp0 On0 1wp0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5",
		"America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5",
		"America/Nassau|LMT EST EDT|59.u 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2kNuO.u 26XdO.u 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|24e4",
		"America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6",
		"America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2",
		"America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2",
		"America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2",
		"America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3",
		"America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2",
		"America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4",
		"America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5",
		"America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5",
		"America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4",
		"America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4",
		"America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5",
		"America/Punta_Arenas|SMT -05 -04 -03|4G.K 50 40 30|0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0",
		"America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842",
		"America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2",
		"America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5",
		"America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4",
		"America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229",
		"America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4",
		"America/Santiago|SMT -05 -04 -03|4G.K 50 40 30|010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|62e5",
		"America/Santo_Domingo|SDMT EST EDT -0430 AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5",
		"America/Sao_Paulo|LMT -03 -02|36.s 30 20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|20e6",
		"America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452",
		"America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2",
		"America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4",
		"America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3",
		"America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5",
		"America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656",
		"America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4",
		"America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5",
		"America/Whitehorse|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3",
		"America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4",
		"America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642",
		"America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3",
		"Antarctica/Casey|-00 +08 +11|0 -80 -b0|0121212|-2q00 1DjS0 T90 40P0 KL0 blz0|10",
		"Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70",
		"Antarctica/DumontDUrville|-00 +10|0 -a0|0101|-U0o0 cfq0 bFm0|80",
		"Antarctica/Macquarie|AEST AEDT -00 +11|-a0 -b0 0 -b0|0102010101010101010101010101010101010101010101010101010101010101010101010101010101010101013|-29E80 19X0 4SL0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0|1",
		"Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60",
		"Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5",
		"Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40",
		"Antarctica/Rothera|-00 -03|0 30|01|gOo0|130",
		"Antarctica/Syowa|-00 +03|0 -30|01|-vs00|20",
		"Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40",
		"Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25",
		"Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4",
		"Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5",
		"Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5",
		"Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e5",
		"Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3",
		"Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4",
		"Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4",
		"Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4",
		"Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0",
		"Asia/Baghdad|BMT +03 +04|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5",
		"Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4",
		"Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5",
		"Asia/Bangkok|BMT +07|-6G.4 -70|01|-218SG.4|15e6",
		"Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0",
		"Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5",
		"Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4",
		"Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4",
		"Asia/Kolkata|HMT +0630 IST|-5R.k -6u -5u|01212|-18LFR.k 1unn.k HB0 7zX0|15e6",
		"Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4",
		"Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3",
		"Asia/Shanghai|CST CDT|-80 -90|01010101010101010|-1c1I0 LX0 16p0 1jz0 1Myp0 Rb0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6",
		"Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5",
		"Asia/Dhaka|HMT +0630 +0530 +06 +07|-5R.k -6u -5u -60 -70|0121343|-18LFR.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6",
		"Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5",
		"Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4",
		"Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5",
		"Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4",
		"Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0",
		"Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101012323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0|18e5",
		"Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|01010101010101010101010101010101232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0|25e4",
		"Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5",
		"Asia/Hong_Kong|LMT HKT HKST JST|-7A.G -80 -90 -90|0121312121212121212121212121212121212121212121212121212121212121212121|-2CFHA.G 1sEP6.G 1cL0 ylu 93X0 1qQu 1tX0 Rd0 1In0 NB0 1cL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1kL0 14N0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5",
		"Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3",
		"Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4",
		"Europe/Istanbul|IMT EET EEST +04 +03|-1U.U -20 -30 -40 -30|012121212121212121212121212121212121212121212121212121234343434342121212121212121212121212121212121212121212121212121212121212124|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSp0 CL0 mN0 1Vz0 1gN0 1pz0 5Rd0 1fz0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1jB0 18L0 1ip0 17z0 qdd0 xX0 3S10 Tz0 dA10 11z0 1o10 11z0 1qN0 11z0 1ze0 11B0 WM0 1qO0 WI0 1nX0 1rB0 10L0 11B0 1in0 17d0 1in0 2pX0 19E0 1fU0 16Q0 1iI0 16Q0 1iI0 1Vd0 pb0 3Kp0 14o0 1de0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6",
		"Asia/Jakarta|BMT +0720 +0730 +09 +08 WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6",
		"Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4",
		"Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|01212121212132121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyMk.E 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 3LB0 Em0 or0 1cn0 1dB0 16n0 10O0 1ja0 1tC0 14o0 1cM0 1a00 11A0 1Na0 An0 1MP0 AJ0 1Kp0 LC0 1oo0 Wl0 EQN0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4",
		"Asia/Kabul|+04 +0430|-40 -4u|01|-10Qs0|46e5",
		"Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4",
		"Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6",
		"Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5",
		"Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5",
		"Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2",
		"Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5",
		"Asia/Kuala_Lumpur|SMT +07 +0720 +0730 +09 +08|-6T.p -70 -7k -7u -90 -80|0123435|-2Bg6T.p 17anT.p l5XE 17bO 8Fyu 1so1u|71e5",
		"Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4",
		"Asia/Macau|LMT CST CDT|-7y.k -80 -90|012121212121212121212121212121212121212121|-2le7y.k 1XO34.k 1wn0 Rd0 1wn0 R9u 1wqu U10 1tz0 TVu 1tz0 17gu 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cOu 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cL0|57e4",
		"Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3",
		"Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5",
		"Asia/Manila|+08 +09|-80 -90|010101010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6",
		"Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4",
		"Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4",
		"Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5",
		"Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5",
		"Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4",
		"Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4",
		"Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|01231|-2um8n 97XR 1lTzu 2Onc0|29e5",
		"Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|0123232323232323232323232323232323232323232323|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|73e4",
		"Asia/Rangoon|RMT +0630 +09|-6o.E -6u -90|0121|-21Jio.E SmnS.E 7j9u|48e5",
		"Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4",
		"Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4",
		"Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -9u -a0|0123141414141414135353|-2um8r.Q 97XV.Q 1m1zu kKo0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6",
		"Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2",
		"Asia/Taipei|CST JST CDT|-80 -90 -90|01020202020202020202020202020202020202020|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5",
		"Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5",
		"Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5",
		"Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6",
		"Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3",
		"Asia/Tokyo|JST JDT|-90 -a0|010101010|-QJH0 QL0 1lB0 13X0 1zB0 NX0 1zB0 NX0|38e6",
		"Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5",
		"Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5",
		"Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2",
		"Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4",
		"Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4",
		"Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5",
		"Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5",
		"Atlantic/Azores|HMT -02 -01 +00 WET|1S.w 20 10 0 0|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121232323232323232323232323232323234323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2ldW5.s aPX5.s Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4",
		"Atlantic/Bermuda|LMT AST ADT|4j.i 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1BnRE.G 1LTbE.G 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3",
		"Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4",
		"Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2xomp.U 1qOMp.U 7zX0 1djf0|50e4",
		"Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3",
		"Atlantic/Madeira|FMT -01 +00 +01 WET WEST|17.A 10 0 -10 0 -10|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldWQ.o aPWQ.o Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4",
		"Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4",
		"Atlantic/South_Georgia|-02|20|0||30",
		"Atlantic/Stanley|SMT -04 -03 -02|3P.o 40 30 20|012121212121212323212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2",
		"Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5",
		"Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5",
		"Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5",
		"Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3",
		"Australia/Currie|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|746",
		"Australia/Darwin|ACST ACDT|-9u -au|010101010|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0|12e4",
		"Australia/Eucla|+0845 +0945|-8J -9J|0101010101010101010|-293kI xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368",
		"Australia/Hobart|AEST AEDT|-a0 -b0|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 VfB0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4",
		"Australia/Lord_Howe|AEST +1030 +1130 +11|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347",
		"Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10",
		"Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5",
		"Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293jX xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5",
		"CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
		"CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"Pacific/Easter|EMT -07 -06 -05|7h.s 70 60 50|012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|30e2",
		"EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
		"EST|EST|50|0|",
		"EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g5X0 14p0 1wn0 17d0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
		"Etc/GMT+0|GMT|0|0|",
		"Etc/GMT+1|-01|10|0|",
		"Etc/GMT+10|-10|a0|0|",
		"Etc/GMT+11|-11|b0|0|",
		"Etc/GMT+12|-12|c0|0|",
		"Etc/GMT+3|-03|30|0|",
		"Etc/GMT+4|-04|40|0|",
		"Etc/GMT+5|-05|50|0|",
		"Etc/GMT+6|-06|60|0|",
		"Etc/GMT+7|-07|70|0|",
		"Etc/GMT+8|-08|80|0|",
		"Etc/GMT+9|-09|90|0|",
		"Etc/GMT-1|+01|-10|0|",
		"Pacific/Port_Moresby|+10|-a0|0||25e4",
		"Pacific/Pohnpei|+11|-b0|0||34e3",
		"Pacific/Tarawa|+12|-c0|0||29e3",
		"Etc/GMT-13|+13|-d0|0|",
		"Etc/GMT-14|+14|-e0|0|",
		"Etc/GMT-2|+02|-20|0|",
		"Etc/GMT-3|+03|-30|0|",
		"Etc/GMT-4|+04|-40|0|",
		"Etc/GMT-5|+05|-50|0|",
		"Etc/GMT-6|+06|-60|0|",
		"Indian/Christmas|+07|-70|0||21e2",
		"Etc/GMT-8|+08|-80|0|",
		"Pacific/Palau|+09|-90|0||21e3",
		"Etc/UCT|UCT|0|0|",
		"Etc/UTC|UTC|0|0|",
		"Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5",
		"Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3",
		"Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0",
		"Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5",
		"Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6",
		"Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
		"Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5",
		"Europe/Prague|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 16M0 1lc0 1tA0 17A0 11c0 1io0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5",
		"Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5",
		"Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5",
		"Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1ip0 17b0 1op0 1tb0 Q2m0 3Ne0 WM0 1fA0 1cM0 1cM0 1oJ0 1dc0 1030 1fA0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1iM0 1fA0 8Ha0 Rb0 1wN0 Rb0 1BB0 Lz0 1C20 LB0 SNX0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5",
		"Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4",
		"Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4",
		"Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
		"Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3",
		"Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
		"Europe/Kaliningrad|CET CEST CET CEST MSK MSD EEST EET +03|-10 -20 -20 -30 -30 -40 -30 -20 -30|0101010101010232454545454545454546767676767676767676767676767676767676767676787|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 Am0 Lb0 1en0 op0 1pNz0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4",
		"Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5",
		"Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4",
		"Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ldXn.f aPWn.f Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5",
		"Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4",
		"Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|010101010101010101210343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-25Td0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5",
		"Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4",
		"Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5",
		"Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3",
		"Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6",
		"Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco8.l cNb8.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6",
		"Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4",
		"Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5",
		"Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5",
		"Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810",
		"Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4",
		"Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
		"Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5",
		"Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4",
		"Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4",
		"Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0",
		"Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4",
		"Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1a00 1cM0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5",
		"Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4",
		"Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|01232323232323232121212121212121212121212121212121212121212121|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5",
		"Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5",
		"Europe/Zaporozhye|+0220 EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4",
		"HST|HST|a0|0|",
		"Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2",
		"Indian/Cocos|+0630|-6u|0||596",
		"Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130",
		"Indian/Mahe|LMT +04|-3F.M -40|01|-2yO3F.M|79e3",
		"Indian/Maldives|MMT +05|-4S -50|01|-olgS|35e4",
		"Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4",
		"Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4",
		"Pacific/Kwajalein|+11 -12 +12|-b0 c0 -c0|012|-AX0 W9X0|14e3",
		"MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
		"MST|MST|70|0|",
		"MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"Pacific/Chatham|+1215 +1245 +1345|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600",
		"PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"Pacific/Apia|LMT -1130 -11 -10 +14 +13|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545454545454545454545454545454545454|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|37e3",
		"Pacific/Bougainville|+10 +09 +11|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4",
		"Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|0121212121212121212121|-2l9nd.g 2Szcd.g 1cL0 1oN0 10L0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3",
		"Pacific/Enderbury|-12 -11 +13|c0 b0 -d0|012|nIc0 B8n0|1",
		"Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483",
		"Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|0121212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0|88e4",
		"Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3",
		"Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125",
		"Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4",
		"Pacific/Guam|GST ChST|-a0 -a0|01|1fpq0|17e4",
		"Pacific/Honolulu|HST HDT HST|au 9u a0|010102|-1thLu 8x0 lef0 8Pz0 46p0|37e4",
		"Pacific/Kiritimati|-1040 -10 +14|aE a0 -e0|012|nIaE B8nk|51e2",
		"Pacific/Kosrae|+11 +12|-b0 -c0|010|-AX0 1bdz0|66e2",
		"Pacific/Majuro|+11 +12|-b0 -c0|01|-AX0|28e3",
		"Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2",
		"Pacific/Pago_Pago|LMT SST|bm.M b0|01|-2nDMB.c|37e2",
		"Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E PvzB.E 5RCu 1ouJu|10e3",
		"Pacific/Niue|-1120 -1130 -11|bk bu b0|012|-KfME 17y0a|12e2",
		"Pacific/Norfolk|+1112 +1130 +1230 +11|-bc -bu -cu -b0|01213|-Kgbc W01G On0 1COp0|25e4",
		"Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3",
		"Pacific/Pitcairn|-0830 -08|8u 80|01|18Vku|56",
		"Pacific/Rarotonga|-1030 -0930 -10|au 9u a0|012121212121212121212121212|lyWu IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3",
		"Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4",
		"Pacific/Tongatapu|+1220 +13 +14|-ck -d0 -e0|0121212121212121212121212121212121212121212121212121|-1aB0k 2n5dk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0|75e3",
		"WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00"
	],
	"links": [
		"Africa/Abidjan|Africa/Bamako",
		"Africa/Abidjan|Africa/Banjul",
		"Africa/Abidjan|Africa/Conakry",
		"Africa/Abidjan|Africa/Dakar",
		"Africa/Abidjan|Africa/Freetown",
		"Africa/Abidjan|Africa/Lome",
		"Africa/Abidjan|Africa/Nouakchott",
		"Africa/Abidjan|Africa/Ouagadougou",
		"Africa/Abidjan|Africa/Sao_Tome",
		"Africa/Abidjan|Africa/Timbuktu",
		"Africa/Abidjan|Atlantic/St_Helena",
		"Africa/Cairo|Egypt",
		"Africa/Johannesburg|Africa/Maseru",
		"Africa/Johannesburg|Africa/Mbabane",
		"Africa/Khartoum|Africa/Juba",
		"Africa/Lagos|Africa/Bangui",
		"Africa/Lagos|Africa/Brazzaville",
		"Africa/Lagos|Africa/Douala",
		"Africa/Lagos|Africa/Kinshasa",
		"Africa/Lagos|Africa/Libreville",
		"Africa/Lagos|Africa/Luanda",
		"Africa/Lagos|Africa/Malabo",
		"Africa/Lagos|Africa/Niamey",
		"Africa/Lagos|Africa/Porto-Novo",
		"Africa/Maputo|Africa/Blantyre",
		"Africa/Maputo|Africa/Bujumbura",
		"Africa/Maputo|Africa/Gaborone",
		"Africa/Maputo|Africa/Harare",
		"Africa/Maputo|Africa/Kigali",
		"Africa/Maputo|Africa/Lubumbashi",
		"Africa/Maputo|Africa/Lusaka",
		"Africa/Nairobi|Africa/Addis_Ababa",
		"Africa/Nairobi|Africa/Asmara",
		"Africa/Nairobi|Africa/Asmera",
		"Africa/Nairobi|Africa/Dar_es_Salaam",
		"Africa/Nairobi|Africa/Djibouti",
		"Africa/Nairobi|Africa/Kampala",
		"Africa/Nairobi|Africa/Mogadishu",
		"Africa/Nairobi|Indian/Antananarivo",
		"Africa/Nairobi|Indian/Comoro",
		"Africa/Nairobi|Indian/Mayotte",
		"Africa/Tripoli|Libya",
		"America/Adak|America/Atka",
		"America/Adak|US/Aleutian",
		"America/Anchorage|US/Alaska",
		"America/Argentina/Buenos_Aires|America/Buenos_Aires",
		"America/Argentina/Catamarca|America/Argentina/ComodRivadavia",
		"America/Argentina/Catamarca|America/Catamarca",
		"America/Argentina/Cordoba|America/Cordoba",
		"America/Argentina/Cordoba|America/Rosario",
		"America/Argentina/Jujuy|America/Jujuy",
		"America/Argentina/Mendoza|America/Mendoza",
		"America/Atikokan|America/Coral_Harbour",
		"America/Chicago|US/Central",
		"America/Curacao|America/Aruba",
		"America/Curacao|America/Kralendijk",
		"America/Curacao|America/Lower_Princes",
		"America/Denver|America/Shiprock",
		"America/Denver|Navajo",
		"America/Denver|US/Mountain",
		"America/Detroit|US/Michigan",
		"America/Edmonton|Canada/Mountain",
		"America/Fort_Wayne|America/Indiana/Indianapolis",
		"America/Fort_Wayne|America/Indianapolis",
		"America/Fort_Wayne|US/East-Indiana",
		"America/Halifax|Canada/Atlantic",
		"America/Havana|Cuba",
		"America/Indiana/Knox|America/Knox_IN",
		"America/Indiana/Knox|US/Indiana-Starke",
		"America/Jamaica|Jamaica",
		"America/Kentucky/Louisville|America/Louisville",
		"America/Los_Angeles|US/Pacific",
		"America/Los_Angeles|US/Pacific-New",
		"America/Manaus|Brazil/West",
		"America/Mazatlan|Mexico/BajaSur",
		"America/Mexico_City|Mexico/General",
		"America/New_York|US/Eastern",
		"America/Noronha|Brazil/DeNoronha",
		"America/Panama|America/Cayman",
		"America/Phoenix|US/Arizona",
		"America/Port_of_Spain|America/Anguilla",
		"America/Port_of_Spain|America/Antigua",
		"America/Port_of_Spain|America/Dominica",
		"America/Port_of_Spain|America/Grenada",
		"America/Port_of_Spain|America/Guadeloupe",
		"America/Port_of_Spain|America/Marigot",
		"America/Port_of_Spain|America/Montserrat",
		"America/Port_of_Spain|America/St_Barthelemy",
		"America/Port_of_Spain|America/St_Kitts",
		"America/Port_of_Spain|America/St_Lucia",
		"America/Port_of_Spain|America/St_Thomas",
		"America/Port_of_Spain|America/St_Vincent",
		"America/Port_of_Spain|America/Tortola",
		"America/Port_of_Spain|America/Virgin",
		"America/Regina|Canada/East-Saskatchewan",
		"America/Regina|Canada/Saskatchewan",
		"America/Rio_Branco|America/Porto_Acre",
		"America/Rio_Branco|Brazil/Acre",
		"America/Santiago|Chile/Continental",
		"America/Sao_Paulo|Brazil/East",
		"America/St_Johns|Canada/Newfoundland",
		"America/Tijuana|America/Ensenada",
		"America/Tijuana|America/Santa_Isabel",
		"America/Tijuana|Mexico/BajaNorte",
		"America/Toronto|America/Montreal",
		"America/Toronto|Canada/Eastern",
		"America/Vancouver|Canada/Pacific",
		"America/Whitehorse|Canada/Yukon",
		"America/Winnipeg|Canada/Central",
		"Asia/Ashgabat|Asia/Ashkhabad",
		"Asia/Bangkok|Asia/Phnom_Penh",
		"Asia/Bangkok|Asia/Vientiane",
		"Asia/Dhaka|Asia/Dacca",
		"Asia/Dubai|Asia/Muscat",
		"Asia/Ho_Chi_Minh|Asia/Saigon",
		"Asia/Hong_Kong|Hongkong",
		"Asia/Jerusalem|Asia/Tel_Aviv",
		"Asia/Jerusalem|Israel",
		"Asia/Kathmandu|Asia/Katmandu",
		"Asia/Kolkata|Asia/Calcutta",
		"Asia/Kuala_Lumpur|Asia/Singapore",
		"Asia/Kuala_Lumpur|Singapore",
		"Asia/Macau|Asia/Macao",
		"Asia/Makassar|Asia/Ujung_Pandang",
		"Asia/Nicosia|Europe/Nicosia",
		"Asia/Qatar|Asia/Bahrain",
		"Asia/Rangoon|Asia/Yangon",
		"Asia/Riyadh|Asia/Aden",
		"Asia/Riyadh|Asia/Kuwait",
		"Asia/Seoul|ROK",
		"Asia/Shanghai|Asia/Chongqing",
		"Asia/Shanghai|Asia/Chungking",
		"Asia/Shanghai|Asia/Harbin",
		"Asia/Shanghai|PRC",
		"Asia/Taipei|ROC",
		"Asia/Tehran|Iran",
		"Asia/Thimphu|Asia/Thimbu",
		"Asia/Tokyo|Japan",
		"Asia/Ulaanbaatar|Asia/Ulan_Bator",
		"Asia/Urumqi|Asia/Kashgar",
		"Atlantic/Faroe|Atlantic/Faeroe",
		"Atlantic/Reykjavik|Iceland",
		"Atlantic/South_Georgia|Etc/GMT+2",
		"Australia/Adelaide|Australia/South",
		"Australia/Brisbane|Australia/Queensland",
		"Australia/Broken_Hill|Australia/Yancowinna",
		"Australia/Darwin|Australia/North",
		"Australia/Hobart|Australia/Tasmania",
		"Australia/Lord_Howe|Australia/LHI",
		"Australia/Melbourne|Australia/Victoria",
		"Australia/Perth|Australia/West",
		"Australia/Sydney|Australia/ACT",
		"Australia/Sydney|Australia/Canberra",
		"Australia/Sydney|Australia/NSW",
		"Etc/GMT+0|Etc/GMT",
		"Etc/GMT+0|Etc/GMT-0",
		"Etc/GMT+0|Etc/GMT0",
		"Etc/GMT+0|Etc/Greenwich",
		"Etc/GMT+0|GMT",
		"Etc/GMT+0|GMT+0",
		"Etc/GMT+0|GMT-0",
		"Etc/GMT+0|GMT0",
		"Etc/GMT+0|Greenwich",
		"Etc/UCT|UCT",
		"Etc/UTC|Etc/Universal",
		"Etc/UTC|Etc/Zulu",
		"Etc/UTC|UTC",
		"Etc/UTC|Universal",
		"Etc/UTC|Zulu",
		"Europe/Belgrade|Europe/Ljubljana",
		"Europe/Belgrade|Europe/Podgorica",
		"Europe/Belgrade|Europe/Sarajevo",
		"Europe/Belgrade|Europe/Skopje",
		"Europe/Belgrade|Europe/Zagreb",
		"Europe/Chisinau|Europe/Tiraspol",
		"Europe/Dublin|Eire",
		"Europe/Helsinki|Europe/Mariehamn",
		"Europe/Istanbul|Asia/Istanbul",
		"Europe/Istanbul|Turkey",
		"Europe/Lisbon|Portugal",
		"Europe/London|Europe/Belfast",
		"Europe/London|Europe/Guernsey",
		"Europe/London|Europe/Isle_of_Man",
		"Europe/London|Europe/Jersey",
		"Europe/London|GB",
		"Europe/London|GB-Eire",
		"Europe/Moscow|W-SU",
		"Europe/Oslo|Arctic/Longyearbyen",
		"Europe/Oslo|Atlantic/Jan_Mayen",
		"Europe/Prague|Europe/Bratislava",
		"Europe/Rome|Europe/San_Marino",
		"Europe/Rome|Europe/Vatican",
		"Europe/Warsaw|Poland",
		"Europe/Zurich|Europe/Busingen",
		"Europe/Zurich|Europe/Vaduz",
		"Indian/Christmas|Etc/GMT-7",
		"Pacific/Auckland|Antarctica/McMurdo",
		"Pacific/Auckland|Antarctica/South_Pole",
		"Pacific/Auckland|NZ",
		"Pacific/Chatham|NZ-CHAT",
		"Pacific/Easter|Chile/EasterIsland",
		"Pacific/Guam|Pacific/Saipan",
		"Pacific/Honolulu|Pacific/Johnston",
		"Pacific/Honolulu|US/Hawaii",
		"Pacific/Kwajalein|Kwajalein",
		"Pacific/Pago_Pago|Pacific/Midway",
		"Pacific/Pago_Pago|Pacific/Samoa",
		"Pacific/Pago_Pago|US/Samoa",
		"Pacific/Palau|Etc/GMT-9",
		"Pacific/Pohnpei|Etc/GMT-11",
		"Pacific/Pohnpei|Pacific/Ponape",
		"Pacific/Port_Moresby|Etc/GMT-10",
		"Pacific/Port_Moresby|Pacific/Chuuk",
		"Pacific/Port_Moresby|Pacific/Truk",
		"Pacific/Port_Moresby|Pacific/Yap",
		"Pacific/Tarawa|Etc/GMT-12",
		"Pacific/Tarawa|Pacific/Funafuti",
		"Pacific/Tarawa|Pacific/Wake",
		"Pacific/Tarawa|Pacific/Wallis"
	]
};

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(1));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else if(typeof exports === 'object')
		exports["shared-components"] = factory(require("react"));
	else
		root["shared-components"] = factory(root["react"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	__webpack_require__(2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var NumberPicker = function (_React$Component) {
		_inherits(NumberPicker, _React$Component);

		function NumberPicker(props) {
			_classCallCheck(this, NumberPicker);

			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(NumberPicker).call(this, props));

			_this.MAX_VALUE = _this.maxValue();
			return _this;
		}

		_createClass(NumberPicker, [{
			key: "maxValue",
			value: function maxValue() {
				var str_max = "";
				for (var i = 0; i < this.props.digits; i++) {
					str_max += "9";
				}if (this.props.showDecimal) str_max += ".99";
				return parseFloat(str_max);
			}
		}, {
			key: "digitInteger",
			value: function digitInteger(ltr_digit) {
				var sValue = this.props.value.toString();
				var a_sValue = sValue.split(".");
				var integer = a_sValue[0];

				var rtl_digit = this.props.digits - (ltr_digit - 1);

				if (rtl_digit > integer.length) return "0";

				return integer[integer.length - rtl_digit];
			}
		}, {
			key: "digitDecimal",
			value: function digitDecimal(ltr_digit) {
				var sValue = this.props.value.toString();
				var a_sValue = sValue.split(".");
				var decimal = a_sValue.length > 1 && a_sValue[1].length > 0 ? a_sValue[1] : "00";
				if (decimal.length > 2) decimal = decimal.substr(0, 2);
				if (decimal.length < 2) decimal = decimal + "0";

				return decimal[ltr_digit - 1];
			}
		}, {
			key: "modifyValue",
			value: function modifyValue(type, value, event) {
				event.preventDefault();
				if (!this.props.onChange) return;
				var value_to_add = type === "down" ? value * -1 : value;
				var new_value = this.props.value + value_to_add;

				/* adjust float operations */
				var str_new_value = this.props.showDecimal ? new_value.toFixed(2) : new_value.toFixed(0);

				var adjusted_new_value = parseFloat(str_new_value);

				/* dont work with negative values, YET */
				if (adjusted_new_value < 0) adjusted_new_value = 0;

				/* prevent from exceed maximum possible values */
				if (adjusted_new_value > this.MAX_VALUE) adjusted_new_value = this.MAX_VALUE;

				this.props.onChange(adjusted_new_value);
			}
		}, {
			key: "renderButtons",
			value: function renderButtons(type) {

				var elements = [];

				/* display an invisible cell */
				if (this.props.currency) {
					elements.push(_react2.default.createElement("div", { key: "currency", className: "NumberPicker__cell button" }));
				}

				/* display tob/bottom buttons */
				for (var i = 0; i < this.props.digits; i++) {
					var value_to_add = Math.pow(10, this.props.digits - i - 1);
					elements.push(_react2.default.createElement(
						"div",
						{ key: "integer-" + i, className: "NumberPicker__cell button " + type },
						_react2.default.createElement("span", { className: type, onClick: this.modifyValue.bind(this, type, value_to_add) })
					));
				}

				/* display invisible cell to decimal separator and tob/bottom buttons for decimals */
				if (this.props.showDecimal) {
					elements.push(_react2.default.createElement("div", { key: "decimal-separator", className: "NumberPicker__cell decimal-separator" }));
					elements.push(_react2.default.createElement(
						"div",
						{ key: "decimal-1", className: "NumberPicker__cell button " + type },
						_react2.default.createElement("span", { className: type, onClick: this.modifyValue.bind(this, type, 0.1) })
					));
					elements.push(_react2.default.createElement(
						"div",
						{ key: "decimal-2", className: "NumberPicker__cell button " + type },
						_react2.default.createElement("span", { className: type, onClick: this.modifyValue.bind(this, type, 0.01) })
					));
				}

				return elements;
			}
		}, {
			key: "renderDigits",
			value: function renderDigits() {
				var elements = [];

				if (this.props.currency) {
					elements.push(_react2.default.createElement(
						"div",
						{ key: "currency", className: "NumberPicker__cell currency" },
						_react2.default.createElement(
							"span",
							{ className: "currency" },
							this.props.currency
						)
					));
				}

				for (var i = 0; i < this.props.digits; i++) {
					var digit = i + 1;
					elements.push(_react2.default.createElement(
						"div",
						{ key: digit, className: "NumberPicker__cell digit" },
						_react2.default.createElement(
							"span",
							{ className: "digit" },
							this.digitInteger(digit)
						)
					));
				}

				if (this.props.showDecimal) {
					elements.push(_react2.default.createElement(
						"div",
						{ key: "decimal-separator", className: "NumberPicker__cell decimal-separator" },
						_react2.default.createElement(
							"span",
							{ className: "decimal-separator" },
							this.props.decimalSeparator
						)
					));
					elements.push(_react2.default.createElement(
						"div",
						{ key: "decimal-1", className: "NumberPicker__cell digit" },
						_react2.default.createElement(
							"span",
							{ className: "digit" },
							this.digitDecimal(1)
						)
					));
					elements.push(_react2.default.createElement(
						"div",
						{ key: "decimal-2", className: "NumberPicker__cell digit" },
						_react2.default.createElement(
							"span",
							{ className: "digit" },
							this.digitDecimal(2)
						)
					));
				}

				return elements;
			}
		}, {
			key: "render",
			value: function render() {

				return _react2.default.createElement(
					"div",
					{ className: "NumberPicker__wrapper" },
					_react2.default.createElement(
						"div",
						{ className: "NumberPicker__table" },
						_react2.default.createElement(
							"div",
							{ className: "NumberPicker__row" },
							this.renderButtons("up")
						),
						_react2.default.createElement(
							"div",
							{ className: "NumberPicker__row" },
							this.renderDigits()
						),
						_react2.default.createElement(
							"div",
							{ className: "NumberPicker__row" },
							this.renderButtons("down")
						)
					)
				);
			}
		}]);

		return NumberPicker;
	}(_react2.default.Component);

	NumberPicker.propTypes = {
		onChange: _react2.default.PropTypes.func,
		digits: _react2.default.PropTypes.number.isRequired,
		currency: _react2.default.PropTypes.string,
		value: _react2.default.PropTypes.number.isRequired,
		showDecimal: _react2.default.PropTypes.bool.isRequired,
		decimalSeparator: _react2.default.PropTypes.string.isRequired
	};

	NumberPicker.defaultProps = {
		digits: 1,
		currency: null,
		value: 0.00,
		decimalSeparator: ".",
		showDecimal: false
	};

	exports.default = NumberPicker;

/***/ },
/* 1 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ },
/* 2 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }
/******/ ])
});
;

/***/ }),
/* 652 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 653 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var stub = __webpack_require__(655);
var parse = __webpack_require__(312);
var tracking = __webpack_require__(656);
var ls = 'localStorage' in global && global.localStorage ? global.localStorage : stub;

function accessor (key, value) {
  if (arguments.length === 1) {
    return get(key);
  }
  return set(key, value);
}

function get (key) {
  const raw = ls.getItem(key);
  const parsed = parse(raw);
  return parsed;
}

function set (key, value) {
  try {
    ls.setItem(key, JSON.stringify(value));
    return true;
  } catch (e) {
    return false;
  }
}

function remove (key) {
  return ls.removeItem(key);
}

function clear () {
  return ls.clear();
}

function backend (store) {
  store && (ls = store);

  return ls;
}

accessor.set = set;
accessor.get = get;
accessor.remove = remove;
accessor.clear = clear;
accessor.backend = backend;
accessor.on = tracking.on;
accessor.off = tracking.off;

module.exports = accessor;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ms = {};

function getItem (key) {
  return key in ms ? ms[key] : null;
}

function setItem (key, value) {
  ms[key] = value;
  return true;
}

function removeItem (key) {
  var found = key in ms;
  if (found) {
    return delete ms[key];
  }
  return false;
}

function clear () {
  ms = {};
  return true;
}

module.exports = {
  getItem: getItem,
  setItem: setItem,
  removeItem: removeItem,
  clear: clear
};


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var parse = __webpack_require__(312);
var listeners = {};
var listening = false;

function listen () {
  if (global.addEventListener) {
    global.addEventListener('storage', change, false);
  } else if (global.attachEvent) {
    global.attachEvent('onstorage', change);
  } else {
    global.onstorage = change;
  }
}

function change (e) {
  if (!e) {
    e = global.event;
  }
  var all = listeners[e.key];
  if (all) {
    all.forEach(fire);
  }

  function fire (listener) {
    listener(parse(e.newValue), parse(e.oldValue), e.url || e.uri);
  }
}

function on (key, fn) {
  if (listeners[key]) {
    listeners[key].push(fn);
  } else {
    listeners[key] = [fn];
  }
  if (listening === false) {
    listen();
  }
}

function off (key, fn) {
  var ns = listeners[key];
  if (ns.length > 1) {
    ns.splice(ns.indexOf(fn), 1);
  } else {
    listeners[key] = [];
  }
}

module.exports = {
  on: on,
  off: off
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {/*
	meSpeak  v.1.9.6
	based on speak.js, https://github.com/kripken/speak.js
	eSpeak and other code here are under the GNU GPL.
	meSpeak (Modular eSpeak) is a mod of 'speak.js' by N.Landsteiner (2011-2014), www.masswerk.at
	adding support for Webkit/Safari and external voice-modules
	v.1.1 and later default to play via the Web Audio API and uses the HTMLAudioElement as a second option.
	official project page: http://www.masswerk.at/mespeak
*/


var ESpeak = __webpack_require__(662)

/* meScript.js essential changes start here */

var eSpeakDir = '/espeak',
	eSpeakDataDir = '/espeak/espeak-data',
	eSpeakVoicesDir = '/espeak/espeak-data/voices',
	eSpeak = new ESpeak(),
	fileRegistry = [],
	fsErrorDetected = false,
	configDataLoaded = false,
	unloading = false,
	speakQueue = [],
	voicesLoaded = {},
	defaultVoice = '',
	AudioAPI = null,
	canPlay = false,
	playbackVolume = 1,
	masterGain = null,
	audioContext = null,
	audioPool = {},
	webSoundPool = {},
	isChrome = ((typeof navigator !== 'undefined') && navigator.userAgent && navigator.userAgent.indexOf('Chrome') !== -1),
	chromeVersion = (isChrome) ? parseInt(navigator.userAgent.replace(/^.*?\bChrome\/([0-9]+).*$/, '$1'), 10) : 0;

function fsCreateDataFile(path, fname, data, doNotRegister) {
	if (!eSpeak.FS.findObject(path)) eSpeak.FS.createPath('/', path.substring(1), true, true);
	eSpeak.FS.createDataFile(path, fname, data, true, false);
	if (!doNotRegister) fileRegistry.push({
		path: path,
		fname: fname
	});
}

// work around a emscripten FS-bug causing the engine to stop at some iteration (80th call)
// simply create a new instance and reload any files
function recoverFromFSError(message) {
	console.log('meSpeak -- recovering from error:', message);
	// save any loaded files from broken instance
	var files = [],
		f, i, l = fileRegistry.length;
	for (i = 0; i < l; i++) {
		f = fileRegistry[i];
		files.push(eSpeak.FS.findObject(f.path + '/' + f.fname).contents);
	}
	// reboot to a new instance and insert any loaded files
	eSpeak = new ESpeak();
	setUpVFS();
	for (i = 0; i < l; i++) {
		f = fileRegistry[i];
		fsCreateDataFile(f.path, f.fname, files[i], true);
	}
	fsErrorDetected = true;
}

// basic FS setup, for config data see setConfigData(), for voices see setVoiceData()
function setUpVFS() {
	var optionFiles = {
		'croak': 'language variant\nname croak\ngender male 70\npitch 85 117\nflutter 20\nformant 0 100 80 110\n',
		'f1': 'language variant\nname female1\ngender female 70\npitch 140 200\nflutter 8\nroughness 4\nformant 0 115 80 150\nformant 1 120 80 180\nformant 2 100 70 150 150\nformant 3 115 70 150\nformant 4 110 80 150\nformant 5 110 90 150\nformant 6 105 80 150\nformant 7 110 70 150\nformant 8 110 70 150\nstressAdd -10 -10 -20 -20 0 0 40 60\n',
		'f2': 'language variant\nname female2\ngender female\npitch 142 220\nroughness 3\nformant 0 105 80 150\nformant 1 110 80 160\nformant 2 110 70 150\nformant 3 110 70 150\nformant 4 115 80 150\nformant 5 115 80 150\nformant 6 110 70 150\nformant 7 110 70 150\nformant 8 110 70 150\nstressAdd 0 0 -10 -10 0 0 10 40\nbreath 0 2 3 3 3 3 3 2\necho 140 10\nconsonants 125 125\n',
		'f3': 'language variant\nname female3\ngender female\npitch 140 240\nformant 0 105 80 150\nformant 1 120 75 150 -50\nformant 2 135 70 150 -250\nformant 3 125 80 150\nformant 4 125 80 150\nformant 5 125 80 150\nformant 6 120 70 150\nformant 7 110 70 150\nformant 8 110 70 150\nstressAmp 18 18 20 20 20 20 20 20\n//breath 0 2 4 4 4 4 4 4\nbreath 0 2 3 3 3 3 3 2\necho 120 10\nroughness 4\n',
		'f4': 'language variant\nname female4\ngender female\necho 130 15\npitch 142 200\nformant 0 120 80 150\nformant 1 115 80 160 -20\nformant 2 130 75 150 -200\nformant 3 123 75 150\nformant 4 125 80 150\nformant 5 125 80 150\nformant 6 110 80 150\nformant 7 110 75 150\nformant 8 110 75 150\nstressAdd -20 -20 -20 -20 0 0 20 120\nstressAmp 18 16 20 20 20 20 20 20\n',
		'f5': 'language variant\nname female5\ngender female\npitch 160 228\nroughness 0\nformant 0 105 80 150\nformant 1 110 80 160\nformant 2 110 70 150\nformant 3 110 70 150\nformant 4 115 80 200\nformant 5 115 80 100\nformant 6 110 70 150\nformant 7 110 70 100\nformant 8 110 70 150\nstressAdd 0 0 -10 -10 0 0 10 40\nbreath 0 4 6   6 6   6 0 10\necho 140 10\nvoicing 75\nconsonants 150 150\nbreathw 150 150 200 200 400 400\n',
		'klatt': 'language variant\nname klatt\nklatt 1\n',
		'klatt2': 'language variant\nname klatt2\nklatt 2\n',
		'klatt3': 'language variant\nname klatt3\nklatt 3\n',
		'm1': 'language variant\nname male1\ngender male 70\npitch 75 109\nflutter 5\nroughness 4\nconsonants 80 100\nformant 0 98 100 100\nformant 1 97 100 100\nformant 2 97 95 100\nformant 3 97 95 100\nformant 4 97 85 100\nformant 5 105 80 100\nformant 6 95 80 100\nformant 7 100 100 100\nformant 8 100 100 100\n//stressAdd -10 -10 -20 -20 0 0 40 70\n',
		'm2': 'language variant\nname male2\ngender male\npitch 88 115\necho 130 15\nformant 0 100 80 120\nformant 1 90 85 120\nformant 2 110 85 120\nformant 3 105 90 120\nformant 4 100 90 120\nformant 5 100 90 120\nformant 6 100 90 120\nformant 7 100 90 120\nformant 8 100 90 120\n',
		'm3': 'language variant\nname male3\ngender male\npitch 80 122\nformant 0 100 100 100\nformant 1 96 97 100\nformant 2 96 97 100\nformant 3 96 103 100\nformant 4 95 103 100\nformant 5 95 103 100\nformant 6 100 100 100\nformant 7 100 100 100\nformant 8 100 100 100\nstressAdd 10 10 0 0 0 0 -30 -30\n',
		'm4': 'language variant\nname male4\ngender male\npitch 70 110\nformant 0 103 100 100\nformant 1 103 100 100\nformant 2 103 100 100\nformant 3 103 100 100\nformant 4 106 100 100\nformant 5 106 100 100\nformant 6 106 100 100\nformant 7 103 100 100\nformant 8 103 100 100\nstressAdd -10 -10 -30 -30 0 0 60 90\n',
		'm5': 'language variant\nname male5\ngender male\nformant 0 100 85 130\nformant 1 90 85 130 40\nformant 2 80 85 130 310\nformant 3 105 85 130\nformant 4 105 85 130\nformant 5 105 85 130\nformant 6 105 85 150\nformant 7 105 85 150\nformant 8 105 85 150\nintonation 2\n',
		'm6': 'language variant\nname male6\ngender male\npitch 82 117\nformant 0 100 90 120\nformant 1 100 90 140\nformant 2 100 70 140\nformant 3 100 75 140\nformant 4 100 80 140\nformant 5 100 80 140\n',
		'm7': 'language variant\nname male7\npitch 75 125\nformant 0 100 125 100\nformant 1 100 90 80\nformant 2 100 70 90\nformant 3 100 60 90\nformant 4 100 60 90\nformant 5 75 50 90\nformant 6 90 50 100\nformant 7 100 50 100\nformant 8 100 50 100\nvoicing 155\n',
		'whisper': 'language variant\nname whisper\npitch 75 125\nformant 0 100 125 100\nformant 1 100 90 80\nformant 2 100 70 90\nformant 3 100 60 90\nformant 4 100 60 90\nformant 5 75 50 90\nformant 6 90 50 100\nformant 7 100 50 100\nformant 8 100 50 100\nvoicing 155\n',
		'whisperf': 'language variant\nname female whisper\ngender female\npitch 160 220\nroughness 3\nformant 0 105 0 150\nformant 1 110 40 160\nformant 2 110 70 150\nformant 3 110 70 150\nformant 4 115 80 150\nformant 5 115 80 150\nformant 6 110 70 150\nformant 7 110 70 150\nformant 8 110 70 150\nstressAdd 0 0 -10 -10 0 0 10 40\n// whisper\nvoicing 20\nbreath 75 75 50 40 15 10\nbreathw 150 150 200 200 400 400\n'
	};
	var dir = eSpeakVoicesDir + '/!v';
	eSpeak.FS.createPath('/', dir.substring(1), true, true);
	eSpeak.FS.root.write = true;
	for (var fn in optionFiles) {
		eSpeak.FS.createDataFile(dir, fn, decodeStringToArray(optionFiles[fn]), true, true);
	}
}
if (eSpeak && eSpeak.FS) setUpVFS();

function setConfigData(data) {
	[
		['config', decodeBase64ToArray(data.config)],
		['phontab', decodeBase64ToArray(data.phontab)],
		['phonindex', decodeBase64ToArray(data.phonindex)],
		['phondata', decodeBase64ToArray(data.phondata)],
		['intonations', decodeBase64ToArray(data.intonations)]
	].forEach(function(pair) {
		var id = pair[0];
		var data = pair[1];
		fsCreateDataFile(eSpeakDataDir, id, data);
	});
	configDataLoaded = true;
	// inspect data for an optional default-voice
	var voice = data.voice;
	if (typeof voice == 'object' && typeof voice.voice_id == 'string' && typeof voice.dict_id == 'string' && typeof voice.dict == 'string' && typeof voice.voice == 'string') {
		setVoiceData(voice);
	}
	executeQueuedCalls();
}

function setVoiceData(data) {
	var parts, path, fname, f;
	if (!voicesLoaded[data.voice_id]) {
		if (data.dict_id && !eSpeak.FS.findObject(eSpeakDataDir + '/' + data.dict_id)) fsCreateDataFile(eSpeakDataDir, data.dict_id, decodeBase64ToArray(data.dict));
		parts = data.voice_id.split('/');
		path = eSpeakVoicesDir;
		if (parts.length > 1) {
			path += '/' + parts.slice(0, parts.length - 1).join('/');
		}
		fname = parts[parts.length - 1];
		if (data.voice_encoding == 'text') {
			fsCreateDataFile(path, fname, decodeStringToArray(data.voice));
		} else {
			fsCreateDataFile(path, fname, decodeBase64ToArray(data.voice));
		}
		if (data.files && Array.isArray(data.files)) {
			for (var i = 0, l = data.files.length; i < l; i++) {
				f = data.files[i];
				if (typeof f == 'object' && typeof f.path == 'string' && f.path.length && typeof f.data == 'string' && f.data.length) {
					parts = f.path.split('/');
					if (parts.length > 1) {
						path = eSpeakDataDir + '/' + parts.slice(0, parts.length - 1).join('/');
					} else {
						path = eSpeakDataDir;
					}
					fname = parts[parts.length - 1];
					if (f.encoding == 'text') {
						fsCreateDataFile(path, fname, decodeStringToArray(f.data));
					} else {
						fsCreateDataFile(path, fname, decodeBase64ToArray(f.data));
					}
				}
			}
		}
		voicesLoaded[data.voice_id] = true;
	}
	setDefaultVoice(data.voice_id);
	executeQueuedCalls();
}

function decodeBase64ToArray(str) {
	function f(c) {
		if (c == 43) {
			return 62; // "+"
		} else if (c == 47) {
			return 63; // "/"
		} else if (c == 61) {
			return 64; // "="
		} else if (c <= 57) {
			return c + 4; // "0".."9"
		} else if (c <= 90) {
			return c - 65; // "A".."Z"
		} else {
			return c - 71; // "a".."z"
		}
	}
	var h1, h2, h3, h4, out = [],
		i = 0,
		l = str.length;
	while (i < l) {
		h1 = f(str.charCodeAt(i++));
		h2 = f(str.charCodeAt(i++));
		h3 = f(str.charCodeAt(i++));
		h4 = f(str.charCodeAt(i++));
		out.push((h1 << 2) | (h2 >> 4));
		if (h3 != 64) out.push(((h2 & 15) << 4) | (h3 >> 2));
		if (h4 != 64) out.push(((h3 & 3) << 6) | h4);
	}
	return out;
}

function encode64(data) {
	var BASE = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
	var PAD = '=';
	var ret = '';
	var leftchar = 0;
	var leftbits = 0;
	for (var i = 0, l = data.length; i < l; i++) {
		leftchar = (leftchar << 8) | data[i];
		leftbits += 8;
		while (leftbits >= 6) {
			var curr = (leftchar >> (leftbits - 6)) & 0x3f;
			leftbits -= 6;
			ret += BASE[curr];
		}
	}
	if (leftbits == 2) {
		ret += BASE[(leftchar & 3) << 4];
		ret += PAD + PAD;
	} else if (leftbits == 4) {
		ret += BASE[(leftchar & 0xf) << 2];
		ret += PAD;
	}
	return ret;
}

function decodeStringToArray(str) {
	var out = [],
		l = str.length,
		i;
	for (i = 0; i < l; i++) out.push(str.charCodeAt(i));
	return out;
}

function executeQueuedCalls() {
	// execute any defered calls to speak()
	if (configDataLoaded && defaultVoice) {
		for (var i = 0, l = speakQueue.length; i < l; i++) {
			var args = speakQueue[i];
			if (args[3].multipart) {
				speakMultipart(args[0], args[1], args[2], args[3]);
			} else {
				speak(args[0], args[1], args[2], args[3]);
			}
		}
		speakQueue.length = 0;
	}
}

function resetQueue() {
	// public
	speakQueue.length = 0;
}

function speak(text, args, callback, _id) {
	// public
	// returns:
	// with option "rawdata": stream-object in specified format (or null on failure)
	// default: returns numeric 32bit id (or 0 on failure)
	if (typeof args !== 'object') args = {};
	if (!canPlay && !args.rawdata) {
		console.warn('meSpeak: Can\'t play; No audio support.');
		return 0;
	}
	if (!_id || !isValidJobId(_id)) _id = getJobId();
	if (!configDataLoaded || !defaultVoice) {
		console.warn(((!configDataLoaded) ? 'No config-data loaded' : 'No voice module loaded') + ', deferring call.');
		if (args.rawdata) {
			return null;
		} else {
			speakQueue.push([text, args, callback, _id]);
			return _id.number;
		}
	}
	if (args && args.voice && !voicesLoaded[args.voice]) {
		console.warn('Voice ' + args.voice + ' not available. Using default voice: ' + defaultVoice);
	}
	var varg = (args.voice) ? String(args.voice) : (args.v) ? String(args.v) : defaultVoice;
	if (varg.indexOf('mb/mb-') == 0) varg = varg.substring(3);
	if (args.variant) varg += '+' + String(args.variant).replace(/\+/g, '');
	var argstack = [
		'-w', 'wav.wav',
		'-a', args.amplitude !== undefined ? String(args.amplitude) : args.a !== undefined ? String(args.a) : '100',
		'-g', args.wordgap !== undefined ? String(args.wordgap) : args.g !== undefined ? String(args.g) : '0',
		'-p', args.pitch !== undefined ? String(args.pitch) : args.p !== undefined ? String(args.p) : '50',
		'-s', args.speed !== undefined ? String(args.speed) : args.s !== undefined ? String(args.s) : '175',
		'-b', args.utf16 ? '4' : args.b !== undefined ? String(args.b) : '1',
		'-v', varg
	];
	var a = args.linebreak || args.l;
	if (a) argstack.push('-l', String(a));
	a = args.capitals || args.k;
	if (a) argstack.push('-k', String(a));
	a = args.nostop || args.z;
	if (a) argstack.push('-z');
	if (args.punct !== undefined) {
		if (typeof args.punct == 'string') {
			if (args.punct.length) {
				argstack.push('--punct="' + String(args.punct).replace(/([\\"'])/g, '\\$1') + '"');
			} else {
				argstack.push('--punct');
			}
		} else if (args.punct) {
			argstack.push('--punct');
		}
	}
	a = args.ssml || args.m || args.markup;
	if (a) argstack.push('-m');
	argstack.push('--path=' + eSpeakDir, String(text));
	if (args.log && self.console) console.log('executing espeak ' + argstack.join(' '));
	eSpeak.Module.arguments = argstack;

	if (typeof callback != 'function') callback = undefined;
	if (!callback && typeof args.callback == 'function') callback = args.callback;

	fsErrorDetected = false;
	eSpeak.run();
	if (fsErrorDetected) {
		// eSpeak breaks sometimes on flushing streams, approx. every 80th call
		fsErrorDetected = false;
		eSpeak.Module.arguments = argstack;
		eSpeak.run();
	}

	var outfile = eSpeak.FS.root.contents['wav.wav'].contents,
		wav = unsignedStream(outfile);
	outfile.length = 0;
	argstack = null;

	return (args.rawdata) ? exportStream(wav, args.rawdata) : playSound(wav, args.volume, callback, _id);
}

function exportStream(stream, format) {
	// private
	switch (String(format).toLowerCase()) {
		case 'array':
			return stream;
		case 'base64':
			return encode64(stream);
		case 'buffer':
			return new Buffer(stream);
		case 'data-url':
		case 'data-uri':
		case 'dataurl':
		case 'datauri':
		case 'mime':
			return 'data:audio/x-wav;base64,' + encode64(stream);
		default:
			var buffer = new ArrayBuffer(stream.length);
			new Uint8Array(buffer).set(stream);
			return buffer;
	}
}

function speakMultipart(parts, args, callback, _id) {
	// public
	// returns:
	// with option "rawdata": stream-object in specified format (or null on failure)
	// default: returns numeric 32bit id (or 0 on failure)
	if (typeof args !== 'object') args = {};
	if (!canPlay && !args.rawdata) {
		console.warn('meSpeak: Can\'t play; No audio support.');
		return 0;
	}
	var failed = false;
	if (typeof callback != 'function') callback = undefined;
	if (!callback && typeof args.callback == 'function') callback = args.callback;
	if (Object.prototype.toString.call(parts) != '[object Array]' || !parts.length) {
		console.warn('meSpeak.speakMultipart: First argument must be an array of objects.');
		failed = true;
	}
	if (!failed) {
		for (var i = 0, l = parts.length; i < l; i++) {
			if (typeof parts[i] != 'object') {
				console.warn('meSpeak.speakMultipart: First argument must be an array of objects (part #' + i + ').');
				failed = true;
				break;
			}
		}
	}
	if (failed) {
		if (args.rawdata) {
			return null;
		} else {
			if (callback) callback(false);
			return 0;
		}
	}
	if (!_id || !isValidJobId(_id)) _id = getJobId();
	if (!configDataLoaded || !defaultVoice) {
		console.warn(((!configDataLoaded) ? 'No config-data loaded' : 'No voice module loaded') + ', deferring call.');
		if (args.rawdata) {
			return null;
		} else {
			_id.multipart = true;
			speakQueue.push([parts, args, callback, _id]);
			return _id.number;
		}
	}
	// everything ok, now actually do it
	var wav, sampleLength;
	// loop over the parts
	for (var i = 0, l = parts.length; i < l; i++) {
		var n, part = parts[i],
			opts = {};
		for (n in args) opts[n] = args[n];
		for (n in part) opts[n] = part[n];
		opts.rawdata = 'array';
		opts.callback = undefined;
		var buffer = meSpeak.speak(part.text, opts);
		if (!buffer) {
			if (args.rawdata) {
				return null;
			} else {
				if (callback) callback(false);
				return 0;
			}
		}
		if (i == 0) {
			// first: store it and extract the sample length
			wav = buffer;
			sampleLength = readBytes(buffer, 40, 4);
		} else {
			// extract the sample length and add it
			sampleLength += readBytes(buffer, 40, 4);
			// strip header and append samples
			wav = wav.concat(buffer.slice(44));
		}
		buffer = null;
	}
	// fix up the sample length (pos 4 and pos 40 in header)
	writeBytes(wav, 4, 4, sampleLength);
	writeBytes(wav, 40, 4, sampleLength);
	// export/play it
	return (args.rawdata) ? exportStream(wav, args.rawdata) : playSound(wav, args.volume, callback, _id);
}

function writeBytes(f, p, n, value) {
	// private: write bytes to a file, least significant first
	while (n) {
		f[p++] = value & 0xff;
		value = value >> 8;
		n--;
	}
}

function readBytes(f, p, n) {
	// private: read bytes from a file, least significant first
	var value = 0,
		shft = 0;
	while (n) {
		value |= f[p++] << shft;
		shft += 8;
		n--;
	}
	return value;
}

function unsignedStream(wav) {
	// private
	var i, l = wav.length,
		v, out = new Array(l);
	for (i = 0; i < l; i++) {
		v = wav[i];
		out[i] = (v >= 0) ? v : 256 + v;
	}
	return out;
}

function getJobId() {
	// private
	var n, s;
	while (!n || audioPool[s] || webSoundPool[s]) {
		n = Math.floor(Math.random() * Math.pow(2, 32));
		s = n.toString(16);
	}
	return {
		number: n,
		string: s
	}
}

function isValidJobId(id) {
	// private
	return !(Object.prototype.toString.call(id) !== '[object Object]' || Object.prototype.toString.call(id.number) !== '[object Number]' || Object.prototype.toString.call(id.string) !== '[object String]' || !id.number || id.string !== id.number.toString(16));
}

function playSound(stream, relVolume, callback, _id) {
	// public (play): play a wav-stream or an ArrayBuffer generated using option 'rawdata'
	// returns numeric 32bit id (or 0 on failure)
	if (callback && (typeof callback != 'function')) callback = undefined;
	if (!_id || !isValidJobId(_id)) _id = getJobId();
	var streamType = Object.prototype.toString.call(stream);
	if (!(streamType == '[object Array]' || streamType == '[object ArrayBuffer]' || streamType == '[object String]')) {
		console.warn('meSpeak: Can\'t play, not an Array, or ArrayBuffer, or base64-String: ' + streamType);
		if (callback) callback(false);
		return 0;
	}
	if (relVolume !== undefined) {
		relVolume = parseFloat(relVolume);
		if (isNaN(relVolume) || relVolume < 0 || relVolume > 1) relVolume = undefined;
	}
	if (AudioAPI) {
		if (streamType == '[object String]') {
			if (stream.indexOf('data:audio/x-wav;base64,', 0) == 0) stream = stream.substring(24);
			stream = stream.replace(/=+$/, '');
			if (stream.match(/[^A-Za-z0-9\+\/]/)) {
				console.warn('meSpeak: Can\'t play, not a proper base64-String.');
				if (callback) callback(false);
				return 0;
			}
			stream = decodeBase64ToArray(stream);
			if (!stream.length) {
				console.warn('meSpeak: Can\'t play, empty sound data.');
				if (callback) callback(false);
				return 0;
			}
			streamType = '[object Array]';
		}
		var buffer;
		if (streamType == '[object Array]') {
			var buffer = new ArrayBuffer(stream.length);
			new Uint8Array(buffer).set(stream);
		} else {
			buffer = stream;
		}
		return playWebSound(buffer, relVolume, callback, _id);
	} else if (canPlay) {
		var isDataUrl = false;
		if (streamType == '[object String]') {
			if (stream.indexOf('data:audio/x-wav;base64,', 0) < 0) {
				if (stream.match(/[^A-Za-z0-9\+\/]/)) {
					console.warn('meSpeak: Can\'t play, not a proper base64-String.');
					if (callback) callback(false);
					return 0;
				}
				stream = 'data:audio/x-wav;base64,' + stream;
			}
			isDataUrl = true;
		} else if (streamType == '[object ArrayBuffer]') {
			stream = new Uint8Array(stream);
		}
		return (new AudioPlayback(stream, relVolume, isDataUrl, callback, _id).started) ? _id.number : 0;
	} else {
		console.warn('meSpeak: Can\'t play; No audio support.');
		if (callback) callback(false);
		return 0;
	}
}

// public meSpeak.stop()
// takes IDs returned by meSpeak.speak() and/or meSpeak.play as arguments
// if called whitout an argument, all sounds will be stopped.
// returns the number of sounds stopped
function stopSound() {
	var id, i, k, kl, l, item, n, stopped = 0;
	if (arguments.length > 0) {
		// stop specific sounds (by numeric 32bit id)
		for (i = 0, l = arguments.length; i < l; i++) {
			n = parseInt(arguments[i]);
			if (n && !isNaN(n)) {
				id = n.toString(16);
				if (audioPool[id]) {
					audioPool[id].stop();
					stopped++;
				} else if (webSoundPool[id]) {
					stopWebSound(webSoundPool[id]);
					stopped++;
				} else {
					for (k = 0, kl = speakQueue.length; k < kl; k++) {
						item = speakQueue[i];
						if (item[3].string === id) {
							if (!unloading && typeof item[2] == 'function') item[2](false);
							speakQueue.splice(k, 1);
							stopped++;
							break;
						}
					}
				}
			}
		}
	} else {
		// stop all sounds
		for (id in audioPool) {
			audioPool[id].stop();
			stopped++;
		}
		for (id in webSoundPool) {
			stopWebSound(webSoundPool[id]);
			stopped++;
		}
		for (i = 0, l = speakQueue.length; i < l; i++) {
			item = speakQueue[i];
			if (!unloading && typeof item[2] == 'function') item[2](false);
			stopped++;
		}
		speakQueue.length = 0;
	}
	return stopped;
}

function setVolume(vol) {
	// public, sets master volume (no arguments) or rel volume for provided ids
	var id, i, l, n, v;
	v = parseFloat(vol);
	if (!isNaN(v) && v >= 0 && v <= 1 && v != playbackVolume) {
		if (arguments.length == 1) playbackVolume = v;
		if (AudioAPI) {
			if (arguments.length > 1) {
				for (i = 0, l = arguments.length; i < l; i++) {
					n = parseInt(arguments[i]);
					if (n && !isNaN(n)) {
						id = n.toString(16);
						if (webSoundPool[id]) setWebSoundVolume(webSoundPool[id], v);
					}
				}
			} else if (masterGain) {
				masterGain.gain.value = playbackVolume;
			}
		} else if (canPlay) {
			if (arguments.length > 1) {
				for (i = 0, l = arguments.length; i < l; i++) {
					n = parseInt(arguments[i]);
					if (n && !isNaN(n)) {
						id = n.toString(16);
						if (audioPool[id]) audioPool[id].setVolume(v);
					}
				}
			} else {
				for (id in audioPool) audioPool[id].adjustVolume();
			}
		}
	}
	return vol;
}

function getVolume() {
	// public, getter for master volume (no argument) or rel volume for first id provided
	if (arguments.length) {
		var n = parseInt(arguments[0]);
		if (n && !isNaN(n)) {
			var id = n.toString(16);
			if (webSoundPool[id]) return webSoundPool[id].relVolume;
			if (audioPool[id]) return audioPool[id].relVolume;
		}
		return undefined;
	} else {
		return playbackVolume;
	}
}

function resolveAudioApi() {
	if (typeof window !== 'undefined' && self.AudioContext) {
		AudioAPI = self.AudioContext;
		canPlay = true;
		return;
	} else {
		if (typeof window !== 'undefined') {
			var vendors = ['webkit', 'moz', 'o', 'ms'];
			for (var i = 0; i < vendors.length; i++) {
				var api = window[vendors[i] + 'AudioContext'];
				if (api) {
					AudioAPI = api;
					canPlay = true;
					return;
				}
			}
		}
	}
	if (!AudioAPI) {
		if (typeof window === 'undefined') {
			canPlay = true;
			console.warn('meSpeak: Not in browser Only able to do raw');
			return;
		}
		var audioElement = document.createElement('audio');
		if (audioElement && audioElement.canPlayType && (audioElement.canPlayType('audio/wav') || audioElement.canPlayType('audio/x-wav'))) {
			canPlay = true;
		} else {
			canPlay = false;
			console.warn('meSpeak: Muted. No support for HTMLAudioElement with MIME "audio/x-wav" dected.');
		}
	}
}
resolveAudioApi();

function canPlaybackWav() {
	// public (canPlay)
	return canPlay;
}

// Controller for HTMLAudioElements (collected in pool to provide access to volume of playing instances)
// (external dependencies: var playbackVolume; input: stream Array (uint8), relVolume: Number 0..1, callback: function)
// provides external method adjustVolume()
function AudioPlayback(stream, relVolume, isDataUrl, callback, id) {
	this.relVolume = relVolume;
	this.audio = null;
	this.id = id.string;
	this.callback = (typeof callback == 'function') ? callback : undefined;
	this.playing = false;
	this.started = false;
	this.play(stream, isDataUrl);
}
AudioPlayback.prototype = {
	play: function(stream, isDataUrl) {
		try {
			audioPool[this.id] = this;
			this.audio = document.createElement('audio');
			this.adjustVolume();
			var that = this;
			this.audio.addEventListener('ended', function() {
				that.remove();
			}, false);
			this.audio.addEventListener('canplaythrough', function() {
				that.audio.play();
				that.playing = true;
			}, false);
			if (isDataUrl) {
				this.audio.src = stream;
			} else {
				this.audio.src = 'data:audio/x-wav;base64,' + encode64(stream);
			}
			this.audio.load();
			this.started = true;
		} catch (e) {
			console.warn('meSpeak: HTMLAudioElement Exception: ' + e.message);
			this.started = false;
			this.remove();
		}
	},
	adjustVolume: function() {
		this.audio.volume = (this.relVolume !== undefined) ? this.relVolume * playbackVolume : playbackVolume;
	},
	setVolume: function(v) {
		this.relVolume = v;
		this.adjustVolume();
	},
	remove: function(stopped) {
		if (this.id) delete audioPool[this.id];
		if (this.callback) {
			var f = this.callback;
			this.callback = undefined;
			if (!unloading) f(!stopped);
		}
	},
	stop: function() {
		try {
			if (this.playing) this.audio.pause();
		} catch (e) {}
		this.remove(true);
	}
};

// play a sound via Web Audio API
// (external dependencies: vars masterGain, playbackVolume; input: stream ArrayBuffer (Uint8Array), relVolume: Number 0..1, callback: function)
function playWebSound(stream, volume, callback, id) {
	try {
		var source, gainNode, timer, relVolume;
		if (!audioContext) audioContext = new AudioAPI();
		if (!masterGain) {
			masterGain = (audioContext.createGain) ? audioContext.createGain() : audioContext.createGainNode();
			masterGain.connect(audioContext.destination);
			masterGain.gain.value = playbackVolume;
		}
		source = audioContext.createBufferSource();
		relVolume = parseFloat(volume);
		if (relVolume === undefined || isNaN(relVolume) || relVolume < 0 || relVolume > 1) relVolume = 1;
		gainNode = (audioContext.createGain) ? audioContext.createGain() : audioContext.createGainNode();
		gainNode.connect(masterGain);
		gainNode.gain.value = relVolume;
		source.connect(gainNode);
		audioContext.decodeAudioData(stream, function(audioData) {
				var f = function() {
					webSoundEndHandler(source, gainNode, callback, true, id.string);
				};
				if (!isChrome && source.onended !== undefined) {
					source.onended = f;
				} else {
					var duration = audioData.duration;
					setTimeout(f, duration ? Math.ceil(duration * 1000) : 10);
				}
				source.buffer = audioData;
				if (chromeVersion >= 32 && source.start) source.start(0);
			},
			function(err) {
				console.log('meSpeak: Web Audio Decoding Error: ' + ((typeof err == 'object') ? err.message : err));
				if (timer) clearTimeout(timer);
				if (source) source.disconnect();
				if (gainNode) gainNode.disconnect();
				if (webSoundPool[id.string]) delete webSoundPool[id.string];
				if (!unloading && typeof callback == 'function') callback(false);
				return 0;
			});
		webSoundPool[id.string] = {
			'source': source,
			'gainNode': gainNode,
			'callback': callback,
			'id': id.string,
			'relVolume': relVolume
		};
		if (chromeVersion < 32) {
			if (source.start) {
				source.start(0);
			} else {
				source.noteOn(0);
			}
		}
		return id.number;
	} catch (e) {
		console.warn('meSpeak: Web Audio Exception: ' + e.message);
		if (timer) clearTimeout(timer);
		webSoundEndHandler(source, gainNode, callback, false, id.string);
		return 0;
	}
}

function webSoundEndHandler(source, gainNode, callback, success, id) {
	if (!unloading && typeof callback == 'function') callback(success);
	// finnaly clean up with a bit of delay (work around a Chrome duration bug/issue)
	var f = function() {
		if (source) {
			if (source.onended !== undefined) source.onended = undefined;
			source.disconnect();
		}
		if (gainNode) gainNode.disconnect();
		if (id && webSoundPool[id]) delete webSoundPool[id];
	};
	if (!success) {
		f();
	} else {
		setTimeout(f, 500);
	}
}

function stopWebSound(obj) {
	// private
	try {
		if (obj.source.stop) {
			obj.source.stop(0);
		} else {
			obj.sourcesource.noteOff(0);
		}
	} catch (e) {}
	webSoundEndHandler(obj.source, obj.gainNode, obj.callback, false, obj.id);
}

function setWebSoundVolume(obj, v) {
	// private
	obj.gainNode.gain.value = v;
	obj.relVolume = v;
}

function setDefaultVoice(voice) {
	// public
	if (voice && voicesLoaded[voice]) defaultVoice = voice;
}

function getDefaultVoice() {
	// public
	return defaultVoice;
}

function loadVoice(url, callback) {
	// public
	if (typeof url !== 'string') {
		setVoiceData(url);
		if (callback) callback(false, url.voice_id);
	} else if (url) new HttpRequest(url, voiceRequestCallback, callback);
}

function loadConfig(url) {
	// public
	if (typeof url === 'object') setConfigData(url);
	else if (url) new HttpRequest(url, configDataRequestCallback, null);
}

function isVoiceLoaded(voice) {
	// public
	return (voicesLoaded[voice]) ? true : false;
}

function isConfigLoaded() {
	// public
	return (configDataLoaded) ? true : false;
}

var HttpRequest
if (typeof window === "undefined") {
	HttpRequest = function(url, loadCallback, userCallback) {
		var error = new Error("meSpeak: URLs not supported in Node.js");
		if(userCallback)userCallback(error,null);
		else throw error;
	}
} else {
	HttpRequest = function(url, loadCallback, userCallback) {
		// userCallback is an optional callback-handler.
		var req = this.request = new XMLHttpRequest();
		this.handler = loadCallback;
		this.url = url;
		this.localmode = Boolean(window.location.href.search(/^file:/i) == 0);
		this.userCallback = userCallback;
		var objref = this;
		try {
			req.open('GET', url);
			req.onreadystatechange = function() {
				objref.handler();
			};
			req.send('');
		} catch (e) {
			if (window.console) console.warn('Failed to load resource from ' + url + ': Network error.');
			if (typeof userCallback == 'function') userCallback(false, 'network error');
			this.request = this.handler = this.userCallback = null;
		}
	}
}

function voiceRequestCallback() {
	var req = this.request;
	if (req.readyState == 4) {
		if (this.localmode || req.status == 200) {
			var data = JSON.parse(req.responseText);
			if (typeof data == 'object' && typeof data.voice_id == 'string' && typeof data.voice == 'string' && (
				((!data.dict_id && !data.dict_id) || (typeof data.dict_id == 'string' && typeof data.dict == 'string')) || (!data.files || (typeof data.files == 'object' && Array.isArray(data.files)))
			)) {
				setVoiceData(data);
				if (typeof this.userCallback == 'function') this.userCallback(true, data.voice_id);
			} else {
				console.warn('Failed to load voice from ' + this.url + ': Not a voice module.');
				if (typeof this.userCallback == 'function') this.userCallback(false, 'data error');
			}
		} else {
			console.warn('Failed to load voice from ' + this.url + ': Received status ' + req.status + '.');
			if (typeof this.userCallback == 'function') this.userCallback(false, 'file error');
		}
		this.request = this.handler = this.userCallback = null;
	}
}

function configDataRequestCallback() {
	var req = this.request;
	if (req.readyState == 4) {
		if (this.localmode || req.status == 200) {
			var data = JSON.parse(req.responseText);
			if (typeof data == 'object' && typeof data.config == 'string' && typeof data.phontab == 'string' && typeof data.phonindex == 'string' && typeof data.phondata == 'string' && typeof data.intonations == 'string') {
				setConfigData(data);
			} else {
				console.warn('Failed to load config-data from ' + this.url + ': No valid data.');
			}
		} else {
			console.warn('Failed to load config-data from ' + this.url + ': Received status ' + req.status + '.');
		}
		this.request = this.handler = this.userCallback = null;
	}
}

function unloadHandler(event) {
	unloading = true;
	stopSound();
	audioPool = {};
	webSoundPool = {};
}

if (typeof window !== 'undefined') window.addEventListener('unload', unloadHandler, false);

// public interface
module.exports = {
	speak: speak,
	speakMultipart: speakMultipart,
	loadConfig: loadConfig,
	loadVoice: loadVoice,
	setDefaultVoice: setDefaultVoice,
	getDefaultVoice: getDefaultVoice,
	setVolume: setVolume,
	getVolume: getVolume,
	play: playSound,
	isConfigLoaded: isConfigLoaded,
	isVoiceLoaded: isVoiceLoaded,
	resetQueue: resetQueue,
	canPlay: canPlaybackWav,
	stop: stopSound
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(658).Buffer))

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(659)
var ieee754 = __webpack_require__(660)
var isArray = __webpack_require__(661)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function placeHoldersCount (b64) {
  var len = b64.length
  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // the number of equal signs (place holders)
  // if there are two placeholders, than the two characters before it
  // represent one byte
  // if there is only one, then the three characters before it represent 2 bytes
  // this is just a cheap hack to not do indexOf twice
  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0
}

function byteLength (b64) {
  // base64 is 4/3 + up to two characters of the original data
  return (b64.length * 3 / 4) - placeHoldersCount(b64)
}

function toByteArray (b64) {
  var i, l, tmp, placeHolders, arr
  var len = b64.length
  placeHolders = placeHoldersCount(b64)

  arr = new Arr((len * 3 / 4) - placeHolders)

  // if there are placeholders, only get up to the last complete 4 chars
  l = placeHolders > 0 ? len - 4 : len

  var L = 0

  for (i = 0; i < l; i += 4) {
    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)]
    arr[L++] = (tmp >> 16) & 0xFF
    arr[L++] = (tmp >> 8) & 0xFF
    arr[L++] = tmp & 0xFF
  }

  if (placeHolders === 2) {
    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[L++] = tmp & 0xFF
  } else if (placeHolders === 1) {
    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[L++] = (tmp >> 8) & 0xFF
    arr[L++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var output = ''
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    output += lookup[tmp >> 2]
    output += lookup[(tmp << 4) & 0x3F]
    output += '=='
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + (uint8[len - 1])
    output += lookup[tmp >> 10]
    output += lookup[(tmp >> 4) & 0x3F]
    output += lookup[(tmp << 2) & 0x3F]
    output += '='
  }

  parts.push(output)

  return parts.join('')
}


/***/ }),
/* 660 */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 661 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function ESpeak() {
// emscripten implementation

var vprint = console.warn


var Module = {
	noInitialRun: true
};

// WARNING: .ll contains i64 or double values. These 64-bit values are dangerous in USE_TYPED_ARRAYS == 2.
//          We store i64 as i32, and double as float. This can cause serious problems!
"use strict";

/*
// Capture the output of this into a variable, if you want
(function(Module, args) {
  Module = Module || {};
  Module.arguments = args || [];
*/

///*
// Runs much faster, for some reason
if (!this.Module) {
  this.Module = {};
}
if (!Module.arguments) {
  try {
    Module.arguments = scriptArgs;
  } catch(e) {
    try {
      Module.arguments = arguments;
    } catch(e) {
      Module.arguments = [];
    }
  }
}
//*/

  
// === Auto-generated preamble library stuff ===

//========================================
// Runtime code shared with compiler
//========================================

var Runtime = {
  stackSave: function () {
    return STACKTOP;
  },
  stackRestore: function (stackTop) {
    STACKTOP = stackTop;
  },
  forceAlign: function (target, quantum) {
    quantum = quantum || 4;
    if (isNumber(target) && isNumber(quantum)) {
      return Math.ceil(target/quantum)*quantum;
    } else {
      return 'Math.ceil((' + target + ')/' + quantum + ')*' + quantum;
    }
  },
  isNumberType: function (type) {
    return type in Runtime.INT_TYPES || type in Runtime.FLOAT_TYPES;
  },
  isPointerType: function isPointerType(type) {
  return pointingLevels(type) > 0;
},
  isStructType: function isStructType(type) {
  if (isPointerType(type)) return false;
  if (new RegExp(/^\[\d+\ x\ (.*)\]/g).test(type)) return true; // [15 x ?] blocks. Like structs
  if (new RegExp(/<?{ [^}]* }>?/g).test(type)) return true; // { i32, i8 } etc. - anonymous struct types
  // See comment in isStructPointerType()
  return !Runtime.isNumberType(type) && type[0] == '%';
},
  INT_TYPES: {"i1":0,"i8":0,"i16":0,"i32":0,"i64":0},
  FLOAT_TYPES: {"float":0,"double":0},
  or64: function (x, y) {
    var l = (x | 0) | (y | 0);
    var h = (Math.round(x / 4294967296) | Math.round(y / 4294967296)) * 4294967296;
    return l + h;
  },
  and64: function (x, y) {
    var l = (x | 0) & (y | 0);
    var h = (Math.round(x / 4294967296) & Math.round(y / 4294967296)) * 4294967296;
    return l + h;
  },
  xor64: function (x, y) {
    var l = (x | 0) ^ (y | 0);
    var h = (Math.round(x / 4294967296) ^ Math.round(y / 4294967296)) * 4294967296;
    return l + h;
  },
  getNativeFieldSize: function getNativeFieldSize(type) {
  return Math.max(Runtime.getNativeTypeSize(type), 4);
},
  getNativeTypeSize: function getNativeTypeSize(type) {
  if (false) return 1;
  var size = {
    '_i1': 1,
    '_i8': 1,
    '_i16': 2,
    '_i32': 4,
    '_i64': 8,
    "_float": 4,
    "_double": 8
  }['_'+type]; // add '_' since float&double confuse Closure compiler as keys.
  if (!size && type[type.length-1] == '*') {
    size = 4; // A pointer
  }
  return size;
},
  dedup: function dedup(items, ident) {
  var seen = {};
  if (ident) {
    return items.filter(function(item) {
      if (seen[item[ident]]) return false;
      seen[item[ident]] = true;
      return true;
    });
  } else {
    return items.filter(function(item) {
      if (seen[item]) return false;
      seen[item] = true;
      return true;
    });
  }
},
  set: function set() {
  var args = typeof arguments[0] === 'object' ? arguments[0] : arguments;
  var ret = {};
  for (var i = 0; i < args.length; i++) {
    ret[args[i]] = 0;
  }
  return ret;
},
  calculateStructAlignment: function calculateStructAlignment(type) {
    type.flatSize = 0;
    type.alignSize = 0;
    var diffs = [];
    var prev = -1;
    type.flatIndexes = type.fields.map(function(field) {
      var size, alignSize;
      if (Runtime.isNumberType(field) || Runtime.isPointerType(field)) {
        size = Runtime.getNativeTypeSize(field); // pack char; char; in structs, also char[X]s.
        alignSize = size;
      } else if (Runtime.isStructType(field)) {
        size = Types.types[field].flatSize;
        alignSize = Types.types[field].alignSize;
      } else {
        dprint('Unclear type in struct: ' + field + ', in ' + type.name_ + ' :: ' + dump(Types.types[type.name_]));
        assert(0);
      }
      alignSize = type.packed ? 1 : Math.min(alignSize, 4);
      type.alignSize = Math.max(type.alignSize, alignSize);
      var curr = Runtime.alignMemory(type.flatSize, alignSize); // if necessary, place this on aligned memory
      type.flatSize = curr + size;
      if (prev >= 0) {
        diffs.push(curr-prev);
      }
      prev = curr;
      return curr;
    });
    type.flatSize = Runtime.alignMemory(type.flatSize, type.alignSize);
    if (diffs.length == 0) {
      type.flatFactor = type.flatSize;
    } else if (Runtime.dedup(diffs).length == 1) {
      type.flatFactor = diffs[0];
    }
    type.needsFlattening = (type.flatFactor != 1);
    return type.flatIndexes;
  },
  generateStructInfo: function (struct, typeName, offset) {
    var type, alignment;
    if (typeName) {
      offset = offset || 0;
      type = (typeof Types === 'undefined' ? Runtime.typeInfo : Types.types)[typeName];
      if (!type) return null;
      if (!struct) struct = (typeof Types === 'undefined' ? Runtime : Types).structMetadata[typeName.replace(/.*\./, '')];
      if (!struct) return null;
      assert(type.fields.length === struct.length, 'Number of named fields must match the type for ' + typeName + '. Perhaps due to inheritance, which is not supported yet?');
      alignment = type.flatIndexes;
    } else {
      var type = { fields: struct.map(function(item) { return item[0] }) };
      alignment = Runtime.calculateStructAlignment(type);
    }
    var ret = {
      __size__: type.flatSize
    };
    if (typeName) {
      struct.forEach(function(item, i) {
        if (typeof item === 'string') {
          ret[item] = alignment[i] + offset;
        } else {
          // embedded struct
          var key;
          for (var k in item) key = k;
          ret[key] = Runtime.generateStructInfo(item[key], type.fields[i], alignment[i]);
        }
      });
    } else {
      struct.forEach(function(item, i) {
        ret[item[1]] = alignment[i];
      });
    }
    return ret;
  },
  stackAlloc: function stackAlloc(size) { var ret = STACKTOP; _memset(STACKTOP, 0, size); STACKTOP += size;STACKTOP = Math.ceil((STACKTOP)/4)*4;; return ret; },
  staticAlloc: function staticAlloc(size) { var ret = STATICTOP; STATICTOP += size;STATICTOP = Math.ceil((STATICTOP)/4)*4;; return ret; },
  alignMemory: function alignMemory(size,quantum) { var ret = size = Math.ceil((size)/(quantum ? quantum : 4))*(quantum ? quantum : 4);; return ret; },
  __dummy__: 0
}



var CorrectionsMonitor = {
  MAX_ALLOWED: 0, // XXX
  corrections: 0,
  sigs: {},

  note: function(type, succeed, sig) {
    if (!succeed) {
      this.corrections++;
      if (this.corrections >= this.MAX_ALLOWED) abort('\n\nToo many corrections!');
    }
  },

  vprint: function() {
    var items = [];
    for (var sig in this.sigs) {
      items.push({
        sig: sig,
        fails: this.sigs[sig][0],
        succeeds: this.sigs[sig][1],
        total: this.sigs[sig][0] + this.sigs[sig][1]
      });
    }
    items.sort(function(x, y) { return y.total - x.total; });
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      vprint(item.sig + ' : ' + item.total + ' hits, %' + (Math.ceil(100*item.fails/item.total)) + ' failures');
    }
  }
};

function cRound(x) {
  return x >= 0 ? Math.floor(x) : Math.ceil(x);
}


//========================================
// Runtime essentials
//========================================

var __globalConstructor__ = function globalConstructor() {
};

var __THREW__ = false; // Used in checking for thrown exceptions.

var __ATEXIT__ = [];

var ABORT = false;

var undef = 0;
var tempValue, tempInt, tempBigInt;

function abort(text) {
  vprint(text + ':\n' + (new Error).stack);
  ABORT = true;
  throw "Assertion: " + text;
}

function assert(condition, text) {
  if (!condition) {
    abort('Assertion failed: ' + text);
  }
}

// Sets a value in memory in a dynamic way at run-time. Uses the
// type data. This is the same as makeSetValue, except that
// makeSetValue is done at compile-time and generates the needed
// code then, whereas this function picks the right code at
// run-time.

function setValue(ptr, value, type) {
  if (type[type.length-1] === '*') type = 'i32'; // pointers are 32-bit
  switch(type) {
    case 'i1': HEAP8[(ptr)]=value;; break;
    case 'i8': HEAP8[(ptr)]=value;; break;
    case 'i16': HEAP16[((ptr)>>1)]=value;; break;
    case 'i32': HEAP32[((ptr)>>2)]=value;; break;
    case 'i64': HEAP32[((ptr)>>2)]=value;; break;
    case 'float': HEAPF32[((ptr)>>2)]=value;; break;
    case 'double': HEAPF32[((ptr)>>2)]=value;; break;
    default: abort('invalid type for setValue: ' + type);
  }
}
Module.setValue = setValue;

// Parallel to setValue.

function getValue(ptr, type) {
  if (type[type.length-1] === '*') type = 'i32'; // pointers are 32-bit
  switch(type) {
    case 'i1': return HEAP8[(ptr)];
    case 'i8': return HEAP8[(ptr)];
    case 'i16': return HEAP16[((ptr)>>1)];
    case 'i32': return HEAP32[((ptr)>>2)];
    case 'i64': return HEAP32[((ptr)>>2)];
    case 'float': return HEAPF32[((ptr)>>2)];
    case 'double': return HEAPF32[((ptr)>>2)];
    default: abort('invalid type for setValue: ' + type);
  }
  return null;
}
Module.getValue = getValue;

// Allocates memory for some data and initializes it properly.

var ALLOC_NORMAL = 0; // Tries to use _malloc()
var ALLOC_STACK = 1; // Lives for the duration of the current function call
var ALLOC_STATIC = 2; // Cannot be freed
Module.ALLOC_NORMAL = ALLOC_NORMAL;
Module.ALLOC_STACK = ALLOC_STACK;
Module.ALLOC_STATIC = ALLOC_STATIC;

function allocate(slab, types, allocator) {
  var zeroinit, size;
  if (typeof slab === 'number') {
    zeroinit = true;
    size = slab;
  } else {
    zeroinit = false;
    size = slab.length;
  }

  var ret = [_malloc, Runtime.stackAlloc, Runtime.staticAlloc][allocator === undefined ? ALLOC_STATIC : allocator](Math.max(size, 1));

  var singleType = typeof types === 'string' ? types : null;

  var i = 0, type;
  while (i < size) {
    var curr = zeroinit ? 0 : slab[i];

    if (typeof curr === 'function') {
      curr = Runtime.getFunctionIndex(curr);
    }

    type = singleType || types[i];
    if (type === 0) {
      i++;
      continue;
    }

    setValue(ret+i, curr, type);
    i += Runtime.getNativeTypeSize(type);
  }

  return ret;
}
Module.allocate = allocate;

function Pointer_stringify(ptr) {
  var ret = "";
  var i = 0;
  var t;
  var nullByte = String.fromCharCode(0);
  while (1) {
    t = String.fromCharCode(HEAPU8[(ptr+i)]);
    if (t == nullByte) { break; } else {}
    ret += t;
    i += 1;
  }
  return ret;
}
Module.Pointer_stringify = Pointer_stringify;

function Array_stringify(array) {
  var ret = "";
  for (var i = 0; i < array.length; i++) {
    ret += String.fromCharCode(array[i]);
  }
  return ret;
}
Module.Array_stringify = Array_stringify;

// Memory management

var FUNCTION_TABLE; // XXX: In theory the indexes here can be equal to pointers to stacked or malloced memory. Such comparisons should
                    //      be false, but can turn out true. We should probably set the top bit to prevent such issues.

var PAGE_SIZE = 4096;
function alignMemoryPage(x) {
  return Math.ceil(x/PAGE_SIZE)*PAGE_SIZE;
}

var HEAP;
var HEAP8, HEAPU8, HEAP16, HEAPU16, HEAP32, HEAPU32, HEAPF32;

var STACK_ROOT, STACKTOP, STACK_MAX;
var STATICTOP;

var HAS_TYPED_ARRAYS = false;
var TOTAL_MEMORY = Module.TOTAL_MEMORY || 52428800;
var FAST_MEMORY = Module.FAST_MEMORY || 2097152;

// Initialize the runtime's memory
HAS_TYPED_ARRAYS = false;
try {
  HAS_TYPED_ARRAYS = !!Int32Array && !!Float32Array && !!(new Int32Array(1).subarray); // check for full engine support (use string 'subarray' to avoid closure compiler confusion)
} catch(e) {}

if (HAS_TYPED_ARRAYS) {
  var buffer = new ArrayBuffer(TOTAL_MEMORY);
  HEAP8 = new Int8Array(buffer);
  HEAP16 = new Int16Array(buffer);
  HEAP32 = new Int32Array(buffer);
  HEAPU8 = new Uint8Array(buffer);
  HEAPU16 = new Uint16Array(buffer);
  HEAPU32 = new Uint32Array(buffer);
  HEAPF32 = new Float32Array(buffer);

  // Endianness check (note: assumes compiler arch was little-endian)
  HEAP32[0] = 255;
  assert(HEAPU8[0] === 255 && HEAPU8[3] === 0, 'Typed arrays 2 must be run on a little-endian system');
} else
{
  // Make sure that our HEAP is implemented as a flat array.
  HEAP = new Array(TOTAL_MEMORY);
  for (var i = 0; i < FAST_MEMORY; i++) {
    HEAP[i] = 0; // XXX We do *not* use {{| makeSetValue(0, 'i', 0, 'null') |}} here, since this is done just to optimize runtime speed
  }
  abort('Cannot fallback to non-typed array case in USE_TYPED_ARRAYS == 2: Code is too specialized');
}

var base = intArrayFromString('(null)'); // So printing %s of NULL gives '(null)'
                                         // Also this ensures we leave 0 as an invalid address, 'NULL'
for (var i = 0; i < base.length; i++) {
  HEAP8[(i)]=base[i];
}

Module.HEAP = HEAP;
Module.HEAP8 = HEAP8;
Module.HEAP16 = HEAP16;
Module.HEAP32 = HEAP32;
Module.HEAPU8 = HEAPU8;
Module.HEAPU16 = HEAPU16;
Module.HEAPU32 = HEAPU32;
Module.HEAPF32 = HEAPF32;

STACK_ROOT = STACKTOP = alignMemoryPage(10);
var TOTAL_STACK = 1024*1024; // XXX: Changing this value can lead to bad perf on v8!
STACK_MAX = STACK_ROOT + TOTAL_STACK;

STATICTOP = alignMemoryPage(STACK_MAX);

function __shutdownRuntime__() {
  while(__ATEXIT__.length > 0) {
    var atexit = __ATEXIT__.pop();
    var func = atexit.func;
    if (typeof func === 'number') {
      func = FUNCTION_TABLE[func];
    }
    func(atexit.arg === undefined ? null : atexit.arg);
  }

  // allow browser to GC, set heaps to null?

  // Print summary of correction activity
  CorrectionsMonitor.vprint();
}


// Copies a list of num items on the HEAP into a
// a normal JavaScript array of numbers
function Array_copy(ptr, num) {
  // TODO: In the SAFE_HEAP case, do some reading here, for debugging purposes - currently this is an 'unnoticed read'.
  if (HAS_TYPED_ARRAYS) {
    return Array.prototype.slice.call(HEAP8.subarray(ptr, ptr+num)); // Make a normal array out of the typed 'view'
                                                                     // Consider making a typed array here, for speed?
  } else {
    return HEAP8.slice(ptr, ptr+num);
  }
  return HEAP.slice(ptr, ptr+num);
}
Module.Array_copy = Array_copy;

function String_len(ptr) {
  var i = 0;
  while (HEAP8[(ptr+i)]) i++; // Note: should be |!= 0|, technically. But this helps catch bugs with undefineds
  return i;
}
Module.String_len = String_len;

// Copies a C-style string, terminated by a zero, from the HEAP into
// a normal JavaScript array of numbers
function String_copy(ptr, addZero) {
  var len = String_len(ptr);
  if (addZero) len++;
  var ret = Array_copy(ptr, len);
  if (addZero) ret[len-1] = 0;
  return ret;
}
Module.String_copy = String_copy;

// Tools

this.vprint = function(x) {console.warn(x)}

// This processes a JS string into a C-line array of numbers, 0-terminated.
// For LLVM-originating strings, see parser.js:parseLLVMString function
function intArrayFromString(stringy, dontAddNull) {
  var ret = [];
  var t;
  var i = 0;
  while (i < stringy.length) {
    var chr = stringy.charCodeAt(i);
    if (chr > 0xFF) {
      chr &= 0xFF;
    }
    ret.push(chr);
    i = i + 1;
  }
  if (!dontAddNull) {
    ret.push(0);
  }
  return ret;
}
Module.intArrayFromString = intArrayFromString;

function intArrayToString(array) {
  var ret = [];
  for (var i = 0; i < array.length; i++) {
    var chr = array[i];
    if (chr > 0xFF) {
      chr &= 0xFF;
    }
    ret.push(String.fromCharCode(chr));
  }
  return ret.join('');
}
Module.intArrayToString = intArrayToString;

function unSign(value, bits, ignore, sig) {
  if (value >= 0) {
    return value;
  }
  return bits <= 32 ? 2*Math.abs(1 << (bits-1)) + value // Need some trickery, since if bits == 32, we are right at the limit of the bits JS uses in bitshifts
                    : Math.pow(2, bits)         + value;
  // TODO: clean up previous line
}
function reSign(value, bits, ignore, sig) {
  if (value <= 0) {
    return value;
  }
  var half = bits <= 32 ? Math.abs(1 << (bits-1)) // abs is needed if bits == 32
                        : Math.pow(2, bits-1);
  if (value >= half && (bits <= 32 || value > half)) { // for huge values, we can hit the precision limit and always get true here. so don't do that
    value = -2*half + value; // Cannot bitshift half, as it may be at the limit of the bits JS uses in bitshifts
  }
  return value;
}

// === Body ===



Runtime.QUANTUM_SIZE = 4
var $struct___sFILE___SIZE = 104; // %struct.__sFILE
  var $struct___sFILE___FLATTENER = [0,4,8,12,14,16,24,28,32,36,40,44,48,56,60,64,67,68,76,80,84,88,92,100];
var $struct___sbuf___SIZE = 8; // %struct.__sbuf
  
var $struct__reent___SIZE = 1060; // %struct._reent
  var $struct__reent___FLATTENER = [0,4,8,12,16,20,48,52,56,60,64,68,72,76,80,84,88,328,332,732,736,748];
var $struct__Bigint___SIZE = 24; // %struct._Bigint
  
var $union_anon_0___SIZE = 240; // %union.anon.0
  
var $struct_anon_1___SIZE = 240; // %struct.anon.1
  
var $struct__atexit___SIZE = 400; // %struct._atexit
  var $struct__atexit___FLATTENER = [0,4,8,136];
var $struct__on_exit_args___SIZE = 264; // %struct._on_exit_args
  var $struct__on_exit_args___FLATTENER = [0,128,256,260];
var $struct__glue___SIZE = 12; // %struct._glue
  
var $struct__mbstate_t___SIZE = 8; // %struct._mbstate_t
  
var $union_anon___SIZE = 4; // %union.anon
  
var $struct_option___SIZE = 16; // %struct.option
  
var $struct_MNEM_TAB___SIZE = 8; // %struct.MNEM_TAB
  
var $struct_MatchRecord___SIZE = 16; // %struct.MatchRecord
  
var $struct_TUNE___SIZE = 68; // %struct.TUNE
  var $struct_TUNE___FLATTENER = [0,12,16,24,25,26,27,28,29,30,31,32,33,34,35,36,39,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,64];
var $struct_SYLLABLE___SIZE = 6; // %struct.SYLLABLE
  
var $struct_TONE_HEAD___SIZE = 16; // %struct.TONE_HEAD
  var $struct_TONE_HEAD___FLATTENER = [0,1,2,3,4,8,9,10,12];
var $struct_SSML_STACK___SIZE = 76; // %struct.SSML_STACK
  var $struct_SSML_STACK___FLATTENER = [0,4,8,12,16,56];
var $struct_PARAM_STACK_45___SIZE = 64; // %struct.PARAM_STACK.45
  
var $struct_ACCENTS___SIZE = 8; // %struct.ACCENTS
  
var $struct_MBROLA_TAB___SIZE = 24; // %struct.MBROLA_TAB
  
var $struct_PHONEME_TAB___SIZE = 16; // %struct.PHONEME_TAB
  var $struct_PHONEME_TAB___FLATTENER = [0,4,8,10,11,12,13,14,15];
var $struct_PHONEME_TAB_LIST_106___SIZE = 48; // %struct.PHONEME_TAB_LIST.106
  var $struct_PHONEME_TAB_LIST_106___FLATTENER = [0,32,36,40,44];
var $struct_frameref_t___SIZE = 8; // %struct.frameref_t
  
var $struct_frame_t___SIZE = 64; // %struct.frame_t
  var $struct_frame_t___FLATTENER = [0,2,16,17,18,26,32,35,39,44,49,56,63];
var $struct_PHONEME_DATA___SIZE = 152; // %struct.PHONEME_DATA
  var $struct_PHONEME_DATA___FLATTENER = [0,4,68,88,108,124,128,132];
var $struct_PHONEME_LIST___SIZE = 24; // %struct.PHONEME_LIST
  var $struct_PHONEME_LIST___FLATTENER = [0,1,2,3,4,6,8,12,14,15,16,17,18,19,20,21];
var $struct_SPEED_FACTORS___SIZE = 64; // %struct.SPEED_FACTORS
  
var $struct_voice_t___SIZE = 1344; // %struct.voice_t
  var $struct_voice_t___FLATTENER = [0,40,44,48,52,56,60,64,68,72,76,80,84,88,92,96,100,104,108,112,144,162,180,198,216,234,252,272,308,344];
var $struct_SOUND_ICON___SIZE = 16; // %struct.SOUND_ICON
  
var $struct_Translator___SIZE = 8328; // %struct.Translator
  var $struct_Translator___FLATTENER = [0,280,284,288,292,332,632,652,656,660,668,676,692,696,700,704,708,964,968,1000,1048,1052,1056,5152,5256,6280,6792,7272,7752,7756,8012,8268,8272,8276,8280,8284,8288,8292,8296,8300,8304,8308,8312,8316,8320,8324];
var $struct_LANGUAGE_OPTIONS___SIZE = 280; // %struct.LANGUAGE_OPTIONS
  var $struct_LANGUAGE_OPTIONS___FLATTENER = [0,4,8,12,16,20,24,100,176,180,184,188,192,196,200,204,208,212,216,220,224,228,232,240,244,248,249,250,251,252,256,260,264,268,272,276];
var $struct_PHONEME_LIST2___SIZE = 8; // %struct.PHONEME_LIST2
  var $struct_PHONEME_LIST2___FLATTENER = [0,1,2,3,4,6];
var $struct_REPLACE_PHONEMES___SIZE = 3; // %struct.REPLACE_PHONEMES
  
var $struct_datablock___SIZE = 16; // %struct.datablock
  
var $struct_espeak_VOICE___SIZE = 24; // %struct.espeak_VOICE
  var $struct_espeak_VOICE___FLATTENER = [0,4,8,12,13,14,15,16,20];
var $struct_wavegen_peaks_t___SIZE = 80; // %struct.wavegen_peaks_t
  var $struct_wavegen_peaks_t___FLATTENER = [0,4,8,12,16,24,32,40,48,56,64,72];
var $struct_RESONATOR___SIZE = 40; // %struct.RESONATOR
  
var $struct_WGEN_DATA___SIZE = 64; // %struct.WGEN_DATA
  
var $struct_sonicStreamStruct___SIZE = 88; // %struct.sonicStreamStruct
  
var $struct_klatt_frame_t___SIZE = 288; // %struct.klatt_frame_t
  var $struct_klatt_frame_t___FLATTENER = [0,4,8,48,88,128,168,172,176,180,184,188,192,196,200,204,208,248];
var $struct_klatt_global_t___SIZE = 2748; // %struct.klatt_global_t
  var $struct_klatt_global_t___FLATTENER = [0,4,8,12,16,20,24,28,32,36,40,44,48,52,56,64,72,80,88,96,104,112,120,128,136,144,152,160,164,172,176,180,184,188,1468];
var $struct_resonator_t___SIZE = 64; // %struct.resonator_t
  
var $struct_klatt_peaks_t___SIZE = 80; // %struct.klatt_peaks_t
  var $struct_klatt_peaks_t___FLATTENER = [0,4,8,12,16,24,32,40,48,56,64,72];
var $struct_frame_t_199___SIZE = 64; // %struct.frame_t.199
  var $struct_frame_t_199___FLATTENER = [0,2,16,17,18,26,32,35,39,44,49,56,63];
var $struct_stat___SIZE = 80; // %struct.stat
  var $struct_stat___FLATTENER = [0,8,12,16,20,24,28,36,40,44,48,52,56,60,64,68,72];
var $struct_PARAM_STACK___SIZE = 64; // %struct.PARAM_STACK
  
var $struct_PHONEME_TAB_LIST___SIZE = 48; // %struct.PHONEME_TAB_LIST
  var $struct_PHONEME_TAB_LIST___FLATTENER = [0,32,36,40,44];
var $struct_PHONEME_TAB_11___SIZE = 16; // %struct.PHONEME_TAB.11
  var $struct_PHONEME_TAB_11___FLATTENER = [0,4,8,10,11,12,13,14,15];
var $struct_RGROUP___SIZE = 28; // %struct.RGROUP
  var $struct_RGROUP___FLATTENER = [0,16,20,24];
var $struct_WORD_TAB___SIZE = 12; // %struct.WORD_TAB
  var $struct_WORD_TAB___FLATTENER = [0,4,6,8,9,10];
var $struct_PHONEME_TAB_LIST_25___SIZE = 48; // %struct.PHONEME_TAB_LIST.25
  var $struct_PHONEME_TAB_LIST_25___FLATTENER = [0,32,36,40,44];
var $struct_WORD_TAB_29___SIZE = 12; // %struct.WORD_TAB.29
  var $struct_WORD_TAB_29___FLATTENER = [0,4,6,8,9,10];
var $struct_Translator_33___SIZE = 8328; // %struct.Translator.33
  var $struct_Translator_33___FLATTENER = [0,280,284,288,292,332,632,652,656,660,668,676,692,696,700,704,708,964,968,1000,1048,1052,1056,5152,5256,6280,6792,7272,7752,7756,8012,8268,8272,8276,8280,8284,8288,8292,8296,8300,8304,8308,8312,8316,8320,8324];
var $struct_LANGUAGE_OPTIONS_32___SIZE = 280; // %struct.LANGUAGE_OPTIONS.32
  var $struct_LANGUAGE_OPTIONS_32___FLATTENER = [0,4,8,12,16,20,24,100,176,180,184,188,192,196,200,204,208,212,216,220,224,228,232,240,244,248,249,250,251,252,256,260,264,268,272,276];
var $struct_TONE_NUCLEUS___SIZE = 16; // %struct.TONE_NUCLEUS
  var $struct_TONE_NUCLEUS___FLATTENER = [0,1,2,3,4,5,8,12,13,14];
var $struct_PARAM_STACK_54___SIZE = 64; // %struct.PARAM_STACK.54
  
var $struct_FMT_PARAMS___SIZE = 48; // %struct.FMT_PARAMS
  
var $struct_FMT_PARAMS_111___SIZE = 48; // %struct.FMT_PARAMS.111
  
var $struct_SPECT_SEQ___SIZE = 1104; // %struct.SPECT_SEQ
  var $struct_SPECT_SEQ___FLATTENER = [0,2,3,4];
var $struct_frame_t2___SIZE = 44; // %struct.frame_t2
  var $struct_frame_t2___FLATTENER = [0,2,16,17,18,26,32,35,39];
var $struct_SPECT_SEQK___SIZE = 1604; // %struct.SPECT_SEQK
  var $struct_SPECT_SEQK___FLATTENER = [0,2,3,4];
var $struct_pollfd___SIZE = 8; // %struct.pollfd
  var $struct_pollfd___FLATTENER = [0,4,6];
var $struct_dirent___SIZE = 1040; // %struct.dirent
  var $struct_dirent___FLATTENER = [0,4,1028,1032,1036];
var $struct_getopt_data___SIZE = 20; // %struct.getopt_data
  
var _path_home;
var _filetype;
var _wavefile;
var _uri_callback;
var _phoneme_callback;
var _f_wave;
var _quiet;
var _samples_total;
var _samples_split;
var _wavefile_count;
var _end_of_sentence;
var _voice_pcnt;
var __impure_ptr;
var __ZZ13DisplayVoicesP7__sFILEPcE7genders;
var __str1;
var __str3;
var __str4;
var __str5;
var __ZZ4mainE12long_options;
var __str6;
var __str7;
var __str8;
var __str9;
var __str10;
var __str11;
var __str12;
var __str13;
var __str14;
var __str15;
var __str16;
var __str17;
var __str18;
var __str19;
var __str21;
var __str23;
var __str25;
var __str27;
var __str28;
var __str29;
var __str30;
var __ZZL12OpenWaveFilePKciE8wave_hdr;
var __str32;
var __str33;
var __str35;
var __str36;
var __str37;
var __str38;
var __str39;
var __str40;
var __str41;
var __ZL5f_log;
var __str42;
var __str143;
var __str244;
var __str345;
var __str446;
var __str547;
var __str648;
var _mnem_rules;
var __str749;
var __str850;
var __str951;
var __str1052;
var __str1153;
var __str1254;
var __str1355;
var __str1456;
var __str1557;
var __str1658;
var __str1759;
var __str1860;
var __str1961;
var __str2062;
var __str2163;
var __str2264;
var __str2365;
var __str2466;
var __str2567;
var __str2668;
var __str2769;
var __str2870;
var __str2971;
var __str3072;
var __str3173;
var __str3274;
var __str3375;
var __str3476;
var __str3577;
var __str3678;
var __str3779;
var __str3880;
var __str3981;
var __str4082;
var __str4183;
var __str4284;
var __str43;
var __str44;
var __str45;
var __str46;
var __str47;
var __str48;
var __str49;
var __str50;
var __str51;
var __str52;
var __str53;
var __str54;
var __str55;
var __str56;
var __str57;
var _mnem_flags;
var __ZZ22print_dictionary_flagsPjE3buf;
var __str59;
var __ZZ10DecodeRulePKciPciE6output;
var __ZZ10DecodeRulePKciPciE7symbols;
var __ZZ10DecodeRulePKciPciE10symbols_lg;
var __str60;
var __str61;
var __str62;
var __str64;
var __str65;
var __ZL11error_count;
var __ZL21error_need_dictionary;
var __ZL19letterGroupsDefined;
var __ZL10debug_flag;
var __str66;
var __str67;
var __str69;
var __str71;
var __str72;
var __str73;
var __str74;
var __str75;
var __str76;
var __str77;
var __str78;
var __ZL7linenum;
var __ZL10group_name;
var __str79;
var __ZL9group3_ix;
var __str81;
var __str82;
var __str83;
var __str84;
var __str85;
var __str89;
var __ZL9rule_cond;
var __ZL8rule_pre;
var __ZL9rule_post;
var __ZL10rule_match;
var __ZL13rule_phonemes;
var __str90;
var __str91;
var __str92;
var __str93;
var __str94;
var __str95;
var __ZZL16copy_rule_stringPcRiE6outbuf;
var __ZZL16copy_rule_stringPcRiE10next_state;
var __ZZL16copy_rule_stringPcRiE16lettergp_letters;
var __str97;
var __str98;
var __str99;
var __str100;
var __str101;
var __str102;
var __str103;
var __ZL11hash_chains;
var __ZL11hash_counts;
var __ZL9text_mode_b;
var __str104;
var __str106;
var __str107;
var __ZZL12compile_linePcS_PiE10nullstring;
var __str108;
var __str109;
var __str110;
var __str111;
var __str112;
var __str113;
var __str114;
var __str115;
var _dictionary_skipwords;
var _dictionary_name;
var __ZL13remove_accent;
var __str116;
var __str2118;
var __str3119;
var __str4120;
var __str5121;
var __str7123;
var _ipa1;
var __str8124;
var __str9125;
var __ZL15stress_phonemes;
var __ZZ13SetWordStressP10TranslatorPcPjiiE15consonant_types;
var __ZZ13SetWordStressP10TranslatorPcPjiiE8guess_ru;
var __ZZ13SetWordStressP10TranslatorPcPjiiE10guess_ru_v;
var __ZZ13SetWordStressP10TranslatorPcPjiiE10guess_ru_t;
var __ZZ14TranslateRulesP10TranslatorPcS1_iS1_iPjE9str_pause;
var __str10126;
var __str11127;
var __ZL13diereses_list;
var __ZZ14LookupDictListP10TranslatorPPcS1_PjiP8WORD_TABE16word_replacement;
var __str15131;
var __str16132;
var __ZZ11LookupFlagsP10TranslatorPKcE5flags;
var __ZZ12RemoveEndingP10TranslatorPciS1_E6ending;
var __ZZ12RemoveEndingP10TranslatorPciS1_E16add_e_exceptions;
var __str17133;
var __ZZ12RemoveEndingP10TranslatorPciS1_E15add_e_additions;
var __str18134;
var __str19135;
var __str20136;
var __str21137;
var __str22138;
var __str23139;
var __str24140;
var __str25141;
var __str27143;
var __str28144;
var __str29145;
var __str30146;
var __str31147;
var __ZZL9MatchRuleP10TranslatorPPcS1_iS1_P11MatchRecordiiE4best;
var __str32148;
var __str34150;
var _env_fall;
var _env_rise;
var _env_frise;
var __ZL11env_r_frise;
var __ZL10env_frise2;
var __ZL12env_r_frise2;
var __ZL12env_risefall;
var __ZL13env_fallrise3;
var __ZL13env_fallrise4;
var __ZL9env_fall2;
var __ZL9env_rise2;
var __ZL16env_risefallrise;
var _envelope_data;
var __ZL18tone_nucleus_table;
var _punctuation_to_tone;
var _n_tunes;
var _tunes;
var __ZL12syllable_tab;
var __ZL8no_tonic_b;
var __ZL15tone_head_table;
var __ZL10number_pre;
var __ZL10tone_posn2;
var __ZL9tone_posn;
var __ZL11number_tail;
var __ZL14tone_pitch_env;
var __ZZL18calc_pitch_segmentiiP9TONE_HEADP12TONE_NUCLEUSiiE12continue_tab;
var __ZL8min_drop;
var __ZL7drops_0;
var __ZL5oflow;
var __ZL9oflow_emf;
var __ZL10oflow_less;
var __ZL12last_primary;
var _namedata;
var __ZL7f_input;
var _p_textinput;
var _p_wchar_input;
var __ZL10ungot_word;
var _count_characters;
var __ZL10ssml_stack;
var __ZL16current_voice_id;
var _param_stack;
var _param_defaults;
var _walpha_tab;
var __ZL10ungot_char;
var __ZL12end_of_input_b;
var __str167;
var __str1168;
var __str2169;
var __str3170;
var __str4171;
var __str5172;
var __str6173;
var __str7174;
var __str8175;
var __str9176;
var __str10177;
var __str11178;
var __str12179;
var __str13180;
var __str14181;
var __str15182;
var __str16183;
var __str17184;
var __str18185;
var __str19186;
var __str20187;
var __str21188;
var __str22189;
var __str23190;
var __str24191;
var __str25192;
var __str26193;
var __str27194;
var __str28195;
var __str29196;
var __str30197;
var __str31198;
var __ZL8ssmltags;
var __ZL10n_namedata;
var __ZL11namedata_ix;
var __str32199;
var __str33200;
var __str34201;
var __str35202;
var __str36203;
var __str37204;
var __ZL18xml_char_mnemonics;
var __ZZ10ReadClauseP10TranslatorP7__sFILEPcPsPiiS5_S3_E12ungot_string;
var __ZZ10ReadClauseP10TranslatorP7__sFILEPcPsPiiS5_S3_E15ungot_string_ix;
var __ZL19clear_skipping_text_b;
var __ZL11ungot_char2;
var __ZL19ssml_ignore_l_angle;
var __str38205;
var __ZL10sayas_mode;
var __ZL11ignore_text_b;
var __ZL11punct_chars;
var __ZL16punct_attributes;
var __str41208;
var __ZL12chars_ignore;
var __str42209;
var __ZL10audio_text_b;
var __ZL17speech_parameters;
var __ZL12n_ssml_stack;
var __ZL13n_param_stack;
var __ZL7xmlbase;
var __ZZL14LookupCharNameP10TranslatoriiE3buf;
var __str47214;
var __str48215;
var __str49216;
var __ZZL13WordToString2jE3buf;
var __str50217;
var __str51218;
var __str52219;
var __str53220;
var __str54221;
var __str55222;
var __str57224;
var __str58225;
var __str59226;
var __str60227;
var __ZZL14ProcessSsmlTagPwPcRiiiE10mnem_punct;
var __str61228;
var __str62229;
var __str63230;
var __ZZL14ProcessSsmlTagPwPcRiiiE13mnem_capitals;
var __str64231;
var __str65232;
var __str66233;
var __ZZL14ProcessSsmlTagPwPcRiiiE17mnem_interpret_as;
var __str68235;
var __str69236;
var __str70237;
var __str71238;
var __str72239;
var __ZZL14ProcessSsmlTagPwPcRiiiE17mnem_sayas_format;
var __str73240;
var __ZZL14ProcessSsmlTagPwPcRiiiE10mnem_break;
var __str74241;
var __str75242;
var __str76243;
var __str77244;
var __ZZL14ProcessSsmlTagPwPcRiiiE13mnem_emphasis;
var __str78245;
var __str79246;
var __ZZL14ProcessSsmlTagPwPcRiiiE12prosody_attr;
var __str80247;
var __str81248;
var __str82249;
var __ZL22ignore_if_self_closing;
var __str83250;
var __str84251;
var __str85252;
var __str86253;
var __str87254;
var __ZZL14ProcessSsmlTagPwPcRiiiE23emphasis_to_pitch_range;
var __ZZL14ProcessSsmlTagPwPcRiiiE18emphasis_to_volume;
var __str88255;
var __str89256;
var __str90257;
var __str91258;
var __ZL11sayas_start;
var __str92259;
var __str94261;
var __str95262;
var __str96263;
var __str97264;
var __str98265;
var __str99266;
var __ZZL14ProcessSsmlTagPwPcRiiiE11break_value;
var __str100267;
var __str101268;
var __str102269;
var __ZZL18GetVoiceAttributesPwiE11mnem_gender;
var __str105272;
var __str106273;
var __str108275;
var __ZZL14LoadSoundFile2PKcE4slot;
var __str111278;
var __str112279;
var __str113280;
var __str114281;
var __ZZL14ReplaceKeyNamePciRiE8keynames;
var __ZZL19SetProsodyParameteriPwP11PARAM_STACKE11mnem_volume;
var __str115282;
var __str116283;
var __str117;
var __str118;
var __str119;
var __ZZL19SetProsodyParameteriPwP11PARAM_STACKE9mnem_rate;
var __str120;
var __str121;
var __str122;
var __str123;
var __ZZL19SetProsodyParameteriPwP11PARAM_STACKE10mnem_pitch;
var __str124;
var __str125;
var __str126;
var __str127;
var __ZZL19SetProsodyParameteriPwP11PARAM_STACKE10mnem_range;
var __ZZL19SetProsodyParameteriPwP11PARAM_STACKE9mnem_tabs;
var __ZZL17ProcessParamStackPcRiE10cmd_letter;
var __str128;
var __ZZL16GetSsmlAttributePwPKcE5empty;
var __ZZL4GetCvE6ungot2;
var __ZZL4GetCvE5mask2;
var __ZL6speed1;
var __ZL6speed2;
var __ZL6speed3;
var __ZL12speed_lookup;
var __ZL14wav_factor_350;
var __ZL16pause_factor_350;
var __ZZ11CalcLengthsP10TranslatorE14more_syllables;
var __str294;
var __ZL18letter_accents_0e0;
var __ZL18letter_accents_250;
var __ZL13non_ascii_tab;
var __ZL11accents_tab;
var __str297;
var __str1298;
var __str2299;
var __ZZ12LookupLetterP10TranslatorjiPciE13single_letter;
var __str5302;
var __str6303;
var __str7304;
var __str8305;
var __str9306;
var __str10307;
var __str11308;
var __str12309;
var __ZZ14TranslateRomanP10TranslatorPcS1_P8WORD_TABE12roman_values;
var __str13310;
var __str14311;
var __ZZL17TranslateNumber_1P10TranslatorPcS1_PjP8WORD_TABiE9str_pause;
var __ZL14n_digit_lookup;
var __ZL12digit_lookup;
var __ZL14number_control;
var __ZL23speak_missing_thousands;
var __ZL11ph_ordinal2;
var __str15312;
var __str16313;
var __str17314;
var __str18315;
var __str19316;
var __str20317;
var __str21318;
var __str22319;
var __str23320;
var __str24321;
var __str25322;
var __str26323;
var __str27324;
var __str28325;
var __str29326;
var __str30327;
var __str31328;
var __str32329;
var __str33330;
var __str35332;
var __str36333;
var __str37334;
var __str39336;
var __str40337;
var __str41338;
var __str42339;
var __str43340;
var __str44341;
var __str45342;
var __str46343;
var __str47344;
var __str48345;
var __str49346;
var __str50347;
var __str51348;
var __str52349;
var __str53350;
var __str54351;
var __str55352;
var __str56353;
var __str57354;
var __str58355;
var __str59356;
var __str60357;
var __str61358;
var __str62359;
var __str63360;
var __str64361;
var __str65362;
var __str66363;
var __str67364;
var __str68365;
var __str69366;
var __str70367;
var __str71368;
var __str72369;
var __str73370;
var __str74371;
var __str75372;
var __str76373;
var __str77374;
var __str78375;
var _option_mbrola_phonemes;
var __ZL10mbrola_tab;
var __ZL15mbr_name_prefix;
var __str382;
var __str1383;
var __str2384;
var __str3385;
var __str4386;
var __ZL14mbrola_control;
var __ZZ15MbrolaTranslateP12PHONEME_LISTiiP7__sFILEE4phix;
var __ZZ15MbrolaTranslateP12PHONEME_LISTiiP7__sFILEE11embedded_ix;
var __ZZ15MbrolaTranslateP12PHONEME_LISTiiP7__sFILEE10word_count;
var __str6388;
var __str8390;
var __str9391;
var __str10392;
var __str11393;
var __str12394;
var __ZZ10MbrolaFilliiE9n_samples;
var __ZZL10WritePitchiiiiiE6output;
var __str13395;
var __str14396;
var __str15397;
var __str16398;
var __ZZL10GetMbrNameP12PHONEME_LISTP11PHONEME_TABS2_S2_PiS3_S3_E4mnem;
var __str399;
var _version_string;
var _version_phdata;
var _option_device_number;
var _f_logespeak;
var _logging_type;
var _n_phoneme_tab;
var _current_phoneme_table;
var _phoneme_tab;
var _phoneme_tab_flags;
var _phoneme_index;
var _phondata_ptr;
var _wavefile_data;
var __ZL16phoneme_tab_data;
var _n_phoneme_tables;
var _phoneme_tab_list;
var _phoneme_tab_number;
var _wavefile_ix;
var _wavefile_amp;
var _wavefile_ix2;
var _wavefile_amp2;
var _seq_len_adjust;
var _vowel_transition;
var _vowel_transition0;
var _vowel_transition1;
var __str1412;
var __str2413;
var __str3414;
var __str4415;
var __ZZ11LookupSpectP11PHONEME_TABiP10FMT_PARAMSPiP12PHONEME_LISTE10frames_buf;
var __str5416;
var __str7418;
var __str9420;
var __str10421;
var __str11422;
var __str13424;
var __str15426;
var __str16427;
var _this_ph_data;
var __ZZL13NumInstnWordsPtE7n_words;
var __ZZL18InterpretConditionP10TranslatoriP12PHONEME_LISTiE11ph_position;
var __ZZL15StressConditionP10TranslatorP12PHONEME_LISTiiE15condition_level;
var __str17428;
var __str18429;
var __str19430;
var _n_phoneme_list;
var _phoneme_list;
var _mbrola_delay;
var _mbrola_name;
var _speed;
var __ZL9new_voice;
var _n_soundicon_tab;
var _soundicon_tab;
var __ZZ12WordToStringjE3buf;
var __ZL14last_pitch_cmd;
var __ZL12last_amp_cmd;
var __ZL10last_frame;
var __ZL15syllable_centre;
var __ZZ18FormantTransition2P10frameref_tRijjP11PHONEME_TABiE10vcolouring;
var __ZL10modn_flags;
var __ZZ8DoSpect2P11PHONEME_TABiP10FMT_PARAMSP12PHONEME_LISTiE9wave_flag_b;
var __ZL13fmt_amplitude;
var __ZL10last_wcmdq;
var __ZL12pitch_length;
var __ZL10amp_length;
var __ZZ8GenerateP12PHONEME_LISTPiiE2ix;
var __ZZ8GenerateP12PHONEME_LISTPiiE11embedded_ix;
var __ZZ8GenerateP12PHONEME_LISTPiiE10word_count;
var __ZZ8GenerateP12PHONEME_LISTPiiE8sourceix;
var __ZL14syllable_start;
var __ZL12syllable_end;
var __ZL8timer_on_b;
var __ZL6paused_b;
var __ZZ15SpeakNextClauseP7__sFILEPKviE6f_text;
var __ZZ15SpeakNextClauseP7__sFILEPKviE6p_text;
var __str459;
var __str1460;
var __ZZL13set_frame_rmsP7frame_tiE8sqrt_tab;
var __ZZL10AllocFramevE2ix;
var __ZZL10AllocFramevE10frame_pool;
var _translator;
var _translator2;
var __ZL20translator2_language;
var _f_trans;
var _option_tone2;
var _option_tone_flags;
var _option_phonemes;
var _option_phoneme_events;
var _option_quiet;
var _option_endpause;
var _option_capitals;
var _option_punctuation;
var _option_sayas;
var _option_ssml;
var _option_phoneme_input;
var _option_phoneme_variants;
var _option_wordgap;
var _skip_sentences;
var _skip_words;
var _skip_characters;
var _skip_marker;
var _skipping_text;
var _end_character_position;
var _count_sentences;
var _count_words;
var _clause_start_char;
var _clause_start_word;
var _new_sentence;
var _pre_pause;
var _word_phonemes;
var _n_ph_list2;
var _ph_list2;
var _option_punctlist;
var _ctrl_embedded;
var _option_multibyte;
var _option_linelength;
var _embedded_list;
var _n_replace_phonemes;
var _replace_phonemes;
var __ZL10ISO_8859_1;
var __ZL10ISO_8859_2;
var __ZL10ISO_8859_3;
var __ZL10ISO_8859_4;
var __ZL10ISO_8859_5;
var __ZL10ISO_8859_7;
var __ZL10ISO_8859_9;
var __ZL11ISO_8859_14;
var __ZL6KOI8_R;
var __ZL5ISCII;
var _charsets;
var __ZL15length_mod_tabs;
var __ZZ7IsAlphajE18extra_indic_alphas;
var __ZL8brackets;
var __ZZ8utf8_outjPcE4code;
var __ZZ8utf8_in2PiPKciE4mask;
var __str543;
var __str1544;
var __ZZ13TranslateWordP10TranslatorPciP8WORD_TABE7word_zz;
var __ZZ13TranslateWordP10TranslatorPciP8WORD_TABE7word_iz;
var __ZZ13TranslateWordP10TranslatorPciP8WORD_TABE7word_ss;
var __str2545;
var __str4547;
var __str5548;
var __str6549;
var __ZL18any_stressed_words_b;
var __ZZ15TranslateClauseP10TranslatorP7__sFILEPKvPiPPcE17voice_change_name;
var __ZL11embedded_ix;
var __ZL13embedded_read;
var __ZL6source;
var __str7550;
var __str8551;
var __ZL16max_clause_pause;
var __ZL13option_sayas2;
var __ZL18count_sayas_digits;
var __ZL6breaks;
var __ZL13word_emphasis_b;
var __ZL15option_emphasis;
var __ZL13embedded_flag_b;
var __str9552;
var __str10553;
var __str11554;
var __ZZL13TranslateCharP10TranslatorPcijjPiE20hangul_compatibility;
var __ZZL14SubstituteCharP10TranslatorjjPiE11ignore_next_b;
var __str12555;
var __ZL14length_mods_en;
var __ZL15length_mods_en0;
var __ZL17length_mods_equal;
var __str580;
var __str1581;
var __str2582;
var __str3583;
var __str4584;
var __ZL14mbr_samplerate;
var __ZL14mbr_voice_path;
var __ZL10mbr_volume;
var __ZL9mbr_state;
var __ZL7mbr_pid;
var __ZL10mbr_cmd_fd;
var __str5585;
var __ZL12mbr_audio_fd;
var __ZL12mbr_errorbuf;
var __ZL12mbr_error_fd;
var __str7587;
var __str8588;
var __str9589;
var __str10590;
var __str11591;
var __str12592;
var __str13593;
var __str14594;
var __str15595;
var __str16596;
var __str17597;
var __ZL21mbr_pending_data_head;
var __ZL21mbr_pending_data_tail;
var __str18598;
var __str19599;
var __str20600;
var __str21601;
var __ZL13mbr_proc_stat;
var __str22602;
var __str23603;
var __str24604;
var __str25605;
var __str27607;
var __str28608;
var __str30610;
var __str31611;
var __str32612;
var __str33613;
var __str34614;
var __str35615;
var __ZZ15SetIndicLettersP10TranslatorE15dev_consonants2;
var __ZZ16SelectTranslatorPKcE17stress_lengths_fr;
var __ZZ16SelectTranslatorPKcE14stress_amps_fr;
var __ZZ16SelectTranslatorPKcE14stress_amps_sk;
var __ZZ16SelectTranslatorPKcE17stress_lengths_sk;
var __ZZ16SelectTranslatorPKcE17stress_lengths_ta;
var __ZZ16SelectTranslatorPKcE14stress_amps_ta;
var __ZZ16SelectTranslatorPKcE17stress_lengths_af;
var __ZZ16SelectTranslatorPKcE17stress_lengths_bn;
var __ZZ16SelectTranslatorPKcE14stress_amps_bn;
var __ZZ16SelectTranslatorPKcE17stress_lengths_cy;
var __ZZ16SelectTranslatorPKcE14stress_amps_cy;
var __ZZ16SelectTranslatorPKcE17stress_lengths_da;
var __ZZ16SelectTranslatorPKcE17stress_lengths_de;
var __ZZ16SelectTranslatorPKcE14stress_amps_de;
var __ZZ16SelectTranslatorPKcE17stress_lengths_en;
var __str630;
var __ZZ16SelectTranslatorPKcE17stress_lengths_el;
var __ZZ16SelectTranslatorPKcE14stress_amps_el;
var __ZZ16SelectTranslatorPKcE9el_vowels;
var __ZZ16SelectTranslatorPKcE10el_fvowels;
var __ZZ16SelectTranslatorPKcE12el_voiceless;
var __ZZ16SelectTranslatorPKcE13el_consonants;
var __ZZ16SelectTranslatorPKcE18el_char_apostrophe;
var __ZZ16SelectTranslatorPKcE17stress_lengths_eo;
var __ZZ16SelectTranslatorPKcE14stress_amps_eo;
var __ZZ16SelectTranslatorPKcE18eo_char_apostrophe;
var __ZZ16SelectTranslatorPKcE17stress_lengths_es;
var __ZZ16SelectTranslatorPKcE14stress_amps_es;
var __ZZ16SelectTranslatorPKcE20ca_punct_within_word;
var __ZZ16SelectTranslatorPKcE17stress_lengths_eu;
var __ZZ16SelectTranslatorPKcE14stress_amps_eu;
var __ZZ16SelectTranslatorPKcE14stress_amps_fi;
var __ZZ16SelectTranslatorPKcE17stress_lengths_fi;
var __ZZ16SelectTranslatorPKcE17stress_lengths_hi;
var __ZZ16SelectTranslatorPKcE14stress_amps_hi;
var __ZZ16SelectTranslatorPKcE14stress_amps_hr;
var __ZZ16SelectTranslatorPKcE17stress_lengths_hr;
var __ZZ16SelectTranslatorPKcE17stress_lengths_sr;
var __ZL22replace_cyrillic_latin;
var __ZZ16SelectTranslatorPKcE14stress_amps_hu;
var __ZZ16SelectTranslatorPKcE17stress_lengths_hu;
var __ZZ16SelectTranslatorPKcE17stress_lengths_hy;
var __ZZ16SelectTranslatorPKcE9hy_vowels;
var __ZZ16SelectTranslatorPKcE13hy_consonants;
var __ZZ16SelectTranslatorPKcE17stress_lengths_id;
var __ZZ16SelectTranslatorPKcE14stress_amps_id;
var __ZZ16SelectTranslatorPKcE17stress_lengths_is;
var __ZZ16SelectTranslatorPKcE16is_lettergroup_B;
var __str1631;
var __str2632;
var __ZZ16SelectTranslatorPKcE17stress_lengths_it;
var __ZZ16SelectTranslatorPKcE14stress_amps_it;
var __ZZ16SelectTranslatorPKcE18stress_lengths_jbo;
var __ZZ16SelectTranslatorPKcE21jbo_punct_within_word;
var __ZZ16SelectTranslatorPKcE9ka_vowels;
var __ZZ16SelectTranslatorPKcE13ka_consonants;
var __ZZ16SelectTranslatorPKcE10ko_ivowels;
var __ZZ16SelectTranslatorPKcE9ko_voiced;
var __ZZ16SelectTranslatorPKcE14stress_amps_ku;
var __ZZ16SelectTranslatorPKcE17stress_lengths_ku;
var __ZZ16SelectTranslatorPKcE14stress_amps_lv;
var __ZZ16SelectTranslatorPKcE17stress_lengths_lv;
var __ZZ16SelectTranslatorPKcE15vowels_cyrillic;
var __ZZ16SelectTranslatorPKcE14stress_amps_mk;
var __ZZ16SelectTranslatorPKcE17stress_lengths_mk;
var __ZZ16SelectTranslatorPKcE17stress_lengths_nl;
var __str3633;
var __ZZ16SelectTranslatorPKcE17stress_lengths_no;
var __ZZ16SelectTranslatorPKcE14stress_amps_om;
var __ZZ16SelectTranslatorPKcE17stress_lengths_om;
var __ZZ16SelectTranslatorPKcE17stress_lengths_pl;
var __ZZ16SelectTranslatorPKcE14stress_amps_pl;
var __ZZ16SelectTranslatorPKcE17stress_lengths_pt;
var __ZZ16SelectTranslatorPKcE14stress_amps_pt;
var __str4634;
var __ZZ16SelectTranslatorPKcE17stress_lengths_ro;
var __ZZ16SelectTranslatorPKcE14stress_amps_ro;
var __str5635;
var __ZZ16SelectTranslatorPKcE17stress_lengths_sq;
var __ZZ16SelectTranslatorPKcE14stress_amps_sq;
var __ZZ16SelectTranslatorPKcE14stress_amps_sv;
var __ZZ16SelectTranslatorPKcE17stress_lengths_sv;
var __ZZ16SelectTranslatorPKcE17stress_lengths_sw;
var __ZZ16SelectTranslatorPKcE14stress_amps_sw;
var __ZZ16SelectTranslatorPKcE14stress_amps_tr;
var __ZZ16SelectTranslatorPKcE17stress_lengths_tr;
var __ZZ16SelectTranslatorPKcE17stress_lengths_vi;
var __ZZ16SelectTranslatorPKcE14stress_amps_vi;
var __ZZ16SelectTranslatorPKcE9vowels_vi;
var __ZZ16SelectTranslatorPKcE17stress_lengths_zh;
var __ZZ16SelectTranslatorPKcE14stress_amps_zh;
var __ZZL18Translator_RussianP10TranslatorE14stress_amps_ru;
var __ZZL18Translator_RussianP10TranslatorE17stress_lengths_ru;
var __ZZL18Translator_RussianP10TranslatorE11ru_ivowels2;
var __ZZL18SetCyrillicLettersP10TranslatorE9ru_vowels;
var __ZZL18SetCyrillicLettersP10TranslatorE13ru_consonants;
var __ZZL18SetCyrillicLettersP10TranslatorE7ru_soft;
var __ZZL18SetCyrillicLettersP10TranslatorE7ru_hard;
var __ZZL18SetCyrillicLettersP10TranslatorE10ru_nothard;
var __ZZL18SetCyrillicLettersP10TranslatorE9ru_voiced;
var __ZZL18SetCyrillicLettersP10TranslatorE10ru_ivowels;
var __ZL8pairs_ru;
var __ZZL13NewTranslatorvE12stress_amps2;
var __ZZL13NewTranslatorvE15stress_lengths2;
var __ZZL13NewTranslatorvE13empty_wstring;
var __ZZL13NewTranslatorvE13punct_in_word;
var __ZZL13NewTranslatorvE13default_tunes;
var __str6636;
var __str7637;
var __str8638;
var __str9639;
var __str10640;
var __str11641;
var __str12642;
var __str13643;
var __str646;
var __str1647;
var __str2648;
var _genders;
var _tone_points;
var _formant_rate;
var _voice_selected;
var __str3653;
var __str4654;
var __ZL11options_tab;
var __str5655;
var __str6656;
var __str7657;
var __str8658;
var __str9659;
var __str10660;
var __str11661;
var __str12662;
var __str13663;
var __str14664;
var __str15665;
var __str16666;
var __str17667;
var __str18668;
var __str19669;
var __str20670;
var __str21671;
var __str22672;
var __str23673;
var __str24674;
var __str25675;
var __str26676;
var __str27677;
var __str28678;
var __str29679;
var __str30680;
var __str31681;
var __str32682;
var __str33683;
var __str34684;
var __str35685;
var __str36686;
var __str37687;
var __str38688;
var __str39689;
var __str40690;
var __str41691;
var __str42692;
var __str43693;
var __ZL11keyword_tab;
var __ZL15variants_either;
var __ZL13variants_male;
var __ZL15variants_female;
var _variant_lists;
var __ZL9voicedata;
var _voice;
var __str44696;
var __ZZ10VoiceResetiE15default_heights;
var __ZZ10VoiceResetiE14default_widths;
var __ZZ10VoiceResetiE13breath_widths;
var __ZL18formant_rate_22050;
var __ZZ9LoadVoicePKciE16voice_identifier;
var __ZZ9LoadVoicePKciE10voice_name;
var __ZZ9LoadVoicePKciE15voice_languages;
var __str45697;
var __str46698;
var __str47699;
var __str48700;
var __str49701;
var __str50702;
var __str51703;
var __str52704;
var __str53705;
var __str54706;
var __str55707;
var __str56708;
var __str57709;
var __str58710;
var __str59711;
var __str60712;
var __str61713;
var __str62714;
var __str63715;
var __str64716;
var __str65717;
var __str66718;
var __str67719;
var __str68720;
var __str69721;
var __ZL13n_voices_list;
var __ZL11voices_list;
var __str70722;
var __ZZ11SelectVoiceP12espeak_VOICEPiE14voice_variants;
var __ZZ11SelectVoiceP12espeak_VOICEPiE8voice_id;
var __ZZ11SelectVoiceP12espeak_VOICEPiE3buf;
var __str71723;
var __ZZ14SetVoiceByNamePKcE3buf;
var __ZZ17espeak_ListVoicesE6voices;
var __str72724;
var __ZL15len_path_voices;
var __str73725;
var __str74726;
var __str75727;
var __ZZL23ExtractVoiceVariantNamePciE12variant_name;
var __str76728;
var __str77729;
var __str78730;
var __str79731;
var __str80732;
var __str81733;
var __str82734;
var _sin_tab;
var _wvoice;
var _f_log;
var _option_waveout;
var _option_log_frames;
var _embedded_value;
var _samplerate;
var _samplerate_native;
var __ZL5peaks;
var _echo_head;
var _echo_tail;
var _echo_amp;
var _echo_buf;
var __ZL7rbreath;
var _wdata;
var __ZL13amplitude_env;
var _out_ptr;
var _out_start;
var _out_end;
var _outbuf_size;
var _wcmdq;
var _wcmdq_head;
var _wcmdq_tail;
var _embedded_default;
var _current_source_index;
var __ZL18sonicSpeedupStream;
var _sonicSpeed;
var _pitch_adjust_tab;
var _pk_shape1;
var __ZL16PHASE_INC_FACTOR;
var __ZL11Flutter_inc;
var __ZL11samplecount;
var __ZL8nsamples;
var __ZL9wavephase;
var __ZL12wavemult_max;
var __ZL15wavemult_offset;
var __ZL8wavemult;
var __ZL9pk_shape2;
var __ZL8pk_shape;
var __ZZ12GetAmplitudevE12amp_emphasis;
var __ZL17general_amplitude;
var __ZL11peak_height;
var __ZL13peak_harmonic;
var __ZL16option_harmonic1_b;
var __ZL9harmspect;
var __ZL8harm_inc;
var __ZL10minus_pi_t;
var __ZL8two_pi_t;
var __ZZ7WavegenvE4maxh;
var __ZZ7WavegenvE5maxh2;
var __ZZ7WavegenvE3agc;
var __ZZ7WavegenvE13h_switch_sign;
var __ZZ7WavegenvE11cycle_count;
var __ZZ7WavegenvE10amplitude2;
var __ZL8end_wave_b;
var __ZL7hswitch;
var __ZL6hspect;
var __ZL8phaseinc;
var __ZL13cycle_samples;
var __ZL9hf_factor;
var __ZL6cbytes;
var __ZL12glottal_flag;
var __ZL14glottal_reduce;
var __ZL6amp_ix;
var __ZL15modulation_type;
var __ZL14modulation_tab;
var __ZL7voicing;
var __ZL12embedded_max;
var __ZZ15WavegenSetVoiceP7voice_tE2v2;
var __ZL13consonant_amp;
var __ZL11flutter_amp;
var __ZZ8SetSynthiiP7frame_tS0_P7voice_tE19glottal_reduce_tab1;
var __ZZ8SetSynthiiP7frame_tS0_P7voice_tE19glottal_reduce_tab2;
var __ZL17samplecount_start;
var __ZZ12WavegenFill2iE6resume;
var __ZZ12WavegenFill2iE13echo_complete;
var __ZL11echo_length;
var __ZL7amp_inc;
var __ZZL8PlayWaveiiPhiiE9n_samples;
var __ZZL8PlayWaveiiPhiiE2ix;
var __ZZL11PlaySilenceiiE9n_samples;
var __ZZL17AdvanceParametersvE10Flutter_ix;
var __ZL11Flutter_tab;
var _pause_phonemes;
var __ZZ15MakePhonemeListP10TranslatoriiE12types_double;
var __ZL8kt_frame;
var __ZL10kt_globals;
var __ZL5peaks801;
var __ZL12sample_count;
var __ZL8nsamples802;
var __ZL6klattp;
var __ZL10klattp_inc;
var __ZL7klattp1;
var __ZL8end_wave803;
var __ZZ14SetSynth_KlattiiP7frame_tS0_P7voice_tiE7prev_fr;
var __ZL13scale_wav_tab;
var __ZZ9KlattInitvE15natural_samples;
var __ZZ9KlattInitvE10formant_hz;
var __ZZ9KlattInitvE9bandwidth;
var __ZZ9KlattInitvE12parallel_amp;
var __ZZ9KlattInitvE11parallel_bw;
var __ZZL7parwaveP13klatt_frame_tE5noise;
var __ZZL7parwaveP13klatt_frame_tE5voice;
var __ZZL7parwaveP13klatt_frame_tE5vlast;
var __ZZL7parwaveP13klatt_frame_tE8glotlast;
var __ZZL7parwaveP13klatt_frame_tE5sourc;
var __ZZL21pitch_synch_par_resetP13klatt_frame_tE4skew;
var __ZZL21pitch_synch_par_resetP13klatt_frame_tE2B0;
var __ZZL7DBtoLINlE8amptable;
var __ZZL14natural_sourcevE5vwave;
var __ZZL16impulsive_sourcevE7doublet;
var __ZZL16impulsive_sourcevE5vwave;
var __ZZL9gen_noisedE5nlast;
var __ZZL7flutterP13klatt_frame_tE10time_count;
var __ZZL10frame_initP13klatt_frame_tE14amp_par_factor;
var __str810;
var __str1811;
var _optarg;
var _optind;
var _opterr;
var _optopt;
var __ZL8optwhere;
var __str831;
var __str1832;
var __str2833;
var __str3834;
var __str4835;
var __str5836;
var __str6837;
var _llvm_dbg_declare; // stub for _llvm_dbg_declare

  
  
  var ERRNO_CODES={E2BIG: 7, EACCES: 13, EADDRINUSE: 98, EADDRNOTAVAIL: 99, EAFNOSUPPORT: 97, EAGAIN: 11, EALREADY: 114, EBADF: 9, EBADMSG: 74, EBUSY: 16, ECANCELED: 125, ECHILD: 10, ECONNABORTED: 103, ECONNREFUSED: 111, ECONNRESET: 104, EDEADLK: 35, EDESTADDRREQ: 89, EDOM: 33, EDQUOT: 122, EEXIST: 17, EFAULT: 14, EFBIG: 27, EHOSTUNREACH: 113, EIDRM: 43, EILSEQ: 84, EINPROGRESS: 115, EINTR: 4, EINVAL: 22, EIO: 5, EISCONN: 106, EISDIR: 21, ELOOP: 40, EMFILE: 24, EMLINK: 31, EMSGSIZE: 90, EMULTIHOP: 72, ENAMETOOLONG: 36, ENETDOWN: 100, ENETRESET: 102, ENETUNREACH: 101, ENFILE: 23, ENOBUFS: 105, ENODATA: 61, ENODEV: 19, ENOENT: 2, ENOEXEC: 8, ENOLCK: 37, ENOLINK: 67, ENOMEM: 12, ENOMSG: 42, ENOPROTOOPT: 92, ENOSPC: 28, ENOSR: 63, ENOSTR: 60, ENOSYS: 38, ENOTCONN: 107, ENOTDIR: 20, ENOTEMPTY: 39, ENOTRECOVERABLE: 131, ENOTSOCK: 88, ENOTSUP: 95, ENOTTY: 25, ENXIO: 6, EOVERFLOW: 75, EOWNERDEAD: 130, EPERM: 1, EPIPE: 32, EPROTO: 71, EPROTONOSUPPORT: 93, EPROTOTYPE: 91, ERANGE: 34, EROFS: 30, ESPIPE: 29, ESRCH: 3, ESTALE: 116, ETIME: 62, ETIMEDOUT: 110, ETXTBSY: 26, EWOULDBLOCK: 11, EXDEV: 18 };
  
  function ___setErrNo(value) {
      // For convenient setting and returning of errno.
      if (!___setErrNo.ret) ___setErrNo.ret = allocate([0], 'i32', ALLOC_STATIC);
      HEAP32[((___setErrNo.ret)>>2)]=value;
      return value;
    }
  
  var _stdin=0;
  
  var _stdout=0;
  
  var _stderr=0;
  
  var __impure_ptr=0;
  var FS={currentPath: "/", nextInode: 2, streams: [null], ignorePermissions: true, absolutePath: function (relative, base) {
        if (typeof relative !== 'string') return null;
        if (base === undefined) base = FS.currentPath;
        if (relative && relative[0] == '/') base = '';
        var full = base + '/' + relative;
        var parts = full.split('/').reverse();
        var absolute = [''];
        while (parts.length) {
          var part = parts.pop();
          if (part == '' || part == '.') {
            // Nothing.
          } else if (part == '..') {
            if (absolute.length > 1) absolute.pop();
          } else {
            absolute.push(part);
          }
        }
        return absolute.length == 1 ? '/' : absolute.join('/');
      }, analyzePath: function (path, dontResolveLastLink, linksVisited) {
        var ret = {
          isRoot: false,
          exists: false,
          error: 0,
          name: null,
          path: null,
          object: null,
          parentExists: false,
          parentPath: null,
          parentObject: null
        };
        path = FS.absolutePath(path);
        if (path == '/') {
          ret.isRoot = true;
          ret.exists = ret.parentExists = true;
          ret.name = '/';
          ret.path = ret.parentPath = '/';
          ret.object = ret.parentObject = FS.root;
        } else if (path !== null) {
          linksVisited = linksVisited || 0;
          path = path.slice(1).split('/');
          var current = FS.root;
          var traversed = [''];
          while (path.length) {
            if (path.length == 1 && current.isFolder) {
              ret.parentExists = true;
              ret.parentPath = traversed.length == 1 ? '/' : traversed.join('/');
              ret.parentObject = current;
              ret.name = path[0];
            }
            var target = path.shift();
            if (!current.isFolder) {
              ret.error = ERRNO_CODES.ENOTDIR;
              break;
            } else if (!current.read) {
              ret.error = ERRNO_CODES.EACCES;
              break;
            } else if (!current.contents.hasOwnProperty(target)) {
              ret.error = ERRNO_CODES.ENOENT;
              break;
            }
            current = current.contents[target];
            if (current.link && !(dontResolveLastLink && path.length == 0)) {
              if (linksVisited > 40) { // Usual Linux SYMLOOP_MAX.
                ret.error = ERRNO_CODES.ELOOP;
                break;
              }
              var link = FS.absolutePath(current.link, traversed.join('/'));
              return FS.analyzePath([link].concat(path).join('/'),
                                    dontResolveLastLink, linksVisited + 1);
            }
            traversed.push(target);
            if (path.length == 0) {
              ret.exists = true;
              ret.path = traversed.join('/');
              ret.object = current;
            }
          }
          return ret;
        }
        return ret;
      }, findObject: function (path, dontResolveLastLink) {
        FS.ensureRoot();
        var ret = FS.analyzePath(path, dontResolveLastLink);
        if (ret.exists) {
          return ret.object;
        } else {
          ___setErrNo(ret.error);
          return null;
        }
      }, createObject: function (parent, name, properties, canRead, canWrite) {
        if (!parent) parent = '/';
        if (typeof parent === 'string') parent = FS.findObject(parent);
  
        if (!parent) {
          ___setErrNo(ERRNO_CODES.EACCES);
          throw new Error('Parent path must exist.');
        }
        if (!parent.isFolder) {
          ___setErrNo(ERRNO_CODES.ENOTDIR);
          throw new Error('Parent must be a folder.');
        }
        if (!parent.write && !FS.ignorePermissions) {
          ___setErrNo(ERRNO_CODES.EACCES);
          throw new Error('Parent folder must be writeable.');
        }
        if (!name || name == '.' || name == '..') {
          ___setErrNo(ERRNO_CODES.ENOENT);
          throw new Error('Name must not be empty.');
        }
        if (parent.contents.hasOwnProperty(name)) {
          ___setErrNo(ERRNO_CODES.EEXIST);
          throw new Error("Can't overwrite object.");
        }
  
        parent.contents[name] = {
          read: canRead === undefined ? true : canRead,
          write: canWrite === undefined ? false : canWrite,
          timestamp: Date.now(),
          inodeNumber: FS.nextInode++
        };
        for (var key in properties) {
          if (properties.hasOwnProperty(key)) {
            parent.contents[name][key] = properties[key];
          }
        }
  
        return parent.contents[name];
      }, createFolder: function (parent, name, canRead, canWrite) {
        var properties = {isFolder: true, isDevice: false, contents: {}};
        return FS.createObject(parent, name, properties, canRead, canWrite);
      }, createPath: function (parent, path, canRead, canWrite) {
        var current = FS.findObject(parent);
        if (current === null) throw new Error('Invalid parent.');
        path = path.split('/').reverse();
        while (path.length) {
          var part = path.pop();
          if (!part) continue;
          if (!current.contents.hasOwnProperty(part)) {
            FS.createFolder(current, part, canRead, canWrite);
          }
          current = current.contents[part];
        }
        return current;
      }, createFile: function (parent, name, properties, canRead, canWrite) {
        properties.isFolder = false;
        return FS.createObject(parent, name, properties, canRead, canWrite);
      }, createDataFile: function (parent, name, data, canRead, canWrite) {
        if (typeof data === 'string') {
          var dataArray = [];
          for (var i = 0; i < data.length; i++) dataArray.push(data.charCodeAt(i));
          data = dataArray;
        }
        var properties = {isDevice: false, contents: data};
        return FS.createFile(parent, name, properties, canRead, canWrite);
      }, createLazyFile: function (parent, name, url, canRead, canWrite) {
        var properties = {isDevice: false, url: url};
        return FS.createFile(parent, name, properties, canRead, canWrite);
      }, createLink: function (parent, name, target, canRead, canWrite) {
        var properties = {isDevice: false, link: target};
        return FS.createFile(parent, name, properties, canRead, canWrite);
      }, createDevice: function (parent, name, input, output) {
        if (!(input || output)) {
          throw new Error('A device must have at least one callback defined.');
        }
        var ops = {isDevice: true, input: input, output: output};
        return FS.createFile(parent, name, ops, Boolean(input), Boolean(output));
      }, forceLoadFile: function (obj) {
        if (obj.isDevice || obj.isFolder || obj.link || obj.contents) return true;
        var success = true;
        if (typeof XMLHttpRequest !== 'undefined') {
          // Browser.
          // TODO: Use mozResponseArrayBuffer, responseStream, etc. if available.
          var xhr = new XMLHttpRequest();
          xhr.open('GET', obj.url, false);
  
          // Some hints to the browser that we want binary data.
          if (typeof Uint8Array != 'undefined') xhr.responseType = 'arraybuffer';
          if (xhr.overrideMimeType) {
            xhr.overrideMimeType('text/plain; charset=x-user-defined');
          }
  
          xhr.send(null);
          if (xhr.status != 200 && xhr.status != 0) success = false;
          if (xhr.response !== undefined) {
            obj.contents = new Uint8Array(xhr.response || []);
          } else {
            obj.contents = intArrayFromString(xhr.responseText || '', true);
          }
        } else if (typeof read !== 'undefined') {
          // Command-line.
          try {
            // WARNING: Can't read binary files in V8's d8 or tracemonkey's js, as
            //          read() will try to parse UTF8.
            obj.contents = intArrayFromString(read(obj.url), true);
          } catch (e) {
            success = false;
          }
        } else {
          throw new Error('Cannot load without read() or XMLHttpRequest.');
        }
        if (!success) ___setErrNo(ERRNO_CODES.EIO);
        return success;
      }, ensureRoot: function () {
        if (FS.root) return;
        // The main file system tree. All the contents are inside this.
        FS.root = {
          read: true,
          write: false,
          isFolder: true,
          isDevice: false,
          timestamp: Date.now(),
          inodeNumber: 1,
          contents: {}
        };
      }, init: function (input, output, error) {
        // Make sure we initialize only once.
        if (FS.init.initialized) return;
        FS.init.initialized = true;
  
        FS.ensureRoot();
  
        // Default handlers.
        if (!input) input = function() {
          if (!input.cache || !input.cache.length) {
            var result;
            if (typeof window != 'undefined' &&
                typeof window.prompt == 'function') {
              // Browser.
              result = window.prompt('Input: ');
            } else if (typeof readline == 'function') {
              // Command line.
              result = readline();
            }
            if (!result) result = '';
            input.cache = intArrayFromString(result + '\n', true);
          }
          return input.cache.shift();
        };
        if (!output) output = function(val) {
          if (val === null || val === '\n'.charCodeAt(0)) {
            output.printer(output.buffer.join(''));
            output.buffer = [];
          } else {
            output.buffer.push(String.fromCharCode(val));
          }
        };
        if (!output.printer) output.printer = vprint;
        if (!output.buffer) output.buffer = [];
        if (!error) error = output;
  
        // Create the temporary folder.
        FS.createFolder('/', 'tmp', true, true);
  
        // Create the I/O devices.
        var devFolder = FS.createFolder('/', 'dev', true, false);
        var stdin = FS.createDevice(devFolder, 'stdin', input);
        var stdout = FS.createDevice(devFolder, 'stdout', null, output);
        var stderr = FS.createDevice(devFolder, 'stderr', null, error);
        FS.createDevice(devFolder, 'tty', input, output);
  
        // Create default streams.
        FS.streams[1] = {
          path: '/dev/stdin',
          object: stdin,
          position: 0,
          isRead: true,
          isWrite: false,
          isAppend: false,
          error: false,
          eof: false,
          ungotten: []
        };
        FS.streams[2] = {
          path: '/dev/stdout',
          object: stdout,
          position: 0,
          isRead: false,
          isWrite: true,
          isAppend: false,
          error: false,
          eof: false,
          ungotten: []
        };
        FS.streams[3] = {
          path: '/dev/stderr',
          object: stderr,
          position: 0,
          isRead: false,
          isWrite: true,
          isAppend: false,
          error: false,
          eof: false,
          ungotten: []
        };
        _stdin = allocate([1], 'void*', ALLOC_STATIC);
        _stdout = allocate([2], 'void*', ALLOC_STATIC);
        _stderr = allocate([3], 'void*', ALLOC_STATIC);
  
        // Newlib initialization
        FS.streams[_stdin] = FS.streams[1];
        FS.streams[_stdout] = FS.streams[2];
        FS.streams[_stderr] = FS.streams[3];
        __impure_ptr = allocate([ allocate(
          [0, 0, 0, 0, _stdin, 0, 0, 0, _stdout, 0, 0, 0, _stderr, 0, 0, 0],
          'void*', ALLOC_STATIC) ], 'void*', ALLOC_STATIC);
  
        // Once initialized, permissions start having effect.
        FS.ignorePermissions = false;
      }, quit: function () {
        // Flush any partially-printed lines in stdout and stderr
        if (FS.streams[2].object.output.buffer.length > 0) FS.streams[2].object.output('\n'.charCodeAt(0));
        if (FS.streams[3].object.output.buffer.length > 0) FS.streams[3].object.output('\n'.charCodeAt(0));
      } };
  
  var ___stat_struct_layout={__size__: 80, st_dev: 0, st_ino: 8, st_mode: 12, st_nlink: 16, st_uid: 20, st_gid: 24, st_rdev: 28, st_size: 36, st_atime: 40, st_spare1: 44, st_mtime: 48, st_spare2: 52, st_ctime: 56, st_spare3: 60, st_blksize: 64, st_blocks: 68, st_spare4: 72 };function _stat(path, buf, dontResolveLastLink) {
      // http://pubs.opengroup.org/onlinepubs/7908799/xsh/stat.html
      // int stat(const char *path, struct stat *buf);
      // NOTE: dontResolveLastLink is a shortcut for lstat(). It should never be
      //       used in client code.
      var obj = FS.findObject(Pointer_stringify(path), dontResolveLastLink);
      if (obj === null || !FS.forceLoadFile(obj)) return -1;
  
      var offsets = ___stat_struct_layout;
  
      // Constants.
      HEAP32[((buf+offsets.st_nlink)>>2)]=1;
      HEAP32[((buf+offsets.st_uid)>>2)]=0;
      HEAP32[((buf+offsets.st_gid)>>2)]=0;
      HEAP32[((buf+offsets.st_blksize)>>2)]=4096;
  
      // Variables.
      HEAP32[((buf+offsets.st_ino)>>2)]=obj.inodeNumber;
      var time = Math.floor(obj.timestamp / 1000);
      if (offsets.st_atime === undefined) {
        offsets.st_atime = offsets.st_atim.tv_sec;
        offsets.st_mtime = offsets.st_mtim.tv_sec;
        offsets.st_ctime = offsets.st_ctim.tv_sec;
        var nanosec = (obj.timestamp % 1000) * 1000;
        HEAP32[((buf+offsets.st_atim.tv_nsec)>>2)]=nanosec;
        HEAP32[((buf+offsets.st_mtim.tv_nsec)>>2)]=nanosec;
        HEAP32[((buf+offsets.st_ctim.tv_nsec)>>2)]=nanosec;
      }
      HEAP32[((buf+offsets.st_atime)>>2)]=time;
      HEAP32[((buf+offsets.st_mtime)>>2)]=time;
      HEAP32[((buf+offsets.st_ctime)>>2)]=time;
      var mode = 0;
      var size = 0;
      var blocks = 0;
      var dev = 0;
      var rdev = 0;
      if (obj.isDevice) {
        //  Device numbers reuse inode numbers.
        dev = rdev = obj.inodeNumber;
        size = blocks = 0;
        mode = 0x2000;  // S_IFCHR.
      } else {
        dev = 1;
        rdev = 0;
        // NOTE: In our implementation, st_blocks = Math.ceil(st_size/st_blksize),
        //       but this is not required by the standard.
        if (obj.isFolder) {
          size = 4096;
          blocks = 1;
          mode = 0x4000;  // S_IFDIR.
        } else {
          var data = obj.contents || obj.link;
          size = data.length;
          blocks = Math.ceil(data.length / 4096);
          mode = obj.link === undefined ? 0x8000 : 0xA000;  // S_IFREG, S_IFLNK.
        }
      }
      HEAP32[((buf+offsets.st_dev)>>2)]=dev;
      HEAP32[((buf+offsets.st_rdev)>>2)]=rdev;
      // NOTE: These two may be i64, depending on compilation options.
      HEAP32[((buf+offsets.st_size)>>2)]=size;
      HEAP32[((buf+offsets.st_blocks)>>2)]=blocks;
      if (obj.read) mode |= 0x16D;  // S_IRUSR | S_IXUSR | S_IRGRP | S_IXGRP | S_IROTH | S_IXOTH.
      if (obj.write) mode |= 0x92;  // S_IWUSR | S_IWGRP | S_IWOTH.
      HEAP32[((buf+offsets.st_mode)>>2)]=mode;
  
      return 0;
    }

  function _malloc(size) { var ret = STATICTOP; STATICTOP += size;STATICTOP = Math.ceil((STATICTOP)/4)*4;; return ret; }

  
  
  
  
  
  
  
  
  
  function _pwrite(fildes, buf, nbyte, offset) {
      // ssize_t pwrite(int fildes, const void *buf, size_t nbyte, off_t offset);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/write.html
      var stream = FS.streams[fildes];
      if (!stream || stream.object.isDevice) {
        ___setErrNo(ERRNO_CODES.EBADF);
        return -1;
      } else if (!stream.isWrite) {
        ___setErrNo(ERRNO_CODES.EACCES);
        return -1;
      } else if (stream.object.isFolder) {
        ___setErrNo(ERRNO_CODES.EISDIR);
        return -1;
      } else if (nbyte < 0 || offset < 0) {
        ___setErrNo(ERRNO_CODES.EINVAL);
        return -1;
      } else {
        var contents = stream.object.contents;
        while (contents.length < offset) contents.push(0);
        for (var i = 0; i < nbyte; i++) {
          contents[offset + i] = HEAP8[(buf+i)];
        }
        stream.object.timestamp = Date.now();
        return i;
      }
    }function _write(fildes, buf, nbyte) {
      // ssize_t write(int fildes, const void *buf, size_t nbyte);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/write.html
      var stream = FS.streams[fildes];
      if (!stream) {
        ___setErrNo(ERRNO_CODES.EBADF);
        return -1;
      } else if (!stream.isWrite) {
        ___setErrNo(ERRNO_CODES.EACCES);
        return -1;
      } else if (nbyte < 0) {
        ___setErrNo(ERRNO_CODES.EINVAL);
        return -1;
      } else {
        if (stream.object.isDevice) {
          if (stream.object.output) {
            for (var i = 0; i < nbyte; i++) {
              try {
                stream.object.output(HEAP8[(buf+i)]);
              } catch (e) {
                ___setErrNo(ERRNO_CODES.EIO);
                return -1;
              }
            }
            stream.object.timestamp = Date.now();
            return i;
          } else {
            ___setErrNo(ERRNO_CODES.ENXIO);
            return -1;
          }
        } else {
          var bytesWritten = _pwrite(fildes, buf, nbyte, stream.position);
          if (bytesWritten != -1) stream.position += bytesWritten;
          return bytesWritten;
        }
      }
    }function _fwrite(ptr, size, nitems, stream) {
      // size_t fwrite(const void *restrict ptr, size_t size, size_t nitems, FILE *restrict stream);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/fwrite.html
      var bytesToWrite = nitems * size;
      if (bytesToWrite == 0) return 0;
      var bytesWritten = _write(stream, ptr, bytesToWrite);
      if (bytesWritten == -1) {
        if (FS.streams[stream]) FS.streams[stream].error = true;
        return -1;
      } else {
        return Math.floor(bytesWritten / size);
      }
    }
  
  function __formatString(format, varargs) {
      var textIndex = format;
      var argIndex = 0;
      var getNextArg = function(type) {
        // NOTE: Explicitly ignoring type safety. Otherwise this fails:
        //       int x = 4; printf("%c\n", (char)x);
        var ret;
        if (type === 'float' || type === 'double') {
          ret = HEAPF32[((varargs+argIndex)>>2)];
        } else {
          ret = HEAP32[((varargs+argIndex)>>2)];
        }
        argIndex += Runtime.getNativeFieldSize(type);
        return Number(ret);
      };
  
      var ret = [];
      var curr, next, currArg;
      while(1) {
        var startTextIndex = textIndex;
        curr = HEAP8[(textIndex)];
        if (curr === 0) break;
        next = HEAP8[(textIndex+1)];
        if (curr == '%'.charCodeAt(0)) {
          // Handle flags.
          var flagAlwaysSigned = false;
          var flagLeftAlign = false;
          var flagAlternative = false;
          var flagZeroPad = false;
          flagsLoop: while (1) {
            switch (next) {
              case '+'.charCodeAt(0):
                flagAlwaysSigned = true;
                break;
              case '-'.charCodeAt(0):
                flagLeftAlign = true;
                break;
              case '#'.charCodeAt(0):
                flagAlternative = true;
                break;
              case '0'.charCodeAt(0):
                if (flagZeroPad) {
                  break flagsLoop;
                } else {
                  flagZeroPad = true;
                  break;
                }
              default:
                break flagsLoop;
            }
            textIndex++;
            next = HEAP8[(textIndex+1)];
          }
  
          // Handle width.
          var width = 0;
          if (next == '*'.charCodeAt(0)) {
            width = getNextArg('i32');
            textIndex++;
            next = HEAP8[(textIndex+1)];
          } else {
            while (next >= '0'.charCodeAt(0) && next <= '9'.charCodeAt(0)) {
              width = width * 10 + (next - '0'.charCodeAt(0));
              textIndex++;
              next = HEAP8[(textIndex+1)];
            }
          }
  
          // Handle precision.
          var precisionSet = false;
          if (next == '.'.charCodeAt(0)) {
            var precision = 0;
            precisionSet = true;
            textIndex++;
            next = HEAP8[(textIndex+1)];
            if (next == '*'.charCodeAt(0)) {
              precision = getNextArg('i32');
              textIndex++;
            } else {
              while(1) {
                var precisionChr = HEAP8[(textIndex+1)];
                if (precisionChr < '0'.charCodeAt(0) ||
                    precisionChr > '9'.charCodeAt(0)) break;
                precision = precision * 10 + (precisionChr - '0'.charCodeAt(0));
                textIndex++;
              }
            }
            next = HEAP8[(textIndex+1)];
          } else {
            var precision = 6; // Standard default.
          }
  
          // Handle integer sizes. WARNING: These assume a 32-bit architecture!
          var argSize;
          switch (String.fromCharCode(next)) {
            case 'h':
              var nextNext = HEAP8[(textIndex+2)];
              if (nextNext == 'h'.charCodeAt(0)) {
                textIndex++;
                argSize = 1; // char
              } else {
                argSize = 2; // short
              }
              break;
            case 'l':
              var nextNext = HEAP8[(textIndex+2)];
              if (nextNext == 'l'.charCodeAt(0)) {
                textIndex++;
                argSize = 8; // long long
              } else {
                argSize = 4; // long
              }
              break;
            case 'L': // long long
            case 'q': // int64_t
            case 'j': // intmax_t
              argSize = 8;
              break;
            case 'z': // size_t
            case 't': // ptrdiff_t
            case 'I': // signed ptrdiff_t or unsigned size_t
              argSize = 4;
              break;
            default:
              argSize = undefined;
          }
          if (argSize !== undefined) textIndex++;
          next = HEAP8[(textIndex+1)];
  
          // Handle type specifier.
          if (['d', 'i', 'u', 'o', 'x', 'X', 'p'].indexOf(String.fromCharCode(next)) != -1) {
            // Integer.
            var signed = next == 'd'.charCodeAt(0) || next == 'i'.charCodeAt(0);
            argSize = argSize || 4;
            var currArg = getNextArg('i' + (argSize * 8));
            // Truncate to requested size.
            if (argSize <= 4) {
              var limit = Math.pow(256, argSize) - 1;
              currArg = (signed ? reSign : unSign)(currArg & limit, argSize * 8);
            }
            // Format the number.
            var currAbsArg = Math.abs(currArg);
            var argText;
            var prefix = '';
            if (next == 'd'.charCodeAt(0) || next == 'i'.charCodeAt(0)) {
              argText = reSign(currArg, 8 * argSize, 1).toString(10);
            } else if (next == 'u'.charCodeAt(0)) {
              argText = unSign(currArg, 8 * argSize, 1).toString(10);
              currArg = Math.abs(currArg);
            } else if (next == 'o'.charCodeAt(0)) {
              argText = (flagAlternative ? '0' : '') + currAbsArg.toString(8);
            } else if (next == 'x'.charCodeAt(0) || next == 'X'.charCodeAt(0)) {
              prefix = flagAlternative ? '0x' : '';
              if (currArg < 0) {
                // Represent negative numbers in hex as 2's complement.
                currArg = -currArg;
                argText = (currAbsArg - 1).toString(16);
                var buffer = [];
                for (var i = 0; i < argText.length; i++) {
                  buffer.push((0xF - parseInt(argText[i], 16)).toString(16));
                }
                argText = buffer.join('');
                while (argText.length < argSize * 2) argText = 'f' + argText;
              } else {
                argText = currAbsArg.toString(16);
              }
              if (next == 'X'.charCodeAt(0)) {
                prefix = prefix.toUpperCase();
                argText = argText.toUpperCase();
              }
            } else if (next == 'p'.charCodeAt(0)) {
              if (currAbsArg === 0) {
                argText = '(nil)';
              } else {
                prefix = '0x';
                argText = currAbsArg.toString(16);
              }
            }
            if (precisionSet) {
              while (argText.length < precision) {
                argText = '0' + argText;
              }
            }
  
            // Add sign if needed
            if (flagAlwaysSigned) {
              if (currArg < 0) {
                prefix = '-' + prefix;
              } else {
                prefix = '+' + prefix;
              }
            }
  
            // Add padding.
            while (prefix.length + argText.length < width) {
              if (flagLeftAlign) {
                argText += ' ';
              } else {
                if (flagZeroPad) {
                  argText = '0' + argText;
                } else {
                  prefix = ' ' + prefix;
                }
              }
            }
  
            // Insert the result into the buffer.
            argText = prefix + argText;
            argText.split('').forEach(function(chr) {
              ret.push(chr.charCodeAt(0));
            });
          } else if (['f', 'F', 'e', 'E', 'g', 'G'].indexOf(String.fromCharCode(next)) != -1) {
            // Float.
            var currArg = getNextArg(argSize === 4 ? 'float' : 'double');
            var argText;
  
            if (isNaN(currArg)) {
              argText = 'nan';
              flagZeroPad = false;
            } else if (!isFinite(currArg)) {
              argText = (currArg < 0 ? '-' : '') + 'inf';
              flagZeroPad = false;
            } else {
              var isGeneral = false;
              var effectivePrecision = Math.min(precision, 20);
  
              // Convert g/G to f/F or e/E, as per:
              // http://pubs.opengroup.org/onlinepubs/9699919799/functions/printf.html
              if (next == 'g'.charCodeAt(0) || next == 'G'.charCodeAt(0)) {
                isGeneral = true;
                precision = precision || 1;
                var exponent = parseInt(currArg.toExponential(effectivePrecision).split('e')[1], 10);
                if (precision > exponent && exponent >= -4) {
                  next = ((next == 'g'.charCodeAt(0)) ? 'f' : 'F').charCodeAt(0);
                  precision -= exponent + 1;
                } else {
                  next = ((next == 'g'.charCodeAt(0)) ? 'e' : 'E').charCodeAt(0);
                  precision--;
                }
                effectivePrecision = Math.min(precision, 20);
              }
  
              if (next == 'e'.charCodeAt(0) || next == 'E'.charCodeAt(0)) {
                argText = currArg.toExponential(effectivePrecision);
                // Make sure the exponent has at least 2 digits.
                if (/[eE][-+]\d$/.test(argText)) {
                  argText = argText.slice(0, -1) + '0' + argText.slice(-1);
                }
              } else if (next == 'f'.charCodeAt(0) || next == 'F'.charCodeAt(0)) {
                argText = currArg.toFixed(effectivePrecision);
              }
  
              var parts = argText.split('e');
              if (isGeneral && !flagAlternative) {
                // Discard trailing zeros and periods.
                while (parts[0].length > 1 && parts[0].indexOf('.') != -1 &&
                       (parts[0].slice(-1) == '0' || parts[0].slice(-1) == '.')) {
                  parts[0] = parts[0].slice(0, -1);
                }
              } else {
                // Make sure we have a period in alternative mode.
                if (flagAlternative && argText.indexOf('.') == -1) parts[0] += '.';
                // Zero pad until required precision.
                while (precision > effectivePrecision++) parts[0] += '0';
              }
              argText = parts[0] + (parts.length > 1 ? 'e' + parts[1] : '');
  
              // Capitalize 'E' if needed.
              if (next == 'E'.charCodeAt(0)) argText = argText.toUpperCase();
  
              // Add sign.
              if (flagAlwaysSigned && currArg >= 0) {
                argText = '+' + argText;
              }
            }
  
            // Add padding.
            while (argText.length < width) {
              if (flagLeftAlign) {
                argText += ' ';
              } else {
                if (flagZeroPad && (argText[0] == '-' || argText[0] == '+')) {
                  argText = argText[0] + '0' + argText.slice(1);
                } else {
                  argText = (flagZeroPad ? '0' : ' ') + argText;
                }
              }
            }
  
            // Adjust case.
            if (next < 'a'.charCodeAt(0)) argText = argText.toUpperCase();
  
            // Insert the result into the buffer.
            argText.split('').forEach(function(chr) {
              ret.push(chr.charCodeAt(0));
            });
          } else if (next == 's'.charCodeAt(0)) {
            // String.
            var arg = getNextArg('i8*');
            var copiedString;
            if (arg) {
              copiedString = String_copy(arg);
              if (precisionSet && copiedString.length > precision) {
                copiedString = copiedString.slice(0, precision);
              }
            } else {
              copiedString = intArrayFromString('(null)', true);
            }
            if (!flagLeftAlign) {
              while (copiedString.length < width--) {
                ret.push(' '.charCodeAt(0));
              }
            }
            ret = ret.concat(copiedString);
            if (flagLeftAlign) {
              while (copiedString.length < width--) {
                ret.push(' '.charCodeAt(0));
              }
            }
          } else if (next == 'c'.charCodeAt(0)) {
            // Character.
            if (flagLeftAlign) ret.push(getNextArg('i8'));
            while (--width > 0) {
              ret.push(' '.charCodeAt(0));
            }
            if (!flagLeftAlign) ret.push(getNextArg('i8'));
          } else if (next == 'n'.charCodeAt(0)) {
            // Write the length written so far to the next parameter.
            var ptr = getNextArg('i32*');
            HEAP32[((ptr)>>2)]=ret.length;
          } else if (next == '%'.charCodeAt(0)) {
            // Literal percent sign.
            ret.push(curr);
          } else {
            // Unknown specifiers remain untouched.
            for (var i = startTextIndex; i < textIndex + 2; i++) {
              ret.push(HEAP8[(i)]);
            }
          }
          textIndex += 2;
          // TODO: Support a/A (hex float) and m (last error) specifiers.
          // TODO: Support %1${specifier} for arg selection.
        } else {
          ret.push(curr);
          textIndex += 1;
        }
      }
      return ret;
    }function _fprintf(stream, format, varargs) {
      // int fprintf(FILE *restrict stream, const char *restrict format, ...);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/printf.html
      var result = __formatString(format, varargs);
      var stack = Runtime.stackSave();
      var ret = _fwrite(allocate(result, 'i8', ALLOC_STACK), 1, result.length, stream);
      Runtime.stackRestore(stack);
      return ret;
    }

  function _free(){}

  function _strlen(ptr) {
      return String_len(ptr);
    }

  function _strcpy(pdest, psrc) {
      var i = 0;
      do {
        var $src$, $dest$, $stop$, $stop4$, $fast$;
  $src$ = psrc+i;
  $dest$ = pdest+i;
  $stop$ = $src$ + 1;
  if (($dest$%4) == ($src$%4) && 1 > 8) {
    while ($src$%4 !== 0 && $src$ < $stop$) {
      ; HEAP8[$dest$++] = HEAP8[$src$++];
    }
    $src$ >>= 2;
    $dest$ >>= 2;
    $stop4$ = $stop$ >> 2;
    while ($src$ < $stop4$) {
  ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
    }
    $src$ <<= 2;
    $dest$ <<= 2;
  }while ($src$ < $stop$) {
    ; HEAP8[$dest$++] = HEAP8[$src$++];
  }
        i ++;
      } while (HEAP8[(psrc+i-1)] != 0);
      return pdest;
    }

  
  function _snprintf(s, n, format, varargs) {
      // int snprintf(char *restrict s, size_t n, const char *restrict format, ...);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/printf.html
      var result = __formatString(format, varargs);
      var limit = (n === undefined) ? result.length
                                    : Math.min(result.length, n - 1);
      for (var i = 0; i < limit; i++) {
        HEAP8[(s+i)]=result[i];;
      }
      HEAP8[(s+i)]=0;;
      return result.length;
    }function _sprintf(s, format, varargs) {
      // int sprintf(char *restrict s, const char *restrict format, ...);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/printf.html
      return _snprintf(s, undefined, format, varargs);
    }

  
  function _fputc(c, stream) {
      // int fputc(int c, FILE *stream);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/fputc.html
      var chr = unSign(c & 0xFF);
      HEAP8[(_fputc.ret)]=chr;
      var ret = _write(stream, _fputc.ret, 1);
      if (ret == -1) {
        if (stream in FS.streams) FS.streams[stream].error = true;
        return -1;
      } else {
        return chr;
      }
    }

  
  function __scanString(format, get, unget, varargs) {
      // Supports %x, %4x, %d.%d, %s.
      // TODO: Support all format specifiers.
      format = Pointer_stringify(format);
      var formatIndex = 0;
      var argsi = 0;
      var fields = 0;
      var argIndex = 0;
      for (var formatIndex = 0; formatIndex < format.length; formatIndex++) {
        if (next <= 0) return fields;
        var next = get();
        if (next <= 0) return fields;  // End of input.
        if (format[formatIndex] === '%') {
          formatIndex++;
          var maxSpecifierStart = formatIndex;
          while (format[formatIndex].charCodeAt(0) >= '0'.charCodeAt(0) &&
                 format[formatIndex].charCodeAt(0) <= '9'.charCodeAt(0)) {
            formatIndex++;
          }
          var max_;
          if (formatIndex != maxSpecifierStart) {
            max_ = parseInt(format.slice(maxSpecifierStart, formatIndex), 10);
          }
          // TODO: Handle type size modifier.
          var type = format[formatIndex];
          formatIndex++;
          var curr = 0;
          var buffer = [];
          while ((curr < max_ || isNaN(max_)) && next > 0) {
            if ((type === 'd' && next >= '0'.charCodeAt(0) && next <= '9'.charCodeAt(0)) ||
                (type === 'x' && (next >= '0'.charCodeAt(0) && next <= '9'.charCodeAt(0) ||
                                  next >= 'a'.charCodeAt(0) && next <= 'f'.charCodeAt(0) ||
                                  next >= 'A'.charCodeAt(0) && next <= 'F'.charCodeAt(0))) ||
                (type === 's') &&
                (formatIndex >= format.length || next !== format[formatIndex].charCodeAt(0))) { // Stop when we read something that is coming up
              buffer.push(String.fromCharCode(next));
              next = get();
              curr++;
            } else {
              break;
            }
          }
          if (buffer.length === 0) return 0;  // Failure.
          var text = buffer.join('');
          var argPtr = HEAP32[((varargs+argIndex)>>2)];
          argIndex += Runtime.getNativeFieldSize('void*');
          switch (type) {
            case 'd':
              HEAP32[((argPtr)>>2)]=parseInt(text, 10);
              break;
            case 'x':
              HEAP32[((argPtr)>>2)]=parseInt(text, 16);
              break;
            case 's':
              var array = intArrayFromString(text);
              for (var j = 0; j < array.length; j++) {
                HEAP8[(argPtr+j)]=array[j];
              }
              break;
          }
          fields++;
        } else {
          // Not a specifier.
          if (format[formatIndex].charCodeAt(0) !== next) {
            unget(next);
            return fields;
          }
        }
      }
      return fields;
    }function _sscanf(s, format, varargs) {
      // int sscanf(const char *restrict s, const char *restrict format, ... );
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/scanf.html
      var index = 0;
      var get = function() { return HEAP8[(s+index++)]; };
      var unget = function() { index--; };
      return __scanString(format, get, unget, varargs);
    }

  function _printf(format, varargs) {
      // int printf(const char *restrict format, ...);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/printf.html
      var stdout = HEAP32[((_stdout)>>2)];
      return _fprintf(stdout, format, varargs);
    }

  
  function __exit(status) {
      // void _exit(int status);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/exit.html
      __shutdownRuntime__();
      ABORT = true;
      throw 'exit(' + status + ') called, at ' + new Error().stack;
    }function _exit(status) {
      __exit(status);
    }

  
  function _isspace(chr) {
      return chr in { 32: 0, 9: 0, 10: 0, 11: 0, 12: 0, 13: 0 };
    }
  
  function _isdigit(chr) {
      return chr >= '0'.charCodeAt(0) && chr <= '9'.charCodeAt(0);
    }function _atoi(s) {
      var c;
      while ((c = HEAP8[(s)]) && _isspace(c)) s++;
      if (!c || !_isdigit(c)) return 0;
      var e = s;
      while ((c = HEAP8[(e)]) && _isdigit(c)) e++;
      return Math.floor(Number(Pointer_stringify(s).substr(0, e-s)));
    }

  
  
  
  
  
  
  
  
  var ___dirent_struct_layout={__size__: 1040, d_ino: 0, d_name: 4, d_off: 1028, d_reclen: 1032, d_type: 1036 };function _open(path, oflag, varargs) {
      // int open(const char *path, int oflag, ...);
      // http://pubs.opengroup.org/onlinepubs/009695399/functions/open.html
      // NOTE: This implementation tries to mimic glibc rather that strictly
      // following the POSIX standard.
  
      var mode = HEAP32[((varargs)>>2)];
  
      // Simplify flags.
      var accessMode = oflag & 3;
      var isWrite = accessMode != 0;
      var isRead = accessMode != 1;
      var isCreate = Boolean(oflag & 512);
      var isExistCheck = Boolean(oflag & 2048);
      var isTruncate = Boolean(oflag & 1024);
      var isAppend = Boolean(oflag & 8);
  
      // Verify path.
      var origPath = path;
      path = FS.analyzePath(Pointer_stringify(path));
      if (!path.parentExists) {
        ___setErrNo(path.error);
        return -1;
      }
      var target = path.object || null;
      var finalPath;
  
      // Verify the file exists, create if needed and allowed.
      if (target) {
        if (isCreate && isExistCheck) {
          ___setErrNo(ERRNO_CODES.EEXIST);
          return -1;
        }
        if ((isWrite || isCreate || isTruncate) && target.isFolder) {
          ___setErrNo(ERRNO_CODES.EISDIR);
          return -1;
        }
        if (isRead && !target.read || isWrite && !target.write) {
          ___setErrNo(ERRNO_CODES.EACCES);
          return -1;
        }
        if (isTruncate && !target.isDevice) {
          target.contents = [];
        } else {
          if (!FS.forceLoadFile(target)) {
            ___setErrNo(ERRNO_CODES.EIO);
            return -1;
          }
        }
        finalPath = path.path;
      } else {
        if (!isCreate) {
          ___setErrNo(ERRNO_CODES.ENOENT);
          return -1;
        }
        if (!path.parentObject.write) {
          ___setErrNo(ERRNO_CODES.EACCES);
          return -1;
        }
        target = FS.createDataFile(path.parentObject, path.name, [],
                                   mode & 0x100, mode & 0x80);  // S_IRUSR, S_IWUSR.
        finalPath = path.parentPath + '/' + path.name;
      }
      // Actually create an open stream.
      var id = FS.streams.length;
      if (target.isFolder) {
        var entryBuffer = 0;
        if (___dirent_struct_layout) {
          entryBuffer = _malloc(___dirent_struct_layout.__size__);
        }
        var contents = [];
        for (var key in target.contents) contents.push(key);
        FS.streams[id] = {
          path: finalPath,
          object: target,
          // An index into contents. Special values: -2 is ".", -1 is "..".
          position: -2,
          isRead: true,
          isWrite: false,
          isAppend: false,
          error: false,
          eof: false,
          ungotten: [],
          // Folder-specific properties:
          // Remember the contents at the time of opening in an array, so we can
          // seek between them relying on a single order.
          contents: contents,
          // Each stream has its own area for readdir() returns.
          currentEntry: entryBuffer
        };
      } else {
        FS.streams[id] = {
          path: finalPath,
          object: target,
          position: 0,
          isRead: isRead,
          isWrite: isWrite,
          isAppend: isAppend,
          error: false,
          eof: false,
          ungotten: []
        };
      }
      return id;
    }function _fopen(filename, mode) {
      // FILE *fopen(const char *restrict filename, const char *restrict mode);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/fopen.html
      var flags;
      mode = Pointer_stringify(mode);
      if (mode[0] == 'r') {
        if (mode.indexOf('+') != -1) {
          flags = 2;
        } else {
          flags = 0;
        }
      } else if (mode[0] == 'w') {
        if (mode.indexOf('+') != -1) {
          flags = 2;
        } else {
          flags = 1;
        }
        flags |= 512;
        flags |= 1024;
      } else if (mode[0] == 'a') {
        if (mode.indexOf('+') != -1) {
          flags = 2;
        } else {
          flags = 1;
        }
        flags |= 512;
        flags |= 8;
      } else {
        ___setErrNo(ERRNO_CODES.EINVAL);
        return 0;
      }
      var ret = _open(filename, flags, allocate([0x1FF, 0, 0, 0], 'i32', ALLOC_STACK));  // All creation permissions.
      return (ret == -1) ? 0 : ret;
    }

  
  function _memset(ptr, value, num) {
      var $dest$, $stop$, $stop4$, $fast$, $value4$;
  $dest$ = ptr;
  $stop$ = $dest$ + num;
  $value4$ = value;
  if ($value4$ < 0) $value4$ += 256;
  $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
  while ($dest$%4 !== 0 && $dest$ < $stop$) {
    ;; HEAP8[$dest$++] = value;
  }
  $dest$ >>= 2;
  $stop4$ = $stop$ >> 2;
  while ($dest$ < $stop4$) {
  ;;;;;;;  HEAP32[$dest$++] = $value4$;
  }
  $dest$ <<= 2;
  while ($dest$ < $stop$) {
    ;; HEAP8[$dest$++] = value;
  }
    }var _llvm_memset_p0i8_i32=_memset;

  function _strrchr(ptr, chr) {
      var ptr2 = ptr + _strlen(ptr);
      do {
        if (HEAP8[(ptr2)] == chr) return ptr2;
        ptr2--;
      } while (ptr2 >= ptr);
      return 0;
    }

  
  
  
  function _close(fildes) {
      // int close(int fildes);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/close.html
      if (FS.streams[fildes]) {
        if (FS.streams[fildes].currentEntry) {
          _free(FS.streams[fildes].currentEntry);
        }
        delete FS.streams[fildes];
        return 0;
      } else {
        ___setErrNo(ERRNO_CODES.EBADF);
        return -1;
      }
    }
  
  
  
  function _fsync(fildes) {
      // int fsync(int fildes);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/fsync.html
      if (FS.streams[fildes]) {
        // We write directly to the file system, so there's nothing to do here.
        return 0;
      } else {
        ___setErrNo(ERRNO_CODES.EBADF);
        return -1;
      }
    }function _fclose(stream) {
      // int fclose(FILE *stream);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/fclose.html
      _fsync(stream);
      return _close(stream);
    }

  
  
  function _fflush(stream) {
      // int fflush(FILE *stream);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/fflush.html
      var flush = function(filedes) {
        // Right now we write all data directly, except for output devices.
        if (filedes in FS.streams && FS.streams[filedes].object.output) {
          FS.streams[filedes].object.output(null);
        }
      };
      try {
        if (stream === 0) {
          for (var i in FS.streams) flush(i);
        } else {
          flush(stream);
        }
        return 0;
      } catch (e) {
        ___setErrNo(ERRNO_CODES.EIO);
        return -1;
      }
    }

  
  
  function _ftell(stream) {
      // long ftell(FILE *stream);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/ftell.html
      if (stream in FS.streams) {
        stream = FS.streams[stream];
        if (stream.object.isDevice) {
          ___setErrNo(ERRNO_CODES.ESPIPE);
          return -1;
        } else {
          return stream.position;
        }
      } else {
        ___setErrNo(ERRNO_CODES.EBADF);
        return -1;
      }
    }

  
  
  
  
  function _lseek(fildes, offset, whence) {
      // off_t lseek(int fildes, off_t offset, int whence);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/lseek.html
      if (FS.streams[fildes] && !FS.streams[fildes].isDevice) {
        var stream = FS.streams[fildes];
        var position = offset;
        if (whence === 1) {  // SEEK_CUR.
          position += stream.position;
        } else if (whence === 2) {  // SEEK_END.
          position += stream.object.contents.length;
        }
        if (position < 0) {
          ___setErrNo(ERRNO_CODES.EINVAL);
          return -1;
        } else {
          stream.ungotten = [];
          stream.position = position;
          return position;
        }
      } else {
        ___setErrNo(ERRNO_CODES.EBADF);
        return -1;
      }
    }function _fseek(stream, offset, whence) {
      // int fseek(FILE *stream, long offset, int whence);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/fseek.html
      var ret = _lseek(stream, offset, whence);
      if (ret == -1) {
        return -1;
      } else {
        FS.streams[stream].eof = false;
        return 0;
      }
    }


  
  function _strncmp(px, py, n) {
      var i = 0;
      while (i < n) {
        var x = HEAP8[(px+i)];
        var y = HEAP8[(py+i)];
        if (x == y && x == 0) return 0;
        if (x == 0) return -1;
        if (y == 0) return 1;
        if (x == y) {
          i ++;
          continue;
        } else {
          return x > y ? 1 : -1;
        }
      }
      return 0;
    }function _strcmp(px, py) {
      return _strncmp(px, py, TOTAL_MEMORY);
    }

  function _setlocale(category, locale) {
      if (!_setlocale.ret) _setlocale.ret = allocate([0], 'i8', ALLOC_NORMAL);
      return _setlocale.ret;
    }

  
  
  
  var _environ=null;
  
  var ___environ=null;function ___buildEnvironment(env) {
      // WARNING: Arbitrary limit!
      var MAX_ENV_VALUES = 64;
      var TOTAL_ENV_SIZE = 1024;
  
      // Statically allocate memory for the environment.
      var poolPtr;
      var envPtr;
      if (_environ === null) {
        // Set default values. Use string keys for Closure Compiler compatibility.
        ENV.USER = 'root';
        ENV.PATH = '/';
        ENV.PWD = '/';
        ENV.HOME = '/';
        ENV.LANG = 'en_US.UTF-8';
        ENV._ = './this.program';
        // Allocate memory.
        poolPtr = allocate(TOTAL_ENV_SIZE, 'i8', ALLOC_STATIC);
        envPtr = allocate(MAX_ENV_VALUES * 4,
                          'i8*', ALLOC_STATIC);
        HEAP32[((envPtr)>>2)]=poolPtr;
        _environ = allocate([envPtr], 'i8**', ALLOC_STATIC);
        // Set up global variable alias.
        ___environ = _environ;
      } else {
        envPtr = HEAP32[((_environ)>>2)];
        poolPtr = HEAP32[((envPtr)>>2)];
      }
  
      // Collect key=value lines.
      var strings = [];
      var totalSize = 0;
      for (var key in env) {
        if (typeof env[key] === 'string') {
          var line = key + '=' + env[key];
          strings.push(line);
          totalSize += line.length;
        }
      }
      if (totalSize > TOTAL_ENV_SIZE) {
        throw new Error('Environment size exceeded TOTAL_ENV_SIZE!');
      }
  
      // Make new.
      var ptrSize = 4;
      for (var i = 0; i < strings.length; i++) {
        var line = strings[i];
        for (var j = 0; j < line.length; j++) {
          HEAP8[(poolPtr+j)]=line.charCodeAt(j);
        }
        HEAP8[(poolPtr+j)]=0;
        HEAP32[((envPtr+i * ptrSize)>>2)]=poolPtr;
        poolPtr += line.length + 1;
      }
      HEAP32[((envPtr+strings.length * ptrSize)>>2)]=0;
    }var ENV={ };function _getenv(name) {
      // char *getenv(const char *name);
      // http://pubs.opengroup.org/onlinepubs/009695399/functions/getenv.html
      if (name === 0) return 0;
      name = Pointer_stringify(name);
      if (!ENV.hasOwnProperty(name)) return 0;
  
      if (_getenv.ret) _free(_getenv.ret);
      _getenv.ret = allocate(intArrayFromString(ENV[name]), 'i8', ALLOC_NORMAL);
      return _getenv.ret;
    }


  
  
  function _access(path, amode) {
      // int access(const char *path, int amode);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/access.html
      path = Pointer_stringify(path);
      var target = FS.findObject(path);
      if (target === null) return -1;
      if ((amode & 2 && !target.write) ||  // W_OK.
          ((amode & 1 || amode & 4) && !target.read)) {  // X_OK, R_OK.
        ___setErrNo(ERRNO_CODES.EACCES);
        return -1;
      } else {
        return 0;
      }
    }

  function _strcat(pdest, psrc) {
      var len = _strlen(pdest);
      var i = 0;
      do {
        var $src$, $dest$, $stop$, $stop4$, $fast$;
  $src$ = psrc+i;
  $dest$ = pdest+len+i;
  $stop$ = $src$ + 1;
  if (($dest$%4) == ($src$%4) && 1 > 8) {
    while ($src$%4 !== 0 && $src$ < $stop$) {
      ; HEAP8[$dest$++] = HEAP8[$src$++];
    }
    $src$ >>= 2;
    $dest$ >>= 2;
    $stop4$ = $stop$ >> 2;
    while ($src$ < $stop4$) {
  ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
    }
    $src$ <<= 2;
    $dest$ <<= 2;
  }while ($src$ < $stop$) {
    ; HEAP8[$dest$++] = HEAP8[$src$++];
  }
        i ++;
      } while (HEAP8[(psrc+i-1)] != 0);
      return pdest;
    }

  
  
  
  
  
  
  
  
  
  function _pread(fildes, buf, nbyte, offset) {
      // ssize_t pread(int fildes, void *buf, size_t nbyte, off_t offset);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/read.html
      var stream = FS.streams[fildes];
      if (!stream || stream.object.isDevice) {
        ___setErrNo(ERRNO_CODES.EBADF);
        return -1;
      } else if (!stream.isRead) {
        ___setErrNo(ERRNO_CODES.EACCES);
        return -1;
      } else if (stream.object.isFolder) {
        ___setErrNo(ERRNO_CODES.EISDIR);
        return -1;
      } else if (nbyte < 0 || offset < 0) {
        ___setErrNo(ERRNO_CODES.EINVAL);
        return -1;
      } else {
        var bytesRead = 0;
        while (stream.ungotten.length && nbyte > 0) {
          HEAP8[(buf++)]=stream.ungotten.pop();
          nbyte--;
          bytesRead++;
        }
        var contents = stream.object.contents;
        var size = Math.min(contents.length - offset, nbyte);
        for (var i = 0; i < size; i++) {
          HEAP8[(buf+i)]=contents[offset + i];
          bytesRead++;
        }
        return bytesRead;
      }
    }function _read(fildes, buf, nbyte) {
      // ssize_t read(int fildes, void *buf, size_t nbyte);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/read.html
      var stream = FS.streams[fildes];
      if (!stream) {
        ___setErrNo(ERRNO_CODES.EBADF);
        return -1;
      } else if (!stream.isRead) {
        ___setErrNo(ERRNO_CODES.EACCES);
        return -1;
      } else if (nbyte < 0) {
        ___setErrNo(ERRNO_CODES.EINVAL);
        return -1;
      } else {
        var bytesRead;
        if (stream.object.isDevice) {
          if (stream.object.input) {
            bytesRead = 0;
            while (stream.ungotten.length && nbyte > 0) {
              HEAP8[(buf++)]=stream.ungotten.pop();
              nbyte--;
              bytesRead++;
            }
            for (var i = 0; i < nbyte; i++) {
              try {
                var result = stream.object.input();
              } catch (e) {
                ___setErrNo(ERRNO_CODES.EIO);
                return -1;
              }
              if (result === null || result === undefined) break;
              bytesRead++;
              HEAP8[(buf+i)]=result;
            }
            return bytesRead;
          } else {
            ___setErrNo(ERRNO_CODES.ENXIO);
            return -1;
          }
        } else {
          var ungotSize = stream.ungotten.length;
          bytesRead = _pread(fildes, buf, nbyte, stream.position);
          if (bytesRead != -1) {
            stream.position += (stream.ungotten.length - ungotSize) + bytesRead;
          }
          return bytesRead;
        }
      }
    }function _fgetc(stream) {
      // int fgetc(FILE *stream);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/fgetc.html
      if (!(stream in FS.streams)) return -1;
      var streamObj = FS.streams[stream];
      if (streamObj.eof || streamObj.error) return -1;
      var ret = _read(stream, _fgetc.ret, 1);
      if (ret == 0) {
        streamObj.eof = true;
        return -1;
      } else if (ret == -1) {
        streamObj.error = true;
        return -1;
      } else {
        return HEAP8[(_fgetc.ret)];
      }
    }function _fgets(s, n, stream) {
      // char *fgets(char *restrict s, int n, FILE *restrict stream);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/fgets.html
      if (!(stream in FS.streams)) return 0;
      var streamObj = FS.streams[stream];
      if (streamObj.error || streamObj.eof) return 0;
      var byte_;
      for (var i = 0; i < n - 1 && byte_ != '\n'.charCodeAt(0); i++) {
        byte_ = _fgetc(stream);
        if (byte_ == -1) {
          if (streamObj.error) return 0;
          else if (streamObj.eof) break;
        }
        HEAP8[(s+i)]=byte_;
      }
      HEAP8[(s+i)]=0;
      return s;
    }

  function _strstr(ptr1, ptr2) {
      var str1 = Pointer_stringify(ptr1);
      var str2 = Pointer_stringify(ptr2);
      var ret = str1.search(str2);
      return ret >= 0 ? ptr1 + ret : 0;
    }

  function _memcmp(p1, p2, num) {
      for (var i = 0; i < num; i++) {
        var v1 = HEAP8[(p1+i)];
        var v2 = HEAP8[(p2+i)];
        if (v1 != v2) return v1 > v2 ? 1 : -1;
      }
      return 0;
    }

  
  function _memcpy(dest, src, num, idunno) {
      var $src$, $dest$, $stop$, $stop4$, $fast$;
  $src$ = src;
  $dest$ = dest;
  $stop$ = $src$ + num;
  if (($dest$%4) == ($src$%4) && num > 8) {
    while ($src$%4 !== 0 && $src$ < $stop$) {
      ; HEAP8[$dest$++] = HEAP8[$src$++];
    }
    $src$ >>= 2;
    $dest$ >>= 2;
    $stop4$ = $stop$ >> 2;
    while ($src$ < $stop4$) {
  ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
    }
    $src$ <<= 2;
    $dest$ <<= 2;
  }while ($src$ < $stop$) {
    ; HEAP8[$dest$++] = HEAP8[$src$++];
  };
    }function _qsort(base, num, size, comparator) {
      if (num == 0 || size == 0) return;
      // forward calls to the JavaScript sort method
      // first, sort the items logically
      comparator = FUNCTION_TABLE[comparator];
      var keys = [];
      for (var i = 0; i < num; i++) keys.push(i);
      keys.sort(function(a, b) {
        return comparator(base+a*size, base+b*size);
      });
      // apply the sort
      var temp = _malloc(num*size);
      _memcpy(temp, base, num*size);
      for (var i = 0; i < num; i++) {
        if (keys[i] == i) continue; // already in place
        _memcpy(base+i*size, temp+keys[i]*size, size);
      }
      _free(temp);
    }


  
  
  
  function _unlink(path) {
      // int unlink(const char *path);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/unlink.html
      path = FS.analyzePath(Pointer_stringify(path));
      if (!path.parentExists || !path.exists) {
        ___setErrNo(path.error);
        return -1;
      } else if (path.object.isFolder) {
        ___setErrNo(ERRNO_CODES.EISDIR);
        return -1;
      } else if (!path.object.write) {
        ___setErrNo(ERRNO_CODES.EACCES);
        return -1;
      } else {
        delete path.parentObject.contents[path.name];
        return 0;
      }
    }
  
  
  
  function _rmdir(path) {
      // int rmdir(const char *path);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/rmdir.html
      path = FS.analyzePath(Pointer_stringify(path));
      if (!path.parentExists || !path.exists) {
        ___setErrNo(path.error);
        return -1;
      } else if (!path.object.write || path.isRoot) {
        ___setErrNo(ERRNO_CODES.EACCES);
        return -1;
      } else if (!path.object.isFolder) {
        ___setErrNo(ERRNO_CODES.ENOTDIR);
        return -1;
      } else {
        for (var i in path.object.contents) {
          ___setErrNo(ERRNO_CODES.ENOTEMPTY);
          return -1;
        }
        if (path.path == FS.currentPath) {
          ___setErrNo(ERRNO_CODES.EBUSY);
          return -1;
        } else {
          delete path.parentObject.contents[path.name];
          return 0;
        }
      }
    }function _remove(path) {
      // int remove(const char *path);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/remove.html
      var ret = _unlink(path);
      if (ret == -1) ret = _rmdir(path);
      return ret;
    }

  var _llvm_memcpy_p0i8_p0i8_i32=_memcpy;

  function _isalnum(chr) {
      return (chr >= '0'.charCodeAt(0) && chr <= '9'.charCodeAt(0)) ||
             (chr >= 'a'.charCodeAt(0) && chr <= 'z'.charCodeAt(0)) ||
             (chr >= 'A'.charCodeAt(0) && chr <= 'Z'.charCodeAt(0));
    }

// added support for unicode basic latin + latin-1 supplement; mass:werk, N.L. 2014
  function _isalnum(chr) {
      return (chr >= 48 && chr <= 57) ||       // 0 .. 9
             (chr >= 97 && chr <= 122) ||      // a .. z
             (chr >= 65 && chr <= 90) ||       // A .. Z
             (chr >= 0xC0 && chr <= 0xD6) ||   // � .. �
             (chr >= 0xDF && chr <= 0xF6) ||   // � .. �
             (chr >= 0xD8 && chr <= 0xDE) ||   // � .. �
             (chr >= 0xF8 && chr <= 0xFF);     // � .. �
    }
// end of batch

  function _strchr(ptr, chr) {
      ptr--;
      do {
        ptr++;
        var val = HEAP8[(ptr)];
        if (val == chr) return ptr;
      } while (val);
      return 0;
    }

  function _strncpy(pdest, psrc, num) {
      var padding = false, curr;
      for (var i = 0; i < num; i++) {
        curr = padding ? 0 : HEAP8[(psrc+i)];
        HEAP8[(pdest+i)]=curr;
        padding = padding || HEAP8[(psrc+i)] == 0;
      }
      return pdest;
    }

  
  function _fread(ptr, size, nitems, stream) {
      // size_t fread(void *restrict ptr, size_t size, size_t nitems, FILE *restrict stream);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/fread.html
      var bytesToRead = nitems * size;
      if (bytesToRead == 0) return 0;
      var bytesRead = _read(stream, ptr, bytesToRead);
      var streamObj = FS.streams[stream];
      if (bytesRead == -1) {
        if (streamObj) streamObj.error = true;
        return -1;
      } else {
        if (bytesRead < bytesToRead) streamObj.eof = true;
        return Math.floor(bytesRead / size);
      }
    }


  function _tolower(chr) {
      if (chr >= 'A'.charCodeAt(0) && chr <= 'Z'.charCodeAt(0)) {
        return chr - 'A'.charCodeAt(0) + 'a'.charCodeAt(0);
      } else {
        return chr;
      }
    }

  function _isalpha(chr) {
      return (chr >= 'a'.charCodeAt(0) && chr <= 'z'.charCodeAt(0)) ||
             (chr >= 'A'.charCodeAt(0) && chr <= 'Z'.charCodeAt(0));
    }

  function _isupper(chr) {
      return chr >= 'A'.charCodeAt(0) && chr <= 'Z'.charCodeAt(0);
    }

  function _islower(chr) {
      return chr >= 'a'.charCodeAt(0) && chr <= 'z'.charCodeAt(0);
    }

  function _ispunct(chr) {
      return (chr >= '!'.charCodeAt(0) && chr <= '/'.charCodeAt(0)) ||
             (chr >= ':'.charCodeAt(0) && chr <= '@'.charCodeAt(0)) ||
             (chr >= '['.charCodeAt(0) && chr <= '`'.charCodeAt(0)) ||
             (chr >= '{'.charCodeAt(0) && chr <= '~'.charCodeAt(0));
    }

// added support for unicode basic latin + latin-1 supplement; mass:werk, N.L. 2014
  function _tolower(chr) {
      if ((chr >= 65 && chr <90) ||
          (chr >= 0xC0 && chr <= 0xD6) ||
          (chr >= 0xD8 && chr <= 0xDE)) return chr - 65 + 97;
      return chr;
    }

  function _isalpha(chr) {
      return (chr >= 97 && chr <= 122) ||      // a .. z
             (chr >= 65 && chr <= 90) ||       // A .. Z
             (chr >= 0xC0 && chr <= 0xD6) ||   // � .. �
             (chr >= 0xDF && chr <= 0xF6) ||   // � .. �
             (chr >= 0xD8 && chr <= 0xDE) ||   // � .. �
             (chr >= 0xF8 && chr <= 0xFF);     // � .. �
    }

  function _isupper(chr) {
      return (chr >= 65 && chr <= 90) ||       // A .. Z
             (chr >= 0xC0 && chr <= 0xD6) ||   // � .. �
             (chr >= 0xD8 && chr <= 0xDE);     // � .. �
    }

  function _islower(chr) {
      return (chr >= 97 && chr <= 122) ||      // a .. z
             (chr >= 0xDF && chr <= 0xF6) ||   // � .. �
             (chr >= 0xF8 && chr <= 0xFF);     // � .. �
    }

  function _ispunct(chr) {
      return (chr >= 33 && chr <= 47) ||       // ! .. /
             (chr >= 58 && chr <= 64) ||       // : .. @
             (chr >= 91 && chr <= 96) ||       // [ .. `
             (chr >= 123 && chr <= 126);       // { .. ~
    }
// end of batch

var _atof; // stub for _atof

  function _realloc(ptr, size) {
      // Very simple, inefficient implementation - if you use a real malloc, best to use
      // a real realloc with it
      if (!size) {
        if (ptr) _free(ptr);
        return 0;
      }
      var ret = _malloc(size);
      if (ptr) {
        _memcpy(ret, ptr, size); // might be some invalid reads
        _free(ptr);
      }
      return ret;
    }
var _mkstemp; // stub for _mkstemp


  
  function _system(command) {
      // int system(const char *command);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/system.html
      // Can't call external programs.
      ___setErrNo(ERRNO_CODES.EAGAIN);
      return -1;
    }

  function _ungetc(c, stream) {
      // int ungetc(int c, FILE *stream);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/ungetc.html
      if (stream in FS.streams) {
        c = unSign(c & 0xFF);
        FS.streams[stream].ungotten.push(c);
        return c;
      } else {
        return -1;
      }
    }

  function _strdup(ptr) {
      var len = String_len(ptr);
      var newStr = _malloc(len + 1);
      var $src$, $dest$, $stop$, $stop4$, $fast$;
  $src$ = ptr;
  $dest$ = newStr;
  $stop$ = $src$ + len;
  if (($dest$%4) == ($src$%4) && len > 8) {
    while ($src$%4 !== 0 && $src$ < $stop$) {
      ; HEAP8[$dest$++] = HEAP8[$src$++];
    }
    $src$ >>= 2;
    $dest$ >>= 2;
    $stop4$ = $stop$ >> 2;
    while ($src$ < $stop4$) {
  ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
    }
    $src$ <<= 2;
    $dest$ <<= 2;
  }while ($src$ < $stop$) {
    ; HEAP8[$dest$++] = HEAP8[$src$++];
  };
      HEAP8[(newStr+len)]=0;;
      return newStr;
    }

  
  function _kill(pid, sig) {
      // int kill(pid_t pid, int sig);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/kill.html
      // Makes no sense in a single-process environment.
      ___setErrNo(ERRNO_CODES.EPERM);
      return -1;
    }



  
  function ___errno_location() {
      return ___setErrNo.ret;
    }
  var ___errno=___errno_location;

  
  
  
  var ERRNO_MESSAGES={1: "Operation not permitted", 2: "No such file or directory", 3: "No such process", 4: "Interrupted system call", 5: "Input/output error", 6: "No such device or address", 8: "Exec format error", 9: "Bad file descriptor", 10: "No child processes", 11: "Resource temporarily unavailable", 12: "Cannot allocate memory", 13: "Permission denied", 14: "Bad address", 16: "Device or resource busy", 17: "File exists", 18: "Invalid cross-device link", 19: "No such device", 20: "Not a directory", 21: "Is a directory", 22: "Invalid argument", 23: "Too many open files in system", 24: "Too many open files", 25: "Inappropriate ioctl for device", 26: "Text file busy", 27: "File too large", 28: "No space left on device", 29: "Illegal seek", 30: "Read-only file system", 31: "Too many links", 32: "Broken pipe", 33: "Numerical argument out of domain", 34: "Numerical result out of range", 35: "Resource deadlock avoided", 36: "File name too long", 37: "No locks available", 38: "Function not implemented", 39: "Directory not empty", 40: "Too many levels of symbolic links", 42: "No message of desired type", 43: "Identifier removed", 60: "Device not a stream", 61: "No data available", 62: "Timer expired", 63: "Out of streams resources", 67: "Link has been severed", 71: "Protocol error", 72: "Multihop attempted", 74: "Bad message", 75: "Value too large for defined data type", 84: "Invalid or incomplete multibyte or wide character", 88: "Socket operation on non-socket", 89: "Destination address required", 90: "Message too long", 91: "Protocol wrong type for socket", 92: "Protocol not available", 93: "Protocol not supported", 95: "Operation not supported", 97: "Address family not supported by protocol", 98: "Address already in use", 99: "Cannot assign requested address", 100: "Network is down", 101: "Network is unreachable", 102: "Network dropped connection on reset", 103: "Software caused connection abort", 104: "Connection reset by peer", 105: "No buffer space available", 106: "Transport endpoint is already connected", 107: "Transport endpoint is not connected", 110: "Connection timed out", 111: "Connection refused", 113: "No route to host", 114: "Operation already in progress", 115: "Operation now in progress", 116: "Stale NFS file handle", 122: "Disk quota exceeded", 125: "Operation canceled", 130: "Owner died", 131: "State not recoverable" };
  function _strerror_r(errnum, strerrbuf, buflen) {
      if (errnum in ERRNO_MESSAGES) {
        if (ERRNO_MESSAGES[errnum].length > buflen - 1) {
          return ___setErrNo(ERRNO_CODES.ERANGE);
        } else {
          var msg = ERRNO_MESSAGES[errnum];
          for (var i = 0; i < msg.length; i++) {
            HEAP8[(strerrbuf+i)]=msg.charCodeAt(i);
          }
          HEAP8[(strerrbuf+i)]=0;
          return 0;
        }
      } else {
        return ___setErrNo(ERRNO_CODES.EINVAL);
      }
    }function _strerror(errnum) {
      if (!_strerror.buffer) _strerror.buffer = _malloc(256);
      _strerror_r(errnum, _strerror.buffer, 256);
      return _strerror.buffer;
    }


  
  function _memmove(dest, src, num, idunno) {
      // not optimized!
      if (num === 0) return; // will confuse malloc if 0
      var tmp = _malloc(num);
      _memcpy(tmp, src, num);
      _memcpy(dest, tmp, num);
      _free(tmp);
    }
  var _llvm_memmove_p0i8_p0i8_i32=_memmove;
var _llvm_va_start; // stub for _llvm_va_start

  
  
  var _vfprintf=_fprintf;

  function _llvm_va_end() {}

  
  
  function _wait(stat_loc) {
      // pid_t wait(int *stat_loc);
      // http://pubs.opengroup.org/onlinepubs/009695399/functions/wait.html
      // Makes no sense in a single-process environment.
      ___setErrNo(ERRNO_CODES.ECHILD);
      return -1;
    }
  
  var _waitpid=_wait;

  
  var _vsnprintf=_snprintf;

  
  
  var ___pollfd_struct_layout=null;function _poll(fds, nfds, timeout) {
      // int poll(struct pollfd fds[], nfds_t nfds, int timeout);
      // http://pubs.opengroup.org/onlinepubs/009695399/functions/poll.html
      // NOTE: This is pretty much a no-op mimicing glibc.
      var offsets = ___pollfd_struct_layout;
      var nonzero = 0;
      for (var i = 0; i < nfds; i++) {
        var pollfd = fds + ___pollfd_struct_layout.__size__ * i;
        var fd = HEAP32[((pollfd+offsets.fd)>>2)];
        var events = HEAP16[((pollfd+offsets.events)>>1)];
        var revents = 0;
        if (fd in FS.streams) {
          var stream = FS.streams[fd];
          if (events & 1) revents |= 1;
          if (events & 2) revents |= 2;
        } else {
          if (events & 4) revents |= 4;
        }
        if (revents) nonzero++;
        HEAP16[((pollfd+offsets.revents)>>1)]=revents;
      }
      return nonzero;
    }


  function _memchr(ptr, chr, num) {
      chr = unSign(chr);
      for (var i = 0; i < num; i++) {
        if (HEAP8[(ptr)] == chr) return ptr;
        ptr++;
      }
      return 0;
    }

  
  function _fork() {
      // pid_t fork(void);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/fork.html
      // We don't support multiple processes.
      ___setErrNo(ERRNO_CODES.EAGAIN);
      return -1;
    }

  
  
  
  
  
  
  
  
  var ___flock_struct_layout=null;function _fcntl(fildes, cmd, varargs) {
      // int fcntl(int fildes, int cmd, ...);
      // http://pubs.opengroup.org/onlinepubs/009695399/functions/fcntl.html
      if (!(fildes in FS.streams)) {
        ___setErrNo(ERRNO_CODES.EBADF);
        return -1;
      }
      var stream = FS.streams[fildes];
      switch (cmd) {
        case 0:
          var arg = HEAP32[((varargs)>>2)];
          if (arg < 0) {
            ___setErrNo(ERRNO_CODES.EINVAL);
            return -1;
          }
          var newStream = {};
          for (var member in stream) {
            newStream[member] = stream[member];
          }
          if (arg in FS.streams) arg = FS.streams.length;
          FS.streams[arg] = newStream;
          return arg;
        case 1:
        case 2:
          return 0;  // FD_CLOEXEC makes no sense for a single process.
        case 3:
          var flags = 0;
          if (stream.isRead && stream.isWrite) flags = 2;
          else if (!stream.isRead && stream.isWrite) flags = 1;
          else if (stream.isRead && !stream.isWrite) flags = 0;
          if (stream.isAppend) flags |= 8;
          // Synchronization and blocking flags are irrelevant to us.
          return flags;
        case 4:
          var arg = HEAP32[((varargs)>>2)];
          stream.isAppend = Boolean(arg | 8);
          // Synchronization and blocking flags are irrelevant to us.
          return 0;
        case 7:
        case 20:
          var arg = HEAP32[((varargs)>>2)];
          var offset = ___flock_struct_layout.l_type;
          // We're always unlocked.
          HEAP16[((arg+offset)>>1)]=3;
          return 0;
        case 8:
        case 9:
        case 21:
        case 22:
          // Pretend that the locking is successful.
          return 0;
        case 6:
        case 5:
          // These are for sockets. We don't have them implemented (yet?).
          ___setErrNo(ERRNO_CODES.EINVAL);
          return -1;
        default:
          ___setErrNo(ERRNO_CODES.EINVAL);
          return -1;
      }
      // Should never be reached. Only to silence strict warnings.
      return -1;
    }
  function _dup2(fildes, fildes2) {
      // int dup2(int fildes, int fildes2);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/dup.html
      if (fildes2 < 0) {
        ___setErrNo(ERRNO_CODES.EBADF);
        return -1;
      } else if (fildes === fildes2 && FS.streams[fildes]) {
        return fildes;
      } else {
        _close(fildes2);
        return _fcntl(fildes, 0, allocate([fildes2, 0, 0, 0], 'i32', ALLOC_STACK));  // F_DUPFD.
      }
    }


  function _signal(sig, func) {
      // TODO
      return 0;
    }

  
  
  function _execl(/* ... */) {
      // int execl(const char *path, const char *arg0, ... /*, (char *)0 */);
      // http://pubs.opengroup.org/onlinepubs/009695399/functions/exec.html
      // We don't support executing external code.
      ___setErrNo(ERRNO_CODES.ENOEXEC);
      return -1;
    }
  
  var _execlp=_execl;



  
  function _pipe(fildes) {
      // int pipe(int fildes[2]);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/pipe.html
      // It is possible to implement this using two device streams, but pipes make
      // little sense in a single-threaded environment, so we do not support them.
      ___setErrNo(ERRNO_CODES.ENOSYS);
      return -1;
    }

  
  
  
  function _opendir(dirname) {
      // DIR *opendir(const char *dirname);
      // http://pubs.opengroup.org/onlinepubs/007908799/xsh/opendir.html
      // NOTE: Calculating absolute path redundantly since we need to associate it
      //       with the opened stream.
      var path = FS.absolutePath(Pointer_stringify(dirname));
      if (path === null) {
        ___setErrNo(ERRNO_CODES.ENOENT);
        return 0;
      }
      var target = FS.findObject(path);
      if (target === null) return 0;
      if (!target.isFolder) {
        ___setErrNo(ERRNO_CODES.ENOTDIR);
        return 0;
      } else if (!target.read) {
        ___setErrNo(ERRNO_CODES.EACCES);
        return 0;
      }
      var id = FS.streams.length;
      var contents = [];
      for (var key in target.contents) contents.push(key);
      FS.streams[id] = {
        path: path,
        object: target,
        // An index into contents. Special values: -2 is ".", -1 is "..".
        position: -2,
        isRead: true,
        isWrite: false,
        isAppend: false,
        error: false,
        eof: false,
        ungotten: [],
        // Folder-specific properties:
        // Remember the contents at the time of opening in an array, so we can
        // seek between them relying on a single order.
        contents: contents,
        // Each stream has its own area for readdir() returns.
        currentEntry: _malloc(___dirent_struct_layout.__size__)
      };
      return id;
    }

  
  
  
  
  function _readdir_r(dirp, entry, result) {
      // int readdir_r(DIR *dirp, struct dirent *entry, struct dirent **result);
      // http://pubs.opengroup.org/onlinepubs/007908799/xsh/readdir_r.html
      if (!FS.streams[dirp] || !FS.streams[dirp].object.isFolder) {
        return ___setErrNo(ERRNO_CODES.EBADF);
      }
      var stream = FS.streams[dirp];
      var loc = stream.position;
      var entries = 0;
      for (var key in stream.contents) entries++;
      if (loc < -2 || loc >= entries) {
        HEAP32[((result)>>2)]=0;
      } else {
        var name, inode;
        if (loc === -2) {
          name = '.';
          inode = 1;  // Really undefined.
        } else if (loc === -1) {
          name = '..';
          inode = 1;  // Really undefined.
        } else {
          name = stream.contents[loc];
          inode = stream.object.contents[name].inodeNumber;
        }
        stream.position++;
        var offsets = ___dirent_struct_layout;
        HEAP32[((entry+offsets.d_ino)>>2)]=inode;
        HEAP32[((entry+offsets.d_off)>>2)]=stream.position;
        HEAP32[((entry+offsets.d_reclen)>>2)]=name.length + 1;
        for (var i = 0; i < name.length; i++) {
          HEAP8[(entry + offsets.d_name+i)]=name.charCodeAt(i);
        }
        HEAP8[(entry + offsets.d_name+i)]=0;
        var type = stream.object.isDevice ? 2 // DT_CHR, character device.
                 : stream.object.isFolder ? 4 // DT_DIR, directory.
                 : stream.object.link !== undefined ? 10 // DT_LNK, symbolic link.
                 : 8; // DT_REG, regular file.
        HEAP8[(entry+offsets.d_type)]=type;
        HEAP32[((result)>>2)]=entry;
      }
      return 0;
    }
  
  function _readdir(dirp) {
      // struct dirent *readdir(DIR *dirp);
      // http://pubs.opengroup.org/onlinepubs/007908799/xsh/readdir_r.html
      if (!FS.streams[dirp] || !FS.streams[dirp].object.isFolder) {
        ___setErrNo(ERRNO_CODES.EBADF);
        return 0;
      } else {
        if (!_readdir.result) _readdir.result = _malloc(4);
        _readdir_r(dirp, FS.streams[dirp].currentEntry, _readdir.result);
        if (HEAP32[((_readdir.result)>>2)] === 0) {
          return 0;
        } else {
          return FS.streams[dirp].currentEntry;
        }
      }
    }

  
  
  function _closedir(dirp) {
      // int closedir(DIR *dirp);
      // http://pubs.opengroup.org/onlinepubs/007908799/xsh/closedir.html
      if (!FS.streams[dirp] || !FS.streams[dirp].object.isFolder) {
        return ___setErrNo(ERRNO_CODES.EBADF);
      } else {
        _free(FS.streams[dirp].currentEntry);
        delete FS.streams[dirp];
        return 0;
      }
    }

  function _calloc(n, s) {
      var ret = _malloc(n*s);
      _memset(ret, 0, n*s);
      return ret;
    }

  var _cos=Math.cos;

  
  var ___rand_state=42;function _rand() {
      // int rand(void);
      ___rand_state = (1103515245 * ___rand_state + 12345) % 0x100000000;
      return ___rand_state & 0x7FFFFFFF;
    }

  var _exp=Math.exp;

  var _sin=Math.sin;

  
  var _vsprintf=_sprintf;

  
  function _fputs(s, stream) {
      // int fputs(const char *restrict s, FILE *restrict stream);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/fputs.html
      return _write(stream, s, _strlen(s));
    }

  function _exp2(x) {
      return Math.pow(2, x);
    }




  function __Z13GetFileLengthPKc($filename) {
    var __stackBase__  = STACKTOP; STACKTOP += 80; _memset(__stackBase__, 0, 80);
    var __label__;
  
    var $retval;
    var $filename_addr;
    var $statbuf=__stackBase__;
    $filename_addr=$filename;
    var $0=$filename_addr; //@line 130 "speak.cpp"
    var $call=_stat($0, $statbuf); //@line 130 "speak.cpp"
    var $cmp=((($call))|0)!=0; //@line 130 "speak.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 130 "speak.cpp"
    if (__label__ == 1) {
  
      $retval=0; //@line 131 "speak.cpp"
      ; //@line 131 "speak.cpp"
    }
    else if (__label__ == 2) {
  
      var $st_mode=(($statbuf+12)&4294967295); //@line 133 "speak.cpp"
      var $1=HEAP32[(($st_mode)>>2)]; //@line 133 "speak.cpp"
      var $and=($1) & 61440; //@line 133 "speak.cpp"
      var $cmp1=((($and))|0)==16384; //@line 133 "speak.cpp"
      if ($cmp1) { __label__ = 3;; } else { __label__ = 4;; } //@line 133 "speak.cpp"
      if (__label__ == 3) {
  
        $retval=-2; //@line 135 "speak.cpp"
        ; //@line 135 "speak.cpp"
      }
      else if (__label__ == 4) {
  
        var $st_size=(($statbuf+36)&4294967295); //@line 137 "speak.cpp"
        var $2=HEAP32[(($st_size)>>2)]; //@line 137 "speak.cpp"
        $retval=$2; //@line 137 "speak.cpp"
        ; //@line 137 "speak.cpp"
      }
    }
  
    var $3=$retval; //@line 138 "speak.cpp"
    STACKTOP = __stackBase__;
    return $3; //@line 138 "speak.cpp"
    return null;
  }
  

  function __Z5Alloci($size) {
    ;
    var __label__;
  
    var $size_addr;
    var $p;
    $size_addr=$size;
    var $0=$size_addr; //@line 144 "speak.cpp"
    var $call=_malloc($0); //@line 144 "speak.cpp"
    $p=$call; //@line 144 "speak.cpp"
    var $cmp=((($call))|0)==0; //@line 144 "speak.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 144 "speak.cpp"
    if (__label__ == 1) {
  
      var $1=HEAP32[((__impure_ptr)>>2)]; //@line 145 "speak.cpp"
      var $_stderr=(($1+12)&4294967295); //@line 145 "speak.cpp"
      var $2=HEAP32[(($_stderr)>>2)]; //@line 145 "speak.cpp"
      var $3=_fwrite(((__str106)&4294967295), 22, 1, $2); //@line 145 "speak.cpp"
      ; //@line 145 "speak.cpp"
    }
  
    var $4=$p; //@line 146 "speak.cpp"
    ;
    return $4; //@line 146 "speak.cpp"
    return null;
  }
  

  function __Z4FreePv($ptr) {
    ;
    var __label__;
  
    var $ptr_addr;
    $ptr_addr=$ptr;
    var $0=$ptr_addr; //@line 151 "speak.cpp"
    var $cmp=((($0))|0)!=0; //@line 151 "speak.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 151 "speak.cpp"
    if (__label__ == 1) {
  
      var $1=$ptr_addr; //@line 152 "speak.cpp"
      ; //@line 152 "speak.cpp"
      ; //@line 152 "speak.cpp"
    }
  
    ;
    return; //@line 153 "speak.cpp"
    return;
  }
  

  function __Z13DisplayVoicesP7__sFILEPc($f_out, $language) {
    var __stackBase__  = STACKTOP; STACKTOP += 36; _memset(__stackBase__, 0, 36);
    var __label__;
  
    var $f_out_addr;
    var $language_addr;
    var $ix;
    var $p;
    var $len;
    var $count;
    var $scores;
    var $v;
    var $lang_name;
    var $age_buf=__stackBase__;
    var $voices;
    var $voice_select=__stackBase__+12;
    $f_out_addr=$f_out;
    $language_addr=$language;
    $scores=0; //@line 162 "speak.cpp"
    var $0=$language_addr; //@line 171 "speak.cpp"
    var $cmp=((($0))|0)!=0; //@line 171 "speak.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 3;; } //@line 171 "speak.cpp"
    $land_lhs_true$$if_else$2: do { 
      if (__label__ == 1) {
  
        var $1=$language_addr; //@line 171 "speak.cpp"
        var $arrayidx=(($1)&4294967295); //@line 171 "speak.cpp"
        var $2=HEAP8[($arrayidx)]; //@line 171 "speak.cpp"
        var $conv=(tempInt=(($2)),(tempInt>=128?tempInt-256:tempInt)); //@line 171 "speak.cpp"
        var $cmp1=((($conv))|0)!=0; //@line 171 "speak.cpp"
        if (!($cmp1)) { __label__ = 3;break $land_lhs_true$$if_else$2; } //@line 171 "speak.cpp"
  
        var $3=$language_addr; //@line 174 "speak.cpp"
        var $languages=(($voice_select+4)&4294967295); //@line 174 "speak.cpp"
        HEAP32[(($languages)>>2)]=$3; //@line 174 "speak.cpp"
        var $age=(($voice_select+13)&4294967295); //@line 175 "speak.cpp"
        HEAP8[($age)]=0; //@line 175 "speak.cpp"
        var $gender=(($voice_select+12)&4294967295); //@line 176 "speak.cpp"
        HEAP8[($gender)]=0; //@line 176 "speak.cpp"
        var $name=(($voice_select)&4294967295); //@line 177 "speak.cpp"
        HEAP32[(($name)>>2)]=0; //@line 177 "speak.cpp"
        var $call=_espeak_ListVoices($voice_select); //@line 178 "speak.cpp"
        $voices=((__ZZ17espeak_ListVoicesE6voices)&4294967295); //@line 178 "speak.cpp"
        $scores=1; //@line 179 "speak.cpp"
        __label__ = 4;break $land_lhs_true$$if_else$2; //@line 180 "speak.cpp"
      }
    } while(0);
    if (__label__ == 3) {
  
      var $call2=_espeak_ListVoices(0); //@line 183 "speak.cpp"
      $voices=((__ZZ17espeak_ListVoicesE6voices)&4294967295); //@line 183 "speak.cpp"
      ;
    }
  
    var $4=$f_out_addr; //@line 186 "speak.cpp"
    var $5=_fwrite(((__str1)&4294967295), 64, 1, $4); //@line 186 "speak.cpp"
    $ix=0; //@line 188 "speak.cpp"
    var $6=$ix; //@line 188 "speak.cpp"
    var $7=$voices; //@line 188 "speak.cpp"
    var $arrayidx43=(($7+4*$6)&4294967295); //@line 188 "speak.cpp"
    var $8=HEAP32[(($arrayidx43)>>2)]; //@line 188 "speak.cpp"
    $v=$8; //@line 188 "speak.cpp"
    var $cmp54=((($8))|0)!=0; //@line 188 "speak.cpp"
    if ($cmp54) { __label__ = 5;; } else { __label__ = 15;; } //@line 188 "speak.cpp"
    $for_body_lr_ph$$for_end$8: do { 
      if (__label__ == 5) {
  
        var $arraydecay=(($age_buf)&4294967295); //@line 198 "speak.cpp"
        var $arraydecay26=(($age_buf)&4294967295); //@line 204 "speak.cpp"
        ; //@line 188 "speak.cpp"
        $for_body$10: while(1) { 
  
          $count=0; //@line 190 "speak.cpp"
          var $9=$v; //@line 191 "speak.cpp"
          var $languages6=(($9+4)&4294967295); //@line 191 "speak.cpp"
          var $10=HEAP32[(($languages6)>>2)]; //@line 191 "speak.cpp"
          $p=$10; //@line 191 "speak.cpp"
          var $11=$p; //@line 192 "speak.cpp"
          var $12=HEAP8[($11)]; //@line 192 "speak.cpp"
          var $conv71=(tempInt=(($12)),(tempInt>=128?tempInt-256:tempInt)); //@line 192 "speak.cpp"
          var $cmp82=((($conv71))|0)!=0; //@line 192 "speak.cpp"
          if ($cmp82) { __label__ = 7;; } else { __label__ = 14;; } //@line 192 "speak.cpp"
          $while_body$$while_end$12: do { 
            if (__label__ == 7) {
              while(1) { 
  
                var $13=$p; //@line 194 "speak.cpp"
                var $add_ptr=(($13+1)&4294967295); //@line 194 "speak.cpp"
                var $call9=_strlen($add_ptr); //@line 194 "speak.cpp"
                $len=$call9; //@line 194 "speak.cpp"
                var $14=$p; //@line 195 "speak.cpp"
                var $add_ptr10=(($14+1)&4294967295); //@line 195 "speak.cpp"
                $lang_name=$add_ptr10; //@line 195 "speak.cpp"
                var $15=$v; //@line 197 "speak.cpp"
                var $age11=(($15+13)&4294967295); //@line 197 "speak.cpp"
                var $16=HEAPU8[($age11)]; //@line 197 "speak.cpp"
                var $conv12=((($16))&255); //@line 197 "speak.cpp"
                var $cmp13=((($conv12))|0)==0; //@line 197 "speak.cpp"
                if ($cmp13) { __label__ = 8;; } else { __label__ = 9;; } //@line 197 "speak.cpp"
                if (__label__ == 8) {
  
                  var $src$, $dest$, $stop$, $stop4$, $fast$;
                  $src$ = ((__str41208)&4294967295);
                  $dest$ = $arraydecay;
                  $stop$ = $src$ + 4;
                  if (($dest$%4) == ($src$%4) && 4 > 8) {
                    while ($src$%4 !== 0 && $src$ < $stop$) {
                      ; HEAP8[$dest$++] = HEAP8[$src$++];
                    }
                    $src$ >>= 2;
                    $dest$ >>= 2;
                    $stop4$ = $stop$ >> 2;
                    while ($src$ < $stop4$) {
                  ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
                    }
                    $src$ <<= 2;
                    $dest$ <<= 2;
                  }while ($src$ < $stop$) {
                    ; HEAP8[$dest$++] = HEAP8[$src$++];
                  }; //@line 198 "speak.cpp"
                  ; //@line 198 "speak.cpp"
                }
                else if (__label__ == 9) {
  
                  var $17=$v; //@line 200 "speak.cpp"
                  var $age18=(($17+13)&4294967295); //@line 200 "speak.cpp"
                  var $18=HEAPU8[($age18)]; //@line 200 "speak.cpp"
                  var $conv19=((($18))&255); //@line 200 "speak.cpp"
                  var $call20=_sprintf($arraydecay, ((__str3)&4294967295), allocate([$conv19,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 200 "speak.cpp"
                  ;
                }
  
                var $19=$count; //@line 202 "speak.cpp"
                var $cmp22=((($19))|0)==0; //@line 202 "speak.cpp"
                var $20=$f_out_addr; //@line 204 "speak.cpp"
                if ($cmp22) { __label__ = 11;; } else { __label__ = 12;; } //@line 202 "speak.cpp"
                if (__label__ == 11) {
  
                  var $21=$p; //@line 204 "speak.cpp"
                  var $arrayidx24=(($21)&4294967295); //@line 204 "speak.cpp"
                  var $22=HEAP8[($arrayidx24)]; //@line 204 "speak.cpp"
                  var $conv25=(tempInt=(($22)),(tempInt>=128?tempInt-256:tempInt)); //@line 204 "speak.cpp"
                  var $23=$lang_name; //@line 204 "speak.cpp"
                  var $24=$v; //@line 204 "speak.cpp"
                  var $gender27=(($24+12)&4294967295); //@line 204 "speak.cpp"
                  var $25=HEAPU8[($gender27)]; //@line 204 "speak.cpp"
                  var $idxprom=((($25))&255); //@line 204 "speak.cpp"
                  var $arrayidx28=((__ZZ13DisplayVoicesP7__sFILEPcE7genders+$idxprom)&4294967295); //@line 204 "speak.cpp"
                  var $26=HEAP8[($arrayidx28)]; //@line 204 "speak.cpp"
                  var $conv29=(tempInt=(($26)),(tempInt>=128?tempInt-256:tempInt)); //@line 204 "speak.cpp"
                  var $27=$v; //@line 204 "speak.cpp"
                  var $name30=(($27)&4294967295); //@line 204 "speak.cpp"
                  var $28=HEAP32[(($name30)>>2)]; //@line 204 "speak.cpp"
                  var $29=$v; //@line 204 "speak.cpp"
                  var $identifier=(($29+8)&4294967295); //@line 204 "speak.cpp"
                  var $30=HEAP32[(($identifier)>>2)]; //@line 204 "speak.cpp"
                  var $call31=_fprintf($20, ((__str4)&4294967295), allocate([$conv25,0,0,0,$23,0,0,0,$arraydecay26,0,0,0,$conv29,0,0,0,$28,0,0,0,$30,0,0,0], ["i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 204 "speak.cpp"
                  ; //@line 206 "speak.cpp"
                }
                else if (__label__ == 12) {
  
                  var $31=$lang_name; //@line 209 "speak.cpp"
                  var $32=$p; //@line 209 "speak.cpp"
                  var $arrayidx33=(($32)&4294967295); //@line 209 "speak.cpp"
                  var $33=HEAP8[($arrayidx33)]; //@line 209 "speak.cpp"
                  var $conv34=(tempInt=(($33)),(tempInt>=128?tempInt-256:tempInt)); //@line 209 "speak.cpp"
                  var $call35=_fprintf($20, ((__str5)&4294967295), allocate([$31,0,0,0,$conv34,0,0,0], ["i8*",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 209 "speak.cpp"
                  ;
                }
  
                var $34=$count; //@line 211 "speak.cpp"
                var $inc=((($34)+1)&4294967295); //@line 211 "speak.cpp"
                $count=$inc; //@line 211 "speak.cpp"
                var $35=$len; //@line 212 "speak.cpp"
                var $add=((($35)+2)&4294967295); //@line 212 "speak.cpp"
                var $36=$p; //@line 212 "speak.cpp"
                var $add_ptr37=(($36+$add)&4294967295); //@line 212 "speak.cpp"
                $p=$add_ptr37; //@line 212 "speak.cpp"
                var $37=$p; //@line 192 "speak.cpp"
                var $38=HEAP8[($37)]; //@line 192 "speak.cpp"
                var $conv7=(tempInt=(($38)),(tempInt>=128?tempInt-256:tempInt)); //@line 192 "speak.cpp"
                var $cmp8=((($conv7))|0)!=0; //@line 192 "speak.cpp"
                if ($cmp8) { __label__ = 7;continue ; } else { __label__ = 14;break $while_body$$while_end$12; } //@line 192 "speak.cpp"
              }
            }
          } while(0);
  
          var $39=$f_out_addr; //@line 216 "speak.cpp"
          var $call38=_fputc(10, $39); //@line 216 "speak.cpp"
          var $40=$ix; //@line 188 "speak.cpp"
          var $inc39=((($40)+1)&4294967295); //@line 188 "speak.cpp"
          $ix=$inc39; //@line 188 "speak.cpp"
          var $41=$ix; //@line 188 "speak.cpp"
          var $42=$voices; //@line 188 "speak.cpp"
          var $arrayidx4=(($42+4*$41)&4294967295); //@line 188 "speak.cpp"
          var $43=HEAP32[(($arrayidx4)>>2)]; //@line 188 "speak.cpp"
          $v=$43; //@line 188 "speak.cpp"
          var $cmp5=((($43))|0)!=0; //@line 188 "speak.cpp"
          if ($cmp5) { __label__ = 6;continue $for_body$10; } else { __label__ = 15;break $for_body_lr_ph$$for_end$8; } //@line 188 "speak.cpp"
        }
      }
    } while(0);
  
    STACKTOP = __stackBase__;
    return; //@line 218 "speak.cpp"
    return;
  }
  

  function __Z13WVoiceChangedP7voice_t($wvoice) {
    ;
    var __label__;
  
    ;
    return; //@line 223 "speak.cpp"
    return;
  }
  

  function __Z11MarkerEventijiPh($type, $char_position, $value, $out_ptr) {
    ;
    var __label__;
  
    var $type_addr;
    var $char_position_addr;
    var $value_addr;
    var $out_ptr_addr;
    $type_addr=$type;
    $char_position_addr=$char_position;
    $value_addr=$value;
    $out_ptr_addr=$out_ptr;
    var $0=$type_addr; //@line 292 "speak.cpp"
    var $cmp=((($0))|0)==2; //@line 292 "speak.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 292 "speak.cpp"
    if (__label__ == 1) {
  
      HEAP32[((_end_of_sentence)>>2)]=1; //@line 293 "speak.cpp"
      ; //@line 293 "speak.cpp"
    }
  
    ;
    return; //@line 294 "speak.cpp"
    return;
  }
  

  function _main($argc, $argv) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $_ZL9help_text;
    $_ZL9help_text=((__str37)&4294967295);
    var $_ZZ4mainE8err_load;
    $_ZZ4mainE8err_load=((__str18)&4294967295);
    var $retval;
    var $argc_addr;
    var $argv_addr;
    var $f_text;
    var $p_text;
    var $data_path;
    var $option_index=STACKTOP; _memset(STACKTOP, 0, 4); STACKTOP += 4;STACKTOP = Math.ceil((STACKTOP)/4)*4;;
    var $c;
    var $value=STACKTOP; _memset(STACKTOP, 0, 4); STACKTOP += 4;STACKTOP = Math.ceil((STACKTOP)/4)*4;;
    var $speed;
    var $ix;
    var $optarg2;
    var $amp;
    var $wordgap;
    var $speaking;
    var $flag_stdin;
    var $flag_compile;
    var $pitch_adjustment;
    var $voice_select=STACKTOP; _memset(STACKTOP, 0, 24); STACKTOP += 24;STACKTOP = Math.ceil((STACKTOP)/4)*4;;
    var $filename=STACKTOP; _memset(STACKTOP, 0, 200); STACKTOP += 200;STACKTOP = Math.ceil((STACKTOP)/4)*4;;
    var $voicename=STACKTOP; _memset(STACKTOP, 0, 40); STACKTOP += 40;STACKTOP = Math.ceil((STACKTOP)/4)*4;;
    var $dictname=STACKTOP; _memset(STACKTOP, 0, 40); STACKTOP += 40;STACKTOP = Math.ceil((STACKTOP)/4)*4;;
    var $extn;
    $retval=0;
    $argc_addr=$argc;
    $argv_addr=$argv;
    $f_text=0; //@line 495 "speak.cpp"
    $p_text=0; //@line 496 "speak.cpp"
    $data_path=0; //@line 497 "speak.cpp"
    HEAP32[(($option_index)>>2)]=0; //@line 499 "speak.cpp"
    $speed=175; //@line 502 "speak.cpp"
    $amp=100; //@line 505 "speak.cpp"
    $wordgap=0; //@line 506 "speak.cpp"
    $speaking=0; //@line 507 "speak.cpp"
    $flag_stdin=0; //@line 508 "speak.cpp"
    $flag_compile=0; //@line 509 "speak.cpp"
    $pitch_adjustment=50; //@line 510 "speak.cpp"
    var $arrayidx=(($voicename)&4294967295); //@line 516 "speak.cpp"
    HEAP8[($arrayidx)]=0; //@line 516 "speak.cpp"
    HEAP8[(((_mbrola_name)&4294967295))]=0; //@line 517 "speak.cpp"
    var $arrayidx1=(($dictname)&4294967295); //@line 518 "speak.cpp"
    HEAP8[($arrayidx1)]=0; //@line 518 "speak.cpp"
    HEAP8[(((_wavefile)&4294967295))]=0; //@line 519 "speak.cpp"
    var $arrayidx2=(($filename)&4294967295); //@line 520 "speak.cpp"
    HEAP8[($arrayidx2)]=0; //@line 520 "speak.cpp"
    HEAP32[((_option_linelength)>>2)]=0; //@line 521 "speak.cpp"
    HEAP32[((_option_phonemes)>>2)]=0; //@line 522 "speak.cpp"
    HEAP32[((_option_waveout)>>2)]=0; //@line 523 "speak.cpp"
    HEAP32[((_option_wordgap)>>2)]=0; //@line 524 "speak.cpp"
    HEAP32[((_option_endpause)>>2)]=1; //@line 525 "speak.cpp"
    HEAP32[((_option_phoneme_input)>>2)]=1; //@line 526 "speak.cpp"
    HEAP32[((_option_multibyte)>>2)]=0; //@line 527 "speak.cpp"
    var $0=HEAP32[((__impure_ptr)>>2)]; //@line 528 "speak.cpp"
    var $_stdout=(($0+8)&4294967295); //@line 528 "speak.cpp"
    var $1=HEAP32[(($_stdout)>>2)]; //@line 528 "speak.cpp"
    HEAP32[((_f_trans)>>2)]=$1; //@line 528 "speak.cpp"
    var $2=$argc_addr; //@line 588 "speak.cpp"
    var $3=$argv_addr; //@line 588 "speak.cpp"
    var $call6=_getopt_long($2, $3, ((__str19)&4294967295), ((__ZZ4mainE12long_options)&4294967295), $option_index); //@line 588 "speak.cpp"
    $c=$call6; //@line 588 "speak.cpp"
    var $cmp7=((($call6))|0)==-1; //@line 592 "speak.cpp"
    if ($cmp7) { __label__ = 43;; } else { __label__ = 1;; } //@line 592 "speak.cpp"
    $while_end71$$if_end_lr_ph$2: do { 
      if (__label__ == 1) {
  
        var $arraydecay=(($filename)&4294967295); //@line 638 "speak.cpp"
        var $arraydecay32=(($voicename)&4294967295); //@line 660 "speak.cpp"
        var $arraydecay41=(($voicename)&4294967295); //@line 684 "speak.cpp"
        var $_pr8=$c; //@line 597 "speak.cpp"
        __lastLabel__ = 1; ; //@line 592 "speak.cpp"
        $if_end$4: while(1) { 
  
          var $4=__lastLabel__ == 1 ? $_pr8 : ($call); //@line 597 "speak.cpp"
          var $5=HEAP32[((_optarg)>>2)]; //@line 594 "speak.cpp"
          $optarg2=$5; //@line 594 "speak.cpp"
          if ($4 == 98) {
            __lastLabel__ = 2; __label__ = 3;;
          }
          else if ($4 == 104) {
            __lastLabel__ = 2; __label__ = 5;;
          }
          else if ($4 == 107) {
            __lastLabel__ = 2; __label__ = 6;;
          }
          else if ($4 == 120) {
            __lastLabel__ = 2; __label__ = 7;;
          }
          else if ($4 == 88) {
            __lastLabel__ = 2; __label__ = 8;;
          }
          else if ($4 == 109) {
            __lastLabel__ = 2; __label__ = 9;;
          }
          else if ($4 == 112) {
            __lastLabel__ = 2; __label__ = 10;;
          }
          else if ($4 == 113) {
            __lastLabel__ = 2; __label__ = 12;;
          }
          else if ($4 == 102) {
            __lastLabel__ = 2; __label__ = 13;;
          }
          else if ($4 == 108) {
            __lastLabel__ = 2; __label__ = 14;;
          }
          else if ($4 == 97) {
            __lastLabel__ = 2; __label__ = 15;;
          }
          else if ($4 == 115) {
            __lastLabel__ = 2; __label__ = 16;;
          }
          else if ($4 == 103) {
            __lastLabel__ = 2; __label__ = 17;;
          }
          else if ($4 == 118) {
            __lastLabel__ = 2; __label__ = 18;;
          }
          else if ($4 == 119) {
            __lastLabel__ = 2; __label__ = 19;;
          }
          else if ($4 == 122) {
            __lastLabel__ = 2; __label__ = 20;;
          }
          else if ($4 == 256) {
            __lastLabel__ = 2; __label__ = 21;;
          }
          else if ($4 == 261) {
            __lastLabel__ = 2; __label__ = 22;;
          }
          else if ($4 == 257) {
            __lastLabel__ = 2; __label__ = 23;;
          }
          else if ($4 == 258) {
            __lastLabel__ = 2; __label__ = 23;;
          }
          else if ($4 == 259) {
            __lastLabel__ = 2; __label__ = 26;;
          }
          else if ($4 == 260) {
            __lastLabel__ = 2; __label__ = 32;;
          }
          else if ($4 == 262) {
            __lastLabel__ = 2; __label__ = 33;;
          }
          else if ($4 == 263) {
            __lastLabel__ = 2; __label__ = 36;;
          }
          else if ($4 == 264) {
            __lastLabel__ = 2; __label__ = 37;;
          }
          else if ($4 == 265) {
            __lastLabel__ = 2; __label__ = 40;;
          }
          else if ($4 == 266) {
            __lastLabel__ = 2; __label__ = 41;;
          }
          else {
          __lastLabel__ = 2; __label__ = 42;;
          }
          
          $sw_default$$sw_bb$$sw_bb8$$sw_bb11$$sw_bb13$$sw_bb14$$sw_bb15$$sw_bb16$$sw_bb21$$sw_bb22$$sw_bb23$$sw_bb25$$sw_bb27$$sw_bb29$$sw_bb31$$sw_bb33$$sw_bb34$$sw_bb35$$sw_bb36$$sw_bb38$$sw_bb43$$sw_bb53$$sw_bb56$$sw_bb61$$sw_bb62$$sw_bb69$$sw_bb70$6: do { 
            if (__label__ == 42) {
  
              _exit(0); //@line 732 "speak.cpp"
              __label__ = 38;break $sw_default$$sw_bb$$sw_bb8$$sw_bb11$$sw_bb13$$sw_bb14$$sw_bb15$$sw_bb16$$sw_bb21$$sw_bb22$$sw_bb23$$sw_bb25$$sw_bb27$$sw_bb29$$sw_bb31$$sw_bb33$$sw_bb34$$sw_bb35$$sw_bb36$$sw_bb38$$sw_bb43$$sw_bb53$$sw_bb56$$sw_bb61$$sw_bb62$$sw_bb69$$sw_bb70$6; //@line 733 "speak.cpp"
            }
            else if (__label__ == 3) {
  
              HEAP32[((_option_multibyte)>>2)]=2; //@line 601 "speak.cpp"
              var $6=$optarg2; //@line 602 "speak.cpp"
              var $call3=_sscanf($6, ((__str63715)&4294967295), allocate([$value,0,0,0], ["i32*",0,0,0], ALLOC_STACK)); //@line 602 "speak.cpp"
              var $cmp4=((($call3))|0)==1; //@line 602 "speak.cpp"
              var $7=HEAP32[(($value)>>2)]; //@line 602 "speak.cpp"
              var $cmp5=((($7))|0) <= 4; //@line 602 "speak.cpp"
              var $or_cond=($cmp4) & ($cmp5); //@line 602 "speak.cpp"
              if (!($or_cond)) { __label__ = 38;break $sw_default$$sw_bb$$sw_bb8$$sw_bb11$$sw_bb13$$sw_bb14$$sw_bb15$$sw_bb16$$sw_bb21$$sw_bb22$$sw_bb23$$sw_bb25$$sw_bb27$$sw_bb29$$sw_bb31$$sw_bb33$$sw_bb34$$sw_bb35$$sw_bb36$$sw_bb38$$sw_bb43$$sw_bb53$$sw_bb56$$sw_bb61$$sw_bb62$$sw_bb69$$sw_bb70$6; } //@line 602 "speak.cpp"
  
              var $8=HEAP32[(($value)>>2)]; //@line 603 "speak.cpp"
              HEAP32[((_option_multibyte)>>2)]=$8; //@line 603 "speak.cpp"
              __label__ = 38;break $sw_default$$sw_bb$$sw_bb8$$sw_bb11$$sw_bb13$$sw_bb14$$sw_bb15$$sw_bb16$$sw_bb21$$sw_bb22$$sw_bb23$$sw_bb25$$sw_bb27$$sw_bb29$$sw_bb31$$sw_bb33$$sw_bb34$$sw_bb35$$sw_bb36$$sw_bb38$$sw_bb43$$sw_bb53$$sw_bb56$$sw_bb61$$sw_bb62$$sw_bb69$$sw_bb70$6; //@line 603 "speak.cpp"
            }
            else if (__label__ == 5) {
  
              var $9=$argv_addr; //@line 607 "speak.cpp"
              var $arrayidx9=(($9)&4294967295); //@line 607 "speak.cpp"
              var $10=HEAP32[(($arrayidx9)>>2)]; //@line 607 "speak.cpp"
              var $11=$data_path; //@line 607 "speak.cpp"
              __ZL9init_pathPcS_($10, $11); //@line 607 "speak.cpp"
              var $12=HEAP32[((_version_string)>>2)]; //@line 608 "speak.cpp"
              var $13=$_ZL9help_text; //@line 608 "speak.cpp"
              var $call10=_printf(((__str21)&4294967295), allocate([$12,0,0,0,((_path_home)&4294967295),0,0,0,$13,0,0,0], ["i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 608 "speak.cpp"
              _exit(0); //@line 609 "speak.cpp"
              __label__ = 38;break $sw_default$$sw_bb$$sw_bb8$$sw_bb11$$sw_bb13$$sw_bb14$$sw_bb15$$sw_bb16$$sw_bb21$$sw_bb22$$sw_bb23$$sw_bb25$$sw_bb27$$sw_bb29$$sw_bb31$$sw_bb33$$sw_bb34$$sw_bb35$$sw_bb36$$sw_bb38$$sw_bb43$$sw_bb53$$sw_bb56$$sw_bb61$$sw_bb62$$sw_bb69$$sw_bb70$6; //@line 610 "speak.cpp"
            }
            else if (__label__ == 6) {
  
              var $14=$optarg2; //@line 613 "speak.cpp"
              var $call12=_atoi($14); //@line 613 "speak.cpp"
              HEAP32[((_option_capitals)>>2)]=$call12; //@line 613 "speak.cpp"
              __label__ = 38;break $sw_default$$sw_bb$$sw_bb8$$sw_bb11$$sw_bb13$$sw_bb14$$sw_bb15$$sw_bb16$$sw_bb21$$sw_bb22$$sw_bb23$$sw_bb25$$sw_bb27$$sw_bb29$$sw_bb31$$sw_bb33$$sw_bb34$$sw_bb35$$sw_bb36$$sw_bb38$$sw_bb43$$sw_bb53$$sw_bb56$$sw_bb61$$sw_bb62$$sw_bb69$$sw_bb70$6; //@line 614 "speak.cpp"
            }
            else if (__label__ == 7) {
  
              HEAP32[((_option_phonemes)>>2)]=1; //@line 617 "speak.cpp"
              __label__ = 38;break $sw_default$$sw_bb$$sw_bb8$$sw_bb11$$sw_bb13$$sw_bb14$$sw_bb15$$sw_bb16$$sw_bb21$$sw_bb22$$sw_bb23$$sw_bb25$$sw_bb27$$sw_bb29$$sw_bb31$$sw_bb33$$sw_bb34$$sw_bb35$$sw_bb36$$sw_bb38$$sw_bb43$$sw_bb53$$sw_bb56$$sw_bb61$$sw_bb62$$sw_bb69$$sw_bb70$6; //@line 618 "speak.cpp"
            }
            else if (__label__ == 8) {
  
              HEAP32[((_option_phonemes)>>2)]=2; //@line 621 "speak.cpp"
              __label__ = 38;break $sw_default$$sw_bb$$sw_bb8$$sw_bb11$$sw_bb13$$sw_bb14$$sw_bb15$$sw_bb16$$sw_bb21$$sw_bb22$$sw_bb23$$sw_bb25$$sw_bb27$$sw_bb29$$sw_bb31$$sw_bb33$$sw_bb34$$sw_bb35$$sw_bb36$$sw_bb38$$sw_bb43$$sw_bb53$$sw_bb56$$sw_bb61$$sw_bb62$$sw_bb69$$sw_bb70$6; //@line 622 "speak.cpp"
            }
            else if (__label__ == 9) {
  
              HEAP32[((_option_ssml)>>2)]=1; //@line 625 "speak.cpp"
              __label__ = 38;break $sw_default$$sw_bb$$sw_bb8$$sw_bb11$$sw_bb13$$sw_bb14$$sw_bb15$$sw_bb16$$sw_bb21$$sw_bb22$$sw_bb23$$sw_bb25$$sw_bb27$$sw_bb29$$sw_bb31$$sw_bb33$$sw_bb34$$sw_bb35$$sw_bb36$$sw_bb38$$sw_bb43$$sw_bb53$$sw_bb56$$sw_bb61$$sw_bb62$$sw_bb69$$sw_bb70$6; //@line 626 "speak.cpp"
            }
            else if (__label__ == 10) {
  
              var $15=$optarg2; //@line 629 "speak.cpp"
              var $call17=_atoi($15); //@line 629 "speak.cpp"
              $pitch_adjustment=$call17; //@line 629 "speak.cpp"
              var $16=$pitch_adjustment; //@line 630 "speak.cpp"
              var $cmp18=((($16))|0) > 99; //@line 630 "speak.cpp"
              if (!($cmp18)) { __label__ = 38;break $sw_default$$sw_bb$$sw_bb8$$sw_bb11$$sw_bb13$$sw_bb14$$sw_bb15$$sw_bb16$$sw_bb21$$sw_bb22$$sw_bb23$$sw_bb25$$sw_bb27$$sw_bb29$$sw_bb31$$sw_bb33$$sw_bb34$$sw_bb35$$sw_bb36$$sw_bb38$$sw_bb43$$sw_bb53$$sw_bb56$$sw_bb61$$sw_bb62$$sw_bb69$$sw_bb70$6; } //@line 630 "speak.cpp"
  
              $pitch_adjustment=99; //@line 630 "speak.cpp"
              __label__ = 38;break $sw_default$$sw_bb$$sw_bb8$$sw_bb11$$sw_bb13$$sw_bb14$$sw_bb15$$sw_bb16$$sw_bb21$$sw_bb22$$sw_bb23$$sw_bb25$$sw_bb27$$sw_bb29$$sw_bb31$$sw_bb33$$sw_bb34$$sw_bb35$$sw_bb36$$sw_bb38$$sw_bb43$$sw_bb53$$sw_bb56$$sw_bb61$$sw_bb62$$sw_bb69$$sw_bb70$6; //@line 630 "speak.cpp"
            }
            else if (__label__ == 12) {
  
              HEAP32[((_quiet)>>2)]=1; //@line 634 "speak.cpp"
              __label__ = 38;break $sw_default$$sw_bb$$sw_bb8$$sw_bb11$$sw_bb13$$sw_bb14$$sw_bb15$$sw_bb16$$sw_bb21$$sw_bb22$$sw_bb23$$sw_bb25$$sw_bb27$$sw_bb29$$sw_bb31$$sw_bb33$$sw_bb34$$sw_bb35$$sw_bb36$$sw_bb38$$sw_bb43$$sw_bb53$$sw_bb56$$sw_bb61$$sw_bb62$$sw_bb69$$sw_bb70$6; //@line 635 "speak.cpp"
            }
            else if (__label__ == 13) {
  
              var $17=$optarg2; //@line 638 "speak.cpp"
              __Z8strncpy0PcPKci($arraydecay, $17, 200); //@line 638 "speak.cpp"
              __label__ = 38;break $sw_default$$sw_bb$$sw_bb8$$sw_bb11$$sw_bb13$$sw_bb14$$sw_bb15$$sw_bb16$$sw_bb21$$sw_bb22$$sw_bb23$$sw_bb25$$sw_bb27$$sw_bb29$$sw_bb31$$sw_bb33$$sw_bb34$$sw_bb35$$sw_bb36$$sw_bb38$$sw_bb43$$sw_bb53$$sw_bb56$$sw_bb61$$sw_bb62$$sw_bb69$$sw_bb70$6; //@line 639 "speak.cpp"
            }
            else if (__label__ == 14) {
  
              HEAP32[(($value)>>2)]=0; //@line 642 "speak.cpp"
              var $18=$optarg2; //@line 643 "speak.cpp"
              var $call24=_atoi($18); //@line 643 "speak.cpp"
              HEAP32[(($value)>>2)]=$call24; //@line 643 "speak.cpp"
              var $19=HEAP32[(($value)>>2)]; //@line 644 "speak.cpp"
              HEAP32[((_option_linelength)>>2)]=$19; //@line 644 "speak.cpp"
              __label__ = 38;break $sw_default$$sw_bb$$sw_bb8$$sw_bb11$$sw_bb13$$sw_bb14$$sw_bb15$$sw_bb16$$sw_bb21$$sw_bb22$$sw_bb23$$sw_bb25$$sw_bb27$$sw_bb29$$sw_bb31$$sw_bb33$$sw_bb34$$sw_bb35$$sw_bb36$$sw_bb38$$sw_bb43$$sw_bb53$$sw_bb56$$sw_bb61$$sw_bb62$$sw_bb69$$sw_bb70$6; //@line 645 "speak.cpp"
            }
            else if (__label__ == 15) {
  
              var $20=$optarg2; //@line 648 "speak.cpp"
              var $call26=_atoi($20); //@line 648 "speak.cpp"
              $amp=$call26; //@line 648 "speak.cpp"
              __label__ = 38;break $sw_default$$sw_bb$$sw_bb8$$sw_bb11$$sw_bb13$$sw_bb14$$sw_bb15$$sw_bb16$$sw_bb21$$sw_bb22$$sw_bb23$$sw_bb25$$sw_bb27$$sw_bb29$$sw_bb31$$sw_bb33$$sw_bb34$$sw_bb35$$sw_bb36$$sw_bb38$$sw_bb43$$sw_bb53$$sw_bb56$$sw_bb61$$sw_bb62$$sw_bb69$$sw_bb70$6; //@line 649 "speak.cpp"
            }
            else if (__label__ == 16) {
  
              var $21=$optarg2; //@line 652 "speak.cpp"
              var $call28=_atoi($21); //@line 652 "speak.cpp"
              $speed=$call28; //@line 652 "speak.cpp"
              __label__ = 38;break $sw_default$$sw_bb$$sw_bb8$$sw_bb11$$sw_bb13$$sw_bb14$$sw_bb15$$sw_bb16$$sw_bb21$$sw_bb22$$sw_bb23$$sw_bb25$$sw_bb27$$sw_bb29$$sw_bb31$$sw_bb33$$sw_bb34$$sw_bb35$$sw_bb36$$sw_bb38$$sw_bb43$$sw_bb53$$sw_bb56$$sw_bb61$$sw_bb62$$sw_bb69$$sw_bb70$6; //@line 653 "speak.cpp"
            }
            else if (__label__ == 17) {
  
              var $22=$optarg2; //@line 656 "speak.cpp"
              var $call30=_atoi($22); //@line 656 "speak.cpp"
              $wordgap=$call30; //@line 656 "speak.cpp"
              __label__ = 38;break $sw_default$$sw_bb$$sw_bb8$$sw_bb11$$sw_bb13$$sw_bb14$$sw_bb15$$sw_bb16$$sw_bb21$$sw_bb22$$sw_bb23$$sw_bb25$$sw_bb27$$sw_bb29$$sw_bb31$$sw_bb33$$sw_bb34$$sw_bb35$$sw_bb36$$sw_bb38$$sw_bb43$$sw_bb53$$sw_bb56$$sw_bb61$$sw_bb62$$sw_bb69$$sw_bb70$6; //@line 657 "speak.cpp"
            }
            else if (__label__ == 18) {
  
              var $23=$optarg2; //@line 660 "speak.cpp"
              __Z8strncpy0PcPKci($arraydecay32, $23, 40); //@line 660 "speak.cpp"
              __label__ = 38;break $sw_default$$sw_bb$$sw_bb8$$sw_bb11$$sw_bb13$$sw_bb14$$sw_bb15$$sw_bb16$$sw_bb21$$sw_bb22$$sw_bb23$$sw_bb25$$sw_bb27$$sw_bb29$$sw_bb31$$sw_bb33$$sw_bb34$$sw_bb35$$sw_bb36$$sw_bb38$$sw_bb43$$sw_bb53$$sw_bb56$$sw_bb61$$sw_bb62$$sw_bb69$$sw_bb70$6; //@line 661 "speak.cpp"
            }
            else if (__label__ == 19) {
  
              HEAP32[((_option_waveout)>>2)]=1; //@line 664 "speak.cpp"
              var $24=$optarg2; //@line 665 "speak.cpp"
              __Z8strncpy0PcPKci(((_wavefile)&4294967295), $24, 200); //@line 665 "speak.cpp"
              __label__ = 38;break $sw_default$$sw_bb$$sw_bb8$$sw_bb11$$sw_bb13$$sw_bb14$$sw_bb15$$sw_bb16$$sw_bb21$$sw_bb22$$sw_bb23$$sw_bb25$$sw_bb27$$sw_bb29$$sw_bb31$$sw_bb33$$sw_bb34$$sw_bb35$$sw_bb36$$sw_bb38$$sw_bb43$$sw_bb53$$sw_bb56$$sw_bb61$$sw_bb62$$sw_bb69$$sw_bb70$6; //@line 666 "speak.cpp"
            }
            else if (__label__ == 20) {
  
              HEAP32[((_option_endpause)>>2)]=0; //@line 669 "speak.cpp"
              __label__ = 38;break $sw_default$$sw_bb$$sw_bb8$$sw_bb11$$sw_bb13$$sw_bb14$$sw_bb15$$sw_bb16$$sw_bb21$$sw_bb22$$sw_bb23$$sw_bb25$$sw_bb27$$sw_bb29$$sw_bb31$$sw_bb33$$sw_bb34$$sw_bb35$$sw_bb36$$sw_bb38$$sw_bb43$$sw_bb53$$sw_bb56$$sw_bb61$$sw_bb62$$sw_bb69$$sw_bb70$6; //@line 670 "speak.cpp"
            }
            else if (__label__ == 21) {
  
              $flag_stdin=1; //@line 673 "speak.cpp"
              __label__ = 38;break $sw_default$$sw_bb$$sw_bb8$$sw_bb11$$sw_bb13$$sw_bb14$$sw_bb15$$sw_bb16$$sw_bb21$$sw_bb22$$sw_bb23$$sw_bb25$$sw_bb27$$sw_bb29$$sw_bb31$$sw_bb33$$sw_bb34$$sw_bb35$$sw_bb36$$sw_bb38$$sw_bb43$$sw_bb53$$sw_bb56$$sw_bb61$$sw_bb62$$sw_bb69$$sw_bb70$6; //@line 674 "speak.cpp"
            }
            else if (__label__ == 22) {
  
              HEAP32[((_option_waveout)>>2)]=1; //@line 677 "speak.cpp"
              var $src$, $dest$, $stop$, $stop4$, $fast$;
              $src$ = ((__str12)&4294967295);
              $dest$ = ((_wavefile)&4294967295);
              $stop$ = $src$ + 7;
              if (($dest$%4) == ($src$%4) && 7 > 8) {
                while ($src$%4 !== 0 && $src$ < $stop$) {
                  ; HEAP8[$dest$++] = HEAP8[$src$++];
                }
                $src$ >>= 2;
                $dest$ >>= 2;
                $stop4$ = $stop$ >> 2;
                while ($src$ < $stop4$) {
              ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
                }
                $src$ <<= 2;
                $dest$ <<= 2;
              }while ($src$ < $stop$) {
                ; HEAP8[$dest$++] = HEAP8[$src$++];
              }; //@line 678 "speak.cpp"
              __label__ = 38;break $sw_default$$sw_bb$$sw_bb8$$sw_bb11$$sw_bb13$$sw_bb14$$sw_bb15$$sw_bb16$$sw_bb21$$sw_bb22$$sw_bb23$$sw_bb25$$sw_bb27$$sw_bb29$$sw_bb31$$sw_bb33$$sw_bb34$$sw_bb35$$sw_bb36$$sw_bb38$$sw_bb43$$sw_bb53$$sw_bb56$$sw_bb61$$sw_bb62$$sw_bb69$$sw_bb70$6; //@line 679 "speak.cpp"
            }
            else if (__label__ == 23) {
  
              var $cmp39=((($5))|0)!=0; //@line 683 "speak.cpp"
              if ($cmp39) { __label__ = 24;; } else { __label__ = 25;; } //@line 683 "speak.cpp"
              if (__label__ == 24) {
  
                var $25=$optarg2; //@line 684 "speak.cpp"
                __Z8strncpy0PcPKci($arraydecay41, $25, 40); //@line 684 "speak.cpp"
                ; //@line 684 "speak.cpp"
              }
  
              var $26=$c; //@line 685 "speak.cpp"
              $flag_compile=$26; //@line 685 "speak.cpp"
              __label__ = 38;break $sw_default$$sw_bb$$sw_bb8$$sw_bb11$$sw_bb13$$sw_bb14$$sw_bb15$$sw_bb16$$sw_bb21$$sw_bb22$$sw_bb23$$sw_bb25$$sw_bb27$$sw_bb29$$sw_bb31$$sw_bb33$$sw_bb34$$sw_bb35$$sw_bb36$$sw_bb38$$sw_bb43$$sw_bb53$$sw_bb56$$sw_bb61$$sw_bb62$$sw_bb69$$sw_bb70$6; //@line 686 "speak.cpp"
            }
            else if (__label__ == 26) {
  
              HEAP32[((_option_punctuation)>>2)]=1; //@line 689 "speak.cpp"
              var $27=$optarg2; //@line 690 "speak.cpp"
              var $cmp44=((($27))|0)!=0; //@line 690 "speak.cpp"
              if (!($cmp44)) { __label__ = 38;break $sw_default$$sw_bb$$sw_bb8$$sw_bb11$$sw_bb13$$sw_bb14$$sw_bb15$$sw_bb16$$sw_bb21$$sw_bb22$$sw_bb23$$sw_bb25$$sw_bb27$$sw_bb29$$sw_bb31$$sw_bb33$$sw_bb34$$sw_bb35$$sw_bb36$$sw_bb38$$sw_bb43$$sw_bb53$$sw_bb56$$sw_bb61$$sw_bb62$$sw_bb69$$sw_bb70$6; } //@line 690 "speak.cpp"
  
              $ix=0; //@line 692 "speak.cpp"
              __lastLabel__ = 27; ; //@line 693 "speak.cpp"
              while(1) { 
  
                var $28=__lastLabel__ == 30 ? $inc : (0); //@line 693 "speak.cpp"
                var $cmp47=((($28))|0) < 60; //@line 693 "speak.cpp"
                if (!($cmp47)) { __label__ = 31;break ; } //@line 693 "speak.cpp"
  
                var $29=$ix; //@line 693 "speak.cpp"
                var $30=$optarg2; //@line 693 "speak.cpp"
                var $arrayidx48=(($30+$29)&4294967295); //@line 693 "speak.cpp"
                var $31=HEAP8[($arrayidx48)]; //@line 693 "speak.cpp"
                var $conv=(tempInt=(($31)),(tempInt>=128?tempInt-256:tempInt)); //@line 693 "speak.cpp"
                var $32=$ix; //@line 693 "speak.cpp"
                var $arrayidx49=((_option_punctlist+$32*4)&4294967295); //@line 693 "speak.cpp"
                HEAP32[(($arrayidx49)>>2)]=$conv; //@line 693 "speak.cpp"
                var $cmp50=((($conv))|0)!=0; //@line 693 "speak.cpp"
                if (!($cmp50)) { __label__ = 31;break ; }
  
                var $33=$ix; //@line 693 "speak.cpp"
                var $inc=((($33)+1)&4294967295); //@line 693 "speak.cpp"
                $ix=$inc; //@line 693 "speak.cpp"
                __lastLabel__ = 30; __label__ = 28;continue ; //@line 693 "speak.cpp"
              }
  
              HEAP32[((((_option_punctlist+236)&4294967295))>>2)]=0; //@line 694 "speak.cpp"
              HEAP32[((_option_punctuation)>>2)]=2; //@line 695 "speak.cpp"
              __label__ = 38;break $sw_default$$sw_bb$$sw_bb8$$sw_bb11$$sw_bb13$$sw_bb14$$sw_bb15$$sw_bb16$$sw_bb21$$sw_bb22$$sw_bb23$$sw_bb25$$sw_bb27$$sw_bb29$$sw_bb31$$sw_bb33$$sw_bb34$$sw_bb35$$sw_bb36$$sw_bb38$$sw_bb43$$sw_bb53$$sw_bb56$$sw_bb61$$sw_bb62$$sw_bb69$$sw_bb70$6; //@line 696 "speak.cpp"
            }
            else if (__label__ == 32) {
  
              var $34=$argv_addr; //@line 700 "speak.cpp"
              var $arrayidx54=(($34)&4294967295); //@line 700 "speak.cpp"
              var $35=HEAP32[(($arrayidx54)>>2)]; //@line 700 "speak.cpp"
              var $36=$data_path; //@line 700 "speak.cpp"
              __ZL9init_pathPcS_($35, $36); //@line 700 "speak.cpp"
              var $37=HEAP32[((__impure_ptr)>>2)]; //@line 701 "speak.cpp"
              var $_stdout55=(($37+8)&4294967295); //@line 701 "speak.cpp"
              var $38=HEAP32[(($_stdout55)>>2)]; //@line 701 "speak.cpp"
              var $39=$optarg2; //@line 701 "speak.cpp"
              __Z13DisplayVoicesP7__sFILEPc($38, $39); //@line 701 "speak.cpp"
              _exit(0); //@line 702 "speak.cpp"
              var $_pr=$optarg2; //@line 705 "speak.cpp"
              __lastLabel__ = 32; __label__ = 33;break $sw_default$$sw_bb$$sw_bb8$$sw_bb11$$sw_bb13$$sw_bb14$$sw_bb15$$sw_bb16$$sw_bb21$$sw_bb22$$sw_bb23$$sw_bb25$$sw_bb27$$sw_bb29$$sw_bb31$$sw_bb33$$sw_bb34$$sw_bb35$$sw_bb36$$sw_bb38$$sw_bb43$$sw_bb53$$sw_bb56$$sw_bb61$$sw_bb62$$sw_bb69$$sw_bb70$6; //@line 702 "speak.cpp"
            }
            else if (__label__ == 36) {
  
              var $42=$optarg2; //@line 712 "speak.cpp"
              $data_path=$42; //@line 712 "speak.cpp"
              __label__ = 38;break $sw_default$$sw_bb$$sw_bb8$$sw_bb11$$sw_bb13$$sw_bb14$$sw_bb15$$sw_bb16$$sw_bb21$$sw_bb22$$sw_bb23$$sw_bb25$$sw_bb27$$sw_bb29$$sw_bb31$$sw_bb33$$sw_bb34$$sw_bb35$$sw_bb36$$sw_bb38$$sw_bb43$$sw_bb53$$sw_bb56$$sw_bb61$$sw_bb62$$sw_bb69$$sw_bb70$6; //@line 713 "speak.cpp"
            }
            else if (__label__ == 37) {
  
              var $43=$optarg2; //@line 716 "speak.cpp"
              var $call63=_fopen($43, ((__str11422)&4294967295)); //@line 716 "speak.cpp"
              HEAP32[((_f_trans)>>2)]=$call63; //@line 716 "speak.cpp"
              var $cmp64=((($call63))|0)==0; //@line 716 "speak.cpp"
              if (!($cmp64)) { __label__ = 38;break $sw_default$$sw_bb$$sw_bb8$$sw_bb11$$sw_bb13$$sw_bb14$$sw_bb15$$sw_bb16$$sw_bb21$$sw_bb22$$sw_bb23$$sw_bb25$$sw_bb27$$sw_bb29$$sw_bb31$$sw_bb33$$sw_bb34$$sw_bb35$$sw_bb36$$sw_bb38$$sw_bb43$$sw_bb53$$sw_bb56$$sw_bb61$$sw_bb62$$sw_bb69$$sw_bb70$6; } //@line 716 "speak.cpp"
  
              var $46=HEAP32[((__impure_ptr)>>2)]; //@line 718 "speak.cpp"
              var $_stderr=(($46+12)&4294967295); //@line 718 "speak.cpp"
              var $47=HEAP32[(($_stderr)>>2)]; //@line 718 "speak.cpp"
              var $48=$optarg2; //@line 718 "speak.cpp"
              var $call66=_fprintf($47, ((__str23)&4294967295), allocate([$48,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 718 "speak.cpp"
              var $49=HEAP32[((__impure_ptr)>>2)]; //@line 719 "speak.cpp"
              var $_stderr67=(($49+12)&4294967295); //@line 719 "speak.cpp"
              var $50=HEAP32[(($_stderr67)>>2)]; //@line 719 "speak.cpp"
              HEAP32[((_f_trans)>>2)]=$50; //@line 719 "speak.cpp"
              __label__ = 38;break $sw_default$$sw_bb$$sw_bb8$$sw_bb11$$sw_bb13$$sw_bb14$$sw_bb15$$sw_bb16$$sw_bb21$$sw_bb22$$sw_bb23$$sw_bb25$$sw_bb27$$sw_bb29$$sw_bb31$$sw_bb33$$sw_bb34$$sw_bb35$$sw_bb36$$sw_bb38$$sw_bb43$$sw_bb53$$sw_bb56$$sw_bb61$$sw_bb62$$sw_bb69$$sw_bb70$6; //@line 720 "speak.cpp"
            }
            else if (__label__ == 40) {
  
              HEAP32[((_option_mbrola_phonemes)>>2)]=16; //@line 724 "speak.cpp"
              __label__ = 38;break $sw_default$$sw_bb$$sw_bb8$$sw_bb11$$sw_bb13$$sw_bb14$$sw_bb15$$sw_bb16$$sw_bb21$$sw_bb22$$sw_bb23$$sw_bb25$$sw_bb27$$sw_bb29$$sw_bb31$$sw_bb33$$sw_bb34$$sw_bb35$$sw_bb36$$sw_bb38$$sw_bb43$$sw_bb53$$sw_bb56$$sw_bb61$$sw_bb62$$sw_bb69$$sw_bb70$6; //@line 725 "speak.cpp"
            }
            else if (__label__ == 41) {
  
              HEAP32[((_option_phonemes)>>2)]=3; //@line 728 "speak.cpp"
              __label__ = 38;break $sw_default$$sw_bb$$sw_bb8$$sw_bb11$$sw_bb13$$sw_bb14$$sw_bb15$$sw_bb16$$sw_bb21$$sw_bb22$$sw_bb23$$sw_bb25$$sw_bb27$$sw_bb29$$sw_bb31$$sw_bb33$$sw_bb34$$sw_bb35$$sw_bb36$$sw_bb38$$sw_bb43$$sw_bb53$$sw_bb56$$sw_bb61$$sw_bb62$$sw_bb69$$sw_bb70$6; //@line 729 "speak.cpp"
            }
          } while(0);
          if (__label__ == 33) {
  
            var $40=__lastLabel__ == 32 ? $_pr : ($5); //@line 705 "speak.cpp"
            var $cmp57=((($40))|0)==0; //@line 705 "speak.cpp"
            if ($cmp57) { __label__ = 34;; } else { __label__ = 35;; } //@line 705 "speak.cpp"
            if (__label__ == 34) {
  
              HEAP32[((_samples_split)>>2)]=30; //@line 706 "speak.cpp"
              ; //@line 706 "speak.cpp"
            }
            else if (__label__ == 35) {
  
              var $41=$optarg2; //@line 708 "speak.cpp"
              var $call59=_atoi($41); //@line 708 "speak.cpp"
              HEAP32[((_samples_split)>>2)]=$call59; //@line 708 "speak.cpp"
              ;
            }
          }
  
          var $44=$argc_addr; //@line 588 "speak.cpp"
          var $45=$argv_addr; //@line 588 "speak.cpp"
          var $call=_getopt_long($44, $45, ((__str19)&4294967295), ((__ZZ4mainE12long_options)&4294967295), $option_index); //@line 588 "speak.cpp"
          $c=$call; //@line 588 "speak.cpp"
          var $cmp=((($call))|0)==-1; //@line 592 "speak.cpp"
          if ($cmp) { __lastLabel__ = 38; __label__ = 43;break $while_end71$$if_end_lr_ph$2; } else { __lastLabel__ = 38; __label__ = 2;continue $if_end$4; } //@line 592 "speak.cpp"
        }
      }
    } while(0);
  
    var $51=$argv_addr; //@line 736 "speak.cpp"
    var $arrayidx72=(($51)&4294967295); //@line 736 "speak.cpp"
    var $52=HEAP32[(($arrayidx72)>>2)]; //@line 736 "speak.cpp"
    var $53=$data_path; //@line 736 "speak.cpp"
    __ZL9init_pathPcS_($52, $53); //@line 736 "speak.cpp"
    __ZL10initialisev(); //@line 737 "speak.cpp"
    var $54=$flag_compile; //@line 740 "speak.cpp"
    var $tobool=((($54))|0)!=0; //@line 740 "speak.cpp"
    if ($tobool) { __label__ = 44;; } else { __label__ = 45;; } //@line 740 "speak.cpp"
    if (__label__ == 44) {
  
      var $arraydecay75=(($voicename)&4294967295); //@line 742 "speak.cpp"
      var $call76=__Z9LoadVoicePKci($arraydecay75, 5); //@line 742 "speak.cpp"
      var $55=$flag_compile; //@line 758 "speak.cpp"
      var $and=($55) & 1; //@line 758 "speak.cpp"
      var $call77=__Z17CompileDictionaryPKcS0_P7__sFILEPci(0, ((_dictionary_name)&4294967295), 0, 0, $and); //@line 758 "speak.cpp"
      _exit(0); //@line 761 "speak.cpp"
      ; //@line 762 "speak.cpp"
    }
  
    var $arrayidx79=(($voicename)&4294967295); //@line 765 "speak.cpp"
    var $56=HEAP8[($arrayidx79)]; //@line 765 "speak.cpp"
    var $conv80=(tempInt=(($56)),(tempInt>=128?tempInt-256:tempInt)); //@line 765 "speak.cpp"
    var $cmp81=((($conv80))|0)==0; //@line 765 "speak.cpp"
    if ($cmp81) { __label__ = 46;; } else { __label__ = 47;; } //@line 765 "speak.cpp"
    if (__label__ == 46) {
  
      var $arraydecay83=(($voicename)&4294967295); //@line 766 "speak.cpp"
      var $src$, $dest$, $stop$, $stop4$, $fast$;
      $src$ = ((__str45697)&4294967295);
      $dest$ = $arraydecay83;
      $stop$ = $src$ + 8;
      if (($dest$%4) == ($src$%4) && 8 > 8) {
        while ($src$%4 !== 0 && $src$ < $stop$) {
          ; HEAP8[$dest$++] = HEAP8[$src$++];
        }
        $src$ >>= 2;
        $dest$ >>= 2;
        $stop4$ = $stop$ >> 2;
        while ($src$ < $stop4$) {
      ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
        }
        $src$ <<= 2;
        $dest$ <<= 2;
      }while ($src$ < $stop$) {
        ; HEAP8[$dest$++] = HEAP8[$src$++];
      }; //@line 766 "speak.cpp"
      ; //@line 766 "speak.cpp"
    }
  
    var $arraydecay86=(($voicename)&4294967295); //@line 768 "speak.cpp"
    var $call87=__Z14SetVoiceByNamePKc($arraydecay86); //@line 768 "speak.cpp"
    var $cmp88=((($call87))|0)!=0; //@line 768 "speak.cpp"
    if ($cmp88) { __label__ = 48;; } else { __label__ = 50;; } //@line 768 "speak.cpp"
    $if_then89$$if_end98$58: do { 
      if (__label__ == 48) {
  
        var $57=$voice_select; //@line 770 "speak.cpp"
        var $dest$, $stop$, $stop4$, $fast$, $value4$;
        $dest$ = $57;
        $stop$ = $dest$ + 24;
        $value4$ = 0;
        if ($value4$ < 0) $value4$ += 256;
        $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
        while ($dest$%4 !== 0 && $dest$ < $stop$) {
          ;; HEAP8[$dest$++] = 0;
        }
        $dest$ >>= 2;
        $stop4$ = $stop$ >> 2;
        while ($dest$ < $stop4$) {
        ;;;;;;;  HEAP32[$dest$++] = $value4$;
        }
        $dest$ <<= 2;
        while ($dest$ < $stop$) {
          ;; HEAP8[$dest$++] = 0;
        }; //@line 770 "speak.cpp"
        var $arraydecay90=(($voicename)&4294967295); //@line 771 "speak.cpp"
        var $languages=(($voice_select+4)&4294967295); //@line 771 "speak.cpp"
        HEAP32[(($languages)>>2)]=$arraydecay90; //@line 771 "speak.cpp"
        var $call91=__Z20SetVoiceByPropertiesP12espeak_VOICE($voice_select); //@line 772 "speak.cpp"
        var $cmp92=((($call91))|0)!=0; //@line 772 "speak.cpp"
        if (!($cmp92)) { __label__ = 50;break $if_then89$$if_end98$58; } //@line 772 "speak.cpp"
  
        var $58=HEAP32[((__impure_ptr)>>2)]; //@line 774 "speak.cpp"
        var $_stderr94=(($58+12)&4294967295); //@line 774 "speak.cpp"
        var $59=HEAP32[(($_stderr94)>>2)]; //@line 774 "speak.cpp"
        var $60=$_ZZ4mainE8err_load; //@line 774 "speak.cpp"
        var $arraydecay95=(($voicename)&4294967295); //@line 774 "speak.cpp"
        var $call96=_fprintf($59, ((__str25)&4294967295), allocate([$60,0,0,0,$arraydecay95,0,0,0], ["i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 774 "speak.cpp"
        _exit(2); //@line 775 "speak.cpp"
        ; //@line 776 "speak.cpp"
      }
    } while(0);
  
    var $61=$speed; //@line 779 "speak.cpp"
    __Z12SetParameteriii(1, $61, 0); //@line 779 "speak.cpp"
    var $62=$amp; //@line 780 "speak.cpp"
    __Z12SetParameteriii(2, $62, 0); //@line 780 "speak.cpp"
    var $63=HEAP32[((_option_capitals)>>2)]; //@line 781 "speak.cpp"
    __Z12SetParameteriii(6, $63, 0); //@line 781 "speak.cpp"
    var $64=HEAP32[((_option_punctuation)>>2)]; //@line 782 "speak.cpp"
    __Z12SetParameteriii(5, $64, 0); //@line 782 "speak.cpp"
    var $65=$wordgap; //@line 783 "speak.cpp"
    __Z12SetParameteriii(7, $65, 0); //@line 783 "speak.cpp"
    var $66=$pitch_adjustment; //@line 785 "speak.cpp"
    var $cmp99=((($66))|0)!=50; //@line 785 "speak.cpp"
    if ($cmp99) { __label__ = 51;; } else { __label__ = 52;; } //@line 785 "speak.cpp"
    if (__label__ == 51) {
  
      var $67=$pitch_adjustment; //@line 787 "speak.cpp"
      __Z12SetParameteriii(3, $67, 0); //@line 787 "speak.cpp"
      ; //@line 788 "speak.cpp"
    }
  
    var $68=HEAP32[((_voice)>>2)]; //@line 789 "speak.cpp"
    __Z13DoVoiceChangeP7voice_t($68); //@line 789 "speak.cpp"
    var $arrayidx102=(($filename)&4294967295); //@line 791 "speak.cpp"
    var $69=HEAP8[($arrayidx102)]; //@line 791 "speak.cpp"
    var $conv103=(tempInt=(($69)),(tempInt>=128?tempInt-256:tempInt)); //@line 791 "speak.cpp"
    var $cmp104=((($conv103))|0)==0; //@line 791 "speak.cpp"
    if ($cmp104) { __label__ = 53;; } else { __label__ = 59;; } //@line 791 "speak.cpp"
    $if_then105$$if_else116$65: do { 
      if (__label__ == 53) {
  
        var $70=HEAP32[((_optind)>>2)]; //@line 793 "speak.cpp"
        var $71=$argc_addr; //@line 793 "speak.cpp"
        var $cmp106=((($70))|0) < ((($71))|0); //@line 793 "speak.cpp"
        var $72=$flag_stdin; //@line 793 "speak.cpp"
        if ($cmp106) { __label__ = 54;; } else { __label__ = 57;; } //@line 793 "speak.cpp"
        if (__label__ == 54) {
  
          var $cmp108=((($72))|0)==0; //@line 793 "speak.cpp"
          if ($cmp108) { __label__ = 56;; } else { __label__ = 55;; } //@line 793 "speak.cpp"
          if (__label__ == 56) {
  
            var $75=HEAP32[((_optind)>>2)]; //@line 797 "speak.cpp"
            var $76=$argv_addr; //@line 797 "speak.cpp"
            var $arrayidx110=(($76+4*$75)&4294967295); //@line 797 "speak.cpp"
            var $77=HEAP32[(($arrayidx110)>>2)]; //@line 797 "speak.cpp"
            $p_text=$77; //@line 797 "speak.cpp"
            ; //@line 798 "speak.cpp"
          }
          else if (__label__ == 55) {
  
            var $73=HEAP32[((__impure_ptr)>>2)]; //@line 801 "speak.cpp"
            var $_stdin3=(($73+4)&4294967295); //@line 801 "speak.cpp"
            var $74=HEAP32[(($_stdin3)>>2)]; //@line 801 "speak.cpp"
            $f_text=$74; //@line 801 "speak.cpp"
            __lastLabel__ = 55; __label__ = 61;break $if_then105$$if_else116$65; //@line 802 "speak.cpp"
          }
        }
        else if (__label__ == 57) {
  
          var $78=HEAP32[((__impure_ptr)>>2)]; //@line 801 "speak.cpp"
          var $_stdin=(($78+4)&4294967295); //@line 801 "speak.cpp"
          var $79=HEAP32[(($_stdin)>>2)]; //@line 801 "speak.cpp"
          $f_text=$79; //@line 801 "speak.cpp"
          var $cmp112=((($72))|0)==0; //@line 802 "speak.cpp"
          if ($cmp112) { __lastLabel__ = 57; ; } else { __lastLabel__ = 57; __label__ = 61;break $if_then105$$if_else116$65; } //@line 802 "speak.cpp"
  
          HEAP32[((_option_linelength)>>2)]=-1; //@line 803 "speak.cpp"
          ; //@line 803 "speak.cpp"
        }
  
        var $_pr5=$f_text; //@line 811 "speak.cpp"
        __lastLabel__ = 60; ;
      }
      else if (__label__ == 59) {
  
        var $arraydecay117=(($filename)&4294967295); //@line 808 "speak.cpp"
        var $call118=_fopen($arraydecay117, ((__str51703)&4294967295)); //@line 808 "speak.cpp"
        $f_text=$call118; //@line 808 "speak.cpp"
        __lastLabel__ = 59; ;
      }
    } while(0);
  
    var $80=__lastLabel__ == 60 ? $_pr5 : (__lastLabel__ == 55 ? $74 : (__lastLabel__ == 57 ? $79 : ($call118))); //@line 811 "speak.cpp"
    var $cmp120=((($80))|0)==0; //@line 811 "speak.cpp"
    if ($cmp120) { __label__ = 62;; } else { __label__ = 64;; } //@line 811 "speak.cpp"
    $land_lhs_true121$$if_end127$77: do { 
      if (__label__ == 62) {
  
        var $81=$p_text; //@line 811 "speak.cpp"
        var $cmp122=((($81))|0)==0; //@line 811 "speak.cpp"
        if (!($cmp122)) { __label__ = 64;break $land_lhs_true121$$if_end127$77; } //@line 811 "speak.cpp"
  
        var $82=HEAP32[((__impure_ptr)>>2)]; //@line 813 "speak.cpp"
        var $_stderr124=(($82+12)&4294967295); //@line 813 "speak.cpp"
        var $83=HEAP32[(($_stderr124)>>2)]; //@line 813 "speak.cpp"
        var $84=$_ZZ4mainE8err_load; //@line 813 "speak.cpp"
        var $arraydecay125=(($filename)&4294967295); //@line 813 "speak.cpp"
        var $call126=_fprintf($83, ((__str27)&4294967295), allocate([$84,0,0,0,$arraydecay125,0,0,0], ["i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 813 "speak.cpp"
        _exit(1); //@line 814 "speak.cpp"
        ; //@line 815 "speak.cpp"
      }
    } while(0);
  
    var $85=HEAP32[((_option_waveout)>>2)]; //@line 817 "speak.cpp"
    var $tobool128=((($85))|0)!=0; //@line 817 "speak.cpp"
    var $86=HEAP32[((_quiet)>>2)]; //@line 817 "speak.cpp"
    var $tobool129=((($86))|0)!=0; //@line 817 "speak.cpp"
    var $or_cond1=($tobool128) | ($tobool129); //@line 817 "speak.cpp"
    if ($or_cond1) { __label__ = 65;; } else { __label__ = 79;; } //@line 817 "speak.cpp"
    $if_then130$$if_else168$81: do { 
      if (__label__ == 65) {
  
        var $87=HEAP32[((_quiet)>>2)]; //@line 819 "speak.cpp"
        var $tobool131=((($87))|0)!=0; //@line 819 "speak.cpp"
        var $88=HEAP32[((_samplerate)>>2)]; //@line 822 "speak.cpp"
        if ($tobool131) { __label__ = 66;; } else { __label__ = 67;; } //@line 819 "speak.cpp"
        $if_then132$$if_else134$83: do { 
          if (__label__ == 66) {
  
            var $call133=__ZL12OpenWaveFilePKci(0, $88); //@line 822 "speak.cpp"
            HEAP32[((_option_waveout)>>2)]=1; //@line 823 "speak.cpp"
            ; //@line 824 "speak.cpp"
          }
          else if (__label__ == 67) {
  
            var $89=HEAP32[((_samples_split)>>2)]; //@line 828 "speak.cpp"
            var $mul=((($88)*60)&4294967295); //@line 828 "speak.cpp"
            var $mul135=((($mul)*($89))&4294967295); //@line 828 "speak.cpp"
            HEAP32[((_samples_split)>>2)]=$mul135; //@line 828 "speak.cpp"
            var $90=HEAP32[((_samples_split)>>2)]; //@line 830 "speak.cpp"
            var $tobool136=((($90))|0)!=0; //@line 830 "speak.cpp"
            if ($tobool136) { __label__ = 68;; } else { __label__ = 71;; } //@line 830 "speak.cpp"
            if (__label__ == 68) {
  
              var $call138=_strrchr(((_wavefile)&4294967295), 46); //@line 834 "speak.cpp"
              $extn=$call138; //@line 834 "speak.cpp"
              var $91=$extn; //@line 835 "speak.cpp"
              var $cmp139=((($91))|0)!=0; //@line 835 "speak.cpp"
              if (!($cmp139)) { __label__ = 73;break $if_then132$$if_else134$83; } //@line 835 "speak.cpp"
  
              var $call141=_strlen(((_wavefile)&4294967295)); //@line 835 "speak.cpp"
              var $add_ptr=((((_wavefile)&4294967295)+$call141)&4294967295); //@line 835 "speak.cpp"
              var $92=$extn; //@line 835 "speak.cpp"
              var $sub_ptr_lhs_cast=($add_ptr); //@line 835 "speak.cpp"
              var $sub_ptr_rhs_cast=($92); //@line 835 "speak.cpp"
              var $sub_ptr_sub=((($sub_ptr_lhs_cast)-($sub_ptr_rhs_cast))&4294967295); //@line 835 "speak.cpp"
              var $cmp142=((($sub_ptr_sub))|0) <= 4; //@line 835 "speak.cpp"
              if (!($cmp142)) { __label__ = 73;break $if_then132$$if_else134$83; } //@line 835 "speak.cpp"
  
              var $93=$extn; //@line 837 "speak.cpp"
              var $call144=_strcpy(((_filetype)&4294967295), $93); //@line 837 "speak.cpp"
              var $94=$extn; //@line 838 "speak.cpp"
              HEAP8[($94)]=0; //@line 838 "speak.cpp"
              ; //@line 839 "speak.cpp"
            }
            else if (__label__ == 71) {
  
              var $95=HEAP32[((_samplerate)>>2)]; //@line 842 "speak.cpp"
              var $call147=__ZL12OpenWaveFilePKci(((_wavefile)&4294967295), $95); //@line 842 "speak.cpp"
              var $cmp148=((($call147))|0)!=0; //@line 842 "speak.cpp"
              if (!($cmp148)) { __label__ = 73;break $if_then132$$if_else134$83; } //@line 842 "speak.cpp"
  
              var $96=HEAP32[((__impure_ptr)>>2)]; //@line 844 "speak.cpp"
              var $_stderr150=(($96+12)&4294967295); //@line 844 "speak.cpp"
              var $97=HEAP32[(($_stderr150)>>2)]; //@line 844 "speak.cpp"
              var $call151=_fprintf($97, ((__str28)&4294967295), allocate([((_wavefile)&4294967295),0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 844 "speak.cpp"
              _exit(3); //@line 845 "speak.cpp"
              ; //@line 846 "speak.cpp"
            }
          }
        } while(0);
  
        __Z8InitTexti(0); //@line 849 "speak.cpp"
        var $98=$f_text; //@line 850 "speak.cpp"
        var $99=$p_text; //@line 850 "speak.cpp"
        var $call155=__Z15SpeakNextClauseP7__sFILEPKvi($98, $99, 0); //@line 850 "speak.cpp"
        $ix=1; //@line 852 "speak.cpp"
        ; //@line 853 "speak.cpp"
        while(1) { 
  
          var $call156=__ZL11WavegenFilev(); //@line 855 "speak.cpp"
          var $cmp157=((($call156))|0)!=0; //@line 855 "speak.cpp"
          if ($cmp157) { __label__ = 75;; } else { __label__ = 76;; } //@line 855 "speak.cpp"
          if (__label__ == 75) {
  
            var $100=$ix; //@line 857 "speak.cpp"
            var $cmp159=((($100))|0)==0; //@line 857 "speak.cpp"
            if ($cmp159) { __label__ = 78;break ; } //@line 857 "speak.cpp"
          }
  
          var $call163=__Z8GenerateP12PHONEME_LISTPii(((_phoneme_list)&4294967295), _n_phoneme_list, 1); //@line 861 "speak.cpp"
          var $cmp164=((($call163))|0)==0; //@line 861 "speak.cpp"
          if (!($cmp164)) { __label__ = 74;continue ; } //@line 861 "speak.cpp"
  
          var $call166=__Z15SpeakNextClauseP7__sFILEPKvi(0, 0, 1); //@line 863 "speak.cpp"
          $ix=$call166; //@line 863 "speak.cpp"
          __label__ = 74;continue ; //@line 864 "speak.cpp"
        }
  
        __ZL13CloseWaveFilev(); //@line 867 "speak.cpp"
        __label__ = 83;break $if_then130$$if_else168$81; //@line 868 "speak.cpp"
      }
      else if (__label__ == 79) {
  
        __Z8InitTexti(0); //@line 877 "speak.cpp"
        var $101=$f_text; //@line 878 "speak.cpp"
        var $102=$p_text; //@line 878 "speak.cpp"
        var $call170=__Z15SpeakNextClauseP7__sFILEPKvi($101, $102, 0); //@line 878 "speak.cpp"
        var $103=HEAP32[((_option_quiet)>>2)]; //@line 880 "speak.cpp"
        var $tobool171=((($103))|0)!=0; //@line 880 "speak.cpp"
        if ($tobool171) { __label__ = 80;; } else { __label__ = 82;; } //@line 880 "speak.cpp"
        if (__label__ == 80) {
          while(1) { 
  
            var $call173=__Z15SpeakNextClauseP7__sFILEPKvi(0, 0, 1); //@line 882 "speak.cpp"
            var $cmp174=((($call173))|0)!=0; //@line 882 "speak.cpp"
            if ($cmp174) { __label__ = 80;continue ; } else { __label__ = 81;break ; } //@line 882 "speak.cpp"
          }
  
          $retval=0; //@line 883 "speak.cpp"
          __label__ = 87;break $if_then130$$if_else168$81; //@line 883 "speak.cpp"
        }
        else if (__label__ == 82) {
  
          var $104=HEAP32[((__impure_ptr)>>2)]; //@line 909 "speak.cpp"
          var $_stderr178=(($104+12)&4294967295); //@line 909 "speak.cpp"
          var $105=HEAP32[(($_stderr178)>>2)]; //@line 909 "speak.cpp"
          var $106=_fwrite(((__str29)&4294967295), 79, 1, $105); //@line 909 "speak.cpp"
          __label__ = 83;break $if_then130$$if_else168$81;
        }
      }
    } while(0);
    if (__label__ == 83) {
  
      var $107=HEAP32[((_f_trans)>>2)]; //@line 913 "speak.cpp"
      var $108=HEAP32[((__impure_ptr)>>2)]; //@line 913 "speak.cpp"
      var $_stdout181=(($108+8)&4294967295); //@line 913 "speak.cpp"
      var $109=HEAP32[(($_stdout181)>>2)]; //@line 913 "speak.cpp"
      var $cmp182=((($107))|0)!=((($109))|0); //@line 913 "speak.cpp"
      if ($cmp182) { __label__ = 84;; } else { __label__ = 86;; } //@line 913 "speak.cpp"
      $land_lhs_true183$$if_end188$108: do { 
        if (__label__ == 84) {
  
          var $110=HEAP32[((_f_trans)>>2)]; //@line 913 "speak.cpp"
          var $111=HEAP32[((__impure_ptr)>>2)]; //@line 913 "speak.cpp"
          var $_stderr184=(($111+12)&4294967295); //@line 913 "speak.cpp"
          var $112=HEAP32[(($_stderr184)>>2)]; //@line 913 "speak.cpp"
          var $cmp185=((($110))|0)!=((($112))|0); //@line 913 "speak.cpp"
          if (!($cmp185)) { __label__ = 86;break $land_lhs_true183$$if_end188$108; } //@line 913 "speak.cpp"
  
          var $113=HEAP32[((_f_trans)>>2)]; //@line 914 "speak.cpp"
          var $call187=_fclose($113); //@line 914 "speak.cpp"
          ; //@line 914 "speak.cpp"
        }
      } while(0);
  
      $retval=0; //@line 915 "speak.cpp"
      ; //@line 915 "speak.cpp"
    }
  
    var $114=$retval; //@line 916 "speak.cpp"
    ;
    return $114; //@line 916 "speak.cpp"
    return null;
  }
  Module["_main"] = _main;

  function __ZL9init_pathPcS_($argv0, $path_specified) {
    ;
    var __label__;
  
    var $argv0_addr;
    var $path_specified_addr;
    var $env;
    $argv0_addr=$argv0;
    $path_specified_addr=$path_specified;
    var $0=$path_specified_addr; //@line 341 "speak.cpp"
    var $tobool=((($0))|0)!=0; //@line 341 "speak.cpp"
    if ($tobool) { __label__ = 1;; } else { __label__ = 2;; } //@line 341 "speak.cpp"
    $if_then$$if_end$2: do { 
      if (__label__ == 1) {
  
        var $1=$path_specified_addr; //@line 343 "speak.cpp"
        var $call=_sprintf(((_path_home)&4294967295), ((__str38)&4294967295), allocate([$1,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 343 "speak.cpp"
        ; //@line 344 "speak.cpp"
      }
      else if (__label__ == 2) {
  
        var $call1=_getenv(((__str39)&4294967295)); //@line 383 "speak.cpp"
        $env=$call1; //@line 383 "speak.cpp"
        var $cmp=((($call1))|0)!=0; //@line 383 "speak.cpp"
        if ($cmp) { __label__ = 3;; } else { __label__ = 4;; } //@line 383 "speak.cpp"
        if (__label__ == 3) {
  
          var $2=$env; //@line 385 "speak.cpp"
          var $call3=_snprintf(((_path_home)&4294967295), 150, ((__str38)&4294967295), allocate([$2,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 385 "speak.cpp"
          var $call4=__Z13GetFileLengthPKc(((_path_home)&4294967295)); //@line 386 "speak.cpp"
          var $cmp5=((($call4))|0)==-2; //@line 386 "speak.cpp"
          if ($cmp5) { __label__ = 6;break $if_then$$if_end$2; } //@line 386 "speak.cpp"
        }
  
        var $call9=_getenv(((__str40)&4294967295)); //@line 390 "speak.cpp"
        var $call10=_snprintf(((_path_home)&4294967295), 150, ((__str38)&4294967295), allocate([$call9,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 390 "speak.cpp"
        var $call11=_access(((_path_home)&4294967295), 4); //@line 391 "speak.cpp"
        var $cmp12=((($call11))|0)!=0; //@line 391 "speak.cpp"
        if (!($cmp12)) { __label__ = 6;break $if_then$$if_end$2; } //@line 391 "speak.cpp"
  
        var $src$, $dest$, $stop$, $stop4$, $fast$;
        $src$ = ((__str41)&4294967295);
        $dest$ = ((_path_home)&4294967295);
        $stop$ = $src$ + 23;
        if (($dest$%4) == ($src$%4) && 23 > 8) {
          while ($src$%4 !== 0 && $src$ < $stop$) {
            ; HEAP8[$dest$++] = HEAP8[$src$++];
          }
          $src$ >>= 2;
          $dest$ >>= 2;
          $stop4$ = $stop$ >> 2;
          while ($src$ < $stop4$) {
        ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
          }
          $src$ <<= 2;
          $dest$ <<= 2;
        }while ($src$ < $stop$) {
          ; HEAP8[$dest$++] = HEAP8[$src$++];
        }; //@line 393 "speak.cpp"
        ; //@line 394 "speak.cpp"
      }
    } while(0);
  
    ;
    return; //@line 397 "speak.cpp"
    return;
  }
  

  function __ZL10initialisev() {
    ;
    var __label__;
  
    var $param;
    var $result;
    var $call=_setlocale(2, ((__str32)&4294967295)); //@line 411 "speak.cpp"
    var $cmp=((($call))|0)==0; //@line 411 "speak.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 3;; } //@line 411 "speak.cpp"
    $if_then$$if_end5$2: do { 
      if (__label__ == 1) {
  
        var $call1=_setlocale(2, ((__str33)&4294967295)); //@line 413 "speak.cpp"
        var $cmp2=((($call1))|0)==0; //@line 413 "speak.cpp"
        if (!($cmp2)) { __label__ = 3;break $if_then$$if_end5$2; } //@line 413 "speak.cpp"
  
        var $call4=_setlocale(2, ((__str13643)&4294967295)); //@line 414 "speak.cpp"
        ; //@line 414 "speak.cpp"
      }
    } while(0);
  
    __Z11WavegenInitii(22050, 0); //@line 419 "speak.cpp"
    var $call6=__Z10LoadPhDatav(); //@line 420 "speak.cpp"
    $result=$call6; //@line 420 "speak.cpp"
    var $cmp7=((($call6))|0)!=1; //@line 420 "speak.cpp"
    if ($cmp7) { __label__ = 4;; } else { __label__ = 7;; } //@line 420 "speak.cpp"
    if (__label__ == 4) {
  
      var $0=$result; //@line 422 "speak.cpp"
      var $cmp9=((($0))|0)==-1; //@line 422 "speak.cpp"
      var $1=HEAP32[((__impure_ptr)>>2)]; //@line 424 "speak.cpp"
      var $_stderr=(($1+12)&4294967295); //@line 424 "speak.cpp"
      var $2=HEAP32[(($_stderr)>>2)]; //@line 424 "speak.cpp"
      if ($cmp9) { __label__ = 5;; } else { __label__ = 6;; } //@line 422 "speak.cpp"
      if (__label__ == 5) {
  
        var $3=_fwrite(((__str35)&4294967295), 27, 1, $2); //@line 424 "speak.cpp"
        _exit(1); //@line 425 "speak.cpp"
        ; //@line 426 "speak.cpp"
      }
      else if (__label__ == 6) {
  
        var $4=$result; //@line 428 "speak.cpp"
        var $call13=_fprintf($2, ((__str36)&4294967295), allocate([$4,0,0,0,83200,0,0,0,((_path_home)&4294967295),0,0,0], ["i32",0,0,0,"i32",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 428 "speak.cpp"
        ;
      }
    }
  
    __Z10LoadConfigv(); //@line 430 "speak.cpp"
    __Z13SetVoiceStackP12espeak_VOICE(0); //@line 431 "speak.cpp"
    __Z14SynthesizeInitv(); //@line 432 "speak.cpp"
    $param=0; //@line 434 "speak.cpp"
    ; //@line 434 "speak.cpp"
    while(1) { 
  
      var $5=$param; //@line 435 "speak.cpp"
      var $arrayidx=((_param_defaults+$5*4)&4294967295); //@line 435 "speak.cpp"
      var $6=HEAP32[(($arrayidx)>>2)]; //@line 435 "speak.cpp"
      var $7=$param; //@line 435 "speak.cpp"
      var $arrayidx17=((((_param_stack+4)&4294967295)+$7*4)&4294967295); //@line 435 "speak.cpp"
      HEAP32[(($arrayidx17)>>2)]=$6; //@line 435 "speak.cpp"
      var $8=$param; //@line 434 "speak.cpp"
      var $inc=((($8)+1)&4294967295); //@line 434 "speak.cpp"
      $param=$inc; //@line 434 "speak.cpp"
      var $cmp16=((($inc))|0) < 15; //@line 434 "speak.cpp"
      if ($cmp16) { __label__ = 8;continue ; } else { __label__ = 9;break ; } //@line 434 "speak.cpp"
    }
  
    ;
    return;
    return;
  }
  

  function __ZL12OpenWaveFilePKci($path, $rate) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $path_addr;
    var $rate_addr;
    $path_addr=$path;
    $rate_addr=$rate;
    var $0=$path_addr; //@line 235 "speak.cpp"
    var $cmp=((($0))|0)==0; //@line 235 "speak.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 235 "speak.cpp"
    if (__label__ == 1) {
  
      $retval=2; //@line 236 "speak.cpp"
      ; //@line 236 "speak.cpp"
    }
    else if (__label__ == 2) {
  
      var $1=$path_addr; //@line 238 "speak.cpp"
      var $call=_strcmp($1, ((__str12)&4294967295)); //@line 238 "speak.cpp"
      var $cmp1=((($call))|0)==0; //@line 238 "speak.cpp"
      if ($cmp1) { __label__ = 3;; } else { __label__ = 4;; } //@line 238 "speak.cpp"
      if (__label__ == 3) {
  
        var $2=HEAP32[((__impure_ptr)>>2)]; //@line 244 "speak.cpp"
        var $_stdout=(($2+8)&4294967295); //@line 244 "speak.cpp"
        var $3=HEAP32[(($_stdout)>>2)]; //@line 244 "speak.cpp"
        HEAP32[((_f_wave)>>2)]=$3; //@line 244 "speak.cpp"
        __lastLabel__ = 3; ; //@line 245 "speak.cpp"
      }
      else if (__label__ == 4) {
  
        var $4=$path_addr; //@line 247 "speak.cpp"
        var $call3=_fopen($4, ((__str79)&4294967295)); //@line 247 "speak.cpp"
        HEAP32[((_f_wave)>>2)]=$call3; //@line 247 "speak.cpp"
        __lastLabel__ = 4; ;
      }
  
      var $5=__lastLabel__ == 4 ? $call3 : ($3); //@line 249 "speak.cpp"
      var $cmp5=((($5))|0)!=0; //@line 249 "speak.cpp"
      if ($cmp5) { __label__ = 6;; } else { __label__ = 7;; } //@line 249 "speak.cpp"
      if (__label__ == 6) {
  
        var $6=HEAP32[((_f_wave)>>2)]; //@line 251 "speak.cpp"
        var $call7=_fwrite(((__ZZL12OpenWaveFilePKciE8wave_hdr)&4294967295), 1, 24, $6); //@line 251 "speak.cpp"
        var $7=HEAP32[((_f_wave)>>2)]; //@line 252 "speak.cpp"
        var $8=$rate_addr; //@line 252 "speak.cpp"
        __Z11Write4BytesP7__sFILEi($7, $8); //@line 252 "speak.cpp"
        var $9=HEAP32[((_f_wave)>>2)]; //@line 253 "speak.cpp"
        var $10=$rate_addr; //@line 253 "speak.cpp"
        var $mul=((($10)*2)&4294967295); //@line 253 "speak.cpp"
        __Z11Write4BytesP7__sFILEi($9, $mul); //@line 253 "speak.cpp"
        var $11=HEAP32[((_f_wave)>>2)]; //@line 254 "speak.cpp"
        var $call8=_fwrite(((__ZZL12OpenWaveFilePKciE8wave_hdr+32)&4294967295), 1, 12, $11); //@line 254 "speak.cpp"
        $retval=0; //@line 255 "speak.cpp"
        ; //@line 255 "speak.cpp"
      }
      else if (__label__ == 7) {
  
        $retval=1; //@line 257 "speak.cpp"
        ; //@line 257 "speak.cpp"
      }
    }
  
    var $12=$retval; //@line 258 "speak.cpp"
    ;
    return $12; //@line 258 "speak.cpp"
    return null;
  }
  

  function __ZL11WavegenFilev() {
    var __stackBase__  = STACKTOP; STACKTOP += 1236; _memset(__stackBase__, 0, 1236);
    var __label__;
  
    var $retval;
    var $finished;
    var $wav_outbuf=__stackBase__;
    var $fname=__stackBase__+1024;
    var $arraydecay=(($wav_outbuf)&4294967295); //@line 303 "speak.cpp"
    HEAP32[((_out_start)>>2)]=$arraydecay; //@line 303 "speak.cpp"
    HEAP32[((_out_ptr)>>2)]=$arraydecay; //@line 303 "speak.cpp"
    var $arraydecay1=(($wav_outbuf)&4294967295); //@line 304 "speak.cpp"
    var $add_ptr=(($arraydecay1+1024)&4294967295); //@line 304 "speak.cpp"
    HEAP32[((_out_end)>>2)]=$add_ptr; //@line 304 "speak.cpp"
    var $call=__Z11WavegenFilli(0); //@line 306 "speak.cpp"
    $finished=$call; //@line 306 "speak.cpp"
    var $0=HEAP32[((_quiet)>>2)]; //@line 308 "speak.cpp"
    var $tobool=((($0))|0)!=0; //@line 308 "speak.cpp"
    if ($tobool) { __label__ = 1;; } else { __label__ = 2;; } //@line 308 "speak.cpp"
    $if_then$$if_end$2: do { 
      if (__label__ == 1) {
  
        var $1=$finished; //@line 309 "speak.cpp"
        $retval=$1; //@line 309 "speak.cpp"
        ; //@line 309 "speak.cpp"
      }
      else if (__label__ == 2) {
  
        var $2=HEAP32[((_f_wave)>>2)]; //@line 311 "speak.cpp"
        var $cmp=((($2))|0)==0; //@line 311 "speak.cpp"
        if ($cmp) { __label__ = 3;; } else { __label__ = 5;; } //@line 311 "speak.cpp"
        $if_then2$$if_end10$5: do { 
          if (__label__ == 3) {
  
            var $arraydecay3=(($fname)&4294967295); //@line 313 "speak.cpp"
            var $3=HEAP32[((_wavefile_count)>>2)]; //@line 313 "speak.cpp"
            var $inc=((($3)+1)&4294967295); //@line 313 "speak.cpp"
            HEAP32[((_wavefile_count)>>2)]=$inc; //@line 313 "speak.cpp"
            var $call4=_sprintf($arraydecay3, ((__str30)&4294967295), allocate([((_wavefile)&4294967295),0,0,0,$inc,0,0,0,((_filetype)&4294967295),0,0,0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 313 "speak.cpp"
            var $arraydecay5=(($fname)&4294967295); //@line 314 "speak.cpp"
            var $4=HEAP32[((_samplerate)>>2)]; //@line 314 "speak.cpp"
            var $call6=__ZL12OpenWaveFilePKci($arraydecay5, $4); //@line 314 "speak.cpp"
            var $cmp7=((($call6))|0)!=0; //@line 314 "speak.cpp"
            if (!($cmp7)) { __label__ = 5;break $if_then2$$if_end10$5; } //@line 314 "speak.cpp"
  
            $retval=1; //@line 315 "speak.cpp"
            __label__ = 12;break $if_then$$if_end$2; //@line 315 "speak.cpp"
          }
        } while(0);
  
        var $5=HEAP32[((_end_of_sentence)>>2)]; //@line 318 "speak.cpp"
        var $tobool11=((($5))|0)!=0; //@line 318 "speak.cpp"
        if ($tobool11) { __label__ = 6;; } else { __label__ = 9;; } //@line 318 "speak.cpp"
        $if_then12$$if_end17$9: do { 
          if (__label__ == 6) {
  
            HEAP32[((_end_of_sentence)>>2)]=0; //@line 320 "speak.cpp"
            var $6=HEAPU32[((_samples_split)>>2)]; //@line 321 "speak.cpp"
            var $cmp13=((($6))>>>0) > 0; //@line 321 "speak.cpp"
            if (!($cmp13)) { __label__ = 9;break $if_then12$$if_end17$9; } //@line 321 "speak.cpp"
  
            var $7=HEAPU32[((_samples_total)>>2)]; //@line 321 "speak.cpp"
            var $8=HEAPU32[((_samples_split)>>2)]; //@line 321 "speak.cpp"
            var $cmp14=((($7))>>>0) > ((($8))>>>0); //@line 321 "speak.cpp"
            if (!($cmp14)) { __label__ = 9;break $if_then12$$if_end17$9; } //@line 321 "speak.cpp"
  
            __ZL13CloseWaveFilev(); //@line 323 "speak.cpp"
            HEAP32[((_samples_total)>>2)]=0; //@line 324 "speak.cpp"
            ; //@line 325 "speak.cpp"
          }
        } while(0);
  
        var $9=HEAP32[((_f_wave)>>2)]; //@line 328 "speak.cpp"
        var $cmp18=((($9))|0)!=0; //@line 328 "speak.cpp"
        if ($cmp18) { __label__ = 10;; } else { __label__ = 11;; } //@line 328 "speak.cpp"
        if (__label__ == 10) {
  
          var $10=HEAP32[((_out_ptr)>>2)]; //@line 330 "speak.cpp"
          var $arraydecay20=(($wav_outbuf)&4294967295); //@line 330 "speak.cpp"
          var $sub_ptr_lhs_cast=($10); //@line 330 "speak.cpp"
          var $sub_ptr_rhs_cast=($arraydecay20); //@line 330 "speak.cpp"
          var $sub_ptr_sub=((($sub_ptr_lhs_cast)-($sub_ptr_rhs_cast))&4294967295); //@line 330 "speak.cpp"
          var $div=((((($sub_ptr_sub))|0)/2)|0); //@line 330 "speak.cpp"
          var $11=HEAP32[((_samples_total)>>2)]; //@line 330 "speak.cpp"
          var $add=((($11)+($div))&4294967295); //@line 330 "speak.cpp"
          HEAP32[((_samples_total)>>2)]=$add; //@line 330 "speak.cpp"
          var $arraydecay21=(($wav_outbuf)&4294967295); //@line 331 "speak.cpp"
          var $12=HEAP32[((_out_ptr)>>2)]; //@line 331 "speak.cpp"
          var $arraydecay22=(($wav_outbuf)&4294967295); //@line 331 "speak.cpp"
          var $sub_ptr_lhs_cast23=($12); //@line 331 "speak.cpp"
          var $sub_ptr_rhs_cast24=($arraydecay22); //@line 331 "speak.cpp"
          var $sub_ptr_sub25=((($sub_ptr_lhs_cast23)-($sub_ptr_rhs_cast24))&4294967295); //@line 331 "speak.cpp"
          var $13=HEAP32[((_f_wave)>>2)]; //@line 331 "speak.cpp"
          var $call26=_fwrite($arraydecay21, 1, $sub_ptr_sub25, $13); //@line 331 "speak.cpp"
          ; //@line 332 "speak.cpp"
        }
  
        var $14=$finished; //@line 333 "speak.cpp"
        $retval=$14; //@line 333 "speak.cpp"
        ; //@line 333 "speak.cpp"
      }
    } while(0);
  
    var $15=$retval; //@line 334 "speak.cpp"
    STACKTOP = __stackBase__;
    return $15; //@line 334 "speak.cpp"
    return null;
  }
  

  function __ZL13CloseWaveFilev() {
    ;
    var __label__;
  
    var $pos;
    var $0=HEAP32[((_f_wave)>>2)]; //@line 268 "speak.cpp"
    var $cmp=((($0))|0)==0; //@line 268 "speak.cpp"
    if ($cmp) { __label__ = 3;; } else { __label__ = 1;; } //@line 268 "speak.cpp"
    $return$$lor_lhs_false$2: do { 
      if (__label__ == 1) {
  
        var $1=HEAP32[((_f_wave)>>2)]; //@line 268 "speak.cpp"
        var $2=HEAP32[((__impure_ptr)>>2)]; //@line 268 "speak.cpp"
        var $_stdout=(($2+8)&4294967295); //@line 268 "speak.cpp"
        var $3=HEAP32[(($_stdout)>>2)]; //@line 268 "speak.cpp"
        var $cmp1=((($1))|0)==((($3))|0); //@line 268 "speak.cpp"
        if ($cmp1) { __label__ = 3;break $return$$lor_lhs_false$2; } //@line 268 "speak.cpp"
  
        var $4=HEAP32[((_f_wave)>>2)]; //@line 271 "speak.cpp"
        var $call=_fflush($4); //@line 271 "speak.cpp"
        var $5=HEAP32[((_f_wave)>>2)]; //@line 272 "speak.cpp"
        var $call2=_ftell($5); //@line 272 "speak.cpp"
        $pos=$call2; //@line 272 "speak.cpp"
        var $6=HEAP32[((_f_wave)>>2)]; //@line 274 "speak.cpp"
        var $call3=_fseek($6, 4, 0); //@line 274 "speak.cpp"
        var $7=HEAP32[((_f_wave)>>2)]; //@line 275 "speak.cpp"
        var $8=$pos; //@line 275 "speak.cpp"
        var $sub=((($8)-8)&4294967295); //@line 275 "speak.cpp"
        __Z11Write4BytesP7__sFILEi($7, $sub); //@line 275 "speak.cpp"
        var $9=HEAP32[((_f_wave)>>2)]; //@line 277 "speak.cpp"
        var $call4=_fseek($9, 40, 0); //@line 277 "speak.cpp"
        var $10=HEAP32[((_f_wave)>>2)]; //@line 278 "speak.cpp"
        var $11=$pos; //@line 278 "speak.cpp"
        var $sub5=((($11)-44)&4294967295); //@line 278 "speak.cpp"
        __Z11Write4BytesP7__sFILEi($10, $sub5); //@line 278 "speak.cpp"
        var $12=HEAP32[((_f_wave)>>2)]; //@line 281 "speak.cpp"
        var $call6=_fclose($12); //@line 281 "speak.cpp"
        HEAP32[((_f_wave)>>2)]=0; //@line 282 "speak.cpp"
        ; //@line 284 "speak.cpp"
      }
    } while(0);
  
    ;
    return; //@line 284 "speak.cpp"
    return;
  }
  

  function __Z8isspace2j($c) {
    ;
    var __label__;
  
    var $retval;
    var $c_addr;
    var $c2;
    $c_addr=$c;
    var $0=$c_addr; //@line 150 "compiledict.cpp"
    var $and=($0) & 255; //@line 150 "compiledict.cpp"
    $c2=$and; //@line 150 "compiledict.cpp"
    var $cmp=((($and))|0)==0; //@line 150 "compiledict.cpp"
    var $1=$c_addr; //@line 150 "compiledict.cpp"
    var $cmp1=((($1))>>>0) > 32; //@line 150 "compiledict.cpp"
    var $or_cond=($cmp) | ($cmp1); //@line 150 "compiledict.cpp"
    if ($or_cond) { __label__ = 1;; } else { __label__ = 2;; } //@line 150 "compiledict.cpp"
    if (__label__ == 1) {
  
      $retval=0; //@line 151 "compiledict.cpp"
      ; //@line 151 "compiledict.cpp"
    }
    else if (__label__ == 2) {
  
      $retval=1; //@line 152 "compiledict.cpp"
      ; //@line 152 "compiledict.cpp"
    }
  
    var $2=$retval; //@line 153 "compiledict.cpp"
    ;
    return $2; //@line 153 "compiledict.cpp"
    return null;
  }
  

  function __Z14LookupMnemNameP8MNEM_TABi($table, $value) {
    ;
    var __label__;
  
    var $retval;
    var $table_addr;
    var $value_addr;
    $table_addr=$table;
    $value_addr=$value;
    ; //@line 175 "compiledict.cpp"
    while(1) { 
  
      var $0=$table_addr; //@line 175 "compiledict.cpp"
      var $mnem=(($0)&4294967295); //@line 175 "compiledict.cpp"
      var $1=HEAP32[(($mnem)>>2)]; //@line 175 "compiledict.cpp"
      var $cmp=((($1))|0)!=0; //@line 175 "compiledict.cpp"
      if (!($cmp)) { __label__ = 5;break ; } //@line 175 "compiledict.cpp"
  
      var $2=$table_addr; //@line 177 "compiledict.cpp"
      var $value1=(($2+4)&4294967295); //@line 177 "compiledict.cpp"
      var $3=HEAP32[(($value1)>>2)]; //@line 177 "compiledict.cpp"
      var $4=$value_addr; //@line 177 "compiledict.cpp"
      var $cmp2=((($3))|0)==((($4))|0); //@line 177 "compiledict.cpp"
      var $5=$table_addr; //@line 178 "compiledict.cpp"
      if ($cmp2) { __label__ = 3;break ; } //@line 177 "compiledict.cpp"
  
      var $incdec_ptr=(($5+8)&4294967295); //@line 179 "compiledict.cpp"
      $table_addr=$incdec_ptr; //@line 179 "compiledict.cpp"
      __label__ = 1;continue ; //@line 180 "compiledict.cpp"
    }
    if (__label__ == 5) {
  
      $retval=((__str13643)&4294967295); //@line 181 "compiledict.cpp"
      ; //@line 181 "compiledict.cpp"
    }
    else if (__label__ == 3) {
  
      var $mnem3=(($5)&4294967295); //@line 178 "compiledict.cpp"
      var $6=HEAP32[(($mnem3)>>2)]; //@line 178 "compiledict.cpp"
      $retval=$6; //@line 178 "compiledict.cpp"
      ; //@line 178 "compiledict.cpp"
    }
  
    var $7=$retval; //@line 182 "compiledict.cpp"
    ;
    return $7; //@line 182 "compiledict.cpp"
    return null;
  }
  

  function __Z22print_dictionary_flagsPj($flags) {
    ;
    var __label__;
  
    var $flags_addr;
    $flags_addr=$flags;
    var $0=$flags_addr; //@line 189 "compiledict.cpp"
    var $arrayidx=(($0)&4294967295); //@line 189 "compiledict.cpp"
    var $1=HEAP32[(($arrayidx)>>2)]; //@line 189 "compiledict.cpp"
    var $and=($1) & 15; //@line 189 "compiledict.cpp"
    var $add=((($and)+64)&4294967295); //@line 189 "compiledict.cpp"
    var $call=__Z14LookupMnemNameP8MNEM_TABi(((_mnem_flags)&4294967295), $add); //@line 189 "compiledict.cpp"
    var $2=$flags_addr; //@line 189 "compiledict.cpp"
    var $arrayidx1=(($2)&4294967295); //@line 189 "compiledict.cpp"
    var $3=HEAP32[(($arrayidx1)>>2)]; //@line 189 "compiledict.cpp"
    var $4=$flags_addr; //@line 189 "compiledict.cpp"
    var $arrayidx2=(($4+4)&4294967295); //@line 189 "compiledict.cpp"
    var $5=HEAP32[(($arrayidx2)>>2)]; //@line 189 "compiledict.cpp"
    var $call3=_sprintf(((__ZZ22print_dictionary_flagsPjE3buf)&4294967295), ((__str59)&4294967295), allocate([$call,0,0,0,$3,0,0,0,$5,0,0,0], ["i8*",0,0,0,"i32",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 189 "compiledict.cpp"
    ;
    return ((__ZZ22print_dictionary_flagsPjE3buf)&4294967295); //@line 190 "compiledict.cpp"
    return null;
  }
  

  function __Z10DecodeRulePKciPci($group_chars, $group_length, $rule, $control) {
    var __stackBase__  = STACKTOP; STACKTOP += 140; _memset(__stackBase__, 0, 140);
    var __label__;
    var __lastLabel__ = null;
  
    var $group_chars_addr;
    var $group_length_addr;
    var $rule_addr;
    var $control_addr;
    var $rb;
    var $c;
    var $p;
    var $ix;
    var $match_type;
    var $finished;
    var $value;
    var $linenum;
    var $flags;
    var $suffix_char;
    var $condition_num;
    var $at_start;
    var $name;
    var $buf=__stackBase__;
    var $buf_pre=__stackBase__+60;
    var $suffix=__stackBase__+120;
    $group_chars_addr=$group_chars;
    $group_length_addr=$group_length;
    $rule_addr=$rule;
    $control_addr=$control;
    $finished=0; //@line 205 "compiledict.cpp"
    $linenum=0; //@line 207 "compiledict.cpp"
    $condition_num=0; //@line 210 "compiledict.cpp"
    $at_start=0; //@line 211 "compiledict.cpp"
    $match_type=0; //@line 223 "compiledict.cpp"
    var $arrayidx=(($buf_pre)&4294967295); //@line 224 "compiledict.cpp"
    HEAP8[($arrayidx)]=0; //@line 224 "compiledict.cpp"
    $ix=0; //@line 226 "compiledict.cpp"
    var $0=$ix; //@line 226 "compiledict.cpp"
    var $1=$group_length_addr; //@line 226 "compiledict.cpp"
    var $cmp9=((($0))|0) < ((($1))|0); //@line 226 "compiledict.cpp"
    var $2=$ix; //@line 228 "compiledict.cpp"
    if ($cmp9) { __lastLabel__ = 0; __label__ = 1;; } else { __lastLabel__ = 0; __label__ = 2;; } //@line 226 "compiledict.cpp"
    $for_body$$for_end$2: do { 
      if (__label__ == 1) {
        while(1) { 
  
          var $3=__lastLabel__ == 1 ? $10 : ($2);
          var $4=$group_chars_addr; //@line 228 "compiledict.cpp"
          var $arrayidx1=(($4+$3)&4294967295); //@line 228 "compiledict.cpp"
          var $5=HEAP8[($arrayidx1)]; //@line 228 "compiledict.cpp"
          var $6=$ix; //@line 228 "compiledict.cpp"
          var $arrayidx2=(($buf+$6)&4294967295); //@line 228 "compiledict.cpp"
          HEAP8[($arrayidx2)]=$5; //@line 228 "compiledict.cpp"
          var $7=$ix; //@line 226 "compiledict.cpp"
          var $inc=((($7)+1)&4294967295); //@line 226 "compiledict.cpp"
          $ix=$inc; //@line 226 "compiledict.cpp"
          var $8=$ix; //@line 226 "compiledict.cpp"
          var $9=$group_length_addr; //@line 226 "compiledict.cpp"
          var $cmp=((($8))|0) < ((($9))|0); //@line 226 "compiledict.cpp"
          var $10=$ix; //@line 228 "compiledict.cpp"
          if ($cmp) { __lastLabel__ = 1; __label__ = 1;continue ; } else { __lastLabel__ = 1; __label__ = 2;break $for_body$$for_end$2; } //@line 226 "compiledict.cpp"
        }
      }
    } while(0);
  
    var $_lcssa8=__lastLabel__ == 0 ? $2 : ($10);
    var $arrayidx3=(($buf+$_lcssa8)&4294967295); //@line 230 "compiledict.cpp"
    HEAP8[($arrayidx3)]=0; //@line 230 "compiledict.cpp"
    var $arraydecay=(($buf)&4294967295); //@line 232 "compiledict.cpp"
    var $call=_strlen($arraydecay); //@line 232 "compiledict.cpp"
    var $arrayidx4=(($buf+$call)&4294967295); //@line 232 "compiledict.cpp"
    $p=$arrayidx4; //@line 232 "compiledict.cpp"
    var $11=$finished; //@line 233 "compiledict.cpp"
    var $tobool6=((($11))|0)!=0; //@line 233 "compiledict.cpp"
    var $lnot7=($tobool6) ^ 1; //@line 233 "compiledict.cpp"
    if ($lnot7) { __label__ = 3;; } else { __label__ = 38;; } //@line 233 "compiledict.cpp"
    $while_body_lr_ph$$while_end$6: do { 
      if (__label__ == 3) {
  
        var $arraydecay9=(($buf_pre)&4294967295); //@line 250 "compiledict.cpp"
        var $arraydecay11=(($buf)&4294967295); //@line 255 "compiledict.cpp"
        var $arraydecay13=(($buf)&4294967295); //@line 256 "compiledict.cpp"
        var $arraydecay58=(($suffix)&4294967295); //@line 293 "compiledict.cpp"
        var $arraydecay70=(($suffix)&4294967295); //@line 298 "compiledict.cpp"
        var $arraydecay80=(($suffix)&4294967295); //@line 301 "compiledict.cpp"
        var $arraydecay82=(($suffix)&4294967295); //@line 302 "compiledict.cpp"
        ; //@line 233 "compiledict.cpp"
        $while_body$8: while(1) { 
  
          var $12=$rule_addr; //@line 235 "compiledict.cpp"
          var $incdec_ptr=(($12+1)&4294967295); //@line 235 "compiledict.cpp"
          $rule_addr=$incdec_ptr; //@line 235 "compiledict.cpp"
          var $13=HEAP8[($12)]; //@line 235 "compiledict.cpp"
          $rb=$13; //@line 235 "compiledict.cpp"
          var $14=$rb; //@line 237 "compiledict.cpp"
          var $conv=((($14))&255); //@line 237 "compiledict.cpp"
          var $cmp5=((($conv))|0) <= 9; //@line 237 "compiledict.cpp"
          var $15=$rb; //@line 239 "compiledict.cpp"
          var $conv6=((($15))&255); //@line 239 "compiledict.cpp"
          if ($cmp5) { __label__ = 5;; } else { __label__ = 12;; } //@line 237 "compiledict.cpp"
          $if_then$$if_end$10: do { 
            if (__label__ == 5) {
  
              if ($conv6 == 0) {
                __label__ = 6;;
              }
              else if ($conv6 == 3) {
                __label__ = 6;;
              }
              else if ($conv6 == 8) {
                __label__ = 7;;
              }
              else if ($conv6 == 1) {
                __label__ = 8;;
              }
              else if ($conv6 == 2) {
                __label__ = 9;;
              }
              else if ($conv6 == 9) {
                __label__ = 11;;
              }
              else if ($conv6 == 5) {
                __label__ = 10;;
              }
              else {
              __label__ = 37;break $if_then$$if_end$10;
              }
              
              if (__label__ == 6) {
  
                $finished=1; //@line 243 "compiledict.cpp"
                __label__ = 37;break $if_then$$if_end$10; //@line 244 "compiledict.cpp"
              }
              else if (__label__ == 7) {
  
                $at_start=1; //@line 246 "compiledict.cpp"
                ; //@line 246 "compiledict.cpp"
              }
              else if (__label__ == 9) {
  
                $match_type=2; //@line 253 "compiledict.cpp"
                var $17=$p; //@line 254 "compiledict.cpp"
                HEAP8[($17)]=0; //@line 254 "compiledict.cpp"
                var $strlen=_strlen($arraydecay11); //@line 255 "compiledict.cpp"
                var $endptr=(($arraydecay11+$strlen)&4294967295); //@line 255 "compiledict.cpp"
                var $src$, $dest$, $stop$, $stop4$, $fast$;
                $src$ = ((__str60)&4294967295);
                $dest$ = $endptr;
                $stop$ = $src$ + 3;
                if (($dest$%4) == ($src$%4) && 3 > 8) {
                  while ($src$%4 !== 0 && $src$ < $stop$) {
                    ; HEAP8[$dest$++] = HEAP8[$src$++];
                  }
                  $src$ >>= 2;
                  $dest$ >>= 2;
                  $stop4$ = $stop$ >> 2;
                  while ($src$ < $stop4$) {
                ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
                  }
                  $src$ <<= 2;
                  $dest$ <<= 2;
                }while ($src$ < $stop$) {
                  ; HEAP8[$dest$++] = HEAP8[$src$++];
                }; //@line 255 "compiledict.cpp"
                var $call14=_strlen($arraydecay13); //@line 256 "compiledict.cpp"
                var $arrayidx15=(($buf+$call14)&4294967295); //@line 256 "compiledict.cpp"
                $p=$arrayidx15; //@line 256 "compiledict.cpp"
                __label__ = 37;break $if_then$$if_end$10; //@line 257 "compiledict.cpp"
              }
              else if (__label__ == 11) {
  
                var $20=$rule_addr; //@line 265 "compiledict.cpp"
                var $arrayidx20=(($20+1)&4294967295); //@line 265 "compiledict.cpp"
                var $21=HEAP8[($arrayidx20)]; //@line 265 "compiledict.cpp"
                var $conv21=(tempInt=(($21)),(tempInt>=128?tempInt-256:tempInt)); //@line 265 "compiledict.cpp"
                var $and=($conv21) & 255; //@line 265 "compiledict.cpp"
                var $sub=((($and)-1)&4294967295); //@line 265 "compiledict.cpp"
                $value=$sub; //@line 265 "compiledict.cpp"
                var $22=$rule_addr; //@line 266 "compiledict.cpp"
                var $arrayidx22=(($22)&4294967295); //@line 266 "compiledict.cpp"
                var $23=HEAP8[($arrayidx22)]; //@line 266 "compiledict.cpp"
                var $conv23=(tempInt=(($23)),(tempInt>=128?tempInt-256:tempInt)); //@line 266 "compiledict.cpp"
                var $and24=($conv23) & 255; //@line 266 "compiledict.cpp"
                var $24=$value; //@line 266 "compiledict.cpp"
                var $mul=((($24)*255)&4294967295); //@line 266 "compiledict.cpp"
                var $sub25=((($mul)-1)&4294967295); //@line 266 "compiledict.cpp"
                var $add=((($sub25)+($and24))&4294967295); //@line 266 "compiledict.cpp"
                $linenum=$add; //@line 266 "compiledict.cpp"
                var $25=$rule_addr; //@line 267 "compiledict.cpp"
                var $add_ptr=(($25+2)&4294967295); //@line 267 "compiledict.cpp"
                $rule_addr=$add_ptr; //@line 267 "compiledict.cpp"
                __label__ = 37;break $if_then$$if_end$10; //@line 268 "compiledict.cpp"
              }
              else if (__label__ == 10) {
  
                var $18=$rule_addr; //@line 262 "compiledict.cpp"
                var $incdec_ptr17=(($18+1)&4294967295); //@line 262 "compiledict.cpp"
                $rule_addr=$incdec_ptr17; //@line 262 "compiledict.cpp"
                var $19=HEAP8[($18)]; //@line 262 "compiledict.cpp"
                var $conv18=(tempInt=(($19)),(tempInt>=128?tempInt-256:tempInt)); //@line 262 "compiledict.cpp"
                $condition_num=$conv18; //@line 262 "compiledict.cpp"
                __label__ = 37;break $if_then$$if_end$10; //@line 263 "compiledict.cpp"
              }
  
              $match_type=1; //@line 248 "compiledict.cpp"
              var $16=$p; //@line 249 "compiledict.cpp"
              HEAP8[($16)]=0; //@line 249 "compiledict.cpp"
              $p=$arraydecay9; //@line 250 "compiledict.cpp"
              ; //@line 251 "compiledict.cpp"
            }
            else if (__label__ == 12) {
  
              var $cmp27=((($conv6))|0)==28; //@line 273 "compiledict.cpp"
              if ($cmp27) { __label__ = 13;; } else { __label__ = 17;; } //@line 273 "compiledict.cpp"
              if (__label__ == 13) {
  
                var $26=$rule_addr; //@line 275 "compiledict.cpp"
                var $incdec_ptr29=(($26+1)&4294967295); //@line 275 "compiledict.cpp"
                $rule_addr=$incdec_ptr29; //@line 275 "compiledict.cpp"
                var $27=HEAP8[($26)]; //@line 275 "compiledict.cpp"
                var $conv30=(tempInt=(($27)),(tempInt>=128?tempInt-256:tempInt)); //@line 275 "compiledict.cpp"
                var $and31=($conv30) & 255; //@line 275 "compiledict.cpp"
                $value=$and31; //@line 275 "compiledict.cpp"
                var $28=$value; //@line 276 "compiledict.cpp"
                var $cmp32=((($28))|0)!=1; //@line 276 "compiledict.cpp"
                if ($cmp32) { __label__ = 15;; } else { __label__ = 14;; } //@line 276 "compiledict.cpp"
                $if_then35$$lor_lhs_false$22: do { 
                  if (__label__ == 14) {
  
                    var $29=$control_addr; //@line 276 "compiledict.cpp"
                    var $and33=($29) & -2147483648; //@line 276 "compiledict.cpp"
                    var $tobool34=((($and33))|0)!=0; //@line 276 "compiledict.cpp"
                    if ($tobool34) { __label__ = 15;break $if_then35$$lor_lhs_false$22; } else { __label__ = 16;break $if_then35$$lor_lhs_false$22; } //@line 276 "compiledict.cpp"
                  }
                } while(0);
                if (__label__ == 15) {
  
                  var $30=$p; //@line 278 "compiledict.cpp"
                  var $arrayidx36=(($30)&4294967295); //@line 278 "compiledict.cpp"
                  HEAP8[($arrayidx36)]=36; //@line 278 "compiledict.cpp"
                  var $31=$value; //@line 279 "compiledict.cpp"
                  var $call37=__Z14LookupMnemNameP8MNEM_TABi(((_mnem_rules)&4294967295), $31); //@line 279 "compiledict.cpp"
                  $name=$call37; //@line 279 "compiledict.cpp"
                  var $32=$p; //@line 280 "compiledict.cpp"
                  var $arrayidx38=(($32+1)&4294967295); //@line 280 "compiledict.cpp"
                  var $33=$name; //@line 280 "compiledict.cpp"
                  var $call39=_strcpy($arrayidx38, $33); //@line 280 "compiledict.cpp"
                  var $34=$name; //@line 281 "compiledict.cpp"
                  var $call40=_strlen($34); //@line 281 "compiledict.cpp"
                  var $add41=((($call40)+1)&4294967295); //@line 281 "compiledict.cpp"
                  var $35=$p; //@line 281 "compiledict.cpp"
                  var $add_ptr42=(($35+$add41)&4294967295); //@line 281 "compiledict.cpp"
                  $p=$add_ptr42; //@line 281 "compiledict.cpp"
                  ; //@line 282 "compiledict.cpp"
                }
  
                $c=32; //@line 283 "compiledict.cpp"
                ; //@line 284 "compiledict.cpp"
              }
              else if (__label__ == 17) {
  
                var $36=$rb; //@line 286 "compiledict.cpp"
                var $conv44=((($36))&255); //@line 286 "compiledict.cpp"
                var $cmp45=((($conv44))|0)==14; //@line 286 "compiledict.cpp"
                if ($cmp45) { __label__ = 18;; } else { __label__ = 25;; } //@line 286 "compiledict.cpp"
                if (__label__ == 18) {
  
                  var $37=$rule_addr; //@line 289 "compiledict.cpp"
                  var $arrayidx47=(($37)&4294967295); //@line 289 "compiledict.cpp"
                  var $38=HEAP8[($arrayidx47)]; //@line 289 "compiledict.cpp"
                  var $conv48=(tempInt=(($38)),(tempInt>=128?tempInt-256:tempInt)); //@line 289 "compiledict.cpp"
                  var $and49=($conv48) & 127; //@line 289 "compiledict.cpp"
                  var $shl=((($and49)*256)&4294967295); //@line 289 "compiledict.cpp"
                  var $39=$rule_addr; //@line 289 "compiledict.cpp"
                  var $arrayidx50=(($39+1)&4294967295); //@line 289 "compiledict.cpp"
                  var $40=HEAP8[($arrayidx50)]; //@line 289 "compiledict.cpp"
                  var $conv51=(tempInt=(($40)),(tempInt>=128?tempInt-256:tempInt)); //@line 289 "compiledict.cpp"
                  var $and52=($conv51) & 127; //@line 289 "compiledict.cpp"
                  var $add53=((($and52)+($shl))&4294967295); //@line 289 "compiledict.cpp"
                  $flags=$add53; //@line 289 "compiledict.cpp"
                  $suffix_char=83; //@line 290 "compiledict.cpp"
                  var $41=$flags; //@line 291 "compiledict.cpp"
                  var $and54=($41) & 4; //@line 291 "compiledict.cpp"
                  var $tobool55=((($and54))|0)!=0; //@line 291 "compiledict.cpp"
                  if ($tobool55) { __label__ = 19;; } else { __label__ = 20;; } //@line 291 "compiledict.cpp"
                  if (__label__ == 19) {
  
                    $suffix_char=80; //@line 292 "compiledict.cpp"
                    ; //@line 292 "compiledict.cpp"
                  }
  
                  var $42=$suffix_char; //@line 293 "compiledict.cpp"
                  var $43=$rule_addr; //@line 293 "compiledict.cpp"
                  var $arrayidx59=(($43+2)&4294967295); //@line 293 "compiledict.cpp"
                  var $44=HEAP8[($arrayidx59)]; //@line 293 "compiledict.cpp"
                  var $conv60=(tempInt=(($44)),(tempInt>=128?tempInt-256:tempInt)); //@line 293 "compiledict.cpp"
                  var $and61=($conv60) & 127; //@line 293 "compiledict.cpp"
                  var $call62=_sprintf($arraydecay58, ((__str62)&4294967295), allocate([$42,0,0,0,$and61,0,0,0], ["i32",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 293 "compiledict.cpp"
                  var $45=$rule_addr; //@line 294 "compiledict.cpp"
                  var $add_ptr63=(($45+3)&4294967295); //@line 294 "compiledict.cpp"
                  $rule_addr=$add_ptr63; //@line 294 "compiledict.cpp"
                  $ix=0; //@line 295 "compiledict.cpp"
                  ; //@line 295 "compiledict.cpp"
                  while(1) { 
  
                    var $46=$flags; //@line 297 "compiledict.cpp"
                    var $and67=($46) & 1; //@line 297 "compiledict.cpp"
                    var $tobool68=((($and67))|0)!=0; //@line 297 "compiledict.cpp"
                    if ($tobool68) { __label__ = 22;; } else { __label__ = 23;; } //@line 297 "compiledict.cpp"
                    if (__label__ == 22) {
  
                      var $call71=_strlen($arraydecay70); //@line 298 "compiledict.cpp"
                      var $arrayidx72=(($suffix+$call71)&4294967295); //@line 298 "compiledict.cpp"
                      var $47=$ix; //@line 298 "compiledict.cpp"
                      var $arrayidx73=((((__str61)&4294967295)+$47)&4294967295); //@line 298 "compiledict.cpp"
                      var $48=HEAP8[($arrayidx73)]; //@line 298 "compiledict.cpp"
                      var $conv74=(tempInt=(($48)),(tempInt>=128?tempInt-256:tempInt)); //@line 298 "compiledict.cpp"
                      var $char=((($conv74)) & 255); //@line 298 "compiledict.cpp"
                      HEAP8[($arrayidx72)]=$char; //@line 298 "compiledict.cpp"
                      var $nul=(($arrayidx72+1)&4294967295); //@line 298 "compiledict.cpp"
                      HEAP8[($nul)]=0; //@line 298 "compiledict.cpp"
                      ; //@line 298 "compiledict.cpp"
                    }
  
                    var $49=$flags; //@line 299 "compiledict.cpp"
                    var $shr=($49) >> 1; //@line 299 "compiledict.cpp"
                    $flags=$shr; //@line 299 "compiledict.cpp"
                    var $50=$ix; //@line 295 "compiledict.cpp"
                    var $inc78=((($50)+1)&4294967295); //@line 295 "compiledict.cpp"
                    $ix=$inc78; //@line 295 "compiledict.cpp"
                    var $cmp65=((($inc78))|0) < 9; //@line 295 "compiledict.cpp"
                    if ($cmp65) { __label__ = 21;continue ; } else { __label__ = 24;break ; } //@line 295 "compiledict.cpp"
                  }
  
                  var $51=$p; //@line 301 "compiledict.cpp"
                  var $call81=_strcpy($51, $arraydecay80); //@line 301 "compiledict.cpp"
                  var $call83=_strlen($arraydecay82); //@line 302 "compiledict.cpp"
                  var $52=$p; //@line 302 "compiledict.cpp"
                  var $add_ptr84=(($52+$call83)&4294967295); //@line 302 "compiledict.cpp"
                  $p=$add_ptr84; //@line 302 "compiledict.cpp"
                  $c=32; //@line 303 "compiledict.cpp"
                  ; //@line 304 "compiledict.cpp"
                }
                else if (__label__ == 25) {
  
                  var $53=$rb; //@line 306 "compiledict.cpp"
                  var $conv86=((($53))&255); //@line 306 "compiledict.cpp"
                  var $cmp87=((($conv86))|0)==17; //@line 306 "compiledict.cpp"
                  if ($cmp87) { __label__ = 26;; } else { __label__ = 27;; } //@line 306 "compiledict.cpp"
                  if (__label__ == 26) {
  
                    var $54=$rule_addr; //@line 308 "compiledict.cpp"
                    var $incdec_ptr89=(($54+1)&4294967295); //@line 308 "compiledict.cpp"
                    $rule_addr=$incdec_ptr89; //@line 308 "compiledict.cpp"
                    var $55=HEAP8[($54)]; //@line 308 "compiledict.cpp"
                    var $conv90=(tempInt=(($55)),(tempInt>=128?tempInt-256:tempInt)); //@line 308 "compiledict.cpp"
                    var $sub91=((($conv90)-65)&4294967295); //@line 308 "compiledict.cpp"
                    var $arrayidx92=((__ZZ10DecodeRulePKciPciE10symbols_lg+$sub91)&4294967295); //@line 308 "compiledict.cpp"
                    var $56=HEAP8[($arrayidx92)]; //@line 308 "compiledict.cpp"
                    $c=$56; //@line 308 "compiledict.cpp"
                    ; //@line 309 "compiledict.cpp"
                  }
                  else if (__label__ == 27) {
  
                    var $57=$rb; //@line 311 "compiledict.cpp"
                    var $conv94=((($57))&255); //@line 311 "compiledict.cpp"
                    var $cmp95=((($conv94))|0)==18; //@line 311 "compiledict.cpp"
                    if ($cmp95) { __label__ = 28;; } else { __label__ = 31;; } //@line 311 "compiledict.cpp"
                    if (__label__ == 28) {
  
                      var $58=$rule_addr; //@line 313 "compiledict.cpp"
                      var $incdec_ptr97=(($58+1)&4294967295); //@line 313 "compiledict.cpp"
                      $rule_addr=$incdec_ptr97; //@line 313 "compiledict.cpp"
                      var $59=HEAP8[($58)]; //@line 313 "compiledict.cpp"
                      var $conv98=(tempInt=(($59)),(tempInt>=128?tempInt-256:tempInt)); //@line 313 "compiledict.cpp"
                      var $sub99=((($conv98)-65)&4294967295); //@line 313 "compiledict.cpp"
                      $value=$sub99; //@line 313 "compiledict.cpp"
                      var $60=$p; //@line 314 "compiledict.cpp"
                      var $arrayidx100=(($60)&4294967295); //@line 314 "compiledict.cpp"
                      HEAP8[($arrayidx100)]=76; //@line 314 "compiledict.cpp"
                      var $61=$value; //@line 315 "compiledict.cpp"
                      var $div=((((($61))|0)/10)|0); //@line 315 "compiledict.cpp"
                      var $add101=((($div)+48)&4294967295); //@line 315 "compiledict.cpp"
                      var $conv102=((($add101)) & 255); //@line 315 "compiledict.cpp"
                      var $62=$p; //@line 315 "compiledict.cpp"
                      var $arrayidx103=(($62+1)&4294967295); //@line 315 "compiledict.cpp"
                      HEAP8[($arrayidx103)]=$conv102; //@line 315 "compiledict.cpp"
                      var $63=$value; //@line 316 "compiledict.cpp"
                      var $rem=((($63))|0)%10; //@line 316 "compiledict.cpp"
                      var $add104=((($rem)+48)&4294967295); //@line 316 "compiledict.cpp"
                      var $conv105=((($add104)) & 255); //@line 316 "compiledict.cpp"
                      $c=$conv105; //@line 316 "compiledict.cpp"
                      var $64=$match_type; //@line 318 "compiledict.cpp"
                      var $cmp106=((($64))|0)==1; //@line 318 "compiledict.cpp"
                      if ($cmp106) { __label__ = 29;; } else { __label__ = 30;; } //@line 318 "compiledict.cpp"
                      if (__label__ == 29) {
  
                        var $65=$c; //@line 320 "compiledict.cpp"
                        var $66=$p; //@line 320 "compiledict.cpp"
                        var $arrayidx108=(($66)&4294967295); //@line 320 "compiledict.cpp"
                        HEAP8[($arrayidx108)]=$65; //@line 320 "compiledict.cpp"
                        $c=76; //@line 321 "compiledict.cpp"
                        ; //@line 322 "compiledict.cpp"
                      }
  
                      var $67=$p; //@line 323 "compiledict.cpp"
                      var $add_ptr110=(($67+2)&4294967295); //@line 323 "compiledict.cpp"
                      $p=$add_ptr110; //@line 323 "compiledict.cpp"
                      ; //@line 324 "compiledict.cpp"
                    }
                    else if (__label__ == 31) {
  
                      var $68=$rb; //@line 326 "compiledict.cpp"
                      var $conv112=((($68))&255); //@line 326 "compiledict.cpp"
                      var $cmp113=((($conv112))|0) <= 31; //@line 326 "compiledict.cpp"
                      var $69=$rb; //@line 327 "compiledict.cpp"
                      var $idxprom=((($69))&255); //@line 327 "compiledict.cpp"
                      if ($cmp113) { __label__ = 32;; } else { __label__ = 33;; } //@line 326 "compiledict.cpp"
                      if (__label__ == 32) {
  
                        var $arrayidx115=((__ZZ10DecodeRulePKciPciE7symbols+$idxprom)&4294967295); //@line 327 "compiledict.cpp"
                        var $70=HEAP8[($arrayidx115)]; //@line 327 "compiledict.cpp"
                        $c=$70; //@line 327 "compiledict.cpp"
                        ; //@line 327 "compiledict.cpp"
                      }
                      else if (__label__ == 33) {
  
                        var $cmp118=((($idxprom))|0)==32; //@line 329 "compiledict.cpp"
                        if ($cmp118) { __label__ = 34;; } else { __label__ = 35;; } //@line 329 "compiledict.cpp"
                        if (__label__ == 34) {
  
                          $c=95; //@line 330 "compiledict.cpp"
                          ; //@line 330 "compiledict.cpp"
                        }
                        else if (__label__ == 35) {
  
                          var $71=$rb; //@line 332 "compiledict.cpp"
                          $c=$71; //@line 332 "compiledict.cpp"
                          ;
                        }
                      }
                    }
                  }
                }
              }
  
              var $72=$c; //@line 333 "compiledict.cpp"
              var $73=$p; //@line 333 "compiledict.cpp"
              var $incdec_ptr127=(($73+1)&4294967295); //@line 333 "compiledict.cpp"
              $p=$incdec_ptr127; //@line 333 "compiledict.cpp"
              HEAP8[($73)]=$72; //@line 333 "compiledict.cpp"
              ; //@line 334 "compiledict.cpp"
            }
          } while(0);
  
          var $74=$finished; //@line 233 "compiledict.cpp"
          var $tobool=((($74))|0)!=0; //@line 233 "compiledict.cpp"
          var $lnot=($tobool) ^ 1; //@line 233 "compiledict.cpp"
          if ($lnot) { __label__ = 4;continue $while_body$8; } else { __label__ = 38;break $while_body_lr_ph$$while_end$6; } //@line 233 "compiledict.cpp"
        }
      }
    } while(0);
  
    var $75=$p; //@line 335 "compiledict.cpp"
    HEAP8[($75)]=0; //@line 335 "compiledict.cpp"
    $p=((__ZZ10DecodeRulePKciPciE6output)&4294967295); //@line 337 "compiledict.cpp"
    var $76=$linenum; //@line 338 "compiledict.cpp"
    var $cmp128=((($76))|0) > 0; //@line 338 "compiledict.cpp"
    if ($cmp128) { __label__ = 39;; } else { __label__ = 40;; } //@line 338 "compiledict.cpp"
    if (__label__ == 39) {
  
      var $77=$p; //@line 340 "compiledict.cpp"
      var $78=$linenum; //@line 340 "compiledict.cpp"
      var $call130=_sprintf($77, ((__str64)&4294967295), allocate([$78,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 340 "compiledict.cpp"
      var $79=$p; //@line 341 "compiledict.cpp"
      var $add_ptr131=(($79+7)&4294967295); //@line 341 "compiledict.cpp"
      $p=$add_ptr131; //@line 341 "compiledict.cpp"
      ; //@line 342 "compiledict.cpp"
    }
  
    var $80=$condition_num; //@line 343 "compiledict.cpp"
    var $cmp133=((($80))|0) > 0; //@line 343 "compiledict.cpp"
    if ($cmp133) { __label__ = 41;; } else { __label__ = 42;; } //@line 343 "compiledict.cpp"
    if (__label__ == 41) {
  
      var $81=$p; //@line 345 "compiledict.cpp"
      var $82=$condition_num; //@line 345 "compiledict.cpp"
      var $call135=_sprintf($81, ((__str65)&4294967295), allocate([$82,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 345 "compiledict.cpp"
      var $83=$p; //@line 346 "compiledict.cpp"
      var $call136=_strlen($83); //@line 346 "compiledict.cpp"
      var $84=$p; //@line 346 "compiledict.cpp"
      var $arrayidx137=(($84+$call136)&4294967295); //@line 346 "compiledict.cpp"
      $p=$arrayidx137; //@line 346 "compiledict.cpp"
      ; //@line 347 "compiledict.cpp"
    }
  
    var $arraydecay139=(($buf_pre)&4294967295); //@line 348 "compiledict.cpp"
    var $call140=_strlen($arraydecay139); //@line 348 "compiledict.cpp"
    $ix=$call140; //@line 348 "compiledict.cpp"
    var $cmp141=((($call140))|0) > 0; //@line 348 "compiledict.cpp"
    var $_pr=$at_start; //@line 350 "compiledict.cpp"
    var $tobool145=((($_pr))|0)!=0; //@line 350 "compiledict.cpp"
    if ($cmp141) { __label__ = 44;; } else { __label__ = 43;; } //@line 348 "compiledict.cpp"
    $if_then144$$lor_lhs_false142$64: do { 
      if (__label__ == 44) {
  
        if ($tobool145) { __label__ = 45;break $if_then144$$lor_lhs_false142$64; } else { __label__ = 46;break $if_then144$$lor_lhs_false142$64; } //@line 350 "compiledict.cpp"
      }
      else if (__label__ == 43) {
  
        if ($tobool145) { __label__ = 45;break $if_then144$$lor_lhs_false142$64; } else { __label__ = 49;break $if_then144$$lor_lhs_false142$64; } //@line 348 "compiledict.cpp"
      }
    } while(0);
    $if_then146$$while_cond149_preheader$$if_end157$67: do { 
      if (__label__ == 45) {
  
        var $85=$p; //@line 351 "compiledict.cpp"
        var $incdec_ptr147=(($85+1)&4294967295); //@line 351 "compiledict.cpp"
        $p=$incdec_ptr147; //@line 351 "compiledict.cpp"
        HEAP8[($85)]=95; //@line 351 "compiledict.cpp"
        __label__ = 46;break $if_then146$$while_cond149_preheader$$if_end157$67; //@line 351 "compiledict.cpp"
      }
    } while(0);
    if (__label__ == 46) {
  
      var $86=$ix; //@line 352 "compiledict.cpp"
      var $dec4=((($86)-1)&4294967295); //@line 352 "compiledict.cpp"
      $ix=$dec4; //@line 352 "compiledict.cpp"
      var $cmp1505=((($dec4))|0) >= 0; //@line 352 "compiledict.cpp"
      if ($cmp1505) { __label__ = 47;; } else { __label__ = 48;; } //@line 352 "compiledict.cpp"
      $while_body151$$while_end154$71: do { 
        if (__label__ == 47) {
          while(1) { 
  
            var $87=$ix; //@line 353 "compiledict.cpp"
            var $arrayidx152=(($buf_pre+$87)&4294967295); //@line 353 "compiledict.cpp"
            var $88=HEAP8[($arrayidx152)]; //@line 353 "compiledict.cpp"
            var $89=$p; //@line 353 "compiledict.cpp"
            var $incdec_ptr153=(($89+1)&4294967295); //@line 353 "compiledict.cpp"
            $p=$incdec_ptr153; //@line 353 "compiledict.cpp"
            HEAP8[($89)]=$88; //@line 353 "compiledict.cpp"
            var $90=$ix; //@line 352 "compiledict.cpp"
            var $dec=((($90)-1)&4294967295); //@line 352 "compiledict.cpp"
            $ix=$dec; //@line 352 "compiledict.cpp"
            var $cmp150=((($dec))|0) >= 0; //@line 352 "compiledict.cpp"
            if ($cmp150) { __label__ = 47;continue ; } else { __label__ = 48;break $while_body151$$while_end154$71; } //@line 352 "compiledict.cpp"
          }
        }
      } while(0);
  
      var $91=$p; //@line 354 "compiledict.cpp"
      var $incdec_ptr155=(($91+1)&4294967295); //@line 354 "compiledict.cpp"
      $p=$incdec_ptr155; //@line 354 "compiledict.cpp"
      HEAP8[($91)]=41; //@line 354 "compiledict.cpp"
      var $92=$p; //@line 355 "compiledict.cpp"
      var $incdec_ptr156=(($92+1)&4294967295); //@line 355 "compiledict.cpp"
      $p=$incdec_ptr156; //@line 355 "compiledict.cpp"
      HEAP8[($92)]=32; //@line 355 "compiledict.cpp"
      ; //@line 356 "compiledict.cpp"
    }
  
    var $93=$p; //@line 357 "compiledict.cpp"
    HEAP8[($93)]=0; //@line 357 "compiledict.cpp"
    var $94=$p; //@line 358 "compiledict.cpp"
    var $arraydecay158=(($buf)&4294967295); //@line 358 "compiledict.cpp"
    var $call159=_strcat($94, $arraydecay158); //@line 358 "compiledict.cpp"
    var $call160=_strlen(((__ZZ10DecodeRulePKciPciE6output)&4294967295)); //@line 359 "compiledict.cpp"
    $ix=$call160; //@line 359 "compiledict.cpp"
    var $cmp1623=((($call160))|0) < 8; //@line 360 "compiledict.cpp"
    var $95=$ix; //@line 361 "compiledict.cpp"
    if ($cmp1623) { __lastLabel__ = 49; __label__ = 50;; } else { __lastLabel__ = 49; __label__ = 51;; } //@line 360 "compiledict.cpp"
    $while_body163$$while_end166$76: do { 
      if (__label__ == 50) {
        while(1) { 
  
          var $96=__lastLabel__ == 50 ? $97 : ($95);
          var $inc164=((($96)+1)&4294967295); //@line 361 "compiledict.cpp"
          $ix=$inc164; //@line 361 "compiledict.cpp"
          var $arrayidx165=((__ZZ10DecodeRulePKciPciE6output+$96)&4294967295); //@line 361 "compiledict.cpp"
          HEAP8[($arrayidx165)]=32; //@line 361 "compiledict.cpp"
          var $_pr2=$ix; //@line 360 "compiledict.cpp"
          var $cmp162=((($_pr2))|0) < 8; //@line 360 "compiledict.cpp"
          var $97=$ix; //@line 361 "compiledict.cpp"
          if ($cmp162) { __lastLabel__ = 50; __label__ = 50;continue ; } else { __lastLabel__ = 50; __label__ = 51;break $while_body163$$while_end166$76; } //@line 360 "compiledict.cpp"
        }
      }
    } while(0);
  
    var $_lcssa=__lastLabel__ == 49 ? $95 : ($97);
    var $arrayidx167=((__ZZ10DecodeRulePKciPciE6output+$_lcssa)&4294967295); //@line 362 "compiledict.cpp"
    HEAP8[($arrayidx167)]=0; //@line 362 "compiledict.cpp"
    STACKTOP = __stackBase__;
    return ((__ZZ10DecodeRulePKciPciE6output)&4294967295); //@line 363 "compiledict.cpp"
    return null;
  }
  

  function __Z13string_sorterPPcS0_($a, $b) {
    ;
    var __label__;
  
    var $retval;
    var $a_addr;
    var $b_addr;
    var $pa;
    var $pb;
    var $ix;
    $a_addr=$a;
    $b_addr=$b;
    var $0=$a_addr; //@line 1341 "compiledict.cpp"
    var $1=HEAP32[(($0)>>2)]; //@line 1341 "compiledict.cpp"
    $pa=$1; //@line 1341 "compiledict.cpp"
    var $2=$b_addr; //@line 1341 "compiledict.cpp"
    var $3=HEAP32[(($2)>>2)]; //@line 1341 "compiledict.cpp"
    $pb=$3; //@line 1341 "compiledict.cpp"
    var $call=_strcmp($1, $3); //@line 1341 "compiledict.cpp"
    $ix=$call; //@line 1341 "compiledict.cpp"
    var $cmp=((($call))|0)!=0; //@line 1341 "compiledict.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 1341 "compiledict.cpp"
    if (__label__ == 1) {
  
      var $4=$ix; //@line 1342 "compiledict.cpp"
      $retval=$4; //@line 1342 "compiledict.cpp"
      ; //@line 1342 "compiledict.cpp"
    }
    else if (__label__ == 2) {
  
      var $5=$pa; //@line 1343 "compiledict.cpp"
      var $call1=_strlen($5); //@line 1343 "compiledict.cpp"
      var $add=((($call1)+1)&4294967295); //@line 1343 "compiledict.cpp"
      var $6=$pa; //@line 1343 "compiledict.cpp"
      var $add_ptr=(($6+$add)&4294967295); //@line 1343 "compiledict.cpp"
      $pa=$add_ptr; //@line 1343 "compiledict.cpp"
      var $7=$pb; //@line 1344 "compiledict.cpp"
      var $call2=_strlen($7); //@line 1344 "compiledict.cpp"
      var $add3=((($call2)+1)&4294967295); //@line 1344 "compiledict.cpp"
      var $8=$pb; //@line 1344 "compiledict.cpp"
      var $add_ptr4=(($8+$add3)&4294967295); //@line 1344 "compiledict.cpp"
      $pb=$add_ptr4; //@line 1344 "compiledict.cpp"
      var $9=$pa; //@line 1345 "compiledict.cpp"
      var $10=$pb; //@line 1345 "compiledict.cpp"
      var $call5=_strcmp($9, $10); //@line 1345 "compiledict.cpp"
      $retval=$call5; //@line 1345 "compiledict.cpp"
      ; //@line 1345 "compiledict.cpp"
    }
  
    var $11=$retval; //@line 1346 "compiledict.cpp"
    ;
    return $11; //@line 1346 "compiledict.cpp"
    return null;
  }
  

  function __Z17CompileDictionaryPKcS0_P7__sFILEPci($dsource, $dict_name, $log, $fname_err, $flags) {
    var __stackBase__  = STACKTOP; STACKTOP += 724; _memset(__stackBase__, 0, 724);
    var __label__;
  
    var $retval;
    var $dsource_addr;
    var $dict_name_addr;
    var $log_addr;
    var $fname_err_addr;
    var $flags_addr;
    var $f_in;
    var $f_out;
    var $offset_rules;
    var $value;
    var $fname_in=__stackBase__;
    var $fname_out=__stackBase__+196;
    var $fname_temp=__stackBase__+364;
    var $path=__stackBase__+532;
    $dsource_addr=$dsource;
    $dict_name_addr=$dict_name;
    $log_addr=$log;
    $fname_err_addr=$fname_err;
    $flags_addr=$flags;
    $offset_rules=0; //@line 1856 "compiledict.cpp"
    HEAP32[((__ZL11error_count)>>2)]=0; //@line 1863 "compiledict.cpp"
    HEAP32[((__ZL21error_need_dictionary)>>2)]=0; //@line 1864 "compiledict.cpp"
    var $dest$, $stop$, $stop4$, $fast$, $value4$;
    $dest$ = ((__ZL19letterGroupsDefined)&4294967295);
    $stop$ = $dest$ + 26;
    $value4$ = 0;
    if ($value4$ < 0) $value4$ += 256;
    $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
    while ($dest$%4 !== 0 && $dest$ < $stop$) {
      ;; HEAP8[$dest$++] = 0;
    }
    $dest$ >>= 2;
    $stop4$ = $stop$ >> 2;
    while ($dest$ < $stop4$) {
    ;;;;;;;  HEAP32[$dest$++] = $value4$;
    }
    $dest$ <<= 2;
    while ($dest$ < $stop$) {
      ;; HEAP8[$dest$++] = 0;
    }; //@line 1865 "compiledict.cpp"
    var $0=$flags_addr; //@line 1867 "compiledict.cpp"
    var $and=($0) & 1; //@line 1867 "compiledict.cpp"
    HEAP32[((__ZL10debug_flag)>>2)]=$and; //@line 1867 "compiledict.cpp"
    var $1=$dsource_addr; //@line 1869 "compiledict.cpp"
    var $cmp=((($1))|0)==0; //@line 1869 "compiledict.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 1869 "compiledict.cpp"
    if (__label__ == 1) {
  
      $dsource_addr=((__str13643)&4294967295); //@line 1870 "compiledict.cpp"
      ; //@line 1870 "compiledict.cpp"
    }
  
    var $2=$log_addr; //@line 1872 "compiledict.cpp"
    HEAP32[((__ZL5f_log)>>2)]=$2; //@line 1872 "compiledict.cpp"
    var $cmp1=((($2))|0)==0; //@line 1874 "compiledict.cpp"
    if ($cmp1) { __label__ = 3;; } else { __label__ = 4;; } //@line 1874 "compiledict.cpp"
    if (__label__ == 3) {
  
      var $3=HEAP32[((__impure_ptr)>>2)]; //@line 1875 "compiledict.cpp"
      var $_stderr=(($3+12)&4294967295); //@line 1875 "compiledict.cpp"
      var $4=HEAP32[(($_stderr)>>2)]; //@line 1875 "compiledict.cpp"
      HEAP32[((__ZL5f_log)>>2)]=$4; //@line 1875 "compiledict.cpp"
      ; //@line 1875 "compiledict.cpp"
    }
  
    var $arraydecay=(($path)&4294967295); //@line 1878 "compiledict.cpp"
    var $5=$dsource_addr; //@line 1878 "compiledict.cpp"
    var $6=$dict_name_addr; //@line 1878 "compiledict.cpp"
    var $call=_sprintf($arraydecay, ((__str66)&4294967295), allocate([$5,0,0,0,$6,0,0,0], ["i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 1878 "compiledict.cpp"
    var $arraydecay4=(($fname_in)&4294967295); //@line 1879 "compiledict.cpp"
    var $arraydecay5=(($path)&4294967295); //@line 1879 "compiledict.cpp"
    var $call6=_sprintf($arraydecay4, ((__str67)&4294967295), allocate([$arraydecay5,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 1879 "compiledict.cpp"
    var $arraydecay7=(($fname_in)&4294967295); //@line 1880 "compiledict.cpp"
    var $call8=_fopen($arraydecay7, ((__str51703)&4294967295)); //@line 1880 "compiledict.cpp"
    $f_in=$call8; //@line 1880 "compiledict.cpp"
    var $cmp9=((($call8))|0)==0; //@line 1880 "compiledict.cpp"
    if ($cmp9) { __label__ = 5;; } else { __label__ = 9;; } //@line 1880 "compiledict.cpp"
    $if_then10$$if_end23$8: do { 
      if (__label__ == 5) {
  
        var $arraydecay11=(($fname_in)&4294967295); //@line 1882 "compiledict.cpp"
        var $arraydecay12=(($path)&4294967295); //@line 1882 "compiledict.cpp"
        var $call13=_sprintf($arraydecay11, ((__str69)&4294967295), allocate([$arraydecay12,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 1882 "compiledict.cpp"
        var $arraydecay14=(($fname_in)&4294967295); //@line 1883 "compiledict.cpp"
        var $call15=__ZL9fopen_logPKcS0_($arraydecay14, ((__str51703)&4294967295)); //@line 1883 "compiledict.cpp"
        $f_in=$call15; //@line 1883 "compiledict.cpp"
        var $cmp16=((($call15))|0)==0; //@line 1883 "compiledict.cpp"
        if (!($cmp16)) { __label__ = 9;break $if_then10$$if_end23$8; } //@line 1883 "compiledict.cpp"
  
        var $7=$fname_err_addr; //@line 1885 "compiledict.cpp"
        var $tobool=((($7))|0)!=0; //@line 1885 "compiledict.cpp"
        if ($tobool) { __label__ = 7;; } else { __label__ = 8;; } //@line 1885 "compiledict.cpp"
        if (__label__ == 7) {
  
          var $8=$fname_err_addr; //@line 1886 "compiledict.cpp"
          var $arraydecay19=(($fname_in)&4294967295); //@line 1886 "compiledict.cpp"
          var $call20=_strcpy($8, $arraydecay19); //@line 1886 "compiledict.cpp"
          ; //@line 1886 "compiledict.cpp"
        }
  
        $retval=-1; //@line 1887 "compiledict.cpp"
        __label__ = 17;break $if_then10$$if_end23$8; //@line 1887 "compiledict.cpp"
      }
    } while(0);
    if (__label__ == 9) {
  
      var $arraydecay24=(($fname_out)&4294967295); //@line 1891 "compiledict.cpp"
      var $9=$dict_name_addr; //@line 1891 "compiledict.cpp"
      var $call25=_sprintf($arraydecay24, ((__str116)&4294967295), allocate([((_path_home)&4294967295),0,0,0,47,0,0,0,$9,0,0,0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 1891 "compiledict.cpp"
      var $arraydecay26=(($fname_out)&4294967295); //@line 1892 "compiledict.cpp"
      var $call27=__ZL9fopen_logPKcS0_($arraydecay26, ((__str71)&4294967295)); //@line 1892 "compiledict.cpp"
      $f_out=$call27; //@line 1892 "compiledict.cpp"
      var $cmp28=((($call27))|0)==0; //@line 1892 "compiledict.cpp"
      if ($cmp28) { __label__ = 10;; } else { __label__ = 13;; } //@line 1892 "compiledict.cpp"
      if (__label__ == 10) {
  
        var $10=$fname_err_addr; //@line 1894 "compiledict.cpp"
        var $tobool30=((($10))|0)!=0; //@line 1894 "compiledict.cpp"
        if ($tobool30) { __label__ = 11;; } else { __label__ = 12;; } //@line 1894 "compiledict.cpp"
        if (__label__ == 11) {
  
          var $11=$fname_err_addr; //@line 1895 "compiledict.cpp"
          var $arraydecay32=(($fname_in)&4294967295); //@line 1895 "compiledict.cpp"
          var $call33=_strcpy($11, $arraydecay32); //@line 1895 "compiledict.cpp"
          ; //@line 1895 "compiledict.cpp"
        }
  
        $retval=-1; //@line 1896 "compiledict.cpp"
        ; //@line 1896 "compiledict.cpp"
      }
      else if (__label__ == 13) {
  
        var $arraydecay36=(($fname_temp)&4294967295); //@line 1898 "compiledict.cpp"
        var $call37=_sprintf($arraydecay36, ((__str72)&4294967295), allocate([((_path_home)&4294967295),0,0,0,47,0,0,0], ["i8*",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 1898 "compiledict.cpp"
        $value=1024; //@line 1900 "compiledict.cpp"
        var $12=$f_out; //@line 1901 "compiledict.cpp"
        var $13=$value; //@line 1901 "compiledict.cpp"
        __Z11Write4BytesP7__sFILEi($12, $13); //@line 1901 "compiledict.cpp"
        var $14=$f_out; //@line 1902 "compiledict.cpp"
        var $15=$offset_rules; //@line 1902 "compiledict.cpp"
        __Z11Write4BytesP7__sFILEi($14, $15); //@line 1902 "compiledict.cpp"
        __ZL22compile_dictlist_startv(); //@line 1904 "compiledict.cpp"
        var $16=HEAP32[((__ZL5f_log)>>2)]; //@line 1906 "compiledict.cpp"
        var $17=HEAP32[((_phoneme_tab_number)>>2)]; //@line 1906 "compiledict.cpp"
        var $arrayidx=((_phoneme_tab_list+$17*48)&4294967295); //@line 1906 "compiledict.cpp"
        var $name=(($arrayidx)&4294967295); //@line 1906 "compiledict.cpp"
        var $arraydecay38=(($name)&4294967295); //@line 1906 "compiledict.cpp"
        var $call39=_fprintf($16, ((__str73)&4294967295), allocate([$arraydecay38,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 1906 "compiledict.cpp"
        var $arraydecay40=(($path)&4294967295); //@line 1907 "compiledict.cpp"
        __ZL21compile_dictlist_filePKcS0_($arraydecay40, ((__str74)&4294967295)); //@line 1907 "compiledict.cpp"
        var $18=HEAP32[((_translator)>>2)]; //@line 1908 "compiledict.cpp"
        var $langopts=(($18)&4294967295); //@line 1908 "compiledict.cpp"
        var $listx=(($langopts+260)&4294967295); //@line 1908 "compiledict.cpp"
        var $19=HEAP32[(($listx)>>2)]; //@line 1908 "compiledict.cpp"
        var $tobool42=((($19))|0)!=0; //@line 1908 "compiledict.cpp"
        var $arraydecay44=(($path)&4294967295); //@line 1910 "compiledict.cpp"
        if ($tobool42) { __label__ = 14;; } else { __label__ = 15;; } //@line 1908 "compiledict.cpp"
        if (__label__ == 14) {
  
          __ZL21compile_dictlist_filePKcS0_($arraydecay44, ((__str75)&4294967295)); //@line 1910 "compiledict.cpp"
          var $arraydecay46=(($path)&4294967295); //@line 1911 "compiledict.cpp"
          __ZL21compile_dictlist_filePKcS0_($arraydecay46, ((__str76)&4294967295)); //@line 1911 "compiledict.cpp"
          ; //@line 1912 "compiledict.cpp"
        }
        else if (__label__ == 15) {
  
          __ZL21compile_dictlist_filePKcS0_($arraydecay44, ((__str76)&4294967295)); //@line 1915 "compiledict.cpp"
          var $arraydecay50=(($path)&4294967295); //@line 1916 "compiledict.cpp"
          __ZL21compile_dictlist_filePKcS0_($arraydecay50, ((__str75)&4294967295)); //@line 1916 "compiledict.cpp"
          ;
        }
  
        var $arraydecay53=(($path)&4294967295); //@line 1918 "compiledict.cpp"
        __ZL21compile_dictlist_filePKcS0_($arraydecay53, ((__str77)&4294967295)); //@line 1918 "compiledict.cpp"
        var $20=$f_out; //@line 1920 "compiledict.cpp"
        __ZL20compile_dictlist_endP7__sFILE($20); //@line 1920 "compiledict.cpp"
        var $21=$f_out; //@line 1921 "compiledict.cpp"
        var $call55=_ftell($21); //@line 1921 "compiledict.cpp"
        $offset_rules=$call55; //@line 1921 "compiledict.cpp"
        var $22=HEAP32[((__ZL5f_log)>>2)]; //@line 1923 "compiledict.cpp"
        var $arraydecay56=(($fname_in)&4294967295); //@line 1923 "compiledict.cpp"
        var $call57=_fprintf($22, ((__str78)&4294967295), allocate([$arraydecay56,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 1923 "compiledict.cpp"
        var $23=$f_in; //@line 1925 "compiledict.cpp"
        var $24=$f_out; //@line 1925 "compiledict.cpp"
        var $arraydecay58=(($fname_temp)&4294967295); //@line 1925 "compiledict.cpp"
        __ZL17compile_dictrulesP7__sFILES0_Pc($23, $24, $arraydecay58); //@line 1925 "compiledict.cpp"
        var $25=$f_in; //@line 1926 "compiledict.cpp"
        var $call60=_fclose($25); //@line 1926 "compiledict.cpp"
        var $26=$f_out; //@line 1928 "compiledict.cpp"
        var $call61=_fseek($26, 4, 0); //@line 1928 "compiledict.cpp"
        var $27=$f_out; //@line 1929 "compiledict.cpp"
        var $28=$offset_rules; //@line 1929 "compiledict.cpp"
        __Z11Write4BytesP7__sFILEi($27, $28); //@line 1929 "compiledict.cpp"
        var $29=$f_out; //@line 1930 "compiledict.cpp"
        var $call62=_fclose($29); //@line 1930 "compiledict.cpp"
        var $30=HEAP32[((_translator)>>2)]; //@line 1932 "compiledict.cpp"
        var $31=$dict_name_addr; //@line 1932 "compiledict.cpp"
        var $call63=__Z14LoadDictionaryP10TranslatorPKci($30, $31, 0); //@line 1932 "compiledict.cpp"
        var $32=HEAP32[((__ZL11error_count)>>2)]; //@line 1934 "compiledict.cpp"
        $retval=$32; //@line 1934 "compiledict.cpp"
        ; //@line 1934 "compiledict.cpp"
      }
    }
  
    var $33=$retval; //@line 1935 "compiledict.cpp"
    STACKTOP = __stackBase__;
    return $33; //@line 1935 "compiledict.cpp"
    return null;
  }
  

  function __ZL9fopen_logPKcS0_($fname, $access) {
    ;
    var __label__;
  
    var $fname_addr;
    var $access_addr;
    var $f;
    $fname_addr=$fname;
    $access_addr=$access;
    var $0=$fname_addr; //@line 162 "compiledict.cpp"
    var $1=$access_addr; //@line 162 "compiledict.cpp"
    var $call=_fopen($0, $1); //@line 162 "compiledict.cpp"
    $f=$call; //@line 162 "compiledict.cpp"
    var $cmp=((($call))|0)==0; //@line 162 "compiledict.cpp"
    var $2=HEAP32[((__ZL5f_log)>>2)]; //@line 164 "compiledict.cpp"
    var $cmp1=((($2))|0)!=0; //@line 164 "compiledict.cpp"
    var $or_cond=($cmp) & ($cmp1); //@line 162 "compiledict.cpp"
    if ($or_cond) { __label__ = 1;; } else { __label__ = 2;; } //@line 162 "compiledict.cpp"
    if (__label__ == 1) {
  
      var $3=HEAP32[((__ZL5f_log)>>2)]; //@line 165 "compiledict.cpp"
      var $4=$access_addr; //@line 165 "compiledict.cpp"
      var $5=$fname_addr; //@line 165 "compiledict.cpp"
      var $call3=_fprintf($3, ((__str115)&4294967295), allocate([$4,0,0,0,$5,0,0,0], ["i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 165 "compiledict.cpp"
      ; //@line 165 "compiledict.cpp"
    }
  
    var $6=$f; //@line 167 "compiledict.cpp"
    ;
    return $6; //@line 167 "compiledict.cpp"
    return null;
  }
  

  function __ZL22compile_dictlist_startv() {
    var __stackBase__  = STACKTOP; STACKTOP += 4; _memset(__stackBase__, 0, 4);
    var __label__;
  
    var $ix;
    var $p;
    var $p2=__stackBase__;
    $ix=0; //@line 792 "compiledict.cpp"
    var $0=$p2; //@line 797 "compiledict.cpp"
    ; //@line 792 "compiledict.cpp"
    $for_body$2: while(1) { 
  
      var $1=$ix; //@line 794 "compiledict.cpp"
      var $arrayidx=((__ZL11hash_chains+$1*4)&4294967295); //@line 794 "compiledict.cpp"
      var $2=HEAP32[(($arrayidx)>>2)]; //@line 794 "compiledict.cpp"
      $p=$2; //@line 794 "compiledict.cpp"
      var $cmp11=((($2))|0)!=0; //@line 795 "compiledict.cpp"
      if ($cmp11) { __label__ = 2;; } else { __label__ = 3;; } //@line 795 "compiledict.cpp"
      $while_body$$while_end$4: do { 
        if (__label__ == 2) {
          while(1) { 
  
            var $3=$p; //@line 797 "compiledict.cpp"
            var $src$, $dest$, $stop$, $stop4$, $fast$;
            $src$ = $3;
            $dest$ = $0;
            $stop$ = $src$ + 4;
            if (($dest$%4) == ($src$%4) && 4 > 8) {
              while ($src$%4 !== 0 && $src$ < $stop$) {
                ; HEAP8[$dest$++] = HEAP8[$src$++];
              }
              $src$ >>= 2;
              $dest$ >>= 2;
              $stop4$ = $stop$ >> 2;
              while ($src$ < $stop4$) {
            ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
              }
              $src$ <<= 2;
              $dest$ <<= 2;
            }while ($src$ < $stop$) {
              ; HEAP8[$dest$++] = HEAP8[$src$++];
            }; //@line 797 "compiledict.cpp"
            var $4=$p; //@line 798 "compiledict.cpp"
            ; //@line 798 "compiledict.cpp"
            var $5=HEAP32[(($p2)>>2)]; //@line 799 "compiledict.cpp"
            $p=$5; //@line 799 "compiledict.cpp"
            var $cmp1=((($5))|0)!=0; //@line 795 "compiledict.cpp"
            if ($cmp1) { __label__ = 2;continue ; } else { __label__ = 3;break $while_body$$while_end$4; } //@line 795 "compiledict.cpp"
          }
        }
      } while(0);
  
      var $6=$ix; //@line 801 "compiledict.cpp"
      var $arrayidx2=((__ZL11hash_chains+$6*4)&4294967295); //@line 801 "compiledict.cpp"
      HEAP32[(($arrayidx2)>>2)]=0; //@line 801 "compiledict.cpp"
      var $7=$ix; //@line 802 "compiledict.cpp"
      var $arrayidx3=((__ZL11hash_counts+$7*4)&4294967295); //@line 802 "compiledict.cpp"
      HEAP32[(($arrayidx3)>>2)]=0; //@line 802 "compiledict.cpp"
      var $8=$ix; //@line 792 "compiledict.cpp"
      var $inc=((($8)+1)&4294967295); //@line 792 "compiledict.cpp"
      $ix=$inc; //@line 792 "compiledict.cpp"
      var $cmp=((($inc))|0) < 1024; //@line 792 "compiledict.cpp"
      if ($cmp) { __label__ = 1;continue $for_body$2; } else { __label__ = 4;break $for_body$2; } //@line 792 "compiledict.cpp"
    }
  
    STACKTOP = __stackBase__;
    return; //@line 804 "compiledict.cpp"
    return;
  }
  

  function __ZL21compile_dictlist_filePKcS0_($path, $filename) {
    var __stackBase__  = STACKTOP; STACKTOP += 528; _memset(__stackBase__, 0, 528);
    var __label__;
  
    var $retval;
    var $path_addr;
    var $filename_addr;
    var $length;
    var $hash=__stackBase__;
    var $p;
    var $count;
    var $f_in;
    var $buf=__stackBase__+4;
    var $fname=__stackBase__+204;
    var $dict_line=__stackBase__+400;
    $path_addr=$path;
    $filename_addr=$filename;
    $count=0; //@line 849 "compiledict.cpp"
    HEAP8[(__ZL9text_mode_b)]=0;
    var $arraydecay=(($fname)&4294967295); //@line 858 "compiledict.cpp"
    var $0=$path_addr; //@line 858 "compiledict.cpp"
    var $1=$filename_addr; //@line 858 "compiledict.cpp"
    var $call=_sprintf($arraydecay, ((__str104)&4294967295), allocate([$0,0,0,0,$1,0,0,0], ["i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 858 "compiledict.cpp"
    var $arraydecay1=(($fname)&4294967295); //@line 859 "compiledict.cpp"
    var $call2=_fopen($arraydecay1, ((__str51703)&4294967295)); //@line 859 "compiledict.cpp"
    $f_in=$call2; //@line 859 "compiledict.cpp"
    var $cmp=((($call2))|0)==0; //@line 859 "compiledict.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 3;; } //@line 859 "compiledict.cpp"
    $if_then$$if_end9$2: do { 
      if (__label__ == 1) {
  
        var $arraydecay3=(($fname)&4294967295); //@line 861 "compiledict.cpp"
        var $2=$path_addr; //@line 861 "compiledict.cpp"
        var $3=$filename_addr; //@line 861 "compiledict.cpp"
        var $call4=_sprintf($arraydecay3, ((__str47699)&4294967295), allocate([$2,0,0,0,$3,0,0,0], ["i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 861 "compiledict.cpp"
        var $arraydecay5=(($fname)&4294967295); //@line 862 "compiledict.cpp"
        var $call6=_fopen($arraydecay5, ((__str51703)&4294967295)); //@line 862 "compiledict.cpp"
        $f_in=$call6; //@line 862 "compiledict.cpp"
        var $cmp7=((($call6))|0)==0; //@line 862 "compiledict.cpp"
        if (!($cmp7)) { __label__ = 3;break $if_then$$if_end9$2; } //@line 862 "compiledict.cpp"
  
        $retval=-1; //@line 863 "compiledict.cpp"
        __label__ = 11;break $if_then$$if_end9$2; //@line 863 "compiledict.cpp"
      }
    } while(0);
    if (__label__ == 3) {
  
      var $4=HEAP32[((__ZL5f_log)>>2)]; //@line 866 "compiledict.cpp"
      var $arraydecay10=(($fname)&4294967295); //@line 866 "compiledict.cpp"
      var $call11=_fprintf($4, ((__str78)&4294967295), allocate([$arraydecay10,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 866 "compiledict.cpp"
      HEAP32[((__ZL7linenum)>>2)]=0; //@line 868 "compiledict.cpp"
      var $arraydecay12=(($buf)&4294967295); //@line 870 "compiledict.cpp"
      var $arraydecay15=(($buf)&4294967295); //@line 874 "compiledict.cpp"
      var $arraydecay16=(($dict_line)&4294967295); //@line 874 "compiledict.cpp"
      var $arraydecay33=(($dict_line)&4294967295); //@line 892 "compiledict.cpp"
      ; //@line 870 "compiledict.cpp"
      $while_cond$7: while(1) { 
  
        var $5=$f_in; //@line 870 "compiledict.cpp"
        var $call13=_fgets($arraydecay12, 200, $5); //@line 870 "compiledict.cpp"
        var $cmp14=((($call13))|0)!=0; //@line 870 "compiledict.cpp"
        if (!($cmp14)) { __label__ = 10;break $while_cond$7; } //@line 870 "compiledict.cpp"
  
        var $6=HEAP32[((__ZL7linenum)>>2)]; //@line 872 "compiledict.cpp"
        var $inc=((($6)+1)&4294967295); //@line 872 "compiledict.cpp"
        HEAP32[((__ZL7linenum)>>2)]=$inc; //@line 872 "compiledict.cpp"
        var $call17=__ZL12compile_linePcS_Pi($arraydecay15, $arraydecay16, $hash); //@line 874 "compiledict.cpp"
        $length=$call17; //@line 874 "compiledict.cpp"
        var $7=$length; //@line 875 "compiledict.cpp"
        var $cmp18=((($7))|0)==0; //@line 875 "compiledict.cpp"
        if ($cmp18) { __label__ = 4;continue $while_cond$7; } //@line 875 "compiledict.cpp"
  
        var $8=HEAP32[(($hash)>>2)]; //@line 877 "compiledict.cpp"
        var $arrayidx=((__ZL11hash_counts+$8*4)&4294967295); //@line 877 "compiledict.cpp"
        var $9=HEAP32[(($arrayidx)>>2)]; //@line 877 "compiledict.cpp"
        var $inc21=((($9)+1)&4294967295); //@line 877 "compiledict.cpp"
        HEAP32[(($arrayidx)>>2)]=$inc21; //@line 877 "compiledict.cpp"
        var $10=$length; //@line 879 "compiledict.cpp"
        var $add=((($10)+4)&4294967295); //@line 879 "compiledict.cpp"
        var $call22=_malloc($add); //@line 879 "compiledict.cpp"
        $p=$call22; //@line 879 "compiledict.cpp"
        var $11=$p; //@line 880 "compiledict.cpp"
        var $cmp23=((($11))|0)==0; //@line 880 "compiledict.cpp"
        if ($cmp23) { __label__ = 7;break $while_cond$7; } //@line 880 "compiledict.cpp"
  
        var $16=$p; //@line 890 "compiledict.cpp"
        var $17=HEAP32[(($hash)>>2)]; //@line 890 "compiledict.cpp"
        var $arrayidx31=((__ZL11hash_chains+$17*4)&4294967295); //@line 890 "compiledict.cpp"
        var $18=$arrayidx31; //@line 890 "compiledict.cpp"
        var $src$, $dest$, $stop$, $stop4$, $fast$;
        $src$ = $18;
        $dest$ = $16;
        $stop$ = $src$ + 4;
        if (($dest$%4) == ($src$%4) && 4 > 8) {
          while ($src$%4 !== 0 && $src$ < $stop$) {
            ; HEAP8[$dest$++] = HEAP8[$src$++];
          }
          $src$ >>= 2;
          $dest$ >>= 2;
          $stop4$ = $stop$ >> 2;
          while ($src$ < $stop4$) {
        ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
          }
          $src$ <<= 2;
          $dest$ <<= 2;
        }while ($src$ < $stop$) {
          ; HEAP8[$dest$++] = HEAP8[$src$++];
        }; //@line 890 "compiledict.cpp"
        var $19=$p; //@line 891 "compiledict.cpp"
        var $20=HEAP32[(($hash)>>2)]; //@line 891 "compiledict.cpp"
        var $arrayidx32=((__ZL11hash_chains+$20*4)&4294967295); //@line 891 "compiledict.cpp"
        HEAP32[(($arrayidx32)>>2)]=$19; //@line 891 "compiledict.cpp"
        var $21=$p; //@line 892 "compiledict.cpp"
        var $add_ptr=(($21+4)&4294967295); //@line 892 "compiledict.cpp"
        var $22=$length; //@line 892 "compiledict.cpp"
        var $src$, $dest$, $stop$, $stop4$, $fast$;
        $src$ = $arraydecay33;
        $dest$ = $add_ptr;
        $stop$ = $src$ + $22;
        if (($dest$%4) == ($src$%4) && $22 > 8) {
          while ($src$%4 !== 0 && $src$ < $stop$) {
            ; HEAP8[$dest$++] = HEAP8[$src$++];
          }
          $src$ >>= 2;
          $dest$ >>= 2;
          $stop4$ = $stop$ >> 2;
          while ($src$ < $stop4$) {
        ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
          }
          $src$ <<= 2;
          $dest$ <<= 2;
        }while ($src$ < $stop$) {
          ; HEAP8[$dest$++] = HEAP8[$src$++];
        }; //@line 892 "compiledict.cpp"
        var $23=$count; //@line 893 "compiledict.cpp"
        var $inc34=((($23)+1)&4294967295); //@line 893 "compiledict.cpp"
        $count=$inc34; //@line 893 "compiledict.cpp"
        __label__ = 4;continue $while_cond$7; //@line 894 "compiledict.cpp"
      }
      $while_end$$if_then24$12: do { 
        if (__label__ == 7) {
  
          var $12=HEAP32[((__ZL5f_log)>>2)]; //@line 882 "compiledict.cpp"
          var $cmp25=((($12))|0)!=0; //@line 882 "compiledict.cpp"
          if (!($cmp25)) { __label__ = 10;break $while_end$$if_then24$12; } //@line 882 "compiledict.cpp"
  
          var $13=HEAP32[((__ZL5f_log)>>2)]; //@line 884 "compiledict.cpp"
          var $14=_fwrite(((__str106)&4294967295), 22, 1, $13); //@line 884 "compiledict.cpp"
          var $15=HEAP32[((__ZL11error_count)>>2)]; //@line 885 "compiledict.cpp"
          var $inc28=((($15)+1)&4294967295); //@line 885 "compiledict.cpp"
          HEAP32[((__ZL11error_count)>>2)]=$inc28; //@line 885 "compiledict.cpp"
          ; //@line 886 "compiledict.cpp"
        }
      } while(0);
  
      var $24=HEAP32[((__ZL5f_log)>>2)]; //@line 896 "compiledict.cpp"
      var $25=$count; //@line 896 "compiledict.cpp"
      var $call35=_fprintf($24, ((__str107)&4294967295), allocate([$25,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 896 "compiledict.cpp"
      var $26=$f_in; //@line 897 "compiledict.cpp"
      var $call36=_fclose($26); //@line 897 "compiledict.cpp"
      $retval=0; //@line 898 "compiledict.cpp"
      ; //@line 898 "compiledict.cpp"
    }
  
    STACKTOP = __stackBase__;
    return;
    return;
  }
  

  function __ZL20compile_dictlist_endP7__sFILE($f_out) {
    var __stackBase__  = STACKTOP; STACKTOP += 4; _memset(__stackBase__, 0, 4);
    var __label__;
  
    var $f_out_addr;
    var $hash;
    var $length;
    var $p=__stackBase__;
    $f_out_addr=$f_out;
    $hash=0; //@line 827 "compiledict.cpp"
    var $0=$p; //@line 836 "compiledict.cpp"
    ; //@line 827 "compiledict.cpp"
    $for_body$2: while(1) { 
  
      var $1=$hash; //@line 829 "compiledict.cpp"
      var $arrayidx=((__ZL11hash_chains+$1*4)&4294967295); //@line 829 "compiledict.cpp"
      var $2=HEAP32[(($arrayidx)>>2)]; //@line 829 "compiledict.cpp"
      HEAP32[(($p)>>2)]=$2; //@line 829 "compiledict.cpp"
      var $3=$f_out_addr; //@line 830 "compiledict.cpp"
      var $call=_ftell($3); //@line 830 "compiledict.cpp"
      var $4=$hash; //@line 830 "compiledict.cpp"
      var $arrayidx2=((__ZL11hash_counts+$4*4)&4294967295); //@line 830 "compiledict.cpp"
      HEAP32[(($arrayidx2)>>2)]=$call; //@line 830 "compiledict.cpp"
      var $5=HEAP32[(($p)>>2)]; //@line 832 "compiledict.cpp"
      var $cmp31=((($5))|0)!=0; //@line 832 "compiledict.cpp"
      if ($cmp31) { __label__ = 2;; } else { __label__ = 3;; } //@line 832 "compiledict.cpp"
      $while_body$$while_end$4: do { 
        if (__label__ == 2) {
          while(1) { 
  
            var $6=HEAP32[(($p)>>2)]; //@line 834 "compiledict.cpp"
            var $add_ptr=(($6+4)&4294967295); //@line 834 "compiledict.cpp"
            var $7=HEAP8[($add_ptr)]; //@line 834 "compiledict.cpp"
            var $conv=(tempInt=(($7)),(tempInt>=128?tempInt-256:tempInt)); //@line 834 "compiledict.cpp"
            $length=$conv; //@line 834 "compiledict.cpp"
            var $8=HEAP32[(($p)>>2)]; //@line 835 "compiledict.cpp"
            var $add_ptr4=(($8+4)&4294967295); //@line 835 "compiledict.cpp"
            var $9=$length; //@line 835 "compiledict.cpp"
            var $10=$f_out_addr; //@line 835 "compiledict.cpp"
            var $call5=_fwrite($add_ptr4, $9, 1, $10); //@line 835 "compiledict.cpp"
            var $11=HEAP32[(($p)>>2)]; //@line 836 "compiledict.cpp"
            var $src$, $dest$, $stop$, $stop4$, $fast$;
            $src$ = $11;
            $dest$ = $0;
            $stop$ = $src$ + 4;
            if (($dest$%4) == ($src$%4) && 4 > 8) {
              while ($src$%4 !== 0 && $src$ < $stop$) {
                ; HEAP8[$dest$++] = HEAP8[$src$++];
              }
              $src$ >>= 2;
              $dest$ >>= 2;
              $stop4$ = $stop$ >> 2;
              while ($src$ < $stop4$) {
            ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
              }
              $src$ <<= 2;
              $dest$ <<= 2;
            }while ($src$ < $stop$) {
              ; HEAP8[$dest$++] = HEAP8[$src$++];
            }; //@line 836 "compiledict.cpp"
            var $12=HEAP32[(($p)>>2)]; //@line 832 "compiledict.cpp"
            var $cmp3=((($12))|0)!=0; //@line 832 "compiledict.cpp"
            if ($cmp3) { __label__ = 2;continue ; } else { __label__ = 3;break $while_body$$while_end$4; } //@line 832 "compiledict.cpp"
          }
        }
      } while(0);
  
      var $13=$f_out_addr; //@line 838 "compiledict.cpp"
      var $call6=_fputc(0, $13); //@line 838 "compiledict.cpp"
      var $14=$hash; //@line 827 "compiledict.cpp"
      var $inc=((($14)+1)&4294967295); //@line 827 "compiledict.cpp"
      $hash=$inc; //@line 827 "compiledict.cpp"
      var $cmp1=((($inc))|0) < 1024; //@line 827 "compiledict.cpp"
      if ($cmp1) { __label__ = 1;continue $for_body$2; } else { __label__ = 4;break $for_body$2; } //@line 827 "compiledict.cpp"
    }
  
    STACKTOP = __stackBase__;
    return; //@line 840 "compiledict.cpp"
    return;
  }
  

  function __ZL17compile_dictrulesP7__sFILES0_Pc($f_in, $f_out, $fname_temp) {
    var __stackBase__  = STACKTOP; STACKTOP += 11876; _memset(__stackBase__, 0, 11876);
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $f_in_addr;
    var $f_out_addr;
    var $fname_temp_addr;
    var $prule;
    var $p;
    var $ix;
    var $c=__stackBase__;
    var $gp;
    var $f_temp;
    var $n_rules=__stackBase__+4;
    var $count;
    var $different;
    var $wc=__stackBase__+8;
    var $prev_rgroup_name;
    var $char_code=__stackBase__+12;
    var $compile_mode;
    var $buf;
    var $buf1=__stackBase__+16;
    var $rules=__stackBase__+516;
    var $n_rgroups;
    var $n_groups3;
    var $rgroup=__stackBase__+8516;
    var $replace1;
    var $replace2;
    var $p123;
    $f_in_addr=$f_in;
    $f_out_addr=$f_out;
    $fname_temp_addr=$fname_temp;
    HEAP32[(($n_rules)>>2)]=0; //@line 1623 "compiledict.cpp"
    $count=0; //@line 1624 "compiledict.cpp"
    $compile_mode=0; //@line 1629 "compiledict.cpp"
    $n_rgroups=0; //@line 1634 "compiledict.cpp"
    $n_groups3=0; //@line 1635 "compiledict.cpp"
    HEAP32[((__ZL7linenum)>>2)]=0; //@line 1638 "compiledict.cpp"
    HEAP8[(((__ZL10group_name)&4294967295))]=0; //@line 1639 "compiledict.cpp"
    var $0=$fname_temp_addr; //@line 1641 "compiledict.cpp"
    var $call=__ZL9fopen_logPKcS0_($0, ((__str79)&4294967295)); //@line 1641 "compiledict.cpp"
    $f_temp=$call; //@line 1641 "compiledict.cpp"
    var $cmp=((($call))|0)==0; //@line 1641 "compiledict.cpp"
    if ($cmp) { __label__ = 2;; } else { __label__ = 1;; } //@line 1641 "compiledict.cpp"
    if (__label__ == 2) {
  
      $retval=1; //@line 1642 "compiledict.cpp"
      ; //@line 1642 "compiledict.cpp"
    }
    else if (__label__ == 1) {
  
      var $arraydecay=(($buf1)&4294967295); //@line 1647 "compiledict.cpp"
      var $arraydecay25=(($rules)&4294967295); //@line 1665 "compiledict.cpp"
      var $1=$n_rules; //@line 1676 "compiledict.cpp"
      ; //@line 1646 "compiledict.cpp"
      $for_cond$5: while(1) { 
  
        var $2=HEAP32[((__ZL7linenum)>>2)]; //@line 1646 "compiledict.cpp"
        var $inc=((($2)+1)&4294967295); //@line 1646 "compiledict.cpp"
        HEAP32[((__ZL7linenum)>>2)]=$inc; //@line 1646 "compiledict.cpp"
        var $3=$f_in_addr; //@line 1647 "compiledict.cpp"
        var $call1=_fgets($arraydecay, 500, $3); //@line 1647 "compiledict.cpp"
        $buf=$call1; //@line 1647 "compiledict.cpp"
        var $cmp2=((($call1))|0)!=0; //@line 1648 "compiledict.cpp"
        if ($cmp2) { __label__ = 4;; } else { __label__ = 10;; } //@line 1648 "compiledict.cpp"
        $if_then3$$if_then16$7: do { 
          if (__label__ == 4) {
  
            var $4=$buf; //@line 1650 "compiledict.cpp"
            var $call4=_strstr($4, ((__str82734)&4294967295)); //@line 1650 "compiledict.cpp"
            $p=$call4; //@line 1650 "compiledict.cpp"
            var $cmp5=((($call4))|0)!=0; //@line 1650 "compiledict.cpp"
            if ($cmp5) { __label__ = 5;; } else { __label__ = 6;; } //@line 1650 "compiledict.cpp"
            if (__label__ == 5) {
  
              var $5=$p; //@line 1651 "compiledict.cpp"
              HEAP8[($5)]=0; //@line 1651 "compiledict.cpp"
              ; //@line 1651 "compiledict.cpp"
            }
  
            var $6=$buf; //@line 1653 "compiledict.cpp"
            var $arrayidx=(($6)&4294967295); //@line 1653 "compiledict.cpp"
            var $7=HEAP8[($arrayidx)]; //@line 1653 "compiledict.cpp"
            var $conv=(tempInt=(($7)),(tempInt>=128?tempInt-256:tempInt)); //@line 1653 "compiledict.cpp"
            var $cmp8=((($conv))|0)==13; //@line 1653 "compiledict.cpp"
            if ($cmp8) { __lastLabel__ = 6; __label__ = 7;; } else { __lastLabel__ = 6; __label__ = 8;; } //@line 1653 "compiledict.cpp"
            if (__label__ == 7) {
  
              var $8=$buf; //@line 1653 "compiledict.cpp"
              var $incdec_ptr=(($8+1)&4294967295); //@line 1653 "compiledict.cpp"
              $buf=$incdec_ptr; //@line 1653 "compiledict.cpp"
              __lastLabel__ = 7; ; //@line 1653 "compiledict.cpp"
            }
  
            var $9=__lastLabel__ == 6 ? $6 : ($incdec_ptr); //@line 1656 "compiledict.cpp"
            var $cmp12=((($9))|0)==0; //@line 1656 "compiledict.cpp"
            if ($cmp12) { __label__ = 10;break $if_then3$$if_then16$7; } //@line 1656 "compiledict.cpp"
  
            var $10=$buf; //@line 1656 "compiledict.cpp"
            var $arrayidx13=(($10)&4294967295); //@line 1656 "compiledict.cpp"
            var $11=HEAP8[($arrayidx13)]; //@line 1656 "compiledict.cpp"
            var $conv14=(tempInt=(($11)),(tempInt>=128?tempInt-256:tempInt)); //@line 1656 "compiledict.cpp"
            var $cmp15=((($conv14))|0)==46; //@line 1656 "compiledict.cpp"
            if ($cmp15) { __label__ = 10;break $if_then3$$if_then16$7; } //@line 1656 "compiledict.cpp"
  
            var $69=$compile_mode; //@line 1750 "compiledict.cpp"
            if ($69 == 1) {
              __label__ = 44;;
            }
            else if ($69 == 2) {
              __label__ = 47;;
            }
            else {
            __label__ = 3;continue $for_cond$5;
            }
            
            if (__label__ == 44) {
  
              var $70=$buf; //@line 1753 "compiledict.cpp"
              var $call114=__ZL12compile_rulePc($70); //@line 1753 "compiledict.cpp"
              $prule=$call114; //@line 1753 "compiledict.cpp"
              var $71=$prule; //@line 1754 "compiledict.cpp"
              var $cmp115=((($71))|0)!=0; //@line 1754 "compiledict.cpp"
              if (!($cmp115)) { __label__ = 3;continue $for_cond$5; } //@line 1754 "compiledict.cpp"
  
              var $72=HEAP32[(($n_rules)>>2)]; //@line 1754 "compiledict.cpp"
              var $cmp117=((($72))|0) < 2000; //@line 1754 "compiledict.cpp"
              if (!($cmp117)) { __label__ = 3;continue $for_cond$5; } //@line 1754 "compiledict.cpp"
  
              var $73=$prule; //@line 1756 "compiledict.cpp"
              var $74=HEAP32[(($n_rules)>>2)]; //@line 1756 "compiledict.cpp"
              var $inc119=((($74)+1)&4294967295); //@line 1756 "compiledict.cpp"
              HEAP32[(($n_rules)>>2)]=$inc119; //@line 1756 "compiledict.cpp"
              var $arrayidx120=(($rules+$74*4)&4294967295); //@line 1756 "compiledict.cpp"
              HEAP32[(($arrayidx120)>>2)]=$73; //@line 1756 "compiledict.cpp"
              __label__ = 3;continue $for_cond$5; //@line 1757 "compiledict.cpp"
            }
            else if (__label__ == 47) {
  
              var $75=$buf; //@line 1766 "compiledict.cpp"
              $p123=$75; //@line 1766 "compiledict.cpp"
              $replace1=0; //@line 1767 "compiledict.cpp"
              $replace2=0; //@line 1768 "compiledict.cpp"
              var $76=$p123; //@line 1769 "compiledict.cpp"
              var $77=HEAP8[($76)]; //@line 1769 "compiledict.cpp"
              var $conv1254=(tempInt=(($77)),(tempInt>=128?tempInt-256:tempInt)); //@line 1769 "compiledict.cpp"
              var $call1265=__Z8isspace2j($conv1254); //@line 1769 "compiledict.cpp"
              var $tobool6=((($call1265))|0)!=0; //@line 1769 "compiledict.cpp"
              if ($tobool6) { __label__ = 48;; } else { __label__ = 49;; } //@line 1769 "compiledict.cpp"
              $while_body127$$while_end129$22: do { 
                if (__label__ == 48) {
                  while(1) { 
  
                    var $78=$p123; //@line 1769 "compiledict.cpp"
                    var $incdec_ptr128=(($78+1)&4294967295); //@line 1769 "compiledict.cpp"
                    $p123=$incdec_ptr128; //@line 1769 "compiledict.cpp"
                    var $79=$p123; //@line 1769 "compiledict.cpp"
                    var $80=HEAP8[($79)]; //@line 1769 "compiledict.cpp"
                    var $conv125=(tempInt=(($80)),(tempInt>=128?tempInt-256:tempInt)); //@line 1769 "compiledict.cpp"
                    var $call126=__Z8isspace2j($conv125); //@line 1769 "compiledict.cpp"
                    var $tobool=((($call126))|0)!=0; //@line 1769 "compiledict.cpp"
                    if ($tobool) { __label__ = 48;continue ; } else { __label__ = 49;break $while_body127$$while_end129$22; } //@line 1769 "compiledict.cpp"
                  }
                }
              } while(0);
  
              $ix=0; //@line 1770 "compiledict.cpp"
              var $81=$p123; //@line 1771 "compiledict.cpp"
              var $82=HEAPU8[($81)]; //@line 1771 "compiledict.cpp"
              var $conv1317=((($82))&255); //@line 1771 "compiledict.cpp"
              var $cmp1328=((($conv1317))|0) > 32; //@line 1771 "compiledict.cpp"
              if ($cmp1328) { __label__ = 50;; } else { __label__ = 51;; } //@line 1771 "compiledict.cpp"
              $while_body133$$while_cond138_loopexit$26: do { 
                if (__label__ == 50) {
                  while(1) { 
  
                    var $83=$p123; //@line 1773 "compiledict.cpp"
                    var $call134=__Z7utf8_inPiPKc($c, $83); //@line 1773 "compiledict.cpp"
                    var $84=$p123; //@line 1773 "compiledict.cpp"
                    var $add_ptr=(($84+$call134)&4294967295); //@line 1773 "compiledict.cpp"
                    $p123=$add_ptr; //@line 1773 "compiledict.cpp"
                    var $85=HEAP32[(($c)>>2)]; //@line 1774 "compiledict.cpp"
                    var $86=$ix; //@line 1774 "compiledict.cpp"
                    var $shl=($85) << ($86); //@line 1774 "compiledict.cpp"
                    var $87=$replace1; //@line 1774 "compiledict.cpp"
                    var $add135=((($87)+($shl))&4294967295); //@line 1774 "compiledict.cpp"
                    $replace1=$add135; //@line 1774 "compiledict.cpp"
                    var $88=$ix; //@line 1775 "compiledict.cpp"
                    var $add136=((($88)+16)&4294967295); //@line 1775 "compiledict.cpp"
                    $ix=$add136; //@line 1775 "compiledict.cpp"
                    var $89=$p123; //@line 1771 "compiledict.cpp"
                    var $90=HEAPU8[($89)]; //@line 1771 "compiledict.cpp"
                    var $conv131=((($90))&255); //@line 1771 "compiledict.cpp"
                    var $cmp132=((($conv131))|0) > 32; //@line 1771 "compiledict.cpp"
                    if ($cmp132) { __label__ = 50;continue ; } else { __label__ = 51;break $while_body133$$while_cond138_loopexit$26; } //@line 1771 "compiledict.cpp"
                  }
                }
              } while(0);
  
              var $91=$p123; //@line 1777 "compiledict.cpp"
              var $92=HEAP8[($91)]; //@line 1777 "compiledict.cpp"
              var $conv1399=(tempInt=(($92)),(tempInt>=128?tempInt-256:tempInt)); //@line 1777 "compiledict.cpp"
              var $call14010=__Z8isspace2j($conv1399); //@line 1777 "compiledict.cpp"
              var $tobool14111=((($call14010))|0)!=0; //@line 1777 "compiledict.cpp"
              if ($tobool14111) { __label__ = 52;; } else { __label__ = 53;; } //@line 1777 "compiledict.cpp"
              $while_body142$$while_end144$30: do { 
                if (__label__ == 52) {
                  while(1) { 
  
                    var $93=$p123; //@line 1777 "compiledict.cpp"
                    var $incdec_ptr143=(($93+1)&4294967295); //@line 1777 "compiledict.cpp"
                    $p123=$incdec_ptr143; //@line 1777 "compiledict.cpp"
                    var $94=$p123; //@line 1777 "compiledict.cpp"
                    var $95=HEAP8[($94)]; //@line 1777 "compiledict.cpp"
                    var $conv139=(tempInt=(($95)),(tempInt>=128?tempInt-256:tempInt)); //@line 1777 "compiledict.cpp"
                    var $call140=__Z8isspace2j($conv139); //@line 1777 "compiledict.cpp"
                    var $tobool141=((($call140))|0)!=0; //@line 1777 "compiledict.cpp"
                    if ($tobool141) { __label__ = 52;continue ; } else { __label__ = 53;break $while_body142$$while_end144$30; } //@line 1777 "compiledict.cpp"
                  }
                }
              } while(0);
  
              $ix=0; //@line 1778 "compiledict.cpp"
              var $96=$p123; //@line 1779 "compiledict.cpp"
              var $97=HEAPU8[($96)]; //@line 1779 "compiledict.cpp"
              var $conv14612=((($97))&255); //@line 1779 "compiledict.cpp"
              var $cmp14713=((($conv14612))|0) > 32; //@line 1779 "compiledict.cpp"
              if ($cmp14713) { __label__ = 54;; } else { __label__ = 55;; } //@line 1779 "compiledict.cpp"
              $while_body148$$while_end154$34: do { 
                if (__label__ == 54) {
                  while(1) { 
  
                    var $98=$p123; //@line 1781 "compiledict.cpp"
                    var $call149=__Z7utf8_inPiPKc($c, $98); //@line 1781 "compiledict.cpp"
                    var $99=$p123; //@line 1781 "compiledict.cpp"
                    var $add_ptr150=(($99+$call149)&4294967295); //@line 1781 "compiledict.cpp"
                    $p123=$add_ptr150; //@line 1781 "compiledict.cpp"
                    var $100=HEAP32[(($c)>>2)]; //@line 1782 "compiledict.cpp"
                    var $101=$ix; //@line 1782 "compiledict.cpp"
                    var $shl151=($100) << ($101); //@line 1782 "compiledict.cpp"
                    var $102=$replace2; //@line 1782 "compiledict.cpp"
                    var $add152=((($102)+($shl151))&4294967295); //@line 1782 "compiledict.cpp"
                    $replace2=$add152; //@line 1782 "compiledict.cpp"
                    var $103=$ix; //@line 1783 "compiledict.cpp"
                    var $add153=((($103)+16)&4294967295); //@line 1783 "compiledict.cpp"
                    $ix=$add153; //@line 1783 "compiledict.cpp"
                    var $104=$p123; //@line 1779 "compiledict.cpp"
                    var $105=HEAPU8[($104)]; //@line 1779 "compiledict.cpp"
                    var $conv146=((($105))&255); //@line 1779 "compiledict.cpp"
                    var $cmp147=((($conv146))|0) > 32; //@line 1779 "compiledict.cpp"
                    if ($cmp147) { __label__ = 54;continue ; } else { __label__ = 55;break $while_body148$$while_end154$34; } //@line 1779 "compiledict.cpp"
                  }
                }
              } while(0);
  
              var $106=$replace1; //@line 1785 "compiledict.cpp"
              var $cmp155=((($106))|0)!=0; //@line 1785 "compiledict.cpp"
              if (!($cmp155)) { __label__ = 3;continue $for_cond$5; } //@line 1785 "compiledict.cpp"
  
              var $107=$f_out_addr; //@line 1787 "compiledict.cpp"
              var $108=$replace1; //@line 1787 "compiledict.cpp"
              __Z11Write4BytesP7__sFILEi($107, $108); //@line 1787 "compiledict.cpp"
              var $109=$f_out_addr; //@line 1788 "compiledict.cpp"
              var $110=$replace2; //@line 1788 "compiledict.cpp"
              __Z11Write4BytesP7__sFILEi($109, $110); //@line 1788 "compiledict.cpp"
              __label__ = 3;continue $for_cond$5; //@line 1789 "compiledict.cpp"
            }
          }
        } while(0);
  
        var $12=HEAP32[(($n_rules)>>2)]; //@line 1660 "compiledict.cpp"
        var $cmp17=((($12))|0) > 0; //@line 1660 "compiledict.cpp"
        if ($cmp17) { __label__ = 11;; } else { __label__ = 12;; } //@line 1660 "compiledict.cpp"
        if (__label__ == 11) {
  
          var $13=$n_rgroups; //@line 1662 "compiledict.cpp"
          var $arrayidx19=(($rgroup+$13*28)&4294967295); //@line 1662 "compiledict.cpp"
          var $name=(($arrayidx19)&4294967295); //@line 1662 "compiledict.cpp"
          var $arraydecay20=(($name)&4294967295); //@line 1662 "compiledict.cpp"
          var $call21=_strcpy($arraydecay20, ((__ZL10group_name)&4294967295)); //@line 1662 "compiledict.cpp"
          var $14=HEAP32[((__ZL9group3_ix)>>2)]; //@line 1663 "compiledict.cpp"
          var $15=$n_rgroups; //@line 1663 "compiledict.cpp"
          var $arrayidx22=(($rgroup+$15*28)&4294967295); //@line 1663 "compiledict.cpp"
          var $group3_ix=(($arrayidx22+24)&4294967295); //@line 1663 "compiledict.cpp"
          HEAP32[(($group3_ix)>>2)]=$14; //@line 1663 "compiledict.cpp"
          var $16=$f_temp; //@line 1664 "compiledict.cpp"
          var $call23=_ftell($16); //@line 1664 "compiledict.cpp"
          var $17=$n_rgroups; //@line 1664 "compiledict.cpp"
          var $arrayidx24=(($rgroup+$17*28)&4294967295); //@line 1664 "compiledict.cpp"
          var $start=(($arrayidx24+16)&4294967295); //@line 1664 "compiledict.cpp"
          HEAP32[(($start)>>2)]=$call23; //@line 1664 "compiledict.cpp"
          var $18=$f_temp; //@line 1665 "compiledict.cpp"
          var $19=HEAP32[(($n_rules)>>2)]; //@line 1665 "compiledict.cpp"
          __ZL17output_rule_groupP7__sFILEiPPcS1_($18, $19, $arraydecay25); //@line 1665 "compiledict.cpp"
          var $20=$f_temp; //@line 1666 "compiledict.cpp"
          var $call26=_ftell($20); //@line 1666 "compiledict.cpp"
          var $21=$n_rgroups; //@line 1666 "compiledict.cpp"
          var $arrayidx27=(($rgroup+$21*28)&4294967295); //@line 1666 "compiledict.cpp"
          var $start28=(($arrayidx27+16)&4294967295); //@line 1666 "compiledict.cpp"
          var $22=HEAP32[(($start28)>>2)]; //@line 1666 "compiledict.cpp"
          var $sub=((($call26)-($22))&4294967295); //@line 1666 "compiledict.cpp"
          var $23=$n_rgroups; //@line 1666 "compiledict.cpp"
          var $arrayidx29=(($rgroup+$23*28)&4294967295); //@line 1666 "compiledict.cpp"
          var $length=(($arrayidx29+20)&4294967295); //@line 1666 "compiledict.cpp"
          HEAP32[(($length)>>2)]=$sub; //@line 1666 "compiledict.cpp"
          var $24=$n_rgroups; //@line 1667 "compiledict.cpp"
          var $inc30=((($24)+1)&4294967295); //@line 1667 "compiledict.cpp"
          $n_rgroups=$inc30; //@line 1667 "compiledict.cpp"
          var $25=HEAP32[(($n_rules)>>2)]; //@line 1669 "compiledict.cpp"
          var $26=$count; //@line 1669 "compiledict.cpp"
          var $add=((($26)+($25))&4294967295); //@line 1669 "compiledict.cpp"
          $count=$add; //@line 1669 "compiledict.cpp"
          ; //@line 1670 "compiledict.cpp"
        }
  
        HEAP32[(($n_rules)>>2)]=0; //@line 1671 "compiledict.cpp"
        var $27=$compile_mode; //@line 1673 "compiledict.cpp"
        var $cmp32=((($27))|0)==2; //@line 1673 "compiledict.cpp"
        if ($cmp32) { __label__ = 13;; } else { __label__ = 14;; } //@line 1673 "compiledict.cpp"
        if (__label__ == 13) {
  
          var $28=$f_out_addr; //@line 1676 "compiledict.cpp"
          var $call34=_fwrite($1, 1, 4, $28); //@line 1676 "compiledict.cpp"
          $compile_mode=0; //@line 1677 "compiledict.cpp"
          ; //@line 1678 "compiledict.cpp"
        }
  
        var $29=$buf; //@line 1680 "compiledict.cpp"
        var $cmp36=((($29))|0)==0; //@line 1680 "compiledict.cpp"
        if ($cmp36) { __label__ = 57;break $for_cond$5; } //@line 1680 "compiledict.cpp"
  
        var $30=$buf; //@line 1682 "compiledict.cpp"
        var $call39=_memcmp($30, ((__str81)&4294967295), 2); //@line 1682 "compiledict.cpp"
        var $cmp40=((($call39))|0)==0; //@line 1682 "compiledict.cpp"
        var $31=$buf; //@line 1684 "compiledict.cpp"
        if ($cmp40) { __label__ = 16;; } else { __label__ = 17;; } //@line 1682 "compiledict.cpp"
        if (__label__ == 16) {
  
          var $arrayidx42=(($31+2)&4294967295); //@line 1684 "compiledict.cpp"
          var $32=$f_out_addr; //@line 1684 "compiledict.cpp"
          __ZL19compile_lettergroupPcP7__sFILE($arrayidx42, $32); //@line 1684 "compiledict.cpp"
          __label__ = 3;continue $for_cond$5; //@line 1685 "compiledict.cpp"
        }
        else if (__label__ == 17) {
  
          var $call45=_memcmp($31, ((__str82)&4294967295), 8); //@line 1688 "compiledict.cpp"
          var $cmp46=((($call45))|0)==0; //@line 1688 "compiledict.cpp"
          if ($cmp46) { __label__ = 18;; } else { __label__ = 20;; } //@line 1688 "compiledict.cpp"
          $if_then47$$if_end53$50: do { 
            if (__label__ == 18) {
  
              $compile_mode=2; //@line 1690 "compiledict.cpp"
              var $33=$f_out_addr; //@line 1691 "compiledict.cpp"
              var $call48=_fputc(6, $33); //@line 1691 "compiledict.cpp"
              var $34=$f_out_addr; //@line 1692 "compiledict.cpp"
              var $call49=_fputc(20, $34); //@line 1692 "compiledict.cpp"
              var $35=$f_out_addr; //@line 1695 "compiledict.cpp"
              var $call5014=_ftell($35); //@line 1695 "compiledict.cpp"
              var $and15=($call5014) & 3; //@line 1695 "compiledict.cpp"
              var $cmp5116=((($and15))|0)!=0; //@line 1695 "compiledict.cpp"
              if (!($cmp5116)) { __label__ = 20;break $if_then47$$if_end53$50; } //@line 1695 "compiledict.cpp"
              while(1) { 
  
                var $36=$f_out_addr; //@line 1696 "compiledict.cpp"
                var $call52=_fputc(0, $36); //@line 1696 "compiledict.cpp"
                var $37=$f_out_addr; //@line 1695 "compiledict.cpp"
                var $call50=_ftell($37); //@line 1695 "compiledict.cpp"
                var $and=($call50) & 3; //@line 1695 "compiledict.cpp"
                var $cmp51=((($and))|0)!=0; //@line 1695 "compiledict.cpp"
                if ($cmp51) { __label__ = 19;continue ; } else { __label__ = 20;break $if_then47$$if_end53$50; } //@line 1695 "compiledict.cpp"
              }
            }
          } while(0);
  
          var $38=$buf; //@line 1699 "compiledict.cpp"
          var $call54=_memcmp($38, ((__str83)&4294967295), 6); //@line 1699 "compiledict.cpp"
          var $cmp55=((($call54))|0)==0; //@line 1699 "compiledict.cpp"
          if (!($cmp55)) { __label__ = 3;continue $for_cond$5; } //@line 1699 "compiledict.cpp"
  
          $compile_mode=1; //@line 1701 "compiledict.cpp"
          var $39=$buf; //@line 1703 "compiledict.cpp"
          var $arrayidx57=(($39+6)&4294967295); //@line 1703 "compiledict.cpp"
          $p=$arrayidx57; //@line 1703 "compiledict.cpp"
          ; //@line 1704 "compiledict.cpp"
          $while_cond58$56: while(1) { 
  
            var $40=$p; //@line 1704 "compiledict.cpp"
            var $arrayidx59=(($40)&4294967295); //@line 1704 "compiledict.cpp"
            var $41=HEAPU8[($arrayidx59)]; //@line 1704 "compiledict.cpp"
            var $conv60=((($41))&255); //@line 1704 "compiledict.cpp"
            var $cmp61=((($conv60))|0)==32; //@line 1704 "compiledict.cpp"
            if ($cmp61) { __label__ = 24;; } else { __label__ = 23;; } //@line 1704 "compiledict.cpp"
            if (__label__ == 23) {
  
              var $42=$p; //@line 1704 "compiledict.cpp"
              var $arrayidx62=(($42)&4294967295); //@line 1704 "compiledict.cpp"
              var $43=HEAPU8[($arrayidx62)]; //@line 1704 "compiledict.cpp"
              var $conv63=((($43))&255); //@line 1704 "compiledict.cpp"
              var $cmp64=((($conv63))|0)==9; //@line 1704 "compiledict.cpp"
              if (!($cmp64)) { __label__ = 25;break $while_cond58$56; } //@line 1704 "compiledict.cpp"
            }
  
            var $44=$p; //@line 1704 "compiledict.cpp"
            var $incdec_ptr66=(($44+1)&4294967295); //@line 1704 "compiledict.cpp"
            $p=$incdec_ptr66; //@line 1704 "compiledict.cpp"
            __label__ = 22;continue $while_cond58$56; //@line 1704 "compiledict.cpp"
          }
  
          $ix=0; //@line 1705 "compiledict.cpp"
          ; //@line 1706 "compiledict.cpp"
          $while_cond68$62: while(1) { 
  
            var $45=$p; //@line 1706 "compiledict.cpp"
            var $46=HEAPU8[($45)]; //@line 1706 "compiledict.cpp"
            var $conv69=((($46))&255); //@line 1706 "compiledict.cpp"
            var $cmp70=((($conv69))|0) > 32; //@line 1706 "compiledict.cpp"
            if (!($cmp70)) { __label__ = 29;break $while_cond68$62; } //@line 1706 "compiledict.cpp"
  
            var $47=$ix; //@line 1706 "compiledict.cpp"
            var $cmp71=((($47))|0) < 12; //@line 1706 "compiledict.cpp"
            if (!($cmp71)) { __label__ = 29;break $while_cond68$62; }
  
            var $48=$p; //@line 1707 "compiledict.cpp"
            var $incdec_ptr73=(($48+1)&4294967295); //@line 1707 "compiledict.cpp"
            $p=$incdec_ptr73; //@line 1707 "compiledict.cpp"
            var $49=HEAP8[($48)]; //@line 1707 "compiledict.cpp"
            var $50=$ix; //@line 1707 "compiledict.cpp"
            var $inc74=((($50)+1)&4294967295); //@line 1707 "compiledict.cpp"
            $ix=$inc74; //@line 1707 "compiledict.cpp"
            var $arrayidx75=((__ZL10group_name+$50)&4294967295); //@line 1707 "compiledict.cpp"
            HEAP8[($arrayidx75)]=$49; //@line 1707 "compiledict.cpp"
            __label__ = 26;continue $while_cond68$62; //@line 1707 "compiledict.cpp"
          }
  
          var $51=$ix; //@line 1708 "compiledict.cpp"
          var $arrayidx77=((__ZL10group_name+$51)&4294967295); //@line 1708 "compiledict.cpp"
          HEAP8[($arrayidx77)]=0; //@line 1708 "compiledict.cpp"
          HEAP32[((__ZL9group3_ix)>>2)]=0; //@line 1709 "compiledict.cpp"
          var $call78=_sscanf(((__ZL10group_name)&4294967295), ((__str84)&4294967295), allocate([$char_code,0,0,0], ["i32*",0,0,0], ALLOC_STACK)); //@line 1711 "compiledict.cpp"
          var $cmp79=((($call78))|0)==1; //@line 1711 "compiledict.cpp"
          if ($cmp79) { __label__ = 30;; } else { __label__ = 33;; } //@line 1711 "compiledict.cpp"
          $if_then80$$if_else$67: do { 
            if (__label__ == 30) {
  
              $p=((__ZL10group_name)&4294967295); //@line 1714 "compiledict.cpp"
              var $52=HEAPU32[(($char_code)>>2)]; //@line 1716 "compiledict.cpp"
              var $cmp81=((($52))>>>0) > 256; //@line 1716 "compiledict.cpp"
              if ($cmp81) { __label__ = 31;; } else { __label__ = 32;; } //@line 1716 "compiledict.cpp"
              if (__label__ == 31) {
  
                var $53=HEAPU32[(($char_code)>>2)]; //@line 1718 "compiledict.cpp"
                var $shr=($53) >>> 8; //@line 1718 "compiledict.cpp"
                var $conv83=((($shr)) & 255); //@line 1718 "compiledict.cpp"
                var $54=$p; //@line 1718 "compiledict.cpp"
                var $incdec_ptr84=(($54+1)&4294967295); //@line 1718 "compiledict.cpp"
                $p=$incdec_ptr84; //@line 1718 "compiledict.cpp"
                HEAP8[($54)]=$conv83; //@line 1718 "compiledict.cpp"
                ; //@line 1719 "compiledict.cpp"
              }
  
              var $55=HEAP32[(($char_code)>>2)]; //@line 1720 "compiledict.cpp"
              var $conv86=((($55)) & 255); //@line 1720 "compiledict.cpp"
              var $56=$p; //@line 1720 "compiledict.cpp"
              var $incdec_ptr87=(($56+1)&4294967295); //@line 1720 "compiledict.cpp"
              $p=$incdec_ptr87; //@line 1720 "compiledict.cpp"
              HEAP8[($56)]=$conv86; //@line 1720 "compiledict.cpp"
              var $57=$p; //@line 1721 "compiledict.cpp"
              HEAP8[($57)]=0; //@line 1721 "compiledict.cpp"
              __label__ = 37;break $if_then80$$if_else$67; //@line 1722 "compiledict.cpp"
            }
            else if (__label__ == 33) {
  
              var $58=HEAP32[((_translator)>>2)]; //@line 1725 "compiledict.cpp"
              var $letter_bits_offset=(($58+964)&4294967295); //@line 1725 "compiledict.cpp"
              var $59=HEAP32[(($letter_bits_offset)>>2)]; //@line 1725 "compiledict.cpp"
              var $cmp88=((($59))|0) > 0; //@line 1725 "compiledict.cpp"
              if (!($cmp88)) { __label__ = 37;break $if_then80$$if_else$67; } //@line 1725 "compiledict.cpp"
  
              var $call90=__Z7utf8_inPiPKc($wc, ((__ZL10group_name)&4294967295)); //@line 1727 "compiledict.cpp"
              var $60=HEAP32[(($wc)>>2)]; //@line 1728 "compiledict.cpp"
              var $61=HEAP32[((_translator)>>2)]; //@line 1728 "compiledict.cpp"
              var $letter_bits_offset91=(($61+964)&4294967295); //@line 1728 "compiledict.cpp"
              var $62=HEAP32[(($letter_bits_offset91)>>2)]; //@line 1728 "compiledict.cpp"
              var $sub92=((($60)-($62))&4294967295); //@line 1728 "compiledict.cpp"
              $ix=$sub92; //@line 1728 "compiledict.cpp"
              var $cmp93=((($sub92))|0) >= 0; //@line 1728 "compiledict.cpp"
              if (!($cmp93)) { __label__ = 37;break $if_then80$$if_else$67; } //@line 1728 "compiledict.cpp"
  
              var $63=$ix; //@line 1728 "compiledict.cpp"
              var $cmp94=((($63))|0) < 128; //@line 1728 "compiledict.cpp"
              if (!($cmp94)) { __label__ = 37;break $if_then80$$if_else$67; } //@line 1728 "compiledict.cpp"
  
              var $64=$ix; //@line 1730 "compiledict.cpp"
              var $add96=((($64)+1)&4294967295); //@line 1730 "compiledict.cpp"
              HEAP32[((__ZL9group3_ix)>>2)]=$add96; //@line 1730 "compiledict.cpp"
              __lastLabel__ = 36; __label__ = 38;break $if_then80$$if_else$67; //@line 1731 "compiledict.cpp"
            }
          } while(0);
          if (__label__ == 37) {
  
            var $_pr=HEAP32[((__ZL9group3_ix)>>2)]; //@line 1735 "compiledict.cpp"
            __lastLabel__ = 37; ;
          }
  
          var $65=__lastLabel__ == 37 ? $_pr : ($add96); //@line 1735 "compiledict.cpp"
          var $cmp100=((($65))|0)==0; //@line 1735 "compiledict.cpp"
          if (!($cmp100)) { __label__ = 3;continue $for_cond$5; } //@line 1735 "compiledict.cpp"
  
          var $call102=_strlen(((__ZL10group_name)&4294967295)); //@line 1735 "compiledict.cpp"
          var $cmp103=((($call102))>>>0) > 2; //@line 1735 "compiledict.cpp"
          if (!($cmp103)) { __label__ = 3;continue $for_cond$5; } //@line 1735 "compiledict.cpp"
  
          var $call105=__Z7utf8_inPiPKc($c, ((__ZL10group_name)&4294967295)); //@line 1737 "compiledict.cpp"
          var $cmp106=((($call105))|0) < 2; //@line 1737 "compiledict.cpp"
          if ($cmp106) { __label__ = 41;; } else { __label__ = 42;; } //@line 1737 "compiledict.cpp"
          if (__label__ == 41) {
  
            var $66=HEAP32[((__ZL5f_log)>>2)]; //@line 1739 "compiledict.cpp"
            var $67=HEAP32[((__ZL7linenum)>>2)]; //@line 1739 "compiledict.cpp"
            var $call108=_fprintf($66, ((__str85)&4294967295), allocate([$67,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 1739 "compiledict.cpp"
            var $68=HEAP32[((__ZL11error_count)>>2)]; //@line 1740 "compiledict.cpp"
            var $inc109=((($68)+1)&4294967295); //@line 1740 "compiledict.cpp"
            HEAP32[((__ZL11error_count)>>2)]=$inc109; //@line 1740 "compiledict.cpp"
            ; //@line 1741 "compiledict.cpp"
          }
  
          HEAP8[(((__ZL10group_name+2)&4294967295))]=0; //@line 1743 "compiledict.cpp"
          __label__ = 3;continue $for_cond$5; //@line 1744 "compiledict.cpp"
        }
      }
  
      var $111=$f_temp; //@line 1794 "compiledict.cpp"
      var $call158=_fclose($111); //@line 1794 "compiledict.cpp"
      var $arraydecay159=(($rgroup)&4294967295); //@line 1796 "compiledict.cpp"
      var $112=$arraydecay159; //@line 1796 "compiledict.cpp"
      var $113=$n_rgroups; //@line 1796 "compiledict.cpp"
      _qsort($112, $113, 28, 2); //@line 1796 "compiledict.cpp"
      var $114=$fname_temp_addr; //@line 1798 "compiledict.cpp"
      var $call160=_fopen($114, ((__str18429)&4294967295)); //@line 1798 "compiledict.cpp"
      $f_temp=$call160; //@line 1798 "compiledict.cpp"
      var $cmp161=((($call160))|0)==0; //@line 1798 "compiledict.cpp"
      if ($cmp161) { __label__ = 58;; } else { __label__ = 59;; } //@line 1798 "compiledict.cpp"
      if (__label__ == 58) {
  
        $retval=2; //@line 1799 "compiledict.cpp"
        ; //@line 1799 "compiledict.cpp"
      }
      else if (__label__ == 59) {
  
        $prev_rgroup_name=((__str15397)&4294967295); //@line 1801 "compiledict.cpp"
        $gp=0; //@line 1803 "compiledict.cpp"
        var $115=$gp; //@line 1803 "compiledict.cpp"
        var $116=$n_rgroups; //@line 1803 "compiledict.cpp"
        var $cmp1653=((($115))|0) < ((($116))|0); //@line 1803 "compiledict.cpp"
        if ($cmp1653) { __label__ = 60;; } else { __label__ = 70;; } //@line 1803 "compiledict.cpp"
        $for_body$$for_end210$88: do { 
          if (__label__ == 60) {
            $for_body$89: while(1) { 
  
              var $117=$f_temp; //@line 1805 "compiledict.cpp"
              var $118=$gp; //@line 1805 "compiledict.cpp"
              var $arrayidx166=(($rgroup+$118*28)&4294967295); //@line 1805 "compiledict.cpp"
              var $start167=(($arrayidx166+16)&4294967295); //@line 1805 "compiledict.cpp"
              var $119=HEAP32[(($start167)>>2)]; //@line 1805 "compiledict.cpp"
              var $call168=_fseek($117, $119, 0); //@line 1805 "compiledict.cpp"
              var $120=$gp; //@line 1807 "compiledict.cpp"
              var $arrayidx169=(($rgroup+$120*28)&4294967295); //@line 1807 "compiledict.cpp"
              var $name170=(($arrayidx169)&4294967295); //@line 1807 "compiledict.cpp"
              var $arraydecay171=(($name170)&4294967295); //@line 1807 "compiledict.cpp"
              var $121=$prev_rgroup_name; //@line 1807 "compiledict.cpp"
              var $call172=_strcmp($arraydecay171, $121); //@line 1807 "compiledict.cpp"
              $different=$call172; //@line 1807 "compiledict.cpp"
              var $cmp173=((($call172))|0)!=0; //@line 1807 "compiledict.cpp"
              if ($cmp173) { __label__ = 61;; } else { __label__ = 67;; } //@line 1807 "compiledict.cpp"
              if (__label__ == 61) {
  
                var $122=$gp; //@line 1810 "compiledict.cpp"
                var $cmp175=((($122))|0) > 0; //@line 1810 "compiledict.cpp"
                if ($cmp175) { __label__ = 62;; } else { __label__ = 63;; } //@line 1810 "compiledict.cpp"
                if (__label__ == 62) {
  
                  var $123=$f_out_addr; //@line 1811 "compiledict.cpp"
                  var $call177=_fputc(7, $123); //@line 1811 "compiledict.cpp"
                  ; //@line 1811 "compiledict.cpp"
                }
  
                var $124=$f_out_addr; //@line 1812 "compiledict.cpp"
                var $call179=_fputc(6, $124); //@line 1812 "compiledict.cpp"
                var $125=$gp; //@line 1814 "compiledict.cpp"
                var $arrayidx180=(($rgroup+$125*28)&4294967295); //@line 1814 "compiledict.cpp"
                var $group3_ix181=(($arrayidx180+24)&4294967295); //@line 1814 "compiledict.cpp"
                var $126=HEAP32[(($group3_ix181)>>2)]; //@line 1814 "compiledict.cpp"
                var $cmp182=((($126))|0)!=0; //@line 1814 "compiledict.cpp"
                if ($cmp182) { __label__ = 64;; } else { __label__ = 65;; } //@line 1814 "compiledict.cpp"
                if (__label__ == 64) {
  
                  var $127=$n_groups3; //@line 1816 "compiledict.cpp"
                  var $inc184=((($127)+1)&4294967295); //@line 1816 "compiledict.cpp"
                  $n_groups3=$inc184; //@line 1816 "compiledict.cpp"
                  var $128=$f_out_addr; //@line 1817 "compiledict.cpp"
                  var $call185=_fputc(1, $128); //@line 1817 "compiledict.cpp"
                  var $129=$gp; //@line 1818 "compiledict.cpp"
                  var $arrayidx186=(($rgroup+$129*28)&4294967295); //@line 1818 "compiledict.cpp"
                  var $group3_ix187=(($arrayidx186+24)&4294967295); //@line 1818 "compiledict.cpp"
                  var $130=HEAP32[(($group3_ix187)>>2)]; //@line 1818 "compiledict.cpp"
                  var $131=$f_out_addr; //@line 1818 "compiledict.cpp"
                  var $call188=_fputc($130, $131); //@line 1818 "compiledict.cpp"
                  ; //@line 1819 "compiledict.cpp"
                }
                else if (__label__ == 65) {
  
                  var $132=$f_out_addr; //@line 1822 "compiledict.cpp"
                  var $133=$gp; //@line 1822 "compiledict.cpp"
                  var $arrayidx190=(($rgroup+$133*28)&4294967295); //@line 1822 "compiledict.cpp"
                  var $name191=(($arrayidx190)&4294967295); //@line 1822 "compiledict.cpp"
                  var $arraydecay192=(($name191)&4294967295); //@line 1822 "compiledict.cpp"
                  $prev_rgroup_name=$arraydecay192; //@line 1822 "compiledict.cpp"
                  var $fputs=_fputs($arraydecay192, $132); //@line 1822 "compiledict.cpp"
                  ;
                }
  
                var $134=$f_out_addr; //@line 1824 "compiledict.cpp"
                var $call195=_fputc(0, $134); //@line 1824 "compiledict.cpp"
                ; //@line 1825 "compiledict.cpp"
              }
  
              var $135=$gp; //@line 1827 "compiledict.cpp"
              var $arrayidx197=(($rgroup+$135*28)&4294967295); //@line 1827 "compiledict.cpp"
              var $length198=(($arrayidx197+20)&4294967295); //@line 1827 "compiledict.cpp"
              var $136=HEAP32[(($length198)>>2)]; //@line 1827 "compiledict.cpp"
              $ix=$136; //@line 1827 "compiledict.cpp"
              var $cmp2002=((($136))|0) > 0; //@line 1827 "compiledict.cpp"
              if ($cmp2002) { __label__ = 68;; } else { __label__ = 69;; } //@line 1827 "compiledict.cpp"
              $for_body201$$for_end204$101: do { 
                if (__label__ == 68) {
                  while(1) { 
  
                    var $137=$f_temp; //@line 1829 "compiledict.cpp"
                    var $call202=_fgetc($137); //@line 1829 "compiledict.cpp"
                    HEAP32[(($c)>>2)]=$call202; //@line 1829 "compiledict.cpp"
                    var $138=HEAP32[(($c)>>2)]; //@line 1830 "compiledict.cpp"
                    var $139=$f_out_addr; //@line 1830 "compiledict.cpp"
                    var $call203=_fputc($138, $139); //@line 1830 "compiledict.cpp"
                    var $140=$ix; //@line 1827 "compiledict.cpp"
                    var $dec=((($140)-1)&4294967295); //@line 1827 "compiledict.cpp"
                    $ix=$dec; //@line 1827 "compiledict.cpp"
                    var $cmp200=((($dec))|0) > 0; //@line 1827 "compiledict.cpp"
                    if ($cmp200) { __label__ = 68;continue ; } else { __label__ = 69;break $for_body201$$for_end204$101; } //@line 1827 "compiledict.cpp"
                  }
                }
              } while(0);
  
              var $141=$gp; //@line 1803 "compiledict.cpp"
              var $inc209=((($141)+1)&4294967295); //@line 1803 "compiledict.cpp"
              $gp=$inc209; //@line 1803 "compiledict.cpp"
              var $142=$gp; //@line 1803 "compiledict.cpp"
              var $143=$n_rgroups; //@line 1803 "compiledict.cpp"
              var $cmp165=((($142))|0) < ((($143))|0); //@line 1803 "compiledict.cpp"
              if ($cmp165) { __label__ = 60;continue $for_body$89; } else { __label__ = 70;break $for_body$$for_end210$88; } //@line 1803 "compiledict.cpp"
            }
          }
        } while(0);
  
        var $144=$f_out_addr; //@line 1837 "compiledict.cpp"
        var $call211=_fputc(7, $144); //@line 1837 "compiledict.cpp"
        var $145=$f_out_addr; //@line 1838 "compiledict.cpp"
        var $call212=_fputc(0, $145); //@line 1838 "compiledict.cpp"
        var $146=$f_temp; //@line 1840 "compiledict.cpp"
        var $call213=_fclose($146); //@line 1840 "compiledict.cpp"
        var $147=$fname_temp_addr; //@line 1841 "compiledict.cpp"
        var $call214=_remove($147); //@line 1841 "compiledict.cpp"
        var $148=HEAP32[((__ZL5f_log)>>2)]; //@line 1843 "compiledict.cpp"
        var $149=$count; //@line 1843 "compiledict.cpp"
        var $150=$n_rgroups; //@line 1843 "compiledict.cpp"
        var $151=$n_groups3; //@line 1843 "compiledict.cpp"
        var $call215=_fprintf($148, ((__str89)&4294967295), allocate([$149,0,0,0,$150,0,0,0,$151,0,0,0], ["i32",0,0,0,"i32",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 1843 "compiledict.cpp"
        $retval=0; //@line 1844 "compiledict.cpp"
        ; //@line 1844 "compiledict.cpp"
      }
    }
  
    STACKTOP = __stackBase__;
    return;
    return;
  }
  

  function __ZL17output_rule_groupP7__sFILEiPPcS1_($f_out, $n_rules, $rules) {
    var __stackBase__  = STACKTOP; STACKTOP += 512; _memset(__stackBase__, 0, 512);
    var __label__;
  
    var $f_out_addr;
    var $n_rules_addr;
    var $rules_addr;
    var $name_addr;
    var $ix;
    var $len1;
    var $len2;
    var $len_name;
    var $p;
    var $p2;
    var $p3;
    var $common;
    var $nextchar_count=__stackBase__;
    $f_out_addr=$f_out;
    $n_rules_addr=$n_rules;
    $rules_addr=$rules;
    $name_addr=((__ZL10group_name)&4294967295);
    var $arraydecay=(($nextchar_count)&4294967295); //@line 1480 "compiledict.cpp"
    var $0=$arraydecay; //@line 1480 "compiledict.cpp"
    var $dest$, $stop$, $stop4$, $fast$, $value4$;
    $dest$ = $0;
    $stop$ = $dest$ + 512;
    $value4$ = 0;
    if ($value4$ < 0) $value4$ += 256;
    $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
    while ($dest$%4 !== 0 && $dest$ < $stop$) {
      ;; HEAP8[$dest$++] = 0;
    }
    $dest$ >>= 2;
    $stop4$ = $stop$ >> 2;
    while ($dest$ < $stop4$) {
    ;;;;;;;  HEAP32[$dest$++] = $value4$;
    }
    $dest$ <<= 2;
    while ($dest$ < $stop$) {
      ;; HEAP8[$dest$++] = 0;
    }; //@line 1480 "compiledict.cpp"
    var $1=$name_addr; //@line 1482 "compiledict.cpp"
    var $call=_strlen($1); //@line 1482 "compiledict.cpp"
    $len_name=$call; //@line 1482 "compiledict.cpp"
    $common=((__str13643)&4294967295); //@line 1489 "compiledict.cpp"
    var $2=$rules_addr; //@line 1490 "compiledict.cpp"
    var $3=$2; //@line 1490 "compiledict.cpp"
    var $4=$n_rules_addr; //@line 1490 "compiledict.cpp"
    _qsort($3, $4, 4, 4); //@line 1490 "compiledict.cpp"
    var $5=$name_addr; //@line 1492 "compiledict.cpp"
    var $call1=_strcmp($5, ((__str103)&4294967295)); //@line 1492 "compiledict.cpp"
    var $cmp=((($call1))|0)==0; //@line 1492 "compiledict.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 1492 "compiledict.cpp"
    if (__label__ == 1) {
  
      $len_name=0; //@line 1493 "compiledict.cpp"
      ; //@line 1493 "compiledict.cpp"
    }
  
    $ix=0; //@line 1495 "compiledict.cpp"
    var $6=$ix; //@line 1495 "compiledict.cpp"
    var $7=$n_rules_addr; //@line 1495 "compiledict.cpp"
    var $cmp21=((($6))|0) < ((($7))|0); //@line 1495 "compiledict.cpp"
    if ($cmp21) { __label__ = 3;; } else { __label__ = 11;; } //@line 1495 "compiledict.cpp"
    $for_body$$for_end$5: do { 
      if (__label__ == 3) {
        $for_body$6: while(1) { 
  
          var $8=$ix; //@line 1497 "compiledict.cpp"
          var $9=$rules_addr; //@line 1497 "compiledict.cpp"
          var $arrayidx=(($9+4*$8)&4294967295); //@line 1497 "compiledict.cpp"
          var $10=HEAP32[(($arrayidx)>>2)]; //@line 1497 "compiledict.cpp"
          $p=$10; //@line 1497 "compiledict.cpp"
          var $11=$p; //@line 1498 "compiledict.cpp"
          var $call3=_strlen($11); //@line 1498 "compiledict.cpp"
          var $add=((($call3)+1)&4294967295); //@line 1498 "compiledict.cpp"
          $len1=$add; //@line 1498 "compiledict.cpp"
          var $12=$len1; //@line 1499 "compiledict.cpp"
          var $13=$p; //@line 1499 "compiledict.cpp"
          var $arrayidx4=(($13+$12)&4294967295); //@line 1499 "compiledict.cpp"
          $p3=$arrayidx4; //@line 1499 "compiledict.cpp"
          var $14=$p3; //@line 1500 "compiledict.cpp"
          var $15=$len_name; //@line 1500 "compiledict.cpp"
          var $add_ptr=(($14+$15)&4294967295); //@line 1500 "compiledict.cpp"
          $p2=$add_ptr; //@line 1500 "compiledict.cpp"
          var $16=$p2; //@line 1501 "compiledict.cpp"
          var $call5=_strlen($16); //@line 1501 "compiledict.cpp"
          $len2=$call5; //@line 1501 "compiledict.cpp"
          var $17=$p2; //@line 1503 "compiledict.cpp"
          var $arrayidx6=(($17)&4294967295); //@line 1503 "compiledict.cpp"
          var $18=HEAPU8[($arrayidx6)]; //@line 1503 "compiledict.cpp"
          var $idxprom=((($18))&255); //@line 1503 "compiledict.cpp"
          var $arrayidx7=(($nextchar_count+$idxprom*2)&4294967295); //@line 1503 "compiledict.cpp"
          var $19=HEAP16[(($arrayidx7)>>1)]; //@line 1503 "compiledict.cpp"
          var $inc=((($19)+1)&65535); //@line 1503 "compiledict.cpp"
          HEAP16[(($arrayidx7)>>1)]=$inc; //@line 1503 "compiledict.cpp"
          var $20=$common; //@line 1505 "compiledict.cpp"
          var $arrayidx8=(($20)&4294967295); //@line 1505 "compiledict.cpp"
          var $21=HEAP8[($arrayidx8)]; //@line 1505 "compiledict.cpp"
          var $conv=(tempInt=(($21)),(tempInt>=128?tempInt-256:tempInt)); //@line 1505 "compiledict.cpp"
          var $cmp9=((($conv))|0)!=0; //@line 1505 "compiledict.cpp"
          if ($cmp9) { __label__ = 4;; } else { __label__ = 6;; } //@line 1505 "compiledict.cpp"
          $land_lhs_true$$if_else$8: do { 
            if (__label__ == 4) {
  
              var $22=$p; //@line 1505 "compiledict.cpp"
              var $23=$common; //@line 1505 "compiledict.cpp"
              var $call10=_strcmp($22, $23); //@line 1505 "compiledict.cpp"
              var $cmp11=((($call10))|0)==0; //@line 1505 "compiledict.cpp"
              if (!($cmp11)) { __label__ = 6;break $land_lhs_true$$if_else$8; } //@line 1505 "compiledict.cpp"
  
              var $24=$p2; //@line 1507 "compiledict.cpp"
              var $25=$len2; //@line 1507 "compiledict.cpp"
              var $26=$f_out_addr; //@line 1507 "compiledict.cpp"
              var $call13=_fwrite($24, $25, 1, $26); //@line 1507 "compiledict.cpp"
              var $27=$f_out_addr; //@line 1508 "compiledict.cpp"
              var $call14=_fputc(0, $27); //@line 1508 "compiledict.cpp"
              __label__ = 10;break $land_lhs_true$$if_else$8; //@line 1509 "compiledict.cpp"
            }
          } while(0);
          if (__label__ == 6) {
  
            var $28=$ix; //@line 1512 "compiledict.cpp"
            var $29=$n_rules_addr; //@line 1512 "compiledict.cpp"
            var $sub=((($29)-1)&4294967295); //@line 1512 "compiledict.cpp"
            var $cmp15=((($28))|0) < ((($sub))|0); //@line 1512 "compiledict.cpp"
            if ($cmp15) { __label__ = 7;; } else { __label__ = 9;; } //@line 1512 "compiledict.cpp"
            $land_lhs_true16$$if_end24$13: do { 
              if (__label__ == 7) {
  
                var $30=$p; //@line 1512 "compiledict.cpp"
                var $31=$ix; //@line 1512 "compiledict.cpp"
                var $add17=((($31)+1)&4294967295); //@line 1512 "compiledict.cpp"
                var $32=$rules_addr; //@line 1512 "compiledict.cpp"
                var $arrayidx18=(($32+4*$add17)&4294967295); //@line 1512 "compiledict.cpp"
                var $33=HEAP32[(($arrayidx18)>>2)]; //@line 1512 "compiledict.cpp"
                var $call19=_strcmp($30, $33); //@line 1512 "compiledict.cpp"
                var $cmp20=((($call19))|0)==0; //@line 1512 "compiledict.cpp"
                if (!($cmp20)) { __label__ = 9;break $land_lhs_true16$$if_end24$13; } //@line 1512 "compiledict.cpp"
  
                var $34=$ix; //@line 1514 "compiledict.cpp"
                var $35=$rules_addr; //@line 1514 "compiledict.cpp"
                var $arrayidx22=(($35+4*$34)&4294967295); //@line 1514 "compiledict.cpp"
                var $36=HEAP32[(($arrayidx22)>>2)]; //@line 1514 "compiledict.cpp"
                $common=$36; //@line 1514 "compiledict.cpp"
                var $37=$f_out_addr; //@line 1515 "compiledict.cpp"
                var $call23=_fputc(4, $37); //@line 1515 "compiledict.cpp"
                ; //@line 1516 "compiledict.cpp"
              }
            } while(0);
  
            var $38=$p2; //@line 1518 "compiledict.cpp"
            var $39=$len2; //@line 1518 "compiledict.cpp"
            var $40=$f_out_addr; //@line 1518 "compiledict.cpp"
            var $call25=_fwrite($38, $39, 1, $40); //@line 1518 "compiledict.cpp"
            var $41=$f_out_addr; //@line 1519 "compiledict.cpp"
            var $call26=_fputc(3, $41); //@line 1519 "compiledict.cpp"
            var $42=$p; //@line 1520 "compiledict.cpp"
            var $43=$len1; //@line 1520 "compiledict.cpp"
            var $44=$f_out_addr; //@line 1520 "compiledict.cpp"
            var $call27=_fwrite($42, $43, 1, $44); //@line 1520 "compiledict.cpp"
            ;
          }
  
          var $45=$ix; //@line 1495 "compiledict.cpp"
          var $inc29=((($45)+1)&4294967295); //@line 1495 "compiledict.cpp"
          $ix=$inc29; //@line 1495 "compiledict.cpp"
          var $46=$ix; //@line 1495 "compiledict.cpp"
          var $47=$n_rules_addr; //@line 1495 "compiledict.cpp"
          var $cmp2=((($46))|0) < ((($47))|0); //@line 1495 "compiledict.cpp"
          if ($cmp2) { __label__ = 3;continue $for_body$6; } else { __label__ = 11;break $for_body$$for_end$5; } //@line 1495 "compiledict.cpp"
        }
      }
    } while(0);
  
    STACKTOP = __stackBase__;
    return; //@line 1531 "compiledict.cpp"
    return;
  }
  

  function __ZL19compile_lettergroupPcP7__sFILE($input, $f_out) {
    var __stackBase__  = STACKTOP; STACKTOP += 1000; _memset(__stackBase__, 0, 1000);
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $input_addr;
    var $f_out_addr;
    var $p;
    var $p_start;
    var $group;
    var $ix;
    var $n_items;
    var $length;
    var $max_length;
    var $items=__stackBase__;
    var $item_length=__stackBase__+800;
    $input_addr=$input;
    $f_out_addr=$f_out;
    $max_length=0; //@line 1543 "compiledict.cpp"
    var $0=$input_addr; //@line 1549 "compiledict.cpp"
    $p=$0; //@line 1549 "compiledict.cpp"
    var $1=$p; //@line 1550 "compiledict.cpp"
    var $arrayidx=(($1)&4294967295); //@line 1550 "compiledict.cpp"
    var $2=HEAP8[($arrayidx)]; //@line 1550 "compiledict.cpp"
    var $conv=(tempInt=(($2)),(tempInt>=128?tempInt-256:tempInt)); //@line 1550 "compiledict.cpp"
    var $isdigittmp=((($conv)-48)&4294967295); //@line 1550 "compiledict.cpp"
    var $isdigit=((($isdigittmp))>>>0) < 10; //@line 1550 "compiledict.cpp"
    var $call=((($isdigit))&1); //@line 1550 "compiledict.cpp"
    var $tobool=((($call))|0)!=0; //@line 1550 "compiledict.cpp"
    if ($tobool) { __label__ = 1;; } else { __label__ = 2;; } //@line 1550 "compiledict.cpp"
    $lor_lhs_false$$if_then$2: do { 
      if (__label__ == 1) {
  
        var $3=$p; //@line 1550 "compiledict.cpp"
        var $arrayidx1=(($3+1)&4294967295); //@line 1550 "compiledict.cpp"
        var $4=HEAP8[($arrayidx1)]; //@line 1550 "compiledict.cpp"
        var $conv2=(tempInt=(($4)),(tempInt>=128?tempInt-256:tempInt)); //@line 1550 "compiledict.cpp"
        var $isdigittmp1=((($conv2)-48)&4294967295); //@line 1550 "compiledict.cpp"
        var $isdigit2=((($isdigittmp1))>>>0) < 10; //@line 1550 "compiledict.cpp"
        var $call3=((($isdigit2))&1); //@line 1550 "compiledict.cpp"
        var $tobool4=((($call3))|0)!=0; //@line 1550 "compiledict.cpp"
        if (!($tobool4)) { __label__ = 2;break $lor_lhs_false$$if_then$2; } //@line 1550 "compiledict.cpp"
  
        var $8=$p; //@line 1557 "compiledict.cpp"
        var $arrayidx6=(($8)&4294967295); //@line 1557 "compiledict.cpp"
        var $call7=_atoi($arrayidx6); //@line 1557 "compiledict.cpp"
        $group=$call7; //@line 1557 "compiledict.cpp"
        var $9=$group; //@line 1558 "compiledict.cpp"
        var $cmp=((($9))|0) >= 26; //@line 1558 "compiledict.cpp"
        if ($cmp) { __label__ = 5;; } else { __label__ = 4;; } //@line 1558 "compiledict.cpp"
        if (__label__ == 5) {
  
          var $12=HEAP32[((__ZL5f_log)>>2)]; //@line 1560 "compiledict.cpp"
          var $13=HEAP32[((__ZL7linenum)>>2)]; //@line 1560 "compiledict.cpp"
          var $call9=_fprintf($12, ((__str101)&4294967295), allocate([$13,0,0,0,25,0,0,0], ["i32",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 1560 "compiledict.cpp"
          var $14=HEAP32[((__ZL11error_count)>>2)]; //@line 1561 "compiledict.cpp"
          var $inc10=((($14)+1)&4294967295); //@line 1561 "compiledict.cpp"
          HEAP32[((__ZL11error_count)>>2)]=$inc10; //@line 1561 "compiledict.cpp"
          $retval=1; //@line 1562 "compiledict.cpp"
          __label__ = 26;break $lor_lhs_false$$if_then$2; //@line 1562 "compiledict.cpp"
        }
        else if (__label__ == 4) {
  
          var $10=$p; //@line 1565 "compiledict.cpp"
          var $11=HEAP8[($10)]; //@line 1565 "compiledict.cpp"
          var $conv1210=(tempInt=(($11)),(tempInt>=128?tempInt-256:tempInt)); //@line 1565 "compiledict.cpp"
          var $call1311=__Z8isspace2j($conv1210); //@line 1565 "compiledict.cpp"
          var $tobool1412=((($call1311))|0)!=0; //@line 1565 "compiledict.cpp"
          var $lnot13=($tobool1412) ^ 1; //@line 1565 "compiledict.cpp"
          if ($lnot13) { __label__ = 6;; } else { __label__ = 7;; } //@line 1565 "compiledict.cpp"
          $while_body$$while_end$8: do { 
            if (__label__ == 6) {
              while(1) { 
  
                var $15=$p; //@line 1565 "compiledict.cpp"
                var $incdec_ptr=(($15+1)&4294967295); //@line 1565 "compiledict.cpp"
                $p=$incdec_ptr; //@line 1565 "compiledict.cpp"
                var $16=$p; //@line 1565 "compiledict.cpp"
                var $17=HEAP8[($16)]; //@line 1565 "compiledict.cpp"
                var $conv12=(tempInt=(($17)),(tempInt>=128?tempInt-256:tempInt)); //@line 1565 "compiledict.cpp"
                var $call13=__Z8isspace2j($conv12); //@line 1565 "compiledict.cpp"
                var $tobool14=((($call13))|0)!=0; //@line 1565 "compiledict.cpp"
                var $lnot=($tobool14) ^ 1; //@line 1565 "compiledict.cpp"
                if ($lnot) { __label__ = 6;continue ; } else { __label__ = 7;break $while_body$$while_end$8; } //@line 1565 "compiledict.cpp"
              }
            }
          } while(0);
  
          var $18=$f_out_addr; //@line 1567 "compiledict.cpp"
          var $call15=_fputc(6, $18); //@line 1567 "compiledict.cpp"
          var $19=$f_out_addr; //@line 1568 "compiledict.cpp"
          var $call16=_fputc(18, $19); //@line 1568 "compiledict.cpp"
          var $20=$group; //@line 1569 "compiledict.cpp"
          var $add=((($20)+65)&4294967295); //@line 1569 "compiledict.cpp"
          var $21=$f_out_addr; //@line 1569 "compiledict.cpp"
          var $call17=_fputc($add, $21); //@line 1569 "compiledict.cpp"
          var $22=$group; //@line 1570 "compiledict.cpp"
          var $arrayidx18=((__ZL19letterGroupsDefined+$22)&4294967295); //@line 1570 "compiledict.cpp"
          var $23=HEAP8[($arrayidx18)]; //@line 1570 "compiledict.cpp"
          var $conv19=(tempInt=(($23)),(tempInt>=128?tempInt-256:tempInt)); //@line 1570 "compiledict.cpp"
          var $cmp20=((($conv19))|0)!=0; //@line 1570 "compiledict.cpp"
          if ($cmp20) { __label__ = 8;; } else { __label__ = 9;; } //@line 1570 "compiledict.cpp"
          if (__label__ == 8) {
  
            var $24=HEAP32[((__ZL5f_log)>>2)]; //@line 1572 "compiledict.cpp"
            var $25=HEAP32[((__ZL7linenum)>>2)]; //@line 1572 "compiledict.cpp"
            var $26=$group; //@line 1572 "compiledict.cpp"
            var $call22=_fprintf($24, ((__str102)&4294967295), allocate([$25,0,0,0,$26,0,0,0], ["i32",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 1572 "compiledict.cpp"
            var $27=HEAP32[((__ZL11error_count)>>2)]; //@line 1573 "compiledict.cpp"
            var $inc23=((($27)+1)&4294967295); //@line 1573 "compiledict.cpp"
            HEAP32[((__ZL11error_count)>>2)]=$inc23; //@line 1573 "compiledict.cpp"
            ; //@line 1574 "compiledict.cpp"
          }
  
          var $28=$group; //@line 1575 "compiledict.cpp"
          var $arrayidx25=((__ZL19letterGroupsDefined+$28)&4294967295); //@line 1575 "compiledict.cpp"
          HEAP8[($arrayidx25)]=1; //@line 1575 "compiledict.cpp"
          $n_items=0; //@line 1577 "compiledict.cpp"
          __lastLabel__ = 9; ; //@line 1578 "compiledict.cpp"
          $while_cond26$15: while(1) { 
  
            var $29=__lastLabel__ == 18 ? $_pr : (0); //@line 1578 "compiledict.cpp"
            var $cmp27=((($29))|0) < 200; //@line 1578 "compiledict.cpp"
            if (!($cmp27)) { __label__ = 19;break $while_cond26$15; } //@line 1578 "compiledict.cpp"
  
            var $30=$p; //@line 1580 "compiledict.cpp"
            var $31=HEAP8[($30)]; //@line 1580 "compiledict.cpp"
            var $conv306=(tempInt=(($31)),(tempInt>=128?tempInt-256:tempInt)); //@line 1580 "compiledict.cpp"
            var $call317=__Z8isspace2j($conv306); //@line 1580 "compiledict.cpp"
            var $tobool328=((($call317))|0)!=0; //@line 1580 "compiledict.cpp"
            var $32=$p; //@line 1580 "compiledict.cpp"
            if ($tobool328) { __lastLabel__ = 11; __label__ = 12;; } else { __lastLabel__ = 11; __label__ = 13;; } //@line 1580 "compiledict.cpp"
            $while_body33$$while_end35$18: do { 
              if (__label__ == 12) {
                while(1) { 
  
                  var $33=__lastLabel__ == 12 ? $36 : ($32);
                  var $incdec_ptr34=(($33+1)&4294967295); //@line 1580 "compiledict.cpp"
                  $p=$incdec_ptr34; //@line 1580 "compiledict.cpp"
                  var $34=$p; //@line 1580 "compiledict.cpp"
                  var $35=HEAP8[($34)]; //@line 1580 "compiledict.cpp"
                  var $conv30=(tempInt=(($35)),(tempInt>=128?tempInt-256:tempInt)); //@line 1580 "compiledict.cpp"
                  var $call31=__Z8isspace2j($conv30); //@line 1580 "compiledict.cpp"
                  var $tobool32=((($call31))|0)!=0; //@line 1580 "compiledict.cpp"
                  var $36=$p; //@line 1580 "compiledict.cpp"
                  if ($tobool32) { __lastLabel__ = 12; __label__ = 12;continue ; } else { __lastLabel__ = 12; __label__ = 13;break $while_body33$$while_end35$18; } //@line 1580 "compiledict.cpp"
                }
              }
            } while(0);
  
            var $_lcssa=__lastLabel__ == 11 ? $32 : ($36);
            var $37=HEAP8[($_lcssa)]; //@line 1581 "compiledict.cpp"
            var $conv36=(tempInt=(($37)),(tempInt>=128?tempInt-256:tempInt)); //@line 1581 "compiledict.cpp"
            var $cmp37=((($conv36))|0)==0; //@line 1581 "compiledict.cpp"
            if ($cmp37) { __label__ = 19;break $while_cond26$15; } //@line 1581 "compiledict.cpp"
  
            var $38=$p; //@line 1584 "compiledict.cpp"
            $p_start=$38; //@line 1584 "compiledict.cpp"
            var $39=$n_items; //@line 1584 "compiledict.cpp"
            var $arrayidx40=(($items+$39*4)&4294967295); //@line 1584 "compiledict.cpp"
            HEAP32[(($arrayidx40)>>2)]=$38; //@line 1584 "compiledict.cpp"
            ; //@line 1585 "compiledict.cpp"
            while(1) { 
  
              var $40=$p; //@line 1585 "compiledict.cpp"
              var $41=HEAP8[($40)]; //@line 1585 "compiledict.cpp"
              var $conv42=(tempInt=(($41)),(tempInt>=128?tempInt-256:tempInt)); //@line 1585 "compiledict.cpp"
              var $and=($conv42) & 255; //@line 1585 "compiledict.cpp"
              var $cmp43=((($and))|0) > 32; //@line 1585 "compiledict.cpp"
              var $42=$p; //@line 1587 "compiledict.cpp"
              var $incdec_ptr45=(($42+1)&4294967295); //@line 1587 "compiledict.cpp"
              $p=$incdec_ptr45; //@line 1587 "compiledict.cpp"
              if ($cmp43) { __label__ = 15;continue ; } else { __label__ = 16;break ; } //@line 1585 "compiledict.cpp"
            }
  
            HEAP8[($42)]=0; //@line 1589 "compiledict.cpp"
            var $43=$p; //@line 1590 "compiledict.cpp"
            var $44=$p_start; //@line 1590 "compiledict.cpp"
            var $sub_ptr_lhs_cast=($43); //@line 1590 "compiledict.cpp"
            var $sub_ptr_rhs_cast=($44); //@line 1590 "compiledict.cpp"
            var $sub_ptr_sub=((($sub_ptr_lhs_cast)-($sub_ptr_rhs_cast))&4294967295); //@line 1590 "compiledict.cpp"
            $length=$sub_ptr_sub; //@line 1590 "compiledict.cpp"
            var $45=$length; //@line 1591 "compiledict.cpp"
            var $46=$max_length; //@line 1591 "compiledict.cpp"
            var $cmp48=((($45))|0) > ((($46))|0); //@line 1591 "compiledict.cpp"
            if ($cmp48) { __label__ = 17;; } else { __label__ = 18;; } //@line 1591 "compiledict.cpp"
            if (__label__ == 17) {
  
              var $47=$length; //@line 1592 "compiledict.cpp"
              $max_length=$47; //@line 1592 "compiledict.cpp"
              ; //@line 1592 "compiledict.cpp"
            }
  
            var $48=$length; //@line 1593 "compiledict.cpp"
            var $conv51=((($48)) & 255); //@line 1593 "compiledict.cpp"
            var $49=$n_items; //@line 1593 "compiledict.cpp"
            var $inc52=((($49)+1)&4294967295); //@line 1593 "compiledict.cpp"
            $n_items=$inc52; //@line 1593 "compiledict.cpp"
            var $arrayidx53=(($item_length+$49)&4294967295); //@line 1593 "compiledict.cpp"
            HEAP8[($arrayidx53)]=$conv51; //@line 1593 "compiledict.cpp"
            var $_pr=$n_items; //@line 1578 "compiledict.cpp"
            __lastLabel__ = 18; __label__ = 10;continue $while_cond26$15; //@line 1594 "compiledict.cpp"
          }
  
          var $_pr3=$max_length; //@line 1597 "compiledict.cpp"
          var $cmp565=((($_pr3))|0) > 1; //@line 1597 "compiledict.cpp"
          if ($cmp565) { __label__ = 20;; } else { __label__ = 25;; } //@line 1597 "compiledict.cpp"
          $while_body57$$while_end67$30: do { 
            if (__label__ == 20) {
              $while_body57$31: while(1) { 
  
                $ix=0; //@line 1599 "compiledict.cpp"
                var $50=$ix; //@line 1599 "compiledict.cpp"
                var $51=$n_items; //@line 1599 "compiledict.cpp"
                var $cmp584=((($50))|0) < ((($51))|0); //@line 1599 "compiledict.cpp"
                if ($cmp584) { __label__ = 21;; } else { __label__ = 24;; } //@line 1599 "compiledict.cpp"
                $for_body$$for_end$33: do { 
                  if (__label__ == 21) {
                    while(1) { 
  
                      var $52=$ix; //@line 1601 "compiledict.cpp"
                      var $arrayidx59=(($item_length+$52)&4294967295); //@line 1601 "compiledict.cpp"
                      var $53=HEAP8[($arrayidx59)]; //@line 1601 "compiledict.cpp"
                      var $conv60=(tempInt=(($53)),(tempInt>=128?tempInt-256:tempInt)); //@line 1601 "compiledict.cpp"
                      var $54=$max_length; //@line 1601 "compiledict.cpp"
                      var $cmp61=((($conv60))|0)==((($54))|0); //@line 1601 "compiledict.cpp"
                      if ($cmp61) { __label__ = 22;; } else { __label__ = 23;; } //@line 1601 "compiledict.cpp"
                      if (__label__ == 22) {
  
                        var $55=$ix; //@line 1603 "compiledict.cpp"
                        var $arrayidx63=(($items+$55*4)&4294967295); //@line 1603 "compiledict.cpp"
                        var $56=HEAP32[(($arrayidx63)>>2)]; //@line 1603 "compiledict.cpp"
                        var $57=$max_length; //@line 1603 "compiledict.cpp"
                        var $58=$f_out_addr; //@line 1603 "compiledict.cpp"
                        var $call64=_fwrite($56, 1, $57, $58); //@line 1603 "compiledict.cpp"
                        ; //@line 1604 "compiledict.cpp"
                      }
  
                      var $59=$ix; //@line 1599 "compiledict.cpp"
                      var $inc66=((($59)+1)&4294967295); //@line 1599 "compiledict.cpp"
                      $ix=$inc66; //@line 1599 "compiledict.cpp"
                      var $60=$ix; //@line 1599 "compiledict.cpp"
                      var $61=$n_items; //@line 1599 "compiledict.cpp"
                      var $cmp58=((($60))|0) < ((($61))|0); //@line 1599 "compiledict.cpp"
                      if ($cmp58) { __label__ = 21;continue ; } else { __label__ = 24;break $for_body$$for_end$33; } //@line 1599 "compiledict.cpp"
                    }
                  }
                } while(0);
  
                var $62=$max_length; //@line 1606 "compiledict.cpp"
                var $dec=((($62)-1)&4294967295); //@line 1606 "compiledict.cpp"
                $max_length=$dec; //@line 1606 "compiledict.cpp"
                var $cmp56=((($dec))|0) > 1; //@line 1597 "compiledict.cpp"
                if ($cmp56) { __label__ = 20;continue $while_body57$31; } else { __label__ = 25;break $while_body57$$while_end67$30; } //@line 1597 "compiledict.cpp"
              }
            }
          } while(0);
  
          var $63=$f_out_addr; //@line 1609 "compiledict.cpp"
          var $call68=_fputc(7, $63); //@line 1609 "compiledict.cpp"
          $retval=0; //@line 1611 "compiledict.cpp"
          __label__ = 26;break $lor_lhs_false$$if_then$2; //@line 1611 "compiledict.cpp"
        }
      }
    } while(0);
    if (__label__ == 2) {
  
      var $5=HEAP32[((__ZL5f_log)>>2)]; //@line 1552 "compiledict.cpp"
      var $6=HEAP32[((__ZL7linenum)>>2)]; //@line 1552 "compiledict.cpp"
      var $call5=_fprintf($5, ((__str100)&4294967295), allocate([$6,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 1552 "compiledict.cpp"
      var $7=HEAP32[((__ZL11error_count)>>2)]; //@line 1553 "compiledict.cpp"
      var $inc=((($7)+1)&4294967295); //@line 1553 "compiledict.cpp"
      HEAP32[((__ZL11error_count)>>2)]=$inc; //@line 1553 "compiledict.cpp"
      $retval=1; //@line 1554 "compiledict.cpp"
      ; //@line 1554 "compiledict.cpp"
    }
  
    STACKTOP = __stackBase__;
    return;
    return;
  }
  

  function __ZL12compile_rulePc($input) {
    var __stackBase__  = STACKTOP; STACKTOP += 244; _memset(__stackBase__, 0, 244);
    var __label__;
  
    var $retval;
    var $input_addr;
    var $ix;
    var $c;
    var $wc=__stackBase__;
    var $p;
    var $prule;
    var $len;
    var $len_name;
    var $start;
    var $state=__stackBase__+4;
    var $finish;
    var $pre_bracket;
    var $buf=__stackBase__+8;
    var $output=__stackBase__+88;
    var $bad_phoneme=__stackBase__+240;
    $input_addr=$input;
    HEAP32[(($state)>>2)]=2; //@line 1161 "compiledict.cpp"
    $finish=0; //@line 1162 "compiledict.cpp"
    $pre_bracket=0; //@line 1163 "compiledict.cpp"
    var $arrayidx=(($buf)&4294967295); //@line 1168 "compiledict.cpp"
    HEAP8[($arrayidx)]=0; //@line 1168 "compiledict.cpp"
    HEAP8[(((__ZL9rule_cond)&4294967295))]=0; //@line 1169 "compiledict.cpp"
    HEAP8[(((__ZL8rule_pre)&4294967295))]=0; //@line 1170 "compiledict.cpp"
    HEAP8[(((__ZL9rule_post)&4294967295))]=0; //@line 1171 "compiledict.cpp"
    HEAP8[(((__ZL10rule_match)&4294967295))]=0; //@line 1172 "compiledict.cpp"
    HEAP8[(((__ZL13rule_phonemes)&4294967295))]=0; //@line 1173 "compiledict.cpp"
    var $arraydecay=(($buf)&4294967295); //@line 1175 "compiledict.cpp"
    $p=$arraydecay; //@line 1175 "compiledict.cpp"
    $ix=0; //@line 1177 "compiledict.cpp"
    var $0=$finish; //@line 1177 "compiledict.cpp"
    var $cmp2=((($0))|0)==0; //@line 1177 "compiledict.cpp"
    if ($cmp2) { __label__ = 1;; } else { __label__ = 13;; } //@line 1177 "compiledict.cpp"
    $for_body_lr_ph$$for_end$2: do { 
      if (__label__ == 1) {
  
        var $arraydecay3=(($buf)&4294967295); //@line 1187 "compiledict.cpp"
        var $arraydecay4=(($buf)&4294967295); //@line 1188 "compiledict.cpp"
        var $arraydecay6=(($buf)&4294967295); //@line 1194 "compiledict.cpp"
        var $arraydecay7=(($buf)&4294967295); //@line 1196 "compiledict.cpp"
        var $arraydecay12=(($buf)&4294967295); //@line 1208 "compiledict.cpp"
        var $arraydecay14=(($buf)&4294967295); //@line 1215 "compiledict.cpp"
        var $arraydecay15=(($buf)&4294967295); //@line 1216 "compiledict.cpp"
        ; //@line 1177 "compiledict.cpp"
        $for_body$4: while(1) { 
  
          var $1=$ix; //@line 1179 "compiledict.cpp"
          var $2=$input_addr; //@line 1179 "compiledict.cpp"
          var $arrayidx1=(($2+$1)&4294967295); //@line 1179 "compiledict.cpp"
          var $3=HEAP8[($arrayidx1)]; //@line 1179 "compiledict.cpp"
          $c=$3; //@line 1179 "compiledict.cpp"
          var $4=$ix; //@line 1181 "compiledict.cpp"
          var $5=$input_addr; //@line 1181 "compiledict.cpp"
          var $arrayidx2=(($5+$4)&4294967295); //@line 1181 "compiledict.cpp"
          var $6=HEAPU8[($arrayidx2)]; //@line 1181 "compiledict.cpp"
          $c=$6; //@line 1181 "compiledict.cpp"
          var $conv=((($6))&255); //@line 1181 "compiledict.cpp"
          if ($conv == 41) {
            __label__ = 3;;
          }
          else if ($conv == 40) {
            __label__ = 4;;
          }
          else if ($conv == 10) {
            __label__ = 6;break $for_body$4;
          }
          else if ($conv == 13) {
            __label__ = 6;break $for_body$4;
          }
          else if ($conv == 0) {
            __label__ = 6;break $for_body$4;
          }
          else if ($conv == 9) {
            __label__ = 7;;
          }
          else if ($conv == 32) {
            __label__ = 7;;
          }
          else if ($conv == 63) {
            __label__ = 8;;
          }
          else {
          __label__ = 11;;
          }
          
          $sw_default$$sw_bb$$sw_bb5$$sw_bb13$$sw_bb16$6: do { 
            if (__label__ == 11) {
  
              var $21=$c; //@line 1227 "compiledict.cpp"
              var $22=$p; //@line 1227 "compiledict.cpp"
              var $incdec_ptr20=(($22+1)&4294967295); //@line 1227 "compiledict.cpp"
              $p=$incdec_ptr20; //@line 1227 "compiledict.cpp"
              HEAP8[($22)]=$21; //@line 1227 "compiledict.cpp"
              ; //@line 1228 "compiledict.cpp"
            }
            else if (__label__ == 3) {
  
              var $7=$p; //@line 1184 "compiledict.cpp"
              HEAP8[($7)]=0; //@line 1184 "compiledict.cpp"
              HEAP32[(($state)>>2)]=1; //@line 1185 "compiledict.cpp"
              $pre_bracket=1; //@line 1186 "compiledict.cpp"
              __ZL16copy_rule_stringPcRi($arraydecay3, $state); //@line 1187 "compiledict.cpp"
              $p=$arraydecay4; //@line 1188 "compiledict.cpp"
              ; //@line 1189 "compiledict.cpp"
            }
            else if (__label__ == 4) {
  
              var $8=$p; //@line 1192 "compiledict.cpp"
              HEAP8[($8)]=0; //@line 1192 "compiledict.cpp"
              HEAP32[(($state)>>2)]=2; //@line 1193 "compiledict.cpp"
              __ZL16copy_rule_stringPcRi($arraydecay6, $state); //@line 1194 "compiledict.cpp"
              HEAP32[(($state)>>2)]=3; //@line 1195 "compiledict.cpp"
              $p=$arraydecay7; //@line 1196 "compiledict.cpp"
              var $9=$ix; //@line 1197 "compiledict.cpp"
              var $add=((($9)+1)&4294967295); //@line 1197 "compiledict.cpp"
              var $10=$input_addr; //@line 1197 "compiledict.cpp"
              var $arrayidx8=(($10+$add)&4294967295); //@line 1197 "compiledict.cpp"
              var $11=HEAP8[($arrayidx8)]; //@line 1197 "compiledict.cpp"
              var $conv9=(tempInt=(($11)),(tempInt>=128?tempInt-256:tempInt)); //@line 1197 "compiledict.cpp"
              var $cmp10=((($conv9))|0)==32; //@line 1197 "compiledict.cpp"
              if (!($cmp10)) { __label__ = 12;break $sw_default$$sw_bb$$sw_bb5$$sw_bb13$$sw_bb16$6; } //@line 1197 "compiledict.cpp"
  
              var $12=HEAP32[((__ZL5f_log)>>2)]; //@line 1199 "compiledict.cpp"
              var $13=HEAP32[((__ZL7linenum)>>2)]; //@line 1199 "compiledict.cpp"
              var $call=_fprintf($12, ((__str90)&4294967295), allocate([$13,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 1199 "compiledict.cpp"
              var $14=HEAP32[((__ZL11error_count)>>2)]; //@line 1200 "compiledict.cpp"
              var $inc=((($14)+1)&4294967295); //@line 1200 "compiledict.cpp"
              HEAP32[((__ZL11error_count)>>2)]=$inc; //@line 1200 "compiledict.cpp"
              ; //@line 1201 "compiledict.cpp"
            }
            else if (__label__ == 7) {
  
              var $17=$p; //@line 1214 "compiledict.cpp"
              HEAP8[($17)]=0; //@line 1214 "compiledict.cpp"
              __ZL16copy_rule_stringPcRi($arraydecay14, $state); //@line 1215 "compiledict.cpp"
              $p=$arraydecay15; //@line 1216 "compiledict.cpp"
              ; //@line 1217 "compiledict.cpp"
            }
            else if (__label__ == 8) {
  
              var $18=HEAP32[(($state)>>2)]; //@line 1220 "compiledict.cpp"
              var $cmp17=((($18))|0)==2; //@line 1220 "compiledict.cpp"
              if ($cmp17) { __label__ = 9;; } else { __label__ = 10;; } //@line 1220 "compiledict.cpp"
              if (__label__ == 9) {
  
                HEAP32[(($state)>>2)]=0; //@line 1221 "compiledict.cpp"
                ; //@line 1221 "compiledict.cpp"
              }
              else if (__label__ == 10) {
  
                var $19=$c; //@line 1223 "compiledict.cpp"
                var $20=$p; //@line 1223 "compiledict.cpp"
                var $incdec_ptr=(($20+1)&4294967295); //@line 1223 "compiledict.cpp"
                $p=$incdec_ptr; //@line 1223 "compiledict.cpp"
                HEAP8[($20)]=$19; //@line 1223 "compiledict.cpp"
                ;
              }
            }
          } while(0);
  
          var $_pr=$finish; //@line 1177 "compiledict.cpp"
          var $23=$ix; //@line 1177 "compiledict.cpp"
          var $inc21=((($23)+1)&4294967295); //@line 1177 "compiledict.cpp"
          $ix=$inc21; //@line 1177 "compiledict.cpp"
          var $cmp=((($_pr))|0)==0; //@line 1177 "compiledict.cpp"
          if ($cmp) { __label__ = 2;continue $for_body$4; } else { __label__ = 13;break $for_body_lr_ph$$for_end$2; } //@line 1177 "compiledict.cpp"
        }
  
        var $15=$p; //@line 1207 "compiledict.cpp"
        HEAP8[($15)]=0; //@line 1207 "compiledict.cpp"
        __ZL16copy_rule_stringPcRi($arraydecay12, $state); //@line 1208 "compiledict.cpp"
        $finish=1; //@line 1209 "compiledict.cpp"
        var $16=$ix; //@line 1177 "compiledict.cpp"
        var $inc213=((($16)+1)&4294967295); //@line 1177 "compiledict.cpp"
        $ix=$inc213; //@line 1177 "compiledict.cpp"
        ; //@line 1177 "compiledict.cpp"
      }
    } while(0);
  
    var $call22=_strcmp(((__ZL10rule_match)&4294967295), ((__str91)&4294967295)); //@line 1232 "compiledict.cpp"
    var $cmp23=((($call22))|0)==0; //@line 1232 "compiledict.cpp"
    if ($cmp23) { __label__ = 14;; } else { __label__ = 15;; } //@line 1232 "compiledict.cpp"
    if (__label__ == 14) {
  
      var $call25=_strcpy(((__ZL10rule_match)&4294967295), ((__ZL10group_name)&4294967295)); //@line 1233 "compiledict.cpp"
      ; //@line 1233 "compiledict.cpp"
    }
  
    var $24=HEAP8[(((__ZL10rule_match)&4294967295))]; //@line 1235 "compiledict.cpp"
    var $conv27=(tempInt=(($24)),(tempInt>=128?tempInt-256:tempInt)); //@line 1235 "compiledict.cpp"
    var $cmp28=((($conv27))|0)==0; //@line 1235 "compiledict.cpp"
    if ($cmp28) { __label__ = 16;; } else { __label__ = 19;; } //@line 1235 "compiledict.cpp"
    if (__label__ == 16) {
  
      var $25=HEAP8[(((__ZL9rule_post)&4294967295))]; //@line 1237 "compiledict.cpp"
      var $conv30=(tempInt=(($25)),(tempInt>=128?tempInt-256:tempInt)); //@line 1237 "compiledict.cpp"
      var $cmp31=((($conv30))|0)!=0; //@line 1237 "compiledict.cpp"
      if ($cmp31) { __label__ = 17;; } else { __label__ = 18;; } //@line 1237 "compiledict.cpp"
      if (__label__ == 17) {
  
        var $26=HEAP32[((__ZL5f_log)>>2)]; //@line 1239 "compiledict.cpp"
        var $27=HEAP32[((__ZL7linenum)>>2)]; //@line 1239 "compiledict.cpp"
        var $call33=_fprintf($26, ((__str92)&4294967295), allocate([$27,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 1239 "compiledict.cpp"
        var $28=HEAP32[((__ZL11error_count)>>2)]; //@line 1240 "compiledict.cpp"
        var $inc34=((($28)+1)&4294967295); //@line 1240 "compiledict.cpp"
        HEAP32[((__ZL11error_count)>>2)]=$inc34; //@line 1240 "compiledict.cpp"
        ; //@line 1241 "compiledict.cpp"
      }
  
      $retval=0; //@line 1242 "compiledict.cpp"
      ; //@line 1242 "compiledict.cpp"
    }
    else if (__label__ == 19) {
  
      var $arraydecay37=(($buf)&4294967295); //@line 1245 "compiledict.cpp"
      var $arraydecay38=(($bad_phoneme)&4294967295); //@line 1245 "compiledict.cpp"
      var $call39=__Z14EncodePhonemesPcS_Ph(((__ZL13rule_phonemes)&4294967295), $arraydecay37, $arraydecay38); //@line 1245 "compiledict.cpp"
      var $arrayidx40=(($bad_phoneme)&4294967295); //@line 1246 "compiledict.cpp"
      var $29=HEAPU8[($arrayidx40)]; //@line 1246 "compiledict.cpp"
      var $conv41=((($29))&255); //@line 1246 "compiledict.cpp"
      var $cmp42=((($conv41))|0)!=0; //@line 1246 "compiledict.cpp"
      if ($cmp42) { __label__ = 20;; } else { __label__ = 21;; } //@line 1246 "compiledict.cpp"
      if (__label__ == 20) {
  
        var $30=HEAP32[((__ZL5f_log)>>2)]; //@line 1248 "compiledict.cpp"
        var $31=HEAP32[((__ZL7linenum)>>2)]; //@line 1248 "compiledict.cpp"
        var $arrayidx44=(($bad_phoneme)&4294967295); //@line 1248 "compiledict.cpp"
        var $32=HEAPU8[($arrayidx44)]; //@line 1248 "compiledict.cpp"
        var $conv45=((($32))&255); //@line 1248 "compiledict.cpp"
        var $33=$input_addr; //@line 1248 "compiledict.cpp"
        var $call46=_fprintf($30, ((__str93)&4294967295), allocate([$31,0,0,0,$conv45,0,0,0,$33,0,0,0], ["i32",0,0,0,"i32",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 1248 "compiledict.cpp"
        var $34=HEAP32[((__ZL11error_count)>>2)]; //@line 1249 "compiledict.cpp"
        var $inc47=((($34)+1)&4294967295); //@line 1249 "compiledict.cpp"
        HEAP32[((__ZL11error_count)>>2)]=$inc47; //@line 1249 "compiledict.cpp"
        ; //@line 1250 "compiledict.cpp"
      }
  
      var $arraydecay49=(($output)&4294967295); //@line 1251 "compiledict.cpp"
      var $arraydecay50=(($buf)&4294967295); //@line 1251 "compiledict.cpp"
      var $call51=_strcpy($arraydecay49, $arraydecay50); //@line 1251 "compiledict.cpp"
      var $arraydecay52=(($buf)&4294967295); //@line 1252 "compiledict.cpp"
      var $call53=_strlen($arraydecay52); //@line 1252 "compiledict.cpp"
      var $add54=((($call53)+1)&4294967295); //@line 1252 "compiledict.cpp"
      $len=$add54; //@line 1252 "compiledict.cpp"
      var $call55=_strlen(((__ZL10group_name)&4294967295)); //@line 1254 "compiledict.cpp"
      $len_name=$call55; //@line 1254 "compiledict.cpp"
      var $cmp56=((($call55))|0) > 0; //@line 1255 "compiledict.cpp"
      if ($cmp56) { __label__ = 22;; } else { __label__ = 26;; } //@line 1255 "compiledict.cpp"
      $land_lhs_true$$if_end70$31: do { 
        if (__label__ == 22) {
  
          var $35=$len_name; //@line 1255 "compiledict.cpp"
          var $call57=_memcmp(((__ZL10rule_match)&4294967295), ((__ZL10group_name)&4294967295), $35); //@line 1255 "compiledict.cpp"
          var $cmp58=((($call57))|0)!=0; //@line 1255 "compiledict.cpp"
          if (!($cmp58)) { __label__ = 26;break $land_lhs_true$$if_end70$31; } //@line 1255 "compiledict.cpp"
  
          var $call60=__Z7utf8_inPiPKc($wc, ((__ZL10rule_match)&4294967295)); //@line 1257 "compiledict.cpp"
          var $36=HEAP8[(((__ZL10group_name)&4294967295))]; //@line 1258 "compiledict.cpp"
          var $conv61=(tempInt=(($36)),(tempInt>=128?tempInt-256:tempInt)); //@line 1258 "compiledict.cpp"
          var $cmp62=((($conv61))|0)==57; //@line 1258 "compiledict.cpp"
          if ($cmp62) { __label__ = 24;; } else { __label__ = 25;; } //@line 1258 "compiledict.cpp"
          if (__label__ == 24) {
  
            var $37=HEAP32[(($wc)>>2)]; //@line 1258 "compiledict.cpp"
            var $call64=__Z7IsDigitj($37); //@line 1258 "compiledict.cpp"
            var $tobool=((($call64))|0)!=0; //@line 1258 "compiledict.cpp"
            if ($tobool) { __label__ = 26;break $land_lhs_true$$if_end70$31; } //@line 1258 "compiledict.cpp"
          }
  
          var $38=HEAP32[((__ZL5f_log)>>2)]; //@line 1264 "compiledict.cpp"
          var $39=HEAP32[((__ZL7linenum)>>2)]; //@line 1264 "compiledict.cpp"
          var $call67=_fprintf($38, ((__str94)&4294967295), allocate([$39,0,0,0,((__ZL10rule_match)&4294967295),0,0,0,((__ZL10group_name)&4294967295),0,0,0], ["i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 1264 "compiledict.cpp"
          var $40=HEAP32[((__ZL11error_count)>>2)]; //@line 1265 "compiledict.cpp"
          var $inc68=((($40)+1)&4294967295); //@line 1265 "compiledict.cpp"
          HEAP32[((__ZL11error_count)>>2)]=$inc68; //@line 1265 "compiledict.cpp"
          ;
        }
      } while(0);
  
      var $41=$len; //@line 1268 "compiledict.cpp"
      var $arrayidx71=(($output+$41)&4294967295); //@line 1268 "compiledict.cpp"
      var $call72=_strcpy($arrayidx71, ((__ZL10rule_match)&4294967295)); //@line 1268 "compiledict.cpp"
      var $call73=_strlen(((__ZL10rule_match)&4294967295)); //@line 1269 "compiledict.cpp"
      var $42=$len; //@line 1269 "compiledict.cpp"
      var $add74=((($42)+($call73))&4294967295); //@line 1269 "compiledict.cpp"
      $len=$add74; //@line 1269 "compiledict.cpp"
      var $43=HEAP32[((__ZL10debug_flag)>>2)]; //@line 1271 "compiledict.cpp"
      var $tobool75=((($43))|0)!=0; //@line 1271 "compiledict.cpp"
      if ($tobool75) { __label__ = 27;; } else { __label__ = 28;; } //@line 1271 "compiledict.cpp"
      if (__label__ == 27) {
  
        var $44=$len; //@line 1273 "compiledict.cpp"
        var $arrayidx77=(($output+$44)&4294967295); //@line 1273 "compiledict.cpp"
        HEAP8[($arrayidx77)]=9; //@line 1273 "compiledict.cpp"
        var $45=HEAP32[((__ZL7linenum)>>2)]; //@line 1274 "compiledict.cpp"
        var $rem=((($45))|0)%255; //@line 1274 "compiledict.cpp"
        var $add78=((($rem)+1)&4294967295); //@line 1274 "compiledict.cpp"
        var $conv79=((($add78)) & 255); //@line 1274 "compiledict.cpp"
        var $46=$len; //@line 1274 "compiledict.cpp"
        var $add80=((($46)+1)&4294967295); //@line 1274 "compiledict.cpp"
        var $arrayidx81=(($output+$add80)&4294967295); //@line 1274 "compiledict.cpp"
        HEAP8[($arrayidx81)]=$conv79; //@line 1274 "compiledict.cpp"
        var $47=HEAP32[((__ZL7linenum)>>2)]; //@line 1275 "compiledict.cpp"
        var $div=((((($47))|0)/255)|0); //@line 1275 "compiledict.cpp"
        var $add82=((($div)+1)&4294967295); //@line 1275 "compiledict.cpp"
        var $conv83=((($add82)) & 255); //@line 1275 "compiledict.cpp"
        var $48=$len; //@line 1275 "compiledict.cpp"
        var $add84=((($48)+2)&4294967295); //@line 1275 "compiledict.cpp"
        var $arrayidx85=(($output+$add84)&4294967295); //@line 1275 "compiledict.cpp"
        HEAP8[($arrayidx85)]=$conv83; //@line 1275 "compiledict.cpp"
        var $49=$len; //@line 1276 "compiledict.cpp"
        var $add86=((($49)+3)&4294967295); //@line 1276 "compiledict.cpp"
        $len=$add86; //@line 1276 "compiledict.cpp"
        ; //@line 1277 "compiledict.cpp"
      }
  
      var $50=HEAP8[(((__ZL9rule_cond)&4294967295))]; //@line 1279 "compiledict.cpp"
      var $conv88=(tempInt=(($50)),(tempInt>=128?tempInt-256:tempInt)); //@line 1279 "compiledict.cpp"
      var $cmp89=((($conv88))|0)!=0; //@line 1279 "compiledict.cpp"
      if ($cmp89) { __label__ = 29;; } else { __label__ = 35;; } //@line 1279 "compiledict.cpp"
      if (__label__ == 29) {
  
        $ix=-1; //@line 1281 "compiledict.cpp"
        var $51=HEAP8[(((__ZL9rule_cond)&4294967295))]; //@line 1282 "compiledict.cpp"
        var $conv91=(tempInt=(($51)),(tempInt>=128?tempInt-256:tempInt)); //@line 1282 "compiledict.cpp"
        var $cmp92=((($conv91))|0)==33; //@line 1282 "compiledict.cpp"
        if ($cmp92) { __label__ = 30;; } else { __label__ = 31;; } //@line 1282 "compiledict.cpp"
        if (__label__ == 30) {
  
          var $call94=_atoi(((__ZL9rule_cond+1)&4294967295)); //@line 1285 "compiledict.cpp"
          var $add95=((($call94)+32)&4294967295); //@line 1285 "compiledict.cpp"
          $ix=$add95; //@line 1285 "compiledict.cpp"
          ; //@line 1286 "compiledict.cpp"
        }
        else if (__label__ == 31) {
  
          var $call97=_atoi(((__ZL9rule_cond)&4294967295)); //@line 1290 "compiledict.cpp"
          $ix=$call97; //@line 1290 "compiledict.cpp"
          ;
        }
  
        var $52=$ix; //@line 1293 "compiledict.cpp"
        var $cmp99=((($52))|0) > 0; //@line 1293 "compiledict.cpp"
        var $53=$ix; //@line 1293 "compiledict.cpp"
        var $cmp101=((($53))|0) < 255; //@line 1293 "compiledict.cpp"
        var $or_cond=($cmp99) & ($cmp101); //@line 1293 "compiledict.cpp"
        if ($or_cond) { __label__ = 33;; } else { __label__ = 34;; } //@line 1293 "compiledict.cpp"
        if (__label__ == 33) {
  
          var $54=$len; //@line 1295 "compiledict.cpp"
          var $inc103=((($54)+1)&4294967295); //@line 1295 "compiledict.cpp"
          $len=$inc103; //@line 1295 "compiledict.cpp"
          var $arrayidx104=(($output+$54)&4294967295); //@line 1295 "compiledict.cpp"
          HEAP8[($arrayidx104)]=5; //@line 1295 "compiledict.cpp"
          var $55=$ix; //@line 1296 "compiledict.cpp"
          var $conv105=((($55)) & 255); //@line 1296 "compiledict.cpp"
          var $56=$len; //@line 1296 "compiledict.cpp"
          var $inc106=((($56)+1)&4294967295); //@line 1296 "compiledict.cpp"
          $len=$inc106; //@line 1296 "compiledict.cpp"
          var $arrayidx107=(($output+$56)&4294967295); //@line 1296 "compiledict.cpp"
          HEAP8[($arrayidx107)]=$conv105; //@line 1296 "compiledict.cpp"
          ; //@line 1297 "compiledict.cpp"
        }
        else if (__label__ == 34) {
  
          var $57=HEAP32[((__ZL5f_log)>>2)]; //@line 1300 "compiledict.cpp"
          var $58=HEAP32[((__ZL7linenum)>>2)]; //@line 1300 "compiledict.cpp"
          var $59=$ix; //@line 1300 "compiledict.cpp"
          var $call109=_fprintf($57, ((__str95)&4294967295), allocate([$58,0,0,0,$59,0,0,0], ["i32",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 1300 "compiledict.cpp"
          var $60=HEAP32[((__ZL11error_count)>>2)]; //@line 1301 "compiledict.cpp"
          var $inc110=((($60)+1)&4294967295); //@line 1301 "compiledict.cpp"
          HEAP32[((__ZL11error_count)>>2)]=$inc110; //@line 1301 "compiledict.cpp"
          ;
        }
      }
  
      var $61=HEAP8[(((__ZL8rule_pre)&4294967295))]; //@line 1304 "compiledict.cpp"
      var $conv113=(tempInt=(($61)),(tempInt>=128?tempInt-256:tempInt)); //@line 1304 "compiledict.cpp"
      var $cmp114=((($conv113))|0)!=0; //@line 1304 "compiledict.cpp"
      if ($cmp114) { __label__ = 36;; } else { __label__ = 41;; } //@line 1304 "compiledict.cpp"
      $if_then115$$if_end132$51: do { 
        if (__label__ == 36) {
  
          $start=0; //@line 1306 "compiledict.cpp"
          var $62=HEAP8[(((__ZL8rule_pre)&4294967295))]; //@line 1307 "compiledict.cpp"
          var $conv116=(tempInt=(($62)),(tempInt>=128?tempInt-256:tempInt)); //@line 1307 "compiledict.cpp"
          var $cmp117=((($conv116))|0)==32; //@line 1307 "compiledict.cpp"
          if ($cmp117) { __label__ = 37;; } else { __label__ = 38;; } //@line 1307 "compiledict.cpp"
          if (__label__ == 37) {
  
            $c=8; //@line 1310 "compiledict.cpp"
            $start=1; //@line 1311 "compiledict.cpp"
            ; //@line 1312 "compiledict.cpp"
          }
          else if (__label__ == 38) {
  
            $c=1; //@line 1315 "compiledict.cpp"
            ;
          }
  
          var $63=$c; //@line 1317 "compiledict.cpp"
          var $64=$len; //@line 1317 "compiledict.cpp"
          var $inc121=((($64)+1)&4294967295); //@line 1317 "compiledict.cpp"
          $len=$inc121; //@line 1317 "compiledict.cpp"
          var $arrayidx122=(($output+$64)&4294967295); //@line 1317 "compiledict.cpp"
          HEAP8[($arrayidx122)]=$63; //@line 1317 "compiledict.cpp"
          var $call123=_strlen(((__ZL8rule_pre)&4294967295)); //@line 1320 "compiledict.cpp"
          var $sub=((($call123)-1)&4294967295); //@line 1320 "compiledict.cpp"
          $ix=$sub; //@line 1320 "compiledict.cpp"
          var $65=$ix; //@line 1320 "compiledict.cpp"
          var $66=$start; //@line 1320 "compiledict.cpp"
          var $cmp1251=((($65))|0) >= ((($66))|0); //@line 1320 "compiledict.cpp"
          if (!($cmp1251)) { __label__ = 41;break $if_then115$$if_end132$51; } //@line 1320 "compiledict.cpp"
          while(1) { 
  
            var $67=$ix; //@line 1321 "compiledict.cpp"
            var $arrayidx127=((__ZL8rule_pre+$67)&4294967295); //@line 1321 "compiledict.cpp"
            var $68=HEAP8[($arrayidx127)]; //@line 1321 "compiledict.cpp"
            var $69=$len; //@line 1321 "compiledict.cpp"
            var $inc128=((($69)+1)&4294967295); //@line 1321 "compiledict.cpp"
            $len=$inc128; //@line 1321 "compiledict.cpp"
            var $arrayidx129=(($output+$69)&4294967295); //@line 1321 "compiledict.cpp"
            HEAP8[($arrayidx129)]=$68; //@line 1321 "compiledict.cpp"
            var $70=$ix; //@line 1320 "compiledict.cpp"
            var $dec=((($70)-1)&4294967295); //@line 1320 "compiledict.cpp"
            $ix=$dec; //@line 1320 "compiledict.cpp"
            var $71=$ix; //@line 1320 "compiledict.cpp"
            var $72=$start; //@line 1320 "compiledict.cpp"
            var $cmp125=((($71))|0) >= ((($72))|0); //@line 1320 "compiledict.cpp"
            if ($cmp125) { __label__ = 40;continue ; } else { __label__ = 41;break $if_then115$$if_end132$51; } //@line 1320 "compiledict.cpp"
          }
        }
      } while(0);
  
      var $73=HEAP8[(((__ZL9rule_post)&4294967295))]; //@line 1324 "compiledict.cpp"
      var $conv133=(tempInt=(($73)),(tempInt>=128?tempInt-256:tempInt)); //@line 1324 "compiledict.cpp"
      var $cmp134=((($conv133))|0)!=0; //@line 1324 "compiledict.cpp"
      if ($cmp134) { __label__ = 42;; } else { __label__ = 43;; } //@line 1324 "compiledict.cpp"
      if (__label__ == 42) {
  
        var $74=$len; //@line 1326 "compiledict.cpp"
        var $arrayidx136=(($output+$74)&4294967295); //@line 1326 "compiledict.cpp"
        var $call137=_sprintf($arrayidx136, ((__str70722)&4294967295), allocate([2,0,0,0,((__ZL9rule_post)&4294967295),0,0,0], ["i32",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 1326 "compiledict.cpp"
        var $call138=_strlen(((__ZL9rule_post)&4294967295)); //@line 1327 "compiledict.cpp"
        var $75=$len; //@line 1327 "compiledict.cpp"
        var $add139=((($call138)+1)&4294967295); //@line 1327 "compiledict.cpp"
        var $add140=((($add139)+($75))&4294967295); //@line 1327 "compiledict.cpp"
        $len=$add140; //@line 1327 "compiledict.cpp"
        ; //@line 1328 "compiledict.cpp"
      }
  
      var $76=$len; //@line 1329 "compiledict.cpp"
      var $inc142=((($76)+1)&4294967295); //@line 1329 "compiledict.cpp"
      $len=$inc142; //@line 1329 "compiledict.cpp"
      var $arrayidx143=(($output+$76)&4294967295); //@line 1329 "compiledict.cpp"
      HEAP8[($arrayidx143)]=0; //@line 1329 "compiledict.cpp"
      var $77=$len; //@line 1330 "compiledict.cpp"
      var $call144=_malloc($77); //@line 1330 "compiledict.cpp"
      $prule=$call144; //@line 1330 "compiledict.cpp"
      var $78=$prule; //@line 1331 "compiledict.cpp"
      var $arraydecay145=(($output)&4294967295); //@line 1331 "compiledict.cpp"
      var $79=$len; //@line 1331 "compiledict.cpp"
      var $src$, $dest$, $stop$, $stop4$, $fast$;
      $src$ = $arraydecay145;
      $dest$ = $78;
      $stop$ = $src$ + $79;
      if (($dest$%4) == ($src$%4) && $79 > 8) {
        while ($src$%4 !== 0 && $src$ < $stop$) {
          ; HEAP8[$dest$++] = HEAP8[$src$++];
        }
        $src$ >>= 2;
        $dest$ >>= 2;
        $stop4$ = $stop$ >> 2;
        while ($src$ < $stop4$) {
      ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
        }
        $src$ <<= 2;
        $dest$ <<= 2;
      }while ($src$ < $stop$) {
        ; HEAP8[$dest$++] = HEAP8[$src$++];
      }; //@line 1331 "compiledict.cpp"
      var $80=$prule; //@line 1332 "compiledict.cpp"
      $retval=$80; //@line 1332 "compiledict.cpp"
      ; //@line 1332 "compiledict.cpp"
    }
  
    var $81=$retval; //@line 1333 "compiledict.cpp"
    STACKTOP = __stackBase__;
    return $81; //@line 1333 "compiledict.cpp"
    return null;
  }
  

  function __ZL13rgroup_sorterP6RGROUPS0_($a, $b) {
    ;
    var __label__;
  
    var $retval;
    var $a_addr;
    var $b_addr;
    var $ix;
    $a_addr=$a;
    $b_addr=$b;
    var $0=$b_addr; //@line 1353 "compiledict.cpp"
    var $name=(($0)&4294967295); //@line 1353 "compiledict.cpp"
    var $arraydecay=(($name)&4294967295); //@line 1353 "compiledict.cpp"
    var $call=_strlen($arraydecay); //@line 1353 "compiledict.cpp"
    var $1=$a_addr; //@line 1353 "compiledict.cpp"
    var $name1=(($1)&4294967295); //@line 1353 "compiledict.cpp"
    var $arraydecay2=(($name1)&4294967295); //@line 1353 "compiledict.cpp"
    var $call3=_strlen($arraydecay2); //@line 1353 "compiledict.cpp"
    var $sub=((($call)-($call3))&4294967295); //@line 1353 "compiledict.cpp"
    $ix=$sub; //@line 1353 "compiledict.cpp"
    var $2=$ix; //@line 1354 "compiledict.cpp"
    var $cmp=((($2))|0)!=0; //@line 1354 "compiledict.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 1354 "compiledict.cpp"
    if (__label__ == 1) {
  
      var $3=$ix; //@line 1354 "compiledict.cpp"
      $retval=$3; //@line 1354 "compiledict.cpp"
      ; //@line 1354 "compiledict.cpp"
    }
    else if (__label__ == 2) {
  
      var $4=$a_addr; //@line 1355 "compiledict.cpp"
      var $name4=(($4)&4294967295); //@line 1355 "compiledict.cpp"
      var $arraydecay5=(($name4)&4294967295); //@line 1355 "compiledict.cpp"
      var $5=$b_addr; //@line 1355 "compiledict.cpp"
      var $name6=(($5)&4294967295); //@line 1355 "compiledict.cpp"
      var $arraydecay7=(($name6)&4294967295); //@line 1355 "compiledict.cpp"
      var $call8=_strcmp($arraydecay5, $arraydecay7); //@line 1355 "compiledict.cpp"
      $ix=$call8; //@line 1355 "compiledict.cpp"
      var $6=$ix; //@line 1356 "compiledict.cpp"
      var $cmp9=((($6))|0)!=0; //@line 1356 "compiledict.cpp"
      if ($cmp9) { __label__ = 3;; } else { __label__ = 4;; } //@line 1356 "compiledict.cpp"
      if (__label__ == 3) {
  
        var $7=$ix; //@line 1356 "compiledict.cpp"
        $retval=$7; //@line 1356 "compiledict.cpp"
        ; //@line 1356 "compiledict.cpp"
      }
      else if (__label__ == 4) {
  
        var $8=$a_addr; //@line 1357 "compiledict.cpp"
        var $start=(($8+16)&4294967295); //@line 1357 "compiledict.cpp"
        var $9=HEAP32[(($start)>>2)]; //@line 1357 "compiledict.cpp"
        var $10=$b_addr; //@line 1357 "compiledict.cpp"
        var $start12=(($10+16)&4294967295); //@line 1357 "compiledict.cpp"
        var $11=HEAP32[(($start12)>>2)]; //@line 1357 "compiledict.cpp"
        var $sub13=((($9)-($11))&4294967295); //@line 1357 "compiledict.cpp"
        $retval=$sub13; //@line 1357 "compiledict.cpp"
        ; //@line 1357 "compiledict.cpp"
      }
    }
  
    var $12=$retval; //@line 1358 "compiledict.cpp"
    ;
    return $12; //@line 1358 "compiledict.cpp"
    return null;
  }
  

  function __ZL16copy_rule_stringPcRi($string, $state) {
    ;
    var __label__;
  
    var $string_addr;
    var $state_addr;
    var $output;
    var $p;
    var $ix;
    var $len;
    var $c;
    var $sxflags;
    var $value;
    var $literal;
    var $mr;
    $string_addr=$string;
    $state_addr=$state;
    var $0=$string_addr; //@line 930 "compiledict.cpp"
    var $arrayidx=(($0)&4294967295); //@line 930 "compiledict.cpp"
    var $1=HEAP8[($arrayidx)]; //@line 930 "compiledict.cpp"
    var $conv=(tempInt=(($1)),(tempInt>=128?tempInt-256:tempInt)); //@line 930 "compiledict.cpp"
    var $cmp=((($conv))|0)==0; //@line 930 "compiledict.cpp"
    if ($cmp) { __label__ = 75;; } else { __label__ = 1;; } //@line 930 "compiledict.cpp"
    if (__label__ == 1) {
  
      var $2=$state_addr; //@line 932 "compiledict.cpp"
      var $3=HEAP32[(($2)>>2)]; //@line 932 "compiledict.cpp"
      var $arrayidx1=((__ZZL16copy_rule_stringPcRiE6outbuf+$3*4)&4294967295); //@line 932 "compiledict.cpp"
      var $4=HEAP32[(($arrayidx1)>>2)]; //@line 932 "compiledict.cpp"
      $output=$4; //@line 932 "compiledict.cpp"
      var $5=$state_addr; //@line 933 "compiledict.cpp"
      var $6=HEAP32[(($5)>>2)]; //@line 933 "compiledict.cpp"
      var $cmp2=((($6))|0)==4; //@line 933 "compiledict.cpp"
      if ($cmp2) { __label__ = 2;; } else { __label__ = 5;; } //@line 933 "compiledict.cpp"
      if (__label__ == 2) {
  
        var $call=_strlen(((__ZL13rule_phonemes)&4294967295)); //@line 936 "compiledict.cpp"
        $len=$call; //@line 936 "compiledict.cpp"
        var $7=$len; //@line 937 "compiledict.cpp"
        var $cmp4=((($7))|0) > 0; //@line 937 "compiledict.cpp"
        if ($cmp4) { __label__ = 3;; } else { __label__ = 4;; } //@line 937 "compiledict.cpp"
        if (__label__ == 3) {
  
          var $8=$len; //@line 938 "compiledict.cpp"
          var $inc=((($8)+1)&4294967295); //@line 938 "compiledict.cpp"
          $len=$inc; //@line 938 "compiledict.cpp"
          var $arrayidx6=((__ZL13rule_phonemes+$8)&4294967295); //@line 938 "compiledict.cpp"
          HEAP8[($arrayidx6)]=32; //@line 938 "compiledict.cpp"
          ; //@line 938 "compiledict.cpp"
        }
  
        var $9=$len; //@line 939 "compiledict.cpp"
        var $arrayidx8=((__ZL13rule_phonemes+$9)&4294967295); //@line 939 "compiledict.cpp"
        $output=$arrayidx8; //@line 939 "compiledict.cpp"
        ; //@line 940 "compiledict.cpp"
      }
  
      $sxflags=8421376; //@line 941 "compiledict.cpp"
      var $10=$string_addr; //@line 943 "compiledict.cpp"
      $p=$10; //@line 943 "compiledict.cpp"
      $ix=0; //@line 943 "compiledict.cpp"
      ; //@line 943 "compiledict.cpp"
      $for_cond$10: while(1) { 
  
        $literal=0; //@line 945 "compiledict.cpp"
        var $11=$p; //@line 946 "compiledict.cpp"
        var $incdec_ptr=(($11+1)&4294967295); //@line 946 "compiledict.cpp"
        $p=$incdec_ptr; //@line 946 "compiledict.cpp"
        var $12=HEAP8[($11)]; //@line 946 "compiledict.cpp"
        $c=$12; //@line 946 "compiledict.cpp"
        var $13=$c; //@line 947 "compiledict.cpp"
        var $conv10=(tempInt=(($13)),(tempInt>=128?tempInt-256:tempInt)); //@line 947 "compiledict.cpp"
        var $cmp11=((($conv10))|0)==92; //@line 947 "compiledict.cpp"
        if ($cmp11) { __label__ = 7;; } else { __label__ = 15;; } //@line 947 "compiledict.cpp"
        if (__label__ == 7) {
  
          var $14=$p; //@line 949 "compiledict.cpp"
          var $incdec_ptr13=(($14+1)&4294967295); //@line 949 "compiledict.cpp"
          $p=$incdec_ptr13; //@line 949 "compiledict.cpp"
          var $15=HEAP8[($14)]; //@line 949 "compiledict.cpp"
          $c=$15; //@line 949 "compiledict.cpp"
          var $16=$c; //@line 950 "compiledict.cpp"
          var $conv14=(tempInt=(($16)),(tempInt>=128?tempInt-256:tempInt)); //@line 950 "compiledict.cpp"
          var $cmp15=((($conv14))|0) >= 48; //@line 950 "compiledict.cpp"
          if ($cmp15) { __label__ = 8;; } else { __label__ = 14;; } //@line 950 "compiledict.cpp"
          $land_lhs_true$$if_end45$14: do { 
            if (__label__ == 8) {
  
              var $17=$c; //@line 950 "compiledict.cpp"
              var $conv16=(tempInt=(($17)),(tempInt>=128?tempInt-256:tempInt)); //@line 950 "compiledict.cpp"
              var $cmp17=((($conv16))|0) <= 51; //@line 950 "compiledict.cpp"
              if (!($cmp17)) { __label__ = 14;break $land_lhs_true$$if_end45$14; } //@line 950 "compiledict.cpp"
  
              var $18=$p; //@line 950 "compiledict.cpp"
              var $arrayidx19=(($18)&4294967295); //@line 950 "compiledict.cpp"
              var $19=HEAP8[($arrayidx19)]; //@line 950 "compiledict.cpp"
              var $conv20=(tempInt=(($19)),(tempInt>=128?tempInt-256:tempInt)); //@line 950 "compiledict.cpp"
              var $cmp21=((($conv20))|0) >= 48; //@line 950 "compiledict.cpp"
              if (!($cmp21)) { __label__ = 14;break $land_lhs_true$$if_end45$14; } //@line 950 "compiledict.cpp"
  
              var $20=$p; //@line 950 "compiledict.cpp"
              var $arrayidx23=(($20)&4294967295); //@line 950 "compiledict.cpp"
              var $21=HEAP8[($arrayidx23)]; //@line 950 "compiledict.cpp"
              var $conv24=(tempInt=(($21)),(tempInt>=128?tempInt-256:tempInt)); //@line 950 "compiledict.cpp"
              var $cmp25=((($conv24))|0) <= 55; //@line 950 "compiledict.cpp"
              if (!($cmp25)) { __label__ = 14;break $land_lhs_true$$if_end45$14; } //@line 950 "compiledict.cpp"
  
              var $22=$p; //@line 950 "compiledict.cpp"
              var $arrayidx27=(($22+1)&4294967295); //@line 950 "compiledict.cpp"
              var $23=HEAP8[($arrayidx27)]; //@line 950 "compiledict.cpp"
              var $conv28=(tempInt=(($23)),(tempInt>=128?tempInt-256:tempInt)); //@line 950 "compiledict.cpp"
              var $cmp29=((($conv28))|0) >= 48; //@line 950 "compiledict.cpp"
              if (!($cmp29)) { __label__ = 14;break $land_lhs_true$$if_end45$14; } //@line 950 "compiledict.cpp"
  
              var $24=$p; //@line 950 "compiledict.cpp"
              var $arrayidx31=(($24+1)&4294967295); //@line 950 "compiledict.cpp"
              var $25=HEAP8[($arrayidx31)]; //@line 950 "compiledict.cpp"
              var $conv32=(tempInt=(($25)),(tempInt>=128?tempInt-256:tempInt)); //@line 950 "compiledict.cpp"
              var $cmp33=((($conv32))|0) <= 55; //@line 950 "compiledict.cpp"
              if (!($cmp33)) { __label__ = 14;break $land_lhs_true$$if_end45$14; } //@line 950 "compiledict.cpp"
  
              var $26=$c; //@line 953 "compiledict.cpp"
              var $conv35=(tempInt=(($26)),(tempInt>=128?tempInt-256:tempInt)); //@line 953 "compiledict.cpp"
              var $sub=((($conv35)-48)&4294967295); //@line 953 "compiledict.cpp"
              var $mul=((($sub)*64)&4294967295); //@line 953 "compiledict.cpp"
              var $27=$p; //@line 953 "compiledict.cpp"
              var $arrayidx36=(($27)&4294967295); //@line 953 "compiledict.cpp"
              var $28=HEAP8[($arrayidx36)]; //@line 953 "compiledict.cpp"
              var $conv37=(tempInt=(($28)),(tempInt>=128?tempInt-256:tempInt)); //@line 953 "compiledict.cpp"
              var $sub38=((($conv37)-48)&4294967295); //@line 953 "compiledict.cpp"
              var $mul39=((($sub38)*8)&4294967295); //@line 953 "compiledict.cpp"
              var $29=$p; //@line 953 "compiledict.cpp"
              var $arrayidx40=(($29+1)&4294967295); //@line 953 "compiledict.cpp"
              var $30=HEAP8[($arrayidx40)]; //@line 953 "compiledict.cpp"
              var $conv41=(tempInt=(($30)),(tempInt>=128?tempInt-256:tempInt)); //@line 953 "compiledict.cpp"
              var $add=((($mul)-48)&4294967295); //@line 953 "compiledict.cpp"
              var $sub42=((($add)+($conv41))&4294967295); //@line 953 "compiledict.cpp"
              var $add43=((($sub42)+($mul39))&4294967295); //@line 953 "compiledict.cpp"
              var $conv44=((($add43)) & 255); //@line 953 "compiledict.cpp"
              $c=$conv44; //@line 953 "compiledict.cpp"
              var $31=$p; //@line 954 "compiledict.cpp"
              var $add_ptr=(($31+2)&4294967295); //@line 954 "compiledict.cpp"
              $p=$add_ptr; //@line 954 "compiledict.cpp"
              ; //@line 955 "compiledict.cpp"
            }
          } while(0);
  
          $literal=1; //@line 956 "compiledict.cpp"
          ; //@line 957 "compiledict.cpp"
        }
  
        var $32=$state_addr; //@line 959 "compiledict.cpp"
        var $33=HEAP32[(($32)>>2)]; //@line 959 "compiledict.cpp"
        var $cmp47=((($33))|0)==1; //@line 959 "compiledict.cpp"
        if ($cmp47) { __label__ = 17;; } else { __label__ = 16;; } //@line 959 "compiledict.cpp"
        $if_then49$$lor_lhs_false$23: do { 
          if (__label__ == 16) {
  
            var $34=$state_addr; //@line 959 "compiledict.cpp"
            var $35=HEAP32[(($34)>>2)]; //@line 959 "compiledict.cpp"
            var $cmp48=((($35))|0)==3; //@line 959 "compiledict.cpp"
            if ($cmp48) { __label__ = 17;break $if_then49$$lor_lhs_false$23; } else { __label__ = 73;break $if_then49$$lor_lhs_false$23; } //@line 959 "compiledict.cpp"
          }
        } while(0);
        $if_then49$$if_end212$25: do { 
          if (__label__ == 17) {
  
            var $36=$literal; //@line 962 "compiledict.cpp"
            var $cmp50=((($36))|0)==0; //@line 962 "compiledict.cpp"
            if (!($cmp50)) { __label__ = 73;break $if_then49$$if_end212$25; } //@line 962 "compiledict.cpp"
  
            var $37=$c; //@line 965 "compiledict.cpp"
            var $conv52=(tempInt=(($37)),(tempInt>=128?tempInt-256:tempInt)); //@line 965 "compiledict.cpp"
            if ($conv52 == 95) {
              __label__ = 19;;
            }
            else if ($conv52 == 89) {
              __label__ = 20;;
            }
            else if ($conv52 == 65) {
              __label__ = 21;;
            }
            else if ($conv52 == 66) {
              __label__ = 21;;
            }
            else if ($conv52 == 67) {
              __label__ = 21;;
            }
            else if ($conv52 == 72) {
              __label__ = 21;;
            }
            else if ($conv52 == 70) {
              __label__ = 21;;
            }
            else if ($conv52 == 71) {
              __label__ = 21;;
            }
            else if ($conv52 == 68) {
              __label__ = 24;;
            }
            else if ($conv52 == 75) {
              __label__ = 25;;
            }
            else if ($conv52 == 78) {
              __label__ = 26;;
            }
            else if ($conv52 == 86) {
              __label__ = 27;;
            }
            else if ($conv52 == 90) {
              __label__ = 28;;
            }
            else if ($conv52 == 43) {
              __label__ = 29;;
            }
            else if ($conv52 == 64) {
              __label__ = 30;;
            }
            else if ($conv52 == 38) {
              __label__ = 31;;
            }
            else if ($conv52 == 37) {
              __label__ = 32;;
            }
            else if ($conv52 == 35) {
              __label__ = 33;;
            }
            else if ($conv52 == 33) {
              __label__ = 34;;
            }
            else if ($conv52 == 84) {
              __label__ = 35;;
            }
            else if ($conv52 == 87) {
              __label__ = 36;;
            }
            else if ($conv52 == 88) {
              __label__ = 37;;
            }
            else if ($conv52 == 74) {
              __label__ = 38;;
            }
            else if ($conv52 == 76) {
              __label__ = 39;;
            }
            else if ($conv52 == 36) {
              __label__ = 48;;
            }
            else if ($conv52 == 80) {
              __label__ = 55;;
            }
            else if ($conv52 == 83) {
              __label__ = 56;;
            }
            else {
            __label__ = 73;break $if_then49$$if_end212$25;
            }
            
            $sw_bb$$sw_bb53$$sw_bb54$$sw_bb74$$sw_bb75$$sw_bb76$$sw_bb77$$sw_bb78$$sw_bb79$$sw_bb80$$sw_bb81$$sw_bb82$$sw_bb83$$sw_bb84$$sw_bb85$$sw_bb88$$sw_bb89$$sw_bb90$$sw_bb91$$sw_bb137$$sw_bb158$$sw_bb159$28: do { 
              if (__label__ == 19) {
  
                $c=32; //@line 968 "compiledict.cpp"
                __label__ = 73;break $if_then49$$if_end212$25; //@line 969 "compiledict.cpp"
              }
              else if (__label__ == 20) {
  
                $c=73; //@line 972 "compiledict.cpp"
                __label__ = 21;break $sw_bb$$sw_bb53$$sw_bb54$$sw_bb74$$sw_bb75$$sw_bb76$$sw_bb77$$sw_bb78$$sw_bb79$$sw_bb80$$sw_bb81$$sw_bb82$$sw_bb83$$sw_bb84$$sw_bb85$$sw_bb88$$sw_bb89$$sw_bb90$$sw_bb91$$sw_bb137$$sw_bb158$$sw_bb159$28; //@line 972 "compiledict.cpp"
              }
              else if (__label__ == 24) {
  
                $c=15; //@line 992 "compiledict.cpp"
                __label__ = 73;break $if_then49$$if_end212$25; //@line 993 "compiledict.cpp"
              }
              else if (__label__ == 25) {
  
                $c=25; //@line 995 "compiledict.cpp"
                __label__ = 73;break $if_then49$$if_end212$25; //@line 996 "compiledict.cpp"
              }
              else if (__label__ == 26) {
  
                $c=24; //@line 998 "compiledict.cpp"
                __label__ = 73;break $if_then49$$if_end212$25; //@line 999 "compiledict.cpp"
              }
              else if (__label__ == 27) {
  
                $c=26; //@line 1001 "compiledict.cpp"
                __label__ = 73;break $if_then49$$if_end212$25; //@line 1002 "compiledict.cpp"
              }
              else if (__label__ == 28) {
  
                $c=16; //@line 1004 "compiledict.cpp"
                __label__ = 73;break $if_then49$$if_end212$25; //@line 1005 "compiledict.cpp"
              }
              else if (__label__ == 29) {
  
                $c=12; //@line 1007 "compiledict.cpp"
                __label__ = 73;break $if_then49$$if_end212$25; //@line 1008 "compiledict.cpp"
              }
              else if (__label__ == 30) {
  
                $c=21; //@line 1010 "compiledict.cpp"
                __label__ = 73;break $if_then49$$if_end212$25; //@line 1011 "compiledict.cpp"
              }
              else if (__label__ == 31) {
  
                $c=10; //@line 1013 "compiledict.cpp"
                __label__ = 73;break $if_then49$$if_end212$25; //@line 1014 "compiledict.cpp"
              }
              else if (__label__ == 32) {
  
                $c=11; //@line 1016 "compiledict.cpp"
                __label__ = 73;break $if_then49$$if_end212$25; //@line 1017 "compiledict.cpp"
              }
              else if (__label__ == 33) {
  
                $c=13; //@line 1019 "compiledict.cpp"
                __label__ = 73;break $if_then49$$if_end212$25; //@line 1020 "compiledict.cpp"
              }
              else if (__label__ == 34) {
  
                $c=19; //@line 1022 "compiledict.cpp"
                __label__ = 73;break $if_then49$$if_end212$25; //@line 1023 "compiledict.cpp"
              }
              else if (__label__ == 35) {
  
                var $48=$ix; //@line 1025 "compiledict.cpp"
                var $inc86=((($48)+1)&4294967295); //@line 1025 "compiledict.cpp"
                $ix=$inc86; //@line 1025 "compiledict.cpp"
                var $49=$output; //@line 1025 "compiledict.cpp"
                var $arrayidx87=(($49+$48)&4294967295); //@line 1025 "compiledict.cpp"
                HEAP8[($arrayidx87)]=28; //@line 1025 "compiledict.cpp"
                $c=17; //@line 1026 "compiledict.cpp"
                __label__ = 73;break $if_then49$$if_end212$25; //@line 1027 "compiledict.cpp"
              }
              else if (__label__ == 36) {
  
                $c=31; //@line 1029 "compiledict.cpp"
                __label__ = 73;break $if_then49$$if_end212$25; //@line 1030 "compiledict.cpp"
              }
              else if (__label__ == 37) {
  
                $c=29; //@line 1032 "compiledict.cpp"
                __label__ = 73;break $if_then49$$if_end212$25; //@line 1033 "compiledict.cpp"
              }
              else if (__label__ == 38) {
  
                $c=23; //@line 1035 "compiledict.cpp"
                __label__ = 73;break $if_then49$$if_end212$25; //@line 1036 "compiledict.cpp"
              }
              else if (__label__ == 39) {
  
                var $50=$p; //@line 1039 "compiledict.cpp"
                var $incdec_ptr92=(($50+1)&4294967295); //@line 1039 "compiledict.cpp"
                $p=$incdec_ptr92; //@line 1039 "compiledict.cpp"
                var $51=HEAP8[($50)]; //@line 1039 "compiledict.cpp"
                var $conv93=(tempInt=(($51)),(tempInt>=128?tempInt-256:tempInt)); //@line 1039 "compiledict.cpp"
                var $sub94=((($conv93)-48)&4294967295); //@line 1039 "compiledict.cpp"
                var $conv95=((($sub94)) & 255); //@line 1039 "compiledict.cpp"
                $c=$conv95; //@line 1039 "compiledict.cpp"
                var $52=$p; //@line 1040 "compiledict.cpp"
                var $incdec_ptr96=(($52+1)&4294967295); //@line 1040 "compiledict.cpp"
                $p=$incdec_ptr96; //@line 1040 "compiledict.cpp"
                var $53=HEAP8[($52)]; //@line 1040 "compiledict.cpp"
                var $conv97=(tempInt=(($53)),(tempInt>=128?tempInt-256:tempInt)); //@line 1040 "compiledict.cpp"
                var $sub98=((($conv97)-48)&4294967295); //@line 1040 "compiledict.cpp"
                $value=$sub98; //@line 1040 "compiledict.cpp"
                var $54=$c; //@line 1041 "compiledict.cpp"
                var $conv99=(tempInt=(($54)),(tempInt>=128?tempInt-256:tempInt)); //@line 1041 "compiledict.cpp"
                var $mul100=((($conv99)*10)&4294967295); //@line 1041 "compiledict.cpp"
                var $55=$value; //@line 1041 "compiledict.cpp"
                var $add101=((($mul100)+($55))&4294967295); //@line 1041 "compiledict.cpp"
                var $conv102=((($add101)) & 255); //@line 1041 "compiledict.cpp"
                $c=$conv102; //@line 1041 "compiledict.cpp"
                var $56=$value; //@line 1042 "compiledict.cpp"
                var $cmp103=((($56))|0) < 0; //@line 1042 "compiledict.cpp"
                var $57=$value; //@line 1042 "compiledict.cpp"
                var $cmp105=((($57))|0) > 9; //@line 1042 "compiledict.cpp"
                var $or_cond=($cmp103) | ($cmp105); //@line 1042 "compiledict.cpp"
                if ($or_cond) { __label__ = 40;; } else { __label__ = 41;; } //@line 1042 "compiledict.cpp"
                $if_then106$$if_else109$47: do { 
                  if (__label__ == 40) {
  
                    $c=0; //@line 1044 "compiledict.cpp"
                    var $58=HEAP32[((__ZL5f_log)>>2)]; //@line 1045 "compiledict.cpp"
                    var $59=HEAP32[((__ZL7linenum)>>2)]; //@line 1045 "compiledict.cpp"
                    var $call107=_fprintf($58, ((__str97)&4294967295), allocate([$59,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 1045 "compiledict.cpp"
                    var $60=HEAP32[((__ZL11error_count)>>2)]; //@line 1046 "compiledict.cpp"
                    var $inc108=((($60)+1)&4294967295); //@line 1046 "compiledict.cpp"
                    HEAP32[((__ZL11error_count)>>2)]=$inc108; //@line 1046 "compiledict.cpp"
                    ; //@line 1047 "compiledict.cpp"
                  }
                  else if (__label__ == 41) {
  
                    var $61=$c; //@line 1049 "compiledict.cpp"
                    var $conv110=(tempInt=(($61)),(tempInt>=128?tempInt-256:tempInt)); //@line 1049 "compiledict.cpp"
                    var $cmp111=((($conv110))|0) <= 0; //@line 1049 "compiledict.cpp"
                    if ($cmp111) { __label__ = 44;; } else { __label__ = 42;; } //@line 1049 "compiledict.cpp"
                    $if_then120$$lor_lhs_false112$50: do { 
                      if (__label__ == 42) {
  
                        var $62=$c; //@line 1049 "compiledict.cpp"
                        var $conv113=(tempInt=(($62)),(tempInt>=128?tempInt-256:tempInt)); //@line 1049 "compiledict.cpp"
                        var $cmp114=((($conv113))|0) >= 26; //@line 1049 "compiledict.cpp"
                        if ($cmp114) { __label__ = 44;break $if_then120$$lor_lhs_false112$50; } //@line 1049 "compiledict.cpp"
  
                        var $63=$c; //@line 1049 "compiledict.cpp"
                        var $conv116=(tempInt=(($63)),(tempInt>=128?tempInt-256:tempInt)); //@line 1049 "compiledict.cpp"
                        var $arrayidx117=((__ZL19letterGroupsDefined+$conv116)&4294967295); //@line 1049 "compiledict.cpp"
                        var $64=HEAP8[($arrayidx117)]; //@line 1049 "compiledict.cpp"
                        var $conv118=(tempInt=(($64)),(tempInt>=128?tempInt-256:tempInt)); //@line 1049 "compiledict.cpp"
                        var $cmp119=((($conv118))|0)==0; //@line 1049 "compiledict.cpp"
                        if (!($cmp119)) { __label__ = 45;break $if_then106$$if_else109$47; } //@line 1049 "compiledict.cpp"
                      }
                    } while(0);
  
                    var $65=HEAP32[((__ZL5f_log)>>2)]; //@line 1051 "compiledict.cpp"
                    var $66=HEAP32[((__ZL7linenum)>>2)]; //@line 1051 "compiledict.cpp"
                    var $67=$c; //@line 1051 "compiledict.cpp"
                    var $conv121=(tempInt=(($67)),(tempInt>=128?tempInt-256:tempInt)); //@line 1051 "compiledict.cpp"
                    var $call122=_fprintf($65, ((__str98)&4294967295), allocate([$66,0,0,0,$conv121,0,0,0], ["i32",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 1051 "compiledict.cpp"
                    var $68=HEAP32[((__ZL11error_count)>>2)]; //@line 1052 "compiledict.cpp"
                    var $inc123=((($68)+1)&4294967295); //@line 1052 "compiledict.cpp"
                    HEAP32[((__ZL11error_count)>>2)]=$inc123; //@line 1052 "compiledict.cpp"
                    ; //@line 1053 "compiledict.cpp"
                  }
                } while(0);
  
                var $69=$c; //@line 1054 "compiledict.cpp"
                var $conv126=(tempInt=(($69)),(tempInt>=128?tempInt-256:tempInt)); //@line 1054 "compiledict.cpp"
                var $add127=((($conv126)+65)&4294967295); //@line 1054 "compiledict.cpp"
                var $conv128=((($add127)) & 255); //@line 1054 "compiledict.cpp"
                $c=$conv128; //@line 1054 "compiledict.cpp"
                var $70=$state_addr; //@line 1055 "compiledict.cpp"
                var $71=HEAP32[(($70)>>2)]; //@line 1055 "compiledict.cpp"
                var $cmp129=((($71))|0)==1; //@line 1055 "compiledict.cpp"
                if ($cmp129) { __label__ = 46;; } else { __label__ = 47;; } //@line 1055 "compiledict.cpp"
                if (__label__ == 46) {
  
                  var $72=$c; //@line 1058 "compiledict.cpp"
                  var $73=$ix; //@line 1058 "compiledict.cpp"
                  var $inc131=((($73)+1)&4294967295); //@line 1058 "compiledict.cpp"
                  $ix=$inc131; //@line 1058 "compiledict.cpp"
                  var $74=$output; //@line 1058 "compiledict.cpp"
                  var $arrayidx132=(($74+$73)&4294967295); //@line 1058 "compiledict.cpp"
                  HEAP8[($arrayidx132)]=$72; //@line 1058 "compiledict.cpp"
                  $c=18; //@line 1059 "compiledict.cpp"
                  __label__ = 73;break $if_then49$$if_end212$25; //@line 1060 "compiledict.cpp"
                }
                else if (__label__ == 47) {
  
                  var $75=$ix; //@line 1063 "compiledict.cpp"
                  var $inc134=((($75)+1)&4294967295); //@line 1063 "compiledict.cpp"
                  $ix=$inc134; //@line 1063 "compiledict.cpp"
                  var $76=$output; //@line 1063 "compiledict.cpp"
                  var $arrayidx135=(($76+$75)&4294967295); //@line 1063 "compiledict.cpp"
                  HEAP8[($arrayidx135)]=18; //@line 1063 "compiledict.cpp"
                  __label__ = 73;break $if_then49$$if_end212$25;
                }
              }
              else if (__label__ == 48) {
  
                var $77=$ix; //@line 1068 "compiledict.cpp"
                var $inc138=((($77)+1)&4294967295); //@line 1068 "compiledict.cpp"
                $ix=$inc138; //@line 1068 "compiledict.cpp"
                var $78=$output; //@line 1068 "compiledict.cpp"
                var $arrayidx139=(($78+$77)&4294967295); //@line 1068 "compiledict.cpp"
                HEAP8[($arrayidx139)]=28; //@line 1068 "compiledict.cpp"
                $c=0; //@line 1069 "compiledict.cpp"
                $mr=((_mnem_rules)&4294967295); //@line 1070 "compiledict.cpp"
                ; //@line 1071 "compiledict.cpp"
                while(1) { 
  
                  var $79=$mr; //@line 1071 "compiledict.cpp"
                  var $mnem=(($79)&4294967295); //@line 1071 "compiledict.cpp"
                  var $80=HEAP32[(($mnem)>>2)]; //@line 1071 "compiledict.cpp"
                  var $cmp140=((($80))|0)!=0; //@line 1071 "compiledict.cpp"
                  if (!($cmp140)) { __label__ = 53;break ; } //@line 1071 "compiledict.cpp"
  
                  var $81=$mr; //@line 1073 "compiledict.cpp"
                  var $mnem141=(($81)&4294967295); //@line 1073 "compiledict.cpp"
                  var $82=HEAP32[(($mnem141)>>2)]; //@line 1073 "compiledict.cpp"
                  var $call142=_strlen($82); //@line 1073 "compiledict.cpp"
                  $len=$call142; //@line 1073 "compiledict.cpp"
                  var $83=$p; //@line 1074 "compiledict.cpp"
                  var $84=$mr; //@line 1074 "compiledict.cpp"
                  var $mnem143=(($84)&4294967295); //@line 1074 "compiledict.cpp"
                  var $85=HEAP32[(($mnem143)>>2)]; //@line 1074 "compiledict.cpp"
                  var $86=$len; //@line 1074 "compiledict.cpp"
                  var $call144=_memcmp($83, $85, $86); //@line 1074 "compiledict.cpp"
                  var $cmp145=((($call144))|0)==0; //@line 1074 "compiledict.cpp"
                  var $87=$mr; //@line 1076 "compiledict.cpp"
                  if ($cmp145) { __label__ = 51;break ; } //@line 1074 "compiledict.cpp"
  
                  var $incdec_ptr151=(($87+8)&4294967295); //@line 1080 "compiledict.cpp"
                  $mr=$incdec_ptr151; //@line 1080 "compiledict.cpp"
                  __label__ = 49;continue ; //@line 1081 "compiledict.cpp"
                }
                if (__label__ == 51) {
  
                  var $value147=(($87+4)&4294967295); //@line 1076 "compiledict.cpp"
                  var $88=HEAP32[(($value147)>>2)]; //@line 1076 "compiledict.cpp"
                  var $conv148=((($88)) & 255); //@line 1076 "compiledict.cpp"
                  $c=$conv148; //@line 1076 "compiledict.cpp"
                  var $89=$len; //@line 1077 "compiledict.cpp"
                  var $90=$p; //@line 1077 "compiledict.cpp"
                  var $add_ptr149=(($90+$89)&4294967295); //@line 1077 "compiledict.cpp"
                  $p=$add_ptr149; //@line 1077 "compiledict.cpp"
                  ; //@line 1078 "compiledict.cpp"
                }
  
                var $91=$c; //@line 1082 "compiledict.cpp"
                var $conv152=(tempInt=(($91)),(tempInt>=128?tempInt-256:tempInt)); //@line 1082 "compiledict.cpp"
                var $cmp153=((($conv152))|0)==0; //@line 1082 "compiledict.cpp"
                if (!($cmp153)) { __label__ = 73;break $if_then49$$if_end212$25; } //@line 1082 "compiledict.cpp"
  
                var $92=HEAP32[((__ZL5f_log)>>2)]; //@line 1084 "compiledict.cpp"
                var $93=HEAP32[((__ZL7linenum)>>2)]; //@line 1084 "compiledict.cpp"
                var $call155=_fprintf($92, ((__str99)&4294967295), allocate([$93,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 1084 "compiledict.cpp"
                var $94=HEAP32[((__ZL11error_count)>>2)]; //@line 1085 "compiledict.cpp"
                var $inc156=((($94)+1)&4294967295); //@line 1085 "compiledict.cpp"
                HEAP32[((__ZL11error_count)>>2)]=$inc156; //@line 1085 "compiledict.cpp"
                __label__ = 73;break $if_then49$$if_end212$25; //@line 1086 "compiledict.cpp"
              }
              else if (__label__ == 55) {
  
                var $95=$sxflags; //@line 1090 "compiledict.cpp"
                var $or=($95) | 1024; //@line 1090 "compiledict.cpp"
                $sxflags=$or; //@line 1090 "compiledict.cpp"
                __label__ = 56;break $sw_bb$$sw_bb53$$sw_bb54$$sw_bb74$$sw_bb75$$sw_bb76$$sw_bb77$$sw_bb78$$sw_bb79$$sw_bb80$$sw_bb81$$sw_bb82$$sw_bb83$$sw_bb84$$sw_bb85$$sw_bb88$$sw_bb89$$sw_bb90$$sw_bb91$$sw_bb137$$sw_bb158$$sw_bb159$28; //@line 1090 "compiledict.cpp"
              }
            } while(0);
            if (__label__ == 21) {
  
              var $38=$state_addr; //@line 979 "compiledict.cpp"
              var $39=HEAP32[(($38)>>2)]; //@line 979 "compiledict.cpp"
              var $cmp55=((($39))|0)==1; //@line 979 "compiledict.cpp"
              if ($cmp55) { __label__ = 22;; } else { __label__ = 23;; } //@line 979 "compiledict.cpp"
              if (__label__ == 22) {
  
                var $40=$c; //@line 982 "compiledict.cpp"
                var $conv57=(tempInt=(($40)),(tempInt>=128?tempInt-256:tempInt)); //@line 982 "compiledict.cpp"
                var $sub58=((($conv57)-65)&4294967295); //@line 982 "compiledict.cpp"
                var $arrayidx59=((__ZZL16copy_rule_stringPcRiE16lettergp_letters+$sub58)&4294967295); //@line 982 "compiledict.cpp"
                var $41=HEAP8[($arrayidx59)]; //@line 982 "compiledict.cpp"
                var $conv60=(tempInt=(($41)),(tempInt>=128?tempInt-256:tempInt)); //@line 982 "compiledict.cpp"
                var $add61=((($conv60)+65)&4294967295); //@line 982 "compiledict.cpp"
                var $conv62=((($add61)) & 255); //@line 982 "compiledict.cpp"
                var $42=$ix; //@line 982 "compiledict.cpp"
                var $inc63=((($42)+1)&4294967295); //@line 982 "compiledict.cpp"
                $ix=$inc63; //@line 982 "compiledict.cpp"
                var $43=$output; //@line 982 "compiledict.cpp"
                var $arrayidx64=(($43+$42)&4294967295); //@line 982 "compiledict.cpp"
                HEAP8[($arrayidx64)]=$conv62; //@line 982 "compiledict.cpp"
                $c=17; //@line 983 "compiledict.cpp"
                ; //@line 984 "compiledict.cpp"
              }
              else if (__label__ == 23) {
  
                var $44=$ix; //@line 987 "compiledict.cpp"
                var $inc65=((($44)+1)&4294967295); //@line 987 "compiledict.cpp"
                $ix=$inc65; //@line 987 "compiledict.cpp"
                var $45=$output; //@line 987 "compiledict.cpp"
                var $arrayidx66=(($45+$44)&4294967295); //@line 987 "compiledict.cpp"
                HEAP8[($arrayidx66)]=17; //@line 987 "compiledict.cpp"
                var $46=$c; //@line 988 "compiledict.cpp"
                var $conv67=(tempInt=(($46)),(tempInt>=128?tempInt-256:tempInt)); //@line 988 "compiledict.cpp"
                var $sub68=((($conv67)-65)&4294967295); //@line 988 "compiledict.cpp"
                var $arrayidx69=((__ZZL16copy_rule_stringPcRiE16lettergp_letters+$sub68)&4294967295); //@line 988 "compiledict.cpp"
                var $47=HEAP8[($arrayidx69)]; //@line 988 "compiledict.cpp"
                var $conv70=(tempInt=(($47)),(tempInt>=128?tempInt-256:tempInt)); //@line 988 "compiledict.cpp"
                var $add71=((($conv70)+65)&4294967295); //@line 988 "compiledict.cpp"
                var $conv72=((($add71)) & 255); //@line 988 "compiledict.cpp"
                $c=$conv72; //@line 988 "compiledict.cpp"
                ;
              }
            }
            else if (__label__ == 56) {
  
              var $96=$ix; //@line 1092 "compiledict.cpp"
              var $inc160=((($96)+1)&4294967295); //@line 1092 "compiledict.cpp"
              $ix=$inc160; //@line 1092 "compiledict.cpp"
              var $97=$output; //@line 1092 "compiledict.cpp"
              var $arrayidx161=(($97+$96)&4294967295); //@line 1092 "compiledict.cpp"
              HEAP8[($arrayidx161)]=14; //@line 1092 "compiledict.cpp"
              $value=0; //@line 1093 "compiledict.cpp"
              ; //@line 1094 "compiledict.cpp"
              while(1) { 
  
                var $98=$p; //@line 1094 "compiledict.cpp"
                var $incdec_ptr163=(($98+1)&4294967295); //@line 1094 "compiledict.cpp"
                $p=$incdec_ptr163; //@line 1094 "compiledict.cpp"
                var $99=HEAP8[($98)]; //@line 1094 "compiledict.cpp"
                $c=$99; //@line 1094 "compiledict.cpp"
                var $conv164=(tempInt=(($99)),(tempInt>=128?tempInt-256:tempInt)); //@line 1094 "compiledict.cpp"
                var $call165=__Z8isspace2j($conv164); //@line 1094 "compiledict.cpp"
                var $tobool=((($call165))|0)!=0; //@line 1094 "compiledict.cpp"
                if ($tobool) { __label__ = 72;break ; } //@line 1094 "compiledict.cpp"
  
                var $100=$c; //@line 1094 "compiledict.cpp"
                var $conv166=(tempInt=(($100)),(tempInt>=128?tempInt-256:tempInt)); //@line 1094 "compiledict.cpp"
                var $cmp167=((($conv166))|0)!=0; //@line 1094 "compiledict.cpp"
                if (!($cmp167)) { __label__ = 72;break ; }
  
                var $101=$c; //@line 1096 "compiledict.cpp"
                var $conv169=(tempInt=(($101)),(tempInt>=128?tempInt-256:tempInt)); //@line 1096 "compiledict.cpp"
                if ($conv169 == 101) {
                  __label__ = 60;;
                }
                else if ($conv169 == 105) {
                  __label__ = 61;;
                }
                else if ($conv169 == 112) {
                  __label__ = 62;;
                }
                else if ($conv169 == 118) {
                  __label__ = 63;;
                }
                else if ($conv169 == 100) {
                  __label__ = 64;;
                }
                else if ($conv169 == 102) {
                  __label__ = 65;;
                }
                else if ($conv169 == 113) {
                  __label__ = 66;;
                }
                else if ($conv169 == 116) {
                  __label__ = 67;;
                }
                else if ($conv169 == 98) {
                  __label__ = 68;;
                }
                else if ($conv169 == 97) {
                  __label__ = 69;;
                }
                else {
                __label__ = 70;;
                }
                
                if (__label__ == 70) {
  
                  var $112=$c; //@line 1129 "compiledict.cpp"
                  var $conv190=(tempInt=(($112)),(tempInt>=128?tempInt-256:tempInt)); //@line 1129 "compiledict.cpp"
                  var $isdigittmp=((($conv190)-48)&4294967295); //@line 1129 "compiledict.cpp"
                  var $isdigit=((($isdigittmp))>>>0) < 10; //@line 1129 "compiledict.cpp"
                  var $call191=((($isdigit))&1); //@line 1129 "compiledict.cpp"
                  var $tobool192=((($call191))|0)!=0; //@line 1129 "compiledict.cpp"
                  if (!($tobool192)) { __label__ = 57;continue ; } //@line 1129 "compiledict.cpp"
  
                  var $113=$value; //@line 1130 "compiledict.cpp"
                  var $mul194=((($113)*10)&4294967295); //@line 1130 "compiledict.cpp"
                  var $114=$c; //@line 1130 "compiledict.cpp"
                  var $conv195=(tempInt=(($114)),(tempInt>=128?tempInt-256:tempInt)); //@line 1130 "compiledict.cpp"
                  var $sub196=((($mul194)-48)&4294967295); //@line 1130 "compiledict.cpp"
                  var $add197=((($sub196)+($conv195))&4294967295); //@line 1130 "compiledict.cpp"
                  $value=$add197; //@line 1130 "compiledict.cpp"
                  __label__ = 57;continue ; //@line 1130 "compiledict.cpp"
                }
                else if (__label__ == 60) {
  
                  var $102=$sxflags; //@line 1099 "compiledict.cpp"
                  var $or171=($102) | 256; //@line 1099 "compiledict.cpp"
                  $sxflags=$or171; //@line 1099 "compiledict.cpp"
                  __label__ = 57;continue ; //@line 1100 "compiledict.cpp"
                }
                else if (__label__ == 61) {
  
                  var $103=$sxflags; //@line 1102 "compiledict.cpp"
                  var $or173=($103) | 512; //@line 1102 "compiledict.cpp"
                  $sxflags=$or173; //@line 1102 "compiledict.cpp"
                  __label__ = 57;continue ; //@line 1103 "compiledict.cpp"
                }
                else if (__label__ == 62) {
  
                  var $104=$sxflags; //@line 1105 "compiledict.cpp"
                  var $or175=($104) | 1024; //@line 1105 "compiledict.cpp"
                  $sxflags=$or175; //@line 1105 "compiledict.cpp"
                  __label__ = 57;continue ; //@line 1106 "compiledict.cpp"
                }
                else if (__label__ == 63) {
  
                  var $105=$sxflags; //@line 1108 "compiledict.cpp"
                  var $or177=($105) | 2048; //@line 1108 "compiledict.cpp"
                  $sxflags=$or177; //@line 1108 "compiledict.cpp"
                  __label__ = 57;continue ; //@line 1109 "compiledict.cpp"
                }
                else if (__label__ == 64) {
  
                  var $106=$sxflags; //@line 1111 "compiledict.cpp"
                  var $or179=($106) | 4096; //@line 1111 "compiledict.cpp"
                  $sxflags=$or179; //@line 1111 "compiledict.cpp"
                  __label__ = 57;continue ; //@line 1112 "compiledict.cpp"
                }
                else if (__label__ == 65) {
  
                  var $107=$sxflags; //@line 1114 "compiledict.cpp"
                  var $or181=($107) | 8192; //@line 1114 "compiledict.cpp"
                  $sxflags=$or181; //@line 1114 "compiledict.cpp"
                  __label__ = 57;continue ; //@line 1115 "compiledict.cpp"
                }
                else if (__label__ == 66) {
  
                  var $108=$sxflags; //@line 1117 "compiledict.cpp"
                  var $or183=($108) | 16384; //@line 1117 "compiledict.cpp"
                  $sxflags=$or183; //@line 1117 "compiledict.cpp"
                  __label__ = 57;continue ; //@line 1118 "compiledict.cpp"
                }
                else if (__label__ == 67) {
  
                  var $109=$sxflags; //@line 1120 "compiledict.cpp"
                  var $or185=($109) | 65536; //@line 1120 "compiledict.cpp"
                  $sxflags=$or185; //@line 1120 "compiledict.cpp"
                  __label__ = 57;continue ; //@line 1121 "compiledict.cpp"
                }
                else if (__label__ == 68) {
  
                  var $110=$sxflags; //@line 1123 "compiledict.cpp"
                  var $or187=($110) | 131072; //@line 1123 "compiledict.cpp"
                  $sxflags=$or187; //@line 1123 "compiledict.cpp"
                  __label__ = 57;continue ; //@line 1124 "compiledict.cpp"
                }
                else if (__label__ == 69) {
  
                  var $111=$sxflags; //@line 1126 "compiledict.cpp"
                  var $or189=($111) | 262144; //@line 1126 "compiledict.cpp"
                  $sxflags=$or189; //@line 1126 "compiledict.cpp"
                  __label__ = 57;continue ; //@line 1127 "compiledict.cpp"
                }
              }
  
              var $115=$p; //@line 1134 "compiledict.cpp"
              var $incdec_ptr200=(($115+-1)&4294967295); //@line 1134 "compiledict.cpp"
              $p=$incdec_ptr200; //@line 1134 "compiledict.cpp"
              var $116=$sxflags; //@line 1135 "compiledict.cpp"
              var $shr=($116) >> 16; //@line 1135 "compiledict.cpp"
              var $conv201=((($shr)) & 255); //@line 1135 "compiledict.cpp"
              var $117=$ix; //@line 1135 "compiledict.cpp"
              var $inc202=((($117)+1)&4294967295); //@line 1135 "compiledict.cpp"
              $ix=$inc202; //@line 1135 "compiledict.cpp"
              var $118=$output; //@line 1135 "compiledict.cpp"
              var $arrayidx203=(($118+$117)&4294967295); //@line 1135 "compiledict.cpp"
              HEAP8[($arrayidx203)]=$conv201; //@line 1135 "compiledict.cpp"
              var $119=$sxflags; //@line 1136 "compiledict.cpp"
              var $shr204=($119) >> 8; //@line 1136 "compiledict.cpp"
              var $conv205=((($shr204)) & 255); //@line 1136 "compiledict.cpp"
              var $120=$ix; //@line 1136 "compiledict.cpp"
              var $inc206=((($120)+1)&4294967295); //@line 1136 "compiledict.cpp"
              $ix=$inc206; //@line 1136 "compiledict.cpp"
              var $121=$output; //@line 1136 "compiledict.cpp"
              var $arrayidx207=(($121+$120)&4294967295); //@line 1136 "compiledict.cpp"
              HEAP8[($arrayidx207)]=$conv205; //@line 1136 "compiledict.cpp"
              var $122=$value; //@line 1137 "compiledict.cpp"
              var $or208=($122) | 128; //@line 1137 "compiledict.cpp"
              var $conv209=((($or208)) & 255); //@line 1137 "compiledict.cpp"
              $c=$conv209; //@line 1137 "compiledict.cpp"
              ; //@line 1138 "compiledict.cpp"
            }
          }
        } while(0);
  
        var $123=$c; //@line 1142 "compiledict.cpp"
        var $124=$ix; //@line 1142 "compiledict.cpp"
        var $inc213=((($124)+1)&4294967295); //@line 1142 "compiledict.cpp"
        $ix=$inc213; //@line 1142 "compiledict.cpp"
        var $125=$output; //@line 1142 "compiledict.cpp"
        var $arrayidx214=(($125+$124)&4294967295); //@line 1142 "compiledict.cpp"
        HEAP8[($arrayidx214)]=$123; //@line 1142 "compiledict.cpp"
        var $126=$c; //@line 1143 "compiledict.cpp"
        var $conv215=(tempInt=(($126)),(tempInt>=128?tempInt-256:tempInt)); //@line 1143 "compiledict.cpp"
        var $cmp216=((($conv215))|0)==0; //@line 1143 "compiledict.cpp"
        if ($cmp216) { __label__ = 74;break $for_cond$10; } else { __label__ = 6;continue $for_cond$10; } //@line 1143 "compiledict.cpp"
      }
  
      var $127=$state_addr; //@line 1146 "compiledict.cpp"
      var $128=HEAP32[(($127)>>2)]; //@line 1146 "compiledict.cpp"
      var $arrayidx219=((__ZZL16copy_rule_stringPcRiE10next_state+$128*4)&4294967295); //@line 1146 "compiledict.cpp"
      var $129=HEAP32[(($arrayidx219)>>2)]; //@line 1146 "compiledict.cpp"
      var $130=$state_addr; //@line 1146 "compiledict.cpp"
      HEAP32[(($130)>>2)]=$129; //@line 1146 "compiledict.cpp"
      ; //@line 1147 "compiledict.cpp"
    }
  
    ;
    return; //@line 1147 "compiledict.cpp"
    return;
  }
  

  function __ZL12compile_linePcS_Pi($linebuf, $dict_line, $hash) {
    var __stackBase__  = STACKTOP; STACKTOP += 312; _memset(__stackBase__, 0, 312);
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $linebuf_addr;
    var $dict_line_addr;
    var $hash_addr;
    var $c;
    var $p;
    var $word;
    var $phonetic;
    var $ix;
    var $step;
    var $n_flag_codes;
    var $flag_offset;
    var $length;
    var $multiple_words;
    var $multiple_numeric_hyphen;
    var $multiple_string;
    var $multiple_string_end;
    var $len_word;
    var $len_phonetic;
    var $text_not_phonemes;
    var $wc=__stackBase__;
    var $all_upper_case;
    var $mnemptr;
    var $comment;
    var $flag_codes=__stackBase__+4;
    var $encoded_ph=__stackBase__+104;
    var $bad_phoneme=__stackBase__+304;
    var $c2=__stackBase__+308;
    $linebuf_addr=$linebuf;
    $dict_line_addr=$dict_line;
    $hash_addr=$hash;
    $n_flag_codes=0; //@line 378 "compiledict.cpp"
    $multiple_words=0; //@line 381 "compiledict.cpp"
    $multiple_numeric_hyphen=0; //@line 382 "compiledict.cpp"
    $multiple_string=0; //@line 383 "compiledict.cpp"
    $multiple_string_end=0; //@line 384 "compiledict.cpp"
    $comment=0; //@line 399 "compiledict.cpp"
    $text_not_phonemes=0; //@line 400 "compiledict.cpp"
    $word=((__ZZL12compile_linePcS_PiE10nullstring)&4294967295); //@line 401 "compiledict.cpp"
    $phonetic=((__ZZL12compile_linePcS_PiE10nullstring)&4294967295); //@line 401 "compiledict.cpp"
    var $0=$linebuf_addr; //@line 403 "compiledict.cpp"
    var $call=_memcmp($0, ((__str108)&4294967295), 2); //@line 403 "compiledict.cpp"
    var $cmp=((($call))|0)==0; //@line 403 "compiledict.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 403 "compiledict.cpp"
    if (__label__ == 1) {
  
      $step=1; //@line 405 "compiledict.cpp"
      ; //@line 406 "compiledict.cpp"
    }
  
    var $1=$linebuf_addr; //@line 407 "compiledict.cpp"
    $p=$1; //@line 407 "compiledict.cpp"
    $step=0; //@line 426 "compiledict.cpp"
    $c=0; //@line 428 "compiledict.cpp"
    var $2=$c; //@line 429 "compiledict.cpp"
    var $conv13=((($2))&255); //@line 429 "compiledict.cpp"
    var $cmp114=((($conv13))|0)!=10; //@line 429 "compiledict.cpp"
    if ($cmp114) { __label__ = 3;; } else { __label__ = 55;; } //@line 429 "compiledict.cpp"
    $while_body$$while_end147$5: do { 
      if (__label__ == 3) {
        $while_body$6: while(1) { 
  
          var $3=$p; //@line 431 "compiledict.cpp"
          var $4=HEAP8[($3)]; //@line 431 "compiledict.cpp"
          $c=$4; //@line 431 "compiledict.cpp"
          var $5=$c; //@line 433 "compiledict.cpp"
          var $conv2=((($5))&255); //@line 433 "compiledict.cpp"
          var $cmp3=((($conv2))|0)==63; //@line 433 "compiledict.cpp"
          if ($cmp3) { __label__ = 4;; } else { __label__ = 12;; } //@line 433 "compiledict.cpp"
          $land_lhs_true$$if_end28$8: do { 
            if (__label__ == 4) {
  
              var $6=$step; //@line 433 "compiledict.cpp"
              var $cmp4=((($6))|0)==0; //@line 433 "compiledict.cpp"
              if (!($cmp4)) { __label__ = 12;break $land_lhs_true$$if_end28$8; } //@line 433 "compiledict.cpp"
  
              $flag_offset=100; //@line 436 "compiledict.cpp"
              var $7=$p; //@line 438 "compiledict.cpp"
              var $incdec_ptr=(($7+1)&4294967295); //@line 438 "compiledict.cpp"
              $p=$incdec_ptr; //@line 438 "compiledict.cpp"
              var $8=$p; //@line 439 "compiledict.cpp"
              var $9=HEAP8[($8)]; //@line 439 "compiledict.cpp"
              var $conv6=(tempInt=(($9)),(tempInt>=128?tempInt-256:tempInt)); //@line 439 "compiledict.cpp"
              var $cmp7=((($conv6))|0)==33; //@line 439 "compiledict.cpp"
              if ($cmp7) { __label__ = 6;; } else { __label__ = 7;; } //@line 439 "compiledict.cpp"
              if (__label__ == 6) {
  
                $flag_offset=132; //@line 442 "compiledict.cpp"
                var $10=$p; //@line 443 "compiledict.cpp"
                var $incdec_ptr9=(($10+1)&4294967295); //@line 443 "compiledict.cpp"
                $p=$incdec_ptr9; //@line 443 "compiledict.cpp"
                ; //@line 444 "compiledict.cpp"
              }
  
              $ix=0; //@line 446 "compiledict.cpp"
              var $11=$p; //@line 447 "compiledict.cpp"
              var $12=HEAP8[($11)]; //@line 447 "compiledict.cpp"
              var $conv11=(tempInt=(($12)),(tempInt>=128?tempInt-256:tempInt)); //@line 447 "compiledict.cpp"
              var $isdigittmp=((($conv11)-48)&4294967295); //@line 447 "compiledict.cpp"
              var $isdigit=((($isdigittmp))>>>0) < 10; //@line 447 "compiledict.cpp"
              var $call12=((($isdigit))&1); //@line 447 "compiledict.cpp"
              var $tobool=((($call12))|0)!=0; //@line 447 "compiledict.cpp"
              if ($tobool) { __label__ = 8;; } else { __label__ = 9;; } //@line 447 "compiledict.cpp"
              if (__label__ == 8) {
  
                var $13=$p; //@line 449 "compiledict.cpp"
                var $14=HEAP8[($13)]; //@line 449 "compiledict.cpp"
                var $conv14=(tempInt=(($14)),(tempInt>=128?tempInt-256:tempInt)); //@line 449 "compiledict.cpp"
                var $15=$ix; //@line 449 "compiledict.cpp"
                var $sub=((($15)-48)&4294967295); //@line 449 "compiledict.cpp"
                var $add=((($sub)+($conv14))&4294967295); //@line 449 "compiledict.cpp"
                $ix=$add; //@line 449 "compiledict.cpp"
                var $16=$p; //@line 450 "compiledict.cpp"
                var $incdec_ptr15=(($16+1)&4294967295); //@line 450 "compiledict.cpp"
                $p=$incdec_ptr15; //@line 450 "compiledict.cpp"
                ; //@line 451 "compiledict.cpp"
              }
  
              var $17=$p; //@line 452 "compiledict.cpp"
              var $18=HEAP8[($17)]; //@line 452 "compiledict.cpp"
              var $conv17=(tempInt=(($18)),(tempInt>=128?tempInt-256:tempInt)); //@line 452 "compiledict.cpp"
              var $isdigittmp1=((($conv17)-48)&4294967295); //@line 452 "compiledict.cpp"
              var $isdigit2=((($isdigittmp1))>>>0) < 10; //@line 452 "compiledict.cpp"
              var $call18=((($isdigit2))&1); //@line 452 "compiledict.cpp"
              var $tobool19=((($call18))|0)!=0; //@line 452 "compiledict.cpp"
              if ($tobool19) { __label__ = 10;; } else { __label__ = 11;; } //@line 452 "compiledict.cpp"
              if (__label__ == 10) {
  
                var $19=$ix; //@line 454 "compiledict.cpp"
                var $mul=((($19)*10)&4294967295); //@line 454 "compiledict.cpp"
                var $20=$p; //@line 454 "compiledict.cpp"
                var $21=HEAP8[($20)]; //@line 454 "compiledict.cpp"
                var $conv21=(tempInt=(($21)),(tempInt>=128?tempInt-256:tempInt)); //@line 454 "compiledict.cpp"
                var $sub22=((($mul)-48)&4294967295); //@line 454 "compiledict.cpp"
                var $add23=((($sub22)+($conv21))&4294967295); //@line 454 "compiledict.cpp"
                $ix=$add23; //@line 454 "compiledict.cpp"
                var $22=$p; //@line 455 "compiledict.cpp"
                var $incdec_ptr24=(($22+1)&4294967295); //@line 455 "compiledict.cpp"
                $p=$incdec_ptr24; //@line 455 "compiledict.cpp"
                ; //@line 456 "compiledict.cpp"
              }
  
              var $23=$ix; //@line 457 "compiledict.cpp"
              var $24=$flag_offset; //@line 457 "compiledict.cpp"
              var $add26=((($24)+($23))&4294967295); //@line 457 "compiledict.cpp"
              var $conv27=((($add26)) & 255); //@line 457 "compiledict.cpp"
              var $25=$n_flag_codes; //@line 457 "compiledict.cpp"
              var $inc=((($25)+1)&4294967295); //@line 457 "compiledict.cpp"
              $n_flag_codes=$inc; //@line 457 "compiledict.cpp"
              var $arrayidx=(($flag_codes+$25)&4294967295); //@line 457 "compiledict.cpp"
              HEAP8[($arrayidx)]=$conv27; //@line 457 "compiledict.cpp"
              var $26=$p; //@line 458 "compiledict.cpp"
              var $27=HEAP8[($26)]; //@line 458 "compiledict.cpp"
              $c=$27; //@line 458 "compiledict.cpp"
              ; //@line 459 "compiledict.cpp"
            }
          } while(0);
  
          var $28=$c; //@line 461 "compiledict.cpp"
          var $conv29=((($28))&255); //@line 461 "compiledict.cpp"
          var $cmp30=((($conv29))|0)==36; //@line 461 "compiledict.cpp"
          if ($cmp30) { __label__ = 13;; } else { __label__ = 25;; } //@line 461 "compiledict.cpp"
          $land_lhs_true31$$if_end64$21: do { 
            if (__label__ == 13) {
  
              var $29=$p; //@line 461 "compiledict.cpp"
              var $arrayidx32=(($29+1)&4294967295); //@line 461 "compiledict.cpp"
              var $30=HEAP8[($arrayidx32)]; //@line 461 "compiledict.cpp"
              var $conv33=(tempInt=(($30)),(tempInt>=128?tempInt-256:tempInt)); //@line 461 "compiledict.cpp"
              var $call34=_isalnum($conv33); //@line 461 "compiledict.cpp"
              var $tobool35=((($call34))|0)!=0; //@line 461 "compiledict.cpp"
              if (!($tobool35)) { __label__ = 25;break $land_lhs_true31$$if_end64$21; } //@line 461 "compiledict.cpp"
  
              var $31=$p; //@line 464 "compiledict.cpp"
              $mnemptr=$31; //@line 464 "compiledict.cpp"
              var $32=$p; //@line 465 "compiledict.cpp"
              var $33=HEAPU8[($32)]; //@line 465 "compiledict.cpp"
              $c=$33; //@line 465 "compiledict.cpp"
              var $conv389=((($33))&255); //@line 465 "compiledict.cpp"
              var $call3910=__Z8isspace2j($conv389); //@line 465 "compiledict.cpp"
              var $tobool4011=((($call3910))|0)!=0; //@line 465 "compiledict.cpp"
              var $lnot12=($tobool4011) ^ 1; //@line 465 "compiledict.cpp"
              var $34=$p; //@line 465 "compiledict.cpp"
              if ($lnot12) { __lastLabel__ = 14; __label__ = 15;; } else { __lastLabel__ = 14; __label__ = 16;; } //@line 465 "compiledict.cpp"
              $while_body41$$while_end$24: do { 
                if (__label__ == 15) {
                  while(1) { 
  
                    var $35=__lastLabel__ == 15 ? $38 : ($34);
                    var $incdec_ptr42=(($35+1)&4294967295); //@line 465 "compiledict.cpp"
                    $p=$incdec_ptr42; //@line 465 "compiledict.cpp"
                    var $36=$p; //@line 465 "compiledict.cpp"
                    var $37=HEAPU8[($36)]; //@line 465 "compiledict.cpp"
                    $c=$37; //@line 465 "compiledict.cpp"
                    var $conv38=((($37))&255); //@line 465 "compiledict.cpp"
                    var $call39=__Z8isspace2j($conv38); //@line 465 "compiledict.cpp"
                    var $tobool40=((($call39))|0)!=0; //@line 465 "compiledict.cpp"
                    var $lnot=($tobool40) ^ 1; //@line 465 "compiledict.cpp"
                    var $38=$p; //@line 465 "compiledict.cpp"
                    if ($lnot) { __lastLabel__ = 15; __label__ = 15;continue ; } else { __lastLabel__ = 15; __label__ = 16;break $while_body41$$while_end$24; } //@line 465 "compiledict.cpp"
                  }
                }
              } while(0);
  
              var $_lcssa=__lastLabel__ == 14 ? $34 : ($38);
              HEAP8[($_lcssa)]=0; //@line 466 "compiledict.cpp"
              var $39=$mnemptr; //@line 468 "compiledict.cpp"
              var $call43=__Z10LookupMnemP8MNEM_TABPKc(((_mnem_flags)&4294967295), $39); //@line 468 "compiledict.cpp"
              $ix=$call43; //@line 468 "compiledict.cpp"
              var $cmp44=((($call43))>>>0) > 0; //@line 469 "compiledict.cpp"
              if ($cmp44) { __label__ = 17;; } else { __label__ = 24;; } //@line 469 "compiledict.cpp"
              if (__label__ == 17) {
  
                var $40=$ix; //@line 471 "compiledict.cpp"
                var $cmp46=((($40))|0)==200; //@line 471 "compiledict.cpp"
                if ($cmp46) { __label__ = 18;; } else { __label__ = 19;; } //@line 471 "compiledict.cpp"
                if (__label__ == 18) {
  
                  HEAP8[(__ZL9text_mode_b)]=1;
                  ; //@line 474 "compiledict.cpp"
                }
                else if (__label__ == 19) {
  
                  var $41=$ix; //@line 476 "compiledict.cpp"
                  var $cmp48=((($41))|0)==201; //@line 476 "compiledict.cpp"
                  if ($cmp48) { __label__ = 20;; } else { __label__ = 21;; } //@line 476 "compiledict.cpp"
                  if (__label__ == 20) {
  
                    HEAP8[(__ZL9text_mode_b)]=0;
                    ; //@line 479 "compiledict.cpp"
                  }
                  else if (__label__ == 21) {
  
                    var $42=$ix; //@line 481 "compiledict.cpp"
                    var $cmp51=((($42))|0)==29; //@line 481 "compiledict.cpp"
                    if ($cmp51) { __label__ = 22;; } else { __label__ = 23;; } //@line 481 "compiledict.cpp"
                    if (__label__ == 22) {
  
                      $text_not_phonemes=1; //@line 483 "compiledict.cpp"
                      ; //@line 484 "compiledict.cpp"
                    }
                    else if (__label__ == 23) {
  
                      var $43=$ix; //@line 487 "compiledict.cpp"
                      var $conv54=((($43)) & 255); //@line 487 "compiledict.cpp"
                      var $44=$n_flag_codes; //@line 487 "compiledict.cpp"
                      var $inc55=((($44)+1)&4294967295); //@line 487 "compiledict.cpp"
                      $n_flag_codes=$inc55; //@line 487 "compiledict.cpp"
                      var $arrayidx56=(($flag_codes+$44)&4294967295); //@line 487 "compiledict.cpp"
                      HEAP8[($arrayidx56)]=$conv54; //@line 487 "compiledict.cpp"
                      ;
                    }
                  }
                }
              }
              else if (__label__ == 24) {
  
                var $45=HEAP32[((__ZL5f_log)>>2)]; //@line 492 "compiledict.cpp"
                var $46=HEAP32[((__ZL7linenum)>>2)]; //@line 492 "compiledict.cpp"
                var $47=$mnemptr; //@line 492 "compiledict.cpp"
                var $call61=_fprintf($45, ((__str109)&4294967295), allocate([$46,0,0,0,$47,0,0,0], ["i32",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 492 "compiledict.cpp"
                var $48=HEAP32[((__ZL11error_count)>>2)]; //@line 493 "compiledict.cpp"
                var $inc62=((($48)+1)&4294967295); //@line 493 "compiledict.cpp"
                HEAP32[((__ZL11error_count)>>2)]=$inc62; //@line 493 "compiledict.cpp"
                ;
              }
            }
          } while(0);
  
          var $49=$c; //@line 497 "compiledict.cpp"
          var $conv65=((($49))&255); //@line 497 "compiledict.cpp"
          var $cmp66=((($conv65))|0)==47; //@line 497 "compiledict.cpp"
          if ($cmp66) { __label__ = 26;; } else { __label__ = 29;; } //@line 497 "compiledict.cpp"
          $land_lhs_true67$$if_end74$41: do { 
            if (__label__ == 26) {
  
              var $50=$p; //@line 497 "compiledict.cpp"
              var $arrayidx68=(($50+1)&4294967295); //@line 497 "compiledict.cpp"
              var $51=HEAP8[($arrayidx68)]; //@line 497 "compiledict.cpp"
              var $conv69=(tempInt=(($51)),(tempInt>=128?tempInt-256:tempInt)); //@line 497 "compiledict.cpp"
              var $cmp70=((($conv69))|0)==47; //@line 497 "compiledict.cpp"
              if (!($cmp70)) { __label__ = 29;break $land_lhs_true67$$if_end74$41; } //@line 497 "compiledict.cpp"
  
              var $52=$multiple_words; //@line 497 "compiledict.cpp"
              var $cmp72=((($52))|0)==0; //@line 497 "compiledict.cpp"
              if (!($cmp72)) { __label__ = 29;break $land_lhs_true67$$if_end74$41; } //@line 497 "compiledict.cpp"
  
              $c=10; //@line 499 "compiledict.cpp"
              var $53=$p; //@line 500 "compiledict.cpp"
              $comment=$53; //@line 500 "compiledict.cpp"
              ; //@line 501 "compiledict.cpp"
            }
          } while(0);
  
          var $54=$step; //@line 503 "compiledict.cpp"
          if ($54 == 0) {
            __label__ = 30;;
          }
          else if ($54 == 1) {
            __label__ = 34;;
          }
          else if ($54 == 2) {
            __label__ = 46;;
          }
          else if ($54 == 3) {
            __label__ = 50;;
          }
          else if ($54 == 4) {
            __label__ = 52;;
          }
          else {
          __label__ = 54;;
          }
          
          $sw_epilog$$sw_bb$$sw_bb85$$sw_bb119$$sw_bb133$$sw_bb139$46: do { 
            if (__label__ == 30) {
  
              var $55=$c; //@line 506 "compiledict.cpp"
              var $conv75=((($55))&255); //@line 506 "compiledict.cpp"
              var $cmp76=((($conv75))|0)==40; //@line 506 "compiledict.cpp"
              if ($cmp76) { __label__ = 31;; } else { __label__ = 32;; } //@line 506 "compiledict.cpp"
              if (__label__ == 31) {
  
                $multiple_words=1; //@line 508 "compiledict.cpp"
                var $56=$p; //@line 509 "compiledict.cpp"
                var $add_ptr=(($56+1)&4294967295); //@line 509 "compiledict.cpp"
                $word=$add_ptr; //@line 509 "compiledict.cpp"
                $step=1; //@line 510 "compiledict.cpp"
                ; //@line 511 "compiledict.cpp"
              }
              else if (__label__ == 32) {
  
                var $57=$c; //@line 513 "compiledict.cpp"
                var $conv79=((($57))&255); //@line 513 "compiledict.cpp"
                var $call80=__Z8isspace2j($conv79); //@line 513 "compiledict.cpp"
                var $tobool81=((($call80))|0)!=0; //@line 513 "compiledict.cpp"
                if ($tobool81) { __label__ = 54;break $sw_epilog$$sw_bb$$sw_bb85$$sw_bb119$$sw_bb133$$sw_bb139$46; } //@line 513 "compiledict.cpp"
  
                var $58=$p; //@line 515 "compiledict.cpp"
                $word=$58; //@line 515 "compiledict.cpp"
                $step=1; //@line 516 "compiledict.cpp"
                ; //@line 517 "compiledict.cpp"
              }
            }
            else if (__label__ == 34) {
  
              var $59=$c; //@line 521 "compiledict.cpp"
              var $conv86=((($59))&255); //@line 521 "compiledict.cpp"
              var $cmp87=((($conv86))|0)==45; //@line 521 "compiledict.cpp"
              if ($cmp87) { __label__ = 35;; } else { __label__ = 39;; } //@line 521 "compiledict.cpp"
              $land_lhs_true88$$if_end99$53: do { 
                if (__label__ == 35) {
  
                  var $60=$multiple_words; //@line 521 "compiledict.cpp"
                  var $tobool89=((($60))|0)!=0; //@line 521 "compiledict.cpp"
                  if (!($tobool89)) { __label__ = 39;break $land_lhs_true88$$if_end99$53; } //@line 521 "compiledict.cpp"
  
                  var $61=$word; //@line 523 "compiledict.cpp"
                  var $arrayidx91=(($61)&4294967295); //@line 523 "compiledict.cpp"
                  var $62=HEAP8[($arrayidx91)]; //@line 523 "compiledict.cpp"
                  var $conv92=(tempInt=(($62)),(tempInt>=128?tempInt-256:tempInt)); //@line 523 "compiledict.cpp"
                  var $isdigittmp3=((($conv92)-48)&4294967295); //@line 523 "compiledict.cpp"
                  var $isdigit4=((($isdigittmp3))>>>0) < 10; //@line 523 "compiledict.cpp"
                  var $call93=((($isdigit4))&1); //@line 523 "compiledict.cpp"
                  var $tobool94=((($call93))|0)!=0; //@line 523 "compiledict.cpp"
                  if ($tobool94) { __label__ = 37;; } else { __label__ = 38;; } //@line 523 "compiledict.cpp"
                  if (__label__ == 37) {
  
                    $multiple_numeric_hyphen=1; //@line 525 "compiledict.cpp"
                    ; //@line 526 "compiledict.cpp"
                  }
  
                  var $63=$n_flag_codes; //@line 529 "compiledict.cpp"
                  var $inc97=((($63)+1)&4294967295); //@line 529 "compiledict.cpp"
                  $n_flag_codes=$inc97; //@line 529 "compiledict.cpp"
                  var $arrayidx98=(($flag_codes+$63)&4294967295); //@line 529 "compiledict.cpp"
                  HEAP8[($arrayidx98)]=44; //@line 529 "compiledict.cpp"
                  $c=32; //@line 531 "compiledict.cpp"
                  ; //@line 532 "compiledict.cpp"
                }
              } while(0);
  
              var $64=$c; //@line 533 "compiledict.cpp"
              var $conv100=((($64))&255); //@line 533 "compiledict.cpp"
              var $call101=__Z8isspace2j($conv100); //@line 533 "compiledict.cpp"
              var $tobool102=((($call101))|0)!=0; //@line 533 "compiledict.cpp"
              if ($tobool102) { __label__ = 40;; } else { __label__ = 43;; } //@line 533 "compiledict.cpp"
              if (__label__ == 40) {
  
                var $65=$p; //@line 535 "compiledict.cpp"
                var $arrayidx104=(($65)&4294967295); //@line 535 "compiledict.cpp"
                HEAP8[($arrayidx104)]=0; //@line 535 "compiledict.cpp"
                var $66=$multiple_words; //@line 537 "compiledict.cpp"
                var $tobool105=((($66))|0)!=0; //@line 537 "compiledict.cpp"
                if ($tobool105) { __label__ = 41;; } else { __label__ = 42;; } //@line 537 "compiledict.cpp"
                if (__label__ == 41) {
  
                  var $67=$p; //@line 539 "compiledict.cpp"
                  var $add_ptr107=(($67+1)&4294967295); //@line 539 "compiledict.cpp"
                  $multiple_string_end=$add_ptr107; //@line 539 "compiledict.cpp"
                  $multiple_string=$add_ptr107; //@line 539 "compiledict.cpp"
                  $step=2; //@line 540 "compiledict.cpp"
                  ; //@line 541 "compiledict.cpp"
                }
                else if (__label__ == 42) {
  
                  $step=3; //@line 544 "compiledict.cpp"
                  ;
                }
              }
              else if (__label__ == 43) {
  
                var $68=$c; //@line 548 "compiledict.cpp"
                var $conv111=((($68))&255); //@line 548 "compiledict.cpp"
                var $cmp112=((($conv111))|0)==41; //@line 548 "compiledict.cpp"
                if (!($cmp112)) { __label__ = 54;break $sw_epilog$$sw_bb$$sw_bb85$$sw_bb119$$sw_bb133$$sw_bb139$46; } //@line 548 "compiledict.cpp"
  
                var $69=$multiple_words; //@line 548 "compiledict.cpp"
                var $tobool114=((($69))|0)!=0; //@line 548 "compiledict.cpp"
                if (!($tobool114)) { __label__ = 54;break $sw_epilog$$sw_bb$$sw_bb85$$sw_bb119$$sw_bb133$$sw_bb139$46; } //@line 548 "compiledict.cpp"
  
                var $70=$p; //@line 550 "compiledict.cpp"
                var $arrayidx116=(($70)&4294967295); //@line 550 "compiledict.cpp"
                HEAP8[($arrayidx116)]=0; //@line 550 "compiledict.cpp"
                $step=3; //@line 551 "compiledict.cpp"
                $multiple_words=0; //@line 552 "compiledict.cpp"
                ; //@line 553 "compiledict.cpp"
              }
            }
            else if (__label__ == 46) {
  
              var $71=$c; //@line 557 "compiledict.cpp"
              var $conv120=((($71))&255); //@line 557 "compiledict.cpp"
              var $call121=__Z8isspace2j($conv120); //@line 557 "compiledict.cpp"
              var $tobool122=((($call121))|0)!=0; //@line 557 "compiledict.cpp"
              if ($tobool122) { __label__ = 47;; } else { __label__ = 48;; } //@line 557 "compiledict.cpp"
              if (__label__ == 47) {
  
                var $72=$multiple_words; //@line 559 "compiledict.cpp"
                var $inc124=((($72)+1)&4294967295); //@line 559 "compiledict.cpp"
                $multiple_words=$inc124; //@line 559 "compiledict.cpp"
                ; //@line 560 "compiledict.cpp"
              }
              else if (__label__ == 48) {
  
                var $73=$c; //@line 562 "compiledict.cpp"
                var $conv126=((($73))&255); //@line 562 "compiledict.cpp"
                var $cmp127=((($conv126))|0)==41; //@line 562 "compiledict.cpp"
                if (!($cmp127)) { __label__ = 54;break $sw_epilog$$sw_bb$$sw_bb85$$sw_bb119$$sw_bb133$$sw_bb139$46; } //@line 562 "compiledict.cpp"
  
                var $74=$p; //@line 564 "compiledict.cpp"
                var $arrayidx129=(($74)&4294967295); //@line 564 "compiledict.cpp"
                HEAP8[($arrayidx129)]=32; //@line 564 "compiledict.cpp"
                var $75=$p; //@line 565 "compiledict.cpp"
                var $add_ptr130=(($75+1)&4294967295); //@line 565 "compiledict.cpp"
                $multiple_string_end=$add_ptr130; //@line 565 "compiledict.cpp"
                $step=3; //@line 566 "compiledict.cpp"
                ; //@line 567 "compiledict.cpp"
              }
            }
            else if (__label__ == 50) {
  
              var $76=$c; //@line 571 "compiledict.cpp"
              var $conv134=((($76))&255); //@line 571 "compiledict.cpp"
              var $call135=__Z8isspace2j($conv134); //@line 571 "compiledict.cpp"
              var $tobool136=((($call135))|0)!=0; //@line 571 "compiledict.cpp"
              if ($tobool136) { __label__ = 54;break $sw_epilog$$sw_bb$$sw_bb85$$sw_bb119$$sw_bb133$$sw_bb139$46; } //@line 571 "compiledict.cpp"
  
              var $77=$p; //@line 573 "compiledict.cpp"
              $phonetic=$77; //@line 573 "compiledict.cpp"
              $step=4; //@line 574 "compiledict.cpp"
              ; //@line 575 "compiledict.cpp"
            }
            else if (__label__ == 52) {
  
              var $78=$c; //@line 579 "compiledict.cpp"
              var $conv140=((($78))&255); //@line 579 "compiledict.cpp"
              var $call141=__Z8isspace2j($conv140); //@line 579 "compiledict.cpp"
              var $tobool142=((($call141))|0)!=0; //@line 579 "compiledict.cpp"
              if (!($tobool142)) { __label__ = 54;break $sw_epilog$$sw_bb$$sw_bb85$$sw_bb119$$sw_bb133$$sw_bb139$46; } //@line 579 "compiledict.cpp"
  
              var $79=$p; //@line 581 "compiledict.cpp"
              var $arrayidx144=(($79)&4294967295); //@line 581 "compiledict.cpp"
              HEAP8[($arrayidx144)]=0; //@line 581 "compiledict.cpp"
              $step=5; //@line 582 "compiledict.cpp"
              ; //@line 583 "compiledict.cpp"
            }
          } while(0);
  
          var $80=$p; //@line 589 "compiledict.cpp"
          var $incdec_ptr146=(($80+1)&4294967295); //@line 589 "compiledict.cpp"
          $p=$incdec_ptr146; //@line 589 "compiledict.cpp"
          var $81=$c; //@line 429 "compiledict.cpp"
          var $conv=((($81))&255); //@line 429 "compiledict.cpp"
          var $cmp1=((($conv))|0)!=10; //@line 429 "compiledict.cpp"
          if ($cmp1) { __label__ = 3;continue $while_body$6; } else { __label__ = 55;break $while_body$$while_end147$5; } //@line 429 "compiledict.cpp"
        }
      }
    } while(0);
  
    var $82=$word; //@line 592 "compiledict.cpp"
    var $arrayidx148=(($82)&4294967295); //@line 592 "compiledict.cpp"
    var $83=HEAP8[($arrayidx148)]; //@line 592 "compiledict.cpp"
    var $conv149=(tempInt=(($83)),(tempInt>=128?tempInt-256:tempInt)); //@line 592 "compiledict.cpp"
    var $cmp150=((($conv149))|0)==0; //@line 592 "compiledict.cpp"
    if ($cmp150) { __label__ = 56;; } else { __label__ = 57;; } //@line 592 "compiledict.cpp"
    if (__label__ == 56) {
  
      $retval=0; //@line 600 "compiledict.cpp"
      ; //@line 600 "compiledict.cpp"
    }
    else if (__label__ == 57) {
  
      var $_b=HEAPU8[(__ZL9text_mode_b)];
      var $84=((($_b))&1);
      var $tobool153=((($84))|0)!=0; //@line 603 "compiledict.cpp"
      if ($tobool153) { __label__ = 58;; } else { __label__ = 59;; } //@line 603 "compiledict.cpp"
      $if_end155_thread$$if_end155$82: do { 
        if (__label__ == 58) {
  
          $text_not_phonemes=1; //@line 604 "compiledict.cpp"
          __label__ = 60;break $if_end155_thread$$if_end155$82; //@line 606 "compiledict.cpp"
        }
        else if (__label__ == 59) {
  
          var $_pr=$text_not_phonemes; //@line 606 "compiledict.cpp"
          var $tobool156=((($_pr))|0)!=0; //@line 606 "compiledict.cpp"
          if ($tobool156) { __label__ = 60;break $if_end155_thread$$if_end155$82; } //@line 606 "compiledict.cpp"
  
          var $96=$phonetic; //@line 639 "compiledict.cpp"
          var $arraydecay176=(($encoded_ph)&4294967295); //@line 639 "compiledict.cpp"
          var $arraydecay177=(($bad_phoneme)&4294967295); //@line 639 "compiledict.cpp"
          var $call178=__Z14EncodePhonemesPcS_Ph($96, $arraydecay176, $arraydecay177); //@line 639 "compiledict.cpp"
          var $arraydecay179=(($encoded_ph)&4294967295); //@line 640 "compiledict.cpp"
          var $call180=_strchr($arraydecay179, 21); //@line 640 "compiledict.cpp"
          var $cmp181=((($call180))|0)!=0; //@line 640 "compiledict.cpp"
          if ($cmp181) { __label__ = 65;; } else { __label__ = 66;; } //@line 640 "compiledict.cpp"
          if (__label__ == 65) {
  
            var $97=$n_flag_codes; //@line 642 "compiledict.cpp"
            var $inc183=((($97)+1)&4294967295); //@line 642 "compiledict.cpp"
            $n_flag_codes=$inc183; //@line 642 "compiledict.cpp"
            var $arrayidx184=(($flag_codes+$97)&4294967295); //@line 642 "compiledict.cpp"
            HEAP8[($arrayidx184)]=10; //@line 642 "compiledict.cpp"
            ; //@line 643 "compiledict.cpp"
          }
  
          var $arrayidx186=(($bad_phoneme)&4294967295); //@line 646 "compiledict.cpp"
          var $98=HEAPU8[($arrayidx186)]; //@line 646 "compiledict.cpp"
          var $conv187=((($98))&255); //@line 646 "compiledict.cpp"
          var $cmp188=((($conv187))|0)!=0; //@line 646 "compiledict.cpp"
          if (!($cmp188)) { __label__ = 68;break $if_end155_thread$$if_end155$82; } //@line 646 "compiledict.cpp"
  
          var $99=HEAP32[((__ZL5f_log)>>2)]; //@line 649 "compiledict.cpp"
          var $100=HEAP32[((__ZL7linenum)>>2)]; //@line 649 "compiledict.cpp"
          var $arrayidx190=(($bad_phoneme)&4294967295); //@line 649 "compiledict.cpp"
          var $101=HEAPU8[($arrayidx190)]; //@line 649 "compiledict.cpp"
          var $conv191=((($101))&255); //@line 649 "compiledict.cpp"
          var $arrayidx192=(($bad_phoneme)&4294967295); //@line 649 "compiledict.cpp"
          var $102=HEAPU8[($arrayidx192)]; //@line 649 "compiledict.cpp"
          var $conv193=((($102))&255); //@line 649 "compiledict.cpp"
          var $103=$word; //@line 649 "compiledict.cpp"
          var $104=$phonetic; //@line 649 "compiledict.cpp"
          var $call194=_fprintf($99, ((__str112)&4294967295), allocate([$100,0,0,0,$conv191,0,0,0,$conv193,0,0,0,$103,0,0,0,$104,0,0,0], ["i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 649 "compiledict.cpp"
          var $105=HEAP32[((__ZL11error_count)>>2)]; //@line 650 "compiledict.cpp"
          var $inc195=((($105)+1)&4294967295); //@line 650 "compiledict.cpp"
          HEAP32[((__ZL11error_count)>>2)]=$inc195; //@line 650 "compiledict.cpp"
          __label__ = 68;break $if_end155_thread$$if_end155$82; //@line 651 "compiledict.cpp"
        }
      } while(0);
      $if_then157$$if_end197$90: do { 
        if (__label__ == 60) {
  
          var $85=$word; //@line 608 "compiledict.cpp"
          var $arrayidx158=(($85)&4294967295); //@line 608 "compiledict.cpp"
          var $86=HEAP8[($arrayidx158)]; //@line 608 "compiledict.cpp"
          var $conv159=(tempInt=(($86)),(tempInt>=128?tempInt-256:tempInt)); //@line 608 "compiledict.cpp"
          var $cmp160=((($conv159))|0)==95; //@line 608 "compiledict.cpp"
          if ($cmp160) { __label__ = 61;; } else { __label__ = 63;; } //@line 608 "compiledict.cpp"
          if (__label__ == 61) {
  
            var $87=$phonetic; //@line 611 "compiledict.cpp"
            var $strlen=_strlen($87); //@line 611 "compiledict.cpp"
            var $endptr=(($87+$strlen)&4294967295); //@line 611 "compiledict.cpp"
            var $src$, $dest$, $stop$, $stop4$, $fast$;
            $src$ = ((__str110)&4294967295);
            $dest$ = $endptr;
            $stop$ = $src$ + 2;
            if (($dest$%4) == ($src$%4) && 2 > 8) {
              while ($src$%4 !== 0 && $src$ < $stop$) {
                ; HEAP8[$dest$++] = HEAP8[$src$++];
              }
              $src$ >>= 2;
              $dest$ >>= 2;
              $stop4$ = $stop$ >> 2;
              while ($src$ < $stop4$) {
            ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
              }
              $src$ <<= 2;
              $dest$ <<= 2;
            }while ($src$ < $stop$) {
              ; HEAP8[$dest$++] = HEAP8[$src$++];
            }; //@line 611 "compiledict.cpp"
            var $88=HEAP32[((_translator)>>2)]; //@line 615 "compiledict.cpp"
            var $89=$phonetic; //@line 615 "compiledict.cpp"
            var $call163=__Z13TranslateWordP10TranslatorPciP8WORD_TAB($88, $89, 0, 0); //@line 615 "compiledict.cpp"
            $text_not_phonemes=0; //@line 616 "compiledict.cpp"
            var $arraydecay=(($encoded_ph)&4294967295); //@line 617 "compiledict.cpp"
            __Z8strncpy0PcPKci($arraydecay, ((_word_phonemes)&4294967295), 156); //@line 617 "compiledict.cpp"
            var $90=HEAP8[(((_word_phonemes)&4294967295))]; //@line 619 "compiledict.cpp"
            var $conv164=(tempInt=(($90)),(tempInt>=128?tempInt-256:tempInt)); //@line 619 "compiledict.cpp"
            var $cmp165=((($conv164))|0)==0; //@line 619 "compiledict.cpp"
            var $91=HEAP32[((__ZL21error_need_dictionary)>>2)]; //@line 619 "compiledict.cpp"
            var $cmp167=((($91))|0) < 3; //@line 619 "compiledict.cpp"
            var $or_cond=($cmp165) & ($cmp167); //@line 619 "compiledict.cpp"
            if (!($or_cond)) { __label__ = 68;break $if_then157$$if_end197$90; } //@line 619 "compiledict.cpp"
  
            var $92=HEAP32[((__ZL21error_need_dictionary)>>2)]; //@line 622 "compiledict.cpp"
            var $inc169=((($92)+1)&4294967295); //@line 622 "compiledict.cpp"
            HEAP32[((__ZL21error_need_dictionary)>>2)]=$inc169; //@line 622 "compiledict.cpp"
            var $93=HEAP32[((__ZL5f_log)>>2)]; //@line 623 "compiledict.cpp"
            var $94=HEAP32[((__ZL7linenum)>>2)]; //@line 623 "compiledict.cpp"
            var $call170=_fprintf($93, ((__str111)&4294967295), allocate([$94,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 623 "compiledict.cpp"
            ; //@line 624 "compiledict.cpp"
          }
          else if (__label__ == 63) {
  
            var $arraydecay173=(($encoded_ph)&4294967295); //@line 634 "compiledict.cpp"
            var $95=$phonetic; //@line 634 "compiledict.cpp"
            __Z8strncpy0PcPKci($arraydecay173, $95, 156); //@line 634 "compiledict.cpp"
            ;
          }
        }
      } while(0);
  
      var $106=$text_not_phonemes; //@line 654 "compiledict.cpp"
      var $107=HEAP32[((_translator)>>2)]; //@line 654 "compiledict.cpp"
      var $langopts=(($107)&4294967295); //@line 654 "compiledict.cpp"
      var $textmode=(($langopts+252)&4294967295); //@line 654 "compiledict.cpp"
      var $108=HEAP8[($textmode)]; //@line 654 "compiledict.cpp"
      var $conv198=(tempInt=(($108)),(tempInt>=128?tempInt-256:tempInt)); //@line 654 "compiledict.cpp"
      var $cmp199=((($106))|0)!=((($conv198))|0); //@line 654 "compiledict.cpp"
      if ($cmp199) { __label__ = 69;; } else { __label__ = 70;; } //@line 654 "compiledict.cpp"
      if (__label__ == 69) {
  
        var $109=$n_flag_codes; //@line 656 "compiledict.cpp"
        var $inc201=((($109)+1)&4294967295); //@line 656 "compiledict.cpp"
        $n_flag_codes=$inc201; //@line 656 "compiledict.cpp"
        var $arrayidx202=(($flag_codes+$109)&4294967295); //@line 656 "compiledict.cpp"
        HEAP8[($arrayidx202)]=29; //@line 656 "compiledict.cpp"
        ; //@line 657 "compiledict.cpp"
      }
  
      var $110=$word; //@line 660 "compiledict.cpp"
      var $call204=_sscanf($110, ((__str113)&4294967295), allocate([$wc,0,0,0], ["i32*",0,0,0], ALLOC_STACK)); //@line 660 "compiledict.cpp"
      var $cmp205=((($call204))|0)==1; //@line 660 "compiledict.cpp"
      if ($cmp205) { __label__ = 71;; } else { __label__ = 72;; } //@line 660 "compiledict.cpp"
      $if_then206$$if_else209$100: do { 
        if (__label__ == 71) {
  
          var $111=HEAP32[(($wc)>>2)]; //@line 663 "compiledict.cpp"
          var $112=$word; //@line 663 "compiledict.cpp"
          var $call207=__Z8utf8_outjPc($111, $112); //@line 663 "compiledict.cpp"
          $ix=$call207; //@line 663 "compiledict.cpp"
          var $113=$ix; //@line 664 "compiledict.cpp"
          var $114=$word; //@line 664 "compiledict.cpp"
          var $arrayidx208=(($114+$113)&4294967295); //@line 664 "compiledict.cpp"
          HEAP8[($arrayidx208)]=0; //@line 664 "compiledict.cpp"
          ; //@line 665 "compiledict.cpp"
        }
        else if (__label__ == 72) {
  
          var $115=$word; //@line 667 "compiledict.cpp"
          var $arrayidx210=(($115)&4294967295); //@line 667 "compiledict.cpp"
          var $116=HEAP8[($arrayidx210)]; //@line 667 "compiledict.cpp"
          var $conv211=(tempInt=(($116)),(tempInt>=128?tempInt-256:tempInt)); //@line 667 "compiledict.cpp"
          var $cmp212=((($conv211))|0)!=95; //@line 667 "compiledict.cpp"
          if (!($cmp212)) { __label__ = 80;break $if_then206$$if_else209$100; } //@line 667 "compiledict.cpp"
  
          $all_upper_case=1; //@line 672 "compiledict.cpp"
          var $117=$word; //@line 673 "compiledict.cpp"
          $p=$117; //@line 673 "compiledict.cpp"
          var $118=$word; //@line 674 "compiledict.cpp"
          $p=$118; //@line 674 "compiledict.cpp"
          var $119=$p; //@line 678 "compiledict.cpp"
          var $call2146=__Z7utf8_inPiPKc($c2, $119); //@line 678 "compiledict.cpp"
          $ix=$call2146; //@line 678 "compiledict.cpp"
          var $120=HEAP32[(($c2)>>2)]; //@line 679 "compiledict.cpp"
          var $cmp2157=((($120))|0)==0; //@line 679 "compiledict.cpp"
          if ($cmp2157) { __label__ = 78;; } else { __label__ = 74;; } //@line 679 "compiledict.cpp"
          $for_end$$if_end217$104: do { 
            if (__label__ == 74) {
              while(1) { 
  
                var $121=HEAP32[(($c2)>>2)]; //@line 681 "compiledict.cpp"
                var $call218=_iswupper($121); //@line 681 "compiledict.cpp"
                var $tobool219=((($call218))|0)!=0; //@line 681 "compiledict.cpp"
                if ($tobool219) { __label__ = 75;; } else { __label__ = 76;; } //@line 681 "compiledict.cpp"
                if (__label__ == 75) {
  
                  var $122=HEAP32[(($c2)>>2)]; //@line 683 "compiledict.cpp"
                  var $call221=_towlower($122); //@line 683 "compiledict.cpp"
                  var $123=$p; //@line 683 "compiledict.cpp"
                  var $call222=__Z8utf8_outjPc($call221, $123); //@line 683 "compiledict.cpp"
                  ; //@line 684 "compiledict.cpp"
                }
                else if (__label__ == 76) {
  
                  $all_upper_case=0; //@line 687 "compiledict.cpp"
                  ;
                }
  
                var $124=$ix; //@line 689 "compiledict.cpp"
                var $125=$p; //@line 689 "compiledict.cpp"
                var $add_ptr225=(($125+$124)&4294967295); //@line 689 "compiledict.cpp"
                $p=$add_ptr225; //@line 689 "compiledict.cpp"
                var $126=$p; //@line 678 "compiledict.cpp"
                var $call214=__Z7utf8_inPiPKc($c2, $126); //@line 678 "compiledict.cpp"
                $ix=$call214; //@line 678 "compiledict.cpp"
                var $127=HEAP32[(($c2)>>2)]; //@line 679 "compiledict.cpp"
                var $cmp215=((($127))|0)==0; //@line 679 "compiledict.cpp"
                if ($cmp215) { __label__ = 78;break $for_end$$if_end217$104; } else { __label__ = 74;continue ; } //@line 679 "compiledict.cpp"
              }
            }
          } while(0);
  
          var $128=$all_upper_case; //@line 691 "compiledict.cpp"
          var $tobool226=((($128))|0)!=0; //@line 691 "compiledict.cpp"
          if (!($tobool226)) { __label__ = 80;break $if_then206$$if_else209$100; } //@line 691 "compiledict.cpp"
  
          var $129=$n_flag_codes; //@line 693 "compiledict.cpp"
          var $inc228=((($129)+1)&4294967295); //@line 693 "compiledict.cpp"
          $n_flag_codes=$inc228; //@line 693 "compiledict.cpp"
          var $arrayidx229=(($flag_codes+$129)&4294967295); //@line 693 "compiledict.cpp"
          HEAP8[($arrayidx229)]=42; //@line 693 "compiledict.cpp"
          ; //@line 694 "compiledict.cpp"
        }
      } while(0);
  
      var $130=$word; //@line 697 "compiledict.cpp"
      var $call233=_strlen($130); //@line 697 "compiledict.cpp"
      $len_word=$call233; //@line 697 "compiledict.cpp"
      var $131=HEAP32[((_translator)>>2)]; //@line 699 "compiledict.cpp"
      var $transpose_min=(($131+288)&4294967295); //@line 699 "compiledict.cpp"
      var $132=HEAP32[(($transpose_min)>>2)]; //@line 699 "compiledict.cpp"
      var $cmp234=((($132))|0) > 0; //@line 699 "compiledict.cpp"
      if ($cmp234) { __label__ = 81;; } else { __label__ = 82;; } //@line 699 "compiledict.cpp"
      if (__label__ == 81) {
  
        var $133=HEAP32[((_translator)>>2)]; //@line 701 "compiledict.cpp"
        var $134=$word; //@line 701 "compiledict.cpp"
        var $call236=__Z17TransposeAlphabetP10TranslatorPc($133, $134); //@line 701 "compiledict.cpp"
        $len_word=$call236; //@line 701 "compiledict.cpp"
        ; //@line 702 "compiledict.cpp"
      }
  
      var $135=$word; //@line 704 "compiledict.cpp"
      var $call238=__Z14HashDictionaryPKc($135); //@line 704 "compiledict.cpp"
      var $136=$hash_addr; //@line 704 "compiledict.cpp"
      HEAP32[(($136)>>2)]=$call238; //@line 704 "compiledict.cpp"
      var $arraydecay239=(($encoded_ph)&4294967295); //@line 705 "compiledict.cpp"
      var $call240=_strlen($arraydecay239); //@line 705 "compiledict.cpp"
      $len_phonetic=$call240; //@line 705 "compiledict.cpp"
      var $137=$len_word; //@line 707 "compiledict.cpp"
      var $conv241=((($137)) & 255); //@line 707 "compiledict.cpp"
      var $138=$dict_line_addr; //@line 707 "compiledict.cpp"
      var $arrayidx242=(($138+1)&4294967295); //@line 707 "compiledict.cpp"
      HEAP8[($arrayidx242)]=$conv241; //@line 707 "compiledict.cpp"
      var $139=$len_word; //@line 708 "compiledict.cpp"
      var $and=($139) & 63; //@line 708 "compiledict.cpp"
      $len_word=$and; //@line 708 "compiledict.cpp"
      var $140=$dict_line_addr; //@line 710 "compiledict.cpp"
      var $arrayidx243=(($140+2)&4294967295); //@line 710 "compiledict.cpp"
      var $141=$word; //@line 710 "compiledict.cpp"
      var $142=$len_word; //@line 710 "compiledict.cpp"
      var $src$, $dest$, $stop$, $stop4$, $fast$;
      $src$ = $141;
      $dest$ = $arrayidx243;
      $stop$ = $src$ + $142;
      if (($dest$%4) == ($src$%4) && $142 > 8) {
        while ($src$%4 !== 0 && $src$ < $stop$) {
          ; HEAP8[$dest$++] = HEAP8[$src$++];
        }
        $src$ >>= 2;
        $dest$ >>= 2;
        $stop4$ = $stop$ >> 2;
        while ($src$ < $stop4$) {
      ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
        }
        $src$ <<= 2;
        $dest$ <<= 2;
      }while ($src$ < $stop$) {
        ; HEAP8[$dest$++] = HEAP8[$src$++];
      }; //@line 710 "compiledict.cpp"
      var $143=$len_phonetic; //@line 712 "compiledict.cpp"
      var $cmp244=((($143))|0)==0; //@line 712 "compiledict.cpp"
      if ($cmp244) { __label__ = 83;; } else { __label__ = 84;; } //@line 712 "compiledict.cpp"
      if (__label__ == 83) {
  
        var $144=$dict_line_addr; //@line 715 "compiledict.cpp"
        var $arrayidx246=(($144+1)&4294967295); //@line 715 "compiledict.cpp"
        var $145=HEAP8[($arrayidx246)]; //@line 715 "compiledict.cpp"
        var $conv247=(tempInt=(($145)),(tempInt>=128?tempInt-256:tempInt)); //@line 715 "compiledict.cpp"
        var $or=($conv247) | 128; //@line 715 "compiledict.cpp"
        var $conv248=((($or)) & 255); //@line 715 "compiledict.cpp"
        HEAP8[($arrayidx246)]=$conv248; //@line 715 "compiledict.cpp"
        var $146=$len_word; //@line 716 "compiledict.cpp"
        var $add249=((($146)+2)&4294967295); //@line 716 "compiledict.cpp"
        $length=$add249; //@line 716 "compiledict.cpp"
        ; //@line 717 "compiledict.cpp"
      }
      else if (__label__ == 84) {
  
        var $147=$len_word; //@line 720 "compiledict.cpp"
        var $148=$len_phonetic; //@line 720 "compiledict.cpp"
        var $add251=((($147)+3)&4294967295); //@line 720 "compiledict.cpp"
        var $add252=((($add251)+($148))&4294967295); //@line 720 "compiledict.cpp"
        $length=$add252; //@line 720 "compiledict.cpp"
        var $149=$len_word; //@line 721 "compiledict.cpp"
        var $add253=((($149)+2)&4294967295); //@line 721 "compiledict.cpp"
        var $150=$dict_line_addr; //@line 721 "compiledict.cpp"
        var $arrayidx254=(($150+$add253)&4294967295); //@line 721 "compiledict.cpp"
        var $arraydecay255=(($encoded_ph)&4294967295); //@line 721 "compiledict.cpp"
        var $call256=_strcpy($arrayidx254, $arraydecay255); //@line 721 "compiledict.cpp"
        ;
      }
  
      $ix=0; //@line 724 "compiledict.cpp"
      var $151=$ix; //@line 724 "compiledict.cpp"
      var $152=$n_flag_codes; //@line 724 "compiledict.cpp"
      var $cmp2598=((($151))>>>0) < ((($152))>>>0); //@line 724 "compiledict.cpp"
      if ($cmp2598) { __label__ = 86;; } else { __label__ = 87;; } //@line 724 "compiledict.cpp"
      $for_body$$for_end264$121: do { 
        if (__label__ == 86) {
          while(1) { 
  
            var $153=$ix; //@line 726 "compiledict.cpp"
            var $arrayidx260=(($flag_codes+$153)&4294967295); //@line 726 "compiledict.cpp"
            var $154=HEAP8[($arrayidx260)]; //@line 726 "compiledict.cpp"
            var $155=$ix; //@line 726 "compiledict.cpp"
            var $156=$length; //@line 726 "compiledict.cpp"
            var $add261=((($156)+($155))&4294967295); //@line 726 "compiledict.cpp"
            var $157=$dict_line_addr; //@line 726 "compiledict.cpp"
            var $arrayidx262=(($157+$add261)&4294967295); //@line 726 "compiledict.cpp"
            HEAP8[($arrayidx262)]=$154; //@line 726 "compiledict.cpp"
            var $158=$ix; //@line 724 "compiledict.cpp"
            var $inc263=((($158)+1)&4294967295); //@line 724 "compiledict.cpp"
            $ix=$inc263; //@line 724 "compiledict.cpp"
            var $159=$ix; //@line 724 "compiledict.cpp"
            var $160=$n_flag_codes; //@line 724 "compiledict.cpp"
            var $cmp259=((($159))>>>0) < ((($160))>>>0); //@line 724 "compiledict.cpp"
            if ($cmp259) { __label__ = 86;continue ; } else { __label__ = 87;break $for_body$$for_end264$121; } //@line 724 "compiledict.cpp"
          }
        }
      } while(0);
  
      var $161=$n_flag_codes; //@line 728 "compiledict.cpp"
      var $162=$length; //@line 728 "compiledict.cpp"
      var $add265=((($162)+($161))&4294967295); //@line 728 "compiledict.cpp"
      $length=$add265; //@line 728 "compiledict.cpp"
      var $163=$multiple_string; //@line 730 "compiledict.cpp"
      var $cmp266=((($163))|0)!=0; //@line 730 "compiledict.cpp"
      if ($cmp266) { __label__ = 88;; } else { __label__ = 94;; } //@line 730 "compiledict.cpp"
      $land_lhs_true267$$if_end286$125: do { 
        if (__label__ == 88) {
  
          var $164=$multiple_words; //@line 730 "compiledict.cpp"
          var $cmp268=((($164))|0) > 0; //@line 730 "compiledict.cpp"
          if (!($cmp268)) { __label__ = 94;break $land_lhs_true267$$if_end286$125; } //@line 730 "compiledict.cpp"
  
          var $165=$multiple_words; //@line 732 "compiledict.cpp"
          var $cmp270=((($165))|0) > 10; //@line 732 "compiledict.cpp"
          if ($cmp270) { __label__ = 90;; } else { __label__ = 91;; } //@line 732 "compiledict.cpp"
          if (__label__ == 90) {
  
            var $166=HEAP32[((__ZL5f_log)>>2)]; //@line 734 "compiledict.cpp"
            var $167=HEAP32[((__ZL7linenum)>>2)]; //@line 734 "compiledict.cpp"
            var $168=$multiple_words; //@line 734 "compiledict.cpp"
            var $call272=_fprintf($166, ((__str114)&4294967295), allocate([$167,0,0,0,$168,0,0,0], ["i32",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 734 "compiledict.cpp"
            ; //@line 735 "compiledict.cpp"
          }
          else if (__label__ == 91) {
  
            var $169=$multiple_words; //@line 738 "compiledict.cpp"
            var $add274=((($169)+80)&4294967295); //@line 738 "compiledict.cpp"
            var $conv275=((($add274)) & 255); //@line 738 "compiledict.cpp"
            var $170=$length; //@line 738 "compiledict.cpp"
            var $inc276=((($170)+1)&4294967295); //@line 738 "compiledict.cpp"
            $length=$inc276; //@line 738 "compiledict.cpp"
            var $171=$dict_line_addr; //@line 738 "compiledict.cpp"
            var $arrayidx277=(($171+$170)&4294967295); //@line 738 "compiledict.cpp"
            HEAP8[($arrayidx277)]=$conv275; //@line 738 "compiledict.cpp"
            var $172=$multiple_string_end; //@line 739 "compiledict.cpp"
            var $173=$multiple_string; //@line 739 "compiledict.cpp"
            var $sub_ptr_lhs_cast=($172); //@line 739 "compiledict.cpp"
            var $sub_ptr_rhs_cast=($173); //@line 739 "compiledict.cpp"
            var $sub_ptr_sub=((($sub_ptr_lhs_cast)-($sub_ptr_rhs_cast))&4294967295); //@line 739 "compiledict.cpp"
            $ix=$sub_ptr_sub; //@line 739 "compiledict.cpp"
            var $174=$multiple_numeric_hyphen; //@line 740 "compiledict.cpp"
            var $tobool278=((($174))|0)!=0; //@line 740 "compiledict.cpp"
            if ($tobool278) { __label__ = 92;; } else { __label__ = 93;; } //@line 740 "compiledict.cpp"
            if (__label__ == 92) {
  
              var $175=$length; //@line 742 "compiledict.cpp"
              var $inc280=((($175)+1)&4294967295); //@line 742 "compiledict.cpp"
              $length=$inc280; //@line 742 "compiledict.cpp"
              var $176=$dict_line_addr; //@line 742 "compiledict.cpp"
              var $arrayidx281=(($176+$175)&4294967295); //@line 742 "compiledict.cpp"
              HEAP8[($arrayidx281)]=32; //@line 742 "compiledict.cpp"
              ; //@line 743 "compiledict.cpp"
            }
  
            var $177=$length; //@line 744 "compiledict.cpp"
            var $178=$dict_line_addr; //@line 744 "compiledict.cpp"
            var $arrayidx283=(($178+$177)&4294967295); //@line 744 "compiledict.cpp"
            var $179=$multiple_string; //@line 744 "compiledict.cpp"
            var $180=$ix; //@line 744 "compiledict.cpp"
            var $src$, $dest$, $stop$, $stop4$, $fast$;
            $src$ = $179;
            $dest$ = $arrayidx283;
            $stop$ = $src$ + $180;
            if (($dest$%4) == ($src$%4) && $180 > 8) {
              while ($src$%4 !== 0 && $src$ < $stop$) {
                ; HEAP8[$dest$++] = HEAP8[$src$++];
              }
              $src$ >>= 2;
              $dest$ >>= 2;
              $stop4$ = $stop$ >> 2;
              while ($src$ < $stop4$) {
            ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
              }
              $src$ <<= 2;
              $dest$ <<= 2;
            }while ($src$ < $stop$) {
              ; HEAP8[$dest$++] = HEAP8[$src$++];
            }; //@line 744 "compiledict.cpp"
            var $181=$ix; //@line 745 "compiledict.cpp"
            var $182=$length; //@line 745 "compiledict.cpp"
            var $add284=((($182)+($181))&4294967295); //@line 745 "compiledict.cpp"
            $length=$add284; //@line 745 "compiledict.cpp"
            ;
          }
        }
      } while(0);
  
      var $183=$length; //@line 748 "compiledict.cpp"
      var $conv287=((($183)) & 255); //@line 748 "compiledict.cpp"
      var $184=$dict_line_addr; //@line 748 "compiledict.cpp"
      var $arrayidx288=(($184)&4294967295); //@line 748 "compiledict.cpp"
      HEAP8[($arrayidx288)]=$conv287; //@line 748 "compiledict.cpp"
      var $185=$length; //@line 780 "compiledict.cpp"
      $retval=$185; //@line 780 "compiledict.cpp"
      ; //@line 780 "compiledict.cpp"
    }
  
    var $186=$retval; //@line 781 "compiledict.cpp"
    STACKTOP = __stackBase__;
    return $186; //@line 781 "compiledict.cpp"
    return null;
  }
  

  function __Z8strncpy0PcPKci($to, $from, $size) {
    ;
    var __label__;
  
    var $to_addr;
    var $from_addr;
    var $size_addr;
    $to_addr=$to;
    $from_addr=$from;
    $size_addr=$size;
    var $0=$to_addr; //@line 87 "dictionary.cpp"
    var $1=$from_addr; //@line 87 "dictionary.cpp"
    var $2=$size_addr; //@line 87 "dictionary.cpp"
    var $call=_strncpy($0, $1, $2); //@line 87 "dictionary.cpp"
    var $3=$size_addr; //@line 88 "dictionary.cpp"
    var $sub=((($3)-1)&4294967295); //@line 88 "dictionary.cpp"
    var $4=$to_addr; //@line 88 "dictionary.cpp"
    var $arrayidx=(($4+$sub)&4294967295); //@line 88 "dictionary.cpp"
    HEAP8[($arrayidx)]=0; //@line 88 "dictionary.cpp"
    ;
    return; //@line 89 "dictionary.cpp"
    return;
  }
  

  function __Z13Reverse4Bytesi($word) {
    ;
    var __label__;
  
    var $word_addr;
    $word_addr=$word;
    var $0=$word_addr; //@line 106 "dictionary.cpp"
    ;
    return $0; //@line 106 "dictionary.cpp"
    return null;
  }
  

  function __Z10LookupMnemP8MNEM_TABPKc($table, $string) {
    ;
    var __label__;
  
    var $retval;
    var $table_addr;
    var $string_addr;
    $table_addr=$table;
    $string_addr=$string;
    ; //@line 113 "dictionary.cpp"
    while(1) { 
  
      var $0=$table_addr; //@line 113 "dictionary.cpp"
      var $mnem=(($0)&4294967295); //@line 113 "dictionary.cpp"
      var $1=HEAP32[(($mnem)>>2)]; //@line 113 "dictionary.cpp"
      var $cmp=((($1))|0)!=0; //@line 113 "dictionary.cpp"
      if (!($cmp)) { __label__ = 5;break ; } //@line 113 "dictionary.cpp"
  
      var $2=$string_addr; //@line 115 "dictionary.cpp"
      var $3=$table_addr; //@line 115 "dictionary.cpp"
      var $mnem1=(($3)&4294967295); //@line 115 "dictionary.cpp"
      var $4=HEAP32[(($mnem1)>>2)]; //@line 115 "dictionary.cpp"
      var $call=_strcmp($2, $4); //@line 115 "dictionary.cpp"
      var $cmp2=((($call))|0)==0; //@line 115 "dictionary.cpp"
      var $5=$table_addr; //@line 116 "dictionary.cpp"
      if ($cmp2) { __label__ = 3;break ; } //@line 115 "dictionary.cpp"
  
      var $incdec_ptr=(($5+8)&4294967295); //@line 117 "dictionary.cpp"
      $table_addr=$incdec_ptr; //@line 117 "dictionary.cpp"
      __label__ = 1;continue ; //@line 118 "dictionary.cpp"
    }
    if (__label__ == 5) {
  
      var $7=$table_addr; //@line 119 "dictionary.cpp"
      var $value3=(($7+4)&4294967295); //@line 119 "dictionary.cpp"
      var $8=HEAP32[(($value3)>>2)]; //@line 119 "dictionary.cpp"
      $retval=$8; //@line 119 "dictionary.cpp"
      ; //@line 119 "dictionary.cpp"
    }
    else if (__label__ == 3) {
  
      var $value=(($5+4)&4294967295); //@line 116 "dictionary.cpp"
      var $6=HEAP32[(($value)>>2)]; //@line 116 "dictionary.cpp"
      $retval=$6; //@line 116 "dictionary.cpp"
      ; //@line 116 "dictionary.cpp"
    }
  
    var $9=$retval; //@line 120 "dictionary.cpp"
    ;
    return $9; //@line 120 "dictionary.cpp"
    return null;
  }
  

  function __Z14LoadDictionaryP10TranslatorPKci($tr, $name, $no_error) {
    var __stackBase__  = STACKTOP; STACKTOP += 172; _memset(__stackBase__, 0, 172);
    var __label__;
  
    var $retval;
    var $tr_addr;
    var $name_addr;
    var $no_error_addr;
    var $hash;
    var $p;
    var $pw;
    var $length;
    var $f;
    var $size;
    var $fname=__stackBase__;
    $tr_addr=$tr;
    $name_addr=$name;
    $no_error_addr=$no_error;
    var $0=$name_addr; //@line 250 "dictionary.cpp"
    var $call=_strcpy(((_dictionary_name)&4294967295), $0); //@line 250 "dictionary.cpp"
    var $1=$tr_addr; //@line 251 "dictionary.cpp"
    var $dictionary_name=(($1+292)&4294967295); //@line 251 "dictionary.cpp"
    var $arraydecay=(($dictionary_name)&4294967295); //@line 251 "dictionary.cpp"
    var $2=$name_addr; //@line 251 "dictionary.cpp"
    var $call1=_strcpy($arraydecay, $2); //@line 251 "dictionary.cpp"
    var $arraydecay2=(($fname)&4294967295); //@line 256 "dictionary.cpp"
    var $3=$name_addr; //@line 256 "dictionary.cpp"
    var $call3=_sprintf($arraydecay2, ((__str116)&4294967295), allocate([((_path_home)&4294967295),0,0,0,47,0,0,0,$3,0,0,0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 256 "dictionary.cpp"
    var $arraydecay4=(($fname)&4294967295); //@line 257 "dictionary.cpp"
    var $call5=__Z13GetFileLengthPKc($arraydecay4); //@line 257 "dictionary.cpp"
    $size=$call5; //@line 257 "dictionary.cpp"
    var $4=$tr_addr; //@line 259 "dictionary.cpp"
    var $data_dictlist=(($4+1052)&4294967295); //@line 259 "dictionary.cpp"
    var $5=HEAP32[(($data_dictlist)>>2)]; //@line 259 "dictionary.cpp"
    var $cmp=((($5))|0)!=0; //@line 259 "dictionary.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 259 "dictionary.cpp"
    if (__label__ == 1) {
  
      var $6=$tr_addr; //@line 261 "dictionary.cpp"
      var $data_dictlist6=(($6+1052)&4294967295); //@line 261 "dictionary.cpp"
      var $7=HEAP32[(($data_dictlist6)>>2)]; //@line 261 "dictionary.cpp"
      __Z4FreePv($7); //@line 261 "dictionary.cpp"
      var $8=$tr_addr; //@line 262 "dictionary.cpp"
      var $data_dictlist7=(($8+1052)&4294967295); //@line 262 "dictionary.cpp"
      HEAP32[(($data_dictlist7)>>2)]=0; //@line 262 "dictionary.cpp"
      ; //@line 263 "dictionary.cpp"
    }
  
    var $arraydecay8=(($fname)&4294967295); //@line 265 "dictionary.cpp"
    var $call9=_fopen($arraydecay8, ((__str18429)&4294967295)); //@line 265 "dictionary.cpp"
    $f=$call9; //@line 265 "dictionary.cpp"
    var $cmp10=((($call9))|0)==0; //@line 266 "dictionary.cpp"
    if ($cmp10) { __label__ = 4;; } else { __label__ = 3;; } //@line 266 "dictionary.cpp"
    $if_then12$$lor_lhs_false$5: do { 
      if (__label__ == 3) {
  
        var $9=$size; //@line 266 "dictionary.cpp"
        var $cmp11=((($9))>>>0) <= 0; //@line 266 "dictionary.cpp"
        if ($cmp11) { __label__ = 4;break $if_then12$$lor_lhs_false$5; } //@line 266 "dictionary.cpp"
  
        var $13=$size; //@line 275 "dictionary.cpp"
        var $call19=__Z5Alloci($13); //@line 275 "dictionary.cpp"
        var $14=$tr_addr; //@line 275 "dictionary.cpp"
        var $data_dictlist20=(($14+1052)&4294967295); //@line 275 "dictionary.cpp"
        HEAP32[(($data_dictlist20)>>2)]=$call19; //@line 275 "dictionary.cpp"
        var $15=$tr_addr; //@line 276 "dictionary.cpp"
        var $data_dictlist21=(($15+1052)&4294967295); //@line 276 "dictionary.cpp"
        var $16=HEAP32[(($data_dictlist21)>>2)]; //@line 276 "dictionary.cpp"
        var $17=$size; //@line 276 "dictionary.cpp"
        var $18=$f; //@line 276 "dictionary.cpp"
        var $call22=_fread($16, 1, $17, $18); //@line 276 "dictionary.cpp"
        $size=$call22; //@line 276 "dictionary.cpp"
        var $19=$f; //@line 277 "dictionary.cpp"
        var $call23=_fclose($19); //@line 277 "dictionary.cpp"
        var $20=$tr_addr; //@line 280 "dictionary.cpp"
        var $data_dictlist24=(($20+1052)&4294967295); //@line 280 "dictionary.cpp"
        var $21=HEAP32[(($data_dictlist24)>>2)]; //@line 280 "dictionary.cpp"
        var $22=$21; //@line 280 "dictionary.cpp"
        $pw=$22; //@line 280 "dictionary.cpp"
        var $23=$pw; //@line 281 "dictionary.cpp"
        var $arrayidx=(($23+4)&4294967295); //@line 281 "dictionary.cpp"
        var $24=HEAP32[(($arrayidx)>>2)]; //@line 281 "dictionary.cpp"
        var $call25=__Z13Reverse4Bytesi($24); //@line 281 "dictionary.cpp"
        $length=$call25; //@line 281 "dictionary.cpp"
        var $25=$size; //@line 283 "dictionary.cpp"
        var $cmp26=((($25))>>>0) <= 1032; //@line 283 "dictionary.cpp"
        if ($cmp26) { __label__ = 8;; } else { __label__ = 9;; } //@line 283 "dictionary.cpp"
        if (__label__ == 8) {
  
          var $26=HEAP32[((__impure_ptr)>>2)]; //@line 285 "dictionary.cpp"
          var $_stderr28=(($26+12)&4294967295); //@line 285 "dictionary.cpp"
          var $27=HEAP32[(($_stderr28)>>2)]; //@line 285 "dictionary.cpp"
          var $arraydecay29=(($fname)&4294967295); //@line 285 "dictionary.cpp"
          var $call30=_fprintf($27, ((__str3119)&4294967295), allocate([$arraydecay29,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 285 "dictionary.cpp"
          $retval=2; //@line 286 "dictionary.cpp"
          __label__ = 19;break $if_then12$$lor_lhs_false$5; //@line 286 "dictionary.cpp"
        }
        else if (__label__ == 9) {
  
          var $28=$pw; //@line 289 "dictionary.cpp"
          var $arrayidx32=(($28)&4294967295); //@line 289 "dictionary.cpp"
          var $29=HEAP32[(($arrayidx32)>>2)]; //@line 289 "dictionary.cpp"
          var $call33=__Z13Reverse4Bytesi($29); //@line 289 "dictionary.cpp"
          var $cmp34=((($call33))|0)!=1024; //@line 289 "dictionary.cpp"
          if ($cmp34) { __label__ = 11;; } else { __label__ = 10;; } //@line 289 "dictionary.cpp"
          $if_then39$$lor_lhs_false35$11: do { 
            if (__label__ == 10) {
  
              var $30=$length; //@line 289 "dictionary.cpp"
              var $cmp36=((($30))|0) <= 0; //@line 289 "dictionary.cpp"
              var $31=$length; //@line 289 "dictionary.cpp"
              var $cmp38=((($31))|0) > 134217728; //@line 289 "dictionary.cpp"
              var $or_cond=($cmp36) | ($cmp38); //@line 289 "dictionary.cpp"
              if ($or_cond) { __label__ = 11;break $if_then39$$lor_lhs_false35$11; } //@line 289 "dictionary.cpp"
  
              var $37=$length; //@line 295 "dictionary.cpp"
              var $38=$tr_addr; //@line 295 "dictionary.cpp"
              var $data_dictlist46=(($38+1052)&4294967295); //@line 295 "dictionary.cpp"
              var $39=HEAP32[(($data_dictlist46)>>2)]; //@line 295 "dictionary.cpp"
              var $arrayidx47=(($39+$37)&4294967295); //@line 295 "dictionary.cpp"
              var $40=$tr_addr; //@line 295 "dictionary.cpp"
              var $data_dictrules=(($40+1048)&4294967295); //@line 295 "dictionary.cpp"
              HEAP32[(($data_dictrules)>>2)]=$arrayidx47; //@line 295 "dictionary.cpp"
              var $41=$tr_addr; //@line 298 "dictionary.cpp"
              __ZL10InitGroupsP10Translator($41); //@line 298 "dictionary.cpp"
              var $42=$tr_addr; //@line 299 "dictionary.cpp"
              var $groups1=(($42+5256)&4294967295); //@line 299 "dictionary.cpp"
              var $arrayidx48=(($groups1)&4294967295); //@line 299 "dictionary.cpp"
              var $43=HEAP32[(($arrayidx48)>>2)]; //@line 299 "dictionary.cpp"
              var $cmp49=((($43))|0)==0; //@line 299 "dictionary.cpp"
              if ($cmp49) { __label__ = 13;; } else { __label__ = 14;; } //@line 299 "dictionary.cpp"
              if (__label__ == 13) {
  
                var $44=HEAP32[((__impure_ptr)>>2)]; //@line 301 "dictionary.cpp"
                var $_stderr51=(($44+12)&4294967295); //@line 301 "dictionary.cpp"
                var $45=HEAP32[(($_stderr51)>>2)]; //@line 301 "dictionary.cpp"
                var $46=$name_addr; //@line 301 "dictionary.cpp"
                var $call52=_fprintf($45, ((__str5121)&4294967295), allocate([$46,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 301 "dictionary.cpp"
                ; //@line 302 "dictionary.cpp"
              }
  
              var $47=$tr_addr; //@line 305 "dictionary.cpp"
              var $data_dictlist54=(($47+1052)&4294967295); //@line 305 "dictionary.cpp"
              var $48=HEAP32[(($data_dictlist54)>>2)]; //@line 305 "dictionary.cpp"
              var $arrayidx55=(($48+8)&4294967295); //@line 305 "dictionary.cpp"
              $p=$arrayidx55; //@line 305 "dictionary.cpp"
              $hash=0; //@line 307 "dictionary.cpp"
              ; //@line 307 "dictionary.cpp"
              $for_body$17: while(1) { 
  
                var $49=$p; //@line 309 "dictionary.cpp"
                var $50=$hash; //@line 309 "dictionary.cpp"
                var $51=$tr_addr; //@line 309 "dictionary.cpp"
                var $dict_hashtab=(($51+1056)&4294967295); //@line 309 "dictionary.cpp"
                var $arrayidx57=(($dict_hashtab+$50*4)&4294967295); //@line 309 "dictionary.cpp"
                HEAP32[(($arrayidx57)>>2)]=$49; //@line 309 "dictionary.cpp"
                var $52=$p; //@line 310 "dictionary.cpp"
                var $53=HEAP8[($52)]; //@line 310 "dictionary.cpp"
                var $conv1=(tempInt=(($53)),(tempInt>=128?tempInt-256:tempInt)); //@line 310 "dictionary.cpp"
                $length=$conv1; //@line 310 "dictionary.cpp"
                var $cmp582=((($conv1))|0)!=0; //@line 310 "dictionary.cpp"
                if ($cmp582) { __label__ = 16;; } else { __label__ = 17;; } //@line 310 "dictionary.cpp"
                $while_body$$while_end$19: do { 
                  if (__label__ == 16) {
                    while(1) { 
  
                      var $54=$length; //@line 312 "dictionary.cpp"
                      var $55=$p; //@line 312 "dictionary.cpp"
                      var $add_ptr=(($55+$54)&4294967295); //@line 312 "dictionary.cpp"
                      $p=$add_ptr; //@line 312 "dictionary.cpp"
                      var $56=$p; //@line 310 "dictionary.cpp"
                      var $57=HEAP8[($56)]; //@line 310 "dictionary.cpp"
                      var $conv=(tempInt=(($57)),(tempInt>=128?tempInt-256:tempInt)); //@line 310 "dictionary.cpp"
                      $length=$conv; //@line 310 "dictionary.cpp"
                      var $cmp58=((($conv))|0)!=0; //@line 310 "dictionary.cpp"
                      if ($cmp58) { __label__ = 16;continue ; } else { __label__ = 17;break $while_body$$while_end$19; } //@line 310 "dictionary.cpp"
                    }
                  }
                } while(0);
  
                var $58=$p; //@line 314 "dictionary.cpp"
                var $incdec_ptr=(($58+1)&4294967295); //@line 314 "dictionary.cpp"
                $p=$incdec_ptr; //@line 314 "dictionary.cpp"
                var $59=$hash; //@line 307 "dictionary.cpp"
                var $inc=((($59)+1)&4294967295); //@line 307 "dictionary.cpp"
                $hash=$inc; //@line 307 "dictionary.cpp"
                var $cmp56=((($inc))|0) < 1024; //@line 307 "dictionary.cpp"
                if ($cmp56) { __label__ = 15;continue $for_body$17; } else { __label__ = 18;break $for_body$17; } //@line 307 "dictionary.cpp"
              }
  
              $retval=0; //@line 317 "dictionary.cpp"
              __label__ = 19;break $if_then12$$lor_lhs_false$5; //@line 317 "dictionary.cpp"
            }
          } while(0);
  
          var $32=HEAP32[((__impure_ptr)>>2)]; //@line 292 "dictionary.cpp"
          var $_stderr40=(($32+12)&4294967295); //@line 292 "dictionary.cpp"
          var $33=HEAP32[(($_stderr40)>>2)]; //@line 292 "dictionary.cpp"
          var $arraydecay41=(($fname)&4294967295); //@line 292 "dictionary.cpp"
          var $34=$pw; //@line 292 "dictionary.cpp"
          var $arrayidx42=(($34)&4294967295); //@line 292 "dictionary.cpp"
          var $35=HEAP32[(($arrayidx42)>>2)]; //@line 292 "dictionary.cpp"
          var $call43=__Z13Reverse4Bytesi($35); //@line 292 "dictionary.cpp"
          var $36=$length; //@line 292 "dictionary.cpp"
          var $call44=_fprintf($33, ((__str4120)&4294967295), allocate([$arraydecay41,0,0,0,$call43,0,0,0,$36,0,0,0], ["i8*",0,0,0,"i32",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 292 "dictionary.cpp"
          $retval=2; //@line 293 "dictionary.cpp"
          __label__ = 19;break $if_then12$$lor_lhs_false$5; //@line 293 "dictionary.cpp"
        }
      }
    } while(0);
    if (__label__ == 4) {
  
      var $10=$no_error_addr; //@line 268 "dictionary.cpp"
      var $cmp13=((($10))|0)==0; //@line 268 "dictionary.cpp"
      if ($cmp13) { __label__ = 5;; } else { __label__ = 6;; } //@line 268 "dictionary.cpp"
      if (__label__ == 5) {
  
        var $11=HEAP32[((__impure_ptr)>>2)]; //@line 270 "dictionary.cpp"
        var $_stderr=(($11+12)&4294967295); //@line 270 "dictionary.cpp"
        var $12=HEAP32[(($_stderr)>>2)]; //@line 270 "dictionary.cpp"
        var $arraydecay15=(($fname)&4294967295); //@line 270 "dictionary.cpp"
        var $call16=_fprintf($12, ((__str2118)&4294967295), allocate([$arraydecay15,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 270 "dictionary.cpp"
        ; //@line 271 "dictionary.cpp"
      }
  
      $retval=1; //@line 272 "dictionary.cpp"
      ; //@line 272 "dictionary.cpp"
    }
  
    var $60=$retval; //@line 318 "dictionary.cpp"
    STACKTOP = __stackBase__;
    return $60; //@line 318 "dictionary.cpp"
    return null;
  }
  

  function __ZL10InitGroupsP10Translator($tr) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $tr_addr;
    var $ix;
    var $p;
    var $p_name;
    var $pw;
    var $c;
    var $c2;
    var $len;
    $tr_addr=$tr;
    var $0=$tr_addr; //@line 142 "dictionary.cpp"
    var $n_groups2=(($0+7752)&4294967295); //@line 142 "dictionary.cpp"
    HEAP32[(($n_groups2)>>2)]=0; //@line 142 "dictionary.cpp"
    $ix=0; //@line 143 "dictionary.cpp"
    ; //@line 143 "dictionary.cpp"
    $for_body$2: while(1) { 
  
      var $1=$ix; //@line 145 "dictionary.cpp"
      var $2=$tr_addr; //@line 145 "dictionary.cpp"
      var $groups1=(($2+5256)&4294967295); //@line 145 "dictionary.cpp"
      var $arrayidx=(($groups1+$1*4)&4294967295); //@line 145 "dictionary.cpp"
      HEAP32[(($arrayidx)>>2)]=0; //@line 145 "dictionary.cpp"
      var $3=$ix; //@line 146 "dictionary.cpp"
      var $4=$tr_addr; //@line 146 "dictionary.cpp"
      var $groups2_count=(($4+7756)&4294967295); //@line 146 "dictionary.cpp"
      var $arrayidx1=(($groups2_count+$3)&4294967295); //@line 146 "dictionary.cpp"
      HEAP8[($arrayidx1)]=0; //@line 146 "dictionary.cpp"
      var $5=$ix; //@line 147 "dictionary.cpp"
      var $6=$tr_addr; //@line 147 "dictionary.cpp"
      var $groups2_start=(($6+8012)&4294967295); //@line 147 "dictionary.cpp"
      var $arrayidx2=(($groups2_start+$5)&4294967295); //@line 147 "dictionary.cpp"
      HEAP8[($arrayidx2)]=-1; //@line 147 "dictionary.cpp"
      var $7=$ix; //@line 143 "dictionary.cpp"
      var $inc=((($7)+1)&4294967295); //@line 143 "dictionary.cpp"
      $ix=$inc; //@line 143 "dictionary.cpp"
      var $cmp=((($inc))|0) < 256; //@line 143 "dictionary.cpp"
      if ($cmp) { __label__ = 1;continue $for_body$2; } else { __label__ = 2;break $for_body$2; } //@line 143 "dictionary.cpp"
    }
  
    var $8=$tr_addr; //@line 149 "dictionary.cpp"
    var $letterGroups=(($8+5152)&4294967295); //@line 149 "dictionary.cpp"
    var $arraydecay=(($letterGroups)&4294967295); //@line 149 "dictionary.cpp"
    var $9=$arraydecay; //@line 149 "dictionary.cpp"
    var $dest$, $stop$, $stop4$, $fast$, $value4$;
    $dest$ = $9;
    $stop$ = $dest$ + 104;
    $value4$ = 0;
    if ($value4$ < 0) $value4$ += 256;
    $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
    while ($dest$%4 !== 0 && $dest$ < $stop$) {
      ;; HEAP8[$dest$++] = 0;
    }
    $dest$ >>= 2;
    $stop4$ = $stop$ >> 2;
    while ($dest$ < $stop4$) {
    ;;;;;;;  HEAP32[$dest$++] = $value4$;
    }
    $dest$ <<= 2;
    while ($dest$ < $stop$) {
      ;; HEAP8[$dest$++] = 0;
    }; //@line 149 "dictionary.cpp"
    var $10=$tr_addr; //@line 150 "dictionary.cpp"
    var $groups3=(($10+6280)&4294967295); //@line 150 "dictionary.cpp"
    var $arraydecay3=(($groups3)&4294967295); //@line 150 "dictionary.cpp"
    var $11=$arraydecay3; //@line 150 "dictionary.cpp"
    var $dest$, $stop$, $stop4$, $fast$, $value4$;
    $dest$ = $11;
    $stop$ = $dest$ + 512;
    $value4$ = 0;
    if ($value4$ < 0) $value4$ += 256;
    $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
    while ($dest$%4 !== 0 && $dest$ < $stop$) {
      ;; HEAP8[$dest$++] = 0;
    }
    $dest$ >>= 2;
    $stop4$ = $stop$ >> 2;
    while ($dest$ < $stop4$) {
    ;;;;;;;  HEAP32[$dest$++] = $value4$;
    }
    $dest$ <<= 2;
    while ($dest$ < $stop$) {
      ;; HEAP8[$dest$++] = 0;
    }; //@line 150 "dictionary.cpp"
    var $12=$tr_addr; //@line 152 "dictionary.cpp"
    var $data_dictrules=(($12+1048)&4294967295); //@line 152 "dictionary.cpp"
    var $13=HEAP32[(($data_dictrules)>>2)]; //@line 152 "dictionary.cpp"
    $p=$13; //@line 152 "dictionary.cpp"
    ; //@line 153 "dictionary.cpp"
    $while_cond$5: while(1) { 
  
      var $14=$p; //@line 153 "dictionary.cpp"
      var $15=HEAP8[($14)]; //@line 153 "dictionary.cpp"
      var $conv=(tempInt=(($15)),(tempInt>=128?tempInt-256:tempInt)); //@line 153 "dictionary.cpp"
      var $cmp4=((($conv))|0)!=0; //@line 153 "dictionary.cpp"
      if (!($cmp4)) { __label__ = 25;break $while_cond$5; } //@line 153 "dictionary.cpp"
  
      var $16=$p; //@line 155 "dictionary.cpp"
      var $17=HEAP8[($16)]; //@line 155 "dictionary.cpp"
      var $conv5=(tempInt=(($17)),(tempInt>=128?tempInt-256:tempInt)); //@line 155 "dictionary.cpp"
      var $cmp6=((($conv5))|0)!=6; //@line 155 "dictionary.cpp"
      if ($cmp6) { __label__ = 5;break $while_cond$5; } //@line 155 "dictionary.cpp"
  
      var $23=$p; //@line 160 "dictionary.cpp"
      var $incdec_ptr=(($23+1)&4294967295); //@line 160 "dictionary.cpp"
      $p=$incdec_ptr; //@line 160 "dictionary.cpp"
      var $24=$p; //@line 162 "dictionary.cpp"
      var $arrayidx8=(($24)&4294967295); //@line 162 "dictionary.cpp"
      var $25=HEAP8[($arrayidx8)]; //@line 162 "dictionary.cpp"
      var $conv9=(tempInt=(($25)),(tempInt>=128?tempInt-256:tempInt)); //@line 162 "dictionary.cpp"
      var $cmp10=((($conv9))|0)==20; //@line 162 "dictionary.cpp"
      var $26=$p; //@line 164 "dictionary.cpp"
      if ($cmp10) { __label__ = 7;; } else { __label__ = 10;; } //@line 162 "dictionary.cpp"
      if (__label__ == 7) {
  
        var $27=($26); //@line 164 "dictionary.cpp"
        var $add=((($27)+4)&4294967295); //@line 164 "dictionary.cpp"
        var $and=($add) & -4; //@line 164 "dictionary.cpp"
        var $28=($and); //@line 164 "dictionary.cpp"
        $pw=$28; //@line 164 "dictionary.cpp"
        var $29=$pw; //@line 165 "dictionary.cpp"
        var $30=$tr_addr; //@line 165 "dictionary.cpp"
        var $langopts=(($30)&4294967295); //@line 165 "dictionary.cpp"
        var $replace_chars=(($langopts+264)&4294967295); //@line 165 "dictionary.cpp"
        HEAP32[(($replace_chars)>>2)]=$29; //@line 165 "dictionary.cpp"
        var $31=$pw; //@line 166 "dictionary.cpp"
        var $arrayidx134=(($31)&4294967295); //@line 166 "dictionary.cpp"
        var $32=HEAP32[(($arrayidx134)>>2)]; //@line 166 "dictionary.cpp"
        var $cmp145=((($32))|0)!=0; //@line 166 "dictionary.cpp"
        var $33=$pw; //@line 168 "dictionary.cpp"
        if ($cmp145) { __lastLabel__ = 7; __label__ = 8;; } else { __lastLabel__ = 7; __label__ = 9;; } //@line 166 "dictionary.cpp"
        $while_body15$$while_end$11: do { 
          if (__label__ == 8) {
            while(1) { 
  
              var $34=__lastLabel__ == 8 ? $37 : ($33);
              var $add_ptr=(($34+8)&4294967295); //@line 168 "dictionary.cpp"
              $pw=$add_ptr; //@line 168 "dictionary.cpp"
              var $35=$pw; //@line 166 "dictionary.cpp"
              var $arrayidx13=(($35)&4294967295); //@line 166 "dictionary.cpp"
              var $36=HEAP32[(($arrayidx13)>>2)]; //@line 166 "dictionary.cpp"
              var $cmp14=((($36))|0)!=0; //@line 166 "dictionary.cpp"
              var $37=$pw; //@line 168 "dictionary.cpp"
              if ($cmp14) { __lastLabel__ = 8; __label__ = 8;continue ; } else { __lastLabel__ = 8; __label__ = 9;break $while_body15$$while_end$11; } //@line 166 "dictionary.cpp"
            }
          }
        } while(0);
  
        var $_lcssa3=__lastLabel__ == 7 ? $33 : ($37);
        var $add_ptr16=(($_lcssa3+4)&4294967295); //@line 170 "dictionary.cpp"
        var $38=$add_ptr16; //@line 170 "dictionary.cpp"
        $p=$38; //@line 170 "dictionary.cpp"
        __label__ = 3;continue $while_cond$5; //@line 182 "dictionary.cpp"
      }
      else if (__label__ == 10) {
  
        var $arrayidx18=(($26)&4294967295); //@line 185 "dictionary.cpp"
        var $39=HEAP8[($arrayidx18)]; //@line 185 "dictionary.cpp"
        var $conv19=(tempInt=(($39)),(tempInt>=128?tempInt-256:tempInt)); //@line 185 "dictionary.cpp"
        var $cmp20=((($conv19))|0)==18; //@line 185 "dictionary.cpp"
        var $40=$p; //@line 187 "dictionary.cpp"
        if ($cmp20) { __label__ = 11;; } else { __label__ = 13;; } //@line 185 "dictionary.cpp"
        $if_then21$$if_else$16: do { 
          if (__label__ == 11) {
  
            var $arrayidx22=(($40+1)&4294967295); //@line 187 "dictionary.cpp"
            var $41=HEAP8[($arrayidx22)]; //@line 187 "dictionary.cpp"
            var $conv23=(tempInt=(($41)),(tempInt>=128?tempInt-256:tempInt)); //@line 187 "dictionary.cpp"
            var $sub=((($conv23)-65)&4294967295); //@line 187 "dictionary.cpp"
            $ix=$sub; //@line 187 "dictionary.cpp"
            var $42=$p; //@line 188 "dictionary.cpp"
            var $add_ptr24=(($42+2)&4294967295); //@line 188 "dictionary.cpp"
            $p=$add_ptr24; //@line 188 "dictionary.cpp"
            var $43=$ix; //@line 189 "dictionary.cpp"
            var $cmp25=((($43))|0) >= 0; //@line 189 "dictionary.cpp"
            var $44=$ix; //@line 189 "dictionary.cpp"
            var $cmp26=((($44))|0) < 26; //@line 189 "dictionary.cpp"
            var $or_cond=($cmp25) & ($cmp26); //@line 189 "dictionary.cpp"
            if (!($or_cond)) { __label__ = 22;break $if_then21$$if_else$16; } //@line 189 "dictionary.cpp"
  
            var $45=$p; //@line 191 "dictionary.cpp"
            var $46=$ix; //@line 191 "dictionary.cpp"
            var $47=$tr_addr; //@line 191 "dictionary.cpp"
            var $letterGroups28=(($47+5152)&4294967295); //@line 191 "dictionary.cpp"
            var $arrayidx29=(($letterGroups28+$46*4)&4294967295); //@line 191 "dictionary.cpp"
            HEAP32[(($arrayidx29)>>2)]=$45; //@line 191 "dictionary.cpp"
            ; //@line 192 "dictionary.cpp"
          }
          else if (__label__ == 13) {
  
            var $call31=_strlen($40); //@line 196 "dictionary.cpp"
            $len=$call31; //@line 196 "dictionary.cpp"
            var $48=$p; //@line 197 "dictionary.cpp"
            $p_name=$48; //@line 197 "dictionary.cpp"
            var $49=$p_name; //@line 198 "dictionary.cpp"
            var $arrayidx32=(($49)&4294967295); //@line 198 "dictionary.cpp"
            var $50=HEAP8[($arrayidx32)]; //@line 198 "dictionary.cpp"
            $c=$50; //@line 198 "dictionary.cpp"
            var $51=$p_name; //@line 199 "dictionary.cpp"
            var $arrayidx33=(($51+1)&4294967295); //@line 199 "dictionary.cpp"
            var $52=HEAP8[($arrayidx33)]; //@line 199 "dictionary.cpp"
            $c2=$52; //@line 199 "dictionary.cpp"
            var $53=$len; //@line 201 "dictionary.cpp"
            var $add34=((($53)+1)&4294967295); //@line 201 "dictionary.cpp"
            var $54=$p; //@line 201 "dictionary.cpp"
            var $add_ptr35=(($54+$add34)&4294967295); //@line 201 "dictionary.cpp"
            $p=$add_ptr35; //@line 201 "dictionary.cpp"
            var $55=$len; //@line 202 "dictionary.cpp"
            var $cmp36=((($55))|0)==1; //@line 202 "dictionary.cpp"
            if ($cmp36) { __label__ = 14;; } else { __label__ = 15;; } //@line 202 "dictionary.cpp"
            if (__label__ == 14) {
  
              var $56=$p; //@line 204 "dictionary.cpp"
              var $57=$c; //@line 204 "dictionary.cpp"
              var $idxprom=((($57))&255); //@line 204 "dictionary.cpp"
              var $58=$tr_addr; //@line 204 "dictionary.cpp"
              var $groups138=(($58+5256)&4294967295); //@line 204 "dictionary.cpp"
              var $arrayidx39=(($groups138+$idxprom*4)&4294967295); //@line 204 "dictionary.cpp"
              HEAP32[(($arrayidx39)>>2)]=$56; //@line 204 "dictionary.cpp"
              ; //@line 205 "dictionary.cpp"
            }
            else if (__label__ == 15) {
  
              var $59=$len; //@line 207 "dictionary.cpp"
              var $cmp41=((($59))|0)==0; //@line 207 "dictionary.cpp"
              if ($cmp41) { __label__ = 16;; } else { __label__ = 17;; } //@line 207 "dictionary.cpp"
              if (__label__ == 16) {
  
                var $60=$p; //@line 209 "dictionary.cpp"
                var $61=$tr_addr; //@line 209 "dictionary.cpp"
                var $groups143=(($61+5256)&4294967295); //@line 209 "dictionary.cpp"
                var $arrayidx44=(($groups143)&4294967295); //@line 209 "dictionary.cpp"
                HEAP32[(($arrayidx44)>>2)]=$60; //@line 209 "dictionary.cpp"
                ; //@line 210 "dictionary.cpp"
              }
              else if (__label__ == 17) {
  
                var $62=$c; //@line 212 "dictionary.cpp"
                var $conv46=((($62))&255); //@line 212 "dictionary.cpp"
                var $cmp47=((($conv46))|0)==1; //@line 212 "dictionary.cpp"
                if ($cmp47) { __label__ = 18;; } else { __label__ = 19;; } //@line 212 "dictionary.cpp"
                if (__label__ == 18) {
  
                  var $63=$p; //@line 215 "dictionary.cpp"
                  var $64=$c2; //@line 215 "dictionary.cpp"
                  var $conv49=((($64))&255); //@line 215 "dictionary.cpp"
                  var $sub50=((($conv49)-1)&4294967295); //@line 215 "dictionary.cpp"
                  var $65=$tr_addr; //@line 215 "dictionary.cpp"
                  var $groups351=(($65+6280)&4294967295); //@line 215 "dictionary.cpp"
                  var $arrayidx52=(($groups351+$sub50*4)&4294967295); //@line 215 "dictionary.cpp"
                  HEAP32[(($arrayidx52)>>2)]=$63; //@line 215 "dictionary.cpp"
                  ; //@line 216 "dictionary.cpp"
                }
                else if (__label__ == 19) {
  
                  var $66=$c; //@line 219 "dictionary.cpp"
                  var $idxprom54=((($66))&255); //@line 219 "dictionary.cpp"
                  var $67=$tr_addr; //@line 219 "dictionary.cpp"
                  var $groups2_start55=(($67+8012)&4294967295); //@line 219 "dictionary.cpp"
                  var $arrayidx56=(($groups2_start55+$idxprom54)&4294967295); //@line 219 "dictionary.cpp"
                  var $68=HEAPU8[($arrayidx56)]; //@line 219 "dictionary.cpp"
                  var $conv57=((($68))&255); //@line 219 "dictionary.cpp"
                  var $cmp58=((($conv57))|0)==255; //@line 219 "dictionary.cpp"
                  if ($cmp58) { __label__ = 20;; } else { __label__ = 21;; } //@line 219 "dictionary.cpp"
                  if (__label__ == 20) {
  
                    var $69=$tr_addr; //@line 220 "dictionary.cpp"
                    var $n_groups260=(($69+7752)&4294967295); //@line 220 "dictionary.cpp"
                    var $70=HEAP32[(($n_groups260)>>2)]; //@line 220 "dictionary.cpp"
                    var $conv61=((($70)) & 255); //@line 220 "dictionary.cpp"
                    var $71=$c; //@line 220 "dictionary.cpp"
                    var $idxprom62=((($71))&255); //@line 220 "dictionary.cpp"
                    var $72=$tr_addr; //@line 220 "dictionary.cpp"
                    var $groups2_start63=(($72+8012)&4294967295); //@line 220 "dictionary.cpp"
                    var $arrayidx64=(($groups2_start63+$idxprom62)&4294967295); //@line 220 "dictionary.cpp"
                    HEAP8[($arrayidx64)]=$conv61; //@line 220 "dictionary.cpp"
                    ; //@line 220 "dictionary.cpp"
                  }
  
                  var $73=$c; //@line 222 "dictionary.cpp"
                  var $idxprom66=((($73))&255); //@line 222 "dictionary.cpp"
                  var $74=$tr_addr; //@line 222 "dictionary.cpp"
                  var $groups2_count67=(($74+7756)&4294967295); //@line 222 "dictionary.cpp"
                  var $arrayidx68=(($groups2_count67+$idxprom66)&4294967295); //@line 222 "dictionary.cpp"
                  var $75=HEAP8[($arrayidx68)]; //@line 222 "dictionary.cpp"
                  var $inc69=((($75)+1)&255); //@line 222 "dictionary.cpp"
                  HEAP8[($arrayidx68)]=$inc69; //@line 222 "dictionary.cpp"
                  var $76=$p; //@line 223 "dictionary.cpp"
                  var $77=$tr_addr; //@line 223 "dictionary.cpp"
                  var $n_groups270=(($77+7752)&4294967295); //@line 223 "dictionary.cpp"
                  var $78=HEAP32[(($n_groups270)>>2)]; //@line 223 "dictionary.cpp"
                  var $79=$tr_addr; //@line 223 "dictionary.cpp"
                  var $groups2=(($79+6792)&4294967295); //@line 223 "dictionary.cpp"
                  var $arrayidx71=(($groups2+$78*4)&4294967295); //@line 223 "dictionary.cpp"
                  HEAP32[(($arrayidx71)>>2)]=$76; //@line 223 "dictionary.cpp"
                  var $80=$c; //@line 224 "dictionary.cpp"
                  var $conv72=((($80))&255); //@line 224 "dictionary.cpp"
                  var $81=$c2; //@line 224 "dictionary.cpp"
                  var $conv73=((($81))&255); //@line 224 "dictionary.cpp"
                  var $shl=((($conv73)*256)&4294967295); //@line 224 "dictionary.cpp"
                  var $add74=((($shl)+($conv72))&4294967295); //@line 224 "dictionary.cpp"
                  var $82=$tr_addr; //@line 224 "dictionary.cpp"
                  var $n_groups275=(($82+7752)&4294967295); //@line 224 "dictionary.cpp"
                  var $83=HEAPU32[(($n_groups275)>>2)]; //@line 224 "dictionary.cpp"
                  var $inc76=((($83)+1)&4294967295); //@line 224 "dictionary.cpp"
                  HEAP32[(($n_groups275)>>2)]=$inc76; //@line 224 "dictionary.cpp"
                  var $84=$tr_addr; //@line 224 "dictionary.cpp"
                  var $groups2_name=(($84+7272)&4294967295); //@line 224 "dictionary.cpp"
                  var $arrayidx77=(($groups2_name+$83*4)&4294967295); //@line 224 "dictionary.cpp"
                  HEAP32[(($arrayidx77)>>2)]=$add74; //@line 224 "dictionary.cpp"
                  ;
                }
              }
            }
          }
        } while(0);
  
        var $85=$p; //@line 229 "dictionary.cpp"
        var $86=HEAP8[($85)]; //@line 229 "dictionary.cpp"
        var $conv831=(tempInt=(($86)),(tempInt>=128?tempInt-256:tempInt)); //@line 229 "dictionary.cpp"
        var $cmp842=((($conv831))|0)!=7; //@line 229 "dictionary.cpp"
        var $87=$p; //@line 231 "dictionary.cpp"
        if ($cmp842) { __lastLabel__ = 22; __label__ = 23;; } else { __lastLabel__ = 22; __label__ = 24;; } //@line 229 "dictionary.cpp"
        $while_body85$$while_end89$33: do { 
          if (__label__ == 23) {
            while(1) { 
  
              var $88=__lastLabel__ == 23 ? $92 : ($87);
              var $call86=_strlen($88); //@line 231 "dictionary.cpp"
              var $add87=((($call86)+1)&4294967295); //@line 231 "dictionary.cpp"
              var $89=$p; //@line 231 "dictionary.cpp"
              var $add_ptr88=(($89+$add87)&4294967295); //@line 231 "dictionary.cpp"
              $p=$add_ptr88; //@line 231 "dictionary.cpp"
              var $90=$p; //@line 229 "dictionary.cpp"
              var $91=HEAP8[($90)]; //@line 229 "dictionary.cpp"
              var $conv83=(tempInt=(($91)),(tempInt>=128?tempInt-256:tempInt)); //@line 229 "dictionary.cpp"
              var $cmp84=((($conv83))|0)!=7; //@line 229 "dictionary.cpp"
              var $92=$p; //@line 231 "dictionary.cpp"
              if ($cmp84) { __lastLabel__ = 23; __label__ = 23;continue ; } else { __lastLabel__ = 23; __label__ = 24;break $while_body85$$while_end89$33; } //@line 229 "dictionary.cpp"
            }
          }
        } while(0);
  
        var $_lcssa=__lastLabel__ == 22 ? $87 : ($92);
        var $incdec_ptr90=(($_lcssa+1)&4294967295); //@line 233 "dictionary.cpp"
        $p=$incdec_ptr90; //@line 233 "dictionary.cpp"
        __label__ = 3;continue $while_cond$5; //@line 234 "dictionary.cpp"
      }
    }
    if (__label__ == 5) {
  
      var $18=HEAP32[((__impure_ptr)>>2)]; //@line 157 "dictionary.cpp"
      var $_stderr=(($18+12)&4294967295); //@line 157 "dictionary.cpp"
      var $19=HEAP32[(($_stderr)>>2)]; //@line 157 "dictionary.cpp"
      var $20=$p; //@line 157 "dictionary.cpp"
      var $21=$tr_addr; //@line 157 "dictionary.cpp"
      var $data_dictrules7=(($21+1048)&4294967295); //@line 157 "dictionary.cpp"
      var $22=HEAP32[(($data_dictrules7)>>2)]; //@line 157 "dictionary.cpp"
      var $sub_ptr_lhs_cast=($20); //@line 157 "dictionary.cpp"
      var $sub_ptr_rhs_cast=($22); //@line 157 "dictionary.cpp"
      var $sub_ptr_sub=((($sub_ptr_lhs_cast)-($sub_ptr_rhs_cast))&4294967295); //@line 157 "dictionary.cpp"
      var $call=_fprintf($19, ((__str34150)&4294967295), allocate([((_dictionary_name)&4294967295),0,0,0,$sub_ptr_sub,0,0,0], ["i8*",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 157 "dictionary.cpp"
      ; //@line 158 "dictionary.cpp"
    }
  
    ;
    return; //@line 236 "dictionary.cpp"
    return;
  }
  

  function __Z14HashDictionaryPKc($string) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $string_addr;
    var $c;
    var $chars;
    var $hash;
    $string_addr=$string;
    $chars=0; //@line 328 "dictionary.cpp"
    $hash=0; //@line 329 "dictionary.cpp"
    var $0=$string_addr; //@line 331 "dictionary.cpp"
    var $incdec_ptr1=(($0+1)&4294967295); //@line 331 "dictionary.cpp"
    $string_addr=$incdec_ptr1; //@line 331 "dictionary.cpp"
    var $1=HEAP8[($0)]; //@line 331 "dictionary.cpp"
    var $conv2=(tempInt=(($1)),(tempInt>=128?tempInt-256:tempInt)); //@line 331 "dictionary.cpp"
    var $and4=($conv2) & 255; //@line 331 "dictionary.cpp"
    $c=$and4; //@line 331 "dictionary.cpp"
    var $cmp5=((($and4))|0)!=0; //@line 331 "dictionary.cpp"
    var $2=$hash; //@line 333 "dictionary.cpp"
    if ($cmp5) { __lastLabel__ = 0; __label__ = 1;; } else { __lastLabel__ = 0; __label__ = 2;; } //@line 331 "dictionary.cpp"
    $while_body$$while_end$2: do { 
      if (__label__ == 1) {
        while(1) { 
  
          var $3=__lastLabel__ == 1 ? $10 : ($2);
          var $mul=((($3)*8)&4294967295); //@line 333 "dictionary.cpp"
          var $4=$c; //@line 333 "dictionary.cpp"
          var $add=((($4)+($mul))&4294967295); //@line 333 "dictionary.cpp"
          $hash=$add; //@line 333 "dictionary.cpp"
          var $5=$hash; //@line 334 "dictionary.cpp"
          var $and1=($5) & 1023; //@line 334 "dictionary.cpp"
          var $6=$hash; //@line 334 "dictionary.cpp"
          var $shr=($6) >> 8; //@line 334 "dictionary.cpp"
          var $xor=($shr) ^ ($and1); //@line 334 "dictionary.cpp"
          $hash=$xor; //@line 334 "dictionary.cpp"
          var $7=$chars; //@line 335 "dictionary.cpp"
          var $inc=((($7)+1)&4294967295); //@line 335 "dictionary.cpp"
          $chars=$inc; //@line 335 "dictionary.cpp"
          var $8=$string_addr; //@line 331 "dictionary.cpp"
          var $incdec_ptr=(($8+1)&4294967295); //@line 331 "dictionary.cpp"
          $string_addr=$incdec_ptr; //@line 331 "dictionary.cpp"
          var $9=HEAP8[($8)]; //@line 331 "dictionary.cpp"
          var $conv=(tempInt=(($9)),(tempInt>=128?tempInt-256:tempInt)); //@line 331 "dictionary.cpp"
          var $and=($conv) & 255; //@line 331 "dictionary.cpp"
          $c=$and; //@line 331 "dictionary.cpp"
          var $cmp=((($and))|0)!=0; //@line 331 "dictionary.cpp"
          var $10=$hash; //@line 333 "dictionary.cpp"
          if ($cmp) { __lastLabel__ = 1; __label__ = 1;continue ; } else { __lastLabel__ = 1; __label__ = 2;break $while_body$$while_end$2; } //@line 331 "dictionary.cpp"
        }
      }
    } while(0);
  
    var $_lcssa=__lastLabel__ == 0 ? $2 : ($10);
    var $11=$chars; //@line 338 "dictionary.cpp"
    var $add2=((($11)+($_lcssa))&4294967295); //@line 338 "dictionary.cpp"
    var $and3=($add2) & 1023; //@line 338 "dictionary.cpp"
    ;
    return $and3; //@line 338 "dictionary.cpp"
    return null;
  }
  

  function __Z14EncodePhonemesPcS_Ph($p, $outptr, $bad_phoneme) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $p_addr;
    var $outptr_addr;
    var $bad_phoneme_addr;
    var $ix;
    var $c;
    var $count;
    var $max;
    var $max_ph;
    var $consumed;
    var $mnemonic_word;
    var $p_lang;
    $p_addr=$p;
    $outptr_addr=$outptr;
    $bad_phoneme_addr=$bad_phoneme;
    var $0=$bad_phoneme_addr; //@line 367 "dictionary.cpp"
    var $arrayidx=(($0)&4294967295); //@line 367 "dictionary.cpp"
    HEAP8[($arrayidx)]=0; //@line 367 "dictionary.cpp"
    var $1=$p_addr; //@line 370 "dictionary.cpp"
    var $2=HEAP8[($1)]; //@line 370 "dictionary.cpp"
    var $conv4=(tempInt=(($2)),(tempInt>=128?tempInt-256:tempInt)); //@line 370 "dictionary.cpp"
    var $call5=_isspace($conv4); //@line 370 "dictionary.cpp"
    var $tobool6=((($call5))|0)!=0; //@line 370 "dictionary.cpp"
    if ($tobool6) { __label__ = 1;; } else { __label__ = 2;; } //@line 370 "dictionary.cpp"
    $while_body$$while_cond1$2: do { 
      if (__label__ == 1) {
        while(1) { 
  
          var $3=$p_addr; //@line 372 "dictionary.cpp"
          var $incdec_ptr=(($3+1)&4294967295); //@line 372 "dictionary.cpp"
          $p_addr=$incdec_ptr; //@line 372 "dictionary.cpp"
          var $4=$p_addr; //@line 370 "dictionary.cpp"
          var $5=HEAP8[($4)]; //@line 370 "dictionary.cpp"
          var $conv=(tempInt=(($5)),(tempInt>=128?tempInt-256:tempInt)); //@line 370 "dictionary.cpp"
          var $call=_isspace($conv); //@line 370 "dictionary.cpp"
          var $tobool=((($call))|0)!=0; //@line 370 "dictionary.cpp"
          if ($tobool) { __label__ = 1;continue ; } else { __label__ = 2;break $while_body$$while_cond1$2; } //@line 370 "dictionary.cpp"
        }
      }
    } while(0);
    $while_cond1$5: while(1) { 
  
      var $6=$p_addr; //@line 375 "dictionary.cpp"
      var $7=HEAPU8[($6)]; //@line 375 "dictionary.cpp"
      $c=$7; //@line 375 "dictionary.cpp"
      var $conv2=((($7))&255); //@line 375 "dictionary.cpp"
      var $cmp=((($conv2))|0)!=0; //@line 375 "dictionary.cpp"
      if (!($cmp)) { __label__ = 34;break $while_cond1$5; } //@line 375 "dictionary.cpp"
  
      var $8=$c; //@line 375 "dictionary.cpp"
      var $conv3=((($8))&255); //@line 375 "dictionary.cpp"
      var $call4=_isspace($conv3); //@line 375 "dictionary.cpp"
      var $tobool5=((($call4))|0)!=0; //@line 375 "dictionary.cpp"
      var $lnot=($tobool5) ^ 1; //@line 375 "dictionary.cpp"
      if (!($lnot)) { __label__ = 34;break $while_cond1$5; }
  
      $consumed=0; //@line 377 "dictionary.cpp"
      var $9=$c; //@line 379 "dictionary.cpp"
      var $conv7=((($9))&255); //@line 379 "dictionary.cpp"
      var $cond=((($conv7))|0)==124; //@line 379 "dictionary.cpp"
      if ($cond) { __label__ = 5;; } else { __label__ = 7;; } //@line 379 "dictionary.cpp"
      $sw_bb$$sw_default$9: do { 
        if (__label__ == 5) {
  
          var $10=$p_addr; //@line 385 "dictionary.cpp"
          var $arrayidx8=(($10+1)&4294967295); //@line 385 "dictionary.cpp"
          var $11=HEAPU8[($arrayidx8)]; //@line 385 "dictionary.cpp"
          $c=$11; //@line 385 "dictionary.cpp"
          var $conv9=((($11))&255); //@line 385 "dictionary.cpp"
          var $cmp10=((($conv9))|0)==124; //@line 385 "dictionary.cpp"
          if ($cmp10) { __label__ = 7;break $sw_bb$$sw_default$9; } //@line 385 "dictionary.cpp"
  
          var $12=$p_addr; //@line 392 "dictionary.cpp"
          var $incdec_ptr11=(($12+1)&4294967295); //@line 392 "dictionary.cpp"
          $p_addr=$incdec_ptr11; //@line 392 "dictionary.cpp"
          __label__ = 2;continue $while_cond1$5; //@line 393 "dictionary.cpp"
        }
      } while(0);
  
      $max=-1; //@line 399 "dictionary.cpp"
      $max_ph=0; //@line 400 "dictionary.cpp"
      $ix=1; //@line 402 "dictionary.cpp"
      var $13=$ix; //@line 402 "dictionary.cpp"
      var $14=HEAP32[((_n_phoneme_tab)>>2)]; //@line 402 "dictionary.cpp"
      var $cmp121=((($13))|0) < ((($14))|0); //@line 402 "dictionary.cpp"
      if (!($cmp121)) { __label__ = 22;break $while_cond1$5; } //@line 402 "dictionary.cpp"
      $for_body$13: while(1) { 
  
        var $15=$ix; //@line 404 "dictionary.cpp"
        var $arrayidx13=((_phoneme_tab+$15*4)&4294967295); //@line 404 "dictionary.cpp"
        var $16=HEAP32[(($arrayidx13)>>2)]; //@line 404 "dictionary.cpp"
        var $cmp14=((($16))|0)==0; //@line 404 "dictionary.cpp"
        if ($cmp14) { __label__ = 20;; } else { __label__ = 9;; } //@line 404 "dictionary.cpp"
        $for_inc$$if_end16$15: do { 
          if (__label__ == 9) {
  
            var $17=$ix; //@line 406 "dictionary.cpp"
            var $arrayidx17=((_phoneme_tab+$17*4)&4294967295); //@line 406 "dictionary.cpp"
            var $18=HEAP32[(($arrayidx17)>>2)]; //@line 406 "dictionary.cpp"
            var $type=(($18+11)&4294967295); //@line 406 "dictionary.cpp"
            var $19=HEAPU8[($type)]; //@line 406 "dictionary.cpp"
            var $conv18=((($19))&255); //@line 406 "dictionary.cpp"
            var $cmp19=((($conv18))|0)==15; //@line 406 "dictionary.cpp"
            if ($cmp19) { __label__ = 20;break $for_inc$$if_end16$15; } //@line 406 "dictionary.cpp"
  
            $count=0; //@line 409 "dictionary.cpp"
            var $20=$ix; //@line 410 "dictionary.cpp"
            var $arrayidx22=((_phoneme_tab+$20*4)&4294967295); //@line 410 "dictionary.cpp"
            var $21=HEAP32[(($arrayidx22)>>2)]; //@line 410 "dictionary.cpp"
            var $mnemonic=(($21)&4294967295); //@line 410 "dictionary.cpp"
            var $22=HEAP32[(($mnemonic)>>2)]; //@line 410 "dictionary.cpp"
            $mnemonic_word=$22; //@line 410 "dictionary.cpp"
            ; //@line 412 "dictionary.cpp"
            while(1) { 
  
              var $23=$count; //@line 412 "dictionary.cpp"
              var $24=$p_addr; //@line 412 "dictionary.cpp"
              var $arrayidx24=(($24+$23)&4294967295); //@line 412 "dictionary.cpp"
              var $25=HEAPU8[($arrayidx24)]; //@line 412 "dictionary.cpp"
              $c=$25; //@line 412 "dictionary.cpp"
              var $conv25=((($25))&255); //@line 412 "dictionary.cpp"
              var $cmp26=((($conv25))|0) > 32; //@line 412 "dictionary.cpp"
              if (!($cmp26)) { __label__ = 13;break ; } //@line 412 "dictionary.cpp"
  
              var $26=$count; //@line 412 "dictionary.cpp"
              var $cmp27=((($26))|0) < 4; //@line 412 "dictionary.cpp"
              if (!($cmp27)) { __label__ = 13;break ; } //@line 412 "dictionary.cpp"
  
              var $28=$c; //@line 412 "dictionary.cpp"
              var $conv29=((($28))&255); //@line 412 "dictionary.cpp"
              var $29=$mnemonic_word; //@line 412 "dictionary.cpp"
              var $30=$count; //@line 412 "dictionary.cpp"
              var $mul=((($30)*8)&4294967295); //@line 412 "dictionary.cpp"
              var $shr=($29) >>> ((($mul))>>>0); //@line 412 "dictionary.cpp"
              var $and=($shr) & 255; //@line 412 "dictionary.cpp"
              var $cmp30=((($conv29))|0)==((($and))|0); //@line 412 "dictionary.cpp"
              var $31=$count; //@line 414 "dictionary.cpp"
              if ($cmp30) { __lastLabel__ = 14; ; } else { __lastLabel__ = 14; __label__ = 16;break ; }
  
              var $inc=((($31)+1)&4294967295); //@line 414 "dictionary.cpp"
              $count=$inc; //@line 414 "dictionary.cpp"
              __label__ = 11;continue ; //@line 414 "dictionary.cpp"
            }
            if (__label__ == 13) {
  
              var $27=$count; //@line 414 "dictionary.cpp"
              __lastLabel__ = 13; ;
            }
  
            var $32=__lastLabel__ == 13 ? $27 : ($31);
            var $33=$max; //@line 416 "dictionary.cpp"
            var $cmp34=((($32))|0) > ((($33))|0); //@line 416 "dictionary.cpp"
            if (!($cmp34)) { __label__ = 20;break $for_inc$$if_end16$15; } //@line 416 "dictionary.cpp"
  
            var $34=$count; //@line 416 "dictionary.cpp"
            var $cmp36=((($34))|0)==4; //@line 416 "dictionary.cpp"
            if ($cmp36) { __label__ = 19;; } else { __label__ = 18;; } //@line 416 "dictionary.cpp"
            if (__label__ == 18) {
  
              var $35=$mnemonic_word; //@line 416 "dictionary.cpp"
              var $36=$count; //@line 416 "dictionary.cpp"
              var $mul37=((($36)*8)&4294967295); //@line 416 "dictionary.cpp"
              var $shr38=($35) >>> ((($mul37))>>>0); //@line 416 "dictionary.cpp"
              var $and39=($shr38) & 255; //@line 416 "dictionary.cpp"
              var $cmp40=((($and39))|0)==0; //@line 416 "dictionary.cpp"
              if (!($cmp40)) { __label__ = 20;break $for_inc$$if_end16$15; } //@line 416 "dictionary.cpp"
            }
  
            var $37=$count; //@line 419 "dictionary.cpp"
            $max=$37; //@line 419 "dictionary.cpp"
            var $38=$ix; //@line 420 "dictionary.cpp"
            var $arrayidx42=((_phoneme_tab+$38*4)&4294967295); //@line 420 "dictionary.cpp"
            var $39=HEAP32[(($arrayidx42)>>2)]; //@line 420 "dictionary.cpp"
            var $code=(($39+10)&4294967295); //@line 420 "dictionary.cpp"
            var $40=HEAPU8[($code)]; //@line 420 "dictionary.cpp"
            var $conv43=((($40))&255); //@line 420 "dictionary.cpp"
            $max_ph=$conv43; //@line 420 "dictionary.cpp"
            ; //@line 421 "dictionary.cpp"
          }
        } while(0);
  
        var $41=$ix; //@line 402 "dictionary.cpp"
        var $inc45=((($41)+1)&4294967295); //@line 402 "dictionary.cpp"
        $ix=$inc45; //@line 402 "dictionary.cpp"
        var $42=$ix; //@line 402 "dictionary.cpp"
        var $43=HEAP32[((_n_phoneme_tab)>>2)]; //@line 402 "dictionary.cpp"
        var $cmp12=((($42))|0) < ((($43))|0); //@line 402 "dictionary.cpp"
        if ($cmp12) { __label__ = 8;continue $for_body$13; } else { __label__ = 21;break $for_body$13; } //@line 402 "dictionary.cpp"
      }
  
      var $_pr=$max_ph; //@line 424 "dictionary.cpp"
      var $cmp46=((($_pr))|0)==0; //@line 424 "dictionary.cpp"
      if ($cmp46) { __label__ = 22;break $while_cond1$5; } //@line 424 "dictionary.cpp"
  
      var $50=$max; //@line 433 "dictionary.cpp"
      var $cmp52=((($50))|0) <= 0; //@line 433 "dictionary.cpp"
      if ($cmp52) { __label__ = 24;; } else { __label__ = 25;; } //@line 433 "dictionary.cpp"
      if (__label__ == 24) {
  
        $max=1; //@line 434 "dictionary.cpp"
        ; //@line 434 "dictionary.cpp"
      }
  
      var $51=$consumed; //@line 435 "dictionary.cpp"
      var $52=$max; //@line 435 "dictionary.cpp"
      var $add=((($52)+($51))&4294967295); //@line 435 "dictionary.cpp"
      var $53=$p_addr; //@line 435 "dictionary.cpp"
      var $add_ptr55=(($53+$add)&4294967295); //@line 435 "dictionary.cpp"
      $p_addr=$add_ptr55; //@line 435 "dictionary.cpp"
      var $54=$max_ph; //@line 436 "dictionary.cpp"
      var $conv56=((($54)) & 255); //@line 436 "dictionary.cpp"
      var $55=$outptr_addr; //@line 436 "dictionary.cpp"
      var $incdec_ptr57=(($55+1)&4294967295); //@line 436 "dictionary.cpp"
      $outptr_addr=$incdec_ptr57; //@line 436 "dictionary.cpp"
      HEAP8[($55)]=$conv56; //@line 436 "dictionary.cpp"
      var $56=$max_ph; //@line 438 "dictionary.cpp"
      var $cmp58=((($56))|0)==21; //@line 438 "dictionary.cpp"
      if (!($cmp58)) { __label__ = 2;continue $while_cond1$5; } //@line 438 "dictionary.cpp"
  
      var $57=$outptr_addr; //@line 441 "dictionary.cpp"
      $p_lang=$57; //@line 441 "dictionary.cpp"
      ; //@line 442 "dictionary.cpp"
      while(1) { 
  
        var $58=$p_addr; //@line 442 "dictionary.cpp"
        var $59=HEAPU8[($58)]; //@line 442 "dictionary.cpp"
        $c=$59; //@line 442 "dictionary.cpp"
        var $conv61=((($59))&255); //@line 442 "dictionary.cpp"
        var $call62=_isspace($conv61); //@line 442 "dictionary.cpp"
        var $tobool63=((($call62))|0)!=0; //@line 442 "dictionary.cpp"
        if ($tobool63) { __label__ = 30;break ; } //@line 442 "dictionary.cpp"
  
        var $60=$c; //@line 442 "dictionary.cpp"
        var $conv65=((($60))&255); //@line 442 "dictionary.cpp"
        var $cmp66=((($conv65))|0)!=0; //@line 442 "dictionary.cpp"
        if (!($cmp66)) { __label__ = 30;break ; }
  
        var $61=$p_addr; //@line 444 "dictionary.cpp"
        var $incdec_ptr69=(($61+1)&4294967295); //@line 444 "dictionary.cpp"
        $p_addr=$incdec_ptr69; //@line 444 "dictionary.cpp"
        var $62=$c; //@line 445 "dictionary.cpp"
        var $conv70=((($62))&255); //@line 445 "dictionary.cpp"
        var $call71=_tolower($conv70); //@line 445 "dictionary.cpp"
        var $conv72=((($call71)) & 255); //@line 445 "dictionary.cpp"
        var $63=$outptr_addr; //@line 445 "dictionary.cpp"
        var $incdec_ptr73=(($63+1)&4294967295); //@line 445 "dictionary.cpp"
        $outptr_addr=$incdec_ptr73; //@line 445 "dictionary.cpp"
        HEAP8[($63)]=$conv72; //@line 445 "dictionary.cpp"
        __label__ = 27;continue ; //@line 446 "dictionary.cpp"
      }
  
      var $64=$outptr_addr; //@line 447 "dictionary.cpp"
      HEAP8[($64)]=0; //@line 447 "dictionary.cpp"
      var $65=$c; //@line 448 "dictionary.cpp"
      var $conv75=((($65))&255); //@line 448 "dictionary.cpp"
      var $cmp76=((($conv75))|0)==0; //@line 448 "dictionary.cpp"
      if ($cmp76) { __label__ = 31;; } else { __label__ = 33;; } //@line 448 "dictionary.cpp"
      if (__label__ == 31) {
  
        var $66=$p_lang; //@line 450 "dictionary.cpp"
        var $call78=_strcmp($66, ((__str52704)&4294967295)); //@line 450 "dictionary.cpp"
        var $cmp79=((($call78))|0)==0; //@line 450 "dictionary.cpp"
        if ($cmp79) { __label__ = 32;break $while_cond1$5; } else { __label__ = 2;continue $while_cond1$5; } //@line 450 "dictionary.cpp"
      }
      else if (__label__ == 33) {
  
        var $69=$outptr_addr; //@line 458 "dictionary.cpp"
        var $incdec_ptr83=(($69+1)&4294967295); //@line 458 "dictionary.cpp"
        $outptr_addr=$incdec_ptr83; //@line 458 "dictionary.cpp"
        HEAP8[($69)]=124; //@line 458 "dictionary.cpp"
        __label__ = 2;continue $while_cond1$5;
      }
    }
    if (__label__ == 34) {
  
      var $70=$outptr_addr; //@line 465 "dictionary.cpp"
      HEAP8[($70)]=0; //@line 465 "dictionary.cpp"
      var $71=$p_addr; //@line 466 "dictionary.cpp"
      $retval=$71; //@line 466 "dictionary.cpp"
      ; //@line 466 "dictionary.cpp"
    }
    else if (__label__ == 22) {
  
      var $44=$p_addr; //@line 427 "dictionary.cpp"
      var $45=HEAP8[($44)]; //@line 427 "dictionary.cpp"
      var $46=$bad_phoneme_addr; //@line 427 "dictionary.cpp"
      var $arrayidx48=(($46)&4294967295); //@line 427 "dictionary.cpp"
      HEAP8[($arrayidx48)]=$45; //@line 427 "dictionary.cpp"
      var $47=$bad_phoneme_addr; //@line 428 "dictionary.cpp"
      var $arrayidx49=(($47+1)&4294967295); //@line 428 "dictionary.cpp"
      HEAP8[($arrayidx49)]=0; //@line 428 "dictionary.cpp"
      var $48=$outptr_addr; //@line 429 "dictionary.cpp"
      var $incdec_ptr50=(($48+1)&4294967295); //@line 429 "dictionary.cpp"
      $outptr_addr=$incdec_ptr50; //@line 429 "dictionary.cpp"
      HEAP8[($48)]=0; //@line 429 "dictionary.cpp"
      var $49=$p_addr; //@line 430 "dictionary.cpp"
      var $add_ptr=(($49+1)&4294967295); //@line 430 "dictionary.cpp"
      $retval=$add_ptr; //@line 430 "dictionary.cpp"
      ; //@line 430 "dictionary.cpp"
    }
    else if (__label__ == 32) {
  
      var $67=$p_lang; //@line 452 "dictionary.cpp"
      HEAP8[($67)]=0; //@line 452 "dictionary.cpp"
      var $68=$p_addr; //@line 453 "dictionary.cpp"
      $retval=$68; //@line 453 "dictionary.cpp"
      ; //@line 453 "dictionary.cpp"
    }
  
    var $72=$retval; //@line 467 "dictionary.cpp"
    ;
    return $72; //@line 467 "dictionary.cpp"
    return null;
  }
  

  function __Z14DecodePhonemesPKcPc($inptr, $outptr) {
    ;
    var __label__;
  
    var $inptr_addr;
    var $outptr_addr;
    var $phcode;
    var $c;
    var $mnem;
    var $ph;
    $inptr_addr=$inptr;
    $outptr_addr=$outptr;
    var $0=$inptr_addr; //@line 481 "dictionary.cpp"
    var $incdec_ptr8=(($0+1)&4294967295); //@line 481 "dictionary.cpp"
    $inptr_addr=$incdec_ptr8; //@line 481 "dictionary.cpp"
    var $1=HEAPU8[($0)]; //@line 481 "dictionary.cpp"
    $phcode=$1; //@line 481 "dictionary.cpp"
    var $conv9=((($1))&255); //@line 481 "dictionary.cpp"
    var $cmp10=((($conv9))|0) > 0; //@line 481 "dictionary.cpp"
    if ($cmp10) { __label__ = 1;; } else { __label__ = 14;; } //@line 481 "dictionary.cpp"
    $while_body$$while_end40$2: do { 
      if (__label__ == 1) {
        $while_body$3: while(1) { 
  
          var $2=$phcode; //@line 483 "dictionary.cpp"
          var $conv1=((($2))&255); //@line 483 "dictionary.cpp"
          var $cmp2=((($conv1))|0)==255; //@line 483 "dictionary.cpp"
          if ($cmp2) { __label__ = 2;; } else { __label__ = 3;; } //@line 483 "dictionary.cpp"
          $while_cond_backedge$$if_end$5: do { 
            if (__label__ == 3) {
  
              var $5=$phcode; //@line 485 "dictionary.cpp"
              var $idxprom=((($5))&255); //@line 485 "dictionary.cpp"
              var $arrayidx=((_phoneme_tab+$idxprom*4)&4294967295); //@line 485 "dictionary.cpp"
              var $6=HEAPU32[(($arrayidx)>>2)]; //@line 485 "dictionary.cpp"
              $ph=$6; //@line 485 "dictionary.cpp"
              var $cmp3=((($6))|0)==0; //@line 485 "dictionary.cpp"
              if ($cmp3) { __label__ = 2;break $while_cond_backedge$$if_end$5; } //@line 485 "dictionary.cpp"
  
              var $7=$ph; //@line 488 "dictionary.cpp"
              var $type=(($7+11)&4294967295); //@line 488 "dictionary.cpp"
              var $8=HEAPU8[($type)]; //@line 488 "dictionary.cpp"
              var $conv6=((($8))&255); //@line 488 "dictionary.cpp"
              var $cmp7=((($conv6))|0)==1; //@line 488 "dictionary.cpp"
              if ($cmp7) { __label__ = 5;; } else { __label__ = 9;; } //@line 488 "dictionary.cpp"
              $land_lhs_true$$if_else$8: do { 
                if (__label__ == 5) {
  
                  var $9=$ph; //@line 488 "dictionary.cpp"
                  var $std_length=(($9+14)&4294967295); //@line 488 "dictionary.cpp"
                  var $10=HEAPU8[($std_length)]; //@line 488 "dictionary.cpp"
                  var $conv8=((($10))&255); //@line 488 "dictionary.cpp"
                  var $cmp9=((($conv8))|0) <= 4; //@line 488 "dictionary.cpp"
                  if (!($cmp9)) { __label__ = 9;break $land_lhs_true$$if_else$8; } //@line 488 "dictionary.cpp"
  
                  var $11=$ph; //@line 488 "dictionary.cpp"
                  var $program=(($11+8)&4294967295); //@line 488 "dictionary.cpp"
                  var $12=HEAPU16[(($program)>>1)]; //@line 488 "dictionary.cpp"
                  var $conv11=((($12))&65535); //@line 488 "dictionary.cpp"
                  var $cmp12=((($conv11))|0)==0; //@line 488 "dictionary.cpp"
                  if (!($cmp12)) { __label__ = 9;break $land_lhs_true$$if_else$8; } //@line 488 "dictionary.cpp"
  
                  var $13=$ph; //@line 490 "dictionary.cpp"
                  var $std_length14=(($13+14)&4294967295); //@line 490 "dictionary.cpp"
                  var $14=HEAPU8[($std_length14)]; //@line 490 "dictionary.cpp"
                  var $conv15=((($14))&255); //@line 490 "dictionary.cpp"
                  var $cmp16=((($conv15))|0) > 1; //@line 490 "dictionary.cpp"
                  if (!($cmp16)) { __label__ = 2;break $while_cond_backedge$$if_end$5; } //@line 490 "dictionary.cpp"
  
                  var $15=$ph; //@line 491 "dictionary.cpp"
                  var $std_length18=(($15+14)&4294967295); //@line 491 "dictionary.cpp"
                  var $16=HEAPU8[($std_length18)]; //@line 491 "dictionary.cpp"
                  var $idxprom19=((($16))&255); //@line 491 "dictionary.cpp"
                  var $arrayidx20=((((__str7123)&4294967295)+$idxprom19)&4294967295); //@line 491 "dictionary.cpp"
                  var $17=HEAP8[($arrayidx20)]; //@line 491 "dictionary.cpp"
                  var $18=$outptr_addr; //@line 491 "dictionary.cpp"
                  var $incdec_ptr21=(($18+1)&4294967295); //@line 491 "dictionary.cpp"
                  $outptr_addr=$incdec_ptr21; //@line 491 "dictionary.cpp"
                  HEAP8[($18)]=$17; //@line 491 "dictionary.cpp"
                  __label__ = 2;break $while_cond_backedge$$if_end$5; //@line 491 "dictionary.cpp"
                }
              } while(0);
  
              var $19=$ph; //@line 495 "dictionary.cpp"
              var $mnemonic=(($19)&4294967295); //@line 495 "dictionary.cpp"
              var $20=HEAP32[(($mnemonic)>>2)]; //@line 495 "dictionary.cpp"
              $mnem=$20; //@line 495 "dictionary.cpp"
              var $21=$mnem; //@line 497 "dictionary.cpp"
              var $and4=($21) & 255; //@line 497 "dictionary.cpp"
              var $conv245=((($and4)) & 255); //@line 497 "dictionary.cpp"
              $c=$conv245; //@line 497 "dictionary.cpp"
              var $conv256=((($conv245))&255); //@line 497 "dictionary.cpp"
              var $cmp267=((($conv256))|0)!=0; //@line 497 "dictionary.cpp"
              if ($cmp267) { __label__ = 10;; } else { __label__ = 11;; } //@line 497 "dictionary.cpp"
              $while_body27$$while_end$14: do { 
                if (__label__ == 10) {
                  while(1) { 
  
                    var $22=$c; //@line 499 "dictionary.cpp"
                    var $23=$outptr_addr; //@line 499 "dictionary.cpp"
                    var $incdec_ptr28=(($23+1)&4294967295); //@line 499 "dictionary.cpp"
                    $outptr_addr=$incdec_ptr28; //@line 499 "dictionary.cpp"
                    HEAP8[($23)]=$22; //@line 499 "dictionary.cpp"
                    var $24=$mnem; //@line 500 "dictionary.cpp"
                    var $shr=($24) >>> 8; //@line 500 "dictionary.cpp"
                    $mnem=$shr; //@line 500 "dictionary.cpp"
                    var $25=$mnem; //@line 497 "dictionary.cpp"
                    var $and=($25) & 255; //@line 497 "dictionary.cpp"
                    var $conv24=((($and)) & 255); //@line 497 "dictionary.cpp"
                    $c=$conv24; //@line 497 "dictionary.cpp"
                    var $conv25=((($conv24))&255); //@line 497 "dictionary.cpp"
                    var $cmp26=((($conv25))|0)!=0; //@line 497 "dictionary.cpp"
                    if ($cmp26) { __label__ = 10;continue ; } else { __label__ = 11;break $while_body27$$while_end$14; } //@line 497 "dictionary.cpp"
                  }
                }
              } while(0);
  
              var $26=$phcode; //@line 502 "dictionary.cpp"
              var $conv29=((($26))&255); //@line 502 "dictionary.cpp"
              var $cmp30=((($conv29))|0)==21; //@line 502 "dictionary.cpp"
              if (!($cmp30)) { __label__ = 2;break $while_cond_backedge$$if_end$5; } //@line 502 "dictionary.cpp"
  
              var $27=$inptr_addr; //@line 504 "dictionary.cpp"
              var $28=HEAP8[($27)]; //@line 504 "dictionary.cpp"
              var $conv331=(tempInt=(($28)),(tempInt>=128?tempInt-256:tempInt)); //@line 504 "dictionary.cpp"
              var $call2=_isalpha($conv331); //@line 504 "dictionary.cpp"
              var $tobool3=((($call2))|0)!=0; //@line 504 "dictionary.cpp"
              if (!($tobool3)) { __label__ = 2;break $while_cond_backedge$$if_end$5; } //@line 504 "dictionary.cpp"
              while(1) { 
  
                var $29=$inptr_addr; //@line 506 "dictionary.cpp"
                var $incdec_ptr35=(($29+1)&4294967295); //@line 506 "dictionary.cpp"
                $inptr_addr=$incdec_ptr35; //@line 506 "dictionary.cpp"
                var $30=HEAP8[($29)]; //@line 506 "dictionary.cpp"
                var $31=$outptr_addr; //@line 506 "dictionary.cpp"
                var $incdec_ptr36=(($31+1)&4294967295); //@line 506 "dictionary.cpp"
                $outptr_addr=$incdec_ptr36; //@line 506 "dictionary.cpp"
                HEAP8[($31)]=$30; //@line 506 "dictionary.cpp"
                var $32=$inptr_addr; //@line 504 "dictionary.cpp"
                var $33=HEAP8[($32)]; //@line 504 "dictionary.cpp"
                var $conv33=(tempInt=(($33)),(tempInt>=128?tempInt-256:tempInt)); //@line 504 "dictionary.cpp"
                var $call=_isalpha($conv33); //@line 504 "dictionary.cpp"
                var $tobool=((($call))|0)!=0; //@line 504 "dictionary.cpp"
                if ($tobool) { __label__ = 13;continue ; } else { __label__ = 2;break $while_cond_backedge$$if_end$5; } //@line 504 "dictionary.cpp"
              }
            }
          } while(0);
  
          var $3=$inptr_addr; //@line 481 "dictionary.cpp"
          var $incdec_ptr=(($3+1)&4294967295); //@line 481 "dictionary.cpp"
          $inptr_addr=$incdec_ptr; //@line 481 "dictionary.cpp"
          var $4=HEAPU8[($3)]; //@line 481 "dictionary.cpp"
          $phcode=$4; //@line 481 "dictionary.cpp"
          var $conv=((($4))&255); //@line 481 "dictionary.cpp"
          var $cmp=((($conv))|0) > 0; //@line 481 "dictionary.cpp"
          if ($cmp) { __label__ = 1;continue $while_body$3; } else { __label__ = 14;break $while_body$$while_end40$2; } //@line 481 "dictionary.cpp"
        }
      }
    } while(0);
  
    var $34=$outptr_addr; //@line 511 "dictionary.cpp"
    HEAP8[($34)]=0; //@line 511 "dictionary.cpp"
    ;
    return; //@line 512 "dictionary.cpp"
    return;
  }
  

  function __Z26GetTranslatedPhonemeStringPci($phon_out, $n_phon_out) {
    var __stackBase__  = STACKTOP; STACKTOP += 4; _memset(__stackBase__, 0, 4);
    var __label__;
  
    var $phon_out_addr;
    var $n_phon_out_addr;
    var $ix;
    var $phon_out_ix=__stackBase__;
    var $stress;
    var $c;
    var $p;
    var $plist;
    $phon_out_addr=$phon_out;
    $n_phon_out_addr=$n_phon_out;
    HEAP32[(($phon_out_ix)>>2)]=0; //@line 603 "dictionary.cpp"
    var $0=$phon_out_addr; //@line 611 "dictionary.cpp"
    var $cmp=((($0))|0)!=0; //@line 611 "dictionary.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 28;; } //@line 611 "dictionary.cpp"
    if (__label__ == 1) {
  
      $ix=1; //@line 613 "dictionary.cpp"
      ; //@line 613 "dictionary.cpp"
      $for_cond$4: while(1) { 
  
        var $1=$ix; //@line 613 "dictionary.cpp"
        var $2=HEAP32[((_n_phoneme_list)>>2)]; //@line 613 "dictionary.cpp"
        var $sub=((($2)-2)&4294967295); //@line 613 "dictionary.cpp"
        var $cmp1=((($1))|0) < ((($sub))|0); //@line 613 "dictionary.cpp"
        if (!($cmp1)) { __label__ = 25;break $for_cond$4; } //@line 613 "dictionary.cpp"
  
        var $3=HEAP32[(($phon_out_ix)>>2)]; //@line 613 "dictionary.cpp"
        var $4=$n_phon_out_addr; //@line 613 "dictionary.cpp"
        var $sub2=((($4)-6)&4294967295); //@line 613 "dictionary.cpp"
        var $cmp3=((($3))|0) < ((($sub2))|0); //@line 613 "dictionary.cpp"
        if (!($cmp3)) { __label__ = 25;break $for_cond$4; }
  
        var $5=$ix; //@line 615 "dictionary.cpp"
        var $arrayidx=((_phoneme_list+$5*24)&4294967295); //@line 615 "dictionary.cpp"
        $plist=$arrayidx; //@line 615 "dictionary.cpp"
        var $6=$plist; //@line 616 "dictionary.cpp"
        var $newword=(($6+19)&4294967295); //@line 616 "dictionary.cpp"
        var $7=HEAP8[($newword)]; //@line 616 "dictionary.cpp"
        var $tobool=(tempInt=(($7)),(tempInt>=128?tempInt-256:tempInt))!=0; //@line 616 "dictionary.cpp"
        if ($tobool) { __label__ = 5;; } else { __label__ = 6;; } //@line 616 "dictionary.cpp"
        if (__label__ == 5) {
  
          var $8=HEAP32[(($phon_out_ix)>>2)]; //@line 617 "dictionary.cpp"
          var $inc=((($8)+1)&4294967295); //@line 617 "dictionary.cpp"
          HEAP32[(($phon_out_ix)>>2)]=$inc; //@line 617 "dictionary.cpp"
          var $9=$phon_out_addr; //@line 617 "dictionary.cpp"
          var $arrayidx5=(($9+$8)&4294967295); //@line 617 "dictionary.cpp"
          HEAP8[($arrayidx5)]=32; //@line 617 "dictionary.cpp"
          ; //@line 617 "dictionary.cpp"
        }
  
        var $10=$plist; //@line 619 "dictionary.cpp"
        var $synthflags=(($10+4)&4294967295); //@line 619 "dictionary.cpp"
        var $11=HEAPU16[(($synthflags)>>1)]; //@line 619 "dictionary.cpp"
        var $conv=((($11))&65535); //@line 619 "dictionary.cpp"
        var $and=($conv) & 4; //@line 619 "dictionary.cpp"
        var $tobool6=((($and))|0)!=0; //@line 619 "dictionary.cpp"
        if ($tobool6) { __label__ = 7;; } else { __label__ = 15;; } //@line 619 "dictionary.cpp"
        $if_then7$$if_end27$11: do { 
          if (__label__ == 7) {
  
            var $12=$plist; //@line 621 "dictionary.cpp"
            var $stresslevel=(($12+1)&4294967295); //@line 621 "dictionary.cpp"
            var $13=HEAPU8[($stresslevel)]; //@line 621 "dictionary.cpp"
            var $conv8=((($13))&255); //@line 621 "dictionary.cpp"
            $stress=$conv8; //@line 621 "dictionary.cpp"
            var $cmp9=((($conv8))|0) > 1; //@line 621 "dictionary.cpp"
            if (!($cmp9)) { __label__ = 15;break $if_then7$$if_end27$11; } //@line 621 "dictionary.cpp"
  
            $c=0; //@line 623 "dictionary.cpp"
            var $14=$stress; //@line 624 "dictionary.cpp"
            var $cmp11=((($14))|0) > 5; //@line 624 "dictionary.cpp"
            if ($cmp11) { __label__ = 9;; } else { __label__ = 10;; } //@line 624 "dictionary.cpp"
            if (__label__ == 9) {
  
              $stress=5; //@line 624 "dictionary.cpp"
              ; //@line 624 "dictionary.cpp"
            }
  
            var $15=HEAP32[((_option_phonemes)>>2)]; //@line 626 "dictionary.cpp"
            var $cmp14=((($15))|0)==3; //@line 626 "dictionary.cpp"
            if ($cmp14) { __label__ = 11;; } else { __label__ = 13;; } //@line 626 "dictionary.cpp"
            $if_then15$$if_end21$17: do { 
              if (__label__ == 11) {
  
                $c=716; //@line 628 "dictionary.cpp"
                var $16=$stress; //@line 629 "dictionary.cpp"
                var $cmp16=((($16))|0) > 3; //@line 629 "dictionary.cpp"
                if (!($cmp16)) { __label__ = 14;break $if_then15$$if_end21$17; } //@line 629 "dictionary.cpp"
  
                $c=712; //@line 630 "dictionary.cpp"
                ; //@line 630 "dictionary.cpp"
              }
              else if (__label__ == 13) {
  
                var $17=$stress; //@line 634 "dictionary.cpp"
                var $arrayidx19=((((__str8124)&4294967295)+$17)&4294967295); //@line 634 "dictionary.cpp"
                var $18=HEAP8[($arrayidx19)]; //@line 634 "dictionary.cpp"
                var $conv20=(tempInt=(($18)),(tempInt>=128?tempInt-256:tempInt)); //@line 634 "dictionary.cpp"
                $c=$conv20; //@line 634 "dictionary.cpp"
                var $cmp22=((($conv20))|0)!=0; //@line 637 "dictionary.cpp"
                if (!($cmp22)) { __label__ = 15;break $if_then7$$if_end27$11; } //@line 637 "dictionary.cpp"
              }
            } while(0);
  
            var $19=$c; //@line 639 "dictionary.cpp"
            var $20=HEAP32[(($phon_out_ix)>>2)]; //@line 639 "dictionary.cpp"
            var $21=$phon_out_addr; //@line 639 "dictionary.cpp"
            var $arrayidx24=(($21+$20)&4294967295); //@line 639 "dictionary.cpp"
            var $call=__Z8utf8_outjPc($19, $arrayidx24); //@line 639 "dictionary.cpp"
            var $22=HEAP32[(($phon_out_ix)>>2)]; //@line 639 "dictionary.cpp"
            var $add=((($22)+($call))&4294967295); //@line 639 "dictionary.cpp"
            HEAP32[(($phon_out_ix)>>2)]=$add; //@line 639 "dictionary.cpp"
            ; //@line 640 "dictionary.cpp"
          }
        } while(0);
  
        var $23=$plist; //@line 644 "dictionary.cpp"
        var $ph=(($23+8)&4294967295); //@line 644 "dictionary.cpp"
        var $24=HEAP32[(($ph)>>2)]; //@line 644 "dictionary.cpp"
        var $code=(($24+10)&4294967295); //@line 644 "dictionary.cpp"
        var $25=HEAPU8[($code)]; //@line 644 "dictionary.cpp"
        var $conv28=((($25))&255); //@line 644 "dictionary.cpp"
        var $cmp29=((($conv28))|0)==21; //@line 644 "dictionary.cpp"
        if ($cmp29) { __label__ = 16;; } else { __label__ = 17;; } //@line 644 "dictionary.cpp"
        $if_then30$$if_else37$23: do { 
          if (__label__ == 16) {
  
            var $26=$plist; //@line 647 "dictionary.cpp"
            var $tone_ph=(($26+3)&4294967295); //@line 647 "dictionary.cpp"
            var $27=HEAPU8[($tone_ph)]; //@line 647 "dictionary.cpp"
            var $idxprom=((($27))&255); //@line 647 "dictionary.cpp"
            var $arrayidx31=((_phoneme_tab_list+$idxprom*48)&4294967295); //@line 647 "dictionary.cpp"
            var $name=(($arrayidx31)&4294967295); //@line 647 "dictionary.cpp"
            var $arraydecay=(($name)&4294967295); //@line 647 "dictionary.cpp"
            $p=$arraydecay; //@line 647 "dictionary.cpp"
            var $28=HEAP32[(($phon_out_ix)>>2)]; //@line 649 "dictionary.cpp"
            var $29=$phon_out_addr; //@line 649 "dictionary.cpp"
            var $arrayidx32=(($29+$28)&4294967295); //@line 649 "dictionary.cpp"
            var $30=$p; //@line 649 "dictionary.cpp"
            var $call33=_sprintf($arrayidx32, ((__str9125)&4294967295), allocate([$30,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 649 "dictionary.cpp"
            var $31=$p; //@line 650 "dictionary.cpp"
            var $call34=_strlen($31); //@line 650 "dictionary.cpp"
            var $32=HEAP32[(($phon_out_ix)>>2)]; //@line 650 "dictionary.cpp"
            var $add35=((($call34)+2)&4294967295); //@line 650 "dictionary.cpp"
            var $add36=((($add35)+($32))&4294967295); //@line 650 "dictionary.cpp"
            HEAP32[(($phon_out_ix)>>2)]=$add36; //@line 650 "dictionary.cpp"
            ; //@line 651 "dictionary.cpp"
          }
          else if (__label__ == 17) {
  
            var $33=$phon_out_addr; //@line 654 "dictionary.cpp"
            var $34=$plist; //@line 654 "dictionary.cpp"
            var $ph38=(($34+8)&4294967295); //@line 654 "dictionary.cpp"
            var $35=HEAP32[(($ph38)>>2)]; //@line 654 "dictionary.cpp"
            var $36=$plist; //@line 654 "dictionary.cpp"
            __ZL15WritePhMnemonicPcPiP11PHONEME_TABP12PHONEME_LIST($33, $phon_out_ix, $35, $36); //@line 654 "dictionary.cpp"
            var $37=$plist; //@line 656 "dictionary.cpp"
            var $synthflags39=(($37+4)&4294967295); //@line 656 "dictionary.cpp"
            var $38=HEAPU16[(($synthflags39)>>1)]; //@line 656 "dictionary.cpp"
            var $conv40=((($38))&65535); //@line 656 "dictionary.cpp"
            var $and41=($conv40) & 8; //@line 656 "dictionary.cpp"
            var $tobool42=((($and41))|0)!=0; //@line 656 "dictionary.cpp"
            if ($tobool42) { __label__ = 18;; } else { __label__ = 19;; } //@line 656 "dictionary.cpp"
            if (__label__ == 18) {
  
              var $39=$phon_out_addr; //@line 658 "dictionary.cpp"
              var $40=HEAP32[((((_phoneme_tab+48)&4294967295))>>2)]; //@line 658 "dictionary.cpp"
              __ZL15WritePhMnemonicPcPiP11PHONEME_TABP12PHONEME_LIST($39, $phon_out_ix, $40, 0); //@line 658 "dictionary.cpp"
              ; //@line 659 "dictionary.cpp"
            }
  
            var $41=$plist; //@line 660 "dictionary.cpp"
            var $synthflags45=(($41+4)&4294967295); //@line 660 "dictionary.cpp"
            var $42=HEAPU16[(($synthflags45)>>1)]; //@line 660 "dictionary.cpp"
            var $conv46=((($42))&65535); //@line 660 "dictionary.cpp"
            var $and47=($conv46) & 4; //@line 660 "dictionary.cpp"
            var $tobool48=((($and47))|0)!=0; //@line 660 "dictionary.cpp"
            if ($tobool48) { __label__ = 20;; } else { __label__ = 22;; } //@line 660 "dictionary.cpp"
            $land_lhs_true$$if_end52$29: do { 
              if (__label__ == 20) {
  
                var $43=$plist; //@line 660 "dictionary.cpp"
                var $type=(($43+15)&4294967295); //@line 660 "dictionary.cpp"
                var $44=HEAPU8[($type)]; //@line 660 "dictionary.cpp"
                var $conv49=((($44))&255); //@line 660 "dictionary.cpp"
                var $cmp50=((($conv49))|0)!=2; //@line 660 "dictionary.cpp"
                if (!($cmp50)) { __label__ = 22;break $land_lhs_true$$if_end52$29; } //@line 660 "dictionary.cpp"
  
                var $45=$phon_out_addr; //@line 663 "dictionary.cpp"
                var $46=HEAP32[((((_phoneme_tab+80)&4294967295))>>2)]; //@line 663 "dictionary.cpp"
                __ZL15WritePhMnemonicPcPiP11PHONEME_TABP12PHONEME_LIST($45, $phon_out_ix, $46, 0); //@line 663 "dictionary.cpp"
                ; //@line 664 "dictionary.cpp"
              }
            } while(0);
  
            var $47=$plist; //@line 665 "dictionary.cpp"
            var $tone_ph53=(($47+3)&4294967295); //@line 665 "dictionary.cpp"
            var $48=HEAPU8[($tone_ph53)]; //@line 665 "dictionary.cpp"
            var $conv54=((($48))&255); //@line 665 "dictionary.cpp"
            var $cmp55=((($conv54))|0) > 0; //@line 665 "dictionary.cpp"
            if (!($cmp55)) { __label__ = 24;break $if_then30$$if_else37$23; } //@line 665 "dictionary.cpp"
  
            var $49=$phon_out_addr; //@line 667 "dictionary.cpp"
            var $50=$plist; //@line 667 "dictionary.cpp"
            var $tone_ph57=(($50+3)&4294967295); //@line 667 "dictionary.cpp"
            var $51=HEAPU8[($tone_ph57)]; //@line 667 "dictionary.cpp"
            var $idxprom58=((($51))&255); //@line 667 "dictionary.cpp"
            var $arrayidx59=((_phoneme_tab+$idxprom58*4)&4294967295); //@line 667 "dictionary.cpp"
            var $52=HEAP32[(($arrayidx59)>>2)]; //@line 667 "dictionary.cpp"
            __ZL15WritePhMnemonicPcPiP11PHONEME_TABP12PHONEME_LIST($49, $phon_out_ix, $52, 0); //@line 667 "dictionary.cpp"
            ; //@line 668 "dictionary.cpp"
          }
        } while(0);
  
        var $53=$ix; //@line 613 "dictionary.cpp"
        var $inc62=((($53)+1)&4294967295); //@line 613 "dictionary.cpp"
        $ix=$inc62; //@line 613 "dictionary.cpp"
        __label__ = 2;continue $for_cond$4; //@line 613 "dictionary.cpp"
      }
  
      var $54=HEAP32[(($phon_out_ix)>>2)]; //@line 672 "dictionary.cpp"
      var $55=$n_phon_out_addr; //@line 672 "dictionary.cpp"
      var $cmp63=((($54))|0) >= ((($55))|0); //@line 672 "dictionary.cpp"
      if ($cmp63) { __label__ = 26;; } else { __label__ = 27;; } //@line 672 "dictionary.cpp"
      if (__label__ == 26) {
  
        var $56=$n_phon_out_addr; //@line 673 "dictionary.cpp"
        var $sub65=((($56)-1)&4294967295); //@line 673 "dictionary.cpp"
        HEAP32[(($phon_out_ix)>>2)]=$sub65; //@line 673 "dictionary.cpp"
        ; //@line 673 "dictionary.cpp"
      }
  
      var $57=HEAP32[(($phon_out_ix)>>2)]; //@line 674 "dictionary.cpp"
      var $58=$phon_out_addr; //@line 674 "dictionary.cpp"
      var $arrayidx67=(($58+$57)&4294967295); //@line 674 "dictionary.cpp"
      HEAP8[($arrayidx67)]=0; //@line 674 "dictionary.cpp"
      ; //@line 675 "dictionary.cpp"
    }
  
    STACKTOP = __stackBase__;
    return; //@line 676 "dictionary.cpp"
    return;
  }
  

  function __ZL15WritePhMnemonicPcPiP11PHONEME_TABP12PHONEME_LIST($phon_out, $ix, $ph, $plist) {
    var __stackBase__  = STACKTOP; STACKTOP += 152; _memset(__stackBase__, 0, 152);
    var __label__;
    var __lastLabel__ = null;
  
    var $phon_out_addr;
    var $ix_addr;
    var $ph_addr;
    var $plist_addr;
    var $c;
    var $mnem;
    var $len;
    var $first;
    var $ipa_control;
    var $phdata=__stackBase__;
    $phon_out_addr=$phon_out;
    $ix_addr=$ix;
    $ph_addr=$ph;
    $plist_addr=$plist;
    $ipa_control=0; //@line 532 "dictionary.cpp"
    var $0=HEAP32[((_option_phonemes)>>2)]; //@line 535 "dictionary.cpp"
    var $cmp=((($0))|0)==3; //@line 535 "dictionary.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 8;; } //@line 535 "dictionary.cpp"
    $if_then$$if_end20$2: do { 
      if (__label__ == 1) {
  
        var $ipa_string=(($phdata+132)&4294967295); //@line 538 "dictionary.cpp"
        var $arrayidx=(($ipa_string)&4294967295); //@line 538 "dictionary.cpp"
        HEAP8[($arrayidx)]=0; //@line 538 "dictionary.cpp"
        var $1=$plist_addr; //@line 540 "dictionary.cpp"
        var $cmp1=((($1))|0)==0; //@line 540 "dictionary.cpp"
        if ($cmp1) { __label__ = 2;; } else { __label__ = 3;; } //@line 540 "dictionary.cpp"
        if (__label__ == 2) {
  
          var $2=$ph_addr; //@line 542 "dictionary.cpp"
          var $code=(($2+10)&4294967295); //@line 542 "dictionary.cpp"
          var $3=HEAPU8[($code)]; //@line 542 "dictionary.cpp"
          var $conv=((($3))&255); //@line 542 "dictionary.cpp"
          __Z17InterpretPhoneme2iP12PHONEME_DATA($conv, $phdata); //@line 542 "dictionary.cpp"
          ; //@line 543 "dictionary.cpp"
        }
        else if (__label__ == 3) {
  
          var $4=$plist_addr; //@line 546 "dictionary.cpp"
          __Z16InterpretPhonemeP10TranslatoriP12PHONEME_LISTP12PHONEME_DATA(0, 0, $4, $phdata); //@line 546 "dictionary.cpp"
          ;
        }
  
        var $ipa_string3=(($phdata+132)&4294967295); //@line 549 "dictionary.cpp"
        var $arraydecay=(($ipa_string3)&4294967295); //@line 549 "dictionary.cpp"
        var $call=_strlen($arraydecay); //@line 549 "dictionary.cpp"
        $len=$call; //@line 549 "dictionary.cpp"
        var $cmp4=((($call))|0) > 0; //@line 550 "dictionary.cpp"
        if (!($cmp4)) { __label__ = 8;break $if_then$$if_end20$2; } //@line 550 "dictionary.cpp"
  
        var $ipa_string6=(($phdata+132)&4294967295); //@line 552 "dictionary.cpp"
        var $arrayidx7=(($ipa_string6)&4294967295); //@line 552 "dictionary.cpp"
        var $5=HEAP8[($arrayidx7)]; //@line 552 "dictionary.cpp"
        var $conv8=(tempInt=(($5)),(tempInt>=128?tempInt-256:tempInt)); //@line 552 "dictionary.cpp"
        $ipa_control=$conv8; //@line 552 "dictionary.cpp"
        var $cmp9=((($conv8))>>>0) > 32; //@line 552 "dictionary.cpp"
        if ($cmp9) { __lastLabel__ = 5; __label__ = 6;; } else { __lastLabel__ = 5; __label__ = 7;; } //@line 552 "dictionary.cpp"
        if (__label__ == 6) {
  
          var $6=$ix_addr; //@line 554 "dictionary.cpp"
          var $7=HEAP32[(($6)>>2)]; //@line 554 "dictionary.cpp"
          var $8=$phon_out_addr; //@line 554 "dictionary.cpp"
          var $arrayidx11=(($8+$7)&4294967295); //@line 554 "dictionary.cpp"
          var $ipa_string12=(($phdata+132)&4294967295); //@line 554 "dictionary.cpp"
          var $arraydecay13=(($ipa_string12)&4294967295); //@line 554 "dictionary.cpp"
          var $call14=_strcpy($arrayidx11, $arraydecay13); //@line 554 "dictionary.cpp"
          var $9=$len; //@line 555 "dictionary.cpp"
          var $10=$ix_addr; //@line 555 "dictionary.cpp"
          var $11=HEAP32[(($10)>>2)]; //@line 555 "dictionary.cpp"
          var $add=((($11)+($9))&4294967295); //@line 555 "dictionary.cpp"
          HEAP32[(($10)>>2)]=$add; //@line 555 "dictionary.cpp"
          var $_pr=$ipa_control; //@line 557 "dictionary.cpp"
          __lastLabel__ = 6; ; //@line 556 "dictionary.cpp"
        }
  
        var $12=__lastLabel__ == 6 ? $_pr : ($conv8); //@line 557 "dictionary.cpp"
        var $cmp16=((($12))>>>0) >= 32; //@line 557 "dictionary.cpp"
        if ($cmp16) { __label__ = 23;break $if_then$$if_end20$2; } else { __label__ = 8;break $if_then$$if_end20$2; } //@line 557 "dictionary.cpp"
      }
    } while(0);
    $for_end$$if_end20$12: do { 
      if (__label__ == 8) {
  
        $first=1; //@line 562 "dictionary.cpp"
        var $13=$ph_addr; //@line 563 "dictionary.cpp"
        var $mnemonic=(($13)&4294967295); //@line 563 "dictionary.cpp"
        var $14=HEAP32[(($mnemonic)>>2)]; //@line 563 "dictionary.cpp"
        $mnem=$14; //@line 563 "dictionary.cpp"
        ; //@line 563 "dictionary.cpp"
        $for_cond$14: while(1) { 
  
          var $15=$mnem; //@line 563 "dictionary.cpp"
          var $and=($15) & 255; //@line 563 "dictionary.cpp"
          $c=$and; //@line 563 "dictionary.cpp"
          var $cmp21=((($and))|0)!=0; //@line 563 "dictionary.cpp"
          if (!($cmp21)) { __label__ = 23;break $for_end$$if_end20$12; } //@line 563 "dictionary.cpp"
  
          var $16=$c; //@line 565 "dictionary.cpp"
          var $cmp22=((($16))|0)==47; //@line 565 "dictionary.cpp"
          var $17=HEAP32[((_option_phoneme_variants)>>2)]; //@line 565 "dictionary.cpp"
          var $cmp23=((($17))|0)==0; //@line 565 "dictionary.cpp"
          var $or_cond=($cmp22) & ($cmp23); //@line 565 "dictionary.cpp"
          if ($or_cond) { __label__ = 23;break $for_end$$if_end20$12; } //@line 565 "dictionary.cpp"
  
          var $18=HEAP32[((_option_phonemes)>>2)]; //@line 568 "dictionary.cpp"
          var $cmp26=((($18))|0)==3; //@line 568 "dictionary.cpp"
          if ($cmp26) { __label__ = 12;; } else { __label__ = 20;; } //@line 568 "dictionary.cpp"
          $if_then27$$if_else54$18: do { 
            if (__label__ == 12) {
  
              var $19=$first; //@line 571 "dictionary.cpp"
              var $tobool=((($19))|0)!=0; //@line 571 "dictionary.cpp"
              var $20=$c; //@line 571 "dictionary.cpp"
              var $cmp29=((($20))|0)==95; //@line 571 "dictionary.cpp"
              var $or_cond3=($tobool) & ($cmp29); //@line 571 "dictionary.cpp"
              if ($or_cond3) { __label__ = 23;break $for_end$$if_end20$12; } //@line 571 "dictionary.cpp"
  
              var $cmp32=((($20))|0)==35; //@line 574 "dictionary.cpp"
              if ($cmp32) { __label__ = 14;; } else { __label__ = 15;; } //@line 574 "dictionary.cpp"
              if (__label__ == 14) {
  
                var $21=$ph_addr; //@line 574 "dictionary.cpp"
                var $type=(($21+11)&4294967295); //@line 574 "dictionary.cpp"
                var $22=HEAPU8[($type)]; //@line 574 "dictionary.cpp"
                var $conv34=((($22))&255); //@line 574 "dictionary.cpp"
                var $cmp35=((($conv34))|0)==2; //@line 574 "dictionary.cpp"
                if ($cmp35) { __label__ = 23;break $for_end$$if_end20$12; } //@line 574 "dictionary.cpp"
              }
  
              var $23=$first; //@line 578 "dictionary.cpp"
              var $tobool38=((($23))|0)!=0; //@line 578 "dictionary.cpp"
              if ($tobool38) { __label__ = 17;; } else { __label__ = 16;; } //@line 578 "dictionary.cpp"
              if (__label__ == 16) {
  
                var $24=$c; //@line 578 "dictionary.cpp"
                var $isdigittmp=((($24)-48)&4294967295); //@line 578 "dictionary.cpp"
                var $isdigit=((($isdigittmp))>>>0) < 10; //@line 578 "dictionary.cpp"
                var $call40=((($isdigit))&1); //@line 578 "dictionary.cpp"
                var $tobool41=((($call40))|0)!=0; //@line 578 "dictionary.cpp"
                if ($tobool41) { __label__ = 22;break $if_then27$$if_else54$18; } //@line 578 "dictionary.cpp"
              }
  
              var $25=$c; //@line 581 "dictionary.cpp"
              var $cmp44=((($25))|0) >= 32; //@line 581 "dictionary.cpp"
              var $26=$c; //@line 581 "dictionary.cpp"
              var $cmp46=((($26))|0) < 128; //@line 581 "dictionary.cpp"
              var $or_cond1=($cmp44) & ($cmp46); //@line 581 "dictionary.cpp"
              if ($or_cond1) { __label__ = 18;; } else { __label__ = 19;; } //@line 581 "dictionary.cpp"
              if (__label__ == 18) {
  
                var $27=$c; //@line 582 "dictionary.cpp"
                var $sub=((($27)-32)&4294967295); //@line 582 "dictionary.cpp"
                var $arrayidx48=((_ipa1+$sub*2)&4294967295); //@line 582 "dictionary.cpp"
                var $28=HEAPU16[(($arrayidx48)>>1)]; //@line 582 "dictionary.cpp"
                var $conv49=((($28))&65535); //@line 582 "dictionary.cpp"
                $c=$conv49; //@line 582 "dictionary.cpp"
                ; //@line 582 "dictionary.cpp"
              }
  
              var $29=$c; //@line 584 "dictionary.cpp"
              var $30=$ix_addr; //@line 584 "dictionary.cpp"
              var $31=HEAP32[(($30)>>2)]; //@line 584 "dictionary.cpp"
              var $32=$phon_out_addr; //@line 584 "dictionary.cpp"
              var $arrayidx51=(($32+$31)&4294967295); //@line 584 "dictionary.cpp"
              var $call52=__Z8utf8_outjPc($29, $arrayidx51); //@line 584 "dictionary.cpp"
              var $33=$ix_addr; //@line 584 "dictionary.cpp"
              var $34=HEAP32[(($33)>>2)]; //@line 584 "dictionary.cpp"
              var $add53=((($34)+($call52))&4294967295); //@line 584 "dictionary.cpp"
              HEAP32[(($33)>>2)]=$add53; //@line 584 "dictionary.cpp"
              __label__ = 21;break $if_then27$$if_else54$18; //@line 585 "dictionary.cpp"
            }
            else if (__label__ == 20) {
  
              var $35=$c; //@line 588 "dictionary.cpp"
              var $conv55=((($35)) & 255); //@line 588 "dictionary.cpp"
              var $36=$ix_addr; //@line 588 "dictionary.cpp"
              var $37=HEAP32[(($36)>>2)]; //@line 588 "dictionary.cpp"
              var $inc=((($37)+1)&4294967295); //@line 588 "dictionary.cpp"
              HEAP32[(($36)>>2)]=$inc; //@line 588 "dictionary.cpp"
              var $38=$phon_out_addr; //@line 588 "dictionary.cpp"
              var $arrayidx56=(($38+$37)&4294967295); //@line 588 "dictionary.cpp"
              HEAP8[($arrayidx56)]=$conv55; //@line 588 "dictionary.cpp"
              __label__ = 21;break $if_then27$$if_else54$18;
            }
          } while(0);
          if (__label__ == 21) {
  
            $first=0; //@line 590 "dictionary.cpp"
            ; //@line 591 "dictionary.cpp"
          }
  
          var $39=$mnem; //@line 563 "dictionary.cpp"
          var $shr=($39) >> 8; //@line 563 "dictionary.cpp"
          $mnem=$shr; //@line 563 "dictionary.cpp"
          __label__ = 9;continue $for_cond$14; //@line 563 "dictionary.cpp"
        }
      }
    } while(0);
  
    STACKTOP = __stackBase__;
    return; //@line 592 "dictionary.cpp"
    return;
  }
  

  function __Z7IsVowelP10Translatori($tr, $letter) {
    ;
    var __label__;
  
    var $tr_addr;
    var $letter_addr;
    $tr_addr=$tr;
    $letter_addr=$letter;
    var $0=$tr_addr; //@line 763 "dictionary.cpp"
    var $1=$letter_addr; //@line 763 "dictionary.cpp"
    var $call=__ZL8IsLetterP10Translatorii($0, $1, 7); //@line 763 "dictionary.cpp"
    ;
    return $call; //@line 763 "dictionary.cpp"
    return null;
  }
  

  function __ZL8IsLetterP10Translatorii($tr, $letter, $group) {
    ;
    var __label__;
  
    var $retval;
    var $tr_addr;
    var $letter_addr;
    var $group_addr;
    var $letter2;
    $tr_addr=$tr;
    $letter_addr=$letter;
    $group_addr=$group;
    var $0=$group_addr; //@line 731 "dictionary.cpp"
    var $1=$tr_addr; //@line 731 "dictionary.cpp"
    var $letter_groups=(($1+968)&4294967295); //@line 731 "dictionary.cpp"
    var $arrayidx=(($letter_groups+$0*4)&4294967295); //@line 731 "dictionary.cpp"
    var $2=HEAP32[(($arrayidx)>>2)]; //@line 731 "dictionary.cpp"
    var $cmp=((($2))|0)!=0; //@line 731 "dictionary.cpp"
    var $3=$group_addr; //@line 733 "dictionary.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 4;; } //@line 731 "dictionary.cpp"
    $if_then$$if_end4$2: do { 
      if (__label__ == 1) {
  
        var $4=$tr_addr; //@line 733 "dictionary.cpp"
        var $letter_groups1=(($4+968)&4294967295); //@line 733 "dictionary.cpp"
        var $arrayidx2=(($letter_groups1+$3*4)&4294967295); //@line 733 "dictionary.cpp"
        var $5=HEAP32[(($arrayidx2)>>2)]; //@line 733 "dictionary.cpp"
        var $6=$letter_addr; //@line 733 "dictionary.cpp"
        var $call=_wcschr($5, $6); //@line 733 "dictionary.cpp"
        var $tobool=((($call))|0)!=0; //@line 733 "dictionary.cpp"
        if ($tobool) { __label__ = 2;; } else { __label__ = 3;; } //@line 733 "dictionary.cpp"
        if (__label__ == 2) {
  
          $retval=1; //@line 734 "dictionary.cpp"
          ; //@line 734 "dictionary.cpp"
        }
        else if (__label__ == 3) {
  
          $retval=0; //@line 735 "dictionary.cpp"
          ; //@line 735 "dictionary.cpp"
        }
      }
      else if (__label__ == 4) {
  
        var $cmp5=((($3))|0) > 7; //@line 738 "dictionary.cpp"
        if ($cmp5) { __label__ = 5;; } else { __label__ = 6;; } //@line 738 "dictionary.cpp"
        if (__label__ == 5) {
  
          $retval=0; //@line 739 "dictionary.cpp"
          ; //@line 739 "dictionary.cpp"
        }
        else if (__label__ == 6) {
  
          var $7=$tr_addr; //@line 741 "dictionary.cpp"
          var $letter_bits_offset=(($7+964)&4294967295); //@line 741 "dictionary.cpp"
          var $8=HEAP32[(($letter_bits_offset)>>2)]; //@line 741 "dictionary.cpp"
          var $cmp8=((($8))|0) > 0; //@line 741 "dictionary.cpp"
          var $9=$letter_addr; //@line 743 "dictionary.cpp"
          if ($cmp8) { __label__ = 7;; } else { __label__ = 11;; } //@line 741 "dictionary.cpp"
          $if_then9$$if_else15$11: do { 
            if (__label__ == 7) {
  
              var $10=$tr_addr; //@line 743 "dictionary.cpp"
              var $letter_bits_offset10=(($10+964)&4294967295); //@line 743 "dictionary.cpp"
              var $11=HEAP32[(($letter_bits_offset10)>>2)]; //@line 743 "dictionary.cpp"
              var $sub=((($9)-($11))&4294967295); //@line 743 "dictionary.cpp"
              $letter2=$sub; //@line 743 "dictionary.cpp"
              var $cmp11=((($sub))|0) > 0; //@line 743 "dictionary.cpp"
              if ($cmp11) { __label__ = 8;; } else { __label__ = 10;; } //@line 743 "dictionary.cpp"
              $land_lhs_true$$if_else$13: do { 
                if (__label__ == 8) {
  
                  var $12=$letter2; //@line 743 "dictionary.cpp"
                  var $cmp12=((($12))|0) < 128; //@line 743 "dictionary.cpp"
                  if (!($cmp12)) { __label__ = 10;break $land_lhs_true$$if_else$13; } //@line 743 "dictionary.cpp"
  
                  var $13=$letter2; //@line 744 "dictionary.cpp"
                  $letter_addr=$13; //@line 744 "dictionary.cpp"
                  __label__ = 13;break $if_then9$$if_else15$11; //@line 747 "dictionary.cpp"
                }
              } while(0);
  
              $retval=0; //@line 746 "dictionary.cpp"
              __label__ = 16;break $if_then$$if_end4$2; //@line 746 "dictionary.cpp"
            }
            else if (__label__ == 11) {
  
              var $cmp16=((($9))|0) >= 192; //@line 750 "dictionary.cpp"
              var $14=$letter_addr; //@line 750 "dictionary.cpp"
              var $cmp18=((($14))|0) < 606; //@line 750 "dictionary.cpp"
              var $or_cond=($cmp16) & ($cmp18); //@line 750 "dictionary.cpp"
              if (!($or_cond)) { __label__ = 13;break $if_then9$$if_else15$11; } //@line 750 "dictionary.cpp"
  
              var $15=$letter_addr; //@line 751 "dictionary.cpp"
              var $sub20=((($15)-192)&4294967295); //@line 751 "dictionary.cpp"
              var $arrayidx21=((__ZL13remove_accent+$sub20)&4294967295); //@line 751 "dictionary.cpp"
              var $16=HEAPU8[($arrayidx21)]; //@line 751 "dictionary.cpp"
              var $idxprom=((($16))&255); //@line 751 "dictionary.cpp"
              var $17=$tr_addr; //@line 751 "dictionary.cpp"
              var $letter_bits=(($17+708)&4294967295); //@line 751 "dictionary.cpp"
              var $arrayidx22=(($letter_bits+$idxprom)&4294967295); //@line 751 "dictionary.cpp"
              var $18=HEAPU8[($arrayidx22)]; //@line 751 "dictionary.cpp"
              var $conv=((($18))&255); //@line 751 "dictionary.cpp"
              var $19=$group_addr; //@line 751 "dictionary.cpp"
              var $shl=1 << ($19); //@line 751 "dictionary.cpp"
              var $and=($shl) & ($conv); //@line 751 "dictionary.cpp"
              $retval=$and; //@line 751 "dictionary.cpp"
              __label__ = 16;break $if_then$$if_end4$2; //@line 751 "dictionary.cpp"
            }
          } while(0);
  
          var $20=$letter_addr; //@line 754 "dictionary.cpp"
          var $cmp25=((($20))|0) >= 0; //@line 754 "dictionary.cpp"
          var $21=$letter_addr; //@line 754 "dictionary.cpp"
          var $cmp27=((($21))|0) < 128; //@line 754 "dictionary.cpp"
          var $or_cond1=($cmp25) & ($cmp27); //@line 754 "dictionary.cpp"
          if ($or_cond1) { __label__ = 14;; } else { __label__ = 15;; } //@line 754 "dictionary.cpp"
          if (__label__ == 14) {
  
            var $22=$letter_addr; //@line 755 "dictionary.cpp"
            var $23=$tr_addr; //@line 755 "dictionary.cpp"
            var $letter_bits29=(($23+708)&4294967295); //@line 755 "dictionary.cpp"
            var $arrayidx30=(($letter_bits29+$22)&4294967295); //@line 755 "dictionary.cpp"
            var $24=HEAPU8[($arrayidx30)]; //@line 755 "dictionary.cpp"
            var $conv31=((($24))&255); //@line 755 "dictionary.cpp"
            var $25=$group_addr; //@line 755 "dictionary.cpp"
            var $shl32=1 << ($25); //@line 755 "dictionary.cpp"
            var $and33=($shl32) & ($conv31); //@line 755 "dictionary.cpp"
            $retval=$and33; //@line 755 "dictionary.cpp"
            ; //@line 755 "dictionary.cpp"
          }
          else if (__label__ == 15) {
  
            $retval=0; //@line 757 "dictionary.cpp"
            ; //@line 757 "dictionary.cpp"
          }
        }
      }
    } while(0);
  
    var $26=$retval; //@line 758 "dictionary.cpp"
    ;
    return $26; //@line 758 "dictionary.cpp"
    return null;
  }
  

  function __Z14UnpronouncableP10TranslatorPci($tr, $word, $posn) {
    var __stackBase__  = STACKTOP; STACKTOP += 4; _memset(__stackBase__, 0, 4);
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $tr_addr;
    var $word_addr;
    var $posn_addr;
    var $c=__stackBase__;
    var $c1;
    var $vowel_posn;
    var $index;
    var $count;
    var $apostrophe;
    $tr_addr=$tr;
    $word_addr=$word;
    $posn_addr=$posn;
    $c1=0; //@line 795 "dictionary.cpp"
    $vowel_posn=9; //@line 796 "dictionary.cpp"
    $apostrophe=0; //@line 799 "dictionary.cpp"
    var $0=$word_addr; //@line 801 "dictionary.cpp"
    var $call=__Z7utf8_inPiPKc($c, $0); //@line 801 "dictionary.cpp"
    var $1=$tr_addr; //@line 802 "dictionary.cpp"
    var $letter_bits_offset=(($1+964)&4294967295); //@line 802 "dictionary.cpp"
    var $2=HEAP32[(($letter_bits_offset)>>2)]; //@line 802 "dictionary.cpp"
    var $cmp=((($2))|0) > 0; //@line 802 "dictionary.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 3;; } //@line 802 "dictionary.cpp"
    $land_lhs_true$$if_end$2: do { 
      if (__label__ == 1) {
  
        var $3=HEAP32[(($c)>>2)]; //@line 802 "dictionary.cpp"
        var $cmp1=((($3))|0) < 577; //@line 802 "dictionary.cpp"
        if (!($cmp1)) { __label__ = 3;break $land_lhs_true$$if_end$2; } //@line 802 "dictionary.cpp"
  
        $retval=0; //@line 805 "dictionary.cpp"
        __label__ = 30;break $land_lhs_true$$if_end$2; //@line 805 "dictionary.cpp"
      }
    } while(0);
    $return$$if_end$5: do { 
      if (__label__ == 3) {
  
        var $4=$tr_addr; //@line 808 "dictionary.cpp"
        var $langopts=(($4)&4294967295); //@line 808 "dictionary.cpp"
        var $param=(($langopts+24)&4294967295); //@line 808 "dictionary.cpp"
        var $arrayidx=(($param+20)&4294967295); //@line 808 "dictionary.cpp"
        var $5=HEAP32[(($arrayidx)>>2)]; //@line 808 "dictionary.cpp"
        var $cmp2=((($5))|0)==1; //@line 808 "dictionary.cpp"
        if ($cmp2) { __label__ = 4;; } else { __label__ = 5;; } //@line 808 "dictionary.cpp"
        if (__label__ == 4) {
  
          $retval=0; //@line 809 "dictionary.cpp"
          ; //@line 809 "dictionary.cpp"
        }
        else if (__label__ == 5) {
  
          var $6=$word_addr; //@line 811 "dictionary.cpp"
          var $7=HEAP8[($6)]; //@line 811 "dictionary.cpp"
          var $conv=(tempInt=(($7)),(tempInt>=128?tempInt-256:tempInt)); //@line 811 "dictionary.cpp"
          HEAP32[(($c)>>2)]=$conv; //@line 811 "dictionary.cpp"
          var $cmp5=((($conv))|0)==32; //@line 811 "dictionary.cpp"
          if ($cmp5) { __label__ = 7;; } else { __label__ = 6;; } //@line 811 "dictionary.cpp"
          $if_then9$$lor_lhs_false$10: do { 
            if (__label__ == 6) {
  
              var $8=HEAP32[(($c)>>2)]; //@line 811 "dictionary.cpp"
              var $cmp6=((($8))|0)==0; //@line 811 "dictionary.cpp"
              var $9=HEAP32[(($c)>>2)]; //@line 811 "dictionary.cpp"
              var $cmp8=((($9))|0)==39; //@line 811 "dictionary.cpp"
              var $or_cond=($cmp6) | ($cmp8); //@line 811 "dictionary.cpp"
              if ($or_cond) { __label__ = 7;break $if_then9$$lor_lhs_false$10; } //@line 811 "dictionary.cpp"
  
              $index=0; //@line 814 "dictionary.cpp"
              $count=0; //@line 815 "dictionary.cpp"
              ; //@line 816 "dictionary.cpp"
              $for_cond$13: while(1) { 
  
                var $10=$index; //@line 818 "dictionary.cpp"
                var $11=$word_addr; //@line 818 "dictionary.cpp"
                var $arrayidx11=(($11+$10)&4294967295); //@line 818 "dictionary.cpp"
                var $call12=__Z7utf8_inPiPKc($c, $arrayidx11); //@line 818 "dictionary.cpp"
                var $12=$index; //@line 818 "dictionary.cpp"
                var $add=((($12)+($call12))&4294967295); //@line 818 "dictionary.cpp"
                $index=$add; //@line 818 "dictionary.cpp"
                var $13=HEAP32[(($c)>>2)]; //@line 819 "dictionary.cpp"
                var $cmp13=((($13))|0)==0; //@line 819 "dictionary.cpp"
                var $14=HEAP32[(($c)>>2)]; //@line 819 "dictionary.cpp"
                var $cmp15=((($14))|0)==32; //@line 819 "dictionary.cpp"
                var $or_cond1=($cmp13) | ($cmp15); //@line 819 "dictionary.cpp"
                if ($or_cond1) { __label__ = 21;break $for_cond$13; } //@line 819 "dictionary.cpp"
  
                var $15=HEAP32[(($c)>>2)]; //@line 822 "dictionary.cpp"
                var $cmp18=((($15))|0)==39; //@line 822 "dictionary.cpp"
                if ($cmp18) { __label__ = 11;; } else { __label__ = 13;; } //@line 822 "dictionary.cpp"
                if (__label__ == 11) {
  
                  var $16=$count; //@line 822 "dictionary.cpp"
                  var $cmp20=((($16))|0) > 1; //@line 822 "dictionary.cpp"
                  if ($cmp20) { __label__ = 21;break $for_cond$13; } //@line 822 "dictionary.cpp"
  
                  var $17=$posn_addr; //@line 822 "dictionary.cpp"
                  var $cmp22=((($17))|0) > 0; //@line 822 "dictionary.cpp"
                  if ($cmp22) { __label__ = 21;break $for_cond$13; } //@line 822 "dictionary.cpp"
                }
  
                var $18=$count; //@line 825 "dictionary.cpp"
                var $cmp25=((($18))|0)==0; //@line 825 "dictionary.cpp"
                if ($cmp25) { __label__ = 14;; } else { __label__ = 15;; } //@line 825 "dictionary.cpp"
                if (__label__ == 14) {
  
                  var $19=HEAP32[(($c)>>2)]; //@line 826 "dictionary.cpp"
                  $c1=$19; //@line 826 "dictionary.cpp"
                  ; //@line 826 "dictionary.cpp"
                }
  
                var $20=$count; //@line 827 "dictionary.cpp"
                var $inc=((($20)+1)&4294967295); //@line 827 "dictionary.cpp"
                $count=$inc; //@line 827 "dictionary.cpp"
                var $21=$tr_addr; //@line 829 "dictionary.cpp"
                var $22=HEAP32[(($c)>>2)]; //@line 829 "dictionary.cpp"
                var $call28=__Z7IsVowelP10Translatori($21, $22); //@line 829 "dictionary.cpp"
                var $tobool=((($call28))|0)!=0; //@line 829 "dictionary.cpp"
                if ($tobool) { __label__ = 16;break $for_cond$13; } //@line 829 "dictionary.cpp"
  
                var $24=HEAP32[(($c)>>2)]; //@line 835 "dictionary.cpp"
                var $cmp31=((($24))|0)==39; //@line 835 "dictionary.cpp"
                if ($cmp31) { __label__ = 18;; } else { __label__ = 19;; } //@line 835 "dictionary.cpp"
                if (__label__ == 18) {
  
                  $apostrophe=1; //@line 836 "dictionary.cpp"
                  __label__ = 9;continue $for_cond$13; //@line 836 "dictionary.cpp"
                }
                else if (__label__ == 19) {
  
                  var $25=HEAP32[(($c)>>2)]; //@line 838 "dictionary.cpp"
                  var $call33=_iswalpha($25); //@line 838 "dictionary.cpp"
                  var $tobool34=((($call33))|0)!=0; //@line 838 "dictionary.cpp"
                  if ($tobool34) { __label__ = 9;continue $for_cond$13; } else { __label__ = 20;break $for_cond$13; } //@line 838 "dictionary.cpp"
                }
              }
              if (__label__ == 21) {
  
                var $_pr=$vowel_posn; //@line 842 "dictionary.cpp"
                __lastLabel__ = 21; ;
              }
              else if (__label__ == 16) {
  
                var $23=$count; //@line 831 "dictionary.cpp"
                $vowel_posn=$23; //@line 831 "dictionary.cpp"
                __lastLabel__ = 16; ; //@line 832 "dictionary.cpp"
              }
              else if (__label__ == 20) {
  
                $retval=0; //@line 839 "dictionary.cpp"
                __label__ = 30;break $return$$if_end$5; //@line 839 "dictionary.cpp"
              }
  
              var $26=__lastLabel__ == 21 ? $_pr : ($23); //@line 842 "dictionary.cpp"
              var $cmp38=((($26))|0) > 2; //@line 842 "dictionary.cpp"
              if ($cmp38) { __label__ = 23;; } else { __label__ = 25;; } //@line 842 "dictionary.cpp"
              $land_lhs_true39$$if_end46$32: do { 
                if (__label__ == 23) {
  
                  var $27=$tr_addr; //@line 842 "dictionary.cpp"
                  var $langopts40=(($27)&4294967295); //@line 842 "dictionary.cpp"
                  var $param41=(($langopts40+24)&4294967295); //@line 842 "dictionary.cpp"
                  var $arrayidx42=(($param41+20)&4294967295); //@line 842 "dictionary.cpp"
                  var $28=HEAP32[(($arrayidx42)>>2)]; //@line 842 "dictionary.cpp"
                  var $cmp43=((($28))|0)==2; //@line 842 "dictionary.cpp"
                  if (!($cmp43)) { __label__ = 25;break $land_lhs_true39$$if_end46$32; } //@line 842 "dictionary.cpp"
  
                  var $29=$tr_addr; //@line 845 "dictionary.cpp"
                  var $30=$word_addr; //@line 845 "dictionary.cpp"
                  var $call45=__ZL15Unpronouncable2P10TranslatorPc($29, $30); //@line 845 "dictionary.cpp"
                  $retval=$call45; //@line 845 "dictionary.cpp"
                  __label__ = 30;break $return$$if_end$5; //@line 845 "dictionary.cpp"
                }
              } while(0);
  
              var $31=$c1; //@line 848 "dictionary.cpp"
              var $32=$tr_addr; //@line 848 "dictionary.cpp"
              var $langopts47=(($32)&4294967295); //@line 848 "dictionary.cpp"
              var $param48=(($langopts47+24)&4294967295); //@line 848 "dictionary.cpp"
              var $arrayidx49=(($param48+20)&4294967295); //@line 848 "dictionary.cpp"
              var $33=HEAP32[(($arrayidx49)>>2)]; //@line 848 "dictionary.cpp"
              var $cmp50=((($31))|0)==((($33))|0); //@line 848 "dictionary.cpp"
              if ($cmp50) { __label__ = 26;; } else { __label__ = 27;; } //@line 848 "dictionary.cpp"
              if (__label__ == 26) {
  
                var $34=$vowel_posn; //@line 849 "dictionary.cpp"
                var $dec=((($34)-1)&4294967295); //@line 849 "dictionary.cpp"
                $vowel_posn=$dec; //@line 849 "dictionary.cpp"
                ; //@line 849 "dictionary.cpp"
              }
  
              var $35=$vowel_posn; //@line 851 "dictionary.cpp"
              var $36=$tr_addr; //@line 851 "dictionary.cpp"
              var $langopts53=(($36)&4294967295); //@line 851 "dictionary.cpp"
              var $max_initial_consonants=(($langopts53+248)&4294967295); //@line 851 "dictionary.cpp"
              var $37=HEAP8[($max_initial_consonants)]; //@line 851 "dictionary.cpp"
              var $conv54=(tempInt=(($37)),(tempInt>=128?tempInt-256:tempInt)); //@line 851 "dictionary.cpp"
              var $add55=((($conv54)+1)&4294967295); //@line 851 "dictionary.cpp"
              var $cmp56=((($35))|0) > ((($add55))|0); //@line 851 "dictionary.cpp"
              if ($cmp56) { __label__ = 28;; } else { __label__ = 29;; } //@line 851 "dictionary.cpp"
              if (__label__ == 28) {
  
                $retval=1; //@line 852 "dictionary.cpp"
                __label__ = 30;break $return$$if_end$5; //@line 852 "dictionary.cpp"
              }
              else if (__label__ == 29) {
  
                $retval=0; //@line 854 "dictionary.cpp"
                __label__ = 30;break $return$$if_end$5; //@line 854 "dictionary.cpp"
              }
            }
          } while(0);
  
          $retval=0; //@line 812 "dictionary.cpp"
          ; //@line 812 "dictionary.cpp"
        }
      }
    } while(0);
  
    var $38=$retval; //@line 856 "dictionary.cpp"
    STACKTOP = __stackBase__;
    return $38; //@line 856 "dictionary.cpp"
    return null;
  }
  

  function __ZL15Unpronouncable2P10TranslatorPc($tr, $word) {
    var __stackBase__  = STACKTOP; STACKTOP += 160; _memset(__stackBase__, 0, 160);
    var __label__;
  
    var $retval;
    var $tr_addr;
    var $word_addr;
    var $c;
    var $end_flags;
    var $ph_buf=__stackBase__;
    $tr_addr=$tr;
    $word_addr=$word;
    var $arrayidx=(($ph_buf)&4294967295); //@line 775 "dictionary.cpp"
    HEAP8[($arrayidx)]=0; //@line 775 "dictionary.cpp"
    var $0=$word_addr; //@line 776 "dictionary.cpp"
    var $arrayidx1=(($0+-1)&4294967295); //@line 776 "dictionary.cpp"
    var $1=HEAP8[($arrayidx1)]; //@line 776 "dictionary.cpp"
    var $conv=(tempInt=(($1)),(tempInt>=128?tempInt-256:tempInt)); //@line 776 "dictionary.cpp"
    $c=$conv; //@line 776 "dictionary.cpp"
    var $2=$word_addr; //@line 777 "dictionary.cpp"
    var $arrayidx2=(($2+-1)&4294967295); //@line 777 "dictionary.cpp"
    HEAP8[($arrayidx2)]=32; //@line 777 "dictionary.cpp"
    var $3=$tr_addr; //@line 778 "dictionary.cpp"
    var $4=$word_addr; //@line 778 "dictionary.cpp"
    var $arraydecay=(($ph_buf)&4294967295); //@line 778 "dictionary.cpp"
    var $call=__Z14TranslateRulesP10TranslatorPcS1_iS1_iPj($3, $4, $arraydecay, 160, 0, -2147483648, 0); //@line 778 "dictionary.cpp"
    $end_flags=$call; //@line 778 "dictionary.cpp"
    var $5=$c; //@line 779 "dictionary.cpp"
    var $conv3=((($5)) & 255); //@line 779 "dictionary.cpp"
    var $6=$word_addr; //@line 779 "dictionary.cpp"
    var $arrayidx4=(($6+-1)&4294967295); //@line 779 "dictionary.cpp"
    HEAP8[($arrayidx4)]=$conv3; //@line 779 "dictionary.cpp"
    var $7=$end_flags; //@line 780 "dictionary.cpp"
    var $cmp=((($7))|0)==0; //@line 780 "dictionary.cpp"
    if ($cmp) { __label__ = 2;; } else { __label__ = 1;; } //@line 780 "dictionary.cpp"
    $if_then$$lor_lhs_false$2: do { 
      if (__label__ == 1) {
  
        var $8=$end_flags; //@line 780 "dictionary.cpp"
        var $and=($8) & 32768; //@line 780 "dictionary.cpp"
        var $tobool=((($and))|0)!=0; //@line 780 "dictionary.cpp"
        if ($tobool) { __label__ = 2;break $if_then$$lor_lhs_false$2; } //@line 780 "dictionary.cpp"
  
        $retval=0; //@line 782 "dictionary.cpp"
        __label__ = 4;break $if_then$$lor_lhs_false$2; //@line 782 "dictionary.cpp"
      }
    } while(0);
    if (__label__ == 2) {
  
      $retval=1; //@line 781 "dictionary.cpp"
      ; //@line 781 "dictionary.cpp"
    }
  
    var $9=$retval; //@line 783 "dictionary.cpp"
    STACKTOP = __stackBase__;
    return $9; //@line 783 "dictionary.cpp"
    return null;
  }
  

  function __Z16ChangeWordStressP10TranslatorPci($tr, $word, $new_stress) {
    var __stackBase__  = STACKTOP; STACKTOP += 248; _memset(__stackBase__, 0, 248);
    var __label__;
  
    var $tr_addr;
    var $word_addr;
    var $new_stress_addr;
    var $ix;
    var $p;
    var $max_stress;
    var $vowel_count=__stackBase__;
    var $stressed_syllable=__stackBase__+4;
    var $phonetic=__stackBase__+8;
    var $vowel_stress=__stackBase__+168;
    $tr_addr=$tr;
    $word_addr=$word;
    $new_stress_addr=$new_stress;
    HEAP32[(($stressed_syllable)>>2)]=0; //@line 1010 "dictionary.cpp"
    var $arraydecay=(($phonetic)&4294967295); //@line 1014 "dictionary.cpp"
    var $0=$word_addr; //@line 1014 "dictionary.cpp"
    var $call=_strcpy($arraydecay, $0); //@line 1014 "dictionary.cpp"
    var $1=$tr_addr; //@line 1015 "dictionary.cpp"
    var $arraydecay1=(($phonetic)&4294967295); //@line 1015 "dictionary.cpp"
    var $arraydecay2=(($vowel_stress)&4294967295); //@line 1015 "dictionary.cpp"
    var $call3=__ZL14GetVowelStressP10TranslatorPhPaRiS3_i($1, $arraydecay1, $arraydecay2, $vowel_count, $stressed_syllable, 0); //@line 1015 "dictionary.cpp"
    $max_stress=$call3; //@line 1015 "dictionary.cpp"
    var $2=$new_stress_addr; //@line 1017 "dictionary.cpp"
    var $cmp=((($2))|0) >= 4; //@line 1017 "dictionary.cpp"
    $ix=1; //@line 1020 "dictionary.cpp"
    if ($cmp) { __label__ = 2;; } else { __label__ = 1;; } //@line 1017 "dictionary.cpp"
    $for_cond$$for_cond9_preheader$2: do { 
      if (__label__ == 2) {
        while(1) { 
  
          var $5=$ix; //@line 1020 "dictionary.cpp"
          var $6=HEAP32[(($vowel_count)>>2)]; //@line 1020 "dictionary.cpp"
          var $cmp4=((($5))|0) < ((($6))|0); //@line 1020 "dictionary.cpp"
          if (!($cmp4)) { __label__ = 9;break $for_cond$$for_cond9_preheader$2; } //@line 1020 "dictionary.cpp"
  
          var $7=$ix; //@line 1022 "dictionary.cpp"
          var $arrayidx=(($vowel_stress+$7)&4294967295); //@line 1022 "dictionary.cpp"
          var $8=HEAP8[($arrayidx)]; //@line 1022 "dictionary.cpp"
          var $conv=(tempInt=(($8)),(tempInt>=128?tempInt-256:tempInt)); //@line 1022 "dictionary.cpp"
          var $9=$max_stress; //@line 1022 "dictionary.cpp"
          var $cmp5=((($conv))|0) >= ((($9))|0); //@line 1022 "dictionary.cpp"
          if ($cmp5) { __label__ = 4;break ; } //@line 1022 "dictionary.cpp"
  
          var $12=$ix; //@line 1020 "dictionary.cpp"
          var $inc=((($12)+1)&4294967295); //@line 1020 "dictionary.cpp"
          $ix=$inc; //@line 1020 "dictionary.cpp"
          __label__ = 2;continue ; //@line 1020 "dictionary.cpp"
        }
  
        var $10=$new_stress_addr; //@line 1024 "dictionary.cpp"
        var $conv7=((($10)) & 255); //@line 1024 "dictionary.cpp"
        var $11=$ix; //@line 1024 "dictionary.cpp"
        var $arrayidx8=(($vowel_stress+$11)&4294967295); //@line 1024 "dictionary.cpp"
        HEAP8[($arrayidx8)]=$conv7; //@line 1024 "dictionary.cpp"
        ; //@line 1025 "dictionary.cpp"
      }
      else if (__label__ == 1) {
  
        var $3=$ix; //@line 1032 "dictionary.cpp"
        var $4=HEAP32[(($vowel_count)>>2)]; //@line 1032 "dictionary.cpp"
        var $cmp101=((($3))|0) < ((($4))|0); //@line 1032 "dictionary.cpp"
        if (!($cmp101)) { __label__ = 9;break $for_cond$$for_cond9_preheader$2; } //@line 1032 "dictionary.cpp"
        while(1) { 
  
          var $13=$ix; //@line 1034 "dictionary.cpp"
          var $arrayidx12=(($vowel_stress+$13)&4294967295); //@line 1034 "dictionary.cpp"
          var $14=HEAP8[($arrayidx12)]; //@line 1034 "dictionary.cpp"
          var $conv13=(tempInt=(($14)),(tempInt>=128?tempInt-256:tempInt)); //@line 1034 "dictionary.cpp"
          var $15=$new_stress_addr; //@line 1034 "dictionary.cpp"
          var $cmp14=((($conv13))|0) > ((($15))|0); //@line 1034 "dictionary.cpp"
          if ($cmp14) { __label__ = 7;; } else { __label__ = 8;; } //@line 1034 "dictionary.cpp"
          if (__label__ == 7) {
  
            var $16=$new_stress_addr; //@line 1035 "dictionary.cpp"
            var $conv16=((($16)) & 255); //@line 1035 "dictionary.cpp"
            var $17=$ix; //@line 1035 "dictionary.cpp"
            var $arrayidx17=(($vowel_stress+$17)&4294967295); //@line 1035 "dictionary.cpp"
            HEAP8[($arrayidx17)]=$conv16; //@line 1035 "dictionary.cpp"
            ; //@line 1035 "dictionary.cpp"
          }
  
          var $18=$ix; //@line 1032 "dictionary.cpp"
          var $inc20=((($18)+1)&4294967295); //@line 1032 "dictionary.cpp"
          $ix=$inc20; //@line 1032 "dictionary.cpp"
          var $19=$ix; //@line 1032 "dictionary.cpp"
          var $20=HEAP32[(($vowel_count)>>2)]; //@line 1032 "dictionary.cpp"
          var $cmp10=((($19))|0) < ((($20))|0); //@line 1032 "dictionary.cpp"
          if ($cmp10) { __label__ = 6;continue ; } else { __label__ = 9;break $for_cond$$for_cond9_preheader$2; } //@line 1032 "dictionary.cpp"
        }
      }
    } while(0);
  
    $ix=1; //@line 1040 "dictionary.cpp"
    var $arraydecay23=(($phonetic)&4294967295); //@line 1041 "dictionary.cpp"
    $p=$arraydecay23; //@line 1041 "dictionary.cpp"
    var $21=$p; //@line 1042 "dictionary.cpp"
    var $22=HEAPU8[($21)]; //@line 1042 "dictionary.cpp"
    var $conv242=((($22))&255); //@line 1042 "dictionary.cpp"
    var $cmp253=((($conv242))|0)!=0; //@line 1042 "dictionary.cpp"
    if ($cmp253) { __label__ = 10;; } else { __label__ = 17;; } //@line 1042 "dictionary.cpp"
    $while_body$$while_end$15: do { 
      if (__label__ == 10) {
        $while_body$16: while(1) { 
  
          var $23=$p; //@line 1044 "dictionary.cpp"
          var $24=HEAPU8[($23)]; //@line 1044 "dictionary.cpp"
          var $idxprom=((($24))&255); //@line 1044 "dictionary.cpp"
          var $arrayidx26=((_phoneme_tab+$idxprom*4)&4294967295); //@line 1044 "dictionary.cpp"
          var $25=HEAP32[(($arrayidx26)>>2)]; //@line 1044 "dictionary.cpp"
          var $type=(($25+11)&4294967295); //@line 1044 "dictionary.cpp"
          var $26=HEAPU8[($type)]; //@line 1044 "dictionary.cpp"
          var $conv27=((($26))&255); //@line 1044 "dictionary.cpp"
          var $cmp28=((($conv27))|0)==2; //@line 1044 "dictionary.cpp"
          if ($cmp28) { __label__ = 11;; } else { __label__ = 16;; } //@line 1044 "dictionary.cpp"
          $land_lhs_true$$if_end44$18: do { 
            if (__label__ == 11) {
  
              var $27=$p; //@line 1044 "dictionary.cpp"
              var $28=HEAPU8[($27)]; //@line 1044 "dictionary.cpp"
              var $idxprom29=((($28))&255); //@line 1044 "dictionary.cpp"
              var $arrayidx30=((_phoneme_tab+$idxprom29*4)&4294967295); //@line 1044 "dictionary.cpp"
              var $29=HEAP32[(($arrayidx30)>>2)]; //@line 1044 "dictionary.cpp"
              var $phflags=(($29+4)&4294967295); //@line 1044 "dictionary.cpp"
              var $30=HEAP32[(($phflags)>>2)]; //@line 1044 "dictionary.cpp"
              var $and=($30) & 1048576; //@line 1044 "dictionary.cpp"
              var $tobool=((($and))|0)!=0; //@line 1044 "dictionary.cpp"
              if ($tobool) { __label__ = 16;break $land_lhs_true$$if_end44$18; } //@line 1044 "dictionary.cpp"
  
              var $31=$ix; //@line 1046 "dictionary.cpp"
              var $arrayidx32=(($vowel_stress+$31)&4294967295); //@line 1046 "dictionary.cpp"
              var $32=HEAP8[($arrayidx32)]; //@line 1046 "dictionary.cpp"
              var $conv33=(tempInt=(($32)),(tempInt>=128?tempInt-256:tempInt)); //@line 1046 "dictionary.cpp"
              var $cmp34=((($conv33))|0)==0; //@line 1046 "dictionary.cpp"
              if ($cmp34) { __label__ = 14;; } else { __label__ = 13;; } //@line 1046 "dictionary.cpp"
              $if_then38$$lor_lhs_false$21: do { 
                if (__label__ == 13) {
  
                  var $33=$ix; //@line 1046 "dictionary.cpp"
                  var $arrayidx35=(($vowel_stress+$33)&4294967295); //@line 1046 "dictionary.cpp"
                  var $34=HEAP8[($arrayidx35)]; //@line 1046 "dictionary.cpp"
                  var $conv36=(tempInt=(($34)),(tempInt>=128?tempInt-256:tempInt)); //@line 1046 "dictionary.cpp"
                  var $cmp37=((($conv36))|0) > 1; //@line 1046 "dictionary.cpp"
                  if ($cmp37) { __label__ = 14;break $if_then38$$lor_lhs_false$21; } else { __label__ = 15;break $if_then38$$lor_lhs_false$21; } //@line 1046 "dictionary.cpp"
                }
              } while(0);
              if (__label__ == 14) {
  
                var $35=$ix; //@line 1047 "dictionary.cpp"
                var $arrayidx39=(($vowel_stress+$35)&4294967295); //@line 1047 "dictionary.cpp"
                var $36=HEAPU8[($arrayidx39)]; //@line 1047 "dictionary.cpp"
                var $idxprom40=((($36))&255); //@line 1047 "dictionary.cpp"
                var $arrayidx41=((__ZL15stress_phonemes+$idxprom40)&4294967295); //@line 1047 "dictionary.cpp"
                var $37=HEAP8[($arrayidx41)]; //@line 1047 "dictionary.cpp"
                var $38=$word_addr; //@line 1047 "dictionary.cpp"
                var $incdec_ptr=(($38+1)&4294967295); //@line 1047 "dictionary.cpp"
                $word_addr=$incdec_ptr; //@line 1047 "dictionary.cpp"
                HEAP8[($38)]=$37; //@line 1047 "dictionary.cpp"
                ; //@line 1047 "dictionary.cpp"
              }
  
              var $39=$ix; //@line 1049 "dictionary.cpp"
              var $inc43=((($39)+1)&4294967295); //@line 1049 "dictionary.cpp"
              $ix=$inc43; //@line 1049 "dictionary.cpp"
              ; //@line 1050 "dictionary.cpp"
            }
          } while(0);
  
          var $40=$p; //@line 1051 "dictionary.cpp"
          var $incdec_ptr45=(($40+1)&4294967295); //@line 1051 "dictionary.cpp"
          $p=$incdec_ptr45; //@line 1051 "dictionary.cpp"
          var $41=HEAP8[($40)]; //@line 1051 "dictionary.cpp"
          var $42=$word_addr; //@line 1051 "dictionary.cpp"
          var $incdec_ptr46=(($42+1)&4294967295); //@line 1051 "dictionary.cpp"
          $word_addr=$incdec_ptr46; //@line 1051 "dictionary.cpp"
          HEAP8[($42)]=$41; //@line 1051 "dictionary.cpp"
          var $43=$p; //@line 1042 "dictionary.cpp"
          var $44=HEAPU8[($43)]; //@line 1042 "dictionary.cpp"
          var $conv24=((($44))&255); //@line 1042 "dictionary.cpp"
          var $cmp25=((($conv24))|0)!=0; //@line 1042 "dictionary.cpp"
          if ($cmp25) { __label__ = 10;continue $while_body$16; } else { __label__ = 17;break $while_body$$while_end$15; } //@line 1042 "dictionary.cpp"
        }
      }
    } while(0);
  
    var $45=$word_addr; //@line 1053 "dictionary.cpp"
    HEAP8[($45)]=0; //@line 1053 "dictionary.cpp"
    STACKTOP = __stackBase__;
    return; //@line 1054 "dictionary.cpp"
    return;
  }
  

  function __ZL14GetVowelStressP10TranslatorPhPaRiS3_i($tr, $phonemes, $vowel_stress, $vowel_count, $stressed_syllable, $control) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $tr_addr;
    var $phonemes_addr;
    var $vowel_stress_addr;
    var $vowel_count_addr;
    var $stressed_syllable_addr;
    var $control_addr;
    var $phcode;
    var $ph;
    var $ph_out;
    var $count;
    var $max_stress;
    var $ix;
    var $j;
    var $stress;
    var $primary_posn;
    $tr_addr=$tr;
    $phonemes_addr=$phonemes;
    $vowel_stress_addr=$vowel_stress;
    $vowel_count_addr=$vowel_count;
    $stressed_syllable_addr=$stressed_syllable;
    $control_addr=$control;
    var $0=$phonemes_addr; //@line 872 "dictionary.cpp"
    $ph_out=$0; //@line 872 "dictionary.cpp"
    $count=1; //@line 873 "dictionary.cpp"
    $max_stress=-1; //@line 874 "dictionary.cpp"
    $stress=-1; //@line 877 "dictionary.cpp"
    $primary_posn=0; //@line 878 "dictionary.cpp"
    var $1=$vowel_stress_addr; //@line 880 "dictionary.cpp"
    var $arrayidx=(($1)&4294967295); //@line 880 "dictionary.cpp"
    HEAP8[($arrayidx)]=1; //@line 880 "dictionary.cpp"
    ; //@line 881 "dictionary.cpp"
    $while_cond$2: while(1) { 
  
      var $2=$phonemes_addr; //@line 881 "dictionary.cpp"
      var $incdec_ptr=(($2+1)&4294967295); //@line 881 "dictionary.cpp"
      $phonemes_addr=$incdec_ptr; //@line 881 "dictionary.cpp"
      var $3=HEAPU8[($2)]; //@line 881 "dictionary.cpp"
      $phcode=$3; //@line 881 "dictionary.cpp"
      var $conv=((($3))&255); //@line 881 "dictionary.cpp"
      var $cmp=((($conv))|0)!=0; //@line 881 "dictionary.cpp"
      if (!($cmp)) { __label__ = 39;break $while_cond$2; } //@line 881 "dictionary.cpp"
  
      var $4=$count; //@line 881 "dictionary.cpp"
      var $cmp1=((($4))|0) < 79; //@line 881 "dictionary.cpp"
      if (!($cmp1)) { __label__ = 39;break $while_cond$2; }
  
      var $5=$phcode; //@line 883 "dictionary.cpp"
      var $idxprom=((($5))&255); //@line 883 "dictionary.cpp"
      var $arrayidx2=((_phoneme_tab+$idxprom*4)&4294967295); //@line 883 "dictionary.cpp"
      var $6=HEAPU32[(($arrayidx2)>>2)]; //@line 883 "dictionary.cpp"
      $ph=$6; //@line 883 "dictionary.cpp"
      var $cmp3=((($6))|0)==0; //@line 883 "dictionary.cpp"
      if ($cmp3) { __label__ = 1;continue $while_cond$2; } //@line 883 "dictionary.cpp"
  
      var $7=$ph; //@line 886 "dictionary.cpp"
      var $type=(($7+11)&4294967295); //@line 886 "dictionary.cpp"
      var $8=HEAPU8[($type)]; //@line 886 "dictionary.cpp"
      var $conv4=((($8))&255); //@line 886 "dictionary.cpp"
      var $cmp5=((($conv4))|0)==1; //@line 886 "dictionary.cpp"
      if ($cmp5) { __label__ = 5;; } else { __label__ = 24;; } //@line 886 "dictionary.cpp"
      $land_lhs_true$$if_end53$7: do { 
        if (__label__ == 5) {
  
          var $9=$ph; //@line 886 "dictionary.cpp"
          var $program=(($9+8)&4294967295); //@line 886 "dictionary.cpp"
          var $10=HEAPU16[(($program)>>1)]; //@line 886 "dictionary.cpp"
          var $conv6=((($10))&65535); //@line 886 "dictionary.cpp"
          var $cmp7=((($conv6))|0)==0; //@line 886 "dictionary.cpp"
          if (!($cmp7)) { __label__ = 24;break $land_lhs_true$$if_end53$7; } //@line 886 "dictionary.cpp"
  
          var $11=$phcode; //@line 890 "dictionary.cpp"
          var $conv9=((($11))&255); //@line 890 "dictionary.cpp"
          var $cmp10=((($conv9))|0)==8; //@line 890 "dictionary.cpp"
          if ($cmp10) { __label__ = 7;; } else { __label__ = 20;; } //@line 890 "dictionary.cpp"
          if (__label__ == 7) {
  
            var $12=$count; //@line 893 "dictionary.cpp"
            var $sub=((($12)-1)&4294967295); //@line 893 "dictionary.cpp"
            $j=$sub; //@line 893 "dictionary.cpp"
            __lastLabel__ = 7; ; //@line 894 "dictionary.cpp"
            $while_cond12$12: while(1) { 
  
              var $13=__lastLabel__ == 19 ? $dec : ($sub); //@line 894 "dictionary.cpp"
              var $cmp13=((($13))|0) > 0; //@line 894 "dictionary.cpp"
              if (!($cmp13)) { __label__ = 1;continue $while_cond$2; } //@line 894 "dictionary.cpp"
  
              var $14=$stressed_syllable_addr; //@line 894 "dictionary.cpp"
              var $15=HEAP32[(($14)>>2)]; //@line 894 "dictionary.cpp"
              var $cmp15=((($15))|0)==0; //@line 894 "dictionary.cpp"
              if (!($cmp15)) { __label__ = 1;continue $while_cond$2; } //@line 894 "dictionary.cpp"
  
              var $16=$j; //@line 894 "dictionary.cpp"
              var $17=$vowel_stress_addr; //@line 894 "dictionary.cpp"
              var $arrayidx17=(($17+$16)&4294967295); //@line 894 "dictionary.cpp"
              var $18=HEAP8[($arrayidx17)]; //@line 894 "dictionary.cpp"
              var $conv18=(tempInt=(($18)),(tempInt>=128?tempInt-256:tempInt)); //@line 894 "dictionary.cpp"
              var $cmp19=((($conv18))|0) < 4; //@line 894 "dictionary.cpp"
              if (!($cmp19)) { __label__ = 1;continue $while_cond$2; }
  
              var $19=$j; //@line 896 "dictionary.cpp"
              var $20=$vowel_stress_addr; //@line 896 "dictionary.cpp"
              var $arrayidx22=(($20+$19)&4294967295); //@line 896 "dictionary.cpp"
              var $21=HEAP8[($arrayidx22)]; //@line 896 "dictionary.cpp"
              var $conv23=(tempInt=(($21)),(tempInt>=128?tempInt-256:tempInt)); //@line 896 "dictionary.cpp"
              var $cmp24=((($conv23))|0)!=0; //@line 896 "dictionary.cpp"
              if ($cmp24) { __label__ = 12;; } else { __label__ = 19;; } //@line 896 "dictionary.cpp"
              if (__label__ == 12) {
  
                var $22=$j; //@line 896 "dictionary.cpp"
                var $23=$vowel_stress_addr; //@line 896 "dictionary.cpp"
                var $arrayidx26=(($23+$22)&4294967295); //@line 896 "dictionary.cpp"
                var $24=HEAP8[($arrayidx26)]; //@line 896 "dictionary.cpp"
                var $conv27=(tempInt=(($24)),(tempInt>=128?tempInt-256:tempInt)); //@line 896 "dictionary.cpp"
                var $cmp28=((($conv27))|0)!=1; //@line 896 "dictionary.cpp"
                if ($cmp28) { __label__ = 13;break $while_cond12$12; } //@line 896 "dictionary.cpp"
              }
  
              var $39=$j; //@line 915 "dictionary.cpp"
              var $dec=((($39)-1)&4294967295); //@line 915 "dictionary.cpp"
              $j=$dec; //@line 915 "dictionary.cpp"
              __lastLabel__ = 19; __label__ = 8;continue $while_cond12$12; //@line 916 "dictionary.cpp"
            }
  
            var $25=$j; //@line 899 "dictionary.cpp"
            var $26=$vowel_stress_addr; //@line 899 "dictionary.cpp"
            var $arrayidx30=(($26+$25)&4294967295); //@line 899 "dictionary.cpp"
            HEAP8[($arrayidx30)]=4; //@line 899 "dictionary.cpp"
            var $27=$max_stress; //@line 901 "dictionary.cpp"
            var $cmp31=((($27))|0) < 4; //@line 901 "dictionary.cpp"
            if ($cmp31) { __label__ = 14;; } else { __label__ = 15;; } //@line 901 "dictionary.cpp"
            if (__label__ == 14) {
  
              $max_stress=4; //@line 903 "dictionary.cpp"
              var $28=$j; //@line 904 "dictionary.cpp"
              $primary_posn=$28; //@line 904 "dictionary.cpp"
              ; //@line 905 "dictionary.cpp"
            }
  
            $ix=1; //@line 908 "dictionary.cpp"
            var $29=$ix; //@line 908 "dictionary.cpp"
            var $30=$j; //@line 908 "dictionary.cpp"
            var $cmp344=((($29))|0) < ((($30))|0); //@line 908 "dictionary.cpp"
            if (!($cmp344)) { __label__ = 1;continue $while_cond$2; } //@line 908 "dictionary.cpp"
            while(1) { 
  
              var $31=$ix; //@line 910 "dictionary.cpp"
              var $32=$vowel_stress_addr; //@line 910 "dictionary.cpp"
              var $arrayidx35=(($32+$31)&4294967295); //@line 910 "dictionary.cpp"
              var $33=HEAP8[($arrayidx35)]; //@line 910 "dictionary.cpp"
              var $conv36=(tempInt=(($33)),(tempInt>=128?tempInt-256:tempInt)); //@line 910 "dictionary.cpp"
              var $cmp37=((($conv36))|0)==4; //@line 910 "dictionary.cpp"
              if ($cmp37) { __label__ = 17;; } else { __label__ = 18;; } //@line 910 "dictionary.cpp"
              if (__label__ == 17) {
  
                var $34=$ix; //@line 911 "dictionary.cpp"
                var $35=$vowel_stress_addr; //@line 911 "dictionary.cpp"
                var $arrayidx39=(($35+$34)&4294967295); //@line 911 "dictionary.cpp"
                HEAP8[($arrayidx39)]=3; //@line 911 "dictionary.cpp"
                ; //@line 911 "dictionary.cpp"
              }
  
              var $36=$ix; //@line 908 "dictionary.cpp"
              var $inc=((($36)+1)&4294967295); //@line 908 "dictionary.cpp"
              $ix=$inc; //@line 908 "dictionary.cpp"
              var $37=$ix; //@line 908 "dictionary.cpp"
              var $38=$j; //@line 908 "dictionary.cpp"
              var $cmp34=((($37))|0) < ((($38))|0); //@line 908 "dictionary.cpp"
              if ($cmp34) { __label__ = 16;continue ; } else { __label__ = 1;continue $while_cond$2; } //@line 908 "dictionary.cpp"
            }
          }
          else if (__label__ == 20) {
  
            var $40=$ph; //@line 920 "dictionary.cpp"
            var $std_length=(($40+14)&4294967295); //@line 920 "dictionary.cpp"
            var $41=HEAPU8[($std_length)]; //@line 920 "dictionary.cpp"
            var $conv42=((($41))&255); //@line 920 "dictionary.cpp"
            var $cmp43=((($conv42))|0) < 4; //@line 920 "dictionary.cpp"
            if ($cmp43) { __label__ = 22;; } else { __label__ = 21;; } //@line 920 "dictionary.cpp"
            if (__label__ == 21) {
  
              var $42=$stressed_syllable_addr; //@line 920 "dictionary.cpp"
              var $43=HEAP32[(($42)>>2)]; //@line 920 "dictionary.cpp"
              var $cmp44=((($43))|0)==0; //@line 920 "dictionary.cpp"
              if (!($cmp44)) { __label__ = 1;continue $while_cond$2; } //@line 920 "dictionary.cpp"
            }
  
            var $44=$ph; //@line 922 "dictionary.cpp"
            var $std_length46=(($44+14)&4294967295); //@line 922 "dictionary.cpp"
            var $45=HEAPU8[($std_length46)]; //@line 922 "dictionary.cpp"
            var $conv47=((($45))&255); //@line 922 "dictionary.cpp"
            $stress=$conv47; //@line 922 "dictionary.cpp"
            var $46=$stress; //@line 924 "dictionary.cpp"
            var $47=$max_stress; //@line 924 "dictionary.cpp"
            var $cmp48=((($46))|0) > ((($47))|0); //@line 924 "dictionary.cpp"
            if (!($cmp48)) { __label__ = 1;continue $while_cond$2; } //@line 924 "dictionary.cpp"
  
            var $48=$stress; //@line 925 "dictionary.cpp"
            $max_stress=$48; //@line 925 "dictionary.cpp"
            __label__ = 1;continue $while_cond$2; //@line 925 "dictionary.cpp"
          }
        }
      } while(0);
  
      var $49=$ph; //@line 931 "dictionary.cpp"
      var $type54=(($49+11)&4294967295); //@line 931 "dictionary.cpp"
      var $50=HEAPU8[($type54)]; //@line 931 "dictionary.cpp"
      var $conv55=((($50))&255); //@line 931 "dictionary.cpp"
      var $cmp56=((($conv55))|0)==2; //@line 931 "dictionary.cpp"
      if ($cmp56) { __label__ = 25;; } else { __label__ = 34;; } //@line 931 "dictionary.cpp"
      $land_lhs_true57$$if_else78$35: do { 
        if (__label__ == 25) {
  
          var $51=$ph; //@line 931 "dictionary.cpp"
          var $phflags=(($51+4)&4294967295); //@line 931 "dictionary.cpp"
          var $52=HEAP32[(($phflags)>>2)]; //@line 931 "dictionary.cpp"
          var $and=($52) & 1048576; //@line 931 "dictionary.cpp"
          var $tobool=((($and))|0)!=0; //@line 931 "dictionary.cpp"
          if ($tobool) { __label__ = 34;break $land_lhs_true57$$if_else78$35; } //@line 931 "dictionary.cpp"
  
          var $53=$stress; //@line 933 "dictionary.cpp"
          var $conv59=((($53)) & 255); //@line 933 "dictionary.cpp"
          var $54=$count; //@line 933 "dictionary.cpp"
          var $55=$vowel_stress_addr; //@line 933 "dictionary.cpp"
          var $arrayidx60=(($55+$54)&4294967295); //@line 933 "dictionary.cpp"
          HEAP8[($arrayidx60)]=$conv59; //@line 933 "dictionary.cpp"
          var $56=$stress; //@line 934 "dictionary.cpp"
          var $cmp61=((($56))|0) >= 4; //@line 934 "dictionary.cpp"
          if ($cmp61) { __lastLabel__ = 26; __label__ = 27;; } else { __lastLabel__ = 26; __label__ = 29;; } //@line 934 "dictionary.cpp"
          $land_lhs_true62$$if_end65$38: do { 
            if (__label__ == 27) {
  
              var $57=$stress; //@line 934 "dictionary.cpp"
              var $58=$max_stress; //@line 934 "dictionary.cpp"
              var $cmp63=((($57))|0) >= ((($58))|0); //@line 934 "dictionary.cpp"
              if ($cmp63) { __lastLabel__ = 27; ; } else { __lastLabel__ = 27; __label__ = 29;break $land_lhs_true62$$if_end65$38; } //@line 934 "dictionary.cpp"
  
              var $59=$count; //@line 936 "dictionary.cpp"
              $primary_posn=$59; //@line 936 "dictionary.cpp"
              var $60=$stress; //@line 937 "dictionary.cpp"
              $max_stress=$60; //@line 937 "dictionary.cpp"
              __lastLabel__ = 28; ; //@line 938 "dictionary.cpp"
            }
          } while(0);
  
          var $61=__lastLabel__ == 28 ? $60 : (__lastLabel__ == 27 ? $57 : ($56)); //@line 940 "dictionary.cpp"
          var $cmp66=((($61))|0) < 0; //@line 940 "dictionary.cpp"
          if ($cmp66) { __label__ = 30;; } else { __label__ = 33;; } //@line 940 "dictionary.cpp"
          $land_lhs_true67$$if_end76$42: do { 
            if (__label__ == 30) {
  
              var $62=$control_addr; //@line 940 "dictionary.cpp"
              var $and68=($62) & 1; //@line 940 "dictionary.cpp"
              var $tobool69=((($and68))|0)!=0; //@line 940 "dictionary.cpp"
              if (!($tobool69)) { __label__ = 33;break $land_lhs_true67$$if_end76$42; } //@line 940 "dictionary.cpp"
  
              var $63=$ph; //@line 940 "dictionary.cpp"
              var $phflags71=(($63+4)&4294967295); //@line 940 "dictionary.cpp"
              var $64=HEAP32[(($phflags71)>>2)]; //@line 940 "dictionary.cpp"
              var $and72=($64) & 2; //@line 940 "dictionary.cpp"
              var $tobool73=((($and72))|0)!=0; //@line 940 "dictionary.cpp"
              if (!($tobool73)) { __label__ = 33;break $land_lhs_true67$$if_end76$42; } //@line 940 "dictionary.cpp"
  
              var $65=$count; //@line 941 "dictionary.cpp"
              var $66=$vowel_stress_addr; //@line 941 "dictionary.cpp"
              var $arrayidx75=(($66+$65)&4294967295); //@line 941 "dictionary.cpp"
              HEAP8[($arrayidx75)]=1; //@line 941 "dictionary.cpp"
              ; //@line 941 "dictionary.cpp"
            }
          } while(0);
  
          var $67=$count; //@line 943 "dictionary.cpp"
          var $inc77=((($67)+1)&4294967295); //@line 943 "dictionary.cpp"
          $count=$inc77; //@line 943 "dictionary.cpp"
          $stress=-1; //@line 944 "dictionary.cpp"
          __label__ = 38;break $land_lhs_true57$$if_else78$35; //@line 945 "dictionary.cpp"
        }
      } while(0);
      $if_else78$$if_end93$47: do { 
        if (__label__ == 34) {
  
          var $68=$phcode; //@line 947 "dictionary.cpp"
          var $conv79=((($68))&255); //@line 947 "dictionary.cpp"
          var $cmp80=((($conv79))|0)==20; //@line 947 "dictionary.cpp"
          if (!($cmp80)) { __label__ = 38;break $if_else78$$if_end93$47; } //@line 947 "dictionary.cpp"
  
          var $69=$stress; //@line 950 "dictionary.cpp"
          var $conv82=((($69)) & 255); //@line 950 "dictionary.cpp"
          var $70=$count; //@line 950 "dictionary.cpp"
          var $71=$vowel_stress_addr; //@line 950 "dictionary.cpp"
          var $arrayidx83=(($71+$70)&4294967295); //@line 950 "dictionary.cpp"
          HEAP8[($arrayidx83)]=$conv82; //@line 950 "dictionary.cpp"
          var $72=$stress; //@line 951 "dictionary.cpp"
          var $cmp84=((($72))|0)==0; //@line 951 "dictionary.cpp"
          if (!($cmp84)) { __label__ = 38;break $if_else78$$if_end93$47; } //@line 951 "dictionary.cpp"
  
          var $73=$control_addr; //@line 951 "dictionary.cpp"
          var $and86=($73) & 1; //@line 951 "dictionary.cpp"
          var $tobool87=((($and86))|0)!=0; //@line 951 "dictionary.cpp"
          if (!($tobool87)) { __label__ = 38;break $if_else78$$if_end93$47; } //@line 951 "dictionary.cpp"
  
          var $74=$count; //@line 952 "dictionary.cpp"
          var $inc89=((($74)+1)&4294967295); //@line 952 "dictionary.cpp"
          $count=$inc89; //@line 952 "dictionary.cpp"
          var $75=$vowel_stress_addr; //@line 952 "dictionary.cpp"
          var $arrayidx90=(($75+$74)&4294967295); //@line 952 "dictionary.cpp"
          HEAP8[($arrayidx90)]=1; //@line 952 "dictionary.cpp"
          ; //@line 952 "dictionary.cpp"
        }
      } while(0);
  
      var $76=$phcode; //@line 955 "dictionary.cpp"
      var $77=$ph_out; //@line 955 "dictionary.cpp"
      var $incdec_ptr94=(($77+1)&4294967295); //@line 955 "dictionary.cpp"
      $ph_out=$incdec_ptr94; //@line 955 "dictionary.cpp"
      HEAP8[($77)]=$76; //@line 955 "dictionary.cpp"
      __label__ = 1;continue $while_cond$2; //@line 956 "dictionary.cpp"
    }
  
    var $78=$count; //@line 957 "dictionary.cpp"
    var $79=$vowel_stress_addr; //@line 957 "dictionary.cpp"
    var $arrayidx96=(($79+$78)&4294967295); //@line 957 "dictionary.cpp"
    HEAP8[($arrayidx96)]=1; //@line 957 "dictionary.cpp"
    var $80=$ph_out; //@line 958 "dictionary.cpp"
    HEAP8[($80)]=0; //@line 958 "dictionary.cpp"
    var $81=$stressed_syllable_addr; //@line 961 "dictionary.cpp"
    var $82=HEAP32[(($81)>>2)]; //@line 961 "dictionary.cpp"
    var $cmp97=((($82))|0) > 0; //@line 961 "dictionary.cpp"
    if ($cmp97) { __label__ = 40;; } else { __label__ = 43;; } //@line 961 "dictionary.cpp"
    $if_then98$$if_end104$54: do { 
      if (__label__ == 40) {
  
        var $83=$stressed_syllable_addr; //@line 963 "dictionary.cpp"
        var $84=HEAP32[(($83)>>2)]; //@line 963 "dictionary.cpp"
        var $85=$count; //@line 963 "dictionary.cpp"
        var $cmp99=((($84))|0) >= ((($85))|0); //@line 963 "dictionary.cpp"
        if ($cmp99) { __label__ = 41;; } else { __label__ = 42;; } //@line 963 "dictionary.cpp"
        if (__label__ == 41) {
  
          var $86=$count; //@line 964 "dictionary.cpp"
          var $sub101=((($86)-1)&4294967295); //@line 964 "dictionary.cpp"
          var $87=$stressed_syllable_addr; //@line 964 "dictionary.cpp"
          HEAP32[(($87)>>2)]=$sub101; //@line 964 "dictionary.cpp"
          ; //@line 964 "dictionary.cpp"
        }
  
        var $88=$stressed_syllable_addr; //@line 966 "dictionary.cpp"
        var $89=HEAP32[(($88)>>2)]; //@line 966 "dictionary.cpp"
        var $90=$vowel_stress_addr; //@line 966 "dictionary.cpp"
        var $arrayidx103=(($90+$89)&4294967295); //@line 966 "dictionary.cpp"
        HEAP8[($arrayidx103)]=4; //@line 966 "dictionary.cpp"
        $max_stress=4; //@line 967 "dictionary.cpp"
        var $91=$stressed_syllable_addr; //@line 968 "dictionary.cpp"
        var $92=HEAP32[(($91)>>2)]; //@line 968 "dictionary.cpp"
        $primary_posn=$92; //@line 968 "dictionary.cpp"
        ; //@line 971 "dictionary.cpp"
      }
      else if (__label__ == 43) {
  
        var $_pr=$max_stress; //@line 971 "dictionary.cpp"
        var $cmp105=((($_pr))|0)==5; //@line 971 "dictionary.cpp"
        if (!($cmp105)) { __label__ = 53;break $if_then98$$if_end104$54; } //@line 971 "dictionary.cpp"
  
        $ix=1; //@line 974 "dictionary.cpp"
        var $93=$ix; //@line 974 "dictionary.cpp"
        var $94=$count; //@line 974 "dictionary.cpp"
        var $cmp1083=((($93))|0) < ((($94))|0); //@line 974 "dictionary.cpp"
        if ($cmp1083) { __label__ = 45;; } else { __label__ = 52;; } //@line 974 "dictionary.cpp"
        $for_body109$$for_end130$61: do { 
          if (__label__ == 45) {
            while(1) { 
  
              var $95=$ix; //@line 976 "dictionary.cpp"
              var $96=$vowel_stress_addr; //@line 976 "dictionary.cpp"
              var $arrayidx110=(($96+$95)&4294967295); //@line 976 "dictionary.cpp"
              var $97=HEAP8[($arrayidx110)]; //@line 976 "dictionary.cpp"
              var $conv111=(tempInt=(($97)),(tempInt>=128?tempInt-256:tempInt)); //@line 976 "dictionary.cpp"
              var $cmp112=((($conv111))|0)==4; //@line 976 "dictionary.cpp"
              if ($cmp112) { __label__ = 46;; } else { __label__ = 49;; } //@line 976 "dictionary.cpp"
              if (__label__ == 46) {
  
                var $98=$tr_addr; //@line 978 "dictionary.cpp"
                var $langopts=(($98)&4294967295); //@line 978 "dictionary.cpp"
                var $stress_flags=(($langopts+12)&4294967295); //@line 978 "dictionary.cpp"
                var $99=HEAP32[(($stress_flags)>>2)]; //@line 978 "dictionary.cpp"
                var $and114=($99) & 131072; //@line 978 "dictionary.cpp"
                var $tobool115=((($and114))|0)!=0; //@line 978 "dictionary.cpp"
                var $100=$ix; //@line 979 "dictionary.cpp"
                var $101=$vowel_stress_addr; //@line 979 "dictionary.cpp"
                var $arrayidx117=(($101+$100)&4294967295); //@line 979 "dictionary.cpp"
                if ($tobool115) { __label__ = 47;; } else { __label__ = 48;; } //@line 978 "dictionary.cpp"
                if (__label__ == 47) {
  
                  HEAP8[($arrayidx117)]=1; //@line 979 "dictionary.cpp"
                  ; //@line 979 "dictionary.cpp"
                }
                else if (__label__ == 48) {
  
                  HEAP8[($arrayidx117)]=3; //@line 981 "dictionary.cpp"
                  ;
                }
              }
  
              var $102=$ix; //@line 984 "dictionary.cpp"
              var $103=$vowel_stress_addr; //@line 984 "dictionary.cpp"
              var $arrayidx122=(($103+$102)&4294967295); //@line 984 "dictionary.cpp"
              var $104=HEAP8[($arrayidx122)]; //@line 984 "dictionary.cpp"
              var $conv123=(tempInt=(($104)),(tempInt>=128?tempInt-256:tempInt)); //@line 984 "dictionary.cpp"
              var $cmp124=((($conv123))|0)==5; //@line 984 "dictionary.cpp"
              if ($cmp124) { __label__ = 50;; } else { __label__ = 51;; } //@line 984 "dictionary.cpp"
              if (__label__ == 50) {
  
                var $105=$ix; //@line 986 "dictionary.cpp"
                var $106=$vowel_stress_addr; //@line 986 "dictionary.cpp"
                var $arrayidx126=(($106+$105)&4294967295); //@line 986 "dictionary.cpp"
                HEAP8[($arrayidx126)]=4; //@line 986 "dictionary.cpp"
                var $107=$ix; //@line 987 "dictionary.cpp"
                $primary_posn=$107; //@line 987 "dictionary.cpp"
                ; //@line 988 "dictionary.cpp"
              }
  
              var $108=$ix; //@line 974 "dictionary.cpp"
              var $inc129=((($108)+1)&4294967295); //@line 974 "dictionary.cpp"
              $ix=$inc129; //@line 974 "dictionary.cpp"
              var $109=$ix; //@line 974 "dictionary.cpp"
              var $110=$count; //@line 974 "dictionary.cpp"
              var $cmp108=((($109))|0) < ((($110))|0); //@line 974 "dictionary.cpp"
              if ($cmp108) { __label__ = 45;continue ; } else { __label__ = 52;break $for_body109$$for_end130$61; } //@line 974 "dictionary.cpp"
            }
          }
        } while(0);
  
        $max_stress=4; //@line 990 "dictionary.cpp"
        ; //@line 991 "dictionary.cpp"
      }
    } while(0);
  
    var $111=$primary_posn; //@line 993 "dictionary.cpp"
    var $112=$stressed_syllable_addr; //@line 993 "dictionary.cpp"
    HEAP32[(($112)>>2)]=$111; //@line 993 "dictionary.cpp"
    var $113=$count; //@line 994 "dictionary.cpp"
    var $114=$vowel_count_addr; //@line 994 "dictionary.cpp"
    HEAP32[(($114)>>2)]=$113; //@line 994 "dictionary.cpp"
    var $115=$max_stress; //@line 995 "dictionary.cpp"
    ;
    return $115; //@line 995 "dictionary.cpp"
    return null;
  }
  

  function __Z13SetWordStressP10TranslatorPcPjii($tr, $output, $dictionary_flags, $tonic, $control) {
    var __stackBase__  = STACKTOP; STACKTOP += 408; _memset(__stackBase__, 0, 408);
    var __label__;
    var __lastLabel__ = null;
  
    var $tr_addr;
    var $output_addr;
    var $dictionary_flags_addr;
    var $tonic_addr;
    var $control_addr;
    var $phcode;
    var $p;
    var $ph;
    var $stress;
    var $max_stress;
    var $vowel_count=__stackBase__;
    var $ix;
    var $v;
    var $v_stress;
    var $stressed_syllable=__stackBase__+4;
    var $max_stress_posn;
    var $unstressed_word;
    var $max_output;
    var $final_ph;
    var $final_ph2;
    var $mnem;
    var $mnem2;
    var $post_tonic;
    var $opt_length;
    var $done;
    var $stressflags;
    var $dflags;
    var $first_primary;
    var $vowel_stress=__stackBase__+8;
    var $syllable_weight=__stackBase__+88;
    var $vowel_length=__stackBase__+168;
    var $phonetic=__stackBase__+248;
    var $weight;
    var $lengthened;
    var $wt;
    var $max_weight;
    var $prev_stressed;
    var $shorten;
    $tr_addr=$tr;
    $output_addr=$output;
    $dictionary_flags_addr=$dictionary_flags;
    $tonic_addr=$tonic;
    $control_addr=$control;
    $unstressed_word=0; //@line 1084 "dictionary.cpp"
    $dflags=0; //@line 1094 "dictionary.cpp"
    var $0=$tr_addr; //@line 1112 "dictionary.cpp"
    var $langopts=(($0)&4294967295); //@line 1112 "dictionary.cpp"
    var $stress_flags=(($langopts+12)&4294967295); //@line 1112 "dictionary.cpp"
    var $1=HEAP32[(($stress_flags)>>2)]; //@line 1112 "dictionary.cpp"
    $stressflags=$1; //@line 1112 "dictionary.cpp"
    var $2=$dictionary_flags_addr; //@line 1114 "dictionary.cpp"
    var $cmp=((($2))|0)!=0; //@line 1114 "dictionary.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 1114 "dictionary.cpp"
    if (__label__ == 1) {
  
      var $3=$dictionary_flags_addr; //@line 1115 "dictionary.cpp"
      var $arrayidx=(($3)&4294967295); //@line 1115 "dictionary.cpp"
      var $4=HEAP32[(($arrayidx)>>2)]; //@line 1115 "dictionary.cpp"
      $dflags=$4; //@line 1115 "dictionary.cpp"
      ; //@line 1115 "dictionary.cpp"
    }
  
    $ix=0; //@line 1118 "dictionary.cpp"
    __lastLabel__ = 2; ; //@line 1118 "dictionary.cpp"
    $for_cond$5: while(1) { 
  
      var $5=__lastLabel__ == 7 ? $inc : (0); //@line 1118 "dictionary.cpp"
      var $cmp1=((($5))|0) < 160; //@line 1118 "dictionary.cpp"
      var $6=$ix; //@line 1120 "dictionary.cpp"
      if ($cmp1) { __lastLabel__ = 3; ; } else { __lastLabel__ = 3; __label__ = 8;break $for_cond$5; } //@line 1118 "dictionary.cpp"
  
      var $7=$output_addr; //@line 1120 "dictionary.cpp"
      var $arrayidx2=(($7+$6)&4294967295); //@line 1120 "dictionary.cpp"
      var $8=HEAP8[($arrayidx2)]; //@line 1120 "dictionary.cpp"
      var $9=$ix; //@line 1120 "dictionary.cpp"
      var $arrayidx3=(($phonetic+$9)&4294967295); //@line 1120 "dictionary.cpp"
      HEAP8[($arrayidx3)]=$8; //@line 1120 "dictionary.cpp"
      var $10=$ix; //@line 1122 "dictionary.cpp"
      var $arrayidx4=(($phonetic+$10)&4294967295); //@line 1122 "dictionary.cpp"
      var $11=HEAPU8[($arrayidx4)]; //@line 1122 "dictionary.cpp"
      var $conv=((($11))&255); //@line 1122 "dictionary.cpp"
      var $12=HEAP32[((_n_phoneme_tab)>>2)]; //@line 1122 "dictionary.cpp"
      var $cmp5=((($conv))|0) >= ((($12))|0); //@line 1122 "dictionary.cpp"
      if ($cmp5) { __label__ = 5;; } else { __label__ = 6;; } //@line 1122 "dictionary.cpp"
      if (__label__ == 5) {
  
        var $13=$ix; //@line 1123 "dictionary.cpp"
        var $arrayidx7=(($phonetic+$13)&4294967295); //@line 1123 "dictionary.cpp"
        HEAP8[($arrayidx7)]=13; //@line 1123 "dictionary.cpp"
        ; //@line 1123 "dictionary.cpp"
      }
  
      var $14=$ix; //@line 1124 "dictionary.cpp"
      var $arrayidx9=(($phonetic+$14)&4294967295); //@line 1124 "dictionary.cpp"
      var $15=HEAPU8[($arrayidx9)]; //@line 1124 "dictionary.cpp"
      var $conv10=((($15))&255); //@line 1124 "dictionary.cpp"
      var $cmp11=((($conv10))|0)==0; //@line 1124 "dictionary.cpp"
      if ($cmp11) { __lastLabel__ = 6; __label__ = 8;break $for_cond$5; } else { __lastLabel__ = 6; ; } //@line 1124 "dictionary.cpp"
  
      var $16=$ix; //@line 1118 "dictionary.cpp"
      var $inc=((($16)+1)&4294967295); //@line 1118 "dictionary.cpp"
      $ix=$inc; //@line 1118 "dictionary.cpp"
      __lastLabel__ = 7; __label__ = 3;continue $for_cond$5; //@line 1118 "dictionary.cpp"
    }
  
    var $17=__lastLabel__ == 6 ? $14 : ($6); //@line 1127 "dictionary.cpp"
    var $cmp14=((($17))|0)==0; //@line 1127 "dictionary.cpp"
    if ($cmp14) { __label__ = 223;; } else { __label__ = 9;; } //@line 1127 "dictionary.cpp"
    if (__label__ == 9) {
  
      var $18=$ix; //@line 1128 "dictionary.cpp"
      var $sub=((($18)-1)&4294967295); //@line 1128 "dictionary.cpp"
      var $arrayidx17=(($phonetic+$sub)&4294967295); //@line 1128 "dictionary.cpp"
      var $19=HEAPU8[($arrayidx17)]; //@line 1128 "dictionary.cpp"
      var $conv18=((($19))&255); //@line 1128 "dictionary.cpp"
      $final_ph=$conv18; //@line 1128 "dictionary.cpp"
      var $20=$ix; //@line 1129 "dictionary.cpp"
      var $sub19=((($20)-2)&4294967295); //@line 1129 "dictionary.cpp"
      var $arrayidx20=(($phonetic+$sub19)&4294967295); //@line 1129 "dictionary.cpp"
      var $21=HEAPU8[($arrayidx20)]; //@line 1129 "dictionary.cpp"
      var $conv21=((($21))&255); //@line 1129 "dictionary.cpp"
      $final_ph2=$conv21; //@line 1129 "dictionary.cpp"
      var $22=$output_addr; //@line 1131 "dictionary.cpp"
      var $add_ptr=(($22+157)&4294967295); //@line 1131 "dictionary.cpp"
      $max_output=$add_ptr; //@line 1131 "dictionary.cpp"
      var $23=$dflags; //@line 1134 "dictionary.cpp"
      var $and=($23) & 7; //@line 1134 "dictionary.cpp"
      HEAP32[(($stressed_syllable)>>2)]=$and; //@line 1134 "dictionary.cpp"
      var $24=$dflags; //@line 1135 "dictionary.cpp"
      var $and22=($24) & 8; //@line 1135 "dictionary.cpp"
      var $tobool=((($and22))|0)!=0; //@line 1135 "dictionary.cpp"
      if ($tobool) { __label__ = 10;; } else { __label__ = 11;; } //@line 1135 "dictionary.cpp"
      if (__label__ == 10) {
  
        var $25=$dflags; //@line 1138 "dictionary.cpp"
        var $and24=($25) & 3; //@line 1138 "dictionary.cpp"
        HEAP32[(($stressed_syllable)>>2)]=$and24; //@line 1138 "dictionary.cpp"
        $unstressed_word=1; //@line 1139 "dictionary.cpp"
        ; //@line 1140 "dictionary.cpp"
      }
  
      var $26=$tr_addr; //@line 1142 "dictionary.cpp"
      var $arraydecay=(($phonetic)&4294967295); //@line 1142 "dictionary.cpp"
      var $arraydecay26=(($vowel_stress)&4294967295); //@line 1142 "dictionary.cpp"
      var $call=__ZL14GetVowelStressP10TranslatorPhPaRiS3_i($26, $arraydecay, $arraydecay26, $vowel_count, $stressed_syllable, 1); //@line 1142 "dictionary.cpp"
      $max_stress=$call; //@line 1142 "dictionary.cpp"
      var $cmp27=((($call))|0) < 0; //@line 1143 "dictionary.cpp"
      if ($cmp27) { __label__ = 12;; } else { __label__ = 17;; } //@line 1143 "dictionary.cpp"
      $land_lhs_true$$if_end40$18: do { 
        if (__label__ == 12) {
  
          var $27=$dictionary_flags_addr; //@line 1143 "dictionary.cpp"
          var $tobool28=((($27))|0)!=0; //@line 1143 "dictionary.cpp"
          if (!($tobool28)) { __label__ = 17;break $land_lhs_true$$if_end40$18; } //@line 1143 "dictionary.cpp"
  
          var $28=$tr_addr; //@line 1145 "dictionary.cpp"
          var $langopts30=(($28)&4294967295); //@line 1145 "dictionary.cpp"
          var $stress_flags31=(($langopts30+12)&4294967295); //@line 1145 "dictionary.cpp"
          var $29=HEAP32[(($stress_flags31)>>2)]; //@line 1145 "dictionary.cpp"
          var $and32=($29) & 1; //@line 1145 "dictionary.cpp"
          var $tobool33=((($and32))|0)!=0; //@line 1145 "dictionary.cpp"
          if ($tobool33) { __label__ = 14;; } else { __label__ = 16;; } //@line 1145 "dictionary.cpp"
          $land_lhs_true34$$if_end39$21: do { 
            if (__label__ == 14) {
  
              var $30=HEAP32[(($vowel_count)>>2)]; //@line 1145 "dictionary.cpp"
              var $cmp35=((($30))|0)==2; //@line 1145 "dictionary.cpp"
              if (!($cmp35)) { __label__ = 16;break $land_lhs_true34$$if_end39$21; } //@line 1145 "dictionary.cpp"
  
              var $arrayidx37=(($vowel_stress+1)&4294967295); //@line 1148 "dictionary.cpp"
              HEAP8[($arrayidx37)]=0; //@line 1148 "dictionary.cpp"
              var $31=$dictionary_flags_addr; //@line 1149 "dictionary.cpp"
              var $arrayidx38=(($31)&4294967295); //@line 1149 "dictionary.cpp"
              var $32=HEAP32[(($arrayidx38)>>2)]; //@line 1149 "dictionary.cpp"
              var $or=($32) | 4096; //@line 1149 "dictionary.cpp"
              HEAP32[(($arrayidx38)>>2)]=$or; //@line 1149 "dictionary.cpp"
              ; //@line 1150 "dictionary.cpp"
            }
          } while(0);
  
          $max_stress=0; //@line 1151 "dictionary.cpp"
          ; //@line 1152 "dictionary.cpp"
        }
      } while(0);
  
      $ix=1; //@line 1155 "dictionary.cpp"
      var $arraydecay41=(($phonetic)&4294967295); //@line 1156 "dictionary.cpp"
      $p=$arraydecay41; //@line 1156 "dictionary.cpp"
      var $33=$p; //@line 1156 "dictionary.cpp"
      var $34=HEAPU8[($33)]; //@line 1156 "dictionary.cpp"
      var $conv4319=((($34))&255); //@line 1156 "dictionary.cpp"
      var $cmp4420=((($conv4319))|0)!=0; //@line 1156 "dictionary.cpp"
      if ($cmp4420) { __label__ = 18;; } else { __label__ = 33;; } //@line 1156 "dictionary.cpp"
      $for_body45$$for_end109$26: do { 
        if (__label__ == 18) {
          $for_body45$27: while(1) { 
  
            var $35=$p; //@line 1158 "dictionary.cpp"
            var $arrayidx46=(($35)&4294967295); //@line 1158 "dictionary.cpp"
            var $36=HEAPU8[($arrayidx46)]; //@line 1158 "dictionary.cpp"
            var $idxprom=((($36))&255); //@line 1158 "dictionary.cpp"
            var $arrayidx47=((_phoneme_tab+$idxprom*4)&4294967295); //@line 1158 "dictionary.cpp"
            var $37=HEAP32[(($arrayidx47)>>2)]; //@line 1158 "dictionary.cpp"
            var $type=(($37+11)&4294967295); //@line 1158 "dictionary.cpp"
            var $38=HEAPU8[($type)]; //@line 1158 "dictionary.cpp"
            var $conv48=((($38))&255); //@line 1158 "dictionary.cpp"
            var $cmp49=((($conv48))|0)==2; //@line 1158 "dictionary.cpp"
            if ($cmp49) { __label__ = 19;; } else { __label__ = 32;; } //@line 1158 "dictionary.cpp"
            $land_lhs_true50$$for_inc107$29: do { 
              if (__label__ == 19) {
  
                var $39=$p; //@line 1158 "dictionary.cpp"
                var $arrayidx51=(($39)&4294967295); //@line 1158 "dictionary.cpp"
                var $40=HEAPU8[($arrayidx51)]; //@line 1158 "dictionary.cpp"
                var $idxprom52=((($40))&255); //@line 1158 "dictionary.cpp"
                var $arrayidx53=((_phoneme_tab+$idxprom52*4)&4294967295); //@line 1158 "dictionary.cpp"
                var $41=HEAP32[(($arrayidx53)>>2)]; //@line 1158 "dictionary.cpp"
                var $phflags=(($41+4)&4294967295); //@line 1158 "dictionary.cpp"
                var $42=HEAP32[(($phflags)>>2)]; //@line 1158 "dictionary.cpp"
                var $and54=($42) & 1048576; //@line 1158 "dictionary.cpp"
                var $tobool55=((($and54))|0)!=0; //@line 1158 "dictionary.cpp"
                if ($tobool55) { __label__ = 32;break $land_lhs_true50$$for_inc107$29; } //@line 1158 "dictionary.cpp"
  
                $weight=0; //@line 1160 "dictionary.cpp"
                $lengthened=0; //@line 1161 "dictionary.cpp"
                var $43=$p; //@line 1163 "dictionary.cpp"
                var $arrayidx57=(($43+1)&4294967295); //@line 1163 "dictionary.cpp"
                var $44=HEAPU8[($arrayidx57)]; //@line 1163 "dictionary.cpp"
                var $idxprom58=((($44))&255); //@line 1163 "dictionary.cpp"
                var $arrayidx59=((_phoneme_tab+$idxprom58*4)&4294967295); //@line 1163 "dictionary.cpp"
                var $45=HEAP32[(($arrayidx59)>>2)]; //@line 1163 "dictionary.cpp"
                var $code=(($45+10)&4294967295); //@line 1163 "dictionary.cpp"
                var $46=HEAPU8[($code)]; //@line 1163 "dictionary.cpp"
                var $conv60=((($46))&255); //@line 1163 "dictionary.cpp"
                var $cmp61=((($conv60))|0)==12; //@line 1163 "dictionary.cpp"
                if ($cmp61) { __label__ = 21;; } else { __label__ = 22;; } //@line 1163 "dictionary.cpp"
                $if_end63_thread$$if_end63$32: do { 
                  if (__label__ == 21) {
  
                    $lengthened=1; //@line 1164 "dictionary.cpp"
                    __label__ = 24;break $if_end63_thread$$if_end63$32; //@line 1166 "dictionary.cpp"
                  }
                  else if (__label__ == 22) {
  
                    var $_pr3=$lengthened; //@line 1166 "dictionary.cpp"
                    var $tobool64=((($_pr3))|0)!=0; //@line 1166 "dictionary.cpp"
                    if ($tobool64) { __label__ = 24;break $if_end63_thread$$if_end63$32; } //@line 1166 "dictionary.cpp"
  
                    var $47=$p; //@line 1166 "dictionary.cpp"
                    var $arrayidx65=(($47)&4294967295); //@line 1166 "dictionary.cpp"
                    var $48=HEAPU8[($arrayidx65)]; //@line 1166 "dictionary.cpp"
                    var $idxprom66=((($48))&255); //@line 1166 "dictionary.cpp"
                    var $arrayidx67=((_phoneme_tab+$idxprom66*4)&4294967295); //@line 1166 "dictionary.cpp"
                    var $49=HEAP32[(($arrayidx67)>>2)]; //@line 1166 "dictionary.cpp"
                    var $phflags68=(($49+4)&4294967295); //@line 1166 "dictionary.cpp"
                    var $50=HEAP32[(($phflags68)>>2)]; //@line 1166 "dictionary.cpp"
                    var $and69=($50) & 2097152; //@line 1166 "dictionary.cpp"
                    var $tobool70=((($and69))|0)!=0; //@line 1166 "dictionary.cpp"
                    if ($tobool70) { __label__ = 24;break $if_end63_thread$$if_end63$32; } else { __label__ = 25;break $if_end63_thread$$if_end63$32; } //@line 1166 "dictionary.cpp"
                  }
                } while(0);
                if (__label__ == 24) {
  
                  var $51=$weight; //@line 1169 "dictionary.cpp"
                  var $inc72=((($51)+1)&4294967295); //@line 1169 "dictionary.cpp"
                  $weight=$inc72; //@line 1169 "dictionary.cpp"
                  ; //@line 1170 "dictionary.cpp"
                }
  
                var $52=$weight; //@line 1171 "dictionary.cpp"
                var $conv74=((($52)) & 255); //@line 1171 "dictionary.cpp"
                var $53=$ix; //@line 1171 "dictionary.cpp"
                var $arrayidx75=(($vowel_length+$53)&4294967295); //@line 1171 "dictionary.cpp"
                HEAP8[($arrayidx75)]=$conv74; //@line 1171 "dictionary.cpp"
                var $54=$lengthened; //@line 1173 "dictionary.cpp"
                var $tobool76=((($54))|0)!=0; //@line 1173 "dictionary.cpp"
                if ($tobool76) { __label__ = 26;; } else { __label__ = 27;; } //@line 1173 "dictionary.cpp"
                if (__label__ == 26) {
  
                  var $55=$p; //@line 1173 "dictionary.cpp"
                  var $incdec_ptr=(($55+1)&4294967295); //@line 1173 "dictionary.cpp"
                  $p=$incdec_ptr; //@line 1173 "dictionary.cpp"
                  ; //@line 1173 "dictionary.cpp"
                }
  
                var $56=$p; //@line 1175 "dictionary.cpp"
                var $arrayidx79=(($56+1)&4294967295); //@line 1175 "dictionary.cpp"
                var $57=HEAPU8[($arrayidx79)]; //@line 1175 "dictionary.cpp"
                var $idxprom80=((($57))&255); //@line 1175 "dictionary.cpp"
                var $arrayidx81=((_phoneme_tab+$idxprom80*4)&4294967295); //@line 1175 "dictionary.cpp"
                var $58=HEAP32[(($arrayidx81)>>2)]; //@line 1175 "dictionary.cpp"
                var $type82=(($58+11)&4294967295); //@line 1175 "dictionary.cpp"
                var $59=HEAPU8[($type82)]; //@line 1175 "dictionary.cpp"
                var $idxprom83=((($59))&255); //@line 1175 "dictionary.cpp"
                var $arrayidx84=((__ZZ13SetWordStressP10TranslatorPcPjiiE15consonant_types+$idxprom83)&4294967295); //@line 1175 "dictionary.cpp"
                var $60=HEAP8[($arrayidx84)]; //@line 1175 "dictionary.cpp"
                var $tobool85=(tempInt=(($60)),(tempInt>=128?tempInt-256:tempInt))!=0; //@line 1175 "dictionary.cpp"
                if ($tobool85) { __label__ = 28;; } else { __label__ = 31;; } //@line 1175 "dictionary.cpp"
                $land_lhs_true86$$if_end102$42: do { 
                  if (__label__ == 28) {
  
                    var $61=$p; //@line 1175 "dictionary.cpp"
                    var $arrayidx87=(($61+2)&4294967295); //@line 1175 "dictionary.cpp"
                    var $62=HEAPU8[($arrayidx87)]; //@line 1175 "dictionary.cpp"
                    var $idxprom88=((($62))&255); //@line 1175 "dictionary.cpp"
                    var $arrayidx89=((_phoneme_tab+$idxprom88*4)&4294967295); //@line 1175 "dictionary.cpp"
                    var $63=HEAP32[(($arrayidx89)>>2)]; //@line 1175 "dictionary.cpp"
                    var $type90=(($63+11)&4294967295); //@line 1175 "dictionary.cpp"
                    var $64=HEAPU8[($type90)]; //@line 1175 "dictionary.cpp"
                    var $conv91=((($64))&255); //@line 1175 "dictionary.cpp"
                    var $cmp92=((($conv91))|0)!=2; //@line 1175 "dictionary.cpp"
                    if ($cmp92) { __label__ = 30;; } else { __label__ = 29;; } //@line 1175 "dictionary.cpp"
                    if (__label__ == 29) {
  
                      var $65=$p; //@line 1175 "dictionary.cpp"
                      var $arrayidx94=(($65+1)&4294967295); //@line 1175 "dictionary.cpp"
                      var $66=HEAPU8[($arrayidx94)]; //@line 1175 "dictionary.cpp"
                      var $idxprom95=((($66))&255); //@line 1175 "dictionary.cpp"
                      var $arrayidx96=((_phoneme_tab+$idxprom95*4)&4294967295); //@line 1175 "dictionary.cpp"
                      var $67=HEAP32[(($arrayidx96)>>2)]; //@line 1175 "dictionary.cpp"
                      var $phflags97=(($67+4)&4294967295); //@line 1175 "dictionary.cpp"
                      var $68=HEAP32[(($phflags97)>>2)]; //@line 1175 "dictionary.cpp"
                      var $and98=($68) & 2097152; //@line 1175 "dictionary.cpp"
                      var $tobool99=((($and98))|0)!=0; //@line 1175 "dictionary.cpp"
                      if (!($tobool99)) { __label__ = 31;break $land_lhs_true86$$if_end102$42; } //@line 1175 "dictionary.cpp"
                    }
  
                    var $69=$weight; //@line 1178 "dictionary.cpp"
                    var $inc101=((($69)+1)&4294967295); //@line 1178 "dictionary.cpp"
                    $weight=$inc101; //@line 1178 "dictionary.cpp"
                    ; //@line 1179 "dictionary.cpp"
                  }
                } while(0);
  
                var $70=$weight; //@line 1180 "dictionary.cpp"
                var $conv103=((($70)) & 255); //@line 1180 "dictionary.cpp"
                var $71=$ix; //@line 1180 "dictionary.cpp"
                var $arrayidx104=(($syllable_weight+$71)&4294967295); //@line 1180 "dictionary.cpp"
                HEAP8[($arrayidx104)]=$conv103; //@line 1180 "dictionary.cpp"
                var $72=$ix; //@line 1181 "dictionary.cpp"
                var $inc105=((($72)+1)&4294967295); //@line 1181 "dictionary.cpp"
                $ix=$inc105; //@line 1181 "dictionary.cpp"
                ; //@line 1182 "dictionary.cpp"
              }
            } while(0);
  
            var $73=$p; //@line 1156 "dictionary.cpp"
            var $incdec_ptr108=(($73+1)&4294967295); //@line 1156 "dictionary.cpp"
            $p=$incdec_ptr108; //@line 1156 "dictionary.cpp"
            var $74=$p; //@line 1156 "dictionary.cpp"
            var $75=HEAPU8[($74)]; //@line 1156 "dictionary.cpp"
            var $conv43=((($75))&255); //@line 1156 "dictionary.cpp"
            var $cmp44=((($conv43))|0)!=0; //@line 1156 "dictionary.cpp"
            if ($cmp44) { __label__ = 18;continue $for_body45$27; } else { __label__ = 33;break $for_body45$$for_end109$26; } //@line 1156 "dictionary.cpp"
          }
        }
      } while(0);
  
      var $76=$tr_addr; //@line 1185 "dictionary.cpp"
      var $langopts110=(($76)&4294967295); //@line 1185 "dictionary.cpp"
      var $stress_rule=(($langopts110+8)&4294967295); //@line 1185 "dictionary.cpp"
      var $77=HEAP32[(($stress_rule)>>2)]; //@line 1185 "dictionary.cpp"
      if ($77 == 8) {
        __label__ = 34;;
      }
      else if ($77 == 1) {
        __label__ = 36;;
      }
      else if ($77 == 10) {
        __label__ = 41;;
      }
      else if ($77 == 2) {
        __label__ = 44;;
      }
      else if ($77 == 3) {
        __label__ = 68;;
      }
      else if ($77 == 4) {
        __label__ = 75;;
      }
      else if ($77 == 5) {
        __label__ = 81;;
      }
      else if ($77 == 6) {
        __label__ = 89;;
      }
      else if ($77 == 7) {
        __label__ = 101;;
      }
      else if ($77 == 9) {
        __label__ = 108;;
      }
      else {
      __label__ = 112;;
      }
      
      $sw_epilog$$sw_bb$$sw_bb120$$sw_bb130$$sw_bb139$$sw_bb228$$sw_bb242$$sw_bb254$$sw_bb283$$sw_bb318$$sw_bb336$50: do { 
        if (__label__ == 34) {
  
          var $arrayidx111=(($syllable_weight+1)&4294967295); //@line 1189 "dictionary.cpp"
          var $78=HEAP8[($arrayidx111)]; //@line 1189 "dictionary.cpp"
          var $conv112=(tempInt=(($78)),(tempInt>=128?tempInt-256:tempInt)); //@line 1189 "dictionary.cpp"
          var $cmp113=((($conv112))|0) > 0; //@line 1189 "dictionary.cpp"
          if ($cmp113) { __label__ = 112;break $sw_epilog$$sw_bb$$sw_bb120$$sw_bb130$$sw_bb139$$sw_bb228$$sw_bb242$$sw_bb254$$sw_bb283$$sw_bb318$$sw_bb336$50; } //@line 1189 "dictionary.cpp"
  
          var $arrayidx115=(($syllable_weight+2)&4294967295); //@line 1189 "dictionary.cpp"
          var $79=HEAP8[($arrayidx115)]; //@line 1189 "dictionary.cpp"
          var $conv116=(tempInt=(($79)),(tempInt>=128?tempInt-256:tempInt)); //@line 1189 "dictionary.cpp"
          var $cmp117=((($conv116))|0)==0; //@line 1189 "dictionary.cpp"
          if ($cmp117) { __label__ = 112;break $sw_epilog$$sw_bb$$sw_bb120$$sw_bb130$$sw_bb139$$sw_bb228$$sw_bb242$$sw_bb254$$sw_bb283$$sw_bb318$$sw_bb336$50; } else { __label__ = 36;break $sw_epilog$$sw_bb$$sw_bb120$$sw_bb130$$sw_bb139$$sw_bb228$$sw_bb242$$sw_bb254$$sw_bb283$$sw_bb318$$sw_bb336$50; } //@line 1189 "dictionary.cpp"
        }
        else if (__label__ == 41) {
  
          var $84=HEAP32[(($stressed_syllable)>>2)]; //@line 1206 "dictionary.cpp"
          var $cmp131=((($84))|0)==0; //@line 1206 "dictionary.cpp"
          if (!($cmp131)) { __label__ = 112;break $sw_epilog$$sw_bb$$sw_bb120$$sw_bb130$$sw_bb139$$sw_bb228$$sw_bb242$$sw_bb254$$sw_bb283$$sw_bb318$$sw_bb336$50; } //@line 1206 "dictionary.cpp"
  
          var $85=HEAP32[(($vowel_count)>>2)]; //@line 1208 "dictionary.cpp"
          var $cmp133=((($85))|0) < 4; //@line 1208 "dictionary.cpp"
          if (!($cmp133)) { __label__ = 44;break $sw_epilog$$sw_bb$$sw_bb120$$sw_bb130$$sw_bb139$$sw_bb228$$sw_bb242$$sw_bb254$$sw_bb283$$sw_bb318$$sw_bb336$50; } //@line 1208 "dictionary.cpp"
  
          var $86=HEAP32[(($vowel_count)>>2)]; //@line 1210 "dictionary.cpp"
          var $sub135=((($86)-1)&4294967295); //@line 1210 "dictionary.cpp"
          var $arrayidx136=(($vowel_stress+$sub135)&4294967295); //@line 1210 "dictionary.cpp"
          HEAP8[($arrayidx136)]=4; //@line 1210 "dictionary.cpp"
          $max_stress=4; //@line 1211 "dictionary.cpp"
          __label__ = 114;break $sw_epilog$$sw_bb$$sw_bb120$$sw_bb130$$sw_bb139$$sw_bb228$$sw_bb242$$sw_bb254$$sw_bb283$$sw_bb318$$sw_bb336$50; //@line 1212 "dictionary.cpp"
        }
        else if (__label__ == 68) {
  
          var $129=HEAP32[(($stressed_syllable)>>2)]; //@line 1289 "dictionary.cpp"
          var $cmp229=((($129))|0)==0; //@line 1289 "dictionary.cpp"
          if (!($cmp229)) { __label__ = 112;break $sw_epilog$$sw_bb$$sw_bb120$$sw_bb130$$sw_bb139$$sw_bb228$$sw_bb242$$sw_bb254$$sw_bb283$$sw_bb318$$sw_bb336$50; } //@line 1289 "dictionary.cpp"
  
          var $130=HEAP32[(($vowel_count)>>2)]; //@line 1292 "dictionary.cpp"
          var $sub231=((($130)-1)&4294967295); //@line 1292 "dictionary.cpp"
          HEAP32[(($stressed_syllable)>>2)]=$sub231; //@line 1292 "dictionary.cpp"
          __lastLabel__ = 69; ; //@line 1294 "dictionary.cpp"
          while(1) { 
  
            var $131=__lastLabel__ == 73 ? $dec239 : ($sub231); //@line 1294 "dictionary.cpp"
            var $cmp232=((($131))|0) > 0; //@line 1294 "dictionary.cpp"
            if (!($cmp232)) { __label__ = 74;break ; } //@line 1294 "dictionary.cpp"
  
            var $132=HEAP32[(($stressed_syllable)>>2)]; //@line 1297 "dictionary.cpp"
            var $arrayidx233=(($vowel_stress+$132)&4294967295); //@line 1297 "dictionary.cpp"
            var $133=HEAP8[($arrayidx233)]; //@line 1297 "dictionary.cpp"
            var $conv234=(tempInt=(($133)),(tempInt>=128?tempInt-256:tempInt)); //@line 1297 "dictionary.cpp"
            var $cmp235=((($conv234))|0) < 0; //@line 1297 "dictionary.cpp"
            var $134=HEAP32[(($stressed_syllable)>>2)]; //@line 1299 "dictionary.cpp"
            if ($cmp235) { __label__ = 72;break ; } //@line 1297 "dictionary.cpp"
  
            var $dec239=((($134)-1)&4294967295); //@line 1303 "dictionary.cpp"
            HEAP32[(($stressed_syllable)>>2)]=$dec239; //@line 1303 "dictionary.cpp"
            __lastLabel__ = 73; __label__ = 70;continue ; //@line 1304 "dictionary.cpp"
          }
          if (__label__ == 72) {
  
            var $arrayidx237=(($vowel_stress+$134)&4294967295); //@line 1299 "dictionary.cpp"
            HEAP8[($arrayidx237)]=4; //@line 1299 "dictionary.cpp"
            ; //@line 1300 "dictionary.cpp"
          }
  
          $max_stress=4; //@line 1305 "dictionary.cpp"
          __label__ = 114;break $sw_epilog$$sw_bb$$sw_bb120$$sw_bb130$$sw_bb139$$sw_bb228$$sw_bb242$$sw_bb254$$sw_bb283$$sw_bb318$$sw_bb336$50; //@line 1306 "dictionary.cpp"
        }
        else if (__label__ == 75) {
  
          var $135=HEAP32[(($stressed_syllable)>>2)]; //@line 1310 "dictionary.cpp"
          var $cmp243=((($135))|0)==0; //@line 1310 "dictionary.cpp"
          if (!($cmp243)) { __label__ = 112;break $sw_epilog$$sw_bb$$sw_bb120$$sw_bb130$$sw_bb139$$sw_bb228$$sw_bb242$$sw_bb254$$sw_bb283$$sw_bb318$$sw_bb336$50; } //@line 1310 "dictionary.cpp"
  
          var $136=HEAP32[(($vowel_count)>>2)]; //@line 1312 "dictionary.cpp"
          var $sub245=((($136)-3)&4294967295); //@line 1312 "dictionary.cpp"
          HEAP32[(($stressed_syllable)>>2)]=$sub245; //@line 1312 "dictionary.cpp"
          var $137=HEAP32[(($stressed_syllable)>>2)]; //@line 1313 "dictionary.cpp"
          var $cmp246=((($137))|0) < 1; //@line 1313 "dictionary.cpp"
          if ($cmp246) { __label__ = 77;; } else { __label__ = 78;; } //@line 1313 "dictionary.cpp"
          if (__label__ == 77) {
  
            HEAP32[(($stressed_syllable)>>2)]=1; //@line 1314 "dictionary.cpp"
            ; //@line 1314 "dictionary.cpp"
          }
  
          var $138=$max_stress; //@line 1316 "dictionary.cpp"
          var $cmp249=((($138))|0)==0; //@line 1316 "dictionary.cpp"
          if ($cmp249) { __label__ = 79;; } else { __label__ = 80;; } //@line 1316 "dictionary.cpp"
          if (__label__ == 79) {
  
            var $139=HEAP32[(($stressed_syllable)>>2)]; //@line 1318 "dictionary.cpp"
            var $arrayidx251=(($vowel_stress+$139)&4294967295); //@line 1318 "dictionary.cpp"
            HEAP8[($arrayidx251)]=4; //@line 1318 "dictionary.cpp"
            ; //@line 1319 "dictionary.cpp"
          }
  
          $max_stress=4; //@line 1320 "dictionary.cpp"
          __label__ = 114;break $sw_epilog$$sw_bb$$sw_bb120$$sw_bb130$$sw_bb139$$sw_bb228$$sw_bb242$$sw_bb254$$sw_bb283$$sw_bb318$$sw_bb336$50; //@line 1321 "dictionary.cpp"
        }
        else if (__label__ == 81) {
  
          var $140=HEAP32[(($stressed_syllable)>>2)]; //@line 1326 "dictionary.cpp"
          var $cmp255=((($140))|0)==0; //@line 1326 "dictionary.cpp"
          if (!($cmp255)) { __label__ = 112;break $sw_epilog$$sw_bb$$sw_bb120$$sw_bb130$$sw_bb139$$sw_bb228$$sw_bb242$$sw_bb254$$sw_bb283$$sw_bb318$$sw_bb336$50; } //@line 1326 "dictionary.cpp"
  
          var $141=HEAP32[(($vowel_count)>>2)]; //@line 1333 "dictionary.cpp"
          var $sub257=((($141)-3)&4294967295); //@line 1333 "dictionary.cpp"
          HEAP32[(($stressed_syllable)>>2)]=$sub257; //@line 1333 "dictionary.cpp"
          var $142=HEAP32[(($vowel_count)>>2)]; //@line 1334 "dictionary.cpp"
          var $cmp258=((($142))|0) < 16; //@line 1334 "dictionary.cpp"
          if ($cmp258) { __label__ = 83;; } else { __label__ = 88;; } //@line 1334 "dictionary.cpp"
          if (__label__ == 83) {
  
            var $143=$final_ph; //@line 1336 "dictionary.cpp"
            var $arrayidx260=((_phoneme_tab+$143*4)&4294967295); //@line 1336 "dictionary.cpp"
            var $144=HEAP32[(($arrayidx260)>>2)]; //@line 1336 "dictionary.cpp"
            var $type261=(($144+11)&4294967295); //@line 1336 "dictionary.cpp"
            var $145=HEAPU8[($type261)]; //@line 1336 "dictionary.cpp"
            var $conv262=((($145))&255); //@line 1336 "dictionary.cpp"
            var $cmp263=((($conv262))|0)==2; //@line 1336 "dictionary.cpp"
            if ($cmp263) { __label__ = 84;; } else { __label__ = 85;; } //@line 1336 "dictionary.cpp"
            if (__label__ == 84) {
  
              var $146=HEAP32[(($vowel_count)>>2)]; //@line 1337 "dictionary.cpp"
              var $arrayidx265=((__ZZ13SetWordStressP10TranslatorPcPjiiE10guess_ru_v+$146)&4294967295); //@line 1337 "dictionary.cpp"
              var $147=HEAP8[($arrayidx265)]; //@line 1337 "dictionary.cpp"
              var $conv266=(tempInt=(($147)),(tempInt>=128?tempInt-256:tempInt)); //@line 1337 "dictionary.cpp"
              HEAP32[(($stressed_syllable)>>2)]=$conv266; //@line 1337 "dictionary.cpp"
              ; //@line 1337 "dictionary.cpp"
            }
            else if (__label__ == 85) {
  
              var $148=$final_ph; //@line 1339 "dictionary.cpp"
              var $arrayidx268=((_phoneme_tab+$148*4)&4294967295); //@line 1339 "dictionary.cpp"
              var $149=HEAP32[(($arrayidx268)>>2)]; //@line 1339 "dictionary.cpp"
              var $type269=(($149+11)&4294967295); //@line 1339 "dictionary.cpp"
              var $150=HEAPU8[($type269)]; //@line 1339 "dictionary.cpp"
              var $conv270=((($150))&255); //@line 1339 "dictionary.cpp"
              var $cmp271=((($conv270))|0)==4; //@line 1339 "dictionary.cpp"
              var $151=HEAP32[(($vowel_count)>>2)]; //@line 1340 "dictionary.cpp"
              if ($cmp271) { __label__ = 86;; } else { __label__ = 87;; } //@line 1339 "dictionary.cpp"
              if (__label__ == 86) {
  
                var $arrayidx273=((__ZZ13SetWordStressP10TranslatorPcPjiiE10guess_ru_t+$151)&4294967295); //@line 1340 "dictionary.cpp"
                var $152=HEAP8[($arrayidx273)]; //@line 1340 "dictionary.cpp"
                var $conv274=(tempInt=(($152)),(tempInt>=128?tempInt-256:tempInt)); //@line 1340 "dictionary.cpp"
                HEAP32[(($stressed_syllable)>>2)]=$conv274; //@line 1340 "dictionary.cpp"
                ; //@line 1340 "dictionary.cpp"
              }
              else if (__label__ == 87) {
  
                var $arrayidx276=((__ZZ13SetWordStressP10TranslatorPcPjiiE8guess_ru+$151)&4294967295); //@line 1342 "dictionary.cpp"
                var $153=HEAP8[($arrayidx276)]; //@line 1342 "dictionary.cpp"
                var $conv277=(tempInt=(($153)),(tempInt>=128?tempInt-256:tempInt)); //@line 1342 "dictionary.cpp"
                HEAP32[(($stressed_syllable)>>2)]=$conv277; //@line 1342 "dictionary.cpp"
                ;
              }
            }
          }
  
          var $154=HEAP32[(($stressed_syllable)>>2)]; //@line 1344 "dictionary.cpp"
          var $arrayidx281=(($vowel_stress+$154)&4294967295); //@line 1344 "dictionary.cpp"
          HEAP8[($arrayidx281)]=4; //@line 1344 "dictionary.cpp"
          $max_stress=4; //@line 1345 "dictionary.cpp"
          __label__ = 114;break $sw_epilog$$sw_bb$$sw_bb120$$sw_bb130$$sw_bb139$$sw_bb228$$sw_bb242$$sw_bb254$$sw_bb283$$sw_bb318$$sw_bb336$50; //@line 1346 "dictionary.cpp"
        }
        else if (__label__ == 89) {
  
          var $155=HEAP32[(($stressed_syllable)>>2)]; //@line 1350 "dictionary.cpp"
          var $cmp284=((($155))|0)==0; //@line 1350 "dictionary.cpp"
          if (!($cmp284)) { __label__ = 112;break $sw_epilog$$sw_bb$$sw_bb120$$sw_bb130$$sw_bb139$$sw_bb228$$sw_bb242$$sw_bb254$$sw_bb283$$sw_bb318$$sw_bb336$50; } //@line 1350 "dictionary.cpp"
  
          $max_weight=-1; //@line 1353 "dictionary.cpp"
          $ix=1; //@line 1357 "dictionary.cpp"
          var $156=$ix; //@line 1357 "dictionary.cpp"
          var $157=HEAP32[(($vowel_count)>>2)]; //@line 1357 "dictionary.cpp"
          var $sub28714=((($157)-1)&4294967295); //@line 1357 "dictionary.cpp"
          var $cmp28815=((($156))|0) < ((($sub28714))|0); //@line 1357 "dictionary.cpp"
          if ($cmp28815) { __label__ = 91;; } else { __label__ = 95;; } //@line 1357 "dictionary.cpp"
          $for_body289$$for_end302$86: do { 
            if (__label__ == 91) {
              $for_body289$87: while(1) { 
  
                var $158=$ix; //@line 1359 "dictionary.cpp"
                var $arrayidx290=(($vowel_stress+$158)&4294967295); //@line 1359 "dictionary.cpp"
                var $159=HEAP8[($arrayidx290)]; //@line 1359 "dictionary.cpp"
                var $conv291=(tempInt=(($159)),(tempInt>=128?tempInt-256:tempInt)); //@line 1359 "dictionary.cpp"
                var $cmp292=((($conv291))|0) < 0; //@line 1359 "dictionary.cpp"
                if ($cmp292) { __label__ = 92;; } else { __label__ = 94;; } //@line 1359 "dictionary.cpp"
                $if_then293$$for_inc300$89: do { 
                  if (__label__ == 92) {
  
                    var $160=$ix; //@line 1361 "dictionary.cpp"
                    var $arrayidx294=(($syllable_weight+$160)&4294967295); //@line 1361 "dictionary.cpp"
                    var $161=HEAP8[($arrayidx294)]; //@line 1361 "dictionary.cpp"
                    var $conv295=(tempInt=(($161)),(tempInt>=128?tempInt-256:tempInt)); //@line 1361 "dictionary.cpp"
                    $wt=$conv295; //@line 1361 "dictionary.cpp"
                    var $162=$max_weight; //@line 1361 "dictionary.cpp"
                    var $cmp296=((($conv295))|0) >= ((($162))|0); //@line 1361 "dictionary.cpp"
                    if (!($cmp296)) { __label__ = 94;break $if_then293$$for_inc300$89; } //@line 1361 "dictionary.cpp"
  
                    var $163=$wt; //@line 1363 "dictionary.cpp"
                    $max_weight=$163; //@line 1363 "dictionary.cpp"
                    var $164=HEAP32[(($stressed_syllable)>>2)]; //@line 1364 "dictionary.cpp"
                    $prev_stressed=$164; //@line 1364 "dictionary.cpp"
                    var $165=$ix; //@line 1365 "dictionary.cpp"
                    HEAP32[(($stressed_syllable)>>2)]=$165; //@line 1365 "dictionary.cpp"
                    ; //@line 1366 "dictionary.cpp"
                  }
                } while(0);
  
                var $166=$ix; //@line 1357 "dictionary.cpp"
                var $inc301=((($166)+1)&4294967295); //@line 1357 "dictionary.cpp"
                $ix=$inc301; //@line 1357 "dictionary.cpp"
                var $167=$ix; //@line 1357 "dictionary.cpp"
                var $168=HEAP32[(($vowel_count)>>2)]; //@line 1357 "dictionary.cpp"
                var $sub287=((($168)-1)&4294967295); //@line 1357 "dictionary.cpp"
                var $cmp288=((($167))|0) < ((($sub287))|0); //@line 1357 "dictionary.cpp"
                if ($cmp288) { __label__ = 91;continue $for_body289$87; } else { __label__ = 95;break $for_body289$$for_end302$86; } //@line 1357 "dictionary.cpp"
              }
            }
          } while(0);
  
          var $169=HEAP32[(($vowel_count)>>2)]; //@line 1370 "dictionary.cpp"
          var $sub303=((($169)-1)&4294967295); //@line 1370 "dictionary.cpp"
          var $arrayidx304=(($syllable_weight+$sub303)&4294967295); //@line 1370 "dictionary.cpp"
          var $170=HEAP8[($arrayidx304)]; //@line 1370 "dictionary.cpp"
          var $conv305=(tempInt=(($170)),(tempInt>=128?tempInt-256:tempInt)); //@line 1370 "dictionary.cpp"
          var $cmp306=((($conv305))|0)==2; //@line 1370 "dictionary.cpp"
          var $171=$max_weight; //@line 1370 "dictionary.cpp"
          if ($cmp306) { __label__ = 96;; } else { __label__ = 98;; } //@line 1370 "dictionary.cpp"
          $land_lhs_true307$$if_else311$94: do { 
            if (__label__ == 96) {
  
              var $cmp308=((($171))|0) < 2; //@line 1370 "dictionary.cpp"
              if (!($cmp308)) { __label__ = 100;break $land_lhs_true307$$if_else311$94; } //@line 1370 "dictionary.cpp"
  
              var $172=HEAP32[(($vowel_count)>>2)]; //@line 1373 "dictionary.cpp"
              var $sub310=((($172)-1)&4294967295); //@line 1373 "dictionary.cpp"
              HEAP32[(($stressed_syllable)>>2)]=$sub310; //@line 1373 "dictionary.cpp"
              ; //@line 1374 "dictionary.cpp"
            }
            else if (__label__ == 98) {
  
              var $cmp312=((($171))|0) <= 0; //@line 1376 "dictionary.cpp"
              if (!($cmp312)) { __label__ = 100;break $land_lhs_true307$$if_else311$94; } //@line 1376 "dictionary.cpp"
  
              HEAP32[(($stressed_syllable)>>2)]=1; //@line 1379 "dictionary.cpp"
              ; //@line 1380 "dictionary.cpp"
            }
          } while(0);
  
          var $173=HEAP32[(($stressed_syllable)>>2)]; //@line 1382 "dictionary.cpp"
          var $arrayidx316=(($vowel_stress+$173)&4294967295); //@line 1382 "dictionary.cpp"
          HEAP8[($arrayidx316)]=4; //@line 1382 "dictionary.cpp"
          $max_stress=4; //@line 1383 "dictionary.cpp"
          __label__ = 114;break $sw_epilog$$sw_bb$$sw_bb120$$sw_bb130$$sw_bb139$$sw_bb228$$sw_bb242$$sw_bb254$$sw_bb283$$sw_bb318$$sw_bb336$50; //@line 1384 "dictionary.cpp"
        }
        else if (__label__ == 101) {
  
          var $174=HEAP32[(($stressed_syllable)>>2)]; //@line 1388 "dictionary.cpp"
          var $cmp319=((($174))|0)==0; //@line 1388 "dictionary.cpp"
          if (!($cmp319)) { __label__ = 112;break $sw_epilog$$sw_bb$$sw_bb120$$sw_bb130$$sw_bb139$$sw_bb228$$sw_bb242$$sw_bb254$$sw_bb283$$sw_bb318$$sw_bb336$50; } //@line 1388 "dictionary.cpp"
  
          var $175=HEAP32[(($vowel_count)>>2)]; //@line 1390 "dictionary.cpp"
          var $sub321=((($175)-1)&4294967295); //@line 1390 "dictionary.cpp"
          HEAP32[(($stressed_syllable)>>2)]=$sub321; //@line 1390 "dictionary.cpp"
          $ix=1; //@line 1391 "dictionary.cpp"
          ; //@line 1391 "dictionary.cpp"
          while(1) { 
  
            var $176=$ix; //@line 1391 "dictionary.cpp"
            var $177=HEAP32[(($vowel_count)>>2)]; //@line 1391 "dictionary.cpp"
            var $cmp323=((($176))|0) < ((($177))|0); //@line 1391 "dictionary.cpp"
            if (!($cmp323)) { __label__ = 107;break ; } //@line 1391 "dictionary.cpp"
  
            var $178=$ix; //@line 1393 "dictionary.cpp"
            var $arrayidx325=(($vowel_stress+$178)&4294967295); //@line 1393 "dictionary.cpp"
            var $179=HEAP8[($arrayidx325)]; //@line 1393 "dictionary.cpp"
            var $conv326=(tempInt=(($179)),(tempInt>=128?tempInt-256:tempInt)); //@line 1393 "dictionary.cpp"
            var $cmp327=((($conv326))|0)==1; //@line 1393 "dictionary.cpp"
            var $180=$ix; //@line 1395 "dictionary.cpp"
            if ($cmp327) { __label__ = 105;break ; } //@line 1393 "dictionary.cpp"
  
            var $inc332=((($180)+1)&4294967295); //@line 1391 "dictionary.cpp"
            $ix=$inc332; //@line 1391 "dictionary.cpp"
            __label__ = 103;continue ; //@line 1391 "dictionary.cpp"
          }
          if (__label__ == 105) {
  
            var $sub329=((($180)-1)&4294967295); //@line 1395 "dictionary.cpp"
            HEAP32[(($stressed_syllable)>>2)]=$sub329; //@line 1395 "dictionary.cpp"
            ; //@line 1396 "dictionary.cpp"
          }
  
          var $181=HEAP32[(($stressed_syllable)>>2)]; //@line 1399 "dictionary.cpp"
          var $arrayidx334=(($vowel_stress+$181)&4294967295); //@line 1399 "dictionary.cpp"
          HEAP8[($arrayidx334)]=4; //@line 1399 "dictionary.cpp"
          $max_stress=4; //@line 1400 "dictionary.cpp"
          __label__ = 114;break $sw_epilog$$sw_bb$$sw_bb120$$sw_bb130$$sw_bb139$$sw_bb228$$sw_bb242$$sw_bb254$$sw_bb283$$sw_bb318$$sw_bb336$50; //@line 1401 "dictionary.cpp"
        }
        else if (__label__ == 108) {
  
          $ix=1; //@line 1405 "dictionary.cpp"
          var $182=$ix; //@line 1405 "dictionary.cpp"
          var $183=HEAP32[(($vowel_count)>>2)]; //@line 1405 "dictionary.cpp"
          var $cmp33813=((($182))|0) < ((($183))|0); //@line 1405 "dictionary.cpp"
          if (!($cmp33813)) { __label__ = 112;break $sw_epilog$$sw_bb$$sw_bb120$$sw_bb130$$sw_bb139$$sw_bb228$$sw_bb242$$sw_bb254$$sw_bb283$$sw_bb318$$sw_bb336$50; } //@line 1405 "dictionary.cpp"
          while(1) { 
  
            var $184=$ix; //@line 1407 "dictionary.cpp"
            var $arrayidx340=(($vowel_stress+$184)&4294967295); //@line 1407 "dictionary.cpp"
            var $185=HEAP8[($arrayidx340)]; //@line 1407 "dictionary.cpp"
            var $conv341=(tempInt=(($185)),(tempInt>=128?tempInt-256:tempInt)); //@line 1407 "dictionary.cpp"
            var $cmp342=((($conv341))|0) < 0; //@line 1407 "dictionary.cpp"
            if ($cmp342) { __label__ = 110;; } else { __label__ = 111;; } //@line 1407 "dictionary.cpp"
            if (__label__ == 110) {
  
              var $186=$ix; //@line 1408 "dictionary.cpp"
              var $arrayidx344=(($vowel_stress+$186)&4294967295); //@line 1408 "dictionary.cpp"
              HEAP8[($arrayidx344)]=4; //@line 1408 "dictionary.cpp"
              ; //@line 1408 "dictionary.cpp"
            }
  
            var $187=$ix; //@line 1405 "dictionary.cpp"
            var $inc347=((($187)+1)&4294967295); //@line 1405 "dictionary.cpp"
            $ix=$inc347; //@line 1405 "dictionary.cpp"
            var $188=$ix; //@line 1405 "dictionary.cpp"
            var $189=HEAP32[(($vowel_count)>>2)]; //@line 1405 "dictionary.cpp"
            var $cmp338=((($188))|0) < ((($189))|0); //@line 1405 "dictionary.cpp"
            if ($cmp338) { __label__ = 109;continue ; } else { __label__ = 112;break $sw_epilog$$sw_bb$$sw_bb120$$sw_bb130$$sw_bb139$$sw_bb228$$sw_bb242$$sw_bb254$$sw_bb283$$sw_bb318$$sw_bb336$50; } //@line 1405 "dictionary.cpp"
          }
        }
      } while(0);
      $sw_epilog$$sw_bb120$$if_else351$$sw_bb139$115: do { 
        if (__label__ == 36) {
  
          var $80=HEAP32[(($stressed_syllable)>>2)]; //@line 1194 "dictionary.cpp"
          var $cmp121=((($80))|0)==0; //@line 1194 "dictionary.cpp"
          if (!($cmp121)) { __label__ = 112;break $sw_epilog$$sw_bb120$$if_else351$$sw_bb139$115; } //@line 1194 "dictionary.cpp"
  
          var $81=HEAP32[(($vowel_count)>>2)]; //@line 1194 "dictionary.cpp"
          var $cmp123=((($81))|0) > 2; //@line 1194 "dictionary.cpp"
          if (!($cmp123)) { __label__ = 112;break $sw_epilog$$sw_bb120$$if_else351$$sw_bb139$115; } //@line 1194 "dictionary.cpp"
  
          HEAP32[(($stressed_syllable)>>2)]=2; //@line 1196 "dictionary.cpp"
          var $82=$max_stress; //@line 1197 "dictionary.cpp"
          var $cmp125=((($82))|0)==0; //@line 1197 "dictionary.cpp"
          if ($cmp125) { __label__ = 39;; } else { __label__ = 40;; } //@line 1197 "dictionary.cpp"
          if (__label__ == 39) {
  
            var $83=HEAP32[(($stressed_syllable)>>2)]; //@line 1199 "dictionary.cpp"
            var $arrayidx127=(($vowel_stress+$83)&4294967295); //@line 1199 "dictionary.cpp"
            HEAP8[($arrayidx127)]=4; //@line 1199 "dictionary.cpp"
            ; //@line 1200 "dictionary.cpp"
          }
  
          $max_stress=4; //@line 1201 "dictionary.cpp"
          __label__ = 114;break $sw_epilog$$sw_bb120$$if_else351$$sw_bb139$115; //@line 1202 "dictionary.cpp"
        }
        else if (__label__ == 44) {
  
          var $_pr5=HEAP32[(($stressed_syllable)>>2)]; //@line 1219 "dictionary.cpp"
          var $cmp140=((($_pr5))|0)==0; //@line 1219 "dictionary.cpp"
          if (!($cmp140)) { __label__ = 112;break $sw_epilog$$sw_bb120$$if_else351$$sw_bb139$115; } //@line 1219 "dictionary.cpp"
  
          $max_stress=4; //@line 1222 "dictionary.cpp"
          var $87=HEAP32[(($vowel_count)>>2)]; //@line 1224 "dictionary.cpp"
          var $cmp142=((($87))|0) > 2; //@line 1224 "dictionary.cpp"
          if ($cmp142) { __label__ = 46;; } else { __label__ = 63;; } //@line 1224 "dictionary.cpp"
          $if_then143$$if_else208$124: do { 
            if (__label__ == 46) {
  
              var $88=HEAP32[(($vowel_count)>>2)]; //@line 1226 "dictionary.cpp"
              var $sub144=((($88)-2)&4294967295); //@line 1226 "dictionary.cpp"
              HEAP32[(($stressed_syllable)>>2)]=$sub144; //@line 1226 "dictionary.cpp"
              var $89=$stressflags; //@line 1228 "dictionary.cpp"
              var $and145=($89) & 768; //@line 1228 "dictionary.cpp"
              var $tobool146=((($and145))|0)!=0; //@line 1228 "dictionary.cpp"
              if ($tobool146) { __label__ = 47;; } else { __label__ = 55;; } //@line 1228 "dictionary.cpp"
              $if_then147$$if_end179$126: do { 
                if (__label__ == 47) {
  
                  var $90=$final_ph; //@line 1231 "dictionary.cpp"
                  var $arrayidx148=((_phoneme_tab+$90*4)&4294967295); //@line 1231 "dictionary.cpp"
                  var $91=HEAP32[(($arrayidx148)>>2)]; //@line 1231 "dictionary.cpp"
                  var $type149=(($91+11)&4294967295); //@line 1231 "dictionary.cpp"
                  var $92=HEAPU8[($type149)]; //@line 1231 "dictionary.cpp"
                  var $conv150=((($92))&255); //@line 1231 "dictionary.cpp"
                  var $cmp151=((($conv150))|0)!=2; //@line 1231 "dictionary.cpp"
                  if (!($cmp151)) { __label__ = 55;break $if_then147$$if_end179$126; } //@line 1231 "dictionary.cpp"
  
                  var $93=$stressflags; //@line 1233 "dictionary.cpp"
                  var $and153=($93) & 256; //@line 1233 "dictionary.cpp"
                  var $tobool154=((($and153))|0)!=0; //@line 1233 "dictionary.cpp"
                  if ($tobool154) { __label__ = 49;; } else { __label__ = 50;; } //@line 1233 "dictionary.cpp"
                  if (__label__ == 49) {
  
                    var $94=HEAP32[(($vowel_count)>>2)]; //@line 1235 "dictionary.cpp"
                    var $sub156=((($94)-1)&4294967295); //@line 1235 "dictionary.cpp"
                    HEAP32[(($stressed_syllable)>>2)]=$sub156; //@line 1235 "dictionary.cpp"
                    ; //@line 1236 "dictionary.cpp"
                  }
                  else if (__label__ == 50) {
  
                    var $95=$final_ph; //@line 1239 "dictionary.cpp"
                    var $arrayidx157=((_phoneme_tab+$95*4)&4294967295); //@line 1239 "dictionary.cpp"
                    var $96=HEAP32[(($arrayidx157)>>2)]; //@line 1239 "dictionary.cpp"
                    var $mnemonic=(($96)&4294967295); //@line 1239 "dictionary.cpp"
                    var $97=HEAP32[(($mnemonic)>>2)]; //@line 1239 "dictionary.cpp"
                    $mnem=$97; //@line 1239 "dictionary.cpp"
                    var $98=$final_ph2; //@line 1240 "dictionary.cpp"
                    var $arrayidx158=((_phoneme_tab+$98*4)&4294967295); //@line 1240 "dictionary.cpp"
                    var $99=HEAP32[(($arrayidx158)>>2)]; //@line 1240 "dictionary.cpp"
                    var $mnemonic159=(($99)&4294967295); //@line 1240 "dictionary.cpp"
                    var $100=HEAP32[(($mnemonic159)>>2)]; //@line 1240 "dictionary.cpp"
                    $mnem2=$100; //@line 1240 "dictionary.cpp"
                    var $101=$mnem; //@line 1242 "dictionary.cpp"
                    var $cmp160=((($101))|0)==115; //@line 1242 "dictionary.cpp"
                    if ($cmp160) { __label__ = 51;; } else { __label__ = 52;; } //@line 1242 "dictionary.cpp"
                    if (__label__ == 51) {
  
                      var $102=$mnem2; //@line 1242 "dictionary.cpp"
                      var $cmp162=((($102))|0)==110; //@line 1242 "dictionary.cpp"
                      if ($cmp162) { __label__ = 55;break $if_then147$$if_end179$126; } //@line 1242 "dictionary.cpp"
                    }
  
                    var $103=$mnem; //@line 1247 "dictionary.cpp"
                    var $cmp165=((($103))|0)!=110; //@line 1247 "dictionary.cpp"
                    var $104=$mnem; //@line 1247 "dictionary.cpp"
                    var $cmp167=((($104))|0)!=115; //@line 1247 "dictionary.cpp"
                    var $or_cond=($cmp165) & ($cmp167); //@line 1247 "dictionary.cpp"
                    if ($or_cond) { __label__ = 54;; } else { __label__ = 53;; } //@line 1247 "dictionary.cpp"
                    if (__label__ == 53) {
  
                      var $105=$final_ph2; //@line 1247 "dictionary.cpp"
                      var $arrayidx169=((_phoneme_tab+$105*4)&4294967295); //@line 1247 "dictionary.cpp"
                      var $106=HEAP32[(($arrayidx169)>>2)]; //@line 1247 "dictionary.cpp"
                      var $type170=(($106+11)&4294967295); //@line 1247 "dictionary.cpp"
                      var $107=HEAPU8[($type170)]; //@line 1247 "dictionary.cpp"
                      var $conv171=((($107))&255); //@line 1247 "dictionary.cpp"
                      var $cmp172=((($conv171))|0)!=2; //@line 1247 "dictionary.cpp"
                      if (!($cmp172)) { __label__ = 55;break $if_then147$$if_end179$126; } //@line 1247 "dictionary.cpp"
                    }
  
                    var $108=HEAP32[(($vowel_count)>>2)]; //@line 1249 "dictionary.cpp"
                    var $sub174=((($108)-1)&4294967295); //@line 1249 "dictionary.cpp"
                    HEAP32[(($stressed_syllable)>>2)]=$sub174; //@line 1249 "dictionary.cpp"
                    ; //@line 1250 "dictionary.cpp"
                  }
                }
              } while(0);
  
              var $109=$stressflags; //@line 1254 "dictionary.cpp"
              var $and180=($109) & 524288; //@line 1254 "dictionary.cpp"
              var $tobool181=((($and180))|0)!=0; //@line 1254 "dictionary.cpp"
              if ($tobool181) { __label__ = 56;; } else { __label__ = 58;; } //@line 1254 "dictionary.cpp"
              $if_then182$$if_end193$139: do { 
                if (__label__ == 56) {
  
                  var $110=HEAP32[(($vowel_count)>>2)]; //@line 1257 "dictionary.cpp"
                  var $sub183=((($110)-1)&4294967295); //@line 1257 "dictionary.cpp"
                  var $arrayidx184=(($vowel_length+$sub183)&4294967295); //@line 1257 "dictionary.cpp"
                  var $111=HEAP8[($arrayidx184)]; //@line 1257 "dictionary.cpp"
                  var $conv185=(tempInt=(($111)),(tempInt>=128?tempInt-256:tempInt)); //@line 1257 "dictionary.cpp"
                  var $112=HEAP32[(($vowel_count)>>2)]; //@line 1257 "dictionary.cpp"
                  var $sub186=((($112)-2)&4294967295); //@line 1257 "dictionary.cpp"
                  var $arrayidx187=(($vowel_length+$sub186)&4294967295); //@line 1257 "dictionary.cpp"
                  var $113=HEAP8[($arrayidx187)]; //@line 1257 "dictionary.cpp"
                  var $conv188=(tempInt=(($113)),(tempInt>=128?tempInt-256:tempInt)); //@line 1257 "dictionary.cpp"
                  var $cmp189=((($conv185))|0) > ((($conv188))|0); //@line 1257 "dictionary.cpp"
                  if (!($cmp189)) { __label__ = 58;break $if_then182$$if_end193$139; } //@line 1257 "dictionary.cpp"
  
                  var $114=HEAP32[(($vowel_count)>>2)]; //@line 1259 "dictionary.cpp"
                  var $sub191=((($114)-1)&4294967295); //@line 1259 "dictionary.cpp"
                  HEAP32[(($stressed_syllable)>>2)]=$sub191; //@line 1259 "dictionary.cpp"
                  ; //@line 1260 "dictionary.cpp"
                }
              } while(0);
  
              var $115=HEAP32[(($stressed_syllable)>>2)]; //@line 1263 "dictionary.cpp"
              var $arrayidx194=(($vowel_stress+$115)&4294967295); //@line 1263 "dictionary.cpp"
              var $116=HEAP8[($arrayidx194)]; //@line 1263 "dictionary.cpp"
              var $conv195=(tempInt=(($116)),(tempInt>=128?tempInt-256:tempInt)); //@line 1263 "dictionary.cpp"
              var $cmp196=((($conv195))|0)==0; //@line 1263 "dictionary.cpp"
              if ($cmp196) { __lastLabel__ = 58; __label__ = 60;; } else { __lastLabel__ = 58; __label__ = 59;; } //@line 1263 "dictionary.cpp"
              if (__label__ == 59) {
  
                var $117=HEAP32[(($stressed_syllable)>>2)]; //@line 1263 "dictionary.cpp"
                var $arrayidx198=(($vowel_stress+$117)&4294967295); //@line 1263 "dictionary.cpp"
                var $118=HEAP8[($arrayidx198)]; //@line 1263 "dictionary.cpp"
                var $conv199=(tempInt=(($118)),(tempInt>=128?tempInt-256:tempInt)); //@line 1263 "dictionary.cpp"
                var $cmp200=((($conv199))|0)==1; //@line 1263 "dictionary.cpp"
                if ($cmp200) { __lastLabel__ = 59; ; } else { __lastLabel__ = 59; __label__ = 64;break $if_then143$$if_else208$124; } //@line 1263 "dictionary.cpp"
              }
  
              var $119=__lastLabel__ == 59 ? $117 : ($115); //@line 1266 "dictionary.cpp"
              var $cmp202=((($119))|0) > 1; //@line 1266 "dictionary.cpp"
              var $120=HEAP32[(($stressed_syllable)>>2)]; //@line 1267 "dictionary.cpp"
              if ($cmp202) { __label__ = 61;; } else { __label__ = 62;; } //@line 1266 "dictionary.cpp"
              if (__label__ == 61) {
  
                var $dec=((($120)-1)&4294967295); //@line 1267 "dictionary.cpp"
                HEAP32[(($stressed_syllable)>>2)]=$dec; //@line 1267 "dictionary.cpp"
                ; //@line 1267 "dictionary.cpp"
              }
              else if (__label__ == 62) {
  
                var $inc205=((($120)+1)&4294967295); //@line 1269 "dictionary.cpp"
                HEAP32[(($stressed_syllable)>>2)]=$inc205; //@line 1269 "dictionary.cpp"
                ;
              }
            }
            else if (__label__ == 63) {
  
              HEAP32[(($stressed_syllable)>>2)]=1; //@line 1274 "dictionary.cpp"
              ;
            }
          } while(0);
  
          var $121=HEAP32[(($stressed_syllable)>>2)]; //@line 1278 "dictionary.cpp"
          var $arrayidx210=(($vowel_stress+$121)&4294967295); //@line 1278 "dictionary.cpp"
          var $122=HEAP8[($arrayidx210)]; //@line 1278 "dictionary.cpp"
          var $conv211=(tempInt=(($122)),(tempInt>=128?tempInt-256:tempInt)); //@line 1278 "dictionary.cpp"
          var $cmp212=((($conv211))|0) < 0; //@line 1278 "dictionary.cpp"
          if (!($cmp212)) { __label__ = 112;break $sw_epilog$$sw_bb120$$if_else351$$sw_bb139$115; } //@line 1278 "dictionary.cpp"
  
          var $123=HEAP32[(($stressed_syllable)>>2)]; //@line 1281 "dictionary.cpp"
          var $sub214=((($123)-1)&4294967295); //@line 1281 "dictionary.cpp"
          var $arrayidx215=(($vowel_stress+$sub214)&4294967295); //@line 1281 "dictionary.cpp"
          var $124=HEAP8[($arrayidx215)]; //@line 1281 "dictionary.cpp"
          var $conv216=(tempInt=(($124)),(tempInt>=128?tempInt-256:tempInt)); //@line 1281 "dictionary.cpp"
          var $cmp217=((($conv216))|0) < 4; //@line 1281 "dictionary.cpp"
          if ($cmp217) { __label__ = 67;; } else { __label__ = 66;; } //@line 1281 "dictionary.cpp"
          if (__label__ == 66) {
  
            var $125=HEAP32[(($stressed_syllable)>>2)]; //@line 1281 "dictionary.cpp"
            var $add=((($125)+1)&4294967295); //@line 1281 "dictionary.cpp"
            var $arrayidx219=(($vowel_stress+$add)&4294967295); //@line 1281 "dictionary.cpp"
            var $126=HEAP8[($arrayidx219)]; //@line 1281 "dictionary.cpp"
            var $conv220=(tempInt=(($126)),(tempInt>=128?tempInt-256:tempInt)); //@line 1281 "dictionary.cpp"
            var $cmp221=((($conv220))|0) < 4; //@line 1281 "dictionary.cpp"
            if (!($cmp221)) { __label__ = 112;break $sw_epilog$$sw_bb120$$if_else351$$sw_bb139$115; } //@line 1281 "dictionary.cpp"
          }
  
          var $127=$max_stress; //@line 1282 "dictionary.cpp"
          var $conv223=((($127)) & 255); //@line 1282 "dictionary.cpp"
          var $128=HEAP32[(($stressed_syllable)>>2)]; //@line 1282 "dictionary.cpp"
          var $arrayidx224=(($vowel_stress+$128)&4294967295); //@line 1282 "dictionary.cpp"
          HEAP8[($arrayidx224)]=$conv223; //@line 1282 "dictionary.cpp"
          __label__ = 112;break $sw_epilog$$sw_bb120$$if_else351$$sw_bb139$115; //@line 1282 "dictionary.cpp"
        }
      } while(0);
      $sw_epilog$$if_else351$155: do { 
        if (__label__ == 112) {
  
          var $_pr9=$max_stress; //@line 1414 "dictionary.cpp"
          var $cmp349=((($_pr9))|0) < 4; //@line 1414 "dictionary.cpp"
          if (!($cmp349)) { __label__ = 114;break $sw_epilog$$if_else351$155; } //@line 1414 "dictionary.cpp"
  
          $stress=4; //@line 1415 "dictionary.cpp"
          __label__ = 115;break $sw_epilog$$if_else351$155; //@line 1415 "dictionary.cpp"
        }
      } while(0);
      if (__label__ == 114) {
  
        $stress=3; //@line 1417 "dictionary.cpp"
        ;
      }
  
      var $190=$stressflags; //@line 1420 "dictionary.cpp"
      var $and353=($190) & 4096; //@line 1420 "dictionary.cpp"
      var $tobool354=((($and353))|0)!=0; //@line 1420 "dictionary.cpp"
      if ($tobool354) { __label__ = 116;; } else { __label__ = 121;; } //@line 1420 "dictionary.cpp"
      $land_lhs_true355$$if_end370$161: do { 
        if (__label__ == 116) {
  
          var $191=HEAP32[(($vowel_count)>>2)]; //@line 1420 "dictionary.cpp"
          var $cmp356=((($191))|0)==2; //@line 1420 "dictionary.cpp"
          if (!($cmp356)) { __label__ = 121;break $land_lhs_true355$$if_end370$161; } //@line 1420 "dictionary.cpp"
  
          var $arrayidx358=(($vowel_stress+1)&4294967295); //@line 1423 "dictionary.cpp"
          var $192=HEAP8[($arrayidx358)]; //@line 1423 "dictionary.cpp"
          var $conv359=(tempInt=(($192)),(tempInt>=128?tempInt-256:tempInt)); //@line 1423 "dictionary.cpp"
          var $cmp360=((($conv359))|0)==4; //@line 1423 "dictionary.cpp"
          if ($cmp360) { __label__ = 118;; } else { __label__ = 119;; } //@line 1423 "dictionary.cpp"
          if (__label__ == 118) {
  
            var $arrayidx362=(($vowel_stress+2)&4294967295); //@line 1424 "dictionary.cpp"
            HEAP8[($arrayidx362)]=3; //@line 1424 "dictionary.cpp"
            ; //@line 1424 "dictionary.cpp"
          }
  
          var $arrayidx364=(($vowel_stress+2)&4294967295); //@line 1425 "dictionary.cpp"
          var $193=HEAP8[($arrayidx364)]; //@line 1425 "dictionary.cpp"
          var $conv365=(tempInt=(($193)),(tempInt>=128?tempInt-256:tempInt)); //@line 1425 "dictionary.cpp"
          var $cmp366=((($conv365))|0)==4; //@line 1425 "dictionary.cpp"
          if (!($cmp366)) { __label__ = 121;break $land_lhs_true355$$if_end370$161; } //@line 1425 "dictionary.cpp"
  
          var $arrayidx368=(($vowel_stress+1)&4294967295); //@line 1426 "dictionary.cpp"
          HEAP8[($arrayidx368)]=3; //@line 1426 "dictionary.cpp"
          ; //@line 1426 "dictionary.cpp"
        }
      } while(0);
  
      var $194=$stressflags; //@line 1429 "dictionary.cpp"
      var $and371=($194) & 8192; //@line 1429 "dictionary.cpp"
      var $tobool372=((($and371))|0)!=0; //@line 1429 "dictionary.cpp"
      if ($tobool372) { __label__ = 122;; } else { __label__ = 126;; } //@line 1429 "dictionary.cpp"
      $land_lhs_true373$$if_end386$169: do { 
        if (__label__ == 122) {
  
          var $arrayidx374=(($vowel_stress+1)&4294967295); //@line 1429 "dictionary.cpp"
          var $195=HEAP8[($arrayidx374)]; //@line 1429 "dictionary.cpp"
          var $conv375=(tempInt=(($195)),(tempInt>=128?tempInt-256:tempInt)); //@line 1429 "dictionary.cpp"
          var $cmp376=((($conv375))|0) < 0; //@line 1429 "dictionary.cpp"
          if (!($cmp376)) { __label__ = 126;break $land_lhs_true373$$if_end386$169; } //@line 1429 "dictionary.cpp"
  
          var $196=HEAP32[(($vowel_count)>>2)]; //@line 1432 "dictionary.cpp"
          var $cmp378=((($196))|0) > 2; //@line 1432 "dictionary.cpp"
          if (!($cmp378)) { __label__ = 126;break $land_lhs_true373$$if_end386$169; } //@line 1432 "dictionary.cpp"
  
          var $arrayidx380=(($vowel_stress+2)&4294967295); //@line 1432 "dictionary.cpp"
          var $197=HEAP8[($arrayidx380)]; //@line 1432 "dictionary.cpp"
          var $conv381=(tempInt=(($197)),(tempInt>=128?tempInt-256:tempInt)); //@line 1432 "dictionary.cpp"
          var $cmp382=((($conv381))|0) >= 4; //@line 1432 "dictionary.cpp"
          if (!($cmp382)) { __label__ = 126;break $land_lhs_true373$$if_end386$169; } //@line 1432 "dictionary.cpp"
  
          var $arrayidx384=(($vowel_stress+1)&4294967295); //@line 1434 "dictionary.cpp"
          HEAP8[($arrayidx384)]=3; //@line 1434 "dictionary.cpp"
          ; //@line 1435 "dictionary.cpp"
        }
      } while(0);
  
      $done=0; //@line 1438 "dictionary.cpp"
      $first_primary=0; //@line 1439 "dictionary.cpp"
      $v=1; //@line 1440 "dictionary.cpp"
      var $198=$v; //@line 1440 "dictionary.cpp"
      var $199=HEAP32[(($vowel_count)>>2)]; //@line 1440 "dictionary.cpp"
      var $cmp38818=((($198))|0) < ((($199))|0); //@line 1440 "dictionary.cpp"
      if ($cmp38818) { __label__ = 127;; } else { __label__ = 151;; } //@line 1440 "dictionary.cpp"
      $for_body389$$for_end471$175: do { 
        if (__label__ == 127) {
          $for_body389$176: while(1) { 
  
            var $200=$v; //@line 1442 "dictionary.cpp"
            var $arrayidx390=(($vowel_stress+$200)&4294967295); //@line 1442 "dictionary.cpp"
            var $201=HEAP8[($arrayidx390)]; //@line 1442 "dictionary.cpp"
            var $conv391=(tempInt=(($201)),(tempInt>=128?tempInt-256:tempInt)); //@line 1442 "dictionary.cpp"
            var $cmp392=((($conv391))|0) < 0; //@line 1442 "dictionary.cpp"
            if ($cmp392) { __label__ = 128;; } else { __label__ = 145;; } //@line 1442 "dictionary.cpp"
            $if_then393$$if_end454$178: do { 
              if (__label__ == 128) {
  
                var $202=$stressflags; //@line 1444 "dictionary.cpp"
                var $and394=($202) & 16; //@line 1444 "dictionary.cpp"
                var $tobool395=((($and394))|0)!=0; //@line 1444 "dictionary.cpp"
                if ($tobool395) { __label__ = 129;; } else { __label__ = 131;; } //@line 1444 "dictionary.cpp"
                $land_lhs_true396$$if_else402$180: do { 
                  if (__label__ == 129) {
  
                    var $203=$stress; //@line 1444 "dictionary.cpp"
                    var $cmp397=((($203))|0) < 4; //@line 1444 "dictionary.cpp"
                    if (!($cmp397)) { __label__ = 131;break $land_lhs_true396$$if_else402$180; } //@line 1444 "dictionary.cpp"
  
                    var $204=$v; //@line 1444 "dictionary.cpp"
                    var $205=HEAP32[(($vowel_count)>>2)]; //@line 1444 "dictionary.cpp"
                    var $sub399=((($205)-1)&4294967295); //@line 1444 "dictionary.cpp"
                    var $cmp400=((($204))|0)==((($sub399))|0); //@line 1444 "dictionary.cpp"
                    if ($cmp400) { __label__ = 145;break $if_then393$$if_end454$178; } //@line 1444 "dictionary.cpp"
                  }
                } while(0);
  
                var $206=$stressflags; //@line 1449 "dictionary.cpp"
                var $and403=($206) & 32768; //@line 1449 "dictionary.cpp"
                var $tobool404=((($and403))|0)!=0; //@line 1449 "dictionary.cpp"
                if ($tobool404) { __label__ = 132;; } else { __label__ = 134;; } //@line 1449 "dictionary.cpp"
                $land_lhs_true405$$if_else410$184: do { 
                  if (__label__ == 132) {
  
                    var $207=$done; //@line 1449 "dictionary.cpp"
                    var $cmp406=((($207))|0)==0; //@line 1449 "dictionary.cpp"
                    if (!($cmp406)) { __label__ = 134;break $land_lhs_true405$$if_else410$184; } //@line 1449 "dictionary.cpp"
  
                    var $208=$stress; //@line 1451 "dictionary.cpp"
                    var $conv408=((($208)) & 255); //@line 1451 "dictionary.cpp"
                    var $209=$v; //@line 1451 "dictionary.cpp"
                    var $arrayidx409=(($vowel_stress+$209)&4294967295); //@line 1451 "dictionary.cpp"
                    HEAP8[($arrayidx409)]=$conv408; //@line 1451 "dictionary.cpp"
                    $done=1; //@line 1452 "dictionary.cpp"
                    $stress=3; //@line 1453 "dictionary.cpp"
                    __label__ = 145;break $if_then393$$if_end454$178; //@line 1454 "dictionary.cpp"
                  }
                } while(0);
  
                var $210=$v; //@line 1456 "dictionary.cpp"
                var $sub411=((($210)-1)&4294967295); //@line 1456 "dictionary.cpp"
                var $arrayidx412=(($vowel_stress+$sub411)&4294967295); //@line 1456 "dictionary.cpp"
                var $211=HEAP8[($arrayidx412)]; //@line 1456 "dictionary.cpp"
                var $conv413=(tempInt=(($211)),(tempInt>=128?tempInt-256:tempInt)); //@line 1456 "dictionary.cpp"
                var $cmp414=((($conv413))|0) <= 1; //@line 1456 "dictionary.cpp"
                if (!($cmp414)) { __label__ = 145;break $if_then393$$if_end454$178; } //@line 1456 "dictionary.cpp"
  
                var $212=$v; //@line 1456 "dictionary.cpp"
                var $add416=((($212)+1)&4294967295); //@line 1456 "dictionary.cpp"
                var $arrayidx417=(($vowel_stress+$add416)&4294967295); //@line 1456 "dictionary.cpp"
                var $213=HEAP8[($arrayidx417)]; //@line 1456 "dictionary.cpp"
                var $conv418=(tempInt=(($213)),(tempInt>=128?tempInt-256:tempInt)); //@line 1456 "dictionary.cpp"
                var $cmp419=((($conv418))|0) <= 1; //@line 1456 "dictionary.cpp"
                if ($cmp419) { __label__ = 138;; } else { __label__ = 136;; } //@line 1456 "dictionary.cpp"
                if (__label__ == 136) {
  
                  var $214=$stress; //@line 1456 "dictionary.cpp"
                  var $cmp421=((($214))|0)==4; //@line 1456 "dictionary.cpp"
                  if (!($cmp421)) { __label__ = 145;break $if_then393$$if_end454$178; } //@line 1456 "dictionary.cpp"
  
                  var $215=$v; //@line 1456 "dictionary.cpp"
                  var $add423=((($215)+1)&4294967295); //@line 1456 "dictionary.cpp"
                  var $arrayidx424=(($vowel_stress+$add423)&4294967295); //@line 1456 "dictionary.cpp"
                  var $216=HEAP8[($arrayidx424)]; //@line 1456 "dictionary.cpp"
                  var $conv425=(tempInt=(($216)),(tempInt>=128?tempInt-256:tempInt)); //@line 1456 "dictionary.cpp"
                  var $cmp426=((($conv425))|0) <= 2; //@line 1456 "dictionary.cpp"
                  if (!($cmp426)) { __label__ = 145;break $if_then393$$if_end454$178; } //@line 1456 "dictionary.cpp"
                }
  
                var $217=$stress; //@line 1460 "dictionary.cpp"
                var $cmp428=((($217))|0)==3; //@line 1460 "dictionary.cpp"
                if ($cmp428) { __label__ = 139;; } else { __label__ = 140;; } //@line 1460 "dictionary.cpp"
                if (__label__ == 139) {
  
                  var $218=$stressflags; //@line 1460 "dictionary.cpp"
                  var $and430=($218) & 32; //@line 1460 "dictionary.cpp"
                  var $tobool431=((($and430))|0)!=0; //@line 1460 "dictionary.cpp"
                  if ($tobool431) { __label__ = 150;break $if_then393$$if_end454$178; } //@line 1460 "dictionary.cpp"
                }
  
                var $219=$v; //@line 1463 "dictionary.cpp"
                var $cmp434=((($219))|0) > 1; //@line 1463 "dictionary.cpp"
                if ($cmp434) { __label__ = 141;; } else { __label__ = 144;; } //@line 1463 "dictionary.cpp"
                $land_lhs_true435$$if_end448$196: do { 
                  if (__label__ == 141) {
  
                    var $220=$stressflags; //@line 1463 "dictionary.cpp"
                    var $and436=($220) & 64; //@line 1463 "dictionary.cpp"
                    var $tobool437=((($and436))|0)!=0; //@line 1463 "dictionary.cpp"
                    if (!($tobool437)) { __label__ = 144;break $land_lhs_true435$$if_end448$196; } //@line 1463 "dictionary.cpp"
  
                    var $221=$v; //@line 1463 "dictionary.cpp"
                    var $arrayidx439=(($syllable_weight+$221)&4294967295); //@line 1463 "dictionary.cpp"
                    var $222=HEAP8[($arrayidx439)]; //@line 1463 "dictionary.cpp"
                    var $conv440=(tempInt=(($222)),(tempInt>=128?tempInt-256:tempInt)); //@line 1463 "dictionary.cpp"
                    var $cmp441=((($conv440))|0)==0; //@line 1463 "dictionary.cpp"
                    if (!($cmp441)) { __label__ = 144;break $land_lhs_true435$$if_end448$196; } //@line 1463 "dictionary.cpp"
  
                    var $223=$v; //@line 1463 "dictionary.cpp"
                    var $add443=((($223)+1)&4294967295); //@line 1463 "dictionary.cpp"
                    var $arrayidx444=(($syllable_weight+$add443)&4294967295); //@line 1463 "dictionary.cpp"
                    var $224=HEAP8[($arrayidx444)]; //@line 1463 "dictionary.cpp"
                    var $conv445=(tempInt=(($224)),(tempInt>=128?tempInt-256:tempInt)); //@line 1463 "dictionary.cpp"
                    var $cmp446=((($conv445))|0) > 0; //@line 1463 "dictionary.cpp"
                    if ($cmp446) { __label__ = 150;break $if_then393$$if_end454$178; } //@line 1463 "dictionary.cpp"
                  }
                } while(0);
  
                var $225=$stress; //@line 1471 "dictionary.cpp"
                var $conv449=((($225)) & 255); //@line 1471 "dictionary.cpp"
                var $226=$v; //@line 1471 "dictionary.cpp"
                var $arrayidx450=(($vowel_stress+$226)&4294967295); //@line 1471 "dictionary.cpp"
                HEAP8[($arrayidx450)]=$conv449; //@line 1471 "dictionary.cpp"
                $done=1; //@line 1472 "dictionary.cpp"
                $stress=3; //@line 1473 "dictionary.cpp"
                __label__ = 145;break $if_then393$$if_end454$178; //@line 1474 "dictionary.cpp"
              }
            } while(0);
            $if_end454$$for_inc469$201: do { 
              if (__label__ == 145) {
  
                var $227=$v; //@line 1477 "dictionary.cpp"
                var $arrayidx455=(($vowel_stress+$227)&4294967295); //@line 1477 "dictionary.cpp"
                var $228=HEAP8[($arrayidx455)]; //@line 1477 "dictionary.cpp"
                var $conv456=(tempInt=(($228)),(tempInt>=128?tempInt-256:tempInt)); //@line 1477 "dictionary.cpp"
                var $cmp457=((($conv456))|0) >= 4; //@line 1477 "dictionary.cpp"
                if (!($cmp457)) { __label__ = 150;break $if_end454$$for_inc469$201; } //@line 1477 "dictionary.cpp"
  
                var $229=$first_primary; //@line 1479 "dictionary.cpp"
                var $cmp459=((($229))|0)==0; //@line 1479 "dictionary.cpp"
                if ($cmp459) { __label__ = 147;; } else { __label__ = 148;; } //@line 1479 "dictionary.cpp"
                if (__label__ == 147) {
  
                  var $230=$v; //@line 1480 "dictionary.cpp"
                  $first_primary=$230; //@line 1480 "dictionary.cpp"
                  ; //@line 1480 "dictionary.cpp"
                }
                else if (__label__ == 148) {
  
                  var $231=$stressflags; //@line 1482 "dictionary.cpp"
                  var $and462=($231) & 128; //@line 1482 "dictionary.cpp"
                  var $tobool463=((($and462))|0)!=0; //@line 1482 "dictionary.cpp"
                  if (!($tobool463)) { __label__ = 150;break $if_end454$$for_inc469$201; } //@line 1482 "dictionary.cpp"
  
                  var $232=$v; //@line 1485 "dictionary.cpp"
                  var $arrayidx465=(($vowel_stress+$232)&4294967295); //@line 1485 "dictionary.cpp"
                  HEAP8[($arrayidx465)]=3; //@line 1485 "dictionary.cpp"
                  ; //@line 1486 "dictionary.cpp"
                }
              }
            } while(0);
  
            var $233=$v; //@line 1440 "dictionary.cpp"
            var $inc470=((($233)+1)&4294967295); //@line 1440 "dictionary.cpp"
            $v=$inc470; //@line 1440 "dictionary.cpp"
            var $234=$v; //@line 1440 "dictionary.cpp"
            var $235=HEAP32[(($vowel_count)>>2)]; //@line 1440 "dictionary.cpp"
            var $cmp388=((($234))|0) < ((($235))|0); //@line 1440 "dictionary.cpp"
            if ($cmp388) { __label__ = 127;continue $for_body389$176; } else { __label__ = 151;break $for_body389$$for_end471$175; } //@line 1440 "dictionary.cpp"
          }
        }
      } while(0);
  
      var $236=$unstressed_word; //@line 1490 "dictionary.cpp"
      var $tobool472=((($236))|0)!=0; //@line 1490 "dictionary.cpp"
      if ($tobool472) { __label__ = 152;; } else { __label__ = 156;; } //@line 1490 "dictionary.cpp"
      $land_lhs_true473$$if_end482$210: do { 
        if (__label__ == 152) {
  
          var $237=$tonic_addr; //@line 1490 "dictionary.cpp"
          var $cmp474=((($237))|0) < 0; //@line 1490 "dictionary.cpp"
          if (!($cmp474)) { __label__ = 156;break $land_lhs_true473$$if_end482$210; } //@line 1490 "dictionary.cpp"
  
          var $238=HEAP32[(($vowel_count)>>2)]; //@line 1492 "dictionary.cpp"
          var $cmp476=((($238))|0) <= 2; //@line 1492 "dictionary.cpp"
          var $239=$tr_addr; //@line 1493 "dictionary.cpp"
          var $langopts478=(($239)&4294967295); //@line 1493 "dictionary.cpp"
          if ($cmp476) { __label__ = 154;; } else { __label__ = 155;; } //@line 1492 "dictionary.cpp"
          if (__label__ == 154) {
  
            var $unstressed_wd1=(($langopts478+16)&4294967295); //@line 1493 "dictionary.cpp"
            var $240=HEAP32[(($unstressed_wd1)>>2)]; //@line 1493 "dictionary.cpp"
            $tonic_addr=$240; //@line 1493 "dictionary.cpp"
            ; //@line 1493 "dictionary.cpp"
          }
          else if (__label__ == 155) {
  
            var $unstressed_wd2=(($langopts478+20)&4294967295); //@line 1495 "dictionary.cpp"
            var $241=HEAP32[(($unstressed_wd2)>>2)]; //@line 1495 "dictionary.cpp"
            $tonic_addr=$241; //@line 1495 "dictionary.cpp"
            ;
          }
        }
      } while(0);
  
      $max_stress=0; //@line 1498 "dictionary.cpp"
      $max_stress_posn=0; //@line 1499 "dictionary.cpp"
      $v=1; //@line 1500 "dictionary.cpp"
      var $242=$v; //@line 1500 "dictionary.cpp"
      var $243=HEAP32[(($vowel_count)>>2)]; //@line 1500 "dictionary.cpp"
      var $cmp48417=((($242))|0) < ((($243))|0); //@line 1500 "dictionary.cpp"
      if ($cmp48417) { __label__ = 157;; } else { __label__ = 160;; } //@line 1500 "dictionary.cpp"
      $for_body485$$for_end495$217: do { 
        if (__label__ == 157) {
          while(1) { 
  
            var $244=$v; //@line 1502 "dictionary.cpp"
            var $arrayidx486=(($vowel_stress+$244)&4294967295); //@line 1502 "dictionary.cpp"
            var $245=HEAP8[($arrayidx486)]; //@line 1502 "dictionary.cpp"
            var $conv487=(tempInt=(($245)),(tempInt>=128?tempInt-256:tempInt)); //@line 1502 "dictionary.cpp"
            var $246=$max_stress; //@line 1502 "dictionary.cpp"
            var $cmp488=((($conv487))|0) >= ((($246))|0); //@line 1502 "dictionary.cpp"
            if ($cmp488) { __label__ = 158;; } else { __label__ = 159;; } //@line 1502 "dictionary.cpp"
            if (__label__ == 158) {
  
              var $247=$v; //@line 1504 "dictionary.cpp"
              var $arrayidx490=(($vowel_stress+$247)&4294967295); //@line 1504 "dictionary.cpp"
              var $248=HEAP8[($arrayidx490)]; //@line 1504 "dictionary.cpp"
              var $conv491=(tempInt=(($248)),(tempInt>=128?tempInt-256:tempInt)); //@line 1504 "dictionary.cpp"
              $max_stress=$conv491; //@line 1504 "dictionary.cpp"
              var $249=$v; //@line 1505 "dictionary.cpp"
              $max_stress_posn=$249; //@line 1505 "dictionary.cpp"
              ; //@line 1506 "dictionary.cpp"
            }
  
            var $250=$v; //@line 1500 "dictionary.cpp"
            var $inc494=((($250)+1)&4294967295); //@line 1500 "dictionary.cpp"
            $v=$inc494; //@line 1500 "dictionary.cpp"
            var $251=$v; //@line 1500 "dictionary.cpp"
            var $252=HEAP32[(($vowel_count)>>2)]; //@line 1500 "dictionary.cpp"
            var $cmp484=((($251))|0) < ((($252))|0); //@line 1500 "dictionary.cpp"
            if ($cmp484) { __label__ = 157;continue ; } else { __label__ = 160;break $for_body485$$for_end495$217; } //@line 1500 "dictionary.cpp"
          }
        }
      } while(0);
  
      var $253=$tonic_addr; //@line 1509 "dictionary.cpp"
      var $cmp496=((($253))|0) >= 0; //@line 1509 "dictionary.cpp"
      if ($cmp496) { __label__ = 161;; } else { __label__ = 164;; } //@line 1509 "dictionary.cpp"
      if (__label__ == 161) {
  
        var $254=$tonic_addr; //@line 1514 "dictionary.cpp"
        var $255=$max_stress; //@line 1514 "dictionary.cpp"
        var $cmp498=((($254))|0) > ((($255))|0); //@line 1514 "dictionary.cpp"
        var $256=$max_stress; //@line 1514 "dictionary.cpp"
        var $cmp500=((($256))|0) <= 4; //@line 1514 "dictionary.cpp"
        var $or_cond1=($cmp498) | ($cmp500); //@line 1514 "dictionary.cpp"
        if ($or_cond1) { __label__ = 162;; } else { __label__ = 163;; } //@line 1514 "dictionary.cpp"
        if (__label__ == 162) {
  
          var $257=$tonic_addr; //@line 1515 "dictionary.cpp"
          var $conv502=((($257)) & 255); //@line 1515 "dictionary.cpp"
          var $258=$max_stress_posn; //@line 1515 "dictionary.cpp"
          var $arrayidx503=(($vowel_stress+$258)&4294967295); //@line 1515 "dictionary.cpp"
          HEAP8[($arrayidx503)]=$conv502; //@line 1515 "dictionary.cpp"
          ; //@line 1515 "dictionary.cpp"
        }
  
        var $259=$tonic_addr; //@line 1516 "dictionary.cpp"
        $max_stress=$259; //@line 1516 "dictionary.cpp"
        ; //@line 1517 "dictionary.cpp"
      }
  
      var $arraydecay506=(($phonetic)&4294967295); //@line 1521 "dictionary.cpp"
      $p=$arraydecay506; //@line 1521 "dictionary.cpp"
      $v=1; //@line 1522 "dictionary.cpp"
      var $260=$control_addr; //@line 1524 "dictionary.cpp"
      var $and507=($260) & 1; //@line 1524 "dictionary.cpp"
      var $tobool508=((($and507))|0)!=0; //@line 1524 "dictionary.cpp"
      if ($tobool508) { __label__ = 174;; } else { __label__ = 165;; } //@line 1524 "dictionary.cpp"
      $if_end544$$land_lhs_true509$230: do { 
        if (__label__ == 165) {
  
          var $261=$p; //@line 1524 "dictionary.cpp"
          var $262=HEAPU8[($261)]; //@line 1524 "dictionary.cpp"
          var $idxprom510=((($262))&255); //@line 1524 "dictionary.cpp"
          var $arrayidx511=((_phoneme_tab+$idxprom510*4)&4294967295); //@line 1524 "dictionary.cpp"
          var $263=HEAPU32[(($arrayidx511)>>2)]; //@line 1524 "dictionary.cpp"
          $ph=$263; //@line 1524 "dictionary.cpp"
          var $cmp512=((($263))|0)!=0; //@line 1524 "dictionary.cpp"
          if (!($cmp512)) { __label__ = 174;break $if_end544$$land_lhs_true509$230; } //@line 1524 "dictionary.cpp"
  
          var $264=$ph; //@line 1527 "dictionary.cpp"
          var $type514=(($264+11)&4294967295); //@line 1527 "dictionary.cpp"
          var $265=HEAPU8[($type514)]; //@line 1527 "dictionary.cpp"
          var $conv515=((($265))&255); //@line 1527 "dictionary.cpp"
          var $cmp516=((($conv515))|0)==1; //@line 1527 "dictionary.cpp"
          if ($cmp516) { __label__ = 167;; } else { __label__ = 168;; } //@line 1527 "dictionary.cpp"
          if (__label__ == 167) {
  
            var $266=$p; //@line 1528 "dictionary.cpp"
            var $arrayidx518=(($266+1)&4294967295); //@line 1528 "dictionary.cpp"
            var $267=HEAPU8[($arrayidx518)]; //@line 1528 "dictionary.cpp"
            var $idxprom519=((($267))&255); //@line 1528 "dictionary.cpp"
            var $arrayidx520=((_phoneme_tab+$idxprom519*4)&4294967295); //@line 1528 "dictionary.cpp"
            var $268=HEAP32[(($arrayidx520)>>2)]; //@line 1528 "dictionary.cpp"
            $ph=$268; //@line 1528 "dictionary.cpp"
            ; //@line 1528 "dictionary.cpp"
          }
  
          var $269=$tr_addr; //@line 1539 "dictionary.cpp"
          var $langopts522=(($269)&4294967295); //@line 1539 "dictionary.cpp"
          var $vowel_pause=(($langopts522+4)&4294967295); //@line 1539 "dictionary.cpp"
          var $270=HEAP32[(($vowel_pause)>>2)]; //@line 1539 "dictionary.cpp"
          var $and523=($270) & 48; //@line 1539 "dictionary.cpp"
          var $tobool524=((($and523))|0)!=0; //@line 1539 "dictionary.cpp"
          if (!($tobool524)) { __label__ = 174;break $if_end544$$land_lhs_true509$230; } //@line 1539 "dictionary.cpp"
  
          var $271=$ph; //@line 1539 "dictionary.cpp"
          var $type526=(($271+11)&4294967295); //@line 1539 "dictionary.cpp"
          var $272=HEAPU8[($type526)]; //@line 1539 "dictionary.cpp"
          var $conv527=((($272))&255); //@line 1539 "dictionary.cpp"
          var $cmp528=((($conv527))|0)==2; //@line 1539 "dictionary.cpp"
          if (!($cmp528)) { __label__ = 174;break $if_end544$$land_lhs_true509$230; } //@line 1539 "dictionary.cpp"
  
          var $273=$tr_addr; //@line 1543 "dictionary.cpp"
          var $langopts530=(($273)&4294967295); //@line 1543 "dictionary.cpp"
          var $vowel_pause531=(($langopts530+4)&4294967295); //@line 1543 "dictionary.cpp"
          var $274=HEAP32[(($vowel_pause531)>>2)]; //@line 1543 "dictionary.cpp"
          var $and532=($274) & 32; //@line 1543 "dictionary.cpp"
          var $tobool533=((($and532))|0)!=0; //@line 1543 "dictionary.cpp"
          if ($tobool533) { __label__ = 171;; } else { __label__ = 173;; } //@line 1543 "dictionary.cpp"
          $land_lhs_true534$$if_else540$238: do { 
            if (__label__ == 171) {
  
              var $arrayidx535=(($vowel_stress+1)&4294967295); //@line 1543 "dictionary.cpp"
              var $275=HEAP8[($arrayidx535)]; //@line 1543 "dictionary.cpp"
              var $conv536=(tempInt=(($275)),(tempInt>=128?tempInt-256:tempInt)); //@line 1543 "dictionary.cpp"
              var $cmp537=((($conv536))|0) >= 4; //@line 1543 "dictionary.cpp"
              if (!($cmp537)) { __label__ = 173;break $land_lhs_true534$$if_else540$238; } //@line 1543 "dictionary.cpp"
  
              var $276=$output_addr; //@line 1545 "dictionary.cpp"
              var $incdec_ptr539=(($276+1)&4294967295); //@line 1545 "dictionary.cpp"
              $output_addr=$incdec_ptr539; //@line 1545 "dictionary.cpp"
              HEAP8[($276)]=11; //@line 1545 "dictionary.cpp"
              __label__ = 174;break $if_end544$$land_lhs_true509$230; //@line 1546 "dictionary.cpp"
            }
          } while(0);
  
          var $277=$output_addr; //@line 1549 "dictionary.cpp"
          var $incdec_ptr541=(($277+1)&4294967295); //@line 1549 "dictionary.cpp"
          $output_addr=$incdec_ptr541; //@line 1549 "dictionary.cpp"
          HEAP8[($277)]=23; //@line 1549 "dictionary.cpp"
          ;
        }
      } while(0);
  
      var $arraydecay545=(($phonetic)&4294967295); //@line 1554 "dictionary.cpp"
      $p=$arraydecay545; //@line 1554 "dictionary.cpp"
      $post_tonic=0; //@line 1555 "dictionary.cpp"
      ; //@line 1556 "dictionary.cpp"
      $while_cond546$243: while(1) { 
  
        var $278=$p; //@line 1556 "dictionary.cpp"
        var $incdec_ptr547=(($278+1)&4294967295); //@line 1556 "dictionary.cpp"
        $p=$incdec_ptr547; //@line 1556 "dictionary.cpp"
        var $279=HEAPU8[($278)]; //@line 1556 "dictionary.cpp"
        $phcode=$279; //@line 1556 "dictionary.cpp"
        var $conv548=((($279))&255); //@line 1556 "dictionary.cpp"
        var $cmp549=((($conv548))|0)!=0; //@line 1556 "dictionary.cpp"
        if (!($cmp549)) { __label__ = 222;break $while_cond546$243; } //@line 1556 "dictionary.cpp"
  
        var $280=$output_addr; //@line 1556 "dictionary.cpp"
        var $281=$max_output; //@line 1556 "dictionary.cpp"
        var $cmp550=((($280))>>>0) < ((($281))>>>0); //@line 1556 "dictionary.cpp"
        if (!($cmp550)) { __label__ = 222;break $while_cond546$243; }
  
        var $282=$phcode; //@line 1558 "dictionary.cpp"
        var $idxprom552=((($282))&255); //@line 1558 "dictionary.cpp"
        var $arrayidx553=((_phoneme_tab+$idxprom552*4)&4294967295); //@line 1558 "dictionary.cpp"
        var $283=HEAPU32[(($arrayidx553)>>2)]; //@line 1558 "dictionary.cpp"
        $ph=$283; //@line 1558 "dictionary.cpp"
        var $cmp554=((($283))|0)==0; //@line 1558 "dictionary.cpp"
        if ($cmp554) { __label__ = 175;continue $while_cond546$243; } //@line 1558 "dictionary.cpp"
  
        var $284=$ph; //@line 1564 "dictionary.cpp"
        var $type557=(($284+11)&4294967295); //@line 1564 "dictionary.cpp"
        var $285=HEAPU8[($type557)]; //@line 1564 "dictionary.cpp"
        var $conv558=((($285))&255); //@line 1564 "dictionary.cpp"
        var $cmp559=((($conv558))|0)==0; //@line 1564 "dictionary.cpp"
        if ($cmp559) { __label__ = 179;; } else { __label__ = 180;; } //@line 1564 "dictionary.cpp"
        $if_then560$$if_else561$248: do { 
          if (__label__ == 179) {
  
            var $286=$tr_addr; //@line 1566 "dictionary.cpp"
            var $prev_last_stress=(($286+8288)&4294967295); //@line 1566 "dictionary.cpp"
            HEAP32[(($prev_last_stress)>>2)]=0; //@line 1566 "dictionary.cpp"
            ; //@line 1567 "dictionary.cpp"
          }
          else if (__label__ == 180) {
  
            var $287=$ph; //@line 1569 "dictionary.cpp"
            var $type562=(($287+11)&4294967295); //@line 1569 "dictionary.cpp"
            var $288=HEAPU8[($type562)]; //@line 1569 "dictionary.cpp"
            var $conv563=((($288))&255); //@line 1569 "dictionary.cpp"
            var $cmp564=((($conv563))|0)==2; //@line 1569 "dictionary.cpp"
            if ($cmp564) { __label__ = 181;; } else { __label__ = 182;; } //@line 1569 "dictionary.cpp"
            $land_lhs_true565$$lor_lhs_false569$251: do { 
              if (__label__ == 181) {
  
                var $289=$ph; //@line 1569 "dictionary.cpp"
                var $phflags566=(($289+4)&4294967295); //@line 1569 "dictionary.cpp"
                var $290=HEAP32[(($phflags566)>>2)]; //@line 1569 "dictionary.cpp"
                var $and567=($290) & 1048576; //@line 1569 "dictionary.cpp"
                var $tobool568=((($and567))|0)!=0; //@line 1569 "dictionary.cpp"
                if ($tobool568) { __label__ = 182;break $land_lhs_true565$$lor_lhs_false569$251; } else { __label__ = 183;break $land_lhs_true565$$lor_lhs_false569$251; } //@line 1569 "dictionary.cpp"
              }
            } while(0);
            if (__label__ == 182) {
  
              var $291=$p; //@line 1569 "dictionary.cpp"
              var $292=HEAPU8[($291)]; //@line 1569 "dictionary.cpp"
              var $conv570=((($292))&255); //@line 1569 "dictionary.cpp"
              var $cmp571=((($conv570))|0)==20; //@line 1569 "dictionary.cpp"
              if (!($cmp571)) { __label__ = 220;break $if_then560$$if_else561$248; } //@line 1569 "dictionary.cpp"
            }
  
            var $293=$v; //@line 1573 "dictionary.cpp"
            var $arrayidx573=(($vowel_stress+$293)&4294967295); //@line 1573 "dictionary.cpp"
            var $294=HEAP8[($arrayidx573)]; //@line 1573 "dictionary.cpp"
            var $conv574=(tempInt=(($294)),(tempInt>=128?tempInt-256:tempInt)); //@line 1573 "dictionary.cpp"
            $v_stress=$conv574; //@line 1573 "dictionary.cpp"
            var $295=$v_stress; //@line 1574 "dictionary.cpp"
            var $296=$tr_addr; //@line 1574 "dictionary.cpp"
            var $prev_last_stress575=(($296+8288)&4294967295); //@line 1574 "dictionary.cpp"
            HEAP32[(($prev_last_stress575)>>2)]=$295; //@line 1574 "dictionary.cpp"
            var $297=$v; //@line 1576 "dictionary.cpp"
            var $sub576=((($297)-1)&4294967295); //@line 1576 "dictionary.cpp"
            var $arrayidx577=(($vowel_stress+$sub576)&4294967295); //@line 1576 "dictionary.cpp"
            var $298=HEAP8[($arrayidx577)]; //@line 1576 "dictionary.cpp"
            var $conv578=(tempInt=(($298)),(tempInt>=128?tempInt-256:tempInt)); //@line 1576 "dictionary.cpp"
            var $299=$max_stress; //@line 1576 "dictionary.cpp"
            var $cmp579=((($conv578))|0) >= ((($299))|0); //@line 1576 "dictionary.cpp"
            if ($cmp579) { __label__ = 184;; } else { __label__ = 185;; } //@line 1576 "dictionary.cpp"
            if (__label__ == 184) {
  
              $post_tonic=1; //@line 1577 "dictionary.cpp"
              ; //@line 1577 "dictionary.cpp"
            }
  
            var $300=$v_stress; //@line 1579 "dictionary.cpp"
            var $cmp582=((($300))|0) <= 1; //@line 1579 "dictionary.cpp"
            if ($cmp582) { __label__ = 186;; } else { __label__ = 201;; } //@line 1579 "dictionary.cpp"
            $if_then583$$if_end627$259: do { 
              if (__label__ == 186) {
  
                var $301=$v; //@line 1581 "dictionary.cpp"
                var $cmp584=((($301))|0) > 1; //@line 1581 "dictionary.cpp"
                if ($cmp584) { __label__ = 187;; } else { __label__ = 191;; } //@line 1581 "dictionary.cpp"
                $land_lhs_true585$$if_else594$261: do { 
                  if (__label__ == 187) {
  
                    var $302=$max_stress; //@line 1581 "dictionary.cpp"
                    var $cmp586=((($302))|0) >= 4; //@line 1581 "dictionary.cpp"
                    if (!($cmp586)) { __label__ = 191;break $land_lhs_true585$$if_else594$261; } //@line 1581 "dictionary.cpp"
  
                    var $303=$stressflags; //@line 1581 "dictionary.cpp"
                    var $and588=($303) & 4; //@line 1581 "dictionary.cpp"
                    var $tobool589=((($and588))|0)!=0; //@line 1581 "dictionary.cpp"
                    if (!($tobool589)) { __label__ = 191;break $land_lhs_true585$$if_else594$261; } //@line 1581 "dictionary.cpp"
  
                    var $304=$v; //@line 1581 "dictionary.cpp"
                    var $305=HEAP32[(($vowel_count)>>2)]; //@line 1581 "dictionary.cpp"
                    var $sub591=((($305)-1)&4294967295); //@line 1581 "dictionary.cpp"
                    var $cmp592=((($304))|0)==((($sub591))|0); //@line 1581 "dictionary.cpp"
                    if (!($cmp592)) { __label__ = 191;break $land_lhs_true585$$if_else594$261; } //@line 1581 "dictionary.cpp"
  
                    $v_stress=0; //@line 1584 "dictionary.cpp"
                    __label__ = 201;break $if_then583$$if_end627$259; //@line 1585 "dictionary.cpp"
                  }
                } while(0);
  
                var $306=$stressflags; //@line 1587 "dictionary.cpp"
                var $and595=($306) & 2; //@line 1587 "dictionary.cpp"
                var $tobool596=((($and595))|0)!=0; //@line 1587 "dictionary.cpp"
                if ($tobool596) { __label__ = 194;; } else { __label__ = 192;; } //@line 1587 "dictionary.cpp"
                $if_then602$$lor_lhs_false597$267: do { 
                  if (__label__ == 192) {
  
                    var $307=$v; //@line 1587 "dictionary.cpp"
                    var $cmp598=((($307))|0)==1; //@line 1587 "dictionary.cpp"
                    if ($cmp598) { __label__ = 194;break $if_then602$$lor_lhs_false597$267; } //@line 1587 "dictionary.cpp"
  
                    var $308=$v; //@line 1587 "dictionary.cpp"
                    var $309=HEAP32[(($vowel_count)>>2)]; //@line 1587 "dictionary.cpp"
                    var $sub600=((($309)-1)&4294967295); //@line 1587 "dictionary.cpp"
                    var $cmp601=((($308))|0)==((($sub600))|0); //@line 1587 "dictionary.cpp"
                    if ($cmp601) { __label__ = 194;break $if_then602$$lor_lhs_false597$267; } //@line 1587 "dictionary.cpp"
  
                    var $310=$v; //@line 1593 "dictionary.cpp"
                    var $311=HEAP32[(($vowel_count)>>2)]; //@line 1593 "dictionary.cpp"
                    var $sub604=((($311)-2)&4294967295); //@line 1593 "dictionary.cpp"
                    var $cmp605=((($310))|0)==((($sub604))|0); //@line 1593 "dictionary.cpp"
                    if ($cmp605) { __label__ = 196;; } else { __label__ = 198;; } //@line 1593 "dictionary.cpp"
                    $land_lhs_true606$$if_else612$271: do { 
                      if (__label__ == 196) {
  
                        var $312=HEAP32[(($vowel_count)>>2)]; //@line 1593 "dictionary.cpp"
                        var $sub607=((($312)-1)&4294967295); //@line 1593 "dictionary.cpp"
                        var $arrayidx608=(($vowel_stress+$sub607)&4294967295); //@line 1593 "dictionary.cpp"
                        var $313=HEAP8[($arrayidx608)]; //@line 1593 "dictionary.cpp"
                        var $conv609=(tempInt=(($313)),(tempInt>=128?tempInt-256:tempInt)); //@line 1593 "dictionary.cpp"
                        var $cmp610=((($conv609))|0) <= 1; //@line 1593 "dictionary.cpp"
                        if (!($cmp610)) { __label__ = 198;break $land_lhs_true606$$if_else612$271; } //@line 1593 "dictionary.cpp"
  
                        $v_stress=1; //@line 1596 "dictionary.cpp"
                        __label__ = 201;break $if_then583$$if_end627$259; //@line 1597 "dictionary.cpp"
                      }
                    } while(0);
  
                    var $314=$v; //@line 1601 "dictionary.cpp"
                    var $sub613=((($314)-1)&4294967295); //@line 1601 "dictionary.cpp"
                    var $arrayidx614=(($vowel_stress+$sub613)&4294967295); //@line 1601 "dictionary.cpp"
                    var $315=HEAP8[($arrayidx614)]; //@line 1601 "dictionary.cpp"
                    var $conv615=(tempInt=(($315)),(tempInt>=128?tempInt-256:tempInt)); //@line 1601 "dictionary.cpp"
                    var $cmp616=((($conv615))|0) < 0; //@line 1601 "dictionary.cpp"
                    if ($cmp616) { __label__ = 200;; } else { __label__ = 199;; } //@line 1601 "dictionary.cpp"
                    if (__label__ == 199) {
  
                      var $316=$stressflags; //@line 1601 "dictionary.cpp"
                      var $and618=($316) & 65536; //@line 1601 "dictionary.cpp"
                      var $cmp619=((($and618))|0)==0; //@line 1601 "dictionary.cpp"
                      if (!($cmp619)) { __label__ = 201;break $if_then583$$if_end627$259; } //@line 1601 "dictionary.cpp"
                    }
  
                    $v_stress=0; //@line 1603 "dictionary.cpp"
                    var $317=$v_stress; //@line 1604 "dictionary.cpp"
                    var $conv621=((($317)) & 255); //@line 1604 "dictionary.cpp"
                    var $318=$v; //@line 1604 "dictionary.cpp"
                    var $arrayidx622=(($vowel_stress+$318)&4294967295); //@line 1604 "dictionary.cpp"
                    HEAP8[($arrayidx622)]=$conv621; //@line 1604 "dictionary.cpp"
                    __label__ = 201;break $if_then583$$if_end627$259; //@line 1605 "dictionary.cpp"
                  }
                } while(0);
  
                $v_stress=1; //@line 1590 "dictionary.cpp"
                ; //@line 1591 "dictionary.cpp"
              }
            } while(0);
  
            var $319=$v_stress; //@line 1609 "dictionary.cpp"
            var $cmp628=((($319))|0)==0; //@line 1609 "dictionary.cpp"
            var $320=$v_stress; //@line 1609 "dictionary.cpp"
            var $cmp630=((($320))|0) > 1; //@line 1609 "dictionary.cpp"
            var $or_cond2=($cmp628) | ($cmp630); //@line 1609 "dictionary.cpp"
            if ($or_cond2) { __label__ = 202;; } else { __label__ = 203;; } //@line 1609 "dictionary.cpp"
            if (__label__ == 202) {
  
              var $321=$v_stress; //@line 1610 "dictionary.cpp"
              var $arrayidx632=((__ZL15stress_phonemes+$321)&4294967295); //@line 1610 "dictionary.cpp"
              var $322=HEAP8[($arrayidx632)]; //@line 1610 "dictionary.cpp"
              var $323=$output_addr; //@line 1610 "dictionary.cpp"
              var $incdec_ptr633=(($323+1)&4294967295); //@line 1610 "dictionary.cpp"
              $output_addr=$incdec_ptr633; //@line 1610 "dictionary.cpp"
              HEAP8[($323)]=$322; //@line 1610 "dictionary.cpp"
              ; //@line 1610 "dictionary.cpp"
            }
  
            var $324=$v; //@line 1613 "dictionary.cpp"
            var $arrayidx635=(($vowel_stress+$324)&4294967295); //@line 1613 "dictionary.cpp"
            var $325=HEAP8[($arrayidx635)]; //@line 1613 "dictionary.cpp"
            var $conv636=(tempInt=(($325)),(tempInt>=128?tempInt-256:tempInt)); //@line 1613 "dictionary.cpp"
            var $326=$max_stress; //@line 1613 "dictionary.cpp"
            var $cmp637=((($conv636))|0) > ((($326))|0); //@line 1613 "dictionary.cpp"
            if ($cmp637) { __label__ = 204;; } else { __label__ = 205;; } //@line 1613 "dictionary.cpp"
            if (__label__ == 204) {
  
              var $327=$v; //@line 1615 "dictionary.cpp"
              var $arrayidx639=(($vowel_stress+$327)&4294967295); //@line 1615 "dictionary.cpp"
              var $328=HEAP8[($arrayidx639)]; //@line 1615 "dictionary.cpp"
              var $conv640=(tempInt=(($328)),(tempInt>=128?tempInt-256:tempInt)); //@line 1615 "dictionary.cpp"
              $max_stress=$conv640; //@line 1615 "dictionary.cpp"
              ; //@line 1616 "dictionary.cpp"
            }
  
            var $329=$p; //@line 1618 "dictionary.cpp"
            var $330=HEAPU8[($329)]; //@line 1618 "dictionary.cpp"
            var $conv642=((($330))&255); //@line 1618 "dictionary.cpp"
            var $cmp643=((($conv642))|0)==12; //@line 1618 "dictionary.cpp"
            if ($cmp643) { __label__ = 206;; } else { __label__ = 214;; } //@line 1618 "dictionary.cpp"
            $land_lhs_true644$$if_end665$286: do { 
              if (__label__ == 206) {
  
                var $331=$tr_addr; //@line 1618 "dictionary.cpp"
                var $langopts645=(($331)&4294967295); //@line 1618 "dictionary.cpp"
                var $param=(($langopts645+24)&4294967295); //@line 1618 "dictionary.cpp"
                var $arrayidx646=(($param+8)&4294967295); //@line 1618 "dictionary.cpp"
                var $332=HEAP32[(($arrayidx646)>>2)]; //@line 1618 "dictionary.cpp"
                $opt_length=$332; //@line 1618 "dictionary.cpp"
                var $and647=($332) & 1; //@line 1618 "dictionary.cpp"
                var $tobool648=((($and647))|0)!=0; //@line 1618 "dictionary.cpp"
                if (!($tobool648)) { __label__ = 214;break $land_lhs_true644$$if_end665$286; } //@line 1618 "dictionary.cpp"
  
                $shorten=0; //@line 1621 "dictionary.cpp"
                var $333=$opt_length; //@line 1623 "dictionary.cpp"
                var $and650=($333) & 16; //@line 1623 "dictionary.cpp"
                var $tobool651=((($and650))|0)!=0; //@line 1623 "dictionary.cpp"
                if ($tobool651) { __label__ = 208;; } else { __label__ = 210;; } //@line 1623 "dictionary.cpp"
                $if_then652$$if_else656$289: do { 
                  if (__label__ == 208) {
  
                    var $334=$v; //@line 1626 "dictionary.cpp"
                    var $335=$max_stress_posn; //@line 1626 "dictionary.cpp"
                    var $cmp653=((($334))|0)!=((($335))|0); //@line 1626 "dictionary.cpp"
                    if (!($cmp653)) { __label__ = 212;break $if_then652$$if_else656$289; } //@line 1626 "dictionary.cpp"
  
                    $shorten=1; //@line 1627 "dictionary.cpp"
                    __label__ = 213;break $if_then652$$if_else656$289; //@line 1627 "dictionary.cpp"
                  }
                  else if (__label__ == 210) {
  
                    var $336=$v_stress; //@line 1630 "dictionary.cpp"
                    var $cmp657=((($336))|0) < 4; //@line 1630 "dictionary.cpp"
                    if (!($cmp657)) { __label__ = 212;break $if_then652$$if_else656$289; } //@line 1630 "dictionary.cpp"
  
                    $shorten=1; //@line 1633 "dictionary.cpp"
                    __label__ = 213;break $if_then652$$if_else656$289; //@line 1634 "dictionary.cpp"
                  }
                } while(0);
                if (__label__ == 212) {
  
                  var $_pr11=$shorten; //@line 1636 "dictionary.cpp"
                  var $tobool661=((($_pr11))|0)!=0; //@line 1636 "dictionary.cpp"
                  if (!($tobool661)) { __label__ = 214;break $land_lhs_true644$$if_end665$286; } //@line 1636 "dictionary.cpp"
                }
  
                var $337=$p; //@line 1637 "dictionary.cpp"
                var $incdec_ptr663=(($337+1)&4294967295); //@line 1637 "dictionary.cpp"
                $p=$incdec_ptr663; //@line 1637 "dictionary.cpp"
                ; //@line 1637 "dictionary.cpp"
              }
            } while(0);
  
            var $338=$v_stress; //@line 1640 "dictionary.cpp"
            var $cmp666=((($338))|0) >= 4; //@line 1640 "dictionary.cpp"
            if ($cmp666) { __label__ = 215;; } else { __label__ = 219;; } //@line 1640 "dictionary.cpp"
            $land_lhs_true667$$if_end682$298: do { 
              if (__label__ == 215) {
  
                var $339=$tr_addr; //@line 1640 "dictionary.cpp"
                var $langopts668=(($339)&4294967295); //@line 1640 "dictionary.cpp"
                var $param669=(($langopts668+24)&4294967295); //@line 1640 "dictionary.cpp"
                var $arrayidx670=(($param669+8)&4294967295); //@line 1640 "dictionary.cpp"
                var $340=HEAP32[(($arrayidx670)>>2)]; //@line 1640 "dictionary.cpp"
                var $cmp671=((($340))|0)==2; //@line 1640 "dictionary.cpp"
                if (!($cmp671)) { __label__ = 219;break $land_lhs_true667$$if_end682$298; } //@line 1640 "dictionary.cpp"
  
                var $341=$v; //@line 1643 "dictionary.cpp"
                var $342=HEAP32[(($vowel_count)>>2)]; //@line 1643 "dictionary.cpp"
                var $sub673=((($342)-2)&4294967295); //@line 1643 "dictionary.cpp"
                var $cmp674=((($341))|0)==((($sub673))|0); //@line 1643 "dictionary.cpp"
                if (!($cmp674)) { __label__ = 219;break $land_lhs_true667$$if_end682$298; } //@line 1643 "dictionary.cpp"
  
                var $343=$v; //@line 1643 "dictionary.cpp"
                var $arrayidx676=(($syllable_weight+$343)&4294967295); //@line 1643 "dictionary.cpp"
                var $344=HEAP8[($arrayidx676)]; //@line 1643 "dictionary.cpp"
                var $conv677=(tempInt=(($344)),(tempInt>=128?tempInt-256:tempInt)); //@line 1643 "dictionary.cpp"
                var $cmp678=((($conv677))|0)==0; //@line 1643 "dictionary.cpp"
                if (!($cmp678)) { __label__ = 219;break $land_lhs_true667$$if_end682$298; } //@line 1643 "dictionary.cpp"
  
                var $345=$phcode; //@line 1645 "dictionary.cpp"
                var $346=$output_addr; //@line 1645 "dictionary.cpp"
                var $incdec_ptr680=(($346+1)&4294967295); //@line 1645 "dictionary.cpp"
                $output_addr=$incdec_ptr680; //@line 1645 "dictionary.cpp"
                HEAP8[($346)]=$345; //@line 1645 "dictionary.cpp"
                $phcode=12; //@line 1646 "dictionary.cpp"
                ; //@line 1647 "dictionary.cpp"
              }
            } while(0);
  
            var $347=$v; //@line 1650 "dictionary.cpp"
            var $inc683=((($347)+1)&4294967295); //@line 1650 "dictionary.cpp"
            $v=$inc683; //@line 1650 "dictionary.cpp"
            ; //@line 1651 "dictionary.cpp"
          }
        } while(0);
  
        var $348=$phcode; //@line 1653 "dictionary.cpp"
        var $conv686=((($348))&255); //@line 1653 "dictionary.cpp"
        var $cmp687=((($conv686))|0)!=1; //@line 1653 "dictionary.cpp"
        if (!($cmp687)) { __label__ = 175;continue $while_cond546$243; } //@line 1653 "dictionary.cpp"
  
        var $349=$phcode; //@line 1654 "dictionary.cpp"
        var $350=$output_addr; //@line 1654 "dictionary.cpp"
        var $incdec_ptr689=(($350+1)&4294967295); //@line 1654 "dictionary.cpp"
        $output_addr=$incdec_ptr689; //@line 1654 "dictionary.cpp"
        HEAP8[($350)]=$349; //@line 1654 "dictionary.cpp"
        __label__ = 175;continue $while_cond546$243; //@line 1654 "dictionary.cpp"
      }
  
      var $351=$output_addr; //@line 1656 "dictionary.cpp"
      var $incdec_ptr692=(($351+1)&4294967295); //@line 1656 "dictionary.cpp"
      $output_addr=$incdec_ptr692; //@line 1656 "dictionary.cpp"
      HEAP8[($351)]=0; //@line 1656 "dictionary.cpp"
      ; //@line 1658 "dictionary.cpp"
    }
  
    STACKTOP = __stackBase__;
    return; //@line 1659 "dictionary.cpp"
    return;
  }
  

  function __Z14AppendPhonemesP10TranslatorPciPKc($tr, $string, $size, $ph) {
    ;
    var __label__;
  
    var $tr_addr;
    var $string_addr;
    var $size_addr;
    var $ph_addr;
    var $p;
    var $c;
    var $unstress_mark;
    var $length;
    $tr_addr=$tr;
    $string_addr=$string;
    $size_addr=$size;
    $ph_addr=$ph;
    var $0=$ph_addr; //@line 1683 "dictionary.cpp"
    var $call=_strlen($0); //@line 1683 "dictionary.cpp"
    var $1=$string_addr; //@line 1683 "dictionary.cpp"
    var $call1=_strlen($1); //@line 1683 "dictionary.cpp"
    var $add=((($call1)+($call))&4294967295); //@line 1683 "dictionary.cpp"
    $length=$add; //@line 1683 "dictionary.cpp"
    var $2=$length; //@line 1684 "dictionary.cpp"
    var $3=$size_addr; //@line 1684 "dictionary.cpp"
    var $cmp=((($2))|0) >= ((($3))|0); //@line 1684 "dictionary.cpp"
    if ($cmp) { __label__ = 14;; } else { __label__ = 1;; } //@line 1684 "dictionary.cpp"
    $if_end34$$if_end$2: do { 
      if (__label__ == 1) {
  
        $unstress_mark=0; //@line 1690 "dictionary.cpp"
        var $4=$ph_addr; //@line 1691 "dictionary.cpp"
        $p=$4; //@line 1691 "dictionary.cpp"
        var $5=$p; //@line 1692 "dictionary.cpp"
        var $incdec_ptr1=(($5+1)&4294967295); //@line 1692 "dictionary.cpp"
        $p=$incdec_ptr1; //@line 1692 "dictionary.cpp"
        var $6=HEAPU8[($5)]; //@line 1692 "dictionary.cpp"
        $c=$6; //@line 1692 "dictionary.cpp"
        var $conv2=((($6))&255); //@line 1692 "dictionary.cpp"
        var $cmp23=((($conv2))|0)!=0; //@line 1692 "dictionary.cpp"
        if ($cmp23) { __label__ = 2;; } else { __label__ = 12;; } //@line 1692 "dictionary.cpp"
        $while_body$$while_end$4: do { 
          if (__label__ == 2) {
            $while_body$5: while(1) { 
  
              var $7=$c; //@line 1694 "dictionary.cpp"
              var $conv3=((($7))&255); //@line 1694 "dictionary.cpp"
              var $8=HEAP32[((_n_phoneme_tab)>>2)]; //@line 1694 "dictionary.cpp"
              var $cmp4=((($conv3))|0) >= ((($8))|0); //@line 1694 "dictionary.cpp"
              if ($cmp4) { __label__ = 3;; } else { __label__ = 4;; } //@line 1694 "dictionary.cpp"
              $while_cond_backedge$$if_end6$7: do { 
                if (__label__ == 4) {
  
                  var $11=$c; //@line 1696 "dictionary.cpp"
                  var $idxprom=((($11))&255); //@line 1696 "dictionary.cpp"
                  var $arrayidx=((_phoneme_tab+$idxprom*4)&4294967295); //@line 1696 "dictionary.cpp"
                  var $12=HEAP32[(($arrayidx)>>2)]; //@line 1696 "dictionary.cpp"
                  var $type=(($12+11)&4294967295); //@line 1696 "dictionary.cpp"
                  var $13=HEAPU8[($type)]; //@line 1696 "dictionary.cpp"
                  var $conv7=((($13))&255); //@line 1696 "dictionary.cpp"
                  var $cmp8=((($conv7))|0)==1; //@line 1696 "dictionary.cpp"
                  var $14=$c; //@line 1698 "dictionary.cpp"
                  var $idxprom10=((($14))&255); //@line 1698 "dictionary.cpp"
                  var $arrayidx11=((_phoneme_tab+$idxprom10*4)&4294967295); //@line 1698 "dictionary.cpp"
                  var $15=HEAP32[(($arrayidx11)>>2)]; //@line 1698 "dictionary.cpp"
                  if ($cmp8) { __label__ = 5;; } else { __label__ = 7;; } //@line 1696 "dictionary.cpp"
                  if (__label__ == 5) {
  
                    var $std_length=(($15+14)&4294967295); //@line 1698 "dictionary.cpp"
                    var $16=HEAPU8[($std_length)]; //@line 1698 "dictionary.cpp"
                    var $conv12=((($16))&255); //@line 1698 "dictionary.cpp"
                    var $cmp13=((($conv12))|0) < 4; //@line 1698 "dictionary.cpp"
                    if (!($cmp13)) { __label__ = 3;break $while_cond_backedge$$if_end6$7; } //@line 1698 "dictionary.cpp"
  
                    $unstress_mark=1; //@line 1699 "dictionary.cpp"
                    ; //@line 1699 "dictionary.cpp"
                  }
                  else if (__label__ == 7) {
  
                    var $type18=(($15+11)&4294967295); //@line 1703 "dictionary.cpp"
                    var $17=HEAPU8[($type18)]; //@line 1703 "dictionary.cpp"
                    var $conv19=((($17))&255); //@line 1703 "dictionary.cpp"
                    var $cmp20=((($conv19))|0)==2; //@line 1703 "dictionary.cpp"
                    if (!($cmp20)) { __label__ = 3;break $while_cond_backedge$$if_end6$7; } //@line 1703 "dictionary.cpp"
  
                    var $18=$c; //@line 1705 "dictionary.cpp"
                    var $idxprom22=((($18))&255); //@line 1705 "dictionary.cpp"
                    var $arrayidx23=((_phoneme_tab+$idxprom22*4)&4294967295); //@line 1705 "dictionary.cpp"
                    var $19=HEAP32[(($arrayidx23)>>2)]; //@line 1705 "dictionary.cpp"
                    var $phflags=(($19+4)&4294967295); //@line 1705 "dictionary.cpp"
                    var $20=HEAP32[(($phflags)>>2)]; //@line 1705 "dictionary.cpp"
                    var $and=($20) & 2; //@line 1705 "dictionary.cpp"
                    var $cmp24=((($and))|0)==0; //@line 1705 "dictionary.cpp"
                    if ($cmp24) { __label__ = 9;; } else { __label__ = 11;; } //@line 1705 "dictionary.cpp"
                    $land_lhs_true$$if_end27$14: do { 
                      if (__label__ == 9) {
  
                        var $21=$unstress_mark; //@line 1705 "dictionary.cpp"
                        var $cmp25=((($21))|0)==0; //@line 1705 "dictionary.cpp"
                        if (!($cmp25)) { __label__ = 11;break $land_lhs_true$$if_end27$14; } //@line 1705 "dictionary.cpp"
  
                        var $22=$tr_addr; //@line 1708 "dictionary.cpp"
                        var $word_stressed_count=(($22+8300)&4294967295); //@line 1708 "dictionary.cpp"
                        var $23=HEAP32[(($word_stressed_count)>>2)]; //@line 1708 "dictionary.cpp"
                        var $inc=((($23)+1)&4294967295); //@line 1708 "dictionary.cpp"
                        HEAP32[(($word_stressed_count)>>2)]=$inc; //@line 1708 "dictionary.cpp"
                        ; //@line 1709 "dictionary.cpp"
                      }
                    } while(0);
  
                    $unstress_mark=0; //@line 1710 "dictionary.cpp"
                    var $24=$tr_addr; //@line 1711 "dictionary.cpp"
                    var $word_vowel_count=(($24+8296)&4294967295); //@line 1711 "dictionary.cpp"
                    var $25=HEAP32[(($word_vowel_count)>>2)]; //@line 1711 "dictionary.cpp"
                    var $inc28=((($25)+1)&4294967295); //@line 1711 "dictionary.cpp"
                    HEAP32[(($word_vowel_count)>>2)]=$inc28; //@line 1711 "dictionary.cpp"
                    ; //@line 1712 "dictionary.cpp"
                  }
                }
              } while(0);
  
              var $9=$p; //@line 1692 "dictionary.cpp"
              var $incdec_ptr=(($9+1)&4294967295); //@line 1692 "dictionary.cpp"
              $p=$incdec_ptr; //@line 1692 "dictionary.cpp"
              var $10=HEAPU8[($9)]; //@line 1692 "dictionary.cpp"
              $c=$10; //@line 1692 "dictionary.cpp"
              var $conv=((($10))&255); //@line 1692 "dictionary.cpp"
              var $cmp2=((($conv))|0)!=0; //@line 1692 "dictionary.cpp"
              if ($cmp2) { __label__ = 2;continue $while_body$5; } else { __label__ = 12;break $while_body$$while_end$4; } //@line 1692 "dictionary.cpp"
            }
          }
        } while(0);
  
        var $26=$string_addr; //@line 1716 "dictionary.cpp"
        var $cmp31=((($26))|0)!=0; //@line 1716 "dictionary.cpp"
        if (!($cmp31)) { __label__ = 14;break $if_end34$$if_end$2; } //@line 1716 "dictionary.cpp"
  
        var $27=$string_addr; //@line 1717 "dictionary.cpp"
        var $28=$ph_addr; //@line 1717 "dictionary.cpp"
        var $call33=_strcat($27, $28); //@line 1717 "dictionary.cpp"
        ; //@line 1717 "dictionary.cpp"
      }
    } while(0);
  
    ;
    return; //@line 1718 "dictionary.cpp"
    return;
  }
  

  function __Z14TranslateRulesP10TranslatorPcS1_iS1_iPj($tr, $p_start, $phonemes, $ph_size, $end_phonemes, $word_flags, $dict_flags) {
    var __stackBase__  = STACKTOP; STACKTOP += 416; _memset(__stackBase__, 0, 416);
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $tr_addr;
    var $p_start_addr;
    var $phonemes_addr;
    var $ph_size_addr;
    var $end_phonemes_addr;
    var $word_flags_addr;
    var $dict_flags_addr;
    var $c;
    var $c2;
    var $c12;
    var $c123;
    var $wc=__stackBase__;
    var $wc_prev;
    var $wc_bytes;
    var $p2=__stackBase__+4;
    var $found;
    var $g;
    var $g1;
    var $n;
    var $letter=__stackBase__+8;
    var $any_alpha;
    var $ix;
    var $digit_count;
    var $p=__stackBase__+12;
    var $dict_flags0;
    var $match1=__stackBase__+16;
    var $match2=__stackBase__+32;
    var $ph_buf=__stackBase__+48;
    var $word_copy=__stackBase__+88;
    var $wordbuf=__stackBase__+248;
    var $ix14;
    var $string=__stackBase__+368;
    var $buf=__stackBase__+376;
    $tr_addr=$tr;
    $p_start_addr=$p_start;
    $phonemes_addr=$phonemes;
    $ph_size_addr=$ph_size;
    $end_phonemes_addr=$end_phonemes;
    $word_flags_addr=$word_flags;
    $dict_flags_addr=$dict_flags;
    HEAP32[(($wc)>>2)]=0; //@line 2393 "dictionary.cpp"
    $any_alpha=0; //@line 2402 "dictionary.cpp"
    $digit_count=0; //@line 2404 "dictionary.cpp"
    $dict_flags0=0; //@line 2406 "dictionary.cpp"
    var $0=$tr_addr; //@line 2413 "dictionary.cpp"
    var $data_dictrules=(($0+1048)&4294967295); //@line 2413 "dictionary.cpp"
    var $1=HEAP32[(($data_dictrules)>>2)]; //@line 2413 "dictionary.cpp"
    var $cmp=((($1))|0)==0; //@line 2413 "dictionary.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 2413 "dictionary.cpp"
    $if_then$$if_end$2: do { 
      if (__label__ == 1) {
  
        $retval=0; //@line 2414 "dictionary.cpp"
        ; //@line 2414 "dictionary.cpp"
      }
      else if (__label__ == 2) {
  
        var $2=$dict_flags_addr; //@line 2416 "dictionary.cpp"
        var $cmp1=((($2))|0)!=0; //@line 2416 "dictionary.cpp"
        if ($cmp1) { __label__ = 3;; } else { __label__ = 4;; } //@line 2416 "dictionary.cpp"
        if (__label__ == 3) {
  
          var $3=$dict_flags_addr; //@line 2417 "dictionary.cpp"
          var $arrayidx=(($3)&4294967295); //@line 2417 "dictionary.cpp"
          var $4=HEAP32[(($arrayidx)>>2)]; //@line 2417 "dictionary.cpp"
          $dict_flags0=$4; //@line 2417 "dictionary.cpp"
          ; //@line 2417 "dictionary.cpp"
        }
  
        $ix=0; //@line 2419 "dictionary.cpp"
        __lastLabel__ = 4; ; //@line 2419 "dictionary.cpp"
        $for_cond$8: while(1) { 
  
          var $5=__lastLabel__ == 5 ? $_pr : (0); //@line 2419 "dictionary.cpp"
          var $cmp4=((($5))|0) < 159; //@line 2419 "dictionary.cpp"
          if (!($cmp4)) { __label__ = 8;break $for_cond$8; } //@line 2419 "dictionary.cpp"
  
          var $6=$ix; //@line 2421 "dictionary.cpp"
          var $7=$p_start_addr; //@line 2421 "dictionary.cpp"
          var $arrayidx5=(($7+$6)&4294967295); //@line 2421 "dictionary.cpp"
          var $8=HEAP8[($arrayidx5)]; //@line 2421 "dictionary.cpp"
          $c=$8; //@line 2421 "dictionary.cpp"
          var $9=$c; //@line 2422 "dictionary.cpp"
          var $10=$ix; //@line 2422 "dictionary.cpp"
          var $inc=((($10)+1)&4294967295); //@line 2422 "dictionary.cpp"
          $ix=$inc; //@line 2422 "dictionary.cpp"
          var $arrayidx6=(($word_copy+$10)&4294967295); //@line 2422 "dictionary.cpp"
          HEAP8[($arrayidx6)]=$9; //@line 2422 "dictionary.cpp"
          var $11=$c; //@line 2423 "dictionary.cpp"
          var $conv=((($11))&255); //@line 2423 "dictionary.cpp"
          var $cmp7=((($conv))|0)==0; //@line 2423 "dictionary.cpp"
          if ($cmp7) { __label__ = 8;break $for_cond$8; } //@line 2423 "dictionary.cpp"
  
          var $_pr=$ix; //@line 2419 "dictionary.cpp"
          __lastLabel__ = 5; __label__ = 6;continue $for_cond$8;
        }
  
        var $12=$ix; //@line 2426 "dictionary.cpp"
        var $arrayidx10=(($word_copy+$12)&4294967295); //@line 2426 "dictionary.cpp"
        HEAP8[($arrayidx10)]=0; //@line 2426 "dictionary.cpp"
        var $13=HEAP32[((_option_phonemes)>>2)]; //@line 2429 "dictionary.cpp"
        var $cmp11=((($13))|0)==2; //@line 2429 "dictionary.cpp"
        if ($cmp11) { __label__ = 9;; } else { __label__ = 17;; } //@line 2429 "dictionary.cpp"
        $land_lhs_true$$if_end31$13: do { 
          if (__label__ == 9) {
  
            var $14=$word_flags_addr; //@line 2429 "dictionary.cpp"
            var $and=($14) & 268435456; //@line 2429 "dictionary.cpp"
            var $cmp12=((($and))|0)==0; //@line 2429 "dictionary.cpp"
            if (!($cmp12)) { __label__ = 17;break $land_lhs_true$$if_end31$13; } //@line 2429 "dictionary.cpp"
  
            $ix14=0; //@line 2434 "dictionary.cpp"
            ; //@line 2434 "dictionary.cpp"
            while(1) { 
  
              var $15=$ix14; //@line 2434 "dictionary.cpp"
              var $16=$p_start_addr; //@line 2434 "dictionary.cpp"
              var $arrayidx16=(($16+$15)&4294967295); //@line 2434 "dictionary.cpp"
              var $17=HEAPU8[($arrayidx16)]; //@line 2434 "dictionary.cpp"
              $c=$17; //@line 2434 "dictionary.cpp"
              var $conv17=((($17))&255); //@line 2434 "dictionary.cpp"
              var $cmp18=((($conv17))|0)!=32; //@line 2434 "dictionary.cpp"
              if (!($cmp18)) { __label__ = 14;break ; } //@line 2434 "dictionary.cpp"
  
              var $18=$c; //@line 2434 "dictionary.cpp"
              var $conv19=((($18))&255); //@line 2434 "dictionary.cpp"
              var $cmp20=((($conv19))|0)!=0; //@line 2434 "dictionary.cpp"
              if (!($cmp20)) { __label__ = 14;break ; }
  
              var $19=$c; //@line 2436 "dictionary.cpp"
              var $20=$ix14; //@line 2436 "dictionary.cpp"
              var $arrayidx22=(($wordbuf+$20)&4294967295); //@line 2436 "dictionary.cpp"
              HEAP8[($arrayidx22)]=$19; //@line 2436 "dictionary.cpp"
              var $21=$ix14; //@line 2434 "dictionary.cpp"
              var $inc23=((($21)+1)&4294967295); //@line 2434 "dictionary.cpp"
              $ix14=$inc23; //@line 2434 "dictionary.cpp"
              __label__ = 11;continue ; //@line 2434 "dictionary.cpp"
            }
  
            var $22=$ix14; //@line 2438 "dictionary.cpp"
            var $arrayidx25=(($wordbuf+$22)&4294967295); //@line 2438 "dictionary.cpp"
            HEAP8[($arrayidx25)]=0; //@line 2438 "dictionary.cpp"
            var $23=$word_flags_addr; //@line 2439 "dictionary.cpp"
            var $and26=($23) & -2147483648; //@line 2439 "dictionary.cpp"
            var $tobool=((($and26))|0)!=0; //@line 2439 "dictionary.cpp"
            var $24=HEAP32[((_f_trans)>>2)]; //@line 2440 "dictionary.cpp"
            var $arraydecay=(($wordbuf)&4294967295); //@line 2440 "dictionary.cpp"
            if ($tobool) { __label__ = 15;; } else { __label__ = 16;; } //@line 2439 "dictionary.cpp"
            if (__label__ == 15) {
  
              var $call=_fprintf($24, ((__str10126)&4294967295), allocate([$arraydecay,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 2440 "dictionary.cpp"
              ; //@line 2440 "dictionary.cpp"
            }
            else if (__label__ == 16) {
  
              var $call29=_fprintf($24, ((__str11127)&4294967295), allocate([$arraydecay,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 2442 "dictionary.cpp"
              ;
            }
          }
        } while(0);
  
        var $25=$p_start_addr; //@line 2445 "dictionary.cpp"
        HEAP32[(($p)>>2)]=$25; //@line 2445 "dictionary.cpp"
        var $26=$tr_addr; //@line 2446 "dictionary.cpp"
        var $word_vowel_count=(($26+8296)&4294967295); //@line 2446 "dictionary.cpp"
        HEAP32[(($word_vowel_count)>>2)]=0; //@line 2446 "dictionary.cpp"
        var $27=$tr_addr; //@line 2447 "dictionary.cpp"
        var $word_stressed_count=(($27+8300)&4294967295); //@line 2447 "dictionary.cpp"
        HEAP32[(($word_stressed_count)>>2)]=0; //@line 2447 "dictionary.cpp"
        var $28=$end_phonemes_addr; //@line 2449 "dictionary.cpp"
        var $cmp32=((($28))|0)!=0; //@line 2449 "dictionary.cpp"
        if ($cmp32) { __label__ = 18;; } else { __label__ = 19;; } //@line 2449 "dictionary.cpp"
        if (__label__ == 18) {
  
          var $29=$end_phonemes_addr; //@line 2450 "dictionary.cpp"
          var $arrayidx34=(($29)&4294967295); //@line 2450 "dictionary.cpp"
          HEAP8[($arrayidx34)]=0; //@line 2450 "dictionary.cpp"
          ; //@line 2450 "dictionary.cpp"
        }
  
        var $arrayidx57=(($string)&4294967295); //@line 2465 "dictionary.cpp"
        var $arrayidx58=(($string+1)&4294967295); //@line 2466 "dictionary.cpp"
        var $arraydecay60=(($string)&4294967295); //@line 2468 "dictionary.cpp"
        var $arraydecay61=(($buf)&4294967295); //@line 2468 "dictionary.cpp"
        var $arraydecay66=(($buf)&4294967295); //@line 2471 "dictionary.cpp"
        var $arraydecay69=(($buf)&4294967295); //@line 2474 "dictionary.cpp"
        var $phonemes282=(($match1+4)&4294967295); //@line 2644 "dictionary.cpp"
        var $phonemes285=(($match1+4)&4294967295); //@line 2645 "dictionary.cpp"
        var $points287=(($match1)&4294967295); //@line 2647 "dictionary.cpp"
        var $phonemes295=(($match1+4)&4294967295); //@line 2652 "dictionary.cpp"
        var $end_type306=(($match1+8)&4294967295); //@line 2659 "dictionary.cpp"
        var $end_type313=(($match1+8)&4294967295); //@line 2664 "dictionary.cpp"
        var $del_fwd=(($match1+12)&4294967295); //@line 2680 "dictionary.cpp"
        var $del_fwd342=(($match1+12)&4294967295); //@line 2681 "dictionary.cpp"
        var $phonemes344=(($match1+4)&4294967295); //@line 2682 "dictionary.cpp"
        var $points=(($match2)&4294967295); //@line 2508 "dictionary.cpp"
        var $points107=(($match2)&4294967295); //@line 2509 "dictionary.cpp"
        var $points112=(($match2)&4294967295); //@line 2514 "dictionary.cpp"
        var $points113=(($match1)&4294967295); //@line 2514 "dictionary.cpp"
        var $30=$match1; //@line 2517 "dictionary.cpp"
        var $31=$match2; //@line 2517 "dictionary.cpp"
        var $points241=(($match1)&4294967295); //@line 2608 "dictionary.cpp"
        var $arraydecay266=(($ph_buf)&4294967295); //@line 2628 "dictionary.cpp"
        var $arrayidx267=(($ph_buf)&4294967295); //@line 2629 "dictionary.cpp"
        var $arraydecay270=(($ph_buf)&4294967295); //@line 2631 "dictionary.cpp"
        var $phonemes271=(($match1+4)&4294967295); //@line 2631 "dictionary.cpp"
        var $points272=(($match1)&4294967295); //@line 2632 "dictionary.cpp"
        var $points135=(($match1)&4294967295); //@line 2534 "dictionary.cpp"
        var $arraydecay230=(($ph_buf)&4294967295); //@line 2600 "dictionary.cpp"
        var $arraydecay232=(($ph_buf)&4294967295); //@line 2601 "dictionary.cpp"
        var $phonemes233=(($match1+4)&4294967295); //@line 2601 "dictionary.cpp"
        var $points234=(($match1)&4294967295); //@line 2602 "dictionary.cpp"
        ; //@line 2452 "dictionary.cpp"
        $while_cond$28: while(1) { 
  
          var $32=HEAP32[(($p)>>2)]; //@line 2452 "dictionary.cpp"
          var $33=HEAPU8[($32)]; //@line 2452 "dictionary.cpp"
          $c=$33; //@line 2452 "dictionary.cpp"
          var $conv36=((($33))&255); //@line 2452 "dictionary.cpp"
          var $cmp37=((($conv36))|0)!=32; //@line 2452 "dictionary.cpp"
          if (!($cmp37)) { __label__ = 104;break $while_cond$28; } //@line 2452 "dictionary.cpp"
  
          var $34=$c; //@line 2452 "dictionary.cpp"
          var $conv39=((($34))&255); //@line 2452 "dictionary.cpp"
          var $cmp40=((($conv39))|0)!=0; //@line 2452 "dictionary.cpp"
          if (!($cmp40)) { __label__ = 104;break $while_cond$28; }
  
          var $35=HEAP32[(($wc)>>2)]; //@line 2454 "dictionary.cpp"
          $wc_prev=$35; //@line 2454 "dictionary.cpp"
          var $36=HEAP32[(($p)>>2)]; //@line 2455 "dictionary.cpp"
          var $call42=__Z7utf8_inPiPKc($wc, $36); //@line 2455 "dictionary.cpp"
          $wc_bytes=$call42; //@line 2455 "dictionary.cpp"
          var $37=HEAP32[(($wc)>>2)]; //@line 2456 "dictionary.cpp"
          var $call43=__Z7IsAlphaj($37); //@line 2456 "dictionary.cpp"
          var $tobool44=((($call43))|0)!=0; //@line 2456 "dictionary.cpp"
          if ($tobool44) { __label__ = 23;; } else { __label__ = 24;; } //@line 2456 "dictionary.cpp"
          if (__label__ == 23) {
  
            var $38=$any_alpha; //@line 2457 "dictionary.cpp"
            var $inc46=((($38)+1)&4294967295); //@line 2457 "dictionary.cpp"
            $any_alpha=$inc46; //@line 2457 "dictionary.cpp"
            ; //@line 2457 "dictionary.cpp"
          }
  
          var $39=$c; //@line 2459 "dictionary.cpp"
          var $idxprom=((($39))&255); //@line 2459 "dictionary.cpp"
          var $40=$tr_addr; //@line 2459 "dictionary.cpp"
          var $groups2_count=(($40+7756)&4294967295); //@line 2459 "dictionary.cpp"
          var $arrayidx48=(($groups2_count+$idxprom)&4294967295); //@line 2459 "dictionary.cpp"
          var $41=HEAPU8[($arrayidx48)]; //@line 2459 "dictionary.cpp"
          var $conv49=((($41))&255); //@line 2459 "dictionary.cpp"
          $n=$conv49; //@line 2459 "dictionary.cpp"
          var $42=HEAP32[(($wc)>>2)]; //@line 2460 "dictionary.cpp"
          var $call50=__Z7IsDigitj($42); //@line 2460 "dictionary.cpp"
          var $tobool51=((($call50))|0)!=0; //@line 2460 "dictionary.cpp"
          if ($tobool51) { __label__ = 25;; } else { __label__ = 30;; } //@line 2460 "dictionary.cpp"
          $land_lhs_true52$$if_else70$35: do { 
            if (__label__ == 25) {
  
              var $43=$tr_addr; //@line 2460 "dictionary.cpp"
              var $langopts=(($43)&4294967295); //@line 2460 "dictionary.cpp"
              var $tone_numbers=(($langopts+250)&4294967295); //@line 2460 "dictionary.cpp"
              var $44=HEAP8[($tone_numbers)]; //@line 2460 "dictionary.cpp"
              var $conv53=(tempInt=(($44)),(tempInt>=128?tempInt-256:tempInt)); //@line 2460 "dictionary.cpp"
              var $cmp54=((($conv53))|0)==0; //@line 2460 "dictionary.cpp"
              if ($cmp54) { __label__ = 27;; } else { __label__ = 26;; } //@line 2460 "dictionary.cpp"
              if (__label__ == 26) {
  
                var $45=$any_alpha; //@line 2460 "dictionary.cpp"
                var $tobool55=((($45))|0)!=0; //@line 2460 "dictionary.cpp"
                if ($tobool55) { __label__ = 30;break $land_lhs_true52$$if_else70$35; } //@line 2460 "dictionary.cpp"
              }
  
              HEAP8[($arrayidx57)]=95; //@line 2465 "dictionary.cpp"
              var $46=HEAP32[(($p)>>2)]; //@line 2466 "dictionary.cpp"
              var $47=$wc_bytes; //@line 2466 "dictionary.cpp"
              var $src$, $dest$, $stop$, $stop4$, $fast$;
              $src$ = $46;
              $dest$ = $arrayidx58;
              $stop$ = $src$ + $47;
              if (($dest$%4) == ($src$%4) && $47 > 8) {
                while ($src$%4 !== 0 && $src$ < $stop$) {
                  ; HEAP8[$dest$++] = HEAP8[$src$++];
                }
                $src$ >>= 2;
                $dest$ >>= 2;
                $stop4$ = $stop$ >> 2;
                while ($src$ < $stop4$) {
              ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
                }
                $src$ <<= 2;
                $dest$ <<= 2;
              }while ($src$ < $stop$) {
                ; HEAP8[$dest$++] = HEAP8[$src$++];
              }; //@line 2466 "dictionary.cpp"
              var $48=$wc_bytes; //@line 2467 "dictionary.cpp"
              var $add=((($48)+1)&4294967295); //@line 2467 "dictionary.cpp"
              var $arrayidx59=(($string+$add)&4294967295); //@line 2467 "dictionary.cpp"
              HEAP8[($arrayidx59)]=0; //@line 2467 "dictionary.cpp"
              var $49=$tr_addr; //@line 2468 "dictionary.cpp"
              var $call62=__Z6LookupP10TranslatorPKcPc($49, $arraydecay60, $arraydecay61); //@line 2468 "dictionary.cpp"
              var $50=$digit_count; //@line 2469 "dictionary.cpp"
              var $inc63=((($50)+1)&4294967295); //@line 2469 "dictionary.cpp"
              $digit_count=$inc63; //@line 2469 "dictionary.cpp"
              var $cmp64=((($inc63))>>>0) >= 2; //@line 2469 "dictionary.cpp"
              if ($cmp64) { __label__ = 28;; } else { __label__ = 29;; } //@line 2469 "dictionary.cpp"
              if (__label__ == 28) {
  
                var $strlen=_strlen($arraydecay66); //@line 2471 "dictionary.cpp"
                var $endptr=(($arraydecay66+$strlen)&4294967295); //@line 2471 "dictionary.cpp"
                var $src$, $dest$, $stop$, $stop4$, $fast$;
                $src$ = ((__ZZ14TranslateRulesP10TranslatorPcS1_iS1_iPjE9str_pause)&4294967295);
                $dest$ = $endptr;
                $stop$ = $src$ + 2;
                if (($dest$%4) == ($src$%4) && 2 > 8) {
                  while ($src$%4 !== 0 && $src$ < $stop$) {
                    ; HEAP8[$dest$++] = HEAP8[$src$++];
                  }
                  $src$ >>= 2;
                  $dest$ >>= 2;
                  $stop4$ = $stop$ >> 2;
                  while ($src$ < $stop4$) {
                ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
                  }
                  $src$ <<= 2;
                  $dest$ <<= 2;
                }while ($src$ < $stop$) {
                  ; HEAP8[$dest$++] = HEAP8[$src$++];
                }; //@line 2471 "dictionary.cpp"
                $digit_count=0; //@line 2472 "dictionary.cpp"
                ; //@line 2473 "dictionary.cpp"
              }
  
              var $51=$tr_addr; //@line 2474 "dictionary.cpp"
              var $52=$phonemes_addr; //@line 2474 "dictionary.cpp"
              var $53=$ph_size_addr; //@line 2474 "dictionary.cpp"
              __Z14AppendPhonemesP10TranslatorPciPKc($51, $52, $53, $arraydecay69); //@line 2474 "dictionary.cpp"
              var $54=$wc_bytes; //@line 2475 "dictionary.cpp"
              var $55=HEAP32[(($p)>>2)]; //@line 2475 "dictionary.cpp"
              var $add_ptr=(($55+$54)&4294967295); //@line 2475 "dictionary.cpp"
              HEAP32[(($p)>>2)]=$add_ptr; //@line 2475 "dictionary.cpp"
              __label__ = 20;continue $while_cond$28; //@line 2476 "dictionary.cpp"
            }
          } while(0);
  
          $digit_count=0; //@line 2480 "dictionary.cpp"
          $found=0; //@line 2481 "dictionary.cpp"
          var $56=HEAP32[(($wc)>>2)]; //@line 2483 "dictionary.cpp"
          var $57=$tr_addr; //@line 2483 "dictionary.cpp"
          var $letter_bits_offset=(($57+964)&4294967295); //@line 2483 "dictionary.cpp"
          var $58=HEAP32[(($letter_bits_offset)>>2)]; //@line 2483 "dictionary.cpp"
          var $sub=((($56)-($58))&4294967295); //@line 2483 "dictionary.cpp"
          $ix=$sub; //@line 2483 "dictionary.cpp"
          var $cmp71=((($sub))|0) >= 0; //@line 2483 "dictionary.cpp"
          if ($cmp71) { __label__ = 31;; } else { __label__ = 34;; } //@line 2483 "dictionary.cpp"
          $land_lhs_true72$$if_end81$44: do { 
            if (__label__ == 31) {
  
              var $59=$ix; //@line 2483 "dictionary.cpp"
              var $cmp73=((($59))|0) < 128; //@line 2483 "dictionary.cpp"
              if (!($cmp73)) { __label__ = 34;break $land_lhs_true72$$if_end81$44; } //@line 2483 "dictionary.cpp"
  
              var $60=$ix; //@line 2485 "dictionary.cpp"
              var $61=$tr_addr; //@line 2485 "dictionary.cpp"
              var $groups3=(($61+6280)&4294967295); //@line 2485 "dictionary.cpp"
              var $arrayidx75=(($groups3+$60*4)&4294967295); //@line 2485 "dictionary.cpp"
              var $62=HEAP32[(($arrayidx75)>>2)]; //@line 2485 "dictionary.cpp"
              var $cmp76=((($62))|0)!=0; //@line 2485 "dictionary.cpp"
              if (!($cmp76)) { __label__ = 34;break $land_lhs_true72$$if_end81$44; } //@line 2485 "dictionary.cpp"
  
              var $63=$tr_addr; //@line 2487 "dictionary.cpp"
              var $64=$p_start_addr; //@line 2487 "dictionary.cpp"
              var $65=$wc_bytes; //@line 2487 "dictionary.cpp"
              var $66=$ix; //@line 2487 "dictionary.cpp"
              var $67=$tr_addr; //@line 2487 "dictionary.cpp"
              var $groups378=(($67+6280)&4294967295); //@line 2487 "dictionary.cpp"
              var $arrayidx79=(($groups378+$66*4)&4294967295); //@line 2487 "dictionary.cpp"
              var $68=HEAP32[(($arrayidx79)>>2)]; //@line 2487 "dictionary.cpp"
              var $69=$word_flags_addr; //@line 2487 "dictionary.cpp"
              var $70=$dict_flags0; //@line 2487 "dictionary.cpp"
              __ZL9MatchRuleP10TranslatorPPcS1_iS1_P11MatchRecordii($63, $p, $64, $65, $68, $match1, $69, $70); //@line 2487 "dictionary.cpp"
              $found=1; //@line 2488 "dictionary.cpp"
              __label__ = 85;break $land_lhs_true72$$if_end81$44; //@line 2524 "dictionary.cpp"
            }
          } while(0);
          $if_end281$$if_end81$48: do { 
            if (__label__ == 34) {
  
              var $_pr3=$found; //@line 2492 "dictionary.cpp"
              var $tobool82=((($_pr3))|0)!=0; //@line 2492 "dictionary.cpp"
              if ($tobool82) { __label__ = 85;break $if_end281$$if_end81$48; } //@line 2492 "dictionary.cpp"
  
              var $71=$n; //@line 2492 "dictionary.cpp"
              var $cmp84=((($71))|0) > 0; //@line 2492 "dictionary.cpp"
              if ($cmp84) { __label__ = 36;; } else { __label__ = 43;; } //@line 2492 "dictionary.cpp"
              $if_then85$$if_end121$51: do { 
                if (__label__ == 36) {
  
                  var $72=HEAP32[(($p)>>2)]; //@line 2495 "dictionary.cpp"
                  var $arrayidx86=(($72+1)&4294967295); //@line 2495 "dictionary.cpp"
                  var $73=HEAP8[($arrayidx86)]; //@line 2495 "dictionary.cpp"
                  $c2=$73; //@line 2495 "dictionary.cpp"
                  var $74=$c; //@line 2496 "dictionary.cpp"
                  var $conv87=((($74))&255); //@line 2496 "dictionary.cpp"
                  var $75=$c2; //@line 2496 "dictionary.cpp"
                  var $conv88=((($75))&255); //@line 2496 "dictionary.cpp"
                  var $shl=((($conv88)*256)&4294967295); //@line 2496 "dictionary.cpp"
                  var $add89=((($shl)+($conv87))&4294967295); //@line 2496 "dictionary.cpp"
                  $c12=$add89; //@line 2496 "dictionary.cpp"
                  var $76=$c12; //@line 2497 "dictionary.cpp"
                  var $77=HEAP32[(($p)>>2)]; //@line 2497 "dictionary.cpp"
                  var $arrayidx90=(($77+2)&4294967295); //@line 2497 "dictionary.cpp"
                  var $78=HEAP8[($arrayidx90)]; //@line 2497 "dictionary.cpp"
                  var $conv91=(tempInt=(($78)),(tempInt>=128?tempInt-256:tempInt)); //@line 2497 "dictionary.cpp"
                  var $shl92=((($conv91)*65536)&4294967295); //@line 2497 "dictionary.cpp"
                  var $add93=((($shl92)+($76))&4294967295); //@line 2497 "dictionary.cpp"
                  $c123=$add93; //@line 2497 "dictionary.cpp"
                  var $79=$c; //@line 2499 "dictionary.cpp"
                  var $idxprom94=((($79))&255); //@line 2499 "dictionary.cpp"
                  var $80=$tr_addr; //@line 2499 "dictionary.cpp"
                  var $groups2_start=(($80+8012)&4294967295); //@line 2499 "dictionary.cpp"
                  var $arrayidx95=(($groups2_start+$idxprom94)&4294967295); //@line 2499 "dictionary.cpp"
                  var $81=HEAPU8[($arrayidx95)]; //@line 2499 "dictionary.cpp"
                  var $conv96=((($81))&255); //@line 2499 "dictionary.cpp"
                  $g1=$conv96; //@line 2499 "dictionary.cpp"
                  var $82=$g1; //@line 2500 "dictionary.cpp"
                  $g=$82; //@line 2500 "dictionary.cpp"
                  var $83=$g; //@line 2500 "dictionary.cpp"
                  var $84=$g1; //@line 2500 "dictionary.cpp"
                  var $85=$n; //@line 2500 "dictionary.cpp"
                  var $add989=((($85)+($84))&4294967295); //@line 2500 "dictionary.cpp"
                  var $cmp9910=((($83))|0) < ((($add989))|0); //@line 2500 "dictionary.cpp"
                  if (!($cmp9910)) { __label__ = 43;break $if_then85$$if_end121$51; } //@line 2500 "dictionary.cpp"
                  $for_body100$53: while(1) { 
  
                    var $86=$g; //@line 2502 "dictionary.cpp"
                    var $87=$tr_addr; //@line 2502 "dictionary.cpp"
                    var $groups2_name=(($87+7272)&4294967295); //@line 2502 "dictionary.cpp"
                    var $arrayidx101=(($groups2_name+$86*4)&4294967295); //@line 2502 "dictionary.cpp"
                    var $88=HEAP32[(($arrayidx101)>>2)]; //@line 2502 "dictionary.cpp"
                    var $89=$c12; //@line 2502 "dictionary.cpp"
                    var $cmp102=((($88))|0)==((($89))|0); //@line 2502 "dictionary.cpp"
                    if ($cmp102) { __label__ = 38;; } else { __label__ = 42;; } //@line 2502 "dictionary.cpp"
                    $if_then103$$for_inc118$55: do { 
                      if (__label__ == 38) {
  
                        $found=1; //@line 2504 "dictionary.cpp"
                        var $90=HEAP32[(($p)>>2)]; //@line 2506 "dictionary.cpp"
                        HEAP32[(($p2)>>2)]=$90; //@line 2506 "dictionary.cpp"
                        var $91=$tr_addr; //@line 2507 "dictionary.cpp"
                        var $92=$p_start_addr; //@line 2507 "dictionary.cpp"
                        var $93=$g; //@line 2507 "dictionary.cpp"
                        var $94=$tr_addr; //@line 2507 "dictionary.cpp"
                        var $groups2=(($94+6792)&4294967295); //@line 2507 "dictionary.cpp"
                        var $arrayidx104=(($groups2+$93*4)&4294967295); //@line 2507 "dictionary.cpp"
                        var $95=HEAP32[(($arrayidx104)>>2)]; //@line 2507 "dictionary.cpp"
                        var $96=$word_flags_addr; //@line 2507 "dictionary.cpp"
                        var $97=$dict_flags0; //@line 2507 "dictionary.cpp"
                        __ZL9MatchRuleP10TranslatorPPcS1_iS1_P11MatchRecordii($91, $p2, $92, 2, $95, $match2, $96, $97); //@line 2507 "dictionary.cpp"
                        var $98=HEAP32[(($points)>>2)]; //@line 2508 "dictionary.cpp"
                        var $cmp105=((($98))|0) > 0; //@line 2508 "dictionary.cpp"
                        if ($cmp105) { __label__ = 39;; } else { __label__ = 40;; } //@line 2508 "dictionary.cpp"
                        if (__label__ == 39) {
  
                          var $99=HEAP32[(($points107)>>2)]; //@line 2509 "dictionary.cpp"
                          var $add108=((($99)+35)&4294967295); //@line 2509 "dictionary.cpp"
                          HEAP32[(($points107)>>2)]=$add108; //@line 2509 "dictionary.cpp"
                          ; //@line 2509 "dictionary.cpp"
                        }
  
                        var $100=$tr_addr; //@line 2512 "dictionary.cpp"
                        var $101=$p_start_addr; //@line 2512 "dictionary.cpp"
                        var $102=$c; //@line 2512 "dictionary.cpp"
                        var $idxprom110=((($102))&255); //@line 2512 "dictionary.cpp"
                        var $103=$tr_addr; //@line 2512 "dictionary.cpp"
                        var $groups1=(($103+5256)&4294967295); //@line 2512 "dictionary.cpp"
                        var $arrayidx111=(($groups1+$idxprom110*4)&4294967295); //@line 2512 "dictionary.cpp"
                        var $104=HEAP32[(($arrayidx111)>>2)]; //@line 2512 "dictionary.cpp"
                        var $105=$word_flags_addr; //@line 2512 "dictionary.cpp"
                        var $106=$dict_flags0; //@line 2512 "dictionary.cpp"
                        __ZL9MatchRuleP10TranslatorPPcS1_iS1_P11MatchRecordii($100, $p, $101, 1, $104, $match1, $105, $106); //@line 2512 "dictionary.cpp"
                        var $107=HEAP32[(($points112)>>2)]; //@line 2514 "dictionary.cpp"
                        var $108=HEAP32[(($points113)>>2)]; //@line 2514 "dictionary.cpp"
                        var $cmp114=((($107))|0) >= ((($108))|0); //@line 2514 "dictionary.cpp"
                        if (!($cmp114)) { __label__ = 42;break $if_then103$$for_inc118$55; } //@line 2514 "dictionary.cpp"
  
                        var $src$, $dest$, $stop$, $stop4$, $fast$;
                        $src$ = $31;
                        $dest$ = $30;
                        $stop$ = $src$ + 16;
                        if (($dest$%4) == ($src$%4) && 16 > 8) {
                          while ($src$%4 !== 0 && $src$ < $stop$) {
                            ; HEAP8[$dest$++] = HEAP8[$src$++];
                          }
                          $src$ >>= 2;
                          $dest$ >>= 2;
                          $stop4$ = $stop$ >> 2;
                          while ($src$ < $stop4$) {
                        ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
                          }
                          $src$ <<= 2;
                          $dest$ <<= 2;
                        }while ($src$ < $stop$) {
                          ; HEAP8[$dest$++] = HEAP8[$src$++];
                        }; //@line 2517 "dictionary.cpp"
                        var $109=HEAP32[(($p2)>>2)]; //@line 2518 "dictionary.cpp"
                        HEAP32[(($p)>>2)]=$109; //@line 2518 "dictionary.cpp"
                        ; //@line 2519 "dictionary.cpp"
                      }
                    } while(0);
  
                    var $110=$g; //@line 2500 "dictionary.cpp"
                    var $inc119=((($110)+1)&4294967295); //@line 2500 "dictionary.cpp"
                    $g=$inc119; //@line 2500 "dictionary.cpp"
                    var $111=$g; //@line 2500 "dictionary.cpp"
                    var $112=$g1; //@line 2500 "dictionary.cpp"
                    var $113=$n; //@line 2500 "dictionary.cpp"
                    var $add98=((($113)+($112))&4294967295); //@line 2500 "dictionary.cpp"
                    var $cmp99=((($111))|0) < ((($add98))|0); //@line 2500 "dictionary.cpp"
                    if ($cmp99) { __label__ = 37;continue $for_body100$53; } else { __label__ = 43;break $if_then85$$if_end121$51; } //@line 2500 "dictionary.cpp"
                  }
                }
              } while(0);
  
              var $_pr5_pr=$found; //@line 2524 "dictionary.cpp"
              var $tobool122=((($_pr5_pr))|0)!=0; //@line 2524 "dictionary.cpp"
              if ($tobool122) { __label__ = 85;break $if_end281$$if_end81$48; } //@line 2524 "dictionary.cpp"
  
              var $114=$c; //@line 2527 "dictionary.cpp"
              var $idxprom124=((($114))&255); //@line 2527 "dictionary.cpp"
              var $115=$tr_addr; //@line 2527 "dictionary.cpp"
              var $groups1125=(($115+5256)&4294967295); //@line 2527 "dictionary.cpp"
              var $arrayidx126=(($groups1125+$idxprom124*4)&4294967295); //@line 2527 "dictionary.cpp"
              var $116=HEAP32[(($arrayidx126)>>2)]; //@line 2527 "dictionary.cpp"
              var $cmp127=((($116))|0)!=0; //@line 2527 "dictionary.cpp"
              var $117=$tr_addr; //@line 2528 "dictionary.cpp"
              var $118=$p_start_addr; //@line 2528 "dictionary.cpp"
              if ($cmp127) { __label__ = 45;; } else { __label__ = 46;; } //@line 2527 "dictionary.cpp"
              $if_then128$$if_else132$64: do { 
                if (__label__ == 45) {
  
                  var $119=$c; //@line 2528 "dictionary.cpp"
                  var $idxprom129=((($119))&255); //@line 2528 "dictionary.cpp"
                  var $120=$tr_addr; //@line 2528 "dictionary.cpp"
                  var $groups1130=(($120+5256)&4294967295); //@line 2528 "dictionary.cpp"
                  var $arrayidx131=(($groups1130+$idxprom129*4)&4294967295); //@line 2528 "dictionary.cpp"
                  var $121=HEAP32[(($arrayidx131)>>2)]; //@line 2528 "dictionary.cpp"
                  var $122=$word_flags_addr; //@line 2528 "dictionary.cpp"
                  var $123=$dict_flags0; //@line 2528 "dictionary.cpp"
                  __ZL9MatchRuleP10TranslatorPPcS1_iS1_P11MatchRecordii($117, $p, $118, 1, $121, $match1, $122, $123); //@line 2528 "dictionary.cpp"
                  __label__ = 74;break $if_then128$$if_else132$64; //@line 2528 "dictionary.cpp"
                }
                else if (__label__ == 46) {
  
                  var $124=$tr_addr; //@line 2532 "dictionary.cpp"
                  var $groups1133=(($124+5256)&4294967295); //@line 2532 "dictionary.cpp"
                  var $arrayidx134=(($groups1133)&4294967295); //@line 2532 "dictionary.cpp"
                  var $125=HEAP32[(($arrayidx134)>>2)]; //@line 2532 "dictionary.cpp"
                  var $126=$word_flags_addr; //@line 2532 "dictionary.cpp"
                  var $127=$dict_flags0; //@line 2532 "dictionary.cpp"
                  __ZL9MatchRuleP10TranslatorPPcS1_iS1_P11MatchRecordii($117, $p, $118, 0, $125, $match1, $126, $127); //@line 2532 "dictionary.cpp"
                  var $128=HEAP32[(($points135)>>2)]; //@line 2534 "dictionary.cpp"
                  var $cmp136=((($128))|0)==0; //@line 2534 "dictionary.cpp"
                  if (!($cmp136)) { __label__ = 84;break $if_then128$$if_else132$64; } //@line 2534 "dictionary.cpp"
  
                  var $129=HEAP32[((_option_sayas)>>2)]; //@line 2534 "dictionary.cpp"
                  var $and138=($129) & 16; //@line 2534 "dictionary.cpp"
                  var $cmp139=((($and138))|0)==0; //@line 2534 "dictionary.cpp"
                  if (!($cmp139)) { __label__ = 74;break $if_then128$$if_else132$64; } //@line 2534 "dictionary.cpp"
  
                  var $130=HEAP32[(($p)>>2)]; //@line 2536 "dictionary.cpp"
                  var $add_ptr141=(($130+-1)&4294967295); //@line 2536 "dictionary.cpp"
                  var $call142=__Z7utf8_inPiPKc($letter, $add_ptr141); //@line 2536 "dictionary.cpp"
                  var $sub143=((($call142)-1)&4294967295); //@line 2536 "dictionary.cpp"
                  $n=$sub143; //@line 2536 "dictionary.cpp"
                  var $131=$tr_addr; //@line 2538 "dictionary.cpp"
                  var $letter_bits_offset144=(($131+964)&4294967295); //@line 2538 "dictionary.cpp"
                  var $132=HEAP32[(($letter_bits_offset144)>>2)]; //@line 2538 "dictionary.cpp"
                  var $cmp145=((($132))|0) > 0; //@line 2538 "dictionary.cpp"
                  if ($cmp145) { __label__ = 49;; } else { __label__ = 52;; } //@line 2538 "dictionary.cpp"
                  $if_then146$$if_end155thread_pre_split$69: do { 
                    if (__label__ == 49) {
  
                      var $133=HEAP32[(($letter)>>2)]; //@line 2541 "dictionary.cpp"
                      var $cmp147=((($133))|0) <= 577; //@line 2541 "dictionary.cpp"
                      if ($cmp147) { __lastLabel__ = 49; ; } else { __lastLabel__ = 49; __label__ = 53;break $if_then146$$if_end155thread_pre_split$69; } //@line 2541 "dictionary.cpp"
  
                      var $134=HEAP32[(($letter)>>2)]; //@line 2541 "dictionary.cpp"
                      var $call149=_iswalpha($134); //@line 2541 "dictionary.cpp"
                      var $tobool150=((($call149))|0)!=0; //@line 2541 "dictionary.cpp"
                      if ($tobool150) { __label__ = 51;break $while_cond$28; } else { __label__ = 52;break $if_then146$$if_end155thread_pre_split$69; } //@line 2541 "dictionary.cpp"
                    }
                  } while(0);
                  if (__label__ == 52) {
  
                    var $_pr7=HEAP32[(($letter)>>2)]; //@line 2558 "dictionary.cpp"
                    __lastLabel__ = 52; ;
                  }
  
                  var $138=__lastLabel__ == 52 ? $_pr7 : ($133); //@line 2558 "dictionary.cpp"
                  var $cmp156=((($138))|0)==57384; //@line 2558 "dictionary.cpp"
                  if ($cmp156) { __label__ = 54;; } else { __label__ = 56;; } //@line 2558 "dictionary.cpp"
                  $if_then157$$if_end166$75: do { 
                    if (__label__ == 54) {
  
                      var $139=HEAP32[((_pre_pause)>>2)]; //@line 2560 "dictionary.cpp"
                      var $140=$tr_addr; //@line 2560 "dictionary.cpp"
                      var $langopts158=(($140)&4294967295); //@line 2560 "dictionary.cpp"
                      var $param2=(($langopts158+100)&4294967295); //@line 2560 "dictionary.cpp"
                      var $arrayidx159=(($param2+64)&4294967295); //@line 2560 "dictionary.cpp"
                      var $141=HEAP32[(($arrayidx159)>>2)]; //@line 2560 "dictionary.cpp"
                      var $cmp160=((($139))|0) < ((($141))|0); //@line 2560 "dictionary.cpp"
                      if (!($cmp160)) { __label__ = 56;break $if_then157$$if_end166$75; } //@line 2560 "dictionary.cpp"
  
                      var $142=$tr_addr; //@line 2561 "dictionary.cpp"
                      var $langopts162=(($142)&4294967295); //@line 2561 "dictionary.cpp"
                      var $param2163=(($langopts162+100)&4294967295); //@line 2561 "dictionary.cpp"
                      var $arrayidx164=(($param2163+64)&4294967295); //@line 2561 "dictionary.cpp"
                      var $143=HEAP32[(($arrayidx164)>>2)]; //@line 2561 "dictionary.cpp"
                      HEAP32[((_pre_pause)>>2)]=$143; //@line 2561 "dictionary.cpp"
                      ; //@line 2561 "dictionary.cpp"
                    }
                  } while(0);
  
                  var $144=HEAP32[(($letter)>>2)]; //@line 2563 "dictionary.cpp"
                  var $call167=__Z9IsBracketi($144); //@line 2563 "dictionary.cpp"
                  var $tobool168=((($call167))|0)!=0; //@line 2563 "dictionary.cpp"
                  if ($tobool168) { __label__ = 57;; } else { __label__ = 59;; } //@line 2563 "dictionary.cpp"
                  $if_then169$$if_end178$79: do { 
                    if (__label__ == 57) {
  
                      var $145=HEAP32[((_pre_pause)>>2)]; //@line 2565 "dictionary.cpp"
                      var $146=$tr_addr; //@line 2565 "dictionary.cpp"
                      var $langopts170=(($146)&4294967295); //@line 2565 "dictionary.cpp"
                      var $param=(($langopts170+24)&4294967295); //@line 2565 "dictionary.cpp"
                      var $arrayidx171=(($param+64)&4294967295); //@line 2565 "dictionary.cpp"
                      var $147=HEAP32[(($arrayidx171)>>2)]; //@line 2565 "dictionary.cpp"
                      var $cmp172=((($145))|0) < ((($147))|0); //@line 2565 "dictionary.cpp"
                      if (!($cmp172)) { __label__ = 59;break $if_then169$$if_end178$79; } //@line 2565 "dictionary.cpp"
  
                      var $148=$tr_addr; //@line 2566 "dictionary.cpp"
                      var $langopts174=(($148)&4294967295); //@line 2566 "dictionary.cpp"
                      var $param175=(($langopts174+24)&4294967295); //@line 2566 "dictionary.cpp"
                      var $arrayidx176=(($param175+64)&4294967295); //@line 2566 "dictionary.cpp"
                      var $149=HEAP32[(($arrayidx176)>>2)]; //@line 2566 "dictionary.cpp"
                      HEAP32[((_pre_pause)>>2)]=$149; //@line 2566 "dictionary.cpp"
                      ; //@line 2566 "dictionary.cpp"
                    }
                  } while(0);
  
                  var $150=HEAP32[(($letter)>>2)]; //@line 2570 "dictionary.cpp"
                  var $cmp179=((($150))|0) >= 192; //@line 2570 "dictionary.cpp"
                  var $151=HEAP32[(($letter)>>2)]; //@line 2570 "dictionary.cpp"
                  var $cmp181=((($151))|0) < 606; //@line 2570 "dictionary.cpp"
                  var $or_cond=($cmp179) & ($cmp181); //@line 2570 "dictionary.cpp"
                  if ($or_cond) { __label__ = 60;; } else { __label__ = 71;; } //@line 2570 "dictionary.cpp"
                  $land_lhs_true182$$if_else223$83: do { 
                    if (__label__ == 60) {
  
                      var $152=HEAP32[(($letter)>>2)]; //@line 2570 "dictionary.cpp"
                      var $sub183=((($152)-192)&4294967295); //@line 2570 "dictionary.cpp"
                      var $arrayidx184=((__ZL13remove_accent+$sub183)&4294967295); //@line 2570 "dictionary.cpp"
                      var $153=HEAPU8[($arrayidx184)]; //@line 2570 "dictionary.cpp"
                      var $conv185=((($153))&255); //@line 2570 "dictionary.cpp"
                      $ix=$conv185; //@line 2570 "dictionary.cpp"
                      var $cmp186=((($conv185))|0)!=0; //@line 2570 "dictionary.cpp"
                      if (!($cmp186)) { __label__ = 71;break $land_lhs_true182$$if_else223$83; } //@line 2570 "dictionary.cpp"
  
                      var $154=HEAP32[(($p)>>2)]; //@line 2573 "dictionary.cpp"
                      var $arrayidx188=(($154+-2)&4294967295); //@line 2573 "dictionary.cpp"
                      var $155=HEAP8[($arrayidx188)]; //@line 2573 "dictionary.cpp"
                      var $conv189=(tempInt=(($155)),(tempInt>=128?tempInt-256:tempInt)); //@line 2573 "dictionary.cpp"
                      var $cmp190=((($conv189))|0)!=32; //@line 2573 "dictionary.cpp"
                      if ($cmp190) { __label__ = 63;; } else { __label__ = 62;; } //@line 2573 "dictionary.cpp"
                      if (__label__ == 62) {
  
                        var $156=$n; //@line 2573 "dictionary.cpp"
                        var $157=HEAP32[(($p)>>2)]; //@line 2573 "dictionary.cpp"
                        var $arrayidx192=(($157+$156)&4294967295); //@line 2573 "dictionary.cpp"
                        var $158=HEAP8[($arrayidx192)]; //@line 2573 "dictionary.cpp"
                        var $conv193=(tempInt=(($158)),(tempInt>=128?tempInt-256:tempInt)); //@line 2573 "dictionary.cpp"
                        var $cmp194=((($conv193))|0)!=32; //@line 2573 "dictionary.cpp"
                        if (!($cmp194)) { __label__ = 74;break $if_then128$$if_else132$64; } //@line 2573 "dictionary.cpp"
                      }
  
                      var $159=HEAP32[(($p)>>2)]; //@line 2576 "dictionary.cpp"
                      var $add_ptr196=(($159+-1)&4294967295); //@line 2576 "dictionary.cpp"
                      HEAP32[(($p2)>>2)]=$add_ptr196; //@line 2576 "dictionary.cpp"
                      var $160=$ix; //@line 2577 "dictionary.cpp"
                      var $conv197=((($160)) & 255); //@line 2577 "dictionary.cpp"
                      var $161=HEAP32[(($p)>>2)]; //@line 2577 "dictionary.cpp"
                      var $arrayidx198=(($161+-1)&4294967295); //@line 2577 "dictionary.cpp"
                      HEAP8[($arrayidx198)]=$conv197; //@line 2577 "dictionary.cpp"
                      var $162=$n; //@line 2578 "dictionary.cpp"
                      var $163=HEAP32[(($p)>>2)]; //@line 2578 "dictionary.cpp"
                      var $arrayidx20011=(($163+$162)&4294967295); //@line 2578 "dictionary.cpp"
                      var $164=HEAP8[($arrayidx20011)]; //@line 2578 "dictionary.cpp"
                      var $165=HEAP32[(($p)>>2)]; //@line 2578 "dictionary.cpp"
                      var $arrayidx20112=(($165)&4294967295); //@line 2578 "dictionary.cpp"
                      HEAP8[($arrayidx20112)]=$164; //@line 2578 "dictionary.cpp"
                      var $conv20213=(tempInt=(($164)),(tempInt>=128?tempInt-256:tempInt)); //@line 2578 "dictionary.cpp"
                      var $cmp20314=((($conv20213))|0)!=32; //@line 2578 "dictionary.cpp"
                      if ($cmp20314) { __label__ = 64;; } else { __label__ = 65;; } //@line 2578 "dictionary.cpp"
                      $while_body204$$while_cond205_loopexit$89: do { 
                        if (__label__ == 64) {
                          while(1) { 
  
                            var $166=HEAP32[(($p)>>2)]; //@line 2578 "dictionary.cpp"
                            var $incdec_ptr=(($166+1)&4294967295); //@line 2578 "dictionary.cpp"
                            HEAP32[(($p)>>2)]=$incdec_ptr; //@line 2578 "dictionary.cpp"
                            var $167=$n; //@line 2578 "dictionary.cpp"
                            var $168=HEAP32[(($p)>>2)]; //@line 2578 "dictionary.cpp"
                            var $arrayidx200=(($168+$167)&4294967295); //@line 2578 "dictionary.cpp"
                            var $169=HEAP8[($arrayidx200)]; //@line 2578 "dictionary.cpp"
                            var $170=HEAP32[(($p)>>2)]; //@line 2578 "dictionary.cpp"
                            var $arrayidx201=(($170)&4294967295); //@line 2578 "dictionary.cpp"
                            HEAP8[($arrayidx201)]=$169; //@line 2578 "dictionary.cpp"
                            var $conv202=(tempInt=(($169)),(tempInt>=128?tempInt-256:tempInt)); //@line 2578 "dictionary.cpp"
                            var $cmp203=((($conv202))|0)!=32; //@line 2578 "dictionary.cpp"
                            if ($cmp203) { __label__ = 64;continue ; } else { __label__ = 65;break $while_body204$$while_cond205_loopexit$89; } //@line 2578 "dictionary.cpp"
                          }
                        }
                      } while(0);
  
                      var $171=$n; //@line 2579 "dictionary.cpp"
                      var $dec15=((($171)-1)&4294967295); //@line 2579 "dictionary.cpp"
                      $n=$dec15; //@line 2579 "dictionary.cpp"
                      var $cmp20616=((($171))|0) > 0; //@line 2579 "dictionary.cpp"
                      if ($cmp20616) { __label__ = 66;; } else { __label__ = 67;; } //@line 2579 "dictionary.cpp"
                      $while_body207$$while_end209$93: do { 
                        if (__label__ == 66) {
                          while(1) { 
  
                            var $172=HEAP32[(($p)>>2)]; //@line 2579 "dictionary.cpp"
                            var $incdec_ptr208=(($172+1)&4294967295); //@line 2579 "dictionary.cpp"
                            HEAP32[(($p)>>2)]=$incdec_ptr208; //@line 2579 "dictionary.cpp"
                            HEAP8[($172)]=32; //@line 2579 "dictionary.cpp"
                            var $173=$n; //@line 2579 "dictionary.cpp"
                            var $dec=((($173)-1)&4294967295); //@line 2579 "dictionary.cpp"
                            $n=$dec; //@line 2579 "dictionary.cpp"
                            var $cmp206=((($173))|0) > 0; //@line 2579 "dictionary.cpp"
                            if ($cmp206) { __label__ = 66;continue ; } else { __label__ = 67;break $while_body207$$while_end209$93; } //@line 2579 "dictionary.cpp"
                          }
                        }
                      } while(0);
  
                      var $174=$tr_addr; //@line 2581 "dictionary.cpp"
                      var $langopts210=(($174)&4294967295); //@line 2581 "dictionary.cpp"
                      var $param211=(($langopts210+24)&4294967295); //@line 2581 "dictionary.cpp"
                      var $arrayidx212=(($param211+4)&4294967295); //@line 2581 "dictionary.cpp"
                      var $175=HEAP32[(($arrayidx212)>>2)]; //@line 2581 "dictionary.cpp"
                      var $tobool213=((($175))|0)!=0; //@line 2581 "dictionary.cpp"
                      if ($tobool213) { __label__ = 68;; } else { __label__ = 70;; } //@line 2581 "dictionary.cpp"
                      $land_lhs_true214$$if_end218$97: do { 
                        if (__label__ == 68) {
  
                          var $176=HEAP32[(($letter)>>2)]; //@line 2581 "dictionary.cpp"
                          var $call215=__Z11lookupwcharPKti(((__ZL13diereses_list)&4294967295), $176); //@line 2581 "dictionary.cpp"
                          var $cmp216=((($call215))|0) > 0; //@line 2581 "dictionary.cpp"
                          if (!($cmp216)) { __label__ = 70;break $land_lhs_true214$$if_end218$97; } //@line 2581 "dictionary.cpp"
  
                          var $177=HEAP32[(($p2)>>2)]; //@line 2584 "dictionary.cpp"
                          HEAP32[(($p)>>2)]=$177; //@line 2584 "dictionary.cpp"
                          __label__ = 20;continue $while_cond$28; //@line 2585 "dictionary.cpp"
                        }
                      } while(0);
  
                      var $178=$phonemes_addr; //@line 2588 "dictionary.cpp"
                      var $arrayidx219=(($178)&4294967295); //@line 2588 "dictionary.cpp"
                      HEAP8[($arrayidx219)]=0; //@line 2588 "dictionary.cpp"
                      var $179=$p_start_addr; //@line 2589 "dictionary.cpp"
                      HEAP32[(($p)>>2)]=$179; //@line 2589 "dictionary.cpp"
                      var $180=$tr_addr; //@line 2590 "dictionary.cpp"
                      var $word_vowel_count220=(($180+8296)&4294967295); //@line 2590 "dictionary.cpp"
                      HEAP32[(($word_vowel_count220)>>2)]=0; //@line 2590 "dictionary.cpp"
                      var $181=$tr_addr; //@line 2591 "dictionary.cpp"
                      var $word_stressed_count221=(($181+8300)&4294967295); //@line 2591 "dictionary.cpp"
                      HEAP32[(($word_stressed_count221)>>2)]=0; //@line 2591 "dictionary.cpp"
                      __label__ = 20;continue $while_cond$28; //@line 2592 "dictionary.cpp"
                    }
                  } while(0);
  
                  var $182=HEAP32[(($letter)>>2)]; //@line 2596 "dictionary.cpp"
                  var $cmp224=((($182))|0) >= 12800; //@line 2596 "dictionary.cpp"
                  var $183=HEAP32[(($letter)>>2)]; //@line 2596 "dictionary.cpp"
                  var $cmp226=((($183))|0) < 42752; //@line 2596 "dictionary.cpp"
                  var $or_cond1=($cmp224) & ($cmp226); //@line 2596 "dictionary.cpp"
                  if (!($or_cond1)) { __label__ = 74;break $if_then128$$if_else132$64; } //@line 2596 "dictionary.cpp"
  
                  var $184=$end_phonemes_addr; //@line 2596 "dictionary.cpp"
                  var $cmp228=((($184))|0)!=0; //@line 2596 "dictionary.cpp"
                  if (!($cmp228)) { __label__ = 74;break $if_then128$$if_else132$64; } //@line 2596 "dictionary.cpp"
  
                  var $185=$tr_addr; //@line 2600 "dictionary.cpp"
                  var $call231=__Z6LookupP10TranslatorPKcPc($185, ((__str9306)&4294967295), $arraydecay230); //@line 2600 "dictionary.cpp"
                  HEAP32[(($phonemes233)>>2)]=$arraydecay232; //@line 2601 "dictionary.cpp"
                  HEAP32[(($points234)>>2)]=1; //@line 2602 "dictionary.cpp"
                  var $186=$wc_bytes; //@line 2603 "dictionary.cpp"
                  var $sub235=((($186)-1)&4294967295); //@line 2603 "dictionary.cpp"
                  var $187=HEAP32[(($p)>>2)]; //@line 2603 "dictionary.cpp"
                  var $add_ptr236=(($187+$sub235)&4294967295); //@line 2603 "dictionary.cpp"
                  HEAP32[(($p)>>2)]=$add_ptr236; //@line 2603 "dictionary.cpp"
                  __label__ = 74;break $if_then128$$if_else132$64; //@line 2604 "dictionary.cpp"
                }
              } while(0);
              $if_end240$$if_else278$104: do { 
                if (__label__ == 74) {
  
                  var $_pr17=HEAP32[(($points241)>>2)]; //@line 2608 "dictionary.cpp"
                  var $cmp242=((($_pr17))|0)==0; //@line 2608 "dictionary.cpp"
                  if (!($cmp242)) { __label__ = 84;break $if_end240$$if_else278$104; } //@line 2608 "dictionary.cpp"
  
                  var $188=HEAP32[(($wc)>>2)]; //@line 2610 "dictionary.cpp"
                  var $cmp244=((($188))|0) >= 768; //@line 2610 "dictionary.cpp"
                  var $189=HEAP32[(($wc)>>2)]; //@line 2610 "dictionary.cpp"
                  var $cmp246=((($189))|0) <= 879; //@line 2610 "dictionary.cpp"
                  var $or_cond2=($cmp244) & ($cmp246); //@line 2610 "dictionary.cpp"
                  if ($or_cond2) { __label__ = 83;; } else { __label__ = 76;; } //@line 2610 "dictionary.cpp"
                  $if_end275$$if_else248$107: do { 
                    if (__label__ == 76) {
  
                      var $190=HEAP32[(($wc)>>2)]; //@line 2615 "dictionary.cpp"
                      var $call249=__Z7IsAlphaj($190); //@line 2615 "dictionary.cpp"
                      var $tobool250=((($call249))|0)!=0; //@line 2615 "dictionary.cpp"
                      if ($tobool250) { __label__ = 77;; } else { __label__ = 81;; } //@line 2615 "dictionary.cpp"
                      if (__label__ == 77) {
  
                        var $191=$any_alpha; //@line 2617 "dictionary.cpp"
                        var $cmp252=((($191))|0) > 1; //@line 2617 "dictionary.cpp"
                        if ($cmp252) { __label__ = 79;break $while_cond$28; } //@line 2617 "dictionary.cpp"
  
                        var $192=$wc_bytes; //@line 2617 "dictionary.cpp"
                        var $sub254=((($192)-1)&4294967295); //@line 2617 "dictionary.cpp"
                        var $193=HEAP32[(($p)>>2)]; //@line 2617 "dictionary.cpp"
                        var $arrayidx255=(($193+$sub254)&4294967295); //@line 2617 "dictionary.cpp"
                        var $194=HEAP8[($arrayidx255)]; //@line 2617 "dictionary.cpp"
                        var $conv256=(tempInt=(($194)),(tempInt>=128?tempInt-256:tempInt)); //@line 2617 "dictionary.cpp"
                        var $cmp257=((($conv256))|0) > 32; //@line 2617 "dictionary.cpp"
                        if ($cmp257) { __label__ = 79;break $while_cond$28; } //@line 2617 "dictionary.cpp"
                      }
                      else if (__label__ == 81) {
  
                        var $199=$tr_addr; //@line 2628 "dictionary.cpp"
                        var $200=HEAP32[(($wc)>>2)]; //@line 2628 "dictionary.cpp"
                        __Z12LookupLetterP10TranslatorjiPci($199, $200, -1, $arraydecay266, 0); //@line 2628 "dictionary.cpp"
                        var $201=HEAP8[($arrayidx267)]; //@line 2629 "dictionary.cpp"
                        var $tobool268=(tempInt=(($201)),(tempInt>=128?tempInt-256:tempInt))!=0; //@line 2629 "dictionary.cpp"
                        if (!($tobool268)) { __label__ = 83;break $if_end275$$if_else248$107; } //@line 2629 "dictionary.cpp"
  
                        HEAP32[(($phonemes271)>>2)]=$arraydecay270; //@line 2631 "dictionary.cpp"
                        HEAP32[(($points272)>>2)]=1; //@line 2632 "dictionary.cpp"
                        ; //@line 2633 "dictionary.cpp"
                      }
                    }
                  } while(0);
  
                  var $202=$wc_bytes; //@line 2635 "dictionary.cpp"
                  var $sub276=((($202)-1)&4294967295); //@line 2635 "dictionary.cpp"
                  var $203=HEAP32[(($p)>>2)]; //@line 2635 "dictionary.cpp"
                  var $add_ptr277=(($203+$sub276)&4294967295); //@line 2635 "dictionary.cpp"
                  HEAP32[(($p)>>2)]=$add_ptr277; //@line 2635 "dictionary.cpp"
                  __label__ = 85;break $if_end281$$if_end81$48; //@line 2636 "dictionary.cpp"
                }
              } while(0);
  
              var $204=$tr_addr; //@line 2639 "dictionary.cpp"
              var $phonemes_repeat_count=(($204+652)&4294967295); //@line 2639 "dictionary.cpp"
              HEAP32[(($phonemes_repeat_count)>>2)]=0; //@line 2639 "dictionary.cpp"
              ;
            }
          } while(0);
  
          var $205=HEAP32[(($phonemes282)>>2)]; //@line 2644 "dictionary.cpp"
          var $cmp283=((($205))|0)==0; //@line 2644 "dictionary.cpp"
          if ($cmp283) { __label__ = 86;; } else { __label__ = 87;; } //@line 2644 "dictionary.cpp"
          if (__label__ == 86) {
  
            HEAP32[(($phonemes285)>>2)]=((__str13643)&4294967295); //@line 2645 "dictionary.cpp"
            ; //@line 2645 "dictionary.cpp"
          }
  
          var $206=HEAP32[(($points287)>>2)]; //@line 2647 "dictionary.cpp"
          var $cmp288=((($206))|0) > 0; //@line 2647 "dictionary.cpp"
          if (!($cmp288)) { __label__ = 20;continue $while_cond$28; } //@line 2647 "dictionary.cpp"
  
          var $207=$word_flags_addr; //@line 2649 "dictionary.cpp"
          var $and290=($207) & -2147483648; //@line 2649 "dictionary.cpp"
          var $tobool291=((($and290))|0)!=0; //@line 2649 "dictionary.cpp"
          if ($tobool291) { __label__ = 89;break $while_cond$28; } //@line 2649 "dictionary.cpp"
  
          var $209=HEAP32[(($phonemes295)>>2)]; //@line 2652 "dictionary.cpp"
          var $arrayidx296=(($209)&4294967295); //@line 2652 "dictionary.cpp"
          var $210=HEAP8[($arrayidx296)]; //@line 2652 "dictionary.cpp"
          var $conv297=(tempInt=(($210)),(tempInt>=128?tempInt-256:tempInt)); //@line 2652 "dictionary.cpp"
          var $cmp298=((($conv297))|0)==21; //@line 2652 "dictionary.cpp"
          if ($cmp298) { __label__ = 91;; } else { __label__ = 93;; } //@line 2652 "dictionary.cpp"
          if (__label__ == 91) {
  
            var $211=$word_flags_addr; //@line 2652 "dictionary.cpp"
            var $and300=($211) & 4096; //@line 2652 "dictionary.cpp"
            var $cmp301=((($and300))|0)==0; //@line 2652 "dictionary.cpp"
            if ($cmp301) { __label__ = 92;break $while_cond$28; } //@line 2652 "dictionary.cpp"
          }
  
          var $214=HEAP32[(($end_type306)>>2)]; //@line 2659 "dictionary.cpp"
          var $and307=($214) & -32769; //@line 2659 "dictionary.cpp"
          HEAP32[(($end_type306)>>2)]=$and307; //@line 2659 "dictionary.cpp"
          var $cmp309=((($and307))|0)!=0; //@line 2661 "dictionary.cpp"
          if ($cmp309) { __label__ = 94;; } else { __label__ = 101;; } //@line 2661 "dictionary.cpp"
          $land_lhs_true310$$if_end339$125: do { 
            if (__label__ == 94) {
  
              var $215=$end_phonemes_addr; //@line 2661 "dictionary.cpp"
              var $cmp311=((($215))|0)!=0; //@line 2661 "dictionary.cpp"
              if (!($cmp311)) { __label__ = 101;break $land_lhs_true310$$if_end339$125; } //@line 2661 "dictionary.cpp"
  
              var $216=HEAP32[(($end_type313)>>2)]; //@line 2664 "dictionary.cpp"
              var $and314=($216) & 1024; //@line 2664 "dictionary.cpp"
              var $tobool315=((($and314))|0)!=0; //@line 2664 "dictionary.cpp"
              if (!($tobool315)) { __label__ = 97;break $while_cond$28; } //@line 2664 "dictionary.cpp"
  
              var $217=$word_flags_addr; //@line 2664 "dictionary.cpp"
              var $and317=($217) & 536870912; //@line 2664 "dictionary.cpp"
              var $tobool318=((($and317))|0)!=0; //@line 2664 "dictionary.cpp"
              if (!($tobool318)) { __label__ = 97;break $while_cond$28; } //@line 2664 "dictionary.cpp"
            }
          } while(0);
  
          var $227=HEAP32[(($del_fwd)>>2)]; //@line 2680 "dictionary.cpp"
          var $cmp340=((($227))|0)!=0; //@line 2680 "dictionary.cpp"
          if ($cmp340) { __label__ = 102;; } else { __label__ = 103;; } //@line 2680 "dictionary.cpp"
          if (__label__ == 102) {
  
            var $228=HEAP32[(($del_fwd342)>>2)]; //@line 2681 "dictionary.cpp"
            HEAP8[($228)]=69; //@line 2681 "dictionary.cpp"
            ; //@line 2681 "dictionary.cpp"
          }
  
          var $229=$tr_addr; //@line 2682 "dictionary.cpp"
          var $230=$phonemes_addr; //@line 2682 "dictionary.cpp"
          var $231=$ph_size_addr; //@line 2682 "dictionary.cpp"
          var $232=HEAP32[(($phonemes344)>>2)]; //@line 2682 "dictionary.cpp"
          __Z14AppendPhonemesP10TranslatorPciPKc($229, $230, $231, $232); //@line 2682 "dictionary.cpp"
          __label__ = 20;continue $while_cond$28; //@line 2683 "dictionary.cpp"
        }
        $while_end346$$if_then292$$if_then302$$if_else320$$if_then258$$if_then151$133: do { 
          if (__label__ == 89) {
  
            var $end_type=(($match1+8)&4294967295); //@line 2650 "dictionary.cpp"
            var $208=HEAP32[(($end_type)>>2)]; //@line 2650 "dictionary.cpp"
            var $or293=($208) | 1; //@line 2650 "dictionary.cpp"
            $retval=$or293; //@line 2650 "dictionary.cpp"
            __label__ = 105;break $if_then$$if_end$2; //@line 2650 "dictionary.cpp"
          }
          else if (__label__ == 92) {
  
            var $212=$phonemes_addr; //@line 2655 "dictionary.cpp"
            var $phonemes303=(($match1+4)&4294967295); //@line 2655 "dictionary.cpp"
            var $213=HEAP32[(($phonemes303)>>2)]; //@line 2655 "dictionary.cpp"
            var $call304=_strcpy($212, $213); //@line 2655 "dictionary.cpp"
            $retval=0; //@line 2656 "dictionary.cpp"
            __label__ = 105;break $if_then$$if_end$2; //@line 2656 "dictionary.cpp"
          }
          else if (__label__ == 97) {
  
            var $end_type321=(($match1+8)&4294967295); //@line 2670 "dictionary.cpp"
            var $218=HEAP32[(($end_type321)>>2)]; //@line 2670 "dictionary.cpp"
            var $and322=($218) & 1024; //@line 2670 "dictionary.cpp"
            var $tobool323=((($and322))|0)!=0; //@line 2670 "dictionary.cpp"
            if ($tobool323) { __label__ = 98;; } else { __label__ = 100;; } //@line 2670 "dictionary.cpp"
            $land_lhs_true324$$if_end331$137: do { 
              if (__label__ == 98) {
  
                var $end_type325=(($match1+8)&4294967295); //@line 2670 "dictionary.cpp"
                var $219=HEAP32[(($end_type325)>>2)]; //@line 2670 "dictionary.cpp"
                var $and326=($219) & 127; //@line 2670 "dictionary.cpp"
                var $cmp327=((($and326))|0)==0; //@line 2670 "dictionary.cpp"
                if (!($cmp327)) { __label__ = 100;break $land_lhs_true324$$if_end331$137; } //@line 2670 "dictionary.cpp"
  
                var $220=HEAP32[(($p)>>2)]; //@line 2673 "dictionary.cpp"
                var $221=$p_start_addr; //@line 2673 "dictionary.cpp"
                var $sub_ptr_lhs_cast=($220); //@line 2673 "dictionary.cpp"
                var $sub_ptr_rhs_cast=($221); //@line 2673 "dictionary.cpp"
                var $sub_ptr_sub=((($sub_ptr_lhs_cast)-($sub_ptr_rhs_cast))&4294967295); //@line 2673 "dictionary.cpp"
                var $end_type329=(($match1+8)&4294967295); //@line 2673 "dictionary.cpp"
                var $222=HEAP32[(($end_type329)>>2)]; //@line 2673 "dictionary.cpp"
                var $or330=($sub_ptr_sub) | ($222); //@line 2673 "dictionary.cpp"
                HEAP32[(($end_type329)>>2)]=$or330; //@line 2673 "dictionary.cpp"
                ; //@line 2674 "dictionary.cpp"
              }
            } while(0);
  
            var $223=$end_phonemes_addr; //@line 2675 "dictionary.cpp"
            var $phonemes332=(($match1+4)&4294967295); //@line 2675 "dictionary.cpp"
            var $224=HEAP32[(($phonemes332)>>2)]; //@line 2675 "dictionary.cpp"
            var $call333=_strcpy($223, $224); //@line 2675 "dictionary.cpp"
            var $225=$p_start_addr; //@line 2676 "dictionary.cpp"
            var $arraydecay334=(($word_copy)&4294967295); //@line 2676 "dictionary.cpp"
            var $arraydecay335=(($word_copy)&4294967295); //@line 2676 "dictionary.cpp"
            var $call336=_strlen($arraydecay335); //@line 2676 "dictionary.cpp"
            var $src$, $dest$, $stop$, $stop4$, $fast$;
            $src$ = $arraydecay334;
            $dest$ = $225;
            $stop$ = $src$ + $call336;
            if (($dest$%4) == ($src$%4) && $call336 > 8) {
              while ($src$%4 !== 0 && $src$ < $stop$) {
                ; HEAP8[$dest$++] = HEAP8[$src$++];
              }
              $src$ >>= 2;
              $dest$ >>= 2;
              $stop4$ = $stop$ >> 2;
              while ($src$ < $stop4$) {
            ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
              }
              $src$ <<= 2;
              $dest$ <<= 2;
            }while ($src$ < $stop$) {
              ; HEAP8[$dest$++] = HEAP8[$src$++];
            }; //@line 2676 "dictionary.cpp"
            var $end_type337=(($match1+8)&4294967295); //@line 2677 "dictionary.cpp"
            var $226=HEAP32[(($end_type337)>>2)]; //@line 2677 "dictionary.cpp"
            $retval=$226; //@line 2677 "dictionary.cpp"
            __label__ = 105;break $if_then$$if_end$2; //@line 2677 "dictionary.cpp"
          }
          else if (__label__ == 79) {
  
            var $195=$phonemes_addr; //@line 2620 "dictionary.cpp"
            var $arrayidx259=(($195)&4294967295); //@line 2620 "dictionary.cpp"
            HEAP8[($arrayidx259)]=0; //@line 2620 "dictionary.cpp"
            var $196=$dict_flags_addr; //@line 2621 "dictionary.cpp"
            var $cmp260=((($196))|0)!=0; //@line 2621 "dictionary.cpp"
            if (!($cmp260)) { __label__ = 104;break $while_end346$$if_then292$$if_then302$$if_else320$$if_then258$$if_then151$133; } //@line 2621 "dictionary.cpp"
  
            var $197=$dict_flags_addr; //@line 2622 "dictionary.cpp"
            var $arrayidx262=(($197)&4294967295); //@line 2622 "dictionary.cpp"
            var $198=HEAP32[(($arrayidx262)>>2)]; //@line 2622 "dictionary.cpp"
            var $or=($198) | 65536; //@line 2622 "dictionary.cpp"
            HEAP32[(($arrayidx262)>>2)]=$or; //@line 2622 "dictionary.cpp"
            ; //@line 2622 "dictionary.cpp"
          }
          else if (__label__ == 51) {
  
            var $135=$phonemes_addr; //@line 2543 "dictionary.cpp"
            var $136=$tr_addr; //@line 2543 "dictionary.cpp"
            var $langopts152=(($136)&4294967295); //@line 2543 "dictionary.cpp"
            var $ascii_language=(($langopts152+268)&4294967295); //@line 2543 "dictionary.cpp"
            var $137=HEAP32[(($ascii_language)>>2)]; //@line 2543 "dictionary.cpp"
            var $call153=_sprintf($135, ((__str70722)&4294967295), allocate([21,0,0,0,$137,0,0,0], ["i32",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 2543 "dictionary.cpp"
            $retval=0; //@line 2544 "dictionary.cpp"
            __label__ = 105;break $if_then$$if_end$2; //@line 2544 "dictionary.cpp"
          }
        } while(0);
  
        var $233=$tr_addr; //@line 2687 "dictionary.cpp"
        var $234=$phonemes_addr; //@line 2687 "dictionary.cpp"
        var $235=$dict_flags0; //@line 2687 "dictionary.cpp"
        __Z21ApplySpecialAttributeP10TranslatorPci($233, $234, $235); //@line 2687 "dictionary.cpp"
        var $236=$p_start_addr; //@line 2688 "dictionary.cpp"
        var $arraydecay347=(($word_copy)&4294967295); //@line 2688 "dictionary.cpp"
        var $arraydecay348=(($word_copy)&4294967295); //@line 2688 "dictionary.cpp"
        var $call349=_strlen($arraydecay348); //@line 2688 "dictionary.cpp"
        var $src$, $dest$, $stop$, $stop4$, $fast$;
        $src$ = $arraydecay347;
        $dest$ = $236;
        $stop$ = $src$ + $call349;
        if (($dest$%4) == ($src$%4) && $call349 > 8) {
          while ($src$%4 !== 0 && $src$ < $stop$) {
            ; HEAP8[$dest$++] = HEAP8[$src$++];
          }
          $src$ >>= 2;
          $dest$ >>= 2;
          $stop4$ = $stop$ >> 2;
          while ($src$ < $stop4$) {
        ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
          }
          $src$ <<= 2;
          $dest$ <<= 2;
        }while ($src$ < $stop$) {
          ; HEAP8[$dest$++] = HEAP8[$src$++];
        }; //@line 2688 "dictionary.cpp"
        $retval=0; //@line 2690 "dictionary.cpp"
        ; //@line 2690 "dictionary.cpp"
      }
    } while(0);
  
    var $237=$retval; //@line 2691 "dictionary.cpp"
    STACKTOP = __stackBase__;
    return $237; //@line 2691 "dictionary.cpp"
    return null;
  }
  

  function __Z6LookupP10TranslatorPKcPc($tr, $word, $ph_out) {
    var __stackBase__  = STACKTOP; STACKTOP += 12; _memset(__stackBase__, 0, 12);
    var __label__;
  
    var $tr_addr;
    var $word_addr;
    var $ph_out_addr;
    var $flags=__stackBase__;
    var $word1=__stackBase__+8;
    $tr_addr=$tr;
    $word_addr=$word;
    $ph_out_addr=$ph_out;
    var $arrayidx=(($flags+4)&4294967295); //@line 3369 "dictionary.cpp"
    HEAP32[(($arrayidx)>>2)]=0; //@line 3369 "dictionary.cpp"
    var $arrayidx1=(($flags)&4294967295); //@line 3369 "dictionary.cpp"
    HEAP32[(($arrayidx1)>>2)]=0; //@line 3369 "dictionary.cpp"
    var $0=$word_addr; //@line 3370 "dictionary.cpp"
    HEAP32[(($word1)>>2)]=$0; //@line 3370 "dictionary.cpp"
    var $1=$tr_addr; //@line 3371 "dictionary.cpp"
    var $2=$ph_out_addr; //@line 3371 "dictionary.cpp"
    var $arraydecay=(($flags)&4294967295); //@line 3371 "dictionary.cpp"
    var $call=__Z14LookupDictListP10TranslatorPPcS1_PjiP8WORD_TAB($1, $word1, $2, $arraydecay, 0, 0); //@line 3371 "dictionary.cpp"
    STACKTOP = __stackBase__;
    return $call; //@line 3371 "dictionary.cpp"
    return null;
  }
  

  function __ZL9MatchRuleP10TranslatorPPcS1_iS1_P11MatchRecordii($tr, $word, $word_start, $group_length, $rule, $match_out, $word_flags, $dict_flags) {
    var __stackBase__  = STACKTOP; STACKTOP += 264; _memset(__stackBase__, 0, 264);
    var __label__;
    var __lastLabel__ = null;
  
    var $tr_addr;
    var $word_addr;
    var $word_start_addr;
    var $group_length_addr;
    var $rule_addr;
    var $match_out_addr;
    var $word_flags_addr;
    var $dict_flags_addr;
    var $rb;
    var $letter;
    var $letter_w=__stackBase__;
    var $letter_xbytes;
    var $last_letter;
    var $pre_ptr;
    var $post_ptr;
    var $rule_start;
    var $p;
    var $ix;
    var $match_type;
    var $failed;
    var $unpron_ignore;
    var $consumed;
    var $syllable_count;
    var $vowel;
    var $letter_group;
    var $distance_right;
    var $distance_left;
    var $lg_pts;
    var $n_bytes;
    var $add_points;
    var $command;
    var $check_atstart;
    var $match=__stackBase__+4;
    var $total_consumed;
    var $condition_num;
    var $common_phonemes;
    var $group_chars;
    var $word_buf=__stackBase__+20;
    var $p222;
    var $vowel_count;
    var $p252;
    var $p269;
    var $p2;
    var $rule_w=__stackBase__+180;
    var $p419;
    var $pts;
    var $decoded_phonemes=__stackBase__+184;
    $tr_addr=$tr;
    $word_addr=$word;
    $word_start_addr=$word_start;
    $group_length_addr=$group_length;
    $rule_addr=$rule;
    $match_out_addr=$match_out;
    $word_flags_addr=$word_flags;
    $dict_flags_addr=$dict_flags;
    var $0=$word_addr; //@line 1777 "dictionary.cpp"
    var $1=HEAP32[(($0)>>2)]; //@line 1777 "dictionary.cpp"
    $group_chars=$1; //@line 1777 "dictionary.cpp"
    var $2=$rule_addr; //@line 1779 "dictionary.cpp"
    var $cmp=((($2))|0)==0; //@line 1779 "dictionary.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 1779 "dictionary.cpp"
    if (__label__ == 1) {
  
      var $3=$match_out_addr; //@line 1781 "dictionary.cpp"
      var $points=(($3)&4294967295); //@line 1781 "dictionary.cpp"
      HEAP32[(($points)>>2)]=0; //@line 1781 "dictionary.cpp"
      var $4=$word_addr; //@line 1782 "dictionary.cpp"
      var $5=HEAP32[(($4)>>2)]; //@line 1782 "dictionary.cpp"
      var $incdec_ptr=(($5+1)&4294967295); //@line 1782 "dictionary.cpp"
      HEAP32[(($4)>>2)]=$incdec_ptr; //@line 1782 "dictionary.cpp"
      ; //@line 1783 "dictionary.cpp"
    }
    else if (__label__ == 2) {
  
      $total_consumed=0; //@line 1787 "dictionary.cpp"
      $common_phonemes=0; //@line 1788 "dictionary.cpp"
      $match_type=0; //@line 1789 "dictionary.cpp"
      HEAP32[((((__ZZL9MatchRuleP10TranslatorPPcS1_iS1_P11MatchRecordiiE4best)&4294967295))>>2)]=0; //@line 1791 "dictionary.cpp"
      HEAP32[((((__ZZL9MatchRuleP10TranslatorPPcS1_iS1_P11MatchRecordiiE4best+4)&4294967295))>>2)]=((__str13643)&4294967295); //@line 1792 "dictionary.cpp"
      HEAP32[((((__ZZL9MatchRuleP10TranslatorPPcS1_iS1_P11MatchRecordiiE4best+8)&4294967295))>>2)]=0; //@line 1793 "dictionary.cpp"
      HEAP32[((((__ZZL9MatchRuleP10TranslatorPPcS1_iS1_P11MatchRecordiiE4best+12)&4294967295))>>2)]=0; //@line 1794 "dictionary.cpp"
      var $6=$rule_addr; //@line 1797 "dictionary.cpp"
      var $7=HEAP8[($6)]; //@line 1797 "dictionary.cpp"
      var $conv22=(tempInt=(($7)),(tempInt>=128?tempInt-256:tempInt)); //@line 1797 "dictionary.cpp"
      var $cmp123=((($conv22))|0)!=7; //@line 1797 "dictionary.cpp"
      if ($cmp123) { __label__ = 3;; } else { __label__ = 198;; } //@line 1797 "dictionary.cpp"
      $while_body_lr_ph$$while_end549$5: do { 
        if (__label__ == 3) {
  
          var $points2=(($match)&4294967295); //@line 1807 "dictionary.cpp"
          var $end_type=(($match+8)&4294967295); //@line 1808 "dictionary.cpp"
          var $del_fwd=(($match+12)&4294967295); //@line 1809 "dictionary.cpp"
          var $points518=(($match)&4294967295); //@line 2340 "dictionary.cpp"
          var $8=$match; //@line 2342 "dictionary.cpp"
          var $points524=(($match)&4294967295); //@line 2346 "dictionary.cpp"
          var $points530=(($match)&4294967295); //@line 2352 "dictionary.cpp"
          var $phonemes535=(($match+4)&4294967295); //@line 2355 "dictionary.cpp"
          var $arraydecay536=(($decoded_phonemes)&4294967295); //@line 2355 "dictionary.cpp"
          var $arraydecay538=(($decoded_phonemes)&4294967295); //@line 2356 "dictionary.cpp"
          var $points515=(($match)&4294967295); //@line 2337 "dictionary.cpp"
          var $phonemes=(($match+4)&4294967295); //@line 1829 "dictionary.cpp"
          var $phonemes13=(($match+4)&4294967295); //@line 1830 "dictionary.cpp"
          var $phonemes23=(($match+4)&4294967295); //@line 1833 "dictionary.cpp"
          var $phonemes29=(($match+4)&4294967295); //@line 1835 "dictionary.cpp"
          var $phonemes32=(($match+4)&4294967295); //@line 1840 "dictionary.cpp"
          var $phonemes43=(($match+4)&4294967295); //@line 1867 "dictionary.cpp"
          var $points66=(($match)&4294967295); //@line 1891 "dictionary.cpp"
          var $points499=(($match)&4294967295); //@line 2328 "dictionary.cpp"
          var $end_type171=(($match+8)&4294967295); //@line 2006 "dictionary.cpp"
          var $arraydecay=(($word_buf)&4294967295); //@line 2023 "dictionary.cpp"
          var $arrayidx195=(($word_buf+1)&4294967295); //@line 2027 "dictionary.cpp"
          var $del_fwd291=(($match+12)&4294967295); //@line 2121 "dictionary.cpp"
          var $end_type307=(($match+8)&4294967295); //@line 2129 "dictionary.cpp"
          ; //@line 1797 "dictionary.cpp"
          $while_body$7: while(1) { 
  
            var $11=$word_flags_addr; //@line 1799 "dictionary.cpp"
            var $and=($11) & -2147483648; //@line 1799 "dictionary.cpp"
            $unpron_ignore=$and; //@line 1799 "dictionary.cpp"
            $match_type=0; //@line 1800 "dictionary.cpp"
            $consumed=0; //@line 1801 "dictionary.cpp"
            $letter=0; //@line 1802 "dictionary.cpp"
            $distance_right=-6; //@line 1803 "dictionary.cpp"
            $distance_left=-2; //@line 1804 "dictionary.cpp"
            $check_atstart=0; //@line 1805 "dictionary.cpp"
            HEAP32[(($points2)>>2)]=1; //@line 1807 "dictionary.cpp"
            HEAP32[(($end_type)>>2)]=0; //@line 1808 "dictionary.cpp"
            HEAP32[(($del_fwd)>>2)]=0; //@line 1809 "dictionary.cpp"
            var $12=$word_addr; //@line 1811 "dictionary.cpp"
            var $13=HEAP32[(($12)>>2)]; //@line 1811 "dictionary.cpp"
            $pre_ptr=$13; //@line 1811 "dictionary.cpp"
            var $14=$word_addr; //@line 1812 "dictionary.cpp"
            var $15=HEAP32[(($14)>>2)]; //@line 1812 "dictionary.cpp"
            var $16=$group_length_addr; //@line 1812 "dictionary.cpp"
            var $add_ptr=(($15+$16)&4294967295); //@line 1812 "dictionary.cpp"
            $post_ptr=$add_ptr; //@line 1812 "dictionary.cpp"
            var $17=$rule_addr; //@line 1815 "dictionary.cpp"
            $rule_start=$17; //@line 1815 "dictionary.cpp"
            $failed=0; //@line 1817 "dictionary.cpp"
            var $18=$failed; //@line 1818 "dictionary.cpp"
            var $tobool20=((($18))|0)!=0; //@line 1818 "dictionary.cpp"
            var $lnot21=($tobool20) ^ 1; //@line 1818 "dictionary.cpp"
            if ($lnot21) { __lastLabel__ = 5; __label__ = 6;; } else { __lastLabel__ = 5; __label__ = 183;; } //@line 1818 "dictionary.cpp"
            $while_body4$$while_end502$9: do { 
              if (__label__ == 6) {
                $while_body4$10: while(1) { 
  
                  var $19=$rule_addr; //@line 1820 "dictionary.cpp"
                  var $incdec_ptr5=(($19+1)&4294967295); //@line 1820 "dictionary.cpp"
                  $rule_addr=$incdec_ptr5; //@line 1820 "dictionary.cpp"
                  var $20=HEAP8[($19)]; //@line 1820 "dictionary.cpp"
                  $rb=$20; //@line 1820 "dictionary.cpp"
                  var $21=$rb; //@line 1822 "dictionary.cpp"
                  var $conv6=((($21))&255); //@line 1822 "dictionary.cpp"
                  var $cmp7=((($conv6))|0) <= 9; //@line 1822 "dictionary.cpp"
                  if ($cmp7) { __label__ = 7;; } else { __label__ = 33;; } //@line 1822 "dictionary.cpp"
                  $if_then8$$if_end70$12: do { 
                    if (__label__ == 7) {
  
                      var $22=$rb; //@line 1824 "dictionary.cpp"
                      var $conv9=((($22))&255); //@line 1824 "dictionary.cpp"
                      if ($conv9 == 0) {
                        __label__ = 8;;
                      }
                      else if ($conv9 == 8) {
                        __label__ = 18;;
                      }
                      else if ($conv9 == 1) {
                        __label__ = 19;;
                      }
                      else if ($conv9 == 2) {
                        __label__ = 21;;
                      }
                      else if ($conv9 == 3) {
                        __label__ = 22;;
                      }
                      else if ($conv9 == 4) {
                        __label__ = 23;;
                      }
                      else if ($conv9 == 5) {
                        __label__ = 24;;
                      }
                      else if ($conv9 == 9) {
                        __label__ = 32;;
                      }
                      else {
                      __label__ = 30;break $if_then8$$if_end70$12;
                      }
                      
                      if (__label__ == 8) {
  
                        var $23=$common_phonemes; //@line 1827 "dictionary.cpp"
                        var $cmp10=((($23))|0)!=0; //@line 1827 "dictionary.cpp"
                        if ($cmp10) { __label__ = 9;; } else { __label__ = 16;; } //@line 1827 "dictionary.cpp"
                        $if_then11$$if_else$16: do { 
                          if (__label__ == 9) {
  
                            var $24=$common_phonemes; //@line 1829 "dictionary.cpp"
                            HEAP32[(($phonemes)>>2)]=$24; //@line 1829 "dictionary.cpp"
                            ; //@line 1830 "dictionary.cpp"
                            while(1) { 
  
                              var $25=HEAP32[(($phonemes13)>>2)]; //@line 1830 "dictionary.cpp"
                              var $incdec_ptr14=(($25+1)&4294967295); //@line 1830 "dictionary.cpp"
                              HEAP32[(($phonemes13)>>2)]=$incdec_ptr14; //@line 1830 "dictionary.cpp"
                              var $26=HEAPU8[($25)]; //@line 1830 "dictionary.cpp"
                              $rb=$26; //@line 1830 "dictionary.cpp"
                              var $conv15=((($26))&255); //@line 1830 "dictionary.cpp"
                              var $cmp16=((($conv15))|0)!=0; //@line 1830 "dictionary.cpp"
                              if (!($cmp16)) { __label__ = 17;break $if_then11$$if_else$16; } //@line 1830 "dictionary.cpp"
  
                              var $27=$rb; //@line 1830 "dictionary.cpp"
                              var $conv17=((($27))&255); //@line 1830 "dictionary.cpp"
                              var $cmp18=((($conv17))|0)!=3; //@line 1830 "dictionary.cpp"
                              if (!($cmp18)) { __label__ = 17;break $if_then11$$if_else$16; }
  
                              var $28=$rb; //@line 1832 "dictionary.cpp"
                              var $conv20=((($28))&255); //@line 1832 "dictionary.cpp"
                              var $cmp21=((($conv20))|0)==5; //@line 1832 "dictionary.cpp"
                              if ($cmp21) { __label__ = 13;; } else { __label__ = 14;; } //@line 1832 "dictionary.cpp"
                              if (__label__ == 13) {
  
                                var $29=HEAP32[(($phonemes23)>>2)]; //@line 1833 "dictionary.cpp"
                                var $incdec_ptr24=(($29+1)&4294967295); //@line 1833 "dictionary.cpp"
                                HEAP32[(($phonemes23)>>2)]=$incdec_ptr24; //@line 1833 "dictionary.cpp"
                                ; //@line 1833 "dictionary.cpp"
                              }
  
                              var $30=$rb; //@line 1834 "dictionary.cpp"
                              var $conv26=((($30))&255); //@line 1834 "dictionary.cpp"
                              var $cmp27=((($conv26))|0)==9; //@line 1834 "dictionary.cpp"
                              if (!($cmp27)) { __label__ = 10;continue ; } //@line 1834 "dictionary.cpp"
  
                              var $31=HEAP32[(($phonemes29)>>2)]; //@line 1835 "dictionary.cpp"
                              var $add_ptr30=(($31+2)&4294967295); //@line 1835 "dictionary.cpp"
                              HEAP32[(($phonemes29)>>2)]=$add_ptr30; //@line 1835 "dictionary.cpp"
                              __label__ = 10;continue ; //@line 1835 "dictionary.cpp"
                            }
                          }
                          else if (__label__ == 16) {
  
                            HEAP32[(($phonemes32)>>2)]=((__str13643)&4294967295); //@line 1840 "dictionary.cpp"
                            ;
                          }
                        } while(0);
  
                        var $32=$rule_addr; //@line 1842 "dictionary.cpp"
                        var $incdec_ptr34=(($32+-1)&4294967295); //@line 1842 "dictionary.cpp"
                        $rule_addr=$incdec_ptr34; //@line 1842 "dictionary.cpp"
                        $failed=2; //@line 1843 "dictionary.cpp"
                        ; //@line 1844 "dictionary.cpp"
                      }
                      else if (__label__ == 18) {
  
                        $check_atstart=1; //@line 1847 "dictionary.cpp"
                        $unpron_ignore=0; //@line 1848 "dictionary.cpp"
                        $match_type=1; //@line 1849 "dictionary.cpp"
                        ; //@line 1850 "dictionary.cpp"
                      }
                      else if (__label__ == 19) {
  
                        $match_type=1; //@line 1853 "dictionary.cpp"
                        var $33=$word_flags_addr; //@line 1854 "dictionary.cpp"
                        var $and37=($33) & -2147483648; //@line 1854 "dictionary.cpp"
                        var $tobool38=((($and37))|0)!=0; //@line 1854 "dictionary.cpp"
                        if (!($tobool38)) { __label__ = 30;break $if_then8$$if_end70$12; } //@line 1854 "dictionary.cpp"
  
                        $failed=1; //@line 1859 "dictionary.cpp"
                        ; //@line 1860 "dictionary.cpp"
                      }
                      else if (__label__ == 21) {
  
                        $match_type=2; //@line 1864 "dictionary.cpp"
                        ; //@line 1865 "dictionary.cpp"
                      }
                      else if (__label__ == 22) {
  
                        var $34=$rule_addr; //@line 1867 "dictionary.cpp"
                        HEAP32[(($phonemes43)>>2)]=$34; //@line 1867 "dictionary.cpp"
                        $failed=2; //@line 1868 "dictionary.cpp"
                        ; //@line 1869 "dictionary.cpp"
                      }
                      else if (__label__ == 23) {
  
                        var $35=$rule_addr; //@line 1871 "dictionary.cpp"
                        $common_phonemes=$35; //@line 1871 "dictionary.cpp"
                        ; //@line 1872 "dictionary.cpp"
                      }
                      else if (__label__ == 24) {
  
                        var $36=$rule_addr; //@line 1875 "dictionary.cpp"
                        var $incdec_ptr46=(($36+1)&4294967295); //@line 1875 "dictionary.cpp"
                        $rule_addr=$incdec_ptr46; //@line 1875 "dictionary.cpp"
                        var $37=HEAP8[($36)]; //@line 1875 "dictionary.cpp"
                        $condition_num=$37; //@line 1875 "dictionary.cpp"
                        var $38=$condition_num; //@line 1877 "dictionary.cpp"
                        var $conv47=((($38))&255); //@line 1877 "dictionary.cpp"
                        var $cmp48=((($conv47))|0) >= 32; //@line 1877 "dictionary.cpp"
                        var $39=$tr_addr; //@line 1880 "dictionary.cpp"
                        var $dict_condition=(($39+692)&4294967295); //@line 1880 "dictionary.cpp"
                        var $40=HEAP32[(($dict_condition)>>2)]; //@line 1880 "dictionary.cpp"
                        var $41=$condition_num; //@line 1880 "dictionary.cpp"
                        var $conv50=((($41))&255); //@line 1880 "dictionary.cpp"
                        if ($cmp48) { __label__ = 25;; } else { __label__ = 27;; } //@line 1877 "dictionary.cpp"
                        $if_then49$$if_else55$35: do { 
                          if (__label__ == 25) {
  
                            var $sub=((($conv50)-32)&4294967295); //@line 1880 "dictionary.cpp"
                            var $shl=1 << ($sub); //@line 1880 "dictionary.cpp"
                            var $and51=($shl) & ($40); //@line 1880 "dictionary.cpp"
                            var $cmp52=((($and51))|0)!=0; //@line 1880 "dictionary.cpp"
                            if (!($cmp52)) { __label__ = 29;break $if_then49$$if_else55$35; } //@line 1880 "dictionary.cpp"
  
                            $failed=1; //@line 1881 "dictionary.cpp"
                            __label__ = 30;break $if_then8$$if_end70$12; //@line 1881 "dictionary.cpp"
                          }
                          else if (__label__ == 27) {
  
                            var $shl58=1 << ($conv50); //@line 1886 "dictionary.cpp"
                            var $and59=($shl58) & ($40); //@line 1886 "dictionary.cpp"
                            var $cmp60=((($and59))|0)==0; //@line 1886 "dictionary.cpp"
                            if (!($cmp60)) { __label__ = 29;break $if_then49$$if_else55$35; } //@line 1886 "dictionary.cpp"
  
                            $failed=1; //@line 1887 "dictionary.cpp"
                            __label__ = 30;break $if_then8$$if_end70$12; //@line 1887 "dictionary.cpp"
                          }
                        } while(0);
  
                        var $_pr=$failed; //@line 1890 "dictionary.cpp"
                        var $tobool64=((($_pr))|0)!=0; //@line 1890 "dictionary.cpp"
                        if ($tobool64) { __label__ = 30;break $if_then8$$if_end70$12; } //@line 1890 "dictionary.cpp"
  
                        var $43=HEAP32[(($points66)>>2)]; //@line 1891 "dictionary.cpp"
                        var $inc=((($43)+1)&4294967295); //@line 1891 "dictionary.cpp"
                        HEAP32[(($points66)>>2)]=$inc; //@line 1891 "dictionary.cpp"
                        ; //@line 1891 "dictionary.cpp"
                      }
                      else if (__label__ == 32) {
  
                        var $44=$rule_addr; //@line 1894 "dictionary.cpp"
                        var $add_ptr69=(($44+2)&4294967295); //@line 1894 "dictionary.cpp"
                        $rule_addr=$add_ptr69; //@line 1894 "dictionary.cpp"
                        ; //@line 1895 "dictionary.cpp"
                      }
                    }
                    else if (__label__ == 33) {
  
                      $add_points=0; //@line 1900 "dictionary.cpp"
                      var $45=$match_type; //@line 1902 "dictionary.cpp"
                      if ($45 == 0) {
                        __label__ = 34;;
                      }
                      else if ($45 == 2) {
                        __label__ = 41;;
                      }
                      else if ($45 == 1) {
                        __label__ = 119;;
                      }
                      else {
                      __label__ = 181;;
                      }
                      
                      $sw_epilog496$$sw_bb71$$sw_bb89$$sw_bb328$44: do { 
                        if (__label__ == 34) {
  
                          var $46=$letter; //@line 1906 "dictionary.cpp"
                          $last_letter=$46; //@line 1906 "dictionary.cpp"
                          var $47=$post_ptr; //@line 1907 "dictionary.cpp"
                          var $incdec_ptr72=(($47+1)&4294967295); //@line 1907 "dictionary.cpp"
                          $post_ptr=$incdec_ptr72; //@line 1907 "dictionary.cpp"
                          var $48=HEAP8[($47)]; //@line 1907 "dictionary.cpp"
                          $letter=$48; //@line 1907 "dictionary.cpp"
                          var $49=$letter; //@line 1909 "dictionary.cpp"
                          var $conv73=((($49))&255); //@line 1909 "dictionary.cpp"
                          var $50=$rb; //@line 1909 "dictionary.cpp"
                          var $conv74=((($50))&255); //@line 1909 "dictionary.cpp"
                          var $cmp75=((($conv73))|0)==((($conv74))|0); //@line 1909 "dictionary.cpp"
                          if ($cmp75) { __label__ = 37;; } else { __label__ = 35;; } //@line 1909 "dictionary.cpp"
                          $if_then80$$lor_lhs_false$46: do { 
                            if (__label__ == 35) {
  
                              var $51=$letter; //@line 1909 "dictionary.cpp"
                              var $conv76=((($51))&255); //@line 1909 "dictionary.cpp"
                              var $cmp77=((($conv76))|0)==69; //@line 1909 "dictionary.cpp"
                              if ($cmp77) { __label__ = 36;; } else { __label__ = 40;; } //@line 1909 "dictionary.cpp"
                              if (__label__ == 36) {
  
                                var $52=$rb; //@line 1909 "dictionary.cpp"
                                var $conv78=((($52))&255); //@line 1909 "dictionary.cpp"
                                var $cmp79=((($conv78))|0)==101; //@line 1909 "dictionary.cpp"
                                if ($cmp79) { __label__ = 37;break $if_then80$$lor_lhs_false$46; } //@line 1909 "dictionary.cpp"
                              }
  
                              $failed=1; //@line 1916 "dictionary.cpp"
                              __label__ = 30;break $if_then8$$if_end70$12;
                            }
                          } while(0);
  
                          var $53=$letter; //@line 1911 "dictionary.cpp"
                          var $conv81=((($53))&255); //@line 1911 "dictionary.cpp"
                          var $and82=($conv81) & 192; //@line 1911 "dictionary.cpp"
                          var $cmp83=((($and82))|0)!=128; //@line 1911 "dictionary.cpp"
                          if ($cmp83) { __label__ = 38;; } else { __label__ = 39;; } //@line 1911 "dictionary.cpp"
                          if (__label__ == 38) {
  
                            $add_points=21; //@line 1912 "dictionary.cpp"
                            ; //@line 1912 "dictionary.cpp"
                          }
  
                          var $54=$consumed; //@line 1913 "dictionary.cpp"
                          var $inc86=((($54)+1)&4294967295); //@line 1913 "dictionary.cpp"
                          $consumed=$inc86; //@line 1913 "dictionary.cpp"
                          ; //@line 1914 "dictionary.cpp"
                        }
                        else if (__label__ == 41) {
  
                          var $55=$distance_right; //@line 1922 "dictionary.cpp"
                          var $add=((($55)+6)&4294967295); //@line 1922 "dictionary.cpp"
                          $distance_right=$add; //@line 1922 "dictionary.cpp"
                          var $56=$distance_right; //@line 1923 "dictionary.cpp"
                          var $cmp90=((($56))|0) > 18; //@line 1923 "dictionary.cpp"
                          if ($cmp90) { __label__ = 42;; } else { __label__ = 43;; } //@line 1923 "dictionary.cpp"
                          if (__label__ == 42) {
  
                            $distance_right=19; //@line 1924 "dictionary.cpp"
                            ; //@line 1924 "dictionary.cpp"
                          }
  
                          var $57=$letter; //@line 1925 "dictionary.cpp"
                          $last_letter=$57; //@line 1925 "dictionary.cpp"
                          var $58=$post_ptr; //@line 1926 "dictionary.cpp"
                          var $call=__Z7utf8_inPiPKc($letter_w, $58); //@line 1926 "dictionary.cpp"
                          var $sub93=((($call)-1)&4294967295); //@line 1926 "dictionary.cpp"
                          $letter_xbytes=$sub93; //@line 1926 "dictionary.cpp"
                          var $59=$post_ptr; //@line 1927 "dictionary.cpp"
                          var $incdec_ptr94=(($59+1)&4294967295); //@line 1927 "dictionary.cpp"
                          $post_ptr=$incdec_ptr94; //@line 1927 "dictionary.cpp"
                          var $60=HEAP8[($59)]; //@line 1927 "dictionary.cpp"
                          $letter=$60; //@line 1927 "dictionary.cpp"
                          var $61=$rb; //@line 1929 "dictionary.cpp"
                          var $conv95=((($61))&255); //@line 1929 "dictionary.cpp"
                          if ($conv95 == 17) {
                            __label__ = 44;;
                          }
                          else if ($conv95 == 18) {
                            __label__ = 49;;
                          }
                          else if ($conv95 == 25) {
                            __label__ = 52;;
                          }
                          else if ($conv95 == 15) {
                            __label__ = 57;;
                          }
                          else if ($conv95 == 16) {
                            __label__ = 62;;
                          }
                          else if ($conv95 == 11) {
                            __label__ = 65;;
                          }
                          else if ($conv95 == 28) {
                            __label__ = 68;;
                          }
                          else if ($conv95 == 45) {
                            __label__ = 78;;
                          }
                          else if ($conv95 == 21) {
                            __label__ = 83;;
                          }
                          else if ($conv95 == 29) {
                            __label__ = 94;;
                          }
                          else if ($conv95 == 23) {
                            __label__ = 101;;
                          }
                          else if ($conv95 == 12) {
                            __label__ = 105;;
                          }
                          else if ($conv95 == 13) {
                            __label__ = 106;;
                          }
                          else if ($conv95 == 14) {
                            __label__ = 111;;
                          }
                          else if ($conv95 == 24) {
                            __label__ = 112;;
                          }
                          else {
                          __label__ = 115;;
                          }
                          
                          if (__label__ == 115) {
  
                            var $186=$letter; //@line 2141 "dictionary.cpp"
                            var $conv315=((($186))&255); //@line 2141 "dictionary.cpp"
                            var $187=$rb; //@line 2141 "dictionary.cpp"
                            var $conv316=((($187))&255); //@line 2141 "dictionary.cpp"
                            var $cmp317=((($conv315))|0)==((($conv316))|0); //@line 2141 "dictionary.cpp"
                            if ($cmp317) { __label__ = 116;; } else { __label__ = 118;; } //@line 2141 "dictionary.cpp"
                            if (__label__ == 116) {
  
                              var $188=$letter; //@line 2143 "dictionary.cpp"
                              var $conv319=((($188))&255); //@line 2143 "dictionary.cpp"
                              var $and320=($conv319) & 192; //@line 2143 "dictionary.cpp"
                              var $cmp321=((($and320))|0)!=128; //@line 2143 "dictionary.cpp"
                              if (!($cmp321)) { __label__ = 181;break $sw_epilog496$$sw_bb71$$sw_bb89$$sw_bb328$44; } //@line 2143 "dictionary.cpp"
  
                              var $189=$distance_right; //@line 2146 "dictionary.cpp"
                              var $sub323=((21-($189))&4294967295); //@line 2146 "dictionary.cpp"
                              $add_points=$sub323; //@line 2146 "dictionary.cpp"
                              ; //@line 2147 "dictionary.cpp"
                            }
                            else if (__label__ == 118) {
  
                              $failed=1; //@line 2150 "dictionary.cpp"
                              __label__ = 30;break $if_then8$$if_end70$12;
                            }
                          }
                          else if (__label__ == 44) {
  
                            var $62=$rule_addr; //@line 1932 "dictionary.cpp"
                            var $incdec_ptr97=(($62+1)&4294967295); //@line 1932 "dictionary.cpp"
                            $rule_addr=$incdec_ptr97; //@line 1932 "dictionary.cpp"
                            var $63=HEAP8[($62)]; //@line 1932 "dictionary.cpp"
                            var $conv98=(tempInt=(($63)),(tempInt>=128?tempInt-256:tempInt)); //@line 1932 "dictionary.cpp"
                            var $sub99=((($conv98)-65)&4294967295); //@line 1932 "dictionary.cpp"
                            $letter_group=$sub99; //@line 1932 "dictionary.cpp"
                            var $64=$tr_addr; //@line 1933 "dictionary.cpp"
                            var $65=HEAP32[(($letter_w)>>2)]; //@line 1933 "dictionary.cpp"
                            var $66=$letter_group; //@line 1933 "dictionary.cpp"
                            var $call100=__ZL8IsLetterP10Translatorii($64, $65, $66); //@line 1933 "dictionary.cpp"
                            var $tobool101=((($call100))|0)!=0; //@line 1933 "dictionary.cpp"
                            if ($tobool101) { __label__ = 45;; } else { __label__ = 48;; } //@line 1933 "dictionary.cpp"
                            if (__label__ == 45) {
  
                              $lg_pts=20; //@line 1935 "dictionary.cpp"
                              var $67=$letter_group; //@line 1936 "dictionary.cpp"
                              var $cmp103=((($67))|0)==2; //@line 1936 "dictionary.cpp"
                              if ($cmp103) { __label__ = 46;; } else { __label__ = 47;; } //@line 1936 "dictionary.cpp"
                              if (__label__ == 46) {
  
                                $lg_pts=19; //@line 1937 "dictionary.cpp"
                                ; //@line 1937 "dictionary.cpp"
                              }
  
                              var $68=$lg_pts; //@line 1938 "dictionary.cpp"
                              var $69=$distance_right; //@line 1938 "dictionary.cpp"
                              var $sub106=((($68)-($69))&4294967295); //@line 1938 "dictionary.cpp"
                              $add_points=$sub106; //@line 1938 "dictionary.cpp"
                              var $70=$letter_xbytes; //@line 1939 "dictionary.cpp"
                              var $71=$post_ptr; //@line 1939 "dictionary.cpp"
                              var $add_ptr107=(($71+$70)&4294967295); //@line 1939 "dictionary.cpp"
                              $post_ptr=$add_ptr107; //@line 1939 "dictionary.cpp"
                              ; //@line 1940 "dictionary.cpp"
                            }
                            else if (__label__ == 48) {
  
                              $failed=1; //@line 1942 "dictionary.cpp"
                              __label__ = 30;break $if_then8$$if_end70$12;
                            }
                          }
                          else if (__label__ == 49) {
  
                            var $72=$rule_addr; //@line 1946 "dictionary.cpp"
                            var $incdec_ptr111=(($72+1)&4294967295); //@line 1946 "dictionary.cpp"
                            $rule_addr=$incdec_ptr111; //@line 1946 "dictionary.cpp"
                            var $73=HEAP8[($72)]; //@line 1946 "dictionary.cpp"
                            var $conv112=(tempInt=(($73)),(tempInt>=128?tempInt-256:tempInt)); //@line 1946 "dictionary.cpp"
                            var $sub113=((($conv112)-65)&4294967295); //@line 1946 "dictionary.cpp"
                            $letter_group=$sub113; //@line 1946 "dictionary.cpp"
                            var $74=$tr_addr; //@line 1947 "dictionary.cpp"
                            var $75=$post_ptr; //@line 1947 "dictionary.cpp"
                            var $add_ptr114=(($75+-1)&4294967295); //@line 1947 "dictionary.cpp"
                            var $76=$letter_group; //@line 1947 "dictionary.cpp"
                            var $call115=__ZL13IsLetterGroupP10TranslatorPcii($74, $add_ptr114, $76, 0); //@line 1947 "dictionary.cpp"
                            $n_bytes=$call115; //@line 1947 "dictionary.cpp"
                            var $cmp116=((($call115))|0) > 0; //@line 1947 "dictionary.cpp"
                            if ($cmp116) { __label__ = 50;; } else { __label__ = 51;; } //@line 1947 "dictionary.cpp"
                            if (__label__ == 50) {
  
                              var $77=$distance_right; //@line 1949 "dictionary.cpp"
                              var $sub118=((20-($77))&4294967295); //@line 1949 "dictionary.cpp"
                              $add_points=$sub118; //@line 1949 "dictionary.cpp"
                              var $78=$n_bytes; //@line 1950 "dictionary.cpp"
                              var $sub119=((($78)-1)&4294967295); //@line 1950 "dictionary.cpp"
                              var $79=$post_ptr; //@line 1950 "dictionary.cpp"
                              var $add_ptr120=(($79+$sub119)&4294967295); //@line 1950 "dictionary.cpp"
                              $post_ptr=$add_ptr120; //@line 1950 "dictionary.cpp"
                              ; //@line 1951 "dictionary.cpp"
                            }
                            else if (__label__ == 51) {
  
                              $failed=1; //@line 1953 "dictionary.cpp"
                              __label__ = 30;break $if_then8$$if_end70$12;
                            }
                          }
                          else if (__label__ == 52) {
  
                            var $80=$tr_addr; //@line 1957 "dictionary.cpp"
                            var $81=HEAP32[(($letter_w)>>2)]; //@line 1957 "dictionary.cpp"
                            var $call124=__ZL8IsLetterP10Translatorii($80, $81, 0); //@line 1957 "dictionary.cpp"
                            var $tobool125=((($call124))|0)!=0; //@line 1957 "dictionary.cpp"
                            if ($tobool125) { __label__ = 55;; } else { __label__ = 53;; } //@line 1957 "dictionary.cpp"
                            $if_then131$$lor_lhs_false126$77: do { 
                              if (__label__ == 53) {
  
                                var $82=HEAP32[(($letter_w)>>2)]; //@line 1957 "dictionary.cpp"
                                var $cmp127=((($82))|0)==32; //@line 1957 "dictionary.cpp"
                                if ($cmp127) { __label__ = 54;; } else { __label__ = 56;; } //@line 1957 "dictionary.cpp"
                                if (__label__ == 54) {
  
                                  var $83=$word_flags_addr; //@line 1957 "dictionary.cpp"
                                  var $and129=($83) & 134217728; //@line 1957 "dictionary.cpp"
                                  var $tobool130=((($and129))|0)!=0; //@line 1957 "dictionary.cpp"
                                  if ($tobool130) { __label__ = 55;break $if_then131$$lor_lhs_false126$77; } //@line 1957 "dictionary.cpp"
                                }
  
                                var $84=$distance_right; //@line 1963 "dictionary.cpp"
                                var $sub133=((20-($84))&4294967295); //@line 1963 "dictionary.cpp"
                                $add_points=$sub133; //@line 1963 "dictionary.cpp"
                                var $85=$letter_xbytes; //@line 1964 "dictionary.cpp"
                                var $86=$post_ptr; //@line 1964 "dictionary.cpp"
                                var $add_ptr134=(($86+$85)&4294967295); //@line 1964 "dictionary.cpp"
                                $post_ptr=$add_ptr134; //@line 1964 "dictionary.cpp"
                                __label__ = 181;break $sw_epilog496$$sw_bb71$$sw_bb89$$sw_bb328$44;
                              }
                            } while(0);
  
                            $failed=1; //@line 1959 "dictionary.cpp"
                            __label__ = 30;break $if_then8$$if_end70$12; //@line 1960 "dictionary.cpp"
                          }
                          else if (__label__ == 57) {
  
                            var $87=HEAP32[(($letter_w)>>2)]; //@line 1969 "dictionary.cpp"
                            var $call137=__Z7IsDigitj($87); //@line 1969 "dictionary.cpp"
                            var $tobool138=((($call137))|0)!=0; //@line 1969 "dictionary.cpp"
                            if ($tobool138) { __label__ = 58;; } else { __label__ = 59;; } //@line 1969 "dictionary.cpp"
                            if (__label__ == 58) {
  
                              var $88=$distance_right; //@line 1971 "dictionary.cpp"
                              var $sub140=((20-($88))&4294967295); //@line 1971 "dictionary.cpp"
                              $add_points=$sub140; //@line 1971 "dictionary.cpp"
                              var $89=$letter_xbytes; //@line 1972 "dictionary.cpp"
                              var $90=$post_ptr; //@line 1972 "dictionary.cpp"
                              var $add_ptr141=(($90+$89)&4294967295); //@line 1972 "dictionary.cpp"
                              $post_ptr=$add_ptr141; //@line 1972 "dictionary.cpp"
                              ; //@line 1973 "dictionary.cpp"
                            }
                            else if (__label__ == 59) {
  
                              var $91=$tr_addr; //@line 1975 "dictionary.cpp"
                              var $langopts=(($91)&4294967295); //@line 1975 "dictionary.cpp"
                              var $tone_numbers=(($langopts+250)&4294967295); //@line 1975 "dictionary.cpp"
                              var $92=HEAP8[($tone_numbers)]; //@line 1975 "dictionary.cpp"
                              var $tobool143=(tempInt=(($92)),(tempInt>=128?tempInt-256:tempInt))!=0; //@line 1975 "dictionary.cpp"
                              if ($tobool143) { __label__ = 60;; } else { __label__ = 61;; } //@line 1975 "dictionary.cpp"
                              if (__label__ == 60) {
  
                                var $93=$distance_right; //@line 1978 "dictionary.cpp"
                                var $sub145=((20-($93))&4294967295); //@line 1978 "dictionary.cpp"
                                $add_points=$sub145; //@line 1978 "dictionary.cpp"
                                var $94=$post_ptr; //@line 1979 "dictionary.cpp"
                                var $incdec_ptr146=(($94+-1)&4294967295); //@line 1979 "dictionary.cpp"
                                $post_ptr=$incdec_ptr146; //@line 1979 "dictionary.cpp"
                                ; //@line 1980 "dictionary.cpp"
                              }
                              else if (__label__ == 61) {
  
                                $failed=1; //@line 1982 "dictionary.cpp"
                                __label__ = 30;break $if_then8$$if_end70$12;
                              }
                            }
                          }
                          else if (__label__ == 62) {
  
                            var $95=HEAP32[(($letter_w)>>2)]; //@line 1986 "dictionary.cpp"
                            var $call151=_iswalpha($95); //@line 1986 "dictionary.cpp"
                            var $tobool152=((($call151))|0)!=0; //@line 1986 "dictionary.cpp"
                            if ($tobool152) { __label__ = 64;; } else { __label__ = 63;; } //@line 1986 "dictionary.cpp"
                            if (__label__ == 64) {
  
                              $failed=1; //@line 1992 "dictionary.cpp"
                              __label__ = 30;break $if_then8$$if_end70$12;
                            }
                            else if (__label__ == 63) {
  
                              var $96=$distance_right; //@line 1988 "dictionary.cpp"
                              var $sub154=((21-($96))&4294967295); //@line 1988 "dictionary.cpp"
                              $add_points=$sub154; //@line 1988 "dictionary.cpp"
                              var $97=$letter_xbytes; //@line 1989 "dictionary.cpp"
                              var $98=$post_ptr; //@line 1989 "dictionary.cpp"
                              var $add_ptr155=(($98+$97)&4294967295); //@line 1989 "dictionary.cpp"
                              $post_ptr=$add_ptr155; //@line 1989 "dictionary.cpp"
                              ; //@line 1990 "dictionary.cpp"
                            }
                          }
                          else if (__label__ == 65) {
  
                            var $99=$letter; //@line 1996 "dictionary.cpp"
                            var $conv159=((($99))&255); //@line 1996 "dictionary.cpp"
                            var $100=$last_letter; //@line 1996 "dictionary.cpp"
                            var $conv160=((($100))&255); //@line 1996 "dictionary.cpp"
                            var $cmp161=((($conv159))|0)==((($conv160))|0); //@line 1996 "dictionary.cpp"
                            if ($cmp161) { __label__ = 66;; } else { __label__ = 67;; } //@line 1996 "dictionary.cpp"
                            if (__label__ == 66) {
  
                              var $101=$distance_right; //@line 1997 "dictionary.cpp"
                              var $sub163=((21-($101))&4294967295); //@line 1997 "dictionary.cpp"
                              $add_points=$sub163; //@line 1997 "dictionary.cpp"
                              ; //@line 1997 "dictionary.cpp"
                            }
                            else if (__label__ == 67) {
  
                              $failed=1; //@line 1999 "dictionary.cpp"
                              __label__ = 30;break $if_then8$$if_end70$12;
                            }
                          }
                          else if (__label__ == 68) {
  
                            var $102=$rule_addr; //@line 2003 "dictionary.cpp"
                            var $incdec_ptr167=(($102+1)&4294967295); //@line 2003 "dictionary.cpp"
                            $rule_addr=$incdec_ptr167; //@line 2003 "dictionary.cpp"
                            var $103=HEAP8[($102)]; //@line 2003 "dictionary.cpp"
                            var $conv168=(tempInt=(($103)),(tempInt>=128?tempInt-256:tempInt)); //@line 2003 "dictionary.cpp"
                            $command=$conv168; //@line 2003 "dictionary.cpp"
                            var $104=$command; //@line 2004 "dictionary.cpp"
                            var $cmp169=((($104))|0)==1; //@line 2004 "dictionary.cpp"
                            if ($cmp169) { __label__ = 69;; } else { __label__ = 70;; } //@line 2004 "dictionary.cpp"
                            if (__label__ == 69) {
  
                              HEAP32[(($end_type171)>>2)]=32768; //@line 2006 "dictionary.cpp"
                              ; //@line 2007 "dictionary.cpp"
                            }
                            else if (__label__ == 70) {
  
                              var $105=$command; //@line 2009 "dictionary.cpp"
                              var $and173=($105) & 240; //@line 2009 "dictionary.cpp"
                              var $cmp174=((($and173))|0)==16; //@line 2009 "dictionary.cpp"
                              if ($cmp174) { __label__ = 71;; } else { __label__ = 74;; } //@line 2009 "dictionary.cpp"
                              if (__label__ == 71) {
  
                                var $106=$dict_flags_addr; //@line 2012 "dictionary.cpp"
                                var $107=$command; //@line 2012 "dictionary.cpp"
                                var $and176=($107) & 15; //@line 2012 "dictionary.cpp"
                                var $add177=((($and176)+19)&4294967295); //@line 2012 "dictionary.cpp"
                                var $shl178=1 << ($add177); //@line 2012 "dictionary.cpp"
                                var $and179=($shl178) & ($106); //@line 2012 "dictionary.cpp"
                                var $tobool180=((($and179))|0)!=0; //@line 2012 "dictionary.cpp"
                                if ($tobool180) { __label__ = 72;; } else { __label__ = 73;; } //@line 2012 "dictionary.cpp"
                                if (__label__ == 72) {
  
                                  $add_points=23; //@line 2013 "dictionary.cpp"
                                  ; //@line 2013 "dictionary.cpp"
                                }
                                else if (__label__ == 73) {
  
                                  $failed=1; //@line 2015 "dictionary.cpp"
                                  __label__ = 30;break $if_then8$$if_end70$12;
                                }
                              }
                              else if (__label__ == 74) {
  
                                var $108=$command; //@line 2018 "dictionary.cpp"
                                var $and185=($108) & 240; //@line 2018 "dictionary.cpp"
                                var $cmp186=((($and185))|0)==32; //@line 2018 "dictionary.cpp"
                                if (!($cmp186)) { __label__ = 181;break $sw_epilog496$$sw_bb71$$sw_bb89$$sw_bb328$44; } //@line 2018 "dictionary.cpp"
  
                                var $109=$word_addr; //@line 2022 "dictionary.cpp"
                                var $110=HEAP32[(($109)>>2)]; //@line 2022 "dictionary.cpp"
                                var $111=$word_start_addr; //@line 2022 "dictionary.cpp"
                                var $sub_ptr_lhs_cast=($110); //@line 2022 "dictionary.cpp"
                                var $sub_ptr_rhs_cast=($111); //@line 2022 "dictionary.cpp"
                                var $sub_ptr_rhs_cast_neg=(((-($sub_ptr_rhs_cast)))&4294967295);
                                var $112=$consumed; //@line 2022 "dictionary.cpp"
                                var $113=$group_length_addr; //@line 2022 "dictionary.cpp"
                                var $sub_ptr_sub=((($sub_ptr_lhs_cast)+1)&4294967295); //@line 2022 "dictionary.cpp"
                                var $add188=((($sub_ptr_sub)+($112))&4294967295); //@line 2022 "dictionary.cpp"
                                var $add189=((($add188)+($sub_ptr_rhs_cast_neg))&4294967295); //@line 2022 "dictionary.cpp"
                                var $add190=((($add189)+($113))&4294967295); //@line 2022 "dictionary.cpp"
                                $ix=$add190; //@line 2022 "dictionary.cpp"
                                var $114=$word_start_addr; //@line 2023 "dictionary.cpp"
                                var $add_ptr191=(($114+-1)&4294967295); //@line 2023 "dictionary.cpp"
                                var $115=$ix; //@line 2023 "dictionary.cpp"
                                var $src$, $dest$, $stop$, $stop4$, $fast$;
                                $src$ = $add_ptr191;
                                $dest$ = $arraydecay;
                                $stop$ = $src$ + $115;
                                if (($dest$%4) == ($src$%4) && $115 > 8) {
                                  while ($src$%4 !== 0 && $src$ < $stop$) {
                                    ; HEAP8[$dest$++] = HEAP8[$src$++];
                                  }
                                  $src$ >>= 2;
                                  $dest$ >>= 2;
                                  $stop4$ = $stop$ >> 2;
                                  while ($src$ < $stop4$) {
                                ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
                                  }
                                  $src$ <<= 2;
                                  $dest$ <<= 2;
                                }while ($src$ < $stop$) {
                                  ; HEAP8[$dest$++] = HEAP8[$src$++];
                                }; //@line 2023 "dictionary.cpp"
                                var $116=$ix; //@line 2024 "dictionary.cpp"
                                var $arrayidx192=(($word_buf+$116)&4294967295); //@line 2024 "dictionary.cpp"
                                HEAP8[($arrayidx192)]=32; //@line 2024 "dictionary.cpp"
                                var $117=$ix; //@line 2025 "dictionary.cpp"
                                var $add193=((($117)+1)&4294967295); //@line 2025 "dictionary.cpp"
                                var $arrayidx194=(($word_buf+$add193)&4294967295); //@line 2025 "dictionary.cpp"
                                HEAP8[($arrayidx194)]=0; //@line 2025 "dictionary.cpp"
                                var $118=$tr_addr; //@line 2027 "dictionary.cpp"
                                var $call196=__Z11LookupFlagsP10TranslatorPKc($118, $arrayidx195); //@line 2027 "dictionary.cpp"
                                var $119=$command; //@line 2027 "dictionary.cpp"
                                var $and197=($119) & 15; //@line 2027 "dictionary.cpp"
                                var $add198=((($and197)+19)&4294967295); //@line 2027 "dictionary.cpp"
                                var $shl199=1 << ($add198); //@line 2027 "dictionary.cpp"
                                var $and200=($shl199) & ($call196); //@line 2027 "dictionary.cpp"
                                var $tobool201=((($and200))|0)!=0; //@line 2027 "dictionary.cpp"
                                if ($tobool201) { __label__ = 76;; } else { __label__ = 77;; } //@line 2027 "dictionary.cpp"
                                if (__label__ == 76) {
  
                                  $add_points=23; //@line 2028 "dictionary.cpp"
                                  ; //@line 2028 "dictionary.cpp"
                                }
                                else if (__label__ == 77) {
  
                                  $failed=1; //@line 2030 "dictionary.cpp"
                                  __label__ = 30;break $if_then8$$if_end70$12;
                                }
                              }
                            }
                          }
                          else if (__label__ == 78) {
  
                            var $120=$letter; //@line 2035 "dictionary.cpp"
                            var $conv209=((($120))&255); //@line 2035 "dictionary.cpp"
                            var $cmp210=((($conv209))|0)==45; //@line 2035 "dictionary.cpp"
                            if ($cmp210) { __label__ = 81;; } else { __label__ = 79;; } //@line 2035 "dictionary.cpp"
                            $if_then217$$lor_lhs_false211$113: do { 
                              if (__label__ == 79) {
  
                                var $121=$letter; //@line 2035 "dictionary.cpp"
                                var $conv212=((($121))&255); //@line 2035 "dictionary.cpp"
                                var $cmp213=((($conv212))|0)==32; //@line 2035 "dictionary.cpp"
                                if ($cmp213) { __label__ = 80;; } else { __label__ = 82;; } //@line 2035 "dictionary.cpp"
                                if (__label__ == 80) {
  
                                  var $122=$word_flags_addr; //@line 2035 "dictionary.cpp"
                                  var $and215=($122) & 16384; //@line 2035 "dictionary.cpp"
                                  var $tobool216=((($and215))|0)!=0; //@line 2035 "dictionary.cpp"
                                  if ($tobool216) { __label__ = 81;break $if_then217$$lor_lhs_false211$113; } //@line 2035 "dictionary.cpp"
                                }
  
                                $failed=1; //@line 2040 "dictionary.cpp"
                                __label__ = 30;break $if_then8$$if_end70$12;
                              }
                            } while(0);
  
                            var $123=$distance_right; //@line 2037 "dictionary.cpp"
                            var $sub218=((22-($123))&4294967295); //@line 2037 "dictionary.cpp"
                            $add_points=$sub218; //@line 2037 "dictionary.cpp"
                            ; //@line 2038 "dictionary.cpp"
                          }
                          else if (__label__ == 83) {
  
                            var $124=$post_ptr; //@line 2046 "dictionary.cpp"
                            var $125=$letter_xbytes; //@line 2046 "dictionary.cpp"
                            var $add_ptr223=(($124+$125)&4294967295); //@line 2046 "dictionary.cpp"
                            $p222=$add_ptr223; //@line 2046 "dictionary.cpp"
                            $vowel_count=0; //@line 2047 "dictionary.cpp"
                            $syllable_count=1; //@line 2049 "dictionary.cpp"
                            var $126=$rule_addr; //@line 2050 "dictionary.cpp"
                            var $127=HEAP8[($126)]; //@line 2050 "dictionary.cpp"
                            var $conv22514=(tempInt=(($127)),(tempInt>=128?tempInt-256:tempInt)); //@line 2050 "dictionary.cpp"
                            var $cmp22615=((($conv22514))|0)==21; //@line 2050 "dictionary.cpp"
                            if ($cmp22615) { __label__ = 84;; } else { __label__ = 85;; } //@line 2050 "dictionary.cpp"
                            $while_body227$$while_end230$120: do { 
                              if (__label__ == 84) {
                                while(1) { 
  
                                  var $128=$rule_addr; //@line 2052 "dictionary.cpp"
                                  var $incdec_ptr228=(($128+1)&4294967295); //@line 2052 "dictionary.cpp"
                                  $rule_addr=$incdec_ptr228; //@line 2052 "dictionary.cpp"
                                  var $129=$syllable_count; //@line 2053 "dictionary.cpp"
                                  var $add229=((($129)+1)&4294967295); //@line 2053 "dictionary.cpp"
                                  $syllable_count=$add229; //@line 2053 "dictionary.cpp"
                                  var $130=$rule_addr; //@line 2050 "dictionary.cpp"
                                  var $131=HEAP8[($130)]; //@line 2050 "dictionary.cpp"
                                  var $conv225=(tempInt=(($131)),(tempInt>=128?tempInt-256:tempInt)); //@line 2050 "dictionary.cpp"
                                  var $cmp226=((($conv225))|0)==21; //@line 2050 "dictionary.cpp"
                                  if ($cmp226) { __label__ = 84;continue ; } else { __label__ = 85;break $while_body227$$while_end230$120; } //@line 2050 "dictionary.cpp"
                                }
                              }
                            } while(0);
  
                            $vowel=0; //@line 2055 "dictionary.cpp"
                            var $132=HEAP32[(($letter_w)>>2)]; //@line 2056 "dictionary.cpp"
                            var $cmp23216=((($132))|0)!=32; //@line 2056 "dictionary.cpp"
                            if ($cmp23216) { __lastLabel__ = 85; __label__ = 87;; } else { __lastLabel__ = 85; __label__ = 91;; } //@line 2056 "dictionary.cpp"
                            $while_body233$$while_end244$124: do { 
                              if (__label__ == 87) {
                                $while_body233$125: while(1) { 
  
                                  var $133=__lastLabel__ == 86 ? $_pr24 : (0); //@line 2058 "dictionary.cpp"
                                  var $cmp234=((($133))|0)==0; //@line 2058 "dictionary.cpp"
                                  if ($cmp234) { __label__ = 88;; } else { __label__ = 90;; } //@line 2058 "dictionary.cpp"
                                  $land_lhs_true235$$if_end240$127: do { 
                                    if (__label__ == 88) {
  
                                      var $134=$tr_addr; //@line 2058 "dictionary.cpp"
                                      var $135=HEAP32[(($letter_w)>>2)]; //@line 2058 "dictionary.cpp"
                                      var $call236=__ZL8IsLetterP10Translatorii($134, $135, 7); //@line 2058 "dictionary.cpp"
                                      var $tobool237=((($call236))|0)!=0; //@line 2058 "dictionary.cpp"
                                      if (!($tobool237)) { __label__ = 90;break $land_lhs_true235$$if_end240$127; } //@line 2058 "dictionary.cpp"
  
                                      var $136=$vowel_count; //@line 2061 "dictionary.cpp"
                                      var $inc239=((($136)+1)&4294967295); //@line 2061 "dictionary.cpp"
                                      $vowel_count=$inc239; //@line 2061 "dictionary.cpp"
                                      ; //@line 2062 "dictionary.cpp"
                                    }
                                  } while(0);
  
                                  var $137=$tr_addr; //@line 2063 "dictionary.cpp"
                                  var $138=HEAP32[(($letter_w)>>2)]; //@line 2063 "dictionary.cpp"
                                  var $call241=__ZL8IsLetterP10Translatorii($137, $138, 7); //@line 2063 "dictionary.cpp"
                                  $vowel=$call241; //@line 2063 "dictionary.cpp"
                                  var $139=$p222; //@line 2064 "dictionary.cpp"
                                  var $call242=__Z7utf8_inPiPKc($letter_w, $139); //@line 2064 "dictionary.cpp"
                                  var $140=$p222; //@line 2064 "dictionary.cpp"
                                  var $add_ptr243=(($140+$call242)&4294967295); //@line 2064 "dictionary.cpp"
                                  $p222=$add_ptr243; //@line 2064 "dictionary.cpp"
                                  var $141=HEAP32[(($letter_w)>>2)]; //@line 2056 "dictionary.cpp"
                                  var $cmp232=((($141))|0)!=32; //@line 2056 "dictionary.cpp"
                                  if (!($cmp232)) { __label__ = 91;break $while_body233$$while_end244$124; } //@line 2056 "dictionary.cpp"
  
                                  var $_pr24=$vowel; //@line 2058 "dictionary.cpp"
                                  __lastLabel__ = 86; __label__ = 87;continue $while_body233$125;
                                }
                              }
                            } while(0);
  
                            var $142=$syllable_count; //@line 2066 "dictionary.cpp"
                            var $143=$vowel_count; //@line 2066 "dictionary.cpp"
                            var $cmp245=((($142))|0) <= ((($143))|0); //@line 2066 "dictionary.cpp"
                            if ($cmp245) { __label__ = 92;; } else { __label__ = 93;; } //@line 2066 "dictionary.cpp"
                            if (__label__ == 92) {
  
                              var $144=$syllable_count; //@line 2067 "dictionary.cpp"
                              var $145=$distance_right; //@line 2067 "dictionary.cpp"
                              var $_neg=(((-($145)))&4294967295);
                              var $add247=((($144)+18)&4294967295); //@line 2067 "dictionary.cpp"
                              var $sub248=((($add247)+($_neg))&4294967295); //@line 2067 "dictionary.cpp"
                              $add_points=$sub248; //@line 2067 "dictionary.cpp"
                              ; //@line 2067 "dictionary.cpp"
                            }
                            else if (__label__ == 93) {
  
                              $failed=1; //@line 2069 "dictionary.cpp"
                              __label__ = 30;break $if_then8$$if_end70$12;
                            }
                          }
                          else if (__label__ == 94) {
  
                            var $146=$post_ptr; //@line 2075 "dictionary.cpp"
                            var $147=$letter_xbytes; //@line 2075 "dictionary.cpp"
                            var $add_ptr253=(($146+$147)&4294967295); //@line 2075 "dictionary.cpp"
                            $p252=$add_ptr253; //@line 2075 "dictionary.cpp"
                            ; //@line 2076 "dictionary.cpp"
                            while(1) { 
  
                              var $148=HEAP32[(($letter_w)>>2)]; //@line 2076 "dictionary.cpp"
                              var $cmp255=((($148))|0)!=32; //@line 2076 "dictionary.cpp"
                              if (!($cmp255)) { __label__ = 99;break ; } //@line 2076 "dictionary.cpp"
  
                              var $149=$tr_addr; //@line 2078 "dictionary.cpp"
                              var $150=HEAP32[(($letter_w)>>2)]; //@line 2078 "dictionary.cpp"
                              var $call257=__ZL8IsLetterP10Translatorii($149, $150, 7); //@line 2078 "dictionary.cpp"
                              var $tobool258=((($call257))|0)!=0; //@line 2078 "dictionary.cpp"
                              if ($tobool258) { __label__ = 97;break ; } //@line 2078 "dictionary.cpp"
  
                              var $151=$p252; //@line 2083 "dictionary.cpp"
                              var $call261=__Z7utf8_inPiPKc($letter_w, $151); //@line 2083 "dictionary.cpp"
                              var $152=$p252; //@line 2083 "dictionary.cpp"
                              var $add_ptr262=(($152+$call261)&4294967295); //@line 2083 "dictionary.cpp"
                              $p252=$add_ptr262; //@line 2083 "dictionary.cpp"
                              __label__ = 95;continue ; //@line 2084 "dictionary.cpp"
                            }
                            if (__label__ == 99) {
  
                              var $_pr2=$failed; //@line 2085 "dictionary.cpp"
                              var $tobool264=((($_pr2))|0)!=0; //@line 2085 "dictionary.cpp"
                              if ($tobool264) { __label__ = 30;break $if_then8$$if_end70$12; } //@line 2085 "dictionary.cpp"
  
                              var $153=$distance_right; //@line 2086 "dictionary.cpp"
                              var $sub266=((19-($153))&4294967295); //@line 2086 "dictionary.cpp"
                              $add_points=$sub266; //@line 2086 "dictionary.cpp"
                              ; //@line 2086 "dictionary.cpp"
                            }
                            else if (__label__ == 97) {
  
                              $failed=1; //@line 2080 "dictionary.cpp"
                              __label__ = 30;break $if_then8$$if_end70$12; //@line 2085 "dictionary.cpp"
                            }
                          }
                          else if (__label__ == 101) {
  
                            var $154=$post_ptr; //@line 2095 "dictionary.cpp"
                            var $155=$letter_xbytes; //@line 2095 "dictionary.cpp"
                            var $add_ptr270=(($154+$155)&4294967295); //@line 2095 "dictionary.cpp"
                            $p269=$add_ptr270; //@line 2095 "dictionary.cpp"
                            var $156=$p269; //@line 2096 "dictionary.cpp"
                            $p2=$156; //@line 2096 "dictionary.cpp"
                            var $157=$rule_addr; //@line 2098 "dictionary.cpp"
                            var $call271=__Z7utf8_inPiPKc($rule_w, $157); //@line 2098 "dictionary.cpp"
                            var $158=HEAP32[(($letter_w)>>2)]; //@line 2099 "dictionary.cpp"
                            var $159=HEAP32[(($rule_w)>>2)]; //@line 2099 "dictionary.cpp"
                            var $cmp27317=((($158))|0)!=((($159))|0); //@line 2099 "dictionary.cpp"
                            var $160=HEAP32[(($letter_w)>>2)]; //@line 2099 "dictionary.cpp"
                            var $cmp27518=((($160))|0)!=32; //@line 2099 "dictionary.cpp"
                            var $or_cond19=($cmp27317) & ($cmp27518); //@line 2099 "dictionary.cpp"
                            if ($or_cond19) { __label__ = 102;; } else { __label__ = 103;; } //@line 2099 "dictionary.cpp"
                            $while_body277$$while_end280$146: do { 
                              if (__label__ == 102) {
                                while(1) { 
  
                                  var $161=$p269; //@line 2101 "dictionary.cpp"
                                  $p2=$161; //@line 2101 "dictionary.cpp"
                                  var $162=$p269; //@line 2102 "dictionary.cpp"
                                  var $call278=__Z7utf8_inPiPKc($letter_w, $162); //@line 2102 "dictionary.cpp"
                                  var $163=$p269; //@line 2102 "dictionary.cpp"
                                  var $add_ptr279=(($163+$call278)&4294967295); //@line 2102 "dictionary.cpp"
                                  $p269=$add_ptr279; //@line 2102 "dictionary.cpp"
                                  var $164=HEAP32[(($letter_w)>>2)]; //@line 2099 "dictionary.cpp"
                                  var $165=HEAP32[(($rule_w)>>2)]; //@line 2099 "dictionary.cpp"
                                  var $cmp273=((($164))|0)!=((($165))|0); //@line 2099 "dictionary.cpp"
                                  var $166=HEAP32[(($letter_w)>>2)]; //@line 2099 "dictionary.cpp"
                                  var $cmp275=((($166))|0)!=32; //@line 2099 "dictionary.cpp"
                                  var $or_cond=($cmp273) & ($cmp275); //@line 2099 "dictionary.cpp"
                                  if ($or_cond) { __label__ = 102;continue ; } else { __label__ = 103;break $while_body277$$while_end280$146; } //@line 2099 "dictionary.cpp"
                                }
                              }
                            } while(0);
  
                            var $167=HEAP32[(($letter_w)>>2)]; //@line 2104 "dictionary.cpp"
                            var $168=HEAP32[(($rule_w)>>2)]; //@line 2104 "dictionary.cpp"
                            var $cmp281=((($167))|0)==((($168))|0); //@line 2104 "dictionary.cpp"
                            if (!($cmp281)) { __label__ = 181;break $sw_epilog496$$sw_bb71$$sw_bb89$$sw_bb328$44; } //@line 2104 "dictionary.cpp"
  
                            var $169=$p2; //@line 2106 "dictionary.cpp"
                            $post_ptr=$169; //@line 2106 "dictionary.cpp"
                            ; //@line 2107 "dictionary.cpp"
                          }
                          else if (__label__ == 105) {
  
                            $add_points=20; //@line 2112 "dictionary.cpp"
                            ; //@line 2113 "dictionary.cpp"
                          }
                          else if (__label__ == 106) {
  
                            var $170=$word_addr; //@line 2117 "dictionary.cpp"
                            var $171=HEAP32[(($170)>>2)]; //@line 2117 "dictionary.cpp"
                            var $172=$group_length_addr; //@line 2117 "dictionary.cpp"
                            var $add_ptr286=(($171+$172)&4294967295); //@line 2117 "dictionary.cpp"
                            $p=$add_ptr286; //@line 2117 "dictionary.cpp"
                            ; //@line 2117 "dictionary.cpp"
                            while(1) { 
  
                              var $173=$p; //@line 2117 "dictionary.cpp"
                              var $174=$post_ptr; //@line 2117 "dictionary.cpp"
                              var $cmp287=((($173))>>>0) < ((($174))>>>0); //@line 2117 "dictionary.cpp"
                              if (!($cmp287)) { __label__ = 181;break $sw_epilog496$$sw_bb71$$sw_bb89$$sw_bb328$44; } //@line 2117 "dictionary.cpp"
  
                              var $175=$p; //@line 2119 "dictionary.cpp"
                              var $176=HEAP8[($175)]; //@line 2119 "dictionary.cpp"
                              var $conv288=(tempInt=(($176)),(tempInt>=128?tempInt-256:tempInt)); //@line 2119 "dictionary.cpp"
                              var $cmp289=((($conv288))|0)==101; //@line 2119 "dictionary.cpp"
                              var $177=$p; //@line 2121 "dictionary.cpp"
                              if ($cmp289) { __label__ = 109;break ; } //@line 2119 "dictionary.cpp"
  
                              var $incdec_ptr293=(($177+1)&4294967295); //@line 2117 "dictionary.cpp"
                              $p=$incdec_ptr293; //@line 2117 "dictionary.cpp"
                              __label__ = 107;continue ; //@line 2117 "dictionary.cpp"
                            }
  
                            HEAP32[(($del_fwd291)>>2)]=$177; //@line 2121 "dictionary.cpp"
                            ; //@line 2122 "dictionary.cpp"
                          }
                          else if (__label__ == 111) {
  
                            var $178=$rule_addr; //@line 2129 "dictionary.cpp"
                            var $arrayidx295=(($178)&4294967295); //@line 2129 "dictionary.cpp"
                            var $179=HEAP8[($arrayidx295)]; //@line 2129 "dictionary.cpp"
                            var $conv296=(tempInt=(($179)),(tempInt>=128?tempInt-256:tempInt)); //@line 2129 "dictionary.cpp"
                            var $shl297=((($conv296)*65536)&4294967295); //@line 2129 "dictionary.cpp"
                            var $180=$rule_addr; //@line 2129 "dictionary.cpp"
                            var $arrayidx298=(($180+1)&4294967295); //@line 2129 "dictionary.cpp"
                            var $181=HEAP8[($arrayidx298)]; //@line 2129 "dictionary.cpp"
                            var $conv299=(tempInt=(($181)),(tempInt>=128?tempInt-256:tempInt)); //@line 2129 "dictionary.cpp"
                            var $and300=($conv299) & 127; //@line 2129 "dictionary.cpp"
                            var $shl301=((($and300)*256)&4294967295); //@line 2129 "dictionary.cpp"
                            var $182=$rule_addr; //@line 2129 "dictionary.cpp"
                            var $arrayidx303=(($182+2)&4294967295); //@line 2129 "dictionary.cpp"
                            var $183=HEAP8[($arrayidx303)]; //@line 2129 "dictionary.cpp"
                            var $conv304=(tempInt=(($183)),(tempInt>=128?tempInt-256:tempInt)); //@line 2129 "dictionary.cpp"
                            var $and305=($conv304) & 127; //@line 2129 "dictionary.cpp"
                            var $add302=((($shl301)+($shl297))&4294967295); //@line 2129 "dictionary.cpp"
                            var $add306=((($add302)+($and305))&4294967295); //@line 2129 "dictionary.cpp"
                            HEAP32[(($end_type307)>>2)]=$add306; //@line 2129 "dictionary.cpp"
                            var $184=$rule_addr; //@line 2130 "dictionary.cpp"
                            var $add_ptr308=(($184+3)&4294967295); //@line 2130 "dictionary.cpp"
                            $rule_addr=$add_ptr308; //@line 2130 "dictionary.cpp"
                            ; //@line 2131 "dictionary.cpp"
                          }
                          else if (__label__ == 112) {
  
                            var $185=$word_flags_addr; //@line 2134 "dictionary.cpp"
                            var $and310=($185) & 8192; //@line 2134 "dictionary.cpp"
                            var $tobool311=((($and310))|0)!=0; //@line 2134 "dictionary.cpp"
                            if ($tobool311) { __label__ = 113;; } else { __label__ = 114;; } //@line 2134 "dictionary.cpp"
                            if (__label__ == 113) {
  
                              $failed=1; //@line 2135 "dictionary.cpp"
                              __label__ = 30;break $if_then8$$if_end70$12; //@line 2135 "dictionary.cpp"
                            }
                            else if (__label__ == 114) {
  
                              $add_points=1; //@line 2137 "dictionary.cpp"
                              ;
                            }
                          }
                        }
                        else if (__label__ == 119) {
  
                          var $190=$distance_left; //@line 2158 "dictionary.cpp"
                          var $add329=((($190)+2)&4294967295); //@line 2158 "dictionary.cpp"
                          $distance_left=$add329; //@line 2158 "dictionary.cpp"
                          var $191=$distance_left; //@line 2159 "dictionary.cpp"
                          var $cmp330=((($191))|0) > 18; //@line 2159 "dictionary.cpp"
                          if ($cmp330) { __label__ = 120;; } else { __label__ = 121;; } //@line 2159 "dictionary.cpp"
                          if (__label__ == 120) {
  
                            $distance_left=19; //@line 2160 "dictionary.cpp"
                            ; //@line 2160 "dictionary.cpp"
                          }
  
                          var $192=$pre_ptr; //@line 2162 "dictionary.cpp"
                          var $193=HEAP8[($192)]; //@line 2162 "dictionary.cpp"
                          $last_letter=$193; //@line 2162 "dictionary.cpp"
                          var $194=$pre_ptr; //@line 2163 "dictionary.cpp"
                          var $incdec_ptr333=(($194+-1)&4294967295); //@line 2163 "dictionary.cpp"
                          $pre_ptr=$incdec_ptr333; //@line 2163 "dictionary.cpp"
                          var $195=$pre_ptr; //@line 2164 "dictionary.cpp"
                          var $call334=__Z8utf8_in2PiPKci($letter_w, $195, 1); //@line 2164 "dictionary.cpp"
                          var $sub335=((($call334)-1)&4294967295); //@line 2164 "dictionary.cpp"
                          $letter_xbytes=$sub335; //@line 2164 "dictionary.cpp"
                          var $196=$pre_ptr; //@line 2165 "dictionary.cpp"
                          var $197=HEAP8[($196)]; //@line 2165 "dictionary.cpp"
                          $letter=$197; //@line 2165 "dictionary.cpp"
                          var $198=$rb; //@line 2167 "dictionary.cpp"
                          var $conv336=((($198))&255); //@line 2167 "dictionary.cpp"
                          if ($conv336 == 17) {
                            __label__ = 122;;
                          }
                          else if ($conv336 == 18) {
                            __label__ = 127;;
                          }
                          else if ($conv336 == 25) {
                            __label__ = 130;;
                          }
                          else if ($conv336 == 11) {
                            __label__ = 133;;
                          }
                          else if ($conv336 == 15) {
                            __label__ = 136;;
                          }
                          else if ($conv336 == 16) {
                            __label__ = 139;;
                          }
                          else if ($conv336 == 21) {
                            __label__ = 142;;
                          }
                          else if ($conv336 == 10) {
                            __label__ = 147;;
                          }
                          else if ($conv336 == 29) {
                            __label__ = 150;;
                          }
                          else if ($conv336 == 26) {
                            __label__ = 157;;
                          }
                          else if ($conv336 == 19) {
                            __label__ = 160;;
                          }
                          else if ($conv336 == 46) {
                            __label__ = 163;;
                          }
                          else if ($conv336 == 45) {
                            __label__ = 170;;
                          }
                          else {
                          __label__ = 175;;
                          }
                          
                          if (__label__ == 175) {
  
                            var $268=$letter; //@line 2307 "dictionary.cpp"
                            var $conv478=((($268))&255); //@line 2307 "dictionary.cpp"
                            var $269=$rb; //@line 2307 "dictionary.cpp"
                            var $conv479=((($269))&255); //@line 2307 "dictionary.cpp"
                            var $cmp480=((($conv478))|0)==((($conv479))|0); //@line 2307 "dictionary.cpp"
                            if ($cmp480) { __label__ = 176;; } else { __label__ = 180;; } //@line 2307 "dictionary.cpp"
                            if (__label__ == 176) {
  
                              var $270=$letter; //@line 2309 "dictionary.cpp"
                              var $conv482=((($270))&255); //@line 2309 "dictionary.cpp"
                              var $cmp483=((($conv482))|0)==32; //@line 2309 "dictionary.cpp"
                              if ($cmp483) { __label__ = 177;; } else { __label__ = 178;; } //@line 2309 "dictionary.cpp"
                              if (__label__ == 177) {
  
                                $add_points=4; //@line 2310 "dictionary.cpp"
                                ; //@line 2310 "dictionary.cpp"
                              }
                              else if (__label__ == 178) {
  
                                var $271=$letter; //@line 2313 "dictionary.cpp"
                                var $conv486=((($271))&255); //@line 2313 "dictionary.cpp"
                                var $and487=($conv486) & 192; //@line 2313 "dictionary.cpp"
                                var $cmp488=((($and487))|0)!=128; //@line 2313 "dictionary.cpp"
                                if (!($cmp488)) { __label__ = 181;break $sw_epilog496$$sw_bb71$$sw_bb89$$sw_bb328$44; } //@line 2313 "dictionary.cpp"
  
                                var $272=$distance_left; //@line 2316 "dictionary.cpp"
                                var $sub490=((21-($272))&4294967295); //@line 2316 "dictionary.cpp"
                                $add_points=$sub490; //@line 2316 "dictionary.cpp"
                                ; //@line 2317 "dictionary.cpp"
                              }
                            }
                            else if (__label__ == 180) {
  
                              $failed=1; //@line 2321 "dictionary.cpp"
                              __label__ = 30;break $if_then8$$if_end70$12;
                            }
                          }
                          else if (__label__ == 122) {
  
                            var $199=$rule_addr; //@line 2170 "dictionary.cpp"
                            var $incdec_ptr338=(($199+1)&4294967295); //@line 2170 "dictionary.cpp"
                            $rule_addr=$incdec_ptr338; //@line 2170 "dictionary.cpp"
                            var $200=HEAP8[($199)]; //@line 2170 "dictionary.cpp"
                            var $conv339=(tempInt=(($200)),(tempInt>=128?tempInt-256:tempInt)); //@line 2170 "dictionary.cpp"
                            var $sub340=((($conv339)-65)&4294967295); //@line 2170 "dictionary.cpp"
                            $letter_group=$sub340; //@line 2170 "dictionary.cpp"
                            var $201=$tr_addr; //@line 2171 "dictionary.cpp"
                            var $202=HEAP32[(($letter_w)>>2)]; //@line 2171 "dictionary.cpp"
                            var $203=$letter_group; //@line 2171 "dictionary.cpp"
                            var $call341=__ZL8IsLetterP10Translatorii($201, $202, $203); //@line 2171 "dictionary.cpp"
                            var $tobool342=((($call341))|0)!=0; //@line 2171 "dictionary.cpp"
                            if ($tobool342) { __label__ = 123;; } else { __label__ = 126;; } //@line 2171 "dictionary.cpp"
                            if (__label__ == 123) {
  
                              $lg_pts=20; //@line 2173 "dictionary.cpp"
                              var $204=$letter_group; //@line 2174 "dictionary.cpp"
                              var $cmp344=((($204))|0)==2; //@line 2174 "dictionary.cpp"
                              if ($cmp344) { __label__ = 124;; } else { __label__ = 125;; } //@line 2174 "dictionary.cpp"
                              if (__label__ == 124) {
  
                                $lg_pts=19; //@line 2175 "dictionary.cpp"
                                ; //@line 2175 "dictionary.cpp"
                              }
  
                              var $205=$lg_pts; //@line 2176 "dictionary.cpp"
                              var $206=$distance_left; //@line 2176 "dictionary.cpp"
                              var $sub347=((($205)-($206))&4294967295); //@line 2176 "dictionary.cpp"
                              $add_points=$sub347; //@line 2176 "dictionary.cpp"
                              var $207=$letter_xbytes; //@line 2177 "dictionary.cpp"
                              var $208=$pre_ptr; //@line 2177 "dictionary.cpp"
                              var $idx_neg=(((-($207)))&4294967295); //@line 2177 "dictionary.cpp"
                              var $add_ptr348=(($208+$idx_neg)&4294967295); //@line 2177 "dictionary.cpp"
                              $pre_ptr=$add_ptr348; //@line 2177 "dictionary.cpp"
                              ; //@line 2178 "dictionary.cpp"
                            }
                            else if (__label__ == 126) {
  
                              $failed=1; //@line 2180 "dictionary.cpp"
                              __label__ = 30;break $if_then8$$if_end70$12;
                            }
                          }
                          else if (__label__ == 127) {
  
                            var $209=$rule_addr; //@line 2184 "dictionary.cpp"
                            var $incdec_ptr352=(($209+1)&4294967295); //@line 2184 "dictionary.cpp"
                            $rule_addr=$incdec_ptr352; //@line 2184 "dictionary.cpp"
                            var $210=HEAP8[($209)]; //@line 2184 "dictionary.cpp"
                            var $conv353=(tempInt=(($210)),(tempInt>=128?tempInt-256:tempInt)); //@line 2184 "dictionary.cpp"
                            var $sub354=((($conv353)-65)&4294967295); //@line 2184 "dictionary.cpp"
                            $letter_group=$sub354; //@line 2184 "dictionary.cpp"
                            var $211=$tr_addr; //@line 2185 "dictionary.cpp"
                            var $212=$pre_ptr; //@line 2185 "dictionary.cpp"
                            var $213=$letter_group; //@line 2185 "dictionary.cpp"
                            var $call355=__ZL13IsLetterGroupP10TranslatorPcii($211, $212, $213, 1); //@line 2185 "dictionary.cpp"
                            $n_bytes=$call355; //@line 2185 "dictionary.cpp"
                            var $cmp356=((($call355))|0) > 0; //@line 2185 "dictionary.cpp"
                            if ($cmp356) { __label__ = 128;; } else { __label__ = 129;; } //@line 2185 "dictionary.cpp"
                            if (__label__ == 128) {
  
                              var $214=$distance_right; //@line 2187 "dictionary.cpp"
                              var $sub358=((20-($214))&4294967295); //@line 2187 "dictionary.cpp"
                              $add_points=$sub358; //@line 2187 "dictionary.cpp"
                              var $215=$n_bytes; //@line 2188 "dictionary.cpp"
                              var $sub359=((($215)-1)&4294967295); //@line 2188 "dictionary.cpp"
                              var $216=$pre_ptr; //@line 2188 "dictionary.cpp"
                              var $idx_neg360=(((-($sub359)))&4294967295); //@line 2188 "dictionary.cpp"
                              var $add_ptr361=(($216+$idx_neg360)&4294967295); //@line 2188 "dictionary.cpp"
                              $pre_ptr=$add_ptr361; //@line 2188 "dictionary.cpp"
                              ; //@line 2189 "dictionary.cpp"
                            }
                            else if (__label__ == 129) {
  
                              $failed=1; //@line 2191 "dictionary.cpp"
                              __label__ = 30;break $if_then8$$if_end70$12;
                            }
                          }
                          else if (__label__ == 130) {
  
                            var $217=$tr_addr; //@line 2195 "dictionary.cpp"
                            var $218=HEAP32[(($letter_w)>>2)]; //@line 2195 "dictionary.cpp"
                            var $call365=__ZL8IsLetterP10Translatorii($217, $218, 0); //@line 2195 "dictionary.cpp"
                            var $tobool366=((($call365))|0)!=0; //@line 2195 "dictionary.cpp"
                            if ($tobool366) { __label__ = 132;; } else { __label__ = 131;; } //@line 2195 "dictionary.cpp"
                            if (__label__ == 132) {
  
                              $failed=1; //@line 2201 "dictionary.cpp"
                              __label__ = 30;break $if_then8$$if_end70$12;
                            }
                            else if (__label__ == 131) {
  
                              var $219=$distance_left; //@line 2197 "dictionary.cpp"
                              var $sub368=((20-($219))&4294967295); //@line 2197 "dictionary.cpp"
                              $add_points=$sub368; //@line 2197 "dictionary.cpp"
                              var $220=$letter_xbytes; //@line 2198 "dictionary.cpp"
                              var $221=$pre_ptr; //@line 2198 "dictionary.cpp"
                              var $idx_neg369=(((-($220)))&4294967295); //@line 2198 "dictionary.cpp"
                              var $add_ptr370=(($221+$idx_neg369)&4294967295); //@line 2198 "dictionary.cpp"
                              $pre_ptr=$add_ptr370; //@line 2198 "dictionary.cpp"
                              ; //@line 2199 "dictionary.cpp"
                            }
                          }
                          else if (__label__ == 133) {
  
                            var $222=$letter; //@line 2205 "dictionary.cpp"
                            var $conv374=((($222))&255); //@line 2205 "dictionary.cpp"
                            var $223=$last_letter; //@line 2205 "dictionary.cpp"
                            var $conv375=((($223))&255); //@line 2205 "dictionary.cpp"
                            var $cmp376=((($conv374))|0)==((($conv375))|0); //@line 2205 "dictionary.cpp"
                            if ($cmp376) { __label__ = 134;; } else { __label__ = 135;; } //@line 2205 "dictionary.cpp"
                            if (__label__ == 134) {
  
                              var $224=$distance_left; //@line 2206 "dictionary.cpp"
                              var $sub378=((21-($224))&4294967295); //@line 2206 "dictionary.cpp"
                              $add_points=$sub378; //@line 2206 "dictionary.cpp"
                              ; //@line 2206 "dictionary.cpp"
                            }
                            else if (__label__ == 135) {
  
                              $failed=1; //@line 2208 "dictionary.cpp"
                              __label__ = 30;break $if_then8$$if_end70$12;
                            }
                          }
                          else if (__label__ == 136) {
  
                            var $225=HEAP32[(($letter_w)>>2)]; //@line 2212 "dictionary.cpp"
                            var $call382=__Z7IsDigitj($225); //@line 2212 "dictionary.cpp"
                            var $tobool383=((($call382))|0)!=0; //@line 2212 "dictionary.cpp"
                            if ($tobool383) { __label__ = 137;; } else { __label__ = 138;; } //@line 2212 "dictionary.cpp"
                            if (__label__ == 137) {
  
                              var $226=$distance_left; //@line 2214 "dictionary.cpp"
                              var $sub385=((21-($226))&4294967295); //@line 2214 "dictionary.cpp"
                              $add_points=$sub385; //@line 2214 "dictionary.cpp"
                              var $227=$letter_xbytes; //@line 2215 "dictionary.cpp"
                              var $228=$pre_ptr; //@line 2215 "dictionary.cpp"
                              var $idx_neg386=(((-($227)))&4294967295); //@line 2215 "dictionary.cpp"
                              var $add_ptr387=(($228+$idx_neg386)&4294967295); //@line 2215 "dictionary.cpp"
                              $pre_ptr=$add_ptr387; //@line 2215 "dictionary.cpp"
                              ; //@line 2216 "dictionary.cpp"
                            }
                            else if (__label__ == 138) {
  
                              $failed=1; //@line 2218 "dictionary.cpp"
                              __label__ = 30;break $if_then8$$if_end70$12;
                            }
                          }
                          else if (__label__ == 139) {
  
                            var $229=HEAP32[(($letter_w)>>2)]; //@line 2222 "dictionary.cpp"
                            var $call391=_iswalpha($229); //@line 2222 "dictionary.cpp"
                            var $tobool392=((($call391))|0)!=0; //@line 2222 "dictionary.cpp"
                            if ($tobool392) { __label__ = 141;; } else { __label__ = 140;; } //@line 2222 "dictionary.cpp"
                            if (__label__ == 141) {
  
                              $failed=1; //@line 2228 "dictionary.cpp"
                              __label__ = 30;break $if_then8$$if_end70$12;
                            }
                            else if (__label__ == 140) {
  
                              var $230=$distance_right; //@line 2224 "dictionary.cpp"
                              var $sub394=((21-($230))&4294967295); //@line 2224 "dictionary.cpp"
                              $add_points=$sub394; //@line 2224 "dictionary.cpp"
                              var $231=$letter_xbytes; //@line 2225 "dictionary.cpp"
                              var $232=$pre_ptr; //@line 2225 "dictionary.cpp"
                              var $idx_neg395=(((-($231)))&4294967295); //@line 2225 "dictionary.cpp"
                              var $add_ptr396=(($232+$idx_neg395)&4294967295); //@line 2225 "dictionary.cpp"
                              $pre_ptr=$add_ptr396; //@line 2225 "dictionary.cpp"
                              ; //@line 2226 "dictionary.cpp"
                            }
                          }
                          else if (__label__ == 142) {
  
                            $syllable_count=1; //@line 2233 "dictionary.cpp"
                            var $233=$rule_addr; //@line 2234 "dictionary.cpp"
                            var $234=HEAP8[($233)]; //@line 2234 "dictionary.cpp"
                            var $conv40112=(tempInt=(($234)),(tempInt>=128?tempInt-256:tempInt)); //@line 2234 "dictionary.cpp"
                            var $cmp40213=((($conv40112))|0)==21; //@line 2234 "dictionary.cpp"
                            if ($cmp40213) { __label__ = 143;; } else { __label__ = 144;; } //@line 2234 "dictionary.cpp"
                            $while_body403$$while_end406$204: do { 
                              if (__label__ == 143) {
                                while(1) { 
  
                                  var $235=$rule_addr; //@line 2236 "dictionary.cpp"
                                  var $incdec_ptr404=(($235+1)&4294967295); //@line 2236 "dictionary.cpp"
                                  $rule_addr=$incdec_ptr404; //@line 2236 "dictionary.cpp"
                                  var $236=$syllable_count; //@line 2237 "dictionary.cpp"
                                  var $inc405=((($236)+1)&4294967295); //@line 2237 "dictionary.cpp"
                                  $syllable_count=$inc405; //@line 2237 "dictionary.cpp"
                                  var $237=$rule_addr; //@line 2234 "dictionary.cpp"
                                  var $238=HEAP8[($237)]; //@line 2234 "dictionary.cpp"
                                  var $conv401=(tempInt=(($238)),(tempInt>=128?tempInt-256:tempInt)); //@line 2234 "dictionary.cpp"
                                  var $cmp402=((($conv401))|0)==21; //@line 2234 "dictionary.cpp"
                                  if ($cmp402) { __label__ = 143;continue ; } else { __label__ = 144;break $while_body403$$while_end406$204; } //@line 2234 "dictionary.cpp"
                                }
                              }
                            } while(0);
  
                            var $239=$syllable_count; //@line 2239 "dictionary.cpp"
                            var $240=$tr_addr; //@line 2239 "dictionary.cpp"
                            var $word_vowel_count=(($240+8296)&4294967295); //@line 2239 "dictionary.cpp"
                            var $241=HEAP32[(($word_vowel_count)>>2)]; //@line 2239 "dictionary.cpp"
                            var $cmp407=((($239))|0) <= ((($241))|0); //@line 2239 "dictionary.cpp"
                            if ($cmp407) { __label__ = 145;; } else { __label__ = 146;; } //@line 2239 "dictionary.cpp"
                            if (__label__ == 145) {
  
                              var $242=$syllable_count; //@line 2240 "dictionary.cpp"
                              var $243=$distance_left; //@line 2240 "dictionary.cpp"
                              var $_neg11=(((-($243)))&4294967295);
                              var $add409=((($242)+18)&4294967295); //@line 2240 "dictionary.cpp"
                              var $sub410=((($add409)+($_neg11))&4294967295); //@line 2240 "dictionary.cpp"
                              $add_points=$sub410; //@line 2240 "dictionary.cpp"
                              ; //@line 2240 "dictionary.cpp"
                            }
                            else if (__label__ == 146) {
  
                              $failed=1; //@line 2242 "dictionary.cpp"
                              __label__ = 30;break $if_then8$$if_end70$12;
                            }
                          }
                          else if (__label__ == 147) {
  
                            var $244=$tr_addr; //@line 2246 "dictionary.cpp"
                            var $word_stressed_count=(($244+8300)&4294967295); //@line 2246 "dictionary.cpp"
                            var $245=HEAP32[(($word_stressed_count)>>2)]; //@line 2246 "dictionary.cpp"
                            var $cmp414=((($245))|0) > 0; //@line 2246 "dictionary.cpp"
                            if ($cmp414) { __label__ = 148;; } else { __label__ = 149;; } //@line 2246 "dictionary.cpp"
                            if (__label__ == 148) {
  
                              $add_points=19; //@line 2247 "dictionary.cpp"
                              ; //@line 2247 "dictionary.cpp"
                            }
                            else if (__label__ == 149) {
  
                              $failed=1; //@line 2249 "dictionary.cpp"
                              __label__ = 30;break $if_then8$$if_end70$12;
                            }
                          }
                          else if (__label__ == 150) {
  
                            var $246=$pre_ptr; //@line 2254 "dictionary.cpp"
                            var $247=$letter_xbytes; //@line 2254 "dictionary.cpp"
                            var $idx_neg420=(((-($247)))&4294967295); //@line 2254 "dictionary.cpp"
                            var $add_ptr421=(($246+$idx_neg420)&4294967295); //@line 2254 "dictionary.cpp"
                            var $add_ptr422=(($add_ptr421+-1)&4294967295); //@line 2254 "dictionary.cpp"
                            $p419=$add_ptr422; //@line 2254 "dictionary.cpp"
                            ; //@line 2255 "dictionary.cpp"
                            while(1) { 
  
                              var $248=HEAP32[(($letter_w)>>2)]; //@line 2255 "dictionary.cpp"
                              var $cmp424=((($248))|0)!=32; //@line 2255 "dictionary.cpp"
                              if (!($cmp424)) { __label__ = 155;break ; } //@line 2255 "dictionary.cpp"
  
                              var $249=$tr_addr; //@line 2257 "dictionary.cpp"
                              var $250=HEAP32[(($letter_w)>>2)]; //@line 2257 "dictionary.cpp"
                              var $call426=__ZL8IsLetterP10Translatorii($249, $250, 7); //@line 2257 "dictionary.cpp"
                              var $tobool427=((($call426))|0)!=0; //@line 2257 "dictionary.cpp"
                              if ($tobool427) { __label__ = 153;break ; } //@line 2257 "dictionary.cpp"
  
                              var $251=$p419; //@line 2262 "dictionary.cpp"
                              var $call430=__Z8utf8_in2PiPKci($letter_w, $251, 1); //@line 2262 "dictionary.cpp"
                              var $252=$p419; //@line 2262 "dictionary.cpp"
                              var $idx_neg431=(((-($call430)))&4294967295); //@line 2262 "dictionary.cpp"
                              var $add_ptr432=(($252+$idx_neg431)&4294967295); //@line 2262 "dictionary.cpp"
                              $p419=$add_ptr432; //@line 2262 "dictionary.cpp"
                              __label__ = 151;continue ; //@line 2263 "dictionary.cpp"
                            }
                            if (__label__ == 155) {
  
                              var $_pr4=$failed; //@line 2264 "dictionary.cpp"
                              var $tobool434=((($_pr4))|0)!=0; //@line 2264 "dictionary.cpp"
                              if ($tobool434) { __label__ = 30;break $if_then8$$if_end70$12; } //@line 2264 "dictionary.cpp"
  
                              $add_points=3; //@line 2265 "dictionary.cpp"
                              ; //@line 2265 "dictionary.cpp"
                            }
                            else if (__label__ == 153) {
  
                              $failed=1; //@line 2259 "dictionary.cpp"
                              __label__ = 30;break $if_then8$$if_end70$12; //@line 2264 "dictionary.cpp"
                            }
                          }
                          else if (__label__ == 157) {
  
                            var $253=$tr_addr; //@line 2270 "dictionary.cpp"
                            var $expect_verb=(($253+8272)&4294967295); //@line 2270 "dictionary.cpp"
                            var $254=HEAP32[(($expect_verb)>>2)]; //@line 2270 "dictionary.cpp"
                            var $tobool438=((($254))|0)!=0; //@line 2270 "dictionary.cpp"
                            if ($tobool438) { __label__ = 158;; } else { __label__ = 159;; } //@line 2270 "dictionary.cpp"
                            if (__label__ == 158) {
  
                              $add_points=1; //@line 2271 "dictionary.cpp"
                              ; //@line 2271 "dictionary.cpp"
                            }
                            else if (__label__ == 159) {
  
                              $failed=1; //@line 2273 "dictionary.cpp"
                              __label__ = 30;break $if_then8$$if_end70$12;
                            }
                          }
                          else if (__label__ == 160) {
  
                            var $255=$word_flags_addr; //@line 2277 "dictionary.cpp"
                            var $and443=($255) & 2; //@line 2277 "dictionary.cpp"
                            var $tobool444=((($and443))|0)!=0; //@line 2277 "dictionary.cpp"
                            if ($tobool444) { __label__ = 161;; } else { __label__ = 162;; } //@line 2277 "dictionary.cpp"
                            if (__label__ == 161) {
  
                              $add_points=1; //@line 2278 "dictionary.cpp"
                              ; //@line 2278 "dictionary.cpp"
                            }
                            else if (__label__ == 162) {
  
                              $failed=1; //@line 2280 "dictionary.cpp"
                              __label__ = 30;break $if_then8$$if_end70$12;
                            }
                          }
                          else if (__label__ == 163) {
  
                            var $256=$pre_ptr; //@line 2285 "dictionary.cpp"
                            $p=$256; //@line 2285 "dictionary.cpp"
                            ; //@line 2285 "dictionary.cpp"
                            while(1) { 
  
                              var $257=$p; //@line 2285 "dictionary.cpp"
                              var $258=HEAP8[($257)]; //@line 2285 "dictionary.cpp"
                              var $conv450=(tempInt=(($258)),(tempInt>=128?tempInt-256:tempInt)); //@line 2285 "dictionary.cpp"
                              var $cmp451=((($conv450))|0)!=32; //@line 2285 "dictionary.cpp"
                              if (!($cmp451)) { __label__ = 168;break ; } //@line 2285 "dictionary.cpp"
  
                              var $259=$p; //@line 2287 "dictionary.cpp"
                              var $260=HEAP8[($259)]; //@line 2287 "dictionary.cpp"
                              var $conv453=(tempInt=(($260)),(tempInt>=128?tempInt-256:tempInt)); //@line 2287 "dictionary.cpp"
                              var $cmp454=((($conv453))|0)==46; //@line 2287 "dictionary.cpp"
                              if ($cmp454) { __label__ = 166;break ; } //@line 2287 "dictionary.cpp"
  
                              var $261=$p; //@line 2285 "dictionary.cpp"
                              var $incdec_ptr458=(($261+-1)&4294967295); //@line 2285 "dictionary.cpp"
                              $p=$incdec_ptr458; //@line 2285 "dictionary.cpp"
                              __label__ = 164;continue ; //@line 2285 "dictionary.cpp"
                            }
                            if (__label__ == 166) {
  
                              $add_points=50; //@line 2289 "dictionary.cpp"
                              ; //@line 2290 "dictionary.cpp"
                            }
  
                            var $262=$p; //@line 2293 "dictionary.cpp"
                            var $263=HEAP8[($262)]; //@line 2293 "dictionary.cpp"
                            var $conv460=(tempInt=(($263)),(tempInt>=128?tempInt-256:tempInt)); //@line 2293 "dictionary.cpp"
                            var $cmp461=((($conv460))|0)==32; //@line 2293 "dictionary.cpp"
                            if (!($cmp461)) { __label__ = 181;break $sw_epilog496$$sw_bb71$$sw_bb89$$sw_bb328$44; } //@line 2293 "dictionary.cpp"
  
                            $failed=1; //@line 2294 "dictionary.cpp"
                            __label__ = 30;break $if_then8$$if_end70$12; //@line 2294 "dictionary.cpp"
                          }
                          else if (__label__ == 170) {
  
                            var $264=$letter; //@line 2298 "dictionary.cpp"
                            var $conv465=((($264))&255); //@line 2298 "dictionary.cpp"
                            var $cmp466=((($conv465))|0)==45; //@line 2298 "dictionary.cpp"
                            if ($cmp466) { __label__ = 173;; } else { __label__ = 171;; } //@line 2298 "dictionary.cpp"
                            $if_then473$$lor_lhs_false467$242: do { 
                              if (__label__ == 171) {
  
                                var $265=$letter; //@line 2298 "dictionary.cpp"
                                var $conv468=((($265))&255); //@line 2298 "dictionary.cpp"
                                var $cmp469=((($conv468))|0)==32; //@line 2298 "dictionary.cpp"
                                if ($cmp469) { __label__ = 172;; } else { __label__ = 174;; } //@line 2298 "dictionary.cpp"
                                if (__label__ == 172) {
  
                                  var $266=$word_flags_addr; //@line 2298 "dictionary.cpp"
                                  var $and471=($266) & 128; //@line 2298 "dictionary.cpp"
                                  var $tobool472=((($and471))|0)!=0; //@line 2298 "dictionary.cpp"
                                  if ($tobool472) { __label__ = 173;break $if_then473$$lor_lhs_false467$242; } //@line 2298 "dictionary.cpp"
                                }
  
                                $failed=1; //@line 2303 "dictionary.cpp"
                                __label__ = 30;break $if_then8$$if_end70$12;
                              }
                            } while(0);
  
                            var $267=$distance_right; //@line 2300 "dictionary.cpp"
                            var $sub474=((22-($267))&4294967295); //@line 2300 "dictionary.cpp"
                            $add_points=$sub474; //@line 2300 "dictionary.cpp"
                            ; //@line 2301 "dictionary.cpp"
                          }
                        }
                      } while(0);
  
                      var $_pr6_pr=$failed; //@line 2327 "dictionary.cpp"
                      var $cmp497=((($_pr6_pr))|0)==0; //@line 2327 "dictionary.cpp"
                      if (!($cmp497)) { __label__ = 30;break $if_then8$$if_end70$12; } //@line 2327 "dictionary.cpp"
  
                      var $273=$add_points; //@line 2328 "dictionary.cpp"
                      var $274=HEAP32[(($points499)>>2)]; //@line 2328 "dictionary.cpp"
                      var $add500=((($274)+($273))&4294967295); //@line 2328 "dictionary.cpp"
                      HEAP32[(($points499)>>2)]=$add500; //@line 2328 "dictionary.cpp"
                      ; //@line 2328 "dictionary.cpp"
                    }
                  } while(0);
  
                  var $42=$failed; //@line 1818 "dictionary.cpp"
                  var $tobool=((($42))|0)!=0; //@line 1818 "dictionary.cpp"
                  var $lnot=($tobool) ^ 1; //@line 1818 "dictionary.cpp"
                  if ($lnot) { __lastLabel__ = 30; __label__ = 6;continue $while_body4$10; } else { __lastLabel__ = 30; __label__ = 183;break $while_body4$$while_end502$9; } //@line 1818 "dictionary.cpp"
                }
              }
            } while(0);
  
            var $275=__lastLabel__ == 30 ? $42 : ($18); //@line 2331 "dictionary.cpp"
            var $cmp503=((($275))|0)==2; //@line 2331 "dictionary.cpp"
            if ($cmp503) { __label__ = 184;; } else { __label__ = 197;; } //@line 2331 "dictionary.cpp"
            $land_lhs_true504$$while_cond543$252: do { 
              if (__label__ == 184) {
  
                var $276=$unpron_ignore; //@line 2331 "dictionary.cpp"
                var $cmp505=((($276))|0)==0; //@line 2331 "dictionary.cpp"
                if (!($cmp505)) { __label__ = 197;break $land_lhs_true504$$while_cond543$252; } //@line 2331 "dictionary.cpp"
  
                var $277=$check_atstart; //@line 2334 "dictionary.cpp"
                var $cmp507=((($277))|0)==0; //@line 2334 "dictionary.cpp"
                if ($cmp507) { __label__ = 189;; } else { __label__ = 186;; } //@line 2334 "dictionary.cpp"
                $if_end517$$lor_lhs_false508$255: do { 
                  if (__label__ == 186) {
  
                    var $278=$pre_ptr; //@line 2334 "dictionary.cpp"
                    var $arrayidx509=(($278+-1)&4294967295); //@line 2334 "dictionary.cpp"
                    var $279=HEAP8[($arrayidx509)]; //@line 2334 "dictionary.cpp"
                    var $conv510=(tempInt=(($279)),(tempInt>=128?tempInt-256:tempInt)); //@line 2334 "dictionary.cpp"
                    var $cmp511=((($conv510))|0)==32; //@line 2334 "dictionary.cpp"
                    if (!($cmp511)) { __label__ = 197;break $land_lhs_true504$$while_cond543$252; } //@line 2334 "dictionary.cpp"
  
                    var $_pr8=$check_atstart; //@line 2336 "dictionary.cpp"
                    var $tobool513=((($_pr8))|0)!=0; //@line 2336 "dictionary.cpp"
                    if (!($tobool513)) { __label__ = 189;break $if_end517$$lor_lhs_false508$255; } //@line 2336 "dictionary.cpp"
  
                    var $280=HEAP32[(($points515)>>2)]; //@line 2337 "dictionary.cpp"
                    var $add516=((($280)+4)&4294967295); //@line 2337 "dictionary.cpp"
                    HEAP32[(($points515)>>2)]=$add516; //@line 2337 "dictionary.cpp"
                    ; //@line 2337 "dictionary.cpp"
                  }
                } while(0);
  
                var $281=HEAP32[(($points518)>>2)]; //@line 2340 "dictionary.cpp"
                var $282=HEAP32[((((__ZZL9MatchRuleP10TranslatorPPcS1_iS1_P11MatchRecordiiE4best)&4294967295))>>2)]; //@line 2340 "dictionary.cpp"
                var $cmp519=((($281))|0) >= ((($282))|0); //@line 2340 "dictionary.cpp"
                if ($cmp519) { __label__ = 190;; } else { __label__ = 191;; } //@line 2340 "dictionary.cpp"
                if (__label__ == 190) {
  
                  var $src$, $dest$, $stop$, $stop4$, $fast$;
                  $src$ = $8;
                  $dest$ = __ZZL9MatchRuleP10TranslatorPPcS1_iS1_P11MatchRecordiiE4best;
                  $stop$ = $src$ + 16;
                  if (($dest$%4) == ($src$%4) && 16 > 8) {
                    while ($src$%4 !== 0 && $src$ < $stop$) {
                      ; HEAP8[$dest$++] = HEAP8[$src$++];
                    }
                    $src$ >>= 2;
                    $dest$ >>= 2;
                    $stop4$ = $stop$ >> 2;
                    while ($src$ < $stop4$) {
                  ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
                    }
                    $src$ <<= 2;
                    $dest$ <<= 2;
                  }while ($src$ < $stop$) {
                    ; HEAP8[$dest$++] = HEAP8[$src$++];
                  }; //@line 2342 "dictionary.cpp"
                  var $283=$consumed; //@line 2343 "dictionary.cpp"
                  $total_consumed=$283; //@line 2343 "dictionary.cpp"
                  ; //@line 2344 "dictionary.cpp"
                }
  
                var $284=HEAP32[((_option_phonemes)>>2)]; //@line 2346 "dictionary.cpp"
                var $cmp522=((($284))|0)==2; //@line 2346 "dictionary.cpp"
                if (!($cmp522)) { __label__ = 197;break $land_lhs_true504$$while_cond543$252; } //@line 2346 "dictionary.cpp"
  
                var $285=HEAP32[(($points524)>>2)]; //@line 2346 "dictionary.cpp"
                var $cmp525=((($285))|0) > 0; //@line 2346 "dictionary.cpp"
                if (!($cmp525)) { __label__ = 197;break $land_lhs_true504$$while_cond543$252; } //@line 2346 "dictionary.cpp"
  
                var $286=$word_flags_addr; //@line 2346 "dictionary.cpp"
                var $and527=($286) & 268435456; //@line 2346 "dictionary.cpp"
                var $cmp528=((($and527))|0)==0; //@line 2346 "dictionary.cpp"
                if (!($cmp528)) { __label__ = 197;break $land_lhs_true504$$while_cond543$252; } //@line 2346 "dictionary.cpp"
  
                var $287=HEAP32[(($points530)>>2)]; //@line 2352 "dictionary.cpp"
                $pts=$287; //@line 2352 "dictionary.cpp"
                var $288=$group_length_addr; //@line 2353 "dictionary.cpp"
                var $cmp531=((($288))|0) > 1; //@line 2353 "dictionary.cpp"
                if ($cmp531) { __label__ = 195;; } else { __label__ = 196;; } //@line 2353 "dictionary.cpp"
                if (__label__ == 195) {
  
                  var $289=$pts; //@line 2354 "dictionary.cpp"
                  var $add533=((($289)+35)&4294967295); //@line 2354 "dictionary.cpp"
                  $pts=$add533; //@line 2354 "dictionary.cpp"
                  ; //@line 2354 "dictionary.cpp"
                }
  
                var $290=HEAP32[(($phonemes535)>>2)]; //@line 2355 "dictionary.cpp"
                __Z14DecodePhonemesPKcPc($290, $arraydecay536); //@line 2355 "dictionary.cpp"
                var $291=HEAP32[((_f_trans)>>2)]; //@line 2356 "dictionary.cpp"
                var $292=$pts; //@line 2356 "dictionary.cpp"
                var $293=$group_chars; //@line 2356 "dictionary.cpp"
                var $294=$group_length_addr; //@line 2356 "dictionary.cpp"
                var $295=$rule_start; //@line 2356 "dictionary.cpp"
                var $296=$word_flags_addr; //@line 2356 "dictionary.cpp"
                var $call537=__Z10DecodeRulePKciPci($293, $294, $295, $296); //@line 2356 "dictionary.cpp"
                var $call539=_fprintf($291, ((__str32148)&4294967295), allocate([$292,0,0,0,((__ZZ10DecodeRulePKciPciE6output)&4294967295),0,0,0,$arraydecay538,0,0,0], ["i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 2356 "dictionary.cpp"
                ; //@line 2357 "dictionary.cpp"
              }
            } while(0);
            while(1) { 
  
              var $297=$rule_addr; //@line 2362 "dictionary.cpp"
              var $incdec_ptr544=(($297+1)&4294967295); //@line 2362 "dictionary.cpp"
              $rule_addr=$incdec_ptr544; //@line 2362 "dictionary.cpp"
              var $298=HEAP8[($297)]; //@line 2362 "dictionary.cpp"
              var $conv545=(tempInt=(($298)),(tempInt>=128?tempInt-256:tempInt)); //@line 2362 "dictionary.cpp"
              var $cmp546=((($conv545))|0)!=0; //@line 2362 "dictionary.cpp"
              if ($cmp546) { __label__ = 197;continue ; } else { __label__ = 4;break ; } //@line 2362 "dictionary.cpp"
            }
  
            var $9=$rule_addr; //@line 1797 "dictionary.cpp"
            var $arrayidx=(($9)&4294967295); //@line 1797 "dictionary.cpp"
            var $10=HEAP8[($arrayidx)]; //@line 1797 "dictionary.cpp"
            var $conv=(tempInt=(($10)),(tempInt>=128?tempInt-256:tempInt)); //@line 1797 "dictionary.cpp"
            var $cmp1=((($conv))|0)!=7; //@line 1797 "dictionary.cpp"
            if ($cmp1) { __label__ = 5;continue $while_body$7; } else { __label__ = 198;break $while_body_lr_ph$$while_end549$5; } //@line 1797 "dictionary.cpp"
          }
        }
      } while(0);
  
      var $299=HEAP32[((_option_phonemes)>>2)]; //@line 2365 "dictionary.cpp"
      var $cmp550=((($299))|0)==2; //@line 2365 "dictionary.cpp"
      if ($cmp550) { __label__ = 199;; } else { __label__ = 202;; } //@line 2365 "dictionary.cpp"
      $land_lhs_true551$$if_end559$273: do { 
        if (__label__ == 199) {
  
          var $300=$word_flags_addr; //@line 2365 "dictionary.cpp"
          var $and552=($300) & 268435456; //@line 2365 "dictionary.cpp"
          var $cmp553=((($and552))|0)==0; //@line 2365 "dictionary.cpp"
          if (!($cmp553)) { __label__ = 202;break $land_lhs_true551$$if_end559$273; } //@line 2365 "dictionary.cpp"
  
          var $301=$group_length_addr; //@line 2367 "dictionary.cpp"
          var $cmp555=((($301))|0) <= 1; //@line 2367 "dictionary.cpp"
          if (!($cmp555)) { __label__ = 202;break $land_lhs_true551$$if_end559$273; } //@line 2367 "dictionary.cpp"
  
          var $302=HEAP32[((_f_trans)>>2)]; //@line 2368 "dictionary.cpp"
          var $fputc=_fputc(10, $302); //@line 2368 "dictionary.cpp"
          ; //@line 2368 "dictionary.cpp"
        }
      } while(0);
  
      var $303=$group_length_addr; //@line 2372 "dictionary.cpp"
      var $304=$total_consumed; //@line 2372 "dictionary.cpp"
      var $add560=((($304)+($303))&4294967295); //@line 2372 "dictionary.cpp"
      $total_consumed=$add560; //@line 2372 "dictionary.cpp"
      var $cmp561=((($add560))|0)==0; //@line 2373 "dictionary.cpp"
      if ($cmp561) { __label__ = 203;; } else { __label__ = 204;; } //@line 2373 "dictionary.cpp"
      if (__label__ == 203) {
  
        $total_consumed=1; //@line 2374 "dictionary.cpp"
        ; //@line 2374 "dictionary.cpp"
      }
  
      var $305=$total_consumed; //@line 2376 "dictionary.cpp"
      var $306=$word_addr; //@line 2376 "dictionary.cpp"
      var $307=HEAP32[(($306)>>2)]; //@line 2376 "dictionary.cpp"
      var $add_ptr564=(($307+$305)&4294967295); //@line 2376 "dictionary.cpp"
      HEAP32[(($306)>>2)]=$add_ptr564; //@line 2376 "dictionary.cpp"
      var $308=HEAP32[((((__ZZL9MatchRuleP10TranslatorPPcS1_iS1_P11MatchRecordiiE4best)&4294967295))>>2)]; //@line 2378 "dictionary.cpp"
      var $cmp565=((($308))|0)==0; //@line 2378 "dictionary.cpp"
      if ($cmp565) { __label__ = 205;; } else { __label__ = 206;; } //@line 2378 "dictionary.cpp"
      if (__label__ == 205) {
  
        HEAP32[((((__ZZL9MatchRuleP10TranslatorPPcS1_iS1_P11MatchRecordiiE4best+4)&4294967295))>>2)]=((__str13643)&4294967295); //@line 2379 "dictionary.cpp"
        ; //@line 2379 "dictionary.cpp"
      }
  
      var $309=$match_out_addr; //@line 2380 "dictionary.cpp"
      var $310=$309; //@line 2380 "dictionary.cpp"
      var $src$, $dest$, $stop$, $stop4$, $fast$;
      $src$ = __ZZL9MatchRuleP10TranslatorPPcS1_iS1_P11MatchRecordiiE4best;
      $dest$ = $310;
      $stop$ = $src$ + 16;
      if (($dest$%4) == ($src$%4) && 16 > 8) {
        while ($src$%4 !== 0 && $src$ < $stop$) {
          ; HEAP8[$dest$++] = HEAP8[$src$++];
        }
        $src$ >>= 2;
        $dest$ >>= 2;
        $stop4$ = $stop$ >> 2;
        while ($src$ < $stop4$) {
      ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
        }
        $src$ <<= 2;
        $dest$ <<= 2;
      }while ($src$ < $stop$) {
        ; HEAP8[$dest$++] = HEAP8[$src$++];
      }; //@line 2380 "dictionary.cpp"
      ; //@line 2381 "dictionary.cpp"
    }
  
    STACKTOP = __stackBase__;
    return; //@line 2381 "dictionary.cpp"
    return;
  }
  

  function __Z21ApplySpecialAttributeP10TranslatorPci($tr, $phonemes, $dict_flags) {
    ;
    var __label__;
  
    var $tr_addr;
    var $phonemes_addr;
    var $dict_flags_addr;
    var $len;
    var $p_end;
    $tr_addr=$tr;
    $phonemes_addr=$phonemes;
    $dict_flags_addr=$dict_flags;
    var $0=$dict_flags_addr; //@line 2737 "dictionary.cpp"
    var $and=($0) & 3145728; //@line 2737 "dictionary.cpp"
    var $cmp=((($and))|0)==0; //@line 2737 "dictionary.cpp"
    if ($cmp) { __label__ = 4;; } else { __label__ = 1;; } //@line 2737 "dictionary.cpp"
    $sw_epilog$$if_end$2: do { 
      if (__label__ == 1) {
  
        var $1=$phonemes_addr; //@line 2740 "dictionary.cpp"
        var $call=_strlen($1); //@line 2740 "dictionary.cpp"
        $len=$call; //@line 2740 "dictionary.cpp"
        var $2=$len; //@line 2741 "dictionary.cpp"
        var $sub=((($2)-1)&4294967295); //@line 2741 "dictionary.cpp"
        var $3=$phonemes_addr; //@line 2741 "dictionary.cpp"
        var $arrayidx=(($3+$sub)&4294967295); //@line 2741 "dictionary.cpp"
        $p_end=$arrayidx; //@line 2741 "dictionary.cpp"
        var $4=$tr_addr; //@line 2743 "dictionary.cpp"
        var $translator_name=(($4+280)&4294967295); //@line 2743 "dictionary.cpp"
        var $5=HEAP32[(($translator_name)>>2)]; //@line 2743 "dictionary.cpp"
        var $cond=((($5))|0)==29295; //@line 2743 "dictionary.cpp"
        if (!($cond)) { __label__ = 4;break $sw_epilog$$if_end$2; } //@line 2743 "dictionary.cpp"
  
        var $6=$p_end; //@line 2760 "dictionary.cpp"
        var $arrayidx1=(($6)&4294967295); //@line 2760 "dictionary.cpp"
        var $7=HEAP8[($arrayidx1)]; //@line 2760 "dictionary.cpp"
        var $conv=(tempInt=(($7)),(tempInt>=128?tempInt-256:tempInt)); //@line 2760 "dictionary.cpp"
        var $call2=__Z11PhonemeCodej(106); //@line 2760 "dictionary.cpp"
        var $cmp3=((($conv))|0)==((($call2))|0); //@line 2760 "dictionary.cpp"
        if (!($cmp3)) { __label__ = 4;break $sw_epilog$$if_end$2; } //@line 2760 "dictionary.cpp"
  
        var $8=$p_end; //@line 2763 "dictionary.cpp"
        var $arrayidx5=(($8)&4294967295); //@line 2763 "dictionary.cpp"
        HEAP8[($arrayidx5)]=6; //@line 2763 "dictionary.cpp"
        var $call6=__Z11PhonemeCodej(105); //@line 2764 "dictionary.cpp"
        var $conv7=((($call6)) & 255); //@line 2764 "dictionary.cpp"
        var $9=$p_end; //@line 2764 "dictionary.cpp"
        var $arrayidx8=(($9+1)&4294967295); //@line 2764 "dictionary.cpp"
        HEAP8[($arrayidx8)]=$conv7; //@line 2764 "dictionary.cpp"
        var $10=$p_end; //@line 2765 "dictionary.cpp"
        var $arrayidx9=(($10+2)&4294967295); //@line 2765 "dictionary.cpp"
        HEAP8[($arrayidx9)]=0; //@line 2765 "dictionary.cpp"
        ; //@line 2766 "dictionary.cpp"
      }
    } while(0);
  
    ;
    return; //@line 2769 "dictionary.cpp"
    return;
  }
  

  function __Z22ApplySpecialAttribute2P10TranslatorPci($tr, $phonemes, $dict_flags) {
    ;
    var __label__;
  
    var $tr_addr;
    var $phonemes_addr;
    var $dict_flags_addr;
    var $ix;
    var $len;
    var $p;
    $tr_addr=$tr;
    $phonemes_addr=$phonemes;
    $dict_flags_addr=$dict_flags;
    var $0=$phonemes_addr; //@line 2701 "dictionary.cpp"
    var $call=_strlen($0); //@line 2701 "dictionary.cpp"
    $len=$call; //@line 2701 "dictionary.cpp"
    var $1=$tr_addr; //@line 2703 "dictionary.cpp"
    var $langopts=(($1)&4294967295); //@line 2703 "dictionary.cpp"
    var $param=(($langopts+24)&4294967295); //@line 2703 "dictionary.cpp"
    var $arrayidx=(($param+60)&4294967295); //@line 2703 "dictionary.cpp"
    var $2=HEAP32[(($arrayidx)>>2)]; //@line 2703 "dictionary.cpp"
    var $and=($2) & 2; //@line 2703 "dictionary.cpp"
    var $tobool=((($and))|0)!=0; //@line 2703 "dictionary.cpp"
    if ($tobool) { __label__ = 1;; } else { __label__ = 14;; } //@line 2703 "dictionary.cpp"
    $if_then$$if_end37$2: do { 
      if (__label__ == 1) {
  
        $ix=0; //@line 2705 "dictionary.cpp"
        ; //@line 2705 "dictionary.cpp"
        while(1) { 
  
          var $3=$ix; //@line 2705 "dictionary.cpp"
          var $4=$len; //@line 2705 "dictionary.cpp"
          var $sub=((($4)-1)&4294967295); //@line 2705 "dictionary.cpp"
          var $cmp=((($3))|0) < ((($sub))|0); //@line 2705 "dictionary.cpp"
          if (!($cmp)) { __label__ = 14;break $if_then$$if_end37$2; } //@line 2705 "dictionary.cpp"
  
          var $5=$ix; //@line 2707 "dictionary.cpp"
          var $6=$phonemes_addr; //@line 2707 "dictionary.cpp"
          var $arrayidx1=(($6+$5)&4294967295); //@line 2707 "dictionary.cpp"
          var $7=HEAP8[($arrayidx1)]; //@line 2707 "dictionary.cpp"
          var $conv=(tempInt=(($7)),(tempInt>=128?tempInt-256:tempInt)); //@line 2707 "dictionary.cpp"
          var $cmp2=((($conv))|0)==6; //@line 2707 "dictionary.cpp"
          var $8=$ix; //@line 2709 "dictionary.cpp"
          var $add=((($8)+1)&4294967295); //@line 2709 "dictionary.cpp"
          if ($cmp2) { __label__ = 4;break ; } //@line 2707 "dictionary.cpp"
  
          $ix=$add; //@line 2705 "dictionary.cpp"
          __label__ = 2;continue ; //@line 2705 "dictionary.cpp"
        }
  
        var $9=$phonemes_addr; //@line 2709 "dictionary.cpp"
        var $arrayidx4=(($9+$add)&4294967295); //@line 2709 "dictionary.cpp"
        $p=$arrayidx4; //@line 2709 "dictionary.cpp"
        var $10=$dict_flags_addr; //@line 2710 "dictionary.cpp"
        var $and5=($10) & 2097152; //@line 2710 "dictionary.cpp"
        var $cmp6=((($and5))|0)!=0; //@line 2710 "dictionary.cpp"
        var $11=$p; //@line 2712 "dictionary.cpp"
        var $12=HEAP8[($11)]; //@line 2712 "dictionary.cpp"
        var $conv8=(tempInt=(($12)),(tempInt>=128?tempInt-256:tempInt)); //@line 2712 "dictionary.cpp"
        if ($cmp6) { __label__ = 5;; } else { __label__ = 9;; } //@line 2710 "dictionary.cpp"
        if (__label__ == 5) {
  
          var $call9=__Z11PhonemeCodej(69); //@line 2712 "dictionary.cpp"
          var $cmp10=((($conv8))|0)==((($call9))|0); //@line 2712 "dictionary.cpp"
          if ($cmp10) { __label__ = 6;; } else { __label__ = 7;; } //@line 2712 "dictionary.cpp"
          if (__label__ == 6) {
  
            var $call12=__Z11PhonemeCodej(101); //@line 2713 "dictionary.cpp"
            var $conv13=((($call12)) & 255); //@line 2713 "dictionary.cpp"
            var $13=$p; //@line 2713 "dictionary.cpp"
            HEAP8[($13)]=$conv13; //@line 2713 "dictionary.cpp"
            ; //@line 2713 "dictionary.cpp"
          }
  
          var $14=$p; //@line 2714 "dictionary.cpp"
          var $15=HEAP8[($14)]; //@line 2714 "dictionary.cpp"
          var $conv14=(tempInt=(($15)),(tempInt>=128?tempInt-256:tempInt)); //@line 2714 "dictionary.cpp"
          var $call15=__Z11PhonemeCodej(79); //@line 2714 "dictionary.cpp"
          var $cmp16=((($conv14))|0)==((($call15))|0); //@line 2714 "dictionary.cpp"
          if (!($cmp16)) { __label__ = 14;break $if_then$$if_end37$2; } //@line 2714 "dictionary.cpp"
  
          var $call18=__Z11PhonemeCodej(111); //@line 2715 "dictionary.cpp"
          var $conv19=((($call18)) & 255); //@line 2715 "dictionary.cpp"
          var $16=$p; //@line 2715 "dictionary.cpp"
          HEAP8[($16)]=$conv19; //@line 2715 "dictionary.cpp"
          ; //@line 2715 "dictionary.cpp"
        }
        else if (__label__ == 9) {
  
          var $call22=__Z11PhonemeCodej(101); //@line 2719 "dictionary.cpp"
          var $cmp23=((($conv8))|0)==((($call22))|0); //@line 2719 "dictionary.cpp"
          if ($cmp23) { __label__ = 10;; } else { __label__ = 11;; } //@line 2719 "dictionary.cpp"
          if (__label__ == 10) {
  
            var $call25=__Z11PhonemeCodej(69); //@line 2720 "dictionary.cpp"
            var $conv26=((($call25)) & 255); //@line 2720 "dictionary.cpp"
            var $17=$p; //@line 2720 "dictionary.cpp"
            HEAP8[($17)]=$conv26; //@line 2720 "dictionary.cpp"
            ; //@line 2720 "dictionary.cpp"
          }
  
          var $18=$p; //@line 2721 "dictionary.cpp"
          var $19=HEAP8[($18)]; //@line 2721 "dictionary.cpp"
          var $conv28=(tempInt=(($19)),(tempInt>=128?tempInt-256:tempInt)); //@line 2721 "dictionary.cpp"
          var $call29=__Z11PhonemeCodej(111); //@line 2721 "dictionary.cpp"
          var $cmp30=((($conv28))|0)==((($call29))|0); //@line 2721 "dictionary.cpp"
          if (!($cmp30)) { __label__ = 14;break $if_then$$if_end37$2; } //@line 2721 "dictionary.cpp"
  
          var $call32=__Z11PhonemeCodej(79); //@line 2722 "dictionary.cpp"
          var $conv33=((($call32)) & 255); //@line 2722 "dictionary.cpp"
          var $20=$p; //@line 2722 "dictionary.cpp"
          HEAP8[($20)]=$conv33; //@line 2722 "dictionary.cpp"
          ; //@line 2722 "dictionary.cpp"
        }
      }
    } while(0);
  
    ;
    return; //@line 2728 "dictionary.cpp"
    return;
  }
  

  function __Z17TransposeAlphabetP10TranslatorPc($tr, $text) {
    var __stackBase__  = STACKTOP; STACKTOP += 4; _memset(__stackBase__, 0, 4);
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $tr_addr;
    var $text_addr;
    var $c=__stackBase__;
    var $c2;
    var $ix;
    var $offset;
    var $min;
    var $max;
    var $p;
    var $p2;
    var $all_alpha;
    var $bits;
    var $acc;
    var $pairs_start;
    var $pairs_list;
    $tr_addr=$tr;
    $text_addr=$text;
    var $0=$text_addr; //@line 2790 "dictionary.cpp"
    $p=$0; //@line 2790 "dictionary.cpp"
    var $1=$text_addr; //@line 2791 "dictionary.cpp"
    $p2=$1; //@line 2791 "dictionary.cpp"
    $all_alpha=1; //@line 2792 "dictionary.cpp"
    var $2=$tr_addr; //@line 2798 "dictionary.cpp"
    var $transpose_min=(($2+288)&4294967295); //@line 2798 "dictionary.cpp"
    var $3=HEAP32[(($transpose_min)>>2)]; //@line 2798 "dictionary.cpp"
    var $sub=((($3)-1)&4294967295); //@line 2798 "dictionary.cpp"
    $offset=$sub; //@line 2798 "dictionary.cpp"
    var $4=$tr_addr; //@line 2799 "dictionary.cpp"
    var $transpose_min1=(($4+288)&4294967295); //@line 2799 "dictionary.cpp"
    var $5=HEAP32[(($transpose_min1)>>2)]; //@line 2799 "dictionary.cpp"
    $min=$5; //@line 2799 "dictionary.cpp"
    var $6=$tr_addr; //@line 2800 "dictionary.cpp"
    var $transpose_max=(($6+284)&4294967295); //@line 2800 "dictionary.cpp"
    var $7=HEAP32[(($transpose_max)>>2)]; //@line 2800 "dictionary.cpp"
    $max=$7; //@line 2800 "dictionary.cpp"
    var $8=$max; //@line 2802 "dictionary.cpp"
    var $9=$min; //@line 2802 "dictionary.cpp"
    var $_neg=(((-($9)))&4294967295);
    var $sub2=((($8)+2)&4294967295); //@line 2802 "dictionary.cpp"
    var $add=((($sub2)+($_neg))&4294967295); //@line 2802 "dictionary.cpp"
    $pairs_start=$add; //@line 2802 "dictionary.cpp"
    ; //@line 2804 "dictionary.cpp"
    $do_body$2: while(1) { 
  
      var $10=$p; //@line 2805 "dictionary.cpp"
      var $call=__Z7utf8_inPiPKc($c, $10); //@line 2805 "dictionary.cpp"
      var $11=$p; //@line 2805 "dictionary.cpp"
      var $add_ptr=(($11+$call)&4294967295); //@line 2805 "dictionary.cpp"
      $p=$add_ptr; //@line 2805 "dictionary.cpp"
      var $12=HEAP32[(($c)>>2)]; //@line 2806 "dictionary.cpp"
      var $13=$min; //@line 2806 "dictionary.cpp"
      var $cmp=((($12))|0) >= ((($13))|0); //@line 2806 "dictionary.cpp"
      if ($cmp) { __lastLabel__ = 1; __label__ = 2;; } else { __lastLabel__ = 1; __label__ = 4;; } //@line 2806 "dictionary.cpp"
      $land_lhs_true$$if_else$4: do { 
        if (__label__ == 2) {
  
          var $14=HEAP32[(($c)>>2)]; //@line 2806 "dictionary.cpp"
          var $15=$max; //@line 2806 "dictionary.cpp"
          var $cmp3=((($14))|0) <= ((($15))|0); //@line 2806 "dictionary.cpp"
          if ($cmp3) { __lastLabel__ = 2; ; } else { __lastLabel__ = 2; __label__ = 4;break $land_lhs_true$$if_else$4; } //@line 2806 "dictionary.cpp"
  
          var $16=HEAP32[(($c)>>2)]; //@line 2808 "dictionary.cpp"
          var $17=$offset; //@line 2808 "dictionary.cpp"
          var $sub4=((($16)-($17))&4294967295); //@line 2808 "dictionary.cpp"
          var $conv=((($sub4)) & 255); //@line 2808 "dictionary.cpp"
          var $18=$p2; //@line 2808 "dictionary.cpp"
          var $incdec_ptr=(($18+1)&4294967295); //@line 2808 "dictionary.cpp"
          $p2=$incdec_ptr; //@line 2808 "dictionary.cpp"
          HEAP8[($18)]=$conv; //@line 2808 "dictionary.cpp"
          __label__ = 6;break $land_lhs_true$$if_else$4; //@line 2809 "dictionary.cpp"
        }
      } while(0);
      $do_cond$$if_else$7: do { 
        if (__label__ == 4) {
  
          var $19=__lastLabel__ == 2 ? $14 : ($12); //@line 2811 "dictionary.cpp"
          var $cmp5=((($19))|0)!=0; //@line 2811 "dictionary.cpp"
          if (!($cmp5)) { __label__ = 6;break $do_cond$$if_else$7; } //@line 2811 "dictionary.cpp"
  
          var $20=HEAP32[(($c)>>2)]; //@line 2813 "dictionary.cpp"
          var $21=$p2; //@line 2813 "dictionary.cpp"
          var $call7=__Z8utf8_outjPc($20, $21); //@line 2813 "dictionary.cpp"
          var $22=$p2; //@line 2813 "dictionary.cpp"
          var $add_ptr8=(($22+$call7)&4294967295); //@line 2813 "dictionary.cpp"
          $p2=$add_ptr8; //@line 2813 "dictionary.cpp"
          $all_alpha=0; //@line 2814 "dictionary.cpp"
          ; //@line 2815 "dictionary.cpp"
        }
      } while(0);
  
      var $23=HEAP32[(($c)>>2)]; //@line 2816 "dictionary.cpp"
      var $cmp10=((($23))|0)!=0; //@line 2816 "dictionary.cpp"
      if ($cmp10) { __label__ = 1;continue $do_body$2; } else { __label__ = 7;break $do_body$2; } //@line 2816 "dictionary.cpp"
    }
  
    var $24=$p2; //@line 2817 "dictionary.cpp"
    HEAP8[($24)]=0; //@line 2817 "dictionary.cpp"
    var $25=$all_alpha; //@line 2819 "dictionary.cpp"
    var $tobool=((($25))|0)!=0; //@line 2819 "dictionary.cpp"
    if ($tobool) { __label__ = 8;; } else { __label__ = 21;; } //@line 2819 "dictionary.cpp"
    if (__label__ == 8) {
  
      $acc=0; //@line 2822 "dictionary.cpp"
      $bits=0; //@line 2823 "dictionary.cpp"
      var $26=$text_addr; //@line 2825 "dictionary.cpp"
      $p=$26; //@line 2825 "dictionary.cpp"
      var $27=$text_addr; //@line 2826 "dictionary.cpp"
      $p2=$27; //@line 2826 "dictionary.cpp"
      var $28=$p; //@line 2827 "dictionary.cpp"
      var $incdec_ptr121=(($28+1)&4294967295); //@line 2827 "dictionary.cpp"
      $p=$incdec_ptr121; //@line 2827 "dictionary.cpp"
      var $29=HEAP8[($28)]; //@line 2827 "dictionary.cpp"
      var $conv132=(tempInt=(($29)),(tempInt>=128?tempInt-256:tempInt)); //@line 2827 "dictionary.cpp"
      HEAP32[(($c)>>2)]=$conv132; //@line 2827 "dictionary.cpp"
      var $cmp143=((($conv132))|0)!=0; //@line 2827 "dictionary.cpp"
      if ($cmp143) { __label__ = 9;; } else { __label__ = 18;; } //@line 2827 "dictionary.cpp"
      $while_body$$while_end$14: do { 
        if (__label__ == 9) {
          $while_body$15: while(1) { 
  
            var $30=$tr_addr; //@line 2829 "dictionary.cpp"
            var $frequent_pairs=(($30+8268)&4294967295); //@line 2829 "dictionary.cpp"
            var $31=HEAP32[(($frequent_pairs)>>2)]; //@line 2829 "dictionary.cpp"
            $pairs_list=$31; //@line 2829 "dictionary.cpp"
            var $cmp15=((($31))|0)!=0; //@line 2829 "dictionary.cpp"
            if ($cmp15) { __label__ = 10;; } else { __label__ = 15;; } //@line 2829 "dictionary.cpp"
            $if_then16$$if_end28$17: do { 
              if (__label__ == 10) {
  
                var $32=HEAP32[(($c)>>2)]; //@line 2831 "dictionary.cpp"
                var $33=$p; //@line 2831 "dictionary.cpp"
                var $34=HEAP8[($33)]; //@line 2831 "dictionary.cpp"
                var $conv17=(tempInt=(($34)),(tempInt>=128?tempInt-256:tempInt)); //@line 2831 "dictionary.cpp"
                var $shl=((($conv17)*256)&4294967295); //@line 2831 "dictionary.cpp"
                var $add18=((($shl)+($32))&4294967295); //@line 2831 "dictionary.cpp"
                $c2=$add18; //@line 2831 "dictionary.cpp"
                $ix=0; //@line 2832 "dictionary.cpp"
                ; //@line 2832 "dictionary.cpp"
                while(1) { 
  
                  var $35=$c2; //@line 2832 "dictionary.cpp"
                  var $36=$ix; //@line 2832 "dictionary.cpp"
                  var $37=$pairs_list; //@line 2832 "dictionary.cpp"
                  var $arrayidx=(($37+2*$36)&4294967295); //@line 2832 "dictionary.cpp"
                  var $38=HEAP16[(($arrayidx)>>1)]; //@line 2832 "dictionary.cpp"
                  var $conv19=(tempInt=(($38)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 2832 "dictionary.cpp"
                  var $cmp20=((($35))|0) >= ((($conv19))|0); //@line 2832 "dictionary.cpp"
                  if (!($cmp20)) { __label__ = 15;break $if_then16$$if_end28$17; } //@line 2832 "dictionary.cpp"
  
                  var $39=$c2; //@line 2834 "dictionary.cpp"
                  var $40=$ix; //@line 2834 "dictionary.cpp"
                  var $41=$pairs_list; //@line 2834 "dictionary.cpp"
                  var $arrayidx21=(($41+2*$40)&4294967295); //@line 2834 "dictionary.cpp"
                  var $42=HEAP16[(($arrayidx21)>>1)]; //@line 2834 "dictionary.cpp"
                  var $conv22=(tempInt=(($42)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 2834 "dictionary.cpp"
                  var $cmp23=((($39))|0)==((($conv22))|0); //@line 2834 "dictionary.cpp"
                  var $43=$ix; //@line 2837 "dictionary.cpp"
                  if ($cmp23) { __label__ = 13;break ; } //@line 2834 "dictionary.cpp"
  
                  var $inc=((($43)+1)&4294967295); //@line 2832 "dictionary.cpp"
                  $ix=$inc; //@line 2832 "dictionary.cpp"
                  __label__ = 11;continue ; //@line 2832 "dictionary.cpp"
                }
  
                var $44=$pairs_start; //@line 2837 "dictionary.cpp"
                var $add25=((($44)+($43))&4294967295); //@line 2837 "dictionary.cpp"
                HEAP32[(($c)>>2)]=$add25; //@line 2837 "dictionary.cpp"
                var $45=$p; //@line 2838 "dictionary.cpp"
                var $incdec_ptr26=(($45+1)&4294967295); //@line 2838 "dictionary.cpp"
                $p=$incdec_ptr26; //@line 2838 "dictionary.cpp"
                ; //@line 2839 "dictionary.cpp"
              }
            } while(0);
  
            var $46=$acc; //@line 2843 "dictionary.cpp"
            var $shl29=((($46)*64)&4294967295); //@line 2843 "dictionary.cpp"
            var $47=HEAP32[(($c)>>2)]; //@line 2843 "dictionary.cpp"
            var $and=($47) & 63; //@line 2843 "dictionary.cpp"
            var $add30=((($and)+($shl29))&4294967295); //@line 2843 "dictionary.cpp"
            $acc=$add30; //@line 2843 "dictionary.cpp"
            var $48=$bits; //@line 2844 "dictionary.cpp"
            var $add31=((($48)+6)&4294967295); //@line 2844 "dictionary.cpp"
            $bits=$add31; //@line 2844 "dictionary.cpp"
            var $cmp32=((($add31))|0) >= 8; //@line 2846 "dictionary.cpp"
            if ($cmp32) { __label__ = 16;; } else { __label__ = 17;; } //@line 2846 "dictionary.cpp"
            if (__label__ == 16) {
  
              var $49=$bits; //@line 2848 "dictionary.cpp"
              var $sub34=((($49)-8)&4294967295); //@line 2848 "dictionary.cpp"
              $bits=$sub34; //@line 2848 "dictionary.cpp"
              var $50=$acc; //@line 2849 "dictionary.cpp"
              var $51=$bits; //@line 2849 "dictionary.cpp"
              var $shr=($50) >> ((($51))|0); //@line 2849 "dictionary.cpp"
              var $conv35=((($shr)) & 255); //@line 2849 "dictionary.cpp"
              var $52=$p2; //@line 2849 "dictionary.cpp"
              var $incdec_ptr36=(($52+1)&4294967295); //@line 2849 "dictionary.cpp"
              $p2=$incdec_ptr36; //@line 2849 "dictionary.cpp"
              HEAP8[($52)]=$conv35; //@line 2849 "dictionary.cpp"
              ; //@line 2850 "dictionary.cpp"
            }
  
            var $53=$p; //@line 2827 "dictionary.cpp"
            var $incdec_ptr12=(($53+1)&4294967295); //@line 2827 "dictionary.cpp"
            $p=$incdec_ptr12; //@line 2827 "dictionary.cpp"
            var $54=HEAP8[($53)]; //@line 2827 "dictionary.cpp"
            var $conv13=(tempInt=(($54)),(tempInt>=128?tempInt-256:tempInt)); //@line 2827 "dictionary.cpp"
            HEAP32[(($c)>>2)]=$conv13; //@line 2827 "dictionary.cpp"
            var $cmp14=((($conv13))|0)!=0; //@line 2827 "dictionary.cpp"
            if ($cmp14) { __label__ = 9;continue $while_body$15; } else { __label__ = 18;break $while_body$$while_end$14; } //@line 2827 "dictionary.cpp"
          }
        }
      } while(0);
  
      var $55=$bits; //@line 2852 "dictionary.cpp"
      var $cmp38=((($55))|0) > 0; //@line 2852 "dictionary.cpp"
      if ($cmp38) { __label__ = 19;; } else { __label__ = 20;; } //@line 2852 "dictionary.cpp"
      if (__label__ == 19) {
  
        var $56=$acc; //@line 2854 "dictionary.cpp"
        var $57=$bits; //@line 2854 "dictionary.cpp"
        var $sub40=((8-($57))&4294967295); //@line 2854 "dictionary.cpp"
        var $shl41=($56) << ($sub40); //@line 2854 "dictionary.cpp"
        var $conv42=((($shl41)) & 255); //@line 2854 "dictionary.cpp"
        var $58=$p2; //@line 2854 "dictionary.cpp"
        var $incdec_ptr43=(($58+1)&4294967295); //@line 2854 "dictionary.cpp"
        $p2=$incdec_ptr43; //@line 2854 "dictionary.cpp"
        HEAP8[($58)]=$conv42; //@line 2854 "dictionary.cpp"
        ; //@line 2855 "dictionary.cpp"
      }
  
      var $59=$p2; //@line 2856 "dictionary.cpp"
      HEAP8[($59)]=0; //@line 2856 "dictionary.cpp"
      var $60=$p2; //@line 2857 "dictionary.cpp"
      var $61=$text_addr; //@line 2857 "dictionary.cpp"
      var $sub_ptr_lhs_cast=($60); //@line 2857 "dictionary.cpp"
      var $sub_ptr_rhs_cast=($61); //@line 2857 "dictionary.cpp"
      var $sub_ptr_sub=((($sub_ptr_lhs_cast)-($sub_ptr_rhs_cast))&4294967295); //@line 2857 "dictionary.cpp"
      var $or=($sub_ptr_sub) | 64; //@line 2857 "dictionary.cpp"
      $retval=$or; //@line 2857 "dictionary.cpp"
      ; //@line 2857 "dictionary.cpp"
    }
    else if (__label__ == 21) {
  
      var $62=$p2; //@line 2859 "dictionary.cpp"
      var $63=$text_addr; //@line 2859 "dictionary.cpp"
      var $sub_ptr_lhs_cast46=($62); //@line 2859 "dictionary.cpp"
      var $sub_ptr_rhs_cast47=($63); //@line 2859 "dictionary.cpp"
      var $sub_ptr_sub48=((($sub_ptr_lhs_cast46)-($sub_ptr_rhs_cast47))&4294967295); //@line 2859 "dictionary.cpp"
      $retval=$sub_ptr_sub48; //@line 2859 "dictionary.cpp"
      ; //@line 2859 "dictionary.cpp"
    }
  
    var $64=$retval; //@line 2860 "dictionary.cpp"
    STACKTOP = __stackBase__;
    return $64; //@line 2860 "dictionary.cpp"
    return null;
  }
  

  function __Z14LookupDictListP10TranslatorPPcS1_PjiP8WORD_TAB($tr, $wordptr, $ph_out, $flags, $end_flags, $wtab) {
    var __stackBase__  = STACKTOP; STACKTOP += 164; _memset(__stackBase__, 0, 164);
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $tr_addr;
    var $wordptr_addr;
    var $ph_out_addr;
    var $flags_addr;
    var $end_flags_addr;
    var $wtab_addr;
    var $length;
    var $found;
    var $word1;
    var $word2;
    var $c;
    var $nbytes;
    var $len;
    var $word=__stackBase__;
    var $letter=__stackBase__+160;
    $tr_addr=$tr;
    $wordptr_addr=$wordptr;
    $ph_out_addr=$ph_out;
    $flags_addr=$flags;
    $end_flags_addr=$end_flags;
    $wtab_addr=$wtab;
    $length=0; //@line 3221 "dictionary.cpp"
    var $0=$wordptr_addr; //@line 3222 "dictionary.cpp"
    var $1=HEAP32[(($0)>>2)]; //@line 3222 "dictionary.cpp"
    $word1=$1; //@line 3222 "dictionary.cpp"
    $word2=$1; //@line 3222 "dictionary.cpp"
    ; //@line 3224 "dictionary.cpp"
    $while_cond$2: while(1) { 
  
      var $2=$word2; //@line 3224 "dictionary.cpp"
      var $call=__Z11utf8_nbytesPKc($2); //@line 3224 "dictionary.cpp"
      $nbytes=$call; //@line 3224 "dictionary.cpp"
      var $3=$word2; //@line 3224 "dictionary.cpp"
      var $arrayidx=(($3+$call)&4294967295); //@line 3224 "dictionary.cpp"
      var $4=HEAP8[($arrayidx)]; //@line 3224 "dictionary.cpp"
      var $conv=(tempInt=(($4)),(tempInt>=128?tempInt-256:tempInt)); //@line 3224 "dictionary.cpp"
      var $cmp=((($conv))|0)==32; //@line 3224 "dictionary.cpp"
      if (!($cmp)) { __label__ = 2;break $while_cond$2; } //@line 3224 "dictionary.cpp"
  
      var $6=$nbytes; //@line 3224 "dictionary.cpp"
      var $add=((($6)+1)&4294967295); //@line 3224 "dictionary.cpp"
      var $7=$word2; //@line 3224 "dictionary.cpp"
      var $arrayidx1=(($7+$add)&4294967295); //@line 3224 "dictionary.cpp"
      var $8=HEAP8[($arrayidx1)]; //@line 3224 "dictionary.cpp"
      var $conv2=(tempInt=(($8)),(tempInt>=128?tempInt-256:tempInt)); //@line 3224 "dictionary.cpp"
      var $cmp3=((($conv2))|0)==46; //@line 3224 "dictionary.cpp"
      var $9=$length; //@line 3228 "dictionary.cpp"
      if ($cmp3) { __lastLabel__ = 3; ; } else { __lastLabel__ = 3; __label__ = 5;break $while_cond$2; }
  
      var $arrayidx4=(($word+$9)&4294967295); //@line 3228 "dictionary.cpp"
      var $10=$word2; //@line 3228 "dictionary.cpp"
      var $11=$nbytes; //@line 3228 "dictionary.cpp"
      var $src$, $dest$, $stop$, $stop4$, $fast$;
      $src$ = $10;
      $dest$ = $arrayidx4;
      $stop$ = $src$ + $11;
      if (($dest$%4) == ($src$%4) && $11 > 8) {
        while ($src$%4 !== 0 && $src$ < $stop$) {
          ; HEAP8[$dest$++] = HEAP8[$src$++];
        }
        $src$ >>= 2;
        $dest$ >>= 2;
        $stop4$ = $stop$ >> 2;
        while ($src$ < $stop4$) {
      ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
        }
        $src$ <<= 2;
        $dest$ <<= 2;
      }while ($src$ < $stop$) {
        ; HEAP8[$dest$++] = HEAP8[$src$++];
      }; //@line 3228 "dictionary.cpp"
      var $12=$nbytes; //@line 3229 "dictionary.cpp"
      var $13=$length; //@line 3229 "dictionary.cpp"
      var $add5=((($13)+($12))&4294967295); //@line 3229 "dictionary.cpp"
      $length=$add5; //@line 3229 "dictionary.cpp"
      var $14=$length; //@line 3230 "dictionary.cpp"
      var $inc=((($14)+1)&4294967295); //@line 3230 "dictionary.cpp"
      $length=$inc; //@line 3230 "dictionary.cpp"
      var $arrayidx6=(($word+$14)&4294967295); //@line 3230 "dictionary.cpp"
      HEAP8[($arrayidx6)]=46; //@line 3230 "dictionary.cpp"
      var $15=$nbytes; //@line 3231 "dictionary.cpp"
      var $add7=((($15)+3)&4294967295); //@line 3231 "dictionary.cpp"
      var $16=$word2; //@line 3231 "dictionary.cpp"
      var $add_ptr=(($16+$add7)&4294967295); //@line 3231 "dictionary.cpp"
      $word2=$add_ptr; //@line 3231 "dictionary.cpp"
      __label__ = 1;continue $while_cond$2; //@line 3232 "dictionary.cpp"
    }
    if (__label__ == 2) {
  
      var $5=$length; //@line 3228 "dictionary.cpp"
      __lastLabel__ = 2; ;
    }
  
    var $17=__lastLabel__ == 2 ? $5 : ($9);
    var $cmp8=((($17))|0) > 0; //@line 3233 "dictionary.cpp"
    if ($cmp8) { __label__ = 6;; } else { __label__ = 12;; } //@line 3233 "dictionary.cpp"
    $if_then$$if_end26$9: do { 
      if (__label__ == 6) {
  
        $nbytes=0; //@line 3236 "dictionary.cpp"
        ; //@line 3237 "dictionary.cpp"
        while(1) { 
  
          var $18=$nbytes; //@line 3237 "dictionary.cpp"
          var $19=$word2; //@line 3237 "dictionary.cpp"
          var $arrayidx10=(($19+$18)&4294967295); //@line 3237 "dictionary.cpp"
          var $20=HEAPU8[($arrayidx10)]; //@line 3237 "dictionary.cpp"
          $c=$20; //@line 3237 "dictionary.cpp"
          var $conv11=((($20))&255); //@line 3237 "dictionary.cpp"
          var $cmp12=((($conv11))|0)!=0; //@line 3237 "dictionary.cpp"
          if (!($cmp12)) { __label__ = 10;break ; } //@line 3237 "dictionary.cpp"
  
          var $21=$c; //@line 3237 "dictionary.cpp"
          var $conv14=((($21))&255); //@line 3237 "dictionary.cpp"
          var $cmp15=((($conv14))|0)!=32; //@line 3237 "dictionary.cpp"
          if (!($cmp15)) { __label__ = 10;break ; }
  
          var $22=$nbytes; //@line 3239 "dictionary.cpp"
          var $inc18=((($22)+1)&4294967295); //@line 3239 "dictionary.cpp"
          $nbytes=$inc18; //@line 3239 "dictionary.cpp"
          __label__ = 7;continue ; //@line 3240 "dictionary.cpp"
        }
  
        var $23=$length; //@line 3241 "dictionary.cpp"
        var $arrayidx20=(($word+$23)&4294967295); //@line 3241 "dictionary.cpp"
        var $24=$word2; //@line 3241 "dictionary.cpp"
        var $25=$nbytes; //@line 3241 "dictionary.cpp"
        var $src$, $dest$, $stop$, $stop4$, $fast$;
        $src$ = $24;
        $dest$ = $arrayidx20;
        $stop$ = $src$ + $25;
        if (($dest$%4) == ($src$%4) && $25 > 8) {
          while ($src$%4 !== 0 && $src$ < $stop$) {
            ; HEAP8[$dest$++] = HEAP8[$src$++];
          }
          $src$ >>= 2;
          $dest$ >>= 2;
          $stop4$ = $stop$ >> 2;
          while ($src$ < $stop4$) {
        ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
          }
          $src$ <<= 2;
          $dest$ <<= 2;
        }while ($src$ < $stop$) {
          ; HEAP8[$dest$++] = HEAP8[$src$++];
        }; //@line 3241 "dictionary.cpp"
        var $26=$length; //@line 3242 "dictionary.cpp"
        var $27=$nbytes; //@line 3242 "dictionary.cpp"
        var $add21=((($27)+($26))&4294967295); //@line 3242 "dictionary.cpp"
        var $arrayidx22=(($word+$add21)&4294967295); //@line 3242 "dictionary.cpp"
        HEAP8[($arrayidx22)]=0; //@line 3242 "dictionary.cpp"
        var $28=$tr_addr; //@line 3243 "dictionary.cpp"
        var $arraydecay=(($word)&4294967295); //@line 3243 "dictionary.cpp"
        var $29=$word2; //@line 3243 "dictionary.cpp"
        var $30=$ph_out_addr; //@line 3243 "dictionary.cpp"
        var $31=$flags_addr; //@line 3243 "dictionary.cpp"
        var $32=$end_flags_addr; //@line 3243 "dictionary.cpp"
        var $33=$wtab_addr; //@line 3243 "dictionary.cpp"
        var $call23=__ZL11LookupDict2P10TranslatorPKcS2_PcPjiP8WORD_TAB($28, $arraydecay, $29, $30, $31, $32, $33); //@line 3243 "dictionary.cpp"
        $found=$call23; //@line 3243 "dictionary.cpp"
        var $tobool=((($call23))|0)!=0; //@line 3244 "dictionary.cpp"
        if (!($tobool)) { __label__ = 12;break $if_then$$if_end26$9; } //@line 3244 "dictionary.cpp"
  
        var $34=$flags_addr; //@line 3247 "dictionary.cpp"
        var $arrayidx25=(($34)&4294967295); //@line 3247 "dictionary.cpp"
        var $35=HEAP32[(($arrayidx25)>>2)]; //@line 3247 "dictionary.cpp"
        var $or=($35) | 128; //@line 3247 "dictionary.cpp"
        HEAP32[(($arrayidx25)>>2)]=$or; //@line 3247 "dictionary.cpp"
        var $36=$length; //@line 3248 "dictionary.cpp"
        HEAP32[((_dictionary_skipwords)>>2)]=$36; //@line 3248 "dictionary.cpp"
        $retval=1; //@line 3249 "dictionary.cpp"
        __label__ = 50;break $if_then$$if_end26$9; //@line 3249 "dictionary.cpp"
      }
    } while(0);
    if (__label__ == 12) {
  
      $length=0; //@line 3253 "dictionary.cpp"
      __lastLabel__ = 12; ; //@line 3253 "dictionary.cpp"
      $for_cond$19: while(1) { 
  
        var $37=__lastLabel__ == 19 ? $inc45 : (0); //@line 3253 "dictionary.cpp"
        var $cmp27=((($37))|0) < 159; //@line 3253 "dictionary.cpp"
        if (!($cmp27)) { __label__ = 20;break $for_cond$19; } //@line 3253 "dictionary.cpp"
  
        var $38=$word1; //@line 3255 "dictionary.cpp"
        var $incdec_ptr=(($38+1)&4294967295); //@line 3255 "dictionary.cpp"
        $word1=$incdec_ptr; //@line 3255 "dictionary.cpp"
        var $39=HEAPU8[($38)]; //@line 3255 "dictionary.cpp"
        $c=$39; //@line 3255 "dictionary.cpp"
        var $conv28=((($39))&255); //@line 3255 "dictionary.cpp"
        var $cmp29=((($conv28))|0)==0; //@line 3255 "dictionary.cpp"
        if ($cmp29) { __label__ = 20;break $for_cond$19; } //@line 3255 "dictionary.cpp"
  
        var $40=$c; //@line 3255 "dictionary.cpp"
        var $conv30=((($40))&255); //@line 3255 "dictionary.cpp"
        var $cmp31=((($conv30))|0)==32; //@line 3255 "dictionary.cpp"
        if ($cmp31) { __label__ = 20;break $for_cond$19; } //@line 3255 "dictionary.cpp"
  
        var $41=$c; //@line 3258 "dictionary.cpp"
        var $conv34=((($41))&255); //@line 3258 "dictionary.cpp"
        var $cmp35=((($conv34))|0)==46; //@line 3258 "dictionary.cpp"
        if ($cmp35) { __label__ = 17;; } else { __label__ = 19;; } //@line 3258 "dictionary.cpp"
        $land_lhs_true$$if_end43$24: do { 
          if (__label__ == 17) {
  
            var $42=$length; //@line 3258 "dictionary.cpp"
            var $cmp36=((($42))|0) > 0; //@line 3258 "dictionary.cpp"
            if (!($cmp36)) { __label__ = 19;break $land_lhs_true$$if_end43$24; } //@line 3258 "dictionary.cpp"
  
            var $43=$length; //@line 3258 "dictionary.cpp"
            var $sub=((($43)-1)&4294967295); //@line 3258 "dictionary.cpp"
            var $arrayidx38=(($word+$sub)&4294967295); //@line 3258 "dictionary.cpp"
            var $44=HEAP8[($arrayidx38)]; //@line 3258 "dictionary.cpp"
            var $conv39=(tempInt=(($44)),(tempInt>=128?tempInt-256:tempInt)); //@line 3258 "dictionary.cpp"
            var $isdigittmp=((($conv39)-48)&4294967295); //@line 3258 "dictionary.cpp"
            var $isdigit=((($isdigittmp))>>>0) < 10; //@line 3258 "dictionary.cpp"
            var $call40=((($isdigit))&1); //@line 3258 "dictionary.cpp"
            var $tobool41=((($call40))|0)!=0; //@line 3258 "dictionary.cpp"
            if ($tobool41) { __label__ = 20;break $for_cond$19; } //@line 3258 "dictionary.cpp"
          }
        } while(0);
  
        var $45=$c; //@line 3261 "dictionary.cpp"
        var $46=$length; //@line 3261 "dictionary.cpp"
        var $arrayidx44=(($word+$46)&4294967295); //@line 3261 "dictionary.cpp"
        HEAP8[($arrayidx44)]=$45; //@line 3261 "dictionary.cpp"
        var $47=$length; //@line 3253 "dictionary.cpp"
        var $inc45=((($47)+1)&4294967295); //@line 3253 "dictionary.cpp"
        $length=$inc45; //@line 3253 "dictionary.cpp"
        __lastLabel__ = 19; __label__ = 13;continue $for_cond$19; //@line 3253 "dictionary.cpp"
      }
  
      var $48=$length; //@line 3263 "dictionary.cpp"
      var $arrayidx46=(($word+$48)&4294967295); //@line 3263 "dictionary.cpp"
      HEAP8[($arrayidx46)]=0; //@line 3263 "dictionary.cpp"
      var $49=$tr_addr; //@line 3265 "dictionary.cpp"
      var $arraydecay47=(($word)&4294967295); //@line 3265 "dictionary.cpp"
      var $50=$word1; //@line 3265 "dictionary.cpp"
      var $51=$ph_out_addr; //@line 3265 "dictionary.cpp"
      var $52=$flags_addr; //@line 3265 "dictionary.cpp"
      var $53=$end_flags_addr; //@line 3265 "dictionary.cpp"
      var $54=$wtab_addr; //@line 3265 "dictionary.cpp"
      var $call48=__ZL11LookupDict2P10TranslatorPKcS2_PcPjiP8WORD_TAB($49, $arraydecay47, $50, $51, $52, $53, $54); //@line 3265 "dictionary.cpp"
      $found=$call48; //@line 3265 "dictionary.cpp"
      var $55=$flags_addr; //@line 3267 "dictionary.cpp"
      var $arrayidx49=(($55)&4294967295); //@line 3267 "dictionary.cpp"
      var $56=HEAP32[(($arrayidx49)>>2)]; //@line 3267 "dictionary.cpp"
      var $and=($56) & 134217728; //@line 3267 "dictionary.cpp"
      var $tobool50=((($and))|0)!=0; //@line 3267 "dictionary.cpp"
      if ($tobool50) { __label__ = 21;; } else { __label__ = 25;; } //@line 3267 "dictionary.cpp"
      $if_then51$$if_else66$29: do { 
        if (__label__ == 21) {
  
          var $57=$ph_out_addr; //@line 3269 "dictionary.cpp"
          var $58=$tr_addr; //@line 3269 "dictionary.cpp"
          var $phonemes_repeat=(($58+632)&4294967295); //@line 3269 "dictionary.cpp"
          var $arraydecay52=(($phonemes_repeat)&4294967295); //@line 3269 "dictionary.cpp"
          var $call53=_strcmp($57, $arraydecay52); //@line 3269 "dictionary.cpp"
          var $cmp54=((($call53))|0)==0; //@line 3269 "dictionary.cpp"
          var $59=$tr_addr; //@line 3271 "dictionary.cpp"
          if ($cmp54) { __label__ = 22;; } else { __label__ = 24;; } //@line 3269 "dictionary.cpp"
          if (__label__ == 22) {
  
            var $phonemes_repeat_count=(($59+652)&4294967295); //@line 3271 "dictionary.cpp"
            var $60=HEAP32[(($phonemes_repeat_count)>>2)]; //@line 3271 "dictionary.cpp"
            var $inc56=((($60)+1)&4294967295); //@line 3271 "dictionary.cpp"
            HEAP32[(($phonemes_repeat_count)>>2)]=$inc56; //@line 3271 "dictionary.cpp"
            var $61=$tr_addr; //@line 3272 "dictionary.cpp"
            var $phonemes_repeat_count57=(($61+652)&4294967295); //@line 3272 "dictionary.cpp"
            var $62=HEAP32[(($phonemes_repeat_count57)>>2)]; //@line 3272 "dictionary.cpp"
            var $cmp58=((($62))|0) > 3; //@line 3272 "dictionary.cpp"
            if (!($cmp58)) { __label__ = 26;break $if_then51$$if_else66$29; } //@line 3272 "dictionary.cpp"
  
            var $63=$ph_out_addr; //@line 3274 "dictionary.cpp"
            var $arrayidx60=(($63)&4294967295); //@line 3274 "dictionary.cpp"
            HEAP8[($arrayidx60)]=0; //@line 3274 "dictionary.cpp"
            ; //@line 3275 "dictionary.cpp"
          }
          else if (__label__ == 24) {
  
            var $phonemes_repeat62=(($59+632)&4294967295); //@line 3279 "dictionary.cpp"
            var $arraydecay63=(($phonemes_repeat62)&4294967295); //@line 3279 "dictionary.cpp"
            var $64=$ph_out_addr; //@line 3279 "dictionary.cpp"
            __Z8strncpy0PcPKci($arraydecay63, $64, 20); //@line 3279 "dictionary.cpp"
            var $65=$tr_addr; //@line 3280 "dictionary.cpp"
            var $phonemes_repeat_count64=(($65+652)&4294967295); //@line 3280 "dictionary.cpp"
            HEAP32[(($phonemes_repeat_count64)>>2)]=1; //@line 3280 "dictionary.cpp"
            ;
          }
        }
        else if (__label__ == 25) {
  
          var $66=$tr_addr; //@line 3285 "dictionary.cpp"
          var $phonemes_repeat_count67=(($66+652)&4294967295); //@line 3285 "dictionary.cpp"
          HEAP32[(($phonemes_repeat_count67)>>2)]=0; //@line 3285 "dictionary.cpp"
          ;
        }
      } while(0);
  
      var $67=$found; //@line 3289 "dictionary.cpp"
      var $cmp69=((($67))|0)==0; //@line 3289 "dictionary.cpp"
      if ($cmp69) { __label__ = 27;; } else { __label__ = 39;; } //@line 3289 "dictionary.cpp"
      $land_lhs_true70$$if_end117thread_pre_split$37: do { 
        if (__label__ == 27) {
  
          var $68=$flags_addr; //@line 3289 "dictionary.cpp"
          var $arrayidx71=(($68+4)&4294967295); //@line 3289 "dictionary.cpp"
          var $69=HEAP32[(($arrayidx71)>>2)]; //@line 3289 "dictionary.cpp"
          var $and72=($69) & 2048; //@line 3289 "dictionary.cpp"
          var $tobool73=((($and72))|0)!=0; //@line 3289 "dictionary.cpp"
          if ($tobool73) { __label__ = 28;; } else { __label__ = 31;; } //@line 3289 "dictionary.cpp"
          if (__label__ == 28) {
  
            var $arraydecay75=(($word)&4294967295); //@line 3292 "dictionary.cpp"
            $word2=$arraydecay75; //@line 3292 "dictionary.cpp"
            var $70=$word2; //@line 3293 "dictionary.cpp"
            var $71=HEAP8[($70)]; //@line 3293 "dictionary.cpp"
            var $conv76=(tempInt=(($71)),(tempInt>=128?tempInt-256:tempInt)); //@line 3293 "dictionary.cpp"
            var $cmp77=((($conv76))|0)==95; //@line 3293 "dictionary.cpp"
            if ($cmp77) { __label__ = 29;; } else { __label__ = 30;; } //@line 3293 "dictionary.cpp"
            if (__label__ == 29) {
  
              var $72=$word2; //@line 3293 "dictionary.cpp"
              var $incdec_ptr79=(($72+1)&4294967295); //@line 3293 "dictionary.cpp"
              $word2=$incdec_ptr79; //@line 3293 "dictionary.cpp"
              ; //@line 3293 "dictionary.cpp"
            }
  
            var $73=$word2; //@line 3294 "dictionary.cpp"
            var $call81=__Z7utf8_inPiPKc($letter, $73); //@line 3294 "dictionary.cpp"
            $len=$call81; //@line 3294 "dictionary.cpp"
            var $74=$tr_addr; //@line 3295 "dictionary.cpp"
            var $75=HEAP32[(($letter)>>2)]; //@line 3295 "dictionary.cpp"
            var $76=$ph_out_addr; //@line 3295 "dictionary.cpp"
            __Z20LookupAccentedLetterP10TranslatorjPc($74, $75, $76); //@line 3295 "dictionary.cpp"
            var $77=$word2; //@line 3296 "dictionary.cpp"
            var $78=$len; //@line 3296 "dictionary.cpp"
            var $add_ptr82=(($77+$78)&4294967295); //@line 3296 "dictionary.cpp"
            $found=$add_ptr82; //@line 3296 "dictionary.cpp"
            __lastLabel__ = 30; ; //@line 3297 "dictionary.cpp"
          }
          else if (__label__ == 31) {
  
            var $_pr=$found; //@line 3299 "dictionary.cpp"
            __lastLabel__ = 31; ;
          }
  
          var $79=__lastLabel__ == 31 ? $_pr : ($add_ptr82); //@line 3299 "dictionary.cpp"
          var $cmp84=((($79))|0)==0; //@line 3299 "dictionary.cpp"
          if (!($cmp84)) { __label__ = 39;break $land_lhs_true70$$if_end117thread_pre_split$37; } //@line 3299 "dictionary.cpp"
  
          var $80=$ph_out_addr; //@line 3301 "dictionary.cpp"
          var $arrayidx86=(($80)&4294967295); //@line 3301 "dictionary.cpp"
          HEAP8[($arrayidx86)]=0; //@line 3301 "dictionary.cpp"
          var $81=$end_flags_addr; //@line 3305 "dictionary.cpp"
          var $and87=($81) & 16; //@line 3305 "dictionary.cpp"
          var $tobool88=((($and87))|0)!=0; //@line 3305 "dictionary.cpp"
          if ($tobool88) { __label__ = 34;; } else { __label__ = 36;; } //@line 3305 "dictionary.cpp"
          $land_lhs_true89$$if_else99$47: do { 
            if (__label__ == 34) {
  
              var $82=$length; //@line 3305 "dictionary.cpp"
              var $sub90=((($82)-1)&4294967295); //@line 3305 "dictionary.cpp"
              var $arrayidx91=(($word+$sub90)&4294967295); //@line 3305 "dictionary.cpp"
              var $83=HEAP8[($arrayidx91)]; //@line 3305 "dictionary.cpp"
              var $conv92=(tempInt=(($83)),(tempInt>=128?tempInt-256:tempInt)); //@line 3305 "dictionary.cpp"
              var $cmp93=((($conv92))|0)==101; //@line 3305 "dictionary.cpp"
              if (!($cmp93)) { __label__ = 36;break $land_lhs_true89$$if_else99$47; } //@line 3305 "dictionary.cpp"
  
              var $84=$length; //@line 3308 "dictionary.cpp"
              var $sub95=((($84)-1)&4294967295); //@line 3308 "dictionary.cpp"
              var $arrayidx96=(($word+$sub95)&4294967295); //@line 3308 "dictionary.cpp"
              HEAP8[($arrayidx96)]=0; //@line 3308 "dictionary.cpp"
              var $85=$tr_addr; //@line 3309 "dictionary.cpp"
              var $arraydecay97=(($word)&4294967295); //@line 3309 "dictionary.cpp"
              var $86=$word1; //@line 3309 "dictionary.cpp"
              var $87=$ph_out_addr; //@line 3309 "dictionary.cpp"
              var $88=$flags_addr; //@line 3309 "dictionary.cpp"
              var $89=$end_flags_addr; //@line 3309 "dictionary.cpp"
              var $90=$wtab_addr; //@line 3309 "dictionary.cpp"
              var $call98=__ZL11LookupDict2P10TranslatorPKcS2_PcPjiP8WORD_TAB($85, $arraydecay97, $86, $87, $88, $89, $90); //@line 3309 "dictionary.cpp"
              $found=$call98; //@line 3309 "dictionary.cpp"
              __lastLabel__ = 35; __label__ = 40;break $land_lhs_true70$$if_end117thread_pre_split$37; //@line 3310 "dictionary.cpp"
            }
          } while(0);
  
          var $91=$end_flags_addr; //@line 3312 "dictionary.cpp"
          var $and100=($91) & 4096; //@line 3312 "dictionary.cpp"
          var $tobool101=((($and100))|0)!=0; //@line 3312 "dictionary.cpp"
          if (!($tobool101)) { __label__ = 39;break $land_lhs_true70$$if_end117thread_pre_split$37; } //@line 3312 "dictionary.cpp"
  
          var $92=$length; //@line 3312 "dictionary.cpp"
          var $sub103=((($92)-1)&4294967295); //@line 3312 "dictionary.cpp"
          var $arrayidx104=(($word+$sub103)&4294967295); //@line 3312 "dictionary.cpp"
          var $93=HEAP8[($arrayidx104)]; //@line 3312 "dictionary.cpp"
          var $conv105=(tempInt=(($93)),(tempInt>=128?tempInt-256:tempInt)); //@line 3312 "dictionary.cpp"
          var $94=$length; //@line 3312 "dictionary.cpp"
          var $sub106=((($94)-2)&4294967295); //@line 3312 "dictionary.cpp"
          var $arrayidx107=(($word+$sub106)&4294967295); //@line 3312 "dictionary.cpp"
          var $95=HEAP8[($arrayidx107)]; //@line 3312 "dictionary.cpp"
          var $conv108=(tempInt=(($95)),(tempInt>=128?tempInt-256:tempInt)); //@line 3312 "dictionary.cpp"
          var $cmp109=((($conv105))|0)==((($conv108))|0); //@line 3312 "dictionary.cpp"
          if (!($cmp109)) { __label__ = 39;break $land_lhs_true70$$if_end117thread_pre_split$37; } //@line 3312 "dictionary.cpp"
  
          var $96=$length; //@line 3315 "dictionary.cpp"
          var $sub111=((($96)-1)&4294967295); //@line 3315 "dictionary.cpp"
          var $arrayidx112=(($word+$sub111)&4294967295); //@line 3315 "dictionary.cpp"
          HEAP8[($arrayidx112)]=0; //@line 3315 "dictionary.cpp"
          var $97=$tr_addr; //@line 3316 "dictionary.cpp"
          var $arraydecay113=(($word)&4294967295); //@line 3316 "dictionary.cpp"
          var $98=$word1; //@line 3316 "dictionary.cpp"
          var $99=$ph_out_addr; //@line 3316 "dictionary.cpp"
          var $100=$flags_addr; //@line 3316 "dictionary.cpp"
          var $101=$end_flags_addr; //@line 3316 "dictionary.cpp"
          var $102=$wtab_addr; //@line 3316 "dictionary.cpp"
          var $call114=__ZL11LookupDict2P10TranslatorPKcS2_PcPjiP8WORD_TAB($97, $arraydecay113, $98, $99, $100, $101, $102); //@line 3316 "dictionary.cpp"
          $found=$call114; //@line 3316 "dictionary.cpp"
          __lastLabel__ = 38; __label__ = 40;break $land_lhs_true70$$if_end117thread_pre_split$37; //@line 3317 "dictionary.cpp"
        }
      } while(0);
      if (__label__ == 39) {
  
        var $_pr2=$found; //@line 3320 "dictionary.cpp"
        __lastLabel__ = 39; ;
      }
  
      var $103=__lastLabel__ == 39 ? $_pr2 : (__lastLabel__ == 35 ? $call98 : ($call114)); //@line 3320 "dictionary.cpp"
      var $tobool118=((($103))|0)!=0; //@line 3320 "dictionary.cpp"
      if ($tobool118) { __label__ = 41;; } else { __label__ = 49;; } //@line 3320 "dictionary.cpp"
      if (__label__ == 41) {
  
        var $104=$tr_addr; //@line 3323 "dictionary.cpp"
        var $langopts=(($104)&4294967295); //@line 3323 "dictionary.cpp"
        var $textmode=(($langopts+252)&4294967295); //@line 3323 "dictionary.cpp"
        var $105=HEAP8[($textmode)]; //@line 3323 "dictionary.cpp"
        var $tobool120=(tempInt=(($105)),(tempInt>=128?tempInt-256:tempInt))!=0; //@line 3323 "dictionary.cpp"
        if ($tobool120) { __label__ = 42;; } else { __label__ = 43;; } //@line 3323 "dictionary.cpp"
        if (__label__ == 42) {
  
          var $106=$flags_addr; //@line 3324 "dictionary.cpp"
          var $107=HEAP32[(($106)>>2)]; //@line 3324 "dictionary.cpp"
          var $xor=($107) ^ 536870912; //@line 3324 "dictionary.cpp"
          HEAP32[(($106)>>2)]=$xor; //@line 3324 "dictionary.cpp"
          ; //@line 3324 "dictionary.cpp"
        }
  
        var $108=$flags_addr; //@line 3326 "dictionary.cpp"
        var $109=HEAP32[(($108)>>2)]; //@line 3326 "dictionary.cpp"
        var $and123=($109) & 536870912; //@line 3326 "dictionary.cpp"
        var $tobool124=((($and123))|0)!=0; //@line 3326 "dictionary.cpp"
        if ($tobool124) { __label__ = 44;; } else { __label__ = 48;; } //@line 3326 "dictionary.cpp"
        if (__label__ == 44) {
  
          var $110=$end_flags_addr; //@line 3330 "dictionary.cpp"
          var $and126=($110) & 2; //@line 3330 "dictionary.cpp"
          var $tobool127=((($and126))|0)!=0; //@line 3330 "dictionary.cpp"
          if ($tobool127) { __label__ = 45;; } else { __label__ = 47;; } //@line 3330 "dictionary.cpp"
          $if_then128$$if_end138$63: do { 
            if (__label__ == 45) {
  
              HEAP8[(((__ZZ14LookupDictListP10TranslatorPPcS1_PjiP8WORD_TABE16word_replacement)&4294967295))]=0; //@line 3333 "dictionary.cpp"
              HEAP8[(((__ZZ14LookupDictListP10TranslatorPPcS1_PjiP8WORD_TABE16word_replacement+1)&4294967295))]=32; //@line 3334 "dictionary.cpp"
              var $111=$ph_out_addr; //@line 3335 "dictionary.cpp"
              var $call129=_sprintf(((__ZZ14LookupDictListP10TranslatorPPcS1_PjiP8WORD_TABE16word_replacement+2)&4294967295), ((__str15131)&4294967295), allocate([$111,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 3335 "dictionary.cpp"
              var $112=$wordptr_addr; //@line 3337 "dictionary.cpp"
              var $113=HEAP32[(($112)>>2)]; //@line 3337 "dictionary.cpp"
              $word1=$113; //@line 3337 "dictionary.cpp"
              var $114=$wordptr_addr; //@line 3338 "dictionary.cpp"
              HEAP32[(($114)>>2)]=((__ZZ14LookupDictListP10TranslatorPPcS1_PjiP8WORD_TABE16word_replacement+2)&4294967295); //@line 3338 "dictionary.cpp"
              var $115=HEAP32[((_option_phonemes)>>2)]; //@line 3340 "dictionary.cpp"
              var $cmp130=((($115))|0)==2; //@line 3340 "dictionary.cpp"
              if (!($cmp130)) { __label__ = 47;break $if_then128$$if_end138$63; } //@line 3340 "dictionary.cpp"
  
              var $116=$found; //@line 3342 "dictionary.cpp"
              var $117=$word1; //@line 3342 "dictionary.cpp"
              var $sub_ptr_lhs_cast=($116); //@line 3342 "dictionary.cpp"
              var $sub_ptr_rhs_cast=($117); //@line 3342 "dictionary.cpp"
              var $sub_ptr_sub=((($sub_ptr_lhs_cast)-($sub_ptr_rhs_cast))&4294967295); //@line 3342 "dictionary.cpp"
              $len=$sub_ptr_sub; //@line 3342 "dictionary.cpp"
              var $arraydecay132=(($word)&4294967295); //@line 3343 "dictionary.cpp"
              var $118=$word1; //@line 3343 "dictionary.cpp"
              var $119=$len; //@line 3343 "dictionary.cpp"
              var $src$, $dest$, $stop$, $stop4$, $fast$;
              $src$ = $118;
              $dest$ = $arraydecay132;
              $stop$ = $src$ + $119;
              if (($dest$%4) == ($src$%4) && $119 > 8) {
                while ($src$%4 !== 0 && $src$ < $stop$) {
                  ; HEAP8[$dest$++] = HEAP8[$src$++];
                }
                $src$ >>= 2;
                $dest$ >>= 2;
                $stop4$ = $stop$ >> 2;
                while ($src$ < $stop4$) {
              ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
                }
                $src$ <<= 2;
                $dest$ <<= 2;
              }while ($src$ < $stop$) {
                ; HEAP8[$dest$++] = HEAP8[$src$++];
              }; //@line 3343 "dictionary.cpp"
              var $120=$len; //@line 3344 "dictionary.cpp"
              var $arrayidx133=(($word+$120)&4294967295); //@line 3344 "dictionary.cpp"
              HEAP8[($arrayidx133)]=0; //@line 3344 "dictionary.cpp"
              var $121=HEAP32[((_f_trans)>>2)]; //@line 3345 "dictionary.cpp"
              var $arraydecay134=(($word)&4294967295); //@line 3345 "dictionary.cpp"
              var $122=$wordptr_addr; //@line 3345 "dictionary.cpp"
              var $123=HEAP32[(($122)>>2)]; //@line 3345 "dictionary.cpp"
              var $call135=_fprintf($121, ((__str16132)&4294967295), allocate([$arraydecay134,0,0,0,$123,0,0,0], ["i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 3345 "dictionary.cpp"
              ; //@line 3346 "dictionary.cpp"
            }
          } while(0);
  
          var $124=$ph_out_addr; //@line 3353 "dictionary.cpp"
          var $arrayidx139=(($124)&4294967295); //@line 3353 "dictionary.cpp"
          HEAP8[($arrayidx139)]=0; //@line 3353 "dictionary.cpp"
          $retval=0; //@line 3354 "dictionary.cpp"
          ; //@line 3354 "dictionary.cpp"
        }
        else if (__label__ == 48) {
  
          $retval=1; //@line 3357 "dictionary.cpp"
          ; //@line 3357 "dictionary.cpp"
        }
      }
      else if (__label__ == 49) {
  
        var $125=$ph_out_addr; //@line 3360 "dictionary.cpp"
        var $arrayidx142=(($125)&4294967295); //@line 3360 "dictionary.cpp"
        HEAP8[($arrayidx142)]=0; //@line 3360 "dictionary.cpp"
        $retval=0; //@line 3361 "dictionary.cpp"
        ; //@line 3361 "dictionary.cpp"
      }
    }
  
    var $126=$retval; //@line 3362 "dictionary.cpp"
    STACKTOP = __stackBase__;
    return $126; //@line 3362 "dictionary.cpp"
    return null;
  }
  

  function __ZL11LookupDict2P10TranslatorPKcS2_PcPjiP8WORD_TAB($tr, $word, $word2, $phonetic, $flags, $end_flags, $wtab) {
    var __stackBase__  = STACKTOP; STACKTOP += 320; _memset(__stackBase__, 0, 320);
    var __label__;
  
    var $retval;
    var $tr_addr;
    var $word_addr;
    var $word2_addr;
    var $phonetic_addr;
    var $flags_addr;
    var $end_flags_addr;
    var $wtab_addr;
    var $p;
    var $next;
    var $hash;
    var $phoneme_len;
    var $wlen;
    var $flag;
    var $dictionary_flags;
    var $dictionary_flags2;
    var $condition_failed;
    var $n_chars;
    var $no_phonemes;
    var $skipwords;
    var $ix;
    var $word_end;
    var $word1;
    var $wflags;
    var $word_buf=__stackBase__;
    var $flags1259;
    var $ph_decoded=__stackBase__+160;
    var $textmode;
    $tr_addr=$tr;
    $word_addr=$word;
    $word2_addr=$word2;
    $phonetic_addr=$phonetic;
    $flags_addr=$flags;
    $end_flags_addr=$end_flags;
    $wtab_addr=$wtab;
    $condition_failed=0; //@line 2887 "dictionary.cpp"
    $wflags=0; //@line 2894 "dictionary.cpp"
    var $0=$wtab_addr; //@line 2897 "dictionary.cpp"
    var $cmp=((($0))|0)!=0; //@line 2897 "dictionary.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 2897 "dictionary.cpp"
    if (__label__ == 1) {
  
      var $1=$wtab_addr; //@line 2899 "dictionary.cpp"
      var $flags1=(($1)&4294967295); //@line 2899 "dictionary.cpp"
      var $2=HEAP32[(($flags1)>>2)]; //@line 2899 "dictionary.cpp"
      $wflags=$2; //@line 2899 "dictionary.cpp"
      ; //@line 2900 "dictionary.cpp"
    }
  
    var $3=$word_addr; //@line 2902 "dictionary.cpp"
    $word1=$3; //@line 2902 "dictionary.cpp"
    var $4=$tr_addr; //@line 2903 "dictionary.cpp"
    var $transpose_min=(($4+288)&4294967295); //@line 2903 "dictionary.cpp"
    var $5=HEAP32[(($transpose_min)>>2)]; //@line 2903 "dictionary.cpp"
    var $cmp2=((($5))|0) > 0; //@line 2903 "dictionary.cpp"
    if ($cmp2) { __label__ = 3;; } else { __label__ = 4;; } //@line 2903 "dictionary.cpp"
    if (__label__ == 3) {
  
      var $arraydecay=(($word_buf)&4294967295); //@line 2905 "dictionary.cpp"
      var $6=$word_addr; //@line 2905 "dictionary.cpp"
      var $call=_strcpy($arraydecay, $6); //@line 2905 "dictionary.cpp"
      var $7=$tr_addr; //@line 2906 "dictionary.cpp"
      var $arraydecay4=(($word_buf)&4294967295); //@line 2906 "dictionary.cpp"
      var $call5=__Z17TransposeAlphabetP10TranslatorPc($7, $arraydecay4); //@line 2906 "dictionary.cpp"
      $wlen=$call5; //@line 2906 "dictionary.cpp"
      var $arraydecay6=(($word_buf)&4294967295); //@line 2907 "dictionary.cpp"
      $word_addr=$arraydecay6; //@line 2907 "dictionary.cpp"
      ; //@line 2908 "dictionary.cpp"
    }
    else if (__label__ == 4) {
  
      var $8=$word_addr; //@line 2911 "dictionary.cpp"
      var $call7=_strlen($8); //@line 2911 "dictionary.cpp"
      $wlen=$call7; //@line 2911 "dictionary.cpp"
      ;
    }
  
    var $9=$word_addr; //@line 2914 "dictionary.cpp"
    var $call9=__Z14HashDictionaryPKc($9); //@line 2914 "dictionary.cpp"
    $hash=$call9; //@line 2914 "dictionary.cpp"
    var $10=$hash; //@line 2915 "dictionary.cpp"
    var $11=$tr_addr; //@line 2915 "dictionary.cpp"
    var $dict_hashtab=(($11+1056)&4294967295); //@line 2915 "dictionary.cpp"
    var $arrayidx=(($dict_hashtab+$10*4)&4294967295); //@line 2915 "dictionary.cpp"
    var $12=HEAP32[(($arrayidx)>>2)]; //@line 2915 "dictionary.cpp"
    $p=$12; //@line 2915 "dictionary.cpp"
    var $cmp10=((($12))|0)==0; //@line 2917 "dictionary.cpp"
    if ($cmp10) { __label__ = 6;; } else { __label__ = 9;; } //@line 2917 "dictionary.cpp"
    if (__label__ == 6) {
  
      var $13=$flags_addr; //@line 2919 "dictionary.cpp"
      var $cmp12=((($13))|0)!=0; //@line 2919 "dictionary.cpp"
      if ($cmp12) { __label__ = 7;; } else { __label__ = 8;; } //@line 2919 "dictionary.cpp"
      if (__label__ == 7) {
  
        var $14=$flags_addr; //@line 2920 "dictionary.cpp"
        HEAP32[(($14)>>2)]=0; //@line 2920 "dictionary.cpp"
        ; //@line 2920 "dictionary.cpp"
      }
  
      $retval=0; //@line 2921 "dictionary.cpp"
      ; //@line 2921 "dictionary.cpp"
    }
    else if (__label__ == 9) {
      $while_cond$14: while(1) { 
  
        var $15=$p; //@line 2927 "dictionary.cpp"
        var $16=HEAP8[($15)]; //@line 2927 "dictionary.cpp"
        var $conv=(tempInt=(($16)),(tempInt>=128?tempInt-256:tempInt)); //@line 2927 "dictionary.cpp"
        var $cmp16=((($conv))|0)!=0; //@line 2927 "dictionary.cpp"
        if (!($cmp16)) { __label__ = 95;break $while_cond$14; } //@line 2927 "dictionary.cpp"
  
        var $17=$p; //@line 2929 "dictionary.cpp"
        var $18=$p; //@line 2929 "dictionary.cpp"
        var $arrayidx17=(($18)&4294967295); //@line 2929 "dictionary.cpp"
        var $19=HEAP8[($arrayidx17)]; //@line 2929 "dictionary.cpp"
        var $conv18=(tempInt=(($19)),(tempInt>=128?tempInt-256:tempInt)); //@line 2929 "dictionary.cpp"
        var $add_ptr=(($17+$conv18)&4294967295); //@line 2929 "dictionary.cpp"
        $next=$add_ptr; //@line 2929 "dictionary.cpp"
        var $20=$p; //@line 2931 "dictionary.cpp"
        var $arrayidx19=(($20+1)&4294967295); //@line 2931 "dictionary.cpp"
        var $21=HEAP8[($arrayidx19)]; //@line 2931 "dictionary.cpp"
        var $conv20=(tempInt=(($21)),(tempInt>=128?tempInt-256:tempInt)); //@line 2931 "dictionary.cpp"
        var $and=($conv20) & 127; //@line 2931 "dictionary.cpp"
        var $22=$wlen; //@line 2931 "dictionary.cpp"
        var $cmp21=((($and))|0)!=((($22))|0); //@line 2931 "dictionary.cpp"
        if ($cmp21) { __label__ = 12;; } else { __label__ = 11;; } //@line 2931 "dictionary.cpp"
        $if_then26$$lor_lhs_false$17: do { 
          if (__label__ == 11) {
  
            var $23=$word_addr; //@line 2931 "dictionary.cpp"
            var $24=$p; //@line 2931 "dictionary.cpp"
            var $arrayidx22=(($24+2)&4294967295); //@line 2931 "dictionary.cpp"
            var $25=$wlen; //@line 2931 "dictionary.cpp"
            var $and23=($25) & 63; //@line 2931 "dictionary.cpp"
            var $call24=_memcmp($23, $arrayidx22, $and23); //@line 2931 "dictionary.cpp"
            var $cmp25=((($call24))|0)!=0; //@line 2931 "dictionary.cpp"
            if ($cmp25) { __label__ = 12;break $if_then26$$lor_lhs_false$17; } //@line 2931 "dictionary.cpp"
  
            var $27=$word2_addr; //@line 2939 "dictionary.cpp"
            $word_end=$27; //@line 2939 "dictionary.cpp"
            $dictionary_flags=0; //@line 2941 "dictionary.cpp"
            $dictionary_flags2=0; //@line 2942 "dictionary.cpp"
            var $28=$p; //@line 2943 "dictionary.cpp"
            var $arrayidx28=(($28+1)&4294967295); //@line 2943 "dictionary.cpp"
            var $29=HEAP8[($arrayidx28)]; //@line 2943 "dictionary.cpp"
            var $conv29=(tempInt=(($29)),(tempInt>=128?tempInt-256:tempInt)); //@line 2943 "dictionary.cpp"
            var $and30=($conv29) & 128; //@line 2943 "dictionary.cpp"
            $no_phonemes=$and30; //@line 2943 "dictionary.cpp"
            var $30=$p; //@line 2945 "dictionary.cpp"
            var $arrayidx31=(($30+1)&4294967295); //@line 2945 "dictionary.cpp"
            var $31=HEAP8[($arrayidx31)]; //@line 2945 "dictionary.cpp"
            var $conv32=(tempInt=(($31)),(tempInt>=128?tempInt-256:tempInt)); //@line 2945 "dictionary.cpp"
            var $and33=($conv32) & 63; //@line 2945 "dictionary.cpp"
            var $add=((($and33)+2)&4294967295); //@line 2945 "dictionary.cpp"
            var $32=$p; //@line 2945 "dictionary.cpp"
            var $add_ptr34=(($32+$add)&4294967295); //@line 2945 "dictionary.cpp"
            $p=$add_ptr34; //@line 2945 "dictionary.cpp"
            var $33=$no_phonemes; //@line 2947 "dictionary.cpp"
            var $tobool=((($33))|0)!=0; //@line 2947 "dictionary.cpp"
            var $34=$phonetic_addr; //@line 2949 "dictionary.cpp"
            if ($tobool) { __label__ = 14;; } else { __label__ = 15;; } //@line 2947 "dictionary.cpp"
            if (__label__ == 14) {
  
              var $arrayidx36=(($34)&4294967295); //@line 2949 "dictionary.cpp"
              HEAP8[($arrayidx36)]=0; //@line 2949 "dictionary.cpp"
              $phoneme_len=0; //@line 2950 "dictionary.cpp"
              ; //@line 2951 "dictionary.cpp"
            }
            else if (__label__ == 15) {
  
              var $35=$p; //@line 2954 "dictionary.cpp"
              var $call38=_strcpy($34, $35); //@line 2954 "dictionary.cpp"
              var $36=$p; //@line 2955 "dictionary.cpp"
              var $call39=_strlen($36); //@line 2955 "dictionary.cpp"
              $phoneme_len=$call39; //@line 2955 "dictionary.cpp"
              var $37=$phoneme_len; //@line 2956 "dictionary.cpp"
              var $add40=((($37)+1)&4294967295); //@line 2956 "dictionary.cpp"
              var $38=$p; //@line 2956 "dictionary.cpp"
              var $add_ptr41=(($38+$add40)&4294967295); //@line 2956 "dictionary.cpp"
              $p=$add_ptr41; //@line 2956 "dictionary.cpp"
              ;
            }
            $while_cond43$23: while(1) { 
  
              var $39=$p; //@line 2959 "dictionary.cpp"
              var $40=$next; //@line 2959 "dictionary.cpp"
              var $cmp44=((($39))>>>0) < ((($40))>>>0); //@line 2959 "dictionary.cpp"
              if (!($cmp44)) { __label__ = 39;break $while_cond43$23; } //@line 2959 "dictionary.cpp"
  
              var $41=$p; //@line 2963 "dictionary.cpp"
              var $incdec_ptr=(($41+1)&4294967295); //@line 2963 "dictionary.cpp"
              $p=$incdec_ptr; //@line 2963 "dictionary.cpp"
              var $42=HEAP8[($41)]; //@line 2963 "dictionary.cpp"
              $flag=$42; //@line 2963 "dictionary.cpp"
              var $43=$flag; //@line 2964 "dictionary.cpp"
              var $conv46=((($43))&255); //@line 2964 "dictionary.cpp"
              var $cmp47=((($conv46))|0) >= 100; //@line 2964 "dictionary.cpp"
              var $44=$flag; //@line 2967 "dictionary.cpp"
              var $conv49=((($44))&255); //@line 2967 "dictionary.cpp"
              if ($cmp47) { __label__ = 18;; } else { __label__ = 23;; } //@line 2964 "dictionary.cpp"
              if (__label__ == 18) {
  
                var $cmp50=((($conv49))|0) >= 132; //@line 2967 "dictionary.cpp"
                var $45=$tr_addr; //@line 2970 "dictionary.cpp"
                var $dict_condition=(($45+692)&4294967295); //@line 2970 "dictionary.cpp"
                var $46=HEAPU32[(($dict_condition)>>2)]; //@line 2970 "dictionary.cpp"
                var $47=$flag; //@line 2970 "dictionary.cpp"
                var $conv52=((($47))&255); //@line 2970 "dictionary.cpp"
                if ($cmp50) { __label__ = 19;; } else { __label__ = 21;; } //@line 2967 "dictionary.cpp"
                if (__label__ == 19) {
  
                  var $sub=((($conv52)-132)&4294967295); //@line 2970 "dictionary.cpp"
                  var $shl=1 << ($sub); //@line 2970 "dictionary.cpp"
                  var $and53=($shl) & ($46); //@line 2970 "dictionary.cpp"
                  var $cmp54=((($and53))|0)!=0; //@line 2970 "dictionary.cpp"
                  if (!($cmp54)) { __label__ = 16;continue $while_cond43$23; } //@line 2970 "dictionary.cpp"
  
                  $condition_failed=1; //@line 2971 "dictionary.cpp"
                  __label__ = 16;continue $while_cond43$23; //@line 2971 "dictionary.cpp"
                }
                else if (__label__ == 21) {
  
                  var $sub60=((($conv52)-100)&4294967295); //@line 2976 "dictionary.cpp"
                  var $shl61=1 << ($sub60); //@line 2976 "dictionary.cpp"
                  var $and62=($shl61) & ($46); //@line 2976 "dictionary.cpp"
                  var $cmp63=((($and62))|0)==0; //@line 2976 "dictionary.cpp"
                  if (!($cmp63)) { __label__ = 16;continue $while_cond43$23; } //@line 2976 "dictionary.cpp"
  
                  $condition_failed=1; //@line 2977 "dictionary.cpp"
                  __label__ = 16;continue $while_cond43$23; //@line 2977 "dictionary.cpp"
                }
              }
              else if (__label__ == 23) {
  
                var $cmp69=((($conv49))|0) > 80; //@line 2981 "dictionary.cpp"
                if ($cmp69) { __label__ = 24;; } else { __label__ = 33;; } //@line 2981 "dictionary.cpp"
                if (__label__ == 24) {
  
                  var $48=$next; //@line 2985 "dictionary.cpp"
                  var $49=$p; //@line 2985 "dictionary.cpp"
                  var $sub_ptr_lhs_cast=($48); //@line 2985 "dictionary.cpp"
                  var $sub_ptr_rhs_cast=($49); //@line 2985 "dictionary.cpp"
                  var $sub_ptr_sub=((($sub_ptr_lhs_cast)-($sub_ptr_rhs_cast))&4294967295); //@line 2985 "dictionary.cpp"
                  $n_chars=$sub_ptr_sub; //@line 2985 "dictionary.cpp"
                  var $50=$flag; //@line 2986 "dictionary.cpp"
                  var $conv71=((($50))&255); //@line 2986 "dictionary.cpp"
                  var $sub72=((($conv71)-80)&4294967295); //@line 2986 "dictionary.cpp"
                  $skipwords=$sub72; //@line 2986 "dictionary.cpp"
                  $ix=0; //@line 2989 "dictionary.cpp"
                  var $51=$ix; //@line 2989 "dictionary.cpp"
                  var $52=$skipwords; //@line 2989 "dictionary.cpp"
                  var $cmp732=((($51))|0) <= ((($52))|0); //@line 2989 "dictionary.cpp"
                  if ($cmp732) { __label__ = 25;; } else { __label__ = 28;; } //@line 2989 "dictionary.cpp"
                  $for_body$$for_end$36: do { 
                    if (__label__ == 25) {
                      while(1) { 
  
                        var $53=$wflags; //@line 2991 "dictionary.cpp"
                        var $and74=($53) & 3072; //@line 2991 "dictionary.cpp"
                        var $tobool75=((($and74))|0)!=0; //@line 2991 "dictionary.cpp"
                        if ($tobool75) { __label__ = 26;; } else { __label__ = 27;; } //@line 2991 "dictionary.cpp"
                        if (__label__ == 26) {
  
                          $condition_failed=1; //@line 2993 "dictionary.cpp"
                          ; //@line 2994 "dictionary.cpp"
                        }
  
                        var $54=$ix; //@line 2989 "dictionary.cpp"
                        var $inc=((($54)+1)&4294967295); //@line 2989 "dictionary.cpp"
                        $ix=$inc; //@line 2989 "dictionary.cpp"
                        var $55=$ix; //@line 2989 "dictionary.cpp"
                        var $56=$skipwords; //@line 2989 "dictionary.cpp"
                        var $cmp73=((($55))|0) <= ((($56))|0); //@line 2989 "dictionary.cpp"
                        if ($cmp73) { __label__ = 25;continue ; } else { __label__ = 28;break $for_body$$for_end$36; } //@line 2989 "dictionary.cpp"
                      }
                    }
                  } while(0);
  
                  var $57=$word2_addr; //@line 2997 "dictionary.cpp"
                  var $58=$p; //@line 2997 "dictionary.cpp"
                  var $59=$n_chars; //@line 2997 "dictionary.cpp"
                  var $call78=_memcmp($57, $58, $59); //@line 2997 "dictionary.cpp"
                  var $cmp79=((($call78))|0)!=0; //@line 2997 "dictionary.cpp"
                  if ($cmp79) { __label__ = 29;break $while_cond43$23; } //@line 2997 "dictionary.cpp"
  
                  var $_pr=$condition_failed; //@line 3000 "dictionary.cpp"
                  var $tobool82=((($_pr))|0)!=0; //@line 3000 "dictionary.cpp"
                  if ($tobool82) { __label__ = 31;break $while_cond43$23; } //@line 3000 "dictionary.cpp"
  
                  var $61=$dictionary_flags; //@line 3006 "dictionary.cpp"
                  var $or=($61) | 128; //@line 3006 "dictionary.cpp"
                  $dictionary_flags=$or; //@line 3006 "dictionary.cpp"
                  var $62=$skipwords; //@line 3007 "dictionary.cpp"
                  HEAP32[((_dictionary_skipwords)>>2)]=$62; //@line 3007 "dictionary.cpp"
                  var $63=$next; //@line 3008 "dictionary.cpp"
                  $p=$63; //@line 3008 "dictionary.cpp"
                  var $64=$word2_addr; //@line 3009 "dictionary.cpp"
                  var $65=$n_chars; //@line 3009 "dictionary.cpp"
                  var $add_ptr85=(($64+$65)&4294967295); //@line 3009 "dictionary.cpp"
                  $word_end=$add_ptr85; //@line 3009 "dictionary.cpp"
                  __label__ = 16;continue $while_cond43$23; //@line 3010 "dictionary.cpp"
                }
                else if (__label__ == 33) {
  
                  var $66=$flag; //@line 3012 "dictionary.cpp"
                  var $conv87=((($66))&255); //@line 3012 "dictionary.cpp"
                  var $cmp88=((($conv87))|0) > 64; //@line 3012 "dictionary.cpp"
                  if ($cmp88) { __label__ = 34;; } else { __label__ = 36;; } //@line 3012 "dictionary.cpp"
                  if (__label__ == 34) {
  
                    var $67=$dictionary_flags; //@line 3015 "dictionary.cpp"
                    var $and90=($67) & -16; //@line 3015 "dictionary.cpp"
                    var $68=$flag; //@line 3015 "dictionary.cpp"
                    var $conv91=((($68))&255); //@line 3015 "dictionary.cpp"
                    var $and92=($conv91) & 15; //@line 3015 "dictionary.cpp"
                    var $or93=($and92) | ($and90); //@line 3015 "dictionary.cpp"
                    $dictionary_flags=$or93; //@line 3015 "dictionary.cpp"
                    var $69=$flag; //@line 3016 "dictionary.cpp"
                    var $conv94=((($69))&255); //@line 3016 "dictionary.cpp"
                    var $and95=($conv94) & 12; //@line 3016 "dictionary.cpp"
                    var $cmp96=((($and95))|0)==12; //@line 3016 "dictionary.cpp"
                    if (!($cmp96)) { __label__ = 16;continue $while_cond43$23; } //@line 3016 "dictionary.cpp"
  
                    var $70=$dictionary_flags; //@line 3017 "dictionary.cpp"
                    var $or98=($70) | 2048; //@line 3017 "dictionary.cpp"
                    $dictionary_flags=$or98; //@line 3017 "dictionary.cpp"
                    __label__ = 16;continue $while_cond43$23; //@line 3017 "dictionary.cpp"
                  }
                  else if (__label__ == 36) {
  
                    var $71=$flag; //@line 3020 "dictionary.cpp"
                    var $conv101=((($71))&255); //@line 3020 "dictionary.cpp"
                    var $cmp102=((($conv101))|0) >= 32; //@line 3020 "dictionary.cpp"
                    var $72=$flag; //@line 3022 "dictionary.cpp"
                    var $conv104=((($72))&255); //@line 3022 "dictionary.cpp"
                    if ($cmp102) { __label__ = 37;; } else { __label__ = 38;; } //@line 3020 "dictionary.cpp"
                    if (__label__ == 37) {
  
                      var $sub105=((($conv104)-32)&4294967295); //@line 3022 "dictionary.cpp"
                      var $shl106=1 << ($sub105); //@line 3022 "dictionary.cpp"
                      var $73=$dictionary_flags2; //@line 3022 "dictionary.cpp"
                      var $or107=($73) | ($shl106); //@line 3022 "dictionary.cpp"
                      $dictionary_flags2=$or107; //@line 3022 "dictionary.cpp"
                      __label__ = 16;continue $while_cond43$23; //@line 3023 "dictionary.cpp"
                    }
                    else if (__label__ == 38) {
  
                      var $shl110=1 << ($conv104); //@line 3026 "dictionary.cpp"
                      var $74=$dictionary_flags; //@line 3026 "dictionary.cpp"
                      var $or111=($74) | ($shl110); //@line 3026 "dictionary.cpp"
                      $dictionary_flags=$or111; //@line 3026 "dictionary.cpp"
                      __label__ = 16;continue $while_cond43$23;
                    }
                  }
                }
              }
            }
            $while_end$$if_end81_thread$$if_then83$53: do { 
              if (__label__ == 29) {
  
                $condition_failed=1; //@line 2998 "dictionary.cpp"
                __label__ = 31;break $while_end$$if_end81_thread$$if_then83$53; //@line 3000 "dictionary.cpp"
              }
            } while(0);
            if (__label__ == 31) {
  
              var $60=$next; //@line 3002 "dictionary.cpp"
              $p=$60; //@line 3002 "dictionary.cpp"
              ; //@line 3003 "dictionary.cpp"
            }
  
            var $75=$condition_failed; //@line 3030 "dictionary.cpp"
            var $tobool116=((($75))|0)!=0; //@line 3030 "dictionary.cpp"
            if ($tobool116) { __label__ = 40;; } else { __label__ = 41;; } //@line 3030 "dictionary.cpp"
            if (__label__ == 40) {
  
              $condition_failed=0; //@line 3032 "dictionary.cpp"
              __label__ = 9;continue $while_cond$14; //@line 3033 "dictionary.cpp"
            }
            else if (__label__ == 41) {
  
              var $76=$end_flags_addr; //@line 3036 "dictionary.cpp"
              var $and119=($76) & 4; //@line 3036 "dictionary.cpp"
              var $cmp120=((($and119))|0)==0; //@line 3036 "dictionary.cpp"
              if ($cmp120) { __label__ = 42;; } else { __label__ = 43;; } //@line 3036 "dictionary.cpp"
              if (__label__ == 42) {
  
                var $77=$dictionary_flags; //@line 3039 "dictionary.cpp"
                var $and122=($77) & 262144; //@line 3039 "dictionary.cpp"
                var $tobool123=((($and122))|0)!=0; //@line 3039 "dictionary.cpp"
                if ($tobool123) { __label__ = 9;continue $while_cond$14; } //@line 3039 "dictionary.cpp"
              }
  
              var $78=$end_flags_addr; //@line 3043 "dictionary.cpp"
              var $and127=($78) & 1024; //@line 3043 "dictionary.cpp"
              var $tobool128=((($and127))|0)!=0; //@line 3043 "dictionary.cpp"
              if ($tobool128) { __label__ = 44;; } else { __label__ = 45;; } //@line 3043 "dictionary.cpp"
              if (__label__ == 44) {
  
                var $79=$dictionary_flags; //@line 3043 "dictionary.cpp"
                var $and129=($79) & 1536; //@line 3043 "dictionary.cpp"
                var $tobool130=((($and129))|0)!=0; //@line 3043 "dictionary.cpp"
                if ($tobool130) { __label__ = 9;continue $while_cond$14; } //@line 3043 "dictionary.cpp"
              }
  
              var $80=$end_flags_addr; //@line 3046 "dictionary.cpp"
              var $and133=($80) & 4; //@line 3046 "dictionary.cpp"
              var $tobool134=((($and133))|0)!=0; //@line 3046 "dictionary.cpp"
              if ($tobool134) { __label__ = 46;; } else { __label__ = 49;; } //@line 3046 "dictionary.cpp"
              $if_then135$$if_end147$67: do { 
                if (__label__ == 46) {
  
                  var $81=$dictionary_flags; //@line 3049 "dictionary.cpp"
                  var $and136=($81) & 512; //@line 3049 "dictionary.cpp"
                  var $tobool137=((($and136))|0)!=0; //@line 3049 "dictionary.cpp"
                  if ($tobool137) { __label__ = 9;continue $while_cond$14; } //@line 3049 "dictionary.cpp"
  
                  var $82=$dictionary_flags; //@line 3052 "dictionary.cpp"
                  var $and140=($82) & 1024; //@line 3052 "dictionary.cpp"
                  var $tobool141=((($and140))|0)!=0; //@line 3052 "dictionary.cpp"
                  if (!($tobool141)) { __label__ = 49;break $if_then135$$if_end147$67; } //@line 3052 "dictionary.cpp"
  
                  var $83=$end_flags_addr; //@line 3052 "dictionary.cpp"
                  var $and143=($83) & 8; //@line 3052 "dictionary.cpp"
                  var $cmp144=((($and143))|0)==0; //@line 3052 "dictionary.cpp"
                  if ($cmp144) { __label__ = 9;continue $while_cond$14; } //@line 3052 "dictionary.cpp"
                }
              } while(0);
  
              var $84=$dictionary_flags2; //@line 3059 "dictionary.cpp"
              var $and148=($84) & 4096; //@line 3059 "dictionary.cpp"
              var $tobool149=((($and148))|0)!=0; //@line 3059 "dictionary.cpp"
              if ($tobool149) { __label__ = 50;; } else { __label__ = 51;; } //@line 3059 "dictionary.cpp"
              if (__label__ == 50) {
  
                var $85=$wflags; //@line 3061 "dictionary.cpp"
                var $and151=($85) & 16384; //@line 3061 "dictionary.cpp"
                var $tobool152=((($and151))|0)!=0; //@line 3061 "dictionary.cpp"
                if (!($tobool152)) { __label__ = 9;continue $while_cond$14; } //@line 3061 "dictionary.cpp"
              }
  
              var $86=$dictionary_flags2; //@line 3066 "dictionary.cpp"
              var $and156=($86) & 512; //@line 3066 "dictionary.cpp"
              var $tobool157=((($and156))|0)!=0; //@line 3066 "dictionary.cpp"
              if ($tobool157) { __label__ = 52;; } else { __label__ = 53;; } //@line 3066 "dictionary.cpp"
              if (__label__ == 52) {
  
                var $87=$wflags; //@line 3068 "dictionary.cpp"
                var $and159=($87) & 2; //@line 3068 "dictionary.cpp"
                var $tobool160=((($and159))|0)!=0; //@line 3068 "dictionary.cpp"
                if (!($tobool160)) { __label__ = 9;continue $while_cond$14; } //@line 3068 "dictionary.cpp"
              }
  
              var $88=$dictionary_flags2; //@line 3073 "dictionary.cpp"
              var $and164=($88) & 1024; //@line 3073 "dictionary.cpp"
              var $tobool165=((($and164))|0)!=0; //@line 3073 "dictionary.cpp"
              if ($tobool165) { __label__ = 54;; } else { __label__ = 55;; } //@line 3073 "dictionary.cpp"
              if (__label__ == 54) {
  
                var $89=$wflags; //@line 3075 "dictionary.cpp"
                var $and167=($89) & 1; //@line 3075 "dictionary.cpp"
                var $tobool168=((($and167))|0)!=0; //@line 3075 "dictionary.cpp"
                if (!($tobool168)) { __label__ = 9;continue $while_cond$14; } //@line 3075 "dictionary.cpp"
              }
  
              var $90=$dictionary_flags; //@line 3080 "dictionary.cpp"
              var $and172=($90) & 33554432; //@line 3080 "dictionary.cpp"
              var $tobool173=((($and172))|0)!=0; //@line 3080 "dictionary.cpp"
              if ($tobool173) { __label__ = 56;; } else { __label__ = 57;; } //@line 3080 "dictionary.cpp"
              if (__label__ == 56) {
  
                var $91=$wflags; //@line 3082 "dictionary.cpp"
                var $and175=($91) & 65536; //@line 3082 "dictionary.cpp"
                var $tobool176=((($and175))|0)!=0; //@line 3082 "dictionary.cpp"
                if (!($tobool176)) { __label__ = 9;continue $while_cond$14; } //@line 3082 "dictionary.cpp"
              }
  
              var $92=$dictionary_flags; //@line 3086 "dictionary.cpp"
              var $and180=($92) & 16384; //@line 3086 "dictionary.cpp"
              var $tobool181=((($and180))|0)!=0; //@line 3086 "dictionary.cpp"
              if ($tobool181) { __label__ = 58;; } else { __label__ = 59;; } //@line 3086 "dictionary.cpp"
              if (__label__ == 58) {
  
                var $93=$word_end; //@line 3086 "dictionary.cpp"
                var $94=$tr_addr; //@line 3086 "dictionary.cpp"
                var $clause_end=(($94+8292)&4294967295); //@line 3086 "dictionary.cpp"
                var $95=HEAPU32[(($clause_end)>>2)]; //@line 3086 "dictionary.cpp"
                var $cmp183=((($93))>>>0) < ((($95))>>>0); //@line 3086 "dictionary.cpp"
                if ($cmp183) { __label__ = 9;continue $while_cond$14; } //@line 3086 "dictionary.cpp"
              }
  
              var $96=$dictionary_flags; //@line 3092 "dictionary.cpp"
              var $and186=($96) & 32768; //@line 3092 "dictionary.cpp"
              var $tobool187=((($and186))|0)!=0; //@line 3092 "dictionary.cpp"
              if ($tobool187) { __label__ = 60;; } else { __label__ = 61;; } //@line 3092 "dictionary.cpp"
              if (__label__ == 60) {
  
                var $97=$wtab_addr; //@line 3092 "dictionary.cpp"
                var $flags189=(($97)&4294967295); //@line 3092 "dictionary.cpp"
                var $98=HEAP32[(($flags189)>>2)]; //@line 3092 "dictionary.cpp"
                var $and190=($98) & 512; //@line 3092 "dictionary.cpp"
                var $tobool191=((($and190))|0)!=0; //@line 3092 "dictionary.cpp"
                if (!($tobool191)) { __label__ = 9;continue $while_cond$14; } //@line 3092 "dictionary.cpp"
              }
  
              var $99=$dictionary_flags2; //@line 3098 "dictionary.cpp"
              var $and194=($99) & 8192; //@line 3098 "dictionary.cpp"
              var $tobool195=((($and194))|0)!=0; //@line 3098 "dictionary.cpp"
              if ($tobool195) { __label__ = 62;; } else { __label__ = 63;; } //@line 3098 "dictionary.cpp"
              if (__label__ == 62) {
  
                var $100=$tr_addr; //@line 3098 "dictionary.cpp"
                var $clause_terminator=(($100+8324)&4294967295); //@line 3098 "dictionary.cpp"
                var $101=HEAP32[(($clause_terminator)>>2)]; //@line 3098 "dictionary.cpp"
                var $and197=($101) & 524288; //@line 3098 "dictionary.cpp"
                var $tobool198=((($and197))|0)!=0; //@line 3098 "dictionary.cpp"
                if (!($tobool198)) { __label__ = 9;continue $while_cond$14; } //@line 3098 "dictionary.cpp"
              }
  
              var $102=$dictionary_flags2; //@line 3104 "dictionary.cpp"
              var $and201=($102) & 16; //@line 3104 "dictionary.cpp"
              var $tobool202=((($and201))|0)!=0; //@line 3104 "dictionary.cpp"
              if ($tobool202) { __label__ = 64;; } else { __label__ = 67;; } //@line 3104 "dictionary.cpp"
              $if_then203$$if_end213$93: do { 
                if (__label__ == 64) {
  
                  var $103=$tr_addr; //@line 3108 "dictionary.cpp"
                  var $expect_verb=(($103+8272)&4294967295); //@line 3108 "dictionary.cpp"
                  var $104=HEAP32[(($expect_verb)>>2)]; //@line 3108 "dictionary.cpp"
                  var $tobool204=((($104))|0)!=0; //@line 3108 "dictionary.cpp"
                  if ($tobool204) { __label__ = 67;break $if_then203$$if_end213$93; } //@line 3108 "dictionary.cpp"
  
                  var $105=$tr_addr; //@line 3108 "dictionary.cpp"
                  var $expect_verb_s=(($105+8280)&4294967295); //@line 3108 "dictionary.cpp"
                  var $106=HEAP32[(($expect_verb_s)>>2)]; //@line 3108 "dictionary.cpp"
                  var $tobool206=((($106))|0)!=0; //@line 3108 "dictionary.cpp"
                  if (!($tobool206)) { __label__ = 9;continue $while_cond$14; } //@line 3108 "dictionary.cpp"
  
                  var $107=$end_flags_addr; //@line 3108 "dictionary.cpp"
                  var $and208=($107) & 8; //@line 3108 "dictionary.cpp"
                  var $tobool209=((($and208))|0)!=0; //@line 3108 "dictionary.cpp"
                  if (!($tobool209)) { __label__ = 9;continue $while_cond$14; } //@line 3108 "dictionary.cpp"
                }
              } while(0);
  
              var $108=$dictionary_flags2; //@line 3119 "dictionary.cpp"
              var $and214=($108) & 64; //@line 3119 "dictionary.cpp"
              var $tobool215=((($and214))|0)!=0; //@line 3119 "dictionary.cpp"
              if ($tobool215) { __label__ = 68;; } else { __label__ = 69;; } //@line 3119 "dictionary.cpp"
              if (__label__ == 68) {
  
                var $109=$tr_addr; //@line 3121 "dictionary.cpp"
                var $expect_past=(($109+8276)&4294967295); //@line 3121 "dictionary.cpp"
                var $110=HEAP32[(($expect_past)>>2)]; //@line 3121 "dictionary.cpp"
                var $tobool217=((($110))|0)!=0; //@line 3121 "dictionary.cpp"
                if (!($tobool217)) { __label__ = 9;continue $while_cond$14; } //@line 3121 "dictionary.cpp"
              }
  
              var $111=$dictionary_flags2; //@line 3128 "dictionary.cpp"
              var $and221=($111) & 32; //@line 3128 "dictionary.cpp"
              var $tobool222=((($and221))|0)!=0; //@line 3128 "dictionary.cpp"
              if ($tobool222) { __label__ = 70;; } else { __label__ = 71;; } //@line 3128 "dictionary.cpp"
              if (__label__ == 70) {
  
                var $112=$tr_addr; //@line 3130 "dictionary.cpp"
                var $expect_noun=(($112+8284)&4294967295); //@line 3130 "dictionary.cpp"
                var $113=HEAP32[(($expect_noun)>>2)]; //@line 3130 "dictionary.cpp"
                var $tobool224=((($113))|0)!=0; //@line 3130 "dictionary.cpp"
                if (!($tobool224)) { __label__ = 9;continue $while_cond$14; } //@line 3130 "dictionary.cpp"
              }
  
              var $114=$dictionary_flags; //@line 3137 "dictionary.cpp"
              var $and228=($114) & 2097152; //@line 3137 "dictionary.cpp"
              var $tobool229=((($and228))|0)!=0; //@line 3137 "dictionary.cpp"
              if (!($tobool229)) { __label__ = 74;break $while_cond$14; } //@line 3137 "dictionary.cpp"
  
              var $115=$tr_addr; //@line 3140 "dictionary.cpp"
              var $translator_name=(($115+280)&4294967295); //@line 3140 "dictionary.cpp"
              var $116=HEAP32[(($translator_name)>>2)]; //@line 3140 "dictionary.cpp"
              var $cmp231=((($116))|0)==26741; //@line 3140 "dictionary.cpp"
              if (!($cmp231)) { __label__ = 74;break $while_cond$14; } //@line 3140 "dictionary.cpp"
  
              var $117=$tr_addr; //@line 3140 "dictionary.cpp"
              var $prev_dict_flags=(($117+8320)&4294967295); //@line 3140 "dictionary.cpp"
              var $118=HEAP32[(($prev_dict_flags)>>2)]; //@line 3140 "dictionary.cpp"
              var $and233=($118) & 1048576; //@line 3140 "dictionary.cpp"
              var $tobool234=((($and233))|0)!=0; //@line 3140 "dictionary.cpp"
              if ($tobool234) { __label__ = 74;break $while_cond$14; } else { __label__ = 9;continue $while_cond$14; } //@line 3140 "dictionary.cpp"
            }
          }
        } while(0);
  
        var $26=$next; //@line 2934 "dictionary.cpp"
        $p=$26; //@line 2934 "dictionary.cpp"
        __label__ = 9;continue $while_cond$14; //@line 2935 "dictionary.cpp"
      }
      if (__label__ == 95) {
  
        $retval=0; //@line 3198 "dictionary.cpp"
        ; //@line 3198 "dictionary.cpp"
      }
      else if (__label__ == 74) {
  
        var $119=$flags_addr; //@line 3144 "dictionary.cpp"
        var $cmp238=((($119))|0)!=0; //@line 3144 "dictionary.cpp"
        if ($cmp238) { __label__ = 75;; } else { __label__ = 76;; } //@line 3144 "dictionary.cpp"
        if (__label__ == 75) {
  
          var $120=$dictionary_flags; //@line 3146 "dictionary.cpp"
          var $or240=($120) | 1073741824; //@line 3146 "dictionary.cpp"
          var $121=$flags_addr; //@line 3146 "dictionary.cpp"
          var $arrayidx241=(($121)&4294967295); //@line 3146 "dictionary.cpp"
          HEAP32[(($arrayidx241)>>2)]=$or240; //@line 3146 "dictionary.cpp"
          var $122=$dictionary_flags2; //@line 3147 "dictionary.cpp"
          var $123=$flags_addr; //@line 3147 "dictionary.cpp"
          var $arrayidx242=(($123+4)&4294967295); //@line 3147 "dictionary.cpp"
          HEAP32[(($arrayidx242)>>2)]=$122; //@line 3147 "dictionary.cpp"
          ; //@line 3148 "dictionary.cpp"
        }
  
        var $124=$phoneme_len; //@line 3150 "dictionary.cpp"
        var $cmp244=((($124))|0)==0; //@line 3150 "dictionary.cpp"
        if ($cmp244) { __label__ = 77;; } else { __label__ = 80;; } //@line 3150 "dictionary.cpp"
        if (__label__ == 77) {
  
          var $125=HEAP32[((_option_phonemes)>>2)]; //@line 3152 "dictionary.cpp"
          var $cmp246=((($125))|0)==2; //@line 3152 "dictionary.cpp"
          if ($cmp246) { __label__ = 78;; } else { __label__ = 79;; } //@line 3152 "dictionary.cpp"
          if (__label__ == 78) {
  
            var $126=HEAP32[((_f_trans)>>2)]; //@line 3154 "dictionary.cpp"
            var $127=$word1; //@line 3154 "dictionary.cpp"
            var $128=$flags_addr; //@line 3154 "dictionary.cpp"
            var $call248=__Z22print_dictionary_flagsPj($128); //@line 3154 "dictionary.cpp"
            var $call249=_fprintf($126, ((__str28144)&4294967295), allocate([$127,0,0,0,((__ZZ22print_dictionary_flagsPjE3buf)&4294967295),0,0,0], ["i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 3154 "dictionary.cpp"
            ; //@line 3155 "dictionary.cpp"
          }
  
          $retval=0; //@line 3156 "dictionary.cpp"
          ; //@line 3156 "dictionary.cpp"
        }
        else if (__label__ == 80) {
  
          var $129=$flags_addr; //@line 3159 "dictionary.cpp"
          var $cmp252=((($129))|0)!=0; //@line 3159 "dictionary.cpp"
          if ($cmp252) { __label__ = 81;; } else { __label__ = 82;; } //@line 3159 "dictionary.cpp"
          if (__label__ == 81) {
  
            var $130=$flags_addr; //@line 3160 "dictionary.cpp"
            var $arrayidx254=(($130)&4294967295); //@line 3160 "dictionary.cpp"
            var $131=HEAP32[(($arrayidx254)>>2)]; //@line 3160 "dictionary.cpp"
            var $or255=($131) | -2147483648; //@line 3160 "dictionary.cpp"
            HEAP32[(($arrayidx254)>>2)]=$or255; //@line 3160 "dictionary.cpp"
            ; //@line 3160 "dictionary.cpp"
          }
  
          var $132=HEAP32[((_option_phonemes)>>2)]; //@line 3162 "dictionary.cpp"
          var $cmp257=((($132))|0)==2; //@line 3162 "dictionary.cpp"
          if ($cmp257) { __label__ = 83;; } else { __label__ = 94;; } //@line 3162 "dictionary.cpp"
          $if_then258$$if_end296$122: do { 
            if (__label__ == 83) {
  
              $flags1259=0; //@line 3164 "dictionary.cpp"
              var $133=$phonetic_addr; //@line 3168 "dictionary.cpp"
              var $arraydecay260=(($ph_decoded)&4294967295); //@line 3168 "dictionary.cpp"
              __Z14DecodePhonemesPKcPc($133, $arraydecay260); //@line 3168 "dictionary.cpp"
              var $134=$flags_addr; //@line 3169 "dictionary.cpp"
              var $cmp261=((($134))|0)!=0; //@line 3169 "dictionary.cpp"
              if ($cmp261) { __label__ = 84;; } else { __label__ = 85;; } //@line 3169 "dictionary.cpp"
              if (__label__ == 84) {
  
                var $135=$flags_addr; //@line 3170 "dictionary.cpp"
                var $arrayidx263=(($135)&4294967295); //@line 3170 "dictionary.cpp"
                var $136=HEAP32[(($arrayidx263)>>2)]; //@line 3170 "dictionary.cpp"
                $flags1259=$136; //@line 3170 "dictionary.cpp"
                ; //@line 3170 "dictionary.cpp"
              }
  
              var $137=$dictionary_flags; //@line 3172 "dictionary.cpp"
              var $and265=($137) & 536870912; //@line 3172 "dictionary.cpp"
              var $cmp266=((($and265))|0)==0; //@line 3172 "dictionary.cpp"
              if ($cmp266) { __label__ = 86;; } else { __label__ = 87;; } //@line 3172 "dictionary.cpp"
              if (__label__ == 86) {
  
                $textmode=0; //@line 3173 "dictionary.cpp"
                ; //@line 3173 "dictionary.cpp"
              }
              else if (__label__ == 87) {
  
                $textmode=1; //@line 3175 "dictionary.cpp"
                ;
              }
  
              var $138=$textmode; //@line 3177 "dictionary.cpp"
              var $139=HEAP32[((_translator)>>2)]; //@line 3177 "dictionary.cpp"
              var $langopts=(($139)&4294967295); //@line 3177 "dictionary.cpp"
              var $textmode270=(($langopts+252)&4294967295); //@line 3177 "dictionary.cpp"
              var $140=HEAP8[($textmode270)]; //@line 3177 "dictionary.cpp"
              var $conv271=(tempInt=(($140)),(tempInt>=128?tempInt-256:tempInt)); //@line 3177 "dictionary.cpp"
              var $cmp272=((($138))|0)==((($conv271))|0); //@line 3177 "dictionary.cpp"
              if (!($cmp272)) { __label__ = 94;break $if_then258$$if_end296$122; } //@line 3177 "dictionary.cpp"
  
              var $141=HEAP32[((_dictionary_skipwords)>>2)]; //@line 3180 "dictionary.cpp"
              var $tobool274=((($141))|0)!=0; //@line 3180 "dictionary.cpp"
              if ($tobool274) { __label__ = 90;; } else { __label__ = 92;; } //@line 3180 "dictionary.cpp"
              $land_lhs_true275$$if_else289$132: do { 
                if (__label__ == 90) {
  
                  var $142=$wtab_addr; //@line 3180 "dictionary.cpp"
                  var $cmp276=((($142))|0)!=0; //@line 3180 "dictionary.cpp"
                  if (!($cmp276)) { __label__ = 92;break $land_lhs_true275$$if_else289$132; } //@line 3180 "dictionary.cpp"
  
                  var $arraydecay278=(($word_buf)&4294967295); //@line 3184 "dictionary.cpp"
                  var $143=$word2_addr; //@line 3184 "dictionary.cpp"
                  var $144=$word_end; //@line 3184 "dictionary.cpp"
                  var $145=$word2_addr; //@line 3184 "dictionary.cpp"
                  var $sub_ptr_lhs_cast279=($144); //@line 3184 "dictionary.cpp"
                  var $sub_ptr_rhs_cast280=($145); //@line 3184 "dictionary.cpp"
                  var $sub_ptr_sub281=((($sub_ptr_lhs_cast279)-($sub_ptr_rhs_cast280))&4294967295); //@line 3184 "dictionary.cpp"
                  var $src$, $dest$, $stop$, $stop4$, $fast$;
                  $src$ = $143;
                  $dest$ = $arraydecay278;
                  $stop$ = $src$ + $sub_ptr_sub281;
                  if (($dest$%4) == ($src$%4) && $sub_ptr_sub281 > 8) {
                    while ($src$%4 !== 0 && $src$ < $stop$) {
                      ; HEAP8[$dest$++] = HEAP8[$src$++];
                    }
                    $src$ >>= 2;
                    $dest$ >>= 2;
                    $stop4$ = $stop$ >> 2;
                    while ($src$ < $stop4$) {
                  ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
                    }
                    $src$ <<= 2;
                    $dest$ <<= 2;
                  }while ($src$ < $stop$) {
                    ; HEAP8[$dest$++] = HEAP8[$src$++];
                  }; //@line 3184 "dictionary.cpp"
                  var $146=$word_end; //@line 3185 "dictionary.cpp"
                  var $147=$word2_addr; //@line 3185 "dictionary.cpp"
                  var $sub_ptr_lhs_cast282=($146); //@line 3185 "dictionary.cpp"
                  var $sub_ptr_rhs_cast283=($147); //@line 3185 "dictionary.cpp"
                  var $sub_ptr_rhs_cast283_neg=(((-($sub_ptr_rhs_cast283)))&4294967295);
                  var $sub_ptr_sub284=((($sub_ptr_lhs_cast282)-1)&4294967295); //@line 3185 "dictionary.cpp"
                  var $sub285=((($sub_ptr_sub284)+($sub_ptr_rhs_cast283_neg))&4294967295); //@line 3185 "dictionary.cpp"
                  var $arrayidx286=(($word_buf+$sub285)&4294967295); //@line 3185 "dictionary.cpp"
                  HEAP8[($arrayidx286)]=0; //@line 3185 "dictionary.cpp"
                  var $148=HEAP32[((_f_trans)>>2)]; //@line 3186 "dictionary.cpp"
                  var $149=$word1; //@line 3186 "dictionary.cpp"
                  var $arraydecay287=(($word_buf)&4294967295); //@line 3186 "dictionary.cpp"
                  var $call288=_fprintf($148, ((__str29145)&4294967295), allocate([$149,0,0,0,$arraydecay287,0,0,0], ["i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 3186 "dictionary.cpp"
                  __label__ = 93;break $land_lhs_true275$$if_else289$132; //@line 3187 "dictionary.cpp"
                }
              } while(0);
              if (__label__ == 92) {
  
                var $150=HEAP32[((_f_trans)>>2)]; //@line 3190 "dictionary.cpp"
                var $151=$word1; //@line 3190 "dictionary.cpp"
                var $call290=_fprintf($150, ((__str30146)&4294967295), allocate([$151,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 3190 "dictionary.cpp"
                ;
              }
  
              var $152=HEAP32[((_f_trans)>>2)]; //@line 3192 "dictionary.cpp"
              var $arraydecay292=(($ph_decoded)&4294967295); //@line 3192 "dictionary.cpp"
              var $153=$flags_addr; //@line 3192 "dictionary.cpp"
              var $call293=__Z22print_dictionary_flagsPj($153); //@line 3192 "dictionary.cpp"
              var $call294=_fprintf($152, ((__str31147)&4294967295), allocate([$arraydecay292,0,0,0,((__ZZ22print_dictionary_flagsPjE3buf)&4294967295),0,0,0], ["i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 3192 "dictionary.cpp"
              ; //@line 3193 "dictionary.cpp"
            }
          } while(0);
  
          var $154=$word_end; //@line 3195 "dictionary.cpp"
          $retval=$154; //@line 3195 "dictionary.cpp"
          ; //@line 3195 "dictionary.cpp"
        }
      }
    }
  
    var $155=$retval; //@line 3199 "dictionary.cpp"
    STACKTOP = __stackBase__;
    return $155; //@line 3199 "dictionary.cpp"
    return null;
  }
  

  function __Z11LookupFlagsP10TranslatorPKc($tr, $word) {
    var __stackBase__  = STACKTOP; STACKTOP += 104; _memset(__stackBase__, 0, 104);
    var __label__;
  
    var $tr_addr;
    var $word_addr;
    var $buf=__stackBase__;
    var $word1=__stackBase__+100;
    $tr_addr=$tr;
    $word_addr=$word;
    HEAP32[((((__ZZ11LookupFlagsP10TranslatorPKcE5flags+4)&4294967295))>>2)]=0; //@line 3379 "dictionary.cpp"
    HEAP32[((((__ZZ11LookupFlagsP10TranslatorPKcE5flags)&4294967295))>>2)]=0; //@line 3379 "dictionary.cpp"
    var $0=$word_addr; //@line 3380 "dictionary.cpp"
    HEAP32[(($word1)>>2)]=$0; //@line 3380 "dictionary.cpp"
    var $1=$tr_addr; //@line 3381 "dictionary.cpp"
    var $arraydecay=(($buf)&4294967295); //@line 3381 "dictionary.cpp"
    var $call=__Z14LookupDictListP10TranslatorPPcS1_PjiP8WORD_TAB($1, $word1, $arraydecay, ((__ZZ11LookupFlagsP10TranslatorPKcE5flags)&4294967295), 0, 0); //@line 3381 "dictionary.cpp"
    var $2=HEAP32[((((__ZZ11LookupFlagsP10TranslatorPKcE5flags)&4294967295))>>2)]; //@line 3382 "dictionary.cpp"
    STACKTOP = __stackBase__;
    return $2; //@line 3382 "dictionary.cpp"
    return null;
  }
  

  function __Z12RemoveEndingP10TranslatorPciS1_($tr, $word, $end_type, $word_copy) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $tr_addr;
    var $word_addr;
    var $end_type_addr;
    var $word_copy_addr;
    var $i;
    var $word_end;
    var $len_ending;
    var $end_flags;
    var $p;
    var $len;
    $tr_addr=$tr;
    $word_addr=$word;
    $end_type_addr=$end_type;
    $word_copy_addr=$word_copy;
    var $0=$word_addr; //@line 3414 "dictionary.cpp"
    $word_end=$0; //@line 3414 "dictionary.cpp"
    var $1=$word_end; //@line 3414 "dictionary.cpp"
    var $2=HEAP8[($1)]; //@line 3414 "dictionary.cpp"
    var $conv8=(tempInt=(($2)),(tempInt>=128?tempInt-256:tempInt)); //@line 3414 "dictionary.cpp"
    var $cmp10=((($conv8))|0)!=32; //@line 3414 "dictionary.cpp"
    var $3=$word_end; //@line 3417 "dictionary.cpp"
    if ($cmp10) { __lastLabel__ = 0; __label__ = 1;; } else { __lastLabel__ = 0; __label__ = 4;; } //@line 3414 "dictionary.cpp"
    $for_body$$for_end$2: do { 
      if (__label__ == 1) {
        while(1) { 
  
          var $4=__lastLabel__ == 3 ? $10 : ($3);
          var $5=HEAP8[($4)]; //@line 3417 "dictionary.cpp"
          var $conv1=(tempInt=(($5)),(tempInt>=128?tempInt-256:tempInt)); //@line 3417 "dictionary.cpp"
          var $cmp2=((($conv1))|0)==69; //@line 3417 "dictionary.cpp"
          if ($cmp2) { __label__ = 2;; } else { __label__ = 3;; } //@line 3417 "dictionary.cpp"
          if (__label__ == 2) {
  
            var $6=$word_end; //@line 3418 "dictionary.cpp"
            HEAP8[($6)]=101; //@line 3418 "dictionary.cpp"
            ; //@line 3418 "dictionary.cpp"
          }
  
          var $7=$word_end; //@line 3414 "dictionary.cpp"
          var $incdec_ptr=(($7+1)&4294967295); //@line 3414 "dictionary.cpp"
          $word_end=$incdec_ptr; //@line 3414 "dictionary.cpp"
          var $8=$word_end; //@line 3414 "dictionary.cpp"
          var $9=HEAP8[($8)]; //@line 3414 "dictionary.cpp"
          var $conv=(tempInt=(($9)),(tempInt>=128?tempInt-256:tempInt)); //@line 3414 "dictionary.cpp"
          var $cmp=((($conv))|0)!=32; //@line 3414 "dictionary.cpp"
          var $10=$word_end; //@line 3417 "dictionary.cpp"
          if ($cmp) { __lastLabel__ = 3; __label__ = 1;continue ; } else { __lastLabel__ = 3; __label__ = 4;break $for_body$$for_end$2; } //@line 3414 "dictionary.cpp"
        }
      }
    } while(0);
  
    var $_lcssa7=__lastLabel__ == 0 ? $3 : ($10);
    var $11=$word_addr; //@line 3420 "dictionary.cpp"
    var $sub_ptr_lhs_cast=($_lcssa7); //@line 3420 "dictionary.cpp"
    var $sub_ptr_rhs_cast=($11); //@line 3420 "dictionary.cpp"
    var $sub_ptr_sub=((($sub_ptr_lhs_cast)-($sub_ptr_rhs_cast))&4294967295); //@line 3420 "dictionary.cpp"
    $i=$sub_ptr_sub; //@line 3420 "dictionary.cpp"
    var $12=$word_copy_addr; //@line 3421 "dictionary.cpp"
    var $13=$word_addr; //@line 3421 "dictionary.cpp"
    var $14=$i; //@line 3421 "dictionary.cpp"
    var $src$, $dest$, $stop$, $stop4$, $fast$;
    $src$ = $13;
    $dest$ = $12;
    $stop$ = $src$ + $14;
    if (($dest$%4) == ($src$%4) && $14 > 8) {
      while ($src$%4 !== 0 && $src$ < $stop$) {
        ; HEAP8[$dest$++] = HEAP8[$src$++];
      }
      $src$ >>= 2;
      $dest$ >>= 2;
      $stop4$ = $stop$ >> 2;
      while ($src$ < $stop4$) {
    ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
      }
      $src$ <<= 2;
      $dest$ <<= 2;
    }while ($src$ < $stop$) {
      ; HEAP8[$dest$++] = HEAP8[$src$++];
    }; //@line 3421 "dictionary.cpp"
    var $15=$i; //@line 3422 "dictionary.cpp"
    var $16=$word_copy_addr; //@line 3422 "dictionary.cpp"
    var $arrayidx=(($16+$15)&4294967295); //@line 3422 "dictionary.cpp"
    HEAP8[($arrayidx)]=0; //@line 3422 "dictionary.cpp"
    var $17=$end_type_addr; //@line 3425 "dictionary.cpp"
    var $and=($17) & 63; //@line 3425 "dictionary.cpp"
    $i=$and; //@line 3425 "dictionary.cpp"
    $len_ending=$and; //@line 3425 "dictionary.cpp"
    var $cmp46=((($and))|0) > 0; //@line 3425 "dictionary.cpp"
    if ($cmp46) { __label__ = 5;; } else { __label__ = 8;; } //@line 3425 "dictionary.cpp"
    $for_body5$$for_end12$9: do { 
      if (__label__ == 5) {
        $for_body5$10: while(1) { 
  
          var $18=$word_end; //@line 3427 "dictionary.cpp"
          var $incdec_ptr6=(($18+-1)&4294967295); //@line 3427 "dictionary.cpp"
          $word_end=$incdec_ptr6; //@line 3427 "dictionary.cpp"
          var $19=$word_end; //@line 3428 "dictionary.cpp"
          var $20=HEAP8[($19)]; //@line 3428 "dictionary.cpp"
          var $conv73=(tempInt=(($20)),(tempInt>=128?tempInt-256:tempInt)); //@line 3428 "dictionary.cpp"
          var $and84=($conv73) & 192; //@line 3428 "dictionary.cpp"
          var $cmp95=((($and84))|0)==128; //@line 3428 "dictionary.cpp"
          if ($cmp95) { __label__ = 6;; } else { __label__ = 7;; } //@line 3428 "dictionary.cpp"
          $while_body$$for_inc11$12: do { 
            if (__label__ == 6) {
              while(1) { 
  
                var $21=$word_end; //@line 3430 "dictionary.cpp"
                var $incdec_ptr10=(($21+-1)&4294967295); //@line 3430 "dictionary.cpp"
                $word_end=$incdec_ptr10; //@line 3430 "dictionary.cpp"
                var $22=$len_ending; //@line 3431 "dictionary.cpp"
                var $inc=((($22)+1)&4294967295); //@line 3431 "dictionary.cpp"
                $len_ending=$inc; //@line 3431 "dictionary.cpp"
                var $23=$word_end; //@line 3428 "dictionary.cpp"
                var $24=HEAP8[($23)]; //@line 3428 "dictionary.cpp"
                var $conv7=(tempInt=(($24)),(tempInt>=128?tempInt-256:tempInt)); //@line 3428 "dictionary.cpp"
                var $and8=($conv7) & 192; //@line 3428 "dictionary.cpp"
                var $cmp9=((($and8))|0)==128; //@line 3428 "dictionary.cpp"
                if ($cmp9) { __label__ = 6;continue ; } else { __label__ = 7;break $while_body$$for_inc11$12; } //@line 3428 "dictionary.cpp"
              }
            }
          } while(0);
  
          var $25=$i; //@line 3425 "dictionary.cpp"
          var $dec=((($25)-1)&4294967295); //@line 3425 "dictionary.cpp"
          $i=$dec; //@line 3425 "dictionary.cpp"
          var $cmp4=((($dec))|0) > 0; //@line 3425 "dictionary.cpp"
          if ($cmp4) { __label__ = 5;continue $for_body5$10; } else { __label__ = 8;break $for_body5$$for_end12$9; } //@line 3425 "dictionary.cpp"
        }
      }
    } while(0);
  
    $i=0; //@line 3436 "dictionary.cpp"
    var $26=$i; //@line 3436 "dictionary.cpp"
    var $27=$len_ending; //@line 3436 "dictionary.cpp"
    var $cmp142=((($26))|0) < ((($27))|0); //@line 3436 "dictionary.cpp"
    var $28=$i; //@line 3438 "dictionary.cpp"
    if ($cmp142) { __lastLabel__ = 8; __label__ = 9;; } else { __lastLabel__ = 8; __label__ = 10;; } //@line 3436 "dictionary.cpp"
    $for_body15$$for_end21$17: do { 
      if (__label__ == 9) {
        while(1) { 
  
          var $29=__lastLabel__ == 9 ? $38 : ($28);
          var $30=$word_end; //@line 3438 "dictionary.cpp"
          var $arrayidx16=(($30+$29)&4294967295); //@line 3438 "dictionary.cpp"
          var $31=HEAP8[($arrayidx16)]; //@line 3438 "dictionary.cpp"
          var $32=$i; //@line 3438 "dictionary.cpp"
          var $arrayidx17=((__ZZ12RemoveEndingP10TranslatorPciS1_E6ending+$32)&4294967295); //@line 3438 "dictionary.cpp"
          HEAP8[($arrayidx17)]=$31; //@line 3438 "dictionary.cpp"
          var $33=$i; //@line 3439 "dictionary.cpp"
          var $34=$word_end; //@line 3439 "dictionary.cpp"
          var $arrayidx18=(($34+$33)&4294967295); //@line 3439 "dictionary.cpp"
          HEAP8[($arrayidx18)]=32; //@line 3439 "dictionary.cpp"
          var $35=$i; //@line 3436 "dictionary.cpp"
          var $inc20=((($35)+1)&4294967295); //@line 3436 "dictionary.cpp"
          $i=$inc20; //@line 3436 "dictionary.cpp"
          var $36=$i; //@line 3436 "dictionary.cpp"
          var $37=$len_ending; //@line 3436 "dictionary.cpp"
          var $cmp14=((($36))|0) < ((($37))|0); //@line 3436 "dictionary.cpp"
          var $38=$i; //@line 3438 "dictionary.cpp"
          if ($cmp14) { __lastLabel__ = 9; __label__ = 9;continue ; } else { __lastLabel__ = 9; __label__ = 10;break $for_body15$$for_end21$17; } //@line 3436 "dictionary.cpp"
        }
      }
    } while(0);
  
    var $_lcssa=__lastLabel__ == 8 ? $28 : ($38);
    var $arrayidx22=((__ZZ12RemoveEndingP10TranslatorPciS1_E6ending+$_lcssa)&4294967295); //@line 3441 "dictionary.cpp"
    HEAP8[($arrayidx22)]=0; //@line 3441 "dictionary.cpp"
    var $39=$word_end; //@line 3442 "dictionary.cpp"
    var $incdec_ptr23=(($39+-1)&4294967295); //@line 3442 "dictionary.cpp"
    $word_end=$incdec_ptr23; //@line 3442 "dictionary.cpp"
    var $40=$end_type_addr; //@line 3444 "dictionary.cpp"
    var $and24=($40) & 65520; //@line 3444 "dictionary.cpp"
    var $or=($and24) | 4; //@line 3444 "dictionary.cpp"
    $end_flags=$or; //@line 3444 "dictionary.cpp"
    var $41=$end_type_addr; //@line 3450 "dictionary.cpp"
    var $and25=($41) & 512; //@line 3450 "dictionary.cpp"
    var $tobool=((($and25))|0)!=0; //@line 3450 "dictionary.cpp"
    if ($tobool) { __label__ = 11;; } else { __label__ = 13;; } //@line 3450 "dictionary.cpp"
    $if_then26$$if_end33$21: do { 
      if (__label__ == 11) {
  
        var $42=$word_end; //@line 3452 "dictionary.cpp"
        var $arrayidx27=(($42)&4294967295); //@line 3452 "dictionary.cpp"
        var $43=HEAP8[($arrayidx27)]; //@line 3452 "dictionary.cpp"
        var $conv28=(tempInt=(($43)),(tempInt>=128?tempInt-256:tempInt)); //@line 3452 "dictionary.cpp"
        var $cmp29=((($conv28))|0)==105; //@line 3452 "dictionary.cpp"
        if (!($cmp29)) { __label__ = 13;break $if_then26$$if_end33$21; } //@line 3452 "dictionary.cpp"
  
        var $44=$word_end; //@line 3453 "dictionary.cpp"
        var $arrayidx31=(($44)&4294967295); //@line 3453 "dictionary.cpp"
        HEAP8[($arrayidx31)]=121; //@line 3453 "dictionary.cpp"
        ; //@line 3453 "dictionary.cpp"
      }
    } while(0);
  
    var $45=$end_type_addr; //@line 3456 "dictionary.cpp"
    var $and34=($45) & 256; //@line 3456 "dictionary.cpp"
    var $tobool35=((($and34))|0)!=0; //@line 3456 "dictionary.cpp"
    if ($tobool35) { __label__ = 14;; } else { __label__ = 33;; } //@line 3456 "dictionary.cpp"
    $if_then36$$if_end98$25: do { 
      if (__label__ == 14) {
  
        var $46=$tr_addr; //@line 3458 "dictionary.cpp"
        var $translator_name=(($46+280)&4294967295); //@line 3458 "dictionary.cpp"
        var $47=HEAP32[(($translator_name)>>2)]; //@line 3458 "dictionary.cpp"
        var $cmp37=((($47))|0)==25966; //@line 3458 "dictionary.cpp"
        var $48=$tr_addr; //@line 3461 "dictionary.cpp"
        if ($cmp37) { __label__ = 15;; } else { __label__ = 28;; } //@line 3458 "dictionary.cpp"
        $if_then38$$if_else80$27: do { 
          if (__label__ == 15) {
  
            var $49=$word_end; //@line 3461 "dictionary.cpp"
            var $arrayidx39=(($49+-1)&4294967295); //@line 3461 "dictionary.cpp"
            var $50=HEAP8[($arrayidx39)]; //@line 3461 "dictionary.cpp"
            var $conv40=(tempInt=(($50)),(tempInt>=128?tempInt-256:tempInt)); //@line 3461 "dictionary.cpp"
            var $call=__ZL8IsLetterP10Translatorii($48, $conv40, 7); //@line 3461 "dictionary.cpp"
            var $tobool41=((($call))|0)!=0; //@line 3461 "dictionary.cpp"
            if ($tobool41) { __label__ = 16;; } else { __label__ = 23;; } //@line 3461 "dictionary.cpp"
            $land_lhs_true$$if_else$29: do { 
              if (__label__ == 16) {
  
                var $51=$tr_addr; //@line 3461 "dictionary.cpp"
                var $52=$word_end; //@line 3461 "dictionary.cpp"
                var $arrayidx42=(($52)&4294967295); //@line 3461 "dictionary.cpp"
                var $53=HEAP8[($arrayidx42)]; //@line 3461 "dictionary.cpp"
                var $conv43=(tempInt=(($53)),(tempInt>=128?tempInt-256:tempInt)); //@line 3461 "dictionary.cpp"
                var $call44=__ZL8IsLetterP10Translatorii($51, $conv43, 1); //@line 3461 "dictionary.cpp"
                var $tobool45=((($call44))|0)!=0; //@line 3461 "dictionary.cpp"
                if (!($tobool45)) { __label__ = 23;break $land_lhs_true$$if_else$29; } //@line 3461 "dictionary.cpp"
  
                $i=0; //@line 3465 "dictionary.cpp"
                ; //@line 3465 "dictionary.cpp"
                while(1) { 
  
                  var $54=$i; //@line 3465 "dictionary.cpp"
                  var $arrayidx48=((__ZZ12RemoveEndingP10TranslatorPciS1_E16add_e_exceptions+$54*4)&4294967295); //@line 3465 "dictionary.cpp"
                  var $55=HEAP32[(($arrayidx48)>>2)]; //@line 3465 "dictionary.cpp"
                  $p=$55; //@line 3465 "dictionary.cpp"
                  var $cmp49=((($55))|0)!=0; //@line 3465 "dictionary.cpp"
                  if (!($cmp49)) { __label__ = 22;break ; } //@line 3465 "dictionary.cpp"
  
                  var $56=$p; //@line 3467 "dictionary.cpp"
                  var $call51=_strlen($56); //@line 3467 "dictionary.cpp"
                  $len=$call51; //@line 3467 "dictionary.cpp"
                  var $57=$p; //@line 3468 "dictionary.cpp"
                  var $58=$len; //@line 3468 "dictionary.cpp"
                  var $sub=((1-($58))&4294967295); //@line 3468 "dictionary.cpp"
                  var $59=$word_end; //@line 3468 "dictionary.cpp"
                  var $arrayidx52=(($59+$sub)&4294967295); //@line 3468 "dictionary.cpp"
                  var $60=$len; //@line 3468 "dictionary.cpp"
                  var $call53=_memcmp($57, $arrayidx52, $60); //@line 3468 "dictionary.cpp"
                  var $cmp54=((($call53))|0)==0; //@line 3468 "dictionary.cpp"
                  if ($cmp54) { __label__ = 21;break ; } //@line 3468 "dictionary.cpp"
  
                  var $61=$i; //@line 3465 "dictionary.cpp"
                  var $inc58=((($61)+1)&4294967295); //@line 3465 "dictionary.cpp"
                  $i=$inc58; //@line 3465 "dictionary.cpp"
                  __label__ = 18;continue ; //@line 3465 "dictionary.cpp"
                }
                if (__label__ == 21) {
  
                  var $_pr=$p; //@line 3473 "dictionary.cpp"
                  var $cmp60=((($_pr))|0)==0; //@line 3473 "dictionary.cpp"
                  if (!($cmp60)) { __label__ = 30;break $if_then38$$if_else80$27; } //@line 3473 "dictionary.cpp"
                }
  
                var $62=$end_flags; //@line 3474 "dictionary.cpp"
                var $or62=($62) | 16; //@line 3474 "dictionary.cpp"
                $end_flags=$or62; //@line 3474 "dictionary.cpp"
                __label__ = 30;break $if_then38$$if_else80$27; //@line 3474 "dictionary.cpp"
              }
            } while(0);
  
            $i=0; //@line 3478 "dictionary.cpp"
            ; //@line 3478 "dictionary.cpp"
            while(1) { 
  
              var $63=$i; //@line 3478 "dictionary.cpp"
              var $arrayidx65=((__ZZ12RemoveEndingP10TranslatorPciS1_E15add_e_additions+$63*4)&4294967295); //@line 3478 "dictionary.cpp"
              var $64=HEAP32[(($arrayidx65)>>2)]; //@line 3478 "dictionary.cpp"
              $p=$64; //@line 3478 "dictionary.cpp"
              var $cmp66=((($64))|0)!=0; //@line 3478 "dictionary.cpp"
              if (!($cmp66)) { __label__ = 30;break $if_then38$$if_else80$27; } //@line 3478 "dictionary.cpp"
  
              var $65=$p; //@line 3480 "dictionary.cpp"
              var $call68=_strlen($65); //@line 3480 "dictionary.cpp"
              $len=$call68; //@line 3480 "dictionary.cpp"
              var $66=$p; //@line 3481 "dictionary.cpp"
              var $67=$len; //@line 3481 "dictionary.cpp"
              var $sub69=((1-($67))&4294967295); //@line 3481 "dictionary.cpp"
              var $68=$word_end; //@line 3481 "dictionary.cpp"
              var $arrayidx70=(($68+$sub69)&4294967295); //@line 3481 "dictionary.cpp"
              var $69=$len; //@line 3481 "dictionary.cpp"
              var $call71=_memcmp($66, $arrayidx70, $69); //@line 3481 "dictionary.cpp"
              var $cmp72=((($call71))|0)==0; //@line 3481 "dictionary.cpp"
              if ($cmp72) { __label__ = 26;break ; } //@line 3481 "dictionary.cpp"
  
              var $71=$i; //@line 3478 "dictionary.cpp"
              var $inc77=((($71)+1)&4294967295); //@line 3478 "dictionary.cpp"
              $i=$inc77; //@line 3478 "dictionary.cpp"
              __label__ = 24;continue ; //@line 3478 "dictionary.cpp"
            }
  
            var $70=$end_flags; //@line 3483 "dictionary.cpp"
            var $or74=($70) | 16; //@line 3483 "dictionary.cpp"
            $end_flags=$or74; //@line 3483 "dictionary.cpp"
            ; //@line 3484 "dictionary.cpp"
          }
          else if (__label__ == 28) {
  
            var $langopts=(($48)&4294967295); //@line 3490 "dictionary.cpp"
            var $suffix_add_e=(($langopts+276)&4294967295); //@line 3490 "dictionary.cpp"
            var $72=HEAP32[(($suffix_add_e)>>2)]; //@line 3490 "dictionary.cpp"
            var $cmp81=((($72))|0)!=0; //@line 3490 "dictionary.cpp"
            if (!($cmp81)) { __label__ = 30;break $if_then38$$if_else80$27; } //@line 3490 "dictionary.cpp"
  
            var $73=$end_flags; //@line 3492 "dictionary.cpp"
            var $or83=($73) | 16; //@line 3492 "dictionary.cpp"
            $end_flags=$or83; //@line 3492 "dictionary.cpp"
            ; //@line 3493 "dictionary.cpp"
          }
        } while(0);
  
        var $74=$end_flags; //@line 3495 "dictionary.cpp"
        var $and86=($74) & 16; //@line 3495 "dictionary.cpp"
        var $tobool87=((($and86))|0)!=0; //@line 3495 "dictionary.cpp"
        if (!($tobool87)) { __label__ = 33;break $if_then36$$if_end98$25; } //@line 3495 "dictionary.cpp"
  
        var $75=$tr_addr; //@line 3497 "dictionary.cpp"
        var $langopts89=(($75)&4294967295); //@line 3497 "dictionary.cpp"
        var $suffix_add_e90=(($langopts89+276)&4294967295); //@line 3497 "dictionary.cpp"
        var $76=HEAP32[(($suffix_add_e90)>>2)]; //@line 3497 "dictionary.cpp"
        var $77=$word_end; //@line 3497 "dictionary.cpp"
        var $arrayidx91=(($77+1)&4294967295); //@line 3497 "dictionary.cpp"
        var $call92=__Z8utf8_outjPc($76, $arrayidx91); //@line 3497 "dictionary.cpp"
        var $78=HEAP32[((_option_phonemes)>>2)]; //@line 3499 "dictionary.cpp"
        var $cmp93=((($78))|0)==2; //@line 3499 "dictionary.cpp"
        if (!($cmp93)) { __label__ = 33;break $if_then36$$if_end98$25; } //@line 3499 "dictionary.cpp"
  
        var $79=HEAP32[((_f_trans)>>2)]; //@line 3501 "dictionary.cpp"
        var $80=_fwrite(((__str25141)&4294967295), 6, 1, $79); //@line 3501 "dictionary.cpp"
        ; //@line 3502 "dictionary.cpp"
      }
    } while(0);
  
    var $81=$end_type_addr; //@line 3506 "dictionary.cpp"
    var $and99=($81) & 2048; //@line 3506 "dictionary.cpp"
    var $tobool100=((($and99))|0)!=0; //@line 3506 "dictionary.cpp"
    if ($tobool100) { __label__ = 34;; } else { __label__ = 36;; } //@line 3506 "dictionary.cpp"
    $land_lhs_true101$$if_end105$51: do { 
      if (__label__ == 34) {
  
        var $82=$tr_addr; //@line 3506 "dictionary.cpp"
        var $expect_verb=(($82+8272)&4294967295); //@line 3506 "dictionary.cpp"
        var $83=HEAP32[(($expect_verb)>>2)]; //@line 3506 "dictionary.cpp"
        var $cmp102=((($83))|0)==0; //@line 3506 "dictionary.cpp"
        if (!($cmp102)) { __label__ = 36;break $land_lhs_true101$$if_end105$51; } //@line 3506 "dictionary.cpp"
  
        var $84=$tr_addr; //@line 3507 "dictionary.cpp"
        var $expect_verb104=(($84+8272)&4294967295); //@line 3507 "dictionary.cpp"
        HEAP32[(($expect_verb104)>>2)]=1; //@line 3507 "dictionary.cpp"
        ; //@line 3507 "dictionary.cpp"
      }
    } while(0);
  
    var $call106=_strcmp(((__ZZ12RemoveEndingP10TranslatorPciS1_E6ending)&4294967295), ((__str5172)&4294967295)); //@line 3510 "dictionary.cpp"
    var $cmp107=((($call106))|0)==0; //@line 3510 "dictionary.cpp"
    if ($cmp107) { __label__ = 38;; } else { __label__ = 37;; } //@line 3510 "dictionary.cpp"
    $if_then110$$lor_lhs_false$55: do { 
      if (__label__ == 37) {
  
        var $call108=_strcmp(((__ZZ12RemoveEndingP10TranslatorPciS1_E6ending)&4294967295), ((__str27143)&4294967295)); //@line 3510 "dictionary.cpp"
        var $cmp109=((($call108))|0)==0; //@line 3510 "dictionary.cpp"
        if ($cmp109) { __label__ = 38;break $if_then110$$lor_lhs_false$55; } else { __label__ = 39;break $if_then110$$lor_lhs_false$55; } //@line 3510 "dictionary.cpp"
      }
    } while(0);
    if (__label__ == 38) {
  
      var $85=$end_flags; //@line 3511 "dictionary.cpp"
      var $or111=($85) | 8; //@line 3511 "dictionary.cpp"
      $end_flags=$or111; //@line 3511 "dictionary.cpp"
      ; //@line 3511 "dictionary.cpp"
    }
  
    var $86=HEAP8[(((__ZZ12RemoveEndingP10TranslatorPciS1_E6ending)&4294967295))]; //@line 3514 "dictionary.cpp"
    var $conv113=(tempInt=(($86)),(tempInt>=128?tempInt-256:tempInt)); //@line 3514 "dictionary.cpp"
    var $cmp114=((($conv113))|0)==39; //@line 3514 "dictionary.cpp"
    if ($cmp114) { __label__ = 40;; } else { __label__ = 41;; } //@line 3514 "dictionary.cpp"
    if (__label__ == 40) {
  
      var $87=$end_flags; //@line 3515 "dictionary.cpp"
      var $and116=($87) & -5; //@line 3515 "dictionary.cpp"
      $end_flags=$and116; //@line 3515 "dictionary.cpp"
      ; //@line 3515 "dictionary.cpp"
    }
  
    var $88=$end_flags; //@line 3517 "dictionary.cpp"
    ;
    return $88; //@line 3517 "dictionary.cpp"
    return null;
  }
  

  function __ZL13IsLetterGroupP10TranslatorPcii($tr, $word, $group, $pre) {
    ;
    var __label__;
  
    var $retval;
    var $tr_addr;
    var $word_addr;
    var $group_addr;
    var $pre_addr;
    var $p;
    var $w;
    var $len;
    $tr_addr=$tr;
    $word_addr=$word;
    $group_addr=$group;
    $pre_addr=$pre;
    $len=0; //@line 692 "dictionary.cpp"
    var $0=$group_addr; //@line 694 "dictionary.cpp"
    var $1=$tr_addr; //@line 694 "dictionary.cpp"
    var $letterGroups=(($1+5152)&4294967295); //@line 694 "dictionary.cpp"
    var $arrayidx=(($letterGroups+$0*4)&4294967295); //@line 694 "dictionary.cpp"
    var $2=HEAP32[(($arrayidx)>>2)]; //@line 694 "dictionary.cpp"
    $p=$2; //@line 694 "dictionary.cpp"
    var $3=$p; //@line 695 "dictionary.cpp"
    var $cmp=((($3))|0)==0; //@line 695 "dictionary.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 695 "dictionary.cpp"
    if (__label__ == 1) {
  
      $retval=0; //@line 696 "dictionary.cpp"
      ; //@line 696 "dictionary.cpp"
    }
    else if (__label__ == 2) {
      $while_cond$4: while(1) { 
  
        var $4=$p; //@line 698 "dictionary.cpp"
        var $5=HEAP8[($4)]; //@line 698 "dictionary.cpp"
        var $conv=(tempInt=(($5)),(tempInt>=128?tempInt-256:tempInt)); //@line 698 "dictionary.cpp"
        var $cmp1=((($conv))|0)!=7; //@line 698 "dictionary.cpp"
        if (!($cmp1)) { __label__ = 13;break $while_cond$4; } //@line 698 "dictionary.cpp"
  
        var $6=$pre_addr; //@line 700 "dictionary.cpp"
        var $tobool=((($6))|0)!=0; //@line 700 "dictionary.cpp"
        if ($tobool) { __label__ = 4;; } else { __label__ = 5;; } //@line 700 "dictionary.cpp"
        if (__label__ == 4) {
  
          var $7=$p; //@line 702 "dictionary.cpp"
          var $call=_strlen($7); //@line 702 "dictionary.cpp"
          $len=$call; //@line 702 "dictionary.cpp"
          var $8=$word_addr; //@line 703 "dictionary.cpp"
          var $9=$len; //@line 703 "dictionary.cpp"
          var $idx_neg=(((-($9)))&4294967295); //@line 703 "dictionary.cpp"
          var $add_ptr=(($8+$idx_neg)&4294967295); //@line 703 "dictionary.cpp"
          var $add_ptr3=(($add_ptr+1)&4294967295); //@line 703 "dictionary.cpp"
          $w=$add_ptr3; //@line 703 "dictionary.cpp"
          ; //@line 704 "dictionary.cpp"
        }
        else if (__label__ == 5) {
  
          var $10=$word_addr; //@line 707 "dictionary.cpp"
          $w=$10; //@line 707 "dictionary.cpp"
          ;
        }
  
        var $11=$p; //@line 709 "dictionary.cpp"
        var $12=HEAP8[($11)]; //@line 709 "dictionary.cpp"
        var $conv61=(tempInt=(($12)),(tempInt>=128?tempInt-256:tempInt)); //@line 709 "dictionary.cpp"
        var $13=$w; //@line 709 "dictionary.cpp"
        var $14=HEAP8[($13)]; //@line 709 "dictionary.cpp"
        var $conv72=(tempInt=(($14)),(tempInt>=128?tempInt-256:tempInt)); //@line 709 "dictionary.cpp"
        var $cmp83=((($conv61))|0)==((($conv72))|0); //@line 709 "dictionary.cpp"
        if ($cmp83) { __label__ = 7;; } else { __label__ = 8;; } //@line 709 "dictionary.cpp"
        $while_body9$$while_end$11: do { 
          if (__label__ == 7) {
            while(1) { 
  
              var $15=$w; //@line 711 "dictionary.cpp"
              var $incdec_ptr=(($15+1)&4294967295); //@line 711 "dictionary.cpp"
              $w=$incdec_ptr; //@line 711 "dictionary.cpp"
              var $16=$p; //@line 712 "dictionary.cpp"
              var $incdec_ptr10=(($16+1)&4294967295); //@line 712 "dictionary.cpp"
              $p=$incdec_ptr10; //@line 712 "dictionary.cpp"
              var $17=$p; //@line 709 "dictionary.cpp"
              var $18=HEAP8[($17)]; //@line 709 "dictionary.cpp"
              var $conv6=(tempInt=(($18)),(tempInt>=128?tempInt-256:tempInt)); //@line 709 "dictionary.cpp"
              var $19=$w; //@line 709 "dictionary.cpp"
              var $20=HEAP8[($19)]; //@line 709 "dictionary.cpp"
              var $conv7=(tempInt=(($20)),(tempInt>=128?tempInt-256:tempInt)); //@line 709 "dictionary.cpp"
              var $cmp8=((($conv6))|0)==((($conv7))|0); //@line 709 "dictionary.cpp"
              if ($cmp8) { __label__ = 7;continue ; } else { __label__ = 8;break $while_body9$$while_end$11; } //@line 709 "dictionary.cpp"
            }
          }
        } while(0);
  
        var $21=$p; //@line 714 "dictionary.cpp"
        var $22=HEAP8[($21)]; //@line 714 "dictionary.cpp"
        var $conv11=(tempInt=(($22)),(tempInt>=128?tempInt-256:tempInt)); //@line 714 "dictionary.cpp"
        var $cmp12=((($conv11))|0)==0; //@line 714 "dictionary.cpp"
        if ($cmp12) { __label__ = 9;break $while_cond$4; } //@line 714 "dictionary.cpp"
        while(1) { 
  
          var $27=$p; //@line 721 "dictionary.cpp"
          var $incdec_ptr19=(($27+1)&4294967295); //@line 721 "dictionary.cpp"
          $p=$incdec_ptr19; //@line 721 "dictionary.cpp"
          var $28=HEAP8[($27)]; //@line 721 "dictionary.cpp"
          var $conv20=(tempInt=(($28)),(tempInt>=128?tempInt-256:tempInt)); //@line 721 "dictionary.cpp"
          var $cmp21=((($conv20))|0)!=0; //@line 721 "dictionary.cpp"
          if ($cmp21) { __label__ = 12;continue ; } else { __label__ = 2;continue $while_cond$4; } //@line 721 "dictionary.cpp"
        }
      }
      if (__label__ == 13) {
  
        $retval=0; //@line 723 "dictionary.cpp"
        ; //@line 723 "dictionary.cpp"
      }
      else if (__label__ == 9) {
  
        var $23=$pre_addr; //@line 716 "dictionary.cpp"
        var $tobool14=((($23))|0)!=0; //@line 716 "dictionary.cpp"
        if ($tobool14) { __label__ = 10;; } else { __label__ = 11;; } //@line 716 "dictionary.cpp"
        if (__label__ == 10) {
  
          var $24=$len; //@line 717 "dictionary.cpp"
          $retval=$24; //@line 717 "dictionary.cpp"
          ; //@line 717 "dictionary.cpp"
        }
        else if (__label__ == 11) {
  
          var $25=$w; //@line 718 "dictionary.cpp"
          var $26=$word_addr; //@line 718 "dictionary.cpp"
          var $sub_ptr_lhs_cast=($25); //@line 718 "dictionary.cpp"
          var $sub_ptr_rhs_cast=($26); //@line 718 "dictionary.cpp"
          var $sub_ptr_sub=((($sub_ptr_lhs_cast)-($sub_ptr_rhs_cast))&4294967295); //@line 718 "dictionary.cpp"
          $retval=$sub_ptr_sub; //@line 718 "dictionary.cpp"
          ; //@line 718 "dictionary.cpp"
        }
      }
    }
  
    var $29=$retval; //@line 724 "dictionary.cpp"
    ;
    return $29; //@line 724 "dictionary.cpp"
    return null;
  }
  

  function __Z11CalcPitchesP10Translatori($tr, $clause_type) {
    var __stackBase__  = STACKTOP; STACKTOP += 6000; _memset(__stackBase__, 0, 6000);
    var __label__;
    var __lastLabel__ = null;
  
    var $tr_addr;
    var $clause_type_addr;
    var $p;
    var $syl;
    var $ix;
    var $x;
    var $st_ix;
    var $n_st;
    var $option;
    var $group_tone;
    var $group_tone_emph;
    var $group_tone_comma;
    var $ph_start;
    var $st_start;
    var $st_clause_end;
    var $count;
    var $n_primary;
    var $count_primary;
    var $ph;
    var $ph_end;
    var $syllable_tab2=__stackBase__;
    $tr_addr=$tr;
    $clause_type_addr=$clause_type;
    $ph_start=0; //@line 1126 "intonation.cpp"
    var $0=HEAP32[((_n_phoneme_list)>>2)]; //@line 1133 "intonation.cpp"
    $ph_end=$0; //@line 1133 "intonation.cpp"
    var $arraydecay=(($syllable_tab2)&4294967295); //@line 1137 "intonation.cpp"
    HEAP32[((__ZL12syllable_tab)>>2)]=$arraydecay; //@line 1137 "intonation.cpp"
    $n_st=0; //@line 1138 "intonation.cpp"
    $n_primary=0; //@line 1139 "intonation.cpp"
    $ix=0; //@line 1140 "intonation.cpp"
    var $1=$ix; //@line 1140 "intonation.cpp"
    var $2=HEAP32[((_n_phoneme_list)>>2)]; //@line 1140 "intonation.cpp"
    var $sub4=((($2)-1)&4294967295); //@line 1140 "intonation.cpp"
    var $cmp5=((($1))|0) < ((($sub4))|0); //@line 1140 "intonation.cpp"
    if ($cmp5) { __label__ = 1;; } else { __label__ = 8;; } //@line 1140 "intonation.cpp"
    $for_body$$for_end$2: do { 
      if (__label__ == 1) {
        $for_body$3: while(1) { 
  
          var $3=$ix; //@line 1142 "intonation.cpp"
          var $arrayidx=((_phoneme_list+$3*24)&4294967295); //@line 1142 "intonation.cpp"
          $p=$arrayidx; //@line 1142 "intonation.cpp"
          var $4=$p; //@line 1143 "intonation.cpp"
          var $synthflags=(($4+4)&4294967295); //@line 1143 "intonation.cpp"
          var $5=HEAPU16[(($synthflags)>>1)]; //@line 1143 "intonation.cpp"
          var $conv=((($5))&65535); //@line 1143 "intonation.cpp"
          var $and=($conv) & 4; //@line 1143 "intonation.cpp"
          var $tobool=((($and))|0)!=0; //@line 1143 "intonation.cpp"
          if ($tobool) { __label__ = 2;; } else { __label__ = 4;; } //@line 1143 "intonation.cpp"
          $if_then$$if_else$5: do { 
            if (__label__ == 2) {
  
              var $6=$n_st; //@line 1145 "intonation.cpp"
              var $7=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 1145 "intonation.cpp"
              var $arrayidx1=(($7+6*$6)&4294967295); //@line 1145 "intonation.cpp"
              var $flags=(($arrayidx1+2)&4294967295); //@line 1145 "intonation.cpp"
              HEAP8[($flags)]=0; //@line 1145 "intonation.cpp"
              var $8=$n_st; //@line 1146 "intonation.cpp"
              var $9=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 1146 "intonation.cpp"
              var $arrayidx2=(($9+6*$8)&4294967295); //@line 1146 "intonation.cpp"
              var $env=(($arrayidx2+1)&4294967295); //@line 1146 "intonation.cpp"
              HEAP8[($env)]=0; //@line 1146 "intonation.cpp"
              var $10=$ix; //@line 1147 "intonation.cpp"
              var $add=((($10)+1)&4294967295); //@line 1147 "intonation.cpp"
              var $arrayidx3=((_phoneme_list+$add*24)&4294967295); //@line 1147 "intonation.cpp"
              var $type=(($arrayidx3+15)&4294967295); //@line 1147 "intonation.cpp"
              var $11=HEAP8[($type)]; //@line 1147 "intonation.cpp"
              var $12=$n_st; //@line 1147 "intonation.cpp"
              var $13=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 1147 "intonation.cpp"
              var $arrayidx4=(($13+6*$12)&4294967295); //@line 1147 "intonation.cpp"
              var $nextph_type=(($arrayidx4+3)&4294967295); //@line 1147 "intonation.cpp"
              HEAP8[($nextph_type)]=$11; //@line 1147 "intonation.cpp"
              var $14=$p; //@line 1148 "intonation.cpp"
              var $stresslevel=(($14+1)&4294967295); //@line 1148 "intonation.cpp"
              var $15=HEAP8[($stresslevel)]; //@line 1148 "intonation.cpp"
              var $16=$n_st; //@line 1148 "intonation.cpp"
              var $inc=((($16)+1)&4294967295); //@line 1148 "intonation.cpp"
              $n_st=$inc; //@line 1148 "intonation.cpp"
              var $17=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 1148 "intonation.cpp"
              var $arrayidx5=(($17+6*$16)&4294967295); //@line 1148 "intonation.cpp"
              var $stress=(($arrayidx5)&4294967295); //@line 1148 "intonation.cpp"
              HEAP8[($stress)]=$15; //@line 1148 "intonation.cpp"
              var $18=$p; //@line 1150 "intonation.cpp"
              var $stresslevel6=(($18+1)&4294967295); //@line 1150 "intonation.cpp"
              var $19=HEAPU8[($stresslevel6)]; //@line 1150 "intonation.cpp"
              var $conv7=((($19))&255); //@line 1150 "intonation.cpp"
              var $cmp8=((($conv7))|0) >= 4; //@line 1150 "intonation.cpp"
              if (!($cmp8)) { __label__ = 7;break $if_then$$if_else$5; } //@line 1150 "intonation.cpp"
  
              var $20=$n_primary; //@line 1151 "intonation.cpp"
              var $inc10=((($20)+1)&4294967295); //@line 1151 "intonation.cpp"
              $n_primary=$inc10; //@line 1151 "intonation.cpp"
              ; //@line 1151 "intonation.cpp"
            }
            else if (__label__ == 4) {
  
              var $21=$p; //@line 1154 "intonation.cpp"
              var $ph11=(($21+8)&4294967295); //@line 1154 "intonation.cpp"
              var $22=HEAP32[(($ph11)>>2)]; //@line 1154 "intonation.cpp"
              var $code=(($22+10)&4294967295); //@line 1154 "intonation.cpp"
              var $23=HEAPU8[($code)]; //@line 1154 "intonation.cpp"
              var $conv12=((($23))&255); //@line 1154 "intonation.cpp"
              var $cmp13=((($conv12))|0)==27; //@line 1154 "intonation.cpp"
              if (!($cmp13)) { __label__ = 7;break $if_then$$if_else$5; } //@line 1154 "intonation.cpp"
  
              var $24=$n_st; //@line 1154 "intonation.cpp"
              var $cmp14=((($24))|0) > 0; //@line 1154 "intonation.cpp"
              if (!($cmp14)) { __label__ = 7;break $if_then$$if_else$5; } //@line 1154 "intonation.cpp"
  
              var $25=$n_st; //@line 1156 "intonation.cpp"
              var $sub16=((($25)-1)&4294967295); //@line 1156 "intonation.cpp"
              var $26=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 1156 "intonation.cpp"
              var $arrayidx17=(($26+6*$sub16)&4294967295); //@line 1156 "intonation.cpp"
              var $flags18=(($arrayidx17+2)&4294967295); //@line 1156 "intonation.cpp"
              var $27=HEAP8[($flags18)]; //@line 1156 "intonation.cpp"
              var $conv19=(tempInt=(($27)),(tempInt>=128?tempInt-256:tempInt)); //@line 1156 "intonation.cpp"
              var $or=($conv19) | 4; //@line 1156 "intonation.cpp"
              var $conv20=((($or)) & 255); //@line 1156 "intonation.cpp"
              HEAP8[($flags18)]=$conv20; //@line 1156 "intonation.cpp"
              ; //@line 1157 "intonation.cpp"
            }
          } while(0);
  
          var $28=$ix; //@line 1140 "intonation.cpp"
          var $inc23=((($28)+1)&4294967295); //@line 1140 "intonation.cpp"
          $ix=$inc23; //@line 1140 "intonation.cpp"
          var $29=$ix; //@line 1140 "intonation.cpp"
          var $30=HEAP32[((_n_phoneme_list)>>2)]; //@line 1140 "intonation.cpp"
          var $sub=((($30)-1)&4294967295); //@line 1140 "intonation.cpp"
          var $cmp=((($29))|0) < ((($sub))|0); //@line 1140 "intonation.cpp"
          if ($cmp) { __label__ = 1;continue $for_body$3; } else { __label__ = 8;break $for_body$$for_end$2; } //@line 1140 "intonation.cpp"
        }
      }
    } while(0);
  
    var $31=$n_st; //@line 1159 "intonation.cpp"
    var $32=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 1159 "intonation.cpp"
    var $arrayidx24=(($32+6*$31)&4294967295); //@line 1159 "intonation.cpp"
    var $stress25=(($arrayidx24)&4294967295); //@line 1159 "intonation.cpp"
    HEAP8[($stress25)]=0; //@line 1159 "intonation.cpp"
    var $33=$n_st; //@line 1161 "intonation.cpp"
    var $cmp26=((($33))|0)==0; //@line 1161 "intonation.cpp"
    if ($cmp26) { __label__ = 70;; } else { __label__ = 9;; } //@line 1161 "intonation.cpp"
    $for_end258$$if_end28$13: do { 
      if (__label__ == 9) {
  
        var $34=$tr_addr; //@line 1166 "intonation.cpp"
        var $langopts=(($34)&4294967295); //@line 1166 "intonation.cpp"
        var $tone_language=(($langopts+224)&4294967295); //@line 1166 "intonation.cpp"
        var $35=HEAP32[(($tone_language)>>2)]; //@line 1166 "intonation.cpp"
        var $cmp29=((($35))|0)==1; //@line 1166 "intonation.cpp"
        var $36=$tr_addr; //@line 1168 "intonation.cpp"
        if ($cmp29) { __label__ = 10;; } else { __label__ = 11;; } //@line 1166 "intonation.cpp"
        if (__label__ == 10) {
  
          var $37=$clause_type_addr; //@line 1168 "intonation.cpp"
          __ZL16CalcPitches_ToneP10Translatori($36, $37); //@line 1168 "intonation.cpp"
          ; //@line 1169 "intonation.cpp"
        }
        else if (__label__ == 11) {
  
          var $langopts32=(($36)&4294967295); //@line 1173 "intonation.cpp"
          var $intonation_group=(($langopts32+228)&4294967295); //@line 1173 "intonation.cpp"
          var $38=HEAP32[(($intonation_group)>>2)]; //@line 1173 "intonation.cpp"
          $option=$38; //@line 1173 "intonation.cpp"
          var $39=$option; //@line 1174 "intonation.cpp"
          var $cmp33=((($39))|0) >= 8; //@line 1174 "intonation.cpp"
          if ($cmp33) { __label__ = 12;; } else { __label__ = 13;; } //@line 1174 "intonation.cpp"
          $if_end35_thread$$if_end35$18: do { 
            if (__label__ == 12) {
  
              $option=1; //@line 1175 "intonation.cpp"
              var $40=$clause_type_addr; //@line 1179 "intonation.cpp"
              __lastLabel__ = 12; __label__ = 15;break $if_end35_thread$$if_end35$18; //@line 1177 "intonation.cpp"
            }
            else if (__label__ == 13) {
  
              var $cmp36=((($39))|0)==0; //@line 1177 "intonation.cpp"
              var $41=$clause_type_addr; //@line 1179 "intonation.cpp"
              if ($cmp36) { __lastLabel__ = 13; ; } else { __lastLabel__ = 13; __label__ = 15;break $if_end35_thread$$if_end35$18; } //@line 1177 "intonation.cpp"
  
              var $42=$tr_addr; //@line 1179 "intonation.cpp"
              var $langopts38=(($42)&4294967295); //@line 1179 "intonation.cpp"
              var $tunes=(($langopts38+232)&4294967295); //@line 1179 "intonation.cpp"
              var $arrayidx39=(($tunes+$41)&4294967295); //@line 1179 "intonation.cpp"
              var $43=HEAPU8[($arrayidx39)]; //@line 1179 "intonation.cpp"
              var $conv40=((($43))&255); //@line 1179 "intonation.cpp"
              $group_tone=$conv40; //@line 1179 "intonation.cpp"
              var $44=$tr_addr; //@line 1180 "intonation.cpp"
              var $langopts41=(($44)&4294967295); //@line 1180 "intonation.cpp"
              var $tunes42=(($langopts41+232)&4294967295); //@line 1180 "intonation.cpp"
              var $arrayidx43=(($tunes42+5)&4294967295); //@line 1180 "intonation.cpp"
              var $45=HEAPU8[($arrayidx43)]; //@line 1180 "intonation.cpp"
              var $conv44=((($45))&255); //@line 1180 "intonation.cpp"
              $group_tone_emph=$conv44; //@line 1180 "intonation.cpp"
              var $46=$tr_addr; //@line 1181 "intonation.cpp"
              var $langopts45=(($46)&4294967295); //@line 1181 "intonation.cpp"
              var $tunes46=(($langopts45+232)&4294967295); //@line 1181 "intonation.cpp"
              var $arrayidx47=(($tunes46+1)&4294967295); //@line 1181 "intonation.cpp"
              var $47=HEAPU8[($arrayidx47)]; //@line 1181 "intonation.cpp"
              var $conv48=((($47))&255); //@line 1181 "intonation.cpp"
              $group_tone_comma=$conv48; //@line 1181 "intonation.cpp"
              __label__ = 16;break $if_end35_thread$$if_end35$18; //@line 1182 "intonation.cpp"
            }
          } while(0);
          if (__label__ == 15) {
  
            var $48=__lastLabel__ == 12 ? $40 : ($41);
            var $49=$option; //@line 1185 "intonation.cpp"
            var $50=$tr_addr; //@line 1185 "intonation.cpp"
            var $punct_to_tone=(($50+1000)&4294967295); //@line 1185 "intonation.cpp"
            var $arrayidx50=(($punct_to_tone+$49*6)&4294967295); //@line 1185 "intonation.cpp"
            var $arrayidx51=(($arrayidx50+$48)&4294967295); //@line 1185 "intonation.cpp"
            var $51=HEAPU8[($arrayidx51)]; //@line 1185 "intonation.cpp"
            var $conv52=((($51))&255); //@line 1185 "intonation.cpp"
            $group_tone=$conv52; //@line 1185 "intonation.cpp"
            var $52=$option; //@line 1186 "intonation.cpp"
            var $53=$tr_addr; //@line 1186 "intonation.cpp"
            var $punct_to_tone53=(($53+1000)&4294967295); //@line 1186 "intonation.cpp"
            var $arrayidx54=(($punct_to_tone53+$52*6)&4294967295); //@line 1186 "intonation.cpp"
            var $arrayidx55=(($arrayidx54+5)&4294967295); //@line 1186 "intonation.cpp"
            var $54=HEAPU8[($arrayidx55)]; //@line 1186 "intonation.cpp"
            var $conv56=((($54))&255); //@line 1186 "intonation.cpp"
            $group_tone_emph=$conv56; //@line 1186 "intonation.cpp"
            var $55=$option; //@line 1187 "intonation.cpp"
            var $56=$tr_addr; //@line 1187 "intonation.cpp"
            var $punct_to_tone57=(($56+1000)&4294967295); //@line 1187 "intonation.cpp"
            var $arrayidx58=(($punct_to_tone57+$55*6)&4294967295); //@line 1187 "intonation.cpp"
            var $arrayidx59=(($arrayidx58+1)&4294967295); //@line 1187 "intonation.cpp"
            var $57=HEAPU8[($arrayidx59)]; //@line 1187 "intonation.cpp"
            var $conv60=((($57))&255); //@line 1187 "intonation.cpp"
            $group_tone_comma=$conv60; //@line 1187 "intonation.cpp"
            ;
          }
  
          var $58=$clause_type_addr; //@line 1190 "intonation.cpp"
          var $cmp62=((($58))|0)==4; //@line 1190 "intonation.cpp"
          if ($cmp62) { __label__ = 17;; } else { __label__ = 18;; } //@line 1190 "intonation.cpp"
          if (__label__ == 17) {
  
            HEAP8[(__ZL8no_tonic_b)]=1;
            ; //@line 1191 "intonation.cpp"
          }
          else if (__label__ == 18) {
  
            HEAP8[(__ZL8no_tonic_b)]=0;
            ;
          }
  
          $st_start=0; //@line 1195 "intonation.cpp"
          $count_primary=0; //@line 1196 "intonation.cpp"
          $st_ix=0; //@line 1197 "intonation.cpp"
          var $59=$st_ix; //@line 1197 "intonation.cpp"
          var $60=$n_st; //@line 1197 "intonation.cpp"
          var $cmp673=((($59))|0) < ((($60))|0); //@line 1197 "intonation.cpp"
          if ($cmp673) { __label__ = 20;; } else { __label__ = 54;; } //@line 1197 "intonation.cpp"
          $for_body68$$for_end177$29: do { 
            if (__label__ == 20) {
              $for_body68$30: while(1) { 
  
                var $61=$st_ix; //@line 1199 "intonation.cpp"
                var $62=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 1199 "intonation.cpp"
                var $arrayidx69=(($62+6*$61)&4294967295); //@line 1199 "intonation.cpp"
                $syl=$arrayidx69; //@line 1199 "intonation.cpp"
                var $63=$syl; //@line 1201 "intonation.cpp"
                var $stress70=(($63)&4294967295); //@line 1201 "intonation.cpp"
                var $64=HEAP8[($stress70)]; //@line 1201 "intonation.cpp"
                var $conv71=(tempInt=(($64)),(tempInt>=128?tempInt-256:tempInt)); //@line 1201 "intonation.cpp"
                var $cmp72=((($conv71))|0) >= 4; //@line 1201 "intonation.cpp"
                if ($cmp72) { __label__ = 21;; } else { __label__ = 22;; } //@line 1201 "intonation.cpp"
                if (__label__ == 21) {
  
                  var $65=$count_primary; //@line 1202 "intonation.cpp"
                  var $inc74=((($65)+1)&4294967295); //@line 1202 "intonation.cpp"
                  $count_primary=$inc74; //@line 1202 "intonation.cpp"
                  ; //@line 1202 "intonation.cpp"
                }
  
                var $66=$syl; //@line 1204 "intonation.cpp"
                var $stress76=(($66)&4294967295); //@line 1204 "intonation.cpp"
                var $67=HEAP8[($stress76)]; //@line 1204 "intonation.cpp"
                var $conv77=(tempInt=(($67)),(tempInt>=128?tempInt-256:tempInt)); //@line 1204 "intonation.cpp"
                var $cmp78=((($conv77))|0)==6; //@line 1204 "intonation.cpp"
                if ($cmp78) { __label__ = 23;; } else { __label__ = 36;; } //@line 1204 "intonation.cpp"
                $if_then79$$if_end124$35: do { 
                  if (__label__ == 23) {
  
                    var $68=$st_ix; //@line 1207 "intonation.cpp"
                    var $sub80=((($68)-1)&4294967295); //@line 1207 "intonation.cpp"
                    $ix=$sub80; //@line 1207 "intonation.cpp"
                    ; //@line 1207 "intonation.cpp"
                    $for_cond81$37: while(1) { 
  
                      var $69=$ix; //@line 1207 "intonation.cpp"
                      var $70=$st_start; //@line 1207 "intonation.cpp"
                      var $cmp82=((($69))|0) >= ((($70))|0); //@line 1207 "intonation.cpp"
                      if (!($cmp82)) { __label__ = 30;break $for_cond81$37; } //@line 1207 "intonation.cpp"
  
                      var $71=$ix; //@line 1207 "intonation.cpp"
                      var $72=$st_ix; //@line 1207 "intonation.cpp"
                      var $sub83=((($72)-3)&4294967295); //@line 1207 "intonation.cpp"
                      var $cmp84=((($71))|0) >= ((($sub83))|0); //@line 1207 "intonation.cpp"
                      if (!($cmp84)) { __label__ = 30;break $for_cond81$37; }
  
                      var $73=$ix; //@line 1209 "intonation.cpp"
                      var $74=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 1209 "intonation.cpp"
                      var $arrayidx86=(($74+6*$73)&4294967295); //@line 1209 "intonation.cpp"
                      var $stress87=(($arrayidx86)&4294967295); //@line 1209 "intonation.cpp"
                      var $75=HEAP8[($stress87)]; //@line 1209 "intonation.cpp"
                      var $conv88=(tempInt=(($75)),(tempInt>=128?tempInt-256:tempInt)); //@line 1209 "intonation.cpp"
                      var $cmp89=((($conv88))|0)==6; //@line 1209 "intonation.cpp"
                      if ($cmp89) { __label__ = 30;break $for_cond81$37; } //@line 1209 "intonation.cpp"
  
                      var $76=$ix; //@line 1211 "intonation.cpp"
                      var $77=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 1211 "intonation.cpp"
                      var $arrayidx92=(($77+6*$76)&4294967295); //@line 1211 "intonation.cpp"
                      var $stress93=(($arrayidx92)&4294967295); //@line 1211 "intonation.cpp"
                      var $78=HEAP8[($stress93)]; //@line 1211 "intonation.cpp"
                      var $conv94=(tempInt=(($78)),(tempInt>=128?tempInt-256:tempInt)); //@line 1211 "intonation.cpp"
                      var $cmp95=((($conv94))|0)==4; //@line 1211 "intonation.cpp"
                      var $79=$ix; //@line 1213 "intonation.cpp"
                      if ($cmp95) { __label__ = 28;break $for_cond81$37; } //@line 1211 "intonation.cpp"
  
                      var $dec=((($79)-1)&4294967295); //@line 1207 "intonation.cpp"
                      $ix=$dec; //@line 1207 "intonation.cpp"
                      __label__ = 24;continue $for_cond81$37; //@line 1207 "intonation.cpp"
                    }
                    if (__label__ == 28) {
  
                      var $80=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 1213 "intonation.cpp"
                      var $arrayidx97=(($80+6*$79)&4294967295); //@line 1213 "intonation.cpp"
                      var $stress98=(($arrayidx97)&4294967295); //@line 1213 "intonation.cpp"
                      HEAP8[($stress98)]=3; //@line 1213 "intonation.cpp"
                      ; //@line 1214 "intonation.cpp"
                    }
  
                    var $81=$st_ix; //@line 1219 "intonation.cpp"
                    var $add102=((($81)+1)&4294967295); //@line 1219 "intonation.cpp"
                    $ix=$add102; //@line 1219 "intonation.cpp"
                    ; //@line 1219 "intonation.cpp"
                    while(1) { 
  
                      var $82=$ix; //@line 1219 "intonation.cpp"
                      var $83=$n_st; //@line 1219 "intonation.cpp"
                      var $cmp104=((($82))|0) < ((($83))|0); //@line 1219 "intonation.cpp"
                      if (!($cmp104)) { __label__ = 36;break $if_then79$$if_end124$35; } //@line 1219 "intonation.cpp"
  
                      var $84=$ix; //@line 1221 "intonation.cpp"
                      var $85=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 1221 "intonation.cpp"
                      var $arrayidx106=(($85+6*$84)&4294967295); //@line 1221 "intonation.cpp"
                      var $stress107=(($arrayidx106)&4294967295); //@line 1221 "intonation.cpp"
                      var $86=HEAP8[($stress107)]; //@line 1221 "intonation.cpp"
                      var $conv108=(tempInt=(($86)),(tempInt>=128?tempInt-256:tempInt)); //@line 1221 "intonation.cpp"
                      var $cmp109=((($conv108))|0)==4; //@line 1221 "intonation.cpp"
                      if ($cmp109) { __label__ = 36;break $if_then79$$if_end124$35; } //@line 1221 "intonation.cpp"
  
                      var $87=$ix; //@line 1223 "intonation.cpp"
                      var $88=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 1223 "intonation.cpp"
                      var $arrayidx112=(($88+6*$87)&4294967295); //@line 1223 "intonation.cpp"
                      var $stress113=(($arrayidx112)&4294967295); //@line 1223 "intonation.cpp"
                      var $89=HEAP8[($stress113)]; //@line 1223 "intonation.cpp"
                      var $conv114=(tempInt=(($89)),(tempInt>=128?tempInt-256:tempInt)); //@line 1223 "intonation.cpp"
                      var $cmp115=((($conv114))|0)==6; //@line 1223 "intonation.cpp"
                      if ($cmp115) { __label__ = 34;break ; } //@line 1223 "intonation.cpp"
  
                      var $93=$ix; //@line 1219 "intonation.cpp"
                      var $inc122=((($93)+1)&4294967295); //@line 1219 "intonation.cpp"
                      $ix=$inc122; //@line 1219 "intonation.cpp"
                      __label__ = 31;continue ; //@line 1219 "intonation.cpp"
                    }
  
                    var $90=$st_ix; //@line 1226 "intonation.cpp"
                    var $91=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 1226 "intonation.cpp"
                    var $arrayidx117=(($91+6*$90)&4294967295); //@line 1226 "intonation.cpp"
                    var $flags118=(($arrayidx117+2)&4294967295); //@line 1226 "intonation.cpp"
                    HEAP8[($flags118)]=2; //@line 1226 "intonation.cpp"
                    var $92=$syl; //@line 1227 "intonation.cpp"
                    var $stress119=(($92)&4294967295); //@line 1227 "intonation.cpp"
                    HEAP8[($stress119)]=5; //@line 1227 "intonation.cpp"
                    ; //@line 1228 "intonation.cpp"
                  }
                } while(0);
  
                var $94=$syl; //@line 1233 "intonation.cpp"
                var $stress125=(($94)&4294967295); //@line 1233 "intonation.cpp"
                var $95=HEAP8[($stress125)]; //@line 1233 "intonation.cpp"
                var $conv126=(tempInt=(($95)),(tempInt>=128?tempInt-256:tempInt)); //@line 1233 "intonation.cpp"
                var $cmp127=((($conv126))|0)==6; //@line 1233 "intonation.cpp"
                if ($cmp127) { __label__ = 37;; } else { __label__ = 50;; } //@line 1233 "intonation.cpp"
                if (__label__ == 37) {
  
                  var $96=$st_ix; //@line 1236 "intonation.cpp"
                  var $97=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 1236 "intonation.cpp"
                  var $arrayidx129=(($97+6*$96)&4294967295); //@line 1236 "intonation.cpp"
                  var $flags130=(($arrayidx129+2)&4294967295); //@line 1236 "intonation.cpp"
                  HEAP8[($flags130)]=2; //@line 1236 "intonation.cpp"
                  $count=0; //@line 1238 "intonation.cpp"
                  var $98=$n_primary; //@line 1239 "intonation.cpp"
                  var $99=$count_primary; //@line 1239 "intonation.cpp"
                  var $sub131=((($98)-($99))&4294967295); //@line 1239 "intonation.cpp"
                  var $cmp132=((($sub131))|0) > 1; //@line 1239 "intonation.cpp"
                  if ($cmp132) { __label__ = 38;; } else { __label__ = 39;; } //@line 1239 "intonation.cpp"
                  if (__label__ == 38) {
  
                    $count=1; //@line 1240 "intonation.cpp"
                    ; //@line 1240 "intonation.cpp"
                  }
  
                  var $100=$st_ix; //@line 1242 "intonation.cpp"
                  var $add135=((($100)+1)&4294967295); //@line 1242 "intonation.cpp"
                  $ix=$add135; //@line 1242 "intonation.cpp"
                  ; //@line 1242 "intonation.cpp"
                  $for_cond136$58: while(1) { 
  
                    var $101=$ix; //@line 1242 "intonation.cpp"
                    var $102=$n_st; //@line 1242 "intonation.cpp"
                    var $cmp137=((($101))|0) < ((($102))|0); //@line 1242 "intonation.cpp"
                    if (!($cmp137)) { __label__ = 45;break $for_cond136$58; } //@line 1242 "intonation.cpp"
  
                    var $103=$ix; //@line 1244 "intonation.cpp"
                    var $104=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 1244 "intonation.cpp"
                    var $arrayidx139=(($104+6*$103)&4294967295); //@line 1244 "intonation.cpp"
                    var $stress140=(($arrayidx139)&4294967295); //@line 1244 "intonation.cpp"
                    var $105=HEAP8[($stress140)]; //@line 1244 "intonation.cpp"
                    var $conv141=(tempInt=(($105)),(tempInt>=128?tempInt-256:tempInt)); //@line 1244 "intonation.cpp"
                    var $cmp142=((($conv141))|0) > 4; //@line 1244 "intonation.cpp"
                    if ($cmp142) { __label__ = 45;break $for_cond136$58; } //@line 1244 "intonation.cpp"
  
                    var $106=$ix; //@line 1246 "intonation.cpp"
                    var $107=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 1246 "intonation.cpp"
                    var $arrayidx145=(($107+6*$106)&4294967295); //@line 1246 "intonation.cpp"
                    var $stress146=(($arrayidx145)&4294967295); //@line 1246 "intonation.cpp"
                    var $108=HEAP8[($stress146)]; //@line 1246 "intonation.cpp"
                    var $conv147=(tempInt=(($108)),(tempInt>=128?tempInt-256:tempInt)); //@line 1246 "intonation.cpp"
                    var $cmp148=((($conv147))|0)==4; //@line 1246 "intonation.cpp"
                    if ($cmp148) { __label__ = 43;; } else { __label__ = 44;; } //@line 1246 "intonation.cpp"
                    if (__label__ == 43) {
  
                      var $109=$count; //@line 1248 "intonation.cpp"
                      var $inc150=((($109)+1)&4294967295); //@line 1248 "intonation.cpp"
                      $count=$inc150; //@line 1248 "intonation.cpp"
                      var $110=$count; //@line 1249 "intonation.cpp"
                      var $cmp151=((($110))|0) > 1; //@line 1249 "intonation.cpp"
                      if ($cmp151) { __label__ = 45;break $for_cond136$58; } //@line 1249 "intonation.cpp"
                    }
  
                    var $111=$ix; //@line 1242 "intonation.cpp"
                    var $inc156=((($111)+1)&4294967295); //@line 1242 "intonation.cpp"
                    $ix=$inc156; //@line 1242 "intonation.cpp"
                    __label__ = 40;continue $for_cond136$58; //@line 1242 "intonation.cpp"
                  }
  
                  var $112=$st_start; //@line 1254 "intonation.cpp"
                  var $113=$ix; //@line 1254 "intonation.cpp"
                  var $114=$n_st; //@line 1254 "intonation.cpp"
                  __ZL18count_pitch_vowelsiii($112, $113, $114); //@line 1254 "intonation.cpp"
                  var $115=$ix; //@line 1255 "intonation.cpp"
                  var $116=$n_st; //@line 1255 "intonation.cpp"
                  var $cmp158=((($115))|0) < ((($116))|0); //@line 1255 "intonation.cpp"
                  if ($cmp158) { __label__ = 47;; } else { __label__ = 46;; } //@line 1255 "intonation.cpp"
                  $if_then160$$lor_lhs_false$66: do { 
                    if (__label__ == 46) {
  
                      var $117=$clause_type_addr; //@line 1255 "intonation.cpp"
                      var $cmp159=((($117))|0)==0; //@line 1255 "intonation.cpp"
                      if ($cmp159) { __label__ = 47;break $if_then160$$lor_lhs_false$66; } //@line 1255 "intonation.cpp"
  
                      var $122=$option; //@line 1258 "intonation.cpp"
                      var $123=$st_start; //@line 1258 "intonation.cpp"
                      var $124=$ix; //@line 1258 "intonation.cpp"
                      var $125=$group_tone; //@line 1258 "intonation.cpp"
                      __ZL12calc_pitchesiiii($122, $123, $124, $125); //@line 1258 "intonation.cpp"
                      __label__ = 49;break $if_then160$$lor_lhs_false$66;
                    }
                  } while(0);
                  if (__label__ == 47) {
  
                    var $118=$option; //@line 1256 "intonation.cpp"
                    var $119=$st_start; //@line 1256 "intonation.cpp"
                    var $120=$ix; //@line 1256 "intonation.cpp"
                    var $121=$group_tone_emph; //@line 1256 "intonation.cpp"
                    __ZL12calc_pitchesiiii($118, $119, $120, $121); //@line 1256 "intonation.cpp"
                    ; //@line 1256 "intonation.cpp"
                  }
  
                  var $126=$ix; //@line 1260 "intonation.cpp"
                  $st_start=$126; //@line 1260 "intonation.cpp"
                  ; //@line 1261 "intonation.cpp"
                }
  
                var $127=$st_start; //@line 1262 "intonation.cpp"
                var $128=$st_ix; //@line 1262 "intonation.cpp"
                var $cmp165=((($127))|0) < ((($128))|0); //@line 1262 "intonation.cpp"
                if ($cmp165) { __label__ = 51;; } else { __label__ = 53;; } //@line 1262 "intonation.cpp"
                $land_lhs_true166$$for_inc175$73: do { 
                  if (__label__ == 51) {
  
                    var $129=$syl; //@line 1262 "intonation.cpp"
                    var $flags167=(($129+2)&4294967295); //@line 1262 "intonation.cpp"
                    var $130=HEAP8[($flags167)]; //@line 1262 "intonation.cpp"
                    var $conv168=(tempInt=(($130)),(tempInt>=128?tempInt-256:tempInt)); //@line 1262 "intonation.cpp"
                    var $and169=($conv168) & 4; //@line 1262 "intonation.cpp"
                    var $tobool170=((($and169))|0)!=0; //@line 1262 "intonation.cpp"
                    if (!($tobool170)) { __label__ = 53;break $land_lhs_true166$$for_inc175$73; } //@line 1262 "intonation.cpp"
  
                    var $131=$st_ix; //@line 1265 "intonation.cpp"
                    var $add172=((($131)+1)&4294967295); //@line 1265 "intonation.cpp"
                    $st_clause_end=$add172; //@line 1265 "intonation.cpp"
                    var $132=$st_start; //@line 1266 "intonation.cpp"
                    var $133=$st_clause_end; //@line 1266 "intonation.cpp"
                    var $134=$st_clause_end; //@line 1266 "intonation.cpp"
                    __ZL18count_pitch_vowelsiii($132, $133, $134); //@line 1266 "intonation.cpp"
                    var $135=$option; //@line 1267 "intonation.cpp"
                    var $136=$st_start; //@line 1267 "intonation.cpp"
                    var $137=$st_clause_end; //@line 1267 "intonation.cpp"
                    var $138=$group_tone_comma; //@line 1267 "intonation.cpp"
                    __ZL12calc_pitchesiiii($135, $136, $137, $138); //@line 1267 "intonation.cpp"
                    var $139=$st_clause_end; //@line 1268 "intonation.cpp"
                    $st_start=$139; //@line 1268 "intonation.cpp"
                    ; //@line 1269 "intonation.cpp"
                  }
                } while(0);
  
                var $140=$st_ix; //@line 1197 "intonation.cpp"
                var $inc176=((($140)+1)&4294967295); //@line 1197 "intonation.cpp"
                $st_ix=$inc176; //@line 1197 "intonation.cpp"
                var $141=$st_ix; //@line 1197 "intonation.cpp"
                var $142=$n_st; //@line 1197 "intonation.cpp"
                var $cmp67=((($141))|0) < ((($142))|0); //@line 1197 "intonation.cpp"
                if ($cmp67) { __label__ = 20;continue $for_body68$30; } else { __label__ = 54;break $for_body68$$for_end177$29; } //@line 1197 "intonation.cpp"
              }
            }
          } while(0);
  
          var $143=$st_start; //@line 1272 "intonation.cpp"
          var $144=$st_ix; //@line 1272 "intonation.cpp"
          var $cmp178=((($143))|0) < ((($144))|0); //@line 1272 "intonation.cpp"
          if ($cmp178) { __label__ = 55;; } else { __label__ = 56;; } //@line 1272 "intonation.cpp"
          if (__label__ == 55) {
  
            var $145=$st_start; //@line 1274 "intonation.cpp"
            var $146=$st_ix; //@line 1274 "intonation.cpp"
            var $147=$n_st; //@line 1274 "intonation.cpp"
            __ZL18count_pitch_vowelsiii($145, $146, $147); //@line 1274 "intonation.cpp"
            var $148=$option; //@line 1275 "intonation.cpp"
            var $149=$st_start; //@line 1275 "intonation.cpp"
            var $150=$st_ix; //@line 1275 "intonation.cpp"
            var $151=$group_tone; //@line 1275 "intonation.cpp"
            __ZL12calc_pitchesiiii($148, $149, $150, $151); //@line 1275 "intonation.cpp"
            ; //@line 1276 "intonation.cpp"
          }
  
          $st_ix=0; //@line 1280 "intonation.cpp"
          var $152=$ph_start; //@line 1281 "intonation.cpp"
          $ix=$152; //@line 1281 "intonation.cpp"
          var $153=$ix; //@line 1281 "intonation.cpp"
          var $154=$ph_end; //@line 1281 "intonation.cpp"
          var $cmp1832=((($153))|0) < ((($154))|0); //@line 1281 "intonation.cpp"
          if (!($cmp1832)) { __label__ = 70;break $for_end258$$if_end28$13; } //@line 1281 "intonation.cpp"
          $for_body184$81: while(1) { 
  
            var $155=$ix; //@line 1283 "intonation.cpp"
            var $arrayidx185=((_phoneme_list+$155*24)&4294967295); //@line 1283 "intonation.cpp"
            $p=$arrayidx185; //@line 1283 "intonation.cpp"
            var $156=$st_ix; //@line 1284 "intonation.cpp"
            var $157=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 1284 "intonation.cpp"
            var $arrayidx186=(($157+6*$156)&4294967295); //@line 1284 "intonation.cpp"
            var $stress187=(($arrayidx186)&4294967295); //@line 1284 "intonation.cpp"
            var $158=HEAP8[($stress187)]; //@line 1284 "intonation.cpp"
            var $159=$p; //@line 1284 "intonation.cpp"
            var $stresslevel188=(($159+1)&4294967295); //@line 1284 "intonation.cpp"
            HEAP8[($stresslevel188)]=$158; //@line 1284 "intonation.cpp"
            var $160=$p; //@line 1286 "intonation.cpp"
            var $synthflags189=(($160+4)&4294967295); //@line 1286 "intonation.cpp"
            var $161=HEAPU16[(($synthflags189)>>1)]; //@line 1286 "intonation.cpp"
            var $conv190=((($161))&65535); //@line 1286 "intonation.cpp"
            var $and191=($conv190) & 4; //@line 1286 "intonation.cpp"
            var $tobool192=((($and191))|0)!=0; //@line 1286 "intonation.cpp"
            if ($tobool192) { __label__ = 58;; } else { __label__ = 69;; } //@line 1286 "intonation.cpp"
            if (__label__ == 58) {
  
              var $162=$st_ix; //@line 1288 "intonation.cpp"
              var $163=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 1288 "intonation.cpp"
              var $arrayidx194=(($163+6*$162)&4294967295); //@line 1288 "intonation.cpp"
              $syl=$arrayidx194; //@line 1288 "intonation.cpp"
              var $164=$syl; //@line 1290 "intonation.cpp"
              var $pitch1=(($164+4)&4294967295); //@line 1290 "intonation.cpp"
              var $165=HEAP8[($pitch1)]; //@line 1290 "intonation.cpp"
              var $166=$p; //@line 1290 "intonation.cpp"
              var $pitch1195=(($166+20)&4294967295); //@line 1290 "intonation.cpp"
              HEAP8[($pitch1195)]=$165; //@line 1290 "intonation.cpp"
              var $167=$syl; //@line 1291 "intonation.cpp"
              var $pitch2=(($167+5)&4294967295); //@line 1291 "intonation.cpp"
              var $168=HEAP8[($pitch2)]; //@line 1291 "intonation.cpp"
              var $169=$p; //@line 1291 "intonation.cpp"
              var $pitch2196=(($169+21)&4294967295); //@line 1291 "intonation.cpp"
              HEAP8[($pitch2196)]=$168; //@line 1291 "intonation.cpp"
              var $170=$p; //@line 1293 "intonation.cpp"
              var $env197=(($170+14)&4294967295); //@line 1293 "intonation.cpp"
              HEAP8[($env197)]=0; //@line 1293 "intonation.cpp"
              var $171=$syl; //@line 1294 "intonation.cpp"
              var $flags198=(($171+2)&4294967295); //@line 1294 "intonation.cpp"
              var $172=HEAP8[($flags198)]; //@line 1294 "intonation.cpp"
              var $conv199=(tempInt=(($172)),(tempInt>=128?tempInt-256:tempInt)); //@line 1294 "intonation.cpp"
              var $and200=($conv199) & 1; //@line 1294 "intonation.cpp"
              var $tobool201=((($and200))|0)!=0; //@line 1294 "intonation.cpp"
              var $173=$p; //@line 1296 "intonation.cpp"
              if ($tobool201) { __label__ = 59;; } else { __label__ = 60;; } //@line 1294 "intonation.cpp"
              $if_then202$$if_else204$85: do { 
                if (__label__ == 59) {
  
                  var $env203=(($173+14)&4294967295); //@line 1296 "intonation.cpp"
                  HEAP8[($env203)]=2; //@line 1296 "intonation.cpp"
                  ; //@line 1297 "intonation.cpp"
                }
                else if (__label__ == 60) {
  
                  var $stresslevel205=(($173+1)&4294967295); //@line 1299 "intonation.cpp"
                  var $174=HEAPU8[($stresslevel205)]; //@line 1299 "intonation.cpp"
                  var $conv206=((($174))&255); //@line 1299 "intonation.cpp"
                  var $cmp207=((($conv206))|0) > 5; //@line 1299 "intonation.cpp"
                  if (!($cmp207)) { __label__ = 62;break $if_then202$$if_else204$85; } //@line 1299 "intonation.cpp"
  
                  var $175=$syl; //@line 1300 "intonation.cpp"
                  var $env209=(($175+1)&4294967295); //@line 1300 "intonation.cpp"
                  var $176=HEAP8[($env209)]; //@line 1300 "intonation.cpp"
                  var $177=$p; //@line 1300 "intonation.cpp"
                  var $env210=(($177+14)&4294967295); //@line 1300 "intonation.cpp"
                  HEAP8[($env210)]=$176; //@line 1300 "intonation.cpp"
                  ; //@line 1300 "intonation.cpp"
                }
              } while(0);
  
              var $178=$p; //@line 1302 "intonation.cpp"
              var $pitch1213=(($178+20)&4294967295); //@line 1302 "intonation.cpp"
              var $179=HEAPU8[($pitch1213)]; //@line 1302 "intonation.cpp"
              var $conv214=((($179))&255); //@line 1302 "intonation.cpp"
              var $180=$p; //@line 1302 "intonation.cpp"
              var $pitch2215=(($180+21)&4294967295); //@line 1302 "intonation.cpp"
              var $181=HEAPU8[($pitch2215)]; //@line 1302 "intonation.cpp"
              var $conv216=((($181))&255); //@line 1302 "intonation.cpp"
              var $cmp217=((($conv214))|0) > ((($conv216))|0); //@line 1302 "intonation.cpp"
              if ($cmp217) { __label__ = 63;; } else { __label__ = 64;; } //@line 1302 "intonation.cpp"
              if (__label__ == 63) {
  
                var $182=$p; //@line 1305 "intonation.cpp"
                var $pitch1219=(($182+20)&4294967295); //@line 1305 "intonation.cpp"
                var $183=HEAPU8[($pitch1219)]; //@line 1305 "intonation.cpp"
                var $conv220=((($183))&255); //@line 1305 "intonation.cpp"
                $x=$conv220; //@line 1305 "intonation.cpp"
                var $184=$p; //@line 1306 "intonation.cpp"
                var $pitch2221=(($184+21)&4294967295); //@line 1306 "intonation.cpp"
                var $185=HEAP8[($pitch2221)]; //@line 1306 "intonation.cpp"
                var $186=$p; //@line 1306 "intonation.cpp"
                var $pitch1222=(($186+20)&4294967295); //@line 1306 "intonation.cpp"
                HEAP8[($pitch1222)]=$185; //@line 1306 "intonation.cpp"
                var $187=$x; //@line 1307 "intonation.cpp"
                var $conv223=((($187)) & 255); //@line 1307 "intonation.cpp"
                var $188=$p; //@line 1307 "intonation.cpp"
                var $pitch2224=(($188+21)&4294967295); //@line 1307 "intonation.cpp"
                HEAP8[($pitch2224)]=$conv223; //@line 1307 "intonation.cpp"
                ; //@line 1308 "intonation.cpp"
              }
  
              var $189=$p; //@line 1310 "intonation.cpp"
              var $tone_ph=(($189+3)&4294967295); //@line 1310 "intonation.cpp"
              var $190=HEAP8[($tone_ph)]; //@line 1310 "intonation.cpp"
              var $tobool226=(tempInt=(($190)),(tempInt>=128?tempInt-256:tempInt))!=0; //@line 1310 "intonation.cpp"
              if ($tobool226) { __label__ = 65;; } else { __label__ = 66;; } //@line 1310 "intonation.cpp"
              if (__label__ == 65) {
  
                var $191=$p; //@line 1312 "intonation.cpp"
                var $tone_ph228=(($191+3)&4294967295); //@line 1312 "intonation.cpp"
                var $192=HEAPU8[($tone_ph228)]; //@line 1312 "intonation.cpp"
                var $idxprom=((($192))&255); //@line 1312 "intonation.cpp"
                var $arrayidx229=((_phoneme_tab+$idxprom*4)&4294967295); //@line 1312 "intonation.cpp"
                var $193=HEAP32[(($arrayidx229)>>2)]; //@line 1312 "intonation.cpp"
                $ph=$193; //@line 1312 "intonation.cpp"
                var $194=$p; //@line 1313 "intonation.cpp"
                var $pitch1230=(($194+20)&4294967295); //@line 1313 "intonation.cpp"
                var $195=HEAPU8[($pitch1230)]; //@line 1313 "intonation.cpp"
                var $conv231=((($195))&255); //@line 1313 "intonation.cpp"
                var $196=$p; //@line 1313 "intonation.cpp"
                var $pitch2232=(($196+21)&4294967295); //@line 1313 "intonation.cpp"
                var $197=HEAPU8[($pitch2232)]; //@line 1313 "intonation.cpp"
                var $conv233=((($197))&255); //@line 1313 "intonation.cpp"
                var $add234=((($conv233)+($conv231))&4294967295); //@line 1313 "intonation.cpp"
                var $div=((((($add234))|0)/2)|0); //@line 1313 "intonation.cpp"
                $x=$div; //@line 1313 "intonation.cpp"
                var $198=$x; //@line 1314 "intonation.cpp"
                var $199=$ph; //@line 1314 "intonation.cpp"
                var $end_type=(($199+13)&4294967295); //@line 1314 "intonation.cpp"
                var $200=HEAPU8[($end_type)]; //@line 1314 "intonation.cpp"
                var $conv235=((($200))&255); //@line 1314 "intonation.cpp"
                var $add236=((($conv235)+($198))&4294967295); //@line 1314 "intonation.cpp"
                var $conv237=((($add236)) & 255); //@line 1314 "intonation.cpp"
                var $201=$p; //@line 1314 "intonation.cpp"
                var $pitch2238=(($201+21)&4294967295); //@line 1314 "intonation.cpp"
                HEAP8[($pitch2238)]=$conv237; //@line 1314 "intonation.cpp"
                var $202=$x; //@line 1315 "intonation.cpp"
                var $203=$ph; //@line 1315 "intonation.cpp"
                var $start_type=(($203+12)&4294967295); //@line 1315 "intonation.cpp"
                var $204=HEAPU8[($start_type)]; //@line 1315 "intonation.cpp"
                var $conv239=((($204))&255); //@line 1315 "intonation.cpp"
                var $add240=((($conv239)+($202))&4294967295); //@line 1315 "intonation.cpp"
                var $conv241=((($add240)) & 255); //@line 1315 "intonation.cpp"
                var $205=$p; //@line 1315 "intonation.cpp"
                var $pitch1242=(($205+20)&4294967295); //@line 1315 "intonation.cpp"
                HEAP8[($pitch1242)]=$conv241; //@line 1315 "intonation.cpp"
                ; //@line 1316 "intonation.cpp"
              }
  
              var $206=$syl; //@line 1318 "intonation.cpp"
              var $flags244=(($206+2)&4294967295); //@line 1318 "intonation.cpp"
              var $207=HEAP8[($flags244)]; //@line 1318 "intonation.cpp"
              var $conv245=(tempInt=(($207)),(tempInt>=128?tempInt-256:tempInt)); //@line 1318 "intonation.cpp"
              var $and246=($conv245) & 2; //@line 1318 "intonation.cpp"
              var $tobool247=((($and246))|0)!=0; //@line 1318 "intonation.cpp"
              if ($tobool247) { __label__ = 67;; } else { __label__ = 68;; } //@line 1318 "intonation.cpp"
              if (__label__ == 67) {
  
                var $208=$p; //@line 1320 "intonation.cpp"
                var $stresslevel249=(($208+1)&4294967295); //@line 1320 "intonation.cpp"
                var $209=HEAPU8[($stresslevel249)]; //@line 1320 "intonation.cpp"
                var $conv250=((($209))&255); //@line 1320 "intonation.cpp"
                var $or251=($conv250) | 8; //@line 1320 "intonation.cpp"
                var $conv252=((($or251)) & 255); //@line 1320 "intonation.cpp"
                HEAP8[($stresslevel249)]=$conv252; //@line 1320 "intonation.cpp"
                ; //@line 1321 "intonation.cpp"
              }
  
              var $210=$st_ix; //@line 1323 "intonation.cpp"
              var $inc254=((($210)+1)&4294967295); //@line 1323 "intonation.cpp"
              $st_ix=$inc254; //@line 1323 "intonation.cpp"
              ; //@line 1324 "intonation.cpp"
            }
  
            var $211=$ix; //@line 1281 "intonation.cpp"
            var $inc257=((($211)+1)&4294967295); //@line 1281 "intonation.cpp"
            $ix=$inc257; //@line 1281 "intonation.cpp"
            var $212=$ix; //@line 1281 "intonation.cpp"
            var $213=$ph_end; //@line 1281 "intonation.cpp"
            var $cmp183=((($212))|0) < ((($213))|0); //@line 1281 "intonation.cpp"
            if ($cmp183) { __label__ = 57;continue $for_body184$81; } else { __label__ = 70;break $for_end258$$if_end28$13; } //@line 1281 "intonation.cpp"
          }
        }
      }
    } while(0);
  
    STACKTOP = __stackBase__;
    return; //@line 1327 "intonation.cpp"
    return;
  }
  

  function __ZL16CalcPitches_ToneP10Translatori($tr, $clause_tone) {
    ;
    var __label__;
  
    var $tr_addr;
    var $clause_tone_addr;
    var $p;
    var $ix;
    var $count_stressed;
    var $final_stressed;
    var $tone_ph;
    var $pause;
    var $tone_promoted;
    var $tph;
    var $prev_tph;
    var $prevw_tph;
    var $prev2_tph;
    var $prev_p;
    var $pitch_adjust;
    var $pitch_decrement;
    var $pitch_low;
    var $pitch_high;
    $tr_addr=$tr;
    $clause_tone_addr=$clause_tone;
    $count_stressed=0; //@line 935 "intonation.cpp"
    $final_stressed=0; //@line 936 "intonation.cpp"
    $pitch_adjust=0; //@line 947 "intonation.cpp"
    $pitch_decrement=0; //@line 948 "intonation.cpp"
    $pitch_low=0; //@line 949 "intonation.cpp"
    $pitch_high=0; //@line 950 "intonation.cpp"
    $p=((_phoneme_list)&4294967295); //@line 955 "intonation.cpp"
    $ix=0; //@line 956 "intonation.cpp"
    var $0=$ix; //@line 956 "intonation.cpp"
    var $1=HEAP32[((_n_phoneme_list)>>2)]; //@line 956 "intonation.cpp"
    var $cmp5=((($0))|0) < ((($1))|0); //@line 956 "intonation.cpp"
    if ($cmp5) { __label__ = 1;; } else { __label__ = 8;; } //@line 956 "intonation.cpp"
    $for_body$$for_end$2: do { 
      if (__label__ == 1) {
        $for_body$3: while(1) { 
  
          var $2=$p; //@line 958 "intonation.cpp"
          var $type=(($2+15)&4294967295); //@line 958 "intonation.cpp"
          var $3=HEAPU8[($type)]; //@line 958 "intonation.cpp"
          var $conv=((($3))&255); //@line 958 "intonation.cpp"
          var $cmp1=((($conv))|0)==2; //@line 958 "intonation.cpp"
          if ($cmp1) { __label__ = 2;; } else { __label__ = 7;; } //@line 958 "intonation.cpp"
          $land_lhs_true$$for_inc$5: do { 
            if (__label__ == 2) {
  
              var $4=$p; //@line 958 "intonation.cpp"
              var $stresslevel=(($4+1)&4294967295); //@line 958 "intonation.cpp"
              var $5=HEAPU8[($stresslevel)]; //@line 958 "intonation.cpp"
              var $conv2=((($5))&255); //@line 958 "intonation.cpp"
              var $cmp3=((($conv2))|0) >= 4; //@line 958 "intonation.cpp"
              if (!($cmp3)) { __label__ = 7;break $land_lhs_true$$for_inc$5; } //@line 958 "intonation.cpp"
  
              var $6=$count_stressed; //@line 960 "intonation.cpp"
              var $cmp4=((($6))|0)==0; //@line 960 "intonation.cpp"
              if ($cmp4) { __label__ = 4;; } else { __label__ = 5;; } //@line 960 "intonation.cpp"
              if (__label__ == 4) {
  
                var $7=$ix; //@line 961 "intonation.cpp"
                $final_stressed=$7; //@line 961 "intonation.cpp"
                ; //@line 961 "intonation.cpp"
              }
  
              var $8=$p; //@line 963 "intonation.cpp"
              var $stresslevel6=(($8+1)&4294967295); //@line 963 "intonation.cpp"
              var $9=HEAPU8[($stresslevel6)]; //@line 963 "intonation.cpp"
              var $conv7=((($9))&255); //@line 963 "intonation.cpp"
              var $cmp8=((($conv7))|0) >= 4; //@line 963 "intonation.cpp"
              if (!($cmp8)) { __label__ = 7;break $land_lhs_true$$for_inc$5; } //@line 963 "intonation.cpp"
  
              var $10=$ix; //@line 965 "intonation.cpp"
              $final_stressed=$10; //@line 965 "intonation.cpp"
              var $11=$count_stressed; //@line 966 "intonation.cpp"
              var $inc=((($11)+1)&4294967295); //@line 966 "intonation.cpp"
              $count_stressed=$inc; //@line 966 "intonation.cpp"
              ; //@line 967 "intonation.cpp"
            }
          } while(0);
  
          var $12=$ix; //@line 956 "intonation.cpp"
          var $inc12=((($12)+1)&4294967295); //@line 956 "intonation.cpp"
          $ix=$inc12; //@line 956 "intonation.cpp"
          var $13=$p; //@line 956 "intonation.cpp"
          var $incdec_ptr=(($13+24)&4294967295); //@line 956 "intonation.cpp"
          $p=$incdec_ptr; //@line 956 "intonation.cpp"
          var $14=$ix; //@line 956 "intonation.cpp"
          var $15=HEAP32[((_n_phoneme_list)>>2)]; //@line 956 "intonation.cpp"
          var $cmp=((($14))|0) < ((($15))|0); //@line 956 "intonation.cpp"
          if ($cmp) { __label__ = 1;continue $for_body$3; } else { __label__ = 8;break $for_body$$for_end$2; } //@line 956 "intonation.cpp"
        }
      }
    } while(0);
  
    var $16=$final_stressed; //@line 971 "intonation.cpp"
    var $arrayidx=((_phoneme_list+$16*24)&4294967295); //@line 971 "intonation.cpp"
    var $stresslevel13=(($arrayidx+1)&4294967295); //@line 971 "intonation.cpp"
    HEAP8[($stresslevel13)]=7; //@line 971 "intonation.cpp"
    var $17=$tr_addr; //@line 974 "intonation.cpp"
    var $translator_name=(($17+280)&4294967295); //@line 974 "intonation.cpp"
    var $18=HEAP32[(($translator_name)>>2)]; //@line 974 "intonation.cpp"
    var $cmp14=((($18))|0)==30313; //@line 974 "intonation.cpp"
    if ($cmp14) { __label__ = 9;; } else { __label__ = 11;; } //@line 974 "intonation.cpp"
    $if_then15$$if_end24$14: do { 
      if (__label__ == 9) {
  
        var $19=$final_stressed; //@line 977 "intonation.cpp"
        var $arrayidx16=((_phoneme_list+$19*24)&4294967295); //@line 977 "intonation.cpp"
        $p=$arrayidx16; //@line 977 "intonation.cpp"
        var $20=$p; //@line 978 "intonation.cpp"
        var $tone_ph17=(($20+3)&4294967295); //@line 978 "intonation.cpp"
        var $21=HEAPU8[($tone_ph17)]; //@line 978 "intonation.cpp"
        var $conv18=((($21))&255); //@line 978 "intonation.cpp"
        var $cmp19=((($conv18))|0)==0; //@line 978 "intonation.cpp"
        if (!($cmp19)) { __label__ = 11;break $if_then15$$if_end24$14; } //@line 978 "intonation.cpp"
  
        var $call=__Z11PhonemeCodej(55); //@line 979 "intonation.cpp"
        var $conv21=((($call)) & 255); //@line 979 "intonation.cpp"
        var $22=$p; //@line 979 "intonation.cpp"
        var $tone_ph22=(($22+3)&4294967295); //@line 979 "intonation.cpp"
        HEAP8[($tone_ph22)]=$conv21; //@line 979 "intonation.cpp"
        ; //@line 979 "intonation.cpp"
      }
    } while(0);
  
    $pause=1; //@line 983 "intonation.cpp"
    $tone_promoted=0; //@line 984 "intonation.cpp"
    $p=((_phoneme_list)&4294967295); //@line 986 "intonation.cpp"
    $prev_p=((_phoneme_list)&4294967295); //@line 986 "intonation.cpp"
    var $23=HEAP32[((((_phoneme_tab+36)&4294967295))>>2)]; //@line 987 "intonation.cpp"
    $prevw_tph=$23; //@line 987 "intonation.cpp"
    $prev_tph=$23; //@line 987 "intonation.cpp"
    $ix=0; //@line 990 "intonation.cpp"
    var $24=$ix; //@line 990 "intonation.cpp"
    var $25=HEAP32[((_n_phoneme_list)>>2)]; //@line 990 "intonation.cpp"
    var $cmp262=((($24))|0) < ((($25))|0); //@line 990 "intonation.cpp"
    if ($cmp262) { __label__ = 12;; } else { __label__ = 47;; } //@line 990 "intonation.cpp"
    $for_body27$$for_end127$18: do { 
      if (__label__ == 12) {
        $for_body27$19: while(1) { 
  
          var $26=$p; //@line 992 "intonation.cpp"
          var $type28=(($26+15)&4294967295); //@line 992 "intonation.cpp"
          var $27=HEAPU8[($type28)]; //@line 992 "intonation.cpp"
          var $conv29=((($27))&255); //@line 992 "intonation.cpp"
          var $cmp30=((($conv29))|0)==0; //@line 992 "intonation.cpp"
          if ($cmp30) { __label__ = 13;; } else { __label__ = 15;; } //@line 992 "intonation.cpp"
          $land_lhs_true31$$if_end35$21: do { 
            if (__label__ == 13) {
  
              var $28=$p; //@line 992 "intonation.cpp"
              var $ph=(($28+8)&4294967295); //@line 992 "intonation.cpp"
              var $29=HEAP32[(($ph)>>2)]; //@line 992 "intonation.cpp"
              var $std_length=(($29+14)&4294967295); //@line 992 "intonation.cpp"
              var $30=HEAPU8[($std_length)]; //@line 992 "intonation.cpp"
              var $conv32=((($30))&255); //@line 992 "intonation.cpp"
              var $cmp33=((($conv32))|0) > 50; //@line 992 "intonation.cpp"
              if (!($cmp33)) { __label__ = 15;break $land_lhs_true31$$if_end35$21; } //@line 992 "intonation.cpp"
  
              $pause=1; //@line 994 "intonation.cpp"
              var $31=HEAP32[((((_phoneme_tab+36)&4294967295))>>2)]; //@line 995 "intonation.cpp"
              $prevw_tph=$31; //@line 995 "intonation.cpp"
              ; //@line 996 "intonation.cpp"
            }
          } while(0);
  
          var $32=$p; //@line 998 "intonation.cpp"
          var $newword=(($32+19)&4294967295); //@line 998 "intonation.cpp"
          var $33=HEAP8[($newword)]; //@line 998 "intonation.cpp"
          var $tobool=(tempInt=(($33)),(tempInt>=128?tempInt-256:tempInt))!=0; //@line 998 "intonation.cpp"
          if ($tobool) { __label__ = 16;; } else { __label__ = 17;; } //@line 998 "intonation.cpp"
          if (__label__ == 16) {
  
            var $34=HEAP32[((((_phoneme_tab+36)&4294967295))>>2)]; //@line 1000 "intonation.cpp"
            $prev_tph=$34; //@line 1000 "intonation.cpp"
            ; //@line 1001 "intonation.cpp"
          }
  
          var $35=$p; //@line 1003 "intonation.cpp"
          var $synthflags=(($35+4)&4294967295); //@line 1003 "intonation.cpp"
          var $36=HEAPU16[(($synthflags)>>1)]; //@line 1003 "intonation.cpp"
          var $conv38=((($36))&65535); //@line 1003 "intonation.cpp"
          var $and=($conv38) & 4; //@line 1003 "intonation.cpp"
          var $tobool39=((($and))|0)!=0; //@line 1003 "intonation.cpp"
          if ($tobool39) { __label__ = 18;; } else { __label__ = 46;; } //@line 1003 "intonation.cpp"
          if (__label__ == 18) {
  
            var $37=$p; //@line 1005 "intonation.cpp"
            var $tone_ph41=(($37+3)&4294967295); //@line 1005 "intonation.cpp"
            var $38=HEAPU8[($tone_ph41)]; //@line 1005 "intonation.cpp"
            var $conv42=((($38))&255); //@line 1005 "intonation.cpp"
            $tone_ph=$conv42; //@line 1005 "intonation.cpp"
            var $39=$tone_ph; //@line 1006 "intonation.cpp"
            var $arrayidx43=((_phoneme_tab+$39*4)&4294967295); //@line 1006 "intonation.cpp"
            var $40=HEAP32[(($arrayidx43)>>2)]; //@line 1006 "intonation.cpp"
            $tph=$40; //@line 1006 "intonation.cpp"
            var $41=$tr_addr; //@line 1009 "intonation.cpp"
            var $translator_name44=(($41+280)&4294967295); //@line 1009 "intonation.cpp"
            var $42=HEAP32[(($translator_name44)>>2)]; //@line 1009 "intonation.cpp"
            var $cmp45=((($42))|0)==31336; //@line 1009 "intonation.cpp"
            if ($cmp45) { __label__ = 19;; } else { __label__ = 45;; } //@line 1009 "intonation.cpp"
            $if_then46$$if_end122$30: do { 
              if (__label__ == 19) {
  
                var $43=$tone_ph; //@line 1011 "intonation.cpp"
                var $cmp47=((($43))|0)==0; //@line 1011 "intonation.cpp"
                if ($cmp47) { __label__ = 20;; } else { __label__ = 25;; } //@line 1011 "intonation.cpp"
                if (__label__ == 20) {
  
                  var $44=$pause; //@line 1013 "intonation.cpp"
                  var $tobool49=((($44))|0)!=0; //@line 1013 "intonation.cpp"
                  if ($tobool49) { __label__ = 22;; } else { __label__ = 21;; } //@line 1013 "intonation.cpp"
                  $if_then51$$lor_lhs_false$34: do { 
                    if (__label__ == 21) {
  
                      var $45=$tone_promoted; //@line 1013 "intonation.cpp"
                      var $tobool50=((($45))|0)!=0; //@line 1013 "intonation.cpp"
                      if ($tobool50) { __label__ = 22;break $if_then51$$lor_lhs_false$34; } //@line 1013 "intonation.cpp"
  
                      var $call53=__Z11PhonemeCodej(12593); //@line 1020 "intonation.cpp"
                      $tone_ph=$call53; //@line 1020 "intonation.cpp"
                      __label__ = 24;break $if_then51$$lor_lhs_false$34;
                    }
                  } while(0);
                  if (__label__ == 22) {
  
                    var $call52=__Z11PhonemeCodej(13621); //@line 1015 "intonation.cpp"
                    $tone_ph=$call52; //@line 1015 "intonation.cpp"
                    $tone_promoted=1; //@line 1016 "intonation.cpp"
                    ; //@line 1017 "intonation.cpp"
                  }
  
                  var $46=$tone_ph; //@line 1023 "intonation.cpp"
                  var $conv55=((($46)) & 255); //@line 1023 "intonation.cpp"
                  var $47=$p; //@line 1023 "intonation.cpp"
                  var $tone_ph56=(($47+3)&4294967295); //@line 1023 "intonation.cpp"
                  HEAP8[($tone_ph56)]=$conv55; //@line 1023 "intonation.cpp"
                  var $48=$tone_ph; //@line 1024 "intonation.cpp"
                  var $arrayidx57=((_phoneme_tab+$48*4)&4294967295); //@line 1024 "intonation.cpp"
                  var $49=HEAP32[(($arrayidx57)>>2)]; //@line 1024 "intonation.cpp"
                  $tph=$49; //@line 1024 "intonation.cpp"
                  ; //@line 1026 "intonation.cpp"
                }
                else if (__label__ == 25) {
  
                  $tone_promoted=0; //@line 1029 "intonation.cpp"
                  ;
                }
  
                var $50=$ix; //@line 1032 "intonation.cpp"
                var $51=$final_stressed; //@line 1032 "intonation.cpp"
                var $cmp60=((($50))|0)==((($51))|0); //@line 1032 "intonation.cpp"
                if ($cmp60) { __label__ = 27;; } else { __label__ = 30;; } //@line 1032 "intonation.cpp"
                $if_then61$$if_end70$42: do { 
                  if (__label__ == 27) {
  
                    var $52=$tph; //@line 1034 "intonation.cpp"
                    var $mnemonic=(($52)&4294967295); //@line 1034 "intonation.cpp"
                    var $53=HEAP32[(($mnemonic)>>2)]; //@line 1034 "intonation.cpp"
                    var $cmp62=((($53))|0)==13621; //@line 1034 "intonation.cpp"
                    if ($cmp62) { __label__ = 29;; } else { __label__ = 28;; } //@line 1034 "intonation.cpp"
                    if (__label__ == 28) {
  
                      var $54=$tph; //@line 1034 "intonation.cpp"
                      var $mnemonic64=(($54)&4294967295); //@line 1034 "intonation.cpp"
                      var $55=HEAP32[(($mnemonic64)>>2)]; //@line 1034 "intonation.cpp"
                      var $cmp65=((($55))|0)==12597; //@line 1034 "intonation.cpp"
                      if (!($cmp65)) { __label__ = 30;break $if_then61$$if_end70$42; } //@line 1034 "intonation.cpp"
                    }
  
                    var $56=$final_stressed; //@line 1037 "intonation.cpp"
                    var $arrayidx67=((_phoneme_list+$56*24)&4294967295); //@line 1037 "intonation.cpp"
                    var $stresslevel68=(($arrayidx67+1)&4294967295); //@line 1037 "intonation.cpp"
                    HEAP8[($stresslevel68)]=6; //@line 1037 "intonation.cpp"
                    ; //@line 1038 "intonation.cpp"
                  }
                } while(0);
  
                var $57=$prevw_tph; //@line 1041 "intonation.cpp"
                var $mnemonic71=(($57)&4294967295); //@line 1041 "intonation.cpp"
                var $58=HEAP32[(($mnemonic71)>>2)]; //@line 1041 "intonation.cpp"
                var $cmp72=((($58))|0)==3420466; //@line 1041 "intonation.cpp"
                if ($cmp72) { __label__ = 31;; } else { __label__ = 34;; } //@line 1041 "intonation.cpp"
                if (__label__ == 31) {
  
                  var $59=$tph; //@line 1043 "intonation.cpp"
                  var $mnemonic74=(($59)&4294967295); //@line 1043 "intonation.cpp"
                  var $60=HEAP32[(($mnemonic74)>>2)]; //@line 1043 "intonation.cpp"
                  var $cmp75=((($60))|0)==3420466; //@line 1043 "intonation.cpp"
                  if ($cmp75) { __label__ = 32;; } else { __label__ = 33;; } //@line 1043 "intonation.cpp"
                  if (__label__ == 32) {
  
                    var $call77=__Z11PhonemeCodej(13619); //@line 1044 "intonation.cpp"
                    var $conv78=((($call77)) & 255); //@line 1044 "intonation.cpp"
                    var $61=$prev_p; //@line 1044 "intonation.cpp"
                    var $tone_ph79=(($61+3)&4294967295); //@line 1044 "intonation.cpp"
                    HEAP8[($tone_ph79)]=$conv78; //@line 1044 "intonation.cpp"
                    ; //@line 1044 "intonation.cpp"
                  }
                  else if (__label__ == 33) {
  
                    var $call81=__Z11PhonemeCodej(12594); //@line 1046 "intonation.cpp"
                    var $conv82=((($call81)) & 255); //@line 1046 "intonation.cpp"
                    var $62=$prev_p; //@line 1046 "intonation.cpp"
                    var $tone_ph83=(($62+3)&4294967295); //@line 1046 "intonation.cpp"
                    HEAP8[($tone_ph83)]=$conv82; //@line 1046 "intonation.cpp"
                    ;
                  }
                }
  
                var $63=$prev_tph; //@line 1048 "intonation.cpp"
                var $mnemonic86=(($63)&4294967295); //@line 1048 "intonation.cpp"
                var $64=HEAP32[(($mnemonic86)>>2)]; //@line 1048 "intonation.cpp"
                var $cmp87=((($64))|0)==12597; //@line 1048 "intonation.cpp"
                if ($cmp87) { __label__ = 35;; } else { __label__ = 37;; } //@line 1048 "intonation.cpp"
                $land_lhs_true88$$if_end95$54: do { 
                  if (__label__ == 35) {
  
                    var $65=$tph; //@line 1048 "intonation.cpp"
                    var $mnemonic89=(($65)&4294967295); //@line 1048 "intonation.cpp"
                    var $66=HEAP32[(($mnemonic89)>>2)]; //@line 1048 "intonation.cpp"
                    var $cmp90=((($66))|0)==12597; //@line 1048 "intonation.cpp"
                    if (!($cmp90)) { __label__ = 37;break $land_lhs_true88$$if_end95$54; } //@line 1048 "intonation.cpp"
  
                    var $call92=__Z11PhonemeCodej(13109); //@line 1050 "intonation.cpp"
                    var $conv93=((($call92)) & 255); //@line 1050 "intonation.cpp"
                    var $67=$prev_p; //@line 1050 "intonation.cpp"
                    var $tone_ph94=(($67+3)&4294967295); //@line 1050 "intonation.cpp"
                    HEAP8[($tone_ph94)]=$conv93; //@line 1050 "intonation.cpp"
                    ; //@line 1051 "intonation.cpp"
                  }
                } while(0);
  
                var $68=$tph; //@line 1053 "intonation.cpp"
                var $mnemonic96=(($68)&4294967295); //@line 1053 "intonation.cpp"
                var $69=HEAP32[(($mnemonic96)>>2)]; //@line 1053 "intonation.cpp"
                var $cmp97=((($69))|0)==12593; //@line 1053 "intonation.cpp"
                if (!($cmp97)) { __label__ = 45;break $if_then46$$if_end122$30; } //@line 1053 "intonation.cpp"
  
                var $70=$prevw_tph; //@line 1056 "intonation.cpp"
                var $mnemonic99=(($70)&4294967295); //@line 1056 "intonation.cpp"
                var $71=HEAP32[(($mnemonic99)>>2)]; //@line 1056 "intonation.cpp"
                var $cmp100=((($71))|0)==13621; //@line 1056 "intonation.cpp"
                if ($cmp100) { __label__ = 39;; } else { __label__ = 40;; } //@line 1056 "intonation.cpp"
                if (__label__ == 39) {
  
                  var $call102=__Z11PhonemeCodej(12850); //@line 1057 "intonation.cpp"
                  var $conv103=((($call102)) & 255); //@line 1057 "intonation.cpp"
                  var $72=$p; //@line 1057 "intonation.cpp"
                  var $tone_ph104=(($72+3)&4294967295); //@line 1057 "intonation.cpp"
                  HEAP8[($tone_ph104)]=$conv103; //@line 1057 "intonation.cpp"
                  ; //@line 1057 "intonation.cpp"
                }
  
                var $73=$prevw_tph; //@line 1058 "intonation.cpp"
                var $mnemonic106=(($73)&4294967295); //@line 1058 "intonation.cpp"
                var $74=HEAP32[(($mnemonic106)>>2)]; //@line 1058 "intonation.cpp"
                var $cmp107=((($74))|0)==13619; //@line 1058 "intonation.cpp"
                if ($cmp107) { __label__ = 41;; } else { __label__ = 42;; } //@line 1058 "intonation.cpp"
                if (__label__ == 41) {
  
                  var $call109=__Z11PhonemeCodej(13107); //@line 1059 "intonation.cpp"
                  var $conv110=((($call109)) & 255); //@line 1059 "intonation.cpp"
                  var $75=$p; //@line 1059 "intonation.cpp"
                  var $tone_ph111=(($75+3)&4294967295); //@line 1059 "intonation.cpp"
                  HEAP8[($tone_ph111)]=$conv110; //@line 1059 "intonation.cpp"
                  ; //@line 1059 "intonation.cpp"
                }
  
                var $76=$prevw_tph; //@line 1060 "intonation.cpp"
                var $mnemonic113=(($76)&4294967295); //@line 1060 "intonation.cpp"
                var $77=HEAP32[(($mnemonic113)>>2)]; //@line 1060 "intonation.cpp"
                var $cmp114=((($77))|0)==3420466; //@line 1060 "intonation.cpp"
                if ($cmp114) { __label__ = 43;; } else { __label__ = 44;; } //@line 1060 "intonation.cpp"
                if (__label__ == 43) {
  
                  var $call116=__Z11PhonemeCodej(13364); //@line 1061 "intonation.cpp"
                  var $conv117=((($call116)) & 255); //@line 1061 "intonation.cpp"
                  var $78=$p; //@line 1061 "intonation.cpp"
                  var $tone_ph118=(($78+3)&4294967295); //@line 1061 "intonation.cpp"
                  HEAP8[($tone_ph118)]=$conv117; //@line 1061 "intonation.cpp"
                  ; //@line 1061 "intonation.cpp"
                }
  
                var $79=$p; //@line 1064 "intonation.cpp"
                var $stresslevel120=(($79+1)&4294967295); //@line 1064 "intonation.cpp"
                HEAP8[($stresslevel120)]=0; //@line 1064 "intonation.cpp"
                ; //@line 1065 "intonation.cpp"
              }
            } while(0);
  
            var $80=$p; //@line 1068 "intonation.cpp"
            $prev_p=$80; //@line 1068 "intonation.cpp"
            var $81=$prevw_tph; //@line 1069 "intonation.cpp"
            $prev2_tph=$81; //@line 1069 "intonation.cpp"
            var $82=$tph; //@line 1070 "intonation.cpp"
            $prev_tph=$82; //@line 1070 "intonation.cpp"
            $prevw_tph=$82; //@line 1070 "intonation.cpp"
            $pause=0; //@line 1071 "intonation.cpp"
            ; //@line 1072 "intonation.cpp"
          }
  
          var $83=$ix; //@line 990 "intonation.cpp"
          var $inc125=((($83)+1)&4294967295); //@line 990 "intonation.cpp"
          $ix=$inc125; //@line 990 "intonation.cpp"
          var $84=$p; //@line 990 "intonation.cpp"
          var $incdec_ptr126=(($84+24)&4294967295); //@line 990 "intonation.cpp"
          $p=$incdec_ptr126; //@line 990 "intonation.cpp"
          var $85=$ix; //@line 990 "intonation.cpp"
          var $86=HEAP32[((_n_phoneme_list)>>2)]; //@line 990 "intonation.cpp"
          var $cmp26=((($85))|0) < ((($86))|0); //@line 990 "intonation.cpp"
          if ($cmp26) { __label__ = 12;continue $for_body27$19; } else { __label__ = 47;break $for_body27$$for_end127$18; } //@line 990 "intonation.cpp"
        }
      }
    } while(0);
  
    $p=((_phoneme_list)&4294967295); //@line 1076 "intonation.cpp"
    $ix=0; //@line 1077 "intonation.cpp"
    var $87=$ix; //@line 1077 "intonation.cpp"
    var $88=HEAP32[((_n_phoneme_list)>>2)]; //@line 1077 "intonation.cpp"
    var $cmp1291=((($87))|0) < ((($88))|0); //@line 1077 "intonation.cpp"
    if ($cmp1291) { __label__ = 48;; } else { __label__ = 58;; } //@line 1077 "intonation.cpp"
    $for_body130$$for_end166$71: do { 
      if (__label__ == 48) {
        $for_body130$72: while(1) { 
  
          var $89=$p; //@line 1079 "intonation.cpp"
          var $synthflags131=(($89+4)&4294967295); //@line 1079 "intonation.cpp"
          var $90=HEAPU16[(($synthflags131)>>1)]; //@line 1079 "intonation.cpp"
          var $conv132=((($90))&65535); //@line 1079 "intonation.cpp"
          var $and133=($conv132) & 4; //@line 1079 "intonation.cpp"
          var $tobool134=((($and133))|0)!=0; //@line 1079 "intonation.cpp"
          if ($tobool134) { __label__ = 49;; } else { __label__ = 57;; } //@line 1079 "intonation.cpp"
          if (__label__ == 49) {
  
            var $91=$p; //@line 1081 "intonation.cpp"
            var $tone_ph136=(($91+3)&4294967295); //@line 1081 "intonation.cpp"
            var $92=HEAPU8[($tone_ph136)]; //@line 1081 "intonation.cpp"
            var $conv137=((($92))&255); //@line 1081 "intonation.cpp"
            $tone_ph=$conv137; //@line 1081 "intonation.cpp"
            var $93=$p; //@line 1083 "intonation.cpp"
            var $stresslevel138=(($93+1)&4294967295); //@line 1083 "intonation.cpp"
            var $94=HEAPU8[($stresslevel138)]; //@line 1083 "intonation.cpp"
            var $conv139=((($94))&255); //@line 1083 "intonation.cpp"
            var $cmp140=((($conv139))|0)!=0; //@line 1083 "intonation.cpp"
            if ($cmp140) { __label__ = 50;; } else { __label__ = 54;; } //@line 1083 "intonation.cpp"
            $if_then141$$if_end149$76: do { 
              if (__label__ == 50) {
  
                var $95=$ix; //@line 1085 "intonation.cpp"
                var $96=$final_stressed; //@line 1085 "intonation.cpp"
                var $cmp142=((($95))|0)==((($96))|0); //@line 1085 "intonation.cpp"
                if ($cmp142) { __label__ = 51;; } else { __label__ = 52;; } //@line 1085 "intonation.cpp"
                if (__label__ == 51) {
  
                  var $97=$pitch_low; //@line 1088 "intonation.cpp"
                  $pitch_adjust=$97; //@line 1088 "intonation.cpp"
                  ; //@line 1089 "intonation.cpp"
                }
                else if (__label__ == 52) {
  
                  var $98=$pitch_decrement; //@line 1092 "intonation.cpp"
                  var $99=$pitch_adjust; //@line 1092 "intonation.cpp"
                  var $sub=((($99)-($98))&4294967295); //@line 1092 "intonation.cpp"
                  $pitch_adjust=$sub; //@line 1092 "intonation.cpp"
                  var $100=$pitch_adjust; //@line 1093 "intonation.cpp"
                  var $101=$pitch_low; //@line 1093 "intonation.cpp"
                  var $cmp145=((($100))|0) <= ((($101))|0); //@line 1093 "intonation.cpp"
                  if (!($cmp145)) { __label__ = 54;break $if_then141$$if_end149$76; } //@line 1093 "intonation.cpp"
  
                  var $102=$pitch_high; //@line 1094 "intonation.cpp"
                  $pitch_adjust=$102; //@line 1094 "intonation.cpp"
                  ; //@line 1094 "intonation.cpp"
                }
              }
            } while(0);
  
            var $103=$tone_ph; //@line 1098 "intonation.cpp"
            var $cmp150=((($103))|0)==0; //@line 1098 "intonation.cpp"
            if ($cmp150) { __label__ = 55;; } else { __label__ = 56;; } //@line 1098 "intonation.cpp"
            if (__label__ == 55) {
  
              $tone_ph=17; //@line 1100 "intonation.cpp"
              var $104=$tone_ph; //@line 1101 "intonation.cpp"
              var $conv152=((($104)) & 255); //@line 1101 "intonation.cpp"
              var $105=$p; //@line 1101 "intonation.cpp"
              var $tone_ph153=(($105+3)&4294967295); //@line 1101 "intonation.cpp"
              HEAP8[($tone_ph153)]=$conv152; //@line 1101 "intonation.cpp"
              ; //@line 1102 "intonation.cpp"
            }
  
            var $106=$pitch_adjust; //@line 1103 "intonation.cpp"
            var $107=$tone_ph; //@line 1103 "intonation.cpp"
            var $arrayidx155=((_phoneme_tab+$107*4)&4294967295); //@line 1103 "intonation.cpp"
            var $108=HEAP32[(($arrayidx155)>>2)]; //@line 1103 "intonation.cpp"
            var $start_type=(($108+12)&4294967295); //@line 1103 "intonation.cpp"
            var $109=HEAPU8[($start_type)]; //@line 1103 "intonation.cpp"
            var $conv156=((($109))&255); //@line 1103 "intonation.cpp"
            var $add=((($conv156)+($106))&4294967295); //@line 1103 "intonation.cpp"
            var $conv157=((($add)) & 255); //@line 1103 "intonation.cpp"
            var $110=$p; //@line 1103 "intonation.cpp"
            var $pitch1=(($110+20)&4294967295); //@line 1103 "intonation.cpp"
            HEAP8[($pitch1)]=$conv157; //@line 1103 "intonation.cpp"
            var $111=$pitch_adjust; //@line 1104 "intonation.cpp"
            var $112=$tone_ph; //@line 1104 "intonation.cpp"
            var $arrayidx158=((_phoneme_tab+$112*4)&4294967295); //@line 1104 "intonation.cpp"
            var $113=HEAP32[(($arrayidx158)>>2)]; //@line 1104 "intonation.cpp"
            var $end_type=(($113+13)&4294967295); //@line 1104 "intonation.cpp"
            var $114=HEAPU8[($end_type)]; //@line 1104 "intonation.cpp"
            var $conv159=((($114))&255); //@line 1104 "intonation.cpp"
            var $add160=((($conv159)+($111))&4294967295); //@line 1104 "intonation.cpp"
            var $conv161=((($add160)) & 255); //@line 1104 "intonation.cpp"
            var $115=$p; //@line 1104 "intonation.cpp"
            var $pitch2=(($115+21)&4294967295); //@line 1104 "intonation.cpp"
            HEAP8[($pitch2)]=$conv161; //@line 1104 "intonation.cpp"
            ; //@line 1105 "intonation.cpp"
          }
  
          var $116=$ix; //@line 1077 "intonation.cpp"
          var $inc164=((($116)+1)&4294967295); //@line 1077 "intonation.cpp"
          $ix=$inc164; //@line 1077 "intonation.cpp"
          var $117=$p; //@line 1077 "intonation.cpp"
          var $incdec_ptr165=(($117+24)&4294967295); //@line 1077 "intonation.cpp"
          $p=$incdec_ptr165; //@line 1077 "intonation.cpp"
          var $118=$ix; //@line 1077 "intonation.cpp"
          var $119=HEAP32[((_n_phoneme_list)>>2)]; //@line 1077 "intonation.cpp"
          var $cmp129=((($118))|0) < ((($119))|0); //@line 1077 "intonation.cpp"
          if ($cmp129) { __label__ = 48;continue $for_body130$72; } else { __label__ = 58;break $for_body130$$for_end166$71; } //@line 1077 "intonation.cpp"
        }
      }
    } while(0);
  
    ;
    return; //@line 1109 "intonation.cpp"
    return;
  }
  

  function __ZL18count_pitch_vowelsiii($start, $end, $clause_end) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $start_addr;
    var $end_addr;
    var $clause_end_addr;
    var $ix;
    var $stress;
    var $max_stress;
    var $max_stress_posn;
    var $max_stress_posn2;
    $start_addr=$start;
    $end_addr=$end;
    $clause_end_addr=$clause_end;
    $max_stress=0; //@line 333 "intonation.cpp"
    $max_stress_posn=0; //@line 334 "intonation.cpp"
    $max_stress_posn2=0; //@line 335 "intonation.cpp"
    HEAP32[((__ZL10number_pre)>>2)]=-1; //@line 337 "intonation.cpp"
    HEAP32[((__ZL11number_tail)>>2)]=0; //@line 339 "intonation.cpp"
    HEAP32[((__ZL12last_primary)>>2)]=-1; //@line 340 "intonation.cpp"
    var $0=$start_addr; //@line 342 "intonation.cpp"
    $ix=$0; //@line 342 "intonation.cpp"
    var $1=$ix; //@line 342 "intonation.cpp"
    var $2=$end_addr; //@line 342 "intonation.cpp"
    var $cmp1=((($1))|0) < ((($2))|0); //@line 342 "intonation.cpp"
    if ($cmp1) { __label__ = 1;; } else { __label__ = 11;; } //@line 342 "intonation.cpp"
    $for_body$$for_end$2: do { 
      if (__label__ == 1) {
        while(1) { 
  
          var $3=$ix; //@line 344 "intonation.cpp"
          var $4=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 344 "intonation.cpp"
          var $arrayidx=(($4+6*$3)&4294967295); //@line 344 "intonation.cpp"
          var $stress1=(($arrayidx)&4294967295); //@line 344 "intonation.cpp"
          var $5=HEAP8[($stress1)]; //@line 344 "intonation.cpp"
          var $conv=(tempInt=(($5)),(tempInt>=128?tempInt-256:tempInt)); //@line 344 "intonation.cpp"
          $stress=$conv; //@line 344 "intonation.cpp"
          var $6=$stress; //@line 346 "intonation.cpp"
          var $7=$max_stress; //@line 346 "intonation.cpp"
          var $cmp2=((($6))|0) >= ((($7))|0); //@line 346 "intonation.cpp"
          if ($cmp2) { __lastLabel__ = 1; __label__ = 2;; } else { __lastLabel__ = 1; __label__ = 6;; } //@line 346 "intonation.cpp"
          if (__label__ == 2) {
  
            var $8=$stress; //@line 348 "intonation.cpp"
            var $9=$max_stress; //@line 348 "intonation.cpp"
            var $cmp3=((($8))|0) > ((($9))|0); //@line 348 "intonation.cpp"
            if ($cmp3) { __label__ = 3;; } else { __label__ = 4;; } //@line 348 "intonation.cpp"
            if (__label__ == 3) {
  
              var $10=$ix; //@line 350 "intonation.cpp"
              $max_stress_posn2=$10; //@line 350 "intonation.cpp"
              ; //@line 351 "intonation.cpp"
            }
            else if (__label__ == 4) {
  
              var $11=$max_stress_posn; //@line 354 "intonation.cpp"
              $max_stress_posn2=$11; //@line 354 "intonation.cpp"
              ;
            }
  
            var $12=$ix; //@line 356 "intonation.cpp"
            $max_stress_posn=$12; //@line 356 "intonation.cpp"
            var $13=$stress; //@line 357 "intonation.cpp"
            $max_stress=$13; //@line 357 "intonation.cpp"
            __lastLabel__ = 5; ; //@line 358 "intonation.cpp"
          }
  
          var $14=__lastLabel__ == 5 ? $13 : ($6); //@line 359 "intonation.cpp"
          var $cmp6=((($14))|0) >= 4; //@line 359 "intonation.cpp"
          if ($cmp6) { __label__ = 7;; } else { __label__ = 10;; } //@line 359 "intonation.cpp"
          if (__label__ == 7) {
  
            var $15=HEAP32[((__ZL10number_pre)>>2)]; //@line 361 "intonation.cpp"
            var $cmp8=((($15))|0) < 0; //@line 361 "intonation.cpp"
            if ($cmp8) { __label__ = 8;; } else { __label__ = 9;; } //@line 361 "intonation.cpp"
            if (__label__ == 8) {
  
              var $16=$ix; //@line 362 "intonation.cpp"
              var $17=$start_addr; //@line 362 "intonation.cpp"
              var $sub=((($16)-($17))&4294967295); //@line 362 "intonation.cpp"
              HEAP32[((__ZL10number_pre)>>2)]=$sub; //@line 362 "intonation.cpp"
              ; //@line 362 "intonation.cpp"
            }
  
            var $18=$ix; //@line 364 "intonation.cpp"
            HEAP32[((__ZL12last_primary)>>2)]=$18; //@line 364 "intonation.cpp"
            ; //@line 365 "intonation.cpp"
          }
  
          var $19=$ix; //@line 342 "intonation.cpp"
          var $inc=((($19)+1)&4294967295); //@line 342 "intonation.cpp"
          $ix=$inc; //@line 342 "intonation.cpp"
          var $20=$ix; //@line 342 "intonation.cpp"
          var $21=$end_addr; //@line 342 "intonation.cpp"
          var $cmp=((($20))|0) < ((($21))|0); //@line 342 "intonation.cpp"
          if ($cmp) { __label__ = 1;continue ; } else { __label__ = 11;break $for_body$$for_end$2; } //@line 342 "intonation.cpp"
        }
      }
    } while(0);
  
    var $22=HEAP32[((__ZL10number_pre)>>2)]; //@line 369 "intonation.cpp"
    var $cmp12=((($22))|0) < 0; //@line 369 "intonation.cpp"
    if ($cmp12) { __label__ = 12;; } else { __label__ = 13;; } //@line 369 "intonation.cpp"
    if (__label__ == 12) {
  
      var $23=$end_addr; //@line 370 "intonation.cpp"
      HEAP32[((__ZL10number_pre)>>2)]=$23; //@line 370 "intonation.cpp"
      ; //@line 370 "intonation.cpp"
    }
  
    var $24=$end_addr; //@line 372 "intonation.cpp"
    var $25=$max_stress_posn; //@line 372 "intonation.cpp"
    var $_neg=(((-($25)))&4294967295);
    var $sub15=((($24)-1)&4294967295); //@line 372 "intonation.cpp"
    var $sub16=((($sub15)+($_neg))&4294967295); //@line 372 "intonation.cpp"
    HEAP32[((__ZL11number_tail)>>2)]=$sub16; //@line 372 "intonation.cpp"
    var $26=$max_stress_posn; //@line 373 "intonation.cpp"
    HEAP32[((__ZL9tone_posn)>>2)]=$26; //@line 373 "intonation.cpp"
    var $27=$max_stress_posn2; //@line 374 "intonation.cpp"
    HEAP32[((__ZL10tone_posn2)>>2)]=$27; //@line 374 "intonation.cpp"
    var $_b=HEAPU8[(__ZL8no_tonic_b)];
    var $28=((($_b))&1);
    var $tobool=((($28))|0)!=0; //@line 376 "intonation.cpp"
    if ($tobool) { __label__ = 14;; } else { __label__ = 15;; } //@line 376 "intonation.cpp"
    $if_then17$$if_else18$22: do { 
      if (__label__ == 14) {
  
        var $29=$end_addr; //@line 378 "intonation.cpp"
        HEAP32[((__ZL10tone_posn2)>>2)]=$29; //@line 378 "intonation.cpp"
        HEAP32[((__ZL9tone_posn)>>2)]=$29; //@line 378 "intonation.cpp"
        ; //@line 379 "intonation.cpp"
      }
      else if (__label__ == 15) {
  
        var $30=HEAP32[((__ZL12last_primary)>>2)]; //@line 381 "intonation.cpp"
        var $cmp19=((($30))|0) >= 0; //@line 381 "intonation.cpp"
        if ($cmp19) { __label__ = 16;; } else { __label__ = 18;; } //@line 381 "intonation.cpp"
        if (__label__ == 16) {
  
          var $31=$end_addr; //@line 383 "intonation.cpp"
          var $32=$clause_end_addr; //@line 383 "intonation.cpp"
          var $cmp21=((($31))|0)==((($32))|0); //@line 383 "intonation.cpp"
          if (!($cmp21)) { __label__ = 19;break $if_then17$$if_else18$22; } //@line 383 "intonation.cpp"
  
          var $33=HEAP32[((__ZL12last_primary)>>2)]; //@line 385 "intonation.cpp"
          var $34=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 385 "intonation.cpp"
          var $arrayidx23=(($34+6*$33)&4294967295); //@line 385 "intonation.cpp"
          var $stress24=(($arrayidx23)&4294967295); //@line 385 "intonation.cpp"
          HEAP8[($stress24)]=7; //@line 385 "intonation.cpp"
          ; //@line 386 "intonation.cpp"
        }
        else if (__label__ == 18) {
  
          var $35=HEAP32[((__ZL9tone_posn)>>2)]; //@line 391 "intonation.cpp"
          var $36=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 391 "intonation.cpp"
          var $arrayidx27=(($36+6*$35)&4294967295); //@line 391 "intonation.cpp"
          var $stress28=(($arrayidx27)&4294967295); //@line 391 "intonation.cpp"
          HEAP8[($stress28)]=7; //@line 391 "intonation.cpp"
          ;
        }
      }
    } while(0);
  
    ;
    return; //@line 393 "intonation.cpp"
    return;
  }
  

  function __ZL12calc_pitchesiiii($control, $start, $end, $tune_number) {
    ;
    var __label__;
  
    var $retval;
    var $control_addr;
    var $start_addr;
    var $end_addr;
    var $tune_number_addr;
    var $ix;
    var $th;
    var $tn;
    var $drop;
    var $continuing;
    $control_addr=$control;
    $start_addr=$start;
    $end_addr=$end;
    $tune_number_addr=$tune_number;
    $continuing=0; //@line 859 "intonation.cpp"
    var $0=$control_addr; //@line 861 "intonation.cpp"
    var $cmp=((($0))|0)==0; //@line 861 "intonation.cpp"
    var $1=$start_addr; //@line 863 "intonation.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 861 "intonation.cpp"
    if (__label__ == 1) {
  
      var $2=$end_addr; //@line 863 "intonation.cpp"
      var $3=$tune_number_addr; //@line 863 "intonation.cpp"
      var $call=__ZL13calc_pitches2iii($1, $2, $3); //@line 863 "intonation.cpp"
      $retval=$call; //@line 863 "intonation.cpp"
      ; //@line 863 "intonation.cpp"
    }
    else if (__label__ == 2) {
  
      var $cmp1=((($1))|0) > 0; //@line 866 "intonation.cpp"
      if ($cmp1) { __label__ = 3;; } else { __label__ = 4;; } //@line 866 "intonation.cpp"
      if (__label__ == 3) {
  
        $continuing=1; //@line 867 "intonation.cpp"
        ; //@line 867 "intonation.cpp"
      }
  
      var $4=$tune_number_addr; //@line 869 "intonation.cpp"
      var $arrayidx=((__ZL15tone_head_table+$4*16)&4294967295); //@line 869 "intonation.cpp"
      $th=$arrayidx; //@line 869 "intonation.cpp"
      var $5=$tune_number_addr; //@line 870 "intonation.cpp"
      var $arrayidx4=((__ZL18tone_nucleus_table+$5*16)&4294967295); //@line 870 "intonation.cpp"
      $tn=$arrayidx4; //@line 870 "intonation.cpp"
      var $6=$start_addr; //@line 871 "intonation.cpp"
      $ix=$6; //@line 871 "intonation.cpp"
      var $7=$ix; //@line 876 "intonation.cpp"
      var $8=$ix; //@line 876 "intonation.cpp"
      var $9=HEAP32[((__ZL10number_pre)>>2)]; //@line 876 "intonation.cpp"
      var $add=((($9)+($8))&4294967295); //@line 876 "intonation.cpp"
      var $10=$th; //@line 876 "intonation.cpp"
      var $pre_start=(($10)&4294967295); //@line 876 "intonation.cpp"
      var $11=HEAPU8[($pre_start)]; //@line 876 "intonation.cpp"
      var $conv=((($11))&255); //@line 876 "intonation.cpp"
      var $12=$th; //@line 876 "intonation.cpp"
      var $pre_end=(($12+1)&4294967295); //@line 876 "intonation.cpp"
      var $13=HEAPU8[($pre_end)]; //@line 876 "intonation.cpp"
      var $conv5=((($13))&255); //@line 876 "intonation.cpp"
      __ZL16SetPitchGradientiiii($7, $add, $conv, $conv5); //@line 876 "intonation.cpp"
      var $14=HEAP32[((__ZL10number_pre)>>2)]; //@line 877 "intonation.cpp"
      var $15=$ix; //@line 877 "intonation.cpp"
      var $add6=((($15)+($14))&4294967295); //@line 877 "intonation.cpp"
      $ix=$add6; //@line 877 "intonation.cpp"
      var $16=HEAP32[((_option_tone_flags)>>2)]; //@line 882 "intonation.cpp"
      var $and=($16) & 512; //@line 882 "intonation.cpp"
      var $tobool=((($and))|0)!=0; //@line 882 "intonation.cpp"
      if ($tobool) { __label__ = 5;; } else { __label__ = 6;; } //@line 882 "intonation.cpp"
      if (__label__ == 5) {
  
        var $17=HEAP32[((__ZL10tone_posn2)>>2)]; //@line 884 "intonation.cpp"
        HEAP32[((__ZL9tone_posn)>>2)]=$17; //@line 884 "intonation.cpp"
        ; //@line 885 "intonation.cpp"
      }
  
      var $18=$ix; //@line 886 "intonation.cpp"
      var $19=HEAP32[((__ZL9tone_posn)>>2)]; //@line 886 "intonation.cpp"
      var $20=$th; //@line 886 "intonation.cpp"
      var $21=$tn; //@line 886 "intonation.cpp"
      var $22=$continuing; //@line 886 "intonation.cpp"
      var $call9=__ZL18calc_pitch_segmentiiP9TONE_HEADP12TONE_NUCLEUSii($18, $19, $20, $21, $22); //@line 886 "intonation.cpp"
      $ix=$call9; //@line 886 "intonation.cpp"
      var $_b=HEAPU8[(__ZL8no_tonic_b)];
      var $23=((($_b))&1);
      var $tobool10=((($23))|0)!=0; //@line 889 "intonation.cpp"
      if ($tobool10) { __label__ = 7;; } else { __label__ = 8;; } //@line 889 "intonation.cpp"
      if (__label__ == 7) {
  
        $retval=0; //@line 890 "intonation.cpp"
        ; //@line 890 "intonation.cpp"
      }
      else if (__label__ == 8) {
  
        var $24=$tn; //@line 895 "intonation.cpp"
        var $flags=(($24+14)&4294967295); //@line 895 "intonation.cpp"
        var $25=HEAPU8[($flags)]; //@line 895 "intonation.cpp"
        var $conv13=((($25))&255); //@line 895 "intonation.cpp"
        var $and14=($conv13) & 1; //@line 895 "intonation.cpp"
        var $tobool15=((($and14))|0)!=0; //@line 895 "intonation.cpp"
        if ($tobool15) { __label__ = 9;; } else { __label__ = 10;; } //@line 895 "intonation.cpp"
        if (__label__ == 9) {
  
          var $26=$ix; //@line 897 "intonation.cpp"
          var $27=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 897 "intonation.cpp"
          var $arrayidx17=(($27+6*$26)&4294967295); //@line 897 "intonation.cpp"
          var $flags18=(($arrayidx17+2)&4294967295); //@line 897 "intonation.cpp"
          var $28=HEAP8[($flags18)]; //@line 897 "intonation.cpp"
          var $conv19=(tempInt=(($28)),(tempInt>=128?tempInt-256:tempInt)); //@line 897 "intonation.cpp"
          var $or=($conv19) | 2; //@line 897 "intonation.cpp"
          var $conv20=((($or)) & 255); //@line 897 "intonation.cpp"
          HEAP8[($flags18)]=$conv20; //@line 897 "intonation.cpp"
          ; //@line 898 "intonation.cpp"
        }
  
        var $29=HEAP32[((__ZL11number_tail)>>2)]; //@line 900 "intonation.cpp"
        var $cmp22=((($29))|0)==0; //@line 900 "intonation.cpp"
        var $30=$tn; //@line 902 "intonation.cpp"
        if ($cmp22) { __label__ = 11;; } else { __label__ = 12;; } //@line 900 "intonation.cpp"
        if (__label__ == 11) {
  
          var $pitch_env0=(($30)&4294967295); //@line 902 "intonation.cpp"
          var $31=HEAPU8[($pitch_env0)]; //@line 902 "intonation.cpp"
          var $conv24=((($31))&255); //@line 902 "intonation.cpp"
          HEAP32[((__ZL14tone_pitch_env)>>2)]=$conv24; //@line 902 "intonation.cpp"
          var $32=$tn; //@line 903 "intonation.cpp"
          var $tonic_max0=(($32+1)&4294967295); //@line 903 "intonation.cpp"
          var $33=HEAPU8[($tonic_max0)]; //@line 903 "intonation.cpp"
          var $conv25=((($33))&255); //@line 903 "intonation.cpp"
          var $34=$tn; //@line 903 "intonation.cpp"
          var $tonic_min0=(($34+2)&4294967295); //@line 903 "intonation.cpp"
          var $35=HEAPU8[($tonic_min0)]; //@line 903 "intonation.cpp"
          var $conv26=((($35))&255); //@line 903 "intonation.cpp"
          var $sub=((($conv25)-($conv26))&4294967295); //@line 903 "intonation.cpp"
          $drop=$sub; //@line 903 "intonation.cpp"
          var $36=$ix; //@line 904 "intonation.cpp"
          var $inc=((($36)+1)&4294967295); //@line 904 "intonation.cpp"
          $ix=$inc; //@line 904 "intonation.cpp"
          var $37=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 904 "intonation.cpp"
          var $arrayidx27=(($37+6*$36)&4294967295); //@line 904 "intonation.cpp"
          var $38=$tn; //@line 904 "intonation.cpp"
          var $tonic_min028=(($38+2)&4294967295); //@line 904 "intonation.cpp"
          var $39=HEAPU8[($tonic_min028)]; //@line 904 "intonation.cpp"
          var $conv29=((($39))&255); //@line 904 "intonation.cpp"
          var $40=$drop; //@line 904 "intonation.cpp"
          __ZL9set_pitchP8SYLLABLEii($arrayidx27, $conv29, $40); //@line 904 "intonation.cpp"
          ; //@line 905 "intonation.cpp"
        }
        else if (__label__ == 12) {
  
          var $pitch_env1=(($30+3)&4294967295); //@line 908 "intonation.cpp"
          var $41=HEAPU8[($pitch_env1)]; //@line 908 "intonation.cpp"
          var $conv30=((($41))&255); //@line 908 "intonation.cpp"
          HEAP32[((__ZL14tone_pitch_env)>>2)]=$conv30; //@line 908 "intonation.cpp"
          var $42=$tn; //@line 909 "intonation.cpp"
          var $tonic_max1=(($42+4)&4294967295); //@line 909 "intonation.cpp"
          var $43=HEAPU8[($tonic_max1)]; //@line 909 "intonation.cpp"
          var $conv31=((($43))&255); //@line 909 "intonation.cpp"
          var $44=$tn; //@line 909 "intonation.cpp"
          var $tonic_min1=(($44+5)&4294967295); //@line 909 "intonation.cpp"
          var $45=HEAPU8[($tonic_min1)]; //@line 909 "intonation.cpp"
          var $conv32=((($45))&255); //@line 909 "intonation.cpp"
          var $sub33=((($conv31)-($conv32))&4294967295); //@line 909 "intonation.cpp"
          $drop=$sub33; //@line 909 "intonation.cpp"
          var $46=$ix; //@line 910 "intonation.cpp"
          var $inc34=((($46)+1)&4294967295); //@line 910 "intonation.cpp"
          $ix=$inc34; //@line 910 "intonation.cpp"
          var $47=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 910 "intonation.cpp"
          var $arrayidx35=(($47+6*$46)&4294967295); //@line 910 "intonation.cpp"
          var $48=$tn; //@line 910 "intonation.cpp"
          var $tonic_min136=(($48+5)&4294967295); //@line 910 "intonation.cpp"
          var $49=HEAPU8[($tonic_min136)]; //@line 910 "intonation.cpp"
          var $conv37=((($49))&255); //@line 910 "intonation.cpp"
          var $50=$drop; //@line 910 "intonation.cpp"
          __ZL9set_pitchP8SYLLABLEii($arrayidx35, $conv37, $50); //@line 910 "intonation.cpp"
          ;
        }
  
        var $51=HEAP32[((__ZL14tone_pitch_env)>>2)]; //@line 913 "intonation.cpp"
        var $conv39=((($51)) & 255); //@line 913 "intonation.cpp"
        var $52=HEAP32[((__ZL9tone_posn)>>2)]; //@line 913 "intonation.cpp"
        var $53=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 913 "intonation.cpp"
        var $arrayidx40=(($53+6*$52)&4294967295); //@line 913 "intonation.cpp"
        var $env=(($arrayidx40+1)&4294967295); //@line 913 "intonation.cpp"
        HEAP8[($env)]=$conv39; //@line 913 "intonation.cpp"
        var $54=HEAP32[((__ZL9tone_posn)>>2)]; //@line 914 "intonation.cpp"
        var $55=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 914 "intonation.cpp"
        var $arrayidx41=(($55+6*$54)&4294967295); //@line 914 "intonation.cpp"
        var $stress=(($arrayidx41)&4294967295); //@line 914 "intonation.cpp"
        var $56=HEAP8[($stress)]; //@line 914 "intonation.cpp"
        var $conv42=(tempInt=(($56)),(tempInt>=128?tempInt-256:tempInt)); //@line 914 "intonation.cpp"
        var $cmp43=((($conv42))|0)==4; //@line 914 "intonation.cpp"
        if ($cmp43) { __label__ = 14;; } else { __label__ = 15;; } //@line 914 "intonation.cpp"
        if (__label__ == 14) {
  
          var $57=HEAP32[((__ZL9tone_posn)>>2)]; //@line 915 "intonation.cpp"
          var $58=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 915 "intonation.cpp"
          var $arrayidx45=(($58+6*$57)&4294967295); //@line 915 "intonation.cpp"
          var $stress46=(($arrayidx45)&4294967295); //@line 915 "intonation.cpp"
          HEAP8[($stress46)]=6; //@line 915 "intonation.cpp"
          ; //@line 915 "intonation.cpp"
        }
  
        var $59=$ix; //@line 920 "intonation.cpp"
        var $60=$end_addr; //@line 920 "intonation.cpp"
        var $61=$tn; //@line 920 "intonation.cpp"
        var $tail_start=(($61+12)&4294967295); //@line 920 "intonation.cpp"
        var $62=HEAPU8[($tail_start)]; //@line 920 "intonation.cpp"
        var $conv48=((($62))&255); //@line 920 "intonation.cpp"
        var $63=$tn; //@line 920 "intonation.cpp"
        var $tail_end=(($63+13)&4294967295); //@line 920 "intonation.cpp"
        var $64=HEAPU8[($tail_end)]; //@line 920 "intonation.cpp"
        var $conv49=((($64))&255); //@line 920 "intonation.cpp"
        __ZL16SetPitchGradientiiii($59, $60, $conv48, $conv49); //@line 920 "intonation.cpp"
        var $65=HEAP32[((__ZL14tone_pitch_env)>>2)]; //@line 922 "intonation.cpp"
        $retval=$65; //@line 922 "intonation.cpp"
        ; //@line 922 "intonation.cpp"
      }
    }
  
    ;
    return;
    return;
  }
  

  function __ZL13calc_pitches2iii($start, $end, $tune_number) {
    ;
    var __label__;
  
    var $retval;
    var $start_addr;
    var $end_addr;
    var $tune_number_addr;
    var $ix;
    var $tune;
    var $drop;
    var $continuing;
    $start_addr=$start;
    $end_addr=$end;
    $tune_number_addr=$tune_number;
    $continuing=0; //@line 790 "intonation.cpp"
    var $0=$start_addr; //@line 792 "intonation.cpp"
    var $cmp=((($0))|0) > 0; //@line 792 "intonation.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 792 "intonation.cpp"
    if (__label__ == 1) {
  
      $continuing=1; //@line 793 "intonation.cpp"
      ; //@line 793 "intonation.cpp"
    }
  
    var $1=$tune_number_addr; //@line 795 "intonation.cpp"
    var $2=HEAP32[((_tunes)>>2)]; //@line 795 "intonation.cpp"
    var $arrayidx=(($2+68*$1)&4294967295); //@line 795 "intonation.cpp"
    $tune=$arrayidx; //@line 795 "intonation.cpp"
    var $3=$start_addr; //@line 796 "intonation.cpp"
    $ix=$3; //@line 796 "intonation.cpp"
    var $4=$ix; //@line 801 "intonation.cpp"
    var $5=$ix; //@line 801 "intonation.cpp"
    var $6=HEAP32[((__ZL10number_pre)>>2)]; //@line 801 "intonation.cpp"
    var $add=((($6)+($5))&4294967295); //@line 801 "intonation.cpp"
    var $7=$tune; //@line 801 "intonation.cpp"
    var $prehead_start=(($7+24)&4294967295); //@line 801 "intonation.cpp"
    var $8=HEAPU8[($prehead_start)]; //@line 801 "intonation.cpp"
    var $conv=((($8))&255); //@line 801 "intonation.cpp"
    var $9=$tune; //@line 801 "intonation.cpp"
    var $prehead_end=(($9+25)&4294967295); //@line 801 "intonation.cpp"
    var $10=HEAPU8[($prehead_end)]; //@line 801 "intonation.cpp"
    var $conv1=((($10))&255); //@line 801 "intonation.cpp"
    __ZL16SetPitchGradientiiii($4, $add, $conv, $conv1); //@line 801 "intonation.cpp"
    var $11=HEAP32[((__ZL10number_pre)>>2)]; //@line 802 "intonation.cpp"
    var $12=$ix; //@line 802 "intonation.cpp"
    var $add2=((($12)+($11))&4294967295); //@line 802 "intonation.cpp"
    $ix=$add2; //@line 802 "intonation.cpp"
    var $13=HEAP32[((_option_tone_flags)>>2)]; //@line 807 "intonation.cpp"
    var $and=($13) & 512; //@line 807 "intonation.cpp"
    var $tobool=((($and))|0)!=0; //@line 807 "intonation.cpp"
    if ($tobool) { __label__ = 3;; } else { __label__ = 4;; } //@line 807 "intonation.cpp"
    if (__label__ == 3) {
  
      var $14=HEAP32[((__ZL10tone_posn2)>>2)]; //@line 809 "intonation.cpp"
      HEAP32[((__ZL9tone_posn)>>2)]=$14; //@line 809 "intonation.cpp"
      ; //@line 810 "intonation.cpp"
    }
  
    var $15=$tune; //@line 811 "intonation.cpp"
    var $16=$ix; //@line 811 "intonation.cpp"
    var $17=HEAP32[((__ZL9tone_posn)>>2)]; //@line 811 "intonation.cpp"
    var $call=__ZL17SetHeadIntonationP4TUNEiii($15, $16, $17); //@line 811 "intonation.cpp"
    $ix=$call; //@line 811 "intonation.cpp"
    var $_b=HEAPU8[(__ZL8no_tonic_b)];
    var $18=((($_b))&1);
    var $tobool5=((($18))|0)!=0; //@line 813 "intonation.cpp"
    if ($tobool5) { __label__ = 5;; } else { __label__ = 6;; } //@line 813 "intonation.cpp"
    if (__label__ == 5) {
  
      $retval=0; //@line 814 "intonation.cpp"
      ; //@line 814 "intonation.cpp"
    }
    else if (__label__ == 6) {
  
      var $19=HEAP32[((__ZL11number_tail)>>2)]; //@line 824 "intonation.cpp"
      var $cmp8=((($19))|0)==0; //@line 824 "intonation.cpp"
      var $20=$tune; //@line 826 "intonation.cpp"
      if ($cmp8) { __label__ = 7;; } else { __label__ = 8;; } //@line 824 "intonation.cpp"
      if (__label__ == 7) {
  
        var $nucleus0_env=(($20+42)&4294967295); //@line 826 "intonation.cpp"
        var $21=HEAPU8[($nucleus0_env)]; //@line 826 "intonation.cpp"
        var $conv10=((($21))&255); //@line 826 "intonation.cpp"
        HEAP32[((__ZL14tone_pitch_env)>>2)]=$conv10; //@line 826 "intonation.cpp"
        var $22=$tune; //@line 827 "intonation.cpp"
        var $nucleus0_max=(($22+43)&4294967295); //@line 827 "intonation.cpp"
        var $23=HEAPU8[($nucleus0_max)]; //@line 827 "intonation.cpp"
        var $conv11=((($23))&255); //@line 827 "intonation.cpp"
        var $24=$tune; //@line 827 "intonation.cpp"
        var $nucleus0_min=(($24+44)&4294967295); //@line 827 "intonation.cpp"
        var $25=HEAPU8[($nucleus0_min)]; //@line 827 "intonation.cpp"
        var $conv12=((($25))&255); //@line 827 "intonation.cpp"
        var $sub=((($conv11)-($conv12))&4294967295); //@line 827 "intonation.cpp"
        $drop=$sub; //@line 827 "intonation.cpp"
        var $26=$ix; //@line 828 "intonation.cpp"
        var $inc=((($26)+1)&4294967295); //@line 828 "intonation.cpp"
        $ix=$inc; //@line 828 "intonation.cpp"
        var $27=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 828 "intonation.cpp"
        var $arrayidx13=(($27+6*$26)&4294967295); //@line 828 "intonation.cpp"
        var $28=$tune; //@line 828 "intonation.cpp"
        var $nucleus0_min14=(($28+44)&4294967295); //@line 828 "intonation.cpp"
        var $29=HEAPU8[($nucleus0_min14)]; //@line 828 "intonation.cpp"
        var $conv15=((($29))&255); //@line 828 "intonation.cpp"
        var $30=$drop; //@line 828 "intonation.cpp"
        __ZL9set_pitchP8SYLLABLEii($arrayidx13, $conv15, $30); //@line 828 "intonation.cpp"
        ; //@line 829 "intonation.cpp"
      }
      else if (__label__ == 8) {
  
        var $nucleus1_env=(($20+45)&4294967295); //@line 832 "intonation.cpp"
        var $31=HEAPU8[($nucleus1_env)]; //@line 832 "intonation.cpp"
        var $conv16=((($31))&255); //@line 832 "intonation.cpp"
        HEAP32[((__ZL14tone_pitch_env)>>2)]=$conv16; //@line 832 "intonation.cpp"
        var $32=$tune; //@line 833 "intonation.cpp"
        var $nucleus1_max=(($32+46)&4294967295); //@line 833 "intonation.cpp"
        var $33=HEAPU8[($nucleus1_max)]; //@line 833 "intonation.cpp"
        var $conv17=((($33))&255); //@line 833 "intonation.cpp"
        var $34=$tune; //@line 833 "intonation.cpp"
        var $nucleus1_min=(($34+47)&4294967295); //@line 833 "intonation.cpp"
        var $35=HEAPU8[($nucleus1_min)]; //@line 833 "intonation.cpp"
        var $conv18=((($35))&255); //@line 833 "intonation.cpp"
        var $sub19=((($conv17)-($conv18))&4294967295); //@line 833 "intonation.cpp"
        $drop=$sub19; //@line 833 "intonation.cpp"
        var $36=$ix; //@line 834 "intonation.cpp"
        var $inc20=((($36)+1)&4294967295); //@line 834 "intonation.cpp"
        $ix=$inc20; //@line 834 "intonation.cpp"
        var $37=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 834 "intonation.cpp"
        var $arrayidx21=(($37+6*$36)&4294967295); //@line 834 "intonation.cpp"
        var $38=$tune; //@line 834 "intonation.cpp"
        var $nucleus1_min22=(($38+47)&4294967295); //@line 834 "intonation.cpp"
        var $39=HEAPU8[($nucleus1_min22)]; //@line 834 "intonation.cpp"
        var $conv23=((($39))&255); //@line 834 "intonation.cpp"
        var $40=$drop; //@line 834 "intonation.cpp"
        __ZL9set_pitchP8SYLLABLEii($arrayidx21, $conv23, $40); //@line 834 "intonation.cpp"
        ;
      }
  
      var $41=HEAP32[((__ZL14tone_pitch_env)>>2)]; //@line 837 "intonation.cpp"
      var $conv25=((($41)) & 255); //@line 837 "intonation.cpp"
      var $42=HEAP32[((__ZL9tone_posn)>>2)]; //@line 837 "intonation.cpp"
      var $43=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 837 "intonation.cpp"
      var $arrayidx26=(($43+6*$42)&4294967295); //@line 837 "intonation.cpp"
      var $env=(($arrayidx26+1)&4294967295); //@line 837 "intonation.cpp"
      HEAP8[($env)]=$conv25; //@line 837 "intonation.cpp"
      var $44=HEAP32[((__ZL9tone_posn)>>2)]; //@line 838 "intonation.cpp"
      var $45=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 838 "intonation.cpp"
      var $arrayidx27=(($45+6*$44)&4294967295); //@line 838 "intonation.cpp"
      var $stress=(($arrayidx27)&4294967295); //@line 838 "intonation.cpp"
      var $46=HEAP8[($stress)]; //@line 838 "intonation.cpp"
      var $conv28=(tempInt=(($46)),(tempInt>=128?tempInt-256:tempInt)); //@line 838 "intonation.cpp"
      var $cmp29=((($conv28))|0)==4; //@line 838 "intonation.cpp"
      if ($cmp29) { __label__ = 10;; } else { __label__ = 11;; } //@line 838 "intonation.cpp"
      if (__label__ == 10) {
  
        var $47=HEAP32[((__ZL9tone_posn)>>2)]; //@line 839 "intonation.cpp"
        var $48=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 839 "intonation.cpp"
        var $arrayidx31=(($48+6*$47)&4294967295); //@line 839 "intonation.cpp"
        var $stress32=(($arrayidx31)&4294967295); //@line 839 "intonation.cpp"
        HEAP8[($stress32)]=6; //@line 839 "intonation.cpp"
        ; //@line 839 "intonation.cpp"
      }
  
      var $49=$ix; //@line 844 "intonation.cpp"
      var $50=$end_addr; //@line 844 "intonation.cpp"
      var $51=$tune; //@line 844 "intonation.cpp"
      var $tail_start=(($51+48)&4294967295); //@line 844 "intonation.cpp"
      var $52=HEAPU8[($tail_start)]; //@line 844 "intonation.cpp"
      var $conv34=((($52))&255); //@line 844 "intonation.cpp"
      var $53=$tune; //@line 844 "intonation.cpp"
      var $tail_end=(($53+49)&4294967295); //@line 844 "intonation.cpp"
      var $54=HEAPU8[($tail_end)]; //@line 844 "intonation.cpp"
      var $conv35=((($54))&255); //@line 844 "intonation.cpp"
      __ZL16SetPitchGradientiiii($49, $50, $conv34, $conv35); //@line 844 "intonation.cpp"
      var $55=HEAP32[((__ZL14tone_pitch_env)>>2)]; //@line 846 "intonation.cpp"
      $retval=$55; //@line 846 "intonation.cpp"
      ; //@line 846 "intonation.cpp"
    }
  
    var $56=$retval; //@line 847 "intonation.cpp"
    ;
    return $56; //@line 847 "intonation.cpp"
    return null;
  }
  

  function __ZL16SetPitchGradientiiii($start_ix, $end_ix, $start_pitch, $end_pitch) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $start_ix_addr;
    var $end_ix_addr;
    var $start_pitch_addr;
    var $end_pitch_addr;
    var $ix;
    var $stress;
    var $pitch;
    var $increment;
    var $n_increments;
    var $drop;
    var $syl;
    $start_ix_addr=$start_ix;
    $end_ix_addr=$end_ix;
    $start_pitch_addr=$start_pitch;
    $end_pitch_addr=$end_pitch;
    var $0=$end_pitch_addr; //@line 743 "intonation.cpp"
    var $1=$start_pitch_addr; //@line 743 "intonation.cpp"
    var $sub=((($0)-($1))&4294967295); //@line 743 "intonation.cpp"
    var $shl=($sub) << 8; //@line 743 "intonation.cpp"
    $increment=$shl; //@line 743 "intonation.cpp"
    var $2=$end_ix_addr; //@line 744 "intonation.cpp"
    var $3=$start_ix_addr; //@line 744 "intonation.cpp"
    var $sub1=((($2)-($3))&4294967295); //@line 744 "intonation.cpp"
    $n_increments=$sub1; //@line 744 "intonation.cpp"
    var $4=$n_increments; //@line 746 "intonation.cpp"
    var $cmp=((($4))|0) <= 0; //@line 746 "intonation.cpp"
    if ($cmp) { __label__ = 12;; } else { __label__ = 1;; } //@line 746 "intonation.cpp"
    $for_end$$if_end$2: do { 
      if (__label__ == 1) {
  
        var $5=$n_increments; //@line 749 "intonation.cpp"
        var $cmp2=((($5))|0) > 1; //@line 749 "intonation.cpp"
        if ($cmp2) { __label__ = 2;; } else { __label__ = 3;; } //@line 749 "intonation.cpp"
        if (__label__ == 2) {
  
          var $6=$increment; //@line 751 "intonation.cpp"
          var $7=$n_increments; //@line 751 "intonation.cpp"
          var $div=((((($6))|0)/((($7))|0))|0); //@line 751 "intonation.cpp"
          $increment=$div; //@line 751 "intonation.cpp"
          ; //@line 752 "intonation.cpp"
        }
  
        var $8=$start_pitch_addr; //@line 754 "intonation.cpp"
        var $shl5=($8) << 8; //@line 754 "intonation.cpp"
        $pitch=$shl5; //@line 754 "intonation.cpp"
        var $9=$start_ix_addr; //@line 756 "intonation.cpp"
        $ix=$9; //@line 756 "intonation.cpp"
        var $10=$ix; //@line 756 "intonation.cpp"
        var $11=$end_ix_addr; //@line 756 "intonation.cpp"
        var $cmp61=((($10))|0) < ((($11))|0); //@line 756 "intonation.cpp"
        if (!($cmp61)) { __label__ = 12;break $for_end$$if_end$2; } //@line 756 "intonation.cpp"
        while(1) { 
  
          var $12=$ix; //@line 758 "intonation.cpp"
          var $13=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 758 "intonation.cpp"
          var $arrayidx=(($13+6*$12)&4294967295); //@line 758 "intonation.cpp"
          $syl=$arrayidx; //@line 758 "intonation.cpp"
          var $14=$syl; //@line 759 "intonation.cpp"
          var $stress7=(($14)&4294967295); //@line 759 "intonation.cpp"
          var $15=HEAP8[($stress7)]; //@line 759 "intonation.cpp"
          var $conv=(tempInt=(($15)),(tempInt>=128?tempInt-256:tempInt)); //@line 759 "intonation.cpp"
          $stress=$conv; //@line 759 "intonation.cpp"
          var $16=$increment; //@line 761 "intonation.cpp"
          var $cmp8=((($16))|0) > 0; //@line 761 "intonation.cpp"
          if ($cmp8) { __label__ = 5;; } else { __label__ = 6;; } //@line 761 "intonation.cpp"
          if (__label__ == 5) {
  
            var $17=$syl; //@line 763 "intonation.cpp"
            var $18=$pitch; //@line 763 "intonation.cpp"
            var $shr=($18) >> 8; //@line 763 "intonation.cpp"
            var $19=$increment; //@line 763 "intonation.cpp"
            var $shr10=($19) >> 8; //@line 763 "intonation.cpp"
            var $sub11=(((-($shr10)))&4294967295); //@line 763 "intonation.cpp"
            __ZL9set_pitchP8SYLLABLEii($17, $shr, $sub11); //@line 763 "intonation.cpp"
            var $20=$increment; //@line 764 "intonation.cpp"
            var $21=$pitch; //@line 764 "intonation.cpp"
            var $add=((($21)+($20))&4294967295); //@line 764 "intonation.cpp"
            $pitch=$add; //@line 764 "intonation.cpp"
            ; //@line 765 "intonation.cpp"
          }
          else if (__label__ == 6) {
  
            var $22=$increment; //@line 768 "intonation.cpp"
            var $shr12=($22) >> 8; //@line 768 "intonation.cpp"
            var $sub13=(((-($shr12)))&4294967295); //@line 768 "intonation.cpp"
            $drop=$sub13; //@line 768 "intonation.cpp"
            var $23=$drop; //@line 769 "intonation.cpp"
            var $24=$stress; //@line 769 "intonation.cpp"
            var $arrayidx14=((__ZL8min_drop+$24*4)&4294967295); //@line 769 "intonation.cpp"
            var $25=HEAP32[(($arrayidx14)>>2)]; //@line 769 "intonation.cpp"
            var $cmp15=((($23))|0) < ((($25))|0); //@line 769 "intonation.cpp"
            if ($cmp15) { __lastLabel__ = 6; __label__ = 7;; } else { __lastLabel__ = 6; __label__ = 8;; } //@line 769 "intonation.cpp"
            if (__label__ == 7) {
  
              var $26=$stress; //@line 770 "intonation.cpp"
              var $arrayidx17=((__ZL8min_drop+$26*4)&4294967295); //@line 770 "intonation.cpp"
              var $27=HEAP32[(($arrayidx17)>>2)]; //@line 770 "intonation.cpp"
              $drop=$27; //@line 770 "intonation.cpp"
              __lastLabel__ = 7; ; //@line 770 "intonation.cpp"
            }
  
            var $28=__lastLabel__ == 7 ? $27 : ($23); //@line 774 "intonation.cpp"
            var $29=$increment; //@line 772 "intonation.cpp"
            var $30=$pitch; //@line 772 "intonation.cpp"
            var $add19=((($30)+($29))&4294967295); //@line 772 "intonation.cpp"
            $pitch=$add19; //@line 772 "intonation.cpp"
            var $cmp20=((($28))|0) > 18; //@line 774 "intonation.cpp"
            if ($cmp20) { __label__ = 9;; } else { __label__ = 10;; } //@line 774 "intonation.cpp"
            if (__label__ == 9) {
  
              $drop=18; //@line 775 "intonation.cpp"
              ; //@line 775 "intonation.cpp"
            }
  
            var $31=$syl; //@line 776 "intonation.cpp"
            var $32=$pitch; //@line 776 "intonation.cpp"
            var $shr23=($32) >> 8; //@line 776 "intonation.cpp"
            var $33=$drop; //@line 776 "intonation.cpp"
            __ZL9set_pitchP8SYLLABLEii($31, $shr23, $33); //@line 776 "intonation.cpp"
            ;
          }
  
          var $34=$ix; //@line 756 "intonation.cpp"
          var $inc=((($34)+1)&4294967295); //@line 756 "intonation.cpp"
          $ix=$inc; //@line 756 "intonation.cpp"
          var $35=$ix; //@line 756 "intonation.cpp"
          var $36=$end_ix_addr; //@line 756 "intonation.cpp"
          var $cmp6=((($35))|0) < ((($36))|0); //@line 756 "intonation.cpp"
          if ($cmp6) { __label__ = 4;continue ; } else { __label__ = 12;break $for_end$$if_end$2; } //@line 756 "intonation.cpp"
        }
      }
    } while(0);
  
    ;
    return; //@line 779 "intonation.cpp"
    return;
  }
  

  function __ZL18calc_pitch_segmentiiP9TONE_HEADP12TONE_NUCLEUSii($ix, $end_ix, $th, $tn, $continuing) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $ix_addr;
    var $end_ix_addr;
    var $th_addr;
    var $tn_addr;
    var $min_stress_addr;
    var $continuing_addr;
    var $stress;
    var $pitch;
    var $increment;
    var $n_primary;
    var $n_steps;
    var $initial;
    var $overflow;
    var $n_overflow;
    var $pitch_range;
    var $pitch_range_abs;
    var $drops;
    var $overflow_tab;
    var $syl;
    $ix_addr=$ix;
    $end_ix_addr=$end_ix;
    $th_addr=$th;
    $tn_addr=$tn;
    $min_stress_addr=4;
    $continuing_addr=$continuing;
    $pitch=0; //@line 616 "intonation.cpp"
    $increment=0; //@line 617 "intonation.cpp"
    $n_primary=0; //@line 618 "intonation.cpp"
    $n_steps=0; //@line 619 "intonation.cpp"
    $overflow=0; //@line 621 "intonation.cpp"
    var $0=$th_addr; //@line 631 "intonation.cpp"
    var $body_drops=(($0+4)&4294967295); //@line 631 "intonation.cpp"
    var $1=HEAP32[(($body_drops)>>2)]; //@line 631 "intonation.cpp"
    $drops=$1; //@line 631 "intonation.cpp"
    var $2=$th_addr; //@line 632 "intonation.cpp"
    var $body_end=(($2+3)&4294967295); //@line 632 "intonation.cpp"
    var $3=HEAPU8[($body_end)]; //@line 632 "intonation.cpp"
    var $conv=((($3))&255); //@line 632 "intonation.cpp"
    var $4=$th_addr; //@line 632 "intonation.cpp"
    var $body_start=(($4+2)&4294967295); //@line 632 "intonation.cpp"
    var $5=HEAPU8[($body_start)]; //@line 632 "intonation.cpp"
    var $conv1=((($5))&255); //@line 632 "intonation.cpp"
    var $sub=((($conv)-($conv1))&4294967295); //@line 632 "intonation.cpp"
    var $shl=($sub) << 8; //@line 632 "intonation.cpp"
    $pitch_range=$shl; //@line 632 "intonation.cpp"
    var $6=$pitch_range; //@line 633 "intonation.cpp"
    var $ispos=((($6))|0) > -1; //@line 633 "intonation.cpp"
    var $neg=(((-($6)))&4294967295); //@line 633 "intonation.cpp"
    var $call=($ispos) ? ($6) : ($neg); //@line 633 "intonation.cpp"
    $pitch_range_abs=$call; //@line 633 "intonation.cpp"
    var $7=$continuing_addr; //@line 635 "intonation.cpp"
    var $tobool=((($7))|0)!=0; //@line 635 "intonation.cpp"
    if ($tobool) { __label__ = 1;; } else { __label__ = 2;; } //@line 635 "intonation.cpp"
    if (__label__ == 1) {
  
      $initial=0; //@line 637 "intonation.cpp"
      $overflow=0; //@line 638 "intonation.cpp"
      $n_overflow=5; //@line 639 "intonation.cpp"
      $overflow_tab=((__ZZL18calc_pitch_segmentiiP9TONE_HEADP12TONE_NUCLEUSiiE12continue_tab)&4294967295); //@line 640 "intonation.cpp"
      var $8=$pitch_range; //@line 641 "intonation.cpp"
      var $9=$th_addr; //@line 641 "intonation.cpp"
      var $body_max_steps=(($9+8)&4294967295); //@line 641 "intonation.cpp"
      var $10=HEAPU8[($body_max_steps)]; //@line 641 "intonation.cpp"
      var $conv2=((($10))&255); //@line 641 "intonation.cpp"
      var $sub3=((($conv2)-1)&4294967295); //@line 641 "intonation.cpp"
      var $div=((((($8))|0)/((($sub3))|0))|0); //@line 641 "intonation.cpp"
      $increment=$div; //@line 641 "intonation.cpp"
      ; //@line 642 "intonation.cpp"
    }
    else if (__label__ == 2) {
  
      var $11=$th_addr; //@line 645 "intonation.cpp"
      var $n_overflow4=(($11+10)&4294967295); //@line 645 "intonation.cpp"
      var $12=HEAPU8[($n_overflow4)]; //@line 645 "intonation.cpp"
      var $conv5=((($12))&255); //@line 645 "intonation.cpp"
      $n_overflow=$conv5; //@line 645 "intonation.cpp"
      var $13=$th_addr; //@line 646 "intonation.cpp"
      var $overflow6=(($13+12)&4294967295); //@line 646 "intonation.cpp"
      var $14=HEAP32[(($overflow6)>>2)]; //@line 646 "intonation.cpp"
      $overflow_tab=$14; //@line 646 "intonation.cpp"
      $initial=1; //@line 647 "intonation.cpp"
      ;
    }
  
    var $15=$ix_addr; //@line 650 "intonation.cpp"
    var $16=$end_ix_addr; //@line 650 "intonation.cpp"
    var $cmp4=((($15))|0) < ((($16))|0); //@line 650 "intonation.cpp"
    var $17=$ix_addr; //@line 652 "intonation.cpp"
    if ($cmp4) { __lastLabel__ = 3; __label__ = 4;; } else { __lastLabel__ = 3; __label__ = 31;; } //@line 650 "intonation.cpp"
    $while_body$$while_end$6: do { 
      if (__label__ == 4) {
        $while_body$7: while(1) { 
  
          var $18=__lastLabel__ == 30 ? $90 : ($17);
          var $19=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 652 "intonation.cpp"
          var $arrayidx=(($19+6*$18)&4294967295); //@line 652 "intonation.cpp"
          $syl=$arrayidx; //@line 652 "intonation.cpp"
          var $20=$syl; //@line 653 "intonation.cpp"
          var $stress7=(($20)&4294967295); //@line 653 "intonation.cpp"
          var $21=HEAP8[($stress7)]; //@line 653 "intonation.cpp"
          var $conv8=(tempInt=(($21)),(tempInt>=128?tempInt-256:tempInt)); //@line 653 "intonation.cpp"
          $stress=$conv8; //@line 653 "intonation.cpp"
          var $22=$initial; //@line 658 "intonation.cpp"
          var $tobool9=((($22))|0)!=0; //@line 658 "intonation.cpp"
          if ($tobool9) { __label__ = 8;; } else { __label__ = 5;; } //@line 658 "intonation.cpp"
          $if_then15$$lor_lhs_false$9: do { 
            if (__label__ == 5) {
  
              var $23=$stress; //@line 658 "intonation.cpp"
              var $24=$min_stress_addr; //@line 658 "intonation.cpp"
              var $cmp10=((($23))|0) >= ((($24))|0); //@line 658 "intonation.cpp"
              if ($cmp10) { __lastLabel__ = 5; ; } else { __lastLabel__ = 5; __label__ = 23;break $if_then15$$lor_lhs_false$9; } //@line 658 "intonation.cpp"
  
              var $_pr=$initial; //@line 662 "intonation.cpp"
              var $tobool12=((($_pr))|0)!=0; //@line 662 "intonation.cpp"
              if ($tobool12) { __label__ = 8;break $if_then15$$lor_lhs_false$9; } //@line 662 "intonation.cpp"
  
              var $25=$stress; //@line 662 "intonation.cpp"
              var $cmp14=((($25))|0)==5; //@line 662 "intonation.cpp"
              if ($cmp14) { __label__ = 8;break $if_then15$$lor_lhs_false$9; } //@line 662 "intonation.cpp"
  
              var $39=$n_steps; //@line 682 "intonation.cpp"
              var $cmp34=((($39))|0) > 0; //@line 682 "intonation.cpp"
              if ($cmp34) { __label__ = 16;; } else { __label__ = 17;; } //@line 682 "intonation.cpp"
              if (__label__ == 16) {
  
                var $40=$increment; //@line 683 "intonation.cpp"
                var $41=$pitch; //@line 683 "intonation.cpp"
                var $add=((($41)+($40))&4294967295); //@line 683 "intonation.cpp"
                $pitch=$add; //@line 683 "intonation.cpp"
                __label__ = 19;break $if_then15$$lor_lhs_false$9; //@line 683 "intonation.cpp"
              }
              else if (__label__ == 17) {
  
                var $42=$th_addr; //@line 686 "intonation.cpp"
                var $body_end37=(($42+3)&4294967295); //@line 686 "intonation.cpp"
                var $43=HEAPU8[($body_end37)]; //@line 686 "intonation.cpp"
                var $conv38=((($43))&255); //@line 686 "intonation.cpp"
                var $shl39=((($conv38)*256)&4294967295); //@line 686 "intonation.cpp"
                var $44=$pitch_range_abs; //@line 686 "intonation.cpp"
                var $45=$overflow; //@line 686 "intonation.cpp"
                var $inc=((($45)+1)&4294967295); //@line 686 "intonation.cpp"
                $overflow=$inc; //@line 686 "intonation.cpp"
                var $46=$overflow_tab; //@line 686 "intonation.cpp"
                var $arrayidx40=(($46+$45)&4294967295); //@line 686 "intonation.cpp"
                var $47=HEAP8[($arrayidx40)]; //@line 686 "intonation.cpp"
                var $conv41=(tempInt=(($47)),(tempInt>=128?tempInt-256:tempInt)); //@line 686 "intonation.cpp"
                var $mul=((($conv41)*($44))&4294967295); //@line 686 "intonation.cpp"
                var $div42=((((($mul))|0)/64)|0); //@line 686 "intonation.cpp"
                var $add43=((($div42)+($shl39))&4294967295); //@line 686 "intonation.cpp"
                $pitch=$add43; //@line 686 "intonation.cpp"
                var $48=$overflow; //@line 687 "intonation.cpp"
                var $49=$n_overflow; //@line 687 "intonation.cpp"
                var $cmp44=((($48))|0) >= ((($49))|0); //@line 687 "intonation.cpp"
                if (!($cmp44)) { __label__ = 19;break $if_then15$$lor_lhs_false$9; } //@line 687 "intonation.cpp"
  
                $overflow=0; //@line 689 "intonation.cpp"
                var $50=$th_addr; //@line 690 "intonation.cpp"
                var $overflow46=(($50+12)&4294967295); //@line 690 "intonation.cpp"
                var $51=HEAP32[(($overflow46)>>2)]; //@line 690 "intonation.cpp"
                $overflow_tab=$51; //@line 690 "intonation.cpp"
                __label__ = 19;break $if_then15$$lor_lhs_false$9; //@line 691 "intonation.cpp"
              }
            }
          } while(0);
          $if_then15$$if_end49$$if_end59$18: do { 
            if (__label__ == 8) {
  
              $initial=0; //@line 664 "intonation.cpp"
              $overflow=0; //@line 665 "intonation.cpp"
              var $26=$ix_addr; //@line 666 "intonation.cpp"
              var $27=$end_ix_addr; //@line 666 "intonation.cpp"
              var $28=$min_stress_addr; //@line 666 "intonation.cpp"
              var $call16=__ZL16count_incrementsiii($26, $27, $28); //@line 666 "intonation.cpp"
              $n_primary=$call16; //@line 666 "intonation.cpp"
              $n_steps=$call16; //@line 666 "intonation.cpp"
              var $29=$n_steps; //@line 668 "intonation.cpp"
              var $30=$th_addr; //@line 668 "intonation.cpp"
              var $body_max_steps17=(($30+8)&4294967295); //@line 668 "intonation.cpp"
              var $31=HEAPU8[($body_max_steps17)]; //@line 668 "intonation.cpp"
              var $conv18=((($31))&255); //@line 668 "intonation.cpp"
              var $cmp19=((($29))|0) > ((($conv18))|0); //@line 668 "intonation.cpp"
              if ($cmp19) { __label__ = 9;; } else { __label__ = 10;; } //@line 668 "intonation.cpp"
              if (__label__ == 9) {
  
                var $32=$th_addr; //@line 669 "intonation.cpp"
                var $body_max_steps21=(($32+8)&4294967295); //@line 669 "intonation.cpp"
                var $33=HEAPU8[($body_max_steps21)]; //@line 669 "intonation.cpp"
                var $conv22=((($33))&255); //@line 669 "intonation.cpp"
                $n_steps=$conv22; //@line 669 "intonation.cpp"
                __lastLabel__ = 9; ; //@line 669 "intonation.cpp"
              }
              else if (__label__ == 10) {
  
                var $_pr2=$n_steps; //@line 671 "intonation.cpp"
                __lastLabel__ = 10; ;
              }
  
              var $34=__lastLabel__ == 10 ? $_pr2 : ($conv22); //@line 671 "intonation.cpp"
              var $cmp24=((($34))|0) > 1; //@line 671 "intonation.cpp"
              if ($cmp24) { __label__ = 12;; } else { __label__ = 13;; } //@line 671 "intonation.cpp"
              if (__label__ == 12) {
  
                var $35=$pitch_range; //@line 673 "intonation.cpp"
                var $36=$n_steps; //@line 673 "intonation.cpp"
                var $sub26=((($36)-1)&4294967295); //@line 673 "intonation.cpp"
                var $div27=((((($35))|0)/((($sub26))|0))|0); //@line 673 "intonation.cpp"
                $increment=$div27; //@line 673 "intonation.cpp"
                ; //@line 674 "intonation.cpp"
              }
              else if (__label__ == 13) {
  
                $increment=0; //@line 676 "intonation.cpp"
                ;
              }
  
              var $37=$th_addr; //@line 678 "intonation.cpp"
              var $body_start30=(($37+2)&4294967295); //@line 678 "intonation.cpp"
              var $38=HEAPU8[($body_start30)]; //@line 678 "intonation.cpp"
              var $conv31=((($38))&255); //@line 678 "intonation.cpp"
              var $shl32=($conv31) << 8; //@line 678 "intonation.cpp"
              $pitch=$shl32; //@line 678 "intonation.cpp"
              __label__ = 19;break $if_then15$$if_end49$$if_end59$18; //@line 679 "intonation.cpp"
            }
          } while(0);
          if (__label__ == 19) {
  
            var $52=$n_steps; //@line 695 "intonation.cpp"
            var $dec=((($52)-1)&4294967295); //@line 695 "intonation.cpp"
            $n_steps=$dec; //@line 695 "intonation.cpp"
            var $53=$n_primary; //@line 697 "intonation.cpp"
            var $dec50=((($53)-1)&4294967295); //@line 697 "intonation.cpp"
            $n_primary=$dec50; //@line 697 "intonation.cpp"
            var $54=$tn_addr; //@line 698 "intonation.cpp"
            var $backwards=(($54+8)&4294967295); //@line 698 "intonation.cpp"
            var $55=HEAP32[(($backwards)>>2)]; //@line 698 "intonation.cpp"
            var $tobool51=((($55))|0)!=0; //@line 698 "intonation.cpp"
            if ($tobool51) { __label__ = 20;; } else { __label__ = 22;; } //@line 698 "intonation.cpp"
            $land_lhs_true$$if_end59thread_pre_split$30: do { 
              if (__label__ == 20) {
  
                var $56=$n_primary; //@line 698 "intonation.cpp"
                var $cmp52=((($56))|0) < 2; //@line 698 "intonation.cpp"
                if (!($cmp52)) { __label__ = 22;break $land_lhs_true$$if_end59thread_pre_split$30; } //@line 698 "intonation.cpp"
  
                var $57=$n_primary; //@line 700 "intonation.cpp"
                var $58=$tn_addr; //@line 700 "intonation.cpp"
                var $backwards54=(($58+8)&4294967295); //@line 700 "intonation.cpp"
                var $59=HEAP32[(($backwards54)>>2)]; //@line 700 "intonation.cpp"
                var $arrayidx55=(($59+2*$57)&4294967295); //@line 700 "intonation.cpp"
                var $60=HEAP16[(($arrayidx55)>>1)]; //@line 700 "intonation.cpp"
                var $conv56=(tempInt=(($60)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 700 "intonation.cpp"
                var $shl57=($conv56) << 8; //@line 700 "intonation.cpp"
                $pitch=$shl57; //@line 700 "intonation.cpp"
                ; //@line 701 "intonation.cpp"
              }
            } while(0);
  
            var $_pr3=$stress; //@line 704 "intonation.cpp"
            __lastLabel__ = 22; ;
          }
  
          var $61=__lastLabel__ == 22 ? $_pr3 : ($23); //@line 704 "intonation.cpp"
          var $cmp60=((($61))|0) >= 4; //@line 704 "intonation.cpp"
          if ($cmp60) { __label__ = 24;; } else { __label__ = 25;; } //@line 704 "intonation.cpp"
          if (__label__ == 24) {
  
            var $62=$syl; //@line 706 "intonation.cpp"
            var $stress62=(($62)&4294967295); //@line 706 "intonation.cpp"
            HEAP8[($stress62)]=6; //@line 706 "intonation.cpp"
            var $63=$syl; //@line 707 "intonation.cpp"
            var $64=$pitch; //@line 707 "intonation.cpp"
            var $shr=($64) >> 8; //@line 707 "intonation.cpp"
            var $65=$stress; //@line 707 "intonation.cpp"
            var $66=$drops; //@line 707 "intonation.cpp"
            var $arrayidx63=(($66+4*$65)&4294967295); //@line 707 "intonation.cpp"
            var $67=HEAP32[(($arrayidx63)>>2)]; //@line 707 "intonation.cpp"
            __ZL9set_pitchP8SYLLABLEii($63, $shr, $67); //@line 707 "intonation.cpp"
            ; //@line 708 "intonation.cpp"
          }
          else if (__label__ == 25) {
  
            var $68=$stress; //@line 710 "intonation.cpp"
            var $cmp65=((($68))|0) >= 3; //@line 710 "intonation.cpp"
            if ($cmp65) { __label__ = 26;; } else { __label__ = 27;; } //@line 710 "intonation.cpp"
            if (__label__ == 26) {
  
              var $69=$syl; //@line 712 "intonation.cpp"
              var $70=$pitch; //@line 712 "intonation.cpp"
              var $shr67=($70) >> 8; //@line 712 "intonation.cpp"
              var $71=$stress; //@line 712 "intonation.cpp"
              var $72=$drops; //@line 712 "intonation.cpp"
              var $arrayidx68=(($72+4*$71)&4294967295); //@line 712 "intonation.cpp"
              var $73=HEAP32[(($arrayidx68)>>2)]; //@line 712 "intonation.cpp"
              __ZL9set_pitchP8SYLLABLEii($69, $shr67, $73); //@line 712 "intonation.cpp"
              ; //@line 713 "intonation.cpp"
            }
            else if (__label__ == 27) {
  
              var $74=$ix_addr; //@line 717 "intonation.cpp"
              var $sub70=((($74)-1)&4294967295); //@line 717 "intonation.cpp"
              var $75=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 717 "intonation.cpp"
              var $arrayidx71=(($75+6*$sub70)&4294967295); //@line 717 "intonation.cpp"
              var $stress72=(($arrayidx71)&4294967295); //@line 717 "intonation.cpp"
              var $76=HEAP8[($stress72)]; //@line 717 "intonation.cpp"
              var $conv73=(tempInt=(($76)),(tempInt>=128?tempInt-256:tempInt)); //@line 717 "intonation.cpp"
              var $and=($conv73) & 63; //@line 717 "intonation.cpp"
              var $cmp74=((($and))|0) >= 3; //@line 717 "intonation.cpp"
              var $77=$syl; //@line 718 "intonation.cpp"
              var $78=$pitch; //@line 718 "intonation.cpp"
              var $shr76=($78) >> 8; //@line 718 "intonation.cpp"
              if ($cmp74) { __label__ = 28;; } else { __label__ = 29;; } //@line 717 "intonation.cpp"
              if (__label__ == 28) {
  
                var $79=$th_addr; //@line 718 "intonation.cpp"
                var $body_lower_u=(($79+9)&4294967295); //@line 718 "intonation.cpp"
                var $80=HEAP8[($body_lower_u)]; //@line 718 "intonation.cpp"
                var $conv77=(tempInt=(($80)),(tempInt>=128?tempInt-256:tempInt)); //@line 718 "intonation.cpp"
                var $sub78=((($shr76)-($conv77))&4294967295); //@line 718 "intonation.cpp"
                var $81=$stress; //@line 718 "intonation.cpp"
                var $82=$drops; //@line 718 "intonation.cpp"
                var $arrayidx79=(($82+4*$81)&4294967295); //@line 718 "intonation.cpp"
                var $83=HEAP32[(($arrayidx79)>>2)]; //@line 718 "intonation.cpp"
                __ZL9set_pitchP8SYLLABLEii($77, $sub78, $83); //@line 718 "intonation.cpp"
                ; //@line 718 "intonation.cpp"
              }
              else if (__label__ == 29) {
  
                var $84=$stress; //@line 720 "intonation.cpp"
                var $85=$drops; //@line 720 "intonation.cpp"
                var $arrayidx82=(($85+4*$84)&4294967295); //@line 720 "intonation.cpp"
                var $86=HEAP32[(($arrayidx82)>>2)]; //@line 720 "intonation.cpp"
                __ZL9set_pitchP8SYLLABLEii($77, $shr76, $86); //@line 720 "intonation.cpp"
                ;
              }
            }
          }
  
          var $87=$ix_addr; //@line 723 "intonation.cpp"
          var $inc86=((($87)+1)&4294967295); //@line 723 "intonation.cpp"
          $ix_addr=$inc86; //@line 723 "intonation.cpp"
          var $88=$ix_addr; //@line 650 "intonation.cpp"
          var $89=$end_ix_addr; //@line 650 "intonation.cpp"
          var $cmp=((($88))|0) < ((($89))|0); //@line 650 "intonation.cpp"
          var $90=$ix_addr; //@line 652 "intonation.cpp"
          if ($cmp) { __lastLabel__ = 30; __label__ = 4;continue $while_body$7; } else { __lastLabel__ = 30; __label__ = 31;break $while_body$$while_end$6; } //@line 650 "intonation.cpp"
        }
      }
    } while(0);
  
    var $_lcssa=__lastLabel__ == 3 ? $17 : ($90);
    ;
    return $_lcssa; //@line 725 "intonation.cpp"
    return null;
  }
  

  function __ZL9set_pitchP8SYLLABLEii($syl, $base, $drop) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $syl_addr;
    var $base_addr;
    var $drop_addr;
    var $pitch1;
    var $pitch2;
    var $flags;
    $syl_addr=$syl;
    $base_addr=$base;
    $drop_addr=$drop;
    $flags=0; //@line 425 "intonation.cpp"
    var $0=$base_addr; //@line 427 "intonation.cpp"
    var $cmp=((($0))|0) < 0; //@line 427 "intonation.cpp"
    if ($cmp) { __lastLabel__ = 0; __label__ = 1;; } else { __lastLabel__ = 0; __label__ = 2;; } //@line 427 "intonation.cpp"
    if (__label__ == 1) {
  
      $base_addr=0; //@line 427 "intonation.cpp"
      var $_pr=$drop_addr; //@line 431 "intonation.cpp"
      __lastLabel__ = 1; ; //@line 427 "intonation.cpp"
    }
  
    var $1=__lastLabel__ == 1 ? $_pr : ($drop); //@line 431 "intonation.cpp"
    var $2=$base_addr; //@line 429 "intonation.cpp"
    $pitch2=$2; //@line 429 "intonation.cpp"
    var $cmp1=((($1))|0) < 0; //@line 431 "intonation.cpp"
    if ($cmp1) { __label__ = 3;; } else { __label__ = 4;; } //@line 431 "intonation.cpp"
    if (__label__ == 3) {
  
      $flags=1; //@line 433 "intonation.cpp"
      var $3=$drop_addr; //@line 434 "intonation.cpp"
      var $sub=(((-($3)))&4294967295); //@line 434 "intonation.cpp"
      $drop_addr=$sub; //@line 434 "intonation.cpp"
      ; //@line 435 "intonation.cpp"
    }
  
    var $4=$pitch2; //@line 437 "intonation.cpp"
    var $5=$drop_addr; //@line 437 "intonation.cpp"
    var $add=((($5)+($4))&4294967295); //@line 437 "intonation.cpp"
    $pitch1=$add; //@line 437 "intonation.cpp"
    var $cmp4=((($add))|0) < 0; //@line 438 "intonation.cpp"
    if ($cmp4) { __label__ = 5;; } else { __label__ = 6;; } //@line 438 "intonation.cpp"
    $if_end6_thread$$if_end6$8: do { 
      if (__label__ == 5) {
  
        $pitch1=0; //@line 439 "intonation.cpp"
        ; //@line 441 "intonation.cpp"
      }
      else if (__label__ == 6) {
  
        var $cmp7=((($add))|0) > 254; //@line 441 "intonation.cpp"
        if (!($cmp7)) { __label__ = 8;break $if_end6_thread$$if_end6$8; } //@line 441 "intonation.cpp"
  
        $pitch1=254; //@line 441 "intonation.cpp"
        ; //@line 441 "intonation.cpp"
      }
    } while(0);
  
    var $6=$pitch2; //@line 442 "intonation.cpp"
    var $cmp10=((($6))|0) > 254; //@line 442 "intonation.cpp"
    if ($cmp10) { __label__ = 9;; } else { __label__ = 10;; } //@line 442 "intonation.cpp"
    if (__label__ == 9) {
  
      $pitch2=254; //@line 442 "intonation.cpp"
      ; //@line 442 "intonation.cpp"
    }
  
    var $7=$pitch1; //@line 444 "intonation.cpp"
    var $conv=((($7)) & 255); //@line 444 "intonation.cpp"
    var $8=$syl_addr; //@line 444 "intonation.cpp"
    var $pitch113=(($8+4)&4294967295); //@line 444 "intonation.cpp"
    HEAP8[($pitch113)]=$conv; //@line 444 "intonation.cpp"
    var $9=$pitch2; //@line 445 "intonation.cpp"
    var $conv14=((($9)) & 255); //@line 445 "intonation.cpp"
    var $10=$syl_addr; //@line 445 "intonation.cpp"
    var $pitch215=(($10+5)&4294967295); //@line 445 "intonation.cpp"
    HEAP8[($pitch215)]=$conv14; //@line 445 "intonation.cpp"
    var $11=$flags; //@line 446 "intonation.cpp"
    var $12=$syl_addr; //@line 446 "intonation.cpp"
    var $flags16=(($12+2)&4294967295); //@line 446 "intonation.cpp"
    var $13=HEAP8[($flags16)]; //@line 446 "intonation.cpp"
    var $conv17=(tempInt=(($13)),(tempInt>=128?tempInt-256:tempInt)); //@line 446 "intonation.cpp"
    var $or=($conv17) | ($11); //@line 446 "intonation.cpp"
    var $conv18=((($or)) & 255); //@line 446 "intonation.cpp"
    HEAP8[($flags16)]=$conv18; //@line 446 "intonation.cpp"
    ;
    return; //@line 447 "intonation.cpp"
    return;
  }
  

  function __ZL16count_incrementsiii($ix, $end_ix, $min_stress) {
    ;
    var __label__;
  
    var $ix_addr;
    var $end_ix_addr;
    var $min_stress_addr;
    var $count;
    var $stress;
    $ix_addr=$ix;
    $end_ix_addr=$end_ix;
    $min_stress_addr=$min_stress;
    $count=0; //@line 402 "intonation.cpp"
    ; //@line 405 "intonation.cpp"
    while(1) { 
  
      var $0=$ix_addr; //@line 405 "intonation.cpp"
      var $1=$end_ix_addr; //@line 405 "intonation.cpp"
      var $cmp=((($0))|0) < ((($1))|0); //@line 405 "intonation.cpp"
      if (!($cmp)) { __label__ = 5;break ; } //@line 405 "intonation.cpp"
  
      var $2=$ix_addr; //@line 407 "intonation.cpp"
      var $inc=((($2)+1)&4294967295); //@line 407 "intonation.cpp"
      $ix_addr=$inc; //@line 407 "intonation.cpp"
      var $3=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 407 "intonation.cpp"
      var $arrayidx=(($3+6*$2)&4294967295); //@line 407 "intonation.cpp"
      var $stress1=(($arrayidx)&4294967295); //@line 407 "intonation.cpp"
      var $4=HEAP8[($stress1)]; //@line 407 "intonation.cpp"
      var $conv=(tempInt=(($4)),(tempInt>=128?tempInt-256:tempInt)); //@line 407 "intonation.cpp"
      $stress=$conv; //@line 407 "intonation.cpp"
      var $5=$stress; //@line 408 "intonation.cpp"
      var $cmp2=((($5))|0) >= 7; //@line 408 "intonation.cpp"
      if ($cmp2) { __label__ = 5;break ; } //@line 408 "intonation.cpp"
  
      var $6=$stress; //@line 411 "intonation.cpp"
      var $7=$min_stress_addr; //@line 411 "intonation.cpp"
      var $cmp3=((($6))|0) >= ((($7))|0); //@line 411 "intonation.cpp"
      if (!($cmp3)) { __label__ = 1;continue ; } //@line 411 "intonation.cpp"
  
      var $8=$count; //@line 412 "intonation.cpp"
      var $inc5=((($8)+1)&4294967295); //@line 412 "intonation.cpp"
      $count=$inc5; //@line 412 "intonation.cpp"
      __label__ = 1;continue ; //@line 412 "intonation.cpp"
    }
  
    var $9=$count; //@line 414 "intonation.cpp"
    ;
    return $9; //@line 414 "intonation.cpp"
    return null;
  }
  

  function __ZL17SetHeadIntonationP4TUNEiii($tune, $syl_ix, $end_ix) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $tune_addr;
    var $syl_ix_addr;
    var $end_ix_addr;
    var $control_addr;
    var $stress;
    var $syl;
    var $ix;
    var $pitch;
    var $increment;
    var $n_steps;
    var $stage;
    var $initial;
    var $overflow_ix;
    var $pitch_range;
    var $pitch_range_abs;
    var $drops;
    var $n_unstressed;
    var $unstressed_ix;
    var $unstressed_inc;
    var $used_onset;
    var $head_final;
    var $secondary;
    $tune_addr=$tune;
    $syl_ix_addr=$syl_ix;
    $end_ix_addr=$end_ix;
    $control_addr=0;
    $pitch=0; //@line 467 "intonation.cpp"
    $increment=0; //@line 468 "intonation.cpp"
    $n_steps=0; //@line 469 "intonation.cpp"
    $overflow_ix=0; //@line 472 "intonation.cpp"
    $n_unstressed=0; //@line 476 "intonation.cpp"
    $unstressed_ix=0; //@line 477 "intonation.cpp"
    $used_onset=0; //@line 479 "intonation.cpp"
    var $0=$end_ix_addr; //@line 480 "intonation.cpp"
    $head_final=$0; //@line 480 "intonation.cpp"
    $secondary=2; //@line 481 "intonation.cpp"
    var $1=$tune_addr; //@line 483 "intonation.cpp"
    var $head_end=(($1+32)&4294967295); //@line 483 "intonation.cpp"
    var $2=HEAPU8[($head_end)]; //@line 483 "intonation.cpp"
    var $conv=((($2))&255); //@line 483 "intonation.cpp"
    var $3=$tune_addr; //@line 483 "intonation.cpp"
    var $head_start=(($3+31)&4294967295); //@line 483 "intonation.cpp"
    var $4=HEAPU8[($head_start)]; //@line 483 "intonation.cpp"
    var $conv1=((($4))&255); //@line 483 "intonation.cpp"
    var $sub=((($conv)-($conv1))&4294967295); //@line 483 "intonation.cpp"
    var $shl=($sub) << 8; //@line 483 "intonation.cpp"
    $pitch_range=$shl; //@line 483 "intonation.cpp"
    var $5=$pitch_range; //@line 484 "intonation.cpp"
    var $ispos=((($5))|0) > -1; //@line 484 "intonation.cpp"
    var $neg=(((-($5)))&4294967295); //@line 484 "intonation.cpp"
    var $call=($ispos) ? ($5) : ($neg); //@line 484 "intonation.cpp"
    $pitch_range_abs=$call; //@line 484 "intonation.cpp"
    $drops=((__ZL7drops_0)&4294967295); //@line 485 "intonation.cpp"
    $initial=1; //@line 486 "intonation.cpp"
    $stage=0; //@line 488 "intonation.cpp"
    var $6=$tune_addr; //@line 489 "intonation.cpp"
    var $onset=(($6+30)&4294967295); //@line 489 "intonation.cpp"
    var $7=HEAPU8[($onset)]; //@line 489 "intonation.cpp"
    var $conv2=((($7))&255); //@line 489 "intonation.cpp"
    var $cmp=((($conv2))|0)==255; //@line 489 "intonation.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 489 "intonation.cpp"
    if (__label__ == 1) {
  
      $stage=1; //@line 490 "intonation.cpp"
      ; //@line 490 "intonation.cpp"
    }
  
    var $8=$tune_addr; //@line 492 "intonation.cpp"
    var $head_last=(($8+33)&4294967295); //@line 492 "intonation.cpp"
    var $9=HEAPU8[($head_last)]; //@line 492 "intonation.cpp"
    var $conv3=((($9))&255); //@line 492 "intonation.cpp"
    var $cmp4=((($conv3))|0)!=255; //@line 492 "intonation.cpp"
    if ($cmp4) { __label__ = 4;; } else { __label__ = 3;; } //@line 492 "intonation.cpp"
    $if_then5$$while_cond_preheader$5: do { 
      if (__label__ == 4) {
  
        var $13=$end_ix_addr; //@line 495 "intonation.cpp"
        var $sub6=((($13)-1)&4294967295); //@line 495 "intonation.cpp"
        $ix=$sub6; //@line 495 "intonation.cpp"
        ; //@line 495 "intonation.cpp"
        while(1) { 
  
          var $14=$ix; //@line 495 "intonation.cpp"
          var $15=$syl_ix_addr; //@line 495 "intonation.cpp"
          var $cmp7=((($14))|0) >= ((($15))|0); //@line 495 "intonation.cpp"
          if (!($cmp7)) { __label__ = 3;break $if_then5$$while_cond_preheader$5; } //@line 495 "intonation.cpp"
  
          var $16=$ix; //@line 497 "intonation.cpp"
          var $17=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 497 "intonation.cpp"
          var $arrayidx=(($17+6*$16)&4294967295); //@line 497 "intonation.cpp"
          var $stress8=(($arrayidx)&4294967295); //@line 497 "intonation.cpp"
          var $18=HEAP8[($stress8)]; //@line 497 "intonation.cpp"
          var $conv9=(tempInt=(($18)),(tempInt>=128?tempInt-256:tempInt)); //@line 497 "intonation.cpp"
          var $cmp10=((($conv9))|0) >= 4; //@line 497 "intonation.cpp"
          var $19=$ix; //@line 499 "intonation.cpp"
          if ($cmp10) { __label__ = 7;break ; } //@line 497 "intonation.cpp"
  
          var $dec=((($19)-1)&4294967295); //@line 495 "intonation.cpp"
          $ix=$dec; //@line 495 "intonation.cpp"
          __label__ = 5;continue ; //@line 495 "intonation.cpp"
        }
  
        $head_final=$19; //@line 499 "intonation.cpp"
        ; //@line 500 "intonation.cpp"
      }
    } while(0);
  
    var $10=$syl_ix_addr; //@line 505 "intonation.cpp"
    var $11=$end_ix_addr; //@line 505 "intonation.cpp"
    var $cmp145=((($10))|0) < ((($11))|0); //@line 505 "intonation.cpp"
    var $12=$syl_ix_addr; //@line 507 "intonation.cpp"
    if ($cmp145) { __lastLabel__ = 3; __label__ = 9;; } else { __lastLabel__ = 3; __label__ = 39;; } //@line 505 "intonation.cpp"
    $while_body$$while_end$13: do { 
      if (__label__ == 9) {
        $while_body$14: while(1) { 
  
          var $20=__lastLabel__ == 38 ? $108 : ($12);
          var $21=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 507 "intonation.cpp"
          var $arrayidx15=(($21+6*$20)&4294967295); //@line 507 "intonation.cpp"
          $syl=$arrayidx15; //@line 507 "intonation.cpp"
          var $22=$syl; //@line 508 "intonation.cpp"
          var $stress16=(($22)&4294967295); //@line 508 "intonation.cpp"
          var $23=HEAP8[($stress16)]; //@line 508 "intonation.cpp"
          var $conv17=(tempInt=(($23)),(tempInt>=128?tempInt-256:tempInt)); //@line 508 "intonation.cpp"
          $stress=$conv17; //@line 508 "intonation.cpp"
          var $24=$initial; //@line 510 "intonation.cpp"
          var $tobool=((($24))|0)!=0; //@line 510 "intonation.cpp"
          if ($tobool) { __label__ = 13;; } else { __label__ = 10;; } //@line 510 "intonation.cpp"
          $if_then23$$lor_lhs_false$16: do { 
            if (__label__ == 10) {
  
              var $25=$stress; //@line 510 "intonation.cpp"
              var $cmp18=((($25))|0) >= 4; //@line 510 "intonation.cpp"
              if (!($cmp18)) { __label__ = 32;break $if_then23$$lor_lhs_false$16; } //@line 510 "intonation.cpp"
  
              var $_pr=$initial; //@line 514 "intonation.cpp"
              var $tobool20=((($_pr))|0)!=0; //@line 514 "intonation.cpp"
              if ($tobool20) { __label__ = 13;break $if_then23$$lor_lhs_false$16; } //@line 514 "intonation.cpp"
  
              var $26=$stress; //@line 514 "intonation.cpp"
              var $cmp22=((($26))|0)==5; //@line 514 "intonation.cpp"
              if ($cmp22) { __label__ = 13;break $if_then23$$lor_lhs_false$16; } //@line 514 "intonation.cpp"
  
              var $44=$syl_ix_addr; //@line 544 "intonation.cpp"
              var $45=$head_final; //@line 544 "intonation.cpp"
              var $cmp49=((($44))|0)==((($45))|0); //@line 544 "intonation.cpp"
              if ($cmp49) { __label__ = 23;; } else { __label__ = 24;; } //@line 544 "intonation.cpp"
              if (__label__ == 23) {
  
                var $46=$tune_addr; //@line 547 "intonation.cpp"
                var $head_last51=(($46+33)&4294967295); //@line 547 "intonation.cpp"
                var $47=HEAPU8[($head_last51)]; //@line 547 "intonation.cpp"
                var $conv52=((($47))&255); //@line 547 "intonation.cpp"
                var $shl53=($conv52) << 8; //@line 547 "intonation.cpp"
                $pitch=$shl53; //@line 547 "intonation.cpp"
                $stage=2; //@line 548 "intonation.cpp"
                __label__ = 30;break $if_then23$$lor_lhs_false$16; //@line 549 "intonation.cpp"
              }
              else if (__label__ == 24) {
  
                var $48=$used_onset; //@line 552 "intonation.cpp"
                var $tobool55=((($48))|0)!=0; //@line 552 "intonation.cpp"
                if ($tobool55) { __label__ = 25;; } else { __label__ = 26;; } //@line 552 "intonation.cpp"
                if (__label__ == 25) {
  
                  $stage=1; //@line 554 "intonation.cpp"
                  $used_onset=0; //@line 555 "intonation.cpp"
                  var $49=$tune_addr; //@line 556 "intonation.cpp"
                  var $head_start57=(($49+31)&4294967295); //@line 556 "intonation.cpp"
                  var $50=HEAPU8[($head_start57)]; //@line 556 "intonation.cpp"
                  var $conv58=((($50))&255); //@line 556 "intonation.cpp"
                  var $shl59=($conv58) << 8; //@line 556 "intonation.cpp"
                  $pitch=$shl59; //@line 556 "intonation.cpp"
                  var $51=$n_steps; //@line 557 "intonation.cpp"
                  var $inc=((($51)+1)&4294967295); //@line 557 "intonation.cpp"
                  $n_steps=$inc; //@line 557 "intonation.cpp"
                  __label__ = 30;break $if_then23$$lor_lhs_false$16; //@line 558 "intonation.cpp"
                }
                else if (__label__ == 26) {
  
                  var $52=$n_steps; //@line 560 "intonation.cpp"
                  var $cmp61=((($52))|0) > 0; //@line 560 "intonation.cpp"
                  if ($cmp61) { __label__ = 27;; } else { __label__ = 28;; } //@line 560 "intonation.cpp"
                  if (__label__ == 27) {
  
                    var $53=$increment; //@line 561 "intonation.cpp"
                    var $54=$pitch; //@line 561 "intonation.cpp"
                    var $add63=((($54)+($53))&4294967295); //@line 561 "intonation.cpp"
                    $pitch=$add63; //@line 561 "intonation.cpp"
                    __label__ = 30;break $if_then23$$lor_lhs_false$16; //@line 561 "intonation.cpp"
                  }
                  else if (__label__ == 28) {
  
                    var $55=$tune_addr; //@line 564 "intonation.cpp"
                    var $head_end65=(($55+32)&4294967295); //@line 564 "intonation.cpp"
                    var $56=HEAPU8[($head_end65)]; //@line 564 "intonation.cpp"
                    var $conv66=((($56))&255); //@line 564 "intonation.cpp"
                    var $shl67=((($conv66)*256)&4294967295); //@line 564 "intonation.cpp"
                    var $57=$pitch_range_abs; //@line 564 "intonation.cpp"
                    var $58=$overflow_ix; //@line 564 "intonation.cpp"
                    var $inc68=((($58)+1)&4294967295); //@line 564 "intonation.cpp"
                    $overflow_ix=$inc68; //@line 564 "intonation.cpp"
                    var $59=$tune_addr; //@line 564 "intonation.cpp"
                    var $head_extend=(($59+16)&4294967295); //@line 564 "intonation.cpp"
                    var $arrayidx69=(($head_extend+$58)&4294967295); //@line 564 "intonation.cpp"
                    var $60=HEAP8[($arrayidx69)]; //@line 564 "intonation.cpp"
                    var $conv70=(tempInt=(($60)),(tempInt>=128?tempInt-256:tempInt)); //@line 564 "intonation.cpp"
                    var $mul=((($conv70)*($57))&4294967295); //@line 564 "intonation.cpp"
                    var $div71=((((($mul))|0)/64)|0); //@line 564 "intonation.cpp"
                    var $add72=((($div71)+($shl67))&4294967295); //@line 564 "intonation.cpp"
                    $pitch=$add72; //@line 564 "intonation.cpp"
                    var $61=$overflow_ix; //@line 565 "intonation.cpp"
                    var $62=$tune_addr; //@line 565 "intonation.cpp"
                    var $n_head_extend=(($62+35)&4294967295); //@line 565 "intonation.cpp"
                    var $63=HEAPU8[($n_head_extend)]; //@line 565 "intonation.cpp"
                    var $conv73=((($63))&255); //@line 565 "intonation.cpp"
                    var $cmp74=((($61))|0) >= ((($conv73))|0); //@line 565 "intonation.cpp"
                    if (!($cmp74)) { __label__ = 30;break $if_then23$$lor_lhs_false$16; } //@line 565 "intonation.cpp"
  
                    $overflow_ix=0; //@line 567 "intonation.cpp"
                    __label__ = 30;break $if_then23$$lor_lhs_false$16; //@line 568 "intonation.cpp"
                  }
                }
              }
            }
          } while(0);
          $if_then23$$if_end82$$if_else89$31: do { 
            if (__label__ == 13) {
  
              $initial=0; //@line 516 "intonation.cpp"
              $overflow_ix=0; //@line 517 "intonation.cpp"
              var $27=$tune_addr; //@line 519 "intonation.cpp"
              var $onset24=(($27+30)&4294967295); //@line 519 "intonation.cpp"
              var $28=HEAPU8[($onset24)]; //@line 519 "intonation.cpp"
              var $conv25=((($28))&255); //@line 519 "intonation.cpp"
              var $cmp26=((($conv25))|0)==255; //@line 519 "intonation.cpp"
              var $29=$syl_ix_addr; //@line 521 "intonation.cpp"
              if ($cmp26) { __label__ = 14;; } else { __label__ = 15;; } //@line 519 "intonation.cpp"
              if (__label__ == 14) {
  
                var $30=$head_final; //@line 521 "intonation.cpp"
                var $call28=__ZL16count_incrementsiii($29, $30, 4); //@line 521 "intonation.cpp"
                $n_steps=$call28; //@line 521 "intonation.cpp"
                var $31=$tune_addr; //@line 522 "intonation.cpp"
                var $head_start29=(($31+31)&4294967295); //@line 522 "intonation.cpp"
                var $32=HEAPU8[($head_start29)]; //@line 522 "intonation.cpp"
                var $conv30=((($32))&255); //@line 522 "intonation.cpp"
                var $shl31=($conv30) << 8; //@line 522 "intonation.cpp"
                $pitch=$shl31; //@line 522 "intonation.cpp"
                ; //@line 523 "intonation.cpp"
              }
              else if (__label__ == 15) {
  
                var $add=((($29)+1)&4294967295); //@line 527 "intonation.cpp"
                var $33=$head_final; //@line 527 "intonation.cpp"
                var $call32=__ZL16count_incrementsiii($add, $33, 4); //@line 527 "intonation.cpp"
                $n_steps=$call32; //@line 527 "intonation.cpp"
                var $34=$tune_addr; //@line 528 "intonation.cpp"
                var $onset33=(($34+30)&4294967295); //@line 528 "intonation.cpp"
                var $35=HEAPU8[($onset33)]; //@line 528 "intonation.cpp"
                var $conv34=((($35))&255); //@line 528 "intonation.cpp"
                var $shl35=($conv34) << 8; //@line 528 "intonation.cpp"
                $pitch=$shl35; //@line 528 "intonation.cpp"
                $used_onset=1; //@line 529 "intonation.cpp"
                ;
              }
  
              var $36=$n_steps; //@line 532 "intonation.cpp"
              var $37=$tune_addr; //@line 532 "intonation.cpp"
              var $head_max_steps=(($37+34)&4294967295); //@line 532 "intonation.cpp"
              var $38=HEAPU8[($head_max_steps)]; //@line 532 "intonation.cpp"
              var $conv37=((($38))&255); //@line 532 "intonation.cpp"
              var $cmp38=((($36))|0) > ((($conv37))|0); //@line 532 "intonation.cpp"
              if ($cmp38) { __label__ = 17;; } else { __label__ = 18;; } //@line 532 "intonation.cpp"
              if (__label__ == 17) {
  
                var $39=$tune_addr; //@line 533 "intonation.cpp"
                var $head_max_steps40=(($39+34)&4294967295); //@line 533 "intonation.cpp"
                var $40=HEAPU8[($head_max_steps40)]; //@line 533 "intonation.cpp"
                var $conv41=((($40))&255); //@line 533 "intonation.cpp"
                $n_steps=$conv41; //@line 533 "intonation.cpp"
                __lastLabel__ = 17; ; //@line 533 "intonation.cpp"
              }
              else if (__label__ == 18) {
  
                var $_pr2=$n_steps; //@line 535 "intonation.cpp"
                __lastLabel__ = 18; ;
              }
  
              var $41=__lastLabel__ == 18 ? $_pr2 : ($conv41); //@line 535 "intonation.cpp"
              var $cmp43=((($41))|0) > 1; //@line 535 "intonation.cpp"
              if ($cmp43) { __label__ = 20;; } else { __label__ = 21;; } //@line 535 "intonation.cpp"
              if (__label__ == 20) {
  
                var $42=$pitch_range; //@line 537 "intonation.cpp"
                var $43=$n_steps; //@line 537 "intonation.cpp"
                var $sub45=((($43)-1)&4294967295); //@line 537 "intonation.cpp"
                var $div=((((($42))|0)/((($sub45))|0))|0); //@line 537 "intonation.cpp"
                $increment=$div; //@line 537 "intonation.cpp"
                __label__ = 30;break $if_then23$$if_end82$$if_else89$31; //@line 538 "intonation.cpp"
              }
              else if (__label__ == 21) {
  
                $increment=0; //@line 540 "intonation.cpp"
                __label__ = 30;break $if_then23$$if_end82$$if_else89$31;
              }
            }
          } while(0);
          $if_end82$$if_else89$44: do { 
            if (__label__ == 30) {
  
              var $64=$n_steps; //@line 572 "intonation.cpp"
              var $dec81=((($64)-1)&4294967295); //@line 572 "intonation.cpp"
              $n_steps=$dec81; //@line 572 "intonation.cpp"
              var $_pr3=$stress; //@line 575 "intonation.cpp"
              var $cmp83=((($_pr3))|0) >= 4; //@line 575 "intonation.cpp"
              if (!($cmp83)) { __label__ = 32;break $if_end82$$if_else89$44; } //@line 575 "intonation.cpp"
  
              var $65=$syl_ix_addr; //@line 577 "intonation.cpp"
              var $add85=((($65)+1)&4294967295); //@line 577 "intonation.cpp"
              var $66=$end_ix_addr; //@line 577 "intonation.cpp"
              var $67=$secondary; //@line 577 "intonation.cpp"
              var $call86=__ZL15CountUnstressediii($add85, $66, $67); //@line 577 "intonation.cpp"
              $n_unstressed=$call86; //@line 577 "intonation.cpp"
              $unstressed_ix=0; //@line 578 "intonation.cpp"
              var $68=$syl; //@line 579 "intonation.cpp"
              var $stress87=(($68)&4294967295); //@line 579 "intonation.cpp"
              HEAP8[($stress87)]=6; //@line 579 "intonation.cpp"
              var $69=$tune_addr; //@line 580 "intonation.cpp"
              var $stressed_env=(($69+26)&4294967295); //@line 580 "intonation.cpp"
              var $70=HEAP8[($stressed_env)]; //@line 580 "intonation.cpp"
              var $71=$syl; //@line 580 "intonation.cpp"
              var $env=(($71+1)&4294967295); //@line 580 "intonation.cpp"
              HEAP8[($env)]=$70; //@line 580 "intonation.cpp"
              var $72=$syl; //@line 581 "intonation.cpp"
              var $73=$pitch; //@line 581 "intonation.cpp"
              var $shr=($73) >> 8; //@line 581 "intonation.cpp"
              var $74=$tune_addr; //@line 581 "intonation.cpp"
              var $stressed_drop=(($74+27)&4294967295); //@line 581 "intonation.cpp"
              var $75=HEAPU8[($stressed_drop)]; //@line 581 "intonation.cpp"
              var $conv88=((($75))&255); //@line 581 "intonation.cpp"
              __ZL9set_pitchP8SYLLABLEii($72, $shr, $conv88); //@line 581 "intonation.cpp"
              __label__ = 38;break $if_end82$$if_else89$44; //@line 582 "intonation.cpp"
            }
          } while(0);
          if (__label__ == 32) {
  
            var $76=$stress; //@line 584 "intonation.cpp"
            var $77=$secondary; //@line 584 "intonation.cpp"
            var $cmp90=((($76))|0) >= ((($77))|0); //@line 584 "intonation.cpp"
            if ($cmp90) { __label__ = 33;; } else { __label__ = 34;; } //@line 584 "intonation.cpp"
            if (__label__ == 33) {
  
              var $78=$syl_ix_addr; //@line 586 "intonation.cpp"
              var $add92=((($78)+1)&4294967295); //@line 586 "intonation.cpp"
              var $79=$end_ix_addr; //@line 586 "intonation.cpp"
              var $80=$secondary; //@line 586 "intonation.cpp"
              var $call93=__ZL15CountUnstressediii($add92, $79, $80); //@line 586 "intonation.cpp"
              $n_unstressed=$call93; //@line 586 "intonation.cpp"
              $unstressed_ix=0; //@line 587 "intonation.cpp"
              var $81=$syl; //@line 588 "intonation.cpp"
              var $82=$pitch; //@line 588 "intonation.cpp"
              var $shr94=($82) >> 8; //@line 588 "intonation.cpp"
              var $83=$stress; //@line 588 "intonation.cpp"
              var $84=$drops; //@line 588 "intonation.cpp"
              var $arrayidx95=(($84+4*$83)&4294967295); //@line 588 "intonation.cpp"
              var $85=HEAP32[(($arrayidx95)>>2)]; //@line 588 "intonation.cpp"
              __ZL9set_pitchP8SYLLABLEii($81, $shr94, $85); //@line 588 "intonation.cpp"
              ; //@line 589 "intonation.cpp"
            }
            else if (__label__ == 34) {
  
              var $86=$n_unstressed; //@line 592 "intonation.cpp"
              var $cmp97=((($86))|0) > 1; //@line 592 "intonation.cpp"
              if ($cmp97) { __label__ = 35;; } else { __label__ = 36;; } //@line 592 "intonation.cpp"
              if (__label__ == 35) {
  
                var $87=$stage; //@line 593 "intonation.cpp"
                var $88=$tune_addr; //@line 593 "intonation.cpp"
                var $unstr_end=(($88+39)&4294967295); //@line 593 "intonation.cpp"
                var $arrayidx99=(($unstr_end+$87)&4294967295); //@line 593 "intonation.cpp"
                var $89=HEAP8[($arrayidx99)]; //@line 593 "intonation.cpp"
                var $conv100=(tempInt=(($89)),(tempInt>=128?tempInt-256:tempInt)); //@line 593 "intonation.cpp"
                var $90=$stage; //@line 593 "intonation.cpp"
                var $91=$tune_addr; //@line 593 "intonation.cpp"
                var $unstr_start=(($91+36)&4294967295); //@line 593 "intonation.cpp"
                var $arrayidx101=(($unstr_start+$90)&4294967295); //@line 593 "intonation.cpp"
                var $92=HEAP8[($arrayidx101)]; //@line 593 "intonation.cpp"
                var $conv102=(tempInt=(($92)),(tempInt>=128?tempInt-256:tempInt)); //@line 593 "intonation.cpp"
                var $sub103=((($conv100)-($conv102))&4294967295); //@line 593 "intonation.cpp"
                var $93=$n_unstressed; //@line 593 "intonation.cpp"
                var $sub104=((($93)-1)&4294967295); //@line 593 "intonation.cpp"
                var $div105=((((($sub103))|0)/((($sub104))|0))|0); //@line 593 "intonation.cpp"
                $unstressed_inc=$div105; //@line 593 "intonation.cpp"
                ; //@line 593 "intonation.cpp"
              }
              else if (__label__ == 36) {
  
                $unstressed_inc=0; //@line 595 "intonation.cpp"
                ;
              }
  
              var $94=$syl; //@line 597 "intonation.cpp"
              var $95=$pitch; //@line 597 "intonation.cpp"
              var $shr108=($95) >> 8; //@line 597 "intonation.cpp"
              var $96=$stage; //@line 597 "intonation.cpp"
              var $97=$tune_addr; //@line 597 "intonation.cpp"
              var $unstr_start109=(($97+36)&4294967295); //@line 597 "intonation.cpp"
              var $arrayidx110=(($unstr_start109+$96)&4294967295); //@line 597 "intonation.cpp"
              var $98=HEAP8[($arrayidx110)]; //@line 597 "intonation.cpp"
              var $conv111=(tempInt=(($98)),(tempInt>=128?tempInt-256:tempInt)); //@line 597 "intonation.cpp"
              var $99=$unstressed_inc; //@line 597 "intonation.cpp"
              var $100=$unstressed_ix; //@line 597 "intonation.cpp"
              var $mul113=((($100)*($99))&4294967295); //@line 597 "intonation.cpp"
              var $add112=((($conv111)+($shr108))&4294967295); //@line 597 "intonation.cpp"
              var $add114=((($add112)+($mul113))&4294967295); //@line 597 "intonation.cpp"
              var $101=$stress; //@line 597 "intonation.cpp"
              var $102=$drops; //@line 597 "intonation.cpp"
              var $arrayidx115=(($102+4*$101)&4294967295); //@line 597 "intonation.cpp"
              var $103=HEAP32[(($arrayidx115)>>2)]; //@line 597 "intonation.cpp"
              __ZL9set_pitchP8SYLLABLEii($94, $add114, $103); //@line 597 "intonation.cpp"
              var $104=$unstressed_ix; //@line 598 "intonation.cpp"
              var $inc116=((($104)+1)&4294967295); //@line 598 "intonation.cpp"
              $unstressed_ix=$inc116; //@line 598 "intonation.cpp"
              ;
            }
          }
  
          var $105=$syl_ix_addr; //@line 601 "intonation.cpp"
          var $inc119=((($105)+1)&4294967295); //@line 601 "intonation.cpp"
          $syl_ix_addr=$inc119; //@line 601 "intonation.cpp"
          var $106=$syl_ix_addr; //@line 505 "intonation.cpp"
          var $107=$end_ix_addr; //@line 505 "intonation.cpp"
          var $cmp14=((($106))|0) < ((($107))|0); //@line 505 "intonation.cpp"
          var $108=$syl_ix_addr; //@line 507 "intonation.cpp"
          if ($cmp14) { __lastLabel__ = 38; __label__ = 9;continue $while_body$14; } else { __lastLabel__ = 38; __label__ = 39;break $while_body$$while_end$13; } //@line 505 "intonation.cpp"
        }
      }
    } while(0);
  
    var $_lcssa=__lastLabel__ == 3 ? $12 : ($108);
    ;
    return $_lcssa; //@line 603 "intonation.cpp"
    return null;
  }
  

  function __ZL15CountUnstressediii($start, $end, $limit) {
    ;
    var __label__;
  
    var $start_addr;
    var $end_addr;
    var $limit_addr;
    var $ix;
    $start_addr=$start;
    $end_addr=$end;
    $limit_addr=$limit;
    var $0=$start_addr; //@line 454 "intonation.cpp"
    $ix=$0; //@line 454 "intonation.cpp"
    ; //@line 454 "intonation.cpp"
    while(1) { 
  
      var $1=$ix; //@line 454 "intonation.cpp"
      var $2=$end_addr; //@line 454 "intonation.cpp"
      var $cmp=((($1))|0) <= ((($2))|0); //@line 454 "intonation.cpp"
      if (!($cmp)) { __label__ = 4;break ; } //@line 454 "intonation.cpp"
  
      var $3=$ix; //@line 456 "intonation.cpp"
      var $4=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 456 "intonation.cpp"
      var $arrayidx=(($4+6*$3)&4294967295); //@line 456 "intonation.cpp"
      var $stress=(($arrayidx)&4294967295); //@line 456 "intonation.cpp"
      var $5=HEAP8[($stress)]; //@line 456 "intonation.cpp"
      var $conv=(tempInt=(($5)),(tempInt>=128?tempInt-256:tempInt)); //@line 456 "intonation.cpp"
      var $6=$limit_addr; //@line 456 "intonation.cpp"
      var $cmp1=((($conv))|0) >= ((($6))|0); //@line 456 "intonation.cpp"
      if ($cmp1) { __label__ = 4;break ; } //@line 456 "intonation.cpp"
  
      var $7=$ix; //@line 454 "intonation.cpp"
      var $inc=((($7)+1)&4294967295); //@line 454 "intonation.cpp"
      $ix=$inc; //@line 454 "intonation.cpp"
      __label__ = 1;continue ; //@line 454 "intonation.cpp"
    }
  
    var $8=$ix; //@line 459 "intonation.cpp"
    var $9=$start_addr; //@line 459 "intonation.cpp"
    var $sub=((($8)-($9))&4294967295); //@line 459 "intonation.cpp"
    ;
    return $sub; //@line 459 "intonation.cpp"
    return null;
  }
  

  function _iswalpha($c) {
    ;
    var __label__;
  
    var $retval;
    var $c_addr;
    $c_addr=$c;
    var $0=$c_addr; //@line 239 "readclause.cpp"
    var $cmp=((($0))>>>0) < 256; //@line 239 "readclause.cpp"
    var $1=$c_addr; //@line 240 "readclause.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 239 "readclause.cpp"
    if (__label__ == 1) {
  
      var $call=_isalpha($1); //@line 240 "readclause.cpp"
      $retval=$call; //@line 240 "readclause.cpp"
      ; //@line 240 "readclause.cpp"
    }
    else if (__label__ == 2) {
  
      var $cmp1=((($1))>>>0) > 12352; //@line 241 "readclause.cpp"
      var $2=$c_addr; //@line 241 "readclause.cpp"
      var $cmp2=((($2))>>>0) <= 42752; //@line 241 "readclause.cpp"
      var $or_cond=($cmp1) & ($cmp2); //@line 241 "readclause.cpp"
      if ($or_cond) { __label__ = 3;; } else { __label__ = 4;; } //@line 241 "readclause.cpp"
      if (__label__ == 3) {
  
        $retval=1; //@line 242 "readclause.cpp"
        ; //@line 242 "readclause.cpp"
      }
      else if (__label__ == 4) {
  
        var $3=$c_addr; //@line 243 "readclause.cpp"
        var $cmp5=((($3))>>>0) > 563; //@line 243 "readclause.cpp"
        if ($cmp5) { __label__ = 5;; } else { __label__ = 6;; } //@line 243 "readclause.cpp"
        if (__label__ == 5) {
  
          $retval=0; //@line 244 "readclause.cpp"
          ; //@line 244 "readclause.cpp"
        }
        else if (__label__ == 6) {
  
          var $4=$c_addr; //@line 245 "readclause.cpp"
          var $sub=((($4)-256)&4294967295); //@line 245 "readclause.cpp"
          var $arrayidx=((_walpha_tab+$sub)&4294967295); //@line 245 "readclause.cpp"
          var $5=HEAPU8[($arrayidx)]; //@line 245 "readclause.cpp"
          var $conv=((($5))&255); //@line 245 "readclause.cpp"
          $retval=$conv; //@line 245 "readclause.cpp"
          ; //@line 245 "readclause.cpp"
        }
      }
    }
  
    var $6=$retval; //@line 246 "readclause.cpp"
    ;
    return $6; //@line 246 "readclause.cpp"
    return null;
  }
  

  function _iswdigit($c) {
    ;
    var __label__;
  
    var $retval;
    var $c_addr;
    $c_addr=$c;
    var $0=$c_addr; //@line 250 "readclause.cpp"
    var $cmp=((($0))>>>0) < 256; //@line 250 "readclause.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 250 "readclause.cpp"
    if (__label__ == 1) {
  
      var $1=$c_addr; //@line 251 "readclause.cpp"
      var $isdigittmp=((($1)-48)&4294967295); //@line 251 "readclause.cpp"
      var $isdigit=((($isdigittmp))>>>0) < 10; //@line 251 "readclause.cpp"
      var $call=((($isdigit))&1); //@line 251 "readclause.cpp"
      $retval=$call; //@line 251 "readclause.cpp"
      ; //@line 251 "readclause.cpp"
    }
    else if (__label__ == 2) {
  
      $retval=0; //@line 252 "readclause.cpp"
      ; //@line 252 "readclause.cpp"
    }
  
    var $2=$retval; //@line 253 "readclause.cpp"
    ;
    return $2; //@line 253 "readclause.cpp"
    return null;
  }
  

  function _iswalnum($c) {
    ;
    var __label__;
  
    var $retval;
    var $c_addr;
    $c_addr=$c;
    var $0=$c_addr; //@line 257 "readclause.cpp"
    var $call=_iswdigit($0); //@line 257 "readclause.cpp"
    var $tobool=((($call))|0)!=0; //@line 257 "readclause.cpp"
    if ($tobool) { __label__ = 1;; } else { __label__ = 2;; } //@line 257 "readclause.cpp"
    if (__label__ == 1) {
  
      $retval=1; //@line 258 "readclause.cpp"
      ; //@line 258 "readclause.cpp"
    }
    else if (__label__ == 2) {
  
      var $1=$c_addr; //@line 259 "readclause.cpp"
      var $call1=_iswalpha($1); //@line 259 "readclause.cpp"
      $retval=$call1; //@line 259 "readclause.cpp"
      ; //@line 259 "readclause.cpp"
    }
  
    var $2=$retval; //@line 260 "readclause.cpp"
    ;
    return $2; //@line 260 "readclause.cpp"
    return null;
  }
  

  function _towlower($c) {
    ;
    var __label__;
  
    var $retval;
    var $c_addr;
    var $x;
    $c_addr=$c;
    var $0=$c_addr; //@line 265 "readclause.cpp"
    var $cmp=((($0))>>>0) < 256; //@line 265 "readclause.cpp"
    var $1=$c_addr; //@line 266 "readclause.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 265 "readclause.cpp"
    $if_then$$if_end$2: do { 
      if (__label__ == 1) {
  
        var $call=_tolower($1); //@line 266 "readclause.cpp"
        $retval=$call; //@line 266 "readclause.cpp"
        ; //@line 266 "readclause.cpp"
      }
      else if (__label__ == 2) {
  
        var $cmp1=((($1))>>>0) > 563; //@line 267 "readclause.cpp"
        if ($cmp1) { __label__ = 4;; } else { __label__ = 3;; } //@line 267 "readclause.cpp"
        $if_then3$$lor_lhs_false$5: do { 
          if (__label__ == 3) {
  
            var $2=$c_addr; //@line 267 "readclause.cpp"
            var $sub=((($2)-256)&4294967295); //@line 267 "readclause.cpp"
            var $arrayidx=((_walpha_tab+$sub)&4294967295); //@line 267 "readclause.cpp"
            var $3=HEAPU8[($arrayidx)]; //@line 267 "readclause.cpp"
            var $conv=((($3))&255); //@line 267 "readclause.cpp"
            $x=$conv; //@line 267 "readclause.cpp"
            var $cmp2=((($conv))|0)==255; //@line 267 "readclause.cpp"
            if ($cmp2) { __label__ = 4;break $if_then3$$lor_lhs_false$5; } //@line 267 "readclause.cpp"
  
            var $5=$x; //@line 269 "readclause.cpp"
            var $cmp5=((($5))|0)==254; //@line 269 "readclause.cpp"
            if ($cmp5) { __label__ = 6;; } else { __label__ = 8;; } //@line 269 "readclause.cpp"
            $if_then6$$if_end10$8: do { 
              if (__label__ == 6) {
  
                var $6=$c_addr; //@line 272 "readclause.cpp"
                var $cmp7=((($6))|0)==304; //@line 272 "readclause.cpp"
                if (!($cmp7)) { __label__ = 8;break $if_then6$$if_end10$8; } //@line 272 "readclause.cpp"
  
                $retval=105; //@line 273 "readclause.cpp"
                __label__ = 9;break $if_then$$if_end$2; //@line 273 "readclause.cpp"
              }
            } while(0);
  
            var $7=$c_addr; //@line 275 "readclause.cpp"
            var $8=$x; //@line 275 "readclause.cpp"
            var $add=((($8)+($7))&4294967295); //@line 275 "readclause.cpp"
            $retval=$add; //@line 275 "readclause.cpp"
            __label__ = 9;break $if_then$$if_end$2; //@line 275 "readclause.cpp"
          }
        } while(0);
  
        var $4=$c_addr; //@line 268 "readclause.cpp"
        $retval=$4; //@line 268 "readclause.cpp"
        ; //@line 268 "readclause.cpp"
      }
    } while(0);
  
    var $9=$retval; //@line 276 "readclause.cpp"
    ;
    return $9; //@line 276 "readclause.cpp"
    return null;
  }
  

  function _towupper($c) {
    ;
    var __label__;
  
    var $retval;
    var $c_addr;
    $c_addr=$c;
    var $0=$c_addr; //@line 281 "readclause.cpp"
    var $sub=((($0)-1)&4294967295); //@line 281 "readclause.cpp"
    var $call=_tolower($sub); //@line 281 "readclause.cpp"
    var $1=$c_addr; //@line 281 "readclause.cpp"
    var $cmp=((($call))|0)==((($1))|0); //@line 281 "readclause.cpp"
    var $2=$c_addr; //@line 282 "readclause.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 281 "readclause.cpp"
    if (__label__ == 1) {
  
      var $sub1=((($2)-1)&4294967295); //@line 282 "readclause.cpp"
      $retval=$sub1; //@line 282 "readclause.cpp"
      ; //@line 282 "readclause.cpp"
    }
    else if (__label__ == 2) {
  
      $retval=$2; //@line 283 "readclause.cpp"
      ; //@line 283 "readclause.cpp"
    }
  
    var $3=$retval; //@line 284 "readclause.cpp"
    ;
    return $3; //@line 284 "readclause.cpp"
    return null;
  }
  

  function _iswupper($c) {
    ;
    var __label__;
  
    var $retval;
    var $c_addr;
    var $x;
    $c_addr=$c;
    var $0=$c_addr; //@line 289 "readclause.cpp"
    var $cmp=((($0))>>>0) < 256; //@line 289 "readclause.cpp"
    var $1=$c_addr; //@line 290 "readclause.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 289 "readclause.cpp"
    $if_then$$if_end$2: do { 
      if (__label__ == 1) {
  
        var $call=_isupper($1); //@line 290 "readclause.cpp"
        $retval=$call; //@line 290 "readclause.cpp"
        ; //@line 290 "readclause.cpp"
      }
      else if (__label__ == 2) {
  
        var $cmp1=((($1))>>>0) > 563; //@line 291 "readclause.cpp"
        if ($cmp1) { __label__ = 5;; } else { __label__ = 3;; } //@line 291 "readclause.cpp"
        $if_then5$$lor_lhs_false$5: do { 
          if (__label__ == 3) {
  
            var $2=$c_addr; //@line 291 "readclause.cpp"
            var $sub=((($2)-256)&4294967295); //@line 291 "readclause.cpp"
            var $arrayidx=((_walpha_tab+$sub)&4294967295); //@line 291 "readclause.cpp"
            var $3=HEAPU8[($arrayidx)]; //@line 291 "readclause.cpp"
            var $conv=((($3))&255); //@line 291 "readclause.cpp"
            $x=$conv; //@line 291 "readclause.cpp"
            var $cmp2=((($conv))|0)==0; //@line 291 "readclause.cpp"
            if ($cmp2) { __label__ = 5;break $if_then5$$lor_lhs_false$5; } //@line 291 "readclause.cpp"
  
            var $4=$x; //@line 291 "readclause.cpp"
            var $cmp4=((($4))|0)==255; //@line 291 "readclause.cpp"
            if ($cmp4) { __label__ = 5;break $if_then5$$lor_lhs_false$5; } //@line 291 "readclause.cpp"
  
            $retval=1; //@line 293 "readclause.cpp"
            __label__ = 7;break $if_then$$if_end$2; //@line 293 "readclause.cpp"
          }
        } while(0);
  
        $retval=0; //@line 292 "readclause.cpp"
        ; //@line 292 "readclause.cpp"
      }
    } while(0);
  
    var $5=$retval; //@line 294 "readclause.cpp"
    ;
    return $5; //@line 294 "readclause.cpp"
    return null;
  }
  

  function _iswlower($c) {
    ;
    var __label__;
  
    var $retval;
    var $c_addr;
    $c_addr=$c;
    var $0=$c_addr; //@line 298 "readclause.cpp"
    var $cmp=((($0))>>>0) < 256; //@line 298 "readclause.cpp"
    var $1=$c_addr; //@line 299 "readclause.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 298 "readclause.cpp"
    $if_then$$if_end$2: do { 
      if (__label__ == 1) {
  
        var $call=_islower($1); //@line 299 "readclause.cpp"
        $retval=$call; //@line 299 "readclause.cpp"
        ; //@line 299 "readclause.cpp"
      }
      else if (__label__ == 2) {
  
        var $cmp1=((($1))>>>0) > 563; //@line 300 "readclause.cpp"
        if ($cmp1) { __label__ = 4;; } else { __label__ = 3;; } //@line 300 "readclause.cpp"
        $if_then3$$lor_lhs_false$5: do { 
          if (__label__ == 3) {
  
            var $2=$c_addr; //@line 300 "readclause.cpp"
            var $sub=((($2)-256)&4294967295); //@line 300 "readclause.cpp"
            var $arrayidx=((_walpha_tab+$sub)&4294967295); //@line 300 "readclause.cpp"
            var $3=HEAPU8[($arrayidx)]; //@line 300 "readclause.cpp"
            var $conv=((($3))&255); //@line 300 "readclause.cpp"
            var $cmp2=((($conv))|0)!=255; //@line 300 "readclause.cpp"
            if ($cmp2) { __label__ = 4;break $if_then3$$lor_lhs_false$5; } //@line 300 "readclause.cpp"
  
            $retval=1; //@line 302 "readclause.cpp"
            __label__ = 6;break $if_then$$if_end$2; //@line 302 "readclause.cpp"
          }
        } while(0);
  
        $retval=0; //@line 301 "readclause.cpp"
        ; //@line 301 "readclause.cpp"
      }
    } while(0);
  
    var $4=$retval; //@line 303 "readclause.cpp"
    ;
    return $4; //@line 303 "readclause.cpp"
    return null;
  }
  

  function _iswspace($c) {
    ;
    var __label__;
  
    var $retval;
    var $c_addr;
    $c_addr=$c;
    var $0=$c_addr; //@line 307 "readclause.cpp"
    var $cmp=((($0))>>>0) < 256; //@line 307 "readclause.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 307 "readclause.cpp"
    if (__label__ == 1) {
  
      var $1=$c_addr; //@line 308 "readclause.cpp"
      var $call=_isspace($1); //@line 308 "readclause.cpp"
      $retval=$call; //@line 308 "readclause.cpp"
      ; //@line 308 "readclause.cpp"
    }
    else if (__label__ == 2) {
  
      $retval=0; //@line 309 "readclause.cpp"
      ; //@line 309 "readclause.cpp"
    }
  
    var $2=$retval; //@line 310 "readclause.cpp"
    ;
    return $2; //@line 310 "readclause.cpp"
    return null;
  }
  

  function _iswpunct($c) {
    ;
    var __label__;
  
    var $retval;
    var $c_addr;
    $c_addr=$c;
    var $0=$c_addr; //@line 314 "readclause.cpp"
    var $cmp=((($0))>>>0) < 256; //@line 314 "readclause.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 314 "readclause.cpp"
    if (__label__ == 1) {
  
      var $1=$c_addr; //@line 315 "readclause.cpp"
      var $call=_ispunct($1); //@line 315 "readclause.cpp"
      $retval=$call; //@line 315 "readclause.cpp"
      ; //@line 315 "readclause.cpp"
    }
    else if (__label__ == 2) {
  
      $retval=0; //@line 316 "readclause.cpp"
      ; //@line 316 "readclause.cpp"
    }
  
    var $2=$retval; //@line 317 "readclause.cpp"
    ;
    return $2; //@line 317 "readclause.cpp"
    return null;
  }
  

  function _wcschr($str, $c) {
    ;
    var __label__;
  
    var $retval;
    var $str_addr;
    var $c_addr;
    $str_addr=$str;
    $c_addr=$c;
    ; //@line 321 "readclause.cpp"
    while(1) { 
  
      var $0=$str_addr; //@line 321 "readclause.cpp"
      var $1=HEAP32[(($0)>>2)]; //@line 321 "readclause.cpp"
      var $cmp=((($1))|0)!=0; //@line 321 "readclause.cpp"
      if (!($cmp)) { __label__ = 5;break ; } //@line 321 "readclause.cpp"
  
      var $2=$str_addr; //@line 323 "readclause.cpp"
      var $3=HEAP32[(($2)>>2)]; //@line 323 "readclause.cpp"
      var $4=$c_addr; //@line 323 "readclause.cpp"
      var $cmp1=((($3))|0)==((($4))|0); //@line 323 "readclause.cpp"
      var $5=$str_addr; //@line 324 "readclause.cpp"
      if ($cmp1) { __label__ = 3;break ; } //@line 323 "readclause.cpp"
  
      var $incdec_ptr=(($5+4)&4294967295); //@line 325 "readclause.cpp"
      $str_addr=$incdec_ptr; //@line 325 "readclause.cpp"
      __label__ = 1;continue ; //@line 326 "readclause.cpp"
    }
    if (__label__ == 5) {
  
      $retval=0; //@line 327 "readclause.cpp"
      ; //@line 327 "readclause.cpp"
    }
    else if (__label__ == 3) {
  
      $retval=$5; //@line 324 "readclause.cpp"
      ; //@line 324 "readclause.cpp"
    }
  
    var $6=$retval; //@line 328 "readclause.cpp"
    ;
    return $6; //@line 328 "readclause.cpp"
    return null;
  }
  

  function _wcslen($str) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $str_addr;
    var $ix;
    $str_addr=$str;
    $ix=0; //@line 334 "readclause.cpp"
    var $0=$str_addr; //@line 336 "readclause.cpp"
    var $1=HEAP32[(($0)>>2)]; //@line 336 "readclause.cpp"
    var $cmp1=((($1))|0)!=0; //@line 336 "readclause.cpp"
    var $2=$ix; //@line 338 "readclause.cpp"
    if ($cmp1) { __lastLabel__ = 0; __label__ = 1;; } else { __lastLabel__ = 0; __label__ = 2;; } //@line 336 "readclause.cpp"
    $while_body$$while_end$2: do { 
      if (__label__ == 1) {
        while(1) { 
  
          var $3=__lastLabel__ == 1 ? $6 : ($2);
          var $inc=((($3)+1)&4294967295); //@line 338 "readclause.cpp"
          $ix=$inc; //@line 338 "readclause.cpp"
          var $4=$str_addr; //@line 336 "readclause.cpp"
          var $5=HEAP32[(($4)>>2)]; //@line 336 "readclause.cpp"
          var $cmp=((($5))|0)!=0; //@line 336 "readclause.cpp"
          var $6=$ix; //@line 338 "readclause.cpp"
          if ($cmp) { __lastLabel__ = 1; __label__ = 1;continue ; } else { __lastLabel__ = 1; __label__ = 2;break $while_body$$while_end$2; } //@line 336 "readclause.cpp"
        }
      }
    } while(0);
  
    var $_lcssa=__lastLabel__ == 0 ? $2 : ($6);
    ;
    return $_lcssa; //@line 340 "readclause.cpp"
    return null;
  }
  

  function _wcstod($str, $tailptr) {
    var __stackBase__  = STACKTOP; STACKTOP += 80; _memset(__stackBase__, 0, 80);
    var __label__;
    var __lastLabel__ = null;
  
    var $str_addr;
    var $tailptr_addr;
    var $ix;
    var $buf=__stackBase__;
    $str_addr=$str;
    $tailptr_addr=$tailptr;
    var $0=$str_addr; //@line 348 "readclause.cpp"
    var $1=HEAP32[(($0)>>2)]; //@line 348 "readclause.cpp"
    var $call1=_isspace($1); //@line 348 "readclause.cpp"
    var $tobool2=((($call1))|0)!=0; //@line 348 "readclause.cpp"
    if ($tobool2) { __label__ = 1;; } else { __label__ = 2;; } //@line 348 "readclause.cpp"
    $while_body$$while_end$2: do { 
      if (__label__ == 1) {
        while(1) { 
  
          var $2=$str_addr; //@line 348 "readclause.cpp"
          var $incdec_ptr=(($2+4)&4294967295); //@line 348 "readclause.cpp"
          $str_addr=$incdec_ptr; //@line 348 "readclause.cpp"
          var $3=$str_addr; //@line 348 "readclause.cpp"
          var $4=HEAP32[(($3)>>2)]; //@line 348 "readclause.cpp"
          var $call=_isspace($4); //@line 348 "readclause.cpp"
          var $tobool=((($call))|0)!=0; //@line 348 "readclause.cpp"
          if ($tobool) { __label__ = 1;continue ; } else { __label__ = 2;break $while_body$$while_end$2; } //@line 348 "readclause.cpp"
        }
      }
    } while(0);
  
    $ix=0; //@line 349 "readclause.cpp"
    __lastLabel__ = 2; ; //@line 349 "readclause.cpp"
    while(1) { 
  
      var $5=__lastLabel__ == 5 ? $inc : (0); //@line 349 "readclause.cpp"
      var $cmp=((($5))|0) < 80; //@line 349 "readclause.cpp"
      if (!($cmp)) { __label__ = 6;break ; } //@line 349 "readclause.cpp"
  
      var $6=$ix; //@line 351 "readclause.cpp"
      var $7=$str_addr; //@line 351 "readclause.cpp"
      var $arrayidx=(($7+4*$6)&4294967295); //@line 351 "readclause.cpp"
      var $8=HEAP32[(($arrayidx)>>2)]; //@line 351 "readclause.cpp"
      var $conv=((($8)) & 255); //@line 351 "readclause.cpp"
      var $9=$ix; //@line 351 "readclause.cpp"
      var $arrayidx1=(($buf+$9)&4294967295); //@line 351 "readclause.cpp"
      HEAP8[($arrayidx1)]=$conv; //@line 351 "readclause.cpp"
      var $10=$ix; //@line 352 "readclause.cpp"
      var $arrayidx2=(($buf+$10)&4294967295); //@line 352 "readclause.cpp"
      var $11=HEAP8[($arrayidx2)]; //@line 352 "readclause.cpp"
      var $conv3=(tempInt=(($11)),(tempInt>=128?tempInt-256:tempInt)); //@line 352 "readclause.cpp"
      var $call4=_isspace($conv3); //@line 352 "readclause.cpp"
      var $tobool5=((($call4))|0)!=0; //@line 352 "readclause.cpp"
      if ($tobool5) { __label__ = 6;break ; } //@line 352 "readclause.cpp"
  
      var $12=$ix; //@line 349 "readclause.cpp"
      var $inc=((($12)+1)&4294967295); //@line 349 "readclause.cpp"
      $ix=$inc; //@line 349 "readclause.cpp"
      __lastLabel__ = 5; __label__ = 3;continue ; //@line 349 "readclause.cpp"
    }
  
    var $13=$ix; //@line 355 "readclause.cpp"
    var $14=$str_addr; //@line 355 "readclause.cpp"
    var $arrayidx6=(($14+4*$13)&4294967295); //@line 355 "readclause.cpp"
    var $15=$tailptr_addr; //@line 355 "readclause.cpp"
    HEAP32[(($15)>>2)]=$arrayidx6; //@line 355 "readclause.cpp"
    var $arraydecay=(($buf)&4294967295); //@line 356 "readclause.cpp"
    var $call7=_atof($arraydecay); //@line 356 "readclause.cpp"
    var $conv8=($call7); //@line 356 "readclause.cpp"
    STACKTOP = __stackBase__;
    return $conv8; //@line 356 "readclause.cpp"
    return null;
  }
  

  function __Z9towlower2j($c) {
    ;
    var __label__;
  
    var $c_addr;
    $c_addr=$c;
    var $0=$c_addr; //@line 366 "readclause.cpp"
    var $cmp=((($0))|0)==73; //@line 366 "readclause.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 3;; } //@line 366 "readclause.cpp"
    $if_then$$if_end3$2: do { 
      if (__label__ == 1) {
  
        var $1=HEAP32[((_translator)>>2)]; //@line 368 "readclause.cpp"
        var $translator_name=(($1+280)&4294967295); //@line 368 "readclause.cpp"
        var $2=HEAP32[(($translator_name)>>2)]; //@line 368 "readclause.cpp"
        var $cmp1=((($2))|0)==29810; //@line 368 "readclause.cpp"
        if (!($cmp1)) { __label__ = 3;break $if_then$$if_end3$2; } //@line 368 "readclause.cpp"
  
        $c_addr=305; //@line 370 "readclause.cpp"
        ; //@line 371 "readclause.cpp"
      }
    } while(0);
  
    var $3=$c_addr; //@line 377 "readclause.cpp"
    var $call=_towlower($3); //@line 377 "readclause.cpp"
    ;
    return $call; //@line 377 "readclause.cpp"
    return null;
  }
  

  function __Z3Eofv() {
    ;
    var __label__;
  
    var $retval;
    var $0=HEAP32[((__ZL10ungot_char)>>2)]; //@line 404 "readclause.cpp"
    var $cmp=((($0))|0)!=0; //@line 404 "readclause.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 404 "readclause.cpp"
    if (__label__ == 1) {
  
      $retval=0; //@line 405 "readclause.cpp"
      ; //@line 405 "readclause.cpp"
    }
    else if (__label__ == 2) {
  
      var $1=HEAP32[((__ZL7f_input)>>2)]; //@line 407 "readclause.cpp"
      var $cmp1=((($1))|0)!=0; //@line 407 "readclause.cpp"
      if ($cmp1) { __label__ = 3;; } else { __label__ = 4;; } //@line 407 "readclause.cpp"
      if (__label__ == 3) {
  
        var $2=HEAP32[((__ZL7f_input)>>2)]; //@line 408 "readclause.cpp"
        var $_flags=(($2+12)&4294967295); //@line 408 "readclause.cpp"
        var $3=HEAP16[(($_flags)>>1)]; //@line 408 "readclause.cpp"
        var $conv=(tempInt=(($3)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 408 "readclause.cpp"
        var $and=($conv) & 32; //@line 408 "readclause.cpp"
        var $cmp3=((($and))|0)!=0; //@line 408 "readclause.cpp"
        var $conv4=((($cmp3))&1); //@line 408 "readclause.cpp"
        $retval=$conv4; //@line 408 "readclause.cpp"
        ; //@line 408 "readclause.cpp"
      }
      else if (__label__ == 4) {
  
        var $_b=HEAPU8[(__ZL12end_of_input_b)];
        var $4=((($_b))&1);
        $retval=$4; //@line 410 "readclause.cpp"
        ; //@line 410 "readclause.cpp"
      }
    }
  
    var $5=$retval; //@line 411 "readclause.cpp"
    ;
    return $5; //@line 411 "readclause.cpp"
    return null;
  }
  

  function __Z10Read4BytesP7__sFILE($f) {
    ;
    var __label__;
  
    var $f_addr;
    var $ix;
    var $c;
    var $acc;
    $f_addr=$f;
    $acc=0; //@line 701 "readclause.cpp"
    $ix=0; //@line 703 "readclause.cpp"
    ; //@line 703 "readclause.cpp"
    while(1) { 
  
      var $0=$f_addr; //@line 705 "readclause.cpp"
      var $call=_fgetc($0); //@line 705 "readclause.cpp"
      var $and=($call) & 255; //@line 705 "readclause.cpp"
      var $conv=((($and)) & 255); //@line 705 "readclause.cpp"
      $c=$conv; //@line 705 "readclause.cpp"
      var $1=$c; //@line 706 "readclause.cpp"
      var $conv1=((($1))&255); //@line 706 "readclause.cpp"
      var $2=$ix; //@line 706 "readclause.cpp"
      var $mul=((($2)*8)&4294967295); //@line 706 "readclause.cpp"
      var $shl=($conv1) << ($mul); //@line 706 "readclause.cpp"
      var $3=$acc; //@line 706 "readclause.cpp"
      var $add=((($shl)+($3))&4294967295); //@line 706 "readclause.cpp"
      $acc=$add; //@line 706 "readclause.cpp"
      var $4=$ix; //@line 703 "readclause.cpp"
      var $inc=((($4)+1)&4294967295); //@line 703 "readclause.cpp"
      $ix=$inc; //@line 703 "readclause.cpp"
      var $cmp=((($inc))|0) < 4; //@line 703 "readclause.cpp"
      if ($cmp) { __label__ = 1;continue ; } else { __label__ = 2;break ; } //@line 703 "readclause.cpp"
    }
  
    var $5=$acc; //@line 708 "readclause.cpp"
    ;
    return $5; //@line 708 "readclause.cpp"
    return null;
  }
  

  function __Z11AddNameDataPKci($name, $wide) {
    ;
    var __label__;
  
    var $retval;
    var $name_addr;
    var $wide_addr;
    var $ix;
    var $len;
    var $vp;
    $name_addr=$name;
    $wide_addr=$wide;
    var $0=$wide_addr; //@line 1371 "readclause.cpp"
    var $tobool=((($0))|0)!=0; //@line 1371 "readclause.cpp"
    var $1=$name_addr; //@line 1373 "readclause.cpp"
    if ($tobool) { __label__ = 1;; } else { __label__ = 2;; } //@line 1371 "readclause.cpp"
    if (__label__ == 1) {
  
      var $2=$1; //@line 1373 "readclause.cpp"
      var $call=_wcslen($2); //@line 1373 "readclause.cpp"
      var $add=((($call)+1)&4294967295); //@line 1373 "readclause.cpp"
      var $mul=((($add)*4)&4294967295); //@line 1373 "readclause.cpp"
      $len=$mul; //@line 1373 "readclause.cpp"
      var $3=HEAP32[((__ZL10n_namedata)>>2)]; //@line 1374 "readclause.cpp"
      var $sub=((($3)+3)&4294967295); //@line 1374 "readclause.cpp"
      var $rem=((($sub))>>>0)%4; //@line 1374 "readclause.cpp"
      HEAP32[((__ZL10n_namedata)>>2)]=$rem; //@line 1374 "readclause.cpp"
      ; //@line 1375 "readclause.cpp"
    }
    else if (__label__ == 2) {
  
      var $call2=_strlen($1); //@line 1378 "readclause.cpp"
      var $add3=((($call2)+1)&4294967295); //@line 1378 "readclause.cpp"
      $len=$add3; //@line 1378 "readclause.cpp"
      ;
    }
  
    var $4=HEAP32[((__ZL11namedata_ix)>>2)]; //@line 1381 "readclause.cpp"
    var $5=$len; //@line 1381 "readclause.cpp"
    var $add4=((($5)+($4))&4294967295); //@line 1381 "readclause.cpp"
    var $6=HEAP32[((__ZL10n_namedata)>>2)]; //@line 1381 "readclause.cpp"
    var $cmp=((($add4))|0) >= ((($6))|0); //@line 1381 "readclause.cpp"
    if ($cmp) { __label__ = 4;; } else { __label__ = 7;; } //@line 1381 "readclause.cpp"
    $if_then5$$if_end14$6: do { 
      if (__label__ == 4) {
  
        var $7=HEAP32[((_namedata)>>2)]; //@line 1384 "readclause.cpp"
        var $8=HEAP32[((__ZL11namedata_ix)>>2)]; //@line 1384 "readclause.cpp"
        var $9=$len; //@line 1384 "readclause.cpp"
        var $add6=((($8)+300)&4294967295); //@line 1384 "readclause.cpp"
        var $add7=((($add6)+($9))&4294967295); //@line 1384 "readclause.cpp"
        var $call8=_realloc($7, $add7); //@line 1384 "readclause.cpp"
        $vp=$call8; //@line 1384 "readclause.cpp"
        var $cmp9=((($call8))|0)==0; //@line 1384 "readclause.cpp"
        if ($cmp9) { __label__ = 5;; } else { __label__ = 6;; } //@line 1384 "readclause.cpp"
        if (__label__ == 5) {
  
          $retval=-1; //@line 1385 "readclause.cpp"
          __label__ = 8;break $if_then5$$if_end14$6; //@line 1385 "readclause.cpp"
        }
        else if (__label__ == 6) {
  
          var $10=$vp; //@line 1387 "readclause.cpp"
          HEAP32[((_namedata)>>2)]=$10; //@line 1387 "readclause.cpp"
          var $11=HEAP32[((__ZL11namedata_ix)>>2)]; //@line 1388 "readclause.cpp"
          var $12=$len; //@line 1388 "readclause.cpp"
          var $add12=((($11)+300)&4294967295); //@line 1388 "readclause.cpp"
          var $add13=((($add12)+($12))&4294967295); //@line 1388 "readclause.cpp"
          HEAP32[((__ZL10n_namedata)>>2)]=$add13; //@line 1388 "readclause.cpp"
          __label__ = 7;break $if_then5$$if_end14$6; //@line 1389 "readclause.cpp"
        }
      }
    } while(0);
    if (__label__ == 7) {
  
      var $13=HEAP32[((__ZL11namedata_ix)>>2)]; //@line 1390 "readclause.cpp"
      $ix=$13; //@line 1390 "readclause.cpp"
      var $14=HEAP32[((_namedata)>>2)]; //@line 1390 "readclause.cpp"
      var $arrayidx=(($14+$13)&4294967295); //@line 1390 "readclause.cpp"
      var $15=$name_addr; //@line 1390 "readclause.cpp"
      var $16=$len; //@line 1390 "readclause.cpp"
      var $src$, $dest$, $stop$, $stop4$, $fast$;
      $src$ = $15;
      $dest$ = $arrayidx;
      $stop$ = $src$ + $16;
      if (($dest$%4) == ($src$%4) && $16 > 8) {
        while ($src$%4 !== 0 && $src$ < $stop$) {
          ; HEAP8[$dest$++] = HEAP8[$src$++];
        }
        $src$ >>= 2;
        $dest$ >>= 2;
        $stop4$ = $stop$ >> 2;
        while ($src$ < $stop4$) {
      ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
        }
        $src$ <<= 2;
        $dest$ <<= 2;
      }while ($src$ < $stop$) {
        ; HEAP8[$dest$++] = HEAP8[$src$++];
      }; //@line 1390 "readclause.cpp"
      var $17=$len; //@line 1391 "readclause.cpp"
      var $18=HEAP32[((__ZL11namedata_ix)>>2)]; //@line 1391 "readclause.cpp"
      var $add15=((($18)+($17))&4294967295); //@line 1391 "readclause.cpp"
      HEAP32[((__ZL11namedata_ix)>>2)]=$add15; //@line 1391 "readclause.cpp"
      var $19=$ix; //@line 1392 "readclause.cpp"
      $retval=$19; //@line 1392 "readclause.cpp"
      ; //@line 1392 "readclause.cpp"
    }
  
    var $20=$retval; //@line 1393 "readclause.cpp"
    ;
    return $20; //@line 1393 "readclause.cpp"
    return null;
  }
  

  function __Z13SetVoiceStackP12espeak_VOICE($v) {
    ;
    var __label__;
  
    var $v_addr;
    var $sp;
    $v_addr=$v;
    $sp=((__ZL10ssml_stack)&4294967295); //@line 1399 "readclause.cpp"
    var $0=$v_addr; //@line 1401 "readclause.cpp"
    var $cmp=((($0))|0)==0; //@line 1401 "readclause.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 1401 "readclause.cpp"
    if (__label__ == 1) {
  
      var $1=$sp; //@line 1403 "readclause.cpp"
      var $2=$1; //@line 1403 "readclause.cpp"
      var $dest$, $stop$, $stop4$, $fast$, $value4$;
      $dest$ = $2;
      $stop$ = $dest$ + 76;
      $value4$ = 0;
      if ($value4$ < 0) $value4$ += 256;
      $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
      while ($dest$%4 !== 0 && $dest$ < $stop$) {
        ;; HEAP8[$dest$++] = 0;
      }
      $dest$ >>= 2;
      $stop4$ = $stop$ >> 2;
      while ($dest$ < $stop4$) {
      ;;;;;;;  HEAP32[$dest$++] = $value4$;
      }
      $dest$ <<= 2;
      while ($dest$ < $stop$) {
        ;; HEAP8[$dest$++] = 0;
      }; //@line 1403 "readclause.cpp"
      ; //@line 1404 "readclause.cpp"
    }
    else if (__label__ == 2) {
  
      var $3=$v_addr; //@line 1406 "readclause.cpp"
      var $languages=(($3+4)&4294967295); //@line 1406 "readclause.cpp"
      var $4=HEAP32[(($languages)>>2)]; //@line 1406 "readclause.cpp"
      var $cmp1=((($4))|0)!=0; //@line 1406 "readclause.cpp"
      if ($cmp1) { __label__ = 3;; } else { __label__ = 4;; } //@line 1406 "readclause.cpp"
      if (__label__ == 3) {
  
        var $5=$sp; //@line 1407 "readclause.cpp"
        var $language=(($5+56)&4294967295); //@line 1407 "readclause.cpp"
        var $arraydecay=(($language)&4294967295); //@line 1407 "readclause.cpp"
        var $6=$v_addr; //@line 1407 "readclause.cpp"
        var $languages3=(($6+4)&4294967295); //@line 1407 "readclause.cpp"
        var $7=HEAP32[(($languages3)>>2)]; //@line 1407 "readclause.cpp"
        var $call=_strcpy($arraydecay, $7); //@line 1407 "readclause.cpp"
        ; //@line 1407 "readclause.cpp"
      }
  
      var $8=$v_addr; //@line 1408 "readclause.cpp"
      var $name=(($8)&4294967295); //@line 1408 "readclause.cpp"
      var $9=HEAP32[(($name)>>2)]; //@line 1408 "readclause.cpp"
      var $cmp5=((($9))|0)!=0; //@line 1408 "readclause.cpp"
      if ($cmp5) { __label__ = 5;; } else { __label__ = 6;; } //@line 1408 "readclause.cpp"
      if (__label__ == 5) {
  
        var $10=$sp; //@line 1409 "readclause.cpp"
        var $voice_name=(($10+16)&4294967295); //@line 1409 "readclause.cpp"
        var $arraydecay7=(($voice_name)&4294967295); //@line 1409 "readclause.cpp"
        var $11=$v_addr; //@line 1409 "readclause.cpp"
        var $name8=(($11)&4294967295); //@line 1409 "readclause.cpp"
        var $12=HEAP32[(($name8)>>2)]; //@line 1409 "readclause.cpp"
        var $call9=_strcpy($arraydecay7, $12); //@line 1409 "readclause.cpp"
        ; //@line 1409 "readclause.cpp"
      }
  
      var $13=$v_addr; //@line 1410 "readclause.cpp"
      var $variant=(($13+14)&4294967295); //@line 1410 "readclause.cpp"
      var $14=HEAPU8[($variant)]; //@line 1410 "readclause.cpp"
      var $conv=((($14))&255); //@line 1410 "readclause.cpp"
      var $15=$sp; //@line 1410 "readclause.cpp"
      var $voice_variant=(($15+4)&4294967295); //@line 1410 "readclause.cpp"
      HEAP32[(($voice_variant)>>2)]=$conv; //@line 1410 "readclause.cpp"
      var $16=$v_addr; //@line 1411 "readclause.cpp"
      var $age=(($16+13)&4294967295); //@line 1411 "readclause.cpp"
      var $17=HEAPU8[($age)]; //@line 1411 "readclause.cpp"
      var $conv11=((($17))&255); //@line 1411 "readclause.cpp"
      var $18=$sp; //@line 1411 "readclause.cpp"
      var $voice_age=(($18+12)&4294967295); //@line 1411 "readclause.cpp"
      HEAP32[(($voice_age)>>2)]=$conv11; //@line 1411 "readclause.cpp"
      var $19=$v_addr; //@line 1412 "readclause.cpp"
      var $gender=(($19+12)&4294967295); //@line 1412 "readclause.cpp"
      var $20=HEAPU8[($gender)]; //@line 1412 "readclause.cpp"
      var $conv12=((($20))&255); //@line 1412 "readclause.cpp"
      var $21=$sp; //@line 1412 "readclause.cpp"
      var $voice_gender=(($21+8)&4294967295); //@line 1412 "readclause.cpp"
      HEAP32[(($voice_gender)>>2)]=$conv12; //@line 1412 "readclause.cpp"
      ; //@line 1413 "readclause.cpp"
    }
  
    ;
    return; //@line 1413 "readclause.cpp"
    return;
  }
  

  function __Z10ReadClauseP10TranslatorP7__sFILEPcPsPiiS5_S3_($tr, $f_in, $buf, $charix, $charix_top, $n_buf, $tone_type, $voice_change) {
    var __stackBase__  = STACKTOP; STACKTOP += 1136; _memset(__stackBase__, 0, 1136);
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $tr_addr;
    var $f_in_addr;
    var $buf_addr;
    var $charix_addr;
    var $charix_top_addr;
    var $n_buf_addr;
    var $tone_type_addr;
    var $voice_change_addr;
    var $c1=__stackBase__;
    var $c2=__stackBase__+4;
    var $cprev;
    var $cprev2;
    var $c_next;
    var $parag;
    var $ix=__stackBase__+8;
    var $j;
    var $nl_count;
    var $linelength;
    var $phoneme_mode;
    var $n_xml_buf;
    var $terminator;
    var $punct;
    var $found;
    var $any_alnum;
    var $self_closing;
    var $punct_data;
    var $is_end_clause;
    var $announced_punctuation;
    var $prev_announced_punctuation;
    var $stressed_word;
    var $end_clause_after_tag;
    var $end_clause_index;
    var $xml_buf=__stackBase__+12;
    var $xml_buf2=__stackBase__+1040;
    var $p_word;
    var $text_buf=__stackBase__+1064;
    var $text_buf2=__stackBase__+1104;
    var $p2;
    $tr_addr=$tr;
    $f_in_addr=$f_in;
    $buf_addr=$buf;
    $charix_addr=$charix;
    $charix_top_addr=$charix_top;
    $n_buf_addr=$n_buf;
    $tone_type_addr=$tone_type;
    $voice_change_addr=$voice_change;
    HEAP32[(($c1)>>2)]=32; //@line 2047 "readclause.cpp"
    $cprev=32; //@line 2049 "readclause.cpp"
    $cprev2=32; //@line 2050 "readclause.cpp"
    HEAP32[(($ix)>>2)]=0; //@line 2053 "readclause.cpp"
    $linelength=0; //@line 2056 "readclause.cpp"
    $phoneme_mode=0; //@line 2057 "readclause.cpp"
    $any_alnum=0; //@line 2062 "readclause.cpp"
    $punct_data=0; //@line 2064 "readclause.cpp"
    $announced_punctuation=0; //@line 2066 "readclause.cpp"
    $stressed_word=0; //@line 2068 "readclause.cpp"
    $end_clause_after_tag=0; //@line 2069 "readclause.cpp"
    $end_clause_index=0; //@line 2070 "readclause.cpp"
    var $_b=HEAPU8[(__ZL19clear_skipping_text_b)];
    var $0=((($_b))&1);
    var $tobool=((($0))|0)!=0; //@line 2078 "readclause.cpp"
    if ($tobool) { __label__ = 1;; } else { __label__ = 2;; } //@line 2078 "readclause.cpp"
    if (__label__ == 1) {
  
      HEAP32[((_skipping_text)>>2)]=0; //@line 2080 "readclause.cpp"
      HEAP8[(__ZL19clear_skipping_text_b)]=0;
      ; //@line 2082 "readclause.cpp"
    }
  
    var $1=$tr_addr; //@line 2084 "readclause.cpp"
    var $phonemes_repeat_count=(($1+652)&4294967295); //@line 2084 "readclause.cpp"
    HEAP32[(($phonemes_repeat_count)>>2)]=0; //@line 2084 "readclause.cpp"
    var $2=$tr_addr; //@line 2085 "readclause.cpp"
    var $clause_upper_count=(($2+8304)&4294967295); //@line 2085 "readclause.cpp"
    HEAP32[(($clause_upper_count)>>2)]=0; //@line 2085 "readclause.cpp"
    var $3=$tr_addr; //@line 2086 "readclause.cpp"
    var $clause_lower_count=(($3+8308)&4294967295); //@line 2086 "readclause.cpp"
    HEAP32[(($clause_lower_count)>>2)]=0; //@line 2086 "readclause.cpp"
    HEAP8[(__ZL12end_of_input_b)]=0;
    var $4=$tone_type_addr; //@line 2088 "readclause.cpp"
    HEAP32[(($4)>>2)]=0; //@line 2088 "readclause.cpp"
    var $5=$voice_change_addr; //@line 2089 "readclause.cpp"
    HEAP8[($5)]=0; //@line 2089 "readclause.cpp"
    var $6=$f_in_addr; //@line 2091 "readclause.cpp"
    HEAP32[((__ZL7f_input)>>2)]=$6; //@line 2091 "readclause.cpp"
    var $7=HEAP32[((__ZL10ungot_word)>>2)]; //@line 2093 "readclause.cpp"
    var $cmp=((($7))|0)!=0; //@line 2093 "readclause.cpp"
    if ($cmp) { __label__ = 3;; } else { __label__ = 4;; } //@line 2093 "readclause.cpp"
    if (__label__ == 3) {
  
      var $8=$buf_addr; //@line 2095 "readclause.cpp"
      var $9=HEAP32[((__ZL10ungot_word)>>2)]; //@line 2095 "readclause.cpp"
      var $call=_strcpy($8, $9); //@line 2095 "readclause.cpp"
      var $10=HEAP32[((__ZL10ungot_word)>>2)]; //@line 2096 "readclause.cpp"
      var $call2=_strlen($10); //@line 2096 "readclause.cpp"
      var $11=HEAP32[(($ix)>>2)]; //@line 2096 "readclause.cpp"
      var $add=((($11)+($call2))&4294967295); //@line 2096 "readclause.cpp"
      HEAP32[(($ix)>>2)]=$add; //@line 2096 "readclause.cpp"
      HEAP32[((__ZL10ungot_word)>>2)]=0; //@line 2097 "readclause.cpp"
      ; //@line 2098 "readclause.cpp"
    }
  
    var $12=HEAP32[((__ZL11ungot_char2)>>2)]; //@line 2100 "readclause.cpp"
    var $cmp4=((($12))|0)!=0; //@line 2100 "readclause.cpp"
    if ($cmp4) { __label__ = 5;; } else { __label__ = 6;; } //@line 2100 "readclause.cpp"
    if (__label__ == 5) {
  
      var $13=HEAP32[((__ZL11ungot_char2)>>2)]; //@line 2102 "readclause.cpp"
      HEAP32[(($c2)>>2)]=$13; //@line 2102 "readclause.cpp"
      ; //@line 2103 "readclause.cpp"
    }
    else if (__label__ == 6) {
  
      var $call6=__ZL4GetCv(); //@line 2106 "readclause.cpp"
      HEAP32[(($c2)>>2)]=$call6; //@line 2106 "readclause.cpp"
      ;
    }
  
    var $arrayidx82=(($xml_buf2)&4294967295); //@line 2172 "readclause.cpp"
    var $arrayidx86=(($xml_buf2)&4294967295); //@line 2176 "readclause.cpp"
    var $arrayidx90=(($xml_buf2+1)&4294967295); //@line 2179 "readclause.cpp"
    var $arrayidx94=(($xml_buf2+2)&4294967295); //@line 2180 "readclause.cpp"
    var $arrayidx97=(($xml_buf2+1)&4294967295); //@line 2182 "readclause.cpp"
    var $arraydecay=(($xml_buf2)&4294967295); //@line 2186 "readclause.cpp"
    var $arraydecay164=(($xml_buf)&4294967295); //@line 2245 "readclause.cpp"
    var $arraydecay324=(($text_buf2)&4294967295); //@line 2396 "readclause.cpp"
    var $arraydecay328=(($text_buf)&4294967295); //@line 2398 "readclause.cpp"
    var $arraydecay329=(($text_buf2)&4294967295); //@line 2398 "readclause.cpp"
    var $arraydecay331=(($text_buf)&4294967295); //@line 2399 "readclause.cpp"
    var $arraydecay337=(($text_buf)&4294967295); //@line 2402 "readclause.cpp"
    ; //@line 2109 "readclause.cpp"
    $while_cond$12: while(1) { 
  
      var $call8=__Z3Eofv(); //@line 2109 "readclause.cpp"
      var $tobool9=((($call8))|0)==0; //@line 2109 "readclause.cpp"
      var $14=HEAP32[((__ZL10ungot_char)>>2)]; //@line 2109 "readclause.cpp"
      var $cmp10=((($14))|0)!=0; //@line 2109 "readclause.cpp"
      var $or_cond=($tobool9) | ($cmp10); //@line 2109 "readclause.cpp"
      var $15=HEAP32[((__ZL11ungot_char2)>>2)]; //@line 2109 "readclause.cpp"
      var $cmp12=((($15))|0)!=0; //@line 2109 "readclause.cpp"
      var $or_cond3=($or_cond) | ($cmp12); //@line 2109 "readclause.cpp"
      var $16=HEAP32[((__ZZ10ReadClauseP10TranslatorP7__sFILEPcPsPiiS5_S3_E15ungot_string_ix)>>2)]; //@line 2109 "readclause.cpp"
      var $cmp13=((($16))|0) >= 0; //@line 2109 "readclause.cpp"
      var $or_cond19=($or_cond3) | ($cmp13); //@line 2109 "readclause.cpp"
      if (!($or_cond19)) { __label__ = 256;break $while_cond$12; } //@line 2109 "readclause.cpp"
  
      var $17=HEAP32[(($c1)>>2)]; //@line 2111 "readclause.cpp"
      var $call14=_iswalnum($17); //@line 2111 "readclause.cpp"
      var $tobool15=((($call14))|0)!=0; //@line 2111 "readclause.cpp"
      if ($tobool15) { __label__ = 16;; } else { __label__ = 10;; } //@line 2111 "readclause.cpp"
      $if_end26$$if_then16$15: do { 
        if (__label__ == 10) {
  
          var $18=HEAP32[((_end_character_position)>>2)]; //@line 2113 "readclause.cpp"
          var $cmp17=((($18))|0) > 0; //@line 2113 "readclause.cpp"
          if ($cmp17) { __label__ = 11;; } else { __label__ = 13;; } //@line 2113 "readclause.cpp"
          if (__label__ == 11) {
  
            var $19=HEAP32[((_count_characters)>>2)]; //@line 2113 "readclause.cpp"
            var $20=HEAP32[((_end_character_position)>>2)]; //@line 2113 "readclause.cpp"
            var $cmp18=((($19))|0) > ((($20))|0); //@line 2113 "readclause.cpp"
            if ($cmp18) { __label__ = 12;break $while_cond$12; } //@line 2113 "readclause.cpp"
          }
  
          var $21=HEAP32[((_skip_characters)>>2)]; //@line 2119 "readclause.cpp"
          var $cmp21=((($21))|0) > 0; //@line 2119 "readclause.cpp"
          if (!($cmp21)) { __label__ = 16;break $if_end26$$if_then16$15; } //@line 2119 "readclause.cpp"
  
          var $22=HEAP32[((_count_characters)>>2)]; //@line 2119 "readclause.cpp"
          var $23=HEAP32[((_skip_characters)>>2)]; //@line 2119 "readclause.cpp"
          var $cmp23=((($22))|0) > ((($23))|0); //@line 2119 "readclause.cpp"
          if ($cmp23) { __label__ = 15;break $while_cond$12; } //@line 2119 "readclause.cpp"
        }
      } while(0);
  
      var $25=$cprev; //@line 2130 "readclause.cpp"
      $cprev2=$25; //@line 2130 "readclause.cpp"
      var $26=HEAP32[(($c1)>>2)]; //@line 2131 "readclause.cpp"
      $cprev=$26; //@line 2131 "readclause.cpp"
      var $27=HEAP32[(($c2)>>2)]; //@line 2132 "readclause.cpp"
      HEAP32[(($c1)>>2)]=$27; //@line 2132 "readclause.cpp"
      var $28=HEAP32[((__ZZ10ReadClauseP10TranslatorP7__sFILEPcPsPiiS5_S3_E15ungot_string_ix)>>2)]; //@line 2134 "readclause.cpp"
      var $cmp27=((($28))|0) >= 0; //@line 2134 "readclause.cpp"
      if ($cmp27) { __label__ = 17;; } else { __label__ = 19;; } //@line 2134 "readclause.cpp"
      $if_then28$$if_end32$22: do { 
        if (__label__ == 17) {
  
          var $29=HEAP32[((__ZZ10ReadClauseP10TranslatorP7__sFILEPcPsPiiS5_S3_E15ungot_string_ix)>>2)]; //@line 2136 "readclause.cpp"
          var $arrayidx=((__ZZ10ReadClauseP10TranslatorP7__sFILEPcPsPiiS5_S3_E12ungot_string+$29)&4294967295); //@line 2136 "readclause.cpp"
          var $30=HEAP8[($arrayidx)]; //@line 2136 "readclause.cpp"
          var $conv=(tempInt=(($30)),(tempInt>=128?tempInt-256:tempInt)); //@line 2136 "readclause.cpp"
          var $cmp29=((($conv))|0)==0; //@line 2136 "readclause.cpp"
          if (!($cmp29)) { __label__ = 19;break $if_then28$$if_end32$22; } //@line 2136 "readclause.cpp"
  
          HEAP32[((__ZZ10ReadClauseP10TranslatorP7__sFILEPcPsPiiS5_S3_E15ungot_string_ix)>>2)]=-1; //@line 2137 "readclause.cpp"
          ; //@line 2137 "readclause.cpp"
        }
      } while(0);
  
      var $31=HEAP32[((__ZZ10ReadClauseP10TranslatorP7__sFILEPcPsPiiS5_S3_E15ungot_string_ix)>>2)]; //@line 2140 "readclause.cpp"
      var $cmp33=((($31))|0)==0; //@line 2140 "readclause.cpp"
      var $32=HEAP32[((__ZL11ungot_char2)>>2)]; //@line 2140 "readclause.cpp"
      var $cmp35=((($32))|0)==0; //@line 2140 "readclause.cpp"
      var $or_cond4=($cmp33) & ($cmp35); //@line 2140 "readclause.cpp"
      if ($or_cond4) { __lastLabel__ = 19; __label__ = 20;; } else { __lastLabel__ = 19; __label__ = 21;; } //@line 2140 "readclause.cpp"
      if (__label__ == 20) {
  
        var $33=HEAP32[((__ZZ10ReadClauseP10TranslatorP7__sFILEPcPsPiiS5_S3_E15ungot_string_ix)>>2)]; //@line 2142 "readclause.cpp"
        var $inc=((($33)+1)&4294967295); //@line 2142 "readclause.cpp"
        HEAP32[((__ZZ10ReadClauseP10TranslatorP7__sFILEPcPsPiiS5_S3_E15ungot_string_ix)>>2)]=$inc; //@line 2142 "readclause.cpp"
        var $arrayidx37=((__ZZ10ReadClauseP10TranslatorP7__sFILEPcPsPiiS5_S3_E12ungot_string+$33)&4294967295); //@line 2142 "readclause.cpp"
        var $34=HEAP8[($arrayidx37)]; //@line 2142 "readclause.cpp"
        var $conv38=(tempInt=(($34)),(tempInt>=128?tempInt-256:tempInt)); //@line 2142 "readclause.cpp"
        HEAP32[(($c1)>>2)]=$conv38; //@line 2142 "readclause.cpp"
        __lastLabel__ = 20; ; //@line 2143 "readclause.cpp"
      }
  
      var $35=__lastLabel__ == 20 ? $inc : ($31); //@line 2144 "readclause.cpp"
      var $cmp40=((($35))|0) >= 0; //@line 2144 "readclause.cpp"
      if ($cmp40) { __label__ = 22;; } else { __label__ = 23;; } //@line 2144 "readclause.cpp"
      $if_then41$$if_else45$29: do { 
        if (__label__ == 22) {
  
          var $36=HEAP32[((__ZZ10ReadClauseP10TranslatorP7__sFILEPcPsPiiS5_S3_E15ungot_string_ix)>>2)]; //@line 2146 "readclause.cpp"
          var $inc42=((($36)+1)&4294967295); //@line 2146 "readclause.cpp"
          HEAP32[((__ZZ10ReadClauseP10TranslatorP7__sFILEPcPsPiiS5_S3_E15ungot_string_ix)>>2)]=$inc42; //@line 2146 "readclause.cpp"
          var $arrayidx43=((__ZZ10ReadClauseP10TranslatorP7__sFILEPcPsPiiS5_S3_E12ungot_string+$36)&4294967295); //@line 2146 "readclause.cpp"
          var $37=HEAP8[($arrayidx43)]; //@line 2146 "readclause.cpp"
          var $conv44=(tempInt=(($37)),(tempInt>=128?tempInt-256:tempInt)); //@line 2146 "readclause.cpp"
          HEAP32[(($c2)>>2)]=$conv44; //@line 2146 "readclause.cpp"
          ; //@line 2147 "readclause.cpp"
        }
        else if (__label__ == 23) {
  
          var $call46=__ZL4GetCv(); //@line 2150 "readclause.cpp"
          HEAP32[(($c2)>>2)]=$call46; //@line 2150 "readclause.cpp"
          var $call47=__Z3Eofv(); //@line 2152 "readclause.cpp"
          var $tobool48=((($call47))|0)!=0; //@line 2152 "readclause.cpp"
          if (!($tobool48)) { __label__ = 25;break $if_then41$$if_else45$29; } //@line 2152 "readclause.cpp"
  
          HEAP32[(($c2)>>2)]=32; //@line 2154 "readclause.cpp"
          ; //@line 2155 "readclause.cpp"
        }
      } while(0);
  
      HEAP32[((__ZL11ungot_char2)>>2)]=0; //@line 2157 "readclause.cpp"
      var $38=HEAP32[((_option_ssml)>>2)]; //@line 2159 "readclause.cpp"
      var $tobool52=((($38))|0)!=0; //@line 2159 "readclause.cpp"
      if ($tobool52) { __label__ = 26;; } else { __label__ = 72;; } //@line 2159 "readclause.cpp"
      $land_lhs_true53$$if_end184$34: do { 
        if (__label__ == 26) {
  
          var $39=$phoneme_mode; //@line 2159 "readclause.cpp"
          var $cmp54=((($39))|0)==0; //@line 2159 "readclause.cpp"
          if (!($cmp54)) { __label__ = 72;break $land_lhs_true53$$if_end184$34; } //@line 2159 "readclause.cpp"
  
          var $40=HEAP32[((__ZL19ssml_ignore_l_angle)>>2)]; //@line 2161 "readclause.cpp"
          var $cmp56=((($40))|0)!=38; //@line 2161 "readclause.cpp"
          if ($cmp56) { __label__ = 28;; } else { __label__ = 50;; } //@line 2161 "readclause.cpp"
          $land_lhs_true57$$if_else122$37: do { 
            if (__label__ == 28) {
  
              var $41=HEAP32[(($c1)>>2)]; //@line 2161 "readclause.cpp"
              var $cmp58=((($41))|0)==38; //@line 2161 "readclause.cpp"
              if (!($cmp58)) { __label__ = 50;break $land_lhs_true57$$if_else122$37; } //@line 2161 "readclause.cpp"
  
              var $42=HEAP32[(($c2)>>2)]; //@line 2161 "readclause.cpp"
              var $cmp60=((($42))|0)==35; //@line 2161 "readclause.cpp"
              if ($cmp60) { __label__ = 31;; } else { __label__ = 30;; } //@line 2161 "readclause.cpp"
              if (__label__ == 30) {
  
                var $43=HEAP32[(($c2)>>2)]; //@line 2161 "readclause.cpp"
                var $cmp62=((($43))|0) >= 97; //@line 2161 "readclause.cpp"
                var $44=HEAP32[(($c2)>>2)]; //@line 2161 "readclause.cpp"
                var $cmp64=((($44))|0) <= 122; //@line 2161 "readclause.cpp"
                var $or_cond5=($cmp62) & ($cmp64); //@line 2161 "readclause.cpp"
                if (!($or_cond5)) { __label__ = 50;break $land_lhs_true57$$if_else122$37; } //@line 2161 "readclause.cpp"
              }
  
              $n_xml_buf=0; //@line 2163 "readclause.cpp"
              var $45=HEAP32[(($c2)>>2)]; //@line 2164 "readclause.cpp"
              HEAP32[(($c1)>>2)]=$45; //@line 2164 "readclause.cpp"
              ; //@line 2165 "readclause.cpp"
              $while_cond66$43: while(1) { 
  
                var $call67=__Z3Eofv(); //@line 2165 "readclause.cpp"
                var $tobool68=((($call67))|0)!=0; //@line 2165 "readclause.cpp"
                if ($tobool68) { __label__ = 36;break $while_cond66$43; } //@line 2165 "readclause.cpp"
  
                var $46=HEAP32[(($c1)>>2)]; //@line 2165 "readclause.cpp"
                var $call70=_iswalnum($46); //@line 2165 "readclause.cpp"
                var $tobool71=((($call70))|0)!=0; //@line 2165 "readclause.cpp"
                var $47=HEAP32[(($c1)>>2)]; //@line 2165 "readclause.cpp"
                var $cmp73=((($47))|0)==35; //@line 2165 "readclause.cpp"
                var $or_cond6=($tobool71) | ($cmp73); //@line 2165 "readclause.cpp"
                if (!($or_cond6)) { __label__ = 36;break $while_cond66$43; } //@line 2165 "readclause.cpp"
  
                var $48=$n_xml_buf; //@line 2165 "readclause.cpp"
                var $cmp74=((($48))|0) < 20; //@line 2165 "readclause.cpp"
                if (!($cmp74)) { __label__ = 36;break $while_cond66$43; }
  
                var $49=HEAP32[(($c1)>>2)]; //@line 2167 "readclause.cpp"
                var $conv76=((($49)) & 255); //@line 2167 "readclause.cpp"
                var $50=$n_xml_buf; //@line 2167 "readclause.cpp"
                var $inc77=((($50)+1)&4294967295); //@line 2167 "readclause.cpp"
                $n_xml_buf=$inc77; //@line 2167 "readclause.cpp"
                var $arrayidx78=(($xml_buf2+$50)&4294967295); //@line 2167 "readclause.cpp"
                HEAP8[($arrayidx78)]=$conv76; //@line 2167 "readclause.cpp"
                var $call79=__ZL4GetCv(); //@line 2168 "readclause.cpp"
                HEAP32[(($c1)>>2)]=$call79; //@line 2168 "readclause.cpp"
                __label__ = 32;continue $while_cond66$43; //@line 2169 "readclause.cpp"
              }
  
              var $51=$n_xml_buf; //@line 2170 "readclause.cpp"
              var $arrayidx80=(($xml_buf2+$51)&4294967295); //@line 2170 "readclause.cpp"
              HEAP8[($arrayidx80)]=0; //@line 2170 "readclause.cpp"
              var $call81=__ZL4GetCv(); //@line 2171 "readclause.cpp"
              HEAP32[(($c2)>>2)]=$call81; //@line 2171 "readclause.cpp"
              var $52=HEAP32[(($c1)>>2)]; //@line 2172 "readclause.cpp"
              var $53=HEAP32[(($c2)>>2)]; //@line 2172 "readclause.cpp"
              var $call83=_sprintf(((__ZZ10ReadClauseP10TranslatorP7__sFILEPcPsPiiS5_S3_E12ungot_string)&4294967295), ((__str38205)&4294967295), allocate([$arrayidx82,0,0,0,$52,0,0,0,$53,0,0,0], ["i8*",0,0,0,"i32",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 2172 "readclause.cpp"
              var $54=HEAP32[(($c1)>>2)]; //@line 2174 "readclause.cpp"
              var $cmp84=((($54))|0)==59; //@line 2174 "readclause.cpp"
              if ($cmp84) { __label__ = 37;; } else { __label__ = 44;; } //@line 2174 "readclause.cpp"
              $if_then85$$if_else109$49: do { 
                if (__label__ == 37) {
  
                  var $55=HEAP8[($arrayidx86)]; //@line 2176 "readclause.cpp"
                  var $conv87=(tempInt=(($55)),(tempInt>=128?tempInt-256:tempInt)); //@line 2176 "readclause.cpp"
                  var $cmp88=((($conv87))|0)==35; //@line 2176 "readclause.cpp"
                  if ($cmp88) { __label__ = 38;; } else { __label__ = 41;; } //@line 2176 "readclause.cpp"
                  $if_then89$$if_else100$51: do { 
                    if (__label__ == 38) {
  
                      var $56=HEAP8[($arrayidx90)]; //@line 2179 "readclause.cpp"
                      var $conv91=(tempInt=(($56)),(tempInt>=128?tempInt-256:tempInt)); //@line 2179 "readclause.cpp"
                      var $cmp92=((($conv91))|0)==120; //@line 2179 "readclause.cpp"
                      if ($cmp92) { __label__ = 39;; } else { __label__ = 40;; } //@line 2179 "readclause.cpp"
                      if (__label__ == 39) {
  
                        var $call95=_sscanf($arrayidx94, ((__str10307)&4294967295), allocate([$c1,0,0,0], ["i32*",0,0,0], ALLOC_STACK)); //@line 2180 "readclause.cpp"
                        $found=$call95; //@line 2180 "readclause.cpp"
                        __lastLabel__ = 39; ; //@line 2180 "readclause.cpp"
                      }
                      else if (__label__ == 40) {
  
                        var $call98=_sscanf($arrayidx97, ((__str63715)&4294967295), allocate([$c1,0,0,0], ["i32*",0,0,0], ALLOC_STACK)); //@line 2182 "readclause.cpp"
                        $found=$call98; //@line 2182 "readclause.cpp"
                        __lastLabel__ = 40; ;
                      }
                    }
                    else if (__label__ == 41) {
  
                      var $call101=__Z10LookupMnemP8MNEM_TABPKc(((__ZL18xml_char_mnemonics)&4294967295), $arraydecay); //@line 2186 "readclause.cpp"
                      $found=$call101; //@line 2186 "readclause.cpp"
                      var $cmp102=((($call101))|0)!=-1; //@line 2186 "readclause.cpp"
                      if (!($cmp102)) { __label__ = 46;break $if_then85$$if_else109$49; } //@line 2186 "readclause.cpp"
  
                      var $57=$found; //@line 2188 "readclause.cpp"
                      HEAP32[(($c1)>>2)]=$57; //@line 2188 "readclause.cpp"
                      var $58=HEAP32[(($c2)>>2)]; //@line 2189 "readclause.cpp"
                      var $cmp104=((($58))|0)==0; //@line 2189 "readclause.cpp"
                      if ($cmp104) { __lastLabel__ = 42; ; } else { __lastLabel__ = 42; __label__ = 45;break $if_then89$$if_else100$51; } //@line 2189 "readclause.cpp"
  
                      HEAP32[(($c2)>>2)]=32; //@line 2190 "readclause.cpp"
                      var $_pr=$found; //@line 2199 "readclause.cpp"
                      __lastLabel__ = 43; ; //@line 2190 "readclause.cpp"
                    }
                  } while(0);
  
                  var $59=__lastLabel__ == 40 ? $call98 : (__lastLabel__ == 39 ? $call95 : (__lastLabel__ == 42 ? $57 : ($_pr))); //@line 2199 "readclause.cpp"
                  var $cmp111=((($59))|0) <= 0; //@line 2199 "readclause.cpp"
                  if ($cmp111) { __label__ = 46;break $if_then85$$if_else109$49; } //@line 2199 "readclause.cpp"
  
                  var $_pr23=HEAP32[(($c1)>>2)]; //@line 2206 "readclause.cpp"
                  var $cmp114=((($_pr23))|0) <= 32; //@line 2206 "readclause.cpp"
                  if (!($cmp114)) { __label__ = 72;break $land_lhs_true53$$if_end184$34; } //@line 2206 "readclause.cpp"
  
                  var $60=HEAP32[((__ZL10sayas_mode)>>2)]; //@line 2206 "readclause.cpp"
                  var $cmp116=((($60))|0)==20; //@line 2206 "readclause.cpp"
                  var $61=HEAP32[((__ZL10sayas_mode)>>2)]; //@line 2206 "readclause.cpp"
                  var $cmp118=((($61))|0)==36; //@line 2206 "readclause.cpp"
                  var $or_cond8=($cmp116) | ($cmp118); //@line 2206 "readclause.cpp"
                  if (!($or_cond8)) { __label__ = 72;break $land_lhs_true53$$if_end184$34; } //@line 2206 "readclause.cpp"
  
                  var $62=HEAP32[(($c1)>>2)]; //@line 2208 "readclause.cpp"
                  var $add120=((($62)+57344)&4294967295); //@line 2208 "readclause.cpp"
                  HEAP32[(($c1)>>2)]=$add120; //@line 2208 "readclause.cpp"
                  __label__ = 72;break $land_lhs_true53$$if_end184$34; //@line 2209 "readclause.cpp"
                }
                else if (__label__ == 44) {
  
                  $found=-1; //@line 2196 "readclause.cpp"
                  ;
                }
              } while(0);
  
              HEAP32[((__ZZ10ReadClauseP10TranslatorP7__sFILEPcPsPiiS5_S3_E15ungot_string_ix)>>2)]=0; //@line 2201 "readclause.cpp"
              HEAP32[(($c1)>>2)]=38; //@line 2202 "readclause.cpp"
              HEAP32[(($c2)>>2)]=32; //@line 2203 "readclause.cpp"
              __label__ = 72;break $land_lhs_true53$$if_end184$34; //@line 2206 "readclause.cpp"
            }
          } while(0);
  
          var $63=HEAP32[(($c1)>>2)]; //@line 2212 "readclause.cpp"
          var $cmp123=((($63))|0)==60; //@line 2212 "readclause.cpp"
          var $64=HEAP32[((__ZL19ssml_ignore_l_angle)>>2)]; //@line 2212 "readclause.cpp"
          var $cmp125=((($64))|0)!=60; //@line 2212 "readclause.cpp"
          var $or_cond9=($cmp123) & ($cmp125); //@line 2212 "readclause.cpp"
          if (!($or_cond9)) { __label__ = 72;break $land_lhs_true53$$if_end184$34; } //@line 2212 "readclause.cpp"
  
          var $65=HEAP32[(($c2)>>2)]; //@line 2214 "readclause.cpp"
          var $cmp127=((($65))|0)==33; //@line 2214 "readclause.cpp"
          if ($cmp127) { __label__ = 52;; } else { __label__ = 56;; } //@line 2214 "readclause.cpp"
          if (__label__ == 52) {
            while(1) { 
  
              var $call130=__Z3Eofv(); //@line 2217 "readclause.cpp"
              var $tobool131=((($call130))|0)!=0; //@line 2217 "readclause.cpp"
              if ($tobool131) { __label__ = 55;break ; } //@line 2217 "readclause.cpp"
  
              var $66=HEAP32[(($c1)>>2)]; //@line 2217 "readclause.cpp"
              var $cmp133=((($66))|0)!=62; //@line 2217 "readclause.cpp"
              if (!($cmp133)) { __label__ = 55;break ; }
  
              var $call136=__ZL4GetCv(); //@line 2219 "readclause.cpp"
              HEAP32[(($c1)>>2)]=$call136; //@line 2219 "readclause.cpp"
              __label__ = 52;continue ; //@line 2220 "readclause.cpp"
            }
  
            HEAP32[(($c2)>>2)]=32; //@line 2221 "readclause.cpp"
            ; //@line 2222 "readclause.cpp"
          }
          else if (__label__ == 56) {
  
            var $67=HEAP32[(($c2)>>2)]; //@line 2224 "readclause.cpp"
            var $cmp139=((($67))|0)==47; //@line 2224 "readclause.cpp"
            if ($cmp139) { __label__ = 58;; } else { __label__ = 57;; } //@line 2224 "readclause.cpp"
            if (__label__ == 57) {
  
              var $68=HEAP32[(($c2)>>2)]; //@line 2224 "readclause.cpp"
              var $call141=_iswalpha($68); //@line 2224 "readclause.cpp"
              var $tobool142=((($call141))|0)!=0; //@line 2224 "readclause.cpp"
              if (!($tobool142)) { __label__ = 72;break $land_lhs_true53$$if_end184$34; } //@line 2224 "readclause.cpp"
            }
  
            $n_xml_buf=0; //@line 2227 "readclause.cpp"
            var $69=HEAP32[(($c2)>>2)]; //@line 2228 "readclause.cpp"
            HEAP32[(($c1)>>2)]=$69; //@line 2228 "readclause.cpp"
            ; //@line 2229 "readclause.cpp"
            while(1) { 
  
              var $call145=__Z3Eofv(); //@line 2229 "readclause.cpp"
              var $tobool146=((($call145))|0)!=0; //@line 2229 "readclause.cpp"
              if ($tobool146) { __label__ = 63;break ; } //@line 2229 "readclause.cpp"
  
              var $70=HEAP32[(($c1)>>2)]; //@line 2229 "readclause.cpp"
              var $cmp148=((($70))|0)!=62; //@line 2229 "readclause.cpp"
              if (!($cmp148)) { __label__ = 63;break ; } //@line 2229 "readclause.cpp"
  
              var $71=$n_xml_buf; //@line 2229 "readclause.cpp"
              var $cmp150=((($71))|0) < 256; //@line 2229 "readclause.cpp"
              if (!($cmp150)) { __label__ = 63;break ; }
  
              var $72=HEAP32[(($c1)>>2)]; //@line 2231 "readclause.cpp"
              var $73=$n_xml_buf; //@line 2231 "readclause.cpp"
              var $inc153=((($73)+1)&4294967295); //@line 2231 "readclause.cpp"
              $n_xml_buf=$inc153; //@line 2231 "readclause.cpp"
              var $arrayidx154=(($xml_buf+$73*4)&4294967295); //@line 2231 "readclause.cpp"
              HEAP32[(($arrayidx154)>>2)]=$72; //@line 2231 "readclause.cpp"
              var $call155=__ZL4GetCv(); //@line 2232 "readclause.cpp"
              HEAP32[(($c1)>>2)]=$call155; //@line 2232 "readclause.cpp"
              __label__ = 59;continue ; //@line 2233 "readclause.cpp"
            }
  
            var $74=$n_xml_buf; //@line 2234 "readclause.cpp"
            var $arrayidx157=(($xml_buf+$74*4)&4294967295); //@line 2234 "readclause.cpp"
            HEAP32[(($arrayidx157)>>2)]=0; //@line 2234 "readclause.cpp"
            HEAP32[(($c2)>>2)]=32; //@line 2235 "readclause.cpp"
            $self_closing=0; //@line 2237 "readclause.cpp"
            var $75=$n_xml_buf; //@line 2238 "readclause.cpp"
            var $sub=((($75)-1)&4294967295); //@line 2238 "readclause.cpp"
            var $arrayidx158=(($xml_buf+$sub*4)&4294967295); //@line 2238 "readclause.cpp"
            var $76=HEAP32[(($arrayidx158)>>2)]; //@line 2238 "readclause.cpp"
            var $cmp159=((($76))|0)==47; //@line 2238 "readclause.cpp"
            if ($cmp159) { __label__ = 64;; } else { __label__ = 65;; } //@line 2238 "readclause.cpp"
            if (__label__ == 64) {
  
              var $77=$n_xml_buf; //@line 2241 "readclause.cpp"
              var $sub161=((($77)-1)&4294967295); //@line 2241 "readclause.cpp"
              var $arrayidx162=(($xml_buf+$sub161*4)&4294967295); //@line 2241 "readclause.cpp"
              HEAP32[(($arrayidx162)>>2)]=32; //@line 2241 "readclause.cpp"
              $self_closing=1; //@line 2242 "readclause.cpp"
              ; //@line 2243 "readclause.cpp"
            }
  
            var $78=$buf_addr; //@line 2245 "readclause.cpp"
            var $79=$n_buf_addr; //@line 2245 "readclause.cpp"
            var $80=$self_closing; //@line 2245 "readclause.cpp"
            var $call165=__ZL14ProcessSsmlTagPwPcRiii($arraydecay164, $78, $ix, $79, $80); //@line 2245 "readclause.cpp"
            $terminator=$call165; //@line 2245 "readclause.cpp"
            var $cmp166=((($call165))|0)!=0; //@line 2247 "readclause.cpp"
            if ($cmp166) { __label__ = 66;break $while_cond$12; } //@line 2247 "readclause.cpp"
  
            HEAP32[(($c1)>>2)]=32; //@line 2261 "readclause.cpp"
            var $call179=__ZL4GetCv(); //@line 2262 "readclause.cpp"
            HEAP32[(($c2)>>2)]=$call179; //@line 2262 "readclause.cpp"
            __label__ = 8;continue $while_cond$12; //@line 2263 "readclause.cpp"
          }
        }
      } while(0);
  
      HEAP32[((__ZL19ssml_ignore_l_angle)>>2)]=0; //@line 2267 "readclause.cpp"
      var $_b1=HEAPU8[(__ZL11ignore_text_b)];
      var $90=((($_b1))&1);
      var $tobool185=((($90))|0)!=0; //@line 2269 "readclause.cpp"
      if ($tobool185) { __label__ = 8;continue $while_cond$12; } //@line 2269 "readclause.cpp"
  
      var $91=HEAP32[(($c2)>>2)]; //@line 2272 "readclause.cpp"
      var $cmp188=((($91))|0)==10; //@line 2272 "readclause.cpp"
      var $92=HEAP32[((_option_linelength)>>2)]; //@line 2272 "readclause.cpp"
      var $cmp190=((($92))|0)==-1; //@line 2272 "readclause.cpp"
      var $or_cond11=($cmp188) & ($cmp190); //@line 2272 "readclause.cpp"
      var $93=HEAPU32[(($c1)>>2)]; //@line 2275 "readclause.cpp"
      if ($or_cond11) { __label__ = 74;break $while_cond$12; } //@line 2272 "readclause.cpp"
  
      var $cmp208=((($93))|0)==1; //@line 2291 "readclause.cpp"
      if ($cmp208) { __label__ = 80;; } else { __label__ = 79;; } //@line 2291 "readclause.cpp"
      $if_then212$$lor_lhs_false209$90: do { 
        if (__label__ == 79) {
  
          var $111=HEAP32[(($c1)>>2)]; //@line 2291 "readclause.cpp"
          var $112=HEAP8[(_ctrl_embedded)]; //@line 2291 "readclause.cpp"
          var $conv210=(tempInt=(($112)),(tempInt>=128?tempInt-256:tempInt)); //@line 2291 "readclause.cpp"
          var $cmp211=((($111))|0)==((($conv210))|0); //@line 2291 "readclause.cpp"
          if ($cmp211) { __label__ = 80;break $if_then212$$lor_lhs_false209$90; } else { __label__ = 97;break $if_then212$$lor_lhs_false209$90; } //@line 2291 "readclause.cpp"
        }
      } while(0);
      $if_then212$$if_end267$92: do { 
        if (__label__ == 80) {
  
          var $113=HEAP32[(($c2)>>2)]; //@line 2294 "readclause.cpp"
          var $cmp213=((($113))|0)==86; //@line 2294 "readclause.cpp"
          if ($cmp213) { __label__ = 81;break $while_cond$12; } //@line 2294 "readclause.cpp"
  
          var $123=HEAP32[(($c2)>>2)]; //@line 2303 "readclause.cpp"
          var $cmp236=((($123))|0)==66; //@line 2303 "readclause.cpp"
          if (!($cmp236)) { __label__ = 97;break $if_then212$$if_end267$92; } //@line 2303 "readclause.cpp"
  
          var $124=HEAP32[(($ix)>>2)]; //@line 2307 "readclause.cpp"
          var $125=$buf_addr; //@line 2307 "readclause.cpp"
          var $arrayidx238=(($125+$124)&4294967295); //@line 2307 "readclause.cpp"
          var $src$, $dest$, $stop$, $stop4$, $fast$;
          $src$ = ((__str41208)&4294967295);
          $dest$ = $arrayidx238;
          $stop$ = $src$ + 4;
          if (($dest$%4) == ($src$%4) && 4 > 8) {
            while ($src$%4 !== 0 && $src$ < $stop$) {
              ; HEAP8[$dest$++] = HEAP8[$src$++];
            }
            $src$ >>= 2;
            $dest$ >>= 2;
            $stop4$ = $stop$ >> 2;
            while ($src$ < $stop4$) {
          ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
            }
            $src$ <<= 2;
            $dest$ <<= 2;
          }while ($src$ < $stop$) {
            ; HEAP8[$dest$++] = HEAP8[$src$++];
          }; //@line 2307 "readclause.cpp"
          var $126=HEAP32[(($ix)>>2)]; //@line 2308 "readclause.cpp"
          var $add240=((($126)+3)&4294967295); //@line 2308 "readclause.cpp"
          HEAP32[(($ix)>>2)]=$add240; //@line 2308 "readclause.cpp"
          var $call241=__ZL4GetCv(); //@line 2310 "readclause.cpp"
          HEAP32[(($c2)>>2)]=$call241; //@line 2310 "readclause.cpp"
          var $cmp242=((($call241))|0)==48; //@line 2310 "readclause.cpp"
          if ($cmp242) { __label__ = 89;; } else { __label__ = 90;; } //@line 2310 "readclause.cpp"
          $if_then243$$if_else244$96: do { 
            if (__label__ == 89) {
  
              HEAP32[((_option_punctuation)>>2)]=0; //@line 2311 "readclause.cpp"
              ; //@line 2311 "readclause.cpp"
            }
            else if (__label__ == 90) {
  
              HEAP32[((_option_punctuation)>>2)]=1; //@line 2314 "readclause.cpp"
              HEAP32[((((_option_punctlist)&4294967295))>>2)]=0; //@line 2315 "readclause.cpp"
              var $127=HEAP32[(($c2)>>2)]; //@line 2316 "readclause.cpp"
              var $cmp245=((($127))|0)!=49; //@line 2316 "readclause.cpp"
              if (!($cmp245)) { __label__ = 96;break $if_then243$$if_else244$96; } //@line 2316 "readclause.cpp"
  
              $j=0; //@line 2319 "readclause.cpp"
              ; //@line 2320 "readclause.cpp"
              while(1) { 
  
                var $128=HEAP32[(($c2)>>2)]; //@line 2320 "readclause.cpp"
                var $call248=_iswspace($128); //@line 2320 "readclause.cpp"
                var $tobool249=((($call248))|0)!=0; //@line 2320 "readclause.cpp"
                if ($tobool249) { __label__ = 95;break ; } //@line 2320 "readclause.cpp"
  
                var $call251=__Z3Eofv(); //@line 2320 "readclause.cpp"
                var $tobool252=((($call251))|0)!=0; //@line 2320 "readclause.cpp"
                var $lnot=($tobool252) ^ 1; //@line 2320 "readclause.cpp"
                if (!($lnot)) { __label__ = 95;break ; }
  
                var $129=HEAP32[(($c2)>>2)]; //@line 2322 "readclause.cpp"
                var $130=$j; //@line 2322 "readclause.cpp"
                var $inc255=((($130)+1)&4294967295); //@line 2322 "readclause.cpp"
                $j=$inc255; //@line 2322 "readclause.cpp"
                var $arrayidx256=((_option_punctlist+$130*4)&4294967295); //@line 2322 "readclause.cpp"
                HEAP32[(($arrayidx256)>>2)]=$129; //@line 2322 "readclause.cpp"
                var $call257=__ZL4GetCv(); //@line 2323 "readclause.cpp"
                HEAP32[(($c2)>>2)]=$call257; //@line 2323 "readclause.cpp"
                var $131=HEAP32[(($ix)>>2)]; //@line 2324 "readclause.cpp"
                var $inc258=((($131)+1)&4294967295); //@line 2324 "readclause.cpp"
                HEAP32[(($ix)>>2)]=$inc258; //@line 2324 "readclause.cpp"
                var $132=$buf_addr; //@line 2324 "readclause.cpp"
                var $arrayidx259=(($132+$131)&4294967295); //@line 2324 "readclause.cpp"
                HEAP8[($arrayidx259)]=32; //@line 2324 "readclause.cpp"
                __label__ = 92;continue ; //@line 2325 "readclause.cpp"
              }
  
              var $133=$j; //@line 2326 "readclause.cpp"
              var $arrayidx261=((_option_punctlist+$133*4)&4294967295); //@line 2326 "readclause.cpp"
              HEAP32[(($arrayidx261)>>2)]=0; //@line 2326 "readclause.cpp"
              HEAP32[((_option_punctuation)>>2)]=2; //@line 2327 "readclause.cpp"
              ; //@line 2328 "readclause.cpp"
            }
          } while(0);
  
          var $call264=__ZL4GetCv(); //@line 2330 "readclause.cpp"
          HEAP32[(($c2)>>2)]=$call264; //@line 2330 "readclause.cpp"
          __label__ = 8;continue $while_cond$12; //@line 2331 "readclause.cpp"
        }
      } while(0);
  
      var $134=$linelength; //@line 2335 "readclause.cpp"
      var $inc268=((($134)+1)&4294967295); //@line 2335 "readclause.cpp"
      $linelength=$inc268; //@line 2335 "readclause.cpp"
      var $135=HEAP32[(($c1)>>2)]; //@line 2337 "readclause.cpp"
      var $call269=_iswalnum($135); //@line 2337 "readclause.cpp"
      var $tobool270=((($call269))|0)!=0; //@line 2337 "readclause.cpp"
      if ($tobool270) { __label__ = 98;; } else { __label__ = 99;; } //@line 2337 "readclause.cpp"
      $if_then271$$if_else272$107: do { 
        if (__label__ == 98) {
  
          $any_alnum=1; //@line 2338 "readclause.cpp"
          ; //@line 2338 "readclause.cpp"
        }
        else if (__label__ == 99) {
  
          var $136=$stressed_word; //@line 2341 "readclause.cpp"
          var $tobool273=((($136))|0)!=0; //@line 2341 "readclause.cpp"
          if ($tobool273) { __label__ = 100;; } else { __label__ = 101;; } //@line 2341 "readclause.cpp"
          if (__label__ == 100) {
  
            $stressed_word=0; //@line 2343 "readclause.cpp"
            HEAP32[(($c1)>>2)]=1328; //@line 2344 "readclause.cpp"
            var $137=HEAP32[(($c2)>>2)]; //@line 2345 "readclause.cpp"
            __ZL6UngetCi($137); //@line 2345 "readclause.cpp"
            HEAP32[(($c2)>>2)]=32; //@line 2346 "readclause.cpp"
            ; //@line 2347 "readclause.cpp"
          }
  
          var $138=HEAP32[(($c1)>>2)]; //@line 2349 "readclause.cpp"
          var $call276=__Z11lookupwcharPKti(((__ZL12chars_ignore)&4294967295), $138); //@line 2349 "readclause.cpp"
          var $tobool277=((($call276))|0)!=0; //@line 2349 "readclause.cpp"
          if ($tobool277) { __label__ = 8;continue $while_cond$12; } //@line 2349 "readclause.cpp"
  
          var $139=HEAP32[(($c1)>>2)]; //@line 2355 "readclause.cpp"
          var $call280=_iswspace($139); //@line 2355 "readclause.cpp"
          var $tobool281=((($call280))|0)!=0; //@line 2355 "readclause.cpp"
          if ($tobool281) { __label__ = 103;; } else { __label__ = 109;; } //@line 2355 "readclause.cpp"
          $if_then282$$if_end304$114: do { 
            if (__label__ == 103) {
  
              var $140=$tr_addr; //@line 2359 "readclause.cpp"
              var $translator_name=(($140+280)&4294967295); //@line 2359 "readclause.cpp"
              var $141=HEAP32[(($translator_name)>>2)]; //@line 2359 "readclause.cpp"
              var $cmp283=((($141))|0)==6972015; //@line 2359 "readclause.cpp"
              if (!($cmp283)) { __label__ = 109;break $if_then282$$if_end304$114; } //@line 2359 "readclause.cpp"
  
              var $142=HEAP32[(($ix)>>2)]; //@line 2363 "readclause.cpp"
              var $sub285=((($142)-1)&4294967295); //@line 2363 "readclause.cpp"
              var $143=$buf_addr; //@line 2363 "readclause.cpp"
              var $arrayidx286=(($143+$sub285)&4294967295); //@line 2363 "readclause.cpp"
              $p_word=$arrayidx286; //@line 2363 "readclause.cpp"
              var $144=$p_word; //@line 2364 "readclause.cpp"
              var $arrayidx287=(($144)&4294967295); //@line 2364 "readclause.cpp"
              var $145=HEAP8[($arrayidx287)]; //@line 2364 "readclause.cpp"
              var $conv288=(tempInt=(($145)),(tempInt>=128?tempInt-256:tempInt)); //@line 2364 "readclause.cpp"
              var $cmp289=((($conv288))|0)==105; //@line 2364 "readclause.cpp"
              if (!($cmp289)) { __label__ = 109;break $if_then282$$if_end304$114; } //@line 2364 "readclause.cpp"
  
              var $146=$p_word; //@line 2366 "readclause.cpp"
              var $arrayidx291=(($146+-1)&4294967295); //@line 2366 "readclause.cpp"
              var $147=HEAP8[($arrayidx291)]; //@line 2366 "readclause.cpp"
              var $conv292=(tempInt=(($147)),(tempInt>=128?tempInt-256:tempInt)); //@line 2366 "readclause.cpp"
              var $cmp293=((($conv292))|0)==46; //@line 2366 "readclause.cpp"
              if ($cmp293) { __label__ = 106;; } else { __label__ = 107;; } //@line 2366 "readclause.cpp"
              if (__label__ == 106) {
  
                var $148=$p_word; //@line 2367 "readclause.cpp"
                var $incdec_ptr=(($148+-1)&4294967295); //@line 2367 "readclause.cpp"
                $p_word=$incdec_ptr; //@line 2367 "readclause.cpp"
                ; //@line 2367 "readclause.cpp"
              }
  
              var $149=$p_word; //@line 2368 "readclause.cpp"
              var $arrayidx296=(($149+-1)&4294967295); //@line 2368 "readclause.cpp"
              var $150=HEAP8[($arrayidx296)]; //@line 2368 "readclause.cpp"
              var $conv297=(tempInt=(($150)),(tempInt>=128?tempInt-256:tempInt)); //@line 2368 "readclause.cpp"
              var $cmp298=((($conv297))|0)==32; //@line 2368 "readclause.cpp"
              if ($cmp298) { __label__ = 108;break $while_cond$12; } //@line 2368 "readclause.cpp"
            }
          } while(0);
  
          var $153=HEAP32[(($c1)>>2)]; //@line 2379 "readclause.cpp"
          var $cmp305=((($153))|0)==3405; //@line 2379 "readclause.cpp"
          if (!($cmp305)) { __label__ = 112;break $if_then271$$if_else272$107; } //@line 2379 "readclause.cpp"
  
          var $154=HEAP32[(($c2)>>2)]; //@line 2382 "readclause.cpp"
          var $cmp307=((($154))|0)==8205; //@line 2382 "readclause.cpp"
          if (!($cmp307)) { __label__ = 112;break $if_then271$$if_else272$107; } //@line 2382 "readclause.cpp"
  
          HEAP32[(($c1)>>2)]=3406; //@line 2384 "readclause.cpp"
          ; //@line 2385 "readclause.cpp"
        }
      } while(0);
  
      var $155=HEAP32[(($c1)>>2)]; //@line 2389 "readclause.cpp"
      var $call312=_iswupper($155); //@line 2389 "readclause.cpp"
      var $tobool313=((($call312))|0)!=0; //@line 2389 "readclause.cpp"
      if ($tobool313) { __label__ = 113;; } else { __label__ = 118;; } //@line 2389 "readclause.cpp"
      $if_then314$$if_else343$125: do { 
        if (__label__ == 113) {
  
          var $156=$tr_addr; //@line 2391 "readclause.cpp"
          var $clause_upper_count315=(($156+8304)&4294967295); //@line 2391 "readclause.cpp"
          var $157=HEAP32[(($clause_upper_count315)>>2)]; //@line 2391 "readclause.cpp"
          var $inc316=((($157)+1)&4294967295); //@line 2391 "readclause.cpp"
          HEAP32[(($clause_upper_count315)>>2)]=$inc316; //@line 2391 "readclause.cpp"
          var $158=HEAP32[((_option_capitals)>>2)]; //@line 2392 "readclause.cpp"
          var $cmp317=((($158))|0)==2; //@line 2392 "readclause.cpp"
          var $159=HEAP32[((__ZL10sayas_mode)>>2)]; //@line 2392 "readclause.cpp"
          var $cmp319=((($159))|0)==0; //@line 2392 "readclause.cpp"
          var $or_cond13=($cmp317) & ($cmp319); //@line 2392 "readclause.cpp"
          if (!($or_cond13)) { __label__ = 120;break $if_then314$$if_else343$125; } //@line 2392 "readclause.cpp"
  
          var $160=$cprev; //@line 2392 "readclause.cpp"
          var $call321=_iswupper($160); //@line 2392 "readclause.cpp"
          var $tobool322=((($call321))|0)!=0; //@line 2392 "readclause.cpp"
          if ($tobool322) { __label__ = 120;break $if_then314$$if_else343$125; } //@line 2392 "readclause.cpp"
  
          var $161=$tr_addr; //@line 2396 "readclause.cpp"
          var $call325=__ZL13LookupSpecialP10TranslatorPKcPc($161, $arraydecay324); //@line 2396 "readclause.cpp"
          var $cmp326=((($call325))|0)!=0; //@line 2396 "readclause.cpp"
          if (!($cmp326)) { __label__ = 120;break $if_then314$$if_else343$125; } //@line 2396 "readclause.cpp"
  
          var $strlen=_strlen($arraydecay329); //@line 2398 "readclause.cpp"
          var $leninc=((($strlen)+1)&4294967295); //@line 2398 "readclause.cpp"
          var $src$, $dest$, $stop$, $stop4$, $fast$;
          $src$ = $arraydecay329;
          $dest$ = $arraydecay328;
          $stop$ = $src$ + $leninc;
          if (($dest$%4) == ($src$%4) && $leninc > 8) {
            while ($src$%4 !== 0 && $src$ < $stop$) {
              ; HEAP8[$dest$++] = HEAP8[$src$++];
            }
            $src$ >>= 2;
            $dest$ >>= 2;
            $stop4$ = $stop$ >> 2;
            while ($src$ < $stop4$) {
          ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
            }
            $src$ <<= 2;
            $dest$ <<= 2;
          }while ($src$ < $stop$) {
            ; HEAP8[$dest$++] = HEAP8[$src$++];
          }; //@line 2398 "readclause.cpp"
          var $call332=_strlen($arraydecay331); //@line 2399 "readclause.cpp"
          $j=$call332; //@line 2399 "readclause.cpp"
          var $162=HEAP32[(($ix)>>2)]; //@line 2400 "readclause.cpp"
          var $163=$j; //@line 2400 "readclause.cpp"
          var $add333=((($163)+($162))&4294967295); //@line 2400 "readclause.cpp"
          var $164=$n_buf_addr; //@line 2400 "readclause.cpp"
          var $cmp334=((($add333))|0) < ((($164))|0); //@line 2400 "readclause.cpp"
          if (!($cmp334)) { __label__ = 120;break $if_then314$$if_else343$125; } //@line 2400 "readclause.cpp"
  
          var $165=HEAP32[(($ix)>>2)]; //@line 2402 "readclause.cpp"
          var $166=$buf_addr; //@line 2402 "readclause.cpp"
          var $arrayidx336=(($166+$165)&4294967295); //@line 2402 "readclause.cpp"
          var $call338=_strcpy($arrayidx336, $arraydecay337); //@line 2402 "readclause.cpp"
          var $167=$j; //@line 2403 "readclause.cpp"
          var $168=HEAP32[(($ix)>>2)]; //@line 2403 "readclause.cpp"
          var $add339=((($168)+($167))&4294967295); //@line 2403 "readclause.cpp"
          HEAP32[(($ix)>>2)]=$add339; //@line 2403 "readclause.cpp"
          ; //@line 2404 "readclause.cpp"
        }
        else if (__label__ == 118) {
  
          var $169=HEAP32[(($c1)>>2)]; //@line 2409 "readclause.cpp"
          var $call344=_iswalpha($169); //@line 2409 "readclause.cpp"
          var $tobool345=((($call344))|0)!=0; //@line 2409 "readclause.cpp"
          if (!($tobool345)) { __label__ = 120;break $if_then314$$if_else343$125; } //@line 2409 "readclause.cpp"
  
          var $170=$tr_addr; //@line 2410 "readclause.cpp"
          var $clause_lower_count347=(($170+8308)&4294967295); //@line 2410 "readclause.cpp"
          var $171=HEAP32[(($clause_lower_count347)>>2)]; //@line 2410 "readclause.cpp"
          var $inc348=((($171)+1)&4294967295); //@line 2410 "readclause.cpp"
          HEAP32[(($clause_lower_count347)>>2)]=$inc348; //@line 2410 "readclause.cpp"
          ; //@line 2410 "readclause.cpp"
        }
      } while(0);
  
      var $172=HEAP32[((_option_phoneme_input)>>2)]; //@line 2412 "readclause.cpp"
      var $tobool351=((($172))|0)!=0; //@line 2412 "readclause.cpp"
      if ($tobool351) { __label__ = 121;; } else { __label__ = 130;; } //@line 2412 "readclause.cpp"
      $if_then352$$if_end368$134: do { 
        if (__label__ == 121) {
  
          var $173=$phoneme_mode; //@line 2414 "readclause.cpp"
          var $cmp353=((($173))|0) > 0; //@line 2414 "readclause.cpp"
          if ($cmp353) { __label__ = 122;; } else { __label__ = 123;; } //@line 2414 "readclause.cpp"
          if (__label__ == 122) {
  
            var $174=$phoneme_mode; //@line 2415 "readclause.cpp"
            var $dec=((($174)-1)&4294967295); //@line 2415 "readclause.cpp"
            $phoneme_mode=$dec; //@line 2415 "readclause.cpp"
            ; //@line 2415 "readclause.cpp"
          }
          else if (__label__ == 123) {
  
            var $175=HEAP32[(($c1)>>2)]; //@line 2417 "readclause.cpp"
            var $cmp356=((($175))|0)==91; //@line 2417 "readclause.cpp"
            if ($cmp356) { __lastLabel__ = 123; __label__ = 124;; } else { __lastLabel__ = 123; __label__ = 127;; } //@line 2417 "readclause.cpp"
            if (__label__ == 124) {
  
              var $176=HEAP32[(($c2)>>2)]; //@line 2417 "readclause.cpp"
              var $cmp358=((($176))|0)==91; //@line 2417 "readclause.cpp"
              if ($cmp358) { __label__ = 125;; } else { __label__ = 126;; } //@line 2417 "readclause.cpp"
              if (__label__ == 125) {
  
                $phoneme_mode=-1; //@line 2418 "readclause.cpp"
                __label__ = 130;break $if_then352$$if_end368$134; //@line 2418 "readclause.cpp"
              }
              else if (__label__ == 126) {
  
                var $_pr25=HEAP32[(($c1)>>2)]; //@line 2420 "readclause.cpp"
                __lastLabel__ = 126; ;
              }
            }
  
            var $177=__lastLabel__ == 126 ? $_pr25 : ($175); //@line 2420 "readclause.cpp"
            var $cmp361=((($177))|0)==93; //@line 2420 "readclause.cpp"
            if (!($cmp361)) { __label__ = 130;break $if_then352$$if_end368$134; } //@line 2420 "readclause.cpp"
  
            var $178=HEAP32[(($c2)>>2)]; //@line 2420 "readclause.cpp"
            var $cmp363=((($178))|0)==93; //@line 2420 "readclause.cpp"
            if (!($cmp363)) { __label__ = 130;break $if_then352$$if_end368$134; } //@line 2420 "readclause.cpp"
  
            $phoneme_mode=2; //@line 2421 "readclause.cpp"
            ; //@line 2421 "readclause.cpp"
          }
        }
      } while(0);
  
      var $179=HEAP32[(($c1)>>2)]; //@line 2424 "readclause.cpp"
      var $cmp369=((($179))|0)==10; //@line 2424 "readclause.cpp"
      if ($cmp369) { __label__ = 131;; } else { __label__ = 148;; } //@line 2424 "readclause.cpp"
      if (__label__ == 131) {
  
        $parag=0; //@line 2426 "readclause.cpp"
        ; //@line 2429 "readclause.cpp"
        while(1) { 
  
          var $call372=__Z3Eofv(); //@line 2429 "readclause.cpp"
          var $tobool373=((($call372))|0)!=0; //@line 2429 "readclause.cpp"
          if ($tobool373) { __label__ = 137;break ; } //@line 2429 "readclause.cpp"
  
          var $180=HEAP32[(($c2)>>2)]; //@line 2429 "readclause.cpp"
          var $call375=_iswspace($180); //@line 2429 "readclause.cpp"
          var $tobool376=((($call375))|0)!=0; //@line 2429 "readclause.cpp"
          if (!($tobool376)) { __label__ = 137;break ; }
  
          var $181=HEAP32[(($c2)>>2)]; //@line 2431 "readclause.cpp"
          var $cmp379=((($181))|0)==10; //@line 2431 "readclause.cpp"
          if ($cmp379) { __label__ = 135;; } else { __label__ = 136;; } //@line 2431 "readclause.cpp"
          if (__label__ == 135) {
  
            var $182=$parag; //@line 2432 "readclause.cpp"
            var $inc381=((($182)+1)&4294967295); //@line 2432 "readclause.cpp"
            $parag=$inc381; //@line 2432 "readclause.cpp"
            ; //@line 2432 "readclause.cpp"
          }
  
          var $call383=__ZL4GetCv(); //@line 2433 "readclause.cpp"
          HEAP32[(($c2)>>2)]=$call383; //@line 2433 "readclause.cpp"
          __label__ = 132;continue ; //@line 2434 "readclause.cpp"
        }
  
        var $183=$parag; //@line 2435 "readclause.cpp"
        var $cmp385=((($183))|0) > 0; //@line 2435 "readclause.cpp"
        if ($cmp385) { __label__ = 138;break $while_cond$12; } //@line 2435 "readclause.cpp"
  
        var $195=$linelength; //@line 2452 "readclause.cpp"
        var $196=HEAP32[((_option_linelength)>>2)]; //@line 2452 "readclause.cpp"
        var $cmp402=((($195))|0) <= ((($196))|0); //@line 2452 "readclause.cpp"
        if ($cmp402) { __label__ = 146;break $while_cond$12; } //@line 2452 "readclause.cpp"
  
        $linelength=0; //@line 2461 "readclause.cpp"
        ; //@line 2462 "readclause.cpp"
      }
  
      var $202=$announced_punctuation; //@line 2464 "readclause.cpp"
      $prev_announced_punctuation=$202; //@line 2464 "readclause.cpp"
      $announced_punctuation=0; //@line 2465 "readclause.cpp"
      var $203=$phoneme_mode; //@line 2467 "readclause.cpp"
      var $cmp409=((($203))|0)==0; //@line 2467 "readclause.cpp"
      var $204=HEAP32[((__ZL10sayas_mode)>>2)]; //@line 2467 "readclause.cpp"
      var $cmp411=((($204))|0)==0; //@line 2467 "readclause.cpp"
      var $or_cond14=($cmp409) & ($cmp411); //@line 2467 "readclause.cpp"
      if ($or_cond14) { __label__ = 149;; } else { __label__ = 238;; } //@line 2467 "readclause.cpp"
      $if_then412$$if_end643$161: do { 
        if (__label__ == 149) {
  
          $is_end_clause=0; //@line 2469 "readclause.cpp"
          var $205=$end_clause_after_tag; //@line 2471 "readclause.cpp"
          var $tobool413=((($205))|0)!=0; //@line 2471 "readclause.cpp"
          if ($tobool413) { __label__ = 150;; } else { __label__ = 155;; } //@line 2471 "readclause.cpp"
          $if_then414$$if_end429$163: do { 
            if (__label__ == 150) {
  
              var $206=HEAP32[(($c1)>>2)]; //@line 2477 "readclause.cpp"
              var $call415=_iswspace($206); //@line 2477 "readclause.cpp"
              var $tobool416=((($call415))|0)!=0; //@line 2477 "readclause.cpp"
              if ($tobool416) { __label__ = 155;break $if_then414$$if_end429$163; } //@line 2477 "readclause.cpp"
  
              var $207=HEAP32[(($c1)>>2)]; //@line 2479 "readclause.cpp"
              var $call418=__Z7IsAlphaj($207); //@line 2479 "readclause.cpp"
              var $tobool419=((($call418))|0)!=0; //@line 2479 "readclause.cpp"
              if (!($tobool419)) { __label__ = 153;break $while_cond$12; } //@line 2479 "readclause.cpp"
  
              var $208=HEAP32[(($c1)>>2)]; //@line 2479 "readclause.cpp"
              var $call421=_iswlower($208); //@line 2479 "readclause.cpp"
              var $tobool422=((($call421))|0)!=0; //@line 2479 "readclause.cpp"
              if (!($tobool422)) { __label__ = 153;break $while_cond$12; } //@line 2479 "readclause.cpp"
  
              $end_clause_after_tag=0; //@line 2488 "readclause.cpp"
              ; //@line 2489 "readclause.cpp"
            }
          } while(0);
  
          var $216=HEAP32[(($c1)>>2)]; //@line 2492 "readclause.cpp"
          var $cmp430=((($216))|0)==46; //@line 2492 "readclause.cpp"
          if ($cmp430) { __label__ = 156;; } else { __label__ = 162;; } //@line 2492 "readclause.cpp"
          $land_lhs_true431$$if_end443$169: do { 
            if (__label__ == 156) {
  
              var $217=HEAP32[(($c2)>>2)]; //@line 2492 "readclause.cpp"
              var $cmp432=((($217))|0)==46; //@line 2492 "readclause.cpp"
              if (!($cmp432)) { __label__ = 162;break $land_lhs_true431$$if_end443$169; } //@line 2492 "readclause.cpp"
  
              var $call43538=__ZL4GetCv(); //@line 2494 "readclause.cpp"
              $c_next=$call43538; //@line 2494 "readclause.cpp"
              var $cmp43639=((($call43538))|0)==46; //@line 2494 "readclause.cpp"
              if ($cmp43639) { __label__ = 158;; } else { __label__ = 159;; } //@line 2494 "readclause.cpp"
              $while_body437$$while_end438$172: do { 
                if (__label__ == 158) {
                  while(1) { 
  
                    HEAP32[(($c1)>>2)]=8230; //@line 2497 "readclause.cpp"
                    HEAP32[(($c2)>>2)]=32; //@line 2498 "readclause.cpp"
                    var $call435=__ZL4GetCv(); //@line 2494 "readclause.cpp"
                    $c_next=$call435; //@line 2494 "readclause.cpp"
                    var $cmp436=((($call435))|0)==46; //@line 2494 "readclause.cpp"
                    if ($cmp436) { __label__ = 158;continue ; } else { __label__ = 159;break $while_body437$$while_end438$172; } //@line 2494 "readclause.cpp"
                  }
                }
              } while(0);
  
              var $218=HEAP32[(($c1)>>2)]; //@line 2500 "readclause.cpp"
              var $cmp439=((($218))|0)==8230; //@line 2500 "readclause.cpp"
              var $219=$c_next; //@line 2501 "readclause.cpp"
              if ($cmp439) { __label__ = 160;; } else { __label__ = 161;; } //@line 2500 "readclause.cpp"
              if (__label__ == 160) {
  
                HEAP32[(($c2)>>2)]=$219; //@line 2501 "readclause.cpp"
                ; //@line 2501 "readclause.cpp"
              }
              else if (__label__ == 161) {
  
                __ZL6UngetCi($219); //@line 2503 "readclause.cpp"
                ;
              }
            }
          } while(0);
  
          $punct_data=0; //@line 2506 "readclause.cpp"
          var $220=HEAP32[(($c1)>>2)]; //@line 2507 "readclause.cpp"
          var $call444=__Z11lookupwcharPKti(((__ZL11punct_chars)&4294967295), $220); //@line 2507 "readclause.cpp"
          $punct=$call444; //@line 2507 "readclause.cpp"
          var $cmp445=((($call444))|0)!=0; //@line 2507 "readclause.cpp"
          if ($cmp445) { __label__ = 163;; } else { __label__ = 171;; } //@line 2507 "readclause.cpp"
          $if_then446$$if_end471$180: do { 
            if (__label__ == 163) {
  
              var $221=$punct; //@line 2509 "readclause.cpp"
              var $arrayidx447=((__ZL16punct_attributes+$221*4)&4294967295); //@line 2509 "readclause.cpp"
              var $222=HEAP32[(($arrayidx447)>>2)]; //@line 2509 "readclause.cpp"
              $punct_data=$222; //@line 2509 "readclause.cpp"
              var $223=$punct_data; //@line 2511 "readclause.cpp"
              var $and448=($223) & 1048576; //@line 2511 "readclause.cpp"
              var $tobool449=((($and448))|0)!=0; //@line 2511 "readclause.cpp"
              if ($tobool449) { __label__ = 164;; } else { __label__ = 165;; } //@line 2511 "readclause.cpp"
              if (__label__ == 164) {
  
                $stressed_word=1; //@line 2514 "readclause.cpp"
                var $224=$punct_data; //@line 2515 "readclause.cpp"
                var $shr=($224) >> 12; //@line 2515 "readclause.cpp"
                var $and451=($shr) & 15; //@line 2515 "readclause.cpp"
                var $225=$tone_type_addr; //@line 2515 "readclause.cpp"
                HEAP32[(($225)>>2)]=$and451; //@line 2515 "readclause.cpp"
                __label__ = 8;continue $while_cond$12; //@line 2516 "readclause.cpp"
              }
              else if (__label__ == 165) {
  
                var $226=HEAP32[(($c2)>>2)]; //@line 2519 "readclause.cpp"
                var $call453=_iswspace($226); //@line 2519 "readclause.cpp"
                var $tobool454=((($call453))|0)!=0; //@line 2519 "readclause.cpp"
                if ($tobool454) { __label__ = 170;; } else { __label__ = 166;; } //@line 2519 "readclause.cpp"
                $if_then469$$lor_lhs_false455$185: do { 
                  if (__label__ == 166) {
  
                    var $227=$punct_data; //@line 2519 "readclause.cpp"
                    var $and456=($227) & 32768; //@line 2519 "readclause.cpp"
                    var $tobool457=((($and456))|0)!=0; //@line 2519 "readclause.cpp"
                    if ($tobool457) { __label__ = 170;break $if_then469$$lor_lhs_false455$185; } //@line 2519 "readclause.cpp"
  
                    var $228=HEAP32[(($c2)>>2)]; //@line 2519 "readclause.cpp"
                    var $call459=__Z9IsBracketi($228); //@line 2519 "readclause.cpp"
                    var $tobool460=((($call459))|0)!=0; //@line 2519 "readclause.cpp"
                    var $229=HEAP32[(($c2)>>2)]; //@line 2519 "readclause.cpp"
                    var $cmp462=((($229))|0)==63; //@line 2519 "readclause.cpp"
                    var $or_cond15=($tobool460) | ($cmp462); //@line 2519 "readclause.cpp"
                    if ($or_cond15) { __label__ = 170;break $if_then469$$lor_lhs_false455$185; } //@line 2519 "readclause.cpp"
  
                    var $call464=__Z3Eofv(); //@line 2519 "readclause.cpp"
                    var $tobool465=((($call464))|0)!=0; //@line 2519 "readclause.cpp"
                    if ($tobool465) { __label__ = 170;break $if_then469$$lor_lhs_false455$185; } //@line 2519 "readclause.cpp"
  
                    var $230=HEAP32[(($c2)>>2)]; //@line 2519 "readclause.cpp"
                    var $231=HEAP8[(_ctrl_embedded)]; //@line 2519 "readclause.cpp"
                    var $conv467=(tempInt=(($231)),(tempInt>=128?tempInt-256:tempInt)); //@line 2519 "readclause.cpp"
                    var $cmp468=((($230))|0)==((($conv467))|0); //@line 2519 "readclause.cpp"
                    if (!($cmp468)) { __label__ = 171;break $if_then446$$if_end471$180; } //@line 2519 "readclause.cpp"
                  }
                } while(0);
  
                $is_end_clause=1; //@line 2523 "readclause.cpp"
                ; //@line 2524 "readclause.cpp"
              }
            }
          } while(0);
  
          var $232=HEAP32[(($c1)>>2)]; //@line 2528 "readclause.cpp"
          var $cmp472=((($232))|0)==57404; //@line 2528 "readclause.cpp"
          if ($cmp472) { __label__ = 172;; } else { __label__ = 173;; } //@line 2528 "readclause.cpp"
          if (__label__ == 172) {
  
            HEAP32[(($c1)>>2)]=60; //@line 2528 "readclause.cpp"
            ; //@line 2528 "readclause.cpp"
          }
  
          var $233=HEAP32[((_option_punctuation)>>2)]; //@line 2529 "readclause.cpp"
          var $tobool475=((($233))|0)!=0; //@line 2529 "readclause.cpp"
          if ($tobool475) { __label__ = 174;; } else { __label__ = 181;; } //@line 2529 "readclause.cpp"
          $land_lhs_true476$$if_end493$195: do { 
            if (__label__ == 174) {
  
              var $234=HEAP32[(($c1)>>2)]; //@line 2529 "readclause.cpp"
              var $call477=_iswpunct($234); //@line 2529 "readclause.cpp"
              var $tobool478=((($call477))|0)!=0; //@line 2529 "readclause.cpp"
              if (!($tobool478)) { __label__ = 181;break $land_lhs_true476$$if_end493$195; } //@line 2529 "readclause.cpp"
  
              var $_b2=HEAPU8[(__ZL10audio_text_b)];
              var $235=((($_b2))&1);
              var $cmp480=((($235))|0)==0; //@line 2529 "readclause.cpp"
              if (!($cmp480)) { __label__ = 181;break $land_lhs_true476$$if_end493$195; } //@line 2529 "readclause.cpp"
  
              var $236=HEAP32[((_option_punctuation)>>2)]; //@line 2533 "readclause.cpp"
              var $cmp482=((($236))|0)==1; //@line 2533 "readclause.cpp"
              if ($cmp482) { __label__ = 178;; } else { __label__ = 177;; } //@line 2533 "readclause.cpp"
              if (__label__ == 177) {
  
                var $237=HEAP32[(($c1)>>2)]; //@line 2533 "readclause.cpp"
                var $call484=_wcschr(((_option_punctlist)&4294967295), $237); //@line 2533 "readclause.cpp"
                var $cmp485=((($call484))|0)!=0; //@line 2533 "readclause.cpp"
                if (!($cmp485)) { __label__ = 181;break $land_lhs_true476$$if_end493$195; } //@line 2533 "readclause.cpp"
              }
  
              var $238=$tr_addr; //@line 2535 "readclause.cpp"
              var $phonemes_repeat_count487=(($238+652)&4294967295); //@line 2535 "readclause.cpp"
              HEAP32[(($phonemes_repeat_count487)>>2)]=0; //@line 2535 "readclause.cpp"
              var $239=$tr_addr; //@line 2536 "readclause.cpp"
              var $240=HEAP32[(($c1)>>2)]; //@line 2536 "readclause.cpp"
              var $241=$buf_addr; //@line 2536 "readclause.cpp"
              var $242=$is_end_clause; //@line 2536 "readclause.cpp"
              var $call488=__ZL19AnnouncePunctuationP10TranslatoriPiPcS1_i($239, $240, $c2, $241, $ix, $242); //@line 2536 "readclause.cpp"
              $terminator=$call488; //@line 2536 "readclause.cpp"
              var $cmp489=((($call488))|0) >= 0; //@line 2536 "readclause.cpp"
              if ($cmp489) { __label__ = 179;break $while_cond$12; } //@line 2536 "readclause.cpp"
  
              var $244=HEAP32[(($c1)>>2)]; //@line 2538 "readclause.cpp"
              $announced_punctuation=$244; //@line 2538 "readclause.cpp"
              ; //@line 2539 "readclause.cpp"
            }
          } while(0);
  
          var $245=$punct_data; //@line 2542 "readclause.cpp"
          var $and494=($245) & 2097152; //@line 2542 "readclause.cpp"
          var $tobool495=((($and494))|0)!=0; //@line 2542 "readclause.cpp"
          if ($tobool495) { __label__ = 182;; } else { __label__ = 185;; } //@line 2542 "readclause.cpp"
          $land_lhs_true496$$if_end510$204: do { 
            if (__label__ == 182) {
  
              var $246=$announced_punctuation; //@line 2542 "readclause.cpp"
              var $cmp497=((($246))|0)==0; //@line 2542 "readclause.cpp"
              if (!($cmp497)) { __label__ = 185;break $land_lhs_true496$$if_end510$204; } //@line 2542 "readclause.cpp"
  
              var $247=HEAP32[(($ix)>>2)]; //@line 2547 "readclause.cpp"
              var $248=$buf_addr; //@line 2547 "readclause.cpp"
              var $arrayidx499=(($248+$247)&4294967295); //@line 2547 "readclause.cpp"
              $p2=$arrayidx499; //@line 2547 "readclause.cpp"
              var $249=$p2; //@line 2548 "readclause.cpp"
              var $250=$tr_addr; //@line 2548 "readclause.cpp"
              var $251=HEAP32[(($c1)>>2)]; //@line 2548 "readclause.cpp"
              __ZL14LookupCharNameP10Translatorii($250, $251, 1); //@line 2548 "readclause.cpp"
              var $strlen20=_strlen(((__ZZL14LookupCharNameP10TranslatoriiE3buf)&4294967295)); //@line 2548 "readclause.cpp"
              var $leninc21=((($strlen20)+1)&4294967295); //@line 2548 "readclause.cpp"
              var $src$, $dest$, $stop$, $stop4$, $fast$;
              $src$ = ((__ZZL14LookupCharNameP10TranslatoriiE3buf)&4294967295);
              $dest$ = $249;
              $stop$ = $src$ + $leninc21;
              if (($dest$%4) == ($src$%4) && $leninc21 > 8) {
                while ($src$%4 !== 0 && $src$ < $stop$) {
                  ; HEAP8[$dest$++] = HEAP8[$src$++];
                }
                $src$ >>= 2;
                $dest$ >>= 2;
                $stop4$ = $stop$ >> 2;
                while ($src$ < $stop4$) {
              ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
                }
                $src$ <<= 2;
                $dest$ <<= 2;
              }while ($src$ < $stop$) {
                ; HEAP8[$dest$++] = HEAP8[$src$++];
              }; //@line 2548 "readclause.cpp"
              var $252=$p2; //@line 2549 "readclause.cpp"
              var $arrayidx502=(($252)&4294967295); //@line 2549 "readclause.cpp"
              var $253=HEAP8[($arrayidx502)]; //@line 2549 "readclause.cpp"
              var $conv503=(tempInt=(($253)),(tempInt>=128?tempInt-256:tempInt)); //@line 2549 "readclause.cpp"
              var $cmp504=((($conv503))|0)!=0; //@line 2549 "readclause.cpp"
              if (!($cmp504)) { __label__ = 185;break $land_lhs_true496$$if_end510$204; } //@line 2549 "readclause.cpp"
  
              var $254=$p2; //@line 2551 "readclause.cpp"
              var $call506=_strlen($254); //@line 2551 "readclause.cpp"
              var $255=HEAP32[(($ix)>>2)]; //@line 2551 "readclause.cpp"
              var $add507=((($255)+($call506))&4294967295); //@line 2551 "readclause.cpp"
              HEAP32[(($ix)>>2)]=$add507; //@line 2551 "readclause.cpp"
              var $256=HEAP32[(($c1)>>2)]; //@line 2552 "readclause.cpp"
              $announced_punctuation=$256; //@line 2552 "readclause.cpp"
              var $257=$punct_data; //@line 2553 "readclause.cpp"
              var $and508=($257) & -28673; //@line 2553 "readclause.cpp"
              $punct_data=$and508; //@line 2553 "readclause.cpp"
              ; //@line 2554 "readclause.cpp"
            }
          } while(0);
  
          var $258=$is_end_clause; //@line 2557 "readclause.cpp"
          var $tobool511=((($258))|0)!=0; //@line 2557 "readclause.cpp"
          if (!($tobool511)) { __label__ = 238;break $if_then412$$if_end643$161; } //@line 2557 "readclause.cpp"
  
          $nl_count=0; //@line 2559 "readclause.cpp"
          var $259=HEAP32[(($c2)>>2)]; //@line 2560 "readclause.cpp"
          $c_next=$259; //@line 2560 "readclause.cpp"
          var $260=$c_next; //@line 2562 "readclause.cpp"
          var $call513=_iswspace($260); //@line 2562 "readclause.cpp"
          var $tobool514=((($call513))|0)!=0; //@line 2562 "readclause.cpp"
          if ($tobool514) { __label__ = 187;; } else { __label__ = 192;; } //@line 2562 "readclause.cpp"
          $while_cond516$$if_end530$210: do { 
            if (__label__ == 187) {
              while(1) { 
  
                var $call517=__Z3Eofv(); //@line 2564 "readclause.cpp"
                var $tobool518=((($call517))|0)!=0; //@line 2564 "readclause.cpp"
                if ($tobool518) { __label__ = 192;break $while_cond516$$if_end530$210; } //@line 2564 "readclause.cpp"
  
                var $261=$c_next; //@line 2564 "readclause.cpp"
                var $call520=_iswspace($261); //@line 2564 "readclause.cpp"
                var $tobool521=((($call520))|0)!=0; //@line 2564 "readclause.cpp"
                if (!($tobool521)) { __label__ = 192;break $while_cond516$$if_end530$210; }
  
                var $262=$c_next; //@line 2566 "readclause.cpp"
                var $cmp524=((($262))|0)==10; //@line 2566 "readclause.cpp"
                if ($cmp524) { __label__ = 190;; } else { __label__ = 191;; } //@line 2566 "readclause.cpp"
                if (__label__ == 190) {
  
                  var $263=$nl_count; //@line 2567 "readclause.cpp"
                  var $inc526=((($263)+1)&4294967295); //@line 2567 "readclause.cpp"
                  $nl_count=$inc526; //@line 2567 "readclause.cpp"
                  ; //@line 2567 "readclause.cpp"
                }
  
                var $call528=__ZL4GetCv(); //@line 2568 "readclause.cpp"
                $c_next=$call528; //@line 2568 "readclause.cpp"
                __label__ = 187;continue ; //@line 2569 "readclause.cpp"
              }
            }
          } while(0);
  
          var $264=HEAP32[(($c1)>>2)]; //@line 2572 "readclause.cpp"
          var $cmp531=((($264))|0)==46; //@line 2572 "readclause.cpp"
          if ($cmp531) { __label__ = 193;; } else { __label__ = 195;; } //@line 2572 "readclause.cpp"
          $land_lhs_true532$$if_end535$219: do { 
            if (__label__ == 193) {
  
              var $265=$nl_count; //@line 2572 "readclause.cpp"
              var $cmp533=((($265))|0) < 2; //@line 2572 "readclause.cpp"
              if (!($cmp533)) { __label__ = 226;break $land_lhs_true532$$if_end535$219; } //@line 2572 "readclause.cpp"
  
              var $266=$punct_data; //@line 2574 "readclause.cpp"
              var $or=($266) | 4194304; //@line 2574 "readclause.cpp"
              $punct_data=$or; //@line 2574 "readclause.cpp"
              __label__ = 195;break $land_lhs_true532$$if_end535$219; //@line 2575 "readclause.cpp"
            }
          } while(0);
          $if_end535$$if_end609$222: do { 
            if (__label__ == 195) {
  
              var $_pr26=$nl_count; //@line 2577 "readclause.cpp"
              var $cmp536=((($_pr26))|0)==0; //@line 2577 "readclause.cpp"
              if (!($cmp536)) { __label__ = 226;break $if_end535$$if_end609$222; } //@line 2577 "readclause.cpp"
  
              var $267=HEAP32[(($c1)>>2)]; //@line 2579 "readclause.cpp"
              var $cmp538=((($267))|0)==44; //@line 2579 "readclause.cpp"
              if ($cmp538) { __lastLabel__ = 196; __label__ = 197;; } else { __lastLabel__ = 196; __label__ = 204;; } //@line 2579 "readclause.cpp"
              $land_lhs_true539$$if_end554$225: do { 
                if (__label__ == 197) {
  
                  var $268=$cprev; //@line 2579 "readclause.cpp"
                  var $cmp540=((($268))|0)==46; //@line 2579 "readclause.cpp"
                  if ($cmp540) { __label__ = 198;; } else { __label__ = 203;; } //@line 2579 "readclause.cpp"
                  $land_lhs_true541$$if_end554thread_pre_split$227: do { 
                    if (__label__ == 198) {
  
                      var $269=$tr_addr; //@line 2579 "readclause.cpp"
                      var $translator_name542=(($269+280)&4294967295); //@line 2579 "readclause.cpp"
                      var $270=HEAP32[(($translator_name542)>>2)]; //@line 2579 "readclause.cpp"
                      var $cmp543=((($270))|0)==26741; //@line 2579 "readclause.cpp"
                      if (!($cmp543)) { __label__ = 203;break $land_lhs_true541$$if_end554thread_pre_split$227; } //@line 2579 "readclause.cpp"
  
                      var $271=$cprev2; //@line 2579 "readclause.cpp"
                      var $call545=_iswdigit($271); //@line 2579 "readclause.cpp"
                      var $tobool546=((($call545))|0)!=0; //@line 2579 "readclause.cpp"
                      if (!($tobool546)) { __label__ = 203;break $land_lhs_true541$$if_end554thread_pre_split$227; } //@line 2579 "readclause.cpp"
  
                      var $272=$c_next; //@line 2579 "readclause.cpp"
                      var $call548=_iswdigit($272); //@line 2579 "readclause.cpp"
                      var $tobool549=((($call548))|0)!=0; //@line 2579 "readclause.cpp"
                      if ($tobool549) { __label__ = 202;; } else { __label__ = 201;; } //@line 2579 "readclause.cpp"
                      if (__label__ == 201) {
  
                        var $273=$c_next; //@line 2579 "readclause.cpp"
                        var $call551=_iswlower($273); //@line 2579 "readclause.cpp"
                        var $tobool552=((($call551))|0)!=0; //@line 2579 "readclause.cpp"
                        if (!($tobool552)) { __label__ = 203;break $land_lhs_true541$$if_end554thread_pre_split$227; } //@line 2579 "readclause.cpp"
                      }
  
                      HEAP32[(($c1)>>2)]=1367; //@line 2582 "readclause.cpp"
                      $is_end_clause=0; //@line 2583 "readclause.cpp"
                      __label__ = 220;break $land_lhs_true539$$if_end554$225; //@line 2586 "readclause.cpp"
                    }
                  } while(0);
  
                  var $_pr28=HEAP32[(($c1)>>2)]; //@line 2586 "readclause.cpp"
                  __lastLabel__ = 203; __label__ = 204;break $land_lhs_true539$$if_end554$225;
                }
              } while(0);
              $if_else595$$if_end554$235: do { 
                if (__label__ == 204) {
  
                  var $274=__lastLabel__ == 203 ? $_pr28 : ($267); //@line 2586 "readclause.cpp"
                  var $cmp555=((($274))|0)==46; //@line 2586 "readclause.cpp"
                  if (!($cmp555)) { __label__ = 220;break $if_else595$$if_end554$235; } //@line 2586 "readclause.cpp"
  
                  var $275=$tr_addr; //@line 2588 "readclause.cpp"
                  var $langopts=(($275)&4294967295); //@line 2588 "readclause.cpp"
                  var $numbers=(($langopts+184)&4294967295); //@line 2588 "readclause.cpp"
                  var $276=HEAP32[(($numbers)>>2)]; //@line 2588 "readclause.cpp"
                  var $and557=($276) & 65536; //@line 2588 "readclause.cpp"
                  var $tobool558=((($and557))|0)!=0; //@line 2588 "readclause.cpp"
                  if ($tobool558) { __label__ = 206;; } else { __label__ = 214;; } //@line 2588 "readclause.cpp"
                  $land_lhs_true559$$if_else583$238: do { 
                    if (__label__ == 206) {
  
                      var $277=$cprev; //@line 2589 "readclause.cpp"
                      var $call560=_iswdigit($277); //@line 2589 "readclause.cpp"
                      var $tobool561=((($call560))|0)!=0; //@line 2589 "readclause.cpp"
                      if ($tobool561) { __label__ = 210;; } else { __label__ = 207;; } //@line 2589 "readclause.cpp"
                      $if_then571$$lor_lhs_false562$240: do { 
                        if (__label__ == 207) {
  
                          var $278=$cprev; //@line 2589 "readclause.cpp"
                          var $call563=__ZL8IsRomanUj($278); //@line 2589 "readclause.cpp"
                          var $tobool564=((($call563))|0)!=0; //@line 2589 "readclause.cpp"
                          if (!($tobool564)) { __label__ = 214;break $land_lhs_true559$$if_else583$238; } //@line 2589 "readclause.cpp"
  
                          var $279=$cprev2; //@line 2589 "readclause.cpp"
                          var $call566=__ZL8IsRomanUj($279); //@line 2589 "readclause.cpp"
                          var $tobool567=((($call566))|0)!=0; //@line 2589 "readclause.cpp"
                          if ($tobool567) { __label__ = 210;break $if_then571$$lor_lhs_false562$240; } //@line 2589 "readclause.cpp"
  
                          var $280=$cprev2; //@line 2589 "readclause.cpp"
                          var $call569=_iswspace($280); //@line 2589 "readclause.cpp"
                          var $tobool570=((($call569))|0)!=0; //@line 2589 "readclause.cpp"
                          if (!($tobool570)) { __label__ = 214;break $land_lhs_true559$$if_else583$238; } //@line 2589 "readclause.cpp"
                        }
                      } while(0);
  
                      var $281=$cprev; //@line 2592 "readclause.cpp"
                      var $call572=_iswdigit($281); //@line 2592 "readclause.cpp"
                      var $tobool573=((($call572))|0)!=0; //@line 2592 "readclause.cpp"
                      if ($tobool573) { __label__ = 212;; } else { __label__ = 211;; } //@line 2592 "readclause.cpp"
                      if (__label__ == 212) {
  
                        var $282=$c_next; //@line 2598 "readclause.cpp"
                        var $call576=_iswlower($282); //@line 2598 "readclause.cpp"
                        var $tobool577=((($call576))|0)!=0; //@line 2598 "readclause.cpp"
                        var $283=$c_next; //@line 2598 "readclause.cpp"
                        var $cmp579=((($283))|0)==45; //@line 2598 "readclause.cpp"
                        var $or_cond16=($tobool577) | ($cmp579); //@line 2598 "readclause.cpp"
                        if (!($or_cond16)) { __label__ = 216;break $land_lhs_true559$$if_else583$238; } //@line 2598 "readclause.cpp"
  
                        $is_end_clause=0; //@line 2599 "readclause.cpp"
                        __label__ = 216;break $land_lhs_true559$$if_else583$238; //@line 2599 "readclause.cpp"
                      }
                      else if (__label__ == 211) {
  
                        $is_end_clause=0; //@line 2594 "readclause.cpp"
                        __label__ = 216;break $land_lhs_true559$$if_else583$238; //@line 2595 "readclause.cpp"
                      }
                    }
                  } while(0);
                  $if_end587$$if_else583$249: do { 
                    if (__label__ == 214) {
  
                      var $284=$c_next; //@line 2603 "readclause.cpp"
                      var $cmp584=((($284))|0)==39; //@line 2603 "readclause.cpp"
                      if (!($cmp584)) { __label__ = 216;break $if_end587$$if_else583$249; } //@line 2603 "readclause.cpp"
  
                      $is_end_clause=0; //@line 2605 "readclause.cpp"
                      ; //@line 2606 "readclause.cpp"
                    }
                  } while(0);
  
                  var $285=$c_next; //@line 2607 "readclause.cpp"
                  var $call588=_iswlower($285); //@line 2607 "readclause.cpp"
                  var $tobool589=((($call588))|0)!=0; //@line 2607 "readclause.cpp"
                  if ($tobool589) { __label__ = 217;; } else { __label__ = 218;; } //@line 2607 "readclause.cpp"
                  if (__label__ == 217) {
  
                    $is_end_clause=0; //@line 2611 "readclause.cpp"
                    ; //@line 2612 "readclause.cpp"
                  }
  
                  var $286=$any_alnum; //@line 2613 "readclause.cpp"
                  var $cmp592=((($286))|0)==0; //@line 2613 "readclause.cpp"
                  if (!($cmp592)) { __label__ = 222;break $if_else595$$if_end554$235; } //@line 2613 "readclause.cpp"
  
                  HEAP32[(($c1)>>2)]=32; //@line 2617 "readclause.cpp"
                  $is_end_clause=0; //@line 2618 "readclause.cpp"
                  __label__ = 235;break $if_end535$$if_end609$222; //@line 2619 "readclause.cpp"
                }
              } while(0);
              $if_else595$$if_end599$257: do { 
                if (__label__ == 220) {
  
                  var $287=$any_alnum; //@line 2623 "readclause.cpp"
                  var $cmp596=((($287))|0)==0; //@line 2623 "readclause.cpp"
                  if (!($cmp596)) { __label__ = 222;break $if_else595$$if_end599$257; } //@line 2623 "readclause.cpp"
  
                  $is_end_clause=0; //@line 2626 "readclause.cpp"
                  __label__ = 235;break $if_end535$$if_end609$222; //@line 2627 "readclause.cpp"
                }
              } while(0);
  
              var $_pr30=$is_end_clause; //@line 2630 "readclause.cpp"
              var $tobool600=((($_pr30))|0)!=0; //@line 2630 "readclause.cpp"
              if (!($tobool600)) { __label__ = 235;break $if_end535$$if_end609$222; } //@line 2630 "readclause.cpp"
  
              var $288=HEAP32[(($c1)>>2)]; //@line 2630 "readclause.cpp"
              var $cmp602=((($288))|0)==46; //@line 2630 "readclause.cpp"
              if (!($cmp602)) { __label__ = 226;break $if_end535$$if_end609$222; } //@line 2630 "readclause.cpp"
  
              var $289=$c_next; //@line 2630 "readclause.cpp"
              var $cmp604=((($289))|0)==60; //@line 2630 "readclause.cpp"
              var $290=HEAP32[((_option_ssml)>>2)]; //@line 2630 "readclause.cpp"
              var $tobool606=((($290))|0)!=0; //@line 2630 "readclause.cpp"
              var $or_cond17=($cmp604) & ($tobool606); //@line 2630 "readclause.cpp"
              if (!($or_cond17)) { __label__ = 226;break $if_end535$$if_end609$222; } //@line 2630 "readclause.cpp"
  
              $is_end_clause=0; //@line 2633 "readclause.cpp"
              var $291=HEAP32[(($ix)>>2)]; //@line 2634 "readclause.cpp"
              $end_clause_index=$291; //@line 2634 "readclause.cpp"
              var $292=$punct_data; //@line 2635 "readclause.cpp"
              $end_clause_after_tag=$292; //@line 2635 "readclause.cpp"
              __label__ = 235;break $if_end535$$if_end609$222; //@line 2636 "readclause.cpp"
            }
          } while(0);
          if (__label__ == 226) {
  
            var $_pr32_pr=$is_end_clause; //@line 2639 "readclause.cpp"
            var $tobool610=((($_pr32_pr))|0)!=0; //@line 2639 "readclause.cpp"
            if ($tobool610) { __label__ = 227;break $while_cond$12; } //@line 2639 "readclause.cpp"
          }
  
          var $call633=__Z3Eofv(); //@line 2659 "readclause.cpp"
          var $tobool634=((($call633))|0)!=0; //@line 2659 "readclause.cpp"
          if ($tobool634) { __label__ = 238;break $if_then412$$if_end643$161; } //@line 2659 "readclause.cpp"
  
          var $305=HEAP32[(($c2)>>2)]; //@line 2661 "readclause.cpp"
          var $call636=_iswspace($305); //@line 2661 "readclause.cpp"
          var $tobool637=((($call636))|0)!=0; //@line 2661 "readclause.cpp"
          if (!($tobool637)) { __label__ = 238;break $if_then412$$if_end643$161; } //@line 2661 "readclause.cpp"
  
          var $306=$c_next; //@line 2662 "readclause.cpp"
          __ZL6UngetCi($306); //@line 2662 "readclause.cpp"
          ; //@line 2662 "readclause.cpp"
        }
      } while(0);
  
      var $307=HEAP32[((((__ZL17speech_parameters)&4294967295))>>2)]; //@line 2668 "readclause.cpp"
      var $cmp644=((($307))|0)==1; //@line 2668 "readclause.cpp"
      if ($cmp644) { __label__ = 8;continue $while_cond$12; } //@line 2668 "readclause.cpp"
  
      var $308=HEAP32[(($c1)>>2)]; //@line 2671 "readclause.cpp"
      var $309=$announced_punctuation; //@line 2671 "readclause.cpp"
      var $cmp647=((($308))|0)==((($309))|0); //@line 2671 "readclause.cpp"
      if ($cmp647) { __label__ = 240;; } else { __label__ = 245;; } //@line 2671 "readclause.cpp"
      $if_then648$$if_end657$271: do { 
        if (__label__ == 240) {
  
          var $310=HEAP32[(($c1)>>2)]; //@line 2675 "readclause.cpp"
          var $call649=__Z9IsBracketi($310); //@line 2675 "readclause.cpp"
          var $tobool650=((($call649))|0)!=0; //@line 2675 "readclause.cpp"
          if ($tobool650) { __label__ = 241;; } else { __label__ = 242;; } //@line 2675 "readclause.cpp"
          $if_then651$$if_else652$273: do { 
            if (__label__ == 241) {
  
              HEAP32[(($c1)>>2)]=57384; //@line 2677 "readclause.cpp"
              ; //@line 2678 "readclause.cpp"
            }
            else if (__label__ == 242) {
  
              var $311=HEAP32[(($c1)>>2)]; //@line 2680 "readclause.cpp"
              var $cmp653=((($311))|0)!=45; //@line 2680 "readclause.cpp"
              if (!($cmp653)) { __label__ = 244;break $if_then651$$if_else652$273; } //@line 2680 "readclause.cpp"
  
              HEAP32[(($c1)>>2)]=32; //@line 2682 "readclause.cpp"
              ; //@line 2683 "readclause.cpp"
            }
          } while(0);
  
          var $312=HEAP32[(($ix)>>2)]; //@line 2686 "readclause.cpp"
          var $add65834=((($312)+1)&4294967295); //@line 2686 "readclause.cpp"
          $j=$add65834; //@line 2686 "readclause.cpp"
          ; //@line 2688 "readclause.cpp"
        }
        else if (__label__ == 245) {
  
          var $313=HEAP32[(($ix)>>2)]; //@line 2686 "readclause.cpp"
          var $add658=((($313)+1)&4294967295); //@line 2686 "readclause.cpp"
          $j=$add658; //@line 2686 "readclause.cpp"
          var $cmp659=((($308))|0)==57404; //@line 2688 "readclause.cpp"
          if (!($cmp659)) { __label__ = 247;break $if_then648$$if_end657$271; } //@line 2688 "readclause.cpp"
  
          HEAP32[(($c1)>>2)]=60; //@line 2688 "readclause.cpp"
          ; //@line 2688 "readclause.cpp"
        }
      } while(0);
  
      var $314=HEAP32[(($c1)>>2)]; //@line 2690 "readclause.cpp"
      var $315=HEAP32[(($ix)>>2)]; //@line 2690 "readclause.cpp"
      var $316=$buf_addr; //@line 2690 "readclause.cpp"
      var $arrayidx662=(($316+$315)&4294967295); //@line 2690 "readclause.cpp"
      var $call663=__Z8utf8_outjPc($314, $arrayidx662); //@line 2690 "readclause.cpp"
      var $317=HEAP32[(($ix)>>2)]; //@line 2690 "readclause.cpp"
      var $add664=((($317)+($call663))&4294967295); //@line 2690 "readclause.cpp"
      HEAP32[(($ix)>>2)]=$add664; //@line 2690 "readclause.cpp"
      var $318=HEAP32[(($c1)>>2)]; //@line 2691 "readclause.cpp"
      var $call665=_iswspace($318); //@line 2691 "readclause.cpp"
      var $tobool666=((($call665))|0)!=0; //@line 2691 "readclause.cpp"
      if ($tobool666) { __label__ = 251;; } else { __label__ = 248;; } //@line 2691 "readclause.cpp"
      $if_end680$$land_lhs_true667$281: do { 
        if (__label__ == 248) {
  
          var $319=HEAP32[(($c1)>>2)]; //@line 2691 "readclause.cpp"
          var $call668=__Z9IsBracketi($319); //@line 2691 "readclause.cpp"
          var $tobool669=((($call668))|0)!=0; //@line 2691 "readclause.cpp"
          if ($tobool669) { __label__ = 251;break $if_end680$$land_lhs_true667$281; } //@line 2691 "readclause.cpp"
  
          var $320=HEAP32[((_count_characters)>>2)]; //@line 2693 "readclause.cpp"
          var $321=HEAP32[((_clause_start_char)>>2)]; //@line 2693 "readclause.cpp"
          var $sub671=((($320)-($321))&4294967295); //@line 2693 "readclause.cpp"
          var $conv672=((($sub671)) & 65535); //@line 2693 "readclause.cpp"
          var $322=HEAP32[(($ix)>>2)]; //@line 2693 "readclause.cpp"
          var $323=$charix_addr; //@line 2693 "readclause.cpp"
          var $arrayidx673=(($323+2*$322)&4294967295); //@line 2693 "readclause.cpp"
          HEAP16[(($arrayidx673)>>1)]=$conv672; //@line 2693 "readclause.cpp"
          var $324=$j; //@line 2694 "readclause.cpp"
          var $325=HEAP32[(($ix)>>2)]; //@line 2694 "readclause.cpp"
          var $cmp67537=((($324))|0) < ((($325))|0); //@line 2694 "readclause.cpp"
          if (!($cmp67537)) { __label__ = 251;break $if_end680$$land_lhs_true667$281; } //@line 2694 "readclause.cpp"
          while(1) { 
  
            var $326=$j; //@line 2695 "readclause.cpp"
            var $inc677=((($326)+1)&4294967295); //@line 2695 "readclause.cpp"
            $j=$inc677; //@line 2695 "readclause.cpp"
            var $327=$charix_addr; //@line 2695 "readclause.cpp"
            var $arrayidx678=(($327+2*$326)&4294967295); //@line 2695 "readclause.cpp"
            HEAP16[(($arrayidx678)>>1)]=-1; //@line 2695 "readclause.cpp"
            var $328=$j; //@line 2694 "readclause.cpp"
            var $329=HEAP32[(($ix)>>2)]; //@line 2694 "readclause.cpp"
            var $cmp675=((($328))|0) < ((($329))|0); //@line 2694 "readclause.cpp"
            if ($cmp675) { __label__ = 250;continue ; } else { __label__ = 251;break $if_end680$$land_lhs_true667$281; } //@line 2694 "readclause.cpp"
          }
        }
      } while(0);
  
      var $330=HEAP32[(($ix)>>2)]; //@line 2697 "readclause.cpp"
      var $331=$charix_top_addr; //@line 2697 "readclause.cpp"
      HEAP32[(($331)>>2)]=$330; //@line 2697 "readclause.cpp"
      var $332=HEAP32[(($ix)>>2)]; //@line 2699 "readclause.cpp"
      var $333=$n_buf_addr; //@line 2699 "readclause.cpp"
      var $sub681=((($333)-20)&4294967295); //@line 2699 "readclause.cpp"
      var $cmp682=((($332))|0) > ((($sub681))|0); //@line 2699 "readclause.cpp"
      if ($cmp682) { __label__ = 252;; } else { __label__ = 254;; } //@line 2699 "readclause.cpp"
      $land_lhs_true683$$lor_lhs_false689$287: do { 
        if (__label__ == 252) {
  
          var $334=HEAP32[(($c1)>>2)]; //@line 2699 "readclause.cpp"
          var $call684=__Z7IsAlphaj($334); //@line 2699 "readclause.cpp"
          var $tobool685=((($call684))|0)!=0; //@line 2699 "readclause.cpp"
          if ($tobool685) { __label__ = 254;break $land_lhs_true683$$lor_lhs_false689$287; } //@line 2699 "readclause.cpp"
  
          var $335=HEAP32[(($c1)>>2)]; //@line 2699 "readclause.cpp"
          var $call687=_iswdigit($335); //@line 2699 "readclause.cpp"
          var $tobool688=((($call687))|0)!=0; //@line 2699 "readclause.cpp"
          if (!($tobool688)) { __label__ = 255;break $while_cond$12; } //@line 2699 "readclause.cpp"
        }
      } while(0);
  
      var $336=HEAP32[(($ix)>>2)]; //@line 2699 "readclause.cpp"
      var $337=$n_buf_addr; //@line 2699 "readclause.cpp"
      var $sub690=((($337)-2)&4294967295); //@line 2699 "readclause.cpp"
      var $cmp691=((($336))|0) >= ((($sub690))|0); //@line 2699 "readclause.cpp"
      if ($cmp691) { __label__ = 255;break $while_cond$12; } else { __label__ = 8;continue $while_cond$12; } //@line 2699 "readclause.cpp"
    }
    if (__label__ == 256) {
  
      var $343=$stressed_word; //@line 2710 "readclause.cpp"
      var $tobool698=((($343))|0)!=0; //@line 2710 "readclause.cpp"
      if ($tobool698) { __label__ = 257;; } else { __label__ = 258;; } //@line 2710 "readclause.cpp"
      if (__label__ == 257) {
  
        var $344=HEAP32[(($ix)>>2)]; //@line 2712 "readclause.cpp"
        var $345=$buf_addr; //@line 2712 "readclause.cpp"
        var $arrayidx700=(($345+$344)&4294967295); //@line 2712 "readclause.cpp"
        var $call701=__Z8utf8_outjPc(1328, $arrayidx700); //@line 2712 "readclause.cpp"
        var $346=HEAP32[(($ix)>>2)]; //@line 2712 "readclause.cpp"
        var $add702=((($346)+($call701))&4294967295); //@line 2712 "readclause.cpp"
        HEAP32[(($ix)>>2)]=$add702; //@line 2712 "readclause.cpp"
        ; //@line 2713 "readclause.cpp"
      }
  
      var $347=$end_clause_after_tag; //@line 2714 "readclause.cpp"
      var $tobool704=((($347))|0)!=0; //@line 2714 "readclause.cpp"
      if ($tobool704) { __label__ = 259;; } else { __label__ = 260;; } //@line 2714 "readclause.cpp"
      if (__label__ == 259) {
  
        var $348=$end_clause_index; //@line 2716 "readclause.cpp"
        var $349=$buf_addr; //@line 2716 "readclause.cpp"
        var $arrayidx706=(($349+$348)&4294967295); //@line 2716 "readclause.cpp"
        __ZL10RemoveCharPc($arrayidx706); //@line 2716 "readclause.cpp"
        ; //@line 2717 "readclause.cpp"
      }
  
      var $350=HEAP32[(($ix)>>2)]; //@line 2718 "readclause.cpp"
      var $351=$buf_addr; //@line 2718 "readclause.cpp"
      var $arrayidx708=(($351+$350)&4294967295); //@line 2718 "readclause.cpp"
      HEAP8[($arrayidx708)]=32; //@line 2718 "readclause.cpp"
      var $352=HEAP32[(($ix)>>2)]; //@line 2719 "readclause.cpp"
      var $add709=((($352)+1)&4294967295); //@line 2719 "readclause.cpp"
      var $353=$buf_addr; //@line 2719 "readclause.cpp"
      var $arrayidx710=(($353+$add709)&4294967295); //@line 2719 "readclause.cpp"
      HEAP8[($arrayidx710)]=0; //@line 2719 "readclause.cpp"
      $retval=589864; //@line 2720 "readclause.cpp"
      ; //@line 2720 "readclause.cpp"
    }
    else if (__label__ == 12) {
  
      HEAP8[(__ZL12end_of_input_b)]=1;
      $retval=589864; //@line 2116 "readclause.cpp"
      ; //@line 2116 "readclause.cpp"
    }
    else if (__label__ == 15) {
  
      HEAP8[(__ZL19clear_skipping_text_b)]=1;
      HEAP32[((_skip_characters)>>2)]=0; //@line 2124 "readclause.cpp"
      var $24=HEAP32[(($c2)>>2)]; //@line 2125 "readclause.cpp"
      __ZL6UngetCi($24); //@line 2125 "readclause.cpp"
      $retval=16384; //@line 2126 "readclause.cpp"
      ; //@line 2126 "readclause.cpp"
    }
    else if (__label__ == 66) {
  
      var $81=$end_clause_after_tag; //@line 2249 "readclause.cpp"
      var $tobool168=((($81))|0)!=0; //@line 2249 "readclause.cpp"
      if ($tobool168) { __label__ = 67;; } else { __label__ = 68;; } //@line 2249 "readclause.cpp"
      if (__label__ == 67) {
  
        var $82=$end_clause_index; //@line 2250 "readclause.cpp"
        HEAP32[(($ix)>>2)]=$82; //@line 2250 "readclause.cpp"
        ; //@line 2250 "readclause.cpp"
      }
  
      var $83=HEAP32[(($ix)>>2)]; //@line 2252 "readclause.cpp"
      var $84=$buf_addr; //@line 2252 "readclause.cpp"
      var $arrayidx171=(($84+$83)&4294967295); //@line 2252 "readclause.cpp"
      HEAP8[($arrayidx171)]=32; //@line 2252 "readclause.cpp"
      var $85=HEAP32[(($ix)>>2)]; //@line 2253 "readclause.cpp"
      var $inc172=((($85)+1)&4294967295); //@line 2253 "readclause.cpp"
      HEAP32[(($ix)>>2)]=$inc172; //@line 2253 "readclause.cpp"
      var $86=$buf_addr; //@line 2253 "readclause.cpp"
      var $arrayidx173=(($86+$85)&4294967295); //@line 2253 "readclause.cpp"
      HEAP8[($arrayidx173)]=0; //@line 2253 "readclause.cpp"
      var $87=$terminator; //@line 2255 "readclause.cpp"
      var $and=($87) & 131072; //@line 2255 "readclause.cpp"
      var $tobool174=((($and))|0)!=0; //@line 2255 "readclause.cpp"
      if ($tobool174) { __label__ = 69;; } else { __label__ = 70;; } //@line 2255 "readclause.cpp"
      if (__label__ == 69) {
  
        var $88=$voice_change_addr; //@line 2257 "readclause.cpp"
        var $call176=_strcpy($88, ((__ZL16current_voice_id)&4294967295)); //@line 2257 "readclause.cpp"
        ; //@line 2258 "readclause.cpp"
      }
  
      var $89=$terminator; //@line 2259 "readclause.cpp"
      $retval=$89; //@line 2259 "readclause.cpp"
      ; //@line 2259 "readclause.cpp"
    }
    else if (__label__ == 74) {
  
      var $call192=__Z11lookupwcharPKti(((__ZL11punct_chars)&4294967295), $93); //@line 2275 "readclause.cpp"
      $punct=$call192; //@line 2275 "readclause.cpp"
      var $cmp193=((($call192))|0)==0; //@line 2275 "readclause.cpp"
      if ($cmp193) { __label__ = 75;; } else { __label__ = 76;; } //@line 2275 "readclause.cpp"
      if (__label__ == 75) {
  
        var $94=HEAP32[((_count_characters)>>2)]; //@line 2277 "readclause.cpp"
        var $95=HEAP32[((_clause_start_char)>>2)]; //@line 2277 "readclause.cpp"
        var $sub195=((($94)-($95))&4294967295); //@line 2277 "readclause.cpp"
        var $conv196=((($sub195)) & 65535); //@line 2277 "readclause.cpp"
        var $96=HEAP32[(($ix)>>2)]; //@line 2277 "readclause.cpp"
        var $97=$charix_addr; //@line 2277 "readclause.cpp"
        var $arrayidx197=(($97+2*$96)&4294967295); //@line 2277 "readclause.cpp"
        HEAP16[(($arrayidx197)>>1)]=$conv196; //@line 2277 "readclause.cpp"
        var $98=HEAP32[(($ix)>>2)]; //@line 2278 "readclause.cpp"
        var $99=$charix_top_addr; //@line 2278 "readclause.cpp"
        HEAP32[(($99)>>2)]=$98; //@line 2278 "readclause.cpp"
        var $100=HEAP32[(($c1)>>2)]; //@line 2279 "readclause.cpp"
        var $101=HEAP32[(($ix)>>2)]; //@line 2279 "readclause.cpp"
        var $102=$buf_addr; //@line 2279 "readclause.cpp"
        var $arrayidx198=(($102+$101)&4294967295); //@line 2279 "readclause.cpp"
        var $call199=__Z8utf8_outjPc($100, $arrayidx198); //@line 2279 "readclause.cpp"
        var $103=HEAP32[(($ix)>>2)]; //@line 2279 "readclause.cpp"
        var $add200=((($103)+($call199))&4294967295); //@line 2279 "readclause.cpp"
        HEAP32[(($ix)>>2)]=$add200; //@line 2279 "readclause.cpp"
        $terminator=524328; //@line 2280 "readclause.cpp"
        ; //@line 2281 "readclause.cpp"
      }
      else if (__label__ == 76) {
  
        var $104=$punct; //@line 2284 "readclause.cpp"
        var $arrayidx202=((__ZL16punct_attributes+$104*4)&4294967295); //@line 2284 "readclause.cpp"
        var $105=HEAP32[(($arrayidx202)>>2)]; //@line 2284 "readclause.cpp"
        $terminator=$105; //@line 2284 "readclause.cpp"
        ;
      }
  
      var $106=HEAP32[(($ix)>>2)]; //@line 2286 "readclause.cpp"
      var $107=$buf_addr; //@line 2286 "readclause.cpp"
      var $arrayidx204=(($107+$106)&4294967295); //@line 2286 "readclause.cpp"
      HEAP8[($arrayidx204)]=32; //@line 2286 "readclause.cpp"
      var $108=HEAP32[(($ix)>>2)]; //@line 2287 "readclause.cpp"
      var $add205=((($108)+1)&4294967295); //@line 2287 "readclause.cpp"
      var $109=$buf_addr; //@line 2287 "readclause.cpp"
      var $arrayidx206=(($109+$add205)&4294967295); //@line 2287 "readclause.cpp"
      HEAP8[($arrayidx206)]=0; //@line 2287 "readclause.cpp"
      var $110=$terminator; //@line 2288 "readclause.cpp"
      $retval=$110; //@line 2288 "readclause.cpp"
      ; //@line 2288 "readclause.cpp"
    }
    else if (__label__ == 81) {
  
      var $114=HEAP32[(($ix)>>2)]; //@line 2296 "readclause.cpp"
      var $inc215=((($114)+1)&4294967295); //@line 2296 "readclause.cpp"
      HEAP32[(($ix)>>2)]=$inc215; //@line 2296 "readclause.cpp"
      var $115=$buf_addr; //@line 2296 "readclause.cpp"
      var $arrayidx216=(($115+$114)&4294967295); //@line 2296 "readclause.cpp"
      HEAP8[($arrayidx216)]=0; //@line 2296 "readclause.cpp"
      ; //@line 2297 "readclause.cpp"
      while(1) { 
  
        var $call218=__ZL4GetCv(); //@line 2297 "readclause.cpp"
        HEAP32[(($c1)>>2)]=$call218; //@line 2297 "readclause.cpp"
        var $call219=_iswspace($call218); //@line 2297 "readclause.cpp"
        var $tobool220=((($call219))|0)!=0; //@line 2297 "readclause.cpp"
        if ($tobool220) { __label__ = 86;break ; } //@line 2297 "readclause.cpp"
  
        var $call222=__Z3Eofv(); //@line 2297 "readclause.cpp"
        var $tobool223=((($call222))|0)!=0; //@line 2297 "readclause.cpp"
        if ($tobool223) { __label__ = 86;break ; } //@line 2297 "readclause.cpp"
  
        var $116=HEAP32[(($ix)>>2)]; //@line 2297 "readclause.cpp"
        var $117=$n_buf_addr; //@line 2297 "readclause.cpp"
        var $sub225=((($117)-1)&4294967295); //@line 2297 "readclause.cpp"
        var $cmp226=((($116))|0) < ((($sub225))|0); //@line 2297 "readclause.cpp"
        if (!($cmp226)) { __label__ = 86;break ; }
  
        var $118=HEAP32[(($c1)>>2)]; //@line 2298 "readclause.cpp"
        var $conv229=((($118)) & 255); //@line 2298 "readclause.cpp"
        var $119=HEAP32[(($ix)>>2)]; //@line 2298 "readclause.cpp"
        var $inc230=((($119)+1)&4294967295); //@line 2298 "readclause.cpp"
        HEAP32[(($ix)>>2)]=$inc230; //@line 2298 "readclause.cpp"
        var $120=$buf_addr; //@line 2298 "readclause.cpp"
        var $arrayidx231=(($120+$119)&4294967295); //@line 2298 "readclause.cpp"
        HEAP8[($arrayidx231)]=$conv229; //@line 2298 "readclause.cpp"
        __label__ = 82;continue ; //@line 2298 "readclause.cpp"
      }
  
      var $121=HEAP32[(($ix)>>2)]; //@line 2299 "readclause.cpp"
      var $inc233=((($121)+1)&4294967295); //@line 2299 "readclause.cpp"
      HEAP32[(($ix)>>2)]=$inc233; //@line 2299 "readclause.cpp"
      var $122=$buf_addr; //@line 2299 "readclause.cpp"
      var $arrayidx234=(($122+$121)&4294967295); //@line 2299 "readclause.cpp"
      HEAP8[($arrayidx234)]=0; //@line 2299 "readclause.cpp"
      $retval=147456; //@line 2300 "readclause.cpp"
      ; //@line 2300 "readclause.cpp"
    }
    else if (__label__ == 108) {
  
      HEAP32[((__ZL10ungot_word)>>2)]=((__str42209)&4294967295); //@line 2370 "readclause.cpp"
      var $151=HEAP32[(($c2)>>2)]; //@line 2371 "readclause.cpp"
      __ZL6UngetCi($151); //@line 2371 "readclause.cpp"
      var $152=$p_word; //@line 2372 "readclause.cpp"
      var $arrayidx300=(($152)&4294967295); //@line 2372 "readclause.cpp"
      HEAP8[($arrayidx300)]=0; //@line 2372 "readclause.cpp"
      $retval=524328; //@line 2373 "readclause.cpp"
      ; //@line 2373 "readclause.cpp"
    }
    else if (__label__ == 138) {
  
      var $184=HEAP32[(($c2)>>2)]; //@line 2438 "readclause.cpp"
      __ZL6UngetCi($184); //@line 2438 "readclause.cpp"
      var $185=$end_clause_after_tag; //@line 2440 "readclause.cpp"
      var $tobool387=((($185))|0)!=0; //@line 2440 "readclause.cpp"
      if ($tobool387) { __label__ = 139;; } else { __label__ = 140;; } //@line 2440 "readclause.cpp"
      if (__label__ == 139) {
  
        var $186=$end_clause_index; //@line 2442 "readclause.cpp"
        var $187=$buf_addr; //@line 2442 "readclause.cpp"
        var $arrayidx389=(($187+$186)&4294967295); //@line 2442 "readclause.cpp"
        __ZL10RemoveCharPc($arrayidx389); //@line 2442 "readclause.cpp"
        ; //@line 2443 "readclause.cpp"
      }
  
      var $188=HEAP32[(($ix)>>2)]; //@line 2444 "readclause.cpp"
      var $189=$buf_addr; //@line 2444 "readclause.cpp"
      var $arrayidx391=(($189+$188)&4294967295); //@line 2444 "readclause.cpp"
      HEAP8[($arrayidx391)]=32; //@line 2444 "readclause.cpp"
      var $190=HEAP32[(($ix)>>2)]; //@line 2445 "readclause.cpp"
      var $add392=((($190)+1)&4294967295); //@line 2445 "readclause.cpp"
      var $191=$buf_addr; //@line 2445 "readclause.cpp"
      var $arrayidx393=(($191+$add392)&4294967295); //@line 2445 "readclause.cpp"
      HEAP8[($arrayidx393)]=0; //@line 2445 "readclause.cpp"
      var $192=$parag; //@line 2446 "readclause.cpp"
      var $cmp394=((($192))|0) > 3; //@line 2446 "readclause.cpp"
      if ($cmp394) { __label__ = 141;; } else { __label__ = 142;; } //@line 2446 "readclause.cpp"
      if (__label__ == 141) {
  
        $parag=3; //@line 2447 "readclause.cpp"
        ; //@line 2447 "readclause.cpp"
      }
  
      var $193=HEAP32[((_option_ssml)>>2)]; //@line 2448 "readclause.cpp"
      var $tobool397=((($193))|0)!=0; //@line 2448 "readclause.cpp"
      if ($tobool397) { __label__ = 143;; } else { __label__ = 144;; } //@line 2448 "readclause.cpp"
      if (__label__ == 143) {
  
        $parag=1; //@line 2448 "readclause.cpp"
        ; //@line 2448 "readclause.cpp"
      }
  
      var $194=$parag; //@line 2449 "readclause.cpp"
      var $mul=((($194)*30)&4294967295); //@line 2449 "readclause.cpp"
      var $add400=((($mul)+524328)&4294967295); //@line 2449 "readclause.cpp"
      $retval=$add400; //@line 2449 "readclause.cpp"
      ; //@line 2449 "readclause.cpp"
    }
    else if (__label__ == 146) {
  
      var $197=HEAP32[(($c2)>>2)]; //@line 2455 "readclause.cpp"
      __ZL6UngetCi($197); //@line 2455 "readclause.cpp"
      var $198=HEAP32[(($ix)>>2)]; //@line 2456 "readclause.cpp"
      var $199=$buf_addr; //@line 2456 "readclause.cpp"
      var $arrayidx404=(($199+$198)&4294967295); //@line 2456 "readclause.cpp"
      HEAP8[($arrayidx404)]=32; //@line 2456 "readclause.cpp"
      var $200=HEAP32[(($ix)>>2)]; //@line 2457 "readclause.cpp"
      var $add405=((($200)+1)&4294967295); //@line 2457 "readclause.cpp"
      var $201=$buf_addr; //@line 2457 "readclause.cpp"
      var $arrayidx406=(($201+$add405)&4294967295); //@line 2457 "readclause.cpp"
      HEAP8[($arrayidx406)]=0; //@line 2457 "readclause.cpp"
      $retval=262174; //@line 2458 "readclause.cpp"
      ; //@line 2458 "readclause.cpp"
    }
    else if (__label__ == 153) {
  
      var $209=HEAP32[(($c2)>>2)]; //@line 2482 "readclause.cpp"
      __ZL6UngetCi($209); //@line 2482 "readclause.cpp"
      var $210=HEAP32[(($c1)>>2)]; //@line 2483 "readclause.cpp"
      HEAP32[((__ZL11ungot_char2)>>2)]=$210; //@line 2483 "readclause.cpp"
      var $211=$end_clause_index; //@line 2484 "readclause.cpp"
      var $212=$buf_addr; //@line 2484 "readclause.cpp"
      var $arrayidx424=(($212+$211)&4294967295); //@line 2484 "readclause.cpp"
      HEAP8[($arrayidx424)]=32; //@line 2484 "readclause.cpp"
      var $213=$end_clause_index; //@line 2485 "readclause.cpp"
      var $add425=((($213)+1)&4294967295); //@line 2485 "readclause.cpp"
      var $214=$buf_addr; //@line 2485 "readclause.cpp"
      var $arrayidx426=(($214+$add425)&4294967295); //@line 2485 "readclause.cpp"
      HEAP8[($arrayidx426)]=0; //@line 2485 "readclause.cpp"
      var $215=$end_clause_after_tag; //@line 2486 "readclause.cpp"
      $retval=$215; //@line 2486 "readclause.cpp"
      ; //@line 2486 "readclause.cpp"
    }
    else if (__label__ == 179) {
  
      var $243=$terminator; //@line 2537 "readclause.cpp"
      $retval=$243; //@line 2537 "readclause.cpp"
      ; //@line 2537 "readclause.cpp"
    }
    else if (__label__ == 227) {
  
      var $293=$c_next; //@line 2641 "readclause.cpp"
      __ZL6UngetCi($293); //@line 2641 "readclause.cpp"
      var $294=HEAP32[(($ix)>>2)]; //@line 2642 "readclause.cpp"
      var $295=$buf_addr; //@line 2642 "readclause.cpp"
      var $arrayidx612=(($295+$294)&4294967295); //@line 2642 "readclause.cpp"
      HEAP8[($arrayidx612)]=32; //@line 2642 "readclause.cpp"
      var $296=HEAP32[(($ix)>>2)]; //@line 2643 "readclause.cpp"
      var $add613=((($296)+1)&4294967295); //@line 2643 "readclause.cpp"
      var $297=$buf_addr; //@line 2643 "readclause.cpp"
      var $arrayidx614=(($297+$add613)&4294967295); //@line 2643 "readclause.cpp"
      HEAP8[($arrayidx614)]=0; //@line 2643 "readclause.cpp"
      var $298=$cprev; //@line 2645 "readclause.cpp"
      var $call615=_iswdigit($298); //@line 2645 "readclause.cpp"
      var $tobool616=((($call615))|0)!=0; //@line 2645 "readclause.cpp"
      if ($tobool616) { __label__ = 228;; } else { __label__ = 230;; } //@line 2645 "readclause.cpp"
      $land_lhs_true617$$if_end622$335: do { 
        if (__label__ == 228) {
  
          var $299=$c_next; //@line 2645 "readclause.cpp"
          var $call618=__Z7IsAlphaj($299); //@line 2645 "readclause.cpp"
          var $tobool619=((($call618))|0)!=0; //@line 2645 "readclause.cpp"
          if ($tobool619) { __label__ = 230;break $land_lhs_true617$$if_end622$335; } //@line 2645 "readclause.cpp"
  
          var $300=$punct_data; //@line 2647 "readclause.cpp"
          var $and621=($300) & -4194305; //@line 2647 "readclause.cpp"
          $punct_data=$and621; //@line 2647 "readclause.cpp"
          ; //@line 2648 "readclause.cpp"
        }
      } while(0);
  
      var $301=$nl_count; //@line 2649 "readclause.cpp"
      var $cmp623=((($301))|0) > 1; //@line 2649 "readclause.cpp"
      var $302=$punct_data; //@line 2651 "readclause.cpp"
      if ($cmp623) { __label__ = 231;; } else { __label__ = 234;; } //@line 2649 "readclause.cpp"
      if (__label__ == 231) {
  
        var $cmp625=((($302))|0)==532520; //@line 2651 "readclause.cpp"
        var $303=$punct_data; //@line 2651 "readclause.cpp"
        var $cmp627=((($303))|0)==536621; //@line 2651 "readclause.cpp"
        var $or_cond18=($cmp625) | ($cmp627); //@line 2651 "readclause.cpp"
        if ($or_cond18) { __label__ = 232;; } else { __label__ = 233;; } //@line 2651 "readclause.cpp"
        if (__label__ == 232) {
  
          var $304=$punct_data; //@line 2652 "readclause.cpp"
          var $add629=((($304)+35)&4294967295); //@line 2652 "readclause.cpp"
          $retval=$add629; //@line 2652 "readclause.cpp"
          ; //@line 2652 "readclause.cpp"
        }
        else if (__label__ == 233) {
  
          $retval=524358; //@line 2653 "readclause.cpp"
          ; //@line 2653 "readclause.cpp"
        }
      }
      else if (__label__ == 234) {
  
        $retval=$302; //@line 2655 "readclause.cpp"
        ; //@line 2655 "readclause.cpp"
      }
    }
    else if (__label__ == 255) {
  
      var $338=HEAP32[(($ix)>>2)]; //@line 2703 "readclause.cpp"
      var $339=$buf_addr; //@line 2703 "readclause.cpp"
      var $arrayidx693=(($339+$338)&4294967295); //@line 2703 "readclause.cpp"
      HEAP8[($arrayidx693)]=32; //@line 2703 "readclause.cpp"
      var $340=HEAP32[(($ix)>>2)]; //@line 2704 "readclause.cpp"
      var $add694=((($340)+1)&4294967295); //@line 2704 "readclause.cpp"
      var $341=$buf_addr; //@line 2704 "readclause.cpp"
      var $arrayidx695=(($341+$add694)&4294967295); //@line 2704 "readclause.cpp"
      HEAP8[($arrayidx695)]=0; //@line 2704 "readclause.cpp"
      var $342=HEAP32[(($c2)>>2)]; //@line 2705 "readclause.cpp"
      __ZL6UngetCi($342); //@line 2705 "readclause.cpp"
      $retval=16384; //@line 2706 "readclause.cpp"
      ; //@line 2706 "readclause.cpp"
    }
  
    var $354=$retval; //@line 2721 "readclause.cpp"
    STACKTOP = __stackBase__;
    return $354; //@line 2721 "readclause.cpp"
    return null;
  }
  

  function __ZL4GetCv() {
    var __stackBase__  = STACKTOP; STACKTOP += 16; _memset(__stackBase__, 0, 16);
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $c;
    var $c1;
    var $c2;
    var $cbuf=__stackBase__;
    var $ix;
    var $n_bytes;
    var $m;
    var $0=HEAP32[((__ZL10ungot_char)>>2)]; //@line 483 "readclause.cpp"
    $c1=$0; //@line 483 "readclause.cpp"
    var $cmp=((($0))|0)!=0; //@line 483 "readclause.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 483 "readclause.cpp"
    $if_then$$if_end$2: do { 
      if (__label__ == 1) {
  
        HEAP32[((__ZL10ungot_char)>>2)]=0; //@line 485 "readclause.cpp"
        var $1=$c1; //@line 486 "readclause.cpp"
        $retval=$1; //@line 486 "readclause.cpp"
        ; //@line 486 "readclause.cpp"
      }
      else if (__label__ == 2) {
  
        var $2=HEAP32[((__ZZL4GetCvE6ungot2)>>2)]; //@line 489 "readclause.cpp"
        var $cmp1=((($2))|0)!=0; //@line 489 "readclause.cpp"
        if ($cmp1) { __label__ = 3;; } else { __label__ = 4;; } //@line 489 "readclause.cpp"
        if (__label__ == 3) {
  
          var $3=HEAP32[((__ZZL4GetCvE6ungot2)>>2)]; //@line 491 "readclause.cpp"
          $c1=$3; //@line 491 "readclause.cpp"
          HEAP32[((__ZZL4GetCvE6ungot2)>>2)]=0; //@line 492 "readclause.cpp"
          ; //@line 493 "readclause.cpp"
        }
        else if (__label__ == 4) {
  
          var $call=__ZL8GetC_getv(); //@line 496 "readclause.cpp"
          $c1=$call; //@line 496 "readclause.cpp"
          ;
        }
  
        var $4=HEAP32[((_option_multibyte)>>2)]; //@line 499 "readclause.cpp"
        var $cmp4=((($4))|0)==3; //@line 499 "readclause.cpp"
        var $5=HEAP32[((_option_multibyte)>>2)]; //@line 499 "readclause.cpp"
        var $cmp5=((($5))|0)==4; //@line 499 "readclause.cpp"
        var $or_cond=($cmp4) | ($cmp5); //@line 499 "readclause.cpp"
        if ($or_cond) { __label__ = 6;; } else { __label__ = 7;; } //@line 499 "readclause.cpp"
        if (__label__ == 6) {
  
          var $6=HEAP32[((_count_characters)>>2)]; //@line 501 "readclause.cpp"
          var $inc=((($6)+1)&4294967295); //@line 501 "readclause.cpp"
          HEAP32[((_count_characters)>>2)]=$inc; //@line 501 "readclause.cpp"
          var $7=$c1; //@line 502 "readclause.cpp"
          $retval=$7; //@line 502 "readclause.cpp"
          ; //@line 502 "readclause.cpp"
        }
        else if (__label__ == 7) {
  
          var $8=HEAP32[((_option_multibyte)>>2)]; //@line 505 "readclause.cpp"
          var $cmp8=((($8))|0) < 2; //@line 505 "readclause.cpp"
          if ($cmp8) { __label__ = 8;; } else { __label__ = 36;; } //@line 505 "readclause.cpp"
          $land_lhs_true$$if_end65thread_pre_split$12: do { 
            if (__label__ == 8) {
  
              var $9=$c1; //@line 505 "readclause.cpp"
              var $and=($9) & 128; //@line 505 "readclause.cpp"
              var $tobool=((($and))|0)!=0; //@line 505 "readclause.cpp"
              if ($tobool) { __lastLabel__ = 8; ; } else { __lastLabel__ = 8; __label__ = 37;break $land_lhs_true$$if_end65thread_pre_split$12; } //@line 505 "readclause.cpp"
  
              $n_bytes=0; //@line 508 "readclause.cpp"
              var $10=$c1; //@line 510 "readclause.cpp"
              var $and10=($10) & 224; //@line 510 "readclause.cpp"
              var $cmp11=((($and10))|0)==192; //@line 510 "readclause.cpp"
              if ($cmp11) { __label__ = 10;; } else { __label__ = 12;; } //@line 510 "readclause.cpp"
              $land_lhs_true12$$if_else16$15: do { 
                if (__label__ == 10) {
  
                  var $11=$c1; //@line 510 "readclause.cpp"
                  var $and13=($11) & 30; //@line 510 "readclause.cpp"
                  var $cmp14=((($and13))|0)!=0; //@line 510 "readclause.cpp"
                  if (!($cmp14)) { __label__ = 12;break $land_lhs_true12$$if_else16$15; } //@line 510 "readclause.cpp"
  
                  $n_bytes=1; //@line 511 "readclause.cpp"
                  __lastLabel__ = 11; __label__ = 17;break $land_lhs_true12$$if_else16$15; //@line 511 "readclause.cpp"
                }
              } while(0);
              $if_end29_thread$$if_else16$18: do { 
                if (__label__ == 12) {
  
                  var $12=$c1; //@line 513 "readclause.cpp"
                  var $and17=($12) & 240; //@line 513 "readclause.cpp"
                  var $cmp18=((($and17))|0)==224; //@line 513 "readclause.cpp"
                  if ($cmp18) { __label__ = 13;; } else { __label__ = 14;; } //@line 513 "readclause.cpp"
                  if (__label__ == 13) {
  
                    $n_bytes=2; //@line 514 "readclause.cpp"
                    __lastLabel__ = 13; __label__ = 17;break $if_end29_thread$$if_else16$18; //@line 514 "readclause.cpp"
                  }
                  else if (__label__ == 14) {
  
                    var $13=$c1; //@line 516 "readclause.cpp"
                    var $and21=($13) & 248; //@line 516 "readclause.cpp"
                    var $cmp22=((($and21))|0)==240; //@line 516 "readclause.cpp"
                    if ($cmp22) { __label__ = 15;; } else { __label__ = 18;; } //@line 516 "readclause.cpp"
                    $land_lhs_true23$$if_end29$23: do { 
                      if (__label__ == 15) {
  
                        var $14=$c1; //@line 516 "readclause.cpp"
                        var $and24=($14) & 15; //@line 516 "readclause.cpp"
                        var $cmp25=((($and24))|0) <= 4; //@line 516 "readclause.cpp"
                        if (!($cmp25)) { __label__ = 18;break $land_lhs_true23$$if_end29$23; } //@line 516 "readclause.cpp"
  
                        $n_bytes=3; //@line 517 "readclause.cpp"
                        __lastLabel__ = 16; __label__ = 17;break $if_end29_thread$$if_else16$18; //@line 517 "readclause.cpp"
                      }
                    } while(0);
  
                    var $_pr=$n_bytes; //@line 519 "readclause.cpp"
                    $ix=$_pr; //@line 519 "readclause.cpp"
                    var $cmp30=((($_pr))|0) > 0; //@line 519 "readclause.cpp"
                    if ($cmp30) { __label__ = 19;break $if_end29_thread$$if_else16$18; } else { __label__ = 33;break $if_end29_thread$$if_else16$18; } //@line 519 "readclause.cpp"
                  }
                }
              } while(0);
              $if_end29_thread$$if_then31$$if_end58$27: do { 
                if (__label__ == 17) {
  
                  var $_ph=__lastLabel__ == 13 ? 2 : (__lastLabel__ == 16 ? 3 : (1));
                  $ix=$_ph; //@line 519 "readclause.cpp"
                  __label__ = 19;break $if_end29_thread$$if_then31$$if_end58$27; //@line 519 "readclause.cpp"
                }
              } while(0);
              $if_then31$$if_end58$29: do { 
                if (__label__ == 19) {
  
                  var $15=$c1; //@line 521 "readclause.cpp"
                  var $16=$ix; //@line 521 "readclause.cpp"
                  var $arrayidx=((__ZZ8utf8_in2PiPKciE4mask+$16)&4294967295); //@line 521 "readclause.cpp"
                  var $17=HEAPU8[($arrayidx)]; //@line 521 "readclause.cpp"
                  var $conv=((($17))&255); //@line 521 "readclause.cpp"
                  var $and32=($conv) & ($15); //@line 521 "readclause.cpp"
                  $c=$and32; //@line 521 "readclause.cpp"
                  var $18=$ix; //@line 522 "readclause.cpp"
                  var $arrayidx33=((__ZZL4GetCvE5mask2+$18)&4294967295); //@line 522 "readclause.cpp"
                  var $19=HEAP8[($arrayidx33)]; //@line 522 "readclause.cpp"
                  $m=$19; //@line 522 "readclause.cpp"
                  __lastLabel__ = 19; ; //@line 523 "readclause.cpp"
                  $while_cond$31: while(1) { 
  
                    var $20=__lastLabel__ == 30 ? $dec : ($18); //@line 523 "readclause.cpp"
                    var $cmp34=((($20))|0) > 0; //@line 523 "readclause.cpp"
                    if (!($cmp34)) { __label__ = 31;break $while_cond$31; } //@line 523 "readclause.cpp"
  
                    var $call35=__ZL8GetC_getv(); //@line 525 "readclause.cpp"
                    var $21=$ix; //@line 525 "readclause.cpp"
                    var $arrayidx36=(($cbuf+$21*4)&4294967295); //@line 525 "readclause.cpp"
                    HEAP32[(($arrayidx36)>>2)]=$call35; //@line 525 "readclause.cpp"
                    $c2=$call35; //@line 525 "readclause.cpp"
                    var $cmp37=((($call35))|0)==0; //@line 525 "readclause.cpp"
                    if ($cmp37) { __label__ = 22;break $while_cond$31; } //@line 525 "readclause.cpp"
  
                    var $23=$c2; //@line 533 "readclause.cpp"
                    var $and43=($23) & 192; //@line 533 "readclause.cpp"
                    var $cmp44=((($and43))|0)!=128; //@line 533 "readclause.cpp"
                    if ($cmp44) { __label__ = 26;break $while_cond$31; } //@line 533 "readclause.cpp"
  
                    $m=-128; //@line 541 "readclause.cpp"
                    var $28=$c; //@line 542 "readclause.cpp"
                    var $shl=((($28)*64)&4294967295); //@line 542 "readclause.cpp"
                    var $29=$c2; //@line 542 "readclause.cpp"
                    var $and53=($29) & 63; //@line 542 "readclause.cpp"
                    var $add=((($and53)+($shl))&4294967295); //@line 542 "readclause.cpp"
                    $c=$add; //@line 542 "readclause.cpp"
                    var $30=$ix; //@line 543 "readclause.cpp"
                    var $dec=((($30)-1)&4294967295); //@line 543 "readclause.cpp"
                    $ix=$dec; //@line 543 "readclause.cpp"
                    __lastLabel__ = 30; __label__ = 20;continue $while_cond$31; //@line 544 "readclause.cpp"
                  }
                  if (__label__ == 22) {
  
                    var $22=HEAP32[((_option_multibyte)>>2)]; //@line 527 "readclause.cpp"
                    var $cmp39=((($22))|0)==0; //@line 527 "readclause.cpp"
                    if ($cmp39) { __label__ = 23;; } else { __label__ = 24;; } //@line 527 "readclause.cpp"
                    if (__label__ == 23) {
  
                      HEAP32[((_option_multibyte)>>2)]=2; //@line 528 "readclause.cpp"
                      ; //@line 528 "readclause.cpp"
                    }
  
                    __ZL10GetC_ungeti(32); //@line 529 "readclause.cpp"
                    ; //@line 530 "readclause.cpp"
                  }
                  else if (__label__ == 26) {
  
                    var $24=$n_bytes; //@line 536 "readclause.cpp"
                    var $cmp46=((($24))|0)==2; //@line 536 "readclause.cpp"
                    if ($cmp46) { __label__ = 27;; } else { __label__ = 29;; } //@line 536 "readclause.cpp"
                    $land_lhs_true47$$if_end51$42: do { 
                      if (__label__ == 27) {
  
                        var $25=$ix; //@line 536 "readclause.cpp"
                        var $cmp48=((($25))|0)==1; //@line 536 "readclause.cpp"
                        if (!($cmp48)) { __label__ = 29;break $land_lhs_true47$$if_end51$42; } //@line 536 "readclause.cpp"
  
                        var $arrayidx50=(($cbuf+8)&4294967295); //@line 537 "readclause.cpp"
                        var $26=HEAP32[(($arrayidx50)>>2)]; //@line 537 "readclause.cpp"
                        HEAP32[((__ZZL4GetCvE6ungot2)>>2)]=$26; //@line 537 "readclause.cpp"
                        ; //@line 537 "readclause.cpp"
                      }
                    } while(0);
  
                    var $27=$c2; //@line 538 "readclause.cpp"
                    __ZL10GetC_ungeti($27); //@line 538 "readclause.cpp"
                    ; //@line 539 "readclause.cpp"
                  }
  
                  var $31=$ix; //@line 545 "readclause.cpp"
                  var $cmp54=((($31))|0)==0; //@line 545 "readclause.cpp"
                  if (!($cmp54)) { __label__ = 33;break $if_then31$$if_end58$29; } //@line 545 "readclause.cpp"
  
                  var $32=HEAP32[((_count_characters)>>2)]; //@line 547 "readclause.cpp"
                  var $inc56=((($32)+1)&4294967295); //@line 547 "readclause.cpp"
                  HEAP32[((_count_characters)>>2)]=$inc56; //@line 547 "readclause.cpp"
                  var $33=$c; //@line 548 "readclause.cpp"
                  $retval=$33; //@line 548 "readclause.cpp"
                  __label__ = 40;break $if_then$$if_end$2; //@line 548 "readclause.cpp"
                }
              } while(0);
  
              var $34=HEAP32[((_option_multibyte)>>2)]; //@line 552 "readclause.cpp"
              var $cmp59=((($34))|0)==0; //@line 552 "readclause.cpp"
              if (!($cmp59)) { __label__ = 36;break $land_lhs_true$$if_end65thread_pre_split$12; } //@line 552 "readclause.cpp"
  
              var $call61=__Z3Eofv(); //@line 552 "readclause.cpp"
              var $tobool62=((($call61))|0)!=0; //@line 552 "readclause.cpp"
              if ($tobool62) { __label__ = 36;break $land_lhs_true$$if_end65thread_pre_split$12; } //@line 552 "readclause.cpp"
  
              HEAP32[((_option_multibyte)>>2)]=2; //@line 553 "readclause.cpp"
              __label__ = 36;break $land_lhs_true$$if_end65thread_pre_split$12; //@line 553 "readclause.cpp"
            }
          } while(0);
          if (__label__ == 36) {
  
            var $_pr2=$c1; //@line 558 "readclause.cpp"
            __lastLabel__ = 36; ;
          }
  
          var $35=__lastLabel__ == 36 ? $_pr2 : ($9); //@line 558 "readclause.cpp"
          var $36=HEAP32[((_count_characters)>>2)]; //@line 557 "readclause.cpp"
          var $inc66=((($36)+1)&4294967295); //@line 557 "readclause.cpp"
          HEAP32[((_count_characters)>>2)]=$inc66; //@line 557 "readclause.cpp"
          var $cmp67=((($35))|0) >= 160; //@line 558 "readclause.cpp"
          var $37=$c1; //@line 559 "readclause.cpp"
          if ($cmp67) { __label__ = 38;; } else { __label__ = 39;; } //@line 558 "readclause.cpp"
          if (__label__ == 38) {
  
            var $sub=((($37)-160)&4294967295); //@line 559 "readclause.cpp"
            var $38=HEAP32[((_translator)>>2)]; //@line 559 "readclause.cpp"
            var $charset_a0=(($38+696)&4294967295); //@line 559 "readclause.cpp"
            var $39=HEAP32[(($charset_a0)>>2)]; //@line 559 "readclause.cpp"
            var $arrayidx69=(($39+2*$sub)&4294967295); //@line 559 "readclause.cpp"
            var $40=HEAPU16[(($arrayidx69)>>1)]; //@line 559 "readclause.cpp"
            var $conv70=((($40))&65535); //@line 559 "readclause.cpp"
            $retval=$conv70; //@line 559 "readclause.cpp"
            ; //@line 559 "readclause.cpp"
          }
          else if (__label__ == 39) {
  
            $retval=$37; //@line 560 "readclause.cpp"
            ; //@line 560 "readclause.cpp"
          }
        }
      }
    } while(0);
  
    var $41=$retval; //@line 561 "readclause.cpp"
    STACKTOP = __stackBase__;
    return $41; //@line 561 "readclause.cpp"
    return null;
  }
  

  function __ZL6UngetCi($c) {
    ;
    var __label__;
  
    var $c_addr;
    $c_addr=$c;
    var $0=$c_addr; //@line 566 "readclause.cpp"
    HEAP32[((__ZL10ungot_char)>>2)]=$0; //@line 566 "readclause.cpp"
    ;
    return; //@line 567 "readclause.cpp"
    return;
  }
  

  function __ZL14ProcessSsmlTagPwPcRiii($xml_buf, $outbuf, $outix, $n_outbuf, $self_closing) {
    var __stackBase__  = STACKTOP; STACKTOP += 376; _memset(__stackBase__, 0, 376);
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $xml_buf_addr;
    var $outbuf_addr;
    var $outix_addr;
    var $n_outbuf_addr;
    var $self_closing_addr;
    var $ix;
    var $index;
    var $c;
    var $tag_type;
    var $value;
    var $value2;
    var $value3;
    var $voice_change_flag;
    var $px;
    var $attr1;
    var $attr2;
    var $attr3;
    var $terminator;
    var $uri;
    var $param_type;
    var $tag_name=__stackBase__;
    var $buf=__stackBase__+40;
    var $sp;
    var $ssml_sp;
    var $fname=__stackBase__+120;
    $xml_buf_addr=$xml_buf;
    $outbuf_addr=$outbuf;
    $outix_addr=$outix;
    $n_outbuf_addr=$n_outbuf;
    $self_closing_addr=$self_closing;
    $ix=0; //@line 1659 "readclause.cpp"
    __lastLabel__ = 0; ; //@line 1659 "readclause.cpp"
    $for_cond$2: while(1) { 
  
      var $0=__lastLabel__ == 4 ? $inc : (0); //@line 1659 "readclause.cpp"
      var $cmp=((($0))>>>0) < 39; //@line 1659 "readclause.cpp"
      if (!($cmp)) { __label__ = 5;break $for_cond$2; } //@line 1659 "readclause.cpp"
  
      var $1=$ix; //@line 1661 "readclause.cpp"
      var $2=$xml_buf_addr; //@line 1661 "readclause.cpp"
      var $arrayidx=(($2+4*$1)&4294967295); //@line 1661 "readclause.cpp"
      var $3=HEAP32[(($arrayidx)>>2)]; //@line 1661 "readclause.cpp"
      $c=$3; //@line 1661 "readclause.cpp"
      var $cmp1=((($3))|0)==0; //@line 1661 "readclause.cpp"
      if ($cmp1) { __label__ = 5;break $for_cond$2; } //@line 1661 "readclause.cpp"
  
      var $4=$c; //@line 1661 "readclause.cpp"
      var $call=_iswspace($4); //@line 1661 "readclause.cpp"
      var $tobool=((($call))|0)!=0; //@line 1661 "readclause.cpp"
      if ($tobool) { __label__ = 5;break $for_cond$2; } //@line 1661 "readclause.cpp"
  
      var $5=$c; //@line 1663 "readclause.cpp"
      var $conv=((($5)) & 255); //@line 1663 "readclause.cpp"
      var $conv2=(tempInt=(($conv)),(tempInt>=128?tempInt-256:tempInt)); //@line 1663 "readclause.cpp"
      var $call3=_tolower($conv2); //@line 1663 "readclause.cpp"
      var $conv4=((($call3)) & 255); //@line 1663 "readclause.cpp"
      var $6=$ix; //@line 1663 "readclause.cpp"
      var $arrayidx5=(($tag_name+$6)&4294967295); //@line 1663 "readclause.cpp"
      HEAP8[($arrayidx5)]=$conv4; //@line 1663 "readclause.cpp"
      var $7=$ix; //@line 1659 "readclause.cpp"
      var $inc=((($7)+1)&4294967295); //@line 1659 "readclause.cpp"
      $ix=$inc; //@line 1659 "readclause.cpp"
      __lastLabel__ = 4; __label__ = 1;continue $for_cond$2; //@line 1659 "readclause.cpp"
    }
  
    var $8=$ix; //@line 1665 "readclause.cpp"
    var $arrayidx6=(($tag_name+$8)&4294967295); //@line 1665 "readclause.cpp"
    HEAP8[($arrayidx6)]=0; //@line 1665 "readclause.cpp"
    var $9=$ix; //@line 1667 "readclause.cpp"
    var $10=$xml_buf_addr; //@line 1667 "readclause.cpp"
    var $arrayidx7=(($10+4*$9)&4294967295); //@line 1667 "readclause.cpp"
    $px=$arrayidx7; //@line 1667 "readclause.cpp"
    var $arrayidx8=(($tag_name)&4294967295); //@line 1669 "readclause.cpp"
    var $11=HEAP8[($arrayidx8)]; //@line 1669 "readclause.cpp"
    var $conv9=(tempInt=(($11)),(tempInt>=128?tempInt-256:tempInt)); //@line 1669 "readclause.cpp"
    var $cmp10=((($conv9))|0)==47; //@line 1669 "readclause.cpp"
    if ($cmp10) { __label__ = 6;; } else { __label__ = 9;; } //@line 1669 "readclause.cpp"
    $if_then11$$if_else$8: do { 
      if (__label__ == 6) {
  
        var $arrayidx12=(($tag_name+1)&4294967295); //@line 1672 "readclause.cpp"
        var $call13=__Z10LookupMnemP8MNEM_TABPKc(((__ZL8ssmltags)&4294967295), $arrayidx12); //@line 1672 "readclause.cpp"
        $tag_type=$call13; //@line 1672 "readclause.cpp"
        var $cmp14=((($call13))|0)!=16; //@line 1672 "readclause.cpp"
        if ($cmp14) { __label__ = 7;; } else { __label__ = 8;; } //@line 1672 "readclause.cpp"
        if (__label__ == 7) {
  
          var $12=$outix_addr; //@line 1674 "readclause.cpp"
          var $13=HEAP32[(($12)>>2)]; //@line 1674 "readclause.cpp"
          var $inc16=((($13)+1)&4294967295); //@line 1674 "readclause.cpp"
          HEAP32[(($12)>>2)]=$inc16; //@line 1674 "readclause.cpp"
          var $14=$outbuf_addr; //@line 1674 "readclause.cpp"
          var $arrayidx17=(($14+$13)&4294967295); //@line 1674 "readclause.cpp"
          HEAP8[($arrayidx17)]=32; //@line 1674 "readclause.cpp"
          ; //@line 1675 "readclause.cpp"
        }
  
        var $15=$tag_type; //@line 1676 "readclause.cpp"
        var $add=((($15)+32)&4294967295); //@line 1676 "readclause.cpp"
        $tag_type=$add; //@line 1676 "readclause.cpp"
        __lastLabel__ = 8; __label__ = 14;break $if_then11$$if_else$8; //@line 1677 "readclause.cpp"
      }
      else if (__label__ == 9) {
  
        var $arraydecay=(($tag_name)&4294967295); //@line 1680 "readclause.cpp"
        var $call19=__Z10LookupMnemP8MNEM_TABPKc(((__ZL8ssmltags)&4294967295), $arraydecay); //@line 1680 "readclause.cpp"
        $tag_type=$call19; //@line 1680 "readclause.cpp"
        var $cmp20=((($call19))|0)!=16; //@line 1680 "readclause.cpp"
        if ($cmp20) { __label__ = 10;; } else { __label__ = 11;; } //@line 1680 "readclause.cpp"
        if (__label__ == 10) {
  
          var $16=$outix_addr; //@line 1683 "readclause.cpp"
          var $17=HEAP32[(($16)>>2)]; //@line 1683 "readclause.cpp"
          var $inc22=((($17)+1)&4294967295); //@line 1683 "readclause.cpp"
          HEAP32[(($16)>>2)]=$inc22; //@line 1683 "readclause.cpp"
          var $18=$outbuf_addr; //@line 1683 "readclause.cpp"
          var $arrayidx23=(($18+$17)&4294967295); //@line 1683 "readclause.cpp"
          HEAP8[($arrayidx23)]=32; //@line 1683 "readclause.cpp"
          ; //@line 1684 "readclause.cpp"
        }
  
        var $19=$self_closing_addr; //@line 1686 "readclause.cpp"
        var $tobool25=((($19))|0)!=0; //@line 1686 "readclause.cpp"
        var $20=$tag_type; //@line 1686 "readclause.cpp"
        if ($tobool25) { __lastLabel__ = 11; ; } else { __lastLabel__ = 11; __label__ = 14;break $if_then11$$if_else$8; } //@line 1686 "readclause.cpp"
  
        var $arrayidx26=((__ZL22ignore_if_self_closing+$20)&4294967295); //@line 1686 "readclause.cpp"
        var $21=HEAP8[($arrayidx26)]; //@line 1686 "readclause.cpp"
        var $tobool27=(tempInt=(($21)),(tempInt>=128?tempInt-256:tempInt))!=0; //@line 1686 "readclause.cpp"
        if ($tobool27) { __lastLabel__ = 12; ; } else { __lastLabel__ = 12; __label__ = 14;break $if_then11$$if_else$8; } //@line 1686 "readclause.cpp"
  
        $retval=0; //@line 1687 "readclause.cpp"
        __label__ = 113;break $if_then11$$if_else$8; //@line 1687 "readclause.cpp"
      }
    } while(0);
    $if_end30$$return$19: do { 
      if (__label__ == 14) {
  
        var $22=__lastLabel__ == 12 ? $20 : (__lastLabel__ == 8 ? $add : ($20)); //@line 1695 "readclause.cpp"
        $voice_change_flag=0; //@line 1691 "readclause.cpp"
        $terminator=16384; //@line 1692 "readclause.cpp"
        var $23=HEAPU32[((__ZL12n_ssml_stack)>>2)]; //@line 1693 "readclause.cpp"
        var $sub=((($23)-1)&4294967295); //@line 1693 "readclause.cpp"
        var $arrayidx31=((__ZL10ssml_stack+$sub*76)&4294967295); //@line 1693 "readclause.cpp"
        $ssml_sp=$arrayidx31; //@line 1693 "readclause.cpp"
        if ($22 == 10) {
          __lastLabel__ = 14; __label__ = 15;;
        }
        else if ($22 == 3) {
          __lastLabel__ = 14; __label__ = 20;;
        }
        else if ($22 == 12) {
          __lastLabel__ = 14; __label__ = 25;;
        }
        else if ($22 == 42) {
          __lastLabel__ = 14; __label__ = 31;;
        }
        else if ($22 == 35) {
          __lastLabel__ = 14; __label__ = 31;;
        }
        else if ($22 == 44) {
          __lastLabel__ = 14; __label__ = 31;;
        }
        else if ($22 == 4) {
          __lastLabel__ = 14; __label__ = 32;;
        }
        else if ($22 == 36) {
          __lastLabel__ = 14; __label__ = 39;;
        }
        else if ($22 == 9) {
          __lastLabel__ = 14; __label__ = 42;;
        }
        else if ($22 == 14) {
          __lastLabel__ = 14; __label__ = 44;;
        }
        else if ($22 == 41) {
          __lastLabel__ = 14; __label__ = 45;;
        }
        else if ($22 == 46) {
          __lastLabel__ = 14; __label__ = 45;;
        }
        else if ($22 == 5) {
          __lastLabel__ = 14; __label__ = 46;;
        }
        else if ($22 == 11) {
          __lastLabel__ = 14; __label__ = 51;;
        }
        else if ($22 == 43) {
          __lastLabel__ = 14; __label__ = 66;;
        }
        else if ($22 == 13) {
          __lastLabel__ = 14; __label__ = 67;;
        }
        else if ($22 == 1) {
          __lastLabel__ = 14; __label__ = 79;;
        }
        else if ($22 == 2) {
          __lastLabel__ = 14; __label__ = 85;;
        }
        else if ($22 == 33) {
          __lastLabel__ = 14; __label__ = 88;;
        }
        else if ($22 == 34) {
          __lastLabel__ = 14; __label__ = 92;;
        }
        else if ($22 == 15) {
          __lastLabel__ = 14; __label__ = 96;;
        }
        else if ($22 == 47) {
          __lastLabel__ = 14; __label__ = 96;;
        }
        else if ($22 == 6) {
          __lastLabel__ = 14; __label__ = 97;;
        }
        else if ($22 == 7) {
          __lastLabel__ = 14; __label__ = 100;;
        }
        else if ($22 == 38) {
          __lastLabel__ = 14; __label__ = 105;;
        }
        else if ($22 == 39) {
          __lastLabel__ = 14; __label__ = 108;;
        }
        else {
        __lastLabel__ = 14; __label__ = 112;;
        }
        
        $sw_epilog$$sw_bb$$sw_bb49$$sw_bb62$$sw_bb83$$sw_bb84$$sw_bb110$$sw_bb120$$sw_bb129$$sw_bb130$$sw_bb131$$sw_bb156$$sw_bb220$$sw_bb221$$sw_bb249$$sw_bb266$$while_cond$$while_cond280$$sw_bb293$$sw_bb294$$sw_bb302$$sw_bb317$$sw_bb324$21: do { 
          if (__label__ == 15) {
  
            var $24=$tag_type; //@line 1698 "readclause.cpp"
            var $call32=__ZL14PushParamStacki($24); //@line 1698 "readclause.cpp"
            $sp=$call32; //@line 1698 "readclause.cpp"
            var $25=$px; //@line 1699 "readclause.cpp"
            var $call33=__ZL16GetSsmlAttributePwPKc($25, ((__str83250)&4294967295)); //@line 1699 "readclause.cpp"
            $attr1=$call33; //@line 1699 "readclause.cpp"
            var $26=$px; //@line 1700 "readclause.cpp"
            var $call34=__ZL16GetSsmlAttributePwPKc($26, ((__str84251)&4294967295)); //@line 1700 "readclause.cpp"
            $attr2=$call34; //@line 1700 "readclause.cpp"
            var $27=$attr1; //@line 1703 "readclause.cpp"
            var $call35=__ZL7attrcmpPKwPKc($27, ((__str85252)&4294967295)); //@line 1703 "readclause.cpp"
            var $cmp36=((($call35))|0)==0; //@line 1703 "readclause.cpp"
            if ($cmp36) { __label__ = 16;; } else { __label__ = 17;; } //@line 1703 "readclause.cpp"
            $if_then37$$if_else40$23: do { 
              if (__label__ == 16) {
  
                var $28=$attr2; //@line 1705 "readclause.cpp"
                var $call38=__ZL10attrlookupPKwPK8MNEM_TAB($28, ((__ZZL14ProcessSsmlTagPwPcRiiiE10mnem_punct)&4294967295)); //@line 1705 "readclause.cpp"
                $value=$call38; //@line 1705 "readclause.cpp"
                var $29=$value; //@line 1706 "readclause.cpp"
                var $30=$sp; //@line 1706 "readclause.cpp"
                var $parameter=(($30+4)&4294967295); //@line 1706 "readclause.cpp"
                var $arrayidx39=(($parameter+20)&4294967295); //@line 1706 "readclause.cpp"
                HEAP32[(($arrayidx39)>>2)]=$29; //@line 1706 "readclause.cpp"
                ; //@line 1707 "readclause.cpp"
              }
              else if (__label__ == 17) {
  
                var $31=$attr1; //@line 1709 "readclause.cpp"
                var $call41=__ZL7attrcmpPKwPKc($31, ((__str86253)&4294967295)); //@line 1709 "readclause.cpp"
                var $cmp42=((($call41))|0)==0; //@line 1709 "readclause.cpp"
                if (!($cmp42)) { __label__ = 19;break $if_then37$$if_else40$23; } //@line 1709 "readclause.cpp"
  
                var $32=$attr2; //@line 1711 "readclause.cpp"
                var $call44=__ZL10attrlookupPKwPK8MNEM_TAB($32, ((__ZZL14ProcessSsmlTagPwPcRiiiE13mnem_capitals)&4294967295)); //@line 1711 "readclause.cpp"
                $value=$call44; //@line 1711 "readclause.cpp"
                var $33=$value; //@line 1712 "readclause.cpp"
                var $34=$sp; //@line 1712 "readclause.cpp"
                var $parameter45=(($34+4)&4294967295); //@line 1712 "readclause.cpp"
                var $arrayidx46=(($parameter45+24)&4294967295); //@line 1712 "readclause.cpp"
                HEAP32[(($arrayidx46)>>2)]=$33; //@line 1712 "readclause.cpp"
                ; //@line 1713 "readclause.cpp"
              }
            } while(0);
  
            var $35=$outbuf_addr; //@line 1714 "readclause.cpp"
            var $36=$outix_addr; //@line 1714 "readclause.cpp"
            __ZL17ProcessParamStackPcRi($35, $36); //@line 1714 "readclause.cpp"
            ; //@line 1715 "readclause.cpp"
          }
          else if (__label__ == 20) {
  
            var $37=$tag_type; //@line 1718 "readclause.cpp"
            var $call50=__ZL14PushParamStacki($37); //@line 1718 "readclause.cpp"
            $sp=$call50; //@line 1718 "readclause.cpp"
            $param_type=1; //@line 1721 "readclause.cpp"
            ; //@line 1721 "readclause.cpp"
            while(1) { 
  
              var $38=$px; //@line 1723 "readclause.cpp"
              var $39=$param_type; //@line 1723 "readclause.cpp"
              var $arrayidx54=((__ZZL14ProcessSsmlTagPwPcRiiiE12prosody_attr+$39*4)&4294967295); //@line 1723 "readclause.cpp"
              var $40=HEAP32[(($arrayidx54)>>2)]; //@line 1723 "readclause.cpp"
              var $call55=__ZL16GetSsmlAttributePwPKc($38, $40); //@line 1723 "readclause.cpp"
              $attr1=$call55; //@line 1723 "readclause.cpp"
              var $cmp56=((($call55))|0)!=0; //@line 1723 "readclause.cpp"
              if ($cmp56) { __label__ = 22;; } else { __label__ = 23;; } //@line 1723 "readclause.cpp"
              if (__label__ == 22) {
  
                var $41=$param_type; //@line 1725 "readclause.cpp"
                var $42=$attr1; //@line 1725 "readclause.cpp"
                var $43=$sp; //@line 1725 "readclause.cpp"
                __ZL19SetProsodyParameteriPwP11PARAM_STACK($41, $42, $43); //@line 1725 "readclause.cpp"
                ; //@line 1726 "readclause.cpp"
              }
  
              var $44=$param_type; //@line 1721 "readclause.cpp"
              var $inc60=((($44)+1)&4294967295); //@line 1721 "readclause.cpp"
              $param_type=$inc60; //@line 1721 "readclause.cpp"
              var $cmp52=((($inc60))|0) <= 4; //@line 1721 "readclause.cpp"
              if ($cmp52) { __label__ = 21;continue ; } else { __label__ = 24;break ; } //@line 1721 "readclause.cpp"
            }
  
            var $45=$outbuf_addr; //@line 1729 "readclause.cpp"
            var $46=$outix_addr; //@line 1729 "readclause.cpp"
            __ZL17ProcessParamStackPcRi($45, $46); //@line 1729 "readclause.cpp"
            ; //@line 1730 "readclause.cpp"
          }
          else if (__label__ == 25) {
  
            var $47=$tag_type; //@line 1733 "readclause.cpp"
            var $call63=__ZL14PushParamStacki($47); //@line 1733 "readclause.cpp"
            $sp=$call63; //@line 1733 "readclause.cpp"
            $value=3; //@line 1734 "readclause.cpp"
            var $48=$px; //@line 1735 "readclause.cpp"
            var $call64=__ZL16GetSsmlAttributePwPKc($48, ((__str87254)&4294967295)); //@line 1735 "readclause.cpp"
            $attr1=$call64; //@line 1735 "readclause.cpp"
            var $cmp65=((($call64))|0)!=0; //@line 1735 "readclause.cpp"
            if ($cmp65) { __label__ = 26;; } else { __label__ = 27;; } //@line 1735 "readclause.cpp"
            if (__label__ == 26) {
  
              var $49=$attr1; //@line 1737 "readclause.cpp"
              var $call67=__ZL10attrlookupPKwPK8MNEM_TAB($49, ((__ZZL14ProcessSsmlTagPwPcRiiiE13mnem_emphasis)&4294967295)); //@line 1737 "readclause.cpp"
              $value=$call67; //@line 1737 "readclause.cpp"
              ; //@line 1738 "readclause.cpp"
            }
  
            var $50=HEAP32[((_translator)>>2)]; //@line 1740 "readclause.cpp"
            var $langopts=(($50)&4294967295); //@line 1740 "readclause.cpp"
            var $tone_language=(($langopts+224)&4294967295); //@line 1740 "readclause.cpp"
            var $51=HEAP32[(($tone_language)>>2)]; //@line 1740 "readclause.cpp"
            var $cmp69=((($51))|0)==1; //@line 1740 "readclause.cpp"
            var $52=$value; //@line 1745 "readclause.cpp"
            if ($cmp69) { __label__ = 28;; } else { __label__ = 29;; } //@line 1740 "readclause.cpp"
            if (__label__ == 28) {
  
              var $arrayidx71=((__ZZL14ProcessSsmlTagPwPcRiiiE23emphasis_to_pitch_range+$52)&4294967295); //@line 1745 "readclause.cpp"
              var $53=HEAPU8[($arrayidx71)]; //@line 1745 "readclause.cpp"
              var $conv72=((($53))&255); //@line 1745 "readclause.cpp"
              var $54=$sp; //@line 1745 "readclause.cpp"
              var $parameter73=(($54+4)&4294967295); //@line 1745 "readclause.cpp"
              var $arrayidx74=(($parameter73+16)&4294967295); //@line 1745 "readclause.cpp"
              HEAP32[(($arrayidx74)>>2)]=$conv72; //@line 1745 "readclause.cpp"
              var $55=$value; //@line 1746 "readclause.cpp"
              var $arrayidx75=((__ZZL14ProcessSsmlTagPwPcRiiiE18emphasis_to_volume+$55)&4294967295); //@line 1746 "readclause.cpp"
              var $56=HEAPU8[($arrayidx75)]; //@line 1746 "readclause.cpp"
              var $conv76=((($56))&255); //@line 1746 "readclause.cpp"
              var $57=$sp; //@line 1746 "readclause.cpp"
              var $parameter77=(($57+4)&4294967295); //@line 1746 "readclause.cpp"
              var $arrayidx78=(($parameter77+8)&4294967295); //@line 1746 "readclause.cpp"
              HEAP32[(($arrayidx78)>>2)]=$conv76; //@line 1746 "readclause.cpp"
              ; //@line 1747 "readclause.cpp"
            }
            else if (__label__ == 29) {
  
              var $58=$sp; //@line 1750 "readclause.cpp"
              var $parameter80=(($58+4)&4294967295); //@line 1750 "readclause.cpp"
              var $arrayidx81=(($parameter80+48)&4294967295); //@line 1750 "readclause.cpp"
              HEAP32[(($arrayidx81)>>2)]=$52; //@line 1750 "readclause.cpp"
              ;
            }
  
            var $59=$outbuf_addr; //@line 1752 "readclause.cpp"
            var $60=$outix_addr; //@line 1752 "readclause.cpp"
            __ZL17ProcessParamStackPcRi($59, $60); //@line 1752 "readclause.cpp"
            ; //@line 1753 "readclause.cpp"
          }
          else if (__label__ == 31) {
  
            var $61=$tag_type; //@line 1758 "readclause.cpp"
            var $62=$outbuf_addr; //@line 1758 "readclause.cpp"
            var $63=$outix_addr; //@line 1758 "readclause.cpp"
            __ZL13PopParamStackiPcRi($61, $62, $63); //@line 1758 "readclause.cpp"
            ; //@line 1759 "readclause.cpp"
          }
          else if (__label__ == 32) {
  
            var $64=$px; //@line 1762 "readclause.cpp"
            var $call85=__ZL16GetSsmlAttributePwPKc($64, ((__str88255)&4294967295)); //@line 1762 "readclause.cpp"
            $attr1=$call85; //@line 1762 "readclause.cpp"
            var $65=$px; //@line 1763 "readclause.cpp"
            var $call86=__ZL16GetSsmlAttributePwPKc($65, ((__str89256)&4294967295)); //@line 1763 "readclause.cpp"
            $attr2=$call86; //@line 1763 "readclause.cpp"
            var $66=$px; //@line 1764 "readclause.cpp"
            var $call87=__ZL16GetSsmlAttributePwPKc($66, ((__str90257)&4294967295)); //@line 1764 "readclause.cpp"
            $attr3=$call87; //@line 1764 "readclause.cpp"
            var $67=$attr1; //@line 1765 "readclause.cpp"
            var $call88=__ZL10attrlookupPKwPK8MNEM_TAB($67, ((__ZZL14ProcessSsmlTagPwPcRiiiE17mnem_interpret_as)&4294967295)); //@line 1765 "readclause.cpp"
            $value=$call88; //@line 1765 "readclause.cpp"
            var $68=$attr2; //@line 1766 "readclause.cpp"
            var $call89=__ZL10attrlookupPKwPK8MNEM_TAB($68, ((__ZZL14ProcessSsmlTagPwPcRiiiE17mnem_sayas_format)&4294967295)); //@line 1766 "readclause.cpp"
            $value2=$call89; //@line 1766 "readclause.cpp"
            var $69=$value2; //@line 1767 "readclause.cpp"
            var $cmp90=((($69))|0)==1; //@line 1767 "readclause.cpp"
            if ($cmp90) { __label__ = 33;; } else { __label__ = 34;; } //@line 1767 "readclause.cpp"
            if (__label__ == 33) {
  
              $value=19; //@line 1768 "readclause.cpp"
              ; //@line 1768 "readclause.cpp"
            }
  
            var $70=$attr3; //@line 1770 "readclause.cpp"
            var $call93=__ZL10attrnumberPKwii($70, 0, 0); //@line 1770 "readclause.cpp"
            $value3=$call93; //@line 1770 "readclause.cpp"
            var $71=$value; //@line 1772 "readclause.cpp"
            var $cmp94=((($71))|0)==64; //@line 1772 "readclause.cpp"
            if ($cmp94) { __label__ = 35;; } else { __label__ = 38;; } //@line 1772 "readclause.cpp"
            if (__label__ == 35) {
  
              var $72=$value3; //@line 1774 "readclause.cpp"
              var $cmp96=((($72))|0) <= 1; //@line 1774 "readclause.cpp"
              if ($cmp96) { __label__ = 36;; } else { __label__ = 37;; } //@line 1774 "readclause.cpp"
              if (__label__ == 36) {
  
                $value=193; //@line 1775 "readclause.cpp"
                ; //@line 1775 "readclause.cpp"
              }
              else if (__label__ == 37) {
  
                var $73=$value3; //@line 1777 "readclause.cpp"
                var $add99=((($73)+64)&4294967295); //@line 1777 "readclause.cpp"
                $value=$add99; //@line 1777 "readclause.cpp"
                ;
              }
            }
  
            var $arraydecay102=(($buf)&4294967295); //@line 1780 "readclause.cpp"
            var $74=$value; //@line 1780 "readclause.cpp"
            var $call103=_sprintf($arraydecay102, ((__str91258)&4294967295), allocate([1,0,0,0,$74,0,0,0], ["i32",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 1780 "readclause.cpp"
            var $75=$outix_addr; //@line 1781 "readclause.cpp"
            var $76=HEAP32[(($75)>>2)]; //@line 1781 "readclause.cpp"
            var $77=$outbuf_addr; //@line 1781 "readclause.cpp"
            var $arrayidx104=(($77+$76)&4294967295); //@line 1781 "readclause.cpp"
            var $arraydecay105=(($buf)&4294967295); //@line 1781 "readclause.cpp"
            var $call106=_strcpy($arrayidx104, $arraydecay105); //@line 1781 "readclause.cpp"
            var $arraydecay107=(($buf)&4294967295); //@line 1782 "readclause.cpp"
            var $call108=_strlen($arraydecay107); //@line 1782 "readclause.cpp"
            var $78=$outix_addr; //@line 1782 "readclause.cpp"
            var $79=HEAP32[(($78)>>2)]; //@line 1782 "readclause.cpp"
            var $add109=((($79)+($call108))&4294967295); //@line 1782 "readclause.cpp"
            HEAP32[(($78)>>2)]=$add109; //@line 1782 "readclause.cpp"
            var $80=$outix_addr; //@line 1784 "readclause.cpp"
            var $81=HEAP32[(($80)>>2)]; //@line 1784 "readclause.cpp"
            HEAP32[((__ZL11sayas_start)>>2)]=$81; //@line 1784 "readclause.cpp"
            var $82=$value; //@line 1785 "readclause.cpp"
            HEAP32[((__ZL10sayas_mode)>>2)]=$82; //@line 1785 "readclause.cpp"
            ; //@line 1786 "readclause.cpp"
          }
          else if (__label__ == 39) {
  
            var $83=HEAP32[((__ZL10sayas_mode)>>2)]; //@line 1789 "readclause.cpp"
            var $cmp111=((($83))|0)==36; //@line 1789 "readclause.cpp"
            if ($cmp111) { __label__ = 40;; } else { __label__ = 41;; } //@line 1789 "readclause.cpp"
            if (__label__ == 40) {
  
              var $84=$outix_addr; //@line 1791 "readclause.cpp"
              var $85=HEAP32[(($84)>>2)]; //@line 1791 "readclause.cpp"
              var $86=$outbuf_addr; //@line 1791 "readclause.cpp"
              var $arrayidx113=(($86+$85)&4294967295); //@line 1791 "readclause.cpp"
              HEAP8[($arrayidx113)]=0; //@line 1791 "readclause.cpp"
              var $87=$outbuf_addr; //@line 1792 "readclause.cpp"
              var $88=HEAP32[((__ZL11sayas_start)>>2)]; //@line 1792 "readclause.cpp"
              var $89=$outix_addr; //@line 1792 "readclause.cpp"
              __ZL14ReplaceKeyNamePciRi($87, $88, $89); //@line 1792 "readclause.cpp"
              ; //@line 1793 "readclause.cpp"
            }
  
            var $90=$outix_addr; //@line 1795 "readclause.cpp"
            var $91=HEAP32[(($90)>>2)]; //@line 1795 "readclause.cpp"
            var $inc116=((($91)+1)&4294967295); //@line 1795 "readclause.cpp"
            HEAP32[(($90)>>2)]=$inc116; //@line 1795 "readclause.cpp"
            var $92=$outbuf_addr; //@line 1795 "readclause.cpp"
            var $arrayidx117=(($92+$91)&4294967295); //@line 1795 "readclause.cpp"
            HEAP8[($arrayidx117)]=1; //@line 1795 "readclause.cpp"
            var $93=$outix_addr; //@line 1796 "readclause.cpp"
            var $94=HEAP32[(($93)>>2)]; //@line 1796 "readclause.cpp"
            var $inc118=((($94)+1)&4294967295); //@line 1796 "readclause.cpp"
            HEAP32[(($93)>>2)]=$inc118; //@line 1796 "readclause.cpp"
            var $95=$outbuf_addr; //@line 1796 "readclause.cpp"
            var $arrayidx119=(($95+$94)&4294967295); //@line 1796 "readclause.cpp"
            HEAP8[($arrayidx119)]=89; //@line 1796 "readclause.cpp"
            HEAP32[((__ZL10sayas_mode)>>2)]=0; //@line 1797 "readclause.cpp"
            ; //@line 1798 "readclause.cpp"
          }
          else if (__label__ == 42) {
  
            var $96=$px; //@line 1801 "readclause.cpp"
            var $call121=__ZL16GetSsmlAttributePwPKc($96, ((__str92259)&4294967295)); //@line 1801 "readclause.cpp"
            $attr1=$call121; //@line 1801 "readclause.cpp"
            var $cmp122=((($call121))|0)!=0; //@line 1801 "readclause.cpp"
            if (!($cmp122)) { __label__ = 112;break $sw_epilog$$sw_bb$$sw_bb49$$sw_bb62$$sw_bb83$$sw_bb84$$sw_bb110$$sw_bb120$$sw_bb129$$sw_bb130$$sw_bb131$$sw_bb156$$sw_bb220$$sw_bb221$$sw_bb249$$sw_bb266$$while_cond$$while_cond280$$sw_bb293$$sw_bb294$$sw_bb302$$sw_bb317$$sw_bb324$21; } //@line 1801 "readclause.cpp"
  
            HEAP8[(__ZL11ignore_text_b)]=1;
            var $97=$outix_addr; //@line 1805 "readclause.cpp"
            var $98=HEAP32[(($97)>>2)]; //@line 1805 "readclause.cpp"
            var $99=$outbuf_addr; //@line 1805 "readclause.cpp"
            var $arrayidx124=(($99+$98)&4294967295); //@line 1805 "readclause.cpp"
            var $100=$attr1; //@line 1805 "readclause.cpp"
            var $101=$n_outbuf_addr; //@line 1805 "readclause.cpp"
            var $102=$outix_addr; //@line 1805 "readclause.cpp"
            var $103=HEAP32[(($102)>>2)]; //@line 1805 "readclause.cpp"
            var $sub125=((($101)-($103))&4294967295); //@line 1805 "readclause.cpp"
            var $call126=__ZL13attrcopy_utf8PcPKwi($arrayidx124, $100, $sub125); //@line 1805 "readclause.cpp"
            var $104=$outix_addr; //@line 1805 "readclause.cpp"
            var $105=HEAP32[(($104)>>2)]; //@line 1805 "readclause.cpp"
            var $add127=((($105)+($call126))&4294967295); //@line 1805 "readclause.cpp"
            HEAP32[(($104)>>2)]=$add127; //@line 1805 "readclause.cpp"
            ; //@line 1806 "readclause.cpp"
          }
          else if (__label__ == 44) {
  
            HEAP8[(__ZL11ignore_text_b)]=1;
            ; //@line 1811 "readclause.cpp"
          }
          else if (__label__ == 45) {
  
            HEAP8[(__ZL11ignore_text_b)]=0;
            ; //@line 1816 "readclause.cpp"
          }
          else if (__label__ == 46) {
  
            var $106=$px; //@line 1819 "readclause.cpp"
            var $call132=__ZL16GetSsmlAttributePwPKc($106, ((__str5655)&4294967295)); //@line 1819 "readclause.cpp"
            $attr1=$call132; //@line 1819 "readclause.cpp"
            var $cmp133=((($call132))|0)!=0; //@line 1819 "readclause.cpp"
            if (!($cmp133)) { __label__ = 112;break $sw_epilog$$sw_bb$$sw_bb49$$sw_bb62$$sw_bb83$$sw_bb84$$sw_bb110$$sw_bb120$$sw_bb129$$sw_bb130$$sw_bb131$$sw_bb156$$sw_bb220$$sw_bb221$$sw_bb249$$sw_bb266$$while_cond$$while_cond280$$sw_bb293$$sw_bb294$$sw_bb302$$sw_bb317$$sw_bb324$21; } //@line 1819 "readclause.cpp"
  
            var $arraydecay135=(($buf)&4294967295); //@line 1822 "readclause.cpp"
            var $107=$attr1; //@line 1822 "readclause.cpp"
            var $call136=__ZL13attrcopy_utf8PcPKwi($arraydecay135, $107, 80); //@line 1822 "readclause.cpp"
            var $arraydecay137=(($buf)&4294967295); //@line 1824 "readclause.cpp"
            var $call138=_strcmp(((_skip_marker)&4294967295), $arraydecay137); //@line 1824 "readclause.cpp"
            var $cmp139=((($call138))|0)==0; //@line 1824 "readclause.cpp"
            if ($cmp139) { __label__ = 48;; } else { __label__ = 49;; } //@line 1824 "readclause.cpp"
            if (__label__ == 48) {
  
              HEAP8[(__ZL19clear_skipping_text_b)]=1;
              HEAP8[(((_skip_marker)&4294967295))]=0; //@line 1828 "readclause.cpp"
              $retval=16384; //@line 1829 "readclause.cpp"
              __label__ = 113;break $if_end30$$return$19; //@line 1829 "readclause.cpp"
            }
            else if (__label__ == 49) {
  
              var $arraydecay142=(($buf)&4294967295); //@line 1832 "readclause.cpp"
              var $call143=__Z11AddNameDataPKci($arraydecay142, 0); //@line 1832 "readclause.cpp"
              $index=$call143; //@line 1832 "readclause.cpp"
              var $cmp144=((($call143))|0) >= 0; //@line 1832 "readclause.cpp"
              if (!($cmp144)) { __label__ = 112;break $sw_epilog$$sw_bb$$sw_bb49$$sw_bb62$$sw_bb83$$sw_bb84$$sw_bb110$$sw_bb120$$sw_bb129$$sw_bb130$$sw_bb131$$sw_bb156$$sw_bb220$$sw_bb221$$sw_bb249$$sw_bb266$$while_cond$$while_cond280$$sw_bb293$$sw_bb294$$sw_bb302$$sw_bb317$$sw_bb324$21; } //@line 1832 "readclause.cpp"
  
              var $arraydecay146=(($buf)&4294967295); //@line 1834 "readclause.cpp"
              var $108=$index; //@line 1834 "readclause.cpp"
              var $call147=_sprintf($arraydecay146, ((__str94261)&4294967295), allocate([1,0,0,0,$108,0,0,0], ["i32",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 1834 "readclause.cpp"
              var $109=$outix_addr; //@line 1835 "readclause.cpp"
              var $110=HEAP32[(($109)>>2)]; //@line 1835 "readclause.cpp"
              var $111=$outbuf_addr; //@line 1835 "readclause.cpp"
              var $arrayidx148=(($111+$110)&4294967295); //@line 1835 "readclause.cpp"
              var $arraydecay149=(($buf)&4294967295); //@line 1835 "readclause.cpp"
              var $call150=_strcpy($arrayidx148, $arraydecay149); //@line 1835 "readclause.cpp"
              var $arraydecay151=(($buf)&4294967295); //@line 1836 "readclause.cpp"
              var $call152=_strlen($arraydecay151); //@line 1836 "readclause.cpp"
              var $112=$outix_addr; //@line 1836 "readclause.cpp"
              var $113=HEAP32[(($112)>>2)]; //@line 1836 "readclause.cpp"
              var $add153=((($113)+($call152))&4294967295); //@line 1836 "readclause.cpp"
              HEAP32[(($112)>>2)]=$add153; //@line 1836 "readclause.cpp"
              ; //@line 1837 "readclause.cpp"
            }
          }
          else if (__label__ == 51) {
  
            var $114=$tag_type; //@line 1842 "readclause.cpp"
            var $call157=__ZL14PushParamStacki($114); //@line 1842 "readclause.cpp"
            $sp=$call157; //@line 1842 "readclause.cpp"
            var $115=$px; //@line 1844 "readclause.cpp"
            var $call158=__ZL16GetSsmlAttributePwPKc($115, ((__str95262)&4294967295)); //@line 1844 "readclause.cpp"
            $attr1=$call158; //@line 1844 "readclause.cpp"
            var $cmp159=((($call158))|0)!=0; //@line 1844 "readclause.cpp"
            if ($cmp159) { __label__ = 52;; } else { __label__ = 62;; } //@line 1844 "readclause.cpp"
            $if_then160$$if_end215$69: do { 
              if (__label__ == 52) {
  
                var $arraydecay161=(($buf)&4294967295); //@line 1847 "readclause.cpp"
                var $116=$attr1; //@line 1847 "readclause.cpp"
                var $call162=__ZL13attrcopy_utf8PcPKwi($arraydecay161, $116, 80); //@line 1847 "readclause.cpp"
                var $117=HEAP32[((_uri_callback)>>2)]; //@line 1849 "readclause.cpp"
                var $cmp163=((($117))|0)==0; //@line 1849 "readclause.cpp"
                if ($cmp163) { __label__ = 53;; } else { __label__ = 59;; } //@line 1849 "readclause.cpp"
                if (__label__ == 53) {
  
                  var $118=HEAP32[((__ZL7xmlbase)>>2)]; //@line 1851 "readclause.cpp"
                  var $cmp165=((($118))|0)!=0; //@line 1851 "readclause.cpp"
                  if ($cmp165) { __label__ = 54;; } else { __label__ = 56;; } //@line 1851 "readclause.cpp"
                  $land_lhs_true166$$if_else176$73: do { 
                    if (__label__ == 54) {
  
                      var $arrayidx167=(($buf)&4294967295); //@line 1851 "readclause.cpp"
                      var $119=HEAP8[($arrayidx167)]; //@line 1851 "readclause.cpp"
                      var $conv168=(tempInt=(($119)),(tempInt>=128?tempInt-256:tempInt)); //@line 1851 "readclause.cpp"
                      var $cmp169=((($conv168))|0)!=47; //@line 1851 "readclause.cpp"
                      if (!($cmp169)) { __label__ = 56;break $land_lhs_true166$$if_else176$73; } //@line 1851 "readclause.cpp"
  
                      var $arraydecay171=(($fname)&4294967295); //@line 1853 "readclause.cpp"
                      var $120=HEAP32[((__ZL7xmlbase)>>2)]; //@line 1853 "readclause.cpp"
                      var $arraydecay172=(($buf)&4294967295); //@line 1853 "readclause.cpp"
                      var $call173=_sprintf($arraydecay171, ((__str96263)&4294967295), allocate([$120,0,0,0,$arraydecay172,0,0,0], ["i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 1853 "readclause.cpp"
                      var $arraydecay174=(($fname)&4294967295); //@line 1854 "readclause.cpp"
                      var $call175=__ZL14LoadSoundFile2PKc($arraydecay174); //@line 1854 "readclause.cpp"
                      $index=$call175; //@line 1854 "readclause.cpp"
                      __lastLabel__ = 55; __label__ = 57;break $land_lhs_true166$$if_else176$73; //@line 1855 "readclause.cpp"
                    }
                  } while(0);
                  if (__label__ == 56) {
  
                    var $arraydecay177=(($buf)&4294967295); //@line 1858 "readclause.cpp"
                    var $call178=__ZL14LoadSoundFile2PKc($arraydecay177); //@line 1858 "readclause.cpp"
                    $index=$call178; //@line 1858 "readclause.cpp"
                    __lastLabel__ = 56; ;
                  }
  
                  var $121=__lastLabel__ == 56 ? $call178 : ($call175); //@line 1860 "readclause.cpp"
                  var $cmp180=((($121))|0) >= 0; //@line 1860 "readclause.cpp"
                  if (!($cmp180)) { __label__ = 62;break $if_then160$$if_end215$69; } //@line 1860 "readclause.cpp"
  
                  var $arraydecay182=(($buf)&4294967295); //@line 1862 "readclause.cpp"
                  var $122=$index; //@line 1862 "readclause.cpp"
                  var $call183=_sprintf($arraydecay182, ((__str97264)&4294967295), allocate([1,0,0,0,$122,0,0,0], ["i32",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 1862 "readclause.cpp"
                  var $123=$outix_addr; //@line 1863 "readclause.cpp"
                  var $124=HEAP32[(($123)>>2)]; //@line 1863 "readclause.cpp"
                  var $125=$outbuf_addr; //@line 1863 "readclause.cpp"
                  var $arrayidx184=(($125+$124)&4294967295); //@line 1863 "readclause.cpp"
                  var $arraydecay185=(($buf)&4294967295); //@line 1863 "readclause.cpp"
                  var $call186=_strcpy($arrayidx184, $arraydecay185); //@line 1863 "readclause.cpp"
                  var $arraydecay187=(($buf)&4294967295); //@line 1864 "readclause.cpp"
                  var $call188=_strlen($arraydecay187); //@line 1864 "readclause.cpp"
                  var $126=$outix_addr; //@line 1864 "readclause.cpp"
                  var $127=HEAP32[(($126)>>2)]; //@line 1864 "readclause.cpp"
                  var $add189=((($127)+($call188))&4294967295); //@line 1864 "readclause.cpp"
                  HEAP32[(($126)>>2)]=$add189; //@line 1864 "readclause.cpp"
                  var $128=$sp; //@line 1865 "readclause.cpp"
                  var $parameter190=(($128+4)&4294967295); //@line 1865 "readclause.cpp"
                  var $arrayidx191=(($parameter190)&4294967295); //@line 1865 "readclause.cpp"
                  HEAP32[(($arrayidx191)>>2)]=1; //@line 1865 "readclause.cpp"
                  ; //@line 1866 "readclause.cpp"
                }
                else if (__label__ == 59) {
  
                  var $arraydecay194=(($buf)&4294967295); //@line 1870 "readclause.cpp"
                  var $call195=__Z11AddNameDataPKci($arraydecay194, 0); //@line 1870 "readclause.cpp"
                  $index=$call195; //@line 1870 "readclause.cpp"
                  var $cmp196=((($call195))|0) >= 0; //@line 1870 "readclause.cpp"
                  if (!($cmp196)) { __label__ = 62;break $if_then160$$if_end215$69; } //@line 1870 "readclause.cpp"
  
                  var $129=$index; //@line 1872 "readclause.cpp"
                  var $130=HEAP32[((_namedata)>>2)]; //@line 1872 "readclause.cpp"
                  var $arrayidx198=(($130+$129)&4294967295); //@line 1872 "readclause.cpp"
                  $uri=$arrayidx198; //@line 1872 "readclause.cpp"
                  var $131=HEAP32[((_uri_callback)>>2)]; //@line 1873 "readclause.cpp"
                  var $132=$uri; //@line 1873 "readclause.cpp"
                  var $133=HEAP32[((__ZL7xmlbase)>>2)]; //@line 1873 "readclause.cpp"
                  var $call199=FUNCTION_TABLE[$131](1, $132, $133); //@line 1873 "readclause.cpp"
                  var $cmp200=((($call199))|0)==0; //@line 1873 "readclause.cpp"
                  if (!($cmp200)) { __label__ = 62;break $if_then160$$if_end215$69; } //@line 1873 "readclause.cpp"
  
                  var $arraydecay202=(($buf)&4294967295); //@line 1875 "readclause.cpp"
                  var $134=$index; //@line 1875 "readclause.cpp"
                  var $call203=_sprintf($arraydecay202, ((__str98265)&4294967295), allocate([1,0,0,0,$134,0,0,0], ["i32",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 1875 "readclause.cpp"
                  var $135=$outix_addr; //@line 1876 "readclause.cpp"
                  var $136=HEAP32[(($135)>>2)]; //@line 1876 "readclause.cpp"
                  var $137=$outbuf_addr; //@line 1876 "readclause.cpp"
                  var $arrayidx204=(($137+$136)&4294967295); //@line 1876 "readclause.cpp"
                  var $arraydecay205=(($buf)&4294967295); //@line 1876 "readclause.cpp"
                  var $call206=_strcpy($arrayidx204, $arraydecay205); //@line 1876 "readclause.cpp"
                  var $arraydecay207=(($buf)&4294967295); //@line 1877 "readclause.cpp"
                  var $call208=_strlen($arraydecay207); //@line 1877 "readclause.cpp"
                  var $138=$outix_addr; //@line 1877 "readclause.cpp"
                  var $139=HEAP32[(($138)>>2)]; //@line 1877 "readclause.cpp"
                  var $add209=((($139)+($call208))&4294967295); //@line 1877 "readclause.cpp"
                  HEAP32[(($138)>>2)]=$add209; //@line 1877 "readclause.cpp"
                  var $140=$sp; //@line 1878 "readclause.cpp"
                  var $parameter210=(($140+4)&4294967295); //@line 1878 "readclause.cpp"
                  var $arrayidx211=(($parameter210)&4294967295); //@line 1878 "readclause.cpp"
                  HEAP32[(($arrayidx211)>>2)]=1; //@line 1878 "readclause.cpp"
                  ; //@line 1879 "readclause.cpp"
                }
              }
            } while(0);
  
            var $141=$outbuf_addr; //@line 1883 "readclause.cpp"
            var $142=$outix_addr; //@line 1883 "readclause.cpp"
            __ZL17ProcessParamStackPcRi($141, $142); //@line 1883 "readclause.cpp"
            var $143=$self_closing_addr; //@line 1885 "readclause.cpp"
            var $tobool216=((($143))|0)!=0; //@line 1885 "readclause.cpp"
            if ($tobool216) { __label__ = 63;; } else { __label__ = 64;; } //@line 1885 "readclause.cpp"
            if (__label__ == 63) {
  
              var $144=$tag_type; //@line 1886 "readclause.cpp"
              var $145=$outbuf_addr; //@line 1886 "readclause.cpp"
              var $146=$outix_addr; //@line 1886 "readclause.cpp"
              __ZL13PopParamStackiPcRi($144, $145, $146); //@line 1886 "readclause.cpp"
              ; //@line 1886 "readclause.cpp"
            }
            else if (__label__ == 64) {
  
              HEAP8[(__ZL10audio_text_b)]=1;
              ;
            }
  
            $retval=16384; //@line 1889 "readclause.cpp"
            __label__ = 113;break $if_end30$$return$19; //@line 1889 "readclause.cpp"
          }
          else if (__label__ == 66) {
  
            var $147=$tag_type; //@line 1892 "readclause.cpp"
            var $148=$outbuf_addr; //@line 1892 "readclause.cpp"
            var $149=$outix_addr; //@line 1892 "readclause.cpp"
            __ZL13PopParamStackiPcRi($147, $148, $149); //@line 1892 "readclause.cpp"
            HEAP8[(__ZL10audio_text_b)]=0;
            $retval=16384; //@line 1894 "readclause.cpp"
            __label__ = 113;break $if_end30$$return$19; //@line 1894 "readclause.cpp"
          }
          else if (__label__ == 67) {
  
            $value=21; //@line 1897 "readclause.cpp"
            $terminator=16384; //@line 1898 "readclause.cpp"
            var $150=$px; //@line 1900 "readclause.cpp"
            var $call222=__ZL16GetSsmlAttributePwPKc($150, ((__str99266)&4294967295)); //@line 1900 "readclause.cpp"
            $attr1=$call222; //@line 1900 "readclause.cpp"
            var $cmp223=((($call222))|0)!=0; //@line 1900 "readclause.cpp"
            if ($cmp223) { __label__ = 68;; } else { __label__ = 71;; } //@line 1900 "readclause.cpp"
            if (__label__ == 68) {
  
              var $151=$attr1; //@line 1903 "readclause.cpp"
              var $call225=__ZL10attrlookupPKwPK8MNEM_TAB($151, ((__ZZL14ProcessSsmlTagPwPcRiiiE10mnem_break)&4294967295)); //@line 1903 "readclause.cpp"
              $value=$call225; //@line 1903 "readclause.cpp"
              var $152=$value; //@line 1904 "readclause.cpp"
              var $cmp226=((($152))|0) < 3; //@line 1904 "readclause.cpp"
              if ($cmp226) { __label__ = 69;; } else { __label__ = 70;; } //@line 1904 "readclause.cpp"
              if (__label__ == 69) {
  
                var $153=$outix_addr; //@line 1907 "readclause.cpp"
                var $154=HEAP32[(($153)>>2)]; //@line 1907 "readclause.cpp"
                var $155=$outbuf_addr; //@line 1907 "readclause.cpp"
                var $arrayidx228=(($155+$154)&4294967295); //@line 1907 "readclause.cpp"
                var $156=$value; //@line 1907 "readclause.cpp"
                var $call229=_sprintf($arrayidx228, ((__str100267)&4294967295), allocate([1,0,0,0,$156,0,0,0], ["i32",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 1907 "readclause.cpp"
                var $157=$outix_addr; //@line 1908 "readclause.cpp"
                var $158=HEAP32[(($157)>>2)]; //@line 1908 "readclause.cpp"
                var $add230=((($158)+3)&4294967295); //@line 1908 "readclause.cpp"
                HEAP32[(($157)>>2)]=$add230; //@line 1908 "readclause.cpp"
                $terminator=0; //@line 1909 "readclause.cpp"
                ; //@line 1910 "readclause.cpp"
              }
  
              var $159=$value; //@line 1911 "readclause.cpp"
              var $arrayidx232=((__ZZL14ProcessSsmlTagPwPcRiiiE11break_value+$159*4)&4294967295); //@line 1911 "readclause.cpp"
              var $160=HEAP32[(($arrayidx232)>>2)]; //@line 1911 "readclause.cpp"
              $value=$160; //@line 1911 "readclause.cpp"
              ; //@line 1912 "readclause.cpp"
            }
  
            var $161=$px; //@line 1913 "readclause.cpp"
            var $call234=__ZL16GetSsmlAttributePwPKc($161, ((__str101268)&4294967295)); //@line 1913 "readclause.cpp"
            $attr2=$call234; //@line 1913 "readclause.cpp"
            var $cmp235=((($call234))|0)!=0; //@line 1913 "readclause.cpp"
            if ($cmp235) { __label__ = 72;; } else { __label__ = 74;; } //@line 1913 "readclause.cpp"
            $if_then236$$if_end241$96: do { 
              if (__label__ == 72) {
  
                var $162=$attr2; //@line 1915 "readclause.cpp"
                var $call237=__ZL10attrnumberPKwii($162, 0, 1); //@line 1915 "readclause.cpp"
                var $mul=((($call237)*25)&4294967295); //@line 1915 "readclause.cpp"
                var $163=HEAP32[((((_speed)&4294967295))>>2)]; //@line 1915 "readclause.cpp"
                var $div=((((($mul))|0)/((($163))|0))|0); //@line 1915 "readclause.cpp"
                $value=$div; //@line 1915 "readclause.cpp"
                var $164=$terminator; //@line 1917 "readclause.cpp"
                var $cmp238=((($164))|0)==0; //@line 1917 "readclause.cpp"
                if ($cmp238) { __lastLabel__ = 72; ; } else { __lastLabel__ = 72; __label__ = 76;break $if_then236$$if_end241$96; } //@line 1917 "readclause.cpp"
  
                $terminator=16384; //@line 1918 "readclause.cpp"
                __label__ = 75;break $if_then236$$if_end241$96; //@line 1918 "readclause.cpp"
              }
              else if (__label__ == 74) {
  
                var $_pr1=$terminator; //@line 1920 "readclause.cpp"
                var $tobool242=((($_pr1))|0)!=0; //@line 1920 "readclause.cpp"
                if ($tobool242) { __label__ = 75;break $if_then236$$if_end241$96; } else { __label__ = 112;break $sw_epilog$$sw_bb$$sw_bb49$$sw_bb62$$sw_bb83$$sw_bb84$$sw_bb110$$sw_bb120$$sw_bb129$$sw_bb130$$sw_bb131$$sw_bb156$$sw_bb220$$sw_bb221$$sw_bb249$$sw_bb266$$while_cond$$while_cond280$$sw_bb293$$sw_bb294$$sw_bb302$$sw_bb317$$sw_bb324$21; } //@line 1920 "readclause.cpp"
              }
            } while(0);
            if (__label__ == 75) {
  
              var $_pr3=$value; //@line 1922 "readclause.cpp"
              __lastLabel__ = 75; ;
            }
  
            var $165=__lastLabel__ == 75 ? $_pr3 : ($div); //@line 1922 "readclause.cpp"
            var $cmp244=((($165))|0) > 4095; //@line 1922 "readclause.cpp"
            if ($cmp244) { __label__ = 77;; } else { __label__ = 78;; } //@line 1922 "readclause.cpp"
            if (__label__ == 77) {
  
              $value=4095; //@line 1923 "readclause.cpp"
              ; //@line 1923 "readclause.cpp"
            }
  
            var $166=$terminator; //@line 1924 "readclause.cpp"
            var $167=$value; //@line 1924 "readclause.cpp"
            var $add247=((($167)+($166))&4294967295); //@line 1924 "readclause.cpp"
            $retval=$add247; //@line 1924 "readclause.cpp"
            __label__ = 113;break $if_end30$$return$19; //@line 1924 "readclause.cpp"
          }
          else if (__label__ == 79) {
  
            var $168=$px; //@line 1929 "readclause.cpp"
            var $call250=__ZL16GetSsmlAttributePwPKc($168, ((__str102269)&4294967295)); //@line 1929 "readclause.cpp"
            $attr1=$call250; //@line 1929 "readclause.cpp"
            var $cmp251=((($call250))|0)!=0; //@line 1929 "readclause.cpp"
            if ($cmp251) { __label__ = 80;; } else { __label__ = 82;; } //@line 1929 "readclause.cpp"
            $if_then252$$if_end261$107: do { 
              if (__label__ == 80) {
  
                var $arraydecay253=(($buf)&4294967295); //@line 1931 "readclause.cpp"
                var $169=$attr1; //@line 1931 "readclause.cpp"
                var $call254=__ZL13attrcopy_utf8PcPKwi($arraydecay253, $169, 80); //@line 1931 "readclause.cpp"
                var $arraydecay255=(($buf)&4294967295); //@line 1932 "readclause.cpp"
                var $call256=__Z11AddNameDataPKci($arraydecay255, 0); //@line 1932 "readclause.cpp"
                $index=$call256; //@line 1932 "readclause.cpp"
                var $cmp257=((($call256))|0) >= 0; //@line 1932 "readclause.cpp"
                if (!($cmp257)) { __label__ = 82;break $if_then252$$if_end261$107; } //@line 1932 "readclause.cpp"
  
                var $170=$index; //@line 1934 "readclause.cpp"
                var $171=HEAP32[((_namedata)>>2)]; //@line 1934 "readclause.cpp"
                var $arrayidx259=(($171+$170)&4294967295); //@line 1934 "readclause.cpp"
                HEAP32[((__ZL7xmlbase)>>2)]=$arrayidx259; //@line 1934 "readclause.cpp"
                ; //@line 1935 "readclause.cpp"
              }
            } while(0);
  
            var $172=$px; //@line 1937 "readclause.cpp"
            var $173=$tag_type; //@line 1937 "readclause.cpp"
            var $call262=__ZL18GetVoiceAttributesPwi($172, $173); //@line 1937 "readclause.cpp"
            var $cmp263=((($call262))|0)==0; //@line 1937 "readclause.cpp"
            if ($cmp263) { __label__ = 83;; } else { __label__ = 84;; } //@line 1937 "readclause.cpp"
            if (__label__ == 83) {
  
              $retval=0; //@line 1938 "readclause.cpp"
              __label__ = 113;break $if_end30$$return$19; //@line 1938 "readclause.cpp"
            }
            else if (__label__ == 84) {
  
              $retval=147456; //@line 1939 "readclause.cpp"
              __label__ = 113;break $if_end30$$return$19; //@line 1939 "readclause.cpp"
            }
          }
          else if (__label__ == 85) {
  
            var $174=$px; //@line 1942 "readclause.cpp"
            var $175=$tag_type; //@line 1942 "readclause.cpp"
            var $call267=__ZL18GetVoiceAttributesPwi($174, $175); //@line 1942 "readclause.cpp"
            var $cmp268=((($call267))|0)==0; //@line 1942 "readclause.cpp"
            if ($cmp268) { __label__ = 86;; } else { __label__ = 87;; } //@line 1942 "readclause.cpp"
            if (__label__ == 86) {
  
              $retval=0; //@line 1943 "readclause.cpp"
              __label__ = 113;break $if_end30$$return$19; //@line 1943 "readclause.cpp"
            }
            else if (__label__ == 87) {
  
              $retval=147456; //@line 1944 "readclause.cpp"
              __label__ = 113;break $if_end30$$return$19; //@line 1944 "readclause.cpp"
            }
          }
          else if (__label__ == 88) {
            while(1) { 
  
              var $176=__lastLabel__ == 90 ? $dec : ($23); //@line 1948 "readclause.cpp"
              var $cmp272=((($176))|0) > 1; //@line 1948 "readclause.cpp"
              if (!($cmp272)) { __label__ = 91;break ; } //@line 1948 "readclause.cpp"
  
              var $177=HEAP32[((__ZL12n_ssml_stack)>>2)]; //@line 1948 "readclause.cpp"
              var $sub273=((($177)-1)&4294967295); //@line 1948 "readclause.cpp"
              var $arrayidx274=((__ZL10ssml_stack+$sub273*76)&4294967295); //@line 1948 "readclause.cpp"
              var $tag_type275=(($arrayidx274)&4294967295); //@line 1948 "readclause.cpp"
              var $178=HEAP32[(($tag_type275)>>2)]; //@line 1948 "readclause.cpp"
              var $cmp276=((($178))|0)!=1; //@line 1948 "readclause.cpp"
              if (!($cmp276)) { __label__ = 91;break ; }
  
              var $179=HEAP32[((__ZL12n_ssml_stack)>>2)]; //@line 1950 "readclause.cpp"
              var $dec=((($179)-1)&4294967295); //@line 1950 "readclause.cpp"
              HEAP32[((__ZL12n_ssml_stack)>>2)]=$dec; //@line 1950 "readclause.cpp"
              __lastLabel__ = 90; __label__ = 88;continue ; //@line 1951 "readclause.cpp"
            }
  
            var $180=$px; //@line 1952 "readclause.cpp"
            var $181=$tag_type; //@line 1952 "readclause.cpp"
            var $call277=__ZL18GetVoiceAttributesPwi($180, $181); //@line 1952 "readclause.cpp"
            var $add278=((($call277)+524328)&4294967295); //@line 1952 "readclause.cpp"
            $retval=$add278; //@line 1952 "readclause.cpp"
            __label__ = 113;break $if_end30$$return$19; //@line 1952 "readclause.cpp"
          }
          else if (__label__ == 92) {
            while(1) { 
  
              var $182=__lastLabel__ == 94 ? $dec289 : ($23); //@line 1956 "readclause.cpp"
              var $cmp281=((($182))|0) > 1; //@line 1956 "readclause.cpp"
              if (!($cmp281)) { __label__ = 95;break ; } //@line 1956 "readclause.cpp"
  
              var $183=HEAP32[((__ZL12n_ssml_stack)>>2)]; //@line 1956 "readclause.cpp"
              var $sub283=((($183)-1)&4294967295); //@line 1956 "readclause.cpp"
              var $arrayidx284=((__ZL10ssml_stack+$sub283*76)&4294967295); //@line 1956 "readclause.cpp"
              var $tag_type285=(($arrayidx284)&4294967295); //@line 1956 "readclause.cpp"
              var $184=HEAP32[(($tag_type285)>>2)]; //@line 1956 "readclause.cpp"
              var $cmp286=((($184))|0)!=2; //@line 1956 "readclause.cpp"
              if (!($cmp286)) { __label__ = 95;break ; }
  
              var $185=HEAP32[((__ZL12n_ssml_stack)>>2)]; //@line 1958 "readclause.cpp"
              var $dec289=((($185)-1)&4294967295); //@line 1958 "readclause.cpp"
              HEAP32[((__ZL12n_ssml_stack)>>2)]=$dec289; //@line 1958 "readclause.cpp"
              __lastLabel__ = 94; __label__ = 92;continue ; //@line 1959 "readclause.cpp"
            }
  
            $terminator=0; //@line 1961 "readclause.cpp"
            var $186=$terminator; //@line 1962 "readclause.cpp"
            var $187=$px; //@line 1962 "readclause.cpp"
            var $188=$tag_type; //@line 1962 "readclause.cpp"
            var $call291=__ZL18GetVoiceAttributesPwi($187, $188); //@line 1962 "readclause.cpp"
            var $add292=((($call291)+($186))&4294967295); //@line 1962 "readclause.cpp"
            $retval=$add292; //@line 1962 "readclause.cpp"
            __label__ = 113;break $if_end30$$return$19; //@line 1962 "readclause.cpp"
          }
          else if (__label__ == 96) {
  
            $retval=262174; //@line 1966 "readclause.cpp"
            __label__ = 113;break $if_end30$$return$19; //@line 1966 "readclause.cpp"
          }
          else if (__label__ == 97) {
  
            var $189=$ssml_sp; //@line 1969 "readclause.cpp"
            var $tag_type295=(($189)&4294967295); //@line 1969 "readclause.cpp"
            var $190=HEAP32[(($tag_type295)>>2)]; //@line 1969 "readclause.cpp"
            var $cmp296=((($190))|0)==6; //@line 1969 "readclause.cpp"
            if ($cmp296) { __label__ = 98;; } else { __label__ = 99;; } //@line 1969 "readclause.cpp"
            if (__label__ == 98) {
  
              var $191=$px; //@line 1972 "readclause.cpp"
              var $call298=__ZL18GetVoiceAttributesPwi($191, 38); //@line 1972 "readclause.cpp"
              $voice_change_flag=$call298; //@line 1972 "readclause.cpp"
              ; //@line 1973 "readclause.cpp"
            }
  
            var $192=$px; //@line 1974 "readclause.cpp"
            var $193=$tag_type; //@line 1974 "readclause.cpp"
            var $call300=__ZL18GetVoiceAttributesPwi($192, $193); //@line 1974 "readclause.cpp"
            var $194=$voice_change_flag; //@line 1974 "readclause.cpp"
            var $or=($194) | ($call300); //@line 1974 "readclause.cpp"
            $voice_change_flag=$or; //@line 1974 "readclause.cpp"
            var $195=$voice_change_flag; //@line 1975 "readclause.cpp"
            var $add301=((($195)+524358)&4294967295); //@line 1975 "readclause.cpp"
            $retval=$add301; //@line 1975 "readclause.cpp"
            __label__ = 113;break $if_end30$$return$19; //@line 1975 "readclause.cpp"
          }
          else if (__label__ == 100) {
  
            var $196=$ssml_sp; //@line 1979 "readclause.cpp"
            var $tag_type303=(($196)&4294967295); //@line 1979 "readclause.cpp"
            var $197=HEAP32[(($tag_type303)>>2)]; //@line 1979 "readclause.cpp"
            var $cmp304=((($197))|0)==6; //@line 1979 "readclause.cpp"
            if ($cmp304) { __label__ = 101;; } else { __label__ = 102;; } //@line 1979 "readclause.cpp"
            if (__label__ == 101) {
  
              var $198=$px; //@line 1982 "readclause.cpp"
              var $call306=__ZL18GetVoiceAttributesPwi($198, 38); //@line 1982 "readclause.cpp"
              $voice_change_flag=$call306; //@line 1982 "readclause.cpp"
              ; //@line 1983 "readclause.cpp"
            }
  
            var $199=$ssml_sp; //@line 1984 "readclause.cpp"
            var $tag_type308=(($199)&4294967295); //@line 1984 "readclause.cpp"
            var $200=HEAP32[(($tag_type308)>>2)]; //@line 1984 "readclause.cpp"
            var $cmp309=((($200))|0)==7; //@line 1984 "readclause.cpp"
            if ($cmp309) { __label__ = 103;; } else { __label__ = 104;; } //@line 1984 "readclause.cpp"
            if (__label__ == 103) {
  
              var $201=$px; //@line 1987 "readclause.cpp"
              var $call311=__ZL18GetVoiceAttributesPwi($201, 39); //@line 1987 "readclause.cpp"
              var $202=$voice_change_flag; //@line 1987 "readclause.cpp"
              var $or312=($202) | ($call311); //@line 1987 "readclause.cpp"
              $voice_change_flag=$or312; //@line 1987 "readclause.cpp"
              ; //@line 1988 "readclause.cpp"
            }
  
            var $203=$px; //@line 1989 "readclause.cpp"
            var $204=$tag_type; //@line 1989 "readclause.cpp"
            var $call314=__ZL18GetVoiceAttributesPwi($203, $204); //@line 1989 "readclause.cpp"
            var $205=$voice_change_flag; //@line 1989 "readclause.cpp"
            var $or315=($205) | ($call314); //@line 1989 "readclause.cpp"
            $voice_change_flag=$or315; //@line 1989 "readclause.cpp"
            var $206=$voice_change_flag; //@line 1990 "readclause.cpp"
            var $add316=((($206)+524358)&4294967295); //@line 1990 "readclause.cpp"
            $retval=$add316; //@line 1990 "readclause.cpp"
            __label__ = 113;break $if_end30$$return$19; //@line 1990 "readclause.cpp"
          }
          else if (__label__ == 105) {
  
            var $207=$ssml_sp; //@line 1994 "readclause.cpp"
            var $tag_type318=(($207)&4294967295); //@line 1994 "readclause.cpp"
            var $208=HEAP32[(($tag_type318)>>2)]; //@line 1994 "readclause.cpp"
            var $cmp319=((($208))|0)==6; //@line 1994 "readclause.cpp"
            if ($cmp319) { __label__ = 106;; } else { __label__ = 107;; } //@line 1994 "readclause.cpp"
            if (__label__ == 106) {
  
              var $209=$px; //@line 1997 "readclause.cpp"
              var $210=$tag_type; //@line 1997 "readclause.cpp"
              var $call321=__ZL18GetVoiceAttributesPwi($209, $210); //@line 1997 "readclause.cpp"
              $voice_change_flag=$call321; //@line 1997 "readclause.cpp"
              ; //@line 1998 "readclause.cpp"
            }
  
            var $211=$voice_change_flag; //@line 1999 "readclause.cpp"
            var $add323=((($211)+524328)&4294967295); //@line 1999 "readclause.cpp"
            $retval=$add323; //@line 1999 "readclause.cpp"
            __label__ = 113;break $if_end30$$return$19; //@line 1999 "readclause.cpp"
          }
          else if (__label__ == 108) {
  
            var $212=$ssml_sp; //@line 2003 "readclause.cpp"
            var $tag_type325=(($212)&4294967295); //@line 2003 "readclause.cpp"
            var $213=HEAP32[(($tag_type325)>>2)]; //@line 2003 "readclause.cpp"
            var $cmp326=((($213))|0)==6; //@line 2003 "readclause.cpp"
            if ($cmp326) { __label__ = 110;; } else { __label__ = 109;; } //@line 2003 "readclause.cpp"
            $if_then330$$lor_lhs_false327$145: do { 
              if (__label__ == 109) {
  
                var $214=$ssml_sp; //@line 2003 "readclause.cpp"
                var $tag_type328=(($214)&4294967295); //@line 2003 "readclause.cpp"
                var $215=HEAP32[(($tag_type328)>>2)]; //@line 2003 "readclause.cpp"
                var $cmp329=((($215))|0)==7; //@line 2003 "readclause.cpp"
                if ($cmp329) { __label__ = 110;break $if_then330$$lor_lhs_false327$145; } //@line 2003 "readclause.cpp"
  
                $retval=524358; //@line 2009 "readclause.cpp"
                __label__ = 113;break $if_end30$$return$19; //@line 2009 "readclause.cpp"
              }
            } while(0);
  
            var $216=$px; //@line 2007 "readclause.cpp"
            var $217=$tag_type; //@line 2007 "readclause.cpp"
            var $call331=__ZL18GetVoiceAttributesPwi($216, $217); //@line 2007 "readclause.cpp"
            var $add332=((($call331)+524358)&4294967295); //@line 2007 "readclause.cpp"
            $retval=$add332; //@line 2007 "readclause.cpp"
            __label__ = 113;break $if_end30$$return$19; //@line 2007 "readclause.cpp"
          }
        } while(0);
  
        $retval=0; //@line 2011 "readclause.cpp"
        ; //@line 2011 "readclause.cpp"
      }
    } while(0);
  
    var $218=$retval; //@line 2012 "readclause.cpp"
    STACKTOP = __stackBase__;
    return $218; //@line 2012 "readclause.cpp"
    return null;
  }
  

  function __ZL13LookupSpecialP10TranslatorPKcPc($tr, $text_out) {
    var __stackBase__  = STACKTOP; STACKTOP += 124; _memset(__stackBase__, 0, 124);
    var __label__;
  
    var $retval;
    var $tr_addr;
    var $string_addr;
    var $text_out_addr;
    var $flags=__stackBase__;
    var $phonemes=__stackBase__+8;
    var $phonemes2=__stackBase__+64;
    var $string1=__stackBase__+120;
    $tr_addr=$tr;
    $string_addr=((__str6303)&4294967295);
    $text_out_addr=$text_out;
    var $0=$string_addr; //@line 593 "readclause.cpp"
    HEAP32[(($string1)>>2)]=$0; //@line 593 "readclause.cpp"
    var $arrayidx=(($flags+4)&4294967295); //@line 595 "readclause.cpp"
    HEAP32[(($arrayidx)>>2)]=0; //@line 595 "readclause.cpp"
    var $arrayidx1=(($flags)&4294967295); //@line 595 "readclause.cpp"
    HEAP32[(($arrayidx1)>>2)]=0; //@line 595 "readclause.cpp"
    var $1=$tr_addr; //@line 596 "readclause.cpp"
    var $arraydecay=(($phonemes)&4294967295); //@line 596 "readclause.cpp"
    var $arraydecay2=(($flags)&4294967295); //@line 596 "readclause.cpp"
    var $call=__Z14LookupDictListP10TranslatorPPcS1_PjiP8WORD_TAB($1, $string1, $arraydecay, $arraydecay2, 0, 0); //@line 596 "readclause.cpp"
    var $tobool=((($call))|0)!=0; //@line 596 "readclause.cpp"
    if ($tobool) { __label__ = 1;; } else { __label__ = 2;; } //@line 596 "readclause.cpp"
    if (__label__ == 1) {
  
      var $2=$tr_addr; //@line 598 "readclause.cpp"
      var $arraydecay3=(($phonemes)&4294967295); //@line 598 "readclause.cpp"
      var $arraydecay4=(($flags)&4294967295); //@line 598 "readclause.cpp"
      __Z13SetWordStressP10TranslatorPcPjii($2, $arraydecay3, $arraydecay4, -1, 0); //@line 598 "readclause.cpp"
      var $arraydecay5=(($phonemes)&4294967295); //@line 599 "readclause.cpp"
      var $arraydecay6=(($phonemes2)&4294967295); //@line 599 "readclause.cpp"
      __Z14DecodePhonemesPKcPc($arraydecay5, $arraydecay6); //@line 599 "readclause.cpp"
      var $3=$text_out_addr; //@line 600 "readclause.cpp"
      var $arraydecay7=(($phonemes2)&4294967295); //@line 600 "readclause.cpp"
      var $call8=_sprintf($3, ((__str60227)&4294967295), allocate([$arraydecay7,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 600 "readclause.cpp"
      var $4=$text_out_addr; //@line 601 "readclause.cpp"
      $retval=$4; //@line 601 "readclause.cpp"
      ; //@line 601 "readclause.cpp"
    }
    else if (__label__ == 2) {
  
      $retval=0; //@line 603 "readclause.cpp"
      ; //@line 603 "readclause.cpp"
    }
  
    var $5=$retval; //@line 604 "readclause.cpp"
    STACKTOP = __stackBase__;
    return $5; //@line 604 "readclause.cpp"
    return null;
  }
  

  function __ZL10RemoveCharPc($p) {
    var __stackBase__  = STACKTOP; STACKTOP += 4; _memset(__stackBase__, 0, 4);
    var __label__;
  
    var $p_addr;
    var $c=__stackBase__;
    $p_addr=$p;
    var $0=$p_addr; //@line 2020 "readclause.cpp"
    var $1=$p_addr; //@line 2020 "readclause.cpp"
    var $call=__Z7utf8_inPiPKc($c, $1); //@line 2020 "readclause.cpp"
    var $dest$, $stop$, $stop4$, $fast$, $value4$;
    $dest$ = $0;
    $stop$ = $dest$ + $call;
    $value4$ = 32;
    if ($value4$ < 0) $value4$ += 256;
    $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
    while ($dest$%4 !== 0 && $dest$ < $stop$) {
      ;; HEAP8[$dest$++] = 32;
    }
    $dest$ >>= 2;
    $stop4$ = $stop$ >> 2;
    while ($dest$ < $stop4$) {
    ;;;;;;;  HEAP32[$dest$++] = $value4$;
    }
    $dest$ <<= 2;
    while ($dest$ < $stop$) {
      ;; HEAP8[$dest$++] = 32;
    }; //@line 2020 "readclause.cpp"
    STACKTOP = __stackBase__;
    return; //@line 2021 "readclause.cpp"
    return;
  }
  

  function __ZL19AnnouncePunctuationP10TranslatoriPiPcS1_i($tr, $c1, $c2_ptr, $output, $bufix, $end_clause) {
    var __stackBase__  = STACKTOP; STACKTOP += 280; _memset(__stackBase__, 0, 280);
    var __label__;
  
    var $retval;
    var $tr_addr;
    var $c1_addr;
    var $c2_ptr_addr;
    var $output_addr;
    var $bufix_addr;
    var $end_clause_addr;
    var $punct_count;
    var $punctname;
    var $found;
    var $soundicon;
    var $attributes;
    var $short_pause;
    var $c2;
    var $len;
    var $bufix1;
    var $buf=__stackBase__;
    var $buf2=__stackBase__+200;
    $tr_addr=$tr;
    $c1_addr=$c1;
    $c2_ptr_addr=$c2_ptr;
    $output_addr=$output;
    $bufix_addr=$bufix;
    $end_clause_addr=$end_clause;
    $found=0; //@line 863 "readclause.cpp"
    var $0=$c2_ptr_addr; //@line 873 "readclause.cpp"
    var $1=HEAP32[(($0)>>2)]; //@line 873 "readclause.cpp"
    $c2=$1; //@line 873 "readclause.cpp"
    var $arrayidx=(($buf)&4294967295); //@line 874 "readclause.cpp"
    HEAP8[($arrayidx)]=0; //@line 874 "readclause.cpp"
    var $2=$c1_addr; //@line 876 "readclause.cpp"
    var $call=__ZL15LookupSoundiconi($2); //@line 876 "readclause.cpp"
    $soundicon=$call; //@line 876 "readclause.cpp"
    var $cmp=((($call))|0) >= 0; //@line 876 "readclause.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 876 "readclause.cpp"
    $if_end63_thread$$if_else$2: do { 
      if (__label__ == 1) {
  
        var $arraydecay=(($buf)&4294967295); //@line 879 "readclause.cpp"
        var $3=$soundicon; //@line 879 "readclause.cpp"
        var $call1=_sprintf($arraydecay, ((__str50217)&4294967295), allocate([$3,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 879 "readclause.cpp"
        var $4=$c2; //@line 880 "readclause.cpp"
        __ZL6UngetCi($4); //@line 880 "readclause.cpp"
        $found=1; //@line 881 "readclause.cpp"
        __label__ = 26;break $if_end63_thread$$if_else$2; //@line 946 "readclause.cpp"
      }
      else if (__label__ == 2) {
  
        var $5=$tr_addr; //@line 884 "readclause.cpp"
        var $6=$c1_addr; //@line 884 "readclause.cpp"
        __ZL14LookupCharNameP10Translatorii($5, $6, 0); //@line 884 "readclause.cpp"
        $punctname=((__ZZL14LookupCharNameP10TranslatoriiE3buf)&4294967295); //@line 884 "readclause.cpp"
        $found=1; //@line 886 "readclause.cpp"
        var $7=$bufix_addr; //@line 887 "readclause.cpp"
        var $8=HEAP32[(($7)>>2)]; //@line 887 "readclause.cpp"
        var $cmp5=((($8))|0)==0; //@line 887 "readclause.cpp"
        if ($cmp5) { __label__ = 5;; } else { __label__ = 3;; } //@line 887 "readclause.cpp"
        $if_then9$$lor_lhs_false$5: do { 
          if (__label__ == 3) {
  
            var $9=$end_clause_addr; //@line 887 "readclause.cpp"
            var $cmp6=((($9))|0)==0; //@line 887 "readclause.cpp"
            if ($cmp6) { __label__ = 5;break $if_then9$$lor_lhs_false$5; } //@line 887 "readclause.cpp"
  
            var $10=$tr_addr; //@line 887 "readclause.cpp"
            var $langopts=(($10)&4294967295); //@line 887 "readclause.cpp"
            var $param=(($langopts+24)&4294967295); //@line 887 "readclause.cpp"
            var $arrayidx8=(($param+68)&4294967295); //@line 887 "readclause.cpp"
            var $11=HEAP32[(($arrayidx8)>>2)]; //@line 887 "readclause.cpp"
            var $and=($11) & 2; //@line 887 "readclause.cpp"
            var $tobool=((($and))|0)!=0; //@line 887 "readclause.cpp"
            if ($tobool) { __label__ = 5;break $if_then9$$lor_lhs_false$5; } //@line 887 "readclause.cpp"
  
            var $34=$c2; //@line 934 "readclause.cpp"
            __ZL6UngetCi($34); //@line 934 "readclause.cpp"
            var $35=HEAP32[((_option_ssml)>>2)]; //@line 935 "readclause.cpp"
            var $tobool51=((($35))|0)!=0; //@line 935 "readclause.cpp"
            if ($tobool51) { __label__ = 21;; } else { __label__ = 23;; } //@line 935 "readclause.cpp"
            $if_then52$$if_end58$9: do { 
              if (__label__ == 21) {
  
                var $36=$c1_addr; //@line 937 "readclause.cpp"
                var $cmp53=((($36))|0)==60; //@line 937 "readclause.cpp"
                var $37=$c1_addr; //@line 937 "readclause.cpp"
                var $cmp55=((($37))|0)==38; //@line 937 "readclause.cpp"
                var $or_cond=($cmp53) | ($cmp55); //@line 937 "readclause.cpp"
                if (!($or_cond)) { __label__ = 23;break $if_then52$$if_end58$9; } //@line 937 "readclause.cpp"
  
                var $38=$c1_addr; //@line 938 "readclause.cpp"
                HEAP32[((__ZL19ssml_ignore_l_angle)>>2)]=$38; //@line 938 "readclause.cpp"
                ; //@line 938 "readclause.cpp"
              }
            } while(0);
  
            var $39=$c1_addr; //@line 940 "readclause.cpp"
            HEAP32[((__ZL11ungot_char2)>>2)]=$39; //@line 940 "readclause.cpp"
            var $arrayidx59=(($buf)&4294967295); //@line 941 "readclause.cpp"
            HEAP8[($arrayidx59)]=32; //@line 941 "readclause.cpp"
            var $arrayidx60=(($buf+1)&4294967295); //@line 942 "readclause.cpp"
            HEAP8[($arrayidx60)]=0; //@line 942 "readclause.cpp"
            __label__ = 24;break $if_then9$$lor_lhs_false$5;
          }
        } while(0);
        $if_then9$$if_end63$13: do { 
          if (__label__ == 5) {
  
            $punct_count=1; //@line 889 "readclause.cpp"
            var $12=$c2; //@line 890 "readclause.cpp"
            var $13=$c1_addr; //@line 890 "readclause.cpp"
            var $cmp105=((($12))|0)==((($13))|0); //@line 890 "readclause.cpp"
            var $14=$c1_addr; //@line 890 "readclause.cpp"
            var $cmp116=((($14))|0)!=60; //@line 890 "readclause.cpp"
            var $or_cond17=($cmp105) & ($cmp116); //@line 890 "readclause.cpp"
            if ($or_cond17) { __label__ = 6;; } else { __label__ = 7;; } //@line 890 "readclause.cpp"
            $while_body$$while_end$15: do { 
              if (__label__ == 6) {
                while(1) { 
  
                  var $15=$punct_count; //@line 892 "readclause.cpp"
                  var $inc=((($15)+1)&4294967295); //@line 892 "readclause.cpp"
                  $punct_count=$inc; //@line 892 "readclause.cpp"
                  var $call12=__ZL4GetCv(); //@line 893 "readclause.cpp"
                  $c2=$call12; //@line 893 "readclause.cpp"
                  var $16=$c2; //@line 890 "readclause.cpp"
                  var $17=$c1_addr; //@line 890 "readclause.cpp"
                  var $cmp10=((($16))|0)==((($17))|0); //@line 890 "readclause.cpp"
                  var $18=$c1_addr; //@line 890 "readclause.cpp"
                  var $cmp11=((($18))|0)!=60; //@line 890 "readclause.cpp"
                  var $or_cond1=($cmp10) & ($cmp11); //@line 890 "readclause.cpp"
                  if ($or_cond1) { __label__ = 6;continue ; } else { __label__ = 7;break $while_body$$while_end$15; } //@line 890 "readclause.cpp"
                }
              }
            } while(0);
  
            var $19=$c2; //@line 895 "readclause.cpp"
            var $20=$c2_ptr_addr; //@line 895 "readclause.cpp"
            HEAP32[(($20)>>2)]=$19; //@line 895 "readclause.cpp"
            var $21=$end_clause_addr; //@line 896 "readclause.cpp"
            var $tobool13=((($21))|0)!=0; //@line 896 "readclause.cpp"
            if ($tobool13) { __label__ = 8;; } else { __label__ = 9;; } //@line 896 "readclause.cpp"
            if (__label__ == 8) {
  
              var $22=$c2; //@line 898 "readclause.cpp"
              __ZL6UngetCi($22); //@line 898 "readclause.cpp"
              ; //@line 899 "readclause.cpp"
            }
  
            var $23=$punct_count; //@line 901 "readclause.cpp"
            var $cmp15=((($23))|0)==1; //@line 901 "readclause.cpp"
            if ($cmp15) { __label__ = 10;; } else { __label__ = 11;; } //@line 901 "readclause.cpp"
            if (__label__ == 10) {
  
              var $arraydecay17=(($buf)&4294967295); //@line 904 "readclause.cpp"
              var $24=$punctname; //@line 904 "readclause.cpp"
              var $call18=_sprintf($arraydecay17, ((__str51218)&4294967295), allocate([$24,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 904 "readclause.cpp"
              ; //@line 905 "readclause.cpp"
            }
            else if (__label__ == 11) {
  
              var $25=$punct_count; //@line 907 "readclause.cpp"
              var $cmp20=((($25))|0) < 4; //@line 907 "readclause.cpp"
              var $arrayidx22=(($buf)&4294967295); //@line 909 "readclause.cpp"
              if ($cmp20) { __label__ = 12;; } else { __label__ = 19;; } //@line 907 "readclause.cpp"
              if (__label__ == 12) {
  
                HEAP8[($arrayidx22)]=0; //@line 909 "readclause.cpp"
                var $26=HEAP32[((((_embedded_value+8)&4294967295))>>2)]; //@line 910 "readclause.cpp"
                var $cmp23=((($26))|0) < 300; //@line 910 "readclause.cpp"
                if ($cmp23) { __label__ = 13;; } else { __label__ = 14;; } //@line 910 "readclause.cpp"
                if (__label__ == 13) {
  
                  var $arraydecay25=(($buf)&4294967295); //@line 911 "readclause.cpp"
                  var $src$, $dest$, $stop$, $stop4$, $fast$;
                  $src$ = ((__str52219)&4294967295);
                  $dest$ = $arraydecay25;
                  $stop$ = $src$ + 6;
                  if (($dest$%4) == ($src$%4) && 6 > 8) {
                    while ($src$%4 !== 0 && $src$ < $stop$) {
                      ; HEAP8[$dest$++] = HEAP8[$src$++];
                    }
                    $src$ >>= 2;
                    $dest$ >>= 2;
                    $stop4$ = $stop$ >> 2;
                    while ($src$ < $stop4$) {
                  ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
                    }
                    $src$ <<= 2;
                    $dest$ <<= 2;
                  }while ($src$ < $stop$) {
                    ; HEAP8[$dest$++] = HEAP8[$src$++];
                  }; //@line 911 "readclause.cpp"
                  ; //@line 911 "readclause.cpp"
                }
  
                var $27=$punct_count; //@line 913 "readclause.cpp"
                var $dec3=((($27)-1)&4294967295); //@line 913 "readclause.cpp"
                $punct_count=$dec3; //@line 913 "readclause.cpp"
                var $cmp294=((($27))|0) > 0; //@line 913 "readclause.cpp"
                if ($cmp294) { __label__ = 15;; } else { __label__ = 17;; } //@line 913 "readclause.cpp"
                $while_body30_lr_ph$$while_end36$30: do { 
                  if (__label__ == 15) {
  
                    var $arraydecay31=(($buf2)&4294967295); //@line 915 "readclause.cpp"
                    var $arraydecay33=(($buf)&4294967295); //@line 916 "readclause.cpp"
                    var $arraydecay34=(($buf2)&4294967295); //@line 916 "readclause.cpp"
                    ; //@line 913 "readclause.cpp"
                    while(1) { 
  
                      var $28=$punctname; //@line 915 "readclause.cpp"
                      var $call32=_sprintf($arraydecay31, ((__str51218)&4294967295), allocate([$28,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 915 "readclause.cpp"
                      var $call35=_strcat($arraydecay33, $arraydecay34); //@line 916 "readclause.cpp"
                      var $29=$punct_count; //@line 913 "readclause.cpp"
                      var $dec=((($29)-1)&4294967295); //@line 913 "readclause.cpp"
                      $punct_count=$dec; //@line 913 "readclause.cpp"
                      var $cmp29=((($29))|0) > 0; //@line 913 "readclause.cpp"
                      if ($cmp29) { __label__ = 16;continue ; } else { __label__ = 17;break $while_body30_lr_ph$$while_end36$30; } //@line 913 "readclause.cpp"
                    }
                  }
                } while(0);
  
                var $30=HEAP32[((((_embedded_value+8)&4294967295))>>2)]; //@line 919 "readclause.cpp"
                var $cmp37=((($30))|0) < 300; //@line 919 "readclause.cpp"
                if (!($cmp37)) { __label__ = 24;break $if_then9$$if_end63$13; } //@line 919 "readclause.cpp"
  
                var $arraydecay39=(($buf2)&4294967295); //@line 921 "readclause.cpp"
                var $src$, $dest$, $stop$, $stop4$, $fast$;
                $src$ = ((__str53220)&4294967295);
                $dest$ = $arraydecay39;
                $stop$ = $src$ + 7;
                if (($dest$%4) == ($src$%4) && 7 > 8) {
                  while ($src$%4 !== 0 && $src$ < $stop$) {
                    ; HEAP8[$dest$++] = HEAP8[$src$++];
                  }
                  $src$ >>= 2;
                  $dest$ >>= 2;
                  $stop4$ = $stop$ >> 2;
                  while ($src$ < $stop4$) {
                ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
                  }
                  $src$ <<= 2;
                  $dest$ <<= 2;
                }while ($src$ < $stop$) {
                  ; HEAP8[$dest$++] = HEAP8[$src$++];
                }; //@line 921 "readclause.cpp"
                var $arraydecay41=(($buf)&4294967295); //@line 922 "readclause.cpp"
                var $arraydecay42=(($buf2)&4294967295); //@line 922 "readclause.cpp"
                var $call43=_strcat($arraydecay41, $arraydecay42); //@line 922 "readclause.cpp"
                ; //@line 923 "readclause.cpp"
              }
              else if (__label__ == 19) {
  
                var $31=$punctname; //@line 927 "readclause.cpp"
                var $32=$punct_count; //@line 927 "readclause.cpp"
                var $33=$punctname; //@line 927 "readclause.cpp"
                var $call47=_sprintf($arrayidx22, ((__str54221)&4294967295), allocate([$31,0,0,0,$32,0,0,0,$33,0,0,0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 927 "readclause.cpp"
                ;
              }
            }
          }
        } while(0);
  
        var $_pr=$found; //@line 946 "readclause.cpp"
        var $cmp64=((($_pr))|0)==0; //@line 946 "readclause.cpp"
        if (!($cmp64)) { __label__ = 26;break $if_end63_thread$$if_else$2; } //@line 946 "readclause.cpp"
  
        $retval=-1; //@line 947 "readclause.cpp"
        __label__ = 40;break $if_end63_thread$$if_else$2; //@line 947 "readclause.cpp"
      }
    } while(0);
    $if_end66$$return$39: do { 
      if (__label__ == 26) {
  
        var $40=$bufix_addr; //@line 949 "readclause.cpp"
        var $41=HEAP32[(($40)>>2)]; //@line 949 "readclause.cpp"
        $bufix1=$41; //@line 949 "readclause.cpp"
        var $arraydecay67=(($buf)&4294967295); //@line 950 "readclause.cpp"
        var $call68=_strlen($arraydecay67); //@line 950 "readclause.cpp"
        $len=$call68; //@line 950 "readclause.cpp"
        var $42=$bufix_addr; //@line 951 "readclause.cpp"
        var $43=HEAP32[(($42)>>2)]; //@line 951 "readclause.cpp"
        var $44=$output_addr; //@line 951 "readclause.cpp"
        var $arrayidx69=(($44+$43)&4294967295); //@line 951 "readclause.cpp"
        var $arraydecay70=(($buf)&4294967295); //@line 951 "readclause.cpp"
        var $call71=_strcpy($arrayidx69, $arraydecay70); //@line 951 "readclause.cpp"
        var $45=$len; //@line 952 "readclause.cpp"
        var $46=$bufix_addr; //@line 952 "readclause.cpp"
        var $47=HEAP32[(($46)>>2)]; //@line 952 "readclause.cpp"
        var $add=((($47)+($45))&4294967295); //@line 952 "readclause.cpp"
        HEAP32[(($46)>>2)]=$add; //@line 952 "readclause.cpp"
        var $48=$end_clause_addr; //@line 954 "readclause.cpp"
        var $cmp72=((($48))|0)==0; //@line 954 "readclause.cpp"
        if ($cmp72) { __label__ = 27;; } else { __label__ = 28;; } //@line 954 "readclause.cpp"
        if (__label__ == 27) {
  
          $retval=-1; //@line 955 "readclause.cpp"
          ; //@line 955 "readclause.cpp"
        }
        else if (__label__ == 28) {
  
          var $49=$c1_addr; //@line 957 "readclause.cpp"
          var $cmp75=((($49))|0)==45; //@line 957 "readclause.cpp"
          if ($cmp75) { __label__ = 29;; } else { __label__ = 30;; } //@line 957 "readclause.cpp"
          if (__label__ == 29) {
  
            $retval=16384; //@line 958 "readclause.cpp"
            ; //@line 958 "readclause.cpp"
          }
          else if (__label__ == 30) {
  
            var $50=$c1_addr; //@line 960 "readclause.cpp"
            var $call78=__Z11lookupwcharPKti(((__ZL11punct_chars)&4294967295), $50); //@line 960 "readclause.cpp"
            var $arrayidx79=((__ZL16punct_attributes+$call78*4)&4294967295); //@line 960 "readclause.cpp"
            var $51=HEAP32[(($arrayidx79)>>2)]; //@line 960 "readclause.cpp"
            $attributes=$51; //@line 960 "readclause.cpp"
            $short_pause=262148; //@line 962 "readclause.cpp"
            var $52=$attributes; //@line 963 "readclause.cpp"
            var $and80=($52) & 28672; //@line 963 "readclause.cpp"
            var $cmp81=((($and80))|0)==4096; //@line 963 "readclause.cpp"
            if ($cmp81) { __label__ = 31;; } else { __label__ = 32;; } //@line 963 "readclause.cpp"
            if (__label__ == 31) {
  
              $short_pause=266244; //@line 964 "readclause.cpp"
              ; //@line 964 "readclause.cpp"
            }
  
            var $53=$bufix1; //@line 966 "readclause.cpp"
            var $cmp84=((($53))|0) > 0; //@line 966 "readclause.cpp"
            if ($cmp84) { __label__ = 33;; } else { __label__ = 37;; } //@line 966 "readclause.cpp"
            $land_lhs_true$$if_end95$50: do { 
              if (__label__ == 33) {
  
                var $54=$tr_addr; //@line 966 "readclause.cpp"
                var $langopts85=(($54)&4294967295); //@line 966 "readclause.cpp"
                var $param86=(($langopts85+24)&4294967295); //@line 966 "readclause.cpp"
                var $arrayidx87=(($param86+68)&4294967295); //@line 966 "readclause.cpp"
                var $55=HEAP32[(($arrayidx87)>>2)]; //@line 966 "readclause.cpp"
                var $and88=($55) & 2; //@line 966 "readclause.cpp"
                var $tobool89=((($and88))|0)!=0; //@line 966 "readclause.cpp"
                if ($tobool89) { __label__ = 37;break $land_lhs_true$$if_end95$50; } //@line 966 "readclause.cpp"
  
                var $56=$attributes; //@line 968 "readclause.cpp"
                var $and91=($56) & -32769; //@line 968 "readclause.cpp"
                var $cmp92=((($and91))|0)==266270; //@line 968 "readclause.cpp"
                if ($cmp92) { __label__ = 35;; } else { __label__ = 36;; } //@line 968 "readclause.cpp"
                if (__label__ == 35) {
  
                  $retval=262148; //@line 969 "readclause.cpp"
                  __label__ = 40;break $if_end66$$return$39; //@line 969 "readclause.cpp"
                }
                else if (__label__ == 36) {
  
                  var $57=$short_pause; //@line 970 "readclause.cpp"
                  $retval=$57; //@line 970 "readclause.cpp"
                  __label__ = 40;break $if_end66$$return$39; //@line 970 "readclause.cpp"
                }
              }
            } while(0);
  
            var $58=$attributes; //@line 973 "readclause.cpp"
            var $and96=($58) & 524288; //@line 973 "readclause.cpp"
            var $tobool97=((($and96))|0)!=0; //@line 973 "readclause.cpp"
            if ($tobool97) { __label__ = 38;; } else { __label__ = 39;; } //@line 973 "readclause.cpp"
            if (__label__ == 38) {
  
              var $59=$attributes; //@line 974 "readclause.cpp"
              $retval=$59; //@line 974 "readclause.cpp"
              ; //@line 974 "readclause.cpp"
            }
            else if (__label__ == 39) {
  
              var $60=$short_pause; //@line 976 "readclause.cpp"
              $retval=$60; //@line 976 "readclause.cpp"
              ; //@line 976 "readclause.cpp"
            }
          }
        }
      }
    } while(0);
  
    var $61=$retval; //@line 977 "readclause.cpp"
    STACKTOP = __stackBase__;
    return $61; //@line 977 "readclause.cpp"
    return null;
  }
  

  function __ZL14LookupCharNameP10Translatorii($tr, $c, $only) {
    var __stackBase__  = STACKTOP; STACKTOP += 156; _memset(__stackBase__, 0, 156);
    var __label__;
  
    var $tr_addr;
    var $c_addr;
    var $only_addr;
    var $ix;
    var $flags=__stackBase__;
    var $single_letter=__stackBase__+8;
    var $phonemes=__stackBase__+32;
    var $phonemes2=__stackBase__+92;
    var $lang_name;
    var $string=__stackBase__+152;
    $tr_addr=$tr;
    $c_addr=$c;
    $only_addr=$only;
    $lang_name=0; //@line 617 "readclause.cpp"
    HEAP8[(((__ZZL14LookupCharNameP10TranslatoriiE3buf)&4294967295))]=0; //@line 621 "readclause.cpp"
    var $arrayidx=(($flags)&4294967295); //@line 622 "readclause.cpp"
    HEAP32[(($arrayidx)>>2)]=0; //@line 622 "readclause.cpp"
    var $arrayidx1=(($flags+4)&4294967295); //@line 623 "readclause.cpp"
    HEAP32[(($arrayidx1)>>2)]=0; //@line 623 "readclause.cpp"
    var $arrayidx2=(($single_letter)&4294967295); //@line 624 "readclause.cpp"
    HEAP8[($arrayidx2)]=0; //@line 624 "readclause.cpp"
    var $arrayidx3=(($single_letter+1)&4294967295); //@line 625 "readclause.cpp"
    HEAP8[($arrayidx3)]=95; //@line 625 "readclause.cpp"
    var $0=$c_addr; //@line 626 "readclause.cpp"
    var $arrayidx4=(($single_letter+2)&4294967295); //@line 626 "readclause.cpp"
    var $call=__Z8utf8_outjPc($0, $arrayidx4); //@line 626 "readclause.cpp"
    $ix=$call; //@line 626 "readclause.cpp"
    var $1=$ix; //@line 627 "readclause.cpp"
    var $add=((($1)+2)&4294967295); //@line 627 "readclause.cpp"
    var $arrayidx5=(($single_letter+$add)&4294967295); //@line 627 "readclause.cpp"
    HEAP8[($arrayidx5)]=0; //@line 627 "readclause.cpp"
    var $2=$only_addr; //@line 629 "readclause.cpp"
    var $tobool=((($2))|0)!=0; //@line 629 "readclause.cpp"
    if ($tobool) { __label__ = 1;; } else { __label__ = 2;; } //@line 629 "readclause.cpp"
    $if_then$$if_else$2: do { 
      if (__label__ == 1) {
  
        var $arrayidx6=(($single_letter+2)&4294967295); //@line 631 "readclause.cpp"
        HEAP32[(($string)>>2)]=$arrayidx6; //@line 631 "readclause.cpp"
        var $3=$tr_addr; //@line 632 "readclause.cpp"
        var $arraydecay=(($phonemes)&4294967295); //@line 632 "readclause.cpp"
        var $arraydecay7=(($flags)&4294967295); //@line 632 "readclause.cpp"
        var $call8=__Z14LookupDictListP10TranslatorPPcS1_PjiP8WORD_TAB($3, $string, $arraydecay, $arraydecay7, 0, 0); //@line 632 "readclause.cpp"
        ; //@line 633 "readclause.cpp"
      }
      else if (__label__ == 2) {
  
        var $arrayidx9=(($single_letter+1)&4294967295); //@line 636 "readclause.cpp"
        HEAP32[(($string)>>2)]=$arrayidx9; //@line 636 "readclause.cpp"
        var $4=$tr_addr; //@line 637 "readclause.cpp"
        var $arraydecay10=(($phonemes)&4294967295); //@line 637 "readclause.cpp"
        var $arraydecay11=(($flags)&4294967295); //@line 637 "readclause.cpp"
        var $call12=__Z14LookupDictListP10TranslatorPPcS1_PjiP8WORD_TAB($4, $string, $arraydecay10, $arraydecay11, 0, 0); //@line 637 "readclause.cpp"
        var $cmp=((($call12))|0)==0; //@line 637 "readclause.cpp"
        if (!($cmp)) { __label__ = 5;break $if_then$$if_else$2; } //@line 637 "readclause.cpp"
  
        var $arrayidx14=(($single_letter+2)&4294967295); //@line 640 "readclause.cpp"
        HEAP32[(($string)>>2)]=$arrayidx14; //@line 640 "readclause.cpp"
        var $5=$tr_addr; //@line 641 "readclause.cpp"
        var $arraydecay15=(($phonemes)&4294967295); //@line 641 "readclause.cpp"
        var $arraydecay16=(($flags)&4294967295); //@line 641 "readclause.cpp"
        var $call17=__Z14LookupDictListP10TranslatorPPcS1_PjiP8WORD_TAB($5, $string, $arraydecay15, $arraydecay16, 0, 0); //@line 641 "readclause.cpp"
        var $cmp18=((($call17))|0)==0; //@line 641 "readclause.cpp"
        if (!($cmp18)) { __label__ = 5;break $if_then$$if_else$2; } //@line 641 "readclause.cpp"
  
        var $arrayidx20=(($single_letter+1)&4294967295); //@line 644 "readclause.cpp"
        HEAP8[($arrayidx20)]=32; //@line 644 "readclause.cpp"
        var $6=$tr_addr; //@line 645 "readclause.cpp"
        var $arrayidx21=(($single_letter+2)&4294967295); //@line 645 "readclause.cpp"
        var $arraydecay22=(($phonemes)&4294967295); //@line 645 "readclause.cpp"
        var $call23=__Z14TranslateRulesP10TranslatorPcS1_iS1_iPj($6, $arrayidx21, $arraydecay22, 60, 0, 0, 0); //@line 645 "readclause.cpp"
        ; //@line 646 "readclause.cpp"
      }
    } while(0);
  
    var $7=$only_addr; //@line 650 "readclause.cpp"
    var $cmp26=((($7))|0)==0; //@line 650 "readclause.cpp"
    if ($cmp26) { __label__ = 6;; } else { __label__ = 13;; } //@line 650 "readclause.cpp"
    $land_lhs_true$$if_end50$8: do { 
      if (__label__ == 6) {
  
        var $arrayidx27=(($phonemes)&4294967295); //@line 650 "readclause.cpp"
        var $8=HEAP8[($arrayidx27)]; //@line 650 "readclause.cpp"
        var $conv=(tempInt=(($8)),(tempInt>=128?tempInt-256:tempInt)); //@line 650 "readclause.cpp"
        var $cmp28=((($conv))|0)==0; //@line 650 "readclause.cpp"
        if (!($cmp28)) { __label__ = 13;break $land_lhs_true$$if_end50$8; } //@line 650 "readclause.cpp"
  
        var $9=$tr_addr; //@line 650 "readclause.cpp"
        var $translator_name=(($9+280)&4294967295); //@line 650 "readclause.cpp"
        var $10=HEAP32[(($translator_name)>>2)]; //@line 650 "readclause.cpp"
        var $cmp30=((($10))|0)!=25966; //@line 650 "readclause.cpp"
        if (!($cmp30)) { __label__ = 13;break $land_lhs_true$$if_end50$8; } //@line 650 "readclause.cpp"
  
        var $call32=__Z14SetTranslator2PKc(((__str52704)&4294967295)); //@line 653 "readclause.cpp"
        var $arrayidx33=(($single_letter+1)&4294967295); //@line 654 "readclause.cpp"
        HEAP32[(($string)>>2)]=$arrayidx33; //@line 654 "readclause.cpp"
        var $arrayidx34=(($single_letter+1)&4294967295); //@line 655 "readclause.cpp"
        HEAP8[($arrayidx34)]=95; //@line 655 "readclause.cpp"
        var $11=HEAP32[((_translator2)>>2)]; //@line 656 "readclause.cpp"
        var $arraydecay35=(($phonemes)&4294967295); //@line 656 "readclause.cpp"
        var $arraydecay36=(($flags)&4294967295); //@line 656 "readclause.cpp"
        var $call37=__Z14LookupDictListP10TranslatorPPcS1_PjiP8WORD_TAB($11, $string, $arraydecay35, $arraydecay36, 0, 0); //@line 656 "readclause.cpp"
        var $cmp38=((($call37))|0)==0; //@line 656 "readclause.cpp"
        if ($cmp38) { __label__ = 9;; } else { __label__ = 10;; } //@line 656 "readclause.cpp"
        if (__label__ == 9) {
  
          var $arrayidx40=(($single_letter+2)&4294967295); //@line 658 "readclause.cpp"
          HEAP32[(($string)>>2)]=$arrayidx40; //@line 658 "readclause.cpp"
          var $12=HEAP32[((_translator2)>>2)]; //@line 659 "readclause.cpp"
          var $arraydecay41=(($phonemes)&4294967295); //@line 659 "readclause.cpp"
          var $arraydecay42=(($flags)&4294967295); //@line 659 "readclause.cpp"
          var $call43=__Z14LookupDictListP10TranslatorPPcS1_PjiP8WORD_TAB($12, $string, $arraydecay41, $arraydecay42, 0, 0); //@line 659 "readclause.cpp"
          ; //@line 660 "readclause.cpp"
        }
  
        var $arrayidx45=(($phonemes)&4294967295); //@line 661 "readclause.cpp"
        var $13=HEAP8[($arrayidx45)]; //@line 661 "readclause.cpp"
        var $tobool46=(tempInt=(($13)),(tempInt>=128?tempInt-256:tempInt))!=0; //@line 661 "readclause.cpp"
        if ($tobool46) { __label__ = 11;; } else { __label__ = 12;; } //@line 661 "readclause.cpp"
        if (__label__ == 11) {
  
          $lang_name=((__str52704)&4294967295); //@line 663 "readclause.cpp"
          ; //@line 664 "readclause.cpp"
        }
        else if (__label__ == 12) {
  
          var $14=HEAP32[((_voice)>>2)]; //@line 667 "readclause.cpp"
          var $phoneme_tab_ix=(($14+40)&4294967295); //@line 667 "readclause.cpp"
          var $15=HEAP32[(($phoneme_tab_ix)>>2)]; //@line 667 "readclause.cpp"
          __Z18SelectPhonemeTablei($15); //@line 667 "readclause.cpp"
          ;
        }
      }
    } while(0);
  
    var $arrayidx51=(($phonemes)&4294967295); //@line 671 "readclause.cpp"
    var $16=HEAP8[($arrayidx51)]; //@line 671 "readclause.cpp"
    var $tobool52=(tempInt=(($16)),(tempInt>=128?tempInt-256:tempInt))!=0; //@line 671 "readclause.cpp"
    if ($tobool52) { __label__ = 14;; } else { __label__ = 17;; } //@line 671 "readclause.cpp"
    $if_then53$$if_else73$19: do { 
      if (__label__ == 14) {
  
        var $17=$lang_name; //@line 673 "readclause.cpp"
        var $tobool54=((($17))|0)!=0; //@line 673 "readclause.cpp"
        if ($tobool54) { __label__ = 15;; } else { __label__ = 16;; } //@line 673 "readclause.cpp"
        if (__label__ == 15) {
  
          var $18=HEAP32[((_translator2)>>2)]; //@line 675 "readclause.cpp"
          var $arraydecay56=(($phonemes)&4294967295); //@line 675 "readclause.cpp"
          var $arraydecay57=(($flags)&4294967295); //@line 675 "readclause.cpp"
          __Z13SetWordStressP10TranslatorPcPjii($18, $arraydecay56, $arraydecay57, -1, 0); //@line 675 "readclause.cpp"
          var $arraydecay58=(($phonemes)&4294967295); //@line 676 "readclause.cpp"
          var $arraydecay59=(($phonemes2)&4294967295); //@line 676 "readclause.cpp"
          __Z14DecodePhonemesPKcPc($arraydecay58, $arraydecay59); //@line 676 "readclause.cpp"
          var $arraydecay60=(($phonemes2)&4294967295); //@line 677 "readclause.cpp"
          var $19=$tr_addr; //@line 677 "readclause.cpp"
          var $translator_name61=(($19+280)&4294967295); //@line 677 "readclause.cpp"
          var $20=HEAP32[(($translator_name61)>>2)]; //@line 677 "readclause.cpp"
          __ZL13WordToString2j($20); //@line 677 "readclause.cpp"
          var $call63=_sprintf(((__ZZL14LookupCharNameP10TranslatoriiE3buf)&4294967295), ((__str47214)&4294967295), allocate([((__str52704)&4294967295),0,0,0,$arraydecay60,0,0,0,((__ZZL13WordToString2jE3buf)&4294967295),0,0,0], ["i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 677 "readclause.cpp"
          var $21=HEAP32[((_voice)>>2)]; //@line 678 "readclause.cpp"
          var $phoneme_tab_ix64=(($21+40)&4294967295); //@line 678 "readclause.cpp"
          var $22=HEAP32[(($phoneme_tab_ix64)>>2)]; //@line 678 "readclause.cpp"
          __Z18SelectPhonemeTablei($22); //@line 678 "readclause.cpp"
          ; //@line 679 "readclause.cpp"
        }
        else if (__label__ == 16) {
  
          var $23=$tr_addr; //@line 682 "readclause.cpp"
          var $arraydecay66=(($phonemes)&4294967295); //@line 682 "readclause.cpp"
          var $arraydecay67=(($flags)&4294967295); //@line 682 "readclause.cpp"
          __Z13SetWordStressP10TranslatorPcPjii($23, $arraydecay66, $arraydecay67, -1, 0); //@line 682 "readclause.cpp"
          var $arraydecay68=(($phonemes)&4294967295); //@line 683 "readclause.cpp"
          var $arraydecay69=(($phonemes2)&4294967295); //@line 683 "readclause.cpp"
          __Z14DecodePhonemesPKcPc($arraydecay68, $arraydecay69); //@line 683 "readclause.cpp"
          var $arraydecay70=(($phonemes2)&4294967295); //@line 684 "readclause.cpp"
          var $call71=_sprintf(((__ZZL14LookupCharNameP10TranslatoriiE3buf)&4294967295), ((__str48215)&4294967295), allocate([$arraydecay70,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 684 "readclause.cpp"
          ;
        }
      }
      else if (__label__ == 17) {
  
        var $24=$only_addr; //@line 688 "readclause.cpp"
        var $cmp74=((($24))|0)==0; //@line 688 "readclause.cpp"
        if (!($cmp74)) { __label__ = 19;break $if_then53$$if_else73$19; } //@line 688 "readclause.cpp"
  
        var $src$, $dest$, $stop$, $stop4$, $fast$;
        $src$ = ((__str49216)&4294967295);
        $dest$ = ((__ZZL14LookupCharNameP10TranslatoriiE3buf)&4294967295);
        $stop$ = $src$ + 17;
        if (($dest$%4) == ($src$%4) && 17 > 8) {
          while ($src$%4 !== 0 && $src$ < $stop$) {
            ; HEAP8[$dest$++] = HEAP8[$src$++];
          }
          $src$ >>= 2;
          $dest$ >>= 2;
          $stop4$ = $stop$ >> 2;
          while ($src$ < $stop4$) {
        ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
          }
          $src$ <<= 2;
          $dest$ <<= 2;
        }while ($src$ < $stop$) {
          ; HEAP8[$dest$++] = HEAP8[$src$++];
        }; //@line 690 "readclause.cpp"
        ; //@line 691 "readclause.cpp"
      }
    } while(0);
  
    STACKTOP = __stackBase__;
    return;
    return;
  }
  

  function __ZL8IsRomanUj($c) {
    ;
    var __label__;
  
    var $retval;
    var $c_addr;
    $c_addr=$c;
    var $0=$c_addr; //@line 383 "readclause.cpp"
    var $cmp=((($0))|0)==73; //@line 383 "readclause.cpp"
    var $1=$c_addr; //@line 383 "readclause.cpp"
    var $cmp1=((($1))|0)==86; //@line 383 "readclause.cpp"
    var $or_cond=($cmp) | ($cmp1); //@line 383 "readclause.cpp"
    var $2=$c_addr; //@line 383 "readclause.cpp"
    var $cmp3=((($2))|0)==88; //@line 383 "readclause.cpp"
    var $or_cond1=($or_cond) | ($cmp3); //@line 383 "readclause.cpp"
    var $3=$c_addr; //@line 383 "readclause.cpp"
    var $cmp5=((($3))|0)==76; //@line 383 "readclause.cpp"
    var $or_cond2=($or_cond1) | ($cmp5); //@line 383 "readclause.cpp"
    if ($or_cond2) { __label__ = 1;; } else { __label__ = 2;; } //@line 383 "readclause.cpp"
    if (__label__ == 1) {
  
      $retval=1; //@line 384 "readclause.cpp"
      ; //@line 384 "readclause.cpp"
    }
    else if (__label__ == 2) {
  
      $retval=0; //@line 385 "readclause.cpp"
      ; //@line 385 "readclause.cpp"
    }
  
    var $4=$retval; //@line 386 "readclause.cpp"
    ;
    return $4; //@line 386 "readclause.cpp"
    return null;
  }
  

  function __Z12InitNamedatav() {
    ;
    var __label__;
  
    HEAP32[((__ZL11namedata_ix)>>2)]=0; //@line 2726 "readclause.cpp"
    var $0=HEAP32[((_namedata)>>2)]; //@line 2727 "readclause.cpp"
    var $cmp=((($0))|0)!=0; //@line 2727 "readclause.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 2727 "readclause.cpp"
    if (__label__ == 1) {
  
      var $1=HEAP32[((_namedata)>>2)]; //@line 2729 "readclause.cpp"
      ; //@line 2729 "readclause.cpp"
      HEAP32[((_namedata)>>2)]=0; //@line 2730 "readclause.cpp"
      HEAP32[((__ZL10n_namedata)>>2)]=0; //@line 2731 "readclause.cpp"
      ; //@line 2732 "readclause.cpp"
    }
  
    ;
    return; //@line 2733 "readclause.cpp"
    return;
  }
  

  function __Z9InitText2v() {
    ;
    var __label__;
  
    var $param;
    HEAP32[((__ZL10ungot_char)>>2)]=0; //@line 2740 "readclause.cpp"
    HEAP32[((__ZL11ungot_char2)>>2)]=0; //@line 2741 "readclause.cpp"
    HEAP32[((__ZL12n_ssml_stack)>>2)]=1; //@line 2743 "readclause.cpp"
    HEAP32[((__ZL13n_param_stack)>>2)]=1; //@line 2744 "readclause.cpp"
    HEAP32[((((__ZL10ssml_stack)&4294967295))>>2)]=0; //@line 2745 "readclause.cpp"
    $param=0; //@line 2747 "readclause.cpp"
    ; //@line 2747 "readclause.cpp"
    while(1) { 
  
      var $0=$param; //@line 2748 "readclause.cpp"
      var $arrayidx=((((_param_stack+4)&4294967295)+$0*4)&4294967295); //@line 2748 "readclause.cpp"
      var $1=HEAP32[(($arrayidx)>>2)]; //@line 2748 "readclause.cpp"
      var $2=$param; //@line 2748 "readclause.cpp"
      var $arrayidx1=((__ZL17speech_parameters+$2*4)&4294967295); //@line 2748 "readclause.cpp"
      HEAP32[(($arrayidx1)>>2)]=$1; //@line 2748 "readclause.cpp"
      var $3=$param; //@line 2747 "readclause.cpp"
      var $inc=((($3)+1)&4294967295); //@line 2747 "readclause.cpp"
      $param=$inc; //@line 2747 "readclause.cpp"
      var $cmp=((($inc))|0) < 15; //@line 2747 "readclause.cpp"
      if ($cmp) { __label__ = 1;continue ; } else { __label__ = 2;break ; } //@line 2747 "readclause.cpp"
    }
  
    var $4=HEAP32[((((__ZL17speech_parameters+20)&4294967295))>>2)]; //@line 2750 "readclause.cpp"
    HEAP32[((_option_punctuation)>>2)]=$4; //@line 2750 "readclause.cpp"
    var $5=HEAP32[((((__ZL17speech_parameters+24)&4294967295))>>2)]; //@line 2751 "readclause.cpp"
    HEAP32[((_option_capitals)>>2)]=$5; //@line 2751 "readclause.cpp"
    HEAP8[(((__ZL16current_voice_id)&4294967295))]=0; //@line 2753 "readclause.cpp"
    HEAP8[(__ZL11ignore_text_b)]=0;
    HEAP8[(__ZL10audio_text_b)]=0;
    HEAP8[(__ZL19clear_skipping_text_b)]=0;
    HEAP32[((_count_characters)>>2)]=-1; //@line 2758 "readclause.cpp"
    HEAP32[((__ZL10sayas_mode)>>2)]=0; //@line 2759 "readclause.cpp"
    HEAP32[((__ZL7xmlbase)>>2)]=0; //@line 2761 "readclause.cpp"
    ;
    return; //@line 2762 "readclause.cpp"
    return;
  }
  

  function __ZL13WordToString2j($word) {
    ;
    var __label__;
  
    var $word_addr;
    var $ix;
    var $p;
    $word_addr=$word;
    $p=((__ZZL13WordToString2jE3buf)&4294967295); //@line 577 "readclause.cpp"
    $ix=3; //@line 578 "readclause.cpp"
    ; //@line 578 "readclause.cpp"
    while(1) { 
  
      var $0=$word_addr; //@line 580 "readclause.cpp"
      var $1=$ix; //@line 580 "readclause.cpp"
      var $mul=((($1)*8)&4294967295); //@line 580 "readclause.cpp"
      var $shr=($0) >>> ((($mul))>>>0); //@line 580 "readclause.cpp"
      var $conv=((($shr)) & 255); //@line 580 "readclause.cpp"
      var $2=$p; //@line 580 "readclause.cpp"
      HEAP8[($2)]=$conv; //@line 580 "readclause.cpp"
      var $conv1=(tempInt=(($conv)),(tempInt>=128?tempInt-256:tempInt)); //@line 580 "readclause.cpp"
      var $cmp2=((($conv1))|0)!=0; //@line 580 "readclause.cpp"
      if ($cmp2) { __label__ = 2;; } else { __label__ = 3;; } //@line 580 "readclause.cpp"
      if (__label__ == 2) {
  
        var $3=$p; //@line 581 "readclause.cpp"
        var $incdec_ptr=(($3+1)&4294967295); //@line 581 "readclause.cpp"
        $p=$incdec_ptr; //@line 581 "readclause.cpp"
        ; //@line 581 "readclause.cpp"
      }
  
      var $4=$ix; //@line 578 "readclause.cpp"
      var $dec=((($4)-1)&4294967295); //@line 578 "readclause.cpp"
      $ix=$dec; //@line 578 "readclause.cpp"
      var $cmp=((($dec))|0) >= 0; //@line 578 "readclause.cpp"
      if ($cmp) { __label__ = 1;continue ; } else { __label__ = 4;break ; } //@line 578 "readclause.cpp"
    }
  
    var $5=$p; //@line 583 "readclause.cpp"
    HEAP8[($5)]=0; //@line 583 "readclause.cpp"
    ;
    return;
    return;
  }
  

  function __ZL15LookupSoundiconi($c) {
    ;
    var __label__;
  
    var $retval;
    var $c_addr;
    var $ix;
    $c_addr=$c;
    $ix=4; //@line 810 "readclause.cpp"
    ; //@line 810 "readclause.cpp"
    $for_cond$2: while(1) { 
  
      var $0=$ix; //@line 810 "readclause.cpp"
      var $1=HEAP32[((_n_soundicon_tab)>>2)]; //@line 810 "readclause.cpp"
      var $cmp=((($0))|0) < ((($1))|0); //@line 810 "readclause.cpp"
      if (!($cmp)) { __label__ = 8;break $for_cond$2; } //@line 810 "readclause.cpp"
  
      var $2=$ix; //@line 812 "readclause.cpp"
      var $arrayidx=((_soundicon_tab+$2*16)&4294967295); //@line 812 "readclause.cpp"
      var $name=(($arrayidx)&4294967295); //@line 812 "readclause.cpp"
      var $3=HEAP32[(($name)>>2)]; //@line 812 "readclause.cpp"
      var $4=$c_addr; //@line 812 "readclause.cpp"
      var $cmp1=((($3))|0)==((($4))|0); //@line 812 "readclause.cpp"
      var $5=$ix; //@line 814 "readclause.cpp"
      if ($cmp1) { __label__ = 3;break $for_cond$2; } //@line 812 "readclause.cpp"
  
      var $inc=((($5)+1)&4294967295); //@line 810 "readclause.cpp"
      $ix=$inc; //@line 810 "readclause.cpp"
      __label__ = 1;continue $for_cond$2; //@line 810 "readclause.cpp"
    }
    $for_end$$if_then$6: do { 
      if (__label__ == 8) {
  
        $retval=-1; //@line 822 "readclause.cpp"
        ; //@line 822 "readclause.cpp"
      }
      else if (__label__ == 3) {
  
        var $arrayidx2=((_soundicon_tab+$5*16)&4294967295); //@line 814 "readclause.cpp"
        var $length=(($arrayidx2+4)&4294967295); //@line 814 "readclause.cpp"
        var $6=HEAP32[(($length)>>2)]; //@line 814 "readclause.cpp"
        var $cmp3=((($6))|0)==0; //@line 814 "readclause.cpp"
        if ($cmp3) { __label__ = 4;; } else { __label__ = 6;; } //@line 814 "readclause.cpp"
        $if_then4$$if_end7$9: do { 
          if (__label__ == 4) {
  
            var $7=$ix; //@line 816 "readclause.cpp"
            var $call=__ZL13LoadSoundFilePKci(0, $7); //@line 816 "readclause.cpp"
            var $cmp5=((($call))|0)!=0; //@line 816 "readclause.cpp"
            if (!($cmp5)) { __label__ = 6;break $if_then4$$if_end7$9; } //@line 816 "readclause.cpp"
  
            $retval=-1; //@line 817 "readclause.cpp"
            __label__ = 9;break $for_end$$if_then$6; //@line 817 "readclause.cpp"
          }
        } while(0);
  
        var $8=$ix; //@line 819 "readclause.cpp"
        $retval=$8; //@line 819 "readclause.cpp"
        ; //@line 819 "readclause.cpp"
      }
    } while(0);
  
    var $9=$retval; //@line 823 "readclause.cpp"
    ;
    return $9; //@line 823 "readclause.cpp"
    return null;
  }
  

  function __ZL13LoadSoundFilePKci($fname, $index) {
    var __stackBase__  = STACKTOP; STACKTOP += 764; _memset(__stackBase__, 0, 764);
    var __label__;
  
    var $retval;
    var $fname_addr;
    var $index_addr;
    var $f;
    var $p;
    var $ip;
    var $length;
    var $fname_temp=__stackBase__;
    var $fname2=__stackBase__+100;
    var $ix;
    var $fd_temp;
    var $resample;
    var $header=__stackBase__+304;
    var $command=__stackBase__+316;
    $fname_addr=$fname;
    $index_addr=$index;
    var $0=$fname_addr; //@line 721 "readclause.cpp"
    var $cmp=((($0))|0)==0; //@line 721 "readclause.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 3;; } //@line 721 "readclause.cpp"
    $if_end$$if_end3$2: do { 
      if (__label__ == 1) {
  
        var $1=$index_addr; //@line 724 "readclause.cpp"
        var $arrayidx=((_soundicon_tab+$1*16)&4294967295); //@line 724 "readclause.cpp"
        var $filename=(($arrayidx+12)&4294967295); //@line 724 "readclause.cpp"
        var $2=HEAP32[(($filename)>>2)]; //@line 724 "readclause.cpp"
        $fname_addr=$2; //@line 724 "readclause.cpp"
        var $cmp1=((($2))|0)==0; //@line 727 "readclause.cpp"
        if (!($cmp1)) { __label__ = 3;break $if_end$$if_end3$2; } //@line 727 "readclause.cpp"
  
        $retval=1; //@line 728 "readclause.cpp"
        __label__ = 23;break $if_end$$if_end3$2; //@line 728 "readclause.cpp"
      }
    } while(0);
    $return$$if_end3$5: do { 
      if (__label__ == 3) {
  
        var $3=$fname_addr; //@line 730 "readclause.cpp"
        var $arrayidx4=(($3)&4294967295); //@line 730 "readclause.cpp"
        var $4=HEAP8[($arrayidx4)]; //@line 730 "readclause.cpp"
        var $conv=(tempInt=(($4)),(tempInt>=128?tempInt-256:tempInt)); //@line 730 "readclause.cpp"
        var $cmp5=((($conv))|0)!=47; //@line 730 "readclause.cpp"
        if ($cmp5) { __label__ = 4;; } else { __label__ = 5;; } //@line 730 "readclause.cpp"
        if (__label__ == 4) {
  
          var $arraydecay=(($fname2)&4294967295); //@line 733 "readclause.cpp"
          var $5=$fname_addr; //@line 733 "readclause.cpp"
          var $call=_sprintf($arraydecay, ((__str55222)&4294967295), allocate([((_path_home)&4294967295),0,0,0,47,0,0,0,47,0,0,0,$5,0,0,0], ["i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 733 "readclause.cpp"
          var $arraydecay7=(($fname2)&4294967295); //@line 734 "readclause.cpp"
          $fname_addr=$arraydecay7; //@line 734 "readclause.cpp"
          ; //@line 735 "readclause.cpp"
        }
  
        $f=0; //@line 737 "readclause.cpp"
        var $6=$fname_addr; //@line 739 "readclause.cpp"
        var $call9=_fopen($6, ((__str18429)&4294967295)); //@line 739 "readclause.cpp"
        $f=$call9; //@line 739 "readclause.cpp"
        var $cmp10=((($call9))|0)!=0; //@line 739 "readclause.cpp"
        if ($cmp10) { __label__ = 6;; } else { __label__ = 18;; } //@line 739 "readclause.cpp"
        $if_then11$$if_then49$10: do { 
          if (__label__ == 6) {
  
            var $7=$f; //@line 747 "readclause.cpp"
            var $call12=_fseek($7, 20, 0); //@line 747 "readclause.cpp"
            $ix=0; //@line 748 "readclause.cpp"
            ; //@line 748 "readclause.cpp"
            $for_body$12: while(1) { 
  
              var $8=$f; //@line 749 "readclause.cpp"
              var $call14=__Z10Read4BytesP7__sFILE($8); //@line 749 "readclause.cpp"
              var $9=$ix; //@line 749 "readclause.cpp"
              var $arrayidx15=(($header+$9*4)&4294967295); //@line 749 "readclause.cpp"
              HEAP32[(($arrayidx15)>>2)]=$call14; //@line 749 "readclause.cpp"
              var $10=$ix; //@line 748 "readclause.cpp"
              var $inc=((($10)+1)&4294967295); //@line 748 "readclause.cpp"
              $ix=$inc; //@line 748 "readclause.cpp"
              var $cmp13=((($inc))|0) < 3; //@line 748 "readclause.cpp"
              if ($cmp13) { __label__ = 7;continue $for_body$12; } else { __label__ = 8;break $for_body$12; } //@line 748 "readclause.cpp"
            }
  
            var $arrayidx16=(($header)&4294967295); //@line 752 "readclause.cpp"
            var $11=HEAP32[(($arrayidx16)>>2)]; //@line 752 "readclause.cpp"
            var $cmp17=((($11))|0)!=65537; //@line 752 "readclause.cpp"
            if ($cmp17) { __label__ = 11;; } else { __label__ = 9;; } //@line 752 "readclause.cpp"
            $if_then23$$lor_lhs_false$15: do { 
              if (__label__ == 9) {
  
                var $arrayidx18=(($header+4)&4294967295); //@line 752 "readclause.cpp"
                var $12=HEAP32[(($arrayidx18)>>2)]; //@line 752 "readclause.cpp"
                var $13=HEAP32[((_samplerate)>>2)]; //@line 752 "readclause.cpp"
                var $cmp19=((($12))|0)!=((($13))|0); //@line 752 "readclause.cpp"
                if ($cmp19) { __label__ = 11;break $if_then23$$lor_lhs_false$15; } //@line 752 "readclause.cpp"
  
                var $arrayidx21=(($header+8)&4294967295); //@line 752 "readclause.cpp"
                var $14=HEAP32[(($arrayidx21)>>2)]; //@line 752 "readclause.cpp"
                var $15=HEAP32[((_samplerate)>>2)]; //@line 752 "readclause.cpp"
                var $mul=((($15)*2)&4294967295); //@line 752 "readclause.cpp"
                var $cmp22=((($14))|0)!=((($mul))|0); //@line 752 "readclause.cpp"
                if ($cmp22) { __label__ = 11;break $if_then23$$lor_lhs_false$15; } else { __label__ = 17;break $if_then23$$lor_lhs_false$15; } //@line 752 "readclause.cpp"
              }
            } while(0);
            $if_then23$$if_end47$18: do { 
              if (__label__ == 11) {
  
                var $16=$f; //@line 754 "readclause.cpp"
                var $call24=_fclose($16); //@line 754 "readclause.cpp"
                $f=0; //@line 755 "readclause.cpp"
                var $arrayidx25=(($header+8)&4294967295); //@line 757 "readclause.cpp"
                var $17=HEAP32[(($arrayidx25)>>2)]; //@line 757 "readclause.cpp"
                var $18=HEAP32[((_samplerate)>>2)]; //@line 757 "readclause.cpp"
                var $cmp26=((($17))|0)==((($18))|0); //@line 757 "readclause.cpp"
                if ($cmp26) { __label__ = 12;; } else { __label__ = 13;; } //@line 757 "readclause.cpp"
                if (__label__ == 12) {
  
                  $resample=((__str13643)&4294967295); //@line 758 "readclause.cpp"
                  ; //@line 758 "readclause.cpp"
                }
                else if (__label__ == 13) {
  
                  $resample=((__str57224)&4294967295); //@line 760 "readclause.cpp"
                  ;
                }
  
                var $arraydecay29=(($fname_temp)&4294967295); //@line 762 "readclause.cpp"
                var $src$, $dest$, $stop$, $stop4$, $fast$;
                $src$ = ((__str58225)&4294967295);
                $dest$ = $arraydecay29;
                $stop$ = $src$ + 18;
                if (($dest$%4) == ($src$%4) && 18 > 8) {
                  while ($src$%4 !== 0 && $src$ < $stop$) {
                    ; HEAP8[$dest$++] = HEAP8[$src$++];
                  }
                  $src$ >>= 2;
                  $dest$ >>= 2;
                  $stop4$ = $stop$ >> 2;
                  while ($src$ < $stop4$) {
                ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
                  }
                  $src$ <<= 2;
                  $dest$ <<= 2;
                }while ($src$ < $stop$) {
                  ; HEAP8[$dest$++] = HEAP8[$src$++];
                }; //@line 762 "readclause.cpp"
                var $arraydecay31=(($fname_temp)&4294967295); //@line 763 "readclause.cpp"
                var $call32=_mkstemp($arraydecay31); //@line 763 "readclause.cpp"
                $fd_temp=$call32; //@line 763 "readclause.cpp"
                var $cmp33=((($call32))|0) >= 0; //@line 763 "readclause.cpp"
                if (!($cmp33)) { __label__ = 17;break $if_then23$$if_end47$18; } //@line 763 "readclause.cpp"
  
                var $19=$fd_temp; //@line 765 "readclause.cpp"
                var $call35=_close($19); //@line 765 "readclause.cpp"
                var $arraydecay36=(($command)&4294967295); //@line 767 "readclause.cpp"
                var $20=$fname_addr; //@line 767 "readclause.cpp"
                var $21=HEAP32[((_samplerate)>>2)]; //@line 767 "readclause.cpp"
                var $arraydecay37=(($fname_temp)&4294967295); //@line 767 "readclause.cpp"
                var $22=$resample; //@line 767 "readclause.cpp"
                var $call38=_sprintf($arraydecay36, ((__str59226)&4294967295), allocate([$20,0,0,0,$21,0,0,0,$arraydecay37,0,0,0,$22,0,0,0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 767 "readclause.cpp"
                var $arraydecay39=(($command)&4294967295); //@line 768 "readclause.cpp"
                var $call40=_system($arraydecay39); //@line 768 "readclause.cpp"
                var $cmp41=((($call40))|0)==0; //@line 768 "readclause.cpp"
                if (!($cmp41)) { __label__ = 17;break $if_then23$$if_end47$18; } //@line 768 "readclause.cpp"
  
                var $arraydecay43=(($fname_temp)&4294967295); //@line 770 "readclause.cpp"
                $fname_addr=$arraydecay43; //@line 770 "readclause.cpp"
                ; //@line 771 "readclause.cpp"
              }
            } while(0);
  
            var $_pr=$f; //@line 777 "readclause.cpp"
            var $cmp48=((($_pr))|0)==0; //@line 777 "readclause.cpp"
            if ($cmp48) { __label__ = 18;break $if_then11$$if_then49$10; } else { __label__ = 20;break $if_then11$$if_then49$10; } //@line 777 "readclause.cpp"
          }
        } while(0);
        $if_then49$$if_end54$27: do { 
          if (__label__ == 18) {
  
            var $23=$fname_addr; //@line 779 "readclause.cpp"
            var $call50=_fopen($23, ((__str18429)&4294967295)); //@line 779 "readclause.cpp"
            $f=$call50; //@line 779 "readclause.cpp"
            var $cmp51=((($call50))|0)==0; //@line 780 "readclause.cpp"
            if (!($cmp51)) { __label__ = 20;break $if_then49$$if_end54$27; } //@line 780 "readclause.cpp"
  
            $retval=3; //@line 783 "readclause.cpp"
            __label__ = 23;break $return$$if_end3$5; //@line 783 "readclause.cpp"
          }
        } while(0);
  
        var $24=$fname_addr; //@line 787 "readclause.cpp"
        var $call55=__Z13GetFileLengthPKc($24); //@line 787 "readclause.cpp"
        $length=$call55; //@line 787 "readclause.cpp"
        var $25=$f; //@line 788 "readclause.cpp"
        var $call56=_fseek($25, 0, 0); //@line 788 "readclause.cpp"
        var $26=$index_addr; //@line 789 "readclause.cpp"
        var $arrayidx57=((_soundicon_tab+$26*16)&4294967295); //@line 789 "readclause.cpp"
        var $data=(($arrayidx57+8)&4294967295); //@line 789 "readclause.cpp"
        var $27=HEAP32[(($data)>>2)]; //@line 789 "readclause.cpp"
        var $28=$length; //@line 789 "readclause.cpp"
        var $call58=_realloc($27, $28); //@line 789 "readclause.cpp"
        $p=$call58; //@line 789 "readclause.cpp"
        var $cmp59=((($call58))|0)==0; //@line 789 "readclause.cpp"
        if ($cmp59) { __label__ = 21;; } else { __label__ = 22;; } //@line 789 "readclause.cpp"
        if (__label__ == 21) {
  
          var $29=$f; //@line 791 "readclause.cpp"
          var $call61=_fclose($29); //@line 791 "readclause.cpp"
          $retval=4; //@line 792 "readclause.cpp"
          ; //@line 792 "readclause.cpp"
        }
        else if (__label__ == 22) {
  
          var $30=$p; //@line 794 "readclause.cpp"
          var $31=$length; //@line 794 "readclause.cpp"
          var $32=$f; //@line 794 "readclause.cpp"
          var $call63=_fread($30, 1, $31, $32); //@line 794 "readclause.cpp"
          $length=$call63; //@line 794 "readclause.cpp"
          var $33=$f; //@line 795 "readclause.cpp"
          var $call64=_fclose($33); //@line 795 "readclause.cpp"
          var $arraydecay65=(($fname_temp)&4294967295); //@line 796 "readclause.cpp"
          var $call66=_remove($arraydecay65); //@line 796 "readclause.cpp"
          var $34=$p; //@line 798 "readclause.cpp"
          var $arrayidx67=(($34+40)&4294967295); //@line 798 "readclause.cpp"
          var $35=$arrayidx67; //@line 798 "readclause.cpp"
          $ip=$35; //@line 798 "readclause.cpp"
          var $36=$ip; //@line 799 "readclause.cpp"
          var $37=HEAP32[(($36)>>2)]; //@line 799 "readclause.cpp"
          var $div=((((($37))|0)/2)|0); //@line 799 "readclause.cpp"
          var $38=$index_addr; //@line 799 "readclause.cpp"
          var $arrayidx68=((_soundicon_tab+$38*16)&4294967295); //@line 799 "readclause.cpp"
          var $length69=(($arrayidx68+4)&4294967295); //@line 799 "readclause.cpp"
          HEAP32[(($length69)>>2)]=$div; //@line 799 "readclause.cpp"
          var $39=$p; //@line 800 "readclause.cpp"
          var $40=$index_addr; //@line 800 "readclause.cpp"
          var $arrayidx70=((_soundicon_tab+$40*16)&4294967295); //@line 800 "readclause.cpp"
          var $data71=(($arrayidx70+8)&4294967295); //@line 800 "readclause.cpp"
          HEAP32[(($data71)>>2)]=$39; //@line 800 "readclause.cpp"
          $retval=0; //@line 801 "readclause.cpp"
          ; //@line 801 "readclause.cpp"
        }
      }
    } while(0);
  
    var $41=$retval; //@line 802 "readclause.cpp"
    STACKTOP = __stackBase__;
    return $41; //@line 802 "readclause.cpp"
    return null;
  }
  

  function __ZL14PushParamStacki($tag_type) {
    ;
    var __label__;
  
    var $tag_type_addr;
    var $ix;
    var $sp;
    $tag_type_addr=$tag_type;
    var $0=HEAP32[((__ZL13n_param_stack)>>2)]; //@line 1159 "readclause.cpp"
    var $arrayidx=((_param_stack+$0*64)&4294967295); //@line 1159 "readclause.cpp"
    $sp=$arrayidx; //@line 1159 "readclause.cpp"
    var $cmp=((($0))|0) < 19; //@line 1160 "readclause.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 1160 "readclause.cpp"
    if (__label__ == 1) {
  
      var $1=HEAP32[((__ZL13n_param_stack)>>2)]; //@line 1161 "readclause.cpp"
      var $inc=((($1)+1)&4294967295); //@line 1161 "readclause.cpp"
      HEAP32[((__ZL13n_param_stack)>>2)]=$inc; //@line 1161 "readclause.cpp"
      ; //@line 1161 "readclause.cpp"
    }
  
    var $2=$tag_type_addr; //@line 1163 "readclause.cpp"
    var $3=$sp; //@line 1163 "readclause.cpp"
    var $type=(($3)&4294967295); //@line 1163 "readclause.cpp"
    HEAP32[(($type)>>2)]=$2; //@line 1163 "readclause.cpp"
    $ix=0; //@line 1164 "readclause.cpp"
    ; //@line 1164 "readclause.cpp"
    while(1) { 
  
      var $4=$ix; //@line 1166 "readclause.cpp"
      var $5=$sp; //@line 1166 "readclause.cpp"
      var $parameter=(($5+4)&4294967295); //@line 1166 "readclause.cpp"
      var $arrayidx2=(($parameter+$4*4)&4294967295); //@line 1166 "readclause.cpp"
      HEAP32[(($arrayidx2)>>2)]=-1; //@line 1166 "readclause.cpp"
      var $6=$ix; //@line 1164 "readclause.cpp"
      var $inc3=((($6)+1)&4294967295); //@line 1164 "readclause.cpp"
      $ix=$inc3; //@line 1164 "readclause.cpp"
      var $cmp1=((($inc3))|0) < 15; //@line 1164 "readclause.cpp"
      if ($cmp1) { __label__ = 3;continue ; } else { __label__ = 4;break ; } //@line 1164 "readclause.cpp"
    }
  
    var $7=$sp; //@line 1168 "readclause.cpp"
    ;
    return $7; //@line 1168 "readclause.cpp"
    return null;
  }
  

  function __ZL16GetSsmlAttributePwPKc($pw, $name) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $pw_addr;
    var $name_addr;
    var $ix;
    $pw_addr=$pw;
    $name_addr=$name;
    ; //@line 1204 "readclause.cpp"
    $while_cond$2: while(1) { 
  
      var $0=$pw_addr; //@line 1204 "readclause.cpp"
      var $1=HEAP32[(($0)>>2)]; //@line 1204 "readclause.cpp"
      var $cmp=((($1))|0)!=0; //@line 1204 "readclause.cpp"
      if (!($cmp)) { __label__ = 17;break $while_cond$2; } //@line 1204 "readclause.cpp"
  
      var $2=$pw_addr; //@line 1206 "readclause.cpp"
      var $arrayidx=(($2+-4)&4294967295); //@line 1206 "readclause.cpp"
      var $3=HEAP32[(($arrayidx)>>2)]; //@line 1206 "readclause.cpp"
      var $call=_iswspace($3); //@line 1206 "readclause.cpp"
      var $tobool=((($call))|0)!=0; //@line 1206 "readclause.cpp"
      if ($tobool) { __label__ = 3;; } else { __label__ = 16;; } //@line 1206 "readclause.cpp"
      if (__label__ == 3) {
  
        $ix=0; //@line 1208 "readclause.cpp"
        var $4=$pw_addr; //@line 1209 "readclause.cpp"
        var $5=HEAP32[(($4)>>2)]; //@line 1209 "readclause.cpp"
        var $6=$ix; //@line 1209 "readclause.cpp"
        var $7=$name_addr; //@line 1209 "readclause.cpp"
        var $arrayidx27=(($7+$6)&4294967295); //@line 1209 "readclause.cpp"
        var $8=HEAP8[($arrayidx27)]; //@line 1209 "readclause.cpp"
        var $conv8=(tempInt=(($8)),(tempInt>=128?tempInt-256:tempInt)); //@line 1209 "readclause.cpp"
        var $cmp39=((($5))|0)==((($conv8))|0); //@line 1209 "readclause.cpp"
        if ($cmp39) { __label__ = 4;; } else { __label__ = 5;; } //@line 1209 "readclause.cpp"
        $while_body4$$while_end$7: do { 
          if (__label__ == 4) {
            while(1) { 
  
              var $9=$pw_addr; //@line 1211 "readclause.cpp"
              var $incdec_ptr=(($9+4)&4294967295); //@line 1211 "readclause.cpp"
              $pw_addr=$incdec_ptr; //@line 1211 "readclause.cpp"
              var $10=$ix; //@line 1212 "readclause.cpp"
              var $inc=((($10)+1)&4294967295); //@line 1212 "readclause.cpp"
              $ix=$inc; //@line 1212 "readclause.cpp"
              var $11=$pw_addr; //@line 1209 "readclause.cpp"
              var $12=HEAP32[(($11)>>2)]; //@line 1209 "readclause.cpp"
              var $13=$ix; //@line 1209 "readclause.cpp"
              var $14=$name_addr; //@line 1209 "readclause.cpp"
              var $arrayidx2=(($14+$13)&4294967295); //@line 1209 "readclause.cpp"
              var $15=HEAP8[($arrayidx2)]; //@line 1209 "readclause.cpp"
              var $conv=(tempInt=(($15)),(tempInt>=128?tempInt-256:tempInt)); //@line 1209 "readclause.cpp"
              var $cmp3=((($12))|0)==((($conv))|0); //@line 1209 "readclause.cpp"
              if ($cmp3) { __label__ = 4;continue ; } else { __label__ = 5;break $while_body4$$while_end$7; } //@line 1209 "readclause.cpp"
            }
          }
        } while(0);
  
        var $16=$ix; //@line 1214 "readclause.cpp"
        var $17=$name_addr; //@line 1214 "readclause.cpp"
        var $arrayidx5=(($17+$16)&4294967295); //@line 1214 "readclause.cpp"
        var $18=HEAP8[($arrayidx5)]; //@line 1214 "readclause.cpp"
        var $conv6=(tempInt=(($18)),(tempInt>=128?tempInt-256:tempInt)); //@line 1214 "readclause.cpp"
        var $cmp7=((($conv6))|0)==0; //@line 1214 "readclause.cpp"
        if ($cmp7) { __label__ = 6;break $while_cond$2; } //@line 1214 "readclause.cpp"
      }
  
      var $39=$pw_addr; //@line 1226 "readclause.cpp"
      var $incdec_ptr29=(($39+4)&4294967295); //@line 1226 "readclause.cpp"
      $pw_addr=$incdec_ptr29; //@line 1226 "readclause.cpp"
      __label__ = 1;continue $while_cond$2; //@line 1227 "readclause.cpp"
    }
    $while_end30$$while_cond9_preheader$12: do { 
      if (__label__ == 17) {
  
        $retval=0; //@line 1228 "readclause.cpp"
        ; //@line 1228 "readclause.cpp"
      }
      else if (__label__ == 6) {
  
        var $19=$pw_addr; //@line 1217 "readclause.cpp"
        var $20=HEAP32[(($19)>>2)]; //@line 1217 "readclause.cpp"
        var $call104=_iswspace($20); //@line 1217 "readclause.cpp"
        var $tobool115=((($call104))|0)!=0; //@line 1217 "readclause.cpp"
        var $21=$pw_addr; //@line 1217 "readclause.cpp"
        if ($tobool115) { __lastLabel__ = 6; __label__ = 7;; } else { __lastLabel__ = 6; __label__ = 8;; } //@line 1217 "readclause.cpp"
        $while_body12$$while_end14$15: do { 
          if (__label__ == 7) {
            while(1) { 
  
              var $22=__lastLabel__ == 7 ? $25 : ($21);
              var $incdec_ptr13=(($22+4)&4294967295); //@line 1217 "readclause.cpp"
              $pw_addr=$incdec_ptr13; //@line 1217 "readclause.cpp"
              var $23=$pw_addr; //@line 1217 "readclause.cpp"
              var $24=HEAP32[(($23)>>2)]; //@line 1217 "readclause.cpp"
              var $call10=_iswspace($24); //@line 1217 "readclause.cpp"
              var $tobool11=((($call10))|0)!=0; //@line 1217 "readclause.cpp"
              var $25=$pw_addr; //@line 1217 "readclause.cpp"
              if ($tobool11) { __lastLabel__ = 7; __label__ = 7;continue ; } else { __lastLabel__ = 7; __label__ = 8;break $while_body12$$while_end14$15; } //@line 1217 "readclause.cpp"
            }
          }
        } while(0);
  
        var $_lcssa3=__lastLabel__ == 6 ? $21 : ($25);
        var $26=HEAP32[(($_lcssa3)>>2)]; //@line 1218 "readclause.cpp"
        var $cmp15=((($26))|0)==61; //@line 1218 "readclause.cpp"
        if ($cmp15) { __label__ = 9;; } else { __label__ = 10;; } //@line 1218 "readclause.cpp"
        if (__label__ == 9) {
  
          var $27=$pw_addr; //@line 1218 "readclause.cpp"
          var $incdec_ptr17=(($27+4)&4294967295); //@line 1218 "readclause.cpp"
          $pw_addr=$incdec_ptr17; //@line 1218 "readclause.cpp"
          ; //@line 1218 "readclause.cpp"
        }
  
        var $28=$pw_addr; //@line 1219 "readclause.cpp"
        var $29=HEAP32[(($28)>>2)]; //@line 1219 "readclause.cpp"
        var $call191=_iswspace($29); //@line 1219 "readclause.cpp"
        var $tobool202=((($call191))|0)!=0; //@line 1219 "readclause.cpp"
        var $30=$pw_addr; //@line 1219 "readclause.cpp"
        if ($tobool202) { __lastLabel__ = 10; __label__ = 11;; } else { __lastLabel__ = 10; __label__ = 12;; } //@line 1219 "readclause.cpp"
        $while_body21$$while_end23$22: do { 
          if (__label__ == 11) {
            while(1) { 
  
              var $31=__lastLabel__ == 11 ? $34 : ($30);
              var $incdec_ptr22=(($31+4)&4294967295); //@line 1219 "readclause.cpp"
              $pw_addr=$incdec_ptr22; //@line 1219 "readclause.cpp"
              var $32=$pw_addr; //@line 1219 "readclause.cpp"
              var $33=HEAP32[(($32)>>2)]; //@line 1219 "readclause.cpp"
              var $call19=_iswspace($33); //@line 1219 "readclause.cpp"
              var $tobool20=((($call19))|0)!=0; //@line 1219 "readclause.cpp"
              var $34=$pw_addr; //@line 1219 "readclause.cpp"
              if ($tobool20) { __lastLabel__ = 11; __label__ = 11;continue ; } else { __lastLabel__ = 11; __label__ = 12;break $while_body21$$while_end23$22; } //@line 1219 "readclause.cpp"
            }
          }
        } while(0);
  
        var $_lcssa=__lastLabel__ == 10 ? $30 : ($34);
        var $35=HEAP32[(($_lcssa)>>2)]; //@line 1220 "readclause.cpp"
        var $cmp24=((($35))|0)==34; //@line 1220 "readclause.cpp"
        if ($cmp24) { __label__ = 14;; } else { __label__ = 13;; } //@line 1220 "readclause.cpp"
        $if_then26$$lor_lhs_false$26: do { 
          if (__label__ == 13) {
  
            var $36=$pw_addr; //@line 1220 "readclause.cpp"
            var $37=HEAP32[(($36)>>2)]; //@line 1220 "readclause.cpp"
            var $cmp25=((($37))|0)==39; //@line 1220 "readclause.cpp"
            if ($cmp25) { __label__ = 14;break $if_then26$$lor_lhs_false$26; } //@line 1220 "readclause.cpp"
  
            $retval=((__ZZL16GetSsmlAttributePwPKcE5empty)&4294967295); //@line 1223 "readclause.cpp"
            __label__ = 18;break $while_end30$$while_cond9_preheader$12; //@line 1223 "readclause.cpp"
          }
        } while(0);
  
        var $38=$pw_addr; //@line 1221 "readclause.cpp"
        var $add_ptr=(($38+4)&4294967295); //@line 1221 "readclause.cpp"
        $retval=$add_ptr; //@line 1221 "readclause.cpp"
        ; //@line 1221 "readclause.cpp"
      }
    } while(0);
  
    var $40=$retval; //@line 1229 "readclause.cpp"
    ;
    return $40; //@line 1229 "readclause.cpp"
    return null;
  }
  

  function __ZL7attrcmpPKwPKc($string1, $string2) {
    ;
    var __label__;
  
    var $retval;
    var $string1_addr;
    var $string2_addr;
    var $ix;
    $string1_addr=$string1;
    $string2_addr=$string2;
    var $0=$string1_addr; //@line 1236 "readclause.cpp"
    var $cmp=((($0))|0)==0; //@line 1236 "readclause.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 1236 "readclause.cpp"
    $if_then$$if_end$2: do { 
      if (__label__ == 1) {
  
        $retval=1; //@line 1237 "readclause.cpp"
        ; //@line 1237 "readclause.cpp"
      }
      else if (__label__ == 2) {
  
        $ix=0; //@line 1239 "readclause.cpp"
        ; //@line 1239 "readclause.cpp"
        $for_cond$5: while(1) { 
  
          var $1=$ix; //@line 1239 "readclause.cpp"
          var $2=$string1_addr; //@line 1239 "readclause.cpp"
          var $arrayidx=(($2+4*$1)&4294967295); //@line 1239 "readclause.cpp"
          var $3=HEAP32[(($arrayidx)>>2)]; //@line 1239 "readclause.cpp"
          var $4=$ix; //@line 1239 "readclause.cpp"
          var $5=$string2_addr; //@line 1239 "readclause.cpp"
          var $arrayidx1=(($5+$4)&4294967295); //@line 1239 "readclause.cpp"
          var $6=HEAP8[($arrayidx1)]; //@line 1239 "readclause.cpp"
          var $conv=(tempInt=(($6)),(tempInt>=128?tempInt-256:tempInt)); //@line 1239 "readclause.cpp"
          var $cmp2=((($3))|0)==((($conv))|0); //@line 1239 "readclause.cpp"
          if (!($cmp2)) { __label__ = 6;break $for_cond$5; } //@line 1239 "readclause.cpp"
  
          var $7=$ix; //@line 1239 "readclause.cpp"
          var $8=$string1_addr; //@line 1239 "readclause.cpp"
          var $arrayidx3=(($8+4*$7)&4294967295); //@line 1239 "readclause.cpp"
          var $9=HEAP32[(($arrayidx3)>>2)]; //@line 1239 "readclause.cpp"
          var $cmp4=((($9))|0)!=0; //@line 1239 "readclause.cpp"
          if (!($cmp4)) { __label__ = 6;break $for_cond$5; }
  
          var $10=$ix; //@line 1239 "readclause.cpp"
          var $inc=((($10)+1)&4294967295); //@line 1239 "readclause.cpp"
          $ix=$inc; //@line 1239 "readclause.cpp"
          __label__ = 3;continue $for_cond$5; //@line 1239 "readclause.cpp"
        }
  
        var $11=$ix; //@line 1242 "readclause.cpp"
        var $12=$string1_addr; //@line 1242 "readclause.cpp"
        var $arrayidx5=(($12+4*$11)&4294967295); //@line 1242 "readclause.cpp"
        var $13=HEAP32[(($arrayidx5)>>2)]; //@line 1242 "readclause.cpp"
        var $cmp6=((($13))|0)==34; //@line 1242 "readclause.cpp"
        if ($cmp6) { __label__ = 8;; } else { __label__ = 7;; } //@line 1242 "readclause.cpp"
        $land_lhs_true$$lor_lhs_false$10: do { 
          if (__label__ == 7) {
  
            var $14=$ix; //@line 1242 "readclause.cpp"
            var $15=$string1_addr; //@line 1242 "readclause.cpp"
            var $arrayidx7=(($15+4*$14)&4294967295); //@line 1242 "readclause.cpp"
            var $16=HEAP32[(($arrayidx7)>>2)]; //@line 1242 "readclause.cpp"
            var $cmp8=((($16))|0)==39; //@line 1242 "readclause.cpp"
            if ($cmp8) { __label__ = 8;break $land_lhs_true$$lor_lhs_false$10; } else { __label__ = 10;break $land_lhs_true$$lor_lhs_false$10; } //@line 1242 "readclause.cpp"
          }
        } while(0);
        $land_lhs_true$$if_end13$12: do { 
          if (__label__ == 8) {
  
            var $17=$ix; //@line 1242 "readclause.cpp"
            var $18=$string2_addr; //@line 1242 "readclause.cpp"
            var $arrayidx9=(($18+$17)&4294967295); //@line 1242 "readclause.cpp"
            var $19=HEAP8[($arrayidx9)]; //@line 1242 "readclause.cpp"
            var $conv10=(tempInt=(($19)),(tempInt>=128?tempInt-256:tempInt)); //@line 1242 "readclause.cpp"
            var $cmp11=((($conv10))|0)==0; //@line 1242 "readclause.cpp"
            if (!($cmp11)) { __label__ = 10;break $land_lhs_true$$if_end13$12; } //@line 1242 "readclause.cpp"
  
            $retval=0; //@line 1243 "readclause.cpp"
            __label__ = 11;break $if_then$$if_end$2; //@line 1243 "readclause.cpp"
          }
        } while(0);
  
        $retval=1; //@line 1244 "readclause.cpp"
        ; //@line 1244 "readclause.cpp"
      }
    } while(0);
  
    var $20=$retval; //@line 1245 "readclause.cpp"
    ;
    return $20; //@line 1245 "readclause.cpp"
    return null;
  }
  

  function __ZL10attrlookupPKwPK8MNEM_TAB($string1, $mtab) {
    ;
    var __label__;
  
    var $retval;
    var $string1_addr;
    var $mtab_addr;
    var $ix;
    $string1_addr=$string1;
    $mtab_addr=$mtab;
    $ix=0; //@line 1252 "readclause.cpp"
    ; //@line 1252 "readclause.cpp"
    while(1) { 
  
      var $0=$ix; //@line 1252 "readclause.cpp"
      var $1=$mtab_addr; //@line 1252 "readclause.cpp"
      var $arrayidx=(($1+8*$0)&4294967295); //@line 1252 "readclause.cpp"
      var $mnem=(($arrayidx)&4294967295); //@line 1252 "readclause.cpp"
      var $2=HEAP32[(($mnem)>>2)]; //@line 1252 "readclause.cpp"
      var $cmp=((($2))|0)!=0; //@line 1252 "readclause.cpp"
      if (!($cmp)) { __label__ = 5;break ; } //@line 1252 "readclause.cpp"
  
      var $3=$string1_addr; //@line 1254 "readclause.cpp"
      var $4=$ix; //@line 1254 "readclause.cpp"
      var $5=$mtab_addr; //@line 1254 "readclause.cpp"
      var $arrayidx1=(($5+8*$4)&4294967295); //@line 1254 "readclause.cpp"
      var $mnem2=(($arrayidx1)&4294967295); //@line 1254 "readclause.cpp"
      var $6=HEAP32[(($mnem2)>>2)]; //@line 1254 "readclause.cpp"
      var $call=__ZL7attrcmpPKwPKc($3, $6); //@line 1254 "readclause.cpp"
      var $cmp3=((($call))|0)==0; //@line 1254 "readclause.cpp"
      var $7=$ix; //@line 1255 "readclause.cpp"
      if ($cmp3) { __label__ = 3;break ; } //@line 1254 "readclause.cpp"
  
      var $inc=((($7)+1)&4294967295); //@line 1252 "readclause.cpp"
      $ix=$inc; //@line 1252 "readclause.cpp"
      __label__ = 1;continue ; //@line 1252 "readclause.cpp"
    }
    if (__label__ == 5) {
  
      var $10=$ix; //@line 1257 "readclause.cpp"
      var $11=$mtab_addr; //@line 1257 "readclause.cpp"
      var $arrayidx5=(($11+8*$10)&4294967295); //@line 1257 "readclause.cpp"
      var $value6=(($arrayidx5+4)&4294967295); //@line 1257 "readclause.cpp"
      var $12=HEAP32[(($value6)>>2)]; //@line 1257 "readclause.cpp"
      $retval=$12; //@line 1257 "readclause.cpp"
      ; //@line 1257 "readclause.cpp"
    }
    else if (__label__ == 3) {
  
      var $8=$mtab_addr; //@line 1255 "readclause.cpp"
      var $arrayidx4=(($8+8*$7)&4294967295); //@line 1255 "readclause.cpp"
      var $value=(($arrayidx4+4)&4294967295); //@line 1255 "readclause.cpp"
      var $9=HEAP32[(($value)>>2)]; //@line 1255 "readclause.cpp"
      $retval=$9; //@line 1255 "readclause.cpp"
      ; //@line 1255 "readclause.cpp"
    }
  
    var $13=$retval; //@line 1258 "readclause.cpp"
    ;
    return $13; //@line 1258 "readclause.cpp"
    return null;
  }
  

  function __ZL17ProcessParamStackPcRi($outbuf, $outix) {
    var __stackBase__  = STACKTOP; STACKTOP += 80; _memset(__stackBase__, 0, 80);
    var __label__;
  
    var $outbuf_addr;
    var $outix_addr;
    var $param;
    var $ix;
    var $value;
    var $buf=__stackBase__;
    var $new_parameters=__stackBase__+20;
    $outbuf_addr=$outbuf;
    $outix_addr=$outix;
    $param=0; //@line 1109 "readclause.cpp"
    ; //@line 1109 "readclause.cpp"
    $for_body$2: while(1) { 
  
      var $0=$param; //@line 1110 "readclause.cpp"
      var $arrayidx=(($new_parameters+$0*4)&4294967295); //@line 1110 "readclause.cpp"
      HEAP32[(($arrayidx)>>2)]=-1; //@line 1110 "readclause.cpp"
      var $1=$param; //@line 1109 "readclause.cpp"
      var $inc=((($1)+1)&4294967295); //@line 1109 "readclause.cpp"
      $param=$inc; //@line 1109 "readclause.cpp"
      var $cmp=((($inc))|0) < 15; //@line 1109 "readclause.cpp"
      if ($cmp) { __label__ = 1;continue $for_body$2; } else { __label__ = 2;break $for_body$2; } //@line 1109 "readclause.cpp"
    }
  
    $ix=0; //@line 1112 "readclause.cpp"
    var $2=$ix; //@line 1112 "readclause.cpp"
    var $3=HEAP32[((__ZL13n_param_stack)>>2)]; //@line 1112 "readclause.cpp"
    var $cmp22=((($2))|0) < ((($3))|0); //@line 1112 "readclause.cpp"
    $param=0; //@line 1114 "readclause.cpp"
    if ($cmp22) { __label__ = 4;; } else { __label__ = 3;; } //@line 1112 "readclause.cpp"
    $for_body6$$for_cond20_preheader$5: do { 
      if (__label__ == 4) {
        while(1) { 
  
          var $4=$param; //@line 1116 "readclause.cpp"
          var $5=$ix; //@line 1116 "readclause.cpp"
          var $arrayidx7=((_param_stack+$5*64)&4294967295); //@line 1116 "readclause.cpp"
          var $parameter=(($arrayidx7+4)&4294967295); //@line 1116 "readclause.cpp"
          var $arrayidx8=(($parameter+$4*4)&4294967295); //@line 1116 "readclause.cpp"
          var $6=HEAP32[(($arrayidx8)>>2)]; //@line 1116 "readclause.cpp"
          var $cmp9=((($6))|0) >= 0; //@line 1116 "readclause.cpp"
          if ($cmp9) { __label__ = 5;; } else { __label__ = 6;; } //@line 1116 "readclause.cpp"
          if (__label__ == 5) {
  
            var $7=$param; //@line 1117 "readclause.cpp"
            var $8=$ix; //@line 1117 "readclause.cpp"
            var $arrayidx10=((_param_stack+$8*64)&4294967295); //@line 1117 "readclause.cpp"
            var $parameter11=(($arrayidx10+4)&4294967295); //@line 1117 "readclause.cpp"
            var $arrayidx12=(($parameter11+$7*4)&4294967295); //@line 1117 "readclause.cpp"
            var $9=HEAP32[(($arrayidx12)>>2)]; //@line 1117 "readclause.cpp"
            var $10=$param; //@line 1117 "readclause.cpp"
            var $arrayidx13=(($new_parameters+$10*4)&4294967295); //@line 1117 "readclause.cpp"
            HEAP32[(($arrayidx13)>>2)]=$9; //@line 1117 "readclause.cpp"
            ; //@line 1117 "readclause.cpp"
          }
  
          var $11=$param; //@line 1114 "readclause.cpp"
          var $inc15=((($11)+1)&4294967295); //@line 1114 "readclause.cpp"
          $param=$inc15; //@line 1114 "readclause.cpp"
          var $cmp5=((($inc15))|0) < 15; //@line 1114 "readclause.cpp"
          if ($cmp5) { __label__ = 4;continue ; } //@line 1114 "readclause.cpp"
  
          var $12=$ix; //@line 1112 "readclause.cpp"
          var $inc18=((($12)+1)&4294967295); //@line 1112 "readclause.cpp"
          $ix=$inc18; //@line 1112 "readclause.cpp"
          var $13=$ix; //@line 1112 "readclause.cpp"
          var $14=HEAP32[((__ZL13n_param_stack)>>2)]; //@line 1112 "readclause.cpp"
          var $cmp2=((($13))|0) < ((($14))|0); //@line 1112 "readclause.cpp"
          $param=0; //@line 1114 "readclause.cpp"
          if ($cmp2) { __label__ = 4;continue ; } else { __label__ = 3;break $for_body6$$for_cond20_preheader$5; } //@line 1112 "readclause.cpp"
        }
      }
    } while(0);
  
    var $arrayidx27=(($buf)&4294967295); //@line 1125 "readclause.cpp"
    var $arraydecay34=(($buf)&4294967295); //@line 1147 "readclause.cpp"
    var $arraydecay36=(($buf)&4294967295); //@line 1148 "readclause.cpp"
    var $arraydecay=(($buf)&4294967295); //@line 1142 "readclause.cpp"
    ; //@line 1121 "readclause.cpp"
    while(1) { 
  
      var $15=$param; //@line 1123 "readclause.cpp"
      var $arrayidx23=(($new_parameters+$15*4)&4294967295); //@line 1123 "readclause.cpp"
      var $16=HEAP32[(($arrayidx23)>>2)]; //@line 1123 "readclause.cpp"
      $value=$16; //@line 1123 "readclause.cpp"
      var $17=$param; //@line 1123 "readclause.cpp"
      var $arrayidx24=((__ZL17speech_parameters+$17*4)&4294967295); //@line 1123 "readclause.cpp"
      var $18=HEAP32[(($arrayidx24)>>2)]; //@line 1123 "readclause.cpp"
      var $cmp25=((($16))|0)!=((($18))|0); //@line 1123 "readclause.cpp"
      if ($cmp25) { __label__ = 9;; } else { __label__ = 14;; } //@line 1123 "readclause.cpp"
      if (__label__ == 9) {
  
        HEAP8[($arrayidx27)]=0; //@line 1125 "readclause.cpp"
        var $19=$param; //@line 1127 "readclause.cpp"
        if ($19 == 5) {
          __label__ = 10;;
        }
        else if ($19 == 6) {
          __label__ = 11;;
        }
        else if ($19 == 1) {
          __label__ = 12;;
        }
        else if ($19 == 2) {
          __label__ = 12;;
        }
        else if ($19 == 3) {
          __label__ = 12;;
        }
        else if ($19 == 4) {
          __label__ = 12;;
        }
        else if ($19 == 12) {
          __label__ = 12;;
        }
        else {
        __label__ = 13;;
        }
        
        if (__label__ == 10) {
  
          var $20=$value; //@line 1130 "readclause.cpp"
          var $sub=((($20)-1)&4294967295); //@line 1130 "readclause.cpp"
          HEAP32[((_option_punctuation)>>2)]=$sub; //@line 1130 "readclause.cpp"
          ; //@line 1131 "readclause.cpp"
        }
        else if (__label__ == 11) {
  
          var $21=$value; //@line 1134 "readclause.cpp"
          HEAP32[((_option_capitals)>>2)]=$21; //@line 1134 "readclause.cpp"
          ; //@line 1135 "readclause.cpp"
        }
        else if (__label__ == 12) {
  
          var $22=$value; //@line 1142 "readclause.cpp"
          var $23=$param; //@line 1142 "readclause.cpp"
          var $arrayidx30=((__ZZL17ProcessParamStackPcRiE10cmd_letter+$23)&4294967295); //@line 1142 "readclause.cpp"
          var $24=HEAP8[($arrayidx30)]; //@line 1142 "readclause.cpp"
          var $conv=(tempInt=(($24)),(tempInt>=128?tempInt-256:tempInt)); //@line 1142 "readclause.cpp"
          var $call=_sprintf($arraydecay, ((__str128)&4294967295), allocate([1,0,0,0,$22,0,0,0,$conv,0,0,0], ["i32",0,0,0,"i32",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 1142 "readclause.cpp"
          ; //@line 1143 "readclause.cpp"
        }
  
        var $25=$param; //@line 1146 "readclause.cpp"
        var $arrayidx31=(($new_parameters+$25*4)&4294967295); //@line 1146 "readclause.cpp"
        var $26=HEAP32[(($arrayidx31)>>2)]; //@line 1146 "readclause.cpp"
        var $27=$param; //@line 1146 "readclause.cpp"
        var $arrayidx32=((__ZL17speech_parameters+$27*4)&4294967295); //@line 1146 "readclause.cpp"
        HEAP32[(($arrayidx32)>>2)]=$26; //@line 1146 "readclause.cpp"
        var $28=$outix_addr; //@line 1147 "readclause.cpp"
        var $29=HEAP32[(($28)>>2)]; //@line 1147 "readclause.cpp"
        var $30=$outbuf_addr; //@line 1147 "readclause.cpp"
        var $arrayidx33=(($30+$29)&4294967295); //@line 1147 "readclause.cpp"
        var $call35=_strcpy($arrayidx33, $arraydecay34); //@line 1147 "readclause.cpp"
        var $call37=_strlen($arraydecay36); //@line 1148 "readclause.cpp"
        var $31=$outix_addr; //@line 1148 "readclause.cpp"
        var $32=HEAP32[(($31)>>2)]; //@line 1148 "readclause.cpp"
        var $add=((($32)+($call37))&4294967295); //@line 1148 "readclause.cpp"
        HEAP32[(($31)>>2)]=$add; //@line 1148 "readclause.cpp"
        ; //@line 1149 "readclause.cpp"
      }
  
      var $33=$param; //@line 1121 "readclause.cpp"
      var $inc40=((($33)+1)&4294967295); //@line 1121 "readclause.cpp"
      $param=$inc40; //@line 1121 "readclause.cpp"
      var $cmp21=((($inc40))|0) < 15; //@line 1121 "readclause.cpp"
      if ($cmp21) { __label__ = 8;continue ; } else { __label__ = 15;break ; } //@line 1121 "readclause.cpp"
    }
  
    STACKTOP = __stackBase__;
    return; //@line 1151 "readclause.cpp"
    return;
  }
  

  function __ZL19SetProsodyParameteriPwP11PARAM_STACK($param_type, $attr1, $sp) {
    var __stackBase__  = STACKTOP; STACKTOP += 4; _memset(__stackBase__, 0, 4);
    var __label__;
  
    var $param_type_addr;
    var $attr1_addr;
    var $sp_addr;
    var $value=__stackBase__;
    var $sign;
    $param_type_addr=$param_type;
    $attr1_addr=$attr1;
    $sp_addr=$sp;
    var $0=$attr1_addr; //@line 1538 "readclause.cpp"
    var $1=$param_type_addr; //@line 1538 "readclause.cpp"
    var $arrayidx=((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE9mnem_tabs+$1*4)&4294967295); //@line 1538 "readclause.cpp"
    var $2=HEAP32[(($arrayidx)>>2)]; //@line 1538 "readclause.cpp"
    var $call=__ZL10attrlookupPKwPK8MNEM_TAB($0, $2); //@line 1538 "readclause.cpp"
    HEAP32[(($value)>>2)]=$call; //@line 1538 "readclause.cpp"
    var $cmp=((($call))|0) >= 0; //@line 1538 "readclause.cpp"
    var $3=$param_type_addr; //@line 1541 "readclause.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 1538 "readclause.cpp"
    if (__label__ == 1) {
  
      var $arrayidx1=((((_param_stack+4)&4294967295)+$3*4)&4294967295); //@line 1541 "readclause.cpp"
      var $4=HEAP32[(($arrayidx1)>>2)]; //@line 1541 "readclause.cpp"
      var $5=HEAP32[(($value)>>2)]; //@line 1541 "readclause.cpp"
      var $mul=((($5)*($4))&4294967295); //@line 1541 "readclause.cpp"
      var $div=((((($mul))|0)/100)|0); //@line 1541 "readclause.cpp"
      var $6=$param_type_addr; //@line 1541 "readclause.cpp"
      var $7=$sp_addr; //@line 1541 "readclause.cpp"
      var $parameter=(($7+4)&4294967295); //@line 1541 "readclause.cpp"
      var $arrayidx2=(($parameter+$6*4)&4294967295); //@line 1541 "readclause.cpp"
      HEAP32[(($arrayidx2)>>2)]=$div; //@line 1541 "readclause.cpp"
      ; //@line 1542 "readclause.cpp"
    }
    else if (__label__ == 2) {
  
      var $8=$attr1_addr; //@line 1545 "readclause.cpp"
      var $call3=__ZL18attr_prosody_valueiPKwPi($3, $8, $value); //@line 1545 "readclause.cpp"
      $sign=$call3; //@line 1545 "readclause.cpp"
      var $9=$sign; //@line 1547 "readclause.cpp"
      var $cmp4=((($9))|0)==0; //@line 1547 "readclause.cpp"
      if ($cmp4) { __label__ = 3;; } else { __label__ = 4;; } //@line 1547 "readclause.cpp"
      if (__label__ == 3) {
  
        var $10=HEAP32[(($value)>>2)]; //@line 1548 "readclause.cpp"
        var $11=$param_type_addr; //@line 1548 "readclause.cpp"
        var $12=$sp_addr; //@line 1548 "readclause.cpp"
        var $parameter6=(($12+4)&4294967295); //@line 1548 "readclause.cpp"
        var $arrayidx7=(($parameter6+$11*4)&4294967295); //@line 1548 "readclause.cpp"
        HEAP32[(($arrayidx7)>>2)]=$10; //@line 1548 "readclause.cpp"
        ; //@line 1548 "readclause.cpp"
      }
      else if (__label__ == 4) {
  
        var $13=$sign; //@line 1550 "readclause.cpp"
        var $cmp9=((($13))|0)==2; //@line 1550 "readclause.cpp"
        var $14=$param_type_addr; //@line 1553 "readclause.cpp"
        var $arrayidx11=((__ZL17speech_parameters+$14*4)&4294967295); //@line 1553 "readclause.cpp"
        var $15=HEAP32[(($arrayidx11)>>2)]; //@line 1553 "readclause.cpp"
        var $16=HEAP32[(($value)>>2)]; //@line 1553 "readclause.cpp"
        if ($cmp9) { __label__ = 5;; } else { __label__ = 6;; } //@line 1550 "readclause.cpp"
        if (__label__ == 5) {
  
          var $mul12=((($16)*($15))&4294967295); //@line 1553 "readclause.cpp"
          var $div13=((((($mul12))|0)/100)|0); //@line 1553 "readclause.cpp"
          var $17=$param_type_addr; //@line 1553 "readclause.cpp"
          var $18=$sp_addr; //@line 1553 "readclause.cpp"
          var $parameter14=(($18+4)&4294967295); //@line 1553 "readclause.cpp"
          var $arrayidx15=(($parameter14+$17*4)&4294967295); //@line 1553 "readclause.cpp"
          HEAP32[(($arrayidx15)>>2)]=$div13; //@line 1553 "readclause.cpp"
          ; //@line 1554 "readclause.cpp"
        }
        else if (__label__ == 6) {
  
          var $19=$sign; //@line 1558 "readclause.cpp"
          var $mul18=((($19)*($16))&4294967295); //@line 1558 "readclause.cpp"
          var $add=((($mul18)+($15))&4294967295); //@line 1558 "readclause.cpp"
          var $20=$param_type_addr; //@line 1558 "readclause.cpp"
          var $21=$sp_addr; //@line 1558 "readclause.cpp"
          var $parameter19=(($21+4)&4294967295); //@line 1558 "readclause.cpp"
          var $arrayidx20=(($parameter19+$20*4)&4294967295); //@line 1558 "readclause.cpp"
          HEAP32[(($arrayidx20)>>2)]=$add; //@line 1558 "readclause.cpp"
          ;
        }
      }
    }
  
    STACKTOP = __stackBase__;
    return; //@line 1561 "readclause.cpp"
    return;
  }
  

  function __ZL13PopParamStackiPcRi($tag_type, $outbuf, $outix) {
    ;
    var __label__;
  
    var $tag_type_addr;
    var $outbuf_addr;
    var $outix_addr;
    var $ix;
    var $top;
    $tag_type_addr=$tag_type;
    $outbuf_addr=$outbuf;
    $outix_addr=$outix;
    $top=0; //@line 1176 "readclause.cpp"
    var $0=$tag_type_addr; //@line 1178 "readclause.cpp"
    var $cmp=((($0))|0) >= 32; //@line 1178 "readclause.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 1178 "readclause.cpp"
    if (__label__ == 1) {
  
      var $1=$tag_type_addr; //@line 1179 "readclause.cpp"
      var $sub=((($1)-32)&4294967295); //@line 1179 "readclause.cpp"
      $tag_type_addr=$sub; //@line 1179 "readclause.cpp"
      ; //@line 1179 "readclause.cpp"
    }
  
    $ix=0; //@line 1181 "readclause.cpp"
    var $2=$ix; //@line 1181 "readclause.cpp"
    var $3=HEAP32[((__ZL13n_param_stack)>>2)]; //@line 1181 "readclause.cpp"
    var $cmp11=((($2))|0) < ((($3))|0); //@line 1181 "readclause.cpp"
    if ($cmp11) { __label__ = 3;; } else { __label__ = 6;; } //@line 1181 "readclause.cpp"
    $for_body$$for_end$5: do { 
      if (__label__ == 3) {
        while(1) { 
  
          var $4=$ix; //@line 1183 "readclause.cpp"
          var $arrayidx=((_param_stack+$4*64)&4294967295); //@line 1183 "readclause.cpp"
          var $type=(($arrayidx)&4294967295); //@line 1183 "readclause.cpp"
          var $5=HEAP32[(($type)>>2)]; //@line 1183 "readclause.cpp"
          var $6=$tag_type_addr; //@line 1183 "readclause.cpp"
          var $cmp2=((($5))|0)==((($6))|0); //@line 1183 "readclause.cpp"
          if ($cmp2) { __label__ = 4;; } else { __label__ = 5;; } //@line 1183 "readclause.cpp"
          if (__label__ == 4) {
  
            var $7=$ix; //@line 1185 "readclause.cpp"
            $top=$7; //@line 1185 "readclause.cpp"
            ; //@line 1186 "readclause.cpp"
          }
  
          var $8=$ix; //@line 1181 "readclause.cpp"
          var $inc=((($8)+1)&4294967295); //@line 1181 "readclause.cpp"
          $ix=$inc; //@line 1181 "readclause.cpp"
          var $9=$ix; //@line 1181 "readclause.cpp"
          var $10=HEAP32[((__ZL13n_param_stack)>>2)]; //@line 1181 "readclause.cpp"
          var $cmp1=((($9))|0) < ((($10))|0); //@line 1181 "readclause.cpp"
          if ($cmp1) { __label__ = 3;continue ; } else { __label__ = 6;break $for_body$$for_end$5; } //@line 1181 "readclause.cpp"
        }
      }
    } while(0);
  
    var $11=$top; //@line 1188 "readclause.cpp"
    var $cmp5=((($11))|0) > 0; //@line 1188 "readclause.cpp"
    if ($cmp5) { __label__ = 7;; } else { __label__ = 8;; } //@line 1188 "readclause.cpp"
    if (__label__ == 7) {
  
      var $12=$top; //@line 1190 "readclause.cpp"
      HEAP32[((__ZL13n_param_stack)>>2)]=$12; //@line 1190 "readclause.cpp"
      ; //@line 1191 "readclause.cpp"
    }
  
    var $13=$outbuf_addr; //@line 1192 "readclause.cpp"
    var $14=$outix_addr; //@line 1192 "readclause.cpp"
    __ZL17ProcessParamStackPcRi($13, $14); //@line 1192 "readclause.cpp"
    ;
    return; //@line 1193 "readclause.cpp"
    return;
  }
  

  function __ZL10attrnumberPKwii($pw, $default_value, $type) {
    ;
    var __label__;
  
    var $retval;
    var $pw_addr;
    var $default_value_addr;
    var $type_addr;
    var $value;
    $pw_addr=$pw;
    $default_value_addr=$default_value;
    $type_addr=$type;
    $value=0; //@line 1263 "readclause.cpp"
    var $0=$pw_addr; //@line 1265 "readclause.cpp"
    var $cmp=((($0))|0)==0; //@line 1265 "readclause.cpp"
    if ($cmp) { __label__ = 3;; } else { __label__ = 1;; } //@line 1265 "readclause.cpp"
    $if_then$$lor_lhs_false$2: do { 
      if (__label__ == 1) {
  
        var $1=$pw_addr; //@line 1265 "readclause.cpp"
        var $2=HEAP32[(($1)>>2)]; //@line 1265 "readclause.cpp"
        var $isdigittmp=((($2)-48)&4294967295); //@line 1265 "readclause.cpp"
        var $isdigit=((($isdigittmp))>>>0) < 10; //@line 1265 "readclause.cpp"
        var $call=((($isdigit))&1); //@line 1265 "readclause.cpp"
        var $tobool=((($call))|0)!=0; //@line 1265 "readclause.cpp"
        if (!($tobool)) { __label__ = 3;break $if_then$$lor_lhs_false$2; } //@line 1265 "readclause.cpp"
  
        var $3=$pw_addr; //@line 1268 "readclause.cpp"
        var $4=HEAP32[(($3)>>2)]; //@line 1268 "readclause.cpp"
        var $isdigittmp13=((($4)-48)&4294967295); //@line 1268 "readclause.cpp"
        var $isdigit24=((($isdigittmp13))>>>0) < 10; //@line 1268 "readclause.cpp"
        if ($isdigit24) { __label__ = 4;; } else { __label__ = 5;; } //@line 1268 "readclause.cpp"
        $while_body$$while_end$5: do { 
          if (__label__ == 4) {
            while(1) { 
  
              var $6=$value; //@line 1270 "readclause.cpp"
              var $mul=((($6)*10)&4294967295); //@line 1270 "readclause.cpp"
              var $7=$pw_addr; //@line 1270 "readclause.cpp"
              var $incdec_ptr=(($7+4)&4294967295); //@line 1270 "readclause.cpp"
              $pw_addr=$incdec_ptr; //@line 1270 "readclause.cpp"
              var $8=HEAP32[(($7)>>2)]; //@line 1270 "readclause.cpp"
              var $add=((($mul)-48)&4294967295); //@line 1270 "readclause.cpp"
              var $sub=((($add)+($8))&4294967295); //@line 1270 "readclause.cpp"
              $value=$sub; //@line 1270 "readclause.cpp"
              var $9=$pw_addr; //@line 1268 "readclause.cpp"
              var $10=HEAP32[(($9)>>2)]; //@line 1268 "readclause.cpp"
              var $isdigittmp1=((($10)-48)&4294967295); //@line 1268 "readclause.cpp"
              var $isdigit2=((($isdigittmp1))>>>0) < 10; //@line 1268 "readclause.cpp"
              var $call1=((($isdigit2))&1); //@line 1268 "readclause.cpp"
              var $tobool2=((($call1))|0)!=0; //@line 1268 "readclause.cpp"
              if ($tobool2) { __label__ = 4;continue ; } else { __label__ = 5;break $while_body$$while_end$5; } //@line 1268 "readclause.cpp"
            }
          }
        } while(0);
  
        var $11=$type_addr; //@line 1272 "readclause.cpp"
        var $cmp3=((($11))|0)==1; //@line 1272 "readclause.cpp"
        if ($cmp3) { __label__ = 6;; } else { __label__ = 8;; } //@line 1272 "readclause.cpp"
        $land_lhs_true$$if_end8$9: do { 
          if (__label__ == 6) {
  
            var $12=$pw_addr; //@line 1272 "readclause.cpp"
            var $13=HEAP32[(($12)>>2)]; //@line 1272 "readclause.cpp"
            var $call4=_towlower($13); //@line 1272 "readclause.cpp"
            var $cmp5=((($call4))|0)==115; //@line 1272 "readclause.cpp"
            if (!($cmp5)) { __label__ = 8;break $land_lhs_true$$if_end8$9; } //@line 1272 "readclause.cpp"
  
            var $14=$value; //@line 1275 "readclause.cpp"
            var $mul7=((($14)*1000)&4294967295); //@line 1275 "readclause.cpp"
            $value=$mul7; //@line 1275 "readclause.cpp"
            ; //@line 1276 "readclause.cpp"
          }
        } while(0);
  
        var $15=$value; //@line 1277 "readclause.cpp"
        $retval=$15; //@line 1277 "readclause.cpp"
        __label__ = 9;break $if_then$$lor_lhs_false$2; //@line 1277 "readclause.cpp"
      }
    } while(0);
    if (__label__ == 3) {
  
      var $5=$default_value_addr; //@line 1266 "readclause.cpp"
      $retval=$5; //@line 1266 "readclause.cpp"
      ; //@line 1266 "readclause.cpp"
    }
  
    var $16=$retval; //@line 1278 "readclause.cpp"
    ;
    return $16; //@line 1278 "readclause.cpp"
    return null;
  }
  

  function __ZL14ReplaceKeyNamePciRi($outbuf, $index, $outix) {
    var __stackBase__  = STACKTOP; STACKTOP += 40; _memset(__stackBase__, 0, 40);
    var __label__;
  
    var $retval;
    var $outbuf_addr;
    var $index_addr;
    var $outix_addr;
    var $keynames=__stackBase__;
    var $ix;
    var $letter;
    var $p;
    $outbuf_addr=$outbuf;
    $index_addr=$index;
    $outix_addr=$outix;
    var $0=$keynames; //@line 1572 "readclause.cpp"
    var $src$, $dest$, $stop$, $stop4$, $fast$;
    $src$ = __ZZL14ReplaceKeyNamePciRiE8keynames;
    $dest$ = $0;
    $stop$ = $src$ + 40;
    if (($dest$%4) == ($src$%4) && 40 > 8) {
      while ($src$%4 !== 0 && $src$ < $stop$) {
        ; HEAP8[$dest$++] = HEAP8[$src$++];
      }
      $src$ >>= 2;
      $dest$ >>= 2;
      $stop4$ = $stop$ >> 2;
      while ($src$ < $stop4$) {
    ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
      }
      $src$ <<= 2;
      $dest$ <<= 2;
    }while ($src$ < $stop$) {
      ; HEAP8[$dest$++] = HEAP8[$src$++];
    }; //@line 1572 "readclause.cpp"
    var $1=$index_addr; //@line 1578 "readclause.cpp"
    var $2=$outbuf_addr; //@line 1578 "readclause.cpp"
    var $arrayidx=(($2+$1)&4294967295); //@line 1578 "readclause.cpp"
    $p=$arrayidx; //@line 1578 "readclause.cpp"
    var $arraydecay=(($keynames)&4294967295); //@line 1580 "readclause.cpp"
    var $3=$p; //@line 1580 "readclause.cpp"
    var $call=__Z10LookupMnemP8MNEM_TABPKc($arraydecay, $3); //@line 1580 "readclause.cpp"
    $letter=$call; //@line 1580 "readclause.cpp"
    var $cmp=((($call))|0)!=0; //@line 1580 "readclause.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 1580 "readclause.cpp"
    if (__label__ == 1) {
  
      var $4=$letter; //@line 1582 "readclause.cpp"
      var $5=$p; //@line 1582 "readclause.cpp"
      var $call1=__Z8utf8_outjPc($4, $5); //@line 1582 "readclause.cpp"
      $ix=$call1; //@line 1582 "readclause.cpp"
      var $6=$index_addr; //@line 1583 "readclause.cpp"
      var $7=$ix; //@line 1583 "readclause.cpp"
      var $add=((($7)+($6))&4294967295); //@line 1583 "readclause.cpp"
      var $8=$outix_addr; //@line 1583 "readclause.cpp"
      HEAP32[(($8)>>2)]=$add; //@line 1583 "readclause.cpp"
      var $9=$letter; //@line 1584 "readclause.cpp"
      $retval=$9; //@line 1584 "readclause.cpp"
      ; //@line 1584 "readclause.cpp"
    }
    else if (__label__ == 2) {
  
      $retval=0; //@line 1586 "readclause.cpp"
      ; //@line 1586 "readclause.cpp"
    }
  
    STACKTOP = __stackBase__;
    return;
    return;
  }
  

  function __ZL13attrcopy_utf8PcPKwi($buf, $pw, $len) {
    ;
    var __label__;
  
    var $buf_addr;
    var $pw_addr;
    var $len_addr;
    var $c;
    var $ix;
    var $n;
    var $prev_c;
    $buf_addr=$buf;
    $pw_addr=$pw;
    $len_addr=$len;
    $ix=0; //@line 1286 "readclause.cpp"
    $prev_c=0; //@line 1288 "readclause.cpp"
    var $0=$pw_addr; //@line 1290 "readclause.cpp"
    var $cmp=((($0))|0)!=0; //@line 1290 "readclause.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 6;; } //@line 1290 "readclause.cpp"
    $while_cond$$if_end6$2: do { 
      if (__label__ == 1) {
        while(1) { 
  
          var $1=$ix; //@line 1292 "readclause.cpp"
          var $2=$len_addr; //@line 1292 "readclause.cpp"
          var $sub=((($2)-4)&4294967295); //@line 1292 "readclause.cpp"
          var $cmp1=((($1))|0) < ((($sub))|0); //@line 1292 "readclause.cpp"
          if (!($cmp1)) { __label__ = 6;break $while_cond$$if_end6$2; } //@line 1292 "readclause.cpp"
  
          var $3=$pw_addr; //@line 1292 "readclause.cpp"
          var $incdec_ptr=(($3+4)&4294967295); //@line 1292 "readclause.cpp"
          $pw_addr=$incdec_ptr; //@line 1292 "readclause.cpp"
          var $4=HEAP32[(($3)>>2)]; //@line 1292 "readclause.cpp"
          $c=$4; //@line 1292 "readclause.cpp"
          var $cmp2=((($4))|0)!=0; //@line 1292 "readclause.cpp"
          if (!($cmp2)) { __label__ = 6;break $while_cond$$if_end6$2; }
  
          var $5=$c; //@line 1294 "readclause.cpp"
          var $cmp3=((($5))|0)==34; //@line 1294 "readclause.cpp"
          if ($cmp3) { __label__ = 4;; } else { __label__ = 5;; } //@line 1294 "readclause.cpp"
          if (__label__ == 4) {
  
            var $6=$prev_c; //@line 1294 "readclause.cpp"
            var $cmp4=((($6))|0)!=92; //@line 1294 "readclause.cpp"
            if ($cmp4) { __label__ = 6;break $while_cond$$if_end6$2; } //@line 1294 "readclause.cpp"
          }
  
          var $7=$c; //@line 1296 "readclause.cpp"
          var $8=$ix; //@line 1296 "readclause.cpp"
          var $9=$buf_addr; //@line 1296 "readclause.cpp"
          var $arrayidx=(($9+$8)&4294967295); //@line 1296 "readclause.cpp"
          var $call=__Z8utf8_outjPc($7, $arrayidx); //@line 1296 "readclause.cpp"
          $n=$call; //@line 1296 "readclause.cpp"
          var $10=$n; //@line 1297 "readclause.cpp"
          var $11=$ix; //@line 1297 "readclause.cpp"
          var $add=((($11)+($10))&4294967295); //@line 1297 "readclause.cpp"
          $ix=$add; //@line 1297 "readclause.cpp"
          var $12=$c; //@line 1298 "readclause.cpp"
          $prev_c=$12; //@line 1298 "readclause.cpp"
          __label__ = 1;continue ; //@line 1299 "readclause.cpp"
        }
      }
    } while(0);
  
    var $13=$ix; //@line 1301 "readclause.cpp"
    var $14=$buf_addr; //@line 1301 "readclause.cpp"
    var $arrayidx7=(($14+$13)&4294967295); //@line 1301 "readclause.cpp"
    HEAP8[($arrayidx7)]=0; //@line 1301 "readclause.cpp"
    var $15=$ix; //@line 1302 "readclause.cpp"
    ;
    return $15; //@line 1302 "readclause.cpp"
    return null;
  }
  

  function __ZL14LoadSoundFile2PKc($fname) {
    ;
    var __label__;
  
    var $retval;
    var $fname_addr;
    var $ix;
    $fname_addr=$fname;
    $ix=0; //@line 834 "readclause.cpp"
    ; //@line 834 "readclause.cpp"
    while(1) { 
  
      var $0=$ix; //@line 834 "readclause.cpp"
      var $1=HEAP32[((_n_soundicon_tab)>>2)]; //@line 834 "readclause.cpp"
      var $cmp=((($0))|0) < ((($1))|0); //@line 834 "readclause.cpp"
      if (!($cmp)) { __label__ = 6;break ; } //@line 834 "readclause.cpp"
  
      var $2=$ix; //@line 836 "readclause.cpp"
      var $arrayidx=((_soundicon_tab+$2*16)&4294967295); //@line 836 "readclause.cpp"
      var $filename=(($arrayidx+12)&4294967295); //@line 836 "readclause.cpp"
      var $3=HEAP32[(($filename)>>2)]; //@line 836 "readclause.cpp"
      var $cmp1=((($3))|0)!=0; //@line 836 "readclause.cpp"
      if ($cmp1) { __label__ = 3;; } else { __label__ = 5;; } //@line 836 "readclause.cpp"
      if (__label__ == 3) {
  
        var $4=$fname_addr; //@line 836 "readclause.cpp"
        var $5=$ix; //@line 836 "readclause.cpp"
        var $arrayidx2=((_soundicon_tab+$5*16)&4294967295); //@line 836 "readclause.cpp"
        var $filename3=(($arrayidx2+12)&4294967295); //@line 836 "readclause.cpp"
        var $6=HEAP32[(($filename3)>>2)]; //@line 836 "readclause.cpp"
        var $call=_strcmp($4, $6); //@line 836 "readclause.cpp"
        var $cmp4=((($call))|0)==0; //@line 836 "readclause.cpp"
        if ($cmp4) { __label__ = 4;break ; } //@line 836 "readclause.cpp"
      }
  
      var $8=$ix; //@line 834 "readclause.cpp"
      var $inc=((($8)+1)&4294967295); //@line 834 "readclause.cpp"
      $ix=$inc; //@line 834 "readclause.cpp"
      __label__ = 1;continue ; //@line 834 "readclause.cpp"
    }
    if (__label__ == 6) {
  
      var $9=HEAP32[((__ZZL14LoadSoundFile2PKcE4slot)>>2)]; //@line 841 "readclause.cpp"
      var $inc5=((($9)+1)&4294967295); //@line 841 "readclause.cpp"
      HEAP32[((__ZZL14LoadSoundFile2PKcE4slot)>>2)]=$inc5; //@line 841 "readclause.cpp"
      var $10=HEAP32[((__ZZL14LoadSoundFile2PKcE4slot)>>2)]; //@line 842 "readclause.cpp"
      var $cmp6=((($10))|0) >= 4; //@line 842 "readclause.cpp"
      if ($cmp6) { __label__ = 7;; } else { __label__ = 8;; } //@line 842 "readclause.cpp"
      if (__label__ == 7) {
  
        HEAP32[((__ZZL14LoadSoundFile2PKcE4slot)>>2)]=0; //@line 843 "readclause.cpp"
        ; //@line 843 "readclause.cpp"
      }
  
      var $11=$fname_addr; //@line 845 "readclause.cpp"
      var $12=HEAP32[((__ZZL14LoadSoundFile2PKcE4slot)>>2)]; //@line 845 "readclause.cpp"
      var $call9=__ZL13LoadSoundFilePKci($11, $12); //@line 845 "readclause.cpp"
      var $cmp10=((($call9))|0)!=0; //@line 845 "readclause.cpp"
      if ($cmp10) { __label__ = 9;; } else { __label__ = 10;; } //@line 845 "readclause.cpp"
      if (__label__ == 9) {
  
        $retval=-1; //@line 846 "readclause.cpp"
        ; //@line 846 "readclause.cpp"
      }
      else if (__label__ == 10) {
  
        var $13=$ix; //@line 848 "readclause.cpp"
        var $arrayidx13=((_soundicon_tab+$13*16)&4294967295); //@line 848 "readclause.cpp"
        var $filename14=(($arrayidx13+12)&4294967295); //@line 848 "readclause.cpp"
        var $14=HEAP32[(($filename14)>>2)]; //@line 848 "readclause.cpp"
        var $15=$fname_addr; //@line 848 "readclause.cpp"
        var $call15=_strlen($15); //@line 848 "readclause.cpp"
        var $add=((($call15)+1)&4294967295); //@line 848 "readclause.cpp"
        var $call16=_realloc($14, $add); //@line 848 "readclause.cpp"
        var $16=HEAP32[((__ZZL14LoadSoundFile2PKcE4slot)>>2)]; //@line 848 "readclause.cpp"
        var $arrayidx17=((_soundicon_tab+$16*16)&4294967295); //@line 848 "readclause.cpp"
        var $filename18=(($arrayidx17+12)&4294967295); //@line 848 "readclause.cpp"
        HEAP32[(($filename18)>>2)]=$call16; //@line 848 "readclause.cpp"
        var $17=HEAP32[((__ZZL14LoadSoundFile2PKcE4slot)>>2)]; //@line 849 "readclause.cpp"
        var $arrayidx19=((_soundicon_tab+$17*16)&4294967295); //@line 849 "readclause.cpp"
        var $filename20=(($arrayidx19+12)&4294967295); //@line 849 "readclause.cpp"
        var $18=HEAP32[(($filename20)>>2)]; //@line 849 "readclause.cpp"
        var $19=$fname_addr; //@line 849 "readclause.cpp"
        var $call21=_strcpy($18, $19); //@line 849 "readclause.cpp"
        var $20=HEAP32[((__ZZL14LoadSoundFile2PKcE4slot)>>2)]; //@line 850 "readclause.cpp"
        $retval=$20; //@line 850 "readclause.cpp"
        ; //@line 850 "readclause.cpp"
      }
    }
    else if (__label__ == 4) {
  
      var $7=$ix; //@line 837 "readclause.cpp"
      $retval=$7; //@line 837 "readclause.cpp"
      ; //@line 837 "readclause.cpp"
    }
  
    var $21=$retval; //@line 851 "readclause.cpp"
    ;
    return $21; //@line 851 "readclause.cpp"
    return null;
  }
  

  function __ZL18GetVoiceAttributesPwi($pw, $tag_type) {
    ;
    var __label__;
  
    var $retval;
    var $pw_addr;
    var $tag_type_addr;
    var $lang;
    var $gender;
    var $name;
    var $age;
    var $variant;
    var $new_voice_id;
    var $ssml_sp;
    $pw_addr=$pw;
    $tag_type_addr=$tag_type;
    var $0=$tag_type_addr; //@line 1438 "readclause.cpp"
    var $and=($0) & 32; //@line 1438 "readclause.cpp"
    var $tobool=((($and))|0)!=0; //@line 1438 "readclause.cpp"
    if ($tobool) { __label__ = 1;; } else { __label__ = 3;; } //@line 1438 "readclause.cpp"
    $if_then$$if_else$2: do { 
      if (__label__ == 1) {
  
        var $1=HEAP32[((__ZL12n_ssml_stack)>>2)]; //@line 1441 "readclause.cpp"
        var $cmp=((($1))|0) > 1; //@line 1441 "readclause.cpp"
        if (!($cmp)) { __label__ = 10;break $if_then$$if_else$2; } //@line 1441 "readclause.cpp"
  
        var $2=HEAP32[((__ZL12n_ssml_stack)>>2)]; //@line 1443 "readclause.cpp"
        var $dec=((($2)-1)&4294967295); //@line 1443 "readclause.cpp"
        HEAP32[((__ZL12n_ssml_stack)>>2)]=$dec; //@line 1443 "readclause.cpp"
        __label__ = 10;break $if_then$$if_else$2; //@line 1444 "readclause.cpp"
      }
      else if (__label__ == 3) {
  
        var $3=$pw_addr; //@line 1449 "readclause.cpp"
        var $call=__ZL16GetSsmlAttributePwPKc($3, ((__str106273)&4294967295)); //@line 1449 "readclause.cpp"
        $lang=$call; //@line 1449 "readclause.cpp"
        var $4=$tag_type_addr; //@line 1451 "readclause.cpp"
        var $cmp2=((($4))|0)!=2; //@line 1451 "readclause.cpp"
        if ($cmp2) { __label__ = 4;; } else { __label__ = 5;; } //@line 1451 "readclause.cpp"
        if (__label__ == 4) {
  
          $name=0; //@line 1454 "readclause.cpp"
          $variant=0; //@line 1455 "readclause.cpp"
          $age=0; //@line 1456 "readclause.cpp"
          $gender=0; //@line 1457 "readclause.cpp"
          ; //@line 1458 "readclause.cpp"
        }
        else if (__label__ == 5) {
  
          var $5=$pw_addr; //@line 1461 "readclause.cpp"
          var $call5=__ZL16GetSsmlAttributePwPKc($5, ((__str5655)&4294967295)); //@line 1461 "readclause.cpp"
          $name=$call5; //@line 1461 "readclause.cpp"
          var $6=$pw_addr; //@line 1462 "readclause.cpp"
          var $call6=__ZL16GetSsmlAttributePwPKc($6, ((__str55707)&4294967295)); //@line 1462 "readclause.cpp"
          $variant=$call6; //@line 1462 "readclause.cpp"
          var $7=$pw_addr; //@line 1463 "readclause.cpp"
          var $call7=__ZL16GetSsmlAttributePwPKc($7, ((__str108275)&4294967295)); //@line 1463 "readclause.cpp"
          $age=$call7; //@line 1463 "readclause.cpp"
          var $8=$pw_addr; //@line 1464 "readclause.cpp"
          var $call8=__ZL16GetSsmlAttributePwPKc($8, ((__str7657)&4294967295)); //@line 1464 "readclause.cpp"
          $gender=$call8; //@line 1464 "readclause.cpp"
          ;
        }
  
        var $9=$tag_type_addr; //@line 1467 "readclause.cpp"
        var $cmp10=((($9))|0)!=2; //@line 1467 "readclause.cpp"
        if ($cmp10) { __label__ = 7;; } else { __label__ = 9;; } //@line 1467 "readclause.cpp"
        $land_lhs_true$$if_end13$10: do { 
          if (__label__ == 7) {
  
            var $10=$lang; //@line 1467 "readclause.cpp"
            var $cmp11=((($10))|0)==0; //@line 1467 "readclause.cpp"
            if (!($cmp11)) { __label__ = 9;break $land_lhs_true$$if_end13$10; } //@line 1467 "readclause.cpp"
  
            $retval=0; //@line 1468 "readclause.cpp"
            __label__ = 13;break $if_then$$if_else$2; //@line 1468 "readclause.cpp"
          }
        } while(0);
  
        var $11=HEAP32[((__ZL12n_ssml_stack)>>2)]; //@line 1470 "readclause.cpp"
        var $inc=((($11)+1)&4294967295); //@line 1470 "readclause.cpp"
        HEAP32[((__ZL12n_ssml_stack)>>2)]=$inc; //@line 1470 "readclause.cpp"
        var $arrayidx=((__ZL10ssml_stack+$11*76)&4294967295); //@line 1470 "readclause.cpp"
        $ssml_sp=$arrayidx; //@line 1470 "readclause.cpp"
        var $12=$ssml_sp; //@line 1472 "readclause.cpp"
        var $language=(($12+56)&4294967295); //@line 1472 "readclause.cpp"
        var $arraydecay=(($language)&4294967295); //@line 1472 "readclause.cpp"
        var $13=$lang; //@line 1472 "readclause.cpp"
        var $call14=__ZL13attrcopy_utf8PcPKwi($arraydecay, $13, 20); //@line 1472 "readclause.cpp"
        var $14=$ssml_sp; //@line 1473 "readclause.cpp"
        var $voice_name=(($14+16)&4294967295); //@line 1473 "readclause.cpp"
        var $arraydecay15=(($voice_name)&4294967295); //@line 1473 "readclause.cpp"
        var $15=$name; //@line 1473 "readclause.cpp"
        var $call16=__ZL13attrcopy_utf8PcPKwi($arraydecay15, $15, 40); //@line 1473 "readclause.cpp"
        var $16=$variant; //@line 1474 "readclause.cpp"
        var $call17=__ZL10attrnumberPKwii($16, 1, 0); //@line 1474 "readclause.cpp"
        var $sub=((($call17)-1)&4294967295); //@line 1474 "readclause.cpp"
        var $17=$ssml_sp; //@line 1474 "readclause.cpp"
        var $voice_variant=(($17+4)&4294967295); //@line 1474 "readclause.cpp"
        HEAP32[(($voice_variant)>>2)]=$sub; //@line 1474 "readclause.cpp"
        var $18=$age; //@line 1475 "readclause.cpp"
        var $call18=__ZL10attrnumberPKwii($18, 0, 0); //@line 1475 "readclause.cpp"
        var $19=$ssml_sp; //@line 1475 "readclause.cpp"
        var $voice_age=(($19+12)&4294967295); //@line 1475 "readclause.cpp"
        HEAP32[(($voice_age)>>2)]=$call18; //@line 1475 "readclause.cpp"
        var $20=$gender; //@line 1476 "readclause.cpp"
        var $call19=__ZL10attrlookupPKwPK8MNEM_TAB($20, ((__ZZL18GetVoiceAttributesPwiE11mnem_gender)&4294967295)); //@line 1476 "readclause.cpp"
        var $21=$ssml_sp; //@line 1476 "readclause.cpp"
        var $voice_gender=(($21+8)&4294967295); //@line 1476 "readclause.cpp"
        HEAP32[(($voice_gender)>>2)]=$call19; //@line 1476 "readclause.cpp"
        var $22=$tag_type_addr; //@line 1477 "readclause.cpp"
        var $23=$ssml_sp; //@line 1477 "readclause.cpp"
        var $tag_type20=(($23)&4294967295); //@line 1477 "readclause.cpp"
        HEAP32[(($tag_type20)>>2)]=$22; //@line 1477 "readclause.cpp"
        __label__ = 10;break $if_then$$if_else$2;
      }
    } while(0);
    if (__label__ == 10) {
  
      var $call22=__ZL14VoiceFromStackv(); //@line 1480 "readclause.cpp"
      $new_voice_id=$call22; //@line 1480 "readclause.cpp"
      var $24=$new_voice_id; //@line 1481 "readclause.cpp"
      var $call23=_strcmp($24, ((__ZL16current_voice_id)&4294967295)); //@line 1481 "readclause.cpp"
      var $cmp24=((($call23))|0)!=0; //@line 1481 "readclause.cpp"
      if ($cmp24) { __label__ = 11;; } else { __label__ = 12;; } //@line 1481 "readclause.cpp"
      if (__label__ == 11) {
  
        var $25=$new_voice_id; //@line 1484 "readclause.cpp"
        var $call26=_strcpy(((__ZL16current_voice_id)&4294967295), $25); //@line 1484 "readclause.cpp"
        $retval=131072; //@line 1485 "readclause.cpp"
        ; //@line 1485 "readclause.cpp"
      }
      else if (__label__ == 12) {
  
        $retval=0; //@line 1488 "readclause.cpp"
        ; //@line 1488 "readclause.cpp"
      }
    }
  
    var $26=$retval; //@line 1489 "readclause.cpp"
    ;
    return $26; //@line 1489 "readclause.cpp"
    return null;
  }
  

  function __ZL14VoiceFromStackv() {
    var __stackBase__  = STACKTOP; STACKTOP += 108; _memset(__stackBase__, 0, 108);
    var __label__;
  
    var $retval;
    var $ix;
    var $sp;
    var $v_id;
    var $voice_name_specified;
    var $voice_found=__stackBase__;
    var $voice_select=__stackBase__+4;
    var $voice_name=__stackBase__+28;
    var $language=__stackBase__+68;
    var $arraydecay=(($voice_name)&4294967295); //@line 1053 "readclause.cpp"
    var $call=_strcpy($arraydecay, ((__ZL10ssml_stack+16)&4294967295)); //@line 1053 "readclause.cpp"
    var $arraydecay1=(($language)&4294967295); //@line 1054 "readclause.cpp"
    var $call2=_strcpy($arraydecay1, ((__ZL10ssml_stack+56)&4294967295)); //@line 1054 "readclause.cpp"
    var $0=HEAP32[((((__ZL10ssml_stack+12)&4294967295))>>2)]; //@line 1055 "readclause.cpp"
    var $conv=((($0)) & 255); //@line 1055 "readclause.cpp"
    var $age=(($voice_select+13)&4294967295); //@line 1055 "readclause.cpp"
    HEAP8[($age)]=$conv; //@line 1055 "readclause.cpp"
    var $1=HEAP32[((((__ZL10ssml_stack+8)&4294967295))>>2)]; //@line 1056 "readclause.cpp"
    var $conv3=((($1)) & 255); //@line 1056 "readclause.cpp"
    var $gender=(($voice_select+12)&4294967295); //@line 1056 "readclause.cpp"
    HEAP8[($gender)]=$conv3; //@line 1056 "readclause.cpp"
    var $2=HEAP32[((((__ZL10ssml_stack+4)&4294967295))>>2)]; //@line 1057 "readclause.cpp"
    var $conv4=((($2)) & 255); //@line 1057 "readclause.cpp"
    var $variant=(($voice_select+14)&4294967295); //@line 1057 "readclause.cpp"
    HEAP8[($variant)]=$conv4; //@line 1057 "readclause.cpp"
    var $identifier=(($voice_select+8)&4294967295); //@line 1058 "readclause.cpp"
    HEAP32[(($identifier)>>2)]=0; //@line 1058 "readclause.cpp"
    $ix=0; //@line 1060 "readclause.cpp"
    var $3=$ix; //@line 1060 "readclause.cpp"
    var $4=HEAP32[((__ZL12n_ssml_stack)>>2)]; //@line 1060 "readclause.cpp"
    var $cmp1=((($3))|0) < ((($4))|0); //@line 1060 "readclause.cpp"
    if ($cmp1) { __label__ = 1;; } else { __label__ = 15;; } //@line 1060 "readclause.cpp"
    $for_body_lr_ph$$for_end$2: do { 
      if (__label__ == 1) {
  
        var $arraydecay13=(($voice_name)&4294967295); //@line 1068 "readclause.cpp"
        var $arrayidx17=(($language)&4294967295); //@line 1069 "readclause.cpp"
        var $gender18=(($voice_select+12)&4294967295); //@line 1070 "readclause.cpp"
        var $age19=(($voice_select+13)&4294967295); //@line 1071 "readclause.cpp"
        var $variant20=(($voice_select+14)&4294967295); //@line 1072 "readclause.cpp"
        var $arraydecay26=(($language)&4294967295); //@line 1076 "readclause.cpp"
        var $arrayidx32=(($voice_name)&4294967295); //@line 1078 "readclause.cpp"
        var $gender39=(($voice_select+12)&4294967295); //@line 1081 "readclause.cpp"
        var $age45=(($voice_select+13)&4294967295); //@line 1083 "readclause.cpp"
        var $variant51=(($voice_select+14)&4294967295); //@line 1085 "readclause.cpp"
        ; //@line 1060 "readclause.cpp"
        $for_body$4: while(1) { 
  
          var $5=$ix; //@line 1062 "readclause.cpp"
          var $arrayidx=((__ZL10ssml_stack+$5*76)&4294967295); //@line 1062 "readclause.cpp"
          $sp=$arrayidx; //@line 1062 "readclause.cpp"
          $voice_name_specified=0; //@line 1063 "readclause.cpp"
          var $6=$sp; //@line 1065 "readclause.cpp"
          var $voice_name5=(($6+16)&4294967295); //@line 1065 "readclause.cpp"
          var $arrayidx6=(($voice_name5)&4294967295); //@line 1065 "readclause.cpp"
          var $7=HEAP8[($arrayidx6)]; //@line 1065 "readclause.cpp"
          var $conv7=(tempInt=(($7)),(tempInt>=128?tempInt-256:tempInt)); //@line 1065 "readclause.cpp"
          var $cmp8=((($conv7))|0)!=0; //@line 1065 "readclause.cpp"
          if ($cmp8) { __label__ = 3;; } else { __label__ = 5;; } //@line 1065 "readclause.cpp"
          $land_lhs_true$$if_end$6: do { 
            if (__label__ == 3) {
  
              var $8=$sp; //@line 1065 "readclause.cpp"
              var $voice_name9=(($8+16)&4294967295); //@line 1065 "readclause.cpp"
              var $arraydecay10=(($voice_name9)&4294967295); //@line 1065 "readclause.cpp"
              var $call11=__Z17SelectVoiceByNamePP12espeak_VOICEPKc(0, $arraydecay10); //@line 1065 "readclause.cpp"
              var $cmp12=((($call11))|0)!=0; //@line 1065 "readclause.cpp"
              if (!($cmp12)) { __label__ = 5;break $land_lhs_true$$if_end$6; } //@line 1065 "readclause.cpp"
  
              $voice_name_specified=1; //@line 1067 "readclause.cpp"
              var $9=$sp; //@line 1068 "readclause.cpp"
              var $voice_name14=(($9+16)&4294967295); //@line 1068 "readclause.cpp"
              var $arraydecay15=(($voice_name14)&4294967295); //@line 1068 "readclause.cpp"
              var $call16=_strcpy($arraydecay13, $arraydecay15); //@line 1068 "readclause.cpp"
              HEAP8[($arrayidx17)]=0; //@line 1069 "readclause.cpp"
              HEAP8[($gender18)]=0; //@line 1070 "readclause.cpp"
              HEAP8[($age19)]=0; //@line 1071 "readclause.cpp"
              HEAP8[($variant20)]=0; //@line 1072 "readclause.cpp"
              ; //@line 1073 "readclause.cpp"
            }
          } while(0);
  
          var $10=$sp; //@line 1074 "readclause.cpp"
          var $language21=(($10+56)&4294967295); //@line 1074 "readclause.cpp"
          var $arrayidx22=(($language21)&4294967295); //@line 1074 "readclause.cpp"
          var $11=HEAP8[($arrayidx22)]; //@line 1074 "readclause.cpp"
          var $conv23=(tempInt=(($11)),(tempInt>=128?tempInt-256:tempInt)); //@line 1074 "readclause.cpp"
          var $cmp24=((($conv23))|0)!=0; //@line 1074 "readclause.cpp"
          if ($cmp24) { __label__ = 6;; } else { __label__ = 8;; } //@line 1074 "readclause.cpp"
          $if_then25$$if_end34$10: do { 
            if (__label__ == 6) {
  
              var $12=$sp; //@line 1076 "readclause.cpp"
              var $language27=(($12+56)&4294967295); //@line 1076 "readclause.cpp"
              var $arraydecay28=(($language27)&4294967295); //@line 1076 "readclause.cpp"
              var $call29=_strcpy($arraydecay26, $arraydecay28); //@line 1076 "readclause.cpp"
              var $13=$voice_name_specified; //@line 1077 "readclause.cpp"
              var $cmp30=((($13))|0)==0; //@line 1077 "readclause.cpp"
              if (!($cmp30)) { __label__ = 8;break $if_then25$$if_end34$10; } //@line 1077 "readclause.cpp"
  
              HEAP8[($arrayidx32)]=0; //@line 1078 "readclause.cpp"
              ; //@line 1078 "readclause.cpp"
            }
          } while(0);
  
          var $14=$sp; //@line 1080 "readclause.cpp"
          var $voice_gender=(($14+8)&4294967295); //@line 1080 "readclause.cpp"
          var $15=HEAP32[(($voice_gender)>>2)]; //@line 1080 "readclause.cpp"
          var $cmp35=((($15))|0)!=0; //@line 1080 "readclause.cpp"
          if ($cmp35) { __label__ = 9;; } else { __label__ = 10;; } //@line 1080 "readclause.cpp"
          if (__label__ == 9) {
  
            var $16=$sp; //@line 1081 "readclause.cpp"
            var $voice_gender37=(($16+8)&4294967295); //@line 1081 "readclause.cpp"
            var $17=HEAP32[(($voice_gender37)>>2)]; //@line 1081 "readclause.cpp"
            var $conv38=((($17)) & 255); //@line 1081 "readclause.cpp"
            HEAP8[($gender39)]=$conv38; //@line 1081 "readclause.cpp"
            ; //@line 1081 "readclause.cpp"
          }
  
          var $18=$sp; //@line 1082 "readclause.cpp"
          var $voice_age=(($18+12)&4294967295); //@line 1082 "readclause.cpp"
          var $19=HEAP32[(($voice_age)>>2)]; //@line 1082 "readclause.cpp"
          var $cmp41=((($19))|0)!=0; //@line 1082 "readclause.cpp"
          if ($cmp41) { __label__ = 11;; } else { __label__ = 12;; } //@line 1082 "readclause.cpp"
          if (__label__ == 11) {
  
            var $20=$sp; //@line 1083 "readclause.cpp"
            var $voice_age43=(($20+12)&4294967295); //@line 1083 "readclause.cpp"
            var $21=HEAP32[(($voice_age43)>>2)]; //@line 1083 "readclause.cpp"
            var $conv44=((($21)) & 255); //@line 1083 "readclause.cpp"
            HEAP8[($age45)]=$conv44; //@line 1083 "readclause.cpp"
            ; //@line 1083 "readclause.cpp"
          }
  
          var $22=$sp; //@line 1084 "readclause.cpp"
          var $voice_variant=(($22+4)&4294967295); //@line 1084 "readclause.cpp"
          var $23=HEAP32[(($voice_variant)>>2)]; //@line 1084 "readclause.cpp"
          var $cmp47=((($23))|0)!=0; //@line 1084 "readclause.cpp"
          if ($cmp47) { __label__ = 13;; } else { __label__ = 14;; } //@line 1084 "readclause.cpp"
          if (__label__ == 13) {
  
            var $24=$sp; //@line 1085 "readclause.cpp"
            var $voice_variant49=(($24+4)&4294967295); //@line 1085 "readclause.cpp"
            var $25=HEAP32[(($voice_variant49)>>2)]; //@line 1085 "readclause.cpp"
            var $conv50=((($25)) & 255); //@line 1085 "readclause.cpp"
            HEAP8[($variant51)]=$conv50; //@line 1085 "readclause.cpp"
            ; //@line 1085 "readclause.cpp"
          }
  
          var $26=$ix; //@line 1060 "readclause.cpp"
          var $inc=((($26)+1)&4294967295); //@line 1060 "readclause.cpp"
          $ix=$inc; //@line 1060 "readclause.cpp"
          var $27=$ix; //@line 1060 "readclause.cpp"
          var $28=HEAP32[((__ZL12n_ssml_stack)>>2)]; //@line 1060 "readclause.cpp"
          var $cmp=((($27))|0) < ((($28))|0); //@line 1060 "readclause.cpp"
          if ($cmp) { __label__ = 2;continue $for_body$4; } else { __label__ = 15;break $for_body_lr_ph$$for_end$2; } //@line 1060 "readclause.cpp"
        }
      }
    } while(0);
  
    var $arraydecay53=(($voice_name)&4294967295); //@line 1088 "readclause.cpp"
    var $name=(($voice_select)&4294967295); //@line 1088 "readclause.cpp"
    HEAP32[(($name)>>2)]=$arraydecay53; //@line 1088 "readclause.cpp"
    var $arraydecay54=(($language)&4294967295); //@line 1089 "readclause.cpp"
    var $languages=(($voice_select+4)&4294967295); //@line 1089 "readclause.cpp"
    HEAP32[(($languages)>>2)]=$arraydecay54; //@line 1089 "readclause.cpp"
    var $call55=__Z11SelectVoiceP12espeak_VOICEPi($voice_select, $voice_found); //@line 1090 "readclause.cpp"
    $v_id=$call55; //@line 1090 "readclause.cpp"
    var $cmp56=((($call55))|0)==0; //@line 1091 "readclause.cpp"
    if ($cmp56) { __label__ = 16;; } else { __label__ = 17;; } //@line 1091 "readclause.cpp"
    if (__label__ == 16) {
  
      $retval=((__str45697)&4294967295); //@line 1092 "readclause.cpp"
      ; //@line 1092 "readclause.cpp"
    }
    else if (__label__ == 17) {
  
      var $29=$v_id; //@line 1093 "readclause.cpp"
      $retval=$29; //@line 1093 "readclause.cpp"
      ; //@line 1093 "readclause.cpp"
    }
  
    var $30=$retval; //@line 1094 "readclause.cpp"
    STACKTOP = __stackBase__;
    return $30; //@line 1094 "readclause.cpp"
    return null;
  }
  

  function __ZL18attr_prosody_valueiPKwPi($param_type, $pw, $value_out) {
    var __stackBase__  = STACKTOP; STACKTOP += 4; _memset(__stackBase__, 0, 4);
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $param_type_addr;
    var $pw_addr;
    var $value_out_addr;
    var $sign;
    var $tail=__stackBase__;
    var $value;
    var $x;
    $param_type_addr=$param_type;
    $pw_addr=$pw;
    $value_out_addr=$value_out;
    $sign=0; //@line 1309 "readclause.cpp"
    var $0=$pw_addr; //@line 1313 "readclause.cpp"
    var $1=HEAP32[(($0)>>2)]; //@line 1313 "readclause.cpp"
    var $call1=_iswspace($1); //@line 1313 "readclause.cpp"
    var $tobool2=((($call1))|0)!=0; //@line 1313 "readclause.cpp"
    var $2=$pw_addr; //@line 1313 "readclause.cpp"
    if ($tobool2) { __lastLabel__ = 0; __label__ = 1;; } else { __lastLabel__ = 0; __label__ = 2;; } //@line 1313 "readclause.cpp"
    $while_body$$while_end$2: do { 
      if (__label__ == 1) {
        while(1) { 
  
          var $3=__lastLabel__ == 1 ? $6 : ($2);
          var $incdec_ptr=(($3+4)&4294967295); //@line 1313 "readclause.cpp"
          $pw_addr=$incdec_ptr; //@line 1313 "readclause.cpp"
          var $4=$pw_addr; //@line 1313 "readclause.cpp"
          var $5=HEAP32[(($4)>>2)]; //@line 1313 "readclause.cpp"
          var $call=_iswspace($5); //@line 1313 "readclause.cpp"
          var $tobool=((($call))|0)!=0; //@line 1313 "readclause.cpp"
          var $6=$pw_addr; //@line 1313 "readclause.cpp"
          if ($tobool) { __lastLabel__ = 1; __label__ = 1;continue ; } else { __lastLabel__ = 1; __label__ = 2;break $while_body$$while_end$2; } //@line 1313 "readclause.cpp"
        }
      }
    } while(0);
  
    var $_lcssa=__lastLabel__ == 0 ? $2 : ($6);
    var $7=HEAP32[(($_lcssa)>>2)]; //@line 1314 "readclause.cpp"
    var $cmp=((($7))|0)==43; //@line 1314 "readclause.cpp"
    if ($cmp) { __label__ = 3;; } else { __label__ = 4;; } //@line 1314 "readclause.cpp"
    if (__label__ == 3) {
  
      var $8=$pw_addr; //@line 1316 "readclause.cpp"
      var $incdec_ptr1=(($8+4)&4294967295); //@line 1316 "readclause.cpp"
      $pw_addr=$incdec_ptr1; //@line 1316 "readclause.cpp"
      $sign=1; //@line 1317 "readclause.cpp"
      ; //@line 1318 "readclause.cpp"
    }
  
    var $9=$pw_addr; //@line 1319 "readclause.cpp"
    var $10=HEAP32[(($9)>>2)]; //@line 1319 "readclause.cpp"
    var $cmp2=((($10))|0)==45; //@line 1319 "readclause.cpp"
    if ($cmp2) { __label__ = 5;; } else { __label__ = 6;; } //@line 1319 "readclause.cpp"
    if (__label__ == 5) {
  
      var $11=$pw_addr; //@line 1321 "readclause.cpp"
      var $incdec_ptr4=(($11+4)&4294967295); //@line 1321 "readclause.cpp"
      $pw_addr=$incdec_ptr4; //@line 1321 "readclause.cpp"
      $sign=-1; //@line 1322 "readclause.cpp"
      ; //@line 1323 "readclause.cpp"
    }
  
    var $12=$pw_addr; //@line 1324 "readclause.cpp"
    var $call6=_wcstod($12, $tail); //@line 1324 "readclause.cpp"
    var $conv=($call6); //@line 1324 "readclause.cpp"
    $value=$conv; //@line 1324 "readclause.cpp"
    var $13=HEAP32[(($tail)>>2)]; //@line 1325 "readclause.cpp"
    var $14=$pw_addr; //@line 1325 "readclause.cpp"
    var $cmp7=((($13))|0)==((($14))|0); //@line 1325 "readclause.cpp"
    if ($cmp7) { __label__ = 7;; } else { __label__ = 8;; } //@line 1325 "readclause.cpp"
    $if_then8$$if_end9$12: do { 
      if (__label__ == 7) {
  
        var $15=$value_out_addr; //@line 1328 "readclause.cpp"
        HEAP32[(($15)>>2)]=100; //@line 1328 "readclause.cpp"
        $retval=2; //@line 1329 "readclause.cpp"
        ; //@line 1329 "readclause.cpp"
      }
      else if (__label__ == 8) {
  
        var $16=HEAP32[(($tail)>>2)]; //@line 1332 "readclause.cpp"
        var $17=HEAP32[(($16)>>2)]; //@line 1332 "readclause.cpp"
        var $cmp10=((($17))|0)==37; //@line 1332 "readclause.cpp"
        if ($cmp10) { __label__ = 9;; } else { __label__ = 12;; } //@line 1332 "readclause.cpp"
        if (__label__ == 9) {
  
          var $18=$sign; //@line 1334 "readclause.cpp"
          var $cmp12=((($18))|0)!=0; //@line 1334 "readclause.cpp"
          if ($cmp12) { __label__ = 10;; } else { __label__ = 11;; } //@line 1334 "readclause.cpp"
          if (__label__ == 10) {
  
            var $19=$sign; //@line 1335 "readclause.cpp"
            var $conv14=((($19))|0); //@line 1335 "readclause.cpp"
            var $20=$value; //@line 1335 "readclause.cpp"
            var $mul=($conv14)*($20); //@line 1335 "readclause.cpp"
            var $add=100+($mul); //@line 1335 "readclause.cpp"
            $value=$add; //@line 1335 "readclause.cpp"
            ; //@line 1335 "readclause.cpp"
          }
  
          var $21=$value; //@line 1336 "readclause.cpp"
          var $conv16=((($21))|0); //@line 1336 "readclause.cpp"
          var $22=$value_out_addr; //@line 1336 "readclause.cpp"
          HEAP32[(($22)>>2)]=$conv16; //@line 1336 "readclause.cpp"
          $retval=2; //@line 1337 "readclause.cpp"
          ; //@line 1337 "readclause.cpp"
        }
        else if (__label__ == 12) {
  
          var $23=HEAP32[(($tail)>>2)]; //@line 1340 "readclause.cpp"
          var $arrayidx=(($23)&4294967295); //@line 1340 "readclause.cpp"
          var $24=HEAP32[(($arrayidx)>>2)]; //@line 1340 "readclause.cpp"
          var $cmp18=((($24))|0)==115; //@line 1340 "readclause.cpp"
          if ($cmp18) { __label__ = 13;; } else { __label__ = 15;; } //@line 1340 "readclause.cpp"
          $land_lhs_true$$if_end26$21: do { 
            if (__label__ == 13) {
  
              var $25=HEAP32[(($tail)>>2)]; //@line 1340 "readclause.cpp"
              var $arrayidx19=(($25+4)&4294967295); //@line 1340 "readclause.cpp"
              var $26=HEAP32[(($arrayidx19)>>2)]; //@line 1340 "readclause.cpp"
              var $cmp20=((($26))|0)==116; //@line 1340 "readclause.cpp"
              if (!($cmp20)) { __label__ = 15;break $land_lhs_true$$if_end26$21; } //@line 1340 "readclause.cpp"
  
              var $27=$value; //@line 1344 "readclause.cpp"
              var $28=$sign; //@line 1344 "readclause.cpp"
              var $conv22=((($28))|0); //@line 1344 "readclause.cpp"
              var $mul23=($27)*($conv22); //@line 1344 "readclause.cpp"
              var $div=($mul23)/12; //@line 1344 "readclause.cpp"
              var $exp2=_exp2($div); //@line 1344 "readclause.cpp"
              var $mul24=($exp2)*100; //@line 1344 "readclause.cpp"
              $x=$mul24; //@line 1344 "readclause.cpp"
              var $29=$x; //@line 1345 "readclause.cpp"
              var $conv25=((($29))|0); //@line 1345 "readclause.cpp"
              var $30=$value_out_addr; //@line 1345 "readclause.cpp"
              HEAP32[(($30)>>2)]=$conv25; //@line 1345 "readclause.cpp"
              $retval=2; //@line 1346 "readclause.cpp"
              __label__ = 21;break $if_then8$$if_end9$12; //@line 1346 "readclause.cpp"
            }
          } while(0);
  
          var $31=$param_type_addr; //@line 1349 "readclause.cpp"
          var $cmp27=((($31))|0)==1; //@line 1349 "readclause.cpp"
          if ($cmp27) { __label__ = 16;; } else { __label__ = 20;; } //@line 1349 "readclause.cpp"
          if (__label__ == 16) {
  
            var $32=$sign; //@line 1351 "readclause.cpp"
            var $cmp29=((($32))|0)==0; //@line 1351 "readclause.cpp"
            if ($cmp29) { __label__ = 17;; } else { __label__ = 18;; } //@line 1351 "readclause.cpp"
            if (__label__ == 17) {
  
              var $33=$value; //@line 1352 "readclause.cpp"
              var $mul31=($33)*100; //@line 1352 "readclause.cpp"
              var $conv32=((($mul31))|0); //@line 1352 "readclause.cpp"
              var $34=$value_out_addr; //@line 1352 "readclause.cpp"
              HEAP32[(($34)>>2)]=$conv32; //@line 1352 "readclause.cpp"
              ; //@line 1352 "readclause.cpp"
            }
            else if (__label__ == 18) {
  
              var $35=$sign; //@line 1354 "readclause.cpp"
              var $conv33=((($35))|0); //@line 1354 "readclause.cpp"
              var $36=$value; //@line 1354 "readclause.cpp"
              var $mul34=($conv33)*($36); //@line 1354 "readclause.cpp"
              var $mul35=($mul34)*100; //@line 1354 "readclause.cpp"
              var $conv36=((($mul35))|0); //@line 1354 "readclause.cpp"
              var $add37=((($conv36)+100)&4294967295); //@line 1354 "readclause.cpp"
              var $37=$value_out_addr; //@line 1354 "readclause.cpp"
              HEAP32[(($37)>>2)]=$add37; //@line 1354 "readclause.cpp"
              ;
            }
  
            $retval=2; //@line 1355 "readclause.cpp"
            ; //@line 1355 "readclause.cpp"
          }
          else if (__label__ == 20) {
  
            var $38=$value; //@line 1358 "readclause.cpp"
            var $conv40=((($38))|0); //@line 1358 "readclause.cpp"
            var $39=$value_out_addr; //@line 1358 "readclause.cpp"
            HEAP32[(($39)>>2)]=$conv40; //@line 1358 "readclause.cpp"
            var $40=$sign; //@line 1359 "readclause.cpp"
            $retval=$40; //@line 1359 "readclause.cpp"
            ; //@line 1359 "readclause.cpp"
          }
        }
      }
    } while(0);
  
    var $41=$retval; //@line 1360 "readclause.cpp"
    STACKTOP = __stackBase__;
    return $41; //@line 1360 "readclause.cpp"
    return null;
  }
  

  function __ZL8GetC_getv() {
    ;
    var __label__;
  
    var $retval;
    var $c;
    var $c2;
    var $0=HEAP32[((__ZL7f_input)>>2)]; //@line 419 "readclause.cpp"
    var $cmp=((($0))|0)!=0; //@line 419 "readclause.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 8;; } //@line 419 "readclause.cpp"
    $if_then$$if_end13$2: do { 
      if (__label__ == 1) {
  
        var $1=HEAP32[((__ZL7f_input)>>2)]; //@line 421 "readclause.cpp"
        var $call=_fgetc($1); //@line 421 "readclause.cpp"
        $c=$call; //@line 421 "readclause.cpp"
        var $2=HEAP32[((__ZL7f_input)>>2)]; //@line 422 "readclause.cpp"
        var $_flags=(($2+12)&4294967295); //@line 422 "readclause.cpp"
        var $3=HEAP16[(($_flags)>>1)]; //@line 422 "readclause.cpp"
        var $conv=(tempInt=(($3)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 422 "readclause.cpp"
        var $and=($conv) & 32; //@line 422 "readclause.cpp"
        var $cmp1=((($and))|0)!=0; //@line 422 "readclause.cpp"
        if ($cmp1) { __label__ = 2;; } else { __label__ = 3;; } //@line 422 "readclause.cpp"
        if (__label__ == 2) {
  
          $c=32; //@line 422 "readclause.cpp"
          ; //@line 422 "readclause.cpp"
        }
  
        var $4=HEAP32[((_option_multibyte)>>2)]; //@line 424 "readclause.cpp"
        var $cmp3=((($4))|0)==4; //@line 424 "readclause.cpp"
        if ($cmp3) { __label__ = 4;; } else { __label__ = 7;; } //@line 424 "readclause.cpp"
        if (__label__ == 4) {
  
          var $5=HEAP32[((__ZL7f_input)>>2)]; //@line 426 "readclause.cpp"
          var $call5=_fgetc($5); //@line 426 "readclause.cpp"
          $c2=$call5; //@line 426 "readclause.cpp"
          var $6=HEAP32[((__ZL7f_input)>>2)]; //@line 427 "readclause.cpp"
          var $_flags6=(($6+12)&4294967295); //@line 427 "readclause.cpp"
          var $7=HEAP16[(($_flags6)>>1)]; //@line 427 "readclause.cpp"
          var $conv7=(tempInt=(($7)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 427 "readclause.cpp"
          var $and8=($conv7) & 32; //@line 427 "readclause.cpp"
          var $cmp9=((($and8))|0)!=0; //@line 427 "readclause.cpp"
          if ($cmp9) { __label__ = 5;; } else { __label__ = 6;; } //@line 427 "readclause.cpp"
          if (__label__ == 5) {
  
            $c2=0; //@line 427 "readclause.cpp"
            ; //@line 427 "readclause.cpp"
          }
  
          var $8=$c; //@line 428 "readclause.cpp"
          var $9=$c2; //@line 428 "readclause.cpp"
          var $shl=((($9)*256)&4294967295); //@line 428 "readclause.cpp"
          var $add=((($shl)+($8))&4294967295); //@line 428 "readclause.cpp"
          $c=$add; //@line 428 "readclause.cpp"
          ; //@line 429 "readclause.cpp"
        }
  
        var $10=$c; //@line 430 "readclause.cpp"
        $retval=$10; //@line 430 "readclause.cpp"
        ; //@line 430 "readclause.cpp"
      }
      else if (__label__ == 8) {
  
        var $11=HEAP32[((_option_multibyte)>>2)]; //@line 433 "readclause.cpp"
        var $cmp14=((($11))|0)==3; //@line 433 "readclause.cpp"
        if ($cmp14) { __label__ = 9;; } else { __label__ = 13;; } //@line 433 "readclause.cpp"
        $if_then15$$if_else$14: do { 
          if (__label__ == 9) {
  
            var $12=HEAP32[((_p_wchar_input)>>2)]; //@line 435 "readclause.cpp"
            var $13=HEAP32[(($12)>>2)]; //@line 435 "readclause.cpp"
            var $cmp16=((($13))|0)==0; //@line 435 "readclause.cpp"
            if ($cmp16) { __label__ = 10;; } else { __label__ = 11;; } //@line 435 "readclause.cpp"
            if (__label__ == 10) {
  
              HEAP8[(__ZL12end_of_input_b)]=1;
              $retval=0; //@line 438 "readclause.cpp"
              __label__ = 20;break $if_then$$if_end13$2; //@line 438 "readclause.cpp"
            }
            else if (__label__ == 11) {
  
              var $_b1=HEAPU8[(__ZL12end_of_input_b)];
              var $14=((($_b1))&1);
              var $tobool=((($14))|0)!=0; //@line 441 "readclause.cpp"
              if ($tobool) { __label__ = 19;break $if_then15$$if_else$14; } //@line 441 "readclause.cpp"
  
              var $15=HEAP32[((_p_wchar_input)>>2)]; //@line 442 "readclause.cpp"
              var $incdec_ptr=(($15+4)&4294967295); //@line 442 "readclause.cpp"
              HEAP32[((_p_wchar_input)>>2)]=$incdec_ptr; //@line 442 "readclause.cpp"
              var $16=HEAP32[(($15)>>2)]; //@line 442 "readclause.cpp"
              $retval=$16; //@line 442 "readclause.cpp"
              __label__ = 20;break $if_then$$if_end13$2; //@line 442 "readclause.cpp"
            }
          }
          else if (__label__ == 13) {
  
            var $17=HEAP32[((_p_textinput)>>2)]; //@line 446 "readclause.cpp"
            var $18=HEAPU8[($17)]; //@line 446 "readclause.cpp"
            var $conv21=((($18))&255); //@line 446 "readclause.cpp"
            var $cmp22=((($conv21))|0)==0; //@line 446 "readclause.cpp"
            if ($cmp22) { __label__ = 14;; } else { __label__ = 15;; } //@line 446 "readclause.cpp"
            if (__label__ == 14) {
  
              HEAP8[(__ZL12end_of_input_b)]=1;
              $retval=0; //@line 449 "readclause.cpp"
              __label__ = 20;break $if_then$$if_end13$2; //@line 449 "readclause.cpp"
            }
            else if (__label__ == 15) {
  
              var $_b=HEAPU8[(__ZL12end_of_input_b)];
              var $19=((($_b))&1);
              var $tobool25=((($19))|0)!=0; //@line 452 "readclause.cpp"
              if ($tobool25) { __label__ = 19;break $if_then15$$if_else$14; } //@line 452 "readclause.cpp"
  
              var $20=HEAP32[((_option_multibyte)>>2)]; //@line 454 "readclause.cpp"
              var $cmp27=((($20))|0)==4; //@line 454 "readclause.cpp"
              var $21=HEAPU32[((_p_textinput)>>2)]; //@line 456 "readclause.cpp"
              if ($cmp27) { __label__ = 17;; } else { __label__ = 18;; } //@line 454 "readclause.cpp"
              if (__label__ == 17) {
  
                var $arrayidx=(($21)&4294967295); //@line 456 "readclause.cpp"
                var $22=HEAPU8[($arrayidx)]; //@line 456 "readclause.cpp"
                var $conv29=((($22))&255); //@line 456 "readclause.cpp"
                var $23=HEAP32[((_p_textinput)>>2)]; //@line 456 "readclause.cpp"
                var $arrayidx30=(($23+1)&4294967295); //@line 456 "readclause.cpp"
                var $24=HEAPU8[($arrayidx30)]; //@line 456 "readclause.cpp"
                var $conv31=((($24))&255); //@line 456 "readclause.cpp"
                var $shl32=((($conv31)*256)&4294967295); //@line 456 "readclause.cpp"
                var $add33=((($shl32)+($conv29))&4294967295); //@line 456 "readclause.cpp"
                $c=$add33; //@line 456 "readclause.cpp"
                var $25=HEAP32[((_p_textinput)>>2)]; //@line 457 "readclause.cpp"
                var $add_ptr=(($25+2)&4294967295); //@line 457 "readclause.cpp"
                HEAP32[((_p_textinput)>>2)]=$add_ptr; //@line 457 "readclause.cpp"
                var $26=$c; //@line 458 "readclause.cpp"
                $retval=$26; //@line 458 "readclause.cpp"
                __label__ = 20;break $if_then$$if_end13$2; //@line 458 "readclause.cpp"
              }
              else if (__label__ == 18) {
  
                var $incdec_ptr35=(($21+1)&4294967295); //@line 460 "readclause.cpp"
                HEAP32[((_p_textinput)>>2)]=$incdec_ptr35; //@line 460 "readclause.cpp"
                var $27=HEAPU8[($21)]; //@line 460 "readclause.cpp"
                var $conv36=((($27))&255); //@line 460 "readclause.cpp"
                var $and37=($conv36) & 255; //@line 460 "readclause.cpp"
                $retval=$and37; //@line 460 "readclause.cpp"
                __label__ = 20;break $if_then$$if_end13$2; //@line 460 "readclause.cpp"
              }
            }
          }
        } while(0);
  
        $retval=0; //@line 463 "readclause.cpp"
        ; //@line 463 "readclause.cpp"
      }
    } while(0);
  
    var $28=$retval; //@line 464 "readclause.cpp"
    ;
    return $28; //@line 464 "readclause.cpp"
    return null;
  }
  

  function __ZL10GetC_ungeti($c) {
    ;
    var __label__;
  
    var $c_addr;
    $c_addr=$c;
    var $0=HEAP32[((__ZL7f_input)>>2)]; //@line 392 "readclause.cpp"
    var $cmp=((($0))|0)!=0; //@line 392 "readclause.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 392 "readclause.cpp"
    if (__label__ == 1) {
  
      var $1=$c_addr; //@line 393 "readclause.cpp"
      var $2=HEAP32[((__ZL7f_input)>>2)]; //@line 393 "readclause.cpp"
      var $call=_ungetc($1, $2); //@line 393 "readclause.cpp"
      ; //@line 393 "readclause.cpp"
    }
    else if (__label__ == 2) {
  
      var $3=HEAP32[((_p_textinput)>>2)]; //@line 396 "readclause.cpp"
      var $incdec_ptr=(($3+-1)&4294967295); //@line 396 "readclause.cpp"
      HEAP32[((_p_textinput)>>2)]=$incdec_ptr; //@line 396 "readclause.cpp"
      var $4=$c_addr; //@line 397 "readclause.cpp"
      var $conv=((($4)) & 255); //@line 397 "readclause.cpp"
      var $5=HEAP32[((_p_textinput)>>2)]; //@line 397 "readclause.cpp"
      HEAP8[($5)]=$conv; //@line 397 "readclause.cpp"
      HEAP8[(__ZL12end_of_input_b)]=0;
      ;
    }
  
    ;
    return; //@line 400 "readclause.cpp"
    return;
  }
  

  function __Z8SetSpeedi($control) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $control_addr;
    var $x;
    var $s1;
    var $wpm;
    var $wpm2;
    var $wpm_value;
    var $sonic;
    $control_addr=$control;
    HEAP32[((((_speed+28)&4294967295))>>2)]=0; //@line 147 "setlengths.cpp"
    HEAP32[((((_speed+24)&4294967295))>>2)]=450; //@line 148 "setlengths.cpp"
    HEAP32[((((_speed+16)&4294967295))>>2)]=110; //@line 149 "setlengths.cpp"
    HEAP32[((((_speed+20)&4294967295))>>2)]=100; //@line 150 "setlengths.cpp"
    HEAP32[((((_speed+8)&4294967295))>>2)]=5; //@line 151 "setlengths.cpp"
    var $0=HEAP32[((((_embedded_value+8)&4294967295))>>2)]; //@line 153 "setlengths.cpp"
    $wpm=$0; //@line 153 "setlengths.cpp"
    var $1=$control_addr; //@line 154 "setlengths.cpp"
    var $cmp=((($1))|0)==2; //@line 154 "setlengths.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 154 "setlengths.cpp"
    if (__label__ == 1) {
  
      var $2=HEAP32[((((_embedded_value+32)&4294967295))>>2)]; //@line 155 "setlengths.cpp"
      $wpm=$2; //@line 155 "setlengths.cpp"
      ; //@line 155 "setlengths.cpp"
    }
  
    var $3=$wpm; //@line 157 "setlengths.cpp"
    $wpm_value=$3; //@line 157 "setlengths.cpp"
    var $4=HEAP32[((_voice)>>2)]; //@line 159 "setlengths.cpp"
    var $speed_percent=(($4+64)&4294967295); //@line 159 "setlengths.cpp"
    var $5=HEAP32[(($speed_percent)>>2)]; //@line 159 "setlengths.cpp"
    var $cmp1=((($5))|0) > 0; //@line 159 "setlengths.cpp"
    if ($cmp1) { __label__ = 3;; } else { __label__ = 4;; } //@line 159 "setlengths.cpp"
    if (__label__ == 3) {
  
      var $6=$wpm; //@line 161 "setlengths.cpp"
      var $7=HEAP32[((_voice)>>2)]; //@line 161 "setlengths.cpp"
      var $speed_percent3=(($7+64)&4294967295); //@line 161 "setlengths.cpp"
      var $8=HEAP32[(($speed_percent3)>>2)]; //@line 161 "setlengths.cpp"
      var $mul=((($8)*($6))&4294967295); //@line 161 "setlengths.cpp"
      var $div=((((($mul))|0)/100)|0); //@line 161 "setlengths.cpp"
      $wpm=$div; //@line 161 "setlengths.cpp"
      ; //@line 162 "setlengths.cpp"
    }
  
    var $9=$control_addr; //@line 164 "setlengths.cpp"
    var $and=($9) & 2; //@line 164 "setlengths.cpp"
    var $tobool=((($and))|0)!=0; //@line 164 "setlengths.cpp"
    if ($tobool) { __label__ = 5;; } else { __label__ = 6;; } //@line 164 "setlengths.cpp"
    if (__label__ == 5) {
  
      __Z12DoSonicSpeedi(1024); //@line 166 "setlengths.cpp"
      ; //@line 167 "setlengths.cpp"
    }
  
    var $10=$wpm_value; //@line 168 "setlengths.cpp"
    var $cmp7=((($10))|0) > 450; //@line 168 "setlengths.cpp"
    if ($cmp7) { __label__ = 10;; } else { __label__ = 7;; } //@line 168 "setlengths.cpp"
    $if_then10$$lor_lhs_false$11: do { 
      if (__label__ == 7) {
  
        var $11=$wpm_value; //@line 168 "setlengths.cpp"
        var $12=HEAP32[((((_speed+32)&4294967295))>>2)]; //@line 168 "setlengths.cpp"
        var $cmp8=((($11))|0) > ((($12))|0); //@line 168 "setlengths.cpp"
        var $13=$wpm; //@line 168 "setlengths.cpp"
        if ($cmp8) { __label__ = 8;; } else { __label__ = 14;; } //@line 168 "setlengths.cpp"
        $land_lhs_true$$if_end29$13: do { 
          if (__label__ == 8) {
  
            var $cmp9=((($13))|0) > 350; //@line 168 "setlengths.cpp"
            if ($cmp9) { __label__ = 10;break $if_then10$$lor_lhs_false$11; } //@line 168 "setlengths.cpp"
  
            var $_pr2=$wpm; //@line 210 "setlengths.cpp"
            __lastLabel__ = 9; __label__ = 16;break $land_lhs_true$$if_end29$13; //@line 207 "setlengths.cpp"
          }
          else if (__label__ == 14) {
  
            var $cmp30=((($13))|0) > 450; //@line 207 "setlengths.cpp"
            if ($cmp30) { __lastLabel__ = 14; ; } else { __lastLabel__ = 14; __label__ = 16;break $land_lhs_true$$if_end29$13; } //@line 207 "setlengths.cpp"
  
            $wpm=450; //@line 208 "setlengths.cpp"
            __label__ = 17;break $land_lhs_true$$if_end29$13; //@line 210 "setlengths.cpp"
          }
        } while(0);
        $if_end32$$if_then34$18: do { 
          if (__label__ == 16) {
  
            var $29=__lastLabel__ == 9 ? $_pr2 : ($13); //@line 210 "setlengths.cpp"
            var $cmp33=((($29))|0) > 360; //@line 210 "setlengths.cpp"
            if ($cmp33) { __label__ = 17;break $if_end32$$if_then34$18; } else { __label__ = 18;break $if_end32$$if_then34$18; } //@line 210 "setlengths.cpp"
          }
        } while(0);
        if (__label__ == 17) {
  
          var $30=$wpm; //@line 212 "setlengths.cpp"
          var $sub=((($30)-360)&4294967295); //@line 212 "setlengths.cpp"
          var $div35=((((($sub))|0)/8)|0); //@line 212 "setlengths.cpp"
          HEAP32[((((_speed+28)&4294967295))>>2)]=$div35; //@line 212 "setlengths.cpp"
          ; //@line 213 "setlengths.cpp"
        }
  
        var $31=$wpm; //@line 215 "setlengths.cpp"
        $wpm2=$31; //@line 215 "setlengths.cpp"
        var $cmp37=((($31))|0) > 359; //@line 216 "setlengths.cpp"
        if ($cmp37) { __lastLabel__ = 18; __label__ = 19;; } else { __lastLabel__ = 18; __label__ = 20;; } //@line 216 "setlengths.cpp"
        if (__label__ == 19) {
  
          $wpm2=359; //@line 216 "setlengths.cpp"
          var $_pr4=$wpm; //@line 217 "setlengths.cpp"
          __lastLabel__ = 19; ; //@line 216 "setlengths.cpp"
        }
  
        var $32=__lastLabel__ == 19 ? $_pr4 : ($31); //@line 217 "setlengths.cpp"
        var $cmp40=((($32))|0) < 80; //@line 217 "setlengths.cpp"
        if ($cmp40) { __label__ = 21;; } else { __label__ = 22;; } //@line 217 "setlengths.cpp"
        if (__label__ == 21) {
  
          $wpm2=80; //@line 217 "setlengths.cpp"
          ; //@line 217 "setlengths.cpp"
        }
  
        var $33=$wpm2; //@line 218 "setlengths.cpp"
        var $sub43=((($33)-80)&4294967295); //@line 218 "setlengths.cpp"
        var $arrayidx=((__ZL12speed_lookup+$sub43)&4294967295); //@line 218 "setlengths.cpp"
        var $34=HEAPU8[($arrayidx)]; //@line 218 "setlengths.cpp"
        var $conv44=((($34))&255); //@line 218 "setlengths.cpp"
        $x=$conv44; //@line 218 "setlengths.cpp"
        var $35=$wpm; //@line 220 "setlengths.cpp"
        var $cmp45=((($35))|0) >= 380; //@line 220 "setlengths.cpp"
        if ($cmp45) { __label__ = 23;; } else { __label__ = 25;; } //@line 220 "setlengths.cpp"
        $if_end47$$if_end50$29: do { 
          if (__label__ == 23) {
  
            $x=7; //@line 221 "setlengths.cpp"
            var $_pr5=$wpm; //@line 222 "setlengths.cpp"
            var $cmp48=((($_pr5))|0) >= 400; //@line 222 "setlengths.cpp"
            if (!($cmp48)) { __label__ = 25;break $if_end47$$if_end50$29; } //@line 222 "setlengths.cpp"
  
            $x=6; //@line 223 "setlengths.cpp"
            ; //@line 223 "setlengths.cpp"
          }
        } while(0);
  
        var $36=$control_addr; //@line 225 "setlengths.cpp"
        var $and51=($36) & 1; //@line 225 "setlengths.cpp"
        var $tobool52=((($and51))|0)!=0; //@line 225 "setlengths.cpp"
        if ($tobool52) { __label__ = 26;; } else { __label__ = 28;; } //@line 225 "setlengths.cpp"
        $if_then53$$if_end67$33: do { 
          if (__label__ == 26) {
  
            var $37=$x; //@line 229 "setlengths.cpp"
            var $38=HEAP32[((_voice)>>2)]; //@line 229 "setlengths.cpp"
            var $speedf154=(($38+52)&4294967295); //@line 229 "setlengths.cpp"
            var $39=HEAP32[(($speedf154)>>2)]; //@line 229 "setlengths.cpp"
            var $mul55=((($39)*($37))&4294967295); //@line 229 "setlengths.cpp"
            var $div56=((((($mul55))|0)/256)|0); //@line 229 "setlengths.cpp"
            HEAP32[((__ZL6speed1)>>2)]=$div56; //@line 229 "setlengths.cpp"
            var $40=$x; //@line 230 "setlengths.cpp"
            var $41=HEAP32[((_voice)>>2)]; //@line 230 "setlengths.cpp"
            var $speedf257=(($41+56)&4294967295); //@line 230 "setlengths.cpp"
            var $42=HEAP32[(($speedf257)>>2)]; //@line 230 "setlengths.cpp"
            var $mul58=((($42)*($40))&4294967295); //@line 230 "setlengths.cpp"
            var $div59=((((($mul58))|0)/256)|0); //@line 230 "setlengths.cpp"
            HEAP32[((__ZL6speed2)>>2)]=$div59; //@line 230 "setlengths.cpp"
            var $43=$x; //@line 231 "setlengths.cpp"
            var $44=HEAP32[((_voice)>>2)]; //@line 231 "setlengths.cpp"
            var $speedf360=(($44+60)&4294967295); //@line 231 "setlengths.cpp"
            var $45=HEAP32[(($speedf360)>>2)]; //@line 231 "setlengths.cpp"
            var $mul61=((($45)*($43))&4294967295); //@line 231 "setlengths.cpp"
            var $div62=((((($mul61))|0)/256)|0); //@line 231 "setlengths.cpp"
            HEAP32[((__ZL6speed3)>>2)]=$div62; //@line 231 "setlengths.cpp"
            var $46=$x; //@line 233 "setlengths.cpp"
            var $cmp63=((($46))|0) <= 7; //@line 233 "setlengths.cpp"
            if (!($cmp63)) { __label__ = 28;break $if_then53$$if_end67$33; } //@line 233 "setlengths.cpp"
  
            var $47=$x; //@line 235 "setlengths.cpp"
            HEAP32[((__ZL6speed1)>>2)]=$47; //@line 235 "setlengths.cpp"
            var $48=$x; //@line 236 "setlengths.cpp"
            var $sub65=((($48)-1)&4294967295); //@line 236 "setlengths.cpp"
            HEAP32[((__ZL6speed3)>>2)]=$sub65; //@line 236 "setlengths.cpp"
            HEAP32[((__ZL6speed2)>>2)]=$sub65; //@line 236 "setlengths.cpp"
            ; //@line 237 "setlengths.cpp"
          }
        } while(0);
  
        var $49=$control_addr; //@line 240 "setlengths.cpp"
        var $and68=($49) & 2; //@line 240 "setlengths.cpp"
        var $tobool69=((($and68))|0)!=0; //@line 240 "setlengths.cpp"
        if (!($tobool69)) { __label__ = 51;break $if_then10$$lor_lhs_false$11; } //@line 240 "setlengths.cpp"
  
        var $50=$wpm; //@line 244 "setlengths.cpp"
        var $cmp71=((($50))|0) > 350; //@line 244 "setlengths.cpp"
        var $51=$wpm; //@line 246 "setlengths.cpp"
        if ($cmp71) { __label__ = 30;; } else { __label__ = 31;; } //@line 244 "setlengths.cpp"
        $if_then72$$if_else$38: do { 
          if (__label__ == 30) {
  
            var $sub73=((($51)-350)&4294967295); //@line 246 "setlengths.cpp"
            var $div74=((((($sub73))|0)/3)|0); //@line 246 "setlengths.cpp"
            var $sub75=((85-($div74))&4294967295); //@line 246 "setlengths.cpp"
            HEAP32[((((_speed+16)&4294967295))>>2)]=$sub75; //@line 246 "setlengths.cpp"
            var $52=$wpm; //@line 247 "setlengths.cpp"
            var $sub76=((($52)-350)&4294967295); //@line 247 "setlengths.cpp"
            var $div77=((((($sub76))|0)/8)|0); //@line 247 "setlengths.cpp"
            var $sub78=((60-($div77))&4294967295); //@line 247 "setlengths.cpp"
            HEAP32[((((_speed+20)&4294967295))>>2)]=$sub78; //@line 247 "setlengths.cpp"
            ; //@line 248 "setlengths.cpp"
          }
          else if (__label__ == 31) {
  
            var $cmp79=((($51))|0) > 250; //@line 250 "setlengths.cpp"
            if (!($cmp79)) { __label__ = 33;break $if_then72$$if_else$38; } //@line 250 "setlengths.cpp"
  
            var $53=$wpm; //@line 252 "setlengths.cpp"
            var $sub81=((($53)-250)&4294967295); //@line 252 "setlengths.cpp"
            var $div82=((((($sub81))|0)/4)|0); //@line 252 "setlengths.cpp"
            var $sub83=((110-($div82))&4294967295); //@line 252 "setlengths.cpp"
            HEAP32[((((_speed+16)&4294967295))>>2)]=$sub83; //@line 252 "setlengths.cpp"
            var $54=$wpm; //@line 253 "setlengths.cpp"
            var $sub84=((($54)-250)&4294967295); //@line 253 "setlengths.cpp"
            var $div85=((((($sub84))|0)/2)|0); //@line 253 "setlengths.cpp"
            var $sub86=((110-($div85))&4294967295); //@line 253 "setlengths.cpp"
            HEAP32[((((_speed+20)&4294967295))>>2)]=$sub86; //@line 253 "setlengths.cpp"
            ; //@line 254 "setlengths.cpp"
          }
        } while(0);
  
        var $55=$x; //@line 256 "setlengths.cpp"
        var $56=HEAP32[((_voice)>>2)]; //@line 256 "setlengths.cpp"
        var $speedf189=(($56+52)&4294967295); //@line 256 "setlengths.cpp"
        var $57=HEAP32[(($speedf189)>>2)]; //@line 256 "setlengths.cpp"
        var $mul90=((($57)*($55))&4294967295); //@line 256 "setlengths.cpp"
        var $div91=((((($mul90))|0)/256)|0); //@line 256 "setlengths.cpp"
        $s1=$div91; //@line 256 "setlengths.cpp"
        var $58=$wpm; //@line 258 "setlengths.cpp"
        var $cmp92=((($58))|0) >= 170; //@line 258 "setlengths.cpp"
        var $59=$s1; //@line 259 "setlengths.cpp"
        if ($cmp92) { __label__ = 34;; } else { __label__ = 35;; } //@line 258 "setlengths.cpp"
        if (__label__ == 34) {
  
          var $mul94=((($59)*150)&4294967295); //@line 259 "setlengths.cpp"
          var $div95=((((($mul94))|0)/128)|0); //@line 259 "setlengths.cpp"
          var $add=((($div95)+110)&4294967295); //@line 259 "setlengths.cpp"
          HEAP32[((((_speed+12)&4294967295))>>2)]=$add; //@line 259 "setlengths.cpp"
          ; //@line 259 "setlengths.cpp"
        }
        else if (__label__ == 35) {
  
          var $mul97=((($59)*128)&4294967295); //@line 261 "setlengths.cpp"
          var $div98=((((($mul97))|0)/130)|0); //@line 261 "setlengths.cpp"
          var $add99=((($div98)+128)&4294967295); //@line 261 "setlengths.cpp"
          HEAP32[((((_speed+12)&4294967295))>>2)]=$add99; //@line 261 "setlengths.cpp"
          ;
        }
  
        var $60=$wpm; //@line 263 "setlengths.cpp"
        var $cmp101=((($60))|0) >= 350; //@line 263 "setlengths.cpp"
        if ($cmp101) { __label__ = 37;; } else { __label__ = 40;; } //@line 263 "setlengths.cpp"
        $if_end106$$if_end117$47: do { 
          if (__label__ == 37) {
  
            var $61=$wpm; //@line 265 "setlengths.cpp"
            var $sub103=((($61)-350)&4294967295); //@line 265 "setlengths.cpp"
            var $arrayidx104=((__ZL14wav_factor_350+$sub103)&4294967295); //@line 265 "setlengths.cpp"
            var $62=HEAPU8[($arrayidx104)]; //@line 265 "setlengths.cpp"
            var $conv105=((($62))&255); //@line 265 "setlengths.cpp"
            HEAP32[((((_speed+12)&4294967295))>>2)]=$conv105; //@line 265 "setlengths.cpp"
            var $_pr7=$wpm; //@line 268 "setlengths.cpp"
            var $cmp107=((($_pr7))|0) >= 390; //@line 268 "setlengths.cpp"
            if (!($cmp107)) { __label__ = 40;break $if_end106$$if_end117$47; } //@line 268 "setlengths.cpp"
  
            var $63=$wpm; //@line 270 "setlengths.cpp"
            var $sub109=((($63)-400)&4294967295); //@line 270 "setlengths.cpp"
            var $div110=((((($sub109))|0)/2)|0); //@line 270 "setlengths.cpp"
            var $sub111=((450-($div110))&4294967295); //@line 270 "setlengths.cpp"
            HEAP32[((((_speed+24)&4294967295))>>2)]=$sub111; //@line 270 "setlengths.cpp"
            var $64=$wpm; //@line 271 "setlengths.cpp"
            var $cmp112=((($64))|0) > 440; //@line 271 "setlengths.cpp"
            if (!($cmp112)) { __label__ = 40;break $if_end106$$if_end117$47; } //@line 271 "setlengths.cpp"
  
            var $65=$wpm; //@line 272 "setlengths.cpp"
            var $_neg=(((-($65)))&4294967295);
            var $sub115=((($_neg)+860)&4294967295); //@line 272 "setlengths.cpp"
            HEAP32[((((_speed+24)&4294967295))>>2)]=$sub115; //@line 272 "setlengths.cpp"
            ; //@line 272 "setlengths.cpp"
          }
        } while(0);
  
        var $66=$s1; //@line 275 "setlengths.cpp"
        var $mul118=((($66)*256)&4294967295); //@line 275 "setlengths.cpp"
        var $div119=((((($mul118))|0)/115)|0); //@line 275 "setlengths.cpp"
        HEAP32[((((_speed)&4294967295))>>2)]=$div119; //@line 275 "setlengths.cpp"
        HEAP32[((((_speed+4)&4294967295))>>2)]=0; //@line 276 "setlengths.cpp"
        var $67=$wpm; //@line 278 "setlengths.cpp"
        var $cmp120=((($67))|0) > 430; //@line 278 "setlengths.cpp"
        if ($cmp120) { __label__ = 41;; } else { __label__ = 42;; } //@line 278 "setlengths.cpp"
        $if_then121$$if_else122$52: do { 
          if (__label__ == 41) {
  
            HEAP32[((((_speed)&4294967295))>>2)]=12; //@line 280 "setlengths.cpp"
            ; //@line 282 "setlengths.cpp"
          }
          else if (__label__ == 42) {
  
            var $68=$wpm; //@line 284 "setlengths.cpp"
            var $cmp123=((($68))|0) > 400; //@line 284 "setlengths.cpp"
            if ($cmp123) { __label__ = 43;; } else { __label__ = 44;; } //@line 284 "setlengths.cpp"
            if (__label__ == 43) {
  
              HEAP32[((((_speed)&4294967295))>>2)]=13; //@line 286 "setlengths.cpp"
              ; //@line 288 "setlengths.cpp"
            }
            else if (__label__ == 44) {
  
              var $69=$wpm; //@line 290 "setlengths.cpp"
              var $cmp126=((($69))|0) > 374; //@line 290 "setlengths.cpp"
              if ($cmp126) { __label__ = 45;; } else { __label__ = 46;; } //@line 290 "setlengths.cpp"
              if (__label__ == 45) {
  
                HEAP32[((((_speed)&4294967295))>>2)]=14; //@line 292 "setlengths.cpp"
                ; //@line 293 "setlengths.cpp"
              }
              else if (__label__ == 46) {
  
                var $70=$wpm; //@line 295 "setlengths.cpp"
                var $cmp129=((($70))|0) > 350; //@line 295 "setlengths.cpp"
                if (!($cmp129)) { __label__ = 48;break $if_then121$$if_else122$52; } //@line 295 "setlengths.cpp"
  
                var $71=$wpm; //@line 297 "setlengths.cpp"
                var $sub131=((($71)-350)&4294967295); //@line 297 "setlengths.cpp"
                var $arrayidx132=((__ZL16pause_factor_350+$sub131)&4294967295); //@line 297 "setlengths.cpp"
                var $72=HEAPU8[($arrayidx132)]; //@line 297 "setlengths.cpp"
                var $conv133=((($72))&255); //@line 297 "setlengths.cpp"
                HEAP32[((((_speed)&4294967295))>>2)]=$conv133; //@line 297 "setlengths.cpp"
                ; //@line 298 "setlengths.cpp"
              }
            }
          }
        } while(0);
  
        var $73=HEAP32[((((_speed+4)&4294967295))>>2)]; //@line 300 "setlengths.cpp"
        var $cmp138=((($73))|0)==0; //@line 300 "setlengths.cpp"
        if (!($cmp138)) { __label__ = 51;break $if_then10$$lor_lhs_false$11; } //@line 300 "setlengths.cpp"
  
        var $74=HEAP32[((((_speed)&4294967295))>>2)]; //@line 303 "setlengths.cpp"
        HEAP32[((((_speed+4)&4294967295))>>2)]=$74; //@line 303 "setlengths.cpp"
        var $cmp140=((($74))|0) < 16; //@line 303 "setlengths.cpp"
        if (!($cmp140)) { __label__ = 51;break $if_then10$$lor_lhs_false$11; } //@line 303 "setlengths.cpp"
  
        HEAP32[((((_speed+4)&4294967295))>>2)]=16; //@line 304 "setlengths.cpp"
        __label__ = 51;break $if_then10$$lor_lhs_false$11; //@line 304 "setlengths.cpp"
      }
    } while(0);
    $if_then10$$if_end144$65: do { 
      if (__label__ == 10) {
  
        var $14=$wpm; //@line 170 "setlengths.cpp"
        $wpm2=$14; //@line 170 "setlengths.cpp"
        $wpm=175; //@line 171 "setlengths.cpp"
        $x=73; //@line 175 "setlengths.cpp"
        var $15=$control_addr; //@line 176 "setlengths.cpp"
        var $and11=($15) & 1; //@line 176 "setlengths.cpp"
        var $tobool12=((($and11))|0)!=0; //@line 176 "setlengths.cpp"
        if ($tobool12) { __label__ = 11;; } else { __label__ = 12;; } //@line 176 "setlengths.cpp"
        if (__label__ == 11) {
  
          var $16=$x; //@line 178 "setlengths.cpp"
          var $17=HEAP32[((_voice)>>2)]; //@line 178 "setlengths.cpp"
          var $speedf1=(($17+52)&4294967295); //@line 178 "setlengths.cpp"
          var $18=HEAP32[(($speedf1)>>2)]; //@line 178 "setlengths.cpp"
          var $mul14=((($18)*($16))&4294967295); //@line 178 "setlengths.cpp"
          var $div15=((((($mul14))|0)/256)|0); //@line 178 "setlengths.cpp"
          HEAP32[((__ZL6speed1)>>2)]=$div15; //@line 178 "setlengths.cpp"
          var $19=$x; //@line 179 "setlengths.cpp"
          var $20=HEAP32[((_voice)>>2)]; //@line 179 "setlengths.cpp"
          var $speedf2=(($20+56)&4294967295); //@line 179 "setlengths.cpp"
          var $21=HEAP32[(($speedf2)>>2)]; //@line 179 "setlengths.cpp"
          var $mul16=((($21)*($19))&4294967295); //@line 179 "setlengths.cpp"
          var $div17=((((($mul16))|0)/256)|0); //@line 179 "setlengths.cpp"
          HEAP32[((__ZL6speed2)>>2)]=$div17; //@line 179 "setlengths.cpp"
          var $22=$x; //@line 180 "setlengths.cpp"
          var $23=HEAP32[((_voice)>>2)]; //@line 180 "setlengths.cpp"
          var $speedf3=(($23+60)&4294967295); //@line 180 "setlengths.cpp"
          var $24=HEAP32[(($speedf3)>>2)]; //@line 180 "setlengths.cpp"
          var $mul18=((($24)*($22))&4294967295); //@line 180 "setlengths.cpp"
          var $div19=((((($mul18))|0)/256)|0); //@line 180 "setlengths.cpp"
          HEAP32[((__ZL6speed3)>>2)]=$div19; //@line 180 "setlengths.cpp"
          ; //@line 181 "setlengths.cpp"
        }
  
        var $25=$control_addr; //@line 182 "setlengths.cpp"
        var $and21=($25) & 2; //@line 182 "setlengths.cpp"
        var $tobool22=((($and21))|0)!=0; //@line 182 "setlengths.cpp"
        if (!($tobool22)) { __label__ = 51;break $if_then10$$if_end144$65; } //@line 182 "setlengths.cpp"
  
        var $26=$wpm2; //@line 184 "setlengths.cpp"
        var $conv=((($26))|0); //@line 184 "setlengths.cpp"
        var $27=$wpm; //@line 184 "setlengths.cpp"
        var $conv24=((($27))|0); //@line 184 "setlengths.cpp"
        var $div25=($conv)/($conv24); //@line 184 "setlengths.cpp"
        $sonic=$div25; //@line 184 "setlengths.cpp"
        var $28=$sonic; //@line 185 "setlengths.cpp"
        var $mul26=($28)*1024; //@line 185 "setlengths.cpp"
        var $conv27=((($mul26))|0); //@line 185 "setlengths.cpp"
        __Z12DoSonicSpeedi($conv27); //@line 185 "setlengths.cpp"
        HEAP32[((((_speed)&4294967295))>>2)]=85; //@line 186 "setlengths.cpp"
        HEAP32[((((_speed+4)&4294967295))>>2)]=80; //@line 187 "setlengths.cpp"
        HEAP32[((((_speed+8)&4294967295))>>2)]=22; //@line 188 "setlengths.cpp"
        HEAP32[((((_speed+24)&4294967295))>>2)]=900; //@line 189 "setlengths.cpp"
        HEAP32[((((_speed+12)&4294967295))>>2)]=211; //@line 190 "setlengths.cpp"
        HEAP32[((((_speed+16)&4294967295))>>2)]=210; //@line 191 "setlengths.cpp"
        HEAP32[((((_speed+20)&4294967295))>>2)]=170; //@line 192 "setlengths.cpp"
        ; //@line 193 "setlengths.cpp"
      }
    } while(0);
  
    ;
    return; //@line 312 "setlengths.cpp"
    return;
  }
  

  function __Z12SetParameteriii($parameter, $value, $relative) {
    ;
    var __label__;
  
    var $parameter_addr;
    var $value_addr;
    var $relative_addr;
    var $new_value;
    var $default_value;
    $parameter_addr=$parameter;
    $value_addr=$value;
    $relative_addr=$relative;
    var $0=$value_addr; //@line 334 "setlengths.cpp"
    $new_value=$0; //@line 334 "setlengths.cpp"
    var $1=$relative_addr; //@line 337 "setlengths.cpp"
    var $tobool=((($1))|0)!=0; //@line 337 "setlengths.cpp"
    if ($tobool) { __label__ = 1;; } else { __label__ = 3;; } //@line 337 "setlengths.cpp"
    $if_then$$if_end2$2: do { 
      if (__label__ == 1) {
  
        var $2=$parameter_addr; //@line 339 "setlengths.cpp"
        var $cmp=((($2))|0) < 5; //@line 339 "setlengths.cpp"
        if (!($cmp)) { __label__ = 3;break $if_then$$if_end2$2; } //@line 339 "setlengths.cpp"
  
        var $3=$parameter_addr; //@line 341 "setlengths.cpp"
        var $arrayidx=((_param_defaults+$3*4)&4294967295); //@line 341 "setlengths.cpp"
        var $4=HEAP32[(($arrayidx)>>2)]; //@line 341 "setlengths.cpp"
        $default_value=$4; //@line 341 "setlengths.cpp"
        var $5=$default_value; //@line 342 "setlengths.cpp"
        var $6=$default_value; //@line 342 "setlengths.cpp"
        var $7=$value_addr; //@line 342 "setlengths.cpp"
        var $mul=((($7)*($6))&4294967295); //@line 342 "setlengths.cpp"
        var $div=((((($mul))|0)/100)|0); //@line 342 "setlengths.cpp"
        var $add=((($div)+($5))&4294967295); //@line 342 "setlengths.cpp"
        $new_value=$add; //@line 342 "setlengths.cpp"
        ; //@line 343 "setlengths.cpp"
      }
    } while(0);
  
    var $8=$new_value; //@line 345 "setlengths.cpp"
    var $9=$parameter_addr; //@line 345 "setlengths.cpp"
    var $arrayidx3=((((_param_stack+4)&4294967295)+$9*4)&4294967295); //@line 345 "setlengths.cpp"
    HEAP32[(($arrayidx3)>>2)]=$8; //@line 345 "setlengths.cpp"
    var $10=$parameter_addr; //@line 347 "setlengths.cpp"
    if ($10 == 1) {
      __label__ = 4;;
    }
    else if ($10 == 2) {
      __label__ = 5;;
    }
    else if ($10 == 3) {
      __label__ = 6;;
    }
    else if ($10 == 4) {
      __label__ = 11;;
    }
    else if ($10 == 13) {
      __label__ = 14;;
    }
    else if ($10 == 7) {
      __label__ = 15;;
    }
    else if ($10 == 9) {
      __label__ = 16;;
    }
    else {
    __label__ = 19;;
    }
    
    if (__label__ == 4) {
  
      var $11=$new_value; //@line 350 "setlengths.cpp"
      HEAP32[((((_embedded_value+8)&4294967295))>>2)]=$11; //@line 350 "setlengths.cpp"
      var $12=$new_value; //@line 351 "setlengths.cpp"
      HEAP32[((((_embedded_value+32)&4294967295))>>2)]=$12; //@line 351 "setlengths.cpp"
      __Z8SetSpeedi(3); //@line 352 "setlengths.cpp"
      ; //@line 353 "setlengths.cpp"
    }
    else if (__label__ == 5) {
  
      var $13=$new_value; //@line 356 "setlengths.cpp"
      HEAP32[((((_embedded_value+12)&4294967295))>>2)]=$13; //@line 356 "setlengths.cpp"
      var $call=__Z12GetAmplitudev(); //@line 357 "setlengths.cpp"
      ; //@line 358 "setlengths.cpp"
    }
    else if (__label__ == 6) {
  
      var $14=$new_value; //@line 361 "setlengths.cpp"
      var $cmp6=((($14))|0) > 99; //@line 361 "setlengths.cpp"
      if ($cmp6) { __label__ = 7;; } else { __label__ = 8;; } //@line 361 "setlengths.cpp"
      $if_end8_thread$$if_end8$10: do { 
        if (__label__ == 7) {
  
          $new_value=99; //@line 361 "setlengths.cpp"
          ; //@line 362 "setlengths.cpp"
        }
        else if (__label__ == 8) {
  
          var $cmp9=((($14))|0) < 0; //@line 362 "setlengths.cpp"
          if (!($cmp9)) { __label__ = 10;break $if_end8_thread$$if_end8$10; } //@line 362 "setlengths.cpp"
  
          $new_value=0; //@line 362 "setlengths.cpp"
          ; //@line 362 "setlengths.cpp"
        }
      } while(0);
  
      var $15=$new_value; //@line 363 "setlengths.cpp"
      HEAP32[((((_embedded_value+4)&4294967295))>>2)]=$15; //@line 363 "setlengths.cpp"
      ; //@line 364 "setlengths.cpp"
    }
    else if (__label__ == 11) {
  
      var $16=$new_value; //@line 367 "setlengths.cpp"
      var $cmp13=((($16))|0) > 99; //@line 367 "setlengths.cpp"
      if ($cmp13) { __label__ = 12;; } else { __label__ = 13;; } //@line 367 "setlengths.cpp"
      if (__label__ == 12) {
  
        $new_value=99; //@line 367 "setlengths.cpp"
        ; //@line 367 "setlengths.cpp"
      }
  
      var $17=$new_value; //@line 368 "setlengths.cpp"
      HEAP32[((((_embedded_value+16)&4294967295))>>2)]=$17; //@line 368 "setlengths.cpp"
      ; //@line 369 "setlengths.cpp"
    }
    else if (__label__ == 14) {
  
      var $18=$new_value; //@line 372 "setlengths.cpp"
      HEAP32[((_option_linelength)>>2)]=$18; //@line 372 "setlengths.cpp"
      ; //@line 373 "setlengths.cpp"
    }
    else if (__label__ == 15) {
  
      var $19=$new_value; //@line 376 "setlengths.cpp"
      HEAP32[((_option_wordgap)>>2)]=$19; //@line 376 "setlengths.cpp"
      ; //@line 377 "setlengths.cpp"
    }
    else if (__label__ == 16) {
  
      var $20=$new_value; //@line 380 "setlengths.cpp"
      var $and=($20) & 255; //@line 380 "setlengths.cpp"
      var $cmp19=((($and))|0)!=0; //@line 380 "setlengths.cpp"
      if ($cmp19) { __label__ = 17;; } else { __label__ = 18;; } //@line 380 "setlengths.cpp"
      if (__label__ == 17) {
  
        var $21=$new_value; //@line 381 "setlengths.cpp"
        var $and21=($21) & 255; //@line 381 "setlengths.cpp"
        var $22=HEAP32[((_translator)>>2)]; //@line 381 "setlengths.cpp"
        var $langopts=(($22)&4294967295); //@line 381 "setlengths.cpp"
        var $intonation_group=(($langopts+228)&4294967295); //@line 381 "setlengths.cpp"
        HEAP32[(($intonation_group)>>2)]=$and21; //@line 381 "setlengths.cpp"
        ; //@line 381 "setlengths.cpp"
      }
  
      var $23=$new_value; //@line 382 "setlengths.cpp"
      HEAP32[((_option_tone_flags)>>2)]=$23; //@line 382 "setlengths.cpp"
      ; //@line 383 "setlengths.cpp"
    }
  
    ;
    return; //@line 388 "setlengths.cpp"
    return;
  }
  

  function __Z11CalcLengthsP10Translator($tr) {
    var __stackBase__  = STACKTOP; STACKTOP += 156; _memset(__stackBase__, 0, 156);
    var __label__;
    var __lastLabel__ = null;
  
    var $tr_addr;
    var $ix;
    var $ix2;
    var $prev;
    var $next;
    var $next2;
    var $next3;
    var $p;
    var $p2;
    var $stress;
    var $type;
    var $pre_sonorant;
    var $pre_voiced;
    var $last_pitch;
    var $pitch_start;
    var $length_mod;
    var $len;
    var $env2;
    var $end_of_clause;
    var $embedded_ix=__stackBase__;
    var $min_drop;
    var $pitch1;
    var $emphasized;
    var $tone_mod;
    var $pitch_env;
    var $phdata_tone=__stackBase__+4;
    $tr_addr=$tr;
    $pre_sonorant=0; //@line 425 "setlengths.cpp"
    $pre_voiced=0; //@line 426 "setlengths.cpp"
    $last_pitch=0; //@line 427 "setlengths.cpp"
    HEAP32[(($embedded_ix)>>2)]=0; //@line 433 "setlengths.cpp"
    $pitch_env=0; //@line 438 "setlengths.cpp"
    $ix=1; //@line 441 "setlengths.cpp"
    var $0=$ix; //@line 441 "setlengths.cpp"
    var $1=HEAP32[((_n_phoneme_list)>>2)]; //@line 441 "setlengths.cpp"
    var $cmp7=((($0))|0) < ((($1))|0); //@line 441 "setlengths.cpp"
    if ($cmp7) { __label__ = 1;; } else { __label__ = 193;; } //@line 441 "setlengths.cpp"
    $for_body_lr_ph$$for_end733$2: do { 
      if (__label__ == 1) {
  
        var $pitch_env595=(($phdata_tone+124)&4294967295); //@line 779 "setlengths.cpp"
        ; //@line 441 "setlengths.cpp"
        $for_body$4: while(1) { 
  
          var $2=$ix; //@line 443 "setlengths.cpp"
          var $sub=((($2)-1)&4294967295); //@line 443 "setlengths.cpp"
          var $arrayidx=((_phoneme_list+$sub*24)&4294967295); //@line 443 "setlengths.cpp"
          $prev=$arrayidx; //@line 443 "setlengths.cpp"
          var $3=$ix; //@line 444 "setlengths.cpp"
          var $arrayidx1=((_phoneme_list+$3*24)&4294967295); //@line 444 "setlengths.cpp"
          $p=$arrayidx1; //@line 444 "setlengths.cpp"
          var $4=$p; //@line 445 "setlengths.cpp"
          var $stresslevel=(($4+1)&4294967295); //@line 445 "setlengths.cpp"
          var $5=HEAPU8[($stresslevel)]; //@line 445 "setlengths.cpp"
          var $conv=((($5))&255); //@line 445 "setlengths.cpp"
          var $and=($conv) & 7; //@line 445 "setlengths.cpp"
          $stress=$and; //@line 445 "setlengths.cpp"
          var $6=$p; //@line 446 "setlengths.cpp"
          var $stresslevel2=(($6+1)&4294967295); //@line 446 "setlengths.cpp"
          var $7=HEAPU8[($stresslevel2)]; //@line 446 "setlengths.cpp"
          var $conv3=((($7))&255); //@line 446 "setlengths.cpp"
          var $and4=($conv3) & 8; //@line 446 "setlengths.cpp"
          $emphasized=$and4; //@line 446 "setlengths.cpp"
          var $8=$ix; //@line 448 "setlengths.cpp"
          var $add=((($8)+1)&4294967295); //@line 448 "setlengths.cpp"
          var $arrayidx5=((_phoneme_list+$add*24)&4294967295); //@line 448 "setlengths.cpp"
          $next=$arrayidx5; //@line 448 "setlengths.cpp"
          var $9=$p; //@line 450 "setlengths.cpp"
          var $synthflags=(($9+4)&4294967295); //@line 450 "setlengths.cpp"
          var $10=HEAPU16[(($synthflags)>>1)]; //@line 450 "setlengths.cpp"
          var $conv6=((($10))&65535); //@line 450 "setlengths.cpp"
          var $and7=($conv6) & 2; //@line 450 "setlengths.cpp"
          var $tobool=((($and7))|0)!=0; //@line 450 "setlengths.cpp"
          if ($tobool) { __label__ = 3;; } else { __label__ = 4;; } //@line 450 "setlengths.cpp"
          if (__label__ == 3) {
  
            __ZL11DoEmbedded2Pi($embedded_ix); //@line 452 "setlengths.cpp"
            ; //@line 453 "setlengths.cpp"
          }
  
          var $11=$p; //@line 455 "setlengths.cpp"
          var $type8=(($11+15)&4294967295); //@line 455 "setlengths.cpp"
          var $12=HEAPU8[($type8)]; //@line 455 "setlengths.cpp"
          var $conv9=((($12))&255); //@line 455 "setlengths.cpp"
          $type=$conv9; //@line 455 "setlengths.cpp"
          var $13=$p; //@line 456 "setlengths.cpp"
          var $synthflags10=(($13+4)&4294967295); //@line 456 "setlengths.cpp"
          var $14=HEAPU16[(($synthflags10)>>1)]; //@line 456 "setlengths.cpp"
          var $conv11=((($14))&65535); //@line 456 "setlengths.cpp"
          var $and12=($conv11) & 4; //@line 456 "setlengths.cpp"
          var $tobool13=((($and12))|0)!=0; //@line 456 "setlengths.cpp"
          if ($tobool13) { __label__ = 5;; } else { __label__ = 6;; } //@line 456 "setlengths.cpp"
          $if_end15_thread$$if_end15$9: do { 
            if (__label__ == 5) {
  
              $type=2; //@line 457 "setlengths.cpp"
              __label__ = 98;break $if_end15_thread$$if_end15$9; //@line 459 "setlengths.cpp"
            }
            else if (__label__ == 6) {
  
              var $_pr=$type; //@line 459 "setlengths.cpp"
              if ($_pr == 0) {
                __label__ = 7;;
              }
              else if ($_pr == 4) {
                __label__ = 8;;
              }
              else if ($_pr == 7) {
                __label__ = 23;;
              }
              else if ($_pr == 6) {
                __label__ = 23;;
              }
              else if ($_pr == 5) {
                __label__ = 49;;
              }
              else if ($_pr == 3) {
                __label__ = 74;;
              }
              else if ($_pr == 8) {
                __label__ = 74;;
              }
              else if ($_pr == 2) {
                __label__ = 98;break $if_end15_thread$$if_end15$9;
              }
              else {
              __label__ = 192;break $if_end15_thread$$if_end15$9;
              }
              
              if (__label__ == 7) {
  
                $last_pitch=0; //@line 462 "setlengths.cpp"
                __label__ = 192;break $if_end15_thread$$if_end15$9; //@line 463 "setlengths.cpp"
              }
              else if (__label__ == 8) {
  
                $last_pitch=0; //@line 466 "setlengths.cpp"
                var $15=$prev; //@line 467 "setlengths.cpp"
                var $type17=(($15+15)&4294967295); //@line 467 "setlengths.cpp"
                var $16=HEAPU8[($type17)]; //@line 467 "setlengths.cpp"
                var $conv18=((($16))&255); //@line 467 "setlengths.cpp"
                var $cmp19=((($conv18))|0)==6; //@line 467 "setlengths.cpp"
                if ($cmp19) { __label__ = 9;; } else { __label__ = 10;; } //@line 467 "setlengths.cpp"
                $if_then20$$if_else$15: do { 
                  if (__label__ == 9) {
  
                    var $17=$p; //@line 468 "setlengths.cpp"
                    var $prepause=(($17+16)&4294967295); //@line 468 "setlengths.cpp"
                    HEAP8[($prepause)]=25; //@line 468 "setlengths.cpp"
                    ; //@line 468 "setlengths.cpp"
                  }
                  else if (__label__ == 10) {
  
                    var $18=HEAP32[((__ZZ11CalcLengthsP10TranslatorE14more_syllables)>>2)]; //@line 470 "setlengths.cpp"
                    var $cmp21=((($18))|0) > 0; //@line 470 "setlengths.cpp"
                    if ($cmp21) { __label__ = 12;; } else { __label__ = 11;; } //@line 470 "setlengths.cpp"
                    $if_then23$$lor_lhs_false$18: do { 
                      if (__label__ == 11) {
  
                        var $19=$stress; //@line 470 "setlengths.cpp"
                        var $cmp22=((($19))|0) < 4; //@line 470 "setlengths.cpp"
                        if ($cmp22) { __label__ = 12;break $if_then23$$lor_lhs_false$18; } //@line 470 "setlengths.cpp"
  
                        var $21=$p; //@line 473 "setlengths.cpp"
                        var $prepause26=(($21+16)&4294967295); //@line 473 "setlengths.cpp"
                        HEAP8[($prepause26)]=60; //@line 473 "setlengths.cpp"
                        __label__ = 14;break $if_then20$$if_else$15;
                      }
                    } while(0);
  
                    var $20=$p; //@line 471 "setlengths.cpp"
                    var $prepause24=(($20+16)&4294967295); //@line 471 "setlengths.cpp"
                    HEAP8[($prepause24)]=48; //@line 471 "setlengths.cpp"
                    ; //@line 471 "setlengths.cpp"
                  }
                } while(0);
  
                var $22=$prev; //@line 475 "setlengths.cpp"
                var $type29=(($22+15)&4294967295); //@line 475 "setlengths.cpp"
                var $23=HEAPU8[($type29)]; //@line 475 "setlengths.cpp"
                var $conv30=((($23))&255); //@line 475 "setlengths.cpp"
                var $cmp31=((($conv30))|0)==4; //@line 475 "setlengths.cpp"
                if ($cmp31) { __label__ = 15;; } else { __label__ = 16;; } //@line 475 "setlengths.cpp"
                if (__label__ == 15) {
  
                  var $24=$p; //@line 476 "setlengths.cpp"
                  var $prepause33=(($24+16)&4294967295); //@line 476 "setlengths.cpp"
                  HEAP8[($prepause33)]=60; //@line 476 "setlengths.cpp"
                  ; //@line 476 "setlengths.cpp"
                }
  
                var $25=$tr_addr; //@line 478 "setlengths.cpp"
                var $langopts=(($25)&4294967295); //@line 478 "setlengths.cpp"
                var $word_gap=(($langopts)&4294967295); //@line 478 "setlengths.cpp"
                var $26=HEAP32[(($word_gap)>>2)]; //@line 478 "setlengths.cpp"
                var $and35=($26) & 16; //@line 478 "setlengths.cpp"
                var $tobool36=((($and35))|0)!=0; //@line 478 "setlengths.cpp"
                if ($tobool36) { __label__ = 17;; } else { __label__ = 19;; } //@line 478 "setlengths.cpp"
                $land_lhs_true$$if_end40$26: do { 
                  if (__label__ == 17) {
  
                    var $27=$p; //@line 478 "setlengths.cpp"
                    var $newword=(($27+19)&4294967295); //@line 478 "setlengths.cpp"
                    var $28=HEAP8[($newword)]; //@line 478 "setlengths.cpp"
                    var $tobool37=(tempInt=(($28)),(tempInt>=128?tempInt-256:tempInt))!=0; //@line 478 "setlengths.cpp"
                    if (!($tobool37)) { __label__ = 19;break $land_lhs_true$$if_end40$26; } //@line 478 "setlengths.cpp"
  
                    var $29=$p; //@line 479 "setlengths.cpp"
                    var $prepause39=(($29+16)&4294967295); //@line 479 "setlengths.cpp"
                    HEAP8[($prepause39)]=60; //@line 479 "setlengths.cpp"
                    ; //@line 479 "setlengths.cpp"
                  }
                } while(0);
  
                var $30=$p; //@line 481 "setlengths.cpp"
                var $ph=(($30+8)&4294967295); //@line 481 "setlengths.cpp"
                var $31=HEAP32[(($ph)>>2)]; //@line 481 "setlengths.cpp"
                var $phflags=(($31+4)&4294967295); //@line 481 "setlengths.cpp"
                var $32=HEAP32[(($phflags)>>2)]; //@line 481 "setlengths.cpp"
                var $and41=($32) & 4194304; //@line 481 "setlengths.cpp"
                var $tobool42=((($and41))|0)!=0; //@line 481 "setlengths.cpp"
                if ($tobool42) { __label__ = 20;; } else { __label__ = 21;; } //@line 481 "setlengths.cpp"
                if (__label__ == 20) {
  
                  var $33=$p; //@line 482 "setlengths.cpp"
                  var $prepause44=(($33+16)&4294967295); //@line 482 "setlengths.cpp"
                  var $34=HEAPU8[($prepause44)]; //@line 482 "setlengths.cpp"
                  var $conv45=((($34))&255); //@line 482 "setlengths.cpp"
                  var $add46=((($conv45)+30)&4294967295); //@line 482 "setlengths.cpp"
                  var $conv47=((($add46)) & 255); //@line 482 "setlengths.cpp"
                  HEAP8[($prepause44)]=$conv47; //@line 482 "setlengths.cpp"
                  ; //@line 482 "setlengths.cpp"
                }
  
                var $35=$p; //@line 484 "setlengths.cpp"
                var $synthflags49=(($35+4)&4294967295); //@line 484 "setlengths.cpp"
                var $36=HEAPU16[(($synthflags49)>>1)]; //@line 484 "setlengths.cpp"
                var $conv50=((($36))&65535); //@line 484 "setlengths.cpp"
                var $and51=($conv50) & 8; //@line 484 "setlengths.cpp"
                var $tobool52=((($and51))|0)!=0; //@line 484 "setlengths.cpp"
                if (!($tobool52)) { __label__ = 192;break $if_end15_thread$$if_end15$9; } //@line 484 "setlengths.cpp"
  
                var $37=$tr_addr; //@line 485 "setlengths.cpp"
                var $langopts54=(($37)&4294967295); //@line 485 "setlengths.cpp"
                var $long_stop=(($langopts54+240)&4294967295); //@line 485 "setlengths.cpp"
                var $38=HEAP32[(($long_stop)>>2)]; //@line 485 "setlengths.cpp"
                var $39=$p; //@line 485 "setlengths.cpp"
                var $prepause55=(($39+16)&4294967295); //@line 485 "setlengths.cpp"
                var $40=HEAPU8[($prepause55)]; //@line 485 "setlengths.cpp"
                var $conv56=((($40))&255); //@line 485 "setlengths.cpp"
                var $add57=((($conv56)+($38))&4294967295); //@line 485 "setlengths.cpp"
                var $conv58=((($add57)) & 255); //@line 485 "setlengths.cpp"
                HEAP8[($prepause55)]=$conv58; //@line 485 "setlengths.cpp"
                __label__ = 192;break $if_end15_thread$$if_end15$9; //@line 485 "setlengths.cpp"
              }
              else if (__label__ == 23) {
  
                var $41=$p; //@line 490 "setlengths.cpp"
                var $newword61=(($41+19)&4294967295); //@line 490 "setlengths.cpp"
                var $42=HEAP8[($newword61)]; //@line 490 "setlengths.cpp"
                var $tobool62=(tempInt=(($42)),(tempInt>=128?tempInt-256:tempInt))!=0; //@line 490 "setlengths.cpp"
                if ($tobool62) { __label__ = 24;; } else { __label__ = 27;; } //@line 490 "setlengths.cpp"
                $if_then63$$if_end76$35: do { 
                  if (__label__ == 24) {
  
                    var $43=$prev; //@line 492 "setlengths.cpp"
                    var $type64=(($43+15)&4294967295); //@line 492 "setlengths.cpp"
                    var $44=HEAPU8[($type64)]; //@line 492 "setlengths.cpp"
                    var $conv65=((($44))&255); //@line 492 "setlengths.cpp"
                    var $cmp66=((($conv65))|0)==2; //@line 492 "setlengths.cpp"
                    if ($cmp66) { __label__ = 25;; } else { __label__ = 26;; } //@line 492 "setlengths.cpp"
                    if (__label__ == 25) {
  
                      var $45=$p; //@line 492 "setlengths.cpp"
                      var $ph68=(($45+8)&4294967295); //@line 492 "setlengths.cpp"
                      var $46=HEAP32[(($ph68)>>2)]; //@line 492 "setlengths.cpp"
                      var $phflags69=(($46+4)&4294967295); //@line 492 "setlengths.cpp"
                      var $47=HEAP32[(($phflags69)>>2)]; //@line 492 "setlengths.cpp"
                      var $and70=($47) & 16777216; //@line 492 "setlengths.cpp"
                      var $tobool71=((($and70))|0)!=0; //@line 492 "setlengths.cpp"
                      if ($tobool71) { __label__ = 27;break $if_then63$$if_end76$35; } //@line 492 "setlengths.cpp"
                    }
  
                    var $48=$p; //@line 497 "setlengths.cpp"
                    var $prepause74=(($48+16)&4294967295); //@line 497 "setlengths.cpp"
                    HEAP8[($prepause74)]=15; //@line 497 "setlengths.cpp"
                    ;
                  }
                } while(0);
  
                var $49=$next; //@line 501 "setlengths.cpp"
                var $type77=(($49+15)&4294967295); //@line 501 "setlengths.cpp"
                var $50=HEAPU8[($type77)]; //@line 501 "setlengths.cpp"
                var $conv78=((($50))&255); //@line 501 "setlengths.cpp"
                var $cmp79=((($conv78))|0)==0; //@line 501 "setlengths.cpp"
                if ($cmp79) { __label__ = 28;; } else { __label__ = 31;; } //@line 501 "setlengths.cpp"
                $land_lhs_true80$$if_end91$41: do { 
                  if (__label__ == 28) {
  
                    var $51=$prev; //@line 501 "setlengths.cpp"
                    var $type81=(($51+15)&4294967295); //@line 501 "setlengths.cpp"
                    var $52=HEAPU8[($type81)]; //@line 501 "setlengths.cpp"
                    var $conv82=((($52))&255); //@line 501 "setlengths.cpp"
                    var $cmp83=((($conv82))|0)==8; //@line 501 "setlengths.cpp"
                    if (!($cmp83)) { __label__ = 31;break $land_lhs_true80$$if_end91$41; } //@line 501 "setlengths.cpp"
  
                    var $53=$p; //@line 501 "setlengths.cpp"
                    var $ph85=(($53+8)&4294967295); //@line 501 "setlengths.cpp"
                    var $54=HEAP32[(($ph85)>>2)]; //@line 501 "setlengths.cpp"
                    var $phflags86=(($54+4)&4294967295); //@line 501 "setlengths.cpp"
                    var $55=HEAP32[(($phflags86)>>2)]; //@line 501 "setlengths.cpp"
                    var $and87=($55) & 8; //@line 501 "setlengths.cpp"
                    var $tobool88=((($and87))|0)!=0; //@line 501 "setlengths.cpp"
                    if ($tobool88) { __label__ = 31;break $land_lhs_true80$$if_end91$41; } //@line 501 "setlengths.cpp"
  
                    var $56=$p; //@line 502 "setlengths.cpp"
                    var $prepause90=(($56+16)&4294967295); //@line 502 "setlengths.cpp"
                    HEAP8[($prepause90)]=25; //@line 502 "setlengths.cpp"
                    ; //@line 502 "setlengths.cpp"
                  }
                } while(0);
  
                var $57=$prev; //@line 504 "setlengths.cpp"
                var $ph92=(($57+8)&4294967295); //@line 504 "setlengths.cpp"
                var $58=HEAP32[(($ph92)>>2)]; //@line 504 "setlengths.cpp"
                var $phflags93=(($58+4)&4294967295); //@line 504 "setlengths.cpp"
                var $59=HEAP32[(($phflags93)>>2)]; //@line 504 "setlengths.cpp"
                var $and94=($59) & 16384; //@line 504 "setlengths.cpp"
                var $tobool95=((($and94))|0)!=0; //@line 504 "setlengths.cpp"
                if ($tobool95) { __label__ = 32;; } else { __label__ = 33;; } //@line 504 "setlengths.cpp"
                if (__label__ == 32) {
  
                  var $60=$p; //@line 505 "setlengths.cpp"
                  var $prepause97=(($60+16)&4294967295); //@line 505 "setlengths.cpp"
                  HEAP8[($prepause97)]=30; //@line 505 "setlengths.cpp"
                  ; //@line 505 "setlengths.cpp"
                }
  
                var $61=$tr_addr; //@line 507 "setlengths.cpp"
                var $langopts99=(($61)&4294967295); //@line 507 "setlengths.cpp"
                var $word_gap100=(($langopts99)&4294967295); //@line 507 "setlengths.cpp"
                var $62=HEAP32[(($word_gap100)>>2)]; //@line 507 "setlengths.cpp"
                var $and101=($62) & 16; //@line 507 "setlengths.cpp"
                var $tobool102=((($and101))|0)!=0; //@line 507 "setlengths.cpp"
                if ($tobool102) { __label__ = 34;; } else { __label__ = 36;; } //@line 507 "setlengths.cpp"
                $land_lhs_true103$$if_end108$49: do { 
                  if (__label__ == 34) {
  
                    var $63=$p; //@line 507 "setlengths.cpp"
                    var $newword104=(($63+19)&4294967295); //@line 507 "setlengths.cpp"
                    var $64=HEAP8[($newword104)]; //@line 507 "setlengths.cpp"
                    var $tobool105=(tempInt=(($64)),(tempInt>=128?tempInt-256:tempInt))!=0; //@line 507 "setlengths.cpp"
                    if (!($tobool105)) { __label__ = 36;break $land_lhs_true103$$if_end108$49; } //@line 507 "setlengths.cpp"
  
                    var $65=$p; //@line 508 "setlengths.cpp"
                    var $prepause107=(($65+16)&4294967295); //@line 508 "setlengths.cpp"
                    HEAP8[($prepause107)]=30; //@line 508 "setlengths.cpp"
                    ; //@line 508 "setlengths.cpp"
                  }
                } while(0);
  
                var $66=$p; //@line 510 "setlengths.cpp"
                var $ph109=(($66+8)&4294967295); //@line 510 "setlengths.cpp"
                var $67=HEAP32[(($ph109)>>2)]; //@line 510 "setlengths.cpp"
                var $phflags110=(($67+4)&4294967295); //@line 510 "setlengths.cpp"
                var $68=HEAP32[(($phflags110)>>2)]; //@line 510 "setlengths.cpp"
                var $and111=($68) & 32; //@line 510 "setlengths.cpp"
                var $tobool112=((($and111))|0)!=0; //@line 510 "setlengths.cpp"
                if ($tobool112) { __label__ = 37;; } else { __label__ = 42;; } //@line 510 "setlengths.cpp"
                $land_lhs_true113$$if_else128$53: do { 
                  if (__label__ == 37) {
  
                    var $69=$next; //@line 510 "setlengths.cpp"
                    var $type114=(($69+15)&4294967295); //@line 510 "setlengths.cpp"
                    var $70=HEAPU8[($type114)]; //@line 510 "setlengths.cpp"
                    var $conv115=((($70))&255); //@line 510 "setlengths.cpp"
                    var $cmp116=((($conv115))|0)==4; //@line 510 "setlengths.cpp"
                    if (!($cmp116)) { __label__ = 42;break $land_lhs_true113$$if_else128$53; } //@line 510 "setlengths.cpp"
  
                    var $71=$next; //@line 510 "setlengths.cpp"
                    var $newword118=(($71+19)&4294967295); //@line 510 "setlengths.cpp"
                    var $72=HEAP8[($newword118)]; //@line 510 "setlengths.cpp"
                    var $tobool119=(tempInt=(($72)),(tempInt>=128?tempInt-256:tempInt))!=0; //@line 510 "setlengths.cpp"
                    if ($tobool119) { __label__ = 42;break $land_lhs_true113$$if_else128$53; } //@line 510 "setlengths.cpp"
  
                    var $73=$prev; //@line 512 "setlengths.cpp"
                    var $type121=(($73+15)&4294967295); //@line 512 "setlengths.cpp"
                    var $74=HEAPU8[($type121)]; //@line 512 "setlengths.cpp"
                    var $conv122=((($74))&255); //@line 512 "setlengths.cpp"
                    var $cmp123=((($conv122))|0)==2; //@line 512 "setlengths.cpp"
                    var $75=$p; //@line 513 "setlengths.cpp"
                    var $length=(($75+12)&4294967295); //@line 513 "setlengths.cpp"
                    if ($cmp123) { __label__ = 40;; } else { __label__ = 41;; } //@line 512 "setlengths.cpp"
                    if (__label__ == 40) {
  
                      HEAP16[(($length)>>1)]=200; //@line 513 "setlengths.cpp"
                      __label__ = 43;break $land_lhs_true113$$if_else128$53; //@line 513 "setlengths.cpp"
                    }
                    else if (__label__ == 41) {
  
                      HEAP16[(($length)>>1)]=150; //@line 515 "setlengths.cpp"
                      __label__ = 43;break $land_lhs_true113$$if_else128$53;
                    }
                  }
                } while(0);
                if (__label__ == 42) {
  
                  var $76=$p; //@line 518 "setlengths.cpp"
                  var $length129=(($76+12)&4294967295); //@line 518 "setlengths.cpp"
                  HEAP16[(($length129)>>1)]=256; //@line 518 "setlengths.cpp"
                  ;
                }
  
                var $77=$type; //@line 520 "setlengths.cpp"
                var $cmp131=((($77))|0)==7; //@line 520 "setlengths.cpp"
                if (!($cmp131)) { __label__ = 192;break $if_end15_thread$$if_end15$9; } //@line 520 "setlengths.cpp"
  
                var $78=$next; //@line 522 "setlengths.cpp"
                var $type133=(($78+15)&4294967295); //@line 522 "setlengths.cpp"
                var $79=HEAPU8[($type133)]; //@line 522 "setlengths.cpp"
                var $conv134=((($79))&255); //@line 522 "setlengths.cpp"
                var $cmp135=((($conv134))|0)==2; //@line 522 "setlengths.cpp"
                if ($cmp135) { __label__ = 45;; } else { __label__ = 46;; } //@line 522 "setlengths.cpp"
                if (__label__ == 45) {
  
                  $pre_voiced=1; //@line 524 "setlengths.cpp"
                  ; //@line 525 "setlengths.cpp"
                }
  
                var $80=$prev; //@line 526 "setlengths.cpp"
                var $type138=(($80+15)&4294967295); //@line 526 "setlengths.cpp"
                var $81=HEAPU8[($type138)]; //@line 526 "setlengths.cpp"
                var $conv139=((($81))&255); //@line 526 "setlengths.cpp"
                var $cmp140=((($conv139))|0)==2; //@line 526 "setlengths.cpp"
                if ($cmp140) { __label__ = 48;; } else { __label__ = 47;; } //@line 526 "setlengths.cpp"
                if (__label__ == 47) {
  
                  var $82=$prev; //@line 526 "setlengths.cpp"
                  var $type142=(($82+15)&4294967295); //@line 526 "setlengths.cpp"
                  var $83=HEAPU8[($type142)]; //@line 526 "setlengths.cpp"
                  var $conv143=((($83))&255); //@line 526 "setlengths.cpp"
                  var $cmp144=((($conv143))|0)==3; //@line 526 "setlengths.cpp"
                  if (!($cmp144)) { __label__ = 192;break $if_end15_thread$$if_end15$9; } //@line 526 "setlengths.cpp"
                }
  
                var $84=$prev; //@line 528 "setlengths.cpp"
                var $length146=(($84+12)&4294967295); //@line 528 "setlengths.cpp"
                var $85=HEAP16[(($length146)>>1)]; //@line 528 "setlengths.cpp"
                var $conv147=(tempInt=(($85)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 528 "setlengths.cpp"
                var $add148=((($conv147)+255)&4294967295); //@line 528 "setlengths.cpp"
                var $div=((((($add148))|0)/2)|0); //@line 528 "setlengths.cpp"
                var $conv149=((($div)) & 65535); //@line 528 "setlengths.cpp"
                var $86=$p; //@line 528 "setlengths.cpp"
                var $length150=(($86+12)&4294967295); //@line 528 "setlengths.cpp"
                HEAP16[(($length150)>>1)]=$conv149; //@line 528 "setlengths.cpp"
                __label__ = 192;break $if_end15_thread$$if_end15$9; //@line 529 "setlengths.cpp"
              }
              else if (__label__ == 49) {
  
                var $87=$prev; //@line 534 "setlengths.cpp"
                var $type154=(($87+15)&4294967295); //@line 534 "setlengths.cpp"
                var $88=HEAPU8[($type154)]; //@line 534 "setlengths.cpp"
                var $conv155=((($88))&255); //@line 534 "setlengths.cpp"
                var $cmp156=((($conv155))|0)==7; //@line 534 "setlengths.cpp"
                if ($cmp156) { __label__ = 53;; } else { __label__ = 50;; } //@line 534 "setlengths.cpp"
                $if_then170$$lor_lhs_false157$71: do { 
                  if (__label__ == 50) {
  
                    var $89=$prev; //@line 534 "setlengths.cpp"
                    var $type158=(($89+15)&4294967295); //@line 534 "setlengths.cpp"
                    var $90=HEAPU8[($type158)]; //@line 534 "setlengths.cpp"
                    var $conv159=((($90))&255); //@line 534 "setlengths.cpp"
                    var $cmp160=((($conv159))|0)==6; //@line 534 "setlengths.cpp"
                    if ($cmp160) { __label__ = 53;break $if_then170$$lor_lhs_false157$71; } //@line 534 "setlengths.cpp"
  
                    var $91=$prev; //@line 534 "setlengths.cpp"
                    var $ph162=(($91+8)&4294967295); //@line 534 "setlengths.cpp"
                    var $92=HEAP32[(($ph162)>>2)]; //@line 534 "setlengths.cpp"
                    var $phflags163=(($92+4)&4294967295); //@line 534 "setlengths.cpp"
                    var $93=HEAP32[(($phflags163)>>2)]; //@line 534 "setlengths.cpp"
                    var $and164=($93) & 32; //@line 534 "setlengths.cpp"
                    var $tobool165=((($and164))|0)!=0; //@line 534 "setlengths.cpp"
                    if ($tobool165) { __label__ = 53;break $if_then170$$lor_lhs_false157$71; } //@line 534 "setlengths.cpp"
  
                    var $94=$prev; //@line 534 "setlengths.cpp"
                    var $type167=(($94+15)&4294967295); //@line 534 "setlengths.cpp"
                    var $95=HEAPU8[($type167)]; //@line 534 "setlengths.cpp"
                    var $conv168=((($95))&255); //@line 534 "setlengths.cpp"
                    var $cmp169=((($conv168))|0)==3; //@line 534 "setlengths.cpp"
                    if ($cmp169) { __label__ = 53;break $if_then170$$lor_lhs_false157$71; } else { __label__ = 54;break $if_then170$$lor_lhs_false157$71; } //@line 534 "setlengths.cpp"
                  }
                } while(0);
                if (__label__ == 53) {
  
                  var $96=$p; //@line 535 "setlengths.cpp"
                  var $prepause171=(($96+16)&4294967295); //@line 535 "setlengths.cpp"
                  HEAP8[($prepause171)]=30; //@line 535 "setlengths.cpp"
                  ; //@line 535 "setlengths.cpp"
                }
  
                var $97=$next; //@line 537 "setlengths.cpp"
                var $type173=(($97+15)&4294967295); //@line 537 "setlengths.cpp"
                var $98=HEAPU8[($type173)]; //@line 537 "setlengths.cpp"
                var $conv174=((($98))&255); //@line 537 "setlengths.cpp"
                var $cmp175=((($conv174))|0)==2; //@line 537 "setlengths.cpp"
                if ($cmp175) { __label__ = 56;; } else { __label__ = 55;; } //@line 537 "setlengths.cpp"
                $if_then180$$lor_lhs_false176$78: do { 
                  if (__label__ == 55) {
  
                    var $99=$next; //@line 537 "setlengths.cpp"
                    var $type177=(($99+15)&4294967295); //@line 537 "setlengths.cpp"
                    var $100=HEAPU8[($type177)]; //@line 537 "setlengths.cpp"
                    var $conv178=((($100))&255); //@line 537 "setlengths.cpp"
                    var $cmp179=((($conv178))|0)==3; //@line 537 "setlengths.cpp"
                    if ($cmp179) { __label__ = 56;break $if_then180$$lor_lhs_false176$78; } else { __label__ = 70;break $if_then180$$lor_lhs_false176$78; } //@line 537 "setlengths.cpp"
                  }
                } while(0);
                $if_then180$$if_end229$80: do { 
                  if (__label__ == 56) {
  
                    var $101=$next; //@line 539 "setlengths.cpp"
                    var $type181=(($101+15)&4294967295); //@line 539 "setlengths.cpp"
                    var $102=HEAPU8[($type181)]; //@line 539 "setlengths.cpp"
                    var $conv182=((($102))&255); //@line 539 "setlengths.cpp"
                    var $cmp183=((($conv182))|0)==2; //@line 539 "setlengths.cpp"
                    if ($cmp183) { __label__ = 58;; } else { __label__ = 57;; } //@line 539 "setlengths.cpp"
                    $if_then187$$lor_lhs_false184$82: do { 
                      if (__label__ == 57) {
  
                        var $103=$next; //@line 539 "setlengths.cpp"
                        var $newword185=(($103+19)&4294967295); //@line 539 "setlengths.cpp"
                        var $104=HEAP8[($newword185)]; //@line 539 "setlengths.cpp"
                        var $tobool186=(tempInt=(($104)),(tempInt>=128?tempInt-256:tempInt))!=0; //@line 539 "setlengths.cpp"
                        if ($tobool186) { __label__ = 59;break $if_then187$$lor_lhs_false184$82; } else { __label__ = 58;break $if_then187$$lor_lhs_false184$82; } //@line 539 "setlengths.cpp"
                      }
                    } while(0);
                    if (__label__ == 58) {
  
                      $pre_voiced=1; //@line 540 "setlengths.cpp"
                      ; //@line 540 "setlengths.cpp"
                    }
  
                    var $105=$p; //@line 542 "setlengths.cpp"
                    var $prepause189=(($105+16)&4294967295); //@line 542 "setlengths.cpp"
                    HEAP8[($prepause189)]=40; //@line 542 "setlengths.cpp"
                    var $106=$prev; //@line 544 "setlengths.cpp"
                    var $type190=(($106+15)&4294967295); //@line 544 "setlengths.cpp"
                    var $107=HEAPU8[($type190)]; //@line 544 "setlengths.cpp"
                    var $conv191=((($107))&255); //@line 544 "setlengths.cpp"
                    var $cmp192=((($conv191))|0)==0; //@line 544 "setlengths.cpp"
                    if ($cmp192) { __label__ = 61;; } else { __label__ = 60;; } //@line 544 "setlengths.cpp"
                    $if_then197$$lor_lhs_false193$87: do { 
                      if (__label__ == 60) {
  
                        var $108=$prev; //@line 544 "setlengths.cpp"
                        var $type194=(($108+15)&4294967295); //@line 544 "setlengths.cpp"
                        var $109=HEAPU8[($type194)]; //@line 544 "setlengths.cpp"
                        var $conv195=((($109))&255); //@line 544 "setlengths.cpp"
                        var $cmp196=((($conv195))|0)==2; //@line 544 "setlengths.cpp"
                        if ($cmp196) { __label__ = 61;break $if_then197$$lor_lhs_false193$87; } //@line 544 "setlengths.cpp"
  
                        var $111=$p; //@line 547 "setlengths.cpp"
                        var $newword200=(($111+19)&4294967295); //@line 547 "setlengths.cpp"
                        var $112=HEAPU8[($newword200)]; //@line 547 "setlengths.cpp"
                        var $conv201=((($112))&255); //@line 547 "setlengths.cpp"
                        var $cmp202=((($conv201))|0)==0; //@line 547 "setlengths.cpp"
                        if (!($cmp202)) { __label__ = 70;break $if_then180$$if_end229$80; } //@line 547 "setlengths.cpp"
  
                        var $113=$prev; //@line 549 "setlengths.cpp"
                        var $type204=(($113+15)&4294967295); //@line 549 "setlengths.cpp"
                        var $114=HEAPU8[($type204)]; //@line 549 "setlengths.cpp"
                        var $conv205=((($114))&255); //@line 549 "setlengths.cpp"
                        var $cmp206=((($conv205))|0)==3; //@line 549 "setlengths.cpp"
                        if ($cmp206) { __label__ = 64;; } else { __label__ = 65;; } //@line 549 "setlengths.cpp"
                        if (__label__ == 64) {
  
                          var $115=$p; //@line 550 "setlengths.cpp"
                          var $prepause208=(($115+16)&4294967295); //@line 550 "setlengths.cpp"
                          HEAP8[($prepause208)]=20; //@line 550 "setlengths.cpp"
                          ; //@line 550 "setlengths.cpp"
                        }
  
                        var $116=$prev; //@line 551 "setlengths.cpp"
                        var $type210=(($116+15)&4294967295); //@line 551 "setlengths.cpp"
                        var $117=HEAPU8[($type210)]; //@line 551 "setlengths.cpp"
                        var $conv211=((($117))&255); //@line 551 "setlengths.cpp"
                        var $cmp212=((($conv211))|0)==8; //@line 551 "setlengths.cpp"
                        if ($cmp212) { __label__ = 66;; } else { __label__ = 67;; } //@line 551 "setlengths.cpp"
                        if (__label__ == 66) {
  
                          var $118=$p; //@line 552 "setlengths.cpp"
                          var $prepause214=(($118+16)&4294967295); //@line 552 "setlengths.cpp"
                          HEAP8[($prepause214)]=12; //@line 552 "setlengths.cpp"
                          ; //@line 552 "setlengths.cpp"
                        }
  
                        var $119=$prev; //@line 554 "setlengths.cpp"
                        var $type216=(($119+15)&4294967295); //@line 554 "setlengths.cpp"
                        var $120=HEAPU8[($type216)]; //@line 554 "setlengths.cpp"
                        var $conv217=((($120))&255); //@line 554 "setlengths.cpp"
                        var $cmp218=((($conv217))|0)==4; //@line 554 "setlengths.cpp"
                        if (!($cmp218)) { __label__ = 70;break $if_then180$$if_end229$80; } //@line 554 "setlengths.cpp"
  
                        var $121=$prev; //@line 554 "setlengths.cpp"
                        var $ph220=(($121+8)&4294967295); //@line 554 "setlengths.cpp"
                        var $122=HEAP32[(($ph220)>>2)]; //@line 554 "setlengths.cpp"
                        var $phflags221=(($122+4)&4294967295); //@line 554 "setlengths.cpp"
                        var $123=HEAP32[(($phflags221)>>2)]; //@line 554 "setlengths.cpp"
                        var $and222=($123) & 8; //@line 554 "setlengths.cpp"
                        var $tobool223=((($and222))|0)!=0; //@line 554 "setlengths.cpp"
                        if ($tobool223) { __label__ = 70;break $if_then180$$if_end229$80; } //@line 554 "setlengths.cpp"
  
                        var $124=$p; //@line 555 "setlengths.cpp"
                        var $prepause225=(($124+16)&4294967295); //@line 555 "setlengths.cpp"
                        HEAP8[($prepause225)]=0; //@line 555 "setlengths.cpp"
                        __label__ = 70;break $if_then180$$if_end229$80; //@line 555 "setlengths.cpp"
                      }
                    } while(0);
  
                    var $110=$p; //@line 545 "setlengths.cpp"
                    var $prepause198=(($110+16)&4294967295); //@line 545 "setlengths.cpp"
                    HEAP8[($prepause198)]=0; //@line 545 "setlengths.cpp"
                    ; //@line 545 "setlengths.cpp"
                  }
                } while(0);
  
                var $125=$tr_addr; //@line 558 "setlengths.cpp"
                var $langopts230=(($125)&4294967295); //@line 558 "setlengths.cpp"
                var $word_gap231=(($langopts230)&4294967295); //@line 558 "setlengths.cpp"
                var $126=HEAP32[(($word_gap231)>>2)]; //@line 558 "setlengths.cpp"
                var $and232=($126) & 16; //@line 558 "setlengths.cpp"
                var $tobool233=((($and232))|0)!=0; //@line 558 "setlengths.cpp"
                if (!($tobool233)) { __label__ = 192;break $if_end15_thread$$if_end15$9; } //@line 558 "setlengths.cpp"
  
                var $127=$p; //@line 558 "setlengths.cpp"
                var $newword235=(($127+19)&4294967295); //@line 558 "setlengths.cpp"
                var $128=HEAP8[($newword235)]; //@line 558 "setlengths.cpp"
                var $tobool236=(tempInt=(($128)),(tempInt>=128?tempInt-256:tempInt))!=0; //@line 558 "setlengths.cpp"
                if (!($tobool236)) { __label__ = 192;break $if_end15_thread$$if_end15$9; } //@line 558 "setlengths.cpp"
  
                var $129=$p; //@line 558 "setlengths.cpp"
                var $prepause238=(($129+16)&4294967295); //@line 558 "setlengths.cpp"
                var $130=HEAPU8[($prepause238)]; //@line 558 "setlengths.cpp"
                var $conv239=((($130))&255); //@line 558 "setlengths.cpp"
                var $cmp240=((($conv239))|0) < 20; //@line 558 "setlengths.cpp"
                if (!($cmp240)) { __label__ = 192;break $if_end15_thread$$if_end15$9; } //@line 558 "setlengths.cpp"
  
                var $131=$p; //@line 559 "setlengths.cpp"
                var $prepause242=(($131+16)&4294967295); //@line 559 "setlengths.cpp"
                HEAP8[($prepause242)]=20; //@line 559 "setlengths.cpp"
                __label__ = 192;break $if_end15_thread$$if_end15$9; //@line 559 "setlengths.cpp"
              }
              else if (__label__ == 74) {
  
                var $132=$tr_addr; //@line 565 "setlengths.cpp"
                var $stress_amps=(($132+660)&4294967295); //@line 565 "setlengths.cpp"
                var $arrayidx245=(($stress_amps)&4294967295); //@line 565 "setlengths.cpp"
                var $133=HEAP8[($arrayidx245)]; //@line 565 "setlengths.cpp"
                var $134=$p; //@line 565 "setlengths.cpp"
                var $amp=(($134+18)&4294967295); //@line 565 "setlengths.cpp"
                HEAP8[($amp)]=$133; //@line 565 "setlengths.cpp"
                var $135=$p; //@line 566 "setlengths.cpp"
                var $length246=(($135+12)&4294967295); //@line 566 "setlengths.cpp"
                HEAP16[(($length246)>>1)]=256; //@line 566 "setlengths.cpp"
                $min_drop=0; //@line 567 "setlengths.cpp"
                var $136=$p; //@line 569 "setlengths.cpp"
                var $newword247=(($136+19)&4294967295); //@line 569 "setlengths.cpp"
                var $137=HEAP8[($newword247)]; //@line 569 "setlengths.cpp"
                var $tobool248=(tempInt=(($137)),(tempInt>=128?tempInt-256:tempInt))!=0; //@line 569 "setlengths.cpp"
                if ($tobool248) { __label__ = 75;; } else { __label__ = 80;; } //@line 569 "setlengths.cpp"
                $if_then249$$if_end268$105: do { 
                  if (__label__ == 75) {
  
                    var $138=$prev; //@line 571 "setlengths.cpp"
                    var $type250=(($138+15)&4294967295); //@line 571 "setlengths.cpp"
                    var $139=HEAPU8[($type250)]; //@line 571 "setlengths.cpp"
                    var $conv251=((($139))&255); //@line 571 "setlengths.cpp"
                    var $cmp252=((($conv251))|0)==3; //@line 571 "setlengths.cpp"
                    if ($cmp252) { __label__ = 76;; } else { __label__ = 77;; } //@line 571 "setlengths.cpp"
                    if (__label__ == 76) {
  
                      var $140=$p; //@line 572 "setlengths.cpp"
                      var $prepause254=(($140+16)&4294967295); //@line 572 "setlengths.cpp"
                      HEAP8[($prepause254)]=25; //@line 572 "setlengths.cpp"
                      ; //@line 572 "setlengths.cpp"
                    }
  
                    var $141=$prev; //@line 573 "setlengths.cpp"
                    var $type256=(($141+15)&4294967295); //@line 573 "setlengths.cpp"
                    var $142=HEAPU8[($type256)]; //@line 573 "setlengths.cpp"
                    var $conv257=((($142))&255); //@line 573 "setlengths.cpp"
                    var $cmp258=((($conv257))|0)==2; //@line 573 "setlengths.cpp"
                    if (!($cmp258)) { __label__ = 80;break $if_then249$$if_end268$105; } //@line 573 "setlengths.cpp"
  
                    var $143=$p; //@line 575 "setlengths.cpp"
                    var $ph260=(($143+8)&4294967295); //@line 575 "setlengths.cpp"
                    var $144=HEAP32[(($ph260)>>2)]; //@line 575 "setlengths.cpp"
                    var $phflags261=(($144+4)&4294967295); //@line 575 "setlengths.cpp"
                    var $145=HEAP32[(($phflags261)>>2)]; //@line 575 "setlengths.cpp"
                    var $and262=($145) & 16777216; //@line 575 "setlengths.cpp"
                    var $tobool263=((($and262))|0)!=0; //@line 575 "setlengths.cpp"
                    if ($tobool263) { __label__ = 80;break $if_then249$$if_end268$105; } //@line 575 "setlengths.cpp"
  
                    var $146=$p; //@line 576 "setlengths.cpp"
                    var $prepause265=(($146+16)&4294967295); //@line 576 "setlengths.cpp"
                    HEAP8[($prepause265)]=12; //@line 576 "setlengths.cpp"
                    ; //@line 576 "setlengths.cpp"
                  }
                } while(0);
  
                var $147=$next; //@line 580 "setlengths.cpp"
                var $type269=(($147+15)&4294967295); //@line 580 "setlengths.cpp"
                var $148=HEAPU8[($type269)]; //@line 580 "setlengths.cpp"
                var $conv270=((($148))&255); //@line 580 "setlengths.cpp"
                var $cmp271=((($conv270))|0)==2; //@line 580 "setlengths.cpp"
                if ($cmp271) { __label__ = 81;; } else { __label__ = 82;; } //@line 580 "setlengths.cpp"
                if (__label__ == 81) {
  
                  $pre_sonorant=1; //@line 582 "setlengths.cpp"
                  __label__ = 192;break $if_end15_thread$$if_end15$9; //@line 583 "setlengths.cpp"
                }
                else if (__label__ == 82) {
  
                  var $149=$last_pitch; //@line 586 "setlengths.cpp"
                  var $conv274=((($149)) & 255); //@line 586 "setlengths.cpp"
                  var $150=$p; //@line 586 "setlengths.cpp"
                  var $pitch2=(($150+21)&4294967295); //@line 586 "setlengths.cpp"
                  HEAP8[($pitch2)]=$conv274; //@line 586 "setlengths.cpp"
                  var $151=$prev; //@line 588 "setlengths.cpp"
                  var $type275=(($151+15)&4294967295); //@line 588 "setlengths.cpp"
                  var $152=HEAPU8[($type275)]; //@line 588 "setlengths.cpp"
                  var $conv276=((($152))&255); //@line 588 "setlengths.cpp"
                  var $cmp277=((($conv276))|0)==2; //@line 588 "setlengths.cpp"
                  if ($cmp277) { __label__ = 84;; } else { __label__ = 83;; } //@line 588 "setlengths.cpp"
                  $if_then282$$lor_lhs_false278$116: do { 
                    if (__label__ == 83) {
  
                      var $153=$prev; //@line 588 "setlengths.cpp"
                      var $type279=(($153+15)&4294967295); //@line 588 "setlengths.cpp"
                      var $154=HEAPU8[($type279)]; //@line 588 "setlengths.cpp"
                      var $conv280=((($154))&255); //@line 588 "setlengths.cpp"
                      var $cmp281=((($conv280))|0)==3; //@line 588 "setlengths.cpp"
                      if ($cmp281) { __label__ = 84;break $if_then282$$lor_lhs_false278$116; } //@line 588 "setlengths.cpp"
  
                      var $172=$ix; //@line 608 "setlengths.cpp"
                      $ix2=$172; //@line 608 "setlengths.cpp"
                      ; //@line 608 "setlengths.cpp"
                      while(1) { 
  
                        var $173=$ix2; //@line 608 "setlengths.cpp"
                        var $174=HEAP32[((_n_phoneme_list)>>2)]; //@line 608 "setlengths.cpp"
                        var $cmp315=((($173))|0) < ((($174))|0); //@line 608 "setlengths.cpp"
                        if (!($cmp315)) { __label__ = 95;break $if_then282$$lor_lhs_false278$116; } //@line 608 "setlengths.cpp"
  
                        var $175=$ix2; //@line 610 "setlengths.cpp"
                        var $arrayidx317=((_phoneme_list+$175*24)&4294967295); //@line 610 "setlengths.cpp"
                        var $type318=(($arrayidx317+15)&4294967295); //@line 610 "setlengths.cpp"
                        var $176=HEAPU8[($type318)]; //@line 610 "setlengths.cpp"
                        var $conv319=((($176))&255); //@line 610 "setlengths.cpp"
                        var $cmp320=((($conv319))|0)==2; //@line 610 "setlengths.cpp"
                        var $177=$ix2; //@line 612 "setlengths.cpp"
                        if ($cmp320) { __label__ = 93;break ; } //@line 610 "setlengths.cpp"
  
                        var $inc=((($177)+1)&4294967295); //@line 608 "setlengths.cpp"
                        $ix2=$inc; //@line 608 "setlengths.cpp"
                        __label__ = 91;continue ; //@line 608 "setlengths.cpp"
                      }
  
                      var $arrayidx322=((_phoneme_list+$177*24)&4294967295); //@line 612 "setlengths.cpp"
                      var $pitch2323=(($arrayidx322+21)&4294967295); //@line 612 "setlengths.cpp"
                      var $178=HEAP8[($pitch2323)]; //@line 612 "setlengths.cpp"
                      var $179=$p; //@line 612 "setlengths.cpp"
                      var $pitch2324=(($179+21)&4294967295); //@line 612 "setlengths.cpp"
                      HEAP8[($pitch2324)]=$178; //@line 612 "setlengths.cpp"
                      __label__ = 95;break $if_then282$$lor_lhs_false278$116; //@line 613 "setlengths.cpp"
                    }
                  } while(0);
                  $if_then282$$if_end326$124: do { 
                    if (__label__ == 84) {
  
                      var $155=$prev; //@line 590 "setlengths.cpp"
                      var $length283=(($155+12)&4294967295); //@line 590 "setlengths.cpp"
                      var $156=HEAP16[(($length283)>>1)]; //@line 590 "setlengths.cpp"
                      var $157=$p; //@line 590 "setlengths.cpp"
                      var $length284=(($157+12)&4294967295); //@line 590 "setlengths.cpp"
                      HEAP16[(($length284)>>1)]=$156; //@line 590 "setlengths.cpp"
                      var $158=$p; //@line 592 "setlengths.cpp"
                      var $type285=(($158+15)&4294967295); //@line 592 "setlengths.cpp"
                      var $159=HEAPU8[($type285)]; //@line 592 "setlengths.cpp"
                      var $conv286=((($159))&255); //@line 592 "setlengths.cpp"
                      var $cmp287=((($conv286))|0)==3; //@line 592 "setlengths.cpp"
                      if ($cmp287) { __label__ = 85;; } else { __label__ = 86;; } //@line 592 "setlengths.cpp"
                      if (__label__ == 85) {
  
                        var $160=HEAP32[((__ZL6speed1)>>2)]; //@line 594 "setlengths.cpp"
                        var $conv289=((($160)) & 65535); //@line 594 "setlengths.cpp"
                        var $161=$p; //@line 594 "setlengths.cpp"
                        var $length290=(($161+12)&4294967295); //@line 594 "setlengths.cpp"
                        HEAP16[(($length290)>>1)]=$conv289; //@line 594 "setlengths.cpp"
                        ; //@line 595 "setlengths.cpp"
                      }
  
                      var $162=$next; //@line 597 "setlengths.cpp"
                      var $type292=(($162+15)&4294967295); //@line 597 "setlengths.cpp"
                      var $163=HEAPU8[($type292)]; //@line 597 "setlengths.cpp"
                      var $conv293=((($163))&255); //@line 597 "setlengths.cpp"
                      var $cmp294=((($conv293))|0)==5; //@line 597 "setlengths.cpp"
                      if ($cmp294) { __label__ = 87;; } else { __label__ = 88;; } //@line 597 "setlengths.cpp"
                      if (__label__ == 87) {
  
                        var $164=$p; //@line 599 "setlengths.cpp"
                        var $length296=(($164+12)&4294967295); //@line 599 "setlengths.cpp"
                        var $165=HEAP16[(($length296)>>1)]; //@line 599 "setlengths.cpp"
                        var $conv297=(tempInt=(($165)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 599 "setlengths.cpp"
                        var $mul=((($conv297)*160)&4294967295); //@line 599 "setlengths.cpp"
                        var $div298=((((($mul))|0)/100)|0); //@line 599 "setlengths.cpp"
                        var $conv299=((($div298)) & 65535); //@line 599 "setlengths.cpp"
                        var $166=$p; //@line 599 "setlengths.cpp"
                        var $length300=(($166+12)&4294967295); //@line 599 "setlengths.cpp"
                        HEAP16[(($length300)>>1)]=$conv299; //@line 599 "setlengths.cpp"
                        ; //@line 600 "setlengths.cpp"
                      }
  
                      var $167=$next; //@line 601 "setlengths.cpp"
                      var $type302=(($167+15)&4294967295); //@line 601 "setlengths.cpp"
                      var $168=HEAPU8[($type302)]; //@line 601 "setlengths.cpp"
                      var $conv303=((($168))&255); //@line 601 "setlengths.cpp"
                      var $cmp304=((($conv303))|0)==7; //@line 601 "setlengths.cpp"
                      if (!($cmp304)) { __label__ = 95;break $if_then282$$if_end326$124; } //@line 601 "setlengths.cpp"
  
                      var $169=$p; //@line 603 "setlengths.cpp"
                      var $length306=(($169+12)&4294967295); //@line 603 "setlengths.cpp"
                      var $170=HEAP16[(($length306)>>1)]; //@line 603 "setlengths.cpp"
                      var $conv307=(tempInt=(($170)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 603 "setlengths.cpp"
                      var $mul308=((($conv307)*120)&4294967295); //@line 603 "setlengths.cpp"
                      var $div309=((((($mul308))|0)/100)|0); //@line 603 "setlengths.cpp"
                      var $conv310=((($div309)) & 65535); //@line 603 "setlengths.cpp"
                      var $171=$p; //@line 603 "setlengths.cpp"
                      var $length311=(($171+12)&4294967295); //@line 603 "setlengths.cpp"
                      HEAP16[(($length311)>>1)]=$conv310; //@line 603 "setlengths.cpp"
                      ; //@line 604 "setlengths.cpp"
                    }
                  } while(0);
  
                  var $180=$p; //@line 618 "setlengths.cpp"
                  var $pitch2327=(($180+21)&4294967295); //@line 618 "setlengths.cpp"
                  var $181=HEAPU8[($pitch2327)]; //@line 618 "setlengths.cpp"
                  var $conv328=((($181))&255); //@line 618 "setlengths.cpp"
                  var $sub329=((($conv328)-16)&4294967295); //@line 618 "setlengths.cpp"
                  var $conv330=((($sub329)) & 255); //@line 618 "setlengths.cpp"
                  var $182=$p; //@line 618 "setlengths.cpp"
                  var $pitch1331=(($182+20)&4294967295); //@line 618 "setlengths.cpp"
                  HEAP8[($pitch1331)]=$conv330; //@line 618 "setlengths.cpp"
                  var $183=$p; //@line 619 "setlengths.cpp"
                  var $pitch2332=(($183+21)&4294967295); //@line 619 "setlengths.cpp"
                  var $184=HEAPU8[($pitch2332)]; //@line 619 "setlengths.cpp"
                  var $conv333=((($184))&255); //@line 619 "setlengths.cpp"
                  var $cmp334=((($conv333))|0) < 16; //@line 619 "setlengths.cpp"
                  if ($cmp334) { __label__ = 96;; } else { __label__ = 97;; } //@line 619 "setlengths.cpp"
                  if (__label__ == 96) {
  
                    var $185=$p; //@line 621 "setlengths.cpp"
                    var $pitch1336=(($185+20)&4294967295); //@line 621 "setlengths.cpp"
                    HEAP8[($pitch1336)]=0; //@line 621 "setlengths.cpp"
                    ; //@line 622 "setlengths.cpp"
                  }
  
                  var $186=$p; //@line 623 "setlengths.cpp"
                  var $env=(($186+14)&4294967295); //@line 623 "setlengths.cpp"
                  HEAP8[($env)]=0; //@line 623 "setlengths.cpp"
                  $pre_voiced=0; //@line 624 "setlengths.cpp"
                  __label__ = 192;break $if_end15_thread$$if_end15$9;
                }
              }
            }
          } while(0);
          if (__label__ == 98) {
  
            $min_drop=0; //@line 629 "setlengths.cpp"
            var $187=$ix; //@line 630 "setlengths.cpp"
            var $add340=((($187)+2)&4294967295); //@line 630 "setlengths.cpp"
            var $arrayidx341=((_phoneme_list+$add340*24)&4294967295); //@line 630 "setlengths.cpp"
            $next2=$arrayidx341; //@line 630 "setlengths.cpp"
            var $188=$ix; //@line 631 "setlengths.cpp"
            var $add342=((($188)+3)&4294967295); //@line 631 "setlengths.cpp"
            var $arrayidx343=((_phoneme_list+$add342*24)&4294967295); //@line 631 "setlengths.cpp"
            $next3=$arrayidx343; //@line 631 "setlengths.cpp"
            var $189=$stress; //@line 633 "setlengths.cpp"
            var $cmp344=((($189))|0) > 7; //@line 633 "setlengths.cpp"
            if ($cmp344) { __label__ = 99;; } else { __label__ = 100;; } //@line 633 "setlengths.cpp"
            $if_end346_thread$$if_end346$139: do { 
              if (__label__ == 99) {
  
                $stress=7; //@line 633 "setlengths.cpp"
                ; //@line 635 "setlengths.cpp"
              }
              else if (__label__ == 100) {
  
                var $cmp347=((($189))|0) <= 1; //@line 635 "setlengths.cpp"
                if (!($cmp347)) { __label__ = 102;break $if_end346_thread$$if_end346$139; } //@line 635 "setlengths.cpp"
  
                var $190=$stress; //@line 637 "setlengths.cpp"
                var $xor=($190) ^ 1; //@line 637 "setlengths.cpp"
                $stress=$xor; //@line 637 "setlengths.cpp"
                ; //@line 638 "setlengths.cpp"
              }
            } while(0);
  
            var $191=$pre_sonorant; //@line 639 "setlengths.cpp"
            var $tobool350=((($191))|0)!=0; //@line 639 "setlengths.cpp"
            var $192=$stress; //@line 640 "setlengths.cpp"
            var $193=$tr_addr; //@line 640 "setlengths.cpp"
            var $stress_amps352=(($193+660)&4294967295); //@line 640 "setlengths.cpp"
            var $arrayidx353=(($stress_amps352+$192)&4294967295); //@line 640 "setlengths.cpp"
            var $194=HEAPU8[($arrayidx353)]; //@line 640 "setlengths.cpp"
            if ($tobool350) { __label__ = 103;; } else { __label__ = 104;; } //@line 639 "setlengths.cpp"
            if (__label__ == 103) {
  
              var $conv354=((($194))&255); //@line 640 "setlengths.cpp"
              var $sub355=((($conv354)-1)&4294967295); //@line 640 "setlengths.cpp"
              var $conv356=((($sub355)) & 255); //@line 640 "setlengths.cpp"
              var $195=$p; //@line 640 "setlengths.cpp"
              var $amp357=(($195+18)&4294967295); //@line 640 "setlengths.cpp"
              HEAP8[($amp357)]=$conv356; //@line 640 "setlengths.cpp"
              ; //@line 640 "setlengths.cpp"
            }
            else if (__label__ == 104) {
  
              var $196=$p; //@line 642 "setlengths.cpp"
              var $amp361=(($196+18)&4294967295); //@line 642 "setlengths.cpp"
              HEAP8[($amp361)]=$194; //@line 642 "setlengths.cpp"
              ;
            }
  
            var $197=$emphasized; //@line 644 "setlengths.cpp"
            var $tobool363=((($197))|0)!=0; //@line 644 "setlengths.cpp"
            if ($tobool363) { __label__ = 106;; } else { __label__ = 107;; } //@line 644 "setlengths.cpp"
            if (__label__ == 106) {
  
              var $198=$p; //@line 645 "setlengths.cpp"
              var $amp365=(($198+18)&4294967295); //@line 645 "setlengths.cpp"
              HEAP8[($amp365)]=25; //@line 645 "setlengths.cpp"
              ; //@line 645 "setlengths.cpp"
            }
  
            var $199=$ix; //@line 647 "setlengths.cpp"
            var $200=HEAP32[((_n_phoneme_list)>>2)]; //@line 647 "setlengths.cpp"
            var $sub367=((($200)-3)&4294967295); //@line 647 "setlengths.cpp"
            var $cmp368=((($199))|0) >= ((($sub367))|0); //@line 647 "setlengths.cpp"
            if ($cmp368) { __label__ = 108;; } else { __label__ = 110;; } //@line 647 "setlengths.cpp"
            $if_then369$$if_end382$151: do { 
              if (__label__ == 108) {
  
                var $201=$p; //@line 650 "setlengths.cpp"
                var $amp370=(($201+18)&4294967295); //@line 650 "setlengths.cpp"
                var $202=HEAPU8[($amp370)]; //@line 650 "setlengths.cpp"
                var $conv371=((($202))&255); //@line 650 "setlengths.cpp"
                var $203=$tr_addr; //@line 650 "setlengths.cpp"
                var $langopts372=(($203)&4294967295); //@line 650 "setlengths.cpp"
                var $param=(($langopts372+24)&4294967295); //@line 650 "setlengths.cpp"
                var $arrayidx373=(($param+36)&4294967295); //@line 650 "setlengths.cpp"
                var $204=HEAP32[(($arrayidx373)>>2)]; //@line 650 "setlengths.cpp"
                var $cmp374=((($conv371))|0) > ((($204))|0); //@line 650 "setlengths.cpp"
                if (!($cmp374)) { __label__ = 110;break $if_then369$$if_end382$151; } //@line 650 "setlengths.cpp"
  
                var $205=$tr_addr; //@line 651 "setlengths.cpp"
                var $langopts376=(($205)&4294967295); //@line 651 "setlengths.cpp"
                var $param377=(($langopts376+24)&4294967295); //@line 651 "setlengths.cpp"
                var $arrayidx378=(($param377+36)&4294967295); //@line 651 "setlengths.cpp"
                var $206=HEAP32[(($arrayidx378)>>2)]; //@line 651 "setlengths.cpp"
                var $conv379=((($206)) & 255); //@line 651 "setlengths.cpp"
                var $207=$p; //@line 651 "setlengths.cpp"
                var $amp380=(($207+18)&4294967295); //@line 651 "setlengths.cpp"
                HEAP8[($amp380)]=$conv379; //@line 651 "setlengths.cpp"
                ; //@line 651 "setlengths.cpp"
              }
            } while(0);
  
            HEAP32[((__ZZ11CalcLengthsP10TranslatorE14more_syllables)>>2)]=0; //@line 655 "setlengths.cpp"
            $end_of_clause=0; //@line 656 "setlengths.cpp"
            var $208=$p; //@line 657 "setlengths.cpp"
            var $add_ptr=(($208+24)&4294967295); //@line 657 "setlengths.cpp"
            $p2=$add_ptr; //@line 657 "setlengths.cpp"
            var $209=$p2; //@line 657 "setlengths.cpp"
            var $newword3843=(($209+19)&4294967295); //@line 657 "setlengths.cpp"
            var $210=HEAPU8[($newword3843)]; //@line 657 "setlengths.cpp"
            var $conv3854=((($210))&255); //@line 657 "setlengths.cpp"
            var $cmp3865=((($conv3854))|0)==0; //@line 657 "setlengths.cpp"
            var $211=$p2; //@line 659 "setlengths.cpp"
            if ($cmp3865) { __lastLabel__ = 110; __label__ = 111;; } else { __lastLabel__ = 110; __label__ = 117;; } //@line 657 "setlengths.cpp"
            $for_body387$$for_end405$155: do { 
              if (__label__ == 111) {
                $for_body387$156: while(1) { 
  
                  var $212=__lastLabel__ == 116 ? $224 : ($211);
                  var $type388=(($212+15)&4294967295); //@line 659 "setlengths.cpp"
                  var $213=HEAPU8[($type388)]; //@line 659 "setlengths.cpp"
                  var $conv389=((($213))&255); //@line 659 "setlengths.cpp"
                  var $cmp390=((($conv389))|0)==2; //@line 659 "setlengths.cpp"
                  if ($cmp390) { __label__ = 112;; } else { __label__ = 114;; } //@line 659 "setlengths.cpp"
                  $land_lhs_true391$$if_end398$158: do { 
                    if (__label__ == 112) {
  
                      var $214=$p2; //@line 659 "setlengths.cpp"
                      var $ph392=(($214+8)&4294967295); //@line 659 "setlengths.cpp"
                      var $215=HEAP32[(($ph392)>>2)]; //@line 659 "setlengths.cpp"
                      var $phflags393=(($215+4)&4294967295); //@line 659 "setlengths.cpp"
                      var $216=HEAP32[(($phflags393)>>2)]; //@line 659 "setlengths.cpp"
                      var $and394=($216) & 1048576; //@line 659 "setlengths.cpp"
                      var $tobool395=((($and394))|0)!=0; //@line 659 "setlengths.cpp"
                      if ($tobool395) { __label__ = 114;break $land_lhs_true391$$if_end398$158; } //@line 659 "setlengths.cpp"
  
                      var $217=HEAP32[((__ZZ11CalcLengthsP10TranslatorE14more_syllables)>>2)]; //@line 660 "setlengths.cpp"
                      var $inc397=((($217)+1)&4294967295); //@line 660 "setlengths.cpp"
                      HEAP32[((__ZZ11CalcLengthsP10TranslatorE14more_syllables)>>2)]=$inc397; //@line 660 "setlengths.cpp"
                      ; //@line 660 "setlengths.cpp"
                    }
                  } while(0);
  
                  var $218=$p2; //@line 662 "setlengths.cpp"
                  var $ph399=(($218+8)&4294967295); //@line 662 "setlengths.cpp"
                  var $219=HEAP32[(($ph399)>>2)]; //@line 662 "setlengths.cpp"
                  var $code=(($219+10)&4294967295); //@line 662 "setlengths.cpp"
                  var $220=HEAPU8[($code)]; //@line 662 "setlengths.cpp"
                  var $conv400=((($220))&255); //@line 662 "setlengths.cpp"
                  var $cmp401=((($conv400))|0)==27; //@line 662 "setlengths.cpp"
                  if ($cmp401) { __label__ = 115;; } else { __label__ = 116;; } //@line 662 "setlengths.cpp"
                  if (__label__ == 115) {
  
                    $end_of_clause=2; //@line 663 "setlengths.cpp"
                    ; //@line 663 "setlengths.cpp"
                  }
  
                  var $221=$p2; //@line 657 "setlengths.cpp"
                  var $incdec_ptr=(($221+24)&4294967295); //@line 657 "setlengths.cpp"
                  $p2=$incdec_ptr; //@line 657 "setlengths.cpp"
                  var $222=$p2; //@line 657 "setlengths.cpp"
                  var $newword384=(($222+19)&4294967295); //@line 657 "setlengths.cpp"
                  var $223=HEAPU8[($newword384)]; //@line 657 "setlengths.cpp"
                  var $conv385=((($223))&255); //@line 657 "setlengths.cpp"
                  var $cmp386=((($conv385))|0)==0; //@line 657 "setlengths.cpp"
                  var $224=$p2; //@line 659 "setlengths.cpp"
                  if ($cmp386) { __lastLabel__ = 116; __label__ = 111;continue $for_body387$156; } else { __lastLabel__ = 116; __label__ = 117;break $for_body387$$for_end405$155; } //@line 657 "setlengths.cpp"
                }
              }
            } while(0);
  
            var $_lcssa=__lastLabel__ == 110 ? $211 : ($224);
            var $ph406=(($_lcssa+8)&4294967295); //@line 665 "setlengths.cpp"
            var $225=HEAP32[(($ph406)>>2)]; //@line 665 "setlengths.cpp"
            var $code407=(($225+10)&4294967295); //@line 665 "setlengths.cpp"
            var $226=HEAPU8[($code407)]; //@line 665 "setlengths.cpp"
            var $conv408=((($226))&255); //@line 665 "setlengths.cpp"
            var $cmp409=((($conv408))|0)==27; //@line 665 "setlengths.cpp"
            if ($cmp409) { __label__ = 118;; } else { __label__ = 119;; } //@line 665 "setlengths.cpp"
            if (__label__ == 118) {
  
              $end_of_clause=2; //@line 666 "setlengths.cpp"
              ; //@line 666 "setlengths.cpp"
            }
  
            var $227=$p2; //@line 668 "setlengths.cpp"
            var $newword412=(($227+19)&4294967295); //@line 668 "setlengths.cpp"
            var $228=HEAPU8[($newword412)]; //@line 668 "setlengths.cpp"
            var $conv413=((($228))&255); //@line 668 "setlengths.cpp"
            var $and414=($conv413) & 2; //@line 668 "setlengths.cpp"
            var $tobool415=((($and414))|0)!=0; //@line 668 "setlengths.cpp"
            var $229=HEAP32[((__ZZ11CalcLengthsP10TranslatorE14more_syllables)>>2)]; //@line 668 "setlengths.cpp"
            var $cmp417=((($229))|0)==0; //@line 668 "setlengths.cpp"
            var $or_cond=($tobool415) & ($cmp417); //@line 668 "setlengths.cpp"
            if ($or_cond) { __label__ = 120;; } else { __label__ = 121;; } //@line 668 "setlengths.cpp"
            if (__label__ == 120) {
  
              $end_of_clause=2; //@line 670 "setlengths.cpp"
              ; //@line 671 "setlengths.cpp"
            }
  
            var $230=$next; //@line 674 "setlengths.cpp"
            var $ph420=(($230+8)&4294967295); //@line 674 "setlengths.cpp"
            var $231=HEAP32[(($ph420)>>2)]; //@line 674 "setlengths.cpp"
            var $code421=(($231+10)&4294967295); //@line 674 "setlengths.cpp"
            var $232=HEAPU8[($code421)]; //@line 674 "setlengths.cpp"
            var $conv422=((($232))&255); //@line 674 "setlengths.cpp"
            var $cmp423=((($conv422))|0)==23; //@line 674 "setlengths.cpp"
            if ($cmp423) { __label__ = 122;; } else { __label__ = 124;; } //@line 674 "setlengths.cpp"
            $land_lhs_true424$$if_end431$172: do { 
              if (__label__ == 122) {
  
                var $233=$next2; //@line 674 "setlengths.cpp"
                var $type425=(($233+15)&4294967295); //@line 674 "setlengths.cpp"
                var $234=HEAPU8[($type425)]; //@line 674 "setlengths.cpp"
                var $conv426=((($234))&255); //@line 674 "setlengths.cpp"
                var $cmp427=((($conv426))|0)==0; //@line 674 "setlengths.cpp"
                if (!($cmp427)) { __label__ = 124;break $land_lhs_true424$$if_end431$172; } //@line 674 "setlengths.cpp"
  
                var $235=$next2; //@line 677 "setlengths.cpp"
                $next=$235; //@line 677 "setlengths.cpp"
                var $236=$next3; //@line 678 "setlengths.cpp"
                $next2=$236; //@line 678 "setlengths.cpp"
                var $237=$ix; //@line 679 "setlengths.cpp"
                var $add429=((($237)+4)&4294967295); //@line 679 "setlengths.cpp"
                var $arrayidx430=((_phoneme_list+$add429*24)&4294967295); //@line 679 "setlengths.cpp"
                $next3=$arrayidx430; //@line 679 "setlengths.cpp"
                ; //@line 680 "setlengths.cpp"
              }
            } while(0);
  
            var $238=HEAP32[((__ZZ11CalcLengthsP10TranslatorE14more_syllables)>>2)]; //@line 682 "setlengths.cpp"
            var $cmp432=((($238))|0)==0; //@line 682 "setlengths.cpp"
            var $239=$next2; //@line 684 "setlengths.cpp"
            var $ph434=(($239+8)&4294967295); //@line 684 "setlengths.cpp"
            var $240=HEAP32[(($ph434)>>2)]; //@line 684 "setlengths.cpp"
            var $length_mod435=(($240+15)&4294967295); //@line 684 "setlengths.cpp"
            var $241=HEAPU8[($length_mod435)]; //@line 684 "setlengths.cpp"
            var $conv436=((($241))&255); //@line 684 "setlengths.cpp"
            var $mul437=((($conv436)*10)&4294967295); //@line 684 "setlengths.cpp"
            var $242=$next; //@line 684 "setlengths.cpp"
            var $ph438=(($242+8)&4294967295); //@line 684 "setlengths.cpp"
            var $243=HEAP32[(($ph438)>>2)]; //@line 684 "setlengths.cpp"
            var $length_mod439=(($243+15)&4294967295); //@line 684 "setlengths.cpp"
            var $244=HEAPU8[($length_mod439)]; //@line 684 "setlengths.cpp"
            var $conv440=((($244))&255); //@line 684 "setlengths.cpp"
            var $add441=((($conv440)+($mul437))&4294967295); //@line 684 "setlengths.cpp"
            var $245=$tr_addr; //@line 684 "setlengths.cpp"
            var $langopts442=(($245)&4294967295); //@line 684 "setlengths.cpp"
            if ($cmp432) { __label__ = 125;; } else { __label__ = 129;; } //@line 682 "setlengths.cpp"
            $if_then433$$if_else466$176: do { 
              if (__label__ == 125) {
  
                var $length_mods0=(($langopts442+180)&4294967295); //@line 684 "setlengths.cpp"
                var $246=HEAP32[(($length_mods0)>>2)]; //@line 684 "setlengths.cpp"
                var $arrayidx443=(($246+$add441)&4294967295); //@line 684 "setlengths.cpp"
                var $247=HEAPU8[($arrayidx443)]; //@line 684 "setlengths.cpp"
                var $conv444=((($247))&255); //@line 684 "setlengths.cpp"
                $len=$conv444; //@line 684 "setlengths.cpp"
                var $248=$next; //@line 686 "setlengths.cpp"
                var $newword445=(($248+19)&4294967295); //@line 686 "setlengths.cpp"
                var $249=HEAP8[($newword445)]; //@line 686 "setlengths.cpp"
                var $tobool446=(tempInt=(($249)),(tempInt>=128?tempInt-256:tempInt))!=0; //@line 686 "setlengths.cpp"
                if ($tobool446) { __label__ = 126;; } else { __label__ = 128;; } //@line 686 "setlengths.cpp"
                $land_lhs_true447$$if_else464$178: do { 
                  if (__label__ == 126) {
  
                    var $250=$tr_addr; //@line 686 "setlengths.cpp"
                    var $langopts448=(($250)&4294967295); //@line 686 "setlengths.cpp"
                    var $word_gap449=(($langopts448)&4294967295); //@line 686 "setlengths.cpp"
                    var $251=HEAP32[(($word_gap449)>>2)]; //@line 686 "setlengths.cpp"
                    var $and450=($251) & 32; //@line 686 "setlengths.cpp"
                    var $tobool451=((($and450))|0)!=0; //@line 686 "setlengths.cpp"
                    if (!($tobool451)) { __label__ = 128;break $land_lhs_true447$$if_else464$178; } //@line 686 "setlengths.cpp"
  
                    var $252=$len; //@line 689 "setlengths.cpp"
                    var $253=$next; //@line 689 "setlengths.cpp"
                    var $ph453=(($253+8)&4294967295); //@line 689 "setlengths.cpp"
                    var $254=HEAP32[(($ph453)>>2)]; //@line 689 "setlengths.cpp"
                    var $length_mod454=(($254+15)&4294967295); //@line 689 "setlengths.cpp"
                    var $255=HEAPU8[($length_mod454)]; //@line 689 "setlengths.cpp"
                    var $conv455=((($255))&255); //@line 689 "setlengths.cpp"
                    var $mul456=((($conv455)*10)&4294967295); //@line 689 "setlengths.cpp"
                    var $add457=((($mul456)+1)&4294967295); //@line 689 "setlengths.cpp"
                    var $256=$tr_addr; //@line 689 "setlengths.cpp"
                    var $langopts458=(($256)&4294967295); //@line 689 "setlengths.cpp"
                    var $length_mods0459=(($langopts458+180)&4294967295); //@line 689 "setlengths.cpp"
                    var $257=HEAP32[(($length_mods0459)>>2)]; //@line 689 "setlengths.cpp"
                    var $arrayidx460=(($257+$add457)&4294967295); //@line 689 "setlengths.cpp"
                    var $258=HEAPU8[($arrayidx460)]; //@line 689 "setlengths.cpp"
                    var $conv461=((($258))&255); //@line 689 "setlengths.cpp"
                    var $add462=((($conv461)+($252))&4294967295); //@line 689 "setlengths.cpp"
                    var $div463=((((($add462))|0)/2)|0); //@line 689 "setlengths.cpp"
                    $length_mod=$div463; //@line 689 "setlengths.cpp"
                    __label__ = 134;break $if_then433$$if_else466$176; //@line 690 "setlengths.cpp"
                  }
                } while(0);
  
                var $259=$len; //@line 692 "setlengths.cpp"
                $length_mod=$259; //@line 692 "setlengths.cpp"
                ;
              }
              else if (__label__ == 129) {
  
                var $length_mods=(($langopts442+176)&4294967295); //@line 696 "setlengths.cpp"
                var $260=HEAP32[(($length_mods)>>2)]; //@line 696 "setlengths.cpp"
                var $arrayidx476=(($260+$add441)&4294967295); //@line 696 "setlengths.cpp"
                var $261=HEAPU8[($arrayidx476)]; //@line 696 "setlengths.cpp"
                var $conv477=((($261))&255); //@line 696 "setlengths.cpp"
                $length_mod=$conv477; //@line 696 "setlengths.cpp"
                var $262=$next; //@line 698 "setlengths.cpp"
                var $type478=(($262+15)&4294967295); //@line 698 "setlengths.cpp"
                var $263=HEAPU8[($type478)]; //@line 698 "setlengths.cpp"
                var $conv479=((($263))&255); //@line 698 "setlengths.cpp"
                var $cmp480=((($conv479))|0)==8; //@line 698 "setlengths.cpp"
                if (!($cmp480)) { __label__ = 134;break $if_then433$$if_else466$176; } //@line 698 "setlengths.cpp"
  
                var $264=$next2; //@line 698 "setlengths.cpp"
                var $type482=(($264+15)&4294967295); //@line 698 "setlengths.cpp"
                var $265=HEAPU8[($type482)]; //@line 698 "setlengths.cpp"
                var $conv483=((($265))&255); //@line 698 "setlengths.cpp"
                var $cmp484=((($conv483))|0)==4; //@line 698 "setlengths.cpp"
                if ($cmp484) { __label__ = 132;; } else { __label__ = 131;; } //@line 698 "setlengths.cpp"
                if (__label__ == 131) {
  
                  var $266=$next2; //@line 698 "setlengths.cpp"
                  var $type486=(($266+15)&4294967295); //@line 698 "setlengths.cpp"
                  var $267=HEAPU8[($type486)]; //@line 698 "setlengths.cpp"
                  var $conv487=((($267))&255); //@line 698 "setlengths.cpp"
                  var $cmp488=((($conv487))|0)==5; //@line 698 "setlengths.cpp"
                  if (!($cmp488)) { __label__ = 134;break $if_then433$$if_else466$176; } //@line 698 "setlengths.cpp"
                }
  
                var $268=$next3; //@line 698 "setlengths.cpp"
                var $ph490=(($268+8)&4294967295); //@line 698 "setlengths.cpp"
                var $269=HEAP32[(($ph490)>>2)]; //@line 698 "setlengths.cpp"
                var $phflags491=(($269+4)&4294967295); //@line 698 "setlengths.cpp"
                var $270=HEAP32[(($phflags491)>>2)]; //@line 698 "setlengths.cpp"
                var $and492=($270) & 8; //@line 698 "setlengths.cpp"
                var $tobool493=((($and492))|0)!=0; //@line 698 "setlengths.cpp"
                if (!($tobool493)) { __label__ = 134;break $if_then433$$if_else466$176; } //@line 698 "setlengths.cpp"
  
                var $271=$length_mod; //@line 699 "setlengths.cpp"
                var $sub495=((($271)-15)&4294967295); //@line 699 "setlengths.cpp"
                $length_mod=$sub495; //@line 699 "setlengths.cpp"
                ; //@line 699 "setlengths.cpp"
              }
            } while(0);
  
            var $272=HEAP32[((__ZZ11CalcLengthsP10TranslatorE14more_syllables)>>2)]; //@line 702 "setlengths.cpp"
            var $cmp498=((($272))|0)==0; //@line 702 "setlengths.cpp"
            if ($cmp498) { __label__ = 135;; } else { __label__ = 136;; } //@line 702 "setlengths.cpp"
            if (__label__ == 135) {
  
              var $273=HEAP32[((__ZL6speed1)>>2)]; //@line 703 "setlengths.cpp"
              var $274=$length_mod; //@line 703 "setlengths.cpp"
              var $mul500=((($274)*($273))&4294967295); //@line 703 "setlengths.cpp"
              $length_mod=$mul500; //@line 703 "setlengths.cpp"
              ; //@line 703 "setlengths.cpp"
            }
            else if (__label__ == 136) {
  
              var $275=HEAP32[((__ZZ11CalcLengthsP10TranslatorE14more_syllables)>>2)]; //@line 705 "setlengths.cpp"
              var $cmp502=((($275))|0)==1; //@line 705 "setlengths.cpp"
              if ($cmp502) { __label__ = 137;; } else { __label__ = 138;; } //@line 705 "setlengths.cpp"
              if (__label__ == 137) {
  
                var $276=HEAP32[((__ZL6speed2)>>2)]; //@line 706 "setlengths.cpp"
                var $277=$length_mod; //@line 706 "setlengths.cpp"
                var $mul504=((($277)*($276))&4294967295); //@line 706 "setlengths.cpp"
                $length_mod=$mul504; //@line 706 "setlengths.cpp"
                ; //@line 706 "setlengths.cpp"
              }
              else if (__label__ == 138) {
  
                var $278=HEAP32[((__ZL6speed3)>>2)]; //@line 708 "setlengths.cpp"
                var $279=$length_mod; //@line 708 "setlengths.cpp"
                var $mul506=((($279)*($278))&4294967295); //@line 708 "setlengths.cpp"
                $length_mod=$mul506; //@line 708 "setlengths.cpp"
                ;
              }
            }
  
            var $280=$length_mod; //@line 710 "setlengths.cpp"
            var $div509=((((($280))|0)/128)|0); //@line 710 "setlengths.cpp"
            $length_mod=$div509; //@line 710 "setlengths.cpp"
            var $cmp510=((($div509))|0) < 8; //@line 712 "setlengths.cpp"
            if ($cmp510) { __label__ = 140;; } else { __label__ = 141;; } //@line 712 "setlengths.cpp"
            if (__label__ == 140) {
  
              $length_mod=8; //@line 713 "setlengths.cpp"
              ; //@line 713 "setlengths.cpp"
            }
  
            var $281=$stress; //@line 715 "setlengths.cpp"
            var $cmp513=((($281))|0) >= 7; //@line 715 "setlengths.cpp"
            if ($cmp513) { __label__ = 142;; } else { __label__ = 144;; } //@line 715 "setlengths.cpp"
            $if_then514$$if_else520$199: do { 
              if (__label__ == 142) {
  
                var $282=$length_mod; //@line 718 "setlengths.cpp"
                var $add515=((($282)+20)&4294967295); //@line 718 "setlengths.cpp"
                $length_mod=$add515; //@line 718 "setlengths.cpp"
                var $283=$emphasized; //@line 719 "setlengths.cpp"
                var $tobool516=((($283))|0)!=0; //@line 719 "setlengths.cpp"
                if (!($tobool516)) { __label__ = 146;break $if_then514$$if_else520$199; } //@line 719 "setlengths.cpp"
  
                var $284=$length_mod; //@line 720 "setlengths.cpp"
                var $add518=((($284)+10)&4294967295); //@line 720 "setlengths.cpp"
                $length_mod=$add518; //@line 720 "setlengths.cpp"
                ; //@line 720 "setlengths.cpp"
              }
              else if (__label__ == 144) {
  
                var $285=$emphasized; //@line 723 "setlengths.cpp"
                var $tobool521=((($285))|0)!=0; //@line 723 "setlengths.cpp"
                if (!($tobool521)) { __label__ = 146;break $if_then514$$if_else520$199; } //@line 723 "setlengths.cpp"
  
                var $286=$length_mod; //@line 725 "setlengths.cpp"
                var $add523=((($286)+20)&4294967295); //@line 725 "setlengths.cpp"
                $length_mod=$add523; //@line 725 "setlengths.cpp"
                ; //@line 726 "setlengths.cpp"
              }
            } while(0);
  
            var $287=$stress; //@line 728 "setlengths.cpp"
            var $288=$tr_addr; //@line 728 "setlengths.cpp"
            var $stress_lengths=(($288+676)&4294967295); //@line 728 "setlengths.cpp"
            var $arrayidx526=(($stress_lengths+$287*2)&4294967295); //@line 728 "setlengths.cpp"
            var $289=HEAP16[(($arrayidx526)>>1)]; //@line 728 "setlengths.cpp"
            var $conv527=(tempInt=(($289)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 728 "setlengths.cpp"
            $len=$conv527; //@line 728 "setlengths.cpp"
            var $cmp528=((($conv527))|0)==0; //@line 728 "setlengths.cpp"
            if ($cmp528) { __label__ = 147;; } else { __label__ = 148;; } //@line 728 "setlengths.cpp"
            if (__label__ == 147) {
  
              var $290=$tr_addr; //@line 729 "setlengths.cpp"
              var $stress_lengths530=(($290+676)&4294967295); //@line 729 "setlengths.cpp"
              var $arrayidx531=(($stress_lengths530+12)&4294967295); //@line 729 "setlengths.cpp"
              var $291=HEAP16[(($arrayidx531)>>1)]; //@line 729 "setlengths.cpp"
              var $conv532=(tempInt=(($291)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 729 "setlengths.cpp"
              $len=$conv532; //@line 729 "setlengths.cpp"
              ; //@line 729 "setlengths.cpp"
            }
  
            var $292=$length_mod; //@line 731 "setlengths.cpp"
            var $293=$len; //@line 731 "setlengths.cpp"
            var $mul534=((($293)*($292))&4294967295); //@line 731 "setlengths.cpp"
            $length_mod=$mul534; //@line 731 "setlengths.cpp"
            var $294=$p; //@line 733 "setlengths.cpp"
            var $tone_ph=(($294+3)&4294967295); //@line 733 "setlengths.cpp"
            var $295=HEAPU8[($tone_ph)]; //@line 733 "setlengths.cpp"
            var $conv535=((($295))&255); //@line 733 "setlengths.cpp"
            var $cmp536=((($conv535))|0)!=0; //@line 733 "setlengths.cpp"
            if ($cmp536) { __label__ = 149;; } else { __label__ = 151;; } //@line 733 "setlengths.cpp"
            $if_then537$$if_end546$208: do { 
              if (__label__ == 149) {
  
                var $296=$p; //@line 735 "setlengths.cpp"
                var $tone_ph538=(($296+3)&4294967295); //@line 735 "setlengths.cpp"
                var $297=HEAPU8[($tone_ph538)]; //@line 735 "setlengths.cpp"
                var $idxprom=((($297))&255); //@line 735 "setlengths.cpp"
                var $arrayidx539=((_phoneme_tab+$idxprom*4)&4294967295); //@line 735 "setlengths.cpp"
                var $298=HEAP32[(($arrayidx539)>>2)]; //@line 735 "setlengths.cpp"
                var $std_length=(($298+14)&4294967295); //@line 735 "setlengths.cpp"
                var $299=HEAPU8[($std_length)]; //@line 735 "setlengths.cpp"
                var $conv540=((($299))&255); //@line 735 "setlengths.cpp"
                $tone_mod=$conv540; //@line 735 "setlengths.cpp"
                var $cmp541=((($conv540))|0) > 0; //@line 735 "setlengths.cpp"
                if (!($cmp541)) { __label__ = 151;break $if_then537$$if_end546$208; } //@line 735 "setlengths.cpp"
  
                var $300=$length_mod; //@line 738 "setlengths.cpp"
                var $301=$tone_mod; //@line 738 "setlengths.cpp"
                var $mul543=((($301)*($300))&4294967295); //@line 738 "setlengths.cpp"
                var $div544=((((($mul543))|0)/100)|0); //@line 738 "setlengths.cpp"
                $length_mod=$div544; //@line 738 "setlengths.cpp"
                ; //@line 739 "setlengths.cpp"
              }
            } while(0);
  
            var $302=$end_of_clause; //@line 742 "setlengths.cpp"
            var $cmp547=((($302))|0)==2; //@line 742 "setlengths.cpp"
            if ($cmp547) { __label__ = 152;; } else { __label__ = 155;; } //@line 742 "setlengths.cpp"
            if (__label__ == 152) {
  
              var $303=$p; //@line 745 "setlengths.cpp"
              var $ph549=(($303+8)&4294967295); //@line 745 "setlengths.cpp"
              var $304=HEAP32[(($ph549)>>2)]; //@line 745 "setlengths.cpp"
              var $std_length550=(($304+14)&4294967295); //@line 745 "setlengths.cpp"
              var $305=HEAPU8[($std_length550)]; //@line 745 "setlengths.cpp"
              var $conv551=((($305))&255); //@line 745 "setlengths.cpp"
              var $mul552=((($conv551)*2)&4294967295); //@line 745 "setlengths.cpp"
              $len=$mul552; //@line 745 "setlengths.cpp"
              var $306=$tr_addr; //@line 746 "setlengths.cpp"
              var $langopts553=(($306)&4294967295); //@line 746 "setlengths.cpp"
              var $stress_flags=(($langopts553+12)&4294967295); //@line 746 "setlengths.cpp"
              var $307=HEAP32[(($stress_flags)>>2)]; //@line 746 "setlengths.cpp"
              var $and554=($307) & 262144; //@line 746 "setlengths.cpp"
              var $tobool555=((($and554))|0)!=0; //@line 746 "setlengths.cpp"
              if ($tobool555) { __label__ = 153;; } else { __label__ = 154;; } //@line 746 "setlengths.cpp"
              if (__label__ == 153) {
  
                $len=200; //@line 747 "setlengths.cpp"
                ; //@line 747 "setlengths.cpp"
              }
  
              var $308=$length_mod; //@line 748 "setlengths.cpp"
              var $309=$len; //@line 748 "setlengths.cpp"
              var $sub558=((280-($309))&4294967295); //@line 748 "setlengths.cpp"
              var $div559=((((($sub558))|0)/3)|0); //@line 748 "setlengths.cpp"
              var $add560=((($div559)+256)&4294967295); //@line 748 "setlengths.cpp"
              var $mul561=((($add560)*($308))&4294967295); //@line 748 "setlengths.cpp"
              var $div562=((((($mul561))|0)/256)|0); //@line 748 "setlengths.cpp"
              $length_mod=$div562; //@line 748 "setlengths.cpp"
              ; //@line 749 "setlengths.cpp"
            }
  
            var $310=$length_mod; //@line 751 "setlengths.cpp"
            var $311=$tr_addr; //@line 751 "setlengths.cpp"
            var $langopts564=(($311)&4294967295); //@line 751 "setlengths.cpp"
            var $max_lengthmod=(($langopts564+272)&4294967295); //@line 751 "setlengths.cpp"
            var $312=HEAP32[(($max_lengthmod)>>2)]; //@line 751 "setlengths.cpp"
            var $313=HEAP32[((__ZL6speed1)>>2)]; //@line 751 "setlengths.cpp"
            var $mul565=((($313)*($312))&4294967295); //@line 751 "setlengths.cpp"
            var $cmp566=((($310))|0) > ((($mul565))|0); //@line 751 "setlengths.cpp"
            if ($cmp566) { __label__ = 156;; } else { __label__ = 157;; } //@line 751 "setlengths.cpp"
            if (__label__ == 156) {
  
              var $314=$tr_addr; //@line 754 "setlengths.cpp"
              var $langopts568=(($314)&4294967295); //@line 754 "setlengths.cpp"
              var $max_lengthmod569=(($langopts568+272)&4294967295); //@line 754 "setlengths.cpp"
              var $315=HEAP32[(($max_lengthmod569)>>2)]; //@line 754 "setlengths.cpp"
              var $316=HEAP32[((__ZL6speed1)>>2)]; //@line 754 "setlengths.cpp"
              var $mul570=((($316)*($315))&4294967295); //@line 754 "setlengths.cpp"
              $length_mod=$mul570; //@line 754 "setlengths.cpp"
              ; //@line 755 "setlengths.cpp"
            }
  
            var $317=$length_mod; //@line 757 "setlengths.cpp"
            var $div572=((((($317))|0)/128)|0); //@line 757 "setlengths.cpp"
            $length_mod=$div572; //@line 757 "setlengths.cpp"
            var $318=$p; //@line 759 "setlengths.cpp"
            var $type573=(($318+15)&4294967295); //@line 759 "setlengths.cpp"
            var $319=HEAPU8[($type573)]; //@line 759 "setlengths.cpp"
            var $conv574=((($319))&255); //@line 759 "setlengths.cpp"
            var $cmp575=((($conv574))|0)!=2; //@line 759 "setlengths.cpp"
            if ($cmp575) { __label__ = 158;; } else { __label__ = 159;; } //@line 759 "setlengths.cpp"
            if (__label__ == 158) {
  
              $length_mod=256; //@line 761 "setlengths.cpp"
              $min_drop=16; //@line 762 "setlengths.cpp"
              ; //@line 763 "setlengths.cpp"
            }
  
            var $320=$length_mod; //@line 764 "setlengths.cpp"
            var $conv578=((($320)) & 65535); //@line 764 "setlengths.cpp"
            var $321=$p; //@line 764 "setlengths.cpp"
            var $length579=(($321+12)&4294967295); //@line 764 "setlengths.cpp"
            HEAP16[(($length579)>>1)]=$conv578; //@line 764 "setlengths.cpp"
            var $322=$p; //@line 766 "setlengths.cpp"
            var $env580=(($322+14)&4294967295); //@line 766 "setlengths.cpp"
            var $323=HEAPU8[($env580)]; //@line 766 "setlengths.cpp"
            var $conv581=((($323))&255); //@line 766 "setlengths.cpp"
            var $cmp582=((($conv581))|0) >= 19; //@line 766 "setlengths.cpp"
            if ($cmp582) { __label__ = 160;; } else { __label__ = 161;; } //@line 766 "setlengths.cpp"
            if (__label__ == 160) {
  
              var $324=HEAP32[((__impure_ptr)>>2)]; //@line 768 "setlengths.cpp"
              var $_stderr=(($324+12)&4294967295); //@line 768 "setlengths.cpp"
              var $325=HEAP32[(($_stderr)>>2)]; //@line 768 "setlengths.cpp"
              var $326=_fwrite(((__str294)&4294967295), 28, 1, $325); //@line 768 "setlengths.cpp"
              var $327=$p; //@line 769 "setlengths.cpp"
              var $env584=(($327+14)&4294967295); //@line 769 "setlengths.cpp"
              HEAP8[($env584)]=0; //@line 769 "setlengths.cpp"
              ; //@line 770 "setlengths.cpp"
            }
  
            var $328=$p; //@line 774 "setlengths.cpp"
            var $env586=(($328+14)&4294967295); //@line 774 "setlengths.cpp"
            var $329=HEAPU8[($env586)]; //@line 774 "setlengths.cpp"
            var $conv587=((($329))&255); //@line 774 "setlengths.cpp"
            var $add588=((($conv587)+1)&4294967295); //@line 774 "setlengths.cpp"
            $env2=$add588; //@line 774 "setlengths.cpp"
            var $330=$p; //@line 776 "setlengths.cpp"
            var $tone_ph589=(($330+3)&4294967295); //@line 776 "setlengths.cpp"
            var $331=HEAPU8[($tone_ph589)]; //@line 776 "setlengths.cpp"
            var $conv590=((($331))&255); //@line 776 "setlengths.cpp"
            var $cmp591=((($conv590))|0)!=0; //@line 776 "setlengths.cpp"
            if ($cmp591) { __label__ = 162;; } else { __label__ = 163;; } //@line 776 "setlengths.cpp"
            if (__label__ == 162) {
  
              var $332=$p; //@line 778 "setlengths.cpp"
              var $tone_ph593=(($332+3)&4294967295); //@line 778 "setlengths.cpp"
              var $333=HEAPU8[($tone_ph593)]; //@line 778 "setlengths.cpp"
              var $conv594=((($333))&255); //@line 778 "setlengths.cpp"
              __Z17InterpretPhoneme2iP12PHONEME_DATA($conv594, $phdata_tone); //@line 778 "setlengths.cpp"
              var $334=HEAP32[(($pitch_env595)>>2)]; //@line 779 "setlengths.cpp"
              var $call596=__Z11GetEnvelopei($334); //@line 779 "setlengths.cpp"
              $pitch_env=$call596; //@line 779 "setlengths.cpp"
              ; //@line 780 "setlengths.cpp"
            }
            else if (__label__ == 163) {
  
              var $335=$env2; //@line 783 "setlengths.cpp"
              var $arrayidx598=((_envelope_data+$335*4)&4294967295); //@line 783 "setlengths.cpp"
              var $336=HEAP32[(($arrayidx598)>>2)]; //@line 783 "setlengths.cpp"
              $pitch_env=$336; //@line 783 "setlengths.cpp"
              ;
            }
  
            var $337=$p; //@line 786 "setlengths.cpp"
            var $pitch1600=(($337+20)&4294967295); //@line 786 "setlengths.cpp"
            var $338=HEAPU8[($pitch1600)]; //@line 786 "setlengths.cpp"
            var $conv601=((($338))&255); //@line 786 "setlengths.cpp"
            var $339=$p; //@line 786 "setlengths.cpp"
            var $pitch2602=(($339+21)&4294967295); //@line 786 "setlengths.cpp"
            var $340=HEAPU8[($pitch2602)]; //@line 786 "setlengths.cpp"
            var $conv603=((($340))&255); //@line 786 "setlengths.cpp"
            var $341=$p; //@line 786 "setlengths.cpp"
            var $pitch1604=(($341+20)&4294967295); //@line 786 "setlengths.cpp"
            var $342=HEAPU8[($pitch1604)]; //@line 786 "setlengths.cpp"
            var $conv605=((($342))&255); //@line 786 "setlengths.cpp"
            var $sub606=((($conv603)-($conv605))&4294967295); //@line 786 "setlengths.cpp"
            var $343=$pitch_env; //@line 786 "setlengths.cpp"
            var $arrayidx607=(($343)&4294967295); //@line 786 "setlengths.cpp"
            var $344=HEAPU8[($arrayidx607)]; //@line 786 "setlengths.cpp"
            var $conv608=((($344))&255); //@line 786 "setlengths.cpp"
            var $mul609=((($conv608)*($sub606))&4294967295); //@line 786 "setlengths.cpp"
            var $div610=((((($mul609))|0)/256)|0); //@line 786 "setlengths.cpp"
            var $add611=((($div610)+($conv601))&4294967295); //@line 786 "setlengths.cpp"
            $pitch_start=$add611; //@line 786 "setlengths.cpp"
            var $345=$pre_sonorant; //@line 788 "setlengths.cpp"
            var $tobool612=((($345))|0)!=0; //@line 788 "setlengths.cpp"
            if ($tobool612) { __lastLabel__ = 164; __label__ = 167;; } else { __lastLabel__ = 164; __label__ = 165;; } //@line 788 "setlengths.cpp"
            $if_then615$$lor_lhs_false613$231: do { 
              if (__label__ == 165) {
  
                var $346=$pre_voiced; //@line 788 "setlengths.cpp"
                var $tobool614=((($346))|0)!=0; //@line 788 "setlengths.cpp"
                if (!($tobool614)) { __label__ = 177;break $if_then615$$lor_lhs_false613$231; } //@line 788 "setlengths.cpp"
  
                var $_pr2=$pitch_start; //@line 791 "setlengths.cpp"
                __lastLabel__ = 166; __label__ = 167;break $if_then615$$lor_lhs_false613$231;
              }
            } while(0);
            $if_then615$$if_end650$234: do { 
              if (__label__ == 167) {
  
                var $347=__lastLabel__ == 166 ? $_pr2 : ($add611); //@line 791 "setlengths.cpp"
                var $cmp616=((($347))|0)==255; //@line 791 "setlengths.cpp"
                if ($cmp616) { __label__ = 168;; } else { __label__ = 169;; } //@line 791 "setlengths.cpp"
                if (__label__ == 168) {
  
                  var $348=$pitch_start; //@line 792 "setlengths.cpp"
                  $last_pitch=$348; //@line 792 "setlengths.cpp"
                  ; //@line 792 "setlengths.cpp"
                }
  
                var $349=$pitch_start; //@line 794 "setlengths.cpp"
                var $350=$last_pitch; //@line 794 "setlengths.cpp"
                var $sub619=((($349)-($350))&4294967295); //@line 794 "setlengths.cpp"
                var $cmp620=((($sub619))|0) > 16; //@line 794 "setlengths.cpp"
                if ($cmp620) { __label__ = 170;; } else { __label__ = 171;; } //@line 794 "setlengths.cpp"
                if (__label__ == 170) {
  
                  var $351=$pitch_start; //@line 795 "setlengths.cpp"
                  var $sub622=((($351)-16)&4294967295); //@line 795 "setlengths.cpp"
                  $last_pitch=$sub622; //@line 795 "setlengths.cpp"
                  ; //@line 795 "setlengths.cpp"
                }
  
                var $352=$last_pitch; //@line 797 "setlengths.cpp"
                var $conv624=((($352)) & 255); //@line 797 "setlengths.cpp"
                var $353=$prev; //@line 797 "setlengths.cpp"
                var $pitch1625=(($353+20)&4294967295); //@line 797 "setlengths.cpp"
                HEAP8[($pitch1625)]=$conv624; //@line 797 "setlengths.cpp"
                var $354=$pitch_start; //@line 798 "setlengths.cpp"
                var $conv626=((($354)) & 255); //@line 798 "setlengths.cpp"
                var $355=$prev; //@line 798 "setlengths.cpp"
                var $pitch2627=(($355+21)&4294967295); //@line 798 "setlengths.cpp"
                HEAP8[($pitch2627)]=$conv626; //@line 798 "setlengths.cpp"
                var $356=$last_pitch; //@line 799 "setlengths.cpp"
                var $357=$pitch_start; //@line 799 "setlengths.cpp"
                var $cmp628=((($356))|0) < ((($357))|0); //@line 799 "setlengths.cpp"
                var $358=$prev; //@line 801 "setlengths.cpp"
                var $env630=(($358+14)&4294967295); //@line 801 "setlengths.cpp"
                if ($cmp628) { __label__ = 172;; } else { __label__ = 173;; } //@line 799 "setlengths.cpp"
                if (__label__ == 172) {
  
                  HEAP8[($env630)]=2; //@line 801 "setlengths.cpp"
                  var $359=$env2; //@line 802 "setlengths.cpp"
                  var $conv631=((($359)) & 255); //@line 802 "setlengths.cpp"
                  var $360=$p; //@line 802 "setlengths.cpp"
                  var $env632=(($360+14)&4294967295); //@line 802 "setlengths.cpp"
                  HEAP8[($env632)]=$conv631; //@line 802 "setlengths.cpp"
                  ; //@line 803 "setlengths.cpp"
                }
                else if (__label__ == 173) {
  
                  HEAP8[($env630)]=0; //@line 806 "setlengths.cpp"
                  ;
                }
  
                var $361=$length_mod; //@line 809 "setlengths.cpp"
                var $conv636=((($361)) & 65535); //@line 809 "setlengths.cpp"
                var $362=$prev; //@line 809 "setlengths.cpp"
                var $length637=(($362+12)&4294967295); //@line 809 "setlengths.cpp"
                HEAP16[(($length637)>>1)]=$conv636; //@line 809 "setlengths.cpp"
                var $363=$p; //@line 811 "setlengths.cpp"
                var $amp638=(($363+18)&4294967295); //@line 811 "setlengths.cpp"
                var $364=HEAP8[($amp638)]; //@line 811 "setlengths.cpp"
                var $365=$prev; //@line 811 "setlengths.cpp"
                var $amp639=(($365+18)&4294967295); //@line 811 "setlengths.cpp"
                HEAP8[($amp639)]=$364; //@line 811 "setlengths.cpp"
                var $366=$prev; //@line 812 "setlengths.cpp"
                var $type640=(($366+15)&4294967295); //@line 812 "setlengths.cpp"
                var $367=HEAPU8[($type640)]; //@line 812 "setlengths.cpp"
                var $conv641=((($367))&255); //@line 812 "setlengths.cpp"
                var $cmp642=((($conv641))|0)!=3; //@line 812 "setlengths.cpp"
                if (!($cmp642)) { __label__ = 177;break $if_then615$$if_end650$234; } //@line 812 "setlengths.cpp"
  
                var $368=$prev; //@line 812 "setlengths.cpp"
                var $amp644=(($368+18)&4294967295); //@line 812 "setlengths.cpp"
                var $369=HEAPU8[($amp644)]; //@line 812 "setlengths.cpp"
                var $conv645=((($369))&255); //@line 812 "setlengths.cpp"
                var $cmp646=((($conv645))|0) > 18; //@line 812 "setlengths.cpp"
                if (!($cmp646)) { __label__ = 177;break $if_then615$$if_end650$234; } //@line 812 "setlengths.cpp"
  
                var $370=$prev; //@line 813 "setlengths.cpp"
                var $amp648=(($370+18)&4294967295); //@line 813 "setlengths.cpp"
                HEAP8[($amp648)]=18; //@line 813 "setlengths.cpp"
                ; //@line 813 "setlengths.cpp"
              }
            } while(0);
  
            var $371=$next; //@line 817 "setlengths.cpp"
            var $synthflags651=(($371+4)&4294967295); //@line 817 "setlengths.cpp"
            var $372=HEAPU16[(($synthflags651)>>1)]; //@line 817 "setlengths.cpp"
            var $conv652=((($372))&65535); //@line 817 "setlengths.cpp"
            var $and653=($conv652) & -2; //@line 817 "setlengths.cpp"
            var $conv654=((($and653)) & 65535); //@line 817 "setlengths.cpp"
            HEAP16[(($synthflags651)>>1)]=$conv654; //@line 817 "setlengths.cpp"
            var $373=$next; //@line 818 "setlengths.cpp"
            var $type655=(($373+15)&4294967295); //@line 818 "setlengths.cpp"
            var $374=HEAPU8[($type655)]; //@line 818 "setlengths.cpp"
            var $conv656=((($374))&255); //@line 818 "setlengths.cpp"
            var $cmp657=((($conv656))|0)==8; //@line 818 "setlengths.cpp"
            if ($cmp657) { __label__ = 178;; } else { __label__ = 180;; } //@line 818 "setlengths.cpp"
            $land_lhs_true658$$if_end666$249: do { 
              if (__label__ == 178) {
  
                var $375=$next2; //@line 818 "setlengths.cpp"
                var $type659=(($375+15)&4294967295); //@line 818 "setlengths.cpp"
                var $376=HEAPU8[($type659)]; //@line 818 "setlengths.cpp"
                var $conv660=((($376))&255); //@line 818 "setlengths.cpp"
                var $cmp661=((($conv660))|0)!=2; //@line 818 "setlengths.cpp"
                if (!($cmp661)) { __label__ = 180;break $land_lhs_true658$$if_end666$249; } //@line 818 "setlengths.cpp"
  
                var $377=$next; //@line 819 "setlengths.cpp"
                var $synthflags663=(($377+4)&4294967295); //@line 819 "setlengths.cpp"
                var $378=HEAPU16[(($synthflags663)>>1)]; //@line 819 "setlengths.cpp"
                var $conv664=((($378))&65535); //@line 819 "setlengths.cpp"
                var $or=($conv664) | 1; //@line 819 "setlengths.cpp"
                var $conv665=((($or)) & 65535); //@line 819 "setlengths.cpp"
                HEAP16[(($synthflags663)>>1)]=$conv665; //@line 819 "setlengths.cpp"
                ; //@line 819 "setlengths.cpp"
              }
            } while(0);
  
            var $379=$next; //@line 821 "setlengths.cpp"
            var $type667=(($379+15)&4294967295); //@line 821 "setlengths.cpp"
            var $380=HEAPU8[($type667)]; //@line 821 "setlengths.cpp"
            var $conv668=((($380))&255); //@line 821 "setlengths.cpp"
            var $cmp669=((($conv668))|0)==3; //@line 821 "setlengths.cpp"
            if ($cmp669) { __label__ = 181;; } else { __label__ = 186;; } //@line 821 "setlengths.cpp"
            $if_then670$$if_end697$253: do { 
              if (__label__ == 181) {
  
                var $381=$next; //@line 823 "setlengths.cpp"
                var $synthflags671=(($381+4)&4294967295); //@line 823 "setlengths.cpp"
                var $382=HEAPU16[(($synthflags671)>>1)]; //@line 823 "setlengths.cpp"
                var $conv672=((($382))&65535); //@line 823 "setlengths.cpp"
                var $or673=($conv672) | 1; //@line 823 "setlengths.cpp"
                var $conv674=((($or673)) & 65535); //@line 823 "setlengths.cpp"
                HEAP16[(($synthflags671)>>1)]=$conv674; //@line 823 "setlengths.cpp"
                var $383=$next2; //@line 825 "setlengths.cpp"
                var $type675=(($383+15)&4294967295); //@line 825 "setlengths.cpp"
                var $384=HEAPU8[($type675)]; //@line 825 "setlengths.cpp"
                var $conv676=((($384))&255); //@line 825 "setlengths.cpp"
                var $cmp677=((($conv676))|0)==2; //@line 825 "setlengths.cpp"
                if ($cmp677) { __label__ = 182;; } else { __label__ = 183;; } //@line 825 "setlengths.cpp"
                if (__label__ == 182) {
  
                  var $385=$next; //@line 827 "setlengths.cpp"
                  var $synthflags679=(($385+4)&4294967295); //@line 827 "setlengths.cpp"
                  var $386=HEAPU16[(($synthflags679)>>1)]; //@line 827 "setlengths.cpp"
                  var $conv680=((($386))&65535); //@line 827 "setlengths.cpp"
                  var $and681=($conv680) & -2; //@line 827 "setlengths.cpp"
                  var $conv682=((($and681)) & 65535); //@line 827 "setlengths.cpp"
                  HEAP16[(($synthflags679)>>1)]=$conv682; //@line 827 "setlengths.cpp"
                  ; //@line 828 "setlengths.cpp"
                }
  
                var $387=$next2; //@line 830 "setlengths.cpp"
                var $type684=(($387+15)&4294967295); //@line 830 "setlengths.cpp"
                var $388=HEAPU8[($type684)]; //@line 830 "setlengths.cpp"
                var $conv685=((($388))&255); //@line 830 "setlengths.cpp"
                var $cmp686=((($conv685))|0)!=2; //@line 830 "setlengths.cpp"
                if (!($cmp686)) { __label__ = 186;break $if_then670$$if_end697$253; } //@line 830 "setlengths.cpp"
  
                var $389=$next; //@line 832 "setlengths.cpp"
                var $ph688=(($389+8)&4294967295); //@line 832 "setlengths.cpp"
                var $390=HEAP32[(($ph688)>>2)]; //@line 832 "setlengths.cpp"
                var $mnemonic=(($390)&4294967295); //@line 832 "setlengths.cpp"
                var $391=HEAP32[(($mnemonic)>>2)]; //@line 832 "setlengths.cpp"
                var $cmp689=((($391))|0)==12146; //@line 832 "setlengths.cpp"
                if (!($cmp689)) { __label__ = 186;break $if_then670$$if_end697$253; } //@line 832 "setlengths.cpp"
  
                var $392=$next; //@line 834 "setlengths.cpp"
                var $synthflags691=(($392+4)&4294967295); //@line 834 "setlengths.cpp"
                var $393=HEAPU16[(($synthflags691)>>1)]; //@line 834 "setlengths.cpp"
                var $conv692=((($393))&65535); //@line 834 "setlengths.cpp"
                var $and693=($conv692) & -2; //@line 834 "setlengths.cpp"
                var $conv694=((($and693)) & 65535); //@line 834 "setlengths.cpp"
                HEAP16[(($synthflags691)>>1)]=$conv694; //@line 834 "setlengths.cpp"
                ; //@line 836 "setlengths.cpp"
              }
            } while(0);
  
            var $394=$min_drop; //@line 840 "setlengths.cpp"
            var $cmp698=((($394))|0) > 0; //@line 840 "setlengths.cpp"
            if ($cmp698) { __label__ = 187;; } else { __label__ = 191;; } //@line 840 "setlengths.cpp"
            $land_lhs_true699$$if_end715$261: do { 
              if (__label__ == 187) {
  
                var $395=$p; //@line 840 "setlengths.cpp"
                var $pitch2700=(($395+21)&4294967295); //@line 840 "setlengths.cpp"
                var $396=HEAPU8[($pitch2700)]; //@line 840 "setlengths.cpp"
                var $conv701=((($396))&255); //@line 840 "setlengths.cpp"
                var $397=$p; //@line 840 "setlengths.cpp"
                var $pitch1702=(($397+20)&4294967295); //@line 840 "setlengths.cpp"
                var $398=HEAPU8[($pitch1702)]; //@line 840 "setlengths.cpp"
                var $conv703=((($398))&255); //@line 840 "setlengths.cpp"
                var $sub704=((($conv701)-($conv703))&4294967295); //@line 840 "setlengths.cpp"
                var $399=$min_drop; //@line 840 "setlengths.cpp"
                var $cmp705=((($sub704))|0) < ((($399))|0); //@line 840 "setlengths.cpp"
                if (!($cmp705)) { __label__ = 191;break $land_lhs_true699$$if_end715$261; } //@line 840 "setlengths.cpp"
  
                var $400=$p; //@line 842 "setlengths.cpp"
                var $pitch2707=(($400+21)&4294967295); //@line 842 "setlengths.cpp"
                var $401=HEAPU8[($pitch2707)]; //@line 842 "setlengths.cpp"
                var $conv708=((($401))&255); //@line 842 "setlengths.cpp"
                var $402=$min_drop; //@line 842 "setlengths.cpp"
                var $sub709=((($conv708)-($402))&4294967295); //@line 842 "setlengths.cpp"
                $pitch1=$sub709; //@line 842 "setlengths.cpp"
                var $403=$pitch1; //@line 843 "setlengths.cpp"
                var $cmp710=((($403))|0) < 0; //@line 843 "setlengths.cpp"
                if ($cmp710) { __label__ = 189;; } else { __label__ = 190;; } //@line 843 "setlengths.cpp"
                if (__label__ == 189) {
  
                  $pitch1=0; //@line 844 "setlengths.cpp"
                  ; //@line 844 "setlengths.cpp"
                }
  
                var $404=$pitch1; //@line 845 "setlengths.cpp"
                var $conv713=((($404)) & 255); //@line 845 "setlengths.cpp"
                var $405=$p; //@line 845 "setlengths.cpp"
                var $pitch1714=(($405+20)&4294967295); //@line 845 "setlengths.cpp"
                HEAP8[($pitch1714)]=$conv713; //@line 845 "setlengths.cpp"
                ; //@line 846 "setlengths.cpp"
              }
            } while(0);
  
            var $406=$p; //@line 848 "setlengths.cpp"
            var $pitch1716=(($406+20)&4294967295); //@line 848 "setlengths.cpp"
            var $407=HEAPU8[($pitch1716)]; //@line 848 "setlengths.cpp"
            var $conv717=((($407))&255); //@line 848 "setlengths.cpp"
            var $408=$p; //@line 848 "setlengths.cpp"
            var $pitch2718=(($408+21)&4294967295); //@line 848 "setlengths.cpp"
            var $409=HEAPU8[($pitch2718)]; //@line 848 "setlengths.cpp"
            var $conv719=((($409))&255); //@line 848 "setlengths.cpp"
            var $410=$p; //@line 848 "setlengths.cpp"
            var $pitch1720=(($410+20)&4294967295); //@line 848 "setlengths.cpp"
            var $411=HEAPU8[($pitch1720)]; //@line 848 "setlengths.cpp"
            var $conv721=((($411))&255); //@line 848 "setlengths.cpp"
            var $sub722=((($conv719)-($conv721))&4294967295); //@line 848 "setlengths.cpp"
            var $412=$p; //@line 848 "setlengths.cpp"
            var $env723=(($412+14)&4294967295); //@line 848 "setlengths.cpp"
            var $413=HEAPU8[($env723)]; //@line 848 "setlengths.cpp"
            var $idxprom724=((($413))&255); //@line 848 "setlengths.cpp"
            var $arrayidx725=((_envelope_data+$idxprom724*4)&4294967295); //@line 848 "setlengths.cpp"
            var $414=HEAP32[(($arrayidx725)>>2)]; //@line 848 "setlengths.cpp"
            var $arrayidx726=(($414+127)&4294967295); //@line 848 "setlengths.cpp"
            var $415=HEAPU8[($arrayidx726)]; //@line 848 "setlengths.cpp"
            var $conv727=((($415))&255); //@line 848 "setlengths.cpp"
            var $mul728=((($conv727)*($sub722))&4294967295); //@line 848 "setlengths.cpp"
            var $div729=((((($mul728))|0)/256)|0); //@line 848 "setlengths.cpp"
            var $add730=((($div729)+($conv717))&4294967295); //@line 848 "setlengths.cpp"
            $last_pitch=$add730; //@line 848 "setlengths.cpp"
            $pre_sonorant=0; //@line 849 "setlengths.cpp"
            $pre_voiced=0; //@line 850 "setlengths.cpp"
            ; //@line 851 "setlengths.cpp"
          }
  
          var $416=$ix; //@line 441 "setlengths.cpp"
          var $inc732=((($416)+1)&4294967295); //@line 441 "setlengths.cpp"
          $ix=$inc732; //@line 441 "setlengths.cpp"
          var $417=$ix; //@line 441 "setlengths.cpp"
          var $418=HEAP32[((_n_phoneme_list)>>2)]; //@line 441 "setlengths.cpp"
          var $cmp=((($417))|0) < ((($418))|0); //@line 441 "setlengths.cpp"
          if ($cmp) { __label__ = 2;continue $for_body$4; } else { __label__ = 193;break $for_body_lr_ph$$for_end733$2; } //@line 441 "setlengths.cpp"
        }
      }
    } while(0);
  
    STACKTOP = __stackBase__;
    return; //@line 854 "setlengths.cpp"
    return;
  }
  

  function __ZL11DoEmbedded2Pi($embix) {
    ;
    var __label__;
  
    var $embix_addr;
    var $word;
    $embix_addr=$embix;
    ; //@line 398 "setlengths.cpp"
    while(1) { 
  
      var $0=$embix_addr; //@line 399 "setlengths.cpp"
      var $1=HEAP32[(($0)>>2)]; //@line 399 "setlengths.cpp"
      var $inc=((($1)+1)&4294967295); //@line 399 "setlengths.cpp"
      HEAP32[(($0)>>2)]=$inc; //@line 399 "setlengths.cpp"
      var $arrayidx=((_embedded_list+$1*4)&4294967295); //@line 399 "setlengths.cpp"
      var $2=HEAP32[(($arrayidx)>>2)]; //@line 399 "setlengths.cpp"
      $word=$2; //@line 399 "setlengths.cpp"
      var $3=$word; //@line 401 "setlengths.cpp"
      var $and=($3) & 31; //@line 401 "setlengths.cpp"
      var $cmp=((($and))|0)==2; //@line 401 "setlengths.cpp"
      if ($cmp) { __label__ = 2;; } else { __label__ = 3;; } //@line 401 "setlengths.cpp"
      if (__label__ == 2) {
  
        var $4=$word; //@line 404 "setlengths.cpp"
        var $and1=($4) & 127; //@line 404 "setlengths.cpp"
        var $5=$word; //@line 404 "setlengths.cpp"
        var $shr=($5) >>> 8; //@line 404 "setlengths.cpp"
        __Z11SetEmbeddedii($and1, $shr); //@line 404 "setlengths.cpp"
        __Z8SetSpeedi(1); //@line 405 "setlengths.cpp"
        ; //@line 406 "setlengths.cpp"
      }
  
      var $6=$word; //@line 407 "setlengths.cpp"
      var $and2=($6) & 128; //@line 407 "setlengths.cpp"
      var $cmp3=((($and2))|0)==0; //@line 407 "setlengths.cpp"
      if ($cmp3) { __label__ = 1;continue ; } else { __label__ = 4;break ; } //@line 407 "setlengths.cpp"
    }
  
    ;
    return; //@line 408 "setlengths.cpp"
    return;
  }
  

  function __Z20LookupAccentedLetterP10TranslatorjPc($tr, $letter, $ph_buf) {
    var __stackBase__  = STACKTOP; STACKTOP += 128; _memset(__stackBase__, 0, 128);
    var __label__;
    var __lastLabel__ = null;
  
    var $tr_addr;
    var $letter_addr;
    var $ph_buf_addr;
    var $accent_data;
    var $accent1;
    var $accent2;
    var $basic_letter;
    var $letter2;
    var $ph_letter1=__stackBase__;
    var $ph_letter2=__stackBase__+32;
    var $ph_accent1=__stackBase__+64;
    var $ph_accent2=__stackBase__+96;
    $tr_addr=$tr;
    $letter_addr=$letter;
    $ph_buf_addr=$ph_buf;
    $accent_data=0; //@line 418 "numbers.cpp"
    $accent1=0; //@line 419 "numbers.cpp"
    $accent2=0; //@line 420 "numbers.cpp"
    $letter2=0; //@line 422 "numbers.cpp"
    var $arrayidx=(($ph_accent2)&4294967295); //@line 428 "numbers.cpp"
    HEAP8[($arrayidx)]=0; //@line 428 "numbers.cpp"
    var $0=$letter_addr; //@line 430 "numbers.cpp"
    var $cmp=((($0))>>>0) >= 224; //@line 430 "numbers.cpp"
    var $1=$letter_addr; //@line 430 "numbers.cpp"
    var $cmp1=((($1))>>>0) < 383; //@line 430 "numbers.cpp"
    var $or_cond=($cmp) & ($cmp1); //@line 430 "numbers.cpp"
    var $2=$letter_addr; //@line 432 "numbers.cpp"
    if ($or_cond) { __label__ = 1;; } else { __label__ = 2;; } //@line 430 "numbers.cpp"
    if (__label__ == 1) {
  
      var $sub=((($2)-224)&4294967295); //@line 432 "numbers.cpp"
      var $arrayidx2=((__ZL18letter_accents_0e0+$sub*2)&4294967295); //@line 432 "numbers.cpp"
      var $3=HEAPU16[(($arrayidx2)>>1)]; //@line 432 "numbers.cpp"
      var $conv=((($3))&65535); //@line 432 "numbers.cpp"
      $accent_data=$conv; //@line 432 "numbers.cpp"
      __lastLabel__ = 1; ; //@line 433 "numbers.cpp"
    }
    else if (__label__ == 2) {
  
      var $cmp3=((($2))>>>0) >= 592; //@line 435 "numbers.cpp"
      var $4=$letter_addr; //@line 435 "numbers.cpp"
      var $cmp5=((($4))>>>0) <= 680; //@line 435 "numbers.cpp"
      var $or_cond1=($cmp3) & ($cmp5); //@line 435 "numbers.cpp"
      if ($or_cond1) { __label__ = 3;; } else { __label__ = 4;; } //@line 435 "numbers.cpp"
      if (__label__ == 3) {
  
        var $5=$letter_addr; //@line 437 "numbers.cpp"
        var $sub7=((($5)-592)&4294967295); //@line 437 "numbers.cpp"
        var $arrayidx8=((__ZL18letter_accents_250+$sub7*2)&4294967295); //@line 437 "numbers.cpp"
        var $6=HEAPU16[(($arrayidx8)>>1)]; //@line 437 "numbers.cpp"
        var $conv9=((($6))&65535); //@line 437 "numbers.cpp"
        $accent_data=$conv9; //@line 437 "numbers.cpp"
        __lastLabel__ = 3; ; //@line 438 "numbers.cpp"
      }
      else if (__label__ == 4) {
  
        var $_pr=$accent_data; //@line 440 "numbers.cpp"
        __lastLabel__ = 4; ;
      }
    }
  
    var $7=__lastLabel__ == 4 ? $_pr : (__lastLabel__ == 3 ? $conv9 : ($conv)); //@line 440 "numbers.cpp"
    var $cmp11=((($7))|0)!=0; //@line 440 "numbers.cpp"
    if ($cmp11) { __label__ = 6;; } else { __label__ = 24;; } //@line 440 "numbers.cpp"
    $if_then12$$if_end91$9: do { 
      if (__label__ == 6) {
  
        var $8=$accent_data; //@line 442 "numbers.cpp"
        var $and=($8) & 63; //@line 442 "numbers.cpp"
        var $add=((($and)+59)&4294967295); //@line 442 "numbers.cpp"
        $basic_letter=$add; //@line 442 "numbers.cpp"
        var $9=$basic_letter; //@line 443 "numbers.cpp"
        var $cmp13=((($9))|0) < 97; //@line 443 "numbers.cpp"
        if ($cmp13) { __label__ = 7;; } else { __label__ = 8;; } //@line 443 "numbers.cpp"
        if (__label__ == 7) {
  
          var $10=$basic_letter; //@line 444 "numbers.cpp"
          var $sub15=((($10)-59)&4294967295); //@line 444 "numbers.cpp"
          var $arrayidx16=((__ZL13non_ascii_tab+$sub15*2)&4294967295); //@line 444 "numbers.cpp"
          var $11=HEAP16[(($arrayidx16)>>1)]; //@line 444 "numbers.cpp"
          var $conv17=(tempInt=(($11)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 444 "numbers.cpp"
          $basic_letter=$conv17; //@line 444 "numbers.cpp"
          ; //@line 444 "numbers.cpp"
        }
  
        var $12=$accent_data; //@line 446 "numbers.cpp"
        var $and19=($12) & 32768; //@line 446 "numbers.cpp"
        var $tobool=((($and19))|0)!=0; //@line 446 "numbers.cpp"
        var $13=$accent_data; //@line 448 "numbers.cpp"
        var $shr=($13) >> 6; //@line 448 "numbers.cpp"
        if ($tobool) { __label__ = 9;; } else { __label__ = 10;; } //@line 446 "numbers.cpp"
        if (__label__ == 9) {
  
          var $and21=($shr) & 63; //@line 448 "numbers.cpp"
          $letter2=$and21; //@line 448 "numbers.cpp"
          var $14=$letter2; //@line 449 "numbers.cpp"
          var $add22=((($14)+59)&4294967295); //@line 449 "numbers.cpp"
          $letter2=$add22; //@line 449 "numbers.cpp"
          var $15=$accent_data; //@line 450 "numbers.cpp"
          var $shr23=($15) >> 12; //@line 450 "numbers.cpp"
          var $and24=($shr23) & 7; //@line 450 "numbers.cpp"
          $accent2=$and24; //@line 450 "numbers.cpp"
          ; //@line 451 "numbers.cpp"
        }
        else if (__label__ == 10) {
  
          var $and27=($shr) & 31; //@line 454 "numbers.cpp"
          $accent1=$and27; //@line 454 "numbers.cpp"
          var $16=$accent_data; //@line 455 "numbers.cpp"
          var $shr28=($16) >> 11; //@line 455 "numbers.cpp"
          var $and29=($shr28) & 15; //@line 455 "numbers.cpp"
          $accent2=$and29; //@line 455 "numbers.cpp"
          ;
        }
  
        var $17=$tr_addr; //@line 459 "numbers.cpp"
        var $18=$accent1; //@line 459 "numbers.cpp"
        var $arrayidx31=((__ZL11accents_tab+$18*8)&4294967295); //@line 459 "numbers.cpp"
        var $name=(($arrayidx31)&4294967295); //@line 459 "numbers.cpp"
        var $19=HEAP32[(($name)>>2)]; //@line 459 "numbers.cpp"
        var $arraydecay=(($ph_accent1)&4294967295); //@line 459 "numbers.cpp"
        var $call=__Z6LookupP10TranslatorPKcPc($17, $19, $arraydecay); //@line 459 "numbers.cpp"
        var $cmp32=((($call))|0)!=0; //@line 459 "numbers.cpp"
        if (!($cmp32)) { __label__ = 24;break $if_then12$$if_end91$9; } //@line 459 "numbers.cpp"
  
        var $20=$tr_addr; //@line 462 "numbers.cpp"
        var $21=$basic_letter; //@line 462 "numbers.cpp"
        var $arraydecay34=(($ph_letter1)&4294967295); //@line 462 "numbers.cpp"
        var $call35=__ZL13LookupLetter2P10TranslatorjPc($20, $21, $arraydecay34); //@line 462 "numbers.cpp"
        var $cmp36=((($call35))|0)!=0; //@line 462 "numbers.cpp"
        if (!($cmp36)) { __label__ = 24;break $if_then12$$if_end91$9; } //@line 462 "numbers.cpp"
  
        var $22=$accent2; //@line 464 "numbers.cpp"
        var $cmp38=((($22))|0)!=0; //@line 464 "numbers.cpp"
        if ($cmp38) { __label__ = 14;; } else { __label__ = 16;; } //@line 464 "numbers.cpp"
        $if_then39$$if_end56$20: do { 
          if (__label__ == 14) {
  
            var $23=$tr_addr; //@line 466 "numbers.cpp"
            var $24=$accent2; //@line 466 "numbers.cpp"
            var $arrayidx40=((__ZL11accents_tab+$24*8)&4294967295); //@line 466 "numbers.cpp"
            var $name41=(($arrayidx40)&4294967295); //@line 466 "numbers.cpp"
            var $25=HEAP32[(($name41)>>2)]; //@line 466 "numbers.cpp"
            var $arraydecay42=(($ph_accent2)&4294967295); //@line 466 "numbers.cpp"
            var $call43=__Z6LookupP10TranslatorPKcPc($23, $25, $arraydecay42); //@line 466 "numbers.cpp"
            var $26=$accent2; //@line 471 "numbers.cpp"
            var $arrayidx47=((__ZL11accents_tab+$26*8)&4294967295); //@line 471 "numbers.cpp"
            var $flags=(($arrayidx47+4)&4294967295); //@line 471 "numbers.cpp"
            var $27=HEAP32[(($flags)>>2)]; //@line 471 "numbers.cpp"
            var $and48=($27) & 1; //@line 471 "numbers.cpp"
            var $tobool49=((($and48))|0)!=0; //@line 471 "numbers.cpp"
            if (!($tobool49)) { __label__ = 16;break $if_then39$$if_end56$20; } //@line 471 "numbers.cpp"
  
            var $28=$ph_buf_addr; //@line 473 "numbers.cpp"
            var $arraydecay51=(($ph_accent2)&4294967295); //@line 473 "numbers.cpp"
            var $call52=_strcpy($28, $arraydecay51); //@line 473 "numbers.cpp"
            var $29=$ph_buf_addr; //@line 474 "numbers.cpp"
            var $call53=_strlen($29); //@line 474 "numbers.cpp"
            var $30=$ph_buf_addr; //@line 474 "numbers.cpp"
            var $add_ptr=(($30+$call53)&4294967295); //@line 474 "numbers.cpp"
            $ph_buf_addr=$add_ptr; //@line 474 "numbers.cpp"
            var $arrayidx54=(($ph_accent2)&4294967295); //@line 475 "numbers.cpp"
            HEAP8[($arrayidx54)]=0; //@line 475 "numbers.cpp"
            ; //@line 476 "numbers.cpp"
          }
        } while(0);
  
        var $31=$letter2; //@line 478 "numbers.cpp"
        var $cmp57=((($31))|0)!=0; //@line 478 "numbers.cpp"
        if ($cmp57) { __label__ = 17;; } else { __label__ = 18;; } //@line 478 "numbers.cpp"
        if (__label__ == 17) {
  
          var $32=$tr_addr; //@line 481 "numbers.cpp"
          var $33=$letter2; //@line 481 "numbers.cpp"
          var $arraydecay59=(($ph_letter2)&4294967295); //@line 481 "numbers.cpp"
          var $call60=__ZL13LookupLetter2P10TranslatorjPc($32, $33, $arraydecay59); //@line 481 "numbers.cpp"
          var $34=$ph_buf_addr; //@line 482 "numbers.cpp"
          var $arraydecay61=(($ph_accent1)&4294967295); //@line 482 "numbers.cpp"
          var $arraydecay62=(($ph_letter1)&4294967295); //@line 482 "numbers.cpp"
          var $arraydecay63=(($ph_letter2)&4294967295); //@line 482 "numbers.cpp"
          var $arraydecay64=(($ph_accent2)&4294967295); //@line 482 "numbers.cpp"
          var $call65=_sprintf($34, ((__str297)&4294967295), allocate([$arraydecay61,0,0,0,23,0,0,0,$arraydecay62,0,0,0,6,0,0,0,$arraydecay63,0,0,0,$arraydecay64,0,0,0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 482 "numbers.cpp"
          ; //@line 483 "numbers.cpp"
        }
        else if (__label__ == 18) {
  
          var $35=$accent1; //@line 486 "numbers.cpp"
          var $cmp67=((($35))|0)==0; //@line 486 "numbers.cpp"
          if ($cmp67) { __label__ = 19;; } else { __label__ = 20;; } //@line 486 "numbers.cpp"
          if (__label__ == 19) {
  
            var $36=$ph_buf_addr; //@line 487 "numbers.cpp"
            var $arraydecay69=(($ph_letter1)&4294967295); //@line 487 "numbers.cpp"
            var $call70=_strcpy($36, $arraydecay69); //@line 487 "numbers.cpp"
            ; //@line 487 "numbers.cpp"
          }
          else if (__label__ == 20) {
  
            var $37=$tr_addr; //@line 489 "numbers.cpp"
            var $langopts=(($37)&4294967295); //@line 489 "numbers.cpp"
            var $accents=(($langopts+220)&4294967295); //@line 489 "numbers.cpp"
            var $38=HEAP32[(($accents)>>2)]; //@line 489 "numbers.cpp"
            var $and72=($38) & 1; //@line 489 "numbers.cpp"
            var $tobool73=((($and72))|0)!=0; //@line 489 "numbers.cpp"
            if ($tobool73) { __label__ = 22;; } else { __label__ = 21;; } //@line 489 "numbers.cpp"
            $if_then78$$lor_lhs_false$30: do { 
              if (__label__ == 21) {
  
                var $39=$accent1; //@line 489 "numbers.cpp"
                var $arrayidx74=((__ZL11accents_tab+$39*8)&4294967295); //@line 489 "numbers.cpp"
                var $flags75=(($arrayidx74+4)&4294967295); //@line 489 "numbers.cpp"
                var $40=HEAP32[(($flags75)>>2)]; //@line 489 "numbers.cpp"
                var $and76=($40) & 1; //@line 489 "numbers.cpp"
                var $tobool77=((($and76))|0)!=0; //@line 489 "numbers.cpp"
                if ($tobool77) { __label__ = 22;break $if_then78$$lor_lhs_false$30; } //@line 489 "numbers.cpp"
  
                var $42=$ph_buf_addr; //@line 492 "numbers.cpp"
                var $arraydecay83=(($ph_letter1)&4294967295); //@line 492 "numbers.cpp"
                var $arraydecay84=(($ph_accent1)&4294967295); //@line 492 "numbers.cpp"
                var $call85=_sprintf($42, ((__str2299)&4294967295), allocate([4,0,0,0,$arraydecay83,0,0,0,23,0,0,0,$arraydecay84,0,0,0,23,0,0,0], ["i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 492 "numbers.cpp"
                __label__ = 24;break $if_then12$$if_end91$9;
              }
            } while(0);
  
            var $41=$ph_buf_addr; //@line 490 "numbers.cpp"
            var $arraydecay79=(($ph_accent1)&4294967295); //@line 490 "numbers.cpp"
            var $arraydecay80=(($ph_letter1)&4294967295); //@line 490 "numbers.cpp"
            var $call81=_sprintf($41, ((__str1298)&4294967295), allocate([$arraydecay79,0,0,0,23,0,0,0,6,0,0,0,$arraydecay80,0,0,0], ["i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 490 "numbers.cpp"
            ; //@line 490 "numbers.cpp"
          }
        }
      }
    } while(0);
  
    STACKTOP = __stackBase__;
    return; //@line 497 "numbers.cpp"
    return;
  }
  

  function __ZL13LookupLetter2P10TranslatorjPc($tr, $letter, $ph_buf) {
    var __stackBase__  = STACKTOP; STACKTOP += 12; _memset(__stackBase__, 0, 12);
    var __label__;
  
    var $tr_addr;
    var $letter_addr;
    var $ph_buf_addr;
    var $len;
    var $single_letter=__stackBase__;
    $tr_addr=$tr;
    $letter_addr=$letter;
    $ph_buf_addr=$ph_buf;
    var $arrayidx=(($single_letter)&4294967295); //@line 397 "numbers.cpp"
    HEAP8[($arrayidx)]=0; //@line 397 "numbers.cpp"
    var $arrayidx1=(($single_letter+1)&4294967295); //@line 398 "numbers.cpp"
    HEAP8[($arrayidx1)]=95; //@line 398 "numbers.cpp"
    var $0=$letter_addr; //@line 399 "numbers.cpp"
    var $arrayidx2=(($single_letter+2)&4294967295); //@line 399 "numbers.cpp"
    var $call=__Z8utf8_outjPc($0, $arrayidx2); //@line 399 "numbers.cpp"
    $len=$call; //@line 399 "numbers.cpp"
    var $1=$len; //@line 400 "numbers.cpp"
    var $add=((($1)+2)&4294967295); //@line 400 "numbers.cpp"
    var $arrayidx3=(($single_letter+$add)&4294967295); //@line 400 "numbers.cpp"
    HEAP8[($arrayidx3)]=32; //@line 400 "numbers.cpp"
    var $2=$len; //@line 401 "numbers.cpp"
    var $add4=((($2)+3)&4294967295); //@line 401 "numbers.cpp"
    var $arrayidx5=(($single_letter+$add4)&4294967295); //@line 401 "numbers.cpp"
    HEAP8[($arrayidx5)]=0; //@line 401 "numbers.cpp"
    var $3=$tr_addr; //@line 403 "numbers.cpp"
    var $arrayidx6=(($single_letter+1)&4294967295); //@line 403 "numbers.cpp"
    var $4=$ph_buf_addr; //@line 403 "numbers.cpp"
    var $call7=__Z6LookupP10TranslatorPKcPc($3, $arrayidx6, $4); //@line 403 "numbers.cpp"
    var $cmp=((($call7))|0)==0; //@line 403 "numbers.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 3;; } //@line 403 "numbers.cpp"
    $if_then$$if_end15$2: do { 
      if (__label__ == 1) {
  
        var $arrayidx8=(($single_letter+1)&4294967295); //@line 405 "numbers.cpp"
        HEAP8[($arrayidx8)]=32; //@line 405 "numbers.cpp"
        var $5=$tr_addr; //@line 406 "numbers.cpp"
        var $arrayidx9=(($single_letter+2)&4294967295); //@line 406 "numbers.cpp"
        var $6=$ph_buf_addr; //@line 406 "numbers.cpp"
        var $call10=__Z6LookupP10TranslatorPKcPc($5, $arrayidx9, $6); //@line 406 "numbers.cpp"
        var $cmp11=((($call10))|0)==0; //@line 406 "numbers.cpp"
        if (!($cmp11)) { __label__ = 3;break $if_then$$if_end15$2; } //@line 406 "numbers.cpp"
  
        var $7=$tr_addr; //@line 408 "numbers.cpp"
        var $arrayidx13=(($single_letter+2)&4294967295); //@line 408 "numbers.cpp"
        var $8=$ph_buf_addr; //@line 408 "numbers.cpp"
        var $call14=__Z14TranslateRulesP10TranslatorPcS1_iS1_iPj($7, $arrayidx13, $8, 20, 0, 0, 0); //@line 408 "numbers.cpp"
        ; //@line 409 "numbers.cpp"
      }
    } while(0);
  
    var $9=$ph_buf_addr; //@line 411 "numbers.cpp"
    var $arrayidx16=(($9)&4294967295); //@line 411 "numbers.cpp"
    var $10=HEAP8[($arrayidx16)]; //@line 411 "numbers.cpp"
    var $conv=(tempInt=(($10)),(tempInt>=128?tempInt-256:tempInt)); //@line 411 "numbers.cpp"
    STACKTOP = __stackBase__;
    return $conv; //@line 411 "numbers.cpp"
    return null;
  }
  

  function __Z12LookupLetterP10TranslatorjiPci($tr, $letter, $next_byte, $ph_buf1, $control) {
    var __stackBase__  = STACKTOP; STACKTOP += 48; _memset(__stackBase__, 0, 48);
    var __label__;
  
    var $tr_addr;
    var $letter_addr;
    var $next_byte_addr;
    var $ph_buf1_addr;
    var $control_addr;
    var $len;
    var $dict_flags=__stackBase__;
    var $ph_buf3=__stackBase__+8;
    var $ptr;
    $tr_addr=$tr;
    $letter_addr=$letter;
    $next_byte_addr=$next_byte;
    $ph_buf1_addr=$ph_buf1;
    $control_addr=$control;
    var $0=$ph_buf1_addr; //@line 511 "numbers.cpp"
    var $arrayidx=(($0)&4294967295); //@line 511 "numbers.cpp"
    HEAP8[($arrayidx)]=0; //@line 511 "numbers.cpp"
    var $1=$letter_addr; //@line 512 "numbers.cpp"
    var $call=__Z8utf8_outjPc($1, ((__ZZ12LookupLetterP10TranslatorjiPciE13single_letter+2)&4294967295)); //@line 512 "numbers.cpp"
    $len=$call; //@line 512 "numbers.cpp"
    var $2=$len; //@line 513 "numbers.cpp"
    var $add=((($2)+2)&4294967295); //@line 513 "numbers.cpp"
    var $arrayidx1=((__ZZ12LookupLetterP10TranslatorjiPciE13single_letter+$add)&4294967295); //@line 513 "numbers.cpp"
    HEAP8[($arrayidx1)]=32; //@line 513 "numbers.cpp"
    var $3=$next_byte_addr; //@line 515 "numbers.cpp"
    var $cmp=((($3))|0)==-1; //@line 515 "numbers.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 7;; } //@line 515 "numbers.cpp"
    $if_then$$if_end19$2: do { 
      if (__label__ == 1) {
  
        var $4=$tr_addr; //@line 518 "numbers.cpp"
        var $5=$ph_buf1_addr; //@line 518 "numbers.cpp"
        var $call2=__Z6LookupP10TranslatorPKcPc($4, ((__ZZ12LookupLetterP10TranslatorjiPciE13single_letter+2)&4294967295), $5); //@line 518 "numbers.cpp"
        var $cmp3=((($call2))|0)!=0; //@line 518 "numbers.cpp"
        if ($cmp3) { __label__ = 20;break $if_then$$if_end19$2; } //@line 518 "numbers.cpp"
  
        HEAP8[(((__ZZ12LookupLetterP10TranslatorjiPciE13single_letter+1)&4294967295))]=95; //@line 521 "numbers.cpp"
        var $6=$tr_addr; //@line 522 "numbers.cpp"
        var $arraydecay=(($ph_buf3)&4294967295); //@line 522 "numbers.cpp"
        var $call5=__Z6LookupP10TranslatorPKcPc($6, ((__ZZ12LookupLetterP10TranslatorjiPciE13single_letter+1)&4294967295), $arraydecay); //@line 522 "numbers.cpp"
        var $cmp6=((($call5))|0)!=0; //@line 522 "numbers.cpp"
        if ($cmp6) { __label__ = 20;break $if_then$$if_end19$2; } //@line 522 "numbers.cpp"
  
        var $7=$tr_addr; //@line 526 "numbers.cpp"
        var $translator_name=(($7+280)&4294967295); //@line 526 "numbers.cpp"
        var $8=HEAP32[(($translator_name)>>2)]; //@line 526 "numbers.cpp"
        var $cmp9=((($8))|0)==25966; //@line 526 "numbers.cpp"
        if ($cmp9) { __label__ = 20;break $if_then$$if_end19$2; } //@line 526 "numbers.cpp"
  
        var $call12=__Z14SetTranslator2PKc(((__str52704)&4294967295)); //@line 529 "numbers.cpp"
        var $9=HEAP32[((_translator2)>>2)]; //@line 530 "numbers.cpp"
        var $arraydecay13=(($ph_buf3)&4294967295); //@line 530 "numbers.cpp"
        var $call14=__Z6LookupP10TranslatorPKcPc($9, ((__ZZ12LookupLetterP10TranslatorjiPciE13single_letter+2)&4294967295), $arraydecay13); //@line 530 "numbers.cpp"
        var $cmp15=((($call14))|0)!=0; //@line 530 "numbers.cpp"
        if ($cmp15) { __label__ = 5;; } else { __label__ = 6;; } //@line 530 "numbers.cpp"
        if (__label__ == 5) {
  
          var $10=$ph_buf1_addr; //@line 533 "numbers.cpp"
          HEAP8[($10)]=21; //@line 533 "numbers.cpp"
          var $nul=(($10+1)&4294967295); //@line 533 "numbers.cpp"
          HEAP8[($nul)]=0; //@line 533 "numbers.cpp"
          ; //@line 534 "numbers.cpp"
        }
  
        var $11=HEAP32[((_voice)>>2)]; //@line 535 "numbers.cpp"
        var $phoneme_tab_ix=(($11+40)&4294967295); //@line 535 "numbers.cpp"
        var $12=HEAP32[(($phoneme_tab_ix)>>2)]; //@line 535 "numbers.cpp"
        __Z18SelectPhonemeTablei($12); //@line 535 "numbers.cpp"
        ; //@line 536 "numbers.cpp"
      }
      else if (__label__ == 7) {
  
        var $13=$letter_addr; //@line 539 "numbers.cpp"
        var $cmp20=((($13))>>>0) <= 32; //@line 539 "numbers.cpp"
        if ($cmp20) { __label__ = 9;; } else { __label__ = 8;; } //@line 539 "numbers.cpp"
        $if_then22$$lor_lhs_false$11: do { 
          if (__label__ == 8) {
  
            var $14=$letter_addr; //@line 539 "numbers.cpp"
            var $call21=_iswspace($14); //@line 539 "numbers.cpp"
            var $tobool=((($call21))|0)!=0; //@line 539 "numbers.cpp"
            if ($tobool) { __label__ = 9;break $if_then22$$lor_lhs_false$11; } //@line 539 "numbers.cpp"
  
            var $18=$next_byte_addr; //@line 547 "numbers.cpp"
            var $cmp26=((($18))|0)!=32; //@line 547 "numbers.cpp"
            if ($cmp26) { __label__ = 11;; } else { __label__ = 12;; } //@line 547 "numbers.cpp"
            if (__label__ == 11) {
  
              $next_byte_addr=31; //@line 548 "numbers.cpp"
              ; //@line 548 "numbers.cpp"
            }
  
            var $19=$next_byte_addr; //@line 549 "numbers.cpp"
            var $conv=((($19)) & 255); //@line 549 "numbers.cpp"
            var $20=$len; //@line 549 "numbers.cpp"
            var $add29=((($20)+3)&4294967295); //@line 549 "numbers.cpp"
            var $arrayidx30=((__ZZ12LookupLetterP10TranslatorjiPciE13single_letter+$add29)&4294967295); //@line 549 "numbers.cpp"
            HEAP8[($arrayidx30)]=$conv; //@line 549 "numbers.cpp"
            HEAP8[(((__ZZ12LookupLetterP10TranslatorjiPciE13single_letter+1)&4294967295))]=95; //@line 551 "numbers.cpp"
            var $arrayidx31=(($dict_flags+4)&4294967295); //@line 554 "numbers.cpp"
            HEAP32[(($arrayidx31)>>2)]=0; //@line 554 "numbers.cpp"
            $ptr=((__ZZ12LookupLetterP10TranslatorjiPciE13single_letter+1)&4294967295); //@line 555 "numbers.cpp"
            var $21=$tr_addr; //@line 557 "numbers.cpp"
            var $arraydecay32=(($ph_buf3)&4294967295); //@line 557 "numbers.cpp"
            var $call33=__Z6LookupP10TranslatorPKcPc($21, ((__ZZ12LookupLetterP10TranslatorjiPciE13single_letter+1)&4294967295), $arraydecay32); //@line 557 "numbers.cpp"
            var $cmp34=((($call33))|0)==0; //@line 557 "numbers.cpp"
            if ($cmp34) { __label__ = 13;; } else { __label__ = 15;; } //@line 557 "numbers.cpp"
            $if_then35$$if_end43$17: do { 
              if (__label__ == 13) {
  
                HEAP8[(((__ZZ12LookupLetterP10TranslatorjiPciE13single_letter+1)&4294967295))]=32; //@line 559 "numbers.cpp"
                var $22=$tr_addr; //@line 560 "numbers.cpp"
                var $arraydecay36=(($ph_buf3)&4294967295); //@line 560 "numbers.cpp"
                var $call37=__Z6LookupP10TranslatorPKcPc($22, ((__ZZ12LookupLetterP10TranslatorjiPciE13single_letter+2)&4294967295), $arraydecay36); //@line 560 "numbers.cpp"
                var $cmp38=((($call37))|0)==0; //@line 560 "numbers.cpp"
                if (!($cmp38)) { __label__ = 15;break $if_then35$$if_end43$17; } //@line 560 "numbers.cpp"
  
                var $23=$tr_addr; //@line 562 "numbers.cpp"
                var $arraydecay40=(($ph_buf3)&4294967295); //@line 562 "numbers.cpp"
                var $call41=__Z14TranslateRulesP10TranslatorPcS1_iS1_iPj($23, ((__ZZ12LookupLetterP10TranslatorjiPciE13single_letter+2)&4294967295), $arraydecay40, 40, 0, 268435456, 0); //@line 562 "numbers.cpp"
                ; //@line 563 "numbers.cpp"
              }
            } while(0);
  
            var $arrayidx44=(($ph_buf3)&4294967295); //@line 566 "numbers.cpp"
            var $24=HEAP8[($arrayidx44)]; //@line 566 "numbers.cpp"
            var $conv45=(tempInt=(($24)),(tempInt>=128?tempInt-256:tempInt)); //@line 566 "numbers.cpp"
            var $cmp46=((($conv45))|0)==0; //@line 566 "numbers.cpp"
            if ($cmp46) { __label__ = 16;; } else { __label__ = 17;; } //@line 566 "numbers.cpp"
            if (__label__ == 16) {
  
              var $25=$tr_addr; //@line 568 "numbers.cpp"
              var $26=$letter_addr; //@line 568 "numbers.cpp"
              var $arraydecay48=(($ph_buf3)&4294967295); //@line 568 "numbers.cpp"
              __Z20LookupAccentedLetterP10TranslatorjPc($25, $26, $arraydecay48); //@line 568 "numbers.cpp"
              ; //@line 569 "numbers.cpp"
            }
  
            var $27=$ph_buf1_addr; //@line 571 "numbers.cpp"
            var $arraydecay50=(($ph_buf3)&4294967295); //@line 571 "numbers.cpp"
            var $call51=_strcpy($27, $arraydecay50); //@line 571 "numbers.cpp"
            var $28=$ph_buf1_addr; //@line 572 "numbers.cpp"
            var $arrayidx52=(($28)&4294967295); //@line 572 "numbers.cpp"
            var $29=HEAP8[($arrayidx52)]; //@line 572 "numbers.cpp"
            var $conv53=(tempInt=(($29)),(tempInt>=128?tempInt-256:tempInt)); //@line 572 "numbers.cpp"
            var $cmp54=((($conv53))|0)==0; //@line 572 "numbers.cpp"
            if ($cmp54) { __label__ = 20;break $if_then$$if_end19$2; } //@line 572 "numbers.cpp"
  
            var $30=$ph_buf1_addr; //@line 572 "numbers.cpp"
            var $arrayidx56=(($30)&4294967295); //@line 572 "numbers.cpp"
            var $31=HEAP8[($arrayidx56)]; //@line 572 "numbers.cpp"
            var $conv57=(tempInt=(($31)),(tempInt>=128?tempInt-256:tempInt)); //@line 572 "numbers.cpp"
            var $cmp58=((($conv57))|0)==21; //@line 572 "numbers.cpp"
            if ($cmp58) { __label__ = 20;break $if_then$$if_end19$2; } //@line 572 "numbers.cpp"
  
            var $arrayidx61=(($dict_flags)&4294967295); //@line 577 "numbers.cpp"
            HEAP32[(($arrayidx61)>>2)]=0; //@line 577 "numbers.cpp"
            var $arrayidx62=(($dict_flags+4)&4294967295); //@line 578 "numbers.cpp"
            HEAP32[(($arrayidx62)>>2)]=0; //@line 578 "numbers.cpp"
            var $32=$tr_addr; //@line 579 "numbers.cpp"
            var $33=$ph_buf1_addr; //@line 579 "numbers.cpp"
            var $arraydecay63=(($dict_flags)&4294967295); //@line 579 "numbers.cpp"
            var $34=$control_addr; //@line 579 "numbers.cpp"
            var $and=($34) & 1; //@line 579 "numbers.cpp"
            __Z13SetWordStressP10TranslatorPcPjii($32, $33, $arraydecay63, -1, $and); //@line 579 "numbers.cpp"
            __label__ = 20;break $if_then$$if_end19$2; //@line 581 "numbers.cpp"
          }
        } while(0);
  
        var $15=$letter_addr; //@line 542 "numbers.cpp"
        var $call23=_sprintf(((__ZZ12LookupLetterP10TranslatorjiPciE13single_letter+1)&4294967295), ((__str5302)&4294967295), allocate([$15,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 542 "numbers.cpp"
        var $16=$tr_addr; //@line 543 "numbers.cpp"
        var $17=$ph_buf1_addr; //@line 543 "numbers.cpp"
        var $call24=__Z6LookupP10TranslatorPKcPc($16, ((__ZZ12LookupLetterP10TranslatorjiPciE13single_letter+1)&4294967295), $17); //@line 543 "numbers.cpp"
        ; //@line 544 "numbers.cpp"
      }
    } while(0);
  
    STACKTOP = __stackBase__;
    return; //@line 581 "numbers.cpp"
    return;
  }
  

  function __Z15TranslateLetterP10TranslatorPcS1_i($tr, $word, $phonemes, $control) {
    var __stackBase__  = STACKTOP; STACKTOP += 152; _memset(__stackBase__, 0, 152);
    var __label__;
  
    var $retval;
    var $tr_addr;
    var $word_addr;
    var $phonemes_addr;
    var $control_addr;
    var $n_bytes;
    var $letter=__stackBase__;
    var $len;
    var $save_option_phonemes;
    var $p2;
    var $pbuf;
    var $capital=__stackBase__+4;
    var $ph_buf=__stackBase__+24;
    var $ph_buf2=__stackBase__+84;
    var $hexbuf=__stackBase__+144;
    $tr_addr=$tr;
    $word_addr=$word;
    $phonemes_addr=$phonemes;
    $control_addr=$control;
    var $arrayidx=(($ph_buf)&4294967295); //@line 603 "numbers.cpp"
    HEAP8[($arrayidx)]=0; //@line 603 "numbers.cpp"
    var $arrayidx1=(($capital)&4294967295); //@line 604 "numbers.cpp"
    HEAP8[($arrayidx1)]=0; //@line 604 "numbers.cpp"
    var $0=$word_addr; //@line 606 "numbers.cpp"
    var $call=__Z7utf8_inPiPKc($letter, $0); //@line 606 "numbers.cpp"
    $n_bytes=$call; //@line 606 "numbers.cpp"
    var $1=HEAP32[(($letter)>>2)]; //@line 608 "numbers.cpp"
    var $and=($1) & 1048320; //@line 608 "numbers.cpp"
    var $cmp=((($and))|0)==57344; //@line 608 "numbers.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 608 "numbers.cpp"
    if (__label__ == 1) {
  
      var $2=HEAP32[(($letter)>>2)]; //@line 610 "numbers.cpp"
      var $and2=($2) & 255; //@line 610 "numbers.cpp"
      HEAP32[(($letter)>>2)]=$and2; //@line 610 "numbers.cpp"
      ; //@line 611 "numbers.cpp"
    }
  
    var $3=$control_addr; //@line 613 "numbers.cpp"
    var $and3=($3) & 2; //@line 613 "numbers.cpp"
    var $tobool=((($and3))|0)!=0; //@line 613 "numbers.cpp"
    if ($tobool) { __label__ = 3;; } else { __label__ = 5;; } //@line 613 "numbers.cpp"
    $if_then4$$if_end10$5: do { 
      if (__label__ == 3) {
  
        var $4=HEAP32[(($letter)>>2)]; //@line 616 "numbers.cpp"
        var $call5=_iswupper($4); //@line 616 "numbers.cpp"
        var $tobool6=((($call5))|0)!=0; //@line 616 "numbers.cpp"
        if (!($tobool6)) { __label__ = 5;break $if_then4$$if_end10$5; } //@line 616 "numbers.cpp"
  
        var $5=$tr_addr; //@line 618 "numbers.cpp"
        var $arraydecay=(($capital)&4294967295); //@line 618 "numbers.cpp"
        var $call8=__Z6LookupP10TranslatorPKcPc($5, ((__str6303)&4294967295), $arraydecay); //@line 618 "numbers.cpp"
        ; //@line 619 "numbers.cpp"
      }
    } while(0);
  
    var $6=HEAP32[(($letter)>>2)]; //@line 621 "numbers.cpp"
    var $call11=__Z9towlower2j($6); //@line 621 "numbers.cpp"
    HEAP32[(($letter)>>2)]=$call11; //@line 621 "numbers.cpp"
    var $7=$tr_addr; //@line 623 "numbers.cpp"
    var $8=HEAP32[(($letter)>>2)]; //@line 623 "numbers.cpp"
    var $9=$n_bytes; //@line 623 "numbers.cpp"
    var $10=$word_addr; //@line 623 "numbers.cpp"
    var $arrayidx12=(($10+$9)&4294967295); //@line 623 "numbers.cpp"
    var $11=HEAP8[($arrayidx12)]; //@line 623 "numbers.cpp"
    var $conv=(tempInt=(($11)),(tempInt>=128?tempInt-256:tempInt)); //@line 623 "numbers.cpp"
    var $arraydecay13=(($ph_buf)&4294967295); //@line 623 "numbers.cpp"
    var $12=$control_addr; //@line 623 "numbers.cpp"
    var $and14=($12) & 1; //@line 623 "numbers.cpp"
    __Z12LookupLetterP10TranslatorjiPci($7, $8, $conv, $arraydecay13, $and14); //@line 623 "numbers.cpp"
    var $arrayidx15=(($ph_buf)&4294967295); //@line 625 "numbers.cpp"
    var $13=HEAP8[($arrayidx15)]; //@line 625 "numbers.cpp"
    var $conv16=(tempInt=(($13)),(tempInt>=128?tempInt-256:tempInt)); //@line 625 "numbers.cpp"
    var $cmp17=((($conv16))|0)==21; //@line 625 "numbers.cpp"
    if ($cmp17) { __label__ = 6;; } else { __label__ = 7;; } //@line 625 "numbers.cpp"
    $if_then18$$if_end21$9: do { 
      if (__label__ == 6) {
  
        var $14=$phonemes_addr; //@line 627 "numbers.cpp"
        var $arraydecay19=(($ph_buf)&4294967295); //@line 627 "numbers.cpp"
        var $call20=_strcpy($14, $arraydecay19); //@line 627 "numbers.cpp"
        $retval=0; //@line 628 "numbers.cpp"
        ; //@line 628 "numbers.cpp"
      }
      else if (__label__ == 7) {
  
        var $arrayidx22=(($ph_buf)&4294967295); //@line 631 "numbers.cpp"
        var $15=HEAP8[($arrayidx22)]; //@line 631 "numbers.cpp"
        var $conv23=(tempInt=(($15)),(tempInt>=128?tempInt-256:tempInt)); //@line 631 "numbers.cpp"
        var $cmp24=((($conv23))|0)==0; //@line 631 "numbers.cpp"
        if ($cmp24) { __label__ = 8;; } else { __label__ = 11;; } //@line 631 "numbers.cpp"
        $land_lhs_true$$if_end38$12: do { 
          if (__label__ == 8) {
  
            var $16=$tr_addr; //@line 631 "numbers.cpp"
            var $translator_name=(($16+280)&4294967295); //@line 631 "numbers.cpp"
            var $17=HEAP32[(($translator_name)>>2)]; //@line 631 "numbers.cpp"
            var $cmp25=((($17))|0)!=25966; //@line 631 "numbers.cpp"
            if (!($cmp25)) { __label__ = 11;break $land_lhs_true$$if_end38$12; } //@line 631 "numbers.cpp"
  
            var $call27=__Z14SetTranslator2PKc(((__str52704)&4294967295)); //@line 634 "numbers.cpp"
            var $18=HEAP32[((_option_phonemes)>>2)]; //@line 635 "numbers.cpp"
            $save_option_phonemes=$18; //@line 635 "numbers.cpp"
            HEAP32[((_option_phonemes)>>2)]=0; //@line 636 "numbers.cpp"
            var $19=HEAP32[((_translator2)>>2)]; //@line 637 "numbers.cpp"
            var $20=HEAP32[(($letter)>>2)]; //@line 637 "numbers.cpp"
            var $21=$n_bytes; //@line 637 "numbers.cpp"
            var $22=$word_addr; //@line 637 "numbers.cpp"
            var $arrayidx28=(($22+$21)&4294967295); //@line 637 "numbers.cpp"
            var $23=HEAP8[($arrayidx28)]; //@line 637 "numbers.cpp"
            var $conv29=(tempInt=(($23)),(tempInt>=128?tempInt-256:tempInt)); //@line 637 "numbers.cpp"
            var $arraydecay30=(($ph_buf)&4294967295); //@line 637 "numbers.cpp"
            var $24=$control_addr; //@line 637 "numbers.cpp"
            var $and31=($24) & 1; //@line 637 "numbers.cpp"
            __Z12LookupLetterP10TranslatorjiPci($19, $20, $conv29, $arraydecay30, $and31); //@line 637 "numbers.cpp"
            var $25=HEAP32[((_voice)>>2)]; //@line 638 "numbers.cpp"
            var $phoneme_tab_ix=(($25+40)&4294967295); //@line 638 "numbers.cpp"
            var $26=HEAP32[(($phoneme_tab_ix)>>2)]; //@line 638 "numbers.cpp"
            __Z18SelectPhonemeTablei($26); //@line 638 "numbers.cpp"
            var $27=$save_option_phonemes; //@line 639 "numbers.cpp"
            HEAP32[((_option_phonemes)>>2)]=$27; //@line 639 "numbers.cpp"
            var $arrayidx32=(($ph_buf)&4294967295); //@line 641 "numbers.cpp"
            var $28=HEAP8[($arrayidx32)]; //@line 641 "numbers.cpp"
            var $conv33=(tempInt=(($28)),(tempInt>=128?tempInt-256:tempInt)); //@line 641 "numbers.cpp"
            var $cmp34=((($conv33))|0)!=0; //@line 641 "numbers.cpp"
            if (!($cmp34)) { __label__ = 11;break $land_lhs_true$$if_end38$12; } //@line 641 "numbers.cpp"
  
            var $29=$phonemes_addr; //@line 643 "numbers.cpp"
            var $call36=_sprintf($29, ((__str7304)&4294967295), allocate([21,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 643 "numbers.cpp"
            $retval=0; //@line 644 "numbers.cpp"
            __label__ = 26;break $if_then18$$if_end21$9; //@line 644 "numbers.cpp"
          }
        } while(0);
  
        var $arrayidx39=(($ph_buf)&4294967295); //@line 648 "numbers.cpp"
        var $30=HEAP8[($arrayidx39)]; //@line 648 "numbers.cpp"
        var $conv40=(tempInt=(($30)),(tempInt>=128?tempInt-256:tempInt)); //@line 648 "numbers.cpp"
        var $cmp41=((($conv40))|0)==0; //@line 648 "numbers.cpp"
        if ($cmp41) { __label__ = 12;; } else { __label__ = 20;; } //@line 648 "numbers.cpp"
        $if_then42$$if_end73$17: do { 
          if (__label__ == 12) {
  
            var $31=HEAP32[(($letter)>>2)]; //@line 651 "numbers.cpp"
            var $call43=_iswalpha($31); //@line 651 "numbers.cpp"
            var $tobool44=((($call43))|0)!=0; //@line 651 "numbers.cpp"
            if ($tobool44) { __label__ = 13;; } else { __label__ = 14;; } //@line 651 "numbers.cpp"
            if (__label__ == 13) {
  
              var $32=$tr_addr; //@line 652 "numbers.cpp"
              var $arraydecay46=(($ph_buf)&4294967295); //@line 652 "numbers.cpp"
              var $call47=__Z6LookupP10TranslatorPKcPc($32, ((__str8305)&4294967295), $arraydecay46); //@line 652 "numbers.cpp"
              ; //@line 652 "numbers.cpp"
            }
  
            var $arrayidx49=(($ph_buf)&4294967295); //@line 654 "numbers.cpp"
            var $33=HEAP8[($arrayidx49)]; //@line 654 "numbers.cpp"
            var $conv50=(tempInt=(($33)),(tempInt>=128?tempInt-256:tempInt)); //@line 654 "numbers.cpp"
            var $cmp51=((($conv50))|0)==0; //@line 654 "numbers.cpp"
            if ($cmp51) { __label__ = 15;; } else { __label__ = 17;; } //@line 654 "numbers.cpp"
            $land_lhs_true52$$if_end58$22: do { 
              if (__label__ == 15) {
  
                var $34=HEAP32[(($letter)>>2)]; //@line 654 "numbers.cpp"
                var $call53=_iswspace($34); //@line 654 "numbers.cpp"
                var $tobool54=((($call53))|0)!=0; //@line 654 "numbers.cpp"
                if ($tobool54) { __label__ = 17;break $land_lhs_true52$$if_end58$22; } //@line 654 "numbers.cpp"
  
                var $35=$tr_addr; //@line 655 "numbers.cpp"
                var $arraydecay56=(($ph_buf)&4294967295); //@line 655 "numbers.cpp"
                var $call57=__Z6LookupP10TranslatorPKcPc($35, ((__str9306)&4294967295), $arraydecay56); //@line 655 "numbers.cpp"
                ; //@line 655 "numbers.cpp"
              }
            } while(0);
  
            var $arrayidx59=(($ph_buf)&4294967295); //@line 657 "numbers.cpp"
            var $36=HEAP8[($arrayidx59)]; //@line 657 "numbers.cpp"
            var $conv60=(tempInt=(($36)),(tempInt>=128?tempInt-256:tempInt)); //@line 657 "numbers.cpp"
            var $cmp61=((($conv60))|0)!=0; //@line 657 "numbers.cpp"
            if (!($cmp61)) { __label__ = 20;break $if_then42$$if_end73$17; } //@line 657 "numbers.cpp"
  
            var $arraydecay63=(($hexbuf)&4294967295); //@line 660 "numbers.cpp"
            var $37=HEAP32[(($letter)>>2)]; //@line 660 "numbers.cpp"
            var $call64=_sprintf($arraydecay63, ((__str10307)&4294967295), allocate([$37,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 660 "numbers.cpp"
            var $arraydecay65=(($ph_buf)&4294967295); //@line 661 "numbers.cpp"
            $pbuf=$arraydecay65; //@line 661 "numbers.cpp"
            var $arraydecay66=(($hexbuf)&4294967295); //@line 662 "numbers.cpp"
            $p2=$arraydecay66; //@line 662 "numbers.cpp"
            var $38=$p2; //@line 662 "numbers.cpp"
            var $39=HEAP8[($38)]; //@line 662 "numbers.cpp"
            var $conv671=(tempInt=(($39)),(tempInt>=128?tempInt-256:tempInt)); //@line 662 "numbers.cpp"
            var $cmp682=((($conv671))|0)!=0; //@line 662 "numbers.cpp"
            if (!($cmp682)) { __label__ = 20;break $if_then42$$if_end73$17; } //@line 662 "numbers.cpp"
            while(1) { 
  
              var $40=$pbuf; //@line 664 "numbers.cpp"
              var $call69=_strlen($40); //@line 664 "numbers.cpp"
              var $41=$pbuf; //@line 664 "numbers.cpp"
              var $add_ptr=(($41+$call69)&4294967295); //@line 664 "numbers.cpp"
              $pbuf=$add_ptr; //@line 664 "numbers.cpp"
              var $42=$pbuf; //@line 665 "numbers.cpp"
              var $incdec_ptr=(($42+1)&4294967295); //@line 665 "numbers.cpp"
              $pbuf=$incdec_ptr; //@line 665 "numbers.cpp"
              HEAP8[($42)]=23; //@line 665 "numbers.cpp"
              var $43=$tr_addr; //@line 666 "numbers.cpp"
              var $44=$p2; //@line 666 "numbers.cpp"
              var $45=HEAP8[($44)]; //@line 666 "numbers.cpp"
              var $conv70=(tempInt=(($45)),(tempInt>=128?tempInt-256:tempInt)); //@line 666 "numbers.cpp"
              var $46=$pbuf; //@line 666 "numbers.cpp"
              __Z12LookupLetterP10TranslatorjiPci($43, $conv70, 0, $46, 1); //@line 666 "numbers.cpp"
              var $47=$p2; //@line 662 "numbers.cpp"
              var $incdec_ptr71=(($47+1)&4294967295); //@line 662 "numbers.cpp"
              $p2=$incdec_ptr71; //@line 662 "numbers.cpp"
              var $48=$p2; //@line 662 "numbers.cpp"
              var $49=HEAP8[($48)]; //@line 662 "numbers.cpp"
              var $conv67=(tempInt=(($49)),(tempInt>=128?tempInt-256:tempInt)); //@line 662 "numbers.cpp"
              var $cmp68=((($conv67))|0)!=0; //@line 662 "numbers.cpp"
              if ($cmp68) { __label__ = 19;continue ; } else { __label__ = 20;break $if_then42$$if_end73$17; } //@line 662 "numbers.cpp"
            }
          }
        } while(0);
  
        var $50=$phonemes_addr; //@line 671 "numbers.cpp"
        var $call74=_strlen($50); //@line 671 "numbers.cpp"
        $len=$call74; //@line 671 "numbers.cpp"
        var $51=$tr_addr; //@line 672 "numbers.cpp"
        var $langopts=(($51)&4294967295); //@line 672 "numbers.cpp"
        var $accents=(($langopts+220)&4294967295); //@line 672 "numbers.cpp"
        var $52=HEAP32[(($accents)>>2)]; //@line 672 "numbers.cpp"
        var $and75=($52) & 2; //@line 672 "numbers.cpp"
        var $tobool76=((($and75))|0)!=0; //@line 672 "numbers.cpp"
        var $arraydecay78=(($ph_buf2)&4294967295); //@line 673 "numbers.cpp"
        if ($tobool76) { __label__ = 21;; } else { __label__ = 22;; } //@line 672 "numbers.cpp"
        if (__label__ == 21) {
  
          var $arraydecay79=(($ph_buf)&4294967295); //@line 673 "numbers.cpp"
          var $arraydecay80=(($capital)&4294967295); //@line 673 "numbers.cpp"
          var $call81=_sprintf($arraydecay78, ((__str11308)&4294967295), allocate([255,0,0,0,$arraydecay79,0,0,0,$arraydecay80,0,0,0], ["i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 673 "numbers.cpp"
          ; //@line 673 "numbers.cpp"
        }
        else if (__label__ == 22) {
  
          var $arraydecay83=(($capital)&4294967295); //@line 675 "numbers.cpp"
          var $arraydecay84=(($ph_buf)&4294967295); //@line 675 "numbers.cpp"
          var $call85=_sprintf($arraydecay78, ((__str11308)&4294967295), allocate([255,0,0,0,$arraydecay83,0,0,0,$arraydecay84,0,0,0], ["i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 675 "numbers.cpp"
          ;
        }
  
        var $53=$len; //@line 676 "numbers.cpp"
        var $arraydecay87=(($ph_buf2)&4294967295); //@line 676 "numbers.cpp"
        var $call88=_strlen($arraydecay87); //@line 676 "numbers.cpp"
        var $add=((($call88)+($53))&4294967295); //@line 676 "numbers.cpp"
        var $cmp89=((($add))>>>0) < 160; //@line 676 "numbers.cpp"
        if ($cmp89) { __label__ = 24;; } else { __label__ = 25;; } //@line 676 "numbers.cpp"
        if (__label__ == 24) {
  
          var $54=$len; //@line 678 "numbers.cpp"
          var $55=$phonemes_addr; //@line 678 "numbers.cpp"
          var $arrayidx91=(($55+$54)&4294967295); //@line 678 "numbers.cpp"
          var $arraydecay92=(($ph_buf2)&4294967295); //@line 678 "numbers.cpp"
          var $call93=_strcpy($arrayidx91, $arraydecay92); //@line 678 "numbers.cpp"
          ; //@line 679 "numbers.cpp"
        }
  
        var $56=$n_bytes; //@line 680 "numbers.cpp"
        $retval=$56; //@line 680 "numbers.cpp"
        ; //@line 680 "numbers.cpp"
      }
    } while(0);
  
    var $57=$retval; //@line 681 "numbers.cpp"
    STACKTOP = __stackBase__;
    return $57; //@line 681 "numbers.cpp"
    return null;
  }
  

  function __Z17SetSpellingStressP10TranslatorPcii($tr, $phonemes, $control, $n_chars) {
    var __stackBase__  = STACKTOP; STACKTOP += 160; _memset(__stackBase__, 0, 160);
    var __label__;
    var __lastLabel__ = null;
  
    var $tr_addr;
    var $phonemes_addr;
    var $control_addr;
    var $n_chars_addr;
    var $ix;
    var $c;
    var $n_stress;
    var $count;
    var $buf=__stackBase__;
    $tr_addr=$tr;
    $phonemes_addr=$phonemes;
    $control_addr=$control;
    $n_chars_addr=$n_chars;
    $n_stress=0; //@line 690 "numbers.cpp"
    $ix=0; //@line 694 "numbers.cpp"
    var $0=$ix; //@line 694 "numbers.cpp"
    var $1=$phonemes_addr; //@line 694 "numbers.cpp"
    var $arrayidx4=(($1+$0)&4294967295); //@line 694 "numbers.cpp"
    var $2=HEAP8[($arrayidx4)]; //@line 694 "numbers.cpp"
    var $conv5=(tempInt=(($2)),(tempInt>=128?tempInt-256:tempInt)); //@line 694 "numbers.cpp"
    $c=$conv5; //@line 694 "numbers.cpp"
    var $cmp6=((($conv5))|0)!=0; //@line 694 "numbers.cpp"
    if ($cmp6) { __lastLabel__ = 0; __label__ = 1;; } else { __lastLabel__ = 0; __label__ = 4;; } //@line 694 "numbers.cpp"
    $for_body$$for_end$2: do { 
      if (__label__ == 1) {
        while(1) { 
  
          var $3=__lastLabel__ == 0 ? $conv5 : ($conv); //@line 696 "numbers.cpp"
          var $cmp1=((($3))|0)==6; //@line 696 "numbers.cpp"
          if ($cmp1) { __label__ = 2;; } else { __label__ = 3;; } //@line 696 "numbers.cpp"
          if (__label__ == 2) {
  
            var $4=$n_stress; //@line 698 "numbers.cpp"
            var $inc=((($4)+1)&4294967295); //@line 698 "numbers.cpp"
            $n_stress=$inc; //@line 698 "numbers.cpp"
            ; //@line 699 "numbers.cpp"
          }
  
          var $5=$c; //@line 700 "numbers.cpp"
          var $conv2=((($5)) & 255); //@line 700 "numbers.cpp"
          var $6=$ix; //@line 700 "numbers.cpp"
          var $arrayidx3=(($buf+$6)&4294967295); //@line 700 "numbers.cpp"
          HEAP8[($arrayidx3)]=$conv2; //@line 700 "numbers.cpp"
          var $7=$ix; //@line 694 "numbers.cpp"
          var $inc4=((($7)+1)&4294967295); //@line 694 "numbers.cpp"
          $ix=$inc4; //@line 694 "numbers.cpp"
          var $8=$ix; //@line 694 "numbers.cpp"
          var $9=$phonemes_addr; //@line 694 "numbers.cpp"
          var $arrayidx=(($9+$8)&4294967295); //@line 694 "numbers.cpp"
          var $10=HEAP8[($arrayidx)]; //@line 694 "numbers.cpp"
          var $conv=(tempInt=(($10)),(tempInt>=128?tempInt-256:tempInt)); //@line 694 "numbers.cpp"
          $c=$conv; //@line 694 "numbers.cpp"
          var $cmp=((($conv))|0)!=0; //@line 694 "numbers.cpp"
          if ($cmp) { __lastLabel__ = 3; __label__ = 1;continue ; } else { __lastLabel__ = 3; __label__ = 4;break $for_body$$for_end$2; } //@line 694 "numbers.cpp"
        }
      }
    } while(0);
  
    var $11=$ix; //@line 702 "numbers.cpp"
    var $arrayidx5=(($buf+$11)&4294967295); //@line 702 "numbers.cpp"
    HEAP8[($arrayidx5)]=0; //@line 702 "numbers.cpp"
    $count=0; //@line 704 "numbers.cpp"
    $ix=0; //@line 705 "numbers.cpp"
    var $12=$ix; //@line 705 "numbers.cpp"
    var $arrayidx71=(($buf+$12)&4294967295); //@line 705 "numbers.cpp"
    var $13=HEAPU8[($arrayidx71)]; //@line 705 "numbers.cpp"
    var $conv82=((($13))&255); //@line 705 "numbers.cpp"
    $c=$conv82; //@line 705 "numbers.cpp"
    var $cmp93=((($conv82))|0)!=0; //@line 705 "numbers.cpp"
    if ($cmp93) { __lastLabel__ = 4; __label__ = 5;; } else { __lastLabel__ = 4; __label__ = 26;; } //@line 705 "numbers.cpp"
    $for_body10$$for_end52$9: do { 
      if (__label__ == 5) {
        $for_body10$10: while(1) { 
  
          var $14=__lastLabel__ == 4 ? $conv82 : ($conv8); //@line 707 "numbers.cpp"
          var $cmp11=((($14))|0)==6; //@line 707 "numbers.cpp"
          if ($cmp11) { __lastLabel__ = 5; __label__ = 6;; } else { __lastLabel__ = 5; __label__ = 15;; } //@line 707 "numbers.cpp"
          $land_lhs_true$$if_else29$12: do { 
            if (__label__ == 6) {
  
              var $15=$n_chars_addr; //@line 707 "numbers.cpp"
              var $cmp12=((($15))|0) > 1; //@line 707 "numbers.cpp"
              if ($cmp12) { __label__ = 7;; } else { __label__ = 14;; } //@line 707 "numbers.cpp"
              if (__label__ == 7) {
  
                var $16=$count; //@line 709 "numbers.cpp"
                var $inc14=((($16)+1)&4294967295); //@line 709 "numbers.cpp"
                $count=$inc14; //@line 709 "numbers.cpp"
                var $17=$tr_addr; //@line 711 "numbers.cpp"
                var $langopts=(($17)&4294967295); //@line 711 "numbers.cpp"
                var $spelling_stress=(($langopts+249)&4294967295); //@line 711 "numbers.cpp"
                var $18=HEAP8[($spelling_stress)]; //@line 711 "numbers.cpp"
                var $conv15=(tempInt=(($18)),(tempInt>=128?tempInt-256:tempInt)); //@line 711 "numbers.cpp"
                var $cmp16=((($conv15))|0)==1; //@line 711 "numbers.cpp"
                var $19=$count; //@line 714 "numbers.cpp"
                if ($cmp16) { __label__ = 8;; } else { __label__ = 10;; } //@line 711 "numbers.cpp"
                if (__label__ == 8) {
  
                  var $cmp18=((($19))|0) > 1; //@line 714 "numbers.cpp"
                  if (!($cmp18)) { __label__ = 24;break $land_lhs_true$$if_else29$12; } //@line 714 "numbers.cpp"
  
                  $c=5; //@line 715 "numbers.cpp"
                  __label__ = 24;break $land_lhs_true$$if_else29$12; //@line 715 "numbers.cpp"
                }
                else if (__label__ == 10) {
  
                  var $20=$n_stress; //@line 719 "numbers.cpp"
                  var $cmp21=((($19))|0)!=((($20))|0); //@line 719 "numbers.cpp"
                  if (!($cmp21)) { __label__ = 24;break $land_lhs_true$$if_else29$12; } //@line 719 "numbers.cpp"
  
                  var $21=$count; //@line 721 "numbers.cpp"
                  var $rem=((($21))|0)%3; //@line 721 "numbers.cpp"
                  var $cmp23=((($rem))|0)!=0; //@line 721 "numbers.cpp"
                  if ($cmp23) { __label__ = 13;; } else { __label__ = 12;; } //@line 721 "numbers.cpp"
                  if (__label__ == 12) {
  
                    var $22=$count; //@line 721 "numbers.cpp"
                    var $23=$n_stress; //@line 721 "numbers.cpp"
                    var $sub=((($23)-1)&4294967295); //@line 721 "numbers.cpp"
                    var $cmp24=((($22))|0)==((($sub))|0); //@line 721 "numbers.cpp"
                    if (!($cmp24)) { __label__ = 24;break $land_lhs_true$$if_else29$12; } //@line 721 "numbers.cpp"
                  }
  
                  $c=5; //@line 722 "numbers.cpp"
                  __label__ = 24;break $land_lhs_true$$if_else29$12; //@line 722 "numbers.cpp"
                }
              }
              else if (__label__ == 14) {
  
                var $_pr=$c; //@line 727 "numbers.cpp"
                __lastLabel__ = 14; __label__ = 15;break $land_lhs_true$$if_else29$12;
              }
            }
          } while(0);
          $if_end48$$if_else29$25: do { 
            if (__label__ == 15) {
  
              var $24=__lastLabel__ == 14 ? $_pr : ($14); //@line 727 "numbers.cpp"
              var $cmp30=((($24))|0)==255; //@line 727 "numbers.cpp"
              if (!($cmp30)) { __label__ = 24;break $if_end48$$if_else29$25; } //@line 727 "numbers.cpp"
  
              var $25=$control_addr; //@line 729 "numbers.cpp"
              var $cmp32=((($25))|0) < 2; //@line 729 "numbers.cpp"
              if ($cmp32) { __label__ = 25;break $if_end48$$if_else29$25; } //@line 729 "numbers.cpp"
  
              var $26=$ix; //@line 729 "numbers.cpp"
              var $cmp34=((($26))|0)==0; //@line 729 "numbers.cpp"
              if ($cmp34) { __label__ = 25;break $if_end48$$if_else29$25; } //@line 729 "numbers.cpp"
  
              var $27=$control_addr; //@line 732 "numbers.cpp"
              var $cmp37=((($27))|0)==4; //@line 732 "numbers.cpp"
              if ($cmp37) { __label__ = 19;; } else { __label__ = 20;; } //@line 732 "numbers.cpp"
              if (__label__ == 19) {
  
                $c=9; //@line 733 "numbers.cpp"
                ; //@line 733 "numbers.cpp"
              }
  
              var $28=$count; //@line 734 "numbers.cpp"
              var $rem40=((($28))|0)%3; //@line 734 "numbers.cpp"
              var $cmp41=((($rem40))|0)==0; //@line 734 "numbers.cpp"
              if ($cmp41) { __label__ = 22;; } else { __label__ = 21;; } //@line 734 "numbers.cpp"
              $if_then44$$lor_lhs_false42$33: do { 
                if (__label__ == 21) {
  
                  var $29=$control_addr; //@line 734 "numbers.cpp"
                  var $cmp43=((($29))|0) > 2; //@line 734 "numbers.cpp"
                  if ($cmp43) { __label__ = 22;break $if_then44$$lor_lhs_false42$33; } //@line 734 "numbers.cpp"
  
                  $c=23; //@line 737 "numbers.cpp"
                  __label__ = 24;break $if_end48$$if_else29$25;
                }
              } while(0);
  
              $c=11; //@line 735 "numbers.cpp"
              __label__ = 24;break $if_end48$$if_else29$25; //@line 735 "numbers.cpp"
            }
          } while(0);
          if (__label__ == 24) {
  
            var $30=$c; //@line 741 "numbers.cpp"
            var $conv49=((($30)) & 255); //@line 741 "numbers.cpp"
            var $31=$phonemes_addr; //@line 741 "numbers.cpp"
            var $incdec_ptr=(($31+1)&4294967295); //@line 741 "numbers.cpp"
            $phonemes_addr=$incdec_ptr; //@line 741 "numbers.cpp"
            HEAP8[($31)]=$conv49; //@line 741 "numbers.cpp"
            ; //@line 742 "numbers.cpp"
          }
  
          var $32=$ix; //@line 705 "numbers.cpp"
          var $inc51=((($32)+1)&4294967295); //@line 705 "numbers.cpp"
          $ix=$inc51; //@line 705 "numbers.cpp"
          var $33=$ix; //@line 705 "numbers.cpp"
          var $arrayidx7=(($buf+$33)&4294967295); //@line 705 "numbers.cpp"
          var $34=HEAPU8[($arrayidx7)]; //@line 705 "numbers.cpp"
          var $conv8=((($34))&255); //@line 705 "numbers.cpp"
          $c=$conv8; //@line 705 "numbers.cpp"
          var $cmp9=((($conv8))|0)!=0; //@line 705 "numbers.cpp"
          if ($cmp9) { __lastLabel__ = 25; __label__ = 5;continue $for_body10$10; } else { __lastLabel__ = 25; __label__ = 26;break $for_body10$$for_end52$9; } //@line 705 "numbers.cpp"
        }
      }
    } while(0);
  
    var $35=$control_addr; //@line 743 "numbers.cpp"
    var $cmp53=((($35))|0) >= 2; //@line 743 "numbers.cpp"
    if ($cmp53) { __label__ = 27;; } else { __label__ = 28;; } //@line 743 "numbers.cpp"
    if (__label__ == 27) {
  
      var $36=$phonemes_addr; //@line 744 "numbers.cpp"
      var $incdec_ptr55=(($36+1)&4294967295); //@line 744 "numbers.cpp"
      $phonemes_addr=$incdec_ptr55; //@line 744 "numbers.cpp"
      HEAP8[($36)]=11; //@line 744 "numbers.cpp"
      ; //@line 744 "numbers.cpp"
    }
  
    var $37=$phonemes_addr; //@line 745 "numbers.cpp"
    HEAP8[($37)]=0; //@line 745 "numbers.cpp"
    STACKTOP = __stackBase__;
    return; //@line 746 "numbers.cpp"
    return;
  }
  

  function __Z14TranslateRomanP10TranslatorPcS1_P8WORD_TAB($tr, $word, $ph_out, $wtab) {
    var __stackBase__  = STACKTOP; STACKTOP += 200; _memset(__stackBase__, 0, 200);
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $tr_addr;
    var $word_addr;
    var $ph_out_addr;
    var $wtab_addr;
    var $c;
    var $p;
    var $p2;
    var $acc;
    var $prev;
    var $value;
    var $subtract;
    var $repeat;
    var $n_digits;
    var $word_start;
    var $num_control;
    var $flags=__stackBase__;
    var $ph_roman=__stackBase__+8;
    var $number_chars=__stackBase__+40;
    $tr_addr=$tr;
    $word_addr=$word;
    $ph_out_addr=$ph_out;
    $wtab_addr=$wtab;
    $repeat=0; //@line 839 "numbers.cpp"
    $n_digits=0; //@line 840 "numbers.cpp"
    $num_control=0; //@line 842 "numbers.cpp"
    $acc=0; //@line 850 "numbers.cpp"
    $prev=0; //@line 851 "numbers.cpp"
    $subtract=32767; //@line 852 "numbers.cpp"
    var $0=$ph_out_addr; //@line 853 "numbers.cpp"
    var $arrayidx=(($0)&4294967295); //@line 853 "numbers.cpp"
    HEAP8[($arrayidx)]=0; //@line 853 "numbers.cpp"
    var $arrayidx1=(($flags)&4294967295); //@line 854 "numbers.cpp"
    HEAP32[(($arrayidx1)>>2)]=0; //@line 854 "numbers.cpp"
    var $arrayidx2=(($flags+4)&4294967295); //@line 855 "numbers.cpp"
    HEAP32[(($arrayidx2)>>2)]=0; //@line 855 "numbers.cpp"
    var $1=$tr_addr; //@line 857 "numbers.cpp"
    var $langopts=(($1)&4294967295); //@line 857 "numbers.cpp"
    var $numbers=(($langopts+184)&4294967295); //@line 857 "numbers.cpp"
    var $2=HEAP32[(($numbers)>>2)]; //@line 857 "numbers.cpp"
    var $and=($2) & 33554432; //@line 857 "numbers.cpp"
    var $tobool=((($and))|0)!=0; //@line 857 "numbers.cpp"
    if ($tobool) { __label__ = 1;; } else { __label__ = 2;; } //@line 857 "numbers.cpp"
    $land_lhs_true$$lor_lhs_false$2: do { 
      if (__label__ == 1) {
  
        var $3=$wtab_addr; //@line 857 "numbers.cpp"
        var $arrayidx3=(($3)&4294967295); //@line 857 "numbers.cpp"
        var $flags4=(($arrayidx3)&4294967295); //@line 857 "numbers.cpp"
        var $4=HEAP32[(($flags4)>>2)]; //@line 857 "numbers.cpp"
        var $and5=($4) & 1; //@line 857 "numbers.cpp"
        var $tobool6=((($and5))|0)!=0; //@line 857 "numbers.cpp"
        if ($tobool6) { __label__ = 2;break $land_lhs_true$$lor_lhs_false$2; } else { __label__ = 3;break $land_lhs_true$$lor_lhs_false$2; } //@line 857 "numbers.cpp"
      }
    } while(0);
    $lor_lhs_false$$if_then$4: do { 
      if (__label__ == 2) {
  
        var $5=$word_addr; //@line 857 "numbers.cpp"
        var $arrayidx7=(($5+-2)&4294967295); //@line 857 "numbers.cpp"
        var $6=HEAP8[($arrayidx7)]; //@line 857 "numbers.cpp"
        var $conv=(tempInt=(($6)),(tempInt>=128?tempInt-256:tempInt)); //@line 857 "numbers.cpp"
        var $isdigittmp=((($conv)-48)&4294967295); //@line 857 "numbers.cpp"
        var $isdigit=((($isdigittmp))>>>0) < 10; //@line 857 "numbers.cpp"
        var $call=((($isdigit))&1); //@line 857 "numbers.cpp"
        var $tobool8=((($call))|0)!=0; //@line 857 "numbers.cpp"
        if ($tobool8) { __label__ = 3;break $lor_lhs_false$$if_then$4; } //@line 857 "numbers.cpp"
  
        var $7=$word_addr; //@line 860 "numbers.cpp"
        $word_start=$7; //@line 860 "numbers.cpp"
        ; //@line 861 "numbers.cpp"
        $while_cond$7: while(1) { 
  
          var $8=$word_addr; //@line 861 "numbers.cpp"
          var $incdec_ptr=(($8+1)&4294967295); //@line 861 "numbers.cpp"
          $word_addr=$incdec_ptr; //@line 861 "numbers.cpp"
          var $9=HEAP8[($8)]; //@line 861 "numbers.cpp"
          var $conv9=(tempInt=(($9)),(tempInt>=128?tempInt-256:tempInt)); //@line 861 "numbers.cpp"
          $c=$conv9; //@line 861 "numbers.cpp"
          var $cmp=((($conv9))|0)!=32; //@line 861 "numbers.cpp"
          if (!($cmp)) { __label__ = 25;break $while_cond$7; } //@line 861 "numbers.cpp"
  
          var $10=$c; //@line 863 "numbers.cpp"
          var $memchr=_memchr(((__str12309)&4294967295), $10, 8); //@line 863 "numbers.cpp"
          $p2=$memchr; //@line 863 "numbers.cpp"
          var $cmp11=((($memchr))|0)==0; //@line 863 "numbers.cpp"
          if ($cmp11) { __label__ = 7;break $while_cond$7; } //@line 863 "numbers.cpp"
  
          var $11=$p2; //@line 866 "numbers.cpp"
          var $sub_ptr_lhs_cast=($11); //@line 866 "numbers.cpp"
          var $sub_ptr_sub=((($sub_ptr_lhs_cast)-(__str12309))&4294967295); //@line 866 "numbers.cpp"
          var $arrayidx14=((__ZZ14TranslateRomanP10TranslatorPcS1_P8WORD_TABE12roman_values+$sub_ptr_sub*4)&4294967295); //@line 866 "numbers.cpp"
          var $12=HEAP32[(($arrayidx14)>>2)]; //@line 866 "numbers.cpp"
          $value=$12; //@line 866 "numbers.cpp"
          var $13=$value; //@line 867 "numbers.cpp"
          var $14=$prev; //@line 867 "numbers.cpp"
          var $cmp15=((($13))|0)==((($14))|0); //@line 867 "numbers.cpp"
          if ($cmp15) { __label__ = 9;; } else { __label__ = 11;; } //@line 867 "numbers.cpp"
          if (__label__ == 9) {
  
            var $15=$repeat; //@line 869 "numbers.cpp"
            var $inc=((($15)+1)&4294967295); //@line 869 "numbers.cpp"
            $repeat=$inc; //@line 869 "numbers.cpp"
            var $16=$repeat; //@line 870 "numbers.cpp"
            var $cmp17=((($16))|0) >= 3; //@line 870 "numbers.cpp"
            if ($cmp17) { __label__ = 10;break $while_cond$7; } //@line 870 "numbers.cpp"
          }
          else if (__label__ == 11) {
  
            $repeat=0; //@line 874 "numbers.cpp"
            ;
          }
  
          var $17=$prev; //@line 876 "numbers.cpp"
          var $cmp21=((($17))|0) > 1; //@line 876 "numbers.cpp"
          var $18=$prev; //@line 876 "numbers.cpp"
          var $cmp23=((($18))|0)!=10; //@line 876 "numbers.cpp"
          var $or_cond=($cmp21) & ($cmp23); //@line 876 "numbers.cpp"
          var $19=$prev; //@line 876 "numbers.cpp"
          var $cmp25=((($19))|0)!=100; //@line 876 "numbers.cpp"
          var $or_cond1=($or_cond) & ($cmp25); //@line 876 "numbers.cpp"
          if ($or_cond1) { __lastLabel__ = 12; __label__ = 13;; } else { __lastLabel__ = 12; __label__ = 15;; } //@line 876 "numbers.cpp"
          if (__label__ == 13) {
  
            var $20=$value; //@line 878 "numbers.cpp"
            var $21=$prev; //@line 878 "numbers.cpp"
            var $cmp27=((($20))|0) >= ((($21))|0); //@line 878 "numbers.cpp"
            if ($cmp27) { __lastLabel__ = 13; __label__ = 14;break $while_cond$7; } else { __lastLabel__ = 13; ; } //@line 878 "numbers.cpp"
          }
  
          var $22=__lastLabel__ == 13 ? $21 : ($19); //@line 881 "numbers.cpp"
          var $cmp31=((($22))|0)!=0; //@line 881 "numbers.cpp"
          if ($cmp31) { __label__ = 16;; } else { __label__ = 21;; } //@line 881 "numbers.cpp"
          $land_lhs_true32$$if_else40$18: do { 
            if (__label__ == 16) {
  
              var $23=$prev; //@line 881 "numbers.cpp"
              var $24=$value; //@line 881 "numbers.cpp"
              var $cmp33=((($23))|0) < ((($24))|0); //@line 881 "numbers.cpp"
              if (!($cmp33)) { __label__ = 21;break $land_lhs_true32$$if_else40$18; } //@line 881 "numbers.cpp"
  
              var $25=$acc; //@line 883 "numbers.cpp"
              var $rem=((($25))|0)%10; //@line 883 "numbers.cpp"
              var $cmp35=((($rem))|0)!=0; //@line 883 "numbers.cpp"
              if ($cmp35) { __label__ = 19;break $while_cond$7; } //@line 883 "numbers.cpp"
  
              var $26=$prev; //@line 883 "numbers.cpp"
              var $mul=((($26)*10)&4294967295); //@line 883 "numbers.cpp"
              var $27=$value; //@line 883 "numbers.cpp"
              var $cmp37=((($mul))|0) < ((($27))|0); //@line 883 "numbers.cpp"
              if ($cmp37) { __label__ = 19;break $while_cond$7; } //@line 883 "numbers.cpp"
  
              var $28=$prev; //@line 885 "numbers.cpp"
              $subtract=$28; //@line 885 "numbers.cpp"
              var $29=$subtract; //@line 886 "numbers.cpp"
              var $30=$value; //@line 886 "numbers.cpp"
              var $sub=((($30)-($29))&4294967295); //@line 886 "numbers.cpp"
              $value=$sub; //@line 886 "numbers.cpp"
              __label__ = 24;break $land_lhs_true32$$if_else40$18; //@line 887 "numbers.cpp"
            }
          } while(0);
          if (__label__ == 21) {
  
            var $31=$value; //@line 889 "numbers.cpp"
            var $32=$subtract; //@line 889 "numbers.cpp"
            var $cmp41=((($31))|0) >= ((($32))|0); //@line 889 "numbers.cpp"
            if ($cmp41) { __label__ = 22;break $while_cond$7; } //@line 889 "numbers.cpp"
  
            var $33=$prev; //@line 892 "numbers.cpp"
            var $34=$acc; //@line 892 "numbers.cpp"
            var $add=((($34)+($33))&4294967295); //@line 892 "numbers.cpp"
            $acc=$add; //@line 892 "numbers.cpp"
            ;
          }
  
          var $35=$value; //@line 893 "numbers.cpp"
          $prev=$35; //@line 893 "numbers.cpp"
          var $36=$n_digits; //@line 894 "numbers.cpp"
          var $inc46=((($36)+1)&4294967295); //@line 894 "numbers.cpp"
          $n_digits=$inc46; //@line 894 "numbers.cpp"
          __label__ = 5;continue $while_cond$7; //@line 895 "numbers.cpp"
        }
        if (__label__ == 25) {
  
          var $37=$word_addr; //@line 897 "numbers.cpp"
          var $arrayidx47=(($37)&4294967295); //@line 897 "numbers.cpp"
          var $38=HEAP8[($arrayidx47)]; //@line 897 "numbers.cpp"
          var $conv48=(tempInt=(($38)),(tempInt>=128?tempInt-256:tempInt)); //@line 897 "numbers.cpp"
          var $isdigittmp2=((($conv48)-48)&4294967295); //@line 897 "numbers.cpp"
          var $isdigit3=((($isdigittmp2))>>>0) < 10; //@line 897 "numbers.cpp"
          var $call49=((($isdigit3))&1); //@line 897 "numbers.cpp"
          var $tobool50=((($call49))|0)!=0; //@line 897 "numbers.cpp"
          if ($tobool50) { __label__ = 26;; } else { __label__ = 27;; } //@line 897 "numbers.cpp"
          if (__label__ == 26) {
  
            $retval=0; //@line 898 "numbers.cpp"
            __label__ = 48;break $lor_lhs_false$$if_then$4; //@line 898 "numbers.cpp"
          }
          else if (__label__ == 27) {
  
            var $39=$prev; //@line 900 "numbers.cpp"
            var $40=$acc; //@line 900 "numbers.cpp"
            var $add53=((($40)+($39))&4294967295); //@line 900 "numbers.cpp"
            $acc=$add53; //@line 900 "numbers.cpp"
            var $41=$acc; //@line 901 "numbers.cpp"
            var $42=$tr_addr; //@line 901 "numbers.cpp"
            var $langopts54=(($42)&4294967295); //@line 901 "numbers.cpp"
            var $min_roman=(($langopts54+200)&4294967295); //@line 901 "numbers.cpp"
            var $43=HEAP32[(($min_roman)>>2)]; //@line 901 "numbers.cpp"
            var $cmp55=((($41))|0) < ((($43))|0); //@line 901 "numbers.cpp"
            if ($cmp55) { __label__ = 28;; } else { __label__ = 29;; } //@line 901 "numbers.cpp"
            if (__label__ == 28) {
  
              $retval=0; //@line 902 "numbers.cpp"
              __label__ = 48;break $lor_lhs_false$$if_then$4; //@line 902 "numbers.cpp"
            }
            else if (__label__ == 29) {
  
              var $44=$acc; //@line 904 "numbers.cpp"
              var $45=$tr_addr; //@line 904 "numbers.cpp"
              var $langopts58=(($45)&4294967295); //@line 904 "numbers.cpp"
              var $max_roman=(($langopts58+196)&4294967295); //@line 904 "numbers.cpp"
              var $46=HEAP32[(($max_roman)>>2)]; //@line 904 "numbers.cpp"
              var $cmp59=((($44))|0) > ((($46))|0); //@line 904 "numbers.cpp"
              if ($cmp59) { __label__ = 30;; } else { __label__ = 31;; } //@line 904 "numbers.cpp"
              if (__label__ == 30) {
  
                $retval=0; //@line 905 "numbers.cpp"
                __label__ = 48;break $lor_lhs_false$$if_then$4; //@line 905 "numbers.cpp"
              }
              else if (__label__ == 31) {
  
                var $47=$tr_addr; //@line 908 "numbers.cpp"
                var $arraydecay=(($ph_roman)&4294967295); //@line 908 "numbers.cpp"
                var $call62=__Z6LookupP10TranslatorPKcPc($47, ((__str13310)&4294967295), $arraydecay); //@line 908 "numbers.cpp"
                var $48=$ph_out_addr; //@line 909 "numbers.cpp"
                var $arrayidx63=(($48)&4294967295); //@line 909 "numbers.cpp"
                $p=$arrayidx63; //@line 909 "numbers.cpp"
                var $49=$tr_addr; //@line 911 "numbers.cpp"
                var $langopts64=(($49)&4294967295); //@line 911 "numbers.cpp"
                var $numbers65=(($langopts64+184)&4294967295); //@line 911 "numbers.cpp"
                var $50=HEAP32[(($numbers65)>>2)]; //@line 911 "numbers.cpp"
                var $and66=($50) & 67108864; //@line 911 "numbers.cpp"
                var $cmp67=((($and66))|0)==0; //@line 911 "numbers.cpp"
                if ($cmp67) { __label__ = 32;; } else { __label__ = 33;; } //@line 911 "numbers.cpp"
                if (__label__ == 32) {
  
                  var $51=$ph_out_addr; //@line 913 "numbers.cpp"
                  var $arraydecay69=(($ph_roman)&4294967295); //@line 913 "numbers.cpp"
                  var $call70=_strcpy($51, $arraydecay69); //@line 913 "numbers.cpp"
                  var $arraydecay71=(($ph_roman)&4294967295); //@line 914 "numbers.cpp"
                  var $call72=_strlen($arraydecay71); //@line 914 "numbers.cpp"
                  var $52=$ph_out_addr; //@line 914 "numbers.cpp"
                  var $arrayidx73=(($52+$call72)&4294967295); //@line 914 "numbers.cpp"
                  $p=$arrayidx73; //@line 914 "numbers.cpp"
                  ; //@line 915 "numbers.cpp"
                }
  
                var $arraydecay75=(($number_chars)&4294967295); //@line 917 "numbers.cpp"
                var $53=$acc; //@line 917 "numbers.cpp"
                var $call76=_sprintf($arraydecay75, ((__str14311)&4294967295), allocate([$53,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 917 "numbers.cpp"
                var $54=$word_addr; //@line 919 "numbers.cpp"
                var $arrayidx77=(($54)&4294967295); //@line 919 "numbers.cpp"
                var $55=HEAP8[($arrayidx77)]; //@line 919 "numbers.cpp"
                var $conv78=(tempInt=(($55)),(tempInt>=128?tempInt-256:tempInt)); //@line 919 "numbers.cpp"
                var $cmp79=((($conv78))|0)==46; //@line 919 "numbers.cpp"
                if ($cmp79) { __label__ = 34;; } else { __label__ = 35;; } //@line 919 "numbers.cpp"
                if (__label__ == 34) {
  
                  $retval=0; //@line 922 "numbers.cpp"
                  __label__ = 48;break $lor_lhs_false$$if_then$4; //@line 922 "numbers.cpp"
                }
                else if (__label__ == 35) {
  
                  var $56=$tr_addr; //@line 925 "numbers.cpp"
                  var $57=$word_start; //@line 925 "numbers.cpp"
                  var $58=$word_addr; //@line 925 "numbers.cpp"
                  var $59=$wtab_addr; //@line 925 "numbers.cpp"
                  var $call82=__ZL15CheckDotOrdinalP10TranslatorPcS1_P8WORD_TABi($56, $57, $58, $59, 1); //@line 925 "numbers.cpp"
                  var $tobool83=((($call82))|0)!=0; //@line 925 "numbers.cpp"
                  if ($tobool83) { __label__ = 36;; } else { __label__ = 37;; } //@line 925 "numbers.cpp"
                  if (__label__ == 36) {
  
                    var $60=$wtab_addr; //@line 926 "numbers.cpp"
                    var $arrayidx85=(($60)&4294967295); //@line 926 "numbers.cpp"
                    var $flags86=(($arrayidx85)&4294967295); //@line 926 "numbers.cpp"
                    var $61=HEAP32[(($flags86)>>2)]; //@line 926 "numbers.cpp"
                    var $or=($61) | 32768; //@line 926 "numbers.cpp"
                    HEAP32[(($flags86)>>2)]=$or; //@line 926 "numbers.cpp"
                    ; //@line 926 "numbers.cpp"
                  }
  
                  var $62=$tr_addr; //@line 928 "numbers.cpp"
                  var $langopts88=(($62)&4294967295); //@line 928 "numbers.cpp"
                  var $numbers89=(($langopts88+184)&4294967295); //@line 928 "numbers.cpp"
                  var $63=HEAP32[(($numbers89)>>2)]; //@line 928 "numbers.cpp"
                  var $and90=($63) & 134217728; //@line 928 "numbers.cpp"
                  var $tobool91=((($and90))|0)!=0; //@line 928 "numbers.cpp"
                  if ($tobool91) { __label__ = 38;; } else { __label__ = 45;; } //@line 928 "numbers.cpp"
                  $if_then92$$if_end117$47: do { 
                    if (__label__ == 38) {
  
                      var $64=$tr_addr; //@line 930 "numbers.cpp"
                      var $translator_name=(($64+280)&4294967295); //@line 930 "numbers.cpp"
                      var $65=HEAP32[(($translator_name)>>2)]; //@line 930 "numbers.cpp"
                      var $cmp93=((($65))|0)==26741; //@line 930 "numbers.cpp"
                      var $66=$wtab_addr; //@line 932 "numbers.cpp"
                      var $arrayidx95=(($66)&4294967295); //@line 932 "numbers.cpp"
                      var $flags96=(($arrayidx95)&4294967295); //@line 932 "numbers.cpp"
                      var $67=HEAP32[(($flags96)>>2)]; //@line 932 "numbers.cpp"
                      if ($cmp93) { __label__ = 39;; } else { __label__ = 44;; } //@line 930 "numbers.cpp"
                      if (__label__ == 39) {
  
                        var $and97=($67) & 32768; //@line 932 "numbers.cpp"
                        var $tobool98=((($and97))|0)!=0; //@line 932 "numbers.cpp"
                        if ($tobool98) { __label__ = 45;break $if_then92$$if_end117$47; } //@line 932 "numbers.cpp"
  
                        var $68=$wtab_addr; //@line 934 "numbers.cpp"
                        var $arrayidx100=(($68)&4294967295); //@line 934 "numbers.cpp"
                        var $flags101=(($arrayidx100)&4294967295); //@line 934 "numbers.cpp"
                        var $69=HEAP32[(($flags101)>>2)]; //@line 934 "numbers.cpp"
                        var $and102=($69) & 16384; //@line 934 "numbers.cpp"
                        var $tobool103=((($and102))|0)!=0; //@line 934 "numbers.cpp"
                        if ($tobool103) { __label__ = 41;; } else { __label__ = 43;; } //@line 934 "numbers.cpp"
                        $land_lhs_true104$$if_else109$52: do { 
                          if (__label__ == 41) {
  
                            var $70=$word_addr; //@line 934 "numbers.cpp"
                            var $71=$acc; //@line 934 "numbers.cpp"
                            var $call105=__ZL11hu_number_ePKcii($70, 0, $71); //@line 934 "numbers.cpp"
                            var $tobool106=((($call105))|0)!=0; //@line 934 "numbers.cpp"
                            if (!($tobool106)) { __label__ = 43;break $land_lhs_true104$$if_else109$52; } //@line 934 "numbers.cpp"
  
                            var $72=$num_control; //@line 937 "numbers.cpp"
                            var $or108=($72) | 1; //@line 937 "numbers.cpp"
                            $num_control=$or108; //@line 937 "numbers.cpp"
                            __label__ = 45;break $if_then92$$if_end117$47; //@line 941 "numbers.cpp"
                          }
                        } while(0);
  
                        $retval=0; //@line 940 "numbers.cpp"
                        __label__ = 48;break $lor_lhs_false$$if_then$4; //@line 940 "numbers.cpp"
                      }
                      else if (__label__ == 44) {
  
                        var $or115=($67) | 32768; //@line 945 "numbers.cpp"
                        HEAP32[(($flags96)>>2)]=$or115; //@line 945 "numbers.cpp"
                        ;
                      }
                    }
                  } while(0);
  
                  var $73=$tr_addr; //@line 949 "numbers.cpp"
                  var $prev_dict_flags=(($73+8320)&4294967295); //@line 949 "numbers.cpp"
                  HEAP32[(($prev_dict_flags)>>2)]=0; //@line 949 "numbers.cpp"
                  var $74=$tr_addr; //@line 950 "numbers.cpp"
                  var $arrayidx118=(($number_chars+2)&4294967295); //@line 950 "numbers.cpp"
                  var $75=$p; //@line 950 "numbers.cpp"
                  var $arraydecay119=(($flags)&4294967295); //@line 950 "numbers.cpp"
                  var $76=$wtab_addr; //@line 950 "numbers.cpp"
                  var $77=$num_control; //@line 950 "numbers.cpp"
                  var $call120=__Z15TranslateNumberP10TranslatorPcS1_PjP8WORD_TABi($74, $arrayidx118, $75, $arraydecay119, $76, $77); //@line 950 "numbers.cpp"
                  var $78=$tr_addr; //@line 952 "numbers.cpp"
                  var $langopts121=(($78)&4294967295); //@line 952 "numbers.cpp"
                  var $numbers122=(($langopts121+184)&4294967295); //@line 952 "numbers.cpp"
                  var $79=HEAP32[(($numbers122)>>2)]; //@line 952 "numbers.cpp"
                  var $and123=($79) & 67108864; //@line 952 "numbers.cpp"
                  var $tobool124=((($and123))|0)!=0; //@line 952 "numbers.cpp"
                  if ($tobool124) { __label__ = 46;; } else { __label__ = 47;; } //@line 952 "numbers.cpp"
                  if (__label__ == 46) {
  
                    var $80=$ph_out_addr; //@line 953 "numbers.cpp"
                    var $arraydecay126=(($ph_roman)&4294967295); //@line 953 "numbers.cpp"
                    var $call127=_strcat($80, $arraydecay126); //@line 953 "numbers.cpp"
                    ; //@line 953 "numbers.cpp"
                  }
  
                  $retval=1; //@line 955 "numbers.cpp"
                  __label__ = 48;break $lor_lhs_false$$if_then$4; //@line 955 "numbers.cpp"
                }
              }
            }
          }
        }
        else if (__label__ == 7) {
  
          $retval=0; //@line 864 "numbers.cpp"
          __label__ = 48;break $lor_lhs_false$$if_then$4; //@line 864 "numbers.cpp"
        }
        else if (__label__ == 10) {
  
          $retval=0; //@line 871 "numbers.cpp"
          __label__ = 48;break $lor_lhs_false$$if_then$4; //@line 871 "numbers.cpp"
        }
        else if (__label__ == 14) {
  
          $retval=0; //@line 879 "numbers.cpp"
          __label__ = 48;break $lor_lhs_false$$if_then$4; //@line 879 "numbers.cpp"
        }
        else if (__label__ == 19) {
  
          $retval=0; //@line 884 "numbers.cpp"
          __label__ = 48;break $lor_lhs_false$$if_then$4; //@line 884 "numbers.cpp"
        }
        else if (__label__ == 22) {
  
          $retval=0; //@line 890 "numbers.cpp"
          __label__ = 48;break $lor_lhs_false$$if_then$4; //@line 890 "numbers.cpp"
        }
      }
    } while(0);
    if (__label__ == 3) {
  
      $retval=0; //@line 858 "numbers.cpp"
      ; //@line 858 "numbers.cpp"
    }
  
    var $81=$retval; //@line 956 "numbers.cpp"
    STACKTOP = __stackBase__;
    return $81; //@line 956 "numbers.cpp"
    return null;
  }
  

  function __ZL15CheckDotOrdinalP10TranslatorPcS1_P8WORD_TABi($tr, $word, $word_end, $wtab, $roman) {
    var __stackBase__  = STACKTOP; STACKTOP += 4; _memset(__stackBase__, 0, 4);
    var __label__;
  
    var $tr_addr;
    var $word_addr;
    var $word_end_addr;
    var $wtab_addr;
    var $roman_addr;
    var $ordinal;
    var $c2=__stackBase__;
    var $nextflags;
    $tr_addr=$tr;
    $word_addr=$word;
    $word_end_addr=$word_end;
    $wtab_addr=$wtab;
    $roman_addr=$roman;
    $ordinal=0; //@line 758 "numbers.cpp"
    var $0=$tr_addr; //@line 762 "numbers.cpp"
    var $langopts=(($0)&4294967295); //@line 762 "numbers.cpp"
    var $numbers=(($langopts+184)&4294967295); //@line 762 "numbers.cpp"
    var $1=HEAP32[(($numbers)>>2)]; //@line 762 "numbers.cpp"
    var $and=($1) & 65536; //@line 762 "numbers.cpp"
    var $tobool=((($and))|0)!=0; //@line 762 "numbers.cpp"
    if ($tobool) { __label__ = 1;; } else { __label__ = 32;; } //@line 762 "numbers.cpp"
    $land_lhs_true$$if_end92$2: do { 
      if (__label__ == 1) {
  
        var $2=$word_end_addr; //@line 762 "numbers.cpp"
        var $arrayidx=(($2)&4294967295); //@line 762 "numbers.cpp"
        var $3=HEAP8[($arrayidx)]; //@line 762 "numbers.cpp"
        var $conv=(tempInt=(($3)),(tempInt>=128?tempInt-256:tempInt)); //@line 762 "numbers.cpp"
        var $cmp=((($conv))|0)==46; //@line 762 "numbers.cpp"
        if ($cmp) { __label__ = 3;; } else { __label__ = 2;; } //@line 762 "numbers.cpp"
        if (__label__ == 2) {
  
          var $4=$wtab_addr; //@line 762 "numbers.cpp"
          var $arrayidx1=(($4)&4294967295); //@line 762 "numbers.cpp"
          var $flags=(($arrayidx1)&4294967295); //@line 762 "numbers.cpp"
          var $5=HEAP32[(($flags)>>2)]; //@line 762 "numbers.cpp"
          var $and2=($5) & 65536; //@line 762 "numbers.cpp"
          var $tobool3=((($and2))|0)!=0; //@line 762 "numbers.cpp"
          if (!($tobool3)) { __label__ = 32;break $land_lhs_true$$if_end92$2; } //@line 762 "numbers.cpp"
        }
  
        var $6=$wtab_addr; //@line 762 "numbers.cpp"
        var $arrayidx5=(($6+12)&4294967295); //@line 762 "numbers.cpp"
        var $flags6=(($arrayidx5)&4294967295); //@line 762 "numbers.cpp"
        var $7=HEAP32[(($flags6)>>2)]; //@line 762 "numbers.cpp"
        var $and7=($7) & 256; //@line 762 "numbers.cpp"
        var $tobool8=((($and7))|0)!=0; //@line 762 "numbers.cpp"
        if ($tobool8) { __label__ = 32;break $land_lhs_true$$if_end92$2; } //@line 762 "numbers.cpp"
  
        var $8=$roman_addr; //@line 764 "numbers.cpp"
        var $tobool9=((($8))|0)!=0; //@line 764 "numbers.cpp"
        if ($tobool9) { __label__ = 6;; } else { __label__ = 5;; } //@line 764 "numbers.cpp"
        if (__label__ == 5) {
  
          var $9=$wtab_addr; //@line 764 "numbers.cpp"
          var $arrayidx11=(($9+12)&4294967295); //@line 764 "numbers.cpp"
          var $flags12=(($arrayidx11)&4294967295); //@line 764 "numbers.cpp"
          var $10=HEAP32[(($flags12)>>2)]; //@line 764 "numbers.cpp"
          var $and13=($10) & 2; //@line 764 "numbers.cpp"
          var $tobool14=((($and13))|0)!=0; //@line 764 "numbers.cpp"
          if ($tobool14) { __label__ = 32;break $land_lhs_true$$if_end92$2; } //@line 764 "numbers.cpp"
        }
  
        var $11=$word_end_addr; //@line 766 "numbers.cpp"
        var $arrayidx16=(($11)&4294967295); //@line 766 "numbers.cpp"
        var $12=HEAP8[($arrayidx16)]; //@line 766 "numbers.cpp"
        var $conv17=(tempInt=(($12)),(tempInt>=128?tempInt-256:tempInt)); //@line 766 "numbers.cpp"
        var $cmp18=((($conv17))|0)==46; //@line 766 "numbers.cpp"
        var $13=$word_end_addr; //@line 767 "numbers.cpp"
        if ($cmp18) { __label__ = 7;; } else { __label__ = 8;; } //@line 766 "numbers.cpp"
        if (__label__ == 7) {
  
          var $arrayidx20=(($13+2)&4294967295); //@line 767 "numbers.cpp"
          var $call=__Z7utf8_inPiPKc($c2, $arrayidx20); //@line 767 "numbers.cpp"
          ; //@line 767 "numbers.cpp"
        }
        else if (__label__ == 8) {
  
          var $arrayidx21=(($13)&4294967295); //@line 769 "numbers.cpp"
          var $call22=__Z7utf8_inPiPKc($c2, $arrayidx21); //@line 769 "numbers.cpp"
          ;
        }
  
        var $14=$word_end_addr; //@line 771 "numbers.cpp"
        var $arrayidx23=(($14)&4294967295); //@line 771 "numbers.cpp"
        var $15=HEAP8[($arrayidx23)]; //@line 771 "numbers.cpp"
        var $conv24=(tempInt=(($15)),(tempInt>=128?tempInt-256:tempInt)); //@line 771 "numbers.cpp"
        var $cmp25=((($conv24))|0)!=0; //@line 771 "numbers.cpp"
        if (!($cmp25)) { __label__ = 32;break $land_lhs_true$$if_end92$2; } //@line 771 "numbers.cpp"
  
        var $16=$word_end_addr; //@line 771 "numbers.cpp"
        var $arrayidx27=(($16+1)&4294967295); //@line 771 "numbers.cpp"
        var $17=HEAP8[($arrayidx27)]; //@line 771 "numbers.cpp"
        var $conv28=(tempInt=(($17)),(tempInt>=128?tempInt-256:tempInt)); //@line 771 "numbers.cpp"
        var $cmp29=((($conv28))|0)!=0; //@line 771 "numbers.cpp"
        if (!($cmp29)) { __label__ = 32;break $land_lhs_true$$if_end92$2; } //@line 771 "numbers.cpp"
  
        var $18=HEAP32[(($c2)>>2)]; //@line 771 "numbers.cpp"
        var $cmp31=((($18))|0)==0; //@line 771 "numbers.cpp"
        if ($cmp31) { __label__ = 14;; } else { __label__ = 12;; } //@line 771 "numbers.cpp"
        $if_then40$$lor_lhs_false32$17: do { 
          if (__label__ == 12) {
  
            var $19=$wtab_addr; //@line 771 "numbers.cpp"
            var $arrayidx33=(($19)&4294967295); //@line 771 "numbers.cpp"
            var $flags34=(($arrayidx33)&4294967295); //@line 771 "numbers.cpp"
            var $20=HEAP32[(($flags34)>>2)]; //@line 771 "numbers.cpp"
            var $and35=($20) & 131072; //@line 771 "numbers.cpp"
            var $tobool36=((($and35))|0)!=0; //@line 771 "numbers.cpp"
            if ($tobool36) { __label__ = 14;break $if_then40$$lor_lhs_false32$17; } //@line 771 "numbers.cpp"
  
            var $21=HEAP32[(($c2)>>2)]; //@line 771 "numbers.cpp"
            var $call38=__Z7IsAlphaj($21); //@line 771 "numbers.cpp"
            var $tobool39=((($call38))|0)!=0; //@line 771 "numbers.cpp"
            if (!($tobool39)) { __label__ = 32;break $land_lhs_true$$if_end92$2; } //@line 771 "numbers.cpp"
          }
        } while(0);
  
        $ordinal=2; //@line 776 "numbers.cpp"
        var $22=$word_end_addr; //@line 777 "numbers.cpp"
        var $arrayidx41=(($22)&4294967295); //@line 777 "numbers.cpp"
        var $23=HEAP8[($arrayidx41)]; //@line 777 "numbers.cpp"
        var $conv42=(tempInt=(($23)),(tempInt>=128?tempInt-256:tempInt)); //@line 777 "numbers.cpp"
        var $cmp43=((($conv42))|0)==46; //@line 777 "numbers.cpp"
        if ($cmp43) { __label__ = 15;; } else { __label__ = 16;; } //@line 777 "numbers.cpp"
        if (__label__ == 15) {
  
          var $24=$word_end_addr; //@line 778 "numbers.cpp"
          var $arrayidx45=(($24)&4294967295); //@line 778 "numbers.cpp"
          HEAP8[($arrayidx45)]=32; //@line 778 "numbers.cpp"
          ; //@line 778 "numbers.cpp"
        }
  
        var $25=$roman_addr; //@line 780 "numbers.cpp"
        var $cmp47=((($25))|0)==0; //@line 780 "numbers.cpp"
        if (!($cmp47)) { __label__ = 32;break $land_lhs_true$$if_end92$2; } //@line 780 "numbers.cpp"
  
        var $26=$tr_addr; //@line 780 "numbers.cpp"
        var $translator_name=(($26+280)&4294967295); //@line 780 "numbers.cpp"
        var $27=HEAP32[(($translator_name)>>2)]; //@line 780 "numbers.cpp"
        var $cmp49=((($27))|0)==26741; //@line 780 "numbers.cpp"
        if (!($cmp49)) { __label__ = 32;break $land_lhs_true$$if_end92$2; } //@line 780 "numbers.cpp"
  
        $nextflags=0; //@line 783 "numbers.cpp"
        var $28=HEAP32[(($c2)>>2)]; //@line 784 "numbers.cpp"
        var $call51=__Z7IsAlphaj($28); //@line 784 "numbers.cpp"
        var $tobool52=((($call51))|0)!=0; //@line 784 "numbers.cpp"
        if ($tobool52) { __label__ = 19;; } else { __label__ = 20;; } //@line 784 "numbers.cpp"
        if (__label__ == 19) {
  
          var $29=$tr_addr; //@line 786 "numbers.cpp"
          var $30=$word_end_addr; //@line 786 "numbers.cpp"
          var $arrayidx54=(($30+2)&4294967295); //@line 786 "numbers.cpp"
          var $call55=__Z13TranslateWordP10TranslatorPciP8WORD_TAB($29, $arrayidx54, 0, 0); //@line 786 "numbers.cpp"
          $nextflags=$call55; //@line 786 "numbers.cpp"
          ; //@line 787 "numbers.cpp"
        }
  
        var $31=$tr_addr; //@line 789 "numbers.cpp"
        var $prev_dict_flags=(($31+8320)&4294967295); //@line 789 "numbers.cpp"
        var $32=HEAP32[(($prev_dict_flags)>>2)]; //@line 789 "numbers.cpp"
        var $and57=($32) & 1048576; //@line 789 "numbers.cpp"
        var $tobool58=((($and57))|0)!=0; //@line 789 "numbers.cpp"
        if ($tobool58) { __label__ = 21;; } else { __label__ = 25;; } //@line 789 "numbers.cpp"
        $land_lhs_true59$$if_end70$29: do { 
          if (__label__ == 21) {
  
            var $33=HEAP32[(($c2)>>2)]; //@line 789 "numbers.cpp"
            var $cmp60=((($33))|0)==0; //@line 789 "numbers.cpp"
            if ($cmp60) { __label__ = 24;; } else { __label__ = 22;; } //@line 789 "numbers.cpp"
            $if_then69$$lor_lhs_false61$31: do { 
              if (__label__ == 22) {
  
                var $34=$wtab_addr; //@line 789 "numbers.cpp"
                var $arrayidx62=(($34)&4294967295); //@line 789 "numbers.cpp"
                var $flags63=(($arrayidx62)&4294967295); //@line 789 "numbers.cpp"
                var $35=HEAP32[(($flags63)>>2)]; //@line 789 "numbers.cpp"
                var $and64=($35) & 131072; //@line 789 "numbers.cpp"
                var $tobool65=((($and64))|0)!=0; //@line 789 "numbers.cpp"
                if ($tobool65) { __label__ = 24;break $if_then69$$lor_lhs_false61$31; } //@line 789 "numbers.cpp"
  
                var $36=HEAP32[(($c2)>>2)]; //@line 789 "numbers.cpp"
                var $call67=_iswdigit($36); //@line 789 "numbers.cpp"
                var $tobool68=((($call67))|0)!=0; //@line 789 "numbers.cpp"
                if (!($tobool68)) { __label__ = 25;break $land_lhs_true59$$if_end70$29; } //@line 789 "numbers.cpp"
              }
            } while(0);
  
            $ordinal=0; //@line 790 "numbers.cpp"
            ; //@line 790 "numbers.cpp"
          }
        } while(0);
  
        var $37=$nextflags; //@line 792 "numbers.cpp"
        var $and71=($37) & 1048576; //@line 792 "numbers.cpp"
        var $tobool72=((($and71))|0)!=0; //@line 792 "numbers.cpp"
        if ($tobool72) { __label__ = 26;; } else { __label__ = 27;; } //@line 792 "numbers.cpp"
        if (__label__ == 26) {
  
          $ordinal=0; //@line 793 "numbers.cpp"
          ; //@line 793 "numbers.cpp"
        }
  
        var $38=$nextflags; //@line 795 "numbers.cpp"
        var $and75=($38) & 4194304; //@line 795 "numbers.cpp"
        var $tobool76=((($and75))|0)!=0; //@line 795 "numbers.cpp"
        if (!($tobool76)) { __label__ = 32;break $land_lhs_true$$if_end92$2; } //@line 795 "numbers.cpp"
  
        var $39=$word_addr; //@line 797 "numbers.cpp"
        var $arrayidx78=(($39+-2)&4294967295); //@line 797 "numbers.cpp"
        var $40=HEAP8[($arrayidx78)]; //@line 797 "numbers.cpp"
        var $conv79=(tempInt=(($40)),(tempInt>=128?tempInt-256:tempInt)); //@line 797 "numbers.cpp"
        var $cmp80=((($conv79))|0)==45; //@line 797 "numbers.cpp"
        if ($cmp80) { __label__ = 29;; } else { __label__ = 30;; } //@line 797 "numbers.cpp"
        if (__label__ == 29) {
  
          $ordinal=0; //@line 798 "numbers.cpp"
          ; //@line 798 "numbers.cpp"
        }
  
        var $41=$tr_addr; //@line 800 "numbers.cpp"
        var $prev_dict_flags83=(($41+8320)&4294967295); //@line 800 "numbers.cpp"
        var $42=HEAP32[(($prev_dict_flags83)>>2)]; //@line 800 "numbers.cpp"
        var $and84=($42) & 5242880; //@line 800 "numbers.cpp"
        var $tobool85=((($and84))|0)!=0; //@line 800 "numbers.cpp"
        if (!($tobool85)) { __label__ = 32;break $land_lhs_true$$if_end92$2; } //@line 800 "numbers.cpp"
  
        $ordinal=34; //@line 801 "numbers.cpp"
        ; //@line 801 "numbers.cpp"
      }
    } while(0);
  
    var $43=$ordinal; //@line 807 "numbers.cpp"
    STACKTOP = __stackBase__;
    return $43; //@line 807 "numbers.cpp"
    return null;
  }
  

  function __ZL11hu_number_ePKcii($word, $thousandplex, $value) {
    ;
    var __label__;
  
    var $retval;
    var $word_addr;
    var $thousandplex_addr;
    var $value_addr;
    $word_addr=$word;
    $thousandplex_addr=$thousandplex;
    $value_addr=$value;
    var $0=$word_addr; //@line 815 "numbers.cpp"
    var $arrayidx=(($0)&4294967295); //@line 815 "numbers.cpp"
    var $1=HEAP8[($arrayidx)]; //@line 815 "numbers.cpp"
    var $conv=(tempInt=(($1)),(tempInt>=128?tempInt-256:tempInt)); //@line 815 "numbers.cpp"
    var $cmp=((($conv))|0)==97; //@line 815 "numbers.cpp"
    if ($cmp) { __label__ = 2;; } else { __label__ = 1;; } //@line 815 "numbers.cpp"
    $if_then$$lor_lhs_false$2: do { 
      if (__label__ == 1) {
  
        var $2=$word_addr; //@line 815 "numbers.cpp"
        var $arrayidx1=(($2)&4294967295); //@line 815 "numbers.cpp"
        var $3=HEAP8[($arrayidx1)]; //@line 815 "numbers.cpp"
        var $conv2=(tempInt=(($3)),(tempInt>=128?tempInt-256:tempInt)); //@line 815 "numbers.cpp"
        var $cmp3=((($conv2))|0)==101; //@line 815 "numbers.cpp"
        if ($cmp3) { __label__ = 2;break $if_then$$lor_lhs_false$2; } //@line 815 "numbers.cpp"
  
        $retval=0; //@line 825 "numbers.cpp"
        __label__ = 13;break $if_then$$lor_lhs_false$2; //@line 825 "numbers.cpp"
      }
    } while(0);
    $if_then$$return$5: do { 
      if (__label__ == 2) {
  
        var $4=$word_addr; //@line 817 "numbers.cpp"
        var $arrayidx4=(($4+1)&4294967295); //@line 817 "numbers.cpp"
        var $5=HEAP8[($arrayidx4)]; //@line 817 "numbers.cpp"
        var $conv5=(tempInt=(($5)),(tempInt>=128?tempInt-256:tempInt)); //@line 817 "numbers.cpp"
        var $cmp6=((($conv5))|0)==32; //@line 817 "numbers.cpp"
        if ($cmp6) { __label__ = 6;; } else { __label__ = 3;; } //@line 817 "numbers.cpp"
        $if_then18$$lor_lhs_false7$7: do { 
          if (__label__ == 3) {
  
            var $6=$word_addr; //@line 817 "numbers.cpp"
            var $arrayidx8=(($6+1)&4294967295); //@line 817 "numbers.cpp"
            var $7=HEAP8[($arrayidx8)]; //@line 817 "numbers.cpp"
            var $conv9=(tempInt=(($7)),(tempInt>=128?tempInt-256:tempInt)); //@line 817 "numbers.cpp"
            var $cmp10=((($conv9))|0)==122; //@line 817 "numbers.cpp"
            if ($cmp10) { __label__ = 6;break $if_then18$$lor_lhs_false7$7; } //@line 817 "numbers.cpp"
  
            var $8=$word_addr; //@line 817 "numbers.cpp"
            var $arrayidx12=(($8+1)&4294967295); //@line 817 "numbers.cpp"
            var $9=HEAP8[($arrayidx12)]; //@line 817 "numbers.cpp"
            var $conv13=(tempInt=(($9)),(tempInt>=128?tempInt-256:tempInt)); //@line 817 "numbers.cpp"
            var $cmp14=((($conv13))|0)==116; //@line 817 "numbers.cpp"
            if ($cmp14) { __label__ = 5;; } else { __label__ = 7;; } //@line 817 "numbers.cpp"
            if (__label__ == 5) {
  
              var $10=$word_addr; //@line 817 "numbers.cpp"
              var $arrayidx15=(($10+2)&4294967295); //@line 817 "numbers.cpp"
              var $11=HEAP8[($arrayidx15)]; //@line 817 "numbers.cpp"
              var $conv16=(tempInt=(($11)),(tempInt>=128?tempInt-256:tempInt)); //@line 817 "numbers.cpp"
              var $cmp17=((($conv16))|0)==116; //@line 817 "numbers.cpp"
              if ($cmp17) { __label__ = 6;break $if_then18$$lor_lhs_false7$7; } //@line 817 "numbers.cpp"
            }
  
            var $12=$thousandplex_addr; //@line 820 "numbers.cpp"
            var $cmp19=((($12))|0)==1; //@line 820 "numbers.cpp"
            if ($cmp19) { __label__ = 9;; } else { __label__ = 8;; } //@line 820 "numbers.cpp"
            $land_lhs_true22$$lor_lhs_false20$13: do { 
              if (__label__ == 8) {
  
                var $13=$value_addr; //@line 820 "numbers.cpp"
                var $rem=((($13))|0)%1000; //@line 820 "numbers.cpp"
                var $cmp21=((($rem))|0)==0; //@line 820 "numbers.cpp"
                if ($cmp21) { __label__ = 9;break $land_lhs_true22$$lor_lhs_false20$13; } else { __label__ = 11;break $land_lhs_true22$$lor_lhs_false20$13; } //@line 820 "numbers.cpp"
              }
            } while(0);
            $land_lhs_true22$$if_end27$15: do { 
              if (__label__ == 9) {
  
                var $14=$word_addr; //@line 820 "numbers.cpp"
                var $arrayidx23=(($14+1)&4294967295); //@line 820 "numbers.cpp"
                var $15=HEAP8[($arrayidx23)]; //@line 820 "numbers.cpp"
                var $conv24=(tempInt=(($15)),(tempInt>=128?tempInt-256:tempInt)); //@line 820 "numbers.cpp"
                var $cmp25=((($conv24))|0)==108; //@line 820 "numbers.cpp"
                if (!($cmp25)) { __label__ = 11;break $land_lhs_true22$$if_end27$15; } //@line 820 "numbers.cpp"
  
                $retval=0; //@line 821 "numbers.cpp"
                __label__ = 13;break $if_then$$return$5; //@line 821 "numbers.cpp"
              }
            } while(0);
  
            $retval=1; //@line 823 "numbers.cpp"
            __label__ = 13;break $if_then$$return$5; //@line 823 "numbers.cpp"
          }
        } while(0);
  
        $retval=0; //@line 818 "numbers.cpp"
        ; //@line 818 "numbers.cpp"
      }
    } while(0);
  
    var $16=$retval; //@line 826 "numbers.cpp"
    ;
    return $16; //@line 826 "numbers.cpp"
    return null;
  }
  

  function __Z15TranslateNumberP10TranslatorPcS1_PjP8WORD_TABi($tr, $word1, $ph_out, $flags, $wtab, $control) {
    ;
    var __label__;
  
    var $retval;
    var $tr_addr;
    var $word1_addr;
    var $ph_out_addr;
    var $flags_addr;
    var $wtab_addr;
    var $control_addr;
    $tr_addr=$tr;
    $word1_addr=$word1;
    $ph_out_addr=$ph_out;
    $flags_addr=$flags;
    $wtab_addr=$wtab;
    $control_addr=$control;
    var $0=HEAP32[((_option_sayas)>>2)]; //@line 1944 "numbers.cpp"
    var $cmp=((($0))|0)==193; //@line 1944 "numbers.cpp"
    if ($cmp) { __label__ = 2;; } else { __label__ = 1;; } //@line 1944 "numbers.cpp"
    $if_then$$lor_lhs_false$2: do { 
      if (__label__ == 1) {
  
        var $1=$wtab_addr; //@line 1944 "numbers.cpp"
        var $arrayidx=(($1)&4294967295); //@line 1944 "numbers.cpp"
        var $flags1=(($arrayidx)&4294967295); //@line 1944 "numbers.cpp"
        var $2=HEAP32[(($flags1)>>2)]; //@line 1944 "numbers.cpp"
        var $and=($2) & 524288; //@line 1944 "numbers.cpp"
        var $tobool=((($and))|0)!=0; //@line 1944 "numbers.cpp"
        if ($tobool) { __label__ = 2;break $if_then$$lor_lhs_false$2; } //@line 1944 "numbers.cpp"
  
        var $3=$tr_addr; //@line 1947 "numbers.cpp"
        var $langopts=(($3)&4294967295); //@line 1947 "numbers.cpp"
        var $numbers=(($langopts+184)&4294967295); //@line 1947 "numbers.cpp"
        var $4=HEAP32[(($numbers)>>2)]; //@line 1947 "numbers.cpp"
        var $cmp2=((($4))|0)!=0; //@line 1947 "numbers.cpp"
        if ($cmp2) { __label__ = 4;; } else { __label__ = 5;; } //@line 1947 "numbers.cpp"
        if (__label__ == 4) {
  
          var $5=$tr_addr; //@line 1948 "numbers.cpp"
          var $6=$word1_addr; //@line 1948 "numbers.cpp"
          var $7=$ph_out_addr; //@line 1948 "numbers.cpp"
          var $8=$flags_addr; //@line 1948 "numbers.cpp"
          var $9=$wtab_addr; //@line 1948 "numbers.cpp"
          var $10=$control_addr; //@line 1948 "numbers.cpp"
          var $call=__ZL17TranslateNumber_1P10TranslatorPcS1_PjP8WORD_TABi($5, $6, $7, $8, $9, $10); //@line 1948 "numbers.cpp"
          $retval=$call; //@line 1948 "numbers.cpp"
          __label__ = 6;break $if_then$$lor_lhs_false$2; //@line 1948 "numbers.cpp"
        }
        else if (__label__ == 5) {
  
          $retval=0; //@line 1950 "numbers.cpp"
          __label__ = 6;break $if_then$$lor_lhs_false$2; //@line 1950 "numbers.cpp"
        }
      }
    } while(0);
    if (__label__ == 2) {
  
      $retval=0; //@line 1945 "numbers.cpp"
      ; //@line 1945 "numbers.cpp"
    }
  
    var $11=$retval; //@line 1951 "numbers.cpp"
    ;
    return $11; //@line 1951 "numbers.cpp"
    return null;
  }
  

  function __ZL17TranslateNumber_1P10TranslatorPcS1_PjP8WORD_TABi($tr, $word, $ph_out, $flags, $wtab, $control) {
    var __stackBase__  = STACKTOP; STACKTOP += 560; _memset(__stackBase__, 0, 560);
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $tr_addr;
    var $word_addr;
    var $ph_out_addr;
    var $flags_addr;
    var $wtab_addr;
    var $control_addr;
    var $n_digits;
    var $value;
    var $ix;
    var $digix;
    var $c;
    var $suppress_null;
    var $decimal_point;
    var $thousandplex;
    var $thousands_exact;
    var $thousands_inc;
    var $prev_thousands;
    var $ordinal;
    var $dot_ordinal;
    var $this_value;
    var $decimal_count;
    var $max_decimal_count;
    var $decimal_mode;
    var $hyphen;
    var $suffix_ix;
    var $skipwords;
    var $p=__stackBase__;
    var $string=__stackBase__+4;
    var $buf1=__stackBase__+24;
    var $ph_append=__stackBase__+124;
    var $ph_buf=__stackBase__+176;
    var $ph_buf2=__stackBase__+376;
    var $ph_zeros=__stackBase__+428;
    var $suffix=__stackBase__+480;
    var $buf_digit_lookup=__stackBase__+500;
    var $p2=__stackBase__+552;
    var $next_char=__stackBase__+556;
    var $p562;
    $tr_addr=$tr;
    $word_addr=$word;
    $ph_out_addr=$ph_out;
    $flags_addr=$flags;
    $wtab_addr=$wtab;
    $control_addr=$control;
    $suppress_null=0; //@line 1577 "numbers.cpp"
    $decimal_point=0; //@line 1578 "numbers.cpp"
    $thousandplex=0; //@line 1579 "numbers.cpp"
    $thousands_exact=1; //@line 1580 "numbers.cpp"
    $thousands_inc=0; //@line 1581 "numbers.cpp"
    $prev_thousands=0; //@line 1582 "numbers.cpp"
    $ordinal=0; //@line 1583 "numbers.cpp"
    $skipwords=0; //@line 1591 "numbers.cpp"
    var $0=$flags_addr; //@line 1604 "numbers.cpp"
    HEAP32[(($0)>>2)]=0; //@line 1604 "numbers.cpp"
    HEAP32[((__ZL14n_digit_lookup)>>2)]=0; //@line 1605 "numbers.cpp"
    var $arrayidx=(($buf_digit_lookup)&4294967295); //@line 1606 "numbers.cpp"
    HEAP8[($arrayidx)]=0; //@line 1606 "numbers.cpp"
    var $arraydecay=(($buf_digit_lookup)&4294967295); //@line 1607 "numbers.cpp"
    HEAP32[((__ZL12digit_lookup)>>2)]=$arraydecay; //@line 1607 "numbers.cpp"
    var $1=$control_addr; //@line 1608 "numbers.cpp"
    HEAP32[((__ZL14number_control)>>2)]=$1; //@line 1608 "numbers.cpp"
    $ix=0; //@line 1610 "numbers.cpp"
    var $2=$ix; //@line 1610 "numbers.cpp"
    var $3=$word_addr; //@line 1610 "numbers.cpp"
    var $arrayidx167=(($3+$2)&4294967295); //@line 1610 "numbers.cpp"
    var $4=HEAP8[($arrayidx167)]; //@line 1610 "numbers.cpp"
    var $conv68=(tempInt=(($4)),(tempInt>=128?tempInt-256:tempInt)); //@line 1610 "numbers.cpp"
    var $isdigittmp69=((($conv68)-48)&4294967295); //@line 1610 "numbers.cpp"
    var $isdigit70=((($isdigittmp69))>>>0) < 10; //@line 1610 "numbers.cpp"
    var $5=$ix; //@line 1610 "numbers.cpp"
    if ($isdigit70) { __lastLabel__ = 0; __label__ = 1;; } else { __lastLabel__ = 0; __label__ = 2;; } //@line 1610 "numbers.cpp"
    $for_inc$$for_end$2: do { 
      if (__label__ == 1) {
        while(1) { 
  
          var $6=__lastLabel__ == 1 ? $10 : ($5);
          var $inc=((($6)+1)&4294967295); //@line 1610 "numbers.cpp"
          $ix=$inc; //@line 1610 "numbers.cpp"
          var $7=$ix; //@line 1610 "numbers.cpp"
          var $8=$word_addr; //@line 1610 "numbers.cpp"
          var $arrayidx1=(($8+$7)&4294967295); //@line 1610 "numbers.cpp"
          var $9=HEAP8[($arrayidx1)]; //@line 1610 "numbers.cpp"
          var $conv=(tempInt=(($9)),(tempInt>=128?tempInt-256:tempInt)); //@line 1610 "numbers.cpp"
          var $isdigittmp=((($conv)-48)&4294967295); //@line 1610 "numbers.cpp"
          var $isdigit=((($isdigittmp))>>>0) < 10; //@line 1610 "numbers.cpp"
          var $call=((($isdigit))&1); //@line 1610 "numbers.cpp"
          var $tobool=((($call))|0)!=0; //@line 1610 "numbers.cpp"
          var $10=$ix; //@line 1610 "numbers.cpp"
          if ($tobool) { __lastLabel__ = 1; __label__ = 1;continue ; } else { __lastLabel__ = 1; __label__ = 2;break $for_inc$$for_end$2; } //@line 1610 "numbers.cpp"
        }
      }
    } while(0);
  
    var $_lcssa65=__lastLabel__ == 0 ? $5 : ($10);
    $n_digits=$_lcssa65; //@line 1611 "numbers.cpp"
    var $11=$word_addr; //@line 1612 "numbers.cpp"
    var $call2=_atoi($11); //@line 1612 "numbers.cpp"
    $this_value=$call2; //@line 1612 "numbers.cpp"
    $value=$call2; //@line 1612 "numbers.cpp"
    var $cmp=((($_lcssa65))|0)==3; //@line 1615 "numbers.cpp"
    if ($cmp) { __label__ = 3;; } else { __label__ = 6;; } //@line 1615 "numbers.cpp"
    $land_lhs_true$$if_else$6: do { 
      if (__label__ == 3) {
  
        var $12=$word_addr; //@line 1615 "numbers.cpp"
        var $arrayidx3=(($12+-2)&4294967295); //@line 1615 "numbers.cpp"
        var $13=HEAP8[($arrayidx3)]; //@line 1615 "numbers.cpp"
        var $conv4=(tempInt=(($13)),(tempInt>=128?tempInt-256:tempInt)); //@line 1615 "numbers.cpp"
        var $14=$tr_addr; //@line 1615 "numbers.cpp"
        var $langopts=(($14)&4294967295); //@line 1615 "numbers.cpp"
        var $thousands_sep=(($langopts+204)&4294967295); //@line 1615 "numbers.cpp"
        var $15=HEAP32[(($thousands_sep)>>2)]; //@line 1615 "numbers.cpp"
        var $cmp5=((($conv4))|0)==((($15))|0); //@line 1615 "numbers.cpp"
        if (!($cmp5)) { __label__ = 6;break $land_lhs_true$$if_else$6; } //@line 1615 "numbers.cpp"
  
        var $16=$word_addr; //@line 1615 "numbers.cpp"
        var $arrayidx7=(($16+-3)&4294967295); //@line 1615 "numbers.cpp"
        var $17=HEAP8[($arrayidx7)]; //@line 1615 "numbers.cpp"
        var $conv8=(tempInt=(($17)),(tempInt>=128?tempInt-256:tempInt)); //@line 1615 "numbers.cpp"
        var $isdigittmp6=((($conv8)-48)&4294967295); //@line 1615 "numbers.cpp"
        var $isdigit7=((($isdigittmp6))>>>0) < 10; //@line 1615 "numbers.cpp"
        var $call9=((($isdigit7))&1); //@line 1615 "numbers.cpp"
        var $tobool10=((($call9))|0)!=0; //@line 1615 "numbers.cpp"
        if (!($tobool10)) { __label__ = 6;break $land_lhs_true$$if_else$6; } //@line 1615 "numbers.cpp"
  
        $prev_thousands=1; //@line 1617 "numbers.cpp"
        __label__ = 14;break $land_lhs_true$$if_else$6; //@line 1618 "numbers.cpp"
      }
    } while(0);
    $if_end32$$if_else$10: do { 
      if (__label__ == 6) {
  
        var $18=$tr_addr; //@line 1620 "numbers.cpp"
        var $langopts11=(($18)&4294967295); //@line 1620 "numbers.cpp"
        var $thousands_sep12=(($langopts11+204)&4294967295); //@line 1620 "numbers.cpp"
        var $19=HEAP32[(($thousands_sep12)>>2)]; //@line 1620 "numbers.cpp"
        var $cmp13=((($19))|0)==32; //@line 1620 "numbers.cpp"
        if ($cmp13) { __label__ = 8;; } else { __label__ = 7;; } //@line 1620 "numbers.cpp"
        $if_then16$$lor_lhs_false$12: do { 
          if (__label__ == 7) {
  
            var $20=$tr_addr; //@line 1620 "numbers.cpp"
            var $langopts14=(($20)&4294967295); //@line 1620 "numbers.cpp"
            var $numbers=(($langopts14+184)&4294967295); //@line 1620 "numbers.cpp"
            var $21=HEAP32[(($numbers)>>2)]; //@line 1620 "numbers.cpp"
            var $and=($21) & 4096; //@line 1620 "numbers.cpp"
            var $tobool15=((($and))|0)!=0; //@line 1620 "numbers.cpp"
            if ($tobool15) { __label__ = 8;break $if_then16$$lor_lhs_false$12; } else { __label__ = 12;break $if_then16$$lor_lhs_false$12; } //@line 1620 "numbers.cpp"
          }
        } while(0);
        $if_then16$$if_end29$14: do { 
          if (__label__ == 8) {
  
            var $22=$n_digits; //@line 1623 "numbers.cpp"
            var $cmp17=((($22))|0)==3; //@line 1623 "numbers.cpp"
            if (!($cmp17)) { __label__ = 12;break $if_then16$$if_end29$14; } //@line 1623 "numbers.cpp"
  
            var $23=$wtab_addr; //@line 1623 "numbers.cpp"
            var $flags19=(($23)&4294967295); //@line 1623 "numbers.cpp"
            var $24=HEAP32[(($flags19)>>2)]; //@line 1623 "numbers.cpp"
            var $and20=($24) & 262144; //@line 1623 "numbers.cpp"
            var $tobool21=((($and20))|0)!=0; //@line 1623 "numbers.cpp"
            if ($tobool21) { __label__ = 12;break $if_then16$$if_end29$14; } //@line 1623 "numbers.cpp"
  
            var $25=$word_addr; //@line 1623 "numbers.cpp"
            var $arrayidx23=(($25+-2)&4294967295); //@line 1623 "numbers.cpp"
            var $26=HEAP8[($arrayidx23)]; //@line 1623 "numbers.cpp"
            var $conv24=(tempInt=(($26)),(tempInt>=128?tempInt-256:tempInt)); //@line 1623 "numbers.cpp"
            var $isdigittmp8=((($conv24)-48)&4294967295); //@line 1623 "numbers.cpp"
            var $isdigit9=((($isdigittmp8))>>>0) < 10; //@line 1623 "numbers.cpp"
            var $call25=((($isdigit9))&1); //@line 1623 "numbers.cpp"
            var $tobool26=((($call25))|0)!=0; //@line 1623 "numbers.cpp"
            if (!($tobool26)) { __label__ = 12;break $if_then16$$if_end29$14; } //@line 1623 "numbers.cpp"
  
            $prev_thousands=1; //@line 1625 "numbers.cpp"
            __label__ = 14;break $if_end32$$if_else$10; //@line 1626 "numbers.cpp"
          }
        } while(0);
  
        var $_pr=$prev_thousands; //@line 1628 "numbers.cpp"
        var $cmp30=((($_pr))|0)==0; //@line 1628 "numbers.cpp"
        if (!($cmp30)) { __label__ = 14;break $if_end32$$if_else$10; } //@line 1628 "numbers.cpp"
  
        HEAP32[((__ZL23speak_missing_thousands)>>2)]=0; //@line 1630 "numbers.cpp"
        ; //@line 1631 "numbers.cpp"
      }
    } while(0);
  
    HEAP8[(((__ZL11ph_ordinal2)&4294967295))]=0; //@line 1633 "numbers.cpp"
    var $arrayidx33=(($ph_zeros)&4294967295); //@line 1634 "numbers.cpp"
    HEAP8[($arrayidx33)]=0; //@line 1634 "numbers.cpp"
    var $27=$prev_thousands; //@line 1636 "numbers.cpp"
    var $tobool34=((($27))|0)!=0; //@line 1636 "numbers.cpp"
    if ($tobool34) { __label__ = 16;; } else { __label__ = 15;; } //@line 1636 "numbers.cpp"
    $if_then39$$lor_lhs_false35$22: do { 
      if (__label__ == 15) {
  
        var $28=$word_addr; //@line 1636 "numbers.cpp"
        var $arrayidx36=(($28)&4294967295); //@line 1636 "numbers.cpp"
        var $29=HEAP8[($arrayidx36)]; //@line 1636 "numbers.cpp"
        var $conv37=(tempInt=(($29)),(tempInt>=128?tempInt-256:tempInt)); //@line 1636 "numbers.cpp"
        var $cmp38=((($conv37))|0)!=48; //@line 1636 "numbers.cpp"
        if ($cmp38) { __label__ = 16;break $if_then39$$lor_lhs_false35$22; } else { __label__ = 18;break $if_then39$$lor_lhs_false35$22; } //@line 1636 "numbers.cpp"
      }
    } while(0);
    $if_then39$$if_end45$24: do { 
      if (__label__ == 16) {
  
        var $30=$tr_addr; //@line 1639 "numbers.cpp"
        var $31=$word_addr; //@line 1639 "numbers.cpp"
        var $32=$ix; //@line 1639 "numbers.cpp"
        var $33=$word_addr; //@line 1639 "numbers.cpp"
        var $arrayidx40=(($33+$32)&4294967295); //@line 1639 "numbers.cpp"
        var $34=$wtab_addr; //@line 1639 "numbers.cpp"
        var $call41=__ZL15CheckDotOrdinalP10TranslatorPcS1_P8WORD_TABi($30, $31, $arrayidx40, $34, 0); //@line 1639 "numbers.cpp"
        $ordinal=$call41; //@line 1639 "numbers.cpp"
        var $cmp42=((($call41))|0)!=0; //@line 1639 "numbers.cpp"
        if (!($cmp42)) { __label__ = 18;break $if_then39$$if_end45$24; } //@line 1639 "numbers.cpp"
  
        $dot_ordinal=1; //@line 1640 "numbers.cpp"
        ; //@line 1640 "numbers.cpp"
      }
    } while(0);
  
    var $35=$ix; //@line 1643 "numbers.cpp"
    var $36=$word_addr; //@line 1643 "numbers.cpp"
    var $arrayidx46=(($36+$35)&4294967295); //@line 1643 "numbers.cpp"
    var $37=HEAP8[($arrayidx46)]; //@line 1643 "numbers.cpp"
    var $conv47=(tempInt=(($37)),(tempInt>=128?tempInt-256:tempInt)); //@line 1643 "numbers.cpp"
    var $cmp48=((($conv47))|0)==46; //@line 1643 "numbers.cpp"
    if ($cmp48) { __label__ = 19;; } else { __label__ = 23;; } //@line 1643 "numbers.cpp"
    $land_lhs_true49$$if_end67$28: do { 
      if (__label__ == 19) {
  
        var $38=$ix; //@line 1643 "numbers.cpp"
        var $add=((($38)+1)&4294967295); //@line 1643 "numbers.cpp"
        var $39=$word_addr; //@line 1643 "numbers.cpp"
        var $arrayidx50=(($39+$add)&4294967295); //@line 1643 "numbers.cpp"
        var $40=HEAP8[($arrayidx50)]; //@line 1643 "numbers.cpp"
        var $conv51=(tempInt=(($40)),(tempInt>=128?tempInt-256:tempInt)); //@line 1643 "numbers.cpp"
        var $isdigittmp10=((($conv51)-48)&4294967295); //@line 1643 "numbers.cpp"
        var $isdigit11=((($isdigittmp10))>>>0) < 10; //@line 1643 "numbers.cpp"
        var $call52=((($isdigit11))&1); //@line 1643 "numbers.cpp"
        var $tobool53=((($call52))|0)!=0; //@line 1643 "numbers.cpp"
        if ($tobool53) { __label__ = 23;break $land_lhs_true49$$if_end67$28; } //@line 1643 "numbers.cpp"
  
        var $41=$ix; //@line 1643 "numbers.cpp"
        var $add55=((($41)+2)&4294967295); //@line 1643 "numbers.cpp"
        var $42=$word_addr; //@line 1643 "numbers.cpp"
        var $arrayidx56=(($42+$add55)&4294967295); //@line 1643 "numbers.cpp"
        var $43=HEAP8[($arrayidx56)]; //@line 1643 "numbers.cpp"
        var $conv57=(tempInt=(($43)),(tempInt>=128?tempInt-256:tempInt)); //@line 1643 "numbers.cpp"
        var $isdigittmp12=((($conv57)-48)&4294967295); //@line 1643 "numbers.cpp"
        var $isdigit13=((($isdigittmp12))>>>0) < 10; //@line 1643 "numbers.cpp"
        var $call58=((($isdigit13))&1); //@line 1643 "numbers.cpp"
        var $tobool59=((($call58))|0)!=0; //@line 1643 "numbers.cpp"
        if ($tobool59) { __label__ = 23;break $land_lhs_true49$$if_end67$28; } //@line 1643 "numbers.cpp"
  
        var $44=$wtab_addr; //@line 1643 "numbers.cpp"
        var $arrayidx61=(($44+12)&4294967295); //@line 1643 "numbers.cpp"
        var $flags62=(($arrayidx61)&4294967295); //@line 1643 "numbers.cpp"
        var $45=HEAP32[(($flags62)>>2)]; //@line 1643 "numbers.cpp"
        var $and63=($45) & 256; //@line 1643 "numbers.cpp"
        var $tobool64=((($and63))|0)!=0; //@line 1643 "numbers.cpp"
        if ($tobool64) { __label__ = 23;break $land_lhs_true49$$if_end67$28; } //@line 1643 "numbers.cpp"
  
        var $46=$ix; //@line 1646 "numbers.cpp"
        var $47=$word_addr; //@line 1646 "numbers.cpp"
        var $arrayidx66=(($47+$46)&4294967295); //@line 1646 "numbers.cpp"
        HEAP8[($arrayidx66)]=0; //@line 1646 "numbers.cpp"
        ; //@line 1647 "numbers.cpp"
      }
    } while(0);
  
    var $48=$ordinal; //@line 1649 "numbers.cpp"
    var $cmp68=((($48))|0)==0; //@line 1649 "numbers.cpp"
    if ($cmp68) { __label__ = 25;; } else { __label__ = 24;; } //@line 1649 "numbers.cpp"
    $if_then71$$lor_lhs_false69$34: do { 
      if (__label__ == 24) {
  
        var $49=$tr_addr; //@line 1649 "numbers.cpp"
        var $translator_name=(($49+280)&4294967295); //@line 1649 "numbers.cpp"
        var $50=HEAP32[(($translator_name)>>2)]; //@line 1649 "numbers.cpp"
        var $cmp70=((($50))|0)==26741; //@line 1649 "numbers.cpp"
        if ($cmp70) { __label__ = 25;break $if_then71$$lor_lhs_false69$34; } else { __label__ = 38;break $if_then71$$lor_lhs_false69$34; } //@line 1649 "numbers.cpp"
      }
    } while(0);
    $if_then71$$if_end123$36: do { 
      if (__label__ == 25) {
  
        var $51=$ix; //@line 1653 "numbers.cpp"
        var $inc72=((($51)+1)&4294967295); //@line 1653 "numbers.cpp"
        $ix=$inc72; //@line 1653 "numbers.cpp"
        $hyphen=0; //@line 1654 "numbers.cpp"
        var $arraydecay73=(($suffix)&4294967295); //@line 1655 "numbers.cpp"
        HEAP32[(($p)>>2)]=$arraydecay73; //@line 1655 "numbers.cpp"
        var $52=$wtab_addr; //@line 1656 "numbers.cpp"
        var $arrayidx74=(($52)&4294967295); //@line 1656 "numbers.cpp"
        var $flags75=(($arrayidx74)&4294967295); //@line 1656 "numbers.cpp"
        var $53=HEAP32[(($flags75)>>2)]; //@line 1656 "numbers.cpp"
        var $and76=($53) & 16384; //@line 1656 "numbers.cpp"
        var $tobool77=((($and76))|0)!=0; //@line 1656 "numbers.cpp"
        if ($tobool77) { __label__ = 26;; } else { __label__ = 27;; } //@line 1656 "numbers.cpp"
        if (__label__ == 26) {
  
          var $54=HEAP32[(($p)>>2)]; //@line 1658 "numbers.cpp"
          var $incdec_ptr=(($54+1)&4294967295); //@line 1658 "numbers.cpp"
          HEAP32[(($p)>>2)]=$incdec_ptr; //@line 1658 "numbers.cpp"
          HEAP8[($54)]=45; //@line 1658 "numbers.cpp"
          $hyphen=1; //@line 1659 "numbers.cpp"
          var $55=$ix; //@line 1660 "numbers.cpp"
          var $inc79=((($55)+1)&4294967295); //@line 1660 "numbers.cpp"
          $ix=$inc79; //@line 1660 "numbers.cpp"
          ; //@line 1661 "numbers.cpp"
        }
        $while_cond$40: while(1) { 
  
          var $56=$ix; //@line 1662 "numbers.cpp"
          var $57=$word_addr; //@line 1662 "numbers.cpp"
          var $arrayidx81=(($57+$56)&4294967295); //@line 1662 "numbers.cpp"
          var $58=HEAP8[($arrayidx81)]; //@line 1662 "numbers.cpp"
          var $conv82=(tempInt=(($58)),(tempInt>=128?tempInt-256:tempInt)); //@line 1662 "numbers.cpp"
          var $cmp83=((($conv82))|0)!=0; //@line 1662 "numbers.cpp"
          if (!($cmp83)) { __label__ = 31;break $while_cond$40; } //@line 1662 "numbers.cpp"
  
          var $59=$ix; //@line 1662 "numbers.cpp"
          var $60=$word_addr; //@line 1662 "numbers.cpp"
          var $arrayidx85=(($60+$59)&4294967295); //@line 1662 "numbers.cpp"
          var $61=HEAP8[($arrayidx85)]; //@line 1662 "numbers.cpp"
          var $conv86=(tempInt=(($61)),(tempInt>=128?tempInt-256:tempInt)); //@line 1662 "numbers.cpp"
          var $cmp87=((($conv86))|0)!=32; //@line 1662 "numbers.cpp"
          if (!($cmp87)) { __label__ = 31;break $while_cond$40; } //@line 1662 "numbers.cpp"
  
          var $62=$ix; //@line 1662 "numbers.cpp"
          var $cmp88=((($62))|0) < 19; //@line 1662 "numbers.cpp"
          if (!($cmp88)) { __label__ = 31;break $while_cond$40; }
  
          var $63=$ix; //@line 1664 "numbers.cpp"
          var $inc89=((($63)+1)&4294967295); //@line 1664 "numbers.cpp"
          $ix=$inc89; //@line 1664 "numbers.cpp"
          var $64=$word_addr; //@line 1664 "numbers.cpp"
          var $arrayidx90=(($64+$63)&4294967295); //@line 1664 "numbers.cpp"
          var $65=HEAP8[($arrayidx90)]; //@line 1664 "numbers.cpp"
          var $66=HEAP32[(($p)>>2)]; //@line 1664 "numbers.cpp"
          var $incdec_ptr91=(($66+1)&4294967295); //@line 1664 "numbers.cpp"
          HEAP32[(($p)>>2)]=$incdec_ptr91; //@line 1664 "numbers.cpp"
          HEAP8[($66)]=$65; //@line 1664 "numbers.cpp"
          __label__ = 27;continue $while_cond$40; //@line 1665 "numbers.cpp"
        }
  
        var $67=HEAP32[(($p)>>2)]; //@line 1666 "numbers.cpp"
        HEAP8[($67)]=0; //@line 1666 "numbers.cpp"
        var $arrayidx92=(($suffix)&4294967295); //@line 1668 "numbers.cpp"
        var $68=HEAP8[($arrayidx92)]; //@line 1668 "numbers.cpp"
        var $conv93=(tempInt=(($68)),(tempInt>=128?tempInt-256:tempInt)); //@line 1668 "numbers.cpp"
        var $cmp94=((($conv93))|0)!=0; //@line 1668 "numbers.cpp"
        if (!($cmp94)) { __label__ = 38;break $if_then71$$if_end123$36; } //@line 1668 "numbers.cpp"
  
        var $69=$tr_addr; //@line 1670 "numbers.cpp"
        var $langopts96=(($69)&4294967295); //@line 1670 "numbers.cpp"
        var $ordinal_indicator=(($langopts96+216)&4294967295); //@line 1670 "numbers.cpp"
        var $70=HEAP32[(($ordinal_indicator)>>2)]; //@line 1670 "numbers.cpp"
        var $cmp97=((($70))|0)!=0; //@line 1670 "numbers.cpp"
        if ($cmp97) { __label__ = 33;; } else { __label__ = 35;; } //@line 1670 "numbers.cpp"
        $land_lhs_true98$$if_else105$47: do { 
          if (__label__ == 33) {
  
            var $arraydecay99=(($suffix)&4294967295); //@line 1670 "numbers.cpp"
            var $71=$tr_addr; //@line 1670 "numbers.cpp"
            var $langopts100=(($71)&4294967295); //@line 1670 "numbers.cpp"
            var $ordinal_indicator101=(($langopts100+216)&4294967295); //@line 1670 "numbers.cpp"
            var $72=HEAP32[(($ordinal_indicator101)>>2)]; //@line 1670 "numbers.cpp"
            var $call102=_strcmp($arraydecay99, $72); //@line 1670 "numbers.cpp"
            var $cmp103=((($call102))|0)==0; //@line 1670 "numbers.cpp"
            if (!($cmp103)) { __label__ = 35;break $land_lhs_true98$$if_else105$47; } //@line 1670 "numbers.cpp"
  
            $ordinal=2; //@line 1672 "numbers.cpp"
            __label__ = 38;break $if_then71$$if_end123$36; //@line 1673 "numbers.cpp"
          }
        } while(0);
  
        var $arrayidx106=(($suffix)&4294967295); //@line 1675 "numbers.cpp"
        var $73=HEAP8[($arrayidx106)]; //@line 1675 "numbers.cpp"
        var $conv107=(tempInt=(($73)),(tempInt>=128?tempInt-256:tempInt)); //@line 1675 "numbers.cpp"
        var $isdigittmp14=((($conv107)-48)&4294967295); //@line 1675 "numbers.cpp"
        var $isdigit15=((($isdigittmp14))>>>0) < 10; //@line 1675 "numbers.cpp"
        var $call108=((($isdigit15))&1); //@line 1675 "numbers.cpp"
        var $tobool109=((($call108))|0)!=0; //@line 1675 "numbers.cpp"
        if ($tobool109) { __label__ = 38;break $if_then71$$if_end123$36; } //@line 1675 "numbers.cpp"
  
        var $arraydecay111=(($string)&4294967295); //@line 1677 "numbers.cpp"
        var $arraydecay112=(($suffix)&4294967295); //@line 1677 "numbers.cpp"
        var $call113=_sprintf($arraydecay111, ((__str15312)&4294967295), allocate([$arraydecay112,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 1677 "numbers.cpp"
        var $74=$tr_addr; //@line 1678 "numbers.cpp"
        var $arraydecay114=(($string)&4294967295); //@line 1678 "numbers.cpp"
        var $call115=__Z6LookupP10TranslatorPKcPc($74, $arraydecay114, ((__ZL11ph_ordinal2)&4294967295)); //@line 1678 "numbers.cpp"
        var $tobool116=((($call115))|0)!=0; //@line 1678 "numbers.cpp"
        if (!($tobool116)) { __label__ = 38;break $if_then71$$if_end123$36; } //@line 1678 "numbers.cpp"
  
        $ordinal=2; //@line 1681 "numbers.cpp"
        var $75=$flags_addr; //@line 1682 "numbers.cpp"
        var $arrayidx118=(($75)&4294967295); //@line 1682 "numbers.cpp"
        var $76=HEAP32[(($arrayidx118)>>2)]; //@line 1682 "numbers.cpp"
        var $or=($76) | 128; //@line 1682 "numbers.cpp"
        HEAP32[(($arrayidx118)>>2)]=$or; //@line 1682 "numbers.cpp"
        $skipwords=1; //@line 1683 "numbers.cpp"
        ; //@line 1684 "numbers.cpp"
      }
    } while(0);
  
    var $77=$wtab_addr; //@line 1689 "numbers.cpp"
    var $arrayidx124=(($77)&4294967295); //@line 1689 "numbers.cpp"
    var $flags125=(($arrayidx124)&4294967295); //@line 1689 "numbers.cpp"
    var $78=HEAP32[(($flags125)>>2)]; //@line 1689 "numbers.cpp"
    var $and126=($78) & 32768; //@line 1689 "numbers.cpp"
    var $tobool127=((($and126))|0)!=0; //@line 1689 "numbers.cpp"
    if ($tobool127) { __label__ = 39;; } else { __label__ = 40;; } //@line 1689 "numbers.cpp"
    if (__label__ == 39) {
  
      $ordinal=2; //@line 1690 "numbers.cpp"
      ; //@line 1690 "numbers.cpp"
    }
  
    var $arrayidx130=(($ph_append)&4294967295); //@line 1692 "numbers.cpp"
    HEAP8[($arrayidx130)]=0; //@line 1692 "numbers.cpp"
    var $arrayidx131=(($ph_buf2)&4294967295); //@line 1693 "numbers.cpp"
    HEAP8[($arrayidx131)]=0; //@line 1693 "numbers.cpp"
    var $79=$word_addr; //@line 1696 "numbers.cpp"
    var $arrayidx132=(($79)&4294967295); //@line 1696 "numbers.cpp"
    var $80=HEAP8[($arrayidx132)]; //@line 1696 "numbers.cpp"
    var $conv133=(tempInt=(($80)),(tempInt>=128?tempInt-256:tempInt)); //@line 1696 "numbers.cpp"
    var $cmp134=((($conv133))|0)==48; //@line 1696 "numbers.cpp"
    if ($cmp134) { __label__ = 41;; } else { __label__ = 55;; } //@line 1696 "numbers.cpp"
    $land_lhs_true135$$if_end185$57: do { 
      if (__label__ == 41) {
  
        var $81=$prev_thousands; //@line 1696 "numbers.cpp"
        var $cmp136=((($81))|0)==0; //@line 1696 "numbers.cpp"
        if (!($cmp136)) { __label__ = 55;break $land_lhs_true135$$if_end185$57; } //@line 1696 "numbers.cpp"
  
        var $82=$word_addr; //@line 1696 "numbers.cpp"
        var $arrayidx138=(($82+1)&4294967295); //@line 1696 "numbers.cpp"
        var $83=HEAP8[($arrayidx138)]; //@line 1696 "numbers.cpp"
        var $conv139=(tempInt=(($83)),(tempInt>=128?tempInt-256:tempInt)); //@line 1696 "numbers.cpp"
        var $cmp140=((($conv139))|0)!=32; //@line 1696 "numbers.cpp"
        if (!($cmp140)) { __label__ = 55;break $land_lhs_true135$$if_end185$57; } //@line 1696 "numbers.cpp"
  
        var $84=$word_addr; //@line 1696 "numbers.cpp"
        var $arrayidx142=(($84+1)&4294967295); //@line 1696 "numbers.cpp"
        var $85=HEAP8[($arrayidx142)]; //@line 1696 "numbers.cpp"
        var $conv143=(tempInt=(($85)),(tempInt>=128?tempInt-256:tempInt)); //@line 1696 "numbers.cpp"
        var $86=$tr_addr; //@line 1696 "numbers.cpp"
        var $langopts144=(($86)&4294967295); //@line 1696 "numbers.cpp"
        var $decimal_sep=(($langopts144+208)&4294967295); //@line 1696 "numbers.cpp"
        var $87=HEAP32[(($decimal_sep)>>2)]; //@line 1696 "numbers.cpp"
        var $cmp145=((($conv143))|0)!=((($87))|0); //@line 1696 "numbers.cpp"
        if (!($cmp145)) { __label__ = 55;break $land_lhs_true135$$if_end185$57; } //@line 1696 "numbers.cpp"
  
        var $88=$n_digits; //@line 1698 "numbers.cpp"
        var $cmp147=((($88))|0)==2; //@line 1698 "numbers.cpp"
        if ($cmp147) { __lastLabel__ = 44; __label__ = 45;; } else { __lastLabel__ = 44; __label__ = 49;; } //@line 1698 "numbers.cpp"
        if (__label__ == 45) {
  
          var $89=$word_addr; //@line 1698 "numbers.cpp"
          var $arrayidx149=(($89+3)&4294967295); //@line 1698 "numbers.cpp"
          var $90=HEAP8[($arrayidx149)]; //@line 1698 "numbers.cpp"
          var $conv150=(tempInt=(($90)),(tempInt>=128?tempInt-256:tempInt)); //@line 1698 "numbers.cpp"
          var $cmp151=((($conv150))|0)==58; //@line 1698 "numbers.cpp"
          if ($cmp151) { __label__ = 46;; } else { __label__ = 48;; } //@line 1698 "numbers.cpp"
          $land_lhs_true152$$if_else163thread_pre_split$64: do { 
            if (__label__ == 46) {
  
              var $91=$word_addr; //@line 1698 "numbers.cpp"
              var $arrayidx153=(($91+5)&4294967295); //@line 1698 "numbers.cpp"
              var $92=HEAP8[($arrayidx153)]; //@line 1698 "numbers.cpp"
              var $conv154=(tempInt=(($92)),(tempInt>=128?tempInt-256:tempInt)); //@line 1698 "numbers.cpp"
              var $isdigittmp16=((($conv154)-48)&4294967295); //@line 1698 "numbers.cpp"
              var $isdigit17=((($isdigittmp16))>>>0) < 10; //@line 1698 "numbers.cpp"
              var $call155=((($isdigit17))&1); //@line 1698 "numbers.cpp"
              var $tobool156=((($call155))|0)!=0; //@line 1698 "numbers.cpp"
              if (!($tobool156)) { __label__ = 48;break $land_lhs_true152$$if_else163thread_pre_split$64; } //@line 1698 "numbers.cpp"
  
              var $93=$word_addr; //@line 1698 "numbers.cpp"
              var $arrayidx158=(($93+7)&4294967295); //@line 1698 "numbers.cpp"
              var $94=HEAP8[($arrayidx158)]; //@line 1698 "numbers.cpp"
              var $conv159=(tempInt=(($94)),(tempInt>=128?tempInt-256:tempInt)); //@line 1698 "numbers.cpp"
              var $call160=_isspace($conv159); //@line 1698 "numbers.cpp"
              var $tobool161=((($call160))|0)!=0; //@line 1698 "numbers.cpp"
              if ($tobool161) { __label__ = 55;break $land_lhs_true135$$if_end185$57; } //@line 1698 "numbers.cpp"
            }
          } while(0);
  
          var $_pr43=$n_digits; //@line 1704 "numbers.cpp"
          __lastLabel__ = 48; ;
        }
  
        var $95=__lastLabel__ == 48 ? $_pr43 : ($88); //@line 1704 "numbers.cpp"
        var $cmp164=((($95))|0) > 3; //@line 1704 "numbers.cpp"
        if ($cmp164) { __label__ = 50;; } else { __label__ = 51;; } //@line 1704 "numbers.cpp"
        if (__label__ == 50) {
  
          var $96=$flags_addr; //@line 1706 "numbers.cpp"
          var $arrayidx166=(($96)&4294967295); //@line 1706 "numbers.cpp"
          var $97=HEAP32[(($arrayidx166)>>2)]; //@line 1706 "numbers.cpp"
          var $and167=($97) & -129; //@line 1706 "numbers.cpp"
          HEAP32[(($arrayidx166)>>2)]=$and167; //@line 1706 "numbers.cpp"
          $retval=0; //@line 1707 "numbers.cpp"
          __label__ = 157;break $land_lhs_true135$$if_end185$57; //@line 1707 "numbers.cpp"
        }
        else if (__label__ == 51) {
  
          $ix=0; //@line 1711 "numbers.cpp"
          var $arraydecay177=(($ph_zeros)&4294967295); //@line 1713 "numbers.cpp"
          ; //@line 1711 "numbers.cpp"
          while(1) { 
  
            var $98=$ix; //@line 1711 "numbers.cpp"
            var $99=$word_addr; //@line 1711 "numbers.cpp"
            var $arrayidx170=(($99+$98)&4294967295); //@line 1711 "numbers.cpp"
            var $100=HEAP8[($arrayidx170)]; //@line 1711 "numbers.cpp"
            var $conv171=(tempInt=(($100)),(tempInt>=128?tempInt-256:tempInt)); //@line 1711 "numbers.cpp"
            var $cmp172=((($conv171))|0)==48; //@line 1711 "numbers.cpp"
            if (!($cmp172)) { __label__ = 55;break $land_lhs_true135$$if_end185$57; } //@line 1711 "numbers.cpp"
  
            var $101=$ix; //@line 1711 "numbers.cpp"
            var $102=$n_digits; //@line 1711 "numbers.cpp"
            var $sub=((($102)-1)&4294967295); //@line 1711 "numbers.cpp"
            var $cmp174=((($101))|0) < ((($sub))|0); //@line 1711 "numbers.cpp"
            if (!($cmp174)) { __label__ = 55;break $land_lhs_true135$$if_end185$57; }
  
            var $103=$tr_addr; //@line 1713 "numbers.cpp"
            var $call178=_strlen($arraydecay177); //@line 1713 "numbers.cpp"
            var $arrayidx179=(($ph_zeros+$call178)&4294967295); //@line 1713 "numbers.cpp"
            var $call180=__Z6LookupP10TranslatorPKcPc($103, ((__str16313)&4294967295), $arrayidx179); //@line 1713 "numbers.cpp"
            var $104=$ix; //@line 1711 "numbers.cpp"
            var $inc182=((($104)+1)&4294967295); //@line 1711 "numbers.cpp"
            $ix=$inc182; //@line 1711 "numbers.cpp"
            __label__ = 52;continue ; //@line 1711 "numbers.cpp"
          }
        }
      }
    } while(0);
    if (__label__ == 55) {
  
      var $105=$tr_addr; //@line 1718 "numbers.cpp"
      var $langopts186=(($105)&4294967295); //@line 1718 "numbers.cpp"
      var $numbers187=(($langopts186+184)&4294967295); //@line 1718 "numbers.cpp"
      var $106=HEAP32[(($numbers187)>>2)]; //@line 1718 "numbers.cpp"
      var $and188=($106) & 4096; //@line 1718 "numbers.cpp"
      var $tobool189=((($and188))|0)!=0; //@line 1718 "numbers.cpp"
      if ($tobool189) { __label__ = 56;; } else { __label__ = 58;; } //@line 1718 "numbers.cpp"
      $land_lhs_true190$$if_else195$78: do { 
        if (__label__ == 56) {
  
          var $107=$n_digits; //@line 1718 "numbers.cpp"
          var $108=$word_addr; //@line 1718 "numbers.cpp"
          var $arrayidx191=(($108+$107)&4294967295); //@line 1718 "numbers.cpp"
          var $109=HEAP8[($arrayidx191)]; //@line 1718 "numbers.cpp"
          var $conv192=(tempInt=(($109)),(tempInt>=128?tempInt-256:tempInt)); //@line 1718 "numbers.cpp"
          var $cmp193=((($conv192))|0)==32; //@line 1718 "numbers.cpp"
          if (!($cmp193)) { __label__ = 58;break $land_lhs_true190$$if_else195$78; } //@line 1718 "numbers.cpp"
  
          $thousands_inc=1; //@line 1719 "numbers.cpp"
          __label__ = 60;break $land_lhs_true190$$if_else195$78; //@line 1719 "numbers.cpp"
        }
      } while(0);
      $if_end203_thread$$if_else195$81: do { 
        if (__label__ == 58) {
  
          var $110=$n_digits; //@line 1721 "numbers.cpp"
          var $111=$word_addr; //@line 1721 "numbers.cpp"
          var $arrayidx196=(($111+$110)&4294967295); //@line 1721 "numbers.cpp"
          var $112=HEAP8[($arrayidx196)]; //@line 1721 "numbers.cpp"
          var $conv197=(tempInt=(($112)),(tempInt>=128?tempInt-256:tempInt)); //@line 1721 "numbers.cpp"
          var $113=$tr_addr; //@line 1721 "numbers.cpp"
          var $langopts198=(($113)&4294967295); //@line 1721 "numbers.cpp"
          var $thousands_sep199=(($langopts198+204)&4294967295); //@line 1721 "numbers.cpp"
          var $114=HEAP32[(($thousands_sep199)>>2)]; //@line 1721 "numbers.cpp"
          var $cmp200=((($conv197))|0)==((($114))|0); //@line 1721 "numbers.cpp"
          if ($cmp200) { __label__ = 59;; } else { __label__ = 61;; } //@line 1721 "numbers.cpp"
          if (__label__ == 59) {
  
            $thousands_inc=2; //@line 1722 "numbers.cpp"
            __label__ = 60;break $if_end203_thread$$if_else195$81; //@line 1722 "numbers.cpp"
          }
          else if (__label__ == 61) {
  
            var $_pr44=$thousands_inc; //@line 1725 "numbers.cpp"
            var $116=$n_digits; //@line 1724 "numbers.cpp"
            var $add204=((($116)+2)&4294967295); //@line 1724 "numbers.cpp"
            $suffix_ix=$add204; //@line 1724 "numbers.cpp"
            var $cmp205=((($_pr44))|0) > 0; //@line 1725 "numbers.cpp"
            if ($cmp205) { __label__ = 62;break $if_end203_thread$$if_else195$81; } else { __label__ = 77;break $if_end203_thread$$if_else195$81; } //@line 1725 "numbers.cpp"
          }
        }
      } while(0);
      $if_end203_thread$$if_then206$$if_end282$86: do { 
        if (__label__ == 60) {
  
          var $115=$n_digits; //@line 1724 "numbers.cpp"
          var $add20445=((($115)+2)&4294967295); //@line 1724 "numbers.cpp"
          $suffix_ix=$add20445; //@line 1724 "numbers.cpp"
          __label__ = 62;break $if_end203_thread$$if_then206$$if_end282$86; //@line 1725 "numbers.cpp"
        }
      } while(0);
      $if_then206$$if_end282$88: do { 
        if (__label__ == 62) {
  
          var $117=$n_digits; //@line 1729 "numbers.cpp"
          var $118=$thousands_inc; //@line 1729 "numbers.cpp"
          var $add207=((($118)+($117))&4294967295); //@line 1729 "numbers.cpp"
          $digix=$add207; //@line 1729 "numbers.cpp"
          ; //@line 1731 "numbers.cpp"
          $while_cond208$90: while(1) { 
  
            var $119=$thousandplex; //@line 1731 "numbers.cpp"
            var $add209=((($119)+1)&4294967295); //@line 1731 "numbers.cpp"
            var $120=$wtab_addr; //@line 1731 "numbers.cpp"
            var $arrayidx210=(($120+12*$add209)&4294967295); //@line 1731 "numbers.cpp"
            var $flags211=(($arrayidx210)&4294967295); //@line 1731 "numbers.cpp"
            var $121=HEAP32[(($flags211)>>2)]; //@line 1731 "numbers.cpp"
            var $and212=($121) & 262144; //@line 1731 "numbers.cpp"
            var $cmp213=((($and212))|0)==0; //@line 1731 "numbers.cpp"
            if (!($cmp213)) { __label__ = 77;break $if_then206$$if_end282$88; } //@line 1731 "numbers.cpp"
  
            var $122=$digix; //@line 1732 "numbers.cpp"
            var $123=$word_addr; //@line 1732 "numbers.cpp"
            var $arrayidx215=(($123+$122)&4294967295); //@line 1732 "numbers.cpp"
            var $124=HEAP8[($arrayidx215)]; //@line 1732 "numbers.cpp"
            var $conv216=(tempInt=(($124)),(tempInt>=128?tempInt-256:tempInt)); //@line 1732 "numbers.cpp"
            var $isdigittmp18=((($conv216)-48)&4294967295); //@line 1732 "numbers.cpp"
            var $isdigit19=((($isdigittmp18))>>>0) < 10; //@line 1732 "numbers.cpp"
            var $call217=((($isdigit19))&1); //@line 1732 "numbers.cpp"
            var $tobool218=((($call217))|0)!=0; //@line 1732 "numbers.cpp"
            if (!($tobool218)) { __label__ = 77;break $if_then206$$if_end282$88; } //@line 1732 "numbers.cpp"
  
            var $125=$digix; //@line 1732 "numbers.cpp"
            var $add220=((($125)+1)&4294967295); //@line 1732 "numbers.cpp"
            var $126=$word_addr; //@line 1732 "numbers.cpp"
            var $arrayidx221=(($126+$add220)&4294967295); //@line 1732 "numbers.cpp"
            var $127=HEAP8[($arrayidx221)]; //@line 1732 "numbers.cpp"
            var $conv222=(tempInt=(($127)),(tempInt>=128?tempInt-256:tempInt)); //@line 1732 "numbers.cpp"
            var $isdigittmp20=((($conv222)-48)&4294967295); //@line 1732 "numbers.cpp"
            var $isdigit21=((($isdigittmp20))>>>0) < 10; //@line 1732 "numbers.cpp"
            var $call223=((($isdigit21))&1); //@line 1732 "numbers.cpp"
            var $tobool224=((($call223))|0)!=0; //@line 1732 "numbers.cpp"
            if (!($tobool224)) { __label__ = 77;break $if_then206$$if_end282$88; } //@line 1732 "numbers.cpp"
  
            var $128=$digix; //@line 1732 "numbers.cpp"
            var $add226=((($128)+2)&4294967295); //@line 1732 "numbers.cpp"
            var $129=$word_addr; //@line 1732 "numbers.cpp"
            var $arrayidx227=(($129+$add226)&4294967295); //@line 1732 "numbers.cpp"
            var $130=HEAP8[($arrayidx227)]; //@line 1732 "numbers.cpp"
            var $conv228=(tempInt=(($130)),(tempInt>=128?tempInt-256:tempInt)); //@line 1732 "numbers.cpp"
            var $isdigittmp22=((($conv228)-48)&4294967295); //@line 1732 "numbers.cpp"
            var $isdigit23=((($isdigittmp22))>>>0) < 10; //@line 1732 "numbers.cpp"
            var $call229=((($isdigit23))&1); //@line 1732 "numbers.cpp"
            var $tobool230=((($call229))|0)!=0; //@line 1732 "numbers.cpp"
            if (!($tobool230)) { __label__ = 77;break $if_then206$$if_end282$88; } //@line 1732 "numbers.cpp"
  
            var $131=$digix; //@line 1732 "numbers.cpp"
            var $add232=((($131)+3)&4294967295); //@line 1732 "numbers.cpp"
            var $132=$word_addr; //@line 1732 "numbers.cpp"
            var $arrayidx233=(($132+$add232)&4294967295); //@line 1732 "numbers.cpp"
            var $133=HEAP8[($arrayidx233)]; //@line 1732 "numbers.cpp"
            var $conv234=(tempInt=(($133)),(tempInt>=128?tempInt-256:tempInt)); //@line 1732 "numbers.cpp"
            var $isdigittmp24=((($conv234)-48)&4294967295); //@line 1732 "numbers.cpp"
            var $isdigit25=((($isdigittmp24))>>>0) < 10; //@line 1732 "numbers.cpp"
            var $call235=((($isdigit25))&1); //@line 1732 "numbers.cpp"
            var $tobool236=((($call235))|0)!=0; //@line 1732 "numbers.cpp"
            if ($tobool236) { __label__ = 77;break $if_then206$$if_end282$88; } //@line 1732 "numbers.cpp"
  
            var $134=$digix; //@line 1732 "numbers.cpp"
            var $sub238=((($134)-1)&4294967295); //@line 1732 "numbers.cpp"
            var $135=$word_addr; //@line 1732 "numbers.cpp"
            var $arrayidx239=(($135+$sub238)&4294967295); //@line 1732 "numbers.cpp"
            var $136=HEAP8[($arrayidx239)]; //@line 1732 "numbers.cpp"
            var $conv240=(tempInt=(($136)),(tempInt>=128?tempInt-256:tempInt)); //@line 1732 "numbers.cpp"
            var $isdigittmp26=((($conv240)-48)&4294967295); //@line 1732 "numbers.cpp"
            var $isdigit27=((($isdigittmp26))>>>0) < 10; //@line 1732 "numbers.cpp"
            var $call241=((($isdigit27))&1); //@line 1732 "numbers.cpp"
            var $tobool242=((($call241))|0)!=0; //@line 1732 "numbers.cpp"
            var $lnot=($tobool242) ^ 1; //@line 1732 "numbers.cpp"
            if (!($lnot)) { __label__ = 77;break $if_then206$$if_end282$88; }
  
            var $137=$digix; //@line 1734 "numbers.cpp"
            var $138=$word_addr; //@line 1734 "numbers.cpp"
            var $arrayidx245=(($138+$137)&4294967295); //@line 1734 "numbers.cpp"
            var $139=HEAP8[($arrayidx245)]; //@line 1734 "numbers.cpp"
            var $conv246=(tempInt=(($139)),(tempInt>=128?tempInt-256:tempInt)); //@line 1734 "numbers.cpp"
            var $cmp247=((($conv246))|0)!=48; //@line 1734 "numbers.cpp"
            if ($cmp247) { __label__ = 72;; } else { __label__ = 70;; } //@line 1734 "numbers.cpp"
            $if_then258$$lor_lhs_false248$98: do { 
              if (__label__ == 70) {
  
                var $140=$digix; //@line 1734 "numbers.cpp"
                var $add249=((($140)+1)&4294967295); //@line 1734 "numbers.cpp"
                var $141=$word_addr; //@line 1734 "numbers.cpp"
                var $arrayidx250=(($141+$add249)&4294967295); //@line 1734 "numbers.cpp"
                var $142=HEAP8[($arrayidx250)]; //@line 1734 "numbers.cpp"
                var $conv251=(tempInt=(($142)),(tempInt>=128?tempInt-256:tempInt)); //@line 1734 "numbers.cpp"
                var $cmp252=((($conv251))|0)!=48; //@line 1734 "numbers.cpp"
                if ($cmp252) { __label__ = 72;break $if_then258$$lor_lhs_false248$98; } //@line 1734 "numbers.cpp"
  
                var $143=$digix; //@line 1734 "numbers.cpp"
                var $add254=((($143)+2)&4294967295); //@line 1734 "numbers.cpp"
                var $144=$word_addr; //@line 1734 "numbers.cpp"
                var $arrayidx255=(($144+$add254)&4294967295); //@line 1734 "numbers.cpp"
                var $145=HEAP8[($arrayidx255)]; //@line 1734 "numbers.cpp"
                var $conv256=(tempInt=(($145)),(tempInt>=128?tempInt-256:tempInt)); //@line 1734 "numbers.cpp"
                var $cmp257=((($conv256))|0)!=48; //@line 1734 "numbers.cpp"
                if ($cmp257) { __label__ = 72;break $if_then258$$lor_lhs_false248$98; } else { __label__ = 73;break $if_then258$$lor_lhs_false248$98; } //@line 1734 "numbers.cpp"
              }
            } while(0);
            if (__label__ == 72) {
  
              $thousands_exact=0; //@line 1735 "numbers.cpp"
              ; //@line 1735 "numbers.cpp"
            }
  
            var $146=$thousandplex; //@line 1737 "numbers.cpp"
            var $inc260=((($146)+1)&4294967295); //@line 1737 "numbers.cpp"
            $thousandplex=$inc260; //@line 1737 "numbers.cpp"
            var $147=$digix; //@line 1738 "numbers.cpp"
            var $add261=((($147)+3)&4294967295); //@line 1738 "numbers.cpp"
            $digix=$add261; //@line 1738 "numbers.cpp"
            var $148=$digix; //@line 1739 "numbers.cpp"
            var $149=$word_addr; //@line 1739 "numbers.cpp"
            var $arrayidx262=(($149+$148)&4294967295); //@line 1739 "numbers.cpp"
            var $150=HEAP8[($arrayidx262)]; //@line 1739 "numbers.cpp"
            var $conv263=(tempInt=(($150)),(tempInt>=128?tempInt-256:tempInt)); //@line 1739 "numbers.cpp"
            var $151=$tr_addr; //@line 1739 "numbers.cpp"
            var $langopts264=(($151)&4294967295); //@line 1739 "numbers.cpp"
            var $thousands_sep265=(($langopts264+204)&4294967295); //@line 1739 "numbers.cpp"
            var $152=HEAP32[(($thousands_sep265)>>2)]; //@line 1739 "numbers.cpp"
            var $cmp266=((($conv263))|0)==((($152))|0); //@line 1739 "numbers.cpp"
            if ($cmp266) { __label__ = 76;; } else { __label__ = 74;; } //@line 1739 "numbers.cpp"
            if (__label__ == 74) {
  
              var $153=$tr_addr; //@line 1739 "numbers.cpp"
              var $langopts268=(($153)&4294967295); //@line 1739 "numbers.cpp"
              var $numbers269=(($langopts268+184)&4294967295); //@line 1739 "numbers.cpp"
              var $154=HEAP32[(($numbers269)>>2)]; //@line 1739 "numbers.cpp"
              var $and270=($154) & 4096; //@line 1739 "numbers.cpp"
              var $tobool271=((($and270))|0)!=0; //@line 1739 "numbers.cpp"
              if (!($tobool271)) { __label__ = 77;break $if_then206$$if_end282$88; } //@line 1739 "numbers.cpp"
  
              var $155=$digix; //@line 1739 "numbers.cpp"
              var $156=$word_addr; //@line 1739 "numbers.cpp"
              var $arrayidx273=(($156+$155)&4294967295); //@line 1739 "numbers.cpp"
              var $157=HEAP8[($arrayidx273)]; //@line 1739 "numbers.cpp"
              var $conv274=(tempInt=(($157)),(tempInt>=128?tempInt-256:tempInt)); //@line 1739 "numbers.cpp"
              var $cmp275=((($conv274))|0)==32; //@line 1739 "numbers.cpp"
              if (!($cmp275)) { __label__ = 77;break $if_then206$$if_end282$88; } //@line 1739 "numbers.cpp"
            }
  
            var $158=$digix; //@line 1741 "numbers.cpp"
            var $add277=((($158)+2)&4294967295); //@line 1741 "numbers.cpp"
            $suffix_ix=$add277; //@line 1741 "numbers.cpp"
            var $159=$thousands_inc; //@line 1742 "numbers.cpp"
            var $160=$digix; //@line 1742 "numbers.cpp"
            var $add278=((($160)+($159))&4294967295); //@line 1742 "numbers.cpp"
            $digix=$add278; //@line 1742 "numbers.cpp"
            __label__ = 63;continue $while_cond208$90; //@line 1746 "numbers.cpp"
          }
        }
      } while(0);
  
      var $161=$value; //@line 1749 "numbers.cpp"
      var $cmp283=((($161))|0)==0; //@line 1749 "numbers.cpp"
      if ($cmp283) { __label__ = 78;; } else { __label__ = 80;; } //@line 1749 "numbers.cpp"
      $land_lhs_true284$$if_end287$109: do { 
        if (__label__ == 78) {
  
          var $162=$prev_thousands; //@line 1749 "numbers.cpp"
          var $tobool285=((($162))|0)!=0; //@line 1749 "numbers.cpp"
          if (!($tobool285)) { __label__ = 80;break $land_lhs_true284$$if_end287$109; } //@line 1749 "numbers.cpp"
  
          $suppress_null=1; //@line 1751 "numbers.cpp"
          ; //@line 1752 "numbers.cpp"
        }
      } while(0);
  
      var $163=$tr_addr; //@line 1754 "numbers.cpp"
      var $translator_name288=(($163+280)&4294967295); //@line 1754 "numbers.cpp"
      var $164=HEAP32[(($translator_name288)>>2)]; //@line 1754 "numbers.cpp"
      var $cmp289=((($164))|0)==26741; //@line 1754 "numbers.cpp"
      if ($cmp289) { __label__ = 81;; } else { __label__ = 85;; } //@line 1754 "numbers.cpp"
      $if_then290$$if_end304$113: do { 
        if (__label__ == 81) {
  
          var $165=$thousandplex; //@line 1757 "numbers.cpp"
          var $166=$wtab_addr; //@line 1757 "numbers.cpp"
          var $arrayidx291=(($166+12*$165)&4294967295); //@line 1757 "numbers.cpp"
          var $flags292=(($arrayidx291)&4294967295); //@line 1757 "numbers.cpp"
          var $167=HEAP32[(($flags292)>>2)]; //@line 1757 "numbers.cpp"
          var $and293=($167) & 16384; //@line 1757 "numbers.cpp"
          var $tobool294=((($and293))|0)!=0; //@line 1757 "numbers.cpp"
          if (!($tobool294)) { __label__ = 85;break $if_then290$$if_end304$113; } //@line 1757 "numbers.cpp"
  
          var $168=$thousands_exact; //@line 1757 "numbers.cpp"
          var $cmp296=((($168))|0)==1; //@line 1757 "numbers.cpp"
          if (!($cmp296)) { __label__ = 85;break $if_then290$$if_end304$113; } //@line 1757 "numbers.cpp"
  
          var $169=$suffix_ix; //@line 1757 "numbers.cpp"
          var $170=$word_addr; //@line 1757 "numbers.cpp"
          var $arrayidx298=(($170+$169)&4294967295); //@line 1757 "numbers.cpp"
          var $171=$thousandplex; //@line 1757 "numbers.cpp"
          var $172=$value; //@line 1757 "numbers.cpp"
          var $call299=__ZL11hu_number_ePKcii($arrayidx298, $171, $172); //@line 1757 "numbers.cpp"
          var $tobool300=((($call299))|0)!=0; //@line 1757 "numbers.cpp"
          if (!($tobool300)) { __label__ = 85;break $if_then290$$if_end304$113; } //@line 1757 "numbers.cpp"
  
          var $173=HEAP32[((__ZL14number_control)>>2)]; //@line 1759 "numbers.cpp"
          var $or302=($173) | 1; //@line 1759 "numbers.cpp"
          HEAP32[((__ZL14number_control)>>2)]=$or302; //@line 1759 "numbers.cpp"
          ; //@line 1760 "numbers.cpp"
        }
      } while(0);
  
      var $174=$n_digits; //@line 1763 "numbers.cpp"
      var $175=$word_addr; //@line 1763 "numbers.cpp"
      var $arrayidx305=(($175+$174)&4294967295); //@line 1763 "numbers.cpp"
      var $176=HEAP8[($arrayidx305)]; //@line 1763 "numbers.cpp"
      var $conv306=(tempInt=(($176)),(tempInt>=128?tempInt-256:tempInt)); //@line 1763 "numbers.cpp"
      var $177=$tr_addr; //@line 1763 "numbers.cpp"
      var $langopts307=(($177)&4294967295); //@line 1763 "numbers.cpp"
      var $decimal_sep308=(($langopts307+208)&4294967295); //@line 1763 "numbers.cpp"
      var $178=HEAP32[(($decimal_sep308)>>2)]; //@line 1763 "numbers.cpp"
      var $cmp309=((($conv306))|0)==((($178))|0); //@line 1763 "numbers.cpp"
      if ($cmp309) { __label__ = 86;; } else { __label__ = 88;; } //@line 1763 "numbers.cpp"
      $land_lhs_true310$$if_else319$119: do { 
        if (__label__ == 86) {
  
          var $179=$n_digits; //@line 1763 "numbers.cpp"
          var $add311=((($179)+1)&4294967295); //@line 1763 "numbers.cpp"
          var $180=$word_addr; //@line 1763 "numbers.cpp"
          var $arrayidx312=(($180+$add311)&4294967295); //@line 1763 "numbers.cpp"
          var $181=HEAP8[($arrayidx312)]; //@line 1763 "numbers.cpp"
          var $conv313=(tempInt=(($181)),(tempInt>=128?tempInt-256:tempInt)); //@line 1763 "numbers.cpp"
          var $isdigittmp28=((($conv313)-48)&4294967295); //@line 1763 "numbers.cpp"
          var $isdigit29=((($isdigittmp28))>>>0) < 10; //@line 1763 "numbers.cpp"
          var $call314=((($isdigit29))&1); //@line 1763 "numbers.cpp"
          var $tobool315=((($call314))|0)!=0; //@line 1763 "numbers.cpp"
          if (!($tobool315)) { __label__ = 88;break $land_lhs_true310$$if_else319$119; } //@line 1763 "numbers.cpp"
  
          var $182=$tr_addr; //@line 1766 "numbers.cpp"
          var $arraydecay317=(($ph_append)&4294967295); //@line 1766 "numbers.cpp"
          var $call318=__Z6LookupP10TranslatorPKcPc($182, ((__str17314)&4294967295), $arraydecay317); //@line 1766 "numbers.cpp"
          $decimal_point=1; //@line 1767 "numbers.cpp"
          __label__ = 98;break $land_lhs_true310$$if_else319$119; //@line 1768 "numbers.cpp"
        }
      } while(0);
      $if_end356$$if_else319$122: do { 
        if (__label__ == 88) {
  
          var $183=$suppress_null; //@line 1770 "numbers.cpp"
          var $cmp320=((($183))|0)==0; //@line 1770 "numbers.cpp"
          if ($cmp320) { __label__ = 89;; } else { __label__ = 95;; } //@line 1770 "numbers.cpp"
          if (__label__ == 89) {
  
            var $184=$thousands_inc; //@line 1772 "numbers.cpp"
            var $cmp322=((($184))|0) > 0; //@line 1772 "numbers.cpp"
            if (!($cmp322)) { __label__ = 98;break $if_end356$$if_else319$122; } //@line 1772 "numbers.cpp"
  
            var $185=$thousandplex; //@line 1774 "numbers.cpp"
            var $cmp324=((($185))|0) > 0; //@line 1774 "numbers.cpp"
            if (!($cmp324)) { __label__ = 98;break $if_end356$$if_else319$122; } //@line 1774 "numbers.cpp"
  
            var $186=$value; //@line 1774 "numbers.cpp"
            var $cmp326=((($186))|0) < 1000; //@line 1774 "numbers.cpp"
            if (!($cmp326)) { __label__ = 98;break $if_end356$$if_else319$122; } //@line 1774 "numbers.cpp"
  
            var $187=$suppress_null; //@line 1776 "numbers.cpp"
            var $cmp328=((($187))|0)==0; //@line 1776 "numbers.cpp"
            if (!($cmp328)) { __label__ = 98;break $if_end356$$if_else319$122; } //@line 1776 "numbers.cpp"
  
            var $188=$tr_addr; //@line 1776 "numbers.cpp"
            var $189=$value; //@line 1776 "numbers.cpp"
            var $190=$thousandplex; //@line 1776 "numbers.cpp"
            var $191=$thousands_exact; //@line 1776 "numbers.cpp"
            var $arraydecay330=(($ph_append)&4294967295); //@line 1776 "numbers.cpp"
            var $call331=__ZL15LookupThousandsP10TranslatoriiiPc($188, $189, $190, $191, $arraydecay330); //@line 1776 "numbers.cpp"
            var $tobool332=((($call331))|0)!=0; //@line 1776 "numbers.cpp"
            if (!($tobool332)) { __label__ = 98;break $if_end356$$if_else319$122; } //@line 1776 "numbers.cpp"
  
            $value=0; //@line 1779 "numbers.cpp"
            $suppress_null=1; //@line 1780 "numbers.cpp"
            ; //@line 1781 "numbers.cpp"
          }
          else if (__label__ == 95) {
  
            var $192=HEAP32[((__ZL23speak_missing_thousands)>>2)]; //@line 1787 "numbers.cpp"
            var $cmp338=((($192))|0)==1; //@line 1787 "numbers.cpp"
            if (!($cmp338)) { __label__ = 98;break $if_end356$$if_else319$122; } //@line 1787 "numbers.cpp"
  
            var $arraydecay340=(($string)&4294967295); //@line 1790 "numbers.cpp"
            var $193=$thousandplex; //@line 1790 "numbers.cpp"
            var $add341=((($193)+1)&4294967295); //@line 1790 "numbers.cpp"
            var $call342=_sprintf($arraydecay340, ((__str18315)&4294967295), allocate([$add341,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 1790 "numbers.cpp"
            var $194=$tr_addr; //@line 1791 "numbers.cpp"
            var $arraydecay343=(($string)&4294967295); //@line 1791 "numbers.cpp"
            var $arraydecay344=(($buf1)&4294967295); //@line 1791 "numbers.cpp"
            var $call345=__Z6LookupP10TranslatorPKcPc($194, $arraydecay343, $arraydecay344); //@line 1791 "numbers.cpp"
            var $cmp346=((($call345))|0)==0; //@line 1791 "numbers.cpp"
            if (!($cmp346)) { __label__ = 98;break $if_end356$$if_else319$122; } //@line 1791 "numbers.cpp"
  
            var $arraydecay348=(($string)&4294967295); //@line 1793 "numbers.cpp"
            var $195=$thousandplex; //@line 1793 "numbers.cpp"
            var $call349=_sprintf($arraydecay348, ((__str18315)&4294967295), allocate([$195,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 1793 "numbers.cpp"
            var $196=$tr_addr; //@line 1794 "numbers.cpp"
            var $arraydecay350=(($string)&4294967295); //@line 1794 "numbers.cpp"
            var $arraydecay351=(($ph_append)&4294967295); //@line 1794 "numbers.cpp"
            var $call352=__Z6LookupP10TranslatorPKcPc($196, $arraydecay350, $arraydecay351); //@line 1794 "numbers.cpp"
            ; //@line 1795 "numbers.cpp"
          }
        }
      } while(0);
  
      var $arrayidx357=(($ph_append)&4294967295); //@line 1798 "numbers.cpp"
      var $197=HEAP8[($arrayidx357)]; //@line 1798 "numbers.cpp"
      var $conv358=(tempInt=(($197)),(tempInt>=128?tempInt-256:tempInt)); //@line 1798 "numbers.cpp"
      var $cmp359=((($conv358))|0)==0; //@line 1798 "numbers.cpp"
      if ($cmp359) { __label__ = 99;; } else { __label__ = 102;; } //@line 1798 "numbers.cpp"
      $land_lhs_true360$$if_end369$135: do { 
        if (__label__ == 99) {
  
          var $198=$n_digits; //@line 1798 "numbers.cpp"
          var $199=$word_addr; //@line 1798 "numbers.cpp"
          var $arrayidx361=(($199+$198)&4294967295); //@line 1798 "numbers.cpp"
          var $200=HEAP8[($arrayidx361)]; //@line 1798 "numbers.cpp"
          var $conv362=(tempInt=(($200)),(tempInt>=128?tempInt-256:tempInt)); //@line 1798 "numbers.cpp"
          var $cmp363=((($conv362))|0)==46; //@line 1798 "numbers.cpp"
          if (!($cmp363)) { __label__ = 102;break $land_lhs_true360$$if_end369$135; } //@line 1798 "numbers.cpp"
  
          var $201=$thousandplex; //@line 1798 "numbers.cpp"
          var $cmp365=((($201))|0)==0; //@line 1798 "numbers.cpp"
          if (!($cmp365)) { __label__ = 112;break $land_lhs_true360$$if_end369$135; } //@line 1798 "numbers.cpp"
  
          var $202=$tr_addr; //@line 1800 "numbers.cpp"
          var $arraydecay367=(($ph_append)&4294967295); //@line 1800 "numbers.cpp"
          var $call368=__Z6LookupP10TranslatorPKcPc($202, ((__str19316)&4294967295), $arraydecay367); //@line 1800 "numbers.cpp"
          __label__ = 102;break $land_lhs_true360$$if_end369$135; //@line 1801 "numbers.cpp"
        }
      } while(0);
      $if_end369$$if_end404$139: do { 
        if (__label__ == 102) {
  
          var $_pr47=$thousandplex; //@line 1803 "numbers.cpp"
          var $cmp370=((($_pr47))|0)==0; //@line 1803 "numbers.cpp"
          if (!($cmp370)) { __label__ = 112;break $if_end369$$if_end404$139; } //@line 1803 "numbers.cpp"
  
          var $203=$word_addr; //@line 1807 "numbers.cpp"
          HEAP32[(($p)>>2)]=$203; //@line 1807 "numbers.cpp"
          var $204=HEAP32[(($p)>>2)]; //@line 1808 "numbers.cpp"
          var $arrayidx37360=(($204+1)&4294967295); //@line 1808 "numbers.cpp"
          var $205=HEAP8[($arrayidx37360)]; //@line 1808 "numbers.cpp"
          var $conv37461=(tempInt=(($205)),(tempInt>=128?tempInt-256:tempInt)); //@line 1808 "numbers.cpp"
          var $isdigittmp3062=((($conv37461)-48)&4294967295); //@line 1808 "numbers.cpp"
          var $isdigit3163=((($isdigittmp3062))>>>0) < 10; //@line 1808 "numbers.cpp"
          var $206=HEAPU32[(($p)>>2)]; //@line 1808 "numbers.cpp"
          if ($isdigit3163) { __lastLabel__ = 103; __label__ = 104;; } else { __lastLabel__ = 103; __label__ = 105;; } //@line 1808 "numbers.cpp"
          $while_body377$$while_end379$142: do { 
            if (__label__ == 104) {
              while(1) { 
  
                var $207=__lastLabel__ == 104 ? $210 : ($206);
                var $incdec_ptr378=(($207+1)&4294967295); //@line 1808 "numbers.cpp"
                HEAP32[(($p)>>2)]=$incdec_ptr378; //@line 1808 "numbers.cpp"
                var $208=HEAP32[(($p)>>2)]; //@line 1808 "numbers.cpp"
                var $arrayidx373=(($208+1)&4294967295); //@line 1808 "numbers.cpp"
                var $209=HEAP8[($arrayidx373)]; //@line 1808 "numbers.cpp"
                var $conv374=(tempInt=(($209)),(tempInt>=128?tempInt-256:tempInt)); //@line 1808 "numbers.cpp"
                var $isdigittmp30=((($conv374)-48)&4294967295); //@line 1808 "numbers.cpp"
                var $isdigit31=((($isdigittmp30))>>>0) < 10; //@line 1808 "numbers.cpp"
                var $call375=((($isdigit31))&1); //@line 1808 "numbers.cpp"
                var $tobool376=((($call375))|0)!=0; //@line 1808 "numbers.cpp"
                var $210=HEAPU32[(($p)>>2)]; //@line 1808 "numbers.cpp"
                if ($tobool376) { __lastLabel__ = 104; __label__ = 104;continue ; } else { __lastLabel__ = 104; __label__ = 105;break $while_body377$$while_end379$142; } //@line 1808 "numbers.cpp"
              }
            }
          } while(0);
  
          var $_lcssa=__lastLabel__ == 103 ? $206 : ($210);
          var $arrayidx380=(($_lcssa+-1)&4294967295); //@line 1809 "numbers.cpp"
          var $211=HEAP8[($arrayidx380)]; //@line 1809 "numbers.cpp"
          var $conv381=(tempInt=(($211)),(tempInt>=128?tempInt-256:tempInt)); //@line 1809 "numbers.cpp"
          var $isdigittmp32=((($conv381)-48)&4294967295); //@line 1809 "numbers.cpp"
          var $isdigit33=((($isdigittmp32))>>>0) < 10; //@line 1809 "numbers.cpp"
          var $call382=((($isdigit33))&1); //@line 1809 "numbers.cpp"
          var $tobool383=((($call382))|0)!=0; //@line 1809 "numbers.cpp"
          if ($tobool383) { __label__ = 106;; } else { __label__ = 108;; } //@line 1809 "numbers.cpp"
          $if_then384$$if_end390$146: do { 
            if (__label__ == 106) {
  
              var $212=HEAP32[(($p)>>2)]; //@line 1811 "numbers.cpp"
              var $add_ptr=(($212+-1)&4294967295); //@line 1811 "numbers.cpp"
              HEAP32[(($p2)>>2)]=$add_ptr; //@line 1811 "numbers.cpp"
              var $213=$tr_addr; //@line 1812 "numbers.cpp"
              var $arraydecay385=(($buf_digit_lookup)&4294967295); //@line 1812 "numbers.cpp"
              var $214=$flags_addr; //@line 1812 "numbers.cpp"
              var $215=$wtab_addr; //@line 1812 "numbers.cpp"
              var $call386=__Z14LookupDictListP10TranslatorPPcS1_PjiP8WORD_TAB($213, $p2, $arraydecay385, $214, 4, $215); //@line 1812 "numbers.cpp"
              var $tobool387=((($call386))|0)!=0; //@line 1812 "numbers.cpp"
              if (!($tobool387)) { __label__ = 108;break $if_then384$$if_end390$146; } //@line 1812 "numbers.cpp"
  
              HEAP32[((__ZL14n_digit_lookup)>>2)]=2; //@line 1814 "numbers.cpp"
              ; //@line 1815 "numbers.cpp"
            }
          } while(0);
  
          var $arrayidx391=(($buf_digit_lookup)&4294967295); //@line 1819 "numbers.cpp"
          var $216=HEAP8[($arrayidx391)]; //@line 1819 "numbers.cpp"
          var $conv392=(tempInt=(($216)),(tempInt>=128?tempInt-256:tempInt)); //@line 1819 "numbers.cpp"
          var $cmp393=((($conv392))|0)==0; //@line 1819 "numbers.cpp"
          if (!($cmp393)) { __label__ = 112;break $if_end369$$if_end404$139; } //@line 1819 "numbers.cpp"
  
          var $217=HEAP32[(($p)>>2)]; //@line 1819 "numbers.cpp"
          var $218=HEAP8[($217)]; //@line 1819 "numbers.cpp"
          var $conv395=(tempInt=(($218)),(tempInt>=128?tempInt-256:tempInt)); //@line 1819 "numbers.cpp"
          var $cmp396=((($conv395))|0)!=48; //@line 1819 "numbers.cpp"
          if (!($cmp396)) { __label__ = 112;break $if_end369$$if_end404$139; } //@line 1819 "numbers.cpp"
  
          var $219=$tr_addr; //@line 1822 "numbers.cpp"
          var $arraydecay398=(($buf_digit_lookup)&4294967295); //@line 1822 "numbers.cpp"
          var $220=$flags_addr; //@line 1822 "numbers.cpp"
          var $221=$wtab_addr; //@line 1822 "numbers.cpp"
          var $call399=__Z14LookupDictListP10TranslatorPPcS1_PjiP8WORD_TAB($219, $p, $arraydecay398, $220, 4, $221); //@line 1822 "numbers.cpp"
          var $tobool400=((($call399))|0)!=0; //@line 1822 "numbers.cpp"
          if (!($tobool400)) { __label__ = 112;break $if_end369$$if_end404$139; } //@line 1822 "numbers.cpp"
  
          HEAP32[((__ZL14n_digit_lookup)>>2)]=1; //@line 1824 "numbers.cpp"
          ; //@line 1825 "numbers.cpp"
        }
      } while(0);
  
      var $222=$tr_addr; //@line 1829 "numbers.cpp"
      var $223=$value; //@line 1829 "numbers.cpp"
      var $arraydecay405=(($ph_buf)&4294967295); //@line 1829 "numbers.cpp"
      var $224=$suppress_null; //@line 1829 "numbers.cpp"
      var $225=$thousandplex; //@line 1829 "numbers.cpp"
      var $226=$prev_thousands; //@line 1829 "numbers.cpp"
      var $227=$ordinal; //@line 1829 "numbers.cpp"
      var $or406=($227) | ($226); //@line 1829 "numbers.cpp"
      __ZL10LookupNum3P10TranslatoriPciii($222, $223, $arraydecay405, $224, $225, $or406); //@line 1829 "numbers.cpp"
      var $228=$thousandplex; //@line 1830 "numbers.cpp"
      var $cmp408=((($228))|0) > 0; //@line 1830 "numbers.cpp"
      if ($cmp408) { __label__ = 113;; } else { __label__ = 115;; } //@line 1830 "numbers.cpp"
      $land_lhs_true409$$if_else419$154: do { 
        if (__label__ == 113) {
  
          var $229=$tr_addr; //@line 1830 "numbers.cpp"
          var $langopts410=(($229)&4294967295); //@line 1830 "numbers.cpp"
          var $numbers2=(($langopts410+188)&4294967295); //@line 1830 "numbers.cpp"
          var $230=HEAP32[(($numbers2)>>2)]; //@line 1830 "numbers.cpp"
          var $and411=($230) & 512; //@line 1830 "numbers.cpp"
          var $tobool412=((($and411))|0)!=0; //@line 1830 "numbers.cpp"
          if (!($tobool412)) { __label__ = 115;break $land_lhs_true409$$if_else419$154; } //@line 1830 "numbers.cpp"
  
          var $231=$ph_out_addr; //@line 1831 "numbers.cpp"
          var $arraydecay414=(($ph_zeros)&4294967295); //@line 1831 "numbers.cpp"
          var $arraydecay415=(($ph_append)&4294967295); //@line 1831 "numbers.cpp"
          var $arraydecay416=(($ph_buf2)&4294967295); //@line 1831 "numbers.cpp"
          var $arraydecay417=(($ph_buf)&4294967295); //@line 1831 "numbers.cpp"
          var $call418=_sprintf($231, ((__str20317)&4294967295), allocate([$arraydecay414,0,0,0,$arraydecay415,0,0,0,$arraydecay416,0,0,0,$arraydecay417,0,0,0], ["i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 1831 "numbers.cpp"
          __label__ = 116;break $land_lhs_true409$$if_else419$154; //@line 1831 "numbers.cpp"
        }
      } while(0);
      if (__label__ == 115) {
  
        var $232=$ph_out_addr; //@line 1833 "numbers.cpp"
        var $arraydecay420=(($ph_zeros)&4294967295); //@line 1833 "numbers.cpp"
        var $arraydecay421=(($ph_buf2)&4294967295); //@line 1833 "numbers.cpp"
        var $arraydecay422=(($ph_buf)&4294967295); //@line 1833 "numbers.cpp"
        var $arraydecay423=(($ph_append)&4294967295); //@line 1833 "numbers.cpp"
        var $call424=_sprintf($232, ((__str20317)&4294967295), allocate([$arraydecay420,0,0,0,$arraydecay421,0,0,0,$arraydecay422,0,0,0,$arraydecay423,0,0,0], ["i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 1833 "numbers.cpp"
        ;
      }
  
      var $arraydecay472=(($ph_buf)&4294967295); //@line 1870 "numbers.cpp"
      var $arraydecay480=(($string)&4294967295); //@line 1874 "numbers.cpp"
      var $arraydecay482=(($string)&4294967295); //@line 1875 "numbers.cpp"
      var $arraydecay483=(($buf1)&4294967295); //@line 1875 "numbers.cpp"
      var $arraydecay488=(($ph_buf)&4294967295); //@line 1878 "numbers.cpp"
      var $arraydecay489=(($buf1)&4294967295); //@line 1878 "numbers.cpp"
      var $arraydecay492=(($ph_buf)&4294967295); //@line 1880 "numbers.cpp"
      var $arraydecay504=(($buf1)&4294967295); //@line 1888 "numbers.cpp"
      var $arraydecay506=(($buf1)&4294967295); //@line 1889 "numbers.cpp"
      var $arraydecay463=(($buf1)&4294967295); //@line 1862 "numbers.cpp"
      var $arraydecay465=(($buf1)&4294967295); //@line 1863 "numbers.cpp"
      var $arraydecay448=(($buf1)&4294967295); //@line 1855 "numbers.cpp"
      var $arraydecay450=(($buf1)&4294967295); //@line 1856 "numbers.cpp"
      var $arraydecay524=(($buf1)&4294967295); //@line 1900 "numbers.cpp"
      var $arraydecay526=(($buf1)&4294967295); //@line 1901 "numbers.cpp"
      var $arraydecay529=(($buf1)&4294967295); //@line 1905 "numbers.cpp"
      var $arraydecay533=(($buf1)&4294967295); //@line 1906 "numbers.cpp"
      var $arraydecay547=(($buf1)&4294967295); //@line 1910 "numbers.cpp"
      var $arraydecay549=(($buf1)&4294967295); //@line 1911 "numbers.cpp"
      ; //@line 1836 "numbers.cpp"
      $while_cond426thread_pre_split$160: while(1) { 
  
        var $_pr49=$decimal_point; //@line 1836 "numbers.cpp"
        __lastLabel__ = 117; ;
        $while_cond426$162: while(1) { 
  
          var $233=__lastLabel__ == 117 ? $_pr49 : (0); //@line 1836 "numbers.cpp"
          var $tobool427=((($233))|0)!=0; //@line 1836 "numbers.cpp"
          if (!($tobool427)) { __label__ = 145;break $while_cond426thread_pre_split$160; } //@line 1836 "numbers.cpp"
  
          var $234=$n_digits; //@line 1838 "numbers.cpp"
          var $inc429=((($234)+1)&4294967295); //@line 1838 "numbers.cpp"
          $n_digits=$inc429; //@line 1838 "numbers.cpp"
          $decimal_count=0; //@line 1840 "numbers.cpp"
          var $235=$n_digits; //@line 1841 "numbers.cpp"
          var $236=$decimal_count; //@line 1841 "numbers.cpp"
          var $add43153=((($236)+($235))&4294967295); //@line 1841 "numbers.cpp"
          var $237=$word_addr; //@line 1841 "numbers.cpp"
          var $arrayidx43254=(($237+$add43153)&4294967295); //@line 1841 "numbers.cpp"
          var $238=HEAP8[($arrayidx43254)]; //@line 1841 "numbers.cpp"
          var $conv43355=(tempInt=(($238)),(tempInt>=128?tempInt-256:tempInt)); //@line 1841 "numbers.cpp"
          var $isdigittmp3456=((($conv43355)-48)&4294967295); //@line 1841 "numbers.cpp"
          var $isdigit3557=((($isdigittmp3456))>>>0) < 10; //@line 1841 "numbers.cpp"
          var $call43458=((($isdigit3557))&1); //@line 1841 "numbers.cpp"
          var $tobool43559=((($call43458))|0)!=0; //@line 1841 "numbers.cpp"
          if ($tobool43559) { __label__ = 120;; } else { __label__ = 121;; } //@line 1841 "numbers.cpp"
          $while_body436$$while_end438$165: do { 
            if (__label__ == 120) {
              while(1) { 
  
                var $239=$decimal_count; //@line 1842 "numbers.cpp"
                var $inc437=((($239)+1)&4294967295); //@line 1842 "numbers.cpp"
                $decimal_count=$inc437; //@line 1842 "numbers.cpp"
                var $240=$n_digits; //@line 1841 "numbers.cpp"
                var $241=$decimal_count; //@line 1841 "numbers.cpp"
                var $add431=((($241)+($240))&4294967295); //@line 1841 "numbers.cpp"
                var $242=$word_addr; //@line 1841 "numbers.cpp"
                var $arrayidx432=(($242+$add431)&4294967295); //@line 1841 "numbers.cpp"
                var $243=HEAP8[($arrayidx432)]; //@line 1841 "numbers.cpp"
                var $conv433=(tempInt=(($243)),(tempInt>=128?tempInt-256:tempInt)); //@line 1841 "numbers.cpp"
                var $isdigittmp34=((($conv433)-48)&4294967295); //@line 1841 "numbers.cpp"
                var $isdigit35=((($isdigittmp34))>>>0) < 10; //@line 1841 "numbers.cpp"
                var $call434=((($isdigit35))&1); //@line 1841 "numbers.cpp"
                var $tobool435=((($call434))|0)!=0; //@line 1841 "numbers.cpp"
                if ($tobool435) { __label__ = 120;continue ; } else { __label__ = 121;break $while_body436$$while_end438$165; } //@line 1841 "numbers.cpp"
              }
            }
          } while(0);
  
          $max_decimal_count=2; //@line 1846 "numbers.cpp"
          var $244=$tr_addr; //@line 1847 "numbers.cpp"
          var $langopts439=(($244)&4294967295); //@line 1847 "numbers.cpp"
          var $numbers440=(($langopts439+184)&4294967295); //@line 1847 "numbers.cpp"
          var $245=HEAP32[(($numbers440)>>2)]; //@line 1847 "numbers.cpp"
          var $and441=($245) & 57344; //@line 1847 "numbers.cpp"
          $decimal_mode=$and441; //@line 1847 "numbers.cpp"
          if ($and441 == 32768) {
            __label__ = 122;;
          }
          else if ($and441 == 16384) {
            __label__ = 123;;
          }
          else if ($and441 == 8192) {
            __label__ = 128;;
          }
          else if ($and441 == 40960) {
            __label__ = 128;;
          }
          else if ($and441 == 24576) {
            __label__ = 133;;
          }
          else {
          __label__ = 136;;
          }
          
          $while_cond510$$sw_bb$$while_cond443_preheader$$sw_bb469$$sw_bb495$169: do { 
            if (__label__ == 122) {
  
              $max_decimal_count=5; //@line 1850 "numbers.cpp"
              __label__ = 123;break $while_cond510$$sw_bb$$while_cond443_preheader$$sw_bb469$$sw_bb495$169; //@line 1850 "numbers.cpp"
            }
            else if (__label__ == 128) {
  
              var $267=$tr_addr; //@line 1870 "numbers.cpp"
              var $268=$n_digits; //@line 1870 "numbers.cpp"
              var $269=$word_addr; //@line 1870 "numbers.cpp"
              var $arrayidx470=(($269+$268)&4294967295); //@line 1870 "numbers.cpp"
              var $call471=_atoi($arrayidx470); //@line 1870 "numbers.cpp"
              __ZL10LookupNum3P10TranslatoriPciii($267, $call471, $arraydecay472, 0, 0, 0); //@line 1870 "numbers.cpp"
              var $270=$n_digits; //@line 1871 "numbers.cpp"
              var $271=$word_addr; //@line 1871 "numbers.cpp"
              var $arrayidx474=(($271+$270)&4294967295); //@line 1871 "numbers.cpp"
              var $272=HEAP8[($arrayidx474)]; //@line 1871 "numbers.cpp"
              var $conv475=(tempInt=(($272)),(tempInt>=128?tempInt-256:tempInt)); //@line 1871 "numbers.cpp"
              var $cmp476=((($conv475))|0)==48; //@line 1871 "numbers.cpp"
              if ($cmp476) { __label__ = 130;; } else { __label__ = 129;; } //@line 1871 "numbers.cpp"
              $if_then479$$lor_lhs_false477$172: do { 
                if (__label__ == 129) {
  
                  var $273=$decimal_mode; //@line 1871 "numbers.cpp"
                  var $cmp478=((($273))|0)==40960; //@line 1871 "numbers.cpp"
                  if ($cmp478) { __label__ = 130;break $if_then479$$lor_lhs_false477$172; } else { __label__ = 132;break $if_then479$$lor_lhs_false477$172; } //@line 1871 "numbers.cpp"
                }
              } while(0);
              if (__label__ == 130) {
  
                var $274=$decimal_count; //@line 1874 "numbers.cpp"
                var $call481=_sprintf($arraydecay480, ((__str21318)&4294967295), allocate([$274,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 1874 "numbers.cpp"
                var $275=$tr_addr; //@line 1875 "numbers.cpp"
                var $call484=__Z6LookupP10TranslatorPKcPc($275, $arraydecay482, $arraydecay483); //@line 1875 "numbers.cpp"
                var $cmp485=((($call484))|0)==0; //@line 1875 "numbers.cpp"
                if ($cmp485) { __label__ = 136;break $while_cond510$$sw_bb$$while_cond443_preheader$$sw_bb469$$sw_bb495$169; } //@line 1875 "numbers.cpp"
  
                var $call490=_strcat($arraydecay488, $arraydecay489); //@line 1878 "numbers.cpp"
                ; //@line 1879 "numbers.cpp"
              }
  
              var $276=$ph_out_addr; //@line 1880 "numbers.cpp"
              var $call493=_strcat($276, $arraydecay492); //@line 1880 "numbers.cpp"
              var $277=$decimal_count; //@line 1881 "numbers.cpp"
              var $278=$n_digits; //@line 1881 "numbers.cpp"
              var $add494=((($278)+($277))&4294967295); //@line 1881 "numbers.cpp"
              $n_digits=$add494; //@line 1881 "numbers.cpp"
              __label__ = 136;break $while_cond510$$sw_bb$$while_cond443_preheader$$sw_bb469$$sw_bb495$169; //@line 1882 "numbers.cpp"
            }
            else if (__label__ == 133) {
  
              var $279=$decimal_count; //@line 1886 "numbers.cpp"
              var $cmp496=((($279))|0) <= 4; //@line 1886 "numbers.cpp"
              if (!($cmp496)) { __label__ = 136;break $while_cond510$$sw_bb$$while_cond443_preheader$$sw_bb469$$sw_bb495$169; } //@line 1886 "numbers.cpp"
  
              var $280=$n_digits; //@line 1886 "numbers.cpp"
              var $281=$word_addr; //@line 1886 "numbers.cpp"
              var $arrayidx498=(($281+$280)&4294967295); //@line 1886 "numbers.cpp"
              var $282=HEAP8[($arrayidx498)]; //@line 1886 "numbers.cpp"
              var $conv499=(tempInt=(($282)),(tempInt>=128?tempInt-256:tempInt)); //@line 1886 "numbers.cpp"
              var $cmp500=((($conv499))|0)!=48; //@line 1886 "numbers.cpp"
              if (!($cmp500)) { __label__ = 136;break $while_cond510$$sw_bb$$while_cond443_preheader$$sw_bb469$$sw_bb495$169; } //@line 1886 "numbers.cpp"
  
              var $283=$tr_addr; //@line 1888 "numbers.cpp"
              var $284=$n_digits; //@line 1888 "numbers.cpp"
              var $285=$word_addr; //@line 1888 "numbers.cpp"
              var $arrayidx502=(($285+$284)&4294967295); //@line 1888 "numbers.cpp"
              var $call503=_atoi($arrayidx502); //@line 1888 "numbers.cpp"
              __ZL10LookupNum3P10TranslatoriPciii($283, $call503, $arraydecay504, 0, 0, 0); //@line 1888 "numbers.cpp"
              var $286=$ph_out_addr; //@line 1889 "numbers.cpp"
              var $call507=_strcat($286, $arraydecay506); //@line 1889 "numbers.cpp"
              var $287=$decimal_count; //@line 1890 "numbers.cpp"
              var $288=$n_digits; //@line 1890 "numbers.cpp"
              var $add508=((($288)+($287))&4294967295); //@line 1890 "numbers.cpp"
              $n_digits=$add508; //@line 1890 "numbers.cpp"
              __label__ = 136;break $while_cond510$$sw_bb$$while_cond443_preheader$$sw_bb469$$sw_bb495$169; //@line 1891 "numbers.cpp"
            }
          } while(0);
          $while_cond510$$while_cond443_preheader$181: do { 
            if (__label__ == 123) {
  
              var $246=$n_digits; //@line 1853 "numbers.cpp"
              var $247=$word_addr; //@line 1853 "numbers.cpp"
              var $arrayidx44450=(($247+$246)&4294967295); //@line 1853 "numbers.cpp"
              var $248=HEAP8[($arrayidx44450)]; //@line 1853 "numbers.cpp"
              var $conv44551=(tempInt=(($248)),(tempInt>=128?tempInt-256:tempInt)); //@line 1853 "numbers.cpp"
              var $cmp44652=((($conv44551))|0)==48; //@line 1853 "numbers.cpp"
              if ($cmp44652) { __label__ = 124;; } else { __label__ = 125;; } //@line 1853 "numbers.cpp"
              $while_body447$$while_end453$183: do { 
                if (__label__ == 124) {
                  while(1) { 
  
                    var $249=$tr_addr; //@line 1855 "numbers.cpp"
                    var $call449=__Z6LookupP10TranslatorPKcPc($249, ((__str16313)&4294967295), $arraydecay448); //@line 1855 "numbers.cpp"
                    var $250=$ph_out_addr; //@line 1856 "numbers.cpp"
                    var $call451=_strcat($250, $arraydecay450); //@line 1856 "numbers.cpp"
                    var $251=$decimal_count; //@line 1857 "numbers.cpp"
                    var $dec=((($251)-1)&4294967295); //@line 1857 "numbers.cpp"
                    $decimal_count=$dec; //@line 1857 "numbers.cpp"
                    var $252=$n_digits; //@line 1858 "numbers.cpp"
                    var $inc452=((($252)+1)&4294967295); //@line 1858 "numbers.cpp"
                    $n_digits=$inc452; //@line 1858 "numbers.cpp"
                    var $253=$n_digits; //@line 1853 "numbers.cpp"
                    var $254=$word_addr; //@line 1853 "numbers.cpp"
                    var $arrayidx444=(($254+$253)&4294967295); //@line 1853 "numbers.cpp"
                    var $255=HEAP8[($arrayidx444)]; //@line 1853 "numbers.cpp"
                    var $conv445=(tempInt=(($255)),(tempInt>=128?tempInt-256:tempInt)); //@line 1853 "numbers.cpp"
                    var $cmp446=((($conv445))|0)==48; //@line 1853 "numbers.cpp"
                    if ($cmp446) { __label__ = 124;continue ; } else { __label__ = 125;break $while_body447$$while_end453$183; } //@line 1853 "numbers.cpp"
                  }
                }
              } while(0);
  
              var $256=$decimal_count; //@line 1860 "numbers.cpp"
              var $257=$max_decimal_count; //@line 1860 "numbers.cpp"
              var $cmp454=((($256))|0) <= ((($257))|0); //@line 1860 "numbers.cpp"
              if (!($cmp454)) { __label__ = 136;break $while_cond510$$while_cond443_preheader$181; } //@line 1860 "numbers.cpp"
  
              var $258=$n_digits; //@line 1860 "numbers.cpp"
              var $259=$word_addr; //@line 1860 "numbers.cpp"
              var $arrayidx456=(($259+$258)&4294967295); //@line 1860 "numbers.cpp"
              var $260=HEAP8[($arrayidx456)]; //@line 1860 "numbers.cpp"
              var $conv457=(tempInt=(($260)),(tempInt>=128?tempInt-256:tempInt)); //@line 1860 "numbers.cpp"
              var $isdigittmp36=((($conv457)-48)&4294967295); //@line 1860 "numbers.cpp"
              var $isdigit37=((($isdigittmp36))>>>0) < 10; //@line 1860 "numbers.cpp"
              var $call458=((($isdigit37))&1); //@line 1860 "numbers.cpp"
              var $tobool459=((($call458))|0)!=0; //@line 1860 "numbers.cpp"
              if (!($tobool459)) { __label__ = 136;break $while_cond510$$while_cond443_preheader$181; } //@line 1860 "numbers.cpp"
  
              var $261=$tr_addr; //@line 1862 "numbers.cpp"
              var $262=$n_digits; //@line 1862 "numbers.cpp"
              var $263=$word_addr; //@line 1862 "numbers.cpp"
              var $arrayidx461=(($263+$262)&4294967295); //@line 1862 "numbers.cpp"
              var $call462=_atoi($arrayidx461); //@line 1862 "numbers.cpp"
              __ZL10LookupNum3P10TranslatoriPciii($261, $call462, $arraydecay463, 0, 0, 0); //@line 1862 "numbers.cpp"
              var $264=$ph_out_addr; //@line 1863 "numbers.cpp"
              var $call466=_strcat($264, $arraydecay465); //@line 1863 "numbers.cpp"
              var $265=$decimal_count; //@line 1864 "numbers.cpp"
              var $266=$n_digits; //@line 1864 "numbers.cpp"
              var $add467=((($266)+($265))&4294967295); //@line 1864 "numbers.cpp"
              $n_digits=$add467; //@line 1864 "numbers.cpp"
              ; //@line 1865 "numbers.cpp"
            }
          } while(0);
          while(1) { 
  
            var $289=$n_digits; //@line 1896 "numbers.cpp"
            var $290=$word_addr; //@line 1896 "numbers.cpp"
            var $arrayidx511=(($290+$289)&4294967295); //@line 1896 "numbers.cpp"
            var $291=HEAPU8[($arrayidx511)]; //@line 1896 "numbers.cpp"
            $c=$291; //@line 1896 "numbers.cpp"
            var $conv512=((($291))&255); //@line 1896 "numbers.cpp"
            var $isdigittmp38=((($conv512)-48)&4294967295); //@line 1896 "numbers.cpp"
            var $isdigit39=((($isdigittmp38))>>>0) < 10; //@line 1896 "numbers.cpp"
            var $call513=((($isdigit39))&1); //@line 1896 "numbers.cpp"
            var $tobool514=((($call513))|0)!=0; //@line 1896 "numbers.cpp"
            if (!($tobool514)) { __label__ = 139;break ; } //@line 1896 "numbers.cpp"
  
            var $292=$ph_out_addr; //@line 1896 "numbers.cpp"
            var $call516=_strlen($292); //@line 1896 "numbers.cpp"
            var $cmp517=((($call516))>>>0) < 150; //@line 1896 "numbers.cpp"
            if (!($cmp517)) { __label__ = 139;break ; }
  
            var $293=$n_digits; //@line 1899 "numbers.cpp"
            var $inc520=((($293)+1)&4294967295); //@line 1899 "numbers.cpp"
            $n_digits=$inc520; //@line 1899 "numbers.cpp"
            var $294=$word_addr; //@line 1899 "numbers.cpp"
            var $arrayidx521=(($294+$293)&4294967295); //@line 1899 "numbers.cpp"
            var $295=HEAP8[($arrayidx521)]; //@line 1899 "numbers.cpp"
            var $conv522=(tempInt=(($295)),(tempInt>=128?tempInt-256:tempInt)); //@line 1899 "numbers.cpp"
            var $sub523=((($conv522)-48)&4294967295); //@line 1899 "numbers.cpp"
            $value=$sub523; //@line 1899 "numbers.cpp"
            var $296=$tr_addr; //@line 1900 "numbers.cpp"
            var $297=$value; //@line 1900 "numbers.cpp"
            var $call525=__ZL10LookupNum2P10TranslatoriiPc($296, $297, 2, $arraydecay524); //@line 1900 "numbers.cpp"
            var $298=$ph_out_addr; //@line 1901 "numbers.cpp"
            var $call527=_strcat($298, $arraydecay526); //@line 1901 "numbers.cpp"
            __label__ = 136;continue ; //@line 1902 "numbers.cpp"
          }
  
          var $299=$tr_addr; //@line 1905 "numbers.cpp"
          var $call530=__Z6LookupP10TranslatorPKcPc($299, ((__str22319)&4294967295), $arraydecay529); //@line 1905 "numbers.cpp"
          var $tobool531=((($call530))|0)!=0; //@line 1905 "numbers.cpp"
          if ($tobool531) { __label__ = 140;; } else { __label__ = 141;; } //@line 1905 "numbers.cpp"
          if (__label__ == 140) {
  
            var $300=$ph_out_addr; //@line 1906 "numbers.cpp"
            var $call534=_strcat($300, $arraydecay533); //@line 1906 "numbers.cpp"
            ; //@line 1906 "numbers.cpp"
          }
  
          var $301=$c; //@line 1908 "numbers.cpp"
          var $conv536=((($301))&255); //@line 1908 "numbers.cpp"
          var $302=$tr_addr; //@line 1908 "numbers.cpp"
          var $langopts537=(($302)&4294967295); //@line 1908 "numbers.cpp"
          var $decimal_sep538=(($langopts537+208)&4294967295); //@line 1908 "numbers.cpp"
          var $303=HEAP32[(($decimal_sep538)>>2)]; //@line 1908 "numbers.cpp"
          var $cmp539=((($conv536))|0)==((($303))|0); //@line 1908 "numbers.cpp"
          if ($cmp539) { __label__ = 142;; } else { __label__ = 144;; } //@line 1908 "numbers.cpp"
          if (__label__ == 142) {
  
            var $304=$n_digits; //@line 1908 "numbers.cpp"
            var $add541=((($304)+1)&4294967295); //@line 1908 "numbers.cpp"
            var $305=$word_addr; //@line 1908 "numbers.cpp"
            var $arrayidx542=(($305+$add541)&4294967295); //@line 1908 "numbers.cpp"
            var $306=HEAP8[($arrayidx542)]; //@line 1908 "numbers.cpp"
            var $conv543=(tempInt=(($306)),(tempInt>=128?tempInt-256:tempInt)); //@line 1908 "numbers.cpp"
            var $isdigittmp40=((($conv543)-48)&4294967295); //@line 1908 "numbers.cpp"
            var $isdigit41=((($isdigittmp40))>>>0) < 10; //@line 1908 "numbers.cpp"
            var $call544=((($isdigit41))&1); //@line 1908 "numbers.cpp"
            var $tobool545=((($call544))|0)!=0; //@line 1908 "numbers.cpp"
            if ($tobool545) { __label__ = 143;break $while_cond426$162; } //@line 1908 "numbers.cpp"
          }
  
          $decimal_point=0; //@line 1915 "numbers.cpp"
          __lastLabel__ = 144; __label__ = 118;continue $while_cond426$162;
        }
  
        var $307=$tr_addr; //@line 1910 "numbers.cpp"
        var $call548=__Z6LookupP10TranslatorPKcPc($307, ((__str17314)&4294967295), $arraydecay547); //@line 1910 "numbers.cpp"
        var $308=$ph_out_addr; //@line 1911 "numbers.cpp"
        var $call550=_strcat($308, $arraydecay549); //@line 1911 "numbers.cpp"
        __label__ = 117;continue $while_cond426thread_pre_split$160; //@line 1912 "numbers.cpp"
      }
  
      var $309=$ph_out_addr; //@line 1918 "numbers.cpp"
      var $arrayidx554=(($309)&4294967295); //@line 1918 "numbers.cpp"
      var $310=HEAP8[($arrayidx554)]; //@line 1918 "numbers.cpp"
      var $conv555=(tempInt=(($310)),(tempInt>=128?tempInt-256:tempInt)); //@line 1918 "numbers.cpp"
      var $cmp556=((($conv555))|0)!=0; //@line 1918 "numbers.cpp"
      if ($cmp556) { __label__ = 146;; } else { __label__ = 154;; } //@line 1918 "numbers.cpp"
      $land_lhs_true557$$if_end588$202: do { 
        if (__label__ == 146) {
  
          var $311=$ph_out_addr; //@line 1918 "numbers.cpp"
          var $arrayidx558=(($311)&4294967295); //@line 1918 "numbers.cpp"
          var $312=HEAP8[($arrayidx558)]; //@line 1918 "numbers.cpp"
          var $conv559=(tempInt=(($312)),(tempInt>=128?tempInt-256:tempInt)); //@line 1918 "numbers.cpp"
          var $cmp560=((($conv559))|0)!=21; //@line 1918 "numbers.cpp"
          if (!($cmp560)) { __label__ = 154;break $land_lhs_true557$$if_end588$202; } //@line 1918 "numbers.cpp"
  
          var $313=$n_digits; //@line 1922 "numbers.cpp"
          var $add563=((($313)+1)&4294967295); //@line 1922 "numbers.cpp"
          var $314=$word_addr; //@line 1922 "numbers.cpp"
          var $arrayidx564=(($314+$add563)&4294967295); //@line 1922 "numbers.cpp"
          $p562=$arrayidx564; //@line 1922 "numbers.cpp"
          var $315=$p562; //@line 1924 "numbers.cpp"
          var $call565=__Z7utf8_inPiPKc($next_char, $315); //@line 1924 "numbers.cpp"
          var $316=$p562; //@line 1924 "numbers.cpp"
          var $add_ptr566=(($316+$call565)&4294967295); //@line 1924 "numbers.cpp"
          $p562=$add_ptr566; //@line 1924 "numbers.cpp"
          var $317=$tr_addr; //@line 1925 "numbers.cpp"
          var $langopts567=(($317)&4294967295); //@line 1925 "numbers.cpp"
          var $numbers568=(($langopts567+184)&4294967295); //@line 1925 "numbers.cpp"
          var $318=HEAP32[(($numbers568)>>2)]; //@line 1925 "numbers.cpp"
          var $and569=($318) & 131072; //@line 1925 "numbers.cpp"
          var $tobool570=((($and569))|0)!=0; //@line 1925 "numbers.cpp"
          if ($tobool570) { __label__ = 148;; } else { __label__ = 150;; } //@line 1925 "numbers.cpp"
          $land_lhs_true571$$if_end575$205: do { 
            if (__label__ == 148) {
  
              var $319=HEAP32[(($next_char)>>2)]; //@line 1925 "numbers.cpp"
              var $cmp572=((($319))|0)==32; //@line 1925 "numbers.cpp"
              if (!($cmp572)) { __label__ = 150;break $land_lhs_true571$$if_end575$205; } //@line 1925 "numbers.cpp"
  
              var $320=$p562; //@line 1926 "numbers.cpp"
              var $call574=__Z7utf8_inPiPKc($next_char, $320); //@line 1926 "numbers.cpp"
              ; //@line 1926 "numbers.cpp"
            }
          } while(0);
  
          var $321=HEAP32[(($next_char)>>2)]; //@line 1928 "numbers.cpp"
          var $call576=_iswalpha($321); //@line 1928 "numbers.cpp"
          var $tobool577=((($call576))|0)!=0; //@line 1928 "numbers.cpp"
          if ($tobool577) { __label__ = 154;break $land_lhs_true557$$if_end588$202; } //@line 1928 "numbers.cpp"
  
          var $322=$thousandplex; //@line 1928 "numbers.cpp"
          var $323=$wtab_addr; //@line 1928 "numbers.cpp"
          var $arrayidx579=(($323+12*$322)&4294967295); //@line 1928 "numbers.cpp"
          var $flags580=(($arrayidx579)&4294967295); //@line 1928 "numbers.cpp"
          var $324=HEAP32[(($flags580)>>2)]; //@line 1928 "numbers.cpp"
          var $and581=($324) & 16384; //@line 1928 "numbers.cpp"
          var $tobool582=((($and581))|0)!=0; //@line 1928 "numbers.cpp"
          if ($tobool582) { __label__ = 152;; } else { __label__ = 153;; } //@line 1928 "numbers.cpp"
          if (__label__ == 152) {
  
            var $325=$thousands_exact; //@line 1928 "numbers.cpp"
            var $cmp584=((($325))|0)!=0; //@line 1928 "numbers.cpp"
            if ($cmp584) { __label__ = 154;break $land_lhs_true557$$if_end588$202; } //@line 1928 "numbers.cpp"
          }
  
          var $326=$ph_out_addr; //@line 1929 "numbers.cpp"
          var $strlen=_strlen($326); //@line 1929 "numbers.cpp"
          var $endptr=(($326+$strlen)&4294967295); //@line 1929 "numbers.cpp"
          var $src$, $dest$, $stop$, $stop4$, $fast$;
          $src$ = ((__ZZL17TranslateNumber_1P10TranslatorPcS1_PjP8WORD_TABiE9str_pause)&4294967295);
          $dest$ = $endptr;
          $stop$ = $src$ + 2;
          if (($dest$%4) == ($src$%4) && 2 > 8) {
            while ($src$%4 !== 0 && $src$ < $stop$) {
              ; HEAP8[$dest$++] = HEAP8[$src$++];
            }
            $src$ >>= 2;
            $dest$ >>= 2;
            $stop4$ = $stop$ >> 2;
            while ($src$ < $stop4$) {
          ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
            }
            $src$ <<= 2;
            $dest$ <<= 2;
          }while ($src$ < $stop$) {
            ; HEAP8[$dest$++] = HEAP8[$src$++];
          }; //@line 1929 "numbers.cpp"
          ; //@line 1929 "numbers.cpp"
        }
      } while(0);
  
      var $327=$flags_addr; //@line 1932 "numbers.cpp"
      var $328=HEAP32[(($327)>>2)]; //@line 1932 "numbers.cpp"
      var $or589=($328) | -2147483648; //@line 1932 "numbers.cpp"
      HEAP32[(($327)>>2)]=$or589; //@line 1932 "numbers.cpp"
      var $329=HEAP32[((__ZL23speak_missing_thousands)>>2)]; //@line 1933 "numbers.cpp"
      var $dec590=((($329)-1)&4294967295); //@line 1933 "numbers.cpp"
      HEAP32[((__ZL23speak_missing_thousands)>>2)]=$dec590; //@line 1933 "numbers.cpp"
      var $330=$skipwords; //@line 1935 "numbers.cpp"
      var $tobool591=((($330))|0)!=0; //@line 1935 "numbers.cpp"
      if ($tobool591) { __label__ = 155;; } else { __label__ = 156;; } //@line 1935 "numbers.cpp"
      if (__label__ == 155) {
  
        var $331=$skipwords; //@line 1936 "numbers.cpp"
        HEAP32[((_dictionary_skipwords)>>2)]=$331; //@line 1936 "numbers.cpp"
        ; //@line 1936 "numbers.cpp"
      }
  
      $retval=1; //@line 1937 "numbers.cpp"
      ; //@line 1937 "numbers.cpp"
    }
  
    var $332=$retval; //@line 1938 "numbers.cpp"
    STACKTOP = __stackBase__;
    return $332; //@line 1938 "numbers.cpp"
    return null;
  }
  

  function __ZL15LookupThousandsP10TranslatoriiiPc($tr, $value, $thousandplex, $thousands_exact, $ph_out) {
    var __stackBase__  = STACKTOP; STACKTOP += 104; _memset(__stackBase__, 0, 104);
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $tr_addr;
    var $value_addr;
    var $thousandplex_addr;
    var $thousands_exact_addr;
    var $ph_out_addr;
    var $found;
    var $found_value;
    var $string=__stackBase__;
    var $ph_of=__stackBase__+12;
    var $ph_thousands=__stackBase__+24;
    var $ph_buf=__stackBase__+64;
    $tr_addr=$tr;
    $value_addr=$value;
    $thousandplex_addr=$thousandplex;
    $thousands_exact_addr=$thousands_exact;
    $ph_out_addr=$ph_out;
    $found_value=0; //@line 991 "numbers.cpp"
    var $arrayidx=(($ph_of)&4294967295); //@line 997 "numbers.cpp"
    HEAP8[($arrayidx)]=0; //@line 997 "numbers.cpp"
    var $0=$value_addr; //@line 1000 "numbers.cpp"
    var $cmp=((($0))|0) > 0; //@line 1000 "numbers.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 12;; } //@line 1000 "numbers.cpp"
    $if_then$$if_end36thread_pre_split$2: do { 
      if (__label__ == 1) {
  
        var $1=$thousands_exact_addr; //@line 1002 "numbers.cpp"
        var $and=($1) & 1; //@line 1002 "numbers.cpp"
        var $tobool=((($and))|0)!=0; //@line 1002 "numbers.cpp"
        if ($tobool) { __label__ = 2;; } else { __label__ = 9;; } //@line 1002 "numbers.cpp"
        $if_then1$$if_end27thread_pre_split$4: do { 
          if (__label__ == 2) {
  
            var $2=$thousands_exact_addr; //@line 1004 "numbers.cpp"
            var $and2=($2) & 2; //@line 1004 "numbers.cpp"
            var $tobool3=((($and2))|0)!=0; //@line 1004 "numbers.cpp"
            if ($tobool3) { __label__ = 3;; } else { __label__ = 4;; } //@line 1004 "numbers.cpp"
            if (__label__ == 3) {
  
              var $arraydecay=(($string)&4294967295); //@line 1007 "numbers.cpp"
              var $3=$value_addr; //@line 1007 "numbers.cpp"
              var $4=$thousandplex_addr; //@line 1007 "numbers.cpp"
              var $call=_sprintf($arraydecay, ((__str42339)&4294967295), allocate([$3,0,0,0,$4,0,0,0], ["i32",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 1007 "numbers.cpp"
              var $5=$tr_addr; //@line 1008 "numbers.cpp"
              var $arraydecay5=(($string)&4294967295); //@line 1008 "numbers.cpp"
              var $arraydecay6=(($ph_thousands)&4294967295); //@line 1008 "numbers.cpp"
              var $call7=__Z6LookupP10TranslatorPKcPc($5, $arraydecay5, $arraydecay6); //@line 1008 "numbers.cpp"
              $found_value=$call7; //@line 1008 "numbers.cpp"
              ; //@line 1009 "numbers.cpp"
            }
  
            var $6=$found_value; //@line 1010 "numbers.cpp"
            var $tobool8=((($6))|0)!=0; //@line 1010 "numbers.cpp"
            var $lnot=($tobool8) ^ 1; //@line 1010 "numbers.cpp"
            var $conv=((($lnot))&1); //@line 1010 "numbers.cpp"
            var $7=HEAP32[((__ZL14number_control)>>2)]; //@line 1010 "numbers.cpp"
            var $and9=($7) & 1; //@line 1010 "numbers.cpp"
            var $and10=($and9) & ($conv); //@line 1010 "numbers.cpp"
            var $tobool11=((($and10))|0)!=0; //@line 1010 "numbers.cpp"
            if ($tobool11) { __label__ = 5;; } else { __label__ = 6;; } //@line 1010 "numbers.cpp"
            if (__label__ == 5) {
  
              var $arraydecay13=(($string)&4294967295); //@line 1013 "numbers.cpp"
              var $8=$value_addr; //@line 1013 "numbers.cpp"
              var $9=$thousandplex_addr; //@line 1013 "numbers.cpp"
              var $call14=_sprintf($arraydecay13, ((__str43340)&4294967295), allocate([$8,0,0,0,$9,0,0,0], ["i32",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 1013 "numbers.cpp"
              var $10=$tr_addr; //@line 1014 "numbers.cpp"
              var $arraydecay15=(($string)&4294967295); //@line 1014 "numbers.cpp"
              var $arraydecay16=(($ph_thousands)&4294967295); //@line 1014 "numbers.cpp"
              var $call17=__Z6LookupP10TranslatorPKcPc($10, $arraydecay15, $arraydecay16); //@line 1014 "numbers.cpp"
              $found_value=$call17; //@line 1014 "numbers.cpp"
              __lastLabel__ = 5; ; //@line 1015 "numbers.cpp"
            }
            else if (__label__ == 6) {
  
              var $_pr=$found_value; //@line 1016 "numbers.cpp"
              __lastLabel__ = 6; ;
            }
  
            var $11=__lastLabel__ == 6 ? $_pr : ($call17); //@line 1016 "numbers.cpp"
            var $tobool19=((($11))|0)!=0; //@line 1016 "numbers.cpp"
            if ($tobool19) { __label__ = 9;break $if_then1$$if_end27thread_pre_split$4; } //@line 1016 "numbers.cpp"
  
            var $arraydecay21=(($string)&4294967295); //@line 1019 "numbers.cpp"
            var $12=$value_addr; //@line 1019 "numbers.cpp"
            var $13=$thousandplex_addr; //@line 1019 "numbers.cpp"
            var $call22=_sprintf($arraydecay21, ((__str44341)&4294967295), allocate([$12,0,0,0,$13,0,0,0], ["i32",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 1019 "numbers.cpp"
            var $14=$tr_addr; //@line 1020 "numbers.cpp"
            var $arraydecay23=(($string)&4294967295); //@line 1020 "numbers.cpp"
            var $arraydecay24=(($ph_thousands)&4294967295); //@line 1020 "numbers.cpp"
            var $call25=__Z6LookupP10TranslatorPKcPc($14, $arraydecay23, $arraydecay24); //@line 1020 "numbers.cpp"
            $found_value=$call25; //@line 1020 "numbers.cpp"
            __lastLabel__ = 8; __label__ = 10;break $if_then1$$if_end27thread_pre_split$4; //@line 1021 "numbers.cpp"
          }
        } while(0);
        if (__label__ == 9) {
  
          var $_pr1=$found_value; //@line 1023 "numbers.cpp"
          __lastLabel__ = 9; ;
        }
  
        var $15=__lastLabel__ == 9 ? $_pr1 : ($call25); //@line 1023 "numbers.cpp"
        var $cmp28=((($15))|0)==0; //@line 1023 "numbers.cpp"
        if (!($cmp28)) { __label__ = 12;break $if_then$$if_end36thread_pre_split$2; } //@line 1023 "numbers.cpp"
  
        var $arraydecay30=(($string)&4294967295); //@line 1025 "numbers.cpp"
        var $16=$value_addr; //@line 1025 "numbers.cpp"
        var $17=$thousandplex_addr; //@line 1025 "numbers.cpp"
        var $call31=_sprintf($arraydecay30, ((__str45342)&4294967295), allocate([$16,0,0,0,$17,0,0,0], ["i32",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 1025 "numbers.cpp"
        var $18=$tr_addr; //@line 1026 "numbers.cpp"
        var $arraydecay32=(($string)&4294967295); //@line 1026 "numbers.cpp"
        var $arraydecay33=(($ph_thousands)&4294967295); //@line 1026 "numbers.cpp"
        var $call34=__Z6LookupP10TranslatorPKcPc($18, $arraydecay32, $arraydecay33); //@line 1026 "numbers.cpp"
        $found_value=$call34; //@line 1026 "numbers.cpp"
        __lastLabel__ = 11; __label__ = 13;break $if_then$$if_end36thread_pre_split$2; //@line 1027 "numbers.cpp"
      }
    } while(0);
    if (__label__ == 12) {
  
      var $_pr2=$found_value; //@line 1030 "numbers.cpp"
      __lastLabel__ = 12; ;
    }
  
    var $19=__lastLabel__ == 12 ? $_pr2 : ($call34); //@line 1030 "numbers.cpp"
    var $cmp37=((($19))|0)==0; //@line 1030 "numbers.cpp"
    if ($cmp37) { __label__ = 14;; } else { __label__ = 36;; } //@line 1030 "numbers.cpp"
    $if_then38$$if_end118$21: do { 
      if (__label__ == 14) {
  
        var $20=$value_addr; //@line 1032 "numbers.cpp"
        var $rem=((($20))|0)%100; //@line 1032 "numbers.cpp"
        var $cmp39=((($rem))|0) >= 20; //@line 1032 "numbers.cpp"
        if ($cmp39) { __label__ = 15;; } else { __label__ = 16;; } //@line 1032 "numbers.cpp"
        if (__label__ == 15) {
  
          var $21=$tr_addr; //@line 1034 "numbers.cpp"
          var $arraydecay41=(($ph_of)&4294967295); //@line 1034 "numbers.cpp"
          var $call42=__Z6LookupP10TranslatorPKcPc($21, ((__str46343)&4294967295), $arraydecay41); //@line 1034 "numbers.cpp"
          ; //@line 1035 "numbers.cpp"
        }
  
        $found=0; //@line 1037 "numbers.cpp"
        var $22=$thousands_exact_addr; //@line 1038 "numbers.cpp"
        var $and44=($22) & 1; //@line 1038 "numbers.cpp"
        var $tobool45=((($and44))|0)!=0; //@line 1038 "numbers.cpp"
        if ($tobool45) { __label__ = 17;; } else { __label__ = 28;; } //@line 1038 "numbers.cpp"
        if (__label__ == 17) {
  
          var $23=$thousands_exact_addr; //@line 1040 "numbers.cpp"
          var $and47=($23) & 2; //@line 1040 "numbers.cpp"
          var $tobool48=((($and47))|0)!=0; //@line 1040 "numbers.cpp"
          if ($tobool48) { __label__ = 18;; } else { __label__ = 19;; } //@line 1040 "numbers.cpp"
          if (__label__ == 18) {
  
            var $arraydecay50=(($string)&4294967295); //@line 1043 "numbers.cpp"
            var $24=$value_addr; //@line 1043 "numbers.cpp"
            var $call51=__ZL9M_Varianti($24); //@line 1043 "numbers.cpp"
            var $25=$thousandplex_addr; //@line 1043 "numbers.cpp"
            var $call52=_sprintf($arraydecay50, ((__str47344)&4294967295), allocate([$call51,0,0,0,$25,0,0,0], ["i8*",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 1043 "numbers.cpp"
            var $26=$tr_addr; //@line 1044 "numbers.cpp"
            var $arraydecay53=(($string)&4294967295); //@line 1044 "numbers.cpp"
            var $arraydecay54=(($ph_thousands)&4294967295); //@line 1044 "numbers.cpp"
            var $call55=__Z6LookupP10TranslatorPKcPc($26, $arraydecay53, $arraydecay54); //@line 1044 "numbers.cpp"
            $found=$call55; //@line 1044 "numbers.cpp"
            __lastLabel__ = 18; ; //@line 1045 "numbers.cpp"
          }
          else if (__label__ == 19) {
  
            var $_pr3=$found; //@line 1046 "numbers.cpp"
            __lastLabel__ = 19; ;
          }
  
          var $27=__lastLabel__ == 19 ? $_pr3 : ($call55); //@line 1046 "numbers.cpp"
          var $tobool57=((($27))|0)!=0; //@line 1046 "numbers.cpp"
          if ($tobool57) { __label__ = 23;; } else { __label__ = 21;; } //@line 1046 "numbers.cpp"
          $if_end67thread_pre_split$$land_lhs_true$32: do { 
            if (__label__ == 21) {
  
              var $28=HEAP32[((__ZL14number_control)>>2)]; //@line 1046 "numbers.cpp"
              var $and58=($28) & 1; //@line 1046 "numbers.cpp"
              var $tobool59=((($and58))|0)!=0; //@line 1046 "numbers.cpp"
              if (!($tobool59)) { __label__ = 23;break $if_end67thread_pre_split$$land_lhs_true$32; } //@line 1046 "numbers.cpp"
  
              var $arraydecay61=(($string)&4294967295); //@line 1049 "numbers.cpp"
              var $29=$value_addr; //@line 1049 "numbers.cpp"
              var $call62=__ZL9M_Varianti($29); //@line 1049 "numbers.cpp"
              var $30=$thousandplex_addr; //@line 1049 "numbers.cpp"
              var $call63=_sprintf($arraydecay61, ((__str48345)&4294967295), allocate([$call62,0,0,0,$30,0,0,0], ["i8*",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 1049 "numbers.cpp"
              var $31=$tr_addr; //@line 1050 "numbers.cpp"
              var $arraydecay64=(($string)&4294967295); //@line 1050 "numbers.cpp"
              var $arraydecay65=(($ph_thousands)&4294967295); //@line 1050 "numbers.cpp"
              var $call66=__Z6LookupP10TranslatorPKcPc($31, $arraydecay64, $arraydecay65); //@line 1050 "numbers.cpp"
              $found=$call66; //@line 1050 "numbers.cpp"
              __lastLabel__ = 22; __label__ = 24;break $if_end67thread_pre_split$$land_lhs_true$32; //@line 1051 "numbers.cpp"
            }
          } while(0);
          if (__label__ == 23) {
  
            var $_pr4=$found; //@line 1052 "numbers.cpp"
            __lastLabel__ = 23; ;
          }
  
          var $32=__lastLabel__ == 23 ? $_pr4 : ($call66); //@line 1052 "numbers.cpp"
          var $tobool68=((($32))|0)!=0; //@line 1052 "numbers.cpp"
          if ($tobool68) { __label__ = 26;; } else { __label__ = 25;; } //@line 1052 "numbers.cpp"
          if (__label__ == 26) {
  
            var $_pr5=$found; //@line 1059 "numbers.cpp"
            __lastLabel__ = 26; ;
          }
          else if (__label__ == 25) {
  
            var $arraydecay70=(($string)&4294967295); //@line 1055 "numbers.cpp"
            var $33=$value_addr; //@line 1055 "numbers.cpp"
            var $call71=__ZL9M_Varianti($33); //@line 1055 "numbers.cpp"
            var $34=$thousandplex_addr; //@line 1055 "numbers.cpp"
            var $call72=_sprintf($arraydecay70, ((__str49346)&4294967295), allocate([$call71,0,0,0,$34,0,0,0], ["i8*",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 1055 "numbers.cpp"
            var $35=$tr_addr; //@line 1056 "numbers.cpp"
            var $arraydecay73=(($string)&4294967295); //@line 1056 "numbers.cpp"
            var $arraydecay74=(($ph_thousands)&4294967295); //@line 1056 "numbers.cpp"
            var $call75=__Z6LookupP10TranslatorPKcPc($35, $arraydecay73, $arraydecay74); //@line 1056 "numbers.cpp"
            $found=$call75; //@line 1056 "numbers.cpp"
            __lastLabel__ = 25; ; //@line 1057 "numbers.cpp"
          }
  
          var $36=__lastLabel__ == 26 ? $_pr5 : ($call75); //@line 1059 "numbers.cpp"
          var $cmp78=((($36))|0)==0; //@line 1059 "numbers.cpp"
          if (!($cmp78)) { __label__ = 36;break $if_then38$$if_end118$21; } //@line 1059 "numbers.cpp"
        }
  
        var $arraydecay80=(($string)&4294967295); //@line 1061 "numbers.cpp"
        var $37=$value_addr; //@line 1061 "numbers.cpp"
        var $call81=__ZL9M_Varianti($37); //@line 1061 "numbers.cpp"
        var $38=$thousandplex_addr; //@line 1061 "numbers.cpp"
        var $call82=_sprintf($arraydecay80, ((__str50347)&4294967295), allocate([$call81,0,0,0,$38,0,0,0], ["i8*",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 1061 "numbers.cpp"
        var $39=$tr_addr; //@line 1063 "numbers.cpp"
        var $arraydecay83=(($string)&4294967295); //@line 1063 "numbers.cpp"
        var $arraydecay84=(($ph_thousands)&4294967295); //@line 1063 "numbers.cpp"
        var $call85=__Z6LookupP10TranslatorPKcPc($39, $arraydecay83, $arraydecay84); //@line 1063 "numbers.cpp"
        var $cmp86=((($call85))|0)==0; //@line 1063 "numbers.cpp"
        if (!($cmp86)) { __label__ = 36;break $if_then38$$if_end118$21; } //@line 1063 "numbers.cpp"
  
        var $40=$thousandplex_addr; //@line 1065 "numbers.cpp"
        var $cmp88=((($40))|0) > 3; //@line 1065 "numbers.cpp"
        if ($cmp88) { __label__ = 30;; } else { __label__ = 32;; } //@line 1065 "numbers.cpp"
        $if_then89$$if_end100$44: do { 
          if (__label__ == 30) {
  
            var $arraydecay90=(($string)&4294967295); //@line 1067 "numbers.cpp"
            var $41=$thousandplex_addr; //@line 1067 "numbers.cpp"
            var $sub=((($41)-1)&4294967295); //@line 1067 "numbers.cpp"
            var $call91=_sprintf($arraydecay90, ((__str18315)&4294967295), allocate([$sub,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 1067 "numbers.cpp"
            var $42=$tr_addr; //@line 1068 "numbers.cpp"
            var $arraydecay92=(($string)&4294967295); //@line 1068 "numbers.cpp"
            var $arraydecay93=(($ph_buf)&4294967295); //@line 1068 "numbers.cpp"
            var $call94=__Z6LookupP10TranslatorPKcPc($42, $arraydecay92, $arraydecay93); //@line 1068 "numbers.cpp"
            var $cmp95=((($call94))|0)==0; //@line 1068 "numbers.cpp"
            if (!($cmp95)) { __label__ = 32;break $if_then89$$if_end100$44; } //@line 1068 "numbers.cpp"
  
            var $43=$tr_addr; //@line 1071 "numbers.cpp"
            var $arraydecay97=(($ph_thousands)&4294967295); //@line 1071 "numbers.cpp"
            var $call98=__Z6LookupP10TranslatorPKcPc($43, ((__str51348)&4294967295), $arraydecay97); //@line 1071 "numbers.cpp"
            HEAP32[((__ZL23speak_missing_thousands)>>2)]=3; //@line 1072 "numbers.cpp"
            ; //@line 1073 "numbers.cpp"
          }
        } while(0);
  
        var $arrayidx101=(($ph_thousands)&4294967295); //@line 1075 "numbers.cpp"
        var $44=HEAP8[($arrayidx101)]; //@line 1075 "numbers.cpp"
        var $conv102=(tempInt=(($44)),(tempInt>=128?tempInt-256:tempInt)); //@line 1075 "numbers.cpp"
        var $cmp103=((($conv102))|0)==0; //@line 1075 "numbers.cpp"
        if (!($cmp103)) { __label__ = 36;break $if_then38$$if_end118$21; } //@line 1075 "numbers.cpp"
  
        var $arraydecay105=(($string)&4294967295); //@line 1078 "numbers.cpp"
        var $45=$value_addr; //@line 1078 "numbers.cpp"
        var $call106=_sprintf($arraydecay105, ((__str52349)&4294967295), allocate([$45,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 1078 "numbers.cpp"
        var $46=$tr_addr; //@line 1079 "numbers.cpp"
        var $arraydecay107=(($string)&4294967295); //@line 1079 "numbers.cpp"
        var $arraydecay108=(($ph_thousands)&4294967295); //@line 1079 "numbers.cpp"
        var $call109=__Z6LookupP10TranslatorPKcPc($46, $arraydecay107, $arraydecay108); //@line 1079 "numbers.cpp"
        $found_value=$call109; //@line 1079 "numbers.cpp"
        var $cmp110=((($call109))|0)==0; //@line 1079 "numbers.cpp"
        if ($cmp110) { __label__ = 34;; } else { __label__ = 35;; } //@line 1079 "numbers.cpp"
        if (__label__ == 34) {
  
          var $47=$tr_addr; //@line 1080 "numbers.cpp"
          var $arraydecay112=(($ph_thousands)&4294967295); //@line 1080 "numbers.cpp"
          var $call113=__Z6LookupP10TranslatorPKcPc($47, ((__str53350)&4294967295), $arraydecay112); //@line 1080 "numbers.cpp"
          ; //@line 1080 "numbers.cpp"
        }
  
        HEAP32[((__ZL23speak_missing_thousands)>>2)]=2; //@line 1081 "numbers.cpp"
        ; //@line 1082 "numbers.cpp"
      }
    } while(0);
  
    var $48=$ph_out_addr; //@line 1086 "numbers.cpp"
    var $arraydecay119=(($ph_of)&4294967295); //@line 1086 "numbers.cpp"
    var $arraydecay120=(($ph_thousands)&4294967295); //@line 1086 "numbers.cpp"
    var $call121=_sprintf($48, ((__str47699)&4294967295), allocate([$arraydecay119,0,0,0,$arraydecay120,0,0,0], ["i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 1086 "numbers.cpp"
    var $49=$value_addr; //@line 1088 "numbers.cpp"
    var $cmp122=((($49))|0)==1; //@line 1088 "numbers.cpp"
    if ($cmp122) { __label__ = 37;; } else { __label__ = 40;; } //@line 1088 "numbers.cpp"
    $land_lhs_true123$$if_end129$53: do { 
      if (__label__ == 37) {
  
        var $50=$thousandplex_addr; //@line 1088 "numbers.cpp"
        var $cmp124=((($50))|0)==1; //@line 1088 "numbers.cpp"
        if (!($cmp124)) { __label__ = 40;break $land_lhs_true123$$if_end129$53; } //@line 1088 "numbers.cpp"
  
        var $51=$tr_addr; //@line 1088 "numbers.cpp"
        var $langopts=(($51)&4294967295); //@line 1088 "numbers.cpp"
        var $numbers=(($langopts+184)&4294967295); //@line 1088 "numbers.cpp"
        var $52=HEAP32[(($numbers)>>2)]; //@line 1088 "numbers.cpp"
        var $and126=($52) & 2097152; //@line 1088 "numbers.cpp"
        var $tobool127=((($and126))|0)!=0; //@line 1088 "numbers.cpp"
        if (!($tobool127)) { __label__ = 40;break $land_lhs_true123$$if_end129$53; } //@line 1088 "numbers.cpp"
  
        $retval=1; //@line 1089 "numbers.cpp"
        __label__ = 41;break $land_lhs_true123$$if_end129$53; //@line 1089 "numbers.cpp"
      }
    } while(0);
    if (__label__ == 40) {
  
      var $53=$found_value; //@line 1091 "numbers.cpp"
      $retval=$53; //@line 1091 "numbers.cpp"
      ; //@line 1091 "numbers.cpp"
    }
  
    var $54=$retval; //@line 1092 "numbers.cpp"
    STACKTOP = __stackBase__;
    return $54; //@line 1092 "numbers.cpp"
    return null;
  }
  

  function __ZL10LookupNum3P10TranslatoriPciii($tr, $value, $ph_out, $suppress_null, $thousandplex, $control) {
    var __stackBase__  = STACKTOP; STACKTOP += 380; _memset(__stackBase__, 0, 380);
    var __label__;
    var __lastLabel__ = null;
  
    var $tr_addr;
    var $value_addr;
    var $ph_out_addr;
    var $suppress_null_addr;
    var $thousandplex_addr;
    var $control_addr;
    var $found;
    var $hundreds;
    var $tensunits;
    var $x;
    var $ix;
    var $exact;
    var $ordinal;
    var $say_zero_hundred;
    var $string=__stackBase__;
    var $buf1=__stackBase__+12;
    var $buf2=__stackBase__+112;
    var $ph_100=__stackBase__+212;
    var $ph_10T=__stackBase__+232;
    var $ph_digits=__stackBase__+252;
    var $ph_thousands=__stackBase__+304;
    var $ph_hundred_and=__stackBase__+356;
    var $ph_thousand_and=__stackBase__+368;
    $tr_addr=$tr;
    $value_addr=$value;
    $ph_out_addr=$ph_out;
    $suppress_null_addr=$suppress_null;
    $thousandplex_addr=$thousandplex;
    $control_addr=$control;
    $say_zero_hundred=0; //@line 1364 "numbers.cpp"
    var $0=$control_addr; //@line 1375 "numbers.cpp"
    var $and=($0) & 34; //@line 1375 "numbers.cpp"
    $ordinal=$and; //@line 1375 "numbers.cpp"
    var $1=$value_addr; //@line 1376 "numbers.cpp"
    var $div=((((($1))|0)/100)|0); //@line 1376 "numbers.cpp"
    $hundreds=$div; //@line 1376 "numbers.cpp"
    var $2=$value_addr; //@line 1377 "numbers.cpp"
    var $rem=((($2))|0)%100; //@line 1377 "numbers.cpp"
    $tensunits=$rem; //@line 1377 "numbers.cpp"
    var $arrayidx=(($buf1)&4294967295); //@line 1378 "numbers.cpp"
    HEAP8[($arrayidx)]=0; //@line 1378 "numbers.cpp"
    var $arrayidx1=(($ph_thousands)&4294967295); //@line 1380 "numbers.cpp"
    HEAP8[($arrayidx1)]=0; //@line 1380 "numbers.cpp"
    var $arrayidx2=(($ph_thousand_and)&4294967295); //@line 1381 "numbers.cpp"
    HEAP8[($arrayidx2)]=0; //@line 1381 "numbers.cpp"
    var $3=$tr_addr; //@line 1383 "numbers.cpp"
    var $langopts=(($3)&4294967295); //@line 1383 "numbers.cpp"
    var $numbers=(($langopts+184)&4294967295); //@line 1383 "numbers.cpp"
    var $4=HEAP32[(($numbers)>>2)]; //@line 1383 "numbers.cpp"
    var $and3=($4) & 4194304; //@line 1383 "numbers.cpp"
    var $tobool=((($and3))|0)!=0; //@line 1383 "numbers.cpp"
    if ($tobool) { __label__ = 1;; } else { __label__ = 4;; } //@line 1383 "numbers.cpp"
    $land_lhs_true$$if_endthread_pre_split$2: do { 
      if (__label__ == 1) {
  
        var $5=$control_addr; //@line 1383 "numbers.cpp"
        var $and4=($5) & 1; //@line 1383 "numbers.cpp"
        var $tobool5=((($and4))|0)!=0; //@line 1383 "numbers.cpp"
        if ($tobool5) { __label__ = 3;; } else { __label__ = 2;; } //@line 1383 "numbers.cpp"
        if (__label__ == 2) {
  
          var $6=$hundreds; //@line 1383 "numbers.cpp"
          var $cmp=((($6))|0) >= 10; //@line 1383 "numbers.cpp"
          if ($cmp) { __lastLabel__ = 2; ; } else { __lastLabel__ = 2; __label__ = 5;break $land_lhs_true$$if_endthread_pre_split$2; } //@line 1383 "numbers.cpp"
        }
  
        $say_zero_hundred=1; //@line 1385 "numbers.cpp"
        __label__ = 4;break $land_lhs_true$$if_endthread_pre_split$2; //@line 1386 "numbers.cpp"
      }
    } while(0);
    if (__label__ == 4) {
  
      var $_pr=$hundreds; //@line 1388 "numbers.cpp"
      __lastLabel__ = 4; ;
    }
  
    var $7=__lastLabel__ == 4 ? $_pr : ($6); //@line 1388 "numbers.cpp"
    var $cmp6=((($7))|0) > 0; //@line 1388 "numbers.cpp"
    if ($cmp6) { __label__ = 7;; } else { __label__ = 6;; } //@line 1388 "numbers.cpp"
    $if_then9$$lor_lhs_false7$10: do { 
      if (__label__ == 6) {
  
        var $8=$say_zero_hundred; //@line 1388 "numbers.cpp"
        var $tobool8=((($8))|0)!=0; //@line 1388 "numbers.cpp"
        if ($tobool8) { __label__ = 7;break $if_then9$$lor_lhs_false7$10; } else { __label__ = 61;break $if_then9$$lor_lhs_false7$10; } //@line 1388 "numbers.cpp"
      }
    } while(0);
    if (__label__ == 7) {
  
      $found=0; //@line 1390 "numbers.cpp"
      var $9=$ordinal; //@line 1391 "numbers.cpp"
      var $tobool10=((($9))|0)!=0; //@line 1391 "numbers.cpp"
      if ($tobool10) { __label__ = 8;; } else { __label__ = 12;; } //@line 1391 "numbers.cpp"
      $land_lhs_true11$$if_then16$14: do { 
        if (__label__ == 8) {
  
          var $10=$tensunits; //@line 1391 "numbers.cpp"
          var $cmp12=((($10))|0)==0; //@line 1391 "numbers.cpp"
          if ($cmp12) { __label__ = 9;; } else { __label__ = 10;; } //@line 1391 "numbers.cpp"
          if (__label__ == 9) {
  
            var $11=$tr_addr; //@line 1394 "numbers.cpp"
            var $arraydecay=(($ph_100)&4294967295); //@line 1394 "numbers.cpp"
            var $call=__Z6LookupP10TranslatorPKcPc($11, ((__str35332)&4294967295), $arraydecay); //@line 1394 "numbers.cpp"
            $found=$call; //@line 1394 "numbers.cpp"
            __lastLabel__ = 9; ; //@line 1395 "numbers.cpp"
          }
          else if (__label__ == 10) {
  
            var $_pr1=$found; //@line 1396 "numbers.cpp"
            __lastLabel__ = 10; ;
          }
  
          var $12=__lastLabel__ == 10 ? $_pr1 : ($call); //@line 1396 "numbers.cpp"
          var $cmp15=((($12))|0)==0; //@line 1396 "numbers.cpp"
          if ($cmp15) { __label__ = 12;break $land_lhs_true11$$if_then16$14; } else { __label__ = 17;break $land_lhs_true11$$if_then16$14; } //@line 1396 "numbers.cpp"
        }
      } while(0);
      $if_then16$$if_end27$20: do { 
        if (__label__ == 12) {
  
          var $13=$tensunits; //@line 1398 "numbers.cpp"
          var $cmp17=((($13))|0)==0; //@line 1398 "numbers.cpp"
          if ($cmp17) { __label__ = 13;; } else { __label__ = 14;; } //@line 1398 "numbers.cpp"
          if (__label__ == 13) {
  
            var $14=$tr_addr; //@line 1401 "numbers.cpp"
            var $arraydecay19=(($ph_100)&4294967295); //@line 1401 "numbers.cpp"
            var $call20=__Z6LookupP10TranslatorPKcPc($14, ((__str36333)&4294967295), $arraydecay19); //@line 1401 "numbers.cpp"
            $found=$call20; //@line 1401 "numbers.cpp"
            __lastLabel__ = 13; ; //@line 1402 "numbers.cpp"
          }
          else if (__label__ == 14) {
  
            var $_pr3=$found; //@line 1403 "numbers.cpp"
            __lastLabel__ = 14; ;
          }
  
          var $15=__lastLabel__ == 14 ? $_pr3 : ($call20); //@line 1403 "numbers.cpp"
          var $tobool22=((($15))|0)!=0; //@line 1403 "numbers.cpp"
          if ($tobool22) { __label__ = 17;break $if_then16$$if_end27$20; } //@line 1403 "numbers.cpp"
  
          var $16=$tr_addr; //@line 1405 "numbers.cpp"
          var $arraydecay24=(($ph_100)&4294967295); //@line 1405 "numbers.cpp"
          var $call25=__Z6LookupP10TranslatorPKcPc($16, ((__str37334)&4294967295), $arraydecay24); //@line 1405 "numbers.cpp"
          ; //@line 1406 "numbers.cpp"
        }
      } while(0);
  
      var $17=$tr_addr; //@line 1409 "numbers.cpp"
      var $langopts28=(($17)&4294967295); //@line 1409 "numbers.cpp"
      var $numbers29=(($langopts28+184)&4294967295); //@line 1409 "numbers.cpp"
      var $18=HEAP32[(($numbers29)>>2)]; //@line 1409 "numbers.cpp"
      var $and30=($18) & 2048; //@line 1409 "numbers.cpp"
      var $cmp31=((($and30))|0)!=0; //@line 1409 "numbers.cpp"
      var $19=$hundreds; //@line 1409 "numbers.cpp"
      if ($cmp31) { __label__ = 18;; } else { __label__ = 19;; } //@line 1409 "numbers.cpp"
      $land_lhs_true32$$if_else$28: do { 
        if (__label__ == 18) {
  
          var $cmp33=((($19))|0)!=19; //@line 1409 "numbers.cpp"
          var $20=$hundreds; //@line 1415 "numbers.cpp"
          var $cmp35=((($20))|0) >= 10; //@line 1415 "numbers.cpp"
          var $or_cond=($cmp33) & ($cmp35); //@line 1409 "numbers.cpp"
          if ($or_cond) { __label__ = 20;break $land_lhs_true32$$if_else$28; } else { __label__ = 33;break $land_lhs_true32$$if_else$28; } //@line 1409 "numbers.cpp"
        }
        else if (__label__ == 19) {
  
          var $cmp35_old=((($19))|0) >= 10; //@line 1415 "numbers.cpp"
          if ($cmp35_old) { __label__ = 20;break $land_lhs_true32$$if_else$28; } else { __label__ = 33;break $land_lhs_true32$$if_else$28; } //@line 1415 "numbers.cpp"
        }
      } while(0);
      if (__label__ == 20) {
  
        var $arrayidx37=(($ph_digits)&4294967295); //@line 1417 "numbers.cpp"
        HEAP8[($arrayidx37)]=0; //@line 1417 "numbers.cpp"
        $exact=0; //@line 1419 "numbers.cpp"
        var $21=$value_addr; //@line 1420 "numbers.cpp"
        var $rem38=((($21))|0)%1000; //@line 1420 "numbers.cpp"
        var $cmp39=((($rem38))|0)==0; //@line 1420 "numbers.cpp"
        if ($cmp39) { __label__ = 21;; } else { __label__ = 22;; } //@line 1420 "numbers.cpp"
        if (__label__ == 21) {
  
          $exact=1; //@line 1421 "numbers.cpp"
          ; //@line 1421 "numbers.cpp"
        }
  
        var $22=$tr_addr; //@line 1423 "numbers.cpp"
        var $23=$hundreds; //@line 1423 "numbers.cpp"
        var $div42=((((($23))|0)/10)|0); //@line 1423 "numbers.cpp"
        var $24=$thousandplex_addr; //@line 1423 "numbers.cpp"
        var $add=((($24)+1)&4294967295); //@line 1423 "numbers.cpp"
        var $25=$exact; //@line 1423 "numbers.cpp"
        var $26=$ordinal; //@line 1423 "numbers.cpp"
        var $or=($26) | ($25); //@line 1423 "numbers.cpp"
        var $arraydecay43=(($ph_10T)&4294967295); //@line 1423 "numbers.cpp"
        var $call44=__ZL15LookupThousandsP10TranslatoriiiPc($22, $div42, $add, $or, $arraydecay43); //@line 1423 "numbers.cpp"
        var $cmp45=((($call44))|0)==0; //@line 1423 "numbers.cpp"
        if ($cmp45) { __label__ = 23;; } else { __label__ = 26;; } //@line 1423 "numbers.cpp"
        if (__label__ == 23) {
  
          $x=0; //@line 1425 "numbers.cpp"
          var $27=$tr_addr; //@line 1426 "numbers.cpp"
          var $langopts47=(($27)&4294967295); //@line 1426 "numbers.cpp"
          var $numbers2=(($langopts47+188)&4294967295); //@line 1426 "numbers.cpp"
          var $28=HEAP32[(($numbers2)>>2)]; //@line 1426 "numbers.cpp"
          var $29=$thousandplex_addr; //@line 1426 "numbers.cpp"
          var $add48=((($29)+1)&4294967295); //@line 1426 "numbers.cpp"
          var $shl=1 << ($add48); //@line 1426 "numbers.cpp"
          var $and49=($shl) & ($28); //@line 1426 "numbers.cpp"
          var $tobool50=((($and49))|0)!=0; //@line 1426 "numbers.cpp"
          if ($tobool50) { __label__ = 24;; } else { __label__ = 25;; } //@line 1426 "numbers.cpp"
          if (__label__ == 24) {
  
            $x=8; //@line 1427 "numbers.cpp"
            ; //@line 1427 "numbers.cpp"
          }
  
          var $30=$tr_addr; //@line 1428 "numbers.cpp"
          var $31=$hundreds; //@line 1428 "numbers.cpp"
          var $div53=((((($31))|0)/10)|0); //@line 1428 "numbers.cpp"
          var $32=$x; //@line 1428 "numbers.cpp"
          var $arraydecay54=(($ph_digits)&4294967295); //@line 1428 "numbers.cpp"
          var $call55=__ZL10LookupNum2P10TranslatoriiPc($30, $div53, $32, $arraydecay54); //@line 1428 "numbers.cpp"
          ; //@line 1429 "numbers.cpp"
        }
  
        var $33=$tr_addr; //@line 1431 "numbers.cpp"
        var $langopts57=(($33)&4294967295); //@line 1431 "numbers.cpp"
        var $numbers258=(($langopts57+188)&4294967295); //@line 1431 "numbers.cpp"
        var $34=HEAP32[(($numbers258)>>2)]; //@line 1431 "numbers.cpp"
        var $and59=($34) & 512; //@line 1431 "numbers.cpp"
        var $tobool60=((($and59))|0)!=0; //@line 1431 "numbers.cpp"
        var $arraydecay62=(($ph_thousands)&4294967295); //@line 1432 "numbers.cpp"
        if ($tobool60) { __label__ = 27;; } else { __label__ = 28;; } //@line 1431 "numbers.cpp"
        if (__label__ == 27) {
  
          var $arraydecay63=(($ph_10T)&4294967295); //@line 1432 "numbers.cpp"
          var $arraydecay64=(($ph_digits)&4294967295); //@line 1432 "numbers.cpp"
          var $call65=_sprintf($arraydecay62, ((__str47699)&4294967295), allocate([$arraydecay63,0,0,0,$arraydecay64,0,0,0], ["i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 1432 "numbers.cpp"
          ; //@line 1432 "numbers.cpp"
        }
        else if (__label__ == 28) {
  
          var $arraydecay68=(($ph_digits)&4294967295); //@line 1434 "numbers.cpp"
          var $arraydecay69=(($ph_10T)&4294967295); //@line 1434 "numbers.cpp"
          var $call70=_sprintf($arraydecay62, ((__str47699)&4294967295), allocate([$arraydecay68,0,0,0,$arraydecay69,0,0,0], ["i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 1434 "numbers.cpp"
          ;
        }
  
        var $35=$hundreds; //@line 1436 "numbers.cpp"
        var $rem72=((($35))|0)%10; //@line 1436 "numbers.cpp"
        $hundreds=$rem72; //@line 1436 "numbers.cpp"
        var $cmp73=((($rem72))|0)==0; //@line 1437 "numbers.cpp"
        if ($cmp73) { __label__ = 30;; } else { __label__ = 32;; } //@line 1437 "numbers.cpp"
        $land_lhs_true74$$if_end78$46: do { 
          if (__label__ == 30) {
  
            var $36=$say_zero_hundred; //@line 1437 "numbers.cpp"
            var $cmp75=((($36))|0)==0; //@line 1437 "numbers.cpp"
            if (!($cmp75)) { __label__ = 32;break $land_lhs_true74$$if_end78$46; } //@line 1437 "numbers.cpp"
  
            var $arrayidx77=(($ph_100)&4294967295); //@line 1438 "numbers.cpp"
            HEAP8[($arrayidx77)]=0; //@line 1438 "numbers.cpp"
            ; //@line 1438 "numbers.cpp"
          }
        } while(0);
  
        $suppress_null_addr=1; //@line 1439 "numbers.cpp"
        ; //@line 1440 "numbers.cpp"
      }
  
      var $arrayidx81=(($ph_digits)&4294967295); //@line 1442 "numbers.cpp"
      HEAP8[($arrayidx81)]=0; //@line 1442 "numbers.cpp"
      var $37=$hundreds; //@line 1444 "numbers.cpp"
      var $cmp82=((($37))|0) > 0; //@line 1444 "numbers.cpp"
      if ($cmp82) { __label__ = 35;; } else { __label__ = 34;; } //@line 1444 "numbers.cpp"
      $if_then85$$lor_lhs_false83$51: do { 
        if (__label__ == 34) {
  
          var $38=$say_zero_hundred; //@line 1444 "numbers.cpp"
          var $tobool84=((($38))|0)!=0; //@line 1444 "numbers.cpp"
          if ($tobool84) { __label__ = 35;break $if_then85$$lor_lhs_false83$51; } else { __label__ = 60;break $if_then85$$lor_lhs_false83$51; } //@line 1444 "numbers.cpp"
        }
      } while(0);
      $if_then85$$if_end166$53: do { 
        if (__label__ == 35) {
  
          var $39=$tr_addr; //@line 1446 "numbers.cpp"
          var $langopts86=(($39)&4294967295); //@line 1446 "numbers.cpp"
          var $numbers87=(($langopts86+184)&4294967295); //@line 1446 "numbers.cpp"
          var $40=HEAP32[(($numbers87)>>2)]; //@line 1446 "numbers.cpp"
          var $and88=($40) & 262144; //@line 1446 "numbers.cpp"
          var $tobool89=((($and88))|0)!=0; //@line 1446 "numbers.cpp"
          if ($tobool89) { __label__ = 36;; } else { __label__ = 39;; } //@line 1446 "numbers.cpp"
          $land_lhs_true90$$if_end99$55: do { 
            if (__label__ == 36) {
  
              var $41=$control_addr; //@line 1446 "numbers.cpp"
              var $and91=($41) & 1; //@line 1446 "numbers.cpp"
              var $tobool92=((($and91))|0)!=0; //@line 1446 "numbers.cpp"
              if ($tobool92) { __label__ = 38;; } else { __label__ = 37;; } //@line 1446 "numbers.cpp"
              if (__label__ == 37) {
  
                var $arrayidx94=(($ph_thousands)&4294967295); //@line 1446 "numbers.cpp"
                var $42=HEAP8[($arrayidx94)]; //@line 1446 "numbers.cpp"
                var $conv=(tempInt=(($42)),(tempInt>=128?tempInt-256:tempInt)); //@line 1446 "numbers.cpp"
                var $cmp95=((($conv))|0)!=0; //@line 1446 "numbers.cpp"
                if (!($cmp95)) { __label__ = 39;break $land_lhs_true90$$if_end99$55; } //@line 1446 "numbers.cpp"
              }
  
              var $43=$tr_addr; //@line 1448 "numbers.cpp"
              var $arraydecay97=(($ph_thousand_and)&4294967295); //@line 1448 "numbers.cpp"
              var $call98=__Z6LookupP10TranslatorPKcPc($43, ((__str33330)&4294967295), $arraydecay97); //@line 1448 "numbers.cpp"
              ; //@line 1449 "numbers.cpp"
            }
          } while(0);
  
          $suppress_null_addr=1; //@line 1451 "numbers.cpp"
          $found=0; //@line 1453 "numbers.cpp"
          var $44=$ordinal; //@line 1454 "numbers.cpp"
          var $tobool100=((($44))|0)!=0; //@line 1454 "numbers.cpp"
          if ($tobool100) { __label__ = 40;; } else { __label__ = 45;; } //@line 1454 "numbers.cpp"
          $land_lhs_true101$$if_end124$61: do { 
            if (__label__ == 40) {
  
              var $45=$tensunits; //@line 1454 "numbers.cpp"
              var $cmp102=((($45))|0)==0; //@line 1454 "numbers.cpp"
              if ($cmp102) { __label__ = 42;; } else { __label__ = 41;; } //@line 1454 "numbers.cpp"
              if (__label__ == 41) {
  
                var $46=$tr_addr; //@line 1454 "numbers.cpp"
                var $langopts104=(($46)&4294967295); //@line 1454 "numbers.cpp"
                var $numbers2105=(($langopts104+188)&4294967295); //@line 1454 "numbers.cpp"
                var $47=HEAP32[(($numbers2105)>>2)]; //@line 1454 "numbers.cpp"
                var $and106=($47) & 4096; //@line 1454 "numbers.cpp"
                var $tobool107=((($and106))|0)!=0; //@line 1454 "numbers.cpp"
                if (!($tobool107)) { __label__ = 45;break $land_lhs_true101$$if_end124$61; } //@line 1454 "numbers.cpp"
              }
  
              var $arraydecay109=(($string)&4294967295); //@line 1458 "numbers.cpp"
              var $48=$hundreds; //@line 1458 "numbers.cpp"
              var $call110=_sprintf($arraydecay109, ((__str39336)&4294967295), allocate([$48,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 1458 "numbers.cpp"
              var $49=$tr_addr; //@line 1459 "numbers.cpp"
              var $arraydecay111=(($string)&4294967295); //@line 1459 "numbers.cpp"
              var $arraydecay112=(($ph_digits)&4294967295); //@line 1459 "numbers.cpp"
              var $call113=__Z6LookupP10TranslatorPKcPc($49, $arraydecay111, $arraydecay112); //@line 1459 "numbers.cpp"
              $found=$call113; //@line 1459 "numbers.cpp"
              var $50=$tr_addr; //@line 1461 "numbers.cpp"
              var $langopts114=(($50)&4294967295); //@line 1461 "numbers.cpp"
              var $numbers2115=(($langopts114+188)&4294967295); //@line 1461 "numbers.cpp"
              var $51=HEAP32[(($numbers2115)>>2)]; //@line 1461 "numbers.cpp"
              var $and116=($51) & 4096; //@line 1461 "numbers.cpp"
              var $tobool117=((($and116))|0)!=0; //@line 1461 "numbers.cpp"
              if (!($tobool117)) { __label__ = 45;break $land_lhs_true101$$if_end124$61; } //@line 1461 "numbers.cpp"
  
              var $52=$tensunits; //@line 1461 "numbers.cpp"
              var $cmp119=((($52))|0) > 0; //@line 1461 "numbers.cpp"
              if (!($cmp119)) { __label__ = 45;break $land_lhs_true101$$if_end124$61; } //@line 1461 "numbers.cpp"
  
              var $arraydecay121=(($ph_digits)&4294967295); //@line 1465 "numbers.cpp"
              var $call122=_strcat($arraydecay121, ((__ZL11ph_ordinal2)&4294967295)); //@line 1465 "numbers.cpp"
              ; //@line 1466 "numbers.cpp"
            }
          } while(0);
  
          var $53=$hundreds; //@line 1469 "numbers.cpp"
          var $cmp125=((($53))|0)==0; //@line 1469 "numbers.cpp"
          if ($cmp125) { __label__ = 46;; } else { __label__ = 48;; } //@line 1469 "numbers.cpp"
          $land_lhs_true126$$if_else131$69: do { 
            if (__label__ == 46) {
  
              var $54=$say_zero_hundred; //@line 1469 "numbers.cpp"
              var $tobool127=((($54))|0)!=0; //@line 1469 "numbers.cpp"
              if (!($tobool127)) { __label__ = 48;break $land_lhs_true126$$if_else131$69; } //@line 1469 "numbers.cpp"
  
              var $55=$tr_addr; //@line 1471 "numbers.cpp"
              var $arraydecay129=(($ph_digits)&4294967295); //@line 1471 "numbers.cpp"
              var $call130=__Z6LookupP10TranslatorPKcPc($55, ((__str16313)&4294967295), $arraydecay129); //@line 1471 "numbers.cpp"
              __label__ = 60;break $if_then85$$if_end166$53; //@line 1472 "numbers.cpp"
            }
          } while(0);
  
          var $56=$found; //@line 1475 "numbers.cpp"
          var $tobool132=((($56))|0)!=0; //@line 1475 "numbers.cpp"
          if ($tobool132) { __label__ = 54;; } else { __label__ = 49;; } //@line 1475 "numbers.cpp"
          $if_end149thread_pre_split$$land_lhs_true133$73: do { 
            if (__label__ == 49) {
  
              var $57=$tensunits; //@line 1475 "numbers.cpp"
              var $cmp134=((($57))|0)==0; //@line 1475 "numbers.cpp"
              if ($cmp134) { __label__ = 50;; } else { __label__ = 51;; } //@line 1475 "numbers.cpp"
              if (__label__ == 50) {
  
                var $arraydecay136=(($string)&4294967295); //@line 1478 "numbers.cpp"
                var $58=$hundreds; //@line 1478 "numbers.cpp"
                var $call137=_sprintf($arraydecay136, ((__str40337)&4294967295), allocate([$58,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 1478 "numbers.cpp"
                var $59=$tr_addr; //@line 1479 "numbers.cpp"
                var $arraydecay138=(($string)&4294967295); //@line 1479 "numbers.cpp"
                var $arraydecay139=(($ph_digits)&4294967295); //@line 1479 "numbers.cpp"
                var $call140=__Z6LookupP10TranslatorPKcPc($59, $arraydecay138, $arraydecay139); //@line 1479 "numbers.cpp"
                $found=$call140; //@line 1479 "numbers.cpp"
                __lastLabel__ = 50; ; //@line 1480 "numbers.cpp"
              }
              else if (__label__ == 51) {
  
                var $_pr4=$found; //@line 1482 "numbers.cpp"
                __lastLabel__ = 51; ;
              }
  
              var $60=__lastLabel__ == 51 ? $_pr4 : ($call140); //@line 1482 "numbers.cpp"
              var $tobool142=((($60))|0)!=0; //@line 1482 "numbers.cpp"
              if ($tobool142) { __label__ = 54;break $if_end149thread_pre_split$$land_lhs_true133$73; } //@line 1482 "numbers.cpp"
  
              var $arraydecay144=(($string)&4294967295); //@line 1484 "numbers.cpp"
              var $61=$hundreds; //@line 1484 "numbers.cpp"
              var $call145=_sprintf($arraydecay144, ((__str41338)&4294967295), allocate([$61,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 1484 "numbers.cpp"
              var $62=$tr_addr; //@line 1485 "numbers.cpp"
              var $arraydecay146=(($string)&4294967295); //@line 1485 "numbers.cpp"
              var $arraydecay147=(($ph_digits)&4294967295); //@line 1485 "numbers.cpp"
              var $call148=__Z6LookupP10TranslatorPKcPc($62, $arraydecay146, $arraydecay147); //@line 1485 "numbers.cpp"
              $found=$call148; //@line 1485 "numbers.cpp"
              __lastLabel__ = 53; __label__ = 55;break $if_end149thread_pre_split$$land_lhs_true133$73; //@line 1486 "numbers.cpp"
            }
          } while(0);
          if (__label__ == 54) {
  
            var $_pr6=$found; //@line 1488 "numbers.cpp"
            __lastLabel__ = 54; ;
          }
  
          var $63=__lastLabel__ == 54 ? $_pr6 : ($call148); //@line 1488 "numbers.cpp"
          var $tobool150=((($63))|0)!=0; //@line 1488 "numbers.cpp"
          if ($tobool150) { __label__ = 56;; } else { __label__ = 57;; } //@line 1488 "numbers.cpp"
          if (__label__ == 56) {
  
            var $arrayidx152=(($ph_100)&4294967295); //@line 1490 "numbers.cpp"
            HEAP8[($arrayidx152)]=0; //@line 1490 "numbers.cpp"
            ; //@line 1491 "numbers.cpp"
          }
          else if (__label__ == 57) {
  
            var $64=$hundreds; //@line 1494 "numbers.cpp"
            var $cmp154=((($64))|0) > 1; //@line 1494 "numbers.cpp"
            if ($cmp154) { __label__ = 59;; } else { __label__ = 58;; } //@line 1494 "numbers.cpp"
            if (__label__ == 58) {
  
              var $65=$tr_addr; //@line 1494 "numbers.cpp"
              var $langopts156=(($65)&4294967295); //@line 1494 "numbers.cpp"
              var $numbers157=(($langopts156+184)&4294967295); //@line 1494 "numbers.cpp"
              var $66=HEAP32[(($numbers157)>>2)]; //@line 1494 "numbers.cpp"
              var $and158=($66) & 1024; //@line 1494 "numbers.cpp"
              var $cmp159=((($and158))|0)==0; //@line 1494 "numbers.cpp"
              if (!($cmp159)) { __label__ = 60;break $if_then85$$if_end166$53; } //@line 1494 "numbers.cpp"
            }
  
            var $67=$tr_addr; //@line 1496 "numbers.cpp"
            var $68=$hundreds; //@line 1496 "numbers.cpp"
            var $arraydecay161=(($ph_digits)&4294967295); //@line 1496 "numbers.cpp"
            var $call162=__ZL10LookupNum2P10TranslatoriiPc($67, $68, 0, $arraydecay161); //@line 1496 "numbers.cpp"
            ; //@line 1497 "numbers.cpp"
          }
        }
      } while(0);
  
      var $arraydecay167=(($buf1)&4294967295); //@line 1502 "numbers.cpp"
      var $arraydecay168=(($ph_thousands)&4294967295); //@line 1502 "numbers.cpp"
      var $arraydecay169=(($ph_thousand_and)&4294967295); //@line 1502 "numbers.cpp"
      var $arraydecay170=(($ph_digits)&4294967295); //@line 1502 "numbers.cpp"
      var $arraydecay171=(($ph_100)&4294967295); //@line 1502 "numbers.cpp"
      var $call172=_sprintf($arraydecay167, ((__str20317)&4294967295), allocate([$arraydecay168,0,0,0,$arraydecay169,0,0,0,$arraydecay170,0,0,0,$arraydecay171,0,0,0], ["i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 1502 "numbers.cpp"
      ; //@line 1503 "numbers.cpp"
    }
  
    var $arrayidx174=(($ph_hundred_and)&4294967295); //@line 1505 "numbers.cpp"
    HEAP8[($arrayidx174)]=0; //@line 1505 "numbers.cpp"
    var $69=$tensunits; //@line 1506 "numbers.cpp"
    var $cmp175=((($69))|0) > 0; //@line 1506 "numbers.cpp"
    if ($cmp175) { __label__ = 62;; } else { __label__ = 74;; } //@line 1506 "numbers.cpp"
    $if_then176$$if_end217$91: do { 
      if (__label__ == 62) {
  
        var $70=$value_addr; //@line 1508 "numbers.cpp"
        var $cmp177=((($70))|0) > 100; //@line 1508 "numbers.cpp"
        if ($cmp177) { __label__ = 65;; } else { __label__ = 63;; } //@line 1508 "numbers.cpp"
        $if_then183$$lor_lhs_false178$93: do { 
          if (__label__ == 63) {
  
            var $71=$control_addr; //@line 1508 "numbers.cpp"
            var $and179=($71) & 1; //@line 1508 "numbers.cpp"
            var $tobool180=((($and179))|0)!=0; //@line 1508 "numbers.cpp"
            if (!($tobool180)) { __label__ = 69;break $if_then183$$lor_lhs_false178$93; } //@line 1508 "numbers.cpp"
  
            var $72=$thousandplex_addr; //@line 1508 "numbers.cpp"
            var $cmp182=((($72))|0)==0; //@line 1508 "numbers.cpp"
            if ($cmp182) { __label__ = 65;break $if_then183$$lor_lhs_false178$93; } else { __label__ = 69;break $if_then183$$lor_lhs_false178$93; } //@line 1508 "numbers.cpp"
          }
        } while(0);
        $if_then183$$if_end199$96: do { 
          if (__label__ == 65) {
  
            var $73=$tr_addr; //@line 1510 "numbers.cpp"
            var $langopts184=(($73)&4294967295); //@line 1510 "numbers.cpp"
            var $numbers185=(($langopts184+184)&4294967295); //@line 1510 "numbers.cpp"
            var $74=HEAP32[(($numbers185)>>2)]; //@line 1510 "numbers.cpp"
            var $and186=($74) & 64; //@line 1510 "numbers.cpp"
            var $tobool187=((($and186))|0)!=0; //@line 1510 "numbers.cpp"
            if ($tobool187) { __label__ = 68;; } else { __label__ = 66;; } //@line 1510 "numbers.cpp"
            if (__label__ == 66) {
  
              var $75=$tr_addr; //@line 1510 "numbers.cpp"
              var $langopts189=(($75)&4294967295); //@line 1510 "numbers.cpp"
              var $numbers190=(($langopts189+184)&4294967295); //@line 1510 "numbers.cpp"
              var $76=HEAP32[(($numbers190)>>2)]; //@line 1510 "numbers.cpp"
              var $and191=($76) & 8388608; //@line 1510 "numbers.cpp"
              var $tobool192=((($and191))|0)!=0; //@line 1510 "numbers.cpp"
              if (!($tobool192)) { __label__ = 69;break $if_then183$$if_end199$96; } //@line 1510 "numbers.cpp"
  
              var $77=$tensunits; //@line 1510 "numbers.cpp"
              var $cmp194=((($77))|0) < 10; //@line 1510 "numbers.cpp"
              if (!($cmp194)) { __label__ = 69;break $if_then183$$if_end199$96; } //@line 1510 "numbers.cpp"
            }
  
            var $78=$tr_addr; //@line 1512 "numbers.cpp"
            var $arraydecay196=(($ph_hundred_and)&4294967295); //@line 1512 "numbers.cpp"
            var $call197=__Z6LookupP10TranslatorPKcPc($78, ((__str33330)&4294967295), $arraydecay196); //@line 1512 "numbers.cpp"
            ; //@line 1513 "numbers.cpp"
          }
        } while(0);
  
        var $79=$tr_addr; //@line 1515 "numbers.cpp"
        var $langopts200=(($79)&4294967295); //@line 1515 "numbers.cpp"
        var $numbers201=(($langopts200+184)&4294967295); //@line 1515 "numbers.cpp"
        var $80=HEAP32[(($numbers201)>>2)]; //@line 1515 "numbers.cpp"
        var $and202=($80) & 524288; //@line 1515 "numbers.cpp"
        var $tobool203=((($and202))|0)!=0; //@line 1515 "numbers.cpp"
        if (!($tobool203)) { __label__ = 74;break $if_then176$$if_end217$91; } //@line 1515 "numbers.cpp"
  
        var $81=$hundreds; //@line 1515 "numbers.cpp"
        var $cmp205=((($81))|0)==0; //@line 1515 "numbers.cpp"
        if (!($cmp205)) { __label__ = 74;break $if_then176$$if_end217$91; } //@line 1515 "numbers.cpp"
  
        var $82=$control_addr; //@line 1515 "numbers.cpp"
        var $and207=($82) & 1; //@line 1515 "numbers.cpp"
        var $tobool208=((($and207))|0)!=0; //@line 1515 "numbers.cpp"
        if ($tobool208) { __label__ = 73;; } else { __label__ = 72;; } //@line 1515 "numbers.cpp"
        if (__label__ == 72) {
  
          var $arrayidx210=(($ph_thousands)&4294967295); //@line 1515 "numbers.cpp"
          var $83=HEAP8[($arrayidx210)]; //@line 1515 "numbers.cpp"
          var $conv211=(tempInt=(($83)),(tempInt>=128?tempInt-256:tempInt)); //@line 1515 "numbers.cpp"
          var $cmp212=((($conv211))|0)!=0; //@line 1515 "numbers.cpp"
          if (!($cmp212)) { __label__ = 74;break $if_then176$$if_end217$91; } //@line 1515 "numbers.cpp"
        }
  
        var $84=$tr_addr; //@line 1517 "numbers.cpp"
        var $arraydecay214=(($ph_hundred_and)&4294967295); //@line 1517 "numbers.cpp"
        var $call215=__Z6LookupP10TranslatorPKcPc($84, ((__str33330)&4294967295), $arraydecay214); //@line 1517 "numbers.cpp"
        ; //@line 1518 "numbers.cpp"
      }
    } while(0);
  
    var $arrayidx218=(($buf2)&4294967295); //@line 1522 "numbers.cpp"
    HEAP8[($arrayidx218)]=0; //@line 1522 "numbers.cpp"
    var $85=$tensunits; //@line 1524 "numbers.cpp"
    var $cmp219=((($85))|0)!=0; //@line 1524 "numbers.cpp"
    if ($cmp219) { __label__ = 76;; } else { __label__ = 75;; } //@line 1524 "numbers.cpp"
    $if_then222$$lor_lhs_false220$109: do { 
      if (__label__ == 75) {
  
        var $86=$suppress_null_addr; //@line 1524 "numbers.cpp"
        var $cmp221=((($86))|0)==0; //@line 1524 "numbers.cpp"
        if ($cmp221) { __label__ = 76;break $if_then222$$lor_lhs_false220$109; } //@line 1524 "numbers.cpp"
  
        var $102=HEAP8[(((__ZL11ph_ordinal2)&4294967295))]; //@line 1551 "numbers.cpp"
        var $conv262=(tempInt=(($102)),(tempInt>=128?tempInt-256:tempInt)); //@line 1551 "numbers.cpp"
        var $cmp263=((($conv262))|0)!=0; //@line 1551 "numbers.cpp"
        if (!($cmp263)) { __label__ = 94;break $if_then222$$lor_lhs_false220$109; } //@line 1551 "numbers.cpp"
  
        var $arraydecay265=(($buf1)&4294967295); //@line 1553 "numbers.cpp"
        var $call266=_strlen($arraydecay265); //@line 1553 "numbers.cpp"
        $ix=$call266; //@line 1553 "numbers.cpp"
        var $103=$ix; //@line 1554 "numbers.cpp"
        var $cmp267=((($103))|0) > 0; //@line 1554 "numbers.cpp"
        if ($cmp267) { __label__ = 91;; } else { __label__ = 93;; } //@line 1554 "numbers.cpp"
        $land_lhs_true268$$if_end275$113: do { 
          if (__label__ == 91) {
  
            var $104=$ix; //@line 1554 "numbers.cpp"
            var $sub=((($104)-1)&4294967295); //@line 1554 "numbers.cpp"
            var $arrayidx269=(($buf1+$sub)&4294967295); //@line 1554 "numbers.cpp"
            var $105=HEAP8[($arrayidx269)]; //@line 1554 "numbers.cpp"
            var $conv270=(tempInt=(($105)),(tempInt>=128?tempInt-256:tempInt)); //@line 1554 "numbers.cpp"
            var $cmp271=((($conv270))|0)==10; //@line 1554 "numbers.cpp"
            if (!($cmp271)) { __label__ = 93;break $land_lhs_true268$$if_end275$113; } //@line 1554 "numbers.cpp"
  
            var $106=$ix; //@line 1555 "numbers.cpp"
            var $sub273=((($106)-1)&4294967295); //@line 1555 "numbers.cpp"
            var $arrayidx274=(($buf1+$sub273)&4294967295); //@line 1555 "numbers.cpp"
            HEAP8[($arrayidx274)]=0; //@line 1555 "numbers.cpp"
            ; //@line 1555 "numbers.cpp"
          }
        } while(0);
  
        var $arraydecay276=(($buf2)&4294967295); //@line 1556 "numbers.cpp"
        var $call277=_strcpy($arraydecay276, ((__ZL11ph_ordinal2)&4294967295)); //@line 1556 "numbers.cpp"
        __label__ = 94;break $if_then222$$lor_lhs_false220$109; //@line 1557 "numbers.cpp"
      }
    } while(0);
    $if_then222$$if_end279$117: do { 
      if (__label__ == 76) {
  
        $x=0; //@line 1526 "numbers.cpp"
        var $87=$thousandplex_addr; //@line 1527 "numbers.cpp"
        var $cmp223=((($87))|0)==0; //@line 1527 "numbers.cpp"
        if ($cmp223) { __label__ = 77;; } else { __label__ = 84;; } //@line 1527 "numbers.cpp"
        $if_then224$$if_else240$119: do { 
          if (__label__ == 77) {
  
            $x=2; //@line 1529 "numbers.cpp"
            var $88=$ordinal; //@line 1530 "numbers.cpp"
            var $tobool225=((($88))|0)!=0; //@line 1530 "numbers.cpp"
            if ($tobool225) { __label__ = 78;; } else { __label__ = 79;; } //@line 1530 "numbers.cpp"
            if (__label__ == 78) {
  
              $x=3; //@line 1531 "numbers.cpp"
              ; //@line 1531 "numbers.cpp"
            }
  
            var $89=$value_addr; //@line 1532 "numbers.cpp"
            var $cmp228=((($89))|0) < 100; //@line 1532 "numbers.cpp"
            if ($cmp228) { __label__ = 80;; } else { __label__ = 82;; } //@line 1532 "numbers.cpp"
            $land_lhs_true229$$if_end234$124: do { 
              if (__label__ == 80) {
  
                var $90=$control_addr; //@line 1532 "numbers.cpp"
                var $and230=($90) & 1; //@line 1532 "numbers.cpp"
                var $tobool231=((($and230))|0)!=0; //@line 1532 "numbers.cpp"
                if ($tobool231) { __label__ = 82;break $land_lhs_true229$$if_end234$124; } //@line 1532 "numbers.cpp"
  
                var $91=$x; //@line 1533 "numbers.cpp"
                var $or233=($91) | 4; //@line 1533 "numbers.cpp"
                $x=$or233; //@line 1533 "numbers.cpp"
                ; //@line 1533 "numbers.cpp"
              }
            } while(0);
  
            var $92=$ordinal; //@line 1534 "numbers.cpp"
            var $and235=($92) & 32; //@line 1534 "numbers.cpp"
            var $tobool236=((($and235))|0)!=0; //@line 1534 "numbers.cpp"
            if (!($tobool236)) { __label__ = 86;break $if_then224$$if_else240$119; } //@line 1534 "numbers.cpp"
  
            var $93=$x; //@line 1535 "numbers.cpp"
            var $or238=($93) | 32; //@line 1535 "numbers.cpp"
            $x=$or238; //@line 1535 "numbers.cpp"
            ; //@line 1535 "numbers.cpp"
          }
          else if (__label__ == 84) {
  
            var $94=$tr_addr; //@line 1539 "numbers.cpp"
            var $langopts241=(($94)&4294967295); //@line 1539 "numbers.cpp"
            var $numbers2242=(($langopts241+188)&4294967295); //@line 1539 "numbers.cpp"
            var $95=HEAP32[(($numbers2242)>>2)]; //@line 1539 "numbers.cpp"
            var $96=$thousandplex_addr; //@line 1539 "numbers.cpp"
            var $shl243=1 << ($96); //@line 1539 "numbers.cpp"
            var $and244=($shl243) & ($95); //@line 1539 "numbers.cpp"
            var $tobool245=((($and244))|0)!=0; //@line 1539 "numbers.cpp"
            if (!($tobool245)) { __label__ = 86;break $if_then224$$if_else240$119; } //@line 1539 "numbers.cpp"
  
            $x=8; //@line 1540 "numbers.cpp"
            ; //@line 1540 "numbers.cpp"
          }
        } while(0);
  
        var $97=$tr_addr; //@line 1543 "numbers.cpp"
        var $98=$tensunits; //@line 1543 "numbers.cpp"
        var $99=$x; //@line 1543 "numbers.cpp"
        var $arraydecay249=(($buf2)&4294967295); //@line 1543 "numbers.cpp"
        var $call250=__ZL10LookupNum2P10TranslatoriiPc($97, $98, $99, $arraydecay249); //@line 1543 "numbers.cpp"
        var $cmp251=((($call250))|0)!=0; //@line 1543 "numbers.cpp"
        if (!($cmp251)) { __label__ = 94;break $if_then222$$if_end279$117; } //@line 1543 "numbers.cpp"
  
        var $100=$tr_addr; //@line 1545 "numbers.cpp"
        var $langopts253=(($100)&4294967295); //@line 1545 "numbers.cpp"
        var $numbers254=(($langopts253+184)&4294967295); //@line 1545 "numbers.cpp"
        var $101=HEAP32[(($numbers254)>>2)]; //@line 1545 "numbers.cpp"
        var $and255=($101) & 128; //@line 1545 "numbers.cpp"
        var $tobool256=((($and255))|0)!=0; //@line 1545 "numbers.cpp"
        if (!($tobool256)) { __label__ = 94;break $if_then222$$if_end279$117; } //@line 1545 "numbers.cpp"
  
        var $arrayidx258=(($ph_hundred_and)&4294967295); //@line 1546 "numbers.cpp"
        HEAP8[($arrayidx258)]=0; //@line 1546 "numbers.cpp"
        ; //@line 1546 "numbers.cpp"
      }
    } while(0);
  
    var $107=$ph_out_addr; //@line 1560 "numbers.cpp"
    var $arraydecay280=(($buf1)&4294967295); //@line 1560 "numbers.cpp"
    var $arraydecay281=(($ph_hundred_and)&4294967295); //@line 1560 "numbers.cpp"
    var $arraydecay282=(($buf2)&4294967295); //@line 1560 "numbers.cpp"
    var $call283=_sprintf($107, ((__str6549)&4294967295), allocate([$arraydecay280,0,0,0,$arraydecay281,0,0,0,$arraydecay282,0,0,0], ["i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 1560 "numbers.cpp"
    STACKTOP = __stackBase__;
    return;
    return;
  }
  

  function __ZL10LookupNum2P10TranslatoriiPc($tr, $value, $control, $ph_out) {
    var __stackBase__  = STACKTOP; STACKTOP += 148; _memset(__stackBase__, 0, 148);
    var __label__;
    var __lastLabel__ = null;
  
    var $tr_addr;
    var $value_addr;
    var $control_addr;
    var $ph_out_addr;
    var $found;
    var $ix;
    var $units;
    var $tens;
    var $used_and;
    var $found_ordinal;
    var $next_phtype;
    var $ord_type;
    var $string=__stackBase__;
    var $ph_ordinal=__stackBase__+12;
    var $ph_tens=__stackBase__+32;
    var $ph_digits=__stackBase__+84;
    var $ph_and=__stackBase__+136;
    $tr_addr=$tr;
    $value_addr=$value;
    $control_addr=$control;
    $ph_out_addr=$ph_out;
    $used_and=0; //@line 1109 "numbers.cpp"
    $found_ordinal=0; //@line 1110 "numbers.cpp"
    $ord_type=111; //@line 1112 "numbers.cpp"
    var $0=$value_addr; //@line 1119 "numbers.cpp"
    var $rem=((($0))|0)%10; //@line 1119 "numbers.cpp"
    $units=$rem; //@line 1119 "numbers.cpp"
    var $1=$value_addr; //@line 1120 "numbers.cpp"
    var $div=((((($1))|0)/10)|0); //@line 1120 "numbers.cpp"
    $tens=$div; //@line 1120 "numbers.cpp"
    $found=0; //@line 1122 "numbers.cpp"
    var $arrayidx=(($ph_ordinal)&4294967295); //@line 1123 "numbers.cpp"
    HEAP8[($arrayidx)]=0; //@line 1123 "numbers.cpp"
    var $arrayidx1=(($ph_tens)&4294967295); //@line 1124 "numbers.cpp"
    HEAP8[($arrayidx1)]=0; //@line 1124 "numbers.cpp"
    var $arrayidx2=(($ph_digits)&4294967295); //@line 1125 "numbers.cpp"
    HEAP8[($arrayidx2)]=0; //@line 1125 "numbers.cpp"
    var $arrayidx3=(($ph_and)&4294967295); //@line 1126 "numbers.cpp"
    HEAP8[($arrayidx3)]=0; //@line 1126 "numbers.cpp"
    var $2=$control_addr; //@line 1128 "numbers.cpp"
    var $and=($2) & 32; //@line 1128 "numbers.cpp"
    var $tobool=((($and))|0)!=0; //@line 1128 "numbers.cpp"
    if ($tobool) { __label__ = 1;; } else { __label__ = 2;; } //@line 1128 "numbers.cpp"
    if (__label__ == 1) {
  
      $ord_type=113; //@line 1130 "numbers.cpp"
      ; //@line 1131 "numbers.cpp"
    }
  
    var $3=$control_addr; //@line 1133 "numbers.cpp"
    var $and4=($3) & 2; //@line 1133 "numbers.cpp"
    var $tobool5=((($and4))|0)!=0; //@line 1133 "numbers.cpp"
    var $4=HEAP32[((__ZL14n_digit_lookup)>>2)]; //@line 1133 "numbers.cpp"
    var $cmp=((($4))|0)==2; //@line 1133 "numbers.cpp"
    var $or_cond=($tobool5) & ($cmp); //@line 1133 "numbers.cpp"
    if ($or_cond) { __label__ = 3;; } else { __label__ = 4;; } //@line 1133 "numbers.cpp"
    $if_then6$$if_else$5: do { 
      if (__label__ == 3) {
  
        var $5=$ph_out_addr; //@line 1136 "numbers.cpp"
        var $6=HEAP32[((__ZL12digit_lookup)>>2)]; //@line 1136 "numbers.cpp"
        var $call=_strcpy($5, $6); //@line 1136 "numbers.cpp"
        ; //@line 1137 "numbers.cpp"
      }
      else if (__label__ == 4) {
  
        var $7=HEAP32[((__ZL12digit_lookup)>>2)]; //@line 1140 "numbers.cpp"
        var $arrayidx7=(($7)&4294967295); //@line 1140 "numbers.cpp"
        var $8=HEAP8[($arrayidx7)]; //@line 1140 "numbers.cpp"
        var $conv=(tempInt=(($8)),(tempInt>=128?tempInt-256:tempInt)); //@line 1140 "numbers.cpp"
        var $cmp8=((($conv))|0)==0; //@line 1140 "numbers.cpp"
        if ($cmp8) { __label__ = 5;; } else { __label__ = 23;; } //@line 1140 "numbers.cpp"
        $if_then9$$if_end72$8: do { 
          if (__label__ == 5) {
  
            var $9=$control_addr; //@line 1143 "numbers.cpp"
            var $and10=($9) & 8; //@line 1143 "numbers.cpp"
            var $tobool11=((($and10))|0)!=0; //@line 1143 "numbers.cpp"
            if ($tobool11) { __label__ = 6;; } else { __label__ = 7;; } //@line 1143 "numbers.cpp"
            if (__label__ == 6) {
  
              var $arraydecay=(($string)&4294967295); //@line 1145 "numbers.cpp"
              var $10=$value_addr; //@line 1145 "numbers.cpp"
              var $call13=_sprintf($arraydecay, ((__str23320)&4294967295), allocate([$10,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 1145 "numbers.cpp"
              var $11=$tr_addr; //@line 1146 "numbers.cpp"
              var $arraydecay14=(($string)&4294967295); //@line 1146 "numbers.cpp"
              var $arraydecay15=(($ph_digits)&4294967295); //@line 1146 "numbers.cpp"
              var $call16=__Z6LookupP10TranslatorPKcPc($11, $arraydecay14, $arraydecay15); //@line 1146 "numbers.cpp"
              $found=$call16; //@line 1146 "numbers.cpp"
              __lastLabel__ = 6; ; //@line 1147 "numbers.cpp"
            }
            else if (__label__ == 7) {
  
              var $12=$control_addr; //@line 1149 "numbers.cpp"
              var $and18=($12) & 1; //@line 1149 "numbers.cpp"
              var $tobool19=((($and18))|0)!=0; //@line 1149 "numbers.cpp"
              if ($tobool19) { __label__ = 8;; } else { __label__ = 14;; } //@line 1149 "numbers.cpp"
              if (__label__ == 8) {
  
                var $arraydecay21=(($ph_ordinal)&4294967295); //@line 1151 "numbers.cpp"
                var $call22=_strcpy($arraydecay21, ((__ZL11ph_ordinal2)&4294967295)); //@line 1151 "numbers.cpp"
                var $13=$control_addr; //@line 1153 "numbers.cpp"
                var $and23=($13) & 4; //@line 1153 "numbers.cpp"
                var $tobool24=((($and23))|0)!=0; //@line 1153 "numbers.cpp"
                if ($tobool24) { __label__ = 9;; } else { __label__ = 10;; } //@line 1153 "numbers.cpp"
                if (__label__ == 9) {
  
                  var $arraydecay26=(($string)&4294967295); //@line 1155 "numbers.cpp"
                  var $14=$value_addr; //@line 1155 "numbers.cpp"
                  var $15=$ord_type; //@line 1155 "numbers.cpp"
                  var $call27=_sprintf($arraydecay26, ((__str24321)&4294967295), allocate([$14,0,0,0,$15,0,0,0], ["i32",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 1155 "numbers.cpp"
                  var $16=$tr_addr; //@line 1156 "numbers.cpp"
                  var $arraydecay28=(($string)&4294967295); //@line 1156 "numbers.cpp"
                  var $arraydecay29=(($ph_digits)&4294967295); //@line 1156 "numbers.cpp"
                  var $call30=__Z6LookupP10TranslatorPKcPc($16, $arraydecay28, $arraydecay29); //@line 1156 "numbers.cpp"
                  $found=$call30; //@line 1156 "numbers.cpp"
                  __lastLabel__ = 9; ; //@line 1157 "numbers.cpp"
                }
                else if (__label__ == 10) {
  
                  var $_pr=$found; //@line 1158 "numbers.cpp"
                  __lastLabel__ = 10; ;
                }
  
                var $17=__lastLabel__ == 10 ? $_pr : ($call30); //@line 1158 "numbers.cpp"
                var $cmp32=((($17))|0)==0; //@line 1158 "numbers.cpp"
                if ($cmp32) { __label__ = 12;; } else { __label__ = 13;; } //@line 1158 "numbers.cpp"
                if (__label__ == 12) {
  
                  var $arraydecay34=(($string)&4294967295); //@line 1160 "numbers.cpp"
                  var $18=$value_addr; //@line 1160 "numbers.cpp"
                  var $19=$ord_type; //@line 1160 "numbers.cpp"
                  var $call35=_sprintf($arraydecay34, ((__str25322)&4294967295), allocate([$18,0,0,0,$19,0,0,0], ["i32",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 1160 "numbers.cpp"
                  var $20=$tr_addr; //@line 1161 "numbers.cpp"
                  var $arraydecay36=(($string)&4294967295); //@line 1161 "numbers.cpp"
                  var $arraydecay37=(($ph_digits)&4294967295); //@line 1161 "numbers.cpp"
                  var $call38=__Z6LookupP10TranslatorPKcPc($20, $arraydecay36, $arraydecay37); //@line 1161 "numbers.cpp"
                  $found=$call38; //@line 1161 "numbers.cpp"
                  ; //@line 1162 "numbers.cpp"
                }
  
                var $21=$found; //@line 1163 "numbers.cpp"
                $found_ordinal=$21; //@line 1163 "numbers.cpp"
                __lastLabel__ = 13; ; //@line 1164 "numbers.cpp"
              }
              else if (__label__ == 14) {
  
                var $_pr1=$found; //@line 1166 "numbers.cpp"
                __lastLabel__ = 14; ;
              }
            }
  
            var $22=__lastLabel__ == 14 ? $_pr1 : (__lastLabel__ == 13 ? $21 : ($call16)); //@line 1166 "numbers.cpp"
            var $cmp42=((($22))|0)==0; //@line 1166 "numbers.cpp"
            if (!($cmp42)) { __label__ = 23;break $if_then9$$if_end72$8; } //@line 1166 "numbers.cpp"
  
            var $23=$control_addr; //@line 1168 "numbers.cpp"
            var $and44=($23) & 2; //@line 1168 "numbers.cpp"
            var $tobool45=((($and44))|0)!=0; //@line 1168 "numbers.cpp"
            if ($tobool45) { __label__ = 17;; } else { __label__ = 19;; } //@line 1168 "numbers.cpp"
            if (__label__ == 17) {
  
              var $24=HEAP32[((__ZL14number_control)>>2)]; //@line 1171 "numbers.cpp"
              var $and47=($24) & 1; //@line 1171 "numbers.cpp"
              var $tobool48=((($and47))|0)!=0; //@line 1171 "numbers.cpp"
              if ($tobool48) { __label__ = 18;; } else { __label__ = 20;; } //@line 1171 "numbers.cpp"
              if (__label__ == 18) {
  
                var $arraydecay50=(($string)&4294967295); //@line 1174 "numbers.cpp"
                var $25=$value_addr; //@line 1174 "numbers.cpp"
                var $call51=_sprintf($arraydecay50, ((__str26323)&4294967295), allocate([$25,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 1174 "numbers.cpp"
                var $26=$tr_addr; //@line 1175 "numbers.cpp"
                var $arraydecay52=(($string)&4294967295); //@line 1175 "numbers.cpp"
                var $arraydecay53=(($ph_digits)&4294967295); //@line 1175 "numbers.cpp"
                var $call54=__Z6LookupP10TranslatorPKcPc($26, $arraydecay52, $arraydecay53); //@line 1175 "numbers.cpp"
                $found=$call54; //@line 1175 "numbers.cpp"
                __lastLabel__ = 18; ; //@line 1176 "numbers.cpp"
              }
              else if (__label__ == 20) {
  
                var $_pr2=$found; //@line 1185 "numbers.cpp"
                __lastLabel__ = 20; ;
              }
            }
            else if (__label__ == 19) {
  
              var $arraydecay57=(($string)&4294967295); //@line 1181 "numbers.cpp"
              var $27=$value_addr; //@line 1181 "numbers.cpp"
              var $call58=_sprintf($arraydecay57, ((__str27324)&4294967295), allocate([$27,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 1181 "numbers.cpp"
              var $28=$tr_addr; //@line 1182 "numbers.cpp"
              var $arraydecay59=(($string)&4294967295); //@line 1182 "numbers.cpp"
              var $arraydecay60=(($ph_digits)&4294967295); //@line 1182 "numbers.cpp"
              var $call61=__Z6LookupP10TranslatorPKcPc($28, $arraydecay59, $arraydecay60); //@line 1182 "numbers.cpp"
              $found=$call61; //@line 1182 "numbers.cpp"
              __lastLabel__ = 19; ;
            }
  
            var $29=__lastLabel__ == 20 ? $_pr2 : (__lastLabel__ == 18 ? $call54 : ($call61)); //@line 1185 "numbers.cpp"
            var $tobool63=((($29))|0)!=0; //@line 1185 "numbers.cpp"
            if ($tobool63) { __label__ = 23;break $if_then9$$if_end72$8; } //@line 1185 "numbers.cpp"
  
            var $arraydecay65=(($string)&4294967295); //@line 1187 "numbers.cpp"
            var $30=$value_addr; //@line 1187 "numbers.cpp"
            var $call66=_sprintf($arraydecay65, ((__str28325)&4294967295), allocate([$30,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 1187 "numbers.cpp"
            var $31=$tr_addr; //@line 1188 "numbers.cpp"
            var $arraydecay67=(($string)&4294967295); //@line 1188 "numbers.cpp"
            var $arraydecay68=(($ph_digits)&4294967295); //@line 1188 "numbers.cpp"
            var $call69=__Z6LookupP10TranslatorPKcPc($31, $arraydecay67, $arraydecay68); //@line 1188 "numbers.cpp"
            $found=$call69; //@line 1188 "numbers.cpp"
            ; //@line 1189 "numbers.cpp"
          }
        } while(0);
  
        var $32=$control_addr; //@line 1195 "numbers.cpp"
        var $and73=($32) & 16; //@line 1195 "numbers.cpp"
        var $tobool74=((($and73))|0)!=0; //@line 1195 "numbers.cpp"
        if ($tobool74) { __label__ = 24;; } else { __label__ = 26;; } //@line 1195 "numbers.cpp"
        $land_lhs_true75$$if_else80$34: do { 
          if (__label__ == 24) {
  
            var $33=$value_addr; //@line 1195 "numbers.cpp"
            var $cmp76=((($33))|0) < 10; //@line 1195 "numbers.cpp"
            if (!($cmp76)) { __label__ = 26;break $land_lhs_true75$$if_else80$34; } //@line 1195 "numbers.cpp"
  
            var $34=$tr_addr; //@line 1198 "numbers.cpp"
            var $arraydecay78=(($ph_tens)&4294967295); //@line 1198 "numbers.cpp"
            var $call79=__Z6LookupP10TranslatorPKcPc($34, ((__str16313)&4294967295), $arraydecay78); //@line 1198 "numbers.cpp"
            __label__ = 61;break $land_lhs_true75$$if_else80$34; //@line 1199 "numbers.cpp"
          }
        } while(0);
        $if_end221$$if_else80$37: do { 
          if (__label__ == 26) {
  
            var $35=$found; //@line 1202 "numbers.cpp"
            var $tobool81=((($35))|0)!=0; //@line 1202 "numbers.cpp"
            if ($tobool81) { __label__ = 27;; } else { __label__ = 28;; } //@line 1202 "numbers.cpp"
            if (__label__ == 27) {
  
              var $arrayidx83=(($ph_tens)&4294967295); //@line 1204 "numbers.cpp"
              HEAP8[($arrayidx83)]=0; //@line 1204 "numbers.cpp"
              ; //@line 1205 "numbers.cpp"
            }
            else if (__label__ == 28) {
  
              var $36=$control_addr; //@line 1209 "numbers.cpp"
              var $and85=($36) & 1; //@line 1209 "numbers.cpp"
              var $tobool86=((($and85))|0)!=0; //@line 1209 "numbers.cpp"
              if ($tobool86) { __label__ = 29;; } else { __label__ = 36;; } //@line 1209 "numbers.cpp"
              $land_lhs_true87$$if_end114$42: do { 
                if (__label__ == 29) {
  
                  var $37=$units; //@line 1209 "numbers.cpp"
                  var $cmp88=((($37))|0)==0; //@line 1209 "numbers.cpp"
                  if ($cmp88) { __label__ = 32;; } else { __label__ = 30;; } //@line 1209 "numbers.cpp"
                  $if_then95$$lor_lhs_false$44: do { 
                    if (__label__ == 30) {
  
                      var $38=$tr_addr; //@line 1209 "numbers.cpp"
                      var $langopts=(($38)&4294967295); //@line 1209 "numbers.cpp"
                      var $numbers=(($langopts+184)&4294967295); //@line 1209 "numbers.cpp"
                      var $39=HEAP32[(($numbers)>>2)]; //@line 1209 "numbers.cpp"
                      var $and89=($39) & 16; //@line 1209 "numbers.cpp"
                      var $tobool90=((($and89))|0)!=0; //@line 1209 "numbers.cpp"
                      if ($tobool90) { __label__ = 32;break $if_then95$$lor_lhs_false$44; } //@line 1209 "numbers.cpp"
  
                      var $40=$tr_addr; //@line 1209 "numbers.cpp"
                      var $langopts92=(($40)&4294967295); //@line 1209 "numbers.cpp"
                      var $numbers2=(($langopts92+188)&4294967295); //@line 1209 "numbers.cpp"
                      var $41=HEAP32[(($numbers2)>>2)]; //@line 1209 "numbers.cpp"
                      var $and93=($41) & 4096; //@line 1209 "numbers.cpp"
                      var $tobool94=((($and93))|0)!=0; //@line 1209 "numbers.cpp"
                      if (!($tobool94)) { __label__ = 36;break $land_lhs_true87$$if_end114$42; } //@line 1209 "numbers.cpp"
                    }
                  } while(0);
  
                  var $arraydecay96=(($string)&4294967295); //@line 1212 "numbers.cpp"
                  var $42=$tens; //@line 1212 "numbers.cpp"
                  var $43=$ord_type; //@line 1212 "numbers.cpp"
                  var $call97=_sprintf($arraydecay96, ((__str29326)&4294967295), allocate([$42,0,0,0,$43,0,0,0], ["i32",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 1212 "numbers.cpp"
                  var $44=$tr_addr; //@line 1213 "numbers.cpp"
                  var $arraydecay98=(($string)&4294967295); //@line 1213 "numbers.cpp"
                  var $arraydecay99=(($ph_tens)&4294967295); //@line 1213 "numbers.cpp"
                  var $call100=__Z6LookupP10TranslatorPKcPc($44, $arraydecay98, $arraydecay99); //@line 1213 "numbers.cpp"
                  var $cmp101=((($call100))|0)!=0; //@line 1213 "numbers.cpp"
                  if (!($cmp101)) { __label__ = 36;break $land_lhs_true87$$if_end114$42; } //@line 1213 "numbers.cpp"
  
                  $found_ordinal=1; //@line 1215 "numbers.cpp"
                  var $45=$units; //@line 1217 "numbers.cpp"
                  var $cmp103=((($45))|0)!=0; //@line 1217 "numbers.cpp"
                  if (!($cmp103)) { __label__ = 38;break $land_lhs_true87$$if_end114$42; } //@line 1217 "numbers.cpp"
  
                  var $46=$tr_addr; //@line 1217 "numbers.cpp"
                  var $langopts105=(($46)&4294967295); //@line 1217 "numbers.cpp"
                  var $numbers2106=(($langopts105+188)&4294967295); //@line 1217 "numbers.cpp"
                  var $47=HEAP32[(($numbers2106)>>2)]; //@line 1217 "numbers.cpp"
                  var $and107=($47) & 4096; //@line 1217 "numbers.cpp"
                  var $tobool108=((($and107))|0)!=0; //@line 1217 "numbers.cpp"
                  if (!($tobool108)) { __label__ = 36;break $land_lhs_true87$$if_end114$42; } //@line 1217 "numbers.cpp"
  
                  var $arraydecay110=(($ph_tens)&4294967295); //@line 1220 "numbers.cpp"
                  var $call111=_strcat($arraydecay110, ((__ZL11ph_ordinal2)&4294967295)); //@line 1220 "numbers.cpp"
                  __label__ = 36;break $land_lhs_true87$$if_end114$42; //@line 1221 "numbers.cpp"
                }
              } while(0);
              $if_end114$$if_end122$51: do { 
                if (__label__ == 36) {
  
                  var $_pr3=$found_ordinal; //@line 1224 "numbers.cpp"
                  var $cmp115=((($_pr3))|0)==0; //@line 1224 "numbers.cpp"
                  if (!($cmp115)) { __label__ = 38;break $if_end114$$if_end122$51; } //@line 1224 "numbers.cpp"
  
                  var $arraydecay117=(($string)&4294967295); //@line 1226 "numbers.cpp"
                  var $48=$tens; //@line 1226 "numbers.cpp"
                  var $call118=_sprintf($arraydecay117, ((__str30327)&4294967295), allocate([$48,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 1226 "numbers.cpp"
                  var $49=$tr_addr; //@line 1227 "numbers.cpp"
                  var $arraydecay119=(($string)&4294967295); //@line 1227 "numbers.cpp"
                  var $arraydecay120=(($ph_tens)&4294967295); //@line 1227 "numbers.cpp"
                  var $call121=__Z6LookupP10TranslatorPKcPc($49, $arraydecay119, $arraydecay120); //@line 1227 "numbers.cpp"
                  ; //@line 1228 "numbers.cpp"
                }
              } while(0);
  
              var $arrayidx123=(($ph_tens)&4294967295); //@line 1230 "numbers.cpp"
              var $50=HEAP8[($arrayidx123)]; //@line 1230 "numbers.cpp"
              var $conv124=(tempInt=(($50)),(tempInt>=128?tempInt-256:tempInt)); //@line 1230 "numbers.cpp"
              var $cmp125=((($conv124))|0)==0; //@line 1230 "numbers.cpp"
              if ($cmp125) { __label__ = 39;; } else { __label__ = 41;; } //@line 1230 "numbers.cpp"
              $land_lhs_true126$$if_end139$55: do { 
                if (__label__ == 39) {
  
                  var $51=$tr_addr; //@line 1230 "numbers.cpp"
                  var $langopts127=(($51)&4294967295); //@line 1230 "numbers.cpp"
                  var $numbers128=(($langopts127+184)&4294967295); //@line 1230 "numbers.cpp"
                  var $52=HEAP32[(($numbers128)>>2)]; //@line 1230 "numbers.cpp"
                  var $and129=($52) & 1048576; //@line 1230 "numbers.cpp"
                  var $tobool130=((($and129))|0)!=0; //@line 1230 "numbers.cpp"
                  if (!($tobool130)) { __label__ = 41;break $land_lhs_true126$$if_end139$55; } //@line 1230 "numbers.cpp"
  
                  var $53=$value_addr; //@line 1233 "numbers.cpp"
                  var $rem132=((($53))|0)%20; //@line 1233 "numbers.cpp"
                  $units=$rem132; //@line 1233 "numbers.cpp"
                  var $arraydecay133=(($string)&4294967295); //@line 1234 "numbers.cpp"
                  var $54=$tens; //@line 1234 "numbers.cpp"
                  var $and134=($54) & 254; //@line 1234 "numbers.cpp"
                  var $call135=_sprintf($arraydecay133, ((__str30327)&4294967295), allocate([$and134,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 1234 "numbers.cpp"
                  var $55=$tr_addr; //@line 1235 "numbers.cpp"
                  var $arraydecay136=(($string)&4294967295); //@line 1235 "numbers.cpp"
                  var $arraydecay137=(($ph_tens)&4294967295); //@line 1235 "numbers.cpp"
                  var $call138=__Z6LookupP10TranslatorPKcPc($55, $arraydecay136, $arraydecay137); //@line 1235 "numbers.cpp"
                  ; //@line 1236 "numbers.cpp"
                }
              } while(0);
  
              var $arrayidx140=(($ph_digits)&4294967295); //@line 1238 "numbers.cpp"
              HEAP8[($arrayidx140)]=0; //@line 1238 "numbers.cpp"
              var $56=$units; //@line 1239 "numbers.cpp"
              var $cmp141=((($56))|0) > 0; //@line 1239 "numbers.cpp"
              if (!($cmp141)) { __label__ = 61;break $if_end221$$if_else80$37; } //@line 1239 "numbers.cpp"
  
              $found=0; //@line 1241 "numbers.cpp"
              var $57=$control_addr; //@line 1243 "numbers.cpp"
              var $and143=($57) & 2; //@line 1243 "numbers.cpp"
              var $tobool144=((($and143))|0)!=0; //@line 1243 "numbers.cpp"
              if ($tobool144) { __label__ = 43;; } else { __label__ = 45;; } //@line 1243 "numbers.cpp"
              $land_lhs_true145$$if_else153$60: do { 
                if (__label__ == 43) {
  
                  var $58=HEAP32[((__ZL12digit_lookup)>>2)]; //@line 1243 "numbers.cpp"
                  var $arrayidx146=(($58)&4294967295); //@line 1243 "numbers.cpp"
                  var $59=HEAP8[($arrayidx146)]; //@line 1243 "numbers.cpp"
                  var $conv147=(tempInt=(($59)),(tempInt>=128?tempInt-256:tempInt)); //@line 1243 "numbers.cpp"
                  var $cmp148=((($conv147))|0)!=0; //@line 1243 "numbers.cpp"
                  if (!($cmp148)) { __label__ = 45;break $land_lhs_true145$$if_else153$60; } //@line 1243 "numbers.cpp"
  
                  var $arraydecay150=(($ph_digits)&4294967295); //@line 1246 "numbers.cpp"
                  var $60=HEAP32[((__ZL12digit_lookup)>>2)]; //@line 1246 "numbers.cpp"
                  var $call151=_strcpy($arraydecay150, $60); //@line 1246 "numbers.cpp"
                  $found_ordinal=1; //@line 1247 "numbers.cpp"
                  var $arrayidx152=(($ph_ordinal)&4294967295); //@line 1248 "numbers.cpp"
                  HEAP8[($arrayidx152)]=0; //@line 1248 "numbers.cpp"
                  __label__ = 61;break $if_end221$$if_else80$37; //@line 1249 "numbers.cpp"
                }
              } while(0);
  
              var $61=$control_addr; //@line 1252 "numbers.cpp"
              var $and154=($61) & 8; //@line 1252 "numbers.cpp"
              var $tobool155=((($and154))|0)!=0; //@line 1252 "numbers.cpp"
              if ($tobool155) { __label__ = 46;; } else { __label__ = 47;; } //@line 1252 "numbers.cpp"
              if (__label__ == 46) {
  
                var $arraydecay157=(($string)&4294967295); //@line 1255 "numbers.cpp"
                var $62=$units; //@line 1255 "numbers.cpp"
                var $call158=_sprintf($arraydecay157, ((__str23320)&4294967295), allocate([$62,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 1255 "numbers.cpp"
                var $63=$tr_addr; //@line 1256 "numbers.cpp"
                var $arraydecay159=(($string)&4294967295); //@line 1256 "numbers.cpp"
                var $arraydecay160=(($ph_digits)&4294967295); //@line 1256 "numbers.cpp"
                var $call161=__Z6LookupP10TranslatorPKcPc($63, $arraydecay159, $arraydecay160); //@line 1256 "numbers.cpp"
                $found=$call161; //@line 1256 "numbers.cpp"
                ; //@line 1257 "numbers.cpp"
              }
  
              var $64=$control_addr; //@line 1258 "numbers.cpp"
              var $and163=($64) & 1; //@line 1258 "numbers.cpp"
              var $tobool164=((($and163))|0)!=0; //@line 1258 "numbers.cpp"
              if ($tobool164) { __label__ = 48;; } else { __label__ = 51;; } //@line 1258 "numbers.cpp"
              $land_lhs_true165$$if_end179$67: do { 
                if (__label__ == 48) {
  
                  var $65=$tr_addr; //@line 1258 "numbers.cpp"
                  var $langopts166=(($65)&4294967295); //@line 1258 "numbers.cpp"
                  var $numbers167=(($langopts166+184)&4294967295); //@line 1258 "numbers.cpp"
                  var $66=HEAP32[(($numbers167)>>2)]; //@line 1258 "numbers.cpp"
                  var $and168=($66) & 16; //@line 1258 "numbers.cpp"
                  var $cmp169=((($and168))|0)==0; //@line 1258 "numbers.cpp"
                  if (!($cmp169)) { __label__ = 51;break $land_lhs_true165$$if_end179$67; } //@line 1258 "numbers.cpp"
  
                  var $arraydecay171=(($string)&4294967295); //@line 1261 "numbers.cpp"
                  var $67=$units; //@line 1261 "numbers.cpp"
                  var $68=$ord_type; //@line 1261 "numbers.cpp"
                  var $call172=_sprintf($arraydecay171, ((__str25322)&4294967295), allocate([$67,0,0,0,$68,0,0,0], ["i32",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 1261 "numbers.cpp"
                  var $69=$tr_addr; //@line 1262 "numbers.cpp"
                  var $arraydecay173=(($string)&4294967295); //@line 1262 "numbers.cpp"
                  var $arraydecay174=(($ph_digits)&4294967295); //@line 1262 "numbers.cpp"
                  var $call175=__Z6LookupP10TranslatorPKcPc($69, $arraydecay173, $arraydecay174); //@line 1262 "numbers.cpp"
                  $found=$call175; //@line 1262 "numbers.cpp"
                  var $cmp176=((($call175))|0)!=0; //@line 1262 "numbers.cpp"
                  if (!($cmp176)) { __label__ = 52;break $land_lhs_true165$$if_end179$67; } //@line 1262 "numbers.cpp"
  
                  $found_ordinal=1; //@line 1264 "numbers.cpp"
                  __label__ = 51;break $land_lhs_true165$$if_end179$67; //@line 1265 "numbers.cpp"
                }
              } while(0);
              if (__label__ == 51) {
  
                var $_pr5=$found; //@line 1267 "numbers.cpp"
                var $cmp180=((($_pr5))|0)==0; //@line 1267 "numbers.cpp"
                if (!($cmp180)) { __label__ = 61;break $if_end221$$if_else80$37; } //@line 1267 "numbers.cpp"
              }
  
              var $70=HEAP32[((__ZL14number_control)>>2)]; //@line 1269 "numbers.cpp"
              var $and182=($70) & 1; //@line 1269 "numbers.cpp"
              var $tobool183=((($and182))|0)!=0; //@line 1269 "numbers.cpp"
              if ($tobool183) { __label__ = 53;; } else { __label__ = 55;; } //@line 1269 "numbers.cpp"
              $land_lhs_true184$$if_else193$74: do { 
                if (__label__ == 53) {
  
                  var $71=$control_addr; //@line 1269 "numbers.cpp"
                  var $and185=($71) & 2; //@line 1269 "numbers.cpp"
                  var $tobool186=((($and185))|0)!=0; //@line 1269 "numbers.cpp"
                  if (!($tobool186)) { __label__ = 55;break $land_lhs_true184$$if_else193$74; } //@line 1269 "numbers.cpp"
  
                  var $arraydecay188=(($string)&4294967295); //@line 1272 "numbers.cpp"
                  var $72=$units; //@line 1272 "numbers.cpp"
                  var $call189=_sprintf($arraydecay188, ((__str26323)&4294967295), allocate([$72,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 1272 "numbers.cpp"
                  var $73=$tr_addr; //@line 1273 "numbers.cpp"
                  var $arraydecay190=(($string)&4294967295); //@line 1273 "numbers.cpp"
                  var $arraydecay191=(($ph_digits)&4294967295); //@line 1273 "numbers.cpp"
                  var $call192=__Z6LookupP10TranslatorPKcPc($73, $arraydecay190, $arraydecay191); //@line 1273 "numbers.cpp"
                  $found=$call192; //@line 1273 "numbers.cpp"
                  __lastLabel__ = 54; __label__ = 59;break $land_lhs_true184$$if_else193$74; //@line 1274 "numbers.cpp"
                }
              } while(0);
              $if_end209$$if_else193$77: do { 
                if (__label__ == 55) {
  
                  var $74=$control_addr; //@line 1276 "numbers.cpp"
                  var $and194=($74) & 2; //@line 1276 "numbers.cpp"
                  var $cmp195=((($and194))|0)==0; //@line 1276 "numbers.cpp"
                  if ($cmp195) { __label__ = 57;; } else { __label__ = 56;; } //@line 1276 "numbers.cpp"
                  $if_then201$$lor_lhs_false196$79: do { 
                    if (__label__ == 56) {
  
                      var $75=$tr_addr; //@line 1276 "numbers.cpp"
                      var $langopts197=(($75)&4294967295); //@line 1276 "numbers.cpp"
                      var $numbers198=(($langopts197+184)&4294967295); //@line 1276 "numbers.cpp"
                      var $76=HEAP32[(($numbers198)>>2)]; //@line 1276 "numbers.cpp"
                      var $and199=($76) & 16; //@line 1276 "numbers.cpp"
                      var $cmp200=((($and199))|0)!=0; //@line 1276 "numbers.cpp"
                      if ($cmp200) { __label__ = 57;break $if_then201$$lor_lhs_false196$79; } //@line 1276 "numbers.cpp"
  
                      var $_pr7=$found; //@line 1283 "numbers.cpp"
                      __lastLabel__ = 58; __label__ = 59;break $if_end209$$if_else193$77;
                    }
                  } while(0);
  
                  var $arraydecay202=(($string)&4294967295); //@line 1279 "numbers.cpp"
                  var $77=$units; //@line 1279 "numbers.cpp"
                  var $call203=_sprintf($arraydecay202, ((__str27324)&4294967295), allocate([$77,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 1279 "numbers.cpp"
                  var $78=$tr_addr; //@line 1280 "numbers.cpp"
                  var $arraydecay204=(($string)&4294967295); //@line 1280 "numbers.cpp"
                  var $arraydecay205=(($ph_digits)&4294967295); //@line 1280 "numbers.cpp"
                  var $call206=__Z6LookupP10TranslatorPKcPc($78, $arraydecay204, $arraydecay205); //@line 1280 "numbers.cpp"
                  $found=$call206; //@line 1280 "numbers.cpp"
                  __lastLabel__ = 57; ; //@line 1281 "numbers.cpp"
                }
              } while(0);
  
              var $79=__lastLabel__ == 58 ? $_pr7 : (__lastLabel__ == 54 ? $call192 : ($call206)); //@line 1283 "numbers.cpp"
              var $cmp210=((($79))|0)==0; //@line 1283 "numbers.cpp"
              if (!($cmp210)) { __label__ = 61;break $if_end221$$if_else80$37; } //@line 1283 "numbers.cpp"
  
              var $arraydecay212=(($string)&4294967295); //@line 1285 "numbers.cpp"
              var $80=$units; //@line 1285 "numbers.cpp"
              var $call213=_sprintf($arraydecay212, ((__str28325)&4294967295), allocate([$80,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 1285 "numbers.cpp"
              var $81=$tr_addr; //@line 1286 "numbers.cpp"
              var $arraydecay214=(($string)&4294967295); //@line 1286 "numbers.cpp"
              var $arraydecay215=(($ph_digits)&4294967295); //@line 1286 "numbers.cpp"
              var $call216=__Z6LookupP10TranslatorPKcPc($81, $arraydecay214, $arraydecay215); //@line 1286 "numbers.cpp"
              ; //@line 1287 "numbers.cpp"
            }
          }
        } while(0);
  
        var $82=$control_addr; //@line 1293 "numbers.cpp"
        var $and222=($82) & 1; //@line 1293 "numbers.cpp"
        var $tobool223=((($and222))|0)!=0; //@line 1293 "numbers.cpp"
        if ($tobool223) { __label__ = 62;; } else { __label__ = 70;; } //@line 1293 "numbers.cpp"
        $land_lhs_true224$$if_end251$86: do { 
          if (__label__ == 62) {
  
            var $83=$found_ordinal; //@line 1293 "numbers.cpp"
            var $cmp225=((($83))|0)==0; //@line 1293 "numbers.cpp"
            if (!($cmp225)) { __label__ = 70;break $land_lhs_true224$$if_end251$86; } //@line 1293 "numbers.cpp"
  
            var $arrayidx227=(($ph_ordinal)&4294967295); //@line 1293 "numbers.cpp"
            var $84=HEAP8[($arrayidx227)]; //@line 1293 "numbers.cpp"
            var $conv228=(tempInt=(($84)),(tempInt>=128?tempInt-256:tempInt)); //@line 1293 "numbers.cpp"
            var $cmp229=((($conv228))|0)==0; //@line 1293 "numbers.cpp"
            if (!($cmp229)) { __label__ = 70;break $land_lhs_true224$$if_end251$86; } //@line 1293 "numbers.cpp"
  
            var $85=$value_addr; //@line 1295 "numbers.cpp"
            var $cmp231=((($85))|0) >= 20; //@line 1295 "numbers.cpp"
            if ($cmp231) { __label__ = 65;; } else { __label__ = 68;; } //@line 1295 "numbers.cpp"
            $land_lhs_true232$$if_end243$90: do { 
              if (__label__ == 65) {
  
                var $86=$value_addr; //@line 1295 "numbers.cpp"
                var $rem233=((($86))|0)%10; //@line 1295 "numbers.cpp"
                var $cmp234=((($rem233))|0)==0; //@line 1295 "numbers.cpp"
                if ($cmp234) { __label__ = 67;; } else { __label__ = 66;; } //@line 1295 "numbers.cpp"
                if (__label__ == 66) {
  
                  var $87=$tr_addr; //@line 1295 "numbers.cpp"
                  var $langopts236=(($87)&4294967295); //@line 1295 "numbers.cpp"
                  var $numbers237=(($langopts236+184)&4294967295); //@line 1295 "numbers.cpp"
                  var $88=HEAP32[(($numbers237)>>2)]; //@line 1295 "numbers.cpp"
                  var $and238=($88) & 16; //@line 1295 "numbers.cpp"
                  var $tobool239=((($and238))|0)!=0; //@line 1295 "numbers.cpp"
                  if (!($tobool239)) { __label__ = 68;break $land_lhs_true232$$if_end243$90; } //@line 1295 "numbers.cpp"
                }
  
                var $89=$tr_addr; //@line 1296 "numbers.cpp"
                var $arraydecay241=(($ph_ordinal)&4294967295); //@line 1296 "numbers.cpp"
                var $call242=__Z6LookupP10TranslatorPKcPc($89, ((__str31328)&4294967295), $arraydecay241); //@line 1296 "numbers.cpp"
                ; //@line 1296 "numbers.cpp"
              }
            } while(0);
  
            var $arrayidx244=(($ph_ordinal)&4294967295); //@line 1297 "numbers.cpp"
            var $90=HEAP8[($arrayidx244)]; //@line 1297 "numbers.cpp"
            var $conv245=(tempInt=(($90)),(tempInt>=128?tempInt-256:tempInt)); //@line 1297 "numbers.cpp"
            var $cmp246=((($conv245))|0)==0; //@line 1297 "numbers.cpp"
            if (!($cmp246)) { __label__ = 70;break $land_lhs_true224$$if_end251$86; } //@line 1297 "numbers.cpp"
  
            var $91=$tr_addr; //@line 1298 "numbers.cpp"
            var $arraydecay248=(($ph_ordinal)&4294967295); //@line 1298 "numbers.cpp"
            var $call249=__Z6LookupP10TranslatorPKcPc($91, ((__str32329)&4294967295), $arraydecay248); //@line 1298 "numbers.cpp"
            ; //@line 1298 "numbers.cpp"
          }
        } while(0);
  
        var $92=$tr_addr; //@line 1301 "numbers.cpp"
        var $langopts252=(($92)&4294967295); //@line 1301 "numbers.cpp"
        var $numbers253=(($langopts252+184)&4294967295); //@line 1301 "numbers.cpp"
        var $93=HEAP32[(($numbers253)>>2)]; //@line 1301 "numbers.cpp"
        var $and254=($93) & 48; //@line 1301 "numbers.cpp"
        var $tobool255=((($and254))|0)!=0; //@line 1301 "numbers.cpp"
        if ($tobool255) { __label__ = 71;; } else { __label__ = 79;; } //@line 1301 "numbers.cpp"
        $land_lhs_true256$$if_else291$98: do { 
          if (__label__ == 71) {
  
            var $arrayidx257=(($ph_tens)&4294967295); //@line 1301 "numbers.cpp"
            var $94=HEAP8[($arrayidx257)]; //@line 1301 "numbers.cpp"
            var $conv258=(tempInt=(($94)),(tempInt>=128?tempInt-256:tempInt)); //@line 1301 "numbers.cpp"
            var $cmp259=((($conv258))|0)!=0; //@line 1301 "numbers.cpp"
            if (!($cmp259)) { __label__ = 79;break $land_lhs_true256$$if_else291$98; } //@line 1301 "numbers.cpp"
  
            var $arrayidx261=(($ph_digits)&4294967295); //@line 1301 "numbers.cpp"
            var $95=HEAP8[($arrayidx261)]; //@line 1301 "numbers.cpp"
            var $conv262=(tempInt=(($95)),(tempInt>=128?tempInt-256:tempInt)); //@line 1301 "numbers.cpp"
            var $cmp263=((($conv262))|0)!=0; //@line 1301 "numbers.cpp"
            if (!($cmp263)) { __label__ = 79;break $land_lhs_true256$$if_else291$98; } //@line 1301 "numbers.cpp"
  
            var $96=$tr_addr; //@line 1303 "numbers.cpp"
            var $arraydecay265=(($ph_and)&4294967295); //@line 1303 "numbers.cpp"
            var $call266=__Z6LookupP10TranslatorPKcPc($96, ((__str33330)&4294967295), $arraydecay265); //@line 1303 "numbers.cpp"
            var $97=$tr_addr; //@line 1305 "numbers.cpp"
            var $langopts267=(($97)&4294967295); //@line 1305 "numbers.cpp"
            var $numbers2268=(($langopts267+188)&4294967295); //@line 1305 "numbers.cpp"
            var $98=HEAP32[(($numbers2268)>>2)]; //@line 1305 "numbers.cpp"
            var $and269=($98) & 4096; //@line 1305 "numbers.cpp"
            var $tobool270=((($and269))|0)!=0; //@line 1305 "numbers.cpp"
            if ($tobool270) { __label__ = 74;; } else { __label__ = 75;; } //@line 1305 "numbers.cpp"
            if (__label__ == 74) {
  
              var $arrayidx272=(($ph_and)&4294967295); //@line 1306 "numbers.cpp"
              HEAP8[($arrayidx272)]=0; //@line 1306 "numbers.cpp"
              ; //@line 1306 "numbers.cpp"
            }
  
            var $99=$tr_addr; //@line 1308 "numbers.cpp"
            var $langopts274=(($99)&4294967295); //@line 1308 "numbers.cpp"
            var $numbers275=(($langopts274+184)&4294967295); //@line 1308 "numbers.cpp"
            var $100=HEAP32[(($numbers275)>>2)]; //@line 1308 "numbers.cpp"
            var $and276=($100) & 16; //@line 1308 "numbers.cpp"
            var $tobool277=((($and276))|0)!=0; //@line 1308 "numbers.cpp"
            var $101=$ph_out_addr; //@line 1309 "numbers.cpp"
            if ($tobool277) { __label__ = 76;; } else { __label__ = 77;; } //@line 1308 "numbers.cpp"
            if (__label__ == 76) {
  
              var $arraydecay279=(($ph_digits)&4294967295); //@line 1309 "numbers.cpp"
              var $arraydecay280=(($ph_and)&4294967295); //@line 1309 "numbers.cpp"
              var $arraydecay281=(($ph_tens)&4294967295); //@line 1309 "numbers.cpp"
              var $arraydecay282=(($ph_ordinal)&4294967295); //@line 1309 "numbers.cpp"
              var $call283=_sprintf($101, ((__str20317)&4294967295), allocate([$arraydecay279,0,0,0,$arraydecay280,0,0,0,$arraydecay281,0,0,0,$arraydecay282,0,0,0], ["i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 1309 "numbers.cpp"
              ; //@line 1309 "numbers.cpp"
            }
            else if (__label__ == 77) {
  
              var $arraydecay285=(($ph_tens)&4294967295); //@line 1311 "numbers.cpp"
              var $arraydecay286=(($ph_and)&4294967295); //@line 1311 "numbers.cpp"
              var $arraydecay287=(($ph_digits)&4294967295); //@line 1311 "numbers.cpp"
              var $arraydecay288=(($ph_ordinal)&4294967295); //@line 1311 "numbers.cpp"
              var $call289=_sprintf($101, ((__str20317)&4294967295), allocate([$arraydecay285,0,0,0,$arraydecay286,0,0,0,$arraydecay287,0,0,0,$arraydecay288,0,0,0], ["i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 1311 "numbers.cpp"
              ;
            }
  
            $used_and=1; //@line 1312 "numbers.cpp"
            __label__ = 88;break $if_then6$$if_else$5; //@line 1313 "numbers.cpp"
          }
        } while(0);
  
        var $102=$tr_addr; //@line 1316 "numbers.cpp"
        var $langopts292=(($102)&4294967295); //@line 1316 "numbers.cpp"
        var $numbers293=(($langopts292+184)&4294967295); //@line 1316 "numbers.cpp"
        var $103=HEAP32[(($numbers293)>>2)]; //@line 1316 "numbers.cpp"
        var $and294=($103) & 512; //@line 1316 "numbers.cpp"
        var $tobool295=((($and294))|0)!=0; //@line 1316 "numbers.cpp"
        if ($tobool295) { __label__ = 80;; } else { __label__ = 87;; } //@line 1316 "numbers.cpp"
        $if_then296$$if_end329$110: do { 
          if (__label__ == 80) {
  
            var $arraydecay297=(($ph_tens)&4294967295); //@line 1319 "numbers.cpp"
            var $call298=_strlen($arraydecay297); //@line 1319 "numbers.cpp"
            var $sub=((($call298)-1)&4294967295); //@line 1319 "numbers.cpp"
            $ix=$sub; //@line 1319 "numbers.cpp"
            var $cmp299=((($sub))|0) >= 0; //@line 1319 "numbers.cpp"
            if (!($cmp299)) { __label__ = 87;break $if_then296$$if_end329$110; } //@line 1319 "numbers.cpp"
  
            var $arrayidx301=(($ph_digits)&4294967295); //@line 1319 "numbers.cpp"
            var $104=HEAP8[($arrayidx301)]; //@line 1319 "numbers.cpp"
            var $conv302=(tempInt=(($104)),(tempInt>=128?tempInt-256:tempInt)); //@line 1319 "numbers.cpp"
            var $cmp303=((($conv302))|0)!=0; //@line 1319 "numbers.cpp"
            if (!($cmp303)) { __label__ = 87;break $if_then296$$if_end329$110; } //@line 1319 "numbers.cpp"
  
            var $arrayidx305=(($ph_digits)&4294967295); //@line 1321 "numbers.cpp"
            var $105=HEAP8[($arrayidx305)]; //@line 1321 "numbers.cpp"
            var $conv306=(tempInt=(($105)),(tempInt>=128?tempInt-256:tempInt)); //@line 1321 "numbers.cpp"
            var $arrayidx307=((_phoneme_tab+$conv306*4)&4294967295); //@line 1321 "numbers.cpp"
            var $106=HEAP32[(($arrayidx307)>>2)]; //@line 1321 "numbers.cpp"
            var $type=(($106+11)&4294967295); //@line 1321 "numbers.cpp"
            var $107=HEAPU8[($type)]; //@line 1321 "numbers.cpp"
            var $conv308=((($107))&255); //@line 1321 "numbers.cpp"
            $next_phtype=$conv308; //@line 1321 "numbers.cpp"
            var $cmp309=((($conv308))|0)==1; //@line 1321 "numbers.cpp"
            if ($cmp309) { __label__ = 83;; } else { __label__ = 84;; } //@line 1321 "numbers.cpp"
            if (__label__ == 83) {
  
              var $arrayidx311=(($ph_digits+1)&4294967295); //@line 1322 "numbers.cpp"
              var $108=HEAP8[($arrayidx311)]; //@line 1322 "numbers.cpp"
              var $conv312=(tempInt=(($108)),(tempInt>=128?tempInt-256:tempInt)); //@line 1322 "numbers.cpp"
              var $arrayidx313=((_phoneme_tab+$conv312*4)&4294967295); //@line 1322 "numbers.cpp"
              var $109=HEAP32[(($arrayidx313)>>2)]; //@line 1322 "numbers.cpp"
              var $type314=(($109+11)&4294967295); //@line 1322 "numbers.cpp"
              var $110=HEAPU8[($type314)]; //@line 1322 "numbers.cpp"
              var $conv315=((($110))&255); //@line 1322 "numbers.cpp"
              $next_phtype=$conv315; //@line 1322 "numbers.cpp"
              ; //@line 1322 "numbers.cpp"
            }
  
            var $111=$ix; //@line 1324 "numbers.cpp"
            var $arrayidx317=(($ph_tens+$111)&4294967295); //@line 1324 "numbers.cpp"
            var $112=HEAP8[($arrayidx317)]; //@line 1324 "numbers.cpp"
            var $conv318=(tempInt=(($112)),(tempInt>=128?tempInt-256:tempInt)); //@line 1324 "numbers.cpp"
            var $arrayidx319=((_phoneme_tab+$conv318*4)&4294967295); //@line 1324 "numbers.cpp"
            var $113=HEAP32[(($arrayidx319)>>2)]; //@line 1324 "numbers.cpp"
            var $type320=(($113+11)&4294967295); //@line 1324 "numbers.cpp"
            var $114=HEAPU8[($type320)]; //@line 1324 "numbers.cpp"
            var $conv321=((($114))&255); //@line 1324 "numbers.cpp"
            var $cmp322=((($conv321))|0)==2; //@line 1324 "numbers.cpp"
            if (!($cmp322)) { __label__ = 87;break $if_then296$$if_end329$110; } //@line 1324 "numbers.cpp"
  
            var $115=$next_phtype; //@line 1324 "numbers.cpp"
            var $cmp324=((($115))|0)==2; //@line 1324 "numbers.cpp"
            if (!($cmp324)) { __label__ = 87;break $if_then296$$if_end329$110; } //@line 1324 "numbers.cpp"
  
            var $116=$ix; //@line 1325 "numbers.cpp"
            var $arrayidx326=(($ph_tens+$116)&4294967295); //@line 1325 "numbers.cpp"
            HEAP8[($arrayidx326)]=0; //@line 1325 "numbers.cpp"
            ; //@line 1325 "numbers.cpp"
          }
        } while(0);
  
        var $117=$ph_out_addr; //@line 1328 "numbers.cpp"
        var $arraydecay330=(($ph_tens)&4294967295); //@line 1328 "numbers.cpp"
        var $arraydecay331=(($ph_digits)&4294967295); //@line 1328 "numbers.cpp"
        var $arraydecay332=(($ph_ordinal)&4294967295); //@line 1328 "numbers.cpp"
        var $call333=_sprintf($117, ((__str6549)&4294967295), allocate([$arraydecay330,0,0,0,$arraydecay331,0,0,0,$arraydecay332,0,0,0], ["i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 1328 "numbers.cpp"
        ;
      }
    } while(0);
  
    var $118=$tr_addr; //@line 1332 "numbers.cpp"
    var $langopts336=(($118)&4294967295); //@line 1332 "numbers.cpp"
    var $numbers337=(($langopts336+184)&4294967295); //@line 1332 "numbers.cpp"
    var $119=HEAP32[(($numbers337)>>2)]; //@line 1332 "numbers.cpp"
    var $and338=($119) & 256; //@line 1332 "numbers.cpp"
    var $tobool339=((($and338))|0)!=0; //@line 1332 "numbers.cpp"
    if ($tobool339) { __label__ = 89;; } else { __label__ = 95;; } //@line 1332 "numbers.cpp"
    $if_then340$$if_end354$121: do { 
      if (__label__ == 89) {
  
        $found=0; //@line 1335 "numbers.cpp"
        var $120=$ph_out_addr; //@line 1336 "numbers.cpp"
        var $call341=_strlen($120); //@line 1336 "numbers.cpp"
        var $sub342=((($call341)-1)&4294967295); //@line 1336 "numbers.cpp"
        $ix=$sub342; //@line 1336 "numbers.cpp"
        var $cmp3439=((($sub342))|0) >= 0; //@line 1336 "numbers.cpp"
        if (!($cmp3439)) { __label__ = 95;break $if_then340$$if_end354$121; } //@line 1336 "numbers.cpp"
        while(1) { 
  
          var $121=$ix; //@line 1338 "numbers.cpp"
          var $122=$ph_out_addr; //@line 1338 "numbers.cpp"
          var $arrayidx344=(($122+$121)&4294967295); //@line 1338 "numbers.cpp"
          var $123=HEAP8[($arrayidx344)]; //@line 1338 "numbers.cpp"
          var $conv345=(tempInt=(($123)),(tempInt>=128?tempInt-256:tempInt)); //@line 1338 "numbers.cpp"
          var $cmp346=((($conv345))|0)==6; //@line 1338 "numbers.cpp"
          if ($cmp346) { __label__ = 91;; } else { __label__ = 94;; } //@line 1338 "numbers.cpp"
          if (__label__ == 91) {
  
            var $124=$found; //@line 1340 "numbers.cpp"
            var $tobool348=((($124))|0)!=0; //@line 1340 "numbers.cpp"
            if ($tobool348) { __label__ = 92;; } else { __label__ = 93;; } //@line 1340 "numbers.cpp"
            if (__label__ == 92) {
  
              var $125=$ix; //@line 1341 "numbers.cpp"
              var $126=$ph_out_addr; //@line 1341 "numbers.cpp"
              var $arrayidx350=(($126+$125)&4294967295); //@line 1341 "numbers.cpp"
              HEAP8[($arrayidx350)]=5; //@line 1341 "numbers.cpp"
              ; //@line 1341 "numbers.cpp"
            }
            else if (__label__ == 93) {
  
              $found=1; //@line 1343 "numbers.cpp"
              ;
            }
          }
  
          var $127=$ix; //@line 1336 "numbers.cpp"
          var $dec=((($127)-1)&4294967295); //@line 1336 "numbers.cpp"
          $ix=$dec; //@line 1336 "numbers.cpp"
          var $cmp343=((($dec))|0) >= 0; //@line 1336 "numbers.cpp"
          if ($cmp343) { __label__ = 90;continue ; } else { __label__ = 95;break $if_then340$$if_end354$121; } //@line 1336 "numbers.cpp"
        }
      }
    } while(0);
  
    var $128=$used_and; //@line 1347 "numbers.cpp"
    STACKTOP = __stackBase__;
    return $128; //@line 1347 "numbers.cpp"
    return null;
  }
  

  function __ZL9M_Varianti($value) {
    ;
    var __label__;
  
    var $retval;
    var $value_addr;
    $value_addr=$value;
    var $0=HEAP32[((_translator)>>2)]; //@line 963 "numbers.cpp"
    var $langopts=(($0)&4294967295); //@line 963 "numbers.cpp"
    var $numbers2=(($langopts+188)&4294967295); //@line 963 "numbers.cpp"
    var $1=HEAP32[(($numbers2)>>2)]; //@line 963 "numbers.cpp"
    var $and=($1) & 256; //@line 963 "numbers.cpp"
    var $tobool=((($and))|0)!=0; //@line 963 "numbers.cpp"
    if ($tobool) { __label__ = 1;; } else { __label__ = 3;; } //@line 963 "numbers.cpp"
    $land_lhs_true$$if_else$2: do { 
      if (__label__ == 1) {
  
        var $2=$value_addr; //@line 963 "numbers.cpp"
        var $cmp=((($2))|0) >= 2; //@line 963 "numbers.cpp"
        var $3=$value_addr; //@line 963 "numbers.cpp"
        var $cmp2=((($3))|0) <= 4; //@line 963 "numbers.cpp"
        var $or_cond=($cmp) & ($cmp2); //@line 963 "numbers.cpp"
        if (!($or_cond)) { __label__ = 3;break $land_lhs_true$$if_else$2; } //@line 963 "numbers.cpp"
  
        $retval=((__str54351)&4294967295); //@line 964 "numbers.cpp"
        __label__ = 13;break $land_lhs_true$$if_else$2; //@line 964 "numbers.cpp"
      }
    } while(0);
    $return$$if_else$5: do { 
      if (__label__ == 3) {
  
        var $4=$value_addr; //@line 966 "numbers.cpp"
        var $rem=((($4))|0)%100; //@line 966 "numbers.cpp"
        var $cmp3=((($rem))|0) < 10; //@line 966 "numbers.cpp"
        if ($cmp3) { __label__ = 5;; } else { __label__ = 4;; } //@line 966 "numbers.cpp"
        $if_then6$$lor_lhs_false$7: do { 
          if (__label__ == 4) {
  
            var $5=$value_addr; //@line 966 "numbers.cpp"
            var $rem4=((($5))|0)%100; //@line 966 "numbers.cpp"
            var $cmp5=((($rem4))|0) > 20; //@line 966 "numbers.cpp"
            if ($cmp5) { __label__ = 5;break $if_then6$$lor_lhs_false$7; } else { __label__ = 12;break $if_then6$$lor_lhs_false$7; } //@line 966 "numbers.cpp"
          }
        } while(0);
        $if_then6$$if_end28$9: do { 
          if (__label__ == 5) {
  
            var $6=HEAP32[((_translator)>>2)]; //@line 968 "numbers.cpp"
            var $langopts7=(($6)&4294967295); //@line 968 "numbers.cpp"
            var $numbers28=(($langopts7+188)&4294967295); //@line 968 "numbers.cpp"
            var $7=HEAP32[(($numbers28)>>2)]; //@line 968 "numbers.cpp"
            var $and9=($7) & 64; //@line 968 "numbers.cpp"
            var $tobool10=((($and9))|0)!=0; //@line 968 "numbers.cpp"
            if ($tobool10) { __label__ = 6;; } else { __label__ = 9;; } //@line 968 "numbers.cpp"
            $land_lhs_true11$$if_end$11: do { 
              if (__label__ == 6) {
  
                var $8=$value_addr; //@line 968 "numbers.cpp"
                var $rem12=((($8))|0)%10; //@line 968 "numbers.cpp"
                var $cmp13=((($rem12))|0) >= 2; //@line 968 "numbers.cpp"
                if (!($cmp13)) { __label__ = 9;break $land_lhs_true11$$if_end$11; } //@line 968 "numbers.cpp"
  
                var $9=$value_addr; //@line 968 "numbers.cpp"
                var $rem15=((($9))|0)%10; //@line 968 "numbers.cpp"
                var $cmp16=((($rem15))|0) <= 4; //@line 968 "numbers.cpp"
                if (!($cmp16)) { __label__ = 9;break $land_lhs_true11$$if_end$11; } //@line 968 "numbers.cpp"
  
                $retval=((__str54351)&4294967295); //@line 973 "numbers.cpp"
                __label__ = 13;break $return$$if_else$5; //@line 973 "numbers.cpp"
              }
            } while(0);
  
            var $10=HEAP32[((_translator)>>2)]; //@line 976 "numbers.cpp"
            var $langopts18=(($10)&4294967295); //@line 976 "numbers.cpp"
            var $numbers219=(($langopts18+188)&4294967295); //@line 976 "numbers.cpp"
            var $11=HEAP32[(($numbers219)>>2)]; //@line 976 "numbers.cpp"
            var $and20=($11) & 128; //@line 976 "numbers.cpp"
            var $tobool21=((($and20))|0)!=0; //@line 976 "numbers.cpp"
            if (!($tobool21)) { __label__ = 12;break $if_then6$$if_end28$9; } //@line 976 "numbers.cpp"
  
            var $12=$value_addr; //@line 976 "numbers.cpp"
            var $rem23=((($12))|0)%10; //@line 976 "numbers.cpp"
            var $cmp24=((($rem23))|0)==1; //@line 976 "numbers.cpp"
            if (!($cmp24)) { __label__ = 12;break $if_then6$$if_end28$9; } //@line 976 "numbers.cpp"
  
            $retval=((__str55352)&4294967295); //@line 979 "numbers.cpp"
            __label__ = 13;break $return$$if_else$5; //@line 979 "numbers.cpp"
          }
        } while(0);
  
        $retval=((__str56353)&4294967295); //@line 983 "numbers.cpp"
        ; //@line 983 "numbers.cpp"
      }
    } while(0);
  
    var $13=$retval; //@line 984 "numbers.cpp"
    ;
    return $13; //@line 984 "numbers.cpp"
    return null;
  }
  

  function __Z15LoadMbrolaTablePKcS0_i($mbrola_voice, $phtrans, $srate) {
    var __stackBase__  = STACKTOP; STACKTOP += 168; _memset(__stackBase__, 0, 168);
    var __label__;
  
    var $retval;
    var $mbrola_voice_addr;
    var $phtrans_addr;
    var $srate_addr;
    var $size;
    var $ix;
    var $pw;
    var $f_in;
    var $path=__stackBase__;
    $mbrola_voice_addr=$mbrola_voice;
    $phtrans_addr=$phtrans;
    $srate_addr=$srate;
    HEAP8[(((_mbrola_name)&4294967295))]=0; //@line 124 "synth_mbrola.cpp"
    HEAP32[((_mbrola_delay)>>2)]=0; //@line 125 "synth_mbrola.cpp"
    HEAP32[((__ZL15mbr_name_prefix)>>2)]=0; //@line 126 "synth_mbrola.cpp"
    var $0=$mbrola_voice_addr; //@line 128 "synth_mbrola.cpp"
    var $cmp=((($0))|0)==0; //@line 128 "synth_mbrola.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 128 "synth_mbrola.cpp"
    if (__label__ == 1) {
  
      var $1=HEAP32[((_samplerate_native)>>2)]; //@line 130 "synth_mbrola.cpp"
      HEAP32[((_samplerate)>>2)]=$1; //@line 130 "synth_mbrola.cpp"
      __Z12SetParameteriii(14, 0, 0); //@line 131 "synth_mbrola.cpp"
      $retval=0; //@line 132 "synth_mbrola.cpp"
      ; //@line 132 "synth_mbrola.cpp"
    }
    else if (__label__ == 2) {
  
      var $arraydecay=(($path)&4294967295); //@line 135 "synth_mbrola.cpp"
      var $2=$mbrola_voice_addr; //@line 135 "synth_mbrola.cpp"
      var $call=_sprintf($arraydecay, ((__str382)&4294967295), allocate([((_path_home)&4294967295),0,0,0,$2,0,0,0], ["i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 135 "synth_mbrola.cpp"
      var $arraydecay1=(($path)&4294967295); //@line 139 "synth_mbrola.cpp"
      var $call2=__Z13GetFileLengthPKc($arraydecay1); //@line 139 "synth_mbrola.cpp"
      var $cmp3=((($call2))|0) <= 0; //@line 139 "synth_mbrola.cpp"
      if ($cmp3) { __label__ = 3;; } else { __label__ = 4;; } //@line 139 "synth_mbrola.cpp"
      if (__label__ == 3) {
  
        var $arraydecay5=(($path)&4294967295); //@line 141 "synth_mbrola.cpp"
        var $3=$mbrola_voice_addr; //@line 141 "synth_mbrola.cpp"
        var $call6=_sprintf($arraydecay5, ((__str1383)&4294967295), allocate([$3,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 141 "synth_mbrola.cpp"
        ; //@line 142 "synth_mbrola.cpp"
      }
  
      var $arraydecay8=(($path)&4294967295); //@line 143 "synth_mbrola.cpp"
      var $call9=__Z13GetFileLengthPKc($arraydecay8); //@line 143 "synth_mbrola.cpp"
      var $cmp10=((($call9))|0) <= 0; //@line 143 "synth_mbrola.cpp"
      if ($cmp10) { __label__ = 5;; } else { __label__ = 6;; } //@line 143 "synth_mbrola.cpp"
      if (__label__ == 5) {
  
        var $arraydecay12=(($path)&4294967295); //@line 145 "synth_mbrola.cpp"
        var $4=$mbrola_voice_addr; //@line 145 "synth_mbrola.cpp"
        var $5=$mbrola_voice_addr; //@line 145 "synth_mbrola.cpp"
        var $call13=_sprintf($arraydecay12, ((__str2384)&4294967295), allocate([$4,0,0,0,$5,0,0,0], ["i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 145 "synth_mbrola.cpp"
        ; //@line 146 "synth_mbrola.cpp"
      }
  
      var $arraydecay15=(($path)&4294967295); //@line 147 "synth_mbrola.cpp"
      var $call16=__Z13GetFileLengthPKc($arraydecay15); //@line 147 "synth_mbrola.cpp"
      var $cmp17=((($call16))|0) <= 0; //@line 147 "synth_mbrola.cpp"
      if ($cmp17) { __label__ = 7;; } else { __label__ = 8;; } //@line 147 "synth_mbrola.cpp"
      if (__label__ == 7) {
  
        var $arraydecay19=(($path)&4294967295); //@line 149 "synth_mbrola.cpp"
        var $6=$mbrola_voice_addr; //@line 149 "synth_mbrola.cpp"
        var $call20=_sprintf($arraydecay19, ((__str3385)&4294967295), allocate([$6,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 149 "synth_mbrola.cpp"
        ; //@line 150 "synth_mbrola.cpp"
      }
  
      var $arraydecay22=(($path)&4294967295); //@line 160 "synth_mbrola.cpp"
      var $call23=_init_MBR($arraydecay22); //@line 160 "synth_mbrola.cpp"
      var $cmp24=((($call23))|0)!=0; //@line 160 "synth_mbrola.cpp"
      if ($cmp24) { __label__ = 9;; } else { __label__ = 10;; } //@line 160 "synth_mbrola.cpp"
      if (__label__ == 9) {
  
        $retval=2; //@line 161 "synth_mbrola.cpp"
        ; //@line 161 "synth_mbrola.cpp"
      }
      else if (__label__ == 10) {
  
        _setNoError_MBR(); //@line 163 "synth_mbrola.cpp"
        var $arraydecay27=(($path)&4294967295); //@line 166 "synth_mbrola.cpp"
        var $7=$phtrans_addr; //@line 166 "synth_mbrola.cpp"
        var $call28=_sprintf($arraydecay27, ((__str4386)&4294967295), allocate([((_path_home)&4294967295),0,0,0,$7,0,0,0], ["i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 166 "synth_mbrola.cpp"
        var $arraydecay29=(($path)&4294967295); //@line 167 "synth_mbrola.cpp"
        var $call30=__Z13GetFileLengthPKc($arraydecay29); //@line 167 "synth_mbrola.cpp"
        $size=$call30; //@line 167 "synth_mbrola.cpp"
        var $arraydecay31=(($path)&4294967295); //@line 168 "synth_mbrola.cpp"
        var $call32=_fopen($arraydecay31, ((__str18429)&4294967295)); //@line 168 "synth_mbrola.cpp"
        $f_in=$call32; //@line 168 "synth_mbrola.cpp"
        var $cmp33=((($call32))|0)==0; //@line 168 "synth_mbrola.cpp"
        if ($cmp33) { __label__ = 11;; } else { __label__ = 12;; } //@line 168 "synth_mbrola.cpp"
        if (__label__ == 11) {
  
          _close_MBR(); //@line 169 "synth_mbrola.cpp"
          $retval=2; //@line 170 "synth_mbrola.cpp"
          ; //@line 170 "synth_mbrola.cpp"
        }
        else if (__label__ == 12) {
  
          var $8=HEAP32[((__ZL10mbrola_tab)>>2)]; //@line 173 "synth_mbrola.cpp"
          var $9=$8; //@line 173 "synth_mbrola.cpp"
          var $10=$size; //@line 173 "synth_mbrola.cpp"
          var $call36=_realloc($9, $10); //@line 173 "synth_mbrola.cpp"
          var $11=$call36; //@line 173 "synth_mbrola.cpp"
          HEAP32[((__ZL10mbrola_tab)>>2)]=$11; //@line 173 "synth_mbrola.cpp"
          var $cmp37=((($11))|0)==0; //@line 173 "synth_mbrola.cpp"
          var $12=$f_in; //@line 175 "synth_mbrola.cpp"
          if ($cmp37) { __label__ = 13;; } else { __label__ = 14;; } //@line 173 "synth_mbrola.cpp"
          if (__label__ == 13) {
  
            var $call39=_fclose($12); //@line 175 "synth_mbrola.cpp"
            _close_MBR(); //@line 176 "synth_mbrola.cpp"
            $retval=-1; //@line 177 "synth_mbrola.cpp"
            ; //@line 177 "synth_mbrola.cpp"
          }
          else if (__label__ == 14) {
  
            var $call41=__Z10Read4BytesP7__sFILE($12); //@line 180 "synth_mbrola.cpp"
            HEAP32[((__ZL14mbrola_control)>>2)]=$call41; //@line 180 "synth_mbrola.cpp"
            var $13=HEAP32[((__ZL10mbrola_tab)>>2)]; //@line 181 "synth_mbrola.cpp"
            var $14=$13; //@line 181 "synth_mbrola.cpp"
            $pw=$14; //@line 181 "synth_mbrola.cpp"
            $ix=4; //@line 182 "synth_mbrola.cpp"
            var $15=$ix; //@line 182 "synth_mbrola.cpp"
            var $16=$size; //@line 182 "synth_mbrola.cpp"
            var $cmp421=((($15))|0) < ((($16))|0); //@line 182 "synth_mbrola.cpp"
            if ($cmp421) { __label__ = 15;; } else { __label__ = 16;; } //@line 182 "synth_mbrola.cpp"
            $for_body$$for_end$23: do { 
              if (__label__ == 15) {
                while(1) { 
  
                  var $17=$f_in; //@line 184 "synth_mbrola.cpp"
                  var $call43=__Z10Read4BytesP7__sFILE($17); //@line 184 "synth_mbrola.cpp"
                  var $18=$pw; //@line 184 "synth_mbrola.cpp"
                  var $incdec_ptr=(($18+4)&4294967295); //@line 184 "synth_mbrola.cpp"
                  $pw=$incdec_ptr; //@line 184 "synth_mbrola.cpp"
                  HEAP32[(($18)>>2)]=$call43; //@line 184 "synth_mbrola.cpp"
                  var $19=$ix; //@line 182 "synth_mbrola.cpp"
                  var $add=((($19)+4)&4294967295); //@line 182 "synth_mbrola.cpp"
                  $ix=$add; //@line 182 "synth_mbrola.cpp"
                  var $20=$ix; //@line 182 "synth_mbrola.cpp"
                  var $21=$size; //@line 182 "synth_mbrola.cpp"
                  var $cmp42=((($20))|0) < ((($21))|0); //@line 182 "synth_mbrola.cpp"
                  if ($cmp42) { __label__ = 15;continue ; } else { __label__ = 16;break $for_body$$for_end$23; } //@line 182 "synth_mbrola.cpp"
                }
              }
            } while(0);
  
            var $22=HEAP32[((__ZL10mbrola_tab)>>2)]; //@line 186 "synth_mbrola.cpp"
            var $23=$22; //@line 186 "synth_mbrola.cpp"
            var $24=$size; //@line 186 "synth_mbrola.cpp"
            var $25=$f_in; //@line 186 "synth_mbrola.cpp"
            var $call44=_fread($23, 1, $24, $25); //@line 186 "synth_mbrola.cpp"
            $size=$call44; //@line 186 "synth_mbrola.cpp"
            var $26=$f_in; //@line 187 "synth_mbrola.cpp"
            var $call45=_fclose($26); //@line 187 "synth_mbrola.cpp"
            var $27=HEAP32[((__ZL14mbrola_control)>>2)]; //@line 189 "synth_mbrola.cpp"
            var $and=($27) & 255; //@line 189 "synth_mbrola.cpp"
            var $conv=((($and))|0); //@line 189 "synth_mbrola.cpp"
            var $div=($conv)/16; //@line 189 "synth_mbrola.cpp"
            _setVolumeRatio_MBR($div); //@line 189 "synth_mbrola.cpp"
            var $28=$srate_addr; //@line 191 "synth_mbrola.cpp"
            HEAP32[((_samplerate)>>2)]=$28; //@line 191 "synth_mbrola.cpp"
            var $cmp46=((($28))|0)==22050; //@line 192 "synth_mbrola.cpp"
            if ($cmp46) { __label__ = 17;; } else { __label__ = 18;; } //@line 192 "synth_mbrola.cpp"
            if (__label__ == 17) {
  
              __Z12SetParameteriii(14, 0, 0); //@line 193 "synth_mbrola.cpp"
              ; //@line 193 "synth_mbrola.cpp"
            }
            else if (__label__ == 18) {
  
              __Z12SetParameteriii(14, 1, 0); //@line 195 "synth_mbrola.cpp"
              ;
            }
  
            var $29=$mbrola_voice_addr; //@line 196 "synth_mbrola.cpp"
            var $call49=_strcpy(((_mbrola_name)&4294967295), $29); //@line 196 "synth_mbrola.cpp"
            HEAP32[((_mbrola_delay)>>2)]=1000; //@line 198 "synth_mbrola.cpp"
            $retval=0; //@line 199 "synth_mbrola.cpp"
            ; //@line 199 "synth_mbrola.cpp"
          }
        }
      }
    }
  
    var $30=$retval; //@line 200 "synth_mbrola.cpp"
    STACKTOP = __stackBase__;
    return $30; //@line 200 "synth_mbrola.cpp"
    return null;
  }
  

  function _setNoError_MBR() {
    ;
    var __label__;
  
    ;
    return; //@line 102 "./mbrowrap.h"
    return;
  }
  

  function __Z15MbrolaTranslateP12PHONEME_LISTiiP7__sFILE($plist, $n_phonemes, $resume, $f_mbrola) {
    var __stackBase__  = STACKTOP; STACKTOP += 332; _memset(__stackBase__, 0, 332);
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $plist_addr;
    var $n_phonemes_addr;
    var $resume_addr;
    var $f_mbrola_addr;
    var $name;
    var $len;
    var $len1;
    var $ph;
    var $ph_next;
    var $ph_prev;
    var $p;
    var $next;
    var $prev;
    var $phdata=__stackBase__;
    var $fmtp=__stackBase__+152;
    var $pause;
    var $released;
    var $name2=__stackBase__+200;
    var $control=__stackBase__+204;
    var $done;
    var $len_percent=__stackBase__+208;
    var $final_pitch;
    var $ptr;
    var $mbr_buf=__stackBase__+212;
    var $pitch;
    var $pitch101;
    var $res;
    $plist_addr=$plist;
    $n_phonemes_addr=$n_phonemes;
    $resume_addr=$resume;
    $f_mbrola_addr=$f_mbrola;
    $pause=0; //@line 416 "synth_mbrola.cpp"
    var $0=$resume_addr; //@line 430 "synth_mbrola.cpp"
    var $tobool=((($0))|0)!=0; //@line 430 "synth_mbrola.cpp"
    if ($tobool) { __label__ = 2;; } else { __label__ = 1;; } //@line 430 "synth_mbrola.cpp"
    if (__label__ == 1) {
  
      HEAP32[((__ZZ15MbrolaTranslateP12PHONEME_LISTiiP7__sFILEE4phix)>>2)]=1; //@line 431 "synth_mbrola.cpp"
      HEAP32[((__ZZ15MbrolaTranslateP12PHONEME_LISTiiP7__sFILEE11embedded_ix)>>2)]=0; //@line 432 "synth_mbrola.cpp"
      HEAP32[((__ZZ15MbrolaTranslateP12PHONEME_LISTiiP7__sFILEE10word_count)>>2)]=0; //@line 433 "synth_mbrola.cpp"
      ; //@line 434 "synth_mbrola.cpp"
    }
  
    var $arraydecay=(($mbr_buf)&4294967295); //@line 441 "synth_mbrola.cpp"
    var $arraydecay233=(($mbr_buf)&4294967295); //@line 597 "synth_mbrola.cpp"
    var $arraydecay234=(($mbr_buf)&4294967295); //@line 597 "synth_mbrola.cpp"
    var $sub_ptr_rhs_cast=($arraydecay234); //@line 597 "synth_mbrola.cpp"
    var $1=$fmtp; //@line 556 "synth_mbrola.cpp"
    var $sound_addr=(($phdata+68)&4294967295); //@line 558 "synth_mbrola.cpp"
    var $arrayidx176=(($sound_addr)&4294967295); //@line 558 "synth_mbrola.cpp"
    var $fmt_addr=(($fmtp+8)&4294967295); //@line 558 "synth_mbrola.cpp"
    ; //@line 436 "synth_mbrola.cpp"
    $while_cond$5: while(1) { 
  
      var $2=HEAP32[((__ZZ15MbrolaTranslateP12PHONEME_LISTiiP7__sFILEE4phix)>>2)]; //@line 436 "synth_mbrola.cpp"
      var $3=$n_phonemes_addr; //@line 436 "synth_mbrola.cpp"
      var $cmp=((($2))|0) < ((($3))|0); //@line 436 "synth_mbrola.cpp"
      if (!($cmp)) { __label__ = 64;break $while_cond$5; } //@line 436 "synth_mbrola.cpp"
  
      var $call=__Z9WcmdqFreev(); //@line 438 "synth_mbrola.cpp"
      var $cmp1=((($call))|0) < 22; //@line 438 "synth_mbrola.cpp"
      if ($cmp1) { __label__ = 5;break $while_cond$5; } //@line 438 "synth_mbrola.cpp"
  
      $ptr=$arraydecay; //@line 441 "synth_mbrola.cpp"
      var $4=HEAP32[((__ZZ15MbrolaTranslateP12PHONEME_LISTiiP7__sFILEE4phix)>>2)]; //@line 443 "synth_mbrola.cpp"
      var $5=$plist_addr; //@line 443 "synth_mbrola.cpp"
      var $arrayidx=(($5+24*$4)&4294967295); //@line 443 "synth_mbrola.cpp"
      $p=$arrayidx; //@line 443 "synth_mbrola.cpp"
      var $6=HEAP32[((__ZZ15MbrolaTranslateP12PHONEME_LISTiiP7__sFILEE4phix)>>2)]; //@line 444 "synth_mbrola.cpp"
      var $add=((($6)+1)&4294967295); //@line 444 "synth_mbrola.cpp"
      var $7=$plist_addr; //@line 444 "synth_mbrola.cpp"
      var $arrayidx4=(($7+24*$add)&4294967295); //@line 444 "synth_mbrola.cpp"
      $next=$arrayidx4; //@line 444 "synth_mbrola.cpp"
      var $8=HEAP32[((__ZZ15MbrolaTranslateP12PHONEME_LISTiiP7__sFILEE4phix)>>2)]; //@line 445 "synth_mbrola.cpp"
      var $sub=((($8)-1)&4294967295); //@line 445 "synth_mbrola.cpp"
      var $9=$plist_addr; //@line 445 "synth_mbrola.cpp"
      var $arrayidx5=(($9+24*$sub)&4294967295); //@line 445 "synth_mbrola.cpp"
      $prev=$arrayidx5; //@line 445 "synth_mbrola.cpp"
      var $10=$p; //@line 446 "synth_mbrola.cpp"
      var $ph6=(($10+8)&4294967295); //@line 446 "synth_mbrola.cpp"
      var $11=HEAP32[(($ph6)>>2)]; //@line 446 "synth_mbrola.cpp"
      $ph=$11; //@line 446 "synth_mbrola.cpp"
      var $12=HEAP32[((__ZZ15MbrolaTranslateP12PHONEME_LISTiiP7__sFILEE4phix)>>2)]; //@line 447 "synth_mbrola.cpp"
      var $sub7=((($12)-1)&4294967295); //@line 447 "synth_mbrola.cpp"
      var $13=$plist_addr; //@line 447 "synth_mbrola.cpp"
      var $arrayidx8=(($13+24*$sub7)&4294967295); //@line 447 "synth_mbrola.cpp"
      var $ph9=(($arrayidx8+8)&4294967295); //@line 447 "synth_mbrola.cpp"
      var $14=HEAP32[(($ph9)>>2)]; //@line 447 "synth_mbrola.cpp"
      $ph_prev=$14; //@line 447 "synth_mbrola.cpp"
      var $15=HEAP32[((__ZZ15MbrolaTranslateP12PHONEME_LISTiiP7__sFILEE4phix)>>2)]; //@line 448 "synth_mbrola.cpp"
      var $add10=((($15)+1)&4294967295); //@line 448 "synth_mbrola.cpp"
      var $16=$plist_addr; //@line 448 "synth_mbrola.cpp"
      var $arrayidx11=(($16+24*$add10)&4294967295); //@line 448 "synth_mbrola.cpp"
      var $ph12=(($arrayidx11+8)&4294967295); //@line 448 "synth_mbrola.cpp"
      var $17=HEAP32[(($ph12)>>2)]; //@line 448 "synth_mbrola.cpp"
      $ph_next=$17; //@line 448 "synth_mbrola.cpp"
      var $18=$p; //@line 450 "synth_mbrola.cpp"
      var $synthflags=(($18+4)&4294967295); //@line 450 "synth_mbrola.cpp"
      var $19=HEAPU16[(($synthflags)>>1)]; //@line 450 "synth_mbrola.cpp"
      var $conv=((($19))&65535); //@line 450 "synth_mbrola.cpp"
      var $and=($conv) & 2; //@line 450 "synth_mbrola.cpp"
      var $tobool13=((($and))|0)!=0; //@line 450 "synth_mbrola.cpp"
      if ($tobool13) { __label__ = 7;; } else { __label__ = 8;; } //@line 450 "synth_mbrola.cpp"
      if (__label__ == 7) {
  
        var $20=$p; //@line 452 "synth_mbrola.cpp"
        var $sourceix=(($20+6)&4294967295); //@line 452 "synth_mbrola.cpp"
        var $21=HEAPU16[(($sourceix)>>1)]; //@line 452 "synth_mbrola.cpp"
        var $conv15=((($21))&65535); //@line 452 "synth_mbrola.cpp"
        __Z10DoEmbeddedPii(__ZZ15MbrolaTranslateP12PHONEME_LISTiiP7__sFILEE11embedded_ix, $conv15); //@line 452 "synth_mbrola.cpp"
        ; //@line 453 "synth_mbrola.cpp"
      }
  
      var $22=$p; //@line 455 "synth_mbrola.cpp"
      var $newword=(($22+19)&4294967295); //@line 455 "synth_mbrola.cpp"
      var $23=HEAPU8[($newword)]; //@line 455 "synth_mbrola.cpp"
      var $conv17=((($23))&255); //@line 455 "synth_mbrola.cpp"
      var $and18=($conv17) & 4; //@line 455 "synth_mbrola.cpp"
      var $tobool19=((($and18))|0)!=0; //@line 455 "synth_mbrola.cpp"
      if ($tobool19) { __label__ = 9;; } else { __label__ = 10;; } //@line 455 "synth_mbrola.cpp"
      if (__label__ == 9) {
  
        var $24=$p; //@line 456 "synth_mbrola.cpp"
        var $sourceix21=(($24+6)&4294967295); //@line 456 "synth_mbrola.cpp"
        var $25=HEAPU16[(($sourceix21)>>1)]; //@line 456 "synth_mbrola.cpp"
        var $conv22=((($25))&65535); //@line 456 "synth_mbrola.cpp"
        var $and23=($conv22) & 2047; //@line 456 "synth_mbrola.cpp"
        var $26=HEAP32[((_clause_start_char)>>2)]; //@line 456 "synth_mbrola.cpp"
        var $add24=((($and23)+($26))&4294967295); //@line 456 "synth_mbrola.cpp"
        var $27=HEAP32[((_count_sentences)>>2)]; //@line 456 "synth_mbrola.cpp"
        __Z8DoMarkeriiii(2, $add24, 0, $27); //@line 456 "synth_mbrola.cpp"
        ; //@line 456 "synth_mbrola.cpp"
      }
  
      var $28=$p; //@line 457 "synth_mbrola.cpp"
      var $newword26=(($28+19)&4294967295); //@line 457 "synth_mbrola.cpp"
      var $29=HEAPU8[($newword26)]; //@line 457 "synth_mbrola.cpp"
      var $conv27=((($29))&255); //@line 457 "synth_mbrola.cpp"
      var $and28=($conv27) & 1; //@line 457 "synth_mbrola.cpp"
      var $tobool29=((($and28))|0)!=0; //@line 457 "synth_mbrola.cpp"
      if ($tobool29) { __label__ = 11;; } else { __label__ = 12;; } //@line 457 "synth_mbrola.cpp"
      if (__label__ == 11) {
  
        var $30=$p; //@line 458 "synth_mbrola.cpp"
        var $sourceix31=(($30+6)&4294967295); //@line 458 "synth_mbrola.cpp"
        var $31=HEAPU16[(($sourceix31)>>1)]; //@line 458 "synth_mbrola.cpp"
        var $conv32=((($31))&65535); //@line 458 "synth_mbrola.cpp"
        var $and33=($conv32) & 2047; //@line 458 "synth_mbrola.cpp"
        var $32=HEAP32[((_clause_start_char)>>2)]; //@line 458 "synth_mbrola.cpp"
        var $add34=((($and33)+($32))&4294967295); //@line 458 "synth_mbrola.cpp"
        var $33=$p; //@line 458 "synth_mbrola.cpp"
        var $sourceix35=(($33+6)&4294967295); //@line 458 "synth_mbrola.cpp"
        var $34=HEAPU16[(($sourceix35)>>1)]; //@line 458 "synth_mbrola.cpp"
        var $conv36=((($34))&65535); //@line 458 "synth_mbrola.cpp"
        var $shr=($conv36) >> 11; //@line 458 "synth_mbrola.cpp"
        var $35=HEAP32[((_clause_start_word)>>2)]; //@line 458 "synth_mbrola.cpp"
        var $36=HEAPU32[((__ZZ15MbrolaTranslateP12PHONEME_LISTiiP7__sFILEE10word_count)>>2)]; //@line 458 "synth_mbrola.cpp"
        var $inc=((($36)+1)&4294967295); //@line 458 "synth_mbrola.cpp"
        HEAP32[((__ZZ15MbrolaTranslateP12PHONEME_LISTiiP7__sFILEE10word_count)>>2)]=$inc; //@line 458 "synth_mbrola.cpp"
        var $add37=((($36)+($35))&4294967295); //@line 458 "synth_mbrola.cpp"
        __Z8DoMarkeriiii(1, $add34, $shr, $add37); //@line 458 "synth_mbrola.cpp"
        ; //@line 458 "synth_mbrola.cpp"
      }
  
      var $37=$p; //@line 460 "synth_mbrola.cpp"
      var $38=$ph; //@line 460 "synth_mbrola.cpp"
      var $39=$ph_prev; //@line 460 "synth_mbrola.cpp"
      var $40=$ph_next; //@line 460 "synth_mbrola.cpp"
      var $call39=__ZL10GetMbrNameP12PHONEME_LISTP11PHONEME_TABS2_S2_PiS3_S3_($37, $38, $39, $40, $name2, $len_percent, $control); //@line 460 "synth_mbrola.cpp"
      $name=$call39; //@line 460 "synth_mbrola.cpp"
      var $41=HEAP32[(($control)>>2)]; //@line 461 "synth_mbrola.cpp"
      var $and40=($41) & 1; //@line 461 "synth_mbrola.cpp"
      var $tobool41=((($and40))|0)!=0; //@line 461 "synth_mbrola.cpp"
      if ($tobool41) { __lastLabel__ = 12; __label__ = 13;; } else { __lastLabel__ = 12; __label__ = 14;; } //@line 461 "synth_mbrola.cpp"
      if (__label__ == 13) {
  
        var $42=HEAP32[((__ZZ15MbrolaTranslateP12PHONEME_LISTiiP7__sFILEE4phix)>>2)]; //@line 462 "synth_mbrola.cpp"
        var $inc43=((($42)+1)&4294967295); //@line 462 "synth_mbrola.cpp"
        HEAP32[((__ZZ15MbrolaTranslateP12PHONEME_LISTiiP7__sFILEE4phix)>>2)]=$inc43; //@line 462 "synth_mbrola.cpp"
        var $_pr=$name; //@line 464 "synth_mbrola.cpp"
        __lastLabel__ = 13; ; //@line 462 "synth_mbrola.cpp"
      }
  
      var $43=__lastLabel__ == 13 ? $_pr : ($call39); //@line 464 "synth_mbrola.cpp"
      var $cmp45=((($43))|0)==0; //@line 464 "synth_mbrola.cpp"
      if ($cmp45) { __label__ = 15;; } else { __label__ = 16;; } //@line 464 "synth_mbrola.cpp"
      if (__label__ == 15) {
  
        var $44=HEAP32[((__ZZ15MbrolaTranslateP12PHONEME_LISTiiP7__sFILEE4phix)>>2)]; //@line 465 "synth_mbrola.cpp"
        var $inc47=((($44)+1)&4294967295); //@line 465 "synth_mbrola.cpp"
        HEAP32[((__ZZ15MbrolaTranslateP12PHONEME_LISTiiP7__sFILEE4phix)>>2)]=$inc47; //@line 465 "synth_mbrola.cpp"
        __label__ = 3;continue $while_cond$5; //@line 466 "synth_mbrola.cpp"
      }
      else if (__label__ == 16) {
  
        var $45=$ph; //@line 469 "synth_mbrola.cpp"
        var $type=(($45+11)&4294967295); //@line 469 "synth_mbrola.cpp"
        var $46=HEAPU8[($type)]; //@line 469 "synth_mbrola.cpp"
        var $conv49=((($46))&255); //@line 469 "synth_mbrola.cpp"
        var $cmp50=((($conv49))|0)==0; //@line 469 "synth_mbrola.cpp"
        if ($cmp50) { __label__ = 17;; } else { __label__ = 20;; } //@line 469 "synth_mbrola.cpp"
        $land_lhs_true$$if_else$24: do { 
          if (__label__ == 17) {
  
            var $47=$name; //@line 469 "synth_mbrola.cpp"
            var $48=$ph; //@line 469 "synth_mbrola.cpp"
            var $mnemonic=(($48)&4294967295); //@line 469 "synth_mbrola.cpp"
            var $49=HEAP32[(($mnemonic)>>2)]; //@line 469 "synth_mbrola.cpp"
            var $cmp51=((($47))|0)==((($49))|0); //@line 469 "synth_mbrola.cpp"
            if (!($cmp51)) { __label__ = 20;break $land_lhs_true$$if_else$24; } //@line 469 "synth_mbrola.cpp"
  
            $name=95; //@line 472 "synth_mbrola.cpp"
            var $50=$p; //@line 473 "synth_mbrola.cpp"
            var $length=(($50+12)&4294967295); //@line 473 "synth_mbrola.cpp"
            var $51=HEAP16[(($length)>>1)]; //@line 473 "synth_mbrola.cpp"
            var $conv53=(tempInt=(($51)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 473 "synth_mbrola.cpp"
            var $52=HEAP32[((((_speed)&4294967295))>>2)]; //@line 473 "synth_mbrola.cpp"
            var $mul=((($conv53)*($52))&4294967295); //@line 473 "synth_mbrola.cpp"
            var $div=((((($mul))|0)/256)|0); //@line 473 "synth_mbrola.cpp"
            $len=$div; //@line 473 "synth_mbrola.cpp"
            var $53=$len; //@line 475 "synth_mbrola.cpp"
            var $cmp54=((($53))|0)==0; //@line 475 "synth_mbrola.cpp"
            if (!($cmp54)) { __label__ = 21;break $land_lhs_true$$if_else$24; } //@line 475 "synth_mbrola.cpp"
  
            $len=1; //@line 476 "synth_mbrola.cpp"
            __label__ = 21;break $land_lhs_true$$if_else$24; //@line 476 "synth_mbrola.cpp"
          }
        } while(0);
        if (__label__ == 20) {
  
          var $54=HEAP32[((((_speed+12)&4294967295))>>2)]; //@line 479 "synth_mbrola.cpp"
          var $mul57=((($54)*80)&4294967295); //@line 479 "synth_mbrola.cpp"
          var $div58=((((($mul57))|0)/256)|0); //@line 479 "synth_mbrola.cpp"
          $len=$div58; //@line 479 "synth_mbrola.cpp"
          ;
        }
  
        var $55=$p; //@line 481 "synth_mbrola.cpp"
        var $sourceix60=(($55+6)&4294967295); //@line 481 "synth_mbrola.cpp"
        var $56=HEAPU16[(($sourceix60)>>1)]; //@line 481 "synth_mbrola.cpp"
        var $conv61=((($56))&65535); //@line 481 "synth_mbrola.cpp"
        var $and62=($conv61) & 2047; //@line 481 "synth_mbrola.cpp"
        var $57=HEAP32[((_clause_start_char)>>2)]; //@line 481 "synth_mbrola.cpp"
        var $add63=((($and62)+($57))&4294967295); //@line 481 "synth_mbrola.cpp"
        var $58=$ph; //@line 481 "synth_mbrola.cpp"
        var $mnemonic64=(($58)&4294967295); //@line 481 "synth_mbrola.cpp"
        var $59=HEAP32[(($mnemonic64)>>2)]; //@line 481 "synth_mbrola.cpp"
        __Z8DoMarkeriiii(7, $add63, 0, $59); //@line 481 "synth_mbrola.cpp"
        var $60=$ptr; //@line 483 "synth_mbrola.cpp"
        var $61=$name; //@line 483 "synth_mbrola.cpp"
        var $call65=__Z12WordToStringj($61); //@line 483 "synth_mbrola.cpp"
        var $call66=_sprintf($60, ((__str6388)&4294967295), allocate([((__ZZ12WordToStringjE3buf)&4294967295),0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 483 "synth_mbrola.cpp"
        var $62=$ptr; //@line 483 "synth_mbrola.cpp"
        var $add_ptr=(($62+$call66)&4294967295); //@line 483 "synth_mbrola.cpp"
        $ptr=$add_ptr; //@line 483 "synth_mbrola.cpp"
        var $63=HEAP32[(($name2)>>2)]; //@line 485 "synth_mbrola.cpp"
        var $cmp67=((($63))|0)==95; //@line 485 "synth_mbrola.cpp"
        if ($cmp67) { __label__ = 22;; } else { __label__ = 23;; } //@line 485 "synth_mbrola.cpp"
        if (__label__ == 22) {
  
          var $64=HEAP32[(($len_percent)>>2)]; //@line 488 "synth_mbrola.cpp"
          $pause=$64; //@line 488 "synth_mbrola.cpp"
          HEAP32[(($name2)>>2)]=0; //@line 489 "synth_mbrola.cpp"
          ; //@line 490 "synth_mbrola.cpp"
        }
  
        $done=0; //@line 492 "synth_mbrola.cpp"
        $final_pitch=((__str13643)&4294967295); //@line 493 "synth_mbrola.cpp"
        var $65=$ph; //@line 495 "synth_mbrola.cpp"
        var $type70=(($65+11)&4294967295); //@line 495 "synth_mbrola.cpp"
        var $66=HEAPU8[($type70)]; //@line 495 "synth_mbrola.cpp"
        var $conv71=((($66))&255); //@line 495 "synth_mbrola.cpp"
        if ($conv71 == 2) {
          __label__ = 24;;
        }
        else if ($conv71 == 4) {
          __label__ = 32;;
        }
        else if ($conv71 == 5) {
          __label__ = 40;;
        }
        else if ($conv71 == 6) {
          __label__ = 41;;
        }
        else if ($conv71 == 8) {
          __label__ = 44;;
        }
        else if ($conv71 == 3) {
          __label__ = 48;;
        }
        else {
        __label__ = 50;;
        }
        
        $sw_epilog$$sw_bb$$sw_bb126$$sw_bb152$$sw_bb155$$sw_bb171$$sw_bb195$34: do { 
          if (__label__ == 24) {
  
            var $67=$ph; //@line 498 "synth_mbrola.cpp"
            var $std_length=(($67+14)&4294967295); //@line 498 "synth_mbrola.cpp"
            var $68=HEAPU8[($std_length)]; //@line 498 "synth_mbrola.cpp"
            var $conv72=((($68))&255); //@line 498 "synth_mbrola.cpp"
            $len=$conv72; //@line 498 "synth_mbrola.cpp"
            var $69=$p; //@line 499 "synth_mbrola.cpp"
            var $synthflags73=(($69+4)&4294967295); //@line 499 "synth_mbrola.cpp"
            var $70=HEAPU16[(($synthflags73)>>1)]; //@line 499 "synth_mbrola.cpp"
            var $conv74=((($70))&65535); //@line 499 "synth_mbrola.cpp"
            var $and75=($conv74) & 8; //@line 499 "synth_mbrola.cpp"
            var $tobool76=((($and75))|0)!=0; //@line 499 "synth_mbrola.cpp"
            if ($tobool76) { __label__ = 25;; } else { __label__ = 26;; } //@line 499 "synth_mbrola.cpp"
            if (__label__ == 25) {
  
              var $71=HEAP32[((((_phoneme_tab+48)&4294967295))>>2)]; //@line 500 "synth_mbrola.cpp"
              var $std_length78=(($71+14)&4294967295); //@line 500 "synth_mbrola.cpp"
              var $72=HEAPU8[($std_length78)]; //@line 500 "synth_mbrola.cpp"
              var $conv79=((($72))&255); //@line 500 "synth_mbrola.cpp"
              var $73=$len; //@line 500 "synth_mbrola.cpp"
              var $add80=((($73)+($conv79))&4294967295); //@line 500 "synth_mbrola.cpp"
              $len=$add80; //@line 500 "synth_mbrola.cpp"
              ; //@line 500 "synth_mbrola.cpp"
            }
  
            var $74=$ph_next; //@line 502 "synth_mbrola.cpp"
            var $type82=(($74+11)&4294967295); //@line 502 "synth_mbrola.cpp"
            var $75=HEAPU8[($type82)]; //@line 502 "synth_mbrola.cpp"
            var $conv83=((($75))&255); //@line 502 "synth_mbrola.cpp"
            var $cmp84=((($conv83))|0)==0; //@line 502 "synth_mbrola.cpp"
            if ($cmp84) { __label__ = 27;; } else { __label__ = 28;; } //@line 502 "synth_mbrola.cpp"
            if (__label__ == 27) {
  
              var $76=$len; //@line 503 "synth_mbrola.cpp"
              var $add86=((($76)+50)&4294967295); //@line 503 "synth_mbrola.cpp"
              $len=$add86; //@line 503 "synth_mbrola.cpp"
              ; //@line 503 "synth_mbrola.cpp"
            }
  
            var $77=$len; //@line 504 "synth_mbrola.cpp"
            var $78=$p; //@line 504 "synth_mbrola.cpp"
            var $length88=(($78+12)&4294967295); //@line 504 "synth_mbrola.cpp"
            var $79=HEAP16[(($length88)>>1)]; //@line 504 "synth_mbrola.cpp"
            var $conv89=(tempInt=(($79)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 504 "synth_mbrola.cpp"
            var $mul90=((($conv89)*($77))&4294967295); //@line 504 "synth_mbrola.cpp"
            var $div91=((((($mul90))|0)/256)|0); //@line 504 "synth_mbrola.cpp"
            $len=$div91; //@line 504 "synth_mbrola.cpp"
            var $80=HEAP32[(($name2)>>2)]; //@line 506 "synth_mbrola.cpp"
            var $cmp92=((($80))|0)==0; //@line 506 "synth_mbrola.cpp"
            var $81=$p; //@line 508 "synth_mbrola.cpp"
            var $env=(($81+14)&4294967295); //@line 508 "synth_mbrola.cpp"
            var $82=HEAPU8[($env)]; //@line 508 "synth_mbrola.cpp"
            var $conv94=((($82))&255); //@line 508 "synth_mbrola.cpp"
            var $83=$p; //@line 508 "synth_mbrola.cpp"
            var $pitch1=(($83+20)&4294967295); //@line 508 "synth_mbrola.cpp"
            var $84=HEAPU8[($pitch1)]; //@line 508 "synth_mbrola.cpp"
            var $conv95=((($84))&255); //@line 508 "synth_mbrola.cpp"
            var $85=$p; //@line 508 "synth_mbrola.cpp"
            var $pitch2=(($85+21)&4294967295); //@line 508 "synth_mbrola.cpp"
            var $86=HEAPU8[($pitch2)]; //@line 508 "synth_mbrola.cpp"
            var $conv96=((($86))&255); //@line 508 "synth_mbrola.cpp"
            if ($cmp92) { __label__ = 29;; } else { __label__ = 30;; } //@line 506 "synth_mbrola.cpp"
            if (__label__ == 29) {
  
              __ZL10WritePitchiiiii($conv94, $conv95, $conv96, 0, 0); //@line 508 "synth_mbrola.cpp"
              $pitch=((__ZZL10WritePitchiiiiiE6output)&4294967295); //@line 508 "synth_mbrola.cpp"
              var $87=$ptr; //@line 509 "synth_mbrola.cpp"
              var $88=$len; //@line 509 "synth_mbrola.cpp"
              var $89=$pitch; //@line 509 "synth_mbrola.cpp"
              var $call98=_sprintf($87, ((__str8390)&4294967295), allocate([$88,0,0,0,$89,0,0,0], ["i32",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 509 "synth_mbrola.cpp"
              var $90=$ptr; //@line 509 "synth_mbrola.cpp"
              var $add_ptr99=(($90+$call98)&4294967295); //@line 509 "synth_mbrola.cpp"
              $ptr=$add_ptr99; //@line 509 "synth_mbrola.cpp"
              ; //@line 510 "synth_mbrola.cpp"
            }
            else if (__label__ == 30) {
  
              var $91=HEAP32[(($len_percent)>>2)]; //@line 515 "synth_mbrola.cpp"
              __ZL10WritePitchiiiii($conv94, $conv95, $conv96, $91, 0); //@line 515 "synth_mbrola.cpp"
              $pitch101=((__ZZL10WritePitchiiiiiE6output)&4294967295); //@line 515 "synth_mbrola.cpp"
              var $92=$len; //@line 516 "synth_mbrola.cpp"
              var $93=HEAP32[(($len_percent)>>2)]; //@line 516 "synth_mbrola.cpp"
              var $mul109=((($93)*($92))&4294967295); //@line 516 "synth_mbrola.cpp"
              var $div110=((((($mul109))|0)/100)|0); //@line 516 "synth_mbrola.cpp"
              $len1=$div110; //@line 516 "synth_mbrola.cpp"
              var $94=$ptr; //@line 517 "synth_mbrola.cpp"
              var $95=$len1; //@line 517 "synth_mbrola.cpp"
              var $96=$pitch101; //@line 517 "synth_mbrola.cpp"
              var $call111=_sprintf($94, ((__str8390)&4294967295), allocate([$95,0,0,0,$96,0,0,0], ["i32",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 517 "synth_mbrola.cpp"
              var $97=$ptr; //@line 517 "synth_mbrola.cpp"
              var $add_ptr112=(($97+$call111)&4294967295); //@line 517 "synth_mbrola.cpp"
              $ptr=$add_ptr112; //@line 517 "synth_mbrola.cpp"
              var $98=$p; //@line 519 "synth_mbrola.cpp"
              var $env113=(($98+14)&4294967295); //@line 519 "synth_mbrola.cpp"
              var $99=HEAPU8[($env113)]; //@line 519 "synth_mbrola.cpp"
              var $conv114=((($99))&255); //@line 519 "synth_mbrola.cpp"
              var $100=$p; //@line 519 "synth_mbrola.cpp"
              var $pitch1115=(($100+20)&4294967295); //@line 519 "synth_mbrola.cpp"
              var $101=HEAPU8[($pitch1115)]; //@line 519 "synth_mbrola.cpp"
              var $conv116=((($101))&255); //@line 519 "synth_mbrola.cpp"
              var $102=$p; //@line 519 "synth_mbrola.cpp"
              var $pitch2117=(($102+21)&4294967295); //@line 519 "synth_mbrola.cpp"
              var $103=HEAPU8[($pitch2117)]; //@line 519 "synth_mbrola.cpp"
              var $conv118=((($103))&255); //@line 519 "synth_mbrola.cpp"
              var $104=HEAP32[(($len_percent)>>2)]; //@line 519 "synth_mbrola.cpp"
              var $sub119=(((-($104)))&4294967295); //@line 519 "synth_mbrola.cpp"
              __ZL10WritePitchiiiii($conv114, $conv116, $conv118, $sub119, 0); //@line 519 "synth_mbrola.cpp"
              $pitch101=((__ZZL10WritePitchiiiiiE6output)&4294967295); //@line 519 "synth_mbrola.cpp"
              var $105=$ptr; //@line 520 "synth_mbrola.cpp"
              var $106=HEAP32[(($name2)>>2)]; //@line 520 "synth_mbrola.cpp"
              var $call121=__Z12WordToStringj($106); //@line 520 "synth_mbrola.cpp"
              var $107=$len; //@line 520 "synth_mbrola.cpp"
              var $108=$len1; //@line 520 "synth_mbrola.cpp"
              var $sub122=((($107)-($108))&4294967295); //@line 520 "synth_mbrola.cpp"
              var $109=$pitch101; //@line 520 "synth_mbrola.cpp"
              var $call123=_sprintf($105, ((__str9391)&4294967295), allocate([((__ZZ12WordToStringjE3buf)&4294967295),0,0,0,$sub122,0,0,0,$109,0,0,0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 520 "synth_mbrola.cpp"
              var $110=$ptr; //@line 520 "synth_mbrola.cpp"
              var $add_ptr124=(($110+$call123)&4294967295); //@line 520 "synth_mbrola.cpp"
              $ptr=$add_ptr124; //@line 520 "synth_mbrola.cpp"
              ;
            }
  
            $done=1; //@line 522 "synth_mbrola.cpp"
            __label__ = 54;break $sw_epilog$$sw_bb$$sw_bb126$$sw_bb152$$sw_bb155$$sw_bb171$$sw_bb195$34; //@line 577 "synth_mbrola.cpp"
          }
          else if (__label__ == 32) {
  
            $released=0; //@line 526 "synth_mbrola.cpp"
            var $111=$next; //@line 527 "synth_mbrola.cpp"
            var $type127=(($111+15)&4294967295); //@line 527 "synth_mbrola.cpp"
            var $112=HEAPU8[($type127)]; //@line 527 "synth_mbrola.cpp"
            var $conv128=((($112))&255); //@line 527 "synth_mbrola.cpp"
            var $cmp129=((($conv128))|0)==2; //@line 527 "synth_mbrola.cpp"
            if ($cmp129) { __label__ = 33;; } else { __label__ = 34;; } //@line 527 "synth_mbrola.cpp"
            if (__label__ == 33) {
  
              $released=1; //@line 527 "synth_mbrola.cpp"
              ; //@line 527 "synth_mbrola.cpp"
            }
  
            var $113=$next; //@line 528 "synth_mbrola.cpp"
            var $type132=(($113+15)&4294967295); //@line 528 "synth_mbrola.cpp"
            var $114=HEAPU8[($type132)]; //@line 528 "synth_mbrola.cpp"
            var $conv133=((($114))&255); //@line 528 "synth_mbrola.cpp"
            var $cmp134=((($conv133))|0)==3; //@line 528 "synth_mbrola.cpp"
            if ($cmp134) { __label__ = 35;; } else { __label__ = 37;; } //@line 528 "synth_mbrola.cpp"
            $land_lhs_true135$$if_end139$50: do { 
              if (__label__ == 35) {
  
                var $115=$next; //@line 528 "synth_mbrola.cpp"
                var $newword136=(($115+19)&4294967295); //@line 528 "synth_mbrola.cpp"
                var $116=HEAP8[($newword136)]; //@line 528 "synth_mbrola.cpp"
                var $tobool137=(tempInt=(($116)),(tempInt>=128?tempInt-256:tempInt))!=0; //@line 528 "synth_mbrola.cpp"
                if ($tobool137) { __label__ = 37;break $land_lhs_true135$$if_end139$50; } //@line 528 "synth_mbrola.cpp"
  
                $released=1; //@line 528 "synth_mbrola.cpp"
                __label__ = 39;break $land_lhs_true135$$if_end139$50; //@line 530 "synth_mbrola.cpp"
              }
            } while(0);
            $if_end139$$if_end145$53: do { 
              if (__label__ == 37) {
  
                var $_pr1=$released; //@line 530 "synth_mbrola.cpp"
                var $cmp140=((($_pr1))|0)==0; //@line 530 "synth_mbrola.cpp"
                if (!($cmp140)) { __label__ = 39;break $if_end139$$if_end145$53; } //@line 530 "synth_mbrola.cpp"
  
                var $117=$p; //@line 531 "synth_mbrola.cpp"
                var $synthflags142=(($117+4)&4294967295); //@line 531 "synth_mbrola.cpp"
                var $118=HEAPU16[(($synthflags142)>>1)]; //@line 531 "synth_mbrola.cpp"
                var $conv143=((($118))&65535); //@line 531 "synth_mbrola.cpp"
                var $or=($conv143) | 8192; //@line 531 "synth_mbrola.cpp"
                var $conv144=((($or)) & 65535); //@line 531 "synth_mbrola.cpp"
                HEAP16[(($synthflags142)>>1)]=$conv144; //@line 531 "synth_mbrola.cpp"
                ; //@line 531 "synth_mbrola.cpp"
              }
            } while(0);
  
            var $119=$p; //@line 532 "synth_mbrola.cpp"
            __Z16InterpretPhonemeP10TranslatoriP12PHONEME_LISTP12PHONEME_DATA(0, 0, $119, $phdata); //@line 532 "synth_mbrola.cpp"
            var $call146=__Z9DoSample3P12PHONEME_DATAii($phdata, 0, -1); //@line 533 "synth_mbrola.cpp"
            $len=$call146; //@line 533 "synth_mbrola.cpp"
            var $120=$len; //@line 535 "synth_mbrola.cpp"
            var $mul147=((($120)*1000)&4294967295); //@line 535 "synth_mbrola.cpp"
            var $121=HEAP32[((_samplerate)>>2)]; //@line 535 "synth_mbrola.cpp"
            var $div148=((((($mul147))|0)/((($121))|0))|0); //@line 535 "synth_mbrola.cpp"
            $len=$div148; //@line 535 "synth_mbrola.cpp"
            var $122=$p; //@line 536 "synth_mbrola.cpp"
            var $prepause=(($122+16)&4294967295); //@line 536 "synth_mbrola.cpp"
            var $123=HEAPU8[($prepause)]; //@line 536 "synth_mbrola.cpp"
            var $conv149=((($123))&255); //@line 536 "synth_mbrola.cpp"
            var $call150=__Z11PauseLengthii($conv149, 1); //@line 536 "synth_mbrola.cpp"
            var $124=$len; //@line 536 "synth_mbrola.cpp"
            var $add151=((($124)+($call150))&4294967295); //@line 536 "synth_mbrola.cpp"
            $len=$add151; //@line 536 "synth_mbrola.cpp"
            __label__ = 50;break $sw_epilog$$sw_bb$$sw_bb126$$sw_bb152$$sw_bb155$$sw_bb171$$sw_bb195$34; //@line 537 "synth_mbrola.cpp"
          }
          else if (__label__ == 40) {
  
            var $125=HEAP32[((((_speed+12)&4294967295))>>2)]; //@line 540 "synth_mbrola.cpp"
            var $mul153=((($125)*80)&4294967295); //@line 540 "synth_mbrola.cpp"
            var $div154=((((($mul153))|0)/256)|0); //@line 540 "synth_mbrola.cpp"
            $len=$div154; //@line 540 "synth_mbrola.cpp"
            __label__ = 50;break $sw_epilog$$sw_bb$$sw_bb126$$sw_bb152$$sw_bb155$$sw_bb171$$sw_bb195$34; //@line 541 "synth_mbrola.cpp"
          }
          else if (__label__ == 41) {
  
            $len=0; //@line 544 "synth_mbrola.cpp"
            var $126=$p; //@line 545 "synth_mbrola.cpp"
            __Z16InterpretPhonemeP10TranslatoriP12PHONEME_LISTP12PHONEME_DATA(0, 0, $126, $phdata); //@line 545 "synth_mbrola.cpp"
            var $127=$p; //@line 546 "synth_mbrola.cpp"
            var $synthflags156=(($127+4)&4294967295); //@line 546 "synth_mbrola.cpp"
            var $128=HEAPU16[(($synthflags156)>>1)]; //@line 546 "synth_mbrola.cpp"
            var $conv157=((($128))&65535); //@line 546 "synth_mbrola.cpp"
            var $and158=($conv157) & 8; //@line 546 "synth_mbrola.cpp"
            var $tobool159=((($and158))|0)!=0; //@line 546 "synth_mbrola.cpp"
            if ($tobool159) { __label__ = 42;; } else { __label__ = 43;; } //@line 546 "synth_mbrola.cpp"
            if (__label__ == 42) {
  
              var $129=$p; //@line 547 "synth_mbrola.cpp"
              var $length161=(($129+12)&4294967295); //@line 547 "synth_mbrola.cpp"
              var $130=HEAP16[(($length161)>>1)]; //@line 547 "synth_mbrola.cpp"
              var $conv162=(tempInt=(($130)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 547 "synth_mbrola.cpp"
              var $call163=__Z9DoSample3P12PHONEME_DATAii($phdata, $conv162, -1); //@line 547 "synth_mbrola.cpp"
              $len=$call163; //@line 547 "synth_mbrola.cpp"
              ; //@line 547 "synth_mbrola.cpp"
            }
  
            var $131=$p; //@line 548 "synth_mbrola.cpp"
            var $length165=(($131+12)&4294967295); //@line 548 "synth_mbrola.cpp"
            var $132=HEAP16[(($length165)>>1)]; //@line 548 "synth_mbrola.cpp"
            var $conv166=(tempInt=(($132)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 548 "synth_mbrola.cpp"
            var $call167=__Z9DoSample3P12PHONEME_DATAii($phdata, $conv166, -1); //@line 548 "synth_mbrola.cpp"
            var $133=$len; //@line 548 "synth_mbrola.cpp"
            var $add168=((($133)+($call167))&4294967295); //@line 548 "synth_mbrola.cpp"
            $len=$add168; //@line 548 "synth_mbrola.cpp"
            var $134=$len; //@line 550 "synth_mbrola.cpp"
            var $mul169=((($134)*1000)&4294967295); //@line 550 "synth_mbrola.cpp"
            var $135=HEAP32[((_samplerate)>>2)]; //@line 550 "synth_mbrola.cpp"
            var $div170=((((($mul169))|0)/((($135))|0))|0); //@line 550 "synth_mbrola.cpp"
            $len=$div170; //@line 550 "synth_mbrola.cpp"
            __label__ = 50;break $sw_epilog$$sw_bb$$sw_bb126$$sw_bb152$$sw_bb155$$sw_bb171$$sw_bb195$34; //@line 551 "synth_mbrola.cpp"
          }
          else if (__label__ == 44) {
  
            var $136=$next; //@line 554 "synth_mbrola.cpp"
            var $type172=(($136+15)&4294967295); //@line 554 "synth_mbrola.cpp"
            var $137=HEAPU8[($type172)]; //@line 554 "synth_mbrola.cpp"
            var $conv173=((($137))&255); //@line 554 "synth_mbrola.cpp"
            var $cmp174=((($conv173))|0)!=2; //@line 554 "synth_mbrola.cpp"
            if (!($cmp174)) { __label__ = 50;break $sw_epilog$$sw_bb$$sw_bb126$$sw_bb152$$sw_bb155$$sw_bb171$$sw_bb195$34; } //@line 554 "synth_mbrola.cpp"
  
            var $dest$, $stop$, $stop4$, $fast$, $value4$;
            $dest$ = $1;
            $stop$ = $dest$ + 48;
            $value4$ = 0;
            if ($value4$ < 0) $value4$ += 256;
            $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
            while ($dest$%4 !== 0 && $dest$ < $stop$) {
              ;; HEAP8[$dest$++] = 0;
            }
            $dest$ >>= 2;
            $stop4$ = $stop$ >> 2;
            while ($dest$ < $stop4$) {
            ;;;;;;;  HEAP32[$dest$++] = $value4$;
            }
            $dest$ <<= 2;
            while ($dest$ < $stop$) {
              ;; HEAP8[$dest$++] = 0;
            }; //@line 556 "synth_mbrola.cpp"
            var $138=$p; //@line 557 "synth_mbrola.cpp"
            __Z16InterpretPhonemeP10TranslatoriP12PHONEME_LISTP12PHONEME_DATA(0, 0, $138, $phdata); //@line 557 "synth_mbrola.cpp"
            var $139=HEAP32[(($arrayidx176)>>2)]; //@line 558 "synth_mbrola.cpp"
            HEAP32[(($fmt_addr)>>2)]=$139; //@line 558 "synth_mbrola.cpp"
            var $140=$p; //@line 559 "synth_mbrola.cpp"
            var $ph177=(($140+8)&4294967295); //@line 559 "synth_mbrola.cpp"
            var $141=HEAP32[(($ph177)>>2)]; //@line 559 "synth_mbrola.cpp"
            var $142=$p; //@line 559 "synth_mbrola.cpp"
            var $call178=__Z8DoSpect2P11PHONEME_TABiP10FMT_PARAMSP12PHONEME_LISTi($141, 0, $fmtp, $142, -1); //@line 559 "synth_mbrola.cpp"
            $len=$call178; //@line 559 "synth_mbrola.cpp"
            var $143=$len; //@line 561 "synth_mbrola.cpp"
            var $mul179=((($143)*1000)&4294967295); //@line 561 "synth_mbrola.cpp"
            var $144=HEAP32[((_samplerate)>>2)]; //@line 561 "synth_mbrola.cpp"
            var $div180=((((($mul179))|0)/((($144))|0))|0); //@line 561 "synth_mbrola.cpp"
            $len=$div180; //@line 561 "synth_mbrola.cpp"
            var $145=$next; //@line 562 "synth_mbrola.cpp"
            var $type181=(($145+15)&4294967295); //@line 562 "synth_mbrola.cpp"
            var $146=HEAPU8[($type181)]; //@line 562 "synth_mbrola.cpp"
            var $conv182=((($146))&255); //@line 562 "synth_mbrola.cpp"
            var $cmp183=((($conv182))|0)==0; //@line 562 "synth_mbrola.cpp"
            if ($cmp183) { __label__ = 46;; } else { __label__ = 47;; } //@line 562 "synth_mbrola.cpp"
            if (__label__ == 46) {
  
              var $147=$len; //@line 563 "synth_mbrola.cpp"
              var $add185=((($147)+50)&4294967295); //@line 563 "synth_mbrola.cpp"
              $len=$add185; //@line 563 "synth_mbrola.cpp"
              ; //@line 563 "synth_mbrola.cpp"
            }
  
            var $148=$p; //@line 564 "synth_mbrola.cpp"
            var $env187=(($148+14)&4294967295); //@line 564 "synth_mbrola.cpp"
            var $149=HEAPU8[($env187)]; //@line 564 "synth_mbrola.cpp"
            var $conv188=((($149))&255); //@line 564 "synth_mbrola.cpp"
            var $150=$p; //@line 564 "synth_mbrola.cpp"
            var $pitch1189=(($150+20)&4294967295); //@line 564 "synth_mbrola.cpp"
            var $151=HEAPU8[($pitch1189)]; //@line 564 "synth_mbrola.cpp"
            var $conv190=((($151))&255); //@line 564 "synth_mbrola.cpp"
            var $152=$p; //@line 564 "synth_mbrola.cpp"
            var $pitch2191=(($152+21)&4294967295); //@line 564 "synth_mbrola.cpp"
            var $153=HEAPU8[($pitch2191)]; //@line 564 "synth_mbrola.cpp"
            var $conv192=((($153))&255); //@line 564 "synth_mbrola.cpp"
            __ZL10WritePitchiiiii($conv188, $conv190, $conv192, 0, 1); //@line 564 "synth_mbrola.cpp"
            $final_pitch=((__ZZL10WritePitchiiiiiE6output)&4294967295); //@line 564 "synth_mbrola.cpp"
            __label__ = 50;break $sw_epilog$$sw_bb$$sw_bb126$$sw_bb152$$sw_bb155$$sw_bb171$$sw_bb195$34; //@line 565 "synth_mbrola.cpp"
          }
          else if (__label__ == 48) {
  
            var $154=$next; //@line 569 "synth_mbrola.cpp"
            var $type196=(($154+15)&4294967295); //@line 569 "synth_mbrola.cpp"
            var $155=HEAPU8[($type196)]; //@line 569 "synth_mbrola.cpp"
            var $conv197=((($155))&255); //@line 569 "synth_mbrola.cpp"
            var $cmp198=((($conv197))|0)==0; //@line 569 "synth_mbrola.cpp"
            if (!($cmp198)) { __label__ = 50;break $sw_epilog$$sw_bb$$sw_bb126$$sw_bb152$$sw_bb155$$sw_bb171$$sw_bb195$34; } //@line 569 "synth_mbrola.cpp"
  
            var $156=$len; //@line 571 "synth_mbrola.cpp"
            var $add200=((($156)+50)&4294967295); //@line 571 "synth_mbrola.cpp"
            $len=$add200; //@line 571 "synth_mbrola.cpp"
            var $157=$p; //@line 572 "synth_mbrola.cpp"
            var $env201=(($157+14)&4294967295); //@line 572 "synth_mbrola.cpp"
            var $158=HEAPU8[($env201)]; //@line 572 "synth_mbrola.cpp"
            var $conv202=((($158))&255); //@line 572 "synth_mbrola.cpp"
            var $159=$p; //@line 572 "synth_mbrola.cpp"
            var $pitch1203=(($159+20)&4294967295); //@line 572 "synth_mbrola.cpp"
            var $160=HEAPU8[($pitch1203)]; //@line 572 "synth_mbrola.cpp"
            var $conv204=((($160))&255); //@line 572 "synth_mbrola.cpp"
            var $161=$p; //@line 572 "synth_mbrola.cpp"
            var $pitch2205=(($161+21)&4294967295); //@line 572 "synth_mbrola.cpp"
            var $162=HEAPU8[($pitch2205)]; //@line 572 "synth_mbrola.cpp"
            var $conv206=((($162))&255); //@line 572 "synth_mbrola.cpp"
            __ZL10WritePitchiiiii($conv202, $conv204, $conv206, 0, 1); //@line 572 "synth_mbrola.cpp"
            $final_pitch=((__ZZL10WritePitchiiiiiE6output)&4294967295); //@line 572 "synth_mbrola.cpp"
            __label__ = 50;break $sw_epilog$$sw_bb$$sw_bb126$$sw_bb152$$sw_bb155$$sw_bb171$$sw_bb195$34; //@line 573 "synth_mbrola.cpp"
          }
        } while(0);
        $sw_epilog$$if_end222$69: do { 
          if (__label__ == 50) {
  
            var $_pr3=$done; //@line 577 "synth_mbrola.cpp"
            var $tobool209=((($_pr3))|0)!=0; //@line 577 "synth_mbrola.cpp"
            if ($tobool209) { __label__ = 54;break $sw_epilog$$if_end222$69; } //@line 577 "synth_mbrola.cpp"
  
            var $163=HEAP32[(($name2)>>2)]; //@line 579 "synth_mbrola.cpp"
            var $cmp211=((($163))|0)!=0; //@line 579 "synth_mbrola.cpp"
            if ($cmp211) { __label__ = 52;; } else { __label__ = 53;; } //@line 579 "synth_mbrola.cpp"
            if (__label__ == 52) {
  
              var $164=$len; //@line 581 "synth_mbrola.cpp"
              var $165=HEAP32[(($len_percent)>>2)]; //@line 581 "synth_mbrola.cpp"
              var $mul213=((($165)*($164))&4294967295); //@line 581 "synth_mbrola.cpp"
              var $div214=((((($mul213))|0)/100)|0); //@line 581 "synth_mbrola.cpp"
              $len1=$div214; //@line 581 "synth_mbrola.cpp"
              var $166=$ptr; //@line 582 "synth_mbrola.cpp"
              var $167=$len1; //@line 582 "synth_mbrola.cpp"
              var $168=HEAP32[(($name2)>>2)]; //@line 582 "synth_mbrola.cpp"
              var $call215=__Z12WordToStringj($168); //@line 582 "synth_mbrola.cpp"
              var $call216=_sprintf($166, ((__str10392)&4294967295), allocate([$167,0,0,0,((__ZZ12WordToStringjE3buf)&4294967295),0,0,0], ["i32",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 582 "synth_mbrola.cpp"
              var $169=$ptr; //@line 582 "synth_mbrola.cpp"
              var $add_ptr217=(($169+$call216)&4294967295); //@line 582 "synth_mbrola.cpp"
              $ptr=$add_ptr217; //@line 582 "synth_mbrola.cpp"
              var $170=$len1; //@line 583 "synth_mbrola.cpp"
              var $171=$len; //@line 583 "synth_mbrola.cpp"
              var $sub218=((($171)-($170))&4294967295); //@line 583 "synth_mbrola.cpp"
              $len=$sub218; //@line 583 "synth_mbrola.cpp"
              ; //@line 584 "synth_mbrola.cpp"
            }
  
            var $172=$ptr; //@line 585 "synth_mbrola.cpp"
            var $173=$len; //@line 585 "synth_mbrola.cpp"
            var $174=$final_pitch; //@line 585 "synth_mbrola.cpp"
            var $call220=_sprintf($172, ((__str11393)&4294967295), allocate([$173,0,0,0,$174,0,0,0], ["i32",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 585 "synth_mbrola.cpp"
            var $175=$ptr; //@line 585 "synth_mbrola.cpp"
            var $add_ptr221=(($175+$call220)&4294967295); //@line 585 "synth_mbrola.cpp"
            $ptr=$add_ptr221; //@line 585 "synth_mbrola.cpp"
            ; //@line 586 "synth_mbrola.cpp"
          }
        } while(0);
  
        var $176=$pause; //@line 588 "synth_mbrola.cpp"
        var $tobool223=((($176))|0)!=0; //@line 588 "synth_mbrola.cpp"
        if ($tobool223) { __label__ = 55;; } else { __label__ = 56;; } //@line 588 "synth_mbrola.cpp"
        if (__label__ == 55) {
  
          var $177=$pause; //@line 590 "synth_mbrola.cpp"
          var $call225=__Z11PauseLengthii($177, 0); //@line 590 "synth_mbrola.cpp"
          var $178=$len; //@line 590 "synth_mbrola.cpp"
          var $add226=((($178)+($call225))&4294967295); //@line 590 "synth_mbrola.cpp"
          $len=$add226; //@line 590 "synth_mbrola.cpp"
          var $179=$ptr; //@line 591 "synth_mbrola.cpp"
          var $180=$pause; //@line 591 "synth_mbrola.cpp"
          var $call227=__Z11PauseLengthii($180, 0); //@line 591 "synth_mbrola.cpp"
          var $call228=_sprintf($179, ((__str12394)&4294967295), allocate([$call227,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 591 "synth_mbrola.cpp"
          var $181=$ptr; //@line 591 "synth_mbrola.cpp"
          var $add_ptr229=(($181+$call228)&4294967295); //@line 591 "synth_mbrola.cpp"
          $ptr=$add_ptr229; //@line 591 "synth_mbrola.cpp"
          $pause=0; //@line 592 "synth_mbrola.cpp"
          ; //@line 593 "synth_mbrola.cpp"
        }
  
        var $182=$f_mbrola_addr; //@line 595 "synth_mbrola.cpp"
        var $tobool231=((($182))|0)!=0; //@line 595 "synth_mbrola.cpp"
        if ($tobool231) { __label__ = 57;; } else { __label__ = 58;; } //@line 595 "synth_mbrola.cpp"
        if (__label__ == 57) {
  
          var $183=$ptr; //@line 597 "synth_mbrola.cpp"
          var $sub_ptr_lhs_cast=($183); //@line 597 "synth_mbrola.cpp"
          var $sub_ptr_sub=((($sub_ptr_lhs_cast)-($sub_ptr_rhs_cast))&4294967295); //@line 597 "synth_mbrola.cpp"
          var $184=$f_mbrola_addr; //@line 597 "synth_mbrola.cpp"
          var $call235=_fwrite($arraydecay233, 1, $sub_ptr_sub, $184); //@line 597 "synth_mbrola.cpp"
          ; //@line 598 "synth_mbrola.cpp"
        }
        else if (__label__ == 58) {
  
          var $call238=_write_MBR($arraydecay233); //@line 601 "synth_mbrola.cpp"
          $res=$call238; //@line 601 "synth_mbrola.cpp"
          var $185=$res; //@line 602 "synth_mbrola.cpp"
          var $cmp239=((($185))|0) < 0; //@line 602 "synth_mbrola.cpp"
          if ($cmp239) { __label__ = 59;break $while_cond$5; } //@line 602 "synth_mbrola.cpp"
  
          var $186=$res; //@line 604 "synth_mbrola.cpp"
          var $cmp242=((($186))|0)==0; //@line 604 "synth_mbrola.cpp"
          if ($cmp242) { __label__ = 61;break $while_cond$5; } //@line 604 "synth_mbrola.cpp"
  
          var $187=HEAP32[((_wcmdq_tail)>>2)]; //@line 606 "synth_mbrola.cpp"
          var $arrayidx245=((_wcmdq+$187*16)&4294967295); //@line 606 "synth_mbrola.cpp"
          var $arrayidx246=(($arrayidx245)&4294967295); //@line 606 "synth_mbrola.cpp"
          HEAP32[(($arrayidx246)>>2)]=13; //@line 606 "synth_mbrola.cpp"
          var $188=$len; //@line 607 "synth_mbrola.cpp"
          var $189=HEAP32[((_wcmdq_tail)>>2)]; //@line 607 "synth_mbrola.cpp"
          var $arrayidx247=((_wcmdq+$189*16)&4294967295); //@line 607 "synth_mbrola.cpp"
          var $arrayidx248=(($arrayidx247+4)&4294967295); //@line 607 "synth_mbrola.cpp"
          HEAP32[(($arrayidx248)>>2)]=$188; //@line 607 "synth_mbrola.cpp"
          __Z8WcmdqIncv(); //@line 608 "synth_mbrola.cpp"
          ;
        }
  
        var $190=HEAP32[((__ZZ15MbrolaTranslateP12PHONEME_LISTiiP7__sFILEE4phix)>>2)]; //@line 611 "synth_mbrola.cpp"
        var $inc250=((($190)+1)&4294967295); //@line 611 "synth_mbrola.cpp"
        HEAP32[((__ZZ15MbrolaTranslateP12PHONEME_LISTiiP7__sFILEE4phix)>>2)]=$inc250; //@line 611 "synth_mbrola.cpp"
        __label__ = 3;continue $while_cond$5; //@line 612 "synth_mbrola.cpp"
      }
    }
    if (__label__ == 64) {
  
      var $191=$f_mbrola_addr; //@line 614 "synth_mbrola.cpp"
      var $tobool251=((($191))|0)!=0; //@line 614 "synth_mbrola.cpp"
      if ($tobool251) { __label__ = 66;; } else { __label__ = 65;; } //@line 614 "synth_mbrola.cpp"
      if (__label__ == 65) {
  
        var $call253=_flush_MBR(); //@line 616 "synth_mbrola.cpp"
        var $192=HEAP32[((_wcmdq_tail)>>2)]; //@line 619 "synth_mbrola.cpp"
        var $arrayidx254=((_wcmdq+$192*16)&4294967295); //@line 619 "synth_mbrola.cpp"
        var $arrayidx255=(($arrayidx254)&4294967295); //@line 619 "synth_mbrola.cpp"
        HEAP32[(($arrayidx255)>>2)]=13; //@line 619 "synth_mbrola.cpp"
        var $193=HEAP32[((_wcmdq_tail)>>2)]; //@line 620 "synth_mbrola.cpp"
        var $arrayidx256=((_wcmdq+$193*16)&4294967295); //@line 620 "synth_mbrola.cpp"
        var $arrayidx257=(($arrayidx256+4)&4294967295); //@line 620 "synth_mbrola.cpp"
        HEAP32[(($arrayidx257)>>2)]=500; //@line 620 "synth_mbrola.cpp"
        __Z8WcmdqIncv(); //@line 621 "synth_mbrola.cpp"
        ; //@line 622 "synth_mbrola.cpp"
      }
  
      $retval=0; //@line 624 "synth_mbrola.cpp"
      ; //@line 624 "synth_mbrola.cpp"
    }
    else if (__label__ == 5) {
  
      $retval=1; //@line 439 "synth_mbrola.cpp"
      ; //@line 439 "synth_mbrola.cpp"
    }
    else if (__label__ == 59) {
  
      $retval=0; //@line 603 "synth_mbrola.cpp"
      ; //@line 603 "synth_mbrola.cpp"
    }
    else if (__label__ == 61) {
  
      $retval=1; //@line 605 "synth_mbrola.cpp"
      ; //@line 605 "synth_mbrola.cpp"
    }
  
    var $194=$retval; //@line 625 "synth_mbrola.cpp"
    STACKTOP = __stackBase__;
    return $194; //@line 625 "synth_mbrola.cpp"
    return null;
  }
  

  function __ZL10GetMbrNameP12PHONEME_LISTP11PHONEME_TABS2_S2_PiS3_S3_($plist, $ph, $ph_prev, $ph_next, $name2, $split, $control) {
    ;
    var __label__;
  
    var $retval;
    var $plist_addr;
    var $ph_addr;
    var $ph_prev_addr;
    var $ph_next_addr;
    var $name2_addr;
    var $split_addr;
    var $control_addr;
    var $pr;
    var $other_ph;
    var $found;
    $plist_addr=$plist;
    $ph_addr=$ph;
    $ph_prev_addr=$ph_prev;
    $ph_next_addr=$ph_next;
    $name2_addr=$name2;
    $split_addr=$split;
    $control_addr=$control;
    $found=0; //@line 209 "synth_mbrola.cpp"
    var $0=$name2_addr; //@line 219 "synth_mbrola.cpp"
    HEAP32[(($0)>>2)]=0; //@line 219 "synth_mbrola.cpp"
    var $1=$split_addr; //@line 220 "synth_mbrola.cpp"
    HEAP32[(($1)>>2)]=0; //@line 220 "synth_mbrola.cpp"
    var $2=$control_addr; //@line 221 "synth_mbrola.cpp"
    HEAP32[(($2)>>2)]=0; //@line 221 "synth_mbrola.cpp"
    var $3=$ph_addr; //@line 222 "synth_mbrola.cpp"
    var $mnemonic=(($3)&4294967295); //@line 222 "synth_mbrola.cpp"
    var $4=HEAP32[(($mnemonic)>>2)]; //@line 222 "synth_mbrola.cpp"
    HEAP32[((__ZZL10GetMbrNameP12PHONEME_LISTP11PHONEME_TABS2_S2_PiS3_S3_E4mnem)>>2)]=$4; //@line 222 "synth_mbrola.cpp"
    var $5=HEAP32[((__ZL10mbrola_tab)>>2)]; //@line 224 "synth_mbrola.cpp"
    $pr=$5; //@line 224 "synth_mbrola.cpp"
    ; //@line 225 "synth_mbrola.cpp"
    $while_cond$2: while(1) { 
  
      var $6=$pr; //@line 225 "synth_mbrola.cpp"
      var $name=(($6)&4294967295); //@line 225 "synth_mbrola.cpp"
      var $7=HEAP32[(($name)>>2)]; //@line 225 "synth_mbrola.cpp"
      var $cmp=((($7))|0)!=0; //@line 225 "synth_mbrola.cpp"
      if (!($cmp)) { __label__ = 28;break $while_cond$2; } //@line 225 "synth_mbrola.cpp"
  
      var $8=HEAP32[((__ZZL10GetMbrNameP12PHONEME_LISTP11PHONEME_TABS2_S2_PiS3_S3_E4mnem)>>2)]; //@line 227 "synth_mbrola.cpp"
      var $9=$pr; //@line 227 "synth_mbrola.cpp"
      var $name1=(($9)&4294967295); //@line 227 "synth_mbrola.cpp"
      var $10=HEAP32[(($name1)>>2)]; //@line 227 "synth_mbrola.cpp"
      var $cmp2=((($8))|0)==((($10))|0); //@line 227 "synth_mbrola.cpp"
      if ($cmp2) { __label__ = 3;; } else { __label__ = 27;; } //@line 227 "synth_mbrola.cpp"
      $if_then$$if_end60$5: do { 
        if (__label__ == 3) {
  
          var $11=$pr; //@line 229 "synth_mbrola.cpp"
          var $next_phoneme=(($11+4)&4294967295); //@line 229 "synth_mbrola.cpp"
          var $12=HEAP32[(($next_phoneme)>>2)]; //@line 229 "synth_mbrola.cpp"
          var $cmp3=((($12))|0)==0; //@line 229 "synth_mbrola.cpp"
          if ($cmp3) { __label__ = 4;; } else { __label__ = 5;; } //@line 229 "synth_mbrola.cpp"
          $if_then4$$if_else$7: do { 
            if (__label__ == 4) {
  
              $found=1; //@line 230 "synth_mbrola.cpp"
              ; //@line 230 "synth_mbrola.cpp"
            }
            else if (__label__ == 5) {
  
              var $13=$pr; //@line 232 "synth_mbrola.cpp"
              var $next_phoneme5=(($13+4)&4294967295); //@line 232 "synth_mbrola.cpp"
              var $14=HEAP32[(($next_phoneme5)>>2)]; //@line 232 "synth_mbrola.cpp"
              var $cmp6=((($14))|0)==58; //@line 232 "synth_mbrola.cpp"
              if ($cmp6) { __label__ = 6;; } else { __label__ = 8;; } //@line 232 "synth_mbrola.cpp"
              $land_lhs_true$$if_else8$10: do { 
                if (__label__ == 6) {
  
                  var $15=$plist_addr; //@line 232 "synth_mbrola.cpp"
                  var $synthflags=(($15+4)&4294967295); //@line 232 "synth_mbrola.cpp"
                  var $16=HEAPU16[(($synthflags)>>1)]; //@line 232 "synth_mbrola.cpp"
                  var $conv=((($16))&65535); //@line 232 "synth_mbrola.cpp"
                  var $and=($conv) & 8; //@line 232 "synth_mbrola.cpp"
                  var $tobool=((($and))|0)!=0; //@line 232 "synth_mbrola.cpp"
                  if (!($tobool)) { __label__ = 8;break $land_lhs_true$$if_else8$10; } //@line 232 "synth_mbrola.cpp"
  
                  $found=1; //@line 234 "synth_mbrola.cpp"
                  __label__ = 20;break $if_then4$$if_else$7; //@line 235 "synth_mbrola.cpp"
                }
              } while(0);
  
              var $17=$pr; //@line 238 "synth_mbrola.cpp"
              var $control9=(($17+20)&4294967295); //@line 238 "synth_mbrola.cpp"
              var $18=HEAP32[(($control9)>>2)]; //@line 238 "synth_mbrola.cpp"
              var $and10=($18) & 2; //@line 238 "synth_mbrola.cpp"
              var $tobool11=((($and10))|0)!=0; //@line 238 "synth_mbrola.cpp"
              if ($tobool11) { __label__ = 9;; } else { __label__ = 10;; } //@line 238 "synth_mbrola.cpp"
              $if_then12$$if_else13$14: do { 
                if (__label__ == 9) {
  
                  var $19=$ph_prev_addr; //@line 239 "synth_mbrola.cpp"
                  $other_ph=$19; //@line 239 "synth_mbrola.cpp"
                  ; //@line 239 "synth_mbrola.cpp"
                }
                else if (__label__ == 10) {
  
                  var $20=$pr; //@line 241 "synth_mbrola.cpp"
                  var $control14=(($20+20)&4294967295); //@line 241 "synth_mbrola.cpp"
                  var $21=HEAP32[(($control14)>>2)]; //@line 241 "synth_mbrola.cpp"
                  var $and15=($21) & 8; //@line 241 "synth_mbrola.cpp"
                  var $tobool16=((($and15))|0)!=0; //@line 241 "synth_mbrola.cpp"
                  if ($tobool16) { __label__ = 11;; } else { __label__ = 13;; } //@line 241 "synth_mbrola.cpp"
                  $land_lhs_true17$$if_else20$17: do { 
                    if (__label__ == 11) {
  
                      var $22=$plist_addr; //@line 241 "synth_mbrola.cpp"
                      var $add_ptr=(($22+24)&4294967295); //@line 241 "synth_mbrola.cpp"
                      var $newword=(($add_ptr+19)&4294967295); //@line 241 "synth_mbrola.cpp"
                      var $23=HEAP8[($newword)]; //@line 241 "synth_mbrola.cpp"
                      var $tobool18=(tempInt=(($23)),(tempInt>=128?tempInt-256:tempInt))!=0; //@line 241 "synth_mbrola.cpp"
                      if (!($tobool18)) { __label__ = 13;break $land_lhs_true17$$if_else20$17; } //@line 241 "synth_mbrola.cpp"
  
                      var $24=HEAP32[((((_phoneme_tab)&4294967295))>>2)]; //@line 242 "synth_mbrola.cpp"
                      $other_ph=$24; //@line 242 "synth_mbrola.cpp"
                      __label__ = 14;break $if_then12$$if_else13$14; //@line 242 "synth_mbrola.cpp"
                    }
                  } while(0);
  
                  var $25=$ph_next_addr; //@line 244 "synth_mbrola.cpp"
                  $other_ph=$25; //@line 244 "synth_mbrola.cpp"
                  ;
                }
              } while(0);
  
              var $26=$pr; //@line 246 "synth_mbrola.cpp"
              var $next_phoneme22=(($26+4)&4294967295); //@line 246 "synth_mbrola.cpp"
              var $27=HEAP32[(($next_phoneme22)>>2)]; //@line 246 "synth_mbrola.cpp"
              var $28=$other_ph; //@line 246 "synth_mbrola.cpp"
              var $mnemonic23=(($28)&4294967295); //@line 246 "synth_mbrola.cpp"
              var $29=HEAP32[(($mnemonic23)>>2)]; //@line 246 "synth_mbrola.cpp"
              var $cmp24=((($27))|0)==((($29))|0); //@line 246 "synth_mbrola.cpp"
              if ($cmp24) { __label__ = 19;; } else { __label__ = 15;; } //@line 246 "synth_mbrola.cpp"
              $if_then37$$lor_lhs_false$22: do { 
                if (__label__ == 15) {
  
                  var $30=$pr; //@line 246 "synth_mbrola.cpp"
                  var $next_phoneme25=(($30+4)&4294967295); //@line 246 "synth_mbrola.cpp"
                  var $31=HEAP32[(($next_phoneme25)>>2)]; //@line 246 "synth_mbrola.cpp"
                  var $cmp26=((($31))|0)==2; //@line 246 "synth_mbrola.cpp"
                  if ($cmp26) { __label__ = 16;; } else { __label__ = 17;; } //@line 246 "synth_mbrola.cpp"
                  if (__label__ == 16) {
  
                    var $32=$other_ph; //@line 246 "synth_mbrola.cpp"
                    var $type=(($32+11)&4294967295); //@line 246 "synth_mbrola.cpp"
                    var $33=HEAPU8[($type)]; //@line 246 "synth_mbrola.cpp"
                    var $conv28=((($33))&255); //@line 246 "synth_mbrola.cpp"
                    var $cmp29=((($conv28))|0)==2; //@line 246 "synth_mbrola.cpp"
                    if ($cmp29) { __label__ = 19;break $if_then37$$lor_lhs_false$22; } //@line 246 "synth_mbrola.cpp"
                  }
  
                  var $34=$pr; //@line 246 "synth_mbrola.cpp"
                  var $next_phoneme31=(($34+4)&4294967295); //@line 246 "synth_mbrola.cpp"
                  var $35=HEAP32[(($next_phoneme31)>>2)]; //@line 246 "synth_mbrola.cpp"
                  var $cmp32=((($35))|0)==95; //@line 246 "synth_mbrola.cpp"
                  if (!($cmp32)) { __label__ = 20;break $if_then4$$if_else$7; } //@line 246 "synth_mbrola.cpp"
  
                  var $36=$other_ph; //@line 246 "synth_mbrola.cpp"
                  var $type34=(($36+11)&4294967295); //@line 246 "synth_mbrola.cpp"
                  var $37=HEAPU8[($type34)]; //@line 246 "synth_mbrola.cpp"
                  var $conv35=((($37))&255); //@line 246 "synth_mbrola.cpp"
                  var $cmp36=((($conv35))|0)==0; //@line 246 "synth_mbrola.cpp"
                  if (!($cmp36)) { __label__ = 20;break $if_then4$$if_else$7; } //@line 246 "synth_mbrola.cpp"
                }
              } while(0);
  
              $found=1; //@line 250 "synth_mbrola.cpp"
              ; //@line 251 "synth_mbrola.cpp"
            }
          } while(0);
  
          var $38=$pr; //@line 254 "synth_mbrola.cpp"
          var $control41=(($38+20)&4294967295); //@line 254 "synth_mbrola.cpp"
          var $39=HEAP32[(($control41)>>2)]; //@line 254 "synth_mbrola.cpp"
          var $and42=($39) & 4; //@line 254 "synth_mbrola.cpp"
          var $tobool43=((($and42))|0)!=0; //@line 254 "synth_mbrola.cpp"
          if ($tobool43) { __label__ = 21;; } else { __label__ = 23;; } //@line 254 "synth_mbrola.cpp"
          $land_lhs_true44$$if_end49$30: do { 
            if (__label__ == 21) {
  
              var $40=$plist_addr; //@line 254 "synth_mbrola.cpp"
              var $newword45=(($40+19)&4294967295); //@line 254 "synth_mbrola.cpp"
              var $41=HEAPU8[($newword45)]; //@line 254 "synth_mbrola.cpp"
              var $conv46=((($41))&255); //@line 254 "synth_mbrola.cpp"
              var $cmp47=((($conv46))|0)==0; //@line 254 "synth_mbrola.cpp"
              if (!($cmp47)) { __label__ = 23;break $land_lhs_true44$$if_end49$30; } //@line 254 "synth_mbrola.cpp"
  
              $found=0; //@line 255 "synth_mbrola.cpp"
              __label__ = 27;break $if_then$$if_end60$5; //@line 257 "synth_mbrola.cpp"
            }
          } while(0);
  
          var $_pr=$found; //@line 257 "synth_mbrola.cpp"
          var $tobool50=((($_pr))|0)!=0; //@line 257 "synth_mbrola.cpp"
          if ($tobool50) { __label__ = 24;break $while_cond$2; } //@line 257 "synth_mbrola.cpp"
        }
      } while(0);
  
      var $55=$pr; //@line 273 "synth_mbrola.cpp"
      var $incdec_ptr=(($55+24)&4294967295); //@line 273 "synth_mbrola.cpp"
      $pr=$incdec_ptr; //@line 273 "synth_mbrola.cpp"
      __label__ = 1;continue $while_cond$2; //@line 274 "synth_mbrola.cpp"
    }
    $while_end$$if_then51$35: do { 
      if (__label__ == 24) {
  
        var $42=$pr; //@line 259 "synth_mbrola.cpp"
        var $mbr_name2=(($42+12)&4294967295); //@line 259 "synth_mbrola.cpp"
        var $43=HEAP32[(($mbr_name2)>>2)]; //@line 259 "synth_mbrola.cpp"
        var $44=$name2_addr; //@line 259 "synth_mbrola.cpp"
        HEAP32[(($44)>>2)]=$43; //@line 259 "synth_mbrola.cpp"
        var $45=$pr; //@line 260 "synth_mbrola.cpp"
        var $percent=(($45+16)&4294967295); //@line 260 "synth_mbrola.cpp"
        var $46=HEAP32[(($percent)>>2)]; //@line 260 "synth_mbrola.cpp"
        var $47=$split_addr; //@line 260 "synth_mbrola.cpp"
        HEAP32[(($47)>>2)]=$46; //@line 260 "synth_mbrola.cpp"
        var $48=$pr; //@line 261 "synth_mbrola.cpp"
        var $control52=(($48+20)&4294967295); //@line 261 "synth_mbrola.cpp"
        var $49=HEAP32[(($control52)>>2)]; //@line 261 "synth_mbrola.cpp"
        var $50=$control_addr; //@line 261 "synth_mbrola.cpp"
        HEAP32[(($50)>>2)]=$49; //@line 261 "synth_mbrola.cpp"
        var $51=$pr; //@line 263 "synth_mbrola.cpp"
        var $control53=(($51+20)&4294967295); //@line 263 "synth_mbrola.cpp"
        var $52=HEAP32[(($control53)>>2)]; //@line 263 "synth_mbrola.cpp"
        var $and54=($52) & 16; //@line 263 "synth_mbrola.cpp"
        var $tobool55=((($and54))|0)!=0; //@line 263 "synth_mbrola.cpp"
        var $53=$pr; //@line 265 "synth_mbrola.cpp"
        var $mbr_name=(($53+8)&4294967295); //@line 265 "synth_mbrola.cpp"
        var $54=HEAP32[(($mbr_name)>>2)]; //@line 265 "synth_mbrola.cpp"
        if ($tobool55) { __label__ = 25;; } else { __label__ = 26;; } //@line 263 "synth_mbrola.cpp"
        if (__label__ == 25) {
  
          HEAP32[((__ZL15mbr_name_prefix)>>2)]=$54; //@line 265 "synth_mbrola.cpp"
          $retval=0; //@line 266 "synth_mbrola.cpp"
          __label__ = 31;break $while_end$$if_then51$35; //@line 266 "synth_mbrola.cpp"
        }
        else if (__label__ == 26) {
  
          HEAP32[((__ZZL10GetMbrNameP12PHONEME_LISTP11PHONEME_TABS2_S2_PiS3_S3_E4mnem)>>2)]=$54; //@line 268 "synth_mbrola.cpp"
          __label__ = 28;break $while_end$$if_then51$35; //@line 269 "synth_mbrola.cpp"
        }
      }
    } while(0);
    if (__label__ == 28) {
  
      var $56=HEAP32[((__ZL15mbr_name_prefix)>>2)]; //@line 276 "synth_mbrola.cpp"
      var $cmp61=((($56))|0)!=0; //@line 276 "synth_mbrola.cpp"
      if ($cmp61) { __label__ = 29;; } else { __label__ = 30;; } //@line 276 "synth_mbrola.cpp"
      if (__label__ == 29) {
  
        var $57=HEAP32[((__ZZL10GetMbrNameP12PHONEME_LISTP11PHONEME_TABS2_S2_PiS3_S3_E4mnem)>>2)]; //@line 278 "synth_mbrola.cpp"
        var $shl=($57) << 8; //@line 278 "synth_mbrola.cpp"
        var $58=HEAP32[((__ZL15mbr_name_prefix)>>2)]; //@line 278 "synth_mbrola.cpp"
        var $and63=($58) & 255; //@line 278 "synth_mbrola.cpp"
        var $or=($and63) | ($shl); //@line 278 "synth_mbrola.cpp"
        HEAP32[((__ZZL10GetMbrNameP12PHONEME_LISTP11PHONEME_TABS2_S2_PiS3_S3_E4mnem)>>2)]=$or; //@line 278 "synth_mbrola.cpp"
        ; //@line 279 "synth_mbrola.cpp"
      }
  
      HEAP32[((__ZL15mbr_name_prefix)>>2)]=0; //@line 280 "synth_mbrola.cpp"
      var $59=HEAP32[((__ZZL10GetMbrNameP12PHONEME_LISTP11PHONEME_TABS2_S2_PiS3_S3_E4mnem)>>2)]; //@line 281 "synth_mbrola.cpp"
      $retval=$59; //@line 281 "synth_mbrola.cpp"
      ; //@line 281 "synth_mbrola.cpp"
    }
  
    var $60=$retval; //@line 282 "synth_mbrola.cpp"
    ;
    return $60; //@line 282 "synth_mbrola.cpp"
    return null;
  }
  

  function __ZL10WritePitchiiiii($env, $pitch1, $pitch2, $split, $final) {
    var __stackBase__  = STACKTOP; STACKTOP += 76; _memset(__stackBase__, 0, 76);
    var __label__;
    var __lastLabel__ = null;
  
    var $env_addr;
    var $pitch1_addr;
    var $pitch2_addr;
    var $split_addr;
    var $final_addr;
    var $x;
    var $ix;
    var $pitch_base=__stackBase__;
    var $pitch_range=__stackBase__+4;
    var $p1;
    var $p2;
    var $p_end;
    var $pitch_env;
    var $max;
    var $min;
    var $y_max;
    var $y_min;
    var $env100;
    var $y2;
    var $y=__stackBase__+8;
    var $env_split;
    var $buf=__stackBase__+24;
    $env_addr=$env;
    $pitch1_addr=$pitch1;
    $pitch2_addr=$pitch2;
    $split_addr=$split;
    $final_addr=$final;
    $max=-1; //@line 294 "synth_mbrola.cpp"
    $min=999; //@line 295 "synth_mbrola.cpp"
    $y_max=0; //@line 296 "synth_mbrola.cpp"
    $y_min=0; //@line 297 "synth_mbrola.cpp"
    $env100=80; //@line 298 "synth_mbrola.cpp"
    HEAP8[(((__ZZL10WritePitchiiiiiE6output)&4294967295))]=0; //@line 305 "synth_mbrola.cpp"
    var $0=$env_addr; //@line 306 "synth_mbrola.cpp"
    var $arrayidx=((_envelope_data+$0*4)&4294967295); //@line 306 "synth_mbrola.cpp"
    var $1=HEAP32[(($arrayidx)>>2)]; //@line 306 "synth_mbrola.cpp"
    $pitch_env=$1; //@line 306 "synth_mbrola.cpp"
    var $2=HEAP32[((_voice)>>2)]; //@line 309 "synth_mbrola.cpp"
    var $3=$pitch1_addr; //@line 309 "synth_mbrola.cpp"
    var $4=$pitch2_addr; //@line 309 "synth_mbrola.cpp"
    __Z9SetPitch2P7voice_tiiPiS1_($2, $3, $4, $pitch_base, $pitch_range); //@line 309 "synth_mbrola.cpp"
    var $5=$split_addr; //@line 312 "synth_mbrola.cpp"
    var $mul=((($5)*128)&4294967295); //@line 312 "synth_mbrola.cpp"
    var $div=((((($mul))|0)/100)|0); //@line 312 "synth_mbrola.cpp"
    $env_split=$div; //@line 312 "synth_mbrola.cpp"
    var $6=$env_split; //@line 313 "synth_mbrola.cpp"
    var $cmp=((($6))|0) < 0; //@line 313 "synth_mbrola.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 313 "synth_mbrola.cpp"
    if (__label__ == 1) {
  
      var $7=$env_split; //@line 314 "synth_mbrola.cpp"
      var $sub=(((-($7)))&4294967295); //@line 314 "synth_mbrola.cpp"
      $env_split=$sub; //@line 314 "synth_mbrola.cpp"
      ; //@line 314 "synth_mbrola.cpp"
    }
  
    $x=0; //@line 317 "synth_mbrola.cpp"
    ; //@line 317 "synth_mbrola.cpp"
    $for_body$5: while(1) { 
  
      var $8=$x; //@line 319 "synth_mbrola.cpp"
      var $9=$pitch_env; //@line 319 "synth_mbrola.cpp"
      var $arrayidx2=(($9+$8)&4294967295); //@line 319 "synth_mbrola.cpp"
      var $10=HEAPU8[($arrayidx2)]; //@line 319 "synth_mbrola.cpp"
      var $conv=((($10))&255); //@line 319 "synth_mbrola.cpp"
      var $11=$max; //@line 319 "synth_mbrola.cpp"
      var $cmp3=((($conv))|0) > ((($11))|0); //@line 319 "synth_mbrola.cpp"
      if ($cmp3) { __label__ = 4;; } else { __label__ = 5;; } //@line 319 "synth_mbrola.cpp"
      if (__label__ == 4) {
  
        var $12=$x; //@line 321 "synth_mbrola.cpp"
        var $13=$pitch_env; //@line 321 "synth_mbrola.cpp"
        var $arrayidx5=(($13+$12)&4294967295); //@line 321 "synth_mbrola.cpp"
        var $14=HEAPU8[($arrayidx5)]; //@line 321 "synth_mbrola.cpp"
        var $conv6=((($14))&255); //@line 321 "synth_mbrola.cpp"
        $max=$conv6; //@line 321 "synth_mbrola.cpp"
        var $15=$x; //@line 322 "synth_mbrola.cpp"
        $y_max=$15; //@line 322 "synth_mbrola.cpp"
        ; //@line 323 "synth_mbrola.cpp"
      }
  
      var $16=$x; //@line 324 "synth_mbrola.cpp"
      var $17=$pitch_env; //@line 324 "synth_mbrola.cpp"
      var $arrayidx8=(($17+$16)&4294967295); //@line 324 "synth_mbrola.cpp"
      var $18=HEAPU8[($arrayidx8)]; //@line 324 "synth_mbrola.cpp"
      var $conv9=((($18))&255); //@line 324 "synth_mbrola.cpp"
      var $19=$min; //@line 324 "synth_mbrola.cpp"
      var $cmp10=((($conv9))|0) < ((($19))|0); //@line 324 "synth_mbrola.cpp"
      if ($cmp10) { __label__ = 6;; } else { __label__ = 7;; } //@line 324 "synth_mbrola.cpp"
      if (__label__ == 6) {
  
        var $20=$x; //@line 326 "synth_mbrola.cpp"
        var $21=$pitch_env; //@line 326 "synth_mbrola.cpp"
        var $arrayidx12=(($21+$20)&4294967295); //@line 326 "synth_mbrola.cpp"
        var $22=HEAPU8[($arrayidx12)]; //@line 326 "synth_mbrola.cpp"
        var $conv13=((($22))&255); //@line 326 "synth_mbrola.cpp"
        $min=$conv13; //@line 326 "synth_mbrola.cpp"
        var $23=$x; //@line 327 "synth_mbrola.cpp"
        $y_min=$23; //@line 327 "synth_mbrola.cpp"
        ; //@line 328 "synth_mbrola.cpp"
      }
  
      var $24=$x; //@line 317 "synth_mbrola.cpp"
      var $inc=((($24)+1)&4294967295); //@line 317 "synth_mbrola.cpp"
      $x=$inc; //@line 317 "synth_mbrola.cpp"
      var $cmp1=((($inc))|0) < 128; //@line 317 "synth_mbrola.cpp"
      if ($cmp1) { __label__ = 3;continue $for_body$5; } else { __label__ = 8;break $for_body$5; } //@line 317 "synth_mbrola.cpp"
    }
  
    var $arrayidx15=(($y+8)&4294967295); //@line 332 "synth_mbrola.cpp"
    HEAP32[(($arrayidx15)>>2)]=64; //@line 332 "synth_mbrola.cpp"
    var $25=$y_max; //@line 333 "synth_mbrola.cpp"
    var $cmp16=((($25))|0) > 0; //@line 333 "synth_mbrola.cpp"
    var $26=$y_max; //@line 333 "synth_mbrola.cpp"
    var $cmp17=((($26))|0) < 127; //@line 333 "synth_mbrola.cpp"
    var $or_cond=($cmp16) & ($cmp17); //@line 333 "synth_mbrola.cpp"
    if ($or_cond) { __label__ = 9;; } else { __label__ = 10;; } //@line 333 "synth_mbrola.cpp"
    if (__label__ == 9) {
  
      var $27=$y_max; //@line 335 "synth_mbrola.cpp"
      var $arrayidx19=(($y+8)&4294967295); //@line 335 "synth_mbrola.cpp"
      HEAP32[(($arrayidx19)>>2)]=$27; //@line 335 "synth_mbrola.cpp"
      ; //@line 336 "synth_mbrola.cpp"
    }
  
    var $28=$y_min; //@line 337 "synth_mbrola.cpp"
    var $cmp21=((($28))|0) > 0; //@line 337 "synth_mbrola.cpp"
    var $29=$y_min; //@line 337 "synth_mbrola.cpp"
    var $cmp23=((($29))|0) < 127; //@line 337 "synth_mbrola.cpp"
    var $or_cond1=($cmp21) & ($cmp23); //@line 337 "synth_mbrola.cpp"
    if ($or_cond1) { __label__ = 11;; } else { __label__ = 12;; } //@line 337 "synth_mbrola.cpp"
    if (__label__ == 11) {
  
      var $30=$y_min; //@line 339 "synth_mbrola.cpp"
      var $arrayidx25=(($y+8)&4294967295); //@line 339 "synth_mbrola.cpp"
      HEAP32[(($arrayidx25)>>2)]=$30; //@line 339 "synth_mbrola.cpp"
      ; //@line 340 "synth_mbrola.cpp"
    }
  
    var $arrayidx27=(($y+8)&4294967295); //@line 341 "synth_mbrola.cpp"
    var $31=HEAP32[(($arrayidx27)>>2)]; //@line 341 "synth_mbrola.cpp"
    var $div28=((((($31))|0)/2)|0); //@line 341 "synth_mbrola.cpp"
    var $arrayidx29=(($y+4)&4294967295); //@line 341 "synth_mbrola.cpp"
    HEAP32[(($arrayidx29)>>2)]=$div28; //@line 341 "synth_mbrola.cpp"
    var $arrayidx30=(($y+8)&4294967295); //@line 342 "synth_mbrola.cpp"
    var $32=HEAP32[(($arrayidx30)>>2)]; //@line 342 "synth_mbrola.cpp"
    var $arrayidx31=(($y+8)&4294967295); //@line 342 "synth_mbrola.cpp"
    var $33=HEAP32[(($arrayidx31)>>2)]; //@line 342 "synth_mbrola.cpp"
    var $sub32=((127-($33))&4294967295); //@line 342 "synth_mbrola.cpp"
    var $div33=((((($sub32))|0)/2)|0); //@line 342 "synth_mbrola.cpp"
    var $add=((($div33)+($32))&4294967295); //@line 342 "synth_mbrola.cpp"
    var $arrayidx34=(($y+12)&4294967295); //@line 342 "synth_mbrola.cpp"
    HEAP32[(($arrayidx34)>>2)]=$add; //@line 342 "synth_mbrola.cpp"
    var $34=$pitch_env; //@line 345 "synth_mbrola.cpp"
    var $arrayidx35=(($34)&4294967295); //@line 345 "synth_mbrola.cpp"
    var $35=HEAPU8[($arrayidx35)]; //@line 345 "synth_mbrola.cpp"
    var $conv36=((($35))&255); //@line 345 "synth_mbrola.cpp"
    var $36=HEAP32[(($pitch_range)>>2)]; //@line 345 "synth_mbrola.cpp"
    var $mul37=((($conv36)*($36))&4294967295); //@line 345 "synth_mbrola.cpp"
    var $shr=($mul37) >> 8; //@line 345 "synth_mbrola.cpp"
    var $37=HEAP32[(($pitch_base)>>2)]; //@line 345 "synth_mbrola.cpp"
    var $add38=((($shr)+($37))&4294967295); //@line 345 "synth_mbrola.cpp"
    $p1=$add38; //@line 345 "synth_mbrola.cpp"
    var $38=$pitch_env; //@line 346 "synth_mbrola.cpp"
    var $arrayidx39=(($38+127)&4294967295); //@line 346 "synth_mbrola.cpp"
    var $39=HEAPU8[($arrayidx39)]; //@line 346 "synth_mbrola.cpp"
    var $conv40=((($39))&255); //@line 346 "synth_mbrola.cpp"
    var $40=HEAP32[(($pitch_range)>>2)]; //@line 346 "synth_mbrola.cpp"
    var $mul41=((($conv40)*($40))&4294967295); //@line 346 "synth_mbrola.cpp"
    var $shr42=($mul41) >> 8; //@line 346 "synth_mbrola.cpp"
    var $41=HEAP32[(($pitch_base)>>2)]; //@line 346 "synth_mbrola.cpp"
    var $add43=((($shr42)+($41))&4294967295); //@line 346 "synth_mbrola.cpp"
    $p_end=$add43; //@line 346 "synth_mbrola.cpp"
    var $42=$split_addr; //@line 349 "synth_mbrola.cpp"
    var $cmp44=((($42))|0) >= 0; //@line 349 "synth_mbrola.cpp"
    if ($cmp44) { __label__ = 13;; } else { __label__ = 14;; } //@line 349 "synth_mbrola.cpp"
    if (__label__ == 13) {
  
      var $arraydecay=(($buf)&4294967295); //@line 351 "synth_mbrola.cpp"
      var $43=$p1; //@line 351 "synth_mbrola.cpp"
      var $div46=((((($43))|0)/4096)|0); //@line 351 "synth_mbrola.cpp"
      var $call=_sprintf($arraydecay, ((__str13395)&4294967295), allocate([$div46,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 351 "synth_mbrola.cpp"
      var $arraydecay47=(($buf)&4294967295); //@line 352 "synth_mbrola.cpp"
      var $call48=_strcat(((__ZZL10WritePitchiiiiiE6output)&4294967295), $arraydecay47); //@line 352 "synth_mbrola.cpp"
      ; //@line 353 "synth_mbrola.cpp"
    }
  
    var $44=$env_addr; //@line 356 "synth_mbrola.cpp"
    var $cmp50=((($44))|0) > 1; //@line 356 "synth_mbrola.cpp"
    if ($cmp50) { __label__ = 15;; } else { __label__ = 25;; } //@line 356 "synth_mbrola.cpp"
    $if_then51$$if_end91$23: do { 
      if (__label__ == 15) {
  
        $ix=1; //@line 358 "synth_mbrola.cpp"
        var $arraydecay82=(($buf)&4294967295); //@line 377 "synth_mbrola.cpp"
        var $arraydecay85=(($buf)&4294967295); //@line 378 "synth_mbrola.cpp"
        ; //@line 358 "synth_mbrola.cpp"
        $for_body54$25: while(1) { 
  
          var $45=$ix; //@line 360 "synth_mbrola.cpp"
          var $arrayidx55=(($y+$45*4)&4294967295); //@line 360 "synth_mbrola.cpp"
          var $46=HEAP32[(($arrayidx55)>>2)]; //@line 360 "synth_mbrola.cpp"
          var $47=$pitch_env; //@line 360 "synth_mbrola.cpp"
          var $arrayidx56=(($47+$46)&4294967295); //@line 360 "synth_mbrola.cpp"
          var $48=HEAPU8[($arrayidx56)]; //@line 360 "synth_mbrola.cpp"
          var $conv57=((($48))&255); //@line 360 "synth_mbrola.cpp"
          var $49=HEAP32[(($pitch_range)>>2)]; //@line 360 "synth_mbrola.cpp"
          var $mul58=((($conv57)*($49))&4294967295); //@line 360 "synth_mbrola.cpp"
          var $shr59=($mul58) >> 8; //@line 360 "synth_mbrola.cpp"
          var $50=HEAP32[(($pitch_base)>>2)]; //@line 360 "synth_mbrola.cpp"
          var $add60=((($shr59)+($50))&4294967295); //@line 360 "synth_mbrola.cpp"
          $p2=$add60; //@line 360 "synth_mbrola.cpp"
          var $51=$split_addr; //@line 362 "synth_mbrola.cpp"
          var $cmp61=((($51))|0) > 0; //@line 362 "synth_mbrola.cpp"
          if ($cmp61) { __label__ = 17;; } else { __label__ = 18;; } //@line 362 "synth_mbrola.cpp"
          if (__label__ == 17) {
  
            var $52=$ix; //@line 364 "synth_mbrola.cpp"
            var $arrayidx63=(($y+$52*4)&4294967295); //@line 364 "synth_mbrola.cpp"
            var $53=HEAP32[(($arrayidx63)>>2)]; //@line 364 "synth_mbrola.cpp"
            var $54=$env100; //@line 364 "synth_mbrola.cpp"
            var $mul64=((($54)*($53))&4294967295); //@line 364 "synth_mbrola.cpp"
            var $55=$env_split; //@line 364 "synth_mbrola.cpp"
            var $div65=((((($mul64))|0)/((($55))|0))|0); //@line 364 "synth_mbrola.cpp"
            $y2=$div65; //@line 364 "synth_mbrola.cpp"
            __lastLabel__ = 17; ; //@line 365 "synth_mbrola.cpp"
          }
          else if (__label__ == 18) {
  
            var $56=$split_addr; //@line 367 "synth_mbrola.cpp"
            var $cmp66=((($56))|0) < 0; //@line 367 "synth_mbrola.cpp"
            var $57=$ix; //@line 369 "synth_mbrola.cpp"
            var $arrayidx68=(($y+$57*4)&4294967295); //@line 369 "synth_mbrola.cpp"
            var $58=HEAP32[(($arrayidx68)>>2)]; //@line 369 "synth_mbrola.cpp"
            if ($cmp66) { __label__ = 19;; } else { __label__ = 20;; } //@line 367 "synth_mbrola.cpp"
            if (__label__ == 19) {
  
              var $59=$env_split; //@line 369 "synth_mbrola.cpp"
              var $sub69=((($58)-($59))&4294967295); //@line 369 "synth_mbrola.cpp"
              var $60=$env100; //@line 369 "synth_mbrola.cpp"
              var $mul70=((($sub69)*($60))&4294967295); //@line 369 "synth_mbrola.cpp"
              var $61=$env_split; //@line 369 "synth_mbrola.cpp"
              var $div71=((((($mul70))|0)/((($61))|0))|0); //@line 369 "synth_mbrola.cpp"
              $y2=$div71; //@line 369 "synth_mbrola.cpp"
              __lastLabel__ = 19; ; //@line 370 "synth_mbrola.cpp"
            }
            else if (__label__ == 20) {
  
              var $62=$env100; //@line 373 "synth_mbrola.cpp"
              var $mul74=((($62)*($58))&4294967295); //@line 373 "synth_mbrola.cpp"
              var $div75=((((($mul74))|0)/128)|0); //@line 373 "synth_mbrola.cpp"
              $y2=$div75; //@line 373 "synth_mbrola.cpp"
              __lastLabel__ = 20; ;
            }
          }
  
          var $63=__lastLabel__ == 19 ? $div71 : (__lastLabel__ == 20 ? $div75 : ($div65)); //@line 375 "synth_mbrola.cpp"
          var $cmp78=((($63))|0) > 0; //@line 375 "synth_mbrola.cpp"
          if ($cmp78) { __label__ = 22;; } else { __label__ = 24;; } //@line 375 "synth_mbrola.cpp"
          $land_lhs_true79$$for_inc88$34: do { 
            if (__label__ == 22) {
  
              var $64=$y2; //@line 375 "synth_mbrola.cpp"
              var $65=$env100; //@line 375 "synth_mbrola.cpp"
              var $cmp80=((($64))|0) <= ((($65))|0); //@line 375 "synth_mbrola.cpp"
              if (!($cmp80)) { __label__ = 24;break $land_lhs_true79$$for_inc88$34; } //@line 375 "synth_mbrola.cpp"
  
              var $66=$y2; //@line 377 "synth_mbrola.cpp"
              var $67=$p2; //@line 377 "synth_mbrola.cpp"
              var $div83=((((($67))|0)/4096)|0); //@line 377 "synth_mbrola.cpp"
              var $call84=_sprintf($arraydecay82, ((__str14396)&4294967295), allocate([$66,0,0,0,$div83,0,0,0], ["i32",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 377 "synth_mbrola.cpp"
              var $call86=_strcat(((__ZZL10WritePitchiiiiiE6output)&4294967295), $arraydecay85); //@line 378 "synth_mbrola.cpp"
              ; //@line 379 "synth_mbrola.cpp"
            }
          } while(0);
  
          var $68=$ix; //@line 358 "synth_mbrola.cpp"
          var $inc89=((($68)+1)&4294967295); //@line 358 "synth_mbrola.cpp"
          $ix=$inc89; //@line 358 "synth_mbrola.cpp"
          var $cmp53=((($inc89))|0) < 4; //@line 358 "synth_mbrola.cpp"
          if ($cmp53) { __label__ = 16;continue $for_body54$25; } else { __label__ = 25;break $if_then51$$if_end91$23; } //@line 358 "synth_mbrola.cpp"
        }
      }
    } while(0);
  
    var $69=$p_end; //@line 383 "synth_mbrola.cpp"
    var $div92=((((($69))|0)/4096)|0); //@line 383 "synth_mbrola.cpp"
    $p_end=$div92; //@line 383 "synth_mbrola.cpp"
    var $70=$split_addr; //@line 384 "synth_mbrola.cpp"
    var $cmp93=((($70))|0) <= 0; //@line 384 "synth_mbrola.cpp"
    if ($cmp93) { __label__ = 26;; } else { __label__ = 27;; } //@line 384 "synth_mbrola.cpp"
    if (__label__ == 26) {
  
      var $arraydecay95=(($buf)&4294967295); //@line 386 "synth_mbrola.cpp"
      var $71=$env100; //@line 386 "synth_mbrola.cpp"
      var $72=$p_end; //@line 386 "synth_mbrola.cpp"
      var $call96=_sprintf($arraydecay95, ((__str14396)&4294967295), allocate([$71,0,0,0,$72,0,0,0], ["i32",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 386 "synth_mbrola.cpp"
      var $arraydecay97=(($buf)&4294967295); //@line 387 "synth_mbrola.cpp"
      var $call98=_strcat(((__ZZL10WritePitchiiiiiE6output)&4294967295), $arraydecay97); //@line 387 "synth_mbrola.cpp"
      ; //@line 388 "synth_mbrola.cpp"
    }
  
    var $73=$env100; //@line 389 "synth_mbrola.cpp"
    var $cmp100=((($73))|0) < 100; //@line 389 "synth_mbrola.cpp"
    if ($cmp100) { __label__ = 28;; } else { __label__ = 29;; } //@line 389 "synth_mbrola.cpp"
    if (__label__ == 28) {
  
      var $arraydecay102=(($buf)&4294967295); //@line 391 "synth_mbrola.cpp"
      var $74=$p_end; //@line 391 "synth_mbrola.cpp"
      var $call103=_sprintf($arraydecay102, ((__str14396)&4294967295), allocate([100,0,0,0,$74,0,0,0], ["i32",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 391 "synth_mbrola.cpp"
      var $arraydecay104=(($buf)&4294967295); //@line 392 "synth_mbrola.cpp"
      var $call105=_strcat(((__ZZL10WritePitchiiiiiE6output)&4294967295), $arraydecay104); //@line 392 "synth_mbrola.cpp"
      ; //@line 393 "synth_mbrola.cpp"
    }
  
    var $strlen=_strlen(((__ZZL10WritePitchiiiiiE6output)&4294967295)); //@line 394 "synth_mbrola.cpp"
    var $endptr=((((__ZZL10WritePitchiiiiiE6output)&4294967295)+$strlen)&4294967295); //@line 394 "synth_mbrola.cpp"
    var $src$, $dest$, $stop$, $stop4$, $fast$;
    $src$ = ((__str15397)&4294967295);
    $dest$ = $endptr;
    $stop$ = $src$ + 2;
    if (($dest$%4) == ($src$%4) && 2 > 8) {
      while ($src$%4 !== 0 && $src$ < $stop$) {
        ; HEAP8[$dest$++] = HEAP8[$src$++];
      }
      $src$ >>= 2;
      $dest$ >>= 2;
      $stop4$ = $stop$ >> 2;
      while ($src$ < $stop4$) {
    ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
      }
      $src$ <<= 2;
      $dest$ <<= 2;
    }while ($src$ < $stop$) {
      ; HEAP8[$dest$++] = HEAP8[$src$++];
    }; //@line 394 "synth_mbrola.cpp"
    var $75=$final_addr; //@line 396 "synth_mbrola.cpp"
    var $tobool=((($75))|0)!=0; //@line 396 "synth_mbrola.cpp"
    if ($tobool) { __label__ = 30;; } else { __label__ = 31;; } //@line 396 "synth_mbrola.cpp"
    if (__label__ == 30) {
  
      var $76=$p_end; //@line 397 "synth_mbrola.cpp"
      var $call109=_sprintf(((__ZZL10WritePitchiiiiiE6output)&4294967295), ((__str16398)&4294967295), allocate([$76,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 397 "synth_mbrola.cpp"
      ; //@line 397 "synth_mbrola.cpp"
    }
  
    STACKTOP = __stackBase__;
    return;
    return;
  }
  

  function __Z14MbrolaGenerateP12PHONEME_LISTPii($phoneme_list, $n_ph, $resume) {
    ;
    var __label__;
  
    var $retval;
    var $phoneme_list_addr;
    var $n_ph_addr;
    var $resume_addr;
    var $f_mbrola;
    var $again;
    $phoneme_list_addr=$phoneme_list;
    $n_ph_addr=$n_ph;
    $resume_addr=$resume;
    $f_mbrola=0; //@line 630 "synth_mbrola.cpp"
    var $0=$n_ph_addr; //@line 632 "synth_mbrola.cpp"
    var $1=HEAP32[(($0)>>2)]; //@line 632 "synth_mbrola.cpp"
    var $cmp=((($1))|0)==0; //@line 632 "synth_mbrola.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 632 "synth_mbrola.cpp"
    if (__label__ == 1) {
  
      $retval=0; //@line 633 "synth_mbrola.cpp"
      ; //@line 633 "synth_mbrola.cpp"
    }
    else if (__label__ == 2) {
  
      var $2=HEAP32[((_option_mbrola_phonemes)>>2)]; //@line 635 "synth_mbrola.cpp"
      var $tobool=((($2))|0)!=0; //@line 635 "synth_mbrola.cpp"
      if ($tobool) { __label__ = 3;; } else { __label__ = 4;; } //@line 635 "synth_mbrola.cpp"
      if (__label__ == 3) {
  
        var $3=HEAP32[((_f_trans)>>2)]; //@line 638 "synth_mbrola.cpp"
        $f_mbrola=$3; //@line 638 "synth_mbrola.cpp"
        ; //@line 639 "synth_mbrola.cpp"
      }
  
      var $4=$phoneme_list_addr; //@line 641 "synth_mbrola.cpp"
      var $5=$n_ph_addr; //@line 641 "synth_mbrola.cpp"
      var $6=HEAP32[(($5)>>2)]; //@line 641 "synth_mbrola.cpp"
      var $7=$resume_addr; //@line 641 "synth_mbrola.cpp"
      var $8=$f_mbrola; //@line 641 "synth_mbrola.cpp"
      var $call=__Z15MbrolaTranslateP12PHONEME_LISTiiP7__sFILE($4, $6, $7, $8); //@line 641 "synth_mbrola.cpp"
      $again=$call; //@line 641 "synth_mbrola.cpp"
      var $tobool3=((($call))|0)!=0; //@line 642 "synth_mbrola.cpp"
      if ($tobool3) { __label__ = 6;; } else { __label__ = 5;; } //@line 642 "synth_mbrola.cpp"
      if (__label__ == 5) {
  
        var $9=$n_ph_addr; //@line 643 "synth_mbrola.cpp"
        HEAP32[(($9)>>2)]=0; //@line 643 "synth_mbrola.cpp"
        ; //@line 643 "synth_mbrola.cpp"
      }
  
      var $10=$again; //@line 644 "synth_mbrola.cpp"
      $retval=$10; //@line 644 "synth_mbrola.cpp"
      ; //@line 644 "synth_mbrola.cpp"
    }
  
    var $11=$retval; //@line 645 "synth_mbrola.cpp"
    ;
    return $11; //@line 645 "synth_mbrola.cpp"
    return null;
  }
  

  function __Z10MbrolaFillii($length, $resume) {
    ;
    var __label__;
  
    var $retval;
    var $length_addr;
    var $resume_addr;
    var $req_samples;
    var $result;
    $length_addr=$length;
    $resume_addr=$resume;
    var $0=$resume_addr; //@line 655 "synth_mbrola.cpp"
    var $tobool=((($0))|0)!=0; //@line 655 "synth_mbrola.cpp"
    if ($tobool) { __label__ = 2;; } else { __label__ = 1;; } //@line 655 "synth_mbrola.cpp"
    if (__label__ == 1) {
  
      var $1=HEAP32[((_samplerate)>>2)]; //@line 656 "synth_mbrola.cpp"
      var $2=$length_addr; //@line 656 "synth_mbrola.cpp"
      var $mul=((($2)*($1))&4294967295); //@line 656 "synth_mbrola.cpp"
      var $div=((((($mul))|0)/1000)|0); //@line 656 "synth_mbrola.cpp"
      HEAP32[((__ZZ10MbrolaFilliiE9n_samples)>>2)]=$div; //@line 656 "synth_mbrola.cpp"
      ; //@line 656 "synth_mbrola.cpp"
    }
  
    var $3=HEAP32[((_out_end)>>2)]; //@line 658 "synth_mbrola.cpp"
    var $4=HEAP32[((_out_ptr)>>2)]; //@line 658 "synth_mbrola.cpp"
    var $sub_ptr_lhs_cast=($3); //@line 658 "synth_mbrola.cpp"
    var $sub_ptr_rhs_cast=($4); //@line 658 "synth_mbrola.cpp"
    var $sub_ptr_sub=((($sub_ptr_lhs_cast)-($sub_ptr_rhs_cast))&4294967295); //@line 658 "synth_mbrola.cpp"
    var $div1=((((($sub_ptr_sub))|0)/2)|0); //@line 658 "synth_mbrola.cpp"
    $req_samples=$div1; //@line 658 "synth_mbrola.cpp"
    var $5=$req_samples; //@line 659 "synth_mbrola.cpp"
    var $6=HEAP32[((__ZZ10MbrolaFilliiE9n_samples)>>2)]; //@line 659 "synth_mbrola.cpp"
    var $cmp=((($5))|0) > ((($6))|0); //@line 659 "synth_mbrola.cpp"
    if ($cmp) { __label__ = 3;; } else { __label__ = 4;; } //@line 659 "synth_mbrola.cpp"
    if (__label__ == 3) {
  
      var $7=HEAP32[((__ZZ10MbrolaFilliiE9n_samples)>>2)]; //@line 660 "synth_mbrola.cpp"
      $req_samples=$7; //@line 660 "synth_mbrola.cpp"
      ; //@line 660 "synth_mbrola.cpp"
    }
  
    var $8=HEAP32[((_out_ptr)>>2)]; //@line 661 "synth_mbrola.cpp"
    var $9=$8; //@line 661 "synth_mbrola.cpp"
    var $10=$9; //@line 661 "synth_mbrola.cpp"
    var $11=$req_samples; //@line 661 "synth_mbrola.cpp"
    var $call=_read_MBR($10, $11); //@line 661 "synth_mbrola.cpp"
    $result=$call; //@line 661 "synth_mbrola.cpp"
    var $cmp4=((($call))|0) <= 0; //@line 662 "synth_mbrola.cpp"
    if ($cmp4) { __label__ = 5;; } else { __label__ = 6;; } //@line 662 "synth_mbrola.cpp"
    if (__label__ == 5) {
  
      $retval=0; //@line 663 "synth_mbrola.cpp"
      ; //@line 663 "synth_mbrola.cpp"
    }
    else if (__label__ == 6) {
  
      var $12=$result; //@line 664 "synth_mbrola.cpp"
      var $mul7=((($12)*2)&4294967295); //@line 664 "synth_mbrola.cpp"
      var $13=HEAP32[((_out_ptr)>>2)]; //@line 664 "synth_mbrola.cpp"
      var $add_ptr=(($13+$mul7)&4294967295); //@line 664 "synth_mbrola.cpp"
      HEAP32[((_out_ptr)>>2)]=$add_ptr; //@line 664 "synth_mbrola.cpp"
      var $14=$result; //@line 665 "synth_mbrola.cpp"
      var $15=HEAP32[((__ZZ10MbrolaFilliiE9n_samples)>>2)]; //@line 665 "synth_mbrola.cpp"
      var $sub=((($15)-($14))&4294967295); //@line 665 "synth_mbrola.cpp"
      HEAP32[((__ZZ10MbrolaFilliiE9n_samples)>>2)]=$sub; //@line 665 "synth_mbrola.cpp"
      var $16=HEAP32[((__ZZ10MbrolaFilliiE9n_samples)>>2)]; //@line 666 "synth_mbrola.cpp"
      var $tobool8=((($16))|0)!=0; //@line 666 "synth_mbrola.cpp"
      var $cond=($tobool8) ? 1 : 0; //@line 666 "synth_mbrola.cpp"
      $retval=$cond; //@line 666 "synth_mbrola.cpp"
      ; //@line 666 "synth_mbrola.cpp"
    }
  
    var $17=$retval; //@line 667 "synth_mbrola.cpp"
    ;
    return $17; //@line 667 "synth_mbrola.cpp"
    return null;
  }
  

  function __Z11MbrolaResetv() {
    ;
    var __label__;
  
    var $call=_reset_MBR(); //@line 674 "synth_mbrola.cpp"
    ;
    return; //@line 675 "synth_mbrola.cpp"
    return;
  }
  

  function __Z10LoadPhDatav() {
    var __stackBase__  = STACKTOP; STACKTOP += 4; _memset(__stackBase__, 0, 4);
    var __label__;
  
    var $retval;
    var $ix;
    var $n_phonemes;
    var $version;
    var $result;
    var $length=__stackBase__;
    var $p;
    var $pw;
    $result=1; //@line 116 "synthdata.cpp"
    var $0=HEAP32[((__ZL16phoneme_tab_data)>>2)]; //@line 121 "synthdata.cpp"
    var $call=__ZL10ReadPhFilePvPKcPi($0, ((__str1412)&4294967295), 0); //@line 121 "synthdata.cpp"
    HEAP32[((__ZL16phoneme_tab_data)>>2)]=$call; //@line 121 "synthdata.cpp"
    var $cmp=((($call))|0)==0; //@line 121 "synthdata.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 121 "synthdata.cpp"
    if (__label__ == 1) {
  
      $retval=-1; //@line 122 "synthdata.cpp"
      ; //@line 122 "synthdata.cpp"
    }
    else if (__label__ == 2) {
  
      var $1=HEAP32[((_phoneme_index)>>2)]; //@line 123 "synthdata.cpp"
      var $2=$1; //@line 123 "synthdata.cpp"
      var $call1=__ZL10ReadPhFilePvPKcPi($2, ((__str2413)&4294967295), 0); //@line 123 "synthdata.cpp"
      var $3=$call1; //@line 123 "synthdata.cpp"
      HEAP32[((_phoneme_index)>>2)]=$3; //@line 123 "synthdata.cpp"
      var $cmp2=((($3))|0)==0; //@line 123 "synthdata.cpp"
      if ($cmp2) { __label__ = 3;; } else { __label__ = 4;; } //@line 123 "synthdata.cpp"
      if (__label__ == 3) {
  
        $retval=-1; //@line 124 "synthdata.cpp"
        ; //@line 124 "synthdata.cpp"
      }
      else if (__label__ == 4) {
  
        var $4=HEAP32[((_phondata_ptr)>>2)]; //@line 125 "synthdata.cpp"
        var $call5=__ZL10ReadPhFilePvPKcPi($4, ((__str3414)&4294967295), 0); //@line 125 "synthdata.cpp"
        HEAP32[((_phondata_ptr)>>2)]=$call5; //@line 125 "synthdata.cpp"
        var $cmp6=((($call5))|0)==0; //@line 125 "synthdata.cpp"
        if ($cmp6) { __label__ = 5;; } else { __label__ = 6;; } //@line 125 "synthdata.cpp"
        if (__label__ == 5) {
  
          $retval=-1; //@line 126 "synthdata.cpp"
          ; //@line 126 "synthdata.cpp"
        }
        else if (__label__ == 6) {
  
          var $5=HEAP32[((_tunes)>>2)]; //@line 127 "synthdata.cpp"
          var $6=$5; //@line 127 "synthdata.cpp"
          var $call9=__ZL10ReadPhFilePvPKcPi($6, ((__str4415)&4294967295), $length); //@line 127 "synthdata.cpp"
          var $7=$call9; //@line 127 "synthdata.cpp"
          HEAP32[((_tunes)>>2)]=$7; //@line 127 "synthdata.cpp"
          var $cmp10=((($7))|0)==0; //@line 127 "synthdata.cpp"
          if ($cmp10) { __label__ = 7;; } else { __label__ = 8;; } //@line 127 "synthdata.cpp"
          if (__label__ == 7) {
  
            $retval=-1; //@line 128 "synthdata.cpp"
            ; //@line 128 "synthdata.cpp"
          }
          else if (__label__ == 8) {
  
            var $8=HEAP32[((_phondata_ptr)>>2)]; //@line 129 "synthdata.cpp"
            HEAP32[((_wavefile_data)>>2)]=$8; //@line 129 "synthdata.cpp"
            var $9=HEAPU32[(($length)>>2)]; //@line 130 "synthdata.cpp"
            var $div=Math.floor(((($9))>>>0)/68); //@line 130 "synthdata.cpp"
            HEAP32[((_n_tunes)>>2)]=$div; //@line 130 "synthdata.cpp"
            $version=0; //@line 133 "synthdata.cpp"
            $ix=0; //@line 134 "synthdata.cpp"
            ; //@line 134 "synthdata.cpp"
            $for_body$14: while(1) { 
  
              var $10=$ix; //@line 136 "synthdata.cpp"
              var $11=HEAP32[((_wavefile_data)>>2)]; //@line 136 "synthdata.cpp"
              var $arrayidx=(($11+$10)&4294967295); //@line 136 "synthdata.cpp"
              var $12=HEAPU8[($arrayidx)]; //@line 136 "synthdata.cpp"
              var $conv=((($12))&255); //@line 136 "synthdata.cpp"
              var $13=$ix; //@line 136 "synthdata.cpp"
              var $mul=((($13)*8)&4294967295); //@line 136 "synthdata.cpp"
              var $shl=($conv) << ($mul); //@line 136 "synthdata.cpp"
              var $14=$version; //@line 136 "synthdata.cpp"
              var $add=((($shl)+($14))&4294967295); //@line 136 "synthdata.cpp"
              $version=$add; //@line 136 "synthdata.cpp"
              var $15=$ix; //@line 134 "synthdata.cpp"
              var $inc=((($15)+1)&4294967295); //@line 134 "synthdata.cpp"
              $ix=$inc; //@line 134 "synthdata.cpp"
              var $cmp13=((($inc))|0) < 4; //@line 134 "synthdata.cpp"
              if ($cmp13) { __label__ = 9;continue $for_body$14; } else { __label__ = 10;break $for_body$14; } //@line 134 "synthdata.cpp"
            }
  
            var $16=$version; //@line 139 "synthdata.cpp"
            var $cmp14=((($16))|0)!=83200; //@line 139 "synthdata.cpp"
            if ($cmp14) { __label__ = 11;; } else { __label__ = 12;; } //@line 139 "synthdata.cpp"
            if (__label__ == 11) {
  
              var $17=$version; //@line 141 "synthdata.cpp"
              $result=$17; //@line 141 "synthdata.cpp"
              ; //@line 142 "synthdata.cpp"
            }
  
            var $18=HEAP32[((__ZL16phoneme_tab_data)>>2)]; //@line 145 "synthdata.cpp"
            $p=$18; //@line 145 "synthdata.cpp"
            var $19=$p; //@line 146 "synthdata.cpp"
            var $arrayidx17=(($19)&4294967295); //@line 146 "synthdata.cpp"
            var $20=HEAPU8[($arrayidx17)]; //@line 146 "synthdata.cpp"
            var $conv18=((($20))&255); //@line 146 "synthdata.cpp"
            HEAP32[((_n_phoneme_tables)>>2)]=$conv18; //@line 146 "synthdata.cpp"
            var $21=$p; //@line 147 "synthdata.cpp"
            var $add_ptr=(($21+4)&4294967295); //@line 147 "synthdata.cpp"
            $p=$add_ptr; //@line 147 "synthdata.cpp"
            $ix=0; //@line 149 "synthdata.cpp"
            var $22=$ix; //@line 149 "synthdata.cpp"
            var $23=HEAP32[((_n_phoneme_tables)>>2)]; //@line 149 "synthdata.cpp"
            var $cmp201=((($22))|0) < ((($23))|0); //@line 149 "synthdata.cpp"
            if ($cmp201) { __label__ = 13;; } else { __label__ = 14;; } //@line 149 "synthdata.cpp"
            $for_body21$$for_end42$20: do { 
              if (__label__ == 13) {
                while(1) { 
  
                  var $24=$p; //@line 151 "synthdata.cpp"
                  var $arrayidx22=(($24)&4294967295); //@line 151 "synthdata.cpp"
                  var $25=HEAPU8[($arrayidx22)]; //@line 151 "synthdata.cpp"
                  var $conv23=((($25))&255); //@line 151 "synthdata.cpp"
                  $n_phonemes=$conv23; //@line 151 "synthdata.cpp"
                  var $26=$p; //@line 152 "synthdata.cpp"
                  var $arrayidx24=(($26)&4294967295); //@line 152 "synthdata.cpp"
                  var $27=HEAPU8[($arrayidx24)]; //@line 152 "synthdata.cpp"
                  var $conv25=((($27))&255); //@line 152 "synthdata.cpp"
                  var $28=$ix; //@line 152 "synthdata.cpp"
                  var $arrayidx26=((_phoneme_tab_list+$28*48)&4294967295); //@line 152 "synthdata.cpp"
                  var $n_phonemes27=(($arrayidx26+36)&4294967295); //@line 152 "synthdata.cpp"
                  HEAP32[(($n_phonemes27)>>2)]=$conv25; //@line 152 "synthdata.cpp"
                  var $29=$p; //@line 153 "synthdata.cpp"
                  var $arrayidx28=(($29+1)&4294967295); //@line 153 "synthdata.cpp"
                  var $30=HEAPU8[($arrayidx28)]; //@line 153 "synthdata.cpp"
                  var $conv29=((($30))&255); //@line 153 "synthdata.cpp"
                  var $31=$ix; //@line 153 "synthdata.cpp"
                  var $arrayidx30=((_phoneme_tab_list+$31*48)&4294967295); //@line 153 "synthdata.cpp"
                  var $includes=(($arrayidx30+40)&4294967295); //@line 153 "synthdata.cpp"
                  HEAP32[(($includes)>>2)]=$conv29; //@line 153 "synthdata.cpp"
                  var $32=$p; //@line 154 "synthdata.cpp"
                  var $33=$32; //@line 154 "synthdata.cpp"
                  $pw=$33; //@line 154 "synthdata.cpp"
                  var $34=$pw; //@line 155 "synthdata.cpp"
                  var $arrayidx31=(($34+4)&4294967295); //@line 155 "synthdata.cpp"
                  var $35=HEAP32[(($arrayidx31)>>2)]; //@line 155 "synthdata.cpp"
                  var $call32=__Z13Reverse4Bytesi($35); //@line 155 "synthdata.cpp"
                  var $36=$ix; //@line 155 "synthdata.cpp"
                  var $arrayidx33=((_phoneme_tab_list+$36*48)&4294967295); //@line 155 "synthdata.cpp"
                  var $equivalence_tables=(($arrayidx33+44)&4294967295); //@line 155 "synthdata.cpp"
                  HEAP32[(($equivalence_tables)>>2)]=$call32; //@line 155 "synthdata.cpp"
                  var $37=$p; //@line 156 "synthdata.cpp"
                  var $add_ptr34=(($37+8)&4294967295); //@line 156 "synthdata.cpp"
                  $p=$add_ptr34; //@line 156 "synthdata.cpp"
                  var $38=$ix; //@line 157 "synthdata.cpp"
                  var $arrayidx35=((_phoneme_tab_list+$38*48)&4294967295); //@line 157 "synthdata.cpp"
                  var $name=(($arrayidx35)&4294967295); //@line 157 "synthdata.cpp"
                  var $arraydecay=(($name)&4294967295); //@line 157 "synthdata.cpp"
                  var $39=$p; //@line 157 "synthdata.cpp"
                  var $src$, $dest$, $stop$, $stop4$, $fast$;
                  $src$ = $39;
                  $dest$ = $arraydecay;
                  $stop$ = $src$ + 32;
                  if (($dest$%4) == ($src$%4) && 32 > 8) {
                    while ($src$%4 !== 0 && $src$ < $stop$) {
                      ; HEAP8[$dest$++] = HEAP8[$src$++];
                    }
                    $src$ >>= 2;
                    $dest$ >>= 2;
                    $stop4$ = $stop$ >> 2;
                    while ($src$ < $stop4$) {
                  ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
                    }
                    $src$ <<= 2;
                    $dest$ <<= 2;
                  }while ($src$ < $stop$) {
                    ; HEAP8[$dest$++] = HEAP8[$src$++];
                  }; //@line 157 "synthdata.cpp"
                  var $40=$p; //@line 158 "synthdata.cpp"
                  var $add_ptr36=(($40+32)&4294967295); //@line 158 "synthdata.cpp"
                  $p=$add_ptr36; //@line 158 "synthdata.cpp"
                  var $41=$p; //@line 159 "synthdata.cpp"
                  var $42=$41; //@line 159 "synthdata.cpp"
                  var $43=$ix; //@line 159 "synthdata.cpp"
                  var $arrayidx37=((_phoneme_tab_list+$43*48)&4294967295); //@line 159 "synthdata.cpp"
                  var $phoneme_tab_ptr=(($arrayidx37+32)&4294967295); //@line 159 "synthdata.cpp"
                  HEAP32[(($phoneme_tab_ptr)>>2)]=$42; //@line 159 "synthdata.cpp"
                  var $44=$n_phonemes; //@line 160 "synthdata.cpp"
                  var $mul38=((($44)*16)&4294967295); //@line 160 "synthdata.cpp"
                  var $45=$p; //@line 160 "synthdata.cpp"
                  var $add_ptr39=(($45+$mul38)&4294967295); //@line 160 "synthdata.cpp"
                  $p=$add_ptr39; //@line 160 "synthdata.cpp"
                  var $46=$ix; //@line 149 "synthdata.cpp"
                  var $inc41=((($46)+1)&4294967295); //@line 149 "synthdata.cpp"
                  $ix=$inc41; //@line 149 "synthdata.cpp"
                  var $47=$ix; //@line 149 "synthdata.cpp"
                  var $48=HEAP32[((_n_phoneme_tables)>>2)]; //@line 149 "synthdata.cpp"
                  var $cmp20=((($47))|0) < ((($48))|0); //@line 149 "synthdata.cpp"
                  if ($cmp20) { __label__ = 13;continue ; } else { __label__ = 14;break $for_body21$$for_end42$20; } //@line 149 "synthdata.cpp"
                }
              }
            } while(0);
  
            var $49=HEAP32[((_phoneme_tab_number)>>2)]; //@line 163 "synthdata.cpp"
            var $50=HEAP32[((_n_phoneme_tables)>>2)]; //@line 163 "synthdata.cpp"
            var $cmp43=((($49))|0) >= ((($50))|0); //@line 163 "synthdata.cpp"
            if ($cmp43) { __label__ = 15;; } else { __label__ = 16;; } //@line 163 "synthdata.cpp"
            if (__label__ == 15) {
  
              HEAP32[((_phoneme_tab_number)>>2)]=0; //@line 164 "synthdata.cpp"
              ; //@line 164 "synthdata.cpp"
            }
  
            var $51=$result; //@line 166 "synthdata.cpp"
            $retval=$51; //@line 166 "synthdata.cpp"
            ; //@line 166 "synthdata.cpp"
          }
        }
      }
    }
  
    var $52=$retval; //@line 167 "synthdata.cpp"
    STACKTOP = __stackBase__;
    return $52; //@line 167 "synthdata.cpp"
    return null;
  }
  

  function __ZL10ReadPhFilePvPKcPi($ptr, $fname, $size) {
    var __stackBase__  = STACKTOP; STACKTOP += 192; _memset(__stackBase__, 0, 192);
    var __label__;
  
    var $retval;
    var $ptr_addr;
    var $fname_addr;
    var $size_addr;
    var $f_in;
    var $p;
    var $length;
    var $buf=__stackBase__;
    $ptr_addr=$ptr;
    $fname_addr=$fname;
    $size_addr=$size;
    var $arraydecay=(($buf)&4294967295); //@line 81 "synthdata.cpp"
    var $0=$fname_addr; //@line 81 "synthdata.cpp"
    var $call=_sprintf($arraydecay, ((__str74726)&4294967295), allocate([((_path_home)&4294967295),0,0,0,47,0,0,0,$0,0,0,0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 81 "synthdata.cpp"
    var $arraydecay1=(($buf)&4294967295); //@line 82 "synthdata.cpp"
    var $call2=__Z13GetFileLengthPKc($arraydecay1); //@line 82 "synthdata.cpp"
    $length=$call2; //@line 82 "synthdata.cpp"
    var $arraydecay3=(($buf)&4294967295); //@line 84 "synthdata.cpp"
    var $call4=_fopen($arraydecay3, ((__str18429)&4294967295)); //@line 84 "synthdata.cpp"
    $f_in=$call4; //@line 84 "synthdata.cpp"
    var $cmp=((($call4))|0)==0; //@line 84 "synthdata.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 84 "synthdata.cpp"
    if (__label__ == 1) {
  
      var $1=HEAP32[((__impure_ptr)>>2)]; //@line 86 "synthdata.cpp"
      var $_stderr=(($1+12)&4294967295); //@line 86 "synthdata.cpp"
      var $2=HEAP32[(($_stderr)>>2)]; //@line 86 "synthdata.cpp"
      var $arraydecay5=(($buf)&4294967295); //@line 86 "synthdata.cpp"
      var $call6=_fprintf($2, ((__str19430)&4294967295), allocate([$arraydecay5,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 86 "synthdata.cpp"
      $retval=0; //@line 87 "synthdata.cpp"
      ; //@line 87 "synthdata.cpp"
    }
    else if (__label__ == 2) {
  
      var $3=$ptr_addr; //@line 90 "synthdata.cpp"
      var $cmp7=((($3))|0)!=0; //@line 90 "synthdata.cpp"
      if ($cmp7) { __label__ = 3;; } else { __label__ = 4;; } //@line 90 "synthdata.cpp"
      if (__label__ == 3) {
  
        var $4=$ptr_addr; //@line 91 "synthdata.cpp"
        __Z4FreePv($4); //@line 91 "synthdata.cpp"
        ; //@line 91 "synthdata.cpp"
      }
  
      var $5=$length; //@line 93 "synthdata.cpp"
      var $call10=__Z5Alloci($5); //@line 93 "synthdata.cpp"
      $p=$call10; //@line 93 "synthdata.cpp"
      var $cmp11=((($call10))|0)==0; //@line 93 "synthdata.cpp"
      if ($cmp11) { __label__ = 5;; } else { __label__ = 6;; } //@line 93 "synthdata.cpp"
      if (__label__ == 5) {
  
        var $6=$f_in; //@line 95 "synthdata.cpp"
        var $call13=_fclose($6); //@line 95 "synthdata.cpp"
        $retval=0; //@line 96 "synthdata.cpp"
        ; //@line 96 "synthdata.cpp"
      }
      else if (__label__ == 6) {
  
        var $7=$p; //@line 98 "synthdata.cpp"
        var $8=$length; //@line 98 "synthdata.cpp"
        var $9=$f_in; //@line 98 "synthdata.cpp"
        var $call15=_fread($7, 1, $8, $9); //@line 98 "synthdata.cpp"
        var $10=$length; //@line 98 "synthdata.cpp"
        var $cmp16=((($call15))|0)!=((($10))|0); //@line 98 "synthdata.cpp"
        var $11=$f_in; //@line 100 "synthdata.cpp"
        var $call18=_fclose($11); //@line 100 "synthdata.cpp"
        if ($cmp16) { __label__ = 7;; } else { __label__ = 8;; } //@line 98 "synthdata.cpp"
        if (__label__ == 7) {
  
          $retval=0; //@line 101 "synthdata.cpp"
          ; //@line 101 "synthdata.cpp"
        }
        else if (__label__ == 8) {
  
          var $12=$size_addr; //@line 105 "synthdata.cpp"
          var $cmp21=((($12))|0)!=0; //@line 105 "synthdata.cpp"
          if ($cmp21) { __label__ = 9;; } else { __label__ = 10;; } //@line 105 "synthdata.cpp"
          if (__label__ == 9) {
  
            var $13=$length; //@line 106 "synthdata.cpp"
            var $14=$size_addr; //@line 106 "synthdata.cpp"
            HEAP32[(($14)>>2)]=$13; //@line 106 "synthdata.cpp"
            ; //@line 106 "synthdata.cpp"
          }
  
          var $15=$p; //@line 107 "synthdata.cpp"
          $retval=$15; //@line 107 "synthdata.cpp"
          ; //@line 107 "synthdata.cpp"
        }
      }
    }
  
    var $16=$retval; //@line 108 "synthdata.cpp"
    STACKTOP = __stackBase__;
    return $16; //@line 108 "synthdata.cpp"
    return null;
  }
  

  function __Z10FreePhDatav() {
    ;
    var __label__;
  
    var $0=HEAP32[((__ZL16phoneme_tab_data)>>2)]; //@line 172 "synthdata.cpp"
    __Z4FreePv($0); //@line 172 "synthdata.cpp"
    var $1=HEAP32[((_phoneme_index)>>2)]; //@line 173 "synthdata.cpp"
    var $2=$1; //@line 173 "synthdata.cpp"
    __Z4FreePv($2); //@line 173 "synthdata.cpp"
    var $3=HEAP32[((_phondata_ptr)>>2)]; //@line 174 "synthdata.cpp"
    __Z4FreePv($3); //@line 174 "synthdata.cpp"
    HEAP32[((__ZL16phoneme_tab_data)>>2)]=0; //@line 175 "synthdata.cpp"
    HEAP32[((_phoneme_index)>>2)]=0; //@line 176 "synthdata.cpp"
    HEAP32[((_phondata_ptr)>>2)]=0; //@line 177 "synthdata.cpp"
    ;
    return; //@line 178 "synthdata.cpp"
    return;
  }
  

  function __Z11PhonemeCodej($mnem) {
    ;
    var __label__;
  
    var $retval;
    var $mnem_addr;
    var $ix;
    $mnem_addr=$mnem;
    $ix=0; //@line 185 "synthdata.cpp"
    ; //@line 185 "synthdata.cpp"
    while(1) { 
  
      var $0=$ix; //@line 185 "synthdata.cpp"
      var $1=HEAP32[((_n_phoneme_tab)>>2)]; //@line 185 "synthdata.cpp"
      var $cmp=((($0))|0) < ((($1))|0); //@line 185 "synthdata.cpp"
      if (!($cmp)) { __label__ = 6;break ; } //@line 185 "synthdata.cpp"
  
      var $2=$ix; //@line 187 "synthdata.cpp"
      var $arrayidx=((_phoneme_tab+$2*4)&4294967295); //@line 187 "synthdata.cpp"
      var $3=HEAP32[(($arrayidx)>>2)]; //@line 187 "synthdata.cpp"
      var $cmp1=((($3))|0)==0; //@line 187 "synthdata.cpp"
      if ($cmp1) { __label__ = 5;; } else { __label__ = 3;; } //@line 187 "synthdata.cpp"
      if (__label__ == 3) {
  
        var $4=$ix; //@line 189 "synthdata.cpp"
        var $arrayidx2=((_phoneme_tab+$4*4)&4294967295); //@line 189 "synthdata.cpp"
        var $5=HEAP32[(($arrayidx2)>>2)]; //@line 189 "synthdata.cpp"
        var $mnemonic=(($5)&4294967295); //@line 189 "synthdata.cpp"
        var $6=HEAP32[(($mnemonic)>>2)]; //@line 189 "synthdata.cpp"
        var $7=$mnem_addr; //@line 189 "synthdata.cpp"
        var $cmp3=((($6))|0)==((($7))|0); //@line 189 "synthdata.cpp"
        if ($cmp3) { __label__ = 4;break ; } //@line 189 "synthdata.cpp"
      }
  
      var $11=$ix; //@line 185 "synthdata.cpp"
      var $inc=((($11)+1)&4294967295); //@line 185 "synthdata.cpp"
      $ix=$inc; //@line 185 "synthdata.cpp"
      __label__ = 1;continue ; //@line 185 "synthdata.cpp"
    }
    if (__label__ == 6) {
  
      $retval=0; //@line 192 "synthdata.cpp"
      ; //@line 192 "synthdata.cpp"
    }
    else if (__label__ == 4) {
  
      var $8=$ix; //@line 190 "synthdata.cpp"
      var $arrayidx5=((_phoneme_tab+$8*4)&4294967295); //@line 190 "synthdata.cpp"
      var $9=HEAP32[(($arrayidx5)>>2)]; //@line 190 "synthdata.cpp"
      var $code=(($9+10)&4294967295); //@line 190 "synthdata.cpp"
      var $10=HEAPU8[($code)]; //@line 190 "synthdata.cpp"
      var $conv=((($10))&255); //@line 190 "synthdata.cpp"
      $retval=$conv; //@line 190 "synthdata.cpp"
      ; //@line 190 "synthdata.cpp"
    }
  
    var $12=$retval; //@line 193 "synthdata.cpp"
    ;
    return $12; //@line 193 "synthdata.cpp"
    return null;
  }
  

  function __Z19LookupPhonemeStringPKc($string) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $string_addr;
    var $ix;
    var $c;
    var $mnem;
    $string_addr=$string;
    $mnem=0; //@line 203 "synthdata.cpp"
    $ix=0; //@line 204 "synthdata.cpp"
    __lastLabel__ = 0; ; //@line 204 "synthdata.cpp"
    while(1) { 
  
      var $0=__lastLabel__ == 3 ? $inc : (0); //@line 204 "synthdata.cpp"
      var $cmp=((($0))|0) < 4; //@line 204 "synthdata.cpp"
      if (!($cmp)) { __label__ = 4;break ; } //@line 204 "synthdata.cpp"
  
      var $1=$ix; //@line 206 "synthdata.cpp"
      var $2=$string_addr; //@line 206 "synthdata.cpp"
      var $arrayidx=(($2+$1)&4294967295); //@line 206 "synthdata.cpp"
      var $3=HEAP8[($arrayidx)]; //@line 206 "synthdata.cpp"
      var $conv=(tempInt=(($3)),(tempInt>=128?tempInt-256:tempInt)); //@line 206 "synthdata.cpp"
      var $cmp1=((($conv))|0)==0; //@line 206 "synthdata.cpp"
      if ($cmp1) { __label__ = 4;break ; } //@line 206 "synthdata.cpp"
  
      var $4=$ix; //@line 207 "synthdata.cpp"
      var $5=$string_addr; //@line 207 "synthdata.cpp"
      var $arrayidx2=(($5+$4)&4294967295); //@line 207 "synthdata.cpp"
      var $6=HEAP8[($arrayidx2)]; //@line 207 "synthdata.cpp"
      $c=$6; //@line 207 "synthdata.cpp"
      var $7=$c; //@line 208 "synthdata.cpp"
      var $conv3=((($7))&255); //@line 208 "synthdata.cpp"
      var $8=$ix; //@line 208 "synthdata.cpp"
      var $mul=((($8)*8)&4294967295); //@line 208 "synthdata.cpp"
      var $shl=($conv3) << ($mul); //@line 208 "synthdata.cpp"
      var $9=$mnem; //@line 208 "synthdata.cpp"
      var $or=($shl) | ($9); //@line 208 "synthdata.cpp"
      $mnem=$or; //@line 208 "synthdata.cpp"
      var $10=$ix; //@line 204 "synthdata.cpp"
      var $inc=((($10)+1)&4294967295); //@line 204 "synthdata.cpp"
      $ix=$inc; //@line 204 "synthdata.cpp"
      __lastLabel__ = 3; __label__ = 1;continue ; //@line 204 "synthdata.cpp"
    }
  
    var $11=$mnem; //@line 211 "synthdata.cpp"
    var $call=__Z11PhonemeCodej($11); //@line 211 "synthdata.cpp"
    ;
    return $call; //@line 211 "synthdata.cpp"
    return null;
  }
  

  function __Z11LookupSpectP11PHONEME_TABiP10FMT_PARAMSPiP12PHONEME_LIST($this_ph, $which, $fmt_params, $n_frames, $plist) {
    var __stackBase__  = STACKTOP; STACKTOP += 4; _memset(__stackBase__, 0, 4);
    var __label__;
    var __lastLabel__ = null;
  
    var $this_ph_addr;
    var $which_addr;
    var $fmt_params_addr;
    var $n_frames_addr;
    var $plist_addr;
    var $ix;
    var $nf=__stackBase__;
    var $nf1;
    var $seq_break;
    var $frames;
    var $length1;
    var $length_std;
    var $length_factor;
    var $seq;
    var $seq2;
    var $seqk;
    var $seqk2;
    var $frame;
    $this_ph_addr=$this_ph;
    $which_addr=$which;
    $fmt_params_addr=$fmt_params;
    $n_frames_addr=$n_frames;
    $plist_addr=$plist;
    var $0=$fmt_params_addr; //@line 232 "synthdata.cpp"
    var $fmt_addr=(($0+8)&4294967295); //@line 232 "synthdata.cpp"
    var $1=HEAP32[(($fmt_addr)>>2)]; //@line 232 "synthdata.cpp"
    var $2=HEAP32[((_phondata_ptr)>>2)]; //@line 232 "synthdata.cpp"
    var $arrayidx=(($2+$1)&4294967295); //@line 232 "synthdata.cpp"
    var $3=$arrayidx; //@line 232 "synthdata.cpp"
    $seq=$3; //@line 232 "synthdata.cpp"
    var $4=$seq; //@line 233 "synthdata.cpp"
    var $5=$4; //@line 233 "synthdata.cpp"
    $seqk=$5; //@line 233 "synthdata.cpp"
    var $6=$seq; //@line 234 "synthdata.cpp"
    var $n_frames1=(($6+2)&4294967295); //@line 234 "synthdata.cpp"
    var $7=HEAPU8[($n_frames1)]; //@line 234 "synthdata.cpp"
    var $conv=((($7))&255); //@line 234 "synthdata.cpp"
    HEAP32[(($nf)>>2)]=$conv; //@line 234 "synthdata.cpp"
    var $8=HEAP32[(($nf)>>2)]; //@line 237 "synthdata.cpp"
    var $cmp=((($8))|0) >= 25; //@line 237 "synthdata.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 237 "synthdata.cpp"
    if (__label__ == 1) {
  
      HEAP32[(($nf)>>2)]=24; //@line 238 "synthdata.cpp"
      ; //@line 238 "synthdata.cpp"
    }
  
    var $9=$fmt_params_addr; //@line 240 "synthdata.cpp"
    var $fmt2_lenadj=(($9+24)&4294967295); //@line 240 "synthdata.cpp"
    var $10=HEAP32[(($fmt2_lenadj)>>2)]; //@line 240 "synthdata.cpp"
    var $11=$fmt_params_addr; //@line 240 "synthdata.cpp"
    var $fmt_length=(($11+12)&4294967295); //@line 240 "synthdata.cpp"
    var $12=HEAP32[(($fmt_length)>>2)]; //@line 240 "synthdata.cpp"
    var $add=((($12)+($10))&4294967295); //@line 240 "synthdata.cpp"
    HEAP32[((_seq_len_adjust)>>2)]=$add; //@line 240 "synthdata.cpp"
    $seq_break=0; //@line 241 "synthdata.cpp"
    $ix=0; //@line 243 "synthdata.cpp"
    var $13=$ix; //@line 243 "synthdata.cpp"
    var $14=HEAP32[(($nf)>>2)]; //@line 243 "synthdata.cpp"
    var $cmp29=((($13))|0) < ((($14))|0); //@line 243 "synthdata.cpp"
    if ($cmp29) { __label__ = 4;; } else { __label__ = 3;; } //@line 243 "synthdata.cpp"
    $for_body$$for_end_thread$5: do { 
      if (__label__ == 4) {
        while(1) { 
  
          var $15=$seq; //@line 245 "synthdata.cpp"
          var $frame3=(($15+4)&4294967295); //@line 245 "synthdata.cpp"
          var $arrayidx4=(($frame3)&4294967295); //@line 245 "synthdata.cpp"
          var $frflags=(($arrayidx4)&4294967295); //@line 245 "synthdata.cpp"
          var $16=HEAP16[(($frflags)>>1)]; //@line 245 "synthdata.cpp"
          var $conv5=(tempInt=(($16)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 245 "synthdata.cpp"
          var $and=($conv5) & 1; //@line 245 "synthdata.cpp"
          var $tobool=((($and))|0)!=0; //@line 245 "synthdata.cpp"
          var $17=$ix; //@line 246 "synthdata.cpp"
          if ($tobool) { __label__ = 5;; } else { __label__ = 6;; } //@line 245 "synthdata.cpp"
          if (__label__ == 5) {
  
            var $18=$seqk; //@line 246 "synthdata.cpp"
            var $frame7=(($18+4)&4294967295); //@line 246 "synthdata.cpp"
            var $arrayidx8=(($frame7+$17*64)&4294967295); //@line 246 "synthdata.cpp"
            $frame=$arrayidx8; //@line 246 "synthdata.cpp"
            ; //@line 246 "synthdata.cpp"
          }
          else if (__label__ == 6) {
  
            var $19=$seq; //@line 248 "synthdata.cpp"
            var $frame9=(($19+4)&4294967295); //@line 248 "synthdata.cpp"
            var $arrayidx10=(($frame9+$17*44)&4294967295); //@line 248 "synthdata.cpp"
            var $20=$arrayidx10; //@line 248 "synthdata.cpp"
            $frame=$20; //@line 248 "synthdata.cpp"
            ;
          }
  
          var $21=$frame; //@line 249 "synthdata.cpp"
          var $22=$ix; //@line 249 "synthdata.cpp"
          var $arrayidx12=((__ZZ11LookupSpectP11PHONEME_TABiP10FMT_PARAMSPiP12PHONEME_LISTE10frames_buf+$22*8)&4294967295); //@line 249 "synthdata.cpp"
          var $frame13=(($arrayidx12+4)&4294967295); //@line 249 "synthdata.cpp"
          HEAP32[(($frame13)>>2)]=$21; //@line 249 "synthdata.cpp"
          var $23=$frame; //@line 250 "synthdata.cpp"
          var $frflags14=(($23)&4294967295); //@line 250 "synthdata.cpp"
          var $24=HEAP16[(($frflags14)>>1)]; //@line 250 "synthdata.cpp"
          var $25=$ix; //@line 250 "synthdata.cpp"
          var $arrayidx15=((__ZZ11LookupSpectP11PHONEME_TABiP10FMT_PARAMSPiP12PHONEME_LISTE10frames_buf+$25*8)&4294967295); //@line 250 "synthdata.cpp"
          var $frflags16=(($arrayidx15+2)&4294967295); //@line 250 "synthdata.cpp"
          HEAP16[(($frflags16)>>1)]=$24; //@line 250 "synthdata.cpp"
          var $26=$frame; //@line 251 "synthdata.cpp"
          var $length=(($26+16)&4294967295); //@line 251 "synthdata.cpp"
          var $27=HEAPU8[($length)]; //@line 251 "synthdata.cpp"
          var $conv17=((($27))&255); //@line 251 "synthdata.cpp"
          var $28=$ix; //@line 251 "synthdata.cpp"
          var $arrayidx18=((__ZZ11LookupSpectP11PHONEME_TABiP10FMT_PARAMSPiP12PHONEME_LISTE10frames_buf+$28*8)&4294967295); //@line 251 "synthdata.cpp"
          var $length19=(($arrayidx18)&4294967295); //@line 251 "synthdata.cpp"
          HEAP16[(($length19)>>1)]=$conv17; //@line 251 "synthdata.cpp"
          var $29=$frame; //@line 252 "synthdata.cpp"
          var $frflags20=(($29)&4294967295); //@line 252 "synthdata.cpp"
          var $30=HEAP16[(($frflags20)>>1)]; //@line 252 "synthdata.cpp"
          var $conv21=(tempInt=(($30)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 252 "synthdata.cpp"
          var $and22=($conv21) & 2; //@line 252 "synthdata.cpp"
          var $tobool23=((($and22))|0)!=0; //@line 252 "synthdata.cpp"
          if ($tobool23) { __label__ = 8;; } else { __label__ = 9;; } //@line 252 "synthdata.cpp"
          if (__label__ == 8) {
  
            var $31=$ix; //@line 253 "synthdata.cpp"
            $seq_break=$31; //@line 253 "synthdata.cpp"
            ; //@line 253 "synthdata.cpp"
          }
  
          var $32=$ix; //@line 243 "synthdata.cpp"
          var $inc=((($32)+1)&4294967295); //@line 243 "synthdata.cpp"
          $ix=$inc; //@line 243 "synthdata.cpp"
          var $33=$ix; //@line 243 "synthdata.cpp"
          var $34=HEAP32[(($nf)>>2)]; //@line 243 "synthdata.cpp"
          var $cmp2=((($33))|0) < ((($34))|0); //@line 243 "synthdata.cpp"
          if ($cmp2) { __label__ = 4;continue ; } else { __label__ = 10;break ; } //@line 243 "synthdata.cpp"
        }
  
        var $_pr10=$seq_break; //@line 257 "synthdata.cpp"
        $frames=((__ZZ11LookupSpectP11PHONEME_TABiP10FMT_PARAMSPiP12PHONEME_LISTE10frames_buf)&4294967295); //@line 256 "synthdata.cpp"
        var $cmp26=((($_pr10))|0) > 0; //@line 257 "synthdata.cpp"
        if (!($cmp26)) { __label__ = 14;break $for_body$$for_end_thread$5; } //@line 257 "synthdata.cpp"
  
        var $35=$which_addr; //@line 259 "synthdata.cpp"
        var $cmp28=((($35))|0)==1; //@line 259 "synthdata.cpp"
        var $36=$seq_break; //@line 261 "synthdata.cpp"
        if ($cmp28) { __label__ = 12;; } else { __label__ = 13;; } //@line 259 "synthdata.cpp"
        if (__label__ == 12) {
  
          var $add30=((($36)+1)&4294967295); //@line 261 "synthdata.cpp"
          HEAP32[(($nf)>>2)]=$add30; //@line 261 "synthdata.cpp"
          ; //@line 262 "synthdata.cpp"
        }
        else if (__label__ == 13) {
  
          var $arrayidx32=((__ZZ11LookupSpectP11PHONEME_TABiP10FMT_PARAMSPiP12PHONEME_LISTE10frames_buf+$36*8)&4294967295); //@line 265 "synthdata.cpp"
          $frames=$arrayidx32; //@line 265 "synthdata.cpp"
          var $37=$seq_break; //@line 266 "synthdata.cpp"
          var $38=HEAP32[(($nf)>>2)]; //@line 266 "synthdata.cpp"
          var $sub=((($38)-($37))&4294967295); //@line 266 "synthdata.cpp"
          HEAP32[(($nf)>>2)]=$sub; //@line 266 "synthdata.cpp"
          ;
        }
      }
      else if (__label__ == 3) {
  
        $frames=((__ZZ11LookupSpectP11PHONEME_TABiP10FMT_PARAMSPiP12PHONEME_LISTE10frames_buf)&4294967295); //@line 256 "synthdata.cpp"
        ; //@line 257 "synthdata.cpp"
      }
    } while(0);
  
    var $39=$this_ph_addr; //@line 271 "synthdata.cpp"
    var $type=(($39+11)&4294967295); //@line 271 "synthdata.cpp"
    var $40=HEAPU8[($type)]; //@line 271 "synthdata.cpp"
    var $conv35=((($40))&255); //@line 271 "synthdata.cpp"
    var $cmp36=((($conv35))|0)==2; //@line 271 "synthdata.cpp"
    if ($cmp36) { __label__ = 15;; } else { __label__ = 18;; } //@line 271 "synthdata.cpp"
    $land_lhs_true$$if_end42$22: do { 
      if (__label__ == 15) {
  
        var $41=$fmt_params_addr; //@line 271 "synthdata.cpp"
        var $fmt2_addr=(($41+20)&4294967295); //@line 271 "synthdata.cpp"
        var $42=HEAP32[(($fmt2_addr)>>2)]; //@line 271 "synthdata.cpp"
        var $cmp37=((($42))|0)==0; //@line 271 "synthdata.cpp"
        if (!($cmp37)) { __label__ = 18;break $land_lhs_true$$if_end42$22; } //@line 271 "synthdata.cpp"
  
        var $43=$fmt_params_addr; //@line 271 "synthdata.cpp"
        var $use_vowelin=(($43+4)&4294967295); //@line 271 "synthdata.cpp"
        var $44=HEAP32[(($use_vowelin)>>2)]; //@line 271 "synthdata.cpp"
        var $tobool39=((($44))|0)!=0; //@line 271 "synthdata.cpp"
        if (!($tobool39)) { __label__ = 18;break $land_lhs_true$$if_end42$22; } //@line 271 "synthdata.cpp"
  
        var $45=$frames; //@line 273 "synthdata.cpp"
        var $46=$fmt_params_addr; //@line 273 "synthdata.cpp"
        var $transition0=(($46+36)&4294967295); //@line 273 "synthdata.cpp"
        var $47=HEAP32[(($transition0)>>2)]; //@line 273 "synthdata.cpp"
        var $48=$fmt_params_addr; //@line 273 "synthdata.cpp"
        var $transition1=(($48+40)&4294967295); //@line 273 "synthdata.cpp"
        var $49=HEAP32[(($transition1)>>2)]; //@line 273 "synthdata.cpp"
        var $50=$which_addr; //@line 273 "synthdata.cpp"
        var $call=__Z18FormantTransition2P10frameref_tRijjP11PHONEME_TABi($45, $nf, $47, $49, 0, $50); //@line 273 "synthdata.cpp"
        var $51=HEAP32[((_seq_len_adjust)>>2)]; //@line 273 "synthdata.cpp"
        var $add41=((($51)+($call))&4294967295); //@line 273 "synthdata.cpp"
        HEAP32[((_seq_len_adjust)>>2)]=$add41; //@line 273 "synthdata.cpp"
        ; //@line 274 "synthdata.cpp"
      }
    } while(0);
  
    $length1=0; //@line 276 "synthdata.cpp"
    var $52=HEAP32[(($nf)>>2)]; //@line 277 "synthdata.cpp"
    var $sub43=((($52)-1)&4294967295); //@line 277 "synthdata.cpp"
    $nf1=$sub43; //@line 277 "synthdata.cpp"
    $ix=0; //@line 278 "synthdata.cpp"
    var $53=$ix; //@line 278 "synthdata.cpp"
    var $54=$nf1; //@line 278 "synthdata.cpp"
    var $cmp457=((($53))|0) < ((($54))|0); //@line 278 "synthdata.cpp"
    if ($cmp457) { __label__ = 19;; } else { __label__ = 20;; } //@line 278 "synthdata.cpp"
    $for_body46$$for_end53$27: do { 
      if (__label__ == 19) {
        while(1) { 
  
          var $55=$ix; //@line 279 "synthdata.cpp"
          var $56=$frames; //@line 279 "synthdata.cpp"
          var $arrayidx47=(($56+8*$55)&4294967295); //@line 279 "synthdata.cpp"
          var $length48=(($arrayidx47)&4294967295); //@line 279 "synthdata.cpp"
          var $57=HEAP16[(($length48)>>1)]; //@line 279 "synthdata.cpp"
          var $conv49=(tempInt=(($57)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 279 "synthdata.cpp"
          var $58=$length1; //@line 279 "synthdata.cpp"
          var $add50=((($58)+($conv49))&4294967295); //@line 279 "synthdata.cpp"
          $length1=$add50; //@line 279 "synthdata.cpp"
          var $59=$ix; //@line 278 "synthdata.cpp"
          var $inc52=((($59)+1)&4294967295); //@line 278 "synthdata.cpp"
          $ix=$inc52; //@line 278 "synthdata.cpp"
          var $60=$ix; //@line 278 "synthdata.cpp"
          var $61=$nf1; //@line 278 "synthdata.cpp"
          var $cmp45=((($60))|0) < ((($61))|0); //@line 278 "synthdata.cpp"
          if ($cmp45) { __label__ = 19;continue ; } else { __label__ = 20;break $for_body46$$for_end53$27; } //@line 278 "synthdata.cpp"
        }
      }
    } while(0);
  
    var $62=$fmt_params_addr; //@line 281 "synthdata.cpp"
    var $fmt2_addr54=(($62+20)&4294967295); //@line 281 "synthdata.cpp"
    var $63=HEAP32[(($fmt2_addr54)>>2)]; //@line 281 "synthdata.cpp"
    var $cmp55=((($63))|0)!=0; //@line 281 "synthdata.cpp"
    if ($cmp55) { __label__ = 21;; } else { __label__ = 29;; } //@line 281 "synthdata.cpp"
    if (__label__ == 21) {
  
      var $64=$fmt_params_addr; //@line 285 "synthdata.cpp"
      var $fmt2_addr57=(($64+20)&4294967295); //@line 285 "synthdata.cpp"
      var $65=HEAP32[(($fmt2_addr57)>>2)]; //@line 285 "synthdata.cpp"
      var $66=HEAP32[((_phondata_ptr)>>2)]; //@line 285 "synthdata.cpp"
      var $arrayidx58=(($66+$65)&4294967295); //@line 285 "synthdata.cpp"
      var $67=$arrayidx58; //@line 285 "synthdata.cpp"
      $seq2=$67; //@line 285 "synthdata.cpp"
      var $68=$seq2; //@line 286 "synthdata.cpp"
      var $69=$68; //@line 286 "synthdata.cpp"
      $seqk2=$69; //@line 286 "synthdata.cpp"
      var $70=HEAP32[(($nf)>>2)]; //@line 289 "synthdata.cpp"
      var $dec=((($70)-1)&4294967295); //@line 289 "synthdata.cpp"
      HEAP32[(($nf)>>2)]=$dec; //@line 289 "synthdata.cpp"
      $ix=0; //@line 290 "synthdata.cpp"
      var $71=$ix; //@line 290 "synthdata.cpp"
      var $72=$seq2; //@line 290 "synthdata.cpp"
      var $n_frames604=(($72+2)&4294967295); //@line 290 "synthdata.cpp"
      var $73=HEAPU8[($n_frames604)]; //@line 290 "synthdata.cpp"
      var $conv615=((($73))&255); //@line 290 "synthdata.cpp"
      var $cmp626=((($71))|0) < ((($conv615))|0); //@line 290 "synthdata.cpp"
      if ($cmp626) { __label__ = 22;; } else { __label__ = 28;; } //@line 290 "synthdata.cpp"
      $for_body63$$for_end92$33: do { 
        if (__label__ == 22) {
          while(1) { 
  
            var $74=$seq2; //@line 292 "synthdata.cpp"
            var $frame64=(($74+4)&4294967295); //@line 292 "synthdata.cpp"
            var $arrayidx65=(($frame64)&4294967295); //@line 292 "synthdata.cpp"
            var $frflags66=(($arrayidx65)&4294967295); //@line 292 "synthdata.cpp"
            var $75=HEAP16[(($frflags66)>>1)]; //@line 292 "synthdata.cpp"
            var $conv67=(tempInt=(($75)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 292 "synthdata.cpp"
            var $and68=($conv67) & 1; //@line 292 "synthdata.cpp"
            var $tobool69=((($and68))|0)!=0; //@line 292 "synthdata.cpp"
            var $76=$ix; //@line 293 "synthdata.cpp"
            if ($tobool69) { __label__ = 23;; } else { __label__ = 24;; } //@line 292 "synthdata.cpp"
            if (__label__ == 23) {
  
              var $77=$seqk2; //@line 293 "synthdata.cpp"
              var $frame71=(($77+4)&4294967295); //@line 293 "synthdata.cpp"
              var $arrayidx72=(($frame71+$76*64)&4294967295); //@line 293 "synthdata.cpp"
              $frame=$arrayidx72; //@line 293 "synthdata.cpp"
              ; //@line 293 "synthdata.cpp"
            }
            else if (__label__ == 24) {
  
              var $78=$seq2; //@line 295 "synthdata.cpp"
              var $frame74=(($78+4)&4294967295); //@line 295 "synthdata.cpp"
              var $arrayidx75=(($frame74+$76*44)&4294967295); //@line 295 "synthdata.cpp"
              var $79=$arrayidx75; //@line 295 "synthdata.cpp"
              $frame=$79; //@line 295 "synthdata.cpp"
              ;
            }
  
            var $80=$frame; //@line 297 "synthdata.cpp"
            var $length77=(($80+16)&4294967295); //@line 297 "synthdata.cpp"
            var $81=HEAPU8[($length77)]; //@line 297 "synthdata.cpp"
            var $conv78=((($81))&255); //@line 297 "synthdata.cpp"
            var $82=HEAP32[(($nf)>>2)]; //@line 297 "synthdata.cpp"
            var $83=$frames; //@line 297 "synthdata.cpp"
            var $arrayidx79=(($83+8*$82)&4294967295); //@line 297 "synthdata.cpp"
            var $length80=(($arrayidx79)&4294967295); //@line 297 "synthdata.cpp"
            HEAP16[(($length80)>>1)]=$conv78; //@line 297 "synthdata.cpp"
            var $84=$ix; //@line 298 "synthdata.cpp"
            var $cmp81=((($84))|0) > 0; //@line 298 "synthdata.cpp"
            if ($cmp81) { __label__ = 26;; } else { __label__ = 27;; } //@line 298 "synthdata.cpp"
            if (__label__ == 26) {
  
              var $85=$frame; //@line 300 "synthdata.cpp"
              var $86=HEAP32[(($nf)>>2)]; //@line 300 "synthdata.cpp"
              var $87=$frames; //@line 300 "synthdata.cpp"
              var $arrayidx83=(($87+8*$86)&4294967295); //@line 300 "synthdata.cpp"
              var $frame84=(($arrayidx83+4)&4294967295); //@line 300 "synthdata.cpp"
              HEAP32[(($frame84)>>2)]=$85; //@line 300 "synthdata.cpp"
              var $88=$frame; //@line 301 "synthdata.cpp"
              var $frflags85=(($88)&4294967295); //@line 301 "synthdata.cpp"
              var $89=HEAP16[(($frflags85)>>1)]; //@line 301 "synthdata.cpp"
              var $90=HEAP32[(($nf)>>2)]; //@line 301 "synthdata.cpp"
              var $91=$frames; //@line 301 "synthdata.cpp"
              var $arrayidx86=(($91+8*$90)&4294967295); //@line 301 "synthdata.cpp"
              var $frflags87=(($arrayidx86+2)&4294967295); //@line 301 "synthdata.cpp"
              HEAP16[(($frflags87)>>1)]=$89; //@line 301 "synthdata.cpp"
              ; //@line 302 "synthdata.cpp"
            }
  
            var $92=HEAP32[(($nf)>>2)]; //@line 303 "synthdata.cpp"
            var $inc89=((($92)+1)&4294967295); //@line 303 "synthdata.cpp"
            HEAP32[(($nf)>>2)]=$inc89; //@line 303 "synthdata.cpp"
            var $93=$ix; //@line 290 "synthdata.cpp"
            var $inc91=((($93)+1)&4294967295); //@line 290 "synthdata.cpp"
            $ix=$inc91; //@line 290 "synthdata.cpp"
            var $94=$ix; //@line 290 "synthdata.cpp"
            var $95=$seq2; //@line 290 "synthdata.cpp"
            var $n_frames60=(($95+2)&4294967295); //@line 290 "synthdata.cpp"
            var $96=HEAPU8[($n_frames60)]; //@line 290 "synthdata.cpp"
            var $conv61=((($96))&255); //@line 290 "synthdata.cpp"
            var $cmp62=((($94))|0) < ((($conv61))|0); //@line 290 "synthdata.cpp"
            if ($cmp62) { __label__ = 22;continue ; } else { __label__ = 28;break $for_body63$$for_end92$33; } //@line 290 "synthdata.cpp"
          }
        }
      } while(0);
  
      HEAP32[((_wavefile_ix)>>2)]=0; //@line 305 "synthdata.cpp"
      ; //@line 306 "synthdata.cpp"
    }
  
    var $97=$length1; //@line 308 "synthdata.cpp"
    var $cmp94=((($97))|0) > 0; //@line 308 "synthdata.cpp"
    if ($cmp94) { __label__ = 30;; } else { __label__ = 47;; } //@line 308 "synthdata.cpp"
    $if_then95$$if_end175$45: do { 
      if (__label__ == 30) {
  
        var $98=$which_addr; //@line 310 "synthdata.cpp"
        var $cmp96=((($98))|0)==2; //@line 310 "synthdata.cpp"
        if ($cmp96) { __label__ = 31;; } else { __label__ = 37;; } //@line 310 "synthdata.cpp"
        if (__label__ == 31) {
  
          var $99=$fmt_params_addr; //@line 315 "synthdata.cpp"
          var $std_length=(($99+44)&4294967295); //@line 315 "synthdata.cpp"
          var $100=HEAP32[(($std_length)>>2)]; //@line 315 "synthdata.cpp"
          var $101=HEAP32[((_seq_len_adjust)>>2)]; //@line 315 "synthdata.cpp"
          var $add98=((($100)-45)&4294967295); //@line 315 "synthdata.cpp"
          var $sub99=((($add98)+($101))&4294967295); //@line 315 "synthdata.cpp"
          $length_std=$sub99; //@line 315 "synthdata.cpp"
          var $102=$length_std; //@line 316 "synthdata.cpp"
          var $cmp100=((($102))|0) < 10; //@line 316 "synthdata.cpp"
          if ($cmp100) { __label__ = 32;; } else { __label__ = 33;; } //@line 316 "synthdata.cpp"
          if (__label__ == 32) {
  
            $length_std=10; //@line 317 "synthdata.cpp"
            ; //@line 317 "synthdata.cpp"
          }
  
          var $103=$plist_addr; //@line 318 "synthdata.cpp"
          var $synthflags=(($103+4)&4294967295); //@line 318 "synthdata.cpp"
          var $104=HEAPU16[(($synthflags)>>1)]; //@line 318 "synthdata.cpp"
          var $conv103=((($104))&65535); //@line 318 "synthdata.cpp"
          var $and104=($conv103) & 8; //@line 318 "synthdata.cpp"
          var $tobool105=((($and104))|0)!=0; //@line 318 "synthdata.cpp"
          if ($tobool105) { __label__ = 34;; } else { __label__ = 35;; } //@line 318 "synthdata.cpp"
          if (__label__ == 34) {
  
            var $105=HEAP32[((((_phoneme_tab+48)&4294967295))>>2)]; //@line 319 "synthdata.cpp"
            var $std_length107=(($105+14)&4294967295); //@line 319 "synthdata.cpp"
            var $106=HEAPU8[($std_length107)]; //@line 319 "synthdata.cpp"
            var $conv108=((($106))&255); //@line 319 "synthdata.cpp"
            var $mul=((($conv108)*2)&4294967295); //@line 319 "synthdata.cpp"
            var $107=$length_std; //@line 319 "synthdata.cpp"
            var $add109=((($mul)+($107))&4294967295); //@line 319 "synthdata.cpp"
            $length_std=$add109; //@line 319 "synthdata.cpp"
            ; //@line 319 "synthdata.cpp"
          }
  
          var $108=$length_std; //@line 324 "synthdata.cpp"
          var $mul111=((($108)*256)&4294967295); //@line 324 "synthdata.cpp"
          var $109=$length1; //@line 324 "synthdata.cpp"
          var $div=((((($mul111))|0)/((($109))|0))|0); //@line 324 "synthdata.cpp"
          $length_factor=$div; //@line 324 "synthdata.cpp"
          $ix=0; //@line 326 "synthdata.cpp"
          var $110=$ix; //@line 326 "synthdata.cpp"
          var $111=$nf1; //@line 326 "synthdata.cpp"
          var $cmp1133=((($110))|0) < ((($111))|0); //@line 326 "synthdata.cpp"
          if (!($cmp1133)) { __label__ = 47;break $if_then95$$if_end175$45; } //@line 326 "synthdata.cpp"
          while(1) { 
  
            var $112=$ix; //@line 328 "synthdata.cpp"
            var $113=$frames; //@line 328 "synthdata.cpp"
            var $arrayidx115=(($113+8*$112)&4294967295); //@line 328 "synthdata.cpp"
            var $length116=(($arrayidx115)&4294967295); //@line 328 "synthdata.cpp"
            var $114=HEAP16[(($length116)>>1)]; //@line 328 "synthdata.cpp"
            var $conv117=(tempInt=(($114)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 328 "synthdata.cpp"
            var $115=$length_factor; //@line 328 "synthdata.cpp"
            var $mul118=((($conv117)*($115))&4294967295); //@line 328 "synthdata.cpp"
            var $div119=((((($mul118))|0)/256)|0); //@line 328 "synthdata.cpp"
            var $conv120=((($div119)) & 65535); //@line 328 "synthdata.cpp"
            var $116=$ix; //@line 328 "synthdata.cpp"
            var $117=$frames; //@line 328 "synthdata.cpp"
            var $arrayidx121=(($117+8*$116)&4294967295); //@line 328 "synthdata.cpp"
            var $length122=(($arrayidx121)&4294967295); //@line 328 "synthdata.cpp"
            HEAP16[(($length122)>>1)]=$conv120; //@line 328 "synthdata.cpp"
            var $118=$ix; //@line 326 "synthdata.cpp"
            var $inc124=((($118)+1)&4294967295); //@line 326 "synthdata.cpp"
            $ix=$inc124; //@line 326 "synthdata.cpp"
            var $119=$ix; //@line 326 "synthdata.cpp"
            var $120=$nf1; //@line 326 "synthdata.cpp"
            var $cmp113=((($119))|0) < ((($120))|0); //@line 326 "synthdata.cpp"
            if ($cmp113) { __label__ = 36;continue ; } else { __label__ = 47;break $if_then95$$if_end175$45; } //@line 326 "synthdata.cpp"
          }
        }
        else if (__label__ == 37) {
  
          var $121=$which_addr; //@line 333 "synthdata.cpp"
          var $cmp127=((($121))|0)==1; //@line 333 "synthdata.cpp"
          var $122=$fmt_params_addr; //@line 336 "synthdata.cpp"
          if ($cmp127) { __label__ = 38;; } else { __label__ = 41;; } //@line 333 "synthdata.cpp"
          $if_then128$$if_else145$58: do { 
            if (__label__ == 38) {
  
              var $fmt_control=(($122)&4294967295); //@line 336 "synthdata.cpp"
              var $123=HEAP32[(($fmt_control)>>2)]; //@line 336 "synthdata.cpp"
              var $cmp129=((($123))|0)==1; //@line 336 "synthdata.cpp"
              if (!($cmp129)) { __label__ = 43;break $if_then128$$if_else145$58; } //@line 336 "synthdata.cpp"
  
              var $124=$fmt_params_addr; //@line 340 "synthdata.cpp"
              var $std_length131=(($124+44)&4294967295); //@line 340 "synthdata.cpp"
              var $125=HEAP32[(($std_length131)>>2)]; //@line 340 "synthdata.cpp"
              var $cmp132=((($125))|0) < 130; //@line 340 "synthdata.cpp"
              if (!($cmp132)) { __label__ = 43;break $if_then128$$if_else145$58; } //@line 340 "synthdata.cpp"
  
              var $126=$frames; //@line 341 "synthdata.cpp"
              var $arrayidx134=(($126)&4294967295); //@line 341 "synthdata.cpp"
              var $length135=(($arrayidx134)&4294967295); //@line 341 "synthdata.cpp"
              var $127=HEAP16[(($length135)>>1)]; //@line 341 "synthdata.cpp"
              var $conv136=(tempInt=(($127)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 341 "synthdata.cpp"
              var $128=$fmt_params_addr; //@line 341 "synthdata.cpp"
              var $std_length137=(($128+44)&4294967295); //@line 341 "synthdata.cpp"
              var $129=HEAP32[(($std_length137)>>2)]; //@line 341 "synthdata.cpp"
              var $mul138=((($129)*($conv136))&4294967295); //@line 341 "synthdata.cpp"
              var $div139=((((($mul138))|0)/130)|0); //@line 341 "synthdata.cpp"
              var $conv140=((($div139)) & 65535); //@line 341 "synthdata.cpp"
              var $130=$frames; //@line 341 "synthdata.cpp"
              var $arrayidx141=(($130)&4294967295); //@line 341 "synthdata.cpp"
              var $length142=(($arrayidx141)&4294967295); //@line 341 "synthdata.cpp"
              HEAP16[(($length142)>>1)]=$conv140; //@line 341 "synthdata.cpp"
              __label__ = 43;break $if_then128$$if_else145$58; //@line 341 "synthdata.cpp"
            }
            else if (__label__ == 41) {
  
              var $std_length146=(($122+44)&4294967295); //@line 347 "synthdata.cpp"
              var $131=HEAP32[(($std_length146)>>2)]; //@line 347 "synthdata.cpp"
              var $cmp147=((($131))|0) > 0; //@line 347 "synthdata.cpp"
              if (!($cmp147)) { __label__ = 43;break $if_then128$$if_else145$58; } //@line 347 "synthdata.cpp"
  
              var $132=$fmt_params_addr; //@line 349 "synthdata.cpp"
              var $std_length149=(($132+44)&4294967295); //@line 349 "synthdata.cpp"
              var $133=HEAP32[(($std_length149)>>2)]; //@line 349 "synthdata.cpp"
              var $134=$length1; //@line 349 "synthdata.cpp"
              var $sub150=((($133)-($134))&4294967295); //@line 349 "synthdata.cpp"
              var $135=HEAP32[((_seq_len_adjust)>>2)]; //@line 349 "synthdata.cpp"
              var $add151=((($135)+($sub150))&4294967295); //@line 349 "synthdata.cpp"
              HEAP32[((_seq_len_adjust)>>2)]=$add151; //@line 349 "synthdata.cpp"
              __lastLabel__ = 42; __label__ = 44;break $if_then128$$if_else145$58; //@line 350 "synthdata.cpp"
            }
          } while(0);
          if (__label__ == 43) {
  
            var $_pr=HEAP32[((_seq_len_adjust)>>2)]; //@line 353 "synthdata.cpp"
            __lastLabel__ = 43; ;
          }
  
          var $136=__lastLabel__ == 43 ? $_pr : ($add151); //@line 353 "synthdata.cpp"
          var $cmp154=((($136))|0)!=0; //@line 353 "synthdata.cpp"
          if (!($cmp154)) { __label__ = 47;break $if_then95$$if_end175$45; } //@line 353 "synthdata.cpp"
  
          var $137=$length1; //@line 355 "synthdata.cpp"
          var $138=HEAP32[((_seq_len_adjust)>>2)]; //@line 355 "synthdata.cpp"
          var $add156=((($138)+($137))&4294967295); //@line 355 "synthdata.cpp"
          var $mul157=((($add156)*256)&4294967295); //@line 355 "synthdata.cpp"
          var $139=$length1; //@line 355 "synthdata.cpp"
          var $div158=((((($mul157))|0)/((($139))|0))|0); //@line 355 "synthdata.cpp"
          $length_factor=$div158; //@line 355 "synthdata.cpp"
          $ix=0; //@line 356 "synthdata.cpp"
          var $140=$ix; //@line 356 "synthdata.cpp"
          var $141=$nf1; //@line 356 "synthdata.cpp"
          var $cmp1601=((($140))|0) < ((($141))|0); //@line 356 "synthdata.cpp"
          if (!($cmp1601)) { __label__ = 47;break $if_then95$$if_end175$45; } //@line 356 "synthdata.cpp"
          while(1) { 
  
            var $142=$ix; //@line 358 "synthdata.cpp"
            var $143=$frames; //@line 358 "synthdata.cpp"
            var $arrayidx162=(($143+8*$142)&4294967295); //@line 358 "synthdata.cpp"
            var $length163=(($arrayidx162)&4294967295); //@line 358 "synthdata.cpp"
            var $144=HEAP16[(($length163)>>1)]; //@line 358 "synthdata.cpp"
            var $conv164=(tempInt=(($144)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 358 "synthdata.cpp"
            var $145=$length_factor; //@line 358 "synthdata.cpp"
            var $mul165=((($conv164)*($145))&4294967295); //@line 358 "synthdata.cpp"
            var $div166=((((($mul165))|0)/256)|0); //@line 358 "synthdata.cpp"
            var $conv167=((($div166)) & 65535); //@line 358 "synthdata.cpp"
            var $146=$ix; //@line 358 "synthdata.cpp"
            var $147=$frames; //@line 358 "synthdata.cpp"
            var $arrayidx168=(($147+8*$146)&4294967295); //@line 358 "synthdata.cpp"
            var $length169=(($arrayidx168)&4294967295); //@line 358 "synthdata.cpp"
            HEAP16[(($length169)>>1)]=$conv167; //@line 358 "synthdata.cpp"
            var $148=$ix; //@line 356 "synthdata.cpp"
            var $inc171=((($148)+1)&4294967295); //@line 356 "synthdata.cpp"
            $ix=$inc171; //@line 356 "synthdata.cpp"
            var $149=$ix; //@line 356 "synthdata.cpp"
            var $150=$nf1; //@line 356 "synthdata.cpp"
            var $cmp160=((($149))|0) < ((($150))|0); //@line 356 "synthdata.cpp"
            if ($cmp160) { __label__ = 46;continue ; } else { __label__ = 47;break $if_then95$$if_end175$45; } //@line 356 "synthdata.cpp"
          }
        }
      }
    } while(0);
  
    var $151=HEAP32[(($nf)>>2)]; //@line 364 "synthdata.cpp"
    var $152=$n_frames_addr; //@line 364 "synthdata.cpp"
    HEAP32[(($152)>>2)]=$151; //@line 364 "synthdata.cpp"
    var $153=$frames; //@line 365 "synthdata.cpp"
    STACKTOP = __stackBase__;
    return $153; //@line 365 "synthdata.cpp"
    return null;
  }
  

  function __Z11GetEnvelopei($index) {
    ;
    var __label__;
  
    var $retval;
    var $index_addr;
    $index_addr=$index;
    var $0=$index_addr; //@line 372 "synthdata.cpp"
    var $cmp=((($0))|0)==0; //@line 372 "synthdata.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 372 "synthdata.cpp"
    if (__label__ == 1) {
  
      var $1=HEAP32[((__impure_ptr)>>2)]; //@line 374 "synthdata.cpp"
      var $_stderr=(($1+12)&4294967295); //@line 374 "synthdata.cpp"
      var $2=HEAP32[(($_stderr)>>2)]; //@line 374 "synthdata.cpp"
      var $3=_fwrite(((__str5416)&4294967295), 20, 1, $2); //@line 374 "synthdata.cpp"
      var $4=HEAP32[((((_envelope_data)&4294967295))>>2)]; //@line 375 "synthdata.cpp"
      $retval=$4; //@line 375 "synthdata.cpp"
      ; //@line 375 "synthdata.cpp"
    }
    else if (__label__ == 2) {
  
      var $5=$index_addr; //@line 377 "synthdata.cpp"
      var $6=HEAP32[((_phondata_ptr)>>2)]; //@line 377 "synthdata.cpp"
      var $arrayidx=(($6+$5)&4294967295); //@line 377 "synthdata.cpp"
      $retval=$arrayidx; //@line 377 "synthdata.cpp"
      ; //@line 377 "synthdata.cpp"
    }
  
    var $7=$retval; //@line 378 "synthdata.cpp"
    ;
    return $7; //@line 378 "synthdata.cpp"
    return null;
  }
  

  function __Z18SelectPhonemeTablei($number) {
    ;
    var __label__;
  
    var $number_addr;
    $number_addr=$number;
    HEAP32[((_n_phoneme_tab)>>2)]=0; //@line 416 "synthdata.cpp"
    var $0=$number_addr; //@line 417 "synthdata.cpp"
    __ZL17SetUpPhonemeTableii($0, 0); //@line 417 "synthdata.cpp"
    var $1=HEAP32[((_n_phoneme_tab)>>2)]; //@line 418 "synthdata.cpp"
    var $inc=((($1)+1)&4294967295); //@line 418 "synthdata.cpp"
    HEAP32[((_n_phoneme_tab)>>2)]=$inc; //@line 418 "synthdata.cpp"
    var $2=$number_addr; //@line 419 "synthdata.cpp"
    HEAP32[((_current_phoneme_table)>>2)]=$2; //@line 419 "synthdata.cpp"
    ;
    return; //@line 420 "synthdata.cpp"
    return;
  }
  

  function __ZL17SetUpPhonemeTableii($number, $recursing) {
    ;
    var __label__;
  
    var $number_addr;
    var $recursing_addr;
    var $ix;
    var $includes;
    var $ph_code;
    var $phtab;
    $number_addr=$number;
    $recursing_addr=$recursing;
    var $0=$recursing_addr; //@line 388 "synthdata.cpp"
    var $cmp=((($0))|0)==0; //@line 388 "synthdata.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 388 "synthdata.cpp"
    if (__label__ == 1) {
  
      var $dest$, $stop$, $stop4$, $fast$, $value4$;
      $dest$ = ((_phoneme_tab_flags)&4294967295);
      $stop$ = $dest$ + 256;
      $value4$ = 0;
      if ($value4$ < 0) $value4$ += 256;
      $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
      while ($dest$%4 !== 0 && $dest$ < $stop$) {
        ;; HEAP8[$dest$++] = 0;
      }
      $dest$ >>= 2;
      $stop4$ = $stop$ >> 2;
      while ($dest$ < $stop4$) {
      ;;;;;;;  HEAP32[$dest$++] = $value4$;
      }
      $dest$ <<= 2;
      while ($dest$ < $stop$) {
        ;; HEAP8[$dest$++] = 0;
      }; //@line 390 "synthdata.cpp"
      ; //@line 391 "synthdata.cpp"
    }
  
    var $1=$number_addr; //@line 393 "synthdata.cpp"
    var $arrayidx=((_phoneme_tab_list+$1*48)&4294967295); //@line 393 "synthdata.cpp"
    var $includes1=(($arrayidx+40)&4294967295); //@line 393 "synthdata.cpp"
    var $2=HEAP32[(($includes1)>>2)]; //@line 393 "synthdata.cpp"
    $includes=$2; //@line 393 "synthdata.cpp"
    var $cmp2=((($2))|0) > 0; //@line 393 "synthdata.cpp"
    if ($cmp2) { __label__ = 3;; } else { __label__ = 4;; } //@line 393 "synthdata.cpp"
    if (__label__ == 3) {
  
      var $3=$includes; //@line 396 "synthdata.cpp"
      var $sub=((($3)-1)&4294967295); //@line 396 "synthdata.cpp"
      __ZL17SetUpPhonemeTableii($sub, 1); //@line 396 "synthdata.cpp"
      ; //@line 397 "synthdata.cpp"
    }
  
    var $4=$number_addr; //@line 400 "synthdata.cpp"
    var $arrayidx5=((_phoneme_tab_list+$4*48)&4294967295); //@line 400 "synthdata.cpp"
    var $phoneme_tab_ptr=(($arrayidx5+32)&4294967295); //@line 400 "synthdata.cpp"
    var $5=HEAP32[(($phoneme_tab_ptr)>>2)]; //@line 400 "synthdata.cpp"
    $phtab=$5; //@line 400 "synthdata.cpp"
    $ix=0; //@line 401 "synthdata.cpp"
    var $6=$ix; //@line 401 "synthdata.cpp"
    var $7=$number_addr; //@line 401 "synthdata.cpp"
    var $arrayidx61=((_phoneme_tab_list+$7*48)&4294967295); //@line 401 "synthdata.cpp"
    var $n_phonemes2=(($arrayidx61+36)&4294967295); //@line 401 "synthdata.cpp"
    var $8=HEAP32[(($n_phonemes2)>>2)]; //@line 401 "synthdata.cpp"
    var $cmp73=((($6))|0) < ((($8))|0); //@line 401 "synthdata.cpp"
    if ($cmp73) { __label__ = 5;; } else { __label__ = 10;; } //@line 401 "synthdata.cpp"
    $for_body$$for_end$8: do { 
      if (__label__ == 5) {
        while(1) { 
  
          var $9=$ix; //@line 403 "synthdata.cpp"
          var $10=$phtab; //@line 403 "synthdata.cpp"
          var $arrayidx8=(($10+16*$9)&4294967295); //@line 403 "synthdata.cpp"
          var $code=(($arrayidx8+10)&4294967295); //@line 403 "synthdata.cpp"
          var $11=HEAPU8[($code)]; //@line 403 "synthdata.cpp"
          var $conv=((($11))&255); //@line 403 "synthdata.cpp"
          $ph_code=$conv; //@line 403 "synthdata.cpp"
          var $12=$ix; //@line 404 "synthdata.cpp"
          var $13=$phtab; //@line 404 "synthdata.cpp"
          var $arrayidx9=(($13+16*$12)&4294967295); //@line 404 "synthdata.cpp"
          var $14=$ph_code; //@line 404 "synthdata.cpp"
          var $arrayidx10=((_phoneme_tab+$14*4)&4294967295); //@line 404 "synthdata.cpp"
          HEAP32[(($arrayidx10)>>2)]=$arrayidx9; //@line 404 "synthdata.cpp"
          var $15=$ph_code; //@line 405 "synthdata.cpp"
          var $16=HEAP32[((_n_phoneme_tab)>>2)]; //@line 405 "synthdata.cpp"
          var $cmp11=((($15))|0) > ((($16))|0); //@line 405 "synthdata.cpp"
          if ($cmp11) { __label__ = 6;; } else { __label__ = 7;; } //@line 405 "synthdata.cpp"
          if (__label__ == 6) {
  
            var $17=$ph_code; //@line 406 "synthdata.cpp"
            HEAP32[((_n_phoneme_tab)>>2)]=$17; //@line 406 "synthdata.cpp"
            ; //@line 406 "synthdata.cpp"
          }
  
          var $18=$recursing_addr; //@line 408 "synthdata.cpp"
          var $cmp14=((($18))|0)==0; //@line 408 "synthdata.cpp"
          if ($cmp14) { __label__ = 8;; } else { __label__ = 9;; } //@line 408 "synthdata.cpp"
          if (__label__ == 8) {
  
            var $19=$ph_code; //@line 409 "synthdata.cpp"
            var $arrayidx16=((_phoneme_tab_flags+$19)&4294967295); //@line 409 "synthdata.cpp"
            var $20=HEAPU8[($arrayidx16)]; //@line 409 "synthdata.cpp"
            var $conv17=((($20))&255); //@line 409 "synthdata.cpp"
            var $or=($conv17) | 1; //@line 409 "synthdata.cpp"
            var $conv18=((($or)) & 255); //@line 409 "synthdata.cpp"
            HEAP8[($arrayidx16)]=$conv18; //@line 409 "synthdata.cpp"
            ; //@line 409 "synthdata.cpp"
          }
  
          var $21=$ix; //@line 401 "synthdata.cpp"
          var $inc=((($21)+1)&4294967295); //@line 401 "synthdata.cpp"
          $ix=$inc; //@line 401 "synthdata.cpp"
          var $22=$ix; //@line 401 "synthdata.cpp"
          var $23=$number_addr; //@line 401 "synthdata.cpp"
          var $arrayidx6=((_phoneme_tab_list+$23*48)&4294967295); //@line 401 "synthdata.cpp"
          var $n_phonemes=(($arrayidx6+36)&4294967295); //@line 401 "synthdata.cpp"
          var $24=HEAP32[(($n_phonemes)>>2)]; //@line 401 "synthdata.cpp"
          var $cmp7=((($22))|0) < ((($24))|0); //@line 401 "synthdata.cpp"
          if ($cmp7) { __label__ = 5;continue ; } else { __label__ = 10;break $for_body$$for_end$8; } //@line 401 "synthdata.cpp"
        }
      }
    } while(0);
  
    ;
    return; //@line 411 "synthdata.cpp"
    return;
  }
  

  function __Z18LookupPhonemeTablePKc($name) {
    ;
    var __label__;
  
    var $retval;
    var $name_addr;
    var $ix;
    $name_addr=$name;
    $ix=0; //@line 427 "synthdata.cpp"
    ; //@line 427 "synthdata.cpp"
    while(1) { 
  
      var $0=$ix; //@line 427 "synthdata.cpp"
      var $1=HEAP32[((_n_phoneme_tables)>>2)]; //@line 427 "synthdata.cpp"
      var $cmp=((($0))|0) < ((($1))|0); //@line 427 "synthdata.cpp"
      if (!($cmp)) { __label__ = 5;break ; } //@line 427 "synthdata.cpp"
  
      var $2=$name_addr; //@line 429 "synthdata.cpp"
      var $3=$ix; //@line 429 "synthdata.cpp"
      var $arrayidx=((_phoneme_tab_list+$3*48)&4294967295); //@line 429 "synthdata.cpp"
      var $name1=(($arrayidx)&4294967295); //@line 429 "synthdata.cpp"
      var $arraydecay=(($name1)&4294967295); //@line 429 "synthdata.cpp"
      var $call=_strcmp($2, $arraydecay); //@line 429 "synthdata.cpp"
      var $cmp2=((($call))|0)==0; //@line 429 "synthdata.cpp"
      var $4=$ix; //@line 431 "synthdata.cpp"
      if ($cmp2) { __label__ = 3;break ; } //@line 429 "synthdata.cpp"
  
      var $inc=((($4)+1)&4294967295); //@line 427 "synthdata.cpp"
      $ix=$inc; //@line 427 "synthdata.cpp"
      __label__ = 1;continue ; //@line 427 "synthdata.cpp"
    }
    if (__label__ == 3) {
  
      HEAP32[((_phoneme_tab_number)>>2)]=$4; //@line 431 "synthdata.cpp"
      ; //@line 432 "synthdata.cpp"
    }
  
    var $5=$ix; //@line 435 "synthdata.cpp"
    var $6=HEAP32[((_n_phoneme_tables)>>2)]; //@line 435 "synthdata.cpp"
    var $cmp3=((($5))|0)==((($6))|0); //@line 435 "synthdata.cpp"
    if ($cmp3) { __label__ = 6;; } else { __label__ = 7;; } //@line 435 "synthdata.cpp"
    if (__label__ == 6) {
  
      $retval=-1; //@line 436 "synthdata.cpp"
      ; //@line 436 "synthdata.cpp"
    }
    else if (__label__ == 7) {
  
      var $7=$ix; //@line 438 "synthdata.cpp"
      $retval=$7; //@line 438 "synthdata.cpp"
      ; //@line 438 "synthdata.cpp"
    }
  
    var $8=$retval; //@line 439 "synthdata.cpp"
    ;
    return $8; //@line 439 "synthdata.cpp"
    return null;
  }
  

  function __Z22SelectPhonemeTableNamePKc($name) {
    ;
    var __label__;
  
    var $retval;
    var $name_addr;
    var $ix;
    $name_addr=$name;
    var $0=$name_addr; //@line 448 "synthdata.cpp"
    var $call=__Z18LookupPhonemeTablePKc($0); //@line 448 "synthdata.cpp"
    $ix=$call; //@line 448 "synthdata.cpp"
    var $cmp=((($call))|0)==-1; //@line 448 "synthdata.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 448 "synthdata.cpp"
    if (__label__ == 1) {
  
      $retval=-1; //@line 449 "synthdata.cpp"
      ; //@line 449 "synthdata.cpp"
    }
    else if (__label__ == 2) {
  
      var $1=$ix; //@line 451 "synthdata.cpp"
      __Z18SelectPhonemeTablei($1); //@line 451 "synthdata.cpp"
      var $2=$ix; //@line 452 "synthdata.cpp"
      $retval=$2; //@line 452 "synthdata.cpp"
      ; //@line 452 "synthdata.cpp"
    }
  
    var $3=$retval; //@line 453 "synthdata.cpp"
    ;
    return $3; //@line 453 "synthdata.cpp"
    return null;
  }
  

  function __Z10LoadConfigv() {
    var __stackBase__  = STACKTOP; STACKTOP += 364; _memset(__stackBase__, 0, 364);
    var __label__;
  
    var $buf=__stackBase__;
    var $f;
    var $ix;
    var $c1=__stackBase__+160;
    var $p;
    var $string=__stackBase__+164;
    HEAP32[((_logging_type)>>2)]=0; //@line 468 "synthdata.cpp"
    $ix=0; //@line 470 "synthdata.cpp"
    ; //@line 470 "synthdata.cpp"
    $for_body$2: while(1) { 
  
      var $0=$ix; //@line 472 "synthdata.cpp"
      var $arrayidx=((_soundicon_tab+$0*16)&4294967295); //@line 472 "synthdata.cpp"
      var $filename=(($arrayidx+12)&4294967295); //@line 472 "synthdata.cpp"
      HEAP32[(($filename)>>2)]=0; //@line 472 "synthdata.cpp"
      var $1=$ix; //@line 473 "synthdata.cpp"
      var $arrayidx1=((_soundicon_tab+$1*16)&4294967295); //@line 473 "synthdata.cpp"
      var $data=(($arrayidx1+8)&4294967295); //@line 473 "synthdata.cpp"
      HEAP32[(($data)>>2)]=0; //@line 473 "synthdata.cpp"
      var $2=$ix; //@line 470 "synthdata.cpp"
      var $inc=((($2)+1)&4294967295); //@line 470 "synthdata.cpp"
      $ix=$inc; //@line 470 "synthdata.cpp"
      var $cmp=((($inc))|0) < 4; //@line 470 "synthdata.cpp"
      if ($cmp) { __label__ = 1;continue $for_body$2; } else { __label__ = 2;break $for_body$2; } //@line 470 "synthdata.cpp"
    }
  
    var $arraydecay=(($buf)&4294967295); //@line 476 "synthdata.cpp"
    var $call=_sprintf($arraydecay, ((__str74726)&4294967295), allocate([((_path_home)&4294967295),0,0,0,47,0,0,0,((__str7418)&4294967295),0,0,0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 476 "synthdata.cpp"
    var $arraydecay2=(($buf)&4294967295); //@line 477 "synthdata.cpp"
    var $call3=_fopen($arraydecay2, ((__str51703)&4294967295)); //@line 477 "synthdata.cpp"
    $f=$call3; //@line 477 "synthdata.cpp"
    var $cmp4=((($call3))|0)==0; //@line 477 "synthdata.cpp"
    if ($cmp4) { __label__ = 17;; } else { __label__ = 3;; } //@line 477 "synthdata.cpp"
    $while_end$$while_cond_preheader$5: do { 
      if (__label__ == 3) {
  
        var $arraydecay5=(($buf)&4294967295); //@line 482 "synthdata.cpp"
        var $3=$f; //@line 482 "synthdata.cpp"
        var $call61=_fgets($arraydecay5, 160, $3); //@line 482 "synthdata.cpp"
        var $cmp72=((($call61))|0)!=0; //@line 482 "synthdata.cpp"
        if (!($cmp72)) { __label__ = 17;break $while_end$$while_cond_preheader$5; } //@line 482 "synthdata.cpp"
  
        var $arrayidx8=(($buf)&4294967295); //@line 484 "synthdata.cpp"
        var $arraydecay12=(($buf)&4294967295); //@line 486 "synthdata.cpp"
        var $arrayidx16=(($buf+4)&4294967295); //@line 488 "synthdata.cpp"
        var $arraydecay17=(($string)&4294967295); //@line 488 "synthdata.cpp"
        var $arraydecay21=(($string)&4294967295); //@line 489 "synthdata.cpp"
        var $arraydecay24=(($buf)&4294967295); //@line 492 "synthdata.cpp"
        var $arrayidx28=(($buf+5)&4294967295); //@line 494 "synthdata.cpp"
        var $arraydecay30=(($buf)&4294967295); //@line 497 "synthdata.cpp"
        var $arrayidx34=(($buf+10)&4294967295); //@line 499 "synthdata.cpp"
        var $arraydecay37=(($buf)&4294967295); //@line 502 "synthdata.cpp"
        var $arrayidx41=(($buf+10)&4294967295); //@line 504 "synthdata.cpp"
        var $arraydecay42=(($string)&4294967295); //@line 504 "synthdata.cpp"
        var $arraydecay48=(($string)&4294967295); //@line 508 "synthdata.cpp"
        var $arraydecay51=(($string)&4294967295); //@line 509 "synthdata.cpp"
        ; //@line 482 "synthdata.cpp"
        $while_body$8: while(1) { 
  
          var $4=HEAP8[($arrayidx8)]; //@line 484 "synthdata.cpp"
          var $conv=(tempInt=(($4)),(tempInt>=128?tempInt-256:tempInt)); //@line 484 "synthdata.cpp"
          var $cmp9=((($conv))|0)==47; //@line 484 "synthdata.cpp"
          if ($cmp9) { __label__ = 6;; } else { __label__ = 7;; } //@line 484 "synthdata.cpp"
          $while_cond_backedge$$if_end11$10: do { 
            if (__label__ == 7) {
  
              var $call13=_memcmp($arraydecay12, ((__str9420)&4294967295), 3); //@line 486 "synthdata.cpp"
              var $cmp14=((($call13))|0)==0; //@line 486 "synthdata.cpp"
              if ($cmp14) { __label__ = 8;; } else { __label__ = 10;; } //@line 486 "synthdata.cpp"
              if (__label__ == 8) {
  
                var $call18=_sscanf($arrayidx16, ((__str10421)&4294967295), allocate([_logging_type,0,0,0,$arraydecay17,0,0,0], ["i32*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 488 "synthdata.cpp"
                var $cmp19=((($call18))|0)==2; //@line 488 "synthdata.cpp"
                if (!($cmp19)) { __label__ = 6;break $while_cond_backedge$$if_end11$10; } //@line 488 "synthdata.cpp"
  
                var $call22=_fopen($arraydecay21, ((__str11422)&4294967295)); //@line 489 "synthdata.cpp"
                HEAP32[((_f_logespeak)>>2)]=$call22; //@line 489 "synthdata.cpp"
                ; //@line 489 "synthdata.cpp"
              }
              else if (__label__ == 10) {
  
                var $call25=_memcmp($arraydecay24, ((__str27677)&4294967295), 4); //@line 492 "synthdata.cpp"
                var $cmp26=((($call25))|0)==0; //@line 492 "synthdata.cpp"
                if ($cmp26) { __label__ = 11;; } else { __label__ = 12;; } //@line 492 "synthdata.cpp"
                if (__label__ == 11) {
  
                  __Z14ReadTonePointsPcPi($arrayidx28, ((_tone_points)&4294967295)); //@line 494 "synthdata.cpp"
                  ; //@line 495 "synthdata.cpp"
                }
                else if (__label__ == 12) {
  
                  var $call31=_memcmp($arraydecay30, ((__str13424)&4294967295), 9); //@line 497 "synthdata.cpp"
                  var $cmp32=((($call31))|0)==0; //@line 497 "synthdata.cpp"
                  if ($cmp32) { __label__ = 13;; } else { __label__ = 14;; } //@line 497 "synthdata.cpp"
                  if (__label__ == 13) {
  
                    var $call35=_sscanf($arrayidx34, ((__str63715)&4294967295), allocate([_option_device_number,0,0,0], ["i32*",0,0,0], ALLOC_STACK)); //@line 499 "synthdata.cpp"
                    ; //@line 500 "synthdata.cpp"
                  }
                  else if (__label__ == 14) {
  
                    var $call38=_memcmp($arraydecay37, ((__str15426)&4294967295), 9); //@line 502 "synthdata.cpp"
                    var $cmp39=((($call38))|0)==0; //@line 502 "synthdata.cpp"
                    if (!($cmp39)) { __label__ = 6;break $while_cond_backedge$$if_end11$10; } //@line 502 "synthdata.cpp"
  
                    var $call43=_sscanf($arrayidx41, ((__str16427)&4294967295), allocate([$c1,0,0,0,$arraydecay42,0,0,0], ["i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 504 "synthdata.cpp"
                    $ix=$call43; //@line 504 "synthdata.cpp"
                    var $6=$ix; //@line 505 "synthdata.cpp"
                    var $cmp44=((($6))|0)==2; //@line 505 "synthdata.cpp"
                    if (!($cmp44)) { __label__ = 6;break $while_cond_backedge$$if_end11$10; } //@line 505 "synthdata.cpp"
  
                    var $7=HEAP8[($c1)]; //@line 507 "synthdata.cpp"
                    var $conv46=(tempInt=(($7)),(tempInt>=128?tempInt-256:tempInt)); //@line 507 "synthdata.cpp"
                    var $8=HEAP32[((_n_soundicon_tab)>>2)]; //@line 507 "synthdata.cpp"
                    var $arrayidx47=((_soundicon_tab+$8*16)&4294967295); //@line 507 "synthdata.cpp"
                    var $name=(($arrayidx47)&4294967295); //@line 507 "synthdata.cpp"
                    HEAP32[(($name)>>2)]=$conv46; //@line 507 "synthdata.cpp"
                    var $call49=_strlen($arraydecay48); //@line 508 "synthdata.cpp"
                    var $add=((($call49)+1)&4294967295); //@line 508 "synthdata.cpp"
                    var $call50=__Z5Alloci($add); //@line 508 "synthdata.cpp"
                    $p=$call50; //@line 508 "synthdata.cpp"
                    var $9=$p; //@line 509 "synthdata.cpp"
                    var $call52=_strcpy($9, $arraydecay51); //@line 509 "synthdata.cpp"
                    var $10=$p; //@line 510 "synthdata.cpp"
                    var $11=HEAP32[((_n_soundicon_tab)>>2)]; //@line 510 "synthdata.cpp"
                    var $arrayidx53=((_soundicon_tab+$11*16)&4294967295); //@line 510 "synthdata.cpp"
                    var $filename54=(($arrayidx53+12)&4294967295); //@line 510 "synthdata.cpp"
                    HEAP32[(($filename54)>>2)]=$10; //@line 510 "synthdata.cpp"
                    var $12=HEAP32[((_n_soundicon_tab)>>2)]; //@line 511 "synthdata.cpp"
                    var $inc55=((($12)+1)&4294967295); //@line 511 "synthdata.cpp"
                    HEAP32[((_n_soundicon_tab)>>2)]=$inc55; //@line 511 "synthdata.cpp"
                    var $arrayidx56=((_soundicon_tab+$12*16)&4294967295); //@line 511 "synthdata.cpp"
                    var $length=(($arrayidx56+4)&4294967295); //@line 511 "synthdata.cpp"
                    HEAP32[(($length)>>2)]=0; //@line 511 "synthdata.cpp"
                    ; //@line 512 "synthdata.cpp"
                  }
                }
              }
            }
          } while(0);
  
          var $5=$f; //@line 482 "synthdata.cpp"
          var $call6=_fgets($arraydecay5, 160, $5); //@line 482 "synthdata.cpp"
          var $cmp7=((($call6))|0)!=0; //@line 482 "synthdata.cpp"
          if ($cmp7) { __label__ = 5;continue $while_body$8; } else { __label__ = 17;break $while_end$$while_cond_preheader$5; } //@line 482 "synthdata.cpp"
        }
      }
    } while(0);
  
    STACKTOP = __stackBase__;
    return; //@line 515 "synthdata.cpp"
    return;
  }
  

  function __Z16InterpretPhonemeP10TranslatoriP12PHONEME_LISTP12PHONEME_DATA($tr, $control, $plist, $phdata) {
    var __stackBase__  = STACKTOP; STACKTOP += 44; _memset(__stackBase__, 0, 44);
    var __label__;
    var __lastLabel__ = null;
  
    var $tr_addr;
    var $control_addr;
    var $plist_addr;
    var $phdata_addr;
    var $ph;
    var $prog=__stackBase__;
    var $instn;
    var $instn2;
    var $or_flag;
    var $truth;
    var $data;
    var $end_flag;
    var $ix;
    var $param_sc;
    var $n_return;
    var $return_addr=__stackBase__+4;
    $tr_addr=$tr;
    $control_addr=$control;
    $plist_addr=$plist;
    $phdata_addr=$phdata;
    $n_return=0; //@line 852 "synthdata.cpp"
    var $0=$plist_addr; //@line 855 "synthdata.cpp"
    var $ph1=(($0+8)&4294967295); //@line 855 "synthdata.cpp"
    var $1=HEAP32[(($ph1)>>2)]; //@line 855 "synthdata.cpp"
    $ph=$1; //@line 855 "synthdata.cpp"
    var $2=$phdata_addr; //@line 857 "synthdata.cpp"
    var $3=$2; //@line 857 "synthdata.cpp"
    var $dest$, $stop$, $stop4$, $fast$, $value4$;
    $dest$ = $3;
    $stop$ = $dest$ + 152;
    $value4$ = 0;
    if ($value4$ < 0) $value4$ += 256;
    $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
    while ($dest$%4 !== 0 && $dest$ < $stop$) {
      ;; HEAP8[$dest$++] = 0;
    }
    $dest$ >>= 2;
    $stop4$ = $stop$ >> 2;
    while ($dest$ < $stop4$) {
    ;;;;;;;  HEAP32[$dest$++] = $value4$;
    }
    $dest$ <<= 2;
    while ($dest$ < $stop$) {
      ;; HEAP8[$dest$++] = 0;
    }; //@line 857 "synthdata.cpp"
    var $4=$ph; //@line 858 "synthdata.cpp"
    var $std_length=(($4+14)&4294967295); //@line 858 "synthdata.cpp"
    var $5=HEAPU8[($std_length)]; //@line 858 "synthdata.cpp"
    var $conv=((($5))&255); //@line 858 "synthdata.cpp"
    var $6=$phdata_addr; //@line 858 "synthdata.cpp"
    var $pd_param=(($6+4)&4294967295); //@line 858 "synthdata.cpp"
    var $arrayidx=(($pd_param+40)&4294967295); //@line 858 "synthdata.cpp"
    HEAP32[(($arrayidx)>>2)]=$conv; //@line 858 "synthdata.cpp"
    var $7=$ph; //@line 859 "synthdata.cpp"
    var $length_mod=(($7+15)&4294967295); //@line 859 "synthdata.cpp"
    var $8=HEAPU8[($length_mod)]; //@line 859 "synthdata.cpp"
    var $conv2=((($8))&255); //@line 859 "synthdata.cpp"
    var $9=$phdata_addr; //@line 859 "synthdata.cpp"
    var $pd_param3=(($9+4)&4294967295); //@line 859 "synthdata.cpp"
    var $arrayidx4=(($pd_param3+36)&4294967295); //@line 859 "synthdata.cpp"
    HEAP32[(($arrayidx4)>>2)]=$conv2; //@line 859 "synthdata.cpp"
    var $10=$ph; //@line 861 "synthdata.cpp"
    var $program=(($10+8)&4294967295); //@line 861 "synthdata.cpp"
    var $11=HEAPU16[(($program)>>1)]; //@line 861 "synthdata.cpp"
    var $conv5=((($11))&65535); //@line 861 "synthdata.cpp"
    var $cmp=((($conv5))|0)==0; //@line 861 "synthdata.cpp"
    if ($cmp) { __label__ = 69;; } else { __label__ = 1;; } //@line 861 "synthdata.cpp"
    $for_end237$$if_end$2: do { 
      if (__label__ == 1) {
  
        $end_flag=0; //@line 864 "synthdata.cpp"
        var $12=$ph; //@line 866 "synthdata.cpp"
        var $program6=(($12+8)&4294967295); //@line 866 "synthdata.cpp"
        var $13=HEAPU16[(($program6)>>1)]; //@line 866 "synthdata.cpp"
        var $idxprom=((($13))&65535); //@line 866 "synthdata.cpp"
        var $14=HEAP32[((_phoneme_index)>>2)]; //@line 866 "synthdata.cpp"
        var $arrayidx7=(($14+2*$idxprom)&4294967295); //@line 866 "synthdata.cpp"
        HEAP32[(($prog)>>2)]=$arrayidx7; //@line 866 "synthdata.cpp"
        var $15=$end_flag; //@line 866 "synthdata.cpp"
        var $cmp89=((($15))|0)!=1; //@line 866 "synthdata.cpp"
        if (!($cmp89)) { __label__ = 69;break $for_end237$$if_end$2; } //@line 866 "synthdata.cpp"
        $for_body$4: while(1) { 
  
          var $16=HEAP32[(($prog)>>2)]; //@line 868 "synthdata.cpp"
          var $17=HEAP16[(($16)>>1)]; //@line 868 "synthdata.cpp"
          $instn=$17; //@line 868 "synthdata.cpp"
          var $18=$instn; //@line 869 "synthdata.cpp"
          var $conv9=((($18))&65535); //@line 869 "synthdata.cpp"
          var $shr=($conv9) >> 8; //@line 869 "synthdata.cpp"
          var $and=($shr) & 15; //@line 869 "synthdata.cpp"
          $instn2=$and; //@line 869 "synthdata.cpp"
          $or_flag=0; //@line 870 "synthdata.cpp"
          var $19=$instn; //@line 872 "synthdata.cpp"
          var $conv10=((($19))&65535); //@line 872 "synthdata.cpp"
          var $shr11=($conv10) >> 12; //@line 872 "synthdata.cpp"
          if ($shr11 == 0) {
            __label__ = 3;;
          }
          else if ($shr11 == 1) {
            __label__ = 21;;
          }
          else if ($shr11 == 2) {
            __label__ = 25;;
          }
          else if ($shr11 == 3) {
            __label__ = 25;;
          }
          else if ($shr11 == 6) {
            __label__ = 40;;
          }
          else if ($shr11 == 9) {
            __label__ = 44;;
          }
          else if ($shr11 == 10) {
            __label__ = 49;;
          }
          else if ($shr11 == 11) {
            __label__ = 53;;
          }
          else if ($shr11 == 12) {
            __label__ = 53;;
          }
          else if ($shr11 == 13) {
            __label__ = 53;;
          }
          else if ($shr11 == 14) {
            __label__ = 53;;
          }
          else if ($shr11 == 15) {
            __label__ = 53;;
          }
          else {
          __label__ = 61;;
          }
          
          $sw_default221$$sw_bb$$sw_bb70$$sw_bb84$$sw_bb129$$sw_bb138$$sw_bb155$$sw_bb178$6: do { 
            if (__label__ == 61) {
  
              var $153=$ph; //@line 1077 "synthdata.cpp"
              var $154=$instn; //@line 1077 "synthdata.cpp"
              var $conv222=((($154))&65535); //@line 1077 "synthdata.cpp"
              __ZL12InvalidInstnP11PHONEME_TABi($153, $conv222); //@line 1077 "synthdata.cpp"
              ; //@line 1078 "synthdata.cpp"
            }
            else if (__label__ == 3) {
  
              var $20=$instn; //@line 875 "synthdata.cpp"
              var $conv12=((($20))&65535); //@line 875 "synthdata.cpp"
              var $and13=($conv12) & 255; //@line 875 "synthdata.cpp"
              $data=$and13; //@line 875 "synthdata.cpp"
              var $21=$instn2; //@line 877 "synthdata.cpp"
              var $cmp14=((($21))|0)==0; //@line 877 "synthdata.cpp"
              if ($cmp14) { __label__ = 4;; } else { __label__ = 7;; } //@line 877 "synthdata.cpp"
              if (__label__ == 4) {
  
                var $22=$data; //@line 880 "synthdata.cpp"
                if ($22 == 1) {
                  __label__ = 5;;
                }
                else if ($22 == 2) {
                  __label__ = 62;break $sw_default221$$sw_bb$$sw_bb70$$sw_bb84$$sw_bb129$$sw_bb138$$sw_bb155$$sw_bb178$6;
                }
                else {
                __label__ = 6;;
                }
                
                if (__label__ == 6) {
  
                  var $23=$ph; //@line 890 "synthdata.cpp"
                  var $24=$instn; //@line 890 "synthdata.cpp"
                  var $conv17=((($24))&65535); //@line 890 "synthdata.cpp"
                  __ZL12InvalidInstnP11PHONEME_TABi($23, $conv17); //@line 890 "synthdata.cpp"
                  ; //@line 891 "synthdata.cpp"
                }
                else if (__label__ == 5) {
  
                  $end_flag=1; //@line 883 "synthdata.cpp"
                  ; //@line 884 "synthdata.cpp"
                }
              }
              else if (__label__ == 7) {
  
                var $25=$instn2; //@line 895 "synthdata.cpp"
                var $cmp18=((($25))|0)==5; //@line 895 "synthdata.cpp"
                if ($cmp18) { __label__ = 8;; } else { __label__ = 10;; } //@line 895 "synthdata.cpp"
                if (__label__ == 8) {
  
                  var $26=$plist_addr; //@line 897 "synthdata.cpp"
                  var $arrayidx20=(($26+24)&4294967295); //@line 897 "synthdata.cpp"
                  var $phcode=(($arrayidx20)&4294967295); //@line 897 "synthdata.cpp"
                  var $27=HEAPU8[($phcode)]; //@line 897 "synthdata.cpp"
                  var $idxprom21=((($27))&255); //@line 897 "synthdata.cpp"
                  var $arrayidx22=((_phoneme_tab+$idxprom21*4)&4294967295); //@line 897 "synthdata.cpp"
                  var $28=HEAP32[(($arrayidx22)>>2)]; //@line 897 "synthdata.cpp"
                  var $type=(($28+11)&4294967295); //@line 897 "synthdata.cpp"
                  var $29=HEAPU8[($type)]; //@line 897 "synthdata.cpp"
                  var $conv23=((($29))&255); //@line 897 "synthdata.cpp"
                  var $cmp24=((($conv23))|0)==2; //@line 897 "synthdata.cpp"
                  if (!($cmp24)) { __label__ = 62;break $sw_default221$$sw_bb$$sw_bb70$$sw_bb84$$sw_bb129$$sw_bb138$$sw_bb155$$sw_bb178$6; } //@line 897 "synthdata.cpp"
  
                  var $30=$data; //@line 898 "synthdata.cpp"
                  var $31=$phdata_addr; //@line 898 "synthdata.cpp"
                  var $pd_param26=(($31+4)&4294967295); //@line 898 "synthdata.cpp"
                  var $arrayidx27=(($pd_param26+16)&4294967295); //@line 898 "synthdata.cpp"
                  HEAP32[(($arrayidx27)>>2)]=$30; //@line 898 "synthdata.cpp"
                  ; //@line 898 "synthdata.cpp"
                }
                else if (__label__ == 10) {
  
                  var $32=$instn2; //@line 901 "synthdata.cpp"
                  var $cmp30=((($32))|0)==13; //@line 901 "synthdata.cpp"
                  if ($cmp30) { __label__ = 11;; } else { __label__ = 14;; } //@line 901 "synthdata.cpp"
                  if (__label__ == 11) {
  
                    $ix=0; //@line 904 "synthdata.cpp"
                    var $33=$ix; //@line 904 "synthdata.cpp"
                    var $34=$data; //@line 904 "synthdata.cpp"
                    var $cmp333=((($33))|0) < ((($34))|0); //@line 904 "synthdata.cpp"
                    var $35=$ix; //@line 904 "synthdata.cpp"
                    var $cmp344=((($35))|0) < 16; //@line 904 "synthdata.cpp"
                    var $or_cond15=($cmp333) & ($cmp344); //@line 904 "synthdata.cpp"
                    if ($or_cond15) { __label__ = 12;; } else { __label__ = 13;; } //@line 904 "synthdata.cpp"
                    $for_body35$$for_end$21: do { 
                      if (__label__ == 12) {
                        while(1) { 
  
                          var $36=HEAP32[(($prog)>>2)]; //@line 906 "synthdata.cpp"
                          var $incdec_ptr=(($36+2)&4294967295); //@line 906 "synthdata.cpp"
                          HEAP32[(($prog)>>2)]=$incdec_ptr; //@line 906 "synthdata.cpp"
                          var $37=HEAP32[(($prog)>>2)]; //@line 907 "synthdata.cpp"
                          var $arrayidx36=(($37)&4294967295); //@line 907 "synthdata.cpp"
                          var $38=HEAPU16[(($arrayidx36)>>1)]; //@line 907 "synthdata.cpp"
                          var $conv37=((($38))&65535); //@line 907 "synthdata.cpp"
                          var $shr38=($conv37) >> 8; //@line 907 "synthdata.cpp"
                          var $conv39=((($shr38)) & 255); //@line 907 "synthdata.cpp"
                          var $39=$ix; //@line 907 "synthdata.cpp"
                          var $40=$phdata_addr; //@line 907 "synthdata.cpp"
                          var $ipa_string=(($40+132)&4294967295); //@line 907 "synthdata.cpp"
                          var $arrayidx40=(($ipa_string+$39)&4294967295); //@line 907 "synthdata.cpp"
                          HEAP8[($arrayidx40)]=$conv39; //@line 907 "synthdata.cpp"
                          var $41=HEAP32[(($prog)>>2)]; //@line 908 "synthdata.cpp"
                          var $arrayidx41=(($41)&4294967295); //@line 908 "synthdata.cpp"
                          var $42=HEAPU16[(($arrayidx41)>>1)]; //@line 908 "synthdata.cpp"
                          var $conv42=((($42))&65535); //@line 908 "synthdata.cpp"
                          var $and43=($conv42) & 255; //@line 908 "synthdata.cpp"
                          var $conv44=((($and43)) & 255); //@line 908 "synthdata.cpp"
                          var $43=$ix; //@line 908 "synthdata.cpp"
                          var $add=((($43)+1)&4294967295); //@line 908 "synthdata.cpp"
                          var $44=$phdata_addr; //@line 908 "synthdata.cpp"
                          var $ipa_string45=(($44+132)&4294967295); //@line 908 "synthdata.cpp"
                          var $arrayidx46=(($ipa_string45+$add)&4294967295); //@line 908 "synthdata.cpp"
                          HEAP8[($arrayidx46)]=$conv44; //@line 908 "synthdata.cpp"
                          var $45=$ix; //@line 904 "synthdata.cpp"
                          var $add47=((($45)+2)&4294967295); //@line 904 "synthdata.cpp"
                          $ix=$add47; //@line 904 "synthdata.cpp"
                          var $46=$ix; //@line 904 "synthdata.cpp"
                          var $47=$data; //@line 904 "synthdata.cpp"
                          var $cmp33=((($46))|0) < ((($47))|0); //@line 904 "synthdata.cpp"
                          var $48=$ix; //@line 904 "synthdata.cpp"
                          var $cmp34=((($48))|0) < 16; //@line 904 "synthdata.cpp"
                          var $or_cond1=($cmp33) & ($cmp34); //@line 904 "synthdata.cpp"
                          if ($or_cond1) { __label__ = 12;continue ; } else { __label__ = 13;break $for_body35$$for_end$21; } //@line 904 "synthdata.cpp"
                        }
                      }
                    } while(0);
  
                    var $49=$ix; //@line 910 "synthdata.cpp"
                    var $50=$phdata_addr; //@line 910 "synthdata.cpp"
                    var $ipa_string48=(($50+132)&4294967295); //@line 910 "synthdata.cpp"
                    var $arrayidx49=(($ipa_string48+$49)&4294967295); //@line 910 "synthdata.cpp"
                    HEAP8[($arrayidx49)]=0; //@line 910 "synthdata.cpp"
                    ; //@line 911 "synthdata.cpp"
                  }
                  else if (__label__ == 14) {
  
                    var $51=$instn2; //@line 913 "synthdata.cpp"
                    var $cmp51=((($51))|0) < 16; //@line 913 "synthdata.cpp"
                    if ($cmp51) { __label__ = 15;; } else { __label__ = 20;; } //@line 913 "synthdata.cpp"
                    if (__label__ == 15) {
  
                      var $52=$instn2; //@line 915 "synthdata.cpp"
                      var $cmp53=((($52))|0)==12; //@line 915 "synthdata.cpp"
                      if ($cmp53) { __label__ = 16;; } else { __label__ = 17;; } //@line 915 "synthdata.cpp"
                      if (__label__ == 16) {
  
                        var $53=$data; //@line 917 "synthdata.cpp"
                        var $54=$phdata_addr; //@line 917 "synthdata.cpp"
                        var $pd_param55=(($54+4)&4294967295); //@line 917 "synthdata.cpp"
                        var $arrayidx56=(($pd_param55+4)&4294967295); //@line 917 "synthdata.cpp"
                        HEAP32[(($arrayidx56)>>2)]=$53; //@line 917 "synthdata.cpp"
                        ; //@line 918 "synthdata.cpp"
                      }
  
                      var $55=$data; //@line 919 "synthdata.cpp"
                      var $56=$instn2; //@line 919 "synthdata.cpp"
                      var $57=$phdata_addr; //@line 919 "synthdata.cpp"
                      var $pd_param58=(($57+4)&4294967295); //@line 919 "synthdata.cpp"
                      var $arrayidx59=(($pd_param58+$56*4)&4294967295); //@line 919 "synthdata.cpp"
                      HEAP32[(($arrayidx59)>>2)]=$55; //@line 919 "synthdata.cpp"
                      var $58=$instn2; //@line 920 "synthdata.cpp"
                      var $cmp60=((($58))|0)==1; //@line 920 "synthdata.cpp"
                      if (!($cmp60)) { __label__ = 62;break $sw_default221$$sw_bb$$sw_bb70$$sw_bb84$$sw_bb129$$sw_bb138$$sw_bb155$$sw_bb178$6; } //@line 920 "synthdata.cpp"
  
                      var $59=$control_addr; //@line 920 "synthdata.cpp"
                      var $and61=($59) & 256; //@line 920 "synthdata.cpp"
                      var $tobool=((($and61))|0)!=0; //@line 920 "synthdata.cpp"
                      if (!($tobool)) { __label__ = 62;break $sw_default221$$sw_bb$$sw_bb70$$sw_bb84$$sw_bb129$$sw_bb138$$sw_bb155$$sw_bb178$6; } //@line 920 "synthdata.cpp"
  
                      $end_flag=1; //@line 923 "synthdata.cpp"
                      ; //@line 924 "synthdata.cpp"
                    }
                    else if (__label__ == 20) {
  
                      var $60=$ph; //@line 928 "synthdata.cpp"
                      var $61=$instn; //@line 928 "synthdata.cpp"
                      var $conv65=((($61))&65535); //@line 928 "synthdata.cpp"
                      __ZL12InvalidInstnP11PHONEME_TABi($60, $conv65); //@line 928 "synthdata.cpp"
                      ;
                    }
                  }
                }
              }
            }
            else if (__label__ == 21) {
  
              var $62=$tr_addr; //@line 933 "synthdata.cpp"
              var $cmp71=((($62))|0)==0; //@line 933 "synthdata.cpp"
              if ($cmp71) { __label__ = 62;break $sw_default221$$sw_bb$$sw_bb70$$sw_bb84$$sw_bb129$$sw_bb138$$sw_bb155$$sw_bb178$6; } //@line 933 "synthdata.cpp"
  
              var $63=$instn2; //@line 936 "synthdata.cpp"
              var $cmp74=((($63))|0) < 8; //@line 936 "synthdata.cpp"
              if (!($cmp74)) { __label__ = 62;break $sw_default221$$sw_bb$$sw_bb70$$sw_bb84$$sw_bb129$$sw_bb138$$sw_bb155$$sw_bb178$6; } //@line 936 "synthdata.cpp"
  
              var $64=$tr_addr; //@line 939 "synthdata.cpp"
              var $65=$plist_addr; //@line 939 "synthdata.cpp"
              var $66=$instn2; //@line 939 "synthdata.cpp"
              var $and76=($66) & 7; //@line 939 "synthdata.cpp"
              var $call=__ZL15StressConditionP10TranslatorP12PHONEME_LISTii($64, $65, $and76, 1); //@line 939 "synthdata.cpp"
              if (!($call)) { __label__ = 62;break $sw_default221$$sw_bb$$sw_bb70$$sw_bb84$$sw_bb129$$sw_bb138$$sw_bb155$$sw_bb178$6; } //@line 939 "synthdata.cpp"
  
              var $67=$instn; //@line 941 "synthdata.cpp"
              var $conv78=((($67))&65535); //@line 941 "synthdata.cpp"
              var $and79=($conv78) & 255; //@line 941 "synthdata.cpp"
              var $68=$phdata_addr; //@line 941 "synthdata.cpp"
              var $pd_param80=(($68+4)&4294967295); //@line 941 "synthdata.cpp"
              var $arrayidx81=(($pd_param80+4)&4294967295); //@line 941 "synthdata.cpp"
              HEAP32[(($arrayidx81)>>2)]=$and79; //@line 941 "synthdata.cpp"
              $end_flag=1; //@line 942 "synthdata.cpp"
              ; //@line 943 "synthdata.cpp"
            }
            else if (__label__ == 25) {
  
              $or_flag=0; //@line 950 "synthdata.cpp"
              $truth=1; //@line 951 "synthdata.cpp"
              var $69=$instn; //@line 952 "synthdata.cpp"
              var $conv856=((($69))&65535); //@line 952 "synthdata.cpp"
              var $and867=($conv856) & 57344; //@line 952 "synthdata.cpp"
              var $cmp878=((($and867))|0)==8192; //@line 952 "synthdata.cpp"
              if ($cmp878) { __label__ = 26;; } else { __label__ = 34;; } //@line 952 "synthdata.cpp"
              $while_body$$while_end$39: do { 
                if (__label__ == 26) {
                  while(1) { 
  
                    var $70=$or_flag; //@line 955 "synthdata.cpp"
                    var $tobool88=((($70))|0)!=0; //@line 955 "synthdata.cpp"
                    var $71=$truth; //@line 956 "synthdata.cpp"
                    var $tobool90=((($71)) & 1); //@line 956 "synthdata.cpp"
                    if ($tobool88) { __label__ = 27;; } else { __label__ = 30;; } //@line 955 "synthdata.cpp"
                    if (__label__ == 27) {
  
                      if ($tobool90) { __lastLabel__ = 27; __label__ = 29;; } else { __lastLabel__ = 27; __label__ = 28;; } //@line 956 "synthdata.cpp"
                      if (__label__ == 28) {
  
                        var $72=$tr_addr; //@line 956 "synthdata.cpp"
                        var $73=$control_addr; //@line 956 "synthdata.cpp"
                        var $74=$plist_addr; //@line 956 "synthdata.cpp"
                        var $75=$instn; //@line 956 "synthdata.cpp"
                        var $conv91=((($75))&65535); //@line 956 "synthdata.cpp"
                        var $and92=($conv91) & 4095; //@line 956 "synthdata.cpp"
                        var $call93=__ZL18InterpretConditionP10TranslatoriP12PHONEME_LISTi($72, $73, $74, $and92); //@line 956 "synthdata.cpp"
                        __lastLabel__ = 28; ; //@line 956 "synthdata.cpp"
                      }
  
                      var $76=__lastLabel__ == 27 ? 1 : ($call93);
                      var $frombool=((($76))&1); //@line 956 "synthdata.cpp"
                      $truth=$frombool; //@line 956 "synthdata.cpp"
                      ; //@line 956 "synthdata.cpp"
                    }
                    else if (__label__ == 30) {
  
                      if ($tobool90) { __lastLabel__ = 30; __label__ = 31;; } else { __lastLabel__ = 30; __label__ = 32;; } //@line 958 "synthdata.cpp"
                      if (__label__ == 31) {
  
                        var $77=$tr_addr; //@line 958 "synthdata.cpp"
                        var $78=$control_addr; //@line 958 "synthdata.cpp"
                        var $79=$plist_addr; //@line 958 "synthdata.cpp"
                        var $80=$instn; //@line 958 "synthdata.cpp"
                        var $conv97=((($80))&65535); //@line 958 "synthdata.cpp"
                        var $and98=($conv97) & 4095; //@line 958 "synthdata.cpp"
                        var $call99=__ZL18InterpretConditionP10TranslatoriP12PHONEME_LISTi($77, $78, $79, $and98); //@line 958 "synthdata.cpp"
                        __lastLabel__ = 31; ;
                      }
  
                      var $81=__lastLabel__ == 30 ? 0 : ($call99);
                      var $frombool101=((($81))&1);
                      $truth=$frombool101;
                      ;
                    }
  
                    var $82=$instn; //@line 959 "synthdata.cpp"
                    var $conv103=((($82))&65535); //@line 959 "synthdata.cpp"
                    var $and104=($conv103) & 4096; //@line 959 "synthdata.cpp"
                    $or_flag=$and104; //@line 959 "synthdata.cpp"
                    var $83=HEAP32[(($prog)>>2)]; //@line 960 "synthdata.cpp"
                    var $incdec_ptr105=(($83+2)&4294967295); //@line 960 "synthdata.cpp"
                    HEAP32[(($prog)>>2)]=$incdec_ptr105; //@line 960 "synthdata.cpp"
                    var $84=HEAP16[(($incdec_ptr105)>>1)]; //@line 960 "synthdata.cpp"
                    $instn=$84; //@line 960 "synthdata.cpp"
                    var $85=$instn; //@line 952 "synthdata.cpp"
                    var $conv85=((($85))&65535); //@line 952 "synthdata.cpp"
                    var $and86=($conv85) & 57344; //@line 952 "synthdata.cpp"
                    var $cmp87=((($and86))|0)==8192; //@line 952 "synthdata.cpp"
                    if ($cmp87) { __label__ = 26;continue ; } else { __label__ = 34;break $while_body$$while_end$39; } //@line 952 "synthdata.cpp"
                  }
                }
              } while(0);
  
              var $86=$truth; //@line 963 "synthdata.cpp"
              var $tobool106=((($86)) & 1); //@line 963 "synthdata.cpp"
              var $conv107=((($tobool106))&1); //@line 963 "synthdata.cpp"
              var $cmp108=((($conv107))|0)==0; //@line 963 "synthdata.cpp"
              if ($cmp108) { __label__ = 35;; } else { __label__ = 39;; } //@line 963 "synthdata.cpp"
              $if_then109$$if_end127$53: do { 
                if (__label__ == 35) {
  
                  var $87=$instn; //@line 965 "synthdata.cpp"
                  var $conv110=((($87))&65535); //@line 965 "synthdata.cpp"
                  var $and111=($conv110) & 63488; //@line 965 "synthdata.cpp"
                  var $cmp112=((($and111))|0)==26624; //@line 965 "synthdata.cpp"
                  if ($cmp112) { __label__ = 36;; } else { __label__ = 37;; } //@line 965 "synthdata.cpp"
                  if (__label__ == 36) {
  
                    var $88=$instn; //@line 967 "synthdata.cpp"
                    var $conv114=((($88))&65535); //@line 967 "synthdata.cpp"
                    var $and115=($conv114) & 255; //@line 967 "synthdata.cpp"
                    var $89=HEAP32[(($prog)>>2)]; //@line 967 "synthdata.cpp"
                    var $add_ptr=(($89+2*$and115)&4294967295); //@line 967 "synthdata.cpp"
                    HEAP32[(($prog)>>2)]=$add_ptr; //@line 967 "synthdata.cpp"
                    ; //@line 968 "synthdata.cpp"
                  }
                  else if (__label__ == 37) {
  
                    var $90=HEAP32[(($prog)>>2)]; //@line 972 "synthdata.cpp"
                    var $call117=__ZL13NumInstnWordsPt($90); //@line 972 "synthdata.cpp"
                    var $91=HEAP32[(($prog)>>2)]; //@line 972 "synthdata.cpp"
                    var $add_ptr118=(($91+2*$call117)&4294967295); //@line 972 "synthdata.cpp"
                    HEAP32[(($prog)>>2)]=$add_ptr118; //@line 972 "synthdata.cpp"
                    var $92=HEAP32[(($prog)>>2)]; //@line 973 "synthdata.cpp"
                    var $arrayidx119=(($92)&4294967295); //@line 973 "synthdata.cpp"
                    var $93=HEAPU16[(($arrayidx119)>>1)]; //@line 973 "synthdata.cpp"
                    var $conv120=((($93))&65535); //@line 973 "synthdata.cpp"
                    var $and121=($conv120) & 65024; //@line 973 "synthdata.cpp"
                    var $cmp122=((($and121))|0)==24576; //@line 973 "synthdata.cpp"
                    if (!($cmp122)) { __label__ = 39;break $if_then109$$if_end127$53; } //@line 973 "synthdata.cpp"
  
                    var $94=HEAP32[(($prog)>>2)]; //@line 974 "synthdata.cpp"
                    var $incdec_ptr124=(($94+2)&4294967295); //@line 974 "synthdata.cpp"
                    HEAP32[(($prog)>>2)]=$incdec_ptr124; //@line 974 "synthdata.cpp"
                    ; //@line 974 "synthdata.cpp"
                  }
                }
              } while(0);
  
              var $95=HEAP32[(($prog)>>2)]; //@line 977 "synthdata.cpp"
              var $incdec_ptr128=(($95+-2)&4294967295); //@line 977 "synthdata.cpp"
              HEAP32[(($prog)>>2)]=$incdec_ptr128; //@line 977 "synthdata.cpp"
              ; //@line 978 "synthdata.cpp"
            }
            else if (__label__ == 40) {
  
              var $96=$instn2; //@line 982 "synthdata.cpp"
              var $shr130=($96) >> 1; //@line 982 "synthdata.cpp"
              if ($shr130 == 0) {
                __label__ = 41;;
              }
              else if ($shr130 == 6) {
                __label__ = 43;;
              }
              else if ($shr130 == 5) {
                __label__ = 42;;
              }
              else {
              __label__ = 62;break $sw_default221$$sw_bb$$sw_bb70$$sw_bb84$$sw_bb129$$sw_bb138$$sw_bb155$$sw_bb178$6;
              }
              
              if (__label__ == 41) {
  
                var $97=$instn; //@line 985 "synthdata.cpp"
                var $conv132=((($97))&65535); //@line 985 "synthdata.cpp"
                var $and133=($conv132) & 255; //@line 985 "synthdata.cpp"
                var $sub=((($and133)-1)&4294967295); //@line 985 "synthdata.cpp"
                var $98=HEAP32[(($prog)>>2)]; //@line 985 "synthdata.cpp"
                var $add_ptr134=(($98+2*$sub)&4294967295); //@line 985 "synthdata.cpp"
                HEAP32[(($prog)>>2)]=$add_ptr134; //@line 985 "synthdata.cpp"
                ; //@line 986 "synthdata.cpp"
              }
              else if (__label__ == 43) {
  
                var $101=$plist_addr; //@line 997 "synthdata.cpp"
                var $102=$phdata_addr; //@line 997 "synthdata.cpp"
                __ZL15SwitchVowelTypeP12PHONEME_LISTP12PHONEME_DATAPPti($101, $102, $prog, 3); //@line 997 "synthdata.cpp"
                ; //@line 998 "synthdata.cpp"
              }
              else if (__label__ == 42) {
  
                var $99=$plist_addr; //@line 993 "synthdata.cpp"
                var $100=$phdata_addr; //@line 993 "synthdata.cpp"
                __ZL15SwitchVowelTypeP12PHONEME_LISTP12PHONEME_DATAPPti($99, $100, $prog, 2); //@line 993 "synthdata.cpp"
                ; //@line 994 "synthdata.cpp"
              }
            }
            else if (__label__ == 44) {
  
              var $103=$instn; //@line 1003 "synthdata.cpp"
              var $conv139=((($103))&65535); //@line 1003 "synthdata.cpp"
              var $and140=($conv139) & 15; //@line 1003 "synthdata.cpp"
              var $shl=((($and140)*65536)&4294967295); //@line 1003 "synthdata.cpp"
              var $104=HEAP32[(($prog)>>2)]; //@line 1003 "synthdata.cpp"
              var $arrayidx141=(($104+2)&4294967295); //@line 1003 "synthdata.cpp"
              var $105=HEAPU16[(($arrayidx141)>>1)]; //@line 1003 "synthdata.cpp"
              var $conv142=((($105))&65535); //@line 1003 "synthdata.cpp"
              var $add143=((($shl)+($conv142))&4294967295); //@line 1003 "synthdata.cpp"
              $data=$add143; //@line 1003 "synthdata.cpp"
              var $106=HEAP32[(($prog)>>2)]; //@line 1004 "synthdata.cpp"
              var $incdec_ptr144=(($106+2)&4294967295); //@line 1004 "synthdata.cpp"
              HEAP32[(($prog)>>2)]=$incdec_ptr144; //@line 1004 "synthdata.cpp"
              var $107=$instn2; //@line 1005 "synthdata.cpp"
              if ($107 == 1) {
                __label__ = 45;;
              }
              else if ($107 == 2) {
                __label__ = 47;;
              }
              else if ($107 == 3) {
                __label__ = 48;;
              }
              else {
              __label__ = 62;break $sw_default221$$sw_bb$$sw_bb70$$sw_bb84$$sw_bb129$$sw_bb138$$sw_bb155$$sw_bb178$6;
              }
              
              if (__label__ == 45) {
  
                var $108=$n_return; //@line 1009 "synthdata.cpp"
                var $cmp146=((($108))|0) < 10; //@line 1009 "synthdata.cpp"
                if (!($cmp146)) { __label__ = 62;break $sw_default221$$sw_bb$$sw_bb70$$sw_bb84$$sw_bb129$$sw_bb138$$sw_bb155$$sw_bb178$6; } //@line 1009 "synthdata.cpp"
  
                var $109=HEAP32[(($prog)>>2)]; //@line 1011 "synthdata.cpp"
                var $110=$n_return; //@line 1011 "synthdata.cpp"
                var $inc=((($110)+1)&4294967295); //@line 1011 "synthdata.cpp"
                $n_return=$inc; //@line 1011 "synthdata.cpp"
                var $arrayidx148=(($return_addr+$110*4)&4294967295); //@line 1011 "synthdata.cpp"
                HEAP32[(($arrayidx148)>>2)]=$109; //@line 1011 "synthdata.cpp"
                var $111=$data; //@line 1012 "synthdata.cpp"
                var $112=HEAP32[((_phoneme_index)>>2)]; //@line 1012 "synthdata.cpp"
                var $arrayidx149=(($112+2*$111)&4294967295); //@line 1012 "synthdata.cpp"
                var $add_ptr150=(($arrayidx149+-2)&4294967295); //@line 1012 "synthdata.cpp"
                HEAP32[(($prog)>>2)]=$add_ptr150; //@line 1012 "synthdata.cpp"
                ; //@line 1013 "synthdata.cpp"
              }
              else if (__label__ == 47) {
  
                var $113=$data; //@line 1018 "synthdata.cpp"
                var $114=$phdata_addr; //@line 1018 "synthdata.cpp"
                var $pitch_env=(($114+124)&4294967295); //@line 1018 "synthdata.cpp"
                HEAP32[(($pitch_env)>>2)]=$113; //@line 1018 "synthdata.cpp"
                ; //@line 1019 "synthdata.cpp"
              }
              else if (__label__ == 48) {
  
                var $115=$data; //@line 1023 "synthdata.cpp"
                var $116=$phdata_addr; //@line 1023 "synthdata.cpp"
                var $amp_env=(($116+128)&4294967295); //@line 1023 "synthdata.cpp"
                HEAP32[(($amp_env)>>2)]=$115; //@line 1023 "synthdata.cpp"
                ; //@line 1024 "synthdata.cpp"
              }
            }
            else if (__label__ == 49) {
  
              var $117=$instn2; //@line 1029 "synthdata.cpp"
              var $cmp156=((($117))|0)==1; //@line 1029 "synthdata.cpp"
              if ($cmp156) { __label__ = 50;; } else { __label__ = 51;; } //@line 1029 "synthdata.cpp"
              if (__label__ == 50) {
  
                $ix=0; //@line 1030 "synthdata.cpp"
                ; //@line 1030 "synthdata.cpp"
              }
              else if (__label__ == 51) {
  
                $ix=2; //@line 1032 "synthdata.cpp"
                ;
              }
  
              var $118=HEAP32[(($prog)>>2)]; //@line 1034 "synthdata.cpp"
              var $arrayidx160=(($118)&4294967295); //@line 1034 "synthdata.cpp"
              var $119=HEAPU16[(($arrayidx160)>>1)]; //@line 1034 "synthdata.cpp"
              var $conv161=((($119))&65535); //@line 1034 "synthdata.cpp"
              var $and162=($conv161) & 255; //@line 1034 "synthdata.cpp"
              var $shl163=((($and162)*65536)&4294967295); //@line 1034 "synthdata.cpp"
              var $120=HEAP32[(($prog)>>2)]; //@line 1034 "synthdata.cpp"
              var $arrayidx164=(($120+2)&4294967295); //@line 1034 "synthdata.cpp"
              var $121=HEAPU16[(($arrayidx164)>>1)]; //@line 1034 "synthdata.cpp"
              var $conv165=((($121))&65535); //@line 1034 "synthdata.cpp"
              var $add166=((($shl163)+($conv165))&4294967295); //@line 1034 "synthdata.cpp"
              var $122=$ix; //@line 1034 "synthdata.cpp"
              var $123=$phdata_addr; //@line 1034 "synthdata.cpp"
              var $vowel_transition=(($123+108)&4294967295); //@line 1034 "synthdata.cpp"
              var $arrayidx167=(($vowel_transition+$122*4)&4294967295); //@line 1034 "synthdata.cpp"
              HEAP32[(($arrayidx167)>>2)]=$add166; //@line 1034 "synthdata.cpp"
              var $124=HEAP32[(($prog)>>2)]; //@line 1035 "synthdata.cpp"
              var $arrayidx168=(($124+4)&4294967295); //@line 1035 "synthdata.cpp"
              var $125=HEAPU16[(($arrayidx168)>>1)]; //@line 1035 "synthdata.cpp"
              var $conv169=((($125))&65535); //@line 1035 "synthdata.cpp"
              var $shl170=((($conv169)*65536)&4294967295); //@line 1035 "synthdata.cpp"
              var $126=HEAP32[(($prog)>>2)]; //@line 1035 "synthdata.cpp"
              var $arrayidx171=(($126+6)&4294967295); //@line 1035 "synthdata.cpp"
              var $127=HEAPU16[(($arrayidx171)>>1)]; //@line 1035 "synthdata.cpp"
              var $conv172=((($127))&65535); //@line 1035 "synthdata.cpp"
              var $add173=((($conv172)+($shl170))&4294967295); //@line 1035 "synthdata.cpp"
              var $128=$ix; //@line 1035 "synthdata.cpp"
              var $add174=((($128)+1)&4294967295); //@line 1035 "synthdata.cpp"
              var $129=$phdata_addr; //@line 1035 "synthdata.cpp"
              var $vowel_transition175=(($129+108)&4294967295); //@line 1035 "synthdata.cpp"
              var $arrayidx176=(($vowel_transition175+$add174*4)&4294967295); //@line 1035 "synthdata.cpp"
              HEAP32[(($arrayidx176)>>2)]=$add173; //@line 1035 "synthdata.cpp"
              var $130=HEAP32[(($prog)>>2)]; //@line 1036 "synthdata.cpp"
              var $add_ptr177=(($130+6)&4294967295); //@line 1036 "synthdata.cpp"
              HEAP32[(($prog)>>2)]=$add_ptr177; //@line 1036 "synthdata.cpp"
              ; //@line 1037 "synthdata.cpp"
            }
            else if (__label__ == 53) {
  
              var $131=$instn; //@line 1044 "synthdata.cpp"
              var $conv179=((($131))&65535); //@line 1044 "synthdata.cpp"
              var $shr180=($conv179) >> 12; //@line 1044 "synthdata.cpp"
              var $sub181=((($shr180)-11)&4294967295); //@line 1044 "synthdata.cpp"
              $instn2=$sub181; //@line 1044 "synthdata.cpp"
              var $132=$instn; //@line 1045 "synthdata.cpp"
              var $conv182=((($132))&65535); //@line 1045 "synthdata.cpp"
              var $and183=($conv182) & 15; //@line 1045 "synthdata.cpp"
              var $shl184=((($and183)*262144)&4294967295); //@line 1045 "synthdata.cpp"
              var $133=HEAP32[(($prog)>>2)]; //@line 1045 "synthdata.cpp"
              var $arrayidx185=(($133+2)&4294967295); //@line 1045 "synthdata.cpp"
              var $134=HEAPU16[(($arrayidx185)>>1)]; //@line 1045 "synthdata.cpp"
              var $conv186=((($134))&65535); //@line 1045 "synthdata.cpp"
              var $shl187=((($conv186)*4)&4294967295); //@line 1045 "synthdata.cpp"
              var $add188=((($shl187)+($shl184))&4294967295); //@line 1045 "synthdata.cpp"
              var $135=$instn2; //@line 1045 "synthdata.cpp"
              var $136=$phdata_addr; //@line 1045 "synthdata.cpp"
              var $sound_addr=(($136+68)&4294967295); //@line 1045 "synthdata.cpp"
              var $arrayidx189=(($sound_addr+$135*4)&4294967295); //@line 1045 "synthdata.cpp"
              HEAP32[(($arrayidx189)>>2)]=$add188; //@line 1045 "synthdata.cpp"
              var $137=$instn; //@line 1046 "synthdata.cpp"
              var $conv190=((($137))&65535); //@line 1046 "synthdata.cpp"
              var $shr191=($conv190) >> 4; //@line 1046 "synthdata.cpp"
              var $and192=($shr191) & 255; //@line 1046 "synthdata.cpp"
              var $138=$instn2; //@line 1046 "synthdata.cpp"
              var $139=$phdata_addr; //@line 1046 "synthdata.cpp"
              var $sound_param=(($139+88)&4294967295); //@line 1046 "synthdata.cpp"
              var $arrayidx193=(($sound_param+$138*4)&4294967295); //@line 1046 "synthdata.cpp"
              HEAP32[(($arrayidx193)>>2)]=$and192; //@line 1046 "synthdata.cpp"
              var $conv194=((($and192)) & 255); //@line 1046 "synthdata.cpp"
              $param_sc=$conv194; //@line 1046 "synthdata.cpp"
              var $140=HEAP32[(($prog)>>2)]; //@line 1047 "synthdata.cpp"
              var $incdec_ptr195=(($140+2)&4294967295); //@line 1047 "synthdata.cpp"
              HEAP32[(($prog)>>2)]=$incdec_ptr195; //@line 1047 "synthdata.cpp"
              var $141=HEAP32[(($prog)>>2)]; //@line 1049 "synthdata.cpp"
              var $arrayidx196=(($141+2)&4294967295); //@line 1049 "synthdata.cpp"
              var $142=HEAPU16[(($arrayidx196)>>1)]; //@line 1049 "synthdata.cpp"
              var $conv197=((($142))&65535); //@line 1049 "synthdata.cpp"
              var $cmp198=((($conv197))|0)!=2; //@line 1049 "synthdata.cpp"
              if (!($cmp198)) { __label__ = 62;break $sw_default221$$sw_bb$$sw_bb70$$sw_bb84$$sw_bb129$$sw_bb138$$sw_bb155$$sw_bb178$6; } //@line 1049 "synthdata.cpp"
  
              var $143=$instn2; //@line 1051 "synthdata.cpp"
              var $cmp200=((($143))|0) < 2; //@line 1051 "synthdata.cpp"
              if ($cmp200) { __label__ = 55;; } else { __label__ = 57;; } //@line 1051 "synthdata.cpp"
              $if_then201$$if_else208$78: do { 
                if (__label__ == 55) {
  
                  $end_flag=1; //@line 1054 "synthdata.cpp"
                  var $144=HEAP32[(($prog)>>2)]; //@line 1055 "synthdata.cpp"
                  var $arrayidx202=(($144+2)&4294967295); //@line 1055 "synthdata.cpp"
                  var $145=HEAPU16[(($arrayidx202)>>1)]; //@line 1055 "synthdata.cpp"
                  var $conv203=((($145))&65535); //@line 1055 "synthdata.cpp"
                  var $shr204=($conv203) >> 12; //@line 1055 "synthdata.cpp"
                  var $cmp205=((($shr204))|0)==15; //@line 1055 "synthdata.cpp"
                  if (!($cmp205)) { __label__ = 59;break $if_then201$$if_else208$78; } //@line 1055 "synthdata.cpp"
  
                  $end_flag=2; //@line 1058 "synthdata.cpp"
                  ; //@line 1059 "synthdata.cpp"
                }
                else if (__label__ == 57) {
  
                  var $146=$instn2; //@line 1062 "synthdata.cpp"
                  var $cmp209=((($146))|0)==4; //@line 1062 "synthdata.cpp"
                  if (!($cmp209)) { __label__ = 59;break $if_then201$$if_else208$78; } //@line 1062 "synthdata.cpp"
  
                  var $147=$end_flag; //@line 1065 "synthdata.cpp"
                  var $dec=((($147)-1)&4294967295); //@line 1065 "synthdata.cpp"
                  $end_flag=$dec; //@line 1065 "synthdata.cpp"
                  ; //@line 1066 "synthdata.cpp"
                }
              } while(0);
  
              var $148=$instn2; //@line 1068 "synthdata.cpp"
              var $cmp213=((($148))|0)==2; //@line 1068 "synthdata.cpp"
              var $149=$instn2; //@line 1068 "synthdata.cpp"
              var $cmp214=((($149))|0)==3; //@line 1068 "synthdata.cpp"
              var $or_cond=($cmp213) | ($cmp214); //@line 1068 "synthdata.cpp"
              if (!($or_cond)) { __label__ = 62;break $sw_default221$$sw_bb$$sw_bb70$$sw_bb84$$sw_bb129$$sw_bb138$$sw_bb155$$sw_bb178$6; } //@line 1068 "synthdata.cpp"
  
              var $150=$param_sc; //@line 1071 "synthdata.cpp"
              var $conv216=(tempInt=(($150)),(tempInt>=128?tempInt-256:tempInt)); //@line 1071 "synthdata.cpp"
              var $151=$instn2; //@line 1071 "synthdata.cpp"
              var $152=$phdata_addr; //@line 1071 "synthdata.cpp"
              var $sound_param217=(($152+88)&4294967295); //@line 1071 "synthdata.cpp"
              var $arrayidx218=(($sound_param217+$151*4)&4294967295); //@line 1071 "synthdata.cpp"
              HEAP32[(($arrayidx218)>>2)]=$conv216; //@line 1071 "synthdata.cpp"
              ; //@line 1072 "synthdata.cpp"
            }
          } while(0);
  
          var $155=$ph; //@line 1081 "synthdata.cpp"
          var $phflags=(($155+4)&4294967295); //@line 1081 "synthdata.cpp"
          var $156=HEAP32[(($phflags)>>2)]; //@line 1081 "synthdata.cpp"
          var $and224=($156) & 4096; //@line 1081 "synthdata.cpp"
          var $tobool225=((($and224))|0)!=0; //@line 1081 "synthdata.cpp"
          if ($tobool225) { __label__ = 63;; } else { __label__ = 64;; } //@line 1081 "synthdata.cpp"
          $if_end227_thread$$if_end227$86: do { 
            if (__label__ == 63) {
  
              $end_flag=1; //@line 1083 "synthdata.cpp"
              ; //@line 1086 "synthdata.cpp"
            }
            else if (__label__ == 64) {
  
              var $_pr=$end_flag; //@line 1086 "synthdata.cpp"
              var $cmp228=((($_pr))|0)==1; //@line 1086 "synthdata.cpp"
              if ($cmp228) { __label__ = 66;break $if_end227_thread$$if_end227$86; } //@line 1086 "synthdata.cpp"
  
              var $157=HEAP32[(($prog)>>2)]; //@line 866 "synthdata.cpp"
              var $incdec_ptr23611=(($157+2)&4294967295); //@line 866 "synthdata.cpp"
              HEAP32[(($prog)>>2)]=$incdec_ptr23611; //@line 866 "synthdata.cpp"
              __label__ = 2;continue $for_body$4; //@line 866 "synthdata.cpp"
            }
          } while(0);
  
          var $158=$n_return; //@line 1086 "synthdata.cpp"
          var $cmp230=((($158))|0) > 0; //@line 1086 "synthdata.cpp"
          if ($cmp230) { __label__ = 67;; } else { __label__ = 68;; } //@line 1086 "synthdata.cpp"
          if (__label__ == 67) {
  
            $end_flag=0; //@line 1089 "synthdata.cpp"
            var $159=$n_return; //@line 1090 "synthdata.cpp"
            var $dec232=((($159)-1)&4294967295); //@line 1090 "synthdata.cpp"
            $n_return=$dec232; //@line 1090 "synthdata.cpp"
            var $arrayidx233=(($return_addr+$dec232*4)&4294967295); //@line 1090 "synthdata.cpp"
            var $160=HEAP32[(($arrayidx233)>>2)]; //@line 1090 "synthdata.cpp"
            HEAP32[(($prog)>>2)]=$160; //@line 1090 "synthdata.cpp"
            ; //@line 1091 "synthdata.cpp"
          }
  
          var $_pr10=$end_flag; //@line 866 "synthdata.cpp"
          var $161=HEAP32[(($prog)>>2)]; //@line 866 "synthdata.cpp"
          var $incdec_ptr236=(($161+2)&4294967295); //@line 866 "synthdata.cpp"
          HEAP32[(($prog)>>2)]=$incdec_ptr236; //@line 866 "synthdata.cpp"
          var $cmp8=((($_pr10))|0)!=1; //@line 866 "synthdata.cpp"
          if ($cmp8) { __label__ = 2;continue $for_body$4; } else { __label__ = 69;break $for_end237$$if_end$2; } //@line 866 "synthdata.cpp"
        }
      }
    } while(0);
  
    STACKTOP = __stackBase__;
    return; //@line 1094 "synthdata.cpp"
    return;
  }
  

  function __ZL12InvalidInstnP11PHONEME_TABi($ph, $instn) {
    ;
    var __label__;
  
    var $ph_addr;
    var $instn_addr;
    $ph_addr=$ph;
    $instn_addr=$instn;
    var $0=HEAP32[((__impure_ptr)>>2)]; //@line 525 "synthdata.cpp"
    var $_stderr=(($0+12)&4294967295); //@line 525 "synthdata.cpp"
    var $1=HEAP32[(($_stderr)>>2)]; //@line 525 "synthdata.cpp"
    var $2=$instn_addr; //@line 525 "synthdata.cpp"
    var $3=$ph_addr; //@line 525 "synthdata.cpp"
    var $mnemonic=(($3)&4294967295); //@line 525 "synthdata.cpp"
    var $4=HEAP32[(($mnemonic)>>2)]; //@line 525 "synthdata.cpp"
    var $call=__Z12WordToStringj($4); //@line 525 "synthdata.cpp"
    var $call1=_fprintf($1, ((__str17428)&4294967295), allocate([$2,0,0,0,((__ZZ12WordToStringjE3buf)&4294967295),0,0,0], ["i32",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 525 "synthdata.cpp"
    ;
    return; //@line 526 "synthdata.cpp"
    return;
  }
  

  function __ZL15StressConditionP10TranslatorP12PHONEME_LISTii($tr, $plist, $condition, $control) {
    ;
    var __label__;
  
    var $retval;
    var $tr_addr;
    var $plist_addr;
    var $condition_addr;
    var $control_addr;
    var $stress_level;
    var $pl;
    $tr_addr=$tr;
    $plist_addr=$plist;
    $condition_addr=$condition;
    $control_addr=$control;
    var $0=$plist_addr; //@line 538 "synthdata.cpp"
    var $arrayidx=(($0)&4294967295); //@line 538 "synthdata.cpp"
    var $phcode=(($arrayidx)&4294967295); //@line 538 "synthdata.cpp"
    var $1=HEAPU8[($phcode)]; //@line 538 "synthdata.cpp"
    var $idxprom=((($1))&255); //@line 538 "synthdata.cpp"
    var $arrayidx1=((_phoneme_tab+$idxprom*4)&4294967295); //@line 538 "synthdata.cpp"
    var $2=HEAP32[(($arrayidx1)>>2)]; //@line 538 "synthdata.cpp"
    var $type=(($2+11)&4294967295); //@line 538 "synthdata.cpp"
    var $3=HEAPU8[($type)]; //@line 538 "synthdata.cpp"
    var $conv=((($3))&255); //@line 538 "synthdata.cpp"
    var $cmp=((($conv))|0)==2; //@line 538 "synthdata.cpp"
    var $4=$plist_addr; //@line 540 "synthdata.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 538 "synthdata.cpp"
    $if_then$$if_else$2: do { 
      if (__label__ == 1) {
  
        $pl=$4; //@line 540 "synthdata.cpp"
        __label__ = 5;break $if_then$$if_else$2; //@line 541 "synthdata.cpp"
      }
      else if (__label__ == 2) {
  
        var $arrayidx2=(($4+24)&4294967295); //@line 545 "synthdata.cpp"
        var $phcode3=(($arrayidx2)&4294967295); //@line 545 "synthdata.cpp"
        var $5=HEAPU8[($phcode3)]; //@line 545 "synthdata.cpp"
        var $idxprom4=((($5))&255); //@line 545 "synthdata.cpp"
        var $arrayidx5=((_phoneme_tab+$idxprom4*4)&4294967295); //@line 545 "synthdata.cpp"
        var $6=HEAP32[(($arrayidx5)>>2)]; //@line 545 "synthdata.cpp"
        var $type6=(($6+11)&4294967295); //@line 545 "synthdata.cpp"
        var $7=HEAPU8[($type6)]; //@line 545 "synthdata.cpp"
        var $conv7=((($7))&255); //@line 545 "synthdata.cpp"
        var $cmp8=((($conv7))|0)==2; //@line 545 "synthdata.cpp"
        if ($cmp8) { __label__ = 3;; } else { __label__ = 4;; } //@line 545 "synthdata.cpp"
        if (__label__ == 3) {
  
          var $8=$plist_addr; //@line 547 "synthdata.cpp"
          var $arrayidx10=(($8+24)&4294967295); //@line 547 "synthdata.cpp"
          $pl=$arrayidx10; //@line 547 "synthdata.cpp"
          __label__ = 5;break $if_then$$if_else$2;
        }
        else if (__label__ == 4) {
  
          $retval=0; //@line 550 "synthdata.cpp"
          __label__ = 21;break $if_then$$if_else$2; //@line 550 "synthdata.cpp"
        }
      }
    } while(0);
    $if_end12$$return$8: do { 
      if (__label__ == 5) {
  
        var $9=$pl; //@line 553 "synthdata.cpp"
        var $stresslevel=(($9+1)&4294967295); //@line 553 "synthdata.cpp"
        var $10=HEAPU8[($stresslevel)]; //@line 553 "synthdata.cpp"
        var $conv13=((($10))&255); //@line 553 "synthdata.cpp"
        var $and=($conv13) & 15; //@line 553 "synthdata.cpp"
        $stress_level=$and; //@line 553 "synthdata.cpp"
        var $11=$tr_addr; //@line 555 "synthdata.cpp"
        var $cmp14=((($11))|0)!=0; //@line 555 "synthdata.cpp"
        if ($cmp14) { __label__ = 6;; } else { __label__ = 13;; } //@line 555 "synthdata.cpp"
        $if_then15$$if_end36$10: do { 
          if (__label__ == 6) {
  
            var $12=$control_addr; //@line 557 "synthdata.cpp"
            var $and16=($12) & 1; //@line 557 "synthdata.cpp"
            var $tobool=((($and16))|0)!=0; //@line 557 "synthdata.cpp"
            if ($tobool) { __label__ = 7;; } else { __label__ = 10;; } //@line 557 "synthdata.cpp"
            $land_lhs_true$$if_end25$12: do { 
              if (__label__ == 7) {
  
                var $13=$plist_addr; //@line 557 "synthdata.cpp"
                var $synthflags=(($13+4)&4294967295); //@line 557 "synthdata.cpp"
                var $14=HEAPU16[(($synthflags)>>1)]; //@line 557 "synthdata.cpp"
                var $conv17=((($14))&65535); //@line 557 "synthdata.cpp"
                var $and18=($conv17) & 16; //@line 557 "synthdata.cpp"
                var $tobool19=((($and18))|0)!=0; //@line 557 "synthdata.cpp"
                if (!($tobool19)) { __label__ = 10;break $land_lhs_true$$if_end25$12; } //@line 557 "synthdata.cpp"
  
                var $15=$tr_addr; //@line 557 "synthdata.cpp"
                var $langopts=(($15)&4294967295); //@line 557 "synthdata.cpp"
                var $param=(($langopts+24)&4294967295); //@line 557 "synthdata.cpp"
                var $arrayidx21=(($param+40)&4294967295); //@line 557 "synthdata.cpp"
                var $16=HEAP32[(($arrayidx21)>>2)]; //@line 557 "synthdata.cpp"
                var $and22=($16) & 1; //@line 557 "synthdata.cpp"
                var $cmp23=((($and22))|0)==0; //@line 557 "synthdata.cpp"
                if (!($cmp23)) { __label__ = 10;break $land_lhs_true$$if_end25$12; } //@line 557 "synthdata.cpp"
  
                $retval=0; //@line 560 "synthdata.cpp"
                __label__ = 21;break $if_end12$$return$8; //@line 560 "synthdata.cpp"
              }
            } while(0);
  
            var $17=$tr_addr; //@line 563 "synthdata.cpp"
            var $langopts26=(($17)&4294967295); //@line 563 "synthdata.cpp"
            var $param27=(($langopts26+24)&4294967295); //@line 563 "synthdata.cpp"
            var $arrayidx28=(($param27+40)&4294967295); //@line 563 "synthdata.cpp"
            var $18=HEAP32[(($arrayidx28)>>2)]; //@line 563 "synthdata.cpp"
            var $and29=($18) & 2; //@line 563 "synthdata.cpp"
            var $tobool30=((($and29))|0)!=0; //@line 563 "synthdata.cpp"
            if (!($tobool30)) { __label__ = 13;break $if_then15$$if_end36$10; } //@line 563 "synthdata.cpp"
  
            var $19=$stress_level; //@line 563 "synthdata.cpp"
            var $20=$pl; //@line 563 "synthdata.cpp"
            var $wordstress=(($20+2)&4294967295); //@line 563 "synthdata.cpp"
            var $21=HEAPU8[($wordstress)]; //@line 563 "synthdata.cpp"
            var $conv32=((($21))&255); //@line 563 "synthdata.cpp"
            var $cmp33=((($19))|0) >= ((($conv32))|0); //@line 563 "synthdata.cpp"
            if (!($cmp33)) { __label__ = 13;break $if_then15$$if_end36$10; } //@line 563 "synthdata.cpp"
  
            $stress_level=4; //@line 566 "synthdata.cpp"
            ; //@line 567 "synthdata.cpp"
          }
        } while(0);
  
        var $22=$condition_addr; //@line 570 "synthdata.cpp"
        var $cmp37=((($22))|0)==4; //@line 570 "synthdata.cpp"
        if ($cmp37) { __label__ = 14;; } else { __label__ = 15;; } //@line 570 "synthdata.cpp"
        if (__label__ == 14) {
  
          var $23=$stress_level; //@line 572 "synthdata.cpp"
          var $24=$pl; //@line 572 "synthdata.cpp"
          var $wordstress39=(($24+2)&4294967295); //@line 572 "synthdata.cpp"
          var $25=HEAPU8[($wordstress39)]; //@line 572 "synthdata.cpp"
          var $conv40=((($25))&255); //@line 572 "synthdata.cpp"
          var $cmp41=((($23))|0) >= ((($conv40))|0); //@line 572 "synthdata.cpp"
          $retval=$cmp41; //@line 572 "synthdata.cpp"
          ; //@line 572 "synthdata.cpp"
        }
        else if (__label__ == 15) {
  
          var $26=$condition_addr; //@line 575 "synthdata.cpp"
          var $cmp43=((($26))|0)==3; //@line 575 "synthdata.cpp"
          var $27=$stress_level; //@line 578 "synthdata.cpp"
          if ($cmp43) { __label__ = 16;; } else { __label__ = 18;; } //@line 575 "synthdata.cpp"
          $if_then44$$if_else48$23: do { 
            if (__label__ == 16) {
  
              var $cmp45=((($27))|0) > 3; //@line 578 "synthdata.cpp"
              if (!($cmp45)) { __label__ = 20;break $if_then44$$if_else48$23; } //@line 578 "synthdata.cpp"
  
              $retval=1; //@line 579 "synthdata.cpp"
              __label__ = 21;break $if_end12$$return$8; //@line 579 "synthdata.cpp"
            }
            else if (__label__ == 18) {
  
              var $28=$condition_addr; //@line 583 "synthdata.cpp"
              var $arrayidx49=((__ZZL15StressConditionP10TranslatorP12PHONEME_LISTiiE15condition_level+$28*4)&4294967295); //@line 583 "synthdata.cpp"
              var $29=HEAP32[(($arrayidx49)>>2)]; //@line 583 "synthdata.cpp"
              var $cmp50=((($27))|0) < ((($29))|0); //@line 583 "synthdata.cpp"
              if (!($cmp50)) { __label__ = 20;break $if_then44$$if_else48$23; } //@line 583 "synthdata.cpp"
  
              $retval=1; //@line 584 "synthdata.cpp"
              __label__ = 21;break $if_end12$$return$8; //@line 584 "synthdata.cpp"
            }
          } while(0);
  
          $retval=0; //@line 586 "synthdata.cpp"
          ; //@line 586 "synthdata.cpp"
        }
      }
    } while(0);
  
    var $30=$retval; //@line 588 "synthdata.cpp"
    ;
    return $30; //@line 588 "synthdata.cpp"
    return null;
  }
  

  function __ZL18InterpretConditionP10TranslatoriP12PHONEME_LISTi($tr, $control, $plist, $instn) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $tr_addr;
    var $control_addr;
    var $plist_addr;
    var $instn_addr;
    var $which;
    var $data;
    var $instn2;
    var $count;
    var $ph;
    var $plist_this;
    $tr_addr=$tr;
    $control_addr=$control;
    $plist_addr=$plist;
    $instn_addr=$instn;
    var $0=$instn_addr; //@line 601 "synthdata.cpp"
    var $and=($0) & 255; //@line 601 "synthdata.cpp"
    $data=$and; //@line 601 "synthdata.cpp"
    var $1=$instn_addr; //@line 602 "synthdata.cpp"
    var $shr=($1) >> 8; //@line 602 "synthdata.cpp"
    $instn2=$shr; //@line 602 "synthdata.cpp"
    var $2=$instn2; //@line 604 "synthdata.cpp"
    var $cmp=((($2))|0) < 14; //@line 604 "synthdata.cpp"
    var $3=$instn2; //@line 606 "synthdata.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 67;; } //@line 604 "synthdata.cpp"
    $if_then$$if_else187$2: do { 
      if (__label__ == 1) {
  
        var $rem=((($3))|0)%7; //@line 606 "synthdata.cpp"
        $which=$rem; //@line 606 "synthdata.cpp"
        var $4=$which; //@line 608 "synthdata.cpp"
        var $cmp1=((($4))|0)==4; //@line 608 "synthdata.cpp"
        if ($cmp1) { __lastLabel__ = 1; __label__ = 2;; } else { __lastLabel__ = 1; __label__ = 5;; } //@line 608 "synthdata.cpp"
        if (__label__ == 2) {
  
          var $5=$plist_addr; //@line 611 "synthdata.cpp"
          var $arrayidx=(($5+24)&4294967295); //@line 611 "synthdata.cpp"
          var $sourceix=(($arrayidx+6)&4294967295); //@line 611 "synthdata.cpp"
          var $6=HEAP16[(($sourceix)>>1)]; //@line 611 "synthdata.cpp"
          var $tobool=(tempInt=(($6)),(tempInt>=32768?tempInt-65536:tempInt))!=0; //@line 611 "synthdata.cpp"
          if ($tobool) { __label__ = 3;; } else { __label__ = 4;; } //@line 611 "synthdata.cpp"
          if (__label__ == 3) {
  
            $retval=0; //@line 612 "synthdata.cpp"
            __label__ = 73;break $if_then$$if_else187$2; //@line 612 "synthdata.cpp"
          }
          else if (__label__ == 4) {
  
            var $_pr=$which; //@line 614 "synthdata.cpp"
            __lastLabel__ = 4; ;
          }
        }
  
        var $7=__lastLabel__ == 4 ? $_pr : ($4); //@line 614 "synthdata.cpp"
        var $cmp5=((($7))|0)==5; //@line 614 "synthdata.cpp"
        if ($cmp5) { __label__ = 6;; } else { __label__ = 8;; } //@line 614 "synthdata.cpp"
        $if_then6$$if_end12$10: do { 
          if (__label__ == 6) {
  
            var $8=$plist_addr; //@line 617 "synthdata.cpp"
            var $arrayidx7=(($8)&4294967295); //@line 617 "synthdata.cpp"
            var $sourceix8=(($arrayidx7+6)&4294967295); //@line 617 "synthdata.cpp"
            var $9=HEAP16[(($sourceix8)>>1)]; //@line 617 "synthdata.cpp"
            var $tobool9=(tempInt=(($9)),(tempInt>=32768?tempInt-65536:tempInt))!=0; //@line 617 "synthdata.cpp"
            if (!($tobool9)) { __label__ = 8;break $if_then6$$if_end12$10; } //@line 617 "synthdata.cpp"
  
            $retval=0; //@line 618 "synthdata.cpp"
            __label__ = 73;break $if_then$$if_else187$2; //@line 618 "synthdata.cpp"
          }
        } while(0);
  
        var $10=$which; //@line 620 "synthdata.cpp"
        var $cmp13=((($10))|0)==7; //@line 620 "synthdata.cpp"
        if ($cmp13) { __lastLabel__ = 8; __label__ = 9;; } else { __lastLabel__ = 8; __label__ = 13;; } //@line 620 "synthdata.cpp"
        $if_then14$$if_end23$14: do { 
          if (__label__ == 9) {
  
            var $11=$plist_addr; //@line 623 "synthdata.cpp"
            var $arrayidx15=(($11+24)&4294967295); //@line 623 "synthdata.cpp"
            var $sourceix16=(($arrayidx15+6)&4294967295); //@line 623 "synthdata.cpp"
            var $12=HEAP16[(($sourceix16)>>1)]; //@line 623 "synthdata.cpp"
            var $tobool17=(tempInt=(($12)),(tempInt>=32768?tempInt-65536:tempInt))!=0; //@line 623 "synthdata.cpp"
            if ($tobool17) { __label__ = 11;; } else { __label__ = 10;; } //@line 623 "synthdata.cpp"
            $if_then21$$lor_lhs_false$16: do { 
              if (__label__ == 10) {
  
                var $13=$plist_addr; //@line 623 "synthdata.cpp"
                var $arrayidx18=(($13+48)&4294967295); //@line 623 "synthdata.cpp"
                var $sourceix19=(($arrayidx18+6)&4294967295); //@line 623 "synthdata.cpp"
                var $14=HEAP16[(($sourceix19)>>1)]; //@line 623 "synthdata.cpp"
                var $tobool20=(tempInt=(($14)),(tempInt>=32768?tempInt-65536:tempInt))!=0; //@line 623 "synthdata.cpp"
                if ($tobool20) { __label__ = 11;break $if_then21$$lor_lhs_false$16; } //@line 623 "synthdata.cpp"
  
                var $_pr1=$which; //@line 627 "synthdata.cpp"
                __lastLabel__ = 12; __label__ = 13;break $if_then14$$if_end23$14;
              }
            } while(0);
  
            $retval=0; //@line 624 "synthdata.cpp"
            __label__ = 73;break $if_then$$if_else187$2; //@line 624 "synthdata.cpp"
          }
        } while(0);
  
        var $15=__lastLabel__ == 12 ? $_pr1 : ($10); //@line 627 "synthdata.cpp"
        var $cmp24=((($15))|0)==6; //@line 627 "synthdata.cpp"
        if ($cmp24) { __label__ = 14;; } else { __label__ = 19;; } //@line 627 "synthdata.cpp"
        $if_then25$$if_else$21: do { 
          if (__label__ == 14) {
  
            $which=2; //@line 630 "synthdata.cpp"
            ; //@line 630 "synthdata.cpp"
            while(1) { 
  
              var $16=$which; //@line 632 "synthdata.cpp"
              var $sub=((($16)-1)&4294967295); //@line 632 "synthdata.cpp"
              var $17=$plist_addr; //@line 632 "synthdata.cpp"
              var $arrayidx26=(($17+24*$sub)&4294967295); //@line 632 "synthdata.cpp"
              var $sourceix27=(($arrayidx26+6)&4294967295); //@line 632 "synthdata.cpp"
              var $18=HEAP16[(($sourceix27)>>1)]; //@line 632 "synthdata.cpp"
              var $tobool28=(tempInt=(($18)),(tempInt>=32768?tempInt-65536:tempInt))!=0; //@line 632 "synthdata.cpp"
              if ($tobool28) { __label__ = 16;break ; } //@line 632 "synthdata.cpp"
  
              var $19=$which; //@line 634 "synthdata.cpp"
              var $sub31=((($19)-1)&4294967295); //@line 634 "synthdata.cpp"
              var $20=$plist_addr; //@line 634 "synthdata.cpp"
              var $arrayidx32=(($20+24*$sub31)&4294967295); //@line 634 "synthdata.cpp"
              var $phcode=(($arrayidx32)&4294967295); //@line 634 "synthdata.cpp"
              var $21=HEAPU8[($phcode)]; //@line 634 "synthdata.cpp"
              var $idxprom=((($21))&255); //@line 634 "synthdata.cpp"
              var $arrayidx33=((_phoneme_tab+$idxprom*4)&4294967295); //@line 634 "synthdata.cpp"
              var $22=HEAP32[(($arrayidx33)>>2)]; //@line 634 "synthdata.cpp"
              var $type=(($22+11)&4294967295); //@line 634 "synthdata.cpp"
              var $23=HEAPU8[($type)]; //@line 634 "synthdata.cpp"
              var $conv=((($23))&255); //@line 634 "synthdata.cpp"
              var $cmp34=((($conv))|0)==2; //@line 634 "synthdata.cpp"
              var $_pr2=$which; //@line 644 "synthdata.cpp"
              if ($cmp34) { __lastLabel__ = 17; __label__ = 20;break $if_then25$$if_else$21; } else { __lastLabel__ = 17; ; } //@line 634 "synthdata.cpp"
  
              var $inc=((($_pr2)+1)&4294967295); //@line 630 "synthdata.cpp"
              $which=$inc; //@line 630 "synthdata.cpp"
              __label__ = 15;continue ; //@line 630 "synthdata.cpp"
            }
  
            $retval=0; //@line 633 "synthdata.cpp"
            __label__ = 73;break $if_then$$if_else187$2; //@line 633 "synthdata.cpp"
          }
          else if (__label__ == 19) {
  
            var $24=$which; //@line 640 "synthdata.cpp"
            var $arrayidx37=((__ZZL18InterpretConditionP10TranslatoriP12PHONEME_LISTiE11ph_position+$24*4)&4294967295); //@line 640 "synthdata.cpp"
            var $25=HEAP32[(($arrayidx37)>>2)]; //@line 640 "synthdata.cpp"
            $which=$25; //@line 640 "synthdata.cpp"
            __lastLabel__ = 19; ;
          }
        } while(0);
  
        var $26=__lastLabel__ == 19 ? $25 : ($_pr2); //@line 644 "synthdata.cpp"
        var $27=$plist_addr; //@line 643 "synthdata.cpp"
        $plist_this=$27; //@line 643 "synthdata.cpp"
        var $sub39=((($26)-1)&4294967295); //@line 644 "synthdata.cpp"
        var $28=$plist_addr; //@line 644 "synthdata.cpp"
        var $arrayidx40=(($28+24*$sub39)&4294967295); //@line 644 "synthdata.cpp"
        $plist_addr=$arrayidx40; //@line 644 "synthdata.cpp"
        var $cmp41=((($26))|0)==0; //@line 646 "synthdata.cpp"
        if ($cmp41) { __label__ = 21;; } else { __label__ = 23;; } //@line 646 "synthdata.cpp"
        $if_then42$$if_end49$30: do { 
          if (__label__ == 21) {
  
            var $29=$plist_addr; //@line 648 "synthdata.cpp"
            var $phcode43=(($29)&4294967295); //@line 648 "synthdata.cpp"
            var $30=HEAPU8[($phcode43)]; //@line 648 "synthdata.cpp"
            var $conv44=((($30))&255); //@line 648 "synthdata.cpp"
            var $cmp45=((($conv44))|0)==1; //@line 648 "synthdata.cpp"
            if (!($cmp45)) { __label__ = 23;break $if_then42$$if_end49$30; } //@line 648 "synthdata.cpp"
  
            var $31=$plist_addr; //@line 651 "synthdata.cpp"
            var $arrayidx47=(($31+-24)&4294967295); //@line 651 "synthdata.cpp"
            $plist_addr=$arrayidx47; //@line 651 "synthdata.cpp"
            ; //@line 652 "synthdata.cpp"
          }
        } while(0);
  
        var $32=$control_addr; //@line 655 "synthdata.cpp"
        var $and50=($32) & 256; //@line 655 "synthdata.cpp"
        var $tobool51=((($and50))|0)!=0; //@line 655 "synthdata.cpp"
        if ($tobool51) { __label__ = 24;; } else { __label__ = 25;; } //@line 655 "synthdata.cpp"
        if (__label__ == 24) {
  
          var $33=$plist_addr; //@line 658 "synthdata.cpp"
          var $phcode53=(($33)&4294967295); //@line 658 "synthdata.cpp"
          var $34=HEAPU8[($phcode53)]; //@line 658 "synthdata.cpp"
          var $idxprom54=((($34))&255); //@line 658 "synthdata.cpp"
          var $arrayidx55=((_phoneme_tab+$idxprom54*4)&4294967295); //@line 658 "synthdata.cpp"
          var $35=HEAP32[(($arrayidx55)>>2)]; //@line 658 "synthdata.cpp"
          var $36=$plist_addr; //@line 658 "synthdata.cpp"
          var $ph56=(($36+8)&4294967295); //@line 658 "synthdata.cpp"
          HEAP32[(($ph56)>>2)]=$35; //@line 658 "synthdata.cpp"
          ; //@line 659 "synthdata.cpp"
        }
  
        var $37=$plist_addr; //@line 660 "synthdata.cpp"
        var $ph58=(($37+8)&4294967295); //@line 660 "synthdata.cpp"
        var $38=HEAP32[(($ph58)>>2)]; //@line 660 "synthdata.cpp"
        $ph=$38; //@line 660 "synthdata.cpp"
        var $39=$instn2; //@line 662 "synthdata.cpp"
        var $cmp59=((($39))|0) < 7; //@line 662 "synthdata.cpp"
        if ($cmp59) { __label__ = 26;; } else { __label__ = 32;; } //@line 662 "synthdata.cpp"
        if (__label__ == 26) {
  
          var $40=$data; //@line 665 "synthdata.cpp"
          var $arrayidx61=((_phoneme_tab+$40*4)&4294967295); //@line 665 "synthdata.cpp"
          var $41=HEAP32[(($arrayidx61)>>2)]; //@line 665 "synthdata.cpp"
          var $mnemonic=(($41)&4294967295); //@line 665 "synthdata.cpp"
          var $42=HEAP32[(($mnemonic)>>2)]; //@line 665 "synthdata.cpp"
          var $43=$ph; //@line 665 "synthdata.cpp"
          var $mnemonic62=(($43)&4294967295); //@line 665 "synthdata.cpp"
          var $44=HEAP32[(($mnemonic62)>>2)]; //@line 665 "synthdata.cpp"
          var $cmp63=((($42))|0)==((($44))|0); //@line 665 "synthdata.cpp"
          var $conv64=((($cmp63))&1); //@line 665 "synthdata.cpp"
          var $cmp65=((($conv64))|0)==1; //@line 665 "synthdata.cpp"
          if ($cmp65) { __label__ = 27;; } else { __label__ = 28;; } //@line 665 "synthdata.cpp"
          if (__label__ == 27) {
  
            $retval=1; //@line 666 "synthdata.cpp"
            ; //@line 666 "synthdata.cpp"
          }
          else if (__label__ == 28) {
  
            var $45=$which; //@line 667 "synthdata.cpp"
            var $cmp68=((($45))|0)==0; //@line 667 "synthdata.cpp"
            if ($cmp68) { __label__ = 29;; } else { __label__ = 31;; } //@line 667 "synthdata.cpp"
            $land_lhs_true$$if_end75$42: do { 
              if (__label__ == 29) {
  
                var $46=$ph; //@line 667 "synthdata.cpp"
                var $type69=(($46+11)&4294967295); //@line 667 "synthdata.cpp"
                var $47=HEAPU8[($type69)]; //@line 667 "synthdata.cpp"
                var $conv70=((($47))&255); //@line 667 "synthdata.cpp"
                var $cmp71=((($conv70))|0)==2; //@line 667 "synthdata.cpp"
                if (!($cmp71)) { __label__ = 31;break $land_lhs_true$$if_end75$42; } //@line 667 "synthdata.cpp"
  
                var $48=$data; //@line 668 "synthdata.cpp"
                var $49=$ph; //@line 668 "synthdata.cpp"
                var $end_type=(($49+13)&4294967295); //@line 668 "synthdata.cpp"
                var $50=HEAPU8[($end_type)]; //@line 668 "synthdata.cpp"
                var $conv73=((($50))&255); //@line 668 "synthdata.cpp"
                var $cmp74=((($48))|0)==((($conv73))|0); //@line 668 "synthdata.cpp"
                $retval=$cmp74; //@line 668 "synthdata.cpp"
                __label__ = 73;break $if_then$$if_else187$2; //@line 668 "synthdata.cpp"
              }
            } while(0);
  
            var $51=$data; //@line 669 "synthdata.cpp"
            var $52=$ph; //@line 669 "synthdata.cpp"
            var $start_type=(($52+12)&4294967295); //@line 669 "synthdata.cpp"
            var $53=HEAPU8[($start_type)]; //@line 669 "synthdata.cpp"
            var $conv76=((($53))&255); //@line 669 "synthdata.cpp"
            var $cmp77=((($51))|0)==((($conv76))|0); //@line 669 "synthdata.cpp"
            $retval=$cmp77; //@line 669 "synthdata.cpp"
            ; //@line 669 "synthdata.cpp"
          }
        }
        else if (__label__ == 32) {
  
          var $54=$instn_addr; //@line 672 "synthdata.cpp"
          var $and79=($54) & 31; //@line 672 "synthdata.cpp"
          $data=$and79; //@line 672 "synthdata.cpp"
          var $55=$instn_addr; //@line 674 "synthdata.cpp"
          var $and80=($55) & 224; //@line 674 "synthdata.cpp"
          if ($and80 == 0) {
            __label__ = 33;;
          }
          else if ($and80 == 32) {
            __label__ = 34;;
          }
          else if ($and80 == 64) {
            __label__ = 35;;
          }
          else if ($and80 == 128) {
            __label__ = 36;;
          }
          else {
          __label__ = 66;;
          }
          
          if (__label__ == 66) {
  
            $retval=0; //@line 758 "synthdata.cpp"
            ; //@line 758 "synthdata.cpp"
          }
          else if (__label__ == 33) {
  
            var $56=$ph; //@line 678 "synthdata.cpp"
            var $type81=(($56+11)&4294967295); //@line 678 "synthdata.cpp"
            var $57=HEAPU8[($type81)]; //@line 678 "synthdata.cpp"
            var $conv82=((($57))&255); //@line 678 "synthdata.cpp"
            var $58=$data; //@line 678 "synthdata.cpp"
            var $cmp83=((($conv82))|0)==((($58))|0); //@line 678 "synthdata.cpp"
            $retval=$cmp83; //@line 678 "synthdata.cpp"
            ; //@line 678 "synthdata.cpp"
          }
          else if (__label__ == 34) {
  
            var $59=$ph; //@line 683 "synthdata.cpp"
            var $phflags=(($59+4)&4294967295); //@line 683 "synthdata.cpp"
            var $60=HEAPU32[(($phflags)>>2)]; //@line 683 "synthdata.cpp"
            var $shr85=($60) >>> 16; //@line 683 "synthdata.cpp"
            var $and86=($shr85) & 15; //@line 683 "synthdata.cpp"
            var $61=$data; //@line 683 "synthdata.cpp"
            var $cmp87=((($and86))|0)==((($61))|0); //@line 683 "synthdata.cpp"
            $retval=$cmp87; //@line 683 "synthdata.cpp"
            ; //@line 683 "synthdata.cpp"
          }
          else if (__label__ == 35) {
  
            var $62=$ph; //@line 688 "synthdata.cpp"
            var $phflags89=(($62+4)&4294967295); //@line 688 "synthdata.cpp"
            var $63=HEAP32[(($phflags89)>>2)]; //@line 688 "synthdata.cpp"
            var $64=$data; //@line 688 "synthdata.cpp"
            var $shl=1 << ($64); //@line 688 "synthdata.cpp"
            var $and90=($shl) & ($63); //@line 688 "synthdata.cpp"
            var $cmp91=((($and90))|0)!=0; //@line 688 "synthdata.cpp"
            $retval=$cmp91; //@line 688 "synthdata.cpp"
            ; //@line 688 "synthdata.cpp"
          }
          else if (__label__ == 36) {
  
            var $65=$data; //@line 692 "synthdata.cpp"
            if ($65 == 0) {
              __label__ = 37;;
            }
            else if ($65 == 1) {
              __label__ = 37;;
            }
            else if ($65 == 2) {
              __label__ = 37;;
            }
            else if ($65 == 3) {
              __label__ = 37;;
            }
            else if ($65 == 4) {
              __label__ = 37;;
            }
            else if ($65 == 5) {
              __label__ = 38;;
            }
            else if ($65 == 6) {
              __label__ = 41;;
            }
            else if ($65 == 7) {
              __label__ = 42;;
            }
            else if ($65 == 8) {
              __label__ = 43;;
            }
            else if ($65 == 9) {
              __label__ = 46;;
            }
            else if ($65 == 10) {
              __label__ = 51;;
            }
            else if ($65 == 11) {
              __label__ = 52;;
            }
            else if ($65 == 12) {
              __label__ = 56;;
            }
            else {
            __label__ = 60;;
            }
            
            $sw_bb169$$sw_bb93$$sw_bb94$$sw_bb101$$sw_bb105$$sw_bb109$$sw_bb120$$sw_bb134$$for_cond139$$sw_bb156$53: do { 
              if (__label__ == 37) {
  
                var $66=$tr_addr; //@line 699 "synthdata.cpp"
                var $67=$plist_addr; //@line 699 "synthdata.cpp"
                var $68=$data; //@line 699 "synthdata.cpp"
                var $call=__ZL15StressConditionP10TranslatorP12PHONEME_LISTii($66, $67, $68, 0); //@line 699 "synthdata.cpp"
                $retval=$call; //@line 699 "synthdata.cpp"
                __label__ = 73;break $if_then$$if_else187$2; //@line 699 "synthdata.cpp"
              }
              else if (__label__ == 38) {
  
                var $69=$ph; //@line 702 "synthdata.cpp"
                var $type95=(($69+11)&4294967295); //@line 702 "synthdata.cpp"
                var $70=HEAPU8[($type95)]; //@line 702 "synthdata.cpp"
                var $conv96=((($70))&255); //@line 702 "synthdata.cpp"
                var $cmp97=((($conv96))|0)==0; //@line 702 "synthdata.cpp"
                if ($cmp97) { __lastLabel__ = 38; __label__ = 40;; } else { __lastLabel__ = 38; __label__ = 39;; } //@line 702 "synthdata.cpp"
                if (__label__ == 39) {
  
                  var $71=$plist_this; //@line 702 "synthdata.cpp"
                  var $synthflags=(($71+4)&4294967295); //@line 702 "synthdata.cpp"
                  var $72=HEAPU16[(($synthflags)>>1)]; //@line 702 "synthdata.cpp"
                  var $conv98=((($72))&65535); //@line 702 "synthdata.cpp"
                  var $and99=($conv98) & 8192; //@line 702 "synthdata.cpp"
                  var $tobool100=((($and99))|0)!=0; //@line 702 "synthdata.cpp"
                  __lastLabel__ = 39; ; //@line 702 "synthdata.cpp"
                }
  
                var $73=__lastLabel__ == 38 ? 1 : ($tobool100);
                $retval=$73; //@line 702 "synthdata.cpp"
                __label__ = 73;break $if_then$$if_else187$2; //@line 702 "synthdata.cpp"
              }
              else if (__label__ == 41) {
  
                var $74=$plist_addr; //@line 705 "synthdata.cpp"
                var $sourceix102=(($74+6)&4294967295); //@line 705 "synthdata.cpp"
                var $75=HEAPU16[(($sourceix102)>>1)]; //@line 705 "synthdata.cpp"
                var $conv103=((($75))&65535); //@line 705 "synthdata.cpp"
                var $cmp104=((($conv103))|0)!=0; //@line 705 "synthdata.cpp"
                $retval=$cmp104; //@line 705 "synthdata.cpp"
                __label__ = 73;break $if_then$$if_else187$2; //@line 705 "synthdata.cpp"
              }
              else if (__label__ == 42) {
  
                var $76=$plist_addr; //@line 708 "synthdata.cpp"
                var $sourceix106=(($76+6)&4294967295); //@line 708 "synthdata.cpp"
                var $77=HEAPU16[(($sourceix106)>>1)]; //@line 708 "synthdata.cpp"
                var $conv107=((($77))&65535); //@line 708 "synthdata.cpp"
                var $cmp108=((($conv107))|0)==0; //@line 708 "synthdata.cpp"
                $retval=$cmp108; //@line 708 "synthdata.cpp"
                __label__ = 73;break $if_then$$if_else187$2; //@line 708 "synthdata.cpp"
              }
              else if (__label__ == 43) {
  
                var $78=$plist_addr; //@line 711 "synthdata.cpp"
                var $arrayidx110=(($78+24)&4294967295); //@line 711 "synthdata.cpp"
                var $sourceix111=(($arrayidx110+6)&4294967295); //@line 711 "synthdata.cpp"
                var $79=HEAP16[(($sourceix111)>>1)]; //@line 711 "synthdata.cpp"
                var $tobool112=(tempInt=(($79)),(tempInt>=32768?tempInt-65536:tempInt))!=0; //@line 711 "synthdata.cpp"
                if ($tobool112) { __lastLabel__ = 43; __label__ = 45;; } else { __lastLabel__ = 43; __label__ = 44;; } //@line 711 "synthdata.cpp"
                if (__label__ == 44) {
  
                  var $80=$plist_addr; //@line 711 "synthdata.cpp"
                  var $arrayidx114=(($80+24)&4294967295); //@line 711 "synthdata.cpp"
                  var $ph115=(($arrayidx114+8)&4294967295); //@line 711 "synthdata.cpp"
                  var $81=HEAP32[(($ph115)>>2)]; //@line 711 "synthdata.cpp"
                  var $type116=(($81+11)&4294967295); //@line 711 "synthdata.cpp"
                  var $82=HEAPU8[($type116)]; //@line 711 "synthdata.cpp"
                  var $conv117=((($82))&255); //@line 711 "synthdata.cpp"
                  var $cmp118=((($conv117))|0)==0; //@line 711 "synthdata.cpp"
                  __lastLabel__ = 44; ; //@line 711 "synthdata.cpp"
                }
  
                var $83=__lastLabel__ == 43 ? 1 : ($cmp118);
                $retval=$83; //@line 711 "synthdata.cpp"
                __label__ = 73;break $if_then$$if_else187$2; //@line 711 "synthdata.cpp"
              }
              else if (__label__ == 46) {
  
                var $84=$plist_addr; //@line 715 "synthdata.cpp"
                var $sourceix121=(($84+6)&4294967295); //@line 715 "synthdata.cpp"
                var $85=HEAPU16[(($sourceix121)>>1)]; //@line 715 "synthdata.cpp"
                var $conv122=((($85))&65535); //@line 715 "synthdata.cpp"
                var $cmp123=((($conv122))|0)!=0; //@line 715 "synthdata.cpp"
                if ($cmp123) { __label__ = 47;; } else { __label__ = 48;; } //@line 715 "synthdata.cpp"
                if (__label__ == 47) {
  
                  $retval=0; //@line 716 "synthdata.cpp"
                  __label__ = 73;break $if_then$$if_else187$2; //@line 716 "synthdata.cpp"
                }
                else if (__label__ == 48) {
                  while(1) { 
  
                    var $86=$plist_addr; //@line 718 "synthdata.cpp"
                    var $incdec_ptr=(($86+-24)&4294967295); //@line 718 "synthdata.cpp"
                    $plist_addr=$incdec_ptr; //@line 718 "synthdata.cpp"
                    var $87=$plist_addr; //@line 719 "synthdata.cpp"
                    var $stresslevel=(($87+1)&4294967295); //@line 719 "synthdata.cpp"
                    var $88=HEAPU8[($stresslevel)]; //@line 719 "synthdata.cpp"
                    var $conv126=((($88))&255); //@line 719 "synthdata.cpp"
                    var $and127=($conv126) & 15; //@line 719 "synthdata.cpp"
                    var $cmp128=((($and127))|0) >= 4; //@line 719 "synthdata.cpp"
                    if ($cmp128) { __label__ = 49;break ; } //@line 719 "synthdata.cpp"
  
                    var $89=$plist_addr; //@line 722 "synthdata.cpp"
                    var $sourceix131=(($89+6)&4294967295); //@line 722 "synthdata.cpp"
                    var $90=HEAPU16[(($sourceix131)>>1)]; //@line 722 "synthdata.cpp"
                    var $conv132=((($90))&65535); //@line 722 "synthdata.cpp"
                    var $cmp133=((($conv132))|0)==0; //@line 722 "synthdata.cpp"
                    if ($cmp133) { __label__ = 48;continue ; } else { __label__ = 60;break $sw_bb169$$sw_bb93$$sw_bb94$$sw_bb101$$sw_bb105$$sw_bb109$$sw_bb120$$sw_bb134$$for_cond139$$sw_bb156$53; } //@line 722 "synthdata.cpp"
                  }
  
                  $retval=1; //@line 720 "synthdata.cpp"
                  __label__ = 73;break $if_then$$if_else187$2; //@line 720 "synthdata.cpp"
                }
              }
              else if (__label__ == 51) {
  
                var $91=$ph; //@line 726 "synthdata.cpp"
                var $type135=(($91+11)&4294967295); //@line 726 "synthdata.cpp"
                var $92=HEAPU8[($type135)]; //@line 726 "synthdata.cpp"
                var $conv136=((($92))&255); //@line 726 "synthdata.cpp"
                var $cmp137=((($conv136))|0)!=2; //@line 726 "synthdata.cpp"
                $retval=$cmp137; //@line 726 "synthdata.cpp"
                __label__ = 73;break $if_then$$if_else187$2; //@line 726 "synthdata.cpp"
              }
              else if (__label__ == 52) {
                while(1) { 
  
                  var $93=$plist_addr; //@line 731 "synthdata.cpp"
                  var $incdec_ptr140=(($93+24)&4294967295); //@line 731 "synthdata.cpp"
                  $plist_addr=$incdec_ptr140; //@line 731 "synthdata.cpp"
                  var $94=$plist_addr; //@line 732 "synthdata.cpp"
                  var $phcode141=(($94)&4294967295); //@line 732 "synthdata.cpp"
                  var $95=HEAPU8[($phcode141)]; //@line 732 "synthdata.cpp"
                  var $idxprom142=((($95))&255); //@line 732 "synthdata.cpp"
                  var $arrayidx143=((_phoneme_tab+$idxprom142*4)&4294967295); //@line 732 "synthdata.cpp"
                  var $96=HEAP32[(($arrayidx143)>>2)]; //@line 732 "synthdata.cpp"
                  var $97=$plist_addr; //@line 732 "synthdata.cpp"
                  var $ph144=(($97+8)&4294967295); //@line 732 "synthdata.cpp"
                  HEAP32[(($ph144)>>2)]=$96; //@line 732 "synthdata.cpp"
                  var $98=$plist_addr; //@line 733 "synthdata.cpp"
                  var $sourceix145=(($98+6)&4294967295); //@line 733 "synthdata.cpp"
                  var $99=HEAPU16[(($sourceix145)>>1)]; //@line 733 "synthdata.cpp"
                  var $conv146=((($99))&65535); //@line 733 "synthdata.cpp"
                  var $cmp147=((($conv146))|0)!=0; //@line 733 "synthdata.cpp"
                  if ($cmp147) { __label__ = 53;break ; } //@line 733 "synthdata.cpp"
  
                  var $100=$plist_addr; //@line 735 "synthdata.cpp"
                  var $ph150=(($100+8)&4294967295); //@line 735 "synthdata.cpp"
                  var $101=HEAP32[(($ph150)>>2)]; //@line 735 "synthdata.cpp"
                  var $type151=(($101+11)&4294967295); //@line 735 "synthdata.cpp"
                  var $102=HEAPU8[($type151)]; //@line 735 "synthdata.cpp"
                  var $conv152=((($102))&255); //@line 735 "synthdata.cpp"
                  var $cmp153=((($conv152))|0)==2; //@line 735 "synthdata.cpp"
                  if ($cmp153) { __label__ = 55;break ; } else { __label__ = 52;continue ; } //@line 735 "synthdata.cpp"
                }
                if (__label__ == 53) {
  
                  $retval=1; //@line 734 "synthdata.cpp"
                  __label__ = 73;break $if_then$$if_else187$2; //@line 734 "synthdata.cpp"
                }
                else if (__label__ == 55) {
  
                  $retval=0; //@line 736 "synthdata.cpp"
                  __label__ = 73;break $if_then$$if_else187$2; //@line 736 "synthdata.cpp"
                }
              }
              else if (__label__ == 56) {
  
                var $103=$ph; //@line 741 "synthdata.cpp"
                var $type157=(($103+11)&4294967295); //@line 741 "synthdata.cpp"
                var $104=HEAPU8[($type157)]; //@line 741 "synthdata.cpp"
                var $conv158=((($104))&255); //@line 741 "synthdata.cpp"
                var $cmp159=((($conv158))|0)==2; //@line 741 "synthdata.cpp"
                if ($cmp159) { __lastLabel__ = 56; __label__ = 59;; } else { __lastLabel__ = 56; __label__ = 57;; } //@line 741 "synthdata.cpp"
                $lor_end168$$lor_lhs_false160$80: do { 
                  if (__label__ == 57) {
  
                    var $105=$ph; //@line 741 "synthdata.cpp"
                    var $type161=(($105+11)&4294967295); //@line 741 "synthdata.cpp"
                    var $106=HEAPU8[($type161)]; //@line 741 "synthdata.cpp"
                    var $conv162=((($106))&255); //@line 741 "synthdata.cpp"
                    var $cmp163=((($conv162))|0)==3; //@line 741 "synthdata.cpp"
                    if ($cmp163) { __lastLabel__ = 57; __label__ = 59;break $lor_end168$$lor_lhs_false160$80; } else { __lastLabel__ = 57; ; } //@line 741 "synthdata.cpp"
  
                    var $107=$ph; //@line 741 "synthdata.cpp"
                    var $phflags165=(($107+4)&4294967295); //@line 741 "synthdata.cpp"
                    var $108=HEAP32[(($phflags165)>>2)]; //@line 741 "synthdata.cpp"
                    var $and166=($108) & 16; //@line 741 "synthdata.cpp"
                    var $tobool167=((($and166))|0)!=0; //@line 741 "synthdata.cpp"
                    __lastLabel__ = 58; ; //@line 741 "synthdata.cpp"
                  }
                } while(0);
  
                var $109=__lastLabel__ == 57 ? 1 : (__lastLabel__ == 56 ? 1 : ($tobool167));
                $retval=$109; //@line 741 "synthdata.cpp"
                __label__ = 73;break $if_then$$if_else187$2; //@line 741 "synthdata.cpp"
              }
            } while(0);
  
            $count=0; //@line 745 "synthdata.cpp"
            ; //@line 746 "synthdata.cpp"
            while(1) { 
  
              var $110=$plist_addr; //@line 748 "synthdata.cpp"
              var $ph171=(($110+8)&4294967295); //@line 748 "synthdata.cpp"
              var $111=HEAP32[(($ph171)>>2)]; //@line 748 "synthdata.cpp"
              var $type172=(($111+11)&4294967295); //@line 748 "synthdata.cpp"
              var $112=HEAPU8[($type172)]; //@line 748 "synthdata.cpp"
              var $conv173=((($112))&255); //@line 748 "synthdata.cpp"
              var $cmp174=((($conv173))|0)==2; //@line 748 "synthdata.cpp"
              if ($cmp174) { __label__ = 62;; } else { __label__ = 63;; } //@line 748 "synthdata.cpp"
              if (__label__ == 62) {
  
                var $113=$count; //@line 749 "synthdata.cpp"
                var $inc176=((($113)+1)&4294967295); //@line 749 "synthdata.cpp"
                $count=$inc176; //@line 749 "synthdata.cpp"
                ; //@line 749 "synthdata.cpp"
              }
  
              var $114=$plist_addr; //@line 750 "synthdata.cpp"
              var $sourceix178=(($114+6)&4294967295); //@line 750 "synthdata.cpp"
              var $115=HEAPU16[(($sourceix178)>>1)]; //@line 750 "synthdata.cpp"
              var $conv179=((($115))&65535); //@line 750 "synthdata.cpp"
              var $cmp180=((($conv179))|0)!=0; //@line 750 "synthdata.cpp"
              if ($cmp180) { __label__ = 65;break ; } //@line 750 "synthdata.cpp"
  
              var $116=$plist_addr; //@line 752 "synthdata.cpp"
              var $incdec_ptr183=(($116+-24)&4294967295); //@line 752 "synthdata.cpp"
              $plist_addr=$incdec_ptr183; //@line 752 "synthdata.cpp"
              __label__ = 61;continue ; //@line 753 "synthdata.cpp"
            }
  
            var $117=$count; //@line 754 "synthdata.cpp"
            var $cmp185=((($117))|0)==1; //@line 754 "synthdata.cpp"
            $retval=$cmp185; //@line 754 "synthdata.cpp"
            ; //@line 754 "synthdata.cpp"
          }
        }
      }
      else if (__label__ == 67) {
  
        var $cmp188=((($3))|0)==15; //@line 761 "synthdata.cpp"
        if ($cmp188) { __label__ = 68;; } else { __label__ = 72;; } //@line 761 "synthdata.cpp"
        $if_then189$$if_end201$93: do { 
          if (__label__ == 68) {
  
            var $118=$data; //@line 764 "synthdata.cpp"
            if ($118 == 1) {
              __label__ = 69;;
            }
            else if ($118 == 2) {
              __label__ = 70;;
            }
            else if ($118 == 3) {
              __label__ = 71;;
            }
            else {
            __label__ = 72;break $if_then189$$if_end201$93;
            }
            
            if (__label__ == 69) {
  
              var $119=$control_addr; //@line 767 "synthdata.cpp"
              var $and191=($119) & 1; //@line 767 "synthdata.cpp"
              var $tobool192=((($and191))|0)!=0; //@line 767 "synthdata.cpp"
              $retval=$tobool192; //@line 767 "synthdata.cpp"
              __label__ = 73;break $if_then$$if_else187$2; //@line 767 "synthdata.cpp"
            }
            else if (__label__ == 70) {
  
              var $120=HEAP32[((_voice)>>2)]; //@line 769 "synthdata.cpp"
              var $klattv=(($120+112)&4294967295); //@line 769 "synthdata.cpp"
              var $arrayidx194=(($klattv)&4294967295); //@line 769 "synthdata.cpp"
              var $121=HEAP32[(($arrayidx194)>>2)]; //@line 769 "synthdata.cpp"
              var $cmp195=((($121))|0)!=0; //@line 769 "synthdata.cpp"
              $retval=$cmp195; //@line 769 "synthdata.cpp"
              __label__ = 73;break $if_then$$if_else187$2; //@line 769 "synthdata.cpp"
            }
            else if (__label__ == 71) {
  
              var $122=HEAP8[(((_mbrola_name)&4294967295))]; //@line 771 "synthdata.cpp"
              var $conv197=(tempInt=(($122)),(tempInt>=128?tempInt-256:tempInt)); //@line 771 "synthdata.cpp"
              var $cmp198=((($conv197))|0)!=0; //@line 771 "synthdata.cpp"
              $retval=$cmp198; //@line 771 "synthdata.cpp"
              __label__ = 73;break $if_then$$if_else187$2; //@line 771 "synthdata.cpp"
            }
          }
        } while(0);
  
        $retval=0; //@line 774 "synthdata.cpp"
        ; //@line 774 "synthdata.cpp"
      }
    } while(0);
  
    var $123=$retval; //@line 775 "synthdata.cpp"
    ;
    return $123; //@line 775 "synthdata.cpp"
    return null;
  }
  

  function __ZL13NumInstnWordsPt($prog) {
    ;
    var __label__;
  
    var $retval;
    var $prog_addr;
    var $instn;
    var $instn2;
    var $instn_type;
    $prog_addr=$prog;
    var $0=$prog_addr; //@line 814 "synthdata.cpp"
    var $1=HEAPU16[(($0)>>1)]; //@line 814 "synthdata.cpp"
    var $conv=((($1))&65535); //@line 814 "synthdata.cpp"
    $instn=$conv; //@line 814 "synthdata.cpp"
    var $2=$instn; //@line 815 "synthdata.cpp"
    var $shr=($2) >> 12; //@line 815 "synthdata.cpp"
    $instn_type=$shr; //@line 815 "synthdata.cpp"
    var $3=$instn_type; //@line 816 "synthdata.cpp"
    var $cmp=((($3))|0) < 11; //@line 816 "synthdata.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 816 "synthdata.cpp"
    if (__label__ == 1) {
  
      var $4=$instn_type; //@line 817 "synthdata.cpp"
      var $arrayidx=((__ZZL13NumInstnWordsPtE7n_words+$4)&4294967295); //@line 817 "synthdata.cpp"
      var $5=HEAP8[($arrayidx)]; //@line 817 "synthdata.cpp"
      var $conv1=(tempInt=(($5)),(tempInt>=128?tempInt-256:tempInt)); //@line 817 "synthdata.cpp"
      $retval=$conv1; //@line 817 "synthdata.cpp"
      ; //@line 817 "synthdata.cpp"
    }
    else if (__label__ == 2) {
  
      var $6=$prog_addr; //@line 820 "synthdata.cpp"
      var $arrayidx2=(($6+4)&4294967295); //@line 820 "synthdata.cpp"
      var $7=HEAPU16[(($arrayidx2)>>1)]; //@line 820 "synthdata.cpp"
      var $conv3=((($7))&65535); //@line 820 "synthdata.cpp"
      $instn2=$conv3; //@line 820 "synthdata.cpp"
      var $8=$instn2; //@line 821 "synthdata.cpp"
      var $shr4=($8) >> 12; //@line 821 "synthdata.cpp"
      var $cmp5=((($shr4))|0)==15; //@line 821 "synthdata.cpp"
      if ($cmp5) { __label__ = 3;; } else { __label__ = 4;; } //@line 821 "synthdata.cpp"
      if (__label__ == 3) {
  
        $retval=4; //@line 824 "synthdata.cpp"
        ; //@line 824 "synthdata.cpp"
      }
      else if (__label__ == 4) {
  
        var $9=$instn2; //@line 826 "synthdata.cpp"
        var $cmp8=((($9))|0)==2; //@line 826 "synthdata.cpp"
        if ($cmp8) { __label__ = 5;; } else { __label__ = 6;; } //@line 826 "synthdata.cpp"
        if (__label__ == 5) {
  
          $retval=3; //@line 828 "synthdata.cpp"
          ; //@line 828 "synthdata.cpp"
        }
        else if (__label__ == 6) {
  
          $retval=2; //@line 830 "synthdata.cpp"
          ; //@line 830 "synthdata.cpp"
        }
      }
    }
  
    var $10=$retval; //@line 831 "synthdata.cpp"
    ;
    return $10; //@line 831 "synthdata.cpp"
    return null;
  }
  

  function __ZL15SwitchVowelTypeP12PHONEME_LISTP12PHONEME_DATAPPti($plist, $phdata, $p_prog, $instn_type) {
    ;
    var __label__;
  
    var $plist_addr;
    var $phdata_addr;
    var $p_prog_addr;
    var $instn_type_addr;
    var $prog;
    var $voweltype;
    var $x;
    $plist_addr=$plist;
    $phdata_addr=$phdata;
    $p_prog_addr=$p_prog;
    $instn_type_addr=$instn_type;
    var $0=$instn_type_addr; //@line 784 "synthdata.cpp"
    var $cmp=((($0))|0)==2; //@line 784 "synthdata.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 784 "synthdata.cpp"
    if (__label__ == 1) {
  
      var $1=$phdata_addr; //@line 786 "synthdata.cpp"
      var $pd_control=(($1)&4294967295); //@line 786 "synthdata.cpp"
      var $2=HEAP32[(($pd_control)>>2)]; //@line 786 "synthdata.cpp"
      var $or=($2) | 2; //@line 786 "synthdata.cpp"
      HEAP32[(($pd_control)>>2)]=$or; //@line 786 "synthdata.cpp"
      var $3=$plist_addr; //@line 787 "synthdata.cpp"
      var $arrayidx=(($3+24)&4294967295); //@line 787 "synthdata.cpp"
      var $ph=(($arrayidx+8)&4294967295); //@line 787 "synthdata.cpp"
      var $4=HEAP32[(($ph)>>2)]; //@line 787 "synthdata.cpp"
      var $start_type=(($4+12)&4294967295); //@line 787 "synthdata.cpp"
      var $5=HEAPU8[($start_type)]; //@line 787 "synthdata.cpp"
      var $conv=((($5))&255); //@line 787 "synthdata.cpp"
      $voweltype=$conv; //@line 787 "synthdata.cpp"
      ; //@line 788 "synthdata.cpp"
    }
    else if (__label__ == 2) {
  
      var $6=$plist_addr; //@line 791 "synthdata.cpp"
      var $arrayidx1=(($6+-24)&4294967295); //@line 791 "synthdata.cpp"
      var $ph2=(($arrayidx1+8)&4294967295); //@line 791 "synthdata.cpp"
      var $7=HEAP32[(($ph2)>>2)]; //@line 791 "synthdata.cpp"
      var $end_type=(($7+13)&4294967295); //@line 791 "synthdata.cpp"
      var $8=HEAPU8[($end_type)]; //@line 791 "synthdata.cpp"
      var $conv3=((($8))&255); //@line 791 "synthdata.cpp"
      $voweltype=$conv3; //@line 791 "synthdata.cpp"
      ;
    }
  
    var $9=$voweltype; //@line 794 "synthdata.cpp"
    var $sub=((($9)-28)&4294967295); //@line 794 "synthdata.cpp"
    $voweltype=$sub; //@line 794 "synthdata.cpp"
    var $10=$voweltype; //@line 795 "synthdata.cpp"
    var $cmp4=((($10))|0) >= 0; //@line 795 "synthdata.cpp"
    var $11=$voweltype; //@line 795 "synthdata.cpp"
    var $cmp5=((($11))|0) < 6; //@line 795 "synthdata.cpp"
    var $or_cond=($cmp4) & ($cmp5); //@line 795 "synthdata.cpp"
    if ($or_cond) { __label__ = 4;; } else { __label__ = 5;; } //@line 795 "synthdata.cpp"
    if (__label__ == 4) {
  
      var $12=$p_prog_addr; //@line 797 "synthdata.cpp"
      var $13=HEAP32[(($12)>>2)]; //@line 797 "synthdata.cpp"
      var $14=$voweltype; //@line 797 "synthdata.cpp"
      var $mul=((($14)*2)&4294967295); //@line 797 "synthdata.cpp"
      var $add_ptr=(($13+2*$mul)&4294967295); //@line 797 "synthdata.cpp"
      $prog=$add_ptr; //@line 797 "synthdata.cpp"
      var $15=$prog; //@line 798 "synthdata.cpp"
      var $arrayidx7=(($15+2)&4294967295); //@line 798 "synthdata.cpp"
      var $16=HEAPU16[(($arrayidx7)>>1)]; //@line 798 "synthdata.cpp"
      var $conv8=((($16))&65535); //@line 798 "synthdata.cpp"
      var $and=($conv8) & 15; //@line 798 "synthdata.cpp"
      var $shl=((($and)*65536)&4294967295); //@line 798 "synthdata.cpp"
      var $17=$prog; //@line 798 "synthdata.cpp"
      var $arrayidx9=(($17+4)&4294967295); //@line 798 "synthdata.cpp"
      var $18=HEAPU16[(($arrayidx9)>>1)]; //@line 798 "synthdata.cpp"
      var $conv10=((($18))&65535); //@line 798 "synthdata.cpp"
      var $add=((($shl)+($conv10))&4294967295); //@line 798 "synthdata.cpp"
      var $mul11=((($add)*4)&4294967295); //@line 798 "synthdata.cpp"
      var $19=$instn_type_addr; //@line 798 "synthdata.cpp"
      var $20=$phdata_addr; //@line 798 "synthdata.cpp"
      var $sound_addr=(($20+68)&4294967295); //@line 798 "synthdata.cpp"
      var $arrayidx12=(($sound_addr+$19*4)&4294967295); //@line 798 "synthdata.cpp"
      HEAP32[(($arrayidx12)>>2)]=$mul11; //@line 798 "synthdata.cpp"
      var $21=$prog; //@line 799 "synthdata.cpp"
      var $arrayidx13=(($21+2)&4294967295); //@line 799 "synthdata.cpp"
      var $22=HEAPU16[(($arrayidx13)>>1)]; //@line 799 "synthdata.cpp"
      var $conv14=((($22))&65535); //@line 799 "synthdata.cpp"
      var $shr=($conv14) >> 4; //@line 799 "synthdata.cpp"
      var $and15=($shr) & 255; //@line 799 "synthdata.cpp"
      var $conv16=((($and15)) & 255); //@line 799 "synthdata.cpp"
      $x=$conv16; //@line 799 "synthdata.cpp"
      var $23=$x; //@line 800 "synthdata.cpp"
      var $conv17=(tempInt=(($23)),(tempInt>=128?tempInt-256:tempInt)); //@line 800 "synthdata.cpp"
      var $24=$instn_type_addr; //@line 800 "synthdata.cpp"
      var $25=$phdata_addr; //@line 800 "synthdata.cpp"
      var $sound_param=(($25+88)&4294967295); //@line 800 "synthdata.cpp"
      var $arrayidx18=(($sound_param+$24*4)&4294967295); //@line 800 "synthdata.cpp"
      HEAP32[(($arrayidx18)>>2)]=$conv17; //@line 800 "synthdata.cpp"
      ; //@line 801 "synthdata.cpp"
    }
  
    var $26=$p_prog_addr; //@line 803 "synthdata.cpp"
    var $27=HEAP32[(($26)>>2)]; //@line 803 "synthdata.cpp"
    var $add_ptr20=(($27+24)&4294967295); //@line 803 "synthdata.cpp"
    HEAP32[(($26)>>2)]=$add_ptr20; //@line 803 "synthdata.cpp"
    ;
    return; //@line 804 "synthdata.cpp"
    return;
  }
  

  function __Z17InterpretPhoneme2iP12PHONEME_DATA($phcode, $phdata) {
    var __stackBase__  = STACKTOP; STACKTOP += 96; _memset(__stackBase__, 0, 96);
    var __label__;
  
    var $phcode_addr;
    var $phdata_addr;
    var $ix;
    var $plist=__stackBase__;
    $phcode_addr=$phcode;
    $phdata_addr=$phdata;
    var $arraydecay=(($plist)&4294967295); //@line 1102 "synthdata.cpp"
    var $0=$arraydecay; //@line 1102 "synthdata.cpp"
    var $dest$, $stop$, $stop4$, $fast$, $value4$;
    $dest$ = $0;
    $stop$ = $dest$ + 96;
    $value4$ = 0;
    if ($value4$ < 0) $value4$ += 256;
    $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
    while ($dest$%4 !== 0 && $dest$ < $stop$) {
      ;; HEAP8[$dest$++] = 0;
    }
    $dest$ >>= 2;
    $stop4$ = $stop$ >> 2;
    while ($dest$ < $stop4$) {
    ;;;;;;;  HEAP32[$dest$++] = $value4$;
    }
    $dest$ <<= 2;
    while ($dest$ < $stop$) {
      ;; HEAP8[$dest$++] = 0;
    }; //@line 1102 "synthdata.cpp"
    $ix=0; //@line 1104 "synthdata.cpp"
    ; //@line 1104 "synthdata.cpp"
    while(1) { 
  
      var $1=$ix; //@line 1106 "synthdata.cpp"
      var $arrayidx=(($plist+$1*24)&4294967295); //@line 1106 "synthdata.cpp"
      var $phcode1=(($arrayidx)&4294967295); //@line 1106 "synthdata.cpp"
      HEAP8[($phcode1)]=9; //@line 1106 "synthdata.cpp"
      var $2=HEAP32[((((_phoneme_tab+36)&4294967295))>>2)]; //@line 1107 "synthdata.cpp"
      var $3=$ix; //@line 1107 "synthdata.cpp"
      var $arrayidx2=(($plist+$3*24)&4294967295); //@line 1107 "synthdata.cpp"
      var $ph=(($arrayidx2+8)&4294967295); //@line 1107 "synthdata.cpp"
      HEAP32[(($ph)>>2)]=$2; //@line 1107 "synthdata.cpp"
      var $4=$ix; //@line 1104 "synthdata.cpp"
      var $inc=((($4)+1)&4294967295); //@line 1104 "synthdata.cpp"
      $ix=$inc; //@line 1104 "synthdata.cpp"
      var $cmp=((($inc))|0) < 4; //@line 1104 "synthdata.cpp"
      if ($cmp) { __label__ = 1;continue ; } else { __label__ = 2;break ; } //@line 1104 "synthdata.cpp"
    }
  
    var $5=$phcode_addr; //@line 1110 "synthdata.cpp"
    var $conv=((($5)) & 255); //@line 1110 "synthdata.cpp"
    var $arrayidx3=(($plist+24)&4294967295); //@line 1110 "synthdata.cpp"
    var $phcode4=(($arrayidx3)&4294967295); //@line 1110 "synthdata.cpp"
    HEAP8[($phcode4)]=$conv; //@line 1110 "synthdata.cpp"
    var $6=$phcode_addr; //@line 1111 "synthdata.cpp"
    var $arrayidx5=((_phoneme_tab+$6*4)&4294967295); //@line 1111 "synthdata.cpp"
    var $7=HEAP32[(($arrayidx5)>>2)]; //@line 1111 "synthdata.cpp"
    var $arrayidx6=(($plist+24)&4294967295); //@line 1111 "synthdata.cpp"
    var $ph7=(($arrayidx6+8)&4294967295); //@line 1111 "synthdata.cpp"
    HEAP32[(($ph7)>>2)]=$7; //@line 1111 "synthdata.cpp"
    var $arrayidx8=(($plist+48)&4294967295); //@line 1112 "synthdata.cpp"
    var $sourceix=(($arrayidx8+6)&4294967295); //@line 1112 "synthdata.cpp"
    HEAP16[(($sourceix)>>1)]=1; //@line 1112 "synthdata.cpp"
    var $arrayidx9=(($plist+24)&4294967295); //@line 1114 "synthdata.cpp"
    var $8=$phdata_addr; //@line 1114 "synthdata.cpp"
    __Z16InterpretPhonemeP10TranslatoriP12PHONEME_LISTP12PHONEME_DATA(0, 0, $arrayidx9, $8); //@line 1114 "synthdata.cpp"
    STACKTOP = __stackBase__;
    return; //@line 1115 "synthdata.cpp"
    return;
  }
  

  function __Z12WordToStringj($word) {
    ;
    var __label__;
  
    var $word_addr;
    var $ix;
    $word_addr=$word;
    $ix=0; //@line 85 "synthesize.cpp"
    ; //@line 85 "synthesize.cpp"
    while(1) { 
  
      var $0=$word_addr; //@line 86 "synthesize.cpp"
      var $1=$ix; //@line 86 "synthesize.cpp"
      var $mul=((($1)*8)&4294967295); //@line 86 "synthesize.cpp"
      var $shr=($0) >>> ((($mul))>>>0); //@line 86 "synthesize.cpp"
      var $conv=((($shr)) & 255); //@line 86 "synthesize.cpp"
      var $2=$ix; //@line 86 "synthesize.cpp"
      var $arrayidx=((__ZZ12WordToStringjE3buf+$2)&4294967295); //@line 86 "synthesize.cpp"
      HEAP8[($arrayidx)]=$conv; //@line 86 "synthesize.cpp"
      var $3=$ix; //@line 85 "synthesize.cpp"
      var $inc=((($3)+1)&4294967295); //@line 85 "synthesize.cpp"
      $ix=$inc; //@line 85 "synthesize.cpp"
      var $cmp=((($inc))|0) < 3; //@line 85 "synthesize.cpp"
      if ($cmp) { __label__ = 1;continue ; } else { __label__ = 2;break ; } //@line 85 "synthesize.cpp"
    }
  
    HEAP8[(((__ZZ12WordToStringjE3buf+4)&4294967295))]=0; //@line 87 "synthesize.cpp"
    ;
    return ((__ZZ12WordToStringjE3buf)&4294967295); //@line 88 "synthesize.cpp"
    return null;
  }
  

  function __Z14SynthesizeInitv() {
    ;
    var __label__;
  
    HEAP32[((__ZL14last_pitch_cmd)>>2)]=0; //@line 95 "synthesize.cpp"
    HEAP32[((__ZL12last_amp_cmd)>>2)]=0; //@line 96 "synthesize.cpp"
    HEAP32[((__ZL10last_frame)>>2)]=0; //@line 97 "synthesize.cpp"
    HEAP32[((__ZL15syllable_centre)>>2)]=-1; //@line 98 "synthesize.cpp"
    ;
    return; //@line 104 "synthesize.cpp"
    return;
  }
  

  function __Z11PauseLengthii($pause, $control) {
    ;
    var __label__;
  
    var $pause_addr;
    var $control_addr;
    var $len;
    $pause_addr=$pause;
    $control_addr=$control;
    var $0=$control_addr; //@line 193 "synthesize.cpp"
    var $cmp=((($0))|0)==0; //@line 193 "synthesize.cpp"
    var $1=$pause_addr; //@line 195 "synthesize.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 4;; } //@line 193 "synthesize.cpp"
    if (__label__ == 1) {
  
      var $cmp1=((($1))|0) >= 200; //@line 195 "synthesize.cpp"
      var $2=$pause_addr; //@line 196 "synthesize.cpp"
      if ($cmp1) { __label__ = 2;; } else { __label__ = 3;; } //@line 195 "synthesize.cpp"
      if (__label__ == 2) {
  
        var $3=HEAP32[((((_speed+4)&4294967295))>>2)]; //@line 196 "synthesize.cpp"
        var $mul=((($3)*($2))&4294967295); //@line 196 "synthesize.cpp"
        var $div=((((($mul))|0)/256)|0); //@line 196 "synthesize.cpp"
        $len=$div; //@line 196 "synthesize.cpp"
        ; //@line 196 "synthesize.cpp"
      }
      else if (__label__ == 3) {
  
        var $4=HEAP32[((((_speed)&4294967295))>>2)]; //@line 198 "synthesize.cpp"
        var $mul3=((($4)*($2))&4294967295); //@line 198 "synthesize.cpp"
        var $div4=((((($mul3))|0)/256)|0); //@line 198 "synthesize.cpp"
        $len=$div4; //@line 198 "synthesize.cpp"
        ;
      }
    }
    else if (__label__ == 4) {
  
      var $5=HEAP32[((((_speed+12)&4294967295))>>2)]; //@line 201 "synthesize.cpp"
      var $mul6=((($5)*($1))&4294967295); //@line 201 "synthesize.cpp"
      var $div7=((((($mul6))|0)/256)|0); //@line 201 "synthesize.cpp"
      $len=$div7; //@line 201 "synthesize.cpp"
      ;
    }
  
    var $6=$len; //@line 203 "synthesize.cpp"
    var $7=HEAP32[((((_speed+8)&4294967295))>>2)]; //@line 203 "synthesize.cpp"
    var $cmp9=((($6))|0) < ((($7))|0); //@line 203 "synthesize.cpp"
    if ($cmp9) { __label__ = 6;; } else { __label__ = 7;; } //@line 203 "synthesize.cpp"
    if (__label__ == 6) {
  
      var $8=HEAP32[((((_speed+8)&4294967295))>>2)]; //@line 205 "synthesize.cpp"
      $len=$8; //@line 205 "synthesize.cpp"
      ; //@line 206 "synthesize.cpp"
    }
  
    var $9=$len; //@line 207 "synthesize.cpp"
    ;
    return $9; //@line 207 "synthesize.cpp"
    return null;
  }
  

  function __Z9DoSample3P12PHONEME_DATAii($phdata, $length_mod, $amp) {
    ;
    var __label__;
  
    var $phdata_addr;
    var $length_mod_addr;
    var $amp_addr;
    var $amp2;
    var $len;
    $phdata_addr=$phdata;
    $length_mod_addr=$length_mod;
    $amp_addr=$amp;
    __ZL8EndPitchi(1); //@line 405 "synthesize.cpp"
    var $0=$amp_addr; //@line 407 "synthesize.cpp"
    var $cmp=((($0))|0)==-1; //@line 407 "synthesize.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 407 "synthesize.cpp"
    if (__label__ == 1) {
  
      var $1=$amp_addr; //@line 410 "synthesize.cpp"
      $amp2=$1; //@line 410 "synthesize.cpp"
      ; //@line 411 "synthesize.cpp"
    }
    else if (__label__ == 2) {
  
      var $2=$phdata_addr; //@line 414 "synthesize.cpp"
      var $sound_param=(($2+88)&4294967295); //@line 414 "synthesize.cpp"
      var $arrayidx=(($sound_param+4)&4294967295); //@line 414 "synthesize.cpp"
      var $3=HEAP32[(($arrayidx)>>2)]; //@line 414 "synthesize.cpp"
      $amp2=$3; //@line 414 "synthesize.cpp"
      var $4=$amp2; //@line 415 "synthesize.cpp"
      var $cmp1=((($4))|0)==0; //@line 415 "synthesize.cpp"
      if ($cmp1) { __label__ = 3;; } else { __label__ = 4;; } //@line 415 "synthesize.cpp"
      if (__label__ == 3) {
  
        $amp2=100; //@line 416 "synthesize.cpp"
        ; //@line 416 "synthesize.cpp"
      }
  
      var $5=$amp2; //@line 417 "synthesize.cpp"
      var $mul=((($5)*32)&4294967295); //@line 417 "synthesize.cpp"
      var $div=((((($mul))|0)/100)|0); //@line 417 "synthesize.cpp"
      $amp2=$div; //@line 417 "synthesize.cpp"
      ;
    }
  
    HEAP32[((_seq_len_adjust)>>2)]=0; //@line 420 "synthesize.cpp"
    var $6=$phdata_addr; //@line 422 "synthesize.cpp"
    var $sound_addr=(($6+68)&4294967295); //@line 422 "synthesize.cpp"
    var $arrayidx4=(($sound_addr+4)&4294967295); //@line 422 "synthesize.cpp"
    var $7=HEAP32[(($arrayidx4)>>2)]; //@line 422 "synthesize.cpp"
    var $cmp5=((($7))|0)==0; //@line 422 "synthesize.cpp"
    if ($cmp5) { __label__ = 6;; } else { __label__ = 7;; } //@line 422 "synthesize.cpp"
    if (__label__ == 6) {
  
      $len=0; //@line 424 "synthesize.cpp"
      ; //@line 425 "synthesize.cpp"
    }
    else if (__label__ == 7) {
  
      var $8=$phdata_addr; //@line 428 "synthesize.cpp"
      var $sound_addr8=(($8+68)&4294967295); //@line 428 "synthesize.cpp"
      var $arrayidx9=(($sound_addr8+4)&4294967295); //@line 428 "synthesize.cpp"
      var $9=HEAP32[(($arrayidx9)>>2)]; //@line 428 "synthesize.cpp"
      var $10=$phdata_addr; //@line 428 "synthesize.cpp"
      var $pd_param=(($10+4)&4294967295); //@line 428 "synthesize.cpp"
      var $arrayidx10=(($pd_param+40)&4294967295); //@line 428 "synthesize.cpp"
      var $11=HEAP32[(($arrayidx10)>>2)]; //@line 428 "synthesize.cpp"
      var $mul11=((($11)*2)&4294967295); //@line 428 "synthesize.cpp"
      var $12=$phdata_addr; //@line 428 "synthesize.cpp"
      var $pd_control=(($12)&4294967295); //@line 428 "synthesize.cpp"
      var $13=HEAP32[(($pd_control)>>2)]; //@line 428 "synthesize.cpp"
      var $14=$length_mod_addr; //@line 428 "synthesize.cpp"
      var $15=$amp2; //@line 428 "synthesize.cpp"
      var $call=__ZL9DoSample2iiiiii($9, 2, $mul11, $13, $14, $15); //@line 428 "synthesize.cpp"
      $len=$call; //@line 428 "synthesize.cpp"
      ;
    }
  
    HEAP32[((__ZL10last_frame)>>2)]=0; //@line 430 "synthesize.cpp"
    var $16=$len; //@line 431 "synthesize.cpp"
    ;
    return $16; //@line 431 "synthesize.cpp"
    return null;
  }
  

  function __ZL8EndPitchi($voice_break) {
    ;
    var __label__;
  
    var $voice_break_addr;
    $voice_break_addr=$voice_break;
    var $0=HEAP32[((__ZL12pitch_length)>>2)]; //@line 123 "synthesize.cpp"
    var $cmp=((($0))|0) > 0; //@line 123 "synthesize.cpp"
    var $1=HEAP32[((__ZL14last_pitch_cmd)>>2)]; //@line 123 "synthesize.cpp"
    var $cmp1=((($1))|0) >= 0; //@line 123 "synthesize.cpp"
    var $or_cond=($cmp) & ($cmp1); //@line 123 "synthesize.cpp"
    if ($or_cond) { __label__ = 1;; } else { __label__ = 4;; } //@line 123 "synthesize.cpp"
    if (__label__ == 1) {
  
      var $2=HEAP32[((__ZL14last_pitch_cmd)>>2)]; //@line 125 "synthesize.cpp"
      var $arrayidx=((_wcmdq+$2*16)&4294967295); //@line 125 "synthesize.cpp"
      var $arrayidx2=(($arrayidx+4)&4294967295); //@line 125 "synthesize.cpp"
      var $3=HEAP32[(($arrayidx2)>>2)]; //@line 125 "synthesize.cpp"
      var $cmp3=((($3))|0)==0; //@line 125 "synthesize.cpp"
      if ($cmp3) { __label__ = 2;; } else { __label__ = 3;; } //@line 125 "synthesize.cpp"
      if (__label__ == 2) {
  
        var $4=HEAP32[((__ZL12pitch_length)>>2)]; //@line 126 "synthesize.cpp"
        var $5=HEAP32[((__ZL14last_pitch_cmd)>>2)]; //@line 126 "synthesize.cpp"
        var $arrayidx5=((_wcmdq+$5*16)&4294967295); //@line 126 "synthesize.cpp"
        var $arrayidx6=(($arrayidx5+4)&4294967295); //@line 126 "synthesize.cpp"
        HEAP32[(($arrayidx6)>>2)]=$4; //@line 126 "synthesize.cpp"
        ; //@line 126 "synthesize.cpp"
      }
  
      HEAP32[((__ZL12pitch_length)>>2)]=0; //@line 127 "synthesize.cpp"
      ; //@line 128 "synthesize.cpp"
    }
  
    var $6=$voice_break_addr; //@line 130 "synthesize.cpp"
    var $tobool=((($6))|0)!=0; //@line 130 "synthesize.cpp"
    if ($tobool) { __label__ = 5;; } else { __label__ = 6;; } //@line 130 "synthesize.cpp"
    if (__label__ == 5) {
  
      HEAP32[((__ZL10last_wcmdq)>>2)]=-1; //@line 132 "synthesize.cpp"
      HEAP32[((__ZL10last_frame)>>2)]=0; //@line 133 "synthesize.cpp"
      var $7=HEAP32[((_wcmdq_tail)>>2)]; //@line 134 "synthesize.cpp"
      HEAP32[((__ZL12syllable_end)>>2)]=$7; //@line 134 "synthesize.cpp"
      __ZL11SmoothSpectv(); //@line 135 "synthesize.cpp"
      HEAP32[((__ZL15syllable_centre)>>2)]=-1; //@line 136 "synthesize.cpp"
      var $dest$, $stop$, $stop4$, $fast$, $value4$;
      $dest$ = _vowel_transition;
      $stop$ = $dest$ + 16;
      $value4$ = 0;
      if ($value4$ < 0) $value4$ += 256;
      $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
      while ($dest$%4 !== 0 && $dest$ < $stop$) {
        ;; HEAP8[$dest$++] = 0;
      }
      $dest$ >>= 2;
      $stop4$ = $stop$ >> 2;
      while ($dest$ < $stop4$) {
      ;;;;;;;  HEAP32[$dest$++] = $value4$;
      }
      $dest$ <<= 2;
      while ($dest$ < $stop$) {
        ;; HEAP8[$dest$++] = 0;
      }; //@line 137 "synthesize.cpp"
      ; //@line 138 "synthesize.cpp"
    }
  
    ;
    return; //@line 139 "synthesize.cpp"
    return;
  }
  

  function __ZL9DoSample2iiiiii($index, $which, $std_length, $control, $length_mod, $amp) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $index_addr;
    var $which_addr;
    var $std_length_addr;
    var $control_addr;
    var $length_mod_addr;
    var $amp_addr;
    var $length;
    var $wav_length;
    var $wav_scale;
    var $min_length;
    var $x;
    var $len4;
    var $q;
    var $p;
    $index_addr=$index;
    $which_addr=$which;
    $std_length_addr=$std_length;
    $control_addr=$control;
    $length_mod_addr=$length_mod;
    $amp_addr=$amp;
    var $0=$index_addr; //@line 254 "synthesize.cpp"
    var $and=($0) & 8388607; //@line 254 "synthesize.cpp"
    $index_addr=$and; //@line 254 "synthesize.cpp"
    var $1=$index_addr; //@line 255 "synthesize.cpp"
    var $2=HEAP32[((_wavefile_data)>>2)]; //@line 255 "synthesize.cpp"
    var $arrayidx=(($2+$1)&4294967295); //@line 255 "synthesize.cpp"
    $p=$arrayidx; //@line 255 "synthesize.cpp"
    var $3=$p; //@line 256 "synthesize.cpp"
    var $arrayidx1=(($3+2)&4294967295); //@line 256 "synthesize.cpp"
    var $4=HEAPU8[($arrayidx1)]; //@line 256 "synthesize.cpp"
    var $conv=((($4))&255); //@line 256 "synthesize.cpp"
    $wav_scale=$conv; //@line 256 "synthesize.cpp"
    var $5=$p; //@line 257 "synthesize.cpp"
    var $arrayidx2=(($5+1)&4294967295); //@line 257 "synthesize.cpp"
    var $6=HEAPU8[($arrayidx2)]; //@line 257 "synthesize.cpp"
    var $conv3=((($6))&255); //@line 257 "synthesize.cpp"
    var $mul=((($conv3)*256)&4294967295); //@line 257 "synthesize.cpp"
    $wav_length=$mul; //@line 257 "synthesize.cpp"
    var $7=$p; //@line 258 "synthesize.cpp"
    var $arrayidx4=(($7)&4294967295); //@line 258 "synthesize.cpp"
    var $8=HEAPU8[($arrayidx4)]; //@line 258 "synthesize.cpp"
    var $conv5=((($8))&255); //@line 258 "synthesize.cpp"
    var $9=$wav_length; //@line 258 "synthesize.cpp"
    var $add=((($9)+($conv5))&4294967295); //@line 258 "synthesize.cpp"
    $wav_length=$add; //@line 258 "synthesize.cpp"
    var $10=$wav_length; //@line 260 "synthesize.cpp"
    var $cmp=((($10))|0)==0; //@line 260 "synthesize.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 260 "synthesize.cpp"
    if (__label__ == 1) {
  
      $retval=0; //@line 261 "synthesize.cpp"
      ; //@line 261 "synthesize.cpp"
    }
    else if (__label__ == 2) {
  
      var $11=HEAP32[((((_speed+24)&4294967295))>>2)]; //@line 263 "synthesize.cpp"
      $min_length=$11; //@line 263 "synthesize.cpp"
      var $12=$wav_scale; //@line 265 "synthesize.cpp"
      var $cmp6=((($12))|0)==0; //@line 265 "synthesize.cpp"
      if ($cmp6) { __label__ = 3;; } else { __label__ = 4;; } //@line 265 "synthesize.cpp"
      if (__label__ == 3) {
  
        var $13=$min_length; //@line 266 "synthesize.cpp"
        var $mul8=((($13)*2)&4294967295); //@line 266 "synthesize.cpp"
        $min_length=$mul8; //@line 266 "synthesize.cpp"
        ; //@line 266 "synthesize.cpp"
      }
  
      var $14=$std_length_addr; //@line 275 "synthesize.cpp"
      var $cmp10=((($14))|0) > 0; //@line 275 "synthesize.cpp"
      if ($cmp10) { __label__ = 5;; } else { __label__ = 9;; } //@line 275 "synthesize.cpp"
      $if_then11$$if_else22$8: do { 
        if (__label__ == 5) {
  
          var $15=$std_length_addr; //@line 277 "synthesize.cpp"
          var $16=HEAP32[((_samplerate)>>2)]; //@line 277 "synthesize.cpp"
          var $mul12=((($16)*($15))&4294967295); //@line 277 "synthesize.cpp"
          var $div=((((($mul12))|0)/1000)|0); //@line 277 "synthesize.cpp"
          $std_length_addr=$div; //@line 277 "synthesize.cpp"
          var $17=$wav_scale; //@line 278 "synthesize.cpp"
          var $cmp13=((($17))|0)==0; //@line 278 "synthesize.cpp"
          if ($cmp13) { __label__ = 6;; } else { __label__ = 7;; } //@line 278 "synthesize.cpp"
          if (__label__ == 6) {
  
            var $18=$std_length_addr; //@line 279 "synthesize.cpp"
            var $mul15=((($18)*2)&4294967295); //@line 279 "synthesize.cpp"
            $std_length_addr=$mul15; //@line 279 "synthesize.cpp"
            ; //@line 279 "synthesize.cpp"
          }
  
          var $19=$min_length; //@line 281 "synthesize.cpp"
          var $20=$std_length_addr; //@line 281 "synthesize.cpp"
          var $mul17=((($20)*($19))&4294967295); //@line 281 "synthesize.cpp"
          var $21=$wav_length; //@line 281 "synthesize.cpp"
          var $div18=((((($mul17))|0)/((($21))|0))|0); //@line 281 "synthesize.cpp"
          $x=$div18; //@line 281 "synthesize.cpp"
          var $22=$x; //@line 282 "synthesize.cpp"
          var $23=$min_length; //@line 282 "synthesize.cpp"
          var $cmp19=((($22))|0) > ((($23))|0); //@line 282 "synthesize.cpp"
          if (!($cmp19)) { __label__ = 10;break $if_then11$$if_else22$8; } //@line 282 "synthesize.cpp"
  
          var $24=$x; //@line 283 "synthesize.cpp"
          $min_length=$24; //@line 283 "synthesize.cpp"
          ; //@line 283 "synthesize.cpp"
        }
        else if (__label__ == 9) {
  
          var $25=$wav_length; //@line 288 "synthesize.cpp"
          $std_length_addr=$25; //@line 288 "synthesize.cpp"
          ;
        }
      } while(0);
  
      var $26=$length_mod_addr; //@line 291 "synthesize.cpp"
      var $cmp24=((($26))|0) > 0; //@line 291 "synthesize.cpp"
      if ($cmp24) { __label__ = 11;; } else { __label__ = 12;; } //@line 291 "synthesize.cpp"
      if (__label__ == 11) {
  
        var $27=$std_length_addr; //@line 293 "synthesize.cpp"
        var $28=$length_mod_addr; //@line 293 "synthesize.cpp"
        var $mul26=((($28)*($27))&4294967295); //@line 293 "synthesize.cpp"
        var $div27=((((($mul26))|0)/256)|0); //@line 293 "synthesize.cpp"
        $std_length_addr=$div27; //@line 293 "synthesize.cpp"
        ; //@line 294 "synthesize.cpp"
      }
  
      var $29=$std_length_addr; //@line 296 "synthesize.cpp"
      var $30=HEAP32[((((_speed+12)&4294967295))>>2)]; //@line 296 "synthesize.cpp"
      var $mul29=((($30)*($29))&4294967295); //@line 296 "synthesize.cpp"
      var $div30=((((($mul29))|0)/256)|0); //@line 296 "synthesize.cpp"
      $length=$div30; //@line 296 "synthesize.cpp"
      var $31=$control_addr; //@line 298 "synthesize.cpp"
      var $and31=($31) & 4; //@line 298 "synthesize.cpp"
      var $tobool=((($and31))|0)!=0; //@line 298 "synthesize.cpp"
      if ($tobool) { __label__ = 13;; } else { __label__ = 15;; } //@line 298 "synthesize.cpp"
      $if_then32$$if_end37$19: do { 
        if (__label__ == 13) {
  
          var $32=$length; //@line 302 "synthesize.cpp"
          var $33=$std_length_addr; //@line 302 "synthesize.cpp"
          var $cmp33=((($32))|0) > ((($33))|0); //@line 302 "synthesize.cpp"
          if (!($cmp33)) { __label__ = 15;break $if_then32$$if_end37$19; } //@line 302 "synthesize.cpp"
  
          var $34=$std_length_addr; //@line 305 "synthesize.cpp"
          $length=$34; //@line 305 "synthesize.cpp"
          ; //@line 306 "synthesize.cpp"
        }
      } while(0);
  
      var $35=$length; //@line 314 "synthesize.cpp"
      var $36=$min_length; //@line 314 "synthesize.cpp"
      var $cmp38=((($35))|0) < ((($36))|0); //@line 314 "synthesize.cpp"
      if ($cmp38) { __label__ = 16;; } else { __label__ = 17;; } //@line 314 "synthesize.cpp"
      if (__label__ == 16) {
  
        var $37=$min_length; //@line 315 "synthesize.cpp"
        $length=$37; //@line 315 "synthesize.cpp"
        ; //@line 315 "synthesize.cpp"
      }
  
      var $38=$wav_scale; //@line 318 "synthesize.cpp"
      var $cmp41=((($38))|0)==0; //@line 318 "synthesize.cpp"
      if ($cmp41) { __label__ = 18;; } else { __label__ = 19;; } //@line 318 "synthesize.cpp"
      if (__label__ == 18) {
  
        var $39=$length; //@line 321 "synthesize.cpp"
        var $div43=((((($39))|0)/2)|0); //@line 321 "synthesize.cpp"
        $length=$div43; //@line 321 "synthesize.cpp"
        var $40=$wav_length; //@line 322 "synthesize.cpp"
        var $div44=((((($40))|0)/2)|0); //@line 322 "synthesize.cpp"
        $wav_length=$div44; //@line 322 "synthesize.cpp"
        ; //@line 323 "synthesize.cpp"
      }
  
      var $41=$amp_addr; //@line 325 "synthesize.cpp"
      var $cmp46=((($41))|0) < 0; //@line 325 "synthesize.cpp"
      if ($cmp46) { __label__ = 20;; } else { __label__ = 21;; } //@line 325 "synthesize.cpp"
      if (__label__ == 20) {
  
        var $42=$length; //@line 326 "synthesize.cpp"
        $retval=$42; //@line 326 "synthesize.cpp"
        ; //@line 326 "synthesize.cpp"
      }
      else if (__label__ == 21) {
  
        var $43=$wav_length; //@line 328 "synthesize.cpp"
        var $div49=((((($43))|0)/4)|0); //@line 328 "synthesize.cpp"
        $len4=$div49; //@line 328 "synthesize.cpp"
        var $44=$index_addr; //@line 330 "synthesize.cpp"
        var $add50=((($44)+4)&4294967295); //@line 330 "synthesize.cpp"
        $index_addr=$add50; //@line 330 "synthesize.cpp"
        var $45=$which_addr; //@line 332 "synthesize.cpp"
        var $and51=($45) & 256; //@line 332 "synthesize.cpp"
        var $tobool52=((($and51))|0)!=0; //@line 332 "synthesize.cpp"
        if ($tobool52) { __label__ = 22;; } else { __label__ = 23;; } //@line 332 "synthesize.cpp"
        if (__label__ == 22) {
  
          var $46=HEAP32[((_wcmdq_tail)>>2)]; //@line 335 "synthesize.cpp"
          HEAP32[((__ZL10last_wcmdq)>>2)]=$46; //@line 335 "synthesize.cpp"
          var $47=HEAP32[((_wcmdq_tail)>>2)]; //@line 336 "synthesize.cpp"
          var $arrayidx54=((_wcmdq+$47*16)&4294967295); //@line 336 "synthesize.cpp"
          var $arraydecay=(($arrayidx54)&4294967295); //@line 336 "synthesize.cpp"
          $q=$arraydecay; //@line 336 "synthesize.cpp"
          var $48=$q; //@line 337 "synthesize.cpp"
          var $arrayidx55=(($48)&4294967295); //@line 337 "synthesize.cpp"
          HEAP32[(($arrayidx55)>>2)]=7; //@line 337 "synthesize.cpp"
          var $49=$length; //@line 338 "synthesize.cpp"
          var $50=$wav_length; //@line 338 "synthesize.cpp"
          var $shl=($50) << 16; //@line 338 "synthesize.cpp"
          var $or=($shl) | ($49); //@line 338 "synthesize.cpp"
          var $51=$q; //@line 338 "synthesize.cpp"
          var $arrayidx56=(($51+4)&4294967295); //@line 338 "synthesize.cpp"
          HEAP32[(($arrayidx56)>>2)]=$or; //@line 338 "synthesize.cpp"
          var $52=$index_addr; //@line 339 "synthesize.cpp"
          var $53=HEAP32[((_wavefile_data)>>2)]; //@line 339 "synthesize.cpp"
          var $arrayidx57=(($53+$52)&4294967295); //@line 339 "synthesize.cpp"
          var $54=($arrayidx57); //@line 339 "synthesize.cpp"
          var $55=$q; //@line 339 "synthesize.cpp"
          var $arrayidx58=(($55+8)&4294967295); //@line 339 "synthesize.cpp"
          HEAP32[(($arrayidx58)>>2)]=$54; //@line 339 "synthesize.cpp"
          var $56=$wav_scale; //@line 340 "synthesize.cpp"
          var $57=$amp_addr; //@line 340 "synthesize.cpp"
          var $shl59=((($57)*256)&4294967295); //@line 340 "synthesize.cpp"
          var $add60=((($shl59)+($56))&4294967295); //@line 340 "synthesize.cpp"
          var $58=$q; //@line 340 "synthesize.cpp"
          var $arrayidx61=(($58+12)&4294967295); //@line 340 "synthesize.cpp"
          HEAP32[(($arrayidx61)>>2)]=$add60; //@line 340 "synthesize.cpp"
          __Z8WcmdqIncv(); //@line 341 "synthesize.cpp"
          var $59=$length; //@line 342 "synthesize.cpp"
          $retval=$59; //@line 342 "synthesize.cpp"
          ; //@line 342 "synthesize.cpp"
        }
        else if (__label__ == 23) {
  
          var $60=$length; //@line 345 "synthesize.cpp"
          var $61=$wav_length; //@line 345 "synthesize.cpp"
          var $cmp63=((($60))|0) > ((($61))|0); //@line 345 "synthesize.cpp"
          if ($cmp63) { __label__ = 24;; } else { __label__ = 25;; } //@line 345 "synthesize.cpp"
          if (__label__ == 24) {
  
            var $62=$len4; //@line 347 "synthesize.cpp"
            var $mul65=((($62)*3)&4294967295); //@line 347 "synthesize.cpp"
            $x=$mul65; //@line 347 "synthesize.cpp"
            var $63=$x; //@line 348 "synthesize.cpp"
            var $64=$length; //@line 348 "synthesize.cpp"
            var $sub=((($64)-($63))&4294967295); //@line 348 "synthesize.cpp"
            $length=$sub; //@line 348 "synthesize.cpp"
            ; //@line 349 "synthesize.cpp"
          }
          else if (__label__ == 25) {
  
            var $65=$length; //@line 352 "synthesize.cpp"
            $x=$65; //@line 352 "synthesize.cpp"
            $length=0; //@line 353 "synthesize.cpp"
            ;
          }
  
          var $66=HEAP32[((_wcmdq_tail)>>2)]; //@line 356 "synthesize.cpp"
          HEAP32[((__ZL10last_wcmdq)>>2)]=$66; //@line 356 "synthesize.cpp"
          var $67=HEAP32[((_wcmdq_tail)>>2)]; //@line 357 "synthesize.cpp"
          var $arrayidx68=((_wcmdq+$67*16)&4294967295); //@line 357 "synthesize.cpp"
          var $arraydecay69=(($arrayidx68)&4294967295); //@line 357 "synthesize.cpp"
          $q=$arraydecay69; //@line 357 "synthesize.cpp"
          var $68=$q; //@line 358 "synthesize.cpp"
          var $arrayidx70=(($68)&4294967295); //@line 358 "synthesize.cpp"
          HEAP32[(($arrayidx70)>>2)]=6; //@line 358 "synthesize.cpp"
          var $69=$x; //@line 359 "synthesize.cpp"
          var $70=$q; //@line 359 "synthesize.cpp"
          var $arrayidx71=(($70+4)&4294967295); //@line 359 "synthesize.cpp"
          HEAP32[(($arrayidx71)>>2)]=$69; //@line 359 "synthesize.cpp"
          var $71=$index_addr; //@line 360 "synthesize.cpp"
          var $72=HEAP32[((_wavefile_data)>>2)]; //@line 360 "synthesize.cpp"
          var $arrayidx72=(($72+$71)&4294967295); //@line 360 "synthesize.cpp"
          var $73=($arrayidx72); //@line 360 "synthesize.cpp"
          var $74=$q; //@line 360 "synthesize.cpp"
          var $arrayidx73=(($74+8)&4294967295); //@line 360 "synthesize.cpp"
          HEAP32[(($arrayidx73)>>2)]=$73; //@line 360 "synthesize.cpp"
          var $75=$wav_scale; //@line 361 "synthesize.cpp"
          var $76=$amp_addr; //@line 361 "synthesize.cpp"
          var $shl74=((($76)*256)&4294967295); //@line 361 "synthesize.cpp"
          var $add75=((($shl74)+($75))&4294967295); //@line 361 "synthesize.cpp"
          var $77=$q; //@line 361 "synthesize.cpp"
          var $arrayidx76=(($77+12)&4294967295); //@line 361 "synthesize.cpp"
          HEAP32[(($arrayidx76)>>2)]=$add75; //@line 361 "synthesize.cpp"
          __Z8WcmdqIncv(); //@line 362 "synthesize.cpp"
          var $78=$length; //@line 365 "synthesize.cpp"
          var $79=$len4; //@line 365 "synthesize.cpp"
          var $mul771=((($79)*3)&4294967295); //@line 365 "synthesize.cpp"
          var $cmp782=((($78))|0) > ((($mul771))|0); //@line 365 "synthesize.cpp"
          if ($cmp782) { __lastLabel__ = 26; __label__ = 27;; } else { __lastLabel__ = 26; __label__ = 30;; } //@line 365 "synthesize.cpp"
          $while_body$$while_end$39: do { 
            if (__label__ == 27) {
              while(1) { 
  
                var $80=$len4; //@line 367 "synthesize.cpp"
                $x=$80; //@line 367 "synthesize.cpp"
                var $81=$wav_scale; //@line 368 "synthesize.cpp"
                var $cmp79=((($81))|0)==0; //@line 368 "synthesize.cpp"
                if ($cmp79) { __label__ = 28;; } else { __label__ = 29;; } //@line 368 "synthesize.cpp"
                if (__label__ == 28) {
  
                  var $82=$x; //@line 369 "synthesize.cpp"
                  var $mul81=((($82)*2)&4294967295); //@line 369 "synthesize.cpp"
                  $x=$mul81; //@line 369 "synthesize.cpp"
                  ; //@line 369 "synthesize.cpp"
                }
  
                var $83=HEAP32[((_wcmdq_tail)>>2)]; //@line 371 "synthesize.cpp"
                HEAP32[((__ZL10last_wcmdq)>>2)]=$83; //@line 371 "synthesize.cpp"
                var $84=HEAP32[((_wcmdq_tail)>>2)]; //@line 372 "synthesize.cpp"
                var $arrayidx83=((_wcmdq+$84*16)&4294967295); //@line 372 "synthesize.cpp"
                var $arraydecay84=(($arrayidx83)&4294967295); //@line 372 "synthesize.cpp"
                $q=$arraydecay84; //@line 372 "synthesize.cpp"
                var $85=$q; //@line 373 "synthesize.cpp"
                var $arrayidx85=(($85)&4294967295); //@line 373 "synthesize.cpp"
                HEAP32[(($arrayidx85)>>2)]=6; //@line 373 "synthesize.cpp"
                var $86=$len4; //@line 374 "synthesize.cpp"
                var $mul86=((($86)*2)&4294967295); //@line 374 "synthesize.cpp"
                var $87=$q; //@line 374 "synthesize.cpp"
                var $arrayidx87=(($87+4)&4294967295); //@line 374 "synthesize.cpp"
                HEAP32[(($arrayidx87)>>2)]=$mul86; //@line 374 "synthesize.cpp"
                var $88=$index_addr; //@line 375 "synthesize.cpp"
                var $89=$x; //@line 375 "synthesize.cpp"
                var $add88=((($89)+($88))&4294967295); //@line 375 "synthesize.cpp"
                var $90=HEAP32[((_wavefile_data)>>2)]; //@line 375 "synthesize.cpp"
                var $arrayidx89=(($90+$add88)&4294967295); //@line 375 "synthesize.cpp"
                var $91=($arrayidx89); //@line 375 "synthesize.cpp"
                var $92=$q; //@line 375 "synthesize.cpp"
                var $arrayidx90=(($92+8)&4294967295); //@line 375 "synthesize.cpp"
                HEAP32[(($arrayidx90)>>2)]=$91; //@line 375 "synthesize.cpp"
                var $93=$wav_scale; //@line 376 "synthesize.cpp"
                var $94=$amp_addr; //@line 376 "synthesize.cpp"
                var $shl91=((($94)*256)&4294967295); //@line 376 "synthesize.cpp"
                var $add92=((($shl91)+($93))&4294967295); //@line 376 "synthesize.cpp"
                var $95=$q; //@line 376 "synthesize.cpp"
                var $arrayidx93=(($95+12)&4294967295); //@line 376 "synthesize.cpp"
                HEAP32[(($arrayidx93)>>2)]=$add92; //@line 376 "synthesize.cpp"
                __Z8WcmdqIncv(); //@line 377 "synthesize.cpp"
                var $96=$len4; //@line 379 "synthesize.cpp"
                var $mul94=((($96)*2)&4294967295); //@line 379 "synthesize.cpp"
                var $97=$length; //@line 379 "synthesize.cpp"
                var $sub95=((($97)-($mul94))&4294967295); //@line 379 "synthesize.cpp"
                $length=$sub95; //@line 379 "synthesize.cpp"
                var $98=$length; //@line 365 "synthesize.cpp"
                var $99=$len4; //@line 365 "synthesize.cpp"
                var $mul77=((($99)*3)&4294967295); //@line 365 "synthesize.cpp"
                var $cmp78=((($98))|0) > ((($mul77))|0); //@line 365 "synthesize.cpp"
                if ($cmp78) { __lastLabel__ = 29; __label__ = 27;continue ; } else { __lastLabel__ = 29; __label__ = 30;break $while_body$$while_end$39; } //@line 365 "synthesize.cpp"
              }
            }
          } while(0);
  
          var $100=__lastLabel__ == 29 ? $98 : ($78); //@line 382 "synthesize.cpp"
          var $cmp96=((($100))|0) > 0; //@line 382 "synthesize.cpp"
          if ($cmp96) { __label__ = 31;; } else { __label__ = 34;; } //@line 382 "synthesize.cpp"
          if (__label__ == 31) {
  
            var $101=$wav_length; //@line 384 "synthesize.cpp"
            var $102=$length; //@line 384 "synthesize.cpp"
            var $sub98=((($101)-($102))&4294967295); //@line 384 "synthesize.cpp"
            $x=$sub98; //@line 384 "synthesize.cpp"
            var $103=$wav_scale; //@line 385 "synthesize.cpp"
            var $cmp99=((($103))|0)==0; //@line 385 "synthesize.cpp"
            if ($cmp99) { __label__ = 32;; } else { __label__ = 33;; } //@line 385 "synthesize.cpp"
            if (__label__ == 32) {
  
              var $104=$x; //@line 386 "synthesize.cpp"
              var $mul101=((($104)*2)&4294967295); //@line 386 "synthesize.cpp"
              $x=$mul101; //@line 386 "synthesize.cpp"
              ; //@line 386 "synthesize.cpp"
            }
  
            var $105=HEAP32[((_wcmdq_tail)>>2)]; //@line 387 "synthesize.cpp"
            HEAP32[((__ZL10last_wcmdq)>>2)]=$105; //@line 387 "synthesize.cpp"
            var $106=HEAP32[((_wcmdq_tail)>>2)]; //@line 388 "synthesize.cpp"
            var $arrayidx103=((_wcmdq+$106*16)&4294967295); //@line 388 "synthesize.cpp"
            var $arraydecay104=(($arrayidx103)&4294967295); //@line 388 "synthesize.cpp"
            $q=$arraydecay104; //@line 388 "synthesize.cpp"
            var $107=$q; //@line 389 "synthesize.cpp"
            var $arrayidx105=(($107)&4294967295); //@line 389 "synthesize.cpp"
            HEAP32[(($arrayidx105)>>2)]=6; //@line 389 "synthesize.cpp"
            var $108=$length; //@line 390 "synthesize.cpp"
            var $109=$q; //@line 390 "synthesize.cpp"
            var $arrayidx106=(($109+4)&4294967295); //@line 390 "synthesize.cpp"
            HEAP32[(($arrayidx106)>>2)]=$108; //@line 390 "synthesize.cpp"
            var $110=$index_addr; //@line 391 "synthesize.cpp"
            var $111=$x; //@line 391 "synthesize.cpp"
            var $add107=((($111)+($110))&4294967295); //@line 391 "synthesize.cpp"
            var $112=HEAP32[((_wavefile_data)>>2)]; //@line 391 "synthesize.cpp"
            var $arrayidx108=(($112+$add107)&4294967295); //@line 391 "synthesize.cpp"
            var $113=($arrayidx108); //@line 391 "synthesize.cpp"
            var $114=$q; //@line 391 "synthesize.cpp"
            var $arrayidx109=(($114+8)&4294967295); //@line 391 "synthesize.cpp"
            HEAP32[(($arrayidx109)>>2)]=$113; //@line 391 "synthesize.cpp"
            var $115=$wav_scale; //@line 392 "synthesize.cpp"
            var $116=$amp_addr; //@line 392 "synthesize.cpp"
            var $shl110=((($116)*256)&4294967295); //@line 392 "synthesize.cpp"
            var $add111=((($shl110)+($115))&4294967295); //@line 392 "synthesize.cpp"
            var $117=$q; //@line 392 "synthesize.cpp"
            var $arrayidx112=(($117+12)&4294967295); //@line 392 "synthesize.cpp"
            HEAP32[(($arrayidx112)>>2)]=$add111; //@line 392 "synthesize.cpp"
            __Z8WcmdqIncv(); //@line 393 "synthesize.cpp"
            ; //@line 394 "synthesize.cpp"
          }
  
          var $118=$length; //@line 396 "synthesize.cpp"
          $retval=$118; //@line 396 "synthesize.cpp"
          ; //@line 396 "synthesize.cpp"
        }
      }
    }
  
    var $119=$retval; //@line 397 "synthesize.cpp"
    ;
    return $119; //@line 397 "synthesize.cpp"
    return null;
  }
  

  function __Z18FormantTransition2P10frameref_tRijjP11PHONEME_TABi($seq, $n_frames, $data1, $data2, $other_ph, $which) {
    ;
    var __label__;
  
    var $retval;
    var $seq_addr;
    var $n_frames_addr;
    var $data1_addr;
    var $data2_addr;
    var $other_ph_addr;
    var $which_addr;
    var $ix;
    var $formant;
    var $next_rms;
    var $len;
    var $rms;
    var $f1;
    var $f2;
    var $f2_min;
    var $f2_max;
    var $f3_adj;
    var $f3_amp;
    var $flags;
    var $vcolour;
    var $fr;
    var $x;
    $seq_addr=$seq;
    $n_frames_addr=$n_frames;
    $data1_addr=$data1;
    $data2_addr=$data2;
    $other_ph_addr=$other_ph;
    $which_addr=$which;
    $fr=0; //@line 640 "synthesize.cpp"
    var $0=$n_frames_addr; //@line 642 "synthesize.cpp"
    var $1=HEAP32[(($0)>>2)]; //@line 642 "synthesize.cpp"
    var $cmp=((($1))|0) < 2; //@line 642 "synthesize.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 642 "synthesize.cpp"
    if (__label__ == 1) {
  
      $retval=0; //@line 643 "synthesize.cpp"
      ; //@line 643 "synthesize.cpp"
    }
    else if (__label__ == 2) {
  
      var $2=$data1_addr; //@line 645 "synthesize.cpp"
      var $and=($2) & 63; //@line 645 "synthesize.cpp"
      var $mul=((($and)*2)&4294967295); //@line 645 "synthesize.cpp"
      $len=$mul; //@line 645 "synthesize.cpp"
      var $3=$data1_addr; //@line 646 "synthesize.cpp"
      var $shr=($3) >>> 6; //@line 646 "synthesize.cpp"
      var $and1=($shr) & 63; //@line 646 "synthesize.cpp"
      $rms=$and1; //@line 646 "synthesize.cpp"
      var $4=$data1_addr; //@line 647 "synthesize.cpp"
      var $shr2=($4) >>> 12; //@line 647 "synthesize.cpp"
      $flags=$shr2; //@line 647 "synthesize.cpp"
      var $5=$data2_addr; //@line 649 "synthesize.cpp"
      var $and3=($5) & 63; //@line 649 "synthesize.cpp"
      var $mul4=((($and3)*50)&4294967295); //@line 649 "synthesize.cpp"
      $f2=$mul4; //@line 649 "synthesize.cpp"
      var $6=$data2_addr; //@line 650 "synthesize.cpp"
      var $shr5=($6) >>> 6; //@line 650 "synthesize.cpp"
      var $and6=($shr5) & 31; //@line 650 "synthesize.cpp"
      var $sub=((($and6)-15)&4294967295); //@line 650 "synthesize.cpp"
      var $mul7=((($sub)*50)&4294967295); //@line 650 "synthesize.cpp"
      $f2_min=$mul7; //@line 650 "synthesize.cpp"
      var $7=$data2_addr; //@line 651 "synthesize.cpp"
      var $shr8=($7) >>> 11; //@line 651 "synthesize.cpp"
      var $and9=($shr8) & 31; //@line 651 "synthesize.cpp"
      var $sub10=((($and9)-15)&4294967295); //@line 651 "synthesize.cpp"
      var $mul11=((($sub10)*50)&4294967295); //@line 651 "synthesize.cpp"
      $f2_max=$mul11; //@line 651 "synthesize.cpp"
      var $8=$data2_addr; //@line 652 "synthesize.cpp"
      var $shr12=($8) >>> 16; //@line 652 "synthesize.cpp"
      var $and13=($shr12) & 31; //@line 652 "synthesize.cpp"
      var $sub14=((($and13)-15)&4294967295); //@line 652 "synthesize.cpp"
      var $mul15=((($sub14)*50)&4294967295); //@line 652 "synthesize.cpp"
      $f3_adj=$mul15; //@line 652 "synthesize.cpp"
      var $9=$data2_addr; //@line 653 "synthesize.cpp"
      var $shr16=($9) >>> 21; //@line 653 "synthesize.cpp"
      var $and17=($shr16) & 31; //@line 653 "synthesize.cpp"
      var $mul18=((($and17)*8)&4294967295); //@line 653 "synthesize.cpp"
      $f3_amp=$mul18; //@line 653 "synthesize.cpp"
      var $10=$data2_addr; //@line 654 "synthesize.cpp"
      var $shr19=($10) >>> 26; //@line 654 "synthesize.cpp"
      var $and20=($shr19) & 7; //@line 654 "synthesize.cpp"
      $f1=$and20; //@line 654 "synthesize.cpp"
      var $11=$data2_addr; //@line 655 "synthesize.cpp"
      var $shr21=($11) >>> 29; //@line 655 "synthesize.cpp"
      $vcolour=$shr21; //@line 655 "synthesize.cpp"
      var $12=$other_ph_addr; //@line 660 "synthesize.cpp"
      var $cmp22=((($12))|0)!=0; //@line 660 "synthesize.cpp"
      if ($cmp22) { __label__ = 3;; } else { __label__ = 5;; } //@line 660 "synthesize.cpp"
      $land_lhs_true$$if_end25$5: do { 
        if (__label__ == 3) {
  
          var $13=$other_ph_addr; //@line 660 "synthesize.cpp"
          var $mnemonic=(($13)&4294967295); //@line 660 "synthesize.cpp"
          var $14=HEAP32[(($mnemonic)>>2)]; //@line 660 "synthesize.cpp"
          var $cmp23=((($14))|0)==63; //@line 660 "synthesize.cpp"
          if (!($cmp23)) { __label__ = 5;break $land_lhs_true$$if_end25$5; } //@line 660 "synthesize.cpp"
  
          var $15=$flags; //@line 661 "synthesize.cpp"
          var $or=($15) | 8; //@line 661 "synthesize.cpp"
          $flags=$or; //@line 661 "synthesize.cpp"
          ; //@line 661 "synthesize.cpp"
        }
      } while(0);
  
      var $16=$which_addr; //@line 663 "synthesize.cpp"
      var $cmp26=((($16))|0)==1; //@line 663 "synthesize.cpp"
      if ($cmp26) { __label__ = 6;; } else { __label__ = 20;; } //@line 663 "synthesize.cpp"
      $if_then27$$if_else85$9: do { 
        if (__label__ == 6) {
  
          var $17=$seq_addr; //@line 666 "synthesize.cpp"
          var $arrayidx=(($17)&4294967295); //@line 666 "synthesize.cpp"
          var $frame=(($arrayidx+4)&4294967295); //@line 666 "synthesize.cpp"
          var $18=HEAP32[(($frame)>>2)]; //@line 666 "synthesize.cpp"
          var $call=__ZL9CopyFrameP7frame_ti($18, 0); //@line 666 "synthesize.cpp"
          $fr=$call; //@line 666 "synthesize.cpp"
          var $19=$fr; //@line 667 "synthesize.cpp"
          var $20=$seq_addr; //@line 667 "synthesize.cpp"
          var $arrayidx28=(($20)&4294967295); //@line 667 "synthesize.cpp"
          var $frame29=(($arrayidx28+4)&4294967295); //@line 667 "synthesize.cpp"
          HEAP32[(($frame29)>>2)]=$19; //@line 667 "synthesize.cpp"
          var $21=$seq_addr; //@line 668 "synthesize.cpp"
          var $arrayidx30=(($21)&4294967295); //@line 668 "synthesize.cpp"
          var $length=(($arrayidx30)&4294967295); //@line 668 "synthesize.cpp"
          HEAP16[(($length)>>1)]=50; //@line 668 "synthesize.cpp"
          var $22=$len; //@line 669 "synthesize.cpp"
          var $cmp31=((($22))|0) > 0; //@line 669 "synthesize.cpp"
          if ($cmp31) { __label__ = 7;; } else { __label__ = 8;; } //@line 669 "synthesize.cpp"
          if (__label__ == 7) {
  
            var $23=$len; //@line 670 "synthesize.cpp"
            var $conv=((($23)) & 65535); //@line 670 "synthesize.cpp"
            var $24=$seq_addr; //@line 670 "synthesize.cpp"
            var $arrayidx33=(($24)&4294967295); //@line 670 "synthesize.cpp"
            var $length34=(($arrayidx33)&4294967295); //@line 670 "synthesize.cpp"
            HEAP16[(($length34)>>1)]=$conv; //@line 670 "synthesize.cpp"
            ; //@line 670 "synthesize.cpp"
          }
  
          var $25=$seq_addr; //@line 671 "synthesize.cpp"
          var $arrayidx36=(($25)&4294967295); //@line 671 "synthesize.cpp"
          var $frflags=(($arrayidx36+2)&4294967295); //@line 671 "synthesize.cpp"
          var $26=HEAP16[(($frflags)>>1)]; //@line 671 "synthesize.cpp"
          var $conv37=(tempInt=(($26)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 671 "synthesize.cpp"
          var $or38=($conv37) | 16384; //@line 671 "synthesize.cpp"
          var $conv39=((($or38)) & 65535); //@line 671 "synthesize.cpp"
          HEAP16[(($frflags)>>1)]=$conv39; //@line 671 "synthesize.cpp"
          var $27=$fr; //@line 672 "synthesize.cpp"
          var $frflags40=(($27)&4294967295); //@line 672 "synthesize.cpp"
          var $28=HEAP16[(($frflags40)>>1)]; //@line 672 "synthesize.cpp"
          var $conv41=(tempInt=(($28)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 672 "synthesize.cpp"
          var $or42=($conv41) | 16384; //@line 672 "synthesize.cpp"
          var $conv43=((($or42)) & 65535); //@line 672 "synthesize.cpp"
          HEAP16[(($frflags40)>>1)]=$conv43; //@line 672 "synthesize.cpp"
          var $29=$seq_addr; //@line 674 "synthesize.cpp"
          var $arrayidx44=(($29+8)&4294967295); //@line 674 "synthesize.cpp"
          var $frame45=(($arrayidx44+4)&4294967295); //@line 674 "synthesize.cpp"
          var $30=HEAP32[(($frame45)>>2)]; //@line 674 "synthesize.cpp"
          var $rms46=(($30+17)&4294967295); //@line 674 "synthesize.cpp"
          var $31=HEAPU8[($rms46)]; //@line 674 "synthesize.cpp"
          var $conv47=((($31))&255); //@line 674 "synthesize.cpp"
          $next_rms=$conv47; //@line 674 "synthesize.cpp"
          var $32=HEAP32[((_voice)>>2)]; //@line 676 "synthesize.cpp"
          var $klattv=(($32+112)&4294967295); //@line 676 "synthesize.cpp"
          var $arrayidx48=(($klattv)&4294967295); //@line 676 "synthesize.cpp"
          var $33=HEAP32[(($arrayidx48)>>2)]; //@line 676 "synthesize.cpp"
          var $tobool=((($33))|0)!=0; //@line 676 "synthesize.cpp"
          if ($tobool) { __label__ = 9;; } else { __label__ = 10;; } //@line 676 "synthesize.cpp"
          if (__label__ == 9) {
  
            var $34=$seq_addr; //@line 679 "synthesize.cpp"
            var $arrayidx50=(($34+8)&4294967295); //@line 679 "synthesize.cpp"
            var $frame51=(($arrayidx50+4)&4294967295); //@line 679 "synthesize.cpp"
            var $35=HEAP32[(($frame51)>>2)]; //@line 679 "synthesize.cpp"
            var $klattp=(($35+39)&4294967295); //@line 679 "synthesize.cpp"
            var $arrayidx52=(($klattp)&4294967295); //@line 679 "synthesize.cpp"
            var $36=HEAPU8[($arrayidx52)]; //@line 679 "synthesize.cpp"
            var $conv53=((($36))&255); //@line 679 "synthesize.cpp"
            var $sub54=((($conv53)-4)&4294967295); //@line 679 "synthesize.cpp"
            var $conv55=((($sub54)) & 255); //@line 679 "synthesize.cpp"
            var $37=$fr; //@line 679 "synthesize.cpp"
            var $klattp56=(($37+39)&4294967295); //@line 679 "synthesize.cpp"
            var $arrayidx57=(($klattp56)&4294967295); //@line 679 "synthesize.cpp"
            HEAP8[($arrayidx57)]=$conv55; //@line 679 "synthesize.cpp"
            ; //@line 680 "synthesize.cpp"
          }
  
          var $38=$f2; //@line 681 "synthesize.cpp"
          var $cmp59=((($38))|0)!=0; //@line 681 "synthesize.cpp"
          if ($cmp59) { __label__ = 11;; } else { __label__ = 15;; } //@line 681 "synthesize.cpp"
          $if_then60$$if_else$17: do { 
            if (__label__ == 11) {
  
              var $39=$rms; //@line 683 "synthesize.cpp"
              var $and61=($39) & 32; //@line 683 "synthesize.cpp"
              var $tobool62=((($and61))|0)!=0; //@line 683 "synthesize.cpp"
              if ($tobool62) { __label__ = 12;; } else { __label__ = 13;; } //@line 683 "synthesize.cpp"
              if (__label__ == 12) {
  
                var $40=$fr; //@line 685 "synthesize.cpp"
                var $41=$next_rms; //@line 685 "synthesize.cpp"
                var $42=$rms; //@line 685 "synthesize.cpp"
                var $and64=($42) & 31; //@line 685 "synthesize.cpp"
                var $mul65=((($and64)*($41))&4294967295); //@line 685 "synthesize.cpp"
                var $div=((((($mul65))|0)/30)|0); //@line 685 "synthesize.cpp"
                __ZL13set_frame_rmsP7frame_ti($40, $div); //@line 685 "synthesize.cpp"
                ; //@line 686 "synthesize.cpp"
              }
  
              var $43=$fr; //@line 687 "synthesize.cpp"
              var $44=$f2; //@line 687 "synthesize.cpp"
              var $45=$f2_min; //@line 687 "synthesize.cpp"
              var $46=$f2_max; //@line 687 "synthesize.cpp"
              var $47=$f1; //@line 687 "synthesize.cpp"
              var $48=$f3_adj; //@line 687 "synthesize.cpp"
              var $49=$f3_amp; //@line 687 "synthesize.cpp"
              var $50=$flags; //@line 687 "synthesize.cpp"
              __ZL14AdjustFormantsP7frame_tiiiiiii($43, $44, $45, $46, $47, $48, $49, $50); //@line 687 "synthesize.cpp"
              var $51=$rms; //@line 689 "synthesize.cpp"
              var $and67=($51) & 32; //@line 689 "synthesize.cpp"
              var $cmp68=((($and67))|0)==0; //@line 689 "synthesize.cpp"
              if (!($cmp68)) { __label__ = 18;break $if_then60$$if_else$17; } //@line 689 "synthesize.cpp"
  
              var $52=$fr; //@line 691 "synthesize.cpp"
              var $53=$rms; //@line 691 "synthesize.cpp"
              var $mul70=((($53)*2)&4294967295); //@line 691 "synthesize.cpp"
              __ZL13set_frame_rmsP7frame_ti($52, $mul70); //@line 691 "synthesize.cpp"
              ; //@line 692 "synthesize.cpp"
            }
            else if (__label__ == 15) {
  
              var $54=$flags; //@line 696 "synthesize.cpp"
              var $and72=($54) & 8; //@line 696 "synthesize.cpp"
              var $tobool73=((($and72))|0)!=0; //@line 696 "synthesize.cpp"
              var $55=$fr; //@line 697 "synthesize.cpp"
              if ($tobool73) { __label__ = 16;; } else { __label__ = 17;; } //@line 696 "synthesize.cpp"
              if (__label__ == 16) {
  
                var $56=$next_rms; //@line 697 "synthesize.cpp"
                var $mul75=((($56)*24)&4294967295); //@line 697 "synthesize.cpp"
                var $div76=((((($mul75))|0)/32)|0); //@line 697 "synthesize.cpp"
                __ZL13set_frame_rmsP7frame_ti($55, $div76); //@line 697 "synthesize.cpp"
                ; //@line 697 "synthesize.cpp"
              }
              else if (__label__ == 17) {
  
                __ZL13set_frame_rmsP7frame_ti($55, 28); //@line 699 "synthesize.cpp"
                ;
              }
            }
          } while(0);
  
          var $57=$flags; //@line 702 "synthesize.cpp"
          var $and80=($57) & 8; //@line 702 "synthesize.cpp"
          var $tobool81=((($and80))|0)!=0; //@line 702 "synthesize.cpp"
          if (!($tobool81)) { __label__ = 33;break $if_then27$$if_else85$9; } //@line 702 "synthesize.cpp"
  
          var $58=$fr; //@line 705 "synthesize.cpp"
          var $call83=__ZL14VowelClosenessP7frame_t($58); //@line 705 "synthesize.cpp"
          var $shl=((($call83)*256)&4294967295); //@line 705 "synthesize.cpp"
          var $add=((($shl)+2048)&4294967295); //@line 705 "synthesize.cpp"
          HEAP32[((__ZL10modn_flags)>>2)]=$add; //@line 705 "synthesize.cpp"
          ; //@line 706 "synthesize.cpp"
        }
        else if (__label__ == 20) {
  
          var $59=$rms; //@line 711 "synthesize.cpp"
          var $mul86=((($59)*2)&4294967295); //@line 711 "synthesize.cpp"
          $rms=$mul86; //@line 711 "synthesize.cpp"
          var $60=$f2; //@line 712 "synthesize.cpp"
          var $cmp87=((($60))|0)!=0; //@line 712 "synthesize.cpp"
          if ($cmp87) { __label__ = 22;; } else { __label__ = 21;; } //@line 712 "synthesize.cpp"
          if (__label__ == 21) {
  
            var $61=$flags; //@line 712 "synthesize.cpp"
            var $cmp88=((($61))|0)!=0; //@line 712 "synthesize.cpp"
            if (!($cmp88)) { __label__ = 33;break $if_then27$$if_else85$9; } //@line 712 "synthesize.cpp"
          }
  
          var $62=$flags; //@line 715 "synthesize.cpp"
          var $and90=($62) & 8; //@line 715 "synthesize.cpp"
          var $tobool91=((($and90))|0)!=0; //@line 715 "synthesize.cpp"
          if ($tobool91) { __label__ = 23;; } else { __label__ = 24;; } //@line 715 "synthesize.cpp"
          $if_then92$$if_else103$33: do { 
            if (__label__ == 23) {
  
              var $63=$n_frames_addr; //@line 717 "synthesize.cpp"
              var $64=HEAP32[(($63)>>2)]; //@line 717 "synthesize.cpp"
              var $sub93=((($64)-1)&4294967295); //@line 717 "synthesize.cpp"
              var $65=$seq_addr; //@line 717 "synthesize.cpp"
              var $arrayidx94=(($65+8*$sub93)&4294967295); //@line 717 "synthesize.cpp"
              var $frame95=(($arrayidx94+4)&4294967295); //@line 717 "synthesize.cpp"
              var $66=HEAP32[(($frame95)>>2)]; //@line 717 "synthesize.cpp"
              var $call96=__ZL9CopyFrameP7frame_ti($66, 0); //@line 717 "synthesize.cpp"
              $fr=$call96; //@line 717 "synthesize.cpp"
              var $67=$fr; //@line 718 "synthesize.cpp"
              var $68=$n_frames_addr; //@line 718 "synthesize.cpp"
              var $69=HEAP32[(($68)>>2)]; //@line 718 "synthesize.cpp"
              var $sub97=((($69)-1)&4294967295); //@line 718 "synthesize.cpp"
              var $70=$seq_addr; //@line 718 "synthesize.cpp"
              var $arrayidx98=(($70+8*$sub97)&4294967295); //@line 718 "synthesize.cpp"
              var $frame99=(($arrayidx98+4)&4294967295); //@line 718 "synthesize.cpp"
              HEAP32[(($frame99)>>2)]=$67; //@line 718 "synthesize.cpp"
              $rms=35; //@line 719 "synthesize.cpp"
              var $71=$fr; //@line 722 "synthesize.cpp"
              var $call100=__ZL14VowelClosenessP7frame_t($71); //@line 722 "synthesize.cpp"
              var $shl101=((($call100)*256)&4294967295); //@line 722 "synthesize.cpp"
              var $add102=((($shl101)+1024)&4294967295); //@line 722 "synthesize.cpp"
              HEAP32[((__ZL10modn_flags)>>2)]=$add102; //@line 722 "synthesize.cpp"
              ; //@line 723 "synthesize.cpp"
            }
            else if (__label__ == 24) {
  
              var $72=$seq_addr; //@line 726 "synthesize.cpp"
              var $73=$n_frames_addr; //@line 726 "synthesize.cpp"
              var $74=HEAP32[(($73)>>2)]; //@line 726 "synthesize.cpp"
              var $inc=((($74)+1)&4294967295); //@line 726 "synthesize.cpp"
              HEAP32[(($73)>>2)]=$inc; //@line 726 "synthesize.cpp"
              var $75=$len; //@line 726 "synthesize.cpp"
              var $call104=__ZL18DuplicateLastFrameP10frameref_tii($72, $74, $75); //@line 726 "synthesize.cpp"
              $fr=$call104; //@line 726 "synthesize.cpp"
              var $76=$len; //@line 727 "synthesize.cpp"
              var $cmp105=((($76))|0) > 36; //@line 727 "synthesize.cpp"
              if ($cmp105) { __label__ = 25;; } else { __label__ = 26;; } //@line 727 "synthesize.cpp"
              if (__label__ == 25) {
  
                var $77=$len; //@line 728 "synthesize.cpp"
                var $78=HEAP32[((_seq_len_adjust)>>2)]; //@line 728 "synthesize.cpp"
                var $sub107=((($77)-36)&4294967295); //@line 728 "synthesize.cpp"
                var $add108=((($sub107)+($78))&4294967295); //@line 728 "synthesize.cpp"
                HEAP32[((_seq_len_adjust)>>2)]=$add108; //@line 728 "synthesize.cpp"
                ; //@line 728 "synthesize.cpp"
              }
  
              var $79=$f2; //@line 730 "synthesize.cpp"
              var $cmp110=((($79))|0)!=0; //@line 730 "synthesize.cpp"
              if (!($cmp110)) { __label__ = 28;break $if_then92$$if_else103$33; } //@line 730 "synthesize.cpp"
  
              var $80=$fr; //@line 732 "synthesize.cpp"
              var $81=$f2; //@line 732 "synthesize.cpp"
              var $82=$f2_min; //@line 732 "synthesize.cpp"
              var $83=$f2_max; //@line 732 "synthesize.cpp"
              var $84=$f1; //@line 732 "synthesize.cpp"
              var $85=$f3_adj; //@line 732 "synthesize.cpp"
              var $86=$f3_amp; //@line 732 "synthesize.cpp"
              var $87=$flags; //@line 732 "synthesize.cpp"
              __ZL14AdjustFormantsP7frame_tiiiiiii($80, $81, $82, $83, $84, $85, $86, $87); //@line 732 "synthesize.cpp"
              ; //@line 733 "synthesize.cpp"
            }
          } while(0);
  
          var $88=$fr; //@line 736 "synthesize.cpp"
          var $89=$rms; //@line 736 "synthesize.cpp"
          __ZL13set_frame_rmsP7frame_ti($88, $89); //@line 736 "synthesize.cpp"
          var $90=$vcolour; //@line 738 "synthesize.cpp"
          var $cmp114=((($90))|0) > 0; //@line 738 "synthesize.cpp"
          var $91=$vcolour; //@line 738 "synthesize.cpp"
          var $cmp116=((($91))|0) <= 2; //@line 738 "synthesize.cpp"
          var $or_cond=($cmp114) & ($cmp116); //@line 738 "synthesize.cpp"
          if (!($or_cond)) { __label__ = 33;break $if_then27$$if_else85$9; } //@line 738 "synthesize.cpp"
  
          $ix=0; //@line 740 "synthesize.cpp"
          var $92=$ix; //@line 740 "synthesize.cpp"
          var $93=$n_frames_addr; //@line 740 "synthesize.cpp"
          var $94=HEAP32[(($93)>>2)]; //@line 740 "synthesize.cpp"
          var $cmp1181=((($92))|0) < ((($94))|0); //@line 740 "synthesize.cpp"
          if (!($cmp1181)) { __label__ = 33;break $if_then27$$if_else85$9; } //@line 740 "synthesize.cpp"
          $for_body$42: while(1) { 
  
            var $95=$ix; //@line 742 "synthesize.cpp"
            var $96=$seq_addr; //@line 742 "synthesize.cpp"
            var $arrayidx119=(($96+8*$95)&4294967295); //@line 742 "synthesize.cpp"
            var $frame120=(($arrayidx119+4)&4294967295); //@line 742 "synthesize.cpp"
            var $97=HEAP32[(($frame120)>>2)]; //@line 742 "synthesize.cpp"
            var $call121=__ZL9CopyFrameP7frame_ti($97, 0); //@line 742 "synthesize.cpp"
            $fr=$call121; //@line 742 "synthesize.cpp"
            var $98=$fr; //@line 743 "synthesize.cpp"
            var $99=$ix; //@line 743 "synthesize.cpp"
            var $100=$seq_addr; //@line 743 "synthesize.cpp"
            var $arrayidx122=(($100+8*$99)&4294967295); //@line 743 "synthesize.cpp"
            var $frame123=(($arrayidx122+4)&4294967295); //@line 743 "synthesize.cpp"
            HEAP32[(($frame123)>>2)]=$98; //@line 743 "synthesize.cpp"
            $formant=1; //@line 745 "synthesize.cpp"
            ; //@line 745 "synthesize.cpp"
            while(1) { 
  
              var $101=$formant; //@line 748 "synthesize.cpp"
              var $102=$fr; //@line 748 "synthesize.cpp"
              var $ffreq=(($102+2)&4294967295); //@line 748 "synthesize.cpp"
              var $arrayidx127=(($ffreq+$101*2)&4294967295); //@line 748 "synthesize.cpp"
              var $103=HEAP16[(($arrayidx127)>>1)]; //@line 748 "synthesize.cpp"
              var $conv128=(tempInt=(($103)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 748 "synthesize.cpp"
              var $104=$formant; //@line 748 "synthesize.cpp"
              var $sub129=((($104)-1)&4294967295); //@line 748 "synthesize.cpp"
              var $105=$vcolour; //@line 748 "synthesize.cpp"
              var $sub130=((($105)-1)&4294967295); //@line 748 "synthesize.cpp"
              var $arrayidx131=((__ZZ18FormantTransition2P10frameref_tRijjP11PHONEME_TABiE10vcolouring+$sub130*10)&4294967295); //@line 748 "synthesize.cpp"
              var $arrayidx132=(($arrayidx131+$sub129*2)&4294967295); //@line 748 "synthesize.cpp"
              var $106=HEAP16[(($arrayidx132)>>1)]; //@line 748 "synthesize.cpp"
              var $conv133=(tempInt=(($106)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 748 "synthesize.cpp"
              var $mul134=((($conv133)*($conv128))&4294967295); //@line 748 "synthesize.cpp"
              $x=$mul134; //@line 748 "synthesize.cpp"
              var $107=$x; //@line 749 "synthesize.cpp"
              var $div135=((((($107))|0)/256)|0); //@line 749 "synthesize.cpp"
              var $conv136=((($div135)) & 65535); //@line 749 "synthesize.cpp"
              var $108=$formant; //@line 749 "synthesize.cpp"
              var $109=$fr; //@line 749 "synthesize.cpp"
              var $ffreq137=(($109+2)&4294967295); //@line 749 "synthesize.cpp"
              var $arrayidx138=(($ffreq137+$108*2)&4294967295); //@line 749 "synthesize.cpp"
              HEAP16[(($arrayidx138)>>1)]=$conv136; //@line 749 "synthesize.cpp"
              var $110=$formant; //@line 745 "synthesize.cpp"
              var $inc139=((($110)+1)&4294967295); //@line 745 "synthesize.cpp"
              $formant=$inc139; //@line 745 "synthesize.cpp"
              var $cmp125=((($inc139))|0) <= 5; //@line 745 "synthesize.cpp"
              if ($cmp125) { __label__ = 31;continue ; } else { __label__ = 32;break ; } //@line 745 "synthesize.cpp"
            }
  
            var $111=$ix; //@line 740 "synthesize.cpp"
            var $inc141=((($111)+1)&4294967295); //@line 740 "synthesize.cpp"
            $ix=$inc141; //@line 740 "synthesize.cpp"
            var $112=$ix; //@line 740 "synthesize.cpp"
            var $113=$n_frames_addr; //@line 740 "synthesize.cpp"
            var $114=HEAP32[(($113)>>2)]; //@line 740 "synthesize.cpp"
            var $cmp118=((($112))|0) < ((($114))|0); //@line 740 "synthesize.cpp"
            if ($cmp118) { __label__ = 30;continue $for_body$42; } else { __label__ = 33;break $if_then27$$if_else85$9; } //@line 740 "synthesize.cpp"
          }
        }
      } while(0);
  
      var $115=$fr; //@line 756 "synthesize.cpp"
      var $cmp146=((($115))|0)!=0; //@line 756 "synthesize.cpp"
      if ($cmp146) { __label__ = 34;; } else { __label__ = 38;; } //@line 756 "synthesize.cpp"
      $if_then147$$if_end164$48: do { 
        if (__label__ == 34) {
  
          var $116=$flags; //@line 758 "synthesize.cpp"
          var $and148=($116) & 4; //@line 758 "synthesize.cpp"
          var $tobool149=((($and148))|0)!=0; //@line 758 "synthesize.cpp"
          if ($tobool149) { __label__ = 35;; } else { __label__ = 36;; } //@line 758 "synthesize.cpp"
          if (__label__ == 35) {
  
            var $117=$fr; //@line 759 "synthesize.cpp"
            var $frflags151=(($117)&4294967295); //@line 759 "synthesize.cpp"
            var $118=HEAP16[(($frflags151)>>1)]; //@line 759 "synthesize.cpp"
            var $conv152=(tempInt=(($118)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 759 "synthesize.cpp"
            var $or153=($conv152) | 32; //@line 759 "synthesize.cpp"
            var $conv154=((($or153)) & 65535); //@line 759 "synthesize.cpp"
            HEAP16[(($frflags151)>>1)]=$conv154; //@line 759 "synthesize.cpp"
            ; //@line 759 "synthesize.cpp"
          }
  
          var $119=$flags; //@line 760 "synthesize.cpp"
          var $and156=($119) & 2; //@line 760 "synthesize.cpp"
          var $tobool157=((($and156))|0)!=0; //@line 760 "synthesize.cpp"
          if (!($tobool157)) { __label__ = 38;break $if_then147$$if_end164$48; } //@line 760 "synthesize.cpp"
  
          var $120=$fr; //@line 761 "synthesize.cpp"
          var $frflags159=(($120)&4294967295); //@line 761 "synthesize.cpp"
          var $121=HEAP16[(($frflags159)>>1)]; //@line 761 "synthesize.cpp"
          var $conv160=(tempInt=(($121)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 761 "synthesize.cpp"
          var $or161=($conv160) | 16; //@line 761 "synthesize.cpp"
          var $conv162=((($or161)) & 65535); //@line 761 "synthesize.cpp"
          HEAP16[(($frflags159)>>1)]=$conv162; //@line 761 "synthesize.cpp"
          ; //@line 761 "synthesize.cpp"
        }
      } while(0);
  
      var $122=$flags; //@line 764 "synthesize.cpp"
      var $and165=($122) & 64; //@line 764 "synthesize.cpp"
      var $tobool166=((($and165))|0)!=0; //@line 764 "synthesize.cpp"
      if ($tobool166) { __label__ = 39;; } else { __label__ = 40;; } //@line 764 "synthesize.cpp"
      if (__label__ == 39) {
  
        __ZL7DoPauseii(12, 0); //@line 765 "synthesize.cpp"
        ; //@line 765 "synthesize.cpp"
      }
  
      var $123=$flags; //@line 767 "synthesize.cpp"
      var $and169=($123) & 16; //@line 767 "synthesize.cpp"
      var $tobool170=((($and169))|0)!=0; //@line 767 "synthesize.cpp"
      if ($tobool170) { __label__ = 41;; } else { __label__ = 42;; } //@line 767 "synthesize.cpp"
      if (__label__ == 41) {
  
        var $124=$len; //@line 768 "synthesize.cpp"
        $retval=$124; //@line 768 "synthesize.cpp"
        ; //@line 768 "synthesize.cpp"
      }
      else if (__label__ == 42) {
  
        $retval=0; //@line 769 "synthesize.cpp"
        ; //@line 769 "synthesize.cpp"
      }
    }
  
    var $125=$retval; //@line 770 "synthesize.cpp"
    ;
    return $125; //@line 770 "synthesize.cpp"
    return null;
  }
  

  function __ZL9CopyFrameP7frame_ti($frame1, $copy) {
    ;
    var __label__;
  
    var $retval;
    var $frame1_addr;
    var $copy_addr;
    var $frame2;
    $frame1_addr=$frame1;
    $copy_addr=$copy;
    var $0=$copy_addr; //@line 524 "synthesize.cpp"
    var $cmp=((($0))|0)==0; //@line 524 "synthesize.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 3;; } //@line 524 "synthesize.cpp"
    $land_lhs_true$$if_end$2: do { 
      if (__label__ == 1) {
  
        var $1=$frame1_addr; //@line 524 "synthesize.cpp"
        var $frflags=(($1)&4294967295); //@line 524 "synthesize.cpp"
        var $2=HEAP16[(($frflags)>>1)]; //@line 524 "synthesize.cpp"
        var $conv=(tempInt=(($2)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 524 "synthesize.cpp"
        var $and=($conv) & 32768; //@line 524 "synthesize.cpp"
        var $tobool=((($and))|0)!=0; //@line 524 "synthesize.cpp"
        if (!($tobool)) { __label__ = 3;break $land_lhs_true$$if_end$2; } //@line 524 "synthesize.cpp"
  
        var $3=$frame1_addr; //@line 527 "synthesize.cpp"
        $retval=$3; //@line 527 "synthesize.cpp"
        __label__ = 6;break $land_lhs_true$$if_end$2; //@line 527 "synthesize.cpp"
      }
    } while(0);
    if (__label__ == 3) {
  
      var $call=__ZL10AllocFramev(); //@line 530 "synthesize.cpp"
      $frame2=$call; //@line 530 "synthesize.cpp"
      var $cmp1=((($call))|0)!=0; //@line 531 "synthesize.cpp"
      if ($cmp1) { __label__ = 4;; } else { __label__ = 5;; } //@line 531 "synthesize.cpp"
      if (__label__ == 4) {
  
        var $4=$frame2; //@line 533 "synthesize.cpp"
        var $5=$4; //@line 533 "synthesize.cpp"
        var $6=$frame1_addr; //@line 533 "synthesize.cpp"
        var $7=$6; //@line 533 "synthesize.cpp"
        var $src$, $dest$, $stop$, $stop4$, $fast$;
        $src$ = $7;
        $dest$ = $5;
        $stop$ = $src$ + 64;
        if (($dest$%4) == ($src$%4) && 64 > 8) {
          while ($src$%4 !== 0 && $src$ < $stop$) {
            ; HEAP8[$dest$++] = HEAP8[$src$++];
          }
          $src$ >>= 2;
          $dest$ >>= 2;
          $stop4$ = $stop$ >> 2;
          while ($src$ < $stop4$) {
        ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
          }
          $src$ <<= 2;
          $dest$ <<= 2;
        }while ($src$ < $stop$) {
          ; HEAP8[$dest$++] = HEAP8[$src$++];
        }; //@line 533 "synthesize.cpp"
        var $8=$frame2; //@line 534 "synthesize.cpp"
        var $length=(($8+16)&4294967295); //@line 534 "synthesize.cpp"
        HEAP8[($length)]=0; //@line 534 "synthesize.cpp"
        var $9=$frame2; //@line 535 "synthesize.cpp"
        var $frflags3=(($9)&4294967295); //@line 535 "synthesize.cpp"
        var $10=HEAP16[(($frflags3)>>1)]; //@line 535 "synthesize.cpp"
        var $conv4=(tempInt=(($10)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 535 "synthesize.cpp"
        var $or=($conv4) | 32768; //@line 535 "synthesize.cpp"
        var $conv5=((($or)) & 65535); //@line 535 "synthesize.cpp"
        HEAP16[(($frflags3)>>1)]=$conv5; //@line 535 "synthesize.cpp"
        ; //@line 536 "synthesize.cpp"
      }
  
      var $11=$frame2; //@line 537 "synthesize.cpp"
      $retval=$11; //@line 537 "synthesize.cpp"
      ; //@line 537 "synthesize.cpp"
    }
  
    var $12=$retval; //@line 538 "synthesize.cpp"
    ;
    return $12; //@line 538 "synthesize.cpp"
    return null;
  }
  

  function __ZL13set_frame_rmsP7frame_ti($fr, $new_rms) {
    ;
    var __label__;
  
    var $fr_addr;
    var $new_rms_addr;
    var $x;
    var $h;
    var $ix;
    $fr_addr=$fr;
    $new_rms_addr=$new_rms;
    var $0=HEAP32[((_voice)>>2)]; //@line 478 "synthesize.cpp"
    var $klattv=(($0+112)&4294967295); //@line 478 "synthesize.cpp"
    var $arrayidx=(($klattv)&4294967295); //@line 478 "synthesize.cpp"
    var $1=HEAP32[(($arrayidx)>>2)]; //@line 478 "synthesize.cpp"
    var $tobool=((($1))|0)!=0; //@line 478 "synthesize.cpp"
    if ($tobool) { __label__ = 1;; } else { __label__ = 3;; } //@line 478 "synthesize.cpp"
    $if_then$$if_end3$2: do { 
      if (__label__ == 1) {
  
        var $2=$new_rms_addr; //@line 480 "synthesize.cpp"
        var $cmp=((($2))|0)==-1; //@line 480 "synthesize.cpp"
        if (!($cmp)) { __label__ = 8;break $if_then$$if_end3$2; } //@line 480 "synthesize.cpp"
  
        var $3=$fr_addr; //@line 482 "synthesize.cpp"
        var $klattp=(($3+39)&4294967295); //@line 482 "synthesize.cpp"
        var $arrayidx2=(($klattp)&4294967295); //@line 482 "synthesize.cpp"
        HEAP8[($arrayidx2)]=50; //@line 482 "synthesize.cpp"
        ; //@line 483 "synthesize.cpp"
      }
      else if (__label__ == 3) {
  
        var $4=$fr_addr; //@line 487 "synthesize.cpp"
        var $rms=(($4+17)&4294967295); //@line 487 "synthesize.cpp"
        var $5=HEAPU8[($rms)]; //@line 487 "synthesize.cpp"
        var $conv=((($5))&255); //@line 487 "synthesize.cpp"
        var $cmp4=((($conv))|0)==0; //@line 487 "synthesize.cpp"
        if ($cmp4) { __label__ = 8;break $if_then$$if_end3$2; } //@line 487 "synthesize.cpp"
  
        var $6=$new_rms_addr; //@line 488 "synthesize.cpp"
        var $mul=((($6)*64)&4294967295); //@line 488 "synthesize.cpp"
        var $7=$fr_addr; //@line 488 "synthesize.cpp"
        var $rms7=(($7+17)&4294967295); //@line 488 "synthesize.cpp"
        var $8=HEAPU8[($rms7)]; //@line 488 "synthesize.cpp"
        var $conv8=((($8))&255); //@line 488 "synthesize.cpp"
        var $div=((((($mul))|0)/((($conv8))|0))|0); //@line 488 "synthesize.cpp"
        $x=$div; //@line 488 "synthesize.cpp"
        var $9=$x; //@line 489 "synthesize.cpp"
        var $cmp9=((($9))|0) >= 200; //@line 489 "synthesize.cpp"
        if ($cmp9) { __label__ = 5;; } else { __label__ = 6;; } //@line 489 "synthesize.cpp"
        if (__label__ == 5) {
  
          $x=199; //@line 489 "synthesize.cpp"
          ; //@line 489 "synthesize.cpp"
        }
  
        var $10=$x; //@line 491 "synthesize.cpp"
        var $arrayidx12=((__ZZL13set_frame_rmsP7frame_tiE8sqrt_tab+$10*2)&4294967295); //@line 491 "synthesize.cpp"
        var $11=HEAP16[(($arrayidx12)>>1)]; //@line 491 "synthesize.cpp"
        var $conv13=(tempInt=(($11)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 491 "synthesize.cpp"
        $x=$conv13; //@line 491 "synthesize.cpp"
        $ix=0; //@line 493 "synthesize.cpp"
        ; //@line 493 "synthesize.cpp"
        while(1) { 
  
          var $12=$ix; //@line 495 "synthesize.cpp"
          var $13=$fr_addr; //@line 495 "synthesize.cpp"
          var $fheight=(($13+18)&4294967295); //@line 495 "synthesize.cpp"
          var $arrayidx15=(($fheight+$12)&4294967295); //@line 495 "synthesize.cpp"
          var $14=HEAPU8[($arrayidx15)]; //@line 495 "synthesize.cpp"
          var $conv16=((($14))&255); //@line 495 "synthesize.cpp"
          var $15=$x; //@line 495 "synthesize.cpp"
          var $mul17=((($conv16)*($15))&4294967295); //@line 495 "synthesize.cpp"
          $h=$mul17; //@line 495 "synthesize.cpp"
          var $16=$h; //@line 496 "synthesize.cpp"
          var $div18=((((($16))|0)/512)|0); //@line 496 "synthesize.cpp"
          var $conv19=((($div18)) & 255); //@line 496 "synthesize.cpp"
          var $17=$ix; //@line 496 "synthesize.cpp"
          var $18=$fr_addr; //@line 496 "synthesize.cpp"
          var $fheight20=(($18+18)&4294967295); //@line 496 "synthesize.cpp"
          var $arrayidx21=(($fheight20+$17)&4294967295); //@line 496 "synthesize.cpp"
          HEAP8[($arrayidx21)]=$conv19; //@line 496 "synthesize.cpp"
          var $19=$ix; //@line 493 "synthesize.cpp"
          var $inc=((($19)+1)&4294967295); //@line 493 "synthesize.cpp"
          $ix=$inc; //@line 493 "synthesize.cpp"
          var $cmp14=((($inc))|0) < 8; //@line 493 "synthesize.cpp"
          if ($cmp14) { __label__ = 7;continue ; } else { __label__ = 8;break $if_then$$if_end3$2; } //@line 493 "synthesize.cpp"
        }
      }
    } while(0);
  
    ;
    return; //@line 498 "synthesize.cpp"
    return;
  }
  

  function __ZL14AdjustFormantsP7frame_tiiiiiii($fr, $target, $min, $max, $f1_adj, $f3_adj, $hf_reduce, $flags) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $fr_addr;
    var $target_addr;
    var $min_addr;
    var $max_addr;
    var $f1_adj_addr;
    var $f3_adj_addr;
    var $hf_reduce_addr;
    var $flags_addr;
    var $x;
    $fr_addr=$fr;
    $target_addr=$target;
    $min_addr=$min;
    $max_addr=$max;
    $f1_adj_addr=$f1_adj;
    $f3_adj_addr=$f3_adj;
    $hf_reduce_addr=$hf_reduce;
    $flags_addr=$flags;
    var $0=$target_addr; //@line 559 "synthesize.cpp"
    var $1=HEAP32[((_voice)>>2)]; //@line 559 "synthesize.cpp"
    var $formant_factor=(($1+96)&4294967295); //@line 559 "synthesize.cpp"
    var $2=HEAP32[(($formant_factor)>>2)]; //@line 559 "synthesize.cpp"
    var $mul=((($2)*($0))&4294967295); //@line 559 "synthesize.cpp"
    var $div=((((($mul))|0)/256)|0); //@line 559 "synthesize.cpp"
    $target_addr=$div; //@line 559 "synthesize.cpp"
    var $3=$target_addr; //@line 561 "synthesize.cpp"
    var $4=$fr_addr; //@line 561 "synthesize.cpp"
    var $ffreq=(($4+2)&4294967295); //@line 561 "synthesize.cpp"
    var $arrayidx=(($ffreq+4)&4294967295); //@line 561 "synthesize.cpp"
    var $5=HEAP16[(($arrayidx)>>1)]; //@line 561 "synthesize.cpp"
    var $conv=(tempInt=(($5)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 561 "synthesize.cpp"
    var $sub=((($3)-($conv))&4294967295); //@line 561 "synthesize.cpp"
    var $div1=((((($sub))|0)/2)|0); //@line 561 "synthesize.cpp"
    $x=$div1; //@line 561 "synthesize.cpp"
    var $6=$x; //@line 562 "synthesize.cpp"
    var $7=$max_addr; //@line 562 "synthesize.cpp"
    var $cmp=((($6))|0) > ((($7))|0); //@line 562 "synthesize.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 562 "synthesize.cpp"
    if (__label__ == 1) {
  
      var $8=$max_addr; //@line 562 "synthesize.cpp"
      $x=$8; //@line 562 "synthesize.cpp"
      ; //@line 562 "synthesize.cpp"
    }
  
    var $9=$x; //@line 563 "synthesize.cpp"
    var $10=$min_addr; //@line 563 "synthesize.cpp"
    var $cmp2=((($9))|0) < ((($10))|0); //@line 563 "synthesize.cpp"
    if ($cmp2) { __label__ = 3;; } else { __label__ = 4;; } //@line 563 "synthesize.cpp"
    if (__label__ == 3) {
  
      var $11=$min_addr; //@line 563 "synthesize.cpp"
      $x=$11; //@line 563 "synthesize.cpp"
      ; //@line 563 "synthesize.cpp"
    }
  
    var $12=$x; //@line 564 "synthesize.cpp"
    var $13=$fr_addr; //@line 564 "synthesize.cpp"
    var $ffreq5=(($13+2)&4294967295); //@line 564 "synthesize.cpp"
    var $arrayidx6=(($ffreq5+4)&4294967295); //@line 564 "synthesize.cpp"
    var $14=HEAP16[(($arrayidx6)>>1)]; //@line 564 "synthesize.cpp"
    var $conv7=(tempInt=(($14)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 564 "synthesize.cpp"
    var $add=((($conv7)+($12))&4294967295); //@line 564 "synthesize.cpp"
    var $conv8=((($add)) & 65535); //@line 564 "synthesize.cpp"
    HEAP16[(($arrayidx6)>>1)]=$conv8; //@line 564 "synthesize.cpp"
    var $15=$f3_adj_addr; //@line 565 "synthesize.cpp"
    var $16=$fr_addr; //@line 565 "synthesize.cpp"
    var $ffreq9=(($16+2)&4294967295); //@line 565 "synthesize.cpp"
    var $arrayidx10=(($ffreq9+6)&4294967295); //@line 565 "synthesize.cpp"
    var $17=HEAP16[(($arrayidx10)>>1)]; //@line 565 "synthesize.cpp"
    var $conv11=(tempInt=(($17)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 565 "synthesize.cpp"
    var $add12=((($conv11)+($15))&4294967295); //@line 565 "synthesize.cpp"
    var $conv13=((($add12)) & 65535); //@line 565 "synthesize.cpp"
    HEAP16[(($arrayidx10)>>1)]=$conv13; //@line 565 "synthesize.cpp"
    var $18=$flags_addr; //@line 567 "synthesize.cpp"
    var $and=($18) & 32; //@line 567 "synthesize.cpp"
    var $tobool=((($and))|0)!=0; //@line 567 "synthesize.cpp"
    if ($tobool) { __label__ = 5;; } else { __label__ = 6;; } //@line 567 "synthesize.cpp"
    if (__label__ == 5) {
  
      var $19=$f3_adj_addr; //@line 569 "synthesize.cpp"
      var $sub15=(((-($19)))&4294967295); //@line 569 "synthesize.cpp"
      $f3_adj_addr=$sub15; //@line 569 "synthesize.cpp"
      ; //@line 570 "synthesize.cpp"
    }
  
    var $20=$f3_adj_addr; //@line 571 "synthesize.cpp"
    var $21=$fr_addr; //@line 571 "synthesize.cpp"
    var $ffreq17=(($21+2)&4294967295); //@line 571 "synthesize.cpp"
    var $arrayidx18=(($ffreq17+8)&4294967295); //@line 571 "synthesize.cpp"
    var $22=HEAP16[(($arrayidx18)>>1)]; //@line 571 "synthesize.cpp"
    var $conv19=(tempInt=(($22)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 571 "synthesize.cpp"
    var $add20=((($conv19)+($20))&4294967295); //@line 571 "synthesize.cpp"
    var $conv21=((($add20)) & 65535); //@line 571 "synthesize.cpp"
    HEAP16[(($arrayidx18)>>1)]=$conv21; //@line 571 "synthesize.cpp"
    var $23=$f3_adj_addr; //@line 572 "synthesize.cpp"
    var $24=$fr_addr; //@line 572 "synthesize.cpp"
    var $ffreq22=(($24+2)&4294967295); //@line 572 "synthesize.cpp"
    var $arrayidx23=(($ffreq22+10)&4294967295); //@line 572 "synthesize.cpp"
    var $25=HEAP16[(($arrayidx23)>>1)]; //@line 572 "synthesize.cpp"
    var $conv24=(tempInt=(($25)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 572 "synthesize.cpp"
    var $add25=((($conv24)+($23))&4294967295); //@line 572 "synthesize.cpp"
    var $conv26=((($add25)) & 65535); //@line 572 "synthesize.cpp"
    HEAP16[(($arrayidx23)>>1)]=$conv26; //@line 572 "synthesize.cpp"
    var $26=$f1_adj_addr; //@line 574 "synthesize.cpp"
    var $cmp27=((($26))|0)==1; //@line 574 "synthesize.cpp"
    if ($cmp27) { __lastLabel__ = 6; __label__ = 7;; } else { __lastLabel__ = 6; __label__ = 12;; } //@line 574 "synthesize.cpp"
    if (__label__ == 7) {
  
      var $27=$fr_addr; //@line 576 "synthesize.cpp"
      var $ffreq29=(($27+2)&4294967295); //@line 576 "synthesize.cpp"
      var $arrayidx30=(($ffreq29+2)&4294967295); //@line 576 "synthesize.cpp"
      var $28=HEAP16[(($arrayidx30)>>1)]; //@line 576 "synthesize.cpp"
      var $conv31=(tempInt=(($28)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 576 "synthesize.cpp"
      var $sub32=((235-($conv31))&4294967295); //@line 576 "synthesize.cpp"
      $x=$sub32; //@line 576 "synthesize.cpp"
      var $29=$x; //@line 577 "synthesize.cpp"
      var $cmp33=((($29))|0) < -100; //@line 577 "synthesize.cpp"
      if ($cmp33) { __label__ = 8;; } else { __label__ = 9;; } //@line 577 "synthesize.cpp"
      $if_end35_thread$$if_end35$13: do { 
        if (__label__ == 8) {
  
          $x=-100; //@line 577 "synthesize.cpp"
          ; //@line 578 "synthesize.cpp"
        }
        else if (__label__ == 9) {
  
          var $cmp36=((($29))|0) > -60; //@line 578 "synthesize.cpp"
          if (!($cmp36)) { __label__ = 11;break $if_end35_thread$$if_end35$13; } //@line 578 "synthesize.cpp"
  
          $x=-60; //@line 578 "synthesize.cpp"
          ; //@line 578 "synthesize.cpp"
        }
      } while(0);
  
      var $30=$x; //@line 579 "synthesize.cpp"
      var $31=$fr_addr; //@line 579 "synthesize.cpp"
      var $ffreq39=(($31+2)&4294967295); //@line 579 "synthesize.cpp"
      var $arrayidx40=(($ffreq39+2)&4294967295); //@line 579 "synthesize.cpp"
      var $32=HEAP16[(($arrayidx40)>>1)]; //@line 579 "synthesize.cpp"
      var $conv41=(tempInt=(($32)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 579 "synthesize.cpp"
      var $add42=((($conv41)+($30))&4294967295); //@line 579 "synthesize.cpp"
      var $conv43=((($add42)) & 65535); //@line 579 "synthesize.cpp"
      HEAP16[(($arrayidx40)>>1)]=$conv43; //@line 579 "synthesize.cpp"
      var $_pr=$f1_adj_addr; //@line 581 "synthesize.cpp"
      __lastLabel__ = 11; ; //@line 580 "synthesize.cpp"
    }
  
    var $33=__lastLabel__ == 11 ? $_pr : ($26); //@line 581 "synthesize.cpp"
    var $cmp45=((($33))|0)==2; //@line 581 "synthesize.cpp"
    if ($cmp45) { __label__ = 13;; } else { __label__ = 18;; } //@line 581 "synthesize.cpp"
    if (__label__ == 13) {
  
      var $34=$fr_addr; //@line 583 "synthesize.cpp"
      var $ffreq47=(($34+2)&4294967295); //@line 583 "synthesize.cpp"
      var $arrayidx48=(($ffreq47+2)&4294967295); //@line 583 "synthesize.cpp"
      var $35=HEAP16[(($arrayidx48)>>1)]; //@line 583 "synthesize.cpp"
      var $conv49=(tempInt=(($35)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 583 "synthesize.cpp"
      var $sub50=((235-($conv49))&4294967295); //@line 583 "synthesize.cpp"
      $x=$sub50; //@line 583 "synthesize.cpp"
      var $36=$x; //@line 584 "synthesize.cpp"
      var $cmp51=((($36))|0) < -300; //@line 584 "synthesize.cpp"
      if ($cmp51) { __label__ = 14;; } else { __label__ = 15;; } //@line 584 "synthesize.cpp"
      $if_end53_thread$$if_end53$21: do { 
        if (__label__ == 14) {
  
          $x=-300; //@line 584 "synthesize.cpp"
          ; //@line 585 "synthesize.cpp"
        }
        else if (__label__ == 15) {
  
          var $cmp54=((($36))|0) > -150; //@line 585 "synthesize.cpp"
          if (!($cmp54)) { __label__ = 17;break $if_end53_thread$$if_end53$21; } //@line 585 "synthesize.cpp"
  
          $x=-150; //@line 585 "synthesize.cpp"
          ; //@line 585 "synthesize.cpp"
        }
      } while(0);
  
      var $37=$x; //@line 586 "synthesize.cpp"
      var $38=$fr_addr; //@line 586 "synthesize.cpp"
      var $ffreq57=(($38+2)&4294967295); //@line 586 "synthesize.cpp"
      var $arrayidx58=(($ffreq57+2)&4294967295); //@line 586 "synthesize.cpp"
      var $39=HEAP16[(($arrayidx58)>>1)]; //@line 586 "synthesize.cpp"
      var $conv59=(tempInt=(($39)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 586 "synthesize.cpp"
      var $add60=((($conv59)+($37))&4294967295); //@line 586 "synthesize.cpp"
      var $conv61=((($add60)) & 65535); //@line 586 "synthesize.cpp"
      HEAP16[(($arrayidx58)>>1)]=$conv61; //@line 586 "synthesize.cpp"
      var $40=$x; //@line 587 "synthesize.cpp"
      var $41=$fr_addr; //@line 587 "synthesize.cpp"
      var $ffreq62=(($41+2)&4294967295); //@line 587 "synthesize.cpp"
      var $arrayidx63=(($ffreq62)&4294967295); //@line 587 "synthesize.cpp"
      var $42=HEAP16[(($arrayidx63)>>1)]; //@line 587 "synthesize.cpp"
      var $conv64=(tempInt=(($42)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 587 "synthesize.cpp"
      var $add65=((($conv64)+($40))&4294967295); //@line 587 "synthesize.cpp"
      var $conv66=((($add65)) & 65535); //@line 587 "synthesize.cpp"
      HEAP16[(($arrayidx63)>>1)]=$conv66; //@line 587 "synthesize.cpp"
      ; //@line 588 "synthesize.cpp"
    }
  
    var $43=$f1_adj_addr; //@line 589 "synthesize.cpp"
    var $cmp68=((($43))|0)==3; //@line 589 "synthesize.cpp"
    if ($cmp68) { __label__ = 19;; } else { __label__ = 24;; } //@line 589 "synthesize.cpp"
    if (__label__ == 19) {
  
      var $44=$fr_addr; //@line 591 "synthesize.cpp"
      var $ffreq70=(($44+2)&4294967295); //@line 591 "synthesize.cpp"
      var $arrayidx71=(($ffreq70+2)&4294967295); //@line 591 "synthesize.cpp"
      var $45=HEAP16[(($arrayidx71)>>1)]; //@line 591 "synthesize.cpp"
      var $conv72=(tempInt=(($45)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 591 "synthesize.cpp"
      var $sub73=((100-($conv72))&4294967295); //@line 591 "synthesize.cpp"
      $x=$sub73; //@line 591 "synthesize.cpp"
      var $46=$x; //@line 592 "synthesize.cpp"
      var $cmp74=((($46))|0) < -400; //@line 592 "synthesize.cpp"
      if ($cmp74) { __label__ = 20;; } else { __label__ = 21;; } //@line 592 "synthesize.cpp"
      $if_end76_thread$$if_end76$29: do { 
        if (__label__ == 20) {
  
          $x=-400; //@line 592 "synthesize.cpp"
          ; //@line 593 "synthesize.cpp"
        }
        else if (__label__ == 21) {
  
          var $cmp77=((($46))|0) > -300; //@line 593 "synthesize.cpp"
          if (!($cmp77)) { __label__ = 23;break $if_end76_thread$$if_end76$29; } //@line 593 "synthesize.cpp"
  
          $x=-400; //@line 593 "synthesize.cpp"
          ; //@line 593 "synthesize.cpp"
        }
      } while(0);
  
      var $47=$x; //@line 594 "synthesize.cpp"
      var $48=$fr_addr; //@line 594 "synthesize.cpp"
      var $ffreq80=(($48+2)&4294967295); //@line 594 "synthesize.cpp"
      var $arrayidx81=(($ffreq80+2)&4294967295); //@line 594 "synthesize.cpp"
      var $49=HEAP16[(($arrayidx81)>>1)]; //@line 594 "synthesize.cpp"
      var $conv82=(tempInt=(($49)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 594 "synthesize.cpp"
      var $add83=((($conv82)+($47))&4294967295); //@line 594 "synthesize.cpp"
      var $conv84=((($add83)) & 65535); //@line 594 "synthesize.cpp"
      HEAP16[(($arrayidx81)>>1)]=$conv84; //@line 594 "synthesize.cpp"
      var $50=$x; //@line 595 "synthesize.cpp"
      var $51=$fr_addr; //@line 595 "synthesize.cpp"
      var $ffreq85=(($51+2)&4294967295); //@line 595 "synthesize.cpp"
      var $arrayidx86=(($ffreq85)&4294967295); //@line 595 "synthesize.cpp"
      var $52=HEAP16[(($arrayidx86)>>1)]; //@line 595 "synthesize.cpp"
      var $conv87=(tempInt=(($52)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 595 "synthesize.cpp"
      var $add88=((($conv87)+($50))&4294967295); //@line 595 "synthesize.cpp"
      var $conv89=((($add88)) & 65535); //@line 595 "synthesize.cpp"
      HEAP16[(($arrayidx86)>>1)]=$conv89; //@line 595 "synthesize.cpp"
      ; //@line 596 "synthesize.cpp"
    }
  
    var $53=$fr_addr; //@line 597 "synthesize.cpp"
    var $54=$hf_reduce_addr; //@line 597 "synthesize.cpp"
    __ZL18formants_reduce_hfP7frame_ti($53, $54); //@line 597 "synthesize.cpp"
    ;
    return; //@line 598 "synthesize.cpp"
    return;
  }
  

  function __ZL14VowelClosenessP7frame_t($fr) {
    ;
    var __label__;
  
    var $retval;
    var $fr_addr;
    var $f1;
    $fr_addr=$fr;
    var $0=$fr_addr; //@line 606 "synthesize.cpp"
    var $ffreq=(($0+2)&4294967295); //@line 606 "synthesize.cpp"
    var $arrayidx=(($ffreq+2)&4294967295); //@line 606 "synthesize.cpp"
    var $1=HEAP16[(($arrayidx)>>1)]; //@line 606 "synthesize.cpp"
    var $conv=(tempInt=(($1)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 606 "synthesize.cpp"
    $f1=$conv; //@line 606 "synthesize.cpp"
    var $cmp=((($conv))|0) < 300; //@line 606 "synthesize.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 606 "synthesize.cpp"
    if (__label__ == 1) {
  
      $retval=3; //@line 607 "synthesize.cpp"
      ; //@line 607 "synthesize.cpp"
    }
    else if (__label__ == 2) {
  
      var $2=$f1; //@line 608 "synthesize.cpp"
      var $cmp1=((($2))|0) < 400; //@line 608 "synthesize.cpp"
      if ($cmp1) { __label__ = 3;; } else { __label__ = 4;; } //@line 608 "synthesize.cpp"
      if (__label__ == 3) {
  
        $retval=2; //@line 609 "synthesize.cpp"
        ; //@line 609 "synthesize.cpp"
      }
      else if (__label__ == 4) {
  
        var $3=$f1; //@line 610 "synthesize.cpp"
        var $cmp4=((($3))|0) < 500; //@line 610 "synthesize.cpp"
        if ($cmp4) { __label__ = 5;; } else { __label__ = 6;; } //@line 610 "synthesize.cpp"
        if (__label__ == 5) {
  
          $retval=1; //@line 611 "synthesize.cpp"
          ; //@line 611 "synthesize.cpp"
        }
        else if (__label__ == 6) {
  
          $retval=0; //@line 612 "synthesize.cpp"
          ; //@line 612 "synthesize.cpp"
        }
      }
    }
  
    var $4=$retval; //@line 613 "synthesize.cpp"
    ;
    return $4; //@line 613 "synthesize.cpp"
    return null;
  }
  

  function __ZL18DuplicateLastFrameP10frameref_tii($seq, $n_frames, $length) {
    ;
    var __label__;
  
    var $seq_addr;
    var $n_frames_addr;
    var $length_addr;
    var $fr;
    $seq_addr=$seq;
    $n_frames_addr=$n_frames;
    $length_addr=$length;
    var $0=$length_addr; //@line 545 "synthesize.cpp"
    var $conv=((($0)) & 65535); //@line 545 "synthesize.cpp"
    var $1=$n_frames_addr; //@line 545 "synthesize.cpp"
    var $sub=((($1)-1)&4294967295); //@line 545 "synthesize.cpp"
    var $2=$seq_addr; //@line 545 "synthesize.cpp"
    var $arrayidx=(($2+8*$sub)&4294967295); //@line 545 "synthesize.cpp"
    var $length1=(($arrayidx)&4294967295); //@line 545 "synthesize.cpp"
    HEAP16[(($length1)>>1)]=$conv; //@line 545 "synthesize.cpp"
    var $3=$n_frames_addr; //@line 546 "synthesize.cpp"
    var $sub2=((($3)-1)&4294967295); //@line 546 "synthesize.cpp"
    var $4=$seq_addr; //@line 546 "synthesize.cpp"
    var $arrayidx3=(($4+8*$sub2)&4294967295); //@line 546 "synthesize.cpp"
    var $frame=(($arrayidx3+4)&4294967295); //@line 546 "synthesize.cpp"
    var $5=HEAP32[(($frame)>>2)]; //@line 546 "synthesize.cpp"
    var $call=__ZL9CopyFrameP7frame_ti($5, 1); //@line 546 "synthesize.cpp"
    $fr=$call; //@line 546 "synthesize.cpp"
    var $6=$fr; //@line 547 "synthesize.cpp"
    var $7=$n_frames_addr; //@line 547 "synthesize.cpp"
    var $8=$seq_addr; //@line 547 "synthesize.cpp"
    var $arrayidx4=(($8+8*$7)&4294967295); //@line 547 "synthesize.cpp"
    var $frame5=(($arrayidx4+4)&4294967295); //@line 547 "synthesize.cpp"
    HEAP32[(($frame5)>>2)]=$6; //@line 547 "synthesize.cpp"
    var $9=$n_frames_addr; //@line 548 "synthesize.cpp"
    var $10=$seq_addr; //@line 548 "synthesize.cpp"
    var $arrayidx6=(($10+8*$9)&4294967295); //@line 548 "synthesize.cpp"
    var $length7=(($arrayidx6)&4294967295); //@line 548 "synthesize.cpp"
    HEAP16[(($length7)>>1)]=0; //@line 548 "synthesize.cpp"
    var $11=$fr; //@line 549 "synthesize.cpp"
    ;
    return $11; //@line 549 "synthesize.cpp"
    return null;
  }
  

  function __ZL7DoPauseii($length, $control) {
    ;
    var __label__;
  
    var $length_addr;
    var $control_addr;
    var $len;
    $length_addr=$length;
    $control_addr=$control;
    var $0=$length_addr; //@line 216 "synthesize.cpp"
    var $cmp=((($0))|0)==0; //@line 216 "synthesize.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 216 "synthesize.cpp"
    if (__label__ == 1) {
  
      $len=0; //@line 217 "synthesize.cpp"
      ; //@line 217 "synthesize.cpp"
    }
    else if (__label__ == 2) {
  
      var $1=$length_addr; //@line 220 "synthesize.cpp"
      var $2=$control_addr; //@line 220 "synthesize.cpp"
      var $call=__Z11PauseLengthii($1, $2); //@line 220 "synthesize.cpp"
      $len=$call; //@line 220 "synthesize.cpp"
      var $3=$len; //@line 222 "synthesize.cpp"
      var $4=HEAP32[((_samplerate)>>2)]; //@line 222 "synthesize.cpp"
      var $mul=((($4)*($3))&4294967295); //@line 222 "synthesize.cpp"
      var $div=((((($mul))|0)/1000)|0); //@line 222 "synthesize.cpp"
      $len=$div; //@line 222 "synthesize.cpp"
      ;
    }
  
    __ZL8EndPitchi(1); //@line 225 "synthesize.cpp"
    var $5=HEAP32[((_wcmdq_tail)>>2)]; //@line 226 "synthesize.cpp"
    var $arrayidx=((_wcmdq+$5*16)&4294967295); //@line 226 "synthesize.cpp"
    var $arrayidx1=(($arrayidx)&4294967295); //@line 226 "synthesize.cpp"
    HEAP32[(($arrayidx1)>>2)]=5; //@line 226 "synthesize.cpp"
    var $6=$len; //@line 227 "synthesize.cpp"
    var $7=HEAP32[((_wcmdq_tail)>>2)]; //@line 227 "synthesize.cpp"
    var $arrayidx2=((_wcmdq+$7*16)&4294967295); //@line 227 "synthesize.cpp"
    var $arrayidx3=(($arrayidx2+4)&4294967295); //@line 227 "synthesize.cpp"
    HEAP32[(($arrayidx3)>>2)]=$6; //@line 227 "synthesize.cpp"
    __Z8WcmdqIncv(); //@line 228 "synthesize.cpp"
    HEAP32[((__ZL10last_frame)>>2)]=0; //@line 229 "synthesize.cpp"
    var $8=HEAP32[((__ZL13fmt_amplitude)>>2)]; //@line 231 "synthesize.cpp"
    var $cmp4=((($8))|0)!=0; //@line 231 "synthesize.cpp"
    if ($cmp4) { __label__ = 4;; } else { __label__ = 5;; } //@line 231 "synthesize.cpp"
    if (__label__ == 4) {
  
      var $9=HEAP32[((_wcmdq_tail)>>2)]; //@line 233 "synthesize.cpp"
      var $arrayidx6=((_wcmdq+$9*16)&4294967295); //@line 233 "synthesize.cpp"
      var $arrayidx7=(($arrayidx6)&4294967295); //@line 233 "synthesize.cpp"
      HEAP32[(($arrayidx7)>>2)]=14; //@line 233 "synthesize.cpp"
      HEAP32[((__ZL13fmt_amplitude)>>2)]=0; //@line 234 "synthesize.cpp"
      var $10=HEAP32[((_wcmdq_tail)>>2)]; //@line 234 "synthesize.cpp"
      var $arrayidx8=((_wcmdq+$10*16)&4294967295); //@line 234 "synthesize.cpp"
      var $arrayidx9=(($arrayidx8+4)&4294967295); //@line 234 "synthesize.cpp"
      HEAP32[(($arrayidx9)>>2)]=0; //@line 234 "synthesize.cpp"
      __Z8WcmdqIncv(); //@line 235 "synthesize.cpp"
      ; //@line 236 "synthesize.cpp"
    }
  
    ;
    return; //@line 237 "synthesize.cpp"
    return;
  }
  

  function __Z8DoSpect2P11PHONEME_TABiP10FMT_PARAMSP12PHONEME_LISTi($this_ph, $which, $fmt_params, $plist, $modulation) {
    var __stackBase__  = STACKTOP; STACKTOP += 104; _memset(__stackBase__, 0, 104);
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $this_ph_addr;
    var $which_addr;
    var $fmt_params_addr;
    var $plist_addr;
    var $modulation_addr;
    var $n_frames=__stackBase__;
    var $frames;
    var $frameix;
    var $frame1;
    var $frame2;
    var $fr;
    var $ix;
    var $q;
    var $len;
    var $frame_length;
    var $length_factor;
    var $length_mod;
    var $length_sum;
    var $length_min;
    var $total_len;
    var $wcmd_spect;
    var $frame_lengths=__stackBase__+4;
    $this_ph_addr=$this_ph;
    $which_addr=$which;
    $fmt_params_addr=$fmt_params;
    $plist_addr=$plist;
    $modulation_addr=$modulation;
    $total_len=0; //@line 1007 "synthesize.cpp"
    $wcmd_spect=3; //@line 1009 "synthesize.cpp"
    var $0=$fmt_params_addr; //@line 1012 "synthesize.cpp"
    var $fmt_addr=(($0+8)&4294967295); //@line 1012 "synthesize.cpp"
    var $1=HEAP32[(($fmt_addr)>>2)]; //@line 1012 "synthesize.cpp"
    var $cmp=((($1))|0)==0; //@line 1012 "synthesize.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 1012 "synthesize.cpp"
    if (__label__ == 1) {
  
      $retval=0; //@line 1013 "synthesize.cpp"
      ; //@line 1013 "synthesize.cpp"
    }
    else if (__label__ == 2) {
  
      var $2=$plist_addr; //@line 1015 "synthesize.cpp"
      var $length=(($2+12)&4294967295); //@line 1015 "synthesize.cpp"
      var $3=HEAP16[(($length)>>1)]; //@line 1015 "synthesize.cpp"
      var $conv=(tempInt=(($3)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1015 "synthesize.cpp"
      $length_mod=$conv; //@line 1015 "synthesize.cpp"
      var $4=$length_mod; //@line 1016 "synthesize.cpp"
      var $cmp1=((($4))|0)==0; //@line 1016 "synthesize.cpp"
      if ($cmp1) { __label__ = 3;; } else { __label__ = 4;; } //@line 1016 "synthesize.cpp"
      if (__label__ == 3) {
  
        $length_mod=256; //@line 1016 "synthesize.cpp"
        ; //@line 1016 "synthesize.cpp"
      }
  
      var $5=HEAP32[((_samplerate)>>2)]; //@line 1018 "synthesize.cpp"
      var $div=((((($5))|0)/70)|0); //@line 1018 "synthesize.cpp"
      $length_min=$div; //@line 1018 "synthesize.cpp"
      var $6=$which_addr; //@line 1019 "synthesize.cpp"
      var $cmp4=((($6))|0)==2; //@line 1019 "synthesize.cpp"
      if ($cmp4) { __lastLabel__ = 4; __label__ = 5;; } else { __lastLabel__ = 4; __label__ = 11;; } //@line 1019 "synthesize.cpp"
      if (__label__ == 5) {
  
        var $7=HEAP32[((_translator)>>2)]; //@line 1021 "synthesize.cpp"
        var $langopts=(($7)&4294967295); //@line 1021 "synthesize.cpp"
        var $param=(($langopts+24)&4294967295); //@line 1021 "synthesize.cpp"
        var $arrayidx=(($param+72)&4294967295); //@line 1021 "synthesize.cpp"
        var $8=HEAP32[(($arrayidx)>>2)]; //@line 1021 "synthesize.cpp"
        var $cmp6=((($8))|0) > 0; //@line 1021 "synthesize.cpp"
        if ($cmp6) { __label__ = 6;; } else { __label__ = 10;; } //@line 1021 "synthesize.cpp"
        $land_lhs_true$$if_end18thread_pre_split$10: do { 
          if (__label__ == 6) {
  
            var $9=$this_ph_addr; //@line 1021 "synthesize.cpp"
            var $std_length=(($9+14)&4294967295); //@line 1021 "synthesize.cpp"
            var $10=HEAPU8[($std_length)]; //@line 1021 "synthesize.cpp"
            var $conv7=((($10))&255); //@line 1021 "synthesize.cpp"
            var $11=HEAP32[((_translator)>>2)]; //@line 1021 "synthesize.cpp"
            var $langopts8=(($11)&4294967295); //@line 1021 "synthesize.cpp"
            var $param9=(($langopts8+24)&4294967295); //@line 1021 "synthesize.cpp"
            var $arrayidx10=(($param9+72)&4294967295); //@line 1021 "synthesize.cpp"
            var $12=HEAP32[(($arrayidx10)>>2)]; //@line 1021 "synthesize.cpp"
            var $cmp11=((($conv7))|0) >= ((($12))|0); //@line 1021 "synthesize.cpp"
            if ($cmp11) { __label__ = 9;; } else { __label__ = 7;; } //@line 1021 "synthesize.cpp"
            $if_then16$$lor_lhs_false$12: do { 
              if (__label__ == 7) {
  
                var $13=$plist_addr; //@line 1021 "synthesize.cpp"
                var $synthflags=(($13+4)&4294967295); //@line 1021 "synthesize.cpp"
                var $14=HEAPU16[(($synthflags)>>1)]; //@line 1021 "synthesize.cpp"
                var $conv12=((($14))&65535); //@line 1021 "synthesize.cpp"
                var $and=($conv12) & 8; //@line 1021 "synthesize.cpp"
                var $tobool=((($and))|0)!=0; //@line 1021 "synthesize.cpp"
                if ($tobool) { __label__ = 9;break $if_then16$$lor_lhs_false$12; } //@line 1021 "synthesize.cpp"
  
                var $15=$this_ph_addr; //@line 1021 "synthesize.cpp"
                var $phflags=(($15+4)&4294967295); //@line 1021 "synthesize.cpp"
                var $16=HEAP32[(($phflags)>>2)]; //@line 1021 "synthesize.cpp"
                var $and14=($16) & 2097152; //@line 1021 "synthesize.cpp"
                var $tobool15=((($and14))|0)!=0; //@line 1021 "synthesize.cpp"
                if (!($tobool15)) { __label__ = 10;break $land_lhs_true$$if_end18thread_pre_split$10; } //@line 1021 "synthesize.cpp"
              }
            } while(0);
  
            var $17=$length_min; //@line 1022 "synthesize.cpp"
            var $mul=((($17)*2)&4294967295); //@line 1022 "synthesize.cpp"
            $length_min=$mul; //@line 1022 "synthesize.cpp"
            ; //@line 1022 "synthesize.cpp"
          }
        } while(0);
  
        var $_pr=$which_addr; //@line 1025 "synthesize.cpp"
        __lastLabel__ = 10; ;
      }
  
      var $18=__lastLabel__ == 10 ? $_pr : ($6); //@line 1025 "synthesize.cpp"
      var $cmp19=((($18))|0)==1; //@line 1025 "synthesize.cpp"
      if ($cmp19) { __label__ = 12;; } else { __label__ = 17;; } //@line 1025 "synthesize.cpp"
      $if_then20$$if_end41$18: do { 
        if (__label__ == 12) {
  
          var $19=$this_ph_addr; //@line 1028 "synthesize.cpp"
          var $type=(($19+11)&4294967295); //@line 1028 "synthesize.cpp"
          var $20=HEAPU8[($type)]; //@line 1028 "synthesize.cpp"
          var $conv21=((($20))&255); //@line 1028 "synthesize.cpp"
          var $cmp22=((($conv21))|0)==3; //@line 1028 "synthesize.cpp"
          if ($cmp22) { __label__ = 15;; } else { __label__ = 13;; } //@line 1028 "synthesize.cpp"
          $if_then33$$lor_lhs_false23$20: do { 
            if (__label__ == 13) {
  
              var $21=$plist_addr; //@line 1028 "synthesize.cpp"
              var $arrayidx24=(($21+-24)&4294967295); //@line 1028 "synthesize.cpp"
              var $type25=(($arrayidx24+15)&4294967295); //@line 1028 "synthesize.cpp"
              var $22=HEAPU8[($type25)]; //@line 1028 "synthesize.cpp"
              var $conv26=((($22))&255); //@line 1028 "synthesize.cpp"
              var $cmp27=((($conv26))|0)==3; //@line 1028 "synthesize.cpp"
              if ($cmp27) { __label__ = 15;break $if_then33$$lor_lhs_false23$20; } //@line 1028 "synthesize.cpp"
  
              var $23=$plist_addr; //@line 1028 "synthesize.cpp"
              var $arrayidx29=(($23+-24)&4294967295); //@line 1028 "synthesize.cpp"
              var $type30=(($arrayidx29+15)&4294967295); //@line 1028 "synthesize.cpp"
              var $24=HEAPU8[($type30)]; //@line 1028 "synthesize.cpp"
              var $conv31=((($24))&255); //@line 1028 "synthesize.cpp"
              var $cmp32=((($conv31))|0)==8; //@line 1028 "synthesize.cpp"
              if (!($cmp32)) { __label__ = 17;break $if_then20$$if_end41$18; } //@line 1028 "synthesize.cpp"
            }
          } while(0);
  
          var $25=$length_mod; //@line 1030 "synthesize.cpp"
          var $26=HEAP32[((_translator)>>2)]; //@line 1030 "synthesize.cpp"
          var $langopts34=(($26)&4294967295); //@line 1030 "synthesize.cpp"
          var $param35=(($langopts34+24)&4294967295); //@line 1030 "synthesize.cpp"
          var $arrayidx36=(($param35+28)&4294967295); //@line 1030 "synthesize.cpp"
          var $27=HEAP32[(($arrayidx36)>>2)]; //@line 1030 "synthesize.cpp"
          $len=$27; //@line 1030 "synthesize.cpp"
          var $cmp37=((($25))|0) < ((($27))|0); //@line 1030 "synthesize.cpp"
          if (!($cmp37)) { __label__ = 17;break $if_then20$$if_end41$18; } //@line 1030 "synthesize.cpp"
  
          var $28=$len; //@line 1032 "synthesize.cpp"
          $length_mod=$28; //@line 1032 "synthesize.cpp"
          ; //@line 1033 "synthesize.cpp"
        }
      } while(0);
  
      HEAP32[((__ZL10modn_flags)>>2)]=0; //@line 1037 "synthesize.cpp"
      var $29=$this_ph_addr; //@line 1038 "synthesize.cpp"
      var $30=$which_addr; //@line 1038 "synthesize.cpp"
      var $31=$fmt_params_addr; //@line 1038 "synthesize.cpp"
      var $32=$plist_addr; //@line 1038 "synthesize.cpp"
      var $call=__Z11LookupSpectP11PHONEME_TABiP10FMT_PARAMSPiP12PHONEME_LIST($29, $30, $31, $n_frames, $32); //@line 1038 "synthesize.cpp"
      $frames=$call; //@line 1038 "synthesize.cpp"
      var $cmp42=((($call))|0)==0; //@line 1039 "synthesize.cpp"
      if ($cmp42) { __label__ = 18;; } else { __label__ = 19;; } //@line 1039 "synthesize.cpp"
      if (__label__ == 18) {
  
        $retval=0; //@line 1040 "synthesize.cpp"
        ; //@line 1040 "synthesize.cpp"
      }
      else if (__label__ == 19) {
  
        var $33=$fmt_params_addr; //@line 1042 "synthesize.cpp"
        var $fmt_amp=(($33+16)&4294967295); //@line 1042 "synthesize.cpp"
        var $34=HEAP32[(($fmt_amp)>>2)]; //@line 1042 "synthesize.cpp"
        var $35=HEAP32[((__ZL13fmt_amplitude)>>2)]; //@line 1042 "synthesize.cpp"
        var $cmp45=((($34))|0)!=((($35))|0); //@line 1042 "synthesize.cpp"
        if ($cmp45) { __label__ = 20;; } else { __label__ = 21;; } //@line 1042 "synthesize.cpp"
        if (__label__ == 20) {
  
          var $36=HEAP32[((_wcmdq_tail)>>2)]; //@line 1045 "synthesize.cpp"
          var $arrayidx47=((_wcmdq+$36*16)&4294967295); //@line 1045 "synthesize.cpp"
          var $arraydecay=(($arrayidx47)&4294967295); //@line 1045 "synthesize.cpp"
          $q=$arraydecay; //@line 1045 "synthesize.cpp"
          var $37=$q; //@line 1046 "synthesize.cpp"
          var $arrayidx48=(($37)&4294967295); //@line 1046 "synthesize.cpp"
          HEAP32[(($arrayidx48)>>2)]=14; //@line 1046 "synthesize.cpp"
          var $38=$fmt_params_addr; //@line 1047 "synthesize.cpp"
          var $fmt_amp49=(($38+16)&4294967295); //@line 1047 "synthesize.cpp"
          var $39=HEAP32[(($fmt_amp49)>>2)]; //@line 1047 "synthesize.cpp"
          HEAP32[((__ZL13fmt_amplitude)>>2)]=$39; //@line 1047 "synthesize.cpp"
          var $40=$q; //@line 1047 "synthesize.cpp"
          var $arrayidx50=(($40+4)&4294967295); //@line 1047 "synthesize.cpp"
          HEAP32[(($arrayidx50)>>2)]=$39; //@line 1047 "synthesize.cpp"
          __Z8WcmdqIncv(); //@line 1048 "synthesize.cpp"
          ; //@line 1049 "synthesize.cpp"
        }
  
        var $41=$frames; //@line 1051 "synthesize.cpp"
        var $arrayidx52=(($41)&4294967295); //@line 1051 "synthesize.cpp"
        var $frame=(($arrayidx52+4)&4294967295); //@line 1051 "synthesize.cpp"
        var $42=HEAP32[(($frame)>>2)]; //@line 1051 "synthesize.cpp"
        $frame1=$42; //@line 1051 "synthesize.cpp"
        var $43=HEAP32[((_voice)>>2)]; //@line 1052 "synthesize.cpp"
        var $klattv=(($43+112)&4294967295); //@line 1052 "synthesize.cpp"
        var $arrayidx53=(($klattv)&4294967295); //@line 1052 "synthesize.cpp"
        var $44=HEAP32[(($arrayidx53)>>2)]; //@line 1052 "synthesize.cpp"
        var $tobool54=((($44))|0)!=0; //@line 1052 "synthesize.cpp"
        if ($tobool54) { __label__ = 22;; } else { __label__ = 23;; } //@line 1052 "synthesize.cpp"
        if (__label__ == 22) {
  
          $wcmd_spect=1; //@line 1053 "synthesize.cpp"
          ; //@line 1053 "synthesize.cpp"
        }
  
        var $45=$fmt_params_addr; //@line 1055 "synthesize.cpp"
        var $wav_addr=(($45+28)&4294967295); //@line 1055 "synthesize.cpp"
        var $46=HEAP32[(($wav_addr)>>2)]; //@line 1055 "synthesize.cpp"
        HEAP32[((_wavefile_ix)>>2)]=$46; //@line 1055 "synthesize.cpp"
        var $47=$fmt_params_addr; //@line 1057 "synthesize.cpp"
        var $wav_amp=(($47+32)&4294967295); //@line 1057 "synthesize.cpp"
        var $48=HEAP32[(($wav_amp)>>2)]; //@line 1057 "synthesize.cpp"
        var $cmp57=((($48))|0)==0; //@line 1057 "synthesize.cpp"
        if ($cmp57) { __label__ = 24;; } else { __label__ = 25;; } //@line 1057 "synthesize.cpp"
        if (__label__ == 24) {
  
          HEAP32[((_wavefile_amp)>>2)]=32; //@line 1058 "synthesize.cpp"
          ; //@line 1058 "synthesize.cpp"
        }
        else if (__label__ == 25) {
  
          var $49=$fmt_params_addr; //@line 1060 "synthesize.cpp"
          var $wav_amp59=(($49+32)&4294967295); //@line 1060 "synthesize.cpp"
          var $50=HEAP32[(($wav_amp59)>>2)]; //@line 1060 "synthesize.cpp"
          var $mul60=((($50)*32)&4294967295); //@line 1060 "synthesize.cpp"
          var $div61=((((($mul60))|0)/100)|0); //@line 1060 "synthesize.cpp"
          HEAP32[((_wavefile_amp)>>2)]=$div61; //@line 1060 "synthesize.cpp"
          ;
        }
  
        var $51=HEAP32[((_wavefile_ix)>>2)]; //@line 1062 "synthesize.cpp"
        var $cmp63=((($51))|0)==0; //@line 1062 "synthesize.cpp"
        if ($cmp63) { __label__ = 27;; } else { __label__ = 33;; } //@line 1062 "synthesize.cpp"
        $if_then64$$if_end79$39: do { 
          if (__label__ == 27) {
  
            var $_b=HEAPU8[(__ZZ8DoSpect2P11PHONEME_TABiP10FMT_PARAMSP12PHONEME_LISTiE9wave_flag_b)];
            var $52=((($_b))&1);
            var $tobool65=((($52))|0)!=0; //@line 1064 "synthesize.cpp"
            if ($tobool65) { __label__ = 28;; } else { __label__ = 31;; } //@line 1064 "synthesize.cpp"
            if (__label__ == 28) {
  
              $wcmd_spect=4; //@line 1067 "synthesize.cpp"
              var $53=HEAP32[((_voice)>>2)]; //@line 1068 "synthesize.cpp"
              var $klattv67=(($53+112)&4294967295); //@line 1068 "synthesize.cpp"
              var $arrayidx68=(($klattv67)&4294967295); //@line 1068 "synthesize.cpp"
              var $54=HEAP32[(($arrayidx68)>>2)]; //@line 1068 "synthesize.cpp"
              var $tobool69=((($54))|0)!=0; //@line 1068 "synthesize.cpp"
              if ($tobool69) { __label__ = 29;; } else { __label__ = 30;; } //@line 1068 "synthesize.cpp"
              if (__label__ == 29) {
  
                $wcmd_spect=2; //@line 1069 "synthesize.cpp"
                ; //@line 1069 "synthesize.cpp"
              }
  
              HEAP8[(__ZZ8DoSpect2P11PHONEME_TABiP10FMT_PARAMSP12PHONEME_LISTiE9wave_flag_b)]=0;
              ; //@line 1071 "synthesize.cpp"
            }
            else if (__label__ == 31) {
  
              $wcmd_spect=3; //@line 1074 "synthesize.cpp"
              var $55=HEAP32[((_voice)>>2)]; //@line 1075 "synthesize.cpp"
              var $klattv73=(($55+112)&4294967295); //@line 1075 "synthesize.cpp"
              var $arrayidx74=(($klattv73)&4294967295); //@line 1075 "synthesize.cpp"
              var $56=HEAP32[(($arrayidx74)>>2)]; //@line 1075 "synthesize.cpp"
              var $tobool75=((($56))|0)!=0; //@line 1075 "synthesize.cpp"
              if (!($tobool75)) { __label__ = 33;break $if_then64$$if_end79$39; } //@line 1075 "synthesize.cpp"
  
              $wcmd_spect=1; //@line 1076 "synthesize.cpp"
              ; //@line 1076 "synthesize.cpp"
            }
          }
        } while(0);
  
        var $57=HEAP32[((__ZL10last_frame)>>2)]; //@line 1080 "synthesize.cpp"
        var $cmp80=((($57))|0)!=0; //@line 1080 "synthesize.cpp"
        if ($cmp80) { __label__ = 34;; } else { __label__ = 43;; } //@line 1080 "synthesize.cpp"
        $if_then81$$if_end117$49: do { 
          if (__label__ == 34) {
  
            var $58=HEAP32[((__ZL10last_frame)>>2)]; //@line 1082 "synthesize.cpp"
            var $length82=(($58+16)&4294967295); //@line 1082 "synthesize.cpp"
            var $59=HEAPU8[($length82)]; //@line 1082 "synthesize.cpp"
            var $conv83=((($59))&255); //@line 1082 "synthesize.cpp"
            var $cmp84=((($conv83))|0) < 2; //@line 1082 "synthesize.cpp"
            if ($cmp84) { __label__ = 36;; } else { __label__ = 35;; } //@line 1082 "synthesize.cpp"
            if (__label__ == 35) {
  
              var $60=HEAP32[((__ZL10last_frame)>>2)]; //@line 1082 "synthesize.cpp"
              var $frflags=(($60)&4294967295); //@line 1082 "synthesize.cpp"
              var $61=HEAP16[(($frflags)>>1)]; //@line 1082 "synthesize.cpp"
              var $conv86=(tempInt=(($61)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1082 "synthesize.cpp"
              var $and87=($conv86) & 2; //@line 1082 "synthesize.cpp"
              var $tobool88=((($and87))|0)!=0; //@line 1082 "synthesize.cpp"
              if (!($tobool88)) { __label__ = 43;break $if_then81$$if_end117$49; } //@line 1082 "synthesize.cpp"
            }
  
            var $62=HEAP32[((__ZL10last_frame)>>2)]; //@line 1082 "synthesize.cpp"
            var $frflags90=(($62)&4294967295); //@line 1082 "synthesize.cpp"
            var $63=HEAP16[(($frflags90)>>1)]; //@line 1082 "synthesize.cpp"
            var $conv91=(tempInt=(($63)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1082 "synthesize.cpp"
            var $and92=($conv91) & 16; //@line 1082 "synthesize.cpp"
            var $tobool93=((($and92))|0)!=0; //@line 1082 "synthesize.cpp"
            if ($tobool93) { __label__ = 43;break $if_then81$$if_end117$49; } //@line 1082 "synthesize.cpp"
  
            var $64=$frame1; //@line 1086 "synthesize.cpp"
            var $65=($64); //@line 1086 "synthesize.cpp"
            var $66=HEAP32[((__ZL10last_wcmdq)>>2)]; //@line 1086 "synthesize.cpp"
            var $arrayidx95=((_wcmdq+$66*16)&4294967295); //@line 1086 "synthesize.cpp"
            var $arrayidx96=(($arrayidx95+12)&4294967295); //@line 1086 "synthesize.cpp"
            HEAP32[(($arrayidx96)>>2)]=$65; //@line 1086 "synthesize.cpp"
            var $67=HEAP32[((__ZL10last_frame)>>2)]; //@line 1088 "synthesize.cpp"
            var $frflags97=(($67)&4294967295); //@line 1088 "synthesize.cpp"
            var $68=HEAP16[(($frflags97)>>1)]; //@line 1088 "synthesize.cpp"
            var $conv98=(tempInt=(($68)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1088 "synthesize.cpp"
            var $and99=($conv98) & 8; //@line 1088 "synthesize.cpp"
            var $tobool100=((($and99))|0)!=0; //@line 1088 "synthesize.cpp"
            if (!($tobool100)) { __label__ = 43;break $if_then81$$if_end117$49; } //@line 1088 "synthesize.cpp"
  
            var $69=$frame1; //@line 1091 "synthesize.cpp"
            var $call102=__ZL9CopyFrameP7frame_ti($69, 1); //@line 1091 "synthesize.cpp"
            $fr=$call102; //@line 1091 "synthesize.cpp"
            $ix=3; //@line 1092 "synthesize.cpp"
            __lastLabel__ = 38; ; //@line 1092 "synthesize.cpp"
            while(1) { 
  
              var $70=__lastLabel__ == 38 ? 3 : ($inc); //@line 1094 "synthesize.cpp"
              var $cmp104=((($70))|0) < 7; //@line 1094 "synthesize.cpp"
              if ($cmp104) { __label__ = 40;; } else { __label__ = 41;; } //@line 1094 "synthesize.cpp"
              if (__label__ == 40) {
  
                var $71=$ix; //@line 1095 "synthesize.cpp"
                var $72=HEAP32[((__ZL10last_frame)>>2)]; //@line 1095 "synthesize.cpp"
                var $ffreq=(($72+2)&4294967295); //@line 1095 "synthesize.cpp"
                var $arrayidx106=(($ffreq+$71*2)&4294967295); //@line 1095 "synthesize.cpp"
                var $73=HEAP16[(($arrayidx106)>>1)]; //@line 1095 "synthesize.cpp"
                var $74=$ix; //@line 1095 "synthesize.cpp"
                var $75=$fr; //@line 1095 "synthesize.cpp"
                var $ffreq107=(($75+2)&4294967295); //@line 1095 "synthesize.cpp"
                var $arrayidx108=(($ffreq107+$74*2)&4294967295); //@line 1095 "synthesize.cpp"
                HEAP16[(($arrayidx108)>>1)]=$73; //@line 1095 "synthesize.cpp"
                ; //@line 1095 "synthesize.cpp"
              }
  
              var $76=$ix; //@line 1096 "synthesize.cpp"
              var $77=HEAP32[((__ZL10last_frame)>>2)]; //@line 1096 "synthesize.cpp"
              var $fheight=(($77+18)&4294967295); //@line 1096 "synthesize.cpp"
              var $arrayidx110=(($fheight+$76)&4294967295); //@line 1096 "synthesize.cpp"
              var $78=HEAP8[($arrayidx110)]; //@line 1096 "synthesize.cpp"
              var $79=$ix; //@line 1096 "synthesize.cpp"
              var $80=$fr; //@line 1096 "synthesize.cpp"
              var $fheight111=(($80+18)&4294967295); //@line 1096 "synthesize.cpp"
              var $arrayidx112=(($fheight111+$79)&4294967295); //@line 1096 "synthesize.cpp"
              HEAP8[($arrayidx112)]=$78; //@line 1096 "synthesize.cpp"
              var $81=$ix; //@line 1092 "synthesize.cpp"
              var $inc=((($81)+1)&4294967295); //@line 1092 "synthesize.cpp"
              $ix=$inc; //@line 1092 "synthesize.cpp"
              var $cmp103=((($inc))|0) < 8; //@line 1092 "synthesize.cpp"
              if ($cmp103) { __lastLabel__ = 41; __label__ = 39;continue ; } else { __lastLabel__ = 41; __label__ = 42;break ; } //@line 1092 "synthesize.cpp"
            }
  
            var $82=$fr; //@line 1098 "synthesize.cpp"
            var $83=($82); //@line 1098 "synthesize.cpp"
            var $84=HEAP32[((__ZL10last_wcmdq)>>2)]; //@line 1098 "synthesize.cpp"
            var $arrayidx113=((_wcmdq+$84*16)&4294967295); //@line 1098 "synthesize.cpp"
            var $arrayidx114=(($arrayidx113+12)&4294967295); //@line 1098 "synthesize.cpp"
            HEAP32[(($arrayidx114)>>2)]=$83; //@line 1098 "synthesize.cpp"
            ; //@line 1099 "synthesize.cpp"
          }
        } while(0);
  
        var $85=$this_ph_addr; //@line 1103 "synthesize.cpp"
        var $type118=(($85+11)&4294967295); //@line 1103 "synthesize.cpp"
        var $86=HEAPU8[($type118)]; //@line 1103 "synthesize.cpp"
        var $conv119=((($86))&255); //@line 1103 "synthesize.cpp"
        var $cmp120=((($conv119))|0)==2; //@line 1103 "synthesize.cpp"
        if ($cmp120) { __label__ = 44;; } else { __label__ = 46;; } //@line 1103 "synthesize.cpp"
        $land_lhs_true121$$if_end124$63: do { 
          if (__label__ == 44) {
  
            var $87=$which_addr; //@line 1103 "synthesize.cpp"
            var $cmp122=((($87))|0)==2; //@line 1103 "synthesize.cpp"
            if (!($cmp122)) { __label__ = 46;break $land_lhs_true121$$if_end124$63; } //@line 1103 "synthesize.cpp"
  
            __ZL11SmoothSpectv(); //@line 1105 "synthesize.cpp"
            var $88=HEAP32[((_wcmdq_tail)>>2)]; //@line 1108 "synthesize.cpp"
            HEAP32[((__ZL15syllable_centre)>>2)]=$88; //@line 1108 "synthesize.cpp"
            ; //@line 1109 "synthesize.cpp"
          }
        } while(0);
  
        $length_sum=0; //@line 1111 "synthesize.cpp"
        $frameix=1; //@line 1112 "synthesize.cpp"
        var $89=$frameix; //@line 1112 "synthesize.cpp"
        var $90=HEAP32[(($n_frames)>>2)]; //@line 1112 "synthesize.cpp"
        var $cmp1263=((($89))|0) < ((($90))|0); //@line 1112 "synthesize.cpp"
        if ($cmp1263) { __label__ = 47;; } else { __label__ = 56;; } //@line 1112 "synthesize.cpp"
        $for_body127$$if_end180$67: do { 
          if (__label__ == 47) {
            $for_body127$68: while(1) { 
  
              var $91=$length_mod; //@line 1114 "synthesize.cpp"
              $length_factor=$91; //@line 1114 "synthesize.cpp"
              var $92=$frameix; //@line 1115 "synthesize.cpp"
              var $sub=((($92)-1)&4294967295); //@line 1115 "synthesize.cpp"
              var $93=$frames; //@line 1115 "synthesize.cpp"
              var $arrayidx128=(($93+8*$sub)&4294967295); //@line 1115 "synthesize.cpp"
              var $frflags129=(($arrayidx128+2)&4294967295); //@line 1115 "synthesize.cpp"
              var $94=HEAP16[(($frflags129)>>1)]; //@line 1115 "synthesize.cpp"
              var $conv130=(tempInt=(($94)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1115 "synthesize.cpp"
              var $and131=($conv130) & 4; //@line 1115 "synthesize.cpp"
              var $tobool132=((($and131))|0)!=0; //@line 1115 "synthesize.cpp"
              if ($tobool132) { __label__ = 48;; } else { __label__ = 49;; } //@line 1115 "synthesize.cpp"
              $if_then133$$if_else138$70: do { 
                if (__label__ == 48) {
  
                  var $95=$length_mod; //@line 1117 "synthesize.cpp"
                  var $96=HEAP32[((((_speed+16)&4294967295))>>2)]; //@line 1117 "synthesize.cpp"
                  var $sub134=((256-($96))&4294967295); //@line 1117 "synthesize.cpp"
                  var $mul135=((($sub134)*($95))&4294967295); //@line 1117 "synthesize.cpp"
                  var $97=HEAP32[((((_speed+16)&4294967295))>>2)]; //@line 1117 "synthesize.cpp"
                  var $mul136=((($97)*256)&4294967295); //@line 1117 "synthesize.cpp"
                  var $add=((($mul135)+($mul136))&4294967295); //@line 1117 "synthesize.cpp"
                  var $div137=((((($add))|0)/256)|0); //@line 1117 "synthesize.cpp"
                  $length_factor=$div137; //@line 1117 "synthesize.cpp"
                  ; //@line 1118 "synthesize.cpp"
                }
                else if (__label__ == 49) {
  
                  var $98=$frameix; //@line 1120 "synthesize.cpp"
                  var $sub139=((($98)-1)&4294967295); //@line 1120 "synthesize.cpp"
                  var $99=$frames; //@line 1120 "synthesize.cpp"
                  var $arrayidx140=(($99+8*$sub139)&4294967295); //@line 1120 "synthesize.cpp"
                  var $frflags141=(($arrayidx140+2)&4294967295); //@line 1120 "synthesize.cpp"
                  var $100=HEAP16[(($frflags141)>>1)]; //@line 1120 "synthesize.cpp"
                  var $conv142=(tempInt=(($100)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1120 "synthesize.cpp"
                  var $and143=($conv142) & 16384; //@line 1120 "synthesize.cpp"
                  var $tobool144=((($and143))|0)!=0; //@line 1120 "synthesize.cpp"
                  if (!($tobool144)) { __label__ = 51;break $if_then133$$if_else138$70; } //@line 1120 "synthesize.cpp"
  
                  var $101=$length_mod; //@line 1122 "synthesize.cpp"
                  var $102=HEAP32[((((_speed+20)&4294967295))>>2)]; //@line 1122 "synthesize.cpp"
                  var $sub146=((256-($102))&4294967295); //@line 1122 "synthesize.cpp"
                  var $mul147=((($sub146)*($101))&4294967295); //@line 1122 "synthesize.cpp"
                  var $103=HEAP32[((((_speed+20)&4294967295))>>2)]; //@line 1122 "synthesize.cpp"
                  var $mul148=((($103)*256)&4294967295); //@line 1122 "synthesize.cpp"
                  var $add149=((($mul147)+($mul148))&4294967295); //@line 1122 "synthesize.cpp"
                  var $div150=((((($add149))|0)/256)|0); //@line 1122 "synthesize.cpp"
                  $length_factor=$div150; //@line 1122 "synthesize.cpp"
                  ; //@line 1123 "synthesize.cpp"
                }
              } while(0);
  
              var $104=$frameix; //@line 1125 "synthesize.cpp"
              var $sub153=((($104)-1)&4294967295); //@line 1125 "synthesize.cpp"
              var $105=$frames; //@line 1125 "synthesize.cpp"
              var $arrayidx154=(($105+8*$sub153)&4294967295); //@line 1125 "synthesize.cpp"
              var $length155=(($arrayidx154)&4294967295); //@line 1125 "synthesize.cpp"
              var $106=HEAP16[(($length155)>>1)]; //@line 1125 "synthesize.cpp"
              var $conv156=(tempInt=(($106)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1125 "synthesize.cpp"
              $frame_length=$conv156; //@line 1125 "synthesize.cpp"
              var $107=$frame_length; //@line 1126 "synthesize.cpp"
              var $108=HEAP32[((_samplerate)>>2)]; //@line 1126 "synthesize.cpp"
              var $mul157=((($108)*($107))&4294967295); //@line 1126 "synthesize.cpp"
              var $div158=((((($mul157))|0)/1000)|0); //@line 1126 "synthesize.cpp"
              $len=$div158; //@line 1126 "synthesize.cpp"
              var $109=$len; //@line 1127 "synthesize.cpp"
              var $110=$length_factor; //@line 1127 "synthesize.cpp"
              var $mul159=((($110)*($109))&4294967295); //@line 1127 "synthesize.cpp"
              var $div160=((((($mul159))|0)/256)|0); //@line 1127 "synthesize.cpp"
              $len=$div160; //@line 1127 "synthesize.cpp"
              var $111=$len; //@line 1128 "synthesize.cpp"
              var $112=$length_sum; //@line 1128 "synthesize.cpp"
              var $add161=((($112)+($111))&4294967295); //@line 1128 "synthesize.cpp"
              $length_sum=$add161; //@line 1128 "synthesize.cpp"
              var $113=$len; //@line 1129 "synthesize.cpp"
              var $114=$frameix; //@line 1129 "synthesize.cpp"
              var $arrayidx162=(($frame_lengths+$114*4)&4294967295); //@line 1129 "synthesize.cpp"
              HEAP32[(($arrayidx162)>>2)]=$113; //@line 1129 "synthesize.cpp"
              var $115=$frameix; //@line 1112 "synthesize.cpp"
              var $inc164=((($115)+1)&4294967295); //@line 1112 "synthesize.cpp"
              $frameix=$inc164; //@line 1112 "synthesize.cpp"
              var $116=$frameix; //@line 1112 "synthesize.cpp"
              var $117=HEAP32[(($n_frames)>>2)]; //@line 1112 "synthesize.cpp"
              var $cmp126=((($116))|0) < ((($117))|0); //@line 1112 "synthesize.cpp"
              if ($cmp126) { __label__ = 47;continue $for_body127$68; } else { __label__ = 52;break $for_body127$68; } //@line 1112 "synthesize.cpp"
            }
  
            var $_pr4=$length_sum; //@line 1132 "synthesize.cpp"
            var $cmp166=((($_pr4))|0) > 0; //@line 1132 "synthesize.cpp"
            if (!($cmp166)) { __label__ = 56;break $for_body127$$if_end180$67; } //@line 1132 "synthesize.cpp"
  
            var $118=$length_sum; //@line 1132 "synthesize.cpp"
            var $119=$length_min; //@line 1132 "synthesize.cpp"
            var $cmp168=((($118))|0) < ((($119))|0); //@line 1132 "synthesize.cpp"
            if (!($cmp168)) { __label__ = 56;break $for_body127$$if_end180$67; } //@line 1132 "synthesize.cpp"
  
            $frameix=1; //@line 1135 "synthesize.cpp"
            var $120=$frameix; //@line 1135 "synthesize.cpp"
            var $121=HEAP32[(($n_frames)>>2)]; //@line 1135 "synthesize.cpp"
            var $cmp1712=((($120))|0) < ((($121))|0); //@line 1135 "synthesize.cpp"
            if (!($cmp1712)) { __label__ = 56;break $for_body127$$if_end180$67; } //@line 1135 "synthesize.cpp"
            while(1) { 
  
              var $122=$frameix; //@line 1137 "synthesize.cpp"
              var $arrayidx173=(($frame_lengths+$122*4)&4294967295); //@line 1137 "synthesize.cpp"
              var $123=HEAP32[(($arrayidx173)>>2)]; //@line 1137 "synthesize.cpp"
              var $124=$length_min; //@line 1137 "synthesize.cpp"
              var $mul174=((($124)*($123))&4294967295); //@line 1137 "synthesize.cpp"
              var $125=$length_sum; //@line 1137 "synthesize.cpp"
              var $div175=((((($mul174))|0)/((($125))|0))|0); //@line 1137 "synthesize.cpp"
              var $126=$frameix; //@line 1137 "synthesize.cpp"
              var $arrayidx176=(($frame_lengths+$126*4)&4294967295); //@line 1137 "synthesize.cpp"
              HEAP32[(($arrayidx176)>>2)]=$div175; //@line 1137 "synthesize.cpp"
              var $127=$frameix; //@line 1135 "synthesize.cpp"
              var $inc178=((($127)+1)&4294967295); //@line 1135 "synthesize.cpp"
              $frameix=$inc178; //@line 1135 "synthesize.cpp"
              var $128=$frameix; //@line 1135 "synthesize.cpp"
              var $129=HEAP32[(($n_frames)>>2)]; //@line 1135 "synthesize.cpp"
              var $cmp171=((($128))|0) < ((($129))|0); //@line 1135 "synthesize.cpp"
              if ($cmp171) { __label__ = 55;continue ; } else { __label__ = 56;break $for_body127$$if_end180$67; } //@line 1135 "synthesize.cpp"
            }
          }
        } while(0);
  
        $frameix=1; //@line 1141 "synthesize.cpp"
        var $130=$frameix; //@line 1141 "synthesize.cpp"
        var $131=HEAP32[(($n_frames)>>2)]; //@line 1141 "synthesize.cpp"
        var $cmp1821=((($130))|0) < ((($131))|0); //@line 1141 "synthesize.cpp"
        if ($cmp1821) { __label__ = 57;; } else { __label__ = 72;; } //@line 1141 "synthesize.cpp"
        $for_body183$$for_end235$81: do { 
          if (__label__ == 57) {
            $for_body183$82: while(1) { 
  
              var $132=$frameix; //@line 1143 "synthesize.cpp"
              var $133=$frames; //@line 1143 "synthesize.cpp"
              var $arrayidx184=(($133+8*$132)&4294967295); //@line 1143 "synthesize.cpp"
              var $frame185=(($arrayidx184+4)&4294967295); //@line 1143 "synthesize.cpp"
              var $134=HEAP32[(($frame185)>>2)]; //@line 1143 "synthesize.cpp"
              $frame2=$134; //@line 1143 "synthesize.cpp"
              var $135=$fmt_params_addr; //@line 1145 "synthesize.cpp"
              var $wav_addr186=(($135+28)&4294967295); //@line 1145 "synthesize.cpp"
              var $136=HEAP32[(($wav_addr186)>>2)]; //@line 1145 "synthesize.cpp"
              var $cmp187=((($136))|0)!=0; //@line 1145 "synthesize.cpp"
              if ($cmp187) { __label__ = 58;; } else { __label__ = 60;; } //@line 1145 "synthesize.cpp"
              $land_lhs_true188$$if_end198$84: do { 
                if (__label__ == 58) {
  
                  var $137=$frame1; //@line 1145 "synthesize.cpp"
                  var $frflags189=(($137)&4294967295); //@line 1145 "synthesize.cpp"
                  var $138=HEAP16[(($frflags189)>>1)]; //@line 1145 "synthesize.cpp"
                  var $conv190=(tempInt=(($138)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1145 "synthesize.cpp"
                  var $and191=($conv190) & 128; //@line 1145 "synthesize.cpp"
                  var $cmp192=((($and191))|0)==0; //@line 1145 "synthesize.cpp"
                  if (!($cmp192)) { __label__ = 60;break $land_lhs_true188$$if_end198$84; } //@line 1145 "synthesize.cpp"
  
                  HEAP32[((_seq_len_adjust)>>2)]=0; //@line 1148 "synthesize.cpp"
                  var $139=$fmt_params_addr; //@line 1149 "synthesize.cpp"
                  var $wav_addr194=(($139+28)&4294967295); //@line 1149 "synthesize.cpp"
                  var $140=HEAP32[(($wav_addr194)>>2)]; //@line 1149 "synthesize.cpp"
                  var $141=$which_addr; //@line 1149 "synthesize.cpp"
                  var $add195=((($141)+256)&4294967295); //@line 1149 "synthesize.cpp"
                  var $142=$fmt_params_addr; //@line 1149 "synthesize.cpp"
                  var $fmt_control=(($142)&4294967295); //@line 1149 "synthesize.cpp"
                  var $143=HEAP32[(($fmt_control)>>2)]; //@line 1149 "synthesize.cpp"
                  var $144=HEAP32[((_wavefile_amp)>>2)]; //@line 1149 "synthesize.cpp"
                  var $call196=__ZL9DoSample2iiiiii($140, $add195, 0, $143, 0, $144); //@line 1149 "synthesize.cpp"
                  HEAP8[(__ZZ8DoSpect2P11PHONEME_TABiP10FMT_PARAMSP12PHONEME_LISTiE9wave_flag_b)]=1;
                  HEAP32[((_wavefile_ix)>>2)]=0; //@line 1151 "synthesize.cpp"
                  var $145=$fmt_params_addr; //@line 1152 "synthesize.cpp"
                  var $wav_addr197=(($145+28)&4294967295); //@line 1152 "synthesize.cpp"
                  HEAP32[(($wav_addr197)>>2)]=0; //@line 1152 "synthesize.cpp"
                  ; //@line 1153 "synthesize.cpp"
                }
              } while(0);
  
              var $146=$modulation_addr; //@line 1155 "synthesize.cpp"
              var $cmp199=((($146))|0) >= 0; //@line 1155 "synthesize.cpp"
              if ($cmp199) { __label__ = 61;; } else { __label__ = 66;; } //@line 1155 "synthesize.cpp"
              $if_then200$$if_end214$88: do { 
                if (__label__ == 61) {
  
                  var $147=$frame1; //@line 1157 "synthesize.cpp"
                  var $frflags201=(($147)&4294967295); //@line 1157 "synthesize.cpp"
                  var $148=HEAP16[(($frflags201)>>1)]; //@line 1157 "synthesize.cpp"
                  var $conv202=(tempInt=(($148)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1157 "synthesize.cpp"
                  var $and203=($conv202) & 64; //@line 1157 "synthesize.cpp"
                  var $tobool204=((($and203))|0)!=0; //@line 1157 "synthesize.cpp"
                  if ($tobool204) { __label__ = 62;; } else { __label__ = 63;; } //@line 1157 "synthesize.cpp"
                  if (__label__ == 62) {
  
                    $modulation_addr=6; //@line 1159 "synthesize.cpp"
                    ; //@line 1160 "synthesize.cpp"
                  }
  
                  var $149=$frameix; //@line 1161 "synthesize.cpp"
                  var $150=HEAP32[(($n_frames)>>2)]; //@line 1161 "synthesize.cpp"
                  var $sub207=((($150)-1)&4294967295); //@line 1161 "synthesize.cpp"
                  var $cmp208=((($149))|0)==((($sub207))|0); //@line 1161 "synthesize.cpp"
                  if (!($cmp208)) { __label__ = 66;break $if_then200$$if_end214$88; } //@line 1161 "synthesize.cpp"
  
                  var $151=HEAP32[((__ZL10modn_flags)>>2)]; //@line 1161 "synthesize.cpp"
                  var $and210=($151) & 3840; //@line 1161 "synthesize.cpp"
                  var $tobool211=((($and210))|0)!=0; //@line 1161 "synthesize.cpp"
                  if (!($tobool211)) { __label__ = 66;break $if_then200$$if_end214$88; } //@line 1161 "synthesize.cpp"
  
                  var $152=HEAP32[((__ZL10modn_flags)>>2)]; //@line 1162 "synthesize.cpp"
                  var $153=$modulation_addr; //@line 1162 "synthesize.cpp"
                  var $or=($153) | ($152); //@line 1162 "synthesize.cpp"
                  $modulation_addr=$or; //@line 1162 "synthesize.cpp"
                  ; //@line 1162 "synthesize.cpp"
                }
              } while(0);
  
              var $154=$frameix; //@line 1165 "synthesize.cpp"
              var $arrayidx215=(($frame_lengths+$154*4)&4294967295); //@line 1165 "synthesize.cpp"
              var $155=HEAP32[(($arrayidx215)>>2)]; //@line 1165 "synthesize.cpp"
              $len=$155; //@line 1165 "synthesize.cpp"
              var $156=HEAP32[((__ZL12pitch_length)>>2)]; //@line 1166 "synthesize.cpp"
              var $add216=((($156)+($155))&4294967295); //@line 1166 "synthesize.cpp"
              HEAP32[((__ZL12pitch_length)>>2)]=$add216; //@line 1166 "synthesize.cpp"
              var $157=HEAP32[((__ZL10amp_length)>>2)]; //@line 1167 "synthesize.cpp"
              var $add217=((($157)+($155))&4294967295); //@line 1167 "synthesize.cpp"
              HEAP32[((__ZL10amp_length)>>2)]=$add217; //@line 1167 "synthesize.cpp"
              var $cmp218=((($155))|0)==0; //@line 1169 "synthesize.cpp"
              if ($cmp218) { __label__ = 67;; } else { __label__ = 68;; } //@line 1169 "synthesize.cpp"
              if (__label__ == 67) {
  
                HEAP32[((__ZL10last_frame)>>2)]=0; //@line 1171 "synthesize.cpp"
                var $158=$frame2; //@line 1172 "synthesize.cpp"
                $frame1=$158; //@line 1172 "synthesize.cpp"
                ; //@line 1173 "synthesize.cpp"
              }
              else if (__label__ == 68) {
  
                var $159=HEAP32[((_wcmdq_tail)>>2)]; //@line 1176 "synthesize.cpp"
                HEAP32[((__ZL10last_wcmdq)>>2)]=$159; //@line 1176 "synthesize.cpp"
                var $160=$modulation_addr; //@line 1178 "synthesize.cpp"
                var $cmp221=((($160))|0) >= 0; //@line 1178 "synthesize.cpp"
                if ($cmp221) { __label__ = 69;; } else { __label__ = 70;; } //@line 1178 "synthesize.cpp"
                if (__label__ == 69) {
  
                  var $161=HEAP32[((_wcmdq_tail)>>2)]; //@line 1180 "synthesize.cpp"
                  var $arrayidx223=((_wcmdq+$161*16)&4294967295); //@line 1180 "synthesize.cpp"
                  var $arraydecay224=(($arrayidx223)&4294967295); //@line 1180 "synthesize.cpp"
                  $q=$arraydecay224; //@line 1180 "synthesize.cpp"
                  var $162=$wcmd_spect; //@line 1181 "synthesize.cpp"
                  var $163=$q; //@line 1181 "synthesize.cpp"
                  var $arrayidx225=(($163)&4294967295); //@line 1181 "synthesize.cpp"
                  HEAP32[(($arrayidx225)>>2)]=$162; //@line 1181 "synthesize.cpp"
                  var $164=$len; //@line 1182 "synthesize.cpp"
                  var $165=$modulation_addr; //@line 1182 "synthesize.cpp"
                  var $shl=((($165)*65536)&4294967295); //@line 1182 "synthesize.cpp"
                  var $add226=((($shl)+($164))&4294967295); //@line 1182 "synthesize.cpp"
                  var $166=$q; //@line 1182 "synthesize.cpp"
                  var $arrayidx227=(($166+4)&4294967295); //@line 1182 "synthesize.cpp"
                  HEAP32[(($arrayidx227)>>2)]=$add226; //@line 1182 "synthesize.cpp"
                  var $167=$frame1; //@line 1183 "synthesize.cpp"
                  var $168=($167); //@line 1183 "synthesize.cpp"
                  var $169=$q; //@line 1183 "synthesize.cpp"
                  var $arrayidx228=(($169+8)&4294967295); //@line 1183 "synthesize.cpp"
                  HEAP32[(($arrayidx228)>>2)]=$168; //@line 1183 "synthesize.cpp"
                  var $170=$frame2; //@line 1184 "synthesize.cpp"
                  var $171=($170); //@line 1184 "synthesize.cpp"
                  var $172=$q; //@line 1184 "synthesize.cpp"
                  var $arrayidx229=(($172+12)&4294967295); //@line 1184 "synthesize.cpp"
                  HEAP32[(($arrayidx229)>>2)]=$171; //@line 1184 "synthesize.cpp"
                  __Z8WcmdqIncv(); //@line 1186 "synthesize.cpp"
                  ; //@line 1187 "synthesize.cpp"
                }
  
                var $173=$frame2; //@line 1188 "synthesize.cpp"
                $frame1=$173; //@line 1188 "synthesize.cpp"
                HEAP32[((__ZL10last_frame)>>2)]=$173; //@line 1188 "synthesize.cpp"
                var $174=$len; //@line 1189 "synthesize.cpp"
                var $175=$total_len; //@line 1189 "synthesize.cpp"
                var $add231=((($175)+($174))&4294967295); //@line 1189 "synthesize.cpp"
                $total_len=$add231; //@line 1189 "synthesize.cpp"
                ;
              }
  
              var $176=$frameix; //@line 1141 "synthesize.cpp"
              var $inc234=((($176)+1)&4294967295); //@line 1141 "synthesize.cpp"
              $frameix=$inc234; //@line 1141 "synthesize.cpp"
              var $177=$frameix; //@line 1141 "synthesize.cpp"
              var $178=HEAP32[(($n_frames)>>2)]; //@line 1141 "synthesize.cpp"
              var $cmp182=((($177))|0) < ((($178))|0); //@line 1141 "synthesize.cpp"
              if ($cmp182) { __label__ = 57;continue $for_body183$82; } else { __label__ = 72;break $for_body183$$for_end235$81; } //@line 1141 "synthesize.cpp"
            }
          }
        } while(0);
  
        var $179=$which_addr; //@line 1193 "synthesize.cpp"
        var $cmp236=((($179))|0)!=1; //@line 1193 "synthesize.cpp"
        var $180=HEAP32[((__ZL13fmt_amplitude)>>2)]; //@line 1193 "synthesize.cpp"
        var $cmp238=((($180))|0)!=0; //@line 1193 "synthesize.cpp"
        var $or_cond=($cmp236) & ($cmp238); //@line 1193 "synthesize.cpp"
        if ($or_cond) { __label__ = 73;; } else { __label__ = 74;; } //@line 1193 "synthesize.cpp"
        if (__label__ == 73) {
  
          var $181=HEAP32[((_wcmdq_tail)>>2)]; //@line 1195 "synthesize.cpp"
          var $arrayidx240=((_wcmdq+$181*16)&4294967295); //@line 1195 "synthesize.cpp"
          var $arraydecay241=(($arrayidx240)&4294967295); //@line 1195 "synthesize.cpp"
          $q=$arraydecay241; //@line 1195 "synthesize.cpp"
          var $182=$q; //@line 1196 "synthesize.cpp"
          var $arrayidx242=(($182)&4294967295); //@line 1196 "synthesize.cpp"
          HEAP32[(($arrayidx242)>>2)]=14; //@line 1196 "synthesize.cpp"
          HEAP32[((__ZL13fmt_amplitude)>>2)]=0; //@line 1197 "synthesize.cpp"
          var $183=$q; //@line 1197 "synthesize.cpp"
          var $arrayidx243=(($183+4)&4294967295); //@line 1197 "synthesize.cpp"
          HEAP32[(($arrayidx243)>>2)]=0; //@line 1197 "synthesize.cpp"
          __Z8WcmdqIncv(); //@line 1198 "synthesize.cpp"
          ; //@line 1199 "synthesize.cpp"
        }
  
        var $184=$total_len; //@line 1202 "synthesize.cpp"
        $retval=$184; //@line 1202 "synthesize.cpp"
        ; //@line 1202 "synthesize.cpp"
      }
    }
  
    var $185=$retval; //@line 1203 "synthesize.cpp"
    STACKTOP = __stackBase__;
    return $185; //@line 1203 "synthesize.cpp"
    return null;
  }
  

  function __ZL11SmoothSpectv() {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $q;
    var $frame;
    var $frame2;
    var $frame1;
    var $frame_centre;
    var $ix;
    var $len;
    var $pk;
    var $modified;
    var $allowed;
    var $diff;
    var $f1;
    var $f2;
    var $f1142;
    var $f2143;
    var $0=HEAP32[((__ZL14syllable_start)>>2)]; //@line 790 "synthesize.cpp"
    var $1=HEAP32[((__ZL12syllable_end)>>2)]; //@line 790 "synthesize.cpp"
    var $cmp=((($0))|0)==((($1))|0); //@line 790 "synthesize.cpp"
    if ($cmp) { __label__ = 58;; } else { __label__ = 1;; } //@line 790 "synthesize.cpp"
    $return$$if_end$2: do { 
      if (__label__ == 1) {
  
        var $2=HEAP32[((__ZL15syllable_centre)>>2)]; //@line 793 "synthesize.cpp"
        var $cmp1=((($2))|0) < 0; //@line 793 "synthesize.cpp"
        if ($cmp1) { __label__ = 3;; } else { __label__ = 2;; } //@line 793 "synthesize.cpp"
        $if_then3$$lor_lhs_false$4: do { 
          if (__label__ == 2) {
  
            var $3=HEAP32[((__ZL15syllable_centre)>>2)]; //@line 793 "synthesize.cpp"
            var $4=HEAP32[((__ZL14syllable_start)>>2)]; //@line 793 "synthesize.cpp"
            var $cmp2=((($3))|0)==((($4))|0); //@line 793 "synthesize.cpp"
            if ($cmp2) { __label__ = 3;break $if_then3$$lor_lhs_false$4; } //@line 793 "synthesize.cpp"
  
            var $6=HEAP32[((__ZL15syllable_centre)>>2)]; //@line 799 "synthesize.cpp"
            var $arrayidx=((_wcmdq+$6*16)&4294967295); //@line 799 "synthesize.cpp"
            var $arraydecay=(($arrayidx)&4294967295); //@line 799 "synthesize.cpp"
            $q=$arraydecay; //@line 799 "synthesize.cpp"
            var $7=$q; //@line 800 "synthesize.cpp"
            var $arrayidx5=(($7+8)&4294967295); //@line 800 "synthesize.cpp"
            var $8=HEAP32[(($arrayidx5)>>2)]; //@line 800 "synthesize.cpp"
            var $9=($8); //@line 800 "synthesize.cpp"
            $frame_centre=$9; //@line 800 "synthesize.cpp"
            var $10=HEAP32[((__ZL15syllable_centre)>>2)]; //@line 803 "synthesize.cpp"
            var $sub=((($10)-1)&4294967295); //@line 803 "synthesize.cpp"
            $ix=$sub; //@line 803 "synthesize.cpp"
            var $11=$frame_centre; //@line 804 "synthesize.cpp"
            $frame2=$11; //@line 804 "synthesize.cpp"
            $frame=$11; //@line 804 "synthesize.cpp"
            __lastLabel__ = 4; ; //@line 805 "synthesize.cpp"
            $for_cond$7: while(1) { 
  
              var $12=__lastLabel__ == 30 ? $dec : ($sub); //@line 807 "synthesize.cpp"
              var $cmp6=((($12))|0) < 0; //@line 807 "synthesize.cpp"
              if ($cmp6) { __label__ = 6;; } else { __label__ = 7;; } //@line 807 "synthesize.cpp"
              if (__label__ == 6) {
  
                $ix=159; //@line 807 "synthesize.cpp"
                ; //@line 807 "synthesize.cpp"
              }
  
              var $13=$ix; //@line 808 "synthesize.cpp"
              var $arrayidx9=((_wcmdq+$13*16)&4294967295); //@line 808 "synthesize.cpp"
              var $arraydecay10=(($arrayidx9)&4294967295); //@line 808 "synthesize.cpp"
              $q=$arraydecay10; //@line 808 "synthesize.cpp"
              var $14=$q; //@line 810 "synthesize.cpp"
              var $arrayidx11=(($14)&4294967295); //@line 810 "synthesize.cpp"
              var $15=HEAP32[(($arrayidx11)>>2)]; //@line 810 "synthesize.cpp"
              var $cmp12=((($15))|0)==5; //@line 810 "synthesize.cpp"
              if ($cmp12) { __label__ = 31;break $for_cond$7; } //@line 810 "synthesize.cpp"
  
              var $16=$q; //@line 810 "synthesize.cpp"
              var $arrayidx14=(($16)&4294967295); //@line 810 "synthesize.cpp"
              var $17=HEAP32[(($arrayidx14)>>2)]; //@line 810 "synthesize.cpp"
              var $cmp15=((($17))|0)==6; //@line 810 "synthesize.cpp"
              if ($cmp15) { __label__ = 31;break $for_cond$7; } //@line 810 "synthesize.cpp"
  
              var $18=$q; //@line 813 "synthesize.cpp"
              var $arrayidx18=(($18)&4294967295); //@line 813 "synthesize.cpp"
              var $19=HEAP32[(($arrayidx18)>>2)]; //@line 813 "synthesize.cpp"
              var $cmp19=((($19))|0) <= 4; //@line 813 "synthesize.cpp"
              if ($cmp19) { __label__ = 10;; } else { __label__ = 29;; } //@line 813 "synthesize.cpp"
              $if_then20$$if_end95$14: do { 
                if (__label__ == 10) {
  
                  var $20=$q; //@line 815 "synthesize.cpp"
                  var $arrayidx21=(($20+4)&4294967295); //@line 815 "synthesize.cpp"
                  var $21=HEAP32[(($arrayidx21)>>2)]; //@line 815 "synthesize.cpp"
                  var $and=($21) & 65535; //@line 815 "synthesize.cpp"
                  $len=$and; //@line 815 "synthesize.cpp"
                  var $22=$q; //@line 817 "synthesize.cpp"
                  var $arrayidx22=(($22+12)&4294967295); //@line 817 "synthesize.cpp"
                  var $23=HEAP32[(($arrayidx22)>>2)]; //@line 817 "synthesize.cpp"
                  var $24=($23); //@line 817 "synthesize.cpp"
                  $frame1=$24; //@line 817 "synthesize.cpp"
                  var $25=$frame1; //@line 818 "synthesize.cpp"
                  var $26=$frame; //@line 818 "synthesize.cpp"
                  var $cmp23=((($25))|0)==((($26))|0); //@line 818 "synthesize.cpp"
                  if (!($cmp23)) { __label__ = 31;break $for_cond$7; } //@line 818 "synthesize.cpp"
  
                  var $27=$frame2; //@line 820 "synthesize.cpp"
                  var $28=($27); //@line 820 "synthesize.cpp"
                  var $29=$q; //@line 820 "synthesize.cpp"
                  var $arrayidx25=(($29+12)&4294967295); //@line 820 "synthesize.cpp"
                  HEAP32[(($arrayidx25)>>2)]=$28; //@line 820 "synthesize.cpp"
                  var $30=$frame2; //@line 821 "synthesize.cpp"
                  $frame1=$30; //@line 821 "synthesize.cpp"
                  var $31=$q; //@line 826 "synthesize.cpp"
                  var $arrayidx27=(($31+8)&4294967295); //@line 826 "synthesize.cpp"
                  var $32=HEAP32[(($arrayidx27)>>2)]; //@line 826 "synthesize.cpp"
                  var $33=($32); //@line 826 "synthesize.cpp"
                  $frame2=$33; //@line 826 "synthesize.cpp"
                  $frame=$33; //@line 826 "synthesize.cpp"
                  $modified=0; //@line 827 "synthesize.cpp"
                  var $34=$frame; //@line 829 "synthesize.cpp"
                  var $frflags=(($34)&4294967295); //@line 829 "synthesize.cpp"
                  var $35=HEAP16[(($frflags)>>1)]; //@line 829 "synthesize.cpp"
                  var $conv=(tempInt=(($35)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 829 "synthesize.cpp"
                  var $and28=($conv) & 16; //@line 829 "synthesize.cpp"
                  var $tobool=((($and28))|0)!=0; //@line 829 "synthesize.cpp"
                  if ($tobool) { __label__ = 31;break $for_cond$7; } //@line 829 "synthesize.cpp"
  
                  var $36=$frame; //@line 832 "synthesize.cpp"
                  var $frflags31=(($36)&4294967295); //@line 832 "synthesize.cpp"
                  var $37=HEAP16[(($frflags31)>>1)]; //@line 832 "synthesize.cpp"
                  var $conv32=(tempInt=(($37)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 832 "synthesize.cpp"
                  var $and33=($conv32) & 32; //@line 832 "synthesize.cpp"
                  var $tobool34=((($and33))|0)!=0; //@line 832 "synthesize.cpp"
                  if ($tobool34) { __label__ = 13;; } else { __label__ = 14;; } //@line 832 "synthesize.cpp"
                  if (__label__ == 13) {
  
                    var $38=$len; //@line 833 "synthesize.cpp"
                    var $mul=((($38)*12)&4294967295); //@line 833 "synthesize.cpp"
                    var $div=((((($mul))|0)/10)|0); //@line 833 "synthesize.cpp"
                    $len=$div; //@line 833 "synthesize.cpp"
                    ; //@line 833 "synthesize.cpp"
                  }
  
                  $pk=0; //@line 835 "synthesize.cpp"
                  ; //@line 835 "synthesize.cpp"
                  $for_body$21: while(1) { 
  
                    var $39=$frame; //@line 839 "synthesize.cpp"
                    var $frflags39=(($39)&4294967295); //@line 839 "synthesize.cpp"
                    var $40=HEAP16[(($frflags39)>>1)]; //@line 839 "synthesize.cpp"
                    var $conv40=(tempInt=(($40)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 839 "synthesize.cpp"
                    var $and41=($conv40) & 8; //@line 839 "synthesize.cpp"
                    var $tobool42=((($and41))|0)!=0; //@line 839 "synthesize.cpp"
                    if ($tobool42) { __label__ = 16;; } else { __label__ = 17;; } //@line 839 "synthesize.cpp"
                    $land_lhs_true$$if_end45$23: do { 
                      if (__label__ == 16) {
  
                        var $41=$pk; //@line 839 "synthesize.cpp"
                        var $cmp43=((($41))|0) < 3; //@line 839 "synthesize.cpp"
                        if ($cmp43) { __label__ = 28;break $land_lhs_true$$if_end45$23; } else { __label__ = 17;break $land_lhs_true$$if_end45$23; } //@line 839 "synthesize.cpp"
                      }
                    } while(0);
                    $for_inc$$if_end45$25: do { 
                      if (__label__ == 17) {
  
                        var $42=$pk; //@line 842 "synthesize.cpp"
                        var $43=$frame1; //@line 842 "synthesize.cpp"
                        var $ffreq=(($43+2)&4294967295); //@line 842 "synthesize.cpp"
                        var $arrayidx46=(($ffreq+$42*2)&4294967295); //@line 842 "synthesize.cpp"
                        var $44=HEAP16[(($arrayidx46)>>1)]; //@line 842 "synthesize.cpp"
                        var $conv47=(tempInt=(($44)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 842 "synthesize.cpp"
                        $f1=$conv47; //@line 842 "synthesize.cpp"
                        var $45=$pk; //@line 843 "synthesize.cpp"
                        var $46=$frame; //@line 843 "synthesize.cpp"
                        var $ffreq48=(($46+2)&4294967295); //@line 843 "synthesize.cpp"
                        var $arrayidx49=(($ffreq48+$45*2)&4294967295); //@line 843 "synthesize.cpp"
                        var $47=HEAP16[(($arrayidx49)>>1)]; //@line 843 "synthesize.cpp"
                        var $conv50=(tempInt=(($47)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 843 "synthesize.cpp"
                        $f2=$conv50; //@line 843 "synthesize.cpp"
                        var $48=$f2; //@line 846 "synthesize.cpp"
                        var $49=$f1; //@line 846 "synthesize.cpp"
                        var $sub51=((($48)-($49))&4294967295); //@line 846 "synthesize.cpp"
                        $diff=$sub51; //@line 846 "synthesize.cpp"
                        var $cmp52=((($sub51))|0) > 0; //@line 846 "synthesize.cpp"
                        var $50=$f1; //@line 848 "synthesize.cpp"
                        if ($cmp52) { __label__ = 18;; } else { __label__ = 19;; } //@line 846 "synthesize.cpp"
                        if (__label__ == 18) {
  
                          var $mul54=((($50)*2)&4294967295); //@line 848 "synthesize.cpp"
                          var $51=$f2; //@line 848 "synthesize.cpp"
                          var $add=((($51)+($mul54))&4294967295); //@line 848 "synthesize.cpp"
                          $allowed=$add; //@line 848 "synthesize.cpp"
                          ; //@line 849 "synthesize.cpp"
                        }
                        else if (__label__ == 19) {
  
                          var $52=$f2; //@line 852 "synthesize.cpp"
                          var $mul56=((($52)*2)&4294967295); //@line 852 "synthesize.cpp"
                          var $add57=((($mul56)+($50))&4294967295); //@line 852 "synthesize.cpp"
                          $allowed=$add57; //@line 852 "synthesize.cpp"
                          ;
                        }
  
                        var $53=$allowed; //@line 857 "synthesize.cpp"
                        var $54=$pk; //@line 857 "synthesize.cpp"
                        var $arrayidx59=((_formant_rate+$54*4)&4294967295); //@line 857 "synthesize.cpp"
                        var $55=HEAP32[(($arrayidx59)>>2)]; //@line 857 "synthesize.cpp"
                        var $mul60=((($55)*($53))&4294967295); //@line 857 "synthesize.cpp"
                        var $div61=((((($mul60))|0)/3000)|0); //@line 857 "synthesize.cpp"
                        $allowed=$div61; //@line 857 "synthesize.cpp"
                        var $56=$allowed; //@line 858 "synthesize.cpp"
                        var $57=$len; //@line 858 "synthesize.cpp"
                        var $mul62=((($57)*($56))&4294967295); //@line 858 "synthesize.cpp"
                        var $div63=((((($mul62))|0)/256)|0); //@line 858 "synthesize.cpp"
                        $allowed=$div63; //@line 858 "synthesize.cpp"
                        var $58=$diff; //@line 860 "synthesize.cpp"
                        var $59=$allowed; //@line 860 "synthesize.cpp"
                        var $cmp64=((($58))|0) > ((($59))|0); //@line 860 "synthesize.cpp"
                        if ($cmp64) { __label__ = 21;; } else { __label__ = 24;; } //@line 860 "synthesize.cpp"
                        if (__label__ == 21) {
  
                          var $60=$modified; //@line 862 "synthesize.cpp"
                          var $cmp66=((($60))|0)==0; //@line 862 "synthesize.cpp"
                          if ($cmp66) { __label__ = 22;; } else { __label__ = 23;; } //@line 862 "synthesize.cpp"
                          if (__label__ == 22) {
  
                            var $61=$frame; //@line 864 "synthesize.cpp"
                            var $call=__ZL9CopyFrameP7frame_ti($61, 0); //@line 864 "synthesize.cpp"
                            $frame2=$call; //@line 864 "synthesize.cpp"
                            $modified=1; //@line 865 "synthesize.cpp"
                            ; //@line 866 "synthesize.cpp"
                          }
  
                          var $62=$pk; //@line 867 "synthesize.cpp"
                          var $63=$frame1; //@line 867 "synthesize.cpp"
                          var $ffreq69=(($63+2)&4294967295); //@line 867 "synthesize.cpp"
                          var $arrayidx70=(($ffreq69+$62*2)&4294967295); //@line 867 "synthesize.cpp"
                          var $64=HEAP16[(($arrayidx70)>>1)]; //@line 867 "synthesize.cpp"
                          var $conv71=(tempInt=(($64)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 867 "synthesize.cpp"
                          var $65=$allowed; //@line 867 "synthesize.cpp"
                          var $add72=((($conv71)+($65))&4294967295); //@line 867 "synthesize.cpp"
                          var $conv73=((($add72)) & 65535); //@line 867 "synthesize.cpp"
                          var $66=$pk; //@line 867 "synthesize.cpp"
                          var $67=$frame2; //@line 867 "synthesize.cpp"
                          var $ffreq74=(($67+2)&4294967295); //@line 867 "synthesize.cpp"
                          var $arrayidx75=(($ffreq74+$66*2)&4294967295); //@line 867 "synthesize.cpp"
                          HEAP16[(($arrayidx75)>>1)]=$conv73; //@line 867 "synthesize.cpp"
                          var $68=$frame2; //@line 868 "synthesize.cpp"
                          var $69=($68); //@line 868 "synthesize.cpp"
                          var $70=$q; //@line 868 "synthesize.cpp"
                          var $arrayidx76=(($70+8)&4294967295); //@line 868 "synthesize.cpp"
                          HEAP32[(($arrayidx76)>>2)]=$69; //@line 868 "synthesize.cpp"
                          ; //@line 869 "synthesize.cpp"
                        }
                        else if (__label__ == 24) {
  
                          var $71=$diff; //@line 871 "synthesize.cpp"
                          var $72=$allowed; //@line 871 "synthesize.cpp"
                          var $sub78=(((-($72)))&4294967295); //@line 871 "synthesize.cpp"
                          var $cmp79=((($71))|0) < ((($sub78))|0); //@line 871 "synthesize.cpp"
                          if (!($cmp79)) { __label__ = 28;break $for_inc$$if_end45$25; } //@line 871 "synthesize.cpp"
  
                          var $73=$modified; //@line 873 "synthesize.cpp"
                          var $cmp81=((($73))|0)==0; //@line 873 "synthesize.cpp"
                          if ($cmp81) { __label__ = 26;; } else { __label__ = 27;; } //@line 873 "synthesize.cpp"
                          if (__label__ == 26) {
  
                            var $74=$frame; //@line 875 "synthesize.cpp"
                            var $call83=__ZL9CopyFrameP7frame_ti($74, 0); //@line 875 "synthesize.cpp"
                            $frame2=$call83; //@line 875 "synthesize.cpp"
                            $modified=1; //@line 876 "synthesize.cpp"
                            ; //@line 877 "synthesize.cpp"
                          }
  
                          var $75=$pk; //@line 878 "synthesize.cpp"
                          var $76=$frame1; //@line 878 "synthesize.cpp"
                          var $ffreq85=(($76+2)&4294967295); //@line 878 "synthesize.cpp"
                          var $arrayidx86=(($ffreq85+$75*2)&4294967295); //@line 878 "synthesize.cpp"
                          var $77=HEAP16[(($arrayidx86)>>1)]; //@line 878 "synthesize.cpp"
                          var $conv87=(tempInt=(($77)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 878 "synthesize.cpp"
                          var $78=$allowed; //@line 878 "synthesize.cpp"
                          var $sub88=((($conv87)-($78))&4294967295); //@line 878 "synthesize.cpp"
                          var $conv89=((($sub88)) & 65535); //@line 878 "synthesize.cpp"
                          var $79=$pk; //@line 878 "synthesize.cpp"
                          var $80=$frame2; //@line 878 "synthesize.cpp"
                          var $ffreq90=(($80+2)&4294967295); //@line 878 "synthesize.cpp"
                          var $arrayidx91=(($ffreq90+$79*2)&4294967295); //@line 878 "synthesize.cpp"
                          HEAP16[(($arrayidx91)>>1)]=$conv89; //@line 878 "synthesize.cpp"
                          var $81=$frame2; //@line 879 "synthesize.cpp"
                          var $82=($81); //@line 879 "synthesize.cpp"
                          var $83=$q; //@line 879 "synthesize.cpp"
                          var $arrayidx92=(($83+8)&4294967295); //@line 879 "synthesize.cpp"
                          HEAP32[(($arrayidx92)>>2)]=$82; //@line 879 "synthesize.cpp"
                          ; //@line 880 "synthesize.cpp"
                        }
                      }
                    } while(0);
  
                    var $84=$pk; //@line 835 "synthesize.cpp"
                    var $inc=((($84)+1)&4294967295); //@line 835 "synthesize.cpp"
                    $pk=$inc; //@line 835 "synthesize.cpp"
                    var $cmp38=((($inc))|0) < 6; //@line 835 "synthesize.cpp"
                    if ($cmp38) { __label__ = 15;continue $for_body$21; } else { __label__ = 29;break $if_then20$$if_end95$14; } //@line 835 "synthesize.cpp"
                  }
                }
              } while(0);
  
              var $85=$ix; //@line 884 "synthesize.cpp"
              var $86=HEAP32[((__ZL14syllable_start)>>2)]; //@line 884 "synthesize.cpp"
              var $cmp96=((($85))|0)==((($86))|0); //@line 884 "synthesize.cpp"
              if ($cmp96) { __label__ = 31;break $for_cond$7; } //@line 884 "synthesize.cpp"
  
              var $87=$ix; //@line 886 "synthesize.cpp"
              var $dec=((($87)-1)&4294967295); //@line 886 "synthesize.cpp"
              $ix=$dec; //@line 886 "synthesize.cpp"
              __lastLabel__ = 30; __label__ = 5;continue $for_cond$7; //@line 887 "synthesize.cpp"
            }
  
            var $88=HEAP32[((__ZL15syllable_centre)>>2)]; //@line 890 "synthesize.cpp"
            $ix=$88; //@line 890 "synthesize.cpp"
            $frame=0; //@line 892 "synthesize.cpp"
            ; //@line 893 "synthesize.cpp"
            $for_cond100$45: while(1) { 
  
              var $89=$ix; //@line 895 "synthesize.cpp"
              var $arrayidx101=((_wcmdq+$89*16)&4294967295); //@line 895 "synthesize.cpp"
              var $arraydecay102=(($arrayidx101)&4294967295); //@line 895 "synthesize.cpp"
              $q=$arraydecay102; //@line 895 "synthesize.cpp"
              var $90=$q; //@line 897 "synthesize.cpp"
              var $arrayidx103=(($90)&4294967295); //@line 897 "synthesize.cpp"
              var $91=HEAP32[(($arrayidx103)>>2)]; //@line 897 "synthesize.cpp"
              var $cmp104=((($91))|0)==5; //@line 897 "synthesize.cpp"
              if ($cmp104) { __label__ = 57;break $for_cond100$45; } //@line 897 "synthesize.cpp"
  
              var $92=$q; //@line 897 "synthesize.cpp"
              var $arrayidx106=(($92)&4294967295); //@line 897 "synthesize.cpp"
              var $93=HEAP32[(($arrayidx106)>>2)]; //@line 897 "synthesize.cpp"
              var $cmp107=((($93))|0)==6; //@line 897 "synthesize.cpp"
              if ($cmp107) { __label__ = 57;break $for_cond100$45; } //@line 897 "synthesize.cpp"
  
              var $94=$q; //@line 900 "synthesize.cpp"
              var $arrayidx110=(($94)&4294967295); //@line 900 "synthesize.cpp"
              var $95=HEAP32[(($arrayidx110)>>2)]; //@line 900 "synthesize.cpp"
              var $cmp111=((($95))|0) <= 4; //@line 900 "synthesize.cpp"
              if ($cmp111) { __label__ = 35;; } else { __label__ = 54;; } //@line 900 "synthesize.cpp"
              $if_then112$$if_end199$49: do { 
                if (__label__ == 35) {
  
                  var $96=$q; //@line 903 "synthesize.cpp"
                  var $arrayidx113=(($96+4)&4294967295); //@line 903 "synthesize.cpp"
                  var $97=HEAP32[(($arrayidx113)>>2)]; //@line 903 "synthesize.cpp"
                  var $and114=($97) & 65535; //@line 903 "synthesize.cpp"
                  $len=$and114; //@line 903 "synthesize.cpp"
                  var $98=$q; //@line 905 "synthesize.cpp"
                  var $arrayidx115=(($98+8)&4294967295); //@line 905 "synthesize.cpp"
                  var $99=HEAP32[(($arrayidx115)>>2)]; //@line 905 "synthesize.cpp"
                  var $100=($99); //@line 905 "synthesize.cpp"
                  $frame1=$100; //@line 905 "synthesize.cpp"
                  var $101=$frame; //@line 906 "synthesize.cpp"
                  var $cmp116=((($101))|0)!=0; //@line 906 "synthesize.cpp"
                  if ($cmp116) { __label__ = 36;; } else { __label__ = 38;; } //@line 906 "synthesize.cpp"
                  if (__label__ == 36) {
  
                    var $102=$frame1; //@line 908 "synthesize.cpp"
                    var $103=$frame; //@line 908 "synthesize.cpp"
                    var $cmp118=((($102))|0)==((($103))|0); //@line 908 "synthesize.cpp"
                    if (!($cmp118)) { __label__ = 57;break $for_cond100$45; } //@line 908 "synthesize.cpp"
  
                    var $104=$frame2; //@line 910 "synthesize.cpp"
                    var $105=($104); //@line 910 "synthesize.cpp"
                    var $106=$q; //@line 910 "synthesize.cpp"
                    var $arrayidx120=(($106+8)&4294967295); //@line 910 "synthesize.cpp"
                    HEAP32[(($arrayidx120)>>2)]=$105; //@line 910 "synthesize.cpp"
                    var $107=$frame2; //@line 911 "synthesize.cpp"
                    $frame1=$107; //@line 911 "synthesize.cpp"
                    ; //@line 915 "synthesize.cpp"
                  }
  
                  var $108=$q; //@line 917 "synthesize.cpp"
                  var $arrayidx124=(($108+12)&4294967295); //@line 917 "synthesize.cpp"
                  var $109=HEAP32[(($arrayidx124)>>2)]; //@line 917 "synthesize.cpp"
                  var $110=($109); //@line 917 "synthesize.cpp"
                  $frame2=$110; //@line 917 "synthesize.cpp"
                  $frame=$110; //@line 917 "synthesize.cpp"
                  $modified=0; //@line 918 "synthesize.cpp"
                  var $111=$frame1; //@line 920 "synthesize.cpp"
                  var $frflags125=(($111)&4294967295); //@line 920 "synthesize.cpp"
                  var $112=HEAP16[(($frflags125)>>1)]; //@line 920 "synthesize.cpp"
                  var $conv126=(tempInt=(($112)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 920 "synthesize.cpp"
                  var $and127=($conv126) & 16; //@line 920 "synthesize.cpp"
                  var $tobool128=((($and127))|0)!=0; //@line 920 "synthesize.cpp"
                  if ($tobool128) { __label__ = 57;break $for_cond100$45; } //@line 920 "synthesize.cpp"
  
                  var $113=$frame1; //@line 923 "synthesize.cpp"
                  var $frflags131=(($113)&4294967295); //@line 923 "synthesize.cpp"
                  var $114=HEAP16[(($frflags131)>>1)]; //@line 923 "synthesize.cpp"
                  var $conv132=(tempInt=(($114)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 923 "synthesize.cpp"
                  var $and133=($conv132) & 32; //@line 923 "synthesize.cpp"
                  var $tobool134=((($and133))|0)!=0; //@line 923 "synthesize.cpp"
                  if ($tobool134) { __label__ = 40;; } else { __label__ = 41;; } //@line 923 "synthesize.cpp"
                  if (__label__ == 40) {
  
                    var $115=$len; //@line 924 "synthesize.cpp"
                    var $mul136=((($115)*6)&4294967295); //@line 924 "synthesize.cpp"
                    var $div137=((((($mul136))|0)/5)|0); //@line 924 "synthesize.cpp"
                    $len=$div137; //@line 924 "synthesize.cpp"
                    ; //@line 924 "synthesize.cpp"
                  }
  
                  $pk=0; //@line 926 "synthesize.cpp"
                  ; //@line 926 "synthesize.cpp"
                  $for_body141$59: while(1) { 
  
                    var $116=$pk; //@line 929 "synthesize.cpp"
                    var $117=$frame1; //@line 929 "synthesize.cpp"
                    var $ffreq144=(($117+2)&4294967295); //@line 929 "synthesize.cpp"
                    var $arrayidx145=(($ffreq144+$116*2)&4294967295); //@line 929 "synthesize.cpp"
                    var $118=HEAP16[(($arrayidx145)>>1)]; //@line 929 "synthesize.cpp"
                    var $conv146=(tempInt=(($118)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 929 "synthesize.cpp"
                    $f1142=$conv146; //@line 929 "synthesize.cpp"
                    var $119=$pk; //@line 930 "synthesize.cpp"
                    var $120=$frame; //@line 930 "synthesize.cpp"
                    var $ffreq147=(($120+2)&4294967295); //@line 930 "synthesize.cpp"
                    var $arrayidx148=(($ffreq147+$119*2)&4294967295); //@line 930 "synthesize.cpp"
                    var $121=HEAP16[(($arrayidx148)>>1)]; //@line 930 "synthesize.cpp"
                    var $conv149=(tempInt=(($121)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 930 "synthesize.cpp"
                    $f2143=$conv149; //@line 930 "synthesize.cpp"
                    var $122=$f2143; //@line 933 "synthesize.cpp"
                    var $123=$f1142; //@line 933 "synthesize.cpp"
                    var $sub150=((($122)-($123))&4294967295); //@line 933 "synthesize.cpp"
                    $diff=$sub150; //@line 933 "synthesize.cpp"
                    var $cmp151=((($sub150))|0) > 0; //@line 933 "synthesize.cpp"
                    var $124=$f1142; //@line 935 "synthesize.cpp"
                    if ($cmp151) { __label__ = 43;; } else { __label__ = 44;; } //@line 933 "synthesize.cpp"
                    if (__label__ == 43) {
  
                      var $mul153=((($124)*2)&4294967295); //@line 935 "synthesize.cpp"
                      var $125=$f2143; //@line 935 "synthesize.cpp"
                      var $add154=((($125)+($mul153))&4294967295); //@line 935 "synthesize.cpp"
                      $allowed=$add154; //@line 935 "synthesize.cpp"
                      ; //@line 936 "synthesize.cpp"
                    }
                    else if (__label__ == 44) {
  
                      var $126=$f2143; //@line 939 "synthesize.cpp"
                      var $mul156=((($126)*2)&4294967295); //@line 939 "synthesize.cpp"
                      var $add157=((($mul156)+($124))&4294967295); //@line 939 "synthesize.cpp"
                      $allowed=$add157; //@line 939 "synthesize.cpp"
                      ;
                    }
  
                    var $127=$allowed; //@line 941 "synthesize.cpp"
                    var $128=$pk; //@line 941 "synthesize.cpp"
                    var $arrayidx159=((_formant_rate+$128*4)&4294967295); //@line 941 "synthesize.cpp"
                    var $129=HEAP32[(($arrayidx159)>>2)]; //@line 941 "synthesize.cpp"
                    var $mul160=((($129)*($127))&4294967295); //@line 941 "synthesize.cpp"
                    var $div161=((((($mul160))|0)/3000)|0); //@line 941 "synthesize.cpp"
                    $allowed=$div161; //@line 941 "synthesize.cpp"
                    var $130=$allowed; //@line 942 "synthesize.cpp"
                    var $131=$len; //@line 942 "synthesize.cpp"
                    var $mul162=((($131)*($130))&4294967295); //@line 942 "synthesize.cpp"
                    var $div163=((((($mul162))|0)/256)|0); //@line 942 "synthesize.cpp"
                    $allowed=$div163; //@line 942 "synthesize.cpp"
                    var $132=$diff; //@line 944 "synthesize.cpp"
                    var $133=$allowed; //@line 944 "synthesize.cpp"
                    var $cmp164=((($132))|0) > ((($133))|0); //@line 944 "synthesize.cpp"
                    if ($cmp164) { __label__ = 46;; } else { __label__ = 49;; } //@line 944 "synthesize.cpp"
                    $if_then165$$if_else178$65: do { 
                      if (__label__ == 46) {
  
                        var $134=$modified; //@line 946 "synthesize.cpp"
                        var $cmp166=((($134))|0)==0; //@line 946 "synthesize.cpp"
                        if ($cmp166) { __label__ = 47;; } else { __label__ = 48;; } //@line 946 "synthesize.cpp"
                        if (__label__ == 47) {
  
                          var $135=$frame; //@line 948 "synthesize.cpp"
                          var $call168=__ZL9CopyFrameP7frame_ti($135, 0); //@line 948 "synthesize.cpp"
                          $frame2=$call168; //@line 948 "synthesize.cpp"
                          $modified=1; //@line 949 "synthesize.cpp"
                          ; //@line 950 "synthesize.cpp"
                        }
  
                        var $136=$pk; //@line 951 "synthesize.cpp"
                        var $137=$frame1; //@line 951 "synthesize.cpp"
                        var $ffreq170=(($137+2)&4294967295); //@line 951 "synthesize.cpp"
                        var $arrayidx171=(($ffreq170+$136*2)&4294967295); //@line 951 "synthesize.cpp"
                        var $138=HEAP16[(($arrayidx171)>>1)]; //@line 951 "synthesize.cpp"
                        var $conv172=(tempInt=(($138)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 951 "synthesize.cpp"
                        var $139=$allowed; //@line 951 "synthesize.cpp"
                        var $add173=((($conv172)+($139))&4294967295); //@line 951 "synthesize.cpp"
                        var $conv174=((($add173)) & 65535); //@line 951 "synthesize.cpp"
                        var $140=$pk; //@line 951 "synthesize.cpp"
                        var $141=$frame2; //@line 951 "synthesize.cpp"
                        var $ffreq175=(($141+2)&4294967295); //@line 951 "synthesize.cpp"
                        var $arrayidx176=(($ffreq175+$140*2)&4294967295); //@line 951 "synthesize.cpp"
                        HEAP16[(($arrayidx176)>>1)]=$conv174; //@line 951 "synthesize.cpp"
                        var $142=$frame2; //@line 952 "synthesize.cpp"
                        var $143=($142); //@line 952 "synthesize.cpp"
                        var $144=$q; //@line 952 "synthesize.cpp"
                        var $arrayidx177=(($144+12)&4294967295); //@line 952 "synthesize.cpp"
                        HEAP32[(($arrayidx177)>>2)]=$143; //@line 952 "synthesize.cpp"
                        ; //@line 953 "synthesize.cpp"
                      }
                      else if (__label__ == 49) {
  
                        var $145=$diff; //@line 955 "synthesize.cpp"
                        var $146=$allowed; //@line 955 "synthesize.cpp"
                        var $sub179=(((-($146)))&4294967295); //@line 955 "synthesize.cpp"
                        var $cmp180=((($145))|0) < ((($sub179))|0); //@line 955 "synthesize.cpp"
                        if (!($cmp180)) { __label__ = 53;break $if_then165$$if_else178$65; } //@line 955 "synthesize.cpp"
  
                        var $147=$modified; //@line 957 "synthesize.cpp"
                        var $cmp182=((($147))|0)==0; //@line 957 "synthesize.cpp"
                        if ($cmp182) { __label__ = 51;; } else { __label__ = 52;; } //@line 957 "synthesize.cpp"
                        if (__label__ == 51) {
  
                          var $148=$frame; //@line 959 "synthesize.cpp"
                          var $call184=__ZL9CopyFrameP7frame_ti($148, 0); //@line 959 "synthesize.cpp"
                          $frame2=$call184; //@line 959 "synthesize.cpp"
                          $modified=1; //@line 960 "synthesize.cpp"
                          ; //@line 961 "synthesize.cpp"
                        }
  
                        var $149=$pk; //@line 962 "synthesize.cpp"
                        var $150=$frame1; //@line 962 "synthesize.cpp"
                        var $ffreq186=(($150+2)&4294967295); //@line 962 "synthesize.cpp"
                        var $arrayidx187=(($ffreq186+$149*2)&4294967295); //@line 962 "synthesize.cpp"
                        var $151=HEAP16[(($arrayidx187)>>1)]; //@line 962 "synthesize.cpp"
                        var $conv188=(tempInt=(($151)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 962 "synthesize.cpp"
                        var $152=$allowed; //@line 962 "synthesize.cpp"
                        var $sub189=((($conv188)-($152))&4294967295); //@line 962 "synthesize.cpp"
                        var $conv190=((($sub189)) & 65535); //@line 962 "synthesize.cpp"
                        var $153=$pk; //@line 962 "synthesize.cpp"
                        var $154=$frame2; //@line 962 "synthesize.cpp"
                        var $ffreq191=(($154+2)&4294967295); //@line 962 "synthesize.cpp"
                        var $arrayidx192=(($ffreq191+$153*2)&4294967295); //@line 962 "synthesize.cpp"
                        HEAP16[(($arrayidx192)>>1)]=$conv190; //@line 962 "synthesize.cpp"
                        var $155=$frame2; //@line 963 "synthesize.cpp"
                        var $156=($155); //@line 963 "synthesize.cpp"
                        var $157=$q; //@line 963 "synthesize.cpp"
                        var $arrayidx193=(($157+12)&4294967295); //@line 963 "synthesize.cpp"
                        HEAP32[(($arrayidx193)>>2)]=$156; //@line 963 "synthesize.cpp"
                        ; //@line 964 "synthesize.cpp"
                      }
                    } while(0);
  
                    var $158=$pk; //@line 926 "synthesize.cpp"
                    var $inc197=((($158)+1)&4294967295); //@line 926 "synthesize.cpp"
                    $pk=$inc197; //@line 926 "synthesize.cpp"
                    var $cmp140=((($inc197))|0) < 6; //@line 926 "synthesize.cpp"
                    if ($cmp140) { __label__ = 42;continue $for_body141$59; } else { __label__ = 54;break $if_then112$$if_end199$49; } //@line 926 "synthesize.cpp"
                  }
                }
              } while(0);
  
              var $159=$ix; //@line 968 "synthesize.cpp"
              var $inc200=((($159)+1)&4294967295); //@line 968 "synthesize.cpp"
              $ix=$inc200; //@line 968 "synthesize.cpp"
              var $cmp201=((($inc200))|0) >= 160; //@line 969 "synthesize.cpp"
              if ($cmp201) { __label__ = 55;; } else { __label__ = 56;; } //@line 969 "synthesize.cpp"
              if (__label__ == 55) {
  
                $ix=0; //@line 969 "synthesize.cpp"
                ; //@line 969 "synthesize.cpp"
              }
  
              var $160=$ix; //@line 970 "synthesize.cpp"
              var $161=HEAP32[((__ZL12syllable_end)>>2)]; //@line 970 "synthesize.cpp"
              var $cmp204=((($160))|0)==((($161))|0); //@line 970 "synthesize.cpp"
              if ($cmp204) { __label__ = 57;break $for_cond100$45; } else { __label__ = 32;continue $for_cond100$45; } //@line 970 "synthesize.cpp"
            }
  
            var $162=HEAP32[((__ZL12syllable_end)>>2)]; //@line 974 "synthesize.cpp"
            HEAP32[((__ZL14syllable_start)>>2)]=$162; //@line 974 "synthesize.cpp"
            __label__ = 58;break $return$$if_end$2; //@line 975 "synthesize.cpp"
          }
        } while(0);
  
        var $5=HEAP32[((__ZL12syllable_end)>>2)]; //@line 795 "synthesize.cpp"
        HEAP32[((__ZL14syllable_start)>>2)]=$5; //@line 795 "synthesize.cpp"
        ; //@line 796 "synthesize.cpp"
      }
    } while(0);
  
    ;
    return; //@line 975 "synthesize.cpp"
    return;
  }
  

  function __Z8DoMarkeriiii($type, $char_posn, $length, $value) {
    ;
    var __label__;
  
    var $type_addr;
    var $char_posn_addr;
    var $length_addr;
    var $value_addr;
    $type_addr=$type;
    $char_posn_addr=$char_posn;
    $length_addr=$length;
    $value_addr=$value;
    var $0=HEAP32[((_wcmdq_tail)>>2)]; //@line 1212 "synthesize.cpp"
    var $arrayidx=((_wcmdq+$0*16)&4294967295); //@line 1212 "synthesize.cpp"
    var $arrayidx1=(($arrayidx)&4294967295); //@line 1212 "synthesize.cpp"
    HEAP32[(($arrayidx1)>>2)]=10; //@line 1212 "synthesize.cpp"
    var $1=$type_addr; //@line 1213 "synthesize.cpp"
    var $2=HEAP32[((_wcmdq_tail)>>2)]; //@line 1213 "synthesize.cpp"
    var $arrayidx2=((_wcmdq+$2*16)&4294967295); //@line 1213 "synthesize.cpp"
    var $arrayidx3=(($arrayidx2+4)&4294967295); //@line 1213 "synthesize.cpp"
    HEAP32[(($arrayidx3)>>2)]=$1; //@line 1213 "synthesize.cpp"
    var $3=$char_posn_addr; //@line 1214 "synthesize.cpp"
    var $and=($3) & 16777215; //@line 1214 "synthesize.cpp"
    var $4=$length_addr; //@line 1214 "synthesize.cpp"
    var $shl=($4) << 24; //@line 1214 "synthesize.cpp"
    var $or=($shl) | ($and); //@line 1214 "synthesize.cpp"
    var $5=HEAP32[((_wcmdq_tail)>>2)]; //@line 1214 "synthesize.cpp"
    var $arrayidx4=((_wcmdq+$5*16)&4294967295); //@line 1214 "synthesize.cpp"
    var $arrayidx5=(($arrayidx4+8)&4294967295); //@line 1214 "synthesize.cpp"
    HEAP32[(($arrayidx5)>>2)]=$or; //@line 1214 "synthesize.cpp"
    var $6=$value_addr; //@line 1215 "synthesize.cpp"
    var $7=HEAP32[((_wcmdq_tail)>>2)]; //@line 1215 "synthesize.cpp"
    var $arrayidx6=((_wcmdq+$7*16)&4294967295); //@line 1215 "synthesize.cpp"
    var $arrayidx7=(($arrayidx6+12)&4294967295); //@line 1215 "synthesize.cpp"
    HEAP32[(($arrayidx7)>>2)]=$6; //@line 1215 "synthesize.cpp"
    __Z8WcmdqIncv(); //@line 1216 "synthesize.cpp"
    ;
    return; //@line 1218 "synthesize.cpp"
    return;
  }
  

  function __Z12DoSonicSpeedi($value) {
    ;
    var __label__;
  
    var $value_addr;
    $value_addr=$value;
    var $0=HEAP32[((_wcmdq_tail)>>2)]; //@line 1224 "synthesize.cpp"
    var $arrayidx=((_wcmdq+$0*16)&4294967295); //@line 1224 "synthesize.cpp"
    var $arrayidx1=(($arrayidx)&4294967295); //@line 1224 "synthesize.cpp"
    HEAP32[(($arrayidx1)>>2)]=15; //@line 1224 "synthesize.cpp"
    var $1=$value_addr; //@line 1225 "synthesize.cpp"
    var $2=HEAP32[((_wcmdq_tail)>>2)]; //@line 1225 "synthesize.cpp"
    var $arrayidx2=((_wcmdq+$2*16)&4294967295); //@line 1225 "synthesize.cpp"
    var $arrayidx3=(($arrayidx2+4)&4294967295); //@line 1225 "synthesize.cpp"
    HEAP32[(($arrayidx3)>>2)]=$1; //@line 1225 "synthesize.cpp"
    __Z8WcmdqIncv(); //@line 1226 "synthesize.cpp"
    ;
    return; //@line 1227 "synthesize.cpp"
    return;
  }
  

  function __Z13DoVoiceChangeP7voice_t($v) {
    ;
    var __label__;
  
    var $v_addr;
    var $v2;
    $v_addr=$v;
    var $call=_malloc(1344); //@line 1235 "synthesize.cpp"
    var $0=$call; //@line 1235 "synthesize.cpp"
    $v2=$0; //@line 1235 "synthesize.cpp"
    var $1=$v2; //@line 1236 "synthesize.cpp"
    var $2=$1; //@line 1236 "synthesize.cpp"
    var $3=$v_addr; //@line 1236 "synthesize.cpp"
    var $4=$3; //@line 1236 "synthesize.cpp"
    var $src$, $dest$, $stop$, $stop4$, $fast$;
    $src$ = $4;
    $dest$ = $2;
    $stop$ = $src$ + 1344;
    if (($dest$%4) == ($src$%4) && 1344 > 8) {
      while ($src$%4 !== 0 && $src$ < $stop$) {
        ; HEAP8[$dest$++] = HEAP8[$src$++];
      }
      $src$ >>= 2;
      $dest$ >>= 2;
      $stop4$ = $stop$ >> 2;
      while ($src$ < $stop4$) {
    ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
      }
      $src$ <<= 2;
      $dest$ <<= 2;
    }while ($src$ < $stop$) {
      ; HEAP8[$dest$++] = HEAP8[$src$++];
    }; //@line 1236 "synthesize.cpp"
    var $5=HEAP32[((_wcmdq_tail)>>2)]; //@line 1237 "synthesize.cpp"
    var $arrayidx=((_wcmdq+$5*16)&4294967295); //@line 1237 "synthesize.cpp"
    var $arrayidx1=(($arrayidx)&4294967295); //@line 1237 "synthesize.cpp"
    HEAP32[(($arrayidx1)>>2)]=11; //@line 1237 "synthesize.cpp"
    var $6=$v2; //@line 1238 "synthesize.cpp"
    var $7=($6); //@line 1238 "synthesize.cpp"
    var $8=HEAP32[((_wcmdq_tail)>>2)]; //@line 1238 "synthesize.cpp"
    var $arrayidx2=((_wcmdq+$8*16)&4294967295); //@line 1238 "synthesize.cpp"
    var $arrayidx3=(($arrayidx2+4)&4294967295); //@line 1238 "synthesize.cpp"
    HEAP32[(($arrayidx3)>>2)]=$7; //@line 1238 "synthesize.cpp"
    __Z8WcmdqIncv(); //@line 1239 "synthesize.cpp"
    ;
    return; //@line 1240 "synthesize.cpp"
    return;
  }
  

  function __Z10DoEmbeddedPii($embix, $sourceix) {
    ;
    var __label__;
  
    var $embix_addr;
    var $sourceix_addr;
    var $word;
    var $value;
    var $command;
    $embix_addr=$embix;
    $sourceix_addr=$sourceix;
    ; //@line 1250 "synthesize.cpp"
    $do_body$2: while(1) { 
  
      var $0=$embix_addr; //@line 1251 "synthesize.cpp"
      var $1=HEAP32[(($0)>>2)]; //@line 1251 "synthesize.cpp"
      var $arrayidx=((_embedded_list+$1*4)&4294967295); //@line 1251 "synthesize.cpp"
      var $2=HEAP32[(($arrayidx)>>2)]; //@line 1251 "synthesize.cpp"
      $word=$2; //@line 1251 "synthesize.cpp"
      var $3=$word; //@line 1252 "synthesize.cpp"
      var $shr=($3) >>> 8; //@line 1252 "synthesize.cpp"
      $value=$shr; //@line 1252 "synthesize.cpp"
      var $4=$word; //@line 1253 "synthesize.cpp"
      var $and=($4) & 127; //@line 1253 "synthesize.cpp"
      $command=$and; //@line 1253 "synthesize.cpp"
      var $cmp=((($and))|0)==0; //@line 1255 "synthesize.cpp"
      if ($cmp) { __label__ = 11;break $do_body$2; } //@line 1255 "synthesize.cpp"
  
      var $5=$embix_addr; //@line 1258 "synthesize.cpp"
      var $6=HEAP32[(($5)>>2)]; //@line 1258 "synthesize.cpp"
      var $inc=((($6)+1)&4294967295); //@line 1258 "synthesize.cpp"
      HEAP32[(($5)>>2)]=$inc; //@line 1258 "synthesize.cpp"
      var $7=$command; //@line 1260 "synthesize.cpp"
      var $and1=($7) & 31; //@line 1260 "synthesize.cpp"
      if ($and1 == 2) {
        __label__ = 3;;
      }
      else if ($and1 == 7) {
        __label__ = 4;;
      }
      else if ($and1 == 10) {
        __label__ = 7;;
      }
      else if ($and1 == 11) {
        __label__ = 8;;
      }
      else {
      __label__ = 9;;
      }
      
      $sw_default$$sw_bb$$sw_bb3$$sw_bb23$$sw_bb26$5: do { 
        if (__label__ == 9) {
  
          __ZL7DoPauseii(10, 0); //@line 1291 "synthesize.cpp"
          var $28=HEAP32[((_wcmdq_tail)>>2)]; //@line 1292 "synthesize.cpp"
          var $arrayidx28=((_wcmdq+$28*16)&4294967295); //@line 1292 "synthesize.cpp"
          var $arrayidx29=(($arrayidx28)&4294967295); //@line 1292 "synthesize.cpp"
          HEAP32[(($arrayidx29)>>2)]=12; //@line 1292 "synthesize.cpp"
          var $29=$command; //@line 1293 "synthesize.cpp"
          var $30=HEAP32[((_wcmdq_tail)>>2)]; //@line 1293 "synthesize.cpp"
          var $arrayidx30=((_wcmdq+$30*16)&4294967295); //@line 1293 "synthesize.cpp"
          var $arrayidx31=(($arrayidx30+4)&4294967295); //@line 1293 "synthesize.cpp"
          HEAP32[(($arrayidx31)>>2)]=$29; //@line 1293 "synthesize.cpp"
          var $31=$value; //@line 1294 "synthesize.cpp"
          var $32=HEAP32[((_wcmdq_tail)>>2)]; //@line 1294 "synthesize.cpp"
          var $arrayidx32=((_wcmdq+$32*16)&4294967295); //@line 1294 "synthesize.cpp"
          var $arrayidx33=(($arrayidx32+8)&4294967295); //@line 1294 "synthesize.cpp"
          HEAP32[(($arrayidx33)>>2)]=$31; //@line 1294 "synthesize.cpp"
          __Z8WcmdqIncv(); //@line 1295 "synthesize.cpp"
          ; //@line 1296 "synthesize.cpp"
        }
        else if (__label__ == 3) {
  
          var $8=$command; //@line 1263 "synthesize.cpp"
          var $and2=($8) & 96; //@line 1263 "synthesize.cpp"
          var $add=((($and2)+8)&4294967295); //@line 1263 "synthesize.cpp"
          var $9=$value; //@line 1263 "synthesize.cpp"
          __Z11SetEmbeddedii($add, $9); //@line 1263 "synthesize.cpp"
          __Z8SetSpeedi(2); //@line 1264 "synthesize.cpp"
          ; //@line 1265 "synthesize.cpp"
        }
        else if (__label__ == 4) {
  
          var $10=$value; //@line 1268 "synthesize.cpp"
          var $11=HEAP32[((_n_soundicon_tab)>>2)]; //@line 1268 "synthesize.cpp"
          var $cmp4=((($10))|0) < ((($11))|0); //@line 1268 "synthesize.cpp"
          if (!($cmp4)) { __label__ = 10;break $sw_default$$sw_bb$$sw_bb3$$sw_bb23$$sw_bb26$5; } //@line 1268 "synthesize.cpp"
  
          var $12=$value; //@line 1270 "synthesize.cpp"
          var $arrayidx6=((_soundicon_tab+$12*16)&4294967295); //@line 1270 "synthesize.cpp"
          var $length=(($arrayidx6+4)&4294967295); //@line 1270 "synthesize.cpp"
          var $13=HEAP32[(($length)>>2)]; //@line 1270 "synthesize.cpp"
          var $cmp7=((($13))|0)!=0; //@line 1270 "synthesize.cpp"
          if (!($cmp7)) { __label__ = 10;break $sw_default$$sw_bb$$sw_bb3$$sw_bb23$$sw_bb26$5; } //@line 1270 "synthesize.cpp"
  
          __ZL7DoPauseii(10, 0); //@line 1272 "synthesize.cpp"
          var $14=HEAP32[((_wcmdq_tail)>>2)]; //@line 1273 "synthesize.cpp"
          var $arrayidx9=((_wcmdq+$14*16)&4294967295); //@line 1273 "synthesize.cpp"
          var $arrayidx10=(($arrayidx9)&4294967295); //@line 1273 "synthesize.cpp"
          HEAP32[(($arrayidx10)>>2)]=6; //@line 1273 "synthesize.cpp"
          var $15=$value; //@line 1274 "synthesize.cpp"
          var $arrayidx11=((_soundicon_tab+$15*16)&4294967295); //@line 1274 "synthesize.cpp"
          var $length12=(($arrayidx11+4)&4294967295); //@line 1274 "synthesize.cpp"
          var $16=HEAP32[(($length12)>>2)]; //@line 1274 "synthesize.cpp"
          var $17=HEAP32[((_wcmdq_tail)>>2)]; //@line 1274 "synthesize.cpp"
          var $arrayidx13=((_wcmdq+$17*16)&4294967295); //@line 1274 "synthesize.cpp"
          var $arrayidx14=(($arrayidx13+4)&4294967295); //@line 1274 "synthesize.cpp"
          HEAP32[(($arrayidx14)>>2)]=$16; //@line 1274 "synthesize.cpp"
          var $18=$value; //@line 1275 "synthesize.cpp"
          var $arrayidx15=((_soundicon_tab+$18*16)&4294967295); //@line 1275 "synthesize.cpp"
          var $data=(($arrayidx15+8)&4294967295); //@line 1275 "synthesize.cpp"
          var $19=HEAP32[(($data)>>2)]; //@line 1275 "synthesize.cpp"
          var $20=($19); //@line 1275 "synthesize.cpp"
          var $add16=((($20)+44)&4294967295); //@line 1275 "synthesize.cpp"
          var $21=HEAP32[((_wcmdq_tail)>>2)]; //@line 1275 "synthesize.cpp"
          var $arrayidx17=((_wcmdq+$21*16)&4294967295); //@line 1275 "synthesize.cpp"
          var $arrayidx18=(($arrayidx17+8)&4294967295); //@line 1275 "synthesize.cpp"
          HEAP32[(($arrayidx18)>>2)]=$add16; //@line 1275 "synthesize.cpp"
          var $22=HEAP32[((_wcmdq_tail)>>2)]; //@line 1276 "synthesize.cpp"
          var $arrayidx19=((_wcmdq+$22*16)&4294967295); //@line 1276 "synthesize.cpp"
          var $arrayidx20=(($arrayidx19+12)&4294967295); //@line 1276 "synthesize.cpp"
          HEAP32[(($arrayidx20)>>2)]=5376; //@line 1276 "synthesize.cpp"
          __Z8WcmdqIncv(); //@line 1277 "synthesize.cpp"
          ; //@line 1278 "synthesize.cpp"
        }
        else if (__label__ == 7) {
  
          var $23=$sourceix_addr; //@line 1283 "synthesize.cpp"
          var $and24=($23) & 2047; //@line 1283 "synthesize.cpp"
          var $24=HEAP32[((_clause_start_char)>>2)]; //@line 1283 "synthesize.cpp"
          var $add25=((($and24)+($24))&4294967295); //@line 1283 "synthesize.cpp"
          var $25=$value; //@line 1283 "synthesize.cpp"
          __Z8DoMarkeriiii(3, $add25, 0, $25); //@line 1283 "synthesize.cpp"
          ; //@line 1284 "synthesize.cpp"
        }
        else if (__label__ == 8) {
  
          var $26=HEAP32[((_count_characters)>>2)]; //@line 1287 "synthesize.cpp"
          var $add27=((($26)+1)&4294967295); //@line 1287 "synthesize.cpp"
          var $27=$value; //@line 1287 "synthesize.cpp"
          __Z8DoMarkeriiii(4, $add27, 0, $27); //@line 1287 "synthesize.cpp"
          ; //@line 1288 "synthesize.cpp"
        }
      } while(0);
  
      var $33=$word; //@line 1298 "synthesize.cpp"
      var $and34=($33) & 128; //@line 1298 "synthesize.cpp"
      var $cmp35=((($and34))|0)==0; //@line 1298 "synthesize.cpp"
      if ($cmp35) { __label__ = 1;continue $do_body$2; } else { __label__ = 11;break $do_body$2; } //@line 1298 "synthesize.cpp"
    }
  
    ;
    return; //@line 1299 "synthesize.cpp"
    return;
  }
  

  function __Z8GenerateP12PHONEME_LISTPii($phoneme_list, $n_ph, $resume) {
    var __stackBase__  = STACKTOP; STACKTOP += 656; _memset(__stackBase__, 0, 656);
    var __label__;
  
    var $retval;
    var $phoneme_list_addr;
    var $n_ph_addr;
    var $resume_addr;
    var $prev;
    var $next;
    var $next2;
    var $p;
    var $released;
    var $stress;
    var $modulation;
    var $pre_voiced;
    var $free_min;
    var $pitch_env;
    var $amp_env;
    var $ph;
    var $prev_ph;
    var $phdata=__stackBase__;
    var $phdata_prev=__stackBase__+152;
    var $phdata_next=__stackBase__+304;
    var $phdata_tone=__stackBase__+456;
    var $fmtp=__stackBase__+608;
    $phoneme_list_addr=$phoneme_list;
    $n_ph_addr=$n_ph;
    $resume_addr=$resume;
    $pitch_env=0; //@line 1317 "synthesize.cpp"
    var $0=HEAP32[((_option_quiet)>>2)]; //@line 1329 "synthesize.cpp"
    var $tobool=((($0))|0)!=0; //@line 1329 "synthesize.cpp"
    if ($tobool) { __label__ = 1;; } else { __label__ = 2;; } //@line 1329 "synthesize.cpp"
    if (__label__ == 1) {
  
      $retval=0; //@line 1330 "synthesize.cpp"
      ; //@line 1330 "synthesize.cpp"
    }
    else if (__label__ == 2) {
  
      var $1=HEAP8[(((_mbrola_name)&4294967295))]; //@line 1332 "synthesize.cpp"
      var $conv=(tempInt=(($1)),(tempInt>=128?tempInt-256:tempInt)); //@line 1332 "synthesize.cpp"
      var $cmp=((($conv))|0)!=0; //@line 1332 "synthesize.cpp"
      if ($cmp) { __label__ = 3;; } else { __label__ = 4;; } //@line 1332 "synthesize.cpp"
      if (__label__ == 3) {
  
        var $2=$phoneme_list_addr; //@line 1333 "synthesize.cpp"
        var $3=$n_ph_addr; //@line 1333 "synthesize.cpp"
        var $4=$resume_addr; //@line 1333 "synthesize.cpp"
        var $call=__Z14MbrolaGenerateP12PHONEME_LISTPii($2, $3, $4); //@line 1333 "synthesize.cpp"
        $retval=$call; //@line 1333 "synthesize.cpp"
        ; //@line 1333 "synthesize.cpp"
      }
      else if (__label__ == 4) {
  
        var $5=$resume_addr; //@line 1335 "synthesize.cpp"
        var $cmp3=((($5))|0)==0; //@line 1335 "synthesize.cpp"
        if ($cmp3) { __label__ = 5;; } else { __label__ = 6;; } //@line 1335 "synthesize.cpp"
        if (__label__ == 5) {
  
          HEAP32[((__ZZ8GenerateP12PHONEME_LISTPiiE2ix)>>2)]=1; //@line 1337 "synthesize.cpp"
          HEAP32[((__ZZ8GenerateP12PHONEME_LISTPiiE11embedded_ix)>>2)]=0; //@line 1338 "synthesize.cpp"
          HEAP32[((__ZZ8GenerateP12PHONEME_LISTPiiE10word_count)>>2)]=0; //@line 1339 "synthesize.cpp"
          HEAP32[((__ZL12pitch_length)>>2)]=0; //@line 1340 "synthesize.cpp"
          HEAP32[((__ZL10amp_length)>>2)]=0; //@line 1341 "synthesize.cpp"
          HEAP32[((__ZL10last_frame)>>2)]=0; //@line 1342 "synthesize.cpp"
          HEAP32[((__ZL10last_wcmdq)>>2)]=-1; //@line 1343 "synthesize.cpp"
          var $6=HEAP32[((_wcmdq_tail)>>2)]; //@line 1344 "synthesize.cpp"
          HEAP32[((__ZL14syllable_start)>>2)]=$6; //@line 1344 "synthesize.cpp"
          var $7=HEAP32[((_wcmdq_tail)>>2)]; //@line 1345 "synthesize.cpp"
          HEAP32[((__ZL12syllable_end)>>2)]=$7; //@line 1345 "synthesize.cpp"
          HEAP32[((__ZL15syllable_centre)>>2)]=-1; //@line 1346 "synthesize.cpp"
          HEAP32[((__ZL14last_pitch_cmd)>>2)]=-1; //@line 1347 "synthesize.cpp"
          var $dest$, $stop$, $stop4$, $fast$, $value4$;
          $dest$ = _vowel_transition;
          $stop$ = $dest$ + 16;
          $value4$ = 0;
          if ($value4$ < 0) $value4$ += 256;
          $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
          while ($dest$%4 !== 0 && $dest$ < $stop$) {
            ;; HEAP8[$dest$++] = 0;
          }
          $dest$ >>= 2;
          $stop4$ = $stop$ >> 2;
          while ($dest$ < $stop4$) {
          ;;;;;;;  HEAP32[$dest$++] = $value4$;
          }
          $dest$ <<= 2;
          while ($dest$ < $stop$) {
            ;; HEAP8[$dest$++] = 0;
          }; //@line 1348 "synthesize.cpp"
          __ZL7DoPauseii(0, 0); //@line 1349 "synthesize.cpp"
          ; //@line 1350 "synthesize.cpp"
        }
  
        var $pd_control=(($phdata)&4294967295); //@line 1432 "synthesize.cpp"
        var $8=$fmtp; //@line 1448 "synthesize.cpp"
        var $fmt_control=(($fmtp)&4294967295); //@line 1449 "synthesize.cpp"
        var $sound_addr=(($phdata+68)&4294967295); //@line 1478 "synthesize.cpp"
        var $arrayidx173=(($sound_addr)&4294967295); //@line 1478 "synthesize.cpp"
        var $fmt_addr=(($fmtp+8)&4294967295); //@line 1478 "synthesize.cpp"
        var $sound_param=(($phdata+88)&4294967295); //@line 1479 "synthesize.cpp"
        var $arrayidx174=(($sound_param)&4294967295); //@line 1479 "synthesize.cpp"
        var $fmt_amp=(($fmtp+16)&4294967295); //@line 1479 "synthesize.cpp"
        var $sound_addr199=(($phdata+68)&4294967295); //@line 1506 "synthesize.cpp"
        var $arrayidx200=(($sound_addr199)&4294967295); //@line 1506 "synthesize.cpp"
        var $fmt_addr201=(($fmtp+8)&4294967295); //@line 1506 "synthesize.cpp"
        var $sound_param202=(($phdata+88)&4294967295); //@line 1507 "synthesize.cpp"
        var $arrayidx203=(($sound_param202)&4294967295); //@line 1507 "synthesize.cpp"
        var $fmt_amp204=(($fmtp+16)&4294967295); //@line 1507 "synthesize.cpp"
        var $sound_addr205=(($phdata+68)&4294967295); //@line 1508 "synthesize.cpp"
        var $arrayidx206=(($sound_addr205+16)&4294967295); //@line 1508 "synthesize.cpp"
        var $wav_addr=(($fmtp+28)&4294967295); //@line 1508 "synthesize.cpp"
        var $sound_param207=(($phdata+88)&4294967295); //@line 1509 "synthesize.cpp"
        var $arrayidx208=(($sound_param207+16)&4294967295); //@line 1509 "synthesize.cpp"
        var $wav_amp=(($fmtp+32)&4294967295); //@line 1509 "synthesize.cpp"
        var $9=$fmtp; //@line 1551 "synthesize.cpp"
        var $pd_param=(($phdata+4)&4294967295); //@line 1552 "synthesize.cpp"
        var $arrayidx290=(($pd_param+40)&4294967295); //@line 1552 "synthesize.cpp"
        var $std_length=(($fmtp+44)&4294967295); //@line 1552 "synthesize.cpp"
        var $sound_addr291=(($phdata+68)&4294967295); //@line 1553 "synthesize.cpp"
        var $arrayidx292=(($sound_addr291)&4294967295); //@line 1553 "synthesize.cpp"
        var $fmt_addr293=(($fmtp+8)&4294967295); //@line 1553 "synthesize.cpp"
        var $sound_param294=(($phdata+88)&4294967295); //@line 1554 "synthesize.cpp"
        var $arrayidx295=(($sound_param294)&4294967295); //@line 1554 "synthesize.cpp"
        var $fmt_amp296=(($fmtp+16)&4294967295); //@line 1554 "synthesize.cpp"
        var $sound_addr297=(($phdata+68)&4294967295); //@line 1555 "synthesize.cpp"
        var $arrayidx298=(($sound_addr297+16)&4294967295); //@line 1555 "synthesize.cpp"
        var $wav_addr299=(($fmtp+28)&4294967295); //@line 1555 "synthesize.cpp"
        var $sound_param300=(($phdata+88)&4294967295); //@line 1556 "synthesize.cpp"
        var $arrayidx301=(($sound_param300+16)&4294967295); //@line 1556 "synthesize.cpp"
        var $wav_amp302=(($fmtp+32)&4294967295); //@line 1556 "synthesize.cpp"
        var $10=$fmtp; //@line 1564 "synthesize.cpp"
        var $pd_param334=(($phdata+4)&4294967295); //@line 1577 "synthesize.cpp"
        var $arrayidx335=(($pd_param334+40)&4294967295); //@line 1577 "synthesize.cpp"
        var $std_length337=(($fmtp+44)&4294967295); //@line 1577 "synthesize.cpp"
        var $sound_addr338=(($phdata+68)&4294967295); //@line 1578 "synthesize.cpp"
        var $arrayidx339=(($sound_addr338)&4294967295); //@line 1578 "synthesize.cpp"
        var $fmt_addr340=(($fmtp+8)&4294967295); //@line 1578 "synthesize.cpp"
        var $sound_param341=(($phdata+88)&4294967295); //@line 1579 "synthesize.cpp"
        var $arrayidx342=(($sound_param341)&4294967295); //@line 1579 "synthesize.cpp"
        var $fmt_amp343=(($fmtp+16)&4294967295); //@line 1579 "synthesize.cpp"
        var $11=$fmtp; //@line 1601 "synthesize.cpp"
        var $pd_param400=(($phdata+4)&4294967295); //@line 1626 "synthesize.cpp"
        var $arrayidx401=(($pd_param400+40)&4294967295); //@line 1626 "synthesize.cpp"
        var $std_length403=(($fmtp+44)&4294967295); //@line 1626 "synthesize.cpp"
        var $sound_addr404=(($phdata+68)&4294967295); //@line 1627 "synthesize.cpp"
        var $arrayidx405=(($sound_addr404)&4294967295); //@line 1627 "synthesize.cpp"
        var $fmt_addr406=(($fmtp+8)&4294967295); //@line 1627 "synthesize.cpp"
        var $sound_param407=(($phdata+88)&4294967295); //@line 1628 "synthesize.cpp"
        var $arrayidx408=(($sound_param407)&4294967295); //@line 1628 "synthesize.cpp"
        var $fmt_amp409=(($fmtp+16)&4294967295); //@line 1628 "synthesize.cpp"
        var $sound_addr410=(($phdata+68)&4294967295); //@line 1629 "synthesize.cpp"
        var $arrayidx411=(($sound_addr410+16)&4294967295); //@line 1629 "synthesize.cpp"
        var $wav_addr412=(($fmtp+28)&4294967295); //@line 1629 "synthesize.cpp"
        var $sound_param413=(($phdata+88)&4294967295); //@line 1630 "synthesize.cpp"
        var $arrayidx414=(($sound_param413+16)&4294967295); //@line 1630 "synthesize.cpp"
        var $wav_amp415=(($fmtp+32)&4294967295); //@line 1630 "synthesize.cpp"
        var $12=$fmtp; //@line 1639 "synthesize.cpp"
        var $pd_param422=(($phdata+4)&4294967295); //@line 1642 "synthesize.cpp"
        var $arrayidx423=(($pd_param422+40)&4294967295); //@line 1642 "synthesize.cpp"
        var $std_length425=(($fmtp+44)&4294967295); //@line 1642 "synthesize.cpp"
        var $sound_addr426=(($phdata+68)&4294967295); //@line 1644 "synthesize.cpp"
        var $arrayidx427=(($sound_addr426+8)&4294967295); //@line 1644 "synthesize.cpp"
        var $fmt_addr428=(($fmtp+8)&4294967295); //@line 1644 "synthesize.cpp"
        var $pd_control431=(($phdata)&4294967295); //@line 1644 "synthesize.cpp"
        var $sound_param435=(($phdata+88)&4294967295); //@line 1647 "synthesize.cpp"
        var $arrayidx436=(($sound_param435+8)&4294967295); //@line 1647 "synthesize.cpp"
        var $fmt_length=(($fmtp+12)&4294967295); //@line 1647 "synthesize.cpp"
        var $fmt_addr455=(($fmtp+8)&4294967295); //@line 1663 "synthesize.cpp"
        var $use_vowelin=(($fmtp+4)&4294967295); //@line 1666 "synthesize.cpp"
        var $fmt_control458=(($fmtp)&4294967295); //@line 1667 "synthesize.cpp"
        var $sound_addr459=(($phdata+68)&4294967295); //@line 1668 "synthesize.cpp"
        var $arrayidx460=(($sound_addr459)&4294967295); //@line 1668 "synthesize.cpp"
        var $fmt_addr461=(($fmtp+8)&4294967295); //@line 1668 "synthesize.cpp"
        var $sound_param463=(($phdata+88)&4294967295); //@line 1671 "synthesize.cpp"
        var $arrayidx464=(($sound_param463)&4294967295); //@line 1671 "synthesize.cpp"
        var $fmt_amp465=(($fmtp+16)&4294967295); //@line 1671 "synthesize.cpp"
        var $pitch_env474=(($phdata_tone+124)&4294967295); //@line 1678 "synthesize.cpp"
        var $amp_env476=(($phdata_tone+128)&4294967295); //@line 1679 "synthesize.cpp"
        var $amp_env479=(($phdata_tone+128)&4294967295); //@line 1680 "synthesize.cpp"
        var $sound_addr542=(($phdata+68)&4294967295); //@line 1721 "synthesize.cpp"
        var $arrayidx543=(($sound_addr542)&4294967295); //@line 1721 "synthesize.cpp"
        var $fmt_addr544=(($fmtp+8)&4294967295); //@line 1721 "synthesize.cpp"
        var $sound_param545=(($phdata+88)&4294967295); //@line 1722 "synthesize.cpp"
        var $arrayidx546=(($sound_param545)&4294967295); //@line 1722 "synthesize.cpp"
        var $fmt_amp547=(($fmtp+16)&4294967295); //@line 1722 "synthesize.cpp"
        var $transition0548=(($fmtp+36)&4294967295); //@line 1723 "synthesize.cpp"
        var $transition1549=(($fmtp+40)&4294967295); //@line 1724 "synthesize.cpp"
        var $sound_addr550=(($phdata+68)&4294967295); //@line 1726 "synthesize.cpp"
        var $arrayidx551=(($sound_addr550+12)&4294967295); //@line 1726 "synthesize.cpp"
        var $fmt2_addr=(($fmtp+20)&4294967295); //@line 1726 "synthesize.cpp"
        var $sound_param554=(($phdata+88)&4294967295); //@line 1728 "synthesize.cpp"
        var $arrayidx555=(($sound_param554+12)&4294967295); //@line 1728 "synthesize.cpp"
        var $fmt2_lenadj556=(($fmtp+24)&4294967295); //@line 1728 "synthesize.cpp"
        var $fmt2_lenadj562=(($fmtp+24)&4294967295); //@line 1733 "synthesize.cpp"
        var $use_vowelin563=(($fmtp+4)&4294967295); //@line 1736 "synthesize.cpp"
        var $vowel_transition564=(($phdata_next+108)&4294967295); //@line 1737 "synthesize.cpp"
        var $arrayidx565=(($vowel_transition564+8)&4294967295); //@line 1737 "synthesize.cpp"
        var $transition0566=(($fmtp+36)&4294967295); //@line 1737 "synthesize.cpp"
        var $vowel_transition567=(($phdata_next+108)&4294967295); //@line 1738 "synthesize.cpp"
        var $arrayidx568=(($vowel_transition567+12)&4294967295); //@line 1738 "synthesize.cpp"
        var $transition1569=(($fmtp+40)&4294967295); //@line 1738 "synthesize.cpp"
        var $sound_addr570=(($phdata_next+68)&4294967295); //@line 1740 "synthesize.cpp"
        var $arrayidx571=(($sound_addr570+12)&4294967295); //@line 1740 "synthesize.cpp"
        var $fmt2_addr572=(($fmtp+20)&4294967295); //@line 1740 "synthesize.cpp"
        var $sound_param575=(($phdata_next+88)&4294967295); //@line 1742 "synthesize.cpp"
        var $arrayidx576=(($sound_param575+12)&4294967295); //@line 1742 "synthesize.cpp"
        var $fmt2_lenadj577=(($fmtp+24)&4294967295); //@line 1742 "synthesize.cpp"
        var $sound_addr442=(($phdata_prev+68)&4294967295); //@line 1654 "synthesize.cpp"
        var $arrayidx443=(($sound_addr442+8)&4294967295); //@line 1654 "synthesize.cpp"
        var $fmt_addr444=(($fmtp+8)&4294967295); //@line 1654 "synthesize.cpp"
        var $sound_param447=(($phdata_prev+88)&4294967295); //@line 1657 "synthesize.cpp"
        var $arrayidx448=(($sound_param447+8)&4294967295); //@line 1657 "synthesize.cpp"
        var $fmt2_lenadj=(($fmtp+24)&4294967295); //@line 1657 "synthesize.cpp"
        var $vowel_transition=(($phdata_prev+108)&4294967295); //@line 1659 "synthesize.cpp"
        var $arrayidx450=(($vowel_transition)&4294967295); //@line 1659 "synthesize.cpp"
        var $transition0=(($fmtp+36)&4294967295); //@line 1659 "synthesize.cpp"
        var $vowel_transition451=(($phdata_prev+108)&4294967295); //@line 1660 "synthesize.cpp"
        var $arrayidx452=(($vowel_transition451+4)&4294967295); //@line 1660 "synthesize.cpp"
        var $transition1=(($fmtp+40)&4294967295); //@line 1660 "synthesize.cpp"
        ; //@line 1352 "synthesize.cpp"
        $while_cond$11: while(1) { 
  
          var $13=HEAP32[((__ZZ8GenerateP12PHONEME_LISTPiiE2ix)>>2)]; //@line 1352 "synthesize.cpp"
          var $14=$n_ph_addr; //@line 1352 "synthesize.cpp"
          var $15=HEAP32[(($14)>>2)]; //@line 1352 "synthesize.cpp"
          var $cmp6=((($13))|0) < ((($15))|0); //@line 1352 "synthesize.cpp"
          if (!($cmp6)) { __label__ = 134;break $while_cond$11; } //@line 1352 "synthesize.cpp"
  
          var $16=HEAP32[((__ZZ8GenerateP12PHONEME_LISTPiiE2ix)>>2)]; //@line 1354 "synthesize.cpp"
          var $17=$phoneme_list_addr; //@line 1354 "synthesize.cpp"
          var $arrayidx=(($17+24*$16)&4294967295); //@line 1354 "synthesize.cpp"
          $p=$arrayidx; //@line 1354 "synthesize.cpp"
          var $18=$p; //@line 1356 "synthesize.cpp"
          var $type=(($18+15)&4294967295); //@line 1356 "synthesize.cpp"
          var $19=HEAPU8[($type)]; //@line 1356 "synthesize.cpp"
          var $conv7=((($19))&255); //@line 1356 "synthesize.cpp"
          var $cmp8=((($conv7))|0)==0; //@line 1356 "synthesize.cpp"
          if ($cmp8) { __label__ = 9;; } else { __label__ = 10;; } //@line 1356 "synthesize.cpp"
          if (__label__ == 9) {
  
            $free_min=5; //@line 1357 "synthesize.cpp"
            ; //@line 1357 "synthesize.cpp"
          }
          else if (__label__ == 10) {
  
            var $20=$p; //@line 1359 "synthesize.cpp"
            var $type10=(($20+15)&4294967295); //@line 1359 "synthesize.cpp"
            var $21=HEAPU8[($type10)]; //@line 1359 "synthesize.cpp"
            var $conv11=((($21))&255); //@line 1359 "synthesize.cpp"
            var $cmp12=((($conv11))|0)!=2; //@line 1359 "synthesize.cpp"
            if ($cmp12) { __label__ = 11;; } else { __label__ = 12;; } //@line 1359 "synthesize.cpp"
            if (__label__ == 11) {
  
              $free_min=10; //@line 1360 "synthesize.cpp"
              ; //@line 1360 "synthesize.cpp"
            }
            else if (__label__ == 12) {
  
              $free_min=22; //@line 1362 "synthesize.cpp"
              ;
            }
          }
  
          var $call17=__Z9WcmdqFreev(); //@line 1364 "synthesize.cpp"
          var $22=$free_min; //@line 1364 "synthesize.cpp"
          var $cmp18=((($call17))|0) <= ((($22))|0); //@line 1364 "synthesize.cpp"
          if ($cmp18) { __label__ = 14;break $while_cond$11; } //@line 1364 "synthesize.cpp"
  
          var $23=HEAP32[((__ZZ8GenerateP12PHONEME_LISTPiiE2ix)>>2)]; //@line 1367 "synthesize.cpp"
          var $sub=((($23)-1)&4294967295); //@line 1367 "synthesize.cpp"
          var $24=$phoneme_list_addr; //@line 1367 "synthesize.cpp"
          var $arrayidx21=(($24+24*$sub)&4294967295); //@line 1367 "synthesize.cpp"
          $prev=$arrayidx21; //@line 1367 "synthesize.cpp"
          var $25=HEAP32[((__ZZ8GenerateP12PHONEME_LISTPiiE2ix)>>2)]; //@line 1368 "synthesize.cpp"
          var $add=((($25)+1)&4294967295); //@line 1368 "synthesize.cpp"
          var $26=$phoneme_list_addr; //@line 1368 "synthesize.cpp"
          var $arrayidx22=(($26+24*$add)&4294967295); //@line 1368 "synthesize.cpp"
          $next=$arrayidx22; //@line 1368 "synthesize.cpp"
          var $27=HEAP32[((__ZZ8GenerateP12PHONEME_LISTPiiE2ix)>>2)]; //@line 1369 "synthesize.cpp"
          var $add23=((($27)+2)&4294967295); //@line 1369 "synthesize.cpp"
          var $28=$phoneme_list_addr; //@line 1369 "synthesize.cpp"
          var $arrayidx24=(($28+24*$add23)&4294967295); //@line 1369 "synthesize.cpp"
          $next2=$arrayidx24; //@line 1369 "synthesize.cpp"
          var $29=$p; //@line 1371 "synthesize.cpp"
          var $synthflags=(($29+4)&4294967295); //@line 1371 "synthesize.cpp"
          var $30=HEAPU16[(($synthflags)>>1)]; //@line 1371 "synthesize.cpp"
          var $conv25=((($30))&65535); //@line 1371 "synthesize.cpp"
          var $and=($conv25) & 2; //@line 1371 "synthesize.cpp"
          var $tobool26=((($and))|0)!=0; //@line 1371 "synthesize.cpp"
          if ($tobool26) { __label__ = 16;; } else { __label__ = 17;; } //@line 1371 "synthesize.cpp"
          if (__label__ == 16) {
  
            var $31=$p; //@line 1373 "synthesize.cpp"
            var $sourceix=(($31+6)&4294967295); //@line 1373 "synthesize.cpp"
            var $32=HEAPU16[(($sourceix)>>1)]; //@line 1373 "synthesize.cpp"
            var $conv28=((($32))&65535); //@line 1373 "synthesize.cpp"
            __Z10DoEmbeddedPii(__ZZ8GenerateP12PHONEME_LISTPiiE11embedded_ix, $conv28); //@line 1373 "synthesize.cpp"
            ; //@line 1374 "synthesize.cpp"
          }
  
          var $33=$p; //@line 1376 "synthesize.cpp"
          var $newword=(($33+19)&4294967295); //@line 1376 "synthesize.cpp"
          var $34=HEAP8[($newword)]; //@line 1376 "synthesize.cpp"
          var $tobool30=(tempInt=(($34)),(tempInt>=128?tempInt-256:tempInt))!=0; //@line 1376 "synthesize.cpp"
          if ($tobool30) { __label__ = 18;; } else { __label__ = 26;; } //@line 1376 "synthesize.cpp"
          $if_then31$$if_end63$25: do { 
            if (__label__ == 18) {
  
              var $35=$p; //@line 1378 "synthesize.cpp"
              var $type32=(($35+15)&4294967295); //@line 1378 "synthesize.cpp"
              var $36=HEAPU8[($type32)]; //@line 1378 "synthesize.cpp"
              var $conv33=((($36))&255); //@line 1378 "synthesize.cpp"
              var $cmp34=((($conv33))|0)==2; //@line 1378 "synthesize.cpp"
              if ($cmp34) { __label__ = 19;; } else { __label__ = 20;; } //@line 1378 "synthesize.cpp"
              $land_lhs_true$$lor_lhs_false$27: do { 
                if (__label__ == 19) {
  
                  var $37=HEAP32[((_translator)>>2)]; //@line 1378 "synthesize.cpp"
                  var $langopts=(($37)&4294967295); //@line 1378 "synthesize.cpp"
                  var $param=(($langopts+24)&4294967295); //@line 1378 "synthesize.cpp"
                  var $arrayidx35=(($param+32)&4294967295); //@line 1378 "synthesize.cpp"
                  var $38=HEAP32[(($arrayidx35)>>2)]; //@line 1378 "synthesize.cpp"
                  var $and36=($38) & 1; //@line 1378 "synthesize.cpp"
                  var $tobool37=((($and36))|0)!=0; //@line 1378 "synthesize.cpp"
                  if ($tobool37) { __label__ = 22;break $land_lhs_true$$lor_lhs_false$27; } else { __label__ = 20;break $land_lhs_true$$lor_lhs_false$27; } //@line 1378 "synthesize.cpp"
                }
              } while(0);
              $if_end43$$lor_lhs_false$29: do { 
                if (__label__ == 20) {
  
                  var $39=$p; //@line 1378 "synthesize.cpp"
                  var $ph38=(($39+8)&4294967295); //@line 1378 "synthesize.cpp"
                  var $40=HEAP32[(($ph38)>>2)]; //@line 1378 "synthesize.cpp"
                  var $phflags=(($40+4)&4294967295); //@line 1378 "synthesize.cpp"
                  var $41=HEAP32[(($phflags)>>2)]; //@line 1378 "synthesize.cpp"
                  var $and39=($41) & 16777216; //@line 1378 "synthesize.cpp"
                  var $tobool40=((($and39))|0)!=0; //@line 1378 "synthesize.cpp"
                  if ($tobool40) { __label__ = 22;break $if_end43$$lor_lhs_false$29; } //@line 1378 "synthesize.cpp"
  
                  HEAP32[((__ZL10last_frame)>>2)]=0; //@line 1384 "synthesize.cpp"
                  ;
                }
              } while(0);
  
              var $42=$p; //@line 1387 "synthesize.cpp"
              var $sourceix44=(($42+6)&4294967295); //@line 1387 "synthesize.cpp"
              var $43=HEAPU16[(($sourceix44)>>1)]; //@line 1387 "synthesize.cpp"
              var $conv45=((($43))&65535); //@line 1387 "synthesize.cpp"
              var $and46=($conv45) & 2047; //@line 1387 "synthesize.cpp"
              var $44=HEAP32[((_clause_start_char)>>2)]; //@line 1387 "synthesize.cpp"
              var $add47=((($and46)+($44))&4294967295); //@line 1387 "synthesize.cpp"
              HEAP32[((__ZZ8GenerateP12PHONEME_LISTPiiE8sourceix)>>2)]=$add47; //@line 1387 "synthesize.cpp"
              var $45=$p; //@line 1389 "synthesize.cpp"
              var $newword48=(($45+19)&4294967295); //@line 1389 "synthesize.cpp"
              var $46=HEAPU8[($newword48)]; //@line 1389 "synthesize.cpp"
              var $conv49=((($46))&255); //@line 1389 "synthesize.cpp"
              var $and50=($conv49) & 4; //@line 1389 "synthesize.cpp"
              var $tobool51=((($and50))|0)!=0; //@line 1389 "synthesize.cpp"
              if ($tobool51) { __label__ = 23;; } else { __label__ = 24;; } //@line 1389 "synthesize.cpp"
              if (__label__ == 23) {
  
                var $47=HEAP32[((__ZZ8GenerateP12PHONEME_LISTPiiE8sourceix)>>2)]; //@line 1390 "synthesize.cpp"
                var $48=HEAP32[((_count_sentences)>>2)]; //@line 1390 "synthesize.cpp"
                __Z8DoMarkeriiii(2, $47, 0, $48); //@line 1390 "synthesize.cpp"
                ; //@line 1390 "synthesize.cpp"
              }
  
              var $49=$p; //@line 1395 "synthesize.cpp"
              var $newword54=(($49+19)&4294967295); //@line 1395 "synthesize.cpp"
              var $50=HEAPU8[($newword54)]; //@line 1395 "synthesize.cpp"
              var $conv55=((($50))&255); //@line 1395 "synthesize.cpp"
              var $and56=($conv55) & 1; //@line 1395 "synthesize.cpp"
              var $tobool57=((($and56))|0)!=0; //@line 1395 "synthesize.cpp"
              if (!($tobool57)) { __label__ = 26;break $if_then31$$if_end63$25; } //@line 1395 "synthesize.cpp"
  
              var $51=HEAP32[((__ZZ8GenerateP12PHONEME_LISTPiiE8sourceix)>>2)]; //@line 1396 "synthesize.cpp"
              var $52=$p; //@line 1396 "synthesize.cpp"
              var $sourceix59=(($52+6)&4294967295); //@line 1396 "synthesize.cpp"
              var $53=HEAPU16[(($sourceix59)>>1)]; //@line 1396 "synthesize.cpp"
              var $conv60=((($53))&65535); //@line 1396 "synthesize.cpp"
              var $shr=($conv60) >> 11; //@line 1396 "synthesize.cpp"
              var $54=HEAP32[((_clause_start_word)>>2)]; //@line 1396 "synthesize.cpp"
              var $55=HEAPU32[((__ZZ8GenerateP12PHONEME_LISTPiiE10word_count)>>2)]; //@line 1396 "synthesize.cpp"
              var $inc=((($55)+1)&4294967295); //@line 1396 "synthesize.cpp"
              HEAP32[((__ZZ8GenerateP12PHONEME_LISTPiiE10word_count)>>2)]=$inc; //@line 1396 "synthesize.cpp"
              var $add61=((($55)+($54))&4294967295); //@line 1396 "synthesize.cpp"
              __Z8DoMarkeriiii(1, $51, $shr, $add61); //@line 1396 "synthesize.cpp"
              ; //@line 1396 "synthesize.cpp"
            }
          } while(0);
  
          __ZL12EndAmplitudev(); //@line 1399 "synthesize.cpp"
          var $56=$p; //@line 1401 "synthesize.cpp"
          var $prepause=(($56+16)&4294967295); //@line 1401 "synthesize.cpp"
          var $57=HEAPU8[($prepause)]; //@line 1401 "synthesize.cpp"
          var $conv64=((($57))&255); //@line 1401 "synthesize.cpp"
          var $cmp65=((($conv64))|0) > 0; //@line 1401 "synthesize.cpp"
          if ($cmp65) { __label__ = 27;; } else { __label__ = 28;; } //@line 1401 "synthesize.cpp"
          if (__label__ == 27) {
  
            var $58=$p; //@line 1402 "synthesize.cpp"
            var $prepause67=(($58+16)&4294967295); //@line 1402 "synthesize.cpp"
            var $59=HEAPU8[($prepause67)]; //@line 1402 "synthesize.cpp"
            var $conv68=((($59))&255); //@line 1402 "synthesize.cpp"
            __ZL7DoPauseii($conv68, 1); //@line 1402 "synthesize.cpp"
            ; //@line 1402 "synthesize.cpp"
          }
  
          var $60=HEAP32[((_option_phoneme_events)>>2)]; //@line 1404 "synthesize.cpp"
          var $tobool70=((($60))|0)!=0; //@line 1404 "synthesize.cpp"
          if ($tobool70) { __label__ = 29;; } else { __label__ = 31;; } //@line 1404 "synthesize.cpp"
          $land_lhs_true71$$if_end77$41: do { 
            if (__label__ == 29) {
  
              var $61=$p; //@line 1404 "synthesize.cpp"
              var $type72=(($61+15)&4294967295); //@line 1404 "synthesize.cpp"
              var $62=HEAPU8[($type72)]; //@line 1404 "synthesize.cpp"
              var $conv73=((($62))&255); //@line 1404 "synthesize.cpp"
              var $cmp74=((($conv73))|0)!=2; //@line 1404 "synthesize.cpp"
              if (!($cmp74)) { __label__ = 31;break $land_lhs_true71$$if_end77$41; } //@line 1404 "synthesize.cpp"
  
              var $63=HEAP32[((__ZZ8GenerateP12PHONEME_LISTPiiE8sourceix)>>2)]; //@line 1407 "synthesize.cpp"
              var $64=$p; //@line 1407 "synthesize.cpp"
              var $ph76=(($64+8)&4294967295); //@line 1407 "synthesize.cpp"
              var $65=HEAP32[(($ph76)>>2)]; //@line 1407 "synthesize.cpp"
              var $mnemonic=(($65)&4294967295); //@line 1407 "synthesize.cpp"
              var $66=HEAP32[(($mnemonic)>>2)]; //@line 1407 "synthesize.cpp"
              __Z8DoMarkeriiii(7, $63, 0, $66); //@line 1407 "synthesize.cpp"
              ; //@line 1408 "synthesize.cpp"
            }
          } while(0);
  
          var $67=$p; //@line 1410 "synthesize.cpp"
          var $type78=(($67+15)&4294967295); //@line 1410 "synthesize.cpp"
          var $68=HEAPU8[($type78)]; //@line 1410 "synthesize.cpp"
          var $conv79=((($68))&255); //@line 1410 "synthesize.cpp"
          if ($conv79 == 0) {
            __label__ = 32;;
          }
          else if ($conv79 == 4) {
            __label__ = 33;;
          }
          else if ($conv79 == 6) {
            __label__ = 41;;
          }
          else if ($conv79 == 5) {
            __label__ = 44;;
          }
          else if ($conv79 == 7) {
            __label__ = 67;;
          }
          else if ($conv79 == 8) {
            __label__ = 81;;
          }
          else if ($conv79 == 3) {
            __label__ = 91;;
          }
          else if ($conv79 == 2) {
            __label__ = 100;;
          }
          else {
          __label__ = 133;;
          }
          
          $sw_epilog$$sw_bb$$sw_bb81$$sw_bb105$$sw_bb118$$sw_bb229$$sw_bb313$$sw_bb367$$sw_bb418$45: do { 
            if (__label__ == 32) {
  
              var $69=$p; //@line 1413 "synthesize.cpp"
              var $length=(($69+12)&4294967295); //@line 1413 "synthesize.cpp"
              var $70=HEAP16[(($length)>>1)]; //@line 1413 "synthesize.cpp"
              var $conv80=(tempInt=(($70)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1413 "synthesize.cpp"
              __ZL7DoPauseii($conv80, 0); //@line 1413 "synthesize.cpp"
              ; //@line 1414 "synthesize.cpp"
            }
            else if (__label__ == 33) {
  
              $released=0; //@line 1417 "synthesize.cpp"
              var $71=$next; //@line 1418 "synthesize.cpp"
              var $type82=(($71+15)&4294967295); //@line 1418 "synthesize.cpp"
              var $72=HEAPU8[($type82)]; //@line 1418 "synthesize.cpp"
              var $conv83=((($72))&255); //@line 1418 "synthesize.cpp"
              var $cmp84=((($conv83))|0)==2; //@line 1418 "synthesize.cpp"
              if ($cmp84) { __label__ = 34;; } else { __label__ = 35;; } //@line 1418 "synthesize.cpp"
              $if_then85$$if_else86$48: do { 
                if (__label__ == 34) {
  
                  $released=1; //@line 1420 "synthesize.cpp"
                  ; //@line 1421 "synthesize.cpp"
                }
                else if (__label__ == 35) {
  
                  var $73=$next; //@line 1423 "synthesize.cpp"
                  var $newword87=(($73+19)&4294967295); //@line 1423 "synthesize.cpp"
                  var $74=HEAP8[($newword87)]; //@line 1423 "synthesize.cpp"
                  var $tobool88=(tempInt=(($74)),(tempInt>=128?tempInt-256:tempInt))!=0; //@line 1423 "synthesize.cpp"
                  if ($tobool88) { __label__ = 38;; } else { __label__ = 36;; } //@line 1423 "synthesize.cpp"
                  $if_end96$$if_then89$51: do { 
                    if (__label__ == 36) {
  
                      var $75=$next; //@line 1425 "synthesize.cpp"
                      var $type90=(($75+15)&4294967295); //@line 1425 "synthesize.cpp"
                      var $76=HEAPU8[($type90)]; //@line 1425 "synthesize.cpp"
                      var $conv91=((($76))&255); //@line 1425 "synthesize.cpp"
                      var $cmp92=((($conv91))|0)==3; //@line 1425 "synthesize.cpp"
                      if (!($cmp92)) { __label__ = 38;break $if_end96$$if_then89$51; } //@line 1425 "synthesize.cpp"
  
                      $released=1; //@line 1425 "synthesize.cpp"
                      __label__ = 40;break $if_then85$$if_else86$48; //@line 1425 "synthesize.cpp"
                    }
                  } while(0);
  
                  var $_pr=$released; //@line 1428 "synthesize.cpp"
                  var $cmp97=((($_pr))|0)==0; //@line 1428 "synthesize.cpp"
                  if (!($cmp97)) { __label__ = 40;break $if_then85$$if_else86$48; } //@line 1428 "synthesize.cpp"
  
                  var $77=$p; //@line 1429 "synthesize.cpp"
                  var $synthflags99=(($77+4)&4294967295); //@line 1429 "synthesize.cpp"
                  var $78=HEAPU16[(($synthflags99)>>1)]; //@line 1429 "synthesize.cpp"
                  var $conv100=((($78))&65535); //@line 1429 "synthesize.cpp"
                  var $or=($conv100) | 8192; //@line 1429 "synthesize.cpp"
                  var $conv101=((($or)) & 65535); //@line 1429 "synthesize.cpp"
                  HEAP16[(($synthflags99)>>1)]=$conv101; //@line 1429 "synthesize.cpp"
                  ; //@line 1429 "synthesize.cpp"
                }
              } while(0);
  
              var $79=$p; //@line 1431 "synthesize.cpp"
              __Z16InterpretPhonemeP10TranslatoriP12PHONEME_LISTP12PHONEME_DATA(0, 0, $79, $phdata); //@line 1431 "synthesize.cpp"
              var $80=HEAP32[(($pd_control)>>2)]; //@line 1432 "synthesize.cpp"
              var $or103=($80) | 4; //@line 1432 "synthesize.cpp"
              HEAP32[(($pd_control)>>2)]=$or103; //@line 1432 "synthesize.cpp"
              var $call104=__Z9DoSample3P12PHONEME_DATAii($phdata, 0, 0); //@line 1433 "synthesize.cpp"
              ; //@line 1434 "synthesize.cpp"
            }
            else if (__label__ == 41) {
  
              var $81=$p; //@line 1437 "synthesize.cpp"
              __Z16InterpretPhonemeP10TranslatoriP12PHONEME_LISTP12PHONEME_DATA(0, 0, $81, $phdata); //@line 1437 "synthesize.cpp"
              var $82=$p; //@line 1439 "synthesize.cpp"
              var $synthflags106=(($82+4)&4294967295); //@line 1439 "synthesize.cpp"
              var $83=HEAPU16[(($synthflags106)>>1)]; //@line 1439 "synthesize.cpp"
              var $conv107=((($83))&65535); //@line 1439 "synthesize.cpp"
              var $and108=($conv107) & 8; //@line 1439 "synthesize.cpp"
              var $tobool109=((($and108))|0)!=0; //@line 1439 "synthesize.cpp"
              if ($tobool109) { __label__ = 42;; } else { __label__ = 43;; } //@line 1439 "synthesize.cpp"
              if (__label__ == 42) {
  
                var $84=$p; //@line 1441 "synthesize.cpp"
                var $length111=(($84+12)&4294967295); //@line 1441 "synthesize.cpp"
                var $85=HEAP16[(($length111)>>1)]; //@line 1441 "synthesize.cpp"
                var $conv112=(tempInt=(($85)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1441 "synthesize.cpp"
                var $call113=__Z9DoSample3P12PHONEME_DATAii($phdata, $conv112, 0); //@line 1441 "synthesize.cpp"
                ; //@line 1442 "synthesize.cpp"
              }
  
              var $86=$p; //@line 1443 "synthesize.cpp"
              var $length115=(($86+12)&4294967295); //@line 1443 "synthesize.cpp"
              var $87=HEAP16[(($length115)>>1)]; //@line 1443 "synthesize.cpp"
              var $conv116=(tempInt=(($87)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1443 "synthesize.cpp"
              var $call117=__Z9DoSample3P12PHONEME_DATAii($phdata, $conv116, 0); //@line 1443 "synthesize.cpp"
              ; //@line 1444 "synthesize.cpp"
            }
            else if (__label__ == 44) {
  
              var $88=$p; //@line 1447 "synthesize.cpp"
              var $ph119=(($88+8)&4294967295); //@line 1447 "synthesize.cpp"
              var $89=HEAP32[(($ph119)>>2)]; //@line 1447 "synthesize.cpp"
              $ph=$89; //@line 1447 "synthesize.cpp"
              var $dest$, $stop$, $stop4$, $fast$, $value4$;
              $dest$ = $8;
              $stop$ = $dest$ + 48;
              $value4$ = 0;
              if ($value4$ < 0) $value4$ += 256;
              $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
              while ($dest$%4 !== 0 && $dest$ < $stop$) {
                ;; HEAP8[$dest$++] = 0;
              }
              $dest$ >>= 2;
              $stop4$ = $stop$ >> 2;
              while ($dest$ < $stop4$) {
              ;;;;;;;  HEAP32[$dest$++] = $value4$;
              }
              $dest$ <<= 2;
              while ($dest$ < $stop$) {
                ;; HEAP8[$dest$++] = 0;
              }; //@line 1448 "synthesize.cpp"
              HEAP32[(($fmt_control)>>2)]=4; //@line 1449 "synthesize.cpp"
              $pre_voiced=0; //@line 1451 "synthesize.cpp"
              var $90=$next; //@line 1452 "synthesize.cpp"
              var $type120=(($90+15)&4294967295); //@line 1452 "synthesize.cpp"
              var $91=HEAPU8[($type120)]; //@line 1452 "synthesize.cpp"
              var $conv121=((($91))&255); //@line 1452 "synthesize.cpp"
              var $cmp122=((($conv121))|0)==2; //@line 1452 "synthesize.cpp"
              if ($cmp122) { __label__ = 45;; } else { __label__ = 46;; } //@line 1452 "synthesize.cpp"
              $if_then123$$if_else128$62: do { 
                if (__label__ == 45) {
  
                  var $92=$p; //@line 1454 "synthesize.cpp"
                  var $amp=(($92+18)&4294967295); //@line 1454 "synthesize.cpp"
                  var $93=HEAPU8[($amp)]; //@line 1454 "synthesize.cpp"
                  var $conv124=((($93))&255); //@line 1454 "synthesize.cpp"
                  __ZL11DoAmplitudeiPh($conv124, 0); //@line 1454 "synthesize.cpp"
                  var $94=$p; //@line 1455 "synthesize.cpp"
                  var $env=(($94+14)&4294967295); //@line 1455 "synthesize.cpp"
                  var $95=HEAPU8[($env)]; //@line 1455 "synthesize.cpp"
                  var $idxprom=((($95))&255); //@line 1455 "synthesize.cpp"
                  var $arrayidx125=((_envelope_data+$idxprom*4)&4294967295); //@line 1455 "synthesize.cpp"
                  var $96=HEAP32[(($arrayidx125)>>2)]; //@line 1455 "synthesize.cpp"
                  var $97=$p; //@line 1455 "synthesize.cpp"
                  var $pitch1=(($97+20)&4294967295); //@line 1455 "synthesize.cpp"
                  var $98=HEAPU8[($pitch1)]; //@line 1455 "synthesize.cpp"
                  var $conv126=((($98))&255); //@line 1455 "synthesize.cpp"
                  var $99=$p; //@line 1455 "synthesize.cpp"
                  var $pitch2=(($99+21)&4294967295); //@line 1455 "synthesize.cpp"
                  var $100=HEAPU8[($pitch2)]; //@line 1455 "synthesize.cpp"
                  var $conv127=((($100))&255); //@line 1455 "synthesize.cpp"
                  __ZL7DoPitchPhii($96, $conv126, $conv127); //@line 1455 "synthesize.cpp"
                  $pre_voiced=1; //@line 1456 "synthesize.cpp"
                  ; //@line 1457 "synthesize.cpp"
                }
                else if (__label__ == 46) {
  
                  var $101=$next; //@line 1459 "synthesize.cpp"
                  var $type129=(($101+15)&4294967295); //@line 1459 "synthesize.cpp"
                  var $102=HEAPU8[($type129)]; //@line 1459 "synthesize.cpp"
                  var $conv130=((($102))&255); //@line 1459 "synthesize.cpp"
                  var $cmp131=((($conv130))|0)==3; //@line 1459 "synthesize.cpp"
                  if ($cmp131) { __label__ = 47;; } else { __label__ = 49;; } //@line 1459 "synthesize.cpp"
                  $land_lhs_true132$$if_else145$65: do { 
                    if (__label__ == 47) {
  
                      var $103=$next; //@line 1459 "synthesize.cpp"
                      var $newword133=(($103+19)&4294967295); //@line 1459 "synthesize.cpp"
                      var $104=HEAP8[($newword133)]; //@line 1459 "synthesize.cpp"
                      var $tobool134=(tempInt=(($104)),(tempInt>=128?tempInt-256:tempInt))!=0; //@line 1459 "synthesize.cpp"
                      if ($tobool134) { __label__ = 49;break $land_lhs_true132$$if_else145$65; } //@line 1459 "synthesize.cpp"
  
                      var $105=$next; //@line 1461 "synthesize.cpp"
                      var $amp136=(($105+18)&4294967295); //@line 1461 "synthesize.cpp"
                      var $106=HEAPU8[($amp136)]; //@line 1461 "synthesize.cpp"
                      var $conv137=((($106))&255); //@line 1461 "synthesize.cpp"
                      __ZL11DoAmplitudeiPh($conv137, 0); //@line 1461 "synthesize.cpp"
                      var $107=$next; //@line 1462 "synthesize.cpp"
                      var $env138=(($107+14)&4294967295); //@line 1462 "synthesize.cpp"
                      var $108=HEAPU8[($env138)]; //@line 1462 "synthesize.cpp"
                      var $idxprom139=((($108))&255); //@line 1462 "synthesize.cpp"
                      var $arrayidx140=((_envelope_data+$idxprom139*4)&4294967295); //@line 1462 "synthesize.cpp"
                      var $109=HEAP32[(($arrayidx140)>>2)]; //@line 1462 "synthesize.cpp"
                      var $110=$next; //@line 1462 "synthesize.cpp"
                      var $pitch1141=(($110+20)&4294967295); //@line 1462 "synthesize.cpp"
                      var $111=HEAPU8[($pitch1141)]; //@line 1462 "synthesize.cpp"
                      var $conv142=((($111))&255); //@line 1462 "synthesize.cpp"
                      var $112=$next; //@line 1462 "synthesize.cpp"
                      var $pitch2143=(($112+21)&4294967295); //@line 1462 "synthesize.cpp"
                      var $113=HEAPU8[($pitch2143)]; //@line 1462 "synthesize.cpp"
                      var $conv144=((($113))&255); //@line 1462 "synthesize.cpp"
                      __ZL7DoPitchPhii($109, $conv142, $conv144); //@line 1462 "synthesize.cpp"
                      $pre_voiced=1; //@line 1463 "synthesize.cpp"
                      __label__ = 51;break $if_then123$$if_else128$62; //@line 1464 "synthesize.cpp"
                    }
                  } while(0);
  
                  var $114=HEAP32[((__ZL14last_pitch_cmd)>>2)]; //@line 1467 "synthesize.cpp"
                  var $cmp146=((($114))|0) < 0; //@line 1467 "synthesize.cpp"
                  if (!($cmp146)) { __label__ = 51;break $if_then123$$if_else128$62; } //@line 1467 "synthesize.cpp"
  
                  var $115=$next; //@line 1469 "synthesize.cpp"
                  var $amp148=(($115+18)&4294967295); //@line 1469 "synthesize.cpp"
                  var $116=HEAPU8[($amp148)]; //@line 1469 "synthesize.cpp"
                  var $conv149=((($116))&255); //@line 1469 "synthesize.cpp"
                  __ZL11DoAmplitudeiPh($conv149, 0); //@line 1469 "synthesize.cpp"
                  var $117=$p; //@line 1470 "synthesize.cpp"
                  var $env150=(($117+14)&4294967295); //@line 1470 "synthesize.cpp"
                  var $118=HEAPU8[($env150)]; //@line 1470 "synthesize.cpp"
                  var $idxprom151=((($118))&255); //@line 1470 "synthesize.cpp"
                  var $arrayidx152=((_envelope_data+$idxprom151*4)&4294967295); //@line 1470 "synthesize.cpp"
                  var $119=HEAP32[(($arrayidx152)>>2)]; //@line 1470 "synthesize.cpp"
                  var $120=$p; //@line 1470 "synthesize.cpp"
                  var $pitch1153=(($120+20)&4294967295); //@line 1470 "synthesize.cpp"
                  var $121=HEAPU8[($pitch1153)]; //@line 1470 "synthesize.cpp"
                  var $conv154=((($121))&255); //@line 1470 "synthesize.cpp"
                  var $122=$p; //@line 1470 "synthesize.cpp"
                  var $pitch2155=(($122+21)&4294967295); //@line 1470 "synthesize.cpp"
                  var $123=HEAPU8[($pitch2155)]; //@line 1470 "synthesize.cpp"
                  var $conv156=((($123))&255); //@line 1470 "synthesize.cpp"
                  __ZL7DoPitchPhii($119, $conv154, $conv156); //@line 1470 "synthesize.cpp"
                  ; //@line 1471 "synthesize.cpp"
                }
              } while(0);
  
              var $124=$prev; //@line 1474 "synthesize.cpp"
              var $type160=(($124+15)&4294967295); //@line 1474 "synthesize.cpp"
              var $125=HEAPU8[($type160)]; //@line 1474 "synthesize.cpp"
              var $conv161=((($125))&255); //@line 1474 "synthesize.cpp"
              var $cmp162=((($conv161))|0)==2; //@line 1474 "synthesize.cpp"
              if ($cmp162) { __label__ = 54;; } else { __label__ = 52;; } //@line 1474 "synthesize.cpp"
              $if_then172$$lor_lhs_false163$71: do { 
                if (__label__ == 52) {
  
                  var $126=$prev; //@line 1474 "synthesize.cpp"
                  var $ph164=(($126+8)&4294967295); //@line 1474 "synthesize.cpp"
                  var $127=HEAP32[(($ph164)>>2)]; //@line 1474 "synthesize.cpp"
                  var $phflags165=(($127+4)&4294967295); //@line 1474 "synthesize.cpp"
                  var $128=HEAP32[(($phflags165)>>2)]; //@line 1474 "synthesize.cpp"
                  var $and166=($128) & 256; //@line 1474 "synthesize.cpp"
                  var $tobool167=((($and166))|0)!=0; //@line 1474 "synthesize.cpp"
                  if ($tobool167) { __label__ = 54;break $if_then172$$lor_lhs_false163$71; } //@line 1474 "synthesize.cpp"
  
                  var $129=$ph; //@line 1474 "synthesize.cpp"
                  var $phflags169=(($129+4)&4294967295); //@line 1474 "synthesize.cpp"
                  var $130=HEAP32[(($phflags169)>>2)]; //@line 1474 "synthesize.cpp"
                  var $and170=($130) & 33554432; //@line 1474 "synthesize.cpp"
                  var $tobool171=((($and170))|0)!=0; //@line 1474 "synthesize.cpp"
                  if ($tobool171) { __label__ = 54;break $if_then172$$lor_lhs_false163$71; } //@line 1474 "synthesize.cpp"
  
                  var $140=$p; //@line 1490 "synthesize.cpp"
                  var $synthflags184=(($140+4)&4294967295); //@line 1490 "synthesize.cpp"
                  var $141=HEAPU16[(($synthflags184)>>1)]; //@line 1490 "synthesize.cpp"
                  var $conv185=((($141))&65535); //@line 1490 "synthesize.cpp"
                  var $and186=($conv185) & 8; //@line 1490 "synthesize.cpp"
                  var $tobool187=((($and186))|0)!=0; //@line 1490 "synthesize.cpp"
                  if (!($tobool187)) { __label__ = 58;break $if_then172$$lor_lhs_false163$71; } //@line 1490 "synthesize.cpp"
  
                  __ZL7DoPauseii(50, 0); //@line 1492 "synthesize.cpp"
                  __label__ = 58;break $if_then172$$lor_lhs_false163$71; //@line 1493 "synthesize.cpp"
                }
              } while(0);
              $if_then172$$if_end190$76: do { 
                if (__label__ == 54) {
  
                  var $131=$p; //@line 1477 "synthesize.cpp"
                  __Z16InterpretPhonemeP10TranslatoriP12PHONEME_LISTP12PHONEME_DATA(0, 1, $131, $phdata); //@line 1477 "synthesize.cpp"
                  var $132=HEAP32[(($arrayidx173)>>2)]; //@line 1478 "synthesize.cpp"
                  HEAP32[(($fmt_addr)>>2)]=$132; //@line 1478 "synthesize.cpp"
                  var $133=HEAP32[(($arrayidx174)>>2)]; //@line 1479 "synthesize.cpp"
                  HEAP32[(($fmt_amp)>>2)]=$133; //@line 1479 "synthesize.cpp"
                  var $134=$ph; //@line 1481 "synthesize.cpp"
                  var $135=$p; //@line 1481 "synthesize.cpp"
                  var $call175=__Z8DoSpect2P11PHONEME_TABiP10FMT_PARAMSP12PHONEME_LISTi($134, 0, $fmtp, $135, 0); //@line 1481 "synthesize.cpp"
                  var $136=$p; //@line 1482 "synthesize.cpp"
                  var $synthflags176=(($136+4)&4294967295); //@line 1482 "synthesize.cpp"
                  var $137=HEAPU16[(($synthflags176)>>1)]; //@line 1482 "synthesize.cpp"
                  var $conv177=((($137))&65535); //@line 1482 "synthesize.cpp"
                  var $and178=($conv177) & 8; //@line 1482 "synthesize.cpp"
                  var $tobool179=((($and178))|0)!=0; //@line 1482 "synthesize.cpp"
                  if (!($tobool179)) { __label__ = 58;break $if_then172$$if_end190$76; } //@line 1482 "synthesize.cpp"
  
                  __ZL7DoPauseii(25, 1); //@line 1484 "synthesize.cpp"
                  var $138=$ph; //@line 1485 "synthesize.cpp"
                  var $139=$p; //@line 1485 "synthesize.cpp"
                  var $call181=__Z8DoSpect2P11PHONEME_TABiP10FMT_PARAMSP12PHONEME_LISTi($138, 0, $fmtp, $139, 0); //@line 1485 "synthesize.cpp"
                  ; //@line 1486 "synthesize.cpp"
                }
              } while(0);
  
              var $142=$pre_voiced; //@line 1496 "synthesize.cpp"
              var $tobool191=((($142))|0)!=0; //@line 1496 "synthesize.cpp"
              if ($tobool191) { __label__ = 59;; } else { __label__ = 60;; } //@line 1496 "synthesize.cpp"
              if (__label__ == 59) {
  
                __ZL13StartSyllablev(); //@line 1499 "synthesize.cpp"
                ; //@line 1500 "synthesize.cpp"
              }
              else if (__label__ == 60) {
  
                var $143=$p; //@line 1503 "synthesize.cpp"
                var $synthflags194=(($143+4)&4294967295); //@line 1503 "synthesize.cpp"
                var $144=HEAPU16[(($synthflags194)>>1)]; //@line 1503 "synthesize.cpp"
                var $conv195=((($144))&65535); //@line 1503 "synthesize.cpp"
                var $or196=($conv195) | 8192; //@line 1503 "synthesize.cpp"
                var $conv197=((($or196)) & 65535); //@line 1503 "synthesize.cpp"
                HEAP16[(($synthflags194)>>1)]=$conv197; //@line 1503 "synthesize.cpp"
                ;
              }
  
              var $145=$p; //@line 1505 "synthesize.cpp"
              __Z16InterpretPhonemeP10TranslatoriP12PHONEME_LISTP12PHONEME_DATA(0, 0, $145, $phdata); //@line 1505 "synthesize.cpp"
              var $146=HEAP32[(($arrayidx200)>>2)]; //@line 1506 "synthesize.cpp"
              HEAP32[(($fmt_addr201)>>2)]=$146; //@line 1506 "synthesize.cpp"
              var $147=HEAP32[(($arrayidx203)>>2)]; //@line 1507 "synthesize.cpp"
              HEAP32[(($fmt_amp204)>>2)]=$147; //@line 1507 "synthesize.cpp"
              var $148=HEAP32[(($arrayidx206)>>2)]; //@line 1508 "synthesize.cpp"
              HEAP32[(($wav_addr)>>2)]=$148; //@line 1508 "synthesize.cpp"
              var $149=HEAP32[(($arrayidx208)>>2)]; //@line 1509 "synthesize.cpp"
              HEAP32[(($wav_amp)>>2)]=$149; //@line 1509 "synthesize.cpp"
              var $150=$ph; //@line 1510 "synthesize.cpp"
              var $151=$p; //@line 1510 "synthesize.cpp"
              var $call209=__Z8DoSpect2P11PHONEME_TABiP10FMT_PARAMSP12PHONEME_LISTi($150, 0, $fmtp, $151, 0); //@line 1510 "synthesize.cpp"
              var $152=$p; //@line 1512 "synthesize.cpp"
              var $newword210=(($152+19)&4294967295); //@line 1512 "synthesize.cpp"
              var $153=HEAPU8[($newword210)]; //@line 1512 "synthesize.cpp"
              var $conv211=((($153))&255); //@line 1512 "synthesize.cpp"
              var $cmp212=((($conv211))|0)==0; //@line 1512 "synthesize.cpp"
              if (!($cmp212)) { __label__ = 133;break $sw_epilog$$sw_bb$$sw_bb81$$sw_bb105$$sw_bb118$$sw_bb229$$sw_bb313$$sw_bb367$$sw_bb418$45; } //@line 1512 "synthesize.cpp"
  
              var $154=$next2; //@line 1512 "synthesize.cpp"
              var $newword214=(($154+19)&4294967295); //@line 1512 "synthesize.cpp"
              var $155=HEAPU8[($newword214)]; //@line 1512 "synthesize.cpp"
              var $conv215=((($155))&255); //@line 1512 "synthesize.cpp"
              var $cmp216=((($conv215))|0)==0; //@line 1512 "synthesize.cpp"
              if (!($cmp216)) { __label__ = 133;break $sw_epilog$$sw_bb$$sw_bb81$$sw_bb105$$sw_bb118$$sw_bb229$$sw_bb313$$sw_bb367$$sw_bb418$45; } //@line 1512 "synthesize.cpp"
  
              var $156=$next; //@line 1514 "synthesize.cpp"
              var $type218=(($156+15)&4294967295); //@line 1514 "synthesize.cpp"
              var $157=HEAPU8[($type218)]; //@line 1514 "synthesize.cpp"
              var $conv219=((($157))&255); //@line 1514 "synthesize.cpp"
              var $cmp220=((($conv219))|0)==7; //@line 1514 "synthesize.cpp"
              if ($cmp220) { __label__ = 64;; } else { __label__ = 65;; } //@line 1514 "synthesize.cpp"
              if (__label__ == 64) {
  
                __ZL7DoPauseii(20, 0); //@line 1515 "synthesize.cpp"
                ; //@line 1515 "synthesize.cpp"
              }
  
              var $158=$next; //@line 1516 "synthesize.cpp"
              var $type223=(($158+15)&4294967295); //@line 1516 "synthesize.cpp"
              var $159=HEAPU8[($type223)]; //@line 1516 "synthesize.cpp"
              var $conv224=((($159))&255); //@line 1516 "synthesize.cpp"
              var $cmp225=((($conv224))|0)==6; //@line 1516 "synthesize.cpp"
              if (!($cmp225)) { __label__ = 133;break $sw_epilog$$sw_bb$$sw_bb81$$sw_bb105$$sw_bb118$$sw_bb229$$sw_bb313$$sw_bb367$$sw_bb418$45; } //@line 1516 "synthesize.cpp"
  
              __ZL7DoPauseii(12, 0); //@line 1517 "synthesize.cpp"
              ; //@line 1517 "synthesize.cpp"
            }
            else if (__label__ == 67) {
  
              var $160=$next; //@line 1522 "synthesize.cpp"
              var $type230=(($160+15)&4294967295); //@line 1522 "synthesize.cpp"
              var $161=HEAPU8[($type230)]; //@line 1522 "synthesize.cpp"
              var $conv231=((($161))&255); //@line 1522 "synthesize.cpp"
              var $cmp232=((($conv231))|0)==2; //@line 1522 "synthesize.cpp"
              if ($cmp232) { __label__ = 68;; } else { __label__ = 69;; } //@line 1522 "synthesize.cpp"
              $if_then233$$if_else243$91: do { 
                if (__label__ == 68) {
  
                  var $162=$p; //@line 1524 "synthesize.cpp"
                  var $amp234=(($162+18)&4294967295); //@line 1524 "synthesize.cpp"
                  var $163=HEAPU8[($amp234)]; //@line 1524 "synthesize.cpp"
                  var $conv235=((($163))&255); //@line 1524 "synthesize.cpp"
                  __ZL11DoAmplitudeiPh($conv235, 0); //@line 1524 "synthesize.cpp"
                  var $164=$p; //@line 1525 "synthesize.cpp"
                  var $env236=(($164+14)&4294967295); //@line 1525 "synthesize.cpp"
                  var $165=HEAPU8[($env236)]; //@line 1525 "synthesize.cpp"
                  var $idxprom237=((($165))&255); //@line 1525 "synthesize.cpp"
                  var $arrayidx238=((_envelope_data+$idxprom237*4)&4294967295); //@line 1525 "synthesize.cpp"
                  var $166=HEAP32[(($arrayidx238)>>2)]; //@line 1525 "synthesize.cpp"
                  var $167=$p; //@line 1525 "synthesize.cpp"
                  var $pitch1239=(($167+20)&4294967295); //@line 1525 "synthesize.cpp"
                  var $168=HEAPU8[($pitch1239)]; //@line 1525 "synthesize.cpp"
                  var $conv240=((($168))&255); //@line 1525 "synthesize.cpp"
                  var $169=$p; //@line 1525 "synthesize.cpp"
                  var $pitch2241=(($169+21)&4294967295); //@line 1525 "synthesize.cpp"
                  var $170=HEAPU8[($pitch2241)]; //@line 1525 "synthesize.cpp"
                  var $conv242=((($170))&255); //@line 1525 "synthesize.cpp"
                  __ZL7DoPitchPhii($166, $conv240, $conv242); //@line 1525 "synthesize.cpp"
                  ; //@line 1526 "synthesize.cpp"
                }
                else if (__label__ == 69) {
  
                  var $171=$next; //@line 1528 "synthesize.cpp"
                  var $type244=(($171+15)&4294967295); //@line 1528 "synthesize.cpp"
                  var $172=HEAPU8[($type244)]; //@line 1528 "synthesize.cpp"
                  var $conv245=((($172))&255); //@line 1528 "synthesize.cpp"
                  var $cmp246=((($conv245))|0)==3; //@line 1528 "synthesize.cpp"
                  if ($cmp246) { __label__ = 70;; } else { __label__ = 71;; } //@line 1528 "synthesize.cpp"
                  if (__label__ == 70) {
  
                    var $173=$next; //@line 1530 "synthesize.cpp"
                    var $amp248=(($173+18)&4294967295); //@line 1530 "synthesize.cpp"
                    var $174=HEAPU8[($amp248)]; //@line 1530 "synthesize.cpp"
                    var $conv249=((($174))&255); //@line 1530 "synthesize.cpp"
                    __ZL11DoAmplitudeiPh($conv249, 0); //@line 1530 "synthesize.cpp"
                    var $175=$next; //@line 1531 "synthesize.cpp"
                    var $env250=(($175+14)&4294967295); //@line 1531 "synthesize.cpp"
                    var $176=HEAPU8[($env250)]; //@line 1531 "synthesize.cpp"
                    var $idxprom251=((($176))&255); //@line 1531 "synthesize.cpp"
                    var $arrayidx252=((_envelope_data+$idxprom251*4)&4294967295); //@line 1531 "synthesize.cpp"
                    var $177=HEAP32[(($arrayidx252)>>2)]; //@line 1531 "synthesize.cpp"
                    var $178=$next; //@line 1531 "synthesize.cpp"
                    var $pitch1253=(($178+20)&4294967295); //@line 1531 "synthesize.cpp"
                    var $179=HEAPU8[($pitch1253)]; //@line 1531 "synthesize.cpp"
                    var $conv254=((($179))&255); //@line 1531 "synthesize.cpp"
                    var $180=$next; //@line 1531 "synthesize.cpp"
                    var $pitch2255=(($180+21)&4294967295); //@line 1531 "synthesize.cpp"
                    var $181=HEAPU8[($pitch2255)]; //@line 1531 "synthesize.cpp"
                    var $conv256=((($181))&255); //@line 1531 "synthesize.cpp"
                    __ZL7DoPitchPhii($177, $conv254, $conv256); //@line 1531 "synthesize.cpp"
                    ; //@line 1532 "synthesize.cpp"
                  }
                  else if (__label__ == 71) {
  
                    var $182=HEAP32[((__ZL14last_pitch_cmd)>>2)]; //@line 1535 "synthesize.cpp"
                    var $cmp258=((($182))|0) < 0; //@line 1535 "synthesize.cpp"
                    if (!($cmp258)) { __label__ = 73;break $if_then233$$if_else243$91; } //@line 1535 "synthesize.cpp"
  
                    var $183=$p; //@line 1537 "synthesize.cpp"
                    var $amp260=(($183+18)&4294967295); //@line 1537 "synthesize.cpp"
                    var $184=HEAPU8[($amp260)]; //@line 1537 "synthesize.cpp"
                    var $conv261=((($184))&255); //@line 1537 "synthesize.cpp"
                    __ZL11DoAmplitudeiPh($conv261, 0); //@line 1537 "synthesize.cpp"
                    var $185=$p; //@line 1538 "synthesize.cpp"
                    var $env262=(($185+14)&4294967295); //@line 1538 "synthesize.cpp"
                    var $186=HEAPU8[($env262)]; //@line 1538 "synthesize.cpp"
                    var $idxprom263=((($186))&255); //@line 1538 "synthesize.cpp"
                    var $arrayidx264=((_envelope_data+$idxprom263*4)&4294967295); //@line 1538 "synthesize.cpp"
                    var $187=HEAP32[(($arrayidx264)>>2)]; //@line 1538 "synthesize.cpp"
                    var $188=$p; //@line 1538 "synthesize.cpp"
                    var $pitch1265=(($188+20)&4294967295); //@line 1538 "synthesize.cpp"
                    var $189=HEAPU8[($pitch1265)]; //@line 1538 "synthesize.cpp"
                    var $conv266=((($189))&255); //@line 1538 "synthesize.cpp"
                    var $190=$p; //@line 1538 "synthesize.cpp"
                    var $pitch2267=(($190+21)&4294967295); //@line 1538 "synthesize.cpp"
                    var $191=HEAPU8[($pitch2267)]; //@line 1538 "synthesize.cpp"
                    var $conv268=((($191))&255); //@line 1538 "synthesize.cpp"
                    __ZL7DoPitchPhii($187, $conv266, $conv268); //@line 1538 "synthesize.cpp"
                    ; //@line 1539 "synthesize.cpp"
                  }
                }
              } while(0);
  
              var $192=$next; //@line 1542 "synthesize.cpp"
              var $type272=(($192+15)&4294967295); //@line 1542 "synthesize.cpp"
              var $193=HEAPU8[($type272)]; //@line 1542 "synthesize.cpp"
              var $conv273=((($193))&255); //@line 1542 "synthesize.cpp"
              var $cmp274=((($conv273))|0)==2; //@line 1542 "synthesize.cpp"
              if ($cmp274) { __label__ = 76;; } else { __label__ = 74;; } //@line 1542 "synthesize.cpp"
              $if_then283$$lor_lhs_false275$99: do { 
                if (__label__ == 74) {
  
                  var $194=$next; //@line 1542 "synthesize.cpp"
                  var $type276=(($194+15)&4294967295); //@line 1542 "synthesize.cpp"
                  var $195=HEAPU8[($type276)]; //@line 1542 "synthesize.cpp"
                  var $conv277=((($195))&255); //@line 1542 "synthesize.cpp"
                  var $cmp278=((($conv277))|0)==3; //@line 1542 "synthesize.cpp"
                  if ($cmp278) { __label__ = 75;; } else { __label__ = 77;; } //@line 1542 "synthesize.cpp"
                  if (__label__ == 75) {
  
                    var $196=$next; //@line 1542 "synthesize.cpp"
                    var $newword280=(($196+19)&4294967295); //@line 1542 "synthesize.cpp"
                    var $197=HEAPU8[($newword280)]; //@line 1542 "synthesize.cpp"
                    var $conv281=((($197))&255); //@line 1542 "synthesize.cpp"
                    var $cmp282=((($conv281))|0)==0; //@line 1542 "synthesize.cpp"
                    if ($cmp282) { __label__ = 76;break $if_then283$$lor_lhs_false275$99; } //@line 1542 "synthesize.cpp"
                  }
  
                  var $198=$p; //@line 1548 "synthesize.cpp"
                  var $synthflags285=(($198+4)&4294967295); //@line 1548 "synthesize.cpp"
                  var $199=HEAPU16[(($synthflags285)>>1)]; //@line 1548 "synthesize.cpp"
                  var $conv286=((($199))&65535); //@line 1548 "synthesize.cpp"
                  var $or287=($conv286) | 8192; //@line 1548 "synthesize.cpp"
                  var $conv288=((($or287)) & 65535); //@line 1548 "synthesize.cpp"
                  HEAP16[(($synthflags285)>>1)]=$conv288; //@line 1548 "synthesize.cpp"
                  __label__ = 78;break $if_then283$$lor_lhs_false275$99;
                }
              } while(0);
              if (__label__ == 76) {
  
                __ZL13StartSyllablev(); //@line 1544 "synthesize.cpp"
                ; //@line 1545 "synthesize.cpp"
              }
  
              var $200=$p; //@line 1550 "synthesize.cpp"
              __Z16InterpretPhonemeP10TranslatoriP12PHONEME_LISTP12PHONEME_DATA(0, 0, $200, $phdata); //@line 1550 "synthesize.cpp"
              var $dest$, $stop$, $stop4$, $fast$, $value4$;
              $dest$ = $9;
              $stop$ = $dest$ + 48;
              $value4$ = 0;
              if ($value4$ < 0) $value4$ += 256;
              $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
              while ($dest$%4 !== 0 && $dest$ < $stop$) {
                ;; HEAP8[$dest$++] = 0;
              }
              $dest$ >>= 2;
              $stop4$ = $stop$ >> 2;
              while ($dest$ < $stop4$) {
              ;;;;;;;  HEAP32[$dest$++] = $value4$;
              }
              $dest$ <<= 2;
              while ($dest$ < $stop$) {
                ;; HEAP8[$dest$++] = 0;
              }; //@line 1551 "synthesize.cpp"
              var $201=HEAP32[(($arrayidx290)>>2)]; //@line 1552 "synthesize.cpp"
              var $mul=((($201)*2)&4294967295); //@line 1552 "synthesize.cpp"
              HEAP32[(($std_length)>>2)]=$mul; //@line 1552 "synthesize.cpp"
              var $202=HEAP32[(($arrayidx292)>>2)]; //@line 1553 "synthesize.cpp"
              HEAP32[(($fmt_addr293)>>2)]=$202; //@line 1553 "synthesize.cpp"
              var $203=HEAP32[(($arrayidx295)>>2)]; //@line 1554 "synthesize.cpp"
              HEAP32[(($fmt_amp296)>>2)]=$203; //@line 1554 "synthesize.cpp"
              var $204=HEAP32[(($arrayidx298)>>2)]; //@line 1555 "synthesize.cpp"
              HEAP32[(($wav_addr299)>>2)]=$204; //@line 1555 "synthesize.cpp"
              var $205=HEAP32[(($arrayidx301)>>2)]; //@line 1556 "synthesize.cpp"
              HEAP32[(($wav_amp302)>>2)]=$205; //@line 1556 "synthesize.cpp"
              var $206=$p; //@line 1558 "synthesize.cpp"
              var $synthflags303=(($206+4)&4294967295); //@line 1558 "synthesize.cpp"
              var $207=HEAPU16[(($synthflags303)>>1)]; //@line 1558 "synthesize.cpp"
              var $conv304=((($207))&65535); //@line 1558 "synthesize.cpp"
              var $and305=($conv304) & 8; //@line 1558 "synthesize.cpp"
              var $tobool306=((($and305))|0)!=0; //@line 1558 "synthesize.cpp"
              if ($tobool306) { __label__ = 79;; } else { __label__ = 80;; } //@line 1558 "synthesize.cpp"
              if (__label__ == 79) {
  
                var $208=$p; //@line 1559 "synthesize.cpp"
                var $ph308=(($208+8)&4294967295); //@line 1559 "synthesize.cpp"
                var $209=HEAP32[(($ph308)>>2)]; //@line 1559 "synthesize.cpp"
                var $210=$p; //@line 1559 "synthesize.cpp"
                var $call309=__Z8DoSpect2P11PHONEME_TABiP10FMT_PARAMSP12PHONEME_LISTi($209, 0, $fmtp, $210, 0); //@line 1559 "synthesize.cpp"
                ; //@line 1559 "synthesize.cpp"
              }
  
              var $211=$p; //@line 1560 "synthesize.cpp"
              var $ph311=(($211+8)&4294967295); //@line 1560 "synthesize.cpp"
              var $212=HEAP32[(($ph311)>>2)]; //@line 1560 "synthesize.cpp"
              var $213=$p; //@line 1560 "synthesize.cpp"
              var $call312=__Z8DoSpect2P11PHONEME_TABiP10FMT_PARAMSP12PHONEME_LISTi($212, 0, $fmtp, $213, 0); //@line 1560 "synthesize.cpp"
              ; //@line 1561 "synthesize.cpp"
            }
            else if (__label__ == 81) {
  
              var $dest$, $stop$, $stop4$, $fast$, $value4$;
              $dest$ = $10;
              $stop$ = $dest$ + 48;
              $value4$ = 0;
              if ($value4$ < 0) $value4$ += 256;
              $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
              while ($dest$%4 !== 0 && $dest$ < $stop$) {
                ;; HEAP8[$dest$++] = 0;
              }
              $dest$ >>= 2;
              $stop4$ = $stop$ >> 2;
              while ($dest$ < $stop4$) {
              ;;;;;;;  HEAP32[$dest$++] = $value4$;
              }
              $dest$ <<= 2;
              while ($dest$ < $stop$) {
                ;; HEAP8[$dest$++] = 0;
              }; //@line 1564 "synthesize.cpp"
              var $214=$p; //@line 1565 "synthesize.cpp"
              var $synthflags314=(($214+4)&4294967295); //@line 1565 "synthesize.cpp"
              var $215=HEAPU16[(($synthflags314)>>1)]; //@line 1565 "synthesize.cpp"
              var $conv315=((($215))&65535); //@line 1565 "synthesize.cpp"
              var $and316=($conv315) & 1; //@line 1565 "synthesize.cpp"
              var $tobool317=((($and316))|0)!=0; //@line 1565 "synthesize.cpp"
              if ($tobool317) { __label__ = 83;; } else { __label__ = 82;; } //@line 1565 "synthesize.cpp"
              if (__label__ == 82) {
  
                var $216=$p; //@line 1567 "synthesize.cpp"
                var $amp319=(($216+18)&4294967295); //@line 1567 "synthesize.cpp"
                var $217=HEAPU8[($amp319)]; //@line 1567 "synthesize.cpp"
                var $conv320=((($217))&255); //@line 1567 "synthesize.cpp"
                __ZL11DoAmplitudeiPh($conv320, 0); //@line 1567 "synthesize.cpp"
                var $218=$p; //@line 1568 "synthesize.cpp"
                var $env321=(($218+14)&4294967295); //@line 1568 "synthesize.cpp"
                var $219=HEAPU8[($env321)]; //@line 1568 "synthesize.cpp"
                var $idxprom322=((($219))&255); //@line 1568 "synthesize.cpp"
                var $arrayidx323=((_envelope_data+$idxprom322*4)&4294967295); //@line 1568 "synthesize.cpp"
                var $220=HEAP32[(($arrayidx323)>>2)]; //@line 1568 "synthesize.cpp"
                var $221=$p; //@line 1568 "synthesize.cpp"
                var $pitch1324=(($221+20)&4294967295); //@line 1568 "synthesize.cpp"
                var $222=HEAPU8[($pitch1324)]; //@line 1568 "synthesize.cpp"
                var $conv325=((($222))&255); //@line 1568 "synthesize.cpp"
                var $223=$p; //@line 1568 "synthesize.cpp"
                var $pitch2326=(($223+21)&4294967295); //@line 1568 "synthesize.cpp"
                var $224=HEAPU8[($pitch2326)]; //@line 1568 "synthesize.cpp"
                var $conv327=((($224))&255); //@line 1568 "synthesize.cpp"
                __ZL7DoPitchPhii($220, $conv325, $conv327); //@line 1568 "synthesize.cpp"
                ; //@line 1569 "synthesize.cpp"
              }
  
              var $225=$prev; //@line 1571 "synthesize.cpp"
              var $type329=(($225+15)&4294967295); //@line 1571 "synthesize.cpp"
              var $226=HEAPU8[($type329)]; //@line 1571 "synthesize.cpp"
              var $conv330=((($226))&255); //@line 1571 "synthesize.cpp"
              var $cmp331=((($conv330))|0)==8; //@line 1571 "synthesize.cpp"
              if ($cmp331) { __label__ = 84;; } else { __label__ = 85;; } //@line 1571 "synthesize.cpp"
              if (__label__ == 84) {
  
                HEAP32[((__ZL10last_frame)>>2)]=0; //@line 1573 "synthesize.cpp"
                ; //@line 1574 "synthesize.cpp"
              }
  
              var $227=$p; //@line 1576 "synthesize.cpp"
              __Z16InterpretPhonemeP10TranslatoriP12PHONEME_LISTP12PHONEME_DATA(0, 0, $227, $phdata); //@line 1576 "synthesize.cpp"
              var $228=HEAP32[(($arrayidx335)>>2)]; //@line 1577 "synthesize.cpp"
              var $mul336=((($228)*2)&4294967295); //@line 1577 "synthesize.cpp"
              HEAP32[(($std_length337)>>2)]=$mul336; //@line 1577 "synthesize.cpp"
              var $229=HEAP32[(($arrayidx339)>>2)]; //@line 1578 "synthesize.cpp"
              HEAP32[(($fmt_addr340)>>2)]=$229; //@line 1578 "synthesize.cpp"
              var $230=HEAP32[(($arrayidx342)>>2)]; //@line 1579 "synthesize.cpp"
              HEAP32[(($fmt_amp343)>>2)]=$230; //@line 1579 "synthesize.cpp"
              var $231=$next; //@line 1581 "synthesize.cpp"
              var $type344=(($231+15)&4294967295); //@line 1581 "synthesize.cpp"
              var $232=HEAPU8[($type344)]; //@line 1581 "synthesize.cpp"
              var $conv345=((($232))&255); //@line 1581 "synthesize.cpp"
              var $cmp346=((($conv345))|0)==2; //@line 1581 "synthesize.cpp"
              if ($cmp346) { __label__ = 86;; } else { __label__ = 87;; } //@line 1581 "synthesize.cpp"
              if (__label__ == 86) {
  
                __ZL13StartSyllablev(); //@line 1583 "synthesize.cpp"
                var $233=$p; //@line 1584 "synthesize.cpp"
                var $ph348=(($233+8)&4294967295); //@line 1584 "synthesize.cpp"
                var $234=HEAP32[(($ph348)>>2)]; //@line 1584 "synthesize.cpp"
                var $235=$p; //@line 1584 "synthesize.cpp"
                var $call349=__Z8DoSpect2P11PHONEME_TABiP10FMT_PARAMSP12PHONEME_LISTi($234, 0, $fmtp, $235, 0); //@line 1584 "synthesize.cpp"
                ; //@line 1585 "synthesize.cpp"
              }
              else if (__label__ == 87) {
  
                var $236=$prev; //@line 1587 "synthesize.cpp"
                var $type351=(($236+15)&4294967295); //@line 1587 "synthesize.cpp"
                var $237=HEAPU8[($type351)]; //@line 1587 "synthesize.cpp"
                var $conv352=((($237))&255); //@line 1587 "synthesize.cpp"
                var $cmp353=((($conv352))|0)==2; //@line 1587 "synthesize.cpp"
                if ($cmp353) { __label__ = 88;; } else { __label__ = 90;; } //@line 1587 "synthesize.cpp"
                $land_lhs_true354$$if_else362$120: do { 
                  if (__label__ == 88) {
  
                    var $238=$p; //@line 1587 "synthesize.cpp"
                    var $synthflags355=(($238+4)&4294967295); //@line 1587 "synthesize.cpp"
                    var $239=HEAPU16[(($synthflags355)>>1)]; //@line 1587 "synthesize.cpp"
                    var $conv356=((($239))&65535); //@line 1587 "synthesize.cpp"
                    var $and357=($conv356) & 1; //@line 1587 "synthesize.cpp"
                    var $tobool358=((($and357))|0)!=0; //@line 1587 "synthesize.cpp"
                    if (!($tobool358)) { __label__ = 90;break $land_lhs_true354$$if_else362$120; } //@line 1587 "synthesize.cpp"
  
                    var $240=$p; //@line 1589 "synthesize.cpp"
                    var $ph360=(($240+8)&4294967295); //@line 1589 "synthesize.cpp"
                    var $241=HEAP32[(($ph360)>>2)]; //@line 1589 "synthesize.cpp"
                    var $242=$p; //@line 1589 "synthesize.cpp"
                    var $call361=__Z8DoSpect2P11PHONEME_TABiP10FMT_PARAMSP12PHONEME_LISTi($241, 0, $fmtp, $242, 0); //@line 1589 "synthesize.cpp"
                    __label__ = 133;break $sw_epilog$$sw_bb$$sw_bb81$$sw_bb105$$sw_bb118$$sw_bb229$$sw_bb313$$sw_bb367$$sw_bb418$45; //@line 1590 "synthesize.cpp"
                  }
                } while(0);
  
                HEAP32[((__ZL10last_frame)>>2)]=0; //@line 1593 "synthesize.cpp"
                var $243=$p; //@line 1594 "synthesize.cpp"
                var $ph363=(($243+8)&4294967295); //@line 1594 "synthesize.cpp"
                var $244=HEAP32[(($ph363)>>2)]; //@line 1594 "synthesize.cpp"
                var $245=$p; //@line 1594 "synthesize.cpp"
                var $call364=__Z8DoSpect2P11PHONEME_TABiP10FMT_PARAMSP12PHONEME_LISTi($244, 0, $fmtp, $245, 0); //@line 1594 "synthesize.cpp"
                HEAP32[((__ZL10last_frame)>>2)]=0; //@line 1595 "synthesize.cpp"
                ;
              }
            }
            else if (__label__ == 91) {
  
              var $dest$, $stop$, $stop4$, $fast$, $value4$;
              $dest$ = $11;
              $stop$ = $dest$ + 48;
              $value4$ = 0;
              if ($value4$ < 0) $value4$ += 256;
              $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
              while ($dest$%4 !== 0 && $dest$ < $stop$) {
                ;; HEAP8[$dest$++] = 0;
              }
              $dest$ >>= 2;
              $stop4$ = $stop$ >> 2;
              while ($dest$ < $stop4$) {
              ;;;;;;;  HEAP32[$dest$++] = $value4$;
              }
              $dest$ <<= 2;
              while ($dest$ < $stop$) {
                ;; HEAP8[$dest$++] = 0;
              }; //@line 1601 "synthesize.cpp"
              $modulation=0; //@line 1602 "synthesize.cpp"
              var $246=$p; //@line 1603 "synthesize.cpp"
              var $ph368=(($246+8)&4294967295); //@line 1603 "synthesize.cpp"
              var $247=HEAP32[(($ph368)>>2)]; //@line 1603 "synthesize.cpp"
              var $phflags369=(($247+4)&4294967295); //@line 1603 "synthesize.cpp"
              var $248=HEAP32[(($phflags369)>>2)]; //@line 1603 "synthesize.cpp"
              var $and370=($248) & 128; //@line 1603 "synthesize.cpp"
              var $tobool371=((($and370))|0)!=0; //@line 1603 "synthesize.cpp"
              if ($tobool371) { __label__ = 92;; } else { __label__ = 93;; } //@line 1603 "synthesize.cpp"
              if (__label__ == 92) {
  
                $modulation=5; //@line 1604 "synthesize.cpp"
                ; //@line 1604 "synthesize.cpp"
              }
  
              var $249=$prev; //@line 1606 "synthesize.cpp"
              var $ph374=(($249+8)&4294967295); //@line 1606 "synthesize.cpp"
              var $250=HEAP32[(($ph374)>>2)]; //@line 1606 "synthesize.cpp"
              $prev_ph=$250; //@line 1606 "synthesize.cpp"
              var $251=$p; //@line 1610 "synthesize.cpp"
              var $synthflags375=(($251+4)&4294967295); //@line 1610 "synthesize.cpp"
              var $252=HEAPU16[(($synthflags375)>>1)]; //@line 1610 "synthesize.cpp"
              var $conv376=((($252))&65535); //@line 1610 "synthesize.cpp"
              var $and377=($conv376) & 1; //@line 1610 "synthesize.cpp"
              var $tobool378=((($and377))|0)!=0; //@line 1610 "synthesize.cpp"
              if ($tobool378) { __label__ = 95;; } else { __label__ = 94;; } //@line 1610 "synthesize.cpp"
              if (__label__ == 94) {
  
                var $253=$p; //@line 1612 "synthesize.cpp"
                var $amp380=(($253+18)&4294967295); //@line 1612 "synthesize.cpp"
                var $254=HEAPU8[($amp380)]; //@line 1612 "synthesize.cpp"
                var $conv381=((($254))&255); //@line 1612 "synthesize.cpp"
                __ZL11DoAmplitudeiPh($conv381, 0); //@line 1612 "synthesize.cpp"
                var $255=$p; //@line 1613 "synthesize.cpp"
                var $env382=(($255+14)&4294967295); //@line 1613 "synthesize.cpp"
                var $256=HEAPU8[($env382)]; //@line 1613 "synthesize.cpp"
                var $idxprom383=((($256))&255); //@line 1613 "synthesize.cpp"
                var $arrayidx384=((_envelope_data+$idxprom383*4)&4294967295); //@line 1613 "synthesize.cpp"
                var $257=HEAP32[(($arrayidx384)>>2)]; //@line 1613 "synthesize.cpp"
                var $258=$p; //@line 1613 "synthesize.cpp"
                var $pitch1385=(($258+20)&4294967295); //@line 1613 "synthesize.cpp"
                var $259=HEAPU8[($pitch1385)]; //@line 1613 "synthesize.cpp"
                var $conv386=((($259))&255); //@line 1613 "synthesize.cpp"
                var $260=$p; //@line 1613 "synthesize.cpp"
                var $pitch2387=(($260+21)&4294967295); //@line 1613 "synthesize.cpp"
                var $261=HEAPU8[($pitch2387)]; //@line 1613 "synthesize.cpp"
                var $conv388=((($261))&255); //@line 1613 "synthesize.cpp"
                __ZL7DoPitchPhii($257, $conv386, $conv388); //@line 1613 "synthesize.cpp"
                ; //@line 1614 "synthesize.cpp"
              }
  
              var $262=$prev; //@line 1616 "synthesize.cpp"
              var $type390=(($262+15)&4294967295); //@line 1616 "synthesize.cpp"
              var $263=HEAPU8[($type390)]; //@line 1616 "synthesize.cpp"
              var $conv391=((($263))&255); //@line 1616 "synthesize.cpp"
              var $cmp392=((($conv391))|0)==8; //@line 1616 "synthesize.cpp"
              if ($cmp392) { __label__ = 96;; } else { __label__ = 97;; } //@line 1616 "synthesize.cpp"
              if (__label__ == 96) {
  
                HEAP32[((__ZL10last_frame)>>2)]=0; //@line 1618 "synthesize.cpp"
                ; //@line 1619 "synthesize.cpp"
              }
  
              var $264=$next; //@line 1621 "synthesize.cpp"
              var $type395=(($264+15)&4294967295); //@line 1621 "synthesize.cpp"
              var $265=HEAPU8[($type395)]; //@line 1621 "synthesize.cpp"
              var $conv396=((($265))&255); //@line 1621 "synthesize.cpp"
              var $cmp397=((($conv396))|0)==2; //@line 1621 "synthesize.cpp"
              if ($cmp397) { __label__ = 98;; } else { __label__ = 99;; } //@line 1621 "synthesize.cpp"
              if (__label__ == 98) {
  
                __ZL13StartSyllablev(); //@line 1623 "synthesize.cpp"
                ; //@line 1624 "synthesize.cpp"
              }
  
              var $266=$p; //@line 1625 "synthesize.cpp"
              __Z16InterpretPhonemeP10TranslatoriP12PHONEME_LISTP12PHONEME_DATA(0, 0, $266, $phdata); //@line 1625 "synthesize.cpp"
              var $267=HEAP32[(($arrayidx401)>>2)]; //@line 1626 "synthesize.cpp"
              var $mul402=((($267)*2)&4294967295); //@line 1626 "synthesize.cpp"
              HEAP32[(($std_length403)>>2)]=$mul402; //@line 1626 "synthesize.cpp"
              var $268=HEAP32[(($arrayidx405)>>2)]; //@line 1627 "synthesize.cpp"
              HEAP32[(($fmt_addr406)>>2)]=$268; //@line 1627 "synthesize.cpp"
              var $269=HEAP32[(($arrayidx408)>>2)]; //@line 1628 "synthesize.cpp"
              HEAP32[(($fmt_amp409)>>2)]=$269; //@line 1628 "synthesize.cpp"
              var $270=HEAP32[(($arrayidx411)>>2)]; //@line 1629 "synthesize.cpp"
              HEAP32[(($wav_addr412)>>2)]=$270; //@line 1629 "synthesize.cpp"
              var $271=HEAP32[(($arrayidx414)>>2)]; //@line 1630 "synthesize.cpp"
              HEAP32[(($wav_amp415)>>2)]=$271; //@line 1630 "synthesize.cpp"
              var $272=$p; //@line 1631 "synthesize.cpp"
              var $ph416=(($272+8)&4294967295); //@line 1631 "synthesize.cpp"
              var $273=HEAP32[(($ph416)>>2)]; //@line 1631 "synthesize.cpp"
              var $274=$p; //@line 1631 "synthesize.cpp"
              var $275=$modulation; //@line 1631 "synthesize.cpp"
              var $call417=__Z8DoSpect2P11PHONEME_TABiP10FMT_PARAMSP12PHONEME_LISTi($273, 0, $fmtp, $274, $275); //@line 1631 "synthesize.cpp"
              ; //@line 1633 "synthesize.cpp"
            }
            else if (__label__ == 100) {
  
              var $276=$p; //@line 1636 "synthesize.cpp"
              var $ph419=(($276+8)&4294967295); //@line 1636 "synthesize.cpp"
              var $277=HEAP32[(($ph419)>>2)]; //@line 1636 "synthesize.cpp"
              $ph=$277; //@line 1636 "synthesize.cpp"
              var $278=$p; //@line 1637 "synthesize.cpp"
              var $stresslevel=(($278+1)&4294967295); //@line 1637 "synthesize.cpp"
              var $279=HEAPU8[($stresslevel)]; //@line 1637 "synthesize.cpp"
              var $conv420=((($279))&255); //@line 1637 "synthesize.cpp"
              var $and421=($conv420) & 15; //@line 1637 "synthesize.cpp"
              $stress=$and421; //@line 1637 "synthesize.cpp"
              var $dest$, $stop$, $stop4$, $fast$, $value4$;
              $dest$ = $12;
              $stop$ = $dest$ + 48;
              $value4$ = 0;
              if ($value4$ < 0) $value4$ += 256;
              $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
              while ($dest$%4 !== 0 && $dest$ < $stop$) {
                ;; HEAP8[$dest$++] = 0;
              }
              $dest$ >>= 2;
              $stop4$ = $stop$ >> 2;
              while ($dest$ < $stop4$) {
              ;;;;;;;  HEAP32[$dest$++] = $value4$;
              }
              $dest$ <<= 2;
              while ($dest$ < $stop$) {
                ;; HEAP8[$dest$++] = 0;
              }; //@line 1639 "synthesize.cpp"
              var $280=$p; //@line 1641 "synthesize.cpp"
              __Z16InterpretPhonemeP10TranslatoriP12PHONEME_LISTP12PHONEME_DATA(0, 0, $280, $phdata); //@line 1641 "synthesize.cpp"
              var $281=HEAP32[(($arrayidx423)>>2)]; //@line 1642 "synthesize.cpp"
              var $mul424=((($281)*2)&4294967295); //@line 1642 "synthesize.cpp"
              HEAP32[(($std_length425)>>2)]=$mul424; //@line 1642 "synthesize.cpp"
              var $282=HEAP32[(($arrayidx427)>>2)]; //@line 1644 "synthesize.cpp"
              HEAP32[(($fmt_addr428)>>2)]=$282; //@line 1644 "synthesize.cpp"
              var $cmp429=((($282))|0)!=0; //@line 1644 "synthesize.cpp"
              if ($cmp429) { __label__ = 101;; } else { __label__ = 103;; } //@line 1644 "synthesize.cpp"
              $land_lhs_true430$$if_else437$138: do { 
                if (__label__ == 101) {
  
                  var $283=HEAP32[(($pd_control431)>>2)]; //@line 1644 "synthesize.cpp"
                  var $and432=($283) & 2; //@line 1644 "synthesize.cpp"
                  var $cmp433=((($and432))|0)==0; //@line 1644 "synthesize.cpp"
                  if (!($cmp433)) { __label__ = 103;break $land_lhs_true430$$if_else437$138; } //@line 1644 "synthesize.cpp"
  
                  var $284=HEAP32[(($arrayidx436)>>2)]; //@line 1647 "synthesize.cpp"
                  HEAP32[(($fmt_length)>>2)]=$284; //@line 1647 "synthesize.cpp"
                  __label__ = 107;break $land_lhs_true430$$if_else437$138; //@line 1648 "synthesize.cpp"
                }
              } while(0);
              $if_end454$$if_else437$141: do { 
                if (__label__ == 103) {
  
                  var $285=$prev; //@line 1650 "synthesize.cpp"
                  var $type438=(($285+15)&4294967295); //@line 1650 "synthesize.cpp"
                  var $286=HEAPU8[($type438)]; //@line 1650 "synthesize.cpp"
                  var $conv439=((($286))&255); //@line 1650 "synthesize.cpp"
                  var $cmp440=((($conv439))|0)!=0; //@line 1650 "synthesize.cpp"
                  if (!($cmp440)) { __label__ = 107;break $if_end454$$if_else437$141; } //@line 1650 "synthesize.cpp"
  
                  var $287=$prev; //@line 1653 "synthesize.cpp"
                  __Z16InterpretPhonemeP10TranslatoriP12PHONEME_LISTP12PHONEME_DATA(0, 0, $287, $phdata_prev); //@line 1653 "synthesize.cpp"
                  var $288=HEAP32[(($arrayidx443)>>2)]; //@line 1654 "synthesize.cpp"
                  HEAP32[(($fmt_addr444)>>2)]=$288; //@line 1654 "synthesize.cpp"
                  var $cmp445=((($288))|0)!=0; //@line 1654 "synthesize.cpp"
                  if ($cmp445) { __label__ = 105;; } else { __label__ = 106;; } //@line 1654 "synthesize.cpp"
                  if (__label__ == 105) {
  
                    var $289=HEAP32[(($arrayidx448)>>2)]; //@line 1657 "synthesize.cpp"
                    HEAP32[(($fmt2_lenadj)>>2)]=$289; //@line 1657 "synthesize.cpp"
                    ; //@line 1658 "synthesize.cpp"
                  }
  
                  var $290=HEAP32[(($arrayidx450)>>2)]; //@line 1659 "synthesize.cpp"
                  HEAP32[(($transition0)>>2)]=$290; //@line 1659 "synthesize.cpp"
                  var $291=HEAP32[(($arrayidx452)>>2)]; //@line 1660 "synthesize.cpp"
                  HEAP32[(($transition1)>>2)]=$291; //@line 1660 "synthesize.cpp"
                  ; //@line 1661 "synthesize.cpp"
                }
              } while(0);
  
              var $292=HEAP32[(($fmt_addr455)>>2)]; //@line 1663 "synthesize.cpp"
              var $cmp456=((($292))|0)==0; //@line 1663 "synthesize.cpp"
              if ($cmp456) { __label__ = 108;; } else { __label__ = 109;; } //@line 1663 "synthesize.cpp"
              if (__label__ == 108) {
  
                HEAP32[(($use_vowelin)>>2)]=1; //@line 1666 "synthesize.cpp"
                HEAP32[(($fmt_control458)>>2)]=1; //@line 1667 "synthesize.cpp"
                var $293=HEAP32[(($arrayidx460)>>2)]; //@line 1668 "synthesize.cpp"
                HEAP32[(($fmt_addr461)>>2)]=$293; //@line 1668 "synthesize.cpp"
                ; //@line 1669 "synthesize.cpp"
              }
  
              var $294=HEAP32[(($arrayidx464)>>2)]; //@line 1671 "synthesize.cpp"
              HEAP32[(($fmt_amp465)>>2)]=$294; //@line 1671 "synthesize.cpp"
              var $295=$p; //@line 1673 "synthesize.cpp"
              var $env466=(($295+14)&4294967295); //@line 1673 "synthesize.cpp"
              var $296=HEAPU8[($env466)]; //@line 1673 "synthesize.cpp"
              var $idxprom467=((($296))&255); //@line 1673 "synthesize.cpp"
              var $arrayidx468=((_envelope_data+$idxprom467*4)&4294967295); //@line 1673 "synthesize.cpp"
              var $297=HEAP32[(($arrayidx468)>>2)]; //@line 1673 "synthesize.cpp"
              $pitch_env=$297; //@line 1673 "synthesize.cpp"
              $amp_env=0; //@line 1674 "synthesize.cpp"
              var $298=$p; //@line 1675 "synthesize.cpp"
              var $tone_ph=(($298+3)&4294967295); //@line 1675 "synthesize.cpp"
              var $299=HEAPU8[($tone_ph)]; //@line 1675 "synthesize.cpp"
              var $conv469=((($299))&255); //@line 1675 "synthesize.cpp"
              var $cmp470=((($conv469))|0)!=0; //@line 1675 "synthesize.cpp"
              if ($cmp470) { __label__ = 110;; } else { __label__ = 112;; } //@line 1675 "synthesize.cpp"
              $if_then471$$if_end482$151: do { 
                if (__label__ == 110) {
  
                  var $300=$p; //@line 1677 "synthesize.cpp"
                  var $tone_ph472=(($300+3)&4294967295); //@line 1677 "synthesize.cpp"
                  var $301=HEAPU8[($tone_ph472)]; //@line 1677 "synthesize.cpp"
                  var $conv473=((($301))&255); //@line 1677 "synthesize.cpp"
                  __Z17InterpretPhoneme2iP12PHONEME_DATA($conv473, $phdata_tone); //@line 1677 "synthesize.cpp"
                  var $302=HEAP32[(($pitch_env474)>>2)]; //@line 1678 "synthesize.cpp"
                  var $call475=__Z11GetEnvelopei($302); //@line 1678 "synthesize.cpp"
                  $pitch_env=$call475; //@line 1678 "synthesize.cpp"
                  var $303=HEAP32[(($amp_env476)>>2)]; //@line 1679 "synthesize.cpp"
                  var $cmp477=((($303))|0) > 0; //@line 1679 "synthesize.cpp"
                  if (!($cmp477)) { __label__ = 112;break $if_then471$$if_end482$151; } //@line 1679 "synthesize.cpp"
  
                  var $304=HEAP32[(($amp_env479)>>2)]; //@line 1680 "synthesize.cpp"
                  var $call480=__Z11GetEnvelopei($304); //@line 1680 "synthesize.cpp"
                  $amp_env=$call480; //@line 1680 "synthesize.cpp"
                  ; //@line 1680 "synthesize.cpp"
                }
              } while(0);
  
              __ZL13StartSyllablev(); //@line 1683 "synthesize.cpp"
              $modulation=2; //@line 1685 "synthesize.cpp"
              var $305=$stress; //@line 1686 "synthesize.cpp"
              var $cmp483=((($305))|0) <= 1; //@line 1686 "synthesize.cpp"
              if ($cmp483) { __label__ = 113;; } else { __label__ = 114;; } //@line 1686 "synthesize.cpp"
              $if_then484$$if_else485$155: do { 
                if (__label__ == 113) {
  
                  $modulation=1; //@line 1687 "synthesize.cpp"
                  ; //@line 1687 "synthesize.cpp"
                }
                else if (__label__ == 114) {
  
                  var $306=$stress; //@line 1689 "synthesize.cpp"
                  var $cmp486=((($306))|0) >= 7; //@line 1689 "synthesize.cpp"
                  if (!($cmp486)) { __label__ = 116;break $if_then484$$if_else485$155; } //@line 1689 "synthesize.cpp"
  
                  $modulation=3; //@line 1690 "synthesize.cpp"
                  ; //@line 1690 "synthesize.cpp"
                }
              } while(0);
  
              var $307=$prev; //@line 1692 "synthesize.cpp"
              var $type490=(($307+15)&4294967295); //@line 1692 "synthesize.cpp"
              var $308=HEAPU8[($type490)]; //@line 1692 "synthesize.cpp"
              var $conv491=((($308))&255); //@line 1692 "synthesize.cpp"
              var $cmp492=((($conv491))|0)==5; //@line 1692 "synthesize.cpp"
              if ($cmp492) { __label__ = 118;; } else { __label__ = 117;; } //@line 1692 "synthesize.cpp"
              $if_then497$$lor_lhs_false493$160: do { 
                if (__label__ == 117) {
  
                  var $309=$prev; //@line 1692 "synthesize.cpp"
                  var $type494=(($309+15)&4294967295); //@line 1692 "synthesize.cpp"
                  var $310=HEAPU8[($type494)]; //@line 1692 "synthesize.cpp"
                  var $conv495=((($310))&255); //@line 1692 "synthesize.cpp"
                  var $cmp496=((($conv495))|0)==7; //@line 1692 "synthesize.cpp"
                  if ($cmp496) { __label__ = 118;break $if_then497$$lor_lhs_false493$160; } //@line 1692 "synthesize.cpp"
  
                  var $322=$prev; //@line 1699 "synthesize.cpp"
                  var $type506=(($322+15)&4294967295); //@line 1699 "synthesize.cpp"
                  var $323=HEAPU8[($type506)]; //@line 1699 "synthesize.cpp"
                  var $conv507=((($323))&255); //@line 1699 "synthesize.cpp"
                  var $cmp508=((($conv507))|0)==3; //@line 1699 "synthesize.cpp"
                  if ($cmp508) { __label__ = 121;; } else { __label__ = 120;; } //@line 1699 "synthesize.cpp"
                  $if_then513$$lor_lhs_false509$163: do { 
                    if (__label__ == 120) {
  
                      var $324=$prev; //@line 1699 "synthesize.cpp"
                      var $type510=(($324+15)&4294967295); //@line 1699 "synthesize.cpp"
                      var $325=HEAPU8[($type510)]; //@line 1699 "synthesize.cpp"
                      var $conv511=((($325))&255); //@line 1699 "synthesize.cpp"
                      var $cmp512=((($conv511))|0)==8; //@line 1699 "synthesize.cpp"
                      if ($cmp512) { __label__ = 121;break $if_then513$$lor_lhs_false509$163; } //@line 1699 "synthesize.cpp"
  
                      var $337=$p; //@line 1707 "synthesize.cpp"
                      var $synthflags522=(($337+4)&4294967295); //@line 1707 "synthesize.cpp"
                      var $338=HEAPU16[(($synthflags522)>>1)]; //@line 1707 "synthesize.cpp"
                      var $conv523=((($338))&65535); //@line 1707 "synthesize.cpp"
                      var $and524=($conv523) & 1; //@line 1707 "synthesize.cpp"
                      var $tobool525=((($and524))|0)!=0; //@line 1707 "synthesize.cpp"
                      if ($tobool525) { __label__ = 124;; } else { __label__ = 123;; } //@line 1707 "synthesize.cpp"
                      if (__label__ == 123) {
  
                        var $339=$p; //@line 1709 "synthesize.cpp"
                        var $amp527=(($339+18)&4294967295); //@line 1709 "synthesize.cpp"
                        var $340=HEAPU8[($amp527)]; //@line 1709 "synthesize.cpp"
                        var $conv528=((($340))&255); //@line 1709 "synthesize.cpp"
                        var $341=$amp_env; //@line 1709 "synthesize.cpp"
                        __ZL11DoAmplitudeiPh($conv528, $341); //@line 1709 "synthesize.cpp"
                        var $342=$pitch_env; //@line 1710 "synthesize.cpp"
                        var $343=$p; //@line 1710 "synthesize.cpp"
                        var $pitch1529=(($343+20)&4294967295); //@line 1710 "synthesize.cpp"
                        var $344=HEAPU8[($pitch1529)]; //@line 1710 "synthesize.cpp"
                        var $conv530=((($344))&255); //@line 1710 "synthesize.cpp"
                        var $345=$p; //@line 1710 "synthesize.cpp"
                        var $pitch2531=(($345+21)&4294967295); //@line 1710 "synthesize.cpp"
                        var $346=HEAPU8[($pitch2531)]; //@line 1710 "synthesize.cpp"
                        var $conv532=((($346))&255); //@line 1710 "synthesize.cpp"
                        __ZL7DoPitchPhii($342, $conv530, $conv532); //@line 1710 "synthesize.cpp"
                        ; //@line 1711 "synthesize.cpp"
                      }
  
                      var $347=$ph; //@line 1713 "synthesize.cpp"
                      var $348=$p; //@line 1713 "synthesize.cpp"
                      var $349=$modulation; //@line 1713 "synthesize.cpp"
                      var $call534=__Z8DoSpect2P11PHONEME_TABiP10FMT_PARAMSP12PHONEME_LISTi($347, 1, $fmtp, $348, $349); //@line 1713 "synthesize.cpp"
                      __label__ = 125;break $if_then497$$lor_lhs_false493$160;
                    }
                  } while(0);
  
                  var $326=$p; //@line 1701 "synthesize.cpp"
                  var $amp514=(($326+18)&4294967295); //@line 1701 "synthesize.cpp"
                  var $327=HEAPU8[($amp514)]; //@line 1701 "synthesize.cpp"
                  var $conv515=((($327))&255); //@line 1701 "synthesize.cpp"
                  var $328=$amp_env; //@line 1701 "synthesize.cpp"
                  __ZL11DoAmplitudeiPh($conv515, $328); //@line 1701 "synthesize.cpp"
                  var $329=$ph; //@line 1702 "synthesize.cpp"
                  var $330=$p; //@line 1702 "synthesize.cpp"
                  var $331=$modulation; //@line 1702 "synthesize.cpp"
                  var $call516=__Z8DoSpect2P11PHONEME_TABiP10FMT_PARAMSP12PHONEME_LISTi($329, 1, $fmtp, $330, $331); //@line 1702 "synthesize.cpp"
                  var $332=$pitch_env; //@line 1703 "synthesize.cpp"
                  var $333=$p; //@line 1703 "synthesize.cpp"
                  var $pitch1517=(($333+20)&4294967295); //@line 1703 "synthesize.cpp"
                  var $334=HEAPU8[($pitch1517)]; //@line 1703 "synthesize.cpp"
                  var $conv518=((($334))&255); //@line 1703 "synthesize.cpp"
                  var $335=$p; //@line 1703 "synthesize.cpp"
                  var $pitch2519=(($335+21)&4294967295); //@line 1703 "synthesize.cpp"
                  var $336=HEAPU8[($pitch2519)]; //@line 1703 "synthesize.cpp"
                  var $conv520=((($336))&255); //@line 1703 "synthesize.cpp"
                  __ZL7DoPitchPhii($332, $conv518, $conv520); //@line 1703 "synthesize.cpp"
                  __label__ = 125;break $if_then497$$lor_lhs_false493$160; //@line 1704 "synthesize.cpp"
                }
              } while(0);
              if (__label__ == 118) {
  
                var $311=$p; //@line 1694 "synthesize.cpp"
                var $amp498=(($311+18)&4294967295); //@line 1694 "synthesize.cpp"
                var $312=HEAPU8[($amp498)]; //@line 1694 "synthesize.cpp"
                var $conv499=((($312))&255); //@line 1694 "synthesize.cpp"
                var $313=$amp_env; //@line 1694 "synthesize.cpp"
                __ZL11DoAmplitudeiPh($conv499, $313); //@line 1694 "synthesize.cpp"
                var $314=$pitch_env; //@line 1695 "synthesize.cpp"
                var $315=$p; //@line 1695 "synthesize.cpp"
                var $pitch1500=(($315+20)&4294967295); //@line 1695 "synthesize.cpp"
                var $316=HEAPU8[($pitch1500)]; //@line 1695 "synthesize.cpp"
                var $conv501=((($316))&255); //@line 1695 "synthesize.cpp"
                var $317=$p; //@line 1695 "synthesize.cpp"
                var $pitch2502=(($317+21)&4294967295); //@line 1695 "synthesize.cpp"
                var $318=HEAPU8[($pitch2502)]; //@line 1695 "synthesize.cpp"
                var $conv503=((($318))&255); //@line 1695 "synthesize.cpp"
                __ZL7DoPitchPhii($314, $conv501, $conv503); //@line 1695 "synthesize.cpp"
                var $319=$ph; //@line 1696 "synthesize.cpp"
                var $320=$p; //@line 1696 "synthesize.cpp"
                var $321=$modulation; //@line 1696 "synthesize.cpp"
                var $call504=__Z8DoSpect2P11PHONEME_TABiP10FMT_PARAMSP12PHONEME_LISTi($319, 1, $fmtp, $320, $321); //@line 1696 "synthesize.cpp"
                ; //@line 1697 "synthesize.cpp"
              }
  
              var $350=HEAP32[((_option_phoneme_events)>>2)]; //@line 1716 "synthesize.cpp"
              var $tobool537=((($350))|0)!=0; //@line 1716 "synthesize.cpp"
              if ($tobool537) { __label__ = 126;; } else { __label__ = 127;; } //@line 1716 "synthesize.cpp"
              if (__label__ == 126) {
  
                var $351=HEAP32[((__ZZ8GenerateP12PHONEME_LISTPiiE8sourceix)>>2)]; //@line 1718 "synthesize.cpp"
                var $352=$p; //@line 1718 "synthesize.cpp"
                var $ph539=(($352+8)&4294967295); //@line 1718 "synthesize.cpp"
                var $353=HEAP32[(($ph539)>>2)]; //@line 1718 "synthesize.cpp"
                var $mnemonic540=(($353)&4294967295); //@line 1718 "synthesize.cpp"
                var $354=HEAP32[(($mnemonic540)>>2)]; //@line 1718 "synthesize.cpp"
                __Z8DoMarkeriiii(7, $351, 0, $354); //@line 1718 "synthesize.cpp"
                ; //@line 1719 "synthesize.cpp"
              }
  
              var $355=HEAP32[(($arrayidx543)>>2)]; //@line 1721 "synthesize.cpp"
              HEAP32[(($fmt_addr544)>>2)]=$355; //@line 1721 "synthesize.cpp"
              var $356=HEAP32[(($arrayidx546)>>2)]; //@line 1722 "synthesize.cpp"
              HEAP32[(($fmt_amp547)>>2)]=$356; //@line 1722 "synthesize.cpp"
              HEAP32[(($transition0548)>>2)]=0; //@line 1723 "synthesize.cpp"
              HEAP32[(($transition1549)>>2)]=0; //@line 1724 "synthesize.cpp"
              var $357=HEAP32[(($arrayidx551)>>2)]; //@line 1726 "synthesize.cpp"
              HEAP32[(($fmt2_addr)>>2)]=$357; //@line 1726 "synthesize.cpp"
              var $cmp552=((($357))|0)!=0; //@line 1726 "synthesize.cpp"
              if ($cmp552) { __label__ = 128;; } else { __label__ = 129;; } //@line 1726 "synthesize.cpp"
              $if_then553$$if_else557$176: do { 
                if (__label__ == 128) {
  
                  var $358=HEAP32[(($arrayidx555)>>2)]; //@line 1728 "synthesize.cpp"
                  HEAP32[(($fmt2_lenadj556)>>2)]=$358; //@line 1728 "synthesize.cpp"
                  ; //@line 1729 "synthesize.cpp"
                }
                else if (__label__ == 129) {
  
                  var $359=$next; //@line 1731 "synthesize.cpp"
                  var $type558=(($359+15)&4294967295); //@line 1731 "synthesize.cpp"
                  var $360=HEAPU8[($type558)]; //@line 1731 "synthesize.cpp"
                  var $conv559=((($360))&255); //@line 1731 "synthesize.cpp"
                  var $cmp560=((($conv559))|0)!=0; //@line 1731 "synthesize.cpp"
                  if (!($cmp560)) { __label__ = 132;break $if_then553$$if_else557$176; } //@line 1731 "synthesize.cpp"
  
                  HEAP32[(($fmt2_lenadj562)>>2)]=0; //@line 1733 "synthesize.cpp"
                  var $361=$next; //@line 1734 "synthesize.cpp"
                  __Z16InterpretPhonemeP10TranslatoriP12PHONEME_LISTP12PHONEME_DATA(0, 0, $361, $phdata_next); //@line 1734 "synthesize.cpp"
                  HEAP32[(($use_vowelin563)>>2)]=1; //@line 1736 "synthesize.cpp"
                  var $362=HEAP32[(($arrayidx565)>>2)]; //@line 1737 "synthesize.cpp"
                  HEAP32[(($transition0566)>>2)]=$362; //@line 1737 "synthesize.cpp"
                  var $363=HEAP32[(($arrayidx568)>>2)]; //@line 1738 "synthesize.cpp"
                  HEAP32[(($transition1569)>>2)]=$363; //@line 1738 "synthesize.cpp"
                  var $364=HEAP32[(($arrayidx571)>>2)]; //@line 1740 "synthesize.cpp"
                  HEAP32[(($fmt2_addr572)>>2)]=$364; //@line 1740 "synthesize.cpp"
                  var $cmp573=((($364))|0)!=0; //@line 1740 "synthesize.cpp"
                  if (!($cmp573)) { __label__ = 132;break $if_then553$$if_else557$176; } //@line 1740 "synthesize.cpp"
  
                  var $365=HEAP32[(($arrayidx576)>>2)]; //@line 1742 "synthesize.cpp"
                  HEAP32[(($fmt2_lenadj577)>>2)]=$365; //@line 1742 "synthesize.cpp"
                  ; //@line 1743 "synthesize.cpp"
                }
              } while(0);
  
              var $366=$ph; //@line 1746 "synthesize.cpp"
              var $367=$p; //@line 1746 "synthesize.cpp"
              var $368=$modulation; //@line 1746 "synthesize.cpp"
              var $call581=__Z8DoSpect2P11PHONEME_TABiP10FMT_PARAMSP12PHONEME_LISTi($366, 2, $fmtp, $367, $368); //@line 1746 "synthesize.cpp"
              ; //@line 1748 "synthesize.cpp"
            }
          } while(0);
  
          var $369=HEAP32[((__ZZ8GenerateP12PHONEME_LISTPiiE2ix)>>2)]; //@line 1750 "synthesize.cpp"
          var $inc582=((($369)+1)&4294967295); //@line 1750 "synthesize.cpp"
          HEAP32[((__ZZ8GenerateP12PHONEME_LISTPiiE2ix)>>2)]=$inc582; //@line 1750 "synthesize.cpp"
          __label__ = 7;continue $while_cond$11; //@line 1751 "synthesize.cpp"
        }
        if (__label__ == 134) {
  
          __ZL8EndPitchi(1); //@line 1752 "synthesize.cpp"
          var $370=$n_ph_addr; //@line 1753 "synthesize.cpp"
          var $371=HEAP32[(($370)>>2)]; //@line 1753 "synthesize.cpp"
          var $cmp583=((($371))|0) > 0; //@line 1753 "synthesize.cpp"
          if ($cmp583) { __label__ = 135;; } else { __label__ = 136;; } //@line 1753 "synthesize.cpp"
          if (__label__ == 135) {
  
            var $372=HEAP32[((_count_characters)>>2)]; //@line 1755 "synthesize.cpp"
            var $373=HEAP32[((_count_sentences)>>2)]; //@line 1755 "synthesize.cpp"
            __Z8DoMarkeriiii(5, $372, 0, $373); //@line 1755 "synthesize.cpp"
            var $374=$n_ph_addr; //@line 1756 "synthesize.cpp"
            HEAP32[(($374)>>2)]=0; //@line 1756 "synthesize.cpp"
            ; //@line 1757 "synthesize.cpp"
          }
  
          $retval=0; //@line 1759 "synthesize.cpp"
          ; //@line 1759 "synthesize.cpp"
        }
        else if (__label__ == 14) {
  
          $retval=1; //@line 1365 "synthesize.cpp"
          ; //@line 1365 "synthesize.cpp"
        }
      }
    }
  
    var $375=$retval; //@line 1760 "synthesize.cpp"
    STACKTOP = __stackBase__;
    return $375; //@line 1760 "synthesize.cpp"
    return null;
  }
  

  function __ZL12EndAmplitudev() {
    ;
    var __label__;
  
    var $0=HEAP32[((__ZL10amp_length)>>2)]; //@line 110 "synthesize.cpp"
    var $cmp=((($0))|0) > 0; //@line 110 "synthesize.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 4;; } //@line 110 "synthesize.cpp"
    if (__label__ == 1) {
  
      var $1=HEAP32[((__ZL12last_amp_cmd)>>2)]; //@line 112 "synthesize.cpp"
      var $arrayidx=((_wcmdq+$1*16)&4294967295); //@line 112 "synthesize.cpp"
      var $arrayidx1=(($arrayidx+4)&4294967295); //@line 112 "synthesize.cpp"
      var $2=HEAP32[(($arrayidx1)>>2)]; //@line 112 "synthesize.cpp"
      var $cmp2=((($2))|0)==0; //@line 112 "synthesize.cpp"
      if ($cmp2) { __label__ = 2;; } else { __label__ = 3;; } //@line 112 "synthesize.cpp"
      if (__label__ == 2) {
  
        var $3=HEAP32[((__ZL10amp_length)>>2)]; //@line 113 "synthesize.cpp"
        var $4=HEAP32[((__ZL12last_amp_cmd)>>2)]; //@line 113 "synthesize.cpp"
        var $arrayidx4=((_wcmdq+$4*16)&4294967295); //@line 113 "synthesize.cpp"
        var $arrayidx5=(($arrayidx4+4)&4294967295); //@line 113 "synthesize.cpp"
        HEAP32[(($arrayidx5)>>2)]=$3; //@line 113 "synthesize.cpp"
        ; //@line 113 "synthesize.cpp"
      }
  
      HEAP32[((__ZL10amp_length)>>2)]=0; //@line 114 "synthesize.cpp"
      ; //@line 115 "synthesize.cpp"
    }
  
    ;
    return; //@line 116 "synthesize.cpp"
    return;
  }
  

  function __ZL11DoAmplitudeiPh($amp, $amp_env) {
    ;
    var __label__;
  
    var $amp_addr;
    var $amp_env_addr;
    var $q;
    $amp_addr=$amp;
    $amp_env_addr=$amp_env;
    var $0=HEAP32[((_wcmdq_tail)>>2)]; //@line 147 "synthesize.cpp"
    HEAP32[((__ZL12last_amp_cmd)>>2)]=$0; //@line 147 "synthesize.cpp"
    HEAP32[((__ZL10amp_length)>>2)]=0; //@line 148 "synthesize.cpp"
    var $1=HEAP32[((_wcmdq_tail)>>2)]; //@line 150 "synthesize.cpp"
    var $arrayidx=((_wcmdq+$1*16)&4294967295); //@line 150 "synthesize.cpp"
    var $arraydecay=(($arrayidx)&4294967295); //@line 150 "synthesize.cpp"
    $q=$arraydecay; //@line 150 "synthesize.cpp"
    var $2=$q; //@line 151 "synthesize.cpp"
    var $arrayidx1=(($2)&4294967295); //@line 151 "synthesize.cpp"
    HEAP32[(($arrayidx1)>>2)]=8; //@line 151 "synthesize.cpp"
    var $3=$q; //@line 152 "synthesize.cpp"
    var $arrayidx2=(($3+4)&4294967295); //@line 152 "synthesize.cpp"
    HEAP32[(($arrayidx2)>>2)]=0; //@line 152 "synthesize.cpp"
    var $4=$amp_env_addr; //@line 153 "synthesize.cpp"
    var $5=($4); //@line 153 "synthesize.cpp"
    var $6=$q; //@line 153 "synthesize.cpp"
    var $arrayidx3=(($6+8)&4294967295); //@line 153 "synthesize.cpp"
    HEAP32[(($arrayidx3)>>2)]=$5; //@line 153 "synthesize.cpp"
    var $7=$amp_addr; //@line 154 "synthesize.cpp"
    var $8=$q; //@line 154 "synthesize.cpp"
    var $arrayidx4=(($8+12)&4294967295); //@line 154 "synthesize.cpp"
    HEAP32[(($arrayidx4)>>2)]=$7; //@line 154 "synthesize.cpp"
    __Z8WcmdqIncv(); //@line 155 "synthesize.cpp"
    ;
    return; //@line 156 "synthesize.cpp"
    return;
  }
  

  function __ZL7DoPitchPhii($env, $pitch1, $pitch2) {
    ;
    var __label__;
  
    var $env_addr;
    var $pitch1_addr;
    var $pitch2_addr;
    var $q;
    $env_addr=$env;
    $pitch1_addr=$pitch1;
    $pitch2_addr=$pitch2;
    __ZL8EndPitchi(0); //@line 164 "synthesize.cpp"
    var $0=$pitch1_addr; //@line 166 "synthesize.cpp"
    var $cmp=((($0))|0)==255; //@line 166 "synthesize.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 166 "synthesize.cpp"
    $if_end_thread$$if_end$2: do { 
      if (__label__ == 1) {
  
        $pitch1_addr=55; //@line 169 "synthesize.cpp"
        $pitch2_addr=76; //@line 170 "synthesize.cpp"
        var $1=HEAP32[((((_envelope_data)&4294967295))>>2)]; //@line 171 "synthesize.cpp"
        $env_addr=$1; //@line 171 "synthesize.cpp"
        var $2=HEAP32[((_wcmdq_tail)>>2)]; //@line 173 "synthesize.cpp"
        HEAP32[((__ZL14last_pitch_cmd)>>2)]=$2; //@line 173 "synthesize.cpp"
        HEAP32[((__ZL12pitch_length)>>2)]=0; //@line 174 "synthesize.cpp"
        ; //@line 176 "synthesize.cpp"
      }
      else if (__label__ == 2) {
  
        var $_pr=$pitch2_addr; //@line 176 "synthesize.cpp"
        var $3=HEAP32[((_wcmdq_tail)>>2)]; //@line 173 "synthesize.cpp"
        HEAP32[((__ZL14last_pitch_cmd)>>2)]=$3; //@line 173 "synthesize.cpp"
        HEAP32[((__ZL12pitch_length)>>2)]=0; //@line 174 "synthesize.cpp"
        var $cmp1=((($_pr))|0) < 0; //@line 176 "synthesize.cpp"
        if (!($cmp1)) { __label__ = 4;break $if_end_thread$$if_end$2; } //@line 176 "synthesize.cpp"
  
        $pitch2_addr=0; //@line 177 "synthesize.cpp"
        ; //@line 177 "synthesize.cpp"
      }
    } while(0);
  
    var $4=HEAP32[((_wcmdq_tail)>>2)]; //@line 179 "synthesize.cpp"
    var $arrayidx=((_wcmdq+$4*16)&4294967295); //@line 179 "synthesize.cpp"
    var $arraydecay=(($arrayidx)&4294967295); //@line 179 "synthesize.cpp"
    $q=$arraydecay; //@line 179 "synthesize.cpp"
    var $5=$q; //@line 180 "synthesize.cpp"
    var $arrayidx4=(($5)&4294967295); //@line 180 "synthesize.cpp"
    HEAP32[(($arrayidx4)>>2)]=9; //@line 180 "synthesize.cpp"
    var $6=$q; //@line 181 "synthesize.cpp"
    var $arrayidx5=(($6+4)&4294967295); //@line 181 "synthesize.cpp"
    HEAP32[(($arrayidx5)>>2)]=0; //@line 181 "synthesize.cpp"
    var $7=$env_addr; //@line 182 "synthesize.cpp"
    var $8=($7); //@line 182 "synthesize.cpp"
    var $9=$q; //@line 182 "synthesize.cpp"
    var $arrayidx6=(($9+8)&4294967295); //@line 182 "synthesize.cpp"
    HEAP32[(($arrayidx6)>>2)]=$8; //@line 182 "synthesize.cpp"
    var $10=$pitch1_addr; //@line 183 "synthesize.cpp"
    var $shl=((($10)*65536)&4294967295); //@line 183 "synthesize.cpp"
    var $11=$pitch2_addr; //@line 183 "synthesize.cpp"
    var $add=((($shl)+($11))&4294967295); //@line 183 "synthesize.cpp"
    var $12=$q; //@line 183 "synthesize.cpp"
    var $arrayidx7=(($12+12)&4294967295); //@line 183 "synthesize.cpp"
    HEAP32[(($arrayidx7)>>2)]=$add; //@line 183 "synthesize.cpp"
    __Z8WcmdqIncv(); //@line 184 "synthesize.cpp"
    ;
    return; //@line 185 "synthesize.cpp"
    return;
  }
  

  function __ZL13StartSyllablev() {
    ;
    var __label__;
  
    var $0=HEAP32[((__ZL12syllable_end)>>2)]; //@line 981 "synthesize.cpp"
    var $1=HEAP32[((__ZL14syllable_start)>>2)]; //@line 981 "synthesize.cpp"
    var $cmp=((($0))|0)==((($1))|0); //@line 981 "synthesize.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 981 "synthesize.cpp"
    if (__label__ == 1) {
  
      var $2=HEAP32[((_wcmdq_tail)>>2)]; //@line 982 "synthesize.cpp"
      HEAP32[((__ZL12syllable_end)>>2)]=$2; //@line 982 "synthesize.cpp"
      ; //@line 982 "synthesize.cpp"
    }
  
    ;
    return; //@line 983 "synthesize.cpp"
    return;
  }
  

  function __Z12SynthOnTimerv() {
    ;
    var __label__;
  
    var $retval;
    var $_b=HEAPU8[(__ZL8timer_on_b)];
    var $0=((($_b))&1);
    var $tobool=((($0))|0)!=0; //@line 1770 "synthesize.cpp"
    if ($tobool) { __label__ = 2;; } else { __label__ = 1;; } //@line 1770 "synthesize.cpp"
    if (__label__ == 2) {
      while(1) { 
  
        var $call1=__Z9WcmdqUsedv(); //@line 1776 "synthesize.cpp"
        var $call5=__Z8GenerateP12PHONEME_LISTPii(((_phoneme_list)&4294967295), _n_phoneme_list, 1); //@line 1779 "synthesize.cpp"
        var $cmp6=((($call5))|0)==0; //@line 1779 "synthesize.cpp"
        if ($cmp6) { __label__ = 3;; } else { __label__ = 4;; } //@line 1779 "synthesize.cpp"
        if (__label__ == 3) {
  
          var $call8=__Z15SpeakNextClauseP7__sFILEPKvi(0, 0, 1); //@line 1781 "synthesize.cpp"
          ; //@line 1782 "synthesize.cpp"
        }
  
        var $1=HEAP32[((_skipping_text)>>2)]; //@line 1783 "synthesize.cpp"
        var $tobool10=((($1))|0)!=0; //@line 1783 "synthesize.cpp"
        if ($tobool10) { __label__ = 2;continue ; } else { __label__ = 5;break ; } //@line 1783 "synthesize.cpp"
      }
  
      $retval=0; //@line 1785 "synthesize.cpp"
      ; //@line 1785 "synthesize.cpp"
    }
    else if (__label__ == 1) {
  
      $retval=0; //@line 1772 "synthesize.cpp"
      ; //@line 1772 "synthesize.cpp"
    }
  
    var $2=$retval; //@line 1786 "synthesize.cpp"
    ;
    return $2; //@line 1786 "synthesize.cpp"
    return null;
  }
  

  function __Z15SpeakNextClauseP7__sFILEPKvi($f_in, $text_in, $control) {
    var __stackBase__  = STACKTOP; STACKTOP += 8; _memset(__stackBase__, 0, 8);
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $f_in_addr;
    var $text_in_addr;
    var $control_addr;
    var $clause_tone=__stackBase__;
    var $voice_change=__stackBase__+4;
    $f_in_addr=$f_in;
    $text_in_addr=$text_in;
    $control_addr=$control;
    var $0=$control_addr; //@line 1814 "synthesize.cpp"
    var $cmp=((($0))|0)==4; //@line 1814 "synthesize.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 4;; } //@line 1814 "synthesize.cpp"
    $if_then$$if_end$2: do { 
      if (__label__ == 1) {
  
        var $1=HEAP32[((__ZZ15SpeakNextClauseP7__sFILEPKviE6f_text)>>2)]; //@line 1816 "synthesize.cpp"
        var $cmp1=((($1))|0)==0; //@line 1816 "synthesize.cpp"
        var $2=HEAP32[((__ZZ15SpeakNextClauseP7__sFILEPKviE6p_text)>>2)]; //@line 1816 "synthesize.cpp"
        var $cmp2=((($2))|0)==0; //@line 1816 "synthesize.cpp"
        var $or_cond=($cmp1) & ($cmp2); //@line 1816 "synthesize.cpp"
        if ($or_cond) { __label__ = 2;; } else { __label__ = 3;; } //@line 1816 "synthesize.cpp"
        if (__label__ == 2) {
  
          $retval=0; //@line 1817 "synthesize.cpp"
          ; //@line 1817 "synthesize.cpp"
        }
        else if (__label__ == 3) {
  
          $retval=1; //@line 1819 "synthesize.cpp"
          ; //@line 1819 "synthesize.cpp"
        }
      }
      else if (__label__ == 4) {
  
        var $3=$control_addr; //@line 1822 "synthesize.cpp"
        var $cmp4=((($3))|0)==2; //@line 1822 "synthesize.cpp"
        if ($cmp4) { __label__ = 5;; } else { __label__ = 8;; } //@line 1822 "synthesize.cpp"
        if (__label__ == 5) {
  
          HEAP8[(__ZL8timer_on_b)]=0;
          HEAP32[((__ZZ15SpeakNextClauseP7__sFILEPKviE6p_text)>>2)]=0; //@line 1826 "synthesize.cpp"
          var $4=HEAP32[((__ZZ15SpeakNextClauseP7__sFILEPKviE6f_text)>>2)]; //@line 1827 "synthesize.cpp"
          var $cmp6=((($4))|0)!=0; //@line 1827 "synthesize.cpp"
          if ($cmp6) { __label__ = 6;; } else { __label__ = 7;; } //@line 1827 "synthesize.cpp"
          if (__label__ == 6) {
  
            var $5=HEAP32[((__ZZ15SpeakNextClauseP7__sFILEPKviE6f_text)>>2)]; //@line 1829 "synthesize.cpp"
            var $call=_fclose($5); //@line 1829 "synthesize.cpp"
            HEAP32[((__ZZ15SpeakNextClauseP7__sFILEPKviE6f_text)>>2)]=0; //@line 1830 "synthesize.cpp"
            ; //@line 1831 "synthesize.cpp"
          }
  
          HEAP32[((_n_phoneme_list)>>2)]=0; //@line 1832 "synthesize.cpp"
          __Z9WcmdqStopv(); //@line 1833 "synthesize.cpp"
          HEAP32[((((_embedded_value+24)&4294967295))>>2)]=0; //@line 1835 "synthesize.cpp"
          $retval=0; //@line 1836 "synthesize.cpp"
          ; //@line 1836 "synthesize.cpp"
        }
        else if (__label__ == 8) {
  
          var $6=$control_addr; //@line 1839 "synthesize.cpp"
          var $cmp10=((($6))|0)==3; //@line 1839 "synthesize.cpp"
          if ($cmp10) { __label__ = 9;; } else { __label__ = 13;; } //@line 1839 "synthesize.cpp"
          if (__label__ == 9) {
  
            var $_b=HEAPU8[(__ZL6paused_b)];
            var $7=($_b) ? 2 : 0;
            var $cmp12=((($7))|0)==0; //@line 1842 "synthesize.cpp"
            if ($cmp12) { __label__ = 10;; } else { __label__ = 11;; } //@line 1842 "synthesize.cpp"
            if (__label__ == 10) {
  
              HEAP8[(__ZL8timer_on_b)]=0;
              HEAP8[(__ZL6paused_b)]=1;
              ; //@line 1846 "synthesize.cpp"
            }
            else if (__label__ == 11) {
  
              HEAP8[(__ZL8timer_on_b)]=1;
              HEAP8[(__ZL6paused_b)]=0;
              var $call16=__Z8GenerateP12PHONEME_LISTPii(((_phoneme_list)&4294967295), _n_phoneme_list, 0); //@line 1852 "synthesize.cpp"
              ;
            }
  
            $retval=0; //@line 1854 "synthesize.cpp"
            ; //@line 1854 "synthesize.cpp"
          }
          else if (__label__ == 13) {
  
            var $8=$control_addr; //@line 1857 "synthesize.cpp"
            var $cmp19=((($8))|0)==5; //@line 1857 "synthesize.cpp"
            if ($cmp19) { __label__ = 14;; } else { __label__ = 15;; } //@line 1857 "synthesize.cpp"
            if (__label__ == 14) {
  
              HEAP32[((_n_phoneme_list)>>2)]=0; //@line 1860 "synthesize.cpp"
              __Z9WcmdqStopv(); //@line 1861 "synthesize.cpp"
              $retval=0; //@line 1862 "synthesize.cpp"
              ; //@line 1862 "synthesize.cpp"
            }
            else if (__label__ == 15) {
  
              var $9=$f_in_addr; //@line 1865 "synthesize.cpp"
              var $cmp22=((($9))|0)!=0; //@line 1865 "synthesize.cpp"
              if ($cmp22) { __label__ = 17;; } else { __label__ = 16;; } //@line 1865 "synthesize.cpp"
              $if_then24$$lor_lhs_false$24: do { 
                if (__label__ == 16) {
  
                  var $10=$text_in_addr; //@line 1865 "synthesize.cpp"
                  var $cmp23=((($10))|0)!=0; //@line 1865 "synthesize.cpp"
                  if ($cmp23) { __label__ = 17;break $if_then24$$lor_lhs_false$24; } else { __label__ = 18;break $if_then24$$lor_lhs_false$24; } //@line 1865 "synthesize.cpp"
                }
              } while(0);
              if (__label__ == 17) {
  
                var $11=$f_in_addr; //@line 1867 "synthesize.cpp"
                HEAP32[((__ZZ15SpeakNextClauseP7__sFILEPKviE6f_text)>>2)]=$11; //@line 1867 "synthesize.cpp"
                var $12=$text_in_addr; //@line 1868 "synthesize.cpp"
                HEAP32[((__ZZ15SpeakNextClauseP7__sFILEPKviE6p_text)>>2)]=$12; //@line 1868 "synthesize.cpp"
                HEAP8[(__ZL8timer_on_b)]=1;
                HEAP8[(__ZL6paused_b)]=0;
                ; //@line 1871 "synthesize.cpp"
              }
  
              var $13=HEAP32[((__ZZ15SpeakNextClauseP7__sFILEPKviE6f_text)>>2)]; //@line 1873 "synthesize.cpp"
              var $cmp26=((($13))|0)==0; //@line 1873 "synthesize.cpp"
              var $14=HEAP32[((__ZZ15SpeakNextClauseP7__sFILEPKviE6p_text)>>2)]; //@line 1873 "synthesize.cpp"
              var $cmp28=((($14))|0)==0; //@line 1873 "synthesize.cpp"
              var $or_cond1=($cmp26) & ($cmp28); //@line 1873 "synthesize.cpp"
              if ($or_cond1) { __label__ = 19;; } else { __label__ = 20;; } //@line 1873 "synthesize.cpp"
              if (__label__ == 19) {
  
                HEAP32[((_skipping_text)>>2)]=0; //@line 1875 "synthesize.cpp"
                HEAP8[(__ZL8timer_on_b)]=0;
                $retval=0; //@line 1877 "synthesize.cpp"
                ; //@line 1877 "synthesize.cpp"
              }
              else if (__label__ == 20) {
  
                var $15=HEAP32[((__ZZ15SpeakNextClauseP7__sFILEPKviE6f_text)>>2)]; //@line 1880 "synthesize.cpp"
                var $cmp31=((($15))|0)!=0; //@line 1880 "synthesize.cpp"
                if ($cmp31) { __label__ = 21;; } else { __label__ = 23;; } //@line 1880 "synthesize.cpp"
                $land_lhs_true32$$if_end36$32: do { 
                  if (__label__ == 21) {
  
                    var $16=HEAP32[((__ZZ15SpeakNextClauseP7__sFILEPKviE6f_text)>>2)]; //@line 1880 "synthesize.cpp"
                    var $_flags=(($16+12)&4294967295); //@line 1880 "synthesize.cpp"
                    var $17=HEAP16[(($_flags)>>1)]; //@line 1880 "synthesize.cpp"
                    var $conv=(tempInt=(($17)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1880 "synthesize.cpp"
                    var $and=($conv) & 32; //@line 1880 "synthesize.cpp"
                    var $cmp33=((($and))|0)!=0; //@line 1880 "synthesize.cpp"
                    if (!($cmp33)) { __label__ = 23;break $land_lhs_true32$$if_end36$32; } //@line 1880 "synthesize.cpp"
  
                    HEAP8[(__ZL8timer_on_b)]=0;
                    var $18=HEAP32[((__ZZ15SpeakNextClauseP7__sFILEPKviE6f_text)>>2)]; //@line 1883 "synthesize.cpp"
                    var $call35=_fclose($18); //@line 1883 "synthesize.cpp"
                    HEAP32[((__ZZ15SpeakNextClauseP7__sFILEPKviE6f_text)>>2)]=0; //@line 1884 "synthesize.cpp"
                    $retval=0; //@line 1885 "synthesize.cpp"
                    __label__ = 39;break $if_then$$if_end$2; //@line 1885 "synthesize.cpp"
                  }
                } while(0);
  
                var $19=HEAP32[((_current_phoneme_table)>>2)]; //@line 1888 "synthesize.cpp"
                var $20=HEAP32[((_voice)>>2)]; //@line 1888 "synthesize.cpp"
                var $phoneme_tab_ix=(($20+40)&4294967295); //@line 1888 "synthesize.cpp"
                var $21=HEAP32[(($phoneme_tab_ix)>>2)]; //@line 1888 "synthesize.cpp"
                var $cmp37=((($19))|0)!=((($21))|0); //@line 1888 "synthesize.cpp"
                if ($cmp37) { __label__ = 24;; } else { __label__ = 25;; } //@line 1888 "synthesize.cpp"
                if (__label__ == 24) {
  
                  var $22=HEAP32[((_voice)>>2)]; //@line 1890 "synthesize.cpp"
                  var $phoneme_tab_ix39=(($22+40)&4294967295); //@line 1890 "synthesize.cpp"
                  var $23=HEAP32[(($phoneme_tab_ix39)>>2)]; //@line 1890 "synthesize.cpp"
                  __Z18SelectPhonemeTablei($23); //@line 1890 "synthesize.cpp"
                  ; //@line 1891 "synthesize.cpp"
                }
  
                var $24=HEAP32[((_translator)>>2)]; //@line 1895 "synthesize.cpp"
                var $25=HEAP32[((__ZZ15SpeakNextClauseP7__sFILEPKviE6f_text)>>2)]; //@line 1895 "synthesize.cpp"
                var $26=HEAP32[((__ZZ15SpeakNextClauseP7__sFILEPKviE6p_text)>>2)]; //@line 1895 "synthesize.cpp"
                var $call41=__Z15TranslateClauseP10TranslatorP7__sFILEPKvPiPPc($24, $25, $26, $clause_tone, $voice_change); //@line 1895 "synthesize.cpp"
                HEAP32[((__ZZ15SpeakNextClauseP7__sFILEPKviE6p_text)>>2)]=$call41; //@line 1895 "synthesize.cpp"
                var $27=HEAP32[((_translator)>>2)]; //@line 1897 "synthesize.cpp"
                var $28=HEAP32[(($clause_tone)>>2)]; //@line 1897 "synthesize.cpp"
                __Z11CalcPitchesP10Translatori($27, $28); //@line 1897 "synthesize.cpp"
                var $29=HEAP32[((_translator)>>2)]; //@line 1898 "synthesize.cpp"
                __Z11CalcLengthsP10Translator($29); //@line 1898 "synthesize.cpp"
                var $30=HEAP32[((_option_phonemes)>>2)]; //@line 1900 "synthesize.cpp"
                var $cmp42=((($30))|0) > 0; //@line 1900 "synthesize.cpp"
                var $31=HEAP32[((_phoneme_callback)>>2)]; //@line 1900 "synthesize.cpp"
                var $cmp44=((($31))|0)!=0; //@line 1900 "synthesize.cpp"
                var $or_cond2=($cmp42) | ($cmp44); //@line 1900 "synthesize.cpp"
                if ($or_cond2) { __label__ = 26;; } else { __label__ = 31;; } //@line 1900 "synthesize.cpp"
                $if_then45$$if_end62$39: do { 
                  if (__label__ == 26) {
  
                    var $32=HEAP32[((_translator)>>2)]; //@line 1902 "synthesize.cpp"
                    var $phon_out=(($32+332)&4294967295); //@line 1902 "synthesize.cpp"
                    var $arraydecay=(($phon_out)&4294967295); //@line 1902 "synthesize.cpp"
                    __Z26GetTranslatedPhonemeStringPci($arraydecay, 300); //@line 1902 "synthesize.cpp"
                    var $33=HEAP32[((_option_phonemes)>>2)]; //@line 1903 "synthesize.cpp"
                    var $cmp46=((($33))|0) > 0; //@line 1903 "synthesize.cpp"
                    if ($cmp46) { __label__ = 27;; } else { __label__ = 29;; } //@line 1903 "synthesize.cpp"
                    $if_then47$$if_end55$41: do { 
                      if (__label__ == 27) {
  
                        var $34=HEAP32[((_f_trans)>>2)]; //@line 1905 "synthesize.cpp"
                        var $35=HEAP32[((_translator)>>2)]; //@line 1905 "synthesize.cpp"
                        var $phon_out48=(($35+332)&4294967295); //@line 1905 "synthesize.cpp"
                        var $arraydecay49=(($phon_out48)&4294967295); //@line 1905 "synthesize.cpp"
                        var $call50=_fprintf($34, ((__str459)&4294967295), allocate([$arraydecay49,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 1905 "synthesize.cpp"
                        var $call51=_iswalpha(269); //@line 1907 "synthesize.cpp"
                        var $tobool=((($call51))|0)!=0; //@line 1907 "synthesize.cpp"
                        if ($tobool) { __label__ = 29;break $if_then47$$if_end55$41; } //@line 1907 "synthesize.cpp"
  
                        var $36=HEAP32[((__impure_ptr)>>2)]; //@line 1910 "synthesize.cpp"
                        var $_stderr=(($36+12)&4294967295); //@line 1910 "synthesize.cpp"
                        var $37=HEAP32[(($_stderr)>>2)]; //@line 1910 "synthesize.cpp"
                        var $38=_fwrite(((__str1460)&4294967295), 88, 1, $37); //@line 1910 "synthesize.cpp"
                        ; //@line 1911 "synthesize.cpp"
                      }
                    } while(0);
  
                    var $39=HEAP32[((_phoneme_callback)>>2)]; //@line 1913 "synthesize.cpp"
                    var $cmp56=((($39))|0)!=0; //@line 1913 "synthesize.cpp"
                    if (!($cmp56)) { __label__ = 31;break $if_then45$$if_end62$39; } //@line 1913 "synthesize.cpp"
  
                    var $40=HEAP32[((_phoneme_callback)>>2)]; //@line 1915 "synthesize.cpp"
                    var $41=HEAP32[((_translator)>>2)]; //@line 1915 "synthesize.cpp"
                    var $phon_out58=(($41+332)&4294967295); //@line 1915 "synthesize.cpp"
                    var $arraydecay59=(($phon_out58)&4294967295); //@line 1915 "synthesize.cpp"
                    var $call60=FUNCTION_TABLE[$40]($arraydecay59); //@line 1915 "synthesize.cpp"
                    ; //@line 1916 "synthesize.cpp"
                  }
                } while(0);
  
                var $42=HEAP32[((_skipping_text)>>2)]; //@line 1920 "synthesize.cpp"
                var $tobool63=((($42))|0)!=0; //@line 1920 "synthesize.cpp"
                if ($tobool63) { __label__ = 32;; } else { __label__ = 33;; } //@line 1920 "synthesize.cpp"
                if (__label__ == 32) {
  
                  HEAP32[((_n_phoneme_list)>>2)]=0; //@line 1922 "synthesize.cpp"
                  $retval=1; //@line 1923 "synthesize.cpp"
                  ; //@line 1923 "synthesize.cpp"
                }
                else if (__label__ == 33) {
  
                  var $call66=__Z8GenerateP12PHONEME_LISTPii(((_phoneme_list)&4294967295), _n_phoneme_list, 0); //@line 1926 "synthesize.cpp"
                  var $43=HEAP32[(($voice_change)>>2)]; //@line 1929 "synthesize.cpp"
                  var $cmp68=((($43))|0)!=0; //@line 1929 "synthesize.cpp"
                  if ($cmp68) { __label__ = 34;; } else { __label__ = 35;; } //@line 1929 "synthesize.cpp"
                  if (__label__ == 34) {
  
                    var $44=HEAP32[(($voice_change)>>2)]; //@line 1932 "synthesize.cpp"
                    var $call70=__Z16LoadVoiceVariantPKci($44, 0); //@line 1932 "synthesize.cpp"
                    HEAP32[((__ZL9new_voice)>>2)]=$call70; //@line 1932 "synthesize.cpp"
                    __lastLabel__ = 34; ; //@line 1933 "synthesize.cpp"
                  }
                  else if (__label__ == 35) {
  
                    var $_pr=HEAP32[((__ZL9new_voice)>>2)]; //@line 1935 "synthesize.cpp"
                    __lastLabel__ = 35; ;
                  }
  
                  var $45=__lastLabel__ == 35 ? $_pr : ($call70); //@line 1935 "synthesize.cpp"
                  var $tobool72=((($45))|0)!=0; //@line 1935 "synthesize.cpp"
                  if ($tobool72) { __label__ = 37;; } else { __label__ = 38;; } //@line 1935 "synthesize.cpp"
                  if (__label__ == 37) {
  
                    var $46=HEAP32[((_voice)>>2)]; //@line 1939 "synthesize.cpp"
                    __Z13DoVoiceChangeP7voice_t($46); //@line 1939 "synthesize.cpp"
                    HEAP32[((__ZL9new_voice)>>2)]=0; //@line 1940 "synthesize.cpp"
                    ; //@line 1941 "synthesize.cpp"
                  }
  
                  $retval=1; //@line 1943 "synthesize.cpp"
                  ; //@line 1943 "synthesize.cpp"
                }
              }
            }
          }
        }
      }
    } while(0);
  
    var $47=$retval; //@line 1944 "synthesize.cpp"
    STACKTOP = __stackBase__;
    return $47; //@line 1944 "synthesize.cpp"
    return null;
  }
  

  function __Z11SynthStatusv() {
    ;
    var __label__;
  
    var $_b=HEAPU8[(__ZL8timer_on_b)];
    var $0=((($_b))&1);
    var $_b1=HEAPU8[(__ZL6paused_b)];
    var $1=($_b1) ? 2 : 0;
    var $or=($1) | ($0); //@line 1791 "synthesize.cpp"
    ;
    return $or; //@line 1791 "synthesize.cpp"
    return null;
  }
  

  function __ZL18formants_reduce_hfP7frame_ti($fr, $level) {
    ;
    var __label__;
  
    var $fr_addr;
    var $level_addr;
    var $ix;
    var $x;
    $fr_addr=$fr;
    $level_addr=$level;
    var $0=HEAP32[((_voice)>>2)]; //@line 508 "synthesize.cpp"
    var $klattv=(($0+112)&4294967295); //@line 508 "synthesize.cpp"
    var $arrayidx=(($klattv)&4294967295); //@line 508 "synthesize.cpp"
    var $1=HEAP32[(($arrayidx)>>2)]; //@line 508 "synthesize.cpp"
    var $tobool=((($1))|0)!=0; //@line 508 "synthesize.cpp"
    if ($tobool) { __label__ = 3;; } else { __label__ = 1;; } //@line 508 "synthesize.cpp"
    $for_end$$if_end$2: do { 
      if (__label__ == 1) {
  
        $ix=2; //@line 511 "synthesize.cpp"
        ; //@line 511 "synthesize.cpp"
        while(1) { 
  
          var $2=$ix; //@line 513 "synthesize.cpp"
          var $3=$fr_addr; //@line 513 "synthesize.cpp"
          var $fheight=(($3+18)&4294967295); //@line 513 "synthesize.cpp"
          var $arrayidx1=(($fheight+$2)&4294967295); //@line 513 "synthesize.cpp"
          var $4=HEAPU8[($arrayidx1)]; //@line 513 "synthesize.cpp"
          var $conv=((($4))&255); //@line 513 "synthesize.cpp"
          var $5=$level_addr; //@line 513 "synthesize.cpp"
          var $mul=((($conv)*($5))&4294967295); //@line 513 "synthesize.cpp"
          $x=$mul; //@line 513 "synthesize.cpp"
          var $6=$x; //@line 514 "synthesize.cpp"
          var $div=((((($6))|0)/100)|0); //@line 514 "synthesize.cpp"
          var $conv2=((($div)) & 255); //@line 514 "synthesize.cpp"
          var $7=$ix; //@line 514 "synthesize.cpp"
          var $8=$fr_addr; //@line 514 "synthesize.cpp"
          var $fheight3=(($8+18)&4294967295); //@line 514 "synthesize.cpp"
          var $arrayidx4=(($fheight3+$7)&4294967295); //@line 514 "synthesize.cpp"
          HEAP8[($arrayidx4)]=$conv2; //@line 514 "synthesize.cpp"
          var $9=$ix; //@line 511 "synthesize.cpp"
          var $inc=((($9)+1)&4294967295); //@line 511 "synthesize.cpp"
          $ix=$inc; //@line 511 "synthesize.cpp"
          var $cmp=((($inc))|0) < 8; //@line 511 "synthesize.cpp"
          if ($cmp) { __label__ = 2;continue ; } else { __label__ = 3;break $for_end$$if_end$2; } //@line 511 "synthesize.cpp"
        }
      }
    } while(0);
  
    ;
    return; //@line 516 "synthesize.cpp"
    return;
  }
  

  function __ZL10AllocFramev() {
    ;
    var __label__;
  
    var $0=HEAP32[((__ZZL10AllocFramevE2ix)>>2)]; //@line 447 "synthesize.cpp"
    var $inc=((($0)+1)&4294967295); //@line 447 "synthesize.cpp"
    HEAP32[((__ZZL10AllocFramevE2ix)>>2)]=$inc; //@line 447 "synthesize.cpp"
    var $cmp=((($inc))|0) >= 160; //@line 448 "synthesize.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 448 "synthesize.cpp"
    if (__label__ == 1) {
  
      HEAP32[((__ZZL10AllocFramevE2ix)>>2)]=0; //@line 449 "synthesize.cpp"
      ; //@line 449 "synthesize.cpp"
    }
  
    var $1=HEAP32[((__ZZL10AllocFramevE2ix)>>2)]; //@line 450 "synthesize.cpp"
    var $arrayidx=((__ZZL10AllocFramevE10frame_pool+$1*64)&4294967295); //@line 450 "synthesize.cpp"
    ;
    return $arrayidx; //@line 450 "synthesize.cpp"
    return null;
  }
  

  function __Z13SetLengthModsP10Translatori($tr, $value) {
    ;
    var __label__;
  
    var $tr_addr;
    var $value_addr;
    var $value2;
    $tr_addr=$tr;
    $value_addr=$value;
    var $0=$value_addr; //@line 363 "translate.cpp"
    var $rem=((($0))|0)%100; //@line 363 "translate.cpp"
    var $arrayidx=((__ZL15length_mod_tabs+$rem*4)&4294967295); //@line 363 "translate.cpp"
    var $1=HEAP32[(($arrayidx)>>2)]; //@line 363 "translate.cpp"
    var $2=$tr_addr; //@line 363 "translate.cpp"
    var $langopts=(($2)&4294967295); //@line 363 "translate.cpp"
    var $length_mods=(($langopts+176)&4294967295); //@line 363 "translate.cpp"
    HEAP32[(($length_mods)>>2)]=$1; //@line 363 "translate.cpp"
    var $3=$tr_addr; //@line 363 "translate.cpp"
    var $langopts1=(($3)&4294967295); //@line 363 "translate.cpp"
    var $length_mods0=(($langopts1+180)&4294967295); //@line 363 "translate.cpp"
    HEAP32[(($length_mods0)>>2)]=$1; //@line 363 "translate.cpp"
    var $4=$value_addr; //@line 364 "translate.cpp"
    var $div=((((($4))|0)/100)|0); //@line 364 "translate.cpp"
    $value2=$div; //@line 364 "translate.cpp"
    var $cmp=((($div))|0)!=0; //@line 364 "translate.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 364 "translate.cpp"
    if (__label__ == 1) {
  
      var $5=$value2; //@line 366 "translate.cpp"
      var $arrayidx2=((__ZL15length_mod_tabs+$5*4)&4294967295); //@line 366 "translate.cpp"
      var $6=HEAP32[(($arrayidx2)>>2)]; //@line 366 "translate.cpp"
      var $7=$tr_addr; //@line 366 "translate.cpp"
      var $langopts3=(($7)&4294967295); //@line 366 "translate.cpp"
      var $length_mods04=(($langopts3+180)&4294967295); //@line 366 "translate.cpp"
      HEAP32[(($length_mods04)>>2)]=$6; //@line 366 "translate.cpp"
      ; //@line 367 "translate.cpp"
    }
  
    ;
    return; //@line 368 "translate.cpp"
    return;
  }
  

  function __Z7IsAlphaj($c) {
    ;
    var __label__;
  
    var $retval;
    var $c_addr;
    $c_addr=$c;
    var $0=$c_addr; //@line 379 "translate.cpp"
    var $call=_iswalpha($0); //@line 379 "translate.cpp"
    var $tobool=((($call))|0)!=0; //@line 379 "translate.cpp"
    if ($tobool) { __label__ = 1;; } else { __label__ = 2;; } //@line 379 "translate.cpp"
    if (__label__ == 1) {
  
      $retval=1; //@line 380 "translate.cpp"
      ; //@line 380 "translate.cpp"
    }
    else if (__label__ == 2) {
  
      var $1=$c_addr; //@line 382 "translate.cpp"
      var $cmp=((($1))>>>0) >= 2305; //@line 382 "translate.cpp"
      var $2=$c_addr; //@line 382 "translate.cpp"
      var $cmp1=((($2))>>>0) <= 3575; //@line 382 "translate.cpp"
      var $or_cond=($cmp) & ($cmp1); //@line 382 "translate.cpp"
      var $3=$c_addr; //@line 385 "translate.cpp"
      if ($or_cond) { __label__ = 3;; } else { __label__ = 10;; } //@line 382 "translate.cpp"
      if (__label__ == 3) {
  
        var $and=($3) & 127; //@line 385 "translate.cpp"
        var $cmp3=((($and))>>>0) < 100; //@line 385 "translate.cpp"
        if ($cmp3) { __label__ = 4;; } else { __label__ = 5;; } //@line 385 "translate.cpp"
        if (__label__ == 4) {
  
          $retval=1; //@line 386 "translate.cpp"
          ; //@line 386 "translate.cpp"
        }
        else if (__label__ == 5) {
  
          var $4=$c_addr; //@line 387 "translate.cpp"
          var $call6=__Z11lookupwcharPKti(((__ZZ7IsAlphajE18extra_indic_alphas)&4294967295), $4); //@line 387 "translate.cpp"
          var $cmp7=((($call6))|0)!=0; //@line 387 "translate.cpp"
          if ($cmp7) { __label__ = 6;; } else { __label__ = 7;; } //@line 387 "translate.cpp"
          if (__label__ == 6) {
  
            $retval=1; //@line 388 "translate.cpp"
            ; //@line 388 "translate.cpp"
          }
          else if (__label__ == 7) {
  
            var $5=$c_addr; //@line 389 "translate.cpp"
            var $cmp10=((($5))>>>0) >= 3450; //@line 389 "translate.cpp"
            var $6=$c_addr; //@line 389 "translate.cpp"
            var $cmp12=((($6))>>>0) <= 3455; //@line 389 "translate.cpp"
            var $or_cond1=($cmp10) & ($cmp12); //@line 389 "translate.cpp"
            if ($or_cond1) { __label__ = 8;; } else { __label__ = 9;; } //@line 389 "translate.cpp"
            if (__label__ == 8) {
  
              $retval=1; //@line 390 "translate.cpp"
              ; //@line 390 "translate.cpp"
            }
            else if (__label__ == 9) {
  
              $retval=0; //@line 392 "translate.cpp"
              ; //@line 392 "translate.cpp"
            }
          }
        }
      }
      else if (__label__ == 10) {
  
        var $cmp16=((($3))>>>0) >= 1611; //@line 395 "translate.cpp"
        var $7=$c_addr; //@line 395 "translate.cpp"
        var $cmp18=((($7))>>>0) <= 1630; //@line 395 "translate.cpp"
        var $or_cond2=($cmp16) & ($cmp18); //@line 395 "translate.cpp"
        if ($or_cond2) { __label__ = 11;; } else { __label__ = 12;; } //@line 395 "translate.cpp"
        if (__label__ == 11) {
  
          $retval=1; //@line 396 "translate.cpp"
          ; //@line 396 "translate.cpp"
        }
        else if (__label__ == 12) {
  
          var $8=$c_addr; //@line 398 "translate.cpp"
          var $cmp21=((($8))>>>0) >= 768; //@line 398 "translate.cpp"
          var $9=$c_addr; //@line 398 "translate.cpp"
          var $cmp23=((($9))>>>0) <= 879; //@line 398 "translate.cpp"
          var $or_cond3=($cmp21) & ($cmp23); //@line 398 "translate.cpp"
          if ($or_cond3) { __label__ = 13;; } else { __label__ = 14;; } //@line 398 "translate.cpp"
          if (__label__ == 13) {
  
            $retval=1; //@line 399 "translate.cpp"
            ; //@line 399 "translate.cpp"
          }
          else if (__label__ == 14) {
  
            var $10=$c_addr; //@line 401 "translate.cpp"
            var $cmp26=((($10))>>>0) >= 1920; //@line 401 "translate.cpp"
            var $11=$c_addr; //@line 401 "translate.cpp"
            var $cmp28=((($11))>>>0) <= 1969; //@line 401 "translate.cpp"
            var $or_cond4=($cmp26) & ($cmp28); //@line 401 "translate.cpp"
            if ($or_cond4) { __label__ = 15;; } else { __label__ = 16;; } //@line 401 "translate.cpp"
            if (__label__ == 15) {
  
              $retval=1; //@line 402 "translate.cpp"
              ; //@line 402 "translate.cpp"
            }
            else if (__label__ == 16) {
  
              var $12=$c_addr; //@line 404 "translate.cpp"
              var $cmp31=((($12))>>>0) >= 4352; //@line 404 "translate.cpp"
              var $13=$c_addr; //@line 404 "translate.cpp"
              var $cmp33=((($13))>>>0) <= 4607; //@line 404 "translate.cpp"
              var $or_cond5=($cmp31) & ($cmp33); //@line 404 "translate.cpp"
              if ($or_cond5) { __label__ = 17;; } else { __label__ = 18;; } //@line 404 "translate.cpp"
              if (__label__ == 17) {
  
                $retval=1; //@line 405 "translate.cpp"
                ; //@line 405 "translate.cpp"
              }
              else if (__label__ == 18) {
  
                var $14=$c_addr; //@line 407 "translate.cpp"
                var $cmp36=((($14))>>>0) > 12352; //@line 407 "translate.cpp"
                var $15=$c_addr; //@line 407 "translate.cpp"
                var $cmp38=((($15))>>>0) <= 42752; //@line 407 "translate.cpp"
                var $or_cond6=($cmp36) & ($cmp38); //@line 407 "translate.cpp"
                if ($or_cond6) { __label__ = 19;; } else { __label__ = 20;; } //@line 407 "translate.cpp"
                if (__label__ == 19) {
  
                  $retval=1; //@line 408 "translate.cpp"
                  ; //@line 408 "translate.cpp"
                }
                else if (__label__ == 20) {
  
                  $retval=0; //@line 410 "translate.cpp"
                  ; //@line 410 "translate.cpp"
                }
              }
            }
          }
        }
      }
    }
  
    var $16=$retval; //@line 411 "translate.cpp"
    ;
    return $16; //@line 411 "translate.cpp"
    return null;
  }
  

  function __Z11lookupwcharPKti($list, $c) {
    ;
    var __label__;
  
    var $retval;
    var $list_addr;
    var $c_addr;
    var $ix;
    $list_addr=$list;
    $c_addr=$c;
    $ix=0; //@line 456 "translate.cpp"
    ; //@line 456 "translate.cpp"
    while(1) { 
  
      var $0=$ix; //@line 456 "translate.cpp"
      var $1=$list_addr; //@line 456 "translate.cpp"
      var $arrayidx=(($1+2*$0)&4294967295); //@line 456 "translate.cpp"
      var $2=HEAPU16[(($arrayidx)>>1)]; //@line 456 "translate.cpp"
      var $conv=((($2))&65535); //@line 456 "translate.cpp"
      var $cmp=((($conv))|0)!=0; //@line 456 "translate.cpp"
      if (!($cmp)) { __label__ = 5;break ; } //@line 456 "translate.cpp"
  
      var $3=$ix; //@line 458 "translate.cpp"
      var $4=$list_addr; //@line 458 "translate.cpp"
      var $arrayidx1=(($4+2*$3)&4294967295); //@line 458 "translate.cpp"
      var $5=HEAPU16[(($arrayidx1)>>1)]; //@line 458 "translate.cpp"
      var $conv2=((($5))&65535); //@line 458 "translate.cpp"
      var $6=$c_addr; //@line 458 "translate.cpp"
      var $cmp3=((($conv2))|0)==((($6))|0); //@line 458 "translate.cpp"
      var $7=$ix; //@line 459 "translate.cpp"
      var $add=((($7)+1)&4294967295); //@line 459 "translate.cpp"
      if ($cmp3) { __label__ = 3;break ; } //@line 458 "translate.cpp"
  
      $ix=$add; //@line 456 "translate.cpp"
      __label__ = 1;continue ; //@line 456 "translate.cpp"
    }
    if (__label__ == 5) {
  
      $retval=0; //@line 461 "translate.cpp"
      ; //@line 461 "translate.cpp"
    }
    else if (__label__ == 3) {
  
      $retval=$add; //@line 459 "translate.cpp"
      ; //@line 459 "translate.cpp"
    }
  
    var $8=$retval; //@line 462 "translate.cpp"
    ;
    return $8; //@line 462 "translate.cpp"
    return null;
  }
  

  function __Z7IsDigitj($c) {
    ;
    var __label__;
  
    var $retval;
    var $c_addr;
    $c_addr=$c;
    var $0=$c_addr; //@line 422 "translate.cpp"
    var $call=_iswdigit($0); //@line 422 "translate.cpp"
    var $tobool=((($call))|0)!=0; //@line 422 "translate.cpp"
    if ($tobool) { __label__ = 1;; } else { __label__ = 2;; } //@line 422 "translate.cpp"
    if (__label__ == 1) {
  
      $retval=1; //@line 423 "translate.cpp"
      ; //@line 423 "translate.cpp"
    }
    else if (__label__ == 2) {
  
      var $1=$c_addr; //@line 425 "translate.cpp"
      var $cmp=((($1))>>>0) >= 2406; //@line 425 "translate.cpp"
      var $2=$c_addr; //@line 425 "translate.cpp"
      var $cmp1=((($2))>>>0) <= 2415; //@line 425 "translate.cpp"
      var $or_cond=($cmp) & ($cmp1); //@line 425 "translate.cpp"
      if ($or_cond) { __label__ = 3;; } else { __label__ = 4;; } //@line 425 "translate.cpp"
      if (__label__ == 3) {
  
        $retval=1; //@line 426 "translate.cpp"
        ; //@line 426 "translate.cpp"
      }
      else if (__label__ == 4) {
  
        $retval=0; //@line 428 "translate.cpp"
        ; //@line 428 "translate.cpp"
      }
    }
  
    var $3=$retval; //@line 429 "translate.cpp"
    ;
    return $3; //@line 429 "translate.cpp"
    return null;
  }
  

  function __Z7IsSpacej($c) {
    ;
    var __label__;
  
    var $retval;
    var $c_addr;
    $c_addr=$c;
    var $0=$c_addr; //@line 433 "translate.cpp"
    var $cmp=((($0))|0)==0; //@line 433 "translate.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 433 "translate.cpp"
    if (__label__ == 1) {
  
      $retval=0; //@line 434 "translate.cpp"
      ; //@line 434 "translate.cpp"
    }
    else if (__label__ == 2) {
  
      var $1=$c_addr; //@line 435 "translate.cpp"
      var $cmp1=((($1))>>>0) >= 9472; //@line 435 "translate.cpp"
      var $2=$c_addr; //@line 435 "translate.cpp"
      var $cmp2=((($2))>>>0) < 9632; //@line 435 "translate.cpp"
      var $or_cond=($cmp1) & ($cmp2); //@line 435 "translate.cpp"
      if ($or_cond) { __label__ = 3;; } else { __label__ = 4;; } //@line 435 "translate.cpp"
      if (__label__ == 3) {
  
        $retval=1; //@line 436 "translate.cpp"
        ; //@line 436 "translate.cpp"
      }
      else if (__label__ == 4) {
  
        var $3=$c_addr; //@line 439 "translate.cpp"
        var $call=_iswspace($3); //@line 439 "translate.cpp"
        $retval=$call; //@line 439 "translate.cpp"
        ; //@line 439 "translate.cpp"
      }
    }
  
    var $4=$retval; //@line 440 "translate.cpp"
    ;
    return $4; //@line 440 "translate.cpp"
    return null;
  }
  

  function __Z16DeleteTranslatorP10Translator($tr) {
    ;
    var __label__;
  
    var $tr_addr;
    $tr_addr=$tr;
    var $0=$tr_addr; //@line 445 "translate.cpp"
    var $data_dictlist=(($0+1052)&4294967295); //@line 445 "translate.cpp"
    var $1=HEAP32[(($data_dictlist)>>2)]; //@line 445 "translate.cpp"
    var $cmp=((($1))|0)!=0; //@line 445 "translate.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 445 "translate.cpp"
    if (__label__ == 1) {
  
      var $2=$tr_addr; //@line 446 "translate.cpp"
      var $data_dictlist1=(($2+1052)&4294967295); //@line 446 "translate.cpp"
      var $3=HEAP32[(($data_dictlist1)>>2)]; //@line 446 "translate.cpp"
      __Z4FreePv($3); //@line 446 "translate.cpp"
      ; //@line 446 "translate.cpp"
    }
  
    var $4=$tr_addr; //@line 447 "translate.cpp"
    var $5=$4; //@line 447 "translate.cpp"
    __Z4FreePv($5); //@line 447 "translate.cpp"
    ;
    return; //@line 448 "translate.cpp"
    return;
  }
  

  function __Z9IsBracketi($c) {
    ;
    var __label__;
  
    var $retval;
    var $c_addr;
    $c_addr=$c;
    var $0=$c_addr; //@line 466 "translate.cpp"
    var $cmp=((($0))|0) >= 8212; //@line 466 "translate.cpp"
    var $1=$c_addr; //@line 466 "translate.cpp"
    var $cmp1=((($1))|0) <= 8223; //@line 466 "translate.cpp"
    var $or_cond=($cmp) & ($cmp1); //@line 466 "translate.cpp"
    if ($or_cond) { __label__ = 1;; } else { __label__ = 2;; } //@line 466 "translate.cpp"
    if (__label__ == 1) {
  
      $retval=1; //@line 467 "translate.cpp"
      ; //@line 467 "translate.cpp"
    }
    else if (__label__ == 2) {
  
      var $2=$c_addr; //@line 468 "translate.cpp"
      var $call=__Z11lookupwcharPKti(((__ZL8brackets)&4294967295), $2); //@line 468 "translate.cpp"
      $retval=$call; //@line 468 "translate.cpp"
      ; //@line 468 "translate.cpp"
    }
  
    var $3=$retval; //@line 469 "translate.cpp"
    ;
    return $3; //@line 469 "translate.cpp"
    return null;
  }
  

  function __Z8utf8_outjPc($c, $buf) {
    ;
    var __label__;
  
    var $retval;
    var $c_addr;
    var $buf_addr;
    var $n_bytes;
    var $j;
    var $shift;
    $c_addr=$c;
    $buf_addr=$buf;
    var $0=$c_addr; //@line 481 "translate.cpp"
    var $cmp=((($0))>>>0) < 128; //@line 481 "translate.cpp"
    var $1=$c_addr; //@line 483 "translate.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 481 "translate.cpp"
    if (__label__ == 1) {
  
      var $conv=((($1)) & 255); //@line 483 "translate.cpp"
      var $2=$buf_addr; //@line 483 "translate.cpp"
      var $arrayidx=(($2)&4294967295); //@line 483 "translate.cpp"
      HEAP8[($arrayidx)]=$conv; //@line 483 "translate.cpp"
      $retval=1; //@line 484 "translate.cpp"
      ; //@line 484 "translate.cpp"
    }
    else if (__label__ == 2) {
  
      var $cmp1=((($1))>>>0) >= 1114112; //@line 486 "translate.cpp"
      if ($cmp1) { __label__ = 3;; } else { __label__ = 4;; } //@line 486 "translate.cpp"
      if (__label__ == 3) {
  
        var $3=$buf_addr; //@line 488 "translate.cpp"
        var $arrayidx3=(($3)&4294967295); //@line 488 "translate.cpp"
        HEAP8[($arrayidx3)]=32; //@line 488 "translate.cpp"
        $retval=1; //@line 489 "translate.cpp"
        ; //@line 489 "translate.cpp"
      }
      else if (__label__ == 4) {
  
        var $4=$c_addr; //@line 491 "translate.cpp"
        var $cmp5=((($4))>>>0) < 2048; //@line 491 "translate.cpp"
        if ($cmp5) { __label__ = 5;; } else { __label__ = 6;; } //@line 491 "translate.cpp"
        if (__label__ == 5) {
  
          $n_bytes=1; //@line 492 "translate.cpp"
          ; //@line 492 "translate.cpp"
        }
        else if (__label__ == 6) {
  
          var $5=$c_addr; //@line 494 "translate.cpp"
          var $cmp7=((($5))>>>0) < 65536; //@line 494 "translate.cpp"
          if ($cmp7) { __label__ = 7;; } else { __label__ = 8;; } //@line 494 "translate.cpp"
          if (__label__ == 7) {
  
            $n_bytes=2; //@line 495 "translate.cpp"
            ; //@line 495 "translate.cpp"
          }
          else if (__label__ == 8) {
  
            $n_bytes=3; //@line 497 "translate.cpp"
            ;
          }
        }
  
        var $6=$n_bytes; //@line 499 "translate.cpp"
        var $mul=((($6)*6)&4294967295); //@line 499 "translate.cpp"
        $shift=$mul; //@line 499 "translate.cpp"
        var $7=$n_bytes; //@line 500 "translate.cpp"
        var $arrayidx12=((__ZZ8utf8_outjPcE4code+$7)&4294967295); //@line 500 "translate.cpp"
        var $8=HEAPU8[($arrayidx12)]; //@line 500 "translate.cpp"
        var $conv13=((($8))&255); //@line 500 "translate.cpp"
        var $9=$c_addr; //@line 500 "translate.cpp"
        var $10=$shift; //@line 500 "translate.cpp"
        var $shr=($9) >>> ((($10))>>>0); //@line 500 "translate.cpp"
        var $or=($shr) | ($conv13); //@line 500 "translate.cpp"
        var $conv14=((($or)) & 255); //@line 500 "translate.cpp"
        var $11=$buf_addr; //@line 500 "translate.cpp"
        var $arrayidx15=(($11)&4294967295); //@line 500 "translate.cpp"
        HEAP8[($arrayidx15)]=$conv14; //@line 500 "translate.cpp"
        $j=0; //@line 501 "translate.cpp"
        var $12=$j; //@line 501 "translate.cpp"
        var $13=$n_bytes; //@line 501 "translate.cpp"
        var $cmp161=((($12))|0) < ((($13))|0); //@line 501 "translate.cpp"
        if ($cmp161) { __label__ = 10;; } else { __label__ = 11;; } //@line 501 "translate.cpp"
        $for_body$$for_end$15: do { 
          if (__label__ == 10) {
            while(1) { 
  
              var $14=$shift; //@line 503 "translate.cpp"
              var $sub=((($14)-6)&4294967295); //@line 503 "translate.cpp"
              $shift=$sub; //@line 503 "translate.cpp"
              var $15=$c_addr; //@line 504 "translate.cpp"
              var $16=$shift; //@line 504 "translate.cpp"
              var $shr17=($15) >>> ((($16))>>>0); //@line 504 "translate.cpp"
              var $and=($shr17) & 63; //@line 504 "translate.cpp"
              var $add=((($and)+128)&4294967295); //@line 504 "translate.cpp"
              var $conv18=((($add)) & 255); //@line 504 "translate.cpp"
              var $17=$j; //@line 504 "translate.cpp"
              var $add19=((($17)+1)&4294967295); //@line 504 "translate.cpp"
              var $18=$buf_addr; //@line 504 "translate.cpp"
              var $arrayidx20=(($18+$add19)&4294967295); //@line 504 "translate.cpp"
              HEAP8[($arrayidx20)]=$conv18; //@line 504 "translate.cpp"
              var $19=$j; //@line 501 "translate.cpp"
              var $inc=((($19)+1)&4294967295); //@line 501 "translate.cpp"
              $j=$inc; //@line 501 "translate.cpp"
              var $20=$j; //@line 501 "translate.cpp"
              var $21=$n_bytes; //@line 501 "translate.cpp"
              var $cmp16=((($20))|0) < ((($21))|0); //@line 501 "translate.cpp"
              if ($cmp16) { __label__ = 10;continue ; } else { __label__ = 11;break $for_body$$for_end$15; } //@line 501 "translate.cpp"
            }
          }
        } while(0);
  
        var $22=$n_bytes; //@line 506 "translate.cpp"
        var $add21=((($22)+1)&4294967295); //@line 506 "translate.cpp"
        $retval=$add21; //@line 506 "translate.cpp"
        ; //@line 506 "translate.cpp"
      }
    }
  
    var $23=$retval; //@line 507 "translate.cpp"
    ;
    return $23; //@line 507 "translate.cpp"
    return null;
  }
  

  function __Z11utf8_nbytesPKc($buf) {
    ;
    var __label__;
  
    var $retval;
    var $buf_addr;
    var $c;
    $buf_addr=$buf;
    var $0=$buf_addr; //@line 513 "translate.cpp"
    var $arrayidx=(($0)&4294967295); //@line 513 "translate.cpp"
    var $1=HEAP8[($arrayidx)]; //@line 513 "translate.cpp"
    $c=$1; //@line 513 "translate.cpp"
    var $2=$c; //@line 514 "translate.cpp"
    var $conv=((($2))&255); //@line 514 "translate.cpp"
    var $cmp=((($conv))|0) < 128; //@line 514 "translate.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 514 "translate.cpp"
    if (__label__ == 1) {
  
      $retval=1; //@line 515 "translate.cpp"
      ; //@line 515 "translate.cpp"
    }
    else if (__label__ == 2) {
  
      var $3=$c; //@line 516 "translate.cpp"
      var $conv1=((($3))&255); //@line 516 "translate.cpp"
      var $cmp2=((($conv1))|0) < 224; //@line 516 "translate.cpp"
      if ($cmp2) { __label__ = 3;; } else { __label__ = 4;; } //@line 516 "translate.cpp"
      if (__label__ == 3) {
  
        $retval=2; //@line 517 "translate.cpp"
        ; //@line 517 "translate.cpp"
      }
      else if (__label__ == 4) {
  
        var $4=$c; //@line 518 "translate.cpp"
        var $conv5=((($4))&255); //@line 518 "translate.cpp"
        var $cmp6=((($conv5))|0) < 240; //@line 518 "translate.cpp"
        if ($cmp6) { __label__ = 5;; } else { __label__ = 6;; } //@line 518 "translate.cpp"
        if (__label__ == 5) {
  
          $retval=3; //@line 519 "translate.cpp"
          ; //@line 519 "translate.cpp"
        }
        else if (__label__ == 6) {
  
          $retval=4; //@line 520 "translate.cpp"
          ; //@line 520 "translate.cpp"
        }
      }
    }
  
    var $5=$retval; //@line 521 "translate.cpp"
    ;
    return $5; //@line 521 "translate.cpp"
    return null;
  }
  

  function __Z8utf8_in2PiPKci($c, $buf, $backwards) {
    ;
    var __label__;
  
    var $c_addr;
    var $buf_addr;
    var $backwards_addr;
    var $c1;
    var $n_bytes;
    var $ix;
    $c_addr=$c;
    $buf_addr=$buf;
    $backwards_addr=$backwards;
    var $0=$buf_addr; //@line 535 "translate.cpp"
    var $1=HEAP8[($0)]; //@line 535 "translate.cpp"
    var $conv2=(tempInt=(($1)),(tempInt>=128?tempInt-256:tempInt)); //@line 535 "translate.cpp"
    var $and3=($conv2) & 192; //@line 535 "translate.cpp"
    var $cmp4=((($and3))|0)==128; //@line 535 "translate.cpp"
    if ($cmp4) { __label__ = 1;; } else { __label__ = 5;; } //@line 535 "translate.cpp"
    $while_body$$while_end$2: do { 
      if (__label__ == 1) {
        while(1) { 
  
          var $2=$backwards_addr; //@line 538 "translate.cpp"
          var $tobool=((($2))|0)!=0; //@line 538 "translate.cpp"
          var $3=$buf_addr; //@line 539 "translate.cpp"
          if ($tobool) { __label__ = 2;; } else { __label__ = 3;; } //@line 538 "translate.cpp"
          if (__label__ == 2) {
  
            var $incdec_ptr=(($3+-1)&4294967295); //@line 539 "translate.cpp"
            $buf_addr=$incdec_ptr; //@line 539 "translate.cpp"
            ; //@line 539 "translate.cpp"
          }
          else if (__label__ == 3) {
  
            var $incdec_ptr1=(($3+1)&4294967295); //@line 541 "translate.cpp"
            $buf_addr=$incdec_ptr1; //@line 541 "translate.cpp"
            ;
          }
  
          var $4=$buf_addr; //@line 535 "translate.cpp"
          var $5=HEAP8[($4)]; //@line 535 "translate.cpp"
          var $conv=(tempInt=(($5)),(tempInt>=128?tempInt-256:tempInt)); //@line 535 "translate.cpp"
          var $and=($conv) & 192; //@line 535 "translate.cpp"
          var $cmp=((($and))|0)==128; //@line 535 "translate.cpp"
          if ($cmp) { __label__ = 1;continue ; } else { __label__ = 5;break $while_body$$while_end$2; } //@line 535 "translate.cpp"
        }
      }
    } while(0);
  
    $n_bytes=0; //@line 544 "translate.cpp"
    var $6=$buf_addr; //@line 546 "translate.cpp"
    var $incdec_ptr2=(($6+1)&4294967295); //@line 546 "translate.cpp"
    $buf_addr=$incdec_ptr2; //@line 546 "translate.cpp"
    var $7=HEAP8[($6)]; //@line 546 "translate.cpp"
    var $conv3=(tempInt=(($7)),(tempInt>=128?tempInt-256:tempInt)); //@line 546 "translate.cpp"
    $c1=$conv3; //@line 546 "translate.cpp"
    var $and4=($conv3) & 128; //@line 546 "translate.cpp"
    var $tobool5=((($and4))|0)!=0; //@line 546 "translate.cpp"
    if ($tobool5) { __label__ = 6;; } else { __label__ = 14;; } //@line 546 "translate.cpp"
    $if_then6$$if_end27$10: do { 
      if (__label__ == 6) {
  
        var $8=$c1; //@line 548 "translate.cpp"
        var $and7=($8) & 224; //@line 548 "translate.cpp"
        var $cmp8=((($and7))|0)==192; //@line 548 "translate.cpp"
        if ($cmp8) { __label__ = 7;; } else { __label__ = 8;; } //@line 548 "translate.cpp"
        $if_then9$$if_else10$12: do { 
          if (__label__ == 7) {
  
            $n_bytes=1; //@line 549 "translate.cpp"
            ; //@line 549 "translate.cpp"
          }
          else if (__label__ == 8) {
  
            var $9=$c1; //@line 551 "translate.cpp"
            var $and11=($9) & 240; //@line 551 "translate.cpp"
            var $cmp12=((($and11))|0)==224; //@line 551 "translate.cpp"
            if ($cmp12) { __label__ = 9;; } else { __label__ = 10;; } //@line 551 "translate.cpp"
            if (__label__ == 9) {
  
              $n_bytes=2; //@line 552 "translate.cpp"
              ; //@line 552 "translate.cpp"
            }
            else if (__label__ == 10) {
  
              var $10=$c1; //@line 554 "translate.cpp"
              var $and15=($10) & 248; //@line 554 "translate.cpp"
              var $cmp16=((($and15))|0)==240; //@line 554 "translate.cpp"
              if (!($cmp16)) { __label__ = 12;break $if_then9$$if_else10$12; } //@line 554 "translate.cpp"
  
              $n_bytes=3; //@line 555 "translate.cpp"
              ; //@line 555 "translate.cpp"
            }
          }
        } while(0);
  
        var $11=$n_bytes; //@line 557 "translate.cpp"
        var $arrayidx=((__ZZ8utf8_in2PiPKciE4mask+$11)&4294967295); //@line 557 "translate.cpp"
        var $12=HEAPU8[($arrayidx)]; //@line 557 "translate.cpp"
        var $conv21=((($12))&255); //@line 557 "translate.cpp"
        var $13=$c1; //@line 557 "translate.cpp"
        var $and22=($13) & ($conv21); //@line 557 "translate.cpp"
        $c1=$and22; //@line 557 "translate.cpp"
        $ix=0; //@line 558 "translate.cpp"
        var $14=$ix; //@line 558 "translate.cpp"
        var $15=$n_bytes; //@line 558 "translate.cpp"
        var $cmp231=((($14))|0) < ((($15))|0); //@line 558 "translate.cpp"
        if (!($cmp231)) { __label__ = 14;break $if_then6$$if_end27$10; } //@line 558 "translate.cpp"
        while(1) { 
  
          var $16=$c1; //@line 560 "translate.cpp"
          var $shl=((($16)*64)&4294967295); //@line 560 "translate.cpp"
          var $17=$buf_addr; //@line 560 "translate.cpp"
          var $incdec_ptr24=(($17+1)&4294967295); //@line 560 "translate.cpp"
          $buf_addr=$incdec_ptr24; //@line 560 "translate.cpp"
          var $18=HEAP8[($17)]; //@line 560 "translate.cpp"
          var $conv25=(tempInt=(($18)),(tempInt>=128?tempInt-256:tempInt)); //@line 560 "translate.cpp"
          var $and26=($conv25) & 63; //@line 560 "translate.cpp"
          var $add=((($and26)+($shl))&4294967295); //@line 560 "translate.cpp"
          $c1=$add; //@line 560 "translate.cpp"
          var $19=$ix; //@line 558 "translate.cpp"
          var $inc=((($19)+1)&4294967295); //@line 558 "translate.cpp"
          $ix=$inc; //@line 558 "translate.cpp"
          var $20=$ix; //@line 558 "translate.cpp"
          var $21=$n_bytes; //@line 558 "translate.cpp"
          var $cmp23=((($20))|0) < ((($21))|0); //@line 558 "translate.cpp"
          if ($cmp23) { __label__ = 13;continue ; } else { __label__ = 14;break $if_then6$$if_end27$10; } //@line 558 "translate.cpp"
        }
      }
    } while(0);
  
    var $22=$c1; //@line 563 "translate.cpp"
    var $23=$c_addr; //@line 563 "translate.cpp"
    HEAP32[(($23)>>2)]=$22; //@line 563 "translate.cpp"
    var $24=$n_bytes; //@line 564 "translate.cpp"
    var $add28=((($24)+1)&4294967295); //@line 564 "translate.cpp"
    ;
    return $add28; //@line 564 "translate.cpp"
    return null;
  }
  

  function __Z7utf8_inPiPKc($c, $buf) {
    ;
    var __label__;
  
    var $c_addr;
    var $buf_addr;
    $c_addr=$c;
    $buf_addr=$buf;
    var $0=$c_addr; //@line 572 "translate.cpp"
    var $1=$buf_addr; //@line 572 "translate.cpp"
    var $call=__Z8utf8_in2PiPKci($0, $1, 0); //@line 572 "translate.cpp"
    ;
    return $call; //@line 572 "translate.cpp"
    return null;
  }
  

  function __Z8strchr_wPKci($s, $c) {
    ;
    var __label__;
  
    var $retval;
    var $s_addr;
    var $c_addr;
    $s_addr=$s;
    $c_addr=$c;
    var $0=$c_addr; //@line 579 "translate.cpp"
    var $cmp=((($0))|0) >= 128; //@line 579 "translate.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 579 "translate.cpp"
    if (__label__ == 1) {
  
      $retval=0; //@line 580 "translate.cpp"
      ; //@line 580 "translate.cpp"
    }
    else if (__label__ == 2) {
  
      var $1=$s_addr; //@line 581 "translate.cpp"
      var $2=$c_addr; //@line 581 "translate.cpp"
      var $call=_strchr($1, $2); //@line 581 "translate.cpp"
      $retval=$call; //@line 581 "translate.cpp"
      ; //@line 581 "translate.cpp"
    }
  
    var $3=$retval; //@line 582 "translate.cpp"
    ;
    return $3; //@line 582 "translate.cpp"
    return null;
  }
  

  function __Z10IsAllUpperPKc($word) {
    var __stackBase__  = STACKTOP; STACKTOP += 4; _memset(__stackBase__, 0, 4);
    var __label__;
  
    var $retval;
    var $word_addr;
    var $c=__stackBase__;
    $word_addr=$word;
    ; //@line 588 "translate.cpp"
    while(1) { 
  
      var $0=$word_addr; //@line 588 "translate.cpp"
      var $1=HEAP8[($0)]; //@line 588 "translate.cpp"
      var $conv=(tempInt=(($1)),(tempInt>=128?tempInt-256:tempInt)); //@line 588 "translate.cpp"
      var $cmp=((($conv))|0)!=0; //@line 588 "translate.cpp"
      if (!($cmp)) { __label__ = 5;break ; } //@line 588 "translate.cpp"
  
      var $2=$word_addr; //@line 588 "translate.cpp"
      var $3=HEAP8[($2)]; //@line 588 "translate.cpp"
      var $conv1=(tempInt=(($3)),(tempInt>=128?tempInt-256:tempInt)); //@line 588 "translate.cpp"
      var $call=__Z8isspace2j($conv1); //@line 588 "translate.cpp"
      var $tobool=((($call))|0)!=0; //@line 588 "translate.cpp"
      var $lnot=($tobool) ^ 1; //@line 588 "translate.cpp"
      if (!($lnot)) { __label__ = 5;break ; }
  
      var $4=$word_addr; //@line 590 "translate.cpp"
      var $call2=__Z7utf8_inPiPKc($c, $4); //@line 590 "translate.cpp"
      var $5=$word_addr; //@line 590 "translate.cpp"
      var $add_ptr=(($5+$call2)&4294967295); //@line 590 "translate.cpp"
      $word_addr=$add_ptr; //@line 590 "translate.cpp"
      var $6=HEAP32[(($c)>>2)]; //@line 591 "translate.cpp"
      var $call3=_iswupper($6); //@line 591 "translate.cpp"
      var $tobool4=((($call3))|0)!=0; //@line 591 "translate.cpp"
      if ($tobool4) { __label__ = 1;continue ; } else { __label__ = 4;break ; } //@line 591 "translate.cpp"
    }
    if (__label__ == 5) {
  
      $retval=1; //@line 594 "translate.cpp"
      ; //@line 594 "translate.cpp"
    }
    else if (__label__ == 4) {
  
      $retval=0; //@line 592 "translate.cpp"
      ; //@line 592 "translate.cpp"
    }
  
    var $7=$retval; //@line 595 "translate.cpp"
    STACKTOP = __stackBase__;
    return $7; //@line 595 "translate.cpp"
    return null;
  }
  

  function __Z24ChangeEquivalentPhonemesP10TranslatoriPc($tr, $lang2, $phonemes) {
    var __stackBase__  = STACKTOP; STACKTOP += 160; _memset(__stackBase__, 0, 160);
    var __label__;
  
    var $retval;
    var $tr_addr;
    var $lang2_addr;
    var $phonemes_addr;
    var $ix;
    var $len;
    var $phon;
    var $p;
    var $pb;
    var $eqlist;
    var $p_out;
    var $p_in;
    var $remove_stress;
    var $phonbuf=__stackBase__;
    $tr_addr=$tr;
    $lang2_addr=$lang2;
    $phonemes_addr=$phonemes;
    $remove_stress=0; //@line 707 "translate.cpp"
    var $0=$tr_addr; //@line 711 "translate.cpp"
    var $phoneme_tab_ix=(($0+656)&4294967295); //@line 711 "translate.cpp"
    var $1=HEAP32[(($phoneme_tab_ix)>>2)]; //@line 711 "translate.cpp"
    var $arrayidx=((_phoneme_tab_list+$1*48)&4294967295); //@line 711 "translate.cpp"
    var $equivalence_tables=(($arrayidx+44)&4294967295); //@line 711 "translate.cpp"
    var $2=HEAP32[(($equivalence_tables)>>2)]; //@line 711 "translate.cpp"
    $ix=$2; //@line 711 "translate.cpp"
    var $cmp=((($2))|0)==0; //@line 711 "translate.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 711 "translate.cpp"
    if (__label__ == 1) {
  
      $retval=0; //@line 712 "translate.cpp"
      ; //@line 712 "translate.cpp"
    }
    else if (__label__ == 2) {
  
      var $3=$ix; //@line 714 "translate.cpp"
      var $4=HEAP32[((_phondata_ptr)>>2)]; //@line 714 "translate.cpp"
      var $arrayidx1=(($4+$3)&4294967295); //@line 714 "translate.cpp"
      $pb=$arrayidx1; //@line 714 "translate.cpp"
      ; //@line 716 "translate.cpp"
      $for_cond$5: while(1) { 
  
        var $5=$pb; //@line 718 "translate.cpp"
        var $arrayidx2=(($5)&4294967295); //@line 718 "translate.cpp"
        var $6=HEAPU8[($arrayidx2)]; //@line 718 "translate.cpp"
        var $conv=((($6))&255); //@line 718 "translate.cpp"
        var $cmp3=((($conv))|0)==0; //@line 718 "translate.cpp"
        if ($cmp3) { __label__ = 4;break $for_cond$5; } //@line 718 "translate.cpp"
  
        var $7=$pb; //@line 721 "translate.cpp"
        var $arrayidx6=(($7)&4294967295); //@line 721 "translate.cpp"
        var $8=HEAPU8[($arrayidx6)]; //@line 721 "translate.cpp"
        var $conv7=((($8))&255); //@line 721 "translate.cpp"
        var $9=$lang2_addr; //@line 721 "translate.cpp"
        var $cmp8=((($conv7))|0)==((($9))|0); //@line 721 "translate.cpp"
        var $10=$pb; //@line 727 "translate.cpp"
        if ($cmp8) { __label__ = 7;break $for_cond$5; } //@line 721 "translate.cpp"
  
        var $arrayidx11=(($10+2)&4294967295); //@line 724 "translate.cpp"
        var $11=HEAPU8[($arrayidx11)]; //@line 724 "translate.cpp"
        var $conv12=((($11))&255); //@line 724 "translate.cpp"
        var $shl=((($conv12)*256)&4294967295); //@line 724 "translate.cpp"
        var $12=$pb; //@line 724 "translate.cpp"
        var $arrayidx13=(($12+3)&4294967295); //@line 724 "translate.cpp"
        var $13=HEAPU8[($arrayidx13)]; //@line 724 "translate.cpp"
        var $conv14=((($13))&255); //@line 724 "translate.cpp"
        var $add=((($conv14)+($shl))&4294967295); //@line 724 "translate.cpp"
        $len=$add; //@line 724 "translate.cpp"
        var $14=$len; //@line 725 "translate.cpp"
        var $mul=((($14)*4)&4294967295); //@line 725 "translate.cpp"
        var $15=$pb; //@line 725 "translate.cpp"
        var $add_ptr=(($15+$mul)&4294967295); //@line 725 "translate.cpp"
        $pb=$add_ptr; //@line 725 "translate.cpp"
        __label__ = 3;continue $for_cond$5; //@line 726 "translate.cpp"
      }
      if (__label__ == 4) {
  
        $retval=0; //@line 719 "translate.cpp"
        ; //@line 719 "translate.cpp"
      }
      else if (__label__ == 7) {
  
        var $arrayidx15=(($10+1)&4294967295); //@line 727 "translate.cpp"
        var $16=HEAPU8[($arrayidx15)]; //@line 727 "translate.cpp"
        var $conv16=((($16))&255); //@line 727 "translate.cpp"
        $remove_stress=$conv16; //@line 727 "translate.cpp"
        var $17=HEAP32[((_option_phonemes)>>2)]; //@line 729 "translate.cpp"
        var $cmp17=((($17))|0)==2; //@line 729 "translate.cpp"
        if ($cmp17) { __label__ = 8;; } else { __label__ = 9;; } //@line 729 "translate.cpp"
        if (__label__ == 8) {
  
          var $18=$phonemes_addr; //@line 731 "translate.cpp"
          var $arraydecay=(($phonbuf)&4294967295); //@line 731 "translate.cpp"
          __Z14DecodePhonemesPKcPc($18, $arraydecay); //@line 731 "translate.cpp"
          var $19=HEAP32[((_f_trans)>>2)]; //@line 732 "translate.cpp"
          var $20=$lang2_addr; //@line 732 "translate.cpp"
          var $arrayidx19=((_phoneme_tab_list+$20*48)&4294967295); //@line 732 "translate.cpp"
          var $name=(($arrayidx19)&4294967295); //@line 732 "translate.cpp"
          var $arraydecay20=(($name)&4294967295); //@line 732 "translate.cpp"
          var $arraydecay21=(($phonbuf)&4294967295); //@line 732 "translate.cpp"
          var $21=$tr_addr; //@line 732 "translate.cpp"
          var $phoneme_tab_ix22=(($21+656)&4294967295); //@line 732 "translate.cpp"
          var $22=HEAP32[(($phoneme_tab_ix22)>>2)]; //@line 732 "translate.cpp"
          var $arrayidx23=((_phoneme_tab_list+$22*48)&4294967295); //@line 732 "translate.cpp"
          var $name24=(($arrayidx23)&4294967295); //@line 732 "translate.cpp"
          var $arraydecay25=(($name24)&4294967295); //@line 732 "translate.cpp"
          var $call=_fprintf($19, ((__str543)&4294967295), allocate([$arraydecay20,0,0,0,$arraydecay21,0,0,0,$arraydecay25,0,0,0], ["i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 732 "translate.cpp"
          ; //@line 733 "translate.cpp"
        }
  
        var $23=$phonemes_addr; //@line 735 "translate.cpp"
        $p_in=$23; //@line 735 "translate.cpp"
        var $24=$pb; //@line 736 "translate.cpp"
        var $arrayidx27=(($24+8)&4294967295); //@line 736 "translate.cpp"
        $eqlist=$arrayidx27; //@line 736 "translate.cpp"
        var $arraydecay28=(($phonbuf)&4294967295); //@line 737 "translate.cpp"
        $p_out=$arraydecay28; //@line 737 "translate.cpp"
        var $25=$p_in; //@line 739 "translate.cpp"
        var $incdec_ptr1=(($25+1)&4294967295); //@line 739 "translate.cpp"
        $p_in=$incdec_ptr1; //@line 739 "translate.cpp"
        var $26=HEAP8[($25)]; //@line 739 "translate.cpp"
        $phon=$26; //@line 739 "translate.cpp"
        var $conv292=(tempInt=(($26)),(tempInt>=128?tempInt-256:tempInt)); //@line 739 "translate.cpp"
        var $cmp303=((($conv292))|0)!=0; //@line 739 "translate.cpp"
        if ($cmp303) { __label__ = 10;; } else { __label__ = 20;; } //@line 739 "translate.cpp"
        $while_body$$while_end56$15: do { 
          if (__label__ == 10) {
            $while_body$16: while(1) { 
  
              var $27=$remove_stress; //@line 741 "translate.cpp"
              var $tobool=((($27))|0)!=0; //@line 741 "translate.cpp"
              if ($tobool) { __label__ = 11;; } else { __label__ = 13;; } //@line 741 "translate.cpp"
              $land_lhs_true$$if_end34$18: do { 
                if (__label__ == 11) {
  
                  var $28=$phon; //@line 741 "translate.cpp"
                  var $conv31=(tempInt=(($28)),(tempInt>=128?tempInt-256:tempInt)); //@line 741 "translate.cpp"
                  var $and=($conv31) & 255; //@line 741 "translate.cpp"
                  var $cmp32=((($and))|0) < 8; //@line 741 "translate.cpp"
                  if ($cmp32) { __label__ = 12;break $land_lhs_true$$if_end34$18; } else { __label__ = 13;break $land_lhs_true$$if_end34$18; } //@line 741 "translate.cpp"
                }
              } while(0);
              $while_cond_backedge$$if_end34$20: do { 
                if (__label__ == 13) {
  
                  var $31=$eqlist; //@line 745 "translate.cpp"
                  $p=$31; //@line 745 "translate.cpp"
                  ; //@line 746 "translate.cpp"
                  while(1) { 
  
                    var $32=$p; //@line 746 "translate.cpp"
                    var $33=HEAP8[($32)]; //@line 746 "translate.cpp"
                    var $conv36=(tempInt=(($33)),(tempInt>=128?tempInt-256:tempInt)); //@line 746 "translate.cpp"
                    var $cmp37=((($conv36))|0)!=0; //@line 746 "translate.cpp"
                    if (!($cmp37)) { __label__ = 18;break ; } //@line 746 "translate.cpp"
  
                    var $34=$p; //@line 748 "translate.cpp"
                    var $arrayidx39=(($34+1)&4294967295); //@line 748 "translate.cpp"
                    var $call40=_strlen($arrayidx39); //@line 748 "translate.cpp"
                    $len=$call40; //@line 748 "translate.cpp"
                    var $35=$p; //@line 749 "translate.cpp"
                    var $36=HEAP8[($35)]; //@line 749 "translate.cpp"
                    var $conv41=(tempInt=(($36)),(tempInt>=128?tempInt-256:tempInt)); //@line 749 "translate.cpp"
                    var $37=$phon; //@line 749 "translate.cpp"
                    var $conv42=(tempInt=(($37)),(tempInt>=128?tempInt-256:tempInt)); //@line 749 "translate.cpp"
                    var $cmp43=((($conv41))|0)==((($conv42))|0); //@line 749 "translate.cpp"
                    if ($cmp43) { __label__ = 16;break ; } //@line 749 "translate.cpp"
  
                    var $42=$len; //@line 755 "translate.cpp"
                    var $add49=((($42)+2)&4294967295); //@line 755 "translate.cpp"
                    var $43=$p; //@line 755 "translate.cpp"
                    var $add_ptr50=(($43+$add49)&4294967295); //@line 755 "translate.cpp"
                    $p=$add_ptr50; //@line 755 "translate.cpp"
                    __label__ = 14;continue ; //@line 756 "translate.cpp"
                  }
                  if (__label__ == 16) {
  
                    var $38=$p_out; //@line 751 "translate.cpp"
                    var $39=$p; //@line 751 "translate.cpp"
                    var $arrayidx45=(($39+1)&4294967295); //@line 751 "translate.cpp"
                    var $call46=_strcpy($38, $arrayidx45); //@line 751 "translate.cpp"
                    var $40=$len; //@line 752 "translate.cpp"
                    var $41=$p_out; //@line 752 "translate.cpp"
                    var $add_ptr47=(($41+$40)&4294967295); //@line 752 "translate.cpp"
                    $p_out=$add_ptr47; //@line 752 "translate.cpp"
                    ; //@line 753 "translate.cpp"
                  }
  
                  var $44=$p; //@line 757 "translate.cpp"
                  var $45=HEAP8[($44)]; //@line 757 "translate.cpp"
                  var $conv51=(tempInt=(($45)),(tempInt>=128?tempInt-256:tempInt)); //@line 757 "translate.cpp"
                  var $cmp52=((($conv51))|0)==0; //@line 757 "translate.cpp"
                  if (!($cmp52)) { __label__ = 12;break $while_cond_backedge$$if_end34$20; } //@line 757 "translate.cpp"
  
                  var $46=$phon; //@line 760 "translate.cpp"
                  var $47=$p_out; //@line 760 "translate.cpp"
                  var $incdec_ptr54=(($47+1)&4294967295); //@line 760 "translate.cpp"
                  $p_out=$incdec_ptr54; //@line 760 "translate.cpp"
                  HEAP8[($47)]=$46; //@line 760 "translate.cpp"
                  ; //@line 761 "translate.cpp"
                }
              } while(0);
  
              var $29=$p_in; //@line 739 "translate.cpp"
              var $incdec_ptr=(($29+1)&4294967295); //@line 739 "translate.cpp"
              $p_in=$incdec_ptr; //@line 739 "translate.cpp"
              var $30=HEAP8[($29)]; //@line 739 "translate.cpp"
              $phon=$30; //@line 739 "translate.cpp"
              var $conv29=(tempInt=(($30)),(tempInt>=128?tempInt-256:tempInt)); //@line 739 "translate.cpp"
              var $cmp30=((($conv29))|0)!=0; //@line 739 "translate.cpp"
              if ($cmp30) { __label__ = 10;continue $while_body$16; } else { __label__ = 20;break $while_body$$while_end56$15; } //@line 739 "translate.cpp"
            }
          }
        } while(0);
  
        var $48=$p_out; //@line 763 "translate.cpp"
        HEAP8[($48)]=0; //@line 763 "translate.cpp"
        var $49=$remove_stress; //@line 765 "translate.cpp"
        var $tobool57=((($49))|0)!=0; //@line 765 "translate.cpp"
        if ($tobool57) { __label__ = 21;; } else { __label__ = 22;; } //@line 765 "translate.cpp"
        if (__label__ == 21) {
  
          var $50=$tr_addr; //@line 767 "translate.cpp"
          var $arraydecay59=(($phonbuf)&4294967295); //@line 767 "translate.cpp"
          __Z13SetWordStressP10TranslatorPcPjii($50, $arraydecay59, 0, -1, 0); //@line 767 "translate.cpp"
          ; //@line 768 "translate.cpp"
        }
  
        var $51=$phonemes_addr; //@line 770 "translate.cpp"
        var $arraydecay61=(($phonbuf)&4294967295); //@line 770 "translate.cpp"
        var $call62=_strcpy($51, $arraydecay61); //@line 770 "translate.cpp"
        var $52=HEAP32[((_option_phonemes)>>2)]; //@line 772 "translate.cpp"
        var $cmp63=((($52))|0)==2; //@line 772 "translate.cpp"
        if ($cmp63) { __label__ = 23;; } else { __label__ = 24;; } //@line 772 "translate.cpp"
        if (__label__ == 23) {
  
          var $53=$tr_addr; //@line 774 "translate.cpp"
          var $phoneme_tab_ix65=(($53+656)&4294967295); //@line 774 "translate.cpp"
          var $54=HEAP32[(($phoneme_tab_ix65)>>2)]; //@line 774 "translate.cpp"
          __Z18SelectPhonemeTablei($54); //@line 774 "translate.cpp"
          var $55=$phonemes_addr; //@line 775 "translate.cpp"
          var $arraydecay66=(($phonbuf)&4294967295); //@line 775 "translate.cpp"
          __Z14DecodePhonemesPKcPc($55, $arraydecay66); //@line 775 "translate.cpp"
          var $56=HEAP32[((_f_trans)>>2)]; //@line 776 "translate.cpp"
          var $arraydecay67=(($phonbuf)&4294967295); //@line 776 "translate.cpp"
          var $call68=_fprintf($56, ((__str1544)&4294967295), allocate([$arraydecay67,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 776 "translate.cpp"
          ; //@line 777 "translate.cpp"
        }
  
        $retval=1; //@line 778 "translate.cpp"
        ; //@line 778 "translate.cpp"
      }
    }
  
    var $57=$retval; //@line 779 "translate.cpp"
    STACKTOP = __stackBase__;
    return $57; //@line 779 "translate.cpp"
    return null;
  }
  

  function __Z13TranslateWordP10TranslatorPciP8WORD_TAB($tr, $word_start, $next_pause, $wtab) {
    var __stackBase__  = STACKTOP; STACKTOP += 1656; _memset(__stackBase__, 0, 1656);
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $tr_addr;
    var $word_start_addr;
    var $next_pause_addr;
    var $wtab_addr;
    var $word1=__stackBase__;
    var $word_length;
    var $ix;
    var $p;
    var $pfix;
    var $n_chars;
    var $dictionary_flags=__stackBase__+4;
    var $dictionary_flags2=__stackBase__+12;
    var $end_type;
    var $prefix_type;
    var $prefix_stress;
    var $wordx=__stackBase__+20;
    var $phonemes=__stackBase__+24;
    var $ph_limit;
    var $prefix_phonemes=__stackBase__+184;
    var $unpron_phonemes=__stackBase__+344;
    var $end_phonemes=__stackBase__+504;
    var $word_copy=__stackBase__+664;
    var $word_copy2=__stackBase__+824;
    var $word_copy_length;
    var $prefix_chars=__stackBase__+984;
    var $found;
    var $end_flags;
    var $c_temp;
    var $first_char=__stackBase__+1052;
    var $last_char=__stackBase__+1056;
    var $add_plural_suffix;
    var $prefix_flags;
    var $confirm_prefix;
    var $spell_word;
    var $stress_bits;
    var $emphasize_allcaps;
    var $wflags;
    var $wmark;
    var $was_unpronouncable;
    var $wtab_null=__stackBase__+1060;
    var $posn;
    var $non_initial;
    var $length;
    var $wc=__stackBase__+1156;
    var $loopcount;
    var $end2;
    var $phonemes2=__stackBase__+1160;
    var $end_phonemes2=__stackBase__+1320;
    var $wordpf=__stackBase__+1480;
    var $prefix_phonemes2=__stackBase__+1484;
    var $phonemes2482=__stackBase__+1496;
    var $p659;
    $tr_addr=$tr;
    $word_start_addr=$word_start;
    $next_pause_addr=$next_pause;
    $wtab_addr=$wtab;
    $end_type=0; //@line 796 "translate.cpp"
    $prefix_type=0; //@line 797 "translate.cpp"
    $found=0; //@line 809 "translate.cpp"
    HEAP32[(($last_char)>>2)]=0; //@line 813 "translate.cpp"
    $add_plural_suffix=0; //@line 814 "translate.cpp"
    $prefix_flags=0; //@line 815 "translate.cpp"
    $emphasize_allcaps=0; //@line 819 "translate.cpp"
    $was_unpronouncable=0; //@line 822 "translate.cpp"
    var $0=$wtab_addr; //@line 831 "translate.cpp"
    var $cmp=((($0))|0)==0; //@line 831 "translate.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 831 "translate.cpp"
    if (__label__ == 1) {
  
      var $arraydecay=(($wtab_null)&4294967295); //@line 833 "translate.cpp"
      var $1=$arraydecay; //@line 833 "translate.cpp"
      var $dest$, $stop$, $stop4$, $fast$, $value4$;
      $dest$ = $1;
      $stop$ = $dest$ + 96;
      $value4$ = 0;
      if ($value4$ < 0) $value4$ += 256;
      $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
      while ($dest$%4 !== 0 && $dest$ < $stop$) {
        ;; HEAP8[$dest$++] = 0;
      }
      $dest$ >>= 2;
      $stop4$ = $stop$ >> 2;
      while ($dest$ < $stop4$) {
      ;;;;;;;  HEAP32[$dest$++] = $value4$;
      }
      $dest$ <<= 2;
      while ($dest$ < $stop$) {
        ;; HEAP8[$dest$++] = 0;
      }; //@line 833 "translate.cpp"
      var $arraydecay1=(($wtab_null)&4294967295); //@line 834 "translate.cpp"
      $wtab_addr=$arraydecay1; //@line 834 "translate.cpp"
      ; //@line 835 "translate.cpp"
    }
  
    var $2=$wtab_addr; //@line 836 "translate.cpp"
    var $flags=(($2)&4294967295); //@line 836 "translate.cpp"
    var $3=HEAP32[(($flags)>>2)]; //@line 836 "translate.cpp"
    $wflags=$3; //@line 836 "translate.cpp"
    var $4=$wtab_addr; //@line 837 "translate.cpp"
    var $wmark2=(($4+9)&4294967295); //@line 837 "translate.cpp"
    var $5=HEAPU8[($wmark2)]; //@line 837 "translate.cpp"
    var $conv=((($5))&255); //@line 837 "translate.cpp"
    $wmark=$conv; //@line 837 "translate.cpp"
    var $arrayidx=(($dictionary_flags)&4294967295); //@line 839 "translate.cpp"
    HEAP32[(($arrayidx)>>2)]=0; //@line 839 "translate.cpp"
    var $arrayidx3=(($dictionary_flags+4)&4294967295); //@line 840 "translate.cpp"
    HEAP32[(($arrayidx3)>>2)]=0; //@line 840 "translate.cpp"
    var $arrayidx4=(($dictionary_flags2)&4294967295); //@line 841 "translate.cpp"
    HEAP32[(($arrayidx4)>>2)]=0; //@line 841 "translate.cpp"
    var $arrayidx5=(($dictionary_flags2+4)&4294967295); //@line 842 "translate.cpp"
    HEAP32[(($arrayidx5)>>2)]=0; //@line 842 "translate.cpp"
    HEAP32[((_dictionary_skipwords)>>2)]=0; //@line 843 "translate.cpp"
    var $arrayidx6=(($phonemes)&4294967295); //@line 845 "translate.cpp"
    HEAP8[($arrayidx6)]=0; //@line 845 "translate.cpp"
    var $arrayidx7=(($unpron_phonemes)&4294967295); //@line 846 "translate.cpp"
    HEAP8[($arrayidx7)]=0; //@line 846 "translate.cpp"
    var $arrayidx8=(($prefix_phonemes)&4294967295); //@line 847 "translate.cpp"
    HEAP8[($arrayidx8)]=0; //@line 847 "translate.cpp"
    var $arrayidx9=(($end_phonemes)&4294967295); //@line 848 "translate.cpp"
    HEAP8[($arrayidx9)]=0; //@line 848 "translate.cpp"
    var $arrayidx10=(($phonemes+160)&4294967295); //@line 849 "translate.cpp"
    $ph_limit=$arrayidx10; //@line 849 "translate.cpp"
    var $6=$tr_addr; //@line 851 "translate.cpp"
    var $data_dictlist=(($6+1052)&4294967295); //@line 851 "translate.cpp"
    var $7=HEAP32[(($data_dictlist)>>2)]; //@line 851 "translate.cpp"
    var $cmp11=((($7))|0)==0; //@line 851 "translate.cpp"
    if ($cmp11) { __label__ = 3;; } else { __label__ = 4;; } //@line 851 "translate.cpp"
    $if_then12$$if_end13$5: do { 
      if (__label__ == 3) {
  
        HEAP8[(((_word_phonemes)&4294967295))]=0; //@line 854 "translate.cpp"
        $retval=0; //@line 855 "translate.cpp"
        ; //@line 855 "translate.cpp"
      }
      else if (__label__ == 4) {
  
        var $8=$word_start_addr; //@line 859 "translate.cpp"
        HEAP32[(($word1)>>2)]=$8; //@line 859 "translate.cpp"
        var $9=HEAP32[(($word1)>>2)]; //@line 860 "translate.cpp"
        var $10=HEAP8[($9)]; //@line 860 "translate.cpp"
        var $conv14=(tempInt=(($10)),(tempInt>=128?tempInt-256:tempInt)); //@line 860 "translate.cpp"
        var $cmp15=((($conv14))|0)==32; //@line 860 "translate.cpp"
        if ($cmp15) { __label__ = 5;; } else { __label__ = 6;; } //@line 860 "translate.cpp"
        if (__label__ == 5) {
  
          var $11=HEAP32[(($word1)>>2)]; //@line 860 "translate.cpp"
          var $incdec_ptr=(($11+1)&4294967295); //@line 860 "translate.cpp"
          HEAP32[(($word1)>>2)]=$incdec_ptr; //@line 860 "translate.cpp"
          ; //@line 860 "translate.cpp"
        }
  
        var $12=HEAP32[(($word1)>>2)]; //@line 861 "translate.cpp"
        HEAP32[(($wordx)>>2)]=$12; //@line 861 "translate.cpp"
        var $13=HEAP32[(($wordx)>>2)]; //@line 863 "translate.cpp"
        var $call=__Z7utf8_inPiPKc($first_char, $13); //@line 863 "translate.cpp"
        $word_length=0; //@line 864 "translate.cpp"
        ; //@line 865 "translate.cpp"
        $while_cond$11: while(1) { 
  
          var $14=HEAP32[(($wordx)>>2)]; //@line 865 "translate.cpp"
          var $15=HEAP8[($14)]; //@line 865 "translate.cpp"
          var $conv18=(tempInt=(($15)),(tempInt>=128?tempInt-256:tempInt)); //@line 865 "translate.cpp"
          var $cmp19=((($conv18))|0)!=0; //@line 865 "translate.cpp"
          var $16=HEAP32[(($wordx)>>2)]; //@line 865 "translate.cpp"
          if ($cmp19) { __lastLabel__ = 7; ; } else { __lastLabel__ = 7; __label__ = 10;break $while_cond$11; } //@line 865 "translate.cpp"
  
          var $17=HEAP8[($16)]; //@line 865 "translate.cpp"
          var $conv20=(tempInt=(($17)),(tempInt>=128?tempInt-256:tempInt)); //@line 865 "translate.cpp"
          var $cmp21=((($conv20))|0)!=32; //@line 865 "translate.cpp"
          var $18=HEAP32[(($wordx)>>2)]; //@line 867 "translate.cpp"
          if ($cmp21) { __lastLabel__ = 8; ; } else { __lastLabel__ = 8; __label__ = 10;break $while_cond$11; }
  
          var $call22=__Z7utf8_inPiPKc($last_char, $18); //@line 867 "translate.cpp"
          var $19=HEAP32[(($wordx)>>2)]; //@line 867 "translate.cpp"
          var $add_ptr=(($19+$call22)&4294967295); //@line 867 "translate.cpp"
          HEAP32[(($wordx)>>2)]=$add_ptr; //@line 867 "translate.cpp"
          var $20=$word_length; //@line 868 "translate.cpp"
          var $inc=((($20)+1)&4294967295); //@line 868 "translate.cpp"
          $word_length=$inc; //@line 868 "translate.cpp"
          __label__ = 7;continue $while_cond$11; //@line 869 "translate.cpp"
        }
  
        var $21=__lastLabel__ == 8 ? $18 : ($16);
        var $22=$word_start_addr; //@line 871 "translate.cpp"
        var $sub_ptr_lhs_cast=($21); //@line 871 "translate.cpp"
        var $sub_ptr_rhs_cast=($22); //@line 871 "translate.cpp"
        var $sub_ptr_sub=((($sub_ptr_lhs_cast)-($sub_ptr_rhs_cast))&4294967295); //@line 871 "translate.cpp"
        $word_copy_length=$sub_ptr_sub; //@line 871 "translate.cpp"
        var $cmp23=((($sub_ptr_sub))|0) >= 160; //@line 872 "translate.cpp"
        if ($cmp23) { __label__ = 11;; } else { __label__ = 12;; } //@line 872 "translate.cpp"
        if (__label__ == 11) {
  
          $word_copy_length=159; //@line 873 "translate.cpp"
          ; //@line 873 "translate.cpp"
        }
  
        var $arraydecay26=(($word_copy2)&4294967295); //@line 874 "translate.cpp"
        var $23=$word_start_addr; //@line 874 "translate.cpp"
        var $24=$word_copy_length; //@line 874 "translate.cpp"
        var $src$, $dest$, $stop$, $stop4$, $fast$;
        $src$ = $23;
        $dest$ = $arraydecay26;
        $stop$ = $src$ + $24;
        if (($dest$%4) == ($src$%4) && $24 > 8) {
          while ($src$%4 !== 0 && $src$ < $stop$) {
            ; HEAP8[$dest$++] = HEAP8[$src$++];
          }
          $src$ >>= 2;
          $dest$ >>= 2;
          $stop4$ = $stop$ >> 2;
          while ($src$ < $stop4$) {
        ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
          }
          $src$ <<= 2;
          $dest$ <<= 2;
        }while ($src$ < $stop$) {
          ; HEAP8[$dest$++] = HEAP8[$src$++];
        }; //@line 874 "translate.cpp"
        $spell_word=0; //@line 876 "translate.cpp"
        var $25=HEAP32[((_option_sayas)>>2)]; //@line 878 "translate.cpp"
        var $cmp27=((($25))|0)==36; //@line 878 "translate.cpp"
        if ($cmp27) { __label__ = 13;; } else { __label__ = 16;; } //@line 878 "translate.cpp"
        if (__label__ == 13) {
  
          var $26=$word_length; //@line 880 "translate.cpp"
          var $cmp29=((($26))|0)==1; //@line 880 "translate.cpp"
          if ($cmp29) { __label__ = 14;; } else { __label__ = 15;; } //@line 880 "translate.cpp"
          if (__label__ == 14) {
  
            $spell_word=4; //@line 881 "translate.cpp"
            ; //@line 881 "translate.cpp"
          }
          else if (__label__ == 15) {
  
            var $27=HEAP32[(($word1)>>2)]; //@line 885 "translate.cpp"
            var $incdec_ptr31=(($27+-1)&4294967295); //@line 885 "translate.cpp"
            HEAP32[(($word1)>>2)]=$incdec_ptr31; //@line 885 "translate.cpp"
            var $28=HEAP32[(($word1)>>2)]; //@line 886 "translate.cpp"
            HEAP8[($28)]=95; //@line 886 "translate.cpp"
            var $29=$tr_addr; //@line 887 "translate.cpp"
            var $arraydecay32=(($phonemes)&4294967295); //@line 887 "translate.cpp"
            var $arraydecay33=(($dictionary_flags)&4294967295); //@line 887 "translate.cpp"
            var $30=$wtab_addr; //@line 887 "translate.cpp"
            var $call34=__Z14LookupDictListP10TranslatorPPcS1_PjiP8WORD_TAB($29, $word1, $arraydecay32, $arraydecay33, 0, $30); //@line 887 "translate.cpp"
            $found=$call34; //@line 887 "translate.cpp"
            ;
          }
        }
  
        var $31=HEAP32[((_option_sayas)>>2)]; //@line 893 "translate.cpp"
        var $and=($31) & 16; //@line 893 "translate.cpp"
        var $tobool=((($and))|0)!=0; //@line 893 "translate.cpp"
        if ($tobool) { __label__ = 17;; } else { __label__ = 18;; } //@line 893 "translate.cpp"
        $if_then37$$if_else39$25: do { 
          if (__label__ == 17) {
  
            var $32=HEAP32[((_option_sayas)>>2)]; //@line 896 "translate.cpp"
            var $and38=($32) & 15; //@line 896 "translate.cpp"
            $spell_word=$and38; //@line 896 "translate.cpp"
            __lastLabel__ = 17; __label__ = 70;break $if_then37$$if_else39$25; //@line 897 "translate.cpp"
          }
          else if (__label__ == 18) {
  
            var $33=$found; //@line 900 "translate.cpp"
            var $tobool40=((($33))|0)!=0; //@line 900 "translate.cpp"
            if ($tobool40) { __label__ = 20;; } else { __label__ = 19;; } //@line 900 "translate.cpp"
            if (__label__ == 19) {
  
              var $34=$tr_addr; //@line 901 "translate.cpp"
              var $arraydecay42=(($phonemes)&4294967295); //@line 901 "translate.cpp"
              var $arraydecay43=(($dictionary_flags)&4294967295); //@line 901 "translate.cpp"
              var $35=$wtab_addr; //@line 901 "translate.cpp"
              var $call44=__Z14LookupDictListP10TranslatorPPcS1_PjiP8WORD_TAB($34, $word1, $arraydecay42, $arraydecay43, 2, $35); //@line 901 "translate.cpp"
              $found=$call44; //@line 901 "translate.cpp"
              ; //@line 901 "translate.cpp"
            }
  
            var $arrayidx46=(($dictionary_flags)&4294967295); //@line 904 "translate.cpp"
            var $36=HEAP32[(($arrayidx46)>>2)]; //@line 904 "translate.cpp"
            var $and47=($36) & 1; //@line 904 "translate.cpp"
            var $tobool48=((($and47))|0)!=0; //@line 904 "translate.cpp"
            if ($tobool48) { __label__ = 21;; } else { __label__ = 23;; } //@line 904 "translate.cpp"
            $land_lhs_true$$if_end54$31: do { 
              if (__label__ == 21) {
  
                var $37=HEAP32[(($wordx)>>2)]; //@line 904 "translate.cpp"
                var $arrayidx49=(($37+1)&4294967295); //@line 904 "translate.cpp"
                var $38=HEAP8[($arrayidx49)]; //@line 904 "translate.cpp"
                var $conv50=(tempInt=(($38)),(tempInt>=128?tempInt-256:tempInt)); //@line 904 "translate.cpp"
                var $cmp51=((($conv50))|0)==46; //@line 904 "translate.cpp"
                if (!($cmp51)) { __label__ = 23;break $land_lhs_true$$if_end54$31; } //@line 904 "translate.cpp"
  
                var $39=HEAP32[(($wordx)>>2)]; //@line 906 "translate.cpp"
                var $arrayidx53=(($39+1)&4294967295); //@line 906 "translate.cpp"
                HEAP8[($arrayidx53)]=32; //@line 906 "translate.cpp"
                ; //@line 907 "translate.cpp"
              }
            } while(0);
  
            var $arrayidx55=(($dictionary_flags)&4294967295); //@line 909 "translate.cpp"
            var $40=HEAP32[(($arrayidx55)>>2)]; //@line 909 "translate.cpp"
            var $and56=($40) & 536870912; //@line 909 "translate.cpp"
            var $tobool57=((($and56))|0)!=0; //@line 909 "translate.cpp"
            if ($tobool57) { __label__ = 24;; } else { __label__ = 27;; } //@line 909 "translate.cpp"
            $if_then58$$if_else80$35: do { 
              if (__label__ == 24) {
  
                var $41=HEAP32[(($word1)>>2)]; //@line 911 "translate.cpp"
                var $arrayidx59=(($41)&4294967295); //@line 911 "translate.cpp"
                var $42=HEAP8[($arrayidx59)]; //@line 911 "translate.cpp"
                var $conv60=(tempInt=(($42)),(tempInt>=128?tempInt-256:tempInt)); //@line 911 "translate.cpp"
                HEAP32[(($first_char)>>2)]=$conv60; //@line 911 "translate.cpp"
                var $arrayidx61=(($dictionary_flags)&4294967295); //@line 912 "translate.cpp"
                var $43=HEAP32[(($arrayidx61)>>2)]; //@line 912 "translate.cpp"
                var $and62=($43) & 127; //@line 912 "translate.cpp"
                $stress_bits=$and62; //@line 912 "translate.cpp"
                var $44=$tr_addr; //@line 913 "translate.cpp"
                var $arraydecay63=(($phonemes)&4294967295); //@line 913 "translate.cpp"
                var $arraydecay64=(($dictionary_flags2)&4294967295); //@line 913 "translate.cpp"
                var $45=$wtab_addr; //@line 913 "translate.cpp"
                var $call65=__Z14LookupDictListP10TranslatorPPcS1_PjiP8WORD_TAB($44, $word1, $arraydecay63, $arraydecay64, 0, $45); //@line 913 "translate.cpp"
                $found=$call65; //@line 913 "translate.cpp"
                var $arrayidx66=(($dictionary_flags2)&4294967295); //@line 914 "translate.cpp"
                var $46=HEAP32[(($arrayidx66)>>2)]; //@line 914 "translate.cpp"
                var $cmp67=((($46))|0)!=0; //@line 914 "translate.cpp"
                if (!($cmp67)) { __label__ = 33;break $if_then58$$if_else80$35; } //@line 914 "translate.cpp"
  
                var $arrayidx69=(($dictionary_flags2)&4294967295); //@line 916 "translate.cpp"
                var $47=HEAP32[(($arrayidx69)>>2)]; //@line 916 "translate.cpp"
                var $arrayidx70=(($dictionary_flags)&4294967295); //@line 916 "translate.cpp"
                HEAP32[(($arrayidx70)>>2)]=$47; //@line 916 "translate.cpp"
                var $arrayidx71=(($dictionary_flags2+4)&4294967295); //@line 917 "translate.cpp"
                var $48=HEAP32[(($arrayidx71)>>2)]; //@line 917 "translate.cpp"
                var $arrayidx72=(($dictionary_flags+4)&4294967295); //@line 917 "translate.cpp"
                HEAP32[(($arrayidx72)>>2)]=$48; //@line 917 "translate.cpp"
                var $49=$stress_bits; //@line 918 "translate.cpp"
                var $cmp73=((($49))|0)!=0; //@line 918 "translate.cpp"
                if (!($cmp73)) { __label__ = 33;break $if_then58$$if_else80$35; } //@line 918 "translate.cpp"
  
                var $arrayidx75=(($dictionary_flags)&4294967295); //@line 921 "translate.cpp"
                var $50=HEAP32[(($arrayidx75)>>2)]; //@line 921 "translate.cpp"
                var $and76=($50) & -128; //@line 921 "translate.cpp"
                var $51=$stress_bits; //@line 921 "translate.cpp"
                var $or=($and76) | ($51); //@line 921 "translate.cpp"
                var $arrayidx77=(($dictionary_flags)&4294967295); //@line 921 "translate.cpp"
                HEAP32[(($arrayidx77)>>2)]=$or; //@line 921 "translate.cpp"
                ; //@line 922 "translate.cpp"
              }
              else if (__label__ == 27) {
  
                var $52=$found; //@line 926 "translate.cpp"
                var $cmp81=((($52))|0)==0; //@line 926 "translate.cpp"
                if (!($cmp81)) { __label__ = 33;break $if_then58$$if_else80$35; } //@line 926 "translate.cpp"
  
                var $arrayidx83=(($dictionary_flags)&4294967295); //@line 926 "translate.cpp"
                var $53=HEAP32[(($arrayidx83)>>2)]; //@line 926 "translate.cpp"
                var $and84=($53) & 128; //@line 926 "translate.cpp"
                var $tobool85=((($and84))|0)!=0; //@line 926 "translate.cpp"
                if (!($tobool85)) { __label__ = 33;break $if_then58$$if_else80$35; } //@line 926 "translate.cpp"
  
                var $54=HEAP32[(($word1)>>2)]; //@line 929 "translate.cpp"
                HEAP32[(($wordx)>>2)]=$54; //@line 929 "translate.cpp"
                $ix=0; //@line 930 "translate.cpp"
                var $55=$ix; //@line 931 "translate.cpp"
                var $56=HEAP32[((_dictionary_skipwords)>>2)]; //@line 931 "translate.cpp"
                var $cmp8815=((($55))|0) < ((($56))|0); //@line 931 "translate.cpp"
                if (!($cmp8815)) { __label__ = 33;break $if_then58$$if_else80$35; } //@line 931 "translate.cpp"
                while(1) { 
  
                  var $57=HEAP32[(($wordx)>>2)]; //@line 933 "translate.cpp"
                  var $58=HEAP8[($57)]; //@line 933 "translate.cpp"
                  var $conv90=(tempInt=(($58)),(tempInt>=128?tempInt-256:tempInt)); //@line 933 "translate.cpp"
                  var $cmp91=((($conv90))|0)==32; //@line 933 "translate.cpp"
                  if ($cmp91) { __label__ = 31;; } else { __label__ = 32;; } //@line 933 "translate.cpp"
                  if (__label__ == 31) {
  
                    var $59=HEAP32[(($wordx)>>2)]; //@line 935 "translate.cpp"
                    HEAP8[($59)]=45; //@line 935 "translate.cpp"
                    var $60=$ix; //@line 936 "translate.cpp"
                    var $inc93=((($60)+1)&4294967295); //@line 936 "translate.cpp"
                    $ix=$inc93; //@line 936 "translate.cpp"
                    ; //@line 937 "translate.cpp"
                  }
  
                  var $61=HEAP32[(($wordx)>>2)]; //@line 938 "translate.cpp"
                  var $incdec_ptr95=(($61+1)&4294967295); //@line 938 "translate.cpp"
                  HEAP32[(($wordx)>>2)]=$incdec_ptr95; //@line 938 "translate.cpp"
                  var $62=$ix; //@line 931 "translate.cpp"
                  var $63=HEAP32[((_dictionary_skipwords)>>2)]; //@line 931 "translate.cpp"
                  var $cmp88=((($62))|0) < ((($63))|0); //@line 931 "translate.cpp"
                  if ($cmp88) { __label__ = 30;continue ; } else { __label__ = 33;break $if_then58$$if_else80$35; } //@line 931 "translate.cpp"
                }
              }
            } while(0);
  
            var $64=$word_length; //@line 942 "translate.cpp"
            var $cmp99=((($64))|0)==1; //@line 942 "translate.cpp"
            var $65=HEAP32[((_dictionary_skipwords)>>2)]; //@line 942 "translate.cpp"
            var $cmp101=((($65))|0)==0; //@line 942 "translate.cpp"
            var $or_cond=($cmp99) & ($cmp101); //@line 942 "translate.cpp"
            if ($or_cond) { __label__ = 34;; } else { __label__ = 37;; } //@line 942 "translate.cpp"
            $if_then102$$if_end113$48: do { 
              if (__label__ == 34) {
  
                var $66=HEAP32[(($word1)>>2)]; //@line 945 "translate.cpp"
                var $67=$wtab_addr; //@line 945 "translate.cpp"
                var $call103=__ZL17CheckDottedAbbrevPcP8WORD_TAB($66, $67); //@line 945 "translate.cpp"
                var $tobool104=((($call103))|0)!=0; //@line 945 "translate.cpp"
                if (!($tobool104)) { __label__ = 37;break $if_then102$$if_end113$48; } //@line 945 "translate.cpp"
  
                var $arrayidx106=(($dictionary_flags)&4294967295); //@line 947 "translate.cpp"
                HEAP32[(($arrayidx106)>>2)]=0; //@line 947 "translate.cpp"
                var $arrayidx107=(($dictionary_flags+4)&4294967295); //@line 948 "translate.cpp"
                HEAP32[(($arrayidx107)>>2)]=0; //@line 948 "translate.cpp"
                $spell_word=1; //@line 949 "translate.cpp"
                var $68=HEAP32[((_dictionary_skipwords)>>2)]; //@line 950 "translate.cpp"
                var $tobool108=((($68))|0)!=0; //@line 950 "translate.cpp"
                if (!($tobool108)) { __label__ = 37;break $if_then102$$if_end113$48; } //@line 950 "translate.cpp"
  
                var $arrayidx110=(($dictionary_flags)&4294967295); //@line 951 "translate.cpp"
                HEAP32[(($arrayidx110)>>2)]=128; //@line 951 "translate.cpp"
                ; //@line 951 "translate.cpp"
              }
            } while(0);
  
            var $arrayidx114=(($phonemes)&4294967295); //@line 958 "translate.cpp"
            var $69=HEAP8[($arrayidx114)]; //@line 958 "translate.cpp"
            var $conv115=(tempInt=(($69)),(tempInt>=128?tempInt-256:tempInt)); //@line 958 "translate.cpp"
            var $cmp116=((($conv115))|0)==21; //@line 958 "translate.cpp"
            if ($cmp116) { __label__ = 38;; } else { __label__ = 39;; } //@line 958 "translate.cpp"
            if (__label__ == 38) {
  
              var $arraydecay118=(($phonemes)&4294967295); //@line 961 "translate.cpp"
              var $call119=_strcpy(((_word_phonemes)&4294967295), $arraydecay118); //@line 961 "translate.cpp"
              $retval=0; //@line 962 "translate.cpp"
              __label__ = 236;break $if_then12$$if_end13$5; //@line 962 "translate.cpp"
            }
            else if (__label__ == 39) {
  
              var $70=$wmark; //@line 965 "translate.cpp"
              var $cmp121=((($70))|0) > 0; //@line 965 "translate.cpp"
              var $71=$wmark; //@line 965 "translate.cpp"
              var $cmp123=((($71))|0) < 8; //@line 965 "translate.cpp"
              var $or_cond1=($cmp121) & ($cmp123); //@line 965 "translate.cpp"
              if ($or_cond1) { __label__ = 40;; } else { __label__ = 41;; } //@line 965 "translate.cpp"
              if (__label__ == 40) {
  
                var $arrayidx125=(($dictionary_flags)&4294967295); //@line 968 "translate.cpp"
                var $72=HEAP32[(($arrayidx125)>>2)]; //@line 968 "translate.cpp"
                var $and126=($72) & -16; //@line 968 "translate.cpp"
                var $73=$wmark; //@line 968 "translate.cpp"
                var $or127=($and126) | ($73); //@line 968 "translate.cpp"
                var $arrayidx128=(($dictionary_flags)&4294967295); //@line 968 "translate.cpp"
                HEAP32[(($arrayidx128)>>2)]=$or127; //@line 968 "translate.cpp"
                ; //@line 969 "translate.cpp"
              }
  
              var $74=$found; //@line 971 "translate.cpp"
              var $tobool130=((($74))|0)!=0; //@line 971 "translate.cpp"
              if ($tobool130) { __label__ = 49;; } else { __label__ = 42;; } //@line 971 "translate.cpp"
              $if_end150$$land_lhs_true131$59: do { 
                if (__label__ == 42) {
  
                  var $arrayidx132=(($dictionary_flags)&4294967295); //@line 971 "translate.cpp"
                  var $75=HEAP32[(($arrayidx132)>>2)]; //@line 971 "translate.cpp"
                  var $and133=($75) & 131072; //@line 971 "translate.cpp"
                  var $tobool134=((($and133))|0)!=0; //@line 971 "translate.cpp"
                  if ($tobool134) { __label__ = 43;; } else { __label__ = 44;; } //@line 971 "translate.cpp"
                  if (__label__ == 43) {
  
                    $spell_word=1; //@line 974 "translate.cpp"
                    ; //@line 975 "translate.cpp"
                  }
  
                  var $_pr=$found; //@line 977 "translate.cpp"
                  var $tobool137=((($_pr))|0)!=0; //@line 977 "translate.cpp"
                  if ($tobool137) { __label__ = 49;break $if_end150$$land_lhs_true131$59; } //@line 977 "translate.cpp"
  
                  var $76=HEAP32[(($first_char)>>2)]; //@line 977 "translate.cpp"
                  var $call139=_iswdigit($76); //@line 977 "translate.cpp"
                  var $tobool140=((($call139))|0)!=0; //@line 977 "translate.cpp"
                  if (!($tobool140)) { __label__ = 49;break $if_end150$$land_lhs_true131$59; } //@line 977 "translate.cpp"
  
                  var $77=$tr_addr; //@line 979 "translate.cpp"
                  var $call142=__Z6LookupP10TranslatorPKcPc($77, ((__str2545)&4294967295), ((_word_phonemes)&4294967295)); //@line 979 "translate.cpp"
                  var $78=HEAP8[(((_word_phonemes)&4294967295))]; //@line 980 "translate.cpp"
                  var $conv143=(tempInt=(($78)),(tempInt>=128?tempInt-256:tempInt)); //@line 980 "translate.cpp"
                  var $cmp144=((($conv143))|0)==21; //@line 980 "translate.cpp"
                  if ($cmp144) { __label__ = 47;; } else { __label__ = 48;; } //@line 980 "translate.cpp"
                  if (__label__ == 47) {
  
                    $retval=0; //@line 981 "translate.cpp"
                    __label__ = 236;break $if_then12$$if_end13$5; //@line 981 "translate.cpp"
                  }
                  else if (__label__ == 48) {
  
                    var $79=$tr_addr; //@line 983 "translate.cpp"
                    var $80=HEAP32[(($word1)>>2)]; //@line 983 "translate.cpp"
                    var $arraydecay147=(($phonemes)&4294967295); //@line 983 "translate.cpp"
                    var $arraydecay148=(($dictionary_flags)&4294967295); //@line 983 "translate.cpp"
                    var $81=$wtab_addr; //@line 983 "translate.cpp"
                    var $call149=__Z15TranslateNumberP10TranslatorPcS1_PjP8WORD_TABi($79, $80, $arraydecay147, $arraydecay148, $81, 0); //@line 983 "translate.cpp"
                    $found=$call149; //@line 983 "translate.cpp"
                    ; //@line 984 "translate.cpp"
                  }
                }
              } while(0);
  
              var $82=$found; //@line 986 "translate.cpp"
              var $tobool151=((($82))|0)!=0; //@line 986 "translate.cpp"
              var $lnot=($tobool151) ^ 1; //@line 986 "translate.cpp"
              var $conv152=((($lnot))&1); //@line 986 "translate.cpp"
              var $83=$wflags; //@line 986 "translate.cpp"
              var $and153=($83) & 3; //@line 986 "translate.cpp"
              var $cmp154=((($and153))|0)!=2; //@line 986 "translate.cpp"
              var $conv155=((($cmp154))&1); //@line 986 "translate.cpp"
              var $and156=($conv155) & ($conv152); //@line 986 "translate.cpp"
              var $tobool157=((($and156))|0)!=0; //@line 986 "translate.cpp"
              if ($tobool157) { __label__ = 50;; } else { __label__ = 57;; } //@line 986 "translate.cpp"
              $if_then158$$if_end186$70: do { 
                if (__label__ == 50) {
  
                  var $84=$tr_addr; //@line 990 "translate.cpp"
                  var $langopts=(($84)&4294967295); //@line 990 "translate.cpp"
                  var $numbers=(($langopts+184)&4294967295); //@line 990 "translate.cpp"
                  var $85=HEAP32[(($numbers)>>2)]; //@line 990 "translate.cpp"
                  var $and159=($85) & 16777216; //@line 990 "translate.cpp"
                  var $tobool160=((($and159))|0)!=0; //@line 990 "translate.cpp"
                  if ($tobool160) { __label__ = 53;; } else { __label__ = 51;; } //@line 990 "translate.cpp"
                  if (__label__ == 51) {
  
                    var $86=$tr_addr; //@line 990 "translate.cpp"
                    var $langopts161=(($86)&4294967295); //@line 990 "translate.cpp"
                    var $numbers162=(($langopts161+184)&4294967295); //@line 990 "translate.cpp"
                    var $87=HEAP32[(($numbers162)>>2)]; //@line 990 "translate.cpp"
                    var $and163=($87) & 33554432; //@line 990 "translate.cpp"
                    var $tobool164=((($and163))|0)!=0; //@line 990 "translate.cpp"
                    if (!($tobool164)) { __label__ = 57;break $if_then158$$if_end186$70; } //@line 990 "translate.cpp"
  
                    var $88=$wflags; //@line 990 "translate.cpp"
                    var $and166=($88) & 1; //@line 990 "translate.cpp"
                    var $tobool167=((($and166))|0)!=0; //@line 990 "translate.cpp"
                    if (!($tobool167)) { __label__ = 57;break $if_then158$$if_end186$70; } //@line 990 "translate.cpp"
                  }
  
                  var $89=$wflags; //@line 992 "translate.cpp"
                  var $and169=($89) & 16; //@line 992 "translate.cpp"
                  var $tobool170=((($and169))|0)!=0; //@line 992 "translate.cpp"
                  if ($tobool170) { __label__ = 55;; } else { __label__ = 54;; } //@line 992 "translate.cpp"
                  if (__label__ == 54) {
  
                    var $90=$wtab_addr; //@line 992 "translate.cpp"
                    var $arrayidx172=(($90+12)&4294967295); //@line 992 "translate.cpp"
                    var $flags173=(($arrayidx172)&4294967295); //@line 992 "translate.cpp"
                    var $91=HEAP32[(($flags173)>>2)]; //@line 992 "translate.cpp"
                    var $and174=($91) & 256; //@line 992 "translate.cpp"
                    var $tobool175=((($and174))|0)!=0; //@line 992 "translate.cpp"
                    if ($tobool175) { __label__ = 57;break $if_then158$$if_end186$70; } //@line 992 "translate.cpp"
                  }
  
                  var $92=$tr_addr; //@line 995 "translate.cpp"
                  var $93=HEAP32[(($word1)>>2)]; //@line 995 "translate.cpp"
                  var $arraydecay177=(($phonemes)&4294967295); //@line 995 "translate.cpp"
                  var $94=$wtab_addr; //@line 995 "translate.cpp"
                  var $call178=__Z14TranslateRomanP10TranslatorPcS1_P8WORD_TAB($92, $93, $arraydecay177, $94); //@line 995 "translate.cpp"
                  $found=$call178; //@line 995 "translate.cpp"
                  var $cmp179=((($call178))|0)!=0; //@line 995 "translate.cpp"
                  if (!($cmp179)) { __label__ = 57;break $if_then158$$if_end186$70; } //@line 995 "translate.cpp"
  
                  var $arrayidx181=(($dictionary_flags)&4294967295); //@line 996 "translate.cpp"
                  var $95=HEAP32[(($arrayidx181)>>2)]; //@line 996 "translate.cpp"
                  var $or182=($95) | 131072; //@line 996 "translate.cpp"
                  HEAP32[(($arrayidx181)>>2)]=$or182; //@line 996 "translate.cpp"
                  ; //@line 996 "translate.cpp"
                }
              } while(0);
  
              var $96=$wflags; //@line 1001 "translate.cpp"
              var $and187=($96) & 1; //@line 1001 "translate.cpp"
              var $tobool188=((($and187))|0)!=0; //@line 1001 "translate.cpp"
              if ($tobool188) { __label__ = 58;; } else { __label__ = 69;; } //@line 1001 "translate.cpp"
              $land_lhs_true189$$if_end219thread_pre_split$81: do { 
                if (__label__ == 58) {
  
                  var $97=$word_length; //@line 1001 "translate.cpp"
                  var $cmp190=((($97))|0) > 1; //@line 1001 "translate.cpp"
                  if (!($cmp190)) { __label__ = 69;break $land_lhs_true189$$if_end219thread_pre_split$81; } //@line 1001 "translate.cpp"
  
                  var $98=HEAP32[(($first_char)>>2)]; //@line 1001 "translate.cpp"
                  var $call192=_iswalpha($98); //@line 1001 "translate.cpp"
                  var $tobool193=((($call192))|0)!=0; //@line 1001 "translate.cpp"
                  if (!($tobool193)) { __label__ = 69;break $land_lhs_true189$$if_end219thread_pre_split$81; } //@line 1001 "translate.cpp"
  
                  var $99=HEAP32[((_option_tone_flags)>>2)]; //@line 1003 "translate.cpp"
                  var $and195=($99) & 256; //@line 1003 "translate.cpp"
                  var $tobool196=((($and195))|0)!=0; //@line 1003 "translate.cpp"
                  if ($tobool196) { __label__ = 61;; } else { __label__ = 63;; } //@line 1003 "translate.cpp"
                  $land_lhs_true197$$if_else202$85: do { 
                    if (__label__ == 61) {
  
                      var $arrayidx198=(($dictionary_flags)&4294967295); //@line 1003 "translate.cpp"
                      var $100=HEAP32[(($arrayidx198)>>2)]; //@line 1003 "translate.cpp"
                      var $and199=($100) & 131072; //@line 1003 "translate.cpp"
                      var $tobool200=((($and199))|0)!=0; //@line 1003 "translate.cpp"
                      if ($tobool200) { __label__ = 63;break $land_lhs_true197$$if_else202$85; } //@line 1003 "translate.cpp"
  
                      $emphasize_allcaps=2048; //@line 1006 "translate.cpp"
                      __label__ = 69;break $land_lhs_true189$$if_end219thread_pre_split$81; //@line 1007 "translate.cpp"
                    }
                  } while(0);
  
                  var $101=$found; //@line 1009 "translate.cpp"
                  var $tobool203=((($101))|0)!=0; //@line 1009 "translate.cpp"
                  if ($tobool203) { __label__ = 69;break $land_lhs_true189$$if_end219thread_pre_split$81; } //@line 1009 "translate.cpp"
  
                  var $arrayidx205=(($dictionary_flags)&4294967295); //@line 1009 "translate.cpp"
                  var $102=HEAP32[(($arrayidx205)>>2)]; //@line 1009 "translate.cpp"
                  var $and206=($102) & 128; //@line 1009 "translate.cpp"
                  var $tobool207=((($and206))|0)!=0; //@line 1009 "translate.cpp"
                  if ($tobool207) { __label__ = 69;break $land_lhs_true189$$if_end219thread_pre_split$81; } //@line 1009 "translate.cpp"
  
                  var $103=$word_length; //@line 1009 "translate.cpp"
                  var $cmp209=((($103))|0) < 4; //@line 1009 "translate.cpp"
                  if (!($cmp209)) { __label__ = 69;break $land_lhs_true189$$if_end219thread_pre_split$81; } //@line 1009 "translate.cpp"
  
                  var $104=$tr_addr; //@line 1009 "translate.cpp"
                  var $clause_lower_count=(($104+8308)&4294967295); //@line 1009 "translate.cpp"
                  var $105=HEAP32[(($clause_lower_count)>>2)]; //@line 1009 "translate.cpp"
                  var $cmp211=((($105))|0) > 3; //@line 1009 "translate.cpp"
                  if (!($cmp211)) { __label__ = 69;break $land_lhs_true189$$if_end219thread_pre_split$81; } //@line 1009 "translate.cpp"
  
                  var $106=$tr_addr; //@line 1009 "translate.cpp"
                  var $clause_upper_count=(($106+8304)&4294967295); //@line 1009 "translate.cpp"
                  var $107=HEAP32[(($clause_upper_count)>>2)]; //@line 1009 "translate.cpp"
                  var $108=$tr_addr; //@line 1009 "translate.cpp"
                  var $clause_lower_count213=(($108+8308)&4294967295); //@line 1009 "translate.cpp"
                  var $109=HEAP32[(($clause_lower_count213)>>2)]; //@line 1009 "translate.cpp"
                  var $cmp214=((($107))|0) <= ((($109))|0); //@line 1009 "translate.cpp"
                  if (!($cmp214)) { __label__ = 69;break $land_lhs_true189$$if_end219thread_pre_split$81; } //@line 1009 "translate.cpp"
  
                  $spell_word=1; //@line 1013 "translate.cpp"
                  __label__ = 71;break $if_then37$$if_else39$25; //@line 1018 "translate.cpp"
                }
              } while(0);
  
              var $_pr5=$spell_word; //@line 1018 "translate.cpp"
              __lastLabel__ = 69; __label__ = 70;break $if_then37$$if_else39$25;
            }
          }
        } while(0);
        $if_end219$$if_then221$95: do { 
          if (__label__ == 70) {
  
            var $110=__lastLabel__ == 69 ? $_pr5 : ($and38); //@line 1018 "translate.cpp"
            var $cmp220=((($110))|0) > 0; //@line 1018 "translate.cpp"
            if ($cmp220) { __label__ = 71;break $if_end219$$if_then221$95; } //@line 1018 "translate.cpp"
  
            var $115=$found; //@line 1032 "translate.cpp"
            var $cmp232=((($115))|0)==0; //@line 1032 "translate.cpp"
            if (!($cmp232)) { __label__ = 166;break $if_end219$$if_then221$95; } //@line 1032 "translate.cpp"
  
            $posn=0; //@line 1040 "translate.cpp"
            $non_initial=0; //@line 1041 "translate.cpp"
            $length=999; //@line 1042 "translate.cpp"
            var $116=HEAP32[(($word1)>>2)]; //@line 1043 "translate.cpp"
            HEAP32[(($wordx)>>2)]=$116; //@line 1043 "translate.cpp"
            var $arraydecay252=(($unpron_phonemes)&4294967295); //@line 1058 "translate.cpp"
            var $arrayidx256=(($unpron_phonemes)&4294967295); //@line 1060 "translate.cpp"
            ; //@line 1045 "translate.cpp"
            $while_cond234$99: while(1) { 
  
              var $117=$length; //@line 1045 "translate.cpp"
              var $cmp235=((($117))|0) < 3; //@line 1045 "translate.cpp"
              var $118=$length; //@line 1045 "translate.cpp"
              var $cmp237=((($118))|0) > 0; //@line 1045 "translate.cpp"
              var $or_cond2=($cmp235) & ($cmp237); //@line 1045 "translate.cpp"
              if ($or_cond2) { __label__ = 80;; } else { __label__ = 78;; } //@line 1045 "translate.cpp"
              if (__label__ == 78) {
  
                var $119=$word_length; //@line 1045 "translate.cpp"
                var $cmp238=((($119))|0) > 1; //@line 1045 "translate.cpp"
                if (!($cmp238)) { __label__ = 89;break $while_cond234$99; } //@line 1045 "translate.cpp"
  
                var $120=$tr_addr; //@line 1045 "translate.cpp"
                var $121=HEAP32[(($wordx)>>2)]; //@line 1045 "translate.cpp"
                var $122=$posn; //@line 1045 "translate.cpp"
                var $call240=__Z14UnpronouncableP10TranslatorPci($120, $121, $122); //@line 1045 "translate.cpp"
                var $tobool241=((($call240))|0)!=0; //@line 1045 "translate.cpp"
                if (!($tobool241)) { __label__ = 89;break $while_cond234$99; }
              }
  
              $was_unpronouncable=67108864; //@line 1049 "translate.cpp"
              $emphasize_allcaps=0; //@line 1050 "translate.cpp"
              var $123=HEAP32[(($wordx)>>2)]; //@line 1052 "translate.cpp"
              var $arrayidx244=(($123)&4294967295); //@line 1052 "translate.cpp"
              var $124=HEAP8[($arrayidx244)]; //@line 1052 "translate.cpp"
              var $conv245=(tempInt=(($124)),(tempInt>=128?tempInt-256:tempInt)); //@line 1052 "translate.cpp"
              var $cmp246=((($conv245))|0)==39; //@line 1052 "translate.cpp"
              if ($cmp246) { __label__ = 89;break $while_cond234$99; } //@line 1052 "translate.cpp"
  
              var $125=$posn; //@line 1055 "translate.cpp"
              var $cmp249=((($125))|0) > 0; //@line 1055 "translate.cpp"
              if ($cmp249) { __label__ = 82;; } else { __label__ = 83;; } //@line 1055 "translate.cpp"
              if (__label__ == 82) {
  
                $non_initial=1; //@line 1056 "translate.cpp"
                ; //@line 1056 "translate.cpp"
              }
  
              var $126=$tr_addr; //@line 1058 "translate.cpp"
              var $127=HEAP32[(($wordx)>>2)]; //@line 1058 "translate.cpp"
              var $128=$non_initial; //@line 1058 "translate.cpp"
              var $call253=__Z15TranslateLetterP10TranslatorPcS1_i($126, $127, $arraydecay252, $128); //@line 1058 "translate.cpp"
              var $129=HEAP32[(($wordx)>>2)]; //@line 1058 "translate.cpp"
              var $add_ptr254=(($129+$call253)&4294967295); //@line 1058 "translate.cpp"
              HEAP32[(($wordx)>>2)]=$add_ptr254; //@line 1058 "translate.cpp"
              var $130=$posn; //@line 1059 "translate.cpp"
              var $inc255=((($130)+1)&4294967295); //@line 1059 "translate.cpp"
              $posn=$inc255; //@line 1059 "translate.cpp"
              var $131=HEAP8[($arrayidx256)]; //@line 1060 "translate.cpp"
              var $conv257=(tempInt=(($131)),(tempInt>=128?tempInt-256:tempInt)); //@line 1060 "translate.cpp"
              var $cmp258=((($conv257))|0)==21; //@line 1060 "translate.cpp"
              if ($cmp258) { __label__ = 84;break $while_cond234$99; } //@line 1060 "translate.cpp"
  
              $length=0; //@line 1080 "translate.cpp"
              var $132=$length; //@line 1081 "translate.cpp"
              var $133=HEAP32[(($wordx)>>2)]; //@line 1081 "translate.cpp"
              var $arrayidx26921=(($133+$132)&4294967295); //@line 1081 "translate.cpp"
              var $134=HEAP8[($arrayidx26921)]; //@line 1081 "translate.cpp"
              var $conv27022=(tempInt=(($134)),(tempInt>=128?tempInt-256:tempInt)); //@line 1081 "translate.cpp"
              var $cmp27123=((($conv27022))|0)!=32; //@line 1081 "translate.cpp"
              if (!($cmp27123)) { __label__ = 77;continue $while_cond234$99; } //@line 1081 "translate.cpp"
              while(1) { 
  
                var $135=$length; //@line 1081 "translate.cpp"
                var $inc273=((($135)+1)&4294967295); //@line 1081 "translate.cpp"
                $length=$inc273; //@line 1081 "translate.cpp"
                var $136=$length; //@line 1081 "translate.cpp"
                var $137=HEAP32[(($wordx)>>2)]; //@line 1081 "translate.cpp"
                var $arrayidx269=(($137+$136)&4294967295); //@line 1081 "translate.cpp"
                var $138=HEAP8[($arrayidx269)]; //@line 1081 "translate.cpp"
                var $conv270=(tempInt=(($138)),(tempInt>=128?tempInt-256:tempInt)); //@line 1081 "translate.cpp"
                var $cmp271=((($conv270))|0)!=32; //@line 1081 "translate.cpp"
                if ($cmp271) { __label__ = 88;continue ; } else { __label__ = 77;continue $while_cond234$99; } //@line 1081 "translate.cpp"
              }
            }
            if (__label__ == 89) {
  
              var $139=$tr_addr; //@line 1083 "translate.cpp"
              var $arraydecay276=(($unpron_phonemes)&4294967295); //@line 1083 "translate.cpp"
              var $140=$posn; //@line 1083 "translate.cpp"
              __Z17SetSpellingStressP10TranslatorPcii($139, $arraydecay276, 0, $140); //@line 1083 "translate.cpp"
              var $141=HEAP32[(($wordx)>>2)]; //@line 1086 "translate.cpp"
              var $142=HEAP8[($141)]; //@line 1086 "translate.cpp"
              var $conv277=(tempInt=(($142)),(tempInt>=128?tempInt-256:tempInt)); //@line 1086 "translate.cpp"
              var $cmp278=((($conv277))|0)!=32; //@line 1086 "translate.cpp"
              if (!($cmp278)) { __label__ = 166;break $if_end219$$if_then221$95; } //@line 1086 "translate.cpp"
  
              var $arrayidx280=(($unpron_phonemes)&4294967295); //@line 1088 "translate.cpp"
              var $143=HEAP8[($arrayidx280)]; //@line 1088 "translate.cpp"
              var $conv281=(tempInt=(($143)),(tempInt>=128?tempInt-256:tempInt)); //@line 1088 "translate.cpp"
              var $cmp282=((($conv281))|0)!=0; //@line 1088 "translate.cpp"
              if ($cmp282) { __label__ = 91;; } else { __label__ = 93;; } //@line 1088 "translate.cpp"
              $land_lhs_true283$$if_end289$115: do { 
                if (__label__ == 91) {
  
                  var $144=HEAP32[(($wordx)>>2)]; //@line 1088 "translate.cpp"
                  var $arrayidx284=(($144)&4294967295); //@line 1088 "translate.cpp"
                  var $145=HEAP8[($arrayidx284)]; //@line 1088 "translate.cpp"
                  var $conv285=(tempInt=(($145)),(tempInt>=128?tempInt-256:tempInt)); //@line 1088 "translate.cpp"
                  var $cmp286=((($conv285))|0)!=39; //@line 1088 "translate.cpp"
                  if (!($cmp286)) { __label__ = 93;break $land_lhs_true283$$if_end289$115; } //@line 1088 "translate.cpp"
  
                  var $146=HEAP32[(($wordx)>>2)]; //@line 1091 "translate.cpp"
                  var $arrayidx288=(($146+-1)&4294967295); //@line 1091 "translate.cpp"
                  HEAP8[($arrayidx288)]=32; //@line 1091 "translate.cpp"
                  ; //@line 1092 "translate.cpp"
                }
              } while(0);
  
              var $147=$tr_addr; //@line 1095 "translate.cpp"
              var $148=HEAP32[(($wordx)>>2)]; //@line 1095 "translate.cpp"
              var $arraydecay290=(($phonemes)&4294967295); //@line 1095 "translate.cpp"
              var $arraydecay291=(($end_phonemes)&4294967295); //@line 1095 "translate.cpp"
              var $149=$wflags; //@line 1095 "translate.cpp"
              var $arraydecay292=(($dictionary_flags)&4294967295); //@line 1095 "translate.cpp"
              var $call293=__Z14TranslateRulesP10TranslatorPcS1_iS1_iPj($147, $148, $arraydecay290, 160, $arraydecay291, $149, $arraydecay292); //@line 1095 "translate.cpp"
              $end_type=$call293; //@line 1095 "translate.cpp"
              var $arrayidx294=(($phonemes)&4294967295); //@line 1097 "translate.cpp"
              var $150=HEAP8[($arrayidx294)]; //@line 1097 "translate.cpp"
              var $conv295=(tempInt=(($150)),(tempInt>=128?tempInt-256:tempInt)); //@line 1097 "translate.cpp"
              var $cmp296=((($conv295))|0)==21; //@line 1097 "translate.cpp"
              var $arraydecay298=(($phonemes)&4294967295); //@line 1100 "translate.cpp"
              if ($cmp296) { __label__ = 94;; } else { __label__ = 95;; } //@line 1097 "translate.cpp"
              if (__label__ == 94) {
  
                var $call299=_strcpy(((_word_phonemes)&4294967295), $arraydecay298); //@line 1100 "translate.cpp"
                $retval=0; //@line 1101 "translate.cpp"
                __label__ = 236;break $if_then12$$if_end13$5; //@line 1101 "translate.cpp"
              }
              else if (__label__ == 95) {
  
                var $151=HEAP8[($arraydecay298)]; //@line 1104 "translate.cpp"
                var $conv302=(tempInt=(($151)),(tempInt>=128?tempInt-256:tempInt)); //@line 1104 "translate.cpp"
                var $cmp303=((($conv302))|0)==0; //@line 1104 "translate.cpp"
                if ($cmp303) { __label__ = 96;; } else { __label__ = 101;; } //@line 1104 "translate.cpp"
                $land_lhs_true304$$if_end321$122: do { 
                  if (__label__ == 96) {
  
                    var $arrayidx305=(($end_phonemes)&4294967295); //@line 1104 "translate.cpp"
                    var $152=HEAP8[($arrayidx305)]; //@line 1104 "translate.cpp"
                    var $conv306=(tempInt=(($152)),(tempInt>=128?tempInt-256:tempInt)); //@line 1104 "translate.cpp"
                    var $cmp307=((($conv306))|0)==0; //@line 1104 "translate.cpp"
                    if (!($cmp307)) { __label__ = 101;break $land_lhs_true304$$if_end321$122; } //@line 1104 "translate.cpp"
  
                    var $153=HEAP32[(($wordx)>>2)]; //@line 1109 "translate.cpp"
                    var $call309=__Z7utf8_inPiPKc($wc, $153); //@line 1109 "translate.cpp"
                    var $154=$word_length; //@line 1110 "translate.cpp"
                    var $cmp310=((($154))|0)==1; //@line 1110 "translate.cpp"
                    if (!($cmp310)) { __label__ = 101;break $land_lhs_true304$$if_end321$122; } //@line 1110 "translate.cpp"
  
                    var $155=HEAP32[(($wc)>>2)]; //@line 1110 "translate.cpp"
                    var $call312=__Z7IsAlphaj($155); //@line 1110 "translate.cpp"
                    var $tobool313=((($call312))|0)!=0; //@line 1110 "translate.cpp"
                    if (!($tobool313)) { __label__ = 101;break $land_lhs_true304$$if_end321$122; } //@line 1110 "translate.cpp"
  
                    var $156=$tr_addr; //@line 1112 "translate.cpp"
                    var $157=HEAP32[(($wordx)>>2)]; //@line 1112 "translate.cpp"
                    var $arraydecay315=(($phonemes)&4294967295); //@line 1112 "translate.cpp"
                    var $158=$spell_word; //@line 1112 "translate.cpp"
                    var $call316=__ZL22SpeakIndividualLettersP10TranslatorPcS1_i($156, $157, $arraydecay315, $158); //@line 1112 "translate.cpp"
                    HEAP32[(($wordx)>>2)]=$call316; //@line 1112 "translate.cpp"
                    var $cmp317=((($call316))|0)==0; //@line 1112 "translate.cpp"
                    if (!($cmp317)) { __label__ = 101;break $land_lhs_true304$$if_end321$122; } //@line 1112 "translate.cpp"
  
                    $retval=0; //@line 1114 "translate.cpp"
                    __label__ = 236;break $if_then12$$if_end13$5; //@line 1114 "translate.cpp"
                  }
                } while(0);
  
                var $159=HEAP32[(($wordx)>>2)]; //@line 1119 "translate.cpp"
                var $arrayidx322=(($159+-1)&4294967295); //@line 1119 "translate.cpp"
                var $160=HEAP8[($arrayidx322)]; //@line 1119 "translate.cpp"
                $c_temp=$160; //@line 1119 "translate.cpp"
                $found=0; //@line 1121 "translate.cpp"
                $confirm_prefix=1; //@line 1122 "translate.cpp"
                $loopcount=0; //@line 1123 "translate.cpp"
                var $arrayidx333=(($phonemes2)&4294967295); //@line 1134 "translate.cpp"
                var $arraydecay334=(($phonemes2)&4294967295); //@line 1135 "translate.cpp"
                var $arraydecay335=(($end_phonemes2)&4294967295); //@line 1135 "translate.cpp"
                var $arraydecay338=(($dictionary_flags)&4294967295); //@line 1135 "translate.cpp"
                var $arraydecay342=(($word_copy)&4294967295); //@line 1138 "translate.cpp"
                var $arraydecay344=(($phonemes)&4294967295); //@line 1139 "translate.cpp"
                var $arraydecay345=(($end_phonemes)&4294967295); //@line 1139 "translate.cpp"
                var $arraydecay347=(($dictionary_flags)&4294967295); //@line 1139 "translate.cpp"
                var $arraydecay349=(($word_copy)&4294967295); //@line 1140 "translate.cpp"
                var $arraydecay350=(($word_copy)&4294967295); //@line 1140 "translate.cpp"
                var $arraydecay355=(($phonemes)&4294967295); //@line 1146 "translate.cpp"
                var $arraydecay356=(($phonemes2)&4294967295); //@line 1146 "translate.cpp"
                var $arraydecay358=(($end_phonemes)&4294967295); //@line 1147 "translate.cpp"
                var $arraydecay359=(($end_phonemes2)&4294967295); //@line 1147 "translate.cpp"
                var $arraydecay363=(($end_phonemes)&4294967295); //@line 1150 "translate.cpp"
                var $arraydecay364=(($end_phonemes2)&4294967295); //@line 1150 "translate.cpp"
                var $arraydecay365=(($end_phonemes2)&4294967295); //@line 1151 "translate.cpp"
                var $arraydecay418=(($prefix_phonemes2)&4294967295); //@line 1204 "translate.cpp"
                var $arraydecay419=(($end_phonemes)&4294967295); //@line 1204 "translate.cpp"
                var $arrayidx420=(($prefix_chars+1)&4294967295); //@line 1205 "translate.cpp"
                var $arraydecay421=(($prefix_phonemes)&4294967295); //@line 1206 "translate.cpp"
                var $arraydecay422=(($phonemes)&4294967295); //@line 1206 "translate.cpp"
                var $arraydecay424=(($phonemes)&4294967295); //@line 1209 "translate.cpp"
                var $arraydecay425=(($dictionary_flags)&4294967295); //@line 1209 "translate.cpp"
                var $arraydecay429=(($prefix_phonemes)&4294967295); //@line 1212 "translate.cpp"
                var $arraydecay430=(($phonemes)&4294967295); //@line 1212 "translate.cpp"
                var $arrayidx433=(($dictionary_flags)&4294967295); //@line 1214 "translate.cpp"
                var $arrayidx437=(($prefix_phonemes)&4294967295); //@line 1216 "translate.cpp"
                var $arraydecay438=(($prefix_phonemes)&4294967295); //@line 1217 "translate.cpp"
                var $arrayidx446=(($end_phonemes)&4294967295); //@line 1224 "translate.cpp"
                var $arraydecay447=(($phonemes)&4294967295); //@line 1227 "translate.cpp"
                var $arraydecay448=(($dictionary_flags2)&4294967295); //@line 1227 "translate.cpp"
                var $arrayidx450=(($dictionary_flags)&4294967295); //@line 1228 "translate.cpp"
                var $arrayidx453=(($dictionary_flags2)&4294967295); //@line 1230 "translate.cpp"
                var $arrayidx454=(($dictionary_flags)&4294967295); //@line 1230 "translate.cpp"
                var $arrayidx455=(($dictionary_flags2+4)&4294967295); //@line 1231 "translate.cpp"
                var $arrayidx456=(($dictionary_flags+4)&4294967295); //@line 1231 "translate.cpp"
                var $arraydecay461=(($phonemes)&4294967295); //@line 1237 "translate.cpp"
                var $arraydecay462=(($end_phonemes)&4294967295); //@line 1237 "translate.cpp"
                var $arraydecay463=(($dictionary_flags)&4294967295); //@line 1237 "translate.cpp"
                var $arrayidx465=(($phonemes)&4294967295); //@line 1239 "translate.cpp"
                var $arraydecay442=(($prefix_phonemes)&4294967295); //@line 1222 "translate.cpp"
                var $arraydecay443=(($end_phonemes)&4294967295); //@line 1222 "translate.cpp"
                var $arrayidx392=(($prefix_chars)&4294967295); //@line 1179 "translate.cpp"
                __lastLabel__ = 101; ; //@line 1123 "translate.cpp"
                $for_cond$129: while(1) { 
  
                  var $161=__lastLabel__ == 136 ? $inc475 : (0); //@line 1123 "translate.cpp"
                  var $cmp323=((($161))|0) < 50; //@line 1123 "translate.cpp"
                  var $162=$end_type; //@line 1123 "translate.cpp"
                  if (!($cmp323)) { __label__ = 137;break $for_cond$129; } //@line 1123 "translate.cpp"
  
                  var $and325=($162) & 1024; //@line 1123 "translate.cpp"
                  var $tobool326=((($and325))|0)!=0; //@line 1123 "translate.cpp"
                  if (!($tobool326)) { __label__ = 137;break $for_cond$129; }
  
                  var $163=$confirm_prefix; //@line 1127 "translate.cpp"
                  var $tobool328=((($163))|0)!=0; //@line 1127 "translate.cpp"
                  if ($tobool328) { __label__ = 105;; } else { __label__ = 111;; } //@line 1127 "translate.cpp"
                  $land_lhs_true329$$if_end370$133: do { 
                    if (__label__ == 105) {
  
                      var $164=$end_type; //@line 1127 "translate.cpp"
                      var $and330=($164) & 131072; //@line 1127 "translate.cpp"
                      var $tobool331=((($and330))|0)!=0; //@line 1127 "translate.cpp"
                      if ($tobool331) { __label__ = 111;break $land_lhs_true329$$if_end370$133; } //@line 1127 "translate.cpp"
  
                      HEAP8[($arrayidx333)]=0; //@line 1134 "translate.cpp"
                      var $165=$tr_addr; //@line 1135 "translate.cpp"
                      var $166=HEAP32[(($wordx)>>2)]; //@line 1135 "translate.cpp"
                      var $167=$wflags; //@line 1135 "translate.cpp"
                      var $or337=($167) | 805306368; //@line 1135 "translate.cpp"
                      var $call339=__Z14TranslateRulesP10TranslatorPcS1_iS1_iPj($165, $166, $arraydecay334, 160, $arraydecay335, $or337, $arraydecay338); //@line 1135 "translate.cpp"
                      $end2=$call339; //@line 1135 "translate.cpp"
                      var $168=$end2; //@line 1136 "translate.cpp"
                      var $tobool340=((($168))|0)!=0; //@line 1136 "translate.cpp"
                      if (!($tobool340)) { __label__ = 111;break $land_lhs_true329$$if_end370$133; } //@line 1136 "translate.cpp"
  
                      var $169=$tr_addr; //@line 1138 "translate.cpp"
                      var $170=HEAP32[(($wordx)>>2)]; //@line 1138 "translate.cpp"
                      var $171=$end2; //@line 1138 "translate.cpp"
                      var $call343=__Z12RemoveEndingP10TranslatorPciS1_($169, $170, $171, $arraydecay342); //@line 1138 "translate.cpp"
                      var $172=$tr_addr; //@line 1139 "translate.cpp"
                      var $173=HEAP32[(($wordx)>>2)]; //@line 1139 "translate.cpp"
                      var $174=$wflags; //@line 1139 "translate.cpp"
                      var $or346=($174) | 268435456; //@line 1139 "translate.cpp"
                      var $call348=__Z14TranslateRulesP10TranslatorPcS1_iS1_iPj($172, $173, $arraydecay344, 160, $arraydecay345, $or346, $arraydecay347); //@line 1139 "translate.cpp"
                      $end_type=$call348; //@line 1139 "translate.cpp"
                      var $175=HEAP32[(($wordx)>>2)]; //@line 1140 "translate.cpp"
                      var $call351=_strlen($arraydecay350); //@line 1140 "translate.cpp"
                      var $src$, $dest$, $stop$, $stop4$, $fast$;
                      $src$ = $arraydecay349;
                      $dest$ = $175;
                      $stop$ = $src$ + $call351;
                      if (($dest$%4) == ($src$%4) && $call351 > 8) {
                        while ($src$%4 !== 0 && $src$ < $stop$) {
                          ; HEAP8[$dest$++] = HEAP8[$src$++];
                        }
                        $src$ >>= 2;
                        $dest$ >>= 2;
                        $stop4$ = $stop$ >> 2;
                        while ($src$ < $stop4$) {
                      ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
                        }
                        $src$ <<= 2;
                        $dest$ <<= 2;
                      }while ($src$ < $stop$) {
                        ; HEAP8[$dest$++] = HEAP8[$src$++];
                      }; //@line 1140 "translate.cpp"
                      var $176=$end_type; //@line 1141 "translate.cpp"
                      var $and352=($176) & 1024; //@line 1141 "translate.cpp"
                      var $cmp353=((($and352))|0)==0; //@line 1141 "translate.cpp"
                      if ($cmp353) { __label__ = 108;; } else { __label__ = 110;; } //@line 1141 "translate.cpp"
                      $if_then354$$if_end368$137: do { 
                        if (__label__ == 108) {
  
                          var $177=$end2; //@line 1145 "translate.cpp"
                          $end_type=$177; //@line 1145 "translate.cpp"
                          var $call357=_strcpy($arraydecay355, $arraydecay356); //@line 1146 "translate.cpp"
                          var $call360=_strcpy($arraydecay358, $arraydecay359); //@line 1147 "translate.cpp"
                          var $178=HEAP32[((_option_phonemes)>>2)]; //@line 1148 "translate.cpp"
                          var $cmp361=((($178))|0)==2; //@line 1148 "translate.cpp"
                          if (!($cmp361)) { __label__ = 110;break $if_then354$$if_end368$137; } //@line 1148 "translate.cpp"
  
                          __Z14DecodePhonemesPKcPc($arraydecay363, $arraydecay364); //@line 1150 "translate.cpp"
                          var $179=HEAP32[((_f_trans)>>2)]; //@line 1151 "translate.cpp"
                          var $call366=_fprintf($179, ((__str4547)&4294967295), allocate([$arraydecay365,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 1151 "translate.cpp"
                          ; //@line 1152 "translate.cpp"
                        }
                      } while(0);
  
                      $confirm_prefix=0; //@line 1154 "translate.cpp"
                      __label__ = 136;break $land_lhs_true329$$if_end370$133; //@line 1155 "translate.cpp"
                    }
                  } while(0);
                  $if_end370$$for_inc474$141: do { 
                    if (__label__ == 111) {
  
                      var $180=$end_type; //@line 1159 "translate.cpp"
                      $prefix_type=$180; //@line 1159 "translate.cpp"
                      var $181=$prefix_type; //@line 1161 "translate.cpp"
                      var $and371=($181) & 2048; //@line 1161 "translate.cpp"
                      var $tobool372=((($and371))|0)!=0; //@line 1161 "translate.cpp"
                      if ($tobool372) { __label__ = 112;; } else { __label__ = 113;; } //@line 1161 "translate.cpp"
                      if (__label__ == 112) {
  
                        var $182=$tr_addr; //@line 1163 "translate.cpp"
                        var $expect_verb=(($182+8272)&4294967295); //@line 1163 "translate.cpp"
                        HEAP32[(($expect_verb)>>2)]=1; //@line 1163 "translate.cpp"
                        ; //@line 1164 "translate.cpp"
                      }
  
                      var $183=$c_temp; //@line 1166 "translate.cpp"
                      var $184=HEAP32[(($wordx)>>2)]; //@line 1166 "translate.cpp"
                      var $arrayidx375=(($184+-1)&4294967295); //@line 1166 "translate.cpp"
                      HEAP8[($arrayidx375)]=$183; //@line 1166 "translate.cpp"
                      var $185=$prefix_type; //@line 1168 "translate.cpp"
                      var $and376=($185) & 131072; //@line 1168 "translate.cpp"
                      var $cmp377=((($and376))|0)==0; //@line 1168 "translate.cpp"
                      if ($cmp377) { __label__ = 114;; } else { __label__ = 118;; } //@line 1168 "translate.cpp"
                      $if_then378$$if_else391$146: do { 
                        if (__label__ == 114) {
  
                          var $186=$prefix_type; //@line 1170 "translate.cpp"
                          var $and379=($186) & 15; //@line 1170 "translate.cpp"
                          $ix=$and379; //@line 1170 "translate.cpp"
                          var $cmp38119=((($and379))|0) > 0; //@line 1170 "translate.cpp"
                          if (!($cmp38119)) { __label__ = 124;break $if_then378$$if_else391$146; } //@line 1170 "translate.cpp"
                          $for_body382$148: while(1) { 
  
                            var $187=HEAP32[(($wordx)>>2)]; //@line 1172 "translate.cpp"
                            var $incdec_ptr383=(($187+1)&4294967295); //@line 1172 "translate.cpp"
                            HEAP32[(($wordx)>>2)]=$incdec_ptr383; //@line 1172 "translate.cpp"
                            var $188=HEAP32[(($wordx)>>2)]; //@line 1173 "translate.cpp"
                            var $189=HEAP8[($188)]; //@line 1173 "translate.cpp"
                            var $conv38516=(tempInt=(($189)),(tempInt>=128?tempInt-256:tempInt)); //@line 1173 "translate.cpp"
                            var $and38617=($conv38516) & 192; //@line 1173 "translate.cpp"
                            var $cmp38718=((($and38617))|0)==128; //@line 1173 "translate.cpp"
                            if ($cmp38718) { __label__ = 116;; } else { __label__ = 117;; } //@line 1173 "translate.cpp"
                            $while_body388$$for_inc$150: do { 
                              if (__label__ == 116) {
                                while(1) { 
  
                                  var $190=HEAP32[(($wordx)>>2)]; //@line 1173 "translate.cpp"
                                  var $incdec_ptr389=(($190+1)&4294967295); //@line 1173 "translate.cpp"
                                  HEAP32[(($wordx)>>2)]=$incdec_ptr389; //@line 1173 "translate.cpp"
                                  var $191=HEAP32[(($wordx)>>2)]; //@line 1173 "translate.cpp"
                                  var $192=HEAP8[($191)]; //@line 1173 "translate.cpp"
                                  var $conv385=(tempInt=(($192)),(tempInt>=128?tempInt-256:tempInt)); //@line 1173 "translate.cpp"
                                  var $and386=($conv385) & 192; //@line 1173 "translate.cpp"
                                  var $cmp387=((($and386))|0)==128; //@line 1173 "translate.cpp"
                                  if ($cmp387) { __label__ = 116;continue ; } else { __label__ = 117;break $while_body388$$for_inc$150; } //@line 1173 "translate.cpp"
                                }
                              }
                            } while(0);
  
                            var $193=$ix; //@line 1170 "translate.cpp"
                            var $dec=((($193)-1)&4294967295); //@line 1170 "translate.cpp"
                            $ix=$dec; //@line 1170 "translate.cpp"
                            var $cmp381=((($dec))|0) > 0; //@line 1170 "translate.cpp"
                            if ($cmp381) { __label__ = 115;continue $for_body382$148; } else { __label__ = 124;break $if_then378$$if_else391$146; } //@line 1170 "translate.cpp"
                          }
                        }
                        else if (__label__ == 118) {
  
                          $pfix=1; //@line 1178 "translate.cpp"
                          HEAP8[($arrayidx392)]=0; //@line 1179 "translate.cpp"
                          var $194=$prefix_type; //@line 1180 "translate.cpp"
                          var $and393=($194) & 63; //@line 1180 "translate.cpp"
                          $n_chars=$and393; //@line 1180 "translate.cpp"
                          $ix=0; //@line 1182 "translate.cpp"
                          var $195=$ix; //@line 1182 "translate.cpp"
                          var $196=$n_chars; //@line 1182 "translate.cpp"
                          var $cmp39520=((($195))|0) < ((($196))|0); //@line 1182 "translate.cpp"
                          if ($cmp39520) { __label__ = 119;; } else { __label__ = 123;; } //@line 1182 "translate.cpp"
                          $for_body396$$for_end410$155: do { 
                            if (__label__ == 119) {
                              $for_body396$156: while(1) { 
  
                                var $197=HEAP32[(($wordx)>>2)]; //@line 1184 "translate.cpp"
                                var $incdec_ptr397=(($197+1)&4294967295); //@line 1184 "translate.cpp"
                                HEAP32[(($wordx)>>2)]=$incdec_ptr397; //@line 1184 "translate.cpp"
                                var $198=HEAP8[($197)]; //@line 1184 "translate.cpp"
                                var $199=$pfix; //@line 1184 "translate.cpp"
                                var $inc398=((($199)+1)&4294967295); //@line 1184 "translate.cpp"
                                $pfix=$inc398; //@line 1184 "translate.cpp"
                                var $arrayidx399=(($prefix_chars+$199)&4294967295); //@line 1184 "translate.cpp"
                                HEAP8[($arrayidx399)]=$198; //@line 1184 "translate.cpp"
                                var $200=$prefix_type; //@line 1186 "translate.cpp"
                                var $and400=($200) & 131072; //@line 1186 "translate.cpp"
                                var $tobool401=((($and400))|0)!=0; //@line 1186 "translate.cpp"
                                if ($tobool401) { __label__ = 120;; } else { __label__ = 122;; } //@line 1186 "translate.cpp"
                                $land_lhs_true402$$for_inc408$158: do { 
                                  if (__label__ == 120) {
  
                                    var $201=$ix; //@line 1186 "translate.cpp"
                                    var $202=$n_chars; //@line 1186 "translate.cpp"
                                    var $sub=((($202)-1)&4294967295); //@line 1186 "translate.cpp"
                                    var $cmp403=((($201))|0)==((($sub))|0); //@line 1186 "translate.cpp"
                                    if (!($cmp403)) { __label__ = 122;break $land_lhs_true402$$for_inc408$158; } //@line 1186 "translate.cpp"
  
                                    var $203=$pfix; //@line 1188 "translate.cpp"
                                    var $sub405=((($203)-1)&4294967295); //@line 1188 "translate.cpp"
                                    var $arrayidx406=(($prefix_chars+$sub405)&4294967295); //@line 1188 "translate.cpp"
                                    HEAP8[($arrayidx406)]=0; //@line 1188 "translate.cpp"
                                    ; //@line 1189 "translate.cpp"
                                  }
                                } while(0);
  
                                var $204=$ix; //@line 1182 "translate.cpp"
                                var $inc409=((($204)+1)&4294967295); //@line 1182 "translate.cpp"
                                $ix=$inc409; //@line 1182 "translate.cpp"
                                var $205=$ix; //@line 1182 "translate.cpp"
                                var $206=$n_chars; //@line 1182 "translate.cpp"
                                var $cmp395=((($205))|0) < ((($206))|0); //@line 1182 "translate.cpp"
                                if ($cmp395) { __label__ = 119;continue $for_body396$156; } else { __label__ = 123;break $for_body396$$for_end410$155; } //@line 1182 "translate.cpp"
                              }
                            }
                          } while(0);
  
                          var $207=$pfix; //@line 1191 "translate.cpp"
                          var $arrayidx411=(($prefix_chars+$207)&4294967295); //@line 1191 "translate.cpp"
                          HEAP8[($arrayidx411)]=0; //@line 1191 "translate.cpp"
                          ;
                        }
                      } while(0);
  
                      var $208=HEAP32[(($wordx)>>2)]; //@line 1193 "translate.cpp"
                      var $arrayidx413=(($208+-1)&4294967295); //@line 1193 "translate.cpp"
                      var $209=HEAP8[($arrayidx413)]; //@line 1193 "translate.cpp"
                      $c_temp=$209; //@line 1193 "translate.cpp"
                      var $210=HEAP32[(($wordx)>>2)]; //@line 1194 "translate.cpp"
                      var $arrayidx414=(($210+-1)&4294967295); //@line 1194 "translate.cpp"
                      HEAP8[($arrayidx414)]=32; //@line 1194 "translate.cpp"
                      $confirm_prefix=1; //@line 1195 "translate.cpp"
                      var $211=$prefix_type; //@line 1197 "translate.cpp"
                      var $and415=($211) & 131072; //@line 1197 "translate.cpp"
                      var $tobool416=((($and415))|0)!=0; //@line 1197 "translate.cpp"
                      if ($tobool416) { __label__ = 125;; } else { __label__ = 129;; } //@line 1197 "translate.cpp"
                      $if_then417$$if_else441$164: do { 
                        if (__label__ == 125) {
  
                          __Z8strncpy0PcPKci($arraydecay418, $arraydecay419, 12); //@line 1204 "translate.cpp"
                          HEAP32[(($wordpf)>>2)]=$arrayidx420; //@line 1205 "translate.cpp"
                          var $call423=_strcpy($arraydecay421, $arraydecay422); //@line 1206 "translate.cpp"
                          var $212=$tr_addr; //@line 1209 "translate.cpp"
                          var $213=$wtab_addr; //@line 1209 "translate.cpp"
                          var $call426=__Z14LookupDictListP10TranslatorPPcS1_PjiP8WORD_TAB($212, $wordpf, $arraydecay424, $arraydecay425, 0, $213); //@line 1209 "translate.cpp"
                          $found=$call426; //@line 1209 "translate.cpp"
                          var $214=$found; //@line 1210 "translate.cpp"
                          var $tobool427=((($214))|0)!=0; //@line 1210 "translate.cpp"
                          if ($tobool427) { __label__ = 126;; } else { __label__ = 127;; } //@line 1210 "translate.cpp"
                          if (__label__ == 126) {
  
                            var $call431=_strcpy($arraydecay429, $arraydecay430); //@line 1212 "translate.cpp"
                            ; //@line 1213 "translate.cpp"
                          }
  
                          var $215=HEAP32[(($arrayidx433)>>2)]; //@line 1214 "translate.cpp"
                          var $and434=($215) & 131072; //@line 1214 "translate.cpp"
                          var $tobool435=((($and434))|0)!=0; //@line 1214 "translate.cpp"
                          if (!($tobool435)) { __label__ = 130;break $if_then417$$if_else441$164; } //@line 1214 "translate.cpp"
  
                          HEAP8[($arrayidx437)]=0; //@line 1216 "translate.cpp"
                          var $216=$tr_addr; //@line 1217 "translate.cpp"
                          var $217=HEAP32[(($wordpf)>>2)]; //@line 1217 "translate.cpp"
                          var $call439=__ZL22SpeakIndividualLettersP10TranslatorPcS1_i($216, $217, $arraydecay438, 1); //@line 1217 "translate.cpp"
                          ; //@line 1218 "translate.cpp"
                        }
                        else if (__label__ == 129) {
  
                          var $call444=_strcat($arraydecay442, $arraydecay443); //@line 1222 "translate.cpp"
                          ;
                        }
                      } while(0);
  
                      HEAP8[($arrayidx446)]=0; //@line 1224 "translate.cpp"
                      $end_type=0; //@line 1226 "translate.cpp"
                      var $218=$tr_addr; //@line 1227 "translate.cpp"
                      var $219=$wtab_addr; //@line 1227 "translate.cpp"
                      var $call449=__Z14LookupDictListP10TranslatorPPcS1_PjiP8WORD_TAB($218, $wordx, $arraydecay447, $arraydecay448, 1024, $219); //@line 1227 "translate.cpp"
                      $found=$call449; //@line 1227 "translate.cpp"
                      var $220=HEAP32[(($arrayidx450)>>2)]; //@line 1228 "translate.cpp"
                      var $cmp451=((($220))|0)==0; //@line 1228 "translate.cpp"
                      if ($cmp451) { __label__ = 131;; } else { __label__ = 132;; } //@line 1228 "translate.cpp"
                      if (__label__ == 131) {
  
                        var $221=HEAP32[(($arrayidx453)>>2)]; //@line 1230 "translate.cpp"
                        HEAP32[(($arrayidx454)>>2)]=$221; //@line 1230 "translate.cpp"
                        var $222=HEAP32[(($arrayidx455)>>2)]; //@line 1231 "translate.cpp"
                        HEAP32[(($arrayidx456)>>2)]=$222; //@line 1231 "translate.cpp"
                        ; //@line 1232 "translate.cpp"
                      }
                      else if (__label__ == 132) {
  
                        $prefix_flags=1; //@line 1234 "translate.cpp"
                        ;
                      }
  
                      var $223=$found; //@line 1235 "translate.cpp"
                      var $cmp459=((($223))|0)==0; //@line 1235 "translate.cpp"
                      if (!($cmp459)) { __label__ = 136;break $if_end370$$for_inc474$141; } //@line 1235 "translate.cpp"
  
                      var $224=$tr_addr; //@line 1237 "translate.cpp"
                      var $225=HEAP32[(($wordx)>>2)]; //@line 1237 "translate.cpp"
                      var $call464=__Z14TranslateRulesP10TranslatorPcS1_iS1_iPj($224, $225, $arraydecay461, 160, $arraydecay462, 0, $arraydecay463); //@line 1237 "translate.cpp"
                      $end_type=$call464; //@line 1237 "translate.cpp"
                      var $226=HEAP8[($arrayidx465)]; //@line 1239 "translate.cpp"
                      var $conv466=(tempInt=(($226)),(tempInt>=128?tempInt-256:tempInt)); //@line 1239 "translate.cpp"
                      var $cmp467=((($conv466))|0)==21; //@line 1239 "translate.cpp"
                      if ($cmp467) { __label__ = 135;break $for_cond$129; } //@line 1239 "translate.cpp"
                    }
                  } while(0);
  
                  var $229=$loopcount; //@line 1123 "translate.cpp"
                  var $inc475=((($229)+1)&4294967295); //@line 1123 "translate.cpp"
                  $loopcount=$inc475; //@line 1123 "translate.cpp"
                  __lastLabel__ = 136; __label__ = 102;continue $for_cond$129; //@line 1123 "translate.cpp"
                }
                if (__label__ == 137) {
  
                  var $cmp477=((($162))|0)!=0; //@line 1249 "translate.cpp"
                  if ($cmp477) { __label__ = 138;; } else { __label__ = 165;; } //@line 1249 "translate.cpp"
                  $land_lhs_true478$$if_end603$180: do { 
                    if (__label__ == 138) {
  
                      var $230=$end_type; //@line 1249 "translate.cpp"
                      var $and479=($230) & 1024; //@line 1249 "translate.cpp"
                      var $tobool480=((($and479))|0)!=0; //@line 1249 "translate.cpp"
                      if ($tobool480) { __label__ = 165;break $land_lhs_true478$$if_end603$180; } //@line 1249 "translate.cpp"
  
                      var $arraydecay483=(($phonemes2482)&4294967295); //@line 1252 "translate.cpp"
                      var $arraydecay484=(($phonemes)&4294967295); //@line 1252 "translate.cpp"
                      var $call485=_strcpy($arraydecay483, $arraydecay484); //@line 1252 "translate.cpp"
                      var $231=$tr_addr; //@line 1255 "translate.cpp"
                      var $232=HEAP32[(($wordx)>>2)]; //@line 1255 "translate.cpp"
                      var $233=$end_type; //@line 1255 "translate.cpp"
                      var $arraydecay486=(($word_copy)&4294967295); //@line 1255 "translate.cpp"
                      var $call487=__Z12RemoveEndingP10TranslatorPciS1_($231, $232, $233, $arraydecay486); //@line 1255 "translate.cpp"
                      $end_flags=$call487; //@line 1255 "translate.cpp"
                      var $arrayidx488=(($phonemes)&4294967295); //@line 1257 "translate.cpp"
                      HEAP8[($arrayidx488)]=0; //@line 1257 "translate.cpp"
                      var $arrayidx489=(($prefix_phonemes)&4294967295); //@line 1259 "translate.cpp"
                      var $234=HEAP8[($arrayidx489)]; //@line 1259 "translate.cpp"
                      var $conv490=(tempInt=(($234)),(tempInt>=128?tempInt-256:tempInt)); //@line 1259 "translate.cpp"
                      var $cmp491=((($conv490))|0)!=0; //@line 1259 "translate.cpp"
                      if ($cmp491) { __label__ = 140;; } else { __label__ = 148;; } //@line 1259 "translate.cpp"
                      $if_then492$$if_end526$183: do { 
                        if (__label__ == 140) {
  
                          var $235=$c_temp; //@line 1262 "translate.cpp"
                          var $236=HEAP32[(($wordx)>>2)]; //@line 1262 "translate.cpp"
                          var $arrayidx493=(($236+-1)&4294967295); //@line 1262 "translate.cpp"
                          HEAP8[($arrayidx493)]=$235; //@line 1262 "translate.cpp"
                          var $237=$tr_addr; //@line 1263 "translate.cpp"
                          var $arraydecay494=(($phonemes)&4294967295); //@line 1263 "translate.cpp"
                          var $arraydecay495=(($dictionary_flags2)&4294967295); //@line 1263 "translate.cpp"
                          var $238=$end_flags; //@line 1263 "translate.cpp"
                          var $239=$wtab_addr; //@line 1263 "translate.cpp"
                          var $call496=__Z14LookupDictListP10TranslatorPPcS1_PjiP8WORD_TAB($237, $word1, $arraydecay494, $arraydecay495, $238, $239); //@line 1263 "translate.cpp"
                          $found=$call496; //@line 1263 "translate.cpp"
                          var $240=HEAP32[(($wordx)>>2)]; //@line 1264 "translate.cpp"
                          var $arrayidx497=(($240+-1)&4294967295); //@line 1264 "translate.cpp"
                          HEAP8[($arrayidx497)]=32; //@line 1264 "translate.cpp"
                          var $arrayidx498=(($phonemes)&4294967295); //@line 1265 "translate.cpp"
                          var $241=HEAP8[($arrayidx498)]; //@line 1265 "translate.cpp"
                          var $conv499=(tempInt=(($241)),(tempInt>=128?tempInt-256:tempInt)); //@line 1265 "translate.cpp"
                          var $cmp500=((($conv499))|0)==21; //@line 1265 "translate.cpp"
                          if ($cmp500) { __label__ = 141;; } else { __label__ = 142;; } //@line 1265 "translate.cpp"
                          if (__label__ == 141) {
  
                            var $242=HEAP32[(($wordx)>>2)]; //@line 1268 "translate.cpp"
                            var $arraydecay502=(($word_copy)&4294967295); //@line 1268 "translate.cpp"
                            var $arraydecay503=(($word_copy)&4294967295); //@line 1268 "translate.cpp"
                            var $call504=_strlen($arraydecay503); //@line 1268 "translate.cpp"
                            var $src$, $dest$, $stop$, $stop4$, $fast$;
                            $src$ = $arraydecay502;
                            $dest$ = $242;
                            $stop$ = $src$ + $call504;
                            if (($dest$%4) == ($src$%4) && $call504 > 8) {
                              while ($src$%4 !== 0 && $src$ < $stop$) {
                                ; HEAP8[$dest$++] = HEAP8[$src$++];
                              }
                              $src$ >>= 2;
                              $dest$ >>= 2;
                              $stop4$ = $stop$ >> 2;
                              while ($src$ < $stop4$) {
                            ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
                              }
                              $src$ <<= 2;
                              $dest$ <<= 2;
                            }while ($src$ < $stop$) {
                              ; HEAP8[$dest$++] = HEAP8[$src$++];
                            }; //@line 1268 "translate.cpp"
                            var $arraydecay505=(($phonemes)&4294967295); //@line 1269 "translate.cpp"
                            var $call506=_strcpy(((_word_phonemes)&4294967295), $arraydecay505); //@line 1269 "translate.cpp"
                            $retval=0; //@line 1270 "translate.cpp"
                            __label__ = 236;break $if_then12$$if_end13$5; //@line 1270 "translate.cpp"
                          }
                          else if (__label__ == 142) {
  
                            var $arrayidx508=(($dictionary_flags)&4294967295); //@line 1272 "translate.cpp"
                            var $243=HEAP32[(($arrayidx508)>>2)]; //@line 1272 "translate.cpp"
                            var $cmp509=((($243))|0)==0; //@line 1272 "translate.cpp"
                            if ($cmp509) { __label__ = 143;; } else { __label__ = 144;; } //@line 1272 "translate.cpp"
                            if (__label__ == 143) {
  
                              var $arrayidx511=(($dictionary_flags2)&4294967295); //@line 1274 "translate.cpp"
                              var $244=HEAP32[(($arrayidx511)>>2)]; //@line 1274 "translate.cpp"
                              var $arrayidx512=(($dictionary_flags)&4294967295); //@line 1274 "translate.cpp"
                              HEAP32[(($arrayidx512)>>2)]=$244; //@line 1274 "translate.cpp"
                              var $arrayidx513=(($dictionary_flags2+4)&4294967295); //@line 1275 "translate.cpp"
                              var $245=HEAP32[(($arrayidx513)>>2)]; //@line 1275 "translate.cpp"
                              var $arrayidx514=(($dictionary_flags+4)&4294967295); //@line 1275 "translate.cpp"
                              HEAP32[(($arrayidx514)>>2)]=$245; //@line 1275 "translate.cpp"
                              ; //@line 1276 "translate.cpp"
                            }
  
                            var $246=$found; //@line 1277 "translate.cpp"
                            var $tobool516=((($246))|0)!=0; //@line 1277 "translate.cpp"
                            if ($tobool516) { __label__ = 145;; } else { __label__ = 146;; } //@line 1277 "translate.cpp"
                            if (__label__ == 145) {
  
                              var $arrayidx518=(($prefix_phonemes)&4294967295); //@line 1278 "translate.cpp"
                              HEAP8[($arrayidx518)]=0; //@line 1278 "translate.cpp"
                              var $_pr8=$found; //@line 1280 "translate.cpp"
                              var $cmp520=((($_pr8))|0)==0; //@line 1280 "translate.cpp"
                              if (!($cmp520)) { __label__ = 162;break $if_then492$$if_end526$183; } //@line 1280 "translate.cpp"
                            }
  
                            var $arrayidx522=(($dictionary_flags2)&4294967295); //@line 1280 "translate.cpp"
                            var $247=HEAP32[(($arrayidx522)>>2)]; //@line 1280 "translate.cpp"
                            var $cmp523=((($247))|0)!=0; //@line 1280 "translate.cpp"
                            if (!($cmp523)) { __label__ = 148;break $if_then492$$if_end526$183; } //@line 1280 "translate.cpp"
  
                            $prefix_flags=1; //@line 1281 "translate.cpp"
                            __label__ = 148;break $if_then492$$if_end526$183; //@line 1281 "translate.cpp"
                          }
                        }
                      } while(0);
                      $if_end526$$if_end592$195: do { 
                        if (__label__ == 148) {
  
                          var $_pr10=$found; //@line 1283 "translate.cpp"
                          var $cmp527=((($_pr10))|0)==0; //@line 1283 "translate.cpp"
                          if (!($cmp527)) { __label__ = 162;break $if_end526$$if_end592$195; } //@line 1283 "translate.cpp"
  
                          var $248=$tr_addr; //@line 1285 "translate.cpp"
                          var $arraydecay529=(($phonemes)&4294967295); //@line 1285 "translate.cpp"
                          var $arraydecay530=(($dictionary_flags2)&4294967295); //@line 1285 "translate.cpp"
                          var $249=$end_flags; //@line 1285 "translate.cpp"
                          var $250=$wtab_addr; //@line 1285 "translate.cpp"
                          var $call531=__Z14LookupDictListP10TranslatorPPcS1_PjiP8WORD_TAB($248, $wordx, $arraydecay529, $arraydecay530, $249, $250); //@line 1285 "translate.cpp"
                          $found=$call531; //@line 1285 "translate.cpp"
                          var $arrayidx532=(($phonemes)&4294967295); //@line 1286 "translate.cpp"
                          var $251=HEAP8[($arrayidx532)]; //@line 1286 "translate.cpp"
                          var $conv533=(tempInt=(($251)),(tempInt>=128?tempInt-256:tempInt)); //@line 1286 "translate.cpp"
                          var $cmp534=((($conv533))|0)==21; //@line 1286 "translate.cpp"
                          if ($cmp534) { __label__ = 150;; } else { __label__ = 151;; } //@line 1286 "translate.cpp"
                          if (__label__ == 150) {
  
                            var $252=HEAP32[(($wordx)>>2)]; //@line 1289 "translate.cpp"
                            var $arraydecay536=(($word_copy)&4294967295); //@line 1289 "translate.cpp"
                            var $arraydecay537=(($word_copy)&4294967295); //@line 1289 "translate.cpp"
                            var $call538=_strlen($arraydecay537); //@line 1289 "translate.cpp"
                            var $src$, $dest$, $stop$, $stop4$, $fast$;
                            $src$ = $arraydecay536;
                            $dest$ = $252;
                            $stop$ = $src$ + $call538;
                            if (($dest$%4) == ($src$%4) && $call538 > 8) {
                              while ($src$%4 !== 0 && $src$ < $stop$) {
                                ; HEAP8[$dest$++] = HEAP8[$src$++];
                              }
                              $src$ >>= 2;
                              $dest$ >>= 2;
                              $stop4$ = $stop$ >> 2;
                              while ($src$ < $stop4$) {
                            ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
                              }
                              $src$ <<= 2;
                              $dest$ <<= 2;
                            }while ($src$ < $stop$) {
                              ; HEAP8[$dest$++] = HEAP8[$src$++];
                            }; //@line 1289 "translate.cpp"
                            var $arraydecay539=(($phonemes)&4294967295); //@line 1290 "translate.cpp"
                            var $call540=_strcpy(((_word_phonemes)&4294967295), $arraydecay539); //@line 1290 "translate.cpp"
                            $retval=0; //@line 1291 "translate.cpp"
                            __label__ = 236;break $if_then12$$if_end13$5; //@line 1291 "translate.cpp"
                          }
                          else if (__label__ == 151) {
  
                            var $arrayidx547=(($dictionary_flags)&4294967295); //@line 1299 "translate.cpp"
                            var $253=HEAP32[(($arrayidx547)>>2)]; //@line 1299 "translate.cpp"
                            var $cmp548=((($253))|0)==0; //@line 1299 "translate.cpp"
                            if ($cmp548) { __label__ = 152;; } else { __label__ = 153;; } //@line 1299 "translate.cpp"
                            if (__label__ == 152) {
  
                              var $arrayidx550=(($dictionary_flags2)&4294967295); //@line 1301 "translate.cpp"
                              var $254=HEAP32[(($arrayidx550)>>2)]; //@line 1301 "translate.cpp"
                              var $arrayidx551=(($dictionary_flags)&4294967295); //@line 1301 "translate.cpp"
                              HEAP32[(($arrayidx551)>>2)]=$254; //@line 1301 "translate.cpp"
                              var $arrayidx552=(($dictionary_flags2+4)&4294967295); //@line 1302 "translate.cpp"
                              var $255=HEAP32[(($arrayidx552)>>2)]; //@line 1302 "translate.cpp"
                              var $arrayidx553=(($dictionary_flags+4)&4294967295); //@line 1302 "translate.cpp"
                              HEAP32[(($arrayidx553)>>2)]=$255; //@line 1302 "translate.cpp"
                              ; //@line 1303 "translate.cpp"
                            }
  
                            var $_pr12_pr=$found; //@line 1305 "translate.cpp"
                            var $cmp556=((($_pr12_pr))|0)==0; //@line 1305 "translate.cpp"
                            if (!($cmp556)) { __label__ = 162;break $if_end526$$if_end592$195; } //@line 1305 "translate.cpp"
  
                            var $256=$end_type; //@line 1307 "translate.cpp"
                            var $and558=($256) & 16384; //@line 1307 "translate.cpp"
                            var $tobool559=((($and558))|0)!=0; //@line 1307 "translate.cpp"
                            if ($tobool559) { __label__ = 155;; } else { __label__ = 156;; } //@line 1307 "translate.cpp"
                            if (__label__ == 155) {
  
                              var $arraydecay561=(($phonemes)&4294967295); //@line 1310 "translate.cpp"
                              var $arraydecay562=(($phonemes2482)&4294967295); //@line 1310 "translate.cpp"
                              var $call563=_strcpy($arraydecay561, $arraydecay562); //@line 1310 "translate.cpp"
                              var $257=$tr_addr; //@line 1313 "translate.cpp"
                              var $arraydecay564=(($phonemes)&4294967295); //@line 1313 "translate.cpp"
                              var $arrayidx565=(($dictionary_flags)&4294967295); //@line 1313 "translate.cpp"
                              var $258=HEAP32[(($arrayidx565)>>2)]; //@line 1313 "translate.cpp"
                              __Z21ApplySpecialAttributeP10TranslatorPci($257, $arraydecay564, $258); //@line 1313 "translate.cpp"
                              ; //@line 1314 "translate.cpp"
                            }
                            else if (__label__ == 156) {
  
                              var $259=$end_flags; //@line 1317 "translate.cpp"
                              var $and567=($259) & 4; //@line 1317 "translate.cpp"
                              var $tobool568=((($and567))|0)!=0; //@line 1317 "translate.cpp"
                              if ($tobool568) { __label__ = 157;; } else { __label__ = 158;; } //@line 1317 "translate.cpp"
                              if (__label__ == 157) {
  
                                var $260=$wflags; //@line 1318 "translate.cpp"
                                var $or570=($260) | 8192; //@line 1318 "translate.cpp"
                                $wflags=$or570; //@line 1318 "translate.cpp"
                                ; //@line 1318 "translate.cpp"
                              }
  
                              var $261=$end_type; //@line 1319 "translate.cpp"
                              var $and572=($261) & 262144; //@line 1319 "translate.cpp"
                              var $tobool573=((($and572))|0)!=0; //@line 1319 "translate.cpp"
                              if ($tobool573) { __label__ = 159;; } else { __label__ = 160;; } //@line 1319 "translate.cpp"
                              if (__label__ == 159) {
  
                                var $262=$wflags; //@line 1320 "translate.cpp"
                                var $or575=($262) | 134217728; //@line 1320 "translate.cpp"
                                $wflags=$or575; //@line 1320 "translate.cpp"
                                ; //@line 1320 "translate.cpp"
                              }
  
                              var $263=$tr_addr; //@line 1322 "translate.cpp"
                              var $264=HEAP32[(($wordx)>>2)]; //@line 1322 "translate.cpp"
                              var $arraydecay577=(($phonemes)&4294967295); //@line 1322 "translate.cpp"
                              var $265=$wflags; //@line 1322 "translate.cpp"
                              var $arraydecay578=(($dictionary_flags)&4294967295); //@line 1322 "translate.cpp"
                              var $call579=__Z14TranslateRulesP10TranslatorPcS1_iS1_iPj($263, $264, $arraydecay577, 160, 0, $265, $arraydecay578); //@line 1322 "translate.cpp"
                              var $arrayidx580=(($phonemes)&4294967295); //@line 1324 "translate.cpp"
                              var $266=HEAP8[($arrayidx580)]; //@line 1324 "translate.cpp"
                              var $conv581=(tempInt=(($266)),(tempInt>=128?tempInt-256:tempInt)); //@line 1324 "translate.cpp"
                              var $cmp582=((($conv581))|0)==21; //@line 1324 "translate.cpp"
                              if (!($cmp582)) { __label__ = 162;break $if_end526$$if_end592$195; } //@line 1324 "translate.cpp"
  
                              var $arraydecay584=(($phonemes)&4294967295); //@line 1327 "translate.cpp"
                              var $call585=_strcpy(((_word_phonemes)&4294967295), $arraydecay584); //@line 1327 "translate.cpp"
                              var $267=HEAP32[(($wordx)>>2)]; //@line 1328 "translate.cpp"
                              var $arraydecay586=(($word_copy)&4294967295); //@line 1328 "translate.cpp"
                              var $arraydecay587=(($word_copy)&4294967295); //@line 1328 "translate.cpp"
                              var $call588=_strlen($arraydecay587); //@line 1328 "translate.cpp"
                              var $src$, $dest$, $stop$, $stop4$, $fast$;
                              $src$ = $arraydecay586;
                              $dest$ = $267;
                              $stop$ = $src$ + $call588;
                              if (($dest$%4) == ($src$%4) && $call588 > 8) {
                                while ($src$%4 !== 0 && $src$ < $stop$) {
                                  ; HEAP8[$dest$++] = HEAP8[$src$++];
                                }
                                $src$ >>= 2;
                                $dest$ >>= 2;
                                $stop4$ = $stop$ >> 2;
                                while ($src$ < $stop4$) {
                              ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
                                }
                                $src$ <<= 2;
                                $dest$ <<= 2;
                              }while ($src$ < $stop$) {
                                ; HEAP8[$dest$++] = HEAP8[$src$++];
                              }; //@line 1328 "translate.cpp"
                              var $268=$c_temp; //@line 1329 "translate.cpp"
                              var $269=HEAP32[(($wordx)>>2)]; //@line 1329 "translate.cpp"
                              var $arrayidx589=(($269+-1)&4294967295); //@line 1329 "translate.cpp"
                              HEAP8[($arrayidx589)]=$268; //@line 1329 "translate.cpp"
                              $retval=0; //@line 1330 "translate.cpp"
                              __label__ = 236;break $if_then12$$if_end13$5; //@line 1330 "translate.cpp"
                            }
                          }
                        }
                      } while(0);
  
                      var $270=$end_type; //@line 1335 "translate.cpp"
                      var $and593=($270) & 65536; //@line 1335 "translate.cpp"
                      var $cmp594=((($and593))|0)==0; //@line 1335 "translate.cpp"
                      if ($cmp594) { __label__ = 163;; } else { __label__ = 164;; } //@line 1335 "translate.cpp"
                      if (__label__ == 163) {
  
                        var $271=$tr_addr; //@line 1338 "translate.cpp"
                        var $arraydecay596=(($phonemes)&4294967295); //@line 1338 "translate.cpp"
                        var $arraydecay597=(($end_phonemes)&4294967295); //@line 1338 "translate.cpp"
                        __Z14AppendPhonemesP10TranslatorPciPKc($271, $arraydecay596, 160, $arraydecay597); //@line 1338 "translate.cpp"
                        var $arrayidx598=(($end_phonemes)&4294967295); //@line 1339 "translate.cpp"
                        HEAP8[($arrayidx598)]=0; //@line 1339 "translate.cpp"
                        ; //@line 1340 "translate.cpp"
                      }
  
                      var $272=HEAP32[(($wordx)>>2)]; //@line 1341 "translate.cpp"
                      var $arraydecay600=(($word_copy)&4294967295); //@line 1341 "translate.cpp"
                      var $arraydecay601=(($word_copy)&4294967295); //@line 1341 "translate.cpp"
                      var $call602=_strlen($arraydecay601); //@line 1341 "translate.cpp"
                      var $src$, $dest$, $stop$, $stop4$, $fast$;
                      $src$ = $arraydecay600;
                      $dest$ = $272;
                      $stop$ = $src$ + $call602;
                      if (($dest$%4) == ($src$%4) && $call602 > 8) {
                        while ($src$%4 !== 0 && $src$ < $stop$) {
                          ; HEAP8[$dest$++] = HEAP8[$src$++];
                        }
                        $src$ >>= 2;
                        $dest$ >>= 2;
                        $stop4$ = $stop$ >> 2;
                        while ($src$ < $stop4$) {
                      ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
                        }
                        $src$ <<= 2;
                        $dest$ <<= 2;
                      }while ($src$ < $stop$) {
                        ; HEAP8[$dest$++] = HEAP8[$src$++];
                      }; //@line 1341 "translate.cpp"
                      ; //@line 1342 "translate.cpp"
                    }
                  } while(0);
  
                  var $273=$c_temp; //@line 1343 "translate.cpp"
                  var $274=HEAP32[(($wordx)>>2)]; //@line 1343 "translate.cpp"
                  var $arrayidx604=(($274+-1)&4294967295); //@line 1343 "translate.cpp"
                  HEAP8[($arrayidx604)]=$273; //@line 1343 "translate.cpp"
                  __label__ = 166;break $if_end219$$if_then221$95; //@line 1344 "translate.cpp"
                }
                else if (__label__ == 135) {
  
                  var $227=$c_temp; //@line 1242 "translate.cpp"
                  var $228=HEAP32[(($wordx)>>2)]; //@line 1242 "translate.cpp"
                  var $arrayidx469=(($228+-1)&4294967295); //@line 1242 "translate.cpp"
                  HEAP8[($arrayidx469)]=$227; //@line 1242 "translate.cpp"
                  var $arraydecay470=(($phonemes)&4294967295); //@line 1243 "translate.cpp"
                  var $call471=_strcpy(((_word_phonemes)&4294967295), $arraydecay470); //@line 1243 "translate.cpp"
                  $retval=0; //@line 1244 "translate.cpp"
                  __label__ = 236;break $if_then12$$if_end13$5; //@line 1244 "translate.cpp"
                }
              }
            }
            else if (__label__ == 84) {
  
              var $arraydecay260=(($unpron_phonemes)&4294967295); //@line 1063 "translate.cpp"
              var $call261=_strcpy(((_word_phonemes)&4294967295), $arraydecay260); //@line 1063 "translate.cpp"
              var $arrayidx262=(($unpron_phonemes+1)&4294967295); //@line 1064 "translate.cpp"
              var $call263=_strcmp($arrayidx262, ((__str52704)&4294967295)); //@line 1064 "translate.cpp"
              var $cmp264=((($call263))|0)==0; //@line 1064 "translate.cpp"
              if ($cmp264) { __label__ = 85;; } else { __label__ = 86;; } //@line 1064 "translate.cpp"
              if (__label__ == 85) {
  
                $retval=65536; //@line 1065 "translate.cpp"
                __label__ = 236;break $if_then12$$if_end13$5; //@line 1065 "translate.cpp"
              }
              else if (__label__ == 86) {
  
                $retval=0; //@line 1066 "translate.cpp"
                __label__ = 236;break $if_then12$$if_end13$5; //@line 1066 "translate.cpp"
              }
            }
          }
        } while(0);
        $if_then221$$if_end607$225: do { 
          if (__label__ == 71) {
  
            var $arrayidx222=(($phonemes)&4294967295); //@line 1021 "translate.cpp"
            HEAP8[($arrayidx222)]=0; //@line 1021 "translate.cpp"
            $end_type=0; //@line 1022 "translate.cpp"
            var $111=$tr_addr; //@line 1024 "translate.cpp"
            var $112=HEAP32[(($word1)>>2)]; //@line 1024 "translate.cpp"
            var $arraydecay223=(($phonemes)&4294967295); //@line 1024 "translate.cpp"
            var $113=$spell_word; //@line 1024 "translate.cpp"
            var $call224=__ZL22SpeakIndividualLettersP10TranslatorPcS1_i($111, $112, $arraydecay223, $113); //@line 1024 "translate.cpp"
            var $cmp225=((($call224))|0)==0; //@line 1024 "translate.cpp"
            if (!($cmp225)) { __label__ = 166;break $if_then221$$if_end607$225; } //@line 1024 "translate.cpp"
  
            var $114=$word_length; //@line 1026 "translate.cpp"
            var $cmp227=((($114))|0) > 1; //@line 1026 "translate.cpp"
            if ($cmp227) { __label__ = 73;; } else { __label__ = 74;; } //@line 1026 "translate.cpp"
            if (__label__ == 73) {
  
              $retval=65536; //@line 1027 "translate.cpp"
              __label__ = 236;break $if_then12$$if_end13$5; //@line 1027 "translate.cpp"
            }
            else if (__label__ == 74) {
  
              $retval=0; //@line 1028 "translate.cpp"
              __label__ = 236;break $if_then12$$if_end13$5; //@line 1028 "translate.cpp"
            }
          }
        } while(0);
  
        var $275=$add_plural_suffix; //@line 1347 "translate.cpp"
        var $tobool608=((($275))|0)!=0; //@line 1347 "translate.cpp"
        if ($tobool608) { __label__ = 168;; } else { __label__ = 167;; } //@line 1347 "translate.cpp"
        $if_then612$$lor_lhs_false609$232: do { 
          if (__label__ == 167) {
  
            var $276=$wflags; //@line 1347 "translate.cpp"
            var $and610=($276) & 4; //@line 1347 "translate.cpp"
            var $tobool611=((($and610))|0)!=0; //@line 1347 "translate.cpp"
            if ($tobool611) { __label__ = 168;break $if_then612$$lor_lhs_false609$232; } else { __label__ = 174;break $if_then612$$lor_lhs_false609$232; } //@line 1347 "translate.cpp"
          }
        } while(0);
        $if_then612$$if_end630$234: do { 
          if (__label__ == 168) {
  
            var $277=HEAP32[(($last_char)>>2)]; //@line 1350 "translate.cpp"
            var $cmp613=((($277))|0)==102; //@line 1350 "translate.cpp"
            if ($cmp613) { __label__ = 169;; } else { __label__ = 170;; } //@line 1350 "translate.cpp"
            if (__label__ == 169) {
  
              var $278=$tr_addr; //@line 1351 "translate.cpp"
              var $arraydecay615=(($phonemes)&4294967295); //@line 1351 "translate.cpp"
              var $call616=__Z14TranslateRulesP10TranslatorPcS1_iS1_iPj($278, ((__ZZ13TranslateWordP10TranslatorPciP8WORD_TABE7word_ss+1)&4294967295), $arraydecay615, 160, 0, 0, 0); //@line 1351 "translate.cpp"
              ; //@line 1351 "translate.cpp"
            }
            else if (__label__ == 170) {
  
              var $279=HEAP32[(($last_char)>>2)]; //@line 1353 "translate.cpp"
              var $cmp618=((($279))|0)==0; //@line 1353 "translate.cpp"
              if ($cmp618) { __label__ = 172;; } else { __label__ = 171;; } //@line 1353 "translate.cpp"
              $if_then622$$lor_lhs_false619$239: do { 
                if (__label__ == 171) {
  
                  var $280=HEAP32[(($last_char)>>2)]; //@line 1353 "translate.cpp"
                  var $call620=__Z8strchr_wPKci(((__str5548)&4294967295), $280); //@line 1353 "translate.cpp"
                  var $cmp621=((($call620))|0)==0; //@line 1353 "translate.cpp"
                  if ($cmp621) { __label__ = 172;break $if_then622$$lor_lhs_false619$239; } //@line 1353 "translate.cpp"
  
                  var $282=$tr_addr; //@line 1356 "translate.cpp"
                  var $arraydecay626=(($phonemes)&4294967295); //@line 1356 "translate.cpp"
                  var $call627=__Z14TranslateRulesP10TranslatorPcS1_iS1_iPj($282, ((__ZZ13TranslateWordP10TranslatorPciP8WORD_TABE7word_iz+1)&4294967295), $arraydecay626, 160, 0, 0, 0); //@line 1356 "translate.cpp"
                  __label__ = 174;break $if_then612$$if_end630$234;
                }
              } while(0);
  
              var $281=$tr_addr; //@line 1354 "translate.cpp"
              var $arraydecay623=(($phonemes)&4294967295); //@line 1354 "translate.cpp"
              var $call624=__Z14TranslateRulesP10TranslatorPcS1_iS1_iPj($281, ((__ZZ13TranslateWordP10TranslatorPciP8WORD_TABE7word_zz+1)&4294967295), $arraydecay623, 160, 0, 0, 0); //@line 1354 "translate.cpp"
              ; //@line 1354 "translate.cpp"
            }
          }
        } while(0);
  
        var $283=$emphasize_allcaps; //@line 1359 "translate.cpp"
        var $284=$wflags; //@line 1359 "translate.cpp"
        var $or631=($284) | ($283); //@line 1359 "translate.cpp"
        $wflags=$or631; //@line 1359 "translate.cpp"
        $prefix_stress=0; //@line 1364 "translate.cpp"
        var $arraydecay632=(($prefix_phonemes)&4294967295); //@line 1365 "translate.cpp"
        $p=$arraydecay632; //@line 1365 "translate.cpp"
        var $285=$p; //@line 1365 "translate.cpp"
        var $286=HEAP8[($285)]; //@line 1365 "translate.cpp"
        var $conv63426=(tempInt=(($286)),(tempInt>=128?tempInt-256:tempInt)); //@line 1365 "translate.cpp"
        var $cmp63527=((($conv63426))|0)!=0; //@line 1365 "translate.cpp"
        if ($cmp63527) { __label__ = 175;; } else { __label__ = 179;; } //@line 1365 "translate.cpp"
        $for_body636$$for_end647$244: do { 
          if (__label__ == 175) {
            $for_body636$245: while(1) { 
  
              var $287=$p; //@line 1367 "translate.cpp"
              var $288=HEAP8[($287)]; //@line 1367 "translate.cpp"
              var $conv637=(tempInt=(($288)),(tempInt>=128?tempInt-256:tempInt)); //@line 1367 "translate.cpp"
              var $cmp638=((($conv637))|0)==6; //@line 1367 "translate.cpp"
              if ($cmp638) { __label__ = 177;; } else { __label__ = 176;; } //@line 1367 "translate.cpp"
              $if_then642$$lor_lhs_false639$247: do { 
                if (__label__ == 176) {
  
                  var $289=$p; //@line 1367 "translate.cpp"
                  var $290=HEAP8[($289)]; //@line 1367 "translate.cpp"
                  var $conv640=(tempInt=(($290)),(tempInt>=128?tempInt-256:tempInt)); //@line 1367 "translate.cpp"
                  var $cmp641=((($conv640))|0)==7; //@line 1367 "translate.cpp"
                  if ($cmp641) { __label__ = 177;break $if_then642$$lor_lhs_false639$247; } else { __label__ = 178;break $if_then642$$lor_lhs_false639$247; } //@line 1367 "translate.cpp"
                }
              } while(0);
              if (__label__ == 177) {
  
                var $291=$p; //@line 1369 "translate.cpp"
                var $292=HEAP8[($291)]; //@line 1369 "translate.cpp"
                var $conv643=(tempInt=(($292)),(tempInt>=128?tempInt-256:tempInt)); //@line 1369 "translate.cpp"
                $prefix_stress=$conv643; //@line 1369 "translate.cpp"
                ; //@line 1370 "translate.cpp"
              }
  
              var $293=$p; //@line 1365 "translate.cpp"
              var $incdec_ptr646=(($293+1)&4294967295); //@line 1365 "translate.cpp"
              $p=$incdec_ptr646; //@line 1365 "translate.cpp"
              var $294=$p; //@line 1365 "translate.cpp"
              var $295=HEAP8[($294)]; //@line 1365 "translate.cpp"
              var $conv634=(tempInt=(($295)),(tempInt>=128?tempInt-256:tempInt)); //@line 1365 "translate.cpp"
              var $cmp635=((($conv634))|0)!=0; //@line 1365 "translate.cpp"
              if ($cmp635) { __label__ = 175;continue $for_body636$245; } else { __label__ = 179;break $for_body636$$for_end647$244; } //@line 1365 "translate.cpp"
            }
          }
        } while(0);
  
        var $296=$prefix_flags; //@line 1372 "translate.cpp"
        var $tobool648=((($296))|0)!=0; //@line 1372 "translate.cpp"
        if ($tobool648) { __label__ = 181;; } else { __label__ = 180;; } //@line 1372 "translate.cpp"
        $if_then651$$lor_lhs_false649$253: do { 
          if (__label__ == 180) {
  
            var $297=$prefix_stress; //@line 1372 "translate.cpp"
            var $cmp650=((($297))|0)!=0; //@line 1372 "translate.cpp"
            if ($cmp650) { __label__ = 181;break $if_then651$$lor_lhs_false649$253; } //@line 1372 "translate.cpp"
  
            var $313=$tr_addr; //@line 1415 "translate.cpp"
            var $arraydecay695=(($phonemes)&4294967295); //@line 1415 "translate.cpp"
            var $arraydecay696=(($dictionary_flags)&4294967295); //@line 1415 "translate.cpp"
            __Z13SetWordStressP10TranslatorPcPjii($313, $arraydecay695, $arraydecay696, -1, 0); //@line 1415 "translate.cpp"
            var $arraydecay701=(($unpron_phonemes)&4294967295); //@line 1421 "translate.cpp"
            var $arraydecay702=(($prefix_phonemes)&4294967295); //@line 1421 "translate.cpp"
            var $arraydecay703=(($phonemes)&4294967295); //@line 1421 "translate.cpp"
            var $call704=_snprintf(((_word_phonemes)&4294967295), 160, ((__str6549)&4294967295), allocate([$arraydecay701,0,0,0,$arraydecay702,0,0,0,$arraydecay703,0,0,0], ["i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 1421 "translate.cpp"
            HEAP8[(((_word_phonemes+159)&4294967295))]=0; //@line 1423 "translate.cpp"
            __label__ = 192;break $if_then651$$lor_lhs_false649$253;
          }
        } while(0);
        $if_then651$$if_end705$256: do { 
          if (__label__ == 181) {
  
            var $298=$tr_addr; //@line 1374 "translate.cpp"
            var $langopts652=(($298)&4294967295); //@line 1374 "translate.cpp"
            var $param=(($langopts652+24)&4294967295); //@line 1374 "translate.cpp"
            var $arrayidx653=(($param+12)&4294967295); //@line 1374 "translate.cpp"
            var $299=HEAP32[(($arrayidx653)>>2)]; //@line 1374 "translate.cpp"
            var $tobool654=((($299))|0)!=0; //@line 1374 "translate.cpp"
            if ($tobool654) { __label__ = 183;; } else { __label__ = 182;; } //@line 1374 "translate.cpp"
            $if_then658$$lor_lhs_false655$258: do { 
              if (__label__ == 182) {
  
                var $300=$prefix_type; //@line 1374 "translate.cpp"
                var $and656=($300) & 65536; //@line 1374 "translate.cpp"
                var $tobool657=((($and656))|0)!=0; //@line 1374 "translate.cpp"
                if ($tobool657) { __label__ = 183;break $if_then658$$lor_lhs_false655$258; } //@line 1374 "translate.cpp"
  
                var $arraydecay684=(($unpron_phonemes)&4294967295); //@line 1406 "translate.cpp"
                var $arraydecay685=(($prefix_phonemes)&4294967295); //@line 1406 "translate.cpp"
                var $arraydecay686=(($phonemes)&4294967295); //@line 1406 "translate.cpp"
                var $call687=_snprintf(((_word_phonemes)&4294967295), 160, ((__str6549)&4294967295), allocate([$arraydecay684,0,0,0,$arraydecay685,0,0,0,$arraydecay686,0,0,0], ["i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 1406 "translate.cpp"
                HEAP8[(((_word_phonemes+159)&4294967295))]=0; //@line 1408 "translate.cpp"
                var $312=$tr_addr; //@line 1409 "translate.cpp"
                var $arraydecay688=(($dictionary_flags)&4294967295); //@line 1409 "translate.cpp"
                __Z13SetWordStressP10TranslatorPcPjii($312, ((_word_phonemes)&4294967295), $arraydecay688, -1, 0); //@line 1409 "translate.cpp"
                __label__ = 192;break $if_then651$$if_end705$256;
              }
            } while(0);
  
            var $301=$tr_addr; //@line 1378 "translate.cpp"
            var $arraydecay660=(($phonemes)&4294967295); //@line 1378 "translate.cpp"
            var $arraydecay661=(($dictionary_flags)&4294967295); //@line 1378 "translate.cpp"
            __Z13SetWordStressP10TranslatorPcPjii($301, $arraydecay660, $arraydecay661, 3, 0); //@line 1378 "translate.cpp"
            $ix=0; //@line 1381 "translate.cpp"
            var $arraydecay662=(($prefix_phonemes)&4294967295); //@line 1382 "translate.cpp"
            $p659=$arraydecay662; //@line 1382 "translate.cpp"
            var $302=$p659; //@line 1382 "translate.cpp"
            var $303=HEAP8[($302)]; //@line 1382 "translate.cpp"
            var $conv66424=(tempInt=(($303)),(tempInt>=128?tempInt-256:tempInt)); //@line 1382 "translate.cpp"
            var $cmp66525=((($conv66424))|0)!=0; //@line 1382 "translate.cpp"
            if ($cmp66525) { __label__ = 184;; } else { __label__ = 189;; } //@line 1382 "translate.cpp"
            $for_body666$$for_end677$262: do { 
              if (__label__ == 184) {
                while(1) { 
  
                  var $304=$p659; //@line 1384 "translate.cpp"
                  var $305=HEAP8[($304)]; //@line 1384 "translate.cpp"
                  var $conv667=(tempInt=(($305)),(tempInt>=128?tempInt-256:tempInt)); //@line 1384 "translate.cpp"
                  var $cmp668=((($conv667))|0)==6; //@line 1384 "translate.cpp"
                  if ($cmp668) { __label__ = 185;; } else { __label__ = 188;; } //@line 1384 "translate.cpp"
                  if (__label__ == 185) {
  
                    var $306=$ix; //@line 1386 "translate.cpp"
                    var $cmp670=((($306))|0)==0; //@line 1386 "translate.cpp"
                    if ($cmp670) { __label__ = 186;; } else { __label__ = 187;; } //@line 1386 "translate.cpp"
                    if (__label__ == 186) {
  
                      $ix=1; //@line 1387 "translate.cpp"
                      ; //@line 1387 "translate.cpp"
                    }
                    else if (__label__ == 187) {
  
                      var $307=$p659; //@line 1389 "translate.cpp"
                      HEAP8[($307)]=5; //@line 1389 "translate.cpp"
                      ;
                    }
                  }
  
                  var $308=$p659; //@line 1382 "translate.cpp"
                  var $incdec_ptr676=(($308+1)&4294967295); //@line 1382 "translate.cpp"
                  $p659=$incdec_ptr676; //@line 1382 "translate.cpp"
                  var $309=$p659; //@line 1382 "translate.cpp"
                  var $310=HEAP8[($309)]; //@line 1382 "translate.cpp"
                  var $conv664=(tempInt=(($310)),(tempInt>=128?tempInt-256:tempInt)); //@line 1382 "translate.cpp"
                  var $cmp665=((($conv664))|0)!=0; //@line 1382 "translate.cpp"
                  if ($cmp665) { __label__ = 184;continue ; } else { __label__ = 189;break $for_body666$$for_end677$262; } //@line 1382 "translate.cpp"
                }
              }
            } while(0);
  
            var $arraydecay678=(($unpron_phonemes)&4294967295); //@line 1395 "translate.cpp"
            var $arraydecay679=(($prefix_phonemes)&4294967295); //@line 1395 "translate.cpp"
            var $arraydecay680=(($phonemes)&4294967295); //@line 1395 "translate.cpp"
            var $call681=_snprintf(((_word_phonemes)&4294967295), 160, ((__str6549)&4294967295), allocate([$arraydecay678,0,0,0,$arraydecay679,0,0,0,$arraydecay680,0,0,0], ["i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 1395 "translate.cpp"
            HEAP8[(((_word_phonemes+159)&4294967295))]=0; //@line 1397 "translate.cpp"
            var $311=$tr_addr; //@line 1398 "translate.cpp"
            var $arraydecay682=(($dictionary_flags)&4294967295); //@line 1398 "translate.cpp"
            __Z13SetWordStressP10TranslatorPcPjii($311, ((_word_phonemes)&4294967295), $arraydecay682, -1, 0); //@line 1398 "translate.cpp"
            ; //@line 1399 "translate.cpp"
          }
        } while(0);
  
        var $arrayidx706=(($end_phonemes)&4294967295); //@line 1426 "translate.cpp"
        var $314=HEAP8[($arrayidx706)]; //@line 1426 "translate.cpp"
        var $conv707=(tempInt=(($314)),(tempInt>=128?tempInt-256:tempInt)); //@line 1426 "translate.cpp"
        var $cmp708=((($conv707))|0)!=0; //@line 1426 "translate.cpp"
        if ($cmp708) { __label__ = 193;; } else { __label__ = 194;; } //@line 1426 "translate.cpp"
        if (__label__ == 193) {
  
          var $call710=_strlen(((_word_phonemes)&4294967295)); //@line 1429 "translate.cpp"
          $ix=$call710; //@line 1429 "translate.cpp"
          var $315=$ix; //@line 1430 "translate.cpp"
          var $sub711=((159-($315))&4294967295); //@line 1430 "translate.cpp"
          var $arrayidx712=(($end_phonemes+$sub711)&4294967295); //@line 1430 "translate.cpp"
          HEAP8[($arrayidx712)]=0; //@line 1430 "translate.cpp"
          var $316=$ix; //@line 1431 "translate.cpp"
          var $arrayidx713=((_word_phonemes+$316)&4294967295); //@line 1431 "translate.cpp"
          var $arraydecay714=(($end_phonemes)&4294967295); //@line 1431 "translate.cpp"
          var $call715=_strcpy($arrayidx713, $arraydecay714); //@line 1431 "translate.cpp"
          ; //@line 1432 "translate.cpp"
        }
  
        var $317=$wflags; //@line 1434 "translate.cpp"
        var $and717=($317) & 16; //@line 1434 "translate.cpp"
        var $tobool718=((($and717))|0)!=0; //@line 1434 "translate.cpp"
        if ($tobool718) { __label__ = 195;; } else { __label__ = 196;; } //@line 1434 "translate.cpp"
        if (__label__ == 195) {
  
          var $arrayidx720=(($dictionary_flags)&4294967295); //@line 1438 "translate.cpp"
          var $318=HEAP32[(($arrayidx720)>>2)]; //@line 1438 "translate.cpp"
          var $and721=($318) & -268435457; //@line 1438 "translate.cpp"
          HEAP32[(($arrayidx720)>>2)]=$and721; //@line 1438 "translate.cpp"
          ; //@line 1439 "translate.cpp"
        }
  
        var $319=$wflags; //@line 1441 "translate.cpp"
        var $and723=($319) & 128; //@line 1441 "translate.cpp"
        var $tobool724=((($and723))|0)!=0; //@line 1441 "translate.cpp"
        if ($tobool724) { __label__ = 197;; } else { __label__ = 199;; } //@line 1441 "translate.cpp"
        $land_lhs_true725$$if_else730$279: do { 
          if (__label__ == 197) {
  
            var $320=$tr_addr; //@line 1441 "translate.cpp"
            var $langopts726=(($320)&4294967295); //@line 1441 "translate.cpp"
            var $stress_flags=(($langopts726+12)&4294967295); //@line 1441 "translate.cpp"
            var $321=HEAP32[(($stress_flags)>>2)]; //@line 1441 "translate.cpp"
            var $and727=($321) & 1048576; //@line 1441 "translate.cpp"
            var $tobool728=((($and727))|0)!=0; //@line 1441 "translate.cpp"
            if (!($tobool728)) { __label__ = 199;break $land_lhs_true725$$if_else730$279; } //@line 1441 "translate.cpp"
  
            var $322=$tr_addr; //@line 1443 "translate.cpp"
            __Z16ChangeWordStressP10TranslatorPci($322, ((_word_phonemes)&4294967295), 3); //@line 1443 "translate.cpp"
            __label__ = 208;break $land_lhs_true725$$if_else730$279; //@line 1444 "translate.cpp"
          }
        } while(0);
        $if_end761$$if_else730$282: do { 
          if (__label__ == 199) {
  
            var $323=$wflags; //@line 1446 "translate.cpp"
            var $and731=($323) & 3072; //@line 1446 "translate.cpp"
            var $tobool732=((($and731))|0)!=0; //@line 1446 "translate.cpp"
            if ($tobool732) { __label__ = 200;; } else { __label__ = 202;; } //@line 1446 "translate.cpp"
            if (__label__ == 200) {
  
              var $324=$tr_addr; //@line 1450 "translate.cpp"
              __Z16ChangeWordStressP10TranslatorPci($324, ((_word_phonemes)&4294967295), 6); //@line 1450 "translate.cpp"
              var $325=$wflags; //@line 1452 "translate.cpp"
              var $and734=($325) & 2048; //@line 1452 "translate.cpp"
              var $tobool735=((($and734))|0)!=0; //@line 1452 "translate.cpp"
              if (!($tobool735)) { __label__ = 208;break $if_end761$$if_else730$282; } //@line 1452 "translate.cpp"
  
              var $arrayidx737=(($dictionary_flags)&4294967295); //@line 1453 "translate.cpp"
              var $326=HEAP32[(($arrayidx737)>>2)]; //@line 1453 "translate.cpp"
              var $or738=($326) | 268435456; //@line 1453 "translate.cpp"
              HEAP32[(($arrayidx737)>>2)]=$or738; //@line 1453 "translate.cpp"
              ; //@line 1453 "translate.cpp"
            }
            else if (__label__ == 202) {
  
              var $327=HEAP32[((_dictionary_skipwords)>>2)]; //@line 1456 "translate.cpp"
              var $328=$wtab_addr; //@line 1456 "translate.cpp"
              var $arrayidx741=(($328+12*$327)&4294967295); //@line 1456 "translate.cpp"
              var $flags742=(($arrayidx741)&4294967295); //@line 1456 "translate.cpp"
              var $329=HEAP32[(($flags742)>>2)]; //@line 1456 "translate.cpp"
              var $and743=($329) & 16; //@line 1456 "translate.cpp"
              var $tobool744=((($and743))|0)!=0; //@line 1456 "translate.cpp"
              if (!($tobool744)) { __label__ = 208;break $if_end761$$if_else730$282; } //@line 1456 "translate.cpp"
  
              var $arrayidx746=(($dictionary_flags)&4294967295); //@line 1459 "translate.cpp"
              var $330=HEAP32[(($arrayidx746)>>2)]; //@line 1459 "translate.cpp"
              var $and747=($330) & 6144; //@line 1459 "translate.cpp"
              var $tobool748=((($and747))|0)!=0; //@line 1459 "translate.cpp"
              if ($tobool748) { __label__ = 204;; } else { __label__ = 205;; } //@line 1459 "translate.cpp"
              if (__label__ == 204) {
  
                var $331=$tr_addr; //@line 1460 "translate.cpp"
                __Z16ChangeWordStressP10TranslatorPci($331, ((_word_phonemes)&4294967295), 4); //@line 1460 "translate.cpp"
                ; //@line 1460 "translate.cpp"
              }
              else if (__label__ == 205) {
  
                var $arrayidx751=(($dictionary_flags)&4294967295); //@line 1462 "translate.cpp"
                var $332=HEAP32[(($arrayidx751)>>2)]; //@line 1462 "translate.cpp"
                var $and752=($332) & 8192; //@line 1462 "translate.cpp"
                var $tobool753=((($and752))|0)!=0; //@line 1462 "translate.cpp"
                if (!($tobool753)) { __label__ = 208;break $if_end761$$if_else730$282; } //@line 1462 "translate.cpp"
  
                var $_b=HEAPU8[(__ZL18any_stressed_words_b)];
                var $333=((($_b))&1);
                var $tobool755=((($333))|0)!=0; //@line 1462 "translate.cpp"
                if (!($tobool755)) { __label__ = 208;break $if_end761$$if_else730$282; } //@line 1462 "translate.cpp"
  
                var $334=$tr_addr; //@line 1463 "translate.cpp"
                __Z16ChangeWordStressP10TranslatorPci($334, ((_word_phonemes)&4294967295), 3); //@line 1463 "translate.cpp"
                ; //@line 1463 "translate.cpp"
              }
            }
          }
        } while(0);
  
        var $335=$end_type; //@line 1468 "translate.cpp"
        var $and762=($335) & 8192; //@line 1468 "translate.cpp"
        var $tobool763=((($and762))|0)!=0; //@line 1468 "translate.cpp"
        if ($tobool763) { __label__ = 209;; } else { __label__ = 210;; } //@line 1468 "translate.cpp"
        if (__label__ == 209) {
  
          var $336=$tr_addr; //@line 1471 "translate.cpp"
          var $expect_verb765=(($336+8272)&4294967295); //@line 1471 "translate.cpp"
          HEAP32[(($expect_verb765)>>2)]=2; //@line 1471 "translate.cpp"
          var $337=$tr_addr; //@line 1472 "translate.cpp"
          var $expect_verb_s=(($337+8280)&4294967295); //@line 1472 "translate.cpp"
          HEAP32[(($expect_verb_s)>>2)]=2; //@line 1472 "translate.cpp"
          ; //@line 1473 "translate.cpp"
        }
  
        var $arrayidx767=(($dictionary_flags+4)&4294967295); //@line 1475 "translate.cpp"
        var $338=HEAP32[(($arrayidx767)>>2)]; //@line 1475 "translate.cpp"
        var $and768=($338) & 8; //@line 1475 "translate.cpp"
        var $tobool769=((($and768))|0)!=0; //@line 1475 "translate.cpp"
        if ($tobool769) { __label__ = 211;; } else { __label__ = 212;; } //@line 1475 "translate.cpp"
        $if_then770$$if_else772$298: do { 
          if (__label__ == 211) {
  
            var $339=$tr_addr; //@line 1478 "translate.cpp"
            var $expect_past=(($339+8276)&4294967295); //@line 1478 "translate.cpp"
            HEAP32[(($expect_past)>>2)]=3; //@line 1478 "translate.cpp"
            var $340=$tr_addr; //@line 1479 "translate.cpp"
            var $expect_verb771=(($340+8272)&4294967295); //@line 1479 "translate.cpp"
            HEAP32[(($expect_verb771)>>2)]=0; //@line 1479 "translate.cpp"
            var $341=$tr_addr; //@line 1480 "translate.cpp"
            var $expect_noun=(($341+8284)&4294967295); //@line 1480 "translate.cpp"
            HEAP32[(($expect_noun)>>2)]=0; //@line 1480 "translate.cpp"
            ; //@line 1481 "translate.cpp"
          }
          else if (__label__ == 212) {
  
            var $arrayidx773=(($dictionary_flags+4)&4294967295); //@line 1483 "translate.cpp"
            var $342=HEAP32[(($arrayidx773)>>2)]; //@line 1483 "translate.cpp"
            var $and774=($342) & 1; //@line 1483 "translate.cpp"
            var $tobool775=((($and774))|0)!=0; //@line 1483 "translate.cpp"
            if ($tobool775) { __label__ = 213;; } else { __label__ = 214;; } //@line 1483 "translate.cpp"
            if (__label__ == 213) {
  
              var $343=$tr_addr; //@line 1486 "translate.cpp"
              var $expect_verb777=(($343+8272)&4294967295); //@line 1486 "translate.cpp"
              HEAP32[(($expect_verb777)>>2)]=2; //@line 1486 "translate.cpp"
              var $344=$tr_addr; //@line 1487 "translate.cpp"
              var $expect_verb_s778=(($344+8280)&4294967295); //@line 1487 "translate.cpp"
              HEAP32[(($expect_verb_s778)>>2)]=0; //@line 1487 "translate.cpp"
              var $345=$tr_addr; //@line 1488 "translate.cpp"
              var $expect_noun779=(($345+8284)&4294967295); //@line 1488 "translate.cpp"
              HEAP32[(($expect_noun779)>>2)]=0; //@line 1488 "translate.cpp"
              ; //@line 1489 "translate.cpp"
            }
            else if (__label__ == 214) {
  
              var $arrayidx781=(($dictionary_flags+4)&4294967295); //@line 1491 "translate.cpp"
              var $346=HEAP32[(($arrayidx781)>>2)]; //@line 1491 "translate.cpp"
              var $and782=($346) & 2; //@line 1491 "translate.cpp"
              var $tobool783=((($and782))|0)!=0; //@line 1491 "translate.cpp"
              if ($tobool783) { __label__ = 215;; } else { __label__ = 216;; } //@line 1491 "translate.cpp"
              if (__label__ == 215) {
  
                var $347=$tr_addr; //@line 1494 "translate.cpp"
                var $expect_verb785=(($347+8272)&4294967295); //@line 1494 "translate.cpp"
                HEAP32[(($expect_verb785)>>2)]=0; //@line 1494 "translate.cpp"
                var $348=$tr_addr; //@line 1495 "translate.cpp"
                var $expect_verb_s786=(($348+8280)&4294967295); //@line 1495 "translate.cpp"
                HEAP32[(($expect_verb_s786)>>2)]=2; //@line 1495 "translate.cpp"
                var $349=$tr_addr; //@line 1496 "translate.cpp"
                var $expect_past787=(($349+8276)&4294967295); //@line 1496 "translate.cpp"
                HEAP32[(($expect_past787)>>2)]=0; //@line 1496 "translate.cpp"
                var $350=$tr_addr; //@line 1497 "translate.cpp"
                var $expect_noun788=(($350+8284)&4294967295); //@line 1497 "translate.cpp"
                HEAP32[(($expect_noun788)>>2)]=0; //@line 1497 "translate.cpp"
                ; //@line 1498 "translate.cpp"
              }
              else if (__label__ == 216) {
  
                var $arrayidx790=(($dictionary_flags+4)&4294967295); //@line 1500 "translate.cpp"
                var $351=HEAP32[(($arrayidx790)>>2)]; //@line 1500 "translate.cpp"
                var $and791=($351) & 4; //@line 1500 "translate.cpp"
                var $tobool792=((($and791))|0)!=0; //@line 1500 "translate.cpp"
                if (!($tobool792)) { __label__ = 218;break $if_then770$$if_else772$298; } //@line 1500 "translate.cpp"
  
                var $352=$tr_addr; //@line 1503 "translate.cpp"
                var $expect_noun794=(($352+8284)&4294967295); //@line 1503 "translate.cpp"
                HEAP32[(($expect_noun794)>>2)]=2; //@line 1503 "translate.cpp"
                var $353=$tr_addr; //@line 1504 "translate.cpp"
                var $expect_verb795=(($353+8272)&4294967295); //@line 1504 "translate.cpp"
                HEAP32[(($expect_verb795)>>2)]=0; //@line 1504 "translate.cpp"
                var $354=$tr_addr; //@line 1505 "translate.cpp"
                var $expect_verb_s796=(($354+8280)&4294967295); //@line 1505 "translate.cpp"
                HEAP32[(($expect_verb_s796)>>2)]=0; //@line 1505 "translate.cpp"
                var $355=$tr_addr; //@line 1506 "translate.cpp"
                var $expect_past797=(($355+8276)&4294967295); //@line 1506 "translate.cpp"
                HEAP32[(($expect_past797)>>2)]=0; //@line 1506 "translate.cpp"
                ; //@line 1507 "translate.cpp"
              }
            }
          }
        } while(0);
  
        var $356=HEAP32[(($wordx)>>2)]; //@line 1509 "translate.cpp"
        var $arrayidx802=(($356)&4294967295); //@line 1509 "translate.cpp"
        var $357=HEAP8[($arrayidx802)]; //@line 1509 "translate.cpp"
        var $conv803=(tempInt=(($357)),(tempInt>=128?tempInt-256:tempInt)); //@line 1509 "translate.cpp"
        var $cmp804=((($conv803))|0)!=0; //@line 1509 "translate.cpp"
        if ($cmp804) { __label__ = 219;; } else { __label__ = 228;; } //@line 1509 "translate.cpp"
        $land_lhs_true805$$if_end834$309: do { 
          if (__label__ == 219) {
  
            var $arrayidx806=(($dictionary_flags+4)&4294967295); //@line 1509 "translate.cpp"
            var $358=HEAP32[(($arrayidx806)>>2)]; //@line 1509 "translate.cpp"
            var $and807=($358) & 256; //@line 1509 "translate.cpp"
            var $tobool808=((($and807))|0)!=0; //@line 1509 "translate.cpp"
            if ($tobool808) { __label__ = 228;break $land_lhs_true805$$if_end834$309; } //@line 1509 "translate.cpp"
  
            var $359=$tr_addr; //@line 1511 "translate.cpp"
            var $expect_verb810=(($359+8272)&4294967295); //@line 1511 "translate.cpp"
            var $360=HEAP32[(($expect_verb810)>>2)]; //@line 1511 "translate.cpp"
            var $cmp811=((($360))|0) > 0; //@line 1511 "translate.cpp"
            if ($cmp811) { __label__ = 221;; } else { __label__ = 222;; } //@line 1511 "translate.cpp"
            if (__label__ == 221) {
  
              var $361=$tr_addr; //@line 1512 "translate.cpp"
              var $expect_verb813=(($361+8272)&4294967295); //@line 1512 "translate.cpp"
              var $362=HEAP32[(($expect_verb813)>>2)]; //@line 1512 "translate.cpp"
              var $dec814=((($362)-1)&4294967295); //@line 1512 "translate.cpp"
              HEAP32[(($expect_verb813)>>2)]=$dec814; //@line 1512 "translate.cpp"
              ; //@line 1512 "translate.cpp"
            }
  
            var $363=$tr_addr; //@line 1514 "translate.cpp"
            var $expect_verb_s816=(($363+8280)&4294967295); //@line 1514 "translate.cpp"
            var $364=HEAP32[(($expect_verb_s816)>>2)]; //@line 1514 "translate.cpp"
            var $cmp817=((($364))|0) > 0; //@line 1514 "translate.cpp"
            if ($cmp817) { __label__ = 223;; } else { __label__ = 224;; } //@line 1514 "translate.cpp"
            if (__label__ == 223) {
  
              var $365=$tr_addr; //@line 1515 "translate.cpp"
              var $expect_verb_s819=(($365+8280)&4294967295); //@line 1515 "translate.cpp"
              var $366=HEAP32[(($expect_verb_s819)>>2)]; //@line 1515 "translate.cpp"
              var $dec820=((($366)-1)&4294967295); //@line 1515 "translate.cpp"
              HEAP32[(($expect_verb_s819)>>2)]=$dec820; //@line 1515 "translate.cpp"
              ; //@line 1515 "translate.cpp"
            }
  
            var $367=$tr_addr; //@line 1517 "translate.cpp"
            var $expect_noun822=(($367+8284)&4294967295); //@line 1517 "translate.cpp"
            var $368=HEAP32[(($expect_noun822)>>2)]; //@line 1517 "translate.cpp"
            var $cmp823=((($368))|0) > 0; //@line 1517 "translate.cpp"
            if ($cmp823) { __label__ = 225;; } else { __label__ = 226;; } //@line 1517 "translate.cpp"
            if (__label__ == 225) {
  
              var $369=$tr_addr; //@line 1518 "translate.cpp"
              var $expect_noun825=(($369+8284)&4294967295); //@line 1518 "translate.cpp"
              var $370=HEAP32[(($expect_noun825)>>2)]; //@line 1518 "translate.cpp"
              var $dec826=((($370)-1)&4294967295); //@line 1518 "translate.cpp"
              HEAP32[(($expect_noun825)>>2)]=$dec826; //@line 1518 "translate.cpp"
              ; //@line 1518 "translate.cpp"
            }
  
            var $371=$tr_addr; //@line 1520 "translate.cpp"
            var $expect_past828=(($371+8276)&4294967295); //@line 1520 "translate.cpp"
            var $372=HEAP32[(($expect_past828)>>2)]; //@line 1520 "translate.cpp"
            var $cmp829=((($372))|0) > 0; //@line 1520 "translate.cpp"
            if (!($cmp829)) { __label__ = 228;break $land_lhs_true805$$if_end834$309; } //@line 1520 "translate.cpp"
  
            var $373=$tr_addr; //@line 1521 "translate.cpp"
            var $expect_past831=(($373+8276)&4294967295); //@line 1521 "translate.cpp"
            var $374=HEAP32[(($expect_past831)>>2)]; //@line 1521 "translate.cpp"
            var $dec832=((($374)-1)&4294967295); //@line 1521 "translate.cpp"
            HEAP32[(($expect_past831)>>2)]=$dec832; //@line 1521 "translate.cpp"
            ; //@line 1521 "translate.cpp"
          }
        } while(0);
  
        var $375=$word_length; //@line 1524 "translate.cpp"
        var $cmp835=((($375))|0)==1; //@line 1524 "translate.cpp"
        if ($cmp835) { __label__ = 229;; } else { __label__ = 232;; } //@line 1524 "translate.cpp"
        $land_lhs_true836$$if_end846$323: do { 
          if (__label__ == 229) {
  
            var $376=$tr_addr; //@line 1524 "translate.cpp"
            var $translator_name=(($376+280)&4294967295); //@line 1524 "translate.cpp"
            var $377=HEAP32[(($translator_name)>>2)]; //@line 1524 "translate.cpp"
            var $cmp837=((($377))|0)==25966; //@line 1524 "translate.cpp"
            if (!($cmp837)) { __label__ = 232;break $land_lhs_true836$$if_end846$323; } //@line 1524 "translate.cpp"
  
            var $378=HEAP32[(($first_char)>>2)]; //@line 1524 "translate.cpp"
            var $call839=_iswalpha($378); //@line 1524 "translate.cpp"
            var $tobool840=((($call839))|0)!=0; //@line 1524 "translate.cpp"
            var $379=HEAP32[(($first_char)>>2)]; //@line 1524 "translate.cpp"
            var $cmp842=((($379))|0)!=105; //@line 1524 "translate.cpp"
            var $or_cond3=($tobool840) & ($cmp842); //@line 1524 "translate.cpp"
            if (!($or_cond3)) { __label__ = 232;break $land_lhs_true836$$if_end846$323; } //@line 1524 "translate.cpp"
  
            var $arrayidx844=(($dictionary_flags)&4294967295); //@line 1528 "translate.cpp"
            var $380=HEAP32[(($arrayidx844)>>2)]; //@line 1528 "translate.cpp"
            var $or845=($380) | 16777216; //@line 1528 "translate.cpp"
            HEAP32[(($arrayidx844)>>2)]=$or845; //@line 1528 "translate.cpp"
            ; //@line 1529 "translate.cpp"
          }
        } while(0);
  
        var $381=$tr_addr; //@line 1531 "translate.cpp"
        var $langopts847=(($381)&4294967295); //@line 1531 "translate.cpp"
        var $param848=(($langopts847+24)&4294967295); //@line 1531 "translate.cpp"
        var $arrayidx849=(($param848+60)&4294967295); //@line 1531 "translate.cpp"
        var $382=HEAP32[(($arrayidx849)>>2)]; //@line 1531 "translate.cpp"
        var $and850=($382) & 2; //@line 1531 "translate.cpp"
        var $tobool851=((($and850))|0)!=0; //@line 1531 "translate.cpp"
        if ($tobool851) { __label__ = 233;; } else { __label__ = 235;; } //@line 1531 "translate.cpp"
        $land_lhs_true852$$if_end858$328: do { 
          if (__label__ == 233) {
  
            var $arrayidx853=(($dictionary_flags)&4294967295); //@line 1531 "translate.cpp"
            var $383=HEAP32[(($arrayidx853)>>2)]; //@line 1531 "translate.cpp"
            var $and854=($383) & 3145728; //@line 1531 "translate.cpp"
            var $cmp855=((($and854))|0)!=0; //@line 1531 "translate.cpp"
            if (!($cmp855)) { __label__ = 235;break $land_lhs_true852$$if_end858$328; } //@line 1531 "translate.cpp"
  
            var $384=$tr_addr; //@line 1533 "translate.cpp"
            var $arrayidx857=(($dictionary_flags)&4294967295); //@line 1533 "translate.cpp"
            var $385=HEAP32[(($arrayidx857)>>2)]; //@line 1533 "translate.cpp"
            __Z22ApplySpecialAttribute2P10TranslatorPci($384, ((_word_phonemes)&4294967295), $385); //@line 1533 "translate.cpp"
            ; //@line 1534 "translate.cpp"
          }
        } while(0);
  
        var $386=$was_unpronouncable; //@line 1536 "translate.cpp"
        var $arrayidx859=(($dictionary_flags)&4294967295); //@line 1536 "translate.cpp"
        var $387=HEAP32[(($arrayidx859)>>2)]; //@line 1536 "translate.cpp"
        var $or860=($387) | ($386); //@line 1536 "translate.cpp"
        HEAP32[(($arrayidx859)>>2)]=$or860; //@line 1536 "translate.cpp"
        var $388=$word_start_addr; //@line 1537 "translate.cpp"
        var $arraydecay861=(($word_copy2)&4294967295); //@line 1537 "translate.cpp"
        var $389=$word_copy_length; //@line 1537 "translate.cpp"
        var $src$, $dest$, $stop$, $stop4$, $fast$;
        $src$ = $arraydecay861;
        $dest$ = $388;
        $stop$ = $src$ + $389;
        if (($dest$%4) == ($src$%4) && $389 > 8) {
          while ($src$%4 !== 0 && $src$ < $stop$) {
            ; HEAP8[$dest$++] = HEAP8[$src$++];
          }
          $src$ >>= 2;
          $dest$ >>= 2;
          $stop4$ = $stop$ >> 2;
          while ($src$ < $stop4$) {
        ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
          }
          $src$ <<= 2;
          $dest$ <<= 2;
        }while ($src$ < $stop$) {
          ; HEAP8[$dest$++] = HEAP8[$src$++];
        }; //@line 1537 "translate.cpp"
        var $arrayidx862=(($dictionary_flags)&4294967295); //@line 1538 "translate.cpp"
        var $390=HEAP32[(($arrayidx862)>>2)]; //@line 1538 "translate.cpp"
        $retval=$390; //@line 1538 "translate.cpp"
        ; //@line 1538 "translate.cpp"
      }
    } while(0);
  
    var $391=$retval; //@line 1539 "translate.cpp"
    STACKTOP = __stackBase__;
    return $391; //@line 1539 "translate.cpp"
    return null;
  }
  

  function __ZL17CheckDottedAbbrevPcP8WORD_TAB($word1, $wtab) {
    var __stackBase__  = STACKTOP; STACKTOP += 84; _memset(__stackBase__, 0, 84);
    var __label__;
  
    var $word1_addr;
    var $wtab_addr;
    var $wc=__stackBase__;
    var $count;
    var $nbytes;
    var $ok;
    var $ix;
    var $word;
    var $wbuf;
    var $word_buf=__stackBase__+4;
    $word1_addr=$word1;
    $wtab_addr=$wtab;
    $count=0; //@line 628 "translate.cpp"
    var $0=$word1_addr; //@line 636 "translate.cpp"
    $word=$0; //@line 636 "translate.cpp"
    var $arraydecay=(($word_buf)&4294967295); //@line 637 "translate.cpp"
    $wbuf=$arraydecay; //@line 637 "translate.cpp"
    $ix=0; //@line 638 "translate.cpp"
    ; //@line 640 "translate.cpp"
    $for_cond$2: while(1) { 
  
      $ok=0; //@line 642 "translate.cpp"
      var $1=$word; //@line 643 "translate.cpp"
      var $call=__Z7utf8_inPiPKc($wc, $1); //@line 643 "translate.cpp"
      $nbytes=$call; //@line 643 "translate.cpp"
      var $2=$nbytes; //@line 644 "translate.cpp"
      var $3=$word; //@line 644 "translate.cpp"
      var $arrayidx=(($3+$2)&4294967295); //@line 644 "translate.cpp"
      var $4=HEAP8[($arrayidx)]; //@line 644 "translate.cpp"
      var $conv=(tempInt=(($4)),(tempInt>=128?tempInt-256:tempInt)); //@line 644 "translate.cpp"
      var $cmp=((($conv))|0)==32; //@line 644 "translate.cpp"
      if ($cmp) { __label__ = 2;; } else { __label__ = 11;; } //@line 644 "translate.cpp"
      $land_lhs_true$$if_end27$4: do { 
        if (__label__ == 2) {
  
          var $5=HEAP32[(($wc)>>2)]; //@line 644 "translate.cpp"
          var $call1=__Z7IsAlphaj($5); //@line 644 "translate.cpp"
          var $tobool=((($call1))|0)!=0; //@line 644 "translate.cpp"
          if (!($tobool)) { __label__ = 11;break $land_lhs_true$$if_end27$4; } //@line 644 "translate.cpp"
  
          var $6=$nbytes; //@line 646 "translate.cpp"
          var $add=((($6)+1)&4294967295); //@line 646 "translate.cpp"
          var $7=$word; //@line 646 "translate.cpp"
          var $arrayidx2=(($7+$add)&4294967295); //@line 646 "translate.cpp"
          var $8=HEAP8[($arrayidx2)]; //@line 646 "translate.cpp"
          var $conv3=(tempInt=(($8)),(tempInt>=128?tempInt-256:tempInt)); //@line 646 "translate.cpp"
          var $cmp4=((($conv3))|0)==46; //@line 646 "translate.cpp"
          if ($cmp4) { __label__ = 4;; } else { __label__ = 8;; } //@line 646 "translate.cpp"
          if (__label__ == 4) {
  
            var $9=$nbytes; //@line 648 "translate.cpp"
            var $add6=((($9)+2)&4294967295); //@line 648 "translate.cpp"
            var $10=$word; //@line 648 "translate.cpp"
            var $arrayidx7=(($10+$add6)&4294967295); //@line 648 "translate.cpp"
            var $11=HEAP8[($arrayidx7)]; //@line 648 "translate.cpp"
            var $conv8=(tempInt=(($11)),(tempInt>=128?tempInt-256:tempInt)); //@line 648 "translate.cpp"
            var $cmp9=((($conv8))|0)==32; //@line 648 "translate.cpp"
            if ($cmp9) { __label__ = 5;; } else { __label__ = 6;; } //@line 648 "translate.cpp"
            if (__label__ == 5) {
  
              $ok=1; //@line 649 "translate.cpp"
              __label__ = 12;break $land_lhs_true$$if_end27$4; //@line 649 "translate.cpp"
            }
            else if (__label__ == 6) {
  
              var $12=$nbytes; //@line 651 "translate.cpp"
              var $add11=((($12)+2)&4294967295); //@line 651 "translate.cpp"
              var $13=$word; //@line 651 "translate.cpp"
              var $arrayidx12=(($13+$add11)&4294967295); //@line 651 "translate.cpp"
              var $14=HEAP8[($arrayidx12)]; //@line 651 "translate.cpp"
              var $conv13=(tempInt=(($14)),(tempInt>=128?tempInt-256:tempInt)); //@line 651 "translate.cpp"
              var $cmp14=((($conv13))|0)==39; //@line 651 "translate.cpp"
              if (!($cmp14)) { __label__ = 11;break $land_lhs_true$$if_end27$4; } //@line 651 "translate.cpp"
  
              var $15=$nbytes; //@line 653 "translate.cpp"
              var $add16=((($15)+2)&4294967295); //@line 653 "translate.cpp"
              $nbytes=$add16; //@line 653 "translate.cpp"
              $ok=2; //@line 654 "translate.cpp"
              __label__ = 12;break $land_lhs_true$$if_end27$4; //@line 655 "translate.cpp"
            }
          }
          else if (__label__ == 8) {
  
            var $16=$count; //@line 658 "translate.cpp"
            var $cmp19=((($16))|0) > 0; //@line 658 "translate.cpp"
            if (!($cmp19)) { __label__ = 11;break $land_lhs_true$$if_end27$4; } //@line 658 "translate.cpp"
  
            var $17=$nbytes; //@line 658 "translate.cpp"
            var $18=$word; //@line 658 "translate.cpp"
            var $arrayidx21=(($18+$17)&4294967295); //@line 658 "translate.cpp"
            var $19=HEAP8[($arrayidx21)]; //@line 658 "translate.cpp"
            var $conv22=(tempInt=(($19)),(tempInt>=128?tempInt-256:tempInt)); //@line 658 "translate.cpp"
            var $cmp23=((($conv22))|0)==32; //@line 658 "translate.cpp"
            if (!($cmp23)) { __label__ = 11;break $land_lhs_true$$if_end27$4; } //@line 658 "translate.cpp"
  
            $ok=2; //@line 659 "translate.cpp"
            __label__ = 12;break $land_lhs_true$$if_end27$4; //@line 659 "translate.cpp"
          }
        }
      } while(0);
      if (__label__ == 11) {
  
        var $_pr=$ok; //@line 662 "translate.cpp"
        var $cmp28=((($_pr))|0)==0; //@line 662 "translate.cpp"
        if ($cmp28) { __label__ = 17;break $for_cond$2; } //@line 662 "translate.cpp"
      }
  
      $ix=0; //@line 665 "translate.cpp"
      var $20=$ix; //@line 665 "translate.cpp"
      var $21=$nbytes; //@line 665 "translate.cpp"
      var $cmp324=((($20))|0) < ((($21))|0); //@line 665 "translate.cpp"
      if ($cmp324) { __label__ = 13;; } else { __label__ = 14;; } //@line 665 "translate.cpp"
      $for_body$$for_end$19: do { 
        if (__label__ == 13) {
          while(1) { 
  
            var $22=$ix; //@line 666 "translate.cpp"
            var $23=$word; //@line 666 "translate.cpp"
            var $arrayidx33=(($23+$22)&4294967295); //@line 666 "translate.cpp"
            var $24=HEAP8[($arrayidx33)]; //@line 666 "translate.cpp"
            var $25=$wbuf; //@line 666 "translate.cpp"
            var $incdec_ptr=(($25+1)&4294967295); //@line 666 "translate.cpp"
            $wbuf=$incdec_ptr; //@line 666 "translate.cpp"
            HEAP8[($25)]=$24; //@line 666 "translate.cpp"
            var $26=$ix; //@line 665 "translate.cpp"
            var $inc=((($26)+1)&4294967295); //@line 665 "translate.cpp"
            $ix=$inc; //@line 665 "translate.cpp"
            var $27=$ix; //@line 665 "translate.cpp"
            var $28=$nbytes; //@line 665 "translate.cpp"
            var $cmp32=((($27))|0) < ((($28))|0); //@line 665 "translate.cpp"
            if ($cmp32) { __label__ = 13;continue ; } else { __label__ = 14;break $for_body$$for_end$19; } //@line 665 "translate.cpp"
          }
        }
      } while(0);
  
      var $29=$count; //@line 668 "translate.cpp"
      var $inc34=((($29)+1)&4294967295); //@line 668 "translate.cpp"
      $count=$inc34; //@line 668 "translate.cpp"
      var $30=$ok; //@line 670 "translate.cpp"
      var $cmp35=((($30))|0)==2; //@line 670 "translate.cpp"
      var $31=$nbytes; //@line 672 "translate.cpp"
      if ($cmp35) { __label__ = 15;break $for_cond$2; } //@line 670 "translate.cpp"
  
      var $add38=((($31)+3)&4294967295); //@line 676 "translate.cpp"
      var $33=$word; //@line 676 "translate.cpp"
      var $add_ptr39=(($33+$add38)&4294967295); //@line 676 "translate.cpp"
      $word=$add_ptr39; //@line 676 "translate.cpp"
      __label__ = 1;continue $for_cond$2; //@line 677 "translate.cpp"
    }
    if (__label__ == 15) {
  
      var $32=$word; //@line 672 "translate.cpp"
      var $add_ptr=(($32+$31)&4294967295); //@line 672 "translate.cpp"
      $word=$add_ptr; //@line 672 "translate.cpp"
      ; //@line 673 "translate.cpp"
    }
  
    var $34=$count; //@line 679 "translate.cpp"
    var $cmp41=((($34))|0) > 1; //@line 679 "translate.cpp"
    if ($cmp41) { __label__ = 18;; } else { __label__ = 21;; } //@line 679 "translate.cpp"
    if (__label__ == 18) {
  
      var $35=$wbuf; //@line 681 "translate.cpp"
      var $arraydecay43=(($word_buf)&4294967295); //@line 681 "translate.cpp"
      var $sub_ptr_lhs_cast=($35); //@line 681 "translate.cpp"
      var $sub_ptr_rhs_cast=($arraydecay43); //@line 681 "translate.cpp"
      var $sub_ptr_sub=((($sub_ptr_lhs_cast)-($sub_ptr_rhs_cast))&4294967295); //@line 681 "translate.cpp"
      $ix=$sub_ptr_sub; //@line 681 "translate.cpp"
      var $36=$word1_addr; //@line 682 "translate.cpp"
      var $arraydecay44=(($word_buf)&4294967295); //@line 682 "translate.cpp"
      var $37=$ix; //@line 682 "translate.cpp"
      var $src$, $dest$, $stop$, $stop4$, $fast$;
      $src$ = $arraydecay44;
      $dest$ = $36;
      $stop$ = $src$ + $37;
      if (($dest$%4) == ($src$%4) && $37 > 8) {
        while ($src$%4 !== 0 && $src$ < $stop$) {
          ; HEAP8[$dest$++] = HEAP8[$src$++];
        }
        $src$ >>= 2;
        $dest$ >>= 2;
        $stop4$ = $stop$ >> 2;
        while ($src$ < $stop4$) {
      ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
        }
        $src$ <<= 2;
        $dest$ <<= 2;
      }while ($src$ < $stop$) {
        ; HEAP8[$dest$++] = HEAP8[$src$++];
      }; //@line 682 "translate.cpp"
      var $38=$ix; //@line 683 "translate.cpp"
      var $39=$word1_addr; //@line 683 "translate.cpp"
      var $arrayidx452=(($39+$38)&4294967295); //@line 683 "translate.cpp"
      var $40=$word; //@line 683 "translate.cpp"
      var $cmp463=((($arrayidx452))>>>0) < ((($40))>>>0); //@line 683 "translate.cpp"
      if ($cmp463) { __label__ = 19;; } else { __label__ = 20;; } //@line 683 "translate.cpp"
      $while_body$$while_end$29: do { 
        if (__label__ == 19) {
          while(1) { 
  
            var $41=$ix; //@line 684 "translate.cpp"
            var $inc47=((($41)+1)&4294967295); //@line 684 "translate.cpp"
            $ix=$inc47; //@line 684 "translate.cpp"
            var $42=$word1_addr; //@line 684 "translate.cpp"
            var $arrayidx48=(($42+$41)&4294967295); //@line 684 "translate.cpp"
            HEAP8[($arrayidx48)]=32; //@line 684 "translate.cpp"
            var $43=$ix; //@line 683 "translate.cpp"
            var $44=$word1_addr; //@line 683 "translate.cpp"
            var $arrayidx45=(($44+$43)&4294967295); //@line 683 "translate.cpp"
            var $45=$word; //@line 683 "translate.cpp"
            var $cmp46=((($arrayidx45))>>>0) < ((($45))>>>0); //@line 683 "translate.cpp"
            if ($cmp46) { __label__ = 19;continue ; } else { __label__ = 20;break $while_body$$while_end$29; } //@line 683 "translate.cpp"
          }
        }
      } while(0);
  
      var $46=$count; //@line 685 "translate.cpp"
      var $sub=((($46)-1)&4294967295); //@line 685 "translate.cpp"
      var $mul=((($sub)*2)&4294967295); //@line 685 "translate.cpp"
      HEAP32[((_dictionary_skipwords)>>2)]=$mul; //@line 685 "translate.cpp"
      ; //@line 686 "translate.cpp"
    }
  
    var $47=$count; //@line 687 "translate.cpp"
    STACKTOP = __stackBase__;
    return $47; //@line 687 "translate.cpp"
    return null;
  }
  

  function __ZL22SpeakIndividualLettersP10TranslatorPcS1_i($tr, $word, $phonemes, $spell_word) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $tr_addr;
    var $word_addr;
    var $phonemes_addr;
    var $spell_word_addr;
    var $posn;
    var $capitals;
    var $non_initial;
    $tr_addr=$tr;
    $word_addr=$word;
    $phonemes_addr=$phonemes;
    $spell_word_addr=$spell_word;
    $posn=0; //@line 600 "translate.cpp"
    $capitals=0; //@line 601 "translate.cpp"
    $non_initial=0; //@line 602 "translate.cpp"
    var $0=$spell_word_addr; //@line 604 "translate.cpp"
    var $cmp=((($0))|0) > 2; //@line 604 "translate.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 604 "translate.cpp"
    if (__label__ == 1) {
  
      $capitals=2; //@line 605 "translate.cpp"
      ; //@line 605 "translate.cpp"
    }
    $while_cond$4: while(1) { 
  
      var $1=$word_addr; //@line 607 "translate.cpp"
      var $2=HEAP8[($1)]; //@line 607 "translate.cpp"
      var $conv=(tempInt=(($2)),(tempInt>=128?tempInt-256:tempInt)); //@line 607 "translate.cpp"
      var $cmp1=((($conv))|0)!=32; //@line 607 "translate.cpp"
      if (!($cmp1)) { __label__ = 3;break $while_cond$4; } //@line 607 "translate.cpp"
  
      var $4=$word_addr; //@line 607 "translate.cpp"
      var $5=HEAP8[($4)]; //@line 607 "translate.cpp"
      var $conv2=(tempInt=(($5)),(tempInt>=128?tempInt-256:tempInt)); //@line 607 "translate.cpp"
      var $cmp3=((($conv2))|0)!=0; //@line 607 "translate.cpp"
      var $6=$tr_addr; //@line 609 "translate.cpp"
      if ($cmp3) { __lastLabel__ = 4; ; } else { __lastLabel__ = 4; __label__ = 7;break $while_cond$4; }
  
      var $7=$word_addr; //@line 609 "translate.cpp"
      var $8=$phonemes_addr; //@line 609 "translate.cpp"
      var $9=$capitals; //@line 609 "translate.cpp"
      var $10=$non_initial; //@line 609 "translate.cpp"
      var $or=($10) | ($9); //@line 609 "translate.cpp"
      var $call=__Z15TranslateLetterP10TranslatorPcS1_i($6, $7, $8, $or); //@line 609 "translate.cpp"
      var $11=$word_addr; //@line 609 "translate.cpp"
      var $add_ptr=(($11+$call)&4294967295); //@line 609 "translate.cpp"
      $word_addr=$add_ptr; //@line 609 "translate.cpp"
      var $12=$posn; //@line 610 "translate.cpp"
      var $inc=((($12)+1)&4294967295); //@line 610 "translate.cpp"
      $posn=$inc; //@line 610 "translate.cpp"
      $non_initial=1; //@line 611 "translate.cpp"
      var $13=$phonemes_addr; //@line 612 "translate.cpp"
      var $arrayidx=(($13)&4294967295); //@line 612 "translate.cpp"
      var $14=HEAP8[($arrayidx)]; //@line 612 "translate.cpp"
      var $conv4=(tempInt=(($14)),(tempInt>=128?tempInt-256:tempInt)); //@line 612 "translate.cpp"
      var $cmp5=((($conv4))|0)==21; //@line 612 "translate.cpp"
      if ($cmp5) { __label__ = 6;break $while_cond$4; } else { __label__ = 2;continue $while_cond$4; } //@line 612 "translate.cpp"
    }
    $land_end_thread$$while_end$$if_then6$8: do { 
      if (__label__ == 3) {
  
        var $3=$tr_addr; //@line 609 "translate.cpp"
        __lastLabel__ = 3; __label__ = 7;break $land_end_thread$$while_end$$if_then6$8;
      }
      else if (__label__ == 6) {
  
        var $15=$phonemes_addr; //@line 615 "translate.cpp"
        var $call7=_strcpy(((_word_phonemes)&4294967295), $15); //@line 615 "translate.cpp"
        $retval=0; //@line 616 "translate.cpp"
        __label__ = 8;break $land_end_thread$$while_end$$if_then6$8; //@line 616 "translate.cpp"
      }
    } while(0);
    if (__label__ == 7) {
  
      var $16=__lastLabel__ == 3 ? $3 : ($6);
      var $17=$phonemes_addr; //@line 619 "translate.cpp"
      var $18=$spell_word_addr; //@line 619 "translate.cpp"
      var $19=$posn; //@line 619 "translate.cpp"
      __Z17SetSpellingStressP10TranslatorPcii($16, $17, $18, $19); //@line 619 "translate.cpp"
      var $20=$word_addr; //@line 620 "translate.cpp"
      $retval=$20; //@line 620 "translate.cpp"
      ; //@line 620 "translate.cpp"
    }
  
    var $21=$retval; //@line 621 "translate.cpp"
    ;
    return $21; //@line 621 "translate.cpp"
    return null;
  }
  

  function __Z14SetTranslator2PKc($new_language) {
    ;
    var __label__;
  
    var $new_language_addr;
    var $new_phoneme_tab;
    $new_language_addr=$new_language;
    var $0=$new_language_addr; //@line 1571 "translate.cpp"
    var $call=__Z22SelectPhonemeTableNamePKc($0); //@line 1571 "translate.cpp"
    $new_phoneme_tab=$call; //@line 1571 "translate.cpp"
    var $cmp=((($call))|0) >= 0; //@line 1571 "translate.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 7;; } //@line 1571 "translate.cpp"
    $if_then$$if_end14$2: do { 
      if (__label__ == 1) {
  
        var $1=HEAP32[((_translator2)>>2)]; //@line 1573 "translate.cpp"
        var $cmp1=((($1))|0)!=0; //@line 1573 "translate.cpp"
        if ($cmp1) { __label__ = 2;; } else { __label__ = 5;; } //@line 1573 "translate.cpp"
        if (__label__ == 2) {
  
          var $2=$new_language_addr; //@line 1573 "translate.cpp"
          var $call2=_strcmp($2, ((__ZL20translator2_language)&4294967295)); //@line 1573 "translate.cpp"
          var $cmp3=((($call2))|0)!=0; //@line 1573 "translate.cpp"
          var $3=HEAP32[((_translator2)>>2)]; //@line 1576 "translate.cpp"
          if ($cmp3) { __label__ = 3;; } else { __label__ = 4;; } //@line 1573 "translate.cpp"
          if (__label__ == 3) {
  
            __Z16DeleteTranslatorP10Translator($3); //@line 1576 "translate.cpp"
            HEAP32[((_translator2)>>2)]=0; //@line 1577 "translate.cpp"
            ; //@line 1578 "translate.cpp"
          }
          else if (__label__ == 4) {
  
            var $cmp5=((($3))|0)==0; //@line 1580 "translate.cpp"
            if (!($cmp5)) { __label__ = 7;break $if_then$$if_end14$2; } //@line 1580 "translate.cpp"
          }
        }
  
        var $4=$new_language_addr; //@line 1582 "translate.cpp"
        var $call7=__Z16SelectTranslatorPKc($4); //@line 1582 "translate.cpp"
        HEAP32[((_translator2)>>2)]=$call7; //@line 1582 "translate.cpp"
        var $5=$new_language_addr; //@line 1583 "translate.cpp"
        var $call8=_strcpy(((__ZL20translator2_language)&4294967295), $5); //@line 1583 "translate.cpp"
        var $6=HEAP32[((_translator2)>>2)]; //@line 1585 "translate.cpp"
        var $7=$new_language_addr; //@line 1585 "translate.cpp"
        var $call9=__Z14LoadDictionaryP10TranslatorPKci($6, $7, 0); //@line 1585 "translate.cpp"
        var $cmp10=((($call9))|0)!=0; //@line 1585 "translate.cpp"
        if (!($cmp10)) { __label__ = 7;break $if_then$$if_end14$2; } //@line 1585 "translate.cpp"
  
        var $8=HEAP32[((_voice)>>2)]; //@line 1587 "translate.cpp"
        var $phoneme_tab_ix=(($8+40)&4294967295); //@line 1587 "translate.cpp"
        var $9=HEAP32[(($phoneme_tab_ix)>>2)]; //@line 1587 "translate.cpp"
        __Z18SelectPhonemeTablei($9); //@line 1587 "translate.cpp"
        $new_phoneme_tab=-1; //@line 1588 "translate.cpp"
        HEAP8[(((__ZL20translator2_language)&4294967295))]=0; //@line 1589 "translate.cpp"
        ; //@line 1590 "translate.cpp"
      }
    } while(0);
  
    var $10=$new_phoneme_tab; //@line 1593 "translate.cpp"
    ;
    return $10; //@line 1593 "translate.cpp"
    return null;
  }
  

  function __Z15TranslateClauseP10TranslatorP7__sFILEPKvPiPPc($tr, $f_text, $vp_input, $tone_out, $voice_change) {
    var __stackBase__  = STACKTOP; STACKTOP += 6500; _memset(__stackBase__, 0, 6500);
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $tr_addr;
    var $f_text_addr;
    var $vp_input_addr;
    var $tone_out_addr;
    var $voice_change_addr;
    var $ix;
    var $c;
    var $cc=__stackBase__;
    var $source_index=__stackBase__+4;
    var $prev_source_index;
    var $source_index_word;
    var $prev_in=__stackBase__+8;
    var $prev_out=__stackBase__+12;
    var $prev_out2;
    var $prev_in2;
    var $prev_in_save;
    var $next_in=__stackBase__+16;
    var $next_in_nbytes;
    var $char_inserted=__stackBase__+20;
    var $clause_pause;
    var $pre_pause_add;
    var $word_mark;
    var $all_upper_case;
    var $finished;
    var $single_quoted;
    var $phoneme_mode;
    var $dict_flags;
    var $word_flags;
    var $next_word_flags;
    var $embedded_count;
    var $letter_count;
    var $space_inserted;
    var $syllable_marked;
    var $decimal_sep_count;
    var $word;
    var $p;
    var $j;
    var $k;
    var $n_digits;
    var $individual_digits;
    var $charix_top=__stackBase__+24;
    var $charix=__stackBase__+28;
    var $words=__stackBase__+1436;
    var $word_count;
    var $sbuf=__stackBase__+5036;
    var $terminator;
    var $tone;
    var $tone2=__stackBase__+5736;
    var $srcix;
    var $next2_in=__stackBase__+5740;
    var $nx;
    var $c_temp=__stackBase__+5744;
    var $pn;
    var $pw;
    var $nw;
    var $number_buf=__stackBase__+5748;
    var $num_wtab=__stackBase__+5900;
    var $p2;
    $tr_addr=$tr;
    $f_text_addr=$f_text;
    $vp_input_addr=$vp_input;
    $tone_out_addr=$tone_out;
    $voice_change_addr=$voice_change;
    HEAP32[(($source_index)>>2)]=0; //@line 2344 "translate.cpp"
    $prev_source_index=0; //@line 2345 "translate.cpp"
    $source_index_word=0; //@line 2346 "translate.cpp"
    HEAP32[(($prev_out)>>2)]=32; //@line 2348 "translate.cpp"
    $prev_in2=0; //@line 2350 "translate.cpp"
    $prev_in_save=0; //@line 2351 "translate.cpp"
    HEAP32[(($char_inserted)>>2)]=0; //@line 2354 "translate.cpp"
    $pre_pause_add=0; //@line 2356 "translate.cpp"
    $word_mark=0; //@line 2357 "translate.cpp"
    $all_upper_case=1; //@line 2358 "translate.cpp"
    $phoneme_mode=0; //@line 2361 "translate.cpp"
    $dict_flags=0; //@line 2362 "translate.cpp"
    $embedded_count=0; //@line 2365 "translate.cpp"
    $letter_count=0; //@line 2366 "translate.cpp"
    $space_inserted=0; //@line 2367 "translate.cpp"
    $syllable_marked=0; //@line 2368 "translate.cpp"
    $decimal_sep_count=0; //@line 2369 "translate.cpp"
    HEAP32[(($charix_top)>>2)]=0; //@line 2375 "translate.cpp"
    $word_count=0; //@line 2380 "translate.cpp"
    var $0=$tr_addr; //@line 2388 "translate.cpp"
    var $cmp=((($0))|0)==0; //@line 2388 "translate.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 2388 "translate.cpp"
    $if_then$$if_end$2: do { 
      if (__label__ == 1) {
  
        $retval=0; //@line 2390 "translate.cpp"
        ; //@line 2390 "translate.cpp"
      }
      else if (__label__ == 2) {
  
        var $1=$vp_input_addr; //@line 2393 "translate.cpp"
        HEAP32[((_p_textinput)>>2)]=$1; //@line 2393 "translate.cpp"
        var $2=$vp_input_addr; //@line 2394 "translate.cpp"
        var $3=$2; //@line 2394 "translate.cpp"
        HEAP32[((_p_wchar_input)>>2)]=$3; //@line 2394 "translate.cpp"
        HEAP32[((__ZL11embedded_ix)>>2)]=0; //@line 2396 "translate.cpp"
        HEAP32[((__ZL13embedded_read)>>2)]=0; //@line 2397 "translate.cpp"
        HEAP32[((_pre_pause)>>2)]=0; //@line 2398 "translate.cpp"
        HEAP8[(__ZL18any_stressed_words_b)]=0;
        var $4=HEAP32[((_count_characters)>>2)]; //@line 2401 "translate.cpp"
        HEAP32[((_clause_start_char)>>2)]=$4; //@line 2401 "translate.cpp"
        var $cmp1=((($4))|0) < 0; //@line 2401 "translate.cpp"
        if ($cmp1) { __label__ = 3;; } else { __label__ = 4;; } //@line 2401 "translate.cpp"
        if (__label__ == 3) {
  
          HEAP32[((_clause_start_char)>>2)]=0; //@line 2402 "translate.cpp"
          ; //@line 2402 "translate.cpp"
        }
  
        var $5=HEAP32[((_count_words)>>2)]; //@line 2403 "translate.cpp"
        var $add=((($5)+1)&4294967295); //@line 2403 "translate.cpp"
        HEAP32[((_clause_start_word)>>2)]=$add; //@line 2403 "translate.cpp"
        $ix=0; //@line 2405 "translate.cpp"
        ; //@line 2405 "translate.cpp"
        $for_body$8: while(1) { 
  
          var $6=$ix; //@line 2406 "translate.cpp"
          var $arrayidx=(($charix+$6*2)&4294967295); //@line 2406 "translate.cpp"
          HEAP16[(($arrayidx)>>1)]=0; //@line 2406 "translate.cpp"
          var $7=$ix; //@line 2405 "translate.cpp"
          var $inc=((($7)+1)&4294967295); //@line 2405 "translate.cpp"
          $ix=$inc; //@line 2405 "translate.cpp"
          var $cmp4=((($inc))|0) < 700; //@line 2405 "translate.cpp"
          if ($cmp4) { __label__ = 5;continue $for_body$8; } else { __label__ = 6;break $for_body$8; } //@line 2405 "translate.cpp"
        }
  
        var $8=$tr_addr; //@line 2407 "translate.cpp"
        var $9=$f_text_addr; //@line 2407 "translate.cpp"
        var $arraydecay=(($charix)&4294967295); //@line 2407 "translate.cpp"
        var $call=__Z10ReadClauseP10TranslatorP7__sFILEPcPsPiiS5_S3_($8, $9, ((__ZL6source)&4294967295), $arraydecay, $charix_top, 700, $tone2, ((__ZZ15TranslateClauseP10TranslatorP7__sFILEPKvPiPPcE17voice_change_name)&4294967295)); //@line 2407 "translate.cpp"
        $terminator=$call; //@line 2407 "translate.cpp"
        var $10=HEAP32[((_f_logespeak)>>2)]; //@line 2409 "translate.cpp"
        var $cmp5=((($10))|0)!=0; //@line 2409 "translate.cpp"
        if ($cmp5) { __label__ = 7;; } else { __label__ = 11;; } //@line 2409 "translate.cpp"
        $land_lhs_true$$if_end17$11: do { 
          if (__label__ == 7) {
  
            var $11=HEAP32[((_logging_type)>>2)]; //@line 2409 "translate.cpp"
            var $and=($11) & 4; //@line 2409 "translate.cpp"
            var $tobool=((($and))|0)!=0; //@line 2409 "translate.cpp"
            if (!($tobool)) { __label__ = 11;break $land_lhs_true$$if_end17$11; } //@line 2409 "translate.cpp"
  
            var $12=HEAP32[((_f_logespeak)>>2)]; //@line 2411 "translate.cpp"
            var $13=$terminator; //@line 2411 "translate.cpp"
            var $call7=_fprintf($12, ((__str7550)&4294967295), allocate([$13,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 2411 "translate.cpp"
            $p=((__ZL6source)&4294967295); //@line 2412 "translate.cpp"
            var $14=$p; //@line 2412 "translate.cpp"
            var $15=HEAP8[($14)]; //@line 2412 "translate.cpp"
            var $conv59=(tempInt=(($15)),(tempInt>=128?tempInt-256:tempInt)); //@line 2412 "translate.cpp"
            var $cmp960=((($conv59))|0)!=0; //@line 2412 "translate.cpp"
            if ($cmp960) { __label__ = 9;; } else { __label__ = 10;; } //@line 2412 "translate.cpp"
            $for_body10$$for_end14$14: do { 
              if (__label__ == 9) {
                while(1) { 
  
                  var $16=$p; //@line 2413 "translate.cpp"
                  var $17=HEAP8[($16)]; //@line 2413 "translate.cpp"
                  var $conv11=(tempInt=(($17)),(tempInt>=128?tempInt-256:tempInt)); //@line 2413 "translate.cpp"
                  var $18=HEAP32[((_f_logespeak)>>2)]; //@line 2413 "translate.cpp"
                  var $call12=_fputc($conv11, $18); //@line 2413 "translate.cpp"
                  var $19=$p; //@line 2412 "translate.cpp"
                  var $incdec_ptr=(($19+1)&4294967295); //@line 2412 "translate.cpp"
                  $p=$incdec_ptr; //@line 2412 "translate.cpp"
                  var $20=$p; //@line 2412 "translate.cpp"
                  var $21=HEAP8[($20)]; //@line 2412 "translate.cpp"
                  var $conv=(tempInt=(($21)),(tempInt>=128?tempInt-256:tempInt)); //@line 2412 "translate.cpp"
                  var $cmp9=((($conv))|0)!=0; //@line 2412 "translate.cpp"
                  if ($cmp9) { __label__ = 9;continue ; } else { __label__ = 10;break $for_body10$$for_end14$14; } //@line 2412 "translate.cpp"
                }
              }
            } while(0);
  
            var $22=HEAP32[((_f_logespeak)>>2)]; //@line 2414 "translate.cpp"
            var $23=_fwrite(((__str8551)&4294967295), 10, 1, $22); //@line 2414 "translate.cpp"
            var $24=HEAP32[((_f_logespeak)>>2)]; //@line 2415 "translate.cpp"
            var $call16=_fflush($24); //@line 2415 "translate.cpp"
            ; //@line 2416 "translate.cpp"
          }
        } while(0);
  
        $p=((__ZL6source)&4294967295); //@line 2417 "translate.cpp"
        var $25=HEAP32[(($charix_top)>>2)]; //@line 2419 "translate.cpp"
        var $add18=((($25)+1)&4294967295); //@line 2419 "translate.cpp"
        var $arrayidx19=(($charix+$add18*2)&4294967295); //@line 2419 "translate.cpp"
        HEAP16[(($arrayidx19)>>1)]=0; //@line 2419 "translate.cpp"
        var $26=HEAP32[(($charix_top)>>2)]; //@line 2420 "translate.cpp"
        var $add20=((($26)+2)&4294967295); //@line 2420 "translate.cpp"
        var $arrayidx21=(($charix+$add20*2)&4294967295); //@line 2420 "translate.cpp"
        HEAP16[(($arrayidx21)>>1)]=32767; //@line 2420 "translate.cpp"
        var $27=HEAP32[(($charix_top)>>2)]; //@line 2421 "translate.cpp"
        var $add22=((($27)+3)&4294967295); //@line 2421 "translate.cpp"
        var $arrayidx23=(($charix+$add22*2)&4294967295); //@line 2421 "translate.cpp"
        HEAP16[(($arrayidx23)>>1)]=0; //@line 2421 "translate.cpp"
        var $28=$terminator; //@line 2423 "translate.cpp"
        var $and24=($28) & 4095; //@line 2423 "translate.cpp"
        var $mul=((($and24)*10)&4294967295); //@line 2423 "translate.cpp"
        $clause_pause=$mul; //@line 2423 "translate.cpp"
        var $29=$terminator; //@line 2424 "translate.cpp"
        var $shr=($29) >> 12; //@line 2424 "translate.cpp"
        var $and25=($shr) & 7; //@line 2424 "translate.cpp"
        $tone=$and25; //@line 2424 "translate.cpp"
        var $30=HEAP32[(($tone2)>>2)]; //@line 2425 "translate.cpp"
        var $cmp26=((($30))|0)!=0; //@line 2425 "translate.cpp"
        if ($cmp26) { __label__ = 12;; } else { __label__ = 13;; } //@line 2425 "translate.cpp"
        if (__label__ == 12) {
  
          var $31=HEAP32[(($tone2)>>2)]; //@line 2428 "translate.cpp"
          $tone=$31; //@line 2428 "translate.cpp"
          ; //@line 2429 "translate.cpp"
        }
  
        $p=((__ZL6source)&4294967295); //@line 2431 "translate.cpp"
        ; //@line 2431 "translate.cpp"
        $for_cond29$22: while(1) { 
  
          var $32=$p; //@line 2431 "translate.cpp"
          var $33=HEAP8[($32)]; //@line 2431 "translate.cpp"
          var $conv30=(tempInt=(($33)),(tempInt>=128?tempInt-256:tempInt)); //@line 2431 "translate.cpp"
          var $cmp31=((($conv30))|0)!=0; //@line 2431 "translate.cpp"
          if (!($cmp31)) { __label__ = 17;break $for_cond29$22; } //@line 2431 "translate.cpp"
  
          var $34=$p; //@line 2433 "translate.cpp"
          var $35=HEAP8[($34)]; //@line 2433 "translate.cpp"
          var $conv33=(tempInt=(($35)),(tempInt>=128?tempInt-256:tempInt)); //@line 2433 "translate.cpp"
          var $call34=__Z8isspace2j($conv33); //@line 2433 "translate.cpp"
          var $tobool35=((($call34))|0)!=0; //@line 2433 "translate.cpp"
          if (!($tobool35)) { __label__ = 17;break $for_cond29$22; } //@line 2433 "translate.cpp"
  
          var $36=$p; //@line 2431 "translate.cpp"
          var $incdec_ptr39=(($36+1)&4294967295); //@line 2431 "translate.cpp"
          $p=$incdec_ptr39; //@line 2431 "translate.cpp"
          __label__ = 14;continue $for_cond29$22; //@line 2431 "translate.cpp"
        }
  
        var $37=$p; //@line 2438 "translate.cpp"
        var $38=HEAP8[($37)]; //@line 2438 "translate.cpp"
        var $conv41=(tempInt=(($38)),(tempInt>=128?tempInt-256:tempInt)); //@line 2438 "translate.cpp"
        var $cmp42=((($conv41))|0)==0; //@line 2438 "translate.cpp"
        if ($cmp42) { __label__ = 18;; } else { __label__ = 21;; } //@line 2438 "translate.cpp"
        if (__label__ == 18) {
  
          var $39=HEAP32[((__ZL16max_clause_pause)>>2)]; //@line 2442 "translate.cpp"
          var $40=$clause_pause; //@line 2442 "translate.cpp"
          var $sub=((($40)-($39))&4294967295); //@line 2442 "translate.cpp"
          $clause_pause=$sub; //@line 2442 "translate.cpp"
          var $41=$clause_pause; //@line 2443 "translate.cpp"
          var $cmp44=((($41))|0) < 0; //@line 2443 "translate.cpp"
          if ($cmp44) { __label__ = 19;; } else { __label__ = 20;; } //@line 2443 "translate.cpp"
          if (__label__ == 19) {
  
            $clause_pause=0; //@line 2444 "translate.cpp"
            ; //@line 2444 "translate.cpp"
          }
  
          var $42=$terminator; //@line 2446 "translate.cpp"
          var $and47=($42) & -524289; //@line 2446 "translate.cpp"
          $terminator=$and47; //@line 2446 "translate.cpp"
          var $43=$clause_pause; //@line 2447 "translate.cpp"
          var $44=HEAP32[((__ZL16max_clause_pause)>>2)]; //@line 2447 "translate.cpp"
          var $add48=((($44)+($43))&4294967295); //@line 2447 "translate.cpp"
          HEAP32[((__ZL16max_clause_pause)>>2)]=$add48; //@line 2447 "translate.cpp"
          ; //@line 2448 "translate.cpp"
        }
        else if (__label__ == 21) {
  
          var $45=$clause_pause; //@line 2451 "translate.cpp"
          HEAP32[((__ZL16max_clause_pause)>>2)]=$45; //@line 2451 "translate.cpp"
          ;
        }
  
        var $46=$terminator; //@line 2453 "translate.cpp"
        var $47=$tr_addr; //@line 2453 "translate.cpp"
        var $clause_terminator=(($47+8324)&4294967295); //@line 2453 "translate.cpp"
        HEAP32[(($clause_terminator)>>2)]=$46; //@line 2453 "translate.cpp"
        var $48=HEAP32[((_new_sentence)>>2)]; //@line 2455 "translate.cpp"
        var $tobool50=((($48))|0)!=0; //@line 2455 "translate.cpp"
        if ($tobool50) { __label__ = 23;; } else { __label__ = 26;; } //@line 2455 "translate.cpp"
        $if_then51$$if_end59$34: do { 
          if (__label__ == 23) {
  
            var $49=HEAP32[((_count_sentences)>>2)]; //@line 2457 "translate.cpp"
            var $inc52=((($49)+1)&4294967295); //@line 2457 "translate.cpp"
            HEAP32[((_count_sentences)>>2)]=$inc52; //@line 2457 "translate.cpp"
            var $50=HEAP32[((_skip_sentences)>>2)]; //@line 2458 "translate.cpp"
            var $cmp53=((($50))|0) > 0; //@line 2458 "translate.cpp"
            if (!($cmp53)) { __label__ = 26;break $if_then51$$if_end59$34; } //@line 2458 "translate.cpp"
  
            var $51=HEAP32[((_skip_sentences)>>2)]; //@line 2460 "translate.cpp"
            var $dec=((($51)-1)&4294967295); //@line 2460 "translate.cpp"
            HEAP32[((_skip_sentences)>>2)]=$dec; //@line 2460 "translate.cpp"
            var $52=HEAP32[((_skip_sentences)>>2)]; //@line 2461 "translate.cpp"
            var $cmp55=((($52))|0)==0; //@line 2461 "translate.cpp"
            if (!($cmp55)) { __label__ = 26;break $if_then51$$if_end59$34; } //@line 2461 "translate.cpp"
  
            HEAP32[((_skipping_text)>>2)]=0; //@line 2462 "translate.cpp"
            ; //@line 2462 "translate.cpp"
          }
        } while(0);
  
        var $dest$, $stop$, $stop4$, $fast$, $value4$;
        $dest$ = ((_ph_list2)&4294967295);
        $stop$ = $dest$ + 8;
        $value4$ = 0;
        if ($value4$ < 0) $value4$ += 256;
        $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
        while ($dest$%4 !== 0 && $dest$ < $stop$) {
          ;; HEAP8[$dest$++] = 0;
        }
        $dest$ >>= 2;
        $stop4$ = $stop$ >> 2;
        while ($dest$ < $stop4$) {
        ;;;;;;;  HEAP32[$dest$++] = $value4$;
        }
        $dest$ <<= 2;
        while ($dest$ < $stop$) {
          ;; HEAP8[$dest$++] = 0;
        }; //@line 2466 "translate.cpp"
        HEAP8[(((_ph_list2)&4294967295))]=10; //@line 2467 "translate.cpp"
        HEAP32[((_n_ph_list2)>>2)]=1; //@line 2469 "translate.cpp"
        var $53=$tr_addr; //@line 2470 "translate.cpp"
        var $prev_last_stress=(($53+8288)&4294967295); //@line 2470 "translate.cpp"
        HEAP32[(($prev_last_stress)>>2)]=0; //@line 2470 "translate.cpp"
        var $54=$tr_addr; //@line 2471 "translate.cpp"
        var $prepause_timeout=(($54+8312)&4294967295); //@line 2471 "translate.cpp"
        HEAP32[(($prepause_timeout)>>2)]=0; //@line 2471 "translate.cpp"
        var $55=$tr_addr; //@line 2472 "translate.cpp"
        var $expect_verb=(($55+8272)&4294967295); //@line 2472 "translate.cpp"
        HEAP32[(($expect_verb)>>2)]=0; //@line 2472 "translate.cpp"
        var $56=$tr_addr; //@line 2473 "translate.cpp"
        var $expect_noun=(($56+8284)&4294967295); //@line 2473 "translate.cpp"
        HEAP32[(($expect_noun)>>2)]=0; //@line 2473 "translate.cpp"
        var $57=$tr_addr; //@line 2474 "translate.cpp"
        var $expect_past=(($57+8276)&4294967295); //@line 2474 "translate.cpp"
        HEAP32[(($expect_past)>>2)]=0; //@line 2474 "translate.cpp"
        var $58=$tr_addr; //@line 2475 "translate.cpp"
        var $expect_verb_s=(($58+8280)&4294967295); //@line 2475 "translate.cpp"
        HEAP32[(($expect_verb_s)>>2)]=0; //@line 2475 "translate.cpp"
        var $59=$tr_addr; //@line 2476 "translate.cpp"
        var $phonemes_repeat_count=(($59+652)&4294967295); //@line 2476 "translate.cpp"
        HEAP32[(($phonemes_repeat_count)>>2)]=0; //@line 2476 "translate.cpp"
        var $60=$tr_addr; //@line 2477 "translate.cpp"
        var $end_stressed_vowel=(($60+8316)&4294967295); //@line 2477 "translate.cpp"
        HEAP32[(($end_stressed_vowel)>>2)]=0; //@line 2477 "translate.cpp"
        var $61=$tr_addr; //@line 2478 "translate.cpp"
        var $prev_dict_flags=(($61+8320)&4294967295); //@line 2478 "translate.cpp"
        HEAP32[(($prev_dict_flags)>>2)]=0; //@line 2478 "translate.cpp"
        $word_count=0; //@line 2480 "translate.cpp"
        $single_quoted=0; //@line 2481 "translate.cpp"
        $word_flags=0; //@line 2482 "translate.cpp"
        $next_word_flags=0; //@line 2483 "translate.cpp"
        var $arrayidx60=(($sbuf)&4294967295); //@line 2485 "translate.cpp"
        HEAP8[($arrayidx60)]=0; //@line 2485 "translate.cpp"
        var $arrayidx61=(($sbuf+1)&4294967295); //@line 2486 "translate.cpp"
        HEAP8[($arrayidx61)]=32; //@line 2486 "translate.cpp"
        var $arrayidx62=(($sbuf+2)&4294967295); //@line 2487 "translate.cpp"
        HEAP8[($arrayidx62)]=32; //@line 2487 "translate.cpp"
        $ix=3; //@line 2488 "translate.cpp"
        HEAP32[(($prev_in)>>2)]=32; //@line 2489 "translate.cpp"
        var $62=$ix; //@line 2491 "translate.cpp"
        var $conv63=((($62)) & 65535); //@line 2491 "translate.cpp"
        var $arrayidx64=(($words)&4294967295); //@line 2491 "translate.cpp"
        var $start=(($arrayidx64+4)&4294967295); //@line 2491 "translate.cpp"
        HEAP16[(($start)>>1)]=$conv63; //@line 2491 "translate.cpp"
        var $arrayidx65=(($words)&4294967295); //@line 2492 "translate.cpp"
        var $flags=(($arrayidx65)&4294967295); //@line 2492 "translate.cpp"
        HEAP32[(($flags)>>2)]=0; //@line 2492 "translate.cpp"
        $finished=0; //@line 2493 "translate.cpp"
        $j=0; //@line 2495 "translate.cpp"
        var $63=$j; //@line 2495 "translate.cpp"
        var $arrayidx6755=(($charix+$63*2)&4294967295); //@line 2495 "translate.cpp"
        var $64=HEAP16[(($arrayidx6755)>>1)]; //@line 2495 "translate.cpp"
        var $conv6856=(tempInt=(($64)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 2495 "translate.cpp"
        var $cmp6957=((($conv6856))|0) <= 0; //@line 2495 "translate.cpp"
        var $65=$j; //@line 2495 "translate.cpp"
        if ($cmp6957) { __lastLabel__ = 26; __label__ = 27;; } else { __lastLabel__ = 26; __label__ = 28;; } //@line 2495 "translate.cpp"
        $for_inc71$$for_end73$39: do { 
          if (__label__ == 27) {
            while(1) { 
  
              var $66=__lastLabel__ == 27 ? $69 : ($65);
              var $inc72=((($66)+1)&4294967295); //@line 2495 "translate.cpp"
              $j=$inc72; //@line 2495 "translate.cpp"
              var $67=$j; //@line 2495 "translate.cpp"
              var $arrayidx67=(($charix+$67*2)&4294967295); //@line 2495 "translate.cpp"
              var $68=HEAP16[(($arrayidx67)>>1)]; //@line 2495 "translate.cpp"
              var $conv68=(tempInt=(($68)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 2495 "translate.cpp"
              var $cmp69=((($conv68))|0) <= 0; //@line 2495 "translate.cpp"
              var $69=$j; //@line 2495 "translate.cpp"
              if ($cmp69) { __lastLabel__ = 27; __label__ = 27;continue ; } else { __lastLabel__ = 27; __label__ = 28;break $for_inc71$$for_end73$39; } //@line 2495 "translate.cpp"
            }
          }
        } while(0);
  
        var $_lcssa54=__lastLabel__ == 26 ? $65 : ($69);
        var $arrayidx74=(($charix+$_lcssa54*2)&4294967295); //@line 2496 "translate.cpp"
        var $70=HEAP16[(($arrayidx74)>>1)]; //@line 2496 "translate.cpp"
        var $arrayidx75=(($words)&4294967295); //@line 2496 "translate.cpp"
        var $sourceix=(($arrayidx75+6)&4294967295); //@line 2496 "translate.cpp"
        HEAP16[(($sourceix)>>1)]=$70; //@line 2496 "translate.cpp"
        $k=0; //@line 2497 "translate.cpp"
        var $71=$j; //@line 2498 "translate.cpp"
        var $arrayidx7651=(($charix+$71*2)&4294967295); //@line 2498 "translate.cpp"
        var $72=HEAP16[(($arrayidx7651)>>1)]; //@line 2498 "translate.cpp"
        var $conv7752=(tempInt=(($72)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 2498 "translate.cpp"
        var $cmp7853=((($conv7752))|0)!=0; //@line 2498 "translate.cpp"
        if ($cmp7853) { __label__ = 29;; } else { __label__ = 32;; } //@line 2498 "translate.cpp"
        $while_body$$while_end$43: do { 
          if (__label__ == 29) {
            while(1) { 
  
              var $73=$j; //@line 2501 "translate.cpp"
              var $inc79=((($73)+1)&4294967295); //@line 2501 "translate.cpp"
              $j=$inc79; //@line 2501 "translate.cpp"
              var $arrayidx80=(($charix+$73*2)&4294967295); //@line 2501 "translate.cpp"
              var $74=HEAP16[(($arrayidx80)>>1)]; //@line 2501 "translate.cpp"
              var $conv81=(tempInt=(($74)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 2501 "translate.cpp"
              var $cmp82=((($conv81))|0)!=-1; //@line 2501 "translate.cpp"
              if ($cmp82) { __label__ = 30;; } else { __label__ = 31;; } //@line 2501 "translate.cpp"
              if (__label__ == 30) {
  
                var $75=$k; //@line 2502 "translate.cpp"
                var $inc84=((($75)+1)&4294967295); //@line 2502 "translate.cpp"
                $k=$inc84; //@line 2502 "translate.cpp"
                ; //@line 2502 "translate.cpp"
              }
  
              var $76=$j; //@line 2498 "translate.cpp"
              var $arrayidx76=(($charix+$76*2)&4294967295); //@line 2498 "translate.cpp"
              var $77=HEAP16[(($arrayidx76)>>1)]; //@line 2498 "translate.cpp"
              var $conv77=(tempInt=(($77)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 2498 "translate.cpp"
              var $cmp78=((($conv77))|0)!=0; //@line 2498 "translate.cpp"
              if ($cmp78) { __label__ = 29;continue ; } else { __label__ = 32;break $while_body$$while_end$43; } //@line 2498 "translate.cpp"
            }
          }
        } while(0);
  
        var $78=$k; //@line 2504 "translate.cpp"
        var $conv86=((($78)) & 255); //@line 2504 "translate.cpp"
        var $arrayidx87=(($words)&4294967295); //@line 2504 "translate.cpp"
        var $length=(($arrayidx87+10)&4294967295); //@line 2504 "translate.cpp"
        HEAP8[($length)]=$conv86; //@line 2504 "translate.cpp"
        ; //@line 2506 "translate.cpp"
        $while_cond88$50: while(1) { 
  
          var $79=$finished; //@line 2506 "translate.cpp"
          var $tobool89=((($79))|0)!=0; //@line 2506 "translate.cpp"
          if ($tobool89) { __label__ = 230;break $while_cond88$50; } //@line 2506 "translate.cpp"
  
          var $80=$ix; //@line 2506 "translate.cpp"
          var $cmp91=((($80))|0) < 700; //@line 2506 "translate.cpp"
          var $81=HEAP32[((_n_ph_list2)>>2)]; //@line 2506 "translate.cpp"
          var $cmp92=((($81))|0) < 996; //@line 2506 "translate.cpp"
          var $or_cond12=($cmp91) & ($cmp92); //@line 2506 "translate.cpp"
          if (!($or_cond12)) { __label__ = 230;break $while_cond88$50; } //@line 2506 "translate.cpp"
  
          var $82=HEAP32[(($prev_out)>>2)]; //@line 2508 "translate.cpp"
          $prev_out2=$82; //@line 2508 "translate.cpp"
          var $83=$ix; //@line 2509 "translate.cpp"
          var $sub94=((($83)-1)&4294967295); //@line 2509 "translate.cpp"
          var $arrayidx95=(($sbuf+$sub94)&4294967295); //@line 2509 "translate.cpp"
          var $call96=__Z8utf8_in2PiPKci($prev_out, $arrayidx95, 1); //@line 2509 "translate.cpp"
          var $84=$tr_addr; //@line 2511 "translate.cpp"
          var $langopts=(($84)&4294967295); //@line 2511 "translate.cpp"
          var $tone_numbers=(($langopts+250)&4294967295); //@line 2511 "translate.cpp"
          var $85=HEAP8[($tone_numbers)]; //@line 2511 "translate.cpp"
          var $tobool97=(tempInt=(($85)),(tempInt>=128?tempInt-256:tempInt))!=0; //@line 2511 "translate.cpp"
          if ($tobool97) { __label__ = 36;; } else { __label__ = 39;; } //@line 2511 "translate.cpp"
          $land_lhs_true98$$if_end105$54: do { 
            if (__label__ == 36) {
  
              var $86=HEAP32[(($prev_out)>>2)]; //@line 2511 "translate.cpp"
              var $call99=__ZL9IsDigit09j($86); //@line 2511 "translate.cpp"
              var $tobool100=((($call99))|0)!=0; //@line 2511 "translate.cpp"
              if (!($tobool100)) { __label__ = 39;break $land_lhs_true98$$if_end105$54; } //@line 2511 "translate.cpp"
  
              var $87=$prev_out2; //@line 2511 "translate.cpp"
              var $call102=__Z7IsAlphaj($87); //@line 2511 "translate.cpp"
              var $tobool103=((($call102))|0)!=0; //@line 2511 "translate.cpp"
              if (!($tobool103)) { __label__ = 39;break $land_lhs_true98$$if_end105$54; } //@line 2511 "translate.cpp"
  
              HEAP32[(($prev_out)>>2)]=97; //@line 2514 "translate.cpp"
              ; //@line 2515 "translate.cpp"
            }
          } while(0);
  
          var $88=$prev_in_save; //@line 2517 "translate.cpp"
          var $cmp106=((($88))|0)!=0; //@line 2517 "translate.cpp"
          if ($cmp106) { __label__ = 40;; } else { __label__ = 41;; } //@line 2517 "translate.cpp"
          $if_then107$$if_else108$59: do { 
            if (__label__ == 40) {
  
              var $89=$prev_in_save; //@line 2519 "translate.cpp"
              HEAP32[(($prev_in)>>2)]=$89; //@line 2519 "translate.cpp"
              $prev_in_save=0; //@line 2520 "translate.cpp"
              ; //@line 2521 "translate.cpp"
            }
            else if (__label__ == 41) {
  
              var $90=HEAPU32[(($source_index)>>2)]; //@line 2523 "translate.cpp"
              var $cmp109=((($90))>>>0) > 0; //@line 2523 "translate.cpp"
              if (!($cmp109)) { __label__ = 43;break $if_then107$$if_else108$59; } //@line 2523 "translate.cpp"
  
              var $91=HEAP32[(($prev_in)>>2)]; //@line 2525 "translate.cpp"
              $prev_in2=$91; //@line 2525 "translate.cpp"
              var $92=HEAP32[(($source_index)>>2)]; //@line 2526 "translate.cpp"
              var $sub111=((($92)-1)&4294967295); //@line 2526 "translate.cpp"
              var $arrayidx112=((__ZL6source+$sub111)&4294967295); //@line 2526 "translate.cpp"
              var $call113=__Z8utf8_in2PiPKci($prev_in, $arrayidx112, 1); //@line 2526 "translate.cpp"
              ; //@line 2527 "translate.cpp"
            }
          } while(0);
  
          var $93=HEAP32[(($source_index)>>2)]; //@line 2529 "translate.cpp"
          $prev_source_index=$93; //@line 2529 "translate.cpp"
          var $94=HEAP32[(($char_inserted)>>2)]; //@line 2531 "translate.cpp"
          var $tobool116=((($94))|0)!=0; //@line 2531 "translate.cpp"
          if ($tobool116) { __label__ = 44;; } else { __label__ = 45;; } //@line 2531 "translate.cpp"
          if (__label__ == 44) {
  
            var $95=HEAP32[(($char_inserted)>>2)]; //@line 2533 "translate.cpp"
            $c=$95; //@line 2533 "translate.cpp"
            HEAP32[(($char_inserted)>>2)]=0; //@line 2534 "translate.cpp"
            ; //@line 2535 "translate.cpp"
          }
          else if (__label__ == 45) {
  
            var $96=HEAP32[(($source_index)>>2)]; //@line 2538 "translate.cpp"
            var $arrayidx119=((__ZL6source+$96)&4294967295); //@line 2538 "translate.cpp"
            var $call120=__Z7utf8_inPiPKc($cc, $arrayidx119); //@line 2538 "translate.cpp"
            var $97=HEAP32[(($source_index)>>2)]; //@line 2538 "translate.cpp"
            var $add121=((($97)+($call120))&4294967295); //@line 2538 "translate.cpp"
            HEAP32[(($source_index)>>2)]=$add121; //@line 2538 "translate.cpp"
            var $98=HEAP32[(($cc)>>2)]; //@line 2539 "translate.cpp"
            $c=$98; //@line 2539 "translate.cpp"
            ;
          }
  
          var $99=HEAP32[(($source_index)>>2)]; //@line 2541 "translate.cpp"
          var $arrayidx123=((__ZL6source+$99)&4294967295); //@line 2541 "translate.cpp"
          var $call124=__Z7utf8_inPiPKc($next_in, $arrayidx123); //@line 2541 "translate.cpp"
          $next_in_nbytes=$call124; //@line 2541 "translate.cpp"
          var $100=$c; //@line 2543 "translate.cpp"
          if ($100 == 0) {
            __label__ = 47;;
          }
          else if ($100 == 1) {
            __label__ = 49;;
          }
          else {
          __label__ = 48;;
          }
          
          $lor_lhs_false$$if_end127_thread$$if_then131$68: do { 
            if (__label__ == 47) {
  
              $finished=1; //@line 2545 "translate.cpp"
              $c=32; //@line 2546 "translate.cpp"
              __label__ = 48;break $lor_lhs_false$$if_end127_thread$$if_then131$68; //@line 2549 "translate.cpp"
            }
          } while(0);
          $lor_lhs_false$$if_then131$70: do { 
            if (__label__ == 48) {
  
              var $101=$c; //@line 2549 "translate.cpp"
              var $102=HEAP8[(_ctrl_embedded)]; //@line 2549 "translate.cpp"
              var $conv129=(tempInt=(($102)),(tempInt>=128?tempInt-256:tempInt)); //@line 2549 "translate.cpp"
              var $cmp130=((($101))|0)==((($conv129))|0); //@line 2549 "translate.cpp"
              if ($cmp130) { __label__ = 49;break $lor_lhs_false$$if_then131$70; } else { __label__ = 52;break $lor_lhs_false$$if_then131$70; } //@line 2549 "translate.cpp"
            }
          } while(0);
          if (__label__ == 49) {
  
            var $103=HEAP32[(($source_index)>>2)]; //@line 2552 "translate.cpp"
            var $sub132=((($103)-1)&4294967295); //@line 2552 "translate.cpp"
            $srcix=$sub132; //@line 2552 "translate.cpp"
            var $104=HEAP32[(($prev_in)>>2)]; //@line 2554 "translate.cpp"
            var $cmp133=((($104))|0)!=32; //@line 2554 "translate.cpp"
            if ($cmp133) { __label__ = 50;; } else { __label__ = 51;; } //@line 2554 "translate.cpp"
            if (__label__ == 50) {
  
              $c=32; //@line 2556 "translate.cpp"
              var $105=$c; //@line 2557 "translate.cpp"
              $prev_in_save=$105; //@line 2557 "translate.cpp"
              var $106=HEAP32[(($source_index)>>2)]; //@line 2558 "translate.cpp"
              var $dec135=((($106)-1)&4294967295); //@line 2558 "translate.cpp"
              HEAP32[(($source_index)>>2)]=$dec135; //@line 2558 "translate.cpp"
              ; //@line 2569 "translate.cpp"
            }
            else if (__label__ == 51) {
  
              var $call137=__ZL15EmbeddedCommandRj($source_index); //@line 2562 "translate.cpp"
              var $107=$embedded_count; //@line 2562 "translate.cpp"
              var $add138=((($107)+($call137))&4294967295); //@line 2562 "translate.cpp"
              $embedded_count=$add138; //@line 2562 "translate.cpp"
              var $108=HEAP32[(($prev_in)>>2)]; //@line 2563 "translate.cpp"
              $prev_in_save=$108; //@line 2563 "translate.cpp"
              var $109=$srcix; //@line 2565 "translate.cpp"
              var $arrayidx139=((__ZL6source+$109)&4294967295); //@line 2565 "translate.cpp"
              var $110=HEAP32[(($source_index)>>2)]; //@line 2565 "translate.cpp"
              var $111=$srcix; //@line 2565 "translate.cpp"
              var $sub140=((($110)-($111))&4294967295); //@line 2565 "translate.cpp"
              var $dest$, $stop$, $stop4$, $fast$, $value4$;
              $dest$ = $arrayidx139;
              $stop$ = $dest$ + $sub140;
              $value4$ = 32;
              if ($value4$ < 0) $value4$ += 256;
              $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
              while ($dest$%4 !== 0 && $dest$ < $stop$) {
                ;; HEAP8[$dest$++] = 32;
              }
              $dest$ >>= 2;
              $stop4$ = $stop$ >> 2;
              while ($dest$ < $stop4$) {
              ;;;;;;;  HEAP32[$dest$++] = $value4$;
              }
              $dest$ <<= 2;
              while ($dest$ < $stop$) {
                ;; HEAP8[$dest$++] = 32;
              }; //@line 2565 "translate.cpp"
              var $112=$srcix; //@line 2566 "translate.cpp"
              HEAP32[(($source_index)>>2)]=$112; //@line 2566 "translate.cpp"
              __label__ = 33;continue $while_cond88$50; //@line 2567 "translate.cpp"
            }
          }
  
          var $113=HEAP32[((__ZL13option_sayas2)>>2)]; //@line 2571 "translate.cpp"
          var $cmp143=((($113))|0)==36; //@line 2571 "translate.cpp"
          if ($cmp143) { __label__ = 53;; } else { __label__ = 58;; } //@line 2571 "translate.cpp"
          $land_lhs_true144$$if_end153$78: do { 
            if (__label__ == 53) {
  
              var $114=$c; //@line 2571 "translate.cpp"
              var $cmp145=((($114))|0)!=32; //@line 2571 "translate.cpp"
              if (!($cmp145)) { __label__ = 58;break $land_lhs_true144$$if_end153$78; } //@line 2571 "translate.cpp"
  
              var $115=HEAP32[(($prev_in)>>2)]; //@line 2573 "translate.cpp"
              var $cmp147=((($115))|0)==32; //@line 2573 "translate.cpp"
              if ($cmp147) { __label__ = 55;; } else { __label__ = 57;; } //@line 2573 "translate.cpp"
              $land_lhs_true148$$if_end151$81: do { 
                if (__label__ == 55) {
  
                  var $116=HEAP32[(($next_in)>>2)]; //@line 2573 "translate.cpp"
                  var $cmp149=((($116))|0)==32; //@line 2573 "translate.cpp"
                  if (!($cmp149)) { __label__ = 57;break $land_lhs_true148$$if_end151$81; } //@line 2573 "translate.cpp"
  
                  HEAP32[((__ZL13option_sayas2)>>2)]=20; //@line 2574 "translate.cpp"
                  ; //@line 2574 "translate.cpp"
                }
              } while(0);
  
              var $117=$c; //@line 2575 "translate.cpp"
              var $call152=__Z9towlower2j($117); //@line 2575 "translate.cpp"
              $c=$call152; //@line 2575 "translate.cpp"
              ; //@line 2576 "translate.cpp"
            }
          } while(0);
  
          var $118=$phoneme_mode; //@line 2579 "translate.cpp"
          var $tobool154=((($118))|0)!=0; //@line 2579 "translate.cpp"
          if ($tobool154) { __label__ = 59;; } else { __label__ = 62;; } //@line 2579 "translate.cpp"
          $if_then155$$if_else162$86: do { 
            if (__label__ == 59) {
  
              $all_upper_case=8; //@line 2581 "translate.cpp"
              var $119=$c; //@line 2583 "translate.cpp"
              var $cmp156=((($119))|0)==93; //@line 2583 "translate.cpp"
              if (!($cmp156)) { __label__ = 195;break $if_then155$$if_else162$86; } //@line 2583 "translate.cpp"
  
              var $120=HEAP32[(($next_in)>>2)]; //@line 2583 "translate.cpp"
              var $cmp158=((($120))|0)==93; //@line 2583 "translate.cpp"
              if (!($cmp158)) { __label__ = 195;break $if_then155$$if_else162$86; } //@line 2583 "translate.cpp"
  
              $phoneme_mode=0; //@line 2585 "translate.cpp"
              var $121=HEAP32[(($source_index)>>2)]; //@line 2586 "translate.cpp"
              var $inc160=((($121)+1)&4294967295); //@line 2586 "translate.cpp"
              HEAP32[(($source_index)>>2)]=$inc160; //@line 2586 "translate.cpp"
              $c=32; //@line 2587 "translate.cpp"
              ; //@line 2588 "translate.cpp"
            }
            else if (__label__ == 62) {
  
              var $122=HEAP32[((__ZL13option_sayas2)>>2)]; //@line 2591 "translate.cpp"
              var $and163=($122) & 240; //@line 2591 "translate.cpp"
              var $cmp164=((($and163))|0)==64; //@line 2591 "translate.cpp"
              if ($cmp164) { __label__ = 63;; } else { __label__ = 68;; } //@line 2591 "translate.cpp"
              if (__label__ == 63) {
  
                var $123=$c; //@line 2593 "translate.cpp"
                var $call166=_iswdigit($123); //@line 2593 "translate.cpp"
                var $tobool167=((($call166))|0)!=0; //@line 2593 "translate.cpp"
                if ($tobool167) { __label__ = 64;; } else { __label__ = 66;; } //@line 2593 "translate.cpp"
                if (__label__ == 64) {
  
                  var $124=HEAP32[((__ZL18count_sayas_digits)>>2)]; //@line 2595 "translate.cpp"
                  var $inc169=((($124)+1)&4294967295); //@line 2595 "translate.cpp"
                  HEAP32[((__ZL18count_sayas_digits)>>2)]=$inc169; //@line 2595 "translate.cpp"
                  var $125=HEAP32[((__ZL18count_sayas_digits)>>2)]; //@line 2596 "translate.cpp"
                  var $126=HEAP32[((__ZL13option_sayas2)>>2)]; //@line 2596 "translate.cpp"
                  var $and170=($126) & 15; //@line 2596 "translate.cpp"
                  var $cmp171=((($125))|0) > ((($and170))|0); //@line 2596 "translate.cpp"
                  if (!($cmp171)) { __label__ = 195;break $if_then155$$if_else162$86; } //@line 2596 "translate.cpp"
  
                  $c=32; //@line 2599 "translate.cpp"
                  $space_inserted=1; //@line 2600 "translate.cpp"
                  HEAP32[((__ZL18count_sayas_digits)>>2)]=0; //@line 2601 "translate.cpp"
                  ; //@line 2602 "translate.cpp"
                }
                else if (__label__ == 66) {
  
                  HEAP32[((__ZL18count_sayas_digits)>>2)]=0; //@line 2606 "translate.cpp"
                  var $127=HEAP32[(($prev_out)>>2)]; //@line 2607 "translate.cpp"
                  var $call175=_iswdigit($127); //@line 2607 "translate.cpp"
                  var $tobool176=((($call175))|0)!=0; //@line 2607 "translate.cpp"
                  if (!($tobool176)) { __label__ = 195;break $if_then155$$if_else162$86; } //@line 2607 "translate.cpp"
  
                  $c=32; //@line 2609 "translate.cpp"
                  $space_inserted=1; //@line 2610 "translate.cpp"
                  ; //@line 2611 "translate.cpp"
                }
              }
              else if (__label__ == 68) {
  
                var $128=HEAP32[((__ZL13option_sayas2)>>2)]; //@line 2615 "translate.cpp"
                var $and181=($128) & 16; //@line 2615 "translate.cpp"
                var $cmp182=((($and181))|0)==0; //@line 2615 "translate.cpp"
                if (!($cmp182)) { __label__ = 195;break $if_then155$$if_else162$86; } //@line 2615 "translate.cpp"
  
                var $129=$c; //@line 2628 "translate.cpp"
                var $cmp184=((($129))|0)==146; //@line 2628 "translate.cpp"
                var $130=$c; //@line 2628 "translate.cpp"
                var $cmp186=((($130))|0)==180; //@line 2628 "translate.cpp"
                var $or_cond=($cmp184) | ($cmp186); //@line 2628 "translate.cpp"
                var $131=$c; //@line 2628 "translate.cpp"
                var $cmp188=((($131))|0)==8217; //@line 2628 "translate.cpp"
                var $or_cond2=($or_cond) | ($cmp188); //@line 2628 "translate.cpp"
                var $132=$c; //@line 2628 "translate.cpp"
                var $cmp190=((($132))|0)==8242; //@line 2628 "translate.cpp"
                var $or_cond3=($or_cond2) | ($cmp190); //@line 2628 "translate.cpp"
                if ($or_cond3) { __label__ = 70;; } else { __label__ = 71;; } //@line 2628 "translate.cpp"
                if (__label__ == 70) {
  
                  $c=39; //@line 2629 "translate.cpp"
                  ; //@line 2629 "translate.cpp"
                }
  
                var $133=$c; //@line 2631 "translate.cpp"
                var $cmp193=((($133))|0)==8216; //@line 2631 "translate.cpp"
                var $134=$c; //@line 2631 "translate.cpp"
                var $cmp195=((($134))|0)==63; //@line 2631 "translate.cpp"
                var $or_cond4=($cmp193) | ($cmp195); //@line 2631 "translate.cpp"
                if ($or_cond4) { __lastLabel__ = 71; __label__ = 72;; } else { __lastLabel__ = 71; __label__ = 76;; } //@line 2631 "translate.cpp"
                $land_lhs_true196$$if_end203$103: do { 
                  if (__label__ == 72) {
  
                    var $135=HEAP32[(($prev_out)>>2)]; //@line 2631 "translate.cpp"
                    var $call197=__Z7IsAlphaj($135); //@line 2631 "translate.cpp"
                    var $tobool198=((($call197))|0)!=0; //@line 2631 "translate.cpp"
                    if ($tobool198) { __label__ = 73;; } else { __label__ = 75;; } //@line 2631 "translate.cpp"
                    $land_lhs_true199$$if_end203thread_pre_split$105: do { 
                      if (__label__ == 73) {
  
                        var $136=HEAP32[(($next_in)>>2)]; //@line 2631 "translate.cpp"
                        var $call200=__Z7IsAlphaj($136); //@line 2631 "translate.cpp"
                        var $tobool201=((($call200))|0)!=0; //@line 2631 "translate.cpp"
                        if (!($tobool201)) { __label__ = 75;break $land_lhs_true199$$if_end203thread_pre_split$105; } //@line 2631 "translate.cpp"
  
                        $c=39; //@line 2634 "translate.cpp"
                        __label__ = 80;break $land_lhs_true196$$if_end203$103; //@line 2644 "translate.cpp"
                      }
                    } while(0);
  
                    var $_pr=$c; //@line 2637 "translate.cpp"
                    __lastLabel__ = 75; __label__ = 76;break $land_lhs_true196$$if_end203$103;
                  }
                } while(0);
                $if_end210$$if_end203$109: do { 
                  if (__label__ == 76) {
  
                    var $137=__lastLabel__ == 75 ? $_pr : ($134); //@line 2637 "translate.cpp"
                    var $cmp204=((($137))|0)==1328; //@line 2637 "translate.cpp"
                    if ($cmp204) { __label__ = 77;; } else { __label__ = 78;; } //@line 2637 "translate.cpp"
                    if (__label__ == 77) {
  
                      $c=32; //@line 2640 "translate.cpp"
                      var $138=$word_flags; //@line 2641 "translate.cpp"
                      var $or=($138) | 1024; //@line 2641 "translate.cpp"
                      $word_flags=$or; //@line 2641 "translate.cpp"
                      ; //@line 2644 "translate.cpp"
                    }
                    else if (__label__ == 78) {
  
                      var $_pr15_pr=$c; //@line 2644 "translate.cpp"
                      var $cmp207=((($_pr15_pr))|0)==1367; //@line 2644 "translate.cpp"
                      if (!($cmp207)) { __label__ = 80;break $if_end210$$if_end203$109; } //@line 2644 "translate.cpp"
  
                      $c=32; //@line 2646 "translate.cpp"
                      var $139=$word_flags; //@line 2647 "translate.cpp"
                      var $or209=($139) | 131072; //@line 2647 "translate.cpp"
                      $word_flags=$or209; //@line 2647 "translate.cpp"
                      ; //@line 2648 "translate.cpp"
                    }
                  }
                } while(0);
  
                var $140=$tr_addr; //@line 2650 "translate.cpp"
                var $141=HEAP32[(($source_index)>>2)]; //@line 2650 "translate.cpp"
                var $arrayidx211=((__ZL6source+$141)&4294967295); //@line 2650 "translate.cpp"
                var $142=HEAP32[(($prev_in)>>2)]; //@line 2650 "translate.cpp"
                var $143=$c; //@line 2650 "translate.cpp"
                var $144=HEAP32[(($next_in)>>2)]; //@line 2650 "translate.cpp"
                var $call212=__ZL13TranslateCharP10TranslatorPcijjPi($140, $arrayidx211, $142, $143, $144, $char_inserted); //@line 2650 "translate.cpp"
                $c=$call212; //@line 2650 "translate.cpp"
                var $cmp213=((($call212))|0)==8; //@line 2651 "translate.cpp"
                if ($cmp213) { __label__ = 33;continue $while_cond88$50; } //@line 2651 "translate.cpp"
  
                var $145=HEAP32[(($char_inserted)>>2)]; //@line 2654 "translate.cpp"
                var $tobool216=((($145))|0)!=0; //@line 2654 "translate.cpp"
                if ($tobool216) { __label__ = 82;; } else { __label__ = 83;; } //@line 2654 "translate.cpp"
                if (__label__ == 82) {
  
                  var $146=HEAP32[(($char_inserted)>>2)]; //@line 2655 "translate.cpp"
                  HEAP32[(($next_in)>>2)]=$146; //@line 2655 "translate.cpp"
                  ; //@line 2655 "translate.cpp"
                }
  
                var $147=$c; //@line 2658 "translate.cpp"
                var $call219=__Z7IsAlphaj($147); //@line 2658 "translate.cpp"
                var $tobool220=((($call219))|0)!=0; //@line 2658 "translate.cpp"
                if ($tobool220) { __label__ = 91;; } else { __label__ = 84;; } //@line 2658 "translate.cpp"
                $if_end244$$land_lhs_true221$120: do { 
                  if (__label__ == 84) {
  
                    var $148=$c; //@line 2658 "translate.cpp"
                    var $call222=__Z7IsSpacej($148); //@line 2658 "translate.cpp"
                    var $tobool223=((($call222))|0)!=0; //@line 2658 "translate.cpp"
                    if ($tobool223) { __label__ = 91;break $if_end244$$land_lhs_true221$120; } //@line 2658 "translate.cpp"
  
                    var $149=$tr_addr; //@line 2658 "translate.cpp"
                    var $punct_within_word=(($149+704)&4294967295); //@line 2658 "translate.cpp"
                    var $150=HEAP32[(($punct_within_word)>>2)]; //@line 2658 "translate.cpp"
                    var $151=$c; //@line 2658 "translate.cpp"
                    var $call225=_wcschr($150, $151); //@line 2658 "translate.cpp"
                    var $cmp226=((($call225))|0)==0; //@line 2658 "translate.cpp"
                    if (!($cmp226)) { __label__ = 91;break $if_end244$$land_lhs_true221$120; } //@line 2658 "translate.cpp"
  
                    var $152=HEAP32[(($prev_out)>>2)]; //@line 2660 "translate.cpp"
                    var $call228=__Z7IsAlphaj($152); //@line 2660 "translate.cpp"
                    var $tobool229=((($call228))|0)!=0; //@line 2660 "translate.cpp"
                    if (!($tobool229)) { __label__ = 91;break $if_end244$$land_lhs_true221$120; } //@line 2660 "translate.cpp"
  
                    var $153=$tr_addr; //@line 2662 "translate.cpp"
                    var $langopts231=(($153)&4294967295); //@line 2662 "translate.cpp"
                    var $tone_numbers232=(($langopts231+250)&4294967295); //@line 2662 "translate.cpp"
                    var $154=HEAP8[($tone_numbers232)]; //@line 2662 "translate.cpp"
                    var $tobool233=(tempInt=(($154)),(tempInt>=128?tempInt-256:tempInt))!=0; //@line 2662 "translate.cpp"
                    if ($tobool233) { __label__ = 88;; } else { __label__ = 90;; } //@line 2662 "translate.cpp"
                    $land_lhs_true234$$if_else241$125: do { 
                      if (__label__ == 88) {
  
                        var $155=$c; //@line 2662 "translate.cpp"
                        var $call235=__ZL9IsDigit09j($155); //@line 2662 "translate.cpp"
                        var $tobool236=((($call235))|0)!=0; //@line 2662 "translate.cpp"
                        if (!($tobool236)) { __label__ = 90;break $land_lhs_true234$$if_else241$125; } //@line 2662 "translate.cpp"
  
                        var $156=HEAP32[(($next_in)>>2)]; //@line 2662 "translate.cpp"
                        var $call238=__ZL9IsDigit09j($156); //@line 2662 "translate.cpp"
                        var $tobool239=((($call238))|0)!=0; //@line 2662 "translate.cpp"
                        if (!($tobool239)) { __label__ = 91;break $if_end244$$land_lhs_true221$120; } //@line 2662 "translate.cpp"
                      }
                    } while(0);
  
                    $c=32; //@line 2668 "translate.cpp"
                    $space_inserted=1; //@line 2669 "translate.cpp"
                    ;
                  }
                } while(0);
  
                var $157=HEAP32[(($prev_out)>>2)]; //@line 2674 "translate.cpp"
                var $call245=_iswdigit($157); //@line 2674 "translate.cpp"
                var $tobool246=((($call245))|0)!=0; //@line 2674 "translate.cpp"
                if ($tobool246) { __label__ = 92;; } else { __label__ = 94;; } //@line 2674 "translate.cpp"
                $if_then247$$if_else258$130: do { 
                  if (__label__ == 92) {
  
                    var $158=$c; //@line 2676 "translate.cpp"
                    var $call248=_iswdigit($158); //@line 2676 "translate.cpp"
                    var $tobool249=((($call248))|0)==0; //@line 2676 "translate.cpp"
                    var $159=$c; //@line 2676 "translate.cpp"
                    var $cmp251=((($159))|0)!=46; //@line 2676 "translate.cpp"
                    var $or_cond5=($tobool249) & ($cmp251); //@line 2676 "translate.cpp"
                    var $160=$c; //@line 2676 "translate.cpp"
                    var $cmp253=((($160))|0)!=44; //@line 2676 "translate.cpp"
                    var $or_cond6=($or_cond5) & ($cmp253); //@line 2676 "translate.cpp"
                    var $161=$c; //@line 2676 "translate.cpp"
                    var $cmp255=((($161))|0)!=32; //@line 2676 "translate.cpp"
                    var $or_cond7=($or_cond6) & ($cmp255); //@line 2676 "translate.cpp"
                    if ($or_cond7) { __lastLabel__ = 92; ; } else { __lastLabel__ = 92; __label__ = 97;break $if_then247$$if_else258$130; } //@line 2676 "translate.cpp"
  
                    $c=32; //@line 2678 "translate.cpp"
                    $space_inserted=1; //@line 2679 "translate.cpp"
                    __label__ = 101;break $if_then247$$if_else258$130; //@line 2690 "translate.cpp"
                  }
                  else if (__label__ == 94) {
  
                    var $162=HEAP32[(($prev_in)>>2)]; //@line 2684 "translate.cpp"
                    var $cmp259=((($162))|0)!=44; //@line 2684 "translate.cpp"
                    if ($cmp259) { __label__ = 95;; } else { __label__ = 96;; } //@line 2684 "translate.cpp"
                    if (__label__ == 95) {
  
                      $decimal_sep_count=0; //@line 2686 "translate.cpp"
                      ; //@line 2687 "translate.cpp"
                    }
  
                    var $_pr17=$c; //@line 2690 "translate.cpp"
                    __lastLabel__ = 96; __label__ = 97;break $if_then247$$if_else258$130;
                  }
                } while(0);
                $if_end273$$if_end262$137: do { 
                  if (__label__ == 97) {
  
                    var $163=__lastLabel__ == 96 ? $_pr17 : ($161); //@line 2690 "translate.cpp"
                    var $cmp263=((($163))|0)==91; //@line 2690 "translate.cpp"
                    if (!($cmp263)) { __label__ = 101;break $if_end273$$if_end262$137; } //@line 2690 "translate.cpp"
  
                    var $164=HEAP32[(($next_in)>>2)]; //@line 2692 "translate.cpp"
                    var $cmp265=((($164))|0)==2; //@line 2692 "translate.cpp"
                    if ($cmp265) { __label__ = 100;; } else { __label__ = 99;; } //@line 2692 "translate.cpp"
                    if (__label__ == 99) {
  
                      var $165=HEAP32[(($next_in)>>2)]; //@line 2692 "translate.cpp"
                      var $cmp267=((($165))|0)==91; //@line 2692 "translate.cpp"
                      var $166=HEAP32[((_option_phoneme_input)>>2)]; //@line 2692 "translate.cpp"
                      var $tobool269=((($166))|0)!=0; //@line 2692 "translate.cpp"
                      var $or_cond8=($cmp267) & ($tobool269); //@line 2692 "translate.cpp"
                      if (!($or_cond8)) { __label__ = 101;break $if_end273$$if_end262$137; } //@line 2692 "translate.cpp"
                    }
  
                    $phoneme_mode=8; //@line 2695 "translate.cpp"
                    var $167=HEAP32[(($source_index)>>2)]; //@line 2696 "translate.cpp"
                    var $inc271=((($167)+1)&4294967295); //@line 2696 "translate.cpp"
                    HEAP32[(($source_index)>>2)]=$inc271; //@line 2696 "translate.cpp"
                    __label__ = 33;continue $while_cond88$50; //@line 2697 "translate.cpp"
                  }
                } while(0);
  
                var $168=$c; //@line 2701 "translate.cpp"
                var $call274=__Z7IsAlphaj($168); //@line 2701 "translate.cpp"
                var $tobool275=((($call274))|0)!=0; //@line 2701 "translate.cpp"
                if ($tobool275) { __label__ = 102;; } else { __label__ = 138;; } //@line 2701 "translate.cpp"
                if (__label__ == 102) {
  
                  var $169=HEAP32[(($prev_out)>>2)]; //@line 2703 "translate.cpp"
                  var $call277=__Z7IsAlphaj($169); //@line 2703 "translate.cpp"
                  var $tobool278=((($call277))|0)!=0; //@line 2703 "translate.cpp"
                  if ($tobool278) { __label__ = 103;; } else { __label__ = 106;; } //@line 2703 "translate.cpp"
                  $lor_lhs_false279$$if_then286$146: do { 
                    if (__label__ == 103) {
  
                      var $170=$tr_addr; //@line 2703 "translate.cpp"
                      var $langopts280=(($170)&4294967295); //@line 2703 "translate.cpp"
                      var $ideographs=(($langopts280+251)&4294967295); //@line 2703 "translate.cpp"
                      var $171=HEAP8[($ideographs)]; //@line 2703 "translate.cpp"
                      var $tobool281=(tempInt=(($171)),(tempInt>=128?tempInt-256:tempInt))!=0; //@line 2703 "translate.cpp"
                      if (!($tobool281)) { __label__ = 118;break $lor_lhs_false279$$if_then286$146; } //@line 2703 "translate.cpp"
  
                      var $172=$c; //@line 2703 "translate.cpp"
                      var $cmp283=((($172))|0) > 12352; //@line 2703 "translate.cpp"
                      if ($cmp283) { __label__ = 106;break $lor_lhs_false279$$if_then286$146; } //@line 2703 "translate.cpp"
  
                      var $173=HEAP32[(($prev_out)>>2)]; //@line 2703 "translate.cpp"
                      var $cmp285=((($173))|0) > 12352; //@line 2703 "translate.cpp"
                      if ($cmp285) { __label__ = 106;break $lor_lhs_false279$$if_then286$146; } else { __label__ = 118;break $lor_lhs_false279$$if_then286$146; } //@line 2703 "translate.cpp"
                    }
                  } while(0);
                  $if_then286$$if_end327$150: do { 
                    if (__label__ == 106) {
  
                      var $174=$tr_addr; //@line 2705 "translate.cpp"
                      var $punct_within_word287=(($174+704)&4294967295); //@line 2705 "translate.cpp"
                      var $175=HEAP32[(($punct_within_word287)>>2)]; //@line 2705 "translate.cpp"
                      var $176=HEAP32[(($prev_out)>>2)]; //@line 2705 "translate.cpp"
                      var $call288=_wcschr($175, $176); //@line 2705 "translate.cpp"
                      var $cmp289=((($call288))|0)==0; //@line 2705 "translate.cpp"
                      if ($cmp289) { __label__ = 107;; } else { __label__ = 108;; } //@line 2705 "translate.cpp"
                      if (__label__ == 107) {
  
                        $letter_count=0; //@line 2706 "translate.cpp"
                        ; //@line 2706 "translate.cpp"
                      }
  
                      var $177=HEAP32[(($prev_out)>>2)]; //@line 2708 "translate.cpp"
                      var $cmp292=((($177))|0)!=32; //@line 2708 "translate.cpp"
                      if ($cmp292) { __label__ = 109;; } else { __label__ = 112;; } //@line 2708 "translate.cpp"
                      $land_lhs_true293$$if_else303$155: do { 
                        if (__label__ == 109) {
  
                          var $178=$tr_addr; //@line 2708 "translate.cpp"
                          var $punct_within_word294=(($178+704)&4294967295); //@line 2708 "translate.cpp"
                          var $179=HEAP32[(($punct_within_word294)>>2)]; //@line 2708 "translate.cpp"
                          var $180=HEAP32[(($prev_out)>>2)]; //@line 2708 "translate.cpp"
                          var $call295=_wcschr($179, $180); //@line 2708 "translate.cpp"
                          var $cmp296=((($call295))|0)==0; //@line 2708 "translate.cpp"
                          if (!($cmp296)) { __label__ = 112;break $land_lhs_true293$$if_else303$155; } //@line 2708 "translate.cpp"
  
                          $c=32; //@line 2711 "translate.cpp"
                          $space_inserted=1; //@line 2712 "translate.cpp"
                          var $181=HEAP32[(($prev_out)>>2)]; //@line 2714 "translate.cpp"
                          var $call298=__Z9IsBracketi($181); //@line 2714 "translate.cpp"
                          var $tobool299=((($call298))|0)!=0; //@line 2714 "translate.cpp"
                          if ($tobool299) { __label__ = 118;break $if_then286$$if_end327$150; } //@line 2714 "translate.cpp"
  
                          var $182=$next_word_flags; //@line 2716 "translate.cpp"
                          var $or301=($182) | 256; //@line 2716 "translate.cpp"
                          $next_word_flags=$or301; //@line 2716 "translate.cpp"
                          __label__ = 118;break $if_then286$$if_end327$150; //@line 2717 "translate.cpp"
                        }
                      } while(0);
  
                      var $183=$c; //@line 2721 "translate.cpp"
                      var $call304=_iswupper($183); //@line 2721 "translate.cpp"
                      var $tobool305=((($call304))|0)!=0; //@line 2721 "translate.cpp"
                      if ($tobool305) { __label__ = 113;; } else { __label__ = 114;; } //@line 2721 "translate.cpp"
                      if (__label__ == 113) {
  
                        var $184=$word_flags; //@line 2722 "translate.cpp"
                        var $or307=($184) | 2; //@line 2722 "translate.cpp"
                        $word_flags=$or307; //@line 2722 "translate.cpp"
                        ; //@line 2722 "translate.cpp"
                      }
  
                      var $185=HEAP32[(($prev_out)>>2)]; //@line 2724 "translate.cpp"
                      var $cmp309=((($185))|0)==32; //@line 2724 "translate.cpp"
                      if (!($cmp309)) { __label__ = 118;break $if_then286$$if_end327$150; } //@line 2724 "translate.cpp"
  
                      var $186=$ix; //@line 2724 "translate.cpp"
                      var $sub311=((($186)-2)&4294967295); //@line 2724 "translate.cpp"
                      var $arrayidx312=(($sbuf+$sub311)&4294967295); //@line 2724 "translate.cpp"
                      var $187=HEAP8[($arrayidx312)]; //@line 2724 "translate.cpp"
                      var $conv313=(tempInt=(($187)),(tempInt>=128?tempInt-256:tempInt)); //@line 2724 "translate.cpp"
                      var $call314=_iswdigit($conv313); //@line 2724 "translate.cpp"
                      var $tobool315=((($call314))|0)!=0; //@line 2724 "translate.cpp"
                      if (!($tobool315)) { __label__ = 118;break $if_then286$$if_end327$150; } //@line 2724 "translate.cpp"
  
                      var $188=HEAP32[(($prev_in)>>2)]; //@line 2724 "translate.cpp"
                      var $call317=_iswdigit($188); //@line 2724 "translate.cpp"
                      var $tobool318=((($call317))|0)!=0; //@line 2724 "translate.cpp"
                      if ($tobool318) { __label__ = 118;break $if_then286$$if_end327$150; } //@line 2724 "translate.cpp"
  
                      var $189=$ix; //@line 2728 "translate.cpp"
                      var $inc320=((($189)+1)&4294967295); //@line 2728 "translate.cpp"
                      $ix=$inc320; //@line 2728 "translate.cpp"
                      var $arrayidx321=(($sbuf+$189)&4294967295); //@line 2728 "translate.cpp"
                      HEAP8[($arrayidx321)]=32; //@line 2728 "translate.cpp"
                      var $190=$word_count; //@line 2729 "translate.cpp"
                      var $arrayidx322=(($words+$190*12)&4294967295); //@line 2729 "translate.cpp"
                      var $start323=(($arrayidx322+4)&4294967295); //@line 2729 "translate.cpp"
                      var $191=HEAP16[(($start323)>>1)]; //@line 2729 "translate.cpp"
                      var $inc324=((($191)+1)&65535); //@line 2729 "translate.cpp"
                      HEAP16[(($start323)>>1)]=$inc324; //@line 2729 "translate.cpp"
                      ; //@line 2730 "translate.cpp"
                    }
                  } while(0);
  
                  var $192=$letter_count; //@line 2734 "translate.cpp"
                  var $inc328=((($192)+1)&4294967295); //@line 2734 "translate.cpp"
                  $letter_count=$inc328; //@line 2734 "translate.cpp"
                  var $193=$c; //@line 2736 "translate.cpp"
                  var $call329=_iswupper($193); //@line 2736 "translate.cpp"
                  var $tobool330=((($call329))|0)!=0; //@line 2736 "translate.cpp"
                  if ($tobool330) { __label__ = 119;; } else { __label__ = 130;; } //@line 2736 "translate.cpp"
                  if (__label__ == 119) {
  
                    var $194=$c; //@line 2738 "translate.cpp"
                    var $call332=__Z9towlower2j($194); //@line 2738 "translate.cpp"
                    $c=$call332; //@line 2738 "translate.cpp"
                    var $195=$tr_addr; //@line 2740 "translate.cpp"
                    var $langopts333=(($195)&4294967295); //@line 2740 "translate.cpp"
                    var $param=(($langopts333+24)&4294967295); //@line 2740 "translate.cpp"
                    var $arrayidx334=(($param+52)&4294967295); //@line 2740 "translate.cpp"
                    var $196=HEAP32[(($arrayidx334)>>2)]; //@line 2740 "translate.cpp"
                    $j=$196; //@line 2740 "translate.cpp"
                    var $cmp335=((($196))|0) > 0; //@line 2740 "translate.cpp"
                    if ($cmp335) { __label__ = 120;; } else { __label__ = 123;; } //@line 2740 "translate.cpp"
                    if (__label__ == 120) {
  
                      var $197=$j; //@line 2742 "translate.cpp"
                      var $cmp337=((($197))|0)==2; //@line 2742 "translate.cpp"
                      if (!($cmp337)) { __label__ = 195;break $if_then155$$if_else162$86; } //@line 2742 "translate.cpp"
  
                      var $198=$syllable_marked; //@line 2742 "translate.cpp"
                      var $cmp339=((($198))|0)==0; //@line 2742 "translate.cpp"
                      if (!($cmp339)) { __label__ = 195;break $if_then155$$if_else162$86; } //@line 2742 "translate.cpp"
  
                      var $199=$c; //@line 2744 "translate.cpp"
                      HEAP32[(($char_inserted)>>2)]=$199; //@line 2744 "translate.cpp"
                      $c=712; //@line 2745 "translate.cpp"
                      $syllable_marked=1; //@line 2746 "translate.cpp"
                      ; //@line 2747 "translate.cpp"
                    }
                    else if (__label__ == 123) {
  
                      var $200=HEAP32[(($prev_in)>>2)]; //@line 2751 "translate.cpp"
                      var $call343=_iswlower($200); //@line 2751 "translate.cpp"
                      var $tobool344=((($call343))|0)!=0; //@line 2751 "translate.cpp"
                      if ($tobool344) { __label__ = 124;; } else { __label__ = 125;; } //@line 2751 "translate.cpp"
                      if (__label__ == 124) {
  
                        $c=32; //@line 2753 "translate.cpp"
                        $space_inserted=1; //@line 2754 "translate.cpp"
                        var $201=$c; //@line 2755 "translate.cpp"
                        $prev_in_save=$201; //@line 2755 "translate.cpp"
                        ; //@line 2757 "translate.cpp"
                      }
                      else if (__label__ == 125) {
  
                        var $202=$c; //@line 2759 "translate.cpp"
                        var $cmp347=((($202))|0)!=32; //@line 2759 "translate.cpp"
                        if (!($cmp347)) { __label__ = 195;break $if_then155$$if_else162$86; } //@line 2759 "translate.cpp"
  
                        var $203=HEAP32[(($prev_in)>>2)]; //@line 2759 "translate.cpp"
                        var $call349=_iswupper($203); //@line 2759 "translate.cpp"
                        var $tobool350=((($call349))|0)!=0; //@line 2759 "translate.cpp"
                        if (!($tobool350)) { __label__ = 195;break $if_then155$$if_else162$86; } //@line 2759 "translate.cpp"
  
                        var $204=HEAP32[(($next_in)>>2)]; //@line 2759 "translate.cpp"
                        var $call352=_iswlower($204); //@line 2759 "translate.cpp"
                        var $tobool353=((($call352))|0)!=0; //@line 2759 "translate.cpp"
                        if (!($tobool353)) { __label__ = 195;break $if_then155$$if_else162$86; } //@line 2759 "translate.cpp"
  
                        var $205=HEAP32[(($source_index)>>2)]; //@line 2762 "translate.cpp"
                        var $206=$next_in_nbytes; //@line 2762 "translate.cpp"
                        var $add355=((($206)+($205))&4294967295); //@line 2762 "translate.cpp"
                        var $arrayidx356=((__ZL6source+$add355)&4294967295); //@line 2762 "translate.cpp"
                        var $call357=__Z7utf8_inPiPKc($next2_in, $arrayidx356); //@line 2762 "translate.cpp"
                        var $207=HEAP32[(($next2_in)>>2)]; //@line 2763 "translate.cpp"
                        var $call358=__Z7IsAlphaj($207); //@line 2763 "translate.cpp"
                        var $tobool359=((($call358))|0)!=0; //@line 2763 "translate.cpp"
                        if (!($tobool359)) { __label__ = 195;break $if_then155$$if_else162$86; } //@line 2763 "translate.cpp"
  
                        $c=32; //@line 2766 "translate.cpp"
                        $space_inserted=1; //@line 2767 "translate.cpp"
                        var $208=$c; //@line 2768 "translate.cpp"
                        $prev_in_save=$208; //@line 2768 "translate.cpp"
                        var $209=$next_word_flags; //@line 2769 "translate.cpp"
                        var $or361=($209) | 256; //@line 2769 "translate.cpp"
                        $next_word_flags=$or361; //@line 2769 "translate.cpp"
                        ; //@line 2770 "translate.cpp"
                      }
                    }
                  }
                  else if (__label__ == 130) {
  
                    var $210=$all_upper_case; //@line 2776 "translate.cpp"
                    var $tobool367=((($210))|0)!=0; //@line 2776 "translate.cpp"
                    if ($tobool367) { __label__ = 131;; } else { __label__ = 137;; } //@line 2776 "translate.cpp"
                    $land_lhs_true368$$if_else386$182: do { 
                      if (__label__ == 131) {
  
                        var $211=$letter_count; //@line 2776 "translate.cpp"
                        var $cmp369=((($211))|0) > 2; //@line 2776 "translate.cpp"
                        if (!($cmp369)) { __label__ = 137;break $land_lhs_true368$$if_else386$182; } //@line 2776 "translate.cpp"
  
                        var $212=$c; //@line 2778 "translate.cpp"
                        var $cmp371=((($212))|0)==115; //@line 2778 "translate.cpp"
                        if ($cmp371) { __label__ = 133;; } else { __label__ = 136;; } //@line 2778 "translate.cpp"
                        $land_lhs_true372$$if_else384$185: do { 
                          if (__label__ == 133) {
  
                            var $213=HEAP32[(($next_in)>>2)]; //@line 2778 "translate.cpp"
                            var $cmp373=((($213))|0)==32; //@line 2778 "translate.cpp"
                            if (!($cmp373)) { __label__ = 136;break $land_lhs_true372$$if_else384$185; } //@line 2778 "translate.cpp"
  
                            $c=32; //@line 2780 "translate.cpp"
                            var $214=$all_upper_case; //@line 2781 "translate.cpp"
                            var $or375=($214) | 4; //@line 2781 "translate.cpp"
                            $all_upper_case=$or375; //@line 2781 "translate.cpp"
                            var $215=$ix; //@line 2783 "translate.cpp"
                            var $sub376=((($215)-1)&4294967295); //@line 2783 "translate.cpp"
                            var $arrayidx377=(($sbuf+$sub376)&4294967295); //@line 2783 "translate.cpp"
                            var $216=HEAP8[($arrayidx377)]; //@line 2783 "translate.cpp"
                            var $conv378=(tempInt=(($216)),(tempInt>=128?tempInt-256:tempInt)); //@line 2783 "translate.cpp"
                            var $cmp379=((($conv378))|0)==39; //@line 2783 "translate.cpp"
                            if (!($cmp379)) { __label__ = 195;break $if_then155$$if_else162$86; } //@line 2783 "translate.cpp"
  
                            var $217=$ix; //@line 2784 "translate.cpp"
                            var $sub381=((($217)-1)&4294967295); //@line 2784 "translate.cpp"
                            var $arrayidx382=(($sbuf+$sub381)&4294967295); //@line 2784 "translate.cpp"
                            HEAP8[($arrayidx382)]=32; //@line 2784 "translate.cpp"
                            __label__ = 195;break $if_then155$$if_else162$86; //@line 2784 "translate.cpp"
                          }
                        } while(0);
  
                        $all_upper_case=0; //@line 2787 "translate.cpp"
                        __label__ = 195;break $if_then155$$if_else162$86;
                      }
                    } while(0);
  
                    $all_upper_case=0; //@line 2790 "translate.cpp"
                    ;
                  }
                }
                else if (__label__ == 138) {
  
                  var $218=$c; //@line 2794 "translate.cpp"
                  var $cmp390=((($218))|0)==45; //@line 2794 "translate.cpp"
                  if ($cmp390) { __label__ = 139;; } else { __label__ = 154;; } //@line 2794 "translate.cpp"
                  if (__label__ == 139) {
  
                    var $219=HEAP32[(($prev_in)>>2)]; //@line 2796 "translate.cpp"
                    var $call392=__Z7IsSpacej($219); //@line 2796 "translate.cpp"
                    var $tobool393=((($call392))|0)!=0; //@line 2796 "translate.cpp"
                    if ($tobool393) { __label__ = 146;; } else { __label__ = 140;; } //@line 2796 "translate.cpp"
                    $if_else410$$land_lhs_true394$194: do { 
                      if (__label__ == 140) {
  
                        var $220=HEAP32[(($next_in)>>2)]; //@line 2796 "translate.cpp"
                        var $call395=__Z7IsAlphaj($220); //@line 2796 "translate.cpp"
                        var $tobool396=((($call395))|0)!=0; //@line 2796 "translate.cpp"
                        if (!($tobool396)) { __label__ = 146;break $if_else410$$land_lhs_true394$194; } //@line 2796 "translate.cpp"
  
                        var $221=HEAP32[(($prev_out)>>2)]; //@line 2798 "translate.cpp"
                        var $cmp398=((($221))|0)!=32; //@line 2798 "translate.cpp"
                        if ($cmp398) { __label__ = 142;; } else { __label__ = 143;; } //@line 2798 "translate.cpp"
                        if (__label__ == 142) {
  
                          $c=32; //@line 2801 "translate.cpp"
                          $space_inserted=1; //@line 2802 "translate.cpp"
                          __label__ = 195;break $if_then155$$if_else162$86; //@line 2803 "translate.cpp"
                        }
                        else if (__label__ == 143) {
  
                          var $222=$word_flags; //@line 2807 "translate.cpp"
                          var $or401=($222) | 128; //@line 2807 "translate.cpp"
                          $word_flags=$or401; //@line 2807 "translate.cpp"
                          var $223=$word_count; //@line 2808 "translate.cpp"
                          var $cmp402=((($223))|0) > 0; //@line 2808 "translate.cpp"
                          if ($cmp402) { __label__ = 144;; } else { __label__ = 145;; } //@line 2808 "translate.cpp"
                          if (__label__ == 144) {
  
                            var $224=$word_count; //@line 2809 "translate.cpp"
                            var $sub404=((($224)-1)&4294967295); //@line 2809 "translate.cpp"
                            var $arrayidx405=(($words+$sub404*12)&4294967295); //@line 2809 "translate.cpp"
                            var $flags406=(($arrayidx405)&4294967295); //@line 2809 "translate.cpp"
                            var $225=HEAP32[(($flags406)>>2)]; //@line 2809 "translate.cpp"
                            var $or407=($225) | 16384; //@line 2809 "translate.cpp"
                            HEAP32[(($flags406)>>2)]=$or407; //@line 2809 "translate.cpp"
                            ; //@line 2809 "translate.cpp"
                          }
  
                          $c=32; //@line 2810 "translate.cpp"
                          __label__ = 195;break $if_then155$$if_else162$86;
                        }
                      }
                    } while(0);
  
                    var $226=HEAP32[(($prev_in)>>2)]; //@line 2814 "translate.cpp"
                    var $cmp411=((($226))|0)==32; //@line 2814 "translate.cpp"
                    var $227=HEAP32[(($next_in)>>2)]; //@line 2814 "translate.cpp"
                    var $cmp413=((($227))|0)==32; //@line 2814 "translate.cpp"
                    var $or_cond26=($cmp411) & ($cmp413); //@line 2814 "translate.cpp"
                    if ($or_cond26) { __label__ = 147;; } else { __label__ = 148;; } //@line 2814 "translate.cpp"
                    if (__label__ == 147) {
  
                      $c=32; //@line 2817 "translate.cpp"
                      $pre_pause_add=4; //@line 2818 "translate.cpp"
                      ; //@line 2819 "translate.cpp"
                    }
                    else if (__label__ == 148) {
  
                      var $cmp416=((($227))|0)==45; //@line 2821 "translate.cpp"
                      if ($cmp416) { __label__ = 149;; } else { __label__ = 150;; } //@line 2821 "translate.cpp"
                      if (__label__ == 149) {
  
                        var $228=HEAP32[(($source_index)>>2)]; //@line 2824 "translate.cpp"
                        var $inc418=((($228)+1)&4294967295); //@line 2824 "translate.cpp"
                        HEAP32[(($source_index)>>2)]=$inc418; //@line 2824 "translate.cpp"
                        $c=32; //@line 2825 "translate.cpp"
                        $pre_pause_add=4; //@line 2826 "translate.cpp"
                        ; //@line 2827 "translate.cpp"
                      }
                      else if (__label__ == 150) {
  
                        var $229=HEAP32[(($prev_out)>>2)]; //@line 2829 "translate.cpp"
                        var $cmp420=((($229))|0)==32; //@line 2829 "translate.cpp"
                        if (!($cmp420)) { __label__ = 195;break $if_then155$$if_else162$86; } //@line 2829 "translate.cpp"
  
                        var $230=$ix; //@line 2829 "translate.cpp"
                        var $sub422=((($230)-2)&4294967295); //@line 2829 "translate.cpp"
                        var $arrayidx423=(($sbuf+$sub422)&4294967295); //@line 2829 "translate.cpp"
                        var $231=HEAP8[($arrayidx423)]; //@line 2829 "translate.cpp"
                        var $conv424=(tempInt=(($231)),(tempInt>=128?tempInt-256:tempInt)); //@line 2829 "translate.cpp"
                        var $call425=__Z7IsAlphaj($conv424); //@line 2829 "translate.cpp"
                        var $tobool426=((($call425))|0)!=0; //@line 2829 "translate.cpp"
                        if (!($tobool426)) { __label__ = 195;break $if_then155$$if_else162$86; } //@line 2829 "translate.cpp"
  
                        var $232=HEAP32[(($prev_in)>>2)]; //@line 2829 "translate.cpp"
                        var $call428=__Z7IsAlphaj($232); //@line 2829 "translate.cpp"
                        var $tobool429=((($call428))|0)!=0; //@line 2829 "translate.cpp"
                        if ($tobool429) { __label__ = 195;break $if_then155$$if_else162$86; } //@line 2829 "translate.cpp"
  
                        var $233=$ix; //@line 2832 "translate.cpp"
                        var $inc431=((($233)+1)&4294967295); //@line 2832 "translate.cpp"
                        $ix=$inc431; //@line 2832 "translate.cpp"
                        var $arrayidx432=(($sbuf+$233)&4294967295); //@line 2832 "translate.cpp"
                        HEAP8[($arrayidx432)]=32; //@line 2832 "translate.cpp"
                        var $234=$word_count; //@line 2833 "translate.cpp"
                        var $arrayidx433=(($words+$234*12)&4294967295); //@line 2833 "translate.cpp"
                        var $start434=(($arrayidx433+4)&4294967295); //@line 2833 "translate.cpp"
                        var $235=HEAP16[(($start434)>>1)]; //@line 2833 "translate.cpp"
                        var $inc435=((($235)+1)&65535); //@line 2833 "translate.cpp"
                        HEAP16[(($start434)>>1)]=$inc435; //@line 2833 "translate.cpp"
                        ; //@line 2834 "translate.cpp"
                      }
                    }
                  }
                  else if (__label__ == 154) {
  
                    var $236=$c; //@line 2837 "translate.cpp"
                    var $cmp441=((($236))|0)==46; //@line 2837 "translate.cpp"
                    if ($cmp441) { __label__ = 155;; } else { __label__ = 162;; } //@line 2837 "translate.cpp"
                    if (__label__ == 155) {
  
                      var $237=HEAP32[(($prev_out)>>2)]; //@line 2839 "translate.cpp"
                      var $cmp443=((($237))|0)==46; //@line 2839 "translate.cpp"
                      if ($cmp443) { __label__ = 156;; } else { __label__ = 157;; } //@line 2839 "translate.cpp"
                      if (__label__ == 156) {
  
                        $c=32; //@line 2842 "translate.cpp"
                        $space_inserted=1; //@line 2843 "translate.cpp"
                        ; //@line 2844 "translate.cpp"
                      }
                      else if (__label__ == 157) {
  
                        var $238=$word_count; //@line 2846 "translate.cpp"
                        var $cmp446=((($238))|0) > 0; //@line 2846 "translate.cpp"
                        if (!($cmp446)) { __label__ = 195;break $if_then155$$if_else162$86; } //@line 2846 "translate.cpp"
  
                        var $239=$word_count; //@line 2846 "translate.cpp"
                        var $sub448=((($239)-1)&4294967295); //@line 2846 "translate.cpp"
                        var $arrayidx449=(($words+$sub448*12)&4294967295); //@line 2846 "translate.cpp"
                        var $flags450=(($arrayidx449)&4294967295); //@line 2846 "translate.cpp"
                        var $240=HEAP32[(($flags450)>>2)]; //@line 2846 "translate.cpp"
                        var $and451=($240) & 256; //@line 2846 "translate.cpp"
                        var $tobool452=((($and451))|0)!=0; //@line 2846 "translate.cpp"
                        if ($tobool452) { __label__ = 195;break $if_then155$$if_else162$86; } //@line 2846 "translate.cpp"
  
                        var $241=HEAP32[(($prev_in)>>2)]; //@line 2846 "translate.cpp"
                        var $call454=__Z7IsAlphaj($241); //@line 2846 "translate.cpp"
                        var $tobool455=((($call454))|0)!=0; //@line 2846 "translate.cpp"
                        if (!($tobool455)) { __label__ = 195;break $if_then155$$if_else162$86; } //@line 2846 "translate.cpp"
  
                        var $242=$word_count; //@line 2849 "translate.cpp"
                        var $sub457=((($242)-1)&4294967295); //@line 2849 "translate.cpp"
                        var $arrayidx458=(($words+$sub457*12)&4294967295); //@line 2849 "translate.cpp"
                        var $flags459=(($arrayidx458)&4294967295); //@line 2849 "translate.cpp"
                        var $243=HEAP32[(($flags459)>>2)]; //@line 2849 "translate.cpp"
                        var $or460=($243) | 65536; //@line 2849 "translate.cpp"
                        HEAP32[(($flags459)>>2)]=$or460; //@line 2849 "translate.cpp"
                        var $244=HEAP32[(($next_in)>>2)]; //@line 2851 "translate.cpp"
                        var $call461=__Z7IsSpacej($244); //@line 2851 "translate.cpp"
                        var $tobool462=((($call461))|0)!=0; //@line 2851 "translate.cpp"
                        var $245=HEAP32[(($next_in)>>2)]; //@line 2851 "translate.cpp"
                        var $cmp464=((($245))|0)==45; //@line 2851 "translate.cpp"
                        var $or_cond9=($tobool462) | ($cmp464); //@line 2851 "translate.cpp"
                        if (!($or_cond9)) { __label__ = 195;break $if_then155$$if_else162$86; } //@line 2851 "translate.cpp"
  
                        $c=32; //@line 2852 "translate.cpp"
                        ; //@line 2852 "translate.cpp"
                      }
                    }
                    else if (__label__ == 162) {
  
                      var $246=$c; //@line 2856 "translate.cpp"
                      var $cmp470=((($246))|0)==39; //@line 2856 "translate.cpp"
                      if ($cmp470) { __label__ = 163;; } else { __label__ = 178;; } //@line 2856 "translate.cpp"
                      if (__label__ == 163) {
  
                        var $247=HEAP32[(($prev_in)>>2)]; //@line 2858 "translate.cpp"
                        var $cmp472=((($247))|0)==46; //@line 2858 "translate.cpp"
                        if ($cmp472) { __label__ = 165;; } else { __label__ = 164;; } //@line 2858 "translate.cpp"
                        $land_lhs_true476$$lor_lhs_false473$226: do { 
                          if (__label__ == 164) {
  
                            var $248=HEAP32[(($prev_in)>>2)]; //@line 2858 "translate.cpp"
                            var $call474=_iswalnum($248); //@line 2858 "translate.cpp"
                            var $tobool475=((($call474))|0)!=0; //@line 2858 "translate.cpp"
                            if ($tobool475) { __label__ = 165;break $land_lhs_true476$$lor_lhs_false473$226; } else { __label__ = 167;break $land_lhs_true476$$lor_lhs_false473$226; } //@line 2858 "translate.cpp"
                          }
                        } while(0);
                        $land_lhs_true476$$if_else480$228: do { 
                          if (__label__ == 165) {
  
                            var $249=HEAP32[(($next_in)>>2)]; //@line 2858 "translate.cpp"
                            var $call477=__Z7IsAlphaj($249); //@line 2858 "translate.cpp"
                            var $tobool478=((($call477))|0)!=0; //@line 2858 "translate.cpp"
                            if (!($tobool478)) { __label__ = 167;break $land_lhs_true476$$if_else480$228; } //@line 2858 "translate.cpp"
  
                            $single_quoted=0; //@line 2861 "translate.cpp"
                            __label__ = 195;break $if_then155$$if_else162$86; //@line 2862 "translate.cpp"
                          }
                        } while(0);
  
                        var $250=$tr_addr; //@line 2864 "translate.cpp"
                        var $char_plus_apostrophe=(($250+700)&4294967295); //@line 2864 "translate.cpp"
                        var $251=HEAP32[(($char_plus_apostrophe)>>2)]; //@line 2864 "translate.cpp"
                        var $252=HEAP32[(($prev_in)>>2)]; //@line 2864 "translate.cpp"
                        var $call481=_wcschr($251, $252); //@line 2864 "translate.cpp"
                        var $cmp482=((($call481))|0)!=0; //@line 2864 "translate.cpp"
                        if ($cmp482) { __label__ = 168;; } else { __label__ = 171;; } //@line 2864 "translate.cpp"
                        $land_lhs_true483$$if_else490$232: do { 
                          if (__label__ == 168) {
  
                            var $253=$prev_out2; //@line 2864 "translate.cpp"
                            var $cmp484=((($253))|0)==32; //@line 2864 "translate.cpp"
                            if (!($cmp484)) { __label__ = 171;break $land_lhs_true483$$if_else490$232; } //@line 2864 "translate.cpp"
  
                            $single_quoted=0; //@line 2867 "translate.cpp"
                            var $254=HEAP32[(($next_in)>>2)]; //@line 2868 "translate.cpp"
                            var $cmp486=((($254))|0)==32; //@line 2868 "translate.cpp"
                            if (!($cmp486)) { __label__ = 195;break $if_then155$$if_else162$86; } //@line 2868 "translate.cpp"
  
                            var $255=HEAP32[(($source_index)>>2)]; //@line 2870 "translate.cpp"
                            var $inc488=((($255)+1)&4294967295); //@line 2870 "translate.cpp"
                            HEAP32[(($source_index)>>2)]=$inc488; //@line 2870 "translate.cpp"
                            __label__ = 195;break $if_then155$$if_else162$86; //@line 2871 "translate.cpp"
                          }
                        } while(0);
  
                        var $256=HEAP32[(($prev_out)>>2)]; //@line 2875 "translate.cpp"
                        var $cmp491=((($256))|0)==115; //@line 2875 "translate.cpp"
                        if ($cmp491) { __label__ = 172;; } else { __label__ = 174;; } //@line 2875 "translate.cpp"
                        $land_lhs_true492$$if_else495$237: do { 
                          if (__label__ == 172) {
  
                            var $257=$single_quoted; //@line 2875 "translate.cpp"
                            var $cmp493=((($257))|0)==0; //@line 2875 "translate.cpp"
                            if (!($cmp493)) { __label__ = 174;break $land_lhs_true492$$if_else495$237; } //@line 2875 "translate.cpp"
  
                            $c=32; //@line 2878 "translate.cpp"
                            __label__ = 195;break $if_then155$$if_else162$86; //@line 2879 "translate.cpp"
                          }
                        } while(0);
  
                        var $258=HEAP32[(($prev_out)>>2)]; //@line 2882 "translate.cpp"
                        var $call496=__Z7IsSpacej($258); //@line 2882 "translate.cpp"
                        var $tobool497=((($call496))|0)!=0; //@line 2882 "translate.cpp"
                        if ($tobool497) { __label__ = 175;; } else { __label__ = 176;; } //@line 2882 "translate.cpp"
                        if (__label__ == 175) {
  
                          $single_quoted=1; //@line 2883 "translate.cpp"
                          ; //@line 2883 "translate.cpp"
                        }
                        else if (__label__ == 176) {
  
                          $single_quoted=0; //@line 2885 "translate.cpp"
                          ;
                        }
  
                        $pre_pause_add=4; //@line 2887 "translate.cpp"
                        $c=32; //@line 2888 "translate.cpp"
                        ;
                      }
                      else if (__label__ == 178) {
  
                        var $259=$c; //@line 2902 "translate.cpp"
                        var $call505=__Z11lookupwcharPKti(((__ZL6breaks)&4294967295), $259); //@line 2902 "translate.cpp"
                        var $cmp506=((($call505))|0)!=0; //@line 2902 "translate.cpp"
                        if ($cmp506) { __label__ = 179;; } else { __label__ = 180;; } //@line 2902 "translate.cpp"
                        if (__label__ == 179) {
  
                          $c=32; //@line 2904 "translate.cpp"
                          ; //@line 2905 "translate.cpp"
                        }
                        else if (__label__ == 180) {
  
                          var $260=$c; //@line 2907 "translate.cpp"
                          var $call509=_iswdigit($260); //@line 2907 "translate.cpp"
                          var $tobool510=((($call509))|0)!=0; //@line 2907 "translate.cpp"
                          if (!($tobool510)) { __label__ = 195;break $if_then155$$if_else162$86; } //@line 2907 "translate.cpp"
  
                          var $261=$tr_addr; //@line 2909 "translate.cpp"
                          var $langopts512=(($261)&4294967295); //@line 2909 "translate.cpp"
                          var $tone_numbers513=(($langopts512+250)&4294967295); //@line 2909 "translate.cpp"
                          var $262=HEAP8[($tone_numbers513)]; //@line 2909 "translate.cpp"
                          var $tobool514=(tempInt=(($262)),(tempInt>=128?tempInt-256:tempInt))!=0; //@line 2909 "translate.cpp"
                          if ($tobool514) { __label__ = 182;; } else { __label__ = 184;; } //@line 2909 "translate.cpp"
                          $land_lhs_true515$$if_else522$250: do { 
                            if (__label__ == 182) {
  
                              var $263=HEAP32[(($prev_out)>>2)]; //@line 2909 "translate.cpp"
                              var $call516=__Z7IsAlphaj($263); //@line 2909 "translate.cpp"
                              var $tobool517=((($call516))|0)!=0; //@line 2909 "translate.cpp"
                              if (!($tobool517)) { __label__ = 184;break $land_lhs_true515$$if_else522$250; } //@line 2909 "translate.cpp"
  
                              var $264=HEAP32[(($next_in)>>2)]; //@line 2909 "translate.cpp"
                              var $call519=__Z7IsDigitj($264); //@line 2909 "translate.cpp"
                              var $tobool520=((($call519))|0)!=0; //@line 2909 "translate.cpp"
                              if (!($tobool520)) { __label__ = 195;break $if_then155$$if_else162$86; } //@line 2909 "translate.cpp"
                            }
                          } while(0);
  
                          var $265=HEAP32[(($prev_out)>>2)]; //@line 2913 "translate.cpp"
                          var $cmp523=((($265))|0)!=32; //@line 2913 "translate.cpp"
                          if ($cmp523) { __label__ = 185;; } else { __label__ = 192;; } //@line 2913 "translate.cpp"
                          if (__label__ == 185) {
  
                            var $266=HEAP32[(($prev_out)>>2)]; //@line 2913 "translate.cpp"
                            var $call525=_iswdigit($266); //@line 2913 "translate.cpp"
                            var $tobool526=((($call525))|0)!=0; //@line 2913 "translate.cpp"
                            var $_pr20=HEAP32[(($prev_out)>>2)]; //@line 2926 "translate.cpp"
                            if ($tobool526) { __label__ = 191;; } else { __label__ = 186;; } //@line 2913 "translate.cpp"
                            if (__label__ == 191) {
  
                              var $cmp540=((($_pr20))|0)==32; //@line 2926 "translate.cpp"
                              if (!($cmp540)) { __label__ = 195;break $if_then155$$if_else162$86; } //@line 2926 "translate.cpp"
                            }
                            else if (__label__ == 186) {
  
                              var $267=$tr_addr; //@line 2915 "translate.cpp"
                              var $langopts528=(($267)&4294967295); //@line 2915 "translate.cpp"
                              var $decimal_sep=(($langopts528+208)&4294967295); //@line 2915 "translate.cpp"
                              var $268=HEAP32[(($decimal_sep)>>2)]; //@line 2915 "translate.cpp"
                              var $cmp529=((($_pr20))|0)!=((($268))|0); //@line 2915 "translate.cpp"
                              if ($cmp529) { __label__ = 189;; } else { __label__ = 187;; } //@line 2915 "translate.cpp"
                              $if_then536$$lor_lhs_false530$259: do { 
                                if (__label__ == 187) {
  
                                  var $269=$decimal_sep_count; //@line 2915 "translate.cpp"
                                  var $cmp531=((($269))|0) > 0; //@line 2915 "translate.cpp"
                                  if ($cmp531) { __label__ = 188;; } else { __label__ = 190;; } //@line 2915 "translate.cpp"
                                  if (__label__ == 188) {
  
                                    var $270=$tr_addr; //@line 2915 "translate.cpp"
                                    var $langopts533=(($270)&4294967295); //@line 2915 "translate.cpp"
                                    var $decimal_sep534=(($langopts533+208)&4294967295); //@line 2915 "translate.cpp"
                                    var $271=HEAP32[(($decimal_sep534)>>2)]; //@line 2915 "translate.cpp"
                                    var $cmp535=((($271))|0)==44; //@line 2915 "translate.cpp"
                                    if ($cmp535) { __label__ = 189;break $if_then536$$lor_lhs_false530$259; } //@line 2915 "translate.cpp"
                                  }
  
                                  $decimal_sep_count=1; //@line 2922 "translate.cpp"
                                  __label__ = 195;break $if_then155$$if_else162$86;
                                }
                              } while(0);
  
                              $c=32; //@line 2917 "translate.cpp"
                              $space_inserted=1; //@line 2918 "translate.cpp"
                              __label__ = 195;break $if_then155$$if_else162$86; //@line 2919 "translate.cpp"
                            }
                          }
  
                          var $272=$ix; //@line 2926 "translate.cpp"
                          var $sub542=((($272)-2)&4294967295); //@line 2926 "translate.cpp"
                          var $arrayidx543=(($sbuf+$sub542)&4294967295); //@line 2926 "translate.cpp"
                          var $273=HEAP8[($arrayidx543)]; //@line 2926 "translate.cpp"
                          var $conv544=(tempInt=(($273)),(tempInt>=128?tempInt-256:tempInt)); //@line 2926 "translate.cpp"
                          var $call545=__Z7IsAlphaj($conv544); //@line 2926 "translate.cpp"
                          var $tobool546=((($call545))|0)!=0; //@line 2926 "translate.cpp"
                          if (!($tobool546)) { __label__ = 195;break $if_then155$$if_else162$86; } //@line 2926 "translate.cpp"
  
                          var $274=HEAP32[(($prev_in)>>2)]; //@line 2926 "translate.cpp"
                          var $call548=__Z7IsAlphaj($274); //@line 2926 "translate.cpp"
                          var $tobool549=((($call548))|0)!=0; //@line 2926 "translate.cpp"
                          if ($tobool549) { __label__ = 195;break $if_then155$$if_else162$86; } //@line 2926 "translate.cpp"
  
                          var $275=$ix; //@line 2929 "translate.cpp"
                          var $inc551=((($275)+1)&4294967295); //@line 2929 "translate.cpp"
                          $ix=$inc551; //@line 2929 "translate.cpp"
                          var $arrayidx552=(($sbuf+$275)&4294967295); //@line 2929 "translate.cpp"
                          HEAP8[($arrayidx552)]=32; //@line 2929 "translate.cpp"
                          var $276=$word_count; //@line 2930 "translate.cpp"
                          var $arrayidx553=(($words+$276*12)&4294967295); //@line 2930 "translate.cpp"
                          var $start554=(($arrayidx553+4)&4294967295); //@line 2930 "translate.cpp"
                          var $277=HEAP16[(($start554)>>1)]; //@line 2930 "translate.cpp"
                          var $inc555=((($277)+1)&65535); //@line 2930 "translate.cpp"
                          HEAP16[(($start554)>>1)]=$inc555; //@line 2930 "translate.cpp"
                          ; //@line 2931 "translate.cpp"
                        }
                      }
                    }
                  }
                }
              }
            }
          } while(0);
  
          var $278=$c; //@line 2935 "translate.cpp"
          var $call568=__Z7IsSpacej($278); //@line 2935 "translate.cpp"
          var $tobool569=((($call568))|0)!=0; //@line 2935 "translate.cpp"
          if ($tobool569) { __label__ = 196;; } else { __label__ = 225;; } //@line 2935 "translate.cpp"
          $if_then570$$if_else688$269: do { 
            if (__label__ == 196) {
  
              var $279=HEAP32[(($prev_out)>>2)]; //@line 2937 "translate.cpp"
              var $cmp571=((($279))|0)==32; //@line 2937 "translate.cpp"
              if ($cmp571) { __label__ = 197;; } else { __label__ = 198;; } //@line 2937 "translate.cpp"
              if (__label__ == 197) {
  
                var $280=$word_flags; //@line 2939 "translate.cpp"
                var $or573=($280) | 262144; //@line 2939 "translate.cpp"
                $word_flags=$or573; //@line 2939 "translate.cpp"
                __label__ = 33;continue $while_cond88$50; //@line 2940 "translate.cpp"
              }
              else if (__label__ == 198) {
  
                var $281=HEAP32[(($cc)>>2)]; //@line 2943 "translate.cpp"
                var $cmp575=((($281))|0)==9; //@line 2943 "translate.cpp"
                var $282=HEAP32[(($cc)>>2)]; //@line 2943 "translate.cpp"
                var $cmp577=((($282))|0)==10; //@line 2943 "translate.cpp"
                var $or_cond10=($cmp575) | ($cmp577); //@line 2943 "translate.cpp"
                if ($or_cond10) { __label__ = 199;; } else { __label__ = 200;; } //@line 2943 "translate.cpp"
                if (__label__ == 199) {
  
                  var $283=$next_word_flags; //@line 2945 "translate.cpp"
                  var $or579=($283) | 262144; //@line 2945 "translate.cpp"
                  $next_word_flags=$or579; //@line 2945 "translate.cpp"
                  ; //@line 2946 "translate.cpp"
                }
  
                var $284=$space_inserted; //@line 2948 "translate.cpp"
                var $tobool581=((($284))|0)!=0; //@line 2948 "translate.cpp"
                if ($tobool581) { __label__ = 201;; } else { __label__ = 208;; } //@line 2948 "translate.cpp"
                if (__label__ == 201) {
  
                  $j=0; //@line 2951 "translate.cpp"
                  var $285=HEAP32[(($source_index)>>2)]; //@line 2952 "translate.cpp"
                  var $sub583=((($285)-1)&4294967295); //@line 2952 "translate.cpp"
                  $k=$sub583; //@line 2952 "translate.cpp"
                  ; //@line 2953 "translate.cpp"
                  while(1) { 
  
                    var $286=$k; //@line 2953 "translate.cpp"
                    var $287=$source_index_word; //@line 2953 "translate.cpp"
                    var $cmp585=((($286))|0) >= ((($287))|0); //@line 2953 "translate.cpp"
                    if (!($cmp585)) { __label__ = 207;break ; } //@line 2953 "translate.cpp"
  
                    var $288=$k; //@line 2953 "translate.cpp"
                    var $arrayidx587=(($charix+$288*2)&4294967295); //@line 2953 "translate.cpp"
                    var $289=HEAP16[(($arrayidx587)>>1)]; //@line 2953 "translate.cpp"
                    var $conv588=(tempInt=(($289)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 2953 "translate.cpp"
                    var $cmp589=((($conv588))|0)!=0; //@line 2953 "translate.cpp"
                    if (!($cmp589)) { __label__ = 207;break ; }
  
                    var $290=$k; //@line 2955 "translate.cpp"
                    var $arrayidx592=(($charix+$290*2)&4294967295); //@line 2955 "translate.cpp"
                    var $291=HEAP16[(($arrayidx592)>>1)]; //@line 2955 "translate.cpp"
                    var $conv593=(tempInt=(($291)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 2955 "translate.cpp"
                    var $cmp594=((($conv593))|0) > 0; //@line 2955 "translate.cpp"
                    if ($cmp594) { __label__ = 205;; } else { __label__ = 206;; } //@line 2955 "translate.cpp"
                    if (__label__ == 205) {
  
                      var $292=$j; //@line 2956 "translate.cpp"
                      var $inc596=((($292)+1)&4294967295); //@line 2956 "translate.cpp"
                      $j=$inc596; //@line 2956 "translate.cpp"
                      ; //@line 2956 "translate.cpp"
                    }
  
                    var $293=$k; //@line 2957 "translate.cpp"
                    var $dec598=((($293)-1)&4294967295); //@line 2957 "translate.cpp"
                    $k=$dec598; //@line 2957 "translate.cpp"
                    __label__ = 202;continue ; //@line 2958 "translate.cpp"
                  }
  
                  var $294=$j; //@line 2959 "translate.cpp"
                  var $conv600=((($294)) & 255); //@line 2959 "translate.cpp"
                  var $295=$word_count; //@line 2959 "translate.cpp"
                  var $arrayidx601=(($words+$295*12)&4294967295); //@line 2959 "translate.cpp"
                  var $length602=(($arrayidx601+10)&4294967295); //@line 2959 "translate.cpp"
                  HEAP8[($length602)]=$conv600; //@line 2959 "translate.cpp"
                  ; //@line 2960 "translate.cpp"
                }
  
                var $296=HEAP32[(($source_index)>>2)]; //@line 2962 "translate.cpp"
                $source_index_word=$296; //@line 2962 "translate.cpp"
                var $297=$ix; //@line 2965 "translate.cpp"
                var $inc604=((($297)+1)&4294967295); //@line 2965 "translate.cpp"
                $ix=$inc604; //@line 2965 "translate.cpp"
                var $arrayidx605=(($sbuf+$297)&4294967295); //@line 2965 "translate.cpp"
                HEAP8[($arrayidx605)]=32; //@line 2965 "translate.cpp"
                var $298=$word_count; //@line 2967 "translate.cpp"
                var $cmp606=((($298))|0) < 299; //@line 2967 "translate.cpp"
                if ($cmp606) { __label__ = 209;; } else { __label__ = 223;; } //@line 2967 "translate.cpp"
                $land_lhs_true607$$if_end684$288: do { 
                  if (__label__ == 209) {
  
                    var $299=$ix; //@line 2967 "translate.cpp"
                    var $300=$word_count; //@line 2967 "translate.cpp"
                    var $arrayidx608=(($words+$300*12)&4294967295); //@line 2967 "translate.cpp"
                    var $start609=(($arrayidx608+4)&4294967295); //@line 2967 "translate.cpp"
                    var $301=HEAPU16[(($start609)>>1)]; //@line 2967 "translate.cpp"
                    var $conv610=((($301))&65535); //@line 2967 "translate.cpp"
                    var $cmp611=((($299))|0) > ((($conv610))|0); //@line 2967 "translate.cpp"
                    if (!($cmp611)) { __label__ = 223;break $land_lhs_true607$$if_end684$288; } //@line 2967 "translate.cpp"
  
                    var $302=$embedded_count; //@line 2969 "translate.cpp"
                    var $cmp613=((($302))|0) > 0; //@line 2969 "translate.cpp"
                    if ($cmp613) { __label__ = 211;; } else { __label__ = 212;; } //@line 2969 "translate.cpp"
                    if (__label__ == 211) {
  
                      var $303=HEAP32[((__ZL11embedded_ix)>>2)]; //@line 2972 "translate.cpp"
                      var $sub615=((($303)-1)&4294967295); //@line 2972 "translate.cpp"
                      var $arrayidx616=((_embedded_list+$sub615*4)&4294967295); //@line 2972 "translate.cpp"
                      var $304=HEAP32[(($arrayidx616)>>2)]; //@line 2972 "translate.cpp"
                      var $or617=($304) | 128; //@line 2972 "translate.cpp"
                      HEAP32[(($arrayidx616)>>2)]=$or617; //@line 2972 "translate.cpp"
                      var $305=$word_count; //@line 2973 "translate.cpp"
                      var $arrayidx618=(($words+$305*12)&4294967295); //@line 2973 "translate.cpp"
                      var $flags619=(($arrayidx618)&4294967295); //@line 2973 "translate.cpp"
                      var $306=HEAP32[(($flags619)>>2)]; //@line 2973 "translate.cpp"
                      var $or620=($306) | 64; //@line 2973 "translate.cpp"
                      HEAP32[(($flags619)>>2)]=$or620; //@line 2973 "translate.cpp"
                      $embedded_count=0; //@line 2974 "translate.cpp"
                      ; //@line 2975 "translate.cpp"
                    }
  
                    var $307=HEAP32[((_pre_pause)>>2)]; //@line 2976 "translate.cpp"
                    var $conv622=((($307)) & 255); //@line 2976 "translate.cpp"
                    var $308=$word_count; //@line 2976 "translate.cpp"
                    var $arrayidx623=(($words+$308*12)&4294967295); //@line 2976 "translate.cpp"
                    var $pre_pause=(($arrayidx623+8)&4294967295); //@line 2976 "translate.cpp"
                    HEAP8[($pre_pause)]=$conv622; //@line 2976 "translate.cpp"
                    var $309=$all_upper_case; //@line 2977 "translate.cpp"
                    var $310=$word_flags; //@line 2977 "translate.cpp"
                    var $_b=HEAPU8[(__ZL13word_emphasis_b)];
                    var $311=($_b) ? 2048 : 0;
                    var $312=$word_count; //@line 2977 "translate.cpp"
                    var $arrayidx626=(($words+$312*12)&4294967295); //@line 2977 "translate.cpp"
                    var $flags627=(($arrayidx626)&4294967295); //@line 2977 "translate.cpp"
                    var $313=HEAP32[(($flags627)>>2)]; //@line 2977 "translate.cpp"
                    var $or624=($310) | ($309); //@line 2977 "translate.cpp"
                    var $or625=($or624) | ($311); //@line 2977 "translate.cpp"
                    var $or628=($or625) | ($313); //@line 2977 "translate.cpp"
                    HEAP32[(($flags627)>>2)]=$or628; //@line 2977 "translate.cpp"
                    var $314=$word_mark; //@line 2978 "translate.cpp"
                    var $conv629=((($314)) & 255); //@line 2978 "translate.cpp"
                    var $315=$word_count; //@line 2978 "translate.cpp"
                    var $arrayidx630=(($words+$315*12)&4294967295); //@line 2978 "translate.cpp"
                    var $wmark=(($arrayidx630+9)&4294967295); //@line 2978 "translate.cpp"
                    HEAP8[($wmark)]=$conv629; //@line 2978 "translate.cpp"
                    var $316=HEAP32[((_pre_pause)>>2)]; //@line 2980 "translate.cpp"
                    var $cmp631=((($316))|0) > 0; //@line 2980 "translate.cpp"
                    if ($cmp631) { __label__ = 213;; } else { __label__ = 216;; } //@line 2980 "translate.cpp"
                    if (__label__ == 213) {
  
                      var $317=$ix; //@line 2983 "translate.cpp"
                      $j=$317; //@line 2983 "translate.cpp"
                      var $318=$j; //@line 2983 "translate.cpp"
                      var $319=$word_count; //@line 2983 "translate.cpp"
                      var $arrayidx63438=(($words+$319*12)&4294967295); //@line 2983 "translate.cpp"
                      var $start63539=(($arrayidx63438+4)&4294967295); //@line 2983 "translate.cpp"
                      var $320=HEAPU16[(($start63539)>>1)]; //@line 2983 "translate.cpp"
                      var $conv63640=((($320))&65535); //@line 2983 "translate.cpp"
                      var $cmp63741=((($318))|0) > ((($conv63640))|0); //@line 2983 "translate.cpp"
                      var $321=$j; //@line 2985 "translate.cpp"
                      if ($cmp63741) { __lastLabel__ = 213; __label__ = 214;; } else { __lastLabel__ = 213; __label__ = 215;; } //@line 2983 "translate.cpp"
                      $for_body638$$for_end644$296: do { 
                        if (__label__ == 214) {
                          while(1) { 
  
                            var $322=__lastLabel__ == 214 ? $329 : ($321);
                            var $sub639=((($322)-1)&4294967295); //@line 2985 "translate.cpp"
                            var $arrayidx640=(($sbuf+$sub639)&4294967295); //@line 2985 "translate.cpp"
                            var $323=HEAP8[($arrayidx640)]; //@line 2985 "translate.cpp"
                            var $324=$j; //@line 2985 "translate.cpp"
                            var $arrayidx641=(($sbuf+$324)&4294967295); //@line 2985 "translate.cpp"
                            HEAP8[($arrayidx641)]=$323; //@line 2985 "translate.cpp"
                            var $325=$j; //@line 2983 "translate.cpp"
                            var $dec643=((($325)-1)&4294967295); //@line 2983 "translate.cpp"
                            $j=$dec643; //@line 2983 "translate.cpp"
                            var $326=$j; //@line 2983 "translate.cpp"
                            var $327=$word_count; //@line 2983 "translate.cpp"
                            var $arrayidx634=(($words+$327*12)&4294967295); //@line 2983 "translate.cpp"
                            var $start635=(($arrayidx634+4)&4294967295); //@line 2983 "translate.cpp"
                            var $328=HEAPU16[(($start635)>>1)]; //@line 2983 "translate.cpp"
                            var $conv636=((($328))&65535); //@line 2983 "translate.cpp"
                            var $cmp637=((($326))|0) > ((($conv636))|0); //@line 2983 "translate.cpp"
                            var $329=$j; //@line 2985 "translate.cpp"
                            if ($cmp637) { __lastLabel__ = 214; __label__ = 214;continue ; } else { __lastLabel__ = 214; __label__ = 215;break $for_body638$$for_end644$296; } //@line 2983 "translate.cpp"
                          }
                        }
                      } while(0);
  
                      var $_lcssa37=__lastLabel__ == 213 ? $321 : ($329);
                      var $arrayidx645=(($sbuf+$_lcssa37)&4294967295); //@line 2987 "translate.cpp"
                      HEAP8[($arrayidx645)]=32; //@line 2987 "translate.cpp"
                      var $330=$word_count; //@line 2988 "translate.cpp"
                      var $arrayidx646=(($words+$330*12)&4294967295); //@line 2988 "translate.cpp"
                      var $start647=(($arrayidx646+4)&4294967295); //@line 2988 "translate.cpp"
                      var $331=HEAP16[(($start647)>>1)]; //@line 2988 "translate.cpp"
                      var $inc648=((($331)+1)&65535); //@line 2988 "translate.cpp"
                      HEAP16[(($start647)>>1)]=$inc648; //@line 2988 "translate.cpp"
                      var $332=$ix; //@line 2989 "translate.cpp"
                      var $inc649=((($332)+1)&4294967295); //@line 2989 "translate.cpp"
                      $ix=$inc649; //@line 2989 "translate.cpp"
                      ; //@line 2990 "translate.cpp"
                    }
  
                    var $333=$word_count; //@line 2992 "translate.cpp"
                    var $inc651=((($333)+1)&4294967295); //@line 2992 "translate.cpp"
                    $word_count=$inc651; //@line 2992 "translate.cpp"
                    var $334=$ix; //@line 2993 "translate.cpp"
                    var $conv652=((($334)) & 65535); //@line 2993 "translate.cpp"
                    var $335=$word_count; //@line 2993 "translate.cpp"
                    var $arrayidx653=(($words+$335*12)&4294967295); //@line 2993 "translate.cpp"
                    var $start654=(($arrayidx653+4)&4294967295); //@line 2993 "translate.cpp"
                    HEAP16[(($start654)>>1)]=$conv652; //@line 2993 "translate.cpp"
                    var $336=$word_count; //@line 2994 "translate.cpp"
                    var $arrayidx655=(($words+$336*12)&4294967295); //@line 2994 "translate.cpp"
                    var $flags656=(($arrayidx655)&4294967295); //@line 2994 "translate.cpp"
                    HEAP32[(($flags656)>>2)]=0; //@line 2994 "translate.cpp"
                    var $337=HEAP32[(($source_index)>>2)]; //@line 2996 "translate.cpp"
                    $j=$337; //@line 2996 "translate.cpp"
                    var $338=$j; //@line 2996 "translate.cpp"
                    var $arrayidx65844=(($charix+$338*2)&4294967295); //@line 2996 "translate.cpp"
                    var $339=HEAP16[(($arrayidx65844)>>1)]; //@line 2996 "translate.cpp"
                    var $conv65945=(tempInt=(($339)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 2996 "translate.cpp"
                    var $cmp66046=((($conv65945))|0) <= 0; //@line 2996 "translate.cpp"
                    var $340=$j; //@line 2996 "translate.cpp"
                    if ($cmp66046) { __lastLabel__ = 216; __label__ = 217;; } else { __lastLabel__ = 216; __label__ = 218;; } //@line 2996 "translate.cpp"
                    $for_inc662$$for_end664$301: do { 
                      if (__label__ == 217) {
                        while(1) { 
  
                          var $341=__lastLabel__ == 217 ? $344 : ($340);
                          var $inc663=((($341)+1)&4294967295); //@line 2996 "translate.cpp"
                          $j=$inc663; //@line 2996 "translate.cpp"
                          var $342=$j; //@line 2996 "translate.cpp"
                          var $arrayidx658=(($charix+$342*2)&4294967295); //@line 2996 "translate.cpp"
                          var $343=HEAP16[(($arrayidx658)>>1)]; //@line 2996 "translate.cpp"
                          var $conv659=(tempInt=(($343)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 2996 "translate.cpp"
                          var $cmp660=((($conv659))|0) <= 0; //@line 2996 "translate.cpp"
                          var $344=$j; //@line 2996 "translate.cpp"
                          if ($cmp660) { __lastLabel__ = 217; __label__ = 217;continue ; } else { __lastLabel__ = 217; __label__ = 218;break $for_inc662$$for_end664$301; } //@line 2996 "translate.cpp"
                        }
                      }
                    } while(0);
  
                    var $_lcssa43=__lastLabel__ == 216 ? $340 : ($344);
                    var $arrayidx665=(($charix+$_lcssa43*2)&4294967295); //@line 2997 "translate.cpp"
                    var $345=HEAP16[(($arrayidx665)>>1)]; //@line 2997 "translate.cpp"
                    var $346=$word_count; //@line 2997 "translate.cpp"
                    var $arrayidx666=(($words+$346*12)&4294967295); //@line 2997 "translate.cpp"
                    var $sourceix667=(($arrayidx666+6)&4294967295); //@line 2997 "translate.cpp"
                    HEAP16[(($sourceix667)>>1)]=$345; //@line 2997 "translate.cpp"
                    $k=0; //@line 2998 "translate.cpp"
                    var $347=$j; //@line 2999 "translate.cpp"
                    var $arrayidx66948=(($charix+$347*2)&4294967295); //@line 2999 "translate.cpp"
                    var $348=HEAP16[(($arrayidx66948)>>1)]; //@line 2999 "translate.cpp"
                    var $conv67049=(tempInt=(($348)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 2999 "translate.cpp"
                    var $cmp67150=((($conv67049))|0)!=0; //@line 2999 "translate.cpp"
                    if ($cmp67150) { __label__ = 219;; } else { __label__ = 222;; } //@line 2999 "translate.cpp"
                    $while_body672$$while_end680$305: do { 
                      if (__label__ == 219) {
                        while(1) { 
  
                          var $349=$j; //@line 3002 "translate.cpp"
                          var $inc673=((($349)+1)&4294967295); //@line 3002 "translate.cpp"
                          $j=$inc673; //@line 3002 "translate.cpp"
                          var $arrayidx674=(($charix+$349*2)&4294967295); //@line 3002 "translate.cpp"
                          var $350=HEAP16[(($arrayidx674)>>1)]; //@line 3002 "translate.cpp"
                          var $conv675=(tempInt=(($350)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 3002 "translate.cpp"
                          var $cmp676=((($conv675))|0)!=-1; //@line 3002 "translate.cpp"
                          if ($cmp676) { __label__ = 220;; } else { __label__ = 221;; } //@line 3002 "translate.cpp"
                          if (__label__ == 220) {
  
                            var $351=$k; //@line 3003 "translate.cpp"
                            var $inc678=((($351)+1)&4294967295); //@line 3003 "translate.cpp"
                            $k=$inc678; //@line 3003 "translate.cpp"
                            ; //@line 3003 "translate.cpp"
                          }
  
                          var $352=$j; //@line 2999 "translate.cpp"
                          var $arrayidx669=(($charix+$352*2)&4294967295); //@line 2999 "translate.cpp"
                          var $353=HEAP16[(($arrayidx669)>>1)]; //@line 2999 "translate.cpp"
                          var $conv670=(tempInt=(($353)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 2999 "translate.cpp"
                          var $cmp671=((($conv670))|0)!=0; //@line 2999 "translate.cpp"
                          if ($cmp671) { __label__ = 219;continue ; } else { __label__ = 222;break $while_body672$$while_end680$305; } //@line 2999 "translate.cpp"
                        }
                      }
                    } while(0);
  
                    var $354=$k; //@line 3005 "translate.cpp"
                    var $conv681=((($354)) & 255); //@line 3005 "translate.cpp"
                    var $355=$word_count; //@line 3005 "translate.cpp"
                    var $arrayidx682=(($words+$355*12)&4294967295); //@line 3005 "translate.cpp"
                    var $length683=(($arrayidx682+10)&4294967295); //@line 3005 "translate.cpp"
                    HEAP8[($length683)]=$conv681; //@line 3005 "translate.cpp"
                    var $356=$next_word_flags; //@line 3007 "translate.cpp"
                    $word_flags=$356; //@line 3007 "translate.cpp"
                    $next_word_flags=0; //@line 3008 "translate.cpp"
                    HEAP32[((_pre_pause)>>2)]=0; //@line 3009 "translate.cpp"
                    $word_mark=0; //@line 3010 "translate.cpp"
                    $all_upper_case=1; //@line 3011 "translate.cpp"
                    $syllable_marked=0; //@line 3012 "translate.cpp"
                    ; //@line 3013 "translate.cpp"
                  }
                } while(0);
  
                var $357=$space_inserted; //@line 3015 "translate.cpp"
                var $tobool685=((($357))|0)!=0; //@line 3015 "translate.cpp"
                if (!($tobool685)) { __label__ = 227;break $if_then570$$if_else688$269; } //@line 3015 "translate.cpp"
  
                var $358=$prev_source_index; //@line 3017 "translate.cpp"
                HEAP32[(($source_index)>>2)]=$358; //@line 3017 "translate.cpp"
                HEAP32[(($char_inserted)>>2)]=0; //@line 3018 "translate.cpp"
                $space_inserted=0; //@line 3019 "translate.cpp"
                ; //@line 3020 "translate.cpp"
              }
            }
            else if (__label__ == 225) {
  
              var $359=$ix; //@line 3024 "translate.cpp"
              var $cmp689=((($359))|0) < 696; //@line 3024 "translate.cpp"
              if (!($cmp689)) { __label__ = 227;break $if_then570$$if_else688$269; } //@line 3024 "translate.cpp"
  
              var $360=$c; //@line 3025 "translate.cpp"
              var $361=$ix; //@line 3025 "translate.cpp"
              var $arrayidx691=(($sbuf+$361)&4294967295); //@line 3025 "translate.cpp"
              var $call692=__Z8utf8_outjPc($360, $arrayidx691); //@line 3025 "translate.cpp"
              var $362=$ix; //@line 3025 "translate.cpp"
              var $add693=((($362)+($call692))&4294967295); //@line 3025 "translate.cpp"
              $ix=$add693; //@line 3025 "translate.cpp"
              ; //@line 3025 "translate.cpp"
            }
          } while(0);
  
          var $363=$pre_pause_add; //@line 3027 "translate.cpp"
          var $364=HEAP32[((_pre_pause)>>2)]; //@line 3027 "translate.cpp"
          var $cmp696=((($363))|0) > ((($364))|0); //@line 3027 "translate.cpp"
          if ($cmp696) { __label__ = 228;; } else { __label__ = 229;; } //@line 3027 "translate.cpp"
          if (__label__ == 228) {
  
            var $365=$pre_pause_add; //@line 3028 "translate.cpp"
            HEAP32[((_pre_pause)>>2)]=$365; //@line 3028 "translate.cpp"
            ; //@line 3028 "translate.cpp"
          }
  
          $pre_pause_add=0; //@line 3029 "translate.cpp"
          __label__ = 33;continue $while_cond88$50; //@line 3030 "translate.cpp"
        }
  
        var $366=$word_count; //@line 3032 "translate.cpp"
        var $cmp700=((($366))|0)==0; //@line 3032 "translate.cpp"
        if ($cmp700) { __label__ = 231;; } else { __label__ = 233;; } //@line 3032 "translate.cpp"
        $land_lhs_true701$$if_end710$321: do { 
          if (__label__ == 231) {
  
            var $367=$embedded_count; //@line 3032 "translate.cpp"
            var $cmp702=((($367))|0) > 0; //@line 3032 "translate.cpp"
            if (!($cmp702)) { __label__ = 233;break $land_lhs_true701$$if_end710$321; } //@line 3032 "translate.cpp"
  
            var $368=HEAP32[((__ZL11embedded_ix)>>2)]; //@line 3035 "translate.cpp"
            var $sub704=((($368)-1)&4294967295); //@line 3035 "translate.cpp"
            var $arrayidx705=((_embedded_list+$sub704*4)&4294967295); //@line 3035 "translate.cpp"
            var $369=HEAP32[(($arrayidx705)>>2)]; //@line 3035 "translate.cpp"
            var $or706=($369) | 128; //@line 3035 "translate.cpp"
            HEAP32[(($arrayidx705)>>2)]=$or706; //@line 3035 "translate.cpp"
            var $370=$word_count; //@line 3036 "translate.cpp"
            var $arrayidx707=(($words+$370*12)&4294967295); //@line 3036 "translate.cpp"
            var $flags708=(($arrayidx707)&4294967295); //@line 3036 "translate.cpp"
            var $371=HEAP32[(($flags708)>>2)]; //@line 3036 "translate.cpp"
            var $or709=($371) | 64; //@line 3036 "translate.cpp"
            HEAP32[(($flags708)>>2)]=$or709; //@line 3036 "translate.cpp"
            $word_count=1; //@line 3037 "translate.cpp"
            ; //@line 3038 "translate.cpp"
          }
        } while(0);
  
        var $372=$ix; //@line 3040 "translate.cpp"
        var $sub711=((($372)-1)&4294967295); //@line 3040 "translate.cpp"
        var $arrayidx712=(($sbuf+$sub711)&4294967295); //@line 3040 "translate.cpp"
        var $373=$tr_addr; //@line 3040 "translate.cpp"
        var $clause_end=(($373+8292)&4294967295); //@line 3040 "translate.cpp"
        HEAP32[(($clause_end)>>2)]=$arrayidx712; //@line 3040 "translate.cpp"
        var $374=$ix; //@line 3041 "translate.cpp"
        var $arrayidx713=(($sbuf+$374)&4294967295); //@line 3041 "translate.cpp"
        HEAP8[($arrayidx713)]=0; //@line 3041 "translate.cpp"
        var $arrayidx714=(($words)&4294967295); //@line 3042 "translate.cpp"
        var $pre_pause715=(($arrayidx714+8)&4294967295); //@line 3042 "translate.cpp"
        HEAP8[($pre_pause715)]=0; //@line 3042 "translate.cpp"
        var $375=$word_count; //@line 3043 "translate.cpp"
        var $arrayidx716=(($words+$375*12)&4294967295); //@line 3043 "translate.cpp"
        var $pre_pause717=(($arrayidx716+8)&4294967295); //@line 3043 "translate.cpp"
        HEAP8[($pre_pause717)]=8; //@line 3043 "translate.cpp"
        var $376=$word_count; //@line 3044 "translate.cpp"
        var $cmp718=((($376))|0) > 0; //@line 3044 "translate.cpp"
        if ($cmp718) { __label__ = 234;; } else { __label__ = 241;; } //@line 3044 "translate.cpp"
        $if_then719$$if_end751$325: do { 
          if (__label__ == 234) {
  
            var $377=$word_count; //@line 3046 "translate.cpp"
            var $sub720=((($377)-1)&4294967295); //@line 3046 "translate.cpp"
            $ix=$sub720; //@line 3046 "translate.cpp"
            __lastLabel__ = 234; ; //@line 3047 "translate.cpp"
            while(1) { 
  
              var $378=__lastLabel__ == 237 ? $dec732 : ($sub720); //@line 3047 "translate.cpp"
              var $cmp722=((($378))|0) > 0; //@line 3047 "translate.cpp"
              var $379=$ix; //@line 3047 "translate.cpp"
              if ($cmp722) { __lastLabel__ = 235; ; } else { __lastLabel__ = 235; __label__ = 238;break ; } //@line 3047 "translate.cpp"
  
              var $arrayidx724=(($words+$379*12)&4294967295); //@line 3047 "translate.cpp"
              var $start725=(($arrayidx724+4)&4294967295); //@line 3047 "translate.cpp"
              var $380=HEAPU16[(($start725)>>1)]; //@line 3047 "translate.cpp"
              var $idxprom=((($380))&65535); //@line 3047 "translate.cpp"
              var $arrayidx726=(($sbuf+$idxprom)&4294967295); //@line 3047 "translate.cpp"
              var $381=HEAP8[($arrayidx726)]; //@line 3047 "translate.cpp"
              var $conv727=(tempInt=(($381)),(tempInt>=128?tempInt-256:tempInt)); //@line 3047 "translate.cpp"
              var $call728=__Z9IsBracketi($conv727); //@line 3047 "translate.cpp"
              var $tobool729=((($call728))|0)!=0; //@line 3047 "translate.cpp"
              var $382=$ix; //@line 3048 "translate.cpp"
              if ($tobool729) { __lastLabel__ = 236; ; } else { __lastLabel__ = 236; __label__ = 238;break ; }
  
              var $dec732=((($382)-1)&4294967295); //@line 3048 "translate.cpp"
              $ix=$dec732; //@line 3048 "translate.cpp"
              __lastLabel__ = 237; __label__ = 235;continue ; //@line 3048 "translate.cpp"
            }
  
            var $383=__lastLabel__ == 236 ? $382 : ($379);
            var $arrayidx734=(($words+$383*12)&4294967295); //@line 3049 "translate.cpp"
            var $flags735=(($arrayidx734)&4294967295); //@line 3049 "translate.cpp"
            var $384=HEAP32[(($flags735)>>2)]; //@line 3049 "translate.cpp"
            var $or736=($384) | 16; //@line 3049 "translate.cpp"
            HEAP32[(($flags735)>>2)]=$or736; //@line 3049 "translate.cpp"
            var $385=$terminator; //@line 3052 "translate.cpp"
            var $and737=($385) & 4194304; //@line 3052 "translate.cpp"
            var $tobool738=((($and737))|0)!=0; //@line 3052 "translate.cpp"
            if (!($tobool738)) { __label__ = 241;break $if_then719$$if_end751$325; } //@line 3052 "translate.cpp"
  
            var $386=$word_count; //@line 3052 "translate.cpp"
            var $sub740=((($386)-1)&4294967295); //@line 3052 "translate.cpp"
            var $arrayidx741=(($words+$sub740*12)&4294967295); //@line 3052 "translate.cpp"
            var $flags742=(($arrayidx741)&4294967295); //@line 3052 "translate.cpp"
            var $387=HEAP32[(($flags742)>>2)]; //@line 3052 "translate.cpp"
            var $and743=($387) & 256; //@line 3052 "translate.cpp"
            var $tobool744=((($and743))|0)!=0; //@line 3052 "translate.cpp"
            if ($tobool744) { __label__ = 241;break $if_then719$$if_end751$325; } //@line 3052 "translate.cpp"
  
            var $388=$word_count; //@line 3053 "translate.cpp"
            var $sub746=((($388)-1)&4294967295); //@line 3053 "translate.cpp"
            var $arrayidx747=(($words+$sub746*12)&4294967295); //@line 3053 "translate.cpp"
            var $flags748=(($arrayidx747)&4294967295); //@line 3053 "translate.cpp"
            var $389=HEAP32[(($flags748)>>2)]; //@line 3053 "translate.cpp"
            var $or749=($389) | 65536; //@line 3053 "translate.cpp"
            HEAP32[(($flags748)>>2)]=$or749; //@line 3053 "translate.cpp"
            ; //@line 3053 "translate.cpp"
          }
        } while(0);
  
        var $arrayidx752=(($words)&4294967295); //@line 3055 "translate.cpp"
        var $flags753=(($arrayidx752)&4294967295); //@line 3055 "translate.cpp"
        var $390=HEAP32[(($flags753)>>2)]; //@line 3055 "translate.cpp"
        var $or754=($390) | 512; //@line 3055 "translate.cpp"
        HEAP32[(($flags753)>>2)]=$or754; //@line 3055 "translate.cpp"
        $ix=0; //@line 3058 "translate.cpp"
        var $391=$ix; //@line 3058 "translate.cpp"
        var $392=$word_count; //@line 3058 "translate.cpp"
        var $cmp75636=((($391))|0) < ((($392))|0); //@line 3058 "translate.cpp"
        if ($cmp75636) { __label__ = 242;; } else { __label__ = 296;; } //@line 3058 "translate.cpp"
        $for_body757_lr_ph$$for_end994$335: do { 
          if (__label__ == 242) {
  
            var $arraydecay781=(($number_buf)&4294967295); //@line 3086 "translate.cpp"
            var $arrayidx783=(($number_buf+130)&4294967295); //@line 3087 "translate.cpp"
            var $arraydecay816=(($number_buf)&4294967295); //@line 3104 "translate.cpp"
            var $sub_ptr_rhs_cast818=($arraydecay816); //@line 3104 "translate.cpp"
            var $arraydecay820=(($number_buf)&4294967295); //@line 3105 "translate.cpp"
            var $arrayidx836=(($number_buf)&4294967295); //@line 3117 "translate.cpp"
            var $arrayidx837=(($number_buf+1)&4294967295); //@line 3118 "translate.cpp"
            var $arrayidx850=(($number_buf+130)&4294967295); //@line 3126 "translate.cpp"
            var $arrayidx920=(($number_buf+1)&4294967295); //@line 3167 "translate.cpp"
            var $arraydecay967=(($number_buf)&4294967295); //@line 3191 "translate.cpp"
            var $arrayidx969=(($number_buf+2)&4294967295); //@line 3193 "translate.cpp"
            var $arrayidx970=(($number_buf+2)&4294967295); //@line 3194 "translate.cpp"
            ; //@line 3058 "translate.cpp"
            $for_body757$337: while(1) { 
  
              var $393=HEAP32[((_count_words)>>2)]; //@line 3069 "translate.cpp"
              var $inc758=((($393)+1)&4294967295); //@line 3069 "translate.cpp"
              HEAP32[((_count_words)>>2)]=$inc758; //@line 3069 "translate.cpp"
              var $394=HEAP32[((_skip_words)>>2)]; //@line 3070 "translate.cpp"
              var $cmp759=((($394))|0) > 0; //@line 3070 "translate.cpp"
              if ($cmp759) { __label__ = 244;; } else { __label__ = 246;; } //@line 3070 "translate.cpp"
              $if_then760$$if_end765$339: do { 
                if (__label__ == 244) {
  
                  var $395=HEAP32[((_skip_words)>>2)]; //@line 3072 "translate.cpp"
                  var $dec761=((($395)-1)&4294967295); //@line 3072 "translate.cpp"
                  HEAP32[((_skip_words)>>2)]=$dec761; //@line 3072 "translate.cpp"
                  var $396=HEAP32[((_skip_words)>>2)]; //@line 3073 "translate.cpp"
                  var $cmp762=((($396))|0)==0; //@line 3073 "translate.cpp"
                  if (!($cmp762)) { __label__ = 246;break $if_then760$$if_end765$339; } //@line 3073 "translate.cpp"
  
                  HEAP32[((_skipping_text)>>2)]=0; //@line 3074 "translate.cpp"
                  __label__ = 247;break $if_then760$$if_end765$339; //@line 3076 "translate.cpp"
                }
              } while(0);
              $if_end768$$if_end765$342: do { 
                if (__label__ == 246) {
  
                  var $_pr22=HEAP32[((_skipping_text)>>2)]; //@line 3076 "translate.cpp"
                  var $tobool766=((($_pr22))|0)!=0; //@line 3076 "translate.cpp"
                  if ($tobool766) { __label__ = 295;break $if_end768$$if_end765$342; } else { __label__ = 247;break $if_end768$$if_end765$342; } //@line 3076 "translate.cpp"
                }
              } while(0);
              $if_end768$$for_inc992$344: do { 
                if (__label__ == 247) {
  
                  var $397=$ix; //@line 3081 "translate.cpp"
                  var $arrayidx769=(($words+$397*12)&4294967295); //@line 3081 "translate.cpp"
                  var $start770=(($arrayidx769+4)&4294967295); //@line 3081 "translate.cpp"
                  var $398=HEAPU16[(($start770)>>1)]; //@line 3081 "translate.cpp"
                  var $idxprom771=((($398))&65535); //@line 3081 "translate.cpp"
                  var $arrayidx772=(($sbuf+$idxprom771)&4294967295); //@line 3081 "translate.cpp"
                  $pw=$arrayidx772; //@line 3081 "translate.cpp"
                  $word=$arrayidx772; //@line 3081 "translate.cpp"
                  var $399=$word; //@line 3083 "translate.cpp"
                  var $arrayidx773=(($399)&4294967295); //@line 3083 "translate.cpp"
                  var $400=HEAP8[($arrayidx773)]; //@line 3083 "translate.cpp"
                  var $conv774=(tempInt=(($400)),(tempInt>=128?tempInt-256:tempInt)); //@line 3083 "translate.cpp"
                  var $call775=_iswdigit($conv774); //@line 3083 "translate.cpp"
                  var $tobool776=((($call775))|0)!=0; //@line 3083 "translate.cpp"
                  if ($tobool776) { __label__ = 248;; } else { __label__ = 261;; } //@line 3083 "translate.cpp"
                  $land_lhs_true777$$if_end824$346: do { 
                    if (__label__ == 248) {
  
                      var $401=$tr_addr; //@line 3083 "translate.cpp"
                      var $langopts778=(($401)&4294967295); //@line 3083 "translate.cpp"
                      var $break_numbers=(($langopts778+192)&4294967295); //@line 3083 "translate.cpp"
                      var $402=HEAP32[(($break_numbers)>>2)]; //@line 3083 "translate.cpp"
                      var $cmp779=((($402))|0)!=1227133512; //@line 3083 "translate.cpp"
                      if (!($cmp779)) { __label__ = 261;break $land_lhs_true777$$if_end824$346; } //@line 3083 "translate.cpp"
  
                      $pn=$arraydecay781; //@line 3086 "translate.cpp"
                      ; //@line 3087 "translate.cpp"
                      while(1) { 
  
                        var $403=$pn; //@line 3087 "translate.cpp"
                        var $cmp784=((($403))>>>0) < ((($arrayidx783))>>>0); //@line 3087 "translate.cpp"
                        if (!($cmp784)) { __label__ = 260;break ; } //@line 3087 "translate.cpp"
  
                        var $404=$pw; //@line 3089 "translate.cpp"
                        var $405=HEAP8[($404)]; //@line 3089 "translate.cpp"
                        var $conv786=(tempInt=(($405)),(tempInt>=128?tempInt-256:tempInt)); //@line 3089 "translate.cpp"
                        var $call787=_iswdigit($conv786); //@line 3089 "translate.cpp"
                        var $tobool788=((($call787))|0)!=0; //@line 3089 "translate.cpp"
                        var $406=$pw; //@line 3091 "translate.cpp"
                        if ($tobool788) { __label__ = 252;; } else { __label__ = 253;; } //@line 3089 "translate.cpp"
                        if (__label__ == 252) {
  
                          var $incdec_ptr790=(($406+1)&4294967295); //@line 3091 "translate.cpp"
                          $pw=$incdec_ptr790; //@line 3091 "translate.cpp"
                          var $407=HEAP8[($406)]; //@line 3091 "translate.cpp"
                          var $408=$pn; //@line 3091 "translate.cpp"
                          var $incdec_ptr791=(($408+1)&4294967295); //@line 3091 "translate.cpp"
                          $pn=$incdec_ptr791; //@line 3091 "translate.cpp"
                          HEAP8[($408)]=$407; //@line 3091 "translate.cpp"
                          __label__ = 250;continue ; //@line 3092 "translate.cpp"
                        }
                        else if (__label__ == 253) {
  
                          var $409=HEAP8[($406)]; //@line 3094 "translate.cpp"
                          var $conv793=(tempInt=(($409)),(tempInt>=128?tempInt-256:tempInt)); //@line 3094 "translate.cpp"
                          var $410=$tr_addr; //@line 3094 "translate.cpp"
                          var $langopts794=(($410)&4294967295); //@line 3094 "translate.cpp"
                          var $thousands_sep=(($langopts794+204)&4294967295); //@line 3094 "translate.cpp"
                          var $411=HEAP32[(($thousands_sep)>>2)]; //@line 3094 "translate.cpp"
                          var $cmp795=((($conv793))|0)==((($411))|0); //@line 3094 "translate.cpp"
                          if (!($cmp795)) { __label__ = 259;break ; } //@line 3094 "translate.cpp"
  
                          var $412=$pw; //@line 3094 "translate.cpp"
                          var $arrayidx797=(($412+1)&4294967295); //@line 3094 "translate.cpp"
                          var $413=HEAP8[($arrayidx797)]; //@line 3094 "translate.cpp"
                          var $conv798=(tempInt=(($413)),(tempInt>=128?tempInt-256:tempInt)); //@line 3094 "translate.cpp"
                          var $cmp799=((($conv798))|0)==32; //@line 3094 "translate.cpp"
                          if (!($cmp799)) { __label__ = 259;break ; } //@line 3094 "translate.cpp"
  
                          var $414=$pw; //@line 3095 "translate.cpp"
                          var $arrayidx801=(($414+2)&4294967295); //@line 3095 "translate.cpp"
                          var $415=HEAP8[($arrayidx801)]; //@line 3095 "translate.cpp"
                          var $conv802=(tempInt=(($415)),(tempInt>=128?tempInt-256:tempInt)); //@line 3095 "translate.cpp"
                          var $call803=_iswdigit($conv802); //@line 3095 "translate.cpp"
                          var $tobool804=((($call803))|0)!=0; //@line 3095 "translate.cpp"
                          if (!($tobool804)) { __label__ = 259;break ; } //@line 3095 "translate.cpp"
  
                          var $416=$pw; //@line 3095 "translate.cpp"
                          var $arrayidx806=(($416+3)&4294967295); //@line 3095 "translate.cpp"
                          var $417=HEAP8[($arrayidx806)]; //@line 3095 "translate.cpp"
                          var $conv807=(tempInt=(($417)),(tempInt>=128?tempInt-256:tempInt)); //@line 3095 "translate.cpp"
                          var $cmp808=((($conv807))|0)!=32; //@line 3095 "translate.cpp"
                          if (!($cmp808)) { __label__ = 259;break ; } //@line 3095 "translate.cpp"
  
                          var $418=$pw; //@line 3095 "translate.cpp"
                          var $arrayidx810=(($418+4)&4294967295); //@line 3095 "translate.cpp"
                          var $419=HEAP8[($arrayidx810)]; //@line 3095 "translate.cpp"
                          var $conv811=(tempInt=(($419)),(tempInt>=128?tempInt-256:tempInt)); //@line 3095 "translate.cpp"
                          var $cmp812=((($conv811))|0)!=32; //@line 3095 "translate.cpp"
                          if (!($cmp812)) { __label__ = 259;break ; } //@line 3095 "translate.cpp"
  
                          var $420=$pw; //@line 3097 "translate.cpp"
                          var $add_ptr=(($420+2)&4294967295); //@line 3097 "translate.cpp"
                          $pw=$add_ptr; //@line 3097 "translate.cpp"
                          var $421=$ix; //@line 3098 "translate.cpp"
                          var $inc814=((($421)+1)&4294967295); //@line 3098 "translate.cpp"
                          $ix=$inc814; //@line 3098 "translate.cpp"
                          __label__ = 250;continue ;
                        }
                      }
                      if (__label__ == 259) {
  
                        var $422=$pw; //@line 3102 "translate.cpp"
                        var $423=$word; //@line 3102 "translate.cpp"
                        var $sub_ptr_lhs_cast=($422); //@line 3102 "translate.cpp"
                        var $sub_ptr_rhs_cast=($423); //@line 3102 "translate.cpp"
                        var $sub_ptr_sub=((($sub_ptr_lhs_cast)-($sub_ptr_rhs_cast))&4294967295); //@line 3102 "translate.cpp"
                        $nx=$sub_ptr_sub; //@line 3102 "translate.cpp"
                        var $424=$word; //@line 3103 "translate.cpp"
                        var $425=$nx; //@line 3103 "translate.cpp"
                        var $dest$, $stop$, $stop4$, $fast$, $value4$;
                        $dest$ = $424;
                        $stop$ = $dest$ + $425;
                        $value4$ = 32;
                        if ($value4$ < 0) $value4$ += 256;
                        $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
                        while ($dest$%4 !== 0 && $dest$ < $stop$) {
                          ;; HEAP8[$dest$++] = 32;
                        }
                        $dest$ >>= 2;
                        $stop4$ = $stop$ >> 2;
                        while ($dest$ < $stop4$) {
                        ;;;;;;;  HEAP32[$dest$++] = $value4$;
                        }
                        $dest$ <<= 2;
                        while ($dest$ < $stop$) {
                          ;; HEAP8[$dest$++] = 32;
                        }; //@line 3103 "translate.cpp"
                        var $426=$pn; //@line 3104 "translate.cpp"
                        var $sub_ptr_lhs_cast817=($426); //@line 3104 "translate.cpp"
                        var $sub_ptr_sub819=((($sub_ptr_lhs_cast817)-($sub_ptr_rhs_cast818))&4294967295); //@line 3104 "translate.cpp"
                        $nx=$sub_ptr_sub819; //@line 3104 "translate.cpp"
                        var $427=$word; //@line 3105 "translate.cpp"
                        var $428=$nx; //@line 3105 "translate.cpp"
                        var $src$, $dest$, $stop$, $stop4$, $fast$;
                        $src$ = $arraydecay820;
                        $dest$ = $427;
                        $stop$ = $src$ + $428;
                        if (($dest$%4) == ($src$%4) && $428 > 8) {
                          while ($src$%4 !== 0 && $src$ < $stop$) {
                            ; HEAP8[$dest$++] = HEAP8[$src$++];
                          }
                          $src$ >>= 2;
                          $dest$ >>= 2;
                          $stop4$ = $stop$ >> 2;
                          while ($src$ < $stop4$) {
                        ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
                          }
                          $src$ <<= 2;
                          $dest$ <<= 2;
                        }while ($src$ < $stop$) {
                          ; HEAP8[$dest$++] = HEAP8[$src$++];
                        }; //@line 3105 "translate.cpp"
                        ; //@line 3106 "translate.cpp"
                      }
  
                      var $429=$word; //@line 3109 "translate.cpp"
                      $pw=$429; //@line 3109 "translate.cpp"
                      ; //@line 3110 "translate.cpp"
                    }
                  } while(0);
  
                  $n_digits=0; //@line 3112 "translate.cpp"
                  var $430=$n_digits; //@line 3112 "translate.cpp"
                  var $431=$word; //@line 3112 "translate.cpp"
                  var $arrayidx82630=(($431+$430)&4294967295); //@line 3112 "translate.cpp"
                  var $432=HEAP8[($arrayidx82630)]; //@line 3112 "translate.cpp"
                  var $conv82731=(tempInt=(($432)),(tempInt>=128?tempInt-256:tempInt)); //@line 3112 "translate.cpp"
                  var $call82832=_iswdigit($conv82731); //@line 3112 "translate.cpp"
                  var $tobool82933=((($call82832))|0)!=0; //@line 3112 "translate.cpp"
                  var $433=$n_digits; //@line 3112 "translate.cpp"
                  if ($tobool82933) { __lastLabel__ = 261; __label__ = 262;; } else { __lastLabel__ = 261; __label__ = 263;; } //@line 3112 "translate.cpp"
                  $for_inc831$$for_end833$364: do { 
                    if (__label__ == 262) {
                      while(1) { 
  
                        var $434=__lastLabel__ == 262 ? $438 : ($433);
                        var $inc832=((($434)+1)&4294967295); //@line 3112 "translate.cpp"
                        $n_digits=$inc832; //@line 3112 "translate.cpp"
                        var $435=$n_digits; //@line 3112 "translate.cpp"
                        var $436=$word; //@line 3112 "translate.cpp"
                        var $arrayidx826=(($436+$435)&4294967295); //@line 3112 "translate.cpp"
                        var $437=HEAP8[($arrayidx826)]; //@line 3112 "translate.cpp"
                        var $conv827=(tempInt=(($437)),(tempInt>=128?tempInt-256:tempInt)); //@line 3112 "translate.cpp"
                        var $call828=_iswdigit($conv827); //@line 3112 "translate.cpp"
                        var $tobool829=((($call828))|0)!=0; //@line 3112 "translate.cpp"
                        var $438=$n_digits; //@line 3112 "translate.cpp"
                        if ($tobool829) { __lastLabel__ = 262; __label__ = 262;continue ; } else { __lastLabel__ = 262; __label__ = 263;break $for_inc831$$for_end833$364; } //@line 3112 "translate.cpp"
                      }
                    }
                  } while(0);
  
                  var $_lcssa29=__lastLabel__ == 261 ? $433 : ($438);
                  var $cmp834=((($_lcssa29))|0) > 4; //@line 3114 "translate.cpp"
                  if ($cmp834) { __label__ = 264;; } else { __label__ = 284;; } //@line 3114 "translate.cpp"
                  $if_then835$$if_else939$368: do { 
                    if (__label__ == 264) {
  
                      HEAP8[($arrayidx836)]=32; //@line 3117 "translate.cpp"
                      $pn=$arrayidx837; //@line 3118 "translate.cpp"
                      var $439=$n_digits; //@line 3119 "translate.cpp"
                      $nx=$439; //@line 3119 "translate.cpp"
                      $nw=0; //@line 3120 "translate.cpp"
                      $individual_digits=0; //@line 3121 "translate.cpp"
                      var $440=$n_digits; //@line 3123 "translate.cpp"
                      var $441=$tr_addr; //@line 3123 "translate.cpp"
                      var $langopts838=(($441)&4294967295); //@line 3123 "translate.cpp"
                      var $max_digits=(($langopts838+212)&4294967295); //@line 3123 "translate.cpp"
                      var $442=HEAP32[(($max_digits)>>2)]; //@line 3123 "translate.cpp"
                      var $cmp839=((($440))|0) > ((($442))|0); //@line 3123 "translate.cpp"
                      if ($cmp839) { __label__ = 266;; } else { __label__ = 265;; } //@line 3123 "translate.cpp"
                      $if_then844$$lor_lhs_false840$370: do { 
                        if (__label__ == 265) {
  
                          var $443=$word; //@line 3123 "translate.cpp"
                          var $arrayidx841=(($443)&4294967295); //@line 3123 "translate.cpp"
                          var $444=HEAP8[($arrayidx841)]; //@line 3123 "translate.cpp"
                          var $conv842=(tempInt=(($444)),(tempInt>=128?tempInt-256:tempInt)); //@line 3123 "translate.cpp"
                          var $cmp843=((($conv842))|0)==48; //@line 3123 "translate.cpp"
                          if ($cmp843) { __label__ = 266;break $if_then844$$lor_lhs_false840$370; } else { __label__ = 267;break $if_then844$$lor_lhs_false840$370; } //@line 3123 "translate.cpp"
                        }
                      } while(0);
                      if (__label__ == 266) {
  
                        var $445=$ix; //@line 3124 "translate.cpp"
                        var $arrayidx845=(($words+$445*12)&4294967295); //@line 3124 "translate.cpp"
                        var $flags846=(($arrayidx845)&4294967295); //@line 3124 "translate.cpp"
                        var $446=HEAP32[(($flags846)>>2)]; //@line 3124 "translate.cpp"
                        var $or847=($446) | 524288; //@line 3124 "translate.cpp"
                        HEAP32[(($flags846)>>2)]=$or847; //@line 3124 "translate.cpp"
                        ; //@line 3124 "translate.cpp"
                      }
                      $while_cond849$374: while(1) { 
  
                        var $447=$pn; //@line 3126 "translate.cpp"
                        var $cmp851=((($447))>>>0) < ((($arrayidx850))>>>0); //@line 3126 "translate.cpp"
                        if (!($cmp851)) { __label__ = 278;break $while_cond849$374; } //@line 3126 "translate.cpp"
  
                        var $448=$pw; //@line 3128 "translate.cpp"
                        var $incdec_ptr853=(($448+1)&4294967295); //@line 3128 "translate.cpp"
                        $pw=$incdec_ptr853; //@line 3128 "translate.cpp"
                        var $449=HEAP8[($448)]; //@line 3128 "translate.cpp"
                        var $conv854=(tempInt=(($449)),(tempInt>=128?tempInt-256:tempInt)); //@line 3128 "translate.cpp"
                        $c=$conv854; //@line 3128 "translate.cpp"
                        var $isdigittmp=((($conv854)-48)&4294967295); //@line 3128 "translate.cpp"
                        var $isdigit=((($isdigittmp))>>>0) < 10; //@line 3128 "translate.cpp"
                        var $call855=((($isdigit))&1); //@line 3128 "translate.cpp"
                        var $tobool856=((($call855))|0)!=0; //@line 3128 "translate.cpp"
                        if ($tobool856) { __label__ = 270;; } else { __label__ = 269;; } //@line 3128 "translate.cpp"
                        if (__label__ == 269) {
  
                          var $450=$c; //@line 3128 "translate.cpp"
                          var $451=$tr_addr; //@line 3128 "translate.cpp"
                          var $langopts858=(($451)&4294967295); //@line 3128 "translate.cpp"
                          var $decimal_sep859=(($langopts858+208)&4294967295); //@line 3128 "translate.cpp"
                          var $452=HEAP32[(($decimal_sep859)>>2)]; //@line 3128 "translate.cpp"
                          var $cmp860=((($450))|0)!=((($452))|0); //@line 3128 "translate.cpp"
                          if ($cmp860) { __label__ = 278;break $while_cond849$374; } //@line 3128 "translate.cpp"
                        }
  
                        var $453=$c; //@line 3131 "translate.cpp"
                        var $conv863=((($453)) & 255); //@line 3131 "translate.cpp"
                        var $454=$pn; //@line 3131 "translate.cpp"
                        var $incdec_ptr864=(($454+1)&4294967295); //@line 3131 "translate.cpp"
                        $pn=$incdec_ptr864; //@line 3131 "translate.cpp"
                        HEAP8[($454)]=$conv863; //@line 3131 "translate.cpp"
                        var $455=$nx; //@line 3132 "translate.cpp"
                        var $dec865=((($455)-1)&4294967295); //@line 3132 "translate.cpp"
                        $nx=$dec865; //@line 3132 "translate.cpp"
                        var $cmp866=((($dec865))|0) > 0; //@line 3132 "translate.cpp"
                        if (!($cmp866)) { __label__ = 267;continue $while_cond849$374; } //@line 3132 "translate.cpp"
  
                        var $456=$tr_addr; //@line 3132 "translate.cpp"
                        var $langopts868=(($456)&4294967295); //@line 3132 "translate.cpp"
                        var $break_numbers869=(($langopts868+192)&4294967295); //@line 3132 "translate.cpp"
                        var $457=HEAP32[(($break_numbers869)>>2)]; //@line 3132 "translate.cpp"
                        var $458=$nx; //@line 3132 "translate.cpp"
                        var $shl=1 << ($458); //@line 3132 "translate.cpp"
                        var $and870=($shl) & ($457); //@line 3132 "translate.cpp"
                        var $tobool871=((($and870))|0)!=0; //@line 3132 "translate.cpp"
                        if (!($tobool871)) { __label__ = 267;continue $while_cond849$374; } //@line 3132 "translate.cpp"
  
                        var $459=$nw; //@line 3134 "translate.cpp"
                        var $inc873=((($459)+1)&4294967295); //@line 3134 "translate.cpp"
                        $nw=$inc873; //@line 3134 "translate.cpp"
                        var $arrayidx874=(($num_wtab+$459*12)&4294967295); //@line 3134 "translate.cpp"
                        var $460=$arrayidx874; //@line 3134 "translate.cpp"
                        var $461=$ix; //@line 3134 "translate.cpp"
                        var $arrayidx875=(($words+$461*12)&4294967295); //@line 3134 "translate.cpp"
                        var $462=$arrayidx875; //@line 3134 "translate.cpp"
                        var $src$, $dest$, $stop$, $stop4$, $fast$;
                        $src$ = $462;
                        $dest$ = $460;
                        $stop$ = $src$ + 12;
                        if (($dest$%4) == ($src$%4) && 12 > 8) {
                          while ($src$%4 !== 0 && $src$ < $stop$) {
                            ; HEAP8[$dest$++] = HEAP8[$src$++];
                          }
                          $src$ >>= 2;
                          $dest$ >>= 2;
                          $stop4$ = $stop$ >> 2;
                          while ($src$ < $stop4$) {
                        ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
                          }
                          $src$ <<= 2;
                          $dest$ <<= 2;
                        }while ($src$ < $stop$) {
                          ; HEAP8[$dest$++] = HEAP8[$src$++];
                        }; //@line 3134 "translate.cpp"
                        var $463=$tr_addr; //@line 3136 "translate.cpp"
                        var $langopts876=(($463)&4294967295); //@line 3136 "translate.cpp"
                        var $thousands_sep877=(($langopts876+204)&4294967295); //@line 3136 "translate.cpp"
                        var $464=HEAP32[(($thousands_sep877)>>2)]; //@line 3136 "translate.cpp"
                        var $cmp878=((($464))|0)!=32; //@line 3136 "translate.cpp"
                        if ($cmp878) { __label__ = 273;; } else { __label__ = 274;; } //@line 3136 "translate.cpp"
                        if (__label__ == 273) {
  
                          var $465=$tr_addr; //@line 3138 "translate.cpp"
                          var $langopts880=(($465)&4294967295); //@line 3138 "translate.cpp"
                          var $thousands_sep881=(($langopts880+204)&4294967295); //@line 3138 "translate.cpp"
                          var $466=HEAP32[(($thousands_sep881)>>2)]; //@line 3138 "translate.cpp"
                          var $conv882=((($466)) & 255); //@line 3138 "translate.cpp"
                          var $467=$pn; //@line 3138 "translate.cpp"
                          var $incdec_ptr883=(($467+1)&4294967295); //@line 3138 "translate.cpp"
                          $pn=$incdec_ptr883; //@line 3138 "translate.cpp"
                          HEAP8[($467)]=$conv882; //@line 3138 "translate.cpp"
                          ; //@line 3139 "translate.cpp"
                        }
  
                        var $468=$pn; //@line 3140 "translate.cpp"
                        var $incdec_ptr885=(($468+1)&4294967295); //@line 3140 "translate.cpp"
                        $pn=$incdec_ptr885; //@line 3140 "translate.cpp"
                        HEAP8[($468)]=32; //@line 3140 "translate.cpp"
                        var $469=$tr_addr; //@line 3141 "translate.cpp"
                        var $langopts886=(($469)&4294967295); //@line 3141 "translate.cpp"
                        var $break_numbers887=(($langopts886+192)&4294967295); //@line 3141 "translate.cpp"
                        var $470=HEAP32[(($break_numbers887)>>2)]; //@line 3141 "translate.cpp"
                        var $471=$nx; //@line 3141 "translate.cpp"
                        var $sub888=((($471)-1)&4294967295); //@line 3141 "translate.cpp"
                        var $shl889=1 << ($sub888); //@line 3141 "translate.cpp"
                        var $and890=($shl889) & ($470); //@line 3141 "translate.cpp"
                        var $tobool891=((($and890))|0)!=0; //@line 3141 "translate.cpp"
                        if ($tobool891) { __label__ = 275;; } else { __label__ = 276;; } //@line 3141 "translate.cpp"
                        if (__label__ == 275) {
  
                          var $472=$pn; //@line 3144 "translate.cpp"
                          var $incdec_ptr893=(($472+1)&4294967295); //@line 3144 "translate.cpp"
                          $pn=$incdec_ptr893; //@line 3144 "translate.cpp"
                          HEAP8[($472)]=48; //@line 3144 "translate.cpp"
                          var $473=$pn; //@line 3145 "translate.cpp"
                          var $incdec_ptr894=(($473+1)&4294967295); //@line 3145 "translate.cpp"
                          $pn=$incdec_ptr894; //@line 3145 "translate.cpp"
                          HEAP8[($473)]=48; //@line 3145 "translate.cpp"
                          ; //@line 3146 "translate.cpp"
                        }
  
                        var $474=$tr_addr; //@line 3147 "translate.cpp"
                        var $langopts896=(($474)&4294967295); //@line 3147 "translate.cpp"
                        var $break_numbers897=(($langopts896+192)&4294967295); //@line 3147 "translate.cpp"
                        var $475=HEAP32[(($break_numbers897)>>2)]; //@line 3147 "translate.cpp"
                        var $476=$nx; //@line 3147 "translate.cpp"
                        var $sub898=((($476)-2)&4294967295); //@line 3147 "translate.cpp"
                        var $shl899=1 << ($sub898); //@line 3147 "translate.cpp"
                        var $and900=($shl899) & ($475); //@line 3147 "translate.cpp"
                        var $tobool901=((($and900))|0)!=0; //@line 3147 "translate.cpp"
                        if (!($tobool901)) { __label__ = 267;continue $while_cond849$374; } //@line 3147 "translate.cpp"
  
                        var $477=$pn; //@line 3150 "translate.cpp"
                        var $incdec_ptr903=(($477+1)&4294967295); //@line 3150 "translate.cpp"
                        $pn=$incdec_ptr903; //@line 3150 "translate.cpp"
                        HEAP8[($477)]=48; //@line 3150 "translate.cpp"
                        __label__ = 267;continue $while_cond849$374; //@line 3151 "translate.cpp"
                      }
  
                      var $478=$pw; //@line 3154 "translate.cpp"
                      var $incdec_ptr907=(($478+-1)&4294967295); //@line 3154 "translate.cpp"
                      $pw=$incdec_ptr907; //@line 3154 "translate.cpp"
                      var $479=$nw; //@line 3155 "translate.cpp"
                      var $arrayidx908=(($num_wtab+$479*12)&4294967295); //@line 3155 "translate.cpp"
                      var $480=$arrayidx908; //@line 3155 "translate.cpp"
                      var $481=$ix; //@line 3155 "translate.cpp"
                      var $arrayidx909=(($words+$481*12)&4294967295); //@line 3155 "translate.cpp"
                      var $482=$arrayidx909; //@line 3155 "translate.cpp"
                      var $src$, $dest$, $stop$, $stop4$, $fast$;
                      $src$ = $482;
                      $dest$ = $480;
                      $stop$ = $src$ + 24;
                      if (($dest$%4) == ($src$%4) && 24 > 8) {
                        while ($src$%4 !== 0 && $src$ < $stop$) {
                          ; HEAP8[$dest$++] = HEAP8[$src$++];
                        }
                        $src$ >>= 2;
                        $dest$ >>= 2;
                        $stop4$ = $stop$ >> 2;
                        while ($src$ < $stop4$) {
                      ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
                        }
                        $src$ <<= 2;
                        $dest$ <<= 2;
                      }while ($src$ < $stop$) {
                        ; HEAP8[$dest$++] = HEAP8[$src$++];
                      }; //@line 3155 "translate.cpp"
                      $j=1; //@line 3157 "translate.cpp"
                      var $483=$j; //@line 3157 "translate.cpp"
                      var $484=$nw; //@line 3157 "translate.cpp"
                      var $cmp91134=((($483))|0) <= ((($484))|0); //@line 3157 "translate.cpp"
                      if ($cmp91134) { __label__ = 279;; } else { __label__ = 280;; } //@line 3157 "translate.cpp"
                      $for_body912$$for_end918$390: do { 
                        if (__label__ == 279) {
                          while(1) { 
  
                            var $485=$j; //@line 3159 "translate.cpp"
                            var $arrayidx913=(($num_wtab+$485*12)&4294967295); //@line 3159 "translate.cpp"
                            var $flags914=(($arrayidx913)&4294967295); //@line 3159 "translate.cpp"
                            var $486=HEAP32[(($flags914)>>2)]; //@line 3159 "translate.cpp"
                            var $and915=($486) & -262209; //@line 3159 "translate.cpp"
                            HEAP32[(($flags914)>>2)]=$and915; //@line 3159 "translate.cpp"
                            var $487=$j; //@line 3157 "translate.cpp"
                            var $inc917=((($487)+1)&4294967295); //@line 3157 "translate.cpp"
                            $j=$inc917; //@line 3157 "translate.cpp"
                            var $488=$j; //@line 3157 "translate.cpp"
                            var $489=$nw; //@line 3157 "translate.cpp"
                            var $cmp911=((($488))|0) <= ((($489))|0); //@line 3157 "translate.cpp"
                            if ($cmp911) { __label__ = 279;continue ; } else { __label__ = 280;break $for_body912$$for_end918$390; } //@line 3157 "translate.cpp"
                          }
                        }
                      } while(0);
  
                      var $490=$pn; //@line 3163 "translate.cpp"
                      var $491=$pw; //@line 3163 "translate.cpp"
                      var $src$, $dest$, $stop$, $stop4$, $fast$;
                      $src$ = $491;
                      $dest$ = $490;
                      $stop$ = $src$ + 16;
                      if (($dest$%4) == ($src$%4) && 16 > 8) {
                        while ($src$%4 !== 0 && $src$ < $stop$) {
                          ; HEAP8[$dest$++] = HEAP8[$src$++];
                        }
                        $src$ >>= 2;
                        $dest$ >>= 2;
                        $stop4$ = $stop$ >> 2;
                        while ($src$ < $stop4$) {
                      ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
                        }
                        $src$ <<= 2;
                        $dest$ <<= 2;
                      }while ($src$ < $stop$) {
                        ; HEAP8[$dest$++] = HEAP8[$src$++];
                      }; //@line 3163 "translate.cpp"
                      var $492=$pn; //@line 3164 "translate.cpp"
                      var $arrayidx919=(($492+16)&4294967295); //@line 3164 "translate.cpp"
                      HEAP8[($arrayidx919)]=0; //@line 3164 "translate.cpp"
                      $nw=0; //@line 3165 "translate.cpp"
                      $pw=$arrayidx920; //@line 3167 "translate.cpp"
                      var $493=$pw; //@line 3167 "translate.cpp"
                      var $494=$pn; //@line 3167 "translate.cpp"
                      var $cmp92235=((($493))>>>0) < ((($494))>>>0); //@line 3167 "translate.cpp"
                      if (!($cmp92235)) { __label__ = 293;break $if_then835$$if_else939$368; } //@line 3167 "translate.cpp"
                      $for_body923$394: while(1) { 
  
                        var $495=$tr_addr; //@line 3170 "translate.cpp"
                        var $496=$pw; //@line 3170 "translate.cpp"
                        var $497=$nw; //@line 3170 "translate.cpp"
                        var $inc924=((($497)+1)&4294967295); //@line 3170 "translate.cpp"
                        $nw=$inc924; //@line 3170 "translate.cpp"
                        var $arrayidx925=(($num_wtab+$497*12)&4294967295); //@line 3170 "translate.cpp"
                        var $498=$ix; //@line 3170 "translate.cpp"
                        var $arrayidx926=(($words+$498*12)&4294967295); //@line 3170 "translate.cpp"
                        var $pre_pause927=(($arrayidx926+8)&4294967295); //@line 3170 "translate.cpp"
                        var $499=HEAPU8[($pre_pause927)]; //@line 3170 "translate.cpp"
                        var $conv928=((($499))&255); //@line 3170 "translate.cpp"
                        var $call929=__ZL14TranslateWord2P10TranslatorPcP8WORD_TABii($495, $496, $arrayidx925, $conv928, 0); //@line 3170 "translate.cpp"
                        $dict_flags=$call929; //@line 3170 "translate.cpp"
                        ; //@line 3171 "translate.cpp"
                        while(1) { 
  
                          var $500=$pw; //@line 3171 "translate.cpp"
                          var $incdec_ptr931=(($500+1)&4294967295); //@line 3171 "translate.cpp"
                          $pw=$incdec_ptr931; //@line 3171 "translate.cpp"
                          var $501=HEAP8[($500)]; //@line 3171 "translate.cpp"
                          var $conv932=(tempInt=(($501)),(tempInt>=128?tempInt-256:tempInt)); //@line 3171 "translate.cpp"
                          var $cmp933=((($conv932))|0)!=32; //@line 3171 "translate.cpp"
                          if ($cmp933) { __label__ = 282;continue ; } else { __label__ = 283;break ; } //@line 3171 "translate.cpp"
                        }
  
                        var $502=$ix; //@line 3172 "translate.cpp"
                        var $arrayidx936=(($words+$502*12)&4294967295); //@line 3172 "translate.cpp"
                        var $pre_pause937=(($arrayidx936+8)&4294967295); //@line 3172 "translate.cpp"
                        HEAP8[($pre_pause937)]=0; //@line 3172 "translate.cpp"
                        var $503=$pw; //@line 3167 "translate.cpp"
                        var $504=$pn; //@line 3167 "translate.cpp"
                        var $cmp922=((($503))>>>0) < ((($504))>>>0); //@line 3167 "translate.cpp"
                        if ($cmp922) { __label__ = 281;continue $for_body923$394; } else { __label__ = 293;break $if_then835$$if_else939$368; } //@line 3167 "translate.cpp"
                      }
                    }
                    else if (__label__ == 284) {
  
                      HEAP32[((_pre_pause)>>2)]=0; //@line 3177 "translate.cpp"
                      var $505=$tr_addr; //@line 3178 "translate.cpp"
                      var $506=$word; //@line 3178 "translate.cpp"
                      var $507=$ix; //@line 3178 "translate.cpp"
                      var $arrayidx940=(($words+$507*12)&4294967295); //@line 3178 "translate.cpp"
                      var $508=$ix; //@line 3178 "translate.cpp"
                      var $arrayidx941=(($words+$508*12)&4294967295); //@line 3178 "translate.cpp"
                      var $pre_pause942=(($arrayidx941+8)&4294967295); //@line 3178 "translate.cpp"
                      var $509=HEAPU8[($pre_pause942)]; //@line 3178 "translate.cpp"
                      var $conv943=((($509))&255); //@line 3178 "translate.cpp"
                      var $510=$ix; //@line 3178 "translate.cpp"
                      var $add944=((($510)+1)&4294967295); //@line 3178 "translate.cpp"
                      var $arrayidx945=(($words+$add944*12)&4294967295); //@line 3178 "translate.cpp"
                      var $pre_pause946=(($arrayidx945+8)&4294967295); //@line 3178 "translate.cpp"
                      var $511=HEAPU8[($pre_pause946)]; //@line 3178 "translate.cpp"
                      var $conv947=((($511))&255); //@line 3178 "translate.cpp"
                      var $call948=__ZL14TranslateWord2P10TranslatorPcP8WORD_TABii($505, $506, $arrayidx940, $conv943, $conv947); //@line 3178 "translate.cpp"
                      $dict_flags=$call948; //@line 3178 "translate.cpp"
                      var $512=HEAP32[((_pre_pause)>>2)]; //@line 3180 "translate.cpp"
                      var $513=$ix; //@line 3180 "translate.cpp"
                      var $add949=((($513)+1)&4294967295); //@line 3180 "translate.cpp"
                      var $arrayidx950=(($words+$add949*12)&4294967295); //@line 3180 "translate.cpp"
                      var $pre_pause951=(($arrayidx950+8)&4294967295); //@line 3180 "translate.cpp"
                      var $514=HEAPU8[($pre_pause951)]; //@line 3180 "translate.cpp"
                      var $conv952=((($514))&255); //@line 3180 "translate.cpp"
                      var $cmp953=((($512))|0) > ((($conv952))|0); //@line 3180 "translate.cpp"
                      if ($cmp953) { __label__ = 285;; } else { __label__ = 286;; } //@line 3180 "translate.cpp"
                      if (__label__ == 285) {
  
                        var $515=HEAP32[((_pre_pause)>>2)]; //@line 3182 "translate.cpp"
                        var $conv955=((($515)) & 255); //@line 3182 "translate.cpp"
                        var $516=$ix; //@line 3182 "translate.cpp"
                        var $add956=((($516)+1)&4294967295); //@line 3182 "translate.cpp"
                        var $arrayidx957=(($words+$add956*12)&4294967295); //@line 3182 "translate.cpp"
                        var $pre_pause958=(($arrayidx957+8)&4294967295); //@line 3182 "translate.cpp"
                        HEAP8[($pre_pause958)]=$conv955; //@line 3182 "translate.cpp"
                        HEAP32[((_pre_pause)>>2)]=0; //@line 3183 "translate.cpp"
                        ; //@line 3184 "translate.cpp"
                      }
  
                      var $517=$dict_flags; //@line 3186 "translate.cpp"
                      var $and960=($517) & 65536; //@line 3186 "translate.cpp"
                      var $tobool961=((($and960))|0)!=0; //@line 3186 "translate.cpp"
                      if ($tobool961) { __label__ = 287;; } else { __label__ = 289;; } //@line 3186 "translate.cpp"
                      $if_then962$$if_end975$403: do { 
                        if (__label__ == 287) {
  
                          var $518=$word; //@line 3189 "translate.cpp"
                          $pw=$518; //@line 3189 "translate.cpp"
                          var $519=$pw; //@line 3189 "translate.cpp"
                          var $520=HEAP8[($519)]; //@line 3189 "translate.cpp"
                          var $conv96427=(tempInt=(($520)),(tempInt>=128?tempInt-256:tempInt)); //@line 3189 "translate.cpp"
                          var $cmp96528=((($conv96427))|0)!=32; //@line 3189 "translate.cpp"
                          if (!($cmp96528)) { __label__ = 289;break $if_then962$$if_end975$403; } //@line 3189 "translate.cpp"
                          while(1) { 
  
                            var $dest$, $stop$, $stop4$, $fast$, $value4$;
                            $dest$ = $arraydecay967;
                            $stop$ = $dest$ + 9;
                            $value4$ = 32;
                            if ($value4$ < 0) $value4$ += 256;
                            $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
                            while ($dest$%4 !== 0 && $dest$ < $stop$) {
                              ;; HEAP8[$dest$++] = 32;
                            }
                            $dest$ >>= 2;
                            $stop4$ = $stop$ >> 2;
                            while ($dest$ < $stop4$) {
                            ;;;;;;;  HEAP32[$dest$++] = $value4$;
                            }
                            $dest$ <<= 2;
                            while ($dest$ < $stop$) {
                              ;; HEAP8[$dest$++] = 32;
                            }; //@line 3191 "translate.cpp"
                            var $521=$pw; //@line 3192 "translate.cpp"
                            var $call968=__Z7utf8_inPiPKc($c_temp, $521); //@line 3192 "translate.cpp"
                            $nx=$call968; //@line 3192 "translate.cpp"
                            var $522=$pw; //@line 3193 "translate.cpp"
                            var $523=$nx; //@line 3193 "translate.cpp"
                            var $src$, $dest$, $stop$, $stop4$, $fast$;
                            $src$ = $522;
                            $dest$ = $arrayidx969;
                            $stop$ = $src$ + $523;
                            if (($dest$%4) == ($src$%4) && $523 > 8) {
                              while ($src$%4 !== 0 && $src$ < $stop$) {
                                ; HEAP8[$dest$++] = HEAP8[$src$++];
                              }
                              $src$ >>= 2;
                              $dest$ >>= 2;
                              $stop4$ = $stop$ >> 2;
                              while ($src$ < $stop4$) {
                            ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
                              }
                              $src$ <<= 2;
                              $dest$ <<= 2;
                            }while ($src$ < $stop$) {
                              ; HEAP8[$dest$++] = HEAP8[$src$++];
                            }; //@line 3193 "translate.cpp"
                            var $524=$tr_addr; //@line 3194 "translate.cpp"
                            var $525=$ix; //@line 3194 "translate.cpp"
                            var $arrayidx971=(($words+$525*12)&4294967295); //@line 3194 "translate.cpp"
                            var $call972=__ZL14TranslateWord2P10TranslatorPcP8WORD_TABii($524, $arrayidx970, $arrayidx971, 0, 0); //@line 3194 "translate.cpp"
                            var $526=$nx; //@line 3195 "translate.cpp"
                            var $527=$pw; //@line 3195 "translate.cpp"
                            var $add_ptr973=(($527+$526)&4294967295); //@line 3195 "translate.cpp"
                            $pw=$add_ptr973; //@line 3195 "translate.cpp"
                            var $528=$pw; //@line 3189 "translate.cpp"
                            var $529=HEAP8[($528)]; //@line 3189 "translate.cpp"
                            var $conv964=(tempInt=(($529)),(tempInt>=128?tempInt-256:tempInt)); //@line 3189 "translate.cpp"
                            var $cmp965=((($conv964))|0)!=32; //@line 3189 "translate.cpp"
                            if ($cmp965) { __label__ = 288;continue ; } else { __label__ = 289;break $if_then962$$if_end975$403; } //@line 3189 "translate.cpp"
                          }
                        }
                      } while(0);
  
                      var $530=$dict_flags; //@line 3199 "translate.cpp"
                      var $and976=($530) & 50331648; //@line 3199 "translate.cpp"
                      var $tobool977=((($and976))|0)!=0; //@line 3199 "translate.cpp"
                      if (!($tobool977)) { __label__ = 293;break $if_then835$$if_else939$368; } //@line 3199 "translate.cpp"
  
                      var $531=$ix; //@line 3199 "translate.cpp"
                      var $532=$word_count; //@line 3199 "translate.cpp"
                      var $sub979=((($532)-1)&4294967295); //@line 3199 "translate.cpp"
                      var $cmp980=((($531))|0)==((($sub979))|0); //@line 3199 "translate.cpp"
                      if (!($cmp980)) { __label__ = 293;break $if_then835$$if_else939$368; } //@line 3199 "translate.cpp"
  
                      var $533=$terminator; //@line 3199 "translate.cpp"
                      var $and982=($533) & 4194304; //@line 3199 "translate.cpp"
                      var $tobool983=((($and982))|0)!=0; //@line 3199 "translate.cpp"
                      if (!($tobool983)) { __label__ = 293;break $if_then835$$if_else939$368; } //@line 3199 "translate.cpp"
  
                      $clause_pause=10; //@line 3202 "translate.cpp"
                      $tone=4; //@line 3203 "translate.cpp"
                      ; //@line 3204 "translate.cpp"
                    }
                  } while(0);
  
                  var $534=$dict_flags; //@line 3207 "translate.cpp"
                  var $and987=($534) & 128; //@line 3207 "translate.cpp"
                  var $tobool988=((($and987))|0)!=0; //@line 3207 "translate.cpp"
                  if (!($tobool988)) { __label__ = 295;break $if_end768$$for_inc992$344; } //@line 3207 "translate.cpp"
  
                  var $535=HEAP32[((_dictionary_skipwords)>>2)]; //@line 3209 "translate.cpp"
                  var $536=$ix; //@line 3209 "translate.cpp"
                  var $add990=((($536)+($535))&4294967295); //@line 3209 "translate.cpp"
                  $ix=$add990; //@line 3209 "translate.cpp"
                  ; //@line 3210 "translate.cpp"
                }
              } while(0);
  
              var $537=$ix; //@line 3058 "translate.cpp"
              var $inc993=((($537)+1)&4294967295); //@line 3058 "translate.cpp"
              $ix=$inc993; //@line 3058 "translate.cpp"
              var $538=$ix; //@line 3058 "translate.cpp"
              var $539=$word_count; //@line 3058 "translate.cpp"
              var $cmp756=((($538))|0) < ((($539))|0); //@line 3058 "translate.cpp"
              if ($cmp756) { __label__ = 243;continue $for_body757$337; } else { __label__ = 296;break $for_body757_lr_ph$$for_end994$335; } //@line 3058 "translate.cpp"
            }
          }
        } while(0);
  
        $ix=0; //@line 3213 "translate.cpp"
        var $540=HEAP32[((_n_ph_list2)>>2)]; //@line 3217 "translate.cpp"
        __lastLabel__ = 296; ; //@line 3213 "translate.cpp"
        $for_body997$415: while(1) { 
  
          var $541=__lastLabel__ == 296 ? $540 : ($549);
          var $542=$ix; //@line 3217 "translate.cpp"
          var $add998=((($542)+($541))&4294967295); //@line 3217 "translate.cpp"
          var $arrayidx999=((_ph_list2+$add998*8)&4294967295); //@line 3217 "translate.cpp"
          $p2=$arrayidx999; //@line 3217 "translate.cpp"
          var $543=$p2; //@line 3218 "translate.cpp"
          var $phcode=(($543)&4294967295); //@line 3218 "translate.cpp"
          HEAP8[($phcode)]=9; //@line 3218 "translate.cpp"
          var $544=$p2; //@line 3219 "translate.cpp"
          var $stresslevel=(($544+1)&4294967295); //@line 3219 "translate.cpp"
          HEAP8[($stresslevel)]=0; //@line 3219 "translate.cpp"
          var $545=HEAP32[(($source_index)>>2)]; //@line 3220 "translate.cpp"
          var $conv1000=((($545)) & 65535); //@line 3220 "translate.cpp"
          var $546=$p2; //@line 3220 "translate.cpp"
          var $sourceix1001=(($546+6)&4294967295); //@line 3220 "translate.cpp"
          HEAP16[(($sourceix1001)>>1)]=$conv1000; //@line 3220 "translate.cpp"
          var $547=$p2; //@line 3221 "translate.cpp"
          var $synthflags=(($547+4)&4294967295); //@line 3221 "translate.cpp"
          HEAP16[(($synthflags)>>1)]=0; //@line 3221 "translate.cpp"
          var $548=$ix; //@line 3213 "translate.cpp"
          var $inc1003=((($548)+1)&4294967295); //@line 3213 "translate.cpp"
          $ix=$inc1003; //@line 3213 "translate.cpp"
          var $cmp996=((($inc1003))|0) < 2; //@line 3213 "translate.cpp"
          var $549=HEAP32[((_n_ph_list2)>>2)]; //@line 3217 "translate.cpp"
          if ($cmp996) { __lastLabel__ = 297; __label__ = 297;continue $for_body997$415; } else { __lastLabel__ = 297; __label__ = 298;break $for_body997$415; } //@line 3213 "translate.cpp"
        }
  
        var $add1005=((($549)+2)&4294967295); //@line 3223 "translate.cpp"
        HEAP32[((_n_ph_list2)>>2)]=$add1005; //@line 3223 "translate.cpp"
        var $550=HEAP32[((_count_words)>>2)]; //@line 3225 "translate.cpp"
        var $cmp1006=((($550))|0)==0; //@line 3225 "translate.cpp"
        if ($cmp1006) { __label__ = 299;; } else { __label__ = 300;; } //@line 3225 "translate.cpp"
        if (__label__ == 299) {
  
          $clause_pause=0; //@line 3227 "translate.cpp"
          ; //@line 3228 "translate.cpp"
        }
  
        var $call1009=__Z3Eofv(); //@line 3229 "translate.cpp"
        var $tobool1010=((($call1009))|0)!=0; //@line 3229 "translate.cpp"
        if ($tobool1010) { __label__ = 301;; } else { __label__ = 303;; } //@line 3229 "translate.cpp"
        $land_lhs_true1011$$if_end1016$421: do { 
          if (__label__ == 301) {
  
            var $551=$word_count; //@line 3229 "translate.cpp"
            var $cmp1012=((($551))|0)==0; //@line 3229 "translate.cpp"
            var $552=HEAP32[((_option_endpause)>>2)]; //@line 3229 "translate.cpp"
            var $cmp1014=((($552))|0)==0; //@line 3229 "translate.cpp"
            var $or_cond11=($cmp1012) | ($cmp1014); //@line 3229 "translate.cpp"
            if (!($or_cond11)) { __label__ = 303;break $land_lhs_true1011$$if_end1016$421; } //@line 3229 "translate.cpp"
  
            $clause_pause=10; //@line 3231 "translate.cpp"
            ; //@line 3232 "translate.cpp"
          }
        } while(0);
  
        var $553=$tr_addr; //@line 3234 "translate.cpp"
        var $554=$clause_pause; //@line 3234 "translate.cpp"
        var $555=HEAP32[((_new_sentence)>>2)]; //@line 3234 "translate.cpp"
        __Z15MakePhonemeListP10Translatorii($553, $554, $555); //@line 3234 "translate.cpp"
        var $556=$embedded_count; //@line 3236 "translate.cpp"
        var $tobool1017=((($556))|0)!=0; //@line 3236 "translate.cpp"
        if ($tobool1017) { __label__ = 304;; } else { __label__ = 305;; } //@line 3236 "translate.cpp"
        if (__label__ == 304) {
  
          var $557=HEAP32[((_n_phoneme_list)>>2)]; //@line 3238 "translate.cpp"
          var $sub1019=((($557)-2)&4294967295); //@line 3238 "translate.cpp"
          var $arrayidx1020=((_phoneme_list+$sub1019*24)&4294967295); //@line 3238 "translate.cpp"
          var $synthflags1021=(($arrayidx1020+4)&4294967295); //@line 3238 "translate.cpp"
          HEAP16[(($synthflags1021)>>1)]=2; //@line 3238 "translate.cpp"
          var $558=HEAP32[((__ZL11embedded_ix)>>2)]; //@line 3239 "translate.cpp"
          var $sub1022=((($558)-1)&4294967295); //@line 3239 "translate.cpp"
          var $arrayidx1023=((_embedded_list+$sub1022*4)&4294967295); //@line 3239 "translate.cpp"
          var $559=HEAP32[(($arrayidx1023)>>2)]; //@line 3239 "translate.cpp"
          var $or1024=($559) | 128; //@line 3239 "translate.cpp"
          HEAP32[(($arrayidx1023)>>2)]=$or1024; //@line 3239 "translate.cpp"
          ; //@line 3240 "translate.cpp"
        }
  
        var $560=$tone; //@line 3245 "translate.cpp"
        var $561=$tone_out_addr; //@line 3245 "translate.cpp"
        HEAP32[(($561)>>2)]=$560; //@line 3245 "translate.cpp"
        HEAP32[((_new_sentence)>>2)]=0; //@line 3247 "translate.cpp"
        var $562=$terminator; //@line 3248 "translate.cpp"
        var $and1026=($562) & 524288; //@line 3248 "translate.cpp"
        var $tobool1027=((($and1026))|0)!=0; //@line 3248 "translate.cpp"
        if ($tobool1027) { __label__ = 306;; } else { __label__ = 307;; } //@line 3248 "translate.cpp"
        if (__label__ == 306) {
  
          HEAP32[((_new_sentence)>>2)]=1; //@line 3250 "translate.cpp"
          ; //@line 3251 "translate.cpp"
        }
  
        var $563=$voice_change_addr; //@line 3254 "translate.cpp"
        var $cmp1030=((($563))|0)!=0; //@line 3254 "translate.cpp"
        if ($cmp1030) { __label__ = 308;; } else { __label__ = 311;; } //@line 3254 "translate.cpp"
        if (__label__ == 308) {
  
          var $564=$terminator; //@line 3257 "translate.cpp"
          var $and1032=($564) & 131072; //@line 3257 "translate.cpp"
          var $tobool1033=((($and1032))|0)!=0; //@line 3257 "translate.cpp"
          var $565=$voice_change_addr; //@line 3258 "translate.cpp"
          if ($tobool1033) { __label__ = 309;; } else { __label__ = 310;; } //@line 3257 "translate.cpp"
          if (__label__ == 309) {
  
            HEAP32[(($565)>>2)]=((__ZZ15TranslateClauseP10TranslatorP7__sFILEPKvPiPPcE17voice_change_name)&4294967295); //@line 3258 "translate.cpp"
            ; //@line 3258 "translate.cpp"
          }
          else if (__label__ == 310) {
  
            HEAP32[(($565)>>2)]=0; //@line 3260 "translate.cpp"
            ;
          }
        }
  
        var $call1038=__Z3Eofv(); //@line 3263 "translate.cpp"
        var $tobool1039=((($call1038))|0)!=0; //@line 3263 "translate.cpp"
        if ($tobool1039) { __label__ = 313;; } else { __label__ = 312;; } //@line 3263 "translate.cpp"
        $if_then1042$$lor_lhs_false1040$437: do { 
          if (__label__ == 312) {
  
            var $566=$vp_input_addr; //@line 3263 "translate.cpp"
            var $cmp1041=((($566))|0)==0; //@line 3263 "translate.cpp"
            if ($cmp1041) { __label__ = 313;break $if_then1042$$lor_lhs_false1040$437; } //@line 3263 "translate.cpp"
  
            var $567=HEAP32[((_option_multibyte)>>2)]; //@line 3266 "translate.cpp"
            var $cmp1044=((($567))|0)==3; //@line 3266 "translate.cpp"
            if ($cmp1044) { __label__ = 315;; } else { __label__ = 316;; } //@line 3266 "translate.cpp"
            if (__label__ == 315) {
  
              var $568=HEAP32[((_p_wchar_input)>>2)]; //@line 3267 "translate.cpp"
              var $569=$568; //@line 3267 "translate.cpp"
              $retval=$569; //@line 3267 "translate.cpp"
              __label__ = 317;break $if_then$$if_end$2; //@line 3267 "translate.cpp"
            }
            else if (__label__ == 316) {
  
              var $570=HEAP32[((_p_textinput)>>2)]; //@line 3269 "translate.cpp"
              $retval=$570; //@line 3269 "translate.cpp"
              __label__ = 317;break $if_then$$if_end$2; //@line 3269 "translate.cpp"
            }
          }
        } while(0);
  
        $retval=0; //@line 3264 "translate.cpp"
        ; //@line 3264 "translate.cpp"
      }
    } while(0);
  
    var $571=$retval; //@line 3270 "translate.cpp"
    STACKTOP = __stackBase__;
    return $571; //@line 3270 "translate.cpp"
    return null;
  }
  

  function __ZL9IsDigit09j($c) {
    ;
    var __label__;
  
    var $retval;
    var $c_addr;
    $c_addr=$c;
    var $0=$c_addr; //@line 415 "translate.cpp"
    var $cmp=((($0))>>>0) >= 48; //@line 415 "translate.cpp"
    var $1=$c_addr; //@line 415 "translate.cpp"
    var $cmp1=((($1))>>>0) <= 57; //@line 415 "translate.cpp"
    var $or_cond=($cmp) & ($cmp1); //@line 415 "translate.cpp"
    if ($or_cond) { __label__ = 1;; } else { __label__ = 2;; } //@line 415 "translate.cpp"
    if (__label__ == 1) {
  
      $retval=1; //@line 416 "translate.cpp"
      ; //@line 416 "translate.cpp"
    }
    else if (__label__ == 2) {
  
      $retval=0; //@line 417 "translate.cpp"
      ; //@line 417 "translate.cpp"
    }
  
    var $2=$retval; //@line 418 "translate.cpp"
    ;
    return $2; //@line 418 "translate.cpp"
    return null;
  }
  

  function __ZL15EmbeddedCommandRj($source_index) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $source_index_addr;
    var $commands;
    var $value;
    var $sign;
    var $c;
    var $p;
    var $cmd;
    $source_index_addr=$source_index;
    $commands=((__str12555)&4294967295); //@line 2131 "translate.cpp"
    $value=-1; //@line 2132 "translate.cpp"
    $sign=0; //@line 2133 "translate.cpp"
    var $0=$source_index_addr; //@line 2138 "translate.cpp"
    var $1=HEAP32[(($0)>>2)]; //@line 2138 "translate.cpp"
    var $arrayidx=((__ZL6source+$1)&4294967295); //@line 2138 "translate.cpp"
    var $2=HEAP8[($arrayidx)]; //@line 2138 "translate.cpp"
    $c=$2; //@line 2138 "translate.cpp"
    var $3=$c; //@line 2139 "translate.cpp"
    var $conv=((($3))&255); //@line 2139 "translate.cpp"
    var $cmp=((($conv))|0)==43; //@line 2139 "translate.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 2139 "translate.cpp"
    $if_then$$if_else$2: do { 
      if (__label__ == 1) {
  
        $sign=64; //@line 2141 "translate.cpp"
        var $4=$source_index_addr; //@line 2142 "translate.cpp"
        var $5=HEAP32[(($4)>>2)]; //@line 2142 "translate.cpp"
        var $inc=((($5)+1)&4294967295); //@line 2142 "translate.cpp"
        HEAP32[(($4)>>2)]=$inc; //@line 2142 "translate.cpp"
        ; //@line 2143 "translate.cpp"
      }
      else if (__label__ == 2) {
  
        var $6=$c; //@line 2145 "translate.cpp"
        var $conv1=((($6))&255); //@line 2145 "translate.cpp"
        var $cmp2=((($conv1))|0)==45; //@line 2145 "translate.cpp"
        if (!($cmp2)) { __label__ = 4;break $if_then$$if_else$2; } //@line 2145 "translate.cpp"
  
        $sign=96; //@line 2147 "translate.cpp"
        var $7=$source_index_addr; //@line 2148 "translate.cpp"
        var $8=HEAP32[(($7)>>2)]; //@line 2148 "translate.cpp"
        var $inc4=((($8)+1)&4294967295); //@line 2148 "translate.cpp"
        HEAP32[(($7)>>2)]=$inc4; //@line 2148 "translate.cpp"
        ; //@line 2149 "translate.cpp"
      }
    } while(0);
  
    var $9=$source_index_addr; //@line 2151 "translate.cpp"
    var $10=HEAP32[(($9)>>2)]; //@line 2151 "translate.cpp"
    var $arrayidx6=((__ZL6source+$10)&4294967295); //@line 2151 "translate.cpp"
    var $11=HEAP8[($arrayidx6)]; //@line 2151 "translate.cpp"
    var $conv7=(tempInt=(($11)),(tempInt>=128?tempInt-256:tempInt)); //@line 2151 "translate.cpp"
    var $isdigittmp=((($conv7)-48)&4294967295); //@line 2151 "translate.cpp"
    var $isdigit=((($isdigittmp))>>>0) < 10; //@line 2151 "translate.cpp"
    var $call=((($isdigit))&1); //@line 2151 "translate.cpp"
    var $tobool=((($call))|0)!=0; //@line 2151 "translate.cpp"
    if ($tobool) { __label__ = 5;; } else { __label__ = 7;; } //@line 2151 "translate.cpp"
    $if_then8$$if_end16$7: do { 
      if (__label__ == 5) {
  
        var $12=$source_index_addr; //@line 2153 "translate.cpp"
        var $13=HEAP32[(($12)>>2)]; //@line 2153 "translate.cpp"
        var $arrayidx9=((__ZL6source+$13)&4294967295); //@line 2153 "translate.cpp"
        var $call10=_atoi($arrayidx9); //@line 2153 "translate.cpp"
        $value=$call10; //@line 2153 "translate.cpp"
        var $14=$source_index_addr; //@line 2154 "translate.cpp"
        var $15=HEAP32[(($14)>>2)]; //@line 2154 "translate.cpp"
        var $arrayidx113=((__ZL6source+$15)&4294967295); //@line 2154 "translate.cpp"
        var $16=HEAP8[($arrayidx113)]; //@line 2154 "translate.cpp"
        var $conv124=(tempInt=(($16)),(tempInt>=128?tempInt-256:tempInt)); //@line 2154 "translate.cpp"
        var $isdigittmp15=((($conv124)-48)&4294967295); //@line 2154 "translate.cpp"
        var $isdigit26=((($isdigittmp15))>>>0) < 10; //@line 2154 "translate.cpp"
        if (!($isdigit26)) { __label__ = 7;break $if_then8$$if_end16$7; } //@line 2154 "translate.cpp"
        while(1) { 
  
          var $17=$source_index_addr; //@line 2155 "translate.cpp"
          var $18=HEAP32[(($17)>>2)]; //@line 2155 "translate.cpp"
          var $inc15=((($18)+1)&4294967295); //@line 2155 "translate.cpp"
          HEAP32[(($17)>>2)]=$inc15; //@line 2155 "translate.cpp"
          var $19=$source_index_addr; //@line 2154 "translate.cpp"
          var $20=HEAP32[(($19)>>2)]; //@line 2154 "translate.cpp"
          var $arrayidx11=((__ZL6source+$20)&4294967295); //@line 2154 "translate.cpp"
          var $21=HEAP8[($arrayidx11)]; //@line 2154 "translate.cpp"
          var $conv12=(tempInt=(($21)),(tempInt>=128?tempInt-256:tempInt)); //@line 2154 "translate.cpp"
          var $isdigittmp1=((($conv12)-48)&4294967295); //@line 2154 "translate.cpp"
          var $isdigit2=((($isdigittmp1))>>>0) < 10; //@line 2154 "translate.cpp"
          var $call13=((($isdigit2))&1); //@line 2154 "translate.cpp"
          var $tobool14=((($call13))|0)!=0; //@line 2154 "translate.cpp"
          if ($tobool14) { __label__ = 6;continue ; } else { __label__ = 7;break $if_then8$$if_end16$7; } //@line 2154 "translate.cpp"
        }
      }
    } while(0);
  
    var $22=$source_index_addr; //@line 2158 "translate.cpp"
    var $23=HEAP32[(($22)>>2)]; //@line 2158 "translate.cpp"
    var $inc17=((($23)+1)&4294967295); //@line 2158 "translate.cpp"
    HEAP32[(($22)>>2)]=$inc17; //@line 2158 "translate.cpp"
    var $arrayidx18=((__ZL6source+$23)&4294967295); //@line 2158 "translate.cpp"
    var $24=HEAP8[($arrayidx18)]; //@line 2158 "translate.cpp"
    $c=$24; //@line 2158 "translate.cpp"
    var $25=HEAP32[((__ZL11embedded_ix)>>2)]; //@line 2159 "translate.cpp"
    var $cmp19=((($25))|0) >= 248; //@line 2159 "translate.cpp"
    if ($cmp19) { __label__ = 8;; } else { __label__ = 9;; } //@line 2159 "translate.cpp"
    if (__label__ == 8) {
  
      $retval=0; //@line 2160 "translate.cpp"
      ; //@line 2160 "translate.cpp"
    }
    else if (__label__ == 9) {
  
      var $26=$commands; //@line 2162 "translate.cpp"
      var $27=$c; //@line 2162 "translate.cpp"
      var $conv22=((($27))&255); //@line 2162 "translate.cpp"
      var $call23=__Z8strchr_wPKci($26, $conv22); //@line 2162 "translate.cpp"
      $p=$call23; //@line 2162 "translate.cpp"
      var $cmp24=((($call23))|0)==0; //@line 2162 "translate.cpp"
      if ($cmp24) { __label__ = 10;; } else { __label__ = 11;; } //@line 2162 "translate.cpp"
      if (__label__ == 10) {
  
        $retval=0; //@line 2163 "translate.cpp"
        ; //@line 2163 "translate.cpp"
      }
      else if (__label__ == 11) {
  
        var $28=$p; //@line 2164 "translate.cpp"
        var $29=$commands; //@line 2164 "translate.cpp"
        var $sub_ptr_lhs_cast=($28); //@line 2164 "translate.cpp"
        var $sub_ptr_rhs_cast=($29); //@line 2164 "translate.cpp"
        var $sub_ptr_sub=((($sub_ptr_lhs_cast)-($sub_ptr_rhs_cast))&4294967295); //@line 2164 "translate.cpp"
        var $add=((($sub_ptr_sub)+1)&4294967295); //@line 2164 "translate.cpp"
        $cmd=$add; //@line 2164 "translate.cpp"
        var $30=$value; //@line 2165 "translate.cpp"
        var $cmp27=((($30))|0)==-1; //@line 2165 "translate.cpp"
        if ($cmp27) { __lastLabel__ = 11; __label__ = 12;; } else { __lastLabel__ = 11; __label__ = 13;; } //@line 2165 "translate.cpp"
        if (__label__ == 12) {
  
          var $31=$cmd; //@line 2167 "translate.cpp"
          var $arrayidx29=((_embedded_default+$31*4)&4294967295); //@line 2167 "translate.cpp"
          var $32=HEAP32[(($arrayidx29)>>2)]; //@line 2167 "translate.cpp"
          $value=$32; //@line 2167 "translate.cpp"
          $sign=0; //@line 2168 "translate.cpp"
          __lastLabel__ = 12; ; //@line 2169 "translate.cpp"
        }
  
        var $33=__lastLabel__ == 12 ? $31 : ($add); //@line 2171 "translate.cpp"
        var $cmp31=((($33))|0)==9; //@line 2171 "translate.cpp"
        if ($cmp31) { __label__ = 14;; } else { __label__ = 15;; } //@line 2171 "translate.cpp"
        if (__label__ == 14) {
  
          var $34=$value; //@line 2173 "translate.cpp"
          HEAP32[((__ZL13option_sayas2)>>2)]=$34; //@line 2173 "translate.cpp"
          HEAP32[((__ZL18count_sayas_digits)>>2)]=0; //@line 2174 "translate.cpp"
          ; //@line 2175 "translate.cpp"
        }
  
        var $35=$cmd; //@line 2176 "translate.cpp"
        var $cmp34=((($35))|0)==13; //@line 2176 "translate.cpp"
        if ($cmp34) { __label__ = 16;; } else { __label__ = 19;; } //@line 2176 "translate.cpp"
        if (__label__ == 16) {
  
          var $36=$value; //@line 2178 "translate.cpp"
          var $cmp36=((($36))|0) >= 3; //@line 2178 "translate.cpp"
          if ($cmp36) { __label__ = 17;; } else { __label__ = 18;; } //@line 2178 "translate.cpp"
          if (__label__ == 17) {
  
            HEAP8[(__ZL13word_emphasis_b)]=1;
            ; //@line 2179 "translate.cpp"
          }
          else if (__label__ == 18) {
  
            HEAP8[(__ZL13word_emphasis_b)]=0;
            ;
          }
        }
  
        var $37=$cmd; //@line 2184 "translate.cpp"
        var $38=$sign; //@line 2184 "translate.cpp"
        var $39=$value; //@line 2184 "translate.cpp"
        var $shl=((($39)*256)&4294967295); //@line 2184 "translate.cpp"
        var $add41=((($38)+($37))&4294967295); //@line 2184 "translate.cpp"
        var $add42=((($add41)+($shl))&4294967295); //@line 2184 "translate.cpp"
        var $40=HEAP32[((__ZL11embedded_ix)>>2)]; //@line 2184 "translate.cpp"
        var $inc43=((($40)+1)&4294967295); //@line 2184 "translate.cpp"
        HEAP32[((__ZL11embedded_ix)>>2)]=$inc43; //@line 2184 "translate.cpp"
        var $arrayidx44=((_embedded_list+$40*4)&4294967295); //@line 2184 "translate.cpp"
        HEAP32[(($arrayidx44)>>2)]=$add42; //@line 2184 "translate.cpp"
        $retval=1; //@line 2185 "translate.cpp"
        ; //@line 2185 "translate.cpp"
      }
    }
  
    var $41=$retval; //@line 2186 "translate.cpp"
    ;
    return $41; //@line 2186 "translate.cpp"
    return null;
  }
  

  function __ZL13TranslateCharP10TranslatorPcijjPi($tr, $ptr, $prev_in, $c, $next_in, $insert) {
    var __stackBase__  = STACKTOP; STACKTOP += 4; _memset(__stackBase__, 0, 4);
    var __label__;
  
    var $retval;
    var $tr_addr;
    var $ptr_addr;
    var $prev_in_addr;
    var $c_addr;
    var $next_in_addr;
    var $insert_addr;
    var $code;
    var $initial;
    var $medial;
    var $final;
    var $next2=__stackBase__;
    $tr_addr=$tr;
    $ptr_addr=$ptr;
    $prev_in_addr=$prev_in;
    $c_addr=$c;
    $next_in_addr=$next_in;
    $insert_addr=$insert;
    var $0=$tr_addr; //@line 2276 "translate.cpp"
    var $translator_name=(($0+280)&4294967295); //@line 2276 "translate.cpp"
    var $1=HEAP32[(($translator_name)>>2)]; //@line 2276 "translate.cpp"
    if ($1 == 24934) {
      __label__ = 1;;
    }
    else if ($1 == 28268) {
      __label__ = 1;;
    }
    else if ($1 == 27503) {
      __label__ = 9;;
    }
    else {
    __label__ = 18;;
    }
    
    $sw_epilog$$sw_bb$$sw_bb17$2: do { 
      if (__label__ == 1) {
  
        var $2=$prev_in_addr; //@line 2283 "translate.cpp"
        var $call=_iswalpha($2); //@line 2283 "translate.cpp"
        var $tobool=((($call))|0)!=0; //@line 2283 "translate.cpp"
        if ($tobool) { __label__ = 18;break $sw_epilog$$sw_bb$$sw_bb17$2; } //@line 2283 "translate.cpp"
  
        var $3=$ptr_addr; //@line 2285 "translate.cpp"
        var $arrayidx=(($3+1)&4294967295); //@line 2285 "translate.cpp"
        var $call1=__Z7utf8_inPiPKc($next2, $arrayidx); //@line 2285 "translate.cpp"
        var $4=$c_addr; //@line 2287 "translate.cpp"
        var $cmp=((($4))|0)==39; //@line 2287 "translate.cpp"
        if (!($cmp)) { __label__ = 18;break $sw_epilog$$sw_bb$$sw_bb17$2; } //@line 2287 "translate.cpp"
  
        var $5=HEAP32[(($next2)>>2)]; //@line 2287 "translate.cpp"
        var $call2=__Z7IsSpacej($5); //@line 2287 "translate.cpp"
        var $tobool3=((($call2))|0)!=0; //@line 2287 "translate.cpp"
        if (!($tobool3)) { __label__ = 18;break $sw_epilog$$sw_bb$$sw_bb17$2; } //@line 2287 "translate.cpp"
  
        var $6=$next_in_addr; //@line 2289 "translate.cpp"
        var $cmp5=((($6))|0)==110; //@line 2289 "translate.cpp"
        if ($cmp5) { __label__ = 5;; } else { __label__ = 7;; } //@line 2289 "translate.cpp"
        $land_lhs_true6$$if_end$7: do { 
          if (__label__ == 5) {
  
            var $7=$tr_addr; //@line 2289 "translate.cpp"
            var $translator_name7=(($7+280)&4294967295); //@line 2289 "translate.cpp"
            var $8=HEAP32[(($translator_name7)>>2)]; //@line 2289 "translate.cpp"
            var $cmp8=((($8))|0)==24934; //@line 2289 "translate.cpp"
            if (!($cmp8)) { __label__ = 7;break $land_lhs_true6$$if_end$7; } //@line 2289 "translate.cpp"
  
            var $9=$ptr_addr; //@line 2292 "translate.cpp"
            var $arrayidx10=(($9)&4294967295); //@line 2292 "translate.cpp"
            HEAP8[($arrayidx10)]=32; //@line 2292 "translate.cpp"
            $retval=601; //@line 2293 "translate.cpp"
            __label__ = 19;break $sw_epilog$$sw_bb$$sw_bb17$2; //@line 2293 "translate.cpp"
          }
        } while(0);
  
        var $10=$next_in_addr; //@line 2295 "translate.cpp"
        var $cmp11=((($10))|0)==110; //@line 2295 "translate.cpp"
        var $11=$next_in_addr; //@line 2295 "translate.cpp"
        var $cmp12=((($11))|0)==116; //@line 2295 "translate.cpp"
        var $or_cond=($cmp11) | ($cmp12); //@line 2295 "translate.cpp"
        if (!($or_cond)) { __label__ = 18;break $sw_epilog$$sw_bb$$sw_bb17$2; } //@line 2295 "translate.cpp"
  
        $retval=601; //@line 2298 "translate.cpp"
        __label__ = 19;break $sw_epilog$$sw_bb$$sw_bb17$2; //@line 2298 "translate.cpp"
      }
      else if (__label__ == 9) {
  
        var $12=$c_addr; //@line 2305 "translate.cpp"
        var $sub=((($12)-44032)&4294967295); //@line 2305 "translate.cpp"
        $code=$sub; //@line 2305 "translate.cpp"
        var $cmp18=((($sub))|0) >= 0; //@line 2305 "translate.cpp"
        var $13=$c_addr; //@line 2305 "translate.cpp"
        var $cmp20=((($13))>>>0) <= 55215; //@line 2305 "translate.cpp"
        var $or_cond1=($cmp18) & ($cmp20); //@line 2305 "translate.cpp"
        if ($or_cond1) { __label__ = 10;; } else { __label__ = 15;; } //@line 2305 "translate.cpp"
        if (__label__ == 10) {
  
          var $14=$code; //@line 2308 "translate.cpp"
          var $div=((((($14))|0)/28)|0); //@line 2308 "translate.cpp"
          var $div22=((((($div))|0)/21)|0); //@line 2308 "translate.cpp"
          $initial=$div22; //@line 2308 "translate.cpp"
          var $15=$code; //@line 2309 "translate.cpp"
          var $div23=((((($15))|0)/28)|0); //@line 2309 "translate.cpp"
          var $rem=((($div23))|0)%21; //@line 2309 "translate.cpp"
          $medial=$rem; //@line 2309 "translate.cpp"
          var $16=$code; //@line 2310 "translate.cpp"
          var $rem24=((($16))|0)%28; //@line 2310 "translate.cpp"
          $final=$rem24; //@line 2310 "translate.cpp"
          var $17=$initial; //@line 2312 "translate.cpp"
          var $cmp25=((($17))|0)==11; //@line 2312 "translate.cpp"
          if ($cmp25) { __label__ = 11;; } else { __label__ = 13;; } //@line 2312 "translate.cpp"
          $if_then26$$if_else$15: do { 
            if (__label__ == 11) {
  
              var $18=$medial; //@line 2315 "translate.cpp"
              var $add=((($18)+4449)&4294967295); //@line 2315 "translate.cpp"
              $c_addr=$add; //@line 2315 "translate.cpp"
              var $19=$final; //@line 2316 "translate.cpp"
              var $cmp27=((($19))|0) > 0; //@line 2316 "translate.cpp"
              if (!($cmp27)) { __label__ = 14;break $if_then26$$if_else$15; } //@line 2316 "translate.cpp"
  
              var $20=$final; //@line 2317 "translate.cpp"
              var $add29=((($20)+4519)&4294967295); //@line 2317 "translate.cpp"
              var $21=$insert_addr; //@line 2317 "translate.cpp"
              HEAP32[(($21)>>2)]=$add29; //@line 2317 "translate.cpp"
              ; //@line 2317 "translate.cpp"
            }
            else if (__label__ == 13) {
  
              var $22=$initial; //@line 2322 "translate.cpp"
              var $add31=((($22)+4352)&4294967295); //@line 2322 "translate.cpp"
              $c_addr=$add31; //@line 2322 "translate.cpp"
              var $23=$medial; //@line 2323 "translate.cpp"
              var $mul=((($23)*28)&4294967295); //@line 2323 "translate.cpp"
              var $24=$final; //@line 2323 "translate.cpp"
              var $add33=((($24)+50500)&4294967295); //@line 2323 "translate.cpp"
              var $add34=((($add33)+($mul))&4294967295); //@line 2323 "translate.cpp"
              var $25=$insert_addr; //@line 2323 "translate.cpp"
              HEAP32[(($25)>>2)]=$add34; //@line 2323 "translate.cpp"
              ;
            }
          } while(0);
  
          var $26=$c_addr; //@line 2325 "translate.cpp"
          $retval=$26; //@line 2325 "translate.cpp"
          __label__ = 19;break $sw_epilog$$sw_bb$$sw_bb17$2; //@line 2325 "translate.cpp"
        }
        else if (__label__ == 15) {
  
          var $27=$c_addr; //@line 2328 "translate.cpp"
          var $sub37=((($27)-12592)&4294967295); //@line 2328 "translate.cpp"
          $code=$sub37; //@line 2328 "translate.cpp"
          var $cmp38=((($sub37))|0) >= 0; //@line 2328 "translate.cpp"
          if (!($cmp38)) { __label__ = 18;break $sw_epilog$$sw_bb$$sw_bb17$2; } //@line 2328 "translate.cpp"
  
          var $28=$code; //@line 2328 "translate.cpp"
          var $cmp40=((($28))|0) < 52; //@line 2328 "translate.cpp"
          if (!($cmp40)) { __label__ = 18;break $sw_epilog$$sw_bb$$sw_bb17$2; } //@line 2328 "translate.cpp"
  
          var $29=$code; //@line 2331 "translate.cpp"
          var $arrayidx42=((__ZZL13TranslateCharP10TranslatorPcijjPiE20hangul_compatibility+$29)&4294967295); //@line 2331 "translate.cpp"
          var $30=HEAPU8[($arrayidx42)]; //@line 2331 "translate.cpp"
          var $conv=((($30))&255); //@line 2331 "translate.cpp"
          var $add43=((($conv)+4352)&4294967295); //@line 2331 "translate.cpp"
          $retval=$add43; //@line 2331 "translate.cpp"
          __label__ = 19;break $sw_epilog$$sw_bb$$sw_bb17$2; //@line 2331 "translate.cpp"
        }
      }
    } while(0);
    if (__label__ == 18) {
  
      var $31=$tr_addr; //@line 2335 "translate.cpp"
      var $32=$c_addr; //@line 2335 "translate.cpp"
      var $33=$next_in_addr; //@line 2335 "translate.cpp"
      var $34=$insert_addr; //@line 2335 "translate.cpp"
      var $call46=__ZL14SubstituteCharP10TranslatorjjPi($31, $32, $33, $34); //@line 2335 "translate.cpp"
      $retval=$call46; //@line 2335 "translate.cpp"
      ; //@line 2335 "translate.cpp"
    }
  
    var $35=$retval; //@line 2336 "translate.cpp"
    STACKTOP = __stackBase__;
    return $35; //@line 2336 "translate.cpp"
    return null;
  }
  

  function __ZL14TranslateWord2P10TranslatorPcP8WORD_TABii($tr, $word, $wtab, $pre_pause, $next_pause) {
    var __stackBase__  = STACKTOP; STACKTOP += 392; _memset(__stackBase__, 0, 392);
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $tr_addr;
    var $word_addr;
    var $wtab_addr;
    var $pre_pause_addr;
    var $next_pause_addr;
    var $flags;
    var $stress;
    var $next_stress;
    var $next_tone;
    var $p;
    var $srcix;
    var $embedded_cmd;
    var $value;
    var $found_dict_flag;
    var $ph_code;
    var $plist2;
    var $ph;
    var $max_stress;
    var $max_stress_ix;
    var $prev_vowel;
    var $pitch_raised;
    var $switch_phonemes;
    var $first_phoneme;
    var $source_ix;
    var $len;
    var $ix;
    var $sylimit;
    var $new_language;
    var $bad_phoneme=__stackBase__;
    var $word_flags;
    var $word_copy_len;
    var $word_copy=__stackBase__+4;
    var $old_dictionary_name=__stackBase__+168;
    var $c1;
    var $lang_name=__stackBase__+208;
    var $c2;
    var $p2;
    var $ok;
    var $flags2=__stackBase__+220;
    var $c_word2=__stackBase__+228;
    var $ph_buf=__stackBase__+232;
    $tr_addr=$tr;
    $word_addr=$word;
    $wtab_addr=$wtab;
    $pre_pause_addr=$pre_pause;
    $next_pause_addr=$next_pause;
    $flags=0; //@line 1600 "translate.cpp"
    $next_tone=0; //@line 1603 "translate.cpp"
    $max_stress_ix=0; //@line 1613 "translate.cpp"
    $prev_vowel=-1; //@line 1614 "translate.cpp"
    $pitch_raised=0; //@line 1615 "translate.cpp"
    $switch_phonemes=-1; //@line 1616 "translate.cpp"
    $first_phoneme=1; //@line 1617 "translate.cpp"
    var $0=HEAP32[((_f_logespeak)>>2)]; //@line 1629 "translate.cpp"
    var $cmp=((($0))|0)!=0; //@line 1629 "translate.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 7;; } //@line 1629 "translate.cpp"
    $land_lhs_true$$if_end10$2: do { 
      if (__label__ == 1) {
  
        var $1=HEAP32[((_logging_type)>>2)]; //@line 1629 "translate.cpp"
        var $and=($1) & 8; //@line 1629 "translate.cpp"
        var $tobool=((($and))|0)!=0; //@line 1629 "translate.cpp"
        if (!($tobool)) { __label__ = 7;break $land_lhs_true$$if_end10$2; } //@line 1629 "translate.cpp"
  
        var $2=HEAP32[((_f_logespeak)>>2)]; //@line 1631 "translate.cpp"
        var $3=$wtab_addr; //@line 1631 "translate.cpp"
        var $flags1=(($3)&4294967295); //@line 1631 "translate.cpp"
        var $4=HEAP32[(($flags1)>>2)]; //@line 1631 "translate.cpp"
        var $5=$wtab_addr; //@line 1631 "translate.cpp"
        var $length=(($5+10)&4294967295); //@line 1631 "translate.cpp"
        var $6=HEAPU8[($length)]; //@line 1631 "translate.cpp"
        var $conv=((($6))&255); //@line 1631 "translate.cpp"
        var $call=_fprintf($2, ((__str9552)&4294967295), allocate([$4,0,0,0,$conv,0,0,0], ["i32",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 1631 "translate.cpp"
        $ix=0; //@line 1632 "translate.cpp"
        __lastLabel__ = 2; ; //@line 1632 "translate.cpp"
        while(1) { 
  
          var $7=__lastLabel__ == 5 ? $inc : (0); //@line 1632 "translate.cpp"
          var $cmp2=((($7))|0) < 40; //@line 1632 "translate.cpp"
          if (!($cmp2)) { __label__ = 6;break ; } //@line 1632 "translate.cpp"
  
          var $8=$ix; //@line 1634 "translate.cpp"
          var $9=$word_addr; //@line 1634 "translate.cpp"
          var $arrayidx=(($9+$8)&4294967295); //@line 1634 "translate.cpp"
          var $10=HEAP8[($arrayidx)]; //@line 1634 "translate.cpp"
          var $conv3=(tempInt=(($10)),(tempInt>=128?tempInt-256:tempInt)); //@line 1634 "translate.cpp"
          var $cmp4=((($conv3))|0)==0; //@line 1634 "translate.cpp"
          if ($cmp4) { __label__ = 6;break ; } //@line 1634 "translate.cpp"
  
          var $11=$ix; //@line 1635 "translate.cpp"
          var $12=$word_addr; //@line 1635 "translate.cpp"
          var $arrayidx6=(($12+$11)&4294967295); //@line 1635 "translate.cpp"
          var $13=HEAP8[($arrayidx6)]; //@line 1635 "translate.cpp"
          var $conv7=(tempInt=(($13)),(tempInt>=128?tempInt-256:tempInt)); //@line 1635 "translate.cpp"
          var $14=HEAP32[((_f_logespeak)>>2)]; //@line 1635 "translate.cpp"
          var $call8=_fputc($conv7, $14); //@line 1635 "translate.cpp"
          var $15=$ix; //@line 1632 "translate.cpp"
          var $inc=((($15)+1)&4294967295); //@line 1632 "translate.cpp"
          $ix=$inc; //@line 1632 "translate.cpp"
          __lastLabel__ = 5; __label__ = 3;continue ; //@line 1632 "translate.cpp"
        }
  
        var $16=HEAP32[((_f_logespeak)>>2)]; //@line 1637 "translate.cpp"
        var $17=_fwrite(((__str10553)&4294967295), 2, 1, $16); //@line 1637 "translate.cpp"
        ; //@line 1638 "translate.cpp"
      }
    } while(0);
  
    var $18=$wtab_addr; //@line 1640 "translate.cpp"
    var $length11=(($18+10)&4294967295); //@line 1640 "translate.cpp"
    var $19=HEAPU8[($length11)]; //@line 1640 "translate.cpp"
    var $conv12=((($19))&255); //@line 1640 "translate.cpp"
    $len=$conv12; //@line 1640 "translate.cpp"
    var $cmp13=((($conv12))|0) > 31; //@line 1641 "translate.cpp"
    if ($cmp13) { __label__ = 8;; } else { __label__ = 9;; } //@line 1641 "translate.cpp"
    if (__label__ == 8) {
  
      $len=31; //@line 1641 "translate.cpp"
      ; //@line 1641 "translate.cpp"
    }
  
    var $20=$wtab_addr; //@line 1642 "translate.cpp"
    var $sourceix=(($20+6)&4294967295); //@line 1642 "translate.cpp"
    var $21=HEAPU16[(($sourceix)>>1)]; //@line 1642 "translate.cpp"
    var $conv16=((($21))&65535); //@line 1642 "translate.cpp"
    var $and17=($conv16) & 2047; //@line 1642 "translate.cpp"
    var $22=$len; //@line 1642 "translate.cpp"
    var $shl=($22) << 11; //@line 1642 "translate.cpp"
    var $or=($and17) | ($shl); //@line 1642 "translate.cpp"
    $source_ix=$or; //@line 1642 "translate.cpp"
    var $23=$wtab_addr; //@line 1644 "translate.cpp"
    var $arrayidx18=(($23)&4294967295); //@line 1644 "translate.cpp"
    var $flags19=(($arrayidx18)&4294967295); //@line 1644 "translate.cpp"
    var $24=HEAP32[(($flags19)>>2)]; //@line 1644 "translate.cpp"
    $word_flags=$24; //@line 1644 "translate.cpp"
    var $25=$word_flags; //@line 1645 "translate.cpp"
    var $and20=($25) & 64; //@line 1645 "translate.cpp"
    var $tobool21=((($and20))|0)!=0; //@line 1645 "translate.cpp"
    if ($tobool21) { __label__ = 10;; } else { __label__ = 18;; } //@line 1645 "translate.cpp"
    $if_then22$$if_end33$14: do { 
      if (__label__ == 10) {
  
        HEAP8[(__ZL13embedded_flag_b)]=1;
        ; //@line 1649 "translate.cpp"
        while(1) { 
  
          var $26=HEAP32[((__ZL13embedded_read)>>2)]; //@line 1651 "translate.cpp"
          var $inc23=((($26)+1)&4294967295); //@line 1651 "translate.cpp"
          HEAP32[((__ZL13embedded_read)>>2)]=$inc23; //@line 1651 "translate.cpp"
          var $arrayidx24=((_embedded_list+$26*4)&4294967295); //@line 1651 "translate.cpp"
          var $27=HEAP32[(($arrayidx24)>>2)]; //@line 1651 "translate.cpp"
          $embedded_cmd=$27; //@line 1651 "translate.cpp"
          var $28=$embedded_cmd; //@line 1652 "translate.cpp"
          var $shr=($28) >> 8; //@line 1652 "translate.cpp"
          $value=$shr; //@line 1652 "translate.cpp"
          var $29=$embedded_cmd; //@line 1654 "translate.cpp"
          var $and25=($29) & 31; //@line 1654 "translate.cpp"
          if ($and25 == 9) {
            __label__ = 12;;
          }
          else if ($and25 == 13) {
            __label__ = 13;;
          }
          else if ($and25 == 12) {
            __label__ = 14;;
          }
          else {
          __label__ = 17;;
          }
          
          if (__label__ == 12) {
  
            var $30=$value; //@line 1657 "translate.cpp"
            HEAP32[((_option_sayas)>>2)]=$30; //@line 1657 "translate.cpp"
            ; //@line 1658 "translate.cpp"
          }
          else if (__label__ == 13) {
  
            var $31=$value; //@line 1661 "translate.cpp"
            HEAP32[((__ZL15option_emphasis)>>2)]=$31; //@line 1661 "translate.cpp"
            ; //@line 1662 "translate.cpp"
          }
          else if (__label__ == 14) {
  
            var $32=$value; //@line 1666 "translate.cpp"
            var $cmp28=((($32))|0)==0; //@line 1666 "translate.cpp"
            if ($cmp28) { __label__ = 15;; } else { __label__ = 16;; } //@line 1666 "translate.cpp"
            if (__label__ == 15) {
  
              $pre_pause_addr=0; //@line 1667 "translate.cpp"
              ; //@line 1667 "translate.cpp"
            }
            else if (__label__ == 16) {
  
              var $33=$value; //@line 1669 "translate.cpp"
              var $34=$pre_pause_addr; //@line 1669 "translate.cpp"
              var $add=((($34)+($33))&4294967295); //@line 1669 "translate.cpp"
              $pre_pause_addr=$add; //@line 1669 "translate.cpp"
              ;
            }
          }
  
          var $35=$embedded_cmd; //@line 1672 "translate.cpp"
          var $and31=($35) & 128; //@line 1672 "translate.cpp"
          var $cmp32=((($and31))|0)==0; //@line 1672 "translate.cpp"
          if ($cmp32) { __label__ = 11;continue ; } else { __label__ = 18;break $if_then22$$if_end33$14; } //@line 1672 "translate.cpp"
        }
      }
    } while(0);
  
    var $36=$word_addr; //@line 1675 "translate.cpp"
    var $arrayidx34=(($36)&4294967295); //@line 1675 "translate.cpp"
    var $37=HEAP8[($arrayidx34)]; //@line 1675 "translate.cpp"
    var $conv35=(tempInt=(($37)),(tempInt>=128?tempInt-256:tempInt)); //@line 1675 "translate.cpp"
    var $cmp36=((($conv35))|0)==0; //@line 1675 "translate.cpp"
    if ($cmp36) { __label__ = 19;; } else { __label__ = 20;; } //@line 1675 "translate.cpp"
    $if_then37$$if_end38$27: do { 
      if (__label__ == 19) {
  
        HEAP8[(((_word_phonemes)&4294967295))]=0; //@line 1678 "translate.cpp"
        $retval=0; //@line 1679 "translate.cpp"
        ; //@line 1679 "translate.cpp"
      }
      else if (__label__ == 20) {
  
        var $38=$tr_addr; //@line 1683 "translate.cpp"
        var $prepause_timeout=(($38+8312)&4294967295); //@line 1683 "translate.cpp"
        var $39=HEAP32[(($prepause_timeout)>>2)]; //@line 1683 "translate.cpp"
        var $cmp39=((($39))|0) > 0; //@line 1683 "translate.cpp"
        if ($cmp39) { __label__ = 21;; } else { __label__ = 22;; } //@line 1683 "translate.cpp"
        if (__label__ == 21) {
  
          var $40=$tr_addr; //@line 1684 "translate.cpp"
          var $prepause_timeout41=(($40+8312)&4294967295); //@line 1684 "translate.cpp"
          var $41=HEAP32[(($prepause_timeout41)>>2)]; //@line 1684 "translate.cpp"
          var $dec=((($41)-1)&4294967295); //@line 1684 "translate.cpp"
          HEAP32[(($prepause_timeout41)>>2)]=$dec; //@line 1684 "translate.cpp"
          ; //@line 1684 "translate.cpp"
        }
  
        var $42=HEAP32[((_option_sayas)>>2)]; //@line 1686 "translate.cpp"
        var $and43=($42) & 240; //@line 1686 "translate.cpp"
        var $cmp44=((($and43))|0)==16; //@line 1686 "translate.cpp"
        if ($cmp44) { __label__ = 23;; } else { __label__ = 25;; } //@line 1686 "translate.cpp"
        $if_then45$$if_end51$33: do { 
          if (__label__ == 23) {
  
            var $43=$word_flags; //@line 1688 "translate.cpp"
            var $and46=($43) & 512; //@line 1688 "translate.cpp"
            var $tobool47=((($and46))|0)!=0; //@line 1688 "translate.cpp"
            if ($tobool47) { __label__ = 25;break $if_then45$$if_end51$33; } //@line 1688 "translate.cpp"
  
            var $44=$pre_pause_addr; //@line 1691 "translate.cpp"
            var $add49=((($44)+4)&4294967295); //@line 1691 "translate.cpp"
            $pre_pause_addr=$add49; //@line 1691 "translate.cpp"
            ; //@line 1692 "translate.cpp"
          }
        } while(0);
  
        var $45=$word_flags; //@line 1695 "translate.cpp"
        var $and52=($45) & 2; //@line 1695 "translate.cpp"
        var $tobool53=((($and52))|0)!=0; //@line 1695 "translate.cpp"
        if ($tobool53) { __label__ = 26;; } else { __label__ = 32;; } //@line 1695 "translate.cpp"
        $if_then54$$if_end72$37: do { 
          if (__label__ == 26) {
  
            var $46=HEAP32[((_option_capitals)>>2)]; //@line 1697 "translate.cpp"
            var $cmp55=((($46))|0) > 2; //@line 1697 "translate.cpp"
            var $47=HEAP32[((__ZL11embedded_ix)>>2)]; //@line 1697 "translate.cpp"
            var $cmp57=((($47))|0) < 244; //@line 1697 "translate.cpp"
            var $or_cond=($cmp55) & ($cmp57); //@line 1697 "translate.cpp"
            if (!($or_cond)) { __label__ = 32;break $if_then54$$if_end72$37; } //@line 1697 "translate.cpp"
  
            var $_b3=HEAPU8[(__ZL13embedded_flag_b)];
            var $48=($_b3) ? 2 : 0;
            var $tobool59=((($48))|0)!=0; //@line 1700 "translate.cpp"
            if ($tobool59) { __label__ = 28;; } else { __label__ = 29;; } //@line 1700 "translate.cpp"
            if (__label__ == 28) {
  
              var $49=HEAP32[((__ZL11embedded_ix)>>2)]; //@line 1701 "translate.cpp"
              var $sub=((($49)-1)&4294967295); //@line 1701 "translate.cpp"
              var $arrayidx61=((_embedded_list+$sub*4)&4294967295); //@line 1701 "translate.cpp"
              var $50=HEAP32[(($arrayidx61)>>2)]; //@line 1701 "translate.cpp"
              var $and62=($50) & -129; //@line 1701 "translate.cpp"
              HEAP32[(($arrayidx61)>>2)]=$and62; //@line 1701 "translate.cpp"
              ; //@line 1701 "translate.cpp"
            }
  
            var $51=HEAP32[((_option_capitals)>>2)]; //@line 1702 "translate.cpp"
            $pitch_raised=$51; //@line 1702 "translate.cpp"
            var $cmp64=((($51))|0)==3; //@line 1702 "translate.cpp"
            if ($cmp64) { __label__ = 30;; } else { __label__ = 31;; } //@line 1702 "translate.cpp"
            if (__label__ == 30) {
  
              $pitch_raised=20; //@line 1703 "translate.cpp"
              ; //@line 1703 "translate.cpp"
            }
  
            var $52=$pitch_raised; //@line 1704 "translate.cpp"
            var $shl67=((($52)*256)&4294967295); //@line 1704 "translate.cpp"
            var $add68=((($shl67)+193)&4294967295); //@line 1704 "translate.cpp"
            var $53=HEAP32[((__ZL11embedded_ix)>>2)]; //@line 1704 "translate.cpp"
            var $inc69=((($53)+1)&4294967295); //@line 1704 "translate.cpp"
            HEAP32[((__ZL11embedded_ix)>>2)]=$inc69; //@line 1704 "translate.cpp"
            var $arrayidx70=((_embedded_list+$53*4)&4294967295); //@line 1704 "translate.cpp"
            HEAP32[(($arrayidx70)>>2)]=$add68; //@line 1704 "translate.cpp"
            HEAP8[(__ZL13embedded_flag_b)]=1;
            ; //@line 1706 "translate.cpp"
          }
        } while(0);
  
        $p=((_word_phonemes)&4294967295); //@line 1709 "translate.cpp"
        var $54=$word_flags; //@line 1710 "translate.cpp"
        var $and73=($54) & 8; //@line 1710 "translate.cpp"
        var $tobool74=((($and73))|0)!=0; //@line 1710 "translate.cpp"
        if ($tobool74) { __label__ = 33;; } else { __label__ = 40;; } //@line 1710 "translate.cpp"
        $if_then75$$if_else100$47: do { 
          if (__label__ == 33) {
  
            var $55=$word_addr; //@line 1716 "translate.cpp"
            var $call76=_memcmp($55, ((__str11554)&4294967295), 3); //@line 1716 "translate.cpp"
            var $cmp77=((($call76))|0)==0; //@line 1716 "translate.cpp"
            var $56=$word_addr; //@line 1719 "translate.cpp"
            if ($cmp77) { __label__ = 34;; } else { __label__ = 38;; } //@line 1716 "translate.cpp"
            $if_then78$$if_else96$49: do { 
              if (__label__ == 34) {
  
                var $add_ptr=(($56+3)&4294967295); //@line 1719 "translate.cpp"
                $word_addr=$add_ptr; //@line 1719 "translate.cpp"
                $ix=0; //@line 1720 "translate.cpp"
                var $57=$word_addr; //@line 1722 "translate.cpp"
                var $incdec_ptr32=(($57+1)&4294967295); //@line 1722 "translate.cpp"
                $word_addr=$incdec_ptr32; //@line 1722 "translate.cpp"
                var $58=HEAP8[($57)]; //@line 1722 "translate.cpp"
                var $conv8033=(tempInt=(($58)),(tempInt>=128?tempInt-256:tempInt)); //@line 1722 "translate.cpp"
                $c1=$conv8033; //@line 1722 "translate.cpp"
                var $59=$c1; //@line 1723 "translate.cpp"
                var $cmp8134=((($59))|0)==32; //@line 1723 "translate.cpp"
                var $60=$c1; //@line 1723 "translate.cpp"
                var $cmp8235=((($60))|0)==0; //@line 1723 "translate.cpp"
                var $or_cond436=($cmp8134) | ($cmp8235); //@line 1723 "translate.cpp"
                if ($or_cond436) { __label__ = 36;; } else { __label__ = 35;; } //@line 1723 "translate.cpp"
                $for_end89$$if_end84$51: do { 
                  if (__label__ == 35) {
                    while(1) { 
  
                      var $61=$c1; //@line 1725 "translate.cpp"
                      var $call85=_tolower($61); //@line 1725 "translate.cpp"
                      var $conv86=((($call85)) & 255); //@line 1725 "translate.cpp"
                      var $62=$ix; //@line 1725 "translate.cpp"
                      var $inc87=((($62)+1)&4294967295); //@line 1725 "translate.cpp"
                      $ix=$inc87; //@line 1725 "translate.cpp"
                      var $arrayidx88=(($lang_name+$62)&4294967295); //@line 1725 "translate.cpp"
                      HEAP8[($arrayidx88)]=$conv86; //@line 1725 "translate.cpp"
                      var $63=$word_addr; //@line 1722 "translate.cpp"
                      var $incdec_ptr=(($63+1)&4294967295); //@line 1722 "translate.cpp"
                      $word_addr=$incdec_ptr; //@line 1722 "translate.cpp"
                      var $64=HEAP8[($63)]; //@line 1722 "translate.cpp"
                      var $conv80=(tempInt=(($64)),(tempInt>=128?tempInt-256:tempInt)); //@line 1722 "translate.cpp"
                      $c1=$conv80; //@line 1722 "translate.cpp"
                      var $65=$c1; //@line 1723 "translate.cpp"
                      var $cmp81=((($65))|0)==32; //@line 1723 "translate.cpp"
                      var $66=$c1; //@line 1723 "translate.cpp"
                      var $cmp82=((($66))|0)==0; //@line 1723 "translate.cpp"
                      var $or_cond4=($cmp81) | ($cmp82); //@line 1723 "translate.cpp"
                      if ($or_cond4) { __label__ = 36;break $for_end89$$if_end84$51; } else { __label__ = 35;continue ; } //@line 1723 "translate.cpp"
                    }
                  }
                } while(0);
  
                var $67=$ix; //@line 1727 "translate.cpp"
                var $arrayidx90=(($lang_name+$67)&4294967295); //@line 1727 "translate.cpp"
                HEAP8[($arrayidx90)]=0; //@line 1727 "translate.cpp"
                var $arraydecay=(($lang_name)&4294967295); //@line 1729 "translate.cpp"
                var $call91=__Z18LookupPhonemeTablePKc($arraydecay); //@line 1729 "translate.cpp"
                $ix=$call91; //@line 1729 "translate.cpp"
                var $cmp92=((($call91))|0) > 0; //@line 1729 "translate.cpp"
                if (!($cmp92)) { __label__ = 39;break $if_then78$$if_else96$49; } //@line 1729 "translate.cpp"
  
                var $68=$ix; //@line 1731 "translate.cpp"
                __Z18SelectPhonemeTablei($68); //@line 1731 "translate.cpp"
                HEAP8[(((_word_phonemes)&4294967295))]=21; //@line 1732 "translate.cpp"
                var $69=$ix; //@line 1733 "translate.cpp"
                var $conv94=((($69)) & 255); //@line 1733 "translate.cpp"
                HEAP8[(((_word_phonemes+1)&4294967295))]=$conv94; //@line 1733 "translate.cpp"
                HEAP8[(((_word_phonemes+2)&4294967295))]=0; //@line 1734 "translate.cpp"
                ; //@line 1735 "translate.cpp"
              }
              else if (__label__ == 38) {
  
                var $arraydecay97=(($bad_phoneme)&4294967295); //@line 1739 "translate.cpp"
                var $call98=__Z14EncodePhonemesPcS_Ph($56, ((_word_phonemes)&4294967295), $arraydecay97); //@line 1739 "translate.cpp"
                ;
              }
            } while(0);
  
            $flags=-2147483648; //@line 1741 "translate.cpp"
            ; //@line 1742 "translate.cpp"
          }
          else if (__label__ == 40) {
  
            $ix=0; //@line 1746 "translate.cpp"
            ; //@line 1747 "translate.cpp"
            $while_cond$59: while(1) { 
  
              var $70=$ix; //@line 1747 "translate.cpp"
              var $71=$word_addr; //@line 1747 "translate.cpp"
              var $arrayidx101=(($71+$70)&4294967295); //@line 1747 "translate.cpp"
              var $72=HEAP8[($arrayidx101)]; //@line 1747 "translate.cpp"
              var $73=$ix; //@line 1747 "translate.cpp"
              var $arrayidx102=(($word_copy+$73)&4294967295); //@line 1747 "translate.cpp"
              HEAP8[($arrayidx102)]=$72; //@line 1747 "translate.cpp"
              var $conv103=(tempInt=(($72)),(tempInt>=128?tempInt-256:tempInt)); //@line 1747 "translate.cpp"
              $c2=$conv103; //@line 1747 "translate.cpp"
              var $cmp104=((($conv103))|0)!=32; //@line 1747 "translate.cpp"
              if (!($cmp104)) { __label__ = 43;break $while_cond$59; } //@line 1747 "translate.cpp"
  
              var $74=$c2; //@line 1747 "translate.cpp"
              var $cmp106=((($74))|0)!=0; //@line 1747 "translate.cpp"
              if (!($cmp106)) { __label__ = 43;break $while_cond$59; } //@line 1747 "translate.cpp"
  
              var $76=$ix; //@line 1747 "translate.cpp"
              var $cmp107=((($76))|0) < 160; //@line 1747 "translate.cpp"
              var $77=$ix; //@line 1747 "translate.cpp"
              if ($cmp107) { __lastLabel__ = 44; ; } else { __lastLabel__ = 44; __label__ = 46;break $while_cond$59; }
  
              var $inc108=((($77)+1)&4294967295); //@line 1747 "translate.cpp"
              $ix=$inc108; //@line 1747 "translate.cpp"
              __label__ = 41;continue $while_cond$59; //@line 1747 "translate.cpp"
            }
            if (__label__ == 43) {
  
              var $75=$ix; //@line 1747 "translate.cpp"
              __lastLabel__ = 43; ;
            }
  
            var $78=__lastLabel__ == 43 ? $75 : ($77);
            $word_copy_len=$78; //@line 1748 "translate.cpp"
            var $79=HEAP32[((_translator)>>2)]; //@line 1750 "translate.cpp"
            var $80=$word_addr; //@line 1750 "translate.cpp"
            var $81=$next_pause_addr; //@line 1750 "translate.cpp"
            var $82=$wtab_addr; //@line 1750 "translate.cpp"
            var $call109=__Z13TranslateWordP10TranslatorPciP8WORD_TAB($79, $80, $81, $82); //@line 1750 "translate.cpp"
            $flags=$call109; //@line 1750 "translate.cpp"
            var $83=$flags; //@line 1752 "translate.cpp"
            var $and110=($83) & 65536; //@line 1752 "translate.cpp"
            var $tobool111=((($and110))|0)!=0; //@line 1752 "translate.cpp"
            if ($tobool111) { __label__ = 47;; } else { __label__ = 48;; } //@line 1752 "translate.cpp"
            if (__label__ == 47) {
  
              var $84=$word_addr; //@line 1755 "translate.cpp"
              var $arraydecay113=(($word_copy)&4294967295); //@line 1755 "translate.cpp"
              var $85=$word_copy_len; //@line 1755 "translate.cpp"
              var $src$, $dest$, $stop$, $stop4$, $fast$;
              $src$ = $arraydecay113;
              $dest$ = $84;
              $stop$ = $src$ + $85;
              if (($dest$%4) == ($src$%4) && $85 > 8) {
                while ($src$%4 !== 0 && $src$ < $stop$) {
                  ; HEAP8[$dest$++] = HEAP8[$src$++];
                }
                $src$ >>= 2;
                $dest$ >>= 2;
                $stop4$ = $stop$ >> 2;
                while ($src$ < $stop4$) {
              ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
                }
                $src$ <<= 2;
                $dest$ <<= 2;
              }while ($src$ < $stop$) {
                ; HEAP8[$dest$++] = HEAP8[$src$++];
              }; //@line 1755 "translate.cpp"
              var $86=$flags; //@line 1756 "translate.cpp"
              $retval=$86; //@line 1756 "translate.cpp"
              __label__ = 171;break $if_then37$$if_end38$27; //@line 1756 "translate.cpp"
            }
            else if (__label__ == 48) {
  
              var $87=$flags; //@line 1759 "translate.cpp"
              var $and115=($87) & 8388608; //@line 1759 "translate.cpp"
              var $tobool116=((($and115))|0)!=0; //@line 1759 "translate.cpp"
              if ($tobool116) { __label__ = 49;; } else { __label__ = 72;; } //@line 1759 "translate.cpp"
              $land_lhs_true117$$if_end192$70: do { 
                if (__label__ == 49) {
  
                  var $88=$wtab_addr; //@line 1759 "translate.cpp"
                  var $arrayidx118=(($88+12)&4294967295); //@line 1759 "translate.cpp"
                  var $flags119=(($arrayidx118)&4294967295); //@line 1759 "translate.cpp"
                  var $89=HEAP32[(($flags119)>>2)]; //@line 1759 "translate.cpp"
                  var $and120=($89) & 8; //@line 1759 "translate.cpp"
                  var $tobool121=((($and120))|0)!=0; //@line 1759 "translate.cpp"
                  if ($tobool121) { __label__ = 72;break $land_lhs_true117$$if_end192$70; } //@line 1759 "translate.cpp"
  
                  $ok=1; //@line 1762 "translate.cpp"
                  var $arrayidx123=(($flags2)&4294967295); //@line 1767 "translate.cpp"
                  HEAP32[(($arrayidx123)>>2)]=0; //@line 1767 "translate.cpp"
                  var $90=$tr_addr; //@line 1768 "translate.cpp"
                  var $langopts=(($90)&4294967295); //@line 1768 "translate.cpp"
                  var $param=(($langopts+24)&4294967295); //@line 1768 "translate.cpp"
                  var $arrayidx124=(($param+44)&4294967295); //@line 1768 "translate.cpp"
                  var $91=HEAP32[(($arrayidx124)>>2)]; //@line 1768 "translate.cpp"
                  $sylimit=$91; //@line 1768 "translate.cpp"
                  var $92=$word_addr; //@line 1772 "translate.cpp"
                  $p2=$92; //@line 1772 "translate.cpp"
                  var $93=$p2; //@line 1773 "translate.cpp"
                  var $94=HEAP8[($93)]; //@line 1773 "translate.cpp"
                  var $conv12620=(tempInt=(($94)),(tempInt>=128?tempInt-256:tempInt)); //@line 1773 "translate.cpp"
                  var $cmp12721=((($conv12620))|0)!=32; //@line 1773 "translate.cpp"
                  var $95=$p2; //@line 1773 "translate.cpp"
                  var $incdec_ptr12922=(($95+1)&4294967295); //@line 1773 "translate.cpp"
                  if ($cmp12721) { __lastLabel__ = 50; __label__ = 51;; } else { __lastLabel__ = 50; __label__ = 52;; } //@line 1773 "translate.cpp"
                  $while_body128$$while_end130$73: do { 
                    if (__label__ == 51) {
                      while(1) { 
  
                        var $incdec_ptr12923=__lastLabel__ == 51 ? $incdec_ptr129 : ($incdec_ptr12922);
                        $p2=$incdec_ptr12923; //@line 1773 "translate.cpp"
                        var $96=$p2; //@line 1773 "translate.cpp"
                        var $97=HEAP8[($96)]; //@line 1773 "translate.cpp"
                        var $conv126=(tempInt=(($97)),(tempInt>=128?tempInt-256:tempInt)); //@line 1773 "translate.cpp"
                        var $cmp127=((($conv126))|0)!=32; //@line 1773 "translate.cpp"
                        var $98=$p2; //@line 1773 "translate.cpp"
                        var $incdec_ptr129=(($98+1)&4294967295); //@line 1773 "translate.cpp"
                        if ($cmp127) { __lastLabel__ = 51; __label__ = 51;continue ; } else { __lastLabel__ = 51; __label__ = 52;break $while_body128$$while_end130$73; } //@line 1773 "translate.cpp"
                      }
                    }
                  } while(0);
  
                  var $incdec_ptr129_lcssa=__lastLabel__ == 50 ? $incdec_ptr12922 : ($incdec_ptr129);
                  var $call132=__Z7utf8_inPiPKc($c_word2, $incdec_ptr129_lcssa); //@line 1775 "translate.cpp"
                  var $99=HEAP32[(($c_word2)>>2)]; //@line 1776 "translate.cpp"
                  var $call133=_iswalpha($99); //@line 1776 "translate.cpp"
                  var $tobool134=((($call133))|0)!=0; //@line 1776 "translate.cpp"
                  if ($tobool134) { __label__ = 54;; } else { __label__ = 53;; } //@line 1776 "translate.cpp"
                  if (__label__ == 54) {
  
                    var $_pr=$ok; //@line 1781 "translate.cpp"
                    var $cmp137=((($_pr))|0)!=0; //@line 1781 "translate.cpp"
                    if (!($cmp137)) { __label__ = 72;break $land_lhs_true117$$if_end192$70; } //@line 1781 "translate.cpp"
  
                    var $arraydecay139=(($ph_buf)&4294967295); //@line 1783 "translate.cpp"
                    var $call140=_strcpy($arraydecay139, ((_word_phonemes)&4294967295)); //@line 1783 "translate.cpp"
                    var $100=HEAP32[((_translator)>>2)]; //@line 1785 "translate.cpp"
                    var $101=$p2; //@line 1785 "translate.cpp"
                    var $add_ptr141=(($101+1)&4294967295); //@line 1785 "translate.cpp"
                    var $102=$wtab_addr; //@line 1785 "translate.cpp"
                    var $add_ptr142=(($102+12)&4294967295); //@line 1785 "translate.cpp"
                    var $call143=__Z13TranslateWordP10TranslatorPciP8WORD_TAB($100, $add_ptr141, 0, $add_ptr142); //@line 1785 "translate.cpp"
                    var $arrayidx144=(($flags2)&4294967295); //@line 1785 "translate.cpp"
                    HEAP32[(($arrayidx144)>>2)]=$call143; //@line 1785 "translate.cpp"
                    var $arrayidx145=(($flags2)&4294967295); //@line 1786 "translate.cpp"
                    var $103=HEAP32[(($arrayidx145)>>2)]; //@line 1786 "translate.cpp"
                    var $and146=($103) & 67108864; //@line 1786 "translate.cpp"
                    var $tobool147=((($and146))|0)!=0; //@line 1786 "translate.cpp"
                    if ($tobool147) { __label__ = 56;; } else { __label__ = 57;; } //@line 1786 "translate.cpp"
                    if (__label__ == 56) {
  
                      $ok=0; //@line 1787 "translate.cpp"
                      ; //@line 1787 "translate.cpp"
                    }
  
                    var $104=$sylimit; //@line 1789 "translate.cpp"
                    var $and150=($104) & 256; //@line 1789 "translate.cpp"
                    var $tobool151=((($and150))|0)!=0; //@line 1789 "translate.cpp"
                    if ($tobool151) { __label__ = 58;; } else { __label__ = 60;; } //@line 1789 "translate.cpp"
                    $if_then152$$if_end158$83: do { 
                      if (__label__ == 58) {
  
                        var $arrayidx153=(($flags2)&4294967295); //@line 1792 "translate.cpp"
                        var $105=HEAP32[(($arrayidx153)>>2)]; //@line 1792 "translate.cpp"
                        var $and154=($105) & 1048576; //@line 1792 "translate.cpp"
                        var $cmp155=((($and154))|0)==0; //@line 1792 "translate.cpp"
                        if (!($cmp155)) { __label__ = 60;break $if_then152$$if_end158$83; } //@line 1792 "translate.cpp"
  
                        $ok=0; //@line 1794 "translate.cpp"
                        ; //@line 1795 "translate.cpp"
                      }
                    } while(0);
  
                    var $106=$sylimit; //@line 1798 "translate.cpp"
                    var $and159=($106) & 512; //@line 1798 "translate.cpp"
                    var $tobool160=((($and159))|0)!=0; //@line 1798 "translate.cpp"
                    if ($tobool160) { __label__ = 61;; } else { __label__ = 63;; } //@line 1798 "translate.cpp"
                    $land_lhs_true161$$if_end167$87: do { 
                      if (__label__ == 61) {
  
                        var $107=$wtab_addr; //@line 1798 "translate.cpp"
                        var $add_ptr162=(($107+12)&4294967295); //@line 1798 "translate.cpp"
                        var $flags163=(($add_ptr162)&4294967295); //@line 1798 "translate.cpp"
                        var $108=HEAP32[(($flags163)>>2)]; //@line 1798 "translate.cpp"
                        var $and164=($108) & 16; //@line 1798 "translate.cpp"
                        var $tobool165=((($and164))|0)!=0; //@line 1798 "translate.cpp"
                        if (!($tobool165)) { __label__ = 63;break $land_lhs_true161$$if_end167$87; } //@line 1798 "translate.cpp"
  
                        $ok=0; //@line 1801 "translate.cpp"
                        __label__ = 64;break $land_lhs_true161$$if_end167$87; //@line 1804 "translate.cpp"
                      }
                    } while(0);
                    $if_end173$$if_end167$90: do { 
                      if (__label__ == 63) {
  
                        var $_pr8=$ok; //@line 1804 "translate.cpp"
                        var $cmp168=((($_pr8))|0)==0; //@line 1804 "translate.cpp"
                        if ($cmp168) { __label__ = 64;break $if_end173$$if_end167$90; } else { __label__ = 65;break $if_end173$$if_end167$90; } //@line 1804 "translate.cpp"
                      }
                    } while(0);
                    if (__label__ == 64) {
  
                      var $arraydecay170=(($ph_buf)&4294967295); //@line 1806 "translate.cpp"
                      var $call171=_strcpy(((_word_phonemes)&4294967295), $arraydecay170); //@line 1806 "translate.cpp"
                      var $_pr10_pr=$ok; //@line 1810 "translate.cpp"
                      var $tobool174=((($_pr10_pr))|0)!=0; //@line 1810 "translate.cpp"
                      if (!($tobool174)) { __label__ = 72;break $land_lhs_true117$$if_end192$70; } //@line 1810 "translate.cpp"
                    }
  
                    var $109=$p2; //@line 1812 "translate.cpp"
                    HEAP8[($109)]=45; //@line 1812 "translate.cpp"
                    var $110=HEAP32[((_translator)>>2)]; //@line 1813 "translate.cpp"
                    var $111=$word_addr; //@line 1813 "translate.cpp"
                    var $112=$next_pause_addr; //@line 1813 "translate.cpp"
                    var $113=$wtab_addr; //@line 1813 "translate.cpp"
                    var $call176=__Z13TranslateWordP10TranslatorPciP8WORD_TAB($110, $111, $112, $113); //@line 1813 "translate.cpp"
                    $flags=$call176; //@line 1813 "translate.cpp"
                    var $114=$sylimit; //@line 1814 "translate.cpp"
                    var $cmp177=((($114))|0) > 0; //@line 1814 "translate.cpp"
                    if ($cmp177) { __lastLabel__ = 65; __label__ = 66;; } else { __lastLabel__ = 65; __label__ = 69;; } //@line 1814 "translate.cpp"
                    if (__label__ == 66) {
  
                      var $115=$p; //@line 1814 "translate.cpp"
                      var $call179=__ZL14CountSyllablesPh($115); //@line 1814 "translate.cpp"
                      var $116=$sylimit; //@line 1814 "translate.cpp"
                      var $and180=($116) & 31; //@line 1814 "translate.cpp"
                      var $cmp181=((($call179))|0) > ((($and180))|0); //@line 1814 "translate.cpp"
                      if ($cmp181) { __label__ = 67;; } else { __label__ = 68;; } //@line 1814 "translate.cpp"
                      if (__label__ == 67) {
  
                        var $117=$p2; //@line 1817 "translate.cpp"
                        HEAP8[($117)]=32; //@line 1817 "translate.cpp"
                        var $118=HEAP32[((_translator)>>2)]; //@line 1818 "translate.cpp"
                        var $119=$word_addr; //@line 1818 "translate.cpp"
                        var $120=$next_pause_addr; //@line 1818 "translate.cpp"
                        var $121=$wtab_addr; //@line 1818 "translate.cpp"
                        var $call183=__Z13TranslateWordP10TranslatorPciP8WORD_TAB($118, $119, $120, $121); //@line 1818 "translate.cpp"
                        $flags=$call183; //@line 1818 "translate.cpp"
                        __label__ = 72;break $land_lhs_true117$$if_end192$70; //@line 1819 "translate.cpp"
                      }
                      else if (__label__ == 68) {
  
                        var $_pr14=$flags; //@line 1822 "translate.cpp"
                        __lastLabel__ = 68; ;
                      }
                    }
  
                    var $122=__lastLabel__ == 68 ? $_pr14 : ($call176); //@line 1822 "translate.cpp"
                    var $cmp185=((($122))|0)==0; //@line 1822 "translate.cpp"
                    if ($cmp185) { __label__ = 70;; } else { __label__ = 71;; } //@line 1822 "translate.cpp"
                    if (__label__ == 70) {
  
                      var $arrayidx187=(($flags2)&4294967295); //@line 1823 "translate.cpp"
                      var $123=HEAP32[(($arrayidx187)>>2)]; //@line 1823 "translate.cpp"
                      $flags=$123; //@line 1823 "translate.cpp"
                      ; //@line 1823 "translate.cpp"
                    }
  
                    var $124=$flags; //@line 1824 "translate.cpp"
                    var $or189=($124) | 128; //@line 1824 "translate.cpp"
                    $flags=$or189; //@line 1824 "translate.cpp"
                    HEAP32[((_dictionary_skipwords)>>2)]=1; //@line 1825 "translate.cpp"
                    ;
                  }
                  else if (__label__ == 53) {
  
                    $ok=0; //@line 1778 "translate.cpp"
                    ; //@line 1810 "translate.cpp"
                  }
                }
              } while(0);
  
              var $125=$p; //@line 1830 "translate.cpp"
              var $arrayidx193=(($125)&4294967295); //@line 1830 "translate.cpp"
              var $126=HEAPU8[($arrayidx193)]; //@line 1830 "translate.cpp"
              var $conv194=((($126))&255); //@line 1830 "translate.cpp"
              var $cmp195=((($conv194))|0)==21; //@line 1830 "translate.cpp"
              if ($cmp195) { __label__ = 73;; } else { __label__ = 84;; } //@line 1830 "translate.cpp"
              $if_then196$$if_end232$106: do { 
                if (__label__ == 73) {
  
                  var $127=$word_addr; //@line 1833 "translate.cpp"
                  var $arraydecay197=(($word_copy)&4294967295); //@line 1833 "translate.cpp"
                  var $128=$word_copy_len; //@line 1833 "translate.cpp"
                  var $src$, $dest$, $stop$, $stop4$, $fast$;
                  $src$ = $arraydecay197;
                  $dest$ = $127;
                  $stop$ = $src$ + $128;
                  if (($dest$%4) == ($src$%4) && $128 > 8) {
                    while ($src$%4 !== 0 && $src$ < $stop$) {
                      ; HEAP8[$dest$++] = HEAP8[$src$++];
                    }
                    $src$ >>= 2;
                    $dest$ >>= 2;
                    $stop4$ = $stop$ >> 2;
                    while ($src$ < $stop4$) {
                  ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
                    }
                    $src$ <<= 2;
                    $dest$ <<= 2;
                  }while ($src$ < $stop$) {
                    ; HEAP8[$dest$++] = HEAP8[$src$++];
                  }; //@line 1833 "translate.cpp"
                  var $129=$p; //@line 1835 "translate.cpp"
                  var $arrayidx198=(($129+1)&4294967295); //@line 1835 "translate.cpp"
                  $new_language=$arrayidx198; //@line 1835 "translate.cpp"
                  var $130=$new_language; //@line 1836 "translate.cpp"
                  var $arrayidx199=(($130)&4294967295); //@line 1836 "translate.cpp"
                  var $131=HEAP8[($arrayidx199)]; //@line 1836 "translate.cpp"
                  var $conv200=(tempInt=(($131)),(tempInt>=128?tempInt-256:tempInt)); //@line 1836 "translate.cpp"
                  var $cmp201=((($conv200))|0)==0; //@line 1836 "translate.cpp"
                  if ($cmp201) { __label__ = 74;; } else { __label__ = 75;; } //@line 1836 "translate.cpp"
                  if (__label__ == 74) {
  
                    $new_language=((__str52704)&4294967295); //@line 1837 "translate.cpp"
                    ; //@line 1837 "translate.cpp"
                  }
  
                  var $arraydecay204=(($old_dictionary_name)&4294967295); //@line 1839 "translate.cpp"
                  var $call205=_strcpy($arraydecay204, ((_dictionary_name)&4294967295)); //@line 1839 "translate.cpp"
                  var $132=$new_language; //@line 1840 "translate.cpp"
                  var $call206=__Z14SetTranslator2PKc($132); //@line 1840 "translate.cpp"
                  $switch_phonemes=$call206; //@line 1840 "translate.cpp"
                  var $cmp207=((($call206))|0) >= 0; //@line 1842 "translate.cpp"
                  if ($cmp207) { __label__ = 76;; } else { __label__ = 79;; } //@line 1842 "translate.cpp"
                  $if_then208$$if_then217$111: do { 
                    if (__label__ == 76) {
  
                      var $133=HEAP32[((_translator2)>>2)]; //@line 1845 "translate.cpp"
                      var $134=$word_addr; //@line 1845 "translate.cpp"
                      var $135=$next_pause_addr; //@line 1845 "translate.cpp"
                      var $136=$wtab_addr; //@line 1845 "translate.cpp"
                      var $call209=__Z13TranslateWordP10TranslatorPciP8WORD_TAB($133, $134, $135, $136); //@line 1845 "translate.cpp"
                      $flags=$call209; //@line 1845 "translate.cpp"
                      var $137=$p; //@line 1847 "translate.cpp"
                      var $arrayidx210=(($137)&4294967295); //@line 1847 "translate.cpp"
                      var $138=HEAPU8[($arrayidx210)]; //@line 1847 "translate.cpp"
                      var $conv211=((($138))&255); //@line 1847 "translate.cpp"
                      var $cmp212=((($conv211))|0)==21; //@line 1847 "translate.cpp"
                      if ($cmp212) { __label__ = 77;; } else { __label__ = 78;; } //@line 1847 "translate.cpp"
                      if (__label__ == 77) {
  
                        $switch_phonemes=-1; //@line 1850 "translate.cpp"
                        __label__ = 79;break $if_then208$$if_then217$111; //@line 1851 "translate.cpp"
                      }
                      else if (__label__ == 78) {
  
                        var $_pr15=$switch_phonemes; //@line 1853 "translate.cpp"
                        var $cmp216=((($_pr15))|0) < 0; //@line 1853 "translate.cpp"
                        if ($cmp216) { __label__ = 79;break $if_then208$$if_then217$111; } else { __label__ = 80;break $if_then208$$if_then217$111; } //@line 1853 "translate.cpp"
                      }
                    }
                  } while(0);
                  if (__label__ == 79) {
  
                    var $139=$p; //@line 1856 "translate.cpp"
                    var $arrayidx218=(($139)&4294967295); //@line 1856 "translate.cpp"
                    HEAP8[($arrayidx218)]=13; //@line 1856 "translate.cpp"
                    var $140=$p; //@line 1857 "translate.cpp"
                    var $arrayidx219=(($140+1)&4294967295); //@line 1857 "translate.cpp"
                    HEAP8[($arrayidx219)]=13; //@line 1857 "translate.cpp"
                    var $141=$p; //@line 1858 "translate.cpp"
                    var $arrayidx220=(($141+2)&4294967295); //@line 1858 "translate.cpp"
                    HEAP8[($arrayidx220)]=0; //@line 1858 "translate.cpp"
                    ; //@line 1859 "translate.cpp"
                  }
  
                  var $142=$tr_addr; //@line 1863 "translate.cpp"
                  var $143=$switch_phonemes; //@line 1863 "translate.cpp"
                  var $144=$p; //@line 1863 "translate.cpp"
                  var $call222=__Z24ChangeEquivalentPhonemesP10TranslatoriPc($142, $143, $144); //@line 1863 "translate.cpp"
                  var $tobool223=((($call222))|0)!=0; //@line 1863 "translate.cpp"
                  if ($tobool223) { __label__ = 81;; } else { __label__ = 82;; } //@line 1863 "translate.cpp"
                  if (__label__ == 81) {
  
                    $switch_phonemes=-1; //@line 1866 "translate.cpp"
                    ; //@line 1869 "translate.cpp"
                  }
                  else if (__label__ == 82) {
  
                    var $_pr17=$switch_phonemes; //@line 1869 "translate.cpp"
                    var $cmp226=((($_pr17))|0)==-1; //@line 1869 "translate.cpp"
                    if (!($cmp226)) { __label__ = 84;break $if_then196$$if_end232$106; } //@line 1869 "translate.cpp"
                  }
  
                  var $arraydecay228=(($old_dictionary_name)&4294967295); //@line 1871 "translate.cpp"
                  var $call229=_strcpy(((_dictionary_name)&4294967295), $arraydecay228); //@line 1871 "translate.cpp"
                  var $145=HEAP32[((_voice)>>2)]; //@line 1872 "translate.cpp"
                  var $phoneme_tab_ix=(($145+40)&4294967295); //@line 1872 "translate.cpp"
                  var $146=HEAP32[(($phoneme_tab_ix)>>2)]; //@line 1872 "translate.cpp"
                  __Z18SelectPhonemeTablei($146); //@line 1872 "translate.cpp"
                  var $147=HEAP32[((_voice)>>2)]; //@line 1876 "translate.cpp"
                  var $phoneme_tab_ix230=(($147+40)&4294967295); //@line 1876 "translate.cpp"
                  var $148=HEAP32[(($phoneme_tab_ix230)>>2)]; //@line 1876 "translate.cpp"
                  $switch_phonemes=$148; //@line 1876 "translate.cpp"
                  ; //@line 1877 "translate.cpp"
                }
              } while(0);
  
              var $149=$word_flags; //@line 1880 "translate.cpp"
              var $and233=($149) & 128; //@line 1880 "translate.cpp"
              var $tobool234=((($and233))|0)!=0; //@line 1880 "translate.cpp"
              if ($tobool234) { __label__ = 95;; } else { __label__ = 85;; } //@line 1880 "translate.cpp"
              $if_end261$$if_then235$124: do { 
                if (__label__ == 85) {
  
                  var $150=$flags; //@line 1882 "translate.cpp"
                  var $and236=($150) & 268435456; //@line 1882 "translate.cpp"
                  var $tobool237=((($and236))|0)!=0; //@line 1882 "translate.cpp"
                  if ($tobool237) { __label__ = 86;; } else { __label__ = 88;; } //@line 1882 "translate.cpp"
                  $if_then238$$if_end242$126: do { 
                    if (__label__ == 86) {
  
                      var $151=$pre_pause_addr; //@line 1884 "translate.cpp"
                      var $cmp239=((($151))|0) < 1; //@line 1884 "translate.cpp"
                      if (!($cmp239)) { __label__ = 88;break $if_then238$$if_end242$126; } //@line 1884 "translate.cpp"
  
                      $pre_pause_addr=1; //@line 1885 "translate.cpp"
                      ; //@line 1885 "translate.cpp"
                    }
                  } while(0);
  
                  var $152=$flags; //@line 1887 "translate.cpp"
                  var $and243=($152) & 256; //@line 1887 "translate.cpp"
                  var $tobool244=((($and243))|0)!=0; //@line 1887 "translate.cpp"
                  if (!($tobool244)) { __label__ = 95;break $if_end261$$if_then235$124; } //@line 1887 "translate.cpp"
  
                  var $153=$word_flags; //@line 1887 "translate.cpp"
                  var $tobool246=((($153))|0)!=0; //@line 1887 "translate.cpp"
                  if ($tobool246) { __label__ = 95;break $if_end261$$if_then235$124; } //@line 1887 "translate.cpp"
  
                  var $154=$wtab_addr; //@line 1887 "translate.cpp"
                  var $arrayidx248=(($154+-12)&4294967295); //@line 1887 "translate.cpp"
                  var $flags249=(($arrayidx248)&4294967295); //@line 1887 "translate.cpp"
                  var $155=HEAP32[(($flags249)>>2)]; //@line 1887 "translate.cpp"
                  var $and250=($155) & 512; //@line 1887 "translate.cpp"
                  var $tobool251=((($and250))|0)!=0; //@line 1887 "translate.cpp"
                  if ($tobool251) { __label__ = 95;break $if_end261$$if_then235$124; } //@line 1887 "translate.cpp"
  
                  var $156=$tr_addr; //@line 1887 "translate.cpp"
                  var $prepause_timeout253=(($156+8312)&4294967295); //@line 1887 "translate.cpp"
                  var $157=HEAP32[(($prepause_timeout253)>>2)]; //@line 1887 "translate.cpp"
                  var $cmp254=((($157))|0)==0; //@line 1887 "translate.cpp"
                  if (!($cmp254)) { __label__ = 95;break $if_end261$$if_then235$124; } //@line 1887 "translate.cpp"
  
                  var $158=$pre_pause_addr; //@line 1890 "translate.cpp"
                  var $cmp256=((($158))|0) < 4; //@line 1890 "translate.cpp"
                  if ($cmp256) { __label__ = 93;; } else { __label__ = 94;; } //@line 1890 "translate.cpp"
                  if (__label__ == 93) {
  
                    $pre_pause_addr=4; //@line 1890 "translate.cpp"
                    ; //@line 1890 "translate.cpp"
                  }
  
                  var $159=$tr_addr; //@line 1891 "translate.cpp"
                  var $prepause_timeout259=(($159+8312)&4294967295); //@line 1891 "translate.cpp"
                  HEAP32[(($prepause_timeout259)>>2)]=3; //@line 1891 "translate.cpp"
                  ; //@line 1892 "translate.cpp"
                }
              } while(0);
  
              var $160=HEAP32[((__ZL15option_emphasis)>>2)]; //@line 1895 "translate.cpp"
              var $cmp262=((($160))|0) >= 3; //@line 1895 "translate.cpp"
              if (!($cmp262)) { __label__ = 98;break $if_then75$$if_else100$47; } //@line 1895 "translate.cpp"
  
              var $161=$pre_pause_addr; //@line 1895 "translate.cpp"
              var $cmp264=((($161))|0) < 1; //@line 1895 "translate.cpp"
              if (!($cmp264)) { __label__ = 98;break $if_then75$$if_else100$47; } //@line 1895 "translate.cpp"
  
              $pre_pause_addr=1; //@line 1896 "translate.cpp"
              ; //@line 1896 "translate.cpp"
            }
          }
        } while(0);
  
        var $162=HEAP32[((_n_ph_list2)>>2)]; //@line 1899 "translate.cpp"
        var $arrayidx268=((_ph_list2+$162*8)&4294967295); //@line 1899 "translate.cpp"
        $plist2=$arrayidx268; //@line 1899 "translate.cpp"
        $stress=0; //@line 1900 "translate.cpp"
        $next_stress=1; //@line 1901 "translate.cpp"
        $srcix=0; //@line 1902 "translate.cpp"
        $max_stress=-1; //@line 1903 "translate.cpp"
        $found_dict_flag=0; //@line 1905 "translate.cpp"
        var $163=$flags; //@line 1906 "translate.cpp"
        var $and269=($163) & -2147483648; //@line 1906 "translate.cpp"
        var $tobool270=((($and269))|0)!=0; //@line 1906 "translate.cpp"
        if ($tobool270) { __label__ = 99;; } else { __label__ = 101;; } //@line 1906 "translate.cpp"
        $land_lhs_true271$$while_cond276_preheader$141: do { 
          if (__label__ == 99) {
  
            var $164=$flags; //@line 1906 "translate.cpp"
            var $and272=($164) & 536870912; //@line 1906 "translate.cpp"
            var $tobool273=((($and272))|0)!=0; //@line 1906 "translate.cpp"
            if ($tobool273) { __label__ = 101;break $land_lhs_true271$$while_cond276_preheader$141; } //@line 1906 "translate.cpp"
  
            $found_dict_flag=16; //@line 1907 "translate.cpp"
            ; //@line 1907 "translate.cpp"
          }
        } while(0);
  
        var $165=$pre_pause_addr; //@line 1909 "translate.cpp"
        var $cmp27729=((($165))|0) > 0; //@line 1909 "translate.cpp"
        var $166=HEAP32[((_n_ph_list2)>>2)]; //@line 1909 "translate.cpp"
        var $cmp27930=((($166))|0) < 996; //@line 1909 "translate.cpp"
        var $or_cond531=($cmp27729) & ($cmp27930); //@line 1909 "translate.cpp"
        if ($or_cond531) { __lastLabel__ = 101; __label__ = 102;; } else { __lastLabel__ = 101; __label__ = 106;; } //@line 1909 "translate.cpp"
        $while_body281$$while_end292$145: do { 
          if (__label__ == 102) {
            while(1) { 
  
              var $167=__lastLabel__ == 101 ? $165 : ($173); //@line 1913 "translate.cpp"
              var $cmp282=((($167))|0) > 1; //@line 1913 "translate.cpp"
              var $168=HEAP32[((_n_ph_list2)>>2)]; //@line 1915 "translate.cpp"
              var $inc284=((($168)+1)&4294967295); //@line 1915 "translate.cpp"
              HEAP32[((_n_ph_list2)>>2)]=$inc284; //@line 1915 "translate.cpp"
              var $arrayidx285=((_ph_list2+$168*8)&4294967295); //@line 1915 "translate.cpp"
              if ($cmp282) { __label__ = 103;; } else { __label__ = 104;; } //@line 1913 "translate.cpp"
              if (__label__ == 103) {
  
                __ZL9SetPlist2P13PHONEME_LIST2h($arrayidx285, 9); //@line 1915 "translate.cpp"
                var $169=$pre_pause_addr; //@line 1916 "translate.cpp"
                var $sub286=((($169)-2)&4294967295); //@line 1916 "translate.cpp"
                $pre_pause_addr=$sub286; //@line 1916 "translate.cpp"
                ; //@line 1917 "translate.cpp"
              }
              else if (__label__ == 104) {
  
                __ZL9SetPlist2P13PHONEME_LIST2h($arrayidx285, 11); //@line 1920 "translate.cpp"
                var $170=$pre_pause_addr; //@line 1921 "translate.cpp"
                var $dec290=((($170)-1)&4294967295); //@line 1921 "translate.cpp"
                $pre_pause_addr=$dec290; //@line 1921 "translate.cpp"
                ;
              }
  
              var $171=$tr_addr; //@line 1923 "translate.cpp"
              var $end_stressed_vowel=(($171+8316)&4294967295); //@line 1923 "translate.cpp"
              HEAP32[(($end_stressed_vowel)>>2)]=0; //@line 1923 "translate.cpp"
              var $172=$tr_addr; //@line 1924 "translate.cpp"
              var $prev_dict_flags=(($172+8320)&4294967295); //@line 1924 "translate.cpp"
              HEAP32[(($prev_dict_flags)>>2)]=0; //@line 1924 "translate.cpp"
              var $173=$pre_pause_addr; //@line 1909 "translate.cpp"
              var $cmp277=((($173))|0) > 0; //@line 1909 "translate.cpp"
              var $174=HEAP32[((_n_ph_list2)>>2)]; //@line 1909 "translate.cpp"
              var $cmp279=((($174))|0) < 996; //@line 1909 "translate.cpp"
              var $or_cond5=($cmp277) & ($cmp279); //@line 1909 "translate.cpp"
              if ($or_cond5) { __lastLabel__ = 105; __label__ = 102;continue ; } else { __lastLabel__ = 105; __label__ = 106;break $while_body281$$while_end292$145; } //@line 1909 "translate.cpp"
            }
          }
        } while(0);
  
        var $175=HEAP32[((_option_capitals)>>2)]; //@line 1927 "translate.cpp"
        var $cmp293=((($175))|0)==1; //@line 1927 "translate.cpp"
        if ($cmp293) { __label__ = 107;; } else { __label__ = 111;; } //@line 1927 "translate.cpp"
        $land_lhs_true294$$if_end315$153: do { 
          if (__label__ == 107) {
  
            var $176=$word_flags; //@line 1927 "translate.cpp"
            var $and295=($176) & 2; //@line 1927 "translate.cpp"
            var $tobool296=((($and295))|0)!=0; //@line 1927 "translate.cpp"
            if (!($tobool296)) { __label__ = 111;break $land_lhs_true294$$if_end315$153; } //@line 1927 "translate.cpp"
  
            var $177=HEAP32[((_n_ph_list2)>>2)]; //@line 1929 "translate.cpp"
            var $inc298=((($177)+1)&4294967295); //@line 1929 "translate.cpp"
            HEAP32[((_n_ph_list2)>>2)]=$inc298; //@line 1929 "translate.cpp"
            var $arrayidx299=((_ph_list2+$177*8)&4294967295); //@line 1929 "translate.cpp"
            __ZL9SetPlist2P13PHONEME_LIST2h($arrayidx299, 10); //@line 1929 "translate.cpp"
            var $178=HEAP32[((_n_ph_list2)>>2)]; //@line 1930 "translate.cpp"
            var $inc300=((($178)+1)&4294967295); //@line 1930 "translate.cpp"
            HEAP32[((_n_ph_list2)>>2)]=$inc300; //@line 1930 "translate.cpp"
            var $arrayidx301=((_ph_list2+$178*8)&4294967295); //@line 1930 "translate.cpp"
            __ZL9SetPlist2P13PHONEME_LIST2h($arrayidx301, 18); //@line 1930 "translate.cpp"
            var $179=$word_flags; //@line 1931 "translate.cpp"
            var $and302=($179) & 1; //@line 1931 "translate.cpp"
            var $tobool303=((($and302))|0)!=0; //@line 1931 "translate.cpp"
            if (!($tobool303)) { __label__ = 111;break $land_lhs_true294$$if_end315$153; } //@line 1931 "translate.cpp"
  
            var $180=$word_addr; //@line 1931 "translate.cpp"
            var $arrayidx305=(($180+1)&4294967295); //@line 1931 "translate.cpp"
            var $181=HEAP8[($arrayidx305)]; //@line 1931 "translate.cpp"
            var $conv306=(tempInt=(($181)),(tempInt>=128?tempInt-256:tempInt)); //@line 1931 "translate.cpp"
            var $call307=__Z7IsAlphaj($conv306); //@line 1931 "translate.cpp"
            var $tobool308=((($call307))|0)!=0; //@line 1931 "translate.cpp"
            if (!($tobool308)) { __label__ = 111;break $land_lhs_true294$$if_end315$153; } //@line 1931 "translate.cpp"
  
            var $182=HEAP32[((_n_ph_list2)>>2)]; //@line 1934 "translate.cpp"
            var $inc310=((($182)+1)&4294967295); //@line 1934 "translate.cpp"
            HEAP32[((_n_ph_list2)>>2)]=$inc310; //@line 1934 "translate.cpp"
            var $arrayidx311=((_ph_list2+$182*8)&4294967295); //@line 1934 "translate.cpp"
            __ZL9SetPlist2P13PHONEME_LIST2h($arrayidx311, 10); //@line 1934 "translate.cpp"
            var $183=HEAP32[((_n_ph_list2)>>2)]; //@line 1935 "translate.cpp"
            var $inc312=((($183)+1)&4294967295); //@line 1935 "translate.cpp"
            HEAP32[((_n_ph_list2)>>2)]=$inc312; //@line 1935 "translate.cpp"
            var $arrayidx313=((_ph_list2+$183*8)&4294967295); //@line 1935 "translate.cpp"
            __ZL9SetPlist2P13PHONEME_LIST2h($arrayidx313, 18); //@line 1935 "translate.cpp"
            ; //@line 1936 "translate.cpp"
          }
        } while(0);
  
        var $184=$switch_phonemes; //@line 1939 "translate.cpp"
        var $cmp316=((($184))|0) >= 0; //@line 1939 "translate.cpp"
        if ($cmp316) { __label__ = 112;; } else { __label__ = 113;; } //@line 1939 "translate.cpp"
        if (__label__ == 112) {
  
          var $185=HEAP32[((_n_ph_list2)>>2)]; //@line 1942 "translate.cpp"
          var $arrayidx318=((_ph_list2+$185*8)&4294967295); //@line 1942 "translate.cpp"
          __ZL9SetPlist2P13PHONEME_LIST2h($arrayidx318, 21); //@line 1942 "translate.cpp"
          var $186=$switch_phonemes; //@line 1943 "translate.cpp"
          var $conv319=((($186)) & 255); //@line 1943 "translate.cpp"
          var $187=HEAP32[((_n_ph_list2)>>2)]; //@line 1943 "translate.cpp"
          var $inc320=((($187)+1)&4294967295); //@line 1943 "translate.cpp"
          HEAP32[((_n_ph_list2)>>2)]=$inc320; //@line 1943 "translate.cpp"
          var $arrayidx321=((_ph_list2+$187*8)&4294967295); //@line 1943 "translate.cpp"
          var $tone_ph=(($arrayidx321+3)&4294967295); //@line 1943 "translate.cpp"
          HEAP8[($tone_ph)]=$conv319; //@line 1943 "translate.cpp"
          ; //@line 1944 "translate.cpp"
        }
  
        var $188=$word_flags; //@line 1947 "translate.cpp"
        var $and323=($188) & 128; //@line 1947 "translate.cpp"
        var $tobool324=((($and323))|0)!=0; //@line 1947 "translate.cpp"
        if ($tobool324) { __label__ = 114;; } else { __label__ = 116;; } //@line 1947 "translate.cpp"
        $land_lhs_true325$$if_end331$162: do { 
          if (__label__ == 114) {
  
            var $189=$p; //@line 1947 "translate.cpp"
            var $190=HEAPU8[($189)]; //@line 1947 "translate.cpp"
            var $idxprom=((($190))&255); //@line 1947 "translate.cpp"
            var $arrayidx326=((_phoneme_tab+$idxprom*4)&4294967295); //@line 1947 "translate.cpp"
            var $191=HEAP32[(($arrayidx326)>>2)]; //@line 1947 "translate.cpp"
            var $type=(($191+11)&4294967295); //@line 1947 "translate.cpp"
            var $192=HEAPU8[($type)]; //@line 1947 "translate.cpp"
            var $conv327=((($192))&255); //@line 1947 "translate.cpp"
            var $cmp328=((($conv327))|0)==0; //@line 1947 "translate.cpp"
            if (!($cmp328)) { __label__ = 116;break $land_lhs_true325$$if_end331$162; } //@line 1947 "translate.cpp"
  
            var $193=$p; //@line 1948 "translate.cpp"
            var $incdec_ptr330=(($193+1)&4294967295); //@line 1948 "translate.cpp"
            $p=$incdec_ptr330; //@line 1948 "translate.cpp"
            ; //@line 1948 "translate.cpp"
          }
        } while(0);
  
        var $194=$p; //@line 1950 "translate.cpp"
        var $arrayidx332=(($194)&4294967295); //@line 1950 "translate.cpp"
        var $195=HEAPU8[($arrayidx332)]; //@line 1950 "translate.cpp"
        var $conv333=((($195))&255); //@line 1950 "translate.cpp"
        var $cmp334=((($conv333))|0)==0; //@line 1950 "translate.cpp"
        if ($cmp334) { __label__ = 117;; } else { __label__ = 119;; } //@line 1950 "translate.cpp"
        $land_lhs_true335$$while_cond341_preheader$166: do { 
          if (__label__ == 117) {
  
            var $_b2=HEAPU8[(__ZL13embedded_flag_b)];
            var $196=($_b2) ? 2 : 0;
            var $tobool336=((($196))|0)!=0; //@line 1950 "translate.cpp"
            if (!($tobool336)) { __label__ = 119;break $land_lhs_true335$$while_cond341_preheader$166; } //@line 1950 "translate.cpp"
  
            var $197=$p; //@line 1953 "translate.cpp"
            var $arrayidx338=(($197)&4294967295); //@line 1953 "translate.cpp"
            HEAP8[($arrayidx338)]=23; //@line 1953 "translate.cpp"
            var $198=$p; //@line 1954 "translate.cpp"
            var $arrayidx339=(($198+1)&4294967295); //@line 1954 "translate.cpp"
            HEAP8[($arrayidx339)]=0; //@line 1954 "translate.cpp"
            ; //@line 1955 "translate.cpp"
          }
        } while(0);
  
        var $199=$p; //@line 1957 "translate.cpp"
        var $incdec_ptr34224=(($199+1)&4294967295); //@line 1957 "translate.cpp"
        $p=$incdec_ptr34224; //@line 1957 "translate.cpp"
        var $200=HEAPU8[($199)]; //@line 1957 "translate.cpp"
        $ph_code=$200; //@line 1957 "translate.cpp"
        var $conv34325=((($200))&255); //@line 1957 "translate.cpp"
        var $cmp34426=((($conv34325))|0)!=0; //@line 1957 "translate.cpp"
        var $201=HEAP32[((_n_ph_list2)>>2)]; //@line 1957 "translate.cpp"
        var $cmp34627=((($201))|0) < 996; //@line 1957 "translate.cpp"
        var $or_cond628=($cmp34426) & ($cmp34627); //@line 1957 "translate.cpp"
        if ($or_cond628) { __label__ = 120;; } else { __label__ = 157;; } //@line 1957 "translate.cpp"
        $while_body348$$while_end511$170: do { 
          if (__label__ == 120) {
            $while_body348$171: while(1) { 
  
              var $202=$ph_code; //@line 1959 "translate.cpp"
              var $conv349=((($202))&255); //@line 1959 "translate.cpp"
              var $cmp350=((($conv349))|0)==255; //@line 1959 "translate.cpp"
              if ($cmp350) { __label__ = 121;; } else { __label__ = 122;; } //@line 1959 "translate.cpp"
              $while_cond341_backedge$$if_end352$173: do { 
                if (__label__ == 122) {
  
                  var $206=$ph_code; //@line 1963 "translate.cpp"
                  var $idxprom353=((($206))&255); //@line 1963 "translate.cpp"
                  var $arrayidx354=((_phoneme_tab+$idxprom353*4)&4294967295); //@line 1963 "translate.cpp"
                  var $207=HEAP32[(($arrayidx354)>>2)]; //@line 1963 "translate.cpp"
                  $ph=$207; //@line 1963 "translate.cpp"
                  var $208=$ph_code; //@line 1965 "translate.cpp"
                  var $conv355=((($208))&255); //@line 1965 "translate.cpp"
                  var $cmp356=((($conv355))|0)==21; //@line 1965 "translate.cpp"
                  if ($cmp356) { __label__ = 123;; } else { __label__ = 124;; } //@line 1965 "translate.cpp"
                  if (__label__ == 123) {
  
                    var $209=$ph_code; //@line 1967 "translate.cpp"
                    var $210=HEAP32[((_n_ph_list2)>>2)]; //@line 1967 "translate.cpp"
                    var $arrayidx358=((_ph_list2+$210*8)&4294967295); //@line 1967 "translate.cpp"
                    var $phcode=(($arrayidx358)&4294967295); //@line 1967 "translate.cpp"
                    HEAP8[($phcode)]=$209; //@line 1967 "translate.cpp"
                    var $211=HEAP32[((_n_ph_list2)>>2)]; //@line 1968 "translate.cpp"
                    var $arrayidx359=((_ph_list2+$211*8)&4294967295); //@line 1968 "translate.cpp"
                    var $sourceix360=(($arrayidx359+6)&4294967295); //@line 1968 "translate.cpp"
                    HEAP16[(($sourceix360)>>1)]=0; //@line 1968 "translate.cpp"
                    var $_b1=HEAPU8[(__ZL13embedded_flag_b)];
                    var $212=($_b1) ? 2 : 0;
                    var $conv361=((($212)) & 65535); //@line 1969 "translate.cpp"
                    var $213=HEAP32[((_n_ph_list2)>>2)]; //@line 1969 "translate.cpp"
                    var $arrayidx362=((_ph_list2+$213*8)&4294967295); //@line 1969 "translate.cpp"
                    var $synthflags=(($arrayidx362+4)&4294967295); //@line 1969 "translate.cpp"
                    HEAP16[(($synthflags)>>1)]=$conv361; //@line 1969 "translate.cpp"
                    var $214=$p; //@line 1970 "translate.cpp"
                    var $incdec_ptr363=(($214+1)&4294967295); //@line 1970 "translate.cpp"
                    $p=$incdec_ptr363; //@line 1970 "translate.cpp"
                    var $215=HEAP8[($214)]; //@line 1970 "translate.cpp"
                    var $216=HEAP32[((_n_ph_list2)>>2)]; //@line 1970 "translate.cpp"
                    var $inc364=((($216)+1)&4294967295); //@line 1970 "translate.cpp"
                    HEAP32[((_n_ph_list2)>>2)]=$inc364; //@line 1970 "translate.cpp"
                    var $arrayidx365=((_ph_list2+$216*8)&4294967295); //@line 1970 "translate.cpp"
                    var $tone_ph366=(($arrayidx365+3)&4294967295); //@line 1970 "translate.cpp"
                    HEAP8[($tone_ph366)]=$215; //@line 1970 "translate.cpp"
                    ; //@line 1971 "translate.cpp"
                  }
                  else if (__label__ == 124) {
  
                    var $217=$ph; //@line 1973 "translate.cpp"
                    var $type368=(($217+11)&4294967295); //@line 1973 "translate.cpp"
                    var $218=HEAPU8[($type368)]; //@line 1973 "translate.cpp"
                    var $conv369=((($218))&255); //@line 1973 "translate.cpp"
                    var $cmp370=((($conv369))|0)==1; //@line 1973 "translate.cpp"
                    if ($cmp370) { __label__ = 125;; } else { __label__ = 130;; } //@line 1973 "translate.cpp"
                    if (__label__ == 125) {
  
                      var $219=$ph; //@line 1978 "translate.cpp"
                      var $program=(($219+8)&4294967295); //@line 1978 "translate.cpp"
                      var $220=HEAPU16[(($program)>>1)]; //@line 1978 "translate.cpp"
                      var $conv372=((($220))&65535); //@line 1978 "translate.cpp"
                      var $cmp373=((($conv372))|0)==0; //@line 1978 "translate.cpp"
                      if ($cmp373) { __label__ = 126;; } else { __label__ = 127;; } //@line 1978 "translate.cpp"
                      if (__label__ == 126) {
  
                        var $221=$ph; //@line 1979 "translate.cpp"
                        var $std_length=(($221+14)&4294967295); //@line 1979 "translate.cpp"
                        var $222=HEAPU8[($std_length)]; //@line 1979 "translate.cpp"
                        var $conv375=((($222))&255); //@line 1979 "translate.cpp"
                        $next_stress=$conv375; //@line 1979 "translate.cpp"
                        ; //@line 1979 "translate.cpp"
                      }
                      else if (__label__ == 127) {
  
                        var $223=$prev_vowel; //@line 1983 "translate.cpp"
                        var $cmp377=((($223))|0) >= 0; //@line 1983 "translate.cpp"
                        var $224=$ph_code; //@line 1985 "translate.cpp"
                        if ($cmp377) { __label__ = 128;; } else { __label__ = 129;; } //@line 1983 "translate.cpp"
                        if (__label__ == 128) {
  
                          var $225=$prev_vowel; //@line 1985 "translate.cpp"
                          var $arrayidx379=((_ph_list2+$225*8)&4294967295); //@line 1985 "translate.cpp"
                          var $tone_ph380=(($arrayidx379+3)&4294967295); //@line 1985 "translate.cpp"
                          HEAP8[($tone_ph380)]=$224; //@line 1985 "translate.cpp"
                          ; //@line 1986 "translate.cpp"
                        }
                        else if (__label__ == 129) {
  
                          var $conv382=((($224))&255); //@line 1989 "translate.cpp"
                          $next_tone=$conv382; //@line 1989 "translate.cpp"
                          ;
                        }
                      }
                    }
                    else if (__label__ == 130) {
  
                      var $226=$ph_code; //@line 1994 "translate.cpp"
                      var $conv386=((($226))&255); //@line 1994 "translate.cpp"
                      var $cmp387=((($conv386))|0)==20; //@line 1994 "translate.cpp"
                      if ($cmp387) { __label__ = 131;; } else { __label__ = 132;; } //@line 1994 "translate.cpp"
                      if (__label__ == 131) {
  
                        var $227=HEAP32[((_n_ph_list2)>>2)]; //@line 1997 "translate.cpp"
                        var $sub389=((($227)-1)&4294967295); //@line 1997 "translate.cpp"
                        $prev_vowel=$sub389; //@line 1997 "translate.cpp"
                        var $228=$prev_vowel; //@line 1998 "translate.cpp"
                        var $arrayidx390=((_ph_list2+$228*8)&4294967295); //@line 1998 "translate.cpp"
                        var $synthflags391=(($arrayidx390+4)&4294967295); //@line 1998 "translate.cpp"
                        var $229=HEAPU16[(($synthflags391)>>1)]; //@line 1998 "translate.cpp"
                        var $conv392=((($229))&65535); //@line 1998 "translate.cpp"
                        var $or393=($conv392) | 4; //@line 1998 "translate.cpp"
                        var $conv394=((($or393)) & 65535); //@line 1998 "translate.cpp"
                        HEAP16[(($synthflags391)>>1)]=$conv394; //@line 1998 "translate.cpp"
                        var $230=$next_stress; //@line 1999 "translate.cpp"
                        var $conv395=((($230)) & 255); //@line 1999 "translate.cpp"
                        var $231=$prev_vowel; //@line 1999 "translate.cpp"
                        var $arrayidx396=((_ph_list2+$231*8)&4294967295); //@line 1999 "translate.cpp"
                        var $stresslevel=(($arrayidx396+1)&4294967295); //@line 1999 "translate.cpp"
                        HEAP8[($stresslevel)]=$conv395; //@line 1999 "translate.cpp"
                        ; //@line 2000 "translate.cpp"
                      }
                      else if (__label__ == 132) {
  
                        var $232=$ph_code; //@line 2002 "translate.cpp"
                        var $conv398=((($232))&255); //@line 2002 "translate.cpp"
                        var $cmp399=((($conv398))|0)==12; //@line 2002 "translate.cpp"
                        if ($cmp399) { __label__ = 133;; } else { __label__ = 134;; } //@line 2002 "translate.cpp"
                        if (__label__ == 133) {
  
                          var $233=HEAP32[((_n_ph_list2)>>2)]; //@line 2004 "translate.cpp"
                          var $sub401=((($233)-1)&4294967295); //@line 2004 "translate.cpp"
                          var $arrayidx402=((_ph_list2+$sub401*8)&4294967295); //@line 2004 "translate.cpp"
                          var $synthflags403=(($arrayidx402+4)&4294967295); //@line 2004 "translate.cpp"
                          var $234=HEAPU16[(($synthflags403)>>1)]; //@line 2004 "translate.cpp"
                          var $conv404=((($234))&65535); //@line 2004 "translate.cpp"
                          var $or405=($conv404) | 8; //@line 2004 "translate.cpp"
                          var $conv406=((($or405)) & 65535); //@line 2004 "translate.cpp"
                          HEAP16[(($synthflags403)>>1)]=$conv406; //@line 2004 "translate.cpp"
                          ; //@line 2005 "translate.cpp"
                        }
                        else if (__label__ == 134) {
  
                          var $235=$ph_code; //@line 2007 "translate.cpp"
                          var $conv408=((($235))&255); //@line 2007 "translate.cpp"
                          var $cmp409=((($conv408))|0)==15; //@line 2007 "translate.cpp"
                          if ($cmp409) { __label__ = 135;; } else { __label__ = 136;; } //@line 2007 "translate.cpp"
                          if (__label__ == 135) {
  
                            var $236=$source_ix; //@line 2012 "translate.cpp"
                            var $add411=((($236)+1)&4294967295); //@line 2012 "translate.cpp"
                            $srcix=$add411; //@line 2012 "translate.cpp"
                            ; //@line 2013 "translate.cpp"
                          }
                          else if (__label__ == 136) {
  
                            var $237=$ph_code; //@line 2015 "translate.cpp"
                            var $conv413=((($237))&255); //@line 2015 "translate.cpp"
                            var $cmp414=((($conv413))|0)==22; //@line 2015 "translate.cpp"
                            if ($cmp414) { __label__ = 137;; } else { __label__ = 139;; } //@line 2015 "translate.cpp"
                            if (__label__ == 137) {
  
                              var $238=$tr_addr; //@line 2018 "translate.cpp"
                              var $langopts416=(($238)&4294967295); //@line 2018 "translate.cpp"
                              var $param417=(($langopts416+24)&4294967295); //@line 2018 "translate.cpp"
                              var $arrayidx418=(($param417+56)&4294967295); //@line 2018 "translate.cpp"
                              var $239=HEAP32[(($arrayidx418)>>2)]; //@line 2018 "translate.cpp"
                              var $tobool419=((($239))|0)!=0; //@line 2018 "translate.cpp"
                              if (!($tobool419)) { __label__ = 121;break $while_cond341_backedge$$if_end352$173; } //@line 2018 "translate.cpp"
  
                              var $240=$flags; //@line 2020 "translate.cpp"
                              var $or421=($240) | 524288; //@line 2020 "translate.cpp"
                              $flags=$or421; //@line 2020 "translate.cpp"
                              ; //@line 2021 "translate.cpp"
                            }
                            else if (__label__ == 139) {
  
                              var $241=$ph_code; //@line 2025 "translate.cpp"
                              var $242=HEAP32[((_n_ph_list2)>>2)]; //@line 2025 "translate.cpp"
                              var $arrayidx424=((_ph_list2+$242*8)&4294967295); //@line 2025 "translate.cpp"
                              var $phcode425=(($arrayidx424)&4294967295); //@line 2025 "translate.cpp"
                              HEAP8[($phcode425)]=$241; //@line 2025 "translate.cpp"
                              var $243=HEAP32[((_n_ph_list2)>>2)]; //@line 2026 "translate.cpp"
                              var $arrayidx426=((_ph_list2+$243*8)&4294967295); //@line 2026 "translate.cpp"
                              var $tone_ph427=(($arrayidx426+3)&4294967295); //@line 2026 "translate.cpp"
                              HEAP8[($tone_ph427)]=0; //@line 2026 "translate.cpp"
                              var $_b=HEAPU8[(__ZL13embedded_flag_b)];
                              var $244=($_b) ? 2 : 0;
                              var $245=$found_dict_flag; //@line 2027 "translate.cpp"
                              var $or428=($244) | ($245); //@line 2027 "translate.cpp"
                              var $conv429=((($or428)) & 65535); //@line 2027 "translate.cpp"
                              var $246=HEAP32[((_n_ph_list2)>>2)]; //@line 2027 "translate.cpp"
                              var $arrayidx430=((_ph_list2+$246*8)&4294967295); //@line 2027 "translate.cpp"
                              var $synthflags431=(($arrayidx430+4)&4294967295); //@line 2027 "translate.cpp"
                              HEAP16[(($synthflags431)>>1)]=$conv429; //@line 2027 "translate.cpp"
                              HEAP8[(__ZL13embedded_flag_b)]=0;
                              var $247=$srcix; //@line 2029 "translate.cpp"
                              var $conv432=((($247)) & 65535); //@line 2029 "translate.cpp"
                              var $248=HEAP32[((_n_ph_list2)>>2)]; //@line 2029 "translate.cpp"
                              var $arrayidx433=((_ph_list2+$248*8)&4294967295); //@line 2029 "translate.cpp"
                              var $sourceix434=(($arrayidx433+6)&4294967295); //@line 2029 "translate.cpp"
                              HEAP16[(($sourceix434)>>1)]=$conv432; //@line 2029 "translate.cpp"
                              $srcix=0; //@line 2030 "translate.cpp"
                              var $249=$ph; //@line 2032 "translate.cpp"
                              var $type435=(($249+11)&4294967295); //@line 2032 "translate.cpp"
                              var $250=HEAPU8[($type435)]; //@line 2032 "translate.cpp"
                              var $conv436=((($250))&255); //@line 2032 "translate.cpp"
                              var $cmp437=((($conv436))|0)==2; //@line 2032 "translate.cpp"
                              if ($cmp437) { __label__ = 140;; } else { __label__ = 149;; } //@line 2032 "translate.cpp"
                              $if_then438$$if_else466$200: do { 
                                if (__label__ == 140) {
  
                                  var $251=$next_stress; //@line 2034 "translate.cpp"
                                  $stress=$251; //@line 2034 "translate.cpp"
                                  $next_stress=1; //@line 2035 "translate.cpp"
                                  var $252=$stress; //@line 2037 "translate.cpp"
                                  var $cmp439=((($252))|0) >= 4; //@line 2037 "translate.cpp"
                                  if ($cmp439) { __label__ = 141;; } else { __label__ = 142;; } //@line 2037 "translate.cpp"
                                  if (__label__ == 141) {
  
                                    HEAP8[(__ZL18any_stressed_words_b)]=1;
                                    ; //@line 2040 "translate.cpp"
                                  }
  
                                  var $253=$prev_vowel; //@line 2042 "translate.cpp"
                                  var $cmp442=((($253))|0) >= 0; //@line 2042 "translate.cpp"
                                  if ($cmp442) { __label__ = 143;; } else { __label__ = 145;; } //@line 2042 "translate.cpp"
                                  $land_lhs_true443$$if_end451$205: do { 
                                    if (__label__ == 143) {
  
                                      var $254=HEAP32[((_n_ph_list2)>>2)]; //@line 2042 "translate.cpp"
                                      var $sub444=((($254)-1)&4294967295); //@line 2042 "translate.cpp"
                                      var $255=$prev_vowel; //@line 2042 "translate.cpp"
                                      var $cmp445=((($sub444))|0)!=((($255))|0); //@line 2042 "translate.cpp"
                                      if (!($cmp445)) { __label__ = 145;break $land_lhs_true443$$if_end451$205; } //@line 2042 "translate.cpp"
  
                                      var $256=$stress; //@line 2043 "translate.cpp"
                                      var $conv447=((($256)) & 255); //@line 2043 "translate.cpp"
                                      var $257=HEAP32[((_n_ph_list2)>>2)]; //@line 2043 "translate.cpp"
                                      var $sub448=((($257)-1)&4294967295); //@line 2043 "translate.cpp"
                                      var $arrayidx449=((_ph_list2+$sub448*8)&4294967295); //@line 2043 "translate.cpp"
                                      var $stresslevel450=(($arrayidx449+1)&4294967295); //@line 2043 "translate.cpp"
                                      HEAP8[($stresslevel450)]=$conv447; //@line 2043 "translate.cpp"
                                      ; //@line 2043 "translate.cpp"
                                    }
                                  } while(0);
  
                                  var $258=HEAP32[((_n_ph_list2)>>2)]; //@line 2045 "translate.cpp"
                                  var $arrayidx452=((_ph_list2+$258*8)&4294967295); //@line 2045 "translate.cpp"
                                  var $synthflags453=(($arrayidx452+4)&4294967295); //@line 2045 "translate.cpp"
                                  var $259=HEAPU16[(($synthflags453)>>1)]; //@line 2045 "translate.cpp"
                                  var $conv454=((($259))&65535); //@line 2045 "translate.cpp"
                                  var $or455=($conv454) | 4; //@line 2045 "translate.cpp"
                                  var $conv456=((($or455)) & 65535); //@line 2045 "translate.cpp"
                                  HEAP16[(($synthflags453)>>1)]=$conv456; //@line 2045 "translate.cpp"
                                  var $260=HEAP32[((_n_ph_list2)>>2)]; //@line 2046 "translate.cpp"
                                  $prev_vowel=$260; //@line 2046 "translate.cpp"
                                  var $261=$stress; //@line 2048 "translate.cpp"
                                  var $262=$max_stress; //@line 2048 "translate.cpp"
                                  var $cmp457=((($261))|0) > ((($262))|0); //@line 2048 "translate.cpp"
                                  if ($cmp457) { __label__ = 146;; } else { __label__ = 147;; } //@line 2048 "translate.cpp"
                                  if (__label__ == 146) {
  
                                    var $263=$stress; //@line 2050 "translate.cpp"
                                    $max_stress=$263; //@line 2050 "translate.cpp"
                                    var $264=HEAP32[((_n_ph_list2)>>2)]; //@line 2051 "translate.cpp"
                                    $max_stress_ix=$264; //@line 2051 "translate.cpp"
                                    ; //@line 2052 "translate.cpp"
                                  }
  
                                  var $265=$next_tone; //@line 2053 "translate.cpp"
                                  var $cmp460=((($265))|0)!=0; //@line 2053 "translate.cpp"
                                  if (!($cmp460)) { __label__ = 156;break $if_then438$$if_else466$200; } //@line 2053 "translate.cpp"
  
                                  var $266=$next_tone; //@line 2055 "translate.cpp"
                                  var $conv462=((($266)) & 255); //@line 2055 "translate.cpp"
                                  var $267=HEAP32[((_n_ph_list2)>>2)]; //@line 2055 "translate.cpp"
                                  var $arrayidx463=((_ph_list2+$267*8)&4294967295); //@line 2055 "translate.cpp"
                                  var $tone_ph464=(($arrayidx463+3)&4294967295); //@line 2055 "translate.cpp"
                                  HEAP8[($tone_ph464)]=$conv462; //@line 2055 "translate.cpp"
                                  $next_tone=0; //@line 2056 "translate.cpp"
                                  ; //@line 2057 "translate.cpp"
                                }
                                else if (__label__ == 149) {
  
                                  var $268=$first_phoneme; //@line 2061 "translate.cpp"
                                  var $tobool467=((($268))|0)!=0; //@line 2061 "translate.cpp"
                                  if (!($tobool467)) { __label__ = 156;break $if_then438$$if_else466$200; } //@line 2061 "translate.cpp"
  
                                  var $269=$tr_addr; //@line 2061 "translate.cpp"
                                  var $langopts469=(($269)&4294967295); //@line 2061 "translate.cpp"
                                  var $param470=(($langopts469+24)&4294967295); //@line 2061 "translate.cpp"
                                  var $arrayidx471=(($param470+56)&4294967295); //@line 2061 "translate.cpp"
                                  var $270=HEAP32[(($arrayidx471)>>2)]; //@line 2061 "translate.cpp"
                                  var $tobool472=((($270))|0)!=0; //@line 2061 "translate.cpp"
                                  if (!($tobool472)) { __label__ = 156;break $if_then438$$if_else466$200; } //@line 2061 "translate.cpp"
  
                                  var $271=$tr_addr; //@line 2063 "translate.cpp"
                                  var $prev_dict_flags474=(($271+8320)&4294967295); //@line 2063 "translate.cpp"
                                  var $272=HEAP32[(($prev_dict_flags474)>>2)]; //@line 2063 "translate.cpp"
                                  var $and475=($272) & 524288; //@line 2063 "translate.cpp"
                                  var $tobool476=((($and475))|0)!=0; //@line 2063 "translate.cpp"
                                  if ($tobool476) { __label__ = 152;; } else { __label__ = 153;; } //@line 2063 "translate.cpp"
                                  $land_lhs_true477$$lor_lhs_false483$216: do { 
                                    if (__label__ == 152) {
  
                                      var $273=$tr_addr; //@line 2063 "translate.cpp"
                                      var $langopts478=(($273)&4294967295); //@line 2063 "translate.cpp"
                                      var $param479=(($langopts478+24)&4294967295); //@line 2063 "translate.cpp"
                                      var $arrayidx480=(($param479+56)&4294967295); //@line 2063 "translate.cpp"
                                      var $274=HEAP32[(($arrayidx480)>>2)]; //@line 2063 "translate.cpp"
                                      var $and481=($274) & 1; //@line 2063 "translate.cpp"
                                      var $tobool482=((($and481))|0)!=0; //@line 2063 "translate.cpp"
                                      if ($tobool482) { __label__ = 155;break $land_lhs_true477$$lor_lhs_false483$216; } else { __label__ = 153;break $land_lhs_true477$$lor_lhs_false483$216; } //@line 2063 "translate.cpp"
                                    }
                                  } while(0);
                                  if (__label__ == 153) {
  
                                    var $275=$tr_addr; //@line 2063 "translate.cpp"
                                    var $end_stressed_vowel484=(($275+8316)&4294967295); //@line 2063 "translate.cpp"
                                    var $276=HEAP32[(($end_stressed_vowel484)>>2)]; //@line 2063 "translate.cpp"
                                    var $tobool485=((($276))|0)!=0; //@line 2063 "translate.cpp"
                                    if (!($tobool485)) { __label__ = 156;break $if_then438$$if_else466$200; } //@line 2063 "translate.cpp"
  
                                    var $277=$tr_addr; //@line 2063 "translate.cpp"
                                    var $langopts487=(($277)&4294967295); //@line 2063 "translate.cpp"
                                    var $param488=(($langopts487+24)&4294967295); //@line 2063 "translate.cpp"
                                    var $arrayidx489=(($param488+56)&4294967295); //@line 2063 "translate.cpp"
                                    var $278=HEAP32[(($arrayidx489)>>2)]; //@line 2063 "translate.cpp"
                                    var $and490=($278) & 2; //@line 2063 "translate.cpp"
                                    var $tobool491=((($and490))|0)!=0; //@line 2063 "translate.cpp"
                                    if (!($tobool491)) { __label__ = 156;break $if_then438$$if_else466$200; } //@line 2063 "translate.cpp"
                                  }
  
                                  var $279=HEAP32[((_n_ph_list2)>>2)]; //@line 2068 "translate.cpp"
                                  var $arrayidx493=((_ph_list2+$279*8)&4294967295); //@line 2068 "translate.cpp"
                                  var $synthflags494=(($arrayidx493+4)&4294967295); //@line 2068 "translate.cpp"
                                  var $280=HEAPU16[(($synthflags494)>>1)]; //@line 2068 "translate.cpp"
                                  var $conv495=((($280))&65535); //@line 2068 "translate.cpp"
                                  var $or496=($conv495) | 8; //@line 2068 "translate.cpp"
                                  var $conv497=((($or496)) & 65535); //@line 2068 "translate.cpp"
                                  HEAP16[(($synthflags494)>>1)]=$conv497; //@line 2068 "translate.cpp"
                                  ; //@line 2069 "translate.cpp"
                                }
                              } while(0);
  
                              var $281=$stress; //@line 2073 "translate.cpp"
                              var $conv501=((($281)) & 255); //@line 2073 "translate.cpp"
                              var $282=HEAP32[((_n_ph_list2)>>2)]; //@line 2073 "translate.cpp"
                              var $arrayidx502=((_ph_list2+$282*8)&4294967295); //@line 2073 "translate.cpp"
                              var $stresslevel503=(($arrayidx502+1)&4294967295); //@line 2073 "translate.cpp"
                              HEAP8[($stresslevel503)]=$conv501; //@line 2073 "translate.cpp"
                              var $283=HEAP32[((_n_ph_list2)>>2)]; //@line 2074 "translate.cpp"
                              var $inc504=((($283)+1)&4294967295); //@line 2074 "translate.cpp"
                              HEAP32[((_n_ph_list2)>>2)]=$inc504; //@line 2074 "translate.cpp"
                              $first_phoneme=0; //@line 2075 "translate.cpp"
                              ;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              } while(0);
  
              var $203=$p; //@line 1957 "translate.cpp"
              var $incdec_ptr342=(($203+1)&4294967295); //@line 1957 "translate.cpp"
              $p=$incdec_ptr342; //@line 1957 "translate.cpp"
              var $204=HEAPU8[($203)]; //@line 1957 "translate.cpp"
              $ph_code=$204; //@line 1957 "translate.cpp"
              var $conv343=((($204))&255); //@line 1957 "translate.cpp"
              var $cmp344=((($conv343))|0)!=0; //@line 1957 "translate.cpp"
              var $205=HEAP32[((_n_ph_list2)>>2)]; //@line 1957 "translate.cpp"
              var $cmp346=((($205))|0) < 996; //@line 1957 "translate.cpp"
              var $or_cond6=($cmp344) & ($cmp346); //@line 1957 "translate.cpp"
              if ($or_cond6) { __label__ = 120;continue $while_body348$171; } else { __label__ = 157;break $while_body348$$while_end511$170; } //@line 1957 "translate.cpp"
            }
          }
        } while(0);
  
        var $284=$word_flags; //@line 2079 "translate.cpp"
        var $and512=($284) & 131072; //@line 2079 "translate.cpp"
        var $tobool513=((($and512))|0)!=0; //@line 2079 "translate.cpp"
        if ($tobool513) { __label__ = 158;; } else { __label__ = 159;; } //@line 2079 "translate.cpp"
        if (__label__ == 158) {
  
          var $285=HEAP32[((_n_ph_list2)>>2)]; //@line 2081 "translate.cpp"
          var $inc515=((($285)+1)&4294967295); //@line 2081 "translate.cpp"
          HEAP32[((_n_ph_list2)>>2)]=$inc515; //@line 2081 "translate.cpp"
          var $arrayidx516=((_ph_list2+$285*8)&4294967295); //@line 2081 "translate.cpp"
          __ZL9SetPlist2P13PHONEME_LIST2h($arrayidx516, 27); //@line 2081 "translate.cpp"
          ; //@line 2082 "translate.cpp"
        }
  
        var $286=$word_flags; //@line 2085 "translate.cpp"
        var $and518=($286) & 128; //@line 2085 "translate.cpp"
        var $cmp519=((($and518))|0)==0; //@line 2085 "translate.cpp"
        if ($cmp519) { __label__ = 160;; } else { __label__ = 161;; } //@line 2085 "translate.cpp"
        if (__label__ == 160) {
  
          var $287=$source_ix; //@line 2087 "translate.cpp"
          var $conv521=((($287)) & 65535); //@line 2087 "translate.cpp"
          var $288=$plist2; //@line 2087 "translate.cpp"
          var $sourceix522=(($288+6)&4294967295); //@line 2087 "translate.cpp"
          HEAP16[(($sourceix522)>>1)]=$conv521; //@line 2087 "translate.cpp"
          ; //@line 2088 "translate.cpp"
        }
  
        var $289=$tr_addr; //@line 2090 "translate.cpp"
        var $end_stressed_vowel524=(($289+8316)&4294967295); //@line 2090 "translate.cpp"
        HEAP32[(($end_stressed_vowel524)>>2)]=0; //@line 2090 "translate.cpp"
        var $290=$stress; //@line 2091 "translate.cpp"
        var $cmp525=((($290))|0) >= 4; //@line 2091 "translate.cpp"
        if ($cmp525) { __label__ = 162;; } else { __label__ = 164;; } //@line 2091 "translate.cpp"
        $land_lhs_true526$$if_end537$231: do { 
          if (__label__ == 162) {
  
            var $291=HEAP32[((_n_ph_list2)>>2)]; //@line 2091 "translate.cpp"
            var $sub527=((($291)-1)&4294967295); //@line 2091 "translate.cpp"
            var $arrayidx528=((_ph_list2+$sub527*8)&4294967295); //@line 2091 "translate.cpp"
            var $phcode529=(($arrayidx528)&4294967295); //@line 2091 "translate.cpp"
            var $292=HEAPU8[($phcode529)]; //@line 2091 "translate.cpp"
            var $idxprom530=((($292))&255); //@line 2091 "translate.cpp"
            var $arrayidx531=((_phoneme_tab+$idxprom530*4)&4294967295); //@line 2091 "translate.cpp"
            var $293=HEAP32[(($arrayidx531)>>2)]; //@line 2091 "translate.cpp"
            var $type532=(($293+11)&4294967295); //@line 2091 "translate.cpp"
            var $294=HEAPU8[($type532)]; //@line 2091 "translate.cpp"
            var $conv533=((($294))&255); //@line 2091 "translate.cpp"
            var $cmp534=((($conv533))|0)==2; //@line 2091 "translate.cpp"
            if (!($cmp534)) { __label__ = 164;break $land_lhs_true526$$if_end537$231; } //@line 2091 "translate.cpp"
  
            var $295=$tr_addr; //@line 2093 "translate.cpp"
            var $end_stressed_vowel536=(($295+8316)&4294967295); //@line 2093 "translate.cpp"
            HEAP32[(($end_stressed_vowel536)>>2)]=1; //@line 2093 "translate.cpp"
            ; //@line 2094 "translate.cpp"
          }
        } while(0);
  
        var $296=$switch_phonemes; //@line 2096 "translate.cpp"
        var $cmp538=((($296))|0) >= 0; //@line 2096 "translate.cpp"
        if ($cmp538) { __label__ = 165;; } else { __label__ = 166;; } //@line 2096 "translate.cpp"
        if (__label__ == 165) {
  
          var $arraydecay540=(($old_dictionary_name)&4294967295); //@line 2099 "translate.cpp"
          var $call541=_strcpy(((_dictionary_name)&4294967295), $arraydecay540); //@line 2099 "translate.cpp"
          var $297=HEAP32[((_voice)>>2)]; //@line 2100 "translate.cpp"
          var $phoneme_tab_ix542=(($297+40)&4294967295); //@line 2100 "translate.cpp"
          var $298=HEAP32[(($phoneme_tab_ix542)>>2)]; //@line 2100 "translate.cpp"
          __Z18SelectPhonemeTablei($298); //@line 2100 "translate.cpp"
          var $299=HEAP32[((_n_ph_list2)>>2)]; //@line 2101 "translate.cpp"
          var $arrayidx543=((_ph_list2+$299*8)&4294967295); //@line 2101 "translate.cpp"
          __ZL9SetPlist2P13PHONEME_LIST2h($arrayidx543, 21); //@line 2101 "translate.cpp"
          var $300=HEAP32[((_voice)>>2)]; //@line 2102 "translate.cpp"
          var $phoneme_tab_ix544=(($300+40)&4294967295); //@line 2102 "translate.cpp"
          var $301=HEAP32[(($phoneme_tab_ix544)>>2)]; //@line 2102 "translate.cpp"
          var $conv545=((($301)) & 255); //@line 2102 "translate.cpp"
          var $302=HEAP32[((_n_ph_list2)>>2)]; //@line 2102 "translate.cpp"
          var $inc546=((($302)+1)&4294967295); //@line 2102 "translate.cpp"
          HEAP32[((_n_ph_list2)>>2)]=$inc546; //@line 2102 "translate.cpp"
          var $arrayidx547=((_ph_list2+$302*8)&4294967295); //@line 2102 "translate.cpp"
          var $tone_ph548=(($arrayidx547+3)&4294967295); //@line 2102 "translate.cpp"
          HEAP8[($tone_ph548)]=$conv545; //@line 2102 "translate.cpp"
          ; //@line 2103 "translate.cpp"
        }
  
        var $303=$pitch_raised; //@line 2106 "translate.cpp"
        var $cmp550=((($303))|0) > 0; //@line 2106 "translate.cpp"
        if ($cmp550) { __label__ = 167;; } else { __label__ = 168;; } //@line 2106 "translate.cpp"
        if (__label__ == 167) {
  
          var $304=$pitch_raised; //@line 2108 "translate.cpp"
          var $shl552=((($304)*256)&4294967295); //@line 2108 "translate.cpp"
          var $add553=((($shl552)+225)&4294967295); //@line 2108 "translate.cpp"
          var $305=HEAP32[((__ZL11embedded_ix)>>2)]; //@line 2108 "translate.cpp"
          var $inc554=((($305)+1)&4294967295); //@line 2108 "translate.cpp"
          HEAP32[((__ZL11embedded_ix)>>2)]=$inc554; //@line 2108 "translate.cpp"
          var $arrayidx555=((_embedded_list+$305*4)&4294967295); //@line 2108 "translate.cpp"
          HEAP32[(($arrayidx555)>>2)]=$add553; //@line 2108 "translate.cpp"
          var $306=HEAP32[((_n_ph_list2)>>2)]; //@line 2109 "translate.cpp"
          var $arrayidx556=((_ph_list2+$306*8)&4294967295); //@line 2109 "translate.cpp"
          __ZL9SetPlist2P13PHONEME_LIST2h($arrayidx556, 10); //@line 2109 "translate.cpp"
          var $307=HEAP32[((_n_ph_list2)>>2)]; //@line 2110 "translate.cpp"
          var $inc557=((($307)+1)&4294967295); //@line 2110 "translate.cpp"
          HEAP32[((_n_ph_list2)>>2)]=$inc557; //@line 2110 "translate.cpp"
          var $arrayidx558=((_ph_list2+$307*8)&4294967295); //@line 2110 "translate.cpp"
          var $synthflags559=(($arrayidx558+4)&4294967295); //@line 2110 "translate.cpp"
          HEAP16[(($synthflags559)>>1)]=2; //@line 2110 "translate.cpp"
          ; //@line 2111 "translate.cpp"
        }
  
        var $308=$flags; //@line 2113 "translate.cpp"
        var $and561=($308) & 4096; //@line 2113 "translate.cpp"
        var $tobool562=((($and561))|0)!=0; //@line 2113 "translate.cpp"
        if ($tobool562) { __label__ = 169;; } else { __label__ = 170;; } //@line 2113 "translate.cpp"
        if (__label__ == 169) {
  
          var $309=$max_stress_ix; //@line 2116 "translate.cpp"
          var $arrayidx564=((_ph_list2+$309*8)&4294967295); //@line 2116 "translate.cpp"
          var $synthflags565=(($arrayidx564+4)&4294967295); //@line 2116 "translate.cpp"
          var $310=HEAPU16[(($synthflags565)>>1)]; //@line 2116 "translate.cpp"
          var $conv566=((($310))&65535); //@line 2116 "translate.cpp"
          var $or567=($conv566) | 64; //@line 2116 "translate.cpp"
          var $conv568=((($or567)) & 65535); //@line 2116 "translate.cpp"
          HEAP16[(($synthflags565)>>1)]=$conv568; //@line 2116 "translate.cpp"
          ; //@line 2117 "translate.cpp"
        }
  
        var $311=$flags; //@line 2119 "translate.cpp"
        var $312=$tr_addr; //@line 2119 "translate.cpp"
        var $prev_dict_flags570=(($312+8320)&4294967295); //@line 2119 "translate.cpp"
        HEAP32[(($prev_dict_flags570)>>2)]=$311; //@line 2119 "translate.cpp"
        var $313=$flags; //@line 2120 "translate.cpp"
        $retval=$313; //@line 2120 "translate.cpp"
        ; //@line 2120 "translate.cpp"
      }
    } while(0);
  
    var $314=$retval; //@line 2121 "translate.cpp"
    STACKTOP = __stackBase__;
    return $314; //@line 2121 "translate.cpp"
    return null;
  }
  

  function __Z8InitTexti($control) {
    ;
    var __label__;
  
    var $control_addr;
    $control_addr=$control;
    HEAP32[((_count_sentences)>>2)]=0; //@line 3278 "translate.cpp"
    HEAP32[((_count_words)>>2)]=0; //@line 3279 "translate.cpp"
    HEAP32[((_end_character_position)>>2)]=0; //@line 3280 "translate.cpp"
    HEAP32[((_skip_sentences)>>2)]=0; //@line 3281 "translate.cpp"
    HEAP8[(((_skip_marker)&4294967295))]=0; //@line 3282 "translate.cpp"
    HEAP32[((_skip_words)>>2)]=0; //@line 3283 "translate.cpp"
    HEAP32[((_skip_characters)>>2)]=0; //@line 3284 "translate.cpp"
    HEAP32[((_skipping_text)>>2)]=0; //@line 3285 "translate.cpp"
    HEAP32[((_new_sentence)>>2)]=1; //@line 3286 "translate.cpp"
    HEAP32[((_option_sayas)>>2)]=0; //@line 3290 "translate.cpp"
    HEAP32[((__ZL13option_sayas2)>>2)]=0; //@line 3291 "translate.cpp"
    HEAP32[((__ZL15option_emphasis)>>2)]=0; //@line 3292 "translate.cpp"
    HEAP8[(__ZL13word_emphasis_b)]=0;
    HEAP8[(__ZL13embedded_flag_b)]=0;
    __Z9InitText2v(); //@line 3296 "translate.cpp"
    var $0=$control_addr; //@line 3298 "translate.cpp"
    var $and=($0) & 8192; //@line 3298 "translate.cpp"
    var $cmp=((($and))|0)==0; //@line 3298 "translate.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 3298 "translate.cpp"
    if (__label__ == 1) {
  
      __Z12InitNamedatav(); //@line 3300 "translate.cpp"
      ; //@line 3301 "translate.cpp"
    }
  
    ;
    return; //@line 3302 "translate.cpp"
    return;
  }
  

  function __ZL14CountSyllablesPh($phonemes) {
    ;
    var __label__;
  
    var $phonemes_addr;
    var $count;
    var $phon;
    $phonemes_addr=$phonemes;
    $count=0; //@line 1555 "translate.cpp"
    var $0=$phonemes_addr; //@line 1557 "translate.cpp"
    var $incdec_ptr1=(($0+1)&4294967295); //@line 1557 "translate.cpp"
    $phonemes_addr=$incdec_ptr1; //@line 1557 "translate.cpp"
    var $1=HEAPU8[($0)]; //@line 1557 "translate.cpp"
    var $conv2=((($1))&255); //@line 1557 "translate.cpp"
    $phon=$conv2; //@line 1557 "translate.cpp"
    var $cmp3=((($conv2))|0)!=0; //@line 1557 "translate.cpp"
    if ($cmp3) { __label__ = 1;; } else { __label__ = 4;; } //@line 1557 "translate.cpp"
    $while_body$$while_end$2: do { 
      if (__label__ == 1) {
        while(1) { 
  
          var $2=$phon; //@line 1559 "translate.cpp"
          var $arrayidx=((_phoneme_tab+$2*4)&4294967295); //@line 1559 "translate.cpp"
          var $3=HEAP32[(($arrayidx)>>2)]; //@line 1559 "translate.cpp"
          var $type=(($3+11)&4294967295); //@line 1559 "translate.cpp"
          var $4=HEAPU8[($type)]; //@line 1559 "translate.cpp"
          var $conv1=((($4))&255); //@line 1559 "translate.cpp"
          var $cmp2=((($conv1))|0)==2; //@line 1559 "translate.cpp"
          if ($cmp2) { __label__ = 2;; } else { __label__ = 3;; } //@line 1559 "translate.cpp"
          if (__label__ == 2) {
  
            var $5=$count; //@line 1560 "translate.cpp"
            var $inc=((($5)+1)&4294967295); //@line 1560 "translate.cpp"
            $count=$inc; //@line 1560 "translate.cpp"
            ; //@line 1560 "translate.cpp"
          }
  
          var $6=$phonemes_addr; //@line 1557 "translate.cpp"
          var $incdec_ptr=(($6+1)&4294967295); //@line 1557 "translate.cpp"
          $phonemes_addr=$incdec_ptr; //@line 1557 "translate.cpp"
          var $7=HEAPU8[($6)]; //@line 1557 "translate.cpp"
          var $conv=((($7))&255); //@line 1557 "translate.cpp"
          $phon=$conv; //@line 1557 "translate.cpp"
          var $cmp=((($conv))|0)!=0; //@line 1557 "translate.cpp"
          if ($cmp) { __label__ = 1;continue ; } else { __label__ = 4;break $while_body$$while_end$2; } //@line 1557 "translate.cpp"
        }
      }
    } while(0);
  
    var $8=$count; //@line 1562 "translate.cpp"
    ;
    return $8; //@line 1562 "translate.cpp"
    return null;
  }
  

  function __ZL9SetPlist2P13PHONEME_LIST2h($p, $phcode) {
    ;
    var __label__;
  
    var $p_addr;
    var $phcode_addr;
    $p_addr=$p;
    $phcode_addr=$phcode;
    var $0=$phcode_addr; //@line 1545 "translate.cpp"
    var $1=$p_addr; //@line 1545 "translate.cpp"
    var $phcode1=(($1)&4294967295); //@line 1545 "translate.cpp"
    HEAP8[($phcode1)]=$0; //@line 1545 "translate.cpp"
    var $2=$p_addr; //@line 1546 "translate.cpp"
    var $stresslevel=(($2+1)&4294967295); //@line 1546 "translate.cpp"
    HEAP8[($stresslevel)]=0; //@line 1546 "translate.cpp"
    var $3=$p_addr; //@line 1547 "translate.cpp"
    var $tone_ph=(($3+3)&4294967295); //@line 1547 "translate.cpp"
    HEAP8[($tone_ph)]=0; //@line 1547 "translate.cpp"
    var $_b=HEAPU8[(__ZL13embedded_flag_b)];
    var $4=($_b) ? 2 : 0;
    var $conv=((($4)) & 65535); //@line 1548 "translate.cpp"
    var $5=$p_addr; //@line 1548 "translate.cpp"
    var $synthflags=(($5+4)&4294967295); //@line 1548 "translate.cpp"
    HEAP16[(($synthflags)>>1)]=$conv; //@line 1548 "translate.cpp"
    var $6=$p_addr; //@line 1549 "translate.cpp"
    var $sourceix=(($6+6)&4294967295); //@line 1549 "translate.cpp"
    HEAP16[(($sourceix)>>1)]=0; //@line 1549 "translate.cpp"
    HEAP8[(__ZL13embedded_flag_b)]=0;
    ;
    return; //@line 1551 "translate.cpp"
    return;
  }
  

  function __ZL14SubstituteCharP10TranslatorjjPi($tr, $c, $next_in, $insert) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $tr_addr;
    var $c_addr;
    var $next_in_addr;
    var $insert_addr;
    var $ix;
    var $word;
    var $new_c;
    var $c2;
    var $c_lower;
    var $upper_case;
    var $replace_chars;
    $tr_addr=$tr;
    $c_addr=$c;
    $next_in_addr=$next_in;
    $insert_addr=$insert;
    $upper_case=0; //@line 2195 "translate.cpp"
    var $_b=HEAPU8[(__ZZL14SubstituteCharP10TranslatorjjPiE11ignore_next_b)];
    var $0=((($_b))&1);
    var $tobool=((($0))|0)!=0; //@line 2199 "translate.cpp"
    if ($tobool) { __label__ = 1;; } else { __label__ = 2;; } //@line 2199 "translate.cpp"
    if (__label__ == 1) {
  
      HEAP8[(__ZZL14SubstituteCharP10TranslatorjjPiE11ignore_next_b)]=0;
      $retval=8; //@line 2202 "translate.cpp"
      ; //@line 2202 "translate.cpp"
    }
    else if (__label__ == 2) {
  
      var $1=$c_addr; //@line 2204 "translate.cpp"
      var $cmp=((($1))|0)==0; //@line 2204 "translate.cpp"
      if ($cmp) { __label__ = 3;; } else { __label__ = 4;; } //@line 2204 "translate.cpp"
      if (__label__ == 3) {
  
        $retval=0; //@line 2204 "translate.cpp"
        ; //@line 2204 "translate.cpp"
      }
      else if (__label__ == 4) {
  
        var $2=$tr_addr; //@line 2206 "translate.cpp"
        var $langopts=(($2)&4294967295); //@line 2206 "translate.cpp"
        var $replace_chars3=(($langopts+264)&4294967295); //@line 2206 "translate.cpp"
        var $3=HEAP32[(($replace_chars3)>>2)]; //@line 2206 "translate.cpp"
        $replace_chars=$3; //@line 2206 "translate.cpp"
        var $cmp4=((($3))|0)==0; //@line 2206 "translate.cpp"
        var $4=$c_addr; //@line 2207 "translate.cpp"
        if ($cmp4) { __label__ = 5;; } else { __label__ = 6;; } //@line 2206 "translate.cpp"
        if (__label__ == 5) {
  
          $retval=$4; //@line 2207 "translate.cpp"
          ; //@line 2207 "translate.cpp"
        }
        else if (__label__ == 6) {
  
          $c_lower=$4; //@line 2211 "translate.cpp"
          var $call=_iswupper($4); //@line 2211 "translate.cpp"
          var $tobool7=((($call))|0)!=0; //@line 2211 "translate.cpp"
          if ($tobool7) { __label__ = 7;; } else { __label__ = 8;; } //@line 2211 "translate.cpp"
          if (__label__ == 7) {
  
            var $5=$c_addr; //@line 2213 "translate.cpp"
            var $call9=_towlower($5); //@line 2213 "translate.cpp"
            $c_lower=$call9; //@line 2213 "translate.cpp"
            $upper_case=1; //@line 2214 "translate.cpp"
            ; //@line 2215 "translate.cpp"
          }
  
          $new_c=0; //@line 2217 "translate.cpp"
          $ix=0; //@line 2218 "translate.cpp"
          ; //@line 2218 "translate.cpp"
          $for_cond$14: while(1) { 
  
            var $6=$ix; //@line 2218 "translate.cpp"
            var $7=$replace_chars; //@line 2218 "translate.cpp"
            var $arrayidx=(($7+4*$6)&4294967295); //@line 2218 "translate.cpp"
            var $8=HEAP32[(($arrayidx)>>2)]; //@line 2218 "translate.cpp"
            $word=$8; //@line 2218 "translate.cpp"
            var $cmp11=((($8))|0)!=0; //@line 2218 "translate.cpp"
            if (!($cmp11)) { __label__ = 16;break $for_cond$14; } //@line 2218 "translate.cpp"
  
            var $9=$c_lower; //@line 2220 "translate.cpp"
            var $10=$word; //@line 2220 "translate.cpp"
            var $and=($10) & 65535; //@line 2220 "translate.cpp"
            var $cmp12=((($9))|0)==((($and))|0); //@line 2220 "translate.cpp"
            if ($cmp12) { __label__ = 11;; } else { __label__ = 15;; } //@line 2220 "translate.cpp"
            if (__label__ == 11) {
  
              var $11=$word; //@line 2222 "translate.cpp"
              var $shr=($11) >>> 16; //@line 2222 "translate.cpp"
              var $cmp14=((($shr))|0)==0; //@line 2222 "translate.cpp"
              if ($cmp14) { __label__ = 12;break $for_cond$14; } //@line 2222 "translate.cpp"
  
              var $15=$word; //@line 2227 "translate.cpp"
              var $shr18=($15) >>> 16; //@line 2227 "translate.cpp"
              var $16=$next_in_addr; //@line 2227 "translate.cpp"
              var $call19=_towlower($16); //@line 2227 "translate.cpp"
              var $cmp20=((($shr18))|0)==((($call19))|0); //@line 2227 "translate.cpp"
              if ($cmp20) { __label__ = 14;break $for_cond$14; } //@line 2227 "translate.cpp"
            }
  
            var $20=$ix; //@line 2218 "translate.cpp"
            var $add26=((($20)+2)&4294967295); //@line 2218 "translate.cpp"
            $ix=$add26; //@line 2218 "translate.cpp"
            __label__ = 9;continue $for_cond$14; //@line 2218 "translate.cpp"
          }
          if (__label__ == 16) {
  
            var $_pr=$new_c; //@line 2236 "translate.cpp"
            __lastLabel__ = 16; ;
          }
          else if (__label__ == 12) {
  
            var $12=$ix; //@line 2224 "translate.cpp"
            var $add=((($12)+1)&4294967295); //@line 2224 "translate.cpp"
            var $13=$replace_chars; //@line 2224 "translate.cpp"
            var $arrayidx16=(($13+4*$add)&4294967295); //@line 2224 "translate.cpp"
            var $14=HEAPU32[(($arrayidx16)>>2)]; //@line 2224 "translate.cpp"
            $new_c=$14; //@line 2224 "translate.cpp"
            __lastLabel__ = 12; ; //@line 2225 "translate.cpp"
          }
          else if (__label__ == 14) {
  
            var $17=$ix; //@line 2229 "translate.cpp"
            var $add22=((($17)+1)&4294967295); //@line 2229 "translate.cpp"
            var $18=$replace_chars; //@line 2229 "translate.cpp"
            var $arrayidx23=(($18+4*$add22)&4294967295); //@line 2229 "translate.cpp"
            var $19=HEAPU32[(($arrayidx23)>>2)]; //@line 2229 "translate.cpp"
            $new_c=$19; //@line 2229 "translate.cpp"
            HEAP8[(__ZZL14SubstituteCharP10TranslatorjjPiE11ignore_next_b)]=1;
            __lastLabel__ = 14; ; //@line 2231 "translate.cpp"
          }
  
          var $21=__lastLabel__ == 16 ? $_pr : (__lastLabel__ == 14 ? $19 : ($14)); //@line 2236 "translate.cpp"
          var $cmp27=((($21))|0)==0; //@line 2236 "translate.cpp"
          if ($cmp27) { __label__ = 18;; } else { __label__ = 19;; } //@line 2236 "translate.cpp"
          if (__label__ == 18) {
  
            var $22=$c_addr; //@line 2237 "translate.cpp"
            $retval=$22; //@line 2237 "translate.cpp"
            ; //@line 2237 "translate.cpp"
          }
          else if (__label__ == 19) {
  
            var $23=$new_c; //@line 2239 "translate.cpp"
            var $and30=($23) & -2097152; //@line 2239 "translate.cpp"
            var $tobool31=((($and30))|0)!=0; //@line 2239 "translate.cpp"
            if ($tobool31) { __label__ = 20;; } else { __label__ = 24;; } //@line 2239 "translate.cpp"
            if (__label__ == 20) {
  
              var $24=$new_c; //@line 2243 "translate.cpp"
              var $shr33=($24) >>> 16; //@line 2243 "translate.cpp"
              $c2=$shr33; //@line 2243 "translate.cpp"
              var $25=$upper_case; //@line 2244 "translate.cpp"
              var $tobool34=((($25))|0)!=0; //@line 2244 "translate.cpp"
              if ($tobool34) { __label__ = 21;; } else { __label__ = 23;; } //@line 2244 "translate.cpp"
              $land_lhs_true$$if_end39$31: do { 
                if (__label__ == 21) {
  
                  var $26=$next_in_addr; //@line 2244 "translate.cpp"
                  var $call35=_iswupper($26); //@line 2244 "translate.cpp"
                  var $tobool36=((($call35))|0)!=0; //@line 2244 "translate.cpp"
                  if (!($tobool36)) { __label__ = 23;break $land_lhs_true$$if_end39$31; } //@line 2244 "translate.cpp"
  
                  var $27=$c2; //@line 2245 "translate.cpp"
                  var $call38=_towupper($27); //@line 2245 "translate.cpp"
                  $c2=$call38; //@line 2245 "translate.cpp"
                  ; //@line 2245 "translate.cpp"
                }
              } while(0);
  
              var $28=$c2; //@line 2246 "translate.cpp"
              var $29=$insert_addr; //@line 2246 "translate.cpp"
              HEAP32[(($29)>>2)]=$28; //@line 2246 "translate.cpp"
              var $30=$new_c; //@line 2247 "translate.cpp"
              var $and40=($30) & 65535; //@line 2247 "translate.cpp"
              $new_c=$and40; //@line 2247 "translate.cpp"
              ; //@line 2248 "translate.cpp"
            }
  
            var $31=$upper_case; //@line 2250 "translate.cpp"
            var $tobool42=((($31))|0)!=0; //@line 2250 "translate.cpp"
            if ($tobool42) { __label__ = 25;; } else { __label__ = 26;; } //@line 2250 "translate.cpp"
            if (__label__ == 25) {
  
              var $32=$new_c; //@line 2251 "translate.cpp"
              var $call44=_towupper($32); //@line 2251 "translate.cpp"
              $new_c=$call44; //@line 2251 "translate.cpp"
              ; //@line 2251 "translate.cpp"
            }
  
            var $33=$new_c; //@line 2252 "translate.cpp"
            $retval=$33; //@line 2252 "translate.cpp"
            ; //@line 2252 "translate.cpp"
          }
        }
      }
    }
  
    var $34=$retval; //@line 2254 "translate.cpp"
    ;
    return $34; //@line 2254 "translate.cpp"
    return null;
  }
  

  function _init_MBR($voice_path) {
    var __stackBase__  = STACKTOP; STACKTOP += 48; _memset(__stackBase__, 0, 48);
    var __label__;
  
    var $retval;
    var $voice_path_addr;
    var $error;
    var $result;
    var $wavhdr=__stackBase__;
    $voice_path_addr=$voice_path;
    var $0=$voice_path_addr; //@line 484 "mbrowrap.cpp"
    var $call=__ZL12start_mbrolaPKc($0); //@line 484 "mbrowrap.cpp"
    $error=$call; //@line 484 "mbrowrap.cpp"
    var $1=$error; //@line 485 "mbrowrap.cpp"
    var $tobool=((($1))|0)!=0; //@line 485 "mbrowrap.cpp"
    if ($tobool) { __label__ = 1;; } else { __label__ = 2;; } //@line 485 "mbrowrap.cpp"
    $if_then$$if_end$2: do { 
      if (__label__ == 1) {
  
        $retval=-1; //@line 486 "mbrowrap.cpp"
        ; //@line 486 "mbrowrap.cpp"
      }
      else if (__label__ == 2) {
  
        var $call1=__ZL14send_to_mbrolaPKc(((__str580)&4294967295)); //@line 488 "mbrowrap.cpp"
        $result=$call1; //@line 488 "mbrowrap.cpp"
        var $2=$result; //@line 489 "mbrowrap.cpp"
        var $cmp=((($2))|0)!=2; //@line 489 "mbrowrap.cpp"
        if ($cmp) { __label__ = 3;; } else { __label__ = 4;; } //@line 489 "mbrowrap.cpp"
        if (__label__ == 3) {
  
          __ZL11stop_mbrolav(); //@line 490 "mbrowrap.cpp"
          $retval=-1; //@line 491 "mbrowrap.cpp"
          ; //@line 491 "mbrowrap.cpp"
        }
        else if (__label__ == 4) {
  
          var $arraydecay=(($wavhdr)&4294967295); //@line 495 "mbrowrap.cpp"
          var $call4=__ZL19receive_from_mbrolaPvj($arraydecay, 45); //@line 495 "mbrowrap.cpp"
          $result=$call4; //@line 495 "mbrowrap.cpp"
          var $3=$result; //@line 496 "mbrowrap.cpp"
          var $cmp5=((($3))|0)!=44; //@line 496 "mbrowrap.cpp"
          if ($cmp5) { __label__ = 5;; } else { __label__ = 8;; } //@line 496 "mbrowrap.cpp"
          if (__label__ == 5) {
  
            var $4=$result; //@line 497 "mbrowrap.cpp"
            var $cmp7=((($4))|0) >= 0; //@line 497 "mbrowrap.cpp"
            if ($cmp7) { __label__ = 6;; } else { __label__ = 7;; } //@line 497 "mbrowrap.cpp"
            if (__label__ == 6) {
  
              __ZL3errPKcz(((__str1581)&4294967295), allocate(1, "i32", ALLOC_STACK)); //@line 498 "mbrowrap.cpp"
              ; //@line 498 "mbrowrap.cpp"
            }
  
            __ZL11stop_mbrolav(); //@line 499 "mbrowrap.cpp"
            $retval=-1; //@line 500 "mbrowrap.cpp"
            ; //@line 500 "mbrowrap.cpp"
          }
          else if (__label__ == 8) {
  
            var $arraydecay11=(($wavhdr)&4294967295); //@line 504 "mbrowrap.cpp"
            var $call12=_memcmp($arraydecay11, ((__str2582)&4294967295), 4); //@line 504 "mbrowrap.cpp"
            var $cmp13=((($call12))|0)!=0; //@line 504 "mbrowrap.cpp"
            if ($cmp13) { __label__ = 10;; } else { __label__ = 9;; } //@line 504 "mbrowrap.cpp"
            $if_then17$$lor_lhs_false$14: do { 
              if (__label__ == 9) {
  
                var $arraydecay14=(($wavhdr)&4294967295); //@line 505 "mbrowrap.cpp"
                var $add_ptr=(($arraydecay14+8)&4294967295); //@line 505 "mbrowrap.cpp"
                var $call15=_memcmp($add_ptr, ((__str3583)&4294967295), 8); //@line 505 "mbrowrap.cpp"
                var $cmp16=((($call15))|0)!=0; //@line 505 "mbrowrap.cpp"
                if ($cmp16) { __label__ = 10;break $if_then17$$lor_lhs_false$14; } //@line 505 "mbrowrap.cpp"
  
                var $arrayidx=(($wavhdr+24)&4294967295); //@line 510 "mbrowrap.cpp"
                var $5=HEAPU8[($arrayidx)]; //@line 510 "mbrowrap.cpp"
                var $conv=((($5))&255); //@line 510 "mbrowrap.cpp"
                var $arrayidx19=(($wavhdr+25)&4294967295); //@line 510 "mbrowrap.cpp"
                var $6=HEAPU8[($arrayidx19)]; //@line 510 "mbrowrap.cpp"
                var $conv20=((($6))&255); //@line 510 "mbrowrap.cpp"
                var $shl=((($conv20)*256)&4294967295); //@line 510 "mbrowrap.cpp"
                var $arrayidx21=(($wavhdr+26)&4294967295); //@line 510 "mbrowrap.cpp"
                var $7=HEAPU8[($arrayidx21)]; //@line 510 "mbrowrap.cpp"
                var $conv22=((($7))&255); //@line 510 "mbrowrap.cpp"
                var $shl23=((($conv22)*65536)&4294967295); //@line 510 "mbrowrap.cpp"
                var $arrayidx25=(($wavhdr+27)&4294967295); //@line 510 "mbrowrap.cpp"
                var $8=HEAPU8[($arrayidx25)]; //@line 510 "mbrowrap.cpp"
                var $conv26=((($8))&255); //@line 510 "mbrowrap.cpp"
                var $shl27=((($conv26)*16777216)&4294967295); //@line 510 "mbrowrap.cpp"
                var $add=((($shl)+($conv))&4294967295); //@line 510 "mbrowrap.cpp"
                var $add24=((($add)+($shl23))&4294967295); //@line 510 "mbrowrap.cpp"
                var $add28=((($add24)+($shl27))&4294967295); //@line 510 "mbrowrap.cpp"
                HEAP32[((__ZL14mbr_samplerate)>>2)]=$add28; //@line 510 "mbrowrap.cpp"
                var $9=HEAP32[((__ZL14mbr_voice_path)>>2)]; //@line 515 "mbrowrap.cpp"
                var $10=$voice_path_addr; //@line 515 "mbrowrap.cpp"
                var $cmp29=((($9))|0)!=((($10))|0); //@line 515 "mbrowrap.cpp"
                if ($cmp29) { __label__ = 12;; } else { __label__ = 13;; } //@line 515 "mbrowrap.cpp"
                if (__label__ == 12) {
  
                  var $11=HEAP32[((__ZL14mbr_voice_path)>>2)]; //@line 516 "mbrowrap.cpp"
                  ; //@line 516 "mbrowrap.cpp"
                  var $12=$voice_path_addr; //@line 517 "mbrowrap.cpp"
                  var $call31=_strdup($12); //@line 517 "mbrowrap.cpp"
                  HEAP32[((__ZL14mbr_voice_path)>>2)]=$call31; //@line 517 "mbrowrap.cpp"
                  ; //@line 518 "mbrowrap.cpp"
                }
  
                $retval=0; //@line 520 "mbrowrap.cpp"
                __label__ = 14;break $if_then$$if_end$2; //@line 520 "mbrowrap.cpp"
              }
            } while(0);
  
            __ZL3errPKcz(((__str4584)&4294967295), allocate(1, "i32", ALLOC_STACK)); //@line 506 "mbrowrap.cpp"
            __ZL11stop_mbrolav(); //@line 507 "mbrowrap.cpp"
            $retval=-1; //@line 508 "mbrowrap.cpp"
            ; //@line 508 "mbrowrap.cpp"
          }
        }
      }
    } while(0);
  
    var $13=$retval; //@line 521 "mbrowrap.cpp"
    STACKTOP = __stackBase__;
    return $13; //@line 521 "mbrowrap.cpp"
    return null;
  }
  

  function __ZL12start_mbrolaPKc($voice_path) {
    var __stackBase__  = STACKTOP; STACKTOP += 44; _memset(__stackBase__, 0, 44);
    var __label__;
  
    var $retval;
    var $voice_path_addr;
    var $error;
    var $p_stdin=__stackBase__;
    var $p_stdout=__stackBase__+8;
    var $p_stderr=__stackBase__+16;
    var $charbuf=__stackBase__+24;
    var $i;
    $voice_path_addr=$voice_path;
    var $0=HEAP32[((__ZL9mbr_state)>>2)]; //@line 128 "mbrowrap.cpp"
    var $cmp=((($0))|0)!=0; //@line 128 "mbrowrap.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 128 "mbrowrap.cpp"
    $if_then$$if_end$2: do { 
      if (__label__ == 1) {
  
        __ZL3errPKcz(((__str22602)&4294967295), allocate(1, "i32", ALLOC_STACK)); //@line 129 "mbrowrap.cpp"
        $retval=-1; //@line 130 "mbrowrap.cpp"
        ; //@line 130 "mbrowrap.cpp"
      }
      else if (__label__ == 2) {
  
        var $arraydecay=(($p_stdin)&4294967295); //@line 133 "mbrowrap.cpp"
        var $arraydecay1=(($p_stdout)&4294967295); //@line 133 "mbrowrap.cpp"
        var $arraydecay2=(($p_stderr)&4294967295); //@line 133 "mbrowrap.cpp"
        var $call=__ZL12create_pipesPiS_S_($arraydecay, $arraydecay1, $arraydecay2); //@line 133 "mbrowrap.cpp"
        $error=$call; //@line 133 "mbrowrap.cpp"
        var $1=$error; //@line 134 "mbrowrap.cpp"
        var $tobool=((($1))|0)!=0; //@line 134 "mbrowrap.cpp"
        if ($tobool) { __label__ = 3;; } else { __label__ = 4;; } //@line 134 "mbrowrap.cpp"
        if (__label__ == 3) {
  
          $retval=-1; //@line 135 "mbrowrap.cpp"
          ; //@line 135 "mbrowrap.cpp"
        }
        else if (__label__ == 4) {
  
          var $call5=_fork(); //@line 137 "mbrowrap.cpp"
          HEAP32[((__ZL7mbr_pid)>>2)]=$call5; //@line 137 "mbrowrap.cpp"
          var $2=HEAP32[((__ZL7mbr_pid)>>2)]; //@line 139 "mbrowrap.cpp"
          var $cmp6=((($2))|0)==-1; //@line 139 "mbrowrap.cpp"
          if ($cmp6) { __label__ = 5;; } else { __label__ = 6;; } //@line 139 "mbrowrap.cpp"
          if (__label__ == 5) {
  
            var $call8=___errno(); //@line 140 "mbrowrap.cpp"
            var $3=HEAP32[(($call8)>>2)]; //@line 140 "mbrowrap.cpp"
            $error=$3; //@line 140 "mbrowrap.cpp"
            var $arraydecay9=(($p_stdin)&4294967295); //@line 141 "mbrowrap.cpp"
            var $arraydecay10=(($p_stdout)&4294967295); //@line 141 "mbrowrap.cpp"
            var $arraydecay11=(($p_stderr)&4294967295); //@line 141 "mbrowrap.cpp"
            __ZL11close_pipesPiS_S_($arraydecay9, $arraydecay10, $arraydecay11); //@line 141 "mbrowrap.cpp"
            var $4=$error; //@line 142 "mbrowrap.cpp"
            var $call12=_strerror($4); //@line 142 "mbrowrap.cpp"
            __ZL3errPKcz(((__str23603)&4294967295), allocate([$call12,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 142 "mbrowrap.cpp"
            $retval=-1; //@line 143 "mbrowrap.cpp"
            ; //@line 143 "mbrowrap.cpp"
          }
          else if (__label__ == 6) {
  
            var $5=HEAP32[((__ZL7mbr_pid)>>2)]; //@line 146 "mbrowrap.cpp"
            var $cmp14=((($5))|0)==0; //@line 146 "mbrowrap.cpp"
            if ($cmp14) { __label__ = 7;; } else { __label__ = 14;; } //@line 146 "mbrowrap.cpp"
            if (__label__ == 7) {
  
              var $arrayidx=(($p_stdin)&4294967295); //@line 149 "mbrowrap.cpp"
              var $6=HEAP32[(($arrayidx)>>2)]; //@line 149 "mbrowrap.cpp"
              var $call16=_dup2($6, 0); //@line 149 "mbrowrap.cpp"
              var $cmp17=((($call16))|0)==-1; //@line 149 "mbrowrap.cpp"
              if ($cmp17) { __label__ = 10;; } else { __label__ = 8;; } //@line 149 "mbrowrap.cpp"
              $if_then25$$lor_lhs_false$13: do { 
                if (__label__ == 8) {
  
                  var $arrayidx18=(($p_stdout+4)&4294967295); //@line 150 "mbrowrap.cpp"
                  var $7=HEAP32[(($arrayidx18)>>2)]; //@line 150 "mbrowrap.cpp"
                  var $call19=_dup2($7, 1); //@line 150 "mbrowrap.cpp"
                  var $cmp20=((($call19))|0)==-1; //@line 150 "mbrowrap.cpp"
                  if ($cmp20) { __label__ = 10;break $if_then25$$lor_lhs_false$13; } //@line 150 "mbrowrap.cpp"
  
                  var $arrayidx22=(($p_stderr+4)&4294967295); //@line 151 "mbrowrap.cpp"
                  var $8=HEAP32[(($arrayidx22)>>2)]; //@line 151 "mbrowrap.cpp"
                  var $call23=_dup2($8, 2); //@line 151 "mbrowrap.cpp"
                  var $cmp24=((($call23))|0)==-1; //@line 151 "mbrowrap.cpp"
                  if ($cmp24) { __label__ = 10;break $if_then25$$lor_lhs_false$13; } else { __label__ = 11;break $if_then25$$lor_lhs_false$13; } //@line 151 "mbrowrap.cpp"
                }
              } while(0);
              if (__label__ == 10) {
  
                var $call26=___errno(); //@line 153 "mbrowrap.cpp"
                var $9=HEAP32[(($call26)>>2)]; //@line 153 "mbrowrap.cpp"
                var $call27=_strerror($9); //@line 153 "mbrowrap.cpp"
                var $call28=_snprintf(((__ZL12mbr_errorbuf)&4294967295), 160, ((__str24604)&4294967295), allocate([$call27,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 153 "mbrowrap.cpp"
                var $arrayidx29=(($p_stderr+4)&4294967295); //@line 154 "mbrowrap.cpp"
                var $10=HEAP32[(($arrayidx29)>>2)]; //@line 154 "mbrowrap.cpp"
                var $call30=_strlen(((__ZL12mbr_errorbuf)&4294967295)); //@line 154 "mbrowrap.cpp"
                var $call31=_write($10, ((__ZL12mbr_errorbuf)&4294967295), $call30); //@line 154 "mbrowrap.cpp"
                __exit(1); //@line 155 "mbrowrap.cpp"
                ; //@line 156 "mbrowrap.cpp"
              }
  
              var $arrayidx33=(($p_stderr+4)&4294967295); //@line 158 "mbrowrap.cpp"
              var $11=HEAP32[(($arrayidx33)>>2)]; //@line 158 "mbrowrap.cpp"
              $i=$11; //@line 158 "mbrowrap.cpp"
              var $cmp341=((($11))|0) > 2; //@line 158 "mbrowrap.cpp"
              if ($cmp341) { __label__ = 12;; } else { __label__ = 13;; } //@line 158 "mbrowrap.cpp"
              $for_body$$for_end$19: do { 
                if (__label__ == 12) {
                  while(1) { 
  
                    var $12=$i; //@line 159 "mbrowrap.cpp"
                    var $call35=_close($12); //@line 159 "mbrowrap.cpp"
                    var $13=$i; //@line 158 "mbrowrap.cpp"
                    var $dec=((($13)-1)&4294967295); //@line 158 "mbrowrap.cpp"
                    $i=$dec; //@line 158 "mbrowrap.cpp"
                    var $cmp34=((($dec))|0) > 2; //@line 158 "mbrowrap.cpp"
                    if ($cmp34) { __label__ = 12;continue ; } else { __label__ = 13;break $for_body$$for_end$19; } //@line 158 "mbrowrap.cpp"
                  }
                }
              } while(0);
  
              var $call36=_signal(1, 1); //@line 160 "mbrowrap.cpp"
              var $call37=_signal(2, 1); //@line 161 "mbrowrap.cpp"
              var $call38=_signal(3, 1); //@line 162 "mbrowrap.cpp"
              var $call39=_signal(15, 1); //@line 163 "mbrowrap.cpp"
              var $arraydecay40=(($charbuf)&4294967295); //@line 165 "mbrowrap.cpp"
              var $14=HEAPF32[((__ZL10mbr_volume)>>2)]; //@line 165 "mbrowrap.cpp"
              var $conv=($14); //@line 165 "mbrowrap.cpp"
              var $call41=_snprintf($arraydecay40, 20, ((__str25605)&4294967295), allocate([$conv,0,0,0,0,0,0,0], ["double",0,0,0,0,0,0,0], ALLOC_STACK)); //@line 165 "mbrowrap.cpp"
              var $arraydecay42=(($charbuf)&4294967295); //@line 166 "mbrowrap.cpp"
              var $15=$voice_path_addr; //@line 166 "mbrowrap.cpp"
              var $call43=_execlp(((__str33683)&4294967295), ((__str33683)&4294967295), allocate([((__str27607)&4294967295),0,0,0,((__str28608)&4294967295),0,0,0,$arraydecay42,0,0,0,$15,0,0,0,((__str56708)&4294967295),0,0,0,((__str30610)&4294967295),0,0,0,0,0,0,0], ["i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 166 "mbrowrap.cpp"
              var $call44=___errno(); //@line 170 "mbrowrap.cpp"
              var $16=HEAP32[(($call44)>>2)]; //@line 170 "mbrowrap.cpp"
              var $call45=_strerror($16); //@line 170 "mbrowrap.cpp"
              var $call46=_snprintf(((__ZL12mbr_errorbuf)&4294967295), 160, ((__str31611)&4294967295), allocate([$call45,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 170 "mbrowrap.cpp"
              var $call47=_strlen(((__ZL12mbr_errorbuf)&4294967295)); //@line 171 "mbrowrap.cpp"
              var $call48=_write(2, ((__ZL12mbr_errorbuf)&4294967295), $call47); //@line 171 "mbrowrap.cpp"
              __exit(1); //@line 172 "mbrowrap.cpp"
              ; //@line 173 "mbrowrap.cpp"
            }
  
            var $arraydecay50=(($charbuf)&4294967295); //@line 175 "mbrowrap.cpp"
            var $17=HEAP32[((__ZL7mbr_pid)>>2)]; //@line 175 "mbrowrap.cpp"
            var $call51=_snprintf($arraydecay50, 20, ((__str32612)&4294967295), allocate([$17,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 175 "mbrowrap.cpp"
            var $arraydecay52=(($charbuf)&4294967295); //@line 176 "mbrowrap.cpp"
            var $call53=_open($arraydecay52, 0, allocate(1, "i32", ALLOC_STACK)); //@line 176 "mbrowrap.cpp"
            HEAP32[((__ZL13mbr_proc_stat)>>2)]=$call53; //@line 176 "mbrowrap.cpp"
            var $cmp54=((($call53))|0)==-1; //@line 177 "mbrowrap.cpp"
            if ($cmp54) { __label__ = 15;; } else { __label__ = 16;; } //@line 177 "mbrowrap.cpp"
            if (__label__ == 15) {
  
              var $call56=___errno(); //@line 178 "mbrowrap.cpp"
              var $18=HEAP32[(($call56)>>2)]; //@line 178 "mbrowrap.cpp"
              $error=$18; //@line 178 "mbrowrap.cpp"
              var $arraydecay57=(($p_stdin)&4294967295); //@line 179 "mbrowrap.cpp"
              var $arraydecay58=(($p_stdout)&4294967295); //@line 179 "mbrowrap.cpp"
              var $arraydecay59=(($p_stderr)&4294967295); //@line 179 "mbrowrap.cpp"
              __ZL11close_pipesPiS_S_($arraydecay57, $arraydecay58, $arraydecay59); //@line 179 "mbrowrap.cpp"
              var $19=HEAP32[((__ZL7mbr_pid)>>2)]; //@line 180 "mbrowrap.cpp"
              var $call60=_waitpid($19, 0, 0); //@line 180 "mbrowrap.cpp"
              HEAP32[((__ZL7mbr_pid)>>2)]=0; //@line 181 "mbrowrap.cpp"
              var $20=$error; //@line 182 "mbrowrap.cpp"
              var $call61=_strerror($20); //@line 182 "mbrowrap.cpp"
              __ZL3errPKcz(((__str33613)&4294967295), allocate([$call61,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 182 "mbrowrap.cpp"
              $retval=-1; //@line 183 "mbrowrap.cpp"
              ; //@line 183 "mbrowrap.cpp"
            }
            else if (__label__ == 16) {
  
              var $call63=_signal(13, 1); //@line 186 "mbrowrap.cpp"
              var $arrayidx64=(($p_stdin+4)&4294967295); //@line 188 "mbrowrap.cpp"
              var $21=HEAP32[(($arrayidx64)>>2)]; //@line 188 "mbrowrap.cpp"
              var $call65=_fcntl($21, 4, allocate([16384,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 188 "mbrowrap.cpp"
              var $cmp66=((($call65))|0)==-1; //@line 188 "mbrowrap.cpp"
              if ($cmp66) { __label__ = 19;; } else { __label__ = 17;; } //@line 188 "mbrowrap.cpp"
              $if_then75$$lor_lhs_false67$27: do { 
                if (__label__ == 17) {
  
                  var $arrayidx68=(($p_stdout)&4294967295); //@line 189 "mbrowrap.cpp"
                  var $22=HEAP32[(($arrayidx68)>>2)]; //@line 189 "mbrowrap.cpp"
                  var $call69=_fcntl($22, 4, allocate([16384,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 189 "mbrowrap.cpp"
                  var $cmp70=((($call69))|0)==-1; //@line 189 "mbrowrap.cpp"
                  if ($cmp70) { __label__ = 19;break $if_then75$$lor_lhs_false67$27; } //@line 189 "mbrowrap.cpp"
  
                  var $arrayidx72=(($p_stderr)&4294967295); //@line 190 "mbrowrap.cpp"
                  var $23=HEAP32[(($arrayidx72)>>2)]; //@line 190 "mbrowrap.cpp"
                  var $call73=_fcntl($23, 4, allocate([16384,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 190 "mbrowrap.cpp"
                  var $cmp74=((($call73))|0)==-1; //@line 190 "mbrowrap.cpp"
                  if ($cmp74) { __label__ = 19;break $if_then75$$lor_lhs_false67$27; } //@line 190 "mbrowrap.cpp"
  
                  var $arrayidx83=(($p_stdin+4)&4294967295); //@line 199 "mbrowrap.cpp"
                  var $27=HEAP32[(($arrayidx83)>>2)]; //@line 199 "mbrowrap.cpp"
                  HEAP32[((__ZL10mbr_cmd_fd)>>2)]=$27; //@line 199 "mbrowrap.cpp"
                  var $arrayidx84=(($p_stdout)&4294967295); //@line 200 "mbrowrap.cpp"
                  var $28=HEAP32[(($arrayidx84)>>2)]; //@line 200 "mbrowrap.cpp"
                  HEAP32[((__ZL12mbr_audio_fd)>>2)]=$28; //@line 200 "mbrowrap.cpp"
                  var $arrayidx85=(($p_stderr)&4294967295); //@line 201 "mbrowrap.cpp"
                  var $29=HEAP32[(($arrayidx85)>>2)]; //@line 201 "mbrowrap.cpp"
                  HEAP32[((__ZL12mbr_error_fd)>>2)]=$29; //@line 201 "mbrowrap.cpp"
                  var $arrayidx86=(($p_stdin)&4294967295); //@line 202 "mbrowrap.cpp"
                  var $30=HEAP32[(($arrayidx86)>>2)]; //@line 202 "mbrowrap.cpp"
                  var $call87=_close($30); //@line 202 "mbrowrap.cpp"
                  var $arrayidx88=(($p_stdout+4)&4294967295); //@line 203 "mbrowrap.cpp"
                  var $31=HEAP32[(($arrayidx88)>>2)]; //@line 203 "mbrowrap.cpp"
                  var $call89=_close($31); //@line 203 "mbrowrap.cpp"
                  var $arrayidx90=(($p_stderr+4)&4294967295); //@line 204 "mbrowrap.cpp"
                  var $32=HEAP32[(($arrayidx90)>>2)]; //@line 204 "mbrowrap.cpp"
                  var $call91=_close($32); //@line 204 "mbrowrap.cpp"
                  HEAP32[((__ZL9mbr_state)>>2)]=1; //@line 206 "mbrowrap.cpp"
                  $retval=0; //@line 207 "mbrowrap.cpp"
                  __label__ = 21;break $if_then$$if_end$2; //@line 207 "mbrowrap.cpp"
                }
              } while(0);
  
              var $call76=___errno(); //@line 191 "mbrowrap.cpp"
              var $24=HEAP32[(($call76)>>2)]; //@line 191 "mbrowrap.cpp"
              $error=$24; //@line 191 "mbrowrap.cpp"
              var $arraydecay77=(($p_stdin)&4294967295); //@line 192 "mbrowrap.cpp"
              var $arraydecay78=(($p_stdout)&4294967295); //@line 192 "mbrowrap.cpp"
              var $arraydecay79=(($p_stderr)&4294967295); //@line 192 "mbrowrap.cpp"
              __ZL11close_pipesPiS_S_($arraydecay77, $arraydecay78, $arraydecay79); //@line 192 "mbrowrap.cpp"
              var $25=HEAP32[((__ZL7mbr_pid)>>2)]; //@line 193 "mbrowrap.cpp"
              var $call80=_waitpid($25, 0, 0); //@line 193 "mbrowrap.cpp"
              HEAP32[((__ZL7mbr_pid)>>2)]=0; //@line 194 "mbrowrap.cpp"
              var $26=$error; //@line 195 "mbrowrap.cpp"
              var $call81=_strerror($26); //@line 195 "mbrowrap.cpp"
              __ZL3errPKcz(((__str34614)&4294967295), allocate([$call81,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 195 "mbrowrap.cpp"
              $retval=-1; //@line 196 "mbrowrap.cpp"
              ; //@line 196 "mbrowrap.cpp"
            }
          }
        }
      }
    } while(0);
  
    var $33=$retval; //@line 208 "mbrowrap.cpp"
    STACKTOP = __stackBase__;
    return $33; //@line 208 "mbrowrap.cpp"
    return null;
  }
  

  function __ZL14send_to_mbrolaPKc($cmd) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $cmd_addr;
    var $result;
    var $len;
    var $error;
    var $data;
    $cmd_addr=$cmd;
    var $0=HEAP32[((__ZL7mbr_pid)>>2)]; //@line 328 "mbrowrap.cpp"
    var $tobool=((($0))|0)!=0; //@line 328 "mbrowrap.cpp"
    if ($tobool) { __label__ = 2;; } else { __label__ = 1;; } //@line 328 "mbrowrap.cpp"
    $if_end$$if_then$2: do { 
      if (__label__ == 2) {
  
        var $1=$cmd_addr; //@line 331 "mbrowrap.cpp"
        var $call=_strlen($1); //@line 331 "mbrowrap.cpp"
        $len=$call; //@line 331 "mbrowrap.cpp"
        var $2=HEAP32[((__ZL10mbr_cmd_fd)>>2)]; //@line 332 "mbrowrap.cpp"
        var $3=$cmd_addr; //@line 332 "mbrowrap.cpp"
        var $4=$len; //@line 332 "mbrowrap.cpp"
        var $call1=_write($2, $3, $4); //@line 332 "mbrowrap.cpp"
        $result=$call1; //@line 332 "mbrowrap.cpp"
        var $5=$result; //@line 334 "mbrowrap.cpp"
        var $cmp=((($5))|0)==-1; //@line 334 "mbrowrap.cpp"
        if ($cmp) { __label__ = 3;; } else { __label__ = 10;; } //@line 334 "mbrowrap.cpp"
        if (__label__ == 3) {
  
          var $call3=___errno(); //@line 335 "mbrowrap.cpp"
          var $6=HEAP32[(($call3)>>2)]; //@line 335 "mbrowrap.cpp"
          $error=$6; //@line 335 "mbrowrap.cpp"
          var $7=$error; //@line 336 "mbrowrap.cpp"
          var $cmp4=((($7))|0)==32; //@line 336 "mbrowrap.cpp"
          if ($cmp4) { __lastLabel__ = 3; __label__ = 4;; } else { __lastLabel__ = 3; __label__ = 7;; } //@line 336 "mbrowrap.cpp"
          if (__label__ == 4) {
  
            var $call5=__ZL17mbrola_has_errorsv(); //@line 336 "mbrowrap.cpp"
            var $tobool6=((($call5))|0)!=0; //@line 336 "mbrowrap.cpp"
            if ($tobool6) { __label__ = 5;; } else { __label__ = 6;; } //@line 336 "mbrowrap.cpp"
            if (__label__ == 5) {
  
              $retval=-1; //@line 337 "mbrowrap.cpp"
              __label__ = 17;break $if_end$$if_then$2; //@line 337 "mbrowrap.cpp"
            }
            else if (__label__ == 6) {
  
              var $_pr=$error; //@line 338 "mbrowrap.cpp"
              __lastLabel__ = 6; ;
            }
          }
  
          var $8=__lastLabel__ == 6 ? $_pr : ($7); //@line 338 "mbrowrap.cpp"
          var $cmp8=((($8))|0)==11; //@line 338 "mbrowrap.cpp"
          if ($cmp8) { __label__ = 8;; } else { __label__ = 9;; } //@line 338 "mbrowrap.cpp"
          if (__label__ == 8) {
  
            $result=0; //@line 339 "mbrowrap.cpp"
            ; //@line 344 "mbrowrap.cpp"
          }
          else if (__label__ == 9) {
  
            var $9=$error; //@line 341 "mbrowrap.cpp"
            var $call11=_strerror($9); //@line 341 "mbrowrap.cpp"
            __ZL3errPKcz(((__str20600)&4294967295), allocate([$call11,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 341 "mbrowrap.cpp"
            $retval=-1; //@line 342 "mbrowrap.cpp"
            __label__ = 17;break $if_end$$if_then$2; //@line 342 "mbrowrap.cpp"
          }
        }
  
        var $10=$result; //@line 346 "mbrowrap.cpp"
        var $11=$len; //@line 346 "mbrowrap.cpp"
        var $cmp15=((($10))|0)!=((($11))|0); //@line 346 "mbrowrap.cpp"
        if ($cmp15) { __label__ = 11;; } else { __label__ = 16;; } //@line 346 "mbrowrap.cpp"
        $if_then16$$if_end28$16: do { 
          if (__label__ == 11) {
  
            var $12=$len; //@line 348 "mbrowrap.cpp"
            var $13=$result; //@line 348 "mbrowrap.cpp"
            var $_neg=(((-($13)))&4294967295);
            var $add=((($12)+16)&4294967295); //@line 348 "mbrowrap.cpp"
            var $sub=((($add)+($_neg))&4294967295); //@line 348 "mbrowrap.cpp"
            var $call17=_malloc($sub); //@line 348 "mbrowrap.cpp"
            var $14=$call17; //@line 348 "mbrowrap.cpp"
            $data=$14; //@line 348 "mbrowrap.cpp"
            var $15=$data; //@line 349 "mbrowrap.cpp"
            var $tobool18=((($15))|0)!=0; //@line 349 "mbrowrap.cpp"
            if (!($tobool18)) { __label__ = 16;break $if_then16$$if_end28$16; } //@line 349 "mbrowrap.cpp"
  
            var $16=$data; //@line 350 "mbrowrap.cpp"
            var $next=(($16)&4294967295); //@line 350 "mbrowrap.cpp"
            HEAP32[(($next)>>2)]=0; //@line 350 "mbrowrap.cpp"
            var $17=$data; //@line 351 "mbrowrap.cpp"
            var $done=(($17+4)&4294967295); //@line 351 "mbrowrap.cpp"
            HEAP32[(($done)>>2)]=0; //@line 351 "mbrowrap.cpp"
            var $18=$len; //@line 352 "mbrowrap.cpp"
            var $19=$result; //@line 352 "mbrowrap.cpp"
            var $sub20=((($18)-($19))&4294967295); //@line 352 "mbrowrap.cpp"
            var $20=$data; //@line 352 "mbrowrap.cpp"
            var $size=(($20+8)&4294967295); //@line 352 "mbrowrap.cpp"
            HEAP32[(($size)>>2)]=$sub20; //@line 352 "mbrowrap.cpp"
            var $21=$data; //@line 353 "mbrowrap.cpp"
            var $buffer=(($21+12)&4294967295); //@line 353 "mbrowrap.cpp"
            var $arraydecay=(($buffer)&4294967295); //@line 353 "mbrowrap.cpp"
            var $22=$cmd_addr; //@line 353 "mbrowrap.cpp"
            var $23=$result; //@line 353 "mbrowrap.cpp"
            var $add_ptr=(($22+$23)&4294967295); //@line 353 "mbrowrap.cpp"
            var $24=$len; //@line 353 "mbrowrap.cpp"
            var $25=$result; //@line 353 "mbrowrap.cpp"
            var $sub21=((($24)-($25))&4294967295); //@line 353 "mbrowrap.cpp"
            var $src$, $dest$, $stop$, $stop4$, $fast$;
            $src$ = $add_ptr;
            $dest$ = $arraydecay;
            $stop$ = $src$ + $sub21;
            if (($dest$%4) == ($src$%4) && $sub21 > 8) {
              while ($src$%4 !== 0 && $src$ < $stop$) {
                ; HEAP8[$dest$++] = HEAP8[$src$++];
              }
              $src$ >>= 2;
              $dest$ >>= 2;
              $stop4$ = $stop$ >> 2;
              while ($src$ < $stop4$) {
            ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
              }
              $src$ <<= 2;
              $dest$ <<= 2;
            }while ($src$ < $stop$) {
              ; HEAP8[$dest$++] = HEAP8[$src$++];
            }; //@line 353 "mbrowrap.cpp"
            var $26=$len; //@line 354 "mbrowrap.cpp"
            $result=$26; //@line 354 "mbrowrap.cpp"
            var $27=HEAP32[((__ZL21mbr_pending_data_head)>>2)]; //@line 355 "mbrowrap.cpp"
            var $tobool22=((($27))|0)!=0; //@line 355 "mbrowrap.cpp"
            var $28=$data; //@line 358 "mbrowrap.cpp"
            if ($tobool22) { __label__ = 14;; } else { __label__ = 13;; } //@line 355 "mbrowrap.cpp"
            if (__label__ == 14) {
  
              var $29=HEAP32[((__ZL21mbr_pending_data_tail)>>2)]; //@line 358 "mbrowrap.cpp"
              var $next25=(($29)&4294967295); //@line 358 "mbrowrap.cpp"
              HEAP32[(($next25)>>2)]=$28; //@line 358 "mbrowrap.cpp"
              ;
            }
            else if (__label__ == 13) {
  
              HEAP32[((__ZL21mbr_pending_data_head)>>2)]=$28; //@line 356 "mbrowrap.cpp"
              ; //@line 356 "mbrowrap.cpp"
            }
  
            var $30=$data; //@line 359 "mbrowrap.cpp"
            HEAP32[((__ZL21mbr_pending_data_tail)>>2)]=$30; //@line 359 "mbrowrap.cpp"
            ; //@line 360 "mbrowrap.cpp"
          }
        } while(0);
  
        var $31=$result; //@line 363 "mbrowrap.cpp"
        $retval=$31; //@line 363 "mbrowrap.cpp"
        ; //@line 363 "mbrowrap.cpp"
      }
      else if (__label__ == 1) {
  
        $retval=-1; //@line 329 "mbrowrap.cpp"
        ; //@line 329 "mbrowrap.cpp"
      }
    } while(0);
  
    var $32=$retval; //@line 364 "mbrowrap.cpp"
    ;
    return $32; //@line 364 "mbrowrap.cpp"
    return null;
  }
  

  function __ZL11stop_mbrolav() {
    ;
    var __label__;
  
    var $0=HEAP32[((__ZL9mbr_state)>>2)]; //@line 212 "mbrowrap.cpp"
    var $cmp=((($0))|0)==0; //@line 212 "mbrowrap.cpp"
    if ($cmp) { __label__ = 4;; } else { __label__ = 1;; } //@line 212 "mbrowrap.cpp"
    if (__label__ == 1) {
  
      var $1=HEAP32[((__ZL13mbr_proc_stat)>>2)]; //@line 214 "mbrowrap.cpp"
      var $call=_close($1); //@line 214 "mbrowrap.cpp"
      var $2=HEAP32[((__ZL10mbr_cmd_fd)>>2)]; //@line 215 "mbrowrap.cpp"
      var $call1=_close($2); //@line 215 "mbrowrap.cpp"
      var $3=HEAP32[((__ZL12mbr_audio_fd)>>2)]; //@line 216 "mbrowrap.cpp"
      var $call2=_close($3); //@line 216 "mbrowrap.cpp"
      var $4=HEAP32[((__ZL12mbr_error_fd)>>2)]; //@line 217 "mbrowrap.cpp"
      var $call3=_close($4); //@line 217 "mbrowrap.cpp"
      var $5=HEAP32[((__ZL7mbr_pid)>>2)]; //@line 218 "mbrowrap.cpp"
      var $tobool=((($5))|0)!=0; //@line 218 "mbrowrap.cpp"
      if ($tobool) { __label__ = 2;; } else { __label__ = 3;; } //@line 218 "mbrowrap.cpp"
      if (__label__ == 2) {
  
        var $6=HEAP32[((__ZL7mbr_pid)>>2)]; //@line 219 "mbrowrap.cpp"
        var $call5=_kill($6, 15); //@line 219 "mbrowrap.cpp"
        var $7=HEAP32[((__ZL7mbr_pid)>>2)]; //@line 220 "mbrowrap.cpp"
        var $call6=_waitpid($7, 0, 0); //@line 220 "mbrowrap.cpp"
        HEAP32[((__ZL7mbr_pid)>>2)]=0; //@line 221 "mbrowrap.cpp"
        ; //@line 222 "mbrowrap.cpp"
      }
  
      HEAP32[((__ZL9mbr_state)>>2)]=0; //@line 223 "mbrowrap.cpp"
      ; //@line 224 "mbrowrap.cpp"
    }
  
    ;
    return; //@line 224 "mbrowrap.cpp"
    return;
  }
  

  function __ZL19receive_from_mbrolaPvj($buffer, $bufsize) {
    var __stackBase__  = STACKTOP; STACKTOP += 24; _memset(__stackBase__, 0, 24);
    var __label__;
  
    var $retval;
    var $buffer_addr;
    var $bufsize_addr;
    var $result;
    var $wait;
    var $cursize;
    var $pollfd=__stackBase__;
    var $nfds;
    var $idle;
    var $head;
    var $data;
    var $left;
    var $error;
    var $curpos;
    var $space;
    var $obtained;
    $buffer_addr=$buffer;
    $bufsize_addr=$bufsize;
    $wait=1; //@line 384 "mbrowrap.cpp"
    $cursize=0; //@line 385 "mbrowrap.cpp"
    var $0=HEAP32[((__ZL7mbr_pid)>>2)]; //@line 387 "mbrowrap.cpp"
    var $tobool=((($0))|0)!=0; //@line 387 "mbrowrap.cpp"
    if ($tobool) { __label__ = 1;; } else { __label__ = 2;; } //@line 387 "mbrowrap.cpp"
    $do_body_preheader$$if_then$2: do { 
      if (__label__ == 1) {
  
        var $arrayidx=(($pollfd)&4294967295); //@line 395 "mbrowrap.cpp"
        var $fd=(($arrayidx)&4294967295); //@line 395 "mbrowrap.cpp"
        var $arrayidx1=(($pollfd)&4294967295); //@line 396 "mbrowrap.cpp"
        var $events=(($arrayidx1+4)&4294967295); //@line 396 "mbrowrap.cpp"
        var $arrayidx2=(($pollfd+8)&4294967295); //@line 399 "mbrowrap.cpp"
        var $fd3=(($arrayidx2)&4294967295); //@line 399 "mbrowrap.cpp"
        var $arrayidx4=(($pollfd+8)&4294967295); //@line 400 "mbrowrap.cpp"
        var $events5=(($arrayidx4+4)&4294967295); //@line 400 "mbrowrap.cpp"
        var $arrayidx9=(($pollfd+16)&4294967295); //@line 404 "mbrowrap.cpp"
        var $fd10=(($arrayidx9)&4294967295); //@line 404 "mbrowrap.cpp"
        var $arrayidx11=(($pollfd+16)&4294967295); //@line 405 "mbrowrap.cpp"
        var $events12=(($arrayidx11+4)&4294967295); //@line 405 "mbrowrap.cpp"
        var $arraydecay=(($pollfd)&4294967295); //@line 410 "mbrowrap.cpp"
        var $arrayidx29=(($pollfd+8)&4294967295); //@line 432 "mbrowrap.cpp"
        var $revents=(($arrayidx29+6)&4294967295); //@line 432 "mbrowrap.cpp"
        var $arrayidx37=(($pollfd+16)&4294967295); //@line 435 "mbrowrap.cpp"
        var $revents38=(($arrayidx37+6)&4294967295); //@line 435 "mbrowrap.cpp"
        var $arrayidx66=(($pollfd)&4294967295); //@line 459 "mbrowrap.cpp"
        var $revents67=(($arrayidx66+6)&4294967295); //@line 459 "mbrowrap.cpp"
        ; //@line 391 "mbrowrap.cpp"
        $do_body$4: while(1) { 
  
          $nfds=0; //@line 392 "mbrowrap.cpp"
          var $1=HEAP32[((__ZL12mbr_audio_fd)>>2)]; //@line 395 "mbrowrap.cpp"
          HEAP32[(($fd)>>2)]=$1; //@line 395 "mbrowrap.cpp"
          HEAP16[(($events)>>1)]=1; //@line 396 "mbrowrap.cpp"
          var $2=$nfds; //@line 397 "mbrowrap.cpp"
          var $inc=((($2)+1)&4294967295); //@line 397 "mbrowrap.cpp"
          $nfds=$inc; //@line 397 "mbrowrap.cpp"
          var $3=HEAP32[((__ZL12mbr_error_fd)>>2)]; //@line 399 "mbrowrap.cpp"
          HEAP32[(($fd3)>>2)]=$3; //@line 399 "mbrowrap.cpp"
          HEAP16[(($events5)>>1)]=1; //@line 400 "mbrowrap.cpp"
          var $4=$nfds; //@line 401 "mbrowrap.cpp"
          var $inc6=((($4)+1)&4294967295); //@line 401 "mbrowrap.cpp"
          $nfds=$inc6; //@line 401 "mbrowrap.cpp"
          var $5=HEAP32[((__ZL21mbr_pending_data_head)>>2)]; //@line 403 "mbrowrap.cpp"
          var $tobool7=((($5))|0)!=0; //@line 403 "mbrowrap.cpp"
          if ($tobool7) { __label__ = 4;; } else { __label__ = 5;; } //@line 403 "mbrowrap.cpp"
          if (__label__ == 4) {
  
            var $6=HEAP32[((__ZL10mbr_cmd_fd)>>2)]; //@line 404 "mbrowrap.cpp"
            HEAP32[(($fd10)>>2)]=$6; //@line 404 "mbrowrap.cpp"
            HEAP16[(($events12)>>1)]=2; //@line 405 "mbrowrap.cpp"
            var $7=$nfds; //@line 406 "mbrowrap.cpp"
            var $inc13=((($7)+1)&4294967295); //@line 406 "mbrowrap.cpp"
            $nfds=$inc13; //@line 406 "mbrowrap.cpp"
            ; //@line 407 "mbrowrap.cpp"
          }
  
          var $call=__ZL14mbrola_is_idlev(); //@line 409 "mbrowrap.cpp"
          $idle=$call; //@line 409 "mbrowrap.cpp"
          var $8=$nfds; //@line 410 "mbrowrap.cpp"
          var $9=$idle; //@line 410 "mbrowrap.cpp"
          var $tobool15=((($9))|0)!=0; //@line 410 "mbrowrap.cpp"
          var $10=$wait; //@line 410 "mbrowrap.cpp"
          var $cond=($tobool15) ? 0 : ($10); //@line 410 "mbrowrap.cpp"
          var $call16=_poll($arraydecay, $8, $cond); //@line 410 "mbrowrap.cpp"
          $result=$call16; //@line 410 "mbrowrap.cpp"
          var $cmp=((($call16))|0)==-1; //@line 411 "mbrowrap.cpp"
          if ($cmp) { __label__ = 6;break $do_body$4; } //@line 411 "mbrowrap.cpp"
  
          var $12=$result; //@line 415 "mbrowrap.cpp"
          var $cmp21=((($12))|0)==0; //@line 415 "mbrowrap.cpp"
          if ($cmp21) { __label__ = 8;; } else { __label__ = 13;; } //@line 415 "mbrowrap.cpp"
          $if_then22$$if_end28$10: do { 
            if (__label__ == 8) {
  
              var $13=$idle; //@line 416 "mbrowrap.cpp"
              var $tobool23=((($13))|0)!=0; //@line 416 "mbrowrap.cpp"
              if ($tobool23) { __label__ = 9;break $do_body$4; } //@line 416 "mbrowrap.cpp"
  
              var $14=$wait; //@line 420 "mbrowrap.cpp"
              var $cmp25=((($14))|0) >= 3750; //@line 420 "mbrowrap.cpp"
              if ($cmp25) { __label__ = 11;break $do_body$4; } //@line 420 "mbrowrap.cpp"
  
              var $15=$wait; //@line 425 "mbrowrap.cpp"
              var $mul=((($15)*4)&4294967295); //@line 425 "mbrowrap.cpp"
              $wait=$mul; //@line 425 "mbrowrap.cpp"
              ; //@line 426 "mbrowrap.cpp"
            }
            else if (__label__ == 13) {
  
              $wait=1; //@line 430 "mbrowrap.cpp"
              var $16=HEAP16[(($revents)>>1)]; //@line 432 "mbrowrap.cpp"
              var $tobool30=(tempInt=(($16)),(tempInt>=32768?tempInt-65536:tempInt))!=0; //@line 432 "mbrowrap.cpp"
              if ($tobool30) { __label__ = 14;; } else { __label__ = 16;; } //@line 432 "mbrowrap.cpp"
              if (__label__ == 14) {
  
                var $call31=__ZL17mbrola_has_errorsv(); //@line 432 "mbrowrap.cpp"
                var $tobool32=((($call31))|0)!=0; //@line 432 "mbrowrap.cpp"
                if ($tobool32) { __label__ = 15;break $do_body$4; } //@line 432 "mbrowrap.cpp"
              }
  
              var $17=HEAP32[((__ZL21mbr_pending_data_head)>>2)]; //@line 435 "mbrowrap.cpp"
              var $tobool35=((($17))|0)!=0; //@line 435 "mbrowrap.cpp"
              if ($tobool35) { __label__ = 17;; } else { __label__ = 27;; } //@line 435 "mbrowrap.cpp"
              $land_lhs_true36$$if_end65$18: do { 
                if (__label__ == 17) {
  
                  var $18=HEAP16[(($revents38)>>1)]; //@line 435 "mbrowrap.cpp"
                  var $tobool39=(tempInt=(($18)),(tempInt>=32768?tempInt-65536:tempInt))!=0; //@line 435 "mbrowrap.cpp"
                  if (!($tobool39)) { __label__ = 27;break $land_lhs_true36$$if_end65$18; } //@line 435 "mbrowrap.cpp"
  
                  var $19=HEAP32[((__ZL21mbr_pending_data_head)>>2)]; //@line 436 "mbrowrap.cpp"
                  $head=$19; //@line 436 "mbrowrap.cpp"
                  var $20=$head; //@line 437 "mbrowrap.cpp"
                  var $buffer41=(($20+12)&4294967295); //@line 437 "mbrowrap.cpp"
                  var $arraydecay42=(($buffer41)&4294967295); //@line 437 "mbrowrap.cpp"
                  var $21=$head; //@line 437 "mbrowrap.cpp"
                  var $done=(($21+4)&4294967295); //@line 437 "mbrowrap.cpp"
                  var $22=HEAP32[(($done)>>2)]; //@line 437 "mbrowrap.cpp"
                  var $add_ptr=(($arraydecay42+$22)&4294967295); //@line 437 "mbrowrap.cpp"
                  $data=$add_ptr; //@line 437 "mbrowrap.cpp"
                  var $23=$head; //@line 438 "mbrowrap.cpp"
                  var $size=(($23+8)&4294967295); //@line 438 "mbrowrap.cpp"
                  var $24=HEAP32[(($size)>>2)]; //@line 438 "mbrowrap.cpp"
                  var $25=$head; //@line 438 "mbrowrap.cpp"
                  var $done43=(($25+4)&4294967295); //@line 438 "mbrowrap.cpp"
                  var $26=HEAP32[(($done43)>>2)]; //@line 438 "mbrowrap.cpp"
                  var $sub=((($24)-($26))&4294967295); //@line 438 "mbrowrap.cpp"
                  $left=$sub; //@line 438 "mbrowrap.cpp"
                  var $27=HEAP32[((__ZL10mbr_cmd_fd)>>2)]; //@line 439 "mbrowrap.cpp"
                  var $28=$data; //@line 439 "mbrowrap.cpp"
                  var $29=$left; //@line 439 "mbrowrap.cpp"
                  var $call44=_write($27, $28, $29); //@line 439 "mbrowrap.cpp"
                  $result=$call44; //@line 439 "mbrowrap.cpp"
                  var $30=$result; //@line 440 "mbrowrap.cpp"
                  var $cmp45=((($30))|0)==-1; //@line 440 "mbrowrap.cpp"
                  if ($cmp45) { __label__ = 19;break $do_body$4; } //@line 440 "mbrowrap.cpp"
  
                  var $34=$result; //@line 447 "mbrowrap.cpp"
                  var $35=$left; //@line 447 "mbrowrap.cpp"
                  var $cmp56=((($34))|0)!=((($35))|0); //@line 447 "mbrowrap.cpp"
                  if ($cmp56) { __label__ = 24;; } else { __label__ = 25;; } //@line 447 "mbrowrap.cpp"
                  if (__label__ == 24) {
  
                    var $36=$result; //@line 448 "mbrowrap.cpp"
                    var $37=$head; //@line 448 "mbrowrap.cpp"
                    var $done58=(($37+4)&4294967295); //@line 448 "mbrowrap.cpp"
                    var $38=HEAP32[(($done58)>>2)]; //@line 448 "mbrowrap.cpp"
                    var $add=((($38)+($36))&4294967295); //@line 448 "mbrowrap.cpp"
                    HEAP32[(($done58)>>2)]=$add; //@line 448 "mbrowrap.cpp"
                    ; //@line 449 "mbrowrap.cpp"
                  }
                  else if (__label__ == 25) {
  
                    var $39=$head; //@line 450 "mbrowrap.cpp"
                    var $next=(($39)&4294967295); //@line 450 "mbrowrap.cpp"
                    var $40=HEAP32[(($next)>>2)]; //@line 450 "mbrowrap.cpp"
                    HEAP32[((__ZL21mbr_pending_data_head)>>2)]=$40; //@line 450 "mbrowrap.cpp"
                    var $41=$head; //@line 451 "mbrowrap.cpp"
                    var $42=$41; //@line 451 "mbrowrap.cpp"
                    ; //@line 451 "mbrowrap.cpp"
                    var $43=HEAP32[((__ZL21mbr_pending_data_head)>>2)]; //@line 452 "mbrowrap.cpp"
                    var $tobool60=((($43))|0)!=0; //@line 452 "mbrowrap.cpp"
                    if ($tobool60) { __label__ = 31;break $if_then22$$if_end28$10; } //@line 452 "mbrowrap.cpp"
  
                    HEAP32[((__ZL21mbr_pending_data_tail)>>2)]=0; //@line 453 "mbrowrap.cpp"
                    ;
                  }
                }
              } while(0);
  
              var $44=HEAP16[(($revents67)>>1)]; //@line 459 "mbrowrap.cpp"
              var $tobool68=(tempInt=(($44)),(tempInt>=32768?tempInt-65536:tempInt))!=0; //@line 459 "mbrowrap.cpp"
              if (!($tobool68)) { __label__ = 31;break $if_then22$$if_end28$10; } //@line 459 "mbrowrap.cpp"
  
              var $45=$buffer_addr; //@line 460 "mbrowrap.cpp"
              var $46=$cursize; //@line 460 "mbrowrap.cpp"
              var $add_ptr70=(($45+$46)&4294967295); //@line 460 "mbrowrap.cpp"
              $curpos=$add_ptr70; //@line 460 "mbrowrap.cpp"
              var $47=$bufsize_addr; //@line 461 "mbrowrap.cpp"
              var $48=$cursize; //@line 461 "mbrowrap.cpp"
              var $sub71=((($47)-($48))&4294967295); //@line 461 "mbrowrap.cpp"
              $space=$sub71; //@line 461 "mbrowrap.cpp"
              var $49=HEAP32[((__ZL12mbr_audio_fd)>>2)]; //@line 462 "mbrowrap.cpp"
              var $50=$curpos; //@line 462 "mbrowrap.cpp"
              var $51=$space; //@line 462 "mbrowrap.cpp"
              var $call72=_read($49, $50, $51); //@line 462 "mbrowrap.cpp"
              $obtained=$call72; //@line 462 "mbrowrap.cpp"
              var $52=$obtained; //@line 463 "mbrowrap.cpp"
              var $cmp73=((($52))|0)==-1; //@line 463 "mbrowrap.cpp"
              if ($cmp73) { __label__ = 29;break $do_body$4; } //@line 463 "mbrowrap.cpp"
  
              var $54=$obtained; //@line 467 "mbrowrap.cpp"
              var $55=$cursize; //@line 467 "mbrowrap.cpp"
              var $add78=((($55)+($54))&4294967295); //@line 467 "mbrowrap.cpp"
              $cursize=$add78; //@line 467 "mbrowrap.cpp"
              HEAP32[((__ZL9mbr_state)>>2)]=3; //@line 468 "mbrowrap.cpp"
              ; //@line 469 "mbrowrap.cpp"
            }
          } while(0);
  
          var $56=$cursize; //@line 470 "mbrowrap.cpp"
          var $57=$bufsize_addr; //@line 470 "mbrowrap.cpp"
          var $cmp80=((($56))>>>0) < ((($57))>>>0); //@line 470 "mbrowrap.cpp"
          if ($cmp80) { __label__ = 3;continue $do_body$4; } else { __label__ = 32;break $do_body$4; } //@line 470 "mbrowrap.cpp"
        }
        if (__label__ == 6) {
  
          var $call18=___errno(); //@line 412 "mbrowrap.cpp"
          var $11=HEAP32[(($call18)>>2)]; //@line 412 "mbrowrap.cpp"
          var $call19=_strerror($11); //@line 412 "mbrowrap.cpp"
          __ZL3errPKcz(((__str18598)&4294967295), allocate([$call19,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 412 "mbrowrap.cpp"
          $retval=-1; //@line 413 "mbrowrap.cpp"
          __label__ = 33;break $do_body_preheader$$if_then$2; //@line 413 "mbrowrap.cpp"
        }
        else if (__label__ == 9) {
  
          HEAP32[((__ZL9mbr_state)>>2)]=1; //@line 417 "mbrowrap.cpp"
          ; //@line 418 "mbrowrap.cpp"
        }
        else if (__label__ == 11) {
  
          HEAP32[((__ZL9mbr_state)>>2)]=4; //@line 421 "mbrowrap.cpp"
          __ZL3errPKcz(((__str19599)&4294967295), allocate(1, "i32", ALLOC_STACK)); //@line 422 "mbrowrap.cpp"
          ; //@line 423 "mbrowrap.cpp"
        }
        else if (__label__ == 15) {
  
          $retval=-1; //@line 433 "mbrowrap.cpp"
          __label__ = 33;break $do_body_preheader$$if_then$2; //@line 433 "mbrowrap.cpp"
        }
        else if (__label__ == 19) {
  
          var $call47=___errno(); //@line 441 "mbrowrap.cpp"
          var $31=HEAP32[(($call47)>>2)]; //@line 441 "mbrowrap.cpp"
          $error=$31; //@line 441 "mbrowrap.cpp"
          var $32=$error; //@line 442 "mbrowrap.cpp"
          var $cmp48=((($32))|0)==32; //@line 442 "mbrowrap.cpp"
          if ($cmp48) { __label__ = 20;; } else { __label__ = 22;; } //@line 442 "mbrowrap.cpp"
          $land_lhs_true49$$if_end53$36: do { 
            if (__label__ == 20) {
  
              var $call50=__ZL17mbrola_has_errorsv(); //@line 442 "mbrowrap.cpp"
              var $tobool51=((($call50))|0)!=0; //@line 442 "mbrowrap.cpp"
              if (!($tobool51)) { __label__ = 22;break $land_lhs_true49$$if_end53$36; } //@line 442 "mbrowrap.cpp"
  
              $retval=-1; //@line 443 "mbrowrap.cpp"
              __label__ = 33;break $do_body_preheader$$if_then$2; //@line 443 "mbrowrap.cpp"
            }
          } while(0);
  
          var $33=$error; //@line 444 "mbrowrap.cpp"
          var $call54=_strerror($33); //@line 444 "mbrowrap.cpp"
          __ZL3errPKcz(((__str20600)&4294967295), allocate([$call54,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 444 "mbrowrap.cpp"
          $retval=-1; //@line 445 "mbrowrap.cpp"
          __label__ = 33;break $do_body_preheader$$if_then$2; //@line 445 "mbrowrap.cpp"
        }
        else if (__label__ == 29) {
  
          var $call75=___errno(); //@line 464 "mbrowrap.cpp"
          var $53=HEAP32[(($call75)>>2)]; //@line 464 "mbrowrap.cpp"
          var $call76=_strerror($53); //@line 464 "mbrowrap.cpp"
          __ZL3errPKcz(((__str21601)&4294967295), allocate([$call76,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 464 "mbrowrap.cpp"
          $retval=-1; //@line 465 "mbrowrap.cpp"
          __label__ = 33;break $do_body_preheader$$if_then$2; //@line 465 "mbrowrap.cpp"
        }
  
        var $58=$cursize; //@line 472 "mbrowrap.cpp"
        $retval=$58; //@line 472 "mbrowrap.cpp"
        ; //@line 472 "mbrowrap.cpp"
      }
      else if (__label__ == 2) {
  
        $retval=-1; //@line 388 "mbrowrap.cpp"
        ; //@line 388 "mbrowrap.cpp"
      }
    } while(0);
  
    var $59=$retval; //@line 473 "mbrowrap.cpp"
    STACKTOP = __stackBase__;
    return $59; //@line 473 "mbrowrap.cpp"
    return null;
  }
  

  function __ZL3errPKcz($errmsg) {
    var __stackBase__  = STACKTOP; STACKTOP += 4; _memset(__stackBase__, 0, 4);
    var __label__;
  
    var $errmsg_addr;
    var $params=__stackBase__;
    $errmsg_addr=$errmsg;
    var $params1=$params; //@line 84 "mbrowrap.cpp"
    HEAP32[(($params1)>>2)]=arguments[__ZL3errPKcz.length];; //@line 84 "mbrowrap.cpp"
    var $0=$errmsg_addr; //@line 85 "mbrowrap.cpp"
    var $1=HEAP32[(($params)>>2)]; //@line 85 "mbrowrap.cpp"
    var $call=_vsnprintf(((__ZL12mbr_errorbuf)&4294967295), 160, $0, $1); //@line 85 "mbrowrap.cpp"
    var $params2=$params; //@line 86 "mbrowrap.cpp"
    ; //@line 86 "mbrowrap.cpp"
    __ZL3logPKcz(((__str16596)&4294967295), allocate([((__ZL12mbr_errorbuf)&4294967295),0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 87 "mbrowrap.cpp"
    STACKTOP = __stackBase__;
    return; //@line 88 "mbrowrap.cpp"
    return;
  }
  

  function _close_MBR() {
    ;
    var __label__;
  
    __ZL11stop_mbrolav(); //@line 525 "mbrowrap.cpp"
    __ZL17free_pending_datav(); //@line 526 "mbrowrap.cpp"
    var $0=HEAP32[((__ZL14mbr_voice_path)>>2)]; //@line 527 "mbrowrap.cpp"
    ; //@line 527 "mbrowrap.cpp"
    HEAP32[((__ZL14mbr_voice_path)>>2)]=0; //@line 528 "mbrowrap.cpp"
    HEAPF32[((__ZL10mbr_volume)>>2)]=1; //@line 529 "mbrowrap.cpp"
    ;
    return; //@line 530 "mbrowrap.cpp"
    return;
  }
  

  function __ZL17free_pending_datav() {
    ;
    var __label__;
  
    var $p;
    var $head;
    var $0=HEAP32[((__ZL21mbr_pending_data_head)>>2)]; //@line 228 "mbrowrap.cpp"
    $head=$0; //@line 228 "mbrowrap.cpp"
    var $tobool1=((($0))|0)!=0; //@line 229 "mbrowrap.cpp"
    if ($tobool1) { __label__ = 1;; } else { __label__ = 2;; } //@line 229 "mbrowrap.cpp"
    $while_body$$while_end$2: do { 
      if (__label__ == 1) {
        while(1) { 
  
          var $1=$head; //@line 230 "mbrowrap.cpp"
          $p=$1; //@line 230 "mbrowrap.cpp"
          var $2=$head; //@line 231 "mbrowrap.cpp"
          var $next=(($2)&4294967295); //@line 231 "mbrowrap.cpp"
          var $3=HEAP32[(($next)>>2)]; //@line 231 "mbrowrap.cpp"
          $head=$3; //@line 231 "mbrowrap.cpp"
          var $4=$p; //@line 232 "mbrowrap.cpp"
          var $5=$4; //@line 232 "mbrowrap.cpp"
          ; //@line 232 "mbrowrap.cpp"
          var $_pr=$head; //@line 229 "mbrowrap.cpp"
          var $tobool=((($_pr))|0)!=0; //@line 229 "mbrowrap.cpp"
          if ($tobool) { __label__ = 1;continue ; } else { __label__ = 2;break $while_body$$while_end$2; } //@line 229 "mbrowrap.cpp"
        }
      }
    } while(0);
  
    HEAP32[((__ZL21mbr_pending_data_head)>>2)]=0; //@line 234 "mbrowrap.cpp"
    HEAP32[((__ZL21mbr_pending_data_tail)>>2)]=0; //@line 235 "mbrowrap.cpp"
    ;
    return; //@line 236 "mbrowrap.cpp"
    return;
  }
  

  function _reset_MBR() {
    var __stackBase__  = STACKTOP; STACKTOP += 4096; _memset(__stackBase__, 0, 4096);
    var __label__;
  
    var $retval;
    var $result;
    var $success;
    var $dummybuf=__stackBase__;
    $success=1; //@line 534 "mbrowrap.cpp"
    var $0=HEAP32[((__ZL9mbr_state)>>2)]; //@line 537 "mbrowrap.cpp"
    var $cmp=((($0))|0)==1; //@line 537 "mbrowrap.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 537 "mbrowrap.cpp"
    if (__label__ == 1) {
  
      $retval=1; //@line 538 "mbrowrap.cpp"
      ; //@line 538 "mbrowrap.cpp"
    }
    else if (__label__ == 2) {
  
      var $1=HEAP32[((__ZL7mbr_pid)>>2)]; //@line 539 "mbrowrap.cpp"
      var $tobool=((($1))|0)!=0; //@line 539 "mbrowrap.cpp"
      if ($tobool) { __label__ = 4;; } else { __label__ = 3;; } //@line 539 "mbrowrap.cpp"
      if (__label__ == 4) {
  
        var $2=HEAP32[((__ZL7mbr_pid)>>2)]; //@line 541 "mbrowrap.cpp"
        var $call=_kill($2, 30); //@line 541 "mbrowrap.cpp"
        var $cmp3=((($call))|0)==-1; //@line 541 "mbrowrap.cpp"
        if ($cmp3) { __label__ = 5;; } else { __label__ = 6;; } //@line 541 "mbrowrap.cpp"
        if (__label__ == 5) {
  
          $success=0; //@line 542 "mbrowrap.cpp"
          ; //@line 542 "mbrowrap.cpp"
        }
  
        __ZL17free_pending_datav(); //@line 543 "mbrowrap.cpp"
        var $3=HEAP32[((__ZL10mbr_cmd_fd)>>2)]; //@line 544 "mbrowrap.cpp"
        var $call6=_write($3, ((__str5585)&4294967295), 3); //@line 544 "mbrowrap.cpp"
        $result=$call6; //@line 544 "mbrowrap.cpp"
        var $cmp7=((($call6))|0)!=3; //@line 545 "mbrowrap.cpp"
        if ($cmp7) { __label__ = 7;; } else { __label__ = 8;; } //@line 545 "mbrowrap.cpp"
        if (__label__ == 7) {
  
          $success=0; //@line 546 "mbrowrap.cpp"
          ; //@line 546 "mbrowrap.cpp"
        }
  
        var $arraydecay=(($dummybuf)&4294967295); //@line 548 "mbrowrap.cpp"
        ; //@line 548 "mbrowrap.cpp"
        $do_body$13: while(1) { 
  
          var $4=HEAP32[((__ZL12mbr_audio_fd)>>2)]; //@line 548 "mbrowrap.cpp"
          var $call10=_read($4, $arraydecay, 4096); //@line 548 "mbrowrap.cpp"
          $result=$call10; //@line 548 "mbrowrap.cpp"
          var $cmp11=((($call10))|0) > 0; //@line 549 "mbrowrap.cpp"
          if ($cmp11) { __label__ = 9;continue $do_body$13; } else { __label__ = 10;break $do_body$13; } //@line 549 "mbrowrap.cpp"
        }
  
        var $5=$result; //@line 550 "mbrowrap.cpp"
        var $cmp12=((($5))|0)!=-1; //@line 550 "mbrowrap.cpp"
        if ($cmp12) { __label__ = 12;; } else { __label__ = 11;; } //@line 550 "mbrowrap.cpp"
        $if_then15$$lor_lhs_false$16: do { 
          if (__label__ == 11) {
  
            var $call13=___errno(); //@line 550 "mbrowrap.cpp"
            var $6=HEAP32[(($call13)>>2)]; //@line 550 "mbrowrap.cpp"
            var $cmp14=((($6))|0)!=11; //@line 550 "mbrowrap.cpp"
            if ($cmp14) { __label__ = 12;break $if_then15$$lor_lhs_false$16; } else { __label__ = 13;break $if_then15$$lor_lhs_false$16; } //@line 550 "mbrowrap.cpp"
          }
        } while(0);
        if (__label__ == 12) {
  
          $success=0; //@line 551 "mbrowrap.cpp"
          ; //@line 551 "mbrowrap.cpp"
        }
  
        var $call17=__ZL17mbrola_has_errorsv(); //@line 552 "mbrowrap.cpp"
        var $tobool18=((($call17))|0)!=0; //@line 552 "mbrowrap.cpp"
        if ($tobool18) { __label__ = 16;; } else { __label__ = 14;; } //@line 552 "mbrowrap.cpp"
        $if_end21$$land_lhs_true$21: do { 
          if (__label__ == 14) {
  
            var $7=$success; //@line 552 "mbrowrap.cpp"
            var $tobool19=((($7))|0)!=0; //@line 552 "mbrowrap.cpp"
            if (!($tobool19)) { __label__ = 16;break $if_end21$$land_lhs_true$21; } //@line 552 "mbrowrap.cpp"
  
            HEAP32[((__ZL9mbr_state)>>2)]=1; //@line 553 "mbrowrap.cpp"
            ; //@line 553 "mbrowrap.cpp"
          }
        } while(0);
  
        var $8=$success; //@line 554 "mbrowrap.cpp"
        $retval=$8; //@line 554 "mbrowrap.cpp"
        ; //@line 554 "mbrowrap.cpp"
      }
      else if (__label__ == 3) {
  
        $retval=0; //@line 540 "mbrowrap.cpp"
        ; //@line 540 "mbrowrap.cpp"
      }
    }
  
    var $9=$retval; //@line 555 "mbrowrap.cpp"
    STACKTOP = __stackBase__;
    return $9; //@line 555 "mbrowrap.cpp"
    return null;
  }
  

  function __ZL17mbrola_has_errorsv() {
    var __stackBase__  = STACKTOP; STACKTOP += 256; _memset(__stackBase__, 0, 256);
    var __label__;
  
    var $retval;
    var $result;
    var $buffer=__stackBase__;
    var $buf_ptr;
    var $lf;
    var $arraydecay=(($buffer)&4294967295); //@line 284 "mbrowrap.cpp"
    $buf_ptr=$arraydecay; //@line 284 "mbrowrap.cpp"
    var $arraydecay1=(($buffer)&4294967295); //@line 286 "mbrowrap.cpp"
    var $sub_ptr_rhs_cast=($arraydecay1); //@line 286 "mbrowrap.cpp"
    var $sub_ptr_rhs_cast_neg=(((-($sub_ptr_rhs_cast)))&4294967295);
    var $sub_ptr_rhs_cast_neg_neg=(((-($sub_ptr_rhs_cast_neg)))&4294967295);
    var $sub=((($sub_ptr_rhs_cast_neg_neg)+255)&4294967295); //@line 286 "mbrowrap.cpp"
    var $arraydecay27=(($buffer)&4294967295); //@line 318 "mbrowrap.cpp"
    var $arraydecay28=(($buffer)&4294967295); //@line 319 "mbrowrap.cpp"
    ; //@line 285 "mbrowrap.cpp"
    $for_cond$2: while(1) { 
  
      var $0=HEAP32[((__ZL12mbr_error_fd)>>2)]; //@line 286 "mbrowrap.cpp"
      var $1=$buf_ptr; //@line 286 "mbrowrap.cpp"
      var $2=$buf_ptr; //@line 286 "mbrowrap.cpp"
      var $sub_ptr_lhs_cast=($2); //@line 286 "mbrowrap.cpp"
      var $sub_ptr_lhs_cast_neg=(((-($sub_ptr_lhs_cast)))&4294967295);
      var $sub2=((($sub)+($sub_ptr_lhs_cast_neg))&4294967295); //@line 286 "mbrowrap.cpp"
      var $call=_read($0, $1, $sub2); //@line 286 "mbrowrap.cpp"
      $result=$call; //@line 286 "mbrowrap.cpp"
      var $cmp=((($call))|0)==-1; //@line 288 "mbrowrap.cpp"
      if ($cmp) { __label__ = 2;break $for_cond$2; } //@line 288 "mbrowrap.cpp"
  
      var $5=$result; //@line 295 "mbrowrap.cpp"
      var $cmp9=((($5))|0)==0; //@line 295 "mbrowrap.cpp"
      if ($cmp9) { __label__ = 6;break $for_cond$2; } //@line 295 "mbrowrap.cpp"
  
      var $6=$result; //@line 300 "mbrowrap.cpp"
      var $7=$buf_ptr; //@line 300 "mbrowrap.cpp"
      var $arrayidx=(($7+$6)&4294967295); //@line 300 "mbrowrap.cpp"
      HEAP8[($arrayidx)]=0; //@line 300 "mbrowrap.cpp"
      ; //@line 302 "mbrowrap.cpp"
      $for_cond13$6: while(1) { 
  
        var $8=$buf_ptr; //@line 302 "mbrowrap.cpp"
        var $call14=_strchr($8, 10); //@line 302 "mbrowrap.cpp"
        $lf=$call14; //@line 302 "mbrowrap.cpp"
        var $tobool=((($call14))|0)!=0; //@line 302 "mbrowrap.cpp"
        var $9=$buf_ptr; //@line 304 "mbrowrap.cpp"
        if (!($tobool)) { __label__ = 14;break $for_cond13$6; } //@line 302 "mbrowrap.cpp"
  
        var $call15=_strncmp($9, ((__str8588)&4294967295), 18); //@line 304 "mbrowrap.cpp"
        var $cmp16=((($call15))|0)==0; //@line 304 "mbrowrap.cpp"
        if ($cmp16) { __label__ = 13;; } else { __label__ = 10;; } //@line 304 "mbrowrap.cpp"
        $for_inc$$lor_lhs_false$9: do { 
          if (__label__ == 10) {
  
            var $10=$buf_ptr; //@line 305 "mbrowrap.cpp"
            var $call17=_strncmp($10, ((__str9589)&4294967295), 18); //@line 305 "mbrowrap.cpp"
            var $cmp18=((($call17))|0)==0; //@line 305 "mbrowrap.cpp"
            if ($cmp18) { __label__ = 13;break $for_inc$$lor_lhs_false$9; } //@line 305 "mbrowrap.cpp"
  
            var $11=$lf; //@line 307 "mbrowrap.cpp"
            HEAP8[($11)]=0; //@line 307 "mbrowrap.cpp"
            var $12=$buf_ptr; //@line 308 "mbrowrap.cpp"
            __ZL3logPKcz(((__str10590)&4294967295), allocate([$12,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 308 "mbrowrap.cpp"
            var $13=$lf; //@line 310 "mbrowrap.cpp"
            var $14=$result; //@line 310 "mbrowrap.cpp"
            var $sub21=((($14)-1)&4294967295); //@line 310 "mbrowrap.cpp"
            var $15=$buf_ptr; //@line 310 "mbrowrap.cpp"
            var $arrayidx22=(($15+$sub21)&4294967295); //@line 310 "mbrowrap.cpp"
            var $cmp23=((($13))|0)==((($arrayidx22))|0); //@line 310 "mbrowrap.cpp"
            if ($cmp23) { __label__ = 12;break $for_cond$2; } //@line 310 "mbrowrap.cpp"
          }
        } while(0);
  
        var $17=$lf; //@line 302 "mbrowrap.cpp"
        var $add_ptr=(($17+1)&4294967295); //@line 302 "mbrowrap.cpp"
        $buf_ptr=$add_ptr; //@line 302 "mbrowrap.cpp"
        __label__ = 8;continue $for_cond13$6; //@line 302 "mbrowrap.cpp"
      }
  
      var $18=$result; //@line 318 "mbrowrap.cpp"
      _llvm_memmove_p0i8_p0i8_i32($arraydecay27, $9, $18, 1, 0); //@line 318 "mbrowrap.cpp"
      var $19=$result; //@line 319 "mbrowrap.cpp"
      var $add_ptr29=(($arraydecay28+$19)&4294967295); //@line 319 "mbrowrap.cpp"
      $buf_ptr=$add_ptr29; //@line 319 "mbrowrap.cpp"
      __label__ = 1;continue $for_cond$2; //@line 320 "mbrowrap.cpp"
    }
    if (__label__ == 2) {
  
      var $call3=___errno(); //@line 289 "mbrowrap.cpp"
      var $3=HEAP32[(($call3)>>2)]; //@line 289 "mbrowrap.cpp"
      var $cmp4=((($3))|0)==11; //@line 289 "mbrowrap.cpp"
      if ($cmp4) { __label__ = 3;; } else { __label__ = 4;; } //@line 289 "mbrowrap.cpp"
      if (__label__ == 3) {
  
        $retval=0; //@line 290 "mbrowrap.cpp"
        ; //@line 290 "mbrowrap.cpp"
      }
      else if (__label__ == 4) {
  
        var $call6=___errno(); //@line 291 "mbrowrap.cpp"
        var $4=HEAP32[(($call6)>>2)]; //@line 291 "mbrowrap.cpp"
        var $call7=_strerror($4); //@line 291 "mbrowrap.cpp"
        __ZL3errPKcz(((__str7587)&4294967295), allocate([$call7,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 291 "mbrowrap.cpp"
        $retval=-1; //@line 292 "mbrowrap.cpp"
        ; //@line 292 "mbrowrap.cpp"
      }
    }
    else if (__label__ == 6) {
  
      __ZL11mbrola_diedv(); //@line 297 "mbrowrap.cpp"
      $retval=-1; //@line 297 "mbrowrap.cpp"
      ; //@line 297 "mbrowrap.cpp"
    }
    else if (__label__ == 12) {
  
      var $16=$buf_ptr; //@line 311 "mbrowrap.cpp"
      var $call25=_snprintf(((__ZL12mbr_errorbuf)&4294967295), 160, ((__str57709)&4294967295), allocate([$16,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 311 "mbrowrap.cpp"
      $retval=0; //@line 314 "mbrowrap.cpp"
      ; //@line 314 "mbrowrap.cpp"
    }
  
    var $20=$retval; //@line 321 "mbrowrap.cpp"
    STACKTOP = __stackBase__;
    return $20; //@line 321 "mbrowrap.cpp"
    return null;
  }
  

  function _read_MBR($buffer, $nb_samples) {
    ;
    var __label__;
  
    var $buffer_addr;
    var $nb_samples_addr;
    var $result;
    $buffer_addr=$buffer;
    $nb_samples_addr=$nb_samples;
    var $0=$buffer_addr; //@line 559 "mbrowrap.cpp"
    var $1=$nb_samples_addr; //@line 559 "mbrowrap.cpp"
    var $mul=((($1)*2)&4294967295); //@line 559 "mbrowrap.cpp"
    var $call=__ZL19receive_from_mbrolaPvj($0, $mul); //@line 559 "mbrowrap.cpp"
    $result=$call; //@line 559 "mbrowrap.cpp"
    var $2=$result; //@line 560 "mbrowrap.cpp"
    var $cmp=((($2))|0) > 0; //@line 560 "mbrowrap.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 560 "mbrowrap.cpp"
    if (__label__ == 1) {
  
      var $3=$result; //@line 561 "mbrowrap.cpp"
      var $div=((((($3))|0)/2)|0); //@line 561 "mbrowrap.cpp"
      $result=$div; //@line 561 "mbrowrap.cpp"
      ; //@line 561 "mbrowrap.cpp"
    }
  
    var $4=$result; //@line 562 "mbrowrap.cpp"
    ;
    return $4; //@line 562 "mbrowrap.cpp"
    return null;
  }
  

  function _write_MBR($data) {
    ;
    var __label__;
  
    var $data_addr;
    $data_addr=$data;
    HEAP32[((__ZL9mbr_state)>>2)]=2; //@line 567 "mbrowrap.cpp"
    var $0=$data_addr; //@line 568 "mbrowrap.cpp"
    var $call=__ZL14send_to_mbrolaPKc($0); //@line 568 "mbrowrap.cpp"
    ;
    return $call; //@line 568 "mbrowrap.cpp"
    return null;
  }
  

  function _flush_MBR() {
    ;
    var __label__;
  
    var $call=__ZL14send_to_mbrolaPKc(((__str5585)&4294967295)); //@line 573 "mbrowrap.cpp"
    var $cmp=((($call))|0)==3; //@line 573 "mbrowrap.cpp"
    var $conv=((($cmp))&1); //@line 573 "mbrowrap.cpp"
    ;
    return $conv; //@line 573 "mbrowrap.cpp"
    return null;
  }
  

  function _getFreq_MBR() {
    ;
    var __label__;
  
    var $0=HEAP32[((__ZL14mbr_samplerate)>>2)]; //@line 578 "mbrowrap.cpp"
    ;
    return $0; //@line 578 "mbrowrap.cpp"
    return null;
  }
  

  function _setVolumeRatio_MBR($value) {
    ;
    var __label__;
  
    var $value_addr;
    $value_addr=$value;
    var $0=$value_addr; //@line 583 "mbrowrap.cpp"
    var $1=HEAPF32[((__ZL10mbr_volume)>>2)]; //@line 583 "mbrowrap.cpp"
    var $cmp=($0) == ($1); //@line 583 "mbrowrap.cpp"
    if ($cmp) { __label__ = 3;; } else { __label__ = 1;; } //@line 583 "mbrowrap.cpp"
    $return$$if_end$2: do { 
      if (__label__ == 1) {
  
        var $2=$value_addr; //@line 585 "mbrowrap.cpp"
        HEAPF32[((__ZL10mbr_volume)>>2)]=$2; //@line 585 "mbrowrap.cpp"
        var $3=HEAP32[((__ZL9mbr_state)>>2)]; //@line 586 "mbrowrap.cpp"
        var $cmp1=((($3))|0)!=1; //@line 586 "mbrowrap.cpp"
        if ($cmp1) { __label__ = 3;break $return$$if_end$2; } //@line 586 "mbrowrap.cpp"
  
        __ZL11stop_mbrolav(); //@line 592 "mbrowrap.cpp"
        var $4=HEAP32[((__ZL14mbr_voice_path)>>2)]; //@line 593 "mbrowrap.cpp"
        var $call=_init_MBR($4); //@line 593 "mbrowrap.cpp"
        ; //@line 594 "mbrowrap.cpp"
      }
    } while(0);
  
    ;
    return; //@line 594 "mbrowrap.cpp"
    return;
  }
  

  function _lastErrorStr_MBR($buffer, $bufsize) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $buffer_addr;
    var $bufsize_addr;
    var $result;
    $buffer_addr=$buffer;
    $bufsize_addr=$bufsize;
    var $0=HEAP32[((__ZL7mbr_pid)>>2)]; //@line 599 "mbrowrap.cpp"
    var $tobool=((($0))|0)!=0; //@line 599 "mbrowrap.cpp"
    if ($tobool) { __label__ = 1;; } else { __label__ = 2;; } //@line 599 "mbrowrap.cpp"
    if (__label__ == 1) {
  
      var $call=__ZL17mbrola_has_errorsv(); //@line 600 "mbrowrap.cpp"
      ; //@line 600 "mbrowrap.cpp"
    }
  
    var $1=$buffer_addr; //@line 601 "mbrowrap.cpp"
    var $2=$bufsize_addr; //@line 601 "mbrowrap.cpp"
    var $call1=_snprintf($1, $2, ((__str57709)&4294967295), allocate([((__ZL12mbr_errorbuf)&4294967295),0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 601 "mbrowrap.cpp"
    $result=$call1; //@line 601 "mbrowrap.cpp"
    var $3=$result; //@line 602 "mbrowrap.cpp"
    var $4=$bufsize_addr; //@line 602 "mbrowrap.cpp"
    var $cmp=((($3))|0) >= ((($4))|0); //@line 602 "mbrowrap.cpp"
    if ($cmp) { __label__ = 3;; } else { __label__ = 4;; } //@line 602 "mbrowrap.cpp"
    if (__label__ == 3) {
  
      var $5=$bufsize_addr; //@line 602 "mbrowrap.cpp"
      var $sub=((($5)-1)&4294967295); //@line 602 "mbrowrap.cpp"
      __lastLabel__ = 3; ; //@line 602 "mbrowrap.cpp"
    }
    else if (__label__ == 4) {
  
      var $6=$result; //@line 602 "mbrowrap.cpp"
      __lastLabel__ = 4; ; //@line 602 "mbrowrap.cpp"
    }
  
    var $cond=__lastLabel__ == 3 ? $sub : ($6); //@line 602 "mbrowrap.cpp"
    ;
    return $cond; //@line 602 "mbrowrap.cpp"
    return null;
  }
  

  function _resetError_MBR() {
    ;
    var __label__;
  
    HEAP8[(((__ZL12mbr_errorbuf)&4294967295))]=0; //@line 607 "mbrowrap.cpp"
    ;
    return; //@line 608 "mbrowrap.cpp"
    return;
  }
  

  function __ZL11mbrola_diedv() {
    var __stackBase__  = STACKTOP; STACKTOP += 84; _memset(__stackBase__, 0, 84);
    var __label__;
  
    var $pid;
    var $status=__stackBase__;
    var $len;
    var $msg;
    var $msgbuf=__stackBase__+4;
    var $sig;
    var $exst;
    var $0=HEAP32[((__ZL7mbr_pid)>>2)]; //@line 245 "mbrowrap.cpp"
    var $call=_waitpid($0, $status, 1); //@line 245 "mbrowrap.cpp"
    $pid=$call; //@line 245 "mbrowrap.cpp"
    var $1=$pid; //@line 246 "mbrowrap.cpp"
    var $tobool=((($1))|0)!=0; //@line 246 "mbrowrap.cpp"
    if ($tobool) { __label__ = 2;; } else { __label__ = 1;; } //@line 246 "mbrowrap.cpp"
    $if_else$$if_then$2: do { 
      if (__label__ == 2) {
  
        var $2=$pid; //@line 248 "mbrowrap.cpp"
        var $3=HEAP32[((__ZL7mbr_pid)>>2)]; //@line 248 "mbrowrap.cpp"
        var $cmp=((($2))|0)!=((($3))|0); //@line 248 "mbrowrap.cpp"
        if ($cmp) { __label__ = 3;; } else { __label__ = 4;; } //@line 248 "mbrowrap.cpp"
        if (__label__ == 3) {
  
          $msg=((__str12592)&4294967295); //@line 249 "mbrowrap.cpp"
          ; //@line 250 "mbrowrap.cpp"
        }
        else if (__label__ == 4) {
  
          HEAP32[((__ZL7mbr_pid)>>2)]=0; //@line 251 "mbrowrap.cpp"
          var $4=HEAP32[(($status)>>2)]; //@line 252 "mbrowrap.cpp"
          var $and=($4) & 127; //@line 252 "mbrowrap.cpp"
          var $cmp3=((($and))|0) > 0; //@line 252 "mbrowrap.cpp"
          if ($cmp3) { __label__ = 5;; } else { __label__ = 7;; } //@line 252 "mbrowrap.cpp"
          $land_lhs_true$$if_else10$7: do { 
            if (__label__ == 5) {
  
              var $5=HEAP32[(($status)>>2)]; //@line 252 "mbrowrap.cpp"
              var $and4=($5) & 127; //@line 252 "mbrowrap.cpp"
              var $cmp5=((($and4))|0) < 127; //@line 252 "mbrowrap.cpp"
              if (!($cmp5)) { __label__ = 7;break $land_lhs_true$$if_else10$7; } //@line 252 "mbrowrap.cpp"
  
              var $6=HEAP32[(($status)>>2)]; //@line 253 "mbrowrap.cpp"
              var $and7=($6) & 127; //@line 253 "mbrowrap.cpp"
              $sig=$and7; //@line 253 "mbrowrap.cpp"
              var $arraydecay=(($msgbuf)&4294967295); //@line 254 "mbrowrap.cpp"
              var $7=$sig; //@line 254 "mbrowrap.cpp"
              var $call8=_snprintf($arraydecay, 80, ((__str13593)&4294967295), allocate([$7,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 254 "mbrowrap.cpp"
              var $arraydecay9=(($msgbuf)&4294967295); //@line 256 "mbrowrap.cpp"
              $msg=$arraydecay9; //@line 256 "mbrowrap.cpp"
              __label__ = 10;break $if_else$$if_then$2; //@line 257 "mbrowrap.cpp"
            }
          } while(0);
  
          var $8=HEAP32[(($status)>>2)]; //@line 257 "mbrowrap.cpp"
          var $and11=($8) & 255; //@line 257 "mbrowrap.cpp"
          var $cmp12=((($and11))|0)==0; //@line 257 "mbrowrap.cpp"
          if ($cmp12) { __label__ = 8;; } else { __label__ = 9;; } //@line 257 "mbrowrap.cpp"
          if (__label__ == 8) {
  
            var $9=HEAP32[(($status)>>2)]; //@line 258 "mbrowrap.cpp"
            var $shr=($9) >> 8; //@line 258 "mbrowrap.cpp"
            var $and14=($shr) & 255; //@line 258 "mbrowrap.cpp"
            $exst=$and14; //@line 258 "mbrowrap.cpp"
            var $arraydecay15=(($msgbuf)&4294967295); //@line 259 "mbrowrap.cpp"
            var $10=$exst; //@line 259 "mbrowrap.cpp"
            var $call16=_snprintf($arraydecay15, 80, ((__str14594)&4294967295), allocate([$10,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 259 "mbrowrap.cpp"
            var $arraydecay17=(($msgbuf)&4294967295); //@line 261 "mbrowrap.cpp"
            $msg=$arraydecay17; //@line 261 "mbrowrap.cpp"
            ; //@line 262 "mbrowrap.cpp"
          }
          else if (__label__ == 9) {
  
            $msg=((__str15595)&4294967295); //@line 263 "mbrowrap.cpp"
            ;
          }
        }
      }
      else if (__label__ == 1) {
  
        $msg=((__str11591)&4294967295); //@line 247 "mbrowrap.cpp"
        ; //@line 248 "mbrowrap.cpp"
      }
    } while(0);
  
    var $11=$msg; //@line 267 "mbrowrap.cpp"
    __ZL3logPKcz(((__str16596)&4294967295), allocate([$11,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 267 "mbrowrap.cpp"
    var $call22=_strlen(((__ZL12mbr_errorbuf)&4294967295)); //@line 269 "mbrowrap.cpp"
    $len=$call22; //@line 269 "mbrowrap.cpp"
    var $tobool23=((($call22))|0)!=0; //@line 270 "mbrowrap.cpp"
    if ($tobool23) { __label__ = 12;; } else { __label__ = 11;; } //@line 270 "mbrowrap.cpp"
    if (__label__ == 12) {
  
      var $13=$len; //@line 273 "mbrowrap.cpp"
      var $add_ptr=((((__ZL12mbr_errorbuf)&4294967295)+$13)&4294967295); //@line 273 "mbrowrap.cpp"
      var $14=$len; //@line 273 "mbrowrap.cpp"
      var $sub=((160-($14))&4294967295); //@line 273 "mbrowrap.cpp"
      var $15=$msg; //@line 273 "mbrowrap.cpp"
      var $call27=_snprintf($add_ptr, $sub, ((__str17597)&4294967295), allocate([$15,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 273 "mbrowrap.cpp"
      ;
    }
    else if (__label__ == 11) {
  
      var $12=$msg; //@line 271 "mbrowrap.cpp"
      var $call25=_snprintf(((__ZL12mbr_errorbuf)&4294967295), 160, ((__str57709)&4294967295), allocate([$12,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 271 "mbrowrap.cpp"
      ; //@line 271 "mbrowrap.cpp"
    }
  
    STACKTOP = __stackBase__;
    return;
    return;
  }
  

  function __ZL3logPKcz($msg) {
    var __stackBase__  = STACKTOP; STACKTOP += 4; _memset(__stackBase__, 0, 4);
    var __label__;
  
    var $msg_addr;
    var $params=__stackBase__;
    $msg_addr=$msg;
    var $params1=$params; //@line 74 "mbrowrap.cpp"
    HEAP32[(($params1)>>2)]=arguments[__ZL3logPKcz.length];; //@line 74 "mbrowrap.cpp"
    var $0=HEAP32[((__impure_ptr)>>2)]; //@line 75 "mbrowrap.cpp"
    var $_stderr=(($0+12)&4294967295); //@line 75 "mbrowrap.cpp"
    var $1=HEAP32[(($_stderr)>>2)]; //@line 75 "mbrowrap.cpp"
    var $2=$msg_addr; //@line 75 "mbrowrap.cpp"
    var $3=HEAP32[(($params)>>2)]; //@line 75 "mbrowrap.cpp"
    var $call=_vfprintf($1, $2, $3); //@line 75 "mbrowrap.cpp"
    var $4=HEAP32[((__impure_ptr)>>2)]; //@line 76 "mbrowrap.cpp"
    var $_stderr2=(($4+12)&4294967295); //@line 76 "mbrowrap.cpp"
    var $5=HEAP32[(($_stderr2)>>2)]; //@line 76 "mbrowrap.cpp"
    var $call3=_fputc(10, $5); //@line 76 "mbrowrap.cpp"
    var $params4=$params; //@line 77 "mbrowrap.cpp"
    ; //@line 77 "mbrowrap.cpp"
    STACKTOP = __stackBase__;
    return; //@line 78 "mbrowrap.cpp"
    return;
  }
  

  function __ZL14mbrola_is_idlev() {
    var __stackBase__  = STACKTOP; STACKTOP += 20; _memset(__stackBase__, 0, 20);
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $p;
    var $buffer=__stackBase__;
    var $0=HEAP32[((__ZL13mbr_proc_stat)>>2)]; //@line 372 "mbrowrap.cpp"
    var $call=_lseek($0, 0, 0); //@line 372 "mbrowrap.cpp"
    var $cmp=((($call))|0)!=0; //@line 372 "mbrowrap.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 372 "mbrowrap.cpp"
    $if_then$$if_end$2: do { 
      if (__label__ == 1) {
  
        $retval=0; //@line 373 "mbrowrap.cpp"
        ; //@line 373 "mbrowrap.cpp"
      }
      else if (__label__ == 2) {
  
        var $1=HEAP32[((__ZL13mbr_proc_stat)>>2)]; //@line 374 "mbrowrap.cpp"
        var $arraydecay=(($buffer)&4294967295); //@line 374 "mbrowrap.cpp"
        var $call1=_read($1, $arraydecay, 20); //@line 374 "mbrowrap.cpp"
        var $cmp2=((($call1))|0)!=20; //@line 374 "mbrowrap.cpp"
        if ($cmp2) { __label__ = 3;; } else { __label__ = 4;; } //@line 374 "mbrowrap.cpp"
        if (__label__ == 3) {
  
          $retval=0; //@line 375 "mbrowrap.cpp"
          ; //@line 375 "mbrowrap.cpp"
        }
        else if (__label__ == 4) {
  
          var $arraydecay5=(($buffer)&4294967295); //@line 376 "mbrowrap.cpp"
          var $call6=_memchr($arraydecay5, 41, 20); //@line 376 "mbrowrap.cpp"
          $p=$call6; //@line 376 "mbrowrap.cpp"
          var $2=$p; //@line 377 "mbrowrap.cpp"
          var $tobool=((($2))|0)!=0; //@line 377 "mbrowrap.cpp"
          if ($tobool) { __label__ = 5;; } else { __label__ = 6;; } //@line 377 "mbrowrap.cpp"
          $lor_lhs_false$$if_then9$8: do { 
            if (__label__ == 5) {
  
              var $3=$p; //@line 377 "mbrowrap.cpp"
              var $arraydecay7=(($buffer)&4294967295); //@line 377 "mbrowrap.cpp"
              var $sub_ptr_lhs_cast=($3); //@line 377 "mbrowrap.cpp"
              var $sub_ptr_rhs_cast=($arraydecay7); //@line 377 "mbrowrap.cpp"
              var $sub_ptr_sub=((($sub_ptr_lhs_cast)-($sub_ptr_rhs_cast))&4294967295); //@line 377 "mbrowrap.cpp"
              var $cmp8=((($sub_ptr_sub))>>>0) >= 18; //@line 377 "mbrowrap.cpp"
              if ($cmp8) { __label__ = 6;break $lor_lhs_false$$if_then9$8; } //@line 377 "mbrowrap.cpp"
  
              var $4=$p; //@line 379 "mbrowrap.cpp"
              var $arrayidx=(($4+1)&4294967295); //@line 379 "mbrowrap.cpp"
              var $5=HEAP8[($arrayidx)]; //@line 379 "mbrowrap.cpp"
              var $conv=(tempInt=(($5)),(tempInt>=128?tempInt-256:tempInt)); //@line 379 "mbrowrap.cpp"
              var $cmp11=((($conv))|0)==32; //@line 379 "mbrowrap.cpp"
              if ($cmp11) { __lastLabel__ = 7; __label__ = 8;; } else { __lastLabel__ = 7; __label__ = 9;; } //@line 379 "mbrowrap.cpp"
              if (__label__ == 8) {
  
                var $6=$p; //@line 379 "mbrowrap.cpp"
                var $arrayidx12=(($6+2)&4294967295); //@line 379 "mbrowrap.cpp"
                var $7=HEAP8[($arrayidx12)]; //@line 379 "mbrowrap.cpp"
                var $conv13=(tempInt=(($7)),(tempInt>=128?tempInt-256:tempInt)); //@line 379 "mbrowrap.cpp"
                var $cmp14=((($conv13))|0)==83; //@line 379 "mbrowrap.cpp"
                __lastLabel__ = 8; ;
              }
  
              var $8=__lastLabel__ == 7 ? 0 : ($cmp14);
              var $conv15=((($8))&1);
              $retval=$conv15;
              __label__ = 10;break $if_then$$if_end$2;
            }
          } while(0);
  
          $retval=0; //@line 378 "mbrowrap.cpp"
          ; //@line 378 "mbrowrap.cpp"
        }
      }
    } while(0);
  
    var $9=$retval; //@line 380 "mbrowrap.cpp"
    STACKTOP = __stackBase__;
    return $9; //@line 380 "mbrowrap.cpp"
    return null;
  }
  

  function __ZL12create_pipesPiS_S_($p1, $p2, $p3) {
    ;
    var __label__;
  
    var $retval;
    var $p1_addr;
    var $p2_addr;
    var $p3_addr;
    var $error;
    $p1_addr=$p1;
    $p2_addr=$p2;
    $p3_addr=$p3;
    var $0=$p1_addr; //@line 94 "mbrowrap.cpp"
    var $call=_pipe($0); //@line 94 "mbrowrap.cpp"
    var $cmp=((($call))|0)!=-1; //@line 94 "mbrowrap.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 7;; } //@line 94 "mbrowrap.cpp"
    $if_then$$if_else18$2: do { 
      if (__label__ == 1) {
  
        var $1=$p2_addr; //@line 95 "mbrowrap.cpp"
        var $call1=_pipe($1); //@line 95 "mbrowrap.cpp"
        var $cmp2=((($call1))|0)!=-1; //@line 95 "mbrowrap.cpp"
        if ($cmp2) { __label__ = 2;; } else { __label__ = 5;; } //@line 95 "mbrowrap.cpp"
        if (__label__ == 2) {
  
          var $2=$p3_addr; //@line 96 "mbrowrap.cpp"
          var $call4=_pipe($2); //@line 96 "mbrowrap.cpp"
          var $cmp5=((($call4))|0)!=-1; //@line 96 "mbrowrap.cpp"
          if ($cmp5) { __label__ = 3;; } else { __label__ = 4;; } //@line 96 "mbrowrap.cpp"
          if (__label__ == 3) {
  
            $retval=0; //@line 97 "mbrowrap.cpp"
            __label__ = 9;break $if_then$$if_else18$2; //@line 97 "mbrowrap.cpp"
          }
          else if (__label__ == 4) {
  
            var $call7=___errno(); //@line 99 "mbrowrap.cpp"
            var $3=HEAP32[(($call7)>>2)]; //@line 99 "mbrowrap.cpp"
            $error=$3; //@line 99 "mbrowrap.cpp"
            var $4=$p2_addr; //@line 100 "mbrowrap.cpp"
            var $arrayidx=(($4)&4294967295); //@line 100 "mbrowrap.cpp"
            var $5=HEAP32[(($arrayidx)>>2)]; //@line 100 "mbrowrap.cpp"
            var $call8=_close($5); //@line 100 "mbrowrap.cpp"
            var $6=$p2_addr; //@line 101 "mbrowrap.cpp"
            var $arrayidx9=(($6+4)&4294967295); //@line 101 "mbrowrap.cpp"
            var $7=HEAP32[(($arrayidx9)>>2)]; //@line 101 "mbrowrap.cpp"
            var $call10=_close($7); //@line 101 "mbrowrap.cpp"
            ; //@line 102 "mbrowrap.cpp"
          }
        }
        else if (__label__ == 5) {
  
          var $call12=___errno(); //@line 103 "mbrowrap.cpp"
          var $8=HEAP32[(($call12)>>2)]; //@line 103 "mbrowrap.cpp"
          $error=$8; //@line 103 "mbrowrap.cpp"
          ;
        }
  
        var $9=$p1_addr; //@line 104 "mbrowrap.cpp"
        var $arrayidx14=(($9)&4294967295); //@line 104 "mbrowrap.cpp"
        var $10=HEAP32[(($arrayidx14)>>2)]; //@line 104 "mbrowrap.cpp"
        var $call15=_close($10); //@line 104 "mbrowrap.cpp"
        var $11=$p1_addr; //@line 105 "mbrowrap.cpp"
        var $arrayidx16=(($11+4)&4294967295); //@line 105 "mbrowrap.cpp"
        var $12=HEAP32[(($arrayidx16)>>2)]; //@line 105 "mbrowrap.cpp"
        var $call17=_close($12); //@line 105 "mbrowrap.cpp"
        __label__ = 8;break $if_then$$if_else18$2; //@line 106 "mbrowrap.cpp"
      }
      else if (__label__ == 7) {
  
        var $call19=___errno(); //@line 107 "mbrowrap.cpp"
        var $13=HEAP32[(($call19)>>2)]; //@line 107 "mbrowrap.cpp"
        $error=$13; //@line 107 "mbrowrap.cpp"
        __label__ = 8;break $if_then$$if_else18$2;
      }
    } while(0);
    if (__label__ == 8) {
  
      var $14=$error; //@line 109 "mbrowrap.cpp"
      var $call21=_strerror($14); //@line 109 "mbrowrap.cpp"
      __ZL3errPKcz(((__str35615)&4294967295), allocate([$call21,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 109 "mbrowrap.cpp"
      $retval=-1; //@line 110 "mbrowrap.cpp"
      ; //@line 110 "mbrowrap.cpp"
    }
  
    var $15=$retval; //@line 111 "mbrowrap.cpp"
    ;
    return $15; //@line 111 "mbrowrap.cpp"
    return null;
  }
  

  function __ZL11close_pipesPiS_S_($p1, $p2, $p3) {
    ;
    var __label__;
  
    var $p1_addr;
    var $p2_addr;
    var $p3_addr;
    $p1_addr=$p1;
    $p2_addr=$p2;
    $p3_addr=$p3;
    var $0=$p1_addr; //@line 115 "mbrowrap.cpp"
    var $arrayidx=(($0)&4294967295); //@line 115 "mbrowrap.cpp"
    var $1=HEAP32[(($arrayidx)>>2)]; //@line 115 "mbrowrap.cpp"
    var $call=_close($1); //@line 115 "mbrowrap.cpp"
    var $2=$p1_addr; //@line 116 "mbrowrap.cpp"
    var $arrayidx1=(($2+4)&4294967295); //@line 116 "mbrowrap.cpp"
    var $3=HEAP32[(($arrayidx1)>>2)]; //@line 116 "mbrowrap.cpp"
    var $call2=_close($3); //@line 116 "mbrowrap.cpp"
    var $4=$p2_addr; //@line 117 "mbrowrap.cpp"
    var $arrayidx3=(($4)&4294967295); //@line 117 "mbrowrap.cpp"
    var $5=HEAP32[(($arrayidx3)>>2)]; //@line 117 "mbrowrap.cpp"
    var $call4=_close($5); //@line 117 "mbrowrap.cpp"
    var $6=$p2_addr; //@line 118 "mbrowrap.cpp"
    var $arrayidx5=(($6+4)&4294967295); //@line 118 "mbrowrap.cpp"
    var $7=HEAP32[(($arrayidx5)>>2)]; //@line 118 "mbrowrap.cpp"
    var $call6=_close($7); //@line 118 "mbrowrap.cpp"
    var $8=$p3_addr; //@line 119 "mbrowrap.cpp"
    var $arrayidx7=(($8)&4294967295); //@line 119 "mbrowrap.cpp"
    var $9=HEAP32[(($arrayidx7)>>2)]; //@line 119 "mbrowrap.cpp"
    var $call8=_close($9); //@line 119 "mbrowrap.cpp"
    var $10=$p3_addr; //@line 120 "mbrowrap.cpp"
    var $arrayidx9=(($10+4)&4294967295); //@line 120 "mbrowrap.cpp"
    var $11=HEAP32[(($arrayidx9)>>2)]; //@line 120 "mbrowrap.cpp"
    var $call10=_close($11); //@line 120 "mbrowrap.cpp"
    ;
    return; //@line 121 "mbrowrap.cpp"
    return;
  }
  

  function __Z15SetIndicLettersP10Translator($tr) {
    ;
    var __label__;
  
    var $tr_addr;
    $tr_addr=$tr;
    var $0=$tr_addr; //@line 308 "tr_languages.cpp"
    var $letter_bits=(($0+708)&4294967295); //@line 308 "tr_languages.cpp"
    var $arraydecay=(($letter_bits)&4294967295); //@line 308 "tr_languages.cpp"
    var $dest$, $stop$, $stop4$, $fast$, $value4$;
    $dest$ = $arraydecay;
    $stop$ = $dest$ + 256;
    $value4$ = 0;
    if ($value4$ < 0) $value4$ += 256;
    $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
    while ($dest$%4 !== 0 && $dest$ < $stop$) {
      ;; HEAP8[$dest$++] = 0;
    }
    $dest$ >>= 2;
    $stop4$ = $stop$ >> 2;
    while ($dest$ < $stop4$) {
    ;;;;;;;  HEAP32[$dest$++] = $value4$;
    }
    $dest$ <<= 2;
    while ($dest$ < $stop$) {
      ;; HEAP8[$dest$++] = 0;
    }; //@line 308 "tr_languages.cpp"
    var $1=$tr_addr; //@line 309 "tr_languages.cpp"
    __ZL18SetLetterBitsRangeP10Translatoriii($1, 0, 4, 20); //@line 309 "tr_languages.cpp"
    var $2=$tr_addr; //@line 310 "tr_languages.cpp"
    __ZL18SetLetterBitsRangeP10Translatoriii($2, 0, 62, 77); //@line 310 "tr_languages.cpp"
    var $3=$tr_addr; //@line 311 "tr_languages.cpp"
    __ZL18SetLetterBitsRangeP10Translatoriii($3, 0, 85, 87); //@line 311 "tr_languages.cpp"
    var $4=$tr_addr; //@line 313 "tr_languages.cpp"
    __ZL18SetLetterBitsRangeP10Translatoriii($4, 1, 62, 77); //@line 313 "tr_languages.cpp"
    var $5=$tr_addr; //@line 314 "tr_languages.cpp"
    __ZL18SetLetterBitsRangeP10Translatoriii($5, 1, 85, 87); //@line 314 "tr_languages.cpp"
    var $6=$tr_addr; //@line 316 "tr_languages.cpp"
    __ZL18SetLetterBitsRangeP10Translatoriii($6, 2, 21, 57); //@line 316 "tr_languages.cpp"
    var $7=$tr_addr; //@line 317 "tr_languages.cpp"
    __ZL13SetLetterBitsP10TranslatoriPKc($7, 2, ((__ZZ15SetIndicLettersP10TranslatorE15dev_consonants2)&4294967295)); //@line 317 "tr_languages.cpp"
    var $8=$tr_addr; //@line 319 "tr_languages.cpp"
    __ZL18SetLetterBitsRangeP10Translatoriii($8, 6, 4, 20); //@line 319 "tr_languages.cpp"
    var $9=$tr_addr; //@line 320 "tr_languages.cpp"
    __ZL18SetLetterBitsRangeP10Translatoriii($9, 6, 62, 76); //@line 320 "tr_languages.cpp"
    var $10=$tr_addr; //@line 321 "tr_languages.cpp"
    __ZL18SetLetterBitsRangeP10Translatoriii($10, 6, 85, 87); //@line 321 "tr_languages.cpp"
    var $11=$tr_addr; //@line 323 "tr_languages.cpp"
    var $langopts=(($11)&4294967295); //@line 323 "tr_languages.cpp"
    var $param=(($langopts+24)&4294967295); //@line 323 "tr_languages.cpp"
    var $arrayidx=(($param+20)&4294967295); //@line 323 "tr_languages.cpp"
    HEAP32[(($arrayidx)>>2)]=1; //@line 323 "tr_languages.cpp"
    var $12=$tr_addr; //@line 324 "tr_languages.cpp"
    var $letter_bits_offset=(($12+964)&4294967295); //@line 324 "tr_languages.cpp"
    var $13=HEAP32[(($letter_bits_offset)>>2)]; //@line 324 "tr_languages.cpp"
    var $add=((($13)+77)&4294967295); //@line 324 "tr_languages.cpp"
    var $14=$tr_addr; //@line 324 "tr_languages.cpp"
    var $langopts1=(($14)&4294967295); //@line 324 "tr_languages.cpp"
    var $suffix_add_e=(($langopts1+276)&4294967295); //@line 324 "tr_languages.cpp"
    HEAP32[(($suffix_add_e)>>2)]=$add; //@line 324 "tr_languages.cpp"
    ;
    return; //@line 325 "tr_languages.cpp"
    return;
  }
  

  function __ZL18SetLetterBitsRangeP10Translatoriii($tr, $group, $first, $last) {
    ;
    var __label__;
  
    var $tr_addr;
    var $group_addr;
    var $first_addr;
    var $last_addr;
    var $bits;
    var $ix;
    $tr_addr=$tr;
    $group_addr=$group;
    $first_addr=$first;
    $last_addr=$last;
    var $0=$group_addr; //@line 105 "tr_languages.cpp"
    var $shl=1 << ($0); //@line 105 "tr_languages.cpp"
    $bits=$shl; //@line 105 "tr_languages.cpp"
    var $1=$first_addr; //@line 106 "tr_languages.cpp"
    $ix=$1; //@line 106 "tr_languages.cpp"
    var $2=$ix; //@line 106 "tr_languages.cpp"
    var $3=$last_addr; //@line 106 "tr_languages.cpp"
    var $cmp1=((($2))|0) <= ((($3))|0); //@line 106 "tr_languages.cpp"
    if ($cmp1) { __label__ = 1;; } else { __label__ = 2;; } //@line 106 "tr_languages.cpp"
    $for_body$$for_end$2: do { 
      if (__label__ == 1) {
        while(1) { 
  
          var $4=$bits; //@line 108 "tr_languages.cpp"
          var $5=$ix; //@line 108 "tr_languages.cpp"
          var $6=$tr_addr; //@line 108 "tr_languages.cpp"
          var $letter_bits=(($6+708)&4294967295); //@line 108 "tr_languages.cpp"
          var $arrayidx=(($letter_bits+$5)&4294967295); //@line 108 "tr_languages.cpp"
          var $7=HEAPU8[($arrayidx)]; //@line 108 "tr_languages.cpp"
          var $conv=((($7))&255); //@line 108 "tr_languages.cpp"
          var $or=($conv) | ($4); //@line 108 "tr_languages.cpp"
          var $conv1=((($or)) & 255); //@line 108 "tr_languages.cpp"
          HEAP8[($arrayidx)]=$conv1; //@line 108 "tr_languages.cpp"
          var $8=$ix; //@line 106 "tr_languages.cpp"
          var $inc=((($8)+1)&4294967295); //@line 106 "tr_languages.cpp"
          $ix=$inc; //@line 106 "tr_languages.cpp"
          var $9=$ix; //@line 106 "tr_languages.cpp"
          var $10=$last_addr; //@line 106 "tr_languages.cpp"
          var $cmp=((($9))|0) <= ((($10))|0); //@line 106 "tr_languages.cpp"
          if ($cmp) { __label__ = 1;continue ; } else { __label__ = 2;break $for_body$$for_end$2; } //@line 106 "tr_languages.cpp"
        }
      }
    } while(0);
  
    ;
    return; //@line 110 "tr_languages.cpp"
    return;
  }
  

  function __ZL13SetLetterBitsP10TranslatoriPKc($tr, $group, $string) {
    ;
    var __label__;
  
    var $tr_addr;
    var $group_addr;
    var $string_addr;
    var $bits;
    var $c;
    $tr_addr=$tr;
    $group_addr=$group;
    $string_addr=$string;
    var $0=$group_addr; //@line 95 "tr_languages.cpp"
    var $shl=1 << ($0); //@line 95 "tr_languages.cpp"
    $bits=$shl; //@line 95 "tr_languages.cpp"
    var $1=$string_addr; //@line 96 "tr_languages.cpp"
    var $incdec_ptr1=(($1+1)&4294967295); //@line 96 "tr_languages.cpp"
    $string_addr=$incdec_ptr1; //@line 96 "tr_languages.cpp"
    var $2=HEAPU8[($1)]; //@line 96 "tr_languages.cpp"
    $c=$2; //@line 96 "tr_languages.cpp"
    var $conv3=((($2))&255); //@line 96 "tr_languages.cpp"
    var $cmp4=((($conv3))|0)!=0; //@line 96 "tr_languages.cpp"
    if ($cmp4) { __label__ = 1;; } else { __label__ = 2;; } //@line 96 "tr_languages.cpp"
    $while_body$$while_end$2: do { 
      if (__label__ == 1) {
        while(1) { 
  
          var $3=$bits; //@line 97 "tr_languages.cpp"
          var $4=$c; //@line 97 "tr_languages.cpp"
          var $idxprom=((($4))&255); //@line 97 "tr_languages.cpp"
          var $5=$tr_addr; //@line 97 "tr_languages.cpp"
          var $letter_bits=(($5+708)&4294967295); //@line 97 "tr_languages.cpp"
          var $arrayidx=(($letter_bits+$idxprom)&4294967295); //@line 97 "tr_languages.cpp"
          var $6=HEAPU8[($arrayidx)]; //@line 97 "tr_languages.cpp"
          var $conv1=((($6))&255); //@line 97 "tr_languages.cpp"
          var $or=($conv1) | ($3); //@line 97 "tr_languages.cpp"
          var $conv2=((($or)) & 255); //@line 97 "tr_languages.cpp"
          HEAP8[($arrayidx)]=$conv2; //@line 97 "tr_languages.cpp"
          var $7=$string_addr; //@line 96 "tr_languages.cpp"
          var $incdec_ptr=(($7+1)&4294967295); //@line 96 "tr_languages.cpp"
          $string_addr=$incdec_ptr; //@line 96 "tr_languages.cpp"
          var $8=HEAPU8[($7)]; //@line 96 "tr_languages.cpp"
          $c=$8; //@line 96 "tr_languages.cpp"
          var $conv=((($8))&255); //@line 96 "tr_languages.cpp"
          var $cmp=((($conv))|0)!=0; //@line 96 "tr_languages.cpp"
          if ($cmp) { __label__ = 1;continue ; } else { __label__ = 2;break $while_body$$while_end$2; } //@line 96 "tr_languages.cpp"
        }
      }
    } while(0);
  
    ;
    return; //@line 98 "tr_languages.cpp"
    return;
  }
  

  function __Z15SetupTranslatorP10TranslatorPKsPKh($tr, $lengths, $amps) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $tr_addr;
    var $lengths_addr;
    var $amps_addr;
    $tr_addr=$tr;
    $lengths_addr=$lengths;
    $amps_addr=$amps;
    var $0=$lengths_addr; //@line 330 "tr_languages.cpp"
    var $cmp=((($0))|0)!=0; //@line 330 "tr_languages.cpp"
    if ($cmp) { __lastLabel__ = 0; __label__ = 1;; } else { __lastLabel__ = 0; __label__ = 2;; } //@line 330 "tr_languages.cpp"
    if (__label__ == 1) {
  
      var $1=$tr_addr; //@line 331 "tr_languages.cpp"
      var $stress_lengths=(($1+676)&4294967295); //@line 331 "tr_languages.cpp"
      var $arraydecay=(($stress_lengths)&4294967295); //@line 331 "tr_languages.cpp"
      var $2=$arraydecay; //@line 331 "tr_languages.cpp"
      var $3=$lengths_addr; //@line 331 "tr_languages.cpp"
      var $4=$3; //@line 331 "tr_languages.cpp"
      var $src$, $dest$, $stop$, $stop4$, $fast$;
      $src$ = $4;
      $dest$ = $2;
      $stop$ = $src$ + 16;
      if (($dest$%4) == ($src$%4) && 16 > 8) {
        while ($src$%4 !== 0 && $src$ < $stop$) {
          ; HEAP8[$dest$++] = HEAP8[$src$++];
        }
        $src$ >>= 2;
        $dest$ >>= 2;
        $stop4$ = $stop$ >> 2;
        while ($src$ < $stop4$) {
      ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
        }
        $src$ <<= 2;
        $dest$ <<= 2;
      }while ($src$ < $stop$) {
        ; HEAP8[$dest$++] = HEAP8[$src$++];
      }; //@line 331 "tr_languages.cpp"
      var $_pr=$amps_addr; //@line 332 "tr_languages.cpp"
      __lastLabel__ = 1; ; //@line 331 "tr_languages.cpp"
    }
  
    var $5=__lastLabel__ == 1 ? $_pr : ($amps); //@line 332 "tr_languages.cpp"
    var $cmp1=((($5))|0)!=0; //@line 332 "tr_languages.cpp"
    if ($cmp1) { __label__ = 3;; } else { __label__ = 4;; } //@line 332 "tr_languages.cpp"
    if (__label__ == 3) {
  
      var $6=$tr_addr; //@line 333 "tr_languages.cpp"
      var $stress_amps=(($6+660)&4294967295); //@line 333 "tr_languages.cpp"
      var $arraydecay3=(($stress_amps)&4294967295); //@line 333 "tr_languages.cpp"
      var $7=$amps_addr; //@line 333 "tr_languages.cpp"
      var $src$, $dest$, $stop$, $stop4$, $fast$;
      $src$ = $7;
      $dest$ = $arraydecay3;
      $stop$ = $src$ + 8;
      if (($dest$%4) == ($src$%4) && 8 > 8) {
        while ($src$%4 !== 0 && $src$ < $stop$) {
          ; HEAP8[$dest$++] = HEAP8[$src$++];
        }
        $src$ >>= 2;
        $dest$ >>= 2;
        $stop4$ = $stop$ >> 2;
        while ($src$ < $stop4$) {
      ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
        }
        $src$ <<= 2;
        $dest$ <<= 2;
      }while ($src$ < $stop$) {
        ; HEAP8[$dest$++] = HEAP8[$src$++];
      }; //@line 333 "tr_languages.cpp"
      ; //@line 333 "tr_languages.cpp"
    }
  
    ;
    return; //@line 334 "tr_languages.cpp"
    return;
  }
  

  function __Z16SelectTranslatorPKc($name) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $name_addr;
    var $name2;
    var $tr;
    $name_addr=$name;
    $name2=0; //@line 339 "tr_languages.cpp"
    var $0=$name_addr; //@line 352 "tr_languages.cpp"
    var $1=HEAP8[($0)]; //@line 352 "tr_languages.cpp"
    var $conv2=(tempInt=(($1)),(tempInt>=128?tempInt-256:tempInt)); //@line 352 "tr_languages.cpp"
    var $cmp3=((($conv2))|0)!=0; //@line 352 "tr_languages.cpp"
    if ($cmp3) { __label__ = 1;; } else { __label__ = 2;; } //@line 352 "tr_languages.cpp"
    $while_body$$while_end$2: do { 
      if (__label__ == 1) {
        while(1) { 
  
          var $2=$name2; //@line 353 "tr_languages.cpp"
          var $shl=((($2)*256)&4294967295); //@line 353 "tr_languages.cpp"
          var $3=$name_addr; //@line 353 "tr_languages.cpp"
          var $incdec_ptr=(($3+1)&4294967295); //@line 353 "tr_languages.cpp"
          $name_addr=$incdec_ptr; //@line 353 "tr_languages.cpp"
          var $4=HEAP8[($3)]; //@line 353 "tr_languages.cpp"
          var $conv1=(tempInt=(($4)),(tempInt>=128?tempInt-256:tempInt)); //@line 353 "tr_languages.cpp"
          var $add=((($conv1)+($shl))&4294967295); //@line 353 "tr_languages.cpp"
          $name2=$add; //@line 353 "tr_languages.cpp"
          var $5=$name_addr; //@line 352 "tr_languages.cpp"
          var $6=HEAP8[($5)]; //@line 352 "tr_languages.cpp"
          var $conv=(tempInt=(($6)),(tempInt>=128?tempInt-256:tempInt)); //@line 352 "tr_languages.cpp"
          var $cmp=((($conv))|0)!=0; //@line 352 "tr_languages.cpp"
          if ($cmp) { __label__ = 1;continue ; } else { __label__ = 2;break $while_body$$while_end$2; } //@line 352 "tr_languages.cpp"
        }
      }
    } while(0);
  
    var $call=__ZL13NewTranslatorv(); //@line 355 "tr_languages.cpp"
    $tr=$call; //@line 355 "tr_languages.cpp"
    var $7=$name2; //@line 357 "tr_languages.cpp"
    if ($7 == 24934) {
      __label__ = 3;;
    }
    else if ($7 == 24941) {
      __label__ = 4;;
    }
    else if ($7 == 24946) {
      __label__ = 5;;
    }
    else if ($7 == 25191) {
      __label__ = 6;;
    }
    else if ($7 == 25198) {
      __label__ = 7;;
    }
    else if ($7 == 25465) {
      __label__ = 8;;
    }
    else if ($7 == 25697) {
      __label__ = 9;;
    }
    else if ($7 == 25701) {
      __label__ = 10;;
    }
    else if ($7 == 25718) {
      __label__ = 11;;
    }
    else if ($7 == 25966) {
      __label__ = 12;;
    }
    else if ($7 == 25964) {
      __label__ = 13;;
    }
    else if ($7 == 6779491) {
      __label__ = 13;;
    }
    else if ($7 == 25967) {
      __label__ = 15;;
    }
    else if ($7 == 25971) {
      __label__ = 16;;
    }
    else if ($7 == 25441) {
      __label__ = 16;;
    }
    else if ($7 == 7364976) {
      __label__ = 16;;
    }
    else if ($7 == 25973) {
      __label__ = 21;;
    }
    else if ($7 == 26209) {
      __label__ = 22;;
    }
    else if ($7 == 25972) {
      __label__ = 23;;
    }
    else if ($7 == 26217) {
      __label__ = 24;;
    }
    else if ($7 == 26226) {
      __label__ = 25;;
    }
    else if ($7 == 26729) {
      __label__ = 26;;
    }
    else if ($7 == 28261) {
      __label__ = 26;;
    }
    else if ($7 == 28769) {
      __label__ = 26;;
    }
    else if ($7 == 26738) {
      __label__ = 29;;
    }
    else if ($7 == 25203) {
      __label__ = 29;;
    }
    else if ($7 == 29554) {
      __label__ = 29;;
    }
    else if ($7 == 26740) {
      __label__ = 33;;
    }
    else if ($7 == 26741) {
      __label__ = 34;;
    }
    else if ($7 == 26745) {
      __label__ = 35;;
    }
    else if ($7 == 26980) {
      __label__ = 36;;
    }
    else if ($7 == 26995) {
      __label__ = 37;;
    }
    else if ($7 == 26996) {
      __label__ = 38;;
    }
    else if ($7 == 6972015) {
      __label__ = 39;;
    }
    else if ($7 == 27489) {
      __label__ = 40;;
    }
    else if ($7 == 27503) {
      __label__ = 41;;
    }
    else if ($7 == 27509) {
      __label__ = 42;;
    }
    else if ($7 == 27745) {
      __label__ = 43;;
    }
    else if ($7 == 27766) {
      __label__ = 44;;
    }
    else if ($7 == 28011) {
      __label__ = 45;;
    }
    else if ($7 == 28268) {
      __label__ = 46;;
    }
    else if ($7 == 28271) {
      __label__ = 47;;
    }
    else if ($7 == 28525) {
      __label__ = 48;;
    }
    else if ($7 == 28780) {
      __label__ = 49;;
    }
    else if ($7 == 28788) {
      __label__ = 50;;
    }
    else if ($7 == 29295) {
      __label__ = 51;;
    }
    else if ($7 == 29301) {
      __label__ = 52;;
    }
    else if ($7 == 29303) {
      __label__ = 53;;
    }
    else if ($7 == 29547) {
      __label__ = 54;;
    }
    else if ($7 == 25459) {
      __label__ = 54;;
    }
    else if ($7 == 29545) {
      __label__ = 57;;
    }
    else if ($7 == 29548) {
      __label__ = 58;;
    }
    else if ($7 == 29553) {
      __label__ = 59;;
    }
    else if ($7 == 29558) {
      __label__ = 60;;
    }
    else if ($7 == 29559) {
      __label__ = 61;;
    }
    else if ($7 == 29806) {
      __label__ = 61;;
    }
    else if ($7 == 29793) {
      __label__ = 62;;
    }
    else if ($7 == 28012) {
      __label__ = 62;;
    }
    else if ($7 == 27502) {
      __label__ = 62;;
    }
    else if ($7 == 28018) {
      __label__ = 62;;
    }
    else if ($7 == 29797) {
      __label__ = 62;;
    }
    else if ($7 == 29810) {
      __label__ = 73;;
    }
    else if ($7 == 30066) {
      __label__ = 74;;
    }
    else if ($7 == 30313) {
      __label__ = 75;;
    }
    else if ($7 == 30575) {
      __label__ = 76;;
    }
    else if ($7 == 31336) {
      __label__ = 77;;
    }
    else if ($7 == 8022137) {
      __label__ = 77;;
    }
    else {
    __label__ = 79;;
    }
    
    $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6: do { 
      if (__label__ == 79) {
  
        var $495=$tr; //@line 1330 "tr_languages.cpp"
        var $langopts756=(($495)&4294967295); //@line 1330 "tr_languages.cpp"
        var $param757=(($langopts756+24)&4294967295); //@line 1330 "tr_languages.cpp"
        var $arrayidx758=(($param757+20)&4294967295); //@line 1330 "tr_languages.cpp"
        HEAP32[(($arrayidx758)>>2)]=1; //@line 1330 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 1331 "tr_languages.cpp"
      }
      else if (__label__ == 3) {
  
        var $8=$tr; //@line 362 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($8, ((__ZZ16SelectTranslatorPKcE17stress_lengths_af)&4294967295), 0); //@line 362 "tr_languages.cpp"
        var $9=$tr; //@line 364 "tr_languages.cpp"
        var $langopts=(($9)&4294967295); //@line 364 "tr_languages.cpp"
        var $stress_rule=(($langopts+8)&4294967295); //@line 364 "tr_languages.cpp"
        HEAP32[(($stress_rule)>>2)]=0; //@line 364 "tr_languages.cpp"
        var $10=$tr; //@line 365 "tr_languages.cpp"
        var $langopts2=(($10)&4294967295); //@line 365 "tr_languages.cpp"
        var $vowel_pause=(($langopts2+4)&4294967295); //@line 365 "tr_languages.cpp"
        HEAP32[(($vowel_pause)>>2)]=48; //@line 365 "tr_languages.cpp"
        var $11=$tr; //@line 366 "tr_languages.cpp"
        var $langopts3=(($11)&4294967295); //@line 366 "tr_languages.cpp"
        var $param=(($langopts3+24)&4294967295); //@line 366 "tr_languages.cpp"
        var $arrayidx=(($param+4)&4294967295); //@line 366 "tr_languages.cpp"
        HEAP32[(($arrayidx)>>2)]=1; //@line 366 "tr_languages.cpp"
        var $12=$tr; //@line 367 "tr_languages.cpp"
        var $langopts4=(($12)&4294967295); //@line 367 "tr_languages.cpp"
        var $param5=(($langopts4+24)&4294967295); //@line 367 "tr_languages.cpp"
        var $arrayidx6=(($param5+12)&4294967295); //@line 367 "tr_languages.cpp"
        HEAP32[(($arrayidx6)>>2)]=1; //@line 367 "tr_languages.cpp"
        var $13=$tr; //@line 368 "tr_languages.cpp"
        __ZL14SetLetterVowelP10Translatori($13, 121); //@line 368 "tr_languages.cpp"
        var $14=$tr; //@line 370 "tr_languages.cpp"
        var $langopts7=(($14)&4294967295); //@line 370 "tr_languages.cpp"
        var $numbers=(($langopts7+184)&4294967295); //@line 370 "tr_languages.cpp"
        HEAP32[(($numbers)>>2)]=16779472; //@line 370 "tr_languages.cpp"
        var $15=$tr; //@line 371 "tr_languages.cpp"
        var $langopts8=(($15)&4294967295); //@line 371 "tr_languages.cpp"
        var $accents=(($langopts8+220)&4294967295); //@line 371 "tr_languages.cpp"
        HEAP32[(($accents)>>2)]=1; //@line 371 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 373 "tr_languages.cpp"
      }
      else if (__label__ == 4) {
  
        var $16=$tr; //@line 377 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($16, ((__ZZ16SelectTranslatorPKcE17stress_lengths_fr)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_fr)&4294967295)); //@line 377 "tr_languages.cpp"
        var $17=$tr; //@line 378 "tr_languages.cpp"
        var $langopts10=(($17)&4294967295); //@line 378 "tr_languages.cpp"
        var $stress_rule11=(($langopts10+8)&4294967295); //@line 378 "tr_languages.cpp"
        HEAP32[(($stress_rule11)>>2)]=0; //@line 378 "tr_languages.cpp"
        var $18=$tr; //@line 379 "tr_languages.cpp"
        var $langopts12=(($18)&4294967295); //@line 379 "tr_languages.cpp"
        var $stress_flags=(($langopts12+12)&4294967295); //@line 379 "tr_languages.cpp"
        HEAP32[(($stress_flags)>>2)]=36; //@line 379 "tr_languages.cpp"
        var $19=$tr; //@line 380 "tr_languages.cpp"
        var $langopts13=(($19)&4294967295); //@line 380 "tr_languages.cpp"
        var $length_mods=(($langopts13+176)&4294967295); //@line 380 "tr_languages.cpp"
        var $20=HEAP32[(($length_mods)>>2)]; //@line 380 "tr_languages.cpp"
        var $21=$tr; //@line 380 "tr_languages.cpp"
        var $langopts14=(($21)&4294967295); //@line 380 "tr_languages.cpp"
        var $length_mods0=(($langopts14+180)&4294967295); //@line 380 "tr_languages.cpp"
        HEAP32[(($length_mods0)>>2)]=$20; //@line 380 "tr_languages.cpp"
        var $22=$tr; //@line 381 "tr_languages.cpp"
        var $langopts15=(($22)&4294967295); //@line 381 "tr_languages.cpp"
        var $param16=(($langopts15+24)&4294967295); //@line 381 "tr_languages.cpp"
        var $arrayidx17=(($param16+20)&4294967295); //@line 381 "tr_languages.cpp"
        HEAP32[(($arrayidx17)>>2)]=1; //@line 381 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 383 "tr_languages.cpp"
      }
      else if (__label__ == 5) {
  
        var $23=$tr; //@line 387 "tr_languages.cpp"
        var $letter_bits_offset=(($23+964)&4294967295); //@line 387 "tr_languages.cpp"
        HEAP32[(($letter_bits_offset)>>2)]=1536; //@line 387 "tr_languages.cpp"
        var $24=$tr; //@line 388 "tr_languages.cpp"
        var $langopts19=(($24)&4294967295); //@line 388 "tr_languages.cpp"
        var $numbers20=(($langopts19+184)&4294967295); //@line 388 "tr_languages.cpp"
        HEAP32[(($numbers20)>>2)]=2884720; //@line 388 "tr_languages.cpp"
        var $25=$tr; //@line 389 "tr_languages.cpp"
        var $langopts21=(($25)&4294967295); //@line 389 "tr_languages.cpp"
        var $param22=(($langopts21+24)&4294967295); //@line 389 "tr_languages.cpp"
        var $arrayidx23=(($param22+20)&4294967295); //@line 389 "tr_languages.cpp"
        HEAP32[(($arrayidx23)>>2)]=1; //@line 389 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 390 "tr_languages.cpp"
      }
      else if (__label__ == 6) {
  
        var $26=$tr; //@line 394 "tr_languages.cpp"
        __ZL18SetCyrillicLettersP10Translator($26); //@line 394 "tr_languages.cpp"
        var $27=$tr; //@line 395 "tr_languages.cpp"
        __ZL14SetLetterVowelP10Translatori($27, 42); //@line 395 "tr_languages.cpp"
        var $28=$tr; //@line 396 "tr_languages.cpp"
        var $langopts25=(($28)&4294967295); //@line 396 "tr_languages.cpp"
        var $param26=(($langopts25+24)&4294967295); //@line 396 "tr_languages.cpp"
        var $arrayidx27=(($param26+20)&4294967295); //@line 396 "tr_languages.cpp"
        HEAP32[(($arrayidx27)>>2)]=1074; //@line 396 "tr_languages.cpp"
        var $29=$tr; //@line 397 "tr_languages.cpp"
        var $langopts28=(($29)&4294967295); //@line 397 "tr_languages.cpp"
        var $param29=(($langopts28+24)&4294967295); //@line 397 "tr_languages.cpp"
        var $arrayidx30=(($param29+16)&4294967295); //@line 397 "tr_languages.cpp"
        HEAP32[(($arrayidx30)>>2)]=23; //@line 397 "tr_languages.cpp"
        var $30=$tr; //@line 398 "tr_languages.cpp"
        var $langopts31=(($30)&4294967295); //@line 398 "tr_languages.cpp"
        var $param32=(($langopts31+24)&4294967295); //@line 398 "tr_languages.cpp"
        var $arrayidx33=(($param32+40)&4294967295); //@line 398 "tr_languages.cpp"
        HEAP32[(($arrayidx33)>>2)]=2; //@line 398 "tr_languages.cpp"
        var $31=$tr; //@line 399 "tr_languages.cpp"
        var $langopts34=(($31)&4294967295); //@line 399 "tr_languages.cpp"
        var $stress_rule35=(($langopts34+8)&4294967295); //@line 399 "tr_languages.cpp"
        HEAP32[(($stress_rule35)>>2)]=2; //@line 399 "tr_languages.cpp"
        var $32=$tr; //@line 400 "tr_languages.cpp"
        var $langopts36=(($32)&4294967295); //@line 400 "tr_languages.cpp"
        var $numbers37=(($langopts36+184)&4294967295); //@line 400 "tr_languages.cpp"
        HEAP32[(($numbers37)>>2)]=184554728; //@line 400 "tr_languages.cpp"
        var $33=$tr; //@line 401 "tr_languages.cpp"
        var $langopts38=(($33)&4294967295); //@line 401 "tr_languages.cpp"
        var $thousands_sep=(($langopts38+204)&4294967295); //@line 401 "tr_languages.cpp"
        HEAP32[(($thousands_sep)>>2)]=32; //@line 401 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 403 "tr_languages.cpp"
      }
      else if (__label__ == 7) {
  
        var $34=$tr; //@line 410 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($34, ((__ZZ16SelectTranslatorPKcE17stress_lengths_bn)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_bn)&4294967295)); //@line 410 "tr_languages.cpp"
        var $35=$tr; //@line 411 "tr_languages.cpp"
        var $langopts40=(($35)&4294967295); //@line 411 "tr_languages.cpp"
        var $length_mods41=(($langopts40+176)&4294967295); //@line 411 "tr_languages.cpp"
        var $36=HEAP32[(($length_mods41)>>2)]; //@line 411 "tr_languages.cpp"
        var $37=$tr; //@line 411 "tr_languages.cpp"
        var $langopts42=(($37)&4294967295); //@line 411 "tr_languages.cpp"
        var $length_mods043=(($langopts42+180)&4294967295); //@line 411 "tr_languages.cpp"
        HEAP32[(($length_mods043)>>2)]=$36; //@line 411 "tr_languages.cpp"
        var $38=$tr; //@line 413 "tr_languages.cpp"
        var $langopts44=(($38)&4294967295); //@line 413 "tr_languages.cpp"
        var $stress_rule45=(($langopts44+8)&4294967295); //@line 413 "tr_languages.cpp"
        HEAP32[(($stress_rule45)>>2)]=0; //@line 413 "tr_languages.cpp"
        var $39=$tr; //@line 414 "tr_languages.cpp"
        var $langopts46=(($39)&4294967295); //@line 414 "tr_languages.cpp"
        var $stress_flags47=(($langopts46+12)&4294967295); //@line 414 "tr_languages.cpp"
        HEAP32[(($stress_flags47)>>2)]=65540; //@line 414 "tr_languages.cpp"
        var $40=$tr; //@line 415 "tr_languages.cpp"
        var $letter_bits_offset48=(($40+964)&4294967295); //@line 415 "tr_languages.cpp"
        HEAP32[(($letter_bits_offset48)>>2)]=2432; //@line 415 "tr_languages.cpp"
        var $41=$tr; //@line 416 "tr_languages.cpp"
        __Z15SetIndicLettersP10Translator($41); //@line 416 "tr_languages.cpp"
        var $42=$tr; //@line 417 "tr_languages.cpp"
        __ZL18SetLetterBitsRangeP10Translatoriii($42, 4, 62, 76); //@line 417 "tr_languages.cpp"
        var $43=$tr; //@line 419 "tr_languages.cpp"
        var $langopts49=(($43)&4294967295); //@line 419 "tr_languages.cpp"
        var $numbers50=(($langopts49+184)&4294967295); //@line 419 "tr_languages.cpp"
        HEAP32[(($numbers50)>>2)]=1; //@line 419 "tr_languages.cpp"
        var $44=$tr; //@line 420 "tr_languages.cpp"
        var $langopts51=(($44)&4294967295); //@line 420 "tr_languages.cpp"
        var $break_numbers=(($langopts51+192)&4294967295); //@line 420 "tr_languages.cpp"
        HEAP32[(($break_numbers)>>2)]=613567144; //@line 420 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 422 "tr_languages.cpp"
      }
      else if (__label__ == 8) {
  
        var $45=$tr; //@line 429 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($45, ((__ZZ16SelectTranslatorPKcE17stress_lengths_cy)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_cy)&4294967295)); //@line 429 "tr_languages.cpp"
        var $46=HEAP32[((((_charsets+56)&4294967295))>>2)]; //@line 431 "tr_languages.cpp"
        var $47=$tr; //@line 431 "tr_languages.cpp"
        var $charset_a0=(($47+696)&4294967295); //@line 431 "tr_languages.cpp"
        HEAP32[(($charset_a0)>>2)]=$46; //@line 431 "tr_languages.cpp"
        var $48=$tr; //@line 433 "tr_languages.cpp"
        var $langopts53=(($48)&4294967295); //@line 433 "tr_languages.cpp"
        var $stress_rule54=(($langopts53+8)&4294967295); //@line 433 "tr_languages.cpp"
        HEAP32[(($stress_rule54)>>2)]=2; //@line 433 "tr_languages.cpp"
        var $49=$tr; //@line 437 "tr_languages.cpp"
        var $langopts55=(($49)&4294967295); //@line 437 "tr_languages.cpp"
        var $stress_flags56=(($langopts55+12)&4294967295); //@line 437 "tr_languages.cpp"
        HEAP32[(($stress_flags56)>>2)]=22; //@line 437 "tr_languages.cpp"
        var $50=$tr; //@line 438 "tr_languages.cpp"
        var $langopts57=(($50)&4294967295); //@line 438 "tr_languages.cpp"
        var $unstressed_wd1=(($langopts57+16)&4294967295); //@line 438 "tr_languages.cpp"
        HEAP32[(($unstressed_wd1)>>2)]=0; //@line 438 "tr_languages.cpp"
        var $51=$tr; //@line 439 "tr_languages.cpp"
        var $langopts58=(($51)&4294967295); //@line 439 "tr_languages.cpp"
        var $unstressed_wd2=(($langopts58+20)&4294967295); //@line 439 "tr_languages.cpp"
        HEAP32[(($unstressed_wd2)>>2)]=2; //@line 439 "tr_languages.cpp"
        var $52=$tr; //@line 440 "tr_languages.cpp"
        var $langopts59=(($52)&4294967295); //@line 440 "tr_languages.cpp"
        var $param60=(($langopts59+24)&4294967295); //@line 440 "tr_languages.cpp"
        var $arrayidx61=(($param60+28)&4294967295); //@line 440 "tr_languages.cpp"
        HEAP32[(($arrayidx61)>>2)]=120; //@line 440 "tr_languages.cpp"
        var $53=$tr; //@line 442 "tr_languages.cpp"
        var $langopts62=(($53)&4294967295); //@line 442 "tr_languages.cpp"
        var $numbers63=(($langopts62+184)&4294967295); //@line 442 "tr_languages.cpp"
        HEAP32[(($numbers63)>>2)]=1024; //@line 442 "tr_languages.cpp"
        var $54=$tr; //@line 444 "tr_languages.cpp"
        __ZL14SetLetterVowelP10Translatori($54, 119); //@line 444 "tr_languages.cpp"
        var $55=$tr; //@line 445 "tr_languages.cpp"
        __ZL14SetLetterVowelP10Translatori($55, 121); //@line 445 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 447 "tr_languages.cpp"
      }
      else if (__label__ == 9) {
  
        var $56=$tr; //@line 452 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($56, ((__ZZ16SelectTranslatorPKcE17stress_lengths_da)&4294967295), 0); //@line 452 "tr_languages.cpp"
        var $57=$tr; //@line 454 "tr_languages.cpp"
        var $langopts65=(($57)&4294967295); //@line 454 "tr_languages.cpp"
        var $stress_rule66=(($langopts65+8)&4294967295); //@line 454 "tr_languages.cpp"
        HEAP32[(($stress_rule66)>>2)]=0; //@line 454 "tr_languages.cpp"
        var $58=$tr; //@line 455 "tr_languages.cpp"
        var $langopts67=(($58)&4294967295); //@line 455 "tr_languages.cpp"
        var $param68=(($langopts67+24)&4294967295); //@line 455 "tr_languages.cpp"
        var $arrayidx69=(($param68+12)&4294967295); //@line 455 "tr_languages.cpp"
        HEAP32[(($arrayidx69)>>2)]=1; //@line 455 "tr_languages.cpp"
        var $59=$tr; //@line 456 "tr_languages.cpp"
        __ZL14SetLetterVowelP10Translatori($59, 121); //@line 456 "tr_languages.cpp"
        var $60=$tr; //@line 457 "tr_languages.cpp"
        var $langopts70=(($60)&4294967295); //@line 457 "tr_languages.cpp"
        var $numbers71=(($langopts70+184)&4294967295); //@line 457 "tr_languages.cpp"
        HEAP32[(($numbers71)>>2)]=184618072; //@line 457 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 459 "tr_languages.cpp"
      }
      else if (__label__ == 10) {
  
        var $61=$tr; //@line 466 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($61, ((__ZZ16SelectTranslatorPKcE17stress_lengths_de)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_de)&4294967295)); //@line 466 "tr_languages.cpp"
        var $62=$tr; //@line 467 "tr_languages.cpp"
        var $langopts73=(($62)&4294967295); //@line 467 "tr_languages.cpp"
        var $stress_rule74=(($langopts73+8)&4294967295); //@line 467 "tr_languages.cpp"
        HEAP32[(($stress_rule74)>>2)]=0; //@line 467 "tr_languages.cpp"
        var $63=$tr; //@line 468 "tr_languages.cpp"
        var $langopts75=(($63)&4294967295); //@line 468 "tr_languages.cpp"
        var $word_gap=(($langopts75)&4294967295); //@line 468 "tr_languages.cpp"
        HEAP32[(($word_gap)>>2)]=8; //@line 468 "tr_languages.cpp"
        var $64=$tr; //@line 469 "tr_languages.cpp"
        var $langopts76=(($64)&4294967295); //@line 469 "tr_languages.cpp"
        var $vowel_pause77=(($langopts76+4)&4294967295); //@line 469 "tr_languages.cpp"
        HEAP32[(($vowel_pause77)>>2)]=48; //@line 469 "tr_languages.cpp"
        var $65=$tr; //@line 470 "tr_languages.cpp"
        var $langopts78=(($65)&4294967295); //@line 470 "tr_languages.cpp"
        var $param79=(($langopts78+24)&4294967295); //@line 470 "tr_languages.cpp"
        var $arrayidx80=(($param79+12)&4294967295); //@line 470 "tr_languages.cpp"
        HEAP32[(($arrayidx80)>>2)]=1; //@line 470 "tr_languages.cpp"
        var $66=$tr; //@line 471 "tr_languages.cpp"
        var $langopts81=(($66)&4294967295); //@line 471 "tr_languages.cpp"
        var $param82=(($langopts81+24)&4294967295); //@line 471 "tr_languages.cpp"
        var $arrayidx83=(($param82+16)&4294967295); //@line 471 "tr_languages.cpp"
        HEAP32[(($arrayidx83)>>2)]=16; //@line 471 "tr_languages.cpp"
        var $67=$tr; //@line 472 "tr_languages.cpp"
        var $langopts84=(($67)&4294967295); //@line 472 "tr_languages.cpp"
        var $param85=(($langopts84+24)&4294967295); //@line 472 "tr_languages.cpp"
        var $arrayidx86=(($param85+72)&4294967295); //@line 472 "tr_languages.cpp"
        HEAP32[(($arrayidx86)>>2)]=87; //@line 472 "tr_languages.cpp"
        var $68=$tr; //@line 474 "tr_languages.cpp"
        var $langopts87=(($68)&4294967295); //@line 474 "tr_languages.cpp"
        var $numbers88=(($langopts87+184)&4294967295); //@line 474 "tr_languages.cpp"
        HEAP32[(($numbers88)>>2)]=16846872; //@line 474 "tr_languages.cpp"
        var $69=$tr; //@line 476 "tr_languages.cpp"
        __ZL14SetLetterVowelP10Translatori($69, 121); //@line 476 "tr_languages.cpp"
        var $70=$tr; //@line 477 "tr_languages.cpp"
        var $langopts89=(($70)&4294967295); //@line 477 "tr_languages.cpp"
        var $param90=(($langopts89+24)&4294967295); //@line 477 "tr_languages.cpp"
        var $arrayidx91=(($param90+20)&4294967295); //@line 477 "tr_languages.cpp"
        HEAP32[(($arrayidx91)>>2)]=2; //@line 477 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 479 "tr_languages.cpp"
      }
      else if (__label__ == 11) {
  
        var $71=$tr; //@line 483 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($71, ((__ZZ16SelectTranslatorPKcE17stress_lengths_ta)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_ta)&4294967295)); //@line 483 "tr_languages.cpp"
        var $72=$tr; //@line 484 "tr_languages.cpp"
        var $langopts93=(($72)&4294967295); //@line 484 "tr_languages.cpp"
        var $param94=(($langopts93+24)&4294967295); //@line 484 "tr_languages.cpp"
        var $arrayidx95=(($param94+20)&4294967295); //@line 484 "tr_languages.cpp"
        HEAP32[(($arrayidx95)>>2)]=1; //@line 484 "tr_languages.cpp"
        var $73=$tr; //@line 485 "tr_languages.cpp"
        var $langopts96=(($73)&4294967295); //@line 485 "tr_languages.cpp"
        var $length_mods97=(($langopts96+176)&4294967295); //@line 485 "tr_languages.cpp"
        var $74=HEAP32[(($length_mods97)>>2)]; //@line 485 "tr_languages.cpp"
        var $75=$tr; //@line 485 "tr_languages.cpp"
        var $langopts98=(($75)&4294967295); //@line 485 "tr_languages.cpp"
        var $length_mods099=(($langopts98+180)&4294967295); //@line 485 "tr_languages.cpp"
        HEAP32[(($length_mods099)>>2)]=$74; //@line 485 "tr_languages.cpp"
        var $76=$tr; //@line 486 "tr_languages.cpp"
        var $letter_bits_offset100=(($76+964)&4294967295); //@line 486 "tr_languages.cpp"
        HEAP32[(($letter_bits_offset100)>>2)]=1920; //@line 486 "tr_languages.cpp"
        var $77=$tr; //@line 487 "tr_languages.cpp"
        var $langopts101=(($77)&4294967295); //@line 487 "tr_languages.cpp"
        var $stress_rule102=(($langopts101+8)&4294967295); //@line 487 "tr_languages.cpp"
        HEAP32[(($stress_rule102)>>2)]=0; //@line 487 "tr_languages.cpp"
        var $78=$tr; //@line 488 "tr_languages.cpp"
        var $langopts103=(($78)&4294967295); //@line 488 "tr_languages.cpp"
        var $stress_flags104=(($langopts103+12)&4294967295); //@line 488 "tr_languages.cpp"
        HEAP32[(($stress_flags104)>>2)]=65540; //@line 488 "tr_languages.cpp"
        var $79=$tr; //@line 489 "tr_languages.cpp"
        __ZL18SetLetterBitsRangeP10Translatoriii($79, 1, 38, 48); //@line 489 "tr_languages.cpp"
        var $80=$tr; //@line 490 "tr_languages.cpp"
        var $langopts105=(($80)&4294967295); //@line 490 "tr_languages.cpp"
        var $break_numbers106=(($langopts105+192)&4294967295); //@line 490 "tr_languages.cpp"
        HEAP32[(($break_numbers106)>>2)]=5288; //@line 490 "tr_languages.cpp"
        var $81=$tr; //@line 491 "tr_languages.cpp"
        var $langopts107=(($81)&4294967295); //@line 491 "tr_languages.cpp"
        var $numbers108=(($langopts107+184)&4294967295); //@line 491 "tr_languages.cpp"
        HEAP32[(($numbers108)>>2)]=1; //@line 491 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 493 "tr_languages.cpp"
      }
      else if (__label__ == 12) {
  
        var $82=$tr; //@line 498 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($82, ((__ZZ16SelectTranslatorPKcE17stress_lengths_en)&4294967295), 0); //@line 498 "tr_languages.cpp"
        var $83=$tr; //@line 500 "tr_languages.cpp"
        var $langopts110=(($83)&4294967295); //@line 500 "tr_languages.cpp"
        var $stress_rule111=(($langopts110+8)&4294967295); //@line 500 "tr_languages.cpp"
        HEAP32[(($stress_rule111)>>2)]=0; //@line 500 "tr_languages.cpp"
        var $84=$tr; //@line 501 "tr_languages.cpp"
        var $langopts112=(($84)&4294967295); //@line 501 "tr_languages.cpp"
        var $stress_flags113=(($langopts112+12)&4294967295); //@line 501 "tr_languages.cpp"
        HEAP32[(($stress_flags113)>>2)]=8; //@line 501 "tr_languages.cpp"
        var $85=$tr; //@line 502 "tr_languages.cpp"
        var $langopts114=(($85)&4294967295); //@line 502 "tr_languages.cpp"
        var $numbers115=(($langopts114+184)&4294967295); //@line 502 "tr_languages.cpp"
        HEAP32[(($numbers115)>>2)]=16779328; //@line 502 "tr_languages.cpp"
        var $86=$tr; //@line 503 "tr_languages.cpp"
        var $langopts116=(($86)&4294967295); //@line 503 "tr_languages.cpp"
        var $param117=(($langopts116+24)&4294967295); //@line 503 "tr_languages.cpp"
        var $arrayidx118=(($param117+44)&4294967295); //@line 503 "tr_languages.cpp"
        HEAP32[(($arrayidx118)>>2)]=2; //@line 503 "tr_languages.cpp"
        var $87=$tr; //@line 504 "tr_languages.cpp"
        var $langopts119=(($87)&4294967295); //@line 504 "tr_languages.cpp"
        var $suffix_add_e=(($langopts119+276)&4294967295); //@line 504 "tr_languages.cpp"
        HEAP32[(($suffix_add_e)>>2)]=101; //@line 504 "tr_languages.cpp"
        var $88=$tr; //@line 505 "tr_languages.cpp"
        var $langopts120=(($88)&4294967295); //@line 505 "tr_languages.cpp"
        var $param121=(($langopts120+24)&4294967295); //@line 505 "tr_languages.cpp"
        var $arrayidx122=(($param121+20)&4294967295); //@line 505 "tr_languages.cpp"
        HEAP32[(($arrayidx122)>>2)]=2; //@line 505 "tr_languages.cpp"
        var $89=$tr; //@line 506 "tr_languages.cpp"
        __ZL13SetLetterBitsP10TranslatoriPKc($89, 6, ((__str630)&4294967295)); //@line 506 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 508 "tr_languages.cpp"
      }
      else if (__label__ == 13) {
  
        var $90=$tr; //@line 523 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($90, ((__ZZ16SelectTranslatorPKcE17stress_lengths_el)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_el)&4294967295)); //@line 523 "tr_languages.cpp"
        var $91=HEAP32[((((_charsets+28)&4294967295))>>2)]; //@line 525 "tr_languages.cpp"
        var $92=$tr; //@line 525 "tr_languages.cpp"
        var $charset_a0124=(($92+696)&4294967295); //@line 525 "tr_languages.cpp"
        HEAP32[(($charset_a0124)>>2)]=$91; //@line 525 "tr_languages.cpp"
        var $93=$tr; //@line 526 "tr_languages.cpp"
        var $char_plus_apostrophe=(($93+700)&4294967295); //@line 526 "tr_languages.cpp"
        HEAP32[(($char_plus_apostrophe)>>2)]=((__ZZ16SelectTranslatorPKcE18el_char_apostrophe)&4294967295); //@line 526 "tr_languages.cpp"
        var $94=$tr; //@line 528 "tr_languages.cpp"
        var $letter_bits_offset125=(($94+964)&4294967295); //@line 528 "tr_languages.cpp"
        HEAP32[(($letter_bits_offset125)>>2)]=896; //@line 528 "tr_languages.cpp"
        var $95=$tr; //@line 529 "tr_languages.cpp"
        var $letter_bits=(($95+708)&4294967295); //@line 529 "tr_languages.cpp"
        var $arraydecay=(($letter_bits)&4294967295); //@line 529 "tr_languages.cpp"
        var $dest$, $stop$, $stop4$, $fast$, $value4$;
        $dest$ = $arraydecay;
        $stop$ = $dest$ + 256;
        $value4$ = 0;
        if ($value4$ < 0) $value4$ += 256;
        $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
        while ($dest$%4 !== 0 && $dest$ < $stop$) {
          ;; HEAP8[$dest$++] = 0;
        }
        $dest$ >>= 2;
        $stop4$ = $stop$ >> 2;
        while ($dest$ < $stop4$) {
        ;;;;;;;  HEAP32[$dest$++] = $value4$;
        }
        $dest$ <<= 2;
        while ($dest$ < $stop$) {
          ;; HEAP8[$dest$++] = 0;
        }; //@line 529 "tr_languages.cpp"
        var $96=$tr; //@line 530 "tr_languages.cpp"
        __ZL13SetLetterBitsP10TranslatoriPKc($96, 0, ((__ZZ16SelectTranslatorPKcE9el_vowels)&4294967295)); //@line 530 "tr_languages.cpp"
        var $97=$tr; //@line 531 "tr_languages.cpp"
        __ZL13SetLetterBitsP10TranslatoriPKc($97, 7, ((__ZZ16SelectTranslatorPKcE9el_vowels)&4294967295)); //@line 531 "tr_languages.cpp"
        var $98=$tr; //@line 532 "tr_languages.cpp"
        __ZL13SetLetterBitsP10TranslatoriPKc($98, 1, ((__ZZ16SelectTranslatorPKcE12el_voiceless)&4294967295)); //@line 532 "tr_languages.cpp"
        var $99=$tr; //@line 533 "tr_languages.cpp"
        __ZL13SetLetterBitsP10TranslatoriPKc($99, 2, ((__ZZ16SelectTranslatorPKcE13el_consonants)&4294967295)); //@line 533 "tr_languages.cpp"
        var $100=$tr; //@line 534 "tr_languages.cpp"
        __ZL13SetLetterBitsP10TranslatoriPKc($100, 6, ((__ZZ16SelectTranslatorPKcE10el_fvowels)&4294967295)); //@line 534 "tr_languages.cpp"
        var $101=$tr; //@line 536 "tr_languages.cpp"
        var $langopts126=(($101)&4294967295); //@line 536 "tr_languages.cpp"
        var $length_mods127=(($langopts126+176)&4294967295); //@line 536 "tr_languages.cpp"
        var $102=HEAP32[(($length_mods127)>>2)]; //@line 536 "tr_languages.cpp"
        var $103=$tr; //@line 536 "tr_languages.cpp"
        var $langopts128=(($103)&4294967295); //@line 536 "tr_languages.cpp"
        var $length_mods0129=(($langopts128+180)&4294967295); //@line 536 "tr_languages.cpp"
        HEAP32[(($length_mods0129)>>2)]=$102; //@line 536 "tr_languages.cpp"
        var $104=$tr; //@line 537 "tr_languages.cpp"
        var $langopts130=(($104)&4294967295); //@line 537 "tr_languages.cpp"
        var $stress_rule131=(($langopts130+8)&4294967295); //@line 537 "tr_languages.cpp"
        HEAP32[(($stress_rule131)>>2)]=2; //@line 537 "tr_languages.cpp"
        var $105=$tr; //@line 538 "tr_languages.cpp"
        var $langopts132=(($105)&4294967295); //@line 538 "tr_languages.cpp"
        var $stress_flags133=(($langopts132+12)&4294967295); //@line 538 "tr_languages.cpp"
        HEAP32[(($stress_flags133)>>2)]=6; //@line 538 "tr_languages.cpp"
        var $106=$tr; //@line 539 "tr_languages.cpp"
        var $langopts134=(($106)&4294967295); //@line 539 "tr_languages.cpp"
        var $unstressed_wd1135=(($langopts134+16)&4294967295); //@line 539 "tr_languages.cpp"
        HEAP32[(($unstressed_wd1135)>>2)]=0; //@line 539 "tr_languages.cpp"
        var $107=$tr; //@line 540 "tr_languages.cpp"
        var $langopts136=(($107)&4294967295); //@line 540 "tr_languages.cpp"
        var $unstressed_wd2137=(($langopts136+20)&4294967295); //@line 540 "tr_languages.cpp"
        HEAP32[(($unstressed_wd2137)>>2)]=2; //@line 540 "tr_languages.cpp"
        var $108=$tr; //@line 541 "tr_languages.cpp"
        var $langopts138=(($108)&4294967295); //@line 541 "tr_languages.cpp"
        var $param139=(($langopts138+24)&4294967295); //@line 541 "tr_languages.cpp"
        var $arrayidx140=(($param139+28)&4294967295); //@line 541 "tr_languages.cpp"
        HEAP32[(($arrayidx140)>>2)]=130; //@line 541 "tr_languages.cpp"
        var $109=$tr; //@line 543 "tr_languages.cpp"
        var $langopts141=(($109)&4294967295); //@line 543 "tr_languages.cpp"
        var $numbers142=(($langopts141+184)&4294967295); //@line 543 "tr_languages.cpp"
        HEAP32[(($numbers142)>>2)]=264; //@line 543 "tr_languages.cpp"
        var $110=$tr; //@line 544 "tr_languages.cpp"
        var $langopts143=(($110)&4294967295); //@line 544 "tr_languages.cpp"
        var $numbers2=(($langopts143+188)&4294967295); //@line 544 "tr_languages.cpp"
        HEAP32[(($numbers2)>>2)]=4098; //@line 544 "tr_languages.cpp"
        var $111=$name2; //@line 546 "tr_languages.cpp"
        var $cmp144=((($111))|0)==6779491; //@line 546 "tr_languages.cpp"
        if (!($cmp144)) { __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; } //@line 546 "tr_languages.cpp"
  
        var $112=$tr; //@line 549 "tr_languages.cpp"
        var $langopts145=(($112)&4294967295); //@line 549 "tr_languages.cpp"
        var $param146=(($langopts145+24)&4294967295); //@line 549 "tr_languages.cpp"
        var $arrayidx147=(($param146+20)&4294967295); //@line 549 "tr_languages.cpp"
        HEAP32[(($arrayidx147)>>2)]=1; //@line 549 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 550 "tr_languages.cpp"
      }
      else if (__label__ == 15) {
  
        var $113=$tr; //@line 560 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($113, ((__ZZ16SelectTranslatorPKcE17stress_lengths_eo)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_eo)&4294967295)); //@line 560 "tr_languages.cpp"
        var $114=HEAP32[((((_charsets+12)&4294967295))>>2)]; //@line 562 "tr_languages.cpp"
        var $115=$tr; //@line 562 "tr_languages.cpp"
        var $charset_a0149=(($115+696)&4294967295); //@line 562 "tr_languages.cpp"
        HEAP32[(($charset_a0149)>>2)]=$114; //@line 562 "tr_languages.cpp"
        var $116=$tr; //@line 563 "tr_languages.cpp"
        var $char_plus_apostrophe150=(($116+700)&4294967295); //@line 563 "tr_languages.cpp"
        HEAP32[(($char_plus_apostrophe150)>>2)]=((__ZZ16SelectTranslatorPKcE18eo_char_apostrophe)&4294967295); //@line 563 "tr_languages.cpp"
        var $117=$tr; //@line 566 "tr_languages.cpp"
        var $langopts151=(($117)&4294967295); //@line 566 "tr_languages.cpp"
        var $vowel_pause152=(($langopts151+4)&4294967295); //@line 566 "tr_languages.cpp"
        HEAP32[(($vowel_pause152)>>2)]=2; //@line 566 "tr_languages.cpp"
        var $118=$tr; //@line 567 "tr_languages.cpp"
        var $langopts153=(($118)&4294967295); //@line 567 "tr_languages.cpp"
        var $stress_rule154=(($langopts153+8)&4294967295); //@line 567 "tr_languages.cpp"
        HEAP32[(($stress_rule154)>>2)]=2; //@line 567 "tr_languages.cpp"
        var $119=$tr; //@line 568 "tr_languages.cpp"
        var $langopts155=(($119)&4294967295); //@line 568 "tr_languages.cpp"
        var $stress_flags156=(($langopts155+12)&4294967295); //@line 568 "tr_languages.cpp"
        HEAP32[(($stress_flags156)>>2)]=22; //@line 568 "tr_languages.cpp"
        var $120=$tr; //@line 570 "tr_languages.cpp"
        var $langopts157=(($120)&4294967295); //@line 570 "tr_languages.cpp"
        var $unstressed_wd2158=(($langopts157+20)&4294967295); //@line 570 "tr_languages.cpp"
        HEAP32[(($unstressed_wd2158)>>2)]=2; //@line 570 "tr_languages.cpp"
        var $121=$tr; //@line 572 "tr_languages.cpp"
        var $langopts159=(($121)&4294967295); //@line 572 "tr_languages.cpp"
        var $numbers160=(($langopts159+184)&4294967295); //@line 572 "tr_languages.cpp"
        HEAP32[(($numbers160)>>2)]=16782344; //@line 572 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 574 "tr_languages.cpp"
      }
      else if (__label__ == 16) {
  
        var $122=$tr; //@line 585 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($122, ((__ZZ16SelectTranslatorPKcE17stress_lengths_es)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_es)&4294967295)); //@line 585 "tr_languages.cpp"
        var $123=$tr; //@line 587 "tr_languages.cpp"
        var $langopts162=(($123)&4294967295); //@line 587 "tr_languages.cpp"
        var $length_mods163=(($langopts162+176)&4294967295); //@line 587 "tr_languages.cpp"
        var $124=HEAP32[(($length_mods163)>>2)]; //@line 587 "tr_languages.cpp"
        var $125=$tr; //@line 587 "tr_languages.cpp"
        var $langopts164=(($125)&4294967295); //@line 587 "tr_languages.cpp"
        var $length_mods0165=(($langopts164+180)&4294967295); //@line 587 "tr_languages.cpp"
        HEAP32[(($length_mods0165)>>2)]=$124; //@line 587 "tr_languages.cpp"
        var $126=$tr; //@line 588 "tr_languages.cpp"
        var $langopts166=(($126)&4294967295); //@line 588 "tr_languages.cpp"
        var $stress_rule167=(($langopts166+8)&4294967295); //@line 588 "tr_languages.cpp"
        HEAP32[(($stress_rule167)>>2)]=2; //@line 588 "tr_languages.cpp"
        var $127=$tr; //@line 592 "tr_languages.cpp"
        var $langopts168=(($127)&4294967295); //@line 592 "tr_languages.cpp"
        var $stress_flags169=(($langopts168+12)&4294967295); //@line 592 "tr_languages.cpp"
        HEAP32[(($stress_flags169)>>2)]=534; //@line 592 "tr_languages.cpp"
        var $128=$tr; //@line 593 "tr_languages.cpp"
        var $langopts170=(($128)&4294967295); //@line 593 "tr_languages.cpp"
        var $unstressed_wd1171=(($langopts170+16)&4294967295); //@line 593 "tr_languages.cpp"
        HEAP32[(($unstressed_wd1171)>>2)]=0; //@line 593 "tr_languages.cpp"
        var $129=$tr; //@line 594 "tr_languages.cpp"
        var $langopts172=(($129)&4294967295); //@line 594 "tr_languages.cpp"
        var $unstressed_wd2173=(($langopts172+20)&4294967295); //@line 594 "tr_languages.cpp"
        HEAP32[(($unstressed_wd2173)>>2)]=2; //@line 594 "tr_languages.cpp"
        var $130=$tr; //@line 595 "tr_languages.cpp"
        var $langopts174=(($130)&4294967295); //@line 595 "tr_languages.cpp"
        var $param175=(($langopts174+24)&4294967295); //@line 595 "tr_languages.cpp"
        var $arrayidx176=(($param175+28)&4294967295); //@line 595 "tr_languages.cpp"
        HEAP32[(($arrayidx176)>>2)]=120; //@line 595 "tr_languages.cpp"
        var $131=$tr; //@line 597 "tr_languages.cpp"
        var $langopts177=(($131)&4294967295); //@line 597 "tr_languages.cpp"
        var $numbers178=(($langopts177+184)&4294967295); //@line 597 "tr_languages.cpp"
        HEAP32[(($numbers178)>>2)]=85984552; //@line 597 "tr_languages.cpp"
        var $132=$tr; //@line 598 "tr_languages.cpp"
        var $langopts179=(($132)&4294967295); //@line 598 "tr_languages.cpp"
        var $numbers2180=(($langopts179+188)&4294967295); //@line 598 "tr_languages.cpp"
        HEAP32[(($numbers2180)>>2)]=4096; //@line 598 "tr_languages.cpp"
        var $133=$name2; //@line 600 "tr_languages.cpp"
        var $cmp181=((($133))|0)==25441; //@line 600 "tr_languages.cpp"
        if ($cmp181) { __label__ = 17;; } else { __label__ = 18;; } //@line 600 "tr_languages.cpp"
        if (__label__ == 17) {
  
          var $134=$tr; //@line 602 "tr_languages.cpp"
          var $punct_within_word=(($134+704)&4294967295); //@line 602 "tr_languages.cpp"
          HEAP32[(($punct_within_word)>>2)]=((__ZZ16SelectTranslatorPKcE20ca_punct_within_word)&4294967295); //@line 602 "tr_languages.cpp"
          var $135=$tr; //@line 603 "tr_languages.cpp"
          var $langopts183=(($135)&4294967295); //@line 603 "tr_languages.cpp"
          var $stress_flags184=(($langopts183+12)&4294967295); //@line 603 "tr_languages.cpp"
          HEAP32[(($stress_flags184)>>2)]=566; //@line 603 "tr_languages.cpp"
          __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 604 "tr_languages.cpp"
        }
        else if (__label__ == 18) {
  
          var $136=$name2; //@line 606 "tr_languages.cpp"
          var $cmp185=((($136))|0)==7364976; //@line 606 "tr_languages.cpp"
          var $137=$tr; //@line 608 "tr_languages.cpp"
          var $langopts187=(($137)&4294967295); //@line 608 "tr_languages.cpp"
          if ($cmp185) { __label__ = 19;; } else { __label__ = 20;; } //@line 606 "tr_languages.cpp"
          if (__label__ == 19) {
  
            var $stress_flags188=(($langopts187+12)&4294967295); //@line 608 "tr_languages.cpp"
            HEAP32[(($stress_flags188)>>2)]=310; //@line 608 "tr_languages.cpp"
            __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 609 "tr_languages.cpp"
          }
          else if (__label__ == 20) {
  
            var $param191=(($langopts187+24)&4294967295); //@line 612 "tr_languages.cpp"
            var $arrayidx192=(($param191+20)&4294967295); //@line 612 "tr_languages.cpp"
            HEAP32[(($arrayidx192)>>2)]=2; //@line 612 "tr_languages.cpp"
            __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6;
          }
        }
      }
      else if (__label__ == 21) {
  
        var $138=$tr; //@line 621 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($138, ((__ZZ16SelectTranslatorPKcE17stress_lengths_eu)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_eu)&4294967295)); //@line 621 "tr_languages.cpp"
        var $139=$tr; //@line 622 "tr_languages.cpp"
        var $langopts196=(($139)&4294967295); //@line 622 "tr_languages.cpp"
        var $stress_rule197=(($langopts196+8)&4294967295); //@line 622 "tr_languages.cpp"
        HEAP32[(($stress_rule197)>>2)]=1; //@line 622 "tr_languages.cpp"
        var $140=$tr; //@line 623 "tr_languages.cpp"
        var $langopts198=(($140)&4294967295); //@line 623 "tr_languages.cpp"
        var $numbers199=(($langopts198+184)&4294967295); //@line 623 "tr_languages.cpp"
        HEAP32[(($numbers199)>>2)]=1049960; //@line 623 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 625 "tr_languages.cpp"
      }
      else if (__label__ == 22) {
  
        var $141=$tr; //@line 630 "tr_languages.cpp"
        var $letter_bits_offset201=(($141+964)&4294967295); //@line 630 "tr_languages.cpp"
        HEAP32[(($letter_bits_offset201)>>2)]=1536; //@line 630 "tr_languages.cpp"
        var $142=$tr; //@line 631 "tr_languages.cpp"
        var $langopts202=(($142)&4294967295); //@line 631 "tr_languages.cpp"
        var $numbers203=(($langopts202+184)&4294967295); //@line 631 "tr_languages.cpp"
        HEAP32[(($numbers203)>>2)]=96; //@line 631 "tr_languages.cpp"
        var $143=$tr; //@line 632 "tr_languages.cpp"
        var $langopts204=(($143)&4294967295); //@line 632 "tr_languages.cpp"
        var $param205=(($langopts204+24)&4294967295); //@line 632 "tr_languages.cpp"
        var $arrayidx206=(($param205+20)&4294967295); //@line 632 "tr_languages.cpp"
        HEAP32[(($arrayidx206)>>2)]=1; //@line 632 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 634 "tr_languages.cpp"
      }
      else if (__label__ == 23) {
  
        var $144=HEAP32[((((_charsets+16)&4294967295))>>2)]; //@line 638 "tr_languages.cpp"
        var $145=$tr; //@line 638 "tr_languages.cpp"
        var $charset_a0208=(($145+696)&4294967295); //@line 638 "tr_languages.cpp"
        HEAP32[(($charset_a0208)>>2)]=$144; //@line 638 "tr_languages.cpp"
        __label__ = 24;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 638 "tr_languages.cpp"
      }
      else if (__label__ == 25) {
  
        var $155=$tr; //@line 662 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($155, ((__ZZ16SelectTranslatorPKcE17stress_lengths_fr)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_fr)&4294967295)); //@line 662 "tr_languages.cpp"
        var $156=$tr; //@line 663 "tr_languages.cpp"
        var $langopts223=(($156)&4294967295); //@line 663 "tr_languages.cpp"
        var $stress_rule224=(($langopts223+8)&4294967295); //@line 663 "tr_languages.cpp"
        HEAP32[(($stress_rule224)>>2)]=3; //@line 663 "tr_languages.cpp"
        var $157=$tr; //@line 664 "tr_languages.cpp"
        var $langopts225=(($157)&4294967295); //@line 664 "tr_languages.cpp"
        var $stress_flags226=(($langopts225+12)&4294967295); //@line 664 "tr_languages.cpp"
        HEAP32[(($stress_flags226)>>2)]=36; //@line 664 "tr_languages.cpp"
        var $158=$tr; //@line 665 "tr_languages.cpp"
        var $langopts227=(($158)&4294967295); //@line 665 "tr_languages.cpp"
        var $param228=(($langopts227+24)&4294967295); //@line 665 "tr_languages.cpp"
        var $arrayidx229=(($param228+8)&4294967295); //@line 665 "tr_languages.cpp"
        HEAP32[(($arrayidx229)>>2)]=1; //@line 665 "tr_languages.cpp"
        var $159=$tr; //@line 666 "tr_languages.cpp"
        var $langopts230=(($159)&4294967295); //@line 666 "tr_languages.cpp"
        var $length_mods231=(($langopts230+176)&4294967295); //@line 666 "tr_languages.cpp"
        var $160=HEAP32[(($length_mods231)>>2)]; //@line 666 "tr_languages.cpp"
        var $161=$tr; //@line 666 "tr_languages.cpp"
        var $langopts232=(($161)&4294967295); //@line 666 "tr_languages.cpp"
        var $length_mods0233=(($langopts232+180)&4294967295); //@line 666 "tr_languages.cpp"
        HEAP32[(($length_mods0233)>>2)]=$160; //@line 666 "tr_languages.cpp"
        var $162=$tr; //@line 667 "tr_languages.cpp"
        var $langopts234=(($162)&4294967295); //@line 667 "tr_languages.cpp"
        var $accents235=(($langopts234+220)&4294967295); //@line 667 "tr_languages.cpp"
        HEAP32[(($accents235)>>2)]=2; //@line 667 "tr_languages.cpp"
        var $163=$tr; //@line 669 "tr_languages.cpp"
        var $langopts236=(($163)&4294967295); //@line 669 "tr_languages.cpp"
        var $numbers237=(($langopts236+184)&4294967295); //@line 669 "tr_languages.cpp"
        HEAP32[(($numbers237)>>2)]=118658312; //@line 669 "tr_languages.cpp"
        var $164=$tr; //@line 670 "tr_languages.cpp"
        __ZL14SetLetterVowelP10Translatori($164, 121); //@line 670 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 672 "tr_languages.cpp"
      }
      else if (__label__ == 26) {
  
        var $165=$tr; //@line 681 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($165, ((__ZZ16SelectTranslatorPKcE17stress_lengths_hi)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_hi)&4294967295)); //@line 681 "tr_languages.cpp"
        var $166=HEAP32[((((_charsets+76)&4294967295))>>2)]; //@line 682 "tr_languages.cpp"
        var $167=$tr; //@line 682 "tr_languages.cpp"
        var $charset_a0239=(($167+696)&4294967295); //@line 682 "tr_languages.cpp"
        HEAP32[(($charset_a0239)>>2)]=$166; //@line 682 "tr_languages.cpp"
        var $168=$tr; //@line 683 "tr_languages.cpp"
        var $langopts240=(($168)&4294967295); //@line 683 "tr_languages.cpp"
        var $length_mods241=(($langopts240+176)&4294967295); //@line 683 "tr_languages.cpp"
        var $169=HEAP32[(($length_mods241)>>2)]; //@line 683 "tr_languages.cpp"
        var $170=$tr; //@line 683 "tr_languages.cpp"
        var $langopts242=(($170)&4294967295); //@line 683 "tr_languages.cpp"
        var $length_mods0243=(($langopts242+180)&4294967295); //@line 683 "tr_languages.cpp"
        HEAP32[(($length_mods0243)>>2)]=$169; //@line 683 "tr_languages.cpp"
        var $171=$tr; //@line 685 "tr_languages.cpp"
        var $langopts244=(($171)&4294967295); //@line 685 "tr_languages.cpp"
        var $stress_rule245=(($langopts244+8)&4294967295); //@line 685 "tr_languages.cpp"
        HEAP32[(($stress_rule245)>>2)]=6; //@line 685 "tr_languages.cpp"
        var $172=$tr; //@line 686 "tr_languages.cpp"
        var $langopts246=(($172)&4294967295); //@line 686 "tr_languages.cpp"
        var $stress_flags247=(($langopts246+12)&4294967295); //@line 686 "tr_languages.cpp"
        HEAP32[(($stress_flags247)>>2)]=65540; //@line 686 "tr_languages.cpp"
        var $173=$tr; //@line 687 "tr_languages.cpp"
        var $langopts248=(($173)&4294967295); //@line 687 "tr_languages.cpp"
        var $numbers249=(($langopts248+184)&4294967295); //@line 687 "tr_languages.cpp"
        HEAP32[(($numbers249)>>2)]=16; //@line 687 "tr_languages.cpp"
        var $174=$tr; //@line 688 "tr_languages.cpp"
        var $langopts250=(($174)&4294967295); //@line 688 "tr_languages.cpp"
        var $break_numbers251=(($langopts250+192)&4294967295); //@line 688 "tr_languages.cpp"
        HEAP32[(($break_numbers251)>>2)]=84648; //@line 688 "tr_languages.cpp"
        var $175=$tr; //@line 689 "tr_languages.cpp"
        var $letter_bits_offset252=(($175+964)&4294967295); //@line 689 "tr_languages.cpp"
        HEAP32[(($letter_bits_offset252)>>2)]=2304; //@line 689 "tr_languages.cpp"
        var $176=$name2; //@line 691 "tr_languages.cpp"
        var $cmp253=((($176))|0)==28769; //@line 691 "tr_languages.cpp"
        if ($cmp253) { __label__ = 27;; } else { __label__ = 28;; } //@line 691 "tr_languages.cpp"
        if (__label__ == 27) {
  
          var $177=$tr; //@line 693 "tr_languages.cpp"
          var $letter_bits_offset255=(($177+964)&4294967295); //@line 693 "tr_languages.cpp"
          HEAP32[(($letter_bits_offset255)>>2)]=2560; //@line 693 "tr_languages.cpp"
          ; //@line 694 "tr_languages.cpp"
        }
  
        var $178=$tr; //@line 695 "tr_languages.cpp"
        __Z15SetIndicLettersP10Translator($178); //@line 695 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 697 "tr_languages.cpp"
      }
      else if (__label__ == 29) {
  
        var $cmp258=((($7))|0)==29554; //@line 708 "tr_languages.cpp"
        var $179=$tr; //@line 709 "tr_languages.cpp"
        if ($cmp258) { __label__ = 30;; } else { __label__ = 31;; } //@line 708 "tr_languages.cpp"
        if (__label__ == 30) {
  
          __Z15SetupTranslatorP10TranslatorPKsPKh($179, ((__ZZ16SelectTranslatorPKcE17stress_lengths_sr)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_hr)&4294967295)); //@line 709 "tr_languages.cpp"
          ; //@line 709 "tr_languages.cpp"
        }
        else if (__label__ == 31) {
  
          __Z15SetupTranslatorP10TranslatorPKsPKh($179, ((__ZZ16SelectTranslatorPKcE17stress_lengths_hr)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_hr)&4294967295)); //@line 711 "tr_languages.cpp"
          ;
        }
  
        var $180=HEAP32[((((_charsets+8)&4294967295))>>2)]; //@line 712 "tr_languages.cpp"
        var $181=$tr; //@line 712 "tr_languages.cpp"
        var $charset_a0262=(($181+696)&4294967295); //@line 712 "tr_languages.cpp"
        HEAP32[(($charset_a0262)>>2)]=$180; //@line 712 "tr_languages.cpp"
        var $182=$tr; //@line 714 "tr_languages.cpp"
        var $langopts263=(($182)&4294967295); //@line 714 "tr_languages.cpp"
        var $stress_rule264=(($langopts263+8)&4294967295); //@line 714 "tr_languages.cpp"
        HEAP32[(($stress_rule264)>>2)]=0; //@line 714 "tr_languages.cpp"
        var $183=$tr; //@line 715 "tr_languages.cpp"
        var $langopts265=(($183)&4294967295); //@line 715 "tr_languages.cpp"
        var $stress_flags266=(($langopts265+12)&4294967295); //@line 715 "tr_languages.cpp"
        HEAP32[(($stress_flags266)>>2)]=16; //@line 715 "tr_languages.cpp"
        var $184=$tr; //@line 716 "tr_languages.cpp"
        var $langopts267=(($184)&4294967295); //@line 716 "tr_languages.cpp"
        var $param268=(($langopts267+24)&4294967295); //@line 716 "tr_languages.cpp"
        var $arrayidx269=(($param268+16)&4294967295); //@line 716 "tr_languages.cpp"
        HEAP32[(($arrayidx269)>>2)]=3; //@line 716 "tr_languages.cpp"
        var $185=$tr; //@line 717 "tr_languages.cpp"
        var $langopts270=(($185)&4294967295); //@line 717 "tr_languages.cpp"
        var $max_initial_consonants=(($langopts270+248)&4294967295); //@line 717 "tr_languages.cpp"
        HEAP8[($max_initial_consonants)]=5; //@line 717 "tr_languages.cpp"
        var $186=$tr; //@line 718 "tr_languages.cpp"
        var $langopts271=(($186)&4294967295); //@line 718 "tr_languages.cpp"
        var $spelling_stress272=(($langopts271+249)&4294967295); //@line 718 "tr_languages.cpp"
        HEAP8[($spelling_stress272)]=1; //@line 718 "tr_languages.cpp"
        var $187=$tr; //@line 719 "tr_languages.cpp"
        var $langopts273=(($187)&4294967295); //@line 719 "tr_languages.cpp"
        var $accents274=(($langopts273+220)&4294967295); //@line 719 "tr_languages.cpp"
        HEAP32[(($accents274)>>2)]=1; //@line 719 "tr_languages.cpp"
        var $188=$tr; //@line 721 "tr_languages.cpp"
        var $langopts275=(($188)&4294967295); //@line 721 "tr_languages.cpp"
        var $numbers276=(($langopts275+184)&4294967295); //@line 721 "tr_languages.cpp"
        HEAP32[(($numbers276)>>2)]=33572172; //@line 721 "tr_languages.cpp"
        var $189=$tr; //@line 722 "tr_languages.cpp"
        var $langopts277=(($189)&4294967295); //@line 722 "tr_languages.cpp"
        var $numbers2278=(($langopts277+188)&4294967295); //@line 722 "tr_languages.cpp"
        HEAP32[(($numbers2278)>>2)]=74; //@line 722 "tr_languages.cpp"
        var $190=$tr; //@line 723 "tr_languages.cpp"
        var $langopts279=(($190)&4294967295); //@line 723 "tr_languages.cpp"
        var $replace_chars=(($langopts279+264)&4294967295); //@line 723 "tr_languages.cpp"
        HEAP32[(($replace_chars)>>2)]=((__ZL22replace_cyrillic_latin)&4294967295); //@line 723 "tr_languages.cpp"
        var $191=$tr; //@line 725 "tr_languages.cpp"
        __ZL14SetLetterVowelP10Translatori($191, 121); //@line 725 "tr_languages.cpp"
        var $192=$tr; //@line 726 "tr_languages.cpp"
        __ZL14SetLetterVowelP10Translatori($192, 114); //@line 726 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 728 "tr_languages.cpp"
      }
      else if (__label__ == 33) {
  
        var $193=$tr; //@line 733 "tr_languages.cpp"
        var $langopts281=(($193)&4294967295); //@line 733 "tr_languages.cpp"
        var $stress_rule282=(($langopts281+8)&4294967295); //@line 733 "tr_languages.cpp"
        HEAP32[(($stress_rule282)>>2)]=3; //@line 733 "tr_languages.cpp"
        var $194=$tr; //@line 734 "tr_languages.cpp"
        var $langopts283=(($194)&4294967295); //@line 734 "tr_languages.cpp"
        var $stress_flags284=(($langopts283+12)&4294967295); //@line 734 "tr_languages.cpp"
        HEAP32[(($stress_flags284)>>2)]=36; //@line 734 "tr_languages.cpp"
        var $195=$tr; //@line 735 "tr_languages.cpp"
        var $langopts285=(($195)&4294967295); //@line 735 "tr_languages.cpp"
        var $numbers286=(($langopts285+184)&4294967295); //@line 735 "tr_languages.cpp"
        HEAP32[(($numbers286)>>2)]=17990912; //@line 735 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 736 "tr_languages.cpp"
      }
      else if (__label__ == 34) {
  
        var $196=$tr; //@line 744 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($196, ((__ZZ16SelectTranslatorPKcE17stress_lengths_hu)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_hu)&4294967295)); //@line 744 "tr_languages.cpp"
        var $197=HEAP32[((((_charsets+8)&4294967295))>>2)]; //@line 745 "tr_languages.cpp"
        var $198=$tr; //@line 745 "tr_languages.cpp"
        var $charset_a0288=(($198+696)&4294967295); //@line 745 "tr_languages.cpp"
        HEAP32[(($charset_a0288)>>2)]=$197; //@line 745 "tr_languages.cpp"
        var $199=$tr; //@line 747 "tr_languages.cpp"
        var $langopts289=(($199)&4294967295); //@line 747 "tr_languages.cpp"
        var $vowel_pause290=(($langopts289+4)&4294967295); //@line 747 "tr_languages.cpp"
        HEAP32[(($vowel_pause290)>>2)]=32; //@line 747 "tr_languages.cpp"
        var $200=$tr; //@line 748 "tr_languages.cpp"
        var $langopts291=(($200)&4294967295); //@line 748 "tr_languages.cpp"
        var $stress_rule292=(($langopts291+8)&4294967295); //@line 748 "tr_languages.cpp"
        HEAP32[(($stress_rule292)>>2)]=0; //@line 748 "tr_languages.cpp"
        var $201=$tr; //@line 749 "tr_languages.cpp"
        var $langopts293=(($201)&4294967295); //@line 749 "tr_languages.cpp"
        var $stress_flags294=(($langopts293+12)&4294967295); //@line 749 "tr_languages.cpp"
        HEAP32[(($stress_flags294)>>2)]=1081398; //@line 749 "tr_languages.cpp"
        var $202=$tr; //@line 750 "tr_languages.cpp"
        var $langopts295=(($202)&4294967295); //@line 750 "tr_languages.cpp"
        var $unstressed_wd1296=(($langopts295+16)&4294967295); //@line 750 "tr_languages.cpp"
        HEAP32[(($unstressed_wd1296)>>2)]=2; //@line 750 "tr_languages.cpp"
        var $203=$tr; //@line 751 "tr_languages.cpp"
        var $langopts297=(($203)&4294967295); //@line 751 "tr_languages.cpp"
        var $param298=(($langopts297+24)&4294967295); //@line 751 "tr_languages.cpp"
        var $arrayidx299=(($param298+56)&4294967295); //@line 751 "tr_languages.cpp"
        HEAP32[(($arrayidx299)>>2)]=1; //@line 751 "tr_languages.cpp"
        var $204=$tr; //@line 752 "tr_languages.cpp"
        var $langopts300=(($204)&4294967295); //@line 752 "tr_languages.cpp"
        var $param301=(($langopts300+24)&4294967295); //@line 752 "tr_languages.cpp"
        var $arrayidx302=(($param301+68)&4294967295); //@line 752 "tr_languages.cpp"
        HEAP32[(($arrayidx302)>>2)]=2; //@line 752 "tr_languages.cpp"
        var $205=$tr; //@line 754 "tr_languages.cpp"
        var $langopts303=(($205)&4294967295); //@line 754 "tr_languages.cpp"
        var $numbers304=(($langopts303+184)&4294967295); //@line 754 "tr_languages.cpp"
        HEAP32[(($numbers304)>>2)]=186758144; //@line 754 "tr_languages.cpp"
        var $206=$tr; //@line 755 "tr_languages.cpp"
        var $langopts305=(($206)&4294967295); //@line 755 "tr_languages.cpp"
        var $thousands_sep306=(($langopts305+204)&4294967295); //@line 755 "tr_languages.cpp"
        HEAP32[(($thousands_sep306)>>2)]=32; //@line 755 "tr_languages.cpp"
        var $207=$tr; //@line 756 "tr_languages.cpp"
        var $langopts307=(($207)&4294967295); //@line 756 "tr_languages.cpp"
        var $decimal_sep=(($langopts307+208)&4294967295); //@line 756 "tr_languages.cpp"
        HEAP32[(($decimal_sep)>>2)]=44; //@line 756 "tr_languages.cpp"
        var $208=$tr; //@line 757 "tr_languages.cpp"
        var $langopts308=(($208)&4294967295); //@line 757 "tr_languages.cpp"
        var $max_roman=(($langopts308+196)&4294967295); //@line 757 "tr_languages.cpp"
        HEAP32[(($max_roman)>>2)]=899; //@line 757 "tr_languages.cpp"
        var $209=$tr; //@line 758 "tr_languages.cpp"
        var $langopts309=(($209)&4294967295); //@line 758 "tr_languages.cpp"
        var $min_roman=(($langopts309+200)&4294967295); //@line 758 "tr_languages.cpp"
        HEAP32[(($min_roman)>>2)]=1; //@line 758 "tr_languages.cpp"
        var $210=$tr; //@line 759 "tr_languages.cpp"
        __ZL14SetLetterVowelP10Translatori($210, 121); //@line 759 "tr_languages.cpp"
        var $211=$tr; //@line 760 "tr_languages.cpp"
        var $langopts310=(($211)&4294967295); //@line 760 "tr_languages.cpp"
        var $spelling_stress311=(($langopts310+249)&4294967295); //@line 760 "tr_languages.cpp"
        HEAP8[($spelling_stress311)]=1; //@line 760 "tr_languages.cpp"
        var $212=$tr; //@line 761 "tr_languages.cpp"
        __Z13SetLengthModsP10Translatori($212, 3); //@line 761 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 763 "tr_languages.cpp"
      }
      else if (__label__ == 35) {
  
        var $213=$tr; //@line 772 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($213, ((__ZZ16SelectTranslatorPKcE17stress_lengths_hy)&4294967295), 0); //@line 772 "tr_languages.cpp"
        var $214=$tr; //@line 773 "tr_languages.cpp"
        var $langopts313=(($214)&4294967295); //@line 773 "tr_languages.cpp"
        var $stress_rule314=(($langopts313+8)&4294967295); //@line 773 "tr_languages.cpp"
        HEAP32[(($stress_rule314)>>2)]=3; //@line 773 "tr_languages.cpp"
        var $215=$tr; //@line 775 "tr_languages.cpp"
        var $letter_bits_offset315=(($215+964)&4294967295); //@line 775 "tr_languages.cpp"
        HEAP32[(($letter_bits_offset315)>>2)]=1328; //@line 775 "tr_languages.cpp"
        var $216=$tr; //@line 776 "tr_languages.cpp"
        var $letter_bits316=(($216+708)&4294967295); //@line 776 "tr_languages.cpp"
        var $arraydecay317=(($letter_bits316)&4294967295); //@line 776 "tr_languages.cpp"
        var $dest$, $stop$, $stop4$, $fast$, $value4$;
        $dest$ = $arraydecay317;
        $stop$ = $dest$ + 256;
        $value4$ = 0;
        if ($value4$ < 0) $value4$ += 256;
        $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
        while ($dest$%4 !== 0 && $dest$ < $stop$) {
          ;; HEAP8[$dest$++] = 0;
        }
        $dest$ >>= 2;
        $stop4$ = $stop$ >> 2;
        while ($dest$ < $stop4$) {
        ;;;;;;;  HEAP32[$dest$++] = $value4$;
        }
        $dest$ <<= 2;
        while ($dest$ < $stop$) {
          ;; HEAP8[$dest$++] = 0;
        }; //@line 776 "tr_languages.cpp"
        var $217=$tr; //@line 777 "tr_languages.cpp"
        __ZL13SetLetterBitsP10TranslatoriPKc($217, 0, ((__ZZ16SelectTranslatorPKcE9hy_vowels)&4294967295)); //@line 777 "tr_languages.cpp"
        var $218=$tr; //@line 778 "tr_languages.cpp"
        __ZL13SetLetterBitsP10TranslatoriPKc($218, 7, ((__ZZ16SelectTranslatorPKcE9hy_vowels)&4294967295)); //@line 778 "tr_languages.cpp"
        var $219=$tr; //@line 779 "tr_languages.cpp"
        __ZL13SetLetterBitsP10TranslatoriPKc($219, 2, ((__ZZ16SelectTranslatorPKcE13hy_consonants)&4294967295)); //@line 779 "tr_languages.cpp"
        var $220=$tr; //@line 780 "tr_languages.cpp"
        var $langopts318=(($220)&4294967295); //@line 780 "tr_languages.cpp"
        var $max_initial_consonants319=(($langopts318+248)&4294967295); //@line 780 "tr_languages.cpp"
        HEAP8[($max_initial_consonants319)]=6; //@line 780 "tr_languages.cpp"
        var $221=$tr; //@line 781 "tr_languages.cpp"
        var $langopts320=(($221)&4294967295); //@line 781 "tr_languages.cpp"
        var $numbers321=(($langopts320+184)&4294967295); //@line 781 "tr_languages.cpp"
        HEAP32[(($numbers321)>>2)]=1032; //@line 781 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 784 "tr_languages.cpp"
      }
      else if (__label__ == 36) {
  
        var $222=$tr; //@line 791 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($222, ((__ZZ16SelectTranslatorPKcE17stress_lengths_id)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_id)&4294967295)); //@line 791 "tr_languages.cpp"
        var $223=$tr; //@line 792 "tr_languages.cpp"
        var $langopts323=(($223)&4294967295); //@line 792 "tr_languages.cpp"
        var $stress_rule324=(($langopts323+8)&4294967295); //@line 792 "tr_languages.cpp"
        HEAP32[(($stress_rule324)>>2)]=2; //@line 792 "tr_languages.cpp"
        var $224=$tr; //@line 793 "tr_languages.cpp"
        var $langopts325=(($224)&4294967295); //@line 793 "tr_languages.cpp"
        var $numbers326=(($langopts325+184)&4294967295); //@line 793 "tr_languages.cpp"
        HEAP32[(($numbers326)>>2)]=16781320; //@line 793 "tr_languages.cpp"
        var $225=$tr; //@line 794 "tr_languages.cpp"
        var $langopts327=(($225)&4294967295); //@line 794 "tr_languages.cpp"
        var $stress_flags328=(($langopts327+12)&4294967295); //@line 794 "tr_languages.cpp"
        HEAP32[(($stress_flags328)>>2)]=22; //@line 794 "tr_languages.cpp"
        var $226=$tr; //@line 795 "tr_languages.cpp"
        var $langopts329=(($226)&4294967295); //@line 795 "tr_languages.cpp"
        var $accents330=(($langopts329+220)&4294967295); //@line 795 "tr_languages.cpp"
        HEAP32[(($accents330)>>2)]=2; //@line 795 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 797 "tr_languages.cpp"
      }
      else if (__label__ == 37) {
  
        var $227=$tr; //@line 804 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($227, ((__ZZ16SelectTranslatorPKcE17stress_lengths_is)&4294967295), 0); //@line 804 "tr_languages.cpp"
        var $228=$tr; //@line 805 "tr_languages.cpp"
        var $langopts332=(($228)&4294967295); //@line 805 "tr_languages.cpp"
        var $stress_rule333=(($langopts332+8)&4294967295); //@line 805 "tr_languages.cpp"
        HEAP32[(($stress_rule333)>>2)]=0; //@line 805 "tr_languages.cpp"
        var $229=$tr; //@line 806 "tr_languages.cpp"
        var $langopts334=(($229)&4294967295); //@line 806 "tr_languages.cpp"
        var $stress_flags335=(($langopts334+12)&4294967295); //@line 806 "tr_languages.cpp"
        HEAP32[(($stress_flags335)>>2)]=16; //@line 806 "tr_languages.cpp"
        var $230=$tr; //@line 807 "tr_languages.cpp"
        var $langopts336=(($230)&4294967295); //@line 807 "tr_languages.cpp"
        var $param337=(($langopts336+24)&4294967295); //@line 807 "tr_languages.cpp"
        var $arrayidx338=(($param337+8)&4294967295); //@line 807 "tr_languages.cpp"
        HEAP32[(($arrayidx338)>>2)]=17; //@line 807 "tr_languages.cpp"
        var $231=$tr; //@line 808 "tr_languages.cpp"
        var $langopts339=(($231)&4294967295); //@line 808 "tr_languages.cpp"
        var $param340=(($langopts339+24)&4294967295); //@line 808 "tr_languages.cpp"
        var $arrayidx341=(($param340+40)&4294967295); //@line 808 "tr_languages.cpp"
        HEAP32[(($arrayidx341)>>2)]=2; //@line 808 "tr_languages.cpp"
        var $232=$tr; //@line 810 "tr_languages.cpp"
        __ZL15ResetLetterBitsP10Translatori($232, 24); //@line 810 "tr_languages.cpp"
        var $233=$tr; //@line 811 "tr_languages.cpp"
        __ZL13SetLetterBitsP10TranslatoriPKc($233, 4, ((__str1631)&4294967295)); //@line 811 "tr_languages.cpp"
        var $234=$tr; //@line 812 "tr_languages.cpp"
        __ZL13SetLetterBitsP10TranslatoriPKc($234, 3, ((__str2632)&4294967295)); //@line 812 "tr_languages.cpp"
        var $235=$tr; //@line 813 "tr_languages.cpp"
        var $letter_groups=(($235+968)&4294967295); //@line 813 "tr_languages.cpp"
        var $arrayidx342=(($letter_groups+4)&4294967295); //@line 813 "tr_languages.cpp"
        HEAP32[(($arrayidx342)>>2)]=((__ZZ16SelectTranslatorPKcE16is_lettergroup_B)&4294967295); //@line 813 "tr_languages.cpp"
        var $236=$tr; //@line 814 "tr_languages.cpp"
        __ZL14SetLetterVowelP10Translatori($236, 121); //@line 814 "tr_languages.cpp"
        var $237=$tr; //@line 815 "tr_languages.cpp"
        var $langopts343=(($237)&4294967295); //@line 815 "tr_languages.cpp"
        var $numbers344=(($langopts343+184)&4294967295); //@line 815 "tr_languages.cpp"
        HEAP32[(($numbers344)>>2)]=2280; //@line 815 "tr_languages.cpp"
        var $238=$tr; //@line 816 "tr_languages.cpp"
        var $langopts345=(($238)&4294967295); //@line 816 "tr_languages.cpp"
        var $numbers2346=(($langopts345+188)&4294967295); //@line 816 "tr_languages.cpp"
        HEAP32[(($numbers2346)>>2)]=2; //@line 816 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 818 "tr_languages.cpp"
      }
      else if (__label__ == 38) {
  
        var $239=$tr; //@line 825 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($239, ((__ZZ16SelectTranslatorPKcE17stress_lengths_it)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_it)&4294967295)); //@line 825 "tr_languages.cpp"
        var $240=$tr; //@line 827 "tr_languages.cpp"
        var $langopts348=(($240)&4294967295); //@line 827 "tr_languages.cpp"
        var $length_mods349=(($langopts348+176)&4294967295); //@line 827 "tr_languages.cpp"
        var $241=HEAP32[(($length_mods349)>>2)]; //@line 827 "tr_languages.cpp"
        var $242=$tr; //@line 827 "tr_languages.cpp"
        var $langopts350=(($242)&4294967295); //@line 827 "tr_languages.cpp"
        var $length_mods0351=(($langopts350+180)&4294967295); //@line 827 "tr_languages.cpp"
        HEAP32[(($length_mods0351)>>2)]=$241; //@line 827 "tr_languages.cpp"
        var $243=$tr; //@line 828 "tr_languages.cpp"
        var $langopts352=(($243)&4294967295); //@line 828 "tr_languages.cpp"
        var $stress_rule353=(($langopts352+8)&4294967295); //@line 828 "tr_languages.cpp"
        HEAP32[(($stress_rule353)>>2)]=2; //@line 828 "tr_languages.cpp"
        var $244=$tr; //@line 829 "tr_languages.cpp"
        var $langopts354=(($244)&4294967295); //@line 829 "tr_languages.cpp"
        var $stress_flags355=(($langopts354+12)&4294967295); //@line 829 "tr_languages.cpp"
        HEAP32[(($stress_flags355)>>2)]=131088; //@line 829 "tr_languages.cpp"
        var $245=$tr; //@line 830 "tr_languages.cpp"
        var $langopts356=(($245)&4294967295); //@line 830 "tr_languages.cpp"
        var $vowel_pause357=(($langopts356+4)&4294967295); //@line 830 "tr_languages.cpp"
        HEAP32[(($vowel_pause357)>>2)]=1; //@line 830 "tr_languages.cpp"
        var $246=$tr; //@line 831 "tr_languages.cpp"
        var $langopts358=(($246)&4294967295); //@line 831 "tr_languages.cpp"
        var $unstressed_wd1359=(($langopts358+16)&4294967295); //@line 831 "tr_languages.cpp"
        HEAP32[(($unstressed_wd1359)>>2)]=2; //@line 831 "tr_languages.cpp"
        var $247=$tr; //@line 832 "tr_languages.cpp"
        var $langopts360=(($247)&4294967295); //@line 832 "tr_languages.cpp"
        var $unstressed_wd2361=(($langopts360+20)&4294967295); //@line 832 "tr_languages.cpp"
        HEAP32[(($unstressed_wd2361)>>2)]=2; //@line 832 "tr_languages.cpp"
        var $248=$tr; //@line 833 "tr_languages.cpp"
        var $langopts362=(($248)&4294967295); //@line 833 "tr_languages.cpp"
        var $param363=(($langopts362+24)&4294967295); //@line 833 "tr_languages.cpp"
        var $arrayidx364=(($param363+8)&4294967295); //@line 833 "tr_languages.cpp"
        HEAP32[(($arrayidx364)>>2)]=2; //@line 833 "tr_languages.cpp"
        var $249=$tr; //@line 834 "tr_languages.cpp"
        var $langopts365=(($249)&4294967295); //@line 834 "tr_languages.cpp"
        var $param366=(($langopts365+24)&4294967295); //@line 834 "tr_languages.cpp"
        var $arrayidx367=(($param366+56)&4294967295); //@line 834 "tr_languages.cpp"
        HEAP32[(($arrayidx367)>>2)]=2; //@line 834 "tr_languages.cpp"
        var $250=$tr; //@line 835 "tr_languages.cpp"
        var $langopts368=(($250)&4294967295); //@line 835 "tr_languages.cpp"
        var $param369=(($langopts368+24)&4294967295); //@line 835 "tr_languages.cpp"
        var $arrayidx370=(($param369+28)&4294967295); //@line 835 "tr_languages.cpp"
        HEAP32[(($arrayidx370)>>2)]=130; //@line 835 "tr_languages.cpp"
        var $251=$tr; //@line 836 "tr_languages.cpp"
        var $langopts371=(($251)&4294967295); //@line 836 "tr_languages.cpp"
        var $param372=(($langopts371+24)&4294967295); //@line 836 "tr_languages.cpp"
        var $arrayidx373=(($param372+40)&4294967295); //@line 836 "tr_languages.cpp"
        HEAP32[(($arrayidx373)>>2)]=1; //@line 836 "tr_languages.cpp"
        var $252=$tr; //@line 837 "tr_languages.cpp"
        var $langopts374=(($252)&4294967295); //@line 837 "tr_languages.cpp"
        var $param375=(($langopts374+24)&4294967295); //@line 837 "tr_languages.cpp"
        var $arrayidx376=(($param375+60)&4294967295); //@line 837 "tr_languages.cpp"
        HEAP32[(($arrayidx376)>>2)]=2; //@line 837 "tr_languages.cpp"
        var $253=$tr; //@line 838 "tr_languages.cpp"
        var $langopts377=(($253)&4294967295); //@line 838 "tr_languages.cpp"
        var $numbers378=(($langopts377+184)&4294967295); //@line 838 "tr_languages.cpp"
        HEAP32[(($numbers378)>>2)]=16786952; //@line 838 "tr_languages.cpp"
        var $254=$tr; //@line 839 "tr_languages.cpp"
        var $langopts379=(($254)&4294967295); //@line 839 "tr_languages.cpp"
        var $accents380=(($langopts379+220)&4294967295); //@line 839 "tr_languages.cpp"
        HEAP32[(($accents380)>>2)]=2; //@line 839 "tr_languages.cpp"
        var $255=$tr; //@line 840 "tr_languages.cpp"
        __ZL14SetLetterVowelP10Translatori($255, 121); //@line 840 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 842 "tr_languages.cpp"
      }
      else if (__label__ == 39) {
  
        var $256=$tr; //@line 849 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($256, ((__ZZ16SelectTranslatorPKcE18stress_lengths_jbo)&4294967295), 0); //@line 849 "tr_languages.cpp"
        var $257=$tr; //@line 850 "tr_languages.cpp"
        var $langopts382=(($257)&4294967295); //@line 850 "tr_languages.cpp"
        var $stress_rule383=(($langopts382+8)&4294967295); //@line 850 "tr_languages.cpp"
        HEAP32[(($stress_rule383)>>2)]=2; //@line 850 "tr_languages.cpp"
        var $258=$tr; //@line 851 "tr_languages.cpp"
        var $langopts384=(($258)&4294967295); //@line 851 "tr_languages.cpp"
        var $vowel_pause385=(($langopts384+4)&4294967295); //@line 851 "tr_languages.cpp"
        HEAP32[(($vowel_pause385)>>2)]=524; //@line 851 "tr_languages.cpp"
        var $259=$tr; //@line 853 "tr_languages.cpp"
        var $punct_within_word386=(($259+704)&4294967295); //@line 853 "tr_languages.cpp"
        HEAP32[(($punct_within_word386)>>2)]=((__ZZ16SelectTranslatorPKcE21jbo_punct_within_word)&4294967295); //@line 853 "tr_languages.cpp"
        var $260=$tr; //@line 854 "tr_languages.cpp"
        var $langopts387=(($260)&4294967295); //@line 854 "tr_languages.cpp"
        var $param388=(($langopts387+24)&4294967295); //@line 854 "tr_languages.cpp"
        var $arrayidx389=(($param388+52)&4294967295); //@line 854 "tr_languages.cpp"
        HEAP32[(($arrayidx389)>>2)]=2; //@line 854 "tr_languages.cpp"
        var $261=$tr; //@line 855 "tr_languages.cpp"
        __ZL14SetLetterVowelP10Translatori($261, 121); //@line 855 "tr_languages.cpp"
        var $262=$tr; //@line 856 "tr_languages.cpp"
        var $langopts390=(($262)&4294967295); //@line 856 "tr_languages.cpp"
        var $max_lengthmod=(($langopts390+272)&4294967295); //@line 856 "tr_languages.cpp"
        HEAP32[(($max_lengthmod)>>2)]=368; //@line 856 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 858 "tr_languages.cpp"
      }
      else if (__label__ == 40) {
  
        var $263=$tr; //@line 865 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($263, ((__ZZ16SelectTranslatorPKcE17stress_lengths_ta)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_ta)&4294967295)); //@line 865 "tr_languages.cpp"
        var $264=$tr; //@line 866 "tr_languages.cpp"
        var $letter_bits392=(($264+708)&4294967295); //@line 866 "tr_languages.cpp"
        var $arraydecay393=(($letter_bits392)&4294967295); //@line 866 "tr_languages.cpp"
        var $dest$, $stop$, $stop4$, $fast$, $value4$;
        $dest$ = $arraydecay393;
        $stop$ = $dest$ + 256;
        $value4$ = 0;
        if ($value4$ < 0) $value4$ += 256;
        $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
        while ($dest$%4 !== 0 && $dest$ < $stop$) {
          ;; HEAP8[$dest$++] = 0;
        }
        $dest$ >>= 2;
        $stop4$ = $stop$ >> 2;
        while ($dest$ < $stop4$) {
        ;;;;;;;  HEAP32[$dest$++] = $value4$;
        }
        $dest$ <<= 2;
        while ($dest$ < $stop$) {
          ;; HEAP8[$dest$++] = 0;
        }; //@line 866 "tr_languages.cpp"
        var $265=$tr; //@line 867 "tr_languages.cpp"
        __ZL13SetLetterBitsP10TranslatoriPKc($265, 0, ((__ZZ16SelectTranslatorPKcE9ka_vowels)&4294967295)); //@line 867 "tr_languages.cpp"
        var $266=$tr; //@line 868 "tr_languages.cpp"
        __ZL13SetLetterBitsP10TranslatoriPKc($266, 2, ((__ZZ16SelectTranslatorPKcE13ka_consonants)&4294967295)); //@line 868 "tr_languages.cpp"
        var $267=$tr; //@line 869 "tr_languages.cpp"
        __ZL13SetLetterBitsP10TranslatoriPKc($267, 7, ((__ZZ16SelectTranslatorPKcE9ka_vowels)&4294967295)); //@line 869 "tr_languages.cpp"
        var $268=$tr; //@line 871 "tr_languages.cpp"
        var $langopts394=(($268)&4294967295); //@line 871 "tr_languages.cpp"
        var $stress_rule395=(($langopts394+8)&4294967295); //@line 871 "tr_languages.cpp"
        HEAP32[(($stress_rule395)>>2)]=0; //@line 871 "tr_languages.cpp"
        var $269=$tr; //@line 872 "tr_languages.cpp"
        var $langopts396=(($269)&4294967295); //@line 872 "tr_languages.cpp"
        var $stress_flags397=(($langopts396+12)&4294967295); //@line 872 "tr_languages.cpp"
        HEAP32[(($stress_flags397)>>2)]=16; //@line 872 "tr_languages.cpp"
        var $270=$tr; //@line 873 "tr_languages.cpp"
        var $letter_bits_offset398=(($270+964)&4294967295); //@line 873 "tr_languages.cpp"
        HEAP32[(($letter_bits_offset398)>>2)]=4224; //@line 873 "tr_languages.cpp"
        var $271=$tr; //@line 875 "tr_languages.cpp"
        var $langopts399=(($271)&4294967295); //@line 875 "tr_languages.cpp"
        var $max_initial_consonants400=(($langopts399+248)&4294967295); //@line 875 "tr_languages.cpp"
        HEAP8[($max_initial_consonants400)]=7; //@line 875 "tr_languages.cpp"
        var $272=$tr; //@line 876 "tr_languages.cpp"
        var $langopts401=(($272)&4294967295); //@line 876 "tr_languages.cpp"
        var $numbers402=(($langopts401+184)&4294967295); //@line 876 "tr_languages.cpp"
        HEAP32[(($numbers402)>>2)]=3187744; //@line 876 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 878 "tr_languages.cpp"
      }
      else if (__label__ == 41) {
  
        var $273=$tr; //@line 885 "tr_languages.cpp"
        var $letter_bits_offset404=(($273+964)&4294967295); //@line 885 "tr_languages.cpp"
        HEAP32[(($letter_bits_offset404)>>2)]=4352; //@line 885 "tr_languages.cpp"
        var $274=$tr; //@line 886 "tr_languages.cpp"
        var $letter_bits405=(($274+708)&4294967295); //@line 886 "tr_languages.cpp"
        var $arraydecay406=(($letter_bits405)&4294967295); //@line 886 "tr_languages.cpp"
        var $dest$, $stop$, $stop4$, $fast$, $value4$;
        $dest$ = $arraydecay406;
        $stop$ = $dest$ + 256;
        $value4$ = 0;
        if ($value4$ < 0) $value4$ += 256;
        $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
        while ($dest$%4 !== 0 && $dest$ < $stop$) {
          ;; HEAP8[$dest$++] = 0;
        }
        $dest$ >>= 2;
        $stop4$ = $stop$ >> 2;
        while ($dest$ < $stop4$) {
        ;;;;;;;  HEAP32[$dest$++] = $value4$;
        }
        $dest$ <<= 2;
        while ($dest$ < $stop$) {
          ;; HEAP8[$dest$++] = 0;
        }; //@line 886 "tr_languages.cpp"
        var $275=$tr; //@line 887 "tr_languages.cpp"
        __ZL18SetLetterBitsRangeP10Translatoriii($275, 0, 97, 117); //@line 887 "tr_languages.cpp"
        var $276=$tr; //@line 888 "tr_languages.cpp"
        __ZL13SetLetterBitsP10TranslatoriPKc($276, 6, ((__ZZ16SelectTranslatorPKcE10ko_ivowels)&4294967295)); //@line 888 "tr_languages.cpp"
        var $277=$tr; //@line 889 "tr_languages.cpp"
        __ZL13SetLetterBitsP10TranslatoriPKc($277, 5, ((__ZZ16SelectTranslatorPKcE9ko_voiced)&4294967295)); //@line 889 "tr_languages.cpp"
        var $278=$tr; //@line 891 "tr_languages.cpp"
        var $langopts407=(($278)&4294967295); //@line 891 "tr_languages.cpp"
        var $stress_rule408=(($langopts407+8)&4294967295); //@line 891 "tr_languages.cpp"
        HEAP32[(($stress_rule408)>>2)]=8; //@line 891 "tr_languages.cpp"
        var $279=$tr; //@line 892 "tr_languages.cpp"
        var $langopts409=(($279)&4294967295); //@line 892 "tr_languages.cpp"
        var $param410=(($langopts409+24)&4294967295); //@line 892 "tr_languages.cpp"
        var $arrayidx411=(($param410+20)&4294967295); //@line 892 "tr_languages.cpp"
        HEAP32[(($arrayidx411)>>2)]=1; //@line 892 "tr_languages.cpp"
        var $280=$tr; //@line 893 "tr_languages.cpp"
        var $langopts412=(($280)&4294967295); //@line 893 "tr_languages.cpp"
        var $numbers413=(($langopts412+184)&4294967295); //@line 893 "tr_languages.cpp"
        HEAP32[(($numbers413)>>2)]=1024; //@line 893 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 895 "tr_languages.cpp"
      }
      else if (__label__ == 42) {
  
        var $281=$tr; //@line 902 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($281, ((__ZZ16SelectTranslatorPKcE17stress_lengths_ku)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_ku)&4294967295)); //@line 902 "tr_languages.cpp"
        var $282=HEAP32[((((_charsets+36)&4294967295))>>2)]; //@line 903 "tr_languages.cpp"
        var $283=$tr; //@line 903 "tr_languages.cpp"
        var $charset_a0415=(($283+696)&4294967295); //@line 903 "tr_languages.cpp"
        HEAP32[(($charset_a0415)>>2)]=$282; //@line 903 "tr_languages.cpp"
        var $284=$tr; //@line 905 "tr_languages.cpp"
        var $langopts416=(($284)&4294967295); //@line 905 "tr_languages.cpp"
        var $stress_rule417=(($langopts416+8)&4294967295); //@line 905 "tr_languages.cpp"
        HEAP32[(($stress_rule417)>>2)]=7; //@line 905 "tr_languages.cpp"
        var $285=$tr; //@line 907 "tr_languages.cpp"
        var $langopts418=(($285)&4294967295); //@line 907 "tr_languages.cpp"
        var $numbers419=(($langopts418+184)&4294967295); //@line 907 "tr_languages.cpp"
        HEAP32[(($numbers419)>>2)]=263264; //@line 907 "tr_languages.cpp"
        var $286=$tr; //@line 908 "tr_languages.cpp"
        var $langopts420=(($286)&4294967295); //@line 908 "tr_languages.cpp"
        var $max_initial_consonants421=(($langopts420+248)&4294967295); //@line 908 "tr_languages.cpp"
        HEAP8[($max_initial_consonants421)]=2; //@line 908 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 910 "tr_languages.cpp"
      }
      else if (__label__ == 43) {
  
        var $287=HEAP32[((((_charsets+16)&4294967295))>>2)]; //@line 914 "tr_languages.cpp"
        var $288=$tr; //@line 914 "tr_languages.cpp"
        var $charset_a0423=(($288+696)&4294967295); //@line 914 "tr_languages.cpp"
        HEAP32[(($charset_a0423)>>2)]=$287; //@line 914 "tr_languages.cpp"
        var $289=$tr; //@line 915 "tr_languages.cpp"
        var $langopts424=(($289)&4294967295); //@line 915 "tr_languages.cpp"
        var $stress_rule425=(($langopts424+8)&4294967295); //@line 915 "tr_languages.cpp"
        HEAP32[(($stress_rule425)>>2)]=2; //@line 915 "tr_languages.cpp"
        var $290=$tr; //@line 916 "tr_languages.cpp"
        var $langopts426=(($290)&4294967295); //@line 916 "tr_languages.cpp"
        var $stress_flags427=(($langopts426+12)&4294967295); //@line 916 "tr_languages.cpp"
        HEAP32[(($stress_flags427)>>2)]=32; //@line 916 "tr_languages.cpp"
        var $291=$tr; //@line 917 "tr_languages.cpp"
        var $langopts428=(($291)&4294967295); //@line 917 "tr_languages.cpp"
        var $unstressed_wd1429=(($langopts428+16)&4294967295); //@line 917 "tr_languages.cpp"
        HEAP32[(($unstressed_wd1429)>>2)]=0; //@line 917 "tr_languages.cpp"
        var $292=$tr; //@line 918 "tr_languages.cpp"
        var $langopts430=(($292)&4294967295); //@line 918 "tr_languages.cpp"
        var $unstressed_wd2431=(($langopts430+20)&4294967295); //@line 918 "tr_languages.cpp"
        HEAP32[(($unstressed_wd2431)>>2)]=2; //@line 918 "tr_languages.cpp"
        var $293=$tr; //@line 919 "tr_languages.cpp"
        var $langopts432=(($293)&4294967295); //@line 919 "tr_languages.cpp"
        var $param433=(($langopts432+24)&4294967295); //@line 919 "tr_languages.cpp"
        var $arrayidx434=(($param433+4)&4294967295); //@line 919 "tr_languages.cpp"
        HEAP32[(($arrayidx434)>>2)]=1; //@line 919 "tr_languages.cpp"
        var $294=$tr; //@line 920 "tr_languages.cpp"
        var $langopts435=(($294)&4294967295); //@line 920 "tr_languages.cpp"
        var $numbers436=(($langopts435+184)&4294967295); //@line 920 "tr_languages.cpp"
        HEAP32[(($numbers436)>>2)]=16777216; //@line 920 "tr_languages.cpp"
        var $295=$tr; //@line 921 "tr_languages.cpp"
        var $langopts437=(($295)&4294967295); //@line 921 "tr_languages.cpp"
        var $max_roman438=(($langopts437+196)&4294967295); //@line 921 "tr_languages.cpp"
        HEAP32[(($max_roman438)>>2)]=5000; //@line 921 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 923 "tr_languages.cpp"
      }
      else if (__label__ == 44) {
  
        var $296=$tr; //@line 930 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($296, ((__ZZ16SelectTranslatorPKcE17stress_lengths_lv)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_lv)&4294967295)); //@line 930 "tr_languages.cpp"
        var $297=$tr; //@line 932 "tr_languages.cpp"
        var $langopts440=(($297)&4294967295); //@line 932 "tr_languages.cpp"
        var $stress_rule441=(($langopts440+8)&4294967295); //@line 932 "tr_languages.cpp"
        HEAP32[(($stress_rule441)>>2)]=0; //@line 932 "tr_languages.cpp"
        var $298=$tr; //@line 933 "tr_languages.cpp"
        var $langopts442=(($298)&4294967295); //@line 933 "tr_languages.cpp"
        var $spelling_stress443=(($langopts442+249)&4294967295); //@line 933 "tr_languages.cpp"
        HEAP8[($spelling_stress443)]=1; //@line 933 "tr_languages.cpp"
        var $299=HEAP32[((((_charsets+16)&4294967295))>>2)]; //@line 934 "tr_languages.cpp"
        var $300=$tr; //@line 934 "tr_languages.cpp"
        var $charset_a0444=(($300+696)&4294967295); //@line 934 "tr_languages.cpp"
        HEAP32[(($charset_a0444)>>2)]=$299; //@line 934 "tr_languages.cpp"
        var $301=$tr; //@line 935 "tr_languages.cpp"
        var $langopts445=(($301)&4294967295); //@line 935 "tr_languages.cpp"
        var $numbers446=(($langopts445+184)&4294967295); //@line 935 "tr_languages.cpp"
        HEAP32[(($numbers446)>>2)]=99336; //@line 935 "tr_languages.cpp"
        var $302=$tr; //@line 936 "tr_languages.cpp"
        var $langopts447=(($302)&4294967295); //@line 936 "tr_languages.cpp"
        var $stress_flags448=(($langopts447+12)&4294967295); //@line 936 "tr_languages.cpp"
        HEAP32[(($stress_flags448)>>2)]=262166; //@line 936 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 938 "tr_languages.cpp"
      }
      else if (__label__ == 45) {
  
        var $303=$tr; //@line 947 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($303, ((__ZZ16SelectTranslatorPKcE17stress_lengths_mk)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_mk)&4294967295)); //@line 947 "tr_languages.cpp"
        var $304=HEAP32[((((_charsets+20)&4294967295))>>2)]; //@line 948 "tr_languages.cpp"
        var $305=$tr; //@line 948 "tr_languages.cpp"
        var $charset_a0450=(($305+696)&4294967295); //@line 948 "tr_languages.cpp"
        HEAP32[(($charset_a0450)>>2)]=$304; //@line 948 "tr_languages.cpp"
        var $306=$tr; //@line 949 "tr_languages.cpp"
        var $letter_groups451=(($306+968)&4294967295); //@line 949 "tr_languages.cpp"
        var $arrayidx452=(($letter_groups451+28)&4294967295); //@line 949 "tr_languages.cpp"
        HEAP32[(($arrayidx452)>>2)]=((__ZZ16SelectTranslatorPKcE15vowels_cyrillic)&4294967295); //@line 949 "tr_languages.cpp"
        var $307=$tr; //@line 949 "tr_languages.cpp"
        var $letter_groups453=(($307+968)&4294967295); //@line 949 "tr_languages.cpp"
        var $arrayidx454=(($letter_groups453)&4294967295); //@line 949 "tr_languages.cpp"
        HEAP32[(($arrayidx454)>>2)]=((__ZZ16SelectTranslatorPKcE15vowels_cyrillic)&4294967295); //@line 949 "tr_languages.cpp"
        var $308=$tr; //@line 951 "tr_languages.cpp"
        var $langopts455=(($308)&4294967295); //@line 951 "tr_languages.cpp"
        var $stress_rule456=(($langopts455+8)&4294967295); //@line 951 "tr_languages.cpp"
        HEAP32[(($stress_rule456)>>2)]=4; //@line 951 "tr_languages.cpp"
        var $309=$tr; //@line 952 "tr_languages.cpp"
        var $langopts457=(($309)&4294967295); //@line 952 "tr_languages.cpp"
        var $numbers458=(($langopts457+184)&4294967295); //@line 952 "tr_languages.cpp"
        HEAP32[(($numbers458)>>2)]=2114600; //@line 952 "tr_languages.cpp"
        var $310=$tr; //@line 953 "tr_languages.cpp"
        var $langopts459=(($310)&4294967295); //@line 953 "tr_languages.cpp"
        var $numbers2460=(($langopts459+188)&4294967295); //@line 953 "tr_languages.cpp"
        HEAP32[(($numbers2460)>>2)]=138; //@line 953 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 955 "tr_languages.cpp"
      }
      else if (__label__ == 46) {
  
        var $311=$tr; //@line 962 "tr_languages.cpp"
        var $langopts462=(($311)&4294967295); //@line 962 "tr_languages.cpp"
        var $stress_rule463=(($langopts462+8)&4294967295); //@line 962 "tr_languages.cpp"
        HEAP32[(($stress_rule463)>>2)]=0; //@line 962 "tr_languages.cpp"
        var $312=$tr; //@line 963 "tr_languages.cpp"
        var $langopts464=(($312)&4294967295); //@line 963 "tr_languages.cpp"
        var $vowel_pause465=(($langopts464+4)&4294967295); //@line 963 "tr_languages.cpp"
        HEAP32[(($vowel_pause465)>>2)]=48; //@line 963 "tr_languages.cpp"
        var $313=$tr; //@line 964 "tr_languages.cpp"
        var $langopts466=(($313)&4294967295); //@line 964 "tr_languages.cpp"
        var $param467=(($langopts466+24)&4294967295); //@line 964 "tr_languages.cpp"
        var $arrayidx468=(($param467+4)&4294967295); //@line 964 "tr_languages.cpp"
        HEAP32[(($arrayidx468)>>2)]=1; //@line 964 "tr_languages.cpp"
        var $314=$tr; //@line 965 "tr_languages.cpp"
        var $langopts469=(($314)&4294967295); //@line 965 "tr_languages.cpp"
        var $param470=(($langopts469+24)&4294967295); //@line 965 "tr_languages.cpp"
        var $arrayidx471=(($param470+12)&4294967295); //@line 965 "tr_languages.cpp"
        HEAP32[(($arrayidx471)>>2)]=1; //@line 965 "tr_languages.cpp"
        var $315=$tr; //@line 966 "tr_languages.cpp"
        var $langopts472=(($315)&4294967295); //@line 966 "tr_languages.cpp"
        var $param473=(($langopts472+24)&4294967295); //@line 966 "tr_languages.cpp"
        var $arrayidx474=(($param473+16)&4294967295); //@line 966 "tr_languages.cpp"
        HEAP32[(($arrayidx474)>>2)]=16; //@line 966 "tr_languages.cpp"
        var $316=$tr; //@line 967 "tr_languages.cpp"
        __ZL14SetLetterVowelP10Translatori($316, 121); //@line 967 "tr_languages.cpp"
        var $317=$tr; //@line 969 "tr_languages.cpp"
        var $langopts475=(($317)&4294967295); //@line 969 "tr_languages.cpp"
        var $numbers476=(($langopts475+184)&4294967295); //@line 969 "tr_languages.cpp"
        HEAP32[(($numbers476)>>2)]=2169880; //@line 969 "tr_languages.cpp"
        var $318=$tr; //@line 970 "tr_languages.cpp"
        var $langopts477=(($318)&4294967295); //@line 970 "tr_languages.cpp"
        var $ordinal_indicator=(($langopts477+216)&4294967295); //@line 970 "tr_languages.cpp"
        HEAP32[(($ordinal_indicator)>>2)]=((__str3633)&4294967295); //@line 970 "tr_languages.cpp"
        var $319=$tr; //@line 971 "tr_languages.cpp"
        var $langopts478=(($319)&4294967295); //@line 971 "tr_languages.cpp"
        var $stress_flags479=(($langopts478+12)&4294967295); //@line 971 "tr_languages.cpp"
        HEAP32[(($stress_flags479)>>2)]=128; //@line 971 "tr_languages.cpp"
        var $320=$tr; //@line 972 "tr_languages.cpp"
        var $stress_lengths=(($320+676)&4294967295); //@line 972 "tr_languages.cpp"
        var $arraydecay480=(($stress_lengths)&4294967295); //@line 972 "tr_languages.cpp"
        var $321=$arraydecay480; //@line 972 "tr_languages.cpp"
        var $src$, $dest$, $stop$, $stop4$, $fast$;
        $src$ = __ZZ16SelectTranslatorPKcE17stress_lengths_nl;
        $dest$ = $321;
        $stop$ = $src$ + 16;
        if (($dest$%4) == ($src$%4) && 16 > 8) {
          while ($src$%4 !== 0 && $src$ < $stop$) {
            ; HEAP8[$dest$++] = HEAP8[$src$++];
          }
          $src$ >>= 2;
          $dest$ >>= 2;
          $stop4$ = $stop$ >> 2;
          while ($src$ < $stop4$) {
        ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
          }
          $src$ <<= 2;
          $dest$ <<= 2;
        }while ($src$ < $stop$) {
          ; HEAP8[$dest$++] = HEAP8[$src$++];
        }; //@line 972 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 974 "tr_languages.cpp"
      }
      else if (__label__ == 47) {
  
        var $322=$tr; //@line 980 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($322, ((__ZZ16SelectTranslatorPKcE17stress_lengths_no)&4294967295), 0); //@line 980 "tr_languages.cpp"
        var $323=$tr; //@line 981 "tr_languages.cpp"
        var $langopts482=(($323)&4294967295); //@line 981 "tr_languages.cpp"
        var $stress_rule483=(($langopts482+8)&4294967295); //@line 981 "tr_languages.cpp"
        HEAP32[(($stress_rule483)>>2)]=0; //@line 981 "tr_languages.cpp"
        var $324=$tr; //@line 982 "tr_languages.cpp"
        __ZL14SetLetterVowelP10Translatori($324, 121); //@line 982 "tr_languages.cpp"
        var $325=$tr; //@line 983 "tr_languages.cpp"
        var $langopts484=(($325)&4294967295); //@line 983 "tr_languages.cpp"
        var $numbers485=(($langopts484+184)&4294967295); //@line 983 "tr_languages.cpp"
        HEAP32[(($numbers485)>>2)]=71752; //@line 983 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 985 "tr_languages.cpp"
      }
      else if (__label__ == 48) {
  
        var $326=$tr; //@line 992 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($326, ((__ZZ16SelectTranslatorPKcE17stress_lengths_om)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_om)&4294967295)); //@line 992 "tr_languages.cpp"
        var $327=$tr; //@line 993 "tr_languages.cpp"
        var $langopts487=(($327)&4294967295); //@line 993 "tr_languages.cpp"
        var $stress_rule488=(($langopts487+8)&4294967295); //@line 993 "tr_languages.cpp"
        HEAP32[(($stress_rule488)>>2)]=2; //@line 993 "tr_languages.cpp"
        var $328=$tr; //@line 994 "tr_languages.cpp"
        var $langopts489=(($328)&4294967295); //@line 994 "tr_languages.cpp"
        var $stress_flags490=(($langopts489+12)&4294967295); //@line 994 "tr_languages.cpp"
        HEAP32[(($stress_flags490)>>2)]=524310; //@line 994 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 996 "tr_languages.cpp"
      }
      else if (__label__ == 49) {
  
        var $329=$tr; //@line 1003 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($329, ((__ZZ16SelectTranslatorPKcE17stress_lengths_pl)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_pl)&4294967295)); //@line 1003 "tr_languages.cpp"
        var $330=HEAP32[((((_charsets+8)&4294967295))>>2)]; //@line 1005 "tr_languages.cpp"
        var $331=$tr; //@line 1005 "tr_languages.cpp"
        var $charset_a0492=(($331+696)&4294967295); //@line 1005 "tr_languages.cpp"
        HEAP32[(($charset_a0492)>>2)]=$330; //@line 1005 "tr_languages.cpp"
        var $332=$tr; //@line 1006 "tr_languages.cpp"
        var $langopts493=(($332)&4294967295); //@line 1006 "tr_languages.cpp"
        var $stress_rule494=(($langopts493+8)&4294967295); //@line 1006 "tr_languages.cpp"
        HEAP32[(($stress_rule494)>>2)]=2; //@line 1006 "tr_languages.cpp"
        var $333=$tr; //@line 1007 "tr_languages.cpp"
        var $langopts495=(($333)&4294967295); //@line 1007 "tr_languages.cpp"
        var $stress_flags496=(($langopts495+12)&4294967295); //@line 1007 "tr_languages.cpp"
        HEAP32[(($stress_flags496)>>2)]=6; //@line 1007 "tr_languages.cpp"
        var $334=$tr; //@line 1008 "tr_languages.cpp"
        var $langopts497=(($334)&4294967295); //@line 1008 "tr_languages.cpp"
        var $param498=(($langopts497+24)&4294967295); //@line 1008 "tr_languages.cpp"
        var $arrayidx499=(($param498+16)&4294967295); //@line 1008 "tr_languages.cpp"
        HEAP32[(($arrayidx499)>>2)]=8; //@line 1008 "tr_languages.cpp"
        var $335=$tr; //@line 1009 "tr_languages.cpp"
        var $langopts500=(($335)&4294967295); //@line 1009 "tr_languages.cpp"
        var $max_initial_consonants501=(($langopts500+248)&4294967295); //@line 1009 "tr_languages.cpp"
        HEAP8[($max_initial_consonants501)]=7; //@line 1009 "tr_languages.cpp"
        var $336=$tr; //@line 1010 "tr_languages.cpp"
        var $langopts502=(($336)&4294967295); //@line 1010 "tr_languages.cpp"
        var $numbers503=(($langopts502+184)&4294967295); //@line 1010 "tr_languages.cpp"
        HEAP32[(($numbers503)>>2)]=20488; //@line 1010 "tr_languages.cpp"
        var $337=$tr; //@line 1011 "tr_languages.cpp"
        var $langopts504=(($337)&4294967295); //@line 1011 "tr_languages.cpp"
        var $numbers2505=(($langopts504+188)&4294967295); //@line 1011 "tr_languages.cpp"
        HEAP32[(($numbers2505)>>2)]=64; //@line 1011 "tr_languages.cpp"
        var $338=$tr; //@line 1012 "tr_languages.cpp"
        var $langopts506=(($338)&4294967295); //@line 1012 "tr_languages.cpp"
        var $param507=(($langopts506+24)&4294967295); //@line 1012 "tr_languages.cpp"
        var $arrayidx508=(($param507+44)&4294967295); //@line 1012 "tr_languages.cpp"
        HEAP32[(($arrayidx508)>>2)]=260; //@line 1012 "tr_languages.cpp"
        var $339=$tr; //@line 1013 "tr_languages.cpp"
        __ZL14SetLetterVowelP10Translatori($339, 121); //@line 1013 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 1015 "tr_languages.cpp"
      }
      else if (__label__ == 50) {
  
        var $340=$tr; //@line 1022 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($340, ((__ZZ16SelectTranslatorPKcE17stress_lengths_pt)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_pt)&4294967295)); //@line 1022 "tr_languages.cpp"
        var $341=$tr; //@line 1023 "tr_languages.cpp"
        var $langopts510=(($341)&4294967295); //@line 1023 "tr_languages.cpp"
        var $length_mods511=(($langopts510+176)&4294967295); //@line 1023 "tr_languages.cpp"
        var $342=HEAP32[(($length_mods511)>>2)]; //@line 1023 "tr_languages.cpp"
        var $343=$tr; //@line 1023 "tr_languages.cpp"
        var $langopts512=(($343)&4294967295); //@line 1023 "tr_languages.cpp"
        var $length_mods0513=(($langopts512+180)&4294967295); //@line 1023 "tr_languages.cpp"
        HEAP32[(($length_mods0513)>>2)]=$342; //@line 1023 "tr_languages.cpp"
        var $344=$tr; //@line 1025 "tr_languages.cpp"
        var $langopts514=(($344)&4294967295); //@line 1025 "tr_languages.cpp"
        var $stress_rule515=(($langopts514+8)&4294967295); //@line 1025 "tr_languages.cpp"
        HEAP32[(($stress_rule515)>>2)]=3; //@line 1025 "tr_languages.cpp"
        var $345=$tr; //@line 1026 "tr_languages.cpp"
        var $langopts516=(($345)&4294967295); //@line 1026 "tr_languages.cpp"
        var $stress_flags517=(($langopts516+12)&4294967295); //@line 1026 "tr_languages.cpp"
        HEAP32[(($stress_flags517)>>2)]=139286; //@line 1026 "tr_languages.cpp"
        var $346=$tr; //@line 1027 "tr_languages.cpp"
        var $langopts518=(($346)&4294967295); //@line 1027 "tr_languages.cpp"
        var $numbers519=(($langopts518+184)&4294967295); //@line 1027 "tr_languages.cpp"
        HEAP32[(($numbers519)>>2)]=16793704; //@line 1027 "tr_languages.cpp"
        var $347=$tr; //@line 1028 "tr_languages.cpp"
        __ZL14SetLetterVowelP10Translatori($347, 121); //@line 1028 "tr_languages.cpp"
        var $348=$tr; //@line 1029 "tr_languages.cpp"
        __ZL15ResetLetterBitsP10Translatori($348, 2); //@line 1029 "tr_languages.cpp"
        var $349=$tr; //@line 1030 "tr_languages.cpp"
        __ZL13SetLetterBitsP10TranslatoriPKc($349, 1, ((__str4634)&4294967295)); //@line 1030 "tr_languages.cpp"
        var $350=$tr; //@line 1031 "tr_languages.cpp"
        var $langopts520=(($350)&4294967295); //@line 1031 "tr_languages.cpp"
        var $param521=(($langopts520+24)&4294967295); //@line 1031 "tr_languages.cpp"
        var $arrayidx522=(($param521+60)&4294967295); //@line 1031 "tr_languages.cpp"
        HEAP32[(($arrayidx522)>>2)]=2; //@line 1031 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 1033 "tr_languages.cpp"
      }
      else if (__label__ == 51) {
  
        var $351=$tr; //@line 1040 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($351, ((__ZZ16SelectTranslatorPKcE17stress_lengths_ro)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_ro)&4294967295)); //@line 1040 "tr_languages.cpp"
        var $352=$tr; //@line 1042 "tr_languages.cpp"
        var $langopts524=(($352)&4294967295); //@line 1042 "tr_languages.cpp"
        var $stress_rule525=(($langopts524+8)&4294967295); //@line 1042 "tr_languages.cpp"
        HEAP32[(($stress_rule525)>>2)]=2; //@line 1042 "tr_languages.cpp"
        var $353=$tr; //@line 1043 "tr_languages.cpp"
        var $langopts526=(($353)&4294967295); //@line 1043 "tr_languages.cpp"
        var $stress_flags527=(($langopts526+12)&4294967295); //@line 1043 "tr_languages.cpp"
        HEAP32[(($stress_flags527)>>2)]=262; //@line 1043 "tr_languages.cpp"
        var $354=HEAP32[((((_charsets+8)&4294967295))>>2)]; //@line 1045 "tr_languages.cpp"
        var $355=$tr; //@line 1045 "tr_languages.cpp"
        var $charset_a0528=(($355+696)&4294967295); //@line 1045 "tr_languages.cpp"
        HEAP32[(($charset_a0528)>>2)]=$354; //@line 1045 "tr_languages.cpp"
        var $356=$tr; //@line 1046 "tr_languages.cpp"
        var $langopts529=(($356)&4294967295); //@line 1046 "tr_languages.cpp"
        var $numbers530=(($langopts529+184)&4294967295); //@line 1046 "tr_languages.cpp"
        HEAP32[(($numbers530)>>2)]=16805928; //@line 1046 "tr_languages.cpp"
        var $357=$tr; //@line 1047 "tr_languages.cpp"
        var $langopts531=(($357)&4294967295); //@line 1047 "tr_languages.cpp"
        var $numbers2532=(($langopts531+188)&4294967295); //@line 1047 "tr_languages.cpp"
        HEAP32[(($numbers2532)>>2)]=30; //@line 1047 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 1049 "tr_languages.cpp"
      }
      else if (__label__ == 52) {
  
        var $358=$tr; //@line 1052 "tr_languages.cpp"
        __ZL18Translator_RussianP10Translator($358); //@line 1052 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 1053 "tr_languages.cpp"
      }
      else if (__label__ == 53) {
  
        var $359=$tr; //@line 1057 "tr_languages.cpp"
        var $langopts535=(($359)&4294967295); //@line 1057 "tr_languages.cpp"
        var $stress_rule536=(($langopts535+8)&4294967295); //@line 1057 "tr_languages.cpp"
        HEAP32[(($stress_rule536)>>2)]=2; //@line 1057 "tr_languages.cpp"
        var $360=$tr; //@line 1058 "tr_languages.cpp"
        var $langopts537=(($360)&4294967295); //@line 1058 "tr_languages.cpp"
        var $stress_flags538=(($langopts537+12)&4294967295); //@line 1058 "tr_languages.cpp"
        HEAP32[(($stress_flags538)>>2)]=22; //@line 1058 "tr_languages.cpp"
        var $361=$tr; //@line 1059 "tr_languages.cpp"
        var $langopts539=(($361)&4294967295); //@line 1059 "tr_languages.cpp"
        var $length_mods540=(($langopts539+176)&4294967295); //@line 1059 "tr_languages.cpp"
        var $362=HEAP32[(($length_mods540)>>2)]; //@line 1059 "tr_languages.cpp"
        var $363=$tr; //@line 1059 "tr_languages.cpp"
        var $langopts541=(($363)&4294967295); //@line 1059 "tr_languages.cpp"
        var $length_mods0542=(($langopts541+180)&4294967295); //@line 1059 "tr_languages.cpp"
        HEAP32[(($length_mods0542)>>2)]=$362; //@line 1059 "tr_languages.cpp"
        var $364=$tr; //@line 1061 "tr_languages.cpp"
        var $langopts543=(($364)&4294967295); //@line 1061 "tr_languages.cpp"
        var $numbers544=(($langopts543+184)&4294967295); //@line 1061 "tr_languages.cpp"
        HEAP32[(($numbers544)>>2)]=278624; //@line 1061 "tr_languages.cpp"
        var $365=$tr; //@line 1062 "tr_languages.cpp"
        var $langopts545=(($365)&4294967295); //@line 1062 "tr_languages.cpp"
        var $numbers2546=(($langopts545+188)&4294967295); //@line 1062 "tr_languages.cpp"
        HEAP32[(($numbers2546)>>2)]=512; //@line 1062 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 1064 "tr_languages.cpp"
      }
      else if (__label__ == 54) {
  
        var $366=$tr; //@line 1071 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($366, ((__ZZ16SelectTranslatorPKcE17stress_lengths_sk)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_sk)&4294967295)); //@line 1071 "tr_languages.cpp"
        var $367=HEAP32[((((_charsets+8)&4294967295))>>2)]; //@line 1072 "tr_languages.cpp"
        var $368=$tr; //@line 1072 "tr_languages.cpp"
        var $charset_a0548=(($368+696)&4294967295); //@line 1072 "tr_languages.cpp"
        HEAP32[(($charset_a0548)>>2)]=$367; //@line 1072 "tr_languages.cpp"
        var $369=$tr; //@line 1074 "tr_languages.cpp"
        var $langopts549=(($369)&4294967295); //@line 1074 "tr_languages.cpp"
        var $stress_rule550=(($langopts549+8)&4294967295); //@line 1074 "tr_languages.cpp"
        HEAP32[(($stress_rule550)>>2)]=0; //@line 1074 "tr_languages.cpp"
        var $370=$tr; //@line 1075 "tr_languages.cpp"
        var $langopts551=(($370)&4294967295); //@line 1075 "tr_languages.cpp"
        var $stress_flags552=(($langopts551+12)&4294967295); //@line 1075 "tr_languages.cpp"
        HEAP32[(($stress_flags552)>>2)]=22; //@line 1075 "tr_languages.cpp"
        var $371=$tr; //@line 1076 "tr_languages.cpp"
        var $langopts553=(($371)&4294967295); //@line 1076 "tr_languages.cpp"
        var $param554=(($langopts553+24)&4294967295); //@line 1076 "tr_languages.cpp"
        var $arrayidx555=(($param554+16)&4294967295); //@line 1076 "tr_languages.cpp"
        HEAP32[(($arrayidx555)>>2)]=3; //@line 1076 "tr_languages.cpp"
        var $372=$tr; //@line 1077 "tr_languages.cpp"
        var $langopts556=(($372)&4294967295); //@line 1077 "tr_languages.cpp"
        var $max_initial_consonants557=(($langopts556+248)&4294967295); //@line 1077 "tr_languages.cpp"
        HEAP8[($max_initial_consonants557)]=5; //@line 1077 "tr_languages.cpp"
        var $373=$tr; //@line 1078 "tr_languages.cpp"
        var $langopts558=(($373)&4294967295); //@line 1078 "tr_languages.cpp"
        var $spelling_stress559=(($langopts558+249)&4294967295); //@line 1078 "tr_languages.cpp"
        HEAP8[($spelling_stress559)]=1; //@line 1078 "tr_languages.cpp"
        var $374=$tr; //@line 1079 "tr_languages.cpp"
        var $langopts560=(($374)&4294967295); //@line 1079 "tr_languages.cpp"
        var $param561=(($langopts560+24)&4294967295); //@line 1079 "tr_languages.cpp"
        var $arrayidx562=(($param561+44)&4294967295); //@line 1079 "tr_languages.cpp"
        HEAP32[(($arrayidx562)>>2)]=4; //@line 1079 "tr_languages.cpp"
        var $375=$tr; //@line 1081 "tr_languages.cpp"
        var $langopts563=(($375)&4294967295); //@line 1081 "tr_languages.cpp"
        var $numbers564=(($langopts563+184)&4294967295); //@line 1081 "tr_languages.cpp"
        HEAP32[(($numbers564)>>2)]=16794624; //@line 1081 "tr_languages.cpp"
        var $376=$tr; //@line 1082 "tr_languages.cpp"
        var $langopts565=(($376)&4294967295); //@line 1082 "tr_languages.cpp"
        var $numbers2566=(($langopts565+188)&4294967295); //@line 1082 "tr_languages.cpp"
        HEAP32[(($numbers2566)>>2)]=256; //@line 1082 "tr_languages.cpp"
        var $377=$tr; //@line 1083 "tr_languages.cpp"
        var $langopts567=(($377)&4294967295); //@line 1083 "tr_languages.cpp"
        var $thousands_sep568=(($langopts567+204)&4294967295); //@line 1083 "tr_languages.cpp"
        HEAP32[(($thousands_sep568)>>2)]=0; //@line 1083 "tr_languages.cpp"
        var $378=$tr; //@line 1084 "tr_languages.cpp"
        var $langopts569=(($378)&4294967295); //@line 1084 "tr_languages.cpp"
        var $decimal_sep570=(($langopts569+208)&4294967295); //@line 1084 "tr_languages.cpp"
        HEAP32[(($decimal_sep570)>>2)]=44; //@line 1084 "tr_languages.cpp"
        var $379=$name2; //@line 1086 "tr_languages.cpp"
        var $cmp571=((($379))|0)==25459; //@line 1086 "tr_languages.cpp"
        if ($cmp571) { __label__ = 55;; } else { __label__ = 56;; } //@line 1086 "tr_languages.cpp"
        if (__label__ == 55) {
  
          var $380=$tr; //@line 1088 "tr_languages.cpp"
          var $langopts573=(($380)&4294967295); //@line 1088 "tr_languages.cpp"
          var $numbers2574=(($langopts573+188)&4294967295); //@line 1088 "tr_languages.cpp"
          HEAP32[(($numbers2574)>>2)]=264; //@line 1088 "tr_languages.cpp"
          ; //@line 1089 "tr_languages.cpp"
        }
  
        var $381=$tr; //@line 1091 "tr_languages.cpp"
        __ZL14SetLetterVowelP10Translatori($381, 121); //@line 1091 "tr_languages.cpp"
        var $382=$tr; //@line 1092 "tr_languages.cpp"
        __ZL14SetLetterVowelP10Translatori($382, 114); //@line 1092 "tr_languages.cpp"
        var $383=$tr; //@line 1093 "tr_languages.cpp"
        __ZL15ResetLetterBitsP10Translatori($383, 32); //@line 1093 "tr_languages.cpp"
        var $384=$tr; //@line 1094 "tr_languages.cpp"
        __ZL13SetLetterBitsP10TranslatoriPKc($384, 5, ((__str5635)&4294967295)); //@line 1094 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 1096 "tr_languages.cpp"
      }
      else if (__label__ == 57) {
  
        var $385=$tr; //@line 1100 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($385, ((__ZZ16SelectTranslatorPKcE17stress_lengths_ta)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_ta)&4294967295)); //@line 1100 "tr_languages.cpp"
        var $386=$tr; //@line 1101 "tr_languages.cpp"
        var $langopts577=(($386)&4294967295); //@line 1101 "tr_languages.cpp"
        var $length_mods578=(($langopts577+176)&4294967295); //@line 1101 "tr_languages.cpp"
        var $387=HEAP32[(($length_mods578)>>2)]; //@line 1101 "tr_languages.cpp"
        var $388=$tr; //@line 1101 "tr_languages.cpp"
        var $langopts579=(($388)&4294967295); //@line 1101 "tr_languages.cpp"
        var $length_mods0580=(($langopts579+180)&4294967295); //@line 1101 "tr_languages.cpp"
        HEAP32[(($length_mods0580)>>2)]=$387; //@line 1101 "tr_languages.cpp"
        var $389=$tr; //@line 1103 "tr_languages.cpp"
        var $langopts581=(($389)&4294967295); //@line 1103 "tr_languages.cpp"
        var $stress_rule582=(($langopts581+8)&4294967295); //@line 1103 "tr_languages.cpp"
        HEAP32[(($stress_rule582)>>2)]=0; //@line 1103 "tr_languages.cpp"
        var $390=$tr; //@line 1104 "tr_languages.cpp"
        var $langopts583=(($390)&4294967295); //@line 1104 "tr_languages.cpp"
        var $stress_flags584=(($langopts583+12)&4294967295); //@line 1104 "tr_languages.cpp"
        HEAP32[(($stress_flags584)>>2)]=65556; //@line 1104 "tr_languages.cpp"
        var $391=$tr; //@line 1105 "tr_languages.cpp"
        var $langopts585=(($391)&4294967295); //@line 1105 "tr_languages.cpp"
        var $spelling_stress586=(($langopts585+249)&4294967295); //@line 1105 "tr_languages.cpp"
        HEAP8[($spelling_stress586)]=1; //@line 1105 "tr_languages.cpp"
        var $392=$tr; //@line 1107 "tr_languages.cpp"
        var $letter_bits_offset587=(($392+964)&4294967295); //@line 1107 "tr_languages.cpp"
        HEAP32[(($letter_bits_offset587)>>2)]=3456; //@line 1107 "tr_languages.cpp"
        var $393=$tr; //@line 1108 "tr_languages.cpp"
        var $letter_bits588=(($393+708)&4294967295); //@line 1108 "tr_languages.cpp"
        var $arraydecay589=(($letter_bits588)&4294967295); //@line 1108 "tr_languages.cpp"
        var $dest$, $stop$, $stop4$, $fast$, $value4$;
        $dest$ = $arraydecay589;
        $stop$ = $dest$ + 256;
        $value4$ = 0;
        if ($value4$ < 0) $value4$ += 256;
        $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
        while ($dest$%4 !== 0 && $dest$ < $stop$) {
          ;; HEAP8[$dest$++] = 0;
        }
        $dest$ >>= 2;
        $stop4$ = $stop$ >> 2;
        while ($dest$ < $stop4$) {
        ;;;;;;;  HEAP32[$dest$++] = $value4$;
        }
        $dest$ <<= 2;
        while ($dest$ < $stop$) {
          ;; HEAP8[$dest$++] = 0;
        }; //@line 1108 "tr_languages.cpp"
        var $394=$tr; //@line 1109 "tr_languages.cpp"
        __ZL18SetLetterBitsRangeP10Translatoriii($394, 0, 5, 22); //@line 1109 "tr_languages.cpp"
        var $395=$tr; //@line 1110 "tr_languages.cpp"
        __ZL18SetLetterBitsRangeP10Translatoriii($395, 0, 74, 115); //@line 1110 "tr_languages.cpp"
        var $396=$tr; //@line 1112 "tr_languages.cpp"
        __ZL18SetLetterBitsRangeP10Translatoriii($396, 1, 74, 115); //@line 1112 "tr_languages.cpp"
        var $397=$tr; //@line 1114 "tr_languages.cpp"
        __ZL18SetLetterBitsRangeP10Translatoriii($397, 2, 26, 70); //@line 1114 "tr_languages.cpp"
        var $398=$tr; //@line 1116 "tr_languages.cpp"
        var $langopts590=(($398)&4294967295); //@line 1116 "tr_languages.cpp"
        var $param591=(($langopts590+24)&4294967295); //@line 1116 "tr_languages.cpp"
        var $arrayidx592=(($param591+20)&4294967295); //@line 1116 "tr_languages.cpp"
        HEAP32[(($arrayidx592)>>2)]=1; //@line 1116 "tr_languages.cpp"
        var $399=$tr; //@line 1117 "tr_languages.cpp"
        var $letter_bits_offset593=(($399+964)&4294967295); //@line 1117 "tr_languages.cpp"
        var $400=HEAP32[(($letter_bits_offset593)>>2)]; //@line 1117 "tr_languages.cpp"
        var $add594=((($400)+74)&4294967295); //@line 1117 "tr_languages.cpp"
        var $401=$tr; //@line 1117 "tr_languages.cpp"
        var $langopts595=(($401)&4294967295); //@line 1117 "tr_languages.cpp"
        var $suffix_add_e596=(($langopts595+276)&4294967295); //@line 1117 "tr_languages.cpp"
        HEAP32[(($suffix_add_e596)>>2)]=$add594; //@line 1117 "tr_languages.cpp"
        var $402=$tr; //@line 1118 "tr_languages.cpp"
        var $langopts597=(($402)&4294967295); //@line 1118 "tr_languages.cpp"
        var $numbers598=(($langopts597+184)&4294967295); //@line 1118 "tr_languages.cpp"
        HEAP32[(($numbers598)>>2)]=2097152; //@line 1118 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 1120 "tr_languages.cpp"
      }
      else if (__label__ == 58) {
  
        var $403=HEAP32[((((_charsets+8)&4294967295))>>2)]; //@line 1123 "tr_languages.cpp"
        var $404=$tr; //@line 1123 "tr_languages.cpp"
        var $charset_a0600=(($404+696)&4294967295); //@line 1123 "tr_languages.cpp"
        HEAP32[(($charset_a0600)>>2)]=$403; //@line 1123 "tr_languages.cpp"
        var $405=$tr; //@line 1124 "tr_languages.cpp"
        var $langopts601=(($405)&4294967295); //@line 1124 "tr_languages.cpp"
        var $stress_rule602=(($langopts601+8)&4294967295); //@line 1124 "tr_languages.cpp"
        HEAP32[(($stress_rule602)>>2)]=2; //@line 1124 "tr_languages.cpp"
        var $406=$tr; //@line 1125 "tr_languages.cpp"
        var $langopts603=(($406)&4294967295); //@line 1125 "tr_languages.cpp"
        var $stress_flags604=(($langopts603+12)&4294967295); //@line 1125 "tr_languages.cpp"
        HEAP32[(($stress_flags604)>>2)]=32; //@line 1125 "tr_languages.cpp"
        var $407=$tr; //@line 1126 "tr_languages.cpp"
        var $langopts605=(($407)&4294967295); //@line 1126 "tr_languages.cpp"
        var $param606=(($langopts605+24)&4294967295); //@line 1126 "tr_languages.cpp"
        var $arrayidx607=(($param606+16)&4294967295); //@line 1126 "tr_languages.cpp"
        HEAP32[(($arrayidx607)>>2)]=19; //@line 1126 "tr_languages.cpp"
        var $408=$tr; //@line 1127 "tr_languages.cpp"
        var $langopts608=(($408)&4294967295); //@line 1127 "tr_languages.cpp"
        var $numbers609=(($langopts608+184)&4294967295); //@line 1127 "tr_languages.cpp"
        HEAP32[(($numbers609)>>2)]=16864280; //@line 1127 "tr_languages.cpp"
        var $409=$tr; //@line 1128 "tr_languages.cpp"
        var $langopts610=(($409)&4294967295); //@line 1128 "tr_languages.cpp"
        var $numbers2611=(($langopts610+188)&4294967295); //@line 1128 "tr_languages.cpp"
        HEAP32[(($numbers2611)>>2)]=256; //@line 1128 "tr_languages.cpp"
        var $410=$tr; //@line 1129 "tr_languages.cpp"
        var $langopts612=(($410)&4294967295); //@line 1129 "tr_languages.cpp"
        var $thousands_sep613=(($langopts612+204)&4294967295); //@line 1129 "tr_languages.cpp"
        HEAP32[(($thousands_sep613)>>2)]=32; //@line 1129 "tr_languages.cpp"
        var $411=$tr; //@line 1130 "tr_languages.cpp"
        __ZL14SetLetterVowelP10Translatori($411, 114); //@line 1130 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 1131 "tr_languages.cpp"
      }
      else if (__label__ == 59) {
  
        var $412=$tr; //@line 1138 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($412, ((__ZZ16SelectTranslatorPKcE17stress_lengths_sq)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_sq)&4294967295)); //@line 1138 "tr_languages.cpp"
        var $413=$tr; //@line 1140 "tr_languages.cpp"
        var $langopts615=(($413)&4294967295); //@line 1140 "tr_languages.cpp"
        var $stress_rule616=(($langopts615+8)&4294967295); //@line 1140 "tr_languages.cpp"
        HEAP32[(($stress_rule616)>>2)]=2; //@line 1140 "tr_languages.cpp"
        var $414=$tr; //@line 1141 "tr_languages.cpp"
        var $langopts617=(($414)&4294967295); //@line 1141 "tr_languages.cpp"
        var $stress_flags618=(($langopts617+12)&4294967295); //@line 1141 "tr_languages.cpp"
        HEAP32[(($stress_flags618)>>2)]=278; //@line 1141 "tr_languages.cpp"
        var $415=$tr; //@line 1142 "tr_languages.cpp"
        __ZL14SetLetterVowelP10Translatori($415, 121); //@line 1142 "tr_languages.cpp"
        var $416=$tr; //@line 1143 "tr_languages.cpp"
        var $langopts619=(($416)&4294967295); //@line 1143 "tr_languages.cpp"
        var $numbers620=(($langopts619+184)&4294967295); //@line 1143 "tr_languages.cpp"
        HEAP32[(($numbers620)>>2)]=32872; //@line 1143 "tr_languages.cpp"
        var $417=$tr; //@line 1144 "tr_languages.cpp"
        var $langopts621=(($417)&4294967295); //@line 1144 "tr_languages.cpp"
        var $accents622=(($langopts621+220)&4294967295); //@line 1144 "tr_languages.cpp"
        HEAP32[(($accents622)>>2)]=2; //@line 1144 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 1146 "tr_languages.cpp"
      }
      else if (__label__ == 60) {
  
        var $418=$tr; //@line 1153 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($418, ((__ZZ16SelectTranslatorPKcE17stress_lengths_sv)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_sv)&4294967295)); //@line 1153 "tr_languages.cpp"
        var $419=$tr; //@line 1155 "tr_languages.cpp"
        var $langopts624=(($419)&4294967295); //@line 1155 "tr_languages.cpp"
        var $stress_rule625=(($langopts624+8)&4294967295); //@line 1155 "tr_languages.cpp"
        HEAP32[(($stress_rule625)>>2)]=0; //@line 1155 "tr_languages.cpp"
        var $420=$tr; //@line 1156 "tr_languages.cpp"
        __ZL14SetLetterVowelP10Translatori($420, 121); //@line 1156 "tr_languages.cpp"
        var $421=$tr; //@line 1157 "tr_languages.cpp"
        var $langopts626=(($421)&4294967295); //@line 1157 "tr_languages.cpp"
        var $numbers627=(($langopts626+184)&4294967295); //@line 1157 "tr_languages.cpp"
        HEAP32[(($numbers627)>>2)]=6408; //@line 1157 "tr_languages.cpp"
        var $422=$tr; //@line 1158 "tr_languages.cpp"
        var $langopts628=(($422)&4294967295); //@line 1158 "tr_languages.cpp"
        var $accents629=(($langopts628+220)&4294967295); //@line 1158 "tr_languages.cpp"
        HEAP32[(($accents629)>>2)]=1; //@line 1158 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 1160 "tr_languages.cpp"
      }
      else if (__label__ == 61) {
  
        var $423=$tr; //@line 1168 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($423, ((__ZZ16SelectTranslatorPKcE17stress_lengths_sw)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_sw)&4294967295)); //@line 1168 "tr_languages.cpp"
        var $424=$tr; //@line 1169 "tr_languages.cpp"
        var $langopts631=(($424)&4294967295); //@line 1169 "tr_languages.cpp"
        var $length_mods632=(($langopts631+176)&4294967295); //@line 1169 "tr_languages.cpp"
        var $425=HEAP32[(($length_mods632)>>2)]; //@line 1169 "tr_languages.cpp"
        var $426=$tr; //@line 1169 "tr_languages.cpp"
        var $langopts633=(($426)&4294967295); //@line 1169 "tr_languages.cpp"
        var $length_mods0634=(($langopts633+180)&4294967295); //@line 1169 "tr_languages.cpp"
        HEAP32[(($length_mods0634)>>2)]=$425; //@line 1169 "tr_languages.cpp"
        var $427=$tr; //@line 1171 "tr_languages.cpp"
        var $langopts635=(($427)&4294967295); //@line 1171 "tr_languages.cpp"
        var $vowel_pause636=(($langopts635+4)&4294967295); //@line 1171 "tr_languages.cpp"
        HEAP32[(($vowel_pause636)>>2)]=1; //@line 1171 "tr_languages.cpp"
        var $428=$tr; //@line 1172 "tr_languages.cpp"
        var $langopts637=(($428)&4294967295); //@line 1172 "tr_languages.cpp"
        var $stress_rule638=(($langopts637+8)&4294967295); //@line 1172 "tr_languages.cpp"
        HEAP32[(($stress_rule638)>>2)]=2; //@line 1172 "tr_languages.cpp"
        var $429=$tr; //@line 1173 "tr_languages.cpp"
        var $langopts639=(($429)&4294967295); //@line 1173 "tr_languages.cpp"
        var $stress_flags640=(($langopts639+12)&4294967295); //@line 1173 "tr_languages.cpp"
        HEAP32[(($stress_flags640)>>2)]=22; //@line 1173 "tr_languages.cpp"
        var $430=$tr; //@line 1175 "tr_languages.cpp"
        var $langopts641=(($430)&4294967295); //@line 1175 "tr_languages.cpp"
        var $numbers642=(($langopts641+184)&4294967295); //@line 1175 "tr_languages.cpp"
        HEAP32[(($numbers642)>>2)]=1248; //@line 1175 "tr_languages.cpp"
        var $431=$tr; //@line 1176 "tr_languages.cpp"
        var $langopts643=(($431)&4294967295); //@line 1176 "tr_languages.cpp"
        var $break_numbers644=(($langopts643+192)&4294967295); //@line 1176 "tr_languages.cpp"
        HEAP32[(($break_numbers644)>>2)]=1227133544; //@line 1176 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 1178 "tr_languages.cpp"
      }
      else if (__label__ == 62) {
  
        var $432=$tr; //@line 1186 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($432, ((__ZZ16SelectTranslatorPKcE17stress_lengths_ta)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_ta)&4294967295)); //@line 1186 "tr_languages.cpp"
        var $433=$tr; //@line 1187 "tr_languages.cpp"
        var $langopts646=(($433)&4294967295); //@line 1187 "tr_languages.cpp"
        var $length_mods647=(($langopts646+176)&4294967295); //@line 1187 "tr_languages.cpp"
        var $434=HEAP32[(($length_mods647)>>2)]; //@line 1187 "tr_languages.cpp"
        var $435=$tr; //@line 1187 "tr_languages.cpp"
        var $langopts648=(($435)&4294967295); //@line 1187 "tr_languages.cpp"
        var $length_mods0649=(($langopts648+180)&4294967295); //@line 1187 "tr_languages.cpp"
        HEAP32[(($length_mods0649)>>2)]=$434; //@line 1187 "tr_languages.cpp"
        var $436=$tr; //@line 1189 "tr_languages.cpp"
        var $langopts650=(($436)&4294967295); //@line 1189 "tr_languages.cpp"
        var $stress_rule651=(($langopts650+8)&4294967295); //@line 1189 "tr_languages.cpp"
        HEAP32[(($stress_rule651)>>2)]=0; //@line 1189 "tr_languages.cpp"
        var $437=$tr; //@line 1190 "tr_languages.cpp"
        var $langopts652=(($437)&4294967295); //@line 1190 "tr_languages.cpp"
        var $stress_flags653=(($langopts652+12)&4294967295); //@line 1190 "tr_languages.cpp"
        HEAP32[(($stress_flags653)>>2)]=65540; //@line 1190 "tr_languages.cpp"
        var $438=$tr; //@line 1191 "tr_languages.cpp"
        var $langopts654=(($438)&4294967295); //@line 1191 "tr_languages.cpp"
        var $spelling_stress655=(($langopts654+249)&4294967295); //@line 1191 "tr_languages.cpp"
        HEAP8[($spelling_stress655)]=1; //@line 1191 "tr_languages.cpp"
        var $439=$tr; //@line 1192 "tr_languages.cpp"
        var $langopts656=(($439)&4294967295); //@line 1192 "tr_languages.cpp"
        var $break_numbers657=(($langopts656+192)&4294967295); //@line 1192 "tr_languages.cpp"
        HEAP32[(($break_numbers657)>>2)]=5288; //@line 1192 "tr_languages.cpp"
        var $440=$name2; //@line 1194 "tr_languages.cpp"
        var $cmp658=((($440))|0)==29793; //@line 1194 "tr_languages.cpp"
        if ($cmp658) { __lastLabel__ = 62; __label__ = 63;; } else { __lastLabel__ = 62; __label__ = 64;; } //@line 1194 "tr_languages.cpp"
        if (__label__ == 63) {
  
          var $441=$tr; //@line 1196 "tr_languages.cpp"
          var $letter_bits_offset660=(($441+964)&4294967295); //@line 1196 "tr_languages.cpp"
          HEAP32[(($letter_bits_offset660)>>2)]=2944; //@line 1196 "tr_languages.cpp"
          var $442=$tr; //@line 1197 "tr_languages.cpp"
          var $langopts661=(($442)&4294967295); //@line 1197 "tr_languages.cpp"
          var $numbers662=(($langopts661+184)&4294967295); //@line 1197 "tr_languages.cpp"
          HEAP32[(($numbers662)>>2)]=2097152; //@line 1197 "tr_languages.cpp"
          var $_pr=$name2; //@line 1199 "tr_languages.cpp"
          __lastLabel__ = 63; ; //@line 1198 "tr_languages.cpp"
        }
  
        var $443=__lastLabel__ == 63 ? $_pr : ($440); //@line 1199 "tr_languages.cpp"
        var $cmp664=((($443))|0)==28018; //@line 1199 "tr_languages.cpp"
        if ($cmp664) { __label__ = 65;; } else { __label__ = 66;; } //@line 1199 "tr_languages.cpp"
        $if_then665$$if_else667$75: do { 
          if (__label__ == 65) {
  
            var $444=$tr; //@line 1201 "tr_languages.cpp"
            var $letter_bits_offset666=(($444+964)&4294967295); //@line 1201 "tr_languages.cpp"
            HEAP32[(($letter_bits_offset666)>>2)]=2304; //@line 1201 "tr_languages.cpp"
            ; //@line 1202 "tr_languages.cpp"
          }
          else if (__label__ == 66) {
  
            var $445=$name2; //@line 1204 "tr_languages.cpp"
            var $cmp668=((($445))|0)==28012; //@line 1204 "tr_languages.cpp"
            if ($cmp668) { __label__ = 67;; } else { __label__ = 68;; } //@line 1204 "tr_languages.cpp"
            if (__label__ == 67) {
  
              var $446=$tr; //@line 1206 "tr_languages.cpp"
              var $letter_bits_offset670=(($446+964)&4294967295); //@line 1206 "tr_languages.cpp"
              HEAP32[(($letter_bits_offset670)>>2)]=3328; //@line 1206 "tr_languages.cpp"
              var $447=$tr; //@line 1207 "tr_languages.cpp"
              var $langopts671=(($447)&4294967295); //@line 1207 "tr_languages.cpp"
              var $numbers672=(($langopts671+184)&4294967295); //@line 1207 "tr_languages.cpp"
              HEAP32[(($numbers672)>>2)]=2097152; //@line 1207 "tr_languages.cpp"
              ; //@line 1208 "tr_languages.cpp"
            }
            else if (__label__ == 68) {
  
              var $448=$name2; //@line 1210 "tr_languages.cpp"
              var $cmp674=((($448))|0)==27502; //@line 1210 "tr_languages.cpp"
              if ($cmp674) { __label__ = 69;; } else { __label__ = 70;; } //@line 1210 "tr_languages.cpp"
              if (__label__ == 69) {
  
                var $449=$tr; //@line 1212 "tr_languages.cpp"
                var $letter_bits_offset676=(($449+964)&4294967295); //@line 1212 "tr_languages.cpp"
                HEAP32[(($letter_bits_offset676)>>2)]=3200; //@line 1212 "tr_languages.cpp"
                var $450=$tr; //@line 1213 "tr_languages.cpp"
                var $langopts677=(($450)&4294967295); //@line 1213 "tr_languages.cpp"
                var $numbers678=(($langopts677+184)&4294967295); //@line 1213 "tr_languages.cpp"
                HEAP32[(($numbers678)>>2)]=1; //@line 1213 "tr_languages.cpp"
                ; //@line 1214 "tr_languages.cpp"
              }
              else if (__label__ == 70) {
  
                var $451=$name2; //@line 1216 "tr_languages.cpp"
                var $cmp680=((($451))|0)==29797; //@line 1216 "tr_languages.cpp"
                if (!($cmp680)) { __label__ = 72;break $if_then665$$if_else667$75; } //@line 1216 "tr_languages.cpp"
  
                var $452=$tr; //@line 1218 "tr_languages.cpp"
                var $letter_bits_offset682=(($452+964)&4294967295); //@line 1218 "tr_languages.cpp"
                HEAP32[(($letter_bits_offset682)>>2)]=3072; //@line 1218 "tr_languages.cpp"
                var $453=$tr; //@line 1219 "tr_languages.cpp"
                var $langopts683=(($453)&4294967295); //@line 1219 "tr_languages.cpp"
                var $numbers684=(($langopts683+184)&4294967295); //@line 1219 "tr_languages.cpp"
                HEAP32[(($numbers684)>>2)]=1; //@line 1219 "tr_languages.cpp"
                ; //@line 1220 "tr_languages.cpp"
              }
            }
          }
        } while(0);
  
        var $454=$tr; //@line 1221 "tr_languages.cpp"
        var $langopts689=(($454)&4294967295); //@line 1221 "tr_languages.cpp"
        var $param690=(($langopts689+24)&4294967295); //@line 1221 "tr_languages.cpp"
        var $arrayidx691=(($param690+32)&4294967295); //@line 1221 "tr_languages.cpp"
        HEAP32[(($arrayidx691)>>2)]=1; //@line 1221 "tr_languages.cpp"
        var $455=$tr; //@line 1222 "tr_languages.cpp"
        __Z15SetIndicLettersP10Translator($455); //@line 1222 "tr_languages.cpp"
        var $456=$tr; //@line 1223 "tr_languages.cpp"
        __ZL18SetLetterBitsRangeP10Translatoriii($456, 1, 78, 78); //@line 1223 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 1225 "tr_languages.cpp"
      }
      else if (__label__ == 73) {
  
        var $457=$tr; //@line 1250 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($457, ((__ZZ16SelectTranslatorPKcE17stress_lengths_tr)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_tr)&4294967295)); //@line 1250 "tr_languages.cpp"
        var $458=HEAP32[((((_charsets+36)&4294967295))>>2)]; //@line 1251 "tr_languages.cpp"
        var $459=$tr; //@line 1251 "tr_languages.cpp"
        var $charset_a0693=(($459+696)&4294967295); //@line 1251 "tr_languages.cpp"
        HEAP32[(($charset_a0693)>>2)]=$458; //@line 1251 "tr_languages.cpp"
        var $460=$tr; //@line 1253 "tr_languages.cpp"
        var $langopts694=(($460)&4294967295); //@line 1253 "tr_languages.cpp"
        var $stress_rule695=(($langopts694+8)&4294967295); //@line 1253 "tr_languages.cpp"
        HEAP32[(($stress_rule695)>>2)]=7; //@line 1253 "tr_languages.cpp"
        var $461=$tr; //@line 1254 "tr_languages.cpp"
        var $langopts696=(($461)&4294967295); //@line 1254 "tr_languages.cpp"
        var $stress_flags697=(($langopts696+12)&4294967295); //@line 1254 "tr_languages.cpp"
        HEAP32[(($stress_flags697)>>2)]=32; //@line 1254 "tr_languages.cpp"
        var $462=$tr; //@line 1256 "tr_languages.cpp"
        var $langopts698=(($462)&4294967295); //@line 1256 "tr_languages.cpp"
        var $numbers699=(($langopts698+184)&4294967295); //@line 1256 "tr_languages.cpp"
        HEAP32[(($numbers699)>>2)]=2114824; //@line 1256 "tr_languages.cpp"
        var $463=$tr; //@line 1257 "tr_languages.cpp"
        var $langopts700=(($463)&4294967295); //@line 1257 "tr_languages.cpp"
        var $max_initial_consonants701=(($langopts700+248)&4294967295); //@line 1257 "tr_languages.cpp"
        HEAP8[($max_initial_consonants701)]=2; //@line 1257 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 1259 "tr_languages.cpp"
      }
      else if (__label__ == 74) {
  
        var $464=$tr; //@line 1262 "tr_languages.cpp"
        var $letter_bits_offset703=(($464+964)&4294967295); //@line 1262 "tr_languages.cpp"
        HEAP32[(($letter_bits_offset703)>>2)]=1536; //@line 1262 "tr_languages.cpp"
        var $465=$tr; //@line 1263 "tr_languages.cpp"
        var $langopts704=(($465)&4294967295); //@line 1263 "tr_languages.cpp"
        var $param705=(($langopts704+24)&4294967295); //@line 1263 "tr_languages.cpp"
        var $arrayidx706=(($param705+20)&4294967295); //@line 1263 "tr_languages.cpp"
        HEAP32[(($arrayidx706)>>2)]=1; //@line 1263 "tr_languages.cpp"
        var $466=$tr; //@line 1264 "tr_languages.cpp"
        var $langopts707=(($466)&4294967295); //@line 1264 "tr_languages.cpp"
        var $numbers708=(($langopts707+184)&4294967295); //@line 1264 "tr_languages.cpp"
        HEAP32[(($numbers708)>>2)]=16; //@line 1264 "tr_languages.cpp"
        var $467=$tr; //@line 1265 "tr_languages.cpp"
        var $langopts709=(($467)&4294967295); //@line 1265 "tr_languages.cpp"
        var $break_numbers710=(($langopts709+192)&4294967295); //@line 1265 "tr_languages.cpp"
        HEAP32[(($break_numbers710)>>2)]=21160; //@line 1265 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 1266 "tr_languages.cpp"
      }
      else if (__label__ == 75) {
  
        var $468=$tr; //@line 1286 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($468, ((__ZZ16SelectTranslatorPKcE17stress_lengths_vi)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_vi)&4294967295)); //@line 1286 "tr_languages.cpp"
        var $469=$tr; //@line 1287 "tr_languages.cpp"
        var $langopts712=(($469)&4294967295); //@line 1287 "tr_languages.cpp"
        var $length_mods713=(($langopts712+176)&4294967295); //@line 1287 "tr_languages.cpp"
        var $470=HEAP32[(($length_mods713)>>2)]; //@line 1287 "tr_languages.cpp"
        var $471=$tr; //@line 1287 "tr_languages.cpp"
        var $langopts714=(($471)&4294967295); //@line 1287 "tr_languages.cpp"
        var $length_mods0715=(($langopts714+180)&4294967295); //@line 1287 "tr_languages.cpp"
        HEAP32[(($length_mods0715)>>2)]=$470; //@line 1287 "tr_languages.cpp"
        var $472=$tr; //@line 1289 "tr_languages.cpp"
        var $langopts716=(($472)&4294967295); //@line 1289 "tr_languages.cpp"
        var $stress_rule717=(($langopts716+8)&4294967295); //@line 1289 "tr_languages.cpp"
        HEAP32[(($stress_rule717)>>2)]=0; //@line 1289 "tr_languages.cpp"
        var $473=$tr; //@line 1290 "tr_languages.cpp"
        var $langopts718=(($473)&4294967295); //@line 1290 "tr_languages.cpp"
        var $word_gap719=(($langopts718)&4294967295); //@line 1290 "tr_languages.cpp"
        HEAP32[(($word_gap719)>>2)]=33; //@line 1290 "tr_languages.cpp"
        var $474=$tr; //@line 1292 "tr_languages.cpp"
        var $letter_groups720=(($474+968)&4294967295); //@line 1292 "tr_languages.cpp"
        var $arrayidx721=(($letter_groups720+28)&4294967295); //@line 1292 "tr_languages.cpp"
        HEAP32[(($arrayidx721)>>2)]=((__ZZ16SelectTranslatorPKcE9vowels_vi)&4294967295); //@line 1292 "tr_languages.cpp"
        var $475=$tr; //@line 1292 "tr_languages.cpp"
        var $letter_groups722=(($475+968)&4294967295); //@line 1292 "tr_languages.cpp"
        var $arrayidx723=(($letter_groups722)&4294967295); //@line 1292 "tr_languages.cpp"
        HEAP32[(($arrayidx723)>>2)]=((__ZZ16SelectTranslatorPKcE9vowels_vi)&4294967295); //@line 1292 "tr_languages.cpp"
        var $476=$tr; //@line 1293 "tr_languages.cpp"
        var $langopts724=(($476)&4294967295); //@line 1293 "tr_languages.cpp"
        var $tone_language=(($langopts724+224)&4294967295); //@line 1293 "tr_languages.cpp"
        HEAP32[(($tone_language)>>2)]=1; //@line 1293 "tr_languages.cpp"
        var $477=$tr; //@line 1294 "tr_languages.cpp"
        var $langopts725=(($477)&4294967295); //@line 1294 "tr_languages.cpp"
        var $unstressed_wd1726=(($langopts725+16)&4294967295); //@line 1294 "tr_languages.cpp"
        HEAP32[(($unstressed_wd1726)>>2)]=2; //@line 1294 "tr_languages.cpp"
        var $478=$tr; //@line 1295 "tr_languages.cpp"
        var $langopts727=(($478)&4294967295); //@line 1295 "tr_languages.cpp"
        var $numbers728=(($langopts727+184)&4294967295); //@line 1295 "tr_languages.cpp"
        HEAP32[(($numbers728)>>2)]=12615688; //@line 1295 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 1298 "tr_languages.cpp"
      }
      else if (__label__ == 76) {
  
        var $479=$tr; //@line 1301 "tr_languages.cpp"
        var $langopts730=(($479)&4294967295); //@line 1301 "tr_languages.cpp"
        var $stress_rule731=(($langopts730+8)&4294967295); //@line 1301 "tr_languages.cpp"
        HEAP32[(($stress_rule731)>>2)]=0; //@line 1301 "tr_languages.cpp"
        var $480=$tr; //@line 1302 "tr_languages.cpp"
        var $langopts732=(($480)&4294967295); //@line 1302 "tr_languages.cpp"
        var $numbers733=(($langopts732+184)&4294967295); //@line 1302 "tr_languages.cpp"
        HEAP32[(($numbers733)>>2)]=2098528; //@line 1302 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 1303 "tr_languages.cpp"
      }
      else if (__label__ == 77) {
  
        var $481=$tr; //@line 1311 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($481, ((__ZZ16SelectTranslatorPKcE17stress_lengths_zh)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_zh)&4294967295)); //@line 1311 "tr_languages.cpp"
        var $482=$tr; //@line 1313 "tr_languages.cpp"
        var $langopts735=(($482)&4294967295); //@line 1313 "tr_languages.cpp"
        var $stress_rule736=(($langopts735+8)&4294967295); //@line 1313 "tr_languages.cpp"
        HEAP32[(($stress_rule736)>>2)]=3; //@line 1313 "tr_languages.cpp"
        var $483=$tr; //@line 1314 "tr_languages.cpp"
        var $langopts737=(($483)&4294967295); //@line 1314 "tr_languages.cpp"
        var $stress_flags738=(($langopts737+12)&4294967295); //@line 1314 "tr_languages.cpp"
        HEAP32[(($stress_flags738)>>2)]=2; //@line 1314 "tr_languages.cpp"
        var $484=$tr; //@line 1315 "tr_languages.cpp"
        var $langopts739=(($484)&4294967295); //@line 1315 "tr_languages.cpp"
        var $vowel_pause740=(($langopts739+4)&4294967295); //@line 1315 "tr_languages.cpp"
        HEAP32[(($vowel_pause740)>>2)]=0; //@line 1315 "tr_languages.cpp"
        var $485=$tr; //@line 1316 "tr_languages.cpp"
        var $langopts741=(($485)&4294967295); //@line 1316 "tr_languages.cpp"
        var $tone_language742=(($langopts741+224)&4294967295); //@line 1316 "tr_languages.cpp"
        HEAP32[(($tone_language742)>>2)]=1; //@line 1316 "tr_languages.cpp"
        var $486=$tr; //@line 1317 "tr_languages.cpp"
        var $langopts743=(($486)&4294967295); //@line 1317 "tr_languages.cpp"
        var $length_mods744=(($langopts743+176)&4294967295); //@line 1317 "tr_languages.cpp"
        var $487=HEAP32[(($length_mods744)>>2)]; //@line 1317 "tr_languages.cpp"
        var $488=$tr; //@line 1317 "tr_languages.cpp"
        var $langopts745=(($488)&4294967295); //@line 1317 "tr_languages.cpp"
        var $length_mods0746=(($langopts745+180)&4294967295); //@line 1317 "tr_languages.cpp"
        HEAP32[(($length_mods0746)>>2)]=$487; //@line 1317 "tr_languages.cpp"
        var $489=$tr; //@line 1318 "tr_languages.cpp"
        var $langopts747=(($489)&4294967295); //@line 1318 "tr_languages.cpp"
        var $tone_numbers=(($langopts747+250)&4294967295); //@line 1318 "tr_languages.cpp"
        HEAP8[($tone_numbers)]=1; //@line 1318 "tr_languages.cpp"
        var $490=$tr; //@line 1319 "tr_languages.cpp"
        var $langopts748=(($490)&4294967295); //@line 1319 "tr_languages.cpp"
        var $ideographs=(($langopts748+251)&4294967295); //@line 1319 "tr_languages.cpp"
        HEAP8[($ideographs)]=1; //@line 1319 "tr_languages.cpp"
        var $491=$tr; //@line 1320 "tr_languages.cpp"
        var $langopts749=(($491)&4294967295); //@line 1320 "tr_languages.cpp"
        var $word_gap750=(($langopts749)&4294967295); //@line 1320 "tr_languages.cpp"
        HEAP32[(($word_gap750)>>2)]=33; //@line 1320 "tr_languages.cpp"
        var $492=$name2; //@line 1321 "tr_languages.cpp"
        var $cmp751=((($492))|0)==31336; //@line 1321 "tr_languages.cpp"
        if (!($cmp751)) { __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; } //@line 1321 "tr_languages.cpp"
  
        var $493=$tr; //@line 1323 "tr_languages.cpp"
        var $langopts753=(($493)&4294967295); //@line 1323 "tr_languages.cpp"
        var $textmode=(($langopts753+252)&4294967295); //@line 1323 "tr_languages.cpp"
        HEAP8[($textmode)]=1; //@line 1323 "tr_languages.cpp"
        var $494=$tr; //@line 1324 "tr_languages.cpp"
        var $langopts754=(($494)&4294967295); //@line 1324 "tr_languages.cpp"
        var $listx=(($langopts754+260)&4294967295); //@line 1324 "tr_languages.cpp"
        HEAP32[(($listx)>>2)]=1; //@line 1324 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 1325 "tr_languages.cpp"
      }
    } while(0);
    if (__label__ == 24) {
  
      var $146=$tr; //@line 645 "tr_languages.cpp"
      __Z15SetupTranslatorP10TranslatorPKsPKh($146, ((__ZZ16SelectTranslatorPKcE17stress_lengths_fi)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_fi)&4294967295)); //@line 645 "tr_languages.cpp"
      var $147=$tr; //@line 647 "tr_languages.cpp"
      var $langopts210=(($147)&4294967295); //@line 647 "tr_languages.cpp"
      var $stress_rule211=(($langopts210+8)&4294967295); //@line 647 "tr_languages.cpp"
      HEAP32[(($stress_rule211)>>2)]=0; //@line 647 "tr_languages.cpp"
      var $148=$tr; //@line 648 "tr_languages.cpp"
      var $langopts212=(($148)&4294967295); //@line 648 "tr_languages.cpp"
      var $stress_flags213=(($langopts212+12)&4294967295); //@line 648 "tr_languages.cpp"
      HEAP32[(($stress_flags213)>>2)]=86; //@line 648 "tr_languages.cpp"
      var $149=$tr; //@line 649 "tr_languages.cpp"
      var $langopts214=(($149)&4294967295); //@line 649 "tr_languages.cpp"
      var $param215=(($langopts214+24)&4294967295); //@line 649 "tr_languages.cpp"
      var $arrayidx216=(($param215+56)&4294967295); //@line 649 "tr_languages.cpp"
      HEAP32[(($arrayidx216)>>2)]=1; //@line 649 "tr_languages.cpp"
      var $150=$tr; //@line 650 "tr_languages.cpp"
      var $langopts217=(($150)&4294967295); //@line 650 "tr_languages.cpp"
      var $long_stop=(($langopts217+240)&4294967295); //@line 650 "tr_languages.cpp"
      HEAP32[(($long_stop)>>2)]=130; //@line 650 "tr_languages.cpp"
      var $151=$tr; //@line 652 "tr_languages.cpp"
      var $langopts218=(($151)&4294967295); //@line 652 "tr_languages.cpp"
      var $numbers219=(($langopts218+184)&4294967295); //@line 652 "tr_languages.cpp"
      HEAP32[(($numbers219)>>2)]=4104; //@line 652 "tr_languages.cpp"
      var $152=$tr; //@line 653 "tr_languages.cpp"
      __ZL14SetLetterVowelP10Translatori($152, 121); //@line 653 "tr_languages.cpp"
      var $153=$tr; //@line 655 "tr_languages.cpp"
      var $langopts220=(($153)&4294967295); //@line 655 "tr_languages.cpp"
      var $spelling_stress=(($langopts220+249)&4294967295); //@line 655 "tr_languages.cpp"
      HEAP8[($spelling_stress)]=1; //@line 655 "tr_languages.cpp"
      var $154=$tr; //@line 656 "tr_languages.cpp"
      var $langopts221=(($154)&4294967295); //@line 656 "tr_languages.cpp"
      var $intonation_group=(($langopts221+228)&4294967295); //@line 656 "tr_languages.cpp"
      HEAP32[(($intonation_group)>>2)]=3; //@line 656 "tr_languages.cpp"
      ; //@line 658 "tr_languages.cpp"
    }
  
    var $496=$name2; //@line 1334 "tr_languages.cpp"
    var $497=$tr; //@line 1334 "tr_languages.cpp"
    var $translator_name=(($497+280)&4294967295); //@line 1334 "tr_languages.cpp"
    HEAP32[(($translator_name)>>2)]=$496; //@line 1334 "tr_languages.cpp"
    var $498=$tr; //@line 1336 "tr_languages.cpp"
    var $langopts759=(($498)&4294967295); //@line 1336 "tr_languages.cpp"
    var $numbers760=(($langopts759+184)&4294967295); //@line 1336 "tr_languages.cpp"
    var $499=HEAP32[(($numbers760)>>2)]; //@line 1336 "tr_languages.cpp"
    var $and=($499) & 8; //@line 1336 "tr_languages.cpp"
    var $tobool=((($and))|0)!=0; //@line 1336 "tr_languages.cpp"
    if ($tobool) { __label__ = 81;; } else { __label__ = 82;; } //@line 1336 "tr_languages.cpp"
    if (__label__ == 81) {
  
      var $500=$tr; //@line 1339 "tr_languages.cpp"
      var $langopts762=(($500)&4294967295); //@line 1339 "tr_languages.cpp"
      var $thousands_sep763=(($langopts762+204)&4294967295); //@line 1339 "tr_languages.cpp"
      HEAP32[(($thousands_sep763)>>2)]=46; //@line 1339 "tr_languages.cpp"
      var $501=$tr; //@line 1340 "tr_languages.cpp"
      var $langopts764=(($501)&4294967295); //@line 1340 "tr_languages.cpp"
      var $decimal_sep765=(($langopts764+208)&4294967295); //@line 1340 "tr_languages.cpp"
      HEAP32[(($decimal_sep765)>>2)]=44; //@line 1340 "tr_languages.cpp"
      ; //@line 1341 "tr_languages.cpp"
    }
  
    var $502=$tr; //@line 1342 "tr_languages.cpp"
    var $langopts767=(($502)&4294967295); //@line 1342 "tr_languages.cpp"
    var $numbers768=(($langopts767+184)&4294967295); //@line 1342 "tr_languages.cpp"
    var $503=HEAP32[(($numbers768)>>2)]; //@line 1342 "tr_languages.cpp"
    var $and769=($503) & 4; //@line 1342 "tr_languages.cpp"
    var $tobool770=((($and769))|0)!=0; //@line 1342 "tr_languages.cpp"
    if ($tobool770) { __label__ = 83;; } else { __label__ = 84;; } //@line 1342 "tr_languages.cpp"
    if (__label__ == 83) {
  
      var $504=$tr; //@line 1344 "tr_languages.cpp"
      var $langopts772=(($504)&4294967295); //@line 1344 "tr_languages.cpp"
      var $thousands_sep773=(($langopts772+204)&4294967295); //@line 1344 "tr_languages.cpp"
      HEAP32[(($thousands_sep773)>>2)]=0; //@line 1344 "tr_languages.cpp"
      ; //@line 1345 "tr_languages.cpp"
    }
  
    var $505=$tr; //@line 1347 "tr_languages.cpp"
    ;
    return $505; //@line 1347 "tr_languages.cpp"
    return null;
  }
  

  function __ZL13NewTranslatorv() {
    ;
    var __label__;
  
    var $retval;
    var $tr;
    var $ix;
    var $call=__Z5Alloci(8328); //@line 123 "tr_languages.cpp"
    var $0=$call; //@line 123 "tr_languages.cpp"
    $tr=$0; //@line 123 "tr_languages.cpp"
    var $1=$tr; //@line 124 "tr_languages.cpp"
    var $cmp=((($1))|0)==0; //@line 124 "tr_languages.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 124 "tr_languages.cpp"
    if (__label__ == 1) {
  
      $retval=0; //@line 125 "tr_languages.cpp"
      ; //@line 125 "tr_languages.cpp"
    }
    else if (__label__ == 2) {
  
      var $2=HEAP32[((((_charsets+4)&4294967295))>>2)]; //@line 127 "tr_languages.cpp"
      var $3=$tr; //@line 127 "tr_languages.cpp"
      var $charset_a0=(($3+696)&4294967295); //@line 127 "tr_languages.cpp"
      HEAP32[(($charset_a0)>>2)]=$2; //@line 127 "tr_languages.cpp"
      HEAP8[(((_dictionary_name)&4294967295))]=0; //@line 128 "tr_languages.cpp"
      var $4=$tr; //@line 129 "tr_languages.cpp"
      var $dict_condition=(($4+692)&4294967295); //@line 129 "tr_languages.cpp"
      HEAP32[(($dict_condition)>>2)]=0; //@line 129 "tr_languages.cpp"
      var $5=$tr; //@line 130 "tr_languages.cpp"
      var $data_dictrules=(($5+1048)&4294967295); //@line 130 "tr_languages.cpp"
      HEAP32[(($data_dictrules)>>2)]=0; //@line 130 "tr_languages.cpp"
      var $6=$tr; //@line 131 "tr_languages.cpp"
      var $data_dictlist=(($6+1052)&4294967295); //@line 131 "tr_languages.cpp"
      HEAP32[(($data_dictlist)>>2)]=0; //@line 131 "tr_languages.cpp"
      var $7=$tr; //@line 133 "tr_languages.cpp"
      var $transpose_min=(($7+288)&4294967295); //@line 133 "tr_languages.cpp"
      HEAP32[(($transpose_min)>>2)]=97; //@line 133 "tr_languages.cpp"
      var $8=$tr; //@line 134 "tr_languages.cpp"
      var $transpose_max=(($8+284)&4294967295); //@line 134 "tr_languages.cpp"
      HEAP32[(($transpose_max)>>2)]=122; //@line 134 "tr_languages.cpp"
      var $9=$tr; //@line 135 "tr_languages.cpp"
      var $frequent_pairs=(($9+8268)&4294967295); //@line 135 "tr_languages.cpp"
      HEAP32[(($frequent_pairs)>>2)]=0; //@line 135 "tr_languages.cpp"
      var $10=$tr; //@line 138 "tr_languages.cpp"
      var $letter_bits_offset=(($10+964)&4294967295); //@line 138 "tr_languages.cpp"
      HEAP32[(($letter_bits_offset)>>2)]=0; //@line 138 "tr_languages.cpp"
      var $11=$tr; //@line 139 "tr_languages.cpp"
      var $letter_bits=(($11+708)&4294967295); //@line 139 "tr_languages.cpp"
      var $arraydecay=(($letter_bits)&4294967295); //@line 139 "tr_languages.cpp"
      var $dest$, $stop$, $stop4$, $fast$, $value4$;
      $dest$ = $arraydecay;
      $stop$ = $dest$ + 256;
      $value4$ = 0;
      if ($value4$ < 0) $value4$ += 256;
      $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
      while ($dest$%4 !== 0 && $dest$ < $stop$) {
        ;; HEAP8[$dest$++] = 0;
      }
      $dest$ >>= 2;
      $stop4$ = $stop$ >> 2;
      while ($dest$ < $stop4$) {
      ;;;;;;;  HEAP32[$dest$++] = $value4$;
      }
      $dest$ <<= 2;
      while ($dest$ < $stop$) {
        ;; HEAP8[$dest$++] = 0;
      }; //@line 139 "tr_languages.cpp"
      var $12=$tr; //@line 140 "tr_languages.cpp"
      var $letter_groups=(($12+968)&4294967295); //@line 140 "tr_languages.cpp"
      var $arraydecay1=(($letter_groups)&4294967295); //@line 140 "tr_languages.cpp"
      var $13=$arraydecay1; //@line 140 "tr_languages.cpp"
      var $dest$, $stop$, $stop4$, $fast$, $value4$;
      $dest$ = $13;
      $stop$ = $dest$ + 32;
      $value4$ = 0;
      if ($value4$ < 0) $value4$ += 256;
      $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
      while ($dest$%4 !== 0 && $dest$ < $stop$) {
        ;; HEAP8[$dest$++] = 0;
      }
      $dest$ >>= 2;
      $stop4$ = $stop$ >> 2;
      while ($dest$ < $stop4$) {
      ;;;;;;;  HEAP32[$dest$++] = $value4$;
      }
      $dest$ <<= 2;
      while ($dest$ < $stop$) {
        ;; HEAP8[$dest$++] = 0;
      }; //@line 140 "tr_languages.cpp"
      var $14=$tr; //@line 144 "tr_languages.cpp"
      __ZL13SetLetterBitsP10TranslatoriPKc($14, 0, ((__str6636)&4294967295)); //@line 144 "tr_languages.cpp"
      var $15=$tr; //@line 145 "tr_languages.cpp"
      __ZL13SetLetterBitsP10TranslatoriPKc($15, 1, ((__str7637)&4294967295)); //@line 145 "tr_languages.cpp"
      var $16=$tr; //@line 146 "tr_languages.cpp"
      __ZL13SetLetterBitsP10TranslatoriPKc($16, 2, ((__str8638)&4294967295)); //@line 146 "tr_languages.cpp"
      var $17=$tr; //@line 147 "tr_languages.cpp"
      __ZL13SetLetterBitsP10TranslatoriPKc($17, 3, ((__str9639)&4294967295)); //@line 147 "tr_languages.cpp"
      var $18=$tr; //@line 148 "tr_languages.cpp"
      __ZL13SetLetterBitsP10TranslatoriPKc($18, 4, ((__str10640)&4294967295)); //@line 148 "tr_languages.cpp"
      var $19=$tr; //@line 149 "tr_languages.cpp"
      __ZL13SetLetterBitsP10TranslatoriPKc($19, 5, ((__str11641)&4294967295)); //@line 149 "tr_languages.cpp"
      var $20=$tr; //@line 150 "tr_languages.cpp"
      __ZL13SetLetterBitsP10TranslatoriPKc($20, 6, ((__str12642)&4294967295)); //@line 150 "tr_languages.cpp"
      var $21=$tr; //@line 151 "tr_languages.cpp"
      __ZL13SetLetterBitsP10TranslatoriPKc($21, 7, ((__str630)&4294967295)); //@line 151 "tr_languages.cpp"
      var $22=$tr; //@line 154 "tr_languages.cpp"
      var $char_plus_apostrophe=(($22+700)&4294967295); //@line 154 "tr_languages.cpp"
      HEAP32[(($char_plus_apostrophe)>>2)]=((__ZZL13NewTranslatorvE13empty_wstring)&4294967295); //@line 154 "tr_languages.cpp"
      var $23=$tr; //@line 155 "tr_languages.cpp"
      var $punct_within_word=(($23+704)&4294967295); //@line 155 "tr_languages.cpp"
      HEAP32[(($punct_within_word)>>2)]=((__ZZL13NewTranslatorvE13punct_in_word)&4294967295); //@line 155 "tr_languages.cpp"
      $ix=0; //@line 157 "tr_languages.cpp"
      ; //@line 157 "tr_languages.cpp"
      while(1) { 
  
        var $24=$ix; //@line 159 "tr_languages.cpp"
        var $arrayidx=((__ZZL13NewTranslatorvE12stress_amps2+$24)&4294967295); //@line 159 "tr_languages.cpp"
        var $25=HEAP8[($arrayidx)]; //@line 159 "tr_languages.cpp"
        var $26=$ix; //@line 159 "tr_languages.cpp"
        var $27=$tr; //@line 159 "tr_languages.cpp"
        var $stress_amps=(($27+660)&4294967295); //@line 159 "tr_languages.cpp"
        var $arrayidx3=(($stress_amps+$26)&4294967295); //@line 159 "tr_languages.cpp"
        HEAP8[($arrayidx3)]=$25; //@line 159 "tr_languages.cpp"
        var $28=$ix; //@line 160 "tr_languages.cpp"
        var $arrayidx4=((__ZZL13NewTranslatorvE12stress_amps2+$28)&4294967295); //@line 160 "tr_languages.cpp"
        var $29=HEAPU8[($arrayidx4)]; //@line 160 "tr_languages.cpp"
        var $conv=((($29))&255); //@line 160 "tr_languages.cpp"
        var $sub=((($conv)-1)&4294967295); //@line 160 "tr_languages.cpp"
        var $conv5=((($sub)) & 255); //@line 160 "tr_languages.cpp"
        var $30=$ix; //@line 160 "tr_languages.cpp"
        var $31=$tr; //@line 160 "tr_languages.cpp"
        var $stress_amps_r=(($31+668)&4294967295); //@line 160 "tr_languages.cpp"
        var $arrayidx6=(($stress_amps_r+$30)&4294967295); //@line 160 "tr_languages.cpp"
        HEAP8[($arrayidx6)]=$conv5; //@line 160 "tr_languages.cpp"
        var $32=$ix; //@line 161 "tr_languages.cpp"
        var $arrayidx7=((__ZZL13NewTranslatorvE15stress_lengths2+$32*2)&4294967295); //@line 161 "tr_languages.cpp"
        var $33=HEAP16[(($arrayidx7)>>1)]; //@line 161 "tr_languages.cpp"
        var $34=$ix; //@line 161 "tr_languages.cpp"
        var $35=$tr; //@line 161 "tr_languages.cpp"
        var $stress_lengths=(($35+676)&4294967295); //@line 161 "tr_languages.cpp"
        var $arrayidx8=(($stress_lengths+$34*2)&4294967295); //@line 161 "tr_languages.cpp"
        HEAP16[(($arrayidx8)>>1)]=$33; //@line 161 "tr_languages.cpp"
        var $36=$ix; //@line 157 "tr_languages.cpp"
        var $inc=((($36)+1)&4294967295); //@line 157 "tr_languages.cpp"
        $ix=$inc; //@line 157 "tr_languages.cpp"
        var $cmp2=((($inc))|0) < 8; //@line 157 "tr_languages.cpp"
        if ($cmp2) { __label__ = 3;continue ; } else { __label__ = 4;break ; } //@line 157 "tr_languages.cpp"
      }
  
      var $37=$tr; //@line 163 "tr_languages.cpp"
      var $langopts=(($37)&4294967295); //@line 163 "tr_languages.cpp"
      var $38=$langopts; //@line 163 "tr_languages.cpp"
      var $dest$, $stop$, $stop4$, $fast$, $value4$;
      $dest$ = $38;
      $stop$ = $dest$ + 280;
      $value4$ = 0;
      if ($value4$ < 0) $value4$ += 256;
      $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
      while ($dest$%4 !== 0 && $dest$ < $stop$) {
        ;; HEAP8[$dest$++] = 0;
      }
      $dest$ >>= 2;
      $stop4$ = $stop$ >> 2;
      while ($dest$ < $stop4$) {
      ;;;;;;;  HEAP32[$dest$++] = $value4$;
      }
      $dest$ <<= 2;
      while ($dest$ < $stop$) {
        ;; HEAP8[$dest$++] = 0;
      }; //@line 163 "tr_languages.cpp"
      var $39=$tr; //@line 164 "tr_languages.cpp"
      var $langopts9=(($39)&4294967295); //@line 164 "tr_languages.cpp"
      var $max_lengthmod=(($langopts9+272)&4294967295); //@line 164 "tr_languages.cpp"
      HEAP32[(($max_lengthmod)>>2)]=500; //@line 164 "tr_languages.cpp"
      var $40=$tr; //@line 166 "tr_languages.cpp"
      var $langopts10=(($40)&4294967295); //@line 166 "tr_languages.cpp"
      var $stress_rule=(($langopts10+8)&4294967295); //@line 166 "tr_languages.cpp"
      HEAP32[(($stress_rule)>>2)]=2; //@line 166 "tr_languages.cpp"
      var $41=$tr; //@line 167 "tr_languages.cpp"
      var $langopts11=(($41)&4294967295); //@line 167 "tr_languages.cpp"
      var $unstressed_wd1=(($langopts11+16)&4294967295); //@line 167 "tr_languages.cpp"
      HEAP32[(($unstressed_wd1)>>2)]=1; //@line 167 "tr_languages.cpp"
      var $42=$tr; //@line 168 "tr_languages.cpp"
      var $langopts12=(($42)&4294967295); //@line 168 "tr_languages.cpp"
      var $unstressed_wd2=(($langopts12+20)&4294967295); //@line 168 "tr_languages.cpp"
      HEAP32[(($unstressed_wd2)>>2)]=3; //@line 168 "tr_languages.cpp"
      var $43=$tr; //@line 169 "tr_languages.cpp"
      var $langopts13=(($43)&4294967295); //@line 169 "tr_languages.cpp"
      var $param=(($langopts13+24)&4294967295); //@line 169 "tr_languages.cpp"
      var $arrayidx14=(($param+28)&4294967295); //@line 169 "tr_languages.cpp"
      HEAP32[(($arrayidx14)>>2)]=95; //@line 169 "tr_languages.cpp"
      var $44=$tr; //@line 170 "tr_languages.cpp"
      var $langopts15=(($44)&4294967295); //@line 170 "tr_languages.cpp"
      var $param16=(($langopts15+24)&4294967295); //@line 170 "tr_languages.cpp"
      var $arrayidx17=(($param16+72)&4294967295); //@line 170 "tr_languages.cpp"
      HEAP32[(($arrayidx17)>>2)]=95; //@line 170 "tr_languages.cpp"
      var $45=$tr; //@line 171 "tr_languages.cpp"
      var $langopts18=(($45)&4294967295); //@line 171 "tr_languages.cpp"
      var $param19=(($langopts18+24)&4294967295); //@line 171 "tr_languages.cpp"
      var $arrayidx20=(($param19+36)&4294967295); //@line 171 "tr_languages.cpp"
      HEAP32[(($arrayidx20)>>2)]=19; //@line 171 "tr_languages.cpp"
      var $46=$tr; //@line 172 "tr_languages.cpp"
      var $langopts21=(($46)&4294967295); //@line 172 "tr_languages.cpp"
      var $param22=(($langopts21+24)&4294967295); //@line 172 "tr_languages.cpp"
      var $arrayidx23=(($param22+20)&4294967295); //@line 172 "tr_languages.cpp"
      HEAP32[(($arrayidx23)>>2)]=115; //@line 172 "tr_languages.cpp"
      var $47=$tr; //@line 173 "tr_languages.cpp"
      var $langopts24=(($47)&4294967295); //@line 173 "tr_languages.cpp"
      var $param25=(($langopts24+24)&4294967295); //@line 173 "tr_languages.cpp"
      var $arrayidx26=(($param25+64)&4294967295); //@line 173 "tr_languages.cpp"
      HEAP32[(($arrayidx26)>>2)]=4; //@line 173 "tr_languages.cpp"
      var $48=$tr; //@line 174 "tr_languages.cpp"
      var $langopts27=(($48)&4294967295); //@line 174 "tr_languages.cpp"
      var $param2=(($langopts27+100)&4294967295); //@line 174 "tr_languages.cpp"
      var $arrayidx28=(($param2+64)&4294967295); //@line 174 "tr_languages.cpp"
      HEAP32[(($arrayidx28)>>2)]=2; //@line 174 "tr_languages.cpp"
      var $49=$tr; //@line 175 "tr_languages.cpp"
      var $langopts29=(($49)&4294967295); //@line 175 "tr_languages.cpp"
      var $max_initial_consonants=(($langopts29+248)&4294967295); //@line 175 "tr_languages.cpp"
      HEAP8[($max_initial_consonants)]=3; //@line 175 "tr_languages.cpp"
      var $50=$tr; //@line 176 "tr_languages.cpp"
      var $langopts30=(($50)&4294967295); //@line 176 "tr_languages.cpp"
      var $replace_chars=(($langopts30+264)&4294967295); //@line 176 "tr_languages.cpp"
      HEAP32[(($replace_chars)>>2)]=0; //@line 176 "tr_languages.cpp"
      var $51=$tr; //@line 177 "tr_languages.cpp"
      var $langopts31=(($51)&4294967295); //@line 177 "tr_languages.cpp"
      var $ascii_language=(($langopts31+268)&4294967295); //@line 177 "tr_languages.cpp"
      HEAP32[(($ascii_language)>>2)]=((__str13643)&4294967295); //@line 177 "tr_languages.cpp"
      var $52=$tr; //@line 180 "tr_languages.cpp"
      __Z13SetLengthModsP10Translatori($52, 201); //@line 180 "tr_languages.cpp"
      var $53=$tr; //@line 184 "tr_languages.cpp"
      var $langopts32=(($53)&4294967295); //@line 184 "tr_languages.cpp"
      var $long_stop=(($langopts32+240)&4294967295); //@line 184 "tr_languages.cpp"
      HEAP32[(($long_stop)>>2)]=100; //@line 184 "tr_languages.cpp"
      var $54=$tr; //@line 186 "tr_languages.cpp"
      var $langopts33=(($54)&4294967295); //@line 186 "tr_languages.cpp"
      var $max_roman=(($langopts33+196)&4294967295); //@line 186 "tr_languages.cpp"
      HEAP32[(($max_roman)>>2)]=49; //@line 186 "tr_languages.cpp"
      var $55=$tr; //@line 187 "tr_languages.cpp"
      var $langopts34=(($55)&4294967295); //@line 187 "tr_languages.cpp"
      var $min_roman=(($langopts34+200)&4294967295); //@line 187 "tr_languages.cpp"
      HEAP32[(($min_roman)>>2)]=2; //@line 187 "tr_languages.cpp"
      var $56=$tr; //@line 188 "tr_languages.cpp"
      var $langopts35=(($56)&4294967295); //@line 188 "tr_languages.cpp"
      var $thousands_sep=(($langopts35+204)&4294967295); //@line 188 "tr_languages.cpp"
      HEAP32[(($thousands_sep)>>2)]=44; //@line 188 "tr_languages.cpp"
      var $57=$tr; //@line 189 "tr_languages.cpp"
      var $langopts36=(($57)&4294967295); //@line 189 "tr_languages.cpp"
      var $decimal_sep=(($langopts36+208)&4294967295); //@line 189 "tr_languages.cpp"
      HEAP32[(($decimal_sep)>>2)]=46; //@line 189 "tr_languages.cpp"
      var $58=$tr; //@line 190 "tr_languages.cpp"
      var $langopts37=(($58)&4294967295); //@line 190 "tr_languages.cpp"
      var $break_numbers=(($langopts37+192)&4294967295); //@line 190 "tr_languages.cpp"
      HEAP32[(($break_numbers)>>2)]=1227133512; //@line 190 "tr_languages.cpp"
      var $59=$tr; //@line 191 "tr_languages.cpp"
      var $langopts38=(($59)&4294967295); //@line 191 "tr_languages.cpp"
      var $max_digits=(($langopts38+212)&4294967295); //@line 191 "tr_languages.cpp"
      HEAP32[(($max_digits)>>2)]=14; //@line 191 "tr_languages.cpp"
      var $60=$tr; //@line 193 "tr_languages.cpp"
      var $punct_to_tone=(($60+1000)&4294967295); //@line 193 "tr_languages.cpp"
      var $arraydecay39=(($punct_to_tone)&4294967295); //@line 193 "tr_languages.cpp"
      var $61=$arraydecay39; //@line 193 "tr_languages.cpp"
      var $src$, $dest$, $stop$, $stop4$, $fast$;
      $src$ = ((_punctuation_to_tone)&4294967295);
      $dest$ = $61;
      $stop$ = $src$ + 48;
      if (($dest$%4) == ($src$%4) && 48 > 8) {
        while ($src$%4 !== 0 && $src$ < $stop$) {
          ; HEAP8[$dest$++] = HEAP8[$src$++];
        }
        $src$ >>= 2;
        $dest$ >>= 2;
        $stop4$ = $stop$ >> 2;
        while ($src$ < $stop4$) {
      ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
        }
        $src$ <<= 2;
        $dest$ <<= 2;
      }while ($src$ < $stop$) {
        ; HEAP8[$dest$++] = HEAP8[$src$++];
      }; //@line 193 "tr_languages.cpp"
      var $62=$tr; //@line 195 "tr_languages.cpp"
      var $langopts40=(($62)&4294967295); //@line 195 "tr_languages.cpp"
      var $tunes=(($langopts40+232)&4294967295); //@line 195 "tr_languages.cpp"
      var $arraydecay41=(($tunes)&4294967295); //@line 195 "tr_languages.cpp"
      var $src$, $dest$, $stop$, $stop4$, $fast$;
      $src$ = ((__ZZL13NewTranslatorvE13default_tunes)&4294967295);
      $dest$ = $arraydecay41;
      $stop$ = $src$ + 6;
      if (($dest$%4) == ($src$%4) && 6 > 8) {
        while ($src$%4 !== 0 && $src$ < $stop$) {
          ; HEAP8[$dest$++] = HEAP8[$src$++];
        }
        $src$ >>= 2;
        $dest$ >>= 2;
        $stop4$ = $stop$ >> 2;
        while ($src$ < $stop4$) {
      ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
        }
        $src$ <<= 2;
        $dest$ <<= 2;
      }while ($src$ < $stop$) {
        ; HEAP8[$dest$++] = HEAP8[$src$++];
      }; //@line 195 "tr_languages.cpp"
      var $63=$tr; //@line 197 "tr_languages.cpp"
      $retval=$63; //@line 197 "tr_languages.cpp"
      ; //@line 197 "tr_languages.cpp"
    }
  
    var $64=$retval; //@line 198 "tr_languages.cpp"
    ;
    return $64; //@line 198 "tr_languages.cpp"
    return null;
  }
  

  function __ZL14SetLetterVowelP10Translatori($tr, $c) {
    ;
    var __label__;
  
    var $tr_addr;
    var $c_addr;
    $tr_addr=$tr;
    $c_addr=$c;
    var $0=$c_addr; //@line 73 "tr_languages.cpp"
    var $1=$tr_addr; //@line 73 "tr_languages.cpp"
    var $letter_bits=(($1+708)&4294967295); //@line 73 "tr_languages.cpp"
    var $arrayidx=(($letter_bits+$0)&4294967295); //@line 73 "tr_languages.cpp"
    var $2=HEAPU8[($arrayidx)]; //@line 73 "tr_languages.cpp"
    var $conv=((($2))&255); //@line 73 "tr_languages.cpp"
    var $and=($conv) & 64; //@line 73 "tr_languages.cpp"
    var $or=($and) | 129; //@line 73 "tr_languages.cpp"
    var $conv1=((($or)) & 255); //@line 73 "tr_languages.cpp"
    var $3=$c_addr; //@line 73 "tr_languages.cpp"
    var $4=$tr_addr; //@line 73 "tr_languages.cpp"
    var $letter_bits2=(($4+708)&4294967295); //@line 73 "tr_languages.cpp"
    var $arrayidx3=(($letter_bits2+$3)&4294967295); //@line 73 "tr_languages.cpp"
    HEAP8[($arrayidx3)]=$conv1; //@line 73 "tr_languages.cpp"
    ;
    return; //@line 74 "tr_languages.cpp"
    return;
  }
  

  function __ZL18SetCyrillicLettersP10Translator($tr) {
    ;
    var __label__;
  
    var $tr_addr;
    $tr_addr=$tr;
    var $0=HEAP32[((((_charsets+72)&4294967295))>>2)]; //@line 285 "tr_languages.cpp"
    var $1=$tr_addr; //@line 285 "tr_languages.cpp"
    var $charset_a0=(($1+696)&4294967295); //@line 285 "tr_languages.cpp"
    HEAP32[(($charset_a0)>>2)]=$0; //@line 285 "tr_languages.cpp"
    var $2=$tr_addr; //@line 286 "tr_languages.cpp"
    var $transpose_min=(($2+288)&4294967295); //@line 286 "tr_languages.cpp"
    HEAP32[(($transpose_min)>>2)]=1072; //@line 286 "tr_languages.cpp"
    var $3=$tr_addr; //@line 287 "tr_languages.cpp"
    var $transpose_max=(($3+284)&4294967295); //@line 287 "tr_languages.cpp"
    HEAP32[(($transpose_max)>>2)]=1105; //@line 287 "tr_languages.cpp"
    var $4=$tr_addr; //@line 288 "tr_languages.cpp"
    var $frequent_pairs=(($4+8268)&4294967295); //@line 288 "tr_languages.cpp"
    HEAP32[(($frequent_pairs)>>2)]=((__ZL8pairs_ru)&4294967295); //@line 288 "tr_languages.cpp"
    var $5=$tr_addr; //@line 290 "tr_languages.cpp"
    var $letter_bits_offset=(($5+964)&4294967295); //@line 290 "tr_languages.cpp"
    HEAP32[(($letter_bits_offset)>>2)]=1056; //@line 290 "tr_languages.cpp"
    var $6=$tr_addr; //@line 291 "tr_languages.cpp"
    var $letter_bits=(($6+708)&4294967295); //@line 291 "tr_languages.cpp"
    var $arraydecay=(($letter_bits)&4294967295); //@line 291 "tr_languages.cpp"
    var $dest$, $stop$, $stop4$, $fast$, $value4$;
    $dest$ = $arraydecay;
    $stop$ = $dest$ + 256;
    $value4$ = 0;
    if ($value4$ < 0) $value4$ += 256;
    $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
    while ($dest$%4 !== 0 && $dest$ < $stop$) {
      ;; HEAP8[$dest$++] = 0;
    }
    $dest$ >>= 2;
    $stop4$ = $stop$ >> 2;
    while ($dest$ < $stop4$) {
    ;;;;;;;  HEAP32[$dest$++] = $value4$;
    }
    $dest$ <<= 2;
    while ($dest$ < $stop$) {
      ;; HEAP8[$dest$++] = 0;
    }; //@line 291 "tr_languages.cpp"
    var $7=$tr_addr; //@line 292 "tr_languages.cpp"
    __ZL13SetLetterBitsP10TranslatoriPKc($7, 0, ((__ZZL18SetCyrillicLettersP10TranslatorE9ru_vowels)&4294967295)); //@line 292 "tr_languages.cpp"
    var $8=$tr_addr; //@line 293 "tr_languages.cpp"
    __ZL13SetLetterBitsP10TranslatoriPKc($8, 1, ((__ZZL18SetCyrillicLettersP10TranslatorE7ru_soft)&4294967295)); //@line 293 "tr_languages.cpp"
    var $9=$tr_addr; //@line 294 "tr_languages.cpp"
    __ZL13SetLetterBitsP10TranslatoriPKc($9, 2, ((__ZZL18SetCyrillicLettersP10TranslatorE13ru_consonants)&4294967295)); //@line 294 "tr_languages.cpp"
    var $10=$tr_addr; //@line 295 "tr_languages.cpp"
    __ZL13SetLetterBitsP10TranslatoriPKc($10, 3, ((__ZZL18SetCyrillicLettersP10TranslatorE7ru_hard)&4294967295)); //@line 295 "tr_languages.cpp"
    var $11=$tr_addr; //@line 296 "tr_languages.cpp"
    __ZL13SetLetterBitsP10TranslatoriPKc($11, 4, ((__ZZL18SetCyrillicLettersP10TranslatorE10ru_nothard)&4294967295)); //@line 296 "tr_languages.cpp"
    var $12=$tr_addr; //@line 297 "tr_languages.cpp"
    __ZL13SetLetterBitsP10TranslatoriPKc($12, 5, ((__ZZL18SetCyrillicLettersP10TranslatorE9ru_voiced)&4294967295)); //@line 297 "tr_languages.cpp"
    var $13=$tr_addr; //@line 298 "tr_languages.cpp"
    __ZL13SetLetterBitsP10TranslatoriPKc($13, 6, ((__ZZL18SetCyrillicLettersP10TranslatorE10ru_ivowels)&4294967295)); //@line 298 "tr_languages.cpp"
    var $14=$tr_addr; //@line 299 "tr_languages.cpp"
    __ZL13SetLetterBitsP10TranslatoriPKc($14, 7, ((__ZZL18SetCyrillicLettersP10TranslatorE9ru_vowels)&4294967295)); //@line 299 "tr_languages.cpp"
    ;
    return; //@line 300 "tr_languages.cpp"
    return;
  }
  

  function __ZL15ResetLetterBitsP10Translatori($tr, $groups) {
    ;
    var __label__;
  
    var $tr_addr;
    var $groups_addr;
    var $ix;
    var $mask;
    $tr_addr=$tr;
    $groups_addr=$groups;
    var $0=$groups_addr; //@line 82 "tr_languages.cpp"
    var $neg=($0) ^ -1; //@line 82 "tr_languages.cpp"
    $mask=$neg; //@line 82 "tr_languages.cpp"
    $ix=0; //@line 84 "tr_languages.cpp"
    ; //@line 84 "tr_languages.cpp"
    while(1) { 
  
      var $1=$mask; //@line 86 "tr_languages.cpp"
      var $2=$ix; //@line 86 "tr_languages.cpp"
      var $3=$tr_addr; //@line 86 "tr_languages.cpp"
      var $letter_bits=(($3+708)&4294967295); //@line 86 "tr_languages.cpp"
      var $arrayidx=(($letter_bits+$2)&4294967295); //@line 86 "tr_languages.cpp"
      var $4=HEAPU8[($arrayidx)]; //@line 86 "tr_languages.cpp"
      var $conv=((($4))&255); //@line 86 "tr_languages.cpp"
      var $and=($conv) & ($1); //@line 86 "tr_languages.cpp"
      var $conv1=((($and)) & 255); //@line 86 "tr_languages.cpp"
      HEAP8[($arrayidx)]=$conv1; //@line 86 "tr_languages.cpp"
      var $5=$ix; //@line 84 "tr_languages.cpp"
      var $inc=((($5)+1)&4294967295); //@line 84 "tr_languages.cpp"
      $ix=$inc; //@line 84 "tr_languages.cpp"
      var $cmp=((($inc))>>>0) < 256; //@line 84 "tr_languages.cpp"
      if ($cmp) { __label__ = 1;continue ; } else { __label__ = 2;break ; } //@line 84 "tr_languages.cpp"
    }
  
    ;
    return; //@line 88 "tr_languages.cpp"
    return;
  }
  

  function __ZL18Translator_RussianP10Translator($tr) {
    ;
    var __label__;
  
    var $tr_addr;
    $tr_addr=$tr;
    var $0=$tr_addr; //@line 1363 "tr_languages.cpp"
    __Z15SetupTranslatorP10TranslatorPKsPKh($0, ((__ZZL18Translator_RussianP10TranslatorE17stress_lengths_ru)&4294967295), ((__ZZL18Translator_RussianP10TranslatorE14stress_amps_ru)&4294967295)); //@line 1363 "tr_languages.cpp"
    var $1=$tr_addr; //@line 1364 "tr_languages.cpp"
    __ZL18SetCyrillicLettersP10Translator($1); //@line 1364 "tr_languages.cpp"
    var $2=$tr_addr; //@line 1365 "tr_languages.cpp"
    __ZL13SetLetterBitsP10TranslatoriPKc($2, 6, ((__ZZL18Translator_RussianP10TranslatorE11ru_ivowels2)&4294967295)); //@line 1365 "tr_languages.cpp"
    var $3=$tr_addr; //@line 1367 "tr_languages.cpp"
    var $langopts=(($3)&4294967295); //@line 1367 "tr_languages.cpp"
    var $param=(($langopts+24)&4294967295); //@line 1367 "tr_languages.cpp"
    var $arrayidx=(($param+20)&4294967295); //@line 1367 "tr_languages.cpp"
    HEAP32[(($arrayidx)>>2)]=1074; //@line 1367 "tr_languages.cpp"
    var $4=$tr_addr; //@line 1368 "tr_languages.cpp"
    var $langopts1=(($4)&4294967295); //@line 1368 "tr_languages.cpp"
    var $param2=(($langopts1+24)&4294967295); //@line 1368 "tr_languages.cpp"
    var $arrayidx3=(($param2+16)&4294967295); //@line 1368 "tr_languages.cpp"
    HEAP32[(($arrayidx3)>>2)]=1; //@line 1368 "tr_languages.cpp"
    var $5=$tr_addr; //@line 1369 "tr_languages.cpp"
    var $langopts4=(($5)&4294967295); //@line 1369 "tr_languages.cpp"
    var $param5=(($langopts4+24)&4294967295); //@line 1369 "tr_languages.cpp"
    var $arrayidx6=(($param5+40)&4294967295); //@line 1369 "tr_languages.cpp"
    HEAP32[(($arrayidx6)>>2)]=2; //@line 1369 "tr_languages.cpp"
    var $6=$tr_addr; //@line 1370 "tr_languages.cpp"
    var $langopts7=(($6)&4294967295); //@line 1370 "tr_languages.cpp"
    var $stress_rule=(($langopts7+8)&4294967295); //@line 1370 "tr_languages.cpp"
    HEAP32[(($stress_rule)>>2)]=5; //@line 1370 "tr_languages.cpp"
    var $7=$tr_addr; //@line 1371 "tr_languages.cpp"
    var $langopts8=(($7)&4294967295); //@line 1371 "tr_languages.cpp"
    var $stress_flags=(($langopts8+12)&4294967295); //@line 1371 "tr_languages.cpp"
    HEAP32[(($stress_flags)>>2)]=32; //@line 1371 "tr_languages.cpp"
    var $8=$tr_addr; //@line 1373 "tr_languages.cpp"
    var $langopts9=(($8)&4294967295); //@line 1373 "tr_languages.cpp"
    var $numbers=(($langopts9+184)&4294967295); //@line 1373 "tr_languages.cpp"
    HEAP32[(($numbers)>>2)]=1032; //@line 1373 "tr_languages.cpp"
    var $9=$tr_addr; //@line 1374 "tr_languages.cpp"
    var $langopts10=(($9)&4294967295); //@line 1374 "tr_languages.cpp"
    var $numbers2=(($langopts10+188)&4294967295); //@line 1374 "tr_languages.cpp"
    HEAP32[(($numbers2)>>2)]=194; //@line 1374 "tr_languages.cpp"
    var $10=$tr_addr; //@line 1375 "tr_languages.cpp"
    var $langopts11=(($10)&4294967295); //@line 1375 "tr_languages.cpp"
    var $phoneme_change=(($langopts11+244)&4294967295); //@line 1375 "tr_languages.cpp"
    HEAP32[(($phoneme_change)>>2)]=1; //@line 1375 "tr_languages.cpp"
    var $11=$tr_addr; //@line 1376 "tr_languages.cpp"
    var $langopts12=(($11)&4294967295); //@line 1376 "tr_languages.cpp"
    var $testing=(($langopts12+256)&4294967295); //@line 1376 "tr_languages.cpp"
    HEAP32[(($testing)>>2)]=2; //@line 1376 "tr_languages.cpp"
    ;
    return; //@line 1378 "tr_languages.cpp"
    return;
  }
  

  function __Z14ReadTonePointsPcPi($string, $tone_pts) {
    ;
    var __label__;
  
    var $string_addr;
    var $tone_pts_addr;
    var $ix;
    $string_addr=$string;
    $tone_pts_addr=$tone_pts;
    $ix=0; //@line 256 "voices.cpp"
    ; //@line 256 "voices.cpp"
    while(1) { 
  
      var $0=$ix; //@line 257 "voices.cpp"
      var $1=$tone_pts_addr; //@line 257 "voices.cpp"
      var $arrayidx=(($1+4*$0)&4294967295); //@line 257 "voices.cpp"
      HEAP32[(($arrayidx)>>2)]=-1; //@line 257 "voices.cpp"
      var $2=$ix; //@line 256 "voices.cpp"
      var $inc=((($2)+1)&4294967295); //@line 256 "voices.cpp"
      $ix=$inc; //@line 256 "voices.cpp"
      var $cmp=((($inc))|0) < 12; //@line 256 "voices.cpp"
      if ($cmp) { __label__ = 1;continue ; } else { __label__ = 2;break ; } //@line 256 "voices.cpp"
    }
  
    var $3=$string_addr; //@line 259 "voices.cpp"
    var $4=$tone_pts_addr; //@line 259 "voices.cpp"
    var $arrayidx1=(($4)&4294967295); //@line 259 "voices.cpp"
    var $5=$tone_pts_addr; //@line 259 "voices.cpp"
    var $arrayidx2=(($5+4)&4294967295); //@line 259 "voices.cpp"
    var $6=$tone_pts_addr; //@line 259 "voices.cpp"
    var $arrayidx3=(($6+8)&4294967295); //@line 259 "voices.cpp"
    var $7=$tone_pts_addr; //@line 259 "voices.cpp"
    var $arrayidx4=(($7+12)&4294967295); //@line 259 "voices.cpp"
    var $8=$tone_pts_addr; //@line 259 "voices.cpp"
    var $arrayidx5=(($8+16)&4294967295); //@line 259 "voices.cpp"
    var $9=$tone_pts_addr; //@line 259 "voices.cpp"
    var $arrayidx6=(($9+20)&4294967295); //@line 259 "voices.cpp"
    var $10=$tone_pts_addr; //@line 259 "voices.cpp"
    var $arrayidx7=(($10+24)&4294967295); //@line 259 "voices.cpp"
    var $11=$tone_pts_addr; //@line 259 "voices.cpp"
    var $arrayidx8=(($11+28)&4294967295); //@line 259 "voices.cpp"
    var $12=$tone_pts_addr; //@line 259 "voices.cpp"
    var $arrayidx9=(($12+32)&4294967295); //@line 259 "voices.cpp"
    var $13=$tone_pts_addr; //@line 259 "voices.cpp"
    var $arrayidx10=(($13+36)&4294967295); //@line 259 "voices.cpp"
    var $call=_sscanf($3, ((__str44696)&4294967295), allocate([$arrayidx1,0,0,0,$arrayidx2,0,0,0,$arrayidx3,0,0,0,$arrayidx4,0,0,0,$arrayidx5,0,0,0,$arrayidx6,0,0,0,$arrayidx7,0,0,0,$arrayidx8,0,0,0,$arrayidx9,0,0,0,$arrayidx10,0,0,0], ["i32*",0,0,0,"i32*",0,0,0,"i32*",0,0,0,"i32*",0,0,0,"i32*",0,0,0,"i32*",0,0,0,"i32*",0,0,0,"i32*",0,0,0,"i32*",0,0,0,"i32*",0,0,0], ALLOC_STACK)); //@line 259 "voices.cpp"
    ;
    return; //@line 263 "voices.cpp"
    return;
  }
  

  function __Z10VoiceReseti($tone_only) {
    ;
    var __label__;
  
    var $tone_only_addr;
    var $pk;
    $tone_only_addr=$tone_only;
    var $0=HEAP32[((_voice)>>2)]; //@line 393 "voices.cpp"
    var $pitch_base=(($0+44)&4294967295); //@line 393 "voices.cpp"
    HEAP32[(($pitch_base)>>2)]=290816; //@line 393 "voices.cpp"
    var $1=HEAP32[((_voice)>>2)]; //@line 394 "voices.cpp"
    var $pitch_range=(($1+48)&4294967295); //@line 394 "voices.cpp"
    HEAP32[(($pitch_range)>>2)]=4104; //@line 394 "voices.cpp"
    var $2=HEAP32[((_voice)>>2)]; //@line 400 "voices.cpp"
    var $formant_factor=(($2+96)&4294967295); //@line 400 "voices.cpp"
    HEAP32[(($formant_factor)>>2)]=256; //@line 400 "voices.cpp"
    var $3=HEAP32[((_voice)>>2)]; //@line 402 "voices.cpp"
    var $speed_percent=(($3+64)&4294967295); //@line 402 "voices.cpp"
    HEAP32[(($speed_percent)>>2)]=100; //@line 402 "voices.cpp"
    var $4=HEAP32[((_voice)>>2)]; //@line 403 "voices.cpp"
    var $echo_delay=(($4+76)&4294967295); //@line 403 "voices.cpp"
    HEAP32[(($echo_delay)>>2)]=0; //@line 403 "voices.cpp"
    var $5=HEAP32[((_voice)>>2)]; //@line 404 "voices.cpp"
    var $echo_amp=(($5+80)&4294967295); //@line 404 "voices.cpp"
    HEAP32[(($echo_amp)>>2)]=0; //@line 404 "voices.cpp"
    var $6=HEAP32[((_voice)>>2)]; //@line 405 "voices.cpp"
    var $flutter=(($6+68)&4294967295); //@line 405 "voices.cpp"
    HEAP32[(($flutter)>>2)]=64; //@line 405 "voices.cpp"
    var $7=HEAP32[((_voice)>>2)]; //@line 406 "voices.cpp"
    var $n_harmonic_peaks=(($7+84)&4294967295); //@line 406 "voices.cpp"
    HEAP32[(($n_harmonic_peaks)>>2)]=5; //@line 406 "voices.cpp"
    var $8=HEAP32[((_voice)>>2)]; //@line 407 "voices.cpp"
    var $peak_shape=(($8+88)&4294967295); //@line 407 "voices.cpp"
    HEAP32[(($peak_shape)>>2)]=0; //@line 407 "voices.cpp"
    var $9=HEAP32[((_voice)>>2)]; //@line 408 "voices.cpp"
    var $voicing=(($9+92)&4294967295); //@line 408 "voices.cpp"
    HEAP32[(($voicing)>>2)]=64; //@line 408 "voices.cpp"
    var $10=HEAP32[((_voice)>>2)]; //@line 409 "voices.cpp"
    var $consonant_amp=(($10+100)&4294967295); //@line 409 "voices.cpp"
    HEAP32[(($consonant_amp)>>2)]=100; //@line 409 "voices.cpp"
    var $11=HEAP32[((_voice)>>2)]; //@line 410 "voices.cpp"
    var $consonant_ampv=(($11+104)&4294967295); //@line 410 "voices.cpp"
    HEAP32[(($consonant_ampv)>>2)]=100; //@line 410 "voices.cpp"
    var $12=HEAP32[((_voice)>>2)]; //@line 411 "voices.cpp"
    var $samplerate=(($12+108)&4294967295); //@line 411 "voices.cpp"
    HEAP32[(($samplerate)>>2)]=22050; //@line 411 "voices.cpp"
    var $13=HEAP32[((_voice)>>2)]; //@line 412 "voices.cpp"
    var $klattv=(($13+112)&4294967295); //@line 412 "voices.cpp"
    var $arraydecay=(($klattv)&4294967295); //@line 412 "voices.cpp"
    var $14=$arraydecay; //@line 412 "voices.cpp"
    var $dest$, $stop$, $stop4$, $fast$, $value4$;
    $dest$ = $14;
    $stop$ = $dest$ + 32;
    $value4$ = 0;
    if ($value4$ < 0) $value4$ += 256;
    $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
    while ($dest$%4 !== 0 && $dest$ < $stop$) {
      ;; HEAP8[$dest$++] = 0;
    }
    $dest$ >>= 2;
    $stop4$ = $stop$ >> 2;
    while ($dest$ < $stop4$) {
    ;;;;;;;  HEAP32[$dest$++] = $value4$;
    }
    $dest$ <<= 2;
    while ($dest$ < $stop$) {
      ;; HEAP8[$dest$++] = 0;
    }; //@line 412 "voices.cpp"
    HEAP32[((((_speed+32)&4294967295))>>2)]=450; //@line 414 "voices.cpp"
    HEAP32[((((_speed+32+4)&4294967295))>>2)]=800; //@line 415 "voices.cpp"
    HEAP32[((((_speed+32+8)&4294967295))>>2)]=175; //@line 416 "voices.cpp"
    var $15=HEAP32[((_voice)>>2)]; //@line 421 "voices.cpp"
    var $roughness=(($15+72)&4294967295); //@line 421 "voices.cpp"
    HEAP32[(($roughness)>>2)]=2; //@line 421 "voices.cpp"
    __Z10InitBreathv(); //@line 424 "voices.cpp"
    $pk=0; //@line 425 "voices.cpp"
    ; //@line 425 "voices.cpp"
    while(1) { 
  
      var $16=$pk; //@line 427 "voices.cpp"
      var $17=HEAP32[((_voice)>>2)]; //@line 427 "voices.cpp"
      var $freq=(($17+144)&4294967295); //@line 427 "voices.cpp"
      var $arrayidx=(($freq+$16*2)&4294967295); //@line 427 "voices.cpp"
      HEAP16[(($arrayidx)>>1)]=256; //@line 427 "voices.cpp"
      var $18=$pk; //@line 428 "voices.cpp"
      var $arrayidx1=((__ZZ10VoiceResetiE15default_heights+$18)&4294967295); //@line 428 "voices.cpp"
      var $19=HEAPU8[($arrayidx1)]; //@line 428 "voices.cpp"
      var $conv=((($19))&255); //@line 428 "voices.cpp"
      var $mul=((($conv)*2)&4294967295); //@line 428 "voices.cpp"
      var $conv2=((($mul)) & 65535); //@line 428 "voices.cpp"
      var $20=$pk; //@line 428 "voices.cpp"
      var $21=HEAP32[((_voice)>>2)]; //@line 428 "voices.cpp"
      var $height=(($21+162)&4294967295); //@line 428 "voices.cpp"
      var $arrayidx3=(($height+$20*2)&4294967295); //@line 428 "voices.cpp"
      HEAP16[(($arrayidx3)>>1)]=$conv2; //@line 428 "voices.cpp"
      var $22=$pk; //@line 429 "voices.cpp"
      var $arrayidx4=((__ZZ10VoiceResetiE14default_widths+$22)&4294967295); //@line 429 "voices.cpp"
      var $23=HEAPU8[($arrayidx4)]; //@line 429 "voices.cpp"
      var $conv5=((($23))&255); //@line 429 "voices.cpp"
      var $mul6=((($conv5)*2)&4294967295); //@line 429 "voices.cpp"
      var $conv7=((($mul6)) & 65535); //@line 429 "voices.cpp"
      var $24=$pk; //@line 429 "voices.cpp"
      var $25=HEAP32[((_voice)>>2)]; //@line 429 "voices.cpp"
      var $width=(($25+180)&4294967295); //@line 429 "voices.cpp"
      var $arrayidx8=(($width+$24*2)&4294967295); //@line 429 "voices.cpp"
      HEAP16[(($arrayidx8)>>1)]=$conv7; //@line 429 "voices.cpp"
      var $26=$pk; //@line 430 "voices.cpp"
      var $27=HEAP32[((_voice)>>2)]; //@line 430 "voices.cpp"
      var $breath=(($27+272)&4294967295); //@line 430 "voices.cpp"
      var $arrayidx9=(($breath+$26*4)&4294967295); //@line 430 "voices.cpp"
      HEAP32[(($arrayidx9)>>2)]=0; //@line 430 "voices.cpp"
      var $28=$pk; //@line 431 "voices.cpp"
      var $arrayidx10=((__ZZ10VoiceResetiE13breath_widths+$28*4)&4294967295); //@line 431 "voices.cpp"
      var $29=HEAP32[(($arrayidx10)>>2)]; //@line 431 "voices.cpp"
      var $30=$pk; //@line 431 "voices.cpp"
      var $31=HEAP32[((_voice)>>2)]; //@line 431 "voices.cpp"
      var $breathw=(($31+308)&4294967295); //@line 431 "voices.cpp"
      var $arrayidx11=(($breathw+$30*4)&4294967295); //@line 431 "voices.cpp"
      HEAP32[(($arrayidx11)>>2)]=$29; //@line 431 "voices.cpp"
      var $32=$pk; //@line 432 "voices.cpp"
      var $33=HEAP32[((_voice)>>2)]; //@line 432 "voices.cpp"
      var $freqadd=(($33+198)&4294967295); //@line 432 "voices.cpp"
      var $arrayidx12=(($freqadd+$32*2)&4294967295); //@line 432 "voices.cpp"
      HEAP16[(($arrayidx12)>>1)]=0; //@line 432 "voices.cpp"
      var $34=$pk; //@line 435 "voices.cpp"
      var $arrayidx13=((__ZL18formant_rate_22050+$34*4)&4294967295); //@line 435 "voices.cpp"
      var $35=HEAP32[(($arrayidx13)>>2)]; //@line 435 "voices.cpp"
      var $mul14=((($35)*22050)&4294967295); //@line 435 "voices.cpp"
      var $36=HEAP32[((_samplerate)>>2)]; //@line 435 "voices.cpp"
      var $div=((((($mul14))|0)/((($36))|0))|0); //@line 435 "voices.cpp"
      var $37=$pk; //@line 435 "voices.cpp"
      var $arrayidx15=((_formant_rate+$37*4)&4294967295); //@line 435 "voices.cpp"
      HEAP32[(($arrayidx15)>>2)]=$div; //@line 435 "voices.cpp"
      var $38=$pk; //@line 425 "voices.cpp"
      var $inc=((($38)+1)&4294967295); //@line 425 "voices.cpp"
      $pk=$inc; //@line 425 "voices.cpp"
      var $cmp=((($inc))|0) < 9; //@line 425 "voices.cpp"
      if ($cmp) { __label__ = 1;continue ; } else { __label__ = 2;break ; } //@line 425 "voices.cpp"
    }
  
    var $39=HEAP32[((_voice)>>2)]; //@line 437 "voices.cpp"
    var $height16=(($39+162)&4294967295); //@line 437 "voices.cpp"
    var $arrayidx17=(($height16+4)&4294967295); //@line 437 "voices.cpp"
    HEAP16[(($arrayidx17)>>1)]=240; //@line 437 "voices.cpp"
    var $40=HEAP32[((_voice)>>2)]; //@line 443 "voices.cpp"
    __ZL13SetToneAdjustP7voice_tPi($40, ((_tone_points)&4294967295)); //@line 443 "voices.cpp"
    var $41=HEAP32[((_voice)>>2)]; //@line 446 "voices.cpp"
    var $speedf1=(($41+52)&4294967295); //@line 446 "voices.cpp"
    HEAP32[(($speedf1)>>2)]=256; //@line 446 "voices.cpp"
    var $42=HEAP32[((_voice)>>2)]; //@line 447 "voices.cpp"
    var $speedf2=(($42+56)&4294967295); //@line 447 "voices.cpp"
    HEAP32[(($speedf2)>>2)]=238; //@line 447 "voices.cpp"
    var $43=HEAP32[((_voice)>>2)]; //@line 448 "voices.cpp"
    var $speedf3=(($43+60)&4294967295); //@line 448 "voices.cpp"
    HEAP32[(($speedf3)>>2)]=232; //@line 448 "voices.cpp"
    var $44=$tone_only_addr; //@line 450 "voices.cpp"
    var $cmp18=((($44))|0)==0; //@line 450 "voices.cpp"
    if ($cmp18) { __label__ = 3;; } else { __label__ = 4;; } //@line 450 "voices.cpp"
    if (__label__ == 3) {
  
      HEAP32[((_n_replace_phonemes)>>2)]=0; //@line 452 "voices.cpp"
      HEAP32[((_option_quiet)>>2)]=0; //@line 453 "voices.cpp"
      var $call=__Z15LoadMbrolaTablePKcS0_i(0, 0, 0); //@line 454 "voices.cpp"
      ; //@line 455 "voices.cpp"
    }
  
    ;
    return; //@line 456 "voices.cpp"
    return;
  }
  

  function __ZL13SetToneAdjustP7voice_tPi($voice, $tone_pts) {
    ;
    var __label__;
  
    var $voice_addr;
    var $tone_pts_addr;
    var $ix;
    var $pt;
    var $y;
    var $freq1;
    var $freq2;
    var $height1;
    var $height2;
    var $rate;
    $voice_addr=$voice;
    $tone_pts_addr=$tone_pts;
    $freq1=0; //@line 217 "voices.cpp"
    var $0=$tone_pts_addr; //@line 219 "voices.cpp"
    var $arrayidx=(($0+4)&4294967295); //@line 219 "voices.cpp"
    var $1=HEAP32[(($arrayidx)>>2)]; //@line 219 "voices.cpp"
    $height1=$1; //@line 219 "voices.cpp"
    $pt=0; //@line 223 "voices.cpp"
    ; //@line 223 "voices.cpp"
    $for_body$2: while(1) { 
  
      var $2=$pt; //@line 225 "voices.cpp"
      var $3=$tone_pts_addr; //@line 225 "voices.cpp"
      var $arrayidx1=(($3+4*$2)&4294967295); //@line 225 "voices.cpp"
      var $4=HEAP32[(($arrayidx1)>>2)]; //@line 225 "voices.cpp"
      var $cmp2=((($4))|0)==-1; //@line 225 "voices.cpp"
      if ($cmp2) { __label__ = 2;; } else { __label__ = 4;; } //@line 225 "voices.cpp"
      $if_then$$if_end8$4: do { 
        if (__label__ == 2) {
  
          var $5=$pt; //@line 227 "voices.cpp"
          var $6=$tone_pts_addr; //@line 227 "voices.cpp"
          var $arrayidx3=(($6+4*$5)&4294967295); //@line 227 "voices.cpp"
          HEAP32[(($arrayidx3)>>2)]=8000; //@line 227 "voices.cpp"
          var $7=$pt; //@line 228 "voices.cpp"
          var $cmp4=((($7))|0) > 0; //@line 228 "voices.cpp"
          if (!($cmp4)) { __label__ = 4;break $if_then$$if_end8$4; } //@line 228 "voices.cpp"
  
          var $8=$pt; //@line 229 "voices.cpp"
          var $sub=((($8)-1)&4294967295); //@line 229 "voices.cpp"
          var $9=$tone_pts_addr; //@line 229 "voices.cpp"
          var $arrayidx6=(($9+4*$sub)&4294967295); //@line 229 "voices.cpp"
          var $10=HEAP32[(($arrayidx6)>>2)]; //@line 229 "voices.cpp"
          var $11=$pt; //@line 229 "voices.cpp"
          var $add=((($11)+1)&4294967295); //@line 229 "voices.cpp"
          var $12=$tone_pts_addr; //@line 229 "voices.cpp"
          var $arrayidx7=(($12+4*$add)&4294967295); //@line 229 "voices.cpp"
          HEAP32[(($arrayidx7)>>2)]=$10; //@line 229 "voices.cpp"
          ; //@line 229 "voices.cpp"
        }
      } while(0);
  
      var $13=$pt; //@line 231 "voices.cpp"
      var $14=$tone_pts_addr; //@line 231 "voices.cpp"
      var $arrayidx9=(($14+4*$13)&4294967295); //@line 231 "voices.cpp"
      var $15=HEAP32[(($arrayidx9)>>2)]; //@line 231 "voices.cpp"
      var $div=((((($15))|0)/8)|0); //@line 231 "voices.cpp"
      $freq2=$div; //@line 231 "voices.cpp"
      var $16=$pt; //@line 232 "voices.cpp"
      var $add10=((($16)+1)&4294967295); //@line 232 "voices.cpp"
      var $17=$tone_pts_addr; //@line 232 "voices.cpp"
      var $arrayidx11=(($17+4*$add10)&4294967295); //@line 232 "voices.cpp"
      var $18=HEAP32[(($arrayidx11)>>2)]; //@line 232 "voices.cpp"
      $height2=$18; //@line 232 "voices.cpp"
      var $19=$freq2; //@line 233 "voices.cpp"
      var $20=$freq1; //@line 233 "voices.cpp"
      var $sub12=((($19)-($20))&4294967295); //@line 233 "voices.cpp"
      var $cmp13=((($sub12))|0) > 0; //@line 233 "voices.cpp"
      if ($cmp13) { __label__ = 5;; } else { __label__ = 9;; } //@line 233 "voices.cpp"
      $if_then14$$if_end31$8: do { 
        if (__label__ == 5) {
  
          var $21=$height2; //@line 235 "voices.cpp"
          var $22=$height1; //@line 235 "voices.cpp"
          var $sub15=((($21)-($22))&4294967295); //@line 235 "voices.cpp"
          var $conv=((($sub15))|0); //@line 235 "voices.cpp"
          var $23=$freq2; //@line 235 "voices.cpp"
          var $24=$freq1; //@line 235 "voices.cpp"
          var $sub16=((($23)-($24))&4294967295); //@line 235 "voices.cpp"
          var $conv17=((($sub16))|0); //@line 235 "voices.cpp"
          var $div18=($conv)/($conv17); //@line 235 "voices.cpp"
          $rate=$div18; //@line 235 "voices.cpp"
          var $25=$freq1; //@line 237 "voices.cpp"
          $ix=$25; //@line 237 "voices.cpp"
          var $26=$ix; //@line 237 "voices.cpp"
          var $27=$freq2; //@line 237 "voices.cpp"
          var $cmp201=((($26))|0) < ((($27))|0); //@line 237 "voices.cpp"
          if (!($cmp201)) { __label__ = 9;break $if_then14$$if_end31$8; } //@line 237 "voices.cpp"
          while(1) { 
  
            var $28=$height1; //@line 239 "voices.cpp"
            var $29=$rate; //@line 239 "voices.cpp"
            var $30=$ix; //@line 239 "voices.cpp"
            var $31=$freq1; //@line 239 "voices.cpp"
            var $sub22=((($30)-($31))&4294967295); //@line 239 "voices.cpp"
            var $conv23=((($sub22))|0); //@line 239 "voices.cpp"
            var $mul=($29)*($conv23); //@line 239 "voices.cpp"
            var $conv24=((($mul))|0); //@line 239 "voices.cpp"
            var $add25=((($conv24)+($28))&4294967295); //@line 239 "voices.cpp"
            $y=$add25; //@line 239 "voices.cpp"
            var $cmp26=((($add25))|0) > 255; //@line 240 "voices.cpp"
            if ($cmp26) { __label__ = 7;; } else { __label__ = 8;; } //@line 240 "voices.cpp"
            if (__label__ == 7) {
  
              $y=255; //@line 241 "voices.cpp"
              ; //@line 241 "voices.cpp"
            }
  
            var $32=$y; //@line 242 "voices.cpp"
            var $conv29=((($32)) & 255); //@line 242 "voices.cpp"
            var $33=$ix; //@line 242 "voices.cpp"
            var $34=$voice_addr; //@line 242 "voices.cpp"
            var $tone_adjust=(($34+344)&4294967295); //@line 242 "voices.cpp"
            var $arrayidx30=(($tone_adjust+$33)&4294967295); //@line 242 "voices.cpp"
            HEAP8[($arrayidx30)]=$conv29; //@line 242 "voices.cpp"
            var $35=$ix; //@line 237 "voices.cpp"
            var $inc=((($35)+1)&4294967295); //@line 237 "voices.cpp"
            $ix=$inc; //@line 237 "voices.cpp"
            var $36=$ix; //@line 237 "voices.cpp"
            var $37=$freq2; //@line 237 "voices.cpp"
            var $cmp20=((($36))|0) < ((($37))|0); //@line 237 "voices.cpp"
            if ($cmp20) { __label__ = 6;continue ; } else { __label__ = 9;break $if_then14$$if_end31$8; } //@line 237 "voices.cpp"
          }
        }
      } while(0);
  
      var $38=$freq2; //@line 245 "voices.cpp"
      $freq1=$38; //@line 245 "voices.cpp"
      var $39=$height2; //@line 246 "voices.cpp"
      $height1=$39; //@line 246 "voices.cpp"
      var $40=$pt; //@line 223 "voices.cpp"
      var $add33=((($40)+2)&4294967295); //@line 223 "voices.cpp"
      $pt=$add33; //@line 223 "voices.cpp"
      var $cmp=((($add33))|0) < 12; //@line 223 "voices.cpp"
      if ($cmp) { __label__ = 1;continue $for_body$2; } else { __label__ = 10;break $for_body$2; } //@line 223 "voices.cpp"
    }
  
    ;
    return; //@line 248 "voices.cpp"
    return;
  }
  

  function __Z9LoadVoicePKci($vname, $control) {
    var __stackBase__  = STACKTOP; STACKTOP += 1260; _memset(__stackBase__, 0, 1260);
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $vname_addr;
    var $control_addr;
    var $f_voice;
    var $p;
    var $key;
    var $ix;
    var $n;
    var $value=__stackBase__;
    var $value2=__stackBase__+4;
    var $error;
    var $langix;
    var $tone_only;
    var $language_set;
    var $phonemes_set;
    var $stress_amps_set;
    var $stress_lengths_set;
    var $stress_add_set;
    var $conditional_rules;
    var $langopts;
    var $new_translator;
    var $voicename=__stackBase__+8;
    var $language_name=__stackBase__+48;
    var $translator_name=__stackBase__+88;
    var $new_dictionary=__stackBase__+128;
    var $phonemes_name=__stackBase__+168;
    var $option_name=__stackBase__+208;
    var $language_type;
    var $buf=__stackBase__+248;
    var $path_voices=__stackBase__+448;
    var $langname=__stackBase__+612;
    var $stress_amps=__stackBase__+616;
    var $stress_lengths=__stackBase__+648;
    var $stress_add=__stackBase__+680;
    var $names=__stackBase__+712;
    var $pitch1=__stackBase__+1032;
    var $pitch2=__stackBase__+1036;
    var $len;
    var $priority=__stackBase__+1040;
    var $age=__stackBase__+1044;
    var $vgender=__stackBase__+1048;
    var $factor;
    var $tone_data=__stackBase__+1128;
    var $srate=__stackBase__+1176;
    var $name=__stackBase__+1180;
    var $phtrans=__stackBase__+1220;
    $vname_addr=$vname;
    $control_addr=$control;
    $f_voice=0; //@line 528 "voices.cpp"
    $error=0; //@line 535 "voices.cpp"
    $langix=0; //@line 536 "voices.cpp"
    var $0=$control_addr; //@line 537 "voices.cpp"
    var $and=($0) & 2; //@line 537 "voices.cpp"
    $tone_only=$and; //@line 537 "voices.cpp"
    $language_set=0; //@line 538 "voices.cpp"
    $phonemes_set=0; //@line 539 "voices.cpp"
    $stress_amps_set=0; //@line 540 "voices.cpp"
    $stress_lengths_set=0; //@line 541 "voices.cpp"
    $stress_add_set=0; //@line 542 "voices.cpp"
    $conditional_rules=0; //@line 543 "voices.cpp"
    $langopts=0; //@line 544 "voices.cpp"
    $new_translator=0; //@line 546 "voices.cpp"
    var $arraydecay=(($voicename)&4294967295); //@line 571 "voices.cpp"
    var $1=$vname_addr; //@line 571 "voices.cpp"
    var $call=_strcpy($arraydecay, $1); //@line 571 "voices.cpp"
    var $arrayidx=(($voicename)&4294967295); //@line 572 "voices.cpp"
    var $2=HEAP8[($arrayidx)]; //@line 572 "voices.cpp"
    var $conv=(tempInt=(($2)),(tempInt>=128?tempInt-256:tempInt)); //@line 572 "voices.cpp"
    var $cmp=((($conv))|0)==0; //@line 572 "voices.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 572 "voices.cpp"
    if (__label__ == 1) {
  
      var $arraydecay1=(($voicename)&4294967295); //@line 573 "voices.cpp"
      var $src$, $dest$, $stop$, $stop4$, $fast$;
      $src$ = ((__str45697)&4294967295);
      $dest$ = $arraydecay1;
      $stop$ = $src$ + 8;
      if (($dest$%4) == ($src$%4) && 8 > 8) {
        while ($src$%4 !== 0 && $src$ < $stop$) {
          ; HEAP8[$dest$++] = HEAP8[$src$++];
        }
        $src$ >>= 2;
        $dest$ >>= 2;
        $stop4$ = $stop$ >> 2;
        while ($src$ < $stop4$) {
      ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
        }
        $src$ <<= 2;
        $dest$ <<= 2;
      }while ($src$ < $stop$) {
        ; HEAP8[$dest$++] = HEAP8[$src$++];
      }; //@line 573 "voices.cpp"
      ; //@line 573 "voices.cpp"
    }
  
    var $3=$control_addr; //@line 575 "voices.cpp"
    var $and3=($3) & 16; //@line 575 "voices.cpp"
    var $tobool=((($and3))|0)!=0; //@line 575 "voices.cpp"
    if ($tobool) { __label__ = 3;; } else { __label__ = 5;; } //@line 575 "voices.cpp"
    $if_then4$$if_else$5: do { 
      if (__label__ == 3) {
  
        var $arraydecay5=(($buf)&4294967295); //@line 577 "voices.cpp"
        var $4=$vname_addr; //@line 577 "voices.cpp"
        var $call6=_strcpy($arraydecay5, $4); //@line 577 "voices.cpp"
        var $arraydecay7=(($buf)&4294967295); //@line 578 "voices.cpp"
        var $call8=__Z13GetFileLengthPKc($arraydecay7); //@line 578 "voices.cpp"
        var $cmp9=((($call8))|0) <= 0; //@line 578 "voices.cpp"
        if (!($cmp9)) { __label__ = 9;break $if_then4$$if_else$5; } //@line 578 "voices.cpp"
  
        $retval=0; //@line 579 "voices.cpp"
        __label__ = 137;break $if_then4$$if_else$5; //@line 579 "voices.cpp"
      }
      else if (__label__ == 5) {
  
        var $arraydecay12=(($path_voices)&4294967295); //@line 583 "voices.cpp"
        var $call13=_sprintf($arraydecay12, ((__str46698)&4294967295), allocate([((_path_home)&4294967295),0,0,0,47,0,0,0,47,0,0,0], ["i8*",0,0,0,"i32",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 583 "voices.cpp"
        var $arraydecay14=(($buf)&4294967295); //@line 584 "voices.cpp"
        var $arraydecay15=(($path_voices)&4294967295); //@line 584 "voices.cpp"
        var $arraydecay16=(($voicename)&4294967295); //@line 584 "voices.cpp"
        var $call17=_sprintf($arraydecay14, ((__str47699)&4294967295), allocate([$arraydecay15,0,0,0,$arraydecay16,0,0,0], ["i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 584 "voices.cpp"
        var $arraydecay18=(($buf)&4294967295); //@line 586 "voices.cpp"
        var $call19=__Z13GetFileLengthPKc($arraydecay18); //@line 586 "voices.cpp"
        var $cmp20=((($call19))|0) <= 0; //@line 586 "voices.cpp"
        if (!($cmp20)) { __label__ = 9;break $if_then4$$if_else$5; } //@line 586 "voices.cpp"
  
        var $arrayidx22=(($voicename)&4294967295); //@line 589 "voices.cpp"
        var $5=HEAP8[($arrayidx22)]; //@line 589 "voices.cpp"
        var $arrayidx23=(($langname)&4294967295); //@line 589 "voices.cpp"
        HEAP8[($arrayidx23)]=$5; //@line 589 "voices.cpp"
        var $arrayidx24=(($voicename+1)&4294967295); //@line 590 "voices.cpp"
        var $6=HEAP8[($arrayidx24)]; //@line 590 "voices.cpp"
        var $arrayidx25=(($langname+1)&4294967295); //@line 590 "voices.cpp"
        HEAP8[($arrayidx25)]=$6; //@line 590 "voices.cpp"
        var $arrayidx26=(($langname+2)&4294967295); //@line 591 "voices.cpp"
        HEAP8[($arrayidx26)]=0; //@line 591 "voices.cpp"
        var $arraydecay27=(($buf)&4294967295); //@line 592 "voices.cpp"
        var $arraydecay28=(($path_voices)&4294967295); //@line 592 "voices.cpp"
        var $arraydecay29=(($langname)&4294967295); //@line 592 "voices.cpp"
        var $arraydecay30=(($voicename)&4294967295); //@line 592 "voices.cpp"
        var $call31=_sprintf($arraydecay27, ((__str48700)&4294967295), allocate([$arraydecay28,0,0,0,$arraydecay29,0,0,0,47,0,0,0,$arraydecay30,0,0,0], ["i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 592 "voices.cpp"
        var $arraydecay32=(($buf)&4294967295); //@line 594 "voices.cpp"
        var $call33=__Z13GetFileLengthPKc($arraydecay32); //@line 594 "voices.cpp"
        var $cmp34=((($call33))|0) <= 0; //@line 594 "voices.cpp"
        if (!($cmp34)) { __label__ = 9;break $if_then4$$if_else$5; } //@line 594 "voices.cpp"
  
        var $arraydecay36=(($buf)&4294967295); //@line 597 "voices.cpp"
        var $arraydecay37=(($path_voices)&4294967295); //@line 597 "voices.cpp"
        var $arraydecay38=(($voicename)&4294967295); //@line 597 "voices.cpp"
        var $call39=_sprintf($arraydecay36, ((__str49701)&4294967295), allocate([$arraydecay37,0,0,0,47,0,0,0,$arraydecay38,0,0,0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 597 "voices.cpp"
        var $arraydecay40=(($buf)&4294967295); //@line 599 "voices.cpp"
        var $call41=__Z13GetFileLengthPKc($arraydecay40); //@line 599 "voices.cpp"
        var $cmp42=((($call41))|0) <= 0; //@line 599 "voices.cpp"
        if (!($cmp42)) { __label__ = 9;break $if_then4$$if_else$5; } //@line 599 "voices.cpp"
  
        var $arraydecay44=(($buf)&4294967295); //@line 602 "voices.cpp"
        var $arraydecay45=(($path_voices)&4294967295); //@line 602 "voices.cpp"
        var $arraydecay46=(($voicename)&4294967295); //@line 602 "voices.cpp"
        var $call47=_sprintf($arraydecay44, ((__str50702)&4294967295), allocate([$arraydecay45,0,0,0,47,0,0,0,$arraydecay46,0,0,0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 602 "voices.cpp"
        __label__ = 9;break $if_then4$$if_else$5; //@line 603 "voices.cpp"
      }
    } while(0);
    $return$$if_end51$12: do { 
      if (__label__ == 9) {
  
        var $arraydecay52=(($buf)&4294967295); //@line 608 "voices.cpp"
        var $call53=_fopen($arraydecay52, ((__str51703)&4294967295)); //@line 608 "voices.cpp"
        $f_voice=$call53; //@line 608 "voices.cpp"
        $language_type=((__str52704)&4294967295); //@line 610 "voices.cpp"
        var $cmp54=((($call53))|0)==0; //@line 611 "voices.cpp"
        if ($cmp54) { __label__ = 10;; } else { __label__ = 14;; } //@line 611 "voices.cpp"
        $if_then55$$if_end66$14: do { 
          if (__label__ == 10) {
  
            var $7=$control_addr; //@line 613 "voices.cpp"
            var $and56=($7) & 3; //@line 613 "voices.cpp"
            var $tobool57=((($and56))|0)!=0; //@line 613 "voices.cpp"
            if ($tobool57) { __label__ = 11;; } else { __label__ = 12;; } //@line 613 "voices.cpp"
            if (__label__ == 11) {
  
              $retval=0; //@line 614 "voices.cpp"
              __label__ = 137;break $return$$if_end51$12; //@line 614 "voices.cpp"
            }
            else if (__label__ == 12) {
  
              var $arraydecay60=(($voicename)&4294967295); //@line 616 "voices.cpp"
              var $call61=__Z22SelectPhonemeTableNamePKc($arraydecay60); //@line 616 "voices.cpp"
              var $cmp62=((($call61))|0) >= 0; //@line 616 "voices.cpp"
              if (!($cmp62)) { __label__ = 14;break $if_then55$$if_end66$14; } //@line 616 "voices.cpp"
  
              var $arraydecay64=(($voicename)&4294967295); //@line 617 "voices.cpp"
              $language_type=$arraydecay64; //@line 617 "voices.cpp"
              ; //@line 617 "voices.cpp"
            }
          }
        } while(0);
  
        var $8=$tone_only; //@line 620 "voices.cpp"
        var $tobool67=((($8))|0)==0; //@line 620 "voices.cpp"
        var $9=HEAP32[((_translator)>>2)]; //@line 620 "voices.cpp"
        var $cmp68=((($9))|0)!=0; //@line 620 "voices.cpp"
        var $or_cond=($tobool67) & ($cmp68); //@line 620 "voices.cpp"
        if ($or_cond) { __label__ = 15;; } else { __label__ = 16;; } //@line 620 "voices.cpp"
        if (__label__ == 15) {
  
          var $10=HEAP32[((_translator)>>2)]; //@line 622 "voices.cpp"
          __Z16DeleteTranslatorP10Translator($10); //@line 622 "voices.cpp"
          HEAP32[((_translator)>>2)]=0; //@line 623 "voices.cpp"
          ; //@line 624 "voices.cpp"
        }
  
        var $arraydecay71=(($translator_name)&4294967295); //@line 626 "voices.cpp"
        var $11=$language_type; //@line 626 "voices.cpp"
        var $call72=_strcpy($arraydecay71, $11); //@line 626 "voices.cpp"
        var $arraydecay73=(($new_dictionary)&4294967295); //@line 627 "voices.cpp"
        var $12=$language_type; //@line 627 "voices.cpp"
        var $call74=_strcpy($arraydecay73, $12); //@line 627 "voices.cpp"
        var $arraydecay75=(($phonemes_name)&4294967295); //@line 628 "voices.cpp"
        var $13=$language_type; //@line 628 "voices.cpp"
        var $call76=_strcpy($arraydecay75, $13); //@line 628 "voices.cpp"
        var $14=$tone_only; //@line 631 "voices.cpp"
        var $tobool77=((($14))|0)!=0; //@line 631 "voices.cpp"
        if ($tobool77) { __label__ = 18;; } else { __label__ = 17;; } //@line 631 "voices.cpp"
        if (__label__ == 18) {
  
          var $call80=_strchr(((__ZZ9LoadVoicePKciE16voice_identifier)&4294967295), 43); //@line 645 "voices.cpp"
          $p=$call80; //@line 645 "voices.cpp"
          var $cmp81=((($call80))|0)!=0; //@line 645 "voices.cpp"
          if ($cmp81) { __label__ = 19;; } else { __label__ = 20;; } //@line 645 "voices.cpp"
          if (__label__ == 19) {
  
            var $16=$p; //@line 646 "voices.cpp"
            HEAP8[($16)]=0; //@line 646 "voices.cpp"
            ; //@line 646 "voices.cpp"
          }
  
          var $arraydecay84=(($buf)&4294967295); //@line 647 "voices.cpp"
          var $17=$vname_addr; //@line 647 "voices.cpp"
          var $arrayidx85=(($17+3)&4294967295); //@line 647 "voices.cpp"
          var $call86=_sprintf($arraydecay84, ((__str53705)&4294967295), allocate([$arrayidx85,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 647 "voices.cpp"
          var $arraydecay87=(($buf)&4294967295); //@line 648 "voices.cpp"
          var $call88=_strcat(((__ZZ9LoadVoicePKciE16voice_identifier)&4294967295), $arraydecay87); //@line 648 "voices.cpp"
          var $18=HEAP32[((_translator)>>2)]; //@line 649 "voices.cpp"
          var $langopts89=(($18)&4294967295); //@line 649 "voices.cpp"
          $langopts=$langopts89; //@line 649 "voices.cpp"
          ;
        }
        else if (__label__ == 17) {
  
          HEAP32[((_voice)>>2)]=__ZL9voicedata; //@line 633 "voices.cpp"
          var $15=$vname_addr; //@line 634 "voices.cpp"
          __Z8strncpy0PcPKci(((__ZZ9LoadVoicePKciE16voice_identifier)&4294967295), $15, 40); //@line 634 "voices.cpp"
          HEAP8[(((__ZZ9LoadVoicePKciE10voice_name)&4294967295))]=0; //@line 635 "voices.cpp"
          HEAP8[(((__ZZ9LoadVoicePKciE15voice_languages)&4294967295))]=0; //@line 636 "voices.cpp"
          HEAP32[((((_voice_selected+8)&4294967295))>>2)]=((__ZZ9LoadVoicePKciE16voice_identifier)&4294967295); //@line 638 "voices.cpp"
          HEAP32[((((_voice_selected)&4294967295))>>2)]=((__ZZ9LoadVoicePKciE10voice_name)&4294967295); //@line 639 "voices.cpp"
          HEAP32[((((_voice_selected+4)&4294967295))>>2)]=((__ZZ9LoadVoicePKciE15voice_languages)&4294967295); //@line 640 "voices.cpp"
          ; //@line 641 "voices.cpp"
        }
  
        var $19=$tone_only; //@line 651 "voices.cpp"
        __Z10VoiceReseti($19); //@line 651 "voices.cpp"
        var $20=$tone_only; //@line 653 "voices.cpp"
        var $tobool91=((($20))|0)!=0; //@line 653 "voices.cpp"
        if ($tobool91) { __label__ = 23;; } else { __label__ = 22;; } //@line 653 "voices.cpp"
        if (__label__ == 22) {
  
          var $arraydecay93=(($phonemes_name)&4294967295); //@line 654 "voices.cpp"
          var $call94=__Z22SelectPhonemeTableNamePKc($arraydecay93); //@line 654 "voices.cpp"
          ; //@line 654 "voices.cpp"
        }
  
        var $arraydecay97=(($buf)&4294967295); //@line 657 "voices.cpp"
        var $arraydecay100=(($buf)&4294967295); //@line 660 "voices.cpp"
        var $arrayidx109=(($buf)&4294967295); //@line 663 "voices.cpp"
        var $arraydecay114=(($buf)&4294967295); //@line 665 "voices.cpp"
        var $arraydecay416=(($buf)&4294967295); //@line 954 "voices.cpp"
        var $arrayidx119=(($language_name)&4294967295); //@line 678 "voices.cpp"
        var $arraydecay120=(($language_name)&4294967295); //@line 680 "voices.cpp"
        var $arraydecay122=(($language_name)&4294967295); //@line 681 "voices.cpp"
        var $arraydecay127=(($language_name)&4294967295); //@line 684 "voices.cpp"
        var $arraydecay136=(($language_name)&4294967295); //@line 690 "voices.cpp"
        var $arraydecay142=(($language_name)&4294967295); //@line 697 "voices.cpp"
        var $arraydecay144=(($translator_name)&4294967295); //@line 699 "voices.cpp"
        var $arraydecay146=(($new_dictionary)&4294967295); //@line 700 "voices.cpp"
        var $arraydecay148=(($phonemes_name)&4294967295); //@line 701 "voices.cpp"
        var $arraydecay150=(($phonemes_name)&4294967295); //@line 702 "voices.cpp"
        var $arraydecay155=(($translator_name)&4294967295); //@line 707 "voices.cpp"
        var $arraydecay170=(($vgender)&4294967295); //@line 725 "voices.cpp"
        var $arraydecay172=(($vgender)&4294967295); //@line 726 "voices.cpp"
        var $arraydecay180=(($translator_name)&4294967295); //@line 734 "voices.cpp"
        var $arraydecay185=(($translator_name)&4294967295); //@line 739 "voices.cpp"
        var $arraydecay189=(($new_dictionary)&4294967295); //@line 744 "voices.cpp"
        var $arraydecay192=(($phonemes_name)&4294967295); //@line 748 "voices.cpp"
        var $arraydecay206=(($stress_lengths)&4294967295); //@line 768 "voices.cpp"
        var $arraydecay209=(($stress_amps)&4294967295); //@line 772 "voices.cpp"
        var $arraydecay212=(($stress_add)&4294967295); //@line 776 "voices.cpp"
        var $arrayidx222=(($names)&4294967295); //@line 786 "voices.cpp"
        var $arraydecay223=(($arrayidx222)&4294967295); //@line 786 "voices.cpp"
        var $arrayidx224=(($names+40)&4294967295); //@line 786 "voices.cpp"
        var $arraydecay225=(($arrayidx224)&4294967295); //@line 786 "voices.cpp"
        var $arrayidx226=(($names+80)&4294967295); //@line 786 "voices.cpp"
        var $arraydecay227=(($arrayidx226)&4294967295); //@line 786 "voices.cpp"
        var $arrayidx228=(($names+120)&4294967295); //@line 786 "voices.cpp"
        var $arraydecay229=(($arrayidx228)&4294967295); //@line 786 "voices.cpp"
        var $arrayidx230=(($names+160)&4294967295); //@line 786 "voices.cpp"
        var $arraydecay231=(($arrayidx230)&4294967295); //@line 786 "voices.cpp"
        var $arrayidx232=(($names+200)&4294967295); //@line 786 "voices.cpp"
        var $arraydecay233=(($arrayidx232)&4294967295); //@line 786 "voices.cpp"
        var $arraydecay290=(($phonemes_name)&4294967295); //@line 818 "voices.cpp"
        var $arraydecay308=(($option_name)&4294967295); //@line 846 "voices.cpp"
        var $arraydecay312=(($option_name)&4294967295); //@line 846 "voices.cpp"
        var $arraydecay320=(($buf)&4294967295); //@line 853 "voices.cpp"
        var $arraydecay347=(($tone_data)&4294967295); //@line 889 "voices.cpp"
        var $arraydecay348=(($tone_data)&4294967295); //@line 890 "voices.cpp"
        var $arrayidx385=(($phtrans)&4294967295); //@line 926 "voices.cpp"
        var $arraydecay386=(($name)&4294967295); //@line 927 "voices.cpp"
        var $arraydecay387=(($phtrans)&4294967295); //@line 927 "voices.cpp"
        var $arraydecay389=(($name)&4294967295); //@line 928 "voices.cpp"
        var $arraydecay390=(($phtrans)&4294967295); //@line 928 "voices.cpp"
        ; //@line 657 "voices.cpp"
        $while_cond$34: while(1) { 
  
          var $21=$f_voice; //@line 657 "voices.cpp"
          var $cmp96=((($21))|0)!=0; //@line 657 "voices.cpp"
          if (!($cmp96)) { __label__ = 114;break $while_cond$34; } //@line 657 "voices.cpp"
  
          var $22=$f_voice; //@line 657 "voices.cpp"
          var $call98=__ZL11fgets_stripPciP7__sFILE($arraydecay97, 200, $22); //@line 657 "voices.cpp"
          var $cmp99=((($call98))|0)!=0; //@line 657 "voices.cpp"
          if (!($cmp99)) { __label__ = 112;break $while_cond$34; }
  
          $p=$arraydecay100; //@line 660 "voices.cpp"
          ; //@line 660 "voices.cpp"
          $for_cond$38: while(1) { 
  
            var $23=$p; //@line 660 "voices.cpp"
            var $24=HEAP8[($23)]; //@line 660 "voices.cpp"
            var $conv101=(tempInt=(($24)),(tempInt>=128?tempInt-256:tempInt)); //@line 660 "voices.cpp"
            var $cmp102=((($conv101))|0)!=0; //@line 660 "voices.cpp"
            if (!($cmp102)) { __label__ = 30;break $for_cond$38; } //@line 660 "voices.cpp"
  
            var $25=$p; //@line 660 "voices.cpp"
            var $26=HEAP8[($25)]; //@line 660 "voices.cpp"
            var $conv104=(tempInt=(($26)),(tempInt>=128?tempInt-256:tempInt)); //@line 660 "voices.cpp"
            var $call105=_isspace($conv104); //@line 660 "voices.cpp"
            var $tobool106=((($call105))|0)!=0; //@line 660 "voices.cpp"
            var $lnot=($tobool106) ^ 1; //@line 660 "voices.cpp"
            if (!($lnot)) { __label__ = 30;break $for_cond$38; }
  
            var $27=$p; //@line 660 "voices.cpp"
            var $incdec_ptr=(($27+1)&4294967295); //@line 660 "voices.cpp"
            $p=$incdec_ptr; //@line 660 "voices.cpp"
            __label__ = 27;continue $for_cond$38; //@line 660 "voices.cpp"
          }
  
          var $28=$p; //@line 661 "voices.cpp"
          var $incdec_ptr108=(($28+1)&4294967295); //@line 661 "voices.cpp"
          $p=$incdec_ptr108; //@line 661 "voices.cpp"
          HEAP8[($28)]=0; //@line 661 "voices.cpp"
          var $29=HEAP8[($arrayidx109)]; //@line 663 "voices.cpp"
          var $conv110=(tempInt=(($29)),(tempInt>=128?tempInt-256:tempInt)); //@line 663 "voices.cpp"
          var $cmp111=((($conv110))|0)==0; //@line 663 "voices.cpp"
          if ($cmp111) { __label__ = 24;continue $while_cond$34; } //@line 663 "voices.cpp"
  
          var $call115=__Z10LookupMnemP8MNEM_TABPKc(((__ZL11keyword_tab)&4294967295), $arraydecay114); //@line 665 "voices.cpp"
          $key=$call115; //@line 665 "voices.cpp"
          var $30=$key; //@line 667 "voices.cpp"
          if ($30 == 2) {
            __label__ = 33;;
          }
          else if ($30 == 1) {
            __label__ = 41;;
          }
          else if ($30 == 3) {
            __label__ = 45;;
          }
          else if ($30 == 4) {
            __label__ = 46;;
          }
          else if ($30 == 6) {
            __label__ = 50;;
          }
          else if ($30 == 5) {
            __label__ = 51;;
          }
          else if ($30 == 7) {
            __label__ = 52;;
          }
          else if ($30 == 8) {
            __label__ = 53;;
          }
          else if ($30 == 20) {
            __label__ = 54;;
          }
          else if ($30 == 21) {
            __label__ = 55;;
          }
          else if ($30 == 22) {
            __label__ = 56;;
          }
          else if ($30 == 18) {
            __label__ = 57;;
          }
          else if ($30 == 19) {
            __label__ = 59;;
          }
          else if ($30 == 23) {
            __label__ = 32;;
          }
          else if ($30 == 32) {
            __label__ = 73;;
          }
          else if ($30 == 17) {
            __label__ = 76;;
          }
          else if ($30 == 24) {
            __label__ = 77;;
          }
          else if ($30 == 25) {
            __label__ = 78;;
          }
          else if ($30 == 26) {
            __label__ = 80;;
          }
          else if ($30 == 27) {
            __label__ = 81;;
          }
          else if ($30 == 9) {
            __label__ = 85;;
          }
          else if ($30 == 10) {
            __label__ = 86;;
          }
          else if ($30 == 11) {
            __label__ = 88;;
          }
          else if ($30 == 12) {
            __label__ = 90;;
          }
          else if ($30 == 13) {
            __label__ = 94;;
          }
          else if ($30 == 14) {
            __label__ = 95;;
          }
          else if ($30 == 15) {
            __label__ = 97;;
          }
          else if ($30 == 16) {
            __label__ = 101;;
          }
          else if ($30 == 33) {
            __label__ = 102;;
          }
          else if ($30 == 31) {
            __label__ = 103;;
          }
          else if ($30 == 28) {
            __label__ = 104;;
          }
          else if ($30 == 29) {
            __label__ = 107;;
          }
          else if ($30 == 30) {
            __label__ = 108;;
          }
          else {
          __label__ = 109;;
          }
          
          if (__label__ == 109) {
  
            var $195=$key; //@line 948 "voices.cpp"
            var $and407=($195) & 65280; //@line 948 "voices.cpp"
            var $cmp408=((($and407))|0)==256; //@line 948 "voices.cpp"
            if ($cmp408) { __label__ = 110;; } else { __label__ = 111;; } //@line 948 "voices.cpp"
            if (__label__ == 110) {
  
              var $196=$p; //@line 950 "voices.cpp"
              var $197=$key; //@line 950 "voices.cpp"
              var $and410=($197) & 255; //@line 950 "voices.cpp"
              var $198=$langopts; //@line 950 "voices.cpp"
              var $param411=(($198+24)&4294967295); //@line 950 "voices.cpp"
              var $arrayidx412=(($param411+$and410*4)&4294967295); //@line 950 "voices.cpp"
              var $call413=_sscanf($196, ((__str63715)&4294967295), allocate([$arrayidx412,0,0,0], ["i32*",0,0,0], ALLOC_STACK)); //@line 950 "voices.cpp"
              __label__ = 24;continue $while_cond$34; //@line 951 "voices.cpp"
            }
            else if (__label__ == 111) {
  
              var $199=HEAP32[((__impure_ptr)>>2)]; //@line 954 "voices.cpp"
              var $_stderr415=(($199+12)&4294967295); //@line 954 "voices.cpp"
              var $200=HEAP32[(($_stderr415)>>2)]; //@line 954 "voices.cpp"
              var $call417=_fprintf($200, ((__str68720)&4294967295), allocate([$arraydecay416,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 954 "voices.cpp"
              __label__ = 24;continue $while_cond$34;
            }
          }
          else if (__label__ == 33) {
  
            var $33=$tone_only; //@line 674 "voices.cpp"
            var $tobool116=((($33))|0)!=0; //@line 674 "voices.cpp"
            if ($tobool116) { __label__ = 24;continue $while_cond$34; } //@line 674 "voices.cpp"
  
            HEAP32[(($priority)>>2)]=5; //@line 677 "voices.cpp"
            HEAP8[($arrayidx119)]=0; //@line 678 "voices.cpp"
            var $34=$p; //@line 680 "voices.cpp"
            var $call121=_sscanf($34, ((__str54706)&4294967295), allocate([$arraydecay120,0,0,0,$priority,0,0,0], ["i8*",0,0,0,"i32*",0,0,0], ALLOC_STACK)); //@line 680 "voices.cpp"
            var $call123=_strcmp($arraydecay122, ((__str55707)&4294967295)); //@line 681 "voices.cpp"
            var $cmp124=((($call123))|0)==0; //@line 681 "voices.cpp"
            if ($cmp124) { __label__ = 24;continue $while_cond$34; } //@line 681 "voices.cpp"
  
            var $call128=_strlen($arraydecay127); //@line 684 "voices.cpp"
            var $add=((($call128)+2)&4294967295); //@line 684 "voices.cpp"
            $len=$add; //@line 684 "voices.cpp"
            var $35=$len; //@line 686 "voices.cpp"
            var $36=$langix; //@line 686 "voices.cpp"
            var $_neg=(((-($36)))&4294967295);
            var $sub129=((($_neg)+99)&4294967295); //@line 686 "voices.cpp"
            var $cmp130=((($35))>>>0) < ((($sub129))>>>0); //@line 686 "voices.cpp"
            if ($cmp130) { __label__ = 36;; } else { __label__ = 37;; } //@line 686 "voices.cpp"
            if (__label__ == 36) {
  
              var $37=HEAP32[(($priority)>>2)]; //@line 688 "voices.cpp"
              var $conv132=((($37)) & 255); //@line 688 "voices.cpp"
              var $38=$langix; //@line 688 "voices.cpp"
              var $arrayidx133=((__ZZ9LoadVoicePKciE15voice_languages+$38)&4294967295); //@line 688 "voices.cpp"
              HEAP8[($arrayidx133)]=$conv132; //@line 688 "voices.cpp"
              var $39=$langix; //@line 690 "voices.cpp"
              var $add134=((($39)+1)&4294967295); //@line 690 "voices.cpp"
              var $arrayidx135=((__ZZ9LoadVoicePKciE15voice_languages+$add134)&4294967295); //@line 690 "voices.cpp"
              var $call137=_strcpy($arrayidx135, $arraydecay136); //@line 690 "voices.cpp"
              var $40=$len; //@line 691 "voices.cpp"
              var $41=$langix; //@line 691 "voices.cpp"
              var $add138=((($41)+($40))&4294967295); //@line 691 "voices.cpp"
              $langix=$add138; //@line 691 "voices.cpp"
              ; //@line 692 "voices.cpp"
            }
  
            var $42=$language_set; //@line 695 "voices.cpp"
            var $cmp140=((($42))|0)==0; //@line 695 "voices.cpp"
            if (!($cmp140)) { __label__ = 24;continue $while_cond$34; } //@line 695 "voices.cpp"
  
            var $call143=_strtok($arraydecay142, ((__str56708)&4294967295)); //@line 697 "voices.cpp"
            $language_type=$call143; //@line 697 "voices.cpp"
            $language_set=1; //@line 698 "voices.cpp"
            var $43=$language_type; //@line 699 "voices.cpp"
            var $call145=_strcpy($arraydecay144, $43); //@line 699 "voices.cpp"
            var $44=$language_type; //@line 700 "voices.cpp"
            var $call147=_strcpy($arraydecay146, $44); //@line 700 "voices.cpp"
            var $45=$language_type; //@line 701 "voices.cpp"
            var $call149=_strcpy($arraydecay148, $45); //@line 701 "voices.cpp"
            var $call151=__Z22SelectPhonemeTableNamePKc($arraydecay150); //@line 702 "voices.cpp"
            var $46=$new_translator; //@line 704 "voices.cpp"
            var $cmp152=((($46))|0)!=0; //@line 704 "voices.cpp"
            if ($cmp152) { __label__ = 39;; } else { __label__ = 40;; } //@line 704 "voices.cpp"
            if (__label__ == 39) {
  
              var $47=$new_translator; //@line 705 "voices.cpp"
              __Z16DeleteTranslatorP10Translator($47); //@line 705 "voices.cpp"
              ; //@line 705 "voices.cpp"
            }
  
            var $call156=__Z16SelectTranslatorPKc($arraydecay155); //@line 707 "voices.cpp"
            $new_translator=$call156; //@line 707 "voices.cpp"
            var $48=$new_translator; //@line 708 "voices.cpp"
            var $langopts157=(($48)&4294967295); //@line 708 "voices.cpp"
            $langopts=$langopts157; //@line 708 "voices.cpp"
            __label__ = 24;continue $while_cond$34; //@line 709 "voices.cpp"
          }
          else if (__label__ == 41) {
  
            var $49=$tone_only; //@line 714 "voices.cpp"
            var $cmp160=((($49))|0)==0; //@line 714 "voices.cpp"
            if (!($cmp160)) { __label__ = 24;continue $while_cond$34; } //@line 714 "voices.cpp"
  
            var $50=$p; //@line 716 "voices.cpp"
            var $51=HEAP8[($50)]; //@line 716 "voices.cpp"
            var $conv1636=(tempInt=(($51)),(tempInt>=128?tempInt-256:tempInt)); //@line 716 "voices.cpp"
            var $call1647=_isspace($conv1636); //@line 716 "voices.cpp"
            var $tobool1658=((($call1647))|0)!=0; //@line 716 "voices.cpp"
            var $52=$p; //@line 716 "voices.cpp"
            if ($tobool1658) { __lastLabel__ = 42; __label__ = 43;; } else { __lastLabel__ = 42; __label__ = 44;; } //@line 716 "voices.cpp"
            $while_body166$$while_end$61: do { 
              if (__label__ == 43) {
                while(1) { 
  
                  var $53=__lastLabel__ == 43 ? $56 : ($52);
                  var $incdec_ptr167=(($53+1)&4294967295); //@line 716 "voices.cpp"
                  $p=$incdec_ptr167; //@line 716 "voices.cpp"
                  var $54=$p; //@line 716 "voices.cpp"
                  var $55=HEAP8[($54)]; //@line 716 "voices.cpp"
                  var $conv163=(tempInt=(($55)),(tempInt>=128?tempInt-256:tempInt)); //@line 716 "voices.cpp"
                  var $call164=_isspace($conv163); //@line 716 "voices.cpp"
                  var $tobool165=((($call164))|0)!=0; //@line 716 "voices.cpp"
                  var $56=$p; //@line 716 "voices.cpp"
                  if ($tobool165) { __lastLabel__ = 43; __label__ = 43;continue ; } else { __lastLabel__ = 43; __label__ = 44;break $while_body166$$while_end$61; } //@line 716 "voices.cpp"
                }
              }
            } while(0);
  
            var $_lcssa=__lastLabel__ == 42 ? $52 : ($56);
            __Z8strncpy0PcPKci(((__ZZ9LoadVoicePKciE10voice_name)&4294967295), $_lcssa, 40); //@line 717 "voices.cpp"
            __label__ = 24;continue $while_cond$34; //@line 718 "voices.cpp"
          }
          else if (__label__ == 45) {
  
            HEAP32[(($age)>>2)]=0; //@line 723 "voices.cpp"
            var $57=$p; //@line 725 "voices.cpp"
            var $call171=_sscanf($57, ((__str54706)&4294967295), allocate([$arraydecay170,0,0,0,$age,0,0,0], ["i8*",0,0,0,"i32*",0,0,0], ALLOC_STACK)); //@line 725 "voices.cpp"
            var $call173=__Z10LookupMnemP8MNEM_TABPKc(((_genders)&4294967295), $arraydecay172); //@line 726 "voices.cpp"
            var $conv174=((($call173)) & 255); //@line 726 "voices.cpp"
            HEAP8[(((_voice_selected+12)&4294967295))]=$conv174; //@line 726 "voices.cpp"
            var $58=HEAP32[(($age)>>2)]; //@line 727 "voices.cpp"
            var $conv175=((($58)) & 255); //@line 727 "voices.cpp"
            HEAP8[(((_voice_selected+13)&4294967295))]=$conv175; //@line 727 "voices.cpp"
            __label__ = 24;continue $while_cond$34; //@line 729 "voices.cpp"
          }
          else if (__label__ == 46) {
  
            var $59=$tone_only; //@line 732 "voices.cpp"
            var $tobool177=((($59))|0)!=0; //@line 732 "voices.cpp"
            if ($tobool177) { __label__ = 24;continue $while_cond$34; } //@line 732 "voices.cpp"
  
            var $60=$p; //@line 734 "voices.cpp"
            var $call181=_sscanf($60, ((__str57709)&4294967295), allocate([$arraydecay180,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 734 "voices.cpp"
            var $61=$new_translator; //@line 736 "voices.cpp"
            var $cmp182=((($61))|0)!=0; //@line 736 "voices.cpp"
            if ($cmp182) { __label__ = 48;; } else { __label__ = 49;; } //@line 736 "voices.cpp"
            if (__label__ == 48) {
  
              var $62=$new_translator; //@line 737 "voices.cpp"
              __Z16DeleteTranslatorP10Translator($62); //@line 737 "voices.cpp"
              ; //@line 737 "voices.cpp"
            }
  
            var $call186=__Z16SelectTranslatorPKc($arraydecay185); //@line 739 "voices.cpp"
            $new_translator=$call186; //@line 739 "voices.cpp"
            var $63=$new_translator; //@line 740 "voices.cpp"
            var $langopts187=(($63)&4294967295); //@line 740 "voices.cpp"
            $langopts=$langopts187; //@line 740 "voices.cpp"
            __label__ = 24;continue $while_cond$34; //@line 741 "voices.cpp"
          }
          else if (__label__ == 50) {
  
            var $64=$p; //@line 744 "voices.cpp"
            var $call190=_sscanf($64, ((__str57709)&4294967295), allocate([$arraydecay189,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 744 "voices.cpp"
            __label__ = 24;continue $while_cond$34; //@line 745 "voices.cpp"
          }
          else if (__label__ == 51) {
  
            var $65=$p; //@line 748 "voices.cpp"
            var $call193=_sscanf($65, ((__str57709)&4294967295), allocate([$arraydecay192,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 748 "voices.cpp"
            __label__ = 24;continue $while_cond$34; //@line 749 "voices.cpp"
          }
          else if (__label__ == 52) {
  
            var $66=$p; //@line 752 "voices.cpp"
            __ZL12VoiceFormantPc($66); //@line 752 "voices.cpp"
            __label__ = 24;continue $while_cond$34; //@line 753 "voices.cpp"
          }
          else if (__label__ == 53) {
  
            var $67=$p; //@line 759 "voices.cpp"
            var $call196=_sscanf($67, ((__str58710)&4294967295), allocate([$pitch1,0,0,0,$pitch2,0,0,0], ["i32*",0,0,0,"i32*",0,0,0], ALLOC_STACK)); //@line 759 "voices.cpp"
            $n=$call196; //@line 759 "voices.cpp"
            var $68=HEAP32[(($pitch1)>>2)]; //@line 760 "voices.cpp"
            var $sub197=((($68)-9)&4294967295); //@line 760 "voices.cpp"
            var $shl=($sub197) << 12; //@line 760 "voices.cpp"
            var $69=HEAP32[((_voice)>>2)]; //@line 760 "voices.cpp"
            var $pitch_base=(($69+44)&4294967295); //@line 760 "voices.cpp"
            HEAP32[(($pitch_base)>>2)]=$shl; //@line 760 "voices.cpp"
            var $70=HEAP32[(($pitch2)>>2)]; //@line 761 "voices.cpp"
            var $71=HEAP32[(($pitch1)>>2)]; //@line 761 "voices.cpp"
            var $sub198=((($70)-($71))&4294967295); //@line 761 "voices.cpp"
            var $mul=((($sub198)*108)&4294967295); //@line 761 "voices.cpp"
            var $72=HEAP32[((_voice)>>2)]; //@line 761 "voices.cpp"
            var $pitch_range=(($72+48)&4294967295); //@line 761 "voices.cpp"
            HEAP32[(($pitch_range)>>2)]=$mul; //@line 761 "voices.cpp"
            var $73=HEAP32[(($pitch1)>>2)]; //@line 762 "voices.cpp"
            var $sub199=((($73)-82)&4294967295); //@line 762 "voices.cpp"
            var $conv200=((($sub199))|0); //@line 762 "voices.cpp"
            var $div=($conv200)/82; //@line 762 "voices.cpp"
            $factor=$div; //@line 762 "voices.cpp"
            var $74=$factor; //@line 763 "voices.cpp"
            var $div201=($74)/4; //@line 763 "voices.cpp"
            var $add202=1+($div201); //@line 763 "voices.cpp"
            var $mul203=($add202)*256; //@line 763 "voices.cpp"
            var $conv204=((($mul203))|0); //@line 763 "voices.cpp"
            var $75=HEAP32[((_voice)>>2)]; //@line 763 "voices.cpp"
            var $formant_factor=(($75+96)&4294967295); //@line 763 "voices.cpp"
            HEAP32[(($formant_factor)>>2)]=$conv204; //@line 763 "voices.cpp"
            __label__ = 24;continue $while_cond$34; //@line 765 "voices.cpp"
          }
          else if (__label__ == 54) {
  
            var $76=$p; //@line 768 "voices.cpp"
            var $call207=__ZL12Read8NumbersPcPi($76, $arraydecay206); //@line 768 "voices.cpp"
            $stress_lengths_set=$call207; //@line 768 "voices.cpp"
            __label__ = 24;continue $while_cond$34; //@line 769 "voices.cpp"
          }
          else if (__label__ == 55) {
  
            var $77=$p; //@line 772 "voices.cpp"
            var $call210=__ZL12Read8NumbersPcPi($77, $arraydecay209); //@line 772 "voices.cpp"
            $stress_amps_set=$call210; //@line 772 "voices.cpp"
            __label__ = 24;continue $while_cond$34; //@line 773 "voices.cpp"
          }
          else if (__label__ == 56) {
  
            var $78=$p; //@line 776 "voices.cpp"
            var $call213=__ZL12Read8NumbersPcPi($78, $arraydecay212); //@line 776 "voices.cpp"
            $stress_add_set=$call213; //@line 776 "voices.cpp"
            __label__ = 24;continue $while_cond$34; //@line 777 "voices.cpp"
          }
          else if (__label__ == 57) {
  
            var $79=$p; //@line 780 "voices.cpp"
            var $call215=_sscanf($79, ((__str58710)&4294967295), allocate([_option_tone_flags,0,0,0,_option_tone2,0,0,0], ["i32*",0,0,0,"i32*",0,0,0], ALLOC_STACK)); //@line 780 "voices.cpp"
            var $80=HEAP32[((_option_tone_flags)>>2)]; //@line 781 "voices.cpp"
            var $and216=($80) & 255; //@line 781 "voices.cpp"
            var $cmp217=((($and216))|0)!=0; //@line 781 "voices.cpp"
            if (!($cmp217)) { __label__ = 24;continue $while_cond$34; } //@line 781 "voices.cpp"
  
            var $81=HEAP32[((_option_tone_flags)>>2)]; //@line 782 "voices.cpp"
            var $and219=($81) & 255; //@line 782 "voices.cpp"
            var $82=$langopts; //@line 782 "voices.cpp"
            var $intonation_group=(($82+228)&4294967295); //@line 782 "voices.cpp"
            HEAP32[(($intonation_group)>>2)]=$and219; //@line 782 "voices.cpp"
            __label__ = 24;continue $while_cond$34; //@line 782 "voices.cpp"
          }
          else if (__label__ == 59) {
  
            var $83=$p; //@line 786 "voices.cpp"
            var $call234=_sscanf($83, ((__str59711)&4294967295), allocate([$arraydecay223,0,0,0,$arraydecay225,0,0,0,$arraydecay227,0,0,0,$arraydecay229,0,0,0,$arraydecay231,0,0,0,$arraydecay233,0,0,0], ["i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 786 "voices.cpp"
            $n=$call234; //@line 786 "voices.cpp"
            var $84=$langopts; //@line 787 "voices.cpp"
            var $intonation_group235=(($84+228)&4294967295); //@line 787 "voices.cpp"
            HEAP32[(($intonation_group235)>>2)]=0; //@line 787 "voices.cpp"
            $ix=0; //@line 788 "voices.cpp"
            var $85=$ix; //@line 788 "voices.cpp"
            var $86=$n; //@line 788 "voices.cpp"
            var $cmp2379=((($85))|0) < ((($86))|0); //@line 788 "voices.cpp"
            if (!($cmp2379)) { __label__ = 24;continue $while_cond$34; } //@line 788 "voices.cpp"
            while(1) { 
  
              var $87=$ix; //@line 790 "voices.cpp"
              var $arrayidx239=(($names+$87*40)&4294967295); //@line 790 "voices.cpp"
              var $arraydecay240=(($arrayidx239)&4294967295); //@line 790 "voices.cpp"
              var $call241=_strcmp($arraydecay240, ((__str60712)&4294967295)); //@line 790 "voices.cpp"
              var $cmp242=((($call241))|0)==0; //@line 790 "voices.cpp"
              if ($cmp242) { __label__ = 64;; } else { __label__ = 61;; } //@line 790 "voices.cpp"
              if (__label__ == 61) {
  
                var $88=$ix; //@line 793 "voices.cpp"
                var $arrayidx245=(($names+$88*40)&4294967295); //@line 793 "voices.cpp"
                var $arraydecay246=(($arrayidx245)&4294967295); //@line 793 "voices.cpp"
                var $call247=__ZL10LookupTunePKc($arraydecay246); //@line 793 "voices.cpp"
                HEAP32[(($value)>>2)]=$call247; //@line 793 "voices.cpp"
                var $cmp248=((($call247))|0) < 0; //@line 793 "voices.cpp"
                if ($cmp248) { __label__ = 62;; } else { __label__ = 63;; } //@line 793 "voices.cpp"
                if (__label__ == 62) {
  
                  var $89=HEAP32[((__impure_ptr)>>2)]; //@line 794 "voices.cpp"
                  var $_stderr=(($89+12)&4294967295); //@line 794 "voices.cpp"
                  var $90=HEAP32[(($_stderr)>>2)]; //@line 794 "voices.cpp"
                  var $91=$ix; //@line 794 "voices.cpp"
                  var $arrayidx250=(($names+$91*40)&4294967295); //@line 794 "voices.cpp"
                  var $arraydecay251=(($arrayidx250)&4294967295); //@line 794 "voices.cpp"
                  var $call252=_fprintf($90, ((__str61713)&4294967295), allocate([$arraydecay251,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 794 "voices.cpp"
                  ; //@line 794 "voices.cpp"
                }
                else if (__label__ == 63) {
  
                  var $92=HEAP32[(($value)>>2)]; //@line 796 "voices.cpp"
                  var $conv254=((($92)) & 255); //@line 796 "voices.cpp"
                  var $93=$ix; //@line 796 "voices.cpp"
                  var $94=$langopts; //@line 796 "voices.cpp"
                  var $tunes=(($94+232)&4294967295); //@line 796 "voices.cpp"
                  var $arrayidx255=(($tunes+$93)&4294967295); //@line 796 "voices.cpp"
                  HEAP8[($arrayidx255)]=$conv254; //@line 796 "voices.cpp"
                  ;
                }
              }
  
              var $95=$ix; //@line 788 "voices.cpp"
              var $inc=((($95)+1)&4294967295); //@line 788 "voices.cpp"
              $ix=$inc; //@line 788 "voices.cpp"
              var $96=$ix; //@line 788 "voices.cpp"
              var $97=$n; //@line 788 "voices.cpp"
              var $cmp237=((($96))|0) < ((($97))|0); //@line 788 "voices.cpp"
              if ($cmp237) { __label__ = 60;continue ; } else { __label__ = 24;continue $while_cond$34; } //@line 788 "voices.cpp"
            }
          }
          else if (__label__ == 32) {
  
            var $31=$p; //@line 801 "voices.cpp"
            var $32=HEAP8[($31)]; //@line 801 "voices.cpp"
            var $conv26117=(tempInt=(($32)),(tempInt>=128?tempInt-256:tempInt)); //@line 801 "voices.cpp"
            var $cmp26218=((($conv26117))|0)!=0; //@line 801 "voices.cpp"
            if (!($cmp26218)) { __label__ = 24;continue $while_cond$34; } //@line 801 "voices.cpp"
            $while_cond264_preheader$90: while(1) { 
  
              var $100=$p; //@line 803 "voices.cpp"
              var $101=HEAP8[($100)]; //@line 803 "voices.cpp"
              var $conv26510=(tempInt=(($101)),(tempInt>=128?tempInt-256:tempInt)); //@line 803 "voices.cpp"
              var $call26611=_isspace($conv26510); //@line 803 "voices.cpp"
              var $tobool26712=((($call26611))|0)!=0; //@line 803 "voices.cpp"
              if ($tobool26712) { __label__ = 67;; } else { __label__ = 68;; } //@line 803 "voices.cpp"
              $while_body268$$while_end270$92: do { 
                if (__label__ == 67) {
                  while(1) { 
  
                    var $102=$p; //@line 803 "voices.cpp"
                    var $incdec_ptr269=(($102+1)&4294967295); //@line 803 "voices.cpp"
                    $p=$incdec_ptr269; //@line 803 "voices.cpp"
                    var $103=$p; //@line 803 "voices.cpp"
                    var $104=HEAP8[($103)]; //@line 803 "voices.cpp"
                    var $conv265=(tempInt=(($104)),(tempInt>=128?tempInt-256:tempInt)); //@line 803 "voices.cpp"
                    var $call266=_isspace($conv265); //@line 803 "voices.cpp"
                    var $tobool267=((($call266))|0)!=0; //@line 803 "voices.cpp"
                    if ($tobool267) { __label__ = 67;continue ; } else { __label__ = 68;break $while_body268$$while_end270$92; } //@line 803 "voices.cpp"
                  }
                }
              } while(0);
  
              $n=-1; //@line 804 "voices.cpp"
              var $105=$p; //@line 805 "voices.cpp"
              var $call271=_atoi($105); //@line 805 "voices.cpp"
              $n=$call271; //@line 805 "voices.cpp"
              var $cmp272=((($call271))|0) > 0; //@line 805 "voices.cpp"
              if ($cmp272) { __label__ = 69;; } else { __label__ = 71;; } //@line 805 "voices.cpp"
              $land_lhs_true273$$while_cond279_preheader$96: do { 
                if (__label__ == 69) {
  
                  var $106=$n; //@line 805 "voices.cpp"
                  var $cmp274=((($106))|0) < 32; //@line 805 "voices.cpp"
                  if (!($cmp274)) { __label__ = 71;break $land_lhs_true273$$while_cond279_preheader$96; } //@line 805 "voices.cpp"
  
                  var $107=$p; //@line 807 "voices.cpp"
                  var $incdec_ptr276=(($107+1)&4294967295); //@line 807 "voices.cpp"
                  $p=$incdec_ptr276; //@line 807 "voices.cpp"
                  var $108=$n; //@line 808 "voices.cpp"
                  var $shl277=1 << ($108); //@line 808 "voices.cpp"
                  var $109=$conditional_rules; //@line 808 "voices.cpp"
                  var $or=($109) | ($shl277); //@line 808 "voices.cpp"
                  $conditional_rules=$or; //@line 808 "voices.cpp"
                  ; //@line 809 "voices.cpp"
                }
              } while(0);
  
              var $110=$p; //@line 810 "voices.cpp"
              var $111=HEAP8[($110)]; //@line 810 "voices.cpp"
              var $conv28013=(tempInt=(($111)),(tempInt>=128?tempInt-256:tempInt)); //@line 810 "voices.cpp"
              var $call28114=_isalnum($conv28013); //@line 810 "voices.cpp"
              var $tobool28215=((($call28114))|0)!=0; //@line 810 "voices.cpp"
              if ($tobool28215) { __label__ = 72;; } else { __label__ = 65;; } //@line 810 "voices.cpp"
              $while_body283$$while_cond260_loopexit$100: do { 
                if (__label__ == 72) {
                  while(1) { 
  
                    var $112=$p; //@line 810 "voices.cpp"
                    var $incdec_ptr284=(($112+1)&4294967295); //@line 810 "voices.cpp"
                    $p=$incdec_ptr284; //@line 810 "voices.cpp"
                    var $113=$p; //@line 810 "voices.cpp"
                    var $114=HEAP8[($113)]; //@line 810 "voices.cpp"
                    var $conv280=(tempInt=(($114)),(tempInt>=128?tempInt-256:tempInt)); //@line 810 "voices.cpp"
                    var $call281=_isalnum($conv280); //@line 810 "voices.cpp"
                    var $tobool282=((($call281))|0)!=0; //@line 810 "voices.cpp"
                    if ($tobool282) { __label__ = 72;continue ; } else { __label__ = 65;break $while_body283$$while_cond260_loopexit$100; } //@line 810 "voices.cpp"
                  }
                }
              } while(0);
  
              var $98=$p; //@line 801 "voices.cpp"
              var $99=HEAP8[($98)]; //@line 801 "voices.cpp"
              var $conv261=(tempInt=(($99)),(tempInt>=128?tempInt-256:tempInt)); //@line 801 "voices.cpp"
              var $cmp262=((($conv261))|0)!=0; //@line 801 "voices.cpp"
              if ($cmp262) { __label__ = 66;continue $while_cond264_preheader$90; } else { __label__ = 24;continue $while_cond$34; } //@line 801 "voices.cpp"
            }
          }
          else if (__label__ == 73) {
  
            var $115=$phonemes_set; //@line 815 "voices.cpp"
            var $cmp288=((($115))|0)==0; //@line 815 "voices.cpp"
            if ($cmp288) { __label__ = 74;; } else { __label__ = 75;; } //@line 815 "voices.cpp"
            if (__label__ == 74) {
  
              var $call291=__Z22SelectPhonemeTableNamePKc($arraydecay290); //@line 818 "voices.cpp"
              $phonemes_set=1; //@line 819 "voices.cpp"
              ; //@line 820 "voices.cpp"
            }
  
            var $116=$key; //@line 821 "voices.cpp"
            var $117=$p; //@line 821 "voices.cpp"
            __ZL18PhonemeReplacementiPc($116, $117); //@line 821 "voices.cpp"
            __label__ = 24;continue $while_cond$34; //@line 822 "voices.cpp"
          }
          else if (__label__ == 76) {
  
            var $118=$p; //@line 825 "voices.cpp"
            var $119=$langopts; //@line 825 "voices.cpp"
            var $word_gap=(($119)&4294967295); //@line 825 "voices.cpp"
            var $120=$langopts; //@line 825 "voices.cpp"
            var $vowel_pause=(($120+4)&4294967295); //@line 825 "voices.cpp"
            var $call294=_sscanf($118, ((__str58710)&4294967295), allocate([$word_gap,0,0,0,$vowel_pause,0,0,0], ["i32*",0,0,0,"i32*",0,0,0], ALLOC_STACK)); //@line 825 "voices.cpp"
            __label__ = 24;continue $while_cond$34; //@line 826 "voices.cpp"
          }
          else if (__label__ == 77) {
  
            var $121=$p; //@line 829 "voices.cpp"
            var $122=$langopts; //@line 829 "voices.cpp"
            var $stress_rule=(($122+8)&4294967295); //@line 829 "voices.cpp"
            var $123=$langopts; //@line 829 "voices.cpp"
            var $stress_flags=(($123+12)&4294967295); //@line 829 "voices.cpp"
            var $124=$langopts; //@line 829 "voices.cpp"
            var $unstressed_wd1=(($124+16)&4294967295); //@line 829 "voices.cpp"
            var $125=$langopts; //@line 829 "voices.cpp"
            var $unstressed_wd2=(($125+20)&4294967295); //@line 829 "voices.cpp"
            var $call296=_sscanf($121, ((__str62714)&4294967295), allocate([$stress_rule,0,0,0,$stress_flags,0,0,0,$unstressed_wd1,0,0,0,$unstressed_wd2,0,0,0], ["i32*",0,0,0,"i32*",0,0,0,"i32*",0,0,0,"i32*",0,0,0], ALLOC_STACK)); //@line 829 "voices.cpp"
            __label__ = 24;continue $while_cond$34; //@line 833 "voices.cpp"
          }
          else if (__label__ == 78) {
  
            var $126=$p; //@line 836 "voices.cpp"
            var $call298=_sscanf($126, ((__str63715)&4294967295), allocate([$value,0,0,0], ["i32*",0,0,0], ALLOC_STACK)); //@line 836 "voices.cpp"
            var $cmp299=((($call298))|0)==1; //@line 836 "voices.cpp"
            var $127=HEAP32[(($value)>>2)]; //@line 836 "voices.cpp"
            var $cmp301=((($127))|0) < 20; //@line 836 "voices.cpp"
            var $or_cond1=($cmp299) & ($cmp301); //@line 836 "voices.cpp"
            if (!($or_cond1)) { __label__ = 24;continue $while_cond$34; } //@line 836 "voices.cpp"
  
            var $128=HEAP32[(($value)>>2)]; //@line 837 "voices.cpp"
            var $arrayidx303=((_charsets+$128*4)&4294967295); //@line 837 "voices.cpp"
            var $129=HEAP32[(($arrayidx303)>>2)]; //@line 837 "voices.cpp"
            var $130=$new_translator; //@line 837 "voices.cpp"
            var $charset_a0=(($130+696)&4294967295); //@line 837 "voices.cpp"
            HEAP32[(($charset_a0)>>2)]=$129; //@line 837 "voices.cpp"
            __label__ = 24;continue $while_cond$34; //@line 837 "voices.cpp"
          }
          else if (__label__ == 80) {
  
            var $131=$p; //@line 841 "voices.cpp"
            var $132=$langopts; //@line 841 "voices.cpp"
            var $numbers=(($132+184)&4294967295); //@line 841 "voices.cpp"
            var $133=$langopts; //@line 841 "voices.cpp"
            var $numbers2=(($133+188)&4294967295); //@line 841 "voices.cpp"
            var $call306=_sscanf($131, ((__str58710)&4294967295), allocate([$numbers,0,0,0,$numbers2,0,0,0], ["i32*",0,0,0,"i32*",0,0,0], ALLOC_STACK)); //@line 841 "voices.cpp"
            __label__ = 24;continue $while_cond$34; //@line 842 "voices.cpp"
          }
          else if (__label__ == 81) {
  
            HEAP32[(($value2)>>2)]=0; //@line 845 "voices.cpp"
            var $134=$p; //@line 846 "voices.cpp"
            var $call309=_sscanf($134, ((__str64716)&4294967295), allocate([$arraydecay308,0,0,0,$value,0,0,0,$value2,0,0,0], ["i8*",0,0,0,"i32*",0,0,0,"i32*",0,0,0], ALLOC_STACK)); //@line 846 "voices.cpp"
            var $cmp310=((($call309))|0) >= 2; //@line 846 "voices.cpp"
            if ($cmp310) { __label__ = 82;; } else { __label__ = 84;; } //@line 846 "voices.cpp"
            $land_lhs_true311$$if_else318$114: do { 
              if (__label__ == 82) {
  
                var $call313=__Z10LookupMnemP8MNEM_TABPKc(((__ZL11options_tab)&4294967295), $arraydecay312); //@line 846 "voices.cpp"
                $ix=$call313; //@line 846 "voices.cpp"
                var $cmp314=((($call313))|0) >= 0; //@line 846 "voices.cpp"
                if (!($cmp314)) { __label__ = 84;break $land_lhs_true311$$if_else318$114; } //@line 846 "voices.cpp"
  
                var $135=HEAP32[(($value)>>2)]; //@line 848 "voices.cpp"
                var $136=$ix; //@line 848 "voices.cpp"
                var $137=$langopts; //@line 848 "voices.cpp"
                var $param=(($137+24)&4294967295); //@line 848 "voices.cpp"
                var $arrayidx316=(($param+$136*4)&4294967295); //@line 848 "voices.cpp"
                HEAP32[(($arrayidx316)>>2)]=$135; //@line 848 "voices.cpp"
                var $138=HEAP32[(($value2)>>2)]; //@line 849 "voices.cpp"
                var $139=$ix; //@line 849 "voices.cpp"
                var $140=$langopts; //@line 849 "voices.cpp"
                var $param2=(($140+100)&4294967295); //@line 849 "voices.cpp"
                var $arrayidx317=(($param2+$139*4)&4294967295); //@line 849 "voices.cpp"
                HEAP32[(($arrayidx317)>>2)]=$138; //@line 849 "voices.cpp"
                __label__ = 24;continue $while_cond$34; //@line 850 "voices.cpp"
              }
            } while(0);
  
            var $141=HEAP32[((__impure_ptr)>>2)]; //@line 853 "voices.cpp"
            var $_stderr319=(($141+12)&4294967295); //@line 853 "voices.cpp"
            var $142=HEAP32[(($_stderr319)>>2)]; //@line 853 "voices.cpp"
            var $143=$p; //@line 853 "voices.cpp"
            var $call321=_fprintf($142, ((__str65717)&4294967295), allocate([$arraydecay320,0,0,0,$143,0,0,0], ["i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 853 "voices.cpp"
            __label__ = 24;continue $while_cond$34;
          }
          else if (__label__ == 85) {
  
            HEAP32[(($value)>>2)]=0; //@line 859 "voices.cpp"
            var $144=HEAP32[((_voice)>>2)]; //@line 860 "voices.cpp"
            var $echo_amp=(($144+80)&4294967295); //@line 860 "voices.cpp"
            HEAP32[(($echo_amp)>>2)]=0; //@line 860 "voices.cpp"
            var $145=$p; //@line 861 "voices.cpp"
            var $146=HEAP32[((_voice)>>2)]; //@line 861 "voices.cpp"
            var $echo_delay=(($146+76)&4294967295); //@line 861 "voices.cpp"
            var $147=HEAP32[((_voice)>>2)]; //@line 861 "voices.cpp"
            var $echo_amp324=(($147+80)&4294967295); //@line 861 "voices.cpp"
            var $call325=_sscanf($145, ((__str58710)&4294967295), allocate([$echo_delay,0,0,0,$echo_amp324,0,0,0], ["i32*",0,0,0,"i32*",0,0,0], ALLOC_STACK)); //@line 861 "voices.cpp"
            __label__ = 24;continue $while_cond$34; //@line 862 "voices.cpp"
          }
          else if (__label__ == 86) {
  
            var $148=$p; //@line 865 "voices.cpp"
            var $call327=_sscanf($148, ((__str63715)&4294967295), allocate([$value,0,0,0], ["i32*",0,0,0], ALLOC_STACK)); //@line 865 "voices.cpp"
            var $cmp328=((($call327))|0)==1; //@line 865 "voices.cpp"
            if (!($cmp328)) { __label__ = 24;continue $while_cond$34; } //@line 865 "voices.cpp"
  
            var $149=HEAP32[(($value)>>2)]; //@line 866 "voices.cpp"
            var $mul330=((($149)*32)&4294967295); //@line 866 "voices.cpp"
            var $150=HEAP32[((_voice)>>2)]; //@line 866 "voices.cpp"
            var $flutter=(($150+68)&4294967295); //@line 866 "voices.cpp"
            HEAP32[(($flutter)>>2)]=$mul330; //@line 866 "voices.cpp"
            __label__ = 24;continue $while_cond$34; //@line 866 "voices.cpp"
          }
          else if (__label__ == 88) {
  
            var $151=$p; //@line 870 "voices.cpp"
            var $call333=_sscanf($151, ((__str63715)&4294967295), allocate([$value,0,0,0], ["i32*",0,0,0], ALLOC_STACK)); //@line 870 "voices.cpp"
            var $cmp334=((($call333))|0)==1; //@line 870 "voices.cpp"
            if (!($cmp334)) { __label__ = 24;continue $while_cond$34; } //@line 870 "voices.cpp"
  
            var $152=HEAP32[(($value)>>2)]; //@line 871 "voices.cpp"
            var $153=HEAP32[((_voice)>>2)]; //@line 871 "voices.cpp"
            var $roughness=(($153+72)&4294967295); //@line 871 "voices.cpp"
            HEAP32[(($roughness)>>2)]=$152; //@line 871 "voices.cpp"
            __label__ = 24;continue $while_cond$34; //@line 871 "voices.cpp"
          }
          else if (__label__ == 90) {
  
            var $154=$p; //@line 875 "voices.cpp"
            var $call338=_sscanf($154, ((__str63715)&4294967295), allocate([$value,0,0,0], ["i32*",0,0,0], ALLOC_STACK)); //@line 875 "voices.cpp"
            var $cmp339=((($call338))|0)==1; //@line 875 "voices.cpp"
            if (!($cmp339)) { __label__ = 24;continue $while_cond$34; } //@line 875 "voices.cpp"
  
            var $155=HEAP32[(($value)>>2)]; //@line 877 "voices.cpp"
            var $cmp341=((($155))|0) > 4; //@line 877 "voices.cpp"
            if ($cmp341) { __label__ = 92;; } else { __label__ = 93;; } //@line 877 "voices.cpp"
            if (__label__ == 92) {
  
              var $156=HEAP32[((_voice)>>2)]; //@line 879 "voices.cpp"
              var $peak_shape=(($156+88)&4294967295); //@line 879 "voices.cpp"
              HEAP32[(($peak_shape)>>2)]=1; //@line 879 "voices.cpp"
              HEAP32[(($value)>>2)]=4; //@line 880 "voices.cpp"
              ; //@line 881 "voices.cpp"
            }
  
            var $157=HEAP32[(($value)>>2)]; //@line 882 "voices.cpp"
            var $add344=((($157)+1)&4294967295); //@line 882 "voices.cpp"
            var $158=HEAP32[((_voice)>>2)]; //@line 882 "voices.cpp"
            var $n_harmonic_peaks=(($158+84)&4294967295); //@line 882 "voices.cpp"
            HEAP32[(($n_harmonic_peaks)>>2)]=$add344; //@line 882 "voices.cpp"
            __label__ = 24;continue $while_cond$34; //@line 883 "voices.cpp"
          }
          else if (__label__ == 94) {
  
            var $159=$p; //@line 889 "voices.cpp"
            __Z14ReadTonePointsPcPi($159, $arraydecay347); //@line 889 "voices.cpp"
            var $160=HEAP32[((_voice)>>2)]; //@line 890 "voices.cpp"
            __ZL13SetToneAdjustP7voice_tPi($160, $arraydecay348); //@line 890 "voices.cpp"
            __label__ = 24;continue $while_cond$34; //@line 892 "voices.cpp"
          }
          else if (__label__ == 95) {
  
            var $161=$p; //@line 895 "voices.cpp"
            var $call350=_sscanf($161, ((__str63715)&4294967295), allocate([$value,0,0,0], ["i32*",0,0,0], ALLOC_STACK)); //@line 895 "voices.cpp"
            var $cmp351=((($call350))|0)==1; //@line 895 "voices.cpp"
            if (!($cmp351)) { __label__ = 24;continue $while_cond$34; } //@line 895 "voices.cpp"
  
            var $162=HEAP32[(($value)>>2)]; //@line 896 "voices.cpp"
            var $mul353=((($162)*64)&4294967295); //@line 896 "voices.cpp"
            var $div354=((((($mul353))|0)/100)|0); //@line 896 "voices.cpp"
            var $163=HEAP32[((_voice)>>2)]; //@line 896 "voices.cpp"
            var $voicing=(($163+92)&4294967295); //@line 896 "voices.cpp"
            HEAP32[(($voicing)>>2)]=$div354; //@line 896 "voices.cpp"
            __label__ = 24;continue $while_cond$34; //@line 896 "voices.cpp"
          }
          else if (__label__ == 97) {
  
            var $164=$p; //@line 900 "voices.cpp"
            var $165=HEAP32[((_voice)>>2)]; //@line 900 "voices.cpp"
            var $breath=(($165+272)&4294967295); //@line 900 "voices.cpp"
            var $arrayidx357=(($breath+4)&4294967295); //@line 900 "voices.cpp"
            var $call358=__ZL12Read8NumbersPcPi($164, $arrayidx357); //@line 900 "voices.cpp"
            var $166=HEAP32[((_voice)>>2)]; //@line 900 "voices.cpp"
            var $breath359=(($166+272)&4294967295); //@line 900 "voices.cpp"
            var $arrayidx360=(($breath359)&4294967295); //@line 900 "voices.cpp"
            HEAP32[(($arrayidx360)>>2)]=$call358; //@line 900 "voices.cpp"
            $ix=1; //@line 901 "voices.cpp"
            ; //@line 901 "voices.cpp"
            while(1) { 
  
              var $167=$ix; //@line 903 "voices.cpp"
              var $rem=((($167))|0)%2; //@line 903 "voices.cpp"
              var $tobool364=((($rem))|0)!=0; //@line 903 "voices.cpp"
              if ($tobool364) { __label__ = 99;; } else { __label__ = 100;; } //@line 903 "voices.cpp"
              if (__label__ == 99) {
  
                var $168=$ix; //@line 904 "voices.cpp"
                var $169=HEAP32[((_voice)>>2)]; //@line 904 "voices.cpp"
                var $breath366=(($169+272)&4294967295); //@line 904 "voices.cpp"
                var $arrayidx367=(($breath366+$168*4)&4294967295); //@line 904 "voices.cpp"
                var $170=HEAP32[(($arrayidx367)>>2)]; //@line 904 "voices.cpp"
                var $sub368=(((-($170)))&4294967295); //@line 904 "voices.cpp"
                var $171=$ix; //@line 904 "voices.cpp"
                var $172=HEAP32[((_voice)>>2)]; //@line 904 "voices.cpp"
                var $breath369=(($172+272)&4294967295); //@line 904 "voices.cpp"
                var $arrayidx370=(($breath369+$171*4)&4294967295); //@line 904 "voices.cpp"
                HEAP32[(($arrayidx370)>>2)]=$sub368; //@line 904 "voices.cpp"
                ; //@line 904 "voices.cpp"
              }
  
              var $173=$ix; //@line 901 "voices.cpp"
              var $inc373=((($173)+1)&4294967295); //@line 901 "voices.cpp"
              $ix=$inc373; //@line 901 "voices.cpp"
              var $cmp362=((($inc373))|0) < 8; //@line 901 "voices.cpp"
              if ($cmp362) { __label__ = 98;continue ; } else { __label__ = 24;continue $while_cond$34; } //@line 901 "voices.cpp"
            }
          }
          else if (__label__ == 101) {
  
            var $174=$p; //@line 909 "voices.cpp"
            var $175=HEAP32[((_voice)>>2)]; //@line 909 "voices.cpp"
            var $breathw=(($175+308)&4294967295); //@line 909 "voices.cpp"
            var $arrayidx376=(($breathw+4)&4294967295); //@line 909 "voices.cpp"
            var $call377=__ZL12Read8NumbersPcPi($174, $arrayidx376); //@line 909 "voices.cpp"
            var $176=HEAP32[((_voice)>>2)]; //@line 909 "voices.cpp"
            var $breathw378=(($176+308)&4294967295); //@line 909 "voices.cpp"
            var $arrayidx379=(($breathw378)&4294967295); //@line 909 "voices.cpp"
            HEAP32[(($arrayidx379)>>2)]=$call377; //@line 909 "voices.cpp"
            __label__ = 24;continue $while_cond$34; //@line 910 "voices.cpp"
          }
          else if (__label__ == 102) {
  
            var $177=$p; //@line 913 "voices.cpp"
            var $178=HEAP32[((_voice)>>2)]; //@line 913 "voices.cpp"
            var $consonant_amp=(($178+100)&4294967295); //@line 913 "voices.cpp"
            var $179=HEAP32[((_voice)>>2)]; //@line 913 "voices.cpp"
            var $consonant_ampv=(($179+104)&4294967295); //@line 913 "voices.cpp"
            var $call381=_sscanf($177, ((__str58710)&4294967295), allocate([$consonant_amp,0,0,0,$consonant_ampv,0,0,0], ["i32*",0,0,0,"i32*",0,0,0], ALLOC_STACK)); //@line 913 "voices.cpp"
            HEAP32[(($value)>>2)]=$call381; //@line 913 "voices.cpp"
            __label__ = 24;continue $while_cond$34; //@line 914 "voices.cpp"
          }
          else if (__label__ == 103) {
  
            var $180=$p; //@line 917 "voices.cpp"
            var $181=HEAP32[((_voice)>>2)]; //@line 917 "voices.cpp"
            var $speed_percent=(($181+64)&4294967295); //@line 917 "voices.cpp"
            var $call383=_sscanf($180, ((__str63715)&4294967295), allocate([$speed_percent,0,0,0], ["i32*",0,0,0], ALLOC_STACK)); //@line 917 "voices.cpp"
            __label__ = 24;continue $while_cond$34; //@line 918 "voices.cpp"
          }
          else if (__label__ == 104) {
  
            HEAP32[(($srate)>>2)]=16000; //@line 922 "voices.cpp"
            HEAP8[($arrayidx385)]=0; //@line 926 "voices.cpp"
            var $182=$p; //@line 927 "voices.cpp"
            var $call388=_sscanf($182, ((__str66718)&4294967295), allocate([$arraydecay386,0,0,0,$arraydecay387,0,0,0,$srate,0,0,0], ["i8*",0,0,0,"i8*",0,0,0,"i32*",0,0,0], ALLOC_STACK)); //@line 927 "voices.cpp"
            var $183=HEAP32[(($srate)>>2)]; //@line 928 "voices.cpp"
            var $call391=__Z15LoadMbrolaTablePKcS0_i($arraydecay389, $arraydecay390, $183); //@line 928 "voices.cpp"
            var $cmp392=((($call391))|0)!=0; //@line 928 "voices.cpp"
            if ($cmp392) { __label__ = 105;; } else { __label__ = 106;; } //@line 928 "voices.cpp"
            if (__label__ == 105) {
  
              var $184=HEAP32[((__impure_ptr)>>2)]; //@line 930 "voices.cpp"
              var $_stderr394=(($184+12)&4294967295); //@line 930 "voices.cpp"
              var $185=HEAP32[(($_stderr394)>>2)]; //@line 930 "voices.cpp"
              var $186=_fwrite(((__str67719)&4294967295), 23, 1, $185); //@line 930 "voices.cpp"
              ; //@line 931 "voices.cpp"
            }
  
            var $187=HEAP32[(($srate)>>2)]; //@line 932 "voices.cpp"
            var $188=HEAP32[((_voice)>>2)]; //@line 932 "voices.cpp"
            var $samplerate=(($188+108)&4294967295); //@line 932 "voices.cpp"
            HEAP32[(($samplerate)>>2)]=$187; //@line 932 "voices.cpp"
            __label__ = 24;continue $while_cond$34; //@line 934 "voices.cpp"
          }
          else if (__label__ == 107) {
  
            var $189=HEAP32[((_voice)>>2)]; //@line 937 "voices.cpp"
            var $klattv=(($189+112)&4294967295); //@line 937 "voices.cpp"
            var $arrayidx398=(($klattv)&4294967295); //@line 937 "voices.cpp"
            HEAP32[(($arrayidx398)>>2)]=1; //@line 937 "voices.cpp"
            var $190=$p; //@line 938 "voices.cpp"
            var $191=HEAP32[((_voice)>>2)]; //@line 938 "voices.cpp"
            var $klattv399=(($191+112)&4294967295); //@line 938 "voices.cpp"
            var $arraydecay400=(($klattv399)&4294967295); //@line 938 "voices.cpp"
            var $call401=__ZL12Read8NumbersPcPi($190, $arraydecay400); //@line 938 "voices.cpp"
            var $192=HEAP32[((_voice)>>2)]; //@line 939 "voices.cpp"
            var $klattv402=(($192+112)&4294967295); //@line 939 "voices.cpp"
            var $arrayidx403=(($klattv402+20)&4294967295); //@line 939 "voices.cpp"
            var $193=HEAP32[(($arrayidx403)>>2)]; //@line 939 "voices.cpp"
            var $sub404=((($193)-40)&4294967295); //@line 939 "voices.cpp"
            HEAP32[(($arrayidx403)>>2)]=$sub404; //@line 939 "voices.cpp"
            __label__ = 24;continue $while_cond$34; //@line 940 "voices.cpp"
          }
          else if (__label__ == 108) {
  
            var $194=$p; //@line 943 "voices.cpp"
            var $call406=__ZL12Read8NumbersPcPi($194, ((_speed+32)&4294967295)); //@line 943 "voices.cpp"
            __Z8SetSpeedi(3); //@line 944 "voices.cpp"
            __label__ = 24;continue $while_cond$34; //@line 945 "voices.cpp"
          }
        }
        $if_end423$$while_end419$146: do { 
          if (__label__ == 112) {
  
            var $_pr=$f_voice; //@line 959 "voices.cpp"
            var $cmp420=((($_pr))|0)!=0; //@line 959 "voices.cpp"
            if (!($cmp420)) { __label__ = 114;break $if_end423$$while_end419$146; } //@line 959 "voices.cpp"
  
            var $201=$f_voice; //@line 960 "voices.cpp"
            var $call422=_fclose($201); //@line 960 "voices.cpp"
            ; //@line 960 "voices.cpp"
          }
        } while(0);
  
        var $202=$new_translator; //@line 962 "voices.cpp"
        var $cmp424=((($202))|0)==0; //@line 962 "voices.cpp"
        if ($cmp424) { __label__ = 115;; } else { __label__ = 117;; } //@line 962 "voices.cpp"
        $land_lhs_true425$$if_end430$150: do { 
          if (__label__ == 115) {
  
            var $203=$tone_only; //@line 962 "voices.cpp"
            var $tobool426=((($203))|0)!=0; //@line 962 "voices.cpp"
            if ($tobool426) { __label__ = 117;break $land_lhs_true425$$if_end430$150; } //@line 962 "voices.cpp"
  
            var $arraydecay428=(($translator_name)&4294967295); //@line 965 "voices.cpp"
            var $call429=__Z16SelectTranslatorPKc($arraydecay428); //@line 965 "voices.cpp"
            $new_translator=$call429; //@line 965 "voices.cpp"
            ; //@line 966 "voices.cpp"
          }
        } while(0);
  
        __Z8SetSpeedi(3); //@line 968 "voices.cpp"
        $ix=0; //@line 970 "voices.cpp"
        ; //@line 970 "voices.cpp"
        $for_body433$154: while(1) { 
  
          var $204=$ix; //@line 972 "voices.cpp"
          var $205=HEAP32[((_voice)>>2)]; //@line 972 "voices.cpp"
          var $freq=(($205+144)&4294967295); //@line 972 "voices.cpp"
          var $arrayidx434=(($freq+$204*2)&4294967295); //@line 972 "voices.cpp"
          var $206=HEAP16[(($arrayidx434)>>1)]; //@line 972 "voices.cpp"
          var $207=$ix; //@line 972 "voices.cpp"
          var $208=HEAP32[((_voice)>>2)]; //@line 972 "voices.cpp"
          var $freq2=(($208+216)&4294967295); //@line 972 "voices.cpp"
          var $arrayidx435=(($freq2+$207*2)&4294967295); //@line 972 "voices.cpp"
          HEAP16[(($arrayidx435)>>1)]=$206; //@line 972 "voices.cpp"
          var $209=$ix; //@line 973 "voices.cpp"
          var $210=HEAP32[((_voice)>>2)]; //@line 973 "voices.cpp"
          var $height=(($210+162)&4294967295); //@line 973 "voices.cpp"
          var $arrayidx436=(($height+$209*2)&4294967295); //@line 973 "voices.cpp"
          var $211=HEAP16[(($arrayidx436)>>1)]; //@line 973 "voices.cpp"
          var $212=$ix; //@line 973 "voices.cpp"
          var $213=HEAP32[((_voice)>>2)]; //@line 973 "voices.cpp"
          var $height2=(($213+234)&4294967295); //@line 973 "voices.cpp"
          var $arrayidx437=(($height2+$212*2)&4294967295); //@line 973 "voices.cpp"
          HEAP16[(($arrayidx437)>>1)]=$211; //@line 973 "voices.cpp"
          var $214=$ix; //@line 974 "voices.cpp"
          var $215=HEAP32[((_voice)>>2)]; //@line 974 "voices.cpp"
          var $width=(($215+180)&4294967295); //@line 974 "voices.cpp"
          var $arrayidx438=(($width+$214*2)&4294967295); //@line 974 "voices.cpp"
          var $216=HEAP16[(($arrayidx438)>>1)]; //@line 974 "voices.cpp"
          var $217=$ix; //@line 974 "voices.cpp"
          var $218=HEAP32[((_voice)>>2)]; //@line 974 "voices.cpp"
          var $width2=(($218+252)&4294967295); //@line 974 "voices.cpp"
          var $arrayidx439=(($width2+$217*2)&4294967295); //@line 974 "voices.cpp"
          HEAP16[(($arrayidx439)>>1)]=$216; //@line 974 "voices.cpp"
          var $219=$ix; //@line 970 "voices.cpp"
          var $inc441=((($219)+1)&4294967295); //@line 970 "voices.cpp"
          $ix=$inc441; //@line 970 "voices.cpp"
          var $cmp432=((($inc441))|0) < 9; //@line 970 "voices.cpp"
          if ($cmp432) { __label__ = 118;continue $for_body433$154; } else { __label__ = 119;break $for_body433$154; } //@line 970 "voices.cpp"
        }
  
        var $220=$tone_only; //@line 977 "voices.cpp"
        var $tobool443=((($220))|0)!=0; //@line 977 "voices.cpp"
        if ($tobool443) { __label__ = 120;; } else { __label__ = 121;; } //@line 977 "voices.cpp"
        if (__label__ == 120) {
  
          var $221=HEAP32[((_translator)>>2)]; //@line 979 "voices.cpp"
          $new_translator=$221; //@line 979 "voices.cpp"
          ; //@line 980 "voices.cpp"
        }
        else if (__label__ == 121) {
  
          var $arraydecay446=(($phonemes_name)&4294967295); //@line 983 "voices.cpp"
          var $call447=__Z22SelectPhonemeTableNamePKc($arraydecay446); //@line 983 "voices.cpp"
          $ix=$call447; //@line 983 "voices.cpp"
          var $cmp448=((($call447))|0) < 0; //@line 983 "voices.cpp"
          if ($cmp448) { __label__ = 122;; } else { __label__ = 123;; } //@line 983 "voices.cpp"
          if (__label__ == 122) {
  
            var $222=HEAP32[((__impure_ptr)>>2)]; //@line 985 "voices.cpp"
            var $_stderr450=(($222+12)&4294967295); //@line 985 "voices.cpp"
            var $223=HEAP32[(($_stderr450)>>2)]; //@line 985 "voices.cpp"
            var $arraydecay451=(($phonemes_name)&4294967295); //@line 985 "voices.cpp"
            var $call452=_fprintf($223, ((__str69721)&4294967295), allocate([$arraydecay451,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 985 "voices.cpp"
            ; //@line 986 "voices.cpp"
          }
  
          var $224=$ix; //@line 987 "voices.cpp"
          var $225=HEAP32[((_voice)>>2)]; //@line 987 "voices.cpp"
          var $phoneme_tab_ix=(($225+40)&4294967295); //@line 987 "voices.cpp"
          HEAP32[(($phoneme_tab_ix)>>2)]=$224; //@line 987 "voices.cpp"
          var $226=$ix; //@line 988 "voices.cpp"
          var $227=$new_translator; //@line 988 "voices.cpp"
          var $phoneme_tab_ix454=(($227+656)&4294967295); //@line 988 "voices.cpp"
          HEAP32[(($phoneme_tab_ix454)>>2)]=$226; //@line 988 "voices.cpp"
          var $228=$new_translator; //@line 989 "voices.cpp"
          var $arraydecay455=(($new_dictionary)&4294967295); //@line 989 "voices.cpp"
          var $229=$control_addr; //@line 989 "voices.cpp"
          var $and456=($229) & 4; //@line 989 "voices.cpp"
          var $call457=__Z14LoadDictionaryP10TranslatorPKci($228, $arraydecay455, $and456); //@line 989 "voices.cpp"
          $error=$call457; //@line 989 "voices.cpp"
          var $230=HEAP8[(((_dictionary_name)&4294967295))]; //@line 990 "voices.cpp"
          var $conv458=(tempInt=(($230)),(tempInt>=128?tempInt-256:tempInt)); //@line 990 "voices.cpp"
          var $cmp459=((($conv458))|0)==0; //@line 990 "voices.cpp"
          if ($cmp459) { __label__ = 124;; } else { __label__ = 125;; } //@line 990 "voices.cpp"
          if (__label__ == 124) {
  
            $retval=0; //@line 991 "voices.cpp"
            __label__ = 137;break $return$$if_end51$12; //@line 991 "voices.cpp"
          }
          else if (__label__ == 125) {
  
            var $231=$conditional_rules; //@line 993 "voices.cpp"
            var $232=$new_translator; //@line 993 "voices.cpp"
            var $dict_condition=(($232+692)&4294967295); //@line 993 "voices.cpp"
            HEAP32[(($dict_condition)>>2)]=$231; //@line 993 "voices.cpp"
            var $233=$langix; //@line 995 "voices.cpp"
            var $arrayidx462=((__ZZ9LoadVoicePKciE15voice_languages+$233)&4294967295); //@line 995 "voices.cpp"
            HEAP8[($arrayidx462)]=0; //@line 995 "voices.cpp"
            ;
          }
        }
  
        var $234=$new_translator; //@line 998 "voices.cpp"
        var $langopts464=(($234)&4294967295); //@line 998 "voices.cpp"
        $langopts=$langopts464; //@line 998 "voices.cpp"
        var $235=$langopts; //@line 1001 "voices.cpp"
        var $param465=(($235+24)&4294967295); //@line 1001 "voices.cpp"
        var $arrayidx466=(($param465+24)&4294967295); //@line 1001 "voices.cpp"
        var $236=HEAP32[(($arrayidx466)>>2)]; //@line 1001 "voices.cpp"
        HEAP32[(($value)>>2)]=$236; //@line 1001 "voices.cpp"
        var $cmp467=((($236))|0)!=0; //@line 1001 "voices.cpp"
        if ($cmp467) { __label__ = 127;; } else { __label__ = 128;; } //@line 1001 "voices.cpp"
        if (__label__ == 127) {
  
          var $237=$new_translator; //@line 1003 "voices.cpp"
          var $238=HEAP32[(($value)>>2)]; //@line 1003 "voices.cpp"
          __Z13SetLengthModsP10Translatori($237, $238); //@line 1003 "voices.cpp"
          ; //@line 1004 "voices.cpp"
        }
  
        var $239=HEAP32[((_voice)>>2)]; //@line 1006 "voices.cpp"
        var $width470=(($239+180)&4294967295); //@line 1006 "voices.cpp"
        var $arrayidx471=(($width470)&4294967295); //@line 1006 "voices.cpp"
        var $240=HEAP16[(($arrayidx471)>>1)]; //@line 1006 "voices.cpp"
        var $conv472=(tempInt=(($240)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1006 "voices.cpp"
        var $mul473=((($conv472)*105)&4294967295); //@line 1006 "voices.cpp"
        var $div474=((((($mul473))|0)/100)|0); //@line 1006 "voices.cpp"
        var $conv475=((($div474)) & 65535); //@line 1006 "voices.cpp"
        var $241=HEAP32[((_voice)>>2)]; //@line 1006 "voices.cpp"
        var $width476=(($241+180)&4294967295); //@line 1006 "voices.cpp"
        var $arrayidx477=(($width476)&4294967295); //@line 1006 "voices.cpp"
        HEAP16[(($arrayidx477)>>1)]=$conv475; //@line 1006 "voices.cpp"
        var $242=$tone_only; //@line 1008 "voices.cpp"
        var $tobool478=((($242))|0)!=0; //@line 1008 "voices.cpp"
        if ($tobool478) { __label__ = 130;; } else { __label__ = 129;; } //@line 1008 "voices.cpp"
        if (__label__ == 129) {
  
          var $243=$new_translator; //@line 1010 "voices.cpp"
          HEAP32[((_translator)>>2)]=$243; //@line 1010 "voices.cpp"
          ; //@line 1011 "voices.cpp"
        }
  
        $ix=0; //@line 1014 "voices.cpp"
        var $244=$ix; //@line 1014 "voices.cpp"
        var $245=$stress_lengths_set; //@line 1014 "voices.cpp"
        var $cmp4825=((($244))|0) < ((($245))|0); //@line 1014 "voices.cpp"
        if ($cmp4825) { __label__ = 131;; } else { __label__ = 132;; } //@line 1014 "voices.cpp"
        $for_body483$$for_end490$173: do { 
          if (__label__ == 131) {
            while(1) { 
  
              var $246=$ix; //@line 1016 "voices.cpp"
              var $arrayidx484=(($stress_lengths+$246*4)&4294967295); //@line 1016 "voices.cpp"
              var $247=HEAP32[(($arrayidx484)>>2)]; //@line 1016 "voices.cpp"
              var $conv485=((($247)) & 65535); //@line 1016 "voices.cpp"
              var $248=$ix; //@line 1016 "voices.cpp"
              var $249=HEAP32[((_translator)>>2)]; //@line 1016 "voices.cpp"
              var $stress_lengths486=(($249+676)&4294967295); //@line 1016 "voices.cpp"
              var $arrayidx487=(($stress_lengths486+$248*2)&4294967295); //@line 1016 "voices.cpp"
              HEAP16[(($arrayidx487)>>1)]=$conv485; //@line 1016 "voices.cpp"
              var $250=$ix; //@line 1014 "voices.cpp"
              var $inc489=((($250)+1)&4294967295); //@line 1014 "voices.cpp"
              $ix=$inc489; //@line 1014 "voices.cpp"
              var $251=$ix; //@line 1014 "voices.cpp"
              var $252=$stress_lengths_set; //@line 1014 "voices.cpp"
              var $cmp482=((($251))|0) < ((($252))|0); //@line 1014 "voices.cpp"
              if ($cmp482) { __label__ = 131;continue ; } else { __label__ = 132;break $for_body483$$for_end490$173; } //@line 1014 "voices.cpp"
            }
          }
        } while(0);
  
        $ix=0; //@line 1018 "voices.cpp"
        var $253=$ix; //@line 1018 "voices.cpp"
        var $254=$stress_add_set; //@line 1018 "voices.cpp"
        var $cmp4924=((($253))|0) < ((($254))|0); //@line 1018 "voices.cpp"
        if ($cmp4924) { __label__ = 133;; } else { __label__ = 134;; } //@line 1018 "voices.cpp"
        $for_body493$$for_end502$177: do { 
          if (__label__ == 133) {
            while(1) { 
  
              var $255=$ix; //@line 1020 "voices.cpp"
              var $arrayidx494=(($stress_add+$255*4)&4294967295); //@line 1020 "voices.cpp"
              var $256=HEAP32[(($arrayidx494)>>2)]; //@line 1020 "voices.cpp"
              var $257=$ix; //@line 1020 "voices.cpp"
              var $258=HEAP32[((_translator)>>2)]; //@line 1020 "voices.cpp"
              var $stress_lengths495=(($258+676)&4294967295); //@line 1020 "voices.cpp"
              var $arrayidx496=(($stress_lengths495+$257*2)&4294967295); //@line 1020 "voices.cpp"
              var $259=HEAP16[(($arrayidx496)>>1)]; //@line 1020 "voices.cpp"
              var $conv497=(tempInt=(($259)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1020 "voices.cpp"
              var $add498=((($conv497)+($256))&4294967295); //@line 1020 "voices.cpp"
              var $conv499=((($add498)) & 65535); //@line 1020 "voices.cpp"
              HEAP16[(($arrayidx496)>>1)]=$conv499; //@line 1020 "voices.cpp"
              var $260=$ix; //@line 1018 "voices.cpp"
              var $inc501=((($260)+1)&4294967295); //@line 1018 "voices.cpp"
              $ix=$inc501; //@line 1018 "voices.cpp"
              var $261=$ix; //@line 1018 "voices.cpp"
              var $262=$stress_add_set; //@line 1018 "voices.cpp"
              var $cmp492=((($261))|0) < ((($262))|0); //@line 1018 "voices.cpp"
              if ($cmp492) { __label__ = 133;continue ; } else { __label__ = 134;break $for_body493$$for_end502$177; } //@line 1018 "voices.cpp"
            }
          }
        } while(0);
  
        $ix=0; //@line 1022 "voices.cpp"
        var $263=$ix; //@line 1022 "voices.cpp"
        var $264=$stress_amps_set; //@line 1022 "voices.cpp"
        var $cmp5043=((($263))|0) < ((($264))|0); //@line 1022 "voices.cpp"
        if ($cmp5043) { __label__ = 135;; } else { __label__ = 136;; } //@line 1022 "voices.cpp"
        $for_body505$$for_end516$181: do { 
          if (__label__ == 135) {
            while(1) { 
  
              var $265=$ix; //@line 1024 "voices.cpp"
              var $arrayidx506=(($stress_amps+$265*4)&4294967295); //@line 1024 "voices.cpp"
              var $266=HEAP32[(($arrayidx506)>>2)]; //@line 1024 "voices.cpp"
              var $conv507=((($266)) & 255); //@line 1024 "voices.cpp"
              var $267=$ix; //@line 1024 "voices.cpp"
              var $268=HEAP32[((_translator)>>2)]; //@line 1024 "voices.cpp"
              var $stress_amps508=(($268+660)&4294967295); //@line 1024 "voices.cpp"
              var $arrayidx509=(($stress_amps508+$267)&4294967295); //@line 1024 "voices.cpp"
              HEAP8[($arrayidx509)]=$conv507; //@line 1024 "voices.cpp"
              var $269=$ix; //@line 1025 "voices.cpp"
              var $arrayidx510=(($stress_amps+$269*4)&4294967295); //@line 1025 "voices.cpp"
              var $270=HEAP32[(($arrayidx510)>>2)]; //@line 1025 "voices.cpp"
              var $sub511=((($270)-1)&4294967295); //@line 1025 "voices.cpp"
              var $conv512=((($sub511)) & 255); //@line 1025 "voices.cpp"
              var $271=$ix; //@line 1025 "voices.cpp"
              var $272=HEAP32[((_translator)>>2)]; //@line 1025 "voices.cpp"
              var $stress_amps_r=(($272+668)&4294967295); //@line 1025 "voices.cpp"
              var $arrayidx513=(($stress_amps_r+$271)&4294967295); //@line 1025 "voices.cpp"
              HEAP8[($arrayidx513)]=$conv512; //@line 1025 "voices.cpp"
              var $273=$ix; //@line 1022 "voices.cpp"
              var $inc515=((($273)+1)&4294967295); //@line 1022 "voices.cpp"
              $ix=$inc515; //@line 1022 "voices.cpp"
              var $274=$ix; //@line 1022 "voices.cpp"
              var $275=$stress_amps_set; //@line 1022 "voices.cpp"
              var $cmp504=((($274))|0) < ((($275))|0); //@line 1022 "voices.cpp"
              if ($cmp504) { __label__ = 135;continue ; } else { __label__ = 136;break $for_body505$$for_end516$181; } //@line 1022 "voices.cpp"
            }
          }
        } while(0);
  
        var $276=HEAP32[((_voice)>>2)]; //@line 1028 "voices.cpp"
        $retval=$276; //@line 1028 "voices.cpp"
        ; //@line 1028 "voices.cpp"
      }
    } while(0);
  
    var $277=$retval; //@line 1029 "voices.cpp"
    STACKTOP = __stackBase__;
    return $277; //@line 1029 "voices.cpp"
    return null;
  }
  

  function __ZL11fgets_stripPciP7__sFILE($buf, $size, $f_in) {
    ;
    var __label__;
  
    var $retval;
    var $buf_addr;
    var $size_addr;
    var $f_in_addr;
    var $len;
    var $p;
    $buf_addr=$buf;
    $size_addr=$size;
    $f_in_addr=$f_in;
    var $0=$buf_addr; //@line 184 "voices.cpp"
    var $1=$size_addr; //@line 184 "voices.cpp"
    var $2=$f_in_addr; //@line 184 "voices.cpp"
    var $call=_fgets($0, $1, $2); //@line 184 "voices.cpp"
    var $cmp=((($call))|0)==0; //@line 184 "voices.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 184 "voices.cpp"
    if (__label__ == 1) {
  
      $retval=0; //@line 185 "voices.cpp"
      ; //@line 185 "voices.cpp"
    }
    else if (__label__ == 2) {
  
      var $3=$buf_addr; //@line 187 "voices.cpp"
      var $call1=_strlen($3); //@line 187 "voices.cpp"
      $len=$call1; //@line 187 "voices.cpp"
      ; //@line 188 "voices.cpp"
      while(1) { 
  
        var $4=$len; //@line 188 "voices.cpp"
        var $dec=((($4)-1)&4294967295); //@line 188 "voices.cpp"
        $len=$dec; //@line 188 "voices.cpp"
        var $cmp2=((($dec))|0) > 0; //@line 188 "voices.cpp"
        if (!($cmp2)) { __label__ = 6;break ; } //@line 188 "voices.cpp"
  
        var $5=$len; //@line 188 "voices.cpp"
        var $6=$buf_addr; //@line 188 "voices.cpp"
        var $arrayidx=(($6+$5)&4294967295); //@line 188 "voices.cpp"
        var $7=HEAP8[($arrayidx)]; //@line 188 "voices.cpp"
        var $conv=(tempInt=(($7)),(tempInt>=128?tempInt-256:tempInt)); //@line 188 "voices.cpp"
        var $call3=_isspace($conv); //@line 188 "voices.cpp"
        var $tobool=((($call3))|0)!=0; //@line 188 "voices.cpp"
        if (!($tobool)) { __label__ = 6;break ; }
  
        var $8=$len; //@line 189 "voices.cpp"
        var $9=$buf_addr; //@line 189 "voices.cpp"
        var $arrayidx4=(($9+$8)&4294967295); //@line 189 "voices.cpp"
        HEAP8[($arrayidx4)]=0; //@line 189 "voices.cpp"
        __label__ = 3;continue ; //@line 189 "voices.cpp"
      }
  
      var $10=$buf_addr; //@line 191 "voices.cpp"
      var $call5=_strstr($10, ((__str82734)&4294967295)); //@line 191 "voices.cpp"
      $p=$call5; //@line 191 "voices.cpp"
      var $cmp6=((($call5))|0)!=0; //@line 191 "voices.cpp"
      if ($cmp6) { __label__ = 7;; } else { __label__ = 8;; } //@line 191 "voices.cpp"
      if (__label__ == 7) {
  
        var $11=$p; //@line 192 "voices.cpp"
        HEAP8[($11)]=0; //@line 192 "voices.cpp"
        ; //@line 192 "voices.cpp"
      }
  
      var $12=$buf_addr; //@line 194 "voices.cpp"
      $retval=$12; //@line 194 "voices.cpp"
      ; //@line 194 "voices.cpp"
    }
  
    var $13=$retval; //@line 195 "voices.cpp"
    ;
    return $13; //@line 195 "voices.cpp"
    return null;
  }
  

  function __ZL12VoiceFormantPc($p) {
    var __stackBase__  = STACKTOP; STACKTOP += 20; _memset(__stackBase__, 0, 20);
    var __label__;
  
    var $p_addr;
    var $ix;
    var $formant=__stackBase__;
    var $freq=__stackBase__+4;
    var $height=__stackBase__+8;
    var $width=__stackBase__+12;
    var $freqadd=__stackBase__+16;
    $p_addr=$p;
    HEAP32[(($freq)>>2)]=100; //@line 464 "voices.cpp"
    HEAP32[(($height)>>2)]=100; //@line 465 "voices.cpp"
    HEAP32[(($width)>>2)]=100; //@line 466 "voices.cpp"
    HEAP32[(($freqadd)>>2)]=0; //@line 467 "voices.cpp"
    var $0=$p_addr; //@line 469 "voices.cpp"
    var $call=_sscanf($0, ((__str81733)&4294967295), allocate([$formant,0,0,0,$freq,0,0,0,$height,0,0,0,$width,0,0,0,$freqadd,0,0,0], ["i32*",0,0,0,"i32*",0,0,0,"i32*",0,0,0,"i32*",0,0,0,"i32*",0,0,0], ALLOC_STACK)); //@line 469 "voices.cpp"
    $ix=$call; //@line 469 "voices.cpp"
    var $1=$ix; //@line 470 "voices.cpp"
    var $cmp=((($1))|0) < 2; //@line 470 "voices.cpp"
    if ($cmp) { __label__ = 9;; } else { __label__ = 1;; } //@line 470 "voices.cpp"
    $return$$if_end$2: do { 
      if (__label__ == 1) {
  
        var $2=HEAP32[(($formant)>>2)]; //@line 473 "voices.cpp"
        var $cmp1=((($2))|0) < 0; //@line 473 "voices.cpp"
        var $3=HEAP32[(($formant)>>2)]; //@line 473 "voices.cpp"
        var $cmp2=((($3))|0) > 8; //@line 473 "voices.cpp"
        var $or_cond=($cmp1) | ($cmp2); //@line 473 "voices.cpp"
        if ($or_cond) { __label__ = 9;break $return$$if_end$2; } //@line 473 "voices.cpp"
  
        var $4=HEAP32[(($freq)>>2)]; //@line 476 "voices.cpp"
        var $cmp5=((($4))|0) >= 0; //@line 476 "voices.cpp"
        if ($cmp5) { __label__ = 3;; } else { __label__ = 4;; } //@line 476 "voices.cpp"
        if (__label__ == 3) {
  
          var $5=HEAP32[(($freq)>>2)]; //@line 477 "voices.cpp"
          var $conv=((($5))|0); //@line 477 "voices.cpp"
          var $mul=($conv)*2.56001; //@line 477 "voices.cpp"
          var $conv7=((($mul))|0); //@line 477 "voices.cpp"
          var $conv8=((($conv7)) & 65535); //@line 477 "voices.cpp"
          var $6=HEAP32[(($formant)>>2)]; //@line 477 "voices.cpp"
          var $7=HEAP32[((_voice)>>2)]; //@line 477 "voices.cpp"
          var $freq9=(($7+144)&4294967295); //@line 477 "voices.cpp"
          var $arrayidx=(($freq9+$6*2)&4294967295); //@line 477 "voices.cpp"
          HEAP16[(($arrayidx)>>1)]=$conv8; //@line 477 "voices.cpp"
          ; //@line 477 "voices.cpp"
        }
  
        var $8=HEAP32[(($height)>>2)]; //@line 478 "voices.cpp"
        var $cmp11=((($8))|0) >= 0; //@line 478 "voices.cpp"
        if ($cmp11) { __label__ = 5;; } else { __label__ = 6;; } //@line 478 "voices.cpp"
        if (__label__ == 5) {
  
          var $9=HEAP32[(($height)>>2)]; //@line 479 "voices.cpp"
          var $conv13=((($9))|0); //@line 479 "voices.cpp"
          var $mul14=($conv13)*2.56001; //@line 479 "voices.cpp"
          var $conv15=((($mul14))|0); //@line 479 "voices.cpp"
          var $conv16=((($conv15)) & 65535); //@line 479 "voices.cpp"
          var $10=HEAP32[(($formant)>>2)]; //@line 479 "voices.cpp"
          var $11=HEAP32[((_voice)>>2)]; //@line 479 "voices.cpp"
          var $height17=(($11+162)&4294967295); //@line 479 "voices.cpp"
          var $arrayidx18=(($height17+$10*2)&4294967295); //@line 479 "voices.cpp"
          HEAP16[(($arrayidx18)>>1)]=$conv16; //@line 479 "voices.cpp"
          ; //@line 479 "voices.cpp"
        }
  
        var $12=HEAP32[(($width)>>2)]; //@line 480 "voices.cpp"
        var $cmp20=((($12))|0) >= 0; //@line 480 "voices.cpp"
        if ($cmp20) { __label__ = 7;; } else { __label__ = 8;; } //@line 480 "voices.cpp"
        if (__label__ == 7) {
  
          var $13=HEAP32[(($width)>>2)]; //@line 481 "voices.cpp"
          var $conv22=((($13))|0); //@line 481 "voices.cpp"
          var $mul23=($conv22)*2.56001; //@line 481 "voices.cpp"
          var $conv24=((($mul23))|0); //@line 481 "voices.cpp"
          var $conv25=((($conv24)) & 65535); //@line 481 "voices.cpp"
          var $14=HEAP32[(($formant)>>2)]; //@line 481 "voices.cpp"
          var $15=HEAP32[((_voice)>>2)]; //@line 481 "voices.cpp"
          var $width26=(($15+180)&4294967295); //@line 481 "voices.cpp"
          var $arrayidx27=(($width26+$14*2)&4294967295); //@line 481 "voices.cpp"
          HEAP16[(($arrayidx27)>>1)]=$conv25; //@line 481 "voices.cpp"
          ; //@line 481 "voices.cpp"
        }
  
        var $16=HEAP32[(($freqadd)>>2)]; //@line 482 "voices.cpp"
        var $conv29=((($16)) & 65535); //@line 482 "voices.cpp"
        var $17=HEAP32[(($formant)>>2)]; //@line 482 "voices.cpp"
        var $18=HEAP32[((_voice)>>2)]; //@line 482 "voices.cpp"
        var $freqadd30=(($18+198)&4294967295); //@line 482 "voices.cpp"
        var $arrayidx31=(($freqadd30+$17*2)&4294967295); //@line 482 "voices.cpp"
        HEAP16[(($arrayidx31)>>1)]=$conv29; //@line 482 "voices.cpp"
        ; //@line 483 "voices.cpp"
      }
    } while(0);
  
    STACKTOP = __stackBase__;
    return; //@line 483 "voices.cpp"
    return;
  }
  

  function __ZL12Read8NumbersPcPi($data_in, $data) {
    ;
    var __label__;
  
    var $data_in_addr;
    var $data_addr;
    $data_in_addr=$data_in;
    $data_addr=$data;
    var $0=$data_addr; //@line 515 "voices.cpp"
    var $1=$0; //@line 515 "voices.cpp"
    var $dest$, $stop$, $stop4$, $fast$, $value4$;
    $dest$ = $1;
    $stop$ = $dest$ + 12;
    $value4$ = 0;
    if ($value4$ < 0) $value4$ += 256;
    $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
    while ($dest$%4 !== 0 && $dest$ < $stop$) {
      ;; HEAP8[$dest$++] = 0;
    }
    $dest$ >>= 2;
    $stop4$ = $stop$ >> 2;
    while ($dest$ < $stop4$) {
    ;;;;;;;  HEAP32[$dest$++] = $value4$;
    }
    $dest$ <<= 2;
    while ($dest$ < $stop$) {
      ;; HEAP8[$dest$++] = 0;
    }; //@line 515 "voices.cpp"
    var $2=$data_in_addr; //@line 516 "voices.cpp"
    var $3=$data_addr; //@line 516 "voices.cpp"
    var $arrayidx=(($3)&4294967295); //@line 516 "voices.cpp"
    var $4=$data_addr; //@line 516 "voices.cpp"
    var $arrayidx1=(($4+4)&4294967295); //@line 516 "voices.cpp"
    var $5=$data_addr; //@line 516 "voices.cpp"
    var $arrayidx2=(($5+8)&4294967295); //@line 516 "voices.cpp"
    var $6=$data_addr; //@line 516 "voices.cpp"
    var $arrayidx3=(($6+12)&4294967295); //@line 516 "voices.cpp"
    var $7=$data_addr; //@line 516 "voices.cpp"
    var $arrayidx4=(($7+16)&4294967295); //@line 516 "voices.cpp"
    var $8=$data_addr; //@line 516 "voices.cpp"
    var $arrayidx5=(($8+20)&4294967295); //@line 516 "voices.cpp"
    var $9=$data_addr; //@line 516 "voices.cpp"
    var $arrayidx6=(($9+24)&4294967295); //@line 516 "voices.cpp"
    var $10=$data_addr; //@line 516 "voices.cpp"
    var $arrayidx7=(($10+28)&4294967295); //@line 516 "voices.cpp"
    var $call=_sscanf($2, ((__str80732)&4294967295), allocate([$arrayidx,0,0,0,$arrayidx1,0,0,0,$arrayidx2,0,0,0,$arrayidx3,0,0,0,$arrayidx4,0,0,0,$arrayidx5,0,0,0,$arrayidx6,0,0,0,$arrayidx7,0,0,0], ["i32*",0,0,0,"i32*",0,0,0,"i32*",0,0,0,"i32*",0,0,0,"i32*",0,0,0,"i32*",0,0,0,"i32*",0,0,0,"i32*",0,0,0], ALLOC_STACK)); //@line 516 "voices.cpp"
    ;
    return $call; //@line 516 "voices.cpp"
    return null;
  }
  

  function __ZL10LookupTunePKc($name) {
    ;
    var __label__;
  
    var $retval;
    var $name_addr;
    var $ix;
    $name_addr=$name;
    $ix=0; //@line 202 "voices.cpp"
    ; //@line 202 "voices.cpp"
    while(1) { 
  
      var $0=$ix; //@line 202 "voices.cpp"
      var $1=HEAP32[((_n_tunes)>>2)]; //@line 202 "voices.cpp"
      var $cmp=((($0))|0) < ((($1))|0); //@line 202 "voices.cpp"
      if (!($cmp)) { __label__ = 5;break ; } //@line 202 "voices.cpp"
  
      var $2=$name_addr; //@line 204 "voices.cpp"
      var $3=$ix; //@line 204 "voices.cpp"
      var $4=HEAP32[((_tunes)>>2)]; //@line 204 "voices.cpp"
      var $arrayidx=(($4+68*$3)&4294967295); //@line 204 "voices.cpp"
      var $name1=(($arrayidx)&4294967295); //@line 204 "voices.cpp"
      var $arraydecay=(($name1)&4294967295); //@line 204 "voices.cpp"
      var $call=_strcmp($2, $arraydecay); //@line 204 "voices.cpp"
      var $cmp2=((($call))|0)==0; //@line 204 "voices.cpp"
      var $5=$ix; //@line 205 "voices.cpp"
      if ($cmp2) { __label__ = 3;break ; } //@line 204 "voices.cpp"
  
      var $inc=((($5)+1)&4294967295); //@line 202 "voices.cpp"
      $ix=$inc; //@line 202 "voices.cpp"
      __label__ = 1;continue ; //@line 202 "voices.cpp"
    }
    if (__label__ == 5) {
  
      $retval=-1; //@line 207 "voices.cpp"
      ; //@line 207 "voices.cpp"
    }
    else if (__label__ == 3) {
  
      $retval=$5; //@line 205 "voices.cpp"
      ; //@line 205 "voices.cpp"
    }
  
    var $6=$retval; //@line 208 "voices.cpp"
    ;
    return $6; //@line 208 "voices.cpp"
    return null;
  }
  

  function __ZL18PhonemeReplacementiPc($type, $p) {
    var __stackBase__  = STACKTOP; STACKTOP += 28; _memset(__stackBase__, 0, 28);
    var __label__;
  
    var $type_addr;
    var $p_addr;
    var $n;
    var $phon;
    var $flags=__stackBase__;
    var $phon_string1=__stackBase__+4;
    var $phon_string2=__stackBase__+16;
    $type_addr=$type;
    $p_addr=$p;
    HEAP32[(($flags)>>2)]=0; //@line 493 "voices.cpp"
    var $arraydecay=(($phon_string2)&4294967295); //@line 497 "voices.cpp"
    var $src$, $dest$, $stop$, $stop4$, $fast$;
    $src$ = ((__str60712)&4294967295);
    $dest$ = $arraydecay;
    $stop$ = $src$ + 5;
    if (($dest$%4) == ($src$%4) && 5 > 8) {
      while ($src$%4 !== 0 && $src$ < $stop$) {
        ; HEAP8[$dest$++] = HEAP8[$src$++];
      }
      $src$ >>= 2;
      $dest$ >>= 2;
      $stop4$ = $stop$ >> 2;
      while ($src$ < $stop4$) {
    ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
      }
      $src$ <<= 2;
      $dest$ <<= 2;
    }while ($src$ < $stop$) {
      ; HEAP8[$dest$++] = HEAP8[$src$++];
    }; //@line 497 "voices.cpp"
    var $0=$p_addr; //@line 498 "voices.cpp"
    var $arraydecay1=(($phon_string1)&4294967295); //@line 498 "voices.cpp"
    var $arraydecay2=(($phon_string2)&4294967295); //@line 498 "voices.cpp"
    var $call3=_sscanf($0, ((__str79731)&4294967295), allocate([$flags,0,0,0,$arraydecay1,0,0,0,$arraydecay2,0,0,0], ["i32*",0,0,0,"i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 498 "voices.cpp"
    $n=$call3; //@line 498 "voices.cpp"
    var $1=$n; //@line 499 "voices.cpp"
    var $cmp=((($1))|0) < 2; //@line 499 "voices.cpp"
    var $2=HEAP32[((_n_replace_phonemes)>>2)]; //@line 499 "voices.cpp"
    var $cmp4=((($2))|0) >= 60; //@line 499 "voices.cpp"
    var $or_cond=($cmp) | ($cmp4); //@line 499 "voices.cpp"
    if ($or_cond) { __label__ = 3;; } else { __label__ = 1;; } //@line 499 "voices.cpp"
    $return$$if_end$2: do { 
      if (__label__ == 1) {
  
        var $arraydecay5=(($phon_string1)&4294967295); //@line 502 "voices.cpp"
        var $call6=__Z19LookupPhonemeStringPKc($arraydecay5); //@line 502 "voices.cpp"
        $phon=$call6; //@line 502 "voices.cpp"
        var $cmp7=((($call6))|0)==0; //@line 502 "voices.cpp"
        if ($cmp7) { __label__ = 3;break $return$$if_end$2; } //@line 502 "voices.cpp"
  
        var $3=$phon; //@line 505 "voices.cpp"
        var $conv=((($3)) & 255); //@line 505 "voices.cpp"
        var $4=HEAP32[((_n_replace_phonemes)>>2)]; //@line 505 "voices.cpp"
        var $arrayidx=((_replace_phonemes+$4*3)&4294967295); //@line 505 "voices.cpp"
        var $old_ph=(($arrayidx)&4294967295); //@line 505 "voices.cpp"
        HEAP8[($old_ph)]=$conv; //@line 505 "voices.cpp"
        var $arraydecay10=(($phon_string2)&4294967295); //@line 506 "voices.cpp"
        var $call11=__Z19LookupPhonemeStringPKc($arraydecay10); //@line 506 "voices.cpp"
        var $conv12=((($call11)) & 255); //@line 506 "voices.cpp"
        var $5=HEAP32[((_n_replace_phonemes)>>2)]; //@line 506 "voices.cpp"
        var $arrayidx13=((_replace_phonemes+$5*3)&4294967295); //@line 506 "voices.cpp"
        var $new_ph=(($arrayidx13+1)&4294967295); //@line 506 "voices.cpp"
        HEAP8[($new_ph)]=$conv12; //@line 506 "voices.cpp"
        var $6=HEAP32[(($flags)>>2)]; //@line 507 "voices.cpp"
        var $conv14=((($6)) & 255); //@line 507 "voices.cpp"
        var $7=HEAP32[((_n_replace_phonemes)>>2)]; //@line 507 "voices.cpp"
        var $inc=((($7)+1)&4294967295); //@line 507 "voices.cpp"
        HEAP32[((_n_replace_phonemes)>>2)]=$inc; //@line 507 "voices.cpp"
        var $arrayidx15=((_replace_phonemes+$7*3)&4294967295); //@line 507 "voices.cpp"
        var $type16=(($arrayidx15+2)&4294967295); //@line 507 "voices.cpp"
        HEAP8[($type16)]=$conv14; //@line 507 "voices.cpp"
        ; //@line 508 "voices.cpp"
      }
    } while(0);
  
    STACKTOP = __stackBase__;
    return; //@line 508 "voices.cpp"
    return;
  }
  

  function __Z16LoadVoiceVariantPKci($vname, $variant_num) {
    var __stackBase__  = STACKTOP; STACKTOP += 60; _memset(__stackBase__, 0, 60);
    var __label__;
  
    var $retval;
    var $vname_addr;
    var $variant_num_addr;
    var $v;
    var $variant_name;
    var $buf=__stackBase__;
    $vname_addr=$vname;
    $variant_num_addr=$variant_num;
    var $arraydecay=(($buf)&4294967295); //@line 1085 "voices.cpp"
    var $0=$vname_addr; //@line 1085 "voices.cpp"
    __Z8strncpy0PcPKci($arraydecay, $0, 60); //@line 1085 "voices.cpp"
    var $arraydecay1=(($buf)&4294967295); //@line 1086 "voices.cpp"
    var $1=$variant_num_addr; //@line 1086 "voices.cpp"
    __ZL23ExtractVoiceVariantNamePci($arraydecay1, $1); //@line 1086 "voices.cpp"
    $variant_name=((__ZZL23ExtractVoiceVariantNamePciE12variant_name)&4294967295); //@line 1086 "voices.cpp"
    var $arraydecay2=(($buf)&4294967295); //@line 1088 "voices.cpp"
    var $call3=__Z9LoadVoicePKci($arraydecay2, 0); //@line 1088 "voices.cpp"
    $v=$call3; //@line 1088 "voices.cpp"
    var $cmp=((($call3))|0)==0; //@line 1088 "voices.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 1088 "voices.cpp"
    if (__label__ == 1) {
  
      $retval=0; //@line 1089 "voices.cpp"
      ; //@line 1089 "voices.cpp"
    }
    else if (__label__ == 2) {
  
      var $2=$variant_name; //@line 1091 "voices.cpp"
      var $arrayidx=(($2)&4294967295); //@line 1091 "voices.cpp"
      var $3=HEAP8[($arrayidx)]; //@line 1091 "voices.cpp"
      var $conv=(tempInt=(($3)),(tempInt>=128?tempInt-256:tempInt)); //@line 1091 "voices.cpp"
      var $cmp4=((($conv))|0)!=0; //@line 1091 "voices.cpp"
      if ($cmp4) { __label__ = 3;; } else { __label__ = 4;; } //@line 1091 "voices.cpp"
      if (__label__ == 3) {
  
        var $4=$variant_name; //@line 1093 "voices.cpp"
        var $call6=__Z9LoadVoicePKci($4, 2); //@line 1093 "voices.cpp"
        $v=$call6; //@line 1093 "voices.cpp"
        ; //@line 1094 "voices.cpp"
      }
  
      var $5=$v; //@line 1095 "voices.cpp"
      $retval=$5; //@line 1095 "voices.cpp"
      ; //@line 1095 "voices.cpp"
    }
  
    var $6=$retval; //@line 1096 "voices.cpp"
    STACKTOP = __stackBase__;
    return $6; //@line 1096 "voices.cpp"
    return null;
  }
  

  function __ZL23ExtractVoiceVariantNamePci($vname, $variant_num) {
    var __stackBase__  = STACKTOP; STACKTOP += 8; _memset(__stackBase__, 0, 8);
    var __label__;
    var __lastLabel__ = null;
  
    var $vname_addr;
    var $variant_num_addr;
    var $p;
    var $variant_prefix=__stackBase__;
    $vname_addr=$vname;
    $variant_num_addr=$variant_num;
    HEAP8[(((__ZZL23ExtractVoiceVariantNamePciE12variant_name)&4294967295))]=0; //@line 1041 "voices.cpp"
    var $arraydecay=(($variant_prefix)&4294967295); //@line 1042 "voices.cpp"
    var $call=_sprintf($arraydecay, ((__str76728)&4294967295), allocate([47,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 1042 "voices.cpp"
    var $0=$vname_addr; //@line 1044 "voices.cpp"
    var $cmp=((($0))|0)!=0; //@line 1044 "voices.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 5;; } //@line 1044 "voices.cpp"
    $if_then$$if_end10thread_pre_split$2: do { 
      if (__label__ == 1) {
  
        var $1=$vname_addr; //@line 1046 "voices.cpp"
        var $call1=_strchr($1, 43); //@line 1046 "voices.cpp"
        $p=$call1; //@line 1046 "voices.cpp"
        var $cmp2=((($call1))|0)!=0; //@line 1046 "voices.cpp"
        if (!($cmp2)) { __label__ = 5;break $if_then$$if_end10thread_pre_split$2; } //@line 1046 "voices.cpp"
  
        var $2=$p; //@line 1049 "voices.cpp"
        var $incdec_ptr=(($2+1)&4294967295); //@line 1049 "voices.cpp"
        $p=$incdec_ptr; //@line 1049 "voices.cpp"
        HEAP8[($2)]=0; //@line 1049 "voices.cpp"
        var $3=$p; //@line 1050 "voices.cpp"
        var $4=HEAP8[($3)]; //@line 1050 "voices.cpp"
        var $conv=(tempInt=(($4)),(tempInt>=128?tempInt-256:tempInt)); //@line 1050 "voices.cpp"
        var $isdigittmp=((($conv)-48)&4294967295); //@line 1050 "voices.cpp"
        var $isdigit=((($isdigittmp))>>>0) < 10; //@line 1050 "voices.cpp"
        var $call4=((($isdigit))&1); //@line 1050 "voices.cpp"
        var $tobool=((($call4))|0)!=0; //@line 1050 "voices.cpp"
        if ($tobool) { __label__ = 3;; } else { __label__ = 4;; } //@line 1050 "voices.cpp"
        if (__label__ == 3) {
  
          var $5=$p; //@line 1052 "voices.cpp"
          var $call6=_atoi($5); //@line 1052 "voices.cpp"
          $variant_num_addr=$call6; //@line 1052 "voices.cpp"
          __lastLabel__ = 3; __label__ = 6;break $if_then$$if_end10thread_pre_split$2; //@line 1053 "voices.cpp"
        }
        else if (__label__ == 4) {
  
          var $arraydecay7=(($variant_prefix)&4294967295); //@line 1057 "voices.cpp"
          var $call8=_strcpy(((__ZZL23ExtractVoiceVariantNamePciE12variant_name)&4294967295), $arraydecay7); //@line 1057 "voices.cpp"
          var $6=$p; //@line 1058 "voices.cpp"
          __Z8strncpy0PcPKci(((__ZZL23ExtractVoiceVariantNamePciE12variant_name+3)&4294967295), $6, 17); //@line 1058 "voices.cpp"
          __label__ = 5;break $if_then$$if_end10thread_pre_split$2;
        }
      }
    } while(0);
    if (__label__ == 5) {
  
      var $_pr=$variant_num_addr; //@line 1063 "voices.cpp"
      __lastLabel__ = 5; ;
    }
  
    var $7=__lastLabel__ == 5 ? $_pr : ($call6); //@line 1063 "voices.cpp"
    var $cmp11=((($7))|0) > 0; //@line 1063 "voices.cpp"
    if ($cmp11) { __label__ = 7;; } else { __label__ = 10;; } //@line 1063 "voices.cpp"
    if (__label__ == 7) {
  
      var $8=$variant_num_addr; //@line 1065 "voices.cpp"
      var $cmp13=((($8))|0) < 10; //@line 1065 "voices.cpp"
      var $arraydecay15=(($variant_prefix)&4294967295); //@line 1066 "voices.cpp"
      var $9=$variant_num_addr; //@line 1066 "voices.cpp"
      if ($cmp13) { __label__ = 8;; } else { __label__ = 9;; } //@line 1065 "voices.cpp"
      if (__label__ == 8) {
  
        var $call16=_sprintf(((__ZZL23ExtractVoiceVariantNamePciE12variant_name)&4294967295), ((__str77729)&4294967295), allocate([$arraydecay15,0,0,0,$9,0,0,0], ["i8*",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 1066 "voices.cpp"
        ; //@line 1066 "voices.cpp"
      }
      else if (__label__ == 9) {
  
        var $sub=((($9)-10)&4294967295); //@line 1068 "voices.cpp"
        var $call19=_sprintf(((__ZZL23ExtractVoiceVariantNamePciE12variant_name)&4294967295), ((__str78730)&4294967295), allocate([$arraydecay15,0,0,0,$sub,0,0,0], ["i8*",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 1068 "voices.cpp"
        ;
      }
    }
  
    STACKTOP = __stackBase__;
    return;
    return;
  }
  

  function __Z17SelectVoiceByNamePP12espeak_VOICEPKc($voices, $name) {
    var __stackBase__  = STACKTOP; STACKTOP += 44; _memset(__stackBase__, 0, 44);
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $voices_addr;
    var $name_addr;
    var $ix;
    var $match_fname;
    var $match_fname2;
    var $match_name;
    var $id;
    var $last_part_len;
    var $last_part=__stackBase__;
    $voices_addr=$voices;
    $name_addr=$name;
    $match_fname=-1; //@line 1325 "voices.cpp"
    $match_fname2=-1; //@line 1326 "voices.cpp"
    $match_name=-1; //@line 1327 "voices.cpp"
    var $0=$voices_addr; //@line 1332 "voices.cpp"
    var $cmp=((($0))|0)==0; //@line 1332 "voices.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 4;; } //@line 1332 "voices.cpp"
    if (__label__ == 1) {
  
      var $1=HEAP32[((__ZL13n_voices_list)>>2)]; //@line 1334 "voices.cpp"
      var $cmp1=((($1))|0)==0; //@line 1334 "voices.cpp"
      if ($cmp1) { __label__ = 2;; } else { __label__ = 3;; } //@line 1334 "voices.cpp"
      if (__label__ == 2) {
  
        var $call=_espeak_ListVoices(0); //@line 1335 "voices.cpp"
        ; //@line 1335 "voices.cpp"
      }
  
      $voices_addr=((__ZL11voices_list)&4294967295); //@line 1336 "voices.cpp"
      ; //@line 1337 "voices.cpp"
    }
  
    var $arraydecay=(($last_part)&4294967295); //@line 1339 "voices.cpp"
    var $2=$name_addr; //@line 1339 "voices.cpp"
    var $call4=_sprintf($arraydecay, ((__str70722)&4294967295), allocate([47,0,0,0,$2,0,0,0], ["i32",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 1339 "voices.cpp"
    var $arraydecay5=(($last_part)&4294967295); //@line 1340 "voices.cpp"
    var $call6=_strlen($arraydecay5); //@line 1340 "voices.cpp"
    $last_part_len=$call6; //@line 1340 "voices.cpp"
    $ix=0; //@line 1342 "voices.cpp"
    var $arraydecay18=(($last_part)&4294967295); //@line 1355 "voices.cpp"
    ; //@line 1342 "voices.cpp"
    $for_cond$8: while(1) { 
  
      var $3=$ix; //@line 1342 "voices.cpp"
      var $4=$voices_addr; //@line 1342 "voices.cpp"
      var $arrayidx=(($4+4*$3)&4294967295); //@line 1342 "voices.cpp"
      var $5=HEAP32[(($arrayidx)>>2)]; //@line 1342 "voices.cpp"
      var $cmp7=((($5))|0)!=0; //@line 1342 "voices.cpp"
      if (!($cmp7)) { __label__ = 13;break $for_cond$8; } //@line 1342 "voices.cpp"
  
      var $6=$name_addr; //@line 1344 "voices.cpp"
      var $7=$ix; //@line 1344 "voices.cpp"
      var $8=$voices_addr; //@line 1344 "voices.cpp"
      var $arrayidx8=(($8+4*$7)&4294967295); //@line 1344 "voices.cpp"
      var $9=HEAP32[(($arrayidx8)>>2)]; //@line 1344 "voices.cpp"
      var $name9=(($9)&4294967295); //@line 1344 "voices.cpp"
      var $10=HEAP32[(($name9)>>2)]; //@line 1344 "voices.cpp"
      var $call10=_strcmp($6, $10); //@line 1344 "voices.cpp"
      var $cmp11=((($call10))|0)==0; //@line 1344 "voices.cpp"
      if ($cmp11) { __label__ = 7;break $for_cond$8; } //@line 1344 "voices.cpp"
  
      var $12=$name_addr; //@line 1350 "voices.cpp"
      var $13=$ix; //@line 1350 "voices.cpp"
      var $14=$voices_addr; //@line 1350 "voices.cpp"
      var $arrayidx13=(($14+4*$13)&4294967295); //@line 1350 "voices.cpp"
      var $15=HEAP32[(($arrayidx13)>>2)]; //@line 1350 "voices.cpp"
      var $identifier=(($15+8)&4294967295); //@line 1350 "voices.cpp"
      var $16=HEAP32[(($identifier)>>2)]; //@line 1350 "voices.cpp"
      $id=$16; //@line 1350 "voices.cpp"
      var $call14=_strcmp($12, $16); //@line 1350 "voices.cpp"
      var $cmp15=((($call14))|0)==0; //@line 1350 "voices.cpp"
      if ($cmp15) { __label__ = 9;; } else { __label__ = 10;; } //@line 1350 "voices.cpp"
      $if_then16$$if_else17$12: do { 
        if (__label__ == 9) {
  
          var $17=$ix; //@line 1352 "voices.cpp"
          $match_fname=$17; //@line 1352 "voices.cpp"
          ; //@line 1353 "voices.cpp"
        }
        else if (__label__ == 10) {
  
          var $18=$id; //@line 1355 "voices.cpp"
          var $call19=_strlen($18); //@line 1355 "voices.cpp"
          var $19=$last_part_len; //@line 1355 "voices.cpp"
          var $sub=((($call19)-($19))&4294967295); //@line 1355 "voices.cpp"
          var $20=$id; //@line 1355 "voices.cpp"
          var $arrayidx20=(($20+$sub)&4294967295); //@line 1355 "voices.cpp"
          var $call21=_strcmp($arraydecay18, $arrayidx20); //@line 1355 "voices.cpp"
          var $cmp22=((($call21))|0)==0; //@line 1355 "voices.cpp"
          if (!($cmp22)) { __label__ = 12;break $if_then16$$if_else17$12; } //@line 1355 "voices.cpp"
  
          var $21=$ix; //@line 1357 "voices.cpp"
          $match_fname2=$21; //@line 1357 "voices.cpp"
          ; //@line 1358 "voices.cpp"
        }
      } while(0);
  
      var $22=$ix; //@line 1342 "voices.cpp"
      var $inc=((($22)+1)&4294967295); //@line 1342 "voices.cpp"
      $ix=$inc; //@line 1342 "voices.cpp"
      __label__ = 5;continue $for_cond$8; //@line 1342 "voices.cpp"
    }
    if (__label__ == 13) {
  
      var $_pr=$match_name; //@line 1361 "voices.cpp"
      __lastLabel__ = 13; ;
    }
    else if (__label__ == 7) {
  
      var $11=$ix; //@line 1346 "voices.cpp"
      $match_name=$11; //@line 1346 "voices.cpp"
      __lastLabel__ = 7; ; //@line 1347 "voices.cpp"
    }
  
    var $23=__lastLabel__ == 13 ? $_pr : ($11); //@line 1361 "voices.cpp"
    var $cmp27=((($23))|0) < 0; //@line 1361 "voices.cpp"
    if ($cmp27) { __label__ = 15;; } else { __label__ = 17;; } //@line 1361 "voices.cpp"
    $if_then28$$if_end32thread_pre_split$21: do { 
      if (__label__ == 15) {
  
        var $24=$match_fname; //@line 1363 "voices.cpp"
        $match_name=$24; //@line 1363 "voices.cpp"
        var $25=$match_name; //@line 1364 "voices.cpp"
        var $cmp29=((($25))|0) < 0; //@line 1364 "voices.cpp"
        if (!($cmp29)) { __label__ = 20;break $if_then28$$if_end32thread_pre_split$21; } //@line 1364 "voices.cpp"
  
        var $26=$match_fname2; //@line 1365 "voices.cpp"
        $match_name=$26; //@line 1365 "voices.cpp"
        __lastLabel__ = 16; __label__ = 18;break $if_then28$$if_end32thread_pre_split$21; //@line 1365 "voices.cpp"
      }
      else if (__label__ == 17) {
  
        var $_pr1=$match_name; //@line 1368 "voices.cpp"
        __lastLabel__ = 17; __label__ = 18;break $if_then28$$if_end32thread_pre_split$21;
      }
    } while(0);
    $if_end32$$if_end35$25: do { 
      if (__label__ == 18) {
  
        var $27=__lastLabel__ == 17 ? $_pr1 : ($26); //@line 1368 "voices.cpp"
        var $cmp33=((($27))|0) < 0; //@line 1368 "voices.cpp"
        if (!($cmp33)) { __label__ = 20;break $if_end32$$if_end35$25; } //@line 1368 "voices.cpp"
  
        $retval=0; //@line 1369 "voices.cpp"
        __label__ = 21;break $if_end32$$if_end35$25; //@line 1369 "voices.cpp"
      }
    } while(0);
    if (__label__ == 20) {
  
      var $28=$match_name; //@line 1371 "voices.cpp"
      var $29=$voices_addr; //@line 1371 "voices.cpp"
      var $arrayidx36=(($29+4*$28)&4294967295); //@line 1371 "voices.cpp"
      var $30=HEAP32[(($arrayidx36)>>2)]; //@line 1371 "voices.cpp"
      $retval=$30; //@line 1371 "voices.cpp"
      ; //@line 1371 "voices.cpp"
    }
  
    var $31=$retval; //@line 1372 "voices.cpp"
    STACKTOP = __stackBase__;
    return $31; //@line 1372 "voices.cpp"
    return null;
  }
  

  function _espeak_ListVoices($voice_spec) {
    var __stackBase__  = STACKTOP; STACKTOP += 164; _memset(__stackBase__, 0, 164);
    var __label__;
  
    var $voice_spec_addr;
    var $ix;
    var $j;
    var $v;
    var $path_voices=__stackBase__;
    $voice_spec_addr=$voice_spec;
    $ix=0; //@line 1753 "voices.cpp"
    var $0=$ix; //@line 1753 "voices.cpp"
    var $1=HEAP32[((__ZL13n_voices_list)>>2)]; //@line 1753 "voices.cpp"
    var $cmp3=((($0))|0) < ((($1))|0); //@line 1753 "voices.cpp"
    if ($cmp3) { __label__ = 1;; } else { __label__ = 4;; } //@line 1753 "voices.cpp"
    $for_body$$for_end$2: do { 
      if (__label__ == 1) {
        while(1) { 
  
          var $2=$ix; //@line 1755 "voices.cpp"
          var $arrayidx=((__ZL11voices_list+$2*4)&4294967295); //@line 1755 "voices.cpp"
          var $3=HEAP32[(($arrayidx)>>2)]; //@line 1755 "voices.cpp"
          var $cmp1=((($3))|0)!=0; //@line 1755 "voices.cpp"
          if ($cmp1) { __label__ = 2;; } else { __label__ = 3;; } //@line 1755 "voices.cpp"
          if (__label__ == 2) {
  
            var $4=$ix; //@line 1756 "voices.cpp"
            var $arrayidx2=((__ZL11voices_list+$4*4)&4294967295); //@line 1756 "voices.cpp"
            var $5=HEAP32[(($arrayidx2)>>2)]; //@line 1756 "voices.cpp"
            var $6=$5; //@line 1756 "voices.cpp"
            ; //@line 1756 "voices.cpp"
            ; //@line 1756 "voices.cpp"
          }
  
          var $7=$ix; //@line 1753 "voices.cpp"
          var $inc=((($7)+1)&4294967295); //@line 1753 "voices.cpp"
          $ix=$inc; //@line 1753 "voices.cpp"
          var $8=$ix; //@line 1753 "voices.cpp"
          var $9=HEAP32[((__ZL13n_voices_list)>>2)]; //@line 1753 "voices.cpp"
          var $cmp=((($8))|0) < ((($9))|0); //@line 1753 "voices.cpp"
          if ($cmp) { __label__ = 1;continue ; } else { __label__ = 4;break $for_body$$for_end$2; } //@line 1753 "voices.cpp"
        }
      }
    } while(0);
  
    HEAP32[((__ZL13n_voices_list)>>2)]=0; //@line 1758 "voices.cpp"
    var $arraydecay=(($path_voices)&4294967295); //@line 1760 "voices.cpp"
    var $call=_sprintf($arraydecay, ((__str72724)&4294967295), allocate([((_path_home)&4294967295),0,0,0,47,0,0,0], ["i8*",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 1760 "voices.cpp"
    var $arraydecay3=(($path_voices)&4294967295); //@line 1761 "voices.cpp"
    var $call4=_strlen($arraydecay3); //@line 1761 "voices.cpp"
    var $add=((($call4)+1)&4294967295); //@line 1761 "voices.cpp"
    HEAP32[((__ZL15len_path_voices)>>2)]=$add; //@line 1761 "voices.cpp"
    var $arraydecay5=(($path_voices)&4294967295); //@line 1763 "voices.cpp"
    __ZL9GetVoicesPKc($arraydecay5); //@line 1763 "voices.cpp"
    var $10=HEAP32[((__ZL13n_voices_list)>>2)]; //@line 1764 "voices.cpp"
    var $arrayidx6=((__ZL11voices_list+$10*4)&4294967295); //@line 1764 "voices.cpp"
    HEAP32[(($arrayidx6)>>2)]=0; //@line 1764 "voices.cpp"
    var $11=HEAP32[((__ZL13n_voices_list)>>2)]; //@line 1767 "voices.cpp"
    _qsort(__ZL11voices_list, $11, 4, 6); //@line 1767 "voices.cpp"
    var $12=$voice_spec_addr; //@line 1771 "voices.cpp"
    var $tobool=((($12))|0)!=0; //@line 1771 "voices.cpp"
    if ($tobool) { __label__ = 5;; } else { __label__ = 6;; } //@line 1771 "voices.cpp"
    if (__label__ == 5) {
  
      var $13=$voice_spec_addr; //@line 1774 "voices.cpp"
      var $call8=__ZL14SetVoiceScoresP12espeak_VOICEPS0_i($13, ((__ZZ17espeak_ListVoicesE6voices)&4294967295), 1); //@line 1774 "voices.cpp"
      ; //@line 1775 "voices.cpp"
    }
    else if (__label__ == 6) {
  
      $j=0; //@line 1779 "voices.cpp"
      $ix=0; //@line 1780 "voices.cpp"
      var $14=$ix; //@line 1780 "voices.cpp"
      var $arrayidx101=((__ZL11voices_list+$14*4)&4294967295); //@line 1780 "voices.cpp"
      var $15=HEAP32[(($arrayidx101)>>2)]; //@line 1780 "voices.cpp"
      $v=$15; //@line 1780 "voices.cpp"
      var $cmp112=((($15))|0)!=0; //@line 1780 "voices.cpp"
      if ($cmp112) { __label__ = 7;; } else { __label__ = 12;; } //@line 1780 "voices.cpp"
      $for_body12$$for_end28$12: do { 
        if (__label__ == 7) {
          $for_body12$13: while(1) { 
  
            var $16=$v; //@line 1782 "voices.cpp"
            var $languages=(($16+4)&4294967295); //@line 1782 "voices.cpp"
            var $17=HEAP32[(($languages)>>2)]; //@line 1782 "voices.cpp"
            var $arrayidx13=(($17)&4294967295); //@line 1782 "voices.cpp"
            var $18=HEAP8[($arrayidx13)]; //@line 1782 "voices.cpp"
            var $conv=(tempInt=(($18)),(tempInt>=128?tempInt-256:tempInt)); //@line 1782 "voices.cpp"
            var $cmp14=((($conv))|0)!=0; //@line 1782 "voices.cpp"
            if ($cmp14) { __label__ = 8;; } else { __label__ = 11;; } //@line 1782 "voices.cpp"
            $land_lhs_true$$for_inc26$15: do { 
              if (__label__ == 8) {
  
                var $19=$v; //@line 1782 "voices.cpp"
                var $languages15=(($19+4)&4294967295); //@line 1782 "voices.cpp"
                var $20=HEAP32[(($languages15)>>2)]; //@line 1782 "voices.cpp"
                var $arrayidx16=(($20+1)&4294967295); //@line 1782 "voices.cpp"
                var $call17=_strcmp($arrayidx16, ((__str55707)&4294967295)); //@line 1782 "voices.cpp"
                var $cmp18=((($call17))|0)!=0; //@line 1782 "voices.cpp"
                if (!($cmp18)) { __label__ = 11;break $land_lhs_true$$for_inc26$15; } //@line 1782 "voices.cpp"
  
                var $21=$v; //@line 1782 "voices.cpp"
                var $identifier=(($21+8)&4294967295); //@line 1782 "voices.cpp"
                var $22=HEAP32[(($identifier)>>2)]; //@line 1782 "voices.cpp"
                var $call20=_memcmp($22, ((__str73725)&4294967295), 3); //@line 1782 "voices.cpp"
                var $cmp21=((($call20))|0)!=0; //@line 1782 "voices.cpp"
                if (!($cmp21)) { __label__ = 11;break $land_lhs_true$$for_inc26$15; } //@line 1782 "voices.cpp"
  
                var $23=$v; //@line 1784 "voices.cpp"
                var $24=$j; //@line 1784 "voices.cpp"
                var $inc23=((($24)+1)&4294967295); //@line 1784 "voices.cpp"
                $j=$inc23; //@line 1784 "voices.cpp"
                var $arrayidx24=((__ZZ17espeak_ListVoicesE6voices+$24*4)&4294967295); //@line 1784 "voices.cpp"
                HEAP32[(($arrayidx24)>>2)]=$23; //@line 1784 "voices.cpp"
                ; //@line 1785 "voices.cpp"
              }
            } while(0);
  
            var $25=$ix; //@line 1780 "voices.cpp"
            var $inc27=((($25)+1)&4294967295); //@line 1780 "voices.cpp"
            $ix=$inc27; //@line 1780 "voices.cpp"
            var $26=$ix; //@line 1780 "voices.cpp"
            var $arrayidx10=((__ZL11voices_list+$26*4)&4294967295); //@line 1780 "voices.cpp"
            var $27=HEAP32[(($arrayidx10)>>2)]; //@line 1780 "voices.cpp"
            $v=$27; //@line 1780 "voices.cpp"
            var $cmp11=((($27))|0)!=0; //@line 1780 "voices.cpp"
            if ($cmp11) { __label__ = 7;continue $for_body12$13; } else { __label__ = 12;break $for_body12$$for_end28$12; } //@line 1780 "voices.cpp"
          }
        }
      } while(0);
  
      var $28=$j; //@line 1787 "voices.cpp"
      var $arrayidx29=((__ZZ17espeak_ListVoicesE6voices+$28*4)&4294967295); //@line 1787 "voices.cpp"
      HEAP32[(($arrayidx29)>>2)]=0; //@line 1787 "voices.cpp"
      ;
    }
  
    STACKTOP = __stackBase__;
    return ((__ZZ17espeak_ListVoicesE6voices)&4294967295); //@line 1789 "voices.cpp"
    return null;
  }
  

  function __Z11SelectVoiceP12espeak_VOICEPi($voice_select, $found) {
    var __stackBase__  = STACKTOP; STACKTOP += 1272; _memset(__stackBase__, 0, 1272);
    var __label__;
  
    var $retval;
    var $voice_select_addr;
    var $found_addr;
    var $nv;
    var $ix;
    var $ix2;
    var $j;
    var $n_variants;
    var $variant_number;
    var $gender;
    var $skip;
    var $aged;
    var $variant_name;
    var $p;
    var $p_start;
    var $vp;
    var $vp2;
    var $voice_select2=__stackBase__;
    var $voices=__stackBase__+24;
    var $voices2=__stackBase__+624;
    $voice_select_addr=$voice_select;
    $found_addr=$found;
    $aged=1; //@line 1388 "voices.cpp"
    $vp=0; //@line 1391 "voices.cpp"
    var $0=$found_addr; //@line 1399 "voices.cpp"
    HEAP32[(($0)>>2)]=1; //@line 1399 "voices.cpp"
    var $1=$voice_select2; //@line 1400 "voices.cpp"
    var $2=$voice_select_addr; //@line 1400 "voices.cpp"
    var $3=$2; //@line 1400 "voices.cpp"
    var $src$, $dest$, $stop$, $stop4$, $fast$;
    $src$ = $3;
    $dest$ = $1;
    $stop$ = $src$ + 24;
    if (($dest$%4) == ($src$%4) && 24 > 8) {
      while ($src$%4 !== 0 && $src$ < $stop$) {
        ; HEAP8[$dest$++] = HEAP8[$src$++];
      }
      $src$ >>= 2;
      $dest$ >>= 2;
      $stop4$ = $stop$ >> 2;
      while ($src$ < $stop4$) {
    ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
      }
      $src$ <<= 2;
      $dest$ <<= 2;
    }while ($src$ < $stop$) {
      ; HEAP8[$dest$++] = HEAP8[$src$++];
    }; //@line 1400 "voices.cpp"
    var $4=HEAP32[((__ZL13n_voices_list)>>2)]; //@line 1402 "voices.cpp"
    var $cmp=((($4))|0)==0; //@line 1402 "voices.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 1402 "voices.cpp"
    if (__label__ == 1) {
  
      var $call=_espeak_ListVoices(0); //@line 1403 "voices.cpp"
      ; //@line 1403 "voices.cpp"
    }
  
    var $languages=(($voice_select2+4)&4294967295); //@line 1405 "voices.cpp"
    var $5=HEAP32[(($languages)>>2)]; //@line 1405 "voices.cpp"
    var $cmp1=((($5))|0)==0; //@line 1405 "voices.cpp"
    if ($cmp1) { __label__ = 4;; } else { __label__ = 3;; } //@line 1405 "voices.cpp"
    $if_then4$$lor_lhs_false$5: do { 
      if (__label__ == 3) {
  
        var $languages2=(($voice_select2+4)&4294967295); //@line 1405 "voices.cpp"
        var $6=HEAP32[(($languages2)>>2)]; //@line 1405 "voices.cpp"
        var $arrayidx=(($6)&4294967295); //@line 1405 "voices.cpp"
        var $7=HEAP8[($arrayidx)]; //@line 1405 "voices.cpp"
        var $conv=(tempInt=(($7)),(tempInt>=128?tempInt-256:tempInt)); //@line 1405 "voices.cpp"
        var $cmp3=((($conv))|0)==0; //@line 1405 "voices.cpp"
        if ($cmp3) { __label__ = 4;break $if_then4$$lor_lhs_false$5; } else { __label__ = 14;break $if_then4$$lor_lhs_false$5; } //@line 1405 "voices.cpp"
      }
    } while(0);
    $if_then4$$if_end41$7: do { 
      if (__label__ == 4) {
  
        var $name=(($voice_select2)&4294967295); //@line 1410 "voices.cpp"
        var $8=HEAP32[(($name)>>2)]; //@line 1410 "voices.cpp"
        var $cmp5=((($8))|0)==0; //@line 1410 "voices.cpp"
        if ($cmp5) { __label__ = 5;; } else { __label__ = 7;; } //@line 1410 "voices.cpp"
        $if_then6$$if_end12$9: do { 
          if (__label__ == 5) {
  
            var $identifier=(($voice_select2+8)&4294967295); //@line 1412 "voices.cpp"
            var $9=HEAP32[(($identifier)>>2)]; //@line 1412 "voices.cpp"
            var $name7=(($voice_select2)&4294967295); //@line 1412 "voices.cpp"
            HEAP32[(($name7)>>2)]=$9; //@line 1412 "voices.cpp"
            var $cmp8=((($9))|0)==0; //@line 1412 "voices.cpp"
            if (!($cmp8)) { __label__ = 7;break $if_then6$$if_end12$9; } //@line 1412 "voices.cpp"
  
            var $name10=(($voice_select2)&4294967295); //@line 1413 "voices.cpp"
            HEAP32[(($name10)>>2)]=((__str45697)&4294967295); //@line 1413 "voices.cpp"
            ; //@line 1413 "voices.cpp"
          }
        } while(0);
  
        var $name13=(($voice_select2)&4294967295); //@line 1416 "voices.cpp"
        var $10=HEAP32[(($name13)>>2)]; //@line 1416 "voices.cpp"
        __Z8strncpy0PcPKci(((__ZZ11SelectVoiceP12espeak_VOICEPiE3buf)&4294967295), $10, 60); //@line 1416 "voices.cpp"
        __ZL23ExtractVoiceVariantNamePci(((__ZZ11SelectVoiceP12espeak_VOICEPiE3buf)&4294967295), 0); //@line 1417 "voices.cpp"
        $variant_name=((__ZZL23ExtractVoiceVariantNamePciE12variant_name)&4294967295); //@line 1417 "voices.cpp"
        var $call15=__Z17SelectVoiceByNamePP12espeak_VOICEPKc(((__ZL11voices_list)&4294967295), ((__ZZ11SelectVoiceP12espeak_VOICEPiE3buf)&4294967295)); //@line 1419 "voices.cpp"
        $vp=$call15; //@line 1419 "voices.cpp"
        var $cmp16=((($call15))|0)!=0; //@line 1420 "voices.cpp"
        if (!($cmp16)) { __label__ = 14;break $if_then4$$if_end41$7; } //@line 1420 "voices.cpp"
  
        var $11=$vp; //@line 1422 "voices.cpp"
        var $languages18=(($11+4)&4294967295); //@line 1422 "voices.cpp"
        var $12=HEAP32[(($languages18)>>2)]; //@line 1422 "voices.cpp"
        var $arrayidx19=(($12+1)&4294967295); //@line 1422 "voices.cpp"
        var $languages20=(($voice_select2+4)&4294967295); //@line 1422 "voices.cpp"
        HEAP32[(($languages20)>>2)]=$arrayidx19; //@line 1422 "voices.cpp"
        var $gender21=(($voice_select2+12)&4294967295); //@line 1424 "voices.cpp"
        var $13=HEAPU8[($gender21)]; //@line 1424 "voices.cpp"
        var $conv22=((($13))&255); //@line 1424 "voices.cpp"
        var $cmp23=((($conv22))|0)==0; //@line 1424 "voices.cpp"
        if (!($cmp23)) { __label__ = 14;break $if_then4$$if_end41$7; } //@line 1424 "voices.cpp"
  
        var $age=(($voice_select2+13)&4294967295); //@line 1424 "voices.cpp"
        var $14=HEAPU8[($age)]; //@line 1424 "voices.cpp"
        var $conv24=((($14))&255); //@line 1424 "voices.cpp"
        var $cmp25=((($conv24))|0)==0; //@line 1424 "voices.cpp"
        if (!($cmp25)) { __label__ = 14;break $if_then4$$if_end41$7; } //@line 1424 "voices.cpp"
  
        var $variant=(($voice_select2+14)&4294967295); //@line 1424 "voices.cpp"
        var $15=HEAPU8[($variant)]; //@line 1424 "voices.cpp"
        var $conv27=((($15))&255); //@line 1424 "voices.cpp"
        var $cmp28=((($conv27))|0)==0; //@line 1424 "voices.cpp"
        if (!($cmp28)) { __label__ = 14;break $if_then4$$if_end41$7; } //@line 1424 "voices.cpp"
  
        var $16=$variant_name; //@line 1426 "voices.cpp"
        var $arrayidx30=(($16)&4294967295); //@line 1426 "voices.cpp"
        var $17=HEAP8[($arrayidx30)]; //@line 1426 "voices.cpp"
        var $conv31=(tempInt=(($17)),(tempInt>=128?tempInt-256:tempInt)); //@line 1426 "voices.cpp"
        var $cmp32=((($conv31))|0)!=0; //@line 1426 "voices.cpp"
        var $18=$vp; //@line 1428 "voices.cpp"
        var $identifier34=(($18+8)&4294967295); //@line 1428 "voices.cpp"
        var $19=HEAP32[(($identifier34)>>2)]; //@line 1428 "voices.cpp"
        if ($cmp32) { __label__ = 12;; } else { __label__ = 13;; } //@line 1426 "voices.cpp"
        if (__label__ == 12) {
  
          var $20=$variant_name; //@line 1428 "voices.cpp"
          var $arrayidx35=(($20+3)&4294967295); //@line 1428 "voices.cpp"
          var $call36=_sprintf(((__ZZ11SelectVoiceP12espeak_VOICEPiE8voice_id)&4294967295), ((__str71723)&4294967295), allocate([$19,0,0,0,$arrayidx35,0,0,0], ["i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 1428 "voices.cpp"
          $retval=((__ZZ11SelectVoiceP12espeak_VOICEPiE8voice_id)&4294967295); //@line 1429 "voices.cpp"
          __label__ = 53;break $if_then4$$if_end41$7; //@line 1429 "voices.cpp"
        }
        else if (__label__ == 13) {
  
          $retval=$19; //@line 1432 "voices.cpp"
          __label__ = 53;break $if_then4$$if_end41$7; //@line 1432 "voices.cpp"
        }
      }
    } while(0);
    if (__label__ == 14) {
  
      var $arraydecay=(($voices)&4294967295); //@line 1438 "voices.cpp"
      var $call42=__ZL14SetVoiceScoresP12espeak_VOICEPS0_i($voice_select2, $arraydecay, 0); //@line 1438 "voices.cpp"
      $nv=$call42; //@line 1438 "voices.cpp"
      var $cmp43=((($call42))|0)==0; //@line 1440 "voices.cpp"
      if ($cmp43) { __label__ = 15;; } else { __label__ = 17;; } //@line 1440 "voices.cpp"
      $if_then44$$if_end50$22: do { 
        if (__label__ == 15) {
  
          var $21=$found_addr; //@line 1443 "voices.cpp"
          HEAP32[(($21)>>2)]=0; //@line 1443 "voices.cpp"
          var $call45=__Z17SelectVoiceByNamePP12espeak_VOICEPKc(((__ZL11voices_list)&4294967295), ((__str45697)&4294967295)); //@line 1444 "voices.cpp"
          var $arrayidx46=(($voices)&4294967295); //@line 1444 "voices.cpp"
          HEAP32[(($arrayidx46)>>2)]=$call45; //@line 1444 "voices.cpp"
          var $cmp47=((($call45))|0)!=0; //@line 1444 "voices.cpp"
          if (!($cmp47)) { __label__ = 17;break $if_then44$$if_end50$22; } //@line 1444 "voices.cpp"
  
          $nv=1; //@line 1445 "voices.cpp"
          ; //@line 1445 "voices.cpp"
        }
      } while(0);
  
      $gender=0; //@line 1448 "voices.cpp"
      var $gender51=(($voice_select2+12)&4294967295); //@line 1449 "voices.cpp"
      var $22=HEAPU8[($gender51)]; //@line 1449 "voices.cpp"
      var $conv52=((($22))&255); //@line 1449 "voices.cpp"
      var $cmp53=((($conv52))|0)==2; //@line 1449 "voices.cpp"
      if ($cmp53) { __label__ = 20;; } else { __label__ = 18;; } //@line 1449 "voices.cpp"
      $if_then62$$lor_lhs_false54$26: do { 
        if (__label__ == 18) {
  
          var $age55=(($voice_select2+13)&4294967295); //@line 1449 "voices.cpp"
          var $23=HEAPU8[($age55)]; //@line 1449 "voices.cpp"
          var $conv56=((($23))&255); //@line 1449 "voices.cpp"
          var $cmp57=((($conv56))|0) > 0; //@line 1449 "voices.cpp"
          if ($cmp57) { __label__ = 19;; } else { __label__ = 21;; } //@line 1449 "voices.cpp"
          if (__label__ == 19) {
  
            var $age59=(($voice_select2+13)&4294967295); //@line 1449 "voices.cpp"
            var $24=HEAPU8[($age59)]; //@line 1449 "voices.cpp"
            var $conv60=((($24))&255); //@line 1449 "voices.cpp"
            var $cmp61=((($conv60))|0) < 13; //@line 1449 "voices.cpp"
            if ($cmp61) { __label__ = 20;break $if_then62$$lor_lhs_false54$26; } //@line 1449 "voices.cpp"
          }
  
          var $gender63=(($voice_select2+12)&4294967295); //@line 1452 "voices.cpp"
          var $25=HEAPU8[($gender63)]; //@line 1452 "voices.cpp"
          var $conv64=((($25))&255); //@line 1452 "voices.cpp"
          var $cmp65=((($conv64))|0)==1; //@line 1452 "voices.cpp"
          if (!($cmp65)) { __label__ = 23;break $if_then62$$lor_lhs_false54$26; } //@line 1452 "voices.cpp"
  
          $gender=1; //@line 1453 "voices.cpp"
          __label__ = 23;break $if_then62$$lor_lhs_false54$26; //@line 1453 "voices.cpp"
        }
      } while(0);
      if (__label__ == 20) {
  
        $gender=2; //@line 1450 "voices.cpp"
        ; //@line 1450 "voices.cpp"
      }
  
      var $age69=(($voice_select2+13)&4294967295); //@line 1456 "voices.cpp"
      var $26=HEAPU8[($age69)]; //@line 1456 "voices.cpp"
      var $conv70=((($26))&255); //@line 1456 "voices.cpp"
      var $cmp71=((($conv70))|0) < 60; //@line 1456 "voices.cpp"
      if ($cmp71) { __label__ = 24;; } else { __label__ = 25;; } //@line 1456 "voices.cpp"
      $if_end73_thread$$if_end73$35: do { 
        if (__label__ == 24) {
  
          $aged=0; //@line 1457 "voices.cpp"
          var $27=$gender; //@line 1459 "voices.cpp"
          var $arrayidx742=((_variant_lists+$27*4)&4294967295); //@line 1459 "voices.cpp"
          var $28=HEAP32[(($arrayidx742)>>2)]; //@line 1459 "voices.cpp"
          $p_start=$28; //@line 1459 "voices.cpp"
          $p=$28; //@line 1459 "voices.cpp"
          __label__ = 26;break $if_end73_thread$$if_end73$35; //@line 1460 "voices.cpp"
        }
        else if (__label__ == 25) {
  
          var $_pr=$aged; //@line 1460 "voices.cpp"
          var $29=$gender; //@line 1459 "voices.cpp"
          var $arrayidx74=((_variant_lists+$29*4)&4294967295); //@line 1459 "voices.cpp"
          var $30=HEAP32[(($arrayidx74)>>2)]; //@line 1459 "voices.cpp"
          $p_start=$30; //@line 1459 "voices.cpp"
          $p=$30; //@line 1459 "voices.cpp"
          var $cmp75=((($_pr))|0)==0; //@line 1460 "voices.cpp"
          if ($cmp75) { __label__ = 26;break $if_end73_thread$$if_end73$35; } else { __label__ = 27;break $if_end73_thread$$if_end73$35; } //@line 1460 "voices.cpp"
        }
      } while(0);
      if (__label__ == 26) {
  
        var $31=$p; //@line 1461 "voices.cpp"
        var $incdec_ptr=(($31+1)&4294967295); //@line 1461 "voices.cpp"
        $p=$incdec_ptr; //@line 1461 "voices.cpp"
        ; //@line 1461 "voices.cpp"
      }
  
      $n_variants=0; //@line 1464 "voices.cpp"
      $ix=0; //@line 1465 "voices.cpp"
      $ix2=0; //@line 1465 "voices.cpp"
      var $32=$ix; //@line 1465 "voices.cpp"
      var $33=$nv; //@line 1465 "voices.cpp"
      var $cmp786=((($32))|0) < ((($33))|0); //@line 1465 "voices.cpp"
      if ($cmp786) { __label__ = 28;; } else { __label__ = 44;; } //@line 1465 "voices.cpp"
      $for_body$$while_cond$41: do { 
        if (__label__ == 28) {
          $for_body$42: while(1) { 
  
            var $34=$ix; //@line 1467 "voices.cpp"
            var $arrayidx79=(($voices+$34*4)&4294967295); //@line 1467 "voices.cpp"
            var $35=HEAP32[(($arrayidx79)>>2)]; //@line 1467 "voices.cpp"
            $vp=$35; //@line 1467 "voices.cpp"
            $skip=0; //@line 1469 "voices.cpp"
            var $36=$gender; //@line 1470 "voices.cpp"
            var $cmp80=((($36))|0)!=0; //@line 1470 "voices.cpp"
            if ($cmp80) { __label__ = 29;; } else { __label__ = 31;; } //@line 1470 "voices.cpp"
            $land_lhs_true81$$if_end86$44: do { 
              if (__label__ == 29) {
  
                var $37=$vp; //@line 1470 "voices.cpp"
                var $gender82=(($37+12)&4294967295); //@line 1470 "voices.cpp"
                var $38=HEAPU8[($gender82)]; //@line 1470 "voices.cpp"
                var $conv83=((($38))&255); //@line 1470 "voices.cpp"
                var $39=$gender; //@line 1470 "voices.cpp"
                var $cmp84=((($conv83))|0)!=((($39))|0); //@line 1470 "voices.cpp"
                if (!($cmp84)) { __label__ = 31;break $land_lhs_true81$$if_end86$44; } //@line 1470 "voices.cpp"
  
                $skip=1; //@line 1472 "voices.cpp"
                ; //@line 1473 "voices.cpp"
              }
            } while(0);
  
            var $40=$ix2; //@line 1474 "voices.cpp"
            var $cmp87=((($40))|0)==0; //@line 1474 "voices.cpp"
            if ($cmp87) { __label__ = 32;; } else { __label__ = 35;; } //@line 1474 "voices.cpp"
            $land_lhs_true88$$if_end94$48: do { 
              if (__label__ == 32) {
  
                var $41=$aged; //@line 1474 "voices.cpp"
                var $tobool=((($41))|0)!=0; //@line 1474 "voices.cpp"
                if (!($tobool)) { __label__ = 35;break $land_lhs_true88$$if_end94$48; } //@line 1474 "voices.cpp"
  
                var $42=$vp; //@line 1474 "voices.cpp"
                var $age90=(($42+13)&4294967295); //@line 1474 "voices.cpp"
                var $43=HEAPU8[($age90)]; //@line 1474 "voices.cpp"
                var $conv91=((($43))&255); //@line 1474 "voices.cpp"
                var $cmp92=((($conv91))|0) < 60; //@line 1474 "voices.cpp"
                if (!($cmp92)) { __label__ = 35;break $land_lhs_true88$$if_end94$48; } //@line 1474 "voices.cpp"
  
                $skip=1; //@line 1476 "voices.cpp"
                __label__ = 37;break $land_lhs_true88$$if_end94$48; //@line 1478 "voices.cpp"
              }
            } while(0);
            $if_end98$$if_end94$52: do { 
              if (__label__ == 35) {
  
                var $_pr4=$skip; //@line 1478 "voices.cpp"
                var $cmp95=((($_pr4))|0)==0; //@line 1478 "voices.cpp"
                if (!($cmp95)) { __label__ = 37;break $if_end98$$if_end94$52; } //@line 1478 "voices.cpp"
  
                var $44=$vp; //@line 1480 "voices.cpp"
                var $45=$ix2; //@line 1480 "voices.cpp"
                var $inc=((($45)+1)&4294967295); //@line 1480 "voices.cpp"
                $ix2=$inc; //@line 1480 "voices.cpp"
                var $arrayidx97=(($voices2+$45*4)&4294967295); //@line 1480 "voices.cpp"
                HEAP32[(($arrayidx97)>>2)]=$44; //@line 1480 "voices.cpp"
                ; //@line 1481 "voices.cpp"
              }
            } while(0);
  
            $j=0; //@line 1483 "voices.cpp"
            ; //@line 1483 "voices.cpp"
            while(1) { 
  
              var $46=$j; //@line 1483 "voices.cpp"
              var $47=$vp; //@line 1483 "voices.cpp"
              var $xx1=(($47+15)&4294967295); //@line 1483 "voices.cpp"
              var $48=HEAPU8[($xx1)]; //@line 1483 "voices.cpp"
              var $conv100=((($48))&255); //@line 1483 "voices.cpp"
              var $cmp101=((($46))|0) < ((($conv100))|0); //@line 1483 "voices.cpp"
              if (!($cmp101)) { __label__ = 43;break ; } //@line 1483 "voices.cpp"
  
              var $49=$n_variants; //@line 1483 "voices.cpp"
              var $cmp102=((($49))|0) < 12; //@line 1483 "voices.cpp"
              if (!($cmp102)) { __label__ = 43;break ; }
  
              var $50=$p; //@line 1485 "voices.cpp"
              var $51=HEAP8[($50)]; //@line 1485 "voices.cpp"
              var $conv104=(tempInt=(($51)),(tempInt>=128?tempInt-256:tempInt)); //@line 1485 "voices.cpp"
              $variant_number=$conv104; //@line 1485 "voices.cpp"
              var $cmp105=((($conv104))|0)==0; //@line 1485 "voices.cpp"
              if ($cmp105) { __label__ = 41;; } else { __label__ = 42;; } //@line 1485 "voices.cpp"
              if (__label__ == 41) {
  
                var $52=$p_start; //@line 1487 "voices.cpp"
                $p=$52; //@line 1487 "voices.cpp"
                __label__ = 38;continue ; //@line 1488 "voices.cpp"
              }
              else if (__label__ == 42) {
  
                var $53=$n_variants; //@line 1491 "voices.cpp"
                var $inc108=((($53)+1)&4294967295); //@line 1491 "voices.cpp"
                $n_variants=$inc108; //@line 1491 "voices.cpp"
                var $arrayidx109=((__ZZ11SelectVoiceP12espeak_VOICEPiE14voice_variants+$53*24)&4294967295); //@line 1491 "voices.cpp"
                $vp2=$arrayidx109; //@line 1491 "voices.cpp"
                var $54=$vp2; //@line 1492 "voices.cpp"
                var $55=$54; //@line 1492 "voices.cpp"
                var $56=$vp; //@line 1492 "voices.cpp"
                var $57=$56; //@line 1492 "voices.cpp"
                var $src$, $dest$, $stop$, $stop4$, $fast$;
                $src$ = $57;
                $dest$ = $55;
                $stop$ = $src$ + 24;
                if (($dest$%4) == ($src$%4) && 24 > 8) {
                  while ($src$%4 !== 0 && $src$ < $stop$) {
                    ; HEAP8[$dest$++] = HEAP8[$src$++];
                  }
                  $src$ >>= 2;
                  $dest$ >>= 2;
                  $stop4$ = $stop$ >> 2;
                  while ($src$ < $stop4$) {
                ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
                  }
                  $src$ <<= 2;
                  $dest$ <<= 2;
                }while ($src$ < $stop$) {
                  ; HEAP8[$dest$++] = HEAP8[$src$++];
                }; //@line 1492 "voices.cpp"
                var $58=$variant_number; //@line 1493 "voices.cpp"
                var $conv110=((($58)) & 255); //@line 1493 "voices.cpp"
                var $59=$vp2; //@line 1493 "voices.cpp"
                var $variant111=(($59+14)&4294967295); //@line 1493 "voices.cpp"
                HEAP8[($variant111)]=$conv110; //@line 1493 "voices.cpp"
                var $60=$vp2; //@line 1494 "voices.cpp"
                var $61=$ix2; //@line 1494 "voices.cpp"
                var $inc112=((($61)+1)&4294967295); //@line 1494 "voices.cpp"
                $ix2=$inc112; //@line 1494 "voices.cpp"
                var $arrayidx113=(($voices2+$61*4)&4294967295); //@line 1494 "voices.cpp"
                HEAP32[(($arrayidx113)>>2)]=$60; //@line 1494 "voices.cpp"
                var $62=$p; //@line 1495 "voices.cpp"
                var $incdec_ptr114=(($62+1)&4294967295); //@line 1495 "voices.cpp"
                $p=$incdec_ptr114; //@line 1495 "voices.cpp"
                var $63=$j; //@line 1496 "voices.cpp"
                var $inc115=((($63)+1)&4294967295); //@line 1496 "voices.cpp"
                $j=$inc115; //@line 1496 "voices.cpp"
                __label__ = 38;continue ; //@line 1497 "voices.cpp"
              }
            }
  
            var $64=$ix; //@line 1465 "voices.cpp"
            var $inc116=((($64)+1)&4294967295); //@line 1465 "voices.cpp"
            $ix=$inc116; //@line 1465 "voices.cpp"
            var $65=$ix; //@line 1465 "voices.cpp"
            var $66=$nv; //@line 1465 "voices.cpp"
            var $cmp78=((($65))|0) < ((($66))|0); //@line 1465 "voices.cpp"
            if ($cmp78) { __label__ = 28;continue $for_body$42; } else { __label__ = 44;break $for_body$$while_cond$41; } //@line 1465 "voices.cpp"
          }
        }
      } while(0);
      while(1) { 
  
        var $67=$vp; //@line 1500 "voices.cpp"
        var $cmp118=((($67))|0)!=0; //@line 1500 "voices.cpp"
        if (!($cmp118)) { __label__ = 48;break ; } //@line 1500 "voices.cpp"
  
        var $68=$p; //@line 1500 "voices.cpp"
        var $incdec_ptr120=(($68+1)&4294967295); //@line 1500 "voices.cpp"
        $p=$incdec_ptr120; //@line 1500 "voices.cpp"
        var $69=HEAP8[($68)]; //@line 1500 "voices.cpp"
        var $conv121=(tempInt=(($69)),(tempInt>=128?tempInt-256:tempInt)); //@line 1500 "voices.cpp"
        $variant_number=$conv121; //@line 1500 "voices.cpp"
        var $cmp122=((($conv121))|0)!=0; //@line 1500 "voices.cpp"
        if (!($cmp122)) { __label__ = 48;break ; } //@line 1500 "voices.cpp"
  
        var $70=$n_variants; //@line 1500 "voices.cpp"
        var $cmp124=((($70))|0) < 12; //@line 1500 "voices.cpp"
        if (!($cmp124)) { __label__ = 48;break ; }
  
        var $71=$n_variants; //@line 1502 "voices.cpp"
        var $inc126=((($71)+1)&4294967295); //@line 1502 "voices.cpp"
        $n_variants=$inc126; //@line 1502 "voices.cpp"
        var $arrayidx127=((__ZZ11SelectVoiceP12espeak_VOICEPiE14voice_variants+$71*24)&4294967295); //@line 1502 "voices.cpp"
        $vp2=$arrayidx127; //@line 1502 "voices.cpp"
        var $72=$vp2; //@line 1503 "voices.cpp"
        var $73=$72; //@line 1503 "voices.cpp"
        var $74=$vp; //@line 1503 "voices.cpp"
        var $75=$74; //@line 1503 "voices.cpp"
        var $src$, $dest$, $stop$, $stop4$, $fast$;
        $src$ = $75;
        $dest$ = $73;
        $stop$ = $src$ + 24;
        if (($dest$%4) == ($src$%4) && 24 > 8) {
          while ($src$%4 !== 0 && $src$ < $stop$) {
            ; HEAP8[$dest$++] = HEAP8[$src$++];
          }
          $src$ >>= 2;
          $dest$ >>= 2;
          $stop4$ = $stop$ >> 2;
          while ($src$ < $stop4$) {
        ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
          }
          $src$ <<= 2;
          $dest$ <<= 2;
        }while ($src$ < $stop$) {
          ; HEAP8[$dest$++] = HEAP8[$src$++];
        }; //@line 1503 "voices.cpp"
        var $76=$variant_number; //@line 1504 "voices.cpp"
        var $conv128=((($76)) & 255); //@line 1504 "voices.cpp"
        var $77=$vp2; //@line 1504 "voices.cpp"
        var $variant129=(($77+14)&4294967295); //@line 1504 "voices.cpp"
        HEAP8[($variant129)]=$conv128; //@line 1504 "voices.cpp"
        var $78=$vp2; //@line 1505 "voices.cpp"
        var $79=$ix2; //@line 1505 "voices.cpp"
        var $inc130=((($79)+1)&4294967295); //@line 1505 "voices.cpp"
        $ix2=$inc130; //@line 1505 "voices.cpp"
        var $arrayidx131=(($voices2+$79*4)&4294967295); //@line 1505 "voices.cpp"
        HEAP32[(($arrayidx131)>>2)]=$78; //@line 1505 "voices.cpp"
        __label__ = 44;continue ; //@line 1506 "voices.cpp"
      }
  
      var $80=$ix2; //@line 1509 "voices.cpp"
      var $cmp132=((($80))|0)==0; //@line 1509 "voices.cpp"
      if ($cmp132) { __label__ = 49;; } else { __label__ = 50;; } //@line 1509 "voices.cpp"
      if (__label__ == 49) {
  
        $retval=0; //@line 1510 "voices.cpp"
        ; //@line 1510 "voices.cpp"
      }
      else if (__label__ == 50) {
  
        var $variant135=(($voice_select2+14)&4294967295); //@line 1511 "voices.cpp"
        var $81=HEAPU8[($variant135)]; //@line 1511 "voices.cpp"
        var $conv136=((($81))&255); //@line 1511 "voices.cpp"
        var $82=$ix2; //@line 1511 "voices.cpp"
        var $rem=((($conv136))|0)%((($82))|0); //@line 1511 "voices.cpp"
        var $arrayidx137=(($voices2+$rem*4)&4294967295); //@line 1511 "voices.cpp"
        var $83=HEAP32[(($arrayidx137)>>2)]; //@line 1511 "voices.cpp"
        $vp=$83; //@line 1511 "voices.cpp"
        var $84=$vp; //@line 1513 "voices.cpp"
        var $variant138=(($84+14)&4294967295); //@line 1513 "voices.cpp"
        var $85=HEAPU8[($variant138)]; //@line 1513 "voices.cpp"
        var $conv139=((($85))&255); //@line 1513 "voices.cpp"
        var $cmp140=((($conv139))|0)!=0; //@line 1513 "voices.cpp"
        var $86=$vp; //@line 1515 "voices.cpp"
        if ($cmp140) { __label__ = 51;; } else { __label__ = 52;; } //@line 1513 "voices.cpp"
        if (__label__ == 51) {
  
          var $variant142=(($86+14)&4294967295); //@line 1515 "voices.cpp"
          var $87=HEAPU8[($variant142)]; //@line 1515 "voices.cpp"
          var $conv143=((($87))&255); //@line 1515 "voices.cpp"
          __ZL23ExtractVoiceVariantNamePci(0, $conv143); //@line 1515 "voices.cpp"
          $variant_name=((__ZZL23ExtractVoiceVariantNamePciE12variant_name)&4294967295); //@line 1515 "voices.cpp"
          var $88=$vp; //@line 1516 "voices.cpp"
          var $identifier145=(($88+8)&4294967295); //@line 1516 "voices.cpp"
          var $89=HEAP32[(($identifier145)>>2)]; //@line 1516 "voices.cpp"
          var $90=$variant_name; //@line 1516 "voices.cpp"
          var $arrayidx146=(($90+3)&4294967295); //@line 1516 "voices.cpp"
          var $call147=_sprintf(((__ZZ11SelectVoiceP12espeak_VOICEPiE8voice_id)&4294967295), ((__str71723)&4294967295), allocate([$89,0,0,0,$arrayidx146,0,0,0], ["i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 1516 "voices.cpp"
          $retval=((__ZZ11SelectVoiceP12espeak_VOICEPiE8voice_id)&4294967295); //@line 1517 "voices.cpp"
          ; //@line 1517 "voices.cpp"
        }
        else if (__label__ == 52) {
  
          var $identifier149=(($86+8)&4294967295); //@line 1520 "voices.cpp"
          var $91=HEAP32[(($identifier149)>>2)]; //@line 1520 "voices.cpp"
          $retval=$91; //@line 1520 "voices.cpp"
          ; //@line 1520 "voices.cpp"
        }
      }
    }
  
    var $92=$retval; //@line 1521 "voices.cpp"
    STACKTOP = __stackBase__;
    return $92; //@line 1521 "voices.cpp"
    return null;
  }
  

  function __ZL14SetVoiceScoresP12espeak_VOICEPS0_i($voice_select, $voices, $control) {
    var __stackBase__  = STACKTOP; STACKTOP += 80; _memset(__stackBase__, 0, 80);
    var __label__;
  
    var $retval;
    var $voice_select_addr;
    var $voices_addr;
    var $control_addr;
    var $ix;
    var $score;
    var $nv;
    var $n_parts;
    var $lang_len;
    var $vp;
    var $language=__stackBase__;
    $voice_select_addr=$voice_select;
    $voices_addr=$voices;
    $control_addr=$control;
    $n_parts=0; //@line 1277 "voices.cpp"
    $lang_len=0; //@line 1278 "voices.cpp"
    var $0=$voice_select_addr; //@line 1283 "voices.cpp"
    var $languages=(($0+4)&4294967295); //@line 1283 "voices.cpp"
    var $1=HEAP32[(($languages)>>2)]; //@line 1283 "voices.cpp"
    var $cmp=((($1))|0)!=0; //@line 1283 "voices.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 6;; } //@line 1283 "voices.cpp"
    $land_lhs_true$$if_end16$2: do { 
      if (__label__ == 1) {
  
        var $2=$voice_select_addr; //@line 1283 "voices.cpp"
        var $languages1=(($2+4)&4294967295); //@line 1283 "voices.cpp"
        var $3=HEAP32[(($languages1)>>2)]; //@line 1283 "voices.cpp"
        var $arrayidx=(($3)&4294967295); //@line 1283 "voices.cpp"
        var $4=HEAP8[($arrayidx)]; //@line 1283 "voices.cpp"
        var $conv=(tempInt=(($4)),(tempInt>=128?tempInt-256:tempInt)); //@line 1283 "voices.cpp"
        var $cmp2=((($conv))|0)!=0; //@line 1283 "voices.cpp"
        if (!($cmp2)) { __label__ = 6;break $land_lhs_true$$if_end16$2; } //@line 1283 "voices.cpp"
  
        $n_parts=1; //@line 1285 "voices.cpp"
        var $5=$voice_select_addr; //@line 1286 "voices.cpp"
        var $languages3=(($5+4)&4294967295); //@line 1286 "voices.cpp"
        var $6=HEAP32[(($languages3)>>2)]; //@line 1286 "voices.cpp"
        var $call=_strlen($6); //@line 1286 "voices.cpp"
        $lang_len=$call; //@line 1286 "voices.cpp"
        $ix=0; //@line 1287 "voices.cpp"
        var $7=$ix; //@line 1287 "voices.cpp"
        var $8=$lang_len; //@line 1287 "voices.cpp"
        var $cmp42=((($7))|0) <= ((($8))|0); //@line 1287 "voices.cpp"
        var $9=$ix; //@line 1287 "voices.cpp"
        var $cmp53=((($9))>>>0) < 80; //@line 1287 "voices.cpp"
        var $or_cond4=($cmp42) & ($cmp53); //@line 1287 "voices.cpp"
        if (!($or_cond4)) { __label__ = 6;break $land_lhs_true$$if_end16$2; } //@line 1287 "voices.cpp"
        while(1) { 
  
          var $10=$ix; //@line 1289 "voices.cpp"
          var $11=$voice_select_addr; //@line 1289 "voices.cpp"
          var $languages6=(($11+4)&4294967295); //@line 1289 "voices.cpp"
          var $12=HEAP32[(($languages6)>>2)]; //@line 1289 "voices.cpp"
          var $arrayidx7=(($12+$10)&4294967295); //@line 1289 "voices.cpp"
          var $13=HEAP8[($arrayidx7)]; //@line 1289 "voices.cpp"
          var $conv8=(tempInt=(($13)),(tempInt>=128?tempInt-256:tempInt)); //@line 1289 "voices.cpp"
          var $call9=_tolower($conv8); //@line 1289 "voices.cpp"
          var $conv10=((($call9)) & 255); //@line 1289 "voices.cpp"
          var $14=$ix; //@line 1289 "voices.cpp"
          var $arrayidx11=(($language+$14)&4294967295); //@line 1289 "voices.cpp"
          HEAP8[($arrayidx11)]=$conv10; //@line 1289 "voices.cpp"
          var $conv12=(tempInt=(($conv10)),(tempInt>=128?tempInt-256:tempInt)); //@line 1289 "voices.cpp"
          var $cmp13=((($conv12))|0)==45; //@line 1289 "voices.cpp"
          if ($cmp13) { __label__ = 4;; } else { __label__ = 5;; } //@line 1289 "voices.cpp"
          if (__label__ == 4) {
  
            var $15=$n_parts; //@line 1290 "voices.cpp"
            var $inc=((($15)+1)&4294967295); //@line 1290 "voices.cpp"
            $n_parts=$inc; //@line 1290 "voices.cpp"
            ; //@line 1290 "voices.cpp"
          }
  
          var $16=$ix; //@line 1287 "voices.cpp"
          var $inc15=((($16)+1)&4294967295); //@line 1287 "voices.cpp"
          $ix=$inc15; //@line 1287 "voices.cpp"
          var $17=$ix; //@line 1287 "voices.cpp"
          var $18=$lang_len; //@line 1287 "voices.cpp"
          var $cmp4=((($17))|0) <= ((($18))|0); //@line 1287 "voices.cpp"
          var $19=$ix; //@line 1287 "voices.cpp"
          var $cmp5=((($19))>>>0) < 80; //@line 1287 "voices.cpp"
          var $or_cond=($cmp4) & ($cmp5); //@line 1287 "voices.cpp"
          if ($or_cond) { __label__ = 3;continue ; } else { __label__ = 6;break $land_lhs_true$$if_end16$2; } //@line 1287 "voices.cpp"
        }
      }
    } while(0);
  
    $nv=0; //@line 1294 "voices.cpp"
    $ix=0; //@line 1295 "voices.cpp"
    var $20=$ix; //@line 1295 "voices.cpp"
    var $21=HEAP32[((__ZL13n_voices_list)>>2)]; //@line 1295 "voices.cpp"
    var $cmp181=((($20))|0) < ((($21))|0); //@line 1295 "voices.cpp"
    if ($cmp181) { __label__ = 7;; } else { __label__ = 13;; } //@line 1295 "voices.cpp"
    $for_body19_lr_ph$$for_end37$11: do { 
      if (__label__ == 7) {
  
        var $arraydecay=(($language)&4294967295); //@line 1302 "voices.cpp"
        ; //@line 1295 "voices.cpp"
        $for_body19$13: while(1) { 
  
          var $22=$ix; //@line 1297 "voices.cpp"
          var $arrayidx20=((__ZL11voices_list+$22*4)&4294967295); //@line 1297 "voices.cpp"
          var $23=HEAP32[(($arrayidx20)>>2)]; //@line 1297 "voices.cpp"
          $vp=$23; //@line 1297 "voices.cpp"
          var $24=$control_addr; //@line 1299 "voices.cpp"
          var $and=($24) & 1; //@line 1299 "voices.cpp"
          var $cmp21=((($and))|0)==0; //@line 1299 "voices.cpp"
          if ($cmp21) { __label__ = 9;; } else { __label__ = 10;; } //@line 1299 "voices.cpp"
          $land_lhs_true22$$if_end26$15: do { 
            if (__label__ == 9) {
  
              var $25=$vp; //@line 1299 "voices.cpp"
              var $identifier=(($25+8)&4294967295); //@line 1299 "voices.cpp"
              var $26=HEAP32[(($identifier)>>2)]; //@line 1299 "voices.cpp"
              var $call23=_memcmp($26, ((__str73725)&4294967295), 3); //@line 1299 "voices.cpp"
              var $cmp24=((($call23))|0)==0; //@line 1299 "voices.cpp"
              if ($cmp24) { __label__ = 12;break $land_lhs_true22$$if_end26$15; } else { __label__ = 10;break $land_lhs_true22$$if_end26$15; } //@line 1299 "voices.cpp"
            }
          } while(0);
          $for_inc35$$if_end26$17: do { 
            if (__label__ == 10) {
  
              var $27=$voice_select_addr; //@line 1302 "voices.cpp"
              var $28=$n_parts; //@line 1302 "voices.cpp"
              var $29=$lang_len; //@line 1302 "voices.cpp"
              var $30=$ix; //@line 1302 "voices.cpp"
              var $arrayidx27=((__ZL11voices_list+$30*4)&4294967295); //@line 1302 "voices.cpp"
              var $31=HEAP32[(($arrayidx27)>>2)]; //@line 1302 "voices.cpp"
              var $call28=__ZL10ScoreVoiceP12espeak_VOICEPKciiS0_($27, $arraydecay, $28, $29, $31); //@line 1302 "voices.cpp"
              $score=$call28; //@line 1302 "voices.cpp"
              var $cmp29=((($call28))|0) > 0; //@line 1302 "voices.cpp"
              if (!($cmp29)) { __label__ = 12;break $for_inc35$$if_end26$17; } //@line 1302 "voices.cpp"
  
              var $32=$vp; //@line 1304 "voices.cpp"
              var $33=$nv; //@line 1304 "voices.cpp"
              var $inc31=((($33)+1)&4294967295); //@line 1304 "voices.cpp"
              $nv=$inc31; //@line 1304 "voices.cpp"
              var $34=$voices_addr; //@line 1304 "voices.cpp"
              var $arrayidx32=(($34+4*$33)&4294967295); //@line 1304 "voices.cpp"
              HEAP32[(($arrayidx32)>>2)]=$32; //@line 1304 "voices.cpp"
              var $35=$score; //@line 1305 "voices.cpp"
              var $36=$vp; //@line 1305 "voices.cpp"
              var $score33=(($36+16)&4294967295); //@line 1305 "voices.cpp"
              HEAP32[(($score33)>>2)]=$35; //@line 1305 "voices.cpp"
              ; //@line 1306 "voices.cpp"
            }
          } while(0);
  
          var $37=$ix; //@line 1295 "voices.cpp"
          var $inc36=((($37)+1)&4294967295); //@line 1295 "voices.cpp"
          $ix=$inc36; //@line 1295 "voices.cpp"
          var $38=$ix; //@line 1295 "voices.cpp"
          var $39=HEAP32[((__ZL13n_voices_list)>>2)]; //@line 1295 "voices.cpp"
          var $cmp18=((($38))|0) < ((($39))|0); //@line 1295 "voices.cpp"
          if ($cmp18) { __label__ = 8;continue $for_body19$13; } else { __label__ = 13;break $for_body19_lr_ph$$for_end37$11; } //@line 1295 "voices.cpp"
        }
      }
    } while(0);
  
    var $40=$nv; //@line 1308 "voices.cpp"
    var $41=$voices_addr; //@line 1308 "voices.cpp"
    var $arrayidx38=(($41+4*$40)&4294967295); //@line 1308 "voices.cpp"
    HEAP32[(($arrayidx38)>>2)]=0; //@line 1308 "voices.cpp"
    var $42=$nv; //@line 1310 "voices.cpp"
    var $cmp39=((($42))|0)==0; //@line 1310 "voices.cpp"
    if ($cmp39) { __label__ = 14;; } else { __label__ = 15;; } //@line 1310 "voices.cpp"
    if (__label__ == 14) {
  
      $retval=0; //@line 1311 "voices.cpp"
      ; //@line 1311 "voices.cpp"
    }
    else if (__label__ == 15) {
  
      var $43=$voices_addr; //@line 1314 "voices.cpp"
      var $44=$43; //@line 1314 "voices.cpp"
      var $45=$nv; //@line 1314 "voices.cpp"
      _qsort($44, $45, 4, 8); //@line 1314 "voices.cpp"
      var $46=$nv; //@line 1316 "voices.cpp"
      $retval=$46; //@line 1316 "voices.cpp"
      ; //@line 1316 "voices.cpp"
    }
  
    var $47=$retval; //@line 1317 "voices.cpp"
    STACKTOP = __stackBase__;
    return $47; //@line 1317 "voices.cpp"
    return null;
  }
  

  function __Z14SetVoiceByNamePKc($name) {
    var __stackBase__  = STACKTOP; STACKTOP += 24; _memset(__stackBase__, 0, 24);
    var __label__;
  
    var $retval;
    var $name_addr;
    var $v;
    var $voice_selector=__stackBase__;
    var $variant_name;
    $name_addr=$name;
    var $0=$name_addr; //@line 1673 "voices.cpp"
    __Z8strncpy0PcPKci(((__ZZ14SetVoiceByNamePKcE3buf)&4294967295), $0, 60); //@line 1673 "voices.cpp"
    __ZL23ExtractVoiceVariantNamePci(((__ZZ14SetVoiceByNamePKcE3buf)&4294967295), 0); //@line 1674 "voices.cpp"
    $variant_name=((__ZZL23ExtractVoiceVariantNamePciE12variant_name)&4294967295); //@line 1674 "voices.cpp"
    var $1=$voice_selector; //@line 1676 "voices.cpp"
    var $dest$, $stop$, $stop4$, $fast$, $value4$;
    $dest$ = $1;
    $stop$ = $dest$ + 24;
    $value4$ = 0;
    if ($value4$ < 0) $value4$ += 256;
    $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
    while ($dest$%4 !== 0 && $dest$ < $stop$) {
      ;; HEAP8[$dest$++] = 0;
    }
    $dest$ >>= 2;
    $stop4$ = $stop$ >> 2;
    while ($dest$ < $stop4$) {
    ;;;;;;;  HEAP32[$dest$++] = $value4$;
    }
    $dest$ <<= 2;
    while ($dest$ < $stop$) {
      ;; HEAP8[$dest$++] = 0;
    }; //@line 1676 "voices.cpp"
    var $2=$name_addr; //@line 1678 "voices.cpp"
    var $name1=(($voice_selector)&4294967295); //@line 1678 "voices.cpp"
    HEAP32[(($name1)>>2)]=$2; //@line 1678 "voices.cpp"
    var $call2=__Z9LoadVoicePKci(((__ZZ14SetVoiceByNamePKcE3buf)&4294967295), 1); //@line 1683 "voices.cpp"
    var $cmp=((($call2))|0)!=0; //@line 1683 "voices.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 4;; } //@line 1683 "voices.cpp"
    $if_then$$if_end6$2: do { 
      if (__label__ == 1) {
  
        var $3=$variant_name; //@line 1685 "voices.cpp"
        var $arrayidx=(($3)&4294967295); //@line 1685 "voices.cpp"
        var $4=HEAP8[($arrayidx)]; //@line 1685 "voices.cpp"
        var $conv=(tempInt=(($4)),(tempInt>=128?tempInt-256:tempInt)); //@line 1685 "voices.cpp"
        var $cmp3=((($conv))|0)!=0; //@line 1685 "voices.cpp"
        if ($cmp3) { __label__ = 2;; } else { __label__ = 3;; } //@line 1685 "voices.cpp"
        if (__label__ == 2) {
  
          var $5=$variant_name; //@line 1687 "voices.cpp"
          var $call5=__Z9LoadVoicePKci($5, 2); //@line 1687 "voices.cpp"
          ; //@line 1688 "voices.cpp"
        }
  
        var $6=HEAP32[((_voice)>>2)]; //@line 1690 "voices.cpp"
        __Z13DoVoiceChangeP7voice_t($6); //@line 1690 "voices.cpp"
        __Z13SetVoiceStackP12espeak_VOICE($voice_selector); //@line 1691 "voices.cpp"
        $retval=0; //@line 1692 "voices.cpp"
        ; //@line 1692 "voices.cpp"
      }
      else if (__label__ == 4) {
  
        var $7=HEAP32[((__ZL13n_voices_list)>>2)]; //@line 1695 "voices.cpp"
        var $cmp7=((($7))|0)==0; //@line 1695 "voices.cpp"
        if ($cmp7) { __label__ = 5;; } else { __label__ = 6;; } //@line 1695 "voices.cpp"
        if (__label__ == 5) {
  
          var $call9=_espeak_ListVoices(0); //@line 1696 "voices.cpp"
          ; //@line 1696 "voices.cpp"
        }
  
        var $call11=__Z17SelectVoiceByNamePP12espeak_VOICEPKc(((__ZL11voices_list)&4294967295), ((__ZZ14SetVoiceByNamePKcE3buf)&4294967295)); //@line 1698 "voices.cpp"
        $v=$call11; //@line 1698 "voices.cpp"
        var $cmp12=((($call11))|0)!=0; //@line 1698 "voices.cpp"
        if ($cmp12) { __label__ = 7;; } else { __label__ = 11;; } //@line 1698 "voices.cpp"
        $if_then13$$if_end24$11: do { 
          if (__label__ == 7) {
  
            var $8=$v; //@line 1700 "voices.cpp"
            var $identifier=(($8+8)&4294967295); //@line 1700 "voices.cpp"
            var $9=HEAP32[(($identifier)>>2)]; //@line 1700 "voices.cpp"
            var $call14=__Z9LoadVoicePKci($9, 0); //@line 1700 "voices.cpp"
            var $cmp15=((($call14))|0)!=0; //@line 1700 "voices.cpp"
            if (!($cmp15)) { __label__ = 11;break $if_then13$$if_end24$11; } //@line 1700 "voices.cpp"
  
            var $10=$variant_name; //@line 1702 "voices.cpp"
            var $arrayidx17=(($10)&4294967295); //@line 1702 "voices.cpp"
            var $11=HEAP8[($arrayidx17)]; //@line 1702 "voices.cpp"
            var $conv18=(tempInt=(($11)),(tempInt>=128?tempInt-256:tempInt)); //@line 1702 "voices.cpp"
            var $cmp19=((($conv18))|0)!=0; //@line 1702 "voices.cpp"
            if ($cmp19) { __label__ = 9;; } else { __label__ = 10;; } //@line 1702 "voices.cpp"
            if (__label__ == 9) {
  
              var $12=$variant_name; //@line 1704 "voices.cpp"
              var $call21=__Z9LoadVoicePKci($12, 2); //@line 1704 "voices.cpp"
              ; //@line 1705 "voices.cpp"
            }
  
            var $13=HEAP32[((_voice)>>2)]; //@line 1706 "voices.cpp"
            __Z13DoVoiceChangeP7voice_t($13); //@line 1706 "voices.cpp"
            __Z13SetVoiceStackP12espeak_VOICE($voice_selector); //@line 1707 "voices.cpp"
            $retval=0; //@line 1708 "voices.cpp"
            __label__ = 12;break $if_then$$if_end6$2; //@line 1708 "voices.cpp"
          }
        } while(0);
  
        $retval=-1; //@line 1711 "voices.cpp"
        ; //@line 1711 "voices.cpp"
      }
    } while(0);
  
    var $14=$retval; //@line 1712 "voices.cpp"
    STACKTOP = __stackBase__;
    return $14; //@line 1712 "voices.cpp"
    return null;
  }
  

  function __Z20SetVoiceByPropertiesP12espeak_VOICE($voice_selector) {
    var __stackBase__  = STACKTOP; STACKTOP += 4; _memset(__stackBase__, 0, 4);
    var __label__;
  
    var $retval;
    var $voice_selector_addr;
    var $voice_id;
    var $voice_found=__stackBase__;
    $voice_selector_addr=$voice_selector;
    var $0=$voice_selector_addr; //@line 1721 "voices.cpp"
    var $call=__Z11SelectVoiceP12espeak_VOICEPi($0, $voice_found); //@line 1721 "voices.cpp"
    $voice_id=$call; //@line 1721 "voices.cpp"
    var $1=HEAP32[(($voice_found)>>2)]; //@line 1723 "voices.cpp"
    var $cmp=((($1))|0)==0; //@line 1723 "voices.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 1723 "voices.cpp"
    if (__label__ == 1) {
  
      $retval=2; //@line 1724 "voices.cpp"
      ; //@line 1724 "voices.cpp"
    }
    else if (__label__ == 2) {
  
      var $2=$voice_id; //@line 1726 "voices.cpp"
      var $call1=__Z16LoadVoiceVariantPKci($2, 0); //@line 1726 "voices.cpp"
      var $3=HEAP32[((_voice)>>2)]; //@line 1727 "voices.cpp"
      __Z13DoVoiceChangeP7voice_t($3); //@line 1727 "voices.cpp"
      var $4=$voice_selector_addr; //@line 1728 "voices.cpp"
      __Z13SetVoiceStackP12espeak_VOICE($4); //@line 1728 "voices.cpp"
      $retval=0; //@line 1730 "voices.cpp"
      ; //@line 1730 "voices.cpp"
    }
  
    var $5=$retval; //@line 1731 "voices.cpp"
    STACKTOP = __stackBase__;
    return $5; //@line 1731 "voices.cpp"
    return null;
  }
  

  function __ZL9GetVoicesPKc($path) {
    var __stackBase__  = STACKTOP; STACKTOP += 252; _memset(__stackBase__, 0, 252);
    var __label__;
    var __lastLabel__ = null;
  
    var $path_addr;
    var $f_voice;
    var $voice_data;
    var $ftype;
    var $fname=__stackBase__;
    var $dir;
    var $ent;
    $path_addr=$path;
    var $0=$path_addr; //@line 1625 "voices.cpp"
    var $call=_opendir($0); //@line 1625 "voices.cpp"
    $dir=$call; //@line 1625 "voices.cpp"
    var $cmp=((($call))|0)==0; //@line 1625 "voices.cpp"
    if ($cmp) { __label__ = 13;; } else { __label__ = 1;; } //@line 1625 "voices.cpp"
    if (__label__ == 1) {
  
      var $1=$dir; //@line 1628 "voices.cpp"
      var $call11=_readdir($1); //@line 1628 "voices.cpp"
      $ent=$call11; //@line 1628 "voices.cpp"
      var $cmp22=((($call11))|0)==0; //@line 1628 "voices.cpp"
      var $2=HEAP32[((__ZL13n_voices_list)>>2)]; //@line 1630 "voices.cpp"
      var $cmp33=((($2))|0) >= 148; //@line 1630 "voices.cpp"
      var $or_cond4=($cmp22) | ($cmp33); //@line 1628 "voices.cpp"
      if ($or_cond4) { __label__ = 12;; } else { __label__ = 2;; } //@line 1628 "voices.cpp"
      $while_end$$if_end5_lr_ph$4: do { 
        if (__label__ == 2) {
  
          var $arraydecay=(($fname)&4294967295); //@line 1633 "voices.cpp"
          var $arraydecay8=(($fname)&4294967295); //@line 1635 "voices.cpp"
          var $arraydecay14=(($fname)&4294967295); //@line 1640 "voices.cpp"
          var $arraydecay17=(($fname)&4294967295); //@line 1646 "voices.cpp"
          var $arraydecay22=(($fname)&4294967295); //@line 1650 "voices.cpp"
          ; //@line 1628 "voices.cpp"
          $if_end5$6: while(1) { 
  
            var $3=$path_addr; //@line 1633 "voices.cpp"
            var $4=$ent; //@line 1633 "voices.cpp"
            var $d_name=(($4+4)&4294967295); //@line 1633 "voices.cpp"
            var $arraydecay6=(($d_name)&4294967295); //@line 1633 "voices.cpp"
            var $call7=_sprintf($arraydecay, ((__str74726)&4294967295), allocate([$3,0,0,0,47,0,0,0,$arraydecay6,0,0,0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 1633 "voices.cpp"
            var $call9=__Z13GetFileLengthPKc($arraydecay8); //@line 1635 "voices.cpp"
            $ftype=$call9; //@line 1635 "voices.cpp"
            var $cmp10=((($call9))|0)==-2; //@line 1637 "voices.cpp"
            if ($cmp10) { __lastLabel__ = 3; __label__ = 4;; } else { __lastLabel__ = 3; __label__ = 7;; } //@line 1637 "voices.cpp"
            $land_lhs_true$$if_else$8: do { 
              if (__label__ == 4) {
  
                var $5=$ent; //@line 1637 "voices.cpp"
                var $d_name11=(($5+4)&4294967295); //@line 1637 "voices.cpp"
                var $arrayidx=(($d_name11)&4294967295); //@line 1637 "voices.cpp"
                var $6=HEAP8[($arrayidx)]; //@line 1637 "voices.cpp"
                var $conv=(tempInt=(($6)),(tempInt>=128?tempInt-256:tempInt)); //@line 1637 "voices.cpp"
                var $cmp12=((($conv))|0)!=46; //@line 1637 "voices.cpp"
                if ($cmp12) { __label__ = 5;; } else { __label__ = 6;; } //@line 1637 "voices.cpp"
                if (__label__ == 5) {
  
                  __ZL9GetVoicesPKc($arraydecay14); //@line 1640 "voices.cpp"
                  __label__ = 9;break $land_lhs_true$$if_else$8; //@line 1641 "voices.cpp"
                }
                else if (__label__ == 6) {
  
                  var $_pr=$ftype; //@line 1643 "voices.cpp"
                  __lastLabel__ = 6; __label__ = 7;break $land_lhs_true$$if_else$8;
                }
              }
            } while(0);
            $while_cond_backedge$$if_else$13: do { 
              if (__label__ == 7) {
  
                var $7=__lastLabel__ == 6 ? $_pr : ($call9); //@line 1643 "voices.cpp"
                var $cmp15=((($7))|0) > 0; //@line 1643 "voices.cpp"
                if (!($cmp15)) { __label__ = 9;break $while_cond_backedge$$if_else$13; } //@line 1643 "voices.cpp"
  
                var $call18=_fopen($arraydecay17, ((__str51703)&4294967295)); //@line 1646 "voices.cpp"
                $f_voice=$call18; //@line 1646 "voices.cpp"
                var $cmp19=((($call18))|0)==0; //@line 1646 "voices.cpp"
                if ($cmp19) { __label__ = 9;break $while_cond_backedge$$if_else$13; } //@line 1646 "voices.cpp"
  
                var $10=$f_voice; //@line 1650 "voices.cpp"
                var $11=HEAP32[((__ZL15len_path_voices)>>2)]; //@line 1650 "voices.cpp"
                var $add_ptr=(($arraydecay22+$11)&4294967295); //@line 1650 "voices.cpp"
                var $12=$ent; //@line 1650 "voices.cpp"
                var $d_name23=(($12+4)&4294967295); //@line 1650 "voices.cpp"
                var $arraydecay24=(($d_name23)&4294967295); //@line 1650 "voices.cpp"
                var $call25=__ZL13ReadVoiceFileP7__sFILEPKcS2_($10, $add_ptr, $arraydecay24); //@line 1650 "voices.cpp"
                $voice_data=$call25; //@line 1650 "voices.cpp"
                var $13=$f_voice; //@line 1651 "voices.cpp"
                var $call26=_fclose($13); //@line 1651 "voices.cpp"
                var $14=$voice_data; //@line 1653 "voices.cpp"
                var $cmp27=((($14))|0)!=0; //@line 1653 "voices.cpp"
                if (!($cmp27)) { __label__ = 9;break $while_cond_backedge$$if_else$13; } //@line 1653 "voices.cpp"
  
                var $15=$voice_data; //@line 1655 "voices.cpp"
                var $16=HEAP32[((__ZL13n_voices_list)>>2)]; //@line 1655 "voices.cpp"
                var $inc=((($16)+1)&4294967295); //@line 1655 "voices.cpp"
                HEAP32[((__ZL13n_voices_list)>>2)]=$inc; //@line 1655 "voices.cpp"
                var $arrayidx29=((__ZL11voices_list+$16*4)&4294967295); //@line 1655 "voices.cpp"
                HEAP32[(($arrayidx29)>>2)]=$15; //@line 1655 "voices.cpp"
                ; //@line 1656 "voices.cpp"
              }
            } while(0);
  
            var $8=$dir; //@line 1628 "voices.cpp"
            var $call1=_readdir($8); //@line 1628 "voices.cpp"
            $ent=$call1; //@line 1628 "voices.cpp"
            var $cmp2=((($call1))|0)==0; //@line 1628 "voices.cpp"
            var $9=HEAP32[((__ZL13n_voices_list)>>2)]; //@line 1630 "voices.cpp"
            var $cmp3=((($9))|0) >= 148; //@line 1630 "voices.cpp"
            var $or_cond=($cmp2) | ($cmp3); //@line 1628 "voices.cpp"
            if ($or_cond) { __label__ = 12;break $while_end$$if_end5_lr_ph$4; } else { __label__ = 3;continue $if_end5$6; } //@line 1628 "voices.cpp"
          }
        }
      } while(0);
  
      var $17=$dir; //@line 1659 "voices.cpp"
      var $call33=_closedir($17); //@line 1659 "voices.cpp"
      ; //@line 1662 "voices.cpp"
    }
  
    STACKTOP = __stackBase__;
    return; //@line 1662 "voices.cpp"
    return;
  }
  

  function __ZL15VoiceNameSorterPKvS0_($p1, $p2) {
    ;
    var __label__;
  
    var $retval;
    var $p1_addr;
    var $p2_addr;
    var $ix;
    var $v1;
    var $v2;
    $p1_addr=$p1;
    $p2_addr=$p2;
    var $0=$p1_addr; //@line 1103 "voices.cpp"
    var $1=$0; //@line 1103 "voices.cpp"
    var $2=HEAP32[(($1)>>2)]; //@line 1103 "voices.cpp"
    $v1=$2; //@line 1103 "voices.cpp"
    var $3=$p2_addr; //@line 1104 "voices.cpp"
    var $4=$3; //@line 1104 "voices.cpp"
    var $5=HEAP32[(($4)>>2)]; //@line 1104 "voices.cpp"
    $v2=$5; //@line 1104 "voices.cpp"
    var $6=$v1; //@line 1107 "voices.cpp"
    var $languages=(($6+4)&4294967295); //@line 1107 "voices.cpp"
    var $7=HEAP32[(($languages)>>2)]; //@line 1107 "voices.cpp"
    var $arrayidx=(($7+1)&4294967295); //@line 1107 "voices.cpp"
    var $8=$v2; //@line 1107 "voices.cpp"
    var $languages1=(($8+4)&4294967295); //@line 1107 "voices.cpp"
    var $9=HEAP32[(($languages1)>>2)]; //@line 1107 "voices.cpp"
    var $arrayidx2=(($9+1)&4294967295); //@line 1107 "voices.cpp"
    var $call=_strcmp($arrayidx, $arrayidx2); //@line 1107 "voices.cpp"
    $ix=$call; //@line 1107 "voices.cpp"
    var $cmp=((($call))|0)!=0; //@line 1107 "voices.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 1107 "voices.cpp"
    if (__label__ == 1) {
  
      var $10=$ix; //@line 1108 "voices.cpp"
      $retval=$10; //@line 1108 "voices.cpp"
      ; //@line 1108 "voices.cpp"
    }
    else if (__label__ == 2) {
  
      var $11=$v1; //@line 1109 "voices.cpp"
      var $languages3=(($11+4)&4294967295); //@line 1109 "voices.cpp"
      var $12=HEAP32[(($languages3)>>2)]; //@line 1109 "voices.cpp"
      var $arrayidx4=(($12)&4294967295); //@line 1109 "voices.cpp"
      var $13=HEAP8[($arrayidx4)]; //@line 1109 "voices.cpp"
      var $conv=(tempInt=(($13)),(tempInt>=128?tempInt-256:tempInt)); //@line 1109 "voices.cpp"
      var $14=$v2; //@line 1109 "voices.cpp"
      var $languages5=(($14+4)&4294967295); //@line 1109 "voices.cpp"
      var $15=HEAP32[(($languages5)>>2)]; //@line 1109 "voices.cpp"
      var $arrayidx6=(($15)&4294967295); //@line 1109 "voices.cpp"
      var $16=HEAP8[($arrayidx6)]; //@line 1109 "voices.cpp"
      var $conv7=(tempInt=(($16)),(tempInt>=128?tempInt-256:tempInt)); //@line 1109 "voices.cpp"
      var $sub=((($conv)-($conv7))&4294967295); //@line 1109 "voices.cpp"
      $ix=$sub; //@line 1109 "voices.cpp"
      var $cmp8=((($sub))|0)!=0; //@line 1109 "voices.cpp"
      if ($cmp8) { __label__ = 3;; } else { __label__ = 4;; } //@line 1109 "voices.cpp"
      if (__label__ == 3) {
  
        var $17=$ix; //@line 1110 "voices.cpp"
        $retval=$17; //@line 1110 "voices.cpp"
        ; //@line 1110 "voices.cpp"
      }
      else if (__label__ == 4) {
  
        var $18=$v1; //@line 1111 "voices.cpp"
        var $name=(($18)&4294967295); //@line 1111 "voices.cpp"
        var $19=HEAP32[(($name)>>2)]; //@line 1111 "voices.cpp"
        var $20=$v2; //@line 1111 "voices.cpp"
        var $name11=(($20)&4294967295); //@line 1111 "voices.cpp"
        var $21=HEAP32[(($name11)>>2)]; //@line 1111 "voices.cpp"
        var $call12=_strcmp($19, $21); //@line 1111 "voices.cpp"
        $retval=$call12; //@line 1111 "voices.cpp"
        ; //@line 1111 "voices.cpp"
      }
    }
  
    var $22=$retval; //@line 1112 "voices.cpp"
    ;
    return $22; //@line 1112 "voices.cpp"
    return null;
  }
  

  function _espeak_GetCurrentVoice() {
    ;
    var __label__;
  
    ;
    return _voice_selected; //@line 1798 "voices.cpp"
    return null;
  }
  

  function __ZL13ReadVoiceFileP7__sFILEPKcS2_($f_in, $fname, $leafname) {
    var __stackBase__  = STACKTOP; STACKTOP += 672; _memset(__stackBase__, 0, 672);
    var __label__;
  
    var $retval;
    var $f_in_addr;
    var $fname_addr;
    var $leafname_addr;
    var $linebuf=__stackBase__;
    var $vname=__stackBase__+120;
    var $vgender=__stackBase__+200;
    var $vlanguage=__stackBase__+280;
    var $languages=__stackBase__+360;
    var $len;
    var $langix;
    var $n_languages;
    var $p;
    var $voice_data;
    var $priority=__stackBase__+660;
    var $age=__stackBase__+664;
    var $n_variants=__stackBase__+668;
    var $gender;
    $f_in_addr=$f_in;
    $fname_addr=$fname;
    $leafname_addr=$leafname;
    $langix=0; //@line 281 "voices.cpp"
    $n_languages=0; //@line 282 "voices.cpp"
    HEAP32[(($n_variants)>>2)]=3; //@line 287 "voices.cpp"
    var $arrayidx=(($vname)&4294967295); //@line 304 "voices.cpp"
    HEAP8[($arrayidx)]=0; //@line 304 "voices.cpp"
    var $arrayidx1=(($vgender)&4294967295); //@line 305 "voices.cpp"
    HEAP8[($arrayidx1)]=0; //@line 305 "voices.cpp"
    HEAP32[(($age)>>2)]=0; //@line 306 "voices.cpp"
    var $arraydecay=(($linebuf)&4294967295); //@line 308 "voices.cpp"
    var $0=$f_in_addr; //@line 308 "voices.cpp"
    var $call4=__ZL11fgets_stripPciP7__sFILE($arraydecay, 120, $0); //@line 308 "voices.cpp"
    var $cmp5=((($call4))|0)!=0; //@line 308 "voices.cpp"
    if ($cmp5) { __label__ = 1;; } else { __label__ = 14;; } //@line 308 "voices.cpp"
    $while_body_lr_ph$$while_end49$2: do { 
      if (__label__ == 1) {
  
        var $arraydecay2=(($linebuf)&4294967295); //@line 310 "voices.cpp"
        var $arrayidx5=(($linebuf+4)&4294967295); //@line 312 "voices.cpp"
        var $arraydecay9=(($vname)&4294967295); //@line 314 "voices.cpp"
        var $arraydecay10=(($linebuf)&4294967295); //@line 317 "voices.cpp"
        var $arrayidx14=(($vlanguage)&4294967295); //@line 320 "voices.cpp"
        var $arrayidx15=(($linebuf+8)&4294967295); //@line 322 "voices.cpp"
        var $arraydecay16=(($vlanguage)&4294967295); //@line 322 "voices.cpp"
        var $arraydecay18=(($vlanguage)&4294967295); //@line 323 "voices.cpp"
        var $arraydecay27=(($vlanguage)&4294967295); //@line 329 "voices.cpp"
        var $arraydecay31=(($linebuf)&4294967295); //@line 335 "voices.cpp"
        var $arrayidx35=(($linebuf+6)&4294967295); //@line 337 "voices.cpp"
        var $arraydecay36=(($vgender)&4294967295); //@line 337 "voices.cpp"
        var $arraydecay39=(($linebuf)&4294967295); //@line 340 "voices.cpp"
        var $arrayidx43=(($linebuf+8)&4294967295); //@line 342 "voices.cpp"
        ; //@line 308 "voices.cpp"
        $while_body$4: while(1) { 
  
          var $call3=_memcmp($arraydecay2, ((__str5655)&4294967295), 4); //@line 310 "voices.cpp"
          var $cmp4=((($call3))|0)==0; //@line 310 "voices.cpp"
          if ($cmp4) { __label__ = 3;; } else { __label__ = 6;; } //@line 310 "voices.cpp"
          $if_then$$if_else$6: do { 
            if (__label__ == 3) {
  
              $p=$arrayidx5; //@line 312 "voices.cpp"
              var $1=$p; //@line 313 "voices.cpp"
              var $2=HEAP8[($1)]; //@line 313 "voices.cpp"
              var $conv1=(tempInt=(($2)),(tempInt>=128?tempInt-256:tempInt)); //@line 313 "voices.cpp"
              var $call72=_isspace($conv1); //@line 313 "voices.cpp"
              var $tobool3=((($call72))|0)!=0; //@line 313 "voices.cpp"
              if ($tobool3) { __label__ = 4;; } else { __label__ = 5;; } //@line 313 "voices.cpp"
              $while_body8$$while_end$8: do { 
                if (__label__ == 4) {
                  while(1) { 
  
                    var $3=$p; //@line 313 "voices.cpp"
                    var $incdec_ptr=(($3+1)&4294967295); //@line 313 "voices.cpp"
                    $p=$incdec_ptr; //@line 313 "voices.cpp"
                    var $4=$p; //@line 313 "voices.cpp"
                    var $5=HEAP8[($4)]; //@line 313 "voices.cpp"
                    var $conv=(tempInt=(($5)),(tempInt>=128?tempInt-256:tempInt)); //@line 313 "voices.cpp"
                    var $call7=_isspace($conv); //@line 313 "voices.cpp"
                    var $tobool=((($call7))|0)!=0; //@line 313 "voices.cpp"
                    if ($tobool) { __label__ = 4;continue ; } else { __label__ = 5;break $while_body8$$while_end$8; } //@line 313 "voices.cpp"
                  }
                }
              } while(0);
  
              var $6=$p; //@line 314 "voices.cpp"
              __Z8strncpy0PcPKci($arraydecay9, $6, 80); //@line 314 "voices.cpp"
              ; //@line 315 "voices.cpp"
            }
            else if (__label__ == 6) {
  
              var $call11=_memcmp($arraydecay10, ((__str6656)&4294967295), 8); //@line 317 "voices.cpp"
              var $cmp12=((($call11))|0)==0; //@line 317 "voices.cpp"
              if ($cmp12) { __label__ = 7;; } else { __label__ = 10;; } //@line 317 "voices.cpp"
              if (__label__ == 7) {
  
                HEAP32[(($priority)>>2)]=5; //@line 319 "voices.cpp"
                HEAP8[($arrayidx14)]=0; //@line 320 "voices.cpp"
                var $call17=_sscanf($arrayidx15, ((__str54706)&4294967295), allocate([$arraydecay16,0,0,0,$priority,0,0,0], ["i8*",0,0,0,"i32*",0,0,0], ALLOC_STACK)); //@line 322 "voices.cpp"
                var $call19=_strlen($arraydecay18); //@line 323 "voices.cpp"
                var $add=((($call19)+2)&4294967295); //@line 323 "voices.cpp"
                $len=$add; //@line 323 "voices.cpp"
                var $7=$len; //@line 325 "voices.cpp"
                var $8=$langix; //@line 325 "voices.cpp"
                var $_neg=(((-($8)))&4294967295);
                var $sub20=((($_neg)+299)&4294967295); //@line 325 "voices.cpp"
                var $cmp21=((($7))>>>0) < ((($sub20))>>>0); //@line 325 "voices.cpp"
                if (!($cmp21)) { __label__ = 9;break $if_then$$if_else$6; } //@line 325 "voices.cpp"
  
                var $9=HEAP32[(($priority)>>2)]; //@line 327 "voices.cpp"
                var $conv23=((($9)) & 255); //@line 327 "voices.cpp"
                var $10=$langix; //@line 327 "voices.cpp"
                var $arrayidx24=(($languages+$10)&4294967295); //@line 327 "voices.cpp"
                HEAP8[($arrayidx24)]=$conv23; //@line 327 "voices.cpp"
                var $11=$langix; //@line 329 "voices.cpp"
                var $add25=((($11)+1)&4294967295); //@line 329 "voices.cpp"
                var $arrayidx26=(($languages+$add25)&4294967295); //@line 329 "voices.cpp"
                var $call28=_strcpy($arrayidx26, $arraydecay27); //@line 329 "voices.cpp"
                var $12=$len; //@line 330 "voices.cpp"
                var $13=$langix; //@line 330 "voices.cpp"
                var $add29=((($13)+($12))&4294967295); //@line 330 "voices.cpp"
                $langix=$add29; //@line 330 "voices.cpp"
                var $14=$n_languages; //@line 331 "voices.cpp"
                var $inc=((($14)+1)&4294967295); //@line 331 "voices.cpp"
                $n_languages=$inc; //@line 331 "voices.cpp"
                ; //@line 332 "voices.cpp"
              }
              else if (__label__ == 10) {
  
                var $call32=_memcmp($arraydecay31, ((__str7657)&4294967295), 6); //@line 335 "voices.cpp"
                var $cmp33=((($call32))|0)==0; //@line 335 "voices.cpp"
                if ($cmp33) { __label__ = 11;; } else { __label__ = 12;; } //@line 335 "voices.cpp"
                if (__label__ == 11) {
  
                  var $call37=_sscanf($arrayidx35, ((__str54706)&4294967295), allocate([$arraydecay36,0,0,0,$age,0,0,0], ["i8*",0,0,0,"i32*",0,0,0], ALLOC_STACK)); //@line 337 "voices.cpp"
                  ; //@line 338 "voices.cpp"
                }
                else if (__label__ == 12) {
  
                  var $call40=_memcmp($arraydecay39, ((__str75727)&4294967295), 8); //@line 340 "voices.cpp"
                  var $cmp41=((($call40))|0)==0; //@line 340 "voices.cpp"
                  if (!($cmp41)) { __label__ = 9;break $if_then$$if_else$6; } //@line 340 "voices.cpp"
  
                  var $call44=_sscanf($arrayidx43, ((__str63715)&4294967295), allocate([$n_variants,0,0,0], ["i32*",0,0,0], ALLOC_STACK)); //@line 342 "voices.cpp"
                  ; //@line 343 "voices.cpp"
                }
              }
            }
          } while(0);
  
          var $15=$f_in_addr; //@line 308 "voices.cpp"
          var $call=__ZL11fgets_stripPciP7__sFILE($arraydecay, 120, $15); //@line 308 "voices.cpp"
          var $cmp=((($call))|0)!=0; //@line 308 "voices.cpp"
          if ($cmp) { __label__ = 2;continue $while_body$4; } else { __label__ = 14;break $while_body_lr_ph$$while_end49$2; } //@line 308 "voices.cpp"
        }
      }
    } while(0);
  
    var $16=$langix; //@line 345 "voices.cpp"
    var $inc50=((($16)+1)&4294967295); //@line 345 "voices.cpp"
    $langix=$inc50; //@line 345 "voices.cpp"
    var $arrayidx51=(($languages+$16)&4294967295); //@line 345 "voices.cpp"
    HEAP8[($arrayidx51)]=0; //@line 345 "voices.cpp"
    var $arraydecay52=(($vgender)&4294967295); //@line 347 "voices.cpp"
    var $call53=__Z10LookupMnemP8MNEM_TABPKc(((_genders)&4294967295), $arraydecay52); //@line 347 "voices.cpp"
    $gender=$call53; //@line 347 "voices.cpp"
    var $17=$n_languages; //@line 349 "voices.cpp"
    var $cmp54=((($17))|0)==0; //@line 349 "voices.cpp"
    if ($cmp54) { __label__ = 15;; } else { __label__ = 16;; } //@line 349 "voices.cpp"
    if (__label__ == 15) {
  
      $retval=0; //@line 351 "voices.cpp"
      ; //@line 351 "voices.cpp"
    }
    else if (__label__ == 16) {
  
      var $18=$langix; //@line 354 "voices.cpp"
      var $19=$fname_addr; //@line 354 "voices.cpp"
      var $call58=_strlen($19); //@line 354 "voices.cpp"
      var $arraydecay60=(($vname)&4294967295); //@line 354 "voices.cpp"
      var $call61=_strlen($arraydecay60); //@line 354 "voices.cpp"
      var $add59=((($18)+27)&4294967295); //@line 354 "voices.cpp"
      var $add62=((($add59)+($call58))&4294967295); //@line 354 "voices.cpp"
      var $add63=((($add62)+($call61))&4294967295); //@line 354 "voices.cpp"
      var $call64=_calloc($add63, 1); //@line 354 "voices.cpp"
      $p=$call64; //@line 354 "voices.cpp"
      var $20=$p; //@line 355 "voices.cpp"
      var $21=$20; //@line 355 "voices.cpp"
      $voice_data=$21; //@line 355 "voices.cpp"
      var $22=$p; //@line 356 "voices.cpp"
      var $arrayidx65=(($22+24)&4294967295); //@line 356 "voices.cpp"
      $p=$arrayidx65; //@line 356 "voices.cpp"
      var $23=$p; //@line 358 "voices.cpp"
      var $arraydecay66=(($languages)&4294967295); //@line 358 "voices.cpp"
      var $24=$langix; //@line 358 "voices.cpp"
      var $src$, $dest$, $stop$, $stop4$, $fast$;
      $src$ = $arraydecay66;
      $dest$ = $23;
      $stop$ = $src$ + $24;
      if (($dest$%4) == ($src$%4) && $24 > 8) {
        while ($src$%4 !== 0 && $src$ < $stop$) {
          ; HEAP8[$dest$++] = HEAP8[$src$++];
        }
        $src$ >>= 2;
        $dest$ >>= 2;
        $stop4$ = $stop$ >> 2;
        while ($src$ < $stop4$) {
      ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
        }
        $src$ <<= 2;
        $dest$ <<= 2;
      }while ($src$ < $stop$) {
        ; HEAP8[$dest$++] = HEAP8[$src$++];
      }; //@line 358 "voices.cpp"
      var $25=$p; //@line 359 "voices.cpp"
      var $26=$voice_data; //@line 359 "voices.cpp"
      var $languages67=(($26+4)&4294967295); //@line 359 "voices.cpp"
      HEAP32[(($languages67)>>2)]=$25; //@line 359 "voices.cpp"
      var $27=$langix; //@line 361 "voices.cpp"
      var $28=$p; //@line 361 "voices.cpp"
      var $arrayidx68=(($28+$27)&4294967295); //@line 361 "voices.cpp"
      var $29=$fname_addr; //@line 361 "voices.cpp"
      var $call69=_strcpy($arrayidx68, $29); //@line 361 "voices.cpp"
      var $30=$langix; //@line 362 "voices.cpp"
      var $31=$p; //@line 362 "voices.cpp"
      var $arrayidx70=(($31+$30)&4294967295); //@line 362 "voices.cpp"
      var $32=$voice_data; //@line 362 "voices.cpp"
      var $identifier=(($32+8)&4294967295); //@line 362 "voices.cpp"
      HEAP32[(($identifier)>>2)]=$arrayidx70; //@line 362 "voices.cpp"
      var $33=$langix; //@line 363 "voices.cpp"
      var $34=$p; //@line 363 "voices.cpp"
      var $arrayidx71=(($34+$33)&4294967295); //@line 363 "voices.cpp"
      var $35=$voice_data; //@line 363 "voices.cpp"
      var $name=(($35)&4294967295); //@line 363 "voices.cpp"
      HEAP32[(($name)>>2)]=$arrayidx71; //@line 363 "voices.cpp"
      var $arrayidx72=(($vname)&4294967295); //@line 365 "voices.cpp"
      var $36=HEAP8[($arrayidx72)]; //@line 365 "voices.cpp"
      var $conv73=(tempInt=(($36)),(tempInt>=128?tempInt-256:tempInt)); //@line 365 "voices.cpp"
      var $cmp74=((($conv73))|0)!=0; //@line 365 "voices.cpp"
      if ($cmp74) { __label__ = 17;; } else { __label__ = 18;; } //@line 365 "voices.cpp"
      if (__label__ == 17) {
  
        var $37=$fname_addr; //@line 367 "voices.cpp"
        var $call76=_strlen($37); //@line 367 "voices.cpp"
        var $38=$langix; //@line 367 "voices.cpp"
        var $add77=((($call76)+1)&4294967295); //@line 367 "voices.cpp"
        var $add78=((($add77)+($38))&4294967295); //@line 367 "voices.cpp"
        $langix=$add78; //@line 367 "voices.cpp"
        var $39=$langix; //@line 368 "voices.cpp"
        var $40=$p; //@line 368 "voices.cpp"
        var $arrayidx79=(($40+$39)&4294967295); //@line 368 "voices.cpp"
        var $arraydecay80=(($vname)&4294967295); //@line 368 "voices.cpp"
        var $call81=_strcpy($arrayidx79, $arraydecay80); //@line 368 "voices.cpp"
        var $41=$langix; //@line 369 "voices.cpp"
        var $42=$p; //@line 369 "voices.cpp"
        var $arrayidx82=(($42+$41)&4294967295); //@line 369 "voices.cpp"
        var $43=$voice_data; //@line 369 "voices.cpp"
        var $name83=(($43)&4294967295); //@line 369 "voices.cpp"
        HEAP32[(($name83)>>2)]=$arrayidx82; //@line 369 "voices.cpp"
        ; //@line 370 "voices.cpp"
      }
  
      var $44=HEAP32[(($age)>>2)]; //@line 372 "voices.cpp"
      var $conv85=((($44)) & 255); //@line 372 "voices.cpp"
      var $45=$voice_data; //@line 372 "voices.cpp"
      var $age86=(($45+13)&4294967295); //@line 372 "voices.cpp"
      HEAP8[($age86)]=$conv85; //@line 372 "voices.cpp"
      var $46=$gender; //@line 373 "voices.cpp"
      var $conv87=((($46)) & 255); //@line 373 "voices.cpp"
      var $47=$voice_data; //@line 373 "voices.cpp"
      var $gender88=(($47+12)&4294967295); //@line 373 "voices.cpp"
      HEAP8[($gender88)]=$conv87; //@line 373 "voices.cpp"
      var $48=$voice_data; //@line 374 "voices.cpp"
      var $variant=(($48+14)&4294967295); //@line 374 "voices.cpp"
      HEAP8[($variant)]=0; //@line 374 "voices.cpp"
      var $49=HEAP32[(($n_variants)>>2)]; //@line 375 "voices.cpp"
      var $conv89=((($49)) & 255); //@line 375 "voices.cpp"
      var $50=$voice_data; //@line 375 "voices.cpp"
      var $xx1=(($50+15)&4294967295); //@line 375 "voices.cpp"
      HEAP8[($xx1)]=$conv89; //@line 375 "voices.cpp"
      var $51=$voice_data; //@line 376 "voices.cpp"
      $retval=$51; //@line 376 "voices.cpp"
      ; //@line 376 "voices.cpp"
    }
  
    var $52=$retval; //@line 377 "voices.cpp"
    STACKTOP = __stackBase__;
    return $52; //@line 377 "voices.cpp"
    return null;
  }
  

  function __ZL10ScoreVoiceP12espeak_VOICEPKciiS0_($voice_spec, $spec_language, $spec_n_parts, $spec_lang_len, $voice) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $voice_spec_addr;
    var $spec_language_addr;
    var $spec_n_parts_addr;
    var $spec_lang_len_addr;
    var $voice_addr;
    var $ix;
    var $p;
    var $c1;
    var $c2;
    var $language_priority;
    var $n_parts;
    var $matching;
    var $matching_parts;
    var $score;
    var $x;
    var $ratio;
    var $required_age;
    var $diff;
    $voice_spec_addr=$voice_spec;
    $spec_language_addr=$spec_language;
    $spec_n_parts_addr=$spec_n_parts;
    $spec_lang_len_addr=$spec_lang_len;
    $voice_addr=$voice;
    $score=0; //@line 1136 "voices.cpp"
    var $0=$voice_addr; //@line 1142 "voices.cpp"
    var $languages=(($0+4)&4294967295); //@line 1142 "voices.cpp"
    var $1=HEAP32[(($languages)>>2)]; //@line 1142 "voices.cpp"
    $p=$1; //@line 1142 "voices.cpp"
    var $2=$spec_language_addr; //@line 1144 "voices.cpp"
    var $call=_strcmp($2, ((__str33683)&4294967295)); //@line 1144 "voices.cpp"
    var $cmp=((($call))|0)==0; //@line 1144 "voices.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 4;; } //@line 1144 "voices.cpp"
    $if_then$$if_end4$2: do { 
      if (__label__ == 1) {
  
        var $3=$voice_addr; //@line 1147 "voices.cpp"
        var $identifier=(($3+8)&4294967295); //@line 1147 "voices.cpp"
        var $4=HEAP32[(($identifier)>>2)]; //@line 1147 "voices.cpp"
        var $call1=_memcmp($4, ((__str73725)&4294967295), 3); //@line 1147 "voices.cpp"
        var $cmp2=((($call1))|0)==0; //@line 1147 "voices.cpp"
        if ($cmp2) { __label__ = 2;; } else { __label__ = 3;; } //@line 1147 "voices.cpp"
        if (__label__ == 2) {
  
          $retval=100; //@line 1148 "voices.cpp"
          ; //@line 1148 "voices.cpp"
        }
        else if (__label__ == 3) {
  
          $retval=0; //@line 1149 "voices.cpp"
          ; //@line 1149 "voices.cpp"
        }
      }
      else if (__label__ == 4) {
  
        var $5=$spec_n_parts_addr; //@line 1152 "voices.cpp"
        var $cmp5=((($5))|0)==0; //@line 1152 "voices.cpp"
        if ($cmp5) { __label__ = 5;; } else { __label__ = 6;; } //@line 1152 "voices.cpp"
        $if_end60_thread$$if_else$8: do { 
          if (__label__ == 5) {
  
            $score=100; //@line 1154 "voices.cpp"
            ; //@line 1215 "voices.cpp"
          }
          else if (__label__ == 6) {
  
            var $6=$p; //@line 1158 "voices.cpp"
            var $7=HEAP8[($6)]; //@line 1158 "voices.cpp"
            var $conv=(tempInt=(($7)),(tempInt>=128?tempInt-256:tempInt)); //@line 1158 "voices.cpp"
            var $cmp7=((($conv))|0)==0; //@line 1158 "voices.cpp"
            if ($cmp7) { __label__ = 7;; } else { __label__ = 9;; } //@line 1158 "voices.cpp"
            $land_lhs_true$$while_cond_preheader$11: do { 
              if (__label__ == 7) {
  
                var $8=$spec_language_addr; //@line 1158 "voices.cpp"
                var $call8=_strcmp($8, ((__str75727)&4294967295)); //@line 1158 "voices.cpp"
                var $cmp9=((($call8))|0)==0; //@line 1158 "voices.cpp"
                if (!($cmp9)) { __label__ = 9;break $land_lhs_true$$while_cond_preheader$11; } //@line 1158 "voices.cpp"
  
                $score=100; //@line 1161 "voices.cpp"
                ; //@line 1162 "voices.cpp"
              }
            } while(0);
  
            var $9=$p; //@line 1165 "voices.cpp"
            var $10=HEAP8[($9)]; //@line 1165 "voices.cpp"
            var $conv123=(tempInt=(($10)),(tempInt>=128?tempInt-256:tempInt)); //@line 1165 "voices.cpp"
            var $cmp134=((($conv123))|0)!=0; //@line 1165 "voices.cpp"
            if ($cmp134) { __label__ = 10;; } else { __label__ = 31;; } //@line 1165 "voices.cpp"
            $while_body$$if_end60$15: do { 
              if (__label__ == 10) {
                $while_body$16: while(1) { 
  
                  var $11=$p; //@line 1167 "voices.cpp"
                  var $incdec_ptr=(($11+1)&4294967295); //@line 1167 "voices.cpp"
                  $p=$incdec_ptr; //@line 1167 "voices.cpp"
                  var $12=HEAP8[($11)]; //@line 1167 "voices.cpp"
                  var $conv14=(tempInt=(($12)),(tempInt>=128?tempInt-256:tempInt)); //@line 1167 "voices.cpp"
                  $language_priority=$conv14; //@line 1167 "voices.cpp"
                  $matching=1; //@line 1169 "voices.cpp"
                  $matching_parts=0; //@line 1170 "voices.cpp"
                  $n_parts=1; //@line 1171 "voices.cpp"
                  $ix=0; //@line 1173 "voices.cpp"
                  ; //@line 1173 "voices.cpp"
                  $for_cond$18: while(1) { 
  
                    var $13=$ix; //@line 1175 "voices.cpp"
                    var $14=$spec_lang_len_addr; //@line 1175 "voices.cpp"
                    var $cmp15=((($13))|0) >= ((($14))|0); //@line 1175 "voices.cpp"
                    if ($cmp15) { __label__ = 13;; } else { __label__ = 12;; } //@line 1175 "voices.cpp"
                    $if_then18$$lor_lhs_false$20: do { 
                      if (__label__ == 12) {
  
                        var $15=$ix; //@line 1175 "voices.cpp"
                        var $16=$spec_language_addr; //@line 1175 "voices.cpp"
                        var $arrayidx=(($16+$15)&4294967295); //@line 1175 "voices.cpp"
                        var $17=HEAP8[($arrayidx)]; //@line 1175 "voices.cpp"
                        var $conv16=(tempInt=(($17)),(tempInt>=128?tempInt-256:tempInt)); //@line 1175 "voices.cpp"
                        $c1=$conv16; //@line 1175 "voices.cpp"
                        var $cmp17=((($conv16))|0)==45; //@line 1175 "voices.cpp"
                        if ($cmp17) { __label__ = 13;break $if_then18$$lor_lhs_false$20; } else { __label__ = 14;break $if_then18$$lor_lhs_false$20; } //@line 1175 "voices.cpp"
                      }
                    } while(0);
                    if (__label__ == 13) {
  
                      $c1=0; //@line 1176 "voices.cpp"
                      ; //@line 1176 "voices.cpp"
                    }
  
                    var $18=$ix; //@line 1177 "voices.cpp"
                    var $19=$p; //@line 1177 "voices.cpp"
                    var $arrayidx20=(($19+$18)&4294967295); //@line 1177 "voices.cpp"
                    var $20=HEAP8[($arrayidx20)]; //@line 1177 "voices.cpp"
                    var $conv21=(tempInt=(($20)),(tempInt>=128?tempInt-256:tempInt)); //@line 1177 "voices.cpp"
                    $c2=$conv21; //@line 1177 "voices.cpp"
                    var $cmp22=((($conv21))|0)==45; //@line 1177 "voices.cpp"
                    if ($cmp22) { __label__ = 15;; } else { __label__ = 16;; } //@line 1177 "voices.cpp"
                    if (__label__ == 15) {
  
                      $c2=0; //@line 1178 "voices.cpp"
                      ; //@line 1178 "voices.cpp"
                    }
  
                    var $21=$c1; //@line 1180 "voices.cpp"
                    var $22=$c2; //@line 1180 "voices.cpp"
                    var $cmp25=((($21))|0)!=((($22))|0); //@line 1180 "voices.cpp"
                    if ($cmp25) { __label__ = 17;; } else { __label__ = 18;; } //@line 1180 "voices.cpp"
                    if (__label__ == 17) {
  
                      $matching=0; //@line 1182 "voices.cpp"
                      ; //@line 1183 "voices.cpp"
                    }
  
                    var $23=$ix; //@line 1185 "voices.cpp"
                    var $24=$p; //@line 1185 "voices.cpp"
                    var $arrayidx28=(($24+$23)&4294967295); //@line 1185 "voices.cpp"
                    var $25=HEAP8[($arrayidx28)]; //@line 1185 "voices.cpp"
                    var $conv29=(tempInt=(($25)),(tempInt>=128?tempInt-256:tempInt)); //@line 1185 "voices.cpp"
                    var $cmp30=((($conv29))|0)==45; //@line 1185 "voices.cpp"
                    if ($cmp30) { __label__ = 19;; } else { __label__ = 21;; } //@line 1185 "voices.cpp"
                    $if_then31$$if_end35$31: do { 
                      if (__label__ == 19) {
  
                        var $26=$n_parts; //@line 1187 "voices.cpp"
                        var $inc=((($26)+1)&4294967295); //@line 1187 "voices.cpp"
                        $n_parts=$inc; //@line 1187 "voices.cpp"
                        var $27=$matching; //@line 1188 "voices.cpp"
                        var $tobool=((($27))|0)!=0; //@line 1188 "voices.cpp"
                        if (!($tobool)) { __label__ = 21;break $if_then31$$if_end35$31; } //@line 1188 "voices.cpp"
  
                        var $28=$matching_parts; //@line 1189 "voices.cpp"
                        var $inc33=((($28)+1)&4294967295); //@line 1189 "voices.cpp"
                        $matching_parts=$inc33; //@line 1189 "voices.cpp"
                        ; //@line 1189 "voices.cpp"
                      }
                    } while(0);
  
                    var $29=$ix; //@line 1191 "voices.cpp"
                    var $30=$p; //@line 1191 "voices.cpp"
                    var $arrayidx36=(($30+$29)&4294967295); //@line 1191 "voices.cpp"
                    var $31=HEAP8[($arrayidx36)]; //@line 1191 "voices.cpp"
                    var $conv37=(tempInt=(($31)),(tempInt>=128?tempInt-256:tempInt)); //@line 1191 "voices.cpp"
                    var $cmp38=((($conv37))|0)==0; //@line 1191 "voices.cpp"
                    var $32=$ix; //@line 1194 "voices.cpp"
                    var $add=((($32)+1)&4294967295); //@line 1194 "voices.cpp"
                    if ($cmp38) { __label__ = 23;break $for_cond$18; } //@line 1191 "voices.cpp"
  
                    $ix=$add; //@line 1173 "voices.cpp"
                    __label__ = 11;continue $for_cond$18; //@line 1173 "voices.cpp"
                  }
  
                  var $33=$p; //@line 1194 "voices.cpp"
                  var $add_ptr=(($33+$add)&4294967295); //@line 1194 "voices.cpp"
                  $p=$add_ptr; //@line 1194 "voices.cpp"
                  var $34=$matching; //@line 1195 "voices.cpp"
                  var $35=$matching_parts; //@line 1195 "voices.cpp"
                  var $add42=((($35)+($34))&4294967295); //@line 1195 "voices.cpp"
                  $matching_parts=$add42; //@line 1195 "voices.cpp"
                  var $36=$matching_parts; //@line 1197 "voices.cpp"
                  var $cmp43=((($36))|0)==0; //@line 1197 "voices.cpp"
                  if ($cmp43) { __label__ = 24;; } else { __label__ = 25;; } //@line 1197 "voices.cpp"
                  $while_cond_backedge$$if_end45$37: do { 
                    if (__label__ == 25) {
  
                      $x=5; //@line 1200 "voices.cpp"
                      var $39=$spec_n_parts_addr; //@line 1202 "voices.cpp"
                      var $40=$matching_parts; //@line 1202 "voices.cpp"
                      var $sub=((($39)-($40))&4294967295); //@line 1202 "voices.cpp"
                      $diff=$sub; //@line 1202 "voices.cpp"
                      var $cmp46=((($sub))|0) > 0; //@line 1202 "voices.cpp"
                      if ($cmp46) { __label__ = 26;; } else { __label__ = 27;; } //@line 1202 "voices.cpp"
                      if (__label__ == 26) {
  
                        var $41=$diff; //@line 1203 "voices.cpp"
                        var $42=$x; //@line 1203 "voices.cpp"
                        var $sub48=((($42)-($41))&4294967295); //@line 1203 "voices.cpp"
                        $x=$sub48; //@line 1203 "voices.cpp"
                        ; //@line 1203 "voices.cpp"
                      }
  
                      var $43=$n_parts; //@line 1206 "voices.cpp"
                      var $44=$matching_parts; //@line 1206 "voices.cpp"
                      var $sub50=((($43)-($44))&4294967295); //@line 1206 "voices.cpp"
                      $diff=$sub50; //@line 1206 "voices.cpp"
                      var $cmp51=((($sub50))|0) > 0; //@line 1206 "voices.cpp"
                      if ($cmp51) { __label__ = 28;; } else { __label__ = 29;; } //@line 1206 "voices.cpp"
                      if (__label__ == 28) {
  
                        var $45=$diff; //@line 1207 "voices.cpp"
                        var $46=$x; //@line 1207 "voices.cpp"
                        var $sub53=((($46)-($45))&4294967295); //@line 1207 "voices.cpp"
                        $x=$sub53; //@line 1207 "voices.cpp"
                        ; //@line 1207 "voices.cpp"
                      }
  
                      var $47=$x; //@line 1209 "voices.cpp"
                      var $mul=((($47)*100)&4294967295); //@line 1209 "voices.cpp"
                      var $48=$language_priority; //@line 1209 "voices.cpp"
                      var $mul55=((($48)*2)&4294967295); //@line 1209 "voices.cpp"
                      var $sub56=((($mul)-($mul55))&4294967295); //@line 1209 "voices.cpp"
                      $x=$sub56; //@line 1209 "voices.cpp"
                      var $49=$x; //@line 1211 "voices.cpp"
                      var $50=$score; //@line 1211 "voices.cpp"
                      var $cmp57=((($49))|0) > ((($50))|0); //@line 1211 "voices.cpp"
                      if (!($cmp57)) { __label__ = 24;break $while_cond_backedge$$if_end45$37; } //@line 1211 "voices.cpp"
  
                      var $51=$x; //@line 1212 "voices.cpp"
                      $score=$51; //@line 1212 "voices.cpp"
                      ; //@line 1212 "voices.cpp"
                    }
                  } while(0);
  
                  var $37=$p; //@line 1165 "voices.cpp"
                  var $38=HEAP8[($37)]; //@line 1165 "voices.cpp"
                  var $conv12=(tempInt=(($38)),(tempInt>=128?tempInt-256:tempInt)); //@line 1165 "voices.cpp"
                  var $cmp13=((($conv12))|0)!=0; //@line 1165 "voices.cpp"
                  if ($cmp13) { __label__ = 10;continue $while_body$16; } else { __label__ = 31;break $while_body$$if_end60$15; } //@line 1165 "voices.cpp"
                }
              }
            } while(0);
  
            var $_pr=$score; //@line 1215 "voices.cpp"
            var $cmp61=((($_pr))|0)==0; //@line 1215 "voices.cpp"
            if (!($cmp61)) { __label__ = 33;break $if_end60_thread$$if_else$8; } //@line 1215 "voices.cpp"
  
            $retval=0; //@line 1216 "voices.cpp"
            __label__ = 63;break $if_then$$if_end4$2; //@line 1216 "voices.cpp"
          }
        } while(0);
  
        var $52=$voice_spec_addr; //@line 1218 "voices.cpp"
        var $name=(($52)&4294967295); //@line 1218 "voices.cpp"
        var $53=HEAP32[(($name)>>2)]; //@line 1218 "voices.cpp"
        var $cmp64=((($53))|0)!=0; //@line 1218 "voices.cpp"
        if ($cmp64) { __label__ = 34;; } else { __label__ = 38;; } //@line 1218 "voices.cpp"
        $if_then65$$if_end81$50: do { 
          if (__label__ == 34) {
  
            var $54=$voice_spec_addr; //@line 1220 "voices.cpp"
            var $name66=(($54)&4294967295); //@line 1220 "voices.cpp"
            var $55=HEAP32[(($name66)>>2)]; //@line 1220 "voices.cpp"
            var $56=$voice_addr; //@line 1220 "voices.cpp"
            var $name67=(($56)&4294967295); //@line 1220 "voices.cpp"
            var $57=HEAP32[(($name67)>>2)]; //@line 1220 "voices.cpp"
            var $call68=_strcmp($55, $57); //@line 1220 "voices.cpp"
            var $cmp69=((($call68))|0)==0; //@line 1220 "voices.cpp"
            if ($cmp69) { __label__ = 35;; } else { __label__ = 36;; } //@line 1220 "voices.cpp"
            if (__label__ == 35) {
  
              var $58=$score; //@line 1223 "voices.cpp"
              var $add71=((($58)+500)&4294967295); //@line 1223 "voices.cpp"
              $score=$add71; //@line 1223 "voices.cpp"
              ; //@line 1224 "voices.cpp"
            }
            else if (__label__ == 36) {
  
              var $59=$voice_spec_addr; //@line 1226 "voices.cpp"
              var $name73=(($59)&4294967295); //@line 1226 "voices.cpp"
              var $60=HEAP32[(($name73)>>2)]; //@line 1226 "voices.cpp"
              var $61=$voice_addr; //@line 1226 "voices.cpp"
              var $identifier74=(($61+8)&4294967295); //@line 1226 "voices.cpp"
              var $62=HEAP32[(($identifier74)>>2)]; //@line 1226 "voices.cpp"
              var $call75=_strcmp($60, $62); //@line 1226 "voices.cpp"
              var $cmp76=((($call75))|0)==0; //@line 1226 "voices.cpp"
              if (!($cmp76)) { __label__ = 38;break $if_then65$$if_end81$50; } //@line 1226 "voices.cpp"
  
              var $63=$score; //@line 1228 "voices.cpp"
              var $add78=((($63)+400)&4294967295); //@line 1228 "voices.cpp"
              $score=$add78; //@line 1228 "voices.cpp"
              ; //@line 1229 "voices.cpp"
            }
          }
        } while(0);
  
        var $64=$voice_spec_addr; //@line 1232 "voices.cpp"
        var $gender=(($64+12)&4294967295); //@line 1232 "voices.cpp"
        var $65=HEAPU8[($gender)]; //@line 1232 "voices.cpp"
        var $conv82=((($65))&255); //@line 1232 "voices.cpp"
        var $cmp83=((($conv82))|0)==1; //@line 1232 "voices.cpp"
        if ($cmp83) { __label__ = 40;; } else { __label__ = 39;; } //@line 1232 "voices.cpp"
        $land_lhs_true88$$lor_lhs_false84$57: do { 
          if (__label__ == 39) {
  
            var $66=$voice_spec_addr; //@line 1232 "voices.cpp"
            var $gender85=(($66+12)&4294967295); //@line 1232 "voices.cpp"
            var $67=HEAPU8[($gender85)]; //@line 1232 "voices.cpp"
            var $conv86=((($67))&255); //@line 1232 "voices.cpp"
            var $cmp87=((($conv86))|0)==2; //@line 1232 "voices.cpp"
            if ($cmp87) { __label__ = 40;break $land_lhs_true88$$lor_lhs_false84$57; } else { __label__ = 45;break $land_lhs_true88$$lor_lhs_false84$57; } //@line 1232 "voices.cpp"
          }
        } while(0);
        $land_lhs_true88$$if_end107$59: do { 
          if (__label__ == 40) {
  
            var $68=$voice_addr; //@line 1232 "voices.cpp"
            var $gender89=(($68+12)&4294967295); //@line 1232 "voices.cpp"
            var $69=HEAPU8[($gender89)]; //@line 1232 "voices.cpp"
            var $conv90=((($69))&255); //@line 1232 "voices.cpp"
            var $cmp91=((($conv90))|0)==1; //@line 1232 "voices.cpp"
            if ($cmp91) { __label__ = 42;; } else { __label__ = 41;; } //@line 1232 "voices.cpp"
            if (__label__ == 41) {
  
              var $70=$voice_addr; //@line 1232 "voices.cpp"
              var $gender93=(($70+12)&4294967295); //@line 1232 "voices.cpp"
              var $71=HEAPU8[($gender93)]; //@line 1232 "voices.cpp"
              var $conv94=((($71))&255); //@line 1232 "voices.cpp"
              var $cmp95=((($conv94))|0)==2; //@line 1232 "voices.cpp"
              if (!($cmp95)) { __label__ = 45;break $land_lhs_true88$$if_end107$59; } //@line 1232 "voices.cpp"
            }
  
            var $72=$voice_spec_addr; //@line 1235 "voices.cpp"
            var $gender97=(($72+12)&4294967295); //@line 1235 "voices.cpp"
            var $73=HEAPU8[($gender97)]; //@line 1235 "voices.cpp"
            var $conv98=((($73))&255); //@line 1235 "voices.cpp"
            var $74=$voice_addr; //@line 1235 "voices.cpp"
            var $gender99=(($74+12)&4294967295); //@line 1235 "voices.cpp"
            var $75=HEAPU8[($gender99)]; //@line 1235 "voices.cpp"
            var $conv100=((($75))&255); //@line 1235 "voices.cpp"
            var $cmp101=((($conv98))|0)==((($conv100))|0); //@line 1235 "voices.cpp"
            var $76=$score; //@line 1236 "voices.cpp"
            if ($cmp101) { __label__ = 43;; } else { __label__ = 44;; } //@line 1235 "voices.cpp"
            if (__label__ == 43) {
  
              var $add103=((($76)+50)&4294967295); //@line 1236 "voices.cpp"
              $score=$add103; //@line 1236 "voices.cpp"
              ; //@line 1236 "voices.cpp"
            }
            else if (__label__ == 44) {
  
              var $sub105=((($76)-50)&4294967295); //@line 1238 "voices.cpp"
              $score=$sub105; //@line 1238 "voices.cpp"
              ;
            }
          }
        } while(0);
  
        var $77=$voice_spec_addr; //@line 1241 "voices.cpp"
        var $age=(($77+13)&4294967295); //@line 1241 "voices.cpp"
        var $78=HEAPU8[($age)]; //@line 1241 "voices.cpp"
        var $conv108=((($78))&255); //@line 1241 "voices.cpp"
        var $cmp109=((($conv108))|0) <= 12; //@line 1241 "voices.cpp"
        if ($cmp109) { __label__ = 46;; } else { __label__ = 49;; } //@line 1241 "voices.cpp"
        $land_lhs_true110$$if_end120$68: do { 
          if (__label__ == 46) {
  
            var $79=$voice_addr; //@line 1241 "voices.cpp"
            var $gender111=(($79+12)&4294967295); //@line 1241 "voices.cpp"
            var $80=HEAPU8[($gender111)]; //@line 1241 "voices.cpp"
            var $conv112=((($80))&255); //@line 1241 "voices.cpp"
            var $cmp113=((($conv112))|0)==2; //@line 1241 "voices.cpp"
            if (!($cmp113)) { __label__ = 49;break $land_lhs_true110$$if_end120$68; } //@line 1241 "voices.cpp"
  
            var $81=$voice_addr; //@line 1241 "voices.cpp"
            var $age115=(($81+13)&4294967295); //@line 1241 "voices.cpp"
            var $82=HEAPU8[($age115)]; //@line 1241 "voices.cpp"
            var $conv116=((($82))&255); //@line 1241 "voices.cpp"
            var $cmp117=((($conv116))|0) > 12; //@line 1241 "voices.cpp"
            if (!($cmp117)) { __label__ = 49;break $land_lhs_true110$$if_end120$68; } //@line 1241 "voices.cpp"
  
            var $83=$score; //@line 1243 "voices.cpp"
            var $add119=((($83)+5)&4294967295); //@line 1243 "voices.cpp"
            $score=$add119; //@line 1243 "voices.cpp"
            ; //@line 1244 "voices.cpp"
          }
        } while(0);
  
        var $84=$voice_addr; //@line 1246 "voices.cpp"
        var $age121=(($84+13)&4294967295); //@line 1246 "voices.cpp"
        var $85=HEAPU8[($age121)]; //@line 1246 "voices.cpp"
        var $conv122=((($85))&255); //@line 1246 "voices.cpp"
        var $cmp123=((($conv122))|0)!=0; //@line 1246 "voices.cpp"
        if ($cmp123) { __label__ = 50;; } else { __label__ = 59;; } //@line 1246 "voices.cpp"
        $if_then124$$if_end153thread_pre_split$73: do { 
          if (__label__ == 50) {
  
            var $86=$voice_spec_addr; //@line 1248 "voices.cpp"
            var $age125=(($86+13)&4294967295); //@line 1248 "voices.cpp"
            var $87=HEAPU8[($age125)]; //@line 1248 "voices.cpp"
            var $conv126=((($87))&255); //@line 1248 "voices.cpp"
            var $cmp127=((($conv126))|0)==0; //@line 1248 "voices.cpp"
            if ($cmp127) { __label__ = 51;; } else { __label__ = 52;; } //@line 1248 "voices.cpp"
            if (__label__ == 51) {
  
              $required_age=30; //@line 1249 "voices.cpp"
              ; //@line 1249 "voices.cpp"
            }
            else if (__label__ == 52) {
  
              var $88=$voice_spec_addr; //@line 1251 "voices.cpp"
              var $age130=(($88+13)&4294967295); //@line 1251 "voices.cpp"
              var $89=HEAPU8[($age130)]; //@line 1251 "voices.cpp"
              var $conv131=((($89))&255); //@line 1251 "voices.cpp"
              $required_age=$conv131; //@line 1251 "voices.cpp"
              ;
            }
  
            var $90=$required_age; //@line 1253 "voices.cpp"
            var $mul133=((($90)*100)&4294967295); //@line 1253 "voices.cpp"
            var $91=$voice_addr; //@line 1253 "voices.cpp"
            var $age134=(($91+13)&4294967295); //@line 1253 "voices.cpp"
            var $92=HEAPU8[($age134)]; //@line 1253 "voices.cpp"
            var $conv135=((($92))&255); //@line 1253 "voices.cpp"
            var $div=((((($mul133))|0)/((($conv135))|0))|0); //@line 1253 "voices.cpp"
            $ratio=$div; //@line 1253 "voices.cpp"
            var $cmp136=((($div))|0) < 100; //@line 1254 "voices.cpp"
            if ($cmp136) { __label__ = 54;; } else { __label__ = 55;; } //@line 1254 "voices.cpp"
            if (__label__ == 54) {
  
              var $93=$ratio; //@line 1255 "voices.cpp"
              var $div138=((10000/((($93))|0))|0); //@line 1255 "voices.cpp"
              $ratio=$div138; //@line 1255 "voices.cpp"
              ; //@line 1255 "voices.cpp"
            }
  
            var $94=$ratio; //@line 1256 "voices.cpp"
            var $sub140=((($94)-100)&4294967295); //@line 1256 "voices.cpp"
            var $div141=((((($sub140))|0)/10)|0); //@line 1256 "voices.cpp"
            $ratio=$div141; //@line 1256 "voices.cpp"
            var $95=$ratio; //@line 1257 "voices.cpp"
            var $sub142=((5-($95))&4294967295); //@line 1257 "voices.cpp"
            $x=$sub142; //@line 1257 "voices.cpp"
            var $cmp143=((($sub142))|0) > 0; //@line 1258 "voices.cpp"
            if ($cmp143) { __label__ = 56;; } else { __label__ = 57;; } //@line 1258 "voices.cpp"
            if (__label__ == 56) {
  
              $x=0; //@line 1258 "voices.cpp"
              ; //@line 1258 "voices.cpp"
            }
  
            var $96=$score; //@line 1260 "voices.cpp"
            var $97=$x; //@line 1260 "voices.cpp"
            var $add146=((($97)+($96))&4294967295); //@line 1260 "voices.cpp"
            $score=$add146; //@line 1260 "voices.cpp"
            var $98=$voice_spec_addr; //@line 1262 "voices.cpp"
            var $age147=(($98+13)&4294967295); //@line 1262 "voices.cpp"
            var $99=HEAPU8[($age147)]; //@line 1262 "voices.cpp"
            var $conv148=((($99))&255); //@line 1262 "voices.cpp"
            var $cmp149=((($conv148))|0) > 0; //@line 1262 "voices.cpp"
            if (!($cmp149)) { __label__ = 59;break $if_then124$$if_end153thread_pre_split$73; } //@line 1262 "voices.cpp"
  
            var $100=$score; //@line 1263 "voices.cpp"
            var $add151=((($100)+10)&4294967295); //@line 1263 "voices.cpp"
            $score=$add151; //@line 1263 "voices.cpp"
            __lastLabel__ = 58; __label__ = 60;break $if_then124$$if_end153thread_pre_split$73; //@line 1263 "voices.cpp"
          }
        } while(0);
        if (__label__ == 59) {
  
          var $_pr2=$score; //@line 1265 "voices.cpp"
          __lastLabel__ = 59; ;
        }
  
        var $101=__lastLabel__ == 59 ? $_pr2 : ($add151); //@line 1265 "voices.cpp"
        var $cmp154=((($101))|0) < 1; //@line 1265 "voices.cpp"
        if ($cmp154) { __label__ = 61;; } else { __label__ = 62;; } //@line 1265 "voices.cpp"
        if (__label__ == 61) {
  
          $score=1; //@line 1266 "voices.cpp"
          ; //@line 1266 "voices.cpp"
        }
  
        var $102=$score; //@line 1267 "voices.cpp"
        $retval=$102; //@line 1267 "voices.cpp"
        ; //@line 1267 "voices.cpp"
      }
    } while(0);
  
    var $103=$retval; //@line 1268 "voices.cpp"
    ;
    return $103; //@line 1268 "voices.cpp"
    return null;
  }
  

  function __ZL16VoiceScoreSorterPKvS0_($p1, $p2) {
    ;
    var __label__;
  
    var $retval;
    var $p1_addr;
    var $p2_addr;
    var $ix;
    var $v1;
    var $v2;
    $p1_addr=$p1;
    $p2_addr=$p2;
    var $0=$p1_addr; //@line 1118 "voices.cpp"
    var $1=$0; //@line 1118 "voices.cpp"
    var $2=HEAP32[(($1)>>2)]; //@line 1118 "voices.cpp"
    $v1=$2; //@line 1118 "voices.cpp"
    var $3=$p2_addr; //@line 1119 "voices.cpp"
    var $4=$3; //@line 1119 "voices.cpp"
    var $5=HEAP32[(($4)>>2)]; //@line 1119 "voices.cpp"
    $v2=$5; //@line 1119 "voices.cpp"
    var $6=$v2; //@line 1121 "voices.cpp"
    var $score=(($6+16)&4294967295); //@line 1121 "voices.cpp"
    var $7=HEAP32[(($score)>>2)]; //@line 1121 "voices.cpp"
    var $8=$v1; //@line 1121 "voices.cpp"
    var $score1=(($8+16)&4294967295); //@line 1121 "voices.cpp"
    var $9=HEAP32[(($score1)>>2)]; //@line 1121 "voices.cpp"
    var $sub=((($7)-($9))&4294967295); //@line 1121 "voices.cpp"
    $ix=$sub; //@line 1121 "voices.cpp"
    var $cmp=((($sub))|0)!=0; //@line 1121 "voices.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 1121 "voices.cpp"
    if (__label__ == 1) {
  
      var $10=$ix; //@line 1122 "voices.cpp"
      $retval=$10; //@line 1122 "voices.cpp"
      ; //@line 1122 "voices.cpp"
    }
    else if (__label__ == 2) {
  
      var $11=$v1; //@line 1123 "voices.cpp"
      var $name=(($11)&4294967295); //@line 1123 "voices.cpp"
      var $12=HEAP32[(($name)>>2)]; //@line 1123 "voices.cpp"
      var $13=$v2; //@line 1123 "voices.cpp"
      var $name2=(($13)&4294967295); //@line 1123 "voices.cpp"
      var $14=HEAP32[(($name2)>>2)]; //@line 1123 "voices.cpp"
      var $call=_strcmp($12, $14); //@line 1123 "voices.cpp"
      $retval=$call; //@line 1123 "voices.cpp"
      ; //@line 1123 "voices.cpp"
    }
  
    var $15=$retval; //@line 1124 "voices.cpp"
    ;
    return $15; //@line 1124 "voices.cpp"
    return null;
  }
  

  function __Z9WcmdqStopv() {
    ;
    var __label__;
  
    HEAP32[((_wcmdq_head)>>2)]=0; //@line 287 "wavegen.cpp"
    HEAP32[((_wcmdq_tail)>>2)]=0; //@line 288 "wavegen.cpp"
    var $0=HEAP32[((__ZL18sonicSpeedupStream)>>2)]; //@line 289 "wavegen.cpp"
    var $cmp=((($0))|0)!=0; //@line 289 "wavegen.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 289 "wavegen.cpp"
    if (__label__ == 1) {
  
      var $1=HEAP32[((__ZL18sonicSpeedupStream)>>2)]; //@line 291 "wavegen.cpp"
      _sonicDestroyStream($1); //@line 291 "wavegen.cpp"
      HEAP32[((__ZL18sonicSpeedupStream)>>2)]=0; //@line 292 "wavegen.cpp"
      ; //@line 293 "wavegen.cpp"
    }
  
    var $2=HEAP8[(((_mbrola_name)&4294967295))]; //@line 297 "wavegen.cpp"
    var $conv=(tempInt=(($2)),(tempInt>=128?tempInt-256:tempInt)); //@line 297 "wavegen.cpp"
    var $cmp1=((($conv))|0)!=0; //@line 297 "wavegen.cpp"
    if ($cmp1) { __label__ = 3;; } else { __label__ = 4;; } //@line 297 "wavegen.cpp"
    if (__label__ == 3) {
  
      __Z11MbrolaResetv(); //@line 298 "wavegen.cpp"
      ; //@line 298 "wavegen.cpp"
    }
  
    ;
    return; //@line 299 "wavegen.cpp"
    return;
  }
  

  function __Z9WcmdqFreev() {
    ;
    var __label__;
  
    var $i;
    var $0=HEAP32[((_wcmdq_head)>>2)]; //@line 305 "wavegen.cpp"
    var $1=HEAP32[((_wcmdq_tail)>>2)]; //@line 305 "wavegen.cpp"
    var $sub=((($0)-($1))&4294967295); //@line 305 "wavegen.cpp"
    $i=$sub; //@line 305 "wavegen.cpp"
    var $2=$i; //@line 306 "wavegen.cpp"
    var $cmp=((($2))|0) <= 0; //@line 306 "wavegen.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 306 "wavegen.cpp"
    if (__label__ == 1) {
  
      var $3=$i; //@line 306 "wavegen.cpp"
      var $add=((($3)+160)&4294967295); //@line 306 "wavegen.cpp"
      $i=$add; //@line 306 "wavegen.cpp"
      ; //@line 306 "wavegen.cpp"
    }
  
    var $4=$i; //@line 307 "wavegen.cpp"
    ;
    return $4; //@line 307 "wavegen.cpp"
    return null;
  }
  

  function __Z9WcmdqUsedv() {
    ;
    var __label__;
  
    var $call=__Z9WcmdqFreev(); //@line 312 "wavegen.cpp"
    var $sub=((160-($call))&4294967295); //@line 312 "wavegen.cpp"
    ;
    return $sub; //@line 312 "wavegen.cpp"
    return null;
  }
  

  function __Z8WcmdqIncv() {
    ;
    var __label__;
  
    var $0=HEAP32[((_wcmdq_tail)>>2)]; //@line 318 "wavegen.cpp"
    var $inc=((($0)+1)&4294967295); //@line 318 "wavegen.cpp"
    HEAP32[((_wcmdq_tail)>>2)]=$inc; //@line 318 "wavegen.cpp"
    var $cmp=((($inc))|0) >= 160; //@line 319 "wavegen.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 319 "wavegen.cpp"
    if (__label__ == 1) {
  
      HEAP32[((_wcmdq_tail)>>2)]=0; //@line 319 "wavegen.cpp"
      ; //@line 319 "wavegen.cpp"
    }
  
    ;
    return; //@line 320 "wavegen.cpp"
    return;
  }
  

  function __Z16WavegenOpenSoundv() {
    ;
    var __label__;
  
    ;
    return 0; //@line 715 "wavegen.cpp"
    return null;
  }
  

  function __Z17WavegenCloseSoundv() {
    ;
    var __label__;
  
    ;
    return 0; //@line 719 "wavegen.cpp"
    return null;
  }
  

  function __Z16WavegenInitSoundv() {
    ;
    var __label__;
  
    ;
    return 0; //@line 723 "wavegen.cpp"
    return null;
  }
  

  function __Z11WavegenInitii($rate, $wavemult_fact) {
    ;
    var __label__;
  
    var $rate_addr;
    var $wavemult_fact_addr;
    var $ix;
    var $x;
    $rate_addr=$rate;
    $wavemult_fact_addr=$wavemult_fact;
    var $0=$wavemult_fact_addr; //@line 733 "wavegen.cpp"
    var $cmp=((($0))|0)==0; //@line 733 "wavegen.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 733 "wavegen.cpp"
    if (__label__ == 1) {
  
      $wavemult_fact_addr=60; //@line 734 "wavegen.cpp"
      ; //@line 734 "wavegen.cpp"
    }
  
    HEAP32[((_wvoice)>>2)]=0; //@line 736 "wavegen.cpp"
    var $1=$rate_addr; //@line 737 "wavegen.cpp"
    HEAP32[((_samplerate_native)>>2)]=$1; //@line 737 "wavegen.cpp"
    HEAP32[((_samplerate)>>2)]=$1; //@line 737 "wavegen.cpp"
    var $2=HEAP32[((_samplerate)>>2)]; //@line 738 "wavegen.cpp"
    var $div=((134217728/((($2))|0))|0); //@line 738 "wavegen.cpp"
    HEAP32[((__ZL16PHASE_INC_FACTOR)>>2)]=$div; //@line 738 "wavegen.cpp"
    var $3=HEAP32[((_samplerate)>>2)]; //@line 739 "wavegen.cpp"
    var $mul=((($3)*64)&4294967295); //@line 739 "wavegen.cpp"
    var $4=$rate_addr; //@line 739 "wavegen.cpp"
    var $div1=((((($mul))|0)/((($4))|0))|0); //@line 739 "wavegen.cpp"
    HEAP32[((__ZL11Flutter_inc)>>2)]=$div1; //@line 739 "wavegen.cpp"
    HEAP32[((__ZL11samplecount)>>2)]=0; //@line 740 "wavegen.cpp"
    HEAP32[((__ZL8nsamples)>>2)]=0; //@line 741 "wavegen.cpp"
    HEAP32[((__ZL9wavephase)>>2)]=2147483647; //@line 742 "wavegen.cpp"
    HEAP32[((((_wdata+52)&4294967295))>>2)]=32; //@line 745 "wavegen.cpp"
    HEAP32[((((_wdata+60)&4294967295))>>2)]=100; //@line 746 "wavegen.cpp"
    $ix=0; //@line 748 "wavegen.cpp"
    ; //@line 748 "wavegen.cpp"
    $for_body$5: while(1) { 
  
      var $5=$ix; //@line 749 "wavegen.cpp"
      var $arrayidx=((_embedded_default+$5*4)&4294967295); //@line 749 "wavegen.cpp"
      var $6=HEAP32[(($arrayidx)>>2)]; //@line 749 "wavegen.cpp"
      var $7=$ix; //@line 749 "wavegen.cpp"
      var $arrayidx3=((_embedded_value+$7*4)&4294967295); //@line 749 "wavegen.cpp"
      HEAP32[(($arrayidx3)>>2)]=$6; //@line 749 "wavegen.cpp"
      var $8=$ix; //@line 748 "wavegen.cpp"
      var $inc=((($8)+1)&4294967295); //@line 748 "wavegen.cpp"
      $ix=$inc; //@line 748 "wavegen.cpp"
      var $cmp2=((($inc))|0) < 15; //@line 748 "wavegen.cpp"
      if ($cmp2) { __label__ = 3;continue $for_body$5; } else { __label__ = 4;break $for_body$5; } //@line 748 "wavegen.cpp"
    }
  
    var $9=HEAP32[((_samplerate)>>2)]; //@line 754 "wavegen.cpp"
    var $10=$wavemult_fact_addr; //@line 754 "wavegen.cpp"
    var $mul4=((($10)*($9))&4294967295); //@line 754 "wavegen.cpp"
    var $div5=((((($mul4))|0)/12800)|0); //@line 754 "wavegen.cpp"
    HEAP32[((__ZL12wavemult_max)>>2)]=$div5; //@line 754 "wavegen.cpp"
    var $11=HEAP32[((__ZL12wavemult_max)>>2)]; //@line 755 "wavegen.cpp"
    var $cmp6=((($11))|0) > 128; //@line 755 "wavegen.cpp"
    if ($cmp6) { __label__ = 5;; } else { __label__ = 6;; } //@line 755 "wavegen.cpp"
    if (__label__ == 5) {
  
      HEAP32[((__ZL12wavemult_max)>>2)]=128; //@line 755 "wavegen.cpp"
      ; //@line 755 "wavegen.cpp"
    }
  
    var $12=HEAP32[((__ZL12wavemult_max)>>2)]; //@line 757 "wavegen.cpp"
    var $div9=((((($12))|0)/2)|0); //@line 757 "wavegen.cpp"
    HEAP32[((__ZL15wavemult_offset)>>2)]=$div9; //@line 757 "wavegen.cpp"
    var $13=HEAP32[((_samplerate)>>2)]; //@line 759 "wavegen.cpp"
    var $cmp10=((($13))|0)!=22050; //@line 759 "wavegen.cpp"
    if ($cmp10) { __label__ = 7;; } else { __label__ = 9;; } //@line 759 "wavegen.cpp"
    $if_then11$$if_end25$11: do { 
      if (__label__ == 7) {
  
        $ix=0; //@line 763 "wavegen.cpp"
        var $14=$ix; //@line 763 "wavegen.cpp"
        var $15=HEAP32[((__ZL12wavemult_max)>>2)]; //@line 763 "wavegen.cpp"
        var $cmp131=((($14))|0) < ((($15))|0); //@line 763 "wavegen.cpp"
        if (!($cmp131)) { __label__ = 9;break $if_then11$$if_end25$11; } //@line 763 "wavegen.cpp"
        while(1) { 
  
          var $16=$ix; //@line 765 "wavegen.cpp"
          var $conv=((($16))|0); //@line 765 "wavegen.cpp"
          var $mul15=6.283185307*($conv); //@line 765 "wavegen.cpp"
          var $17=HEAP32[((__ZL12wavemult_max)>>2)]; //@line 765 "wavegen.cpp"
          var $conv16=((($17))|0); //@line 765 "wavegen.cpp"
          var $div17=($mul15)/($conv16); //@line 765 "wavegen.cpp"
          var $call=_cos($div17); //@line 765 "wavegen.cpp"
          var $sub=1-($call); //@line 765 "wavegen.cpp"
          var $mul18=127*($sub); //@line 765 "wavegen.cpp"
          $x=$mul18; //@line 765 "wavegen.cpp"
          var $18=$x; //@line 766 "wavegen.cpp"
          var $conv19=((($18))|0); //@line 766 "wavegen.cpp"
          var $conv20=((($conv19)) & 255); //@line 766 "wavegen.cpp"
          var $19=$ix; //@line 766 "wavegen.cpp"
          var $arrayidx21=((__ZL8wavemult+$19)&4294967295); //@line 766 "wavegen.cpp"
          HEAP8[($arrayidx21)]=$conv20; //@line 766 "wavegen.cpp"
          var $20=$ix; //@line 763 "wavegen.cpp"
          var $inc23=((($20)+1)&4294967295); //@line 763 "wavegen.cpp"
          $ix=$inc23; //@line 763 "wavegen.cpp"
          var $21=$ix; //@line 763 "wavegen.cpp"
          var $22=HEAP32[((__ZL12wavemult_max)>>2)]; //@line 763 "wavegen.cpp"
          var $cmp13=((($21))|0) < ((($22))|0); //@line 763 "wavegen.cpp"
          if ($cmp13) { __label__ = 8;continue ; } else { __label__ = 9;break $if_then11$$if_end25$11; } //@line 763 "wavegen.cpp"
        }
      }
    } while(0);
  
    __ZL17WavegenInitPkDatai(1); //@line 770 "wavegen.cpp"
    __ZL17WavegenInitPkDatai(0); //@line 771 "wavegen.cpp"
    HEAP32[((__ZL8pk_shape)>>2)]=((__ZL9pk_shape2)&4294967295); //@line 772 "wavegen.cpp"
    __Z9KlattInitv(); //@line 775 "wavegen.cpp"
    ;
    return; //@line 782 "wavegen.cpp"
    return;
  }
  

  function __ZL17WavegenInitPkDatai($which) {
    ;
    var __label__;
  
    ;
    return; //@line 411 "wavegen.cpp"
    return;
  }
  

  function __Z12GetAmplitudev() {
    ;
    var __label__;
  
    var $amp;
    var $0=HEAP32[((((_embedded_value+12)&4294967295))>>2)]; //@line 792 "wavegen.cpp"
    var $mul=((($0)*55)&4294967295); //@line 792 "wavegen.cpp"
    var $div=((((($mul))|0)/100)|0); //@line 792 "wavegen.cpp"
    $amp=$div; //@line 792 "wavegen.cpp"
    var $1=$amp; //@line 793 "wavegen.cpp"
    var $2=HEAP32[((((_embedded_value+52)&4294967295))>>2)]; //@line 793 "wavegen.cpp"
    var $arrayidx=((__ZZ12GetAmplitudevE12amp_emphasis+$2)&4294967295); //@line 793 "wavegen.cpp"
    var $3=HEAPU8[($arrayidx)]; //@line 793 "wavegen.cpp"
    var $conv=((($3))&255); //@line 793 "wavegen.cpp"
    var $mul1=((($conv)*($1))&4294967295); //@line 793 "wavegen.cpp"
    var $div2=((((($mul1))|0)/16)|0); //@line 793 "wavegen.cpp"
    HEAP32[((__ZL17general_amplitude)>>2)]=$div2; //@line 793 "wavegen.cpp"
    var $4=HEAP32[((__ZL17general_amplitude)>>2)]; //@line 794 "wavegen.cpp"
    ;
    return $4; //@line 794 "wavegen.cpp"
    return null;
  }
  

  function __Z16PeaksToHarmspectP15wavegen_peaks_tiPii($peaks, $pitch, $htab, $control) {
    ;
    var __label__;
  
    var $retval;
    var $peaks_addr;
    var $pitch_addr;
    var $htab_addr;
    var $control_addr;
    var $f;
    var $p;
    var $fp;
    var $fhi;
    var $h;
    var $pk;
    var $hmax;
    var $hmax_samplerate;
    var $x;
    var $ix;
    var $h1;
    var $y;
    var $h2;
    $peaks_addr=$peaks;
    $pitch_addr=$pitch;
    $htab_addr=$htab;
    $control_addr=$control;
    var $0=HEAP32[((_wvoice)>>2)]; //@line 877 "wavegen.cpp"
    var $cmp=((($0))|0)==0; //@line 877 "wavegen.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 877 "wavegen.cpp"
    if (__label__ == 1) {
  
      $retval=1; //@line 878 "wavegen.cpp"
      ; //@line 878 "wavegen.cpp"
    }
    else if (__label__ == 2) {
  
      var $1=HEAP32[((_wvoice)>>2)]; //@line 879 "wavegen.cpp"
      var $n_harmonic_peaks=(($1+84)&4294967295); //@line 879 "wavegen.cpp"
      var $2=HEAP32[(($n_harmonic_peaks)>>2)]; //@line 879 "wavegen.cpp"
      var $3=$peaks_addr; //@line 879 "wavegen.cpp"
      var $arrayidx=(($3+80*$2)&4294967295); //@line 879 "wavegen.cpp"
      var $freq=(($arrayidx)&4294967295); //@line 879 "wavegen.cpp"
      var $4=HEAP32[(($freq)>>2)]; //@line 879 "wavegen.cpp"
      var $5=HEAP32[((_wvoice)>>2)]; //@line 879 "wavegen.cpp"
      var $n_harmonic_peaks1=(($5+84)&4294967295); //@line 879 "wavegen.cpp"
      var $6=HEAP32[(($n_harmonic_peaks1)>>2)]; //@line 879 "wavegen.cpp"
      var $7=$peaks_addr; //@line 879 "wavegen.cpp"
      var $arrayidx2=(($7+80*$6)&4294967295); //@line 879 "wavegen.cpp"
      var $right=(($arrayidx2+12)&4294967295); //@line 879 "wavegen.cpp"
      var $8=HEAP32[(($right)>>2)]; //@line 879 "wavegen.cpp"
      var $add=((($8)+($4))&4294967295); //@line 879 "wavegen.cpp"
      var $9=$pitch_addr; //@line 879 "wavegen.cpp"
      var $div=((((($add))|0)/((($9))|0))|0); //@line 879 "wavegen.cpp"
      $hmax=$div; //@line 879 "wavegen.cpp"
      var $10=$hmax; //@line 880 "wavegen.cpp"
      var $cmp3=((($10))|0) >= 400; //@line 880 "wavegen.cpp"
      if ($cmp3) { __label__ = 3;; } else { __label__ = 4;; } //@line 880 "wavegen.cpp"
      if (__label__ == 3) {
  
        $hmax=399; //@line 881 "wavegen.cpp"
        ; //@line 881 "wavegen.cpp"
      }
  
      var $11=HEAP32[((_samplerate)>>2)]; //@line 884 "wavegen.cpp"
      var $mul=((($11)*19)&4294967295); //@line 884 "wavegen.cpp"
      var $div6=((((($mul))|0)/40)|0); //@line 884 "wavegen.cpp"
      var $shl=($div6) << 16; //@line 884 "wavegen.cpp"
      var $12=$pitch_addr; //@line 884 "wavegen.cpp"
      var $div7=((((($shl))|0)/((($12))|0))|0); //@line 884 "wavegen.cpp"
      $hmax_samplerate=$div7; //@line 884 "wavegen.cpp"
      var $13=$hmax; //@line 887 "wavegen.cpp"
      var $14=$hmax_samplerate; //@line 887 "wavegen.cpp"
      var $cmp8=((($13))|0) > ((($14))|0); //@line 887 "wavegen.cpp"
      if ($cmp8) { __label__ = 5;; } else { __label__ = 6;; } //@line 887 "wavegen.cpp"
      if (__label__ == 5) {
  
        var $15=$hmax_samplerate; //@line 888 "wavegen.cpp"
        $hmax=$15; //@line 888 "wavegen.cpp"
        ; //@line 888 "wavegen.cpp"
      }
  
      $h=0; //@line 890 "wavegen.cpp"
      var $16=$h; //@line 890 "wavegen.cpp"
      var $17=$hmax; //@line 890 "wavegen.cpp"
      var $cmp118=((($16))|0) <= ((($17))|0); //@line 890 "wavegen.cpp"
      if ($cmp118) { __label__ = 7;; } else { __label__ = 8;; } //@line 890 "wavegen.cpp"
      $for_body$$for_end$11: do { 
        if (__label__ == 7) {
          while(1) { 
  
            var $18=$h; //@line 891 "wavegen.cpp"
            var $19=$htab_addr; //@line 891 "wavegen.cpp"
            var $arrayidx12=(($19+4*$18)&4294967295); //@line 891 "wavegen.cpp"
            HEAP32[(($arrayidx12)>>2)]=0; //@line 891 "wavegen.cpp"
            var $20=$h; //@line 890 "wavegen.cpp"
            var $inc=((($20)+1)&4294967295); //@line 890 "wavegen.cpp"
            $h=$inc; //@line 890 "wavegen.cpp"
            var $21=$h; //@line 890 "wavegen.cpp"
            var $22=$hmax; //@line 890 "wavegen.cpp"
            var $cmp11=((($21))|0) <= ((($22))|0); //@line 890 "wavegen.cpp"
            if ($cmp11) { __label__ = 7;continue ; } else { __label__ = 8;break $for_body$$for_end$11; } //@line 890 "wavegen.cpp"
          }
        }
      } while(0);
  
      $h=0; //@line 893 "wavegen.cpp"
      $pk=0; //@line 894 "wavegen.cpp"
      var $23=$pk; //@line 894 "wavegen.cpp"
      var $24=HEAP32[((_wvoice)>>2)]; //@line 894 "wavegen.cpp"
      var $n_harmonic_peaks146=(($24+84)&4294967295); //@line 894 "wavegen.cpp"
      var $25=HEAP32[(($n_harmonic_peaks146)>>2)]; //@line 894 "wavegen.cpp"
      var $cmp157=((($23))|0) <= ((($25))|0); //@line 894 "wavegen.cpp"
      if ($cmp157) { __label__ = 9;; } else { __label__ = 18;; } //@line 894 "wavegen.cpp"
      $for_body16$$for_end67$15: do { 
        if (__label__ == 9) {
          $for_body16$16: while(1) { 
  
            var $26=$pk; //@line 896 "wavegen.cpp"
            var $27=$peaks_addr; //@line 896 "wavegen.cpp"
            var $arrayidx17=(($27+80*$26)&4294967295); //@line 896 "wavegen.cpp"
            $p=$arrayidx17; //@line 896 "wavegen.cpp"
            var $28=$p; //@line 897 "wavegen.cpp"
            var $height=(($28+4)&4294967295); //@line 897 "wavegen.cpp"
            var $29=HEAP32[(($height)>>2)]; //@line 897 "wavegen.cpp"
            var $cmp18=((($29))|0)==0; //@line 897 "wavegen.cpp"
            if ($cmp18) { __label__ = 17;; } else { __label__ = 10;; } //@line 897 "wavegen.cpp"
            $for_inc65$$lor_lhs_false$18: do { 
              if (__label__ == 10) {
  
                var $30=$p; //@line 897 "wavegen.cpp"
                var $freq19=(($30)&4294967295); //@line 897 "wavegen.cpp"
                var $31=HEAP32[(($freq19)>>2)]; //@line 897 "wavegen.cpp"
                $fp=$31; //@line 897 "wavegen.cpp"
                var $cmp20=((($31))|0)==0; //@line 897 "wavegen.cpp"
                if ($cmp20) { __label__ = 17;break $for_inc65$$lor_lhs_false$18; } //@line 897 "wavegen.cpp"
  
                var $32=$p; //@line 900 "wavegen.cpp"
                var $freq23=(($32)&4294967295); //@line 900 "wavegen.cpp"
                var $33=HEAP32[(($freq23)>>2)]; //@line 900 "wavegen.cpp"
                var $34=$p; //@line 900 "wavegen.cpp"
                var $right24=(($34+12)&4294967295); //@line 900 "wavegen.cpp"
                var $35=HEAP32[(($right24)>>2)]; //@line 900 "wavegen.cpp"
                var $add25=((($35)+($33))&4294967295); //@line 900 "wavegen.cpp"
                $fhi=$add25; //@line 900 "wavegen.cpp"
                var $36=$p; //@line 901 "wavegen.cpp"
                var $freq26=(($36)&4294967295); //@line 901 "wavegen.cpp"
                var $37=HEAP32[(($freq26)>>2)]; //@line 901 "wavegen.cpp"
                var $38=$p; //@line 901 "wavegen.cpp"
                var $left=(($38+8)&4294967295); //@line 901 "wavegen.cpp"
                var $39=HEAP32[(($left)>>2)]; //@line 901 "wavegen.cpp"
                var $sub=((($37)-($39))&4294967295); //@line 901 "wavegen.cpp"
                var $40=$pitch_addr; //@line 901 "wavegen.cpp"
                var $div27=((((($sub))|0)/((($40))|0))|0); //@line 901 "wavegen.cpp"
                var $add28=((($div27)+1)&4294967295); //@line 901 "wavegen.cpp"
                $h=$add28; //@line 901 "wavegen.cpp"
                var $41=$h; //@line 902 "wavegen.cpp"
                var $cmp29=((($41))|0) <= 0; //@line 902 "wavegen.cpp"
                if ($cmp29) { __label__ = 12;; } else { __label__ = 13;; } //@line 902 "wavegen.cpp"
                if (__label__ == 12) {
  
                  $h=1; //@line 902 "wavegen.cpp"
                  ; //@line 902 "wavegen.cpp"
                }
  
                var $42=$pitch_addr; //@line 904 "wavegen.cpp"
                var $43=$h; //@line 904 "wavegen.cpp"
                var $mul32=((($43)*($42))&4294967295); //@line 904 "wavegen.cpp"
                $f=$mul32; //@line 904 "wavegen.cpp"
                var $44=$f; //@line 904 "wavegen.cpp"
                var $45=$fp; //@line 904 "wavegen.cpp"
                var $cmp344=((($44))|0) < ((($45))|0); //@line 904 "wavegen.cpp"
                if ($cmp344) { __label__ = 14;; } else { __label__ = 15;; } //@line 904 "wavegen.cpp"
                $for_body35$$for_cond48_loopexit$24: do { 
                  if (__label__ == 14) {
                    while(1) { 
  
                      var $46=$fp; //@line 906 "wavegen.cpp"
                      var $47=$f; //@line 906 "wavegen.cpp"
                      var $sub36=((($46)-($47))&4294967295); //@line 906 "wavegen.cpp"
                      var $48=$p; //@line 906 "wavegen.cpp"
                      var $left37=(($48+8)&4294967295); //@line 906 "wavegen.cpp"
                      var $49=HEAP32[(($left37)>>2)]; //@line 906 "wavegen.cpp"
                      var $shr=($49) >> 8; //@line 906 "wavegen.cpp"
                      var $div38=((((($sub36))|0)/((($shr))|0))|0); //@line 906 "wavegen.cpp"
                      var $50=HEAP32[((__ZL8pk_shape)>>2)]; //@line 906 "wavegen.cpp"
                      var $arrayidx39=(($50+$div38)&4294967295); //@line 906 "wavegen.cpp"
                      var $51=HEAPU8[($arrayidx39)]; //@line 906 "wavegen.cpp"
                      var $conv=((($51))&255); //@line 906 "wavegen.cpp"
                      var $52=$p; //@line 906 "wavegen.cpp"
                      var $height40=(($52+4)&4294967295); //@line 906 "wavegen.cpp"
                      var $53=HEAP32[(($height40)>>2)]; //@line 906 "wavegen.cpp"
                      var $mul41=((($53)*($conv))&4294967295); //@line 906 "wavegen.cpp"
                      var $54=$h; //@line 906 "wavegen.cpp"
                      var $inc42=((($54)+1)&4294967295); //@line 906 "wavegen.cpp"
                      $h=$inc42; //@line 906 "wavegen.cpp"
                      var $55=$htab_addr; //@line 906 "wavegen.cpp"
                      var $arrayidx43=(($55+4*$54)&4294967295); //@line 906 "wavegen.cpp"
                      var $56=HEAP32[(($arrayidx43)>>2)]; //@line 906 "wavegen.cpp"
                      var $add44=((($56)+($mul41))&4294967295); //@line 906 "wavegen.cpp"
                      HEAP32[(($arrayidx43)>>2)]=$add44; //@line 906 "wavegen.cpp"
                      var $57=$pitch_addr; //@line 904 "wavegen.cpp"
                      var $58=$f; //@line 904 "wavegen.cpp"
                      var $add46=((($58)+($57))&4294967295); //@line 904 "wavegen.cpp"
                      $f=$add46; //@line 904 "wavegen.cpp"
                      var $59=$f; //@line 904 "wavegen.cpp"
                      var $60=$fp; //@line 904 "wavegen.cpp"
                      var $cmp34=((($59))|0) < ((($60))|0); //@line 904 "wavegen.cpp"
                      if ($cmp34) { __label__ = 14;continue ; } else { __label__ = 15;break $for_body35$$for_cond48_loopexit$24; } //@line 904 "wavegen.cpp"
                    }
                  }
                } while(0);
  
                var $61=$f; //@line 908 "wavegen.cpp"
                var $62=$fhi; //@line 908 "wavegen.cpp"
                var $cmp495=((($61))|0) < ((($62))|0); //@line 908 "wavegen.cpp"
                if (!($cmp495)) { __label__ = 17;break $for_inc65$$lor_lhs_false$18; } //@line 908 "wavegen.cpp"
                while(1) { 
  
                  var $63=$f; //@line 910 "wavegen.cpp"
                  var $64=$fp; //@line 910 "wavegen.cpp"
                  var $sub51=((($63)-($64))&4294967295); //@line 910 "wavegen.cpp"
                  var $65=$p; //@line 910 "wavegen.cpp"
                  var $right52=(($65+12)&4294967295); //@line 910 "wavegen.cpp"
                  var $66=HEAP32[(($right52)>>2)]; //@line 910 "wavegen.cpp"
                  var $shr53=($66) >> 8; //@line 910 "wavegen.cpp"
                  var $div54=((((($sub51))|0)/((($shr53))|0))|0); //@line 910 "wavegen.cpp"
                  var $67=HEAP32[((__ZL8pk_shape)>>2)]; //@line 910 "wavegen.cpp"
                  var $arrayidx55=(($67+$div54)&4294967295); //@line 910 "wavegen.cpp"
                  var $68=HEAPU8[($arrayidx55)]; //@line 910 "wavegen.cpp"
                  var $conv56=((($68))&255); //@line 910 "wavegen.cpp"
                  var $69=$p; //@line 910 "wavegen.cpp"
                  var $height57=(($69+4)&4294967295); //@line 910 "wavegen.cpp"
                  var $70=HEAP32[(($height57)>>2)]; //@line 910 "wavegen.cpp"
                  var $mul58=((($70)*($conv56))&4294967295); //@line 910 "wavegen.cpp"
                  var $71=$h; //@line 910 "wavegen.cpp"
                  var $inc59=((($71)+1)&4294967295); //@line 910 "wavegen.cpp"
                  $h=$inc59; //@line 910 "wavegen.cpp"
                  var $72=$htab_addr; //@line 910 "wavegen.cpp"
                  var $arrayidx60=(($72+4*$71)&4294967295); //@line 910 "wavegen.cpp"
                  var $73=HEAP32[(($arrayidx60)>>2)]; //@line 910 "wavegen.cpp"
                  var $add61=((($73)+($mul58))&4294967295); //@line 910 "wavegen.cpp"
                  HEAP32[(($arrayidx60)>>2)]=$add61; //@line 910 "wavegen.cpp"
                  var $74=$pitch_addr; //@line 908 "wavegen.cpp"
                  var $75=$f; //@line 908 "wavegen.cpp"
                  var $add63=((($75)+($74))&4294967295); //@line 908 "wavegen.cpp"
                  $f=$add63; //@line 908 "wavegen.cpp"
                  var $76=$f; //@line 908 "wavegen.cpp"
                  var $77=$fhi; //@line 908 "wavegen.cpp"
                  var $cmp49=((($76))|0) < ((($77))|0); //@line 908 "wavegen.cpp"
                  if ($cmp49) { __label__ = 16;continue ; } else { __label__ = 17;break $for_inc65$$lor_lhs_false$18; } //@line 908 "wavegen.cpp"
                }
              }
            } while(0);
  
            var $78=$pk; //@line 894 "wavegen.cpp"
            var $inc66=((($78)+1)&4294967295); //@line 894 "wavegen.cpp"
            $pk=$inc66; //@line 894 "wavegen.cpp"
            var $79=$pk; //@line 894 "wavegen.cpp"
            var $80=HEAP32[((_wvoice)>>2)]; //@line 894 "wavegen.cpp"
            var $n_harmonic_peaks14=(($80+84)&4294967295); //@line 894 "wavegen.cpp"
            var $81=HEAP32[(($n_harmonic_peaks14)>>2)]; //@line 894 "wavegen.cpp"
            var $cmp15=((($79))|0) <= ((($81))|0); //@line 894 "wavegen.cpp"
            if ($cmp15) { __label__ = 9;continue $for_body16$16; } else { __label__ = 18;break $for_body16$$for_end67$15; } //@line 894 "wavegen.cpp"
          }
        }
      } while(0);
  
      var $82=$peaks_addr; //@line 918 "wavegen.cpp"
      var $arrayidx68=(($82+80)&4294967295); //@line 918 "wavegen.cpp"
      var $height69=(($arrayidx68+4)&4294967295); //@line 918 "wavegen.cpp"
      var $83=HEAP32[(($height69)>>2)]; //@line 918 "wavegen.cpp"
      var $mul70=((($83)*10)&4294967295); //@line 918 "wavegen.cpp"
      $y=$mul70; //@line 918 "wavegen.cpp"
      var $84=$pitch_addr; //@line 919 "wavegen.cpp"
      var $div71=((65536000/((($84))|0))|0); //@line 919 "wavegen.cpp"
      $h2=$div71; //@line 919 "wavegen.cpp"
      var $cmp72=((($div71))|0) > 0; //@line 920 "wavegen.cpp"
      if ($cmp72) { __label__ = 19;; } else { __label__ = 21;; } //@line 920 "wavegen.cpp"
      $if_then73$$for_cond81thread_pre_split$32: do { 
        if (__label__ == 19) {
  
          var $85=$y; //@line 922 "wavegen.cpp"
          var $86=$h2; //@line 922 "wavegen.cpp"
          var $div74=((((($85))|0)/((($86))|0))|0); //@line 922 "wavegen.cpp"
          $x=$div74; //@line 922 "wavegen.cpp"
          $h=1; //@line 923 "wavegen.cpp"
          var $cmp753=((($85))|0) > 0; //@line 924 "wavegen.cpp"
          if (!($cmp753)) { __label__ = 21;break $if_then73$$for_cond81thread_pre_split$32; } //@line 924 "wavegen.cpp"
          while(1) { 
  
            var $87=$y; //@line 926 "wavegen.cpp"
            var $88=$h; //@line 926 "wavegen.cpp"
            var $inc76=((($88)+1)&4294967295); //@line 926 "wavegen.cpp"
            $h=$inc76; //@line 926 "wavegen.cpp"
            var $89=$htab_addr; //@line 926 "wavegen.cpp"
            var $arrayidx77=(($89+4*$88)&4294967295); //@line 926 "wavegen.cpp"
            var $90=HEAP32[(($arrayidx77)>>2)]; //@line 926 "wavegen.cpp"
            var $add78=((($90)+($87))&4294967295); //@line 926 "wavegen.cpp"
            HEAP32[(($arrayidx77)>>2)]=$add78; //@line 926 "wavegen.cpp"
            var $91=$x; //@line 927 "wavegen.cpp"
            var $92=$y; //@line 927 "wavegen.cpp"
            var $sub79=((($92)-($91))&4294967295); //@line 927 "wavegen.cpp"
            $y=$sub79; //@line 927 "wavegen.cpp"
            var $cmp75=((($sub79))|0) > 0; //@line 924 "wavegen.cpp"
            if ($cmp75) { __label__ = 20;continue ; } else { __label__ = 21;break $if_then73$$for_cond81thread_pre_split$32; } //@line 924 "wavegen.cpp"
          }
        }
      } while(0);
  
      var $_pr=$pk; //@line 933 "wavegen.cpp"
      var $cmp822=((($_pr))|0) < 9; //@line 933 "wavegen.cpp"
      if ($cmp822) { __label__ = 22;; } else { __label__ = 27;; } //@line 933 "wavegen.cpp"
      $for_body83$$for_end105$37: do { 
        if (__label__ == 22) {
          while(1) { 
  
            var $93=$pk; //@line 935 "wavegen.cpp"
            var $94=$peaks_addr; //@line 935 "wavegen.cpp"
            var $arrayidx84=(($94+80*$93)&4294967295); //@line 935 "wavegen.cpp"
            var $height85=(($arrayidx84+4)&4294967295); //@line 935 "wavegen.cpp"
            var $95=HEAP32[(($height85)>>2)]; //@line 935 "wavegen.cpp"
            var $shr86=($95) >> 14; //@line 935 "wavegen.cpp"
            $x=$shr86; //@line 935 "wavegen.cpp"
            var $96=$x; //@line 936 "wavegen.cpp"
            var $97=$x; //@line 936 "wavegen.cpp"
            var $mul87=((($96)*5)&4294967295); //@line 936 "wavegen.cpp"
            var $mul88=((($mul87)*($97))&4294967295); //@line 936 "wavegen.cpp"
            var $div89=((((($mul88))|0)/2)|0); //@line 936 "wavegen.cpp"
            var $98=$pk; //@line 936 "wavegen.cpp"
            var $arrayidx90=((__ZL11peak_height+$98*4)&4294967295); //@line 936 "wavegen.cpp"
            HEAP32[(($arrayidx90)>>2)]=$div89; //@line 936 "wavegen.cpp"
            var $99=$control_addr; //@line 939 "wavegen.cpp"
            var $cmp91=((($99))|0)==0; //@line 939 "wavegen.cpp"
            if ($cmp91) { __label__ = 23;; } else { __label__ = 24;; } //@line 939 "wavegen.cpp"
            if (__label__ == 23) {
  
              var $100=$pk; //@line 942 "wavegen.cpp"
              var $101=$peaks_addr; //@line 942 "wavegen.cpp"
              var $arrayidx93=(($101+80*$100)&4294967295); //@line 942 "wavegen.cpp"
              var $freq94=(($arrayidx93)&4294967295); //@line 942 "wavegen.cpp"
              var $102=HEAP32[(($freq94)>>2)]; //@line 942 "wavegen.cpp"
              var $103=$pitch_addr; //@line 942 "wavegen.cpp"
              var $div95=((((($102))|0)/((($103))|0))|0); //@line 942 "wavegen.cpp"
              var $104=$pk; //@line 942 "wavegen.cpp"
              var $arrayidx96=((__ZL13peak_harmonic+$104*4)&4294967295); //@line 942 "wavegen.cpp"
              HEAP32[(($arrayidx96)>>2)]=$div95; //@line 942 "wavegen.cpp"
              ; //@line 943 "wavegen.cpp"
            }
  
            var $105=$pk; //@line 945 "wavegen.cpp"
            var $arrayidx98=((__ZL13peak_harmonic+$105*4)&4294967295); //@line 945 "wavegen.cpp"
            var $106=HEAP32[(($arrayidx98)>>2)]; //@line 945 "wavegen.cpp"
            var $107=$hmax_samplerate; //@line 945 "wavegen.cpp"
            var $cmp99=((($106))|0) >= ((($107))|0); //@line 945 "wavegen.cpp"
            if ($cmp99) { __label__ = 25;; } else { __label__ = 26;; } //@line 945 "wavegen.cpp"
            if (__label__ == 25) {
  
              var $108=$pk; //@line 946 "wavegen.cpp"
              var $arrayidx101=((__ZL11peak_height+$108*4)&4294967295); //@line 946 "wavegen.cpp"
              HEAP32[(($arrayidx101)>>2)]=0; //@line 946 "wavegen.cpp"
              ; //@line 946 "wavegen.cpp"
            }
  
            var $109=$pk; //@line 933 "wavegen.cpp"
            var $inc104=((($109)+1)&4294967295); //@line 933 "wavegen.cpp"
            $pk=$inc104; //@line 933 "wavegen.cpp"
            var $cmp82=((($inc104))|0) < 9; //@line 933 "wavegen.cpp"
            if ($cmp82) { __label__ = 22;continue ; } else { __label__ = 27;break $for_body83$$for_end105$37; } //@line 933 "wavegen.cpp"
          }
        }
      } while(0);
  
      $f=0; //@line 950 "wavegen.cpp"
      $h=0; //@line 951 "wavegen.cpp"
      var $110=$h; //@line 951 "wavegen.cpp"
      var $111=$hmax; //@line 951 "wavegen.cpp"
      var $cmp1071=((($110))|0) <= ((($111))|0); //@line 951 "wavegen.cpp"
      if ($cmp1071) { __label__ = 28;; } else { __label__ = 31;; } //@line 951 "wavegen.cpp"
      $for_body108$$for_end127$47: do { 
        if (__label__ == 28) {
          while(1) { 
  
            var $112=$h; //@line 953 "wavegen.cpp"
            var $113=$htab_addr; //@line 953 "wavegen.cpp"
            var $arrayidx109=(($113+4*$112)&4294967295); //@line 953 "wavegen.cpp"
            var $114=HEAP32[(($arrayidx109)>>2)]; //@line 953 "wavegen.cpp"
            var $shr110=($114) >> 15; //@line 953 "wavegen.cpp"
            $x=$shr110; //@line 953 "wavegen.cpp"
            var $115=$x; //@line 954 "wavegen.cpp"
            var $116=$x; //@line 954 "wavegen.cpp"
            var $mul111=((($116)*($115))&4294967295); //@line 954 "wavegen.cpp"
            var $shr112=($mul111) >> 8; //@line 954 "wavegen.cpp"
            var $117=$h; //@line 954 "wavegen.cpp"
            var $118=$htab_addr; //@line 954 "wavegen.cpp"
            var $arrayidx113=(($118+4*$117)&4294967295); //@line 954 "wavegen.cpp"
            HEAP32[(($arrayidx113)>>2)]=$shr112; //@line 954 "wavegen.cpp"
            var $119=$f; //@line 956 "wavegen.cpp"
            var $shr114=($119) >> 19; //@line 956 "wavegen.cpp"
            $ix=$shr114; //@line 956 "wavegen.cpp"
            var $cmp115=((($shr114))|0) < 1000; //@line 956 "wavegen.cpp"
            if ($cmp115) { __label__ = 29;; } else { __label__ = 30;; } //@line 956 "wavegen.cpp"
            if (__label__ == 29) {
  
              var $120=$h; //@line 958 "wavegen.cpp"
              var $121=$htab_addr; //@line 958 "wavegen.cpp"
              var $arrayidx117=(($121+4*$120)&4294967295); //@line 958 "wavegen.cpp"
              var $122=HEAP32[(($arrayidx117)>>2)]; //@line 958 "wavegen.cpp"
              var $123=$ix; //@line 958 "wavegen.cpp"
              var $124=HEAP32[((_wvoice)>>2)]; //@line 958 "wavegen.cpp"
              var $tone_adjust=(($124+344)&4294967295); //@line 958 "wavegen.cpp"
              var $arrayidx118=(($tone_adjust+$123)&4294967295); //@line 958 "wavegen.cpp"
              var $125=HEAPU8[($arrayidx118)]; //@line 958 "wavegen.cpp"
              var $conv119=((($125))&255); //@line 958 "wavegen.cpp"
              var $mul120=((($conv119)*($122))&4294967295); //@line 958 "wavegen.cpp"
              var $shr121=($mul120) >> 13; //@line 958 "wavegen.cpp"
              var $126=$h; //@line 958 "wavegen.cpp"
              var $127=$htab_addr; //@line 958 "wavegen.cpp"
              var $arrayidx122=(($127+4*$126)&4294967295); //@line 958 "wavegen.cpp"
              HEAP32[(($arrayidx122)>>2)]=$shr121; //@line 958 "wavegen.cpp"
              ; //@line 959 "wavegen.cpp"
            }
  
            var $128=$h; //@line 951 "wavegen.cpp"
            var $inc125=((($128)+1)&4294967295); //@line 951 "wavegen.cpp"
            $h=$inc125; //@line 951 "wavegen.cpp"
            var $129=$pitch_addr; //@line 951 "wavegen.cpp"
            var $130=$f; //@line 951 "wavegen.cpp"
            var $add126=((($130)+($129))&4294967295); //@line 951 "wavegen.cpp"
            $f=$add126; //@line 951 "wavegen.cpp"
            var $131=$h; //@line 951 "wavegen.cpp"
            var $132=$hmax; //@line 951 "wavegen.cpp"
            var $cmp107=((($131))|0) <= ((($132))|0); //@line 951 "wavegen.cpp"
            if ($cmp107) { __label__ = 28;continue ; } else { __label__ = 31;break $for_body108$$for_end127$47; } //@line 951 "wavegen.cpp"
          }
        }
      } while(0);
  
      var $133=$htab_addr; //@line 963 "wavegen.cpp"
      var $arrayidx128=(($133+4)&4294967295); //@line 963 "wavegen.cpp"
      var $134=HEAP32[(($arrayidx128)>>2)]; //@line 963 "wavegen.cpp"
      var $_b=HEAPU8[(__ZL16option_harmonic1_b)];
      var $135=($_b) ? 6 : 10;
      var $mul129=((($135)*($134))&4294967295); //@line 963 "wavegen.cpp"
      $h1=$mul129; //@line 963 "wavegen.cpp"
      var $136=$h1; //@line 964 "wavegen.cpp"
      var $div130=((((($136))|0)/8)|0); //@line 964 "wavegen.cpp"
      var $137=$htab_addr; //@line 964 "wavegen.cpp"
      var $arrayidx131=(($137+4)&4294967295); //@line 964 "wavegen.cpp"
      HEAP32[(($arrayidx131)>>2)]=$div130; //@line 964 "wavegen.cpp"
      var $138=$control_addr; //@line 968 "wavegen.cpp"
      var $and=($138) & 1; //@line 968 "wavegen.cpp"
      var $tobool=((($and))|0)!=0; //@line 968 "wavegen.cpp"
      if ($tobool) { __label__ = 32;; } else { __label__ = 34;; } //@line 968 "wavegen.cpp"
      $if_then132$$if_end144$54: do { 
        if (__label__ == 32) {
  
          $h=1; //@line 970 "wavegen.cpp"
          ; //@line 970 "wavegen.cpp"
          while(1) { 
  
            var $139=$h; //@line 972 "wavegen.cpp"
            var $140=$htab_addr; //@line 972 "wavegen.cpp"
            var $arrayidx136=(($140+4*$139)&4294967295); //@line 972 "wavegen.cpp"
            var $141=HEAP32[(($arrayidx136)>>2)]; //@line 972 "wavegen.cpp"
            var $142=$h; //@line 972 "wavegen.cpp"
            var $143=HEAP32[((__ZL9harmspect)>>2)]; //@line 972 "wavegen.cpp"
            var $arrayidx137=(($143+4*$142)&4294967295); //@line 972 "wavegen.cpp"
            var $144=HEAP32[(($arrayidx137)>>2)]; //@line 972 "wavegen.cpp"
            var $sub138=((($141)-($144))&4294967295); //@line 972 "wavegen.cpp"
            var $shr139=($sub138) >> 3; //@line 972 "wavegen.cpp"
            var $145=$h; //@line 972 "wavegen.cpp"
            var $arrayidx140=((__ZL8harm_inc+$145*4)&4294967295); //@line 972 "wavegen.cpp"
            HEAP32[(($arrayidx140)>>2)]=$shr139; //@line 972 "wavegen.cpp"
            var $146=$h; //@line 970 "wavegen.cpp"
            var $inc142=((($146)+1)&4294967295); //@line 970 "wavegen.cpp"
            $h=$inc142; //@line 970 "wavegen.cpp"
            var $cmp134=((($inc142))|0) < 30; //@line 970 "wavegen.cpp"
            if ($cmp134) { __label__ = 33;continue ; } else { __label__ = 34;break $if_then132$$if_end144$54; } //@line 970 "wavegen.cpp"
          }
        }
      } while(0);
  
      var $147=$hmax; //@line 976 "wavegen.cpp"
      $retval=$147; //@line 976 "wavegen.cpp"
      ; //@line 976 "wavegen.cpp"
    }
  
    var $148=$retval; //@line 977 "wavegen.cpp"
    ;
    return $148; //@line 977 "wavegen.cpp"
    return null;
  }
  

  function __Z10InitBreathv() {
    ;
    var __label__;
  
    var $ix;
    var $0=HEAP32[((_samplerate)>>2)]; //@line 1104 "wavegen.cpp"
    var $conv=((($0))|0); //@line 1104 "wavegen.cpp"
    var $div=-3.1415927/($conv); //@line 1104 "wavegen.cpp"
    HEAPF32[((__ZL10minus_pi_t)>>2)]=$div; //@line 1104 "wavegen.cpp"
    var $1=HEAPF32[((__ZL10minus_pi_t)>>2)]; //@line 1105 "wavegen.cpp"
    var $mul=-2*($1); //@line 1105 "wavegen.cpp"
    HEAPF32[((__ZL8two_pi_t)>>2)]=$mul; //@line 1105 "wavegen.cpp"
    $ix=0; //@line 1107 "wavegen.cpp"
    ; //@line 1107 "wavegen.cpp"
    while(1) { 
  
      var $2=$ix; //@line 1109 "wavegen.cpp"
      var $arrayidx=((__ZL7rbreath+$2*40)&4294967295); //@line 1109 "wavegen.cpp"
      __ZL12setresonatorP9RESONATORiii($arrayidx, 2000, 200, 1); //@line 1109 "wavegen.cpp"
      var $3=$ix; //@line 1107 "wavegen.cpp"
      var $inc=((($3)+1)&4294967295); //@line 1107 "wavegen.cpp"
      $ix=$inc; //@line 1107 "wavegen.cpp"
      var $cmp=((($inc))|0) < 9; //@line 1107 "wavegen.cpp"
      if ($cmp) { __label__ = 1;continue ; } else { __label__ = 2;break ; } //@line 1107 "wavegen.cpp"
    }
  
    ;
    return; //@line 1112 "wavegen.cpp"
    return;
  }
  

  function __ZL12setresonatorP9RESONATORiii($rp, $freq, $bwidth, $init) {
    ;
    var __label__;
  
    var $rp_addr;
    var $freq_addr;
    var $bwidth_addr;
    var $init_addr;
    var $x;
    var $arg;
    $rp_addr=$rp;
    $freq_addr=$freq;
    $bwidth_addr=$bwidth;
    $init_addr=$init;
    var $0=$init_addr; //@line 1075 "wavegen.cpp"
    var $tobool=((($0))|0)!=0; //@line 1075 "wavegen.cpp"
    if ($tobool) { __label__ = 1;; } else { __label__ = 2;; } //@line 1075 "wavegen.cpp"
    if (__label__ == 1) {
  
      var $1=$rp_addr; //@line 1077 "wavegen.cpp"
      var $x1=(($1+24)&4294967295); //@line 1077 "wavegen.cpp"
      HEAPF32[(($x1)>>2)]=0; //@line 1077 "wavegen.cpp"
      var $2=$rp_addr; //@line 1078 "wavegen.cpp"
      var $x2=(($2+32)&4294967295); //@line 1078 "wavegen.cpp"
      HEAPF32[(($x2)>>2)]=0; //@line 1078 "wavegen.cpp"
      ; //@line 1079 "wavegen.cpp"
    }
  
    var $3=HEAPF32[((__ZL10minus_pi_t)>>2)]; //@line 1082 "wavegen.cpp"
    var $4=$bwidth_addr; //@line 1082 "wavegen.cpp"
    var $conv=((($4))|0); //@line 1082 "wavegen.cpp"
    var $mul=($3)*($conv); //@line 1082 "wavegen.cpp"
    $arg=$mul; //@line 1082 "wavegen.cpp"
    var $5=$arg; //@line 1083 "wavegen.cpp"
    var $call=_exp($5); //@line 1083 "wavegen.cpp"
    $x=$call; //@line 1083 "wavegen.cpp"
    var $6=$x; //@line 1086 "wavegen.cpp"
    var $7=$x; //@line 1086 "wavegen.cpp"
    var $mul1=($6)*($7); //@line 1086 "wavegen.cpp"
    var $sub=(-($mul1)); //@line 1086 "wavegen.cpp"
    var $8=$rp_addr; //@line 1086 "wavegen.cpp"
    var $c=(($8+16)&4294967295); //@line 1086 "wavegen.cpp"
    HEAPF32[(($c)>>2)]=$sub; //@line 1086 "wavegen.cpp"
    var $9=HEAPF32[((__ZL8two_pi_t)>>2)]; //@line 1090 "wavegen.cpp"
    var $10=$freq_addr; //@line 1090 "wavegen.cpp"
    var $conv2=((($10))|0); //@line 1090 "wavegen.cpp"
    var $mul3=($9)*($conv2); //@line 1090 "wavegen.cpp"
    $arg=$mul3; //@line 1090 "wavegen.cpp"
    var $11=$x; //@line 1091 "wavegen.cpp"
    var $12=$arg; //@line 1091 "wavegen.cpp"
    var $call4=_cos($12); //@line 1091 "wavegen.cpp"
    var $mul5=($11)*($call4); //@line 1091 "wavegen.cpp"
    var $mul6=($mul5)*2; //@line 1091 "wavegen.cpp"
    var $13=$rp_addr; //@line 1091 "wavegen.cpp"
    var $b=(($13+8)&4294967295); //@line 1091 "wavegen.cpp"
    HEAPF32[(($b)>>2)]=$mul6; //@line 1091 "wavegen.cpp"
    var $14=$rp_addr; //@line 1094 "wavegen.cpp"
    var $b7=(($14+8)&4294967295); //@line 1094 "wavegen.cpp"
    var $15=HEAPF32[(($b7)>>2)]; //@line 1094 "wavegen.cpp"
    var $sub8=1-($15); //@line 1094 "wavegen.cpp"
    var $16=$rp_addr; //@line 1094 "wavegen.cpp"
    var $c9=(($16+16)&4294967295); //@line 1094 "wavegen.cpp"
    var $17=HEAPF32[(($c9)>>2)]; //@line 1094 "wavegen.cpp"
    var $sub10=($sub8)-($17); //@line 1094 "wavegen.cpp"
    var $18=$rp_addr; //@line 1094 "wavegen.cpp"
    var $a=(($18)&4294967295); //@line 1094 "wavegen.cpp"
    HEAPF32[(($a)>>2)]=$sub10; //@line 1094 "wavegen.cpp"
    ;
    return; //@line 1095 "wavegen.cpp"
    return;
  }
  

  function __Z7Wavegenv() {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $waveph;
    var $theta;
    var $total;
    var $h;
    var $ix;
    var $z;
    var $z1;
    var $z2;
    var $echo;
    var $ov;
    var $pk;
    var $c;
    var $sample;
    var $amp;
    var $modn_amp;
    var $modn_period;
    ; //@line 1186 "wavegen.cpp"
    $for_cond$2: while(1) { 
  
      var $_b=HEAPU8[(__ZL8end_wave_b)];
      var $0=((($_b))&1);
      var $cmp=((($0))|0)==0; //@line 1188 "wavegen.cpp"
      var $1=HEAP32[((__ZL11samplecount)>>2)]; //@line 1188 "wavegen.cpp"
      var $2=HEAP32[((__ZL8nsamples)>>2)]; //@line 1188 "wavegen.cpp"
      var $cmp1=((($1))|0)==((($2))|0); //@line 1188 "wavegen.cpp"
      var $or_cond3=($cmp) & ($cmp1); //@line 1188 "wavegen.cpp"
      if ($or_cond3) { __label__ = 2;break $for_cond$2; } //@line 1188 "wavegen.cpp"
  
      var $and=($1) & 63; //@line 1191 "wavegen.cpp"
      var $cmp2=((($and))|0)==0; //@line 1191 "wavegen.cpp"
      if ($cmp2) { __label__ = 4;; } else { __label__ = 8;; } //@line 1191 "wavegen.cpp"
      $if_then3$$if_else19$5: do { 
        if (__label__ == 4) {
  
          var $cmp4=((($1))|0)==0; //@line 1194 "wavegen.cpp"
          if ($cmp4) { __label__ = 5;; } else { __label__ = 6;; } //@line 1194 "wavegen.cpp"
          if (__label__ == 5) {
  
            HEAP32[((__ZL7hswitch)>>2)]=0; //@line 1196 "wavegen.cpp"
            HEAP32[((__ZL9harmspect)>>2)]=((__ZL6hspect)&4294967295); //@line 1197 "wavegen.cpp"
            var $3=HEAP32[((((_wdata+4)&4294967295))>>2)]; //@line 1198 "wavegen.cpp"
            var $shl=($3) << 4; //@line 1198 "wavegen.cpp"
            var $call=__Z16PeaksToHarmspectP15wavegen_peaks_tiPii(((__ZL5peaks)&4294967295), $shl, ((__ZL6hspect)&4294967295), 0); //@line 1198 "wavegen.cpp"
            HEAP32[((__ZZ7WavegenvE5maxh2)>>2)]=$call; //@line 1198 "wavegen.cpp"
            var $4=HEAP32[((((_wdata+52)&4294967295))>>2)]; //@line 1202 "wavegen.cpp"
            var $5=HEAP32[((((_wdata+4)&4294967295))>>2)]; //@line 1202 "wavegen.cpp"
            var $shr=($5) >> 8; //@line 1202 "wavegen.cpp"
            var $6=HEAP32[((((_wdata+60)&4294967295))>>2)]; //@line 1202 "wavegen.cpp"
            var $mul=((($6)*($4))&4294967295); //@line 1202 "wavegen.cpp"
            var $mul6=((($mul)*($shr))&4294967295); //@line 1202 "wavegen.cpp"
            var $div=((((($mul6))|0)/80000)|0); //@line 1202 "wavegen.cpp"
            HEAP32[((__ZZ7WavegenvE10amplitude2)>>2)]=$div; //@line 1202 "wavegen.cpp"
            var $7=HEAP32[((((_wdata+4)&4294967295))>>2)]; //@line 1205 "wavegen.cpp"
            var $shr7=($7) >> 12; //@line 1205 "wavegen.cpp"
            var $div8=((890/((($shr7))|0))|0); //@line 1205 "wavegen.cpp"
            HEAP32[((__ZZ7WavegenvE13h_switch_sign)>>2)]=$div8; //@line 1205 "wavegen.cpp"
            ; //@line 1206 "wavegen.cpp"
          }
          else if (__label__ == 6) {
  
            __ZL17AdvanceParametersv(); //@line 1208 "wavegen.cpp"
            ;
          }
  
          var $8=HEAP32[((((_wdata+4)&4294967295))>>2)]; //@line 1211 "wavegen.cpp"
          var $shr10=($8) >> 7; //@line 1211 "wavegen.cpp"
          var $9=HEAP32[((__ZL16PHASE_INC_FACTOR)>>2)]; //@line 1211 "wavegen.cpp"
          var $mul11=((($shr10)*($9))&4294967295); //@line 1211 "wavegen.cpp"
          HEAP32[((__ZL8phaseinc)>>2)]=$mul11; //@line 1211 "wavegen.cpp"
          var $10=HEAP32[((_samplerate)>>2)]; //@line 1212 "wavegen.cpp"
          var $11=HEAP32[((((_wdata+4)&4294967295))>>2)]; //@line 1212 "wavegen.cpp"
          var $shr12=($11) >> 12; //@line 1212 "wavegen.cpp"
          var $div13=((((($10))|0)/((($shr12))|0))|0); //@line 1212 "wavegen.cpp"
          HEAP32[((__ZL13cycle_samples)>>2)]=$div13; //@line 1212 "wavegen.cpp"
          var $12=HEAP32[((((_wdata+4)&4294967295))>>2)]; //@line 1213 "wavegen.cpp"
          var $shr14=($12) >> 11; //@line 1213 "wavegen.cpp"
          HEAP32[((__ZL9hf_factor)>>2)]=$shr14; //@line 1213 "wavegen.cpp"
          var $13=HEAP32[((__ZZ7WavegenvE5maxh2)>>2)]; //@line 1215 "wavegen.cpp"
          HEAP32[((__ZZ7WavegenvE4maxh)>>2)]=$13; //@line 1215 "wavegen.cpp"
          var $14=HEAP32[((__ZL7hswitch)>>2)]; //@line 1216 "wavegen.cpp"
          var $arrayidx=((__ZL6hspect+$14*1600)&4294967295); //@line 1216 "wavegen.cpp"
          var $arraydecay=(($arrayidx)&4294967295); //@line 1216 "wavegen.cpp"
          HEAP32[((__ZL9harmspect)>>2)]=$arraydecay; //@line 1216 "wavegen.cpp"
          var $15=HEAP32[((__ZL7hswitch)>>2)]; //@line 1217 "wavegen.cpp"
          var $xor=($15) ^ 1; //@line 1217 "wavegen.cpp"
          HEAP32[((__ZL7hswitch)>>2)]=$xor; //@line 1217 "wavegen.cpp"
          var $16=HEAP32[((((_wdata+4)&4294967295))>>2)]; //@line 1218 "wavegen.cpp"
          var $shl15=($16) << 4; //@line 1218 "wavegen.cpp"
          var $17=HEAP32[((__ZL7hswitch)>>2)]; //@line 1218 "wavegen.cpp"
          var $arrayidx16=((__ZL6hspect+$17*1600)&4294967295); //@line 1218 "wavegen.cpp"
          var $arraydecay17=(($arrayidx16)&4294967295); //@line 1218 "wavegen.cpp"
          var $call18=__Z16PeaksToHarmspectP15wavegen_peaks_tiPii(((__ZL5peaks)&4294967295), $shl15, $arraydecay17, 1); //@line 1218 "wavegen.cpp"
          HEAP32[((__ZZ7WavegenvE5maxh2)>>2)]=$call18; //@line 1218 "wavegen.cpp"
          __ZL9SetBreathv(); //@line 1220 "wavegen.cpp"
          ; //@line 1221 "wavegen.cpp"
        }
        else if (__label__ == 8) {
  
          var $and20=($1) & 7; //@line 1223 "wavegen.cpp"
          var $cmp21=((($and20))|0)==0; //@line 1223 "wavegen.cpp"
          if (!($cmp21)) { __label__ = 16;break $if_then3$$if_else19$5; } //@line 1223 "wavegen.cpp"
  
          $h=1; //@line 1225 "wavegen.cpp"
          __lastLabel__ = 9; ; //@line 1225 "wavegen.cpp"
          while(1) { 
  
            var $18=__lastLabel__ == 13 ? $inc : (1); //@line 1225 "wavegen.cpp"
            var $cmp24=((($18))|0) < 30; //@line 1225 "wavegen.cpp"
            if (!($cmp24)) { __label__ = 14;break ; } //@line 1225 "wavegen.cpp"
  
            var $19=$h; //@line 1225 "wavegen.cpp"
            var $20=HEAP32[((__ZZ7WavegenvE5maxh2)>>2)]; //@line 1225 "wavegen.cpp"
            var $cmp26=((($19))|0) <= ((($20))|0); //@line 1225 "wavegen.cpp"
            if (!($cmp26)) { __label__ = 14;break ; } //@line 1225 "wavegen.cpp"
  
            var $21=$h; //@line 1225 "wavegen.cpp"
            var $22=HEAP32[((__ZZ7WavegenvE4maxh)>>2)]; //@line 1225 "wavegen.cpp"
            var $cmp27=((($21))|0) <= ((($22))|0); //@line 1225 "wavegen.cpp"
            if (!($cmp27)) { __label__ = 14;break ; }
  
            var $23=$h; //@line 1227 "wavegen.cpp"
            var $arrayidx28=((__ZL8harm_inc+$23*4)&4294967295); //@line 1227 "wavegen.cpp"
            var $24=HEAP32[(($arrayidx28)>>2)]; //@line 1227 "wavegen.cpp"
            var $25=$h; //@line 1227 "wavegen.cpp"
            var $26=HEAP32[((__ZL9harmspect)>>2)]; //@line 1227 "wavegen.cpp"
            var $arrayidx29=(($26+4*$25)&4294967295); //@line 1227 "wavegen.cpp"
            var $27=HEAP32[(($arrayidx29)>>2)]; //@line 1227 "wavegen.cpp"
            var $add=((($27)+($24))&4294967295); //@line 1227 "wavegen.cpp"
            HEAP32[(($arrayidx29)>>2)]=$add; //@line 1227 "wavegen.cpp"
            var $28=$h; //@line 1225 "wavegen.cpp"
            var $inc=((($28)+1)&4294967295); //@line 1225 "wavegen.cpp"
            $h=$inc; //@line 1225 "wavegen.cpp"
            __lastLabel__ = 13; __label__ = 10;continue ; //@line 1225 "wavegen.cpp"
          }
  
          var $29=HEAP32[((__ZZ7WavegenvE3agc)>>2)]; //@line 1231 "wavegen.cpp"
          var $cmp30=((($29))|0) < 256; //@line 1231 "wavegen.cpp"
          if (!($cmp30)) { __label__ = 16;break $if_then3$$if_else19$5; } //@line 1231 "wavegen.cpp"
  
          var $30=HEAP32[((__ZZ7WavegenvE3agc)>>2)]; //@line 1231 "wavegen.cpp"
          var $inc32=((($30)+1)&4294967295); //@line 1231 "wavegen.cpp"
          HEAP32[((__ZZ7WavegenvE3agc)>>2)]=$inc32; //@line 1231 "wavegen.cpp"
          ; //@line 1231 "wavegen.cpp"
        }
      } while(0);
  
      var $31=HEAP32[((__ZL11samplecount)>>2)]; //@line 1234 "wavegen.cpp"
      var $inc36=((($31)+1)&4294967295); //@line 1234 "wavegen.cpp"
      HEAP32[((__ZL11samplecount)>>2)]=$inc36; //@line 1234 "wavegen.cpp"
      var $32=HEAP32[((__ZL9wavephase)>>2)]; //@line 1236 "wavegen.cpp"
      var $cmp37=((($32))|0) > 0; //@line 1236 "wavegen.cpp"
      var $33=HEAP32[((__ZL8phaseinc)>>2)]; //@line 1238 "wavegen.cpp"
      var $34=HEAP32[((__ZL9wavephase)>>2)]; //@line 1238 "wavegen.cpp"
      var $add39=((($34)+($33))&4294967295); //@line 1238 "wavegen.cpp"
      HEAP32[((__ZL9wavephase)>>2)]=$add39; //@line 1238 "wavegen.cpp"
      var $35=HEAP32[((__ZL9wavephase)>>2)]; //@line 1239 "wavegen.cpp"
      var $cmp40=((($35))|0) < 0; //@line 1239 "wavegen.cpp"
      var $or_cond=($cmp37) & ($cmp40); //@line 1236 "wavegen.cpp"
      if ($or_cond) { __label__ = 17;; } else { __label__ = 38;; } //@line 1236 "wavegen.cpp"
      $if_then41$$if_end118$21: do { 
        if (__label__ == 17) {
  
          var $36=HEAP32[((__ZL15wavemult_offset)>>2)]; //@line 1242 "wavegen.cpp"
          var $37=HEAP32[((__ZL13cycle_samples)>>2)]; //@line 1242 "wavegen.cpp"
          var $div42=((((($37))|0)/2)|0); //@line 1242 "wavegen.cpp"
          var $sub=((($36)-($div42))&4294967295); //@line 1242 "wavegen.cpp"
          HEAP32[((__ZL6cbytes)>>2)]=$sub; //@line 1242 "wavegen.cpp"
          var $38=HEAP32[((__ZL11samplecount)>>2)]; //@line 1243 "wavegen.cpp"
          var $39=HEAP32[((__ZL8nsamples)>>2)]; //@line 1243 "wavegen.cpp"
          var $cmp43=((($38))|0) > ((($39))|0); //@line 1243 "wavegen.cpp"
          if ($cmp43) { __label__ = 18;break $for_cond$2; } //@line 1243 "wavegen.cpp"
  
          var $40=HEAP32[((__ZZ7WavegenvE11cycle_count)>>2)]; //@line 1246 "wavegen.cpp"
          var $inc46=((($40)+1)&4294967295); //@line 1246 "wavegen.cpp"
          HEAP32[((__ZZ7WavegenvE11cycle_count)>>2)]=$inc46; //@line 1246 "wavegen.cpp"
          var $41=HEAP32[((_wvoice)>>2)]; //@line 1248 "wavegen.cpp"
          var $n_harmonic_peaks=(($41+84)&4294967295); //@line 1248 "wavegen.cpp"
          var $42=HEAP32[(($n_harmonic_peaks)>>2)]; //@line 1248 "wavegen.cpp"
          var $add47=((($42)+1)&4294967295); //@line 1248 "wavegen.cpp"
          $pk=$add47; //@line 1248 "wavegen.cpp"
          var $cmp495=((($add47))|0) < 9; //@line 1248 "wavegen.cpp"
          if ($cmp495) { __label__ = 20;; } else { __label__ = 21;; } //@line 1248 "wavegen.cpp"
          $for_body50$$for_end57$24: do { 
            if (__label__ == 20) {
              while(1) { 
  
                var $43=$pk; //@line 1251 "wavegen.cpp"
                var $arrayidx51=((__ZL5peaks+$43*80)&4294967295); //@line 1251 "wavegen.cpp"
                var $freq=(($arrayidx51)&4294967295); //@line 1251 "wavegen.cpp"
                var $44=HEAP32[(($freq)>>2)]; //@line 1251 "wavegen.cpp"
                var $45=HEAP32[((((_wdata+4)&4294967295))>>2)]; //@line 1251 "wavegen.cpp"
                var $mul52=((($45)*16)&4294967295); //@line 1251 "wavegen.cpp"
                var $div53=((((($44))|0)/((($mul52))|0))|0); //@line 1251 "wavegen.cpp"
                var $46=$pk; //@line 1251 "wavegen.cpp"
                var $arrayidx54=((__ZL13peak_harmonic+$46*4)&4294967295); //@line 1251 "wavegen.cpp"
                HEAP32[(($arrayidx54)>>2)]=$div53; //@line 1251 "wavegen.cpp"
                var $47=$pk; //@line 1248 "wavegen.cpp"
                var $inc56=((($47)+1)&4294967295); //@line 1248 "wavegen.cpp"
                $pk=$inc56; //@line 1248 "wavegen.cpp"
                var $cmp49=((($inc56))|0) < 9; //@line 1248 "wavegen.cpp"
                if ($cmp49) { __label__ = 20;continue ; } else { __label__ = 21;break $for_body50$$for_end57$24; } //@line 1248 "wavegen.cpp"
              }
            }
          } while(0);
  
          var $48=HEAP32[((((_wdata+52)&4294967295))>>2)]; //@line 1256 "wavegen.cpp"
          var $49=HEAP32[((((_wdata+4)&4294967295))>>2)]; //@line 1256 "wavegen.cpp"
          var $shr58=($49) >> 8; //@line 1256 "wavegen.cpp"
          var $50=HEAP32[((((_wdata+60)&4294967295))>>2)]; //@line 1256 "wavegen.cpp"
          var $mul59=((($50)*($48))&4294967295); //@line 1256 "wavegen.cpp"
          var $mul60=((($mul59)*($shr58))&4294967295); //@line 1256 "wavegen.cpp"
          var $div61=((((($mul60))|0)/80000)|0); //@line 1256 "wavegen.cpp"
          HEAP32[((__ZZ7WavegenvE10amplitude2)>>2)]=$div61; //@line 1256 "wavegen.cpp"
          var $51=HEAP32[((__ZL12glottal_flag)>>2)]; //@line 1258 "wavegen.cpp"
          var $cmp62=((($51))|0) > 0; //@line 1258 "wavegen.cpp"
          if ($cmp62) { __label__ = 22;; } else { __label__ = 28;; } //@line 1258 "wavegen.cpp"
          $if_then63$$if_end81$28: do { 
            if (__label__ == 22) {
  
              var $52=HEAP32[((__ZL12glottal_flag)>>2)]; //@line 1260 "wavegen.cpp"
              var $cmp64=((($52))|0)==3; //@line 1260 "wavegen.cpp"
              if ($cmp64) { __label__ = 23;; } else { __label__ = 25;; } //@line 1260 "wavegen.cpp"
              if (__label__ == 23) {
  
                var $53=HEAP32[((__ZL8nsamples)>>2)]; //@line 1262 "wavegen.cpp"
                var $54=HEAP32[((__ZL11samplecount)>>2)]; //@line 1262 "wavegen.cpp"
                var $sub66=((($53)-($54))&4294967295); //@line 1262 "wavegen.cpp"
                var $55=HEAP32[((__ZL13cycle_samples)>>2)]; //@line 1262 "wavegen.cpp"
                var $mul67=((($55)*2)&4294967295); //@line 1262 "wavegen.cpp"
                var $cmp68=((($sub66))|0) < ((($mul67))|0); //@line 1262 "wavegen.cpp"
                if (!($cmp68)) { __label__ = 28;break $if_then63$$if_end81$28; } //@line 1262 "wavegen.cpp"
  
                HEAP32[((__ZL12glottal_flag)>>2)]=2; //@line 1266 "wavegen.cpp"
                var $56=HEAP32[((__ZZ7WavegenvE10amplitude2)>>2)]; //@line 1267 "wavegen.cpp"
                var $57=HEAP32[((__ZL14glottal_reduce)>>2)]; //@line 1267 "wavegen.cpp"
                var $mul70=((($57)*($56))&4294967295); //@line 1267 "wavegen.cpp"
                var $div71=((((($mul70))|0)/256)|0); //@line 1267 "wavegen.cpp"
                HEAP32[((__ZZ7WavegenvE10amplitude2)>>2)]=$div71; //@line 1267 "wavegen.cpp"
                ; //@line 1268 "wavegen.cpp"
              }
              else if (__label__ == 25) {
  
                var $58=HEAP32[((__ZL12glottal_flag)>>2)]; //@line 1271 "wavegen.cpp"
                var $cmp74=((($58))|0)==4; //@line 1271 "wavegen.cpp"
                if ($cmp74) { __label__ = 26;; } else { __label__ = 27;; } //@line 1271 "wavegen.cpp"
                if (__label__ == 26) {
  
                  HEAP32[((__ZL12glottal_flag)>>2)]=2; //@line 1275 "wavegen.cpp"
                  var $59=HEAP32[((__ZZ7WavegenvE10amplitude2)>>2)]; //@line 1276 "wavegen.cpp"
                  var $60=HEAP32[((__ZL14glottal_reduce)>>2)]; //@line 1276 "wavegen.cpp"
                  var $mul76=((($60)*($59))&4294967295); //@line 1276 "wavegen.cpp"
                  var $div77=((((($mul76))|0)/256)|0); //@line 1276 "wavegen.cpp"
                  HEAP32[((__ZZ7WavegenvE10amplitude2)>>2)]=$div77; //@line 1276 "wavegen.cpp"
                  ; //@line 1277 "wavegen.cpp"
                }
                else if (__label__ == 27) {
  
                  var $61=HEAP32[((__ZL12glottal_flag)>>2)]; //@line 1280 "wavegen.cpp"
                  var $dec=((($61)-1)&4294967295); //@line 1280 "wavegen.cpp"
                  HEAP32[((__ZL12glottal_flag)>>2)]=$dec; //@line 1280 "wavegen.cpp"
                  ;
                }
              }
            }
          } while(0);
  
          var $62=HEAP32[((__ZL13amplitude_env)>>2)]; //@line 1284 "wavegen.cpp"
          var $cmp82=((($62))|0)!=0; //@line 1284 "wavegen.cpp"
          if ($cmp82) { __label__ = 29;; } else { __label__ = 32;; } //@line 1284 "wavegen.cpp"
          if (__label__ == 29) {
  
            var $63=HEAP32[((__ZL6amp_ix)>>2)]; //@line 1287 "wavegen.cpp"
            var $shr84=($63) >> 8; //@line 1287 "wavegen.cpp"
            $ix=$shr84; //@line 1287 "wavegen.cpp"
            var $cmp85=((($shr84))|0) > 127; //@line 1287 "wavegen.cpp"
            if ($cmp85) { __label__ = 30;; } else { __label__ = 31;; } //@line 1287 "wavegen.cpp"
            if (__label__ == 30) {
  
              $ix=127; //@line 1287 "wavegen.cpp"
              ; //@line 1287 "wavegen.cpp"
            }
  
            var $64=$ix; //@line 1288 "wavegen.cpp"
            var $65=HEAP32[((__ZL13amplitude_env)>>2)]; //@line 1288 "wavegen.cpp"
            var $arrayidx88=(($65+$64)&4294967295); //@line 1288 "wavegen.cpp"
            var $66=HEAPU8[($arrayidx88)]; //@line 1288 "wavegen.cpp"
            var $conv=((($66))&255); //@line 1288 "wavegen.cpp"
            $amp=$conv; //@line 1288 "wavegen.cpp"
            var $67=HEAP32[((__ZZ7WavegenvE10amplitude2)>>2)]; //@line 1289 "wavegen.cpp"
            var $68=$amp; //@line 1289 "wavegen.cpp"
            var $mul89=((($68)*($67))&4294967295); //@line 1289 "wavegen.cpp"
            var $div90=((((($mul89))|0)/128)|0); //@line 1289 "wavegen.cpp"
            HEAP32[((__ZZ7WavegenvE10amplitude2)>>2)]=$div90; //@line 1289 "wavegen.cpp"
            ; //@line 1292 "wavegen.cpp"
          }
  
          $modn_period=0; //@line 1295 "wavegen.cpp"
          var $69=HEAP32[((_voice)>>2)]; //@line 1296 "wavegen.cpp"
          var $roughness=(($69+72)&4294967295); //@line 1296 "wavegen.cpp"
          var $70=HEAP32[(($roughness)>>2)]; //@line 1296 "wavegen.cpp"
          var $cmp92=((($70))|0) < 8; //@line 1296 "wavegen.cpp"
          if (!($cmp92)) { __label__ = 38;break $if_then41$$if_end118$21; } //@line 1296 "wavegen.cpp"
  
          var $71=HEAP32[((__ZL15modulation_type)>>2)]; //@line 1298 "wavegen.cpp"
          var $72=HEAP32[((_voice)>>2)]; //@line 1298 "wavegen.cpp"
          var $roughness94=(($72+72)&4294967295); //@line 1298 "wavegen.cpp"
          var $73=HEAP32[(($roughness94)>>2)]; //@line 1298 "wavegen.cpp"
          var $arrayidx95=((__ZL14modulation_tab+$73*8)&4294967295); //@line 1298 "wavegen.cpp"
          var $arrayidx96=(($arrayidx95+$71)&4294967295); //@line 1298 "wavegen.cpp"
          var $74=HEAPU8[($arrayidx96)]; //@line 1298 "wavegen.cpp"
          var $conv97=((($74))&255); //@line 1298 "wavegen.cpp"
          $modn_period=$conv97; //@line 1298 "wavegen.cpp"
          var $75=$modn_period; //@line 1299 "wavegen.cpp"
          var $and98=($75) & 15; //@line 1299 "wavegen.cpp"
          $modn_amp=$and98; //@line 1299 "wavegen.cpp"
          var $76=$modn_period; //@line 1300 "wavegen.cpp"
          var $shr99=($76) >> 4; //@line 1300 "wavegen.cpp"
          $modn_period=$shr99; //@line 1300 "wavegen.cpp"
          var $cmp101=((($shr99))|0)!=0; //@line 1303 "wavegen.cpp"
          if (!($cmp101)) { __label__ = 38;break $if_then41$$if_end118$21; } //@line 1303 "wavegen.cpp"
  
          var $77=$modn_period; //@line 1305 "wavegen.cpp"
          var $cmp103=((($77))|0)==15; //@line 1305 "wavegen.cpp"
          if ($cmp103) { __label__ = 35;; } else { __label__ = 36;; } //@line 1305 "wavegen.cpp"
          if (__label__ == 35) {
  
            var $78=HEAP32[((__ZZ7WavegenvE10amplitude2)>>2)]; //@line 1308 "wavegen.cpp"
            var $79=$modn_amp; //@line 1308 "wavegen.cpp"
            var $mul105=((($79)*($78))&4294967295); //@line 1308 "wavegen.cpp"
            var $div106=((((($mul105))|0)/16)|0); //@line 1308 "wavegen.cpp"
            HEAP32[((__ZZ7WavegenvE10amplitude2)>>2)]=$div106; //@line 1308 "wavegen.cpp"
            HEAP32[((__ZL15modulation_type)>>2)]=0; //@line 1309 "wavegen.cpp"
            ; //@line 1310 "wavegen.cpp"
          }
          else if (__label__ == 36) {
  
            var $80=HEAP32[((__ZZ7WavegenvE11cycle_count)>>2)]; //@line 1314 "wavegen.cpp"
            var $81=$modn_period; //@line 1314 "wavegen.cpp"
            var $rem=((($80))|0)%((($81))|0); //@line 1314 "wavegen.cpp"
            var $cmp108=((($rem))|0)==0; //@line 1314 "wavegen.cpp"
            if (!($cmp108)) { __label__ = 38;break $if_then41$$if_end118$21; } //@line 1314 "wavegen.cpp"
  
            var $82=HEAP32[((__ZZ7WavegenvE10amplitude2)>>2)]; //@line 1315 "wavegen.cpp"
            var $83=$modn_amp; //@line 1315 "wavegen.cpp"
            var $mul110=((($83)*($82))&4294967295); //@line 1315 "wavegen.cpp"
            var $div111=((((($mul110))|0)/16)|0); //@line 1315 "wavegen.cpp"
            HEAP32[((__ZZ7WavegenvE10amplitude2)>>2)]=$div111; //@line 1315 "wavegen.cpp"
            ; //@line 1315 "wavegen.cpp"
          }
        }
      } while(0);
  
      var $84=HEAP32[((__ZL9wavephase)>>2)]; //@line 1324 "wavegen.cpp"
      var $shr119=($84) >> 16; //@line 1324 "wavegen.cpp"
      var $conv120=((($shr119)) & 65535); //@line 1324 "wavegen.cpp"
      $waveph=$conv120; //@line 1324 "wavegen.cpp"
      $total=0; //@line 1325 "wavegen.cpp"
      var $85=HEAP32[((__ZL6cbytes)>>2)]; //@line 1331 "wavegen.cpp"
      var $inc121=((($85)+1)&4294967295); //@line 1331 "wavegen.cpp"
      HEAP32[((__ZL6cbytes)>>2)]=$inc121; //@line 1331 "wavegen.cpp"
      var $cmp122=((($inc121))|0) >= 0; //@line 1332 "wavegen.cpp"
      if ($cmp122) { __label__ = 39;; } else { __label__ = 43;; } //@line 1332 "wavegen.cpp"
      $land_lhs_true123$$if_end149$51: do { 
        if (__label__ == 39) {
  
          var $86=HEAP32[((__ZL6cbytes)>>2)]; //@line 1332 "wavegen.cpp"
          var $87=HEAP32[((__ZL12wavemult_max)>>2)]; //@line 1332 "wavegen.cpp"
          var $cmp124=((($86))|0) < ((($87))|0); //@line 1332 "wavegen.cpp"
          if (!($cmp124)) { __label__ = 43;break $land_lhs_true123$$if_end149$51; } //@line 1332 "wavegen.cpp"
  
          var $88=HEAP32[((_wvoice)>>2)]; //@line 1334 "wavegen.cpp"
          var $n_harmonic_peaks126=(($88+84)&4294967295); //@line 1334 "wavegen.cpp"
          var $89=HEAP32[(($n_harmonic_peaks126)>>2)]; //@line 1334 "wavegen.cpp"
          var $add127=((($89)+1)&4294967295); //@line 1334 "wavegen.cpp"
          $pk=$add127; //@line 1334 "wavegen.cpp"
          var $cmp1294=((($add127))|0) < 9; //@line 1334 "wavegen.cpp"
          if ($cmp1294) { __label__ = 41;; } else { __label__ = 42;; } //@line 1334 "wavegen.cpp"
          $for_body130$$for_end144$54: do { 
            if (__label__ == 41) {
              while(1) { 
  
                var $90=$pk; //@line 1336 "wavegen.cpp"
                var $arrayidx131=((__ZL13peak_harmonic+$90*4)&4294967295); //@line 1336 "wavegen.cpp"
                var $91=HEAP32[(($arrayidx131)>>2)]; //@line 1336 "wavegen.cpp"
                var $92=$waveph; //@line 1336 "wavegen.cpp"
                var $conv132=((($92))&65535); //@line 1336 "wavegen.cpp"
                var $mul133=((($conv132)*($91))&4294967295); //@line 1336 "wavegen.cpp"
                var $conv134=((($mul133)) & 65535); //@line 1336 "wavegen.cpp"
                $theta=$conv134; //@line 1336 "wavegen.cpp"
                var $93=$theta; //@line 1337 "wavegen.cpp"
                var $conv135=((($93))&65535); //@line 1337 "wavegen.cpp"
                var $shr136=($conv135) >> 5; //@line 1337 "wavegen.cpp"
                var $arrayidx137=((_sin_tab+$shr136*2)&4294967295); //@line 1337 "wavegen.cpp"
                var $94=HEAP16[(($arrayidx137)>>1)]; //@line 1337 "wavegen.cpp"
                var $conv138=(tempInt=(($94)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1337 "wavegen.cpp"
                var $95=$pk; //@line 1337 "wavegen.cpp"
                var $arrayidx139=((__ZL11peak_height+$95*4)&4294967295); //@line 1337 "wavegen.cpp"
                var $96=HEAP32[(($arrayidx139)>>2)]; //@line 1337 "wavegen.cpp"
                var $mul140=((($96)*($conv138))&4294967295); //@line 1337 "wavegen.cpp"
                var $97=$total; //@line 1337 "wavegen.cpp"
                var $add141=((($97)+($mul140))&4294967295); //@line 1337 "wavegen.cpp"
                $total=$add141; //@line 1337 "wavegen.cpp"
                var $98=$pk; //@line 1334 "wavegen.cpp"
                var $inc143=((($98)+1)&4294967295); //@line 1334 "wavegen.cpp"
                $pk=$inc143; //@line 1334 "wavegen.cpp"
                var $cmp129=((($inc143))|0) < 9; //@line 1334 "wavegen.cpp"
                if ($cmp129) { __label__ = 41;continue ; } else { __label__ = 42;break $for_body130$$for_end144$54; } //@line 1334 "wavegen.cpp"
              }
            }
          } while(0);
  
          var $99=$total; //@line 1341 "wavegen.cpp"
          var $100=HEAP32[((__ZL9hf_factor)>>2)]; //@line 1341 "wavegen.cpp"
          var $div145=((((($99))|0)/((($100))|0))|0); //@line 1341 "wavegen.cpp"
          var $101=HEAP32[((__ZL6cbytes)>>2)]; //@line 1341 "wavegen.cpp"
          var $arrayidx146=((__ZL8wavemult+$101)&4294967295); //@line 1341 "wavegen.cpp"
          var $102=HEAPU8[($arrayidx146)]; //@line 1341 "wavegen.cpp"
          var $conv147=((($102))&255); //@line 1341 "wavegen.cpp"
          var $mul148=((($conv147)*($div145))&4294967295); //@line 1341 "wavegen.cpp"
          $total=$mul148; //@line 1341 "wavegen.cpp"
          ; //@line 1342 "wavegen.cpp"
        }
      } while(0);
  
      var $103=$waveph; //@line 1349 "wavegen.cpp"
      $theta=$103; //@line 1349 "wavegen.cpp"
      $h=1; //@line 1351 "wavegen.cpp"
      var $104=$h; //@line 1351 "wavegen.cpp"
      var $105=HEAP32[((__ZZ7WavegenvE13h_switch_sign)>>2)]; //@line 1351 "wavegen.cpp"
      var $cmp1516=((($104))|0) <= ((($105))|0); //@line 1351 "wavegen.cpp"
      if ($cmp1516) { __label__ = 44;; } else { __label__ = 45;; } //@line 1351 "wavegen.cpp"
      $for_body152$$while_cond_loopexit$59: do { 
        if (__label__ == 44) {
          while(1) { 
  
            var $106=$theta; //@line 1353 "wavegen.cpp"
            var $conv153=((($106))&65535); //@line 1353 "wavegen.cpp"
            var $shr154=($conv153) >> 5; //@line 1353 "wavegen.cpp"
            var $arrayidx155=((_sin_tab+$shr154*2)&4294967295); //@line 1353 "wavegen.cpp"
            var $107=HEAP16[(($arrayidx155)>>1)]; //@line 1353 "wavegen.cpp"
            var $conv156=(tempInt=(($107)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1353 "wavegen.cpp"
            var $108=$h; //@line 1353 "wavegen.cpp"
            var $109=HEAP32[((__ZL9harmspect)>>2)]; //@line 1353 "wavegen.cpp"
            var $arrayidx157=(($109+4*$108)&4294967295); //@line 1353 "wavegen.cpp"
            var $110=HEAP32[(($arrayidx157)>>2)]; //@line 1353 "wavegen.cpp"
            var $mul158=((($110)*($conv156))&4294967295); //@line 1353 "wavegen.cpp"
            var $111=$total; //@line 1353 "wavegen.cpp"
            var $add159=((($111)+($mul158))&4294967295); //@line 1353 "wavegen.cpp"
            $total=$add159; //@line 1353 "wavegen.cpp"
            var $112=$waveph; //@line 1354 "wavegen.cpp"
            var $conv160=((($112))&65535); //@line 1354 "wavegen.cpp"
            var $113=$theta; //@line 1354 "wavegen.cpp"
            var $conv161=((($113))&65535); //@line 1354 "wavegen.cpp"
            var $add162=((($conv161)+($conv160))&4294967295); //@line 1354 "wavegen.cpp"
            var $conv163=((($add162)) & 65535); //@line 1354 "wavegen.cpp"
            $theta=$conv163; //@line 1354 "wavegen.cpp"
            var $114=$h; //@line 1351 "wavegen.cpp"
            var $inc165=((($114)+1)&4294967295); //@line 1351 "wavegen.cpp"
            $h=$inc165; //@line 1351 "wavegen.cpp"
            var $115=$h; //@line 1351 "wavegen.cpp"
            var $116=HEAP32[((__ZZ7WavegenvE13h_switch_sign)>>2)]; //@line 1351 "wavegen.cpp"
            var $cmp151=((($115))|0) <= ((($116))|0); //@line 1351 "wavegen.cpp"
            if ($cmp151) { __label__ = 44;continue ; } else { __label__ = 45;break $for_body152$$while_cond_loopexit$59; } //@line 1351 "wavegen.cpp"
          }
        }
      } while(0);
  
      var $117=$h; //@line 1356 "wavegen.cpp"
      var $118=HEAP32[((__ZZ7WavegenvE4maxh)>>2)]; //@line 1356 "wavegen.cpp"
      var $cmp1677=((($117))|0) <= ((($118))|0); //@line 1356 "wavegen.cpp"
      if ($cmp1677) { __label__ = 46;; } else { __label__ = 47;; } //@line 1356 "wavegen.cpp"
      $while_body$$while_end$63: do { 
        if (__label__ == 46) {
          while(1) { 
  
            var $119=$theta; //@line 1358 "wavegen.cpp"
            var $conv168=((($119))&65535); //@line 1358 "wavegen.cpp"
            var $shr169=($conv168) >> 5; //@line 1358 "wavegen.cpp"
            var $arrayidx170=((_sin_tab+$shr169*2)&4294967295); //@line 1358 "wavegen.cpp"
            var $120=HEAP16[(($arrayidx170)>>1)]; //@line 1358 "wavegen.cpp"
            var $conv171=(tempInt=(($120)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1358 "wavegen.cpp"
            var $121=$h; //@line 1358 "wavegen.cpp"
            var $122=HEAP32[((__ZL9harmspect)>>2)]; //@line 1358 "wavegen.cpp"
            var $arrayidx172=(($122+4*$121)&4294967295); //@line 1358 "wavegen.cpp"
            var $123=HEAP32[(($arrayidx172)>>2)]; //@line 1358 "wavegen.cpp"
            var $mul173=((($123)*($conv171))&4294967295); //@line 1358 "wavegen.cpp"
            var $124=$total; //@line 1358 "wavegen.cpp"
            var $sub174=((($124)-($mul173))&4294967295); //@line 1358 "wavegen.cpp"
            $total=$sub174; //@line 1358 "wavegen.cpp"
            var $125=$waveph; //@line 1359 "wavegen.cpp"
            var $conv175=((($125))&65535); //@line 1359 "wavegen.cpp"
            var $126=$theta; //@line 1359 "wavegen.cpp"
            var $conv176=((($126))&65535); //@line 1359 "wavegen.cpp"
            var $add177=((($conv176)+($conv175))&4294967295); //@line 1359 "wavegen.cpp"
            var $conv178=((($add177)) & 65535); //@line 1359 "wavegen.cpp"
            $theta=$conv178; //@line 1359 "wavegen.cpp"
            var $127=$h; //@line 1360 "wavegen.cpp"
            var $inc179=((($127)+1)&4294967295); //@line 1360 "wavegen.cpp"
            $h=$inc179; //@line 1360 "wavegen.cpp"
            var $128=$h; //@line 1356 "wavegen.cpp"
            var $129=HEAP32[((__ZZ7WavegenvE4maxh)>>2)]; //@line 1356 "wavegen.cpp"
            var $cmp167=((($128))|0) <= ((($129))|0); //@line 1356 "wavegen.cpp"
            if ($cmp167) { __label__ = 46;continue ; } else { __label__ = 47;break $while_body$$while_end$63; } //@line 1356 "wavegen.cpp"
          }
        }
      } while(0);
  
      var $130=HEAP32[((__ZL7voicing)>>2)]; //@line 1364 "wavegen.cpp"
      var $cmp180=((($130))|0)!=64; //@line 1364 "wavegen.cpp"
      if ($cmp180) { __label__ = 48;; } else { __label__ = 49;; } //@line 1364 "wavegen.cpp"
      if (__label__ == 48) {
  
        var $131=$total; //@line 1366 "wavegen.cpp"
        var $shr182=($131) >> 6; //@line 1366 "wavegen.cpp"
        var $132=HEAP32[((__ZL7voicing)>>2)]; //@line 1366 "wavegen.cpp"
        var $mul183=((($shr182)*($132))&4294967295); //@line 1366 "wavegen.cpp"
        $total=$mul183; //@line 1366 "wavegen.cpp"
        ; //@line 1367 "wavegen.cpp"
      }
  
      var $133=HEAP32[((_wvoice)>>2)]; //@line 1370 "wavegen.cpp"
      var $breath=(($133+272)&4294967295); //@line 1370 "wavegen.cpp"
      var $arrayidx185=(($breath)&4294967295); //@line 1370 "wavegen.cpp"
      var $134=HEAP32[(($arrayidx185)>>2)]; //@line 1370 "wavegen.cpp"
      var $tobool=((($134))|0)!=0; //@line 1370 "wavegen.cpp"
      if ($tobool) { __label__ = 50;; } else { __label__ = 51;; } //@line 1370 "wavegen.cpp"
      if (__label__ == 50) {
  
        var $call187=__ZL11ApplyBreathv(); //@line 1372 "wavegen.cpp"
        var $135=$total; //@line 1372 "wavegen.cpp"
        var $add188=((($135)+($call187))&4294967295); //@line 1372 "wavegen.cpp"
        $total=$add188; //@line 1372 "wavegen.cpp"
        ; //@line 1373 "wavegen.cpp"
      }
  
      $z2=0; //@line 1377 "wavegen.cpp"
      var $136=HEAP32[((((_wdata+40)&4294967295))>>2)]; //@line 1378 "wavegen.cpp"
      var $137=HEAP32[((((_wdata+28)&4294967295))>>2)]; //@line 1378 "wavegen.cpp"
      var $cmp190=((($136))|0) < ((($137))|0); //@line 1378 "wavegen.cpp"
      if ($cmp190) { __label__ = 52;; } else { __label__ = 57;; } //@line 1378 "wavegen.cpp"
      $if_then191$$if_end222$73: do { 
        if (__label__ == 52) {
  
          var $138=HEAP32[((((_wdata+32)&4294967295))>>2)]; //@line 1380 "wavegen.cpp"
          var $cmp192=((($138))|0)==0; //@line 1380 "wavegen.cpp"
          if ($cmp192) { __label__ = 53;; } else { __label__ = 54;; } //@line 1380 "wavegen.cpp"
          if (__label__ == 53) {
  
            var $139=HEAP32[((((_wdata+40)&4294967295))>>2)]; //@line 1383 "wavegen.cpp"
            var $140=HEAP32[((((_wdata+48)&4294967295))>>2)]; //@line 1383 "wavegen.cpp"
            var $add194=((($139)+1)&4294967295); //@line 1383 "wavegen.cpp"
            var $add195=((($add194)+($140))&4294967295); //@line 1383 "wavegen.cpp"
            var $141=HEAP32[((((_wdata+24)&4294967295))>>2)]; //@line 1383 "wavegen.cpp"
            var $arrayidx196=(($141+$add195)&4294967295); //@line 1383 "wavegen.cpp"
            var $142=HEAP8[($arrayidx196)]; //@line 1383 "wavegen.cpp"
            $c=$142; //@line 1383 "wavegen.cpp"
            var $143=HEAP32[((((_wdata+40)&4294967295))>>2)]; //@line 1384 "wavegen.cpp"
            var $144=HEAP32[((((_wdata+48)&4294967295))>>2)]; //@line 1384 "wavegen.cpp"
            var $add197=((($144)+($143))&4294967295); //@line 1384 "wavegen.cpp"
            var $145=HEAP32[((((_wdata+24)&4294967295))>>2)]; //@line 1384 "wavegen.cpp"
            var $arrayidx198=(($145+$add197)&4294967295); //@line 1384 "wavegen.cpp"
            var $146=HEAPU8[($arrayidx198)]; //@line 1384 "wavegen.cpp"
            var $conv199=((($146))&255); //@line 1384 "wavegen.cpp"
            var $147=$c; //@line 1384 "wavegen.cpp"
            var $conv200=(tempInt=(($147)),(tempInt>=128?tempInt-256:tempInt)); //@line 1384 "wavegen.cpp"
            var $mul201=((($conv200)*256)&4294967295); //@line 1384 "wavegen.cpp"
            var $add202=((($mul201)+($conv199))&4294967295); //@line 1384 "wavegen.cpp"
            $sample=$add202; //@line 1384 "wavegen.cpp"
            var $148=HEAP32[((((_wdata+40)&4294967295))>>2)]; //@line 1385 "wavegen.cpp"
            var $add203=((($148)+2)&4294967295); //@line 1385 "wavegen.cpp"
            HEAP32[((((_wdata+40)&4294967295))>>2)]=$add203; //@line 1385 "wavegen.cpp"
            ; //@line 1386 "wavegen.cpp"
          }
          else if (__label__ == 54) {
  
            var $149=HEAP32[((((_wdata+48)&4294967295))>>2)]; //@line 1390 "wavegen.cpp"
            var $150=HEAP32[((((_wdata+40)&4294967295))>>2)]; //@line 1390 "wavegen.cpp"
            var $inc205=((($150)+1)&4294967295); //@line 1390 "wavegen.cpp"
            HEAP32[((((_wdata+40)&4294967295))>>2)]=$inc205; //@line 1390 "wavegen.cpp"
            var $add206=((($150)+($149))&4294967295); //@line 1390 "wavegen.cpp"
            var $151=HEAP32[((((_wdata+24)&4294967295))>>2)]; //@line 1390 "wavegen.cpp"
            var $arrayidx207=(($151+$add206)&4294967295); //@line 1390 "wavegen.cpp"
            var $152=HEAP8[($arrayidx207)]; //@line 1390 "wavegen.cpp"
            var $conv208=(tempInt=(($152)),(tempInt>=128?tempInt-256:tempInt)); //@line 1390 "wavegen.cpp"
            var $153=HEAP32[((((_wdata+32)&4294967295))>>2)]; //@line 1390 "wavegen.cpp"
            var $mul209=((($conv208)*($153))&4294967295); //@line 1390 "wavegen.cpp"
            $sample=$mul209; //@line 1390 "wavegen.cpp"
            ;
          }
  
          var $154=$sample; //@line 1392 "wavegen.cpp"
          var $155=HEAP32[((((_wdata+56)&4294967295))>>2)]; //@line 1392 "wavegen.cpp"
          var $mul211=((($155)*($154))&4294967295); //@line 1392 "wavegen.cpp"
          var $shr212=($mul211) >> 10; //@line 1392 "wavegen.cpp"
          $z2=$shr212; //@line 1392 "wavegen.cpp"
          var $156=$z2; //@line 1393 "wavegen.cpp"
          var $157=HEAP32[((((_wdata+36)&4294967295))>>2)]; //@line 1393 "wavegen.cpp"
          var $mul213=((($157)*($156))&4294967295); //@line 1393 "wavegen.cpp"
          var $div214=((((($mul213))|0)/32)|0); //@line 1393 "wavegen.cpp"
          $z2=$div214; //@line 1393 "wavegen.cpp"
          var $158=HEAP32[((((_wdata+40)&4294967295))>>2)]; //@line 1395 "wavegen.cpp"
          var $159=HEAP32[((((_wdata+48)&4294967295))>>2)]; //@line 1395 "wavegen.cpp"
          var $add215=((($159)+($158))&4294967295); //@line 1395 "wavegen.cpp"
          var $160=HEAP32[((((_wdata+44)&4294967295))>>2)]; //@line 1395 "wavegen.cpp"
          var $cmp216=((($add215))|0) >= ((($160))|0); //@line 1395 "wavegen.cpp"
          if (!($cmp216)) { __label__ = 57;break $if_then191$$if_end222$73; } //@line 1395 "wavegen.cpp"
  
          var $161=HEAP32[((((_wdata+44)&4294967295))>>2)]; //@line 1396 "wavegen.cpp"
          var $mul218=((($161)*3)&4294967295); //@line 1396 "wavegen.cpp"
          var $div219=((((($mul218))|0)/4)|0); //@line 1396 "wavegen.cpp"
          var $162=HEAP32[((((_wdata+48)&4294967295))>>2)]; //@line 1396 "wavegen.cpp"
          var $sub220=((($162)-($div219))&4294967295); //@line 1396 "wavegen.cpp"
          HEAP32[((((_wdata+48)&4294967295))>>2)]=$sub220; //@line 1396 "wavegen.cpp"
          ; //@line 1396 "wavegen.cpp"
        }
      } while(0);
  
      var $163=$z2; //@line 1399 "wavegen.cpp"
      var $164=$total; //@line 1399 "wavegen.cpp"
      var $shr223=($164) >> 8; //@line 1399 "wavegen.cpp"
      var $165=HEAP32[((__ZZ7WavegenvE10amplitude2)>>2)]; //@line 1399 "wavegen.cpp"
      var $mul224=((($shr223)*($165))&4294967295); //@line 1399 "wavegen.cpp"
      var $shr225=($mul224) >> 13; //@line 1399 "wavegen.cpp"
      var $add226=((($shr225)+($163))&4294967295); //@line 1399 "wavegen.cpp"
      $z1=$add226; //@line 1399 "wavegen.cpp"
      var $166=HEAP32[((_echo_tail)>>2)]; //@line 1401 "wavegen.cpp"
      var $inc227=((($166)+1)&4294967295); //@line 1401 "wavegen.cpp"
      HEAP32[((_echo_tail)>>2)]=$inc227; //@line 1401 "wavegen.cpp"
      var $arrayidx228=((_echo_buf+$166*2)&4294967295); //@line 1401 "wavegen.cpp"
      var $167=HEAP16[(($arrayidx228)>>1)]; //@line 1401 "wavegen.cpp"
      var $conv229=(tempInt=(($167)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1401 "wavegen.cpp"
      var $168=HEAP32[((_echo_amp)>>2)]; //@line 1401 "wavegen.cpp"
      var $mul230=((($conv229)*($168))&4294967295); //@line 1401 "wavegen.cpp"
      $echo=$mul230; //@line 1401 "wavegen.cpp"
      var $169=$echo; //@line 1402 "wavegen.cpp"
      var $shr231=($169) >> 8; //@line 1402 "wavegen.cpp"
      var $170=$z1; //@line 1402 "wavegen.cpp"
      var $add232=((($170)+($shr231))&4294967295); //@line 1402 "wavegen.cpp"
      $z1=$add232; //@line 1402 "wavegen.cpp"
      var $171=HEAP32[((_echo_tail)>>2)]; //@line 1403 "wavegen.cpp"
      var $cmp233=((($171))|0) >= 5500; //@line 1403 "wavegen.cpp"
      if ($cmp233) { __label__ = 58;; } else { __label__ = 59;; } //@line 1403 "wavegen.cpp"
      if (__label__ == 58) {
  
        HEAP32[((_echo_tail)>>2)]=0; //@line 1404 "wavegen.cpp"
        ; //@line 1404 "wavegen.cpp"
      }
  
      var $172=$z1; //@line 1406 "wavegen.cpp"
      var $173=HEAP32[((__ZZ7WavegenvE3agc)>>2)]; //@line 1406 "wavegen.cpp"
      var $mul236=((($173)*($172))&4294967295); //@line 1406 "wavegen.cpp"
      var $shr237=($mul236) >> 8; //@line 1406 "wavegen.cpp"
      $z=$shr237; //@line 1406 "wavegen.cpp"
      var $cmp238=((($shr237))|0) >= 32768; //@line 1409 "wavegen.cpp"
      if ($cmp238) { __label__ = 60;; } else { __label__ = 63;; } //@line 1409 "wavegen.cpp"
      $if_then239$$if_else247$84: do { 
        if (__label__ == 60) {
  
          var $174=$z1; //@line 1411 "wavegen.cpp"
          var $div240=((8388608/((($174))|0))|0); //@line 1411 "wavegen.cpp"
          var $sub241=((($div240)-1)&4294967295); //@line 1411 "wavegen.cpp"
          $ov=$sub241; //@line 1411 "wavegen.cpp"
          var $175=$ov; //@line 1412 "wavegen.cpp"
          var $176=HEAP32[((__ZZ7WavegenvE3agc)>>2)]; //@line 1412 "wavegen.cpp"
          var $cmp242=((($175))|0) < ((($176))|0); //@line 1412 "wavegen.cpp"
          if ($cmp242) { __label__ = 61;; } else { __label__ = 62;; } //@line 1412 "wavegen.cpp"
          if (__label__ == 61) {
  
            var $177=$ov; //@line 1412 "wavegen.cpp"
            HEAP32[((__ZZ7WavegenvE3agc)>>2)]=$177; //@line 1412 "wavegen.cpp"
            ; //@line 1412 "wavegen.cpp"
          }
  
          var $178=$z1; //@line 1413 "wavegen.cpp"
          var $179=HEAP32[((__ZZ7WavegenvE3agc)>>2)]; //@line 1413 "wavegen.cpp"
          var $mul245=((($179)*($178))&4294967295); //@line 1413 "wavegen.cpp"
          var $shr246=($mul245) >> 8; //@line 1413 "wavegen.cpp"
          $z=$shr246; //@line 1413 "wavegen.cpp"
          ; //@line 1414 "wavegen.cpp"
        }
        else if (__label__ == 63) {
  
          var $180=$z; //@line 1416 "wavegen.cpp"
          var $cmp248=((($180))|0) <= -32768; //@line 1416 "wavegen.cpp"
          if (!($cmp248)) { __label__ = 67;break $if_then239$$if_else247$84; } //@line 1416 "wavegen.cpp"
  
          var $181=$z1; //@line 1418 "wavegen.cpp"
          var $div250=((-8388608/((($181))|0))|0); //@line 1418 "wavegen.cpp"
          var $sub251=((($div250)-1)&4294967295); //@line 1418 "wavegen.cpp"
          $ov=$sub251; //@line 1418 "wavegen.cpp"
          var $182=$ov; //@line 1419 "wavegen.cpp"
          var $183=HEAP32[((__ZZ7WavegenvE3agc)>>2)]; //@line 1419 "wavegen.cpp"
          var $cmp252=((($182))|0) < ((($183))|0); //@line 1419 "wavegen.cpp"
          if ($cmp252) { __label__ = 65;; } else { __label__ = 66;; } //@line 1419 "wavegen.cpp"
          if (__label__ == 65) {
  
            var $184=$ov; //@line 1419 "wavegen.cpp"
            HEAP32[((__ZZ7WavegenvE3agc)>>2)]=$184; //@line 1419 "wavegen.cpp"
            ; //@line 1419 "wavegen.cpp"
          }
  
          var $185=$z1; //@line 1420 "wavegen.cpp"
          var $186=HEAP32[((__ZZ7WavegenvE3agc)>>2)]; //@line 1420 "wavegen.cpp"
          var $mul255=((($186)*($185))&4294967295); //@line 1420 "wavegen.cpp"
          var $shr256=($mul255) >> 8; //@line 1420 "wavegen.cpp"
          $z=$shr256; //@line 1420 "wavegen.cpp"
          ; //@line 1421 "wavegen.cpp"
        }
      } while(0);
  
      var $187=$z; //@line 1422 "wavegen.cpp"
      var $conv259=((($187)) & 255); //@line 1422 "wavegen.cpp"
      var $188=HEAP32[((_out_ptr)>>2)]; //@line 1422 "wavegen.cpp"
      var $incdec_ptr=(($188+1)&4294967295); //@line 1422 "wavegen.cpp"
      HEAP32[((_out_ptr)>>2)]=$incdec_ptr; //@line 1422 "wavegen.cpp"
      HEAP8[($188)]=$conv259; //@line 1422 "wavegen.cpp"
      var $189=$z; //@line 1423 "wavegen.cpp"
      var $shr260=($189) >> 8; //@line 1423 "wavegen.cpp"
      var $conv261=((($shr260)) & 255); //@line 1423 "wavegen.cpp"
      var $190=HEAP32[((_out_ptr)>>2)]; //@line 1423 "wavegen.cpp"
      var $incdec_ptr262=(($190+1)&4294967295); //@line 1423 "wavegen.cpp"
      HEAP32[((_out_ptr)>>2)]=$incdec_ptr262; //@line 1423 "wavegen.cpp"
      HEAP8[($190)]=$conv261; //@line 1423 "wavegen.cpp"
      var $191=$z; //@line 1425 "wavegen.cpp"
      var $conv263=((($191)) & 65535); //@line 1425 "wavegen.cpp"
      var $192=HEAP32[((_echo_head)>>2)]; //@line 1425 "wavegen.cpp"
      var $inc264=((($192)+1)&4294967295); //@line 1425 "wavegen.cpp"
      HEAP32[((_echo_head)>>2)]=$inc264; //@line 1425 "wavegen.cpp"
      var $arrayidx265=((_echo_buf+$192*2)&4294967295); //@line 1425 "wavegen.cpp"
      HEAP16[(($arrayidx265)>>1)]=$conv263; //@line 1425 "wavegen.cpp"
      var $193=HEAP32[((_echo_head)>>2)]; //@line 1426 "wavegen.cpp"
      var $cmp266=((($193))|0) >= 5500; //@line 1426 "wavegen.cpp"
      if ($cmp266) { __label__ = 68;; } else { __label__ = 69;; } //@line 1426 "wavegen.cpp"
      if (__label__ == 68) {
  
        HEAP32[((_echo_head)>>2)]=0; //@line 1427 "wavegen.cpp"
        ; //@line 1427 "wavegen.cpp"
      }
  
      var $194=HEAPU32[((_out_ptr)>>2)]; //@line 1429 "wavegen.cpp"
      var $195=HEAPU32[((_out_end)>>2)]; //@line 1429 "wavegen.cpp"
      var $cmp269=((($194))>>>0) >= ((($195))>>>0); //@line 1429 "wavegen.cpp"
      if ($cmp269) { __label__ = 70;break $for_cond$2; } else { __label__ = 1;continue $for_cond$2; } //@line 1429 "wavegen.cpp"
    }
    if (__label__ == 2) {
  
      $retval=0; //@line 1189 "wavegen.cpp"
      ; //@line 1189 "wavegen.cpp"
    }
    else if (__label__ == 18) {
  
      $retval=0; //@line 1244 "wavegen.cpp"
      ; //@line 1244 "wavegen.cpp"
    }
    else if (__label__ == 70) {
  
      $retval=1; //@line 1430 "wavegen.cpp"
      ; //@line 1430 "wavegen.cpp"
    }
  
    var $196=$retval; //@line 1433 "wavegen.cpp"
    ;
    return $196; //@line 1433 "wavegen.cpp"
    return null;
  }
  

  function __ZL17AdvanceParametersv() {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $x;
    var $ix;
    var $0=HEAP32[((((_wdata+12)&4294967295))>>2)]; //@line 990 "wavegen.cpp"
    var $1=HEAP32[((((_wdata+8)&4294967295))>>2)]; //@line 990 "wavegen.cpp"
    var $add=((($1)+($0))&4294967295); //@line 990 "wavegen.cpp"
    HEAP32[((((_wdata+8)&4294967295))>>2)]=$add; //@line 990 "wavegen.cpp"
    var $2=HEAP32[((((_wdata+8)&4294967295))>>2)]; //@line 991 "wavegen.cpp"
    var $shr=($2) >> 8; //@line 991 "wavegen.cpp"
    $ix=$shr; //@line 991 "wavegen.cpp"
    var $cmp=((($shr))|0) > 127; //@line 991 "wavegen.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 991 "wavegen.cpp"
    if (__label__ == 1) {
  
      $ix=127; //@line 991 "wavegen.cpp"
      ; //@line 991 "wavegen.cpp"
    }
  
    var $3=$ix; //@line 992 "wavegen.cpp"
    var $4=HEAP32[((((_wdata)&4294967295))>>2)]; //@line 992 "wavegen.cpp"
    var $arrayidx=(($4+$3)&4294967295); //@line 992 "wavegen.cpp"
    var $5=HEAPU8[($arrayidx)]; //@line 992 "wavegen.cpp"
    var $conv=((($5))&255); //@line 992 "wavegen.cpp"
    var $6=HEAP32[((((_wdata+20)&4294967295))>>2)]; //@line 992 "wavegen.cpp"
    var $mul=((($conv)*($6))&4294967295); //@line 992 "wavegen.cpp"
    $x=$mul; //@line 992 "wavegen.cpp"
    var $7=$x; //@line 993 "wavegen.cpp"
    var $shr1=($7) >> 8; //@line 993 "wavegen.cpp"
    var $8=HEAP32[((((_wdata+16)&4294967295))>>2)]; //@line 993 "wavegen.cpp"
    var $add2=((($shr1)+($8))&4294967295); //@line 993 "wavegen.cpp"
    HEAP32[((((_wdata+4)&4294967295))>>2)]=$add2; //@line 993 "wavegen.cpp"
    var $9=HEAP32[((__ZL7amp_inc)>>2)]; //@line 995 "wavegen.cpp"
    var $10=HEAP32[((__ZL6amp_ix)>>2)]; //@line 995 "wavegen.cpp"
    var $add3=((($10)+($9))&4294967295); //@line 995 "wavegen.cpp"
    HEAP32[((__ZL6amp_ix)>>2)]=$add3; //@line 995 "wavegen.cpp"
    var $11=HEAP32[((__ZZL17AdvanceParametersvE10Flutter_ix)>>2)]; //@line 998 "wavegen.cpp"
    var $cmp4=((($11))|0) >= 23552; //@line 998 "wavegen.cpp"
    if ($cmp4) { __label__ = 3;; } else { __label__ = 4;; } //@line 998 "wavegen.cpp"
    if (__label__ == 3) {
  
      HEAP32[((__ZZL17AdvanceParametersvE10Flutter_ix)>>2)]=0; //@line 999 "wavegen.cpp"
      ; //@line 999 "wavegen.cpp"
    }
  
    var $12=HEAP32[((__ZZL17AdvanceParametersvE10Flutter_ix)>>2)]; //@line 1000 "wavegen.cpp"
    var $shr7=($12) >> 6; //@line 1000 "wavegen.cpp"
    var $arrayidx8=((__ZL11Flutter_tab+$shr7)&4294967295); //@line 1000 "wavegen.cpp"
    var $13=HEAPU8[($arrayidx8)]; //@line 1000 "wavegen.cpp"
    var $conv9=((($13))&255); //@line 1000 "wavegen.cpp"
    var $sub=((($conv9)-128)&4294967295); //@line 1000 "wavegen.cpp"
    var $14=HEAP32[((__ZL11flutter_amp)>>2)]; //@line 1000 "wavegen.cpp"
    var $mul10=((($sub)*($14))&4294967295); //@line 1000 "wavegen.cpp"
    $x=$mul10; //@line 1000 "wavegen.cpp"
    var $15=HEAP32[((__ZL11Flutter_inc)>>2)]; //@line 1001 "wavegen.cpp"
    var $16=HEAP32[((__ZZL17AdvanceParametersvE10Flutter_ix)>>2)]; //@line 1001 "wavegen.cpp"
    var $add11=((($16)+($15))&4294967295); //@line 1001 "wavegen.cpp"
    HEAP32[((__ZZL17AdvanceParametersvE10Flutter_ix)>>2)]=$add11; //@line 1001 "wavegen.cpp"
    var $17=$x; //@line 1002 "wavegen.cpp"
    var $18=HEAP32[((((_wdata+4)&4294967295))>>2)]; //@line 1002 "wavegen.cpp"
    var $add12=((($18)+($17))&4294967295); //@line 1002 "wavegen.cpp"
    HEAP32[((((_wdata+4)&4294967295))>>2)]=$add12; //@line 1002 "wavegen.cpp"
    var $cmp13=((($add12))|0) < 102400; //@line 1003 "wavegen.cpp"
    if ($cmp13) { __label__ = 5;; } else { __label__ = 6;; } //@line 1003 "wavegen.cpp"
    if (__label__ == 5) {
  
      HEAP32[((((_wdata+4)&4294967295))>>2)]=102400; //@line 1004 "wavegen.cpp"
      ; //@line 1004 "wavegen.cpp"
    }
  
    var $19=HEAP32[((__ZL11samplecount)>>2)]; //@line 1006 "wavegen.cpp"
    var $20=HEAP32[((__ZL17samplecount_start)>>2)]; //@line 1006 "wavegen.cpp"
    var $cmp16=((($19))|0)==((($20))|0); //@line 1006 "wavegen.cpp"
    if ($cmp16) { __label__ = 21;; } else { __label__ = 7;; } //@line 1006 "wavegen.cpp"
    $for_end93$$if_end18$11: do { 
      if (__label__ == 7) {
  
        $ix=0; //@line 1009 "wavegen.cpp"
        var $21=$ix; //@line 1009 "wavegen.cpp"
        var $22=HEAP32[((_wvoice)>>2)]; //@line 1009 "wavegen.cpp"
        var $n_harmonic_peaks2=(($22+84)&4294967295); //@line 1009 "wavegen.cpp"
        var $23=HEAP32[(($n_harmonic_peaks2)>>2)]; //@line 1009 "wavegen.cpp"
        var $cmp193=((($21))|0) <= ((($23))|0); //@line 1009 "wavegen.cpp"
        if ($cmp193) { __lastLabel__ = 7; __label__ = 9;; } else { __lastLabel__ = 7; __label__ = 8;; } //@line 1009 "wavegen.cpp"
        $for_body$$for_cond60_preheader$13: do { 
          if (__label__ == 9) {
            while(1) { 
  
              var $24=$ix; //@line 1011 "wavegen.cpp"
              var $arrayidx20=((__ZL5peaks+$24*80)&4294967295); //@line 1011 "wavegen.cpp"
              var $freq_inc=(($arrayidx20+48)&4294967295); //@line 1011 "wavegen.cpp"
              var $25=HEAPF32[(($freq_inc)>>2)]; //@line 1011 "wavegen.cpp"
              var $26=$ix; //@line 1011 "wavegen.cpp"
              var $arrayidx21=((__ZL5peaks+$26*80)&4294967295); //@line 1011 "wavegen.cpp"
              var $freq1=(($arrayidx21+16)&4294967295); //@line 1011 "wavegen.cpp"
              var $27=HEAPF32[(($freq1)>>2)]; //@line 1011 "wavegen.cpp"
              var $add22=($27)+($25); //@line 1011 "wavegen.cpp"
              HEAPF32[(($freq1)>>2)]=$add22; //@line 1011 "wavegen.cpp"
              var $28=$ix; //@line 1012 "wavegen.cpp"
              var $arrayidx23=((__ZL5peaks+$28*80)&4294967295); //@line 1012 "wavegen.cpp"
              var $freq124=(($arrayidx23+16)&4294967295); //@line 1012 "wavegen.cpp"
              var $29=HEAPF32[(($freq124)>>2)]; //@line 1012 "wavegen.cpp"
              var $conv25=((($29))|0); //@line 1012 "wavegen.cpp"
              var $30=$ix; //@line 1012 "wavegen.cpp"
              var $arrayidx26=((__ZL5peaks+$30*80)&4294967295); //@line 1012 "wavegen.cpp"
              var $freq=(($arrayidx26)&4294967295); //@line 1012 "wavegen.cpp"
              HEAP32[(($freq)>>2)]=$conv25; //@line 1012 "wavegen.cpp"
              var $31=$ix; //@line 1013 "wavegen.cpp"
              var $arrayidx27=((__ZL5peaks+$31*80)&4294967295); //@line 1013 "wavegen.cpp"
              var $height_inc=(($arrayidx27+56)&4294967295); //@line 1013 "wavegen.cpp"
              var $32=HEAPF32[(($height_inc)>>2)]; //@line 1013 "wavegen.cpp"
              var $33=$ix; //@line 1013 "wavegen.cpp"
              var $arrayidx28=((__ZL5peaks+$33*80)&4294967295); //@line 1013 "wavegen.cpp"
              var $height1=(($arrayidx28+24)&4294967295); //@line 1013 "wavegen.cpp"
              var $34=HEAPF32[(($height1)>>2)]; //@line 1013 "wavegen.cpp"
              var $add29=($34)+($32); //@line 1013 "wavegen.cpp"
              HEAPF32[(($height1)>>2)]=$add29; //@line 1013 "wavegen.cpp"
              var $35=$ix; //@line 1014 "wavegen.cpp"
              var $arrayidx30=((__ZL5peaks+$35*80)&4294967295); //@line 1014 "wavegen.cpp"
              var $height131=(($arrayidx30+24)&4294967295); //@line 1014 "wavegen.cpp"
              var $36=HEAPF32[(($height131)>>2)]; //@line 1014 "wavegen.cpp"
              var $conv32=((($36))|0); //@line 1014 "wavegen.cpp"
              var $37=$ix; //@line 1014 "wavegen.cpp"
              var $arrayidx33=((__ZL5peaks+$37*80)&4294967295); //@line 1014 "wavegen.cpp"
              var $height=(($arrayidx33+4)&4294967295); //@line 1014 "wavegen.cpp"
              HEAP32[(($height)>>2)]=$conv32; //@line 1014 "wavegen.cpp"
              var $cmp34=((($conv32))|0) < 0; //@line 1014 "wavegen.cpp"
              if ($cmp34) { __label__ = 10;; } else { __label__ = 11;; } //@line 1014 "wavegen.cpp"
              if (__label__ == 10) {
  
                var $38=$ix; //@line 1015 "wavegen.cpp"
                var $arrayidx36=((__ZL5peaks+$38*80)&4294967295); //@line 1015 "wavegen.cpp"
                var $height37=(($arrayidx36+4)&4294967295); //@line 1015 "wavegen.cpp"
                HEAP32[(($height37)>>2)]=0; //@line 1015 "wavegen.cpp"
                ; //@line 1015 "wavegen.cpp"
              }
  
              var $39=$ix; //@line 1016 "wavegen.cpp"
              var $arrayidx39=((__ZL5peaks+$39*80)&4294967295); //@line 1016 "wavegen.cpp"
              var $left_inc=(($arrayidx39+64)&4294967295); //@line 1016 "wavegen.cpp"
              var $40=HEAPF32[(($left_inc)>>2)]; //@line 1016 "wavegen.cpp"
              var $41=$ix; //@line 1016 "wavegen.cpp"
              var $arrayidx40=((__ZL5peaks+$41*80)&4294967295); //@line 1016 "wavegen.cpp"
              var $left1=(($arrayidx40+32)&4294967295); //@line 1016 "wavegen.cpp"
              var $42=HEAPF32[(($left1)>>2)]; //@line 1016 "wavegen.cpp"
              var $add41=($42)+($40); //@line 1016 "wavegen.cpp"
              HEAPF32[(($left1)>>2)]=$add41; //@line 1016 "wavegen.cpp"
              var $43=$ix; //@line 1017 "wavegen.cpp"
              var $arrayidx42=((__ZL5peaks+$43*80)&4294967295); //@line 1017 "wavegen.cpp"
              var $left143=(($arrayidx42+32)&4294967295); //@line 1017 "wavegen.cpp"
              var $44=HEAPF32[(($left143)>>2)]; //@line 1017 "wavegen.cpp"
              var $conv44=((($44))|0); //@line 1017 "wavegen.cpp"
              var $45=$ix; //@line 1017 "wavegen.cpp"
              var $arrayidx45=((__ZL5peaks+$45*80)&4294967295); //@line 1017 "wavegen.cpp"
              var $left=(($arrayidx45+8)&4294967295); //@line 1017 "wavegen.cpp"
              HEAP32[(($left)>>2)]=$conv44; //@line 1017 "wavegen.cpp"
              var $46=$ix; //@line 1018 "wavegen.cpp"
              var $cmp46=((($46))|0) < 3; //@line 1018 "wavegen.cpp"
              var $47=$ix; //@line 1020 "wavegen.cpp"
              var $arrayidx48=((__ZL5peaks+$47*80)&4294967295); //@line 1020 "wavegen.cpp"
              if ($cmp46) { __label__ = 12;; } else { __label__ = 13;; } //@line 1018 "wavegen.cpp"
              if (__label__ == 12) {
  
                var $right_inc=(($arrayidx48+72)&4294967295); //@line 1020 "wavegen.cpp"
                var $48=HEAPF32[(($right_inc)>>2)]; //@line 1020 "wavegen.cpp"
                var $49=$ix; //@line 1020 "wavegen.cpp"
                var $arrayidx49=((__ZL5peaks+$49*80)&4294967295); //@line 1020 "wavegen.cpp"
                var $right1=(($arrayidx49+40)&4294967295); //@line 1020 "wavegen.cpp"
                var $50=HEAPF32[(($right1)>>2)]; //@line 1020 "wavegen.cpp"
                var $add50=($50)+($48); //@line 1020 "wavegen.cpp"
                HEAPF32[(($right1)>>2)]=$add50; //@line 1020 "wavegen.cpp"
                var $51=$ix; //@line 1021 "wavegen.cpp"
                var $arrayidx51=((__ZL5peaks+$51*80)&4294967295); //@line 1021 "wavegen.cpp"
                var $right152=(($arrayidx51+40)&4294967295); //@line 1021 "wavegen.cpp"
                var $52=HEAPF32[(($right152)>>2)]; //@line 1021 "wavegen.cpp"
                var $conv53=((($52))|0); //@line 1021 "wavegen.cpp"
                var $53=$ix; //@line 1021 "wavegen.cpp"
                var $arrayidx54=((__ZL5peaks+$53*80)&4294967295); //@line 1021 "wavegen.cpp"
                var $right=(($arrayidx54+12)&4294967295); //@line 1021 "wavegen.cpp"
                HEAP32[(($right)>>2)]=$conv53; //@line 1021 "wavegen.cpp"
                ; //@line 1022 "wavegen.cpp"
              }
              else if (__label__ == 13) {
  
                var $left56=(($arrayidx48+8)&4294967295); //@line 1025 "wavegen.cpp"
                var $54=HEAP32[(($left56)>>2)]; //@line 1025 "wavegen.cpp"
                var $55=$ix; //@line 1025 "wavegen.cpp"
                var $arrayidx57=((__ZL5peaks+$55*80)&4294967295); //@line 1025 "wavegen.cpp"
                var $right58=(($arrayidx57+12)&4294967295); //@line 1025 "wavegen.cpp"
                HEAP32[(($right58)>>2)]=$54; //@line 1025 "wavegen.cpp"
                ;
              }
  
              var $56=$ix; //@line 1009 "wavegen.cpp"
              var $inc=((($56)+1)&4294967295); //@line 1009 "wavegen.cpp"
              $ix=$inc; //@line 1009 "wavegen.cpp"
              var $57=$ix; //@line 1009 "wavegen.cpp"
              var $58=HEAP32[((_wvoice)>>2)]; //@line 1009 "wavegen.cpp"
              var $n_harmonic_peaks=(($58+84)&4294967295); //@line 1009 "wavegen.cpp"
              var $59=HEAP32[(($n_harmonic_peaks)>>2)]; //@line 1009 "wavegen.cpp"
              var $cmp19=((($57))|0) <= ((($59))|0); //@line 1009 "wavegen.cpp"
              if ($cmp19) { __lastLabel__ = 14; __label__ = 9;continue ; } else { __lastLabel__ = 14; __label__ = 8;break $for_body$$for_cond60_preheader$13; } //@line 1009 "wavegen.cpp"
            }
          }
        } while(0);
  
        var $_lcssa=__lastLabel__ == 7 ? $21 : ($57);
        var $cmp611=((($_lcssa))|0) < 8; //@line 1028 "wavegen.cpp"
        if (!($cmp611)) { __label__ = 21;break $for_end93$$if_end18$11; } //@line 1028 "wavegen.cpp"
  
        var $_pr=$ix; //@line 1031 "wavegen.cpp"
        __lastLabel__ = 15; ;
        while(1) { 
  
          var $60=__lastLabel__ == 15 ? $_pr : ($inc92); //@line 1031 "wavegen.cpp"
          var $cmp63=((($60))|0) < 7; //@line 1031 "wavegen.cpp"
          if ($cmp63) { __label__ = 17;; } else { __label__ = 18;; } //@line 1031 "wavegen.cpp"
          if (__label__ == 17) {
  
            var $61=$ix; //@line 1033 "wavegen.cpp"
            var $arrayidx65=((__ZL5peaks+$61*80)&4294967295); //@line 1033 "wavegen.cpp"
            var $freq_inc66=(($arrayidx65+48)&4294967295); //@line 1033 "wavegen.cpp"
            var $62=HEAPF32[(($freq_inc66)>>2)]; //@line 1033 "wavegen.cpp"
            var $63=$ix; //@line 1033 "wavegen.cpp"
            var $arrayidx67=((__ZL5peaks+$63*80)&4294967295); //@line 1033 "wavegen.cpp"
            var $freq168=(($arrayidx67+16)&4294967295); //@line 1033 "wavegen.cpp"
            var $64=HEAPF32[(($freq168)>>2)]; //@line 1033 "wavegen.cpp"
            var $add69=($64)+($62); //@line 1033 "wavegen.cpp"
            HEAPF32[(($freq168)>>2)]=$add69; //@line 1033 "wavegen.cpp"
            var $65=$ix; //@line 1034 "wavegen.cpp"
            var $arrayidx70=((__ZL5peaks+$65*80)&4294967295); //@line 1034 "wavegen.cpp"
            var $freq171=(($arrayidx70+16)&4294967295); //@line 1034 "wavegen.cpp"
            var $66=HEAPF32[(($freq171)>>2)]; //@line 1034 "wavegen.cpp"
            var $conv72=((($66))|0); //@line 1034 "wavegen.cpp"
            var $67=$ix; //@line 1034 "wavegen.cpp"
            var $arrayidx73=((__ZL5peaks+$67*80)&4294967295); //@line 1034 "wavegen.cpp"
            var $freq74=(($arrayidx73)&4294967295); //@line 1034 "wavegen.cpp"
            HEAP32[(($freq74)>>2)]=$conv72; //@line 1034 "wavegen.cpp"
            ; //@line 1035 "wavegen.cpp"
          }
  
          var $68=$ix; //@line 1036 "wavegen.cpp"
          var $arrayidx76=((__ZL5peaks+$68*80)&4294967295); //@line 1036 "wavegen.cpp"
          var $height_inc77=(($arrayidx76+56)&4294967295); //@line 1036 "wavegen.cpp"
          var $69=HEAPF32[(($height_inc77)>>2)]; //@line 1036 "wavegen.cpp"
          var $70=$ix; //@line 1036 "wavegen.cpp"
          var $arrayidx78=((__ZL5peaks+$70*80)&4294967295); //@line 1036 "wavegen.cpp"
          var $height179=(($arrayidx78+24)&4294967295); //@line 1036 "wavegen.cpp"
          var $71=HEAPF32[(($height179)>>2)]; //@line 1036 "wavegen.cpp"
          var $add80=($71)+($69); //@line 1036 "wavegen.cpp"
          HEAPF32[(($height179)>>2)]=$add80; //@line 1036 "wavegen.cpp"
          var $72=$ix; //@line 1037 "wavegen.cpp"
          var $arrayidx81=((__ZL5peaks+$72*80)&4294967295); //@line 1037 "wavegen.cpp"
          var $height182=(($arrayidx81+24)&4294967295); //@line 1037 "wavegen.cpp"
          var $73=HEAPF32[(($height182)>>2)]; //@line 1037 "wavegen.cpp"
          var $conv83=((($73))|0); //@line 1037 "wavegen.cpp"
          var $74=$ix; //@line 1037 "wavegen.cpp"
          var $arrayidx84=((__ZL5peaks+$74*80)&4294967295); //@line 1037 "wavegen.cpp"
          var $height85=(($arrayidx84+4)&4294967295); //@line 1037 "wavegen.cpp"
          HEAP32[(($height85)>>2)]=$conv83; //@line 1037 "wavegen.cpp"
          var $cmp86=((($conv83))|0) < 0; //@line 1037 "wavegen.cpp"
          if ($cmp86) { __label__ = 19;; } else { __label__ = 20;; } //@line 1037 "wavegen.cpp"
          if (__label__ == 19) {
  
            var $75=$ix; //@line 1038 "wavegen.cpp"
            var $arrayidx88=((__ZL5peaks+$75*80)&4294967295); //@line 1038 "wavegen.cpp"
            var $height89=(($arrayidx88+4)&4294967295); //@line 1038 "wavegen.cpp"
            HEAP32[(($height89)>>2)]=0; //@line 1038 "wavegen.cpp"
            ; //@line 1038 "wavegen.cpp"
          }
  
          var $76=$ix; //@line 1028 "wavegen.cpp"
          var $inc92=((($76)+1)&4294967295); //@line 1028 "wavegen.cpp"
          $ix=$inc92; //@line 1028 "wavegen.cpp"
          var $cmp61=((($inc92))|0) < 8; //@line 1028 "wavegen.cpp"
          if ($cmp61) { __lastLabel__ = 20; __label__ = 16;continue ; } else { __lastLabel__ = 20; __label__ = 21;break $for_end93$$if_end18$11; } //@line 1028 "wavegen.cpp"
        }
      }
    } while(0);
  
    ;
    return; //@line 1049 "wavegen.cpp"
    return;
  }
  

  function __ZL9SetBreathv() {
    ;
    var __label__;
  
    var $pk;
    var $0=HEAP32[((_wvoice)>>2)]; //@line 1121 "wavegen.cpp"
    var $breath=(($0+272)&4294967295); //@line 1121 "wavegen.cpp"
    var $arrayidx=(($breath)&4294967295); //@line 1121 "wavegen.cpp"
    var $1=HEAP32[(($arrayidx)>>2)]; //@line 1121 "wavegen.cpp"
    var $cmp=((($1))|0)==0; //@line 1121 "wavegen.cpp"
    if ($cmp) { __label__ = 5;; } else { __label__ = 1;; } //@line 1121 "wavegen.cpp"
    $for_end$$if_end$2: do { 
      if (__label__ == 1) {
  
        $pk=1; //@line 1124 "wavegen.cpp"
        ; //@line 1124 "wavegen.cpp"
        while(1) { 
  
          var $2=$pk; //@line 1126 "wavegen.cpp"
          var $3=HEAP32[((_wvoice)>>2)]; //@line 1126 "wavegen.cpp"
          var $breath2=(($3+272)&4294967295); //@line 1126 "wavegen.cpp"
          var $arrayidx3=(($breath2+$2*4)&4294967295); //@line 1126 "wavegen.cpp"
          var $4=HEAP32[(($arrayidx3)>>2)]; //@line 1126 "wavegen.cpp"
          var $cmp4=((($4))|0)!=0; //@line 1126 "wavegen.cpp"
          if ($cmp4) { __label__ = 3;; } else { __label__ = 4;; } //@line 1126 "wavegen.cpp"
          if (__label__ == 3) {
  
            var $5=$pk; //@line 1130 "wavegen.cpp"
            var $arrayidx6=((__ZL7rbreath+$5*40)&4294967295); //@line 1130 "wavegen.cpp"
            var $6=$pk; //@line 1130 "wavegen.cpp"
            var $arrayidx7=((__ZL5peaks+$6*80)&4294967295); //@line 1130 "wavegen.cpp"
            var $freq=(($arrayidx7)&4294967295); //@line 1130 "wavegen.cpp"
            var $7=HEAP32[(($freq)>>2)]; //@line 1130 "wavegen.cpp"
            var $shr=($7) >> 16; //@line 1130 "wavegen.cpp"
            var $8=$pk; //@line 1130 "wavegen.cpp"
            var $9=HEAP32[((_wvoice)>>2)]; //@line 1130 "wavegen.cpp"
            var $breathw=(($9+308)&4294967295); //@line 1130 "wavegen.cpp"
            var $arrayidx8=(($breathw+$8*4)&4294967295); //@line 1130 "wavegen.cpp"
            var $10=HEAP32[(($arrayidx8)>>2)]; //@line 1130 "wavegen.cpp"
            __ZL12setresonatorP9RESONATORiii($arrayidx6, $shr, $10, 0); //@line 1130 "wavegen.cpp"
            ; //@line 1131 "wavegen.cpp"
          }
  
          var $11=$pk; //@line 1124 "wavegen.cpp"
          var $inc=((($11)+1)&4294967295); //@line 1124 "wavegen.cpp"
          $pk=$inc; //@line 1124 "wavegen.cpp"
          var $cmp1=((($inc))|0) < 9; //@line 1124 "wavegen.cpp"
          if ($cmp1) { __label__ = 2;continue ; } else { __label__ = 5;break $for_end$$if_end$2; } //@line 1124 "wavegen.cpp"
        }
      }
    } while(0);
  
    ;
    return; //@line 1134 "wavegen.cpp"
    return;
  }
  

  function __ZL11ApplyBreathv() {
    ;
    var __label__;
  
    var $value;
    var $noise;
    var $ix;
    var $amp;
    $value=0; //@line 1139 "wavegen.cpp"
    var $call=_rand(); //@line 1146 "wavegen.cpp"
    var $and=($call) & 16383; //@line 1146 "wavegen.cpp"
    var $sub=((($and)-8192)&4294967295); //@line 1146 "wavegen.cpp"
    $noise=$sub; //@line 1146 "wavegen.cpp"
    $ix=1; //@line 1148 "wavegen.cpp"
    ; //@line 1148 "wavegen.cpp"
    while(1) { 
  
      var $0=$ix; //@line 1150 "wavegen.cpp"
      var $1=HEAP32[((_wvoice)>>2)]; //@line 1150 "wavegen.cpp"
      var $breath=(($1+272)&4294967295); //@line 1150 "wavegen.cpp"
      var $arrayidx=(($breath+$0*4)&4294967295); //@line 1150 "wavegen.cpp"
      var $2=HEAP32[(($arrayidx)>>2)]; //@line 1150 "wavegen.cpp"
      $amp=$2; //@line 1150 "wavegen.cpp"
      var $cmp1=((($2))|0)!=0; //@line 1150 "wavegen.cpp"
      if ($cmp1) { __label__ = 2;; } else { __label__ = 3;; } //@line 1150 "wavegen.cpp"
      if (__label__ == 2) {
  
        var $3=$ix; //@line 1152 "wavegen.cpp"
        var $arrayidx2=((__ZL5peaks+$3*80)&4294967295); //@line 1152 "wavegen.cpp"
        var $height=(($arrayidx2+4)&4294967295); //@line 1152 "wavegen.cpp"
        var $4=HEAP32[(($height)>>2)]; //@line 1152 "wavegen.cpp"
        var $shr=($4) >> 14; //@line 1152 "wavegen.cpp"
        var $5=$amp; //@line 1152 "wavegen.cpp"
        var $mul=((($5)*($shr))&4294967295); //@line 1152 "wavegen.cpp"
        $amp=$mul; //@line 1152 "wavegen.cpp"
        var $6=$ix; //@line 1153 "wavegen.cpp"
        var $arrayidx3=((__ZL7rbreath+$6*40)&4294967295); //@line 1153 "wavegen.cpp"
        var $7=$noise; //@line 1153 "wavegen.cpp"
        var $conv=((($7))|0); //@line 1153 "wavegen.cpp"
        var $call4=__ZL9resonatorP9RESONATORd($arrayidx3, $conv); //@line 1153 "wavegen.cpp"
        var $8=$amp; //@line 1153 "wavegen.cpp"
        var $conv5=((($8))|0); //@line 1153 "wavegen.cpp"
        var $mul6=($call4)*($conv5); //@line 1153 "wavegen.cpp"
        var $conv7=((($mul6))|0); //@line 1153 "wavegen.cpp"
        var $9=$value; //@line 1153 "wavegen.cpp"
        var $add=((($conv7)+($9))&4294967295); //@line 1153 "wavegen.cpp"
        $value=$add; //@line 1153 "wavegen.cpp"
        ; //@line 1154 "wavegen.cpp"
      }
  
      var $10=$ix; //@line 1148 "wavegen.cpp"
      var $inc=((($10)+1)&4294967295); //@line 1148 "wavegen.cpp"
      $ix=$inc; //@line 1148 "wavegen.cpp"
      var $cmp=((($inc))|0) < 9; //@line 1148 "wavegen.cpp"
      if ($cmp) { __label__ = 1;continue ; } else { __label__ = 4;break ; } //@line 1148 "wavegen.cpp"
    }
  
    var $11=$value; //@line 1157 "wavegen.cpp"
    ;
    return $11; //@line 1157 "wavegen.cpp"
    return null;
  }
  

  function __Z11SetEmbeddedii($control, $value) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $control_addr;
    var $value_addr;
    var $sign;
    var $command;
    $control_addr=$control;
    $value_addr=$value;
    $sign=0; //@line 1567 "wavegen.cpp"
    var $0=$control_addr; //@line 1570 "wavegen.cpp"
    var $and=($0) & 31; //@line 1570 "wavegen.cpp"
    $command=$and; //@line 1570 "wavegen.cpp"
    var $1=$control_addr; //@line 1571 "wavegen.cpp"
    var $and1=($1) & 96; //@line 1571 "wavegen.cpp"
    var $cmp=((($and1))|0)==96; //@line 1571 "wavegen.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 1571 "wavegen.cpp"
    $if_then$$if_else$2: do { 
      if (__label__ == 1) {
  
        $sign=-1; //@line 1572 "wavegen.cpp"
        ; //@line 1572 "wavegen.cpp"
      }
      else if (__label__ == 2) {
  
        var $2=$control_addr; //@line 1574 "wavegen.cpp"
        var $and2=($2) & 96; //@line 1574 "wavegen.cpp"
        var $cmp3=((($and2))|0)==64; //@line 1574 "wavegen.cpp"
        if (!($cmp3)) { __label__ = 4;break $if_then$$if_else$2; } //@line 1574 "wavegen.cpp"
  
        $sign=1; //@line 1575 "wavegen.cpp"
        ; //@line 1575 "wavegen.cpp"
      }
    } while(0);
  
    var $3=$command; //@line 1577 "wavegen.cpp"
    var $cmp6=((($3))|0) < 15; //@line 1577 "wavegen.cpp"
    if ($cmp6) { __lastLabel__ = 4; __label__ = 5;; } else { __lastLabel__ = 4; __label__ = 9;; } //@line 1577 "wavegen.cpp"
    if (__label__ == 5) {
  
      var $4=$sign; //@line 1579 "wavegen.cpp"
      var $cmp8=((($4))|0)==0; //@line 1579 "wavegen.cpp"
      var $5=$value_addr; //@line 1580 "wavegen.cpp"
      if ($cmp8) { __label__ = 6;; } else { __label__ = 7;; } //@line 1579 "wavegen.cpp"
      if (__label__ == 6) {
  
        var $6=$command; //@line 1580 "wavegen.cpp"
        var $arrayidx=((_embedded_value+$6*4)&4294967295); //@line 1580 "wavegen.cpp"
        HEAP32[(($arrayidx)>>2)]=$5; //@line 1580 "wavegen.cpp"
        ; //@line 1580 "wavegen.cpp"
      }
      else if (__label__ == 7) {
  
        var $7=$sign; //@line 1582 "wavegen.cpp"
        var $mul=((($7)*($5))&4294967295); //@line 1582 "wavegen.cpp"
        var $8=$command; //@line 1582 "wavegen.cpp"
        var $arrayidx11=((_embedded_value+$8*4)&4294967295); //@line 1582 "wavegen.cpp"
        var $9=HEAP32[(($arrayidx11)>>2)]; //@line 1582 "wavegen.cpp"
        var $add=((($9)+($mul))&4294967295); //@line 1582 "wavegen.cpp"
        HEAP32[(($arrayidx11)>>2)]=$add; //@line 1582 "wavegen.cpp"
        ;
      }
  
      var $10=$command; //@line 1583 "wavegen.cpp"
      var $arrayidx13=((_embedded_value+$10*4)&4294967295); //@line 1583 "wavegen.cpp"
      var $11=HEAP32[(($arrayidx13)>>2)]; //@line 1583 "wavegen.cpp"
      var $12=$command; //@line 1583 "wavegen.cpp"
      var $arrayidx14=((__ZL12embedded_max+$12*4)&4294967295); //@line 1583 "wavegen.cpp"
      var $13=HEAP32[(($arrayidx14)>>2)]; //@line 1583 "wavegen.cpp"
      var $call=__ZL13SetWithRange0ii($11, $13); //@line 1583 "wavegen.cpp"
      var $14=$command; //@line 1583 "wavegen.cpp"
      var $arrayidx15=((_embedded_value+$14*4)&4294967295); //@line 1583 "wavegen.cpp"
      HEAP32[(($arrayidx15)>>2)]=$call; //@line 1583 "wavegen.cpp"
      var $_pr=$command; //@line 1586 "wavegen.cpp"
      __lastLabel__ = 8; ; //@line 1584 "wavegen.cpp"
    }
  
    var $15=__lastLabel__ == 8 ? $_pr : ($3); //@line 1586 "wavegen.cpp"
    if ($15 == 6) {
      __label__ = 10;;
    }
    else if ($15 == 1) {
      __label__ = 11;;
    }
    else if ($15 == 3) {
      __label__ = 12;;
    }
    else if ($15 == 13) {
      __label__ = 13;;
    }
    else if ($15 == 5) {
      __label__ = 14;;
    }
    else {
    __label__ = 15;;
    }
    
    $sw_epilog$$sw_bb$$sw_bb17$$sw_bb18$$sw_bb20$$sw_bb22$14: do { 
      if (__label__ == 10) {
  
        __ZL14WavegenSetEchov(); //@line 1589 "wavegen.cpp"
        __label__ = 11;break $sw_epilog$$sw_bb$$sw_bb17$$sw_bb18$$sw_bb20$$sw_bb22$14; //@line 1589 "wavegen.cpp"
      }
      else if (__label__ == 12) {
  
        var $call19=__Z12GetAmplitudev(); //@line 1595 "wavegen.cpp"
        HEAP32[((__ZL17general_amplitude)>>2)]=$call19; //@line 1595 "wavegen.cpp"
        __label__ = 15;break $sw_epilog$$sw_bb$$sw_bb17$$sw_bb18$$sw_bb20$$sw_bb22$14; //@line 1596 "wavegen.cpp"
      }
      else if (__label__ == 13) {
  
        var $call21=__Z12GetAmplitudev(); //@line 1599 "wavegen.cpp"
        HEAP32[((__ZL17general_amplitude)>>2)]=$call21; //@line 1599 "wavegen.cpp"
        __label__ = 15;break $sw_epilog$$sw_bb$$sw_bb17$$sw_bb18$$sw_bb20$$sw_bb22$14; //@line 1600 "wavegen.cpp"
      }
      else if (__label__ == 14) {
  
        __ZL14WavegenSetEchov(); //@line 1603 "wavegen.cpp"
        __label__ = 15;break $sw_epilog$$sw_bb$$sw_bb17$$sw_bb18$$sw_bb20$$sw_bb22$14; //@line 1604 "wavegen.cpp"
      }
    } while(0);
    if (__label__ == 11) {
  
      __ZL16SetPitchFormantsv(); //@line 1591 "wavegen.cpp"
      ; //@line 1592 "wavegen.cpp"
    }
  
    ;
    return; //@line 1606 "wavegen.cpp"
    return;
  }
  

  function __ZL13SetWithRange0ii($value, $max) {
    ;
    var __label__;
  
    var $retval;
    var $value_addr;
    var $max_addr;
    $value_addr=$value;
    $max_addr=$max;
    var $0=$value_addr; //@line 1535 "wavegen.cpp"
    var $cmp=((($0))|0) < 0; //@line 1535 "wavegen.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 1535 "wavegen.cpp"
    if (__label__ == 1) {
  
      $retval=0; //@line 1536 "wavegen.cpp"
      ; //@line 1536 "wavegen.cpp"
    }
    else if (__label__ == 2) {
  
      var $1=$value_addr; //@line 1537 "wavegen.cpp"
      var $2=$max_addr; //@line 1537 "wavegen.cpp"
      var $cmp1=((($1))|0) > ((($2))|0); //@line 1537 "wavegen.cpp"
      if ($cmp1) { __label__ = 3;; } else { __label__ = 4;; } //@line 1537 "wavegen.cpp"
      if (__label__ == 3) {
  
        var $3=$max_addr; //@line 1538 "wavegen.cpp"
        $retval=$3; //@line 1538 "wavegen.cpp"
        ; //@line 1538 "wavegen.cpp"
      }
      else if (__label__ == 4) {
  
        var $4=$value_addr; //@line 1539 "wavegen.cpp"
        $retval=$4; //@line 1539 "wavegen.cpp"
        ; //@line 1539 "wavegen.cpp"
      }
    }
  
    var $5=$retval; //@line 1540 "wavegen.cpp"
    ;
    return $5; //@line 1540 "wavegen.cpp"
    return null;
  }
  

  function __ZL14WavegenSetEchov() {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $delay;
    var $amp;
    var $0=HEAP32[((_wvoice)>>2)]; //@line 803 "wavegen.cpp"
    var $voicing=(($0+92)&4294967295); //@line 803 "wavegen.cpp"
    var $1=HEAP32[(($voicing)>>2)]; //@line 803 "wavegen.cpp"
    HEAP32[((__ZL7voicing)>>2)]=$1; //@line 803 "wavegen.cpp"
    var $2=HEAP32[((_wvoice)>>2)]; //@line 804 "wavegen.cpp"
    var $echo_delay=(($2+76)&4294967295); //@line 804 "wavegen.cpp"
    var $3=HEAP32[(($echo_delay)>>2)]; //@line 804 "wavegen.cpp"
    $delay=$3; //@line 804 "wavegen.cpp"
    var $4=HEAP32[((_wvoice)>>2)]; //@line 805 "wavegen.cpp"
    var $echo_amp=(($4+80)&4294967295); //@line 805 "wavegen.cpp"
    var $5=HEAP32[(($echo_amp)>>2)]; //@line 805 "wavegen.cpp"
    $amp=$5; //@line 805 "wavegen.cpp"
    var $6=$delay; //@line 807 "wavegen.cpp"
    var $cmp=((($6))|0) >= 5500; //@line 807 "wavegen.cpp"
    if ($cmp) { __lastLabel__ = 0; __label__ = 1;; } else { __lastLabel__ = 0; __label__ = 2;; } //@line 807 "wavegen.cpp"
    if (__label__ == 1) {
  
      $delay=5499; //@line 808 "wavegen.cpp"
      var $_pr=$amp; //@line 809 "wavegen.cpp"
      __lastLabel__ = 1; ; //@line 808 "wavegen.cpp"
    }
  
    var $7=__lastLabel__ == 1 ? $_pr : ($5); //@line 809 "wavegen.cpp"
    var $cmp1=((($7))|0) > 100; //@line 809 "wavegen.cpp"
    if ($cmp1) { __label__ = 3;; } else { __label__ = 4;; } //@line 809 "wavegen.cpp"
    if (__label__ == 3) {
  
      $amp=100; //@line 810 "wavegen.cpp"
      ; //@line 810 "wavegen.cpp"
    }
  
    var $dest$, $stop$, $stop4$, $fast$, $value4$;
    $dest$ = _echo_buf;
    $stop$ = $dest$ + 11000;
    $value4$ = 0;
    if ($value4$ < 0) $value4$ += 256;
    $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
    while ($dest$%4 !== 0 && $dest$ < $stop$) {
      ;; HEAP8[$dest$++] = 0;
    }
    $dest$ >>= 2;
    $stop4$ = $stop$ >> 2;
    while ($dest$ < $stop4$) {
    ;;;;;;;  HEAP32[$dest$++] = $value4$;
    }
    $dest$ <<= 2;
    while ($dest$ < $stop$) {
      ;; HEAP8[$dest$++] = 0;
    }; //@line 812 "wavegen.cpp"
    HEAP32[((_echo_tail)>>2)]=0; //@line 813 "wavegen.cpp"
    var $8=HEAP32[((((_embedded_value+20)&4294967295))>>2)]; //@line 815 "wavegen.cpp"
    var $cmp4=((($8))|0) > 0; //@line 815 "wavegen.cpp"
    if ($cmp4) { __label__ = 5;; } else { __label__ = 6;; } //@line 815 "wavegen.cpp"
    $if_end6_thread$$if_end6$8: do { 
      if (__label__ == 5) {
  
        var $9=HEAP32[((((_embedded_value+20)&4294967295))>>2)]; //@line 818 "wavegen.cpp"
        $amp=$9; //@line 818 "wavegen.cpp"
        $delay=130; //@line 819 "wavegen.cpp"
        ; //@line 831 "wavegen.cpp"
      }
      else if (__label__ == 6) {
  
        var $_pr1=$delay; //@line 831 "wavegen.cpp"
        var $cmp7=((($_pr1))|0)==0; //@line 831 "wavegen.cpp"
        if (!($cmp7)) { __label__ = 8;break $if_end6_thread$$if_end6$8; } //@line 831 "wavegen.cpp"
  
        $amp=0; //@line 832 "wavegen.cpp"
        ; //@line 832 "wavegen.cpp"
      }
    } while(0);
  
    var $10=$delay; //@line 834 "wavegen.cpp"
    var $11=HEAP32[((_samplerate)>>2)]; //@line 834 "wavegen.cpp"
    var $mul=((($11)*($10))&4294967295); //@line 834 "wavegen.cpp"
    var $div=((((($mul))|0)/1000)|0); //@line 834 "wavegen.cpp"
    HEAP32[((_echo_head)>>2)]=$div; //@line 834 "wavegen.cpp"
    var $12=HEAP32[((_echo_head)>>2)]; //@line 835 "wavegen.cpp"
    HEAP32[((__ZL11echo_length)>>2)]=$12; //@line 835 "wavegen.cpp"
    var $13=$amp; //@line 836 "wavegen.cpp"
    var $cmp10=((($13))|0)==0; //@line 836 "wavegen.cpp"
    if ($cmp10) { __lastLabel__ = 8; __label__ = 9;; } else { __lastLabel__ = 8; __label__ = 10;; } //@line 836 "wavegen.cpp"
    if (__label__ == 9) {
  
      HEAP32[((__ZL11echo_length)>>2)]=0; //@line 837 "wavegen.cpp"
      var $_pr3=$amp; //@line 838 "wavegen.cpp"
      __lastLabel__ = 9; ; //@line 837 "wavegen.cpp"
    }
  
    var $14=__lastLabel__ == 9 ? $_pr3 : ($13); //@line 838 "wavegen.cpp"
    var $cmp13=((($14))|0) > 20; //@line 838 "wavegen.cpp"
    if ($cmp13) { __label__ = 11;; } else { __label__ = 12;; } //@line 838 "wavegen.cpp"
    if (__label__ == 11) {
  
      var $15=HEAP32[((_echo_head)>>2)]; //@line 839 "wavegen.cpp"
      var $mul15=((($15)*2)&4294967295); //@line 839 "wavegen.cpp"
      HEAP32[((__ZL11echo_length)>>2)]=$mul15; //@line 839 "wavegen.cpp"
      ; //@line 839 "wavegen.cpp"
    }
  
    var $16=$amp; //@line 842 "wavegen.cpp"
    HEAP32[((_echo_amp)>>2)]=$16; //@line 842 "wavegen.cpp"
    var $call=__Z12GetAmplitudev(); //@line 844 "wavegen.cpp"
    HEAP32[((__ZL17general_amplitude)>>2)]=$call; //@line 844 "wavegen.cpp"
    var $17=HEAP32[((__ZL17general_amplitude)>>2)]; //@line 845 "wavegen.cpp"
    var $18=$amp; //@line 845 "wavegen.cpp"
    var $sub=((500-($18))&4294967295); //@line 845 "wavegen.cpp"
    var $mul17=((($sub)*($17))&4294967295); //@line 845 "wavegen.cpp"
    var $div18=((((($mul17))|0)/500)|0); //@line 845 "wavegen.cpp"
    HEAP32[((__ZL17general_amplitude)>>2)]=$div18; //@line 845 "wavegen.cpp"
    ;
    return; //@line 846 "wavegen.cpp"
    return;
  }
  

  function __ZL16SetPitchFormantsv() {
    ;
    var __label__;
  
    var $ix;
    var $factor;
    var $pitch_value;
    var $0=HEAP32[((((_embedded_value+4)&4294967295))>>2)]; //@line 1550 "wavegen.cpp"
    $pitch_value=$0; //@line 1550 "wavegen.cpp"
    var $cmp=((($0))|0) > 101; //@line 1550 "wavegen.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 1550 "wavegen.cpp"
    if (__label__ == 1) {
  
      $pitch_value=101; //@line 1551 "wavegen.cpp"
      ; //@line 1551 "wavegen.cpp"
    }
  
    var $1=$pitch_value; //@line 1553 "wavegen.cpp"
    var $sub=((($1)-50)&4294967295); //@line 1553 "wavegen.cpp"
    var $mul=((($sub)*25)&4294967295); //@line 1553 "wavegen.cpp"
    var $div=((((($mul))|0)/50)|0); //@line 1553 "wavegen.cpp"
    var $add=((($div)+256)&4294967295); //@line 1553 "wavegen.cpp"
    $factor=$add; //@line 1553 "wavegen.cpp"
    $ix=0; //@line 1554 "wavegen.cpp"
    ; //@line 1554 "wavegen.cpp"
    while(1) { 
  
      var $2=$ix; //@line 1556 "wavegen.cpp"
      var $3=HEAP32[((_wvoice)>>2)]; //@line 1556 "wavegen.cpp"
      var $freq2=(($3+216)&4294967295); //@line 1556 "wavegen.cpp"
      var $arrayidx=(($freq2+$2*2)&4294967295); //@line 1556 "wavegen.cpp"
      var $4=HEAP16[(($arrayidx)>>1)]; //@line 1556 "wavegen.cpp"
      var $conv=(tempInt=(($4)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1556 "wavegen.cpp"
      var $5=$factor; //@line 1556 "wavegen.cpp"
      var $mul2=((($conv)*($5))&4294967295); //@line 1556 "wavegen.cpp"
      var $div3=((((($mul2))|0)/256)|0); //@line 1556 "wavegen.cpp"
      var $conv4=((($div3)) & 65535); //@line 1556 "wavegen.cpp"
      var $6=$ix; //@line 1556 "wavegen.cpp"
      var $7=HEAP32[((_wvoice)>>2)]; //@line 1556 "wavegen.cpp"
      var $freq=(($7+144)&4294967295); //@line 1556 "wavegen.cpp"
      var $arrayidx5=(($freq+$6*2)&4294967295); //@line 1556 "wavegen.cpp"
      HEAP16[(($arrayidx5)>>1)]=$conv4; //@line 1556 "wavegen.cpp"
      var $8=$ix; //@line 1554 "wavegen.cpp"
      var $inc=((($8)+1)&4294967295); //@line 1554 "wavegen.cpp"
      $ix=$inc; //@line 1554 "wavegen.cpp"
      var $cmp1=((($inc))|0) <= 5; //@line 1554 "wavegen.cpp"
      if ($cmp1) { __label__ = 3;continue ; } else { __label__ = 4;break ; } //@line 1554 "wavegen.cpp"
    }
  
    var $9=HEAP32[((((_embedded_value+24)&4294967295))>>2)]; //@line 1558 "wavegen.cpp"
    var $mul6=((($9)*3)&4294967295); //@line 1558 "wavegen.cpp"
    $factor=$mul6; //@line 1558 "wavegen.cpp"
    var $10=HEAP32[((_wvoice)>>2)]; //@line 1559 "wavegen.cpp"
    var $height2=(($10+234)&4294967295); //@line 1559 "wavegen.cpp"
    var $arrayidx7=(($height2)&4294967295); //@line 1559 "wavegen.cpp"
    var $11=HEAP16[(($arrayidx7)>>1)]; //@line 1559 "wavegen.cpp"
    var $conv8=(tempInt=(($11)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1559 "wavegen.cpp"
    var $12=$factor; //@line 1559 "wavegen.cpp"
    var $mul9=((($12)*2)&4294967295); //@line 1559 "wavegen.cpp"
    var $sub10=((256-($mul9))&4294967295); //@line 1559 "wavegen.cpp"
    var $mul11=((($sub10)*($conv8))&4294967295); //@line 1559 "wavegen.cpp"
    var $div12=((((($mul11))|0)/256)|0); //@line 1559 "wavegen.cpp"
    var $conv13=((($div12)) & 65535); //@line 1559 "wavegen.cpp"
    var $13=HEAP32[((_wvoice)>>2)]; //@line 1559 "wavegen.cpp"
    var $height=(($13+162)&4294967295); //@line 1559 "wavegen.cpp"
    var $arrayidx14=(($height)&4294967295); //@line 1559 "wavegen.cpp"
    HEAP16[(($arrayidx14)>>1)]=$conv13; //@line 1559 "wavegen.cpp"
    var $14=HEAP32[((_wvoice)>>2)]; //@line 1560 "wavegen.cpp"
    var $height215=(($14+234)&4294967295); //@line 1560 "wavegen.cpp"
    var $arrayidx16=(($height215+2)&4294967295); //@line 1560 "wavegen.cpp"
    var $15=HEAP16[(($arrayidx16)>>1)]; //@line 1560 "wavegen.cpp"
    var $conv17=(tempInt=(($15)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1560 "wavegen.cpp"
    var $16=$factor; //@line 1560 "wavegen.cpp"
    var $sub18=((256-($16))&4294967295); //@line 1560 "wavegen.cpp"
    var $mul19=((($sub18)*($conv17))&4294967295); //@line 1560 "wavegen.cpp"
    var $div20=((((($mul19))|0)/256)|0); //@line 1560 "wavegen.cpp"
    var $conv21=((($div20)) & 65535); //@line 1560 "wavegen.cpp"
    var $17=HEAP32[((_wvoice)>>2)]; //@line 1560 "wavegen.cpp"
    var $height22=(($17+162)&4294967295); //@line 1560 "wavegen.cpp"
    var $arrayidx23=(($height22+2)&4294967295); //@line 1560 "wavegen.cpp"
    HEAP16[(($arrayidx23)>>1)]=$conv21; //@line 1560 "wavegen.cpp"
    ;
    return; //@line 1561 "wavegen.cpp"
    return;
  }
  

  function __Z15WavegenSetVoiceP7voice_t($v) {
    ;
    var __label__;
  
    var $v_addr;
    $v_addr=$v;
    var $0=$v_addr; //@line 1613 "wavegen.cpp"
    var $1=$0; //@line 1613 "wavegen.cpp"
    var $src$, $dest$, $stop$, $stop4$, $fast$;
    $src$ = $1;
    $dest$ = ((__ZZ15WavegenSetVoiceP7voice_tE2v2)&4294967295);
    $stop$ = $src$ + 1344;
    if (($dest$%4) == ($src$%4) && 1344 > 8) {
      while ($src$%4 !== 0 && $src$ < $stop$) {
        ; HEAP8[$dest$++] = HEAP8[$src$++];
      }
      $src$ >>= 2;
      $dest$ >>= 2;
      $stop4$ = $stop$ >> 2;
      while ($src$ < $stop4$) {
    ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
      }
      $src$ <<= 2;
      $dest$ <<= 2;
    }while ($src$ < $stop$) {
      ; HEAP8[$dest$++] = HEAP8[$src$++];
    }; //@line 1613 "wavegen.cpp"
    HEAP32[((_wvoice)>>2)]=__ZZ15WavegenSetVoiceP7voice_tE2v2; //@line 1614 "wavegen.cpp"
    var $2=$v_addr; //@line 1616 "wavegen.cpp"
    var $peak_shape=(($2+88)&4294967295); //@line 1616 "wavegen.cpp"
    var $3=HEAP32[(($peak_shape)>>2)]; //@line 1616 "wavegen.cpp"
    var $cmp=((($3))|0)==0; //@line 1616 "wavegen.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 1616 "wavegen.cpp"
    if (__label__ == 1) {
  
      HEAP32[((__ZL8pk_shape)>>2)]=((_pk_shape1)&4294967295); //@line 1617 "wavegen.cpp"
      ; //@line 1617 "wavegen.cpp"
    }
    else if (__label__ == 2) {
  
      HEAP32[((__ZL8pk_shape)>>2)]=((__ZL9pk_shape2)&4294967295); //@line 1619 "wavegen.cpp"
      ;
    }
  
    var $4=$v_addr; //@line 1621 "wavegen.cpp"
    var $consonant_amp=(($4+100)&4294967295); //@line 1621 "wavegen.cpp"
    var $5=HEAP32[(($consonant_amp)>>2)]; //@line 1621 "wavegen.cpp"
    var $mul=((($5)*26)&4294967295); //@line 1621 "wavegen.cpp"
    var $div=((((($mul))|0)/100)|0); //@line 1621 "wavegen.cpp"
    HEAP32[((__ZL13consonant_amp)>>2)]=$div; //@line 1621 "wavegen.cpp"
    var $6=HEAP32[((_samplerate)>>2)]; //@line 1622 "wavegen.cpp"
    var $cmp1=((($6))|0) <= 11000; //@line 1622 "wavegen.cpp"
    if ($cmp1) { __label__ = 4;; } else { __label__ = 5;; } //@line 1622 "wavegen.cpp"
    if (__label__ == 4) {
  
      var $7=HEAP32[((__ZL13consonant_amp)>>2)]; //@line 1624 "wavegen.cpp"
      var $mul3=((($7)*2)&4294967295); //@line 1624 "wavegen.cpp"
      HEAP32[((__ZL13consonant_amp)>>2)]=$mul3; //@line 1624 "wavegen.cpp"
      HEAP8[(__ZL16option_harmonic1_b)]=1;
      ; //@line 1626 "wavegen.cpp"
    }
  
    __ZL14WavegenSetEchov(); //@line 1627 "wavegen.cpp"
    __ZL16SetPitchFormantsv(); //@line 1628 "wavegen.cpp"
    var $8=HEAP32[((_wvoice)>>2)]; //@line 1629 "wavegen.cpp"
    var $samplerate=(($8+108)&4294967295); //@line 1629 "wavegen.cpp"
    var $9=HEAP32[(($samplerate)>>2)]; //@line 1629 "wavegen.cpp"
    var $10=HEAP32[((_out_ptr)>>2)]; //@line 1629 "wavegen.cpp"
    __Z11MarkerEventijiPh(8, 0, $9, $10); //@line 1629 "wavegen.cpp"
    ;
    return; //@line 1631 "wavegen.cpp"
    return;
  }
  

  function __Z9SetPitch2P7voice_tiiPiS1_($voice, $pitch1, $pitch2, $pitch_base, $pitch_range) {
    ;
    var __label__;
  
    var $voice_addr;
    var $pitch1_addr;
    var $pitch2_addr;
    var $pitch_base_addr;
    var $pitch_range_addr;
    var $x;
    var $base;
    var $range;
    var $pitch_value;
    $voice_addr=$voice;
    $pitch1_addr=$pitch1;
    $pitch2_addr=$pitch2;
    $pitch_base_addr=$pitch_base;
    $pitch_range_addr=$pitch_range;
    var $0=$pitch1_addr; //@line 1656 "wavegen.cpp"
    var $1=$pitch2_addr; //@line 1656 "wavegen.cpp"
    var $cmp=((($0))|0) > ((($1))|0); //@line 1656 "wavegen.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 1656 "wavegen.cpp"
    if (__label__ == 1) {
  
      var $2=$pitch1_addr; //@line 1658 "wavegen.cpp"
      $x=$2; //@line 1658 "wavegen.cpp"
      var $3=$pitch2_addr; //@line 1659 "wavegen.cpp"
      $pitch1_addr=$3; //@line 1659 "wavegen.cpp"
      var $4=$x; //@line 1660 "wavegen.cpp"
      $pitch2_addr=$4; //@line 1660 "wavegen.cpp"
      ; //@line 1661 "wavegen.cpp"
    }
  
    var $5=HEAP32[((((_embedded_value+4)&4294967295))>>2)]; //@line 1663 "wavegen.cpp"
    $pitch_value=$5; //@line 1663 "wavegen.cpp"
    var $cmp1=((($5))|0) > 101; //@line 1663 "wavegen.cpp"
    if ($cmp1) { __label__ = 3;; } else { __label__ = 4;; } //@line 1663 "wavegen.cpp"
    if (__label__ == 3) {
  
      $pitch_value=101; //@line 1664 "wavegen.cpp"
      ; //@line 1664 "wavegen.cpp"
    }
  
    var $6=HEAP32[((((_embedded_value+24)&4294967295))>>2)]; //@line 1665 "wavegen.cpp"
    var $7=$pitch_value; //@line 1665 "wavegen.cpp"
    var $sub=((($7)-($6))&4294967295); //@line 1665 "wavegen.cpp"
    $pitch_value=$sub; //@line 1665 "wavegen.cpp"
    var $cmp4=((($sub))|0) < 0; //@line 1666 "wavegen.cpp"
    if ($cmp4) { __label__ = 5;; } else { __label__ = 6;; } //@line 1666 "wavegen.cpp"
    if (__label__ == 5) {
  
      $pitch_value=0; //@line 1667 "wavegen.cpp"
      ; //@line 1667 "wavegen.cpp"
    }
  
    var $8=$voice_addr; //@line 1669 "wavegen.cpp"
    var $pitch_base7=(($8+44)&4294967295); //@line 1669 "wavegen.cpp"
    var $9=HEAP32[(($pitch_base7)>>2)]; //@line 1669 "wavegen.cpp"
    var $10=$pitch_value; //@line 1669 "wavegen.cpp"
    var $arrayidx=((_pitch_adjust_tab+$10)&4294967295); //@line 1669 "wavegen.cpp"
    var $11=HEAPU8[($arrayidx)]; //@line 1669 "wavegen.cpp"
    var $conv=((($11))&255); //@line 1669 "wavegen.cpp"
    var $mul=((($conv)*($9))&4294967295); //@line 1669 "wavegen.cpp"
    var $div=((((($mul))|0)/128)|0); //@line 1669 "wavegen.cpp"
    $base=$div; //@line 1669 "wavegen.cpp"
    var $12=$voice_addr; //@line 1670 "wavegen.cpp"
    var $pitch_range8=(($12+48)&4294967295); //@line 1670 "wavegen.cpp"
    var $13=HEAP32[(($pitch_range8)>>2)]; //@line 1670 "wavegen.cpp"
    var $14=HEAP32[((((_embedded_value+16)&4294967295))>>2)]; //@line 1670 "wavegen.cpp"
    var $mul9=((($14)*($13))&4294967295); //@line 1670 "wavegen.cpp"
    var $div10=((((($mul9))|0)/50)|0); //@line 1670 "wavegen.cpp"
    $range=$div10; //@line 1670 "wavegen.cpp"
    var $15=$range; //@line 1673 "wavegen.cpp"
    var $16=$voice_addr; //@line 1673 "wavegen.cpp"
    var $pitch_range11=(($16+48)&4294967295); //@line 1673 "wavegen.cpp"
    var $17=HEAP32[(($pitch_range11)>>2)]; //@line 1673 "wavegen.cpp"
    var $sub12=((($15)-($17))&4294967295); //@line 1673 "wavegen.cpp"
    var $mul13=((($sub12)*18)&4294967295); //@line 1673 "wavegen.cpp"
    var $18=$base; //@line 1673 "wavegen.cpp"
    var $sub14=((($18)-($mul13))&4294967295); //@line 1673 "wavegen.cpp"
    $base=$sub14; //@line 1673 "wavegen.cpp"
    var $19=$base; //@line 1675 "wavegen.cpp"
    var $20=$pitch1_addr; //@line 1675 "wavegen.cpp"
    var $21=$range; //@line 1675 "wavegen.cpp"
    var $mul15=((($21)*($20))&4294967295); //@line 1675 "wavegen.cpp"
    var $div16=((((($mul15))|0)/2)|0); //@line 1675 "wavegen.cpp"
    var $add=((($div16)+($19))&4294967295); //@line 1675 "wavegen.cpp"
    var $22=$pitch_base_addr; //@line 1675 "wavegen.cpp"
    HEAP32[(($22)>>2)]=$add; //@line 1675 "wavegen.cpp"
    var $23=$base; //@line 1676 "wavegen.cpp"
    var $24=$pitch2_addr; //@line 1676 "wavegen.cpp"
    var $25=$range; //@line 1676 "wavegen.cpp"
    var $mul17=((($25)*($24))&4294967295); //@line 1676 "wavegen.cpp"
    var $div18=((((($mul17))|0)/2)|0); //@line 1676 "wavegen.cpp"
    var $26=$pitch_base_addr; //@line 1676 "wavegen.cpp"
    var $27=HEAP32[(($26)>>2)]; //@line 1676 "wavegen.cpp"
    var $_neg=(((-($27)))&4294967295);
    var $add19=((($div18)+($23))&4294967295); //@line 1676 "wavegen.cpp"
    var $sub20=((($add19)+($_neg))&4294967295); //@line 1676 "wavegen.cpp"
    var $28=$pitch_range_addr; //@line 1676 "wavegen.cpp"
    HEAP32[(($28)>>2)]=$sub20; //@line 1676 "wavegen.cpp"
    ;
    return; //@line 1677 "wavegen.cpp"
    return;
  }
  

  function __Z8SetPitchiPhii($length, $env, $pitch1, $pitch2) {
    ;
    var __label__;
  
    var $length_addr;
    var $env_addr;
    var $pitch1_addr;
    var $pitch2_addr;
    $length_addr=$length;
    $env_addr=$env;
    $pitch1_addr=$pitch1;
    $pitch2_addr=$pitch2;
    var $0=$env_addr; //@line 1696 "wavegen.cpp"
    HEAP32[((((_wdata)&4294967295))>>2)]=$0; //@line 1696 "wavegen.cpp"
    var $cmp=((($0))|0)==0; //@line 1696 "wavegen.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 1696 "wavegen.cpp"
    if (__label__ == 1) {
  
      HEAP32[((((_wdata)&4294967295))>>2)]=((_env_fall)&4294967295); //@line 1697 "wavegen.cpp"
      ; //@line 1697 "wavegen.cpp"
    }
  
    HEAP32[((((_wdata+8)&4294967295))>>2)]=0; //@line 1699 "wavegen.cpp"
    var $1=$length_addr; //@line 1700 "wavegen.cpp"
    var $cmp1=((($1))|0)==0; //@line 1700 "wavegen.cpp"
    if ($cmp1) { __label__ = 3;; } else { __label__ = 4;; } //@line 1700 "wavegen.cpp"
    if (__label__ == 3) {
  
      HEAP32[((((_wdata+12)&4294967295))>>2)]=0; //@line 1701 "wavegen.cpp"
      ; //@line 1701 "wavegen.cpp"
    }
    else if (__label__ == 4) {
  
      var $2=$length_addr; //@line 1703 "wavegen.cpp"
      var $div=((2097152/((($2))|0))|0); //@line 1703 "wavegen.cpp"
      HEAP32[((((_wdata+12)&4294967295))>>2)]=$div; //@line 1703 "wavegen.cpp"
      ;
    }
  
    var $3=HEAP32[((_wvoice)>>2)]; //@line 1705 "wavegen.cpp"
    var $4=$pitch1_addr; //@line 1705 "wavegen.cpp"
    var $5=$pitch2_addr; //@line 1705 "wavegen.cpp"
    __Z9SetPitch2P7voice_tiiPiS1_($3, $4, $5, ((_wdata+16)&4294967295), ((_wdata+20)&4294967295)); //@line 1705 "wavegen.cpp"
    var $6=HEAP32[((((_wdata)&4294967295))>>2)]; //@line 1707 "wavegen.cpp"
    var $arrayidx=(($6)&4294967295); //@line 1707 "wavegen.cpp"
    var $7=HEAPU8[($arrayidx)]; //@line 1707 "wavegen.cpp"
    var $conv=((($7))&255); //@line 1707 "wavegen.cpp"
    var $8=HEAP32[((((_wdata+20)&4294967295))>>2)]; //@line 1707 "wavegen.cpp"
    var $mul=((($conv)*($8))&4294967295); //@line 1707 "wavegen.cpp"
    var $shr=($mul) >> 8; //@line 1707 "wavegen.cpp"
    var $9=HEAP32[((((_wdata+16)&4294967295))>>2)]; //@line 1707 "wavegen.cpp"
    var $add=((($shr)+($9))&4294967295); //@line 1707 "wavegen.cpp"
    HEAP32[((((_wdata+4)&4294967295))>>2)]=$add; //@line 1707 "wavegen.cpp"
    var $10=HEAP32[((_wvoice)>>2)]; //@line 1709 "wavegen.cpp"
    var $flutter=(($10+68)&4294967295); //@line 1709 "wavegen.cpp"
    var $11=HEAP32[(($flutter)>>2)]; //@line 1709 "wavegen.cpp"
    HEAP32[((__ZL11flutter_amp)>>2)]=$11; //@line 1709 "wavegen.cpp"
    ;
    return; //@line 1711 "wavegen.cpp"
    return;
  }
  

  function __Z8SetSynthiiP7frame_tS0_P7voice_t($length, $modn, $fr1, $fr2, $v) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $length_addr;
    var $modn_addr;
    var $fr1_addr;
    var $fr2_addr;
    var $v_addr;
    var $ix;
    var $next;
    var $length2;
    var $length4;
    var $qix;
    var $cmd;
    $length_addr=$length;
    $modn_addr=$modn;
    $fr1_addr=$fr1;
    $fr2_addr=$fr2;
    $v_addr=$v;
    HEAP8[(__ZL8end_wave_b)]=1;
    var $0=$modn_addr; //@line 1749 "wavegen.cpp"
    var $and=($0) & 255; //@line 1749 "wavegen.cpp"
    HEAP32[((__ZL15modulation_type)>>2)]=$and; //@line 1749 "wavegen.cpp"
    HEAP32[((__ZL12glottal_flag)>>2)]=0; //@line 1751 "wavegen.cpp"
    var $1=$modn_addr; //@line 1752 "wavegen.cpp"
    var $and1=($1) & 1024; //@line 1752 "wavegen.cpp"
    var $tobool=((($and1))|0)!=0; //@line 1752 "wavegen.cpp"
    if ($tobool) { __label__ = 1;; } else { __label__ = 2;; } //@line 1752 "wavegen.cpp"
    if (__label__ == 1) {
  
      HEAP32[((__ZL12glottal_flag)>>2)]=3; //@line 1754 "wavegen.cpp"
      var $2=$modn_addr; //@line 1755 "wavegen.cpp"
      var $shr=($2) >> 8; //@line 1755 "wavegen.cpp"
      var $and2=($shr) & 3; //@line 1755 "wavegen.cpp"
      var $arrayidx=((__ZZ8SetSynthiiP7frame_tS0_P7voice_tE19glottal_reduce_tab1+$and2*4)&4294967295); //@line 1755 "wavegen.cpp"
      var $3=HEAP32[(($arrayidx)>>2)]; //@line 1755 "wavegen.cpp"
      HEAP32[((__ZL14glottal_reduce)>>2)]=$3; //@line 1755 "wavegen.cpp"
      ; //@line 1756 "wavegen.cpp"
    }
  
    var $4=$modn_addr; //@line 1757 "wavegen.cpp"
    var $and3=($4) & 2048; //@line 1757 "wavegen.cpp"
    var $tobool4=((($and3))|0)!=0; //@line 1757 "wavegen.cpp"
    if ($tobool4) { __label__ = 3;; } else { __label__ = 4;; } //@line 1757 "wavegen.cpp"
    if (__label__ == 3) {
  
      HEAP32[((__ZL12glottal_flag)>>2)]=4; //@line 1759 "wavegen.cpp"
      var $5=$modn_addr; //@line 1760 "wavegen.cpp"
      var $shr6=($5) >> 8; //@line 1760 "wavegen.cpp"
      var $and7=($shr6) & 3; //@line 1760 "wavegen.cpp"
      var $arrayidx8=((__ZZ8SetSynthiiP7frame_tS0_P7voice_tE19glottal_reduce_tab2+$and7*4)&4294967295); //@line 1760 "wavegen.cpp"
      var $6=HEAP32[(($arrayidx8)>>2)]; //@line 1760 "wavegen.cpp"
      HEAP32[((__ZL14glottal_reduce)>>2)]=$6; //@line 1760 "wavegen.cpp"
      ; //@line 1761 "wavegen.cpp"
    }
  
    var $7=HEAP32[((_wcmdq_head)>>2)]; //@line 1763 "wavegen.cpp"
    var $add=((($7)+1)&4294967295); //@line 1763 "wavegen.cpp"
    $qix=$add; //@line 1763 "wavegen.cpp"
    __lastLabel__ = 4; ; //@line 1763 "wavegen.cpp"
    $for_cond$8: while(1) { 
  
      var $8=__lastLabel__ == 11 ? $inc : ($add); //@line 1765 "wavegen.cpp"
      var $cmp=((($8))|0) >= 160; //@line 1765 "wavegen.cpp"
      if ($cmp) { __label__ = 6;; } else { __label__ = 7;; } //@line 1765 "wavegen.cpp"
      if (__label__ == 6) {
  
        $qix=0; //@line 1765 "wavegen.cpp"
        ; //@line 1765 "wavegen.cpp"
      }
  
      var $9=$qix; //@line 1766 "wavegen.cpp"
      var $10=HEAP32[((_wcmdq_tail)>>2)]; //@line 1766 "wavegen.cpp"
      var $cmp12=((($9))|0)==((($10))|0); //@line 1766 "wavegen.cpp"
      if ($cmp12) { __label__ = 12;break $for_cond$8; } //@line 1766 "wavegen.cpp"
  
      var $11=$qix; //@line 1768 "wavegen.cpp"
      var $arrayidx15=((_wcmdq+$11*16)&4294967295); //@line 1768 "wavegen.cpp"
      var $arrayidx16=(($arrayidx15)&4294967295); //@line 1768 "wavegen.cpp"
      var $12=HEAP32[(($arrayidx16)>>2)]; //@line 1768 "wavegen.cpp"
      $cmd=$12; //@line 1768 "wavegen.cpp"
      var $13=$cmd; //@line 1769 "wavegen.cpp"
      var $cmp17=((($13))|0)==3; //@line 1769 "wavegen.cpp"
      if ($cmp17) { __label__ = 9;break $for_cond$8; } //@line 1769 "wavegen.cpp"
  
      var $14=$cmd; //@line 1774 "wavegen.cpp"
      var $cmp20=((($14))|0)==6; //@line 1774 "wavegen.cpp"
      var $15=$cmd; //@line 1774 "wavegen.cpp"
      var $cmp21=((($15))|0)==5; //@line 1774 "wavegen.cpp"
      var $or_cond=($cmp20) | ($cmp21); //@line 1774 "wavegen.cpp"
      if ($or_cond) { __label__ = 12;break $for_cond$8; } //@line 1774 "wavegen.cpp"
  
      var $16=$qix; //@line 1763 "wavegen.cpp"
      var $inc=((($16)+1)&4294967295); //@line 1763 "wavegen.cpp"
      $qix=$inc; //@line 1763 "wavegen.cpp"
      __lastLabel__ = 11; __label__ = 5;continue $for_cond$8; //@line 1763 "wavegen.cpp"
    }
    if (__label__ == 9) {
  
      HEAP8[(__ZL8end_wave_b)]=0;
      ; //@line 1772 "wavegen.cpp"
    }
  
    var $17=$length_addr; //@line 1779 "wavegen.cpp"
    var $add24=((($17)+32)&4294967295); //@line 1779 "wavegen.cpp"
    var $and25=($add24) & -64; //@line 1779 "wavegen.cpp"
    $length2=$and25; //@line 1779 "wavegen.cpp"
    var $cmp26=((($and25))|0)==0; //@line 1780 "wavegen.cpp"
    if ($cmp26) { __label__ = 13;; } else { __label__ = 14;; } //@line 1780 "wavegen.cpp"
    if (__label__ == 13) {
  
      $length2=64; //@line 1781 "wavegen.cpp"
      ; //@line 1781 "wavegen.cpp"
    }
  
    var $18=HEAP32[((__ZL11samplecount)>>2)]; //@line 1784 "wavegen.cpp"
    HEAP32[((__ZL17samplecount_start)>>2)]=$18; //@line 1784 "wavegen.cpp"
    var $19=$length2; //@line 1785 "wavegen.cpp"
    var $20=HEAP32[((__ZL8nsamples)>>2)]; //@line 1785 "wavegen.cpp"
    var $add29=((($20)+($19))&4294967295); //@line 1785 "wavegen.cpp"
    HEAP32[((__ZL8nsamples)>>2)]=$add29; //@line 1785 "wavegen.cpp"
    var $21=$length2; //@line 1787 "wavegen.cpp"
    var $div=((((($21))|0)/4)|0); //@line 1787 "wavegen.cpp"
    $length4=$div; //@line 1787 "wavegen.cpp"
    var $22=$v_addr; //@line 1789 "wavegen.cpp"
    var $freq=(($22+144)&4294967295); //@line 1789 "wavegen.cpp"
    var $arrayidx30=(($freq+14)&4294967295); //@line 1789 "wavegen.cpp"
    var $23=HEAP16[(($arrayidx30)>>1)]; //@line 1789 "wavegen.cpp"
    var $conv=(tempInt=(($23)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1789 "wavegen.cpp"
    var $mul=((($conv)*7800)&4294967295); //@line 1789 "wavegen.cpp"
    var $24=$v_addr; //@line 1789 "wavegen.cpp"
    var $freqadd=(($24+198)&4294967295); //@line 1789 "wavegen.cpp"
    var $arrayidx31=(($freqadd+14)&4294967295); //@line 1789 "wavegen.cpp"
    var $25=HEAP16[(($arrayidx31)>>1)]; //@line 1789 "wavegen.cpp"
    var $conv32=(tempInt=(($25)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1789 "wavegen.cpp"
    var $mul33=((($conv32)*256)&4294967295); //@line 1789 "wavegen.cpp"
    var $add34=((($mul33)+($mul))&4294967295); //@line 1789 "wavegen.cpp"
    var $shl=($add34) << 8; //@line 1789 "wavegen.cpp"
    HEAP32[((((__ZL5peaks+560)&4294967295))>>2)]=$shl; //@line 1789 "wavegen.cpp"
    var $26=$v_addr; //@line 1790 "wavegen.cpp"
    var $freq35=(($26+144)&4294967295); //@line 1790 "wavegen.cpp"
    var $arrayidx36=(($freq35+16)&4294967295); //@line 1790 "wavegen.cpp"
    var $27=HEAP16[(($arrayidx36)>>1)]; //@line 1790 "wavegen.cpp"
    var $conv37=(tempInt=(($27)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1790 "wavegen.cpp"
    var $mul38=((($conv37)*9000)&4294967295); //@line 1790 "wavegen.cpp"
    var $28=$v_addr; //@line 1790 "wavegen.cpp"
    var $freqadd39=(($28+198)&4294967295); //@line 1790 "wavegen.cpp"
    var $arrayidx40=(($freqadd39+16)&4294967295); //@line 1790 "wavegen.cpp"
    var $29=HEAP16[(($arrayidx40)>>1)]; //@line 1790 "wavegen.cpp"
    var $conv41=(tempInt=(($29)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1790 "wavegen.cpp"
    var $mul42=((($conv41)*256)&4294967295); //@line 1790 "wavegen.cpp"
    var $add43=((($mul42)+($mul38))&4294967295); //@line 1790 "wavegen.cpp"
    var $shl44=($add43) << 8; //@line 1790 "wavegen.cpp"
    HEAP32[((((__ZL5peaks+640)&4294967295))>>2)]=$shl44; //@line 1790 "wavegen.cpp"
    $ix=0; //@line 1792 "wavegen.cpp"
    __lastLabel__ = 14; ; //@line 1792 "wavegen.cpp"
    $for_body$22: while(1) { 
  
      var $30=__lastLabel__ == 14 ? 0 : ($inc187); //@line 1794 "wavegen.cpp"
      var $cmp47=((($30))|0) < 7; //@line 1794 "wavegen.cpp"
      if ($cmp47) { __label__ = 16;; } else { __label__ = 17;; } //@line 1794 "wavegen.cpp"
      if (__label__ == 16) {
  
        var $31=$ix; //@line 1796 "wavegen.cpp"
        var $32=$fr1_addr; //@line 1796 "wavegen.cpp"
        var $ffreq=(($32+2)&4294967295); //@line 1796 "wavegen.cpp"
        var $arrayidx49=(($ffreq+$31*2)&4294967295); //@line 1796 "wavegen.cpp"
        var $33=HEAP16[(($arrayidx49)>>1)]; //@line 1796 "wavegen.cpp"
        var $conv50=(tempInt=(($33)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1796 "wavegen.cpp"
        var $34=$ix; //@line 1796 "wavegen.cpp"
        var $35=$v_addr; //@line 1796 "wavegen.cpp"
        var $freq51=(($35+144)&4294967295); //@line 1796 "wavegen.cpp"
        var $arrayidx52=(($freq51+$34*2)&4294967295); //@line 1796 "wavegen.cpp"
        var $36=HEAP16[(($arrayidx52)>>1)]; //@line 1796 "wavegen.cpp"
        var $conv53=(tempInt=(($36)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1796 "wavegen.cpp"
        var $mul54=((($conv53)*($conv50))&4294967295); //@line 1796 "wavegen.cpp"
        var $37=$ix; //@line 1796 "wavegen.cpp"
        var $38=$v_addr; //@line 1796 "wavegen.cpp"
        var $freqadd55=(($38+198)&4294967295); //@line 1796 "wavegen.cpp"
        var $arrayidx56=(($freqadd55+$37*2)&4294967295); //@line 1796 "wavegen.cpp"
        var $39=HEAP16[(($arrayidx56)>>1)]; //@line 1796 "wavegen.cpp"
        var $conv57=(tempInt=(($39)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1796 "wavegen.cpp"
        var $mul58=((($conv57)*256)&4294967295); //@line 1796 "wavegen.cpp"
        var $add59=((($mul58)+($mul54))&4294967295); //@line 1796 "wavegen.cpp"
        var $shl60=($add59) << 8; //@line 1796 "wavegen.cpp"
        var $conv61=((($shl60))|0); //@line 1796 "wavegen.cpp"
        var $40=$ix; //@line 1796 "wavegen.cpp"
        var $arrayidx62=((__ZL5peaks+$40*80)&4294967295); //@line 1796 "wavegen.cpp"
        var $freq1=(($arrayidx62+16)&4294967295); //@line 1796 "wavegen.cpp"
        HEAPF32[(($freq1)>>2)]=$conv61; //@line 1796 "wavegen.cpp"
        var $41=$ix; //@line 1797 "wavegen.cpp"
        var $arrayidx63=((__ZL5peaks+$41*80)&4294967295); //@line 1797 "wavegen.cpp"
        var $freq164=(($arrayidx63+16)&4294967295); //@line 1797 "wavegen.cpp"
        var $42=HEAPF32[(($freq164)>>2)]; //@line 1797 "wavegen.cpp"
        var $conv65=((($42))|0); //@line 1797 "wavegen.cpp"
        var $43=$ix; //@line 1797 "wavegen.cpp"
        var $arrayidx66=((__ZL5peaks+$43*80)&4294967295); //@line 1797 "wavegen.cpp"
        var $freq67=(($arrayidx66)&4294967295); //@line 1797 "wavegen.cpp"
        HEAP32[(($freq67)>>2)]=$conv65; //@line 1797 "wavegen.cpp"
        var $44=$ix; //@line 1798 "wavegen.cpp"
        var $45=$fr2_addr; //@line 1798 "wavegen.cpp"
        var $ffreq68=(($45+2)&4294967295); //@line 1798 "wavegen.cpp"
        var $arrayidx69=(($ffreq68+$44*2)&4294967295); //@line 1798 "wavegen.cpp"
        var $46=HEAP16[(($arrayidx69)>>1)]; //@line 1798 "wavegen.cpp"
        var $conv70=(tempInt=(($46)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1798 "wavegen.cpp"
        var $47=$ix; //@line 1798 "wavegen.cpp"
        var $48=$v_addr; //@line 1798 "wavegen.cpp"
        var $freq71=(($48+144)&4294967295); //@line 1798 "wavegen.cpp"
        var $arrayidx72=(($freq71+$47*2)&4294967295); //@line 1798 "wavegen.cpp"
        var $49=HEAP16[(($arrayidx72)>>1)]; //@line 1798 "wavegen.cpp"
        var $conv73=(tempInt=(($49)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1798 "wavegen.cpp"
        var $mul74=((($conv73)*($conv70))&4294967295); //@line 1798 "wavegen.cpp"
        var $50=$ix; //@line 1798 "wavegen.cpp"
        var $51=$v_addr; //@line 1798 "wavegen.cpp"
        var $freqadd75=(($51+198)&4294967295); //@line 1798 "wavegen.cpp"
        var $arrayidx76=(($freqadd75+$50*2)&4294967295); //@line 1798 "wavegen.cpp"
        var $52=HEAP16[(($arrayidx76)>>1)]; //@line 1798 "wavegen.cpp"
        var $conv77=(tempInt=(($52)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1798 "wavegen.cpp"
        var $mul78=((($conv77)*256)&4294967295); //@line 1798 "wavegen.cpp"
        var $add79=((($mul78)+($mul74))&4294967295); //@line 1798 "wavegen.cpp"
        var $shl80=($add79) << 8; //@line 1798 "wavegen.cpp"
        var $conv81=((($shl80))|0); //@line 1798 "wavegen.cpp"
        $next=$conv81; //@line 1798 "wavegen.cpp"
        var $53=$next; //@line 1799 "wavegen.cpp"
        var $54=$ix; //@line 1799 "wavegen.cpp"
        var $arrayidx82=((__ZL5peaks+$54*80)&4294967295); //@line 1799 "wavegen.cpp"
        var $freq183=(($arrayidx82+16)&4294967295); //@line 1799 "wavegen.cpp"
        var $55=HEAPF32[(($freq183)>>2)]; //@line 1799 "wavegen.cpp"
        var $sub=($53)-($55); //@line 1799 "wavegen.cpp"
        var $mul84=($sub)*16; //@line 1799 "wavegen.cpp"
        var $56=$length4; //@line 1799 "wavegen.cpp"
        var $conv85=((($56))|0); //@line 1799 "wavegen.cpp"
        var $div86=($mul84)/($conv85); //@line 1799 "wavegen.cpp"
        var $57=$ix; //@line 1799 "wavegen.cpp"
        var $arrayidx87=((__ZL5peaks+$57*80)&4294967295); //@line 1799 "wavegen.cpp"
        var $freq_inc=(($arrayidx87+48)&4294967295); //@line 1799 "wavegen.cpp"
        HEAPF32[(($freq_inc)>>2)]=$div86; //@line 1799 "wavegen.cpp"
        ; //@line 1800 "wavegen.cpp"
      }
  
      var $58=$ix; //@line 1802 "wavegen.cpp"
      var $59=$fr1_addr; //@line 1802 "wavegen.cpp"
      var $fheight=(($59+18)&4294967295); //@line 1802 "wavegen.cpp"
      var $arrayidx89=(($fheight+$58)&4294967295); //@line 1802 "wavegen.cpp"
      var $60=HEAPU8[($arrayidx89)]; //@line 1802 "wavegen.cpp"
      var $conv90=((($60))&255); //@line 1802 "wavegen.cpp"
      var $61=$ix; //@line 1802 "wavegen.cpp"
      var $62=$v_addr; //@line 1802 "wavegen.cpp"
      var $height=(($62+162)&4294967295); //@line 1802 "wavegen.cpp"
      var $arrayidx91=(($height+$61*2)&4294967295); //@line 1802 "wavegen.cpp"
      var $63=HEAP16[(($arrayidx91)>>1)]; //@line 1802 "wavegen.cpp"
      var $conv92=(tempInt=(($63)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1802 "wavegen.cpp"
      var $mul93=((($conv90)*64)&4294967295); //@line 1802 "wavegen.cpp"
      var $shl94=((($mul93)*($conv92))&4294967295); //@line 1802 "wavegen.cpp"
      var $conv95=((($shl94))|0); //@line 1802 "wavegen.cpp"
      var $64=$ix; //@line 1802 "wavegen.cpp"
      var $arrayidx96=((__ZL5peaks+$64*80)&4294967295); //@line 1802 "wavegen.cpp"
      var $height1=(($arrayidx96+24)&4294967295); //@line 1802 "wavegen.cpp"
      HEAPF32[(($height1)>>2)]=$conv95; //@line 1802 "wavegen.cpp"
      var $65=$ix; //@line 1803 "wavegen.cpp"
      var $arrayidx97=((__ZL5peaks+$65*80)&4294967295); //@line 1803 "wavegen.cpp"
      var $height198=(($arrayidx97+24)&4294967295); //@line 1803 "wavegen.cpp"
      var $66=HEAPF32[(($height198)>>2)]; //@line 1803 "wavegen.cpp"
      var $conv99=((($66))|0); //@line 1803 "wavegen.cpp"
      var $67=$ix; //@line 1803 "wavegen.cpp"
      var $arrayidx100=((__ZL5peaks+$67*80)&4294967295); //@line 1803 "wavegen.cpp"
      var $height101=(($arrayidx100+4)&4294967295); //@line 1803 "wavegen.cpp"
      HEAP32[(($height101)>>2)]=$conv99; //@line 1803 "wavegen.cpp"
      var $68=$ix; //@line 1804 "wavegen.cpp"
      var $69=$fr2_addr; //@line 1804 "wavegen.cpp"
      var $fheight102=(($69+18)&4294967295); //@line 1804 "wavegen.cpp"
      var $arrayidx103=(($fheight102+$68)&4294967295); //@line 1804 "wavegen.cpp"
      var $70=HEAPU8[($arrayidx103)]; //@line 1804 "wavegen.cpp"
      var $conv104=((($70))&255); //@line 1804 "wavegen.cpp"
      var $71=$ix; //@line 1804 "wavegen.cpp"
      var $72=$v_addr; //@line 1804 "wavegen.cpp"
      var $height105=(($72+162)&4294967295); //@line 1804 "wavegen.cpp"
      var $arrayidx106=(($height105+$71*2)&4294967295); //@line 1804 "wavegen.cpp"
      var $73=HEAP16[(($arrayidx106)>>1)]; //@line 1804 "wavegen.cpp"
      var $conv107=(tempInt=(($73)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1804 "wavegen.cpp"
      var $mul108=((($conv104)*64)&4294967295); //@line 1804 "wavegen.cpp"
      var $shl109=((($mul108)*($conv107))&4294967295); //@line 1804 "wavegen.cpp"
      var $conv110=((($shl109))|0); //@line 1804 "wavegen.cpp"
      $next=$conv110; //@line 1804 "wavegen.cpp"
      var $74=$next; //@line 1805 "wavegen.cpp"
      var $75=$ix; //@line 1805 "wavegen.cpp"
      var $arrayidx111=((__ZL5peaks+$75*80)&4294967295); //@line 1805 "wavegen.cpp"
      var $height1112=(($arrayidx111+24)&4294967295); //@line 1805 "wavegen.cpp"
      var $76=HEAPF32[(($height1112)>>2)]; //@line 1805 "wavegen.cpp"
      var $sub113=($74)-($76); //@line 1805 "wavegen.cpp"
      var $mul114=($sub113)*64; //@line 1805 "wavegen.cpp"
      var $77=$length2; //@line 1805 "wavegen.cpp"
      var $conv115=((($77))|0); //@line 1805 "wavegen.cpp"
      var $div116=($mul114)/($conv115); //@line 1805 "wavegen.cpp"
      var $78=$ix; //@line 1805 "wavegen.cpp"
      var $arrayidx117=((__ZL5peaks+$78*80)&4294967295); //@line 1805 "wavegen.cpp"
      var $height_inc=(($arrayidx117+56)&4294967295); //@line 1805 "wavegen.cpp"
      HEAPF32[(($height_inc)>>2)]=$div116; //@line 1805 "wavegen.cpp"
      var $79=$ix; //@line 1807 "wavegen.cpp"
      var $cmp118=((($79))|0) <= 5; //@line 1807 "wavegen.cpp"
      if ($cmp118) { __label__ = 18;; } else { __label__ = 22;; } //@line 1807 "wavegen.cpp"
      $land_lhs_true$$for_inc186$27: do { 
        if (__label__ == 18) {
  
          var $80=$ix; //@line 1807 "wavegen.cpp"
          var $81=HEAP32[((_wvoice)>>2)]; //@line 1807 "wavegen.cpp"
          var $n_harmonic_peaks=(($81+84)&4294967295); //@line 1807 "wavegen.cpp"
          var $82=HEAP32[(($n_harmonic_peaks)>>2)]; //@line 1807 "wavegen.cpp"
          var $cmp119=((($80))|0) <= ((($82))|0); //@line 1807 "wavegen.cpp"
          if (!($cmp119)) { __label__ = 22;break $land_lhs_true$$for_inc186$27; } //@line 1807 "wavegen.cpp"
  
          var $83=$ix; //@line 1809 "wavegen.cpp"
          var $84=$fr1_addr; //@line 1809 "wavegen.cpp"
          var $fwidth=(($84+26)&4294967295); //@line 1809 "wavegen.cpp"
          var $arrayidx121=(($fwidth+$83)&4294967295); //@line 1809 "wavegen.cpp"
          var $85=HEAPU8[($arrayidx121)]; //@line 1809 "wavegen.cpp"
          var $conv122=((($85))&255); //@line 1809 "wavegen.cpp"
          var $86=$ix; //@line 1809 "wavegen.cpp"
          var $87=$v_addr; //@line 1809 "wavegen.cpp"
          var $width=(($87+180)&4294967295); //@line 1809 "wavegen.cpp"
          var $arrayidx123=(($width+$86*2)&4294967295); //@line 1809 "wavegen.cpp"
          var $88=HEAP16[(($arrayidx123)>>1)]; //@line 1809 "wavegen.cpp"
          var $conv124=(tempInt=(($88)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1809 "wavegen.cpp"
          var $mul125=((($conv122)*1024)&4294967295); //@line 1809 "wavegen.cpp"
          var $shl126=((($mul125)*($conv124))&4294967295); //@line 1809 "wavegen.cpp"
          var $conv127=((($shl126))|0); //@line 1809 "wavegen.cpp"
          var $89=$ix; //@line 1809 "wavegen.cpp"
          var $arrayidx128=((__ZL5peaks+$89*80)&4294967295); //@line 1809 "wavegen.cpp"
          var $left1=(($arrayidx128+32)&4294967295); //@line 1809 "wavegen.cpp"
          HEAPF32[(($left1)>>2)]=$conv127; //@line 1809 "wavegen.cpp"
          var $90=$ix; //@line 1810 "wavegen.cpp"
          var $arrayidx129=((__ZL5peaks+$90*80)&4294967295); //@line 1810 "wavegen.cpp"
          var $left1130=(($arrayidx129+32)&4294967295); //@line 1810 "wavegen.cpp"
          var $91=HEAPF32[(($left1130)>>2)]; //@line 1810 "wavegen.cpp"
          var $conv131=((($91))|0); //@line 1810 "wavegen.cpp"
          var $92=$ix; //@line 1810 "wavegen.cpp"
          var $arrayidx132=((__ZL5peaks+$92*80)&4294967295); //@line 1810 "wavegen.cpp"
          var $left=(($arrayidx132+8)&4294967295); //@line 1810 "wavegen.cpp"
          HEAP32[(($left)>>2)]=$conv131; //@line 1810 "wavegen.cpp"
          var $93=$ix; //@line 1811 "wavegen.cpp"
          var $94=$fr2_addr; //@line 1811 "wavegen.cpp"
          var $fwidth133=(($94+26)&4294967295); //@line 1811 "wavegen.cpp"
          var $arrayidx134=(($fwidth133+$93)&4294967295); //@line 1811 "wavegen.cpp"
          var $95=HEAPU8[($arrayidx134)]; //@line 1811 "wavegen.cpp"
          var $conv135=((($95))&255); //@line 1811 "wavegen.cpp"
          var $96=$ix; //@line 1811 "wavegen.cpp"
          var $97=$v_addr; //@line 1811 "wavegen.cpp"
          var $width136=(($97+180)&4294967295); //@line 1811 "wavegen.cpp"
          var $arrayidx137=(($width136+$96*2)&4294967295); //@line 1811 "wavegen.cpp"
          var $98=HEAP16[(($arrayidx137)>>1)]; //@line 1811 "wavegen.cpp"
          var $conv138=(tempInt=(($98)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1811 "wavegen.cpp"
          var $mul139=((($conv135)*1024)&4294967295); //@line 1811 "wavegen.cpp"
          var $shl140=((($mul139)*($conv138))&4294967295); //@line 1811 "wavegen.cpp"
          var $conv141=((($shl140))|0); //@line 1811 "wavegen.cpp"
          $next=$conv141; //@line 1811 "wavegen.cpp"
          var $99=$next; //@line 1812 "wavegen.cpp"
          var $100=$ix; //@line 1812 "wavegen.cpp"
          var $arrayidx142=((__ZL5peaks+$100*80)&4294967295); //@line 1812 "wavegen.cpp"
          var $left1143=(($arrayidx142+32)&4294967295); //@line 1812 "wavegen.cpp"
          var $101=HEAPF32[(($left1143)>>2)]; //@line 1812 "wavegen.cpp"
          var $sub144=($99)-($101); //@line 1812 "wavegen.cpp"
          var $mul145=($sub144)*64; //@line 1812 "wavegen.cpp"
          var $102=$length2; //@line 1812 "wavegen.cpp"
          var $conv146=((($102))|0); //@line 1812 "wavegen.cpp"
          var $div147=($mul145)/($conv146); //@line 1812 "wavegen.cpp"
          var $103=$ix; //@line 1812 "wavegen.cpp"
          var $arrayidx148=((__ZL5peaks+$103*80)&4294967295); //@line 1812 "wavegen.cpp"
          var $left_inc=(($arrayidx148+64)&4294967295); //@line 1812 "wavegen.cpp"
          HEAPF32[(($left_inc)>>2)]=$div147; //@line 1812 "wavegen.cpp"
          var $104=$ix; //@line 1814 "wavegen.cpp"
          var $cmp149=((($104))|0) < 3; //@line 1814 "wavegen.cpp"
          var $105=$ix; //@line 1816 "wavegen.cpp"
          if ($cmp149) { __label__ = 20;; } else { __label__ = 21;; } //@line 1814 "wavegen.cpp"
          if (__label__ == 20) {
  
            var $106=$fr1_addr; //@line 1816 "wavegen.cpp"
            var $fright=(($106+32)&4294967295); //@line 1816 "wavegen.cpp"
            var $arrayidx151=(($fright+$105)&4294967295); //@line 1816 "wavegen.cpp"
            var $107=HEAPU8[($arrayidx151)]; //@line 1816 "wavegen.cpp"
            var $conv152=((($107))&255); //@line 1816 "wavegen.cpp"
            var $108=$ix; //@line 1816 "wavegen.cpp"
            var $109=$v_addr; //@line 1816 "wavegen.cpp"
            var $width153=(($109+180)&4294967295); //@line 1816 "wavegen.cpp"
            var $arrayidx154=(($width153+$108*2)&4294967295); //@line 1816 "wavegen.cpp"
            var $110=HEAP16[(($arrayidx154)>>1)]; //@line 1816 "wavegen.cpp"
            var $conv155=(tempInt=(($110)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1816 "wavegen.cpp"
            var $mul156=((($conv152)*1024)&4294967295); //@line 1816 "wavegen.cpp"
            var $shl157=((($mul156)*($conv155))&4294967295); //@line 1816 "wavegen.cpp"
            var $conv158=((($shl157))|0); //@line 1816 "wavegen.cpp"
            var $111=$ix; //@line 1816 "wavegen.cpp"
            var $arrayidx159=((__ZL5peaks+$111*80)&4294967295); //@line 1816 "wavegen.cpp"
            var $right1=(($arrayidx159+40)&4294967295); //@line 1816 "wavegen.cpp"
            HEAPF32[(($right1)>>2)]=$conv158; //@line 1816 "wavegen.cpp"
            var $112=$ix; //@line 1817 "wavegen.cpp"
            var $arrayidx160=((__ZL5peaks+$112*80)&4294967295); //@line 1817 "wavegen.cpp"
            var $right1161=(($arrayidx160+40)&4294967295); //@line 1817 "wavegen.cpp"
            var $113=HEAPF32[(($right1161)>>2)]; //@line 1817 "wavegen.cpp"
            var $conv162=((($113))|0); //@line 1817 "wavegen.cpp"
            var $114=$ix; //@line 1817 "wavegen.cpp"
            var $arrayidx163=((__ZL5peaks+$114*80)&4294967295); //@line 1817 "wavegen.cpp"
            var $right=(($arrayidx163+12)&4294967295); //@line 1817 "wavegen.cpp"
            HEAP32[(($right)>>2)]=$conv162; //@line 1817 "wavegen.cpp"
            var $115=$ix; //@line 1818 "wavegen.cpp"
            var $116=$fr2_addr; //@line 1818 "wavegen.cpp"
            var $fright164=(($116+32)&4294967295); //@line 1818 "wavegen.cpp"
            var $arrayidx165=(($fright164+$115)&4294967295); //@line 1818 "wavegen.cpp"
            var $117=HEAPU8[($arrayidx165)]; //@line 1818 "wavegen.cpp"
            var $conv166=((($117))&255); //@line 1818 "wavegen.cpp"
            var $118=$ix; //@line 1818 "wavegen.cpp"
            var $119=$v_addr; //@line 1818 "wavegen.cpp"
            var $width167=(($119+180)&4294967295); //@line 1818 "wavegen.cpp"
            var $arrayidx168=(($width167+$118*2)&4294967295); //@line 1818 "wavegen.cpp"
            var $120=HEAP16[(($arrayidx168)>>1)]; //@line 1818 "wavegen.cpp"
            var $conv169=(tempInt=(($120)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1818 "wavegen.cpp"
            var $mul170=((($conv166)*1024)&4294967295); //@line 1818 "wavegen.cpp"
            var $shl171=((($mul170)*($conv169))&4294967295); //@line 1818 "wavegen.cpp"
            var $conv172=((($shl171))|0); //@line 1818 "wavegen.cpp"
            $next=$conv172; //@line 1818 "wavegen.cpp"
            var $121=$next; //@line 1819 "wavegen.cpp"
            var $122=$ix; //@line 1819 "wavegen.cpp"
            var $arrayidx173=((__ZL5peaks+$122*80)&4294967295); //@line 1819 "wavegen.cpp"
            var $right1174=(($arrayidx173+40)&4294967295); //@line 1819 "wavegen.cpp"
            var $123=HEAPF32[(($right1174)>>2)]; //@line 1819 "wavegen.cpp"
            var $sub175=($121)-($123); //@line 1819 "wavegen.cpp"
            var $mul176=($sub175)*64; //@line 1819 "wavegen.cpp"
            var $124=$length2; //@line 1819 "wavegen.cpp"
            var $conv177=((($124))|0); //@line 1819 "wavegen.cpp"
            var $div178=($mul176)/($conv177); //@line 1819 "wavegen.cpp"
            var $125=$ix; //@line 1819 "wavegen.cpp"
            var $arrayidx179=((__ZL5peaks+$125*80)&4294967295); //@line 1819 "wavegen.cpp"
            var $right_inc=(($arrayidx179+72)&4294967295); //@line 1819 "wavegen.cpp"
            HEAPF32[(($right_inc)>>2)]=$div178; //@line 1819 "wavegen.cpp"
            ; //@line 1820 "wavegen.cpp"
          }
          else if (__label__ == 21) {
  
            var $arrayidx180=((__ZL5peaks+$105*80)&4294967295); //@line 1823 "wavegen.cpp"
            var $left181=(($arrayidx180+8)&4294967295); //@line 1823 "wavegen.cpp"
            var $126=HEAP32[(($left181)>>2)]; //@line 1823 "wavegen.cpp"
            var $127=$ix; //@line 1823 "wavegen.cpp"
            var $arrayidx182=((__ZL5peaks+$127*80)&4294967295); //@line 1823 "wavegen.cpp"
            var $right183=(($arrayidx182+12)&4294967295); //@line 1823 "wavegen.cpp"
            HEAP32[(($right183)>>2)]=$126; //@line 1823 "wavegen.cpp"
            ;
          }
        }
      } while(0);
  
      var $128=$ix; //@line 1792 "wavegen.cpp"
      var $inc187=((($128)+1)&4294967295); //@line 1792 "wavegen.cpp"
      $ix=$inc187; //@line 1792 "wavegen.cpp"
      var $cmp46=((($inc187))|0) < 8; //@line 1792 "wavegen.cpp"
      if ($cmp46) { __lastLabel__ = 22; __label__ = 15;continue $for_body$22; } else { __lastLabel__ = 22; __label__ = 23;break $for_body$22; } //@line 1792 "wavegen.cpp"
    }
  
    ;
    return; //@line 1827 "wavegen.cpp"
    return;
  }
  

  function __Z11Write4BytesP7__sFILEi($f, $value) {
    ;
    var __label__;
  
    var $f_addr;
    var $value_addr;
    var $ix;
    $f_addr=$f;
    $value_addr=$value;
    $ix=0; //@line 1843 "wavegen.cpp"
    ; //@line 1843 "wavegen.cpp"
    while(1) { 
  
      var $0=$value_addr; //@line 1845 "wavegen.cpp"
      var $and=($0) & 255; //@line 1845 "wavegen.cpp"
      var $1=$f_addr; //@line 1845 "wavegen.cpp"
      var $call=_fputc($and, $1); //@line 1845 "wavegen.cpp"
      var $2=$value_addr; //@line 1846 "wavegen.cpp"
      var $shr=($2) >> 8; //@line 1846 "wavegen.cpp"
      $value_addr=$shr; //@line 1846 "wavegen.cpp"
      var $3=$ix; //@line 1843 "wavegen.cpp"
      var $inc=((($3)+1)&4294967295); //@line 1843 "wavegen.cpp"
      $ix=$inc; //@line 1843 "wavegen.cpp"
      var $cmp=((($inc))|0) < 4; //@line 1843 "wavegen.cpp"
      if ($cmp) { __label__ = 1;continue ; } else { __label__ = 2;break ; } //@line 1843 "wavegen.cpp"
    }
  
    ;
    return; //@line 1848 "wavegen.cpp"
    return;
  }
  

  function __Z12WavegenFill2i($fill_zeros) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $fill_zeros_addr;
    var $q;
    var $length;
    var $result;
    $fill_zeros_addr=$fill_zeros;
    ; //@line 1864 "wavegen.cpp"
    $while_cond$2: while(1) { 
  
      var $0=HEAPU32[((_out_ptr)>>2)]; //@line 1864 "wavegen.cpp"
      var $1=HEAPU32[((_out_end)>>2)]; //@line 1864 "wavegen.cpp"
      var $cmp=((($0))>>>0) < ((($1))>>>0); //@line 1864 "wavegen.cpp"
      if (!($cmp)) { __label__ = 36;break $while_cond$2; } //@line 1864 "wavegen.cpp"
  
      var $call=__Z9WcmdqUsedv(); //@line 1866 "wavegen.cpp"
      var $cmp1=((($call))|0) <= 0; //@line 1866 "wavegen.cpp"
      if ($cmp1) { __label__ = 3;break $while_cond$2; } //@line 1866 "wavegen.cpp"
  
      $result=0; //@line 1884 "wavegen.cpp"
      var $12=HEAP32[((_wcmdq_head)>>2)]; //@line 1885 "wavegen.cpp"
      var $arrayidx=((_wcmdq+$12*16)&4294967295); //@line 1885 "wavegen.cpp"
      var $arraydecay=(($arrayidx)&4294967295); //@line 1885 "wavegen.cpp"
      $q=$arraydecay; //@line 1885 "wavegen.cpp"
      var $13=$q; //@line 1886 "wavegen.cpp"
      var $arrayidx14=(($13+4)&4294967295); //@line 1886 "wavegen.cpp"
      var $14=HEAP32[(($arrayidx14)>>2)]; //@line 1886 "wavegen.cpp"
      $length=$14; //@line 1886 "wavegen.cpp"
      var $15=$q; //@line 1888 "wavegen.cpp"
      var $arrayidx15=(($15)&4294967295); //@line 1888 "wavegen.cpp"
      var $16=HEAP32[(($arrayidx15)>>2)]; //@line 1888 "wavegen.cpp"
      if ($16 == 9) {
        __label__ = 11;;
      }
      else if ($16 == 5) {
        __label__ = 12;;
      }
      else if ($16 == 6) {
        __label__ = 15;;
      }
      else if ($16 == 7) {
        __label__ = 16;;
      }
      else if ($16 == 4) {
        __label__ = 19;;
      }
      else if ($16 == 3) {
        __label__ = 20;;
      }
      else if ($16 == 2) {
        __label__ = 21;;
      }
      else if ($16 == 1) {
        __label__ = 22;;
      }
      else if ($16 == 10) {
        __label__ = 23;;
      }
      else if ($16 == 8) {
        __label__ = 25;;
      }
      else if ($16 == 11) {
        __label__ = 26;;
      }
      else if ($16 == 12) {
        __label__ = 27;;
      }
      else if ($16 == 13) {
        __label__ = 28;;
      }
      else if ($16 == 14) {
        __label__ = 29;;
      }
      else if ($16 == 15) {
        __label__ = 31;;
      }
      else {
      __label__ = 32;;
      }
      
      $sw_epilogthread_pre_split$$sw_bb$$sw_bb19$$sw_bb24$$sw_bb31$$sw_bb44$$sw_bb45$$sw_bb52$$sw_bb53$$sw_bb60$$sw_bb70$$sw_bb73$$sw_bb76$$sw_bb79$$sw_bb81$$sw_bb86$6: do { 
        if (__label__ == 11) {
  
          var $17=$length; //@line 1891 "wavegen.cpp"
          var $18=$q; //@line 1891 "wavegen.cpp"
          var $arrayidx16=(($18+8)&4294967295); //@line 1891 "wavegen.cpp"
          var $19=HEAP32[(($arrayidx16)>>2)]; //@line 1891 "wavegen.cpp"
          var $20=($19); //@line 1891 "wavegen.cpp"
          var $21=$q; //@line 1891 "wavegen.cpp"
          var $arrayidx17=(($21+12)&4294967295); //@line 1891 "wavegen.cpp"
          var $22=HEAP32[(($arrayidx17)>>2)]; //@line 1891 "wavegen.cpp"
          var $shr=($22) >> 16; //@line 1891 "wavegen.cpp"
          var $23=$q; //@line 1891 "wavegen.cpp"
          var $arrayidx18=(($23+12)&4294967295); //@line 1891 "wavegen.cpp"
          var $24=HEAP32[(($arrayidx18)>>2)]; //@line 1891 "wavegen.cpp"
          var $and=($24) & 65535; //@line 1891 "wavegen.cpp"
          __Z8SetPitchiPhii($17, $20, $shr, $and); //@line 1891 "wavegen.cpp"
          __label__ = 32;break $sw_epilogthread_pre_split$$sw_bb$$sw_bb19$$sw_bb24$$sw_bb31$$sw_bb44$$sw_bb45$$sw_bb52$$sw_bb53$$sw_bb60$$sw_bb70$$sw_bb73$$sw_bb76$$sw_bb79$$sw_bb81$$sw_bb86$6; //@line 1892 "wavegen.cpp"
        }
        else if (__label__ == 12) {
  
          var $25=HEAP32[((__ZZ12WavegenFill2iE6resume)>>2)]; //@line 1895 "wavegen.cpp"
          var $cmp20=((($25))|0)==0; //@line 1895 "wavegen.cpp"
          if ($cmp20) { __label__ = 13;; } else { __label__ = 14;; } //@line 1895 "wavegen.cpp"
          if (__label__ == 13) {
  
            var $26=$length; //@line 1897 "wavegen.cpp"
            var $27=HEAP32[((__ZZ12WavegenFill2iE13echo_complete)>>2)]; //@line 1897 "wavegen.cpp"
            var $sub=((($27)-($26))&4294967295); //@line 1897 "wavegen.cpp"
            HEAP32[((__ZZ12WavegenFill2iE13echo_complete)>>2)]=$sub; //@line 1897 "wavegen.cpp"
            ; //@line 1898 "wavegen.cpp"
          }
  
          HEAP32[((((_wdata+28)&4294967295))>>2)]=0; //@line 1899 "wavegen.cpp"
          HEAP32[((((_wdata+60)&4294967295))>>2)]=100; //@line 1900 "wavegen.cpp"
          __Z10KlattReseti(1); //@line 1901 "wavegen.cpp"
          var $28=$length; //@line 1902 "wavegen.cpp"
          var $29=HEAP32[((__ZZ12WavegenFill2iE6resume)>>2)]; //@line 1902 "wavegen.cpp"
          var $call23=__ZL11PlaySilenceii($28, $29); //@line 1902 "wavegen.cpp"
          $result=$call23; //@line 1902 "wavegen.cpp"
          __lastLabel__ = 14; __label__ = 33;break $sw_epilogthread_pre_split$$sw_bb$$sw_bb19$$sw_bb24$$sw_bb31$$sw_bb44$$sw_bb45$$sw_bb52$$sw_bb53$$sw_bb60$$sw_bb70$$sw_bb73$$sw_bb76$$sw_bb79$$sw_bb81$$sw_bb86$6; //@line 1903 "wavegen.cpp"
        }
        else if (__label__ == 15) {
  
          var $30=HEAP32[((__ZL11echo_length)>>2)]; //@line 1906 "wavegen.cpp"
          HEAP32[((__ZZ12WavegenFill2iE13echo_complete)>>2)]=$30; //@line 1906 "wavegen.cpp"
          HEAP32[((((_wdata+28)&4294967295))>>2)]=0; //@line 1907 "wavegen.cpp"
          __Z10KlattReseti(1); //@line 1908 "wavegen.cpp"
          var $31=$length; //@line 1909 "wavegen.cpp"
          var $32=HEAP32[((__ZZ12WavegenFill2iE6resume)>>2)]; //@line 1909 "wavegen.cpp"
          var $33=$q; //@line 1909 "wavegen.cpp"
          var $arrayidx25=(($33+8)&4294967295); //@line 1909 "wavegen.cpp"
          var $34=HEAP32[(($arrayidx25)>>2)]; //@line 1909 "wavegen.cpp"
          var $35=($34); //@line 1909 "wavegen.cpp"
          var $36=$q; //@line 1909 "wavegen.cpp"
          var $arrayidx26=(($36+12)&4294967295); //@line 1909 "wavegen.cpp"
          var $37=HEAP32[(($arrayidx26)>>2)]; //@line 1909 "wavegen.cpp"
          var $and27=($37) & 255; //@line 1909 "wavegen.cpp"
          var $38=$q; //@line 1909 "wavegen.cpp"
          var $arrayidx28=(($38+12)&4294967295); //@line 1909 "wavegen.cpp"
          var $39=HEAP32[(($arrayidx28)>>2)]; //@line 1909 "wavegen.cpp"
          var $shr29=($39) >> 8; //@line 1909 "wavegen.cpp"
          var $call30=__ZL8PlayWaveiiPhii($31, $32, $35, $and27, $shr29); //@line 1909 "wavegen.cpp"
          $result=$call30; //@line 1909 "wavegen.cpp"
          __lastLabel__ = 15; __label__ = 33;break $sw_epilogthread_pre_split$$sw_bb$$sw_bb19$$sw_bb24$$sw_bb31$$sw_bb44$$sw_bb45$$sw_bb52$$sw_bb53$$sw_bb60$$sw_bb70$$sw_bb73$$sw_bb76$$sw_bb79$$sw_bb81$$sw_bb86$6; //@line 1910 "wavegen.cpp"
        }
        else if (__label__ == 16) {
  
          var $40=$q; //@line 1914 "wavegen.cpp"
          var $arrayidx32=(($40+12)&4294967295); //@line 1914 "wavegen.cpp"
          var $41=HEAP32[(($arrayidx32)>>2)]; //@line 1914 "wavegen.cpp"
          var $shr33=($41) >> 8; //@line 1914 "wavegen.cpp"
          HEAP32[((((_wdata+36)&4294967295))>>2)]=$shr33; //@line 1914 "wavegen.cpp"
          var $42=$q; //@line 1915 "wavegen.cpp"
          var $arrayidx34=(($42+12)&4294967295); //@line 1915 "wavegen.cpp"
          var $43=HEAP32[(($arrayidx34)>>2)]; //@line 1915 "wavegen.cpp"
          var $and35=($43) & 255; //@line 1915 "wavegen.cpp"
          HEAP32[((((_wdata+32)&4294967295))>>2)]=$and35; //@line 1915 "wavegen.cpp"
          var $44=$length; //@line 1916 "wavegen.cpp"
          var $and36=($44) & 65535; //@line 1916 "wavegen.cpp"
          HEAP32[((((_wdata+28)&4294967295))>>2)]=$and36; //@line 1916 "wavegen.cpp"
          var $45=$length; //@line 1917 "wavegen.cpp"
          var $shr37=($45) >> 16; //@line 1917 "wavegen.cpp"
          var $and38=($shr37) & 65535; //@line 1917 "wavegen.cpp"
          HEAP32[((((_wdata+44)&4294967295))>>2)]=$and38; //@line 1917 "wavegen.cpp"
          var $46=HEAP32[((((_wdata+32)&4294967295))>>2)]; //@line 1918 "wavegen.cpp"
          var $cmp39=((($46))|0)==0; //@line 1918 "wavegen.cpp"
          if ($cmp39) { __label__ = 17;; } else { __label__ = 18;; } //@line 1918 "wavegen.cpp"
          if (__label__ == 17) {
  
            var $47=HEAP32[((((_wdata+28)&4294967295))>>2)]; //@line 1920 "wavegen.cpp"
            var $mul=((($47)*2)&4294967295); //@line 1920 "wavegen.cpp"
            HEAP32[((((_wdata+28)&4294967295))>>2)]=$mul; //@line 1920 "wavegen.cpp"
            var $48=HEAP32[((((_wdata+44)&4294967295))>>2)]; //@line 1921 "wavegen.cpp"
            var $mul41=((($48)*2)&4294967295); //@line 1921 "wavegen.cpp"
            HEAP32[((((_wdata+44)&4294967295))>>2)]=$mul41; //@line 1921 "wavegen.cpp"
            ; //@line 1922 "wavegen.cpp"
          }
  
          HEAP32[((((_wdata+40)&4294967295))>>2)]=0; //@line 1923 "wavegen.cpp"
          HEAP32[((((_wdata+48)&4294967295))>>2)]=0; //@line 1924 "wavegen.cpp"
          var $49=$q; //@line 1925 "wavegen.cpp"
          var $arrayidx43=(($49+8)&4294967295); //@line 1925 "wavegen.cpp"
          var $50=HEAP32[(($arrayidx43)>>2)]; //@line 1925 "wavegen.cpp"
          var $51=($50); //@line 1925 "wavegen.cpp"
          HEAP32[((((_wdata+24)&4294967295))>>2)]=$51; //@line 1925 "wavegen.cpp"
          __label__ = 32;break $sw_epilogthread_pre_split$$sw_bb$$sw_bb19$$sw_bb24$$sw_bb31$$sw_bb44$$sw_bb45$$sw_bb52$$sw_bb53$$sw_bb60$$sw_bb70$$sw_bb73$$sw_bb76$$sw_bb79$$sw_bb81$$sw_bb86$6; //@line 1926 "wavegen.cpp"
        }
        else if (__label__ == 19) {
  
          HEAP32[((((_wdata+28)&4294967295))>>2)]=0; //@line 1929 "wavegen.cpp"
          __label__ = 20;break $sw_epilogthread_pre_split$$sw_bb$$sw_bb19$$sw_bb24$$sw_bb31$$sw_bb44$$sw_bb45$$sw_bb52$$sw_bb53$$sw_bb60$$sw_bb70$$sw_bb73$$sw_bb76$$sw_bb79$$sw_bb81$$sw_bb86$6; //@line 1929 "wavegen.cpp"
        }
        else if (__label__ == 21) {
  
          HEAP32[((((_wdata+28)&4294967295))>>2)]=0; //@line 1937 "wavegen.cpp"
          __label__ = 22;break $sw_epilogthread_pre_split$$sw_bb$$sw_bb19$$sw_bb24$$sw_bb31$$sw_bb44$$sw_bb45$$sw_bb52$$sw_bb53$$sw_bb60$$sw_bb70$$sw_bb73$$sw_bb76$$sw_bb79$$sw_bb81$$sw_bb86$6; //@line 1937 "wavegen.cpp"
        }
        else if (__label__ == 23) {
  
          var $74=$q; //@line 1945 "wavegen.cpp"
          var $arrayidx61=(($74+4)&4294967295); //@line 1945 "wavegen.cpp"
          var $75=HEAP32[(($arrayidx61)>>2)]; //@line 1945 "wavegen.cpp"
          var $76=$q; //@line 1945 "wavegen.cpp"
          var $arrayidx62=(($76+8)&4294967295); //@line 1945 "wavegen.cpp"
          var $77=HEAP32[(($arrayidx62)>>2)]; //@line 1945 "wavegen.cpp"
          var $78=$q; //@line 1945 "wavegen.cpp"
          var $arrayidx63=(($78+12)&4294967295); //@line 1945 "wavegen.cpp"
          var $79=HEAP32[(($arrayidx63)>>2)]; //@line 1945 "wavegen.cpp"
          var $80=HEAP32[((_out_ptr)>>2)]; //@line 1945 "wavegen.cpp"
          __Z11MarkerEventijiPh($75, $77, $79, $80); //@line 1945 "wavegen.cpp"
          var $81=$q; //@line 1949 "wavegen.cpp"
          var $arrayidx64=(($81+4)&4294967295); //@line 1949 "wavegen.cpp"
          var $82=HEAP32[(($arrayidx64)>>2)]; //@line 1949 "wavegen.cpp"
          var $cmp65=((($82))|0)==1; //@line 1949 "wavegen.cpp"
          if (!($cmp65)) { __label__ = 32;break $sw_epilogthread_pre_split$$sw_bb$$sw_bb19$$sw_bb24$$sw_bb31$$sw_bb44$$sw_bb45$$sw_bb52$$sw_bb53$$sw_bb60$$sw_bb70$$sw_bb73$$sw_bb76$$sw_bb79$$sw_bb81$$sw_bb86$6; } //@line 1949 "wavegen.cpp"
  
          var $83=$q; //@line 1951 "wavegen.cpp"
          var $arrayidx67=(($83+8)&4294967295); //@line 1951 "wavegen.cpp"
          var $84=HEAP32[(($arrayidx67)>>2)]; //@line 1951 "wavegen.cpp"
          var $and68=($84) & 16777215; //@line 1951 "wavegen.cpp"
          HEAP32[((_current_source_index)>>2)]=$and68; //@line 1951 "wavegen.cpp"
          __label__ = 32;break $sw_epilogthread_pre_split$$sw_bb$$sw_bb19$$sw_bb24$$sw_bb31$$sw_bb44$$sw_bb45$$sw_bb52$$sw_bb53$$sw_bb60$$sw_bb70$$sw_bb73$$sw_bb76$$sw_bb79$$sw_bb81$$sw_bb86$6; //@line 1952 "wavegen.cpp"
        }
        else if (__label__ == 25) {
  
          var $85=$length; //@line 1956 "wavegen.cpp"
          var $86=$q; //@line 1956 "wavegen.cpp"
          var $arrayidx71=(($86+8)&4294967295); //@line 1956 "wavegen.cpp"
          var $87=HEAP32[(($arrayidx71)>>2)]; //@line 1956 "wavegen.cpp"
          var $88=($87); //@line 1956 "wavegen.cpp"
          var $89=$q; //@line 1956 "wavegen.cpp"
          var $arrayidx72=(($89+12)&4294967295); //@line 1956 "wavegen.cpp"
          var $90=HEAP32[(($arrayidx72)>>2)]; //@line 1956 "wavegen.cpp"
          __ZL12SetAmplitudeiPhi($85, $88, $90); //@line 1956 "wavegen.cpp"
          __label__ = 32;break $sw_epilogthread_pre_split$$sw_bb$$sw_bb19$$sw_bb24$$sw_bb31$$sw_bb44$$sw_bb45$$sw_bb52$$sw_bb53$$sw_bb60$$sw_bb70$$sw_bb73$$sw_bb76$$sw_bb79$$sw_bb81$$sw_bb86$6; //@line 1957 "wavegen.cpp"
        }
        else if (__label__ == 26) {
  
          var $91=$q; //@line 1960 "wavegen.cpp"
          var $arrayidx74=(($91+4)&4294967295); //@line 1960 "wavegen.cpp"
          var $92=HEAP32[(($arrayidx74)>>2)]; //@line 1960 "wavegen.cpp"
          var $93=($92); //@line 1960 "wavegen.cpp"
          __Z15WavegenSetVoiceP7voice_t($93); //@line 1960 "wavegen.cpp"
          var $94=$q; //@line 1961 "wavegen.cpp"
          var $arrayidx75=(($94+4)&4294967295); //@line 1961 "wavegen.cpp"
          var $95=HEAP32[(($arrayidx75)>>2)]; //@line 1961 "wavegen.cpp"
          var $96=($95); //@line 1961 "wavegen.cpp"
          var $97=$96; //@line 1961 "wavegen.cpp"
          ; //@line 1961 "wavegen.cpp"
          __label__ = 32;break $sw_epilogthread_pre_split$$sw_bb$$sw_bb19$$sw_bb24$$sw_bb31$$sw_bb44$$sw_bb45$$sw_bb52$$sw_bb53$$sw_bb60$$sw_bb70$$sw_bb73$$sw_bb76$$sw_bb79$$sw_bb81$$sw_bb86$6; //@line 1962 "wavegen.cpp"
        }
        else if (__label__ == 27) {
  
          var $98=$q; //@line 1965 "wavegen.cpp"
          var $arrayidx77=(($98+4)&4294967295); //@line 1965 "wavegen.cpp"
          var $99=HEAP32[(($arrayidx77)>>2)]; //@line 1965 "wavegen.cpp"
          var $100=$q; //@line 1965 "wavegen.cpp"
          var $arrayidx78=(($100+8)&4294967295); //@line 1965 "wavegen.cpp"
          var $101=HEAP32[(($arrayidx78)>>2)]; //@line 1965 "wavegen.cpp"
          __Z11SetEmbeddedii($99, $101); //@line 1965 "wavegen.cpp"
          __label__ = 32;break $sw_epilogthread_pre_split$$sw_bb$$sw_bb19$$sw_bb24$$sw_bb31$$sw_bb44$$sw_bb45$$sw_bb52$$sw_bb53$$sw_bb60$$sw_bb70$$sw_bb73$$sw_bb76$$sw_bb79$$sw_bb81$$sw_bb86$6; //@line 1966 "wavegen.cpp"
        }
        else if (__label__ == 28) {
  
          var $102=$length; //@line 1969 "wavegen.cpp"
          var $103=HEAP32[((__ZZ12WavegenFill2iE6resume)>>2)]; //@line 1969 "wavegen.cpp"
          var $call80=__Z10MbrolaFillii($102, $103); //@line 1969 "wavegen.cpp"
          $result=$call80; //@line 1969 "wavegen.cpp"
          __lastLabel__ = 28; __label__ = 33;break $sw_epilogthread_pre_split$$sw_bb$$sw_bb19$$sw_bb24$$sw_bb31$$sw_bb44$$sw_bb45$$sw_bb52$$sw_bb53$$sw_bb60$$sw_bb70$$sw_bb73$$sw_bb76$$sw_bb79$$sw_bb81$$sw_bb86$6; //@line 1970 "wavegen.cpp"
        }
        else if (__label__ == 29) {
  
          var $104=$q; //@line 1973 "wavegen.cpp"
          var $arrayidx82=(($104+4)&4294967295); //@line 1973 "wavegen.cpp"
          var $105=HEAP32[(($arrayidx82)>>2)]; //@line 1973 "wavegen.cpp"
          HEAP32[((((_wdata+60)&4294967295))>>2)]=$105; //@line 1973 "wavegen.cpp"
          var $cmp83=((($105))|0)==0; //@line 1973 "wavegen.cpp"
          if (!($cmp83)) { __label__ = 32;break $sw_epilogthread_pre_split$$sw_bb$$sw_bb19$$sw_bb24$$sw_bb31$$sw_bb44$$sw_bb45$$sw_bb52$$sw_bb53$$sw_bb60$$sw_bb70$$sw_bb73$$sw_bb76$$sw_bb79$$sw_bb81$$sw_bb86$6; } //@line 1973 "wavegen.cpp"
  
          HEAP32[((((_wdata+60)&4294967295))>>2)]=100; //@line 1974 "wavegen.cpp"
          __label__ = 32;break $sw_epilogthread_pre_split$$sw_bb$$sw_bb19$$sw_bb24$$sw_bb31$$sw_bb44$$sw_bb45$$sw_bb52$$sw_bb53$$sw_bb60$$sw_bb70$$sw_bb73$$sw_bb76$$sw_bb79$$sw_bb81$$sw_bb86$6; //@line 1974 "wavegen.cpp"
        }
        else if (__label__ == 31) {
  
          var $106=$q; //@line 1978 "wavegen.cpp"
          var $arrayidx87=(($106+4)&4294967295); //@line 1978 "wavegen.cpp"
          var $107=HEAP32[(($arrayidx87)>>2)]; //@line 1978 "wavegen.cpp"
          var $conv=((($107))|0); //@line 1978 "wavegen.cpp"
          var $div=($conv)/1024; //@line 1978 "wavegen.cpp"
          HEAPF32[((_sonicSpeed)>>2)]=$div; //@line 1978 "wavegen.cpp"
          __label__ = 32;break $sw_epilogthread_pre_split$$sw_bb$$sw_bb19$$sw_bb24$$sw_bb31$$sw_bb44$$sw_bb45$$sw_bb52$$sw_bb53$$sw_bb60$$sw_bb70$$sw_bb73$$sw_bb76$$sw_bb79$$sw_bb81$$sw_bb86$6; //@line 1979 "wavegen.cpp"
        }
      } while(0);
      if (__label__ == 32) {
  
        var $_pr=$result; //@line 1982 "wavegen.cpp"
        __lastLabel__ = 32; ;
      }
      else if (__label__ == 20) {
  
        var $52=HEAP32[((__ZL11echo_length)>>2)]; //@line 1931 "wavegen.cpp"
        HEAP32[((__ZZ12WavegenFill2iE13echo_complete)>>2)]=$52; //@line 1931 "wavegen.cpp"
        var $53=$length; //@line 1932 "wavegen.cpp"
        var $and46=($53) & 65535; //@line 1932 "wavegen.cpp"
        var $54=$q; //@line 1932 "wavegen.cpp"
        var $arrayidx47=(($54+4)&4294967295); //@line 1932 "wavegen.cpp"
        var $55=HEAP32[(($arrayidx47)>>2)]; //@line 1932 "wavegen.cpp"
        var $shr48=($55) >> 16; //@line 1932 "wavegen.cpp"
        var $56=HEAP32[((__ZZ12WavegenFill2iE6resume)>>2)]; //@line 1932 "wavegen.cpp"
        var $57=$q; //@line 1932 "wavegen.cpp"
        var $arrayidx49=(($57+8)&4294967295); //@line 1932 "wavegen.cpp"
        var $58=HEAP32[(($arrayidx49)>>2)]; //@line 1932 "wavegen.cpp"
        var $59=($58); //@line 1932 "wavegen.cpp"
        var $60=$q; //@line 1932 "wavegen.cpp"
        var $arrayidx50=(($60+12)&4294967295); //@line 1932 "wavegen.cpp"
        var $61=HEAP32[(($arrayidx50)>>2)]; //@line 1932 "wavegen.cpp"
        var $62=($61); //@line 1932 "wavegen.cpp"
        var $call51=__ZL8Wavegen2iiiP7frame_tS0_($and46, $shr48, $56, $59, $62); //@line 1932 "wavegen.cpp"
        $result=$call51; //@line 1932 "wavegen.cpp"
        __lastLabel__ = 20; ; //@line 1933 "wavegen.cpp"
      }
      else if (__label__ == 22) {
  
        var $63=HEAP32[((__ZL11echo_length)>>2)]; //@line 1939 "wavegen.cpp"
        HEAP32[((__ZZ12WavegenFill2iE13echo_complete)>>2)]=$63; //@line 1939 "wavegen.cpp"
        var $64=$length; //@line 1940 "wavegen.cpp"
        var $and54=($64) & 65535; //@line 1940 "wavegen.cpp"
        var $65=$q; //@line 1940 "wavegen.cpp"
        var $arrayidx55=(($65+4)&4294967295); //@line 1940 "wavegen.cpp"
        var $66=HEAP32[(($arrayidx55)>>2)]; //@line 1940 "wavegen.cpp"
        var $shr56=($66) >> 16; //@line 1940 "wavegen.cpp"
        var $67=HEAP32[((__ZZ12WavegenFill2iE6resume)>>2)]; //@line 1940 "wavegen.cpp"
        var $68=$q; //@line 1940 "wavegen.cpp"
        var $arrayidx57=(($68+8)&4294967295); //@line 1940 "wavegen.cpp"
        var $69=HEAP32[(($arrayidx57)>>2)]; //@line 1940 "wavegen.cpp"
        var $70=($69); //@line 1940 "wavegen.cpp"
        var $71=$q; //@line 1940 "wavegen.cpp"
        var $arrayidx58=(($71+12)&4294967295); //@line 1940 "wavegen.cpp"
        var $72=HEAP32[(($arrayidx58)>>2)]; //@line 1940 "wavegen.cpp"
        var $73=($72); //@line 1940 "wavegen.cpp"
        var $call59=__Z14Wavegen_Klatt2iiiP7frame_tS0_($and54, $shr56, $67, $70, $73); //@line 1940 "wavegen.cpp"
        $result=$call59; //@line 1940 "wavegen.cpp"
        __lastLabel__ = 22; ; //@line 1941 "wavegen.cpp"
      }
  
      var $108=__lastLabel__ == 32 ? $_pr : (__lastLabel__ == 28 ? $call80 : (__lastLabel__ == 22 ? $call59 : (__lastLabel__ == 20 ? $call51 : (__lastLabel__ == 15 ? $call30 : ($call23))))); //@line 1982 "wavegen.cpp"
      var $cmp88=((($108))|0)==0; //@line 1982 "wavegen.cpp"
      if ($cmp88) { __label__ = 34;; } else { __label__ = 35;; } //@line 1982 "wavegen.cpp"
      if (__label__ == 34) {
  
        __ZL12WcmdqIncHeadv(); //@line 1984 "wavegen.cpp"
        HEAP32[((__ZZ12WavegenFill2iE6resume)>>2)]=0; //@line 1985 "wavegen.cpp"
        __label__ = 1;continue $while_cond$2; //@line 1986 "wavegen.cpp"
      }
      else if (__label__ == 35) {
  
        HEAP32[((__ZZ12WavegenFill2iE6resume)>>2)]=1; //@line 1989 "wavegen.cpp"
        __label__ = 1;continue $while_cond$2;
      }
    }
    $while_end91$$if_then$36: do { 
      if (__label__ == 36) {
  
        $retval=0; //@line 1993 "wavegen.cpp"
        ; //@line 1993 "wavegen.cpp"
      }
      else if (__label__ == 3) {
  
        var $2=HEAP32[((__ZZ12WavegenFill2iE13echo_complete)>>2)]; //@line 1868 "wavegen.cpp"
        var $cmp2=((($2))|0) > 0; //@line 1868 "wavegen.cpp"
        if ($cmp2) { __label__ = 4;; } else { __label__ = 6;; } //@line 1868 "wavegen.cpp"
        $if_then3$$if_end7$39: do { 
          if (__label__ == 4) {
  
            var $3=HEAP32[((__ZZ12WavegenFill2iE13echo_complete)>>2)]; //@line 1871 "wavegen.cpp"
            var $4=HEAP32[((__ZZ12WavegenFill2iE6resume)>>2)]; //@line 1871 "wavegen.cpp"
            var $call4=__ZL11PlaySilenceii($3, $4); //@line 1871 "wavegen.cpp"
            HEAP32[((__ZZ12WavegenFill2iE6resume)>>2)]=$call4; //@line 1871 "wavegen.cpp"
            var $5=HEAP32[((__ZZ12WavegenFill2iE6resume)>>2)]; //@line 1872 "wavegen.cpp"
            var $cmp5=((($5))|0)==1; //@line 1872 "wavegen.cpp"
            if (!($cmp5)) { __label__ = 6;break $if_then3$$if_end7$39; } //@line 1872 "wavegen.cpp"
  
            $retval=0; //@line 1873 "wavegen.cpp"
            __label__ = 37;break $while_end91$$if_then$36; //@line 1873 "wavegen.cpp"
          }
        } while(0);
  
        var $6=$fill_zeros_addr; //@line 1876 "wavegen.cpp"
        var $tobool=((($6))|0)!=0; //@line 1876 "wavegen.cpp"
        if ($tobool) { __label__ = 7;; } else { __label__ = 9;; } //@line 1876 "wavegen.cpp"
        $while_cond9_preheader$$if_end12$43: do { 
          if (__label__ == 7) {
  
            var $7=HEAPU32[((_out_ptr)>>2)]; //@line 1878 "wavegen.cpp"
            var $8=HEAPU32[((_out_end)>>2)]; //@line 1878 "wavegen.cpp"
            var $cmp101=((($7))>>>0) < ((($8))>>>0); //@line 1878 "wavegen.cpp"
            if (!($cmp101)) { __label__ = 9;break $while_cond9_preheader$$if_end12$43; } //@line 1878 "wavegen.cpp"
            while(1) { 
  
              var $9=HEAP32[((_out_ptr)>>2)]; //@line 1879 "wavegen.cpp"
              var $incdec_ptr=(($9+1)&4294967295); //@line 1879 "wavegen.cpp"
              HEAP32[((_out_ptr)>>2)]=$incdec_ptr; //@line 1879 "wavegen.cpp"
              HEAP8[($9)]=0; //@line 1879 "wavegen.cpp"
              var $10=HEAPU32[((_out_ptr)>>2)]; //@line 1878 "wavegen.cpp"
              var $11=HEAPU32[((_out_end)>>2)]; //@line 1878 "wavegen.cpp"
              var $cmp10=((($10))>>>0) < ((($11))>>>0); //@line 1878 "wavegen.cpp"
              if ($cmp10) { __label__ = 8;continue ; } else { __label__ = 9;break $while_cond9_preheader$$if_end12$43; } //@line 1878 "wavegen.cpp"
            }
          }
        } while(0);
  
        $retval=1; //@line 1881 "wavegen.cpp"
        ; //@line 1881 "wavegen.cpp"
      }
    } while(0);
  
    var $109=$retval; //@line 1994 "wavegen.cpp"
    ;
    return $109; //@line 1994 "wavegen.cpp"
    return null;
  }
  

  function __ZL11PlaySilenceii($length, $resume) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $length_addr;
    var $resume_addr;
    var $value;
    $length_addr=$length;
    $resume_addr=$resume;
    $value=0; //@line 1439 "wavegen.cpp"
    HEAP32[((__ZL8nsamples)>>2)]=0; //@line 1441 "wavegen.cpp"
    HEAP32[((__ZL11samplecount)>>2)]=0; //@line 1442 "wavegen.cpp"
    HEAP32[((__ZL9wavephase)>>2)]=2147483647; //@line 1443 "wavegen.cpp"
    var $0=$length_addr; //@line 1445 "wavegen.cpp"
    var $cmp=((($0))|0)==0; //@line 1445 "wavegen.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 1445 "wavegen.cpp"
    if (__label__ == 1) {
  
      $retval=0; //@line 1446 "wavegen.cpp"
      ; //@line 1446 "wavegen.cpp"
    }
    else if (__label__ == 2) {
  
      var $1=$resume_addr; //@line 1448 "wavegen.cpp"
      var $cmp1=((($1))|0)==0; //@line 1448 "wavegen.cpp"
      if ($cmp1) { __label__ = 3;; } else { __label__ = 4;; } //@line 1448 "wavegen.cpp"
      $if_then2$$while_condthread_pre_split$5: do { 
        if (__label__ == 3) {
  
          var $2=$length_addr; //@line 1449 "wavegen.cpp"
          HEAP32[((__ZZL11PlaySilenceiiE9n_samples)>>2)]=$2; //@line 1449 "wavegen.cpp"
          __lastLabel__ = 3; __label__ = 5;break $if_then2$$while_condthread_pre_split$5; //@line 1449 "wavegen.cpp"
        }
      } while(0);
      while(1) { 
        if (__label__ == 5) {
  
          var $3=__lastLabel__ == 4 ? $_pr : ($2); //@line 1451 "wavegen.cpp"
          var $dec=((($3)-1)&4294967295); //@line 1451 "wavegen.cpp"
          HEAP32[((__ZZL11PlaySilenceiiE9n_samples)>>2)]=$dec; //@line 1451 "wavegen.cpp"
          var $cmp4=((($3))|0) > 0; //@line 1451 "wavegen.cpp"
          if (!($cmp4)) { __label__ = 12;break ; } //@line 1451 "wavegen.cpp"
  
          var $4=HEAP32[((_echo_tail)>>2)]; //@line 1453 "wavegen.cpp"
          var $inc=((($4)+1)&4294967295); //@line 1453 "wavegen.cpp"
          HEAP32[((_echo_tail)>>2)]=$inc; //@line 1453 "wavegen.cpp"
          var $arrayidx=((_echo_buf+$4*2)&4294967295); //@line 1453 "wavegen.cpp"
          var $5=HEAP16[(($arrayidx)>>1)]; //@line 1453 "wavegen.cpp"
          var $conv=(tempInt=(($5)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1453 "wavegen.cpp"
          var $6=HEAP32[((_echo_amp)>>2)]; //@line 1453 "wavegen.cpp"
          var $mul=((($conv)*($6))&4294967295); //@line 1453 "wavegen.cpp"
          var $shr=($mul) >> 8; //@line 1453 "wavegen.cpp"
          $value=$shr; //@line 1453 "wavegen.cpp"
          var $7=HEAP32[((_echo_tail)>>2)]; //@line 1455 "wavegen.cpp"
          var $cmp5=((($7))|0) >= 5500; //@line 1455 "wavegen.cpp"
          if ($cmp5) { __label__ = 7;; } else { __label__ = 8;; } //@line 1455 "wavegen.cpp"
          if (__label__ == 7) {
  
            HEAP32[((_echo_tail)>>2)]=0; //@line 1456 "wavegen.cpp"
            ; //@line 1456 "wavegen.cpp"
          }
  
          var $8=$value; //@line 1458 "wavegen.cpp"
          var $conv8=((($8)) & 255); //@line 1458 "wavegen.cpp"
          var $9=HEAP32[((_out_ptr)>>2)]; //@line 1458 "wavegen.cpp"
          var $incdec_ptr=(($9+1)&4294967295); //@line 1458 "wavegen.cpp"
          HEAP32[((_out_ptr)>>2)]=$incdec_ptr; //@line 1458 "wavegen.cpp"
          HEAP8[($9)]=$conv8; //@line 1458 "wavegen.cpp"
          var $10=$value; //@line 1459 "wavegen.cpp"
          var $shr9=($10) >> 8; //@line 1459 "wavegen.cpp"
          var $conv10=((($shr9)) & 255); //@line 1459 "wavegen.cpp"
          var $11=HEAP32[((_out_ptr)>>2)]; //@line 1459 "wavegen.cpp"
          var $incdec_ptr11=(($11+1)&4294967295); //@line 1459 "wavegen.cpp"
          HEAP32[((_out_ptr)>>2)]=$incdec_ptr11; //@line 1459 "wavegen.cpp"
          HEAP8[($11)]=$conv10; //@line 1459 "wavegen.cpp"
          var $12=$value; //@line 1461 "wavegen.cpp"
          var $conv12=((($12)) & 65535); //@line 1461 "wavegen.cpp"
          var $13=HEAP32[((_echo_head)>>2)]; //@line 1461 "wavegen.cpp"
          var $inc13=((($13)+1)&4294967295); //@line 1461 "wavegen.cpp"
          HEAP32[((_echo_head)>>2)]=$inc13; //@line 1461 "wavegen.cpp"
          var $arrayidx14=((_echo_buf+$13*2)&4294967295); //@line 1461 "wavegen.cpp"
          HEAP16[(($arrayidx14)>>1)]=$conv12; //@line 1461 "wavegen.cpp"
          var $14=HEAP32[((_echo_head)>>2)]; //@line 1462 "wavegen.cpp"
          var $cmp15=((($14))|0) >= 5500; //@line 1462 "wavegen.cpp"
          if ($cmp15) { __label__ = 9;; } else { __label__ = 10;; } //@line 1462 "wavegen.cpp"
          if (__label__ == 9) {
  
            HEAP32[((_echo_head)>>2)]=0; //@line 1463 "wavegen.cpp"
            ; //@line 1463 "wavegen.cpp"
          }
  
          var $15=HEAPU32[((_out_ptr)>>2)]; //@line 1465 "wavegen.cpp"
          var $16=HEAPU32[((_out_end)>>2)]; //@line 1465 "wavegen.cpp"
          var $cmp18=((($15))>>>0) >= ((($16))>>>0); //@line 1465 "wavegen.cpp"
          if ($cmp18) { __label__ = 11;break ; } else { __label__ = 4;continue ; } //@line 1465 "wavegen.cpp"
        }
        else if (__label__ == 4) {
  
          var $_pr=HEAP32[((__ZZL11PlaySilenceiiE9n_samples)>>2)]; //@line 1451 "wavegen.cpp"
          __lastLabel__ = 4; __label__ = 5;continue ;
        }
      }
      if (__label__ == 12) {
  
        $retval=0; //@line 1468 "wavegen.cpp"
        ; //@line 1468 "wavegen.cpp"
      }
      else if (__label__ == 11) {
  
        $retval=1; //@line 1466 "wavegen.cpp"
        ; //@line 1466 "wavegen.cpp"
      }
    }
  
    var $17=$retval; //@line 1469 "wavegen.cpp"
    ;
    return $17; //@line 1469 "wavegen.cpp"
    return null;
  }
  

  function __ZL8PlayWaveiiPhii($length, $resume, $data, $scale, $amp) {
    ;
    var __label__;
  
    var $retval;
    var $length_addr;
    var $resume_addr;
    var $data_addr;
    var $scale_addr;
    var $amp_addr;
    var $value;
    var $c;
    $length_addr=$length;
    $resume_addr=$resume;
    $data_addr=$data;
    $scale_addr=$scale;
    $amp_addr=$amp;
    var $0=$resume_addr; //@line 1480 "wavegen.cpp"
    var $cmp=((($0))|0)==0; //@line 1480 "wavegen.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 1480 "wavegen.cpp"
    if (__label__ == 1) {
  
      var $1=$length_addr; //@line 1482 "wavegen.cpp"
      HEAP32[((__ZZL8PlayWaveiiPhiiE9n_samples)>>2)]=$1; //@line 1482 "wavegen.cpp"
      HEAP32[((__ZZL8PlayWaveiiPhiiE2ix)>>2)]=0; //@line 1483 "wavegen.cpp"
      ; //@line 1484 "wavegen.cpp"
    }
  
    HEAP32[((__ZL8nsamples)>>2)]=0; //@line 1486 "wavegen.cpp"
    HEAP32[((__ZL11samplecount)>>2)]=0; //@line 1487 "wavegen.cpp"
    ; //@line 1489 "wavegen.cpp"
    $while_cond$5: while(1) { 
  
      var $2=HEAP32[((__ZZL8PlayWaveiiPhiiE9n_samples)>>2)]; //@line 1489 "wavegen.cpp"
      var $dec=((($2)-1)&4294967295); //@line 1489 "wavegen.cpp"
      HEAP32[((__ZZL8PlayWaveiiPhiiE9n_samples)>>2)]=$dec; //@line 1489 "wavegen.cpp"
      var $cmp1=((($2))|0) > 0; //@line 1489 "wavegen.cpp"
      if (!($cmp1)) { __label__ = 17;break $while_cond$5; } //@line 1489 "wavegen.cpp"
  
      var $3=$scale_addr; //@line 1491 "wavegen.cpp"
      var $cmp2=((($3))|0)==0; //@line 1491 "wavegen.cpp"
      var $4=HEAPU32[((__ZZL8PlayWaveiiPhiiE2ix)>>2)]; //@line 1494 "wavegen.cpp"
      var $add=((($4)+1)&4294967295); //@line 1494 "wavegen.cpp"
      if ($cmp2) { __label__ = 5;; } else { __label__ = 6;; } //@line 1491 "wavegen.cpp"
      if (__label__ == 5) {
  
        var $5=$data_addr; //@line 1494 "wavegen.cpp"
        var $arrayidx=(($5+$add)&4294967295); //@line 1494 "wavegen.cpp"
        var $6=HEAP8[($arrayidx)]; //@line 1494 "wavegen.cpp"
        $c=$6; //@line 1494 "wavegen.cpp"
        var $7=HEAP32[((__ZZL8PlayWaveiiPhiiE2ix)>>2)]; //@line 1495 "wavegen.cpp"
        var $8=$data_addr; //@line 1495 "wavegen.cpp"
        var $arrayidx4=(($8+$7)&4294967295); //@line 1495 "wavegen.cpp"
        var $9=HEAPU8[($arrayidx4)]; //@line 1495 "wavegen.cpp"
        var $conv=((($9))&255); //@line 1495 "wavegen.cpp"
        var $10=$c; //@line 1495 "wavegen.cpp"
        var $conv5=(tempInt=(($10)),(tempInt>=128?tempInt-256:tempInt)); //@line 1495 "wavegen.cpp"
        var $mul=((($conv5)*256)&4294967295); //@line 1495 "wavegen.cpp"
        var $add6=((($mul)+($conv))&4294967295); //@line 1495 "wavegen.cpp"
        $value=$add6; //@line 1495 "wavegen.cpp"
        var $11=HEAP32[((__ZZL8PlayWaveiiPhiiE2ix)>>2)]; //@line 1496 "wavegen.cpp"
        var $add7=((($11)+2)&4294967295); //@line 1496 "wavegen.cpp"
        HEAP32[((__ZZL8PlayWaveiiPhiiE2ix)>>2)]=$add7; //@line 1496 "wavegen.cpp"
        ; //@line 1497 "wavegen.cpp"
      }
      else if (__label__ == 6) {
  
        HEAP32[((__ZZL8PlayWaveiiPhiiE2ix)>>2)]=$add; //@line 1501 "wavegen.cpp"
        var $12=$data_addr; //@line 1501 "wavegen.cpp"
        var $arrayidx8=(($12+$4)&4294967295); //@line 1501 "wavegen.cpp"
        var $13=HEAP8[($arrayidx8)]; //@line 1501 "wavegen.cpp"
        var $conv9=(tempInt=(($13)),(tempInt>=128?tempInt-256:tempInt)); //@line 1501 "wavegen.cpp"
        var $14=$scale_addr; //@line 1501 "wavegen.cpp"
        var $mul10=((($conv9)*($14))&4294967295); //@line 1501 "wavegen.cpp"
        $value=$mul10; //@line 1501 "wavegen.cpp"
        ;
      }
  
      var $15=HEAP32[((__ZL13consonant_amp)>>2)]; //@line 1503 "wavegen.cpp"
      var $16=HEAP32[((__ZL17general_amplitude)>>2)]; //@line 1503 "wavegen.cpp"
      var $17=$value; //@line 1503 "wavegen.cpp"
      var $mul12=((($16)*($15))&4294967295); //@line 1503 "wavegen.cpp"
      var $mul13=((($mul12)*($17))&4294967295); //@line 1503 "wavegen.cpp"
      $value=$mul13; //@line 1503 "wavegen.cpp"
      var $18=$value; //@line 1504 "wavegen.cpp"
      var $shr=($18) >> 10; //@line 1504 "wavegen.cpp"
      $value=$shr; //@line 1504 "wavegen.cpp"
      var $19=$value; //@line 1505 "wavegen.cpp"
      var $20=$amp_addr; //@line 1505 "wavegen.cpp"
      var $mul14=((($20)*($19))&4294967295); //@line 1505 "wavegen.cpp"
      var $div=((((($mul14))|0)/32)|0); //@line 1505 "wavegen.cpp"
      $value=$div; //@line 1505 "wavegen.cpp"
      var $21=HEAP32[((_echo_tail)>>2)]; //@line 1507 "wavegen.cpp"
      var $inc15=((($21)+1)&4294967295); //@line 1507 "wavegen.cpp"
      HEAP32[((_echo_tail)>>2)]=$inc15; //@line 1507 "wavegen.cpp"
      var $arrayidx16=((_echo_buf+$21*2)&4294967295); //@line 1507 "wavegen.cpp"
      var $22=HEAP16[(($arrayidx16)>>1)]; //@line 1507 "wavegen.cpp"
      var $conv17=(tempInt=(($22)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1507 "wavegen.cpp"
      var $23=HEAP32[((_echo_amp)>>2)]; //@line 1507 "wavegen.cpp"
      var $mul18=((($conv17)*($23))&4294967295); //@line 1507 "wavegen.cpp"
      var $shr19=($mul18) >> 8; //@line 1507 "wavegen.cpp"
      var $24=$value; //@line 1507 "wavegen.cpp"
      var $add20=((($shr19)+($24))&4294967295); //@line 1507 "wavegen.cpp"
      $value=$add20; //@line 1507 "wavegen.cpp"
      var $cmp21=((($add20))|0) > 32767; //@line 1509 "wavegen.cpp"
      if ($cmp21) { __label__ = 8;; } else { __label__ = 9;; } //@line 1509 "wavegen.cpp"
      $if_then22$$if_else23$12: do { 
        if (__label__ == 8) {
  
          $value=32768; //@line 1510 "wavegen.cpp"
          ; //@line 1510 "wavegen.cpp"
        }
        else if (__label__ == 9) {
  
          var $25=$value; //@line 1512 "wavegen.cpp"
          var $cmp24=((($25))|0) < -32768; //@line 1512 "wavegen.cpp"
          if (!($cmp24)) { __label__ = 11;break $if_then22$$if_else23$12; } //@line 1512 "wavegen.cpp"
  
          $value=-32768; //@line 1513 "wavegen.cpp"
          ; //@line 1513 "wavegen.cpp"
        }
      } while(0);
  
      var $26=HEAP32[((_echo_tail)>>2)]; //@line 1515 "wavegen.cpp"
      var $cmp28=((($26))|0) >= 5500; //@line 1515 "wavegen.cpp"
      if ($cmp28) { __label__ = 12;; } else { __label__ = 13;; } //@line 1515 "wavegen.cpp"
      if (__label__ == 12) {
  
        HEAP32[((_echo_tail)>>2)]=0; //@line 1516 "wavegen.cpp"
        ; //@line 1516 "wavegen.cpp"
      }
  
      var $27=$value; //@line 1518 "wavegen.cpp"
      var $conv31=((($27)) & 255); //@line 1518 "wavegen.cpp"
      var $28=HEAP32[((_out_ptr)>>2)]; //@line 1518 "wavegen.cpp"
      var $arrayidx32=(($28)&4294967295); //@line 1518 "wavegen.cpp"
      HEAP8[($arrayidx32)]=$conv31; //@line 1518 "wavegen.cpp"
      var $29=$value; //@line 1519 "wavegen.cpp"
      var $shr33=($29) >> 8; //@line 1519 "wavegen.cpp"
      var $conv34=((($shr33)) & 255); //@line 1519 "wavegen.cpp"
      var $30=HEAP32[((_out_ptr)>>2)]; //@line 1519 "wavegen.cpp"
      var $arrayidx35=(($30+1)&4294967295); //@line 1519 "wavegen.cpp"
      HEAP8[($arrayidx35)]=$conv34; //@line 1519 "wavegen.cpp"
      var $31=HEAP32[((_out_ptr)>>2)]; //@line 1520 "wavegen.cpp"
      var $add_ptr=(($31+2)&4294967295); //@line 1520 "wavegen.cpp"
      HEAP32[((_out_ptr)>>2)]=$add_ptr; //@line 1520 "wavegen.cpp"
      var $32=$value; //@line 1522 "wavegen.cpp"
      var $mul36=((($32)*3)&4294967295); //@line 1522 "wavegen.cpp"
      var $div37=((((($mul36))|0)/4)|0); //@line 1522 "wavegen.cpp"
      var $conv38=((($div37)) & 65535); //@line 1522 "wavegen.cpp"
      var $33=HEAP32[((_echo_head)>>2)]; //@line 1522 "wavegen.cpp"
      var $inc39=((($33)+1)&4294967295); //@line 1522 "wavegen.cpp"
      HEAP32[((_echo_head)>>2)]=$inc39; //@line 1522 "wavegen.cpp"
      var $arrayidx40=((_echo_buf+$33*2)&4294967295); //@line 1522 "wavegen.cpp"
      HEAP16[(($arrayidx40)>>1)]=$conv38; //@line 1522 "wavegen.cpp"
      var $34=HEAP32[((_echo_head)>>2)]; //@line 1523 "wavegen.cpp"
      var $cmp41=((($34))|0) >= 5500; //@line 1523 "wavegen.cpp"
      if ($cmp41) { __label__ = 14;; } else { __label__ = 15;; } //@line 1523 "wavegen.cpp"
      if (__label__ == 14) {
  
        HEAP32[((_echo_head)>>2)]=0; //@line 1524 "wavegen.cpp"
        ; //@line 1524 "wavegen.cpp"
      }
  
      var $35=HEAPU32[((_out_ptr)>>2)]; //@line 1526 "wavegen.cpp"
      var $36=HEAPU32[((_out_end)>>2)]; //@line 1526 "wavegen.cpp"
      var $cmp44=((($35))>>>0) >= ((($36))>>>0); //@line 1526 "wavegen.cpp"
      if ($cmp44) { __label__ = 16;break $while_cond$5; } else { __label__ = 3;continue $while_cond$5; } //@line 1526 "wavegen.cpp"
    }
    if (__label__ == 17) {
  
      $retval=0; //@line 1529 "wavegen.cpp"
      ; //@line 1529 "wavegen.cpp"
    }
    else if (__label__ == 16) {
  
      $retval=1; //@line 1527 "wavegen.cpp"
      ; //@line 1527 "wavegen.cpp"
    }
  
    var $37=$retval; //@line 1530 "wavegen.cpp"
    ;
    return $37; //@line 1530 "wavegen.cpp"
    return null;
  }
  

  function __ZL8Wavegen2iiiP7frame_tS0_($length, $modulation, $resume, $fr1, $fr2) {
    ;
    var __label__;
  
    var $length_addr;
    var $modulation_addr;
    var $resume_addr;
    var $fr1_addr;
    var $fr2_addr;
    $length_addr=$length;
    $modulation_addr=$modulation;
    $resume_addr=$resume;
    $fr1_addr=$fr1;
    $fr2_addr=$fr2;
    var $0=$resume_addr; //@line 1832 "wavegen.cpp"
    var $cmp=((($0))|0)==0; //@line 1832 "wavegen.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 1832 "wavegen.cpp"
    if (__label__ == 1) {
  
      var $1=$length_addr; //@line 1833 "wavegen.cpp"
      var $2=$modulation_addr; //@line 1833 "wavegen.cpp"
      var $3=$fr1_addr; //@line 1833 "wavegen.cpp"
      var $4=$fr2_addr; //@line 1833 "wavegen.cpp"
      var $5=HEAP32[((_wvoice)>>2)]; //@line 1833 "wavegen.cpp"
      __Z8SetSynthiiP7frame_tS0_P7voice_t($1, $2, $3, $4, $5); //@line 1833 "wavegen.cpp"
      ; //@line 1833 "wavegen.cpp"
    }
  
    var $call=__Z7Wavegenv(); //@line 1835 "wavegen.cpp"
    ;
    return $call; //@line 1835 "wavegen.cpp"
    return null;
  }
  

  function __ZL12SetAmplitudeiPhi($length, $amp_env, $value) {
    ;
    var __label__;
  
    var $length_addr;
    var $amp_env_addr;
    var $value_addr;
    $length_addr=$length;
    $amp_env_addr=$amp_env;
    $value_addr=$value;
    HEAP32[((__ZL6amp_ix)>>2)]=0; //@line 1636 "wavegen.cpp"
    var $0=$length_addr; //@line 1637 "wavegen.cpp"
    var $cmp=((($0))|0)==0; //@line 1637 "wavegen.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 1637 "wavegen.cpp"
    if (__label__ == 1) {
  
      HEAP32[((__ZL7amp_inc)>>2)]=0; //@line 1638 "wavegen.cpp"
      ; //@line 1638 "wavegen.cpp"
    }
    else if (__label__ == 2) {
  
      var $1=$length_addr; //@line 1640 "wavegen.cpp"
      var $div=((2097152/((($1))|0))|0); //@line 1640 "wavegen.cpp"
      HEAP32[((__ZL7amp_inc)>>2)]=$div; //@line 1640 "wavegen.cpp"
      ;
    }
  
    var $2=$value_addr; //@line 1642 "wavegen.cpp"
    var $3=HEAP32[((__ZL17general_amplitude)>>2)]; //@line 1642 "wavegen.cpp"
    var $mul=((($3)*($2))&4294967295); //@line 1642 "wavegen.cpp"
    var $div1=((((($mul))|0)/16)|0); //@line 1642 "wavegen.cpp"
    HEAP32[((((_wdata+52)&4294967295))>>2)]=$div1; //@line 1642 "wavegen.cpp"
    var $4=HEAP32[((((_wdata+52)&4294967295))>>2)]; //@line 1643 "wavegen.cpp"
    var $5=HEAP32[((_wvoice)>>2)]; //@line 1643 "wavegen.cpp"
    var $consonant_ampv=(($5+104)&4294967295); //@line 1643 "wavegen.cpp"
    var $6=HEAP32[(($consonant_ampv)>>2)]; //@line 1643 "wavegen.cpp"
    var $mul2=((($4)*15)&4294967295); //@line 1643 "wavegen.cpp"
    var $mul3=((($mul2)*($6))&4294967295); //@line 1643 "wavegen.cpp"
    var $div4=((((($mul3))|0)/100)|0); //@line 1643 "wavegen.cpp"
    HEAP32[((((_wdata+56)&4294967295))>>2)]=$div4; //@line 1643 "wavegen.cpp"
    var $7=$amp_env_addr; //@line 1645 "wavegen.cpp"
    HEAP32[((__ZL13amplitude_env)>>2)]=$7; //@line 1645 "wavegen.cpp"
    ;
    return; //@line 1646 "wavegen.cpp"
    return;
  }
  

  function __ZL12WcmdqIncHeadv() {
    ;
    var __label__;
  
    var $0=HEAP32[((_wcmdq_head)>>2)]; //@line 324 "wavegen.cpp"
    var $inc=((($0)+1)&4294967295); //@line 324 "wavegen.cpp"
    HEAP32[((_wcmdq_head)>>2)]=$inc; //@line 324 "wavegen.cpp"
    var $cmp=((($inc))|0) >= 160; //@line 325 "wavegen.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 325 "wavegen.cpp"
    if (__label__ == 1) {
  
      HEAP32[((_wcmdq_head)>>2)]=0; //@line 325 "wavegen.cpp"
      ; //@line 325 "wavegen.cpp"
    }
  
    ;
    return; //@line 326 "wavegen.cpp"
    return;
  }
  

  function __Z11WavegenFilli($fill_zeros) {
    ;
    var __label__;
  
    var $fill_zeros_addr;
    var $finished;
    var $p_start;
    var $length;
    var $max_length;
    $fill_zeros_addr=$fill_zeros;
    var $0=HEAP32[((_out_ptr)>>2)]; //@line 2033 "wavegen.cpp"
    $p_start=$0; //@line 2033 "wavegen.cpp"
    var $call=__Z12WavegenFill2i(0); //@line 2036 "wavegen.cpp"
    $finished=$call; //@line 2036 "wavegen.cpp"
    var $1=HEAPF32[((_sonicSpeed)>>2)]; //@line 2038 "wavegen.cpp"
    var $cmp=($1) > 1; //@line 2038 "wavegen.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 3;; } //@line 2038 "wavegen.cpp"
    $if_then$$if_end8$2: do { 
      if (__label__ == 1) {
  
        var $2=HEAP32[((_out_end)>>2)]; //@line 2040 "wavegen.cpp"
        var $3=$p_start; //@line 2040 "wavegen.cpp"
        var $sub_ptr_lhs_cast=($2); //@line 2040 "wavegen.cpp"
        var $sub_ptr_rhs_cast=($3); //@line 2040 "wavegen.cpp"
        var $sub_ptr_sub=((($sub_ptr_lhs_cast)-($sub_ptr_rhs_cast))&4294967295); //@line 2040 "wavegen.cpp"
        $max_length=$sub_ptr_sub; //@line 2040 "wavegen.cpp"
        var $4=$p_start; //@line 2041 "wavegen.cpp"
        var $5=$4; //@line 2041 "wavegen.cpp"
        var $6=HEAP32[((_out_ptr)>>2)]; //@line 2041 "wavegen.cpp"
        var $7=$p_start; //@line 2041 "wavegen.cpp"
        var $sub_ptr_lhs_cast1=($6); //@line 2041 "wavegen.cpp"
        var $sub_ptr_rhs_cast2=($7); //@line 2041 "wavegen.cpp"
        var $sub_ptr_sub3=((($sub_ptr_lhs_cast1)-($sub_ptr_rhs_cast2))&4294967295); //@line 2041 "wavegen.cpp"
        var $div=((((($sub_ptr_sub3))|0)/2)|0); //@line 2041 "wavegen.cpp"
        var $8=$max_length; //@line 2041 "wavegen.cpp"
        var $div4=((((($8))|0)/2)|0); //@line 2041 "wavegen.cpp"
        var $9=$finished; //@line 2041 "wavegen.cpp"
        var $call5=__ZL7SpeedUpPsiii($5, $div, $div4, $9); //@line 2041 "wavegen.cpp"
        var $mul=((($call5)*2)&4294967295); //@line 2041 "wavegen.cpp"
        $length=$mul; //@line 2041 "wavegen.cpp"
        var $10=$p_start; //@line 2042 "wavegen.cpp"
        var $11=$length; //@line 2042 "wavegen.cpp"
        var $add_ptr=(($10+$11)&4294967295); //@line 2042 "wavegen.cpp"
        HEAP32[((_out_ptr)>>2)]=$add_ptr; //@line 2042 "wavegen.cpp"
        var $12=$length; //@line 2044 "wavegen.cpp"
        var $13=$max_length; //@line 2044 "wavegen.cpp"
        var $cmp6=((($12))|0) >= ((($13))|0); //@line 2044 "wavegen.cpp"
        if (!($cmp6)) { __label__ = 3;break $if_then$$if_end8$2; } //@line 2044 "wavegen.cpp"
  
        $finished=0; //@line 2045 "wavegen.cpp"
        ; //@line 2045 "wavegen.cpp"
      }
    } while(0);
  
    var $14=$finished; //@line 2047 "wavegen.cpp"
    ;
    return $14; //@line 2047 "wavegen.cpp"
    return null;
  }
  

  function __ZL7SpeedUpPsiii($outbuf, $length_in, $length_out, $end_of_text) {
    ;
    var __label__;
  
    var $retval;
    var $outbuf_addr;
    var $length_in_addr;
    var $length_out_addr;
    var $end_of_text_addr;
    $outbuf_addr=$outbuf;
    $length_in_addr=$length_in;
    $length_out_addr=$length_out;
    $end_of_text_addr=$end_of_text;
    var $0=$length_in_addr; //@line 2000 "wavegen.cpp"
    var $cmp=((($0))|0) > 0; //@line 2000 "wavegen.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 6;; } //@line 2000 "wavegen.cpp"
    if (__label__ == 1) {
  
      var $1=HEAP32[((__ZL18sonicSpeedupStream)>>2)]; //@line 2002 "wavegen.cpp"
      var $cmp1=((($1))|0)==0; //@line 2002 "wavegen.cpp"
      if ($cmp1) { __label__ = 2;; } else { __label__ = 3;; } //@line 2002 "wavegen.cpp"
      if (__label__ == 2) {
  
        var $call=_sonicCreateStream(22050, 1); //@line 2004 "wavegen.cpp"
        HEAP32[((__ZL18sonicSpeedupStream)>>2)]=$call; //@line 2004 "wavegen.cpp"
        ; //@line 2005 "wavegen.cpp"
      }
  
      var $2=HEAP32[((__ZL18sonicSpeedupStream)>>2)]; //@line 2006 "wavegen.cpp"
      var $call3=_sonicGetSpeed($2); //@line 2006 "wavegen.cpp"
      var $conv=($call3); //@line 2006 "wavegen.cpp"
      var $3=HEAPF32[((_sonicSpeed)>>2)]; //@line 2006 "wavegen.cpp"
      var $cmp4=($conv) != ($3); //@line 2006 "wavegen.cpp"
      if ($cmp4) { __label__ = 4;; } else { __label__ = 5;; } //@line 2006 "wavegen.cpp"
      if (__label__ == 4) {
  
        var $4=HEAP32[((__ZL18sonicSpeedupStream)>>2)]; //@line 2008 "wavegen.cpp"
        var $5=HEAPF32[((_sonicSpeed)>>2)]; //@line 2008 "wavegen.cpp"
        var $conv6=($5); //@line 2008 "wavegen.cpp"
        _sonicSetSpeed($4, $conv6); //@line 2008 "wavegen.cpp"
        ; //@line 2009 "wavegen.cpp"
      }
  
      var $6=HEAP32[((__ZL18sonicSpeedupStream)>>2)]; //@line 2011 "wavegen.cpp"
      var $7=$outbuf_addr; //@line 2011 "wavegen.cpp"
      var $8=$length_in_addr; //@line 2011 "wavegen.cpp"
      var $call8=_sonicWriteShortToStream($6, $7, $8); //@line 2011 "wavegen.cpp"
      ; //@line 2012 "wavegen.cpp"
    }
  
    var $9=HEAP32[((__ZL18sonicSpeedupStream)>>2)]; //@line 2014 "wavegen.cpp"
    var $cmp10=((($9))|0)==0; //@line 2014 "wavegen.cpp"
    if ($cmp10) { __label__ = 7;; } else { __label__ = 8;; } //@line 2014 "wavegen.cpp"
    if (__label__ == 7) {
  
      $retval=0; //@line 2015 "wavegen.cpp"
      ; //@line 2015 "wavegen.cpp"
    }
    else if (__label__ == 8) {
  
      var $10=$end_of_text_addr; //@line 2017 "wavegen.cpp"
      var $tobool=((($10))|0)!=0; //@line 2017 "wavegen.cpp"
      if ($tobool) { __label__ = 9;; } else { __label__ = 10;; } //@line 2017 "wavegen.cpp"
      if (__label__ == 9) {
  
        var $11=HEAP32[((__ZL18sonicSpeedupStream)>>2)]; //@line 2019 "wavegen.cpp"
        var $call14=_sonicFlushStream($11); //@line 2019 "wavegen.cpp"
        ; //@line 2020 "wavegen.cpp"
      }
  
      var $12=HEAP32[((__ZL18sonicSpeedupStream)>>2)]; //@line 2021 "wavegen.cpp"
      var $13=$outbuf_addr; //@line 2021 "wavegen.cpp"
      var $14=$length_out_addr; //@line 2021 "wavegen.cpp"
      var $call16=_sonicReadShortFromStream($12, $13, $14); //@line 2021 "wavegen.cpp"
      $retval=$call16; //@line 2021 "wavegen.cpp"
      ; //@line 2021 "wavegen.cpp"
    }
  
    var $15=$retval; //@line 2022 "wavegen.cpp"
    ;
    return $15; //@line 2022 "wavegen.cpp"
    return null;
  }
  

  function __ZL9resonatorP9RESONATORd($r, $input) {
    ;
    var __label__;
  
    var $r_addr;
    var $input_addr;
    var $x;
    $r_addr=$r;
    $input_addr=$input;
    var $0=$r_addr; //@line 1057 "wavegen.cpp"
    var $a=(($0)&4294967295); //@line 1057 "wavegen.cpp"
    var $1=HEAPF32[(($a)>>2)]; //@line 1057 "wavegen.cpp"
    var $2=$input_addr; //@line 1057 "wavegen.cpp"
    var $mul=($1)*($2); //@line 1057 "wavegen.cpp"
    var $3=$r_addr; //@line 1057 "wavegen.cpp"
    var $b=(($3+8)&4294967295); //@line 1057 "wavegen.cpp"
    var $4=HEAPF32[(($b)>>2)]; //@line 1057 "wavegen.cpp"
    var $5=$r_addr; //@line 1057 "wavegen.cpp"
    var $x1=(($5+24)&4294967295); //@line 1057 "wavegen.cpp"
    var $6=HEAPF32[(($x1)>>2)]; //@line 1057 "wavegen.cpp"
    var $mul1=($4)*($6); //@line 1057 "wavegen.cpp"
    var $add=($mul)+($mul1); //@line 1057 "wavegen.cpp"
    var $7=$r_addr; //@line 1057 "wavegen.cpp"
    var $c=(($7+16)&4294967295); //@line 1057 "wavegen.cpp"
    var $8=HEAPF32[(($c)>>2)]; //@line 1057 "wavegen.cpp"
    var $9=$r_addr; //@line 1057 "wavegen.cpp"
    var $x2=(($9+32)&4294967295); //@line 1057 "wavegen.cpp"
    var $10=HEAPF32[(($x2)>>2)]; //@line 1057 "wavegen.cpp"
    var $mul2=($8)*($10); //@line 1057 "wavegen.cpp"
    var $add3=($add)+($mul2); //@line 1057 "wavegen.cpp"
    $x=$add3; //@line 1057 "wavegen.cpp"
    var $11=$r_addr; //@line 1058 "wavegen.cpp"
    var $x14=(($11+24)&4294967295); //@line 1058 "wavegen.cpp"
    var $12=HEAPF32[(($x14)>>2)]; //@line 1058 "wavegen.cpp"
    var $13=$r_addr; //@line 1058 "wavegen.cpp"
    var $x25=(($13+32)&4294967295); //@line 1058 "wavegen.cpp"
    HEAPF32[(($x25)>>2)]=$12; //@line 1058 "wavegen.cpp"
    var $14=$x; //@line 1059 "wavegen.cpp"
    var $15=$r_addr; //@line 1059 "wavegen.cpp"
    var $x16=(($15+24)&4294967295); //@line 1059 "wavegen.cpp"
    HEAPF32[(($x16)>>2)]=$14; //@line 1059 "wavegen.cpp"
    var $16=$x; //@line 1061 "wavegen.cpp"
    ;
    return $16; //@line 1061 "wavegen.cpp"
    return null;
  }
  

  function __Z15MakePhonemeListP10Translatorii($tr, $post_pause, $start_sentence) {
    var __stackBase__  = STACKTOP; STACKTOP += 24152; _memset(__stackBase__, 0, 24152);
    var __label__;
    var __lastLabel__ = null;
  
    var $tr_addr;
    var $post_pause_addr;
    var $start_sentence_addr;
    var $ix;
    var $j;
    var $insert_ph;
    var $phlist;
    var $ph;
    var $prev;
    var $next;
    var $next2;
    var $unstress_count;
    var $word_stress;
    var $switched_language;
    var $max_stress;
    var $voicing;
    var $regression;
    var $end_sourceix;
    var $alternative;
    var $first_vowel;
    var $phdata=__stackBase__;
    var $n_ph_list3;
    var $plist3;
    var $plist3_inserted;
    var $ph_list3=__stackBase__+152;
    var $plist2;
    var $type;
    var $word_end_devoice;
    var $k;
    var $nextw;
    var $ph2;
    var $ph2266;
    var $p;
    var $x;
    $tr_addr=$tr;
    $post_pause_addr=$post_pause;
    $start_sentence_addr=$start_sentence;
    $ix=0; //@line 112 "phonemelist.cpp"
    $insert_ph=0; //@line 114 "phonemelist.cpp"
    $unstress_count=0; //@line 118 "phonemelist.cpp"
    $word_stress=0; //@line 119 "phonemelist.cpp"
    $switched_language=0; //@line 120 "phonemelist.cpp"
    $first_vowel=0; //@line 126 "phonemelist.cpp"
    $plist3_inserted=0; //@line 131 "phonemelist.cpp"
    $plist2=((_ph_list2)&4294967295); //@line 137 "phonemelist.cpp"
    $phlist=((_phoneme_list)&4294967295); //@line 138 "phonemelist.cpp"
    var $0=HEAP32[((_n_ph_list2)>>2)]; //@line 139 "phonemelist.cpp"
    var $sub=((($0)-1)&4294967295); //@line 139 "phonemelist.cpp"
    var $1=$plist2; //@line 139 "phonemelist.cpp"
    var $arrayidx=(($1+8*$sub)&4294967295); //@line 139 "phonemelist.cpp"
    var $sourceix=(($arrayidx+6)&4294967295); //@line 139 "phonemelist.cpp"
    var $2=HEAPU16[(($sourceix)>>1)]; //@line 139 "phonemelist.cpp"
    var $conv=((($2))&65535); //@line 139 "phonemelist.cpp"
    $end_sourceix=$conv; //@line 139 "phonemelist.cpp"
    $max_stress=0; //@line 142 "phonemelist.cpp"
    var $3=HEAP32[((_n_ph_list2)>>2)]; //@line 143 "phonemelist.cpp"
    var $sub1=((($3)-3)&4294967295); //@line 143 "phonemelist.cpp"
    $j=$sub1; //@line 143 "phonemelist.cpp"
    __lastLabel__ = 0; ; //@line 143 "phonemelist.cpp"
    $for_cond$2: while(1) { 
  
      var $4=__lastLabel__ == 5 ? $dec : ($sub1); //@line 143 "phonemelist.cpp"
      var $cmp=((($4))|0) >= 0; //@line 143 "phonemelist.cpp"
      if (!($cmp)) { __label__ = 6;break $for_cond$2; } //@line 143 "phonemelist.cpp"
  
      var $5=$j; //@line 146 "phonemelist.cpp"
      var $6=$plist2; //@line 146 "phonemelist.cpp"
      var $arrayidx2=(($6+8*$5)&4294967295); //@line 146 "phonemelist.cpp"
      var $stresslevel=(($arrayidx2+1)&4294967295); //@line 146 "phonemelist.cpp"
      var $7=HEAPU8[($stresslevel)]; //@line 146 "phonemelist.cpp"
      var $conv3=((($7))&255); //@line 146 "phonemelist.cpp"
      var $and=($conv3) & 127; //@line 146 "phonemelist.cpp"
      var $8=$max_stress; //@line 146 "phonemelist.cpp"
      var $cmp4=((($and))|0) > ((($8))|0); //@line 146 "phonemelist.cpp"
      if ($cmp4) { __label__ = 3;; } else { __label__ = 4;; } //@line 146 "phonemelist.cpp"
      if (__label__ == 3) {
  
        var $9=$j; //@line 147 "phonemelist.cpp"
        var $10=$plist2; //@line 147 "phonemelist.cpp"
        var $arrayidx5=(($10+8*$9)&4294967295); //@line 147 "phonemelist.cpp"
        var $stresslevel6=(($arrayidx5+1)&4294967295); //@line 147 "phonemelist.cpp"
        var $11=HEAPU8[($stresslevel6)]; //@line 147 "phonemelist.cpp"
        var $conv7=((($11))&255); //@line 147 "phonemelist.cpp"
        var $and8=($conv7) & 127; //@line 147 "phonemelist.cpp"
        $max_stress=$and8; //@line 147 "phonemelist.cpp"
        ; //@line 147 "phonemelist.cpp"
      }
  
      var $12=$j; //@line 148 "phonemelist.cpp"
      var $13=$plist2; //@line 148 "phonemelist.cpp"
      var $arrayidx9=(($13+8*$12)&4294967295); //@line 148 "phonemelist.cpp"
      var $sourceix10=(($arrayidx9+6)&4294967295); //@line 148 "phonemelist.cpp"
      var $14=HEAPU16[(($sourceix10)>>1)]; //@line 148 "phonemelist.cpp"
      var $conv11=((($14))&65535); //@line 148 "phonemelist.cpp"
      var $cmp12=((($conv11))|0)!=0; //@line 148 "phonemelist.cpp"
      if ($cmp12) { __label__ = 6;break $for_cond$2; } //@line 148 "phonemelist.cpp"
  
      var $15=$j; //@line 143 "phonemelist.cpp"
      var $dec=((($15)-1)&4294967295); //@line 143 "phonemelist.cpp"
      $j=$dec; //@line 143 "phonemelist.cpp"
      __lastLabel__ = 5; __label__ = 1;continue $for_cond$2; //@line 143 "phonemelist.cpp"
    }
  
    var $16=$max_stress; //@line 151 "phonemelist.cpp"
    var $cmp15=((($16))|0) < 4; //@line 151 "phonemelist.cpp"
    if ($cmp15) { __label__ = 7;; } else { __label__ = 11;; } //@line 151 "phonemelist.cpp"
    $while_cond$$if_end32$10: do { 
      if (__label__ == 7) {
        while(1) { 
  
          var $17=$j; //@line 154 "phonemelist.cpp"
          var $dec17=((($17)-1)&4294967295); //@line 154 "phonemelist.cpp"
          $j=$dec17; //@line 154 "phonemelist.cpp"
          var $cmp18=((($dec17))|0) >= 0; //@line 154 "phonemelist.cpp"
          if (!($cmp18)) { __label__ = 11;break $while_cond$$if_end32$10; } //@line 154 "phonemelist.cpp"
  
          var $18=$j; //@line 156 "phonemelist.cpp"
          var $19=$plist2; //@line 156 "phonemelist.cpp"
          var $arrayidx19=(($19+8*$18)&4294967295); //@line 156 "phonemelist.cpp"
          var $synthflags=(($arrayidx19+4)&4294967295); //@line 156 "phonemelist.cpp"
          var $20=HEAPU16[(($synthflags)>>1)]; //@line 156 "phonemelist.cpp"
          var $conv20=((($20))&65535); //@line 156 "phonemelist.cpp"
          var $and21=($conv20) & 64; //@line 156 "phonemelist.cpp"
          var $tobool=((($and21))|0)!=0; //@line 156 "phonemelist.cpp"
          var $21=$j; //@line 158 "phonemelist.cpp"
          var $22=$plist2; //@line 158 "phonemelist.cpp"
          var $arrayidx23=(($22+8*$21)&4294967295); //@line 158 "phonemelist.cpp"
          var $stresslevel24=(($arrayidx23+1)&4294967295); //@line 158 "phonemelist.cpp"
          if ($tobool) { __label__ = 9;break ; } //@line 156 "phonemelist.cpp"
  
          var $23=HEAPU8[($stresslevel24)]; //@line 161 "phonemelist.cpp"
          var $conv28=((($23))&255); //@line 161 "phonemelist.cpp"
          var $cmp29=((($conv28))|0) >= 4; //@line 161 "phonemelist.cpp"
          if ($cmp29) { __label__ = 11;break $while_cond$$if_end32$10; } else { __label__ = 7;continue ; } //@line 161 "phonemelist.cpp"
        }
  
        HEAP8[($stresslevel24)]=4; //@line 158 "phonemelist.cpp"
        ; //@line 159 "phonemelist.cpp"
      }
    } while(0);
  
    var $24=$tr_addr; //@line 169 "phonemelist.cpp"
    var $langopts=(($24)&4294967295); //@line 169 "phonemelist.cpp"
    var $param=(($langopts+24)&4294967295); //@line 169 "phonemelist.cpp"
    var $arrayidx33=(($param+16)&4294967295); //@line 169 "phonemelist.cpp"
    var $25=HEAP32[(($arrayidx33)>>2)]; //@line 169 "phonemelist.cpp"
    $regression=$25; //@line 169 "phonemelist.cpp"
    var $cmp34=((($25))|0)!=0; //@line 169 "phonemelist.cpp"
    if ($cmp34) { __label__ = 12;; } else { __label__ = 51;; } //@line 169 "phonemelist.cpp"
    $if_then35$$if_end143$17: do { 
      if (__label__ == 12) {
  
        $word_end_devoice=0; //@line 174 "phonemelist.cpp"
        $voicing=0; //@line 175 "phonemelist.cpp"
        var $26=HEAP32[((_n_ph_list2)>>2)]; //@line 177 "phonemelist.cpp"
        var $sub36=((($26)-1)&4294967295); //@line 177 "phonemelist.cpp"
        $j=$sub36; //@line 177 "phonemelist.cpp"
        var $cmp389=((($sub36))|0) >= 0; //@line 177 "phonemelist.cpp"
        if (!($cmp389)) { __label__ = 51;break $if_then35$$if_end143$17; } //@line 177 "phonemelist.cpp"
        $for_body39$19: while(1) { 
  
          var $27=$j; //@line 179 "phonemelist.cpp"
          var $28=$plist2; //@line 179 "phonemelist.cpp"
          var $arrayidx40=(($28+8*$27)&4294967295); //@line 179 "phonemelist.cpp"
          var $phcode=(($arrayidx40)&4294967295); //@line 179 "phonemelist.cpp"
          var $29=HEAPU8[($phcode)]; //@line 179 "phonemelist.cpp"
          var $idxprom=((($29))&255); //@line 179 "phonemelist.cpp"
          var $arrayidx41=((_phoneme_tab+$idxprom*4)&4294967295); //@line 179 "phonemelist.cpp"
          var $30=HEAPU32[(($arrayidx41)>>2)]; //@line 179 "phonemelist.cpp"
          $ph=$30; //@line 179 "phonemelist.cpp"
          var $cmp42=((($30))|0)==0; //@line 180 "phonemelist.cpp"
          if ($cmp42) { __label__ = 50;; } else { __label__ = 14;; } //@line 180 "phonemelist.cpp"
          $for_inc140$$if_end44$21: do { 
            if (__label__ == 14) {
  
              var $31=$ph; //@line 183 "phonemelist.cpp"
              var $code=(($31+10)&4294967295); //@line 183 "phonemelist.cpp"
              var $32=HEAPU8[($code)]; //@line 183 "phonemelist.cpp"
              var $conv45=((($32))&255); //@line 183 "phonemelist.cpp"
              var $cmp46=((($conv45))|0)==21; //@line 183 "phonemelist.cpp"
              var $33=$switched_language; //@line 184 "phonemelist.cpp"
              if ($cmp46) { __lastLabel__ = 14; __label__ = 15;; } else { __lastLabel__ = 14; __label__ = 16;; } //@line 183 "phonemelist.cpp"
              if (__label__ == 15) {
  
                var $xor=($33) ^ 1; //@line 184 "phonemelist.cpp"
                $switched_language=$xor; //@line 184 "phonemelist.cpp"
                __lastLabel__ = 15; ; //@line 184 "phonemelist.cpp"
              }
  
              var $34=__lastLabel__ == 15 ? $xor : ($33); //@line 185 "phonemelist.cpp"
              var $tobool49=((($34))|0)!=0; //@line 185 "phonemelist.cpp"
              if ($tobool49) { __label__ = 50;break $for_inc140$$if_end44$21; } //@line 185 "phonemelist.cpp"
  
              var $35=$ph; //@line 188 "phonemelist.cpp"
              var $type52=(($35+11)&4294967295); //@line 188 "phonemelist.cpp"
              var $36=HEAPU8[($type52)]; //@line 188 "phonemelist.cpp"
              var $conv53=((($36))&255); //@line 188 "phonemelist.cpp"
              $type=$conv53; //@line 188 "phonemelist.cpp"
              var $37=$regression; //@line 190 "phonemelist.cpp"
              var $and54=($37) & 2; //@line 190 "phonemelist.cpp"
              var $tobool55=((($and54))|0)!=0; //@line 190 "phonemelist.cpp"
              if ($tobool55) { __label__ = 18;; } else { __label__ = 24;; } //@line 190 "phonemelist.cpp"
              $if_then56$$if_end69$27: do { 
                if (__label__ == 18) {
  
                  var $38=$ph; //@line 193 "phonemelist.cpp"
                  var $mnemonic=(($38)&4294967295); //@line 193 "phonemelist.cpp"
                  var $39=HEAP32[(($mnemonic)>>2)]; //@line 193 "phonemelist.cpp"
                  var $cmp57=((($39))|0)==118; //@line 193 "phonemelist.cpp"
                  if ($cmp57) { __label__ = 21;; } else { __label__ = 19;; } //@line 193 "phonemelist.cpp"
                  $if_then64$$lor_lhs_false$29: do { 
                    if (__label__ == 19) {
  
                      var $40=$ph; //@line 193 "phonemelist.cpp"
                      var $mnemonic58=(($40)&4294967295); //@line 193 "phonemelist.cpp"
                      var $41=HEAP32[(($mnemonic58)>>2)]; //@line 193 "phonemelist.cpp"
                      var $cmp59=((($41))|0)==15222; //@line 193 "phonemelist.cpp"
                      if ($cmp59) { __label__ = 21;break $if_then64$$lor_lhs_false$29; } //@line 193 "phonemelist.cpp"
  
                      var $42=$ph; //@line 193 "phonemelist.cpp"
                      var $mnemonic61=(($42)&4294967295); //@line 193 "phonemelist.cpp"
                      var $43=HEAP32[(($mnemonic61)>>2)]; //@line 193 "phonemelist.cpp"
                      var $and62=($43) & 255; //@line 193 "phonemelist.cpp"
                      var $cmp63=((($and62))|0)==82; //@line 193 "phonemelist.cpp"
                      if (!($cmp63)) { __label__ = 24;break $if_then56$$if_end69$27; } //@line 193 "phonemelist.cpp"
                    }
                  } while(0);
  
                  var $44=$word_end_devoice; //@line 195 "phonemelist.cpp"
                  var $cmp65=((($44))|0)==1; //@line 195 "phonemelist.cpp"
                  if ($cmp65) { __label__ = 22;; } else { __label__ = 23;; } //@line 195 "phonemelist.cpp"
                  if (__label__ == 22) {
  
                    $voicing=0; //@line 196 "phonemelist.cpp"
                    ; //@line 196 "phonemelist.cpp"
                  }
                  else if (__label__ == 23) {
  
                    $type=3; //@line 198 "phonemelist.cpp"
                    ;
                  }
                }
              } while(0);
  
              var $45=$type; //@line 202 "phonemelist.cpp"
              var $cmp70=((($45))|0)==4; //@line 202 "phonemelist.cpp"
              var $46=$type; //@line 202 "phonemelist.cpp"
              var $cmp72=((($46))|0)==6; //@line 202 "phonemelist.cpp"
              var $or_cond=($cmp70) | ($cmp72); //@line 202 "phonemelist.cpp"
              if ($or_cond) { __label__ = 25;; } else { __label__ = 32;; } //@line 202 "phonemelist.cpp"
              $if_then73$$if_else89$37: do { 
                if (__label__ == 25) {
  
                  var $47=$voicing; //@line 204 "phonemelist.cpp"
                  var $cmp74=((($47))|0)==0; //@line 204 "phonemelist.cpp"
                  if ($cmp74) { __lastLabel__ = 25; __label__ = 26;; } else { __lastLabel__ = 25; __label__ = 29;; } //@line 204 "phonemelist.cpp"
                  if (__label__ == 26) {
  
                    var $48=$regression; //@line 204 "phonemelist.cpp"
                    var $and75=($48) & 15; //@line 204 "phonemelist.cpp"
                    var $tobool76=((($and75))|0)!=0; //@line 204 "phonemelist.cpp"
                    if ($tobool76) { __label__ = 27;; } else { __label__ = 28;; } //@line 204 "phonemelist.cpp"
                    if (__label__ == 27) {
  
                      $voicing=1; //@line 206 "phonemelist.cpp"
                      __label__ = 44;break $if_then73$$if_else89$37; //@line 207 "phonemelist.cpp"
                    }
                    else if (__label__ == 28) {
  
                      var $_pr5=$voicing; //@line 209 "phonemelist.cpp"
                      __lastLabel__ = 28; ;
                    }
                  }
  
                  var $49=__lastLabel__ == 28 ? $_pr5 : ($47); //@line 209 "phonemelist.cpp"
                  var $cmp79=((($49))|0)==2; //@line 209 "phonemelist.cpp"
                  if (!($cmp79)) { __label__ = 44;break $if_then73$$if_else89$37; } //@line 209 "phonemelist.cpp"
  
                  var $50=$ph; //@line 209 "phonemelist.cpp"
                  var $end_type=(($50+13)&4294967295); //@line 209 "phonemelist.cpp"
                  var $51=HEAPU8[($end_type)]; //@line 209 "phonemelist.cpp"
                  var $conv81=((($51))&255); //@line 209 "phonemelist.cpp"
                  var $cmp82=((($conv81))|0)!=0; //@line 209 "phonemelist.cpp"
                  if (!($cmp82)) { __label__ = 44;break $if_then73$$if_else89$37; } //@line 209 "phonemelist.cpp"
  
                  var $52=$ph; //@line 211 "phonemelist.cpp"
                  var $end_type84=(($52+13)&4294967295); //@line 211 "phonemelist.cpp"
                  var $53=HEAP8[($end_type84)]; //@line 211 "phonemelist.cpp"
                  var $54=$j; //@line 211 "phonemelist.cpp"
                  var $55=$plist2; //@line 211 "phonemelist.cpp"
                  var $arrayidx85=(($55+8*$54)&4294967295); //@line 211 "phonemelist.cpp"
                  var $phcode86=(($arrayidx85)&4294967295); //@line 211 "phonemelist.cpp"
                  HEAP8[($phcode86)]=$53; //@line 211 "phonemelist.cpp"
                  ; //@line 212 "phonemelist.cpp"
                }
                else if (__label__ == 32) {
  
                  var $56=$type; //@line 215 "phonemelist.cpp"
                  var $cmp90=((($56))|0)==5; //@line 215 "phonemelist.cpp"
                  var $57=$type; //@line 215 "phonemelist.cpp"
                  var $cmp92=((($57))|0)==7; //@line 215 "phonemelist.cpp"
                  var $or_cond1=($cmp90) | ($cmp92); //@line 215 "phonemelist.cpp"
                  if ($or_cond1) { __label__ = 33;; } else { __label__ = 40;; } //@line 215 "phonemelist.cpp"
                  if (__label__ == 33) {
  
                    var $58=$voicing; //@line 217 "phonemelist.cpp"
                    var $cmp94=((($58))|0)==0; //@line 217 "phonemelist.cpp"
                    if ($cmp94) { __lastLabel__ = 33; __label__ = 34;; } else { __lastLabel__ = 33; __label__ = 37;; } //@line 217 "phonemelist.cpp"
                    if (__label__ == 34) {
  
                      var $59=$regression; //@line 217 "phonemelist.cpp"
                      var $and96=($59) & 15; //@line 217 "phonemelist.cpp"
                      var $tobool97=((($and96))|0)!=0; //@line 217 "phonemelist.cpp"
                      if ($tobool97) { __label__ = 35;; } else { __label__ = 36;; } //@line 217 "phonemelist.cpp"
                      if (__label__ == 35) {
  
                        $voicing=2; //@line 219 "phonemelist.cpp"
                        __label__ = 44;break $if_then73$$if_else89$37; //@line 220 "phonemelist.cpp"
                      }
                      else if (__label__ == 36) {
  
                        var $_pr6=$voicing; //@line 222 "phonemelist.cpp"
                        __lastLabel__ = 36; ;
                      }
                    }
  
                    var $60=__lastLabel__ == 36 ? $_pr6 : ($58); //@line 222 "phonemelist.cpp"
                    var $cmp100=((($60))|0)==1; //@line 222 "phonemelist.cpp"
                    if (!($cmp100)) { __label__ = 44;break $if_then73$$if_else89$37; } //@line 222 "phonemelist.cpp"
  
                    var $61=$ph; //@line 222 "phonemelist.cpp"
                    var $end_type102=(($61+13)&4294967295); //@line 222 "phonemelist.cpp"
                    var $62=HEAPU8[($end_type102)]; //@line 222 "phonemelist.cpp"
                    var $conv103=((($62))&255); //@line 222 "phonemelist.cpp"
                    var $cmp104=((($conv103))|0)!=0; //@line 222 "phonemelist.cpp"
                    if (!($cmp104)) { __label__ = 44;break $if_then73$$if_else89$37; } //@line 222 "phonemelist.cpp"
  
                    var $63=$ph; //@line 224 "phonemelist.cpp"
                    var $end_type106=(($63+13)&4294967295); //@line 224 "phonemelist.cpp"
                    var $64=HEAP8[($end_type106)]; //@line 224 "phonemelist.cpp"
                    var $65=$j; //@line 224 "phonemelist.cpp"
                    var $66=$plist2; //@line 224 "phonemelist.cpp"
                    var $arrayidx107=(($66+8*$65)&4294967295); //@line 224 "phonemelist.cpp"
                    var $phcode108=(($arrayidx107)&4294967295); //@line 224 "phonemelist.cpp"
                    HEAP8[($phcode108)]=$64; //@line 224 "phonemelist.cpp"
                    ; //@line 225 "phonemelist.cpp"
                  }
                  else if (__label__ == 40) {
  
                    var $67=$regression; //@line 229 "phonemelist.cpp"
                    var $and112=($67) & 8; //@line 229 "phonemelist.cpp"
                    var $tobool113=((($and112))|0)!=0; //@line 229 "phonemelist.cpp"
                    if ($tobool113) { __label__ = 41;; } else { __label__ = 43;; } //@line 229 "phonemelist.cpp"
                    if (__label__ == 41) {
  
                      var $68=$type; //@line 232 "phonemelist.cpp"
                      var $cmp115=((($68))|0)==0; //@line 232 "phonemelist.cpp"
                      var $69=$type; //@line 232 "phonemelist.cpp"
                      var $cmp117=((($69))|0)==2; //@line 232 "phonemelist.cpp"
                      var $or_cond2=($cmp115) | ($cmp117); //@line 232 "phonemelist.cpp"
                      if (!($or_cond2)) { __label__ = 44;break $if_then73$$if_else89$37; } //@line 232 "phonemelist.cpp"
  
                      $voicing=0; //@line 233 "phonemelist.cpp"
                      ; //@line 233 "phonemelist.cpp"
                    }
                    else if (__label__ == 43) {
  
                      $voicing=0; //@line 237 "phonemelist.cpp"
                      ;
                    }
                  }
                }
              } while(0);
  
              $word_end_devoice=0; //@line 241 "phonemelist.cpp"
              var $70=$j; //@line 242 "phonemelist.cpp"
              var $71=$plist2; //@line 242 "phonemelist.cpp"
              var $arrayidx124=(($71+8*$70)&4294967295); //@line 242 "phonemelist.cpp"
              var $sourceix125=(($arrayidx124+6)&4294967295); //@line 242 "phonemelist.cpp"
              var $72=HEAP16[(($sourceix125)>>1)]; //@line 242 "phonemelist.cpp"
              var $tobool126=(tempInt=(($72)),(tempInt>=32768?tempInt-65536:tempInt))!=0; //@line 242 "phonemelist.cpp"
              if (!($tobool126)) { __label__ = 50;break $for_inc140$$if_end44$21; } //@line 242 "phonemelist.cpp"
  
              var $73=$regression; //@line 244 "phonemelist.cpp"
              var $and128=($73) & 4; //@line 244 "phonemelist.cpp"
              var $tobool129=((($and128))|0)!=0; //@line 244 "phonemelist.cpp"
              if ($tobool129) { __label__ = 46;; } else { __label__ = 47;; } //@line 244 "phonemelist.cpp"
              if (__label__ == 46) {
  
                $voicing=0; //@line 247 "phonemelist.cpp"
                ; //@line 248 "phonemelist.cpp"
              }
  
              var $74=$regression; //@line 249 "phonemelist.cpp"
              var $and132=($74) & 16; //@line 249 "phonemelist.cpp"
              var $tobool133=((($and132))|0)!=0; //@line 249 "phonemelist.cpp"
              if (!($tobool133)) { __label__ = 50;break $for_inc140$$if_end44$21; } //@line 249 "phonemelist.cpp"
  
              var $75=$voicing; //@line 252 "phonemelist.cpp"
              var $cmp135=((($75))|0)==0; //@line 252 "phonemelist.cpp"
              if (!($cmp135)) { __label__ = 50;break $for_inc140$$if_end44$21; } //@line 252 "phonemelist.cpp"
  
              $voicing=1; //@line 254 "phonemelist.cpp"
              $word_end_devoice=1; //@line 255 "phonemelist.cpp"
              ; //@line 256 "phonemelist.cpp"
            }
          } while(0);
  
          var $76=$j; //@line 177 "phonemelist.cpp"
          var $dec141=((($76)-1)&4294967295); //@line 177 "phonemelist.cpp"
          $j=$dec141; //@line 177 "phonemelist.cpp"
          var $cmp38=((($dec141))|0) >= 0; //@line 177 "phonemelist.cpp"
          if ($cmp38) { __label__ = 13;continue $for_body39$19; } else { __label__ = 51;break $if_then35$$if_end143$17; } //@line 177 "phonemelist.cpp"
        }
      }
    } while(0);
  
    var $77=$tr_addr; //@line 262 "phonemelist.cpp"
    var $arraydecay=(($ph_list3)&4294967295); //@line 262 "phonemelist.cpp"
    var $call=__ZL18SubstitutePhonemesP10TranslatorP12PHONEME_LIST($77, $arraydecay); //@line 262 "phonemelist.cpp"
    var $sub144=((($call)-2)&4294967295); //@line 262 "phonemelist.cpp"
    $n_ph_list3=$sub144; //@line 262 "phonemelist.cpp"
    $j=0; //@line 264 "phonemelist.cpp"
    ; //@line 264 "phonemelist.cpp"
    $for_cond145$72: while(1) { 
  
      var $78=$j; //@line 264 "phonemelist.cpp"
      var $79=$n_ph_list3; //@line 264 "phonemelist.cpp"
      var $cmp146=((($78))|0) < ((($79))|0); //@line 264 "phonemelist.cpp"
      if (!($cmp146)) { __label__ = 64;break $for_cond145$72; } //@line 264 "phonemelist.cpp"
  
      var $80=$ix; //@line 264 "phonemelist.cpp"
      var $cmp147=((($80))|0) < 997; //@line 264 "phonemelist.cpp"
      if (!($cmp147)) { __label__ = 64;break $for_cond145$72; }
  
      var $81=$j; //@line 266 "phonemelist.cpp"
      var $arrayidx149=(($ph_list3+$81*24)&4294967295); //@line 266 "phonemelist.cpp"
      var $sourceix150=(($arrayidx149+6)&4294967295); //@line 266 "phonemelist.cpp"
      var $82=HEAP16[(($sourceix150)>>1)]; //@line 266 "phonemelist.cpp"
      var $tobool151=(tempInt=(($82)),(tempInt>=32768?tempInt-65536:tempInt))!=0; //@line 266 "phonemelist.cpp"
      if ($tobool151) { __label__ = 55;; } else { __label__ = 63;; } //@line 266 "phonemelist.cpp"
      if (__label__ == 55) {
  
        $word_stress=0; //@line 271 "phonemelist.cpp"
        var $83=$j; //@line 274 "phonemelist.cpp"
        $nextw=$83; //@line 274 "phonemelist.cpp"
        ; //@line 274 "phonemelist.cpp"
        $for_cond153$78: while(1) { 
  
          var $84=$nextw; //@line 274 "phonemelist.cpp"
          var $85=$n_ph_list3; //@line 274 "phonemelist.cpp"
          var $cmp154=((($84))|0) < ((($85))|0); //@line 274 "phonemelist.cpp"
          if (!($cmp154)) { __label__ = 60;break $for_cond153$78; } //@line 274 "phonemelist.cpp"
  
          var $86=$nextw; //@line 276 "phonemelist.cpp"
          var $arrayidx156=(($ph_list3+$86*24)&4294967295); //@line 276 "phonemelist.cpp"
          var $stresslevel157=(($arrayidx156+1)&4294967295); //@line 276 "phonemelist.cpp"
          var $87=HEAPU8[($stresslevel157)]; //@line 276 "phonemelist.cpp"
          var $conv158=((($87))&255); //@line 276 "phonemelist.cpp"
          var $88=$word_stress; //@line 276 "phonemelist.cpp"
          var $cmp159=((($conv158))|0) > ((($88))|0); //@line 276 "phonemelist.cpp"
          if ($cmp159) { __label__ = 58;; } else { __label__ = 59;; } //@line 276 "phonemelist.cpp"
          if (__label__ == 58) {
  
            var $89=$nextw; //@line 277 "phonemelist.cpp"
            var $arrayidx161=(($ph_list3+$89*24)&4294967295); //@line 277 "phonemelist.cpp"
            var $stresslevel162=(($arrayidx161+1)&4294967295); //@line 277 "phonemelist.cpp"
            var $90=HEAPU8[($stresslevel162)]; //@line 277 "phonemelist.cpp"
            var $conv163=((($90))&255); //@line 277 "phonemelist.cpp"
            $word_stress=$conv163; //@line 277 "phonemelist.cpp"
            ; //@line 277 "phonemelist.cpp"
          }
  
          var $91=$nextw; //@line 279 "phonemelist.cpp"
          var $inc=((($91)+1)&4294967295); //@line 279 "phonemelist.cpp"
          $nextw=$inc; //@line 279 "phonemelist.cpp"
          var $92=$nextw; //@line 280 "phonemelist.cpp"
          var $arrayidx165=(($ph_list3+$92*24)&4294967295); //@line 280 "phonemelist.cpp"
          var $sourceix166=(($arrayidx165+6)&4294967295); //@line 280 "phonemelist.cpp"
          var $93=HEAP16[(($sourceix166)>>1)]; //@line 280 "phonemelist.cpp"
          var $tobool167=(tempInt=(($93)),(tempInt>=32768?tempInt-65536:tempInt))!=0; //@line 280 "phonemelist.cpp"
          if ($tobool167) { __label__ = 60;break $for_cond153$78; } else { __label__ = 56;continue $for_cond153$78; } //@line 280 "phonemelist.cpp"
        }
  
        var $94=$j; //@line 283 "phonemelist.cpp"
        $k=$94; //@line 283 "phonemelist.cpp"
        var $95=$k; //@line 283 "phonemelist.cpp"
        var $96=$nextw; //@line 283 "phonemelist.cpp"
        var $cmp1728=((($95))|0) < ((($96))|0); //@line 283 "phonemelist.cpp"
        if ($cmp1728) { __label__ = 61;; } else { __label__ = 62;; } //@line 283 "phonemelist.cpp"
        $for_body173$$for_end178$85: do { 
          if (__label__ == 61) {
            while(1) { 
  
              var $97=$word_stress; //@line 285 "phonemelist.cpp"
              var $conv174=((($97)) & 255); //@line 285 "phonemelist.cpp"
              var $98=$k; //@line 285 "phonemelist.cpp"
              var $arrayidx175=(($ph_list3+$98*24)&4294967295); //@line 285 "phonemelist.cpp"
              var $wordstress=(($arrayidx175+2)&4294967295); //@line 285 "phonemelist.cpp"
              HEAP8[($wordstress)]=$conv174; //@line 285 "phonemelist.cpp"
              var $99=$k; //@line 283 "phonemelist.cpp"
              var $inc177=((($99)+1)&4294967295); //@line 283 "phonemelist.cpp"
              $k=$inc177; //@line 283 "phonemelist.cpp"
              var $100=$k; //@line 283 "phonemelist.cpp"
              var $101=$nextw; //@line 283 "phonemelist.cpp"
              var $cmp172=((($100))|0) < ((($101))|0); //@line 283 "phonemelist.cpp"
              if ($cmp172) { __label__ = 61;continue ; } else { __label__ = 62;break $for_body173$$for_end178$85; } //@line 283 "phonemelist.cpp"
            }
          }
        } while(0);
  
        var $102=$nextw; //@line 287 "phonemelist.cpp"
        $j=$102; //@line 287 "phonemelist.cpp"
        __label__ = 52;continue $for_cond145$72; //@line 288 "phonemelist.cpp"
      }
      else if (__label__ == 63) {
  
        var $103=$j; //@line 291 "phonemelist.cpp"
        var $inc180=((($103)+1)&4294967295); //@line 291 "phonemelist.cpp"
        $j=$inc180; //@line 291 "phonemelist.cpp"
        __label__ = 52;continue $for_cond145$72;
      }
    }
  
    var $104=HEAP32[((((_phoneme_tab+36)&4294967295))>>2)]; //@line 296 "phonemelist.cpp"
    $ph=$104; //@line 296 "phonemelist.cpp"
    var $105=$ph; //@line 297 "phonemelist.cpp"
    var $arrayidx183=(($ph_list3)&4294967295); //@line 297 "phonemelist.cpp"
    var $ph184=(($arrayidx183+8)&4294967295); //@line 297 "phonemelist.cpp"
    HEAP32[(($ph184)>>2)]=$105; //@line 297 "phonemelist.cpp"
    $switched_language=0; //@line 299 "phonemelist.cpp"
    $j=0; //@line 301 "phonemelist.cpp"
    var $pd_param=(($phdata+4)&4294967295); //@line 346 "phonemelist.cpp"
    var $arrayidx233=(($pd_param+12)&4294967295); //@line 346 "phonemelist.cpp"
    var $pd_param262=(($phdata+4)&4294967295); //@line 371 "phonemelist.cpp"
    var $arrayidx263=(($pd_param262+4)&4294967295); //@line 371 "phonemelist.cpp"
    var $pd_param480=(($phdata+4)&4294967295); //@line 568 "phonemelist.cpp"
    var $arrayidx481=(($pd_param480+16)&4294967295); //@line 568 "phonemelist.cpp"
    var $pd_param484=(($phdata+4)&4294967295); //@line 570 "phonemelist.cpp"
    var $arrayidx485=(($pd_param484+16)&4294967295); //@line 570 "phonemelist.cpp"
    var $pd_param537=(($phdata+4)&4294967295); //@line 608 "phonemelist.cpp"
    var $arrayidx538=(($pd_param537+40)&4294967295); //@line 608 "phonemelist.cpp"
    ; //@line 301 "phonemelist.cpp"
    $for_cond185$91: while(1) { 
  
      var $106=$insert_ph; //@line 301 "phonemelist.cpp"
      var $tobool186=((($106))|0)!=0; //@line 301 "phonemelist.cpp"
      if ($tobool186) { __lastLabel__ = 65; __label__ = 69;; } else { __lastLabel__ = 65; __label__ = 66;; } //@line 301 "phonemelist.cpp"
      if (__label__ == 66) {
  
        var $107=$j; //@line 301 "phonemelist.cpp"
        var $108=$n_ph_list3; //@line 301 "phonemelist.cpp"
        var $cmp187=((($107))|0) < ((($108))|0); //@line 301 "phonemelist.cpp"
        if (!($cmp187)) { __label__ = 158;break $for_cond185$91; } //@line 301 "phonemelist.cpp"
  
        var $109=$ix; //@line 301 "phonemelist.cpp"
        var $cmp189=((($109))|0) < 997; //@line 301 "phonemelist.cpp"
        if (!($cmp189)) { __label__ = 158;break $for_cond185$91; }
  
        var $_pr7=$insert_ph; //@line 307 "phonemelist.cpp"
        __lastLabel__ = 68; ;
      }
  
      var $110=__lastLabel__ == 68 ? $_pr7 : ($106); //@line 307 "phonemelist.cpp"
      var $111=$ph; //@line 303 "phonemelist.cpp"
      $prev=$111; //@line 303 "phonemelist.cpp"
      var $112=$j; //@line 305 "phonemelist.cpp"
      var $arrayidx192=(($ph_list3+$112*24)&4294967295); //@line 305 "phonemelist.cpp"
      $plist3=$arrayidx192; //@line 305 "phonemelist.cpp"
      var $cmp193=((($110))|0)!=0; //@line 307 "phonemelist.cpp"
      var $113=$plist3; //@line 310 "phonemelist.cpp"
      var $phcode195=(($113)&4294967295); //@line 310 "phonemelist.cpp"
      var $114=HEAPU8[($phcode195)]; //@line 310 "phonemelist.cpp"
      var $idxprom196=((($114))&255); //@line 310 "phonemelist.cpp"
      var $arrayidx197=((_phoneme_tab+$idxprom196*4)&4294967295); //@line 310 "phonemelist.cpp"
      var $115=HEAP32[(($arrayidx197)>>2)]; //@line 310 "phonemelist.cpp"
      if ($cmp193) { __label__ = 70;; } else { __label__ = 73;; } //@line 307 "phonemelist.cpp"
      if (__label__ == 70) {
  
        $next=$115; //@line 310 "phonemelist.cpp"
        var $116=$j; //@line 314 "phonemelist.cpp"
        var $dec198=((($116)-1)&4294967295); //@line 314 "phonemelist.cpp"
        $j=$dec198; //@line 314 "phonemelist.cpp"
        var $117=$j; //@line 315 "phonemelist.cpp"
        var $arrayidx199=(($ph_list3+$117*24)&4294967295); //@line 315 "phonemelist.cpp"
        $plist3_inserted=$arrayidx199; //@line 315 "phonemelist.cpp"
        $plist3=$arrayidx199; //@line 315 "phonemelist.cpp"
        var $118=$j; //@line 316 "phonemelist.cpp"
        var $cmp200=((($118))|0) > 0; //@line 316 "phonemelist.cpp"
        if ($cmp200) { __label__ = 71;; } else { __label__ = 72;; } //@line 316 "phonemelist.cpp"
        if (__label__ == 71) {
  
          var $119=$plist3; //@line 318 "phonemelist.cpp"
          var $arrayidx202=(($119+-24)&4294967295); //@line 318 "phonemelist.cpp"
          var $120=$arrayidx202; //@line 318 "phonemelist.cpp"
          var $121=$plist3; //@line 318 "phonemelist.cpp"
          var $arrayidx203=(($121)&4294967295); //@line 318 "phonemelist.cpp"
          var $122=$arrayidx203; //@line 318 "phonemelist.cpp"
          var $src$, $dest$, $stop$, $stop4$, $fast$;
          $src$ = $122;
          $dest$ = $120;
          $stop$ = $src$ + 24;
          if (($dest$%4) == ($src$%4) && 24 > 8) {
            while ($src$%4 !== 0 && $src$ < $stop$) {
              ; HEAP8[$dest$++] = HEAP8[$src$++];
            }
            $src$ >>= 2;
            $dest$ >>= 2;
            $stop4$ = $stop$ >> 2;
            while ($src$ < $stop4$) {
          ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
            }
            $src$ <<= 2;
            $dest$ <<= 2;
          }while ($src$ < $stop$) {
            ; HEAP8[$dest$++] = HEAP8[$src$++];
          }; //@line 318 "phonemelist.cpp"
          ; //@line 319 "phonemelist.cpp"
        }
  
        var $123=$plist3; //@line 320 "phonemelist.cpp"
        var $arrayidx205=(($123)&4294967295); //@line 320 "phonemelist.cpp"
        var $124=$arrayidx205; //@line 320 "phonemelist.cpp"
        var $dest$, $stop$, $stop4$, $fast$, $value4$;
        $dest$ = $124;
        $stop$ = $dest$ + 24;
        $value4$ = 0;
        if ($value4$ < 0) $value4$ += 256;
        $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
        while ($dest$%4 !== 0 && $dest$ < $stop$) {
          ;; HEAP8[$dest$++] = 0;
        }
        $dest$ >>= 2;
        $stop4$ = $stop$ >> 2;
        while ($dest$ < $stop4$) {
        ;;;;;;;  HEAP32[$dest$++] = $value4$;
        }
        $dest$ <<= 2;
        while ($dest$ < $stop$) {
          ;; HEAP8[$dest$++] = 0;
        }; //@line 320 "phonemelist.cpp"
        var $125=$insert_ph; //@line 321 "phonemelist.cpp"
        var $conv206=((($125)) & 255); //@line 321 "phonemelist.cpp"
        var $126=$plist3; //@line 321 "phonemelist.cpp"
        var $phcode207=(($126)&4294967295); //@line 321 "phonemelist.cpp"
        HEAP8[($phcode207)]=$conv206; //@line 321 "phonemelist.cpp"
        var $127=$insert_ph; //@line 322 "phonemelist.cpp"
        var $arrayidx208=((_phoneme_tab+$127*4)&4294967295); //@line 322 "phonemelist.cpp"
        var $128=HEAP32[(($arrayidx208)>>2)]; //@line 322 "phonemelist.cpp"
        $ph=$128; //@line 322 "phonemelist.cpp"
        var $129=$ph; //@line 323 "phonemelist.cpp"
        var $130=$plist3; //@line 323 "phonemelist.cpp"
        var $ph209=(($130+8)&4294967295); //@line 323 "phonemelist.cpp"
        HEAP32[(($ph209)>>2)]=$129; //@line 323 "phonemelist.cpp"
        $insert_ph=0; //@line 324 "phonemelist.cpp"
        ; //@line 325 "phonemelist.cpp"
      }
      else if (__label__ == 73) {
  
        $ph=$115; //@line 329 "phonemelist.cpp"
        var $131=$ph; //@line 330 "phonemelist.cpp"
        var $132=$plist3; //@line 330 "phonemelist.cpp"
        var $arrayidx214=(($132)&4294967295); //@line 330 "phonemelist.cpp"
        var $ph215=(($arrayidx214+8)&4294967295); //@line 330 "phonemelist.cpp"
        HEAP32[(($ph215)>>2)]=$131; //@line 330 "phonemelist.cpp"
        var $133=$plist3; //@line 332 "phonemelist.cpp"
        var $phcode216=(($133)&4294967295); //@line 332 "phonemelist.cpp"
        var $134=HEAPU8[($phcode216)]; //@line 332 "phonemelist.cpp"
        var $conv217=((($134))&255); //@line 332 "phonemelist.cpp"
        var $cmp218=((($conv217))|0)==21; //@line 332 "phonemelist.cpp"
        if ($cmp218) { __label__ = 74;; } else { __label__ = 75;; } //@line 332 "phonemelist.cpp"
        if (__label__ == 74) {
  
          var $135=$plist3; //@line 335 "phonemelist.cpp"
          var $tone_ph=(($135+3)&4294967295); //@line 335 "phonemelist.cpp"
          var $136=HEAPU8[($tone_ph)]; //@line 335 "phonemelist.cpp"
          var $conv220=((($136))&255); //@line 335 "phonemelist.cpp"
          __Z18SelectPhonemeTablei($conv220); //@line 335 "phonemelist.cpp"
          var $137=$switched_language; //@line 336 "phonemelist.cpp"
          var $xor221=($137) ^ 32; //@line 336 "phonemelist.cpp"
          $switched_language=$xor221; //@line 336 "phonemelist.cpp"
          ; //@line 337 "phonemelist.cpp"
        }
  
        var $138=$plist3; //@line 338 "phonemelist.cpp"
        var $arrayidx223=(($138+24)&4294967295); //@line 338 "phonemelist.cpp"
        var $phcode224=(($arrayidx223)&4294967295); //@line 338 "phonemelist.cpp"
        var $139=HEAPU8[($phcode224)]; //@line 338 "phonemelist.cpp"
        var $idxprom225=((($139))&255); //@line 338 "phonemelist.cpp"
        var $arrayidx226=((_phoneme_tab+$idxprom225*4)&4294967295); //@line 338 "phonemelist.cpp"
        var $140=HEAP32[(($arrayidx226)>>2)]; //@line 338 "phonemelist.cpp"
        $next=$140; //@line 338 "phonemelist.cpp"
        var $141=$next; //@line 339 "phonemelist.cpp"
        var $142=$plist3; //@line 339 "phonemelist.cpp"
        var $arrayidx227=(($142+24)&4294967295); //@line 339 "phonemelist.cpp"
        var $ph228=(($arrayidx227+8)&4294967295); //@line 339 "phonemelist.cpp"
        HEAP32[(($ph228)>>2)]=$141; //@line 339 "phonemelist.cpp"
        ;
      }
  
      var $143=$ph; //@line 342 "phonemelist.cpp"
      var $cmp230=((($143))|0)==0; //@line 342 "phonemelist.cpp"
      if ($cmp230) { __label__ = 157;; } else { __label__ = 77;; } //@line 342 "phonemelist.cpp"
      $for_inc584$$if_end232$108: do { 
        if (__label__ == 77) {
  
          var $144=$tr_addr; //@line 344 "phonemelist.cpp"
          var $145=$plist3; //@line 344 "phonemelist.cpp"
          __Z16InterpretPhonemeP10TranslatoriP12PHONEME_LISTP12PHONEME_DATA($144, 256, $145, $phdata); //@line 344 "phonemelist.cpp"
          var $146=HEAP32[(($arrayidx233)>>2)]; //@line 346 "phonemelist.cpp"
          $alternative=$146; //@line 346 "phonemelist.cpp"
          var $cmp234=((($146))|0) > 0; //@line 346 "phonemelist.cpp"
          if ($cmp234) { __label__ = 78;; } else { __label__ = 83;; } //@line 346 "phonemelist.cpp"
          if (__label__ == 78) {
  
            var $147=$ph; //@line 350 "phonemelist.cpp"
            $ph2=$147; //@line 350 "phonemelist.cpp"
            var $148=$plist3; //@line 352 "phonemelist.cpp"
            var $phcode236=(($148)&4294967295); //@line 352 "phonemelist.cpp"
            var $149=HEAPU8[($phcode236)]; //@line 352 "phonemelist.cpp"
            var $conv237=((($149))&255); //@line 352 "phonemelist.cpp"
            $insert_ph=$conv237; //@line 352 "phonemelist.cpp"
            var $150=$alternative; //@line 353 "phonemelist.cpp"
            var $arrayidx238=((_phoneme_tab+$150*4)&4294967295); //@line 353 "phonemelist.cpp"
            var $151=HEAP32[(($arrayidx238)>>2)]; //@line 353 "phonemelist.cpp"
            $ph=$151; //@line 353 "phonemelist.cpp"
            var $152=$ph; //@line 354 "phonemelist.cpp"
            var $153=$plist3; //@line 354 "phonemelist.cpp"
            var $ph239=(($153+8)&4294967295); //@line 354 "phonemelist.cpp"
            HEAP32[(($ph239)>>2)]=$152; //@line 354 "phonemelist.cpp"
            var $154=$alternative; //@line 355 "phonemelist.cpp"
            var $conv240=((($154)) & 255); //@line 355 "phonemelist.cpp"
            var $155=$plist3; //@line 355 "phonemelist.cpp"
            var $phcode241=(($155)&4294967295); //@line 355 "phonemelist.cpp"
            HEAP8[($phcode241)]=$conv240; //@line 355 "phonemelist.cpp"
            var $156=$ph; //@line 357 "phonemelist.cpp"
            var $type242=(($156+11)&4294967295); //@line 357 "phonemelist.cpp"
            var $157=HEAPU8[($type242)]; //@line 357 "phonemelist.cpp"
            var $conv243=((($157))&255); //@line 357 "phonemelist.cpp"
            var $cmp244=((($conv243))|0)==2; //@line 357 "phonemelist.cpp"
            var $158=$plist3; //@line 359 "phonemelist.cpp"
            var $synthflags246=(($158+4)&4294967295); //@line 359 "phonemelist.cpp"
            var $159=HEAPU16[(($synthflags246)>>1)]; //@line 359 "phonemelist.cpp"
            var $conv247=((($159))&65535); //@line 359 "phonemelist.cpp"
            if ($cmp244) { __label__ = 79;; } else { __label__ = 81;; } //@line 357 "phonemelist.cpp"
            $if_then245$$if_else255$112: do { 
              if (__label__ == 79) {
  
                var $or=($conv247) | 4; //@line 359 "phonemelist.cpp"
                var $conv248=((($or)) & 65535); //@line 359 "phonemelist.cpp"
                HEAP16[(($synthflags246)>>1)]=$conv248; //@line 359 "phonemelist.cpp"
                var $160=$ph2; //@line 360 "phonemelist.cpp"
                var $type249=(($160+11)&4294967295); //@line 360 "phonemelist.cpp"
                var $161=HEAPU8[($type249)]; //@line 360 "phonemelist.cpp"
                var $conv250=((($161))&255); //@line 360 "phonemelist.cpp"
                var $cmp251=((($conv250))|0)!=2; //@line 360 "phonemelist.cpp"
                if (!($cmp251)) { __label__ = 82;break $if_then245$$if_else255$112; } //@line 360 "phonemelist.cpp"
  
                var $162=$plist3; //@line 361 "phonemelist.cpp"
                var $stresslevel253=(($162+1)&4294967295); //@line 361 "phonemelist.cpp"
                HEAP8[($stresslevel253)]=0; //@line 361 "phonemelist.cpp"
                ; //@line 361 "phonemelist.cpp"
              }
              else if (__label__ == 81) {
  
                var $and258=($conv247) & -5; //@line 364 "phonemelist.cpp"
                var $conv259=((($and258)) & 65535); //@line 364 "phonemelist.cpp"
                HEAP16[(($synthflags246)>>1)]=$conv259; //@line 364 "phonemelist.cpp"
                ;
              }
            } while(0);
  
            var $163=$tr_addr; //@line 368 "phonemelist.cpp"
            var $164=$plist3; //@line 368 "phonemelist.cpp"
            __Z16InterpretPhonemeP10TranslatoriP12PHONEME_LISTP12PHONEME_DATA($163, 256, $164, $phdata); //@line 368 "phonemelist.cpp"
            ; //@line 369 "phonemelist.cpp"
          }
  
          var $165=HEAP32[(($arrayidx263)>>2)]; //@line 371 "phonemelist.cpp"
          $alternative=$165; //@line 371 "phonemelist.cpp"
          var $cmp264=((($165))|0) > 0; //@line 371 "phonemelist.cpp"
          if ($cmp264) { __label__ = 84;; } else { __label__ = 90;; } //@line 371 "phonemelist.cpp"
          if (__label__ == 84) {
  
            var $166=$ph; //@line 374 "phonemelist.cpp"
            $ph2266=$166; //@line 374 "phonemelist.cpp"
            var $167=$alternative; //@line 375 "phonemelist.cpp"
            var $arrayidx267=((_phoneme_tab+$167*4)&4294967295); //@line 375 "phonemelist.cpp"
            var $168=HEAP32[(($arrayidx267)>>2)]; //@line 375 "phonemelist.cpp"
            $ph=$168; //@line 375 "phonemelist.cpp"
            var $169=$ph; //@line 376 "phonemelist.cpp"
            var $170=$plist3; //@line 376 "phonemelist.cpp"
            var $ph268=(($170+8)&4294967295); //@line 376 "phonemelist.cpp"
            HEAP32[(($ph268)>>2)]=$169; //@line 376 "phonemelist.cpp"
            var $171=$alternative; //@line 377 "phonemelist.cpp"
            var $conv269=((($171)) & 255); //@line 377 "phonemelist.cpp"
            var $172=$plist3; //@line 377 "phonemelist.cpp"
            var $phcode270=(($172)&4294967295); //@line 377 "phonemelist.cpp"
            HEAP8[($phcode270)]=$conv269; //@line 377 "phonemelist.cpp"
            var $173=$alternative; //@line 379 "phonemelist.cpp"
            var $cmp271=((($173))|0)==1; //@line 379 "phonemelist.cpp"
            if ($cmp271) { __label__ = 157;break $for_inc584$$if_end232$108; } //@line 379 "phonemelist.cpp"
  
            var $174=$ph; //@line 382 "phonemelist.cpp"
            var $type274=(($174+11)&4294967295); //@line 382 "phonemelist.cpp"
            var $175=HEAPU8[($type274)]; //@line 382 "phonemelist.cpp"
            var $conv275=((($175))&255); //@line 382 "phonemelist.cpp"
            var $cmp276=((($conv275))|0)==2; //@line 382 "phonemelist.cpp"
            var $176=$plist3; //@line 384 "phonemelist.cpp"
            var $synthflags278=(($176+4)&4294967295); //@line 384 "phonemelist.cpp"
            var $177=HEAPU16[(($synthflags278)>>1)]; //@line 384 "phonemelist.cpp"
            var $conv279=((($177))&65535); //@line 384 "phonemelist.cpp"
            if ($cmp276) { __label__ = 86;; } else { __label__ = 88;; } //@line 382 "phonemelist.cpp"
            $if_then277$$if_else288$121: do { 
              if (__label__ == 86) {
  
                var $or280=($conv279) | 4; //@line 384 "phonemelist.cpp"
                var $conv281=((($or280)) & 65535); //@line 384 "phonemelist.cpp"
                HEAP16[(($synthflags278)>>1)]=$conv281; //@line 384 "phonemelist.cpp"
                var $178=$ph2266; //@line 385 "phonemelist.cpp"
                var $type282=(($178+11)&4294967295); //@line 385 "phonemelist.cpp"
                var $179=HEAPU8[($type282)]; //@line 385 "phonemelist.cpp"
                var $conv283=((($179))&255); //@line 385 "phonemelist.cpp"
                var $cmp284=((($conv283))|0)!=2; //@line 385 "phonemelist.cpp"
                if (!($cmp284)) { __label__ = 89;break $if_then277$$if_else288$121; } //@line 385 "phonemelist.cpp"
  
                var $180=$plist3; //@line 386 "phonemelist.cpp"
                var $stresslevel286=(($180+1)&4294967295); //@line 386 "phonemelist.cpp"
                HEAP8[($stresslevel286)]=0; //@line 386 "phonemelist.cpp"
                ; //@line 386 "phonemelist.cpp"
              }
              else if (__label__ == 88) {
  
                var $and291=($conv279) & -5; //@line 389 "phonemelist.cpp"
                var $conv292=((($and291)) & 65535); //@line 389 "phonemelist.cpp"
                HEAP16[(($synthflags278)>>1)]=$conv292; //@line 389 "phonemelist.cpp"
                ;
              }
            } while(0);
  
            var $181=$tr_addr; //@line 393 "phonemelist.cpp"
            var $182=$plist3; //@line 393 "phonemelist.cpp"
            __Z16InterpretPhonemeP10TranslatoriP12PHONEME_LISTP12PHONEME_DATA($181, 256, $182, $phdata); //@line 393 "phonemelist.cpp"
            ; //@line 394 "phonemelist.cpp"
          }
  
          var $183=$ph; //@line 396 "phonemelist.cpp"
          var $type295=(($183+11)&4294967295); //@line 396 "phonemelist.cpp"
          var $184=HEAPU8[($type295)]; //@line 396 "phonemelist.cpp"
          var $conv296=((($184))&255); //@line 396 "phonemelist.cpp"
          var $cmp297=((($conv296))|0)==2; //@line 396 "phonemelist.cpp"
          if ($cmp297) { __label__ = 91;; } else { __label__ = 110;; } //@line 396 "phonemelist.cpp"
          $if_then298$$if_end362$127: do { 
            if (__label__ == 91) {
  
              var $185=$plist3; //@line 402 "phonemelist.cpp"
              var $stresslevel299=(($185+1)&4294967295); //@line 402 "phonemelist.cpp"
              var $186=HEAPU8[($stresslevel299)]; //@line 402 "phonemelist.cpp"
              var $conv300=((($186))&255); //@line 402 "phonemelist.cpp"
              var $cmp301=((($conv300))|0) <= 1; //@line 402 "phonemelist.cpp"
              if ($cmp301) { __label__ = 92;; } else { __label__ = 109;; } //@line 402 "phonemelist.cpp"
              if (__label__ == 92) {
  
                var $187=$unstress_count; //@line 405 "phonemelist.cpp"
                var $inc303=((($187)+1)&4294967295); //@line 405 "phonemelist.cpp"
                $unstress_count=$inc303; //@line 405 "phonemelist.cpp"
                var $188=$tr_addr; //@line 407 "phonemelist.cpp"
                var $langopts304=(($188)&4294967295); //@line 407 "phonemelist.cpp"
                var $stress_flags=(($langopts304+12)&4294967295); //@line 407 "phonemelist.cpp"
                var $189=HEAP32[(($stress_flags)>>2)]; //@line 407 "phonemelist.cpp"
                var $and305=($189) & 8; //@line 407 "phonemelist.cpp"
                var $tobool306=((($and305))|0)!=0; //@line 407 "phonemelist.cpp"
                if ($tobool306) { __label__ = 93;; } else { __label__ = 102;; } //@line 407 "phonemelist.cpp"
                if (__label__ == 93) {
  
                  var $190=$plist3; //@line 410 "phonemelist.cpp"
                  var $add_ptr=(($190+24)&4294967295); //@line 410 "phonemelist.cpp"
                  $p=$add_ptr; //@line 410 "phonemelist.cpp"
                  ; //@line 410 "phonemelist.cpp"
                  while(1) { 
  
                    var $191=$p; //@line 410 "phonemelist.cpp"
                    var $type309=(($191+15)&4294967295); //@line 410 "phonemelist.cpp"
                    var $192=HEAPU8[($type309)]; //@line 410 "phonemelist.cpp"
                    var $conv310=((($192))&255); //@line 410 "phonemelist.cpp"
                    var $cmp311=((($conv310))|0)!=0; //@line 410 "phonemelist.cpp"
                    if (!($cmp311)) { __label__ = 110;break $if_then298$$if_end362$127; } //@line 410 "phonemelist.cpp"
  
                    var $193=$p; //@line 412 "phonemelist.cpp"
                    var $type313=(($193+15)&4294967295); //@line 412 "phonemelist.cpp"
                    var $194=HEAPU8[($type313)]; //@line 412 "phonemelist.cpp"
                    var $conv314=((($194))&255); //@line 412 "phonemelist.cpp"
                    var $cmp315=((($conv314))|0)==2; //@line 412 "phonemelist.cpp"
                    var $195=$p; //@line 414 "phonemelist.cpp"
                    if ($cmp315) { __label__ = 96;break ; } //@line 412 "phonemelist.cpp"
  
                    var $incdec_ptr=(($195+24)&4294967295); //@line 410 "phonemelist.cpp"
                    $p=$incdec_ptr; //@line 410 "phonemelist.cpp"
                    __label__ = 94;continue ; //@line 410 "phonemelist.cpp"
                  }
  
                  var $stresslevel317=(($195+1)&4294967295); //@line 414 "phonemelist.cpp"
                  var $196=HEAPU8[($stresslevel317)]; //@line 414 "phonemelist.cpp"
                  var $conv318=((($196))&255); //@line 414 "phonemelist.cpp"
                  var $cmp319=((($conv318))|0) <= 1; //@line 414 "phonemelist.cpp"
                  if (!($cmp319)) { __label__ = 110;break $if_then298$$if_end362$127; } //@line 414 "phonemelist.cpp"
  
                  var $197=$plist3; //@line 416 "phonemelist.cpp"
                  var $wordstress321=(($197+2)&4294967295); //@line 416 "phonemelist.cpp"
                  var $198=HEAPU8[($wordstress321)]; //@line 416 "phonemelist.cpp"
                  var $conv322=((($198))&255); //@line 416 "phonemelist.cpp"
                  var $cmp323=((($conv322))|0) < 4; //@line 416 "phonemelist.cpp"
                  if ($cmp323) { __label__ = 98;; } else { __label__ = 99;; } //@line 416 "phonemelist.cpp"
                  if (__label__ == 98) {
  
                    var $199=$plist3; //@line 417 "phonemelist.cpp"
                    var $stresslevel325=(($199+1)&4294967295); //@line 417 "phonemelist.cpp"
                    HEAP8[($stresslevel325)]=0; //@line 417 "phonemelist.cpp"
                    ; //@line 417 "phonemelist.cpp"
                  }
  
                  var $200=$p; //@line 418 "phonemelist.cpp"
                  var $wordstress327=(($200+2)&4294967295); //@line 418 "phonemelist.cpp"
                  var $201=HEAPU8[($wordstress327)]; //@line 418 "phonemelist.cpp"
                  var $conv328=((($201))&255); //@line 418 "phonemelist.cpp"
                  var $cmp329=((($conv328))|0) < 4; //@line 418 "phonemelist.cpp"
                  if (!($cmp329)) { __label__ = 110;break $if_then298$$if_end362$127; } //@line 418 "phonemelist.cpp"
  
                  var $202=$p; //@line 419 "phonemelist.cpp"
                  var $stresslevel331=(($202+1)&4294967295); //@line 419 "phonemelist.cpp"
                  HEAP8[($stresslevel331)]=0; //@line 419 "phonemelist.cpp"
                  ; //@line 419 "phonemelist.cpp"
                }
                else if (__label__ == 102) {
  
                  var $203=$unstress_count; //@line 427 "phonemelist.cpp"
                  var $cmp338=((($203))|0) > 1; //@line 427 "phonemelist.cpp"
                  if (!($cmp338)) { __label__ = 110;break $if_then298$$if_end362$127; } //@line 427 "phonemelist.cpp"
  
                  var $204=$unstress_count; //@line 427 "phonemelist.cpp"
                  var $and340=($204) & 1; //@line 427 "phonemelist.cpp"
                  var $cmp341=((($and340))|0)==0; //@line 427 "phonemelist.cpp"
                  if (!($cmp341)) { __label__ = 110;break $if_then298$$if_end362$127; } //@line 427 "phonemelist.cpp"
  
                  var $205=$tr_addr; //@line 431 "phonemelist.cpp"
                  var $langopts343=(($205)&4294967295); //@line 431 "phonemelist.cpp"
                  var $stress_flags344=(($langopts343+12)&4294967295); //@line 431 "phonemelist.cpp"
                  var $206=HEAP32[(($stress_flags344)>>2)]; //@line 431 "phonemelist.cpp"
                  var $and345=($206) & 2; //@line 431 "phonemelist.cpp"
                  var $tobool346=((($and345))|0)!=0; //@line 431 "phonemelist.cpp"
                  if ($tobool346) { __label__ = 107;; } else { __label__ = 105;; } //@line 431 "phonemelist.cpp"
                  $if_then354$$lor_lhs_false347$146: do { 
                    if (__label__ == 105) {
  
                      var $207=$word_stress; //@line 431 "phonemelist.cpp"
                      var $cmp348=((($207))|0) > 3; //@line 431 "phonemelist.cpp"
                      if ($cmp348) { __label__ = 106;; } else { __label__ = 108;; } //@line 431 "phonemelist.cpp"
                      if (__label__ == 106) {
  
                        var $208=$plist3; //@line 431 "phonemelist.cpp"
                        var $add_ptr350=(($208+24)&4294967295); //@line 431 "phonemelist.cpp"
                        var $sourceix351=(($add_ptr350+6)&4294967295); //@line 431 "phonemelist.cpp"
                        var $209=HEAPU16[(($sourceix351)>>1)]; //@line 431 "phonemelist.cpp"
                        var $conv352=((($209))&65535); //@line 431 "phonemelist.cpp"
                        var $cmp353=((($conv352))|0)!=0; //@line 431 "phonemelist.cpp"
                        if ($cmp353) { __label__ = 107;break $if_then354$$lor_lhs_false347$146; } //@line 431 "phonemelist.cpp"
                      }
  
                      var $210=$plist3; //@line 438 "phonemelist.cpp"
                      var $stresslevel356=(($210+1)&4294967295); //@line 438 "phonemelist.cpp"
                      HEAP8[($stresslevel356)]=0; //@line 438 "phonemelist.cpp"
                      __label__ = 110;break $if_then298$$if_end362$127;
                    }
                  } while(0);
  
                  $unstress_count=1; //@line 434 "phonemelist.cpp"
                  ; //@line 435 "phonemelist.cpp"
                }
              }
              else if (__label__ == 109) {
  
                $unstress_count=0; //@line 445 "phonemelist.cpp"
                ;
              }
            }
          } while(0);
  
          var $211=$ph; //@line 493 "phonemelist.cpp"
          var $type363=(($211+11)&4294967295); //@line 493 "phonemelist.cpp"
          var $212=HEAPU8[($type363)]; //@line 493 "phonemelist.cpp"
          var $conv364=((($212))&255); //@line 493 "phonemelist.cpp"
          var $cmp365=((($conv364))|0)==2; //@line 493 "phonemelist.cpp"
          if ($cmp365) { __label__ = 111;; } else { __label__ = 112;; } //@line 493 "phonemelist.cpp"
          if (__label__ == 111) {
  
            $first_vowel=0; //@line 494 "phonemelist.cpp"
            ; //@line 494 "phonemelist.cpp"
          }
  
          var $213=$plist3; //@line 496 "phonemelist.cpp"
          var $add_ptr368=(($213+24)&4294967295); //@line 496 "phonemelist.cpp"
          var $synthflags369=(($add_ptr368+4)&4294967295); //@line 496 "phonemelist.cpp"
          var $214=HEAPU16[(($synthflags369)>>1)]; //@line 496 "phonemelist.cpp"
          var $conv370=((($214))&65535); //@line 496 "phonemelist.cpp"
          var $and371=($conv370) & 8; //@line 496 "phonemelist.cpp"
          var $tobool372=((($and371))|0)!=0; //@line 496 "phonemelist.cpp"
          if ($tobool372) { __label__ = 113;; } else { __label__ = 115;; } //@line 496 "phonemelist.cpp"
          $if_then373$$if_end387$157: do { 
            if (__label__ == 113) {
  
              var $215=$next; //@line 499 "phonemelist.cpp"
              var $type374=(($215+11)&4294967295); //@line 499 "phonemelist.cpp"
              var $216=HEAPU8[($type374)]; //@line 499 "phonemelist.cpp"
              var $conv375=((($216))&255); //@line 499 "phonemelist.cpp"
              var $call376=_strchr(((__ZZ15MakePhonemeListP10TranslatoriiE12types_double)&4294967295), $conv375); //@line 499 "phonemelist.cpp"
              var $tobool377=((($call376))|0)!=0; //@line 499 "phonemelist.cpp"
              if (!($tobool377)) { __label__ = 115;break $if_then373$$if_end387$157; } //@line 499 "phonemelist.cpp"
  
              var $217=$next; //@line 502 "phonemelist.cpp"
              var $code379=(($217+10)&4294967295); //@line 502 "phonemelist.cpp"
              var $218=HEAPU8[($code379)]; //@line 502 "phonemelist.cpp"
              var $conv380=((($218))&255); //@line 502 "phonemelist.cpp"
              $insert_ph=$conv380; //@line 502 "phonemelist.cpp"
              var $219=$plist3; //@line 503 "phonemelist.cpp"
              var $add_ptr381=(($219+24)&4294967295); //@line 503 "phonemelist.cpp"
              var $synthflags382=(($add_ptr381+4)&4294967295); //@line 503 "phonemelist.cpp"
              var $220=HEAPU16[(($synthflags382)>>1)]; //@line 503 "phonemelist.cpp"
              var $conv383=((($220))&65535); //@line 503 "phonemelist.cpp"
              var $xor384=($conv383) ^ 8; //@line 503 "phonemelist.cpp"
              var $conv385=((($xor384)) & 65535); //@line 503 "phonemelist.cpp"
              HEAP16[(($synthflags382)>>1)]=$conv385; //@line 503 "phonemelist.cpp"
              ; //@line 504 "phonemelist.cpp"
            }
          } while(0);
  
          var $221=$plist3; //@line 507 "phonemelist.cpp"
          var $add_ptr388=(($221+24)&4294967295); //@line 507 "phonemelist.cpp"
          var $sourceix389=(($add_ptr388+6)&4294967295); //@line 507 "phonemelist.cpp"
          var $222=HEAPU16[(($sourceix389)>>1)]; //@line 507 "phonemelist.cpp"
          var $conv390=((($222))&65535); //@line 507 "phonemelist.cpp"
          var $cmp391=((($conv390))|0)!=0; //@line 507 "phonemelist.cpp"
          if ($cmp391) { __label__ = 116;; } else { __label__ = 141;; } //@line 507 "phonemelist.cpp"
          $if_then392$$if_end471$161: do { 
            if (__label__ == 116) {
  
              var $223=$tr_addr; //@line 511 "phonemelist.cpp"
              var $langopts393=(($223)&4294967295); //@line 511 "phonemelist.cpp"
              var $vowel_pause=(($langopts393+4)&4294967295); //@line 511 "phonemelist.cpp"
              var $224=HEAP32[(($vowel_pause)>>2)]; //@line 511 "phonemelist.cpp"
              var $tobool394=((($224))|0)!=0; //@line 511 "phonemelist.cpp"
              if ($tobool394) { __label__ = 117;; } else { __label__ = 134;; } //@line 511 "phonemelist.cpp"
              $land_lhs_true395$$if_end450$163: do { 
                if (__label__ == 117) {
  
                  var $225=$ph; //@line 511 "phonemelist.cpp"
                  var $type396=(($225+11)&4294967295); //@line 511 "phonemelist.cpp"
                  var $226=HEAPU8[($type396)]; //@line 511 "phonemelist.cpp"
                  var $conv397=((($226))&255); //@line 511 "phonemelist.cpp"
                  var $cmp398=((($conv397))|0)!=0; //@line 511 "phonemelist.cpp"
                  if (!($cmp398)) { __label__ = 134;break $land_lhs_true395$$if_end450$163; } //@line 511 "phonemelist.cpp"
  
                  var $227=$ph; //@line 514 "phonemelist.cpp"
                  var $type400=(($227+11)&4294967295); //@line 514 "phonemelist.cpp"
                  var $228=HEAPU8[($type400)]; //@line 514 "phonemelist.cpp"
                  var $conv401=((($228))&255); //@line 514 "phonemelist.cpp"
                  var $cmp402=((($conv401))|0)!=2; //@line 514 "phonemelist.cpp"
                  if ($cmp402) { __label__ = 119;; } else { __label__ = 121;; } //@line 514 "phonemelist.cpp"
                  $land_lhs_true403$$if_end409$166: do { 
                    if (__label__ == 119) {
  
                      var $229=$tr_addr; //@line 514 "phonemelist.cpp"
                      var $langopts404=(($229)&4294967295); //@line 514 "phonemelist.cpp"
                      var $vowel_pause405=(($langopts404+4)&4294967295); //@line 514 "phonemelist.cpp"
                      var $230=HEAP32[(($vowel_pause405)>>2)]; //@line 514 "phonemelist.cpp"
                      var $and406=($230) & 512; //@line 514 "phonemelist.cpp"
                      var $tobool407=((($and406))|0)!=0; //@line 514 "phonemelist.cpp"
                      if (!($tobool407)) { __label__ = 121;break $land_lhs_true403$$if_end409$166; } //@line 514 "phonemelist.cpp"
  
                      $insert_ph=11; //@line 517 "phonemelist.cpp"
                      ; //@line 518 "phonemelist.cpp"
                    }
                  } while(0);
  
                  var $231=$next; //@line 520 "phonemelist.cpp"
                  var $type410=(($231+11)&4294967295); //@line 520 "phonemelist.cpp"
                  var $232=HEAPU8[($type410)]; //@line 520 "phonemelist.cpp"
                  var $conv411=((($232))&255); //@line 520 "phonemelist.cpp"
                  var $cmp412=((($conv411))|0)==2; //@line 520 "phonemelist.cpp"
                  if (!($cmp412)) { __label__ = 134;break $land_lhs_true395$$if_end450$163; } //@line 520 "phonemelist.cpp"
  
                  var $233=$tr_addr; //@line 522 "phonemelist.cpp"
                  var $langopts414=(($233)&4294967295); //@line 522 "phonemelist.cpp"
                  var $vowel_pause415=(($langopts414+4)&4294967295); //@line 522 "phonemelist.cpp"
                  var $234=HEAP32[(($vowel_pause415)>>2)]; //@line 522 "phonemelist.cpp"
                  var $and416=($234) & 12; //@line 522 "phonemelist.cpp"
                  $x=$and416; //@line 522 "phonemelist.cpp"
                  var $cmp417=((($and416))|0)!=0; //@line 522 "phonemelist.cpp"
                  if ($cmp417) { __label__ = 123;; } else { __label__ = 126;; } //@line 522 "phonemelist.cpp"
                  if (__label__ == 123) {
  
                    var $235=$x; //@line 525 "phonemelist.cpp"
                    var $cmp419=((($235))|0)==12; //@line 525 "phonemelist.cpp"
                    if ($cmp419) { __label__ = 124;; } else { __label__ = 125;; } //@line 525 "phonemelist.cpp"
                    if (__label__ == 124) {
  
                      $insert_ph=11; //@line 526 "phonemelist.cpp"
                      ; //@line 526 "phonemelist.cpp"
                    }
                    else if (__label__ == 125) {
  
                      $insert_ph=23; //@line 528 "phonemelist.cpp"
                      ;
                    }
                  }
  
                  var $236=$ph; //@line 531 "phonemelist.cpp"
                  var $type424=(($236+11)&4294967295); //@line 531 "phonemelist.cpp"
                  var $237=HEAPU8[($type424)]; //@line 531 "phonemelist.cpp"
                  var $conv425=((($237))&255); //@line 531 "phonemelist.cpp"
                  var $cmp426=((($conv425))|0)==2; //@line 531 "phonemelist.cpp"
                  if ($cmp426) { __label__ = 127;; } else { __label__ = 131;; } //@line 531 "phonemelist.cpp"
                  $land_lhs_true427$$if_end437$177: do { 
                    if (__label__ == 127) {
  
                      var $238=$tr_addr; //@line 531 "phonemelist.cpp"
                      var $langopts428=(($238)&4294967295); //@line 531 "phonemelist.cpp"
                      var $vowel_pause429=(($langopts428+4)&4294967295); //@line 531 "phonemelist.cpp"
                      var $239=HEAP32[(($vowel_pause429)>>2)]; //@line 531 "phonemelist.cpp"
                      var $and430=($239) & 3; //@line 531 "phonemelist.cpp"
                      $x=$and430; //@line 531 "phonemelist.cpp"
                      var $cmp431=((($and430))|0)!=0; //@line 531 "phonemelist.cpp"
                      if (!($cmp431)) { __label__ = 131;break $land_lhs_true427$$if_end437$177; } //@line 531 "phonemelist.cpp"
  
                      var $240=$x; //@line 534 "phonemelist.cpp"
                      var $cmp433=((($240))|0)==2; //@line 534 "phonemelist.cpp"
                      if ($cmp433) { __label__ = 129;; } else { __label__ = 130;; } //@line 534 "phonemelist.cpp"
                      if (__label__ == 129) {
  
                        $insert_ph=10; //@line 535 "phonemelist.cpp"
                        ; //@line 535 "phonemelist.cpp"
                      }
                      else if (__label__ == 130) {
  
                        $insert_ph=23; //@line 537 "phonemelist.cpp"
                        ;
                      }
                    }
                  } while(0);
  
                  var $241=$plist3; //@line 540 "phonemelist.cpp"
                  var $add_ptr438=(($241+24)&4294967295); //@line 540 "phonemelist.cpp"
                  var $stresslevel439=(($add_ptr438+1)&4294967295); //@line 540 "phonemelist.cpp"
                  var $242=HEAPU8[($stresslevel439)]; //@line 540 "phonemelist.cpp"
                  var $conv440=((($242))&255); //@line 540 "phonemelist.cpp"
                  var $cmp441=((($conv440))|0) >= 4; //@line 540 "phonemelist.cpp"
                  if (!($cmp441)) { __label__ = 134;break $land_lhs_true395$$if_end450$163; } //@line 540 "phonemelist.cpp"
  
                  var $243=$tr_addr; //@line 540 "phonemelist.cpp"
                  var $langopts443=(($243)&4294967295); //@line 540 "phonemelist.cpp"
                  var $vowel_pause444=(($langopts443+4)&4294967295); //@line 540 "phonemelist.cpp"
                  var $244=HEAP32[(($vowel_pause444)>>2)]; //@line 540 "phonemelist.cpp"
                  var $and445=($244) & 256; //@line 540 "phonemelist.cpp"
                  var $tobool446=((($and445))|0)!=0; //@line 540 "phonemelist.cpp"
                  if (!($tobool446)) { __label__ = 134;break $land_lhs_true395$$if_end450$163; } //@line 540 "phonemelist.cpp"
  
                  $insert_ph=10; //@line 543 "phonemelist.cpp"
                  ; //@line 544 "phonemelist.cpp"
                }
              } while(0);
  
              var $245=$plist3; //@line 548 "phonemelist.cpp"
              var $246=$plist3_inserted; //@line 548 "phonemelist.cpp"
              var $cmp451=((($245))|0)!=((($246))|0); //@line 548 "phonemelist.cpp"
              if (!($cmp451)) { __label__ = 141;break $if_then392$$if_end471$161; } //@line 548 "phonemelist.cpp"
  
              var $247=$tr_addr; //@line 550 "phonemelist.cpp"
              var $langopts453=(($247)&4294967295); //@line 550 "phonemelist.cpp"
              var $word_gap=(($langopts453)&4294967295); //@line 550 "phonemelist.cpp"
              var $248=HEAP32[(($word_gap)>>2)]; //@line 550 "phonemelist.cpp"
              var $and454=($248) & 7; //@line 550 "phonemelist.cpp"
              $x=$and454; //@line 550 "phonemelist.cpp"
              var $cmp455=((($and454))|0)!=0; //@line 550 "phonemelist.cpp"
              if ($cmp455) { __label__ = 136;; } else { __label__ = 139;; } //@line 550 "phonemelist.cpp"
              $if_then456$$if_end466$188: do { 
                if (__label__ == 136) {
  
                  var $249=$x; //@line 552 "phonemelist.cpp"
                  var $cmp457=((($249))|0) > 1; //@line 552 "phonemelist.cpp"
                  if ($cmp457) { __label__ = 138;; } else { __label__ = 137;; } //@line 552 "phonemelist.cpp"
                  if (__label__ == 137) {
  
                    var $250=$insert_ph; //@line 552 "phonemelist.cpp"
                    var $cmp459=((($250))|0)!=10; //@line 552 "phonemelist.cpp"
                    var $251=$insert_ph; //@line 552 "phonemelist.cpp"
                    var $cmp461=((($251))|0)!=11; //@line 552 "phonemelist.cpp"
                    var $or_cond3=($cmp459) & ($cmp461); //@line 552 "phonemelist.cpp"
                    if (!($or_cond3)) { __label__ = 139;break $if_then456$$if_end466$188; } //@line 552 "phonemelist.cpp"
                  }
  
                  var $252=$x; //@line 555 "phonemelist.cpp"
                  var $arrayidx463=((_pause_phonemes+$252)&4294967295); //@line 555 "phonemelist.cpp"
                  var $253=HEAPU8[($arrayidx463)]; //@line 555 "phonemelist.cpp"
                  var $conv464=((($253))&255); //@line 555 "phonemelist.cpp"
                  $insert_ph=$conv464; //@line 555 "phonemelist.cpp"
                  ; //@line 556 "phonemelist.cpp"
                }
              } while(0);
  
              var $254=HEAP32[((_option_wordgap)>>2)]; //@line 558 "phonemelist.cpp"
              var $cmp467=((($254))|0) > 0; //@line 558 "phonemelist.cpp"
              if (!($cmp467)) { __label__ = 141;break $if_then392$$if_end471$161; } //@line 558 "phonemelist.cpp"
  
              $insert_ph=24; //@line 560 "phonemelist.cpp"
              ; //@line 561 "phonemelist.cpp"
            }
          } while(0);
  
          var $255=$plist3; //@line 565 "phonemelist.cpp"
          var $arrayidx472=(($255+48)&4294967295); //@line 565 "phonemelist.cpp"
          var $phcode473=(($arrayidx472)&4294967295); //@line 565 "phonemelist.cpp"
          var $256=HEAPU8[($phcode473)]; //@line 565 "phonemelist.cpp"
          var $idxprom474=((($256))&255); //@line 565 "phonemelist.cpp"
          var $arrayidx475=((_phoneme_tab+$idxprom474*4)&4294967295); //@line 565 "phonemelist.cpp"
          var $257=HEAP32[(($arrayidx475)>>2)]; //@line 565 "phonemelist.cpp"
          $next2=$257; //@line 565 "phonemelist.cpp"
          var $258=$next2; //@line 566 "phonemelist.cpp"
          var $259=$plist3; //@line 566 "phonemelist.cpp"
          var $arrayidx476=(($259+48)&4294967295); //@line 566 "phonemelist.cpp"
          var $ph477=(($arrayidx476+8)&4294967295); //@line 566 "phonemelist.cpp"
          HEAP32[(($ph477)>>2)]=$258; //@line 566 "phonemelist.cpp"
          var $260=$insert_ph; //@line 568 "phonemelist.cpp"
          var $cmp478=((($260))|0)==0; //@line 568 "phonemelist.cpp"
          if ($cmp478) { __label__ = 142;; } else { __label__ = 144;; } //@line 568 "phonemelist.cpp"
          $land_lhs_true479$$if_end486$196: do { 
            if (__label__ == 142) {
  
              var $261=HEAP32[(($arrayidx481)>>2)]; //@line 568 "phonemelist.cpp"
              var $cmp482=((($261))|0)!=0; //@line 568 "phonemelist.cpp"
              if (!($cmp482)) { __label__ = 144;break $land_lhs_true479$$if_end486$196; } //@line 568 "phonemelist.cpp"
  
              var $262=HEAP32[(($arrayidx485)>>2)]; //@line 570 "phonemelist.cpp"
              $insert_ph=$262; //@line 570 "phonemelist.cpp"
              ; //@line 571 "phonemelist.cpp"
            }
          } while(0);
  
          var $263=$ph; //@line 581 "phonemelist.cpp"
          var $264=$ix; //@line 581 "phonemelist.cpp"
          var $265=$phlist; //@line 581 "phonemelist.cpp"
          var $arrayidx491=(($265+24*$264)&4294967295); //@line 581 "phonemelist.cpp"
          var $ph492=(($arrayidx491+8)&4294967295); //@line 581 "phonemelist.cpp"
          HEAP32[(($ph492)>>2)]=$263; //@line 581 "phonemelist.cpp"
          var $266=$ph; //@line 582 "phonemelist.cpp"
          var $type493=(($266+11)&4294967295); //@line 582 "phonemelist.cpp"
          var $267=HEAP8[($type493)]; //@line 582 "phonemelist.cpp"
          var $268=$ix; //@line 582 "phonemelist.cpp"
          var $269=$phlist; //@line 582 "phonemelist.cpp"
          var $arrayidx494=(($269+24*$268)&4294967295); //@line 582 "phonemelist.cpp"
          var $type495=(($arrayidx494+15)&4294967295); //@line 582 "phonemelist.cpp"
          HEAP8[($type495)]=$267; //@line 582 "phonemelist.cpp"
          var $270=$ix; //@line 583 "phonemelist.cpp"
          var $271=$phlist; //@line 583 "phonemelist.cpp"
          var $arrayidx496=(($271+24*$270)&4294967295); //@line 583 "phonemelist.cpp"
          var $env=(($arrayidx496+14)&4294967295); //@line 583 "phonemelist.cpp"
          HEAP8[($env)]=0; //@line 583 "phonemelist.cpp"
          var $272=$plist3; //@line 584 "phonemelist.cpp"
          var $synthflags497=(($272+4)&4294967295); //@line 584 "phonemelist.cpp"
          var $273=HEAPU16[(($synthflags497)>>1)]; //@line 584 "phonemelist.cpp"
          var $conv498=((($273))&65535); //@line 584 "phonemelist.cpp"
          var $274=$switched_language; //@line 584 "phonemelist.cpp"
          var $or499=($conv498) | ($274); //@line 584 "phonemelist.cpp"
          var $conv500=((($or499)) & 65535); //@line 584 "phonemelist.cpp"
          var $275=$ix; //@line 584 "phonemelist.cpp"
          var $276=$phlist; //@line 584 "phonemelist.cpp"
          var $arrayidx501=(($276+24*$275)&4294967295); //@line 584 "phonemelist.cpp"
          var $synthflags502=(($arrayidx501+4)&4294967295); //@line 584 "phonemelist.cpp"
          HEAP16[(($synthflags502)>>1)]=$conv500; //@line 584 "phonemelist.cpp"
          var $277=$plist3; //@line 585 "phonemelist.cpp"
          var $stresslevel503=(($277+1)&4294967295); //@line 585 "phonemelist.cpp"
          var $278=HEAPU8[($stresslevel503)]; //@line 585 "phonemelist.cpp"
          var $conv504=((($278))&255); //@line 585 "phonemelist.cpp"
          var $and505=($conv504) & 15; //@line 585 "phonemelist.cpp"
          var $conv506=((($and505)) & 255); //@line 585 "phonemelist.cpp"
          var $279=$ix; //@line 585 "phonemelist.cpp"
          var $280=$phlist; //@line 585 "phonemelist.cpp"
          var $arrayidx507=(($280+24*$279)&4294967295); //@line 585 "phonemelist.cpp"
          var $stresslevel508=(($arrayidx507+1)&4294967295); //@line 585 "phonemelist.cpp"
          HEAP8[($stresslevel508)]=$conv506; //@line 585 "phonemelist.cpp"
          var $281=$plist3; //@line 586 "phonemelist.cpp"
          var $wordstress509=(($281+2)&4294967295); //@line 586 "phonemelist.cpp"
          var $282=HEAP8[($wordstress509)]; //@line 586 "phonemelist.cpp"
          var $283=$ix; //@line 586 "phonemelist.cpp"
          var $284=$phlist; //@line 586 "phonemelist.cpp"
          var $arrayidx510=(($284+24*$283)&4294967295); //@line 586 "phonemelist.cpp"
          var $wordstress511=(($arrayidx510+2)&4294967295); //@line 586 "phonemelist.cpp"
          HEAP8[($wordstress511)]=$282; //@line 586 "phonemelist.cpp"
          var $285=$plist3; //@line 587 "phonemelist.cpp"
          var $tone_ph512=(($285+3)&4294967295); //@line 587 "phonemelist.cpp"
          var $286=HEAP8[($tone_ph512)]; //@line 587 "phonemelist.cpp"
          var $287=$ix; //@line 587 "phonemelist.cpp"
          var $288=$phlist; //@line 587 "phonemelist.cpp"
          var $arrayidx513=(($288+24*$287)&4294967295); //@line 587 "phonemelist.cpp"
          var $tone_ph514=(($arrayidx513+3)&4294967295); //@line 587 "phonemelist.cpp"
          HEAP8[($tone_ph514)]=$286; //@line 587 "phonemelist.cpp"
          var $289=$ix; //@line 588 "phonemelist.cpp"
          var $290=$phlist; //@line 588 "phonemelist.cpp"
          var $arrayidx515=(($290+24*$289)&4294967295); //@line 588 "phonemelist.cpp"
          var $sourceix516=(($arrayidx515+6)&4294967295); //@line 588 "phonemelist.cpp"
          HEAP16[(($sourceix516)>>1)]=0; //@line 588 "phonemelist.cpp"
          var $291=$ph; //@line 589 "phonemelist.cpp"
          var $code517=(($291+10)&4294967295); //@line 589 "phonemelist.cpp"
          var $292=HEAP8[($code517)]; //@line 589 "phonemelist.cpp"
          var $293=$ix; //@line 589 "phonemelist.cpp"
          var $294=$phlist; //@line 589 "phonemelist.cpp"
          var $arrayidx518=(($294+24*$293)&4294967295); //@line 589 "phonemelist.cpp"
          var $phcode519=(($arrayidx518)&4294967295); //@line 589 "phonemelist.cpp"
          HEAP8[($phcode519)]=$292; //@line 589 "phonemelist.cpp"
          var $295=$plist3; //@line 591 "phonemelist.cpp"
          var $sourceix520=(($295+6)&4294967295); //@line 591 "phonemelist.cpp"
          var $296=HEAPU16[(($sourceix520)>>1)]; //@line 591 "phonemelist.cpp"
          var $conv521=((($296))&65535); //@line 591 "phonemelist.cpp"
          var $cmp522=((($conv521))|0)!=0; //@line 591 "phonemelist.cpp"
          if ($cmp522) { __label__ = 145;; } else { __label__ = 147;; } //@line 591 "phonemelist.cpp"
          $if_then523$$if_else533$200: do { 
            if (__label__ == 145) {
  
              var $297=$plist3; //@line 593 "phonemelist.cpp"
              var $sourceix524=(($297+6)&4294967295); //@line 593 "phonemelist.cpp"
              var $298=HEAP16[(($sourceix524)>>1)]; //@line 593 "phonemelist.cpp"
              var $299=$ix; //@line 593 "phonemelist.cpp"
              var $300=$phlist; //@line 593 "phonemelist.cpp"
              var $arrayidx525=(($300+24*$299)&4294967295); //@line 593 "phonemelist.cpp"
              var $sourceix526=(($arrayidx525+6)&4294967295); //@line 593 "phonemelist.cpp"
              HEAP16[(($sourceix526)>>1)]=$298; //@line 593 "phonemelist.cpp"
              var $301=$ix; //@line 594 "phonemelist.cpp"
              var $302=$phlist; //@line 594 "phonemelist.cpp"
              var $arrayidx527=(($302+24*$301)&4294967295); //@line 594 "phonemelist.cpp"
              var $newword=(($arrayidx527+19)&4294967295); //@line 594 "phonemelist.cpp"
              HEAP8[($newword)]=1; //@line 594 "phonemelist.cpp"
              var $303=$start_sentence_addr; //@line 596 "phonemelist.cpp"
              var $tobool528=((($303))|0)!=0; //@line 596 "phonemelist.cpp"
              if (!($tobool528)) { __label__ = 148;break $if_then523$$if_else533$200; } //@line 596 "phonemelist.cpp"
  
              var $304=$ix; //@line 598 "phonemelist.cpp"
              var $305=$phlist; //@line 598 "phonemelist.cpp"
              var $arrayidx530=(($305+24*$304)&4294967295); //@line 598 "phonemelist.cpp"
              var $newword531=(($arrayidx530+19)&4294967295); //@line 598 "phonemelist.cpp"
              HEAP8[($newword531)]=5; //@line 598 "phonemelist.cpp"
              $start_sentence_addr=0; //@line 599 "phonemelist.cpp"
              ; //@line 600 "phonemelist.cpp"
            }
            else if (__label__ == 147) {
  
              var $306=$ix; //@line 604 "phonemelist.cpp"
              var $307=$phlist; //@line 604 "phonemelist.cpp"
              var $arrayidx534=(($307+24*$306)&4294967295); //@line 604 "phonemelist.cpp"
              var $newword535=(($arrayidx534+19)&4294967295); //@line 604 "phonemelist.cpp"
              HEAP8[($newword535)]=0; //@line 604 "phonemelist.cpp"
              ;
            }
          } while(0);
  
          var $308=HEAP32[(($arrayidx538)>>2)]; //@line 608 "phonemelist.cpp"
          var $mul=((($308)*2)&4294967295); //@line 608 "phonemelist.cpp"
          var $conv539=((($mul)) & 65535); //@line 608 "phonemelist.cpp"
          var $309=$ix; //@line 608 "phonemelist.cpp"
          var $310=$phlist; //@line 608 "phonemelist.cpp"
          var $arrayidx540=(($310+24*$309)&4294967295); //@line 608 "phonemelist.cpp"
          var $length=(($arrayidx540+12)&4294967295); //@line 608 "phonemelist.cpp"
          HEAP16[(($length)>>1)]=$conv539; //@line 608 "phonemelist.cpp"
          var $311=$ph; //@line 609 "phonemelist.cpp"
          var $code541=(($311+10)&4294967295); //@line 609 "phonemelist.cpp"
          var $312=HEAPU8[($code541)]; //@line 609 "phonemelist.cpp"
          var $conv542=((($312))&255); //@line 609 "phonemelist.cpp"
          var $cmp543=((($conv542))|0)==24; //@line 609 "phonemelist.cpp"
          var $313=HEAP32[((_option_wordgap)>>2)]; //@line 609 "phonemelist.cpp"
          var $cmp545=((($313))|0) > 0; //@line 609 "phonemelist.cpp"
          var $or_cond4=($cmp543) & ($cmp545); //@line 609 "phonemelist.cpp"
          if ($or_cond4) { __label__ = 149;; } else { __label__ = 150;; } //@line 609 "phonemelist.cpp"
          if (__label__ == 149) {
  
            var $314=HEAP32[((((_phoneme_tab+40)&4294967295))>>2)]; //@line 611 "phonemelist.cpp"
            var $315=$ix; //@line 611 "phonemelist.cpp"
            var $316=$phlist; //@line 611 "phonemelist.cpp"
            var $arrayidx547=(($316+24*$315)&4294967295); //@line 611 "phonemelist.cpp"
            var $ph548=(($arrayidx547+8)&4294967295); //@line 611 "phonemelist.cpp"
            HEAP32[(($ph548)>>2)]=$314; //@line 611 "phonemelist.cpp"
            var $317=HEAP32[((_option_wordgap)>>2)]; //@line 612 "phonemelist.cpp"
            var $mul549=((($317)*14)&4294967295); //@line 612 "phonemelist.cpp"
            var $conv550=((($mul549)) & 65535); //@line 612 "phonemelist.cpp"
            var $318=$ix; //@line 612 "phonemelist.cpp"
            var $319=$phlist; //@line 612 "phonemelist.cpp"
            var $arrayidx551=(($319+24*$318)&4294967295); //@line 612 "phonemelist.cpp"
            var $length552=(($arrayidx551+12)&4294967295); //@line 612 "phonemelist.cpp"
            HEAP16[(($length552)>>1)]=$conv550; //@line 612 "phonemelist.cpp"
            ; //@line 613 "phonemelist.cpp"
          }
  
          var $320=$ph; //@line 615 "phonemelist.cpp"
          var $type554=(($320+11)&4294967295); //@line 615 "phonemelist.cpp"
          var $321=HEAPU8[($type554)]; //@line 615 "phonemelist.cpp"
          var $conv555=((($321))&255); //@line 615 "phonemelist.cpp"
          var $cmp556=((($conv555))|0)==2; //@line 615 "phonemelist.cpp"
          if ($cmp556) { __label__ = 155;; } else { __label__ = 151;; } //@line 615 "phonemelist.cpp"
          $if_then573$$lor_lhs_false557$208: do { 
            if (__label__ == 151) {
  
              var $322=$ph; //@line 615 "phonemelist.cpp"
              var $type558=(($322+11)&4294967295); //@line 615 "phonemelist.cpp"
              var $323=HEAPU8[($type558)]; //@line 615 "phonemelist.cpp"
              var $conv559=((($323))&255); //@line 615 "phonemelist.cpp"
              var $cmp560=((($conv559))|0)==3; //@line 615 "phonemelist.cpp"
              if ($cmp560) { __label__ = 155;break $if_then573$$lor_lhs_false557$208; } //@line 615 "phonemelist.cpp"
  
              var $324=$ph; //@line 615 "phonemelist.cpp"
              var $type562=(($324+11)&4294967295); //@line 615 "phonemelist.cpp"
              var $325=HEAPU8[($type562)]; //@line 615 "phonemelist.cpp"
              var $conv563=((($325))&255); //@line 615 "phonemelist.cpp"
              var $cmp564=((($conv563))|0)==8; //@line 615 "phonemelist.cpp"
              if ($cmp564) { __label__ = 155;break $if_then573$$lor_lhs_false557$208; } //@line 615 "phonemelist.cpp"
  
              var $326=$ph; //@line 615 "phonemelist.cpp"
              var $type566=(($326+11)&4294967295); //@line 615 "phonemelist.cpp"
              var $327=HEAPU8[($type566)]; //@line 615 "phonemelist.cpp"
              var $conv567=((($327))&255); //@line 615 "phonemelist.cpp"
              var $cmp568=((($conv567))|0)==5; //@line 615 "phonemelist.cpp"
              if ($cmp568) { __label__ = 155;break $if_then573$$lor_lhs_false557$208; } //@line 615 "phonemelist.cpp"
  
              var $328=$ph; //@line 615 "phonemelist.cpp"
              var $type570=(($328+11)&4294967295); //@line 615 "phonemelist.cpp"
              var $329=HEAPU8[($type570)]; //@line 615 "phonemelist.cpp"
              var $conv571=((($329))&255); //@line 615 "phonemelist.cpp"
              var $cmp572=((($conv571))|0)==7; //@line 615 "phonemelist.cpp"
              if ($cmp572) { __label__ = 155;break $if_then573$$lor_lhs_false557$208; } else { __label__ = 156;break $if_then573$$lor_lhs_false557$208; } //@line 615 "phonemelist.cpp"
            }
          } while(0);
          if (__label__ == 155) {
  
            var $330=$ix; //@line 617 "phonemelist.cpp"
            var $331=$phlist; //@line 617 "phonemelist.cpp"
            var $arrayidx574=(($331+24*$330)&4294967295); //@line 617 "phonemelist.cpp"
            var $length575=(($arrayidx574+12)&4294967295); //@line 617 "phonemelist.cpp"
            HEAP16[(($length575)>>1)]=128; //@line 617 "phonemelist.cpp"
            var $332=$ix; //@line 618 "phonemelist.cpp"
            var $333=$phlist; //@line 618 "phonemelist.cpp"
            var $arrayidx576=(($333+24*$332)&4294967295); //@line 618 "phonemelist.cpp"
            var $env577=(($arrayidx576+14)&4294967295); //@line 618 "phonemelist.cpp"
            HEAP8[($env577)]=0; //@line 618 "phonemelist.cpp"
            ; //@line 619 "phonemelist.cpp"
          }
  
          var $334=$ix; //@line 621 "phonemelist.cpp"
          var $335=$phlist; //@line 621 "phonemelist.cpp"
          var $arrayidx579=(($335+24*$334)&4294967295); //@line 621 "phonemelist.cpp"
          var $prepause=(($arrayidx579+16)&4294967295); //@line 621 "phonemelist.cpp"
          HEAP8[($prepause)]=0; //@line 621 "phonemelist.cpp"
          var $336=$ix; //@line 622 "phonemelist.cpp"
          var $337=$phlist; //@line 622 "phonemelist.cpp"
          var $arrayidx580=(($337+24*$336)&4294967295); //@line 622 "phonemelist.cpp"
          var $amp=(($arrayidx580+18)&4294967295); //@line 622 "phonemelist.cpp"
          HEAP8[($amp)]=20; //@line 622 "phonemelist.cpp"
          var $338=$ix; //@line 623 "phonemelist.cpp"
          var $339=$phlist; //@line 623 "phonemelist.cpp"
          var $arrayidx581=(($339+24*$338)&4294967295); //@line 623 "phonemelist.cpp"
          var $pitch1=(($arrayidx581+20)&4294967295); //@line 623 "phonemelist.cpp"
          HEAP8[($pitch1)]=-1; //@line 623 "phonemelist.cpp"
          var $340=$ix; //@line 624 "phonemelist.cpp"
          var $341=$phlist; //@line 624 "phonemelist.cpp"
          var $arrayidx582=(($341+24*$340)&4294967295); //@line 624 "phonemelist.cpp"
          var $pitch2=(($arrayidx582+21)&4294967295); //@line 624 "phonemelist.cpp"
          HEAP8[($pitch2)]=-1; //@line 624 "phonemelist.cpp"
          var $342=$ix; //@line 625 "phonemelist.cpp"
          var $inc583=((($342)+1)&4294967295); //@line 625 "phonemelist.cpp"
          $ix=$inc583; //@line 625 "phonemelist.cpp"
          ; //@line 626 "phonemelist.cpp"
        }
      } while(0);
  
      var $343=$j; //@line 301 "phonemelist.cpp"
      var $inc585=((($343)+1)&4294967295); //@line 301 "phonemelist.cpp"
      $j=$inc585; //@line 301 "phonemelist.cpp"
      __label__ = 65;continue $for_cond185$91; //@line 301 "phonemelist.cpp"
    }
  
    var $344=$ix; //@line 627 "phonemelist.cpp"
    var $345=$phlist; //@line 627 "phonemelist.cpp"
    var $arrayidx587=(($345+24*$344)&4294967295); //@line 627 "phonemelist.cpp"
    var $newword588=(($arrayidx587+19)&4294967295); //@line 627 "phonemelist.cpp"
    HEAP8[($newword588)]=2; //@line 627 "phonemelist.cpp"
    var $346=$ix; //@line 629 "phonemelist.cpp"
    var $347=$phlist; //@line 629 "phonemelist.cpp"
    var $arrayidx589=(($347+24*$346)&4294967295); //@line 629 "phonemelist.cpp"
    var $phcode590=(($arrayidx589)&4294967295); //@line 629 "phonemelist.cpp"
    HEAP8[($phcode590)]=9; //@line 629 "phonemelist.cpp"
    var $348=$ix; //@line 630 "phonemelist.cpp"
    var $349=$phlist; //@line 630 "phonemelist.cpp"
    var $arrayidx591=(($349+24*$348)&4294967295); //@line 630 "phonemelist.cpp"
    var $type592=(($arrayidx591+15)&4294967295); //@line 630 "phonemelist.cpp"
    HEAP8[($type592)]=0; //@line 630 "phonemelist.cpp"
    var $350=$post_pause_addr; //@line 631 "phonemelist.cpp"
    var $conv593=((($350)) & 65535); //@line 631 "phonemelist.cpp"
    var $351=$ix; //@line 631 "phonemelist.cpp"
    var $352=$phlist; //@line 631 "phonemelist.cpp"
    var $arrayidx594=(($352+24*$351)&4294967295); //@line 631 "phonemelist.cpp"
    var $length595=(($arrayidx594+12)&4294967295); //@line 631 "phonemelist.cpp"
    HEAP16[(($length595)>>1)]=$conv593; //@line 631 "phonemelist.cpp"
    var $353=$end_sourceix; //@line 632 "phonemelist.cpp"
    var $conv596=((($353)) & 65535); //@line 632 "phonemelist.cpp"
    var $354=$ix; //@line 632 "phonemelist.cpp"
    var $355=$phlist; //@line 632 "phonemelist.cpp"
    var $arrayidx597=(($355+24*$354)&4294967295); //@line 632 "phonemelist.cpp"
    var $sourceix598=(($arrayidx597+6)&4294967295); //@line 632 "phonemelist.cpp"
    HEAP16[(($sourceix598)>>1)]=$conv596; //@line 632 "phonemelist.cpp"
    var $356=$ix; //@line 633 "phonemelist.cpp"
    var $357=$phlist; //@line 633 "phonemelist.cpp"
    var $arrayidx599=(($357+24*$356)&4294967295); //@line 633 "phonemelist.cpp"
    var $synthflags600=(($arrayidx599+4)&4294967295); //@line 633 "phonemelist.cpp"
    HEAP16[(($synthflags600)>>1)]=0; //@line 633 "phonemelist.cpp"
    var $358=HEAP32[((((_phoneme_tab+36)&4294967295))>>2)]; //@line 634 "phonemelist.cpp"
    var $359=$ix; //@line 634 "phonemelist.cpp"
    var $inc601=((($359)+1)&4294967295); //@line 634 "phonemelist.cpp"
    $ix=$inc601; //@line 634 "phonemelist.cpp"
    var $360=$phlist; //@line 634 "phonemelist.cpp"
    var $arrayidx602=(($360+24*$359)&4294967295); //@line 634 "phonemelist.cpp"
    var $ph603=(($arrayidx602+8)&4294967295); //@line 634 "phonemelist.cpp"
    HEAP32[(($ph603)>>2)]=$358; //@line 634 "phonemelist.cpp"
    var $361=$ix; //@line 636 "phonemelist.cpp"
    var $362=$phlist; //@line 636 "phonemelist.cpp"
    var $arrayidx604=(($362+24*$361)&4294967295); //@line 636 "phonemelist.cpp"
    var $phcode605=(($arrayidx604)&4294967295); //@line 636 "phonemelist.cpp"
    HEAP8[($phcode605)]=9; //@line 636 "phonemelist.cpp"
    var $363=$ix; //@line 637 "phonemelist.cpp"
    var $364=$phlist; //@line 637 "phonemelist.cpp"
    var $arrayidx606=(($364+24*$363)&4294967295); //@line 637 "phonemelist.cpp"
    var $type607=(($arrayidx606+15)&4294967295); //@line 637 "phonemelist.cpp"
    HEAP8[($type607)]=0; //@line 637 "phonemelist.cpp"
    var $365=$ix; //@line 638 "phonemelist.cpp"
    var $366=$phlist; //@line 638 "phonemelist.cpp"
    var $arrayidx608=(($366+24*$365)&4294967295); //@line 638 "phonemelist.cpp"
    var $length609=(($arrayidx608+12)&4294967295); //@line 638 "phonemelist.cpp"
    HEAP16[(($length609)>>1)]=0; //@line 638 "phonemelist.cpp"
    var $367=$ix; //@line 639 "phonemelist.cpp"
    var $368=$phlist; //@line 639 "phonemelist.cpp"
    var $arrayidx610=(($368+24*$367)&4294967295); //@line 639 "phonemelist.cpp"
    var $sourceix611=(($arrayidx610+6)&4294967295); //@line 639 "phonemelist.cpp"
    HEAP16[(($sourceix611)>>1)]=0; //@line 639 "phonemelist.cpp"
    var $369=$ix; //@line 640 "phonemelist.cpp"
    var $370=$phlist; //@line 640 "phonemelist.cpp"
    var $arrayidx612=(($370+24*$369)&4294967295); //@line 640 "phonemelist.cpp"
    var $synthflags613=(($arrayidx612+4)&4294967295); //@line 640 "phonemelist.cpp"
    HEAP16[(($synthflags613)>>1)]=0; //@line 640 "phonemelist.cpp"
    var $371=HEAP32[((((_phoneme_tab+40)&4294967295))>>2)]; //@line 641 "phonemelist.cpp"
    var $372=$ix; //@line 641 "phonemelist.cpp"
    var $inc614=((($372)+1)&4294967295); //@line 641 "phonemelist.cpp"
    $ix=$inc614; //@line 641 "phonemelist.cpp"
    var $373=$phlist; //@line 641 "phonemelist.cpp"
    var $arrayidx615=(($373+24*$372)&4294967295); //@line 641 "phonemelist.cpp"
    var $ph616=(($arrayidx615+8)&4294967295); //@line 641 "phonemelist.cpp"
    HEAP32[(($ph616)>>2)]=$371; //@line 641 "phonemelist.cpp"
    var $374=$ix; //@line 643 "phonemelist.cpp"
    HEAP32[((_n_phoneme_list)>>2)]=$374; //@line 643 "phonemelist.cpp"
    STACKTOP = __stackBase__;
    return; //@line 644 "phonemelist.cpp"
    return;
  }
  

  function __ZL18SubstitutePhonemesP10TranslatorP12PHONEME_LIST($tr, $plist_out) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $tr_addr;
    var $plist_out_addr;
    var $ix;
    var $k;
    var $replace_flags;
    var $n_plist_out;
    var $word_end;
    var $switched_language;
    var $plist2;
    var $next;
    $tr_addr=$tr;
    $plist_out_addr=$plist_out;
    $n_plist_out=0; //@line 48 "phonemelist.cpp"
    $switched_language=0; //@line 50 "phonemelist.cpp"
    $next=0; //@line 52 "phonemelist.cpp"
    $ix=0; //@line 54 "phonemelist.cpp"
    ; //@line 54 "phonemelist.cpp"
    $for_cond$2: while(1) { 
  
      var $0=$ix; //@line 54 "phonemelist.cpp"
      var $1=HEAP32[((_n_ph_list2)>>2)]; //@line 54 "phonemelist.cpp"
      var $cmp=((($0))|0) < ((($1))|0); //@line 54 "phonemelist.cpp"
      if (!($cmp)) { __label__ = 26;break $for_cond$2; } //@line 54 "phonemelist.cpp"
  
      var $2=$n_plist_out; //@line 54 "phonemelist.cpp"
      var $cmp1=((($2))|0) < 1000; //@line 54 "phonemelist.cpp"
      if (!($cmp1)) { __label__ = 26;break $for_cond$2; }
  
      var $3=$ix; //@line 56 "phonemelist.cpp"
      var $arrayidx=((_ph_list2+$3*8)&4294967295); //@line 56 "phonemelist.cpp"
      $plist2=$arrayidx; //@line 56 "phonemelist.cpp"
      var $4=$plist2; //@line 58 "phonemelist.cpp"
      var $phcode=(($4)&4294967295); //@line 58 "phonemelist.cpp"
      var $5=HEAPU8[($phcode)]; //@line 58 "phonemelist.cpp"
      var $conv=((($5))&255); //@line 58 "phonemelist.cpp"
      var $cmp2=((($conv))|0)==21; //@line 58 "phonemelist.cpp"
      var $6=$switched_language; //@line 59 "phonemelist.cpp"
      if ($cmp2) { __lastLabel__ = 3; __label__ = 4;; } else { __lastLabel__ = 3; __label__ = 5;; } //@line 58 "phonemelist.cpp"
      if (__label__ == 4) {
  
        var $xor=($6) ^ 1; //@line 59 "phonemelist.cpp"
        $switched_language=$xor; //@line 59 "phonemelist.cpp"
        __lastLabel__ = 4; ; //@line 59 "phonemelist.cpp"
      }
  
      var $7=__lastLabel__ == 4 ? $xor : ($6); //@line 62 "phonemelist.cpp"
      var $cmp3=((($7))|0)==0; //@line 62 "phonemelist.cpp"
      if ($cmp3) { __label__ = 6;; } else { __label__ = 24;; } //@line 62 "phonemelist.cpp"
      $if_then4$$if_end61$9: do { 
        if (__label__ == 6) {
  
          var $8=$ix; //@line 64 "phonemelist.cpp"
          var $9=HEAP32[((_n_ph_list2)>>2)]; //@line 64 "phonemelist.cpp"
          var $sub=((($9)-1)&4294967295); //@line 64 "phonemelist.cpp"
          var $cmp5=((($8))|0) < ((($sub))|0); //@line 64 "phonemelist.cpp"
          if ($cmp5) { __label__ = 7;; } else { __label__ = 8;; } //@line 64 "phonemelist.cpp"
          if (__label__ == 7) {
  
            var $10=$ix; //@line 65 "phonemelist.cpp"
            var $add=((($10)+1)&4294967295); //@line 65 "phonemelist.cpp"
            var $arrayidx7=((_ph_list2+$add*8)&4294967295); //@line 65 "phonemelist.cpp"
            var $phcode8=(($arrayidx7)&4294967295); //@line 65 "phonemelist.cpp"
            var $11=HEAPU8[($phcode8)]; //@line 65 "phonemelist.cpp"
            var $idxprom=((($11))&255); //@line 65 "phonemelist.cpp"
            var $arrayidx9=((_phoneme_tab+$idxprom*4)&4294967295); //@line 65 "phonemelist.cpp"
            var $12=HEAP32[(($arrayidx9)>>2)]; //@line 65 "phonemelist.cpp"
            $next=$12; //@line 65 "phonemelist.cpp"
            ; //@line 65 "phonemelist.cpp"
          }
  
          $word_end=0; //@line 67 "phonemelist.cpp"
          var $13=$plist2; //@line 68 "phonemelist.cpp"
          var $add_ptr=(($13+8)&4294967295); //@line 68 "phonemelist.cpp"
          var $sourceix=(($add_ptr+6)&4294967295); //@line 68 "phonemelist.cpp"
          var $14=HEAP16[(($sourceix)>>1)]; //@line 68 "phonemelist.cpp"
          var $tobool=(tempInt=(($14)),(tempInt>=32768?tempInt-65536:tempInt))!=0; //@line 68 "phonemelist.cpp"
          if ($tobool) { __label__ = 11;; } else { __label__ = 9;; } //@line 68 "phonemelist.cpp"
          $if_then14$$lor_lhs_false$14: do { 
            if (__label__ == 9) {
  
              var $15=$next; //@line 68 "phonemelist.cpp"
              var $cmp11=((($15))|0)!=0; //@line 68 "phonemelist.cpp"
              if (!($cmp11)) { __label__ = 12;break $if_then14$$lor_lhs_false$14; } //@line 68 "phonemelist.cpp"
  
              var $16=$next; //@line 68 "phonemelist.cpp"
              var $type=(($16+11)&4294967295); //@line 68 "phonemelist.cpp"
              var $17=HEAPU8[($type)]; //@line 68 "phonemelist.cpp"
              var $conv12=((($17))&255); //@line 68 "phonemelist.cpp"
              var $cmp13=((($conv12))|0)==0; //@line 68 "phonemelist.cpp"
              if ($cmp13) { __label__ = 11;break $if_then14$$lor_lhs_false$14; } else { __label__ = 12;break $if_then14$$lor_lhs_false$14; } //@line 68 "phonemelist.cpp"
            }
          } while(0);
          if (__label__ == 11) {
  
            $word_end=1; //@line 69 "phonemelist.cpp"
            ; //@line 69 "phonemelist.cpp"
          }
  
          $k=0; //@line 72 "phonemelist.cpp"
          ; //@line 72 "phonemelist.cpp"
          $for_cond16$20: while(1) { 
  
            var $18=$k; //@line 72 "phonemelist.cpp"
            var $19=HEAP32[((_n_replace_phonemes)>>2)]; //@line 72 "phonemelist.cpp"
            var $cmp17=((($18))|0) < ((($19))|0); //@line 72 "phonemelist.cpp"
            if (!($cmp17)) { __label__ = 23;break $for_cond16$20; } //@line 72 "phonemelist.cpp"
  
            var $20=$plist2; //@line 74 "phonemelist.cpp"
            var $phcode19=(($20)&4294967295); //@line 74 "phonemelist.cpp"
            var $21=HEAPU8[($phcode19)]; //@line 74 "phonemelist.cpp"
            var $conv20=((($21))&255); //@line 74 "phonemelist.cpp"
            var $22=$k; //@line 74 "phonemelist.cpp"
            var $arrayidx21=((_replace_phonemes+$22*3)&4294967295); //@line 74 "phonemelist.cpp"
            var $old_ph=(($arrayidx21)&4294967295); //@line 74 "phonemelist.cpp"
            var $23=HEAPU8[($old_ph)]; //@line 74 "phonemelist.cpp"
            var $conv22=((($23))&255); //@line 74 "phonemelist.cpp"
            var $cmp23=((($conv20))|0)==((($conv22))|0); //@line 74 "phonemelist.cpp"
            if ($cmp23) { __label__ = 15;; } else { __label__ = 22;; } //@line 74 "phonemelist.cpp"
            $if_then24$$for_inc$23: do { 
              if (__label__ == 15) {
  
                var $24=$k; //@line 76 "phonemelist.cpp"
                var $arrayidx25=((_replace_phonemes+$24*3)&4294967295); //@line 76 "phonemelist.cpp"
                var $type26=(($arrayidx25+2)&4294967295); //@line 76 "phonemelist.cpp"
                var $25=HEAP8[($type26)]; //@line 76 "phonemelist.cpp"
                var $conv27=(tempInt=(($25)),(tempInt>=128?tempInt-256:tempInt)); //@line 76 "phonemelist.cpp"
                $replace_flags=$conv27; //@line 76 "phonemelist.cpp"
                var $26=$replace_flags; //@line 78 "phonemelist.cpp"
                var $and=($26) & 1; //@line 78 "phonemelist.cpp"
                var $tobool28=((($and))|0)!=0; //@line 78 "phonemelist.cpp"
                if ($tobool28) { __label__ = 16;; } else { __label__ = 17;; } //@line 78 "phonemelist.cpp"
                if (__label__ == 16) {
  
                  var $27=$word_end; //@line 78 "phonemelist.cpp"
                  var $cmp30=((($27))|0)==0; //@line 78 "phonemelist.cpp"
                  if ($cmp30) { __label__ = 22;break $if_then24$$for_inc$23; } //@line 78 "phonemelist.cpp"
                }
  
                var $28=$replace_flags; //@line 81 "phonemelist.cpp"
                var $and33=($28) & 2; //@line 81 "phonemelist.cpp"
                var $tobool34=((($and33))|0)!=0; //@line 81 "phonemelist.cpp"
                if (!($tobool34)) { __label__ = 19;break $for_cond16$20; } //@line 81 "phonemelist.cpp"
  
                var $29=$plist2; //@line 81 "phonemelist.cpp"
                var $stresslevel=(($29+1)&4294967295); //@line 81 "phonemelist.cpp"
                var $30=HEAPU8[($stresslevel)]; //@line 81 "phonemelist.cpp"
                var $conv36=((($30))&255); //@line 81 "phonemelist.cpp"
                var $and37=($conv36) & 7; //@line 81 "phonemelist.cpp"
                var $cmp38=((($and37))|0) > 3; //@line 81 "phonemelist.cpp"
                if (!($cmp38)) { __label__ = 19;break $for_cond16$20; } //@line 81 "phonemelist.cpp"
              }
            } while(0);
  
            var $41=$k; //@line 72 "phonemelist.cpp"
            var $inc=((($41)+1)&4294967295); //@line 72 "phonemelist.cpp"
            $k=$inc; //@line 72 "phonemelist.cpp"
            __label__ = 13;continue $for_cond16$20; //@line 72 "phonemelist.cpp"
          }
          $for_end$$if_end40$30: do { 
            if (__label__ == 19) {
  
              var $31=$k; //@line 85 "phonemelist.cpp"
              var $arrayidx41=((_replace_phonemes+$31*3)&4294967295); //@line 85 "phonemelist.cpp"
              var $new_ph=(($arrayidx41+1)&4294967295); //@line 85 "phonemelist.cpp"
              var $32=HEAP8[($new_ph)]; //@line 85 "phonemelist.cpp"
              var $33=$plist2; //@line 85 "phonemelist.cpp"
              var $phcode42=(($33)&4294967295); //@line 85 "phonemelist.cpp"
              HEAP8[($phcode42)]=$32; //@line 85 "phonemelist.cpp"
              var $34=$plist2; //@line 86 "phonemelist.cpp"
              var $stresslevel43=(($34+1)&4294967295); //@line 86 "phonemelist.cpp"
              var $35=HEAPU8[($stresslevel43)]; //@line 86 "phonemelist.cpp"
              var $conv44=((($35))&255); //@line 86 "phonemelist.cpp"
              var $cmp45=((($conv44))|0) > 1; //@line 86 "phonemelist.cpp"
              if (!($cmp45)) { __label__ = 23;break $for_end$$if_end40$30; } //@line 86 "phonemelist.cpp"
  
              var $36=$plist2; //@line 86 "phonemelist.cpp"
              var $phcode47=(($36)&4294967295); //@line 86 "phonemelist.cpp"
              var $37=HEAPU8[($phcode47)]; //@line 86 "phonemelist.cpp"
              var $idxprom48=((($37))&255); //@line 86 "phonemelist.cpp"
              var $arrayidx49=((_phoneme_tab+$idxprom48*4)&4294967295); //@line 86 "phonemelist.cpp"
              var $38=HEAP32[(($arrayidx49)>>2)]; //@line 86 "phonemelist.cpp"
              var $phflags=(($38+4)&4294967295); //@line 86 "phonemelist.cpp"
              var $39=HEAP32[(($phflags)>>2)]; //@line 86 "phonemelist.cpp"
              var $and50=($39) & 2; //@line 86 "phonemelist.cpp"
              var $tobool51=((($and50))|0)!=0; //@line 86 "phonemelist.cpp"
              if (!($tobool51)) { __label__ = 23;break $for_end$$if_end40$30; } //@line 86 "phonemelist.cpp"
  
              var $40=$plist2; //@line 87 "phonemelist.cpp"
              var $stresslevel53=(($40+1)&4294967295); //@line 87 "phonemelist.cpp"
              HEAP8[($stresslevel53)]=0; //@line 87 "phonemelist.cpp"
              ; //@line 87 "phonemelist.cpp"
            }
          } while(0);
  
          var $42=$plist2; //@line 92 "phonemelist.cpp"
          var $phcode56=(($42)&4294967295); //@line 92 "phonemelist.cpp"
          var $43=HEAPU8[($phcode56)]; //@line 92 "phonemelist.cpp"
          var $conv57=((($43))&255); //@line 92 "phonemelist.cpp"
          var $cmp58=((($conv57))|0)==0; //@line 92 "phonemelist.cpp"
          if ($cmp58) { __label__ = 25;break $if_then4$$if_end61$9; } else { __label__ = 24;break $if_then4$$if_end61$9; } //@line 92 "phonemelist.cpp"
        }
      } while(0);
      if (__label__ == 24) {
  
        var $44=$n_plist_out; //@line 99 "phonemelist.cpp"
        var $45=$plist_out_addr; //@line 99 "phonemelist.cpp"
        var $arrayidx62=(($45+24*$44)&4294967295); //@line 99 "phonemelist.cpp"
        var $46=$arrayidx62; //@line 99 "phonemelist.cpp"
        var $47=$plist2; //@line 99 "phonemelist.cpp"
        var $48=$47; //@line 99 "phonemelist.cpp"
        var $src$, $dest$, $stop$, $stop4$, $fast$;
        $src$ = $48;
        $dest$ = $46;
        $stop$ = $src$ + 8;
        if (($dest$%4) == ($src$%4) && 8 > 8) {
          while ($src$%4 !== 0 && $src$ < $stop$) {
            ; HEAP8[$dest$++] = HEAP8[$src$++];
          }
          $src$ >>= 2;
          $dest$ >>= 2;
          $stop4$ = $stop$ >> 2;
          while ($src$ < $stop4$) {
        ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
          }
          $src$ <<= 2;
          $dest$ <<= 2;
        }while ($src$ < $stop$) {
          ; HEAP8[$dest$++] = HEAP8[$src$++];
        }; //@line 99 "phonemelist.cpp"
        var $49=$plist2; //@line 100 "phonemelist.cpp"
        var $phcode63=(($49)&4294967295); //@line 100 "phonemelist.cpp"
        var $50=HEAPU8[($phcode63)]; //@line 100 "phonemelist.cpp"
        var $idxprom64=((($50))&255); //@line 100 "phonemelist.cpp"
        var $arrayidx65=((_phoneme_tab+$idxprom64*4)&4294967295); //@line 100 "phonemelist.cpp"
        var $51=HEAP32[(($arrayidx65)>>2)]; //@line 100 "phonemelist.cpp"
        var $52=$n_plist_out; //@line 100 "phonemelist.cpp"
        var $53=$plist_out_addr; //@line 100 "phonemelist.cpp"
        var $arrayidx66=(($53+24*$52)&4294967295); //@line 100 "phonemelist.cpp"
        var $ph=(($arrayidx66+8)&4294967295); //@line 100 "phonemelist.cpp"
        HEAP32[(($ph)>>2)]=$51; //@line 100 "phonemelist.cpp"
        var $54=$n_plist_out; //@line 101 "phonemelist.cpp"
        var $55=$plist_out_addr; //@line 101 "phonemelist.cpp"
        var $arrayidx67=(($55+24*$54)&4294967295); //@line 101 "phonemelist.cpp"
        var $ph68=(($arrayidx67+8)&4294967295); //@line 101 "phonemelist.cpp"
        var $56=HEAP32[(($ph68)>>2)]; //@line 101 "phonemelist.cpp"
        var $type69=(($56+11)&4294967295); //@line 101 "phonemelist.cpp"
        var $57=HEAP8[($type69)]; //@line 101 "phonemelist.cpp"
        var $58=$n_plist_out; //@line 101 "phonemelist.cpp"
        var $59=$plist_out_addr; //@line 101 "phonemelist.cpp"
        var $arrayidx70=(($59+24*$58)&4294967295); //@line 101 "phonemelist.cpp"
        var $type71=(($arrayidx70+15)&4294967295); //@line 101 "phonemelist.cpp"
        HEAP8[($type71)]=$57; //@line 101 "phonemelist.cpp"
        var $60=$n_plist_out; //@line 102 "phonemelist.cpp"
        var $inc72=((($60)+1)&4294967295); //@line 102 "phonemelist.cpp"
        $n_plist_out=$inc72; //@line 102 "phonemelist.cpp"
        ; //@line 103 "phonemelist.cpp"
      }
  
      var $61=$ix; //@line 54 "phonemelist.cpp"
      var $inc74=((($61)+1)&4294967295); //@line 54 "phonemelist.cpp"
      $ix=$inc74; //@line 54 "phonemelist.cpp"
      __label__ = 1;continue $for_cond$2; //@line 54 "phonemelist.cpp"
    }
  
    var $62=$n_plist_out; //@line 104 "phonemelist.cpp"
    ;
    return $62; //@line 104 "phonemelist.cpp"
    return null;
  }
  

  function __Z10KlattReseti($control) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $control_addr;
    var $r_ix;
    $control_addr=$control;
    var $0=$control_addr; //@line 499 "klatt.cpp"
    var $cmp=((($0))|0)==2; //@line 499 "klatt.cpp"
    if ($cmp) { __lastLabel__ = 0; __label__ = 1;; } else { __lastLabel__ = 0; __label__ = 2;; } //@line 499 "klatt.cpp"
    if (__label__ == 1) {
  
      var $1=HEAP32[((((__ZL10kt_globals+8)&4294967295))>>2)]; //@line 502 "klatt.cpp"
      var $mul=((($1)*950)&4294967295); //@line 502 "klatt.cpp"
      var $div=((((($mul))|0)/10000)|0); //@line 502 "klatt.cpp"
      HEAP32[((((__ZL10kt_globals+12)&4294967295))>>2)]=$div; //@line 502 "klatt.cpp"
      var $2=HEAP32[((((__ZL10kt_globals+8)&4294967295))>>2)]; //@line 503 "klatt.cpp"
      var $mul1=((($2)*630)&4294967295); //@line 503 "klatt.cpp"
      var $div2=((((($mul1))|0)/10000)|0); //@line 503 "klatt.cpp"
      HEAP32[((((__ZL10kt_globals+16)&4294967295))>>2)]=$div2; //@line 503 "klatt.cpp"
      var $3=HEAP32[((((__ZL10kt_globals+8)&4294967295))>>2)]; //@line 504 "klatt.cpp"
      var $conv=((($3))|0); //@line 504 "klatt.cpp"
      var $div3=-3.1415927/($conv); //@line 504 "klatt.cpp"
      HEAPF32[((((__ZL10kt_globals+72)&4294967295))>>2)]=$div3; //@line 504 "klatt.cpp"
      var $4=HEAPF32[((((__ZL10kt_globals+72)&4294967295))>>2)]; //@line 505 "klatt.cpp"
      var $mul4=-2*($4); //@line 505 "klatt.cpp"
      HEAPF32[((((__ZL10kt_globals+80)&4294967295))>>2)]=$mul4; //@line 505 "klatt.cpp"
      var $5=HEAP32[((((__ZL10kt_globals+12)&4294967295))>>2)]; //@line 506 "klatt.cpp"
      var $6=HEAP32[((((__ZL10kt_globals+16)&4294967295))>>2)]; //@line 506 "klatt.cpp"
      __ZL6setabcllP11resonator_t($5, $6, ((__ZL10kt_globals+188+1152)&4294967295)); //@line 506 "klatt.cpp"
      var $_pr=$control_addr; //@line 510 "klatt.cpp"
      __lastLabel__ = 1; ; //@line 508 "klatt.cpp"
    }
  
    var $7=__lastLabel__ == 1 ? $_pr : ($0); //@line 510 "klatt.cpp"
    var $cmp5=((($7))|0) > 0; //@line 510 "klatt.cpp"
    if ($cmp5) { __label__ = 3;; } else { __label__ = 5;; } //@line 510 "klatt.cpp"
    $if_then6$$if_end9$5: do { 
      if (__label__ == 3) {
  
        HEAP32[((((__ZL10kt_globals+32)&4294967295))>>2)]=0; //@line 512 "klatt.cpp"
        HEAP32[((((__ZL10kt_globals+40)&4294967295))>>2)]=0; //@line 513 "klatt.cpp"
        HEAP32[((((__ZL10kt_globals+44)&4294967295))>>2)]=0; //@line 514 "klatt.cpp"
        HEAP32[((((__ZL10kt_globals+48)&4294967295))>>2)]=0; //@line 515 "klatt.cpp"
        $r_ix=17; //@line 517 "klatt.cpp"
        ; //@line 517 "klatt.cpp"
        while(1) { 
  
          var $8=$r_ix; //@line 519 "klatt.cpp"
          var $arrayidx=((((__ZL10kt_globals+188)&4294967295)+$8*64)&4294967295); //@line 519 "klatt.cpp"
          var $p1=(($arrayidx+24)&4294967295); //@line 519 "klatt.cpp"
          HEAPF32[(($p1)>>2)]=0; //@line 519 "klatt.cpp"
          var $9=$r_ix; //@line 520 "klatt.cpp"
          var $arrayidx8=((((__ZL10kt_globals+188)&4294967295)+$9*64)&4294967295); //@line 520 "klatt.cpp"
          var $p2=(($arrayidx8+32)&4294967295); //@line 520 "klatt.cpp"
          HEAPF32[(($p2)>>2)]=0; //@line 520 "klatt.cpp"
          var $10=$r_ix; //@line 517 "klatt.cpp"
          var $inc=((($10)+1)&4294967295); //@line 517 "klatt.cpp"
          $r_ix=$inc; //@line 517 "klatt.cpp"
          var $cmp7=((($inc))|0) < 20; //@line 517 "klatt.cpp"
          if ($cmp7) { __label__ = 4;continue ; } else { __label__ = 5;break $if_then6$$if_end9$5; } //@line 517 "klatt.cpp"
        }
      }
    } while(0);
  
    $r_ix=0; //@line 525 "klatt.cpp"
    ; //@line 525 "klatt.cpp"
    while(1) { 
  
      var $11=$r_ix; //@line 527 "klatt.cpp"
      var $arrayidx13=((((__ZL10kt_globals+188)&4294967295)+$11*64)&4294967295); //@line 527 "klatt.cpp"
      var $p114=(($arrayidx13+24)&4294967295); //@line 527 "klatt.cpp"
      HEAPF32[(($p114)>>2)]=0; //@line 527 "klatt.cpp"
      var $12=$r_ix; //@line 528 "klatt.cpp"
      var $arrayidx15=((((__ZL10kt_globals+188)&4294967295)+$12*64)&4294967295); //@line 528 "klatt.cpp"
      var $p216=(($arrayidx15+32)&4294967295); //@line 528 "klatt.cpp"
      HEAPF32[(($p216)>>2)]=0; //@line 528 "klatt.cpp"
      var $13=$r_ix; //@line 525 "klatt.cpp"
      var $inc18=((($13)+1)&4294967295); //@line 525 "klatt.cpp"
      $r_ix=$inc18; //@line 525 "klatt.cpp"
      var $cmp11=((($inc18))|0) <= 16; //@line 525 "klatt.cpp"
      if ($cmp11) { __label__ = 6;continue ; } else { __label__ = 7;break ; } //@line 525 "klatt.cpp"
    }
  
    ;
    return; //@line 530 "klatt.cpp"
    return;
  }
  

  function __ZL6setabcllP11resonator_t($f, $bw, $rp) {
    ;
    var __label__;
  
    var $f_addr;
    var $bw_addr;
    var $rp_addr;
    var $r;
    var $arg;
    $f_addr=$f;
    $bw_addr=$bw;
    $rp_addr=$rp;
    var $0=HEAPF32[((((__ZL10kt_globals+72)&4294967295))>>2)]; //@line 858 "klatt.cpp"
    var $1=$bw_addr; //@line 858 "klatt.cpp"
    var $conv=((($1))|0); //@line 858 "klatt.cpp"
    var $mul=($0)*($conv); //@line 858 "klatt.cpp"
    $arg=$mul; //@line 858 "klatt.cpp"
    var $2=$arg; //@line 859 "klatt.cpp"
    var $call=_exp($2); //@line 859 "klatt.cpp"
    $r=$call; //@line 859 "klatt.cpp"
    var $3=$r; //@line 862 "klatt.cpp"
    var $4=$r; //@line 862 "klatt.cpp"
    var $mul1=($3)*($4); //@line 862 "klatt.cpp"
    var $sub=(-($mul1)); //@line 862 "klatt.cpp"
    var $5=$rp_addr; //@line 862 "klatt.cpp"
    var $c=(($5+16)&4294967295); //@line 862 "klatt.cpp"
    HEAPF32[(($c)>>2)]=$sub; //@line 862 "klatt.cpp"
    var $6=HEAPF32[((((__ZL10kt_globals+80)&4294967295))>>2)]; //@line 865 "klatt.cpp"
    var $7=$f_addr; //@line 865 "klatt.cpp"
    var $conv2=((($7))|0); //@line 865 "klatt.cpp"
    var $mul3=($6)*($conv2); //@line 865 "klatt.cpp"
    $arg=$mul3; //@line 865 "klatt.cpp"
    var $8=$r; //@line 866 "klatt.cpp"
    var $9=$arg; //@line 866 "klatt.cpp"
    var $call4=_cos($9); //@line 866 "klatt.cpp"
    var $mul5=($8)*($call4); //@line 866 "klatt.cpp"
    var $mul6=($mul5)*2; //@line 866 "klatt.cpp"
    var $10=$rp_addr; //@line 866 "klatt.cpp"
    var $b=(($10+8)&4294967295); //@line 866 "klatt.cpp"
    HEAPF32[(($b)>>2)]=$mul6; //@line 866 "klatt.cpp"
    var $11=$rp_addr; //@line 869 "klatt.cpp"
    var $b7=(($11+8)&4294967295); //@line 869 "klatt.cpp"
    var $12=HEAPF32[(($b7)>>2)]; //@line 869 "klatt.cpp"
    var $sub8=1-($12); //@line 869 "klatt.cpp"
    var $13=$rp_addr; //@line 869 "klatt.cpp"
    var $c9=(($13+16)&4294967295); //@line 869 "klatt.cpp"
    var $14=HEAPF32[(($c9)>>2)]; //@line 869 "klatt.cpp"
    var $sub10=($sub8)-($14); //@line 869 "klatt.cpp"
    var $15=$rp_addr; //@line 869 "klatt.cpp"
    var $a=(($15)&4294967295); //@line 869 "klatt.cpp"
    HEAPF32[(($a)>>2)]=$sub10; //@line 869 "klatt.cpp"
    ;
    return; //@line 870 "klatt.cpp"
    return;
  }
  

  function __Z13Wavegen_Klatti($resume) {
    ;
    var __label__;
  
    var $retval;
    var $resume_addr;
    var $pk;
    var $x;
    var $ix;
    var $fade;
    $resume_addr=$resume;
    var $0=$resume_addr; //@line 1001 "klatt.cpp"
    var $cmp=((($0))|0)==0; //@line 1001 "klatt.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 1001 "klatt.cpp"
    if (__label__ == 1) {
  
      HEAP32[((__ZL12sample_count)>>2)]=0; //@line 1003 "klatt.cpp"
      ; //@line 1004 "klatt.cpp"
    }
    $while_cond$4: while(1) { 
  
      var $1=HEAP32[((__ZL12sample_count)>>2)]; //@line 1006 "klatt.cpp"
      var $2=HEAP32[((__ZL8nsamples802)>>2)]; //@line 1006 "klatt.cpp"
      var $cmp1=((($1))|0) < ((($2))|0); //@line 1006 "klatt.cpp"
      if (!($cmp1)) { __label__ = 23;break $while_cond$4; } //@line 1006 "klatt.cpp"
  
      var $3=HEAP32[((((_wdata+4)&4294967295))>>2)]; //@line 1008 "klatt.cpp"
      var $mul=((($3)*10)&4294967295); //@line 1008 "klatt.cpp"
      var $div=((((($mul))|0)/4096)|0); //@line 1008 "klatt.cpp"
      HEAP32[((((__ZL8kt_frame)&4294967295))>>2)]=$div; //@line 1008 "klatt.cpp"
      $ix=0; //@line 1013 "klatt.cpp"
      ; //@line 1013 "klatt.cpp"
      $for_body$7: while(1) { 
  
        var $4=$ix; //@line 1015 "klatt.cpp"
        var $arrayidx=((__ZL5peaks801+$4*80)&4294967295); //@line 1015 "klatt.cpp"
        var $freq=(($arrayidx)&4294967295); //@line 1015 "klatt.cpp"
        var $5=HEAP32[(($freq)>>2)]; //@line 1015 "klatt.cpp"
        var $6=$ix; //@line 1015 "klatt.cpp"
        var $arrayidx3=((((__ZL8kt_frame+8)&4294967295)+$6*4)&4294967295); //@line 1015 "klatt.cpp"
        HEAP32[(($arrayidx3)>>2)]=$5; //@line 1015 "klatt.cpp"
        var $7=$ix; //@line 1016 "klatt.cpp"
        var $cmp4=((($7))|0) < 4; //@line 1016 "klatt.cpp"
        if ($cmp4) { __label__ = 5;; } else { __label__ = 6;; } //@line 1016 "klatt.cpp"
        if (__label__ == 5) {
  
          var $8=$ix; //@line 1018 "klatt.cpp"
          var $arrayidx6=((__ZL5peaks801+$8*80)&4294967295); //@line 1018 "klatt.cpp"
          var $bw=(($arrayidx6+4)&4294967295); //@line 1018 "klatt.cpp"
          var $9=HEAP32[(($bw)>>2)]; //@line 1018 "klatt.cpp"
          var $10=$ix; //@line 1018 "klatt.cpp"
          var $arrayidx7=((((__ZL8kt_frame+48)&4294967295)+$10*4)&4294967295); //@line 1018 "klatt.cpp"
          HEAP32[(($arrayidx7)>>2)]=$9; //@line 1018 "klatt.cpp"
          ; //@line 1019 "klatt.cpp"
        }
  
        var $11=$ix; //@line 1013 "klatt.cpp"
        var $inc=((($11)+1)&4294967295); //@line 1013 "klatt.cpp"
        $ix=$inc; //@line 1013 "klatt.cpp"
        var $cmp2=((($inc))|0) < 6; //@line 1013 "klatt.cpp"
        if ($cmp2) { __label__ = 4;continue $for_body$7; } else { __label__ = 7;break $for_body$7; } //@line 1013 "klatt.cpp"
      }
  
      $ix=1; //@line 1021 "klatt.cpp"
      ; //@line 1021 "klatt.cpp"
      $for_body11$13: while(1) { 
  
        var $12=$ix; //@line 1023 "klatt.cpp"
        var $arrayidx12=((((__ZL8kt_frame+88)&4294967295)+$12*4)&4294967295); //@line 1023 "klatt.cpp"
        HEAP32[(($arrayidx12)>>2)]=0; //@line 1023 "klatt.cpp"
        var $13=$ix; //@line 1021 "klatt.cpp"
        var $inc14=((($13)+1)&4294967295); //@line 1021 "klatt.cpp"
        $ix=$inc14; //@line 1021 "klatt.cpp"
        var $cmp10=((($inc14))|0) < 7; //@line 1021 "klatt.cpp"
        if ($cmp10) { __label__ = 8;continue $for_body11$13; } else { __label__ = 9;break $for_body11$13; } //@line 1021 "klatt.cpp"
      }
  
      var $14=HEAP32[((((__ZL6klattp)&4294967295))>>2)]; //@line 1026 "klatt.cpp"
      HEAP32[((((__ZL8kt_frame+4)&4294967295))>>2)]=$14; //@line 1026 "klatt.cpp"
      var $15=HEAP32[((((__ZL6klattp+24)&4294967295))>>2)]; //@line 1027 "klatt.cpp"
      HEAP32[((((__ZL8kt_frame+196)&4294967295))>>2)]=$15; //@line 1027 "klatt.cpp"
      var $16=HEAP32[((((__ZL6klattp+28)&4294967295))>>2)]; //@line 1028 "klatt.cpp"
      HEAP32[((((__ZL8kt_frame+184)&4294967295))>>2)]=$16; //@line 1028 "klatt.cpp"
      var $17=HEAP32[((((__ZL6klattp+32)&4294967295))>>2)]; //@line 1029 "klatt.cpp"
      HEAP32[((((__ZL8kt_frame+192)&4294967295))>>2)]=$17; //@line 1029 "klatt.cpp"
      var $18=HEAP32[((((__ZL6klattp+12)&4294967295))>>2)]; //@line 1030 "klatt.cpp"
      HEAP32[((((__ZL8kt_frame+168)&4294967295))>>2)]=$18; //@line 1030 "klatt.cpp"
      var $19=HEAP32[((((__ZL6klattp+36)&4294967295))>>2)]; //@line 1031 "klatt.cpp"
      HEAP32[((((__ZL8kt_frame+176)&4294967295))>>2)]=$19; //@line 1031 "klatt.cpp"
      var $20=HEAP32[((((__ZL6klattp+16)&4294967295))>>2)]; //@line 1032 "klatt.cpp"
      HEAP32[((((__ZL8kt_frame+188)&4294967295))>>2)]=$20; //@line 1032 "klatt.cpp"
      var $21=HEAP32[((((__ZL6klattp+8)&4294967295))>>2)]; //@line 1033 "klatt.cpp"
      HEAP32[((((__ZL8kt_frame+180)&4294967295))>>2)]=$21; //@line 1033 "klatt.cpp"
      var $22=HEAP32[((((__ZL6klattp+20)&4294967295))>>2)]; //@line 1034 "klatt.cpp"
      HEAP32[((((__ZL8kt_frame+172)&4294967295))>>2)]=$22; //@line 1034 "klatt.cpp"
      $pk=0; //@line 1037 "klatt.cpp"
      ; //@line 1037 "klatt.cpp"
      $for_body18$16: while(1) { 
  
        var $23=$pk; //@line 1039 "klatt.cpp"
        var $arrayidx19=((__ZL5peaks801+$23*80)&4294967295); //@line 1039 "klatt.cpp"
        var $freq_inc=(($arrayidx19+48)&4294967295); //@line 1039 "klatt.cpp"
        var $24=HEAPF32[(($freq_inc)>>2)]; //@line 1039 "klatt.cpp"
        var $25=$pk; //@line 1039 "klatt.cpp"
        var $arrayidx20=((__ZL5peaks801+$25*80)&4294967295); //@line 1039 "klatt.cpp"
        var $freq1=(($arrayidx20+16)&4294967295); //@line 1039 "klatt.cpp"
        var $26=HEAPF32[(($freq1)>>2)]; //@line 1039 "klatt.cpp"
        var $add=($26)+($24); //@line 1039 "klatt.cpp"
        HEAPF32[(($freq1)>>2)]=$add; //@line 1039 "klatt.cpp"
        var $27=$pk; //@line 1040 "klatt.cpp"
        var $arrayidx21=((__ZL5peaks801+$27*80)&4294967295); //@line 1040 "klatt.cpp"
        var $freq122=(($arrayidx21+16)&4294967295); //@line 1040 "klatt.cpp"
        var $28=HEAPF32[(($freq122)>>2)]; //@line 1040 "klatt.cpp"
        var $conv=((($28))|0); //@line 1040 "klatt.cpp"
        var $29=$pk; //@line 1040 "klatt.cpp"
        var $arrayidx23=((__ZL5peaks801+$29*80)&4294967295); //@line 1040 "klatt.cpp"
        var $freq24=(($arrayidx23)&4294967295); //@line 1040 "klatt.cpp"
        HEAP32[(($freq24)>>2)]=$conv; //@line 1040 "klatt.cpp"
        var $30=$pk; //@line 1041 "klatt.cpp"
        var $arrayidx25=((__ZL5peaks801+$30*80)&4294967295); //@line 1041 "klatt.cpp"
        var $bw_inc=(($arrayidx25+56)&4294967295); //@line 1041 "klatt.cpp"
        var $31=HEAPF32[(($bw_inc)>>2)]; //@line 1041 "klatt.cpp"
        var $32=$pk; //@line 1041 "klatt.cpp"
        var $arrayidx26=((__ZL5peaks801+$32*80)&4294967295); //@line 1041 "klatt.cpp"
        var $bw1=(($arrayidx26+24)&4294967295); //@line 1041 "klatt.cpp"
        var $33=HEAPF32[(($bw1)>>2)]; //@line 1041 "klatt.cpp"
        var $add27=($33)+($31); //@line 1041 "klatt.cpp"
        HEAPF32[(($bw1)>>2)]=$add27; //@line 1041 "klatt.cpp"
        var $34=$pk; //@line 1042 "klatt.cpp"
        var $arrayidx28=((__ZL5peaks801+$34*80)&4294967295); //@line 1042 "klatt.cpp"
        var $bw129=(($arrayidx28+24)&4294967295); //@line 1042 "klatt.cpp"
        var $35=HEAPF32[(($bw129)>>2)]; //@line 1042 "klatt.cpp"
        var $conv30=((($35))|0); //@line 1042 "klatt.cpp"
        var $36=$pk; //@line 1042 "klatt.cpp"
        var $arrayidx31=((__ZL5peaks801+$36*80)&4294967295); //@line 1042 "klatt.cpp"
        var $bw32=(($arrayidx31+4)&4294967295); //@line 1042 "klatt.cpp"
        HEAP32[(($bw32)>>2)]=$conv30; //@line 1042 "klatt.cpp"
        var $37=$pk; //@line 1043 "klatt.cpp"
        var $arrayidx33=((__ZL5peaks801+$37*80)&4294967295); //@line 1043 "klatt.cpp"
        var $bp_inc=(($arrayidx33+72)&4294967295); //@line 1043 "klatt.cpp"
        var $38=HEAPF32[(($bp_inc)>>2)]; //@line 1043 "klatt.cpp"
        var $39=$pk; //@line 1043 "klatt.cpp"
        var $arrayidx34=((__ZL5peaks801+$39*80)&4294967295); //@line 1043 "klatt.cpp"
        var $bp1=(($arrayidx34+40)&4294967295); //@line 1043 "klatt.cpp"
        var $40=HEAPF32[(($bp1)>>2)]; //@line 1043 "klatt.cpp"
        var $add35=($40)+($38); //@line 1043 "klatt.cpp"
        HEAPF32[(($bp1)>>2)]=$add35; //@line 1043 "klatt.cpp"
        var $41=$pk; //@line 1044 "klatt.cpp"
        var $arrayidx36=((__ZL5peaks801+$41*80)&4294967295); //@line 1044 "klatt.cpp"
        var $bp137=(($arrayidx36+40)&4294967295); //@line 1044 "klatt.cpp"
        var $42=HEAPF32[(($bp137)>>2)]; //@line 1044 "klatt.cpp"
        var $conv38=((($42))|0); //@line 1044 "klatt.cpp"
        var $43=$pk; //@line 1044 "klatt.cpp"
        var $arrayidx39=((__ZL5peaks801+$43*80)&4294967295); //@line 1044 "klatt.cpp"
        var $bp=(($arrayidx39+12)&4294967295); //@line 1044 "klatt.cpp"
        HEAP32[(($bp)>>2)]=$conv38; //@line 1044 "klatt.cpp"
        var $44=$pk; //@line 1045 "klatt.cpp"
        var $arrayidx40=((__ZL5peaks801+$44*80)&4294967295); //@line 1045 "klatt.cpp"
        var $ap_inc=(($arrayidx40+64)&4294967295); //@line 1045 "klatt.cpp"
        var $45=HEAPF32[(($ap_inc)>>2)]; //@line 1045 "klatt.cpp"
        var $46=$pk; //@line 1045 "klatt.cpp"
        var $arrayidx41=((__ZL5peaks801+$46*80)&4294967295); //@line 1045 "klatt.cpp"
        var $ap1=(($arrayidx41+32)&4294967295); //@line 1045 "klatt.cpp"
        var $47=HEAPF32[(($ap1)>>2)]; //@line 1045 "klatt.cpp"
        var $add42=($47)+($45); //@line 1045 "klatt.cpp"
        HEAPF32[(($ap1)>>2)]=$add42; //@line 1045 "klatt.cpp"
        var $48=$pk; //@line 1046 "klatt.cpp"
        var $arrayidx43=((__ZL5peaks801+$48*80)&4294967295); //@line 1046 "klatt.cpp"
        var $ap144=(($arrayidx43+32)&4294967295); //@line 1046 "klatt.cpp"
        var $49=HEAPF32[(($ap144)>>2)]; //@line 1046 "klatt.cpp"
        var $conv45=((($49))|0); //@line 1046 "klatt.cpp"
        var $50=$pk; //@line 1046 "klatt.cpp"
        var $arrayidx46=((__ZL5peaks801+$50*80)&4294967295); //@line 1046 "klatt.cpp"
        var $ap=(($arrayidx46+8)&4294967295); //@line 1046 "klatt.cpp"
        HEAP32[(($ap)>>2)]=$conv45; //@line 1046 "klatt.cpp"
        var $51=$pk; //@line 1037 "klatt.cpp"
        var $inc48=((($51)+1)&4294967295); //@line 1037 "klatt.cpp"
        $pk=$inc48; //@line 1037 "klatt.cpp"
        var $cmp17=((($inc48))|0) < 9; //@line 1037 "klatt.cpp"
        if ($cmp17) { __label__ = 10;continue $for_body18$16; } else { __label__ = 11;break $for_body18$16; } //@line 1037 "klatt.cpp"
      }
  
      $ix=0; //@line 1050 "klatt.cpp"
      ; //@line 1050 "klatt.cpp"
      $for_body52$19: while(1) { 
  
        var $52=$ix; //@line 1052 "klatt.cpp"
        var $arrayidx53=((__ZL10klattp_inc+$52*8)&4294967295); //@line 1052 "klatt.cpp"
        var $53=HEAPF32[(($arrayidx53)>>2)]; //@line 1052 "klatt.cpp"
        var $54=$ix; //@line 1052 "klatt.cpp"
        var $arrayidx54=((__ZL7klattp1+$54*8)&4294967295); //@line 1052 "klatt.cpp"
        var $55=HEAPF32[(($arrayidx54)>>2)]; //@line 1052 "klatt.cpp"
        var $add55=($55)+($53); //@line 1052 "klatt.cpp"
        HEAPF32[(($arrayidx54)>>2)]=$add55; //@line 1052 "klatt.cpp"
        var $56=$ix; //@line 1053 "klatt.cpp"
        var $arrayidx56=((__ZL7klattp1+$56*8)&4294967295); //@line 1053 "klatt.cpp"
        var $57=HEAPF32[(($arrayidx56)>>2)]; //@line 1053 "klatt.cpp"
        var $conv57=((($57))|0); //@line 1053 "klatt.cpp"
        var $58=$ix; //@line 1053 "klatt.cpp"
        var $arrayidx58=((__ZL6klattp+$58*4)&4294967295); //@line 1053 "klatt.cpp"
        HEAP32[(($arrayidx58)>>2)]=$conv57; //@line 1053 "klatt.cpp"
        var $59=$ix; //@line 1050 "klatt.cpp"
        var $inc60=((($59)+1)&4294967295); //@line 1050 "klatt.cpp"
        $ix=$inc60; //@line 1050 "klatt.cpp"
        var $cmp51=((($inc60))|0) < 10; //@line 1050 "klatt.cpp"
        if ($cmp51) { __label__ = 12;continue $for_body52$19; } else { __label__ = 13;break $for_body52$19; } //@line 1050 "klatt.cpp"
      }
  
      $ix=0; //@line 1056 "klatt.cpp"
      ; //@line 1056 "klatt.cpp"
      while(1) { 
  
        var $60=$ix; //@line 1058 "klatt.cpp"
        var $arrayidx65=((__ZL5peaks801+$60*80)&4294967295); //@line 1058 "klatt.cpp"
        var $freq66=(($arrayidx65)&4294967295); //@line 1058 "klatt.cpp"
        var $61=HEAP32[(($freq66)>>2)]; //@line 1058 "klatt.cpp"
        var $62=$ix; //@line 1058 "klatt.cpp"
        var $arrayidx67=((((__ZL8kt_frame+208)&4294967295)+$62*4)&4294967295); //@line 1058 "klatt.cpp"
        HEAP32[(($arrayidx67)>>2)]=$61; //@line 1058 "klatt.cpp"
        var $63=$ix; //@line 1059 "klatt.cpp"
        var $cmp68=((($63))|0) < 4; //@line 1059 "klatt.cpp"
        if ($cmp68) { __label__ = 15;; } else { __label__ = 16;; } //@line 1059 "klatt.cpp"
        if (__label__ == 15) {
  
          var $64=$ix; //@line 1061 "klatt.cpp"
          var $arrayidx70=((__ZL5peaks801+$64*80)&4294967295); //@line 1061 "klatt.cpp"
          var $bw71=(($arrayidx70+4)&4294967295); //@line 1061 "klatt.cpp"
          var $65=HEAP32[(($bw71)>>2)]; //@line 1061 "klatt.cpp"
          var $66=$ix; //@line 1061 "klatt.cpp"
          var $arrayidx72=((((__ZL8kt_frame+248)&4294967295)+$66*4)&4294967295); //@line 1061 "klatt.cpp"
          HEAP32[(($arrayidx72)>>2)]=$65; //@line 1061 "klatt.cpp"
          ; //@line 1062 "klatt.cpp"
        }
  
        var $67=$ix; //@line 1056 "klatt.cpp"
        var $inc75=((($67)+1)&4294967295); //@line 1056 "klatt.cpp"
        $ix=$inc75; //@line 1056 "klatt.cpp"
        var $cmp63=((($inc75))|0) <= 6; //@line 1056 "klatt.cpp"
        if ($cmp63) { __label__ = 14;continue ; } else { __label__ = 17;break ; } //@line 1056 "klatt.cpp"
      }
  
      var $68=HEAP32[((((_wdata+12)&4294967295))>>2)]; //@line 1066 "klatt.cpp"
      var $69=HEAP32[((((_wdata+8)&4294967295))>>2)]; //@line 1066 "klatt.cpp"
      var $add77=((($69)+($68))&4294967295); //@line 1066 "klatt.cpp"
      HEAP32[((((_wdata+8)&4294967295))>>2)]=$add77; //@line 1066 "klatt.cpp"
      var $70=HEAP32[((((_wdata+8)&4294967295))>>2)]; //@line 1067 "klatt.cpp"
      var $shr=($70) >> 8; //@line 1067 "klatt.cpp"
      $ix=$shr; //@line 1067 "klatt.cpp"
      var $cmp78=((($shr))|0) > 127; //@line 1067 "klatt.cpp"
      if ($cmp78) { __label__ = 18;; } else { __label__ = 19;; } //@line 1067 "klatt.cpp"
      if (__label__ == 18) {
  
        $ix=127; //@line 1067 "klatt.cpp"
        ; //@line 1067 "klatt.cpp"
      }
  
      var $71=$ix; //@line 1068 "klatt.cpp"
      var $72=HEAP32[((((_wdata)&4294967295))>>2)]; //@line 1068 "klatt.cpp"
      var $arrayidx81=(($72+$71)&4294967295); //@line 1068 "klatt.cpp"
      var $73=HEAPU8[($arrayidx81)]; //@line 1068 "klatt.cpp"
      var $conv82=((($73))&255); //@line 1068 "klatt.cpp"
      var $74=HEAP32[((((_wdata+20)&4294967295))>>2)]; //@line 1068 "klatt.cpp"
      var $mul83=((($conv82)*($74))&4294967295); //@line 1068 "klatt.cpp"
      $x=$mul83; //@line 1068 "klatt.cpp"
      var $75=$x; //@line 1069 "klatt.cpp"
      var $shr84=($75) >> 8; //@line 1069 "klatt.cpp"
      var $76=HEAP32[((((_wdata+16)&4294967295))>>2)]; //@line 1069 "klatt.cpp"
      var $add85=((($shr84)+($76))&4294967295); //@line 1069 "klatt.cpp"
      HEAP32[((((_wdata+4)&4294967295))>>2)]=$add85; //@line 1069 "klatt.cpp"
      var $77=HEAP32[((__ZL8nsamples802)>>2)]; //@line 1071 "klatt.cpp"
      var $78=HEAP32[((__ZL12sample_count)>>2)]; //@line 1071 "klatt.cpp"
      var $sub=((($77)-($78))&4294967295); //@line 1071 "klatt.cpp"
      HEAP32[((((__ZL10kt_globals+28)&4294967295))>>2)]=$sub; //@line 1071 "klatt.cpp"
      var $cmp86=((($sub))|0) > 64; //@line 1072 "klatt.cpp"
      if ($cmp86) { __label__ = 20;; } else { __label__ = 21;; } //@line 1072 "klatt.cpp"
      if (__label__ == 20) {
  
        HEAP32[((((__ZL10kt_globals+28)&4294967295))>>2)]=64; //@line 1073 "klatt.cpp"
        ; //@line 1073 "klatt.cpp"
      }
  
      __ZL10frame_initP13klatt_frame_t(); //@line 1075 "klatt.cpp"
      var $call=__ZL7parwaveP13klatt_frame_t(); //@line 1077 "klatt.cpp"
      var $cmp89=((($call))|0)==1; //@line 1077 "klatt.cpp"
      if ($cmp89) { __label__ = 22;break $while_cond$4; } else { __label__ = 2;continue $while_cond$4; } //@line 1077 "klatt.cpp"
    }
    $while_end$$if_then90$34: do { 
      if (__label__ == 23) {
  
        var $79=HEAP32[((__ZL8end_wave803)>>2)]; //@line 1083 "klatt.cpp"
        var $cmp92=((($79))|0) > 0; //@line 1083 "klatt.cpp"
        if ($cmp92) { __label__ = 24;; } else { __label__ = 26;; } //@line 1083 "klatt.cpp"
        $if_then93$$if_end99$36: do { 
          if (__label__ == 24) {
  
            $fade=64; //@line 1095 "klatt.cpp"
            var $80=$fade; //@line 1099 "klatt.cpp"
            HEAP32[((((__ZL10kt_globals+180)&4294967295))>>2)]=$80; //@line 1099 "klatt.cpp"
            HEAP32[((__ZL8end_wave803)>>2)]=0; //@line 1100 "klatt.cpp"
            var $81=$fade; //@line 1101 "klatt.cpp"
            var $82=HEAP32[((__ZL12sample_count)>>2)]; //@line 1101 "klatt.cpp"
            var $sub94=((($82)-($81))&4294967295); //@line 1101 "klatt.cpp"
            HEAP32[((__ZL12sample_count)>>2)]=$sub94; //@line 1101 "klatt.cpp"
            var $83=$fade; //@line 1102 "klatt.cpp"
            HEAP32[((((__ZL10kt_globals+28)&4294967295))>>2)]=$83; //@line 1102 "klatt.cpp"
            var $call95=__ZL7parwaveP13klatt_frame_t(); //@line 1103 "klatt.cpp"
            var $cmp96=((($call95))|0)==1; //@line 1103 "klatt.cpp"
            if (!($cmp96)) { __label__ = 26;break $if_then93$$if_end99$36; } //@line 1103 "klatt.cpp"
  
            $retval=1; //@line 1105 "klatt.cpp"
            __label__ = 27;break $while_end$$if_then90$34; //@line 1105 "klatt.cpp"
          }
        } while(0);
  
        $retval=0; //@line 1109 "klatt.cpp"
        ; //@line 1109 "klatt.cpp"
      }
      else if (__label__ == 22) {
  
        $retval=1; //@line 1079 "klatt.cpp"
        ; //@line 1079 "klatt.cpp"
      }
    } while(0);
  
    var $84=$retval; //@line 1110 "klatt.cpp"
    ;
    return $84; //@line 1110 "klatt.cpp"
    return null;
  }
  

  function __ZL10frame_initP13klatt_frame_t() {
    var __stackBase__  = STACKTOP; STACKTOP += 56; _memset(__stackBase__, 0, 56);
    var __label__;
  
    var $frame_addr;
    var $amp_par=__stackBase__;
    var $Gain0_tmp;
    var $ix;
    $frame_addr=__ZL8kt_frame;
    var $0=$frame_addr; //@line 546 "klatt.cpp"
    var $F0hz10=(($0)&4294967295); //@line 546 "klatt.cpp"
    var $1=HEAP32[(($F0hz10)>>2)]; //@line 546 "klatt.cpp"
    var $div=((((($1))|0)/10)|0); //@line 546 "klatt.cpp"
    HEAP32[((((__ZL10kt_globals+176)&4294967295))>>2)]=$div; //@line 546 "klatt.cpp"
    var $2=$frame_addr; //@line 548 "klatt.cpp"
    var $AVdb=(($2+4)&4294967295); //@line 548 "klatt.cpp"
    var $3=HEAP32[(($AVdb)>>2)]; //@line 548 "klatt.cpp"
    var $sub=((($3)-7)&4294967295); //@line 548 "klatt.cpp"
    var $4=$frame_addr; //@line 548 "klatt.cpp"
    var $AVdb_tmp=(($4+204)&4294967295); //@line 548 "klatt.cpp"
    HEAP32[(($AVdb_tmp)>>2)]=$sub; //@line 548 "klatt.cpp"
    var $5=$frame_addr; //@line 549 "klatt.cpp"
    var $AVdb_tmp1=(($5+204)&4294967295); //@line 549 "klatt.cpp"
    var $6=HEAP32[(($AVdb_tmp1)>>2)]; //@line 549 "klatt.cpp"
    var $cmp=((($6))|0) < 0; //@line 549 "klatt.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 549 "klatt.cpp"
    if (__label__ == 1) {
  
      var $7=$frame_addr; //@line 551 "klatt.cpp"
      var $AVdb_tmp2=(($7+204)&4294967295); //@line 551 "klatt.cpp"
      HEAP32[(($AVdb_tmp2)>>2)]=0; //@line 551 "klatt.cpp"
      ; //@line 552 "klatt.cpp"
    }
  
    var $8=$frame_addr; //@line 554 "klatt.cpp"
    var $ASP=(($8+168)&4294967295); //@line 554 "klatt.cpp"
    var $9=HEAP32[(($ASP)>>2)]; //@line 554 "klatt.cpp"
    var $call=__ZL7DBtoLINl($9); //@line 554 "klatt.cpp"
    var $mul=($call)*0.05; //@line 554 "klatt.cpp"
    HEAPF32[((((__ZL10kt_globals+128)&4294967295))>>2)]=$mul; //@line 554 "klatt.cpp"
    var $10=$frame_addr; //@line 555 "klatt.cpp"
    var $AF=(($10+184)&4294967295); //@line 555 "klatt.cpp"
    var $11=HEAP32[(($AF)>>2)]; //@line 555 "klatt.cpp"
    var $call3=__ZL7DBtoLINl($11); //@line 555 "klatt.cpp"
    var $mul4=($call3)*0.25; //@line 555 "klatt.cpp"
    HEAPF32[((((__ZL10kt_globals+136)&4294967295))>>2)]=$mul4; //@line 555 "klatt.cpp"
    var $12=$frame_addr; //@line 556 "klatt.cpp"
    var $AVpdb=(($12+196)&4294967295); //@line 556 "klatt.cpp"
    var $13=HEAP32[(($AVpdb)>>2)]; //@line 556 "klatt.cpp"
    var $call5=__ZL7DBtoLINl($13); //@line 556 "klatt.cpp"
    HEAPF32[((((__ZL10kt_globals+120)&4294967295))>>2)]=$call5; //@line 556 "klatt.cpp"
    var $14=$frame_addr; //@line 557 "klatt.cpp"
    var $AB=(($14+192)&4294967295); //@line 557 "klatt.cpp"
    var $15=HEAP32[(($AB)>>2)]; //@line 557 "klatt.cpp"
    var $call6=__ZL7DBtoLINl($15); //@line 557 "klatt.cpp"
    var $mul7=($call6)*0.05; //@line 557 "klatt.cpp"
    HEAPF32[((((__ZL10kt_globals+104)&4294967295))>>2)]=$mul7; //@line 557 "klatt.cpp"
    $ix=0; //@line 559 "klatt.cpp"
    ; //@line 559 "klatt.cpp"
    $for_body$5: while(1) { 
  
      var $16=$ix; //@line 562 "klatt.cpp"
      var $17=$frame_addr; //@line 562 "klatt.cpp"
      var $Ap=(($17+88)&4294967295); //@line 562 "klatt.cpp"
      var $arrayidx=(($Ap+$16*4)&4294967295); //@line 562 "klatt.cpp"
      var $18=HEAP32[(($arrayidx)>>2)]; //@line 562 "klatt.cpp"
      var $call9=__ZL7DBtoLINl($18); //@line 562 "klatt.cpp"
      var $19=$ix; //@line 562 "klatt.cpp"
      var $arrayidx10=((__ZZL10frame_initP13klatt_frame_tE14amp_par_factor+$19*8)&4294967295); //@line 562 "klatt.cpp"
      var $20=HEAPF32[(($arrayidx10)>>2)]; //@line 562 "klatt.cpp"
      var $mul11=($call9)*($20); //@line 562 "klatt.cpp"
      var $21=$ix; //@line 562 "klatt.cpp"
      var $arrayidx12=(($amp_par+$21*8)&4294967295); //@line 562 "klatt.cpp"
      HEAPF32[(($arrayidx12)>>2)]=$mul11; //@line 562 "klatt.cpp"
      var $22=$ix; //@line 559 "klatt.cpp"
      var $inc=((($22)+1)&4294967295); //@line 559 "klatt.cpp"
      $ix=$inc; //@line 559 "klatt.cpp"
      var $cmp8=((($inc))|0) <= 6; //@line 559 "klatt.cpp"
      if ($cmp8) { __label__ = 3;continue $for_body$5; } else { __label__ = 4;break $for_body$5; } //@line 559 "klatt.cpp"
    }
  
    var $23=$frame_addr; //@line 565 "klatt.cpp"
    var $Gain0=(($23+200)&4294967295); //@line 565 "klatt.cpp"
    var $24=HEAP32[(($Gain0)>>2)]; //@line 565 "klatt.cpp"
    var $sub13=((($24)-3)&4294967295); //@line 565 "klatt.cpp"
    $Gain0_tmp=$sub13; //@line 565 "klatt.cpp"
    var $25=$Gain0_tmp; //@line 566 "klatt.cpp"
    var $cmp14=((($25))|0) <= 0; //@line 566 "klatt.cpp"
    if ($cmp14) { __label__ = 5;; } else { __label__ = 6;; } //@line 566 "klatt.cpp"
    if (__label__ == 5) {
  
      $Gain0_tmp=57; //@line 568 "klatt.cpp"
      ; //@line 569 "klatt.cpp"
    }
  
    var $26=$Gain0_tmp; //@line 570 "klatt.cpp"
    var $call17=__ZL7DBtoLINl($26); //@line 570 "klatt.cpp"
    var $27=HEAP32[((((__ZL10kt_globals+184)&4294967295))>>2)]; //@line 570 "klatt.cpp"
    var $conv=((($27))|0); //@line 570 "klatt.cpp"
    var $div18=($call17)/($conv); //@line 570 "klatt.cpp"
    HEAPF32[((((__ZL10kt_globals+152)&4294967295))>>2)]=$div18; //@line 570 "klatt.cpp"
    $ix=1; //@line 573 "klatt.cpp"
    ; //@line 573 "klatt.cpp"
    $for_body21$11: while(1) { 
  
      var $28=$ix; //@line 576 "klatt.cpp"
      var $29=$frame_addr; //@line 576 "klatt.cpp"
      var $Fhz=(($29+8)&4294967295); //@line 576 "klatt.cpp"
      var $arrayidx22=(($Fhz+$28*4)&4294967295); //@line 576 "klatt.cpp"
      var $30=HEAP32[(($arrayidx22)>>2)]; //@line 576 "klatt.cpp"
      var $31=$ix; //@line 576 "klatt.cpp"
      var $32=$frame_addr; //@line 576 "klatt.cpp"
      var $Bhz=(($32+48)&4294967295); //@line 576 "klatt.cpp"
      var $arrayidx23=(($Bhz+$31*4)&4294967295); //@line 576 "klatt.cpp"
      var $33=HEAP32[(($arrayidx23)>>2)]; //@line 576 "klatt.cpp"
      var $34=$ix; //@line 576 "klatt.cpp"
      var $arrayidx24=((((__ZL10kt_globals+188)&4294967295)+$34*64)&4294967295); //@line 576 "klatt.cpp"
      __ZL6setabcllP11resonator_t($30, $33, $arrayidx24); //@line 576 "klatt.cpp"
      var $35=$ix; //@line 578 "klatt.cpp"
      var $cmp25=((($35))|0) <= 5; //@line 578 "klatt.cpp"
      if ($cmp25) { __label__ = 8;; } else { __label__ = 9;; } //@line 578 "klatt.cpp"
      if (__label__ == 8) {
  
        var $36=$ix; //@line 580 "klatt.cpp"
        var $37=$frame_addr; //@line 580 "klatt.cpp"
        var $Fhz_next=(($37+208)&4294967295); //@line 580 "klatt.cpp"
        var $arrayidx27=(($Fhz_next+$36*4)&4294967295); //@line 580 "klatt.cpp"
        var $38=HEAP32[(($arrayidx27)>>2)]; //@line 580 "klatt.cpp"
        var $39=$ix; //@line 580 "klatt.cpp"
        var $40=$frame_addr; //@line 580 "klatt.cpp"
        var $Bhz_next=(($40+248)&4294967295); //@line 580 "klatt.cpp"
        var $arrayidx28=(($Bhz_next+$39*4)&4294967295); //@line 580 "klatt.cpp"
        var $41=HEAP32[(($arrayidx28)>>2)]; //@line 580 "klatt.cpp"
        var $42=$ix; //@line 580 "klatt.cpp"
        var $arrayidx29=((((__ZL10kt_globals+1468)&4294967295)+$42*64)&4294967295); //@line 580 "klatt.cpp"
        __ZL6setabcllP11resonator_t($38, $41, $arrayidx29); //@line 580 "klatt.cpp"
        var $43=$ix; //@line 582 "klatt.cpp"
        var $arrayidx30=((((__ZL10kt_globals+1468)&4294967295)+$43*64)&4294967295); //@line 582 "klatt.cpp"
        var $a=(($arrayidx30)&4294967295); //@line 582 "klatt.cpp"
        var $44=HEAPF32[(($a)>>2)]; //@line 582 "klatt.cpp"
        var $45=$ix; //@line 582 "klatt.cpp"
        var $arrayidx31=((((__ZL10kt_globals+188)&4294967295)+$45*64)&4294967295); //@line 582 "klatt.cpp"
        var $a32=(($arrayidx31)&4294967295); //@line 582 "klatt.cpp"
        var $46=HEAPF32[(($a32)>>2)]; //@line 582 "klatt.cpp"
        var $sub33=($44)-($46); //@line 582 "klatt.cpp"
        var $div34=($sub33)/64; //@line 582 "klatt.cpp"
        var $47=$ix; //@line 582 "klatt.cpp"
        var $arrayidx35=((((__ZL10kt_globals+188)&4294967295)+$47*64)&4294967295); //@line 582 "klatt.cpp"
        var $a_inc=(($arrayidx35+40)&4294967295); //@line 582 "klatt.cpp"
        HEAPF32[(($a_inc)>>2)]=$div34; //@line 582 "klatt.cpp"
        var $48=$ix; //@line 583 "klatt.cpp"
        var $arrayidx36=((((__ZL10kt_globals+1468)&4294967295)+$48*64)&4294967295); //@line 583 "klatt.cpp"
        var $b=(($arrayidx36+8)&4294967295); //@line 583 "klatt.cpp"
        var $49=HEAPF32[(($b)>>2)]; //@line 583 "klatt.cpp"
        var $50=$ix; //@line 583 "klatt.cpp"
        var $arrayidx37=((((__ZL10kt_globals+188)&4294967295)+$50*64)&4294967295); //@line 583 "klatt.cpp"
        var $b38=(($arrayidx37+8)&4294967295); //@line 583 "klatt.cpp"
        var $51=HEAPF32[(($b38)>>2)]; //@line 583 "klatt.cpp"
        var $sub39=($49)-($51); //@line 583 "klatt.cpp"
        var $div40=($sub39)/64; //@line 583 "klatt.cpp"
        var $52=$ix; //@line 583 "klatt.cpp"
        var $arrayidx41=((((__ZL10kt_globals+188)&4294967295)+$52*64)&4294967295); //@line 583 "klatt.cpp"
        var $b_inc=(($arrayidx41+48)&4294967295); //@line 583 "klatt.cpp"
        HEAPF32[(($b_inc)>>2)]=$div40; //@line 583 "klatt.cpp"
        var $53=$ix; //@line 584 "klatt.cpp"
        var $arrayidx42=((((__ZL10kt_globals+1468)&4294967295)+$53*64)&4294967295); //@line 584 "klatt.cpp"
        var $c=(($arrayidx42+16)&4294967295); //@line 584 "klatt.cpp"
        var $54=HEAPF32[(($c)>>2)]; //@line 584 "klatt.cpp"
        var $55=$ix; //@line 584 "klatt.cpp"
        var $arrayidx43=((((__ZL10kt_globals+188)&4294967295)+$55*64)&4294967295); //@line 584 "klatt.cpp"
        var $c44=(($arrayidx43+16)&4294967295); //@line 584 "klatt.cpp"
        var $56=HEAPF32[(($c44)>>2)]; //@line 584 "klatt.cpp"
        var $sub45=($54)-($56); //@line 584 "klatt.cpp"
        var $div46=($sub45)/64; //@line 584 "klatt.cpp"
        var $57=$ix; //@line 584 "klatt.cpp"
        var $arrayidx47=((((__ZL10kt_globals+188)&4294967295)+$57*64)&4294967295); //@line 584 "klatt.cpp"
        var $c_inc=(($arrayidx47+56)&4294967295); //@line 584 "klatt.cpp"
        HEAPF32[(($c_inc)>>2)]=$div46; //@line 584 "klatt.cpp"
        ; //@line 585 "klatt.cpp"
      }
  
      var $58=$ix; //@line 573 "klatt.cpp"
      var $inc50=((($58)+1)&4294967295); //@line 573 "klatt.cpp"
      $ix=$inc50; //@line 573 "klatt.cpp"
      var $cmp20=((($inc50))|0) <= 9; //@line 573 "klatt.cpp"
      if ($cmp20) { __label__ = 7;continue $for_body21$11; } else { __label__ = 10;break $for_body21$11; } //@line 573 "klatt.cpp"
    }
  
    var $59=$frame_addr; //@line 589 "klatt.cpp"
    var $Fhz52=(($59+8)&4294967295); //@line 589 "klatt.cpp"
    var $arrayidx53=(($Fhz52)&4294967295); //@line 589 "klatt.cpp"
    var $60=HEAP32[(($arrayidx53)>>2)]; //@line 589 "klatt.cpp"
    var $61=$frame_addr; //@line 589 "klatt.cpp"
    var $Bhz54=(($61+48)&4294967295); //@line 589 "klatt.cpp"
    var $arrayidx55=(($Bhz54)&4294967295); //@line 589 "klatt.cpp"
    var $62=HEAP32[(($arrayidx55)>>2)]; //@line 589 "klatt.cpp"
    __ZL10setzeroabcllP11resonator_t($60, $62, ((__ZL10kt_globals+188)&4294967295)); //@line 589 "klatt.cpp"
    var $63=$frame_addr; //@line 590 "klatt.cpp"
    var $Fhz_next56=(($63+208)&4294967295); //@line 590 "klatt.cpp"
    var $arrayidx57=(($Fhz_next56)&4294967295); //@line 590 "klatt.cpp"
    var $64=HEAP32[(($arrayidx57)>>2)]; //@line 590 "klatt.cpp"
    var $65=$frame_addr; //@line 590 "klatt.cpp"
    var $Bhz_next58=(($65+248)&4294967295); //@line 590 "klatt.cpp"
    var $arrayidx59=(($Bhz_next58)&4294967295); //@line 590 "klatt.cpp"
    var $66=HEAP32[(($arrayidx59)>>2)]; //@line 590 "klatt.cpp"
    __ZL10setzeroabcllP11resonator_t($64, $66, ((__ZL10kt_globals+1468)&4294967295)); //@line 590 "klatt.cpp"
    var $67=HEAPF32[((((__ZL10kt_globals+1468)&4294967295))>>2)]; //@line 591 "klatt.cpp"
    var $68=HEAPF32[((((__ZL10kt_globals+188)&4294967295))>>2)]; //@line 591 "klatt.cpp"
    var $sub60=($67)-($68); //@line 591 "klatt.cpp"
    var $div61=($sub60)/64; //@line 591 "klatt.cpp"
    HEAPF32[((((__ZL10kt_globals+188+40)&4294967295))>>2)]=$div61; //@line 591 "klatt.cpp"
    var $69=HEAPF32[((((__ZL10kt_globals+1468+8)&4294967295))>>2)]; //@line 592 "klatt.cpp"
    var $70=HEAPF32[((((__ZL10kt_globals+188+8)&4294967295))>>2)]; //@line 592 "klatt.cpp"
    var $sub62=($69)-($70); //@line 592 "klatt.cpp"
    var $div63=($sub62)/64; //@line 592 "klatt.cpp"
    HEAPF32[((((__ZL10kt_globals+188+48)&4294967295))>>2)]=$div63; //@line 592 "klatt.cpp"
    var $71=HEAPF32[((((__ZL10kt_globals+1468+16)&4294967295))>>2)]; //@line 593 "klatt.cpp"
    var $72=HEAPF32[((((__ZL10kt_globals+188+16)&4294967295))>>2)]; //@line 593 "klatt.cpp"
    var $sub64=($71)-($72); //@line 593 "klatt.cpp"
    var $div65=($sub64)/64; //@line 593 "klatt.cpp"
    HEAPF32[((((__ZL10kt_globals+188+56)&4294967295))>>2)]=$div65; //@line 593 "klatt.cpp"
    $ix=0; //@line 598 "klatt.cpp"
    ; //@line 598 "klatt.cpp"
    while(1) { 
  
      var $73=$ix; //@line 600 "klatt.cpp"
      var $74=$frame_addr; //@line 600 "klatt.cpp"
      var $Fhz69=(($74+8)&4294967295); //@line 600 "klatt.cpp"
      var $arrayidx70=(($Fhz69+$73*4)&4294967295); //@line 600 "klatt.cpp"
      var $75=HEAP32[(($arrayidx70)>>2)]; //@line 600 "klatt.cpp"
      var $76=$ix; //@line 600 "klatt.cpp"
      var $77=$frame_addr; //@line 600 "klatt.cpp"
      var $Bphz=(($77+128)&4294967295); //@line 600 "klatt.cpp"
      var $arrayidx71=(($Bphz+$76*4)&4294967295); //@line 600 "klatt.cpp"
      var $78=HEAP32[(($arrayidx71)>>2)]; //@line 600 "klatt.cpp"
      var $79=$ix; //@line 600 "klatt.cpp"
      var $add=((($79)+10)&4294967295); //@line 600 "klatt.cpp"
      var $arrayidx72=((((__ZL10kt_globals+188)&4294967295)+$add*64)&4294967295); //@line 600 "klatt.cpp"
      __ZL6setabcllP11resonator_t($75, $78, $arrayidx72); //@line 600 "klatt.cpp"
      var $80=$ix; //@line 601 "klatt.cpp"
      var $arrayidx73=(($amp_par+$80*8)&4294967295); //@line 601 "klatt.cpp"
      var $81=HEAPF32[(($arrayidx73)>>2)]; //@line 601 "klatt.cpp"
      var $82=$ix; //@line 601 "klatt.cpp"
      var $add74=((($82)+10)&4294967295); //@line 601 "klatt.cpp"
      var $arrayidx75=((((__ZL10kt_globals+188)&4294967295)+$add74*64)&4294967295); //@line 601 "klatt.cpp"
      var $a76=(($arrayidx75)&4294967295); //@line 601 "klatt.cpp"
      var $83=HEAPF32[(($a76)>>2)]; //@line 601 "klatt.cpp"
      var $mul77=($83)*($81); //@line 601 "klatt.cpp"
      HEAPF32[(($a76)>>2)]=$mul77; //@line 601 "klatt.cpp"
      var $84=$ix; //@line 598 "klatt.cpp"
      var $inc79=((($84)+1)&4294967295); //@line 598 "klatt.cpp"
      $ix=$inc79; //@line 598 "klatt.cpp"
      var $cmp67=((($inc79))|0) <= 6; //@line 598 "klatt.cpp"
      if ($cmp67) { __label__ = 11;continue ; } else { __label__ = 12;break ; } //@line 598 "klatt.cpp"
    }
  
    var $85=HEAP32[((((__ZL10kt_globals+8)&4294967295))>>2)]; //@line 606 "klatt.cpp"
    var $div81=((((($85))|0)/2)|0); //@line 606 "klatt.cpp"
    __ZL6setabcllP11resonator_t(0, $div81, ((__ZL10kt_globals+188+1216)&4294967295)); //@line 606 "klatt.cpp"
    STACKTOP = __stackBase__;
    return; //@line 608 "klatt.cpp"
    return;
  }
  

  function __ZL7parwaveP13klatt_frame_t() {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $frame_addr;
    var $temp;
    var $value;
    var $outbypas;
    var $out;
    var $n4;
    var $frics;
    var $glotout;
    var $aspiration;
    var $casc_next_in;
    var $par_glotout;
    var $ix;
    var $z2;
    var $c;
    var $sample;
    $frame_addr=__ZL8kt_frame;
    var $0=$frame_addr; //@line 245 "klatt.cpp"
    __ZL7flutterP13klatt_frame_t($0); //@line 245 "klatt.cpp"
    HEAP32[((((__ZL10kt_globals+36)&4294967295))>>2)]=0; //@line 260 "klatt.cpp"
    ; //@line 260 "klatt.cpp"
    $for_cond$2: while(1) { 
  
      var $1=HEAP32[((((__ZL10kt_globals+36)&4294967295))>>2)]; //@line 260 "klatt.cpp"
      var $2=HEAP32[((((__ZL10kt_globals+28)&4294967295))>>2)]; //@line 260 "klatt.cpp"
      var $cmp=((($1))|0) < ((($2))|0); //@line 260 "klatt.cpp"
      if (!($cmp)) { __label__ = 36;break $for_cond$2; } //@line 260 "klatt.cpp"
  
      var $3=HEAPF32[((__ZZL7parwaveP13klatt_frame_tE5noise)>>2)]; //@line 263 "klatt.cpp"
      var $call=__ZL9gen_noised($3); //@line 263 "klatt.cpp"
      HEAPF32[((__ZZL7parwaveP13klatt_frame_tE5noise)>>2)]=$call; //@line 263 "klatt.cpp"
      var $4=HEAP32[((((__ZL10kt_globals+32)&4294967295))>>2)]; //@line 270 "klatt.cpp"
      var $5=HEAP32[((((__ZL10kt_globals+48)&4294967295))>>2)]; //@line 270 "klatt.cpp"
      var $cmp1=((($4))|0) > ((($5))|0); //@line 270 "klatt.cpp"
      if ($cmp1) { __label__ = 3;; } else { __label__ = 4;; } //@line 270 "klatt.cpp"
      if (__label__ == 3) {
  
        var $6=HEAPF32[((__ZZL7parwaveP13klatt_frame_tE5noise)>>2)]; //@line 272 "klatt.cpp"
        var $mul=($6)*0.5; //@line 272 "klatt.cpp"
        HEAPF32[((__ZZL7parwaveP13klatt_frame_tE5noise)>>2)]=$mul; //@line 272 "klatt.cpp"
        ; //@line 273 "klatt.cpp"
      }
  
      var $7=HEAPF32[((((__ZL10kt_globals+136)&4294967295))>>2)]; //@line 276 "klatt.cpp"
      var $8=HEAPF32[((__ZZL7parwaveP13klatt_frame_tE5noise)>>2)]; //@line 276 "klatt.cpp"
      var $mul2=($7)*($8); //@line 276 "klatt.cpp"
      $frics=$mul2; //@line 276 "klatt.cpp"
      $n4=0; //@line 284 "klatt.cpp"
      ; //@line 284 "klatt.cpp"
      $for_body5$8: while(1) { 
  
        var $9=HEAP32[((((__ZL10kt_globals+20)&4294967295))>>2)]; //@line 286 "klatt.cpp"
        if ($9 == 1) {
          __label__ = 6;;
        }
        else if ($9 == 2) {
          __label__ = 7;;
        }
        else if ($9 == 3) {
          __label__ = 8;;
        }
        else {
        __label__ = 9;;
        }
        
        if (__label__ == 6) {
  
          var $call6=__ZL16impulsive_sourcev(); //@line 289 "klatt.cpp"
          HEAPF32[((__ZZL7parwaveP13klatt_frame_tE5voice)>>2)]=$call6; //@line 289 "klatt.cpp"
          ; //@line 290 "klatt.cpp"
        }
        else if (__label__ == 7) {
  
          var $call8=__ZL14natural_sourcev(); //@line 292 "klatt.cpp"
          HEAPF32[((__ZZL7parwaveP13klatt_frame_tE5voice)>>2)]=$call8; //@line 292 "klatt.cpp"
          ; //@line 293 "klatt.cpp"
        }
        else if (__label__ == 8) {
  
          var $call10=__ZL14sampled_sourcev(); //@line 295 "klatt.cpp"
          HEAPF32[((__ZZL7parwaveP13klatt_frame_tE5voice)>>2)]=$call10; //@line 295 "klatt.cpp"
          ; //@line 296 "klatt.cpp"
        }
  
        var $10=HEAP32[((((__ZL10kt_globals+32)&4294967295))>>2)]; //@line 300 "klatt.cpp"
        var $11=HEAP32[((((__ZL10kt_globals+40)&4294967295))>>2)]; //@line 300 "klatt.cpp"
        var $cmp11=((($10))|0) >= ((($11))|0); //@line 300 "klatt.cpp"
        if ($cmp11) { __label__ = 10;; } else { __label__ = 11;; } //@line 300 "klatt.cpp"
        if (__label__ == 10) {
  
          HEAP32[((((__ZL10kt_globals+32)&4294967295))>>2)]=0; //@line 302 "klatt.cpp"
          var $12=$frame_addr; //@line 303 "klatt.cpp"
          __ZL21pitch_synch_par_resetP13klatt_frame_t($12); //@line 303 "klatt.cpp"
          ; //@line 304 "klatt.cpp"
        }
  
        var $13=HEAPF32[((__ZZL7parwaveP13klatt_frame_tE5voice)>>2)]; //@line 311 "klatt.cpp"
        var $call14=__ZL9resonatorP11resonator_td(((__ZL10kt_globals+188+1152)&4294967295), $13); //@line 311 "klatt.cpp"
        HEAPF32[((__ZZL7parwaveP13klatt_frame_tE5voice)>>2)]=$call14; //@line 311 "klatt.cpp"
        var $14=HEAP32[((((__ZL10kt_globals+32)&4294967295))>>2)]; //@line 314 "klatt.cpp"
        var $inc=((($14)+1)&4294967295); //@line 314 "klatt.cpp"
        HEAP32[((((__ZL10kt_globals+32)&4294967295))>>2)]=$inc; //@line 314 "klatt.cpp"
        var $15=$n4; //@line 284 "klatt.cpp"
        var $inc15=((($15)+1)&4294967295); //@line 284 "klatt.cpp"
        $n4=$inc15; //@line 284 "klatt.cpp"
        var $cmp4=((($inc15))|0) < 4; //@line 284 "klatt.cpp"
        if ($cmp4) { __label__ = 5;continue $for_body5$8; } else { __label__ = 12;break $for_body5$8; } //@line 284 "klatt.cpp"
      }
  
      var $16=HEAPF32[((__ZZL7parwaveP13klatt_frame_tE5voice)>>2)]; //@line 322 "klatt.cpp"
      var $17=HEAPF32[((((__ZL10kt_globals+88)&4294967295))>>2)]; //@line 322 "klatt.cpp"
      var $mul16=($16)*($17); //@line 322 "klatt.cpp"
      var $18=HEAPF32[((__ZZL7parwaveP13klatt_frame_tE5vlast)>>2)]; //@line 322 "klatt.cpp"
      var $19=HEAPF32[((((__ZL10kt_globals+96)&4294967295))>>2)]; //@line 322 "klatt.cpp"
      var $mul17=($18)*($19); //@line 322 "klatt.cpp"
      var $add=($mul16)+($mul17); //@line 322 "klatt.cpp"
      HEAPF32[((__ZZL7parwaveP13klatt_frame_tE5voice)>>2)]=$add; //@line 322 "klatt.cpp"
      var $20=HEAPF32[((__ZZL7parwaveP13klatt_frame_tE5voice)>>2)]; //@line 323 "klatt.cpp"
      HEAPF32[((__ZZL7parwaveP13klatt_frame_tE5vlast)>>2)]=$20; //@line 323 "klatt.cpp"
      var $21=HEAP32[((((__ZL10kt_globals+32)&4294967295))>>2)]; //@line 332 "klatt.cpp"
      var $22=HEAP32[((((__ZL10kt_globals+44)&4294967295))>>2)]; //@line 332 "klatt.cpp"
      var $cmp18=((($21))|0) < ((($22))|0); //@line 332 "klatt.cpp"
      if ($cmp18) { __label__ = 13;; } else { __label__ = 14;; } //@line 332 "klatt.cpp"
      if (__label__ == 13) {
  
        var $23=HEAPF32[((((__ZL10kt_globals+144)&4294967295))>>2)]; //@line 334 "klatt.cpp"
        var $24=HEAP32[((((__ZL10kt_globals+52)&4294967295))>>2)]; //@line 334 "klatt.cpp"
        var $conv=((($24))|0); //@line 334 "klatt.cpp"
        var $mul20=($23)*($conv); //@line 334 "klatt.cpp"
        var $25=HEAPF32[((__ZZL7parwaveP13klatt_frame_tE5voice)>>2)]; //@line 334 "klatt.cpp"
        var $add21=($25)+($mul20); //@line 334 "klatt.cpp"
        HEAPF32[((__ZZL7parwaveP13klatt_frame_tE5voice)>>2)]=$add21; //@line 334 "klatt.cpp"
        ; //@line 335 "klatt.cpp"
      }
  
      var $26=HEAPF32[((((__ZL10kt_globals+112)&4294967295))>>2)]; //@line 338 "klatt.cpp"
      var $27=HEAPF32[((__ZZL7parwaveP13klatt_frame_tE5voice)>>2)]; //@line 338 "klatt.cpp"
      var $mul23=($26)*($27); //@line 338 "klatt.cpp"
      $glotout=$mul23; //@line 338 "klatt.cpp"
      var $28=HEAPF32[((((__ZL10kt_globals+120)&4294967295))>>2)]; //@line 339 "klatt.cpp"
      var $29=HEAPF32[((__ZZL7parwaveP13klatt_frame_tE5voice)>>2)]; //@line 339 "klatt.cpp"
      var $mul24=($28)*($29); //@line 339 "klatt.cpp"
      $par_glotout=$mul24; //@line 339 "klatt.cpp"
      var $30=HEAPF32[((((__ZL10kt_globals+128)&4294967295))>>2)]; //@line 342 "klatt.cpp"
      var $31=HEAPF32[((__ZZL7parwaveP13klatt_frame_tE5noise)>>2)]; //@line 342 "klatt.cpp"
      var $mul25=($30)*($31); //@line 342 "klatt.cpp"
      $aspiration=$mul25; //@line 342 "klatt.cpp"
      var $32=$aspiration; //@line 343 "klatt.cpp"
      var $33=$glotout; //@line 343 "klatt.cpp"
      var $add26=($33)+($32); //@line 343 "klatt.cpp"
      $glotout=$add26; //@line 343 "klatt.cpp"
      var $34=$aspiration; //@line 345 "klatt.cpp"
      var $35=$par_glotout; //@line 345 "klatt.cpp"
      var $add27=($35)+($34); //@line 345 "klatt.cpp"
      $par_glotout=$add27; //@line 345 "klatt.cpp"
      $out=0; //@line 352 "klatt.cpp"
      var $36=HEAP32[((((__ZL10kt_globals)&4294967295))>>2)]; //@line 353 "klatt.cpp"
      var $cmp28=((($36))|0)!=2; //@line 353 "klatt.cpp"
      if ($cmp28) { __label__ = 15;; } else { __label__ = 16;; } //@line 353 "klatt.cpp"
      if (__label__ == 15) {
  
        var $37=$glotout; //@line 355 "klatt.cpp"
        var $call30=__ZL14antiresonator2P11resonator_td($37); //@line 355 "klatt.cpp"
        $casc_next_in=$call30; //@line 355 "klatt.cpp"
        var $38=$casc_next_in; //@line 356 "klatt.cpp"
        var $call31=__ZL9resonatorP11resonator_td(((__ZL10kt_globals+188+576)&4294967295), $38); //@line 356 "klatt.cpp"
        $casc_next_in=$call31; //@line 356 "klatt.cpp"
        var $39=$casc_next_in; //@line 357 "klatt.cpp"
        var $call32=__ZL9resonatorP11resonator_td(((__ZL10kt_globals+188+512)&4294967295), $39); //@line 357 "klatt.cpp"
        $casc_next_in=$call32; //@line 357 "klatt.cpp"
        var $40=$casc_next_in; //@line 358 "klatt.cpp"
        var $call33=__ZL9resonatorP11resonator_td(((__ZL10kt_globals+188+448)&4294967295), $40); //@line 358 "klatt.cpp"
        $casc_next_in=$call33; //@line 358 "klatt.cpp"
        var $41=$casc_next_in; //@line 359 "klatt.cpp"
        var $call34=__ZL9resonatorP11resonator_td(((__ZL10kt_globals+188+384)&4294967295), $41); //@line 359 "klatt.cpp"
        $casc_next_in=$call34; //@line 359 "klatt.cpp"
        var $42=$casc_next_in; //@line 360 "klatt.cpp"
        var $call35=__ZL10resonator2P11resonator_td(((__ZL10kt_globals+188+320)&4294967295), $42); //@line 360 "klatt.cpp"
        $casc_next_in=$call35; //@line 360 "klatt.cpp"
        var $43=$casc_next_in; //@line 361 "klatt.cpp"
        var $call36=__ZL10resonator2P11resonator_td(((__ZL10kt_globals+188+256)&4294967295), $43); //@line 361 "klatt.cpp"
        $casc_next_in=$call36; //@line 361 "klatt.cpp"
        var $44=$casc_next_in; //@line 362 "klatt.cpp"
        var $call37=__ZL10resonator2P11resonator_td(((__ZL10kt_globals+188+192)&4294967295), $44); //@line 362 "klatt.cpp"
        $casc_next_in=$call37; //@line 362 "klatt.cpp"
        var $45=$casc_next_in; //@line 363 "klatt.cpp"
        var $call38=__ZL10resonator2P11resonator_td(((__ZL10kt_globals+188+128)&4294967295), $45); //@line 363 "klatt.cpp"
        $casc_next_in=$call38; //@line 363 "klatt.cpp"
        var $46=$casc_next_in; //@line 364 "klatt.cpp"
        var $call39=__ZL10resonator2P11resonator_td(((__ZL10kt_globals+188+64)&4294967295), $46); //@line 364 "klatt.cpp"
        $out=$call39; //@line 364 "klatt.cpp"
        ; //@line 365 "klatt.cpp"
      }
  
      var $47=$par_glotout; //@line 368 "klatt.cpp"
      HEAPF32[((__ZZL7parwaveP13klatt_frame_tE5sourc)>>2)]=$47; //@line 368 "klatt.cpp"
      var $48=HEAPF32[((__ZZL7parwaveP13klatt_frame_tE5sourc)>>2)]; //@line 377 "klatt.cpp"
      var $call41=__ZL9resonatorP11resonator_td(((__ZL10kt_globals+188+704)&4294967295), $48); //@line 377 "klatt.cpp"
      var $49=$out; //@line 377 "klatt.cpp"
      var $add42=($49)+($call41); //@line 377 "klatt.cpp"
      $out=$add42; //@line 377 "klatt.cpp"
      var $50=HEAPF32[((__ZZL7parwaveP13klatt_frame_tE5sourc)>>2)]; //@line 378 "klatt.cpp"
      var $call43=__ZL9resonatorP11resonator_td(((__ZL10kt_globals+188+640)&4294967295), $50); //@line 378 "klatt.cpp"
      var $51=$out; //@line 378 "klatt.cpp"
      var $add44=($51)+($call43); //@line 378 "klatt.cpp"
      $out=$add44; //@line 378 "klatt.cpp"
      var $52=$frics; //@line 380 "klatt.cpp"
      var $53=$par_glotout; //@line 380 "klatt.cpp"
      var $add45=($52)+($53); //@line 380 "klatt.cpp"
      var $54=HEAPF32[((__ZZL7parwaveP13klatt_frame_tE8glotlast)>>2)]; //@line 380 "klatt.cpp"
      var $sub=($add45)-($54); //@line 380 "klatt.cpp"
      HEAPF32[((__ZZL7parwaveP13klatt_frame_tE5sourc)>>2)]=$sub; //@line 380 "klatt.cpp"
      var $55=$par_glotout; //@line 381 "klatt.cpp"
      HEAPF32[((__ZZL7parwaveP13klatt_frame_tE8glotlast)>>2)]=$55; //@line 381 "klatt.cpp"
      $ix=12; //@line 383 "klatt.cpp"
      ; //@line 383 "klatt.cpp"
      $for_body48$25: while(1) { 
  
        var $56=$ix; //@line 385 "klatt.cpp"
        var $arrayidx=((((__ZL10kt_globals+188)&4294967295)+$56*64)&4294967295); //@line 385 "klatt.cpp"
        var $57=HEAPF32[((__ZZL7parwaveP13klatt_frame_tE5sourc)>>2)]; //@line 385 "klatt.cpp"
        var $call49=__ZL9resonatorP11resonator_td($arrayidx, $57); //@line 385 "klatt.cpp"
        var $58=$out; //@line 385 "klatt.cpp"
        var $sub50=($call49)-($58); //@line 385 "klatt.cpp"
        $out=$sub50; //@line 385 "klatt.cpp"
        var $59=$ix; //@line 383 "klatt.cpp"
        var $inc52=((($59)+1)&4294967295); //@line 383 "klatt.cpp"
        $ix=$inc52; //@line 383 "klatt.cpp"
        var $cmp47=((($inc52))|0) <= 16; //@line 383 "klatt.cpp"
        if ($cmp47) { __label__ = 17;continue $for_body48$25; } else { __label__ = 18;break $for_body48$25; } //@line 383 "klatt.cpp"
      }
  
      var $60=HEAPF32[((((__ZL10kt_globals+104)&4294967295))>>2)]; //@line 388 "klatt.cpp"
      var $61=HEAPF32[((__ZZL7parwaveP13klatt_frame_tE5sourc)>>2)]; //@line 388 "klatt.cpp"
      var $mul54=($60)*($61); //@line 388 "klatt.cpp"
      $outbypas=$mul54; //@line 388 "klatt.cpp"
      var $62=$outbypas; //@line 390 "klatt.cpp"
      var $63=$out; //@line 390 "klatt.cpp"
      var $sub55=($62)-($63); //@line 390 "klatt.cpp"
      $out=$sub55; //@line 390 "klatt.cpp"
      var $64=$out; //@line 423 "klatt.cpp"
      var $call56=__ZL9resonatorP11resonator_td(((__ZL10kt_globals+188+1216)&4294967295), $64); //@line 423 "klatt.cpp"
      $out=$call56; //@line 423 "klatt.cpp"
      var $65=$out; //@line 424 "klatt.cpp"
      var $66=HEAP32[((((_wdata+52)&4294967295))>>2)]; //@line 424 "klatt.cpp"
      var $conv57=((($66))|0); //@line 424 "klatt.cpp"
      var $mul58=($65)*($conv57); //@line 424 "klatt.cpp"
      var $67=HEAPF32[((((__ZL10kt_globals+152)&4294967295))>>2)]; //@line 424 "klatt.cpp"
      var $mul59=($mul58)*($67); //@line 424 "klatt.cpp"
      var $conv60=((($mul59))|0); //@line 424 "klatt.cpp"
      var $conv61=((($conv60))|0); //@line 424 "klatt.cpp"
      $temp=$conv61; //@line 424 "klatt.cpp"
      $z2=0; //@line 433 "klatt.cpp"
      var $68=HEAP32[((((_wdata+40)&4294967295))>>2)]; //@line 434 "klatt.cpp"
      var $69=HEAP32[((((_wdata+28)&4294967295))>>2)]; //@line 434 "klatt.cpp"
      var $cmp62=((($68))|0) < ((($69))|0); //@line 434 "klatt.cpp"
      if ($cmp62) { __label__ = 19;; } else { __label__ = 23;; } //@line 434 "klatt.cpp"
      if (__label__ == 19) {
  
        var $70=HEAP32[((((_wdata+32)&4294967295))>>2)]; //@line 436 "klatt.cpp"
        var $cmp64=((($70))|0)==0; //@line 436 "klatt.cpp"
        var $71=HEAPU32[((((_wdata+40)&4294967295))>>2)]; //@line 439 "klatt.cpp"
        var $add66=((($71)+1)&4294967295); //@line 439 "klatt.cpp"
        if ($cmp64) { __label__ = 20;; } else { __label__ = 21;; } //@line 436 "klatt.cpp"
        if (__label__ == 20) {
  
          var $72=HEAP32[((((_wdata+24)&4294967295))>>2)]; //@line 439 "klatt.cpp"
          var $arrayidx67=(($72+$add66)&4294967295); //@line 439 "klatt.cpp"
          var $73=HEAP8[($arrayidx67)]; //@line 439 "klatt.cpp"
          $c=$73; //@line 439 "klatt.cpp"
          var $74=HEAP32[((((_wdata+40)&4294967295))>>2)]; //@line 440 "klatt.cpp"
          var $75=HEAP32[((((_wdata+24)&4294967295))>>2)]; //@line 440 "klatt.cpp"
          var $arrayidx68=(($75+$74)&4294967295); //@line 440 "klatt.cpp"
          var $76=HEAPU8[($arrayidx68)]; //@line 440 "klatt.cpp"
          var $conv69=((($76))&255); //@line 440 "klatt.cpp"
          var $77=$c; //@line 440 "klatt.cpp"
          var $conv70=(tempInt=(($77)),(tempInt>=128?tempInt-256:tempInt)); //@line 440 "klatt.cpp"
          var $mul71=((($conv70)*256)&4294967295); //@line 440 "klatt.cpp"
          var $add72=((($mul71)+($conv69))&4294967295); //@line 440 "klatt.cpp"
          $sample=$add72; //@line 440 "klatt.cpp"
          var $78=HEAP32[((((_wdata+40)&4294967295))>>2)]; //@line 441 "klatt.cpp"
          var $add73=((($78)+2)&4294967295); //@line 441 "klatt.cpp"
          HEAP32[((((_wdata+40)&4294967295))>>2)]=$add73; //@line 441 "klatt.cpp"
          ; //@line 442 "klatt.cpp"
        }
        else if (__label__ == 21) {
  
          HEAP32[((((_wdata+40)&4294967295))>>2)]=$add66; //@line 446 "klatt.cpp"
          var $79=HEAP32[((((_wdata+24)&4294967295))>>2)]; //@line 446 "klatt.cpp"
          var $arrayidx75=(($79+$71)&4294967295); //@line 446 "klatt.cpp"
          var $80=HEAP8[($arrayidx75)]; //@line 446 "klatt.cpp"
          var $conv76=(tempInt=(($80)),(tempInt>=128?tempInt-256:tempInt)); //@line 446 "klatt.cpp"
          var $81=HEAP32[((((_wdata+32)&4294967295))>>2)]; //@line 446 "klatt.cpp"
          var $mul77=((($conv76)*($81))&4294967295); //@line 446 "klatt.cpp"
          $sample=$mul77; //@line 446 "klatt.cpp"
          ;
        }
  
        var $82=$sample; //@line 448 "klatt.cpp"
        var $83=HEAP32[((((_wdata+56)&4294967295))>>2)]; //@line 448 "klatt.cpp"
        var $mul79=((($83)*($82))&4294967295); //@line 448 "klatt.cpp"
        var $div=((((($mul79))|0)/1024)|0); //@line 448 "klatt.cpp"
        $z2=$div; //@line 448 "klatt.cpp"
        var $84=$z2; //@line 449 "klatt.cpp"
        var $85=HEAP32[((((_wdata+36)&4294967295))>>2)]; //@line 449 "klatt.cpp"
        var $mul80=((($85)*($84))&4294967295); //@line 449 "klatt.cpp"
        var $div81=((((($mul80))|0)/40)|0); //@line 449 "klatt.cpp"
        $z2=$div81; //@line 449 "klatt.cpp"
        var $86=$z2; //@line 450 "klatt.cpp"
        var $conv82=((($86))|0); //@line 450 "klatt.cpp"
        var $87=$temp; //@line 450 "klatt.cpp"
        var $add83=($87)+($conv82); //@line 450 "klatt.cpp"
        $temp=$add83; //@line 450 "klatt.cpp"
        ; //@line 451 "klatt.cpp"
      }
  
      var $88=HEAP32[((((__ZL10kt_globals+180)&4294967295))>>2)]; //@line 455 "klatt.cpp"
      var $cmp85=((($88))|0) > 0; //@line 455 "klatt.cpp"
      if ($cmp85) { __label__ = 24;; } else { __label__ = 25;; } //@line 455 "klatt.cpp"
      if (__label__ == 24) {
  
        var $89=HEAP32[((((__ZL10kt_globals+180)&4294967295))>>2)]; //@line 457 "klatt.cpp"
        var $dec=((($89)-1)&4294967295); //@line 457 "klatt.cpp"
        HEAP32[((((__ZL10kt_globals+180)&4294967295))>>2)]=$dec; //@line 457 "klatt.cpp"
        var $90=$temp; //@line 458 "klatt.cpp"
        var $91=HEAP32[((((__ZL10kt_globals+180)&4294967295))>>2)]; //@line 458 "klatt.cpp"
        var $conv87=((($91))|0); //@line 458 "klatt.cpp"
        var $mul88=($90)*($conv87); //@line 458 "klatt.cpp"
        var $div89=($mul88)/64; //@line 458 "klatt.cpp"
        $temp=$div89; //@line 458 "klatt.cpp"
        ; //@line 459 "klatt.cpp"
      }
  
      var $92=$temp; //@line 461 "klatt.cpp"
      var $conv91=((($92))|0); //@line 461 "klatt.cpp"
      var $93=HEAP32[((_echo_tail)>>2)]; //@line 461 "klatt.cpp"
      var $inc92=((($93)+1)&4294967295); //@line 461 "klatt.cpp"
      HEAP32[((_echo_tail)>>2)]=$inc92; //@line 461 "klatt.cpp"
      var $arrayidx93=((_echo_buf+$93*2)&4294967295); //@line 461 "klatt.cpp"
      var $94=HEAP16[(($arrayidx93)>>1)]; //@line 461 "klatt.cpp"
      var $conv94=(tempInt=(($94)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 461 "klatt.cpp"
      var $95=HEAP32[((_echo_amp)>>2)]; //@line 461 "klatt.cpp"
      var $mul95=((($conv94)*($95))&4294967295); //@line 461 "klatt.cpp"
      var $shr=($mul95) >> 8; //@line 461 "klatt.cpp"
      var $add96=((($shr)+($conv91))&4294967295); //@line 461 "klatt.cpp"
      $value=$add96; //@line 461 "klatt.cpp"
      var $96=HEAP32[((_echo_tail)>>2)]; //@line 462 "klatt.cpp"
      var $cmp97=((($96))|0) >= 5500; //@line 462 "klatt.cpp"
      if ($cmp97) { __lastLabel__ = 25; __label__ = 26;; } else { __lastLabel__ = 25; __label__ = 27;; } //@line 462 "klatt.cpp"
      if (__label__ == 26) {
  
        HEAP32[((_echo_tail)>>2)]=0; //@line 463 "klatt.cpp"
        var $_pr=$value; //@line 465 "klatt.cpp"
        __lastLabel__ = 26; ; //@line 463 "klatt.cpp"
      }
  
      var $97=__lastLabel__ == 26 ? $_pr : ($add96); //@line 465 "klatt.cpp"
      var $cmp100=((($97))|0) < -32768; //@line 465 "klatt.cpp"
      if ($cmp100) { __label__ = 28;; } else { __label__ = 29;; } //@line 465 "klatt.cpp"
      $if_end102_thread$$if_end102$41: do { 
        if (__label__ == 28) {
  
          $value=-32768; //@line 467 "klatt.cpp"
          ; //@line 470 "klatt.cpp"
        }
        else if (__label__ == 29) {
  
          var $_pr1=$value; //@line 470 "klatt.cpp"
          var $cmp103=((($_pr1))|0) > 32767; //@line 470 "klatt.cpp"
          if (!($cmp103)) { __label__ = 31;break $if_end102_thread$$if_end102$41; } //@line 470 "klatt.cpp"
  
          $value=32767; //@line 472 "klatt.cpp"
          ; //@line 473 "klatt.cpp"
        }
      } while(0);
  
      var $98=$value; //@line 475 "klatt.cpp"
      var $conv106=((($98)) & 255); //@line 475 "klatt.cpp"
      var $99=HEAP32[((_out_ptr)>>2)]; //@line 475 "klatt.cpp"
      var $incdec_ptr=(($99+1)&4294967295); //@line 475 "klatt.cpp"
      HEAP32[((_out_ptr)>>2)]=$incdec_ptr; //@line 475 "klatt.cpp"
      HEAP8[($99)]=$conv106; //@line 475 "klatt.cpp"
      var $100=$value; //@line 476 "klatt.cpp"
      var $shr107=($100) >> 8; //@line 476 "klatt.cpp"
      var $conv108=((($shr107)) & 255); //@line 476 "klatt.cpp"
      var $101=HEAP32[((_out_ptr)>>2)]; //@line 476 "klatt.cpp"
      var $incdec_ptr109=(($101+1)&4294967295); //@line 476 "klatt.cpp"
      HEAP32[((_out_ptr)>>2)]=$incdec_ptr109; //@line 476 "klatt.cpp"
      HEAP8[($101)]=$conv108; //@line 476 "klatt.cpp"
      var $102=$value; //@line 478 "klatt.cpp"
      var $conv110=((($102)) & 65535); //@line 478 "klatt.cpp"
      var $103=HEAP32[((_echo_head)>>2)]; //@line 478 "klatt.cpp"
      var $inc111=((($103)+1)&4294967295); //@line 478 "klatt.cpp"
      HEAP32[((_echo_head)>>2)]=$inc111; //@line 478 "klatt.cpp"
      var $arrayidx112=((_echo_buf+$103*2)&4294967295); //@line 478 "klatt.cpp"
      HEAP16[(($arrayidx112)>>1)]=$conv110; //@line 478 "klatt.cpp"
      var $104=HEAP32[((_echo_head)>>2)]; //@line 479 "klatt.cpp"
      var $cmp113=((($104))|0) >= 5500; //@line 479 "klatt.cpp"
      if ($cmp113) { __label__ = 32;; } else { __label__ = 33;; } //@line 479 "klatt.cpp"
      if (__label__ == 32) {
  
        HEAP32[((_echo_head)>>2)]=0; //@line 480 "klatt.cpp"
        ; //@line 480 "klatt.cpp"
      }
  
      var $105=HEAP32[((__ZL12sample_count)>>2)]; //@line 482 "klatt.cpp"
      var $inc116=((($105)+1)&4294967295); //@line 482 "klatt.cpp"
      HEAP32[((__ZL12sample_count)>>2)]=$inc116; //@line 482 "klatt.cpp"
      var $106=HEAPU32[((_out_ptr)>>2)]; //@line 483 "klatt.cpp"
      var $107=HEAPU32[((_out_end)>>2)]; //@line 483 "klatt.cpp"
      var $cmp117=((($106))>>>0) >= ((($107))>>>0); //@line 483 "klatt.cpp"
      if ($cmp117) { __label__ = 34;break $for_cond$2; } //@line 483 "klatt.cpp"
  
      var $108=HEAP32[((((__ZL10kt_globals+36)&4294967295))>>2)]; //@line 260 "klatt.cpp"
      var $inc121=((($108)+1)&4294967295); //@line 260 "klatt.cpp"
      HEAP32[((((__ZL10kt_globals+36)&4294967295))>>2)]=$inc121; //@line 260 "klatt.cpp"
      __label__ = 1;continue $for_cond$2; //@line 260 "klatt.cpp"
    }
    if (__label__ == 36) {
  
      $retval=0; //@line 488 "klatt.cpp"
      ; //@line 488 "klatt.cpp"
    }
    else if (__label__ == 34) {
  
      $retval=1; //@line 485 "klatt.cpp"
      ; //@line 485 "klatt.cpp"
    }
  
    var $109=$retval; //@line 489 "klatt.cpp"
    ;
    return $109; //@line 489 "klatt.cpp"
    return null;
  }
  

  function __Z14SetSynth_KlattiiP7frame_tS0_P7voice_ti($length, $modn, $fr1, $fr2, $v, $control) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $length_addr;
    var $modn_addr;
    var $fr1_addr;
    var $fr2_addr;
    var $v_addr;
    var $control_addr;
    var $ix;
    var $next;
    var $qix;
    var $cmd;
    var $fr3;
    $length_addr=$length;
    $modn_addr=$modn;
    $fr1_addr=$fr1;
    $fr2_addr=$fr2;
    $v_addr=$v;
    $control_addr=$control;
    var $0=HEAP32[((_wvoice)>>2)]; //@line 1122 "klatt.cpp"
    var $cmp=((($0))|0)!=0; //@line 1122 "klatt.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 5;; } //@line 1122 "klatt.cpp"
    if (__label__ == 1) {
  
      var $1=HEAP32[((_wvoice)>>2)]; //@line 1124 "klatt.cpp"
      var $klattv=(($1+112)&4294967295); //@line 1124 "klatt.cpp"
      var $arrayidx=(($klattv)&4294967295); //@line 1124 "klatt.cpp"
      var $2=HEAP32[(($arrayidx)>>2)]; //@line 1124 "klatt.cpp"
      var $cmp1=((($2))|0) > 0; //@line 1124 "klatt.cpp"
      if ($cmp1) { __label__ = 2;; } else { __label__ = 4;; } //@line 1124 "klatt.cpp"
      $land_lhs_true$$if_end$4: do { 
        if (__label__ == 2) {
  
          var $3=HEAP32[((_wvoice)>>2)]; //@line 1124 "klatt.cpp"
          var $klattv2=(($3+112)&4294967295); //@line 1124 "klatt.cpp"
          var $arrayidx3=(($klattv2)&4294967295); //@line 1124 "klatt.cpp"
          var $4=HEAP32[(($arrayidx3)>>2)]; //@line 1124 "klatt.cpp"
          var $cmp4=((($4))|0) <= 3; //@line 1124 "klatt.cpp"
          if (!($cmp4)) { __label__ = 4;break $land_lhs_true$$if_end$4; } //@line 1124 "klatt.cpp"
  
          var $5=HEAP32[((_wvoice)>>2)]; //@line 1126 "klatt.cpp"
          var $klattv6=(($5+112)&4294967295); //@line 1126 "klatt.cpp"
          var $arrayidx7=(($klattv6)&4294967295); //@line 1126 "klatt.cpp"
          var $6=HEAP32[(($arrayidx7)>>2)]; //@line 1126 "klatt.cpp"
          HEAP32[((((__ZL10kt_globals+20)&4294967295))>>2)]=$6; //@line 1126 "klatt.cpp"
          var $7=HEAP32[((((__ZL10kt_globals+20)&4294967295))>>2)]; //@line 1127 "klatt.cpp"
          var $arrayidx8=((__ZL13scale_wav_tab+$7*4)&4294967295); //@line 1127 "klatt.cpp"
          var $8=HEAP32[(($arrayidx8)>>2)]; //@line 1127 "klatt.cpp"
          HEAP32[((((__ZL10kt_globals+184)&4294967295))>>2)]=$8; //@line 1127 "klatt.cpp"
          ; //@line 1128 "klatt.cpp"
        }
      } while(0);
  
      var $9=HEAP32[((_wvoice)>>2)]; //@line 1129 "klatt.cpp"
      var $flutter=(($9+68)&4294967295); //@line 1129 "klatt.cpp"
      var $10=HEAP32[(($flutter)>>2)]; //@line 1129 "klatt.cpp"
      var $div=((((($10))|0)/32)|0); //@line 1129 "klatt.cpp"
      HEAP32[((((__ZL10kt_globals+24)&4294967295))>>2)]=$div; //@line 1129 "klatt.cpp"
      ; //@line 1130 "klatt.cpp"
    }
  
    HEAP32[((__ZL8end_wave803)>>2)]=0; //@line 1132 "klatt.cpp"
    var $11=$control_addr; //@line 1133 "klatt.cpp"
    var $and=($11) & 2; //@line 1133 "klatt.cpp"
    var $tobool=((($and))|0)!=0; //@line 1133 "klatt.cpp"
    if ($tobool) { __label__ = 6;; } else { __label__ = 7;; } //@line 1133 "klatt.cpp"
    if (__label__ == 6) {
  
      HEAP32[((__ZL8end_wave803)>>2)]=1; //@line 1135 "klatt.cpp"
      ; //@line 1136 "klatt.cpp"
    }
  
    var $12=$control_addr; //@line 1137 "klatt.cpp"
    var $and12=($12) & 1; //@line 1137 "klatt.cpp"
    var $tobool13=((($and12))|0)!=0; //@line 1137 "klatt.cpp"
    if ($tobool13) { __label__ = 8;; } else { __label__ = 20;; } //@line 1137 "klatt.cpp"
    $if_then14$$if_end44$12: do { 
      if (__label__ == 8) {
  
        HEAP32[((__ZL8end_wave803)>>2)]=1; //@line 1139 "klatt.cpp"
        var $13=HEAP32[((_wcmdq_head)>>2)]; //@line 1140 "klatt.cpp"
        var $add=((($13)+1)&4294967295); //@line 1140 "klatt.cpp"
        $qix=$add; //@line 1140 "klatt.cpp"
        __lastLabel__ = 8; ; //@line 1140 "klatt.cpp"
        $for_cond$14: while(1) { 
  
          var $14=__lastLabel__ == 19 ? $inc42 : ($add); //@line 1142 "klatt.cpp"
          var $cmp15=((($14))|0) >= 160; //@line 1142 "klatt.cpp"
          if ($cmp15) { __label__ = 10;; } else { __label__ = 11;; } //@line 1142 "klatt.cpp"
          if (__label__ == 10) {
  
            $qix=0; //@line 1142 "klatt.cpp"
            ; //@line 1142 "klatt.cpp"
          }
  
          var $15=$qix; //@line 1143 "klatt.cpp"
          var $16=HEAP32[((_wcmdq_tail)>>2)]; //@line 1143 "klatt.cpp"
          var $cmp18=((($15))|0)==((($16))|0); //@line 1143 "klatt.cpp"
          if ($cmp18) { __label__ = 20;break $if_then14$$if_end44$12; } //@line 1143 "klatt.cpp"
  
          var $17=$qix; //@line 1145 "klatt.cpp"
          var $arrayidx21=((_wcmdq+$17*16)&4294967295); //@line 1145 "klatt.cpp"
          var $arrayidx22=(($arrayidx21)&4294967295); //@line 1145 "klatt.cpp"
          var $18=HEAP32[(($arrayidx22)>>2)]; //@line 1145 "klatt.cpp"
          $cmd=$18; //@line 1145 "klatt.cpp"
          var $19=$cmd; //@line 1146 "klatt.cpp"
          var $cmp23=((($19))|0)==1; //@line 1146 "klatt.cpp"
          if ($cmp23) { __label__ = 13;break $for_cond$14; } //@line 1146 "klatt.cpp"
  
          var $31=$cmd; //@line 1162 "klatt.cpp"
          var $cmp37=((($31))|0)==6; //@line 1162 "klatt.cpp"
          var $32=$cmd; //@line 1162 "klatt.cpp"
          var $cmp38=((($32))|0)==5; //@line 1162 "klatt.cpp"
          var $or_cond=($cmp37) | ($cmp38); //@line 1162 "klatt.cpp"
          if ($or_cond) { __label__ = 20;break $if_then14$$if_end44$12; } //@line 1162 "klatt.cpp"
  
          var $33=$qix; //@line 1140 "klatt.cpp"
          var $inc42=((($33)+1)&4294967295); //@line 1140 "klatt.cpp"
          $qix=$inc42; //@line 1140 "klatt.cpp"
          __lastLabel__ = 19; __label__ = 9;continue $for_cond$14; //@line 1140 "klatt.cpp"
        }
  
        HEAP32[((__ZL8end_wave803)>>2)]=0; //@line 1148 "klatt.cpp"
        var $20=$qix; //@line 1150 "klatt.cpp"
        var $arrayidx25=((_wcmdq+$20*16)&4294967295); //@line 1150 "klatt.cpp"
        var $arrayidx26=(($arrayidx25+8)&4294967295); //@line 1150 "klatt.cpp"
        var $21=HEAP32[(($arrayidx26)>>2)]; //@line 1150 "klatt.cpp"
        var $22=($21); //@line 1150 "klatt.cpp"
        $fr3=$22; //@line 1150 "klatt.cpp"
        $ix=1; //@line 1151 "klatt.cpp"
        __lastLabel__ = 13; ; //@line 1151 "klatt.cpp"
        while(1) { 
  
          var $23=__lastLabel__ == 17 ? $inc : (1); //@line 1151 "klatt.cpp"
          var $cmp28=((($23))|0) < 6; //@line 1151 "klatt.cpp"
          if (!($cmp28)) { __label__ = 20;break $if_then14$$if_end44$12; } //@line 1151 "klatt.cpp"
  
          var $24=$ix; //@line 1153 "klatt.cpp"
          var $25=$fr3; //@line 1153 "klatt.cpp"
          var $ffreq=(($25+2)&4294967295); //@line 1153 "klatt.cpp"
          var $arrayidx29=(($ffreq+$24*2)&4294967295); //@line 1153 "klatt.cpp"
          var $26=HEAP16[(($arrayidx29)>>1)]; //@line 1153 "klatt.cpp"
          var $conv=(tempInt=(($26)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1153 "klatt.cpp"
          var $27=$ix; //@line 1153 "klatt.cpp"
          var $28=$fr2_addr; //@line 1153 "klatt.cpp"
          var $ffreq30=(($28+2)&4294967295); //@line 1153 "klatt.cpp"
          var $arrayidx31=(($ffreq30+$27*2)&4294967295); //@line 1153 "klatt.cpp"
          var $29=HEAP16[(($arrayidx31)>>1)]; //@line 1153 "klatt.cpp"
          var $conv32=(tempInt=(($29)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1153 "klatt.cpp"
          var $cmp33=((($conv))|0)!=((($conv32))|0); //@line 1153 "klatt.cpp"
          if ($cmp33) { __label__ = 16;break ; } //@line 1153 "klatt.cpp"
  
          var $30=$ix; //@line 1151 "klatt.cpp"
          var $inc=((($30)+1)&4294967295); //@line 1151 "klatt.cpp"
          $ix=$inc; //@line 1151 "klatt.cpp"
          __lastLabel__ = 17; __label__ = 14;continue ; //@line 1151 "klatt.cpp"
        }
  
        HEAP32[((__ZL8end_wave803)>>2)]=2; //@line 1156 "klatt.cpp"
        ; //@line 1157 "klatt.cpp"
      }
    } while(0);
  
    var $34=$control_addr; //@line 1191 "klatt.cpp"
    var $and45=($34) & 1; //@line 1191 "klatt.cpp"
    var $tobool46=((($and45))|0)!=0; //@line 1191 "klatt.cpp"
    if ($tobool46) { __label__ = 21;; } else { __label__ = 27;; } //@line 1191 "klatt.cpp"
    if (__label__ == 21) {
  
      $ix=1; //@line 1193 "klatt.cpp"
      __lastLabel__ = 21; ; //@line 1193 "klatt.cpp"
      while(1) { 
  
        var $35=__lastLabel__ == 25 ? $inc60 : (1); //@line 1193 "klatt.cpp"
        var $cmp49=((($35))|0) < 6; //@line 1193 "klatt.cpp"
        if (!($cmp49)) { __label__ = 26;break ; } //@line 1193 "klatt.cpp"
  
        var $36=$ix; //@line 1195 "klatt.cpp"
        var $arrayidx51=((((__ZZ14SetSynth_KlattiiP7frame_tS0_P7voice_tiE7prev_fr+2)&4294967295)+$36*2)&4294967295); //@line 1195 "klatt.cpp"
        var $37=HEAP16[(($arrayidx51)>>1)]; //@line 1195 "klatt.cpp"
        var $conv52=(tempInt=(($37)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1195 "klatt.cpp"
        var $38=$ix; //@line 1195 "klatt.cpp"
        var $39=$fr1_addr; //@line 1195 "klatt.cpp"
        var $ffreq53=(($39+2)&4294967295); //@line 1195 "klatt.cpp"
        var $arrayidx54=(($ffreq53+$38*2)&4294967295); //@line 1195 "klatt.cpp"
        var $40=HEAP16[(($arrayidx54)>>1)]; //@line 1195 "klatt.cpp"
        var $conv55=(tempInt=(($40)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1195 "klatt.cpp"
        var $cmp56=((($conv52))|0)!=((($conv55))|0); //@line 1195 "klatt.cpp"
        if ($cmp56) { __label__ = 24;break ; } //@line 1195 "klatt.cpp"
  
        var $41=$ix; //@line 1193 "klatt.cpp"
        var $inc60=((($41)+1)&4294967295); //@line 1193 "klatt.cpp"
        $ix=$inc60; //@line 1193 "klatt.cpp"
        __lastLabel__ = 25; __label__ = 22;continue ; //@line 1193 "klatt.cpp"
      }
      if (__label__ == 24) {
  
        __Z10KlattReseti(0); //@line 1199 "klatt.cpp"
        ; //@line 1200 "klatt.cpp"
      }
  
      var $42=$fr2_addr; //@line 1203 "klatt.cpp"
      var $43=$42; //@line 1203 "klatt.cpp"
      var $src$, $dest$, $stop$, $stop4$, $fast$;
      $src$ = $43;
      $dest$ = __ZZ14SetSynth_KlattiiP7frame_tS0_P7voice_tiE7prev_fr;
      $stop$ = $src$ + 64;
      if (($dest$%4) == ($src$%4) && 64 > 8) {
        while ($src$%4 !== 0 && $src$ < $stop$) {
          ; HEAP8[$dest$++] = HEAP8[$src$++];
        }
        $src$ >>= 2;
        $dest$ >>= 2;
        $stop4$ = $stop$ >> 2;
        while ($src$ < $stop4$) {
      ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
        }
        $src$ <<= 2;
        $dest$ <<= 2;
      }while ($src$ < $stop$) {
        ; HEAP8[$dest$++] = HEAP8[$src$++];
      }; //@line 1203 "klatt.cpp"
      ; //@line 1204 "klatt.cpp"
    }
  
    $ix=0; //@line 1206 "klatt.cpp"
    __lastLabel__ = 27; ; //@line 1206 "klatt.cpp"
    $for_body65$39: while(1) { 
  
      var $44=__lastLabel__ == 27 ? 0 : ($inc90); //@line 1208 "klatt.cpp"
      var $cmp66=((($44))|0) >= 5; //@line 1208 "klatt.cpp"
      if ($cmp66) { __label__ = 29;; } else { __label__ = 31;; } //@line 1208 "klatt.cpp"
      $land_lhs_true67$$if_else$41: do { 
        if (__label__ == 29) {
  
          var $45=$fr1_addr; //@line 1208 "klatt.cpp"
          var $frflags=(($45)&4294967295); //@line 1208 "klatt.cpp"
          var $46=HEAP16[(($frflags)>>1)]; //@line 1208 "klatt.cpp"
          var $conv68=(tempInt=(($46)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1208 "klatt.cpp"
          var $and69=($conv68) & 1; //@line 1208 "klatt.cpp"
          var $cmp70=((($and69))|0)==0; //@line 1208 "klatt.cpp"
          if (!($cmp70)) { __label__ = 31;break $land_lhs_true67$$if_else$41; } //@line 1208 "klatt.cpp"
  
          var $47=$ix; //@line 1210 "klatt.cpp"
          var $arrayidx72=((__ZL6klattp+$47*4)&4294967295); //@line 1210 "klatt.cpp"
          HEAP32[(($arrayidx72)>>2)]=0; //@line 1210 "klatt.cpp"
          var $48=$ix; //@line 1210 "klatt.cpp"
          var $arrayidx73=((__ZL7klattp1+$48*8)&4294967295); //@line 1210 "klatt.cpp"
          HEAPF32[(($arrayidx73)>>2)]=0; //@line 1210 "klatt.cpp"
          var $49=$ix; //@line 1211 "klatt.cpp"
          var $arrayidx74=((__ZL10klattp_inc+$49*8)&4294967295); //@line 1211 "klatt.cpp"
          HEAPF32[(($arrayidx74)>>2)]=0; //@line 1211 "klatt.cpp"
          __label__ = 32;break $land_lhs_true67$$if_else$41; //@line 1212 "klatt.cpp"
        }
      } while(0);
      if (__label__ == 31) {
  
        var $50=$ix; //@line 1215 "klatt.cpp"
        var $51=$fr1_addr; //@line 1215 "klatt.cpp"
        var $klattp=(($51+39)&4294967295); //@line 1215 "klatt.cpp"
        var $arrayidx75=(($klattp+$50)&4294967295); //@line 1215 "klatt.cpp"
        var $52=HEAPU8[($arrayidx75)]; //@line 1215 "klatt.cpp"
        var $conv76=((($52))&255); //@line 1215 "klatt.cpp"
        var $53=$ix; //@line 1215 "klatt.cpp"
        var $arrayidx77=((__ZL6klattp+$53*4)&4294967295); //@line 1215 "klatt.cpp"
        HEAP32[(($arrayidx77)>>2)]=$conv76; //@line 1215 "klatt.cpp"
        var $conv78=((($conv76))|0); //@line 1215 "klatt.cpp"
        var $54=$ix; //@line 1215 "klatt.cpp"
        var $arrayidx79=((__ZL7klattp1+$54*8)&4294967295); //@line 1215 "klatt.cpp"
        HEAPF32[(($arrayidx79)>>2)]=$conv78; //@line 1215 "klatt.cpp"
        var $55=$ix; //@line 1216 "klatt.cpp"
        var $56=$fr2_addr; //@line 1216 "klatt.cpp"
        var $klattp80=(($56+39)&4294967295); //@line 1216 "klatt.cpp"
        var $arrayidx81=(($klattp80+$55)&4294967295); //@line 1216 "klatt.cpp"
        var $57=HEAPU8[($arrayidx81)]; //@line 1216 "klatt.cpp"
        var $conv82=((($57))&255); //@line 1216 "klatt.cpp"
        var $58=$ix; //@line 1216 "klatt.cpp"
        var $arrayidx83=((__ZL6klattp+$58*4)&4294967295); //@line 1216 "klatt.cpp"
        var $59=HEAP32[(($arrayidx83)>>2)]; //@line 1216 "klatt.cpp"
        var $sub=((($conv82)-($59))&4294967295); //@line 1216 "klatt.cpp"
        var $mul=((($sub)*64)&4294967295); //@line 1216 "klatt.cpp"
        var $conv84=((($mul))|0); //@line 1216 "klatt.cpp"
        var $60=$length_addr; //@line 1216 "klatt.cpp"
        var $conv85=((($60))|0); //@line 1216 "klatt.cpp"
        var $div86=($conv84)/($conv85); //@line 1216 "klatt.cpp"
        var $61=$ix; //@line 1216 "klatt.cpp"
        var $arrayidx87=((__ZL10klattp_inc+$61*8)&4294967295); //@line 1216 "klatt.cpp"
        HEAPF32[(($arrayidx87)>>2)]=$div86; //@line 1216 "klatt.cpp"
        ;
      }
  
      var $62=$ix; //@line 1206 "klatt.cpp"
      var $inc90=((($62)+1)&4294967295); //@line 1206 "klatt.cpp"
      $ix=$inc90; //@line 1206 "klatt.cpp"
      var $cmp64=((($inc90))|0) < 10; //@line 1206 "klatt.cpp"
      if ($cmp64) { __lastLabel__ = 32; __label__ = 28;continue $for_body65$39; } else { __lastLabel__ = 32; __label__ = 33;break $for_body65$39; } //@line 1206 "klatt.cpp"
    }
  
    var $63=$length_addr; //@line 1224 "klatt.cpp"
    HEAP32[((__ZL8nsamples802)>>2)]=$63; //@line 1224 "klatt.cpp"
    $ix=1; //@line 1226 "klatt.cpp"
    ; //@line 1226 "klatt.cpp"
    $for_body94$48: while(1) { 
  
      var $64=$ix; //@line 1228 "klatt.cpp"
      var $65=$fr1_addr; //@line 1228 "klatt.cpp"
      var $ffreq95=(($65+2)&4294967295); //@line 1228 "klatt.cpp"
      var $arrayidx96=(($ffreq95+$64*2)&4294967295); //@line 1228 "klatt.cpp"
      var $66=HEAP16[(($arrayidx96)>>1)]; //@line 1228 "klatt.cpp"
      var $conv97=(tempInt=(($66)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1228 "klatt.cpp"
      var $67=$ix; //@line 1228 "klatt.cpp"
      var $68=$v_addr; //@line 1228 "klatt.cpp"
      var $freq=(($68+144)&4294967295); //@line 1228 "klatt.cpp"
      var $arrayidx98=(($freq+$67*2)&4294967295); //@line 1228 "klatt.cpp"
      var $69=HEAP16[(($arrayidx98)>>1)]; //@line 1228 "klatt.cpp"
      var $conv99=(tempInt=(($69)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1228 "klatt.cpp"
      var $mul100=((($conv99)*($conv97))&4294967295); //@line 1228 "klatt.cpp"
      var $conv101=((($mul100))|0); //@line 1228 "klatt.cpp"
      var $div102=($conv101)/256; //@line 1228 "klatt.cpp"
      var $70=$ix; //@line 1228 "klatt.cpp"
      var $71=$v_addr; //@line 1228 "klatt.cpp"
      var $freqadd=(($71+198)&4294967295); //@line 1228 "klatt.cpp"
      var $arrayidx103=(($freqadd+$70*2)&4294967295); //@line 1228 "klatt.cpp"
      var $72=HEAP16[(($arrayidx103)>>1)]; //@line 1228 "klatt.cpp"
      var $conv104=(tempInt=(($72)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1228 "klatt.cpp"
      var $conv105=((($conv104))|0); //@line 1228 "klatt.cpp"
      var $add106=($div102)+($conv105); //@line 1228 "klatt.cpp"
      var $73=$ix; //@line 1228 "klatt.cpp"
      var $arrayidx107=((__ZL5peaks801+$73*80)&4294967295); //@line 1228 "klatt.cpp"
      var $freq1=(($arrayidx107+16)&4294967295); //@line 1228 "klatt.cpp"
      HEAPF32[(($freq1)>>2)]=$add106; //@line 1228 "klatt.cpp"
      var $74=$ix; //@line 1229 "klatt.cpp"
      var $arrayidx108=((__ZL5peaks801+$74*80)&4294967295); //@line 1229 "klatt.cpp"
      var $freq1109=(($arrayidx108+16)&4294967295); //@line 1229 "klatt.cpp"
      var $75=HEAPF32[(($freq1109)>>2)]; //@line 1229 "klatt.cpp"
      var $conv110=((($75))|0); //@line 1229 "klatt.cpp"
      var $76=$ix; //@line 1229 "klatt.cpp"
      var $arrayidx111=((__ZL5peaks801+$76*80)&4294967295); //@line 1229 "klatt.cpp"
      var $freq112=(($arrayidx111)&4294967295); //@line 1229 "klatt.cpp"
      HEAP32[(($freq112)>>2)]=$conv110; //@line 1229 "klatt.cpp"
      var $77=$ix; //@line 1230 "klatt.cpp"
      var $78=$fr2_addr; //@line 1230 "klatt.cpp"
      var $ffreq113=(($78+2)&4294967295); //@line 1230 "klatt.cpp"
      var $arrayidx114=(($ffreq113+$77*2)&4294967295); //@line 1230 "klatt.cpp"
      var $79=HEAP16[(($arrayidx114)>>1)]; //@line 1230 "klatt.cpp"
      var $conv115=(tempInt=(($79)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1230 "klatt.cpp"
      var $80=$ix; //@line 1230 "klatt.cpp"
      var $81=$v_addr; //@line 1230 "klatt.cpp"
      var $freq116=(($81+144)&4294967295); //@line 1230 "klatt.cpp"
      var $arrayidx117=(($freq116+$80*2)&4294967295); //@line 1230 "klatt.cpp"
      var $82=HEAP16[(($arrayidx117)>>1)]; //@line 1230 "klatt.cpp"
      var $conv118=(tempInt=(($82)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1230 "klatt.cpp"
      var $mul119=((($conv118)*($conv115))&4294967295); //@line 1230 "klatt.cpp"
      var $conv120=((($mul119))|0); //@line 1230 "klatt.cpp"
      var $div121=($conv120)/256; //@line 1230 "klatt.cpp"
      var $83=$ix; //@line 1230 "klatt.cpp"
      var $84=$v_addr; //@line 1230 "klatt.cpp"
      var $freqadd122=(($84+198)&4294967295); //@line 1230 "klatt.cpp"
      var $arrayidx123=(($freqadd122+$83*2)&4294967295); //@line 1230 "klatt.cpp"
      var $85=HEAP16[(($arrayidx123)>>1)]; //@line 1230 "klatt.cpp"
      var $conv124=(tempInt=(($85)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1230 "klatt.cpp"
      var $conv125=((($conv124))|0); //@line 1230 "klatt.cpp"
      var $add126=($div121)+($conv125); //@line 1230 "klatt.cpp"
      $next=$add126; //@line 1230 "klatt.cpp"
      var $86=$next; //@line 1231 "klatt.cpp"
      var $87=$ix; //@line 1231 "klatt.cpp"
      var $arrayidx127=((__ZL5peaks801+$87*80)&4294967295); //@line 1231 "klatt.cpp"
      var $freq1128=(($arrayidx127+16)&4294967295); //@line 1231 "klatt.cpp"
      var $88=HEAPF32[(($freq1128)>>2)]; //@line 1231 "klatt.cpp"
      var $sub129=($86)-($88); //@line 1231 "klatt.cpp"
      var $mul130=($sub129)*64; //@line 1231 "klatt.cpp"
      var $89=$length_addr; //@line 1231 "klatt.cpp"
      var $conv131=((($89))|0); //@line 1231 "klatt.cpp"
      var $div132=($mul130)/($conv131); //@line 1231 "klatt.cpp"
      var $90=$ix; //@line 1231 "klatt.cpp"
      var $arrayidx133=((__ZL5peaks801+$90*80)&4294967295); //@line 1231 "klatt.cpp"
      var $freq_inc=(($arrayidx133+48)&4294967295); //@line 1231 "klatt.cpp"
      HEAPF32[(($freq_inc)>>2)]=$div132; //@line 1231 "klatt.cpp"
      var $91=$ix; //@line 1233 "klatt.cpp"
      var $cmp134=((($91))|0) < 4; //@line 1233 "klatt.cpp"
      if ($cmp134) { __label__ = 35;; } else { __label__ = 36;; } //@line 1233 "klatt.cpp"
      if (__label__ == 35) {
  
        var $92=$ix; //@line 1236 "klatt.cpp"
        var $93=$fr1_addr; //@line 1236 "klatt.cpp"
        var $bw=(($93+35)&4294967295); //@line 1236 "klatt.cpp"
        var $arrayidx136=(($bw+$92)&4294967295); //@line 1236 "klatt.cpp"
        var $94=HEAPU8[($arrayidx136)]; //@line 1236 "klatt.cpp"
        var $conv137=((($94))&255); //@line 1236 "klatt.cpp"
        var $mul138=((($conv137)*2)&4294967295); //@line 1236 "klatt.cpp"
        var $conv139=((($mul138))|0); //@line 1236 "klatt.cpp"
        var $95=$ix; //@line 1236 "klatt.cpp"
        var $arrayidx140=((__ZL5peaks801+$95*80)&4294967295); //@line 1236 "klatt.cpp"
        var $bw1=(($arrayidx140+24)&4294967295); //@line 1236 "klatt.cpp"
        HEAPF32[(($bw1)>>2)]=$conv139; //@line 1236 "klatt.cpp"
        var $96=$ix; //@line 1237 "klatt.cpp"
        var $arrayidx141=((__ZL5peaks801+$96*80)&4294967295); //@line 1237 "klatt.cpp"
        var $bw1142=(($arrayidx141+24)&4294967295); //@line 1237 "klatt.cpp"
        var $97=HEAPF32[(($bw1142)>>2)]; //@line 1237 "klatt.cpp"
        var $conv143=((($97))|0); //@line 1237 "klatt.cpp"
        var $98=$ix; //@line 1237 "klatt.cpp"
        var $arrayidx144=((__ZL5peaks801+$98*80)&4294967295); //@line 1237 "klatt.cpp"
        var $bw145=(($arrayidx144+4)&4294967295); //@line 1237 "klatt.cpp"
        HEAP32[(($bw145)>>2)]=$conv143; //@line 1237 "klatt.cpp"
        var $99=$ix; //@line 1238 "klatt.cpp"
        var $100=$fr2_addr; //@line 1238 "klatt.cpp"
        var $bw146=(($100+35)&4294967295); //@line 1238 "klatt.cpp"
        var $arrayidx147=(($bw146+$99)&4294967295); //@line 1238 "klatt.cpp"
        var $101=HEAPU8[($arrayidx147)]; //@line 1238 "klatt.cpp"
        var $conv148=((($101))&255); //@line 1238 "klatt.cpp"
        var $mul149=((($conv148)*2)&4294967295); //@line 1238 "klatt.cpp"
        var $conv150=((($mul149))|0); //@line 1238 "klatt.cpp"
        $next=$conv150; //@line 1238 "klatt.cpp"
        var $102=$next; //@line 1239 "klatt.cpp"
        var $103=$ix; //@line 1239 "klatt.cpp"
        var $arrayidx151=((__ZL5peaks801+$103*80)&4294967295); //@line 1239 "klatt.cpp"
        var $bw1152=(($arrayidx151+24)&4294967295); //@line 1239 "klatt.cpp"
        var $104=HEAPF32[(($bw1152)>>2)]; //@line 1239 "klatt.cpp"
        var $sub153=($102)-($104); //@line 1239 "klatt.cpp"
        var $mul154=($sub153)*64; //@line 1239 "klatt.cpp"
        var $105=$length_addr; //@line 1239 "klatt.cpp"
        var $conv155=((($105))|0); //@line 1239 "klatt.cpp"
        var $div156=($mul154)/($conv155); //@line 1239 "klatt.cpp"
        var $106=$ix; //@line 1239 "klatt.cpp"
        var $arrayidx157=((__ZL5peaks801+$106*80)&4294967295); //@line 1239 "klatt.cpp"
        var $bw_inc=(($arrayidx157+56)&4294967295); //@line 1239 "klatt.cpp"
        HEAPF32[(($bw_inc)>>2)]=$div156; //@line 1239 "klatt.cpp"
        ; //@line 1240 "klatt.cpp"
      }
  
      var $107=$ix; //@line 1226 "klatt.cpp"
      var $inc160=((($107)+1)&4294967295); //@line 1226 "klatt.cpp"
      $ix=$inc160; //@line 1226 "klatt.cpp"
      var $cmp93=((($inc160))|0) < 6; //@line 1226 "klatt.cpp"
      if ($cmp93) { __label__ = 34;continue $for_body94$48; } else { __label__ = 37;break $for_body94$48; } //@line 1226 "klatt.cpp"
    }
  
    var $108=$fr1_addr; //@line 1244 "klatt.cpp"
    var $klattp162=(($108+39)&4294967295); //@line 1244 "klatt.cpp"
    var $arrayidx163=(($klattp162+1)&4294967295); //@line 1244 "klatt.cpp"
    var $109=HEAPU8[($arrayidx163)]; //@line 1244 "klatt.cpp"
    var $conv164=((($109))&255); //@line 1244 "klatt.cpp"
    var $mul165=((($conv164)*2)&4294967295); //@line 1244 "klatt.cpp"
    var $conv166=((($mul165))|0); //@line 1244 "klatt.cpp"
    HEAPF32[((((__ZL5peaks801+16)&4294967295))>>2)]=$conv166; //@line 1244 "klatt.cpp"
    var $110=HEAPF32[((((__ZL5peaks801+16)&4294967295))>>2)]; //@line 1245 "klatt.cpp"
    var $cmp167=($110) == 0; //@line 1245 "klatt.cpp"
    if ($cmp167) { __label__ = 38;; } else { __label__ = 39;; } //@line 1245 "klatt.cpp"
    if (__label__ == 38) {
  
      var $111=HEAP32[((((__ZL8kt_frame+8+36)&4294967295))>>2)]; //@line 1246 "klatt.cpp"
      var $conv169=((($111))|0); //@line 1246 "klatt.cpp"
      HEAPF32[((((__ZL5peaks801+16)&4294967295))>>2)]=$conv169; //@line 1246 "klatt.cpp"
      ; //@line 1246 "klatt.cpp"
    }
  
    var $112=HEAPF32[((((__ZL5peaks801+16)&4294967295))>>2)]; //@line 1248 "klatt.cpp"
    var $conv171=((($112))|0); //@line 1248 "klatt.cpp"
    HEAP32[((((__ZL5peaks801)&4294967295))>>2)]=$conv171; //@line 1248 "klatt.cpp"
    var $113=$fr2_addr; //@line 1249 "klatt.cpp"
    var $klattp172=(($113+39)&4294967295); //@line 1249 "klatt.cpp"
    var $arrayidx173=(($klattp172+1)&4294967295); //@line 1249 "klatt.cpp"
    var $114=HEAPU8[($arrayidx173)]; //@line 1249 "klatt.cpp"
    var $conv174=((($114))&255); //@line 1249 "klatt.cpp"
    var $mul175=((($conv174)*2)&4294967295); //@line 1249 "klatt.cpp"
    var $conv176=((($mul175))|0); //@line 1249 "klatt.cpp"
    $next=$conv176; //@line 1249 "klatt.cpp"
    var $cmp177=($conv176) == 0; //@line 1250 "klatt.cpp"
    if ($cmp177) { __label__ = 40;; } else { __label__ = 41;; } //@line 1250 "klatt.cpp"
    if (__label__ == 40) {
  
      var $115=HEAP32[((((__ZL8kt_frame+8+36)&4294967295))>>2)]; //@line 1251 "klatt.cpp"
      var $conv179=((($115))|0); //@line 1251 "klatt.cpp"
      $next=$conv179; //@line 1251 "klatt.cpp"
      ; //@line 1251 "klatt.cpp"
    }
  
    var $116=$next; //@line 1253 "klatt.cpp"
    var $117=HEAPF32[((((__ZL5peaks801+16)&4294967295))>>2)]; //@line 1253 "klatt.cpp"
    var $sub181=($116)-($117); //@line 1253 "klatt.cpp"
    var $mul182=($sub181)*64; //@line 1253 "klatt.cpp"
    var $118=$length_addr; //@line 1253 "klatt.cpp"
    var $conv183=((($118))|0); //@line 1253 "klatt.cpp"
    var $div184=($mul182)/($conv183); //@line 1253 "klatt.cpp"
    HEAPF32[((((__ZL5peaks801+48)&4294967295))>>2)]=$div184; //@line 1253 "klatt.cpp"
    HEAPF32[((((__ZL5peaks801+24)&4294967295))>>2)]=89; //@line 1255 "klatt.cpp"
    HEAP32[((((__ZL5peaks801+4)&4294967295))>>2)]=89; //@line 1256 "klatt.cpp"
    HEAPF32[((((__ZL5peaks801+56)&4294967295))>>2)]=0; //@line 1257 "klatt.cpp"
    var $119=$fr1_addr; //@line 1259 "klatt.cpp"
    var $frflags185=(($119)&4294967295); //@line 1259 "klatt.cpp"
    var $120=HEAP16[(($frflags185)>>1)]; //@line 1259 "klatt.cpp"
    var $conv186=(tempInt=(($120)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1259 "klatt.cpp"
    var $and187=($conv186) & 1; //@line 1259 "klatt.cpp"
    var $tobool188=((($and187))|0)!=0; //@line 1259 "klatt.cpp"
    if ($tobool188) { __label__ = 42;; } else { __label__ = 44;; } //@line 1259 "klatt.cpp"
    $if_then189$$if_end236$60: do { 
      if (__label__ == 42) {
  
        $ix=1; //@line 1262 "klatt.cpp"
        ; //@line 1262 "klatt.cpp"
        while(1) { 
  
          var $121=$ix; //@line 1264 "klatt.cpp"
          var $122=$fr1_addr; //@line 1264 "klatt.cpp"
          var $klatt_bp=(($122+56)&4294967295); //@line 1264 "klatt.cpp"
          var $arrayidx193=(($klatt_bp+$121)&4294967295); //@line 1264 "klatt.cpp"
          var $123=HEAPU8[($arrayidx193)]; //@line 1264 "klatt.cpp"
          var $conv194=((($123))&255); //@line 1264 "klatt.cpp"
          var $mul195=((($conv194)*4)&4294967295); //@line 1264 "klatt.cpp"
          var $conv196=((($mul195))|0); //@line 1264 "klatt.cpp"
          var $124=$ix; //@line 1264 "klatt.cpp"
          var $arrayidx197=((__ZL5peaks801+$124*80)&4294967295); //@line 1264 "klatt.cpp"
          var $bp1=(($arrayidx197+40)&4294967295); //@line 1264 "klatt.cpp"
          HEAPF32[(($bp1)>>2)]=$conv196; //@line 1264 "klatt.cpp"
          var $125=$ix; //@line 1265 "klatt.cpp"
          var $arrayidx198=((__ZL5peaks801+$125*80)&4294967295); //@line 1265 "klatt.cpp"
          var $bp1199=(($arrayidx198+40)&4294967295); //@line 1265 "klatt.cpp"
          var $126=HEAPF32[(($bp1199)>>2)]; //@line 1265 "klatt.cpp"
          var $conv200=((($126))|0); //@line 1265 "klatt.cpp"
          var $127=$ix; //@line 1265 "klatt.cpp"
          var $arrayidx201=((__ZL5peaks801+$127*80)&4294967295); //@line 1265 "klatt.cpp"
          var $bp=(($arrayidx201+12)&4294967295); //@line 1265 "klatt.cpp"
          HEAP32[(($bp)>>2)]=$conv200; //@line 1265 "klatt.cpp"
          var $128=$ix; //@line 1266 "klatt.cpp"
          var $129=$fr2_addr; //@line 1266 "klatt.cpp"
          var $klatt_bp202=(($129+56)&4294967295); //@line 1266 "klatt.cpp"
          var $arrayidx203=(($klatt_bp202+$128)&4294967295); //@line 1266 "klatt.cpp"
          var $130=HEAPU8[($arrayidx203)]; //@line 1266 "klatt.cpp"
          var $conv204=((($130))&255); //@line 1266 "klatt.cpp"
          var $mul205=((($conv204)*2)&4294967295); //@line 1266 "klatt.cpp"
          var $conv206=((($mul205))|0); //@line 1266 "klatt.cpp"
          $next=$conv206; //@line 1266 "klatt.cpp"
          var $131=$next; //@line 1267 "klatt.cpp"
          var $132=$ix; //@line 1267 "klatt.cpp"
          var $arrayidx207=((__ZL5peaks801+$132*80)&4294967295); //@line 1267 "klatt.cpp"
          var $bp1208=(($arrayidx207+40)&4294967295); //@line 1267 "klatt.cpp"
          var $133=HEAPF32[(($bp1208)>>2)]; //@line 1267 "klatt.cpp"
          var $sub209=($131)-($133); //@line 1267 "klatt.cpp"
          var $mul210=($sub209)*64; //@line 1267 "klatt.cpp"
          var $134=$length_addr; //@line 1267 "klatt.cpp"
          var $conv211=((($134))|0); //@line 1267 "klatt.cpp"
          var $div212=($mul210)/($conv211); //@line 1267 "klatt.cpp"
          var $135=$ix; //@line 1267 "klatt.cpp"
          var $arrayidx213=((__ZL5peaks801+$135*80)&4294967295); //@line 1267 "klatt.cpp"
          var $bp_inc=(($arrayidx213+72)&4294967295); //@line 1267 "klatt.cpp"
          HEAPF32[(($bp_inc)>>2)]=$div212; //@line 1267 "klatt.cpp"
          var $136=$ix; //@line 1269 "klatt.cpp"
          var $137=$fr1_addr; //@line 1269 "klatt.cpp"
          var $klatt_ap=(($137+49)&4294967295); //@line 1269 "klatt.cpp"
          var $arrayidx214=(($klatt_ap+$136)&4294967295); //@line 1269 "klatt.cpp"
          var $138=HEAPU8[($arrayidx214)]; //@line 1269 "klatt.cpp"
          var $conv215=((($138))&255); //@line 1269 "klatt.cpp"
          var $139=$ix; //@line 1269 "klatt.cpp"
          var $arrayidx216=((__ZL5peaks801+$139*80)&4294967295); //@line 1269 "klatt.cpp"
          var $ap1=(($arrayidx216+32)&4294967295); //@line 1269 "klatt.cpp"
          HEAPF32[(($ap1)>>2)]=$conv215; //@line 1269 "klatt.cpp"
          var $140=$ix; //@line 1270 "klatt.cpp"
          var $arrayidx217=((__ZL5peaks801+$140*80)&4294967295); //@line 1270 "klatt.cpp"
          var $ap1218=(($arrayidx217+32)&4294967295); //@line 1270 "klatt.cpp"
          var $141=HEAPF32[(($ap1218)>>2)]; //@line 1270 "klatt.cpp"
          var $conv219=((($141))|0); //@line 1270 "klatt.cpp"
          var $142=$ix; //@line 1270 "klatt.cpp"
          var $arrayidx220=((__ZL5peaks801+$142*80)&4294967295); //@line 1270 "klatt.cpp"
          var $ap=(($arrayidx220+8)&4294967295); //@line 1270 "klatt.cpp"
          HEAP32[(($ap)>>2)]=$conv219; //@line 1270 "klatt.cpp"
          var $143=$ix; //@line 1271 "klatt.cpp"
          var $144=$fr2_addr; //@line 1271 "klatt.cpp"
          var $klatt_ap221=(($144+49)&4294967295); //@line 1271 "klatt.cpp"
          var $arrayidx222=(($klatt_ap221+$143)&4294967295); //@line 1271 "klatt.cpp"
          var $145=HEAPU8[($arrayidx222)]; //@line 1271 "klatt.cpp"
          var $conv223=((($145))&255); //@line 1271 "klatt.cpp"
          var $mul224=((($conv223)*2)&4294967295); //@line 1271 "klatt.cpp"
          var $conv225=((($mul224))|0); //@line 1271 "klatt.cpp"
          $next=$conv225; //@line 1271 "klatt.cpp"
          var $146=$next; //@line 1272 "klatt.cpp"
          var $147=$ix; //@line 1272 "klatt.cpp"
          var $arrayidx226=((__ZL5peaks801+$147*80)&4294967295); //@line 1272 "klatt.cpp"
          var $ap1227=(($arrayidx226+32)&4294967295); //@line 1272 "klatt.cpp"
          var $148=HEAPF32[(($ap1227)>>2)]; //@line 1272 "klatt.cpp"
          var $sub228=($146)-($148); //@line 1272 "klatt.cpp"
          var $mul229=($sub228)*64; //@line 1272 "klatt.cpp"
          var $149=$length_addr; //@line 1272 "klatt.cpp"
          var $conv230=((($149))|0); //@line 1272 "klatt.cpp"
          var $div231=($mul229)/($conv230); //@line 1272 "klatt.cpp"
          var $150=$ix; //@line 1272 "klatt.cpp"
          var $arrayidx232=((__ZL5peaks801+$150*80)&4294967295); //@line 1272 "klatt.cpp"
          var $ap_inc=(($arrayidx232+64)&4294967295); //@line 1272 "klatt.cpp"
          HEAPF32[(($ap_inc)>>2)]=$div231; //@line 1272 "klatt.cpp"
          var $151=$ix; //@line 1262 "klatt.cpp"
          var $inc234=((($151)+1)&4294967295); //@line 1262 "klatt.cpp"
          $ix=$inc234; //@line 1262 "klatt.cpp"
          var $cmp191=((($inc234))|0) < 7; //@line 1262 "klatt.cpp"
          if ($cmp191) { __label__ = 43;continue ; } else { __label__ = 44;break $if_then189$$if_end236$60; } //@line 1262 "klatt.cpp"
        }
      }
    } while(0);
  
    ;
    return; //@line 1275 "klatt.cpp"
    return;
  }
  

  function __Z14Wavegen_Klatt2iiiP7frame_tS0_($length, $modulation, $resume, $fr1, $fr2) {
    ;
    var __label__;
  
    var $length_addr;
    var $modulation_addr;
    var $resume_addr;
    var $fr1_addr;
    var $fr2_addr;
    $length_addr=$length;
    $modulation_addr=$modulation;
    $resume_addr=$resume;
    $fr1_addr=$fr1;
    $fr2_addr=$fr2;
    var $0=$resume_addr; //@line 1280 "klatt.cpp"
    var $cmp=((($0))|0)==0; //@line 1280 "klatt.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 1280 "klatt.cpp"
    if (__label__ == 1) {
  
      var $1=$length_addr; //@line 1281 "klatt.cpp"
      var $2=$modulation_addr; //@line 1281 "klatt.cpp"
      var $3=$fr1_addr; //@line 1281 "klatt.cpp"
      var $4=$fr2_addr; //@line 1281 "klatt.cpp"
      var $5=HEAP32[((_wvoice)>>2)]; //@line 1281 "klatt.cpp"
      __Z14SetSynth_KlattiiP7frame_tS0_P7voice_ti($1, $2, $3, $4, $5, 1); //@line 1281 "klatt.cpp"
      ; //@line 1281 "klatt.cpp"
    }
  
    var $6=$resume_addr; //@line 1283 "klatt.cpp"
    var $call=__Z13Wavegen_Klatti($6); //@line 1283 "klatt.cpp"
    ;
    return $call; //@line 1283 "klatt.cpp"
    return null;
  }
  

  function __Z9KlattInitv() {
    ;
    var __label__;
  
    var $ix;
    HEAP32[((__ZL12sample_count)>>2)]=0; //@line 1309 "klatt.cpp"
    HEAP32[((((__ZL10kt_globals)&4294967295))>>2)]=1; //@line 1311 "klatt.cpp"
    HEAP32[((((__ZL10kt_globals+8)&4294967295))>>2)]=22050; //@line 1312 "klatt.cpp"
    HEAP32[((((__ZL10kt_globals+20)&4294967295))>>2)]=1; //@line 1314 "klatt.cpp"
    var $0=HEAP32[((((__ZL10kt_globals+20)&4294967295))>>2)]; //@line 1315 "klatt.cpp"
    var $arrayidx=((__ZL13scale_wav_tab+$0*4)&4294967295); //@line 1315 "klatt.cpp"
    var $1=HEAP32[(($arrayidx)>>2)]; //@line 1315 "klatt.cpp"
    HEAP32[((((__ZL10kt_globals+184)&4294967295))>>2)]=$1; //@line 1315 "klatt.cpp"
    HEAP32[((((__ZL10kt_globals+172)&4294967295))>>2)]=((__ZZ9KlattInitvE15natural_samples)&4294967295); //@line 1316 "klatt.cpp"
    HEAP32[((((__ZL10kt_globals+160)&4294967295))>>2)]=100; //@line 1317 "klatt.cpp"
    HEAPF32[((((__ZL10kt_globals+164)&4294967295))>>2)]=3; //@line 1318 "klatt.cpp"
    var $2=HEAP32[((((__ZL10kt_globals+8)&4294967295))>>2)]; //@line 1319 "klatt.cpp"
    var $mul=((($2)*10)&4294967295); //@line 1319 "klatt.cpp"
    var $div=((((($mul))|0)/1000)|0); //@line 1319 "klatt.cpp"
    HEAP32[((((__ZL10kt_globals+28)&4294967295))>>2)]=$div; //@line 1319 "klatt.cpp"
    HEAP32[((((__ZL10kt_globals+4)&4294967295))>>2)]=0; //@line 1320 "klatt.cpp"
    HEAP32[((((__ZL10kt_globals+24)&4294967295))>>2)]=20; //@line 1321 "klatt.cpp"
    __Z10KlattReseti(2); //@line 1323 "klatt.cpp"
    $ix=0; //@line 1326 "klatt.cpp"
    ; //@line 1326 "klatt.cpp"
    while(1) { 
  
      var $3=$ix; //@line 1328 "klatt.cpp"
      var $arrayidx1=((__ZZ9KlattInitvE10formant_hz+$3*2)&4294967295); //@line 1328 "klatt.cpp"
      var $4=HEAP16[(($arrayidx1)>>1)]; //@line 1328 "klatt.cpp"
      var $conv=(tempInt=(($4)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1328 "klatt.cpp"
      var $5=$ix; //@line 1328 "klatt.cpp"
      var $arrayidx2=((((__ZL8kt_frame+8)&4294967295)+$5*4)&4294967295); //@line 1328 "klatt.cpp"
      HEAP32[(($arrayidx2)>>2)]=$conv; //@line 1328 "klatt.cpp"
      var $6=$ix; //@line 1329 "klatt.cpp"
      var $arrayidx3=((__ZZ9KlattInitvE9bandwidth+$6*2)&4294967295); //@line 1329 "klatt.cpp"
      var $7=HEAP16[(($arrayidx3)>>1)]; //@line 1329 "klatt.cpp"
      var $conv4=(tempInt=(($7)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1329 "klatt.cpp"
      var $8=$ix; //@line 1329 "klatt.cpp"
      var $arrayidx5=((((__ZL8kt_frame+48)&4294967295)+$8*4)&4294967295); //@line 1329 "klatt.cpp"
      HEAP32[(($arrayidx5)>>2)]=$conv4; //@line 1329 "klatt.cpp"
      var $9=$ix; //@line 1330 "klatt.cpp"
      var $arrayidx6=((__ZZ9KlattInitvE12parallel_amp+$9*2)&4294967295); //@line 1330 "klatt.cpp"
      var $10=HEAP16[(($arrayidx6)>>1)]; //@line 1330 "klatt.cpp"
      var $conv7=(tempInt=(($10)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1330 "klatt.cpp"
      var $11=$ix; //@line 1330 "klatt.cpp"
      var $arrayidx8=((((__ZL8kt_frame+88)&4294967295)+$11*4)&4294967295); //@line 1330 "klatt.cpp"
      HEAP32[(($arrayidx8)>>2)]=$conv7; //@line 1330 "klatt.cpp"
      var $12=$ix; //@line 1331 "klatt.cpp"
      var $arrayidx9=((__ZZ9KlattInitvE11parallel_bw+$12*2)&4294967295); //@line 1331 "klatt.cpp"
      var $13=HEAP16[(($arrayidx9)>>1)]; //@line 1331 "klatt.cpp"
      var $conv10=(tempInt=(($13)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1331 "klatt.cpp"
      var $14=$ix; //@line 1331 "klatt.cpp"
      var $arrayidx11=((((__ZL8kt_frame+128)&4294967295)+$14*4)&4294967295); //@line 1331 "klatt.cpp"
      HEAP32[(($arrayidx11)>>2)]=$conv10; //@line 1331 "klatt.cpp"
      var $15=$ix; //@line 1326 "klatt.cpp"
      var $inc=((($15)+1)&4294967295); //@line 1326 "klatt.cpp"
      $ix=$inc; //@line 1326 "klatt.cpp"
      var $cmp=((($inc))|0) <= 9; //@line 1326 "klatt.cpp"
      if ($cmp) { __label__ = 1;continue ; } else { __label__ = 2;break ; } //@line 1326 "klatt.cpp"
    }
  
    HEAP32[((((__ZL8kt_frame+248)&4294967295))>>2)]=89; //@line 1333 "klatt.cpp"
    HEAP32[((((__ZL8kt_frame)&4294967295))>>2)]=1000; //@line 1335 "klatt.cpp"
    HEAP32[((((__ZL8kt_frame+4)&4294967295))>>2)]=59; //@line 1336 "klatt.cpp"
    HEAP32[((((__ZL8kt_frame+168)&4294967295))>>2)]=0; //@line 1337 "klatt.cpp"
    HEAP32[((((__ZL8kt_frame+172)&4294967295))>>2)]=40; //@line 1338 "klatt.cpp"
    HEAP32[((((__ZL8kt_frame+176)&4294967295))>>2)]=0; //@line 1339 "klatt.cpp"
    HEAP32[((((__ZL8kt_frame+180)&4294967295))>>2)]=0; //@line 1340 "klatt.cpp"
    HEAP32[((((__ZL8kt_frame+184)&4294967295))>>2)]=50; //@line 1341 "klatt.cpp"
    HEAP32[((((__ZL8kt_frame+188)&4294967295))>>2)]=0; //@line 1342 "klatt.cpp"
    HEAP32[((((__ZL8kt_frame+192)&4294967295))>>2)]=0; //@line 1343 "klatt.cpp"
    HEAP32[((((__ZL8kt_frame+196)&4294967295))>>2)]=0; //@line 1344 "klatt.cpp"
    HEAP32[((((__ZL8kt_frame+200)&4294967295))>>2)]=62; //@line 1345 "klatt.cpp"
    ;
    return; //@line 1346 "klatt.cpp"
    return;
  }
  

  function __ZL7flutterP13klatt_frame_t($frame) {
    ;
    var __label__;
  
    var $frame_addr;
    var $delta_f0;
    var $fla;
    var $flb;
    var $flc;
    var $fld;
    var $fle;
    $frame_addr=$frame;
    var $0=HEAP32[((((__ZL10kt_globals+24)&4294967295))>>2)]; //@line 159 "klatt.cpp"
    var $conv=((($0))|0); //@line 159 "klatt.cpp"
    var $div=($conv)/50; //@line 159 "klatt.cpp"
    $fla=$div; //@line 159 "klatt.cpp"
    var $1=HEAP32[((((__ZL10kt_globals+176)&4294967295))>>2)]; //@line 160 "klatt.cpp"
    var $conv1=((($1))|0); //@line 160 "klatt.cpp"
    var $div2=($conv1)/100; //@line 160 "klatt.cpp"
    $flb=$div2; //@line 160 "klatt.cpp"
    var $2=HEAP32[((__ZZL7flutterP13klatt_frame_tE10time_count)>>2)]; //@line 164 "klatt.cpp"
    var $conv3=((($2))|0); //@line 164 "klatt.cpp"
    var $mul=39.898227289999994*($conv3); //@line 164 "klatt.cpp"
    var $call=_sin($mul); //@line 164 "klatt.cpp"
    $flc=$call; //@line 164 "klatt.cpp"
    var $3=HEAP32[((__ZZL7flutterP13klatt_frame_tE10time_count)>>2)]; //@line 165 "klatt.cpp"
    var $conv4=((($3))|0); //@line 165 "klatt.cpp"
    var $mul5=22.305308169999996*($conv4); //@line 165 "klatt.cpp"
    var $call6=_sin($mul5); //@line 165 "klatt.cpp"
    $fld=$call6; //@line 165 "klatt.cpp"
    var $4=HEAP32[((__ZZL7flutterP13klatt_frame_tE10time_count)>>2)]; //@line 166 "klatt.cpp"
    var $conv7=((($4))|0); //@line 166 "klatt.cpp"
    var $mul8=14.76548569*($conv7); //@line 166 "klatt.cpp"
    var $call9=_sin($mul8); //@line 166 "klatt.cpp"
    $fle=$call9; //@line 166 "klatt.cpp"
    var $5=$fla; //@line 167 "klatt.cpp"
    var $6=$flb; //@line 167 "klatt.cpp"
    var $mul10=($5)*($6); //@line 167 "klatt.cpp"
    var $7=$flc; //@line 167 "klatt.cpp"
    var $8=$fld; //@line 167 "klatt.cpp"
    var $add=($7)+($8); //@line 167 "klatt.cpp"
    var $9=$fle; //@line 167 "klatt.cpp"
    var $add11=($add)+($9); //@line 167 "klatt.cpp"
    var $mul12=($mul10)*($add11); //@line 167 "klatt.cpp"
    var $mul13=($mul12)*10; //@line 167 "klatt.cpp"
    $delta_f0=$mul13; //@line 167 "klatt.cpp"
    var $10=$frame_addr; //@line 168 "klatt.cpp"
    var $F0hz10=(($10)&4294967295); //@line 168 "klatt.cpp"
    var $11=HEAP32[(($F0hz10)>>2)]; //@line 168 "klatt.cpp"
    var $12=$delta_f0; //@line 168 "klatt.cpp"
    var $conv14=((($12))|0); //@line 168 "klatt.cpp"
    var $add15=((($conv14)+($11))&4294967295); //@line 168 "klatt.cpp"
    var $13=$frame_addr; //@line 168 "klatt.cpp"
    var $F0hz1016=(($13)&4294967295); //@line 168 "klatt.cpp"
    HEAP32[(($F0hz1016)>>2)]=$add15; //@line 168 "klatt.cpp"
    var $14=HEAP32[((__ZZL7flutterP13klatt_frame_tE10time_count)>>2)]; //@line 169 "klatt.cpp"
    var $inc=((($14)+1)&4294967295); //@line 169 "klatt.cpp"
    HEAP32[((__ZZL7flutterP13klatt_frame_tE10time_count)>>2)]=$inc; //@line 169 "klatt.cpp"
    ;
    return; //@line 170 "klatt.cpp"
    return;
  }
  

  function __ZL9gen_noised($noise) {
    ;
    var __label__;
  
    var $noise_addr;
    var $temp;
    $noise_addr=$noise;
    var $call=_rand(); //@line 928 "klatt.cpp"
    var $rem=((($call))|0)%16383; //@line 928 "klatt.cpp"
    var $add=((($rem)-8191)&4294967295); //@line 928 "klatt.cpp"
    $temp=$add; //@line 928 "klatt.cpp"
    var $0=$temp; //@line 929 "klatt.cpp"
    HEAP32[((((__ZL10kt_globals+52)&4294967295))>>2)]=$0; //@line 929 "klatt.cpp"
    var $1=HEAP32[((((__ZL10kt_globals+52)&4294967295))>>2)]; //@line 931 "klatt.cpp"
    var $conv=((($1))|0); //@line 931 "klatt.cpp"
    var $2=HEAPF32[((__ZZL9gen_noisedE5nlast)>>2)]; //@line 931 "klatt.cpp"
    var $mul=0.75*($2); //@line 931 "klatt.cpp"
    var $add1=($conv)+($mul); //@line 931 "klatt.cpp"
    $noise_addr=$add1; //@line 931 "klatt.cpp"
    var $3=$noise_addr; //@line 932 "klatt.cpp"
    HEAPF32[((__ZZL9gen_noisedE5nlast)>>2)]=$3; //@line 932 "klatt.cpp"
    var $4=$noise_addr; //@line 934 "klatt.cpp"
    ;
    return $4; //@line 934 "klatt.cpp"
    return null;
  }
  

  function __ZL16impulsive_sourcev() {
    ;
    var __label__;
  
    var $0=HEAP32[((((__ZL10kt_globals+32)&4294967295))>>2)]; //@line 627 "klatt.cpp"
    var $cmp=((($0))|0) < 3; //@line 627 "klatt.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 627 "klatt.cpp"
    if (__label__ == 1) {
  
      var $1=HEAP32[((((__ZL10kt_globals+32)&4294967295))>>2)]; //@line 629 "klatt.cpp"
      var $arrayidx=((__ZZL16impulsive_sourcevE7doublet+$1*8)&4294967295); //@line 629 "klatt.cpp"
      var $2=HEAPF32[(($arrayidx)>>2)]; //@line 629 "klatt.cpp"
      HEAPF32[((__ZZL16impulsive_sourcevE5vwave)>>2)]=$2; //@line 629 "klatt.cpp"
      ; //@line 630 "klatt.cpp"
    }
    else if (__label__ == 2) {
  
      HEAPF32[((__ZZL16impulsive_sourcevE5vwave)>>2)]=0; //@line 633 "klatt.cpp"
      ;
    }
  
    var $3=HEAPF32[((__ZZL16impulsive_sourcevE5vwave)>>2)]; //@line 636 "klatt.cpp"
    var $call=__ZL9resonatorP11resonator_td(((__ZL10kt_globals+188+1088)&4294967295), $3); //@line 636 "klatt.cpp"
    ;
    return $call; //@line 636 "klatt.cpp"
    return null;
  }
  

  function __ZL14natural_sourcev() {
    ;
    var __label__;
  
    var $retval;
    var $lgtemp;
    var $0=HEAP32[((((__ZL10kt_globals+32)&4294967295))>>2)]; //@line 653 "klatt.cpp"
    var $1=HEAP32[((((__ZL10kt_globals+44)&4294967295))>>2)]; //@line 653 "klatt.cpp"
    var $cmp=((($0))|0) < ((($1))|0); //@line 653 "klatt.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 653 "klatt.cpp"
    if (__label__ == 1) {
  
      var $2=HEAPF32[((((__ZL10kt_globals+64)&4294967295))>>2)]; //@line 655 "klatt.cpp"
      var $3=HEAPF32[((((__ZL10kt_globals+56)&4294967295))>>2)]; //@line 655 "klatt.cpp"
      var $sub=($3)-($2); //@line 655 "klatt.cpp"
      HEAPF32[((((__ZL10kt_globals+56)&4294967295))>>2)]=$sub; //@line 655 "klatt.cpp"
      var $4=HEAPF32[((((__ZL10kt_globals+56)&4294967295))>>2)]; //@line 656 "klatt.cpp"
      var $5=HEAPF32[((__ZZL14natural_sourcevE5vwave)>>2)]; //@line 656 "klatt.cpp"
      var $add=($5)+($4); //@line 656 "klatt.cpp"
      HEAPF32[((__ZZL14natural_sourcevE5vwave)>>2)]=$add; //@line 656 "klatt.cpp"
      var $6=HEAPF32[((__ZZL14natural_sourcevE5vwave)>>2)]; //@line 657 "klatt.cpp"
      var $mul=($6)*0.028; //@line 657 "klatt.cpp"
      $lgtemp=$mul; //@line 657 "klatt.cpp"
      var $7=$lgtemp; //@line 659 "klatt.cpp"
      $retval=$7; //@line 659 "klatt.cpp"
      ; //@line 659 "klatt.cpp"
    }
    else if (__label__ == 2) {
  
      HEAPF32[((__ZZL14natural_sourcevE5vwave)>>2)]=0; //@line 663 "klatt.cpp"
      $retval=0; //@line 664 "klatt.cpp"
      ; //@line 664 "klatt.cpp"
    }
  
    var $8=$retval; //@line 666 "klatt.cpp"
    ;
    return $8; //@line 666 "klatt.cpp"
    return null;
  }
  

  function __ZL14sampled_sourcev() {
    ;
    var __label__;
  
    var $itemp;
    var $ftemp;
    var $result;
    var $diff_value;
    var $current_value;
    var $next_value;
    var $temp_diff;
    var $0=HEAP32[((((__ZL10kt_globals+40)&4294967295))>>2)]; //@line 191 "klatt.cpp"
    var $cmp=((($0))|0)!=0; //@line 191 "klatt.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 191 "klatt.cpp"
    if (__label__ == 1) {
  
      var $1=HEAP32[((((__ZL10kt_globals+32)&4294967295))>>2)]; //@line 193 "klatt.cpp"
      var $conv=((($1))|0); //@line 193 "klatt.cpp"
      $ftemp=$conv; //@line 193 "klatt.cpp"
      var $2=$ftemp; //@line 194 "klatt.cpp"
      var $3=HEAP32[((((__ZL10kt_globals+40)&4294967295))>>2)]; //@line 194 "klatt.cpp"
      var $conv1=((($3))|0); //@line 194 "klatt.cpp"
      var $div=($2)/($conv1); //@line 194 "klatt.cpp"
      $ftemp=$div; //@line 194 "klatt.cpp"
      var $4=$ftemp; //@line 195 "klatt.cpp"
      var $5=HEAP32[((((__ZL10kt_globals+160)&4294967295))>>2)]; //@line 195 "klatt.cpp"
      var $conv2=((($5))|0); //@line 195 "klatt.cpp"
      var $mul=($4)*($conv2); //@line 195 "klatt.cpp"
      $ftemp=$mul; //@line 195 "klatt.cpp"
      var $6=$ftemp; //@line 196 "klatt.cpp"
      var $conv3=((($6))|0); //@line 196 "klatt.cpp"
      $itemp=$conv3; //@line 196 "klatt.cpp"
      var $7=$ftemp; //@line 198 "klatt.cpp"
      var $8=$itemp; //@line 198 "klatt.cpp"
      var $conv4=((($8))|0); //@line 198 "klatt.cpp"
      var $sub=($7)-($conv4); //@line 198 "klatt.cpp"
      $temp_diff=$sub; //@line 198 "klatt.cpp"
      var $9=$itemp; //@line 200 "klatt.cpp"
      var $10=HEAP32[((((__ZL10kt_globals+172)&4294967295))>>2)]; //@line 200 "klatt.cpp"
      var $arrayidx=(($10+2*$9)&4294967295); //@line 200 "klatt.cpp"
      var $11=HEAP16[(($arrayidx)>>1)]; //@line 200 "klatt.cpp"
      var $conv5=(tempInt=(($11)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 200 "klatt.cpp"
      $current_value=$conv5; //@line 200 "klatt.cpp"
      var $12=$itemp; //@line 201 "klatt.cpp"
      var $add=((($12)+1)&4294967295); //@line 201 "klatt.cpp"
      var $13=HEAP32[((((__ZL10kt_globals+172)&4294967295))>>2)]; //@line 201 "klatt.cpp"
      var $arrayidx6=(($13+2*$add)&4294967295); //@line 201 "klatt.cpp"
      var $14=HEAP16[(($arrayidx6)>>1)]; //@line 201 "klatt.cpp"
      var $conv7=(tempInt=(($14)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 201 "klatt.cpp"
      $next_value=$conv7; //@line 201 "klatt.cpp"
      var $15=$next_value; //@line 203 "klatt.cpp"
      var $conv8=((($15))|0); //@line 203 "klatt.cpp"
      var $16=$current_value; //@line 203 "klatt.cpp"
      var $conv9=((($16))|0); //@line 203 "klatt.cpp"
      var $sub10=($conv8)-($conv9); //@line 203 "klatt.cpp"
      $diff_value=$sub10; //@line 203 "klatt.cpp"
      var $17=$diff_value; //@line 204 "klatt.cpp"
      var $18=$temp_diff; //@line 204 "klatt.cpp"
      var $mul11=($17)*($18); //@line 204 "klatt.cpp"
      $diff_value=$mul11; //@line 204 "klatt.cpp"
      var $19=$itemp; //@line 206 "klatt.cpp"
      var $20=HEAP32[((((__ZL10kt_globals+172)&4294967295))>>2)]; //@line 206 "klatt.cpp"
      var $arrayidx12=(($20+2*$19)&4294967295); //@line 206 "klatt.cpp"
      var $21=HEAP16[(($arrayidx12)>>1)]; //@line 206 "klatt.cpp"
      var $conv13=(tempInt=(($21)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 206 "klatt.cpp"
      var $conv14=((($conv13))|0); //@line 206 "klatt.cpp"
      var $22=$diff_value; //@line 206 "klatt.cpp"
      var $add15=($conv14)+($22); //@line 206 "klatt.cpp"
      $result=$add15; //@line 206 "klatt.cpp"
      var $23=$result; //@line 207 "klatt.cpp"
      var $24=HEAPF32[((((__ZL10kt_globals+164)&4294967295))>>2)]; //@line 207 "klatt.cpp"
      var $mul16=($23)*($24); //@line 207 "klatt.cpp"
      $result=$mul16; //@line 207 "klatt.cpp"
      ; //@line 208 "klatt.cpp"
    }
    else if (__label__ == 2) {
  
      $result=0; //@line 211 "klatt.cpp"
      ;
    }
  
    var $25=$result; //@line 213 "klatt.cpp"
    ;
    return $25; //@line 213 "klatt.cpp"
    return null;
  }
  

  function __ZL21pitch_synch_par_resetP13klatt_frame_t($frame) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $frame_addr;
    var $temp;
    var $temp1;
    $frame_addr=$frame;
    var $0=$frame_addr; //@line 727 "klatt.cpp"
    var $F0hz10=(($0)&4294967295); //@line 727 "klatt.cpp"
    var $1=HEAP32[(($F0hz10)>>2)]; //@line 727 "klatt.cpp"
    var $cmp=((($1))|0) > 0; //@line 727 "klatt.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 15;; } //@line 727 "klatt.cpp"
    if (__label__ == 1) {
  
      var $2=HEAP32[((((__ZL10kt_globals+8)&4294967295))>>2)]; //@line 731 "klatt.cpp"
      var $mul=((($2)*40)&4294967295); //@line 731 "klatt.cpp"
      var $3=$frame_addr; //@line 731 "klatt.cpp"
      var $F0hz101=(($3)&4294967295); //@line 731 "klatt.cpp"
      var $4=HEAP32[(($F0hz101)>>2)]; //@line 731 "klatt.cpp"
      var $div=((((($mul))|0)/((($4))|0))|0); //@line 731 "klatt.cpp"
      HEAP32[((((__ZL10kt_globals+40)&4294967295))>>2)]=$div; //@line 731 "klatt.cpp"
      var $5=$frame_addr; //@line 734 "klatt.cpp"
      var $AVdb_tmp=(($5+204)&4294967295); //@line 734 "klatt.cpp"
      var $6=HEAP32[(($AVdb_tmp)>>2)]; //@line 734 "klatt.cpp"
      var $call=__ZL7DBtoLINl($6); //@line 734 "klatt.cpp"
      HEAPF32[((((__ZL10kt_globals+112)&4294967295))>>2)]=$call; //@line 734 "klatt.cpp"
      var $7=HEAP32[((((__ZL10kt_globals+40)&4294967295))>>2)]; //@line 738 "klatt.cpp"
      HEAP32[((((__ZL10kt_globals+48)&4294967295))>>2)]=$7; //@line 738 "klatt.cpp"
      var $8=$frame_addr; //@line 739 "klatt.cpp"
      var $AVdb_tmp2=(($8+204)&4294967295); //@line 739 "klatt.cpp"
      var $9=HEAP32[(($AVdb_tmp2)>>2)]; //@line 739 "klatt.cpp"
      var $cmp3=((($9))|0) > 0; //@line 739 "klatt.cpp"
      if ($cmp3) { __label__ = 2;; } else { __label__ = 3;; } //@line 739 "klatt.cpp"
      if (__label__ == 2) {
  
        var $10=HEAP32[((((__ZL10kt_globals+48)&4294967295))>>2)]; //@line 741 "klatt.cpp"
        var $shr=($10) >> 1; //@line 741 "klatt.cpp"
        HEAP32[((((__ZL10kt_globals+48)&4294967295))>>2)]=$shr; //@line 741 "klatt.cpp"
        ; //@line 742 "klatt.cpp"
      }
  
      var $11=$frame_addr; //@line 746 "klatt.cpp"
      var $Aturb=(($11+176)&4294967295); //@line 746 "klatt.cpp"
      var $12=HEAP32[(($Aturb)>>2)]; //@line 746 "klatt.cpp"
      var $call5=__ZL7DBtoLINl($12); //@line 746 "klatt.cpp"
      var $mul6=($call5)*0.1; //@line 746 "klatt.cpp"
      HEAPF32[((((__ZL10kt_globals+144)&4294967295))>>2)]=$mul6; //@line 746 "klatt.cpp"
      var $13=$frame_addr; //@line 750 "klatt.cpp"
      var $Kopen=(($13+172)&4294967295); //@line 750 "klatt.cpp"
      var $14=HEAP32[(($Kopen)>>2)]; //@line 750 "klatt.cpp"
      var $mul7=((($14)*4)&4294967295); //@line 750 "klatt.cpp"
      HEAP32[((((__ZL10kt_globals+44)&4294967295))>>2)]=$mul7; //@line 750 "klatt.cpp"
      var $15=HEAP32[((((__ZL10kt_globals+20)&4294967295))>>2)]; //@line 752 "klatt.cpp"
      var $cmp8=((($15))|0)==1; //@line 752 "klatt.cpp"
      var $16=HEAP32[((((__ZL10kt_globals+44)&4294967295))>>2)]; //@line 752 "klatt.cpp"
      var $cmp9=((($16))|0) > 263; //@line 752 "klatt.cpp"
      var $or_cond=($cmp8) & ($cmp9); //@line 752 "klatt.cpp"
      if ($or_cond) { __label__ = 4;; } else { __label__ = 5;; } //@line 752 "klatt.cpp"
      if (__label__ == 4) {
  
        HEAP32[((((__ZL10kt_globals+44)&4294967295))>>2)]=263; //@line 754 "klatt.cpp"
        ; //@line 755 "klatt.cpp"
      }
  
      var $17=HEAP32[((((__ZL10kt_globals+44)&4294967295))>>2)]; //@line 757 "klatt.cpp"
      var $18=HEAP32[((((__ZL10kt_globals+40)&4294967295))>>2)]; //@line 757 "klatt.cpp"
      var $sub=((($18)-1)&4294967295); //@line 757 "klatt.cpp"
      var $cmp12=((($17))|0) >= ((($sub))|0); //@line 757 "klatt.cpp"
      if ($cmp12) { __lastLabel__ = 5; __label__ = 6;; } else { __lastLabel__ = 5; __label__ = 7;; } //@line 757 "klatt.cpp"
      if (__label__ == 6) {
  
        var $19=HEAP32[((((__ZL10kt_globals+40)&4294967295))>>2)]; //@line 760 "klatt.cpp"
        var $sub14=((($19)-2)&4294967295); //@line 760 "klatt.cpp"
        HEAP32[((((__ZL10kt_globals+44)&4294967295))>>2)]=$sub14; //@line 760 "klatt.cpp"
        __lastLabel__ = 6; ; //@line 761 "klatt.cpp"
      }
  
      var $20=__lastLabel__ == 6 ? $sub14 : ($17); //@line 763 "klatt.cpp"
      var $cmp16=((($20))|0) < 40; //@line 763 "klatt.cpp"
      if ($cmp16) { __label__ = 8;; } else { __label__ = 9;; } //@line 763 "klatt.cpp"
      if (__label__ == 8) {
  
        HEAP32[((((__ZL10kt_globals+44)&4294967295))>>2)]=40; //@line 768 "klatt.cpp"
        ; //@line 769 "klatt.cpp"
      }
  
      var $21=HEAP32[((((__ZL10kt_globals+44)&4294967295))>>2)]; //@line 774 "klatt.cpp"
      var $sub19=((($21)-40)&4294967295); //@line 774 "klatt.cpp"
      var $arrayidx=((__ZZL21pitch_synch_par_resetP13klatt_frame_tE2B0+$sub19*2)&4294967295); //@line 774 "klatt.cpp"
      var $22=HEAP16[(($arrayidx)>>1)]; //@line 774 "klatt.cpp"
      var $conv=(tempInt=(($22)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 774 "klatt.cpp"
      HEAPF32[((((__ZL10kt_globals+64)&4294967295))>>2)]=$conv; //@line 774 "klatt.cpp"
      var $23=HEAPF32[((((__ZL10kt_globals+64)&4294967295))>>2)]; //@line 775 "klatt.cpp"
      var $24=HEAP32[((((__ZL10kt_globals+44)&4294967295))>>2)]; //@line 775 "klatt.cpp"
      var $conv20=((($24))|0); //@line 775 "klatt.cpp"
      var $mul21=($23)*($conv20); //@line 775 "klatt.cpp"
      var $mul22=($mul21)*0.333; //@line 775 "klatt.cpp"
      HEAPF32[((((__ZL10kt_globals+56)&4294967295))>>2)]=$mul22; //@line 775 "klatt.cpp"
      var $25=HEAP32[((((__ZL10kt_globals+8)&4294967295))>>2)]; //@line 779 "klatt.cpp"
      var $26=HEAP32[((((__ZL10kt_globals+44)&4294967295))>>2)]; //@line 779 "klatt.cpp"
      var $div23=((((($25))|0)/((($26))|0))|0); //@line 779 "klatt.cpp"
      $temp=$div23; //@line 779 "klatt.cpp"
      var $27=$temp; //@line 781 "klatt.cpp"
      __ZL6setabcllP11resonator_t(0, $27, ((__ZL10kt_globals+188+1088)&4294967295)); //@line 781 "klatt.cpp"
      var $28=HEAP32[((((__ZL10kt_globals+44)&4294967295))>>2)]; //@line 785 "klatt.cpp"
      var $conv24=((($28))|0); //@line 785 "klatt.cpp"
      var $mul25=($conv24)*0.00833; //@line 785 "klatt.cpp"
      $temp1=$mul25; //@line 785 "klatt.cpp"
      var $29=$temp1; //@line 786 "klatt.cpp"
      var $30=$temp1; //@line 786 "klatt.cpp"
      var $mul26=($29)*($30); //@line 786 "klatt.cpp"
      var $31=HEAPF32[((((__ZL10kt_globals+188+1088)&4294967295))>>2)]; //@line 786 "klatt.cpp"
      var $mul27=($31)*($mul26); //@line 786 "klatt.cpp"
      HEAPF32[((((__ZL10kt_globals+188+1088)&4294967295))>>2)]=$mul27; //@line 786 "klatt.cpp"
      var $32=HEAP32[((((__ZL10kt_globals+40)&4294967295))>>2)]; //@line 794 "klatt.cpp"
      var $33=HEAP32[((((__ZL10kt_globals+44)&4294967295))>>2)]; //@line 794 "klatt.cpp"
      var $sub28=((($32)-($33))&4294967295); //@line 794 "klatt.cpp"
      $temp=$sub28; //@line 794 "klatt.cpp"
      var $34=$frame_addr; //@line 795 "klatt.cpp"
      var $Kskew=(($34+188)&4294967295); //@line 795 "klatt.cpp"
      var $35=HEAP32[(($Kskew)>>2)]; //@line 795 "klatt.cpp"
      var $36=$temp; //@line 795 "klatt.cpp"
      var $cmp29=((($35))|0) > ((($36))|0); //@line 795 "klatt.cpp"
      if ($cmp29) { __label__ = 10;; } else { __label__ = 11;; } //@line 795 "klatt.cpp"
      if (__label__ == 10) {
  
        var $37=$temp; //@line 798 "klatt.cpp"
        var $38=$frame_addr; //@line 798 "klatt.cpp"
        var $Kskew31=(($38+188)&4294967295); //@line 798 "klatt.cpp"
        HEAP32[(($Kskew31)>>2)]=$37; //@line 798 "klatt.cpp"
        ; //@line 799 "klatt.cpp"
      }
  
      var $39=HEAP32[((__ZZL21pitch_synch_par_resetP13klatt_frame_tE4skew)>>2)]; //@line 800 "klatt.cpp"
      var $cmp33=((($39))|0) >= 0; //@line 800 "klatt.cpp"
      var $40=$frame_addr; //@line 802 "klatt.cpp"
      var $Kskew35=(($40+188)&4294967295); //@line 802 "klatt.cpp"
      var $41=HEAP32[(($Kskew35)>>2)]; //@line 802 "klatt.cpp"
      if ($cmp33) { __label__ = 12;; } else { __label__ = 13;; } //@line 800 "klatt.cpp"
      if (__label__ == 12) {
  
        HEAP32[((__ZZL21pitch_synch_par_resetP13klatt_frame_tE4skew)>>2)]=$41; //@line 802 "klatt.cpp"
        ; //@line 803 "klatt.cpp"
      }
      else if (__label__ == 13) {
  
        var $sub37=(((-($41)))&4294967295); //@line 806 "klatt.cpp"
        HEAP32[((__ZZL21pitch_synch_par_resetP13klatt_frame_tE4skew)>>2)]=$sub37; //@line 806 "klatt.cpp"
        ;
      }
  
      var $42=HEAP32[((((__ZL10kt_globals+40)&4294967295))>>2)]; //@line 810 "klatt.cpp"
      var $43=HEAP32[((__ZZL21pitch_synch_par_resetP13klatt_frame_tE4skew)>>2)]; //@line 810 "klatt.cpp"
      var $add=((($43)+($42))&4294967295); //@line 810 "klatt.cpp"
      HEAP32[((((__ZL10kt_globals+40)&4294967295))>>2)]=$add; //@line 810 "klatt.cpp"
      var $44=HEAP32[((__ZZL21pitch_synch_par_resetP13klatt_frame_tE4skew)>>2)]; //@line 811 "klatt.cpp"
      var $sub39=(((-($44)))&4294967295); //@line 811 "klatt.cpp"
      HEAP32[((__ZZL21pitch_synch_par_resetP13klatt_frame_tE4skew)>>2)]=$sub39; //@line 811 "klatt.cpp"
      ; //@line 812 "klatt.cpp"
    }
    else if (__label__ == 15) {
  
      HEAP32[((((__ZL10kt_globals+40)&4294967295))>>2)]=4; //@line 815 "klatt.cpp"
      HEAPF32[((((__ZL10kt_globals+112)&4294967295))>>2)]=0; //@line 816 "klatt.cpp"
      var $45=HEAP32[((((__ZL10kt_globals+40)&4294967295))>>2)]; //@line 817 "klatt.cpp"
      HEAP32[((((__ZL10kt_globals+48)&4294967295))>>2)]=$45; //@line 817 "klatt.cpp"
      HEAPF32[((((__ZL10kt_globals+144)&4294967295))>>2)]=0; //@line 818 "klatt.cpp"
      HEAPF32[((((__ZL10kt_globals+56)&4294967295))>>2)]=0; //@line 819 "klatt.cpp"
      HEAPF32[((((__ZL10kt_globals+64)&4294967295))>>2)]=0; //@line 820 "klatt.cpp"
      ;
    }
  
    var $46=HEAP32[((((__ZL10kt_globals+40)&4294967295))>>2)]; //@line 825 "klatt.cpp"
    var $cmp42=((($46))|0)!=4; //@line 825 "klatt.cpp"
    var $47=HEAP32[((((__ZL10kt_globals+36)&4294967295))>>2)]; //@line 825 "klatt.cpp"
    var $cmp43=((($47))|0)==0; //@line 825 "klatt.cpp"
    var $or_cond1=($cmp42) | ($cmp43); //@line 825 "klatt.cpp"
    if ($or_cond1) { __label__ = 17;; } else { __label__ = 20;; } //@line 825 "klatt.cpp"
    if (__label__ == 17) {
  
      var $48=$frame_addr; //@line 829 "klatt.cpp"
      var $TLTdb=(($48+180)&4294967295); //@line 829 "klatt.cpp"
      var $49=HEAP32[(($TLTdb)>>2)]; //@line 829 "klatt.cpp"
      var $conv45=((($49))|0); //@line 829 "klatt.cpp"
      var $mul46=0.033*($conv45); //@line 829 "klatt.cpp"
      HEAPF32[((((__ZL10kt_globals+96)&4294967295))>>2)]=$mul46; //@line 829 "klatt.cpp"
      var $50=HEAPF32[((((__ZL10kt_globals+96)&4294967295))>>2)]; //@line 831 "klatt.cpp"
      var $cmp47=($50) > 0; //@line 831 "klatt.cpp"
      if ($cmp47) { __label__ = 18;; } else { __label__ = 19;; } //@line 831 "klatt.cpp"
      if (__label__ == 18) {
  
        var $51=HEAPF32[((((__ZL10kt_globals+96)&4294967295))>>2)]; //@line 833 "klatt.cpp"
        var $sub49=1-($51); //@line 833 "klatt.cpp"
        HEAPF32[((((__ZL10kt_globals+88)&4294967295))>>2)]=$sub49; //@line 833 "klatt.cpp"
        ; //@line 834 "klatt.cpp"
      }
      else if (__label__ == 19) {
  
        HEAPF32[((((__ZL10kt_globals+88)&4294967295))>>2)]=1; //@line 837 "klatt.cpp"
        ;
      }
    }
  
    ;
    return; //@line 840 "klatt.cpp"
    return;
  }
  

  function __ZL9resonatorP11resonator_td($r, $input) {
    ;
    var __label__;
  
    var $r_addr;
    var $input_addr;
    var $x;
    $r_addr=$r;
    $input_addr=$input;
    var $0=$r_addr; //@line 85 "klatt.cpp"
    var $a=(($0)&4294967295); //@line 85 "klatt.cpp"
    var $1=HEAPF32[(($a)>>2)]; //@line 85 "klatt.cpp"
    var $2=$input_addr; //@line 85 "klatt.cpp"
    var $mul=($1)*($2); //@line 85 "klatt.cpp"
    var $3=$r_addr; //@line 85 "klatt.cpp"
    var $b=(($3+8)&4294967295); //@line 85 "klatt.cpp"
    var $4=HEAPF32[(($b)>>2)]; //@line 85 "klatt.cpp"
    var $5=$r_addr; //@line 85 "klatt.cpp"
    var $p1=(($5+24)&4294967295); //@line 85 "klatt.cpp"
    var $6=HEAPF32[(($p1)>>2)]; //@line 85 "klatt.cpp"
    var $mul1=($4)*($6); //@line 85 "klatt.cpp"
    var $add=($mul)+($mul1); //@line 85 "klatt.cpp"
    var $7=$r_addr; //@line 85 "klatt.cpp"
    var $c=(($7+16)&4294967295); //@line 85 "klatt.cpp"
    var $8=HEAPF32[(($c)>>2)]; //@line 85 "klatt.cpp"
    var $9=$r_addr; //@line 85 "klatt.cpp"
    var $p2=(($9+32)&4294967295); //@line 85 "klatt.cpp"
    var $10=HEAPF32[(($p2)>>2)]; //@line 85 "klatt.cpp"
    var $mul2=($8)*($10); //@line 85 "klatt.cpp"
    var $add3=($add)+($mul2); //@line 85 "klatt.cpp"
    $x=$add3; //@line 85 "klatt.cpp"
    var $11=$r_addr; //@line 86 "klatt.cpp"
    var $p14=(($11+24)&4294967295); //@line 86 "klatt.cpp"
    var $12=HEAPF32[(($p14)>>2)]; //@line 86 "klatt.cpp"
    var $13=$r_addr; //@line 86 "klatt.cpp"
    var $p25=(($13+32)&4294967295); //@line 86 "klatt.cpp"
    HEAPF32[(($p25)>>2)]=$12; //@line 86 "klatt.cpp"
    var $14=$x; //@line 87 "klatt.cpp"
    var $15=$r_addr; //@line 87 "klatt.cpp"
    var $p16=(($15+24)&4294967295); //@line 87 "klatt.cpp"
    HEAPF32[(($p16)>>2)]=$14; //@line 87 "klatt.cpp"
    var $16=$x; //@line 89 "klatt.cpp"
    ;
    return $16; //@line 89 "klatt.cpp"
    return null;
  }
  

  function __ZL14antiresonator2P11resonator_td($input) {
    ;
    var __label__;
  
    var $r_addr;
    var $input_addr;
    var $x;
    $r_addr=((__ZL10kt_globals+188)&4294967295);
    $input_addr=$input;
    var $0=$r_addr; //@line 129 "klatt.cpp"
    var $a=(($0)&4294967295); //@line 129 "klatt.cpp"
    var $1=HEAPF32[(($a)>>2)]; //@line 129 "klatt.cpp"
    var $2=$input_addr; //@line 129 "klatt.cpp"
    var $mul=($1)*($2); //@line 129 "klatt.cpp"
    var $3=$r_addr; //@line 129 "klatt.cpp"
    var $b=(($3+8)&4294967295); //@line 129 "klatt.cpp"
    var $4=HEAPF32[(($b)>>2)]; //@line 129 "klatt.cpp"
    var $5=$r_addr; //@line 129 "klatt.cpp"
    var $p1=(($5+24)&4294967295); //@line 129 "klatt.cpp"
    var $6=HEAPF32[(($p1)>>2)]; //@line 129 "klatt.cpp"
    var $mul1=($4)*($6); //@line 129 "klatt.cpp"
    var $add=($mul)+($mul1); //@line 129 "klatt.cpp"
    var $7=$r_addr; //@line 129 "klatt.cpp"
    var $c=(($7+16)&4294967295); //@line 129 "klatt.cpp"
    var $8=HEAPF32[(($c)>>2)]; //@line 129 "klatt.cpp"
    var $9=$r_addr; //@line 129 "klatt.cpp"
    var $p2=(($9+32)&4294967295); //@line 129 "klatt.cpp"
    var $10=HEAPF32[(($p2)>>2)]; //@line 129 "klatt.cpp"
    var $mul2=($8)*($10); //@line 129 "klatt.cpp"
    var $add3=($add)+($mul2); //@line 129 "klatt.cpp"
    $x=$add3; //@line 129 "klatt.cpp"
    var $11=$r_addr; //@line 130 "klatt.cpp"
    var $p14=(($11+24)&4294967295); //@line 130 "klatt.cpp"
    var $12=HEAPF32[(($p14)>>2)]; //@line 130 "klatt.cpp"
    var $13=$r_addr; //@line 130 "klatt.cpp"
    var $p25=(($13+32)&4294967295); //@line 130 "klatt.cpp"
    HEAPF32[(($p25)>>2)]=$12; //@line 130 "klatt.cpp"
    var $14=$input_addr; //@line 131 "klatt.cpp"
    var $15=$r_addr; //@line 131 "klatt.cpp"
    var $p16=(($15+24)&4294967295); //@line 131 "klatt.cpp"
    HEAPF32[(($p16)>>2)]=$14; //@line 131 "klatt.cpp"
    var $16=$r_addr; //@line 133 "klatt.cpp"
    var $a_inc=(($16+40)&4294967295); //@line 133 "klatt.cpp"
    var $17=HEAPF32[(($a_inc)>>2)]; //@line 133 "klatt.cpp"
    var $18=$r_addr; //@line 133 "klatt.cpp"
    var $a7=(($18)&4294967295); //@line 133 "klatt.cpp"
    var $19=HEAPF32[(($a7)>>2)]; //@line 133 "klatt.cpp"
    var $add8=($19)+($17); //@line 133 "klatt.cpp"
    HEAPF32[(($a7)>>2)]=$add8; //@line 133 "klatt.cpp"
    var $20=$r_addr; //@line 134 "klatt.cpp"
    var $b_inc=(($20+48)&4294967295); //@line 134 "klatt.cpp"
    var $21=HEAPF32[(($b_inc)>>2)]; //@line 134 "klatt.cpp"
    var $22=$r_addr; //@line 134 "klatt.cpp"
    var $b9=(($22+8)&4294967295); //@line 134 "klatt.cpp"
    var $23=HEAPF32[(($b9)>>2)]; //@line 134 "klatt.cpp"
    var $add10=($23)+($21); //@line 134 "klatt.cpp"
    HEAPF32[(($b9)>>2)]=$add10; //@line 134 "klatt.cpp"
    var $24=$r_addr; //@line 135 "klatt.cpp"
    var $c_inc=(($24+56)&4294967295); //@line 135 "klatt.cpp"
    var $25=HEAPF32[(($c_inc)>>2)]; //@line 135 "klatt.cpp"
    var $26=$r_addr; //@line 135 "klatt.cpp"
    var $c11=(($26+16)&4294967295); //@line 135 "klatt.cpp"
    var $27=HEAPF32[(($c11)>>2)]; //@line 135 "klatt.cpp"
    var $add12=($27)+($25); //@line 135 "klatt.cpp"
    HEAPF32[(($c11)>>2)]=$add12; //@line 135 "klatt.cpp"
    var $28=$x; //@line 136 "klatt.cpp"
    ;
    return $28; //@line 136 "klatt.cpp"
    return null;
  }
  

  function __ZL10resonator2P11resonator_td($r, $input) {
    ;
    var __label__;
  
    var $r_addr;
    var $input_addr;
    var $x;
    $r_addr=$r;
    $input_addr=$input;
    var $0=$r_addr; //@line 96 "klatt.cpp"
    var $a=(($0)&4294967295); //@line 96 "klatt.cpp"
    var $1=HEAPF32[(($a)>>2)]; //@line 96 "klatt.cpp"
    var $2=$input_addr; //@line 96 "klatt.cpp"
    var $mul=($1)*($2); //@line 96 "klatt.cpp"
    var $3=$r_addr; //@line 96 "klatt.cpp"
    var $b=(($3+8)&4294967295); //@line 96 "klatt.cpp"
    var $4=HEAPF32[(($b)>>2)]; //@line 96 "klatt.cpp"
    var $5=$r_addr; //@line 96 "klatt.cpp"
    var $p1=(($5+24)&4294967295); //@line 96 "klatt.cpp"
    var $6=HEAPF32[(($p1)>>2)]; //@line 96 "klatt.cpp"
    var $mul1=($4)*($6); //@line 96 "klatt.cpp"
    var $add=($mul)+($mul1); //@line 96 "klatt.cpp"
    var $7=$r_addr; //@line 96 "klatt.cpp"
    var $c=(($7+16)&4294967295); //@line 96 "klatt.cpp"
    var $8=HEAPF32[(($c)>>2)]; //@line 96 "klatt.cpp"
    var $9=$r_addr; //@line 96 "klatt.cpp"
    var $p2=(($9+32)&4294967295); //@line 96 "klatt.cpp"
    var $10=HEAPF32[(($p2)>>2)]; //@line 96 "klatt.cpp"
    var $mul2=($8)*($10); //@line 96 "klatt.cpp"
    var $add3=($add)+($mul2); //@line 96 "klatt.cpp"
    $x=$add3; //@line 96 "klatt.cpp"
    var $11=$r_addr; //@line 97 "klatt.cpp"
    var $p14=(($11+24)&4294967295); //@line 97 "klatt.cpp"
    var $12=HEAPF32[(($p14)>>2)]; //@line 97 "klatt.cpp"
    var $13=$r_addr; //@line 97 "klatt.cpp"
    var $p25=(($13+32)&4294967295); //@line 97 "klatt.cpp"
    HEAPF32[(($p25)>>2)]=$12; //@line 97 "klatt.cpp"
    var $14=$x; //@line 98 "klatt.cpp"
    var $15=$r_addr; //@line 98 "klatt.cpp"
    var $p16=(($15+24)&4294967295); //@line 98 "klatt.cpp"
    HEAPF32[(($p16)>>2)]=$14; //@line 98 "klatt.cpp"
    var $16=$r_addr; //@line 100 "klatt.cpp"
    var $a_inc=(($16+40)&4294967295); //@line 100 "klatt.cpp"
    var $17=HEAPF32[(($a_inc)>>2)]; //@line 100 "klatt.cpp"
    var $18=$r_addr; //@line 100 "klatt.cpp"
    var $a7=(($18)&4294967295); //@line 100 "klatt.cpp"
    var $19=HEAPF32[(($a7)>>2)]; //@line 100 "klatt.cpp"
    var $add8=($19)+($17); //@line 100 "klatt.cpp"
    HEAPF32[(($a7)>>2)]=$add8; //@line 100 "klatt.cpp"
    var $20=$r_addr; //@line 101 "klatt.cpp"
    var $b_inc=(($20+48)&4294967295); //@line 101 "klatt.cpp"
    var $21=HEAPF32[(($b_inc)>>2)]; //@line 101 "klatt.cpp"
    var $22=$r_addr; //@line 101 "klatt.cpp"
    var $b9=(($22+8)&4294967295); //@line 101 "klatt.cpp"
    var $23=HEAPF32[(($b9)>>2)]; //@line 101 "klatt.cpp"
    var $add10=($23)+($21); //@line 101 "klatt.cpp"
    HEAPF32[(($b9)>>2)]=$add10; //@line 101 "klatt.cpp"
    var $24=$r_addr; //@line 102 "klatt.cpp"
    var $c_inc=(($24+56)&4294967295); //@line 102 "klatt.cpp"
    var $25=HEAPF32[(($c_inc)>>2)]; //@line 102 "klatt.cpp"
    var $26=$r_addr; //@line 102 "klatt.cpp"
    var $c11=(($26+16)&4294967295); //@line 102 "klatt.cpp"
    var $27=HEAPF32[(($c11)>>2)]; //@line 102 "klatt.cpp"
    var $add12=($27)+($25); //@line 102 "klatt.cpp"
    HEAPF32[(($c11)>>2)]=$add12; //@line 102 "klatt.cpp"
    var $28=$x; //@line 103 "klatt.cpp"
    ;
    return $28; //@line 103 "klatt.cpp"
    return null;
  }
  

  function __ZL7DBtoLINl($dB) {
    ;
    var __label__;
  
    var $retval;
    var $dB_addr;
    $dB_addr=$dB;
    var $0=$dB_addr; //@line 971 "klatt.cpp"
    var $cmp=((($0))|0) < 0; //@line 971 "klatt.cpp"
    var $1=$dB_addr; //@line 971 "klatt.cpp"
    var $cmp1=((($1))|0) > 87; //@line 971 "klatt.cpp"
    var $or_cond=($cmp) | ($cmp1); //@line 971 "klatt.cpp"
    if ($or_cond) { __label__ = 1;; } else { __label__ = 2;; } //@line 971 "klatt.cpp"
    if (__label__ == 1) {
  
      $retval=0; //@line 973 "klatt.cpp"
      ; //@line 973 "klatt.cpp"
    }
    else if (__label__ == 2) {
  
      var $2=$dB_addr; //@line 976 "klatt.cpp"
      var $arrayidx=((__ZZL7DBtoLINlE8amptable+$2*2)&4294967295); //@line 976 "klatt.cpp"
      var $3=HEAP16[(($arrayidx)>>1)]; //@line 976 "klatt.cpp"
      var $conv=(tempInt=(($3)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 976 "klatt.cpp"
      var $mul=($conv)*0.001; //@line 976 "klatt.cpp"
      $retval=$mul; //@line 976 "klatt.cpp"
      ; //@line 976 "klatt.cpp"
    }
  
    var $4=$retval; //@line 977 "klatt.cpp"
    ;
    return $4; //@line 977 "klatt.cpp"
    return null;
  }
  

  function __ZL10setzeroabcllP11resonator_t($f, $bw, $rp) {
    ;
    var __label__;
  
    var $f_addr;
    var $bw_addr;
    var $rp_addr;
    var $r;
    var $arg;
    $f_addr=$f;
    $bw_addr=$bw;
    $rp_addr=$rp;
    var $0=$f_addr; //@line 885 "klatt.cpp"
    var $sub=(((-($0)))&4294967295); //@line 885 "klatt.cpp"
    $f_addr=$sub; //@line 885 "klatt.cpp"
    var $1=$f_addr; //@line 887 "klatt.cpp"
    var $cmp=((($1))|0) >= 0; //@line 887 "klatt.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 887 "klatt.cpp"
    if (__label__ == 1) {
  
      $f_addr=-1; //@line 889 "klatt.cpp"
      ; //@line 890 "klatt.cpp"
    }
  
    var $2=HEAPF32[((((__ZL10kt_globals+72)&4294967295))>>2)]; //@line 894 "klatt.cpp"
    var $3=$bw_addr; //@line 894 "klatt.cpp"
    var $conv=((($3))|0); //@line 894 "klatt.cpp"
    var $mul=($2)*($conv); //@line 894 "klatt.cpp"
    $arg=$mul; //@line 894 "klatt.cpp"
    var $4=$arg; //@line 895 "klatt.cpp"
    var $call=_exp($4); //@line 895 "klatt.cpp"
    $r=$call; //@line 895 "klatt.cpp"
    var $5=$r; //@line 898 "klatt.cpp"
    var $6=$r; //@line 898 "klatt.cpp"
    var $mul1=($5)*($6); //@line 898 "klatt.cpp"
    var $sub2=(-($mul1)); //@line 898 "klatt.cpp"
    var $7=$rp_addr; //@line 898 "klatt.cpp"
    var $c=(($7+16)&4294967295); //@line 898 "klatt.cpp"
    HEAPF32[(($c)>>2)]=$sub2; //@line 898 "klatt.cpp"
    var $8=HEAPF32[((((__ZL10kt_globals+80)&4294967295))>>2)]; //@line 901 "klatt.cpp"
    var $9=$f_addr; //@line 901 "klatt.cpp"
    var $conv3=((($9))|0); //@line 901 "klatt.cpp"
    var $mul4=($8)*($conv3); //@line 901 "klatt.cpp"
    $arg=$mul4; //@line 901 "klatt.cpp"
    var $10=$r; //@line 902 "klatt.cpp"
    var $11=$arg; //@line 902 "klatt.cpp"
    var $call5=_cos($11); //@line 902 "klatt.cpp"
    var $mul6=($10)*($call5); //@line 902 "klatt.cpp"
    var $mul7=($mul6)*2; //@line 902 "klatt.cpp"
    var $12=$rp_addr; //@line 902 "klatt.cpp"
    var $b=(($12+8)&4294967295); //@line 902 "klatt.cpp"
    HEAPF32[(($b)>>2)]=$mul7; //@line 902 "klatt.cpp"
    var $13=$rp_addr; //@line 905 "klatt.cpp"
    var $b8=(($13+8)&4294967295); //@line 905 "klatt.cpp"
    var $14=HEAPF32[(($b8)>>2)]; //@line 905 "klatt.cpp"
    var $sub9=1-($14); //@line 905 "klatt.cpp"
    var $15=$rp_addr; //@line 905 "klatt.cpp"
    var $c10=(($15+16)&4294967295); //@line 905 "klatt.cpp"
    var $16=HEAPF32[(($c10)>>2)]; //@line 905 "klatt.cpp"
    var $sub11=($sub9)-($16); //@line 905 "klatt.cpp"
    var $17=$rp_addr; //@line 905 "klatt.cpp"
    var $a=(($17)&4294967295); //@line 905 "klatt.cpp"
    HEAPF32[(($a)>>2)]=$sub11; //@line 905 "klatt.cpp"
    var $18=$rp_addr; //@line 908 "klatt.cpp"
    var $a12=(($18)&4294967295); //@line 908 "klatt.cpp"
    var $19=HEAPF32[(($a12)>>2)]; //@line 908 "klatt.cpp"
    var $div=1/($19); //@line 908 "klatt.cpp"
    var $20=$rp_addr; //@line 908 "klatt.cpp"
    var $a13=(($20)&4294967295); //@line 908 "klatt.cpp"
    HEAPF32[(($a13)>>2)]=$div; //@line 908 "klatt.cpp"
    var $21=$rp_addr; //@line 909 "klatt.cpp"
    var $a14=(($21)&4294967295); //@line 909 "klatt.cpp"
    var $22=HEAPF32[(($a14)>>2)]; //@line 909 "klatt.cpp"
    var $sub15=(-($22)); //@line 909 "klatt.cpp"
    var $23=$rp_addr; //@line 909 "klatt.cpp"
    var $c16=(($23+16)&4294967295); //@line 909 "klatt.cpp"
    var $24=HEAPF32[(($c16)>>2)]; //@line 909 "klatt.cpp"
    var $mul17=($24)*($sub15); //@line 909 "klatt.cpp"
    HEAPF32[(($c16)>>2)]=$mul17; //@line 909 "klatt.cpp"
    var $25=$rp_addr; //@line 910 "klatt.cpp"
    var $a18=(($25)&4294967295); //@line 910 "klatt.cpp"
    var $26=HEAPF32[(($a18)>>2)]; //@line 910 "klatt.cpp"
    var $sub19=(-($26)); //@line 910 "klatt.cpp"
    var $27=$rp_addr; //@line 910 "klatt.cpp"
    var $b20=(($27+8)&4294967295); //@line 910 "klatt.cpp"
    var $28=HEAPF32[(($b20)>>2)]; //@line 910 "klatt.cpp"
    var $mul21=($28)*($sub19); //@line 910 "klatt.cpp"
    HEAPF32[(($b20)>>2)]=$mul21; //@line 910 "klatt.cpp"
    ;
    return; //@line 911 "klatt.cpp"
    return;
  }
  

  function __Z8sonicMSGPcz($format) {
    var __stackBase__  = STACKTOP; STACKTOP += 4100; _memset(__stackBase__, 0, 4100);
    var __label__;
  
    var $format_addr;
    var $buffer=__stackBase__;
    var $ap=__stackBase__+4096;
    var $file;
    $format_addr=$format;
    var $ap1=$ap; //@line 61 "sonic.cpp"
    HEAP32[(($ap1)>>2)]=arguments[__Z8sonicMSGPcz.length];; //@line 61 "sonic.cpp"
    var $arraydecay=(($buffer)&4294967295); //@line 62 "sonic.cpp"
    var $0=$format_addr; //@line 62 "sonic.cpp"
    var $1=HEAP32[(($ap)>>2)]; //@line 62 "sonic.cpp"
    var $call=_vsprintf($arraydecay, $0, $1); //@line 62 "sonic.cpp"
    var $ap2=$ap; //@line 63 "sonic.cpp"
    ; //@line 63 "sonic.cpp"
    var $call3=_fopen(((__str810)&4294967295), ((__str1811)&4294967295)); //@line 64 "sonic.cpp"
    $file=$call3; //@line 64 "sonic.cpp"
    var $2=$file; //@line 65 "sonic.cpp"
    var $arraydecay4=(($buffer)&4294967295); //@line 65 "sonic.cpp"
    var $fputs=_fputs($arraydecay4, $2); //@line 65 "sonic.cpp"
    var $3=$file; //@line 66 "sonic.cpp"
    var $call6=_fclose($3); //@line 66 "sonic.cpp"
    STACKTOP = __stackBase__;
    return; //@line 67 "sonic.cpp"
    return;
  }
  

  function _sonicGetSpeed($stream) {
    ;
    var __label__;
  
    var $stream_addr;
    $stream_addr=$stream;
    var $0=$stream_addr; //@line 93 "sonic.cpp"
    var $speed=(($0+16)&4294967295); //@line 93 "sonic.cpp"
    var $1=HEAPF32[(($speed)>>2)]; //@line 93 "sonic.cpp"
    ;
    return $1; //@line 93 "sonic.cpp"
    return null;
  }
  

  function _sonicSetSpeed($stream, $speed) {
    ;
    var __label__;
  
    var $stream_addr;
    var $speed_addr;
    $stream_addr=$stream;
    $speed_addr=$speed;
    var $0=$speed_addr; //@line 101 "sonic.cpp"
    var $1=$stream_addr; //@line 101 "sonic.cpp"
    var $speed1=(($1+16)&4294967295); //@line 101 "sonic.cpp"
    HEAPF32[(($speed1)>>2)]=$0; //@line 101 "sonic.cpp"
    ;
    return; //@line 102 "sonic.cpp"
    return;
  }
  

  function _sonicGetPitch($stream) {
    ;
    var __label__;
  
    var $stream_addr;
    $stream_addr=$stream;
    var $0=$stream_addr; //@line 108 "sonic.cpp"
    var $pitch=(($0+24)&4294967295); //@line 108 "sonic.cpp"
    var $1=HEAPF32[(($pitch)>>2)]; //@line 108 "sonic.cpp"
    ;
    return $1; //@line 108 "sonic.cpp"
    return null;
  }
  

  function _sonicSetPitch($stream, $pitch) {
    ;
    var __label__;
  
    var $stream_addr;
    var $pitch_addr;
    $stream_addr=$stream;
    $pitch_addr=$pitch;
    var $0=$pitch_addr; //@line 116 "sonic.cpp"
    var $1=$stream_addr; //@line 116 "sonic.cpp"
    var $pitch1=(($1+24)&4294967295); //@line 116 "sonic.cpp"
    HEAPF32[(($pitch1)>>2)]=$0; //@line 116 "sonic.cpp"
    ;
    return; //@line 117 "sonic.cpp"
    return;
  }
  

  function _sonicGetVolume($stream) {
    ;
    var __label__;
  
    var $stream_addr;
    $stream_addr=$stream;
    var $0=$stream_addr; //@line 123 "sonic.cpp"
    var $volume=(($0+20)&4294967295); //@line 123 "sonic.cpp"
    var $1=HEAPF32[(($volume)>>2)]; //@line 123 "sonic.cpp"
    ;
    return $1; //@line 123 "sonic.cpp"
    return null;
  }
  

  function _sonicSetVolume($stream, $volume) {
    ;
    var __label__;
  
    var $stream_addr;
    var $volume_addr;
    $stream_addr=$stream;
    $volume_addr=$volume;
    var $0=$volume_addr; //@line 131 "sonic.cpp"
    var $1=$stream_addr; //@line 131 "sonic.cpp"
    var $volume1=(($1+20)&4294967295); //@line 131 "sonic.cpp"
    HEAPF32[(($volume1)>>2)]=$0; //@line 131 "sonic.cpp"
    ;
    return; //@line 132 "sonic.cpp"
    return;
  }
  

  function _sonicGetSampleRate($stream) {
    ;
    var __label__;
  
    var $stream_addr;
    $stream_addr=$stream;
    var $0=$stream_addr; //@line 138 "sonic.cpp"
    var $sampleRate=(($0+72)&4294967295); //@line 138 "sonic.cpp"
    var $1=HEAP32[(($sampleRate)>>2)]; //@line 138 "sonic.cpp"
    ;
    return $1; //@line 138 "sonic.cpp"
    return null;
  }
  

  function _sonicGetNumChannels($stream) {
    ;
    var __label__;
  
    var $stream_addr;
    $stream_addr=$stream;
    var $0=$stream_addr; //@line 145 "sonic.cpp"
    var $numChannels=(($0+28)&4294967295); //@line 145 "sonic.cpp"
    var $1=HEAP32[(($numChannels)>>2)]; //@line 145 "sonic.cpp"
    ;
    return $1; //@line 145 "sonic.cpp"
    return null;
  }
  

  function _sonicDestroyStream($stream) {
    ;
    var __label__;
  
    var $stream_addr;
    $stream_addr=$stream;
    var $0=$stream_addr; //@line 152 "sonic.cpp"
    var $inputBuffer=(($0)&4294967295); //@line 152 "sonic.cpp"
    var $1=HEAP32[(($inputBuffer)>>2)]; //@line 152 "sonic.cpp"
    var $cmp=((($1))|0)!=0; //@line 152 "sonic.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 152 "sonic.cpp"
    if (__label__ == 1) {
  
      var $2=$stream_addr; //@line 153 "sonic.cpp"
      var $inputBuffer1=(($2)&4294967295); //@line 153 "sonic.cpp"
      var $3=HEAP32[(($inputBuffer1)>>2)]; //@line 153 "sonic.cpp"
      var $4=$3; //@line 153 "sonic.cpp"
      ; //@line 153 "sonic.cpp"
      ; //@line 154 "sonic.cpp"
    }
  
    var $5=$stream_addr; //@line 155 "sonic.cpp"
    var $outputBuffer=(($5+4)&4294967295); //@line 155 "sonic.cpp"
    var $6=HEAP32[(($outputBuffer)>>2)]; //@line 155 "sonic.cpp"
    var $cmp2=((($6))|0)!=0; //@line 155 "sonic.cpp"
    if ($cmp2) { __label__ = 3;; } else { __label__ = 4;; } //@line 155 "sonic.cpp"
    if (__label__ == 3) {
  
      var $7=$stream_addr; //@line 156 "sonic.cpp"
      var $outputBuffer4=(($7+4)&4294967295); //@line 156 "sonic.cpp"
      var $8=HEAP32[(($outputBuffer4)>>2)]; //@line 156 "sonic.cpp"
      var $9=$8; //@line 156 "sonic.cpp"
      ; //@line 156 "sonic.cpp"
      ; //@line 157 "sonic.cpp"
    }
  
    var $10=$stream_addr; //@line 158 "sonic.cpp"
    var $pitchBuffer=(($10+8)&4294967295); //@line 158 "sonic.cpp"
    var $11=HEAP32[(($pitchBuffer)>>2)]; //@line 158 "sonic.cpp"
    var $cmp6=((($11))|0)!=0; //@line 158 "sonic.cpp"
    if ($cmp6) { __label__ = 5;; } else { __label__ = 6;; } //@line 158 "sonic.cpp"
    if (__label__ == 5) {
  
      var $12=$stream_addr; //@line 159 "sonic.cpp"
      var $pitchBuffer8=(($12+8)&4294967295); //@line 159 "sonic.cpp"
      var $13=HEAP32[(($pitchBuffer8)>>2)]; //@line 159 "sonic.cpp"
      var $14=$13; //@line 159 "sonic.cpp"
      ; //@line 159 "sonic.cpp"
      ; //@line 160 "sonic.cpp"
    }
  
    var $15=$stream_addr; //@line 161 "sonic.cpp"
    var $downSampleBuffer=(($15+12)&4294967295); //@line 161 "sonic.cpp"
    var $16=HEAP32[(($downSampleBuffer)>>2)]; //@line 161 "sonic.cpp"
    var $cmp10=((($16))|0)!=0; //@line 161 "sonic.cpp"
    if ($cmp10) { __label__ = 7;; } else { __label__ = 8;; } //@line 161 "sonic.cpp"
    if (__label__ == 7) {
  
      var $17=$stream_addr; //@line 162 "sonic.cpp"
      var $downSampleBuffer12=(($17+12)&4294967295); //@line 162 "sonic.cpp"
      var $18=HEAP32[(($downSampleBuffer12)>>2)]; //@line 162 "sonic.cpp"
      var $19=$18; //@line 162 "sonic.cpp"
      ; //@line 162 "sonic.cpp"
      ; //@line 163 "sonic.cpp"
    }
  
    var $20=$stream_addr; //@line 164 "sonic.cpp"
    var $21=$20; //@line 164 "sonic.cpp"
    ; //@line 164 "sonic.cpp"
    ;
    return; //@line 165 "sonic.cpp"
    return;
  }
  

  function _sonicCreateStream($sampleRate, $numChannels) {
    ;
    var __label__;
  
    var $retval;
    var $sampleRate_addr;
    var $numChannels_addr;
    var $stream;
    var $minPeriod;
    var $maxPeriod;
    var $maxRequired;
    $sampleRate_addr=$sampleRate;
    $numChannels_addr=$numChannels;
    var $call=_calloc(1, 88); //@line 173 "sonic.cpp"
    var $0=$call; //@line 173 "sonic.cpp"
    $stream=$0; //@line 173 "sonic.cpp"
    var $1=$sampleRate_addr; //@line 174 "sonic.cpp"
    var $div=((((($1))|0)/400)|0); //@line 174 "sonic.cpp"
    $minPeriod=$div; //@line 174 "sonic.cpp"
    var $2=$sampleRate_addr; //@line 175 "sonic.cpp"
    var $div1=((((($2))|0)/65)|0); //@line 175 "sonic.cpp"
    $maxPeriod=$div1; //@line 175 "sonic.cpp"
    var $3=$maxPeriod; //@line 176 "sonic.cpp"
    var $mul=((($3)*2)&4294967295); //@line 176 "sonic.cpp"
    $maxRequired=$mul; //@line 176 "sonic.cpp"
    var $4=$stream; //@line 178 "sonic.cpp"
    var $cmp=((($4))|0)==0; //@line 178 "sonic.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 178 "sonic.cpp"
    if (__label__ == 1) {
  
      $retval=0; //@line 179 "sonic.cpp"
      ; //@line 179 "sonic.cpp"
    }
    else if (__label__ == 2) {
  
      var $5=$maxRequired; //@line 181 "sonic.cpp"
      var $6=$stream; //@line 181 "sonic.cpp"
      var $inputBufferSize=(($6+32)&4294967295); //@line 181 "sonic.cpp"
      HEAP32[(($inputBufferSize)>>2)]=$5; //@line 181 "sonic.cpp"
      var $7=$maxRequired; //@line 182 "sonic.cpp"
      var $8=$numChannels_addr; //@line 182 "sonic.cpp"
      var $mul2=((($8)*2)&4294967295); //@line 182 "sonic.cpp"
      var $call3=_calloc($7, $mul2); //@line 182 "sonic.cpp"
      var $9=$call3; //@line 182 "sonic.cpp"
      var $10=$stream; //@line 182 "sonic.cpp"
      var $inputBuffer=(($10)&4294967295); //@line 182 "sonic.cpp"
      HEAP32[(($inputBuffer)>>2)]=$9; //@line 182 "sonic.cpp"
      var $11=$stream; //@line 183 "sonic.cpp"
      var $inputBuffer4=(($11)&4294967295); //@line 183 "sonic.cpp"
      var $12=HEAP32[(($inputBuffer4)>>2)]; //@line 183 "sonic.cpp"
      var $cmp5=((($12))|0)==0; //@line 183 "sonic.cpp"
      if ($cmp5) { __label__ = 3;; } else { __label__ = 4;; } //@line 183 "sonic.cpp"
      if (__label__ == 3) {
  
        var $13=$stream; //@line 184 "sonic.cpp"
        _sonicDestroyStream($13); //@line 184 "sonic.cpp"
        $retval=0; //@line 185 "sonic.cpp"
        ; //@line 185 "sonic.cpp"
      }
      else if (__label__ == 4) {
  
        var $14=$maxRequired; //@line 187 "sonic.cpp"
        var $15=$stream; //@line 187 "sonic.cpp"
        var $outputBufferSize=(($15+40)&4294967295); //@line 187 "sonic.cpp"
        HEAP32[(($outputBufferSize)>>2)]=$14; //@line 187 "sonic.cpp"
        var $16=$maxRequired; //@line 188 "sonic.cpp"
        var $17=$numChannels_addr; //@line 188 "sonic.cpp"
        var $mul8=((($17)*2)&4294967295); //@line 188 "sonic.cpp"
        var $call9=_calloc($16, $mul8); //@line 188 "sonic.cpp"
        var $18=$call9; //@line 188 "sonic.cpp"
        var $19=$stream; //@line 188 "sonic.cpp"
        var $outputBuffer=(($19+4)&4294967295); //@line 188 "sonic.cpp"
        HEAP32[(($outputBuffer)>>2)]=$18; //@line 188 "sonic.cpp"
        var $20=$stream; //@line 189 "sonic.cpp"
        var $outputBuffer10=(($20+4)&4294967295); //@line 189 "sonic.cpp"
        var $21=HEAP32[(($outputBuffer10)>>2)]; //@line 189 "sonic.cpp"
        var $cmp11=((($21))|0)==0; //@line 189 "sonic.cpp"
        if ($cmp11) { __label__ = 5;; } else { __label__ = 6;; } //@line 189 "sonic.cpp"
        if (__label__ == 5) {
  
          var $22=$stream; //@line 190 "sonic.cpp"
          _sonicDestroyStream($22); //@line 190 "sonic.cpp"
          $retval=0; //@line 191 "sonic.cpp"
          ; //@line 191 "sonic.cpp"
        }
        else if (__label__ == 6) {
  
          var $23=$maxRequired; //@line 193 "sonic.cpp"
          var $24=$stream; //@line 193 "sonic.cpp"
          var $pitchBufferSize=(($24+36)&4294967295); //@line 193 "sonic.cpp"
          HEAP32[(($pitchBufferSize)>>2)]=$23; //@line 193 "sonic.cpp"
          var $25=$maxRequired; //@line 194 "sonic.cpp"
          var $26=$numChannels_addr; //@line 194 "sonic.cpp"
          var $mul14=((($26)*2)&4294967295); //@line 194 "sonic.cpp"
          var $call15=_calloc($25, $mul14); //@line 194 "sonic.cpp"
          var $27=$call15; //@line 194 "sonic.cpp"
          var $28=$stream; //@line 194 "sonic.cpp"
          var $pitchBuffer=(($28+8)&4294967295); //@line 194 "sonic.cpp"
          HEAP32[(($pitchBuffer)>>2)]=$27; //@line 194 "sonic.cpp"
          var $29=$stream; //@line 195 "sonic.cpp"
          var $pitchBuffer16=(($29+8)&4294967295); //@line 195 "sonic.cpp"
          var $30=HEAP32[(($pitchBuffer16)>>2)]; //@line 195 "sonic.cpp"
          var $cmp17=((($30))|0)==0; //@line 195 "sonic.cpp"
          if ($cmp17) { __label__ = 7;; } else { __label__ = 8;; } //@line 195 "sonic.cpp"
          if (__label__ == 7) {
  
            var $31=$stream; //@line 196 "sonic.cpp"
            _sonicDestroyStream($31); //@line 196 "sonic.cpp"
            $retval=0; //@line 197 "sonic.cpp"
            ; //@line 197 "sonic.cpp"
          }
          else if (__label__ == 8) {
  
            var $32=$maxRequired; //@line 199 "sonic.cpp"
            var $call20=_calloc($32, 2); //@line 199 "sonic.cpp"
            var $33=$call20; //@line 199 "sonic.cpp"
            var $34=$stream; //@line 199 "sonic.cpp"
            var $downSampleBuffer=(($34+12)&4294967295); //@line 199 "sonic.cpp"
            HEAP32[(($downSampleBuffer)>>2)]=$33; //@line 199 "sonic.cpp"
            var $35=$stream; //@line 200 "sonic.cpp"
            var $speed=(($35+16)&4294967295); //@line 200 "sonic.cpp"
            HEAPF32[(($speed)>>2)]=1; //@line 200 "sonic.cpp"
            var $36=$stream; //@line 201 "sonic.cpp"
            var $pitch=(($36+24)&4294967295); //@line 201 "sonic.cpp"
            HEAPF32[(($pitch)>>2)]=1; //@line 201 "sonic.cpp"
            var $37=$stream; //@line 202 "sonic.cpp"
            var $volume=(($37+20)&4294967295); //@line 202 "sonic.cpp"
            HEAPF32[(($volume)>>2)]=1; //@line 202 "sonic.cpp"
            var $38=$sampleRate_addr; //@line 203 "sonic.cpp"
            var $39=$stream; //@line 203 "sonic.cpp"
            var $sampleRate21=(($39+72)&4294967295); //@line 203 "sonic.cpp"
            HEAP32[(($sampleRate21)>>2)]=$38; //@line 203 "sonic.cpp"
            var $40=$numChannels_addr; //@line 204 "sonic.cpp"
            var $41=$stream; //@line 204 "sonic.cpp"
            var $numChannels22=(($41+28)&4294967295); //@line 204 "sonic.cpp"
            HEAP32[(($numChannels22)>>2)]=$40; //@line 204 "sonic.cpp"
            var $42=$minPeriod; //@line 205 "sonic.cpp"
            var $43=$stream; //@line 205 "sonic.cpp"
            var $minPeriod23=(($43+56)&4294967295); //@line 205 "sonic.cpp"
            HEAP32[(($minPeriod23)>>2)]=$42; //@line 205 "sonic.cpp"
            var $44=$maxPeriod; //@line 206 "sonic.cpp"
            var $45=$stream; //@line 206 "sonic.cpp"
            var $maxPeriod24=(($45+60)&4294967295); //@line 206 "sonic.cpp"
            HEAP32[(($maxPeriod24)>>2)]=$44; //@line 206 "sonic.cpp"
            var $46=$maxRequired; //@line 207 "sonic.cpp"
            var $47=$stream; //@line 207 "sonic.cpp"
            var $maxRequired25=(($47+64)&4294967295); //@line 207 "sonic.cpp"
            HEAP32[(($maxRequired25)>>2)]=$46; //@line 207 "sonic.cpp"
            var $48=$stream; //@line 208 "sonic.cpp"
            $retval=$48; //@line 208 "sonic.cpp"
            ; //@line 208 "sonic.cpp"
          }
        }
      }
    }
  
    var $49=$retval; //@line 209 "sonic.cpp"
    ;
    return $49; //@line 209 "sonic.cpp"
    return null;
  }
  

  function _sonicReadFloatFromStream($stream, $samples, $maxSamples) {
    ;
    var __label__;
  
    var $retval;
    var $stream_addr;
    var $samples_addr;
    var $maxSamples_addr;
    var $numSamples;
    var $remainingSamples;
    var $buffer;
    var $count;
    $stream_addr=$stream;
    $samples_addr=$samples;
    $maxSamples_addr=$maxSamples;
    var $0=$stream_addr; //@line 362 "sonic.cpp"
    var $numOutputSamples=(($0+48)&4294967295); //@line 362 "sonic.cpp"
    var $1=HEAP32[(($numOutputSamples)>>2)]; //@line 362 "sonic.cpp"
    $numSamples=$1; //@line 362 "sonic.cpp"
    $remainingSamples=0; //@line 363 "sonic.cpp"
    var $2=$numSamples; //@line 367 "sonic.cpp"
    var $cmp=((($2))|0)==0; //@line 367 "sonic.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 367 "sonic.cpp"
    if (__label__ == 1) {
  
      $retval=0; //@line 368 "sonic.cpp"
      ; //@line 368 "sonic.cpp"
    }
    else if (__label__ == 2) {
  
      var $3=$numSamples; //@line 370 "sonic.cpp"
      var $4=$maxSamples_addr; //@line 370 "sonic.cpp"
      var $cmp1=((($3))|0) > ((($4))|0); //@line 370 "sonic.cpp"
      if ($cmp1) { __label__ = 3;; } else { __label__ = 4;; } //@line 370 "sonic.cpp"
      if (__label__ == 3) {
  
        var $5=$numSamples; //@line 371 "sonic.cpp"
        var $6=$maxSamples_addr; //@line 371 "sonic.cpp"
        var $sub=((($5)-($6))&4294967295); //@line 371 "sonic.cpp"
        $remainingSamples=$sub; //@line 371 "sonic.cpp"
        var $7=$maxSamples_addr; //@line 372 "sonic.cpp"
        $numSamples=$7; //@line 372 "sonic.cpp"
        ; //@line 373 "sonic.cpp"
      }
  
      var $8=$stream_addr; //@line 374 "sonic.cpp"
      var $outputBuffer=(($8+4)&4294967295); //@line 374 "sonic.cpp"
      var $9=HEAP32[(($outputBuffer)>>2)]; //@line 374 "sonic.cpp"
      $buffer=$9; //@line 374 "sonic.cpp"
      var $10=$numSamples; //@line 375 "sonic.cpp"
      var $11=$stream_addr; //@line 375 "sonic.cpp"
      var $numChannels=(($11+28)&4294967295); //@line 375 "sonic.cpp"
      var $12=HEAP32[(($numChannels)>>2)]; //@line 375 "sonic.cpp"
      var $mul=((($12)*($10))&4294967295); //@line 375 "sonic.cpp"
      var $dec1=((($mul)-1)&4294967295); //@line 376 "sonic.cpp"
      $count=$dec1; //@line 376 "sonic.cpp"
      var $tobool2=((($mul))|0)!=0; //@line 376 "sonic.cpp"
      if ($tobool2) { __label__ = 5;; } else { __label__ = 6;; } //@line 376 "sonic.cpp"
      $while_body$$while_end$8: do { 
        if (__label__ == 5) {
          while(1) { 
  
            var $13=$buffer; //@line 377 "sonic.cpp"
            var $incdec_ptr=(($13+2)&4294967295); //@line 377 "sonic.cpp"
            $buffer=$incdec_ptr; //@line 377 "sonic.cpp"
            var $14=HEAP16[(($13)>>1)]; //@line 377 "sonic.cpp"
            var $conv=(tempInt=(($14)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 377 "sonic.cpp"
            var $conv4=((($conv))|0); //@line 377 "sonic.cpp"
            var $div=($conv4)/32767; //@line 377 "sonic.cpp"
            var $15=$samples_addr; //@line 377 "sonic.cpp"
            var $incdec_ptr5=(($15+4)&4294967295); //@line 377 "sonic.cpp"
            $samples_addr=$incdec_ptr5; //@line 377 "sonic.cpp"
            HEAPF32[(($15)>>2)]=$div; //@line 377 "sonic.cpp"
            var $_pr=$count; //@line 376 "sonic.cpp"
            var $dec=((($_pr)-1)&4294967295); //@line 376 "sonic.cpp"
            $count=$dec; //@line 376 "sonic.cpp"
            var $tobool=((($_pr))|0)!=0; //@line 376 "sonic.cpp"
            if ($tobool) { __label__ = 5;continue ; } else { __label__ = 6;break $while_body$$while_end$8; } //@line 376 "sonic.cpp"
          }
        }
      } while(0);
  
      var $16=$remainingSamples; //@line 379 "sonic.cpp"
      var $cmp6=((($16))|0) > 0; //@line 379 "sonic.cpp"
      if ($cmp6) { __label__ = 7;; } else { __label__ = 8;; } //@line 379 "sonic.cpp"
      if (__label__ == 7) {
  
        var $17=$stream_addr; //@line 380 "sonic.cpp"
        var $outputBuffer8=(($17+4)&4294967295); //@line 380 "sonic.cpp"
        var $18=HEAP32[(($outputBuffer8)>>2)]; //@line 380 "sonic.cpp"
        var $19=$18; //@line 380 "sonic.cpp"
        var $20=$stream_addr; //@line 380 "sonic.cpp"
        var $outputBuffer9=(($20+4)&4294967295); //@line 380 "sonic.cpp"
        var $21=HEAP32[(($outputBuffer9)>>2)]; //@line 380 "sonic.cpp"
        var $22=$numSamples; //@line 380 "sonic.cpp"
        var $23=$stream_addr; //@line 380 "sonic.cpp"
        var $numChannels10=(($23+28)&4294967295); //@line 380 "sonic.cpp"
        var $24=HEAP32[(($numChannels10)>>2)]; //@line 380 "sonic.cpp"
        var $mul11=((($24)*($22))&4294967295); //@line 380 "sonic.cpp"
        var $add_ptr=(($21+2*$mul11)&4294967295); //@line 380 "sonic.cpp"
        var $25=$add_ptr; //@line 380 "sonic.cpp"
        var $26=$remainingSamples; //@line 380 "sonic.cpp"
        var $27=$stream_addr; //@line 380 "sonic.cpp"
        var $numChannels13=(($27+28)&4294967295); //@line 380 "sonic.cpp"
        var $28=HEAP32[(($numChannels13)>>2)]; //@line 380 "sonic.cpp"
        var $mul12=((($26)*2)&4294967295); //@line 380 "sonic.cpp"
        var $mul14=((($mul12)*($28))&4294967295); //@line 380 "sonic.cpp"
        _llvm_memmove_p0i8_p0i8_i32($19, $25, $mul14, 1, 0); //@line 380 "sonic.cpp"
        ; //@line 382 "sonic.cpp"
      }
  
      var $29=$remainingSamples; //@line 383 "sonic.cpp"
      var $30=$stream_addr; //@line 383 "sonic.cpp"
      var $numOutputSamples16=(($30+48)&4294967295); //@line 383 "sonic.cpp"
      HEAP32[(($numOutputSamples16)>>2)]=$29; //@line 383 "sonic.cpp"
      var $31=$numSamples; //@line 384 "sonic.cpp"
      $retval=$31; //@line 384 "sonic.cpp"
      ; //@line 384 "sonic.cpp"
    }
  
    var $32=$retval; //@line 385 "sonic.cpp"
    ;
    return $32; //@line 385 "sonic.cpp"
    return null;
  }
  

  function _sonicReadShortFromStream($stream, $samples, $maxSamples) {
    ;
    var __label__;
  
    var $retval;
    var $stream_addr;
    var $samples_addr;
    var $maxSamples_addr;
    var $numSamples;
    var $remainingSamples;
    $stream_addr=$stream;
    $samples_addr=$samples;
    $maxSamples_addr=$maxSamples;
    var $0=$stream_addr; //@line 394 "sonic.cpp"
    var $numOutputSamples=(($0+48)&4294967295); //@line 394 "sonic.cpp"
    var $1=HEAP32[(($numOutputSamples)>>2)]; //@line 394 "sonic.cpp"
    $numSamples=$1; //@line 394 "sonic.cpp"
    $remainingSamples=0; //@line 395 "sonic.cpp"
    var $2=$numSamples; //@line 397 "sonic.cpp"
    var $cmp=((($2))|0)==0; //@line 397 "sonic.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 397 "sonic.cpp"
    if (__label__ == 1) {
  
      $retval=0; //@line 398 "sonic.cpp"
      ; //@line 398 "sonic.cpp"
    }
    else if (__label__ == 2) {
  
      var $3=$numSamples; //@line 400 "sonic.cpp"
      var $4=$maxSamples_addr; //@line 400 "sonic.cpp"
      var $cmp1=((($3))|0) > ((($4))|0); //@line 400 "sonic.cpp"
      if ($cmp1) { __label__ = 3;; } else { __label__ = 4;; } //@line 400 "sonic.cpp"
      if (__label__ == 3) {
  
        var $5=$numSamples; //@line 401 "sonic.cpp"
        var $6=$maxSamples_addr; //@line 401 "sonic.cpp"
        var $sub=((($5)-($6))&4294967295); //@line 401 "sonic.cpp"
        $remainingSamples=$sub; //@line 401 "sonic.cpp"
        var $7=$maxSamples_addr; //@line 402 "sonic.cpp"
        $numSamples=$7; //@line 402 "sonic.cpp"
        ; //@line 403 "sonic.cpp"
      }
  
      var $8=$samples_addr; //@line 404 "sonic.cpp"
      var $9=$8; //@line 404 "sonic.cpp"
      var $10=$stream_addr; //@line 404 "sonic.cpp"
      var $outputBuffer=(($10+4)&4294967295); //@line 404 "sonic.cpp"
      var $11=HEAP32[(($outputBuffer)>>2)]; //@line 404 "sonic.cpp"
      var $12=$11; //@line 404 "sonic.cpp"
      var $13=$numSamples; //@line 404 "sonic.cpp"
      var $14=$stream_addr; //@line 404 "sonic.cpp"
      var $numChannels=(($14+28)&4294967295); //@line 404 "sonic.cpp"
      var $15=HEAP32[(($numChannels)>>2)]; //@line 404 "sonic.cpp"
      var $mul=((($13)*2)&4294967295); //@line 404 "sonic.cpp"
      var $mul4=((($mul)*($15))&4294967295); //@line 404 "sonic.cpp"
      var $src$, $dest$, $stop$, $stop4$, $fast$;
      $src$ = $12;
      $dest$ = $9;
      $stop$ = $src$ + $mul4;
      if (($dest$%4) == ($src$%4) && $mul4 > 8) {
        while ($src$%4 !== 0 && $src$ < $stop$) {
          ; HEAP8[$dest$++] = HEAP8[$src$++];
        }
        $src$ >>= 2;
        $dest$ >>= 2;
        $stop4$ = $stop$ >> 2;
        while ($src$ < $stop4$) {
      ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
        }
        $src$ <<= 2;
        $dest$ <<= 2;
      }while ($src$ < $stop$) {
        ; HEAP8[$dest$++] = HEAP8[$src$++];
      }; //@line 404 "sonic.cpp"
      var $16=$remainingSamples; //@line 405 "sonic.cpp"
      var $cmp5=((($16))|0) > 0; //@line 405 "sonic.cpp"
      if ($cmp5) { __label__ = 5;; } else { __label__ = 6;; } //@line 405 "sonic.cpp"
      if (__label__ == 5) {
  
        var $17=$stream_addr; //@line 406 "sonic.cpp"
        var $outputBuffer7=(($17+4)&4294967295); //@line 406 "sonic.cpp"
        var $18=HEAP32[(($outputBuffer7)>>2)]; //@line 406 "sonic.cpp"
        var $19=$18; //@line 406 "sonic.cpp"
        var $20=$stream_addr; //@line 406 "sonic.cpp"
        var $outputBuffer8=(($20+4)&4294967295); //@line 406 "sonic.cpp"
        var $21=HEAP32[(($outputBuffer8)>>2)]; //@line 406 "sonic.cpp"
        var $22=$numSamples; //@line 406 "sonic.cpp"
        var $23=$stream_addr; //@line 406 "sonic.cpp"
        var $numChannels9=(($23+28)&4294967295); //@line 406 "sonic.cpp"
        var $24=HEAP32[(($numChannels9)>>2)]; //@line 406 "sonic.cpp"
        var $mul10=((($24)*($22))&4294967295); //@line 406 "sonic.cpp"
        var $add_ptr=(($21+2*$mul10)&4294967295); //@line 406 "sonic.cpp"
        var $25=$add_ptr; //@line 406 "sonic.cpp"
        var $26=$remainingSamples; //@line 406 "sonic.cpp"
        var $27=$stream_addr; //@line 406 "sonic.cpp"
        var $numChannels12=(($27+28)&4294967295); //@line 406 "sonic.cpp"
        var $28=HEAP32[(($numChannels12)>>2)]; //@line 406 "sonic.cpp"
        var $mul11=((($26)*2)&4294967295); //@line 406 "sonic.cpp"
        var $mul13=((($mul11)*($28))&4294967295); //@line 406 "sonic.cpp"
        _llvm_memmove_p0i8_p0i8_i32($19, $25, $mul13, 1, 0); //@line 406 "sonic.cpp"
        ; //@line 408 "sonic.cpp"
      }
  
      var $29=$remainingSamples; //@line 409 "sonic.cpp"
      var $30=$stream_addr; //@line 409 "sonic.cpp"
      var $numOutputSamples15=(($30+48)&4294967295); //@line 409 "sonic.cpp"
      HEAP32[(($numOutputSamples15)>>2)]=$29; //@line 409 "sonic.cpp"
      var $31=$numSamples; //@line 410 "sonic.cpp"
      $retval=$31; //@line 410 "sonic.cpp"
      ; //@line 410 "sonic.cpp"
    }
  
    var $32=$retval; //@line 411 "sonic.cpp"
    ;
    return $32; //@line 411 "sonic.cpp"
    return null;
  }
  

  function _sonicReadUnsignedCharFromStream($stream, $samples, $maxSamples) {
    ;
    var __label__;
  
    var $retval;
    var $stream_addr;
    var $samples_addr;
    var $maxSamples_addr;
    var $numSamples;
    var $remainingSamples;
    var $buffer;
    var $count;
    $stream_addr=$stream;
    $samples_addr=$samples;
    $maxSamples_addr=$maxSamples;
    var $0=$stream_addr; //@line 420 "sonic.cpp"
    var $numOutputSamples=(($0+48)&4294967295); //@line 420 "sonic.cpp"
    var $1=HEAP32[(($numOutputSamples)>>2)]; //@line 420 "sonic.cpp"
    $numSamples=$1; //@line 420 "sonic.cpp"
    $remainingSamples=0; //@line 421 "sonic.cpp"
    var $2=$numSamples; //@line 425 "sonic.cpp"
    var $cmp=((($2))|0)==0; //@line 425 "sonic.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 425 "sonic.cpp"
    if (__label__ == 1) {
  
      $retval=0; //@line 426 "sonic.cpp"
      ; //@line 426 "sonic.cpp"
    }
    else if (__label__ == 2) {
  
      var $3=$numSamples; //@line 428 "sonic.cpp"
      var $4=$maxSamples_addr; //@line 428 "sonic.cpp"
      var $cmp1=((($3))|0) > ((($4))|0); //@line 428 "sonic.cpp"
      if ($cmp1) { __label__ = 3;; } else { __label__ = 4;; } //@line 428 "sonic.cpp"
      if (__label__ == 3) {
  
        var $5=$numSamples; //@line 429 "sonic.cpp"
        var $6=$maxSamples_addr; //@line 429 "sonic.cpp"
        var $sub=((($5)-($6))&4294967295); //@line 429 "sonic.cpp"
        $remainingSamples=$sub; //@line 429 "sonic.cpp"
        var $7=$maxSamples_addr; //@line 430 "sonic.cpp"
        $numSamples=$7; //@line 430 "sonic.cpp"
        ; //@line 431 "sonic.cpp"
      }
  
      var $8=$stream_addr; //@line 432 "sonic.cpp"
      var $outputBuffer=(($8+4)&4294967295); //@line 432 "sonic.cpp"
      var $9=HEAP32[(($outputBuffer)>>2)]; //@line 432 "sonic.cpp"
      $buffer=$9; //@line 432 "sonic.cpp"
      var $10=$numSamples; //@line 433 "sonic.cpp"
      var $11=$stream_addr; //@line 433 "sonic.cpp"
      var $numChannels=(($11+28)&4294967295); //@line 433 "sonic.cpp"
      var $12=HEAP32[(($numChannels)>>2)]; //@line 433 "sonic.cpp"
      var $mul=((($12)*($10))&4294967295); //@line 433 "sonic.cpp"
      var $dec1=((($mul)-1)&4294967295); //@line 434 "sonic.cpp"
      $count=$dec1; //@line 434 "sonic.cpp"
      var $tobool2=((($mul))|0)!=0; //@line 434 "sonic.cpp"
      if ($tobool2) { __label__ = 5;; } else { __label__ = 6;; } //@line 434 "sonic.cpp"
      $while_body$$while_end$8: do { 
        if (__label__ == 5) {
          while(1) { 
  
            var $13=$buffer; //@line 435 "sonic.cpp"
            var $incdec_ptr=(($13+2)&4294967295); //@line 435 "sonic.cpp"
            $buffer=$incdec_ptr; //@line 435 "sonic.cpp"
            var $14=HEAP16[(($13)>>1)]; //@line 435 "sonic.cpp"
            var $conv=(tempInt=(($14)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 435 "sonic.cpp"
            var $shr=($conv) >> 8; //@line 435 "sonic.cpp"
            var $conv4=((($shr)) & 255); //@line 435 "sonic.cpp"
            var $conv5=(tempInt=(($conv4)),(tempInt>=128?tempInt-256:tempInt)); //@line 435 "sonic.cpp"
            var $add=((($conv5)+128)&4294967295); //@line 435 "sonic.cpp"
            var $conv6=((($add)) & 255); //@line 435 "sonic.cpp"
            var $15=$samples_addr; //@line 435 "sonic.cpp"
            var $incdec_ptr7=(($15+1)&4294967295); //@line 435 "sonic.cpp"
            $samples_addr=$incdec_ptr7; //@line 435 "sonic.cpp"
            HEAP8[($15)]=$conv6; //@line 435 "sonic.cpp"
            var $_pr=$count; //@line 434 "sonic.cpp"
            var $dec=((($_pr)-1)&4294967295); //@line 434 "sonic.cpp"
            $count=$dec; //@line 434 "sonic.cpp"
            var $tobool=((($_pr))|0)!=0; //@line 434 "sonic.cpp"
            if ($tobool) { __label__ = 5;continue ; } else { __label__ = 6;break $while_body$$while_end$8; } //@line 434 "sonic.cpp"
          }
        }
      } while(0);
  
      var $16=$remainingSamples; //@line 437 "sonic.cpp"
      var $cmp8=((($16))|0) > 0; //@line 437 "sonic.cpp"
      if ($cmp8) { __label__ = 7;; } else { __label__ = 8;; } //@line 437 "sonic.cpp"
      if (__label__ == 7) {
  
        var $17=$stream_addr; //@line 438 "sonic.cpp"
        var $outputBuffer10=(($17+4)&4294967295); //@line 438 "sonic.cpp"
        var $18=HEAP32[(($outputBuffer10)>>2)]; //@line 438 "sonic.cpp"
        var $19=$18; //@line 438 "sonic.cpp"
        var $20=$stream_addr; //@line 438 "sonic.cpp"
        var $outputBuffer11=(($20+4)&4294967295); //@line 438 "sonic.cpp"
        var $21=HEAP32[(($outputBuffer11)>>2)]; //@line 438 "sonic.cpp"
        var $22=$numSamples; //@line 438 "sonic.cpp"
        var $23=$stream_addr; //@line 438 "sonic.cpp"
        var $numChannels12=(($23+28)&4294967295); //@line 438 "sonic.cpp"
        var $24=HEAP32[(($numChannels12)>>2)]; //@line 438 "sonic.cpp"
        var $mul13=((($24)*($22))&4294967295); //@line 438 "sonic.cpp"
        var $add_ptr=(($21+2*$mul13)&4294967295); //@line 438 "sonic.cpp"
        var $25=$add_ptr; //@line 438 "sonic.cpp"
        var $26=$remainingSamples; //@line 438 "sonic.cpp"
        var $27=$stream_addr; //@line 438 "sonic.cpp"
        var $numChannels15=(($27+28)&4294967295); //@line 438 "sonic.cpp"
        var $28=HEAP32[(($numChannels15)>>2)]; //@line 438 "sonic.cpp"
        var $mul14=((($26)*2)&4294967295); //@line 438 "sonic.cpp"
        var $mul16=((($mul14)*($28))&4294967295); //@line 438 "sonic.cpp"
        _llvm_memmove_p0i8_p0i8_i32($19, $25, $mul16, 1, 0); //@line 438 "sonic.cpp"
        ; //@line 440 "sonic.cpp"
      }
  
      var $29=$remainingSamples; //@line 441 "sonic.cpp"
      var $30=$stream_addr; //@line 441 "sonic.cpp"
      var $numOutputSamples18=(($30+48)&4294967295); //@line 441 "sonic.cpp"
      HEAP32[(($numOutputSamples18)>>2)]=$29; //@line 441 "sonic.cpp"
      var $31=$numSamples; //@line 442 "sonic.cpp"
      $retval=$31; //@line 442 "sonic.cpp"
      ; //@line 442 "sonic.cpp"
    }
  
    var $32=$retval; //@line 443 "sonic.cpp"
    ;
    return $32; //@line 443 "sonic.cpp"
    return null;
  }
  

  function _sonicFlushStream($stream) {
    ;
    var __label__;
  
    var $retval;
    var $stream_addr;
    var $maxRequired;
    var $numSamples;
    var $remainingSpace;
    var $numOutputSamples;
    var $expectedSamples;
    $stream_addr=$stream;
    var $0=$stream_addr; //@line 451 "sonic.cpp"
    var $maxRequired1=(($0+64)&4294967295); //@line 451 "sonic.cpp"
    var $1=HEAP32[(($maxRequired1)>>2)]; //@line 451 "sonic.cpp"
    $maxRequired=$1; //@line 451 "sonic.cpp"
    var $2=$stream_addr; //@line 452 "sonic.cpp"
    var $numInputSamples=(($2+44)&4294967295); //@line 452 "sonic.cpp"
    var $3=HEAP32[(($numInputSamples)>>2)]; //@line 452 "sonic.cpp"
    $numSamples=$3; //@line 452 "sonic.cpp"
    var $4=$numSamples; //@line 455 "sonic.cpp"
    var $cmp=((($4))|0)==0; //@line 455 "sonic.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 455 "sonic.cpp"
    $if_then$$if_end$2: do { 
      if (__label__ == 1) {
  
        $retval=1; //@line 456 "sonic.cpp"
        ; //@line 456 "sonic.cpp"
      }
      else if (__label__ == 2) {
  
        var $5=$numSamples; //@line 458 "sonic.cpp"
        var $6=$maxRequired; //@line 458 "sonic.cpp"
        var $cmp2=((($5))|0) >= ((($6))|0); //@line 458 "sonic.cpp"
        if ($cmp2) { __label__ = 3;; } else { __label__ = 5;; } //@line 458 "sonic.cpp"
        $land_lhs_true$$if_end4$5: do { 
          if (__label__ == 3) {
  
            var $7=$stream_addr; //@line 458 "sonic.cpp"
            var $call=_sonicWriteShortToStream($7, 0, 0); //@line 458 "sonic.cpp"
            var $tobool=((($call))|0)!=0; //@line 458 "sonic.cpp"
            if ($tobool) { __label__ = 5;break $land_lhs_true$$if_end4$5; } //@line 458 "sonic.cpp"
  
            $retval=0; //@line 459 "sonic.cpp"
            __label__ = 12;break $if_then$$if_end$2; //@line 459 "sonic.cpp"
          }
        } while(0);
  
        var $8=$stream_addr; //@line 461 "sonic.cpp"
        var $numInputSamples5=(($8+44)&4294967295); //@line 461 "sonic.cpp"
        var $9=HEAP32[(($numInputSamples5)>>2)]; //@line 461 "sonic.cpp"
        $numSamples=$9; //@line 461 "sonic.cpp"
        var $cmp6=((($9))|0)==0; //@line 462 "sonic.cpp"
        if ($cmp6) { __label__ = 6;; } else { __label__ = 7;; } //@line 462 "sonic.cpp"
        if (__label__ == 6) {
  
          $retval=1; //@line 463 "sonic.cpp"
          ; //@line 463 "sonic.cpp"
        }
        else if (__label__ == 7) {
  
          var $10=$maxRequired; //@line 465 "sonic.cpp"
          var $11=$numSamples; //@line 465 "sonic.cpp"
          var $sub=((($10)-($11))&4294967295); //@line 465 "sonic.cpp"
          $remainingSpace=$sub; //@line 465 "sonic.cpp"
          var $12=$stream_addr; //@line 466 "sonic.cpp"
          var $inputBuffer=(($12)&4294967295); //@line 466 "sonic.cpp"
          var $13=HEAP32[(($inputBuffer)>>2)]; //@line 466 "sonic.cpp"
          var $14=$numSamples; //@line 466 "sonic.cpp"
          var $15=$stream_addr; //@line 466 "sonic.cpp"
          var $numChannels=(($15+28)&4294967295); //@line 466 "sonic.cpp"
          var $16=HEAP32[(($numChannels)>>2)]; //@line 466 "sonic.cpp"
          var $mul=((($16)*($14))&4294967295); //@line 466 "sonic.cpp"
          var $add_ptr=(($13+2*$mul)&4294967295); //@line 466 "sonic.cpp"
          var $17=$add_ptr; //@line 466 "sonic.cpp"
          var $18=$remainingSpace; //@line 466 "sonic.cpp"
          var $19=$stream_addr; //@line 466 "sonic.cpp"
          var $numChannels10=(($19+28)&4294967295); //@line 466 "sonic.cpp"
          var $20=HEAP32[(($numChannels10)>>2)]; //@line 466 "sonic.cpp"
          var $mul9=((($18)*2)&4294967295); //@line 466 "sonic.cpp"
          var $mul11=((($mul9)*($20))&4294967295); //@line 466 "sonic.cpp"
          var $dest$, $stop$, $stop4$, $fast$, $value4$;
          $dest$ = $17;
          $stop$ = $dest$ + $mul11;
          $value4$ = 0;
          if ($value4$ < 0) $value4$ += 256;
          $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
          while ($dest$%4 !== 0 && $dest$ < $stop$) {
            ;; HEAP8[$dest$++] = 0;
          }
          $dest$ >>= 2;
          $stop4$ = $stop$ >> 2;
          while ($dest$ < $stop4$) {
          ;;;;;;;  HEAP32[$dest$++] = $value4$;
          }
          $dest$ <<= 2;
          while ($dest$ < $stop$) {
            ;; HEAP8[$dest$++] = 0;
          }; //@line 466 "sonic.cpp"
          var $21=$maxRequired; //@line 468 "sonic.cpp"
          var $22=$stream_addr; //@line 468 "sonic.cpp"
          var $numInputSamples12=(($22+44)&4294967295); //@line 468 "sonic.cpp"
          HEAP32[(($numInputSamples12)>>2)]=$21; //@line 468 "sonic.cpp"
          var $23=$stream_addr; //@line 469 "sonic.cpp"
          var $numOutputSamples13=(($23+48)&4294967295); //@line 469 "sonic.cpp"
          var $24=HEAP32[(($numOutputSamples13)>>2)]; //@line 469 "sonic.cpp"
          $numOutputSamples=$24; //@line 469 "sonic.cpp"
          var $25=$stream_addr; //@line 470 "sonic.cpp"
          var $call14=_sonicWriteShortToStream($25, 0, 0); //@line 470 "sonic.cpp"
          var $tobool15=((($call14))|0)!=0; //@line 470 "sonic.cpp"
          if ($tobool15) { __label__ = 9;; } else { __label__ = 8;; } //@line 470 "sonic.cpp"
          if (__label__ == 9) {
  
            var $26=$numSamples; //@line 474 "sonic.cpp"
            var $conv=((($26))|0); //@line 474 "sonic.cpp"
            var $27=$stream_addr; //@line 474 "sonic.cpp"
            var $speed=(($27+16)&4294967295); //@line 474 "sonic.cpp"
            var $28=HEAPF32[(($speed)>>2)]; //@line 474 "sonic.cpp"
            var $mul18=($conv)*($28); //@line 474 "sonic.cpp"
            var $conv19=($mul18); //@line 474 "sonic.cpp"
            var $add=($conv19)+0.5; //@line 474 "sonic.cpp"
            var $conv20=((($add))|0); //@line 474 "sonic.cpp"
            $expectedSamples=$conv20; //@line 474 "sonic.cpp"
            var $29=$stream_addr; //@line 475 "sonic.cpp"
            var $numOutputSamples21=(($29+48)&4294967295); //@line 475 "sonic.cpp"
            var $30=HEAP32[(($numOutputSamples21)>>2)]; //@line 475 "sonic.cpp"
            var $31=$numOutputSamples; //@line 475 "sonic.cpp"
            var $32=$expectedSamples; //@line 475 "sonic.cpp"
            var $add22=((($32)+($31))&4294967295); //@line 475 "sonic.cpp"
            var $cmp23=((($30))|0) > ((($add22))|0); //@line 475 "sonic.cpp"
            if ($cmp23) { __label__ = 10;; } else { __label__ = 11;; } //@line 475 "sonic.cpp"
            if (__label__ == 10) {
  
              var $33=$numOutputSamples; //@line 476 "sonic.cpp"
              var $34=$expectedSamples; //@line 476 "sonic.cpp"
              var $add25=((($34)+($33))&4294967295); //@line 476 "sonic.cpp"
              var $35=$stream_addr; //@line 476 "sonic.cpp"
              var $numOutputSamples26=(($35+48)&4294967295); //@line 476 "sonic.cpp"
              HEAP32[(($numOutputSamples26)>>2)]=$add25; //@line 476 "sonic.cpp"
              ; //@line 477 "sonic.cpp"
            }
  
            $retval=1; //@line 478 "sonic.cpp"
            ; //@line 478 "sonic.cpp"
          }
          else if (__label__ == 8) {
  
            $retval=0; //@line 471 "sonic.cpp"
            ; //@line 471 "sonic.cpp"
          }
        }
      }
    } while(0);
  
    var $36=$retval; //@line 479 "sonic.cpp"
    ;
    return $36; //@line 479 "sonic.cpp"
    return null;
  }
  

  function _sonicWriteShortToStream($stream, $samples, $numSamples) {
    ;
    var __label__;
  
    var $retval;
    var $stream_addr;
    var $samples_addr;
    var $numSamples_addr;
    $stream_addr=$stream;
    $samples_addr=$samples;
    $numSamples_addr=$numSamples;
    var $0=$stream_addr; //@line 904 "sonic.cpp"
    var $1=$samples_addr; //@line 904 "sonic.cpp"
    var $2=$numSamples_addr; //@line 904 "sonic.cpp"
    var $call=__ZL28addShortSamplesToInputBufferP17sonicStreamStructPsi($0, $1, $2); //@line 904 "sonic.cpp"
    var $tobool=((($call))|0)!=0; //@line 904 "sonic.cpp"
    if ($tobool) { __label__ = 2;; } else { __label__ = 1;; } //@line 904 "sonic.cpp"
    if (__label__ == 2) {
  
      var $3=$stream_addr; //@line 907 "sonic.cpp"
      var $call1=__ZL18processStreamInputP17sonicStreamStruct($3); //@line 907 "sonic.cpp"
      $retval=$call1; //@line 907 "sonic.cpp"
      ; //@line 907 "sonic.cpp"
    }
    else if (__label__ == 1) {
  
      $retval=0; //@line 905 "sonic.cpp"
      ; //@line 905 "sonic.cpp"
    }
  
    var $4=$retval; //@line 908 "sonic.cpp"
    ;
    return $4; //@line 908 "sonic.cpp"
    return null;
  }
  

  function _sonicSamplesAvailable($stream) {
    ;
    var __label__;
  
    var $stream_addr;
    $stream_addr=$stream;
    var $0=$stream_addr; //@line 485 "sonic.cpp"
    var $numOutputSamples=(($0+48)&4294967295); //@line 485 "sonic.cpp"
    var $1=HEAP32[(($numOutputSamples)>>2)]; //@line 485 "sonic.cpp"
    ;
    return $1; //@line 485 "sonic.cpp"
    return null;
  }
  

  function _sonicWriteFloatToStream($stream, $samples, $numSamples) {
    ;
    var __label__;
  
    var $retval;
    var $stream_addr;
    var $samples_addr;
    var $numSamples_addr;
    $stream_addr=$stream;
    $samples_addr=$samples;
    $numSamples_addr=$numSamples;
    var $0=$stream_addr; //@line 891 "sonic.cpp"
    var $1=$samples_addr; //@line 891 "sonic.cpp"
    var $2=$numSamples_addr; //@line 891 "sonic.cpp"
    var $call=__ZL28addFloatSamplesToInputBufferP17sonicStreamStructPfi($0, $1, $2); //@line 891 "sonic.cpp"
    var $tobool=((($call))|0)!=0; //@line 891 "sonic.cpp"
    if ($tobool) { __label__ = 2;; } else { __label__ = 1;; } //@line 891 "sonic.cpp"
    if (__label__ == 2) {
  
      var $3=$stream_addr; //@line 894 "sonic.cpp"
      var $call1=__ZL18processStreamInputP17sonicStreamStruct($3); //@line 894 "sonic.cpp"
      $retval=$call1; //@line 894 "sonic.cpp"
      ; //@line 894 "sonic.cpp"
    }
    else if (__label__ == 1) {
  
      $retval=0; //@line 892 "sonic.cpp"
      ; //@line 892 "sonic.cpp"
    }
  
    var $4=$retval; //@line 895 "sonic.cpp"
    ;
    return $4; //@line 895 "sonic.cpp"
    return null;
  }
  

  function __ZL28addFloatSamplesToInputBufferP17sonicStreamStructPfi($stream, $samples, $numSamples) {
    ;
    var __label__;
  
    var $retval;
    var $stream_addr;
    var $samples_addr;
    var $numSamples_addr;
    var $buffer;
    var $count;
    $stream_addr=$stream;
    $samples_addr=$samples;
    $numSamples_addr=$numSamples;
    var $0=$numSamples_addr; //@line 250 "sonic.cpp"
    var $1=$stream_addr; //@line 250 "sonic.cpp"
    var $numChannels=(($1+28)&4294967295); //@line 250 "sonic.cpp"
    var $2=HEAP32[(($numChannels)>>2)]; //@line 250 "sonic.cpp"
    var $mul=((($2)*($0))&4294967295); //@line 250 "sonic.cpp"
    $count=$mul; //@line 250 "sonic.cpp"
    var $3=$numSamples_addr; //@line 252 "sonic.cpp"
    var $cmp=((($3))|0)==0; //@line 252 "sonic.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 252 "sonic.cpp"
    if (__label__ == 1) {
  
      $retval=1; //@line 253 "sonic.cpp"
      ; //@line 253 "sonic.cpp"
    }
    else if (__label__ == 2) {
  
      var $4=$stream_addr; //@line 255 "sonic.cpp"
      var $5=$numSamples_addr; //@line 255 "sonic.cpp"
      var $call=__ZL26enlargeInputBufferIfNeededP17sonicStreamStructi($4, $5); //@line 255 "sonic.cpp"
      var $tobool=((($call))|0)!=0; //@line 255 "sonic.cpp"
      if ($tobool) { __label__ = 4;; } else { __label__ = 3;; } //@line 255 "sonic.cpp"
      if (__label__ == 4) {
  
        var $6=$stream_addr; //@line 258 "sonic.cpp"
        var $inputBuffer=(($6)&4294967295); //@line 258 "sonic.cpp"
        var $7=HEAP32[(($inputBuffer)>>2)]; //@line 258 "sonic.cpp"
        var $8=$stream_addr; //@line 258 "sonic.cpp"
        var $numInputSamples=(($8+44)&4294967295); //@line 258 "sonic.cpp"
        var $9=HEAP32[(($numInputSamples)>>2)]; //@line 258 "sonic.cpp"
        var $10=$stream_addr; //@line 258 "sonic.cpp"
        var $numChannels3=(($10+28)&4294967295); //@line 258 "sonic.cpp"
        var $11=HEAP32[(($numChannels3)>>2)]; //@line 258 "sonic.cpp"
        var $mul4=((($11)*($9))&4294967295); //@line 258 "sonic.cpp"
        var $add_ptr=(($7+2*$mul4)&4294967295); //@line 258 "sonic.cpp"
        $buffer=$add_ptr; //@line 258 "sonic.cpp"
        var $12=$count; //@line 259 "sonic.cpp"
        var $dec1=((($12)-1)&4294967295); //@line 259 "sonic.cpp"
        $count=$dec1; //@line 259 "sonic.cpp"
        var $tobool52=((($12))|0)!=0; //@line 259 "sonic.cpp"
        if ($tobool52) { __label__ = 5;; } else { __label__ = 6;; } //@line 259 "sonic.cpp"
        $while_body$$while_end$7: do { 
          if (__label__ == 5) {
            while(1) { 
  
              var $13=$samples_addr; //@line 260 "sonic.cpp"
              var $incdec_ptr=(($13+4)&4294967295); //@line 260 "sonic.cpp"
              $samples_addr=$incdec_ptr; //@line 260 "sonic.cpp"
              var $14=HEAPF32[(($13)>>2)]; //@line 260 "sonic.cpp"
              var $mul6=($14)*32767; //@line 260 "sonic.cpp"
              var $conv=((($mul6))|0); //@line 260 "sonic.cpp"
              var $15=$buffer; //@line 260 "sonic.cpp"
              var $incdec_ptr7=(($15+2)&4294967295); //@line 260 "sonic.cpp"
              $buffer=$incdec_ptr7; //@line 260 "sonic.cpp"
              HEAP16[(($15)>>1)]=$conv; //@line 260 "sonic.cpp"
              var $16=$count; //@line 259 "sonic.cpp"
              var $dec=((($16)-1)&4294967295); //@line 259 "sonic.cpp"
              $count=$dec; //@line 259 "sonic.cpp"
              var $tobool5=((($16))|0)!=0; //@line 259 "sonic.cpp"
              if ($tobool5) { __label__ = 5;continue ; } else { __label__ = 6;break $while_body$$while_end$7; } //@line 259 "sonic.cpp"
            }
          }
        } while(0);
  
        var $17=$numSamples_addr; //@line 262 "sonic.cpp"
        var $18=$stream_addr; //@line 262 "sonic.cpp"
        var $numInputSamples8=(($18+44)&4294967295); //@line 262 "sonic.cpp"
        var $19=HEAP32[(($numInputSamples8)>>2)]; //@line 262 "sonic.cpp"
        var $add=((($19)+($17))&4294967295); //@line 262 "sonic.cpp"
        HEAP32[(($numInputSamples8)>>2)]=$add; //@line 262 "sonic.cpp"
        $retval=1; //@line 263 "sonic.cpp"
        ; //@line 263 "sonic.cpp"
      }
      else if (__label__ == 3) {
  
        $retval=0; //@line 256 "sonic.cpp"
        ; //@line 256 "sonic.cpp"
      }
    }
  
    var $20=$retval; //@line 264 "sonic.cpp"
    ;
    return $20; //@line 264 "sonic.cpp"
    return null;
  }
  

  function __ZL18processStreamInputP17sonicStreamStruct($stream) {
    ;
    var __label__;
  
    var $retval;
    var $stream_addr;
    var $originalNumOutputSamples;
    var $speed;
    $stream_addr=$stream;
    var $0=$stream_addr; //@line 860 "sonic.cpp"
    var $numOutputSamples=(($0+48)&4294967295); //@line 860 "sonic.cpp"
    var $1=HEAP32[(($numOutputSamples)>>2)]; //@line 860 "sonic.cpp"
    $originalNumOutputSamples=$1; //@line 860 "sonic.cpp"
    var $2=$stream_addr; //@line 861 "sonic.cpp"
    var $speed1=(($2+16)&4294967295); //@line 861 "sonic.cpp"
    var $3=HEAPF32[(($speed1)>>2)]; //@line 861 "sonic.cpp"
    var $4=$stream_addr; //@line 861 "sonic.cpp"
    var $pitch=(($4+24)&4294967295); //@line 861 "sonic.cpp"
    var $5=HEAPF32[(($pitch)>>2)]; //@line 861 "sonic.cpp"
    var $div=($3)/($5); //@line 861 "sonic.cpp"
    $speed=$div; //@line 861 "sonic.cpp"
    var $6=$speed; //@line 863 "sonic.cpp"
    var $conv=($6); //@line 863 "sonic.cpp"
    var $cmp=($conv) > 1.00001; //@line 863 "sonic.cpp"
    if ($cmp) { __label__ = 2;; } else { __label__ = 1;; } //@line 863 "sonic.cpp"
    $if_then$$lor_lhs_false$2: do { 
      if (__label__ == 1) {
  
        var $7=$speed; //@line 863 "sonic.cpp"
        var $conv2=($7); //@line 863 "sonic.cpp"
        var $cmp3=($conv2) < 0.99999; //@line 863 "sonic.cpp"
        if ($cmp3) { __label__ = 2;break $if_then$$lor_lhs_false$2; } //@line 863 "sonic.cpp"
  
        var $10=$stream_addr; //@line 866 "sonic.cpp"
        var $11=$stream_addr; //@line 866 "sonic.cpp"
        var $inputBuffer=(($11)&4294967295); //@line 866 "sonic.cpp"
        var $12=HEAP32[(($inputBuffer)>>2)]; //@line 866 "sonic.cpp"
        var $13=$stream_addr; //@line 866 "sonic.cpp"
        var $numInputSamples=(($13+44)&4294967295); //@line 866 "sonic.cpp"
        var $14=HEAP32[(($numInputSamples)>>2)]; //@line 866 "sonic.cpp"
        var $call4=__ZL12copyToOutputP17sonicStreamStructPsi($10, $12, $14); //@line 866 "sonic.cpp"
        var $tobool=((($call4))|0)!=0; //@line 866 "sonic.cpp"
        if ($tobool) { __label__ = 5;; } else { __label__ = 4;; } //@line 866 "sonic.cpp"
        if (__label__ == 5) {
  
          var $15=$stream_addr; //@line 869 "sonic.cpp"
          var $numInputSamples6=(($15+44)&4294967295); //@line 869 "sonic.cpp"
          HEAP32[(($numInputSamples6)>>2)]=0; //@line 869 "sonic.cpp"
          __label__ = 6;break $if_then$$lor_lhs_false$2;
        }
        else if (__label__ == 4) {
  
          $retval=0; //@line 867 "sonic.cpp"
          __label__ = 12;break $if_then$$lor_lhs_false$2; //@line 867 "sonic.cpp"
        }
      }
    } while(0);
    $if_then$$if_end7$$return$8: do { 
      if (__label__ == 2) {
  
        var $8=$stream_addr; //@line 864 "sonic.cpp"
        var $9=$speed; //@line 864 "sonic.cpp"
        __ZL11changeSpeedP17sonicStreamStructf($8, $9); //@line 864 "sonic.cpp"
        __label__ = 6;break $if_then$$if_end7$$return$8; //@line 865 "sonic.cpp"
      }
    } while(0);
    $if_end7$$return$10: do { 
      if (__label__ == 6) {
  
        var $16=$stream_addr; //@line 871 "sonic.cpp"
        var $pitch8=(($16+24)&4294967295); //@line 871 "sonic.cpp"
        var $17=HEAPF32[(($pitch8)>>2)]; //@line 871 "sonic.cpp"
        var $cmp9=($17) != 1; //@line 871 "sonic.cpp"
        if ($cmp9) { __label__ = 7;; } else { __label__ = 9;; } //@line 871 "sonic.cpp"
        $if_then10$$if_end15$12: do { 
          if (__label__ == 7) {
  
            var $18=$stream_addr; //@line 872 "sonic.cpp"
            var $19=$originalNumOutputSamples; //@line 872 "sonic.cpp"
            var $call11=__ZL11adjustPitchP17sonicStreamStructi($18, $19); //@line 872 "sonic.cpp"
            var $tobool12=((($call11))|0)!=0; //@line 872 "sonic.cpp"
            if ($tobool12) { __label__ = 9;break $if_then10$$if_end15$12; } //@line 872 "sonic.cpp"
  
            $retval=0; //@line 873 "sonic.cpp"
            __label__ = 12;break $if_end7$$return$10; //@line 873 "sonic.cpp"
          }
        } while(0);
  
        var $20=$stream_addr; //@line 876 "sonic.cpp"
        var $volume=(($20+20)&4294967295); //@line 876 "sonic.cpp"
        var $21=HEAPF32[(($volume)>>2)]; //@line 876 "sonic.cpp"
        var $cmp16=($21) != 1; //@line 876 "sonic.cpp"
        if ($cmp16) { __label__ = 10;; } else { __label__ = 11;; } //@line 876 "sonic.cpp"
        if (__label__ == 10) {
  
          var $22=$stream_addr; //@line 878 "sonic.cpp"
          var $outputBuffer=(($22+4)&4294967295); //@line 878 "sonic.cpp"
          var $23=HEAP32[(($outputBuffer)>>2)]; //@line 878 "sonic.cpp"
          var $24=$originalNumOutputSamples; //@line 878 "sonic.cpp"
          var $25=$stream_addr; //@line 878 "sonic.cpp"
          var $numChannels=(($25+28)&4294967295); //@line 878 "sonic.cpp"
          var $26=HEAP32[(($numChannels)>>2)]; //@line 878 "sonic.cpp"
          var $mul=((($26)*($24))&4294967295); //@line 878 "sonic.cpp"
          var $add_ptr=(($23+2*$mul)&4294967295); //@line 878 "sonic.cpp"
          var $27=$stream_addr; //@line 878 "sonic.cpp"
          var $numOutputSamples18=(($27+48)&4294967295); //@line 878 "sonic.cpp"
          var $28=HEAP32[(($numOutputSamples18)>>2)]; //@line 878 "sonic.cpp"
          var $29=$originalNumOutputSamples; //@line 878 "sonic.cpp"
          var $sub=((($28)-($29))&4294967295); //@line 878 "sonic.cpp"
          var $30=$stream_addr; //@line 878 "sonic.cpp"
          var $numChannels19=(($30+28)&4294967295); //@line 878 "sonic.cpp"
          var $31=HEAP32[(($numChannels19)>>2)]; //@line 878 "sonic.cpp"
          var $mul20=((($31)*($sub))&4294967295); //@line 878 "sonic.cpp"
          var $32=$stream_addr; //@line 878 "sonic.cpp"
          var $volume21=(($32+20)&4294967295); //@line 878 "sonic.cpp"
          var $33=HEAPF32[(($volume21)>>2)]; //@line 878 "sonic.cpp"
          __ZL12scaleSamplesPsif($add_ptr, $mul20, $33); //@line 878 "sonic.cpp"
          ; //@line 881 "sonic.cpp"
        }
  
        $retval=1; //@line 882 "sonic.cpp"
        ; //@line 882 "sonic.cpp"
      }
    } while(0);
  
    var $34=$retval; //@line 883 "sonic.cpp"
    ;
    return $34; //@line 883 "sonic.cpp"
    return null;
  }
  

  function __ZL28addShortSamplesToInputBufferP17sonicStreamStructPsi($stream, $samples, $numSamples) {
    ;
    var __label__;
  
    var $retval;
    var $stream_addr;
    var $samples_addr;
    var $numSamples_addr;
    $stream_addr=$stream;
    $samples_addr=$samples;
    $numSamples_addr=$numSamples;
    var $0=$numSamples_addr; //@line 272 "sonic.cpp"
    var $cmp=((($0))|0)==0; //@line 272 "sonic.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 272 "sonic.cpp"
    if (__label__ == 1) {
  
      $retval=1; //@line 273 "sonic.cpp"
      ; //@line 273 "sonic.cpp"
    }
    else if (__label__ == 2) {
  
      var $1=$stream_addr; //@line 275 "sonic.cpp"
      var $2=$numSamples_addr; //@line 275 "sonic.cpp"
      var $call=__ZL26enlargeInputBufferIfNeededP17sonicStreamStructi($1, $2); //@line 275 "sonic.cpp"
      var $tobool=((($call))|0)!=0; //@line 275 "sonic.cpp"
      if ($tobool) { __label__ = 4;; } else { __label__ = 3;; } //@line 275 "sonic.cpp"
      if (__label__ == 4) {
  
        var $3=$stream_addr; //@line 278 "sonic.cpp"
        var $inputBuffer=(($3)&4294967295); //@line 278 "sonic.cpp"
        var $4=HEAP32[(($inputBuffer)>>2)]; //@line 278 "sonic.cpp"
        var $5=$stream_addr; //@line 278 "sonic.cpp"
        var $numInputSamples=(($5+44)&4294967295); //@line 278 "sonic.cpp"
        var $6=HEAP32[(($numInputSamples)>>2)]; //@line 278 "sonic.cpp"
        var $7=$stream_addr; //@line 278 "sonic.cpp"
        var $numChannels=(($7+28)&4294967295); //@line 278 "sonic.cpp"
        var $8=HEAP32[(($numChannels)>>2)]; //@line 278 "sonic.cpp"
        var $mul=((($8)*($6))&4294967295); //@line 278 "sonic.cpp"
        var $add_ptr=(($4+2*$mul)&4294967295); //@line 278 "sonic.cpp"
        var $9=$add_ptr; //@line 278 "sonic.cpp"
        var $10=$samples_addr; //@line 278 "sonic.cpp"
        var $11=$10; //@line 278 "sonic.cpp"
        var $12=$numSamples_addr; //@line 278 "sonic.cpp"
        var $13=$stream_addr; //@line 278 "sonic.cpp"
        var $numChannels4=(($13+28)&4294967295); //@line 278 "sonic.cpp"
        var $14=HEAP32[(($numChannels4)>>2)]; //@line 278 "sonic.cpp"
        var $mul3=((($12)*2)&4294967295); //@line 278 "sonic.cpp"
        var $mul5=((($mul3)*($14))&4294967295); //@line 278 "sonic.cpp"
        var $src$, $dest$, $stop$, $stop4$, $fast$;
        $src$ = $11;
        $dest$ = $9;
        $stop$ = $src$ + $mul5;
        if (($dest$%4) == ($src$%4) && $mul5 > 8) {
          while ($src$%4 !== 0 && $src$ < $stop$) {
            ; HEAP8[$dest$++] = HEAP8[$src$++];
          }
          $src$ >>= 2;
          $dest$ >>= 2;
          $stop4$ = $stop$ >> 2;
          while ($src$ < $stop4$) {
        ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
          }
          $src$ <<= 2;
          $dest$ <<= 2;
        }while ($src$ < $stop$) {
          ; HEAP8[$dest$++] = HEAP8[$src$++];
        }; //@line 278 "sonic.cpp"
        var $15=$numSamples_addr; //@line 280 "sonic.cpp"
        var $16=$stream_addr; //@line 280 "sonic.cpp"
        var $numInputSamples6=(($16+44)&4294967295); //@line 280 "sonic.cpp"
        var $17=HEAP32[(($numInputSamples6)>>2)]; //@line 280 "sonic.cpp"
        var $add=((($17)+($15))&4294967295); //@line 280 "sonic.cpp"
        HEAP32[(($numInputSamples6)>>2)]=$add; //@line 280 "sonic.cpp"
        $retval=1; //@line 281 "sonic.cpp"
        ; //@line 281 "sonic.cpp"
      }
      else if (__label__ == 3) {
  
        $retval=0; //@line 276 "sonic.cpp"
        ; //@line 276 "sonic.cpp"
      }
    }
  
    var $18=$retval; //@line 282 "sonic.cpp"
    ;
    return $18; //@line 282 "sonic.cpp"
    return null;
  }
  

  function _sonicWriteUnsignedCharToStream($stream, $samples, $numSamples) {
    ;
    var __label__;
  
    var $retval;
    var $stream_addr;
    var $samples_addr;
    var $numSamples_addr;
    $stream_addr=$stream;
    $samples_addr=$samples;
    $numSamples_addr=$numSamples;
    var $0=$stream_addr; //@line 917 "sonic.cpp"
    var $1=$samples_addr; //@line 917 "sonic.cpp"
    var $2=$numSamples_addr; //@line 917 "sonic.cpp"
    var $call=__ZL35addUnsignedCharSamplesToInputBufferP17sonicStreamStructPhi($0, $1, $2); //@line 917 "sonic.cpp"
    var $tobool=((($call))|0)!=0; //@line 917 "sonic.cpp"
    if ($tobool) { __label__ = 2;; } else { __label__ = 1;; } //@line 917 "sonic.cpp"
    if (__label__ == 2) {
  
      var $3=$stream_addr; //@line 920 "sonic.cpp"
      var $call1=__ZL18processStreamInputP17sonicStreamStruct($3); //@line 920 "sonic.cpp"
      $retval=$call1; //@line 920 "sonic.cpp"
      ; //@line 920 "sonic.cpp"
    }
    else if (__label__ == 1) {
  
      $retval=0; //@line 918 "sonic.cpp"
      ; //@line 918 "sonic.cpp"
    }
  
    var $4=$retval; //@line 921 "sonic.cpp"
    ;
    return $4; //@line 921 "sonic.cpp"
    return null;
  }
  

  function __ZL35addUnsignedCharSamplesToInputBufferP17sonicStreamStructPhi($stream, $samples, $numSamples) {
    ;
    var __label__;
  
    var $retval;
    var $stream_addr;
    var $samples_addr;
    var $numSamples_addr;
    var $buffer;
    var $count;
    $stream_addr=$stream;
    $samples_addr=$samples;
    $numSamples_addr=$numSamples;
    var $0=$numSamples_addr; //@line 291 "sonic.cpp"
    var $1=$stream_addr; //@line 291 "sonic.cpp"
    var $numChannels=(($1+28)&4294967295); //@line 291 "sonic.cpp"
    var $2=HEAP32[(($numChannels)>>2)]; //@line 291 "sonic.cpp"
    var $mul=((($2)*($0))&4294967295); //@line 291 "sonic.cpp"
    $count=$mul; //@line 291 "sonic.cpp"
    var $3=$numSamples_addr; //@line 293 "sonic.cpp"
    var $cmp=((($3))|0)==0; //@line 293 "sonic.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 293 "sonic.cpp"
    if (__label__ == 1) {
  
      $retval=1; //@line 294 "sonic.cpp"
      ; //@line 294 "sonic.cpp"
    }
    else if (__label__ == 2) {
  
      var $4=$stream_addr; //@line 296 "sonic.cpp"
      var $5=$numSamples_addr; //@line 296 "sonic.cpp"
      var $call=__ZL26enlargeInputBufferIfNeededP17sonicStreamStructi($4, $5); //@line 296 "sonic.cpp"
      var $tobool=((($call))|0)!=0; //@line 296 "sonic.cpp"
      if ($tobool) { __label__ = 4;; } else { __label__ = 3;; } //@line 296 "sonic.cpp"
      if (__label__ == 4) {
  
        var $6=$stream_addr; //@line 299 "sonic.cpp"
        var $inputBuffer=(($6)&4294967295); //@line 299 "sonic.cpp"
        var $7=HEAP32[(($inputBuffer)>>2)]; //@line 299 "sonic.cpp"
        var $8=$stream_addr; //@line 299 "sonic.cpp"
        var $numInputSamples=(($8+44)&4294967295); //@line 299 "sonic.cpp"
        var $9=HEAP32[(($numInputSamples)>>2)]; //@line 299 "sonic.cpp"
        var $10=$stream_addr; //@line 299 "sonic.cpp"
        var $numChannels3=(($10+28)&4294967295); //@line 299 "sonic.cpp"
        var $11=HEAP32[(($numChannels3)>>2)]; //@line 299 "sonic.cpp"
        var $mul4=((($11)*($9))&4294967295); //@line 299 "sonic.cpp"
        var $add_ptr=(($7+2*$mul4)&4294967295); //@line 299 "sonic.cpp"
        $buffer=$add_ptr; //@line 299 "sonic.cpp"
        var $12=$count; //@line 300 "sonic.cpp"
        var $dec1=((($12)-1)&4294967295); //@line 300 "sonic.cpp"
        $count=$dec1; //@line 300 "sonic.cpp"
        var $tobool52=((($12))|0)!=0; //@line 300 "sonic.cpp"
        if ($tobool52) { __label__ = 5;; } else { __label__ = 6;; } //@line 300 "sonic.cpp"
        $while_body$$while_end$7: do { 
          if (__label__ == 5) {
            while(1) { 
  
              var $13=$samples_addr; //@line 301 "sonic.cpp"
              var $incdec_ptr=(($13+1)&4294967295); //@line 301 "sonic.cpp"
              $samples_addr=$incdec_ptr; //@line 301 "sonic.cpp"
              var $14=HEAPU8[($13)]; //@line 301 "sonic.cpp"
              var $conv=((($14))&255); //@line 301 "sonic.cpp"
              var $sub=((($conv)-128)&4294967295); //@line 301 "sonic.cpp"
              var $shl=($sub) << 8; //@line 301 "sonic.cpp"
              var $conv6=((($shl)) & 65535); //@line 301 "sonic.cpp"
              var $15=$buffer; //@line 301 "sonic.cpp"
              var $incdec_ptr7=(($15+2)&4294967295); //@line 301 "sonic.cpp"
              $buffer=$incdec_ptr7; //@line 301 "sonic.cpp"
              HEAP16[(($15)>>1)]=$conv6; //@line 301 "sonic.cpp"
              var $16=$count; //@line 300 "sonic.cpp"
              var $dec=((($16)-1)&4294967295); //@line 300 "sonic.cpp"
              $count=$dec; //@line 300 "sonic.cpp"
              var $tobool5=((($16))|0)!=0; //@line 300 "sonic.cpp"
              if ($tobool5) { __label__ = 5;continue ; } else { __label__ = 6;break $while_body$$while_end$7; } //@line 300 "sonic.cpp"
            }
          }
        } while(0);
  
        var $17=$numSamples_addr; //@line 303 "sonic.cpp"
        var $18=$stream_addr; //@line 303 "sonic.cpp"
        var $numInputSamples8=(($18+44)&4294967295); //@line 303 "sonic.cpp"
        var $19=HEAP32[(($numInputSamples8)>>2)]; //@line 303 "sonic.cpp"
        var $add=((($19)+($17))&4294967295); //@line 303 "sonic.cpp"
        HEAP32[(($numInputSamples8)>>2)]=$add; //@line 303 "sonic.cpp"
        $retval=1; //@line 304 "sonic.cpp"
        ; //@line 304 "sonic.cpp"
      }
      else if (__label__ == 3) {
  
        $retval=0; //@line 297 "sonic.cpp"
        ; //@line 297 "sonic.cpp"
      }
    }
  
    var $20=$retval; //@line 305 "sonic.cpp"
    ;
    return $20; //@line 305 "sonic.cpp"
    return null;
  }
  

  function _sonicChangeFloatSpeed($samples, $numSamples, $speed, $pitch, $volume, $sampleRate, $numChannels) {
    ;
    var __label__;
  
    var $samples_addr;
    var $numSamples_addr;
    var $speed_addr;
    var $pitch_addr;
    var $volume_addr;
    var $sampleRate_addr;
    var $numChannels_addr;
    var $stream;
    $samples_addr=$samples;
    $numSamples_addr=$numSamples;
    $speed_addr=$speed;
    $pitch_addr=$pitch;
    $volume_addr=$volume;
    $sampleRate_addr=$sampleRate;
    $numChannels_addr=$numChannels;
    var $0=$sampleRate_addr; //@line 933 "sonic.cpp"
    var $1=$numChannels_addr; //@line 933 "sonic.cpp"
    var $call=_sonicCreateStream($0, $1); //@line 933 "sonic.cpp"
    $stream=$call; //@line 933 "sonic.cpp"
    var $2=$stream; //@line 935 "sonic.cpp"
    var $3=$speed_addr; //@line 935 "sonic.cpp"
    _sonicSetSpeed($2, $3); //@line 935 "sonic.cpp"
    var $4=$stream; //@line 936 "sonic.cpp"
    var $5=$pitch_addr; //@line 936 "sonic.cpp"
    _sonicSetPitch($4, $5); //@line 936 "sonic.cpp"
    var $6=$stream; //@line 937 "sonic.cpp"
    var $7=$volume_addr; //@line 937 "sonic.cpp"
    _sonicSetVolume($6, $7); //@line 937 "sonic.cpp"
    var $8=$stream; //@line 938 "sonic.cpp"
    var $9=$samples_addr; //@line 938 "sonic.cpp"
    var $10=$numSamples_addr; //@line 938 "sonic.cpp"
    var $call1=_sonicWriteFloatToStream($8, $9, $10); //@line 938 "sonic.cpp"
    var $11=$stream; //@line 939 "sonic.cpp"
    var $call2=_sonicFlushStream($11); //@line 939 "sonic.cpp"
    var $12=$stream; //@line 940 "sonic.cpp"
    var $call3=_sonicSamplesAvailable($12); //@line 940 "sonic.cpp"
    $numSamples_addr=$call3; //@line 940 "sonic.cpp"
    var $13=$stream; //@line 941 "sonic.cpp"
    var $14=$samples_addr; //@line 941 "sonic.cpp"
    var $15=$numSamples_addr; //@line 941 "sonic.cpp"
    var $call4=_sonicReadFloatFromStream($13, $14, $15); //@line 941 "sonic.cpp"
    var $16=$stream; //@line 942 "sonic.cpp"
    _sonicDestroyStream($16); //@line 942 "sonic.cpp"
    var $17=$numSamples_addr; //@line 943 "sonic.cpp"
    ;
    return $17; //@line 943 "sonic.cpp"
    return null;
  }
  

  function _sonicChangeShortSpeed($samples, $numSamples, $speed, $pitch, $volume, $sampleRate, $numChannels) {
    ;
    var __label__;
  
    var $samples_addr;
    var $numSamples_addr;
    var $speed_addr;
    var $pitch_addr;
    var $volume_addr;
    var $sampleRate_addr;
    var $numChannels_addr;
    var $stream;
    $samples_addr=$samples;
    $numSamples_addr=$numSamples;
    $speed_addr=$speed;
    $pitch_addr=$pitch;
    $volume_addr=$volume;
    $sampleRate_addr=$sampleRate;
    $numChannels_addr=$numChannels;
    var $0=$sampleRate_addr; //@line 956 "sonic.cpp"
    var $1=$numChannels_addr; //@line 956 "sonic.cpp"
    var $call=_sonicCreateStream($0, $1); //@line 956 "sonic.cpp"
    $stream=$call; //@line 956 "sonic.cpp"
    var $2=$stream; //@line 958 "sonic.cpp"
    var $3=$speed_addr; //@line 958 "sonic.cpp"
    _sonicSetSpeed($2, $3); //@line 958 "sonic.cpp"
    var $4=$stream; //@line 959 "sonic.cpp"
    var $5=$pitch_addr; //@line 959 "sonic.cpp"
    _sonicSetPitch($4, $5); //@line 959 "sonic.cpp"
    var $6=$stream; //@line 960 "sonic.cpp"
    var $7=$volume_addr; //@line 960 "sonic.cpp"
    _sonicSetVolume($6, $7); //@line 960 "sonic.cpp"
    var $8=$stream; //@line 961 "sonic.cpp"
    var $9=$samples_addr; //@line 961 "sonic.cpp"
    var $10=$numSamples_addr; //@line 961 "sonic.cpp"
    var $call1=_sonicWriteShortToStream($8, $9, $10); //@line 961 "sonic.cpp"
    var $11=$stream; //@line 962 "sonic.cpp"
    var $call2=_sonicFlushStream($11); //@line 962 "sonic.cpp"
    var $12=$stream; //@line 963 "sonic.cpp"
    var $call3=_sonicSamplesAvailable($12); //@line 963 "sonic.cpp"
    $numSamples_addr=$call3; //@line 963 "sonic.cpp"
    var $13=$stream; //@line 964 "sonic.cpp"
    var $14=$samples_addr; //@line 964 "sonic.cpp"
    var $15=$numSamples_addr; //@line 964 "sonic.cpp"
    var $call4=_sonicReadShortFromStream($13, $14, $15); //@line 964 "sonic.cpp"
    var $16=$stream; //@line 965 "sonic.cpp"
    _sonicDestroyStream($16); //@line 965 "sonic.cpp"
    var $17=$numSamples_addr; //@line 966 "sonic.cpp"
    ;
    return $17; //@line 966 "sonic.cpp"
    return null;
  }
  

  function __ZL26enlargeInputBufferIfNeededP17sonicStreamStructi($stream, $numSamples) {
    ;
    var __label__;
  
    var $retval;
    var $stream_addr;
    var $numSamples_addr;
    $stream_addr=$stream;
    $numSamples_addr=$numSamples;
    var $0=$stream_addr; //@line 232 "sonic.cpp"
    var $numInputSamples=(($0+44)&4294967295); //@line 232 "sonic.cpp"
    var $1=HEAP32[(($numInputSamples)>>2)]; //@line 232 "sonic.cpp"
    var $2=$numSamples_addr; //@line 232 "sonic.cpp"
    var $add=((($2)+($1))&4294967295); //@line 232 "sonic.cpp"
    var $3=$stream_addr; //@line 232 "sonic.cpp"
    var $inputBufferSize=(($3+32)&4294967295); //@line 232 "sonic.cpp"
    var $4=HEAP32[(($inputBufferSize)>>2)]; //@line 232 "sonic.cpp"
    var $cmp=((($add))|0) > ((($4))|0); //@line 232 "sonic.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 3;; } //@line 232 "sonic.cpp"
    $if_then$$if_end11$2: do { 
      if (__label__ == 1) {
  
        var $5=$stream_addr; //@line 233 "sonic.cpp"
        var $inputBufferSize1=(($5+32)&4294967295); //@line 233 "sonic.cpp"
        var $6=HEAP32[(($inputBufferSize1)>>2)]; //@line 233 "sonic.cpp"
        var $shr=($6) >> 1; //@line 233 "sonic.cpp"
        var $7=$numSamples_addr; //@line 233 "sonic.cpp"
        var $8=$stream_addr; //@line 233 "sonic.cpp"
        var $inputBufferSize3=(($8+32)&4294967295); //@line 233 "sonic.cpp"
        var $9=HEAP32[(($inputBufferSize3)>>2)]; //@line 233 "sonic.cpp"
        var $add2=((($shr)+($7))&4294967295); //@line 233 "sonic.cpp"
        var $add4=((($add2)+($9))&4294967295); //@line 233 "sonic.cpp"
        HEAP32[(($inputBufferSize3)>>2)]=$add4; //@line 233 "sonic.cpp"
        var $10=$stream_addr; //@line 234 "sonic.cpp"
        var $inputBuffer=(($10)&4294967295); //@line 234 "sonic.cpp"
        var $11=HEAP32[(($inputBuffer)>>2)]; //@line 234 "sonic.cpp"
        var $12=$11; //@line 234 "sonic.cpp"
        var $13=$stream_addr; //@line 234 "sonic.cpp"
        var $inputBufferSize5=(($13+32)&4294967295); //@line 234 "sonic.cpp"
        var $14=HEAP32[(($inputBufferSize5)>>2)]; //@line 234 "sonic.cpp"
        var $15=$stream_addr; //@line 234 "sonic.cpp"
        var $numChannels=(($15+28)&4294967295); //@line 234 "sonic.cpp"
        var $16=HEAP32[(($numChannels)>>2)]; //@line 234 "sonic.cpp"
        var $mul=((($14)*2)&4294967295); //@line 234 "sonic.cpp"
        var $mul6=((($mul)*($16))&4294967295); //@line 234 "sonic.cpp"
        var $call=_realloc($12, $mul6); //@line 234 "sonic.cpp"
        var $17=$call; //@line 234 "sonic.cpp"
        var $18=$stream_addr; //@line 234 "sonic.cpp"
        var $inputBuffer7=(($18)&4294967295); //@line 234 "sonic.cpp"
        HEAP32[(($inputBuffer7)>>2)]=$17; //@line 234 "sonic.cpp"
        var $19=$stream_addr; //@line 236 "sonic.cpp"
        var $inputBuffer8=(($19)&4294967295); //@line 236 "sonic.cpp"
        var $20=HEAP32[(($inputBuffer8)>>2)]; //@line 236 "sonic.cpp"
        var $cmp9=((($20))|0)==0; //@line 236 "sonic.cpp"
        if (!($cmp9)) { __label__ = 3;break $if_then$$if_end11$2; } //@line 236 "sonic.cpp"
  
        $retval=0; //@line 237 "sonic.cpp"
        __label__ = 4;break $if_then$$if_end11$2; //@line 237 "sonic.cpp"
      }
    } while(0);
    if (__label__ == 3) {
  
      $retval=1; //@line 240 "sonic.cpp"
      ; //@line 240 "sonic.cpp"
    }
  
    var $21=$retval; //@line 241 "sonic.cpp"
    ;
    return $21; //@line 241 "sonic.cpp"
    return null;
  }
  

  function __ZL11changeSpeedP17sonicStreamStructf($stream, $speed) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $stream_addr;
    var $speed_addr;
    var $samples;
    var $numSamples;
    var $position;
    var $period;
    var $newSamples;
    var $maxRequired;
    $stream_addr=$stream;
    $speed_addr=$speed;
    var $0=$stream_addr; //@line 825 "sonic.cpp"
    var $numInputSamples=(($0+44)&4294967295); //@line 825 "sonic.cpp"
    var $1=HEAP32[(($numInputSamples)>>2)]; //@line 825 "sonic.cpp"
    $numSamples=$1; //@line 825 "sonic.cpp"
    $position=0; //@line 826 "sonic.cpp"
    var $2=$stream_addr; //@line 827 "sonic.cpp"
    var $maxRequired1=(($2+64)&4294967295); //@line 827 "sonic.cpp"
    var $3=HEAP32[(($maxRequired1)>>2)]; //@line 827 "sonic.cpp"
    $maxRequired=$3; //@line 827 "sonic.cpp"
    var $4=$stream_addr; //@line 829 "sonic.cpp"
    var $numInputSamples2=(($4+44)&4294967295); //@line 829 "sonic.cpp"
    var $5=HEAP32[(($numInputSamples2)>>2)]; //@line 829 "sonic.cpp"
    var $6=$maxRequired; //@line 829 "sonic.cpp"
    var $cmp=((($5))|0) < ((($6))|0); //@line 829 "sonic.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 829 "sonic.cpp"
    if (__label__ == 1) {
  
      $retval=1; //@line 830 "sonic.cpp"
      ; //@line 830 "sonic.cpp"
    }
    else if (__label__ == 2) {
      while(1) { 
  
        var $7=$stream_addr; //@line 833 "sonic.cpp"
        var $remainingInputToCopy=(($7+68)&4294967295); //@line 833 "sonic.cpp"
        var $8=HEAP32[(($remainingInputToCopy)>>2)]; //@line 833 "sonic.cpp"
        var $cmp3=((($8))|0) > 0; //@line 833 "sonic.cpp"
        var $9=$stream_addr; //@line 834 "sonic.cpp"
        if ($cmp3) { __label__ = 3;; } else { __label__ = 4;; } //@line 833 "sonic.cpp"
        if (__label__ == 3) {
  
          var $10=$position; //@line 834 "sonic.cpp"
          var $call=__ZL17copyInputToOutputP17sonicStreamStructi($9, $10); //@line 834 "sonic.cpp"
          $newSamples=$call; //@line 834 "sonic.cpp"
          var $11=$newSamples; //@line 835 "sonic.cpp"
          var $12=$position; //@line 835 "sonic.cpp"
          var $add=((($12)+($11))&4294967295); //@line 835 "sonic.cpp"
          $position=$add; //@line 835 "sonic.cpp"
          __lastLabel__ = 3; ; //@line 836 "sonic.cpp"
        }
        else if (__label__ == 4) {
  
          var $inputBuffer=(($9)&4294967295); //@line 837 "sonic.cpp"
          var $13=HEAP32[(($inputBuffer)>>2)]; //@line 837 "sonic.cpp"
          var $14=$position; //@line 837 "sonic.cpp"
          var $15=$stream_addr; //@line 837 "sonic.cpp"
          var $numChannels=(($15+28)&4294967295); //@line 837 "sonic.cpp"
          var $16=HEAP32[(($numChannels)>>2)]; //@line 837 "sonic.cpp"
          var $mul=((($16)*($14))&4294967295); //@line 837 "sonic.cpp"
          var $add_ptr=(($13+2*$mul)&4294967295); //@line 837 "sonic.cpp"
          $samples=$add_ptr; //@line 837 "sonic.cpp"
          var $17=$stream_addr; //@line 838 "sonic.cpp"
          var $18=$samples; //@line 838 "sonic.cpp"
          var $call5=__ZL15findPitchPeriodP17sonicStreamStructPs($17, $18); //@line 838 "sonic.cpp"
          $period=$call5; //@line 838 "sonic.cpp"
          var $19=$speed_addr; //@line 839 "sonic.cpp"
          var $conv=($19); //@line 839 "sonic.cpp"
          var $cmp6=($conv) > 1; //@line 839 "sonic.cpp"
          var $20=$stream_addr; //@line 840 "sonic.cpp"
          var $21=$samples; //@line 840 "sonic.cpp"
          var $22=$speed_addr; //@line 840 "sonic.cpp"
          var $23=$period; //@line 840 "sonic.cpp"
          if ($cmp6) { __label__ = 5;; } else { __label__ = 6;; } //@line 839 "sonic.cpp"
          if (__label__ == 5) {
  
            var $call8=__ZL15skipPitchPeriodP17sonicStreamStructPsfi($20, $21, $22, $23); //@line 840 "sonic.cpp"
            $newSamples=$call8; //@line 840 "sonic.cpp"
            var $24=$period; //@line 841 "sonic.cpp"
            var $25=$newSamples; //@line 841 "sonic.cpp"
            var $26=$position; //@line 841 "sonic.cpp"
            var $add9=((($25)+($24))&4294967295); //@line 841 "sonic.cpp"
            var $add10=((($add9)+($26))&4294967295); //@line 841 "sonic.cpp"
            $position=$add10; //@line 841 "sonic.cpp"
            __lastLabel__ = 5; ; //@line 842 "sonic.cpp"
          }
          else if (__label__ == 6) {
  
            var $call12=__ZL17insertPitchPeriodP17sonicStreamStructPsfi($20, $21, $22, $23); //@line 843 "sonic.cpp"
            $newSamples=$call12; //@line 843 "sonic.cpp"
            var $27=$newSamples; //@line 844 "sonic.cpp"
            var $28=$position; //@line 844 "sonic.cpp"
            var $add13=((($28)+($27))&4294967295); //@line 844 "sonic.cpp"
            $position=$add13; //@line 844 "sonic.cpp"
            __lastLabel__ = 6; ;
          }
        }
  
        var $29=__lastLabel__ == 5 ? $25 : (__lastLabel__ == 6 ? $27 : ($11)); //@line 847 "sonic.cpp"
        var $cmp16=((($29))|0)==0; //@line 847 "sonic.cpp"
        if ($cmp16) { __label__ = 8;break ; } //@line 847 "sonic.cpp"
  
        var $30=$position; //@line 850 "sonic.cpp"
        var $31=$maxRequired; //@line 850 "sonic.cpp"
        var $add19=((($31)+($30))&4294967295); //@line 850 "sonic.cpp"
        var $32=$numSamples; //@line 850 "sonic.cpp"
        var $cmp20=((($add19))|0) <= ((($32))|0); //@line 850 "sonic.cpp"
        if ($cmp20) { __label__ = 2;continue ; } else { __label__ = 10;break ; } //@line 850 "sonic.cpp"
      }
      if (__label__ == 8) {
  
        $retval=0; //@line 848 "sonic.cpp"
        ; //@line 848 "sonic.cpp"
      }
      else if (__label__ == 10) {
  
        var $33=$stream_addr; //@line 851 "sonic.cpp"
        var $34=$position; //@line 851 "sonic.cpp"
        __ZL18removeInputSamplesP17sonicStreamStructi($33, $34); //@line 851 "sonic.cpp"
        $retval=1; //@line 852 "sonic.cpp"
        ; //@line 852 "sonic.cpp"
      }
    }
  
    ;
    return;
    return;
  }
  

  function __ZL12copyToOutputP17sonicStreamStructPsi($stream, $samples, $numSamples) {
    ;
    var __label__;
  
    var $retval;
    var $stream_addr;
    var $samples_addr;
    var $numSamples_addr;
    $stream_addr=$stream;
    $samples_addr=$samples;
    $numSamples_addr=$numSamples;
    var $0=$stream_addr; //@line 327 "sonic.cpp"
    var $1=$numSamples_addr; //@line 327 "sonic.cpp"
    var $call=__ZL27enlargeOutputBufferIfNeededP17sonicStreamStructi($0, $1); //@line 327 "sonic.cpp"
    var $tobool=((($call))|0)!=0; //@line 327 "sonic.cpp"
    if ($tobool) { __label__ = 2;; } else { __label__ = 1;; } //@line 327 "sonic.cpp"
    if (__label__ == 2) {
  
      var $2=$stream_addr; //@line 330 "sonic.cpp"
      var $outputBuffer=(($2+4)&4294967295); //@line 330 "sonic.cpp"
      var $3=HEAP32[(($outputBuffer)>>2)]; //@line 330 "sonic.cpp"
      var $4=$stream_addr; //@line 330 "sonic.cpp"
      var $numOutputSamples=(($4+48)&4294967295); //@line 330 "sonic.cpp"
      var $5=HEAP32[(($numOutputSamples)>>2)]; //@line 330 "sonic.cpp"
      var $6=$stream_addr; //@line 330 "sonic.cpp"
      var $numChannels=(($6+28)&4294967295); //@line 330 "sonic.cpp"
      var $7=HEAP32[(($numChannels)>>2)]; //@line 330 "sonic.cpp"
      var $mul=((($7)*($5))&4294967295); //@line 330 "sonic.cpp"
      var $add_ptr=(($3+2*$mul)&4294967295); //@line 330 "sonic.cpp"
      var $8=$add_ptr; //@line 330 "sonic.cpp"
      var $9=$samples_addr; //@line 330 "sonic.cpp"
      var $10=$9; //@line 330 "sonic.cpp"
      var $11=$numSamples_addr; //@line 330 "sonic.cpp"
      var $12=$stream_addr; //@line 330 "sonic.cpp"
      var $numChannels2=(($12+28)&4294967295); //@line 330 "sonic.cpp"
      var $13=HEAP32[(($numChannels2)>>2)]; //@line 330 "sonic.cpp"
      var $mul1=((($11)*2)&4294967295); //@line 330 "sonic.cpp"
      var $mul3=((($mul1)*($13))&4294967295); //@line 330 "sonic.cpp"
      var $src$, $dest$, $stop$, $stop4$, $fast$;
      $src$ = $10;
      $dest$ = $8;
      $stop$ = $src$ + $mul3;
      if (($dest$%4) == ($src$%4) && $mul3 > 8) {
        while ($src$%4 !== 0 && $src$ < $stop$) {
          ; HEAP8[$dest$++] = HEAP8[$src$++];
        }
        $src$ >>= 2;
        $dest$ >>= 2;
        $stop4$ = $stop$ >> 2;
        while ($src$ < $stop4$) {
      ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
        }
        $src$ <<= 2;
        $dest$ <<= 2;
      }while ($src$ < $stop$) {
        ; HEAP8[$dest$++] = HEAP8[$src$++];
      }; //@line 330 "sonic.cpp"
      var $14=$numSamples_addr; //@line 332 "sonic.cpp"
      var $15=$stream_addr; //@line 332 "sonic.cpp"
      var $numOutputSamples4=(($15+48)&4294967295); //@line 332 "sonic.cpp"
      var $16=HEAP32[(($numOutputSamples4)>>2)]; //@line 332 "sonic.cpp"
      var $add=((($16)+($14))&4294967295); //@line 332 "sonic.cpp"
      HEAP32[(($numOutputSamples4)>>2)]=$add; //@line 332 "sonic.cpp"
      var $17=$numSamples_addr; //@line 333 "sonic.cpp"
      $retval=$17; //@line 333 "sonic.cpp"
      ; //@line 333 "sonic.cpp"
    }
    else if (__label__ == 1) {
  
      $retval=0; //@line 328 "sonic.cpp"
      ; //@line 328 "sonic.cpp"
    }
  
    var $18=$retval; //@line 334 "sonic.cpp"
    ;
    return $18; //@line 334 "sonic.cpp"
    return null;
  }
  

  function __ZL11adjustPitchP17sonicStreamStructi($stream, $originalNumOutputSamples) {
    ;
    var __label__;
  
    var $retval;
    var $stream_addr;
    var $originalNumOutputSamples_addr;
    var $pitch;
    var $numChannels;
    var $period;
    var $newPeriod;
    var $separation;
    var $position;
    var $out;
    var $rampDown;
    var $rampUp;
    $stream_addr=$stream;
    $originalNumOutputSamples_addr=$originalNumOutputSamples;
    var $0=$stream_addr; //@line 729 "sonic.cpp"
    var $pitch1=(($0+24)&4294967295); //@line 729 "sonic.cpp"
    var $1=HEAPF32[(($pitch1)>>2)]; //@line 729 "sonic.cpp"
    $pitch=$1; //@line 729 "sonic.cpp"
    var $2=$stream_addr; //@line 730 "sonic.cpp"
    var $numChannels2=(($2+28)&4294967295); //@line 730 "sonic.cpp"
    var $3=HEAP32[(($numChannels2)>>2)]; //@line 730 "sonic.cpp"
    $numChannels=$3; //@line 730 "sonic.cpp"
    $position=0; //@line 732 "sonic.cpp"
    var $4=$stream_addr; //@line 735 "sonic.cpp"
    var $numOutputSamples=(($4+48)&4294967295); //@line 735 "sonic.cpp"
    var $5=HEAP32[(($numOutputSamples)>>2)]; //@line 735 "sonic.cpp"
    var $6=$originalNumOutputSamples_addr; //@line 735 "sonic.cpp"
    var $cmp=((($5))|0)==((($6))|0); //@line 735 "sonic.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 735 "sonic.cpp"
    if (__label__ == 1) {
  
      $retval=1; //@line 736 "sonic.cpp"
      ; //@line 736 "sonic.cpp"
    }
    else if (__label__ == 2) {
  
      var $7=$stream_addr; //@line 738 "sonic.cpp"
      var $8=$originalNumOutputSamples_addr; //@line 738 "sonic.cpp"
      var $call=__ZL27moveNewSamplesToPitchBufferP17sonicStreamStructi($7, $8); //@line 738 "sonic.cpp"
      var $tobool=((($call))|0)!=0; //@line 738 "sonic.cpp"
      if ($tobool) { __label__ = 4;; } else { __label__ = 3;; } //@line 738 "sonic.cpp"
      if (__label__ == 4) {
        while(1) { 
  
          var $9=$stream_addr; //@line 741 "sonic.cpp"
          var $numPitchSamples=(($9+52)&4294967295); //@line 741 "sonic.cpp"
          var $10=HEAP32[(($numPitchSamples)>>2)]; //@line 741 "sonic.cpp"
          var $11=$position; //@line 741 "sonic.cpp"
          var $sub=((($10)-($11))&4294967295); //@line 741 "sonic.cpp"
          var $12=$stream_addr; //@line 741 "sonic.cpp"
          var $maxRequired=(($12+64)&4294967295); //@line 741 "sonic.cpp"
          var $13=HEAP32[(($maxRequired)>>2)]; //@line 741 "sonic.cpp"
          var $cmp5=((($sub))|0) >= ((($13))|0); //@line 741 "sonic.cpp"
          var $14=$stream_addr; //@line 742 "sonic.cpp"
          if (!($cmp5)) { __label__ = 11;break ; } //@line 741 "sonic.cpp"
  
          var $15=$stream_addr; //@line 742 "sonic.cpp"
          var $pitchBuffer=(($15+8)&4294967295); //@line 742 "sonic.cpp"
          var $16=HEAP32[(($pitchBuffer)>>2)]; //@line 742 "sonic.cpp"
          var $17=$position; //@line 742 "sonic.cpp"
          var $18=$numChannels; //@line 742 "sonic.cpp"
          var $mul=((($18)*($17))&4294967295); //@line 742 "sonic.cpp"
          var $add_ptr=(($16+2*$mul)&4294967295); //@line 742 "sonic.cpp"
          var $call6=__ZL15findPitchPeriodP17sonicStreamStructPs($14, $add_ptr); //@line 742 "sonic.cpp"
          $period=$call6; //@line 742 "sonic.cpp"
          var $19=$period; //@line 743 "sonic.cpp"
          var $conv=((($19))|0); //@line 743 "sonic.cpp"
          var $20=$pitch; //@line 743 "sonic.cpp"
          var $div=($conv)/($20); //@line 743 "sonic.cpp"
          var $conv7=((($div))|0); //@line 743 "sonic.cpp"
          $newPeriod=$conv7; //@line 743 "sonic.cpp"
          var $21=$stream_addr; //@line 744 "sonic.cpp"
          var $22=$newPeriod; //@line 744 "sonic.cpp"
          var $call8=__ZL27enlargeOutputBufferIfNeededP17sonicStreamStructi($21, $22); //@line 744 "sonic.cpp"
          var $tobool9=((($call8))|0)!=0; //@line 744 "sonic.cpp"
          if (!($tobool9)) { __label__ = 6;break ; } //@line 744 "sonic.cpp"
  
          var $23=$stream_addr; //@line 747 "sonic.cpp"
          var $outputBuffer=(($23+4)&4294967295); //@line 747 "sonic.cpp"
          var $24=HEAP32[(($outputBuffer)>>2)]; //@line 747 "sonic.cpp"
          var $25=$stream_addr; //@line 747 "sonic.cpp"
          var $numOutputSamples12=(($25+48)&4294967295); //@line 747 "sonic.cpp"
          var $26=HEAP32[(($numOutputSamples12)>>2)]; //@line 747 "sonic.cpp"
          var $27=$numChannels; //@line 747 "sonic.cpp"
          var $mul13=((($27)*($26))&4294967295); //@line 747 "sonic.cpp"
          var $add_ptr14=(($24+2*$mul13)&4294967295); //@line 747 "sonic.cpp"
          $out=$add_ptr14; //@line 747 "sonic.cpp"
          var $28=$pitch; //@line 748 "sonic.cpp"
          var $cmp15=($28) >= 1; //@line 748 "sonic.cpp"
          var $29=$stream_addr; //@line 749 "sonic.cpp"
          var $pitchBuffer17=(($29+8)&4294967295); //@line 749 "sonic.cpp"
          var $30=HEAP32[(($pitchBuffer17)>>2)]; //@line 749 "sonic.cpp"
          var $31=$position; //@line 749 "sonic.cpp"
          var $32=$numChannels; //@line 749 "sonic.cpp"
          var $mul18=((($32)*($31))&4294967295); //@line 749 "sonic.cpp"
          var $add_ptr19=(($30+2*$mul18)&4294967295); //@line 749 "sonic.cpp"
          $rampDown=$add_ptr19; //@line 749 "sonic.cpp"
          var $33=$stream_addr; //@line 750 "sonic.cpp"
          var $pitchBuffer20=(($33+8)&4294967295); //@line 750 "sonic.cpp"
          var $34=HEAP32[(($pitchBuffer20)>>2)]; //@line 750 "sonic.cpp"
          var $35=$position; //@line 750 "sonic.cpp"
          if ($cmp15) { __label__ = 8;; } else { __label__ = 9;; } //@line 748 "sonic.cpp"
          if (__label__ == 8) {
  
            var $36=$period; //@line 750 "sonic.cpp"
            var $37=$newPeriod; //@line 750 "sonic.cpp"
            var $_neg=(((-($37)))&4294967295);
            var $add=((($36)+($35))&4294967295); //@line 750 "sonic.cpp"
            var $sub21=((($add)+($_neg))&4294967295); //@line 750 "sonic.cpp"
            var $38=$numChannels; //@line 750 "sonic.cpp"
            var $mul22=((($sub21)*($38))&4294967295); //@line 750 "sonic.cpp"
            var $add_ptr23=(($34+2*$mul22)&4294967295); //@line 750 "sonic.cpp"
            $rampUp=$add_ptr23; //@line 750 "sonic.cpp"
            var $39=$newPeriod; //@line 751 "sonic.cpp"
            var $40=$numChannels; //@line 751 "sonic.cpp"
            var $41=$out; //@line 751 "sonic.cpp"
            var $42=$rampDown; //@line 751 "sonic.cpp"
            var $43=$rampUp; //@line 751 "sonic.cpp"
            __ZL10overlapAddiiPsS_S_($39, $40, $41, $42, $43); //@line 751 "sonic.cpp"
            ; //@line 752 "sonic.cpp"
          }
          else if (__label__ == 9) {
  
            var $44=$numChannels; //@line 754 "sonic.cpp"
            var $mul28=((($44)*($35))&4294967295); //@line 754 "sonic.cpp"
            var $add_ptr29=(($34+2*$mul28)&4294967295); //@line 754 "sonic.cpp"
            $rampUp=$add_ptr29; //@line 754 "sonic.cpp"
            var $45=$newPeriod; //@line 755 "sonic.cpp"
            var $46=$period; //@line 755 "sonic.cpp"
            var $sub30=((($45)-($46))&4294967295); //@line 755 "sonic.cpp"
            $separation=$sub30; //@line 755 "sonic.cpp"
            var $47=$period; //@line 756 "sonic.cpp"
            var $48=$numChannels; //@line 756 "sonic.cpp"
            var $49=$separation; //@line 756 "sonic.cpp"
            var $50=$out; //@line 756 "sonic.cpp"
            var $51=$rampDown; //@line 756 "sonic.cpp"
            var $52=$rampUp; //@line 756 "sonic.cpp"
            __ZL24overlapAddWithSeparationiiiPsS_S_($47, $48, $49, $50, $51, $52); //@line 756 "sonic.cpp"
            ;
          }
  
          var $53=$newPeriod; //@line 758 "sonic.cpp"
          var $54=$stream_addr; //@line 758 "sonic.cpp"
          var $numOutputSamples32=(($54+48)&4294967295); //@line 758 "sonic.cpp"
          var $55=HEAP32[(($numOutputSamples32)>>2)]; //@line 758 "sonic.cpp"
          var $add33=((($55)+($53))&4294967295); //@line 758 "sonic.cpp"
          HEAP32[(($numOutputSamples32)>>2)]=$add33; //@line 758 "sonic.cpp"
          var $56=$period; //@line 759 "sonic.cpp"
          var $57=$position; //@line 759 "sonic.cpp"
          var $add34=((($57)+($56))&4294967295); //@line 759 "sonic.cpp"
          $position=$add34; //@line 759 "sonic.cpp"
          __label__ = 4;continue ; //@line 760 "sonic.cpp"
        }
        if (__label__ == 11) {
  
          var $58=$position; //@line 761 "sonic.cpp"
          __ZL18removePitchSamplesP17sonicStreamStructi($14, $58); //@line 761 "sonic.cpp"
          $retval=1; //@line 762 "sonic.cpp"
          ; //@line 762 "sonic.cpp"
        }
        else if (__label__ == 6) {
  
          $retval=0; //@line 745 "sonic.cpp"
          ; //@line 745 "sonic.cpp"
        }
      }
      else if (__label__ == 3) {
  
        $retval=0; //@line 739 "sonic.cpp"
        ; //@line 739 "sonic.cpp"
      }
    }
  
    var $59=$retval; //@line 763 "sonic.cpp"
    ;
    return $59; //@line 763 "sonic.cpp"
    return null;
  }
  

  function __ZL12scaleSamplesPsif($samples, $numSamples, $volume) {
    ;
    var __label__;
  
    var $samples_addr;
    var $numSamples_addr;
    var $volume_addr;
    var $fixedPointVolume;
    var $value;
    $samples_addr=$samples;
    $numSamples_addr=$numSamples;
    $volume_addr=$volume;
    var $0=$volume_addr; //@line 75 "sonic.cpp"
    var $mul=($0)*4096; //@line 75 "sonic.cpp"
    var $conv=((($mul))|0); //@line 75 "sonic.cpp"
    $fixedPointVolume=$conv; //@line 75 "sonic.cpp"
    var $1=$numSamples_addr; //@line 78 "sonic.cpp"
    var $dec1=((($1)-1)&4294967295); //@line 78 "sonic.cpp"
    $numSamples_addr=$dec1; //@line 78 "sonic.cpp"
    var $tobool2=((($1))|0)!=0; //@line 78 "sonic.cpp"
    if ($tobool2) { __label__ = 1;; } else { __label__ = 6;; } //@line 78 "sonic.cpp"
    $while_body$$while_end$2: do { 
      if (__label__ == 1) {
        $while_body$3: while(1) { 
  
          var $2=$samples_addr; //@line 79 "sonic.cpp"
          var $3=HEAP16[(($2)>>1)]; //@line 79 "sonic.cpp"
          var $conv1=(tempInt=(($3)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 79 "sonic.cpp"
          var $4=$fixedPointVolume; //@line 79 "sonic.cpp"
          var $mul2=((($conv1)*($4))&4294967295); //@line 79 "sonic.cpp"
          var $shr=($mul2) >> 12; //@line 79 "sonic.cpp"
          $value=$shr; //@line 79 "sonic.cpp"
          var $cmp=((($shr))|0) > 32767; //@line 80 "sonic.cpp"
          if ($cmp) { __label__ = 2;; } else { __label__ = 3;; } //@line 80 "sonic.cpp"
          $if_then$$if_else$5: do { 
            if (__label__ == 2) {
  
              $value=32767; //@line 81 "sonic.cpp"
              ; //@line 82 "sonic.cpp"
            }
            else if (__label__ == 3) {
  
              var $5=$value; //@line 82 "sonic.cpp"
              var $cmp3=((($5))|0) < -32767; //@line 82 "sonic.cpp"
              if (!($cmp3)) { __label__ = 5;break $if_then$$if_else$5; } //@line 82 "sonic.cpp"
  
              $value=-32767; //@line 83 "sonic.cpp"
              ; //@line 84 "sonic.cpp"
            }
          } while(0);
  
          var $6=$value; //@line 85 "sonic.cpp"
          var $conv6=((($6)) & 65535); //@line 85 "sonic.cpp"
          var $7=$samples_addr; //@line 85 "sonic.cpp"
          var $incdec_ptr=(($7+2)&4294967295); //@line 85 "sonic.cpp"
          $samples_addr=$incdec_ptr; //@line 85 "sonic.cpp"
          HEAP16[(($7)>>1)]=$conv6; //@line 85 "sonic.cpp"
          var $8=$numSamples_addr; //@line 78 "sonic.cpp"
          var $dec=((($8)-1)&4294967295); //@line 78 "sonic.cpp"
          $numSamples_addr=$dec; //@line 78 "sonic.cpp"
          var $tobool=((($8))|0)!=0; //@line 78 "sonic.cpp"
          if ($tobool) { __label__ = 1;continue $while_body$3; } else { __label__ = 6;break $while_body$$while_end$2; } //@line 78 "sonic.cpp"
        }
      }
    } while(0);
  
    ;
    return; //@line 87 "sonic.cpp"
    return;
  }
  

  function __ZL27moveNewSamplesToPitchBufferP17sonicStreamStructi($stream, $originalNumOutputSamples) {
    ;
    var __label__;
  
    var $retval;
    var $stream_addr;
    var $originalNumOutputSamples_addr;
    var $numSamples;
    var $numChannels;
    $stream_addr=$stream;
    $originalNumOutputSamples_addr=$originalNumOutputSamples;
    var $0=$stream_addr; //@line 686 "sonic.cpp"
    var $numOutputSamples=(($0+48)&4294967295); //@line 686 "sonic.cpp"
    var $1=HEAP32[(($numOutputSamples)>>2)]; //@line 686 "sonic.cpp"
    var $2=$originalNumOutputSamples_addr; //@line 686 "sonic.cpp"
    var $sub=((($1)-($2))&4294967295); //@line 686 "sonic.cpp"
    $numSamples=$sub; //@line 686 "sonic.cpp"
    var $3=$stream_addr; //@line 687 "sonic.cpp"
    var $numChannels1=(($3+28)&4294967295); //@line 687 "sonic.cpp"
    var $4=HEAP32[(($numChannels1)>>2)]; //@line 687 "sonic.cpp"
    $numChannels=$4; //@line 687 "sonic.cpp"
    var $5=$stream_addr; //@line 689 "sonic.cpp"
    var $numPitchSamples=(($5+52)&4294967295); //@line 689 "sonic.cpp"
    var $6=HEAP32[(($numPitchSamples)>>2)]; //@line 689 "sonic.cpp"
    var $7=$numSamples; //@line 689 "sonic.cpp"
    var $add=((($7)+($6))&4294967295); //@line 689 "sonic.cpp"
    var $8=$stream_addr; //@line 689 "sonic.cpp"
    var $pitchBufferSize=(($8+36)&4294967295); //@line 689 "sonic.cpp"
    var $9=HEAP32[(($pitchBufferSize)>>2)]; //@line 689 "sonic.cpp"
    var $cmp=((($add))|0) > ((($9))|0); //@line 689 "sonic.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 3;; } //@line 689 "sonic.cpp"
    $if_then$$if_end12$2: do { 
      if (__label__ == 1) {
  
        var $10=$stream_addr; //@line 690 "sonic.cpp"
        var $pitchBufferSize2=(($10+36)&4294967295); //@line 690 "sonic.cpp"
        var $11=HEAP32[(($pitchBufferSize2)>>2)]; //@line 690 "sonic.cpp"
        var $shr=($11) >> 1; //@line 690 "sonic.cpp"
        var $12=$numSamples; //@line 690 "sonic.cpp"
        var $13=$stream_addr; //@line 690 "sonic.cpp"
        var $pitchBufferSize4=(($13+36)&4294967295); //@line 690 "sonic.cpp"
        var $14=HEAP32[(($pitchBufferSize4)>>2)]; //@line 690 "sonic.cpp"
        var $add3=((($shr)+($12))&4294967295); //@line 690 "sonic.cpp"
        var $add5=((($add3)+($14))&4294967295); //@line 690 "sonic.cpp"
        HEAP32[(($pitchBufferSize4)>>2)]=$add5; //@line 690 "sonic.cpp"
        var $15=$stream_addr; //@line 691 "sonic.cpp"
        var $pitchBuffer=(($15+8)&4294967295); //@line 691 "sonic.cpp"
        var $16=HEAP32[(($pitchBuffer)>>2)]; //@line 691 "sonic.cpp"
        var $17=$16; //@line 691 "sonic.cpp"
        var $18=$stream_addr; //@line 691 "sonic.cpp"
        var $pitchBufferSize6=(($18+36)&4294967295); //@line 691 "sonic.cpp"
        var $19=HEAP32[(($pitchBufferSize6)>>2)]; //@line 691 "sonic.cpp"
        var $20=$numChannels; //@line 691 "sonic.cpp"
        var $mul=((($19)*2)&4294967295); //@line 691 "sonic.cpp"
        var $mul7=((($mul)*($20))&4294967295); //@line 691 "sonic.cpp"
        var $call=_realloc($17, $mul7); //@line 691 "sonic.cpp"
        var $21=$call; //@line 691 "sonic.cpp"
        var $22=$stream_addr; //@line 691 "sonic.cpp"
        var $pitchBuffer8=(($22+8)&4294967295); //@line 691 "sonic.cpp"
        HEAP32[(($pitchBuffer8)>>2)]=$21; //@line 691 "sonic.cpp"
        var $23=$stream_addr; //@line 693 "sonic.cpp"
        var $pitchBuffer9=(($23+8)&4294967295); //@line 693 "sonic.cpp"
        var $24=HEAP32[(($pitchBuffer9)>>2)]; //@line 693 "sonic.cpp"
        var $cmp10=((($24))|0)==0; //@line 693 "sonic.cpp"
        if (!($cmp10)) { __label__ = 3;break $if_then$$if_end12$2; } //@line 693 "sonic.cpp"
  
        $retval=0; //@line 694 "sonic.cpp"
        __label__ = 4;break $if_then$$if_end12$2; //@line 694 "sonic.cpp"
      }
    } while(0);
    if (__label__ == 3) {
  
      var $25=$stream_addr; //@line 697 "sonic.cpp"
      var $pitchBuffer13=(($25+8)&4294967295); //@line 697 "sonic.cpp"
      var $26=HEAP32[(($pitchBuffer13)>>2)]; //@line 697 "sonic.cpp"
      var $27=$stream_addr; //@line 697 "sonic.cpp"
      var $numPitchSamples14=(($27+52)&4294967295); //@line 697 "sonic.cpp"
      var $28=HEAP32[(($numPitchSamples14)>>2)]; //@line 697 "sonic.cpp"
      var $29=$numChannels; //@line 697 "sonic.cpp"
      var $mul15=((($29)*($28))&4294967295); //@line 697 "sonic.cpp"
      var $add_ptr=(($26+2*$mul15)&4294967295); //@line 697 "sonic.cpp"
      var $30=$add_ptr; //@line 697 "sonic.cpp"
      var $31=$stream_addr; //@line 697 "sonic.cpp"
      var $outputBuffer=(($31+4)&4294967295); //@line 697 "sonic.cpp"
      var $32=HEAP32[(($outputBuffer)>>2)]; //@line 697 "sonic.cpp"
      var $33=$originalNumOutputSamples_addr; //@line 697 "sonic.cpp"
      var $34=$numChannels; //@line 697 "sonic.cpp"
      var $mul16=((($34)*($33))&4294967295); //@line 697 "sonic.cpp"
      var $add_ptr17=(($32+2*$mul16)&4294967295); //@line 697 "sonic.cpp"
      var $35=$add_ptr17; //@line 697 "sonic.cpp"
      var $36=$numSamples; //@line 697 "sonic.cpp"
      var $37=$numChannels; //@line 697 "sonic.cpp"
      var $mul18=((($36)*2)&4294967295); //@line 697 "sonic.cpp"
      var $mul19=((($mul18)*($37))&4294967295); //@line 697 "sonic.cpp"
      var $src$, $dest$, $stop$, $stop4$, $fast$;
      $src$ = $35;
      $dest$ = $30;
      $stop$ = $src$ + $mul19;
      if (($dest$%4) == ($src$%4) && $mul19 > 8) {
        while ($src$%4 !== 0 && $src$ < $stop$) {
          ; HEAP8[$dest$++] = HEAP8[$src$++];
        }
        $src$ >>= 2;
        $dest$ >>= 2;
        $stop4$ = $stop$ >> 2;
        while ($src$ < $stop4$) {
      ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
        }
        $src$ <<= 2;
        $dest$ <<= 2;
      }while ($src$ < $stop$) {
        ; HEAP8[$dest$++] = HEAP8[$src$++];
      }; //@line 697 "sonic.cpp"
      var $38=$originalNumOutputSamples_addr; //@line 700 "sonic.cpp"
      var $39=$stream_addr; //@line 700 "sonic.cpp"
      var $numOutputSamples20=(($39+48)&4294967295); //@line 700 "sonic.cpp"
      HEAP32[(($numOutputSamples20)>>2)]=$38; //@line 700 "sonic.cpp"
      var $40=$numSamples; //@line 701 "sonic.cpp"
      var $41=$stream_addr; //@line 701 "sonic.cpp"
      var $numPitchSamples21=(($41+52)&4294967295); //@line 701 "sonic.cpp"
      var $42=HEAP32[(($numPitchSamples21)>>2)]; //@line 701 "sonic.cpp"
      var $add22=((($42)+($40))&4294967295); //@line 701 "sonic.cpp"
      HEAP32[(($numPitchSamples21)>>2)]=$add22; //@line 701 "sonic.cpp"
      $retval=1; //@line 702 "sonic.cpp"
      ; //@line 702 "sonic.cpp"
    }
  
    var $43=$retval; //@line 703 "sonic.cpp"
    ;
    return $43; //@line 703 "sonic.cpp"
    return null;
  }
  

  function __ZL15findPitchPeriodP17sonicStreamStructPs($stream, $samples) {
    var __stackBase__  = STACKTOP; STACKTOP += 8; _memset(__stackBase__, 0, 8);
    var __label__;
  
    var $stream_addr;
    var $samples_addr;
    var $minPeriod;
    var $maxPeriod;
    var $sampleRate;
    var $minDiff=__stackBase__;
    var $maxDiff=__stackBase__+4;
    var $retPeriod;
    var $skip;
    var $period;
    $stream_addr=$stream;
    $samples_addr=$samples;
    var $0=$stream_addr; //@line 575 "sonic.cpp"
    var $minPeriod1=(($0+56)&4294967295); //@line 575 "sonic.cpp"
    var $1=HEAP32[(($minPeriod1)>>2)]; //@line 575 "sonic.cpp"
    $minPeriod=$1; //@line 575 "sonic.cpp"
    var $2=$stream_addr; //@line 576 "sonic.cpp"
    var $maxPeriod2=(($2+60)&4294967295); //@line 576 "sonic.cpp"
    var $3=HEAP32[(($maxPeriod2)>>2)]; //@line 576 "sonic.cpp"
    $maxPeriod=$3; //@line 576 "sonic.cpp"
    var $4=$stream_addr; //@line 577 "sonic.cpp"
    var $sampleRate3=(($4+72)&4294967295); //@line 577 "sonic.cpp"
    var $5=HEAP32[(($sampleRate3)>>2)]; //@line 577 "sonic.cpp"
    $sampleRate=$5; //@line 577 "sonic.cpp"
    $skip=1; //@line 579 "sonic.cpp"
    var $6=$sampleRate; //@line 582 "sonic.cpp"
    var $cmp=((($6))|0) > 4000; //@line 582 "sonic.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 582 "sonic.cpp"
    if (__label__ == 1) {
  
      var $7=$sampleRate; //@line 583 "sonic.cpp"
      var $div=((((($7))|0)/4000)|0); //@line 583 "sonic.cpp"
      $skip=$div; //@line 583 "sonic.cpp"
      ; //@line 584 "sonic.cpp"
    }
  
    var $8=$stream_addr; //@line 585 "sonic.cpp"
    var $numChannels=(($8+28)&4294967295); //@line 585 "sonic.cpp"
    var $9=HEAP32[(($numChannels)>>2)]; //@line 585 "sonic.cpp"
    var $cmp4=((($9))|0)==1; //@line 585 "sonic.cpp"
    if ($cmp4) { __label__ = 3;; } else { __label__ = 5;; } //@line 585 "sonic.cpp"
    $land_lhs_true$$if_else$5: do { 
      if (__label__ == 3) {
  
        var $10=$skip; //@line 585 "sonic.cpp"
        var $cmp5=((($10))|0)==1; //@line 585 "sonic.cpp"
        if (!($cmp5)) { __label__ = 5;break $land_lhs_true$$if_else$5; } //@line 585 "sonic.cpp"
  
        var $11=$samples_addr; //@line 586 "sonic.cpp"
        var $12=$minPeriod; //@line 586 "sonic.cpp"
        var $13=$maxPeriod; //@line 586 "sonic.cpp"
        var $call=__ZL22findPitchPeriodInRangePsiiPiS0_($11, $12, $13, $minDiff, $maxDiff); //@line 586 "sonic.cpp"
        $period=$call; //@line 586 "sonic.cpp"
        __label__ = 13;break $land_lhs_true$$if_else$5; //@line 587 "sonic.cpp"
      }
    } while(0);
    $if_end32$$if_else$8: do { 
      if (__label__ == 5) {
  
        var $14=$stream_addr; //@line 588 "sonic.cpp"
        var $15=$samples_addr; //@line 588 "sonic.cpp"
        var $16=$skip; //@line 588 "sonic.cpp"
        __ZL15downSampleInputP17sonicStreamStructPsi($14, $15, $16); //@line 588 "sonic.cpp"
        var $17=$stream_addr; //@line 589 "sonic.cpp"
        var $downSampleBuffer=(($17+12)&4294967295); //@line 589 "sonic.cpp"
        var $18=HEAP32[(($downSampleBuffer)>>2)]; //@line 589 "sonic.cpp"
        var $19=$minPeriod; //@line 589 "sonic.cpp"
        var $20=$skip; //@line 589 "sonic.cpp"
        var $div7=((((($19))|0)/((($20))|0))|0); //@line 589 "sonic.cpp"
        var $21=$maxPeriod; //@line 589 "sonic.cpp"
        var $22=$skip; //@line 589 "sonic.cpp"
        var $div8=((((($21))|0)/((($22))|0))|0); //@line 589 "sonic.cpp"
        var $call9=__ZL22findPitchPeriodInRangePsiiPiS0_($18, $div7, $div8, $minDiff, $maxDiff); //@line 589 "sonic.cpp"
        $period=$call9; //@line 589 "sonic.cpp"
        var $23=$skip; //@line 591 "sonic.cpp"
        var $cmp10=((($23))|0)!=1; //@line 591 "sonic.cpp"
        if (!($cmp10)) { __label__ = 13;break $if_end32$$if_else$8; } //@line 591 "sonic.cpp"
  
        var $24=$skip; //@line 592 "sonic.cpp"
        var $25=$period; //@line 592 "sonic.cpp"
        var $mul=((($25)*($24))&4294967295); //@line 592 "sonic.cpp"
        $period=$mul; //@line 592 "sonic.cpp"
        var $26=$period; //@line 593 "sonic.cpp"
        var $27=$skip; //@line 593 "sonic.cpp"
        var $shl=($27) << 2; //@line 593 "sonic.cpp"
        var $sub=((($26)-($shl))&4294967295); //@line 593 "sonic.cpp"
        $minPeriod=$sub; //@line 593 "sonic.cpp"
        var $28=$period; //@line 594 "sonic.cpp"
        var $29=$skip; //@line 594 "sonic.cpp"
        var $shl12=((($29)*4)&4294967295); //@line 594 "sonic.cpp"
        var $add=((($shl12)+($28))&4294967295); //@line 594 "sonic.cpp"
        $maxPeriod=$add; //@line 594 "sonic.cpp"
        var $30=$minPeriod; //@line 595 "sonic.cpp"
        var $31=$stream_addr; //@line 595 "sonic.cpp"
        var $minPeriod13=(($31+56)&4294967295); //@line 595 "sonic.cpp"
        var $32=HEAP32[(($minPeriod13)>>2)]; //@line 595 "sonic.cpp"
        var $cmp14=((($30))|0) < ((($32))|0); //@line 595 "sonic.cpp"
        if ($cmp14) { __label__ = 7;; } else { __label__ = 8;; } //@line 595 "sonic.cpp"
        if (__label__ == 7) {
  
          var $33=$stream_addr; //@line 596 "sonic.cpp"
          var $minPeriod16=(($33+56)&4294967295); //@line 596 "sonic.cpp"
          var $34=HEAP32[(($minPeriod16)>>2)]; //@line 596 "sonic.cpp"
          $minPeriod=$34; //@line 596 "sonic.cpp"
          ; //@line 597 "sonic.cpp"
        }
  
        var $35=$maxPeriod; //@line 598 "sonic.cpp"
        var $36=$stream_addr; //@line 598 "sonic.cpp"
        var $maxPeriod18=(($36+60)&4294967295); //@line 598 "sonic.cpp"
        var $37=HEAP32[(($maxPeriod18)>>2)]; //@line 598 "sonic.cpp"
        var $cmp19=((($35))|0) > ((($37))|0); //@line 598 "sonic.cpp"
        if ($cmp19) { __label__ = 9;; } else { __label__ = 10;; } //@line 598 "sonic.cpp"
        if (__label__ == 9) {
  
          var $38=$stream_addr; //@line 599 "sonic.cpp"
          var $maxPeriod21=(($38+60)&4294967295); //@line 599 "sonic.cpp"
          var $39=HEAP32[(($maxPeriod21)>>2)]; //@line 599 "sonic.cpp"
          $maxPeriod=$39; //@line 599 "sonic.cpp"
          ; //@line 600 "sonic.cpp"
        }
  
        var $40=$stream_addr; //@line 601 "sonic.cpp"
        var $numChannels23=(($40+28)&4294967295); //@line 601 "sonic.cpp"
        var $41=HEAP32[(($numChannels23)>>2)]; //@line 601 "sonic.cpp"
        var $cmp24=((($41))|0)==1; //@line 601 "sonic.cpp"
        if ($cmp24) { __label__ = 11;; } else { __label__ = 12;; } //@line 601 "sonic.cpp"
        if (__label__ == 11) {
  
          var $42=$samples_addr; //@line 602 "sonic.cpp"
          var $43=$minPeriod; //@line 602 "sonic.cpp"
          var $44=$maxPeriod; //@line 602 "sonic.cpp"
          var $call26=__ZL22findPitchPeriodInRangePsiiPiS0_($42, $43, $44, $minDiff, $maxDiff); //@line 602 "sonic.cpp"
          $period=$call26; //@line 602 "sonic.cpp"
          ; //@line 604 "sonic.cpp"
        }
        else if (__label__ == 12) {
  
          var $45=$stream_addr; //@line 605 "sonic.cpp"
          var $46=$samples_addr; //@line 605 "sonic.cpp"
          __ZL15downSampleInputP17sonicStreamStructPsi($45, $46, 1); //@line 605 "sonic.cpp"
          var $47=$stream_addr; //@line 606 "sonic.cpp"
          var $downSampleBuffer28=(($47+12)&4294967295); //@line 606 "sonic.cpp"
          var $48=HEAP32[(($downSampleBuffer28)>>2)]; //@line 606 "sonic.cpp"
          var $49=$minPeriod; //@line 606 "sonic.cpp"
          var $50=$maxPeriod; //@line 606 "sonic.cpp"
          var $call29=__ZL22findPitchPeriodInRangePsiiPiS0_($48, $49, $50, $minDiff, $maxDiff); //@line 606 "sonic.cpp"
          $period=$call29; //@line 606 "sonic.cpp"
          ;
        }
      }
    } while(0);
  
    var $51=$stream_addr; //@line 611 "sonic.cpp"
    var $52=$period; //@line 611 "sonic.cpp"
    var $53=HEAP32[(($minDiff)>>2)]; //@line 611 "sonic.cpp"
    var $54=HEAP32[(($maxDiff)>>2)]; //@line 611 "sonic.cpp"
    var $call33=__ZL16prevPeriodBetterP17sonicStreamStructiii($51, $52, $53, $54); //@line 611 "sonic.cpp"
    var $tobool=((($call33))|0)!=0; //@line 611 "sonic.cpp"
    if ($tobool) { __label__ = 14;; } else { __label__ = 15;; } //@line 611 "sonic.cpp"
    if (__label__ == 14) {
  
      var $55=$stream_addr; //@line 612 "sonic.cpp"
      var $prevPeriod=(($55+76)&4294967295); //@line 612 "sonic.cpp"
      var $56=HEAP32[(($prevPeriod)>>2)]; //@line 612 "sonic.cpp"
      $retPeriod=$56; //@line 612 "sonic.cpp"
      ; //@line 613 "sonic.cpp"
    }
    else if (__label__ == 15) {
  
      var $57=$period; //@line 614 "sonic.cpp"
      $retPeriod=$57; //@line 614 "sonic.cpp"
      ;
    }
  
    var $58=HEAP32[(($minDiff)>>2)]; //@line 616 "sonic.cpp"
    var $59=$stream_addr; //@line 616 "sonic.cpp"
    var $prevMinDiff=(($59+84)&4294967295); //@line 616 "sonic.cpp"
    HEAP32[(($prevMinDiff)>>2)]=$58; //@line 616 "sonic.cpp"
    var $60=HEAP32[(($maxDiff)>>2)]; //@line 617 "sonic.cpp"
    var $61=$stream_addr; //@line 617 "sonic.cpp"
    var $prevMaxDiff=(($61+80)&4294967295); //@line 617 "sonic.cpp"
    HEAP32[(($prevMaxDiff)>>2)]=$60; //@line 617 "sonic.cpp"
    var $62=$period; //@line 618 "sonic.cpp"
    var $63=$stream_addr; //@line 618 "sonic.cpp"
    var $prevPeriod37=(($63+76)&4294967295); //@line 618 "sonic.cpp"
    HEAP32[(($prevPeriod37)>>2)]=$62; //@line 618 "sonic.cpp"
    var $64=$retPeriod; //@line 619 "sonic.cpp"
    STACKTOP = __stackBase__;
    return $64; //@line 619 "sonic.cpp"
    return null;
  }
  

  function __ZL27enlargeOutputBufferIfNeededP17sonicStreamStructi($stream, $numSamples) {
    ;
    var __label__;
  
    var $retval;
    var $stream_addr;
    var $numSamples_addr;
    $stream_addr=$stream;
    $numSamples_addr=$numSamples;
    var $0=$stream_addr; //@line 216 "sonic.cpp"
    var $numOutputSamples=(($0+48)&4294967295); //@line 216 "sonic.cpp"
    var $1=HEAP32[(($numOutputSamples)>>2)]; //@line 216 "sonic.cpp"
    var $2=$numSamples_addr; //@line 216 "sonic.cpp"
    var $add=((($2)+($1))&4294967295); //@line 216 "sonic.cpp"
    var $3=$stream_addr; //@line 216 "sonic.cpp"
    var $outputBufferSize=(($3+40)&4294967295); //@line 216 "sonic.cpp"
    var $4=HEAP32[(($outputBufferSize)>>2)]; //@line 216 "sonic.cpp"
    var $cmp=((($add))|0) > ((($4))|0); //@line 216 "sonic.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 3;; } //@line 216 "sonic.cpp"
    $if_then$$if_end11$2: do { 
      if (__label__ == 1) {
  
        var $5=$stream_addr; //@line 217 "sonic.cpp"
        var $outputBufferSize1=(($5+40)&4294967295); //@line 217 "sonic.cpp"
        var $6=HEAP32[(($outputBufferSize1)>>2)]; //@line 217 "sonic.cpp"
        var $shr=($6) >> 1; //@line 217 "sonic.cpp"
        var $7=$numSamples_addr; //@line 217 "sonic.cpp"
        var $8=$stream_addr; //@line 217 "sonic.cpp"
        var $outputBufferSize3=(($8+40)&4294967295); //@line 217 "sonic.cpp"
        var $9=HEAP32[(($outputBufferSize3)>>2)]; //@line 217 "sonic.cpp"
        var $add2=((($shr)+($7))&4294967295); //@line 217 "sonic.cpp"
        var $add4=((($add2)+($9))&4294967295); //@line 217 "sonic.cpp"
        HEAP32[(($outputBufferSize3)>>2)]=$add4; //@line 217 "sonic.cpp"
        var $10=$stream_addr; //@line 218 "sonic.cpp"
        var $outputBuffer=(($10+4)&4294967295); //@line 218 "sonic.cpp"
        var $11=HEAP32[(($outputBuffer)>>2)]; //@line 218 "sonic.cpp"
        var $12=$11; //@line 218 "sonic.cpp"
        var $13=$stream_addr; //@line 218 "sonic.cpp"
        var $outputBufferSize5=(($13+40)&4294967295); //@line 218 "sonic.cpp"
        var $14=HEAP32[(($outputBufferSize5)>>2)]; //@line 218 "sonic.cpp"
        var $15=$stream_addr; //@line 218 "sonic.cpp"
        var $numChannels=(($15+28)&4294967295); //@line 218 "sonic.cpp"
        var $16=HEAP32[(($numChannels)>>2)]; //@line 218 "sonic.cpp"
        var $mul=((($14)*2)&4294967295); //@line 218 "sonic.cpp"
        var $mul6=((($mul)*($16))&4294967295); //@line 218 "sonic.cpp"
        var $call=_realloc($12, $mul6); //@line 218 "sonic.cpp"
        var $17=$call; //@line 218 "sonic.cpp"
        var $18=$stream_addr; //@line 218 "sonic.cpp"
        var $outputBuffer7=(($18+4)&4294967295); //@line 218 "sonic.cpp"
        HEAP32[(($outputBuffer7)>>2)]=$17; //@line 218 "sonic.cpp"
        var $19=$stream_addr; //@line 220 "sonic.cpp"
        var $outputBuffer8=(($19+4)&4294967295); //@line 220 "sonic.cpp"
        var $20=HEAP32[(($outputBuffer8)>>2)]; //@line 220 "sonic.cpp"
        var $cmp9=((($20))|0)==0; //@line 220 "sonic.cpp"
        if (!($cmp9)) { __label__ = 3;break $if_then$$if_end11$2; } //@line 220 "sonic.cpp"
  
        $retval=0; //@line 221 "sonic.cpp"
        __label__ = 4;break $if_then$$if_end11$2; //@line 221 "sonic.cpp"
      }
    } while(0);
    if (__label__ == 3) {
  
      $retval=1; //@line 224 "sonic.cpp"
      ; //@line 224 "sonic.cpp"
    }
  
    var $21=$retval; //@line 225 "sonic.cpp"
    ;
    return $21; //@line 225 "sonic.cpp"
    return null;
  }
  

  function __ZL10overlapAddiiPsS_S_($numSamples, $numChannels, $out, $rampDown, $rampUp) {
    ;
    var __label__;
  
    var $numSamples_addr;
    var $numChannels_addr;
    var $out_addr;
    var $rampDown_addr;
    var $rampUp_addr;
    var $o;
    var $u;
    var $d;
    var $i;
    var $t;
    $numSamples_addr=$numSamples;
    $numChannels_addr=$numChannels;
    $out_addr=$out;
    $rampDown_addr=$rampDown;
    $rampUp_addr=$rampUp;
    $i=0; //@line 634 "sonic.cpp"
    var $0=$i; //@line 634 "sonic.cpp"
    var $1=$numChannels_addr; //@line 634 "sonic.cpp"
    var $cmp2=((($0))|0) < ((($1))|0); //@line 634 "sonic.cpp"
    if ($cmp2) { __label__ = 1;; } else { __label__ = 4;; } //@line 634 "sonic.cpp"
    $for_body$$for_end14$2: do { 
      if (__label__ == 1) {
        $for_body$3: while(1) { 
  
          var $2=$out_addr; //@line 635 "sonic.cpp"
          var $3=$i; //@line 635 "sonic.cpp"
          var $add_ptr=(($2+2*$3)&4294967295); //@line 635 "sonic.cpp"
          $o=$add_ptr; //@line 635 "sonic.cpp"
          var $4=$rampUp_addr; //@line 636 "sonic.cpp"
          var $5=$i; //@line 636 "sonic.cpp"
          var $add_ptr1=(($4+2*$5)&4294967295); //@line 636 "sonic.cpp"
          $u=$add_ptr1; //@line 636 "sonic.cpp"
          var $6=$rampDown_addr; //@line 637 "sonic.cpp"
          var $7=$i; //@line 637 "sonic.cpp"
          var $add_ptr2=(($6+2*$7)&4294967295); //@line 637 "sonic.cpp"
          $d=$add_ptr2; //@line 637 "sonic.cpp"
          $t=0; //@line 638 "sonic.cpp"
          var $8=$t; //@line 638 "sonic.cpp"
          var $9=$numSamples_addr; //@line 638 "sonic.cpp"
          var $cmp41=((($8))|0) < ((($9))|0); //@line 638 "sonic.cpp"
          if ($cmp41) { __label__ = 2;; } else { __label__ = 3;; } //@line 638 "sonic.cpp"
          $for_body5$$for_inc12$5: do { 
            if (__label__ == 2) {
              while(1) { 
  
                var $10=$d; //@line 639 "sonic.cpp"
                var $11=HEAP16[(($10)>>1)]; //@line 639 "sonic.cpp"
                var $conv=(tempInt=(($11)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 639 "sonic.cpp"
                var $12=$numSamples_addr; //@line 639 "sonic.cpp"
                var $13=$t; //@line 639 "sonic.cpp"
                var $sub=((($12)-($13))&4294967295); //@line 639 "sonic.cpp"
                var $mul=((($sub)*($conv))&4294967295); //@line 639 "sonic.cpp"
                var $14=$u; //@line 639 "sonic.cpp"
                var $15=HEAP16[(($14)>>1)]; //@line 639 "sonic.cpp"
                var $conv6=(tempInt=(($15)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 639 "sonic.cpp"
                var $16=$t; //@line 639 "sonic.cpp"
                var $mul7=((($conv6)*($16))&4294967295); //@line 639 "sonic.cpp"
                var $add=((($mul7)+($mul))&4294967295); //@line 639 "sonic.cpp"
                var $17=$numSamples_addr; //@line 639 "sonic.cpp"
                var $div=((((($add))|0)/((($17))|0))|0); //@line 639 "sonic.cpp"
                var $conv8=((($div)) & 65535); //@line 639 "sonic.cpp"
                var $18=$o; //@line 639 "sonic.cpp"
                HEAP16[(($18)>>1)]=$conv8; //@line 639 "sonic.cpp"
                var $19=$numChannels_addr; //@line 640 "sonic.cpp"
                var $20=$o; //@line 640 "sonic.cpp"
                var $add_ptr9=(($20+2*$19)&4294967295); //@line 640 "sonic.cpp"
                $o=$add_ptr9; //@line 640 "sonic.cpp"
                var $21=$numChannels_addr; //@line 641 "sonic.cpp"
                var $22=$d; //@line 641 "sonic.cpp"
                var $add_ptr10=(($22+2*$21)&4294967295); //@line 641 "sonic.cpp"
                $d=$add_ptr10; //@line 641 "sonic.cpp"
                var $23=$numChannels_addr; //@line 642 "sonic.cpp"
                var $24=$u; //@line 642 "sonic.cpp"
                var $add_ptr11=(($24+2*$23)&4294967295); //@line 642 "sonic.cpp"
                $u=$add_ptr11; //@line 642 "sonic.cpp"
                var $25=$t; //@line 638 "sonic.cpp"
                var $inc=((($25)+1)&4294967295); //@line 638 "sonic.cpp"
                $t=$inc; //@line 638 "sonic.cpp"
                var $26=$t; //@line 638 "sonic.cpp"
                var $27=$numSamples_addr; //@line 638 "sonic.cpp"
                var $cmp4=((($26))|0) < ((($27))|0); //@line 638 "sonic.cpp"
                if ($cmp4) { __label__ = 2;continue ; } else { __label__ = 3;break $for_body5$$for_inc12$5; } //@line 638 "sonic.cpp"
              }
            }
          } while(0);
  
          var $28=$i; //@line 634 "sonic.cpp"
          var $inc13=((($28)+1)&4294967295); //@line 634 "sonic.cpp"
          $i=$inc13; //@line 634 "sonic.cpp"
          var $29=$i; //@line 634 "sonic.cpp"
          var $30=$numChannels_addr; //@line 634 "sonic.cpp"
          var $cmp=((($29))|0) < ((($30))|0); //@line 634 "sonic.cpp"
          if ($cmp) { __label__ = 1;continue $for_body$3; } else { __label__ = 4;break $for_body$$for_end14$2; } //@line 634 "sonic.cpp"
        }
      }
    } while(0);
  
    ;
    return; //@line 645 "sonic.cpp"
    return;
  }
  

  function __ZL24overlapAddWithSeparationiiiPsS_S_($numSamples, $numChannels, $separation, $out, $rampDown, $rampUp) {
    ;
    var __label__;
  
    var $numSamples_addr;
    var $numChannels_addr;
    var $separation_addr;
    var $out_addr;
    var $rampDown_addr;
    var $rampUp_addr;
    var $o;
    var $u;
    var $d;
    var $i;
    var $t;
    $numSamples_addr=$numSamples;
    $numChannels_addr=$numChannels;
    $separation_addr=$separation;
    $out_addr=$out;
    $rampDown_addr=$rampDown;
    $rampUp_addr=$rampUp;
    $i=0; //@line 660 "sonic.cpp"
    var $0=$i; //@line 660 "sonic.cpp"
    var $1=$numChannels_addr; //@line 660 "sonic.cpp"
    var $cmp3=((($0))|0) < ((($1))|0); //@line 660 "sonic.cpp"
    if ($cmp3) { __label__ = 1;; } else { __label__ = 9;; } //@line 660 "sonic.cpp"
    $for_body$$for_end33$2: do { 
      if (__label__ == 1) {
        $for_body$3: while(1) { 
  
          var $2=$out_addr; //@line 661 "sonic.cpp"
          var $3=$i; //@line 661 "sonic.cpp"
          var $add_ptr=(($2+2*$3)&4294967295); //@line 661 "sonic.cpp"
          $o=$add_ptr; //@line 661 "sonic.cpp"
          var $4=$rampUp_addr; //@line 662 "sonic.cpp"
          var $5=$i; //@line 662 "sonic.cpp"
          var $add_ptr1=(($4+2*$5)&4294967295); //@line 662 "sonic.cpp"
          $u=$add_ptr1; //@line 662 "sonic.cpp"
          var $6=$rampDown_addr; //@line 663 "sonic.cpp"
          var $7=$i; //@line 663 "sonic.cpp"
          var $add_ptr2=(($6+2*$7)&4294967295); //@line 663 "sonic.cpp"
          $d=$add_ptr2; //@line 663 "sonic.cpp"
          $t=0; //@line 664 "sonic.cpp"
          var $8=$t; //@line 664 "sonic.cpp"
          var $9=$numSamples_addr; //@line 664 "sonic.cpp"
          var $10=$separation_addr; //@line 664 "sonic.cpp"
          var $add1=((($10)+($9))&4294967295); //@line 664 "sonic.cpp"
          var $cmp42=((($8))|0) < ((($add1))|0); //@line 664 "sonic.cpp"
          if ($cmp42) { __label__ = 2;; } else { __label__ = 8;; } //@line 664 "sonic.cpp"
          $for_body5$$for_inc31$5: do { 
            if (__label__ == 2) {
              while(1) { 
  
                var $11=$t; //@line 665 "sonic.cpp"
                var $12=$separation_addr; //@line 665 "sonic.cpp"
                var $cmp6=((($11))|0) < ((($12))|0); //@line 665 "sonic.cpp"
                if ($cmp6) { __label__ = 3;; } else { __label__ = 4;; } //@line 665 "sonic.cpp"
                if (__label__ == 3) {
  
                  var $13=$d; //@line 666 "sonic.cpp"
                  var $14=HEAP16[(($13)>>1)]; //@line 666 "sonic.cpp"
                  var $conv=(tempInt=(($14)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 666 "sonic.cpp"
                  var $15=$numSamples_addr; //@line 666 "sonic.cpp"
                  var $16=$t; //@line 666 "sonic.cpp"
                  var $sub=((($15)-($16))&4294967295); //@line 666 "sonic.cpp"
                  var $mul=((($sub)*($conv))&4294967295); //@line 666 "sonic.cpp"
                  var $17=$numSamples_addr; //@line 666 "sonic.cpp"
                  var $div=((((($mul))|0)/((($17))|0))|0); //@line 666 "sonic.cpp"
                  var $conv7=((($div)) & 65535); //@line 666 "sonic.cpp"
                  var $18=$o; //@line 666 "sonic.cpp"
                  HEAP16[(($18)>>1)]=$conv7; //@line 666 "sonic.cpp"
                  var $19=$numChannels_addr; //@line 667 "sonic.cpp"
                  var $20=$d; //@line 667 "sonic.cpp"
                  var $add_ptr8=(($20+2*$19)&4294967295); //@line 667 "sonic.cpp"
                  $d=$add_ptr8; //@line 667 "sonic.cpp"
                  ; //@line 668 "sonic.cpp"
                }
                else if (__label__ == 4) {
  
                  var $21=$t; //@line 668 "sonic.cpp"
                  var $22=$numSamples_addr; //@line 668 "sonic.cpp"
                  var $cmp9=((($21))|0) < ((($22))|0); //@line 668 "sonic.cpp"
                  if ($cmp9) { __label__ = 5;; } else { __label__ = 6;; } //@line 668 "sonic.cpp"
                  if (__label__ == 5) {
  
                    var $23=$d; //@line 669 "sonic.cpp"
                    var $24=HEAP16[(($23)>>1)]; //@line 669 "sonic.cpp"
                    var $conv11=(tempInt=(($24)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 669 "sonic.cpp"
                    var $25=$numSamples_addr; //@line 669 "sonic.cpp"
                    var $26=$t; //@line 669 "sonic.cpp"
                    var $sub12=((($25)-($26))&4294967295); //@line 669 "sonic.cpp"
                    var $mul13=((($sub12)*($conv11))&4294967295); //@line 669 "sonic.cpp"
                    var $27=$u; //@line 669 "sonic.cpp"
                    var $28=HEAP16[(($27)>>1)]; //@line 669 "sonic.cpp"
                    var $conv14=(tempInt=(($28)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 669 "sonic.cpp"
                    var $29=$t; //@line 669 "sonic.cpp"
                    var $30=$separation_addr; //@line 669 "sonic.cpp"
                    var $sub15=((($29)-($30))&4294967295); //@line 669 "sonic.cpp"
                    var $mul16=((($sub15)*($conv14))&4294967295); //@line 669 "sonic.cpp"
                    var $add17=((($mul16)+($mul13))&4294967295); //@line 669 "sonic.cpp"
                    var $31=$numSamples_addr; //@line 669 "sonic.cpp"
                    var $div18=((((($add17))|0)/((($31))|0))|0); //@line 669 "sonic.cpp"
                    var $conv19=((($div18)) & 65535); //@line 669 "sonic.cpp"
                    var $32=$o; //@line 669 "sonic.cpp"
                    HEAP16[(($32)>>1)]=$conv19; //@line 669 "sonic.cpp"
                    var $33=$numChannels_addr; //@line 670 "sonic.cpp"
                    var $34=$d; //@line 670 "sonic.cpp"
                    var $add_ptr20=(($34+2*$33)&4294967295); //@line 670 "sonic.cpp"
                    $d=$add_ptr20; //@line 670 "sonic.cpp"
                    var $35=$numChannels_addr; //@line 671 "sonic.cpp"
                    var $36=$u; //@line 671 "sonic.cpp"
                    var $add_ptr21=(($36+2*$35)&4294967295); //@line 671 "sonic.cpp"
                    $u=$add_ptr21; //@line 671 "sonic.cpp"
                    ; //@line 672 "sonic.cpp"
                  }
                  else if (__label__ == 6) {
  
                    var $37=$u; //@line 673 "sonic.cpp"
                    var $38=HEAP16[(($37)>>1)]; //@line 673 "sonic.cpp"
                    var $conv23=(tempInt=(($38)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 673 "sonic.cpp"
                    var $39=$t; //@line 673 "sonic.cpp"
                    var $40=$separation_addr; //@line 673 "sonic.cpp"
                    var $sub24=((($39)-($40))&4294967295); //@line 673 "sonic.cpp"
                    var $mul25=((($sub24)*($conv23))&4294967295); //@line 673 "sonic.cpp"
                    var $41=$numSamples_addr; //@line 673 "sonic.cpp"
                    var $div26=((((($mul25))|0)/((($41))|0))|0); //@line 673 "sonic.cpp"
                    var $conv27=((($div26)) & 65535); //@line 673 "sonic.cpp"
                    var $42=$o; //@line 673 "sonic.cpp"
                    HEAP16[(($42)>>1)]=$conv27; //@line 673 "sonic.cpp"
                    var $43=$numChannels_addr; //@line 674 "sonic.cpp"
                    var $44=$u; //@line 674 "sonic.cpp"
                    var $add_ptr28=(($44+2*$43)&4294967295); //@line 674 "sonic.cpp"
                    $u=$add_ptr28; //@line 674 "sonic.cpp"
                    ;
                  }
                }
  
                var $45=$numChannels_addr; //@line 676 "sonic.cpp"
                var $46=$o; //@line 676 "sonic.cpp"
                var $add_ptr30=(($46+2*$45)&4294967295); //@line 676 "sonic.cpp"
                $o=$add_ptr30; //@line 676 "sonic.cpp"
                var $47=$t; //@line 664 "sonic.cpp"
                var $inc=((($47)+1)&4294967295); //@line 664 "sonic.cpp"
                $t=$inc; //@line 664 "sonic.cpp"
                var $48=$t; //@line 664 "sonic.cpp"
                var $49=$numSamples_addr; //@line 664 "sonic.cpp"
                var $50=$separation_addr; //@line 664 "sonic.cpp"
                var $add=((($50)+($49))&4294967295); //@line 664 "sonic.cpp"
                var $cmp4=((($48))|0) < ((($add))|0); //@line 664 "sonic.cpp"
                if ($cmp4) { __label__ = 2;continue ; } else { __label__ = 8;break $for_body5$$for_inc31$5; } //@line 664 "sonic.cpp"
              }
            }
          } while(0);
  
          var $51=$i; //@line 660 "sonic.cpp"
          var $inc32=((($51)+1)&4294967295); //@line 660 "sonic.cpp"
          $i=$inc32; //@line 660 "sonic.cpp"
          var $52=$i; //@line 660 "sonic.cpp"
          var $53=$numChannels_addr; //@line 660 "sonic.cpp"
          var $cmp=((($52))|0) < ((($53))|0); //@line 660 "sonic.cpp"
          if ($cmp) { __label__ = 1;continue $for_body$3; } else { __label__ = 9;break $for_body$$for_end33$2; } //@line 660 "sonic.cpp"
        }
      }
    } while(0);
  
    ;
    return; //@line 679 "sonic.cpp"
    return;
  }
  

  function __ZL18removePitchSamplesP17sonicStreamStructi($stream, $numSamples) {
    ;
    var __label__;
  
    var $stream_addr;
    var $numSamples_addr;
    var $numChannels;
    var $source;
    $stream_addr=$stream;
    $numSamples_addr=$numSamples;
    var $0=$stream_addr; //@line 710 "sonic.cpp"
    var $numChannels1=(($0+28)&4294967295); //@line 710 "sonic.cpp"
    var $1=HEAP32[(($numChannels1)>>2)]; //@line 710 "sonic.cpp"
    $numChannels=$1; //@line 710 "sonic.cpp"
    var $2=$stream_addr; //@line 711 "sonic.cpp"
    var $pitchBuffer=(($2+8)&4294967295); //@line 711 "sonic.cpp"
    var $3=HEAP32[(($pitchBuffer)>>2)]; //@line 711 "sonic.cpp"
    var $4=$numSamples_addr; //@line 711 "sonic.cpp"
    var $5=$numChannels; //@line 711 "sonic.cpp"
    var $mul=((($5)*($4))&4294967295); //@line 711 "sonic.cpp"
    var $add_ptr=(($3+2*$mul)&4294967295); //@line 711 "sonic.cpp"
    $source=$add_ptr; //@line 711 "sonic.cpp"
    var $6=$numSamples_addr; //@line 713 "sonic.cpp"
    var $cmp=((($6))|0)==0; //@line 713 "sonic.cpp"
    if ($cmp) { __label__ = 4;; } else { __label__ = 1;; } //@line 713 "sonic.cpp"
    if (__label__ == 1) {
  
      var $7=$numSamples_addr; //@line 716 "sonic.cpp"
      var $8=$stream_addr; //@line 716 "sonic.cpp"
      var $numPitchSamples=(($8+52)&4294967295); //@line 716 "sonic.cpp"
      var $9=HEAP32[(($numPitchSamples)>>2)]; //@line 716 "sonic.cpp"
      var $cmp2=((($7))|0)!=((($9))|0); //@line 716 "sonic.cpp"
      if ($cmp2) { __label__ = 2;; } else { __label__ = 3;; } //@line 716 "sonic.cpp"
      if (__label__ == 2) {
  
        var $10=$stream_addr; //@line 717 "sonic.cpp"
        var $pitchBuffer4=(($10+8)&4294967295); //@line 717 "sonic.cpp"
        var $11=HEAP32[(($pitchBuffer4)>>2)]; //@line 717 "sonic.cpp"
        var $12=$11; //@line 717 "sonic.cpp"
        var $13=$source; //@line 717 "sonic.cpp"
        var $14=$13; //@line 717 "sonic.cpp"
        var $15=$stream_addr; //@line 717 "sonic.cpp"
        var $numPitchSamples5=(($15+52)&4294967295); //@line 717 "sonic.cpp"
        var $16=HEAP32[(($numPitchSamples5)>>2)]; //@line 717 "sonic.cpp"
        var $17=$numSamples_addr; //@line 717 "sonic.cpp"
        var $sub=((($16)-($17))&4294967295); //@line 717 "sonic.cpp"
        var $18=$numChannels; //@line 717 "sonic.cpp"
        var $mul6=((($18)*2)&4294967295); //@line 717 "sonic.cpp"
        var $mul7=((($mul6)*($sub))&4294967295); //@line 717 "sonic.cpp"
        _llvm_memmove_p0i8_p0i8_i32($12, $14, $mul7, 1, 0); //@line 717 "sonic.cpp"
        ; //@line 719 "sonic.cpp"
      }
  
      var $19=$numSamples_addr; //@line 720 "sonic.cpp"
      var $20=$stream_addr; //@line 720 "sonic.cpp"
      var $numPitchSamples9=(($20+52)&4294967295); //@line 720 "sonic.cpp"
      var $21=HEAP32[(($numPitchSamples9)>>2)]; //@line 720 "sonic.cpp"
      var $sub10=((($21)-($19))&4294967295); //@line 720 "sonic.cpp"
      HEAP32[(($numPitchSamples9)>>2)]=$sub10; //@line 720 "sonic.cpp"
      ; //@line 721 "sonic.cpp"
    }
  
    ;
    return; //@line 721 "sonic.cpp"
    return;
  }
  

  function __ZL22findPitchPeriodInRangePsiiPiS0_($samples, $minPeriod, $maxPeriod, $retMinDiff, $retMaxDiff) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $samples_addr;
    var $minPeriod_addr;
    var $maxPeriod_addr;
    var $retMinDiff_addr;
    var $retMaxDiff_addr;
    var $period;
    var $bestPeriod;
    var $s;
    var $p;
    var $sVal;
    var $pVal;
    var $diff;
    var $minDiff;
    var $maxDiff;
    var $i;
    $samples_addr=$samples;
    $minPeriod_addr=$minPeriod;
    $maxPeriod_addr=$maxPeriod;
    $retMinDiff_addr=$retMinDiff;
    $retMaxDiff_addr=$retMaxDiff;
    $bestPeriod=0; //@line 521 "sonic.cpp"
    $minDiff=1; //@line 523 "sonic.cpp"
    $maxDiff=0; //@line 523 "sonic.cpp"
    var $0=$minPeriod_addr; //@line 526 "sonic.cpp"
    $period=$0; //@line 526 "sonic.cpp"
    var $1=$period; //@line 526 "sonic.cpp"
    var $2=$maxPeriod_addr; //@line 526 "sonic.cpp"
    var $cmp3=((($1))|0) <= ((($2))|0); //@line 526 "sonic.cpp"
    if ($cmp3) { __label__ = 1;; } else { __label__ = 11;; } //@line 526 "sonic.cpp"
    $for_body$$for_end24$2: do { 
      if (__label__ == 1) {
        $for_body$3: while(1) { 
  
          $diff=0; //@line 527 "sonic.cpp"
          var $3=$samples_addr; //@line 528 "sonic.cpp"
          $s=$3; //@line 528 "sonic.cpp"
          var $4=$samples_addr; //@line 529 "sonic.cpp"
          var $5=$period; //@line 529 "sonic.cpp"
          var $add_ptr=(($4+2*$5)&4294967295); //@line 529 "sonic.cpp"
          $p=$add_ptr; //@line 529 "sonic.cpp"
          $i=0; //@line 530 "sonic.cpp"
          var $6=$i; //@line 530 "sonic.cpp"
          var $7=$period; //@line 530 "sonic.cpp"
          var $cmp21=((($6))|0) < ((($7))|0); //@line 530 "sonic.cpp"
          if ($cmp21) { __label__ = 2;; } else { __label__ = 6;; } //@line 530 "sonic.cpp"
          $for_body3$$for_end$5: do { 
            if (__label__ == 2) {
              while(1) { 
  
                var $8=$s; //@line 531 "sonic.cpp"
                var $incdec_ptr=(($8+2)&4294967295); //@line 531 "sonic.cpp"
                $s=$incdec_ptr; //@line 531 "sonic.cpp"
                var $9=HEAP16[(($8)>>1)]; //@line 531 "sonic.cpp"
                $sVal=$9; //@line 531 "sonic.cpp"
                var $10=$p; //@line 532 "sonic.cpp"
                var $incdec_ptr4=(($10+2)&4294967295); //@line 532 "sonic.cpp"
                $p=$incdec_ptr4; //@line 532 "sonic.cpp"
                var $11=HEAP16[(($10)>>1)]; //@line 532 "sonic.cpp"
                $pVal=$11; //@line 532 "sonic.cpp"
                var $12=$sVal; //@line 533 "sonic.cpp"
                var $conv=(tempInt=(($12)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 533 "sonic.cpp"
                var $13=$pVal; //@line 533 "sonic.cpp"
                var $conv5=(tempInt=(($13)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 533 "sonic.cpp"
                var $cmp6=((($conv))|0) >= ((($conv5))|0); //@line 533 "sonic.cpp"
                if ($cmp6) { __label__ = 3;; } else { __label__ = 4;; } //@line 533 "sonic.cpp"
                if (__label__ == 3) {
  
                  var $14=$sVal; //@line 533 "sonic.cpp"
                  var $conv7=(tempInt=(($14)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 533 "sonic.cpp"
                  var $15=$pVal; //@line 533 "sonic.cpp"
                  var $conv8=(tempInt=(($15)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 533 "sonic.cpp"
                  var $sub=((($conv7)-($conv8))&4294967295); //@line 533 "sonic.cpp"
                  var $conv9=((($sub)) & 65535); //@line 533 "sonic.cpp"
                  __lastLabel__ = 3; ; //@line 533 "sonic.cpp"
                }
                else if (__label__ == 4) {
  
                  var $16=$pVal; //@line 533 "sonic.cpp"
                  var $conv10=(tempInt=(($16)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 533 "sonic.cpp"
                  var $17=$sVal; //@line 533 "sonic.cpp"
                  var $conv11=(tempInt=(($17)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 533 "sonic.cpp"
                  var $sub12=((($conv10)-($conv11))&4294967295); //@line 533 "sonic.cpp"
                  var $conv13=((($sub12)) & 65535); //@line 533 "sonic.cpp"
                  __lastLabel__ = 4; ; //@line 533 "sonic.cpp"
                }
  
                var $cond=__lastLabel__ == 3 ? $conv9 : ($conv13); //@line 533 "sonic.cpp"
                var $conv14=((($cond))&65535); //@line 533 "sonic.cpp"
                var $18=$diff; //@line 533 "sonic.cpp"
                var $add=((($18)+($conv14))&4294967295); //@line 533 "sonic.cpp"
                $diff=$add; //@line 533 "sonic.cpp"
                var $19=$i; //@line 530 "sonic.cpp"
                var $inc=((($19)+1)&4294967295); //@line 530 "sonic.cpp"
                $i=$inc; //@line 530 "sonic.cpp"
                var $20=$i; //@line 530 "sonic.cpp"
                var $21=$period; //@line 530 "sonic.cpp"
                var $cmp2=((($20))|0) < ((($21))|0); //@line 530 "sonic.cpp"
                if ($cmp2) { __label__ = 2;continue ; } else { __label__ = 6;break $for_body3$$for_end$5; } //@line 530 "sonic.cpp"
              }
            }
          } while(0);
  
          var $22=$diff; //@line 539 "sonic.cpp"
          var $23=$bestPeriod; //@line 539 "sonic.cpp"
          var $mul=((($23)*($22))&4294967295); //@line 539 "sonic.cpp"
          var $24=$minDiff; //@line 539 "sonic.cpp"
          var $25=$period; //@line 539 "sonic.cpp"
          var $mul15=((($25)*($24))&4294967295); //@line 539 "sonic.cpp"
          var $cmp16=((($mul))>>>0) < ((($mul15))>>>0); //@line 539 "sonic.cpp"
          if ($cmp16) { __label__ = 7;; } else { __label__ = 8;; } //@line 539 "sonic.cpp"
          if (__label__ == 7) {
  
            var $26=$diff; //@line 540 "sonic.cpp"
            $minDiff=$26; //@line 540 "sonic.cpp"
            var $27=$period; //@line 541 "sonic.cpp"
            $bestPeriod=$27; //@line 541 "sonic.cpp"
            ; //@line 542 "sonic.cpp"
          }
  
          var $28=$diff; //@line 543 "sonic.cpp"
          var $29=$bestPeriod; //@line 543 "sonic.cpp"
          var $mul17=((($29)*($28))&4294967295); //@line 543 "sonic.cpp"
          var $30=$maxDiff; //@line 543 "sonic.cpp"
          var $31=$period; //@line 543 "sonic.cpp"
          var $mul18=((($31)*($30))&4294967295); //@line 543 "sonic.cpp"
          var $cmp19=((($mul17))>>>0) > ((($mul18))>>>0); //@line 543 "sonic.cpp"
          if ($cmp19) { __label__ = 9;; } else { __label__ = 10;; } //@line 543 "sonic.cpp"
          if (__label__ == 9) {
  
            var $32=$diff; //@line 544 "sonic.cpp"
            $maxDiff=$32; //@line 544 "sonic.cpp"
            ; //@line 545 "sonic.cpp"
          }
  
          var $33=$period; //@line 526 "sonic.cpp"
          var $inc23=((($33)+1)&4294967295); //@line 526 "sonic.cpp"
          $period=$inc23; //@line 526 "sonic.cpp"
          var $34=$period; //@line 526 "sonic.cpp"
          var $35=$maxPeriod_addr; //@line 526 "sonic.cpp"
          var $cmp=((($34))|0) <= ((($35))|0); //@line 526 "sonic.cpp"
          if ($cmp) { __label__ = 1;continue $for_body$3; } else { __label__ = 11;break $for_body$$for_end24$2; } //@line 526 "sonic.cpp"
        }
      }
    } while(0);
  
    var $36=$minDiff; //@line 547 "sonic.cpp"
    var $37=$retMinDiff_addr; //@line 547 "sonic.cpp"
    HEAP32[(($37)>>2)]=$36; //@line 547 "sonic.cpp"
    var $38=$maxDiff; //@line 548 "sonic.cpp"
    var $39=$retMaxDiff_addr; //@line 548 "sonic.cpp"
    HEAP32[(($39)>>2)]=$38; //@line 548 "sonic.cpp"
    var $40=$bestPeriod; //@line 549 "sonic.cpp"
    ;
    return $40; //@line 549 "sonic.cpp"
    return null;
  }
  

  function __ZL15downSampleInputP17sonicStreamStructPsi($stream, $samples, $skip) {
    ;
    var __label__;
  
    var $stream_addr;
    var $samples_addr;
    var $skip_addr;
    var $numSamples;
    var $samplesPerValue;
    var $i;
    var $j;
    var $value;
    var $downSamples;
    $stream_addr=$stream;
    $samples_addr=$samples;
    $skip_addr=$skip;
    var $0=$stream_addr; //@line 496 "sonic.cpp"
    var $maxRequired=(($0+64)&4294967295); //@line 496 "sonic.cpp"
    var $1=HEAP32[(($maxRequired)>>2)]; //@line 496 "sonic.cpp"
    var $2=$skip_addr; //@line 496 "sonic.cpp"
    var $div=((((($1))|0)/((($2))|0))|0); //@line 496 "sonic.cpp"
    $numSamples=$div; //@line 496 "sonic.cpp"
    var $3=$stream_addr; //@line 497 "sonic.cpp"
    var $numChannels=(($3+28)&4294967295); //@line 497 "sonic.cpp"
    var $4=HEAP32[(($numChannels)>>2)]; //@line 497 "sonic.cpp"
    var $5=$skip_addr; //@line 497 "sonic.cpp"
    var $mul=((($5)*($4))&4294967295); //@line 497 "sonic.cpp"
    $samplesPerValue=$mul; //@line 497 "sonic.cpp"
    var $6=$stream_addr; //@line 500 "sonic.cpp"
    var $downSampleBuffer=(($6+12)&4294967295); //@line 500 "sonic.cpp"
    var $7=HEAP32[(($downSampleBuffer)>>2)]; //@line 500 "sonic.cpp"
    $downSamples=$7; //@line 500 "sonic.cpp"
    $i=0; //@line 502 "sonic.cpp"
    var $8=$i; //@line 502 "sonic.cpp"
    var $9=$numSamples; //@line 502 "sonic.cpp"
    var $cmp3=((($8))|0) < ((($9))|0); //@line 502 "sonic.cpp"
    if ($cmp3) { __label__ = 1;; } else { __label__ = 4;; } //@line 502 "sonic.cpp"
    $for_body$$for_end9$2: do { 
      if (__label__ == 1) {
        $for_body$3: while(1) { 
  
          $value=0; //@line 503 "sonic.cpp"
          $j=0; //@line 504 "sonic.cpp"
          var $10=$j; //@line 504 "sonic.cpp"
          var $11=$samplesPerValue; //@line 504 "sonic.cpp"
          var $cmp21=((($10))|0) < ((($11))|0); //@line 504 "sonic.cpp"
          if ($cmp21) { __label__ = 2;; } else { __label__ = 3;; } //@line 504 "sonic.cpp"
          $for_body3$$for_end$5: do { 
            if (__label__ == 2) {
              while(1) { 
  
                var $12=$samples_addr; //@line 505 "sonic.cpp"
                var $incdec_ptr=(($12+2)&4294967295); //@line 505 "sonic.cpp"
                $samples_addr=$incdec_ptr; //@line 505 "sonic.cpp"
                var $13=HEAP16[(($12)>>1)]; //@line 505 "sonic.cpp"
                var $conv=(tempInt=(($13)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 505 "sonic.cpp"
                var $14=$value; //@line 505 "sonic.cpp"
                var $add=((($14)+($conv))&4294967295); //@line 505 "sonic.cpp"
                $value=$add; //@line 505 "sonic.cpp"
                var $15=$j; //@line 504 "sonic.cpp"
                var $inc=((($15)+1)&4294967295); //@line 504 "sonic.cpp"
                $j=$inc; //@line 504 "sonic.cpp"
                var $16=$j; //@line 504 "sonic.cpp"
                var $17=$samplesPerValue; //@line 504 "sonic.cpp"
                var $cmp2=((($16))|0) < ((($17))|0); //@line 504 "sonic.cpp"
                if ($cmp2) { __label__ = 2;continue ; } else { __label__ = 3;break $for_body3$$for_end$5; } //@line 504 "sonic.cpp"
              }
            }
          } while(0);
  
          var $18=$samplesPerValue; //@line 507 "sonic.cpp"
          var $19=$value; //@line 507 "sonic.cpp"
          var $div4=((((($19))|0)/((($18))|0))|0); //@line 507 "sonic.cpp"
          $value=$div4; //@line 507 "sonic.cpp"
          var $20=$value; //@line 508 "sonic.cpp"
          var $conv5=((($20)) & 65535); //@line 508 "sonic.cpp"
          var $21=$downSamples; //@line 508 "sonic.cpp"
          var $incdec_ptr6=(($21+2)&4294967295); //@line 508 "sonic.cpp"
          $downSamples=$incdec_ptr6; //@line 508 "sonic.cpp"
          HEAP16[(($21)>>1)]=$conv5; //@line 508 "sonic.cpp"
          var $22=$i; //@line 502 "sonic.cpp"
          var $inc8=((($22)+1)&4294967295); //@line 502 "sonic.cpp"
          $i=$inc8; //@line 502 "sonic.cpp"
          var $23=$i; //@line 502 "sonic.cpp"
          var $24=$numSamples; //@line 502 "sonic.cpp"
          var $cmp=((($23))|0) < ((($24))|0); //@line 502 "sonic.cpp"
          if ($cmp) { __label__ = 1;continue $for_body$3; } else { __label__ = 4;break $for_body$$for_end9$2; } //@line 502 "sonic.cpp"
        }
      }
    } while(0);
  
    ;
    return; //@line 510 "sonic.cpp"
    return;
  }
  

  function __ZL16prevPeriodBetterP17sonicStreamStructiii($stream, $period, $minDiff, $maxDiff) {
    ;
    var __label__;
  
    var $retval;
    var $stream_addr;
    var $period_addr;
    var $minDiff_addr;
    var $maxDiff_addr;
    $stream_addr=$stream;
    $period_addr=$period;
    $minDiff_addr=$minDiff;
    $maxDiff_addr=$maxDiff;
    var $0=$maxDiff_addr; //@line 560 "sonic.cpp"
    var $mul=((($0)*3)&4294967295); //@line 560 "sonic.cpp"
    var $div=((((($mul))|0)/2)|0); //@line 560 "sonic.cpp"
    var $1=$stream_addr; //@line 560 "sonic.cpp"
    var $prevMaxDiff=(($1+80)&4294967295); //@line 560 "sonic.cpp"
    var $2=HEAP32[(($prevMaxDiff)>>2)]; //@line 560 "sonic.cpp"
    var $cmp=((($div))|0) < ((($2))|0); //@line 560 "sonic.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 3;; } //@line 560 "sonic.cpp"
    $land_lhs_true$$if_end$2: do { 
      if (__label__ == 1) {
  
        var $3=$maxDiff_addr; //@line 560 "sonic.cpp"
        var $conv=((($3))|0); //@line 560 "sonic.cpp"
        var $mul1=($conv)*3; //@line 560 "sonic.cpp"
        var $4=$stream_addr; //@line 560 "sonic.cpp"
        var $prevMinDiff=(($4+84)&4294967295); //@line 560 "sonic.cpp"
        var $5=HEAP32[(($prevMinDiff)>>2)]; //@line 560 "sonic.cpp"
        var $conv2=((($5))|0); //@line 560 "sonic.cpp"
        var $mul3=($mul1)*($conv2); //@line 560 "sonic.cpp"
        var $6=$stream_addr; //@line 560 "sonic.cpp"
        var $prevMaxDiff4=(($6+80)&4294967295); //@line 560 "sonic.cpp"
        var $7=HEAP32[(($prevMaxDiff4)>>2)]; //@line 560 "sonic.cpp"
        var $conv5=((($7))|0); //@line 560 "sonic.cpp"
        var $8=$minDiff_addr; //@line 560 "sonic.cpp"
        var $conv6=((($8))|0); //@line 560 "sonic.cpp"
        var $mul7=($conv5)*($conv6); //@line 560 "sonic.cpp"
        var $mul8=($mul7)*2; //@line 560 "sonic.cpp"
        var $cmp9=($mul3) < ($mul8); //@line 560 "sonic.cpp"
        if (!($cmp9)) { __label__ = 3;break $land_lhs_true$$if_end$2; } //@line 560 "sonic.cpp"
  
        $retval=1; //@line 562 "sonic.cpp"
        __label__ = 4;break $land_lhs_true$$if_end$2; //@line 562 "sonic.cpp"
      }
    } while(0);
    if (__label__ == 3) {
  
      $retval=0; //@line 564 "sonic.cpp"
      ; //@line 564 "sonic.cpp"
    }
  
    var $9=$retval; //@line 565 "sonic.cpp"
    ;
    return $9; //@line 565 "sonic.cpp"
    return null;
  }
  

  function __ZL17copyInputToOutputP17sonicStreamStructi($stream, $position) {
    ;
    var __label__;
  
    var $retval;
    var $stream_addr;
    var $position_addr;
    var $numSamples;
    $stream_addr=$stream;
    $position_addr=$position;
    var $0=$stream_addr; //@line 342 "sonic.cpp"
    var $remainingInputToCopy=(($0+68)&4294967295); //@line 342 "sonic.cpp"
    var $1=HEAP32[(($remainingInputToCopy)>>2)]; //@line 342 "sonic.cpp"
    $numSamples=$1; //@line 342 "sonic.cpp"
    var $2=$numSamples; //@line 344 "sonic.cpp"
    var $3=$stream_addr; //@line 344 "sonic.cpp"
    var $maxRequired=(($3+64)&4294967295); //@line 344 "sonic.cpp"
    var $4=HEAP32[(($maxRequired)>>2)]; //@line 344 "sonic.cpp"
    var $cmp=((($2))|0) > ((($4))|0); //@line 344 "sonic.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 344 "sonic.cpp"
    if (__label__ == 1) {
  
      var $5=$stream_addr; //@line 345 "sonic.cpp"
      var $maxRequired1=(($5+64)&4294967295); //@line 345 "sonic.cpp"
      var $6=HEAP32[(($maxRequired1)>>2)]; //@line 345 "sonic.cpp"
      $numSamples=$6; //@line 345 "sonic.cpp"
      ; //@line 346 "sonic.cpp"
    }
  
    var $7=$stream_addr; //@line 347 "sonic.cpp"
    var $8=$stream_addr; //@line 347 "sonic.cpp"
    var $inputBuffer=(($8)&4294967295); //@line 347 "sonic.cpp"
    var $9=HEAP32[(($inputBuffer)>>2)]; //@line 347 "sonic.cpp"
    var $10=$position_addr; //@line 347 "sonic.cpp"
    var $11=$stream_addr; //@line 347 "sonic.cpp"
    var $numChannels=(($11+28)&4294967295); //@line 347 "sonic.cpp"
    var $12=HEAP32[(($numChannels)>>2)]; //@line 347 "sonic.cpp"
    var $mul=((($12)*($10))&4294967295); //@line 347 "sonic.cpp"
    var $add_ptr=(($9+2*$mul)&4294967295); //@line 347 "sonic.cpp"
    var $13=$numSamples; //@line 347 "sonic.cpp"
    var $call=__ZL12copyToOutputP17sonicStreamStructPsi($7, $add_ptr, $13); //@line 347 "sonic.cpp"
    var $tobool=((($call))|0)!=0; //@line 347 "sonic.cpp"
    if ($tobool) { __label__ = 4;; } else { __label__ = 3;; } //@line 347 "sonic.cpp"
    if (__label__ == 4) {
  
      var $14=$numSamples; //@line 351 "sonic.cpp"
      var $15=$stream_addr; //@line 351 "sonic.cpp"
      var $remainingInputToCopy4=(($15+68)&4294967295); //@line 351 "sonic.cpp"
      var $16=HEAP32[(($remainingInputToCopy4)>>2)]; //@line 351 "sonic.cpp"
      var $sub=((($16)-($14))&4294967295); //@line 351 "sonic.cpp"
      HEAP32[(($remainingInputToCopy4)>>2)]=$sub; //@line 351 "sonic.cpp"
      var $17=$numSamples; //@line 352 "sonic.cpp"
      $retval=$17; //@line 352 "sonic.cpp"
      ; //@line 352 "sonic.cpp"
    }
    else if (__label__ == 3) {
  
      $retval=0; //@line 349 "sonic.cpp"
      ; //@line 349 "sonic.cpp"
    }
  
    var $18=$retval; //@line 353 "sonic.cpp"
    ;
    return $18; //@line 353 "sonic.cpp"
    return null;
  }
  

  function __ZL15skipPitchPeriodP17sonicStreamStructPsfi($stream, $samples, $speed, $period) {
    ;
    var __label__;
  
    var $retval;
    var $stream_addr;
    var $samples_addr;
    var $speed_addr;
    var $period_addr;
    var $newSamples;
    var $numChannels;
    $stream_addr=$stream;
    $samples_addr=$samples;
    $speed_addr=$speed;
    $period_addr=$period;
    var $0=$stream_addr; //@line 773 "sonic.cpp"
    var $numChannels1=(($0+28)&4294967295); //@line 773 "sonic.cpp"
    var $1=HEAP32[(($numChannels1)>>2)]; //@line 773 "sonic.cpp"
    $numChannels=$1; //@line 773 "sonic.cpp"
    var $2=$speed_addr; //@line 775 "sonic.cpp"
    var $cmp=($2) >= 2; //@line 775 "sonic.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 775 "sonic.cpp"
    $if_then$$if_else$2: do { 
      if (__label__ == 1) {
  
        var $3=$period_addr; //@line 776 "sonic.cpp"
        var $conv=((($3))|0); //@line 776 "sonic.cpp"
        var $4=$speed_addr; //@line 776 "sonic.cpp"
        var $sub=($4)-1; //@line 776 "sonic.cpp"
        var $div=($conv)/($sub); //@line 776 "sonic.cpp"
        var $conv2=((($div))|0); //@line 776 "sonic.cpp"
        $newSamples=$conv2; //@line 776 "sonic.cpp"
        ; //@line 777 "sonic.cpp"
      }
      else if (__label__ == 2) {
  
        var $5=$speed_addr; //@line 777 "sonic.cpp"
        var $cmp3=($5) > 1; //@line 777 "sonic.cpp"
        if (!($cmp3)) { __label__ = 4;break $if_then$$if_else$2; } //@line 777 "sonic.cpp"
  
        var $6=$period_addr; //@line 778 "sonic.cpp"
        $newSamples=$6; //@line 778 "sonic.cpp"
        var $7=$period_addr; //@line 779 "sonic.cpp"
        var $conv5=((($7))|0); //@line 779 "sonic.cpp"
        var $8=$speed_addr; //@line 779 "sonic.cpp"
        var $sub6=2-($8); //@line 779 "sonic.cpp"
        var $mul=($conv5)*($sub6); //@line 779 "sonic.cpp"
        var $9=$speed_addr; //@line 779 "sonic.cpp"
        var $sub7=($9)-1; //@line 779 "sonic.cpp"
        var $div8=($mul)/($sub7); //@line 779 "sonic.cpp"
        var $conv9=((($div8))|0); //@line 779 "sonic.cpp"
        var $10=$stream_addr; //@line 779 "sonic.cpp"
        var $remainingInputToCopy=(($10+68)&4294967295); //@line 779 "sonic.cpp"
        HEAP32[(($remainingInputToCopy)>>2)]=$conv9; //@line 779 "sonic.cpp"
        ; //@line 780 "sonic.cpp"
      }
    } while(0);
  
    var $11=$stream_addr; //@line 781 "sonic.cpp"
    var $12=$newSamples; //@line 781 "sonic.cpp"
    var $call=__ZL27enlargeOutputBufferIfNeededP17sonicStreamStructi($11, $12); //@line 781 "sonic.cpp"
    var $tobool=((($call))|0)!=0; //@line 781 "sonic.cpp"
    if ($tobool) { __label__ = 6;; } else { __label__ = 5;; } //@line 781 "sonic.cpp"
    if (__label__ == 6) {
  
      var $13=$newSamples; //@line 784 "sonic.cpp"
      var $14=$numChannels; //@line 784 "sonic.cpp"
      var $15=$stream_addr; //@line 784 "sonic.cpp"
      var $outputBuffer=(($15+4)&4294967295); //@line 784 "sonic.cpp"
      var $16=HEAP32[(($outputBuffer)>>2)]; //@line 784 "sonic.cpp"
      var $17=$stream_addr; //@line 784 "sonic.cpp"
      var $numOutputSamples=(($17+48)&4294967295); //@line 784 "sonic.cpp"
      var $18=HEAP32[(($numOutputSamples)>>2)]; //@line 784 "sonic.cpp"
      var $19=$numChannels; //@line 784 "sonic.cpp"
      var $mul13=((($19)*($18))&4294967295); //@line 784 "sonic.cpp"
      var $add_ptr=(($16+2*$mul13)&4294967295); //@line 784 "sonic.cpp"
      var $20=$samples_addr; //@line 784 "sonic.cpp"
      var $21=$samples_addr; //@line 784 "sonic.cpp"
      var $22=$period_addr; //@line 784 "sonic.cpp"
      var $23=$numChannels; //@line 784 "sonic.cpp"
      var $mul14=((($23)*($22))&4294967295); //@line 784 "sonic.cpp"
      var $add_ptr15=(($21+2*$mul14)&4294967295); //@line 784 "sonic.cpp"
      __ZL10overlapAddiiPsS_S_($13, $14, $add_ptr, $20, $add_ptr15); //@line 784 "sonic.cpp"
      var $24=$newSamples; //@line 786 "sonic.cpp"
      var $25=$stream_addr; //@line 786 "sonic.cpp"
      var $numOutputSamples16=(($25+48)&4294967295); //@line 786 "sonic.cpp"
      var $26=HEAP32[(($numOutputSamples16)>>2)]; //@line 786 "sonic.cpp"
      var $add=((($26)+($24))&4294967295); //@line 786 "sonic.cpp"
      HEAP32[(($numOutputSamples16)>>2)]=$add; //@line 786 "sonic.cpp"
      var $27=$newSamples; //@line 787 "sonic.cpp"
      $retval=$27; //@line 787 "sonic.cpp"
      ; //@line 787 "sonic.cpp"
    }
    else if (__label__ == 5) {
  
      $retval=0; //@line 782 "sonic.cpp"
      ; //@line 782 "sonic.cpp"
    }
  
    var $28=$retval; //@line 788 "sonic.cpp"
    ;
    return $28; //@line 788 "sonic.cpp"
    return null;
  }
  

  function __ZL17insertPitchPeriodP17sonicStreamStructPsfi($stream, $samples, $speed, $period) {
    ;
    var __label__;
  
    var $retval;
    var $stream_addr;
    var $samples_addr;
    var $speed_addr;
    var $period_addr;
    var $newSamples;
    var $out;
    var $numChannels;
    $stream_addr=$stream;
    $samples_addr=$samples;
    $speed_addr=$speed;
    $period_addr=$period;
    var $0=$stream_addr; //@line 799 "sonic.cpp"
    var $numChannels1=(($0+28)&4294967295); //@line 799 "sonic.cpp"
    var $1=HEAP32[(($numChannels1)>>2)]; //@line 799 "sonic.cpp"
    $numChannels=$1; //@line 799 "sonic.cpp"
    var $2=$speed_addr; //@line 801 "sonic.cpp"
    var $cmp=($2) < 0.5; //@line 801 "sonic.cpp"
    var $3=$period_addr; //@line 802 "sonic.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 801 "sonic.cpp"
    if (__label__ == 1) {
  
      var $conv=((($3))|0); //@line 802 "sonic.cpp"
      var $4=$speed_addr; //@line 802 "sonic.cpp"
      var $mul=($conv)*($4); //@line 802 "sonic.cpp"
      var $5=$speed_addr; //@line 802 "sonic.cpp"
      var $sub=1-($5); //@line 802 "sonic.cpp"
      var $div=($mul)/($sub); //@line 802 "sonic.cpp"
      var $conv2=((($div))|0); //@line 802 "sonic.cpp"
      $newSamples=$conv2; //@line 802 "sonic.cpp"
      ; //@line 803 "sonic.cpp"
    }
    else if (__label__ == 2) {
  
      $newSamples=$3; //@line 804 "sonic.cpp"
      var $6=$period_addr; //@line 805 "sonic.cpp"
      var $conv3=((($6))|0); //@line 805 "sonic.cpp"
      var $7=$speed_addr; //@line 805 "sonic.cpp"
      var $mul4=2*($7); //@line 805 "sonic.cpp"
      var $sub5=($mul4)-1; //@line 805 "sonic.cpp"
      var $mul6=($conv3)*($sub5); //@line 805 "sonic.cpp"
      var $8=$speed_addr; //@line 805 "sonic.cpp"
      var $sub7=1-($8); //@line 805 "sonic.cpp"
      var $div8=($mul6)/($sub7); //@line 805 "sonic.cpp"
      var $conv9=((($div8))|0); //@line 805 "sonic.cpp"
      var $9=$stream_addr; //@line 805 "sonic.cpp"
      var $remainingInputToCopy=(($9+68)&4294967295); //@line 805 "sonic.cpp"
      HEAP32[(($remainingInputToCopy)>>2)]=$conv9; //@line 805 "sonic.cpp"
      ;
    }
  
    var $10=$stream_addr; //@line 807 "sonic.cpp"
    var $11=$period_addr; //@line 807 "sonic.cpp"
    var $12=$newSamples; //@line 807 "sonic.cpp"
    var $add=((($12)+($11))&4294967295); //@line 807 "sonic.cpp"
    var $call=__ZL27enlargeOutputBufferIfNeededP17sonicStreamStructi($10, $add); //@line 807 "sonic.cpp"
    var $tobool=((($call))|0)!=0; //@line 807 "sonic.cpp"
    if ($tobool) { __label__ = 5;; } else { __label__ = 4;; } //@line 807 "sonic.cpp"
    if (__label__ == 5) {
  
      var $13=$stream_addr; //@line 810 "sonic.cpp"
      var $outputBuffer=(($13+4)&4294967295); //@line 810 "sonic.cpp"
      var $14=HEAP32[(($outputBuffer)>>2)]; //@line 810 "sonic.cpp"
      var $15=$stream_addr; //@line 810 "sonic.cpp"
      var $numOutputSamples=(($15+48)&4294967295); //@line 810 "sonic.cpp"
      var $16=HEAP32[(($numOutputSamples)>>2)]; //@line 810 "sonic.cpp"
      var $17=$numChannels; //@line 810 "sonic.cpp"
      var $mul12=((($17)*($16))&4294967295); //@line 810 "sonic.cpp"
      var $add_ptr=(($14+2*$mul12)&4294967295); //@line 810 "sonic.cpp"
      $out=$add_ptr; //@line 810 "sonic.cpp"
      var $18=$out; //@line 811 "sonic.cpp"
      var $19=$18; //@line 811 "sonic.cpp"
      var $20=$samples_addr; //@line 811 "sonic.cpp"
      var $21=$20; //@line 811 "sonic.cpp"
      var $22=$period_addr; //@line 811 "sonic.cpp"
      var $23=$numChannels; //@line 811 "sonic.cpp"
      var $mul13=((($22)*2)&4294967295); //@line 811 "sonic.cpp"
      var $mul14=((($mul13)*($23))&4294967295); //@line 811 "sonic.cpp"
      var $src$, $dest$, $stop$, $stop4$, $fast$;
      $src$ = $21;
      $dest$ = $19;
      $stop$ = $src$ + $mul14;
      if (($dest$%4) == ($src$%4) && $mul14 > 8) {
        while ($src$%4 !== 0 && $src$ < $stop$) {
          ; HEAP8[$dest$++] = HEAP8[$src$++];
        }
        $src$ >>= 2;
        $dest$ >>= 2;
        $stop4$ = $stop$ >> 2;
        while ($src$ < $stop4$) {
      ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
        }
        $src$ <<= 2;
        $dest$ <<= 2;
      }while ($src$ < $stop$) {
        ; HEAP8[$dest$++] = HEAP8[$src$++];
      }; //@line 811 "sonic.cpp"
      var $24=$stream_addr; //@line 812 "sonic.cpp"
      var $outputBuffer15=(($24+4)&4294967295); //@line 812 "sonic.cpp"
      var $25=HEAP32[(($outputBuffer15)>>2)]; //@line 812 "sonic.cpp"
      var $26=$stream_addr; //@line 812 "sonic.cpp"
      var $numOutputSamples16=(($26+48)&4294967295); //@line 812 "sonic.cpp"
      var $27=HEAP32[(($numOutputSamples16)>>2)]; //@line 812 "sonic.cpp"
      var $28=$period_addr; //@line 812 "sonic.cpp"
      var $add17=((($28)+($27))&4294967295); //@line 812 "sonic.cpp"
      var $29=$numChannels; //@line 812 "sonic.cpp"
      var $mul18=((($add17)*($29))&4294967295); //@line 812 "sonic.cpp"
      var $add_ptr19=(($25+2*$mul18)&4294967295); //@line 812 "sonic.cpp"
      $out=$add_ptr19; //@line 812 "sonic.cpp"
      var $30=$newSamples; //@line 813 "sonic.cpp"
      var $31=$numChannels; //@line 813 "sonic.cpp"
      var $32=$out; //@line 813 "sonic.cpp"
      var $33=$samples_addr; //@line 813 "sonic.cpp"
      var $34=$period_addr; //@line 813 "sonic.cpp"
      var $35=$numChannels; //@line 813 "sonic.cpp"
      var $mul20=((($35)*($34))&4294967295); //@line 813 "sonic.cpp"
      var $add_ptr21=(($33+2*$mul20)&4294967295); //@line 813 "sonic.cpp"
      var $36=$samples_addr; //@line 813 "sonic.cpp"
      __ZL10overlapAddiiPsS_S_($30, $31, $32, $add_ptr21, $36); //@line 813 "sonic.cpp"
      var $37=$period_addr; //@line 814 "sonic.cpp"
      var $38=$newSamples; //@line 814 "sonic.cpp"
      var $39=$stream_addr; //@line 814 "sonic.cpp"
      var $numOutputSamples23=(($39+48)&4294967295); //@line 814 "sonic.cpp"
      var $40=HEAP32[(($numOutputSamples23)>>2)]; //@line 814 "sonic.cpp"
      var $add22=((($38)+($37))&4294967295); //@line 814 "sonic.cpp"
      var $add24=((($add22)+($40))&4294967295); //@line 814 "sonic.cpp"
      HEAP32[(($numOutputSamples23)>>2)]=$add24; //@line 814 "sonic.cpp"
      var $41=$newSamples; //@line 815 "sonic.cpp"
      $retval=$41; //@line 815 "sonic.cpp"
      ; //@line 815 "sonic.cpp"
    }
    else if (__label__ == 4) {
  
      $retval=0; //@line 808 "sonic.cpp"
      ; //@line 808 "sonic.cpp"
    }
  
    var $42=$retval; //@line 816 "sonic.cpp"
    ;
    return $42; //@line 816 "sonic.cpp"
    return null;
  }
  

  function __ZL18removeInputSamplesP17sonicStreamStructi($stream, $position) {
    ;
    var __label__;
  
    var $stream_addr;
    var $position_addr;
    var $remainingSamples;
    $stream_addr=$stream;
    $position_addr=$position;
    var $0=$stream_addr; //@line 312 "sonic.cpp"
    var $numInputSamples=(($0+44)&4294967295); //@line 312 "sonic.cpp"
    var $1=HEAP32[(($numInputSamples)>>2)]; //@line 312 "sonic.cpp"
    var $2=$position_addr; //@line 312 "sonic.cpp"
    var $sub=((($1)-($2))&4294967295); //@line 312 "sonic.cpp"
    $remainingSamples=$sub; //@line 312 "sonic.cpp"
    var $3=$remainingSamples; //@line 314 "sonic.cpp"
    var $cmp=((($3))|0) > 0; //@line 314 "sonic.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 314 "sonic.cpp"
    if (__label__ == 1) {
  
      var $4=$stream_addr; //@line 315 "sonic.cpp"
      var $inputBuffer=(($4)&4294967295); //@line 315 "sonic.cpp"
      var $5=HEAP32[(($inputBuffer)>>2)]; //@line 315 "sonic.cpp"
      var $6=$5; //@line 315 "sonic.cpp"
      var $7=$stream_addr; //@line 315 "sonic.cpp"
      var $inputBuffer1=(($7)&4294967295); //@line 315 "sonic.cpp"
      var $8=HEAP32[(($inputBuffer1)>>2)]; //@line 315 "sonic.cpp"
      var $9=$position_addr; //@line 315 "sonic.cpp"
      var $10=$stream_addr; //@line 315 "sonic.cpp"
      var $numChannels=(($10+28)&4294967295); //@line 315 "sonic.cpp"
      var $11=HEAP32[(($numChannels)>>2)]; //@line 315 "sonic.cpp"
      var $mul=((($11)*($9))&4294967295); //@line 315 "sonic.cpp"
      var $add_ptr=(($8+2*$mul)&4294967295); //@line 315 "sonic.cpp"
      var $12=$add_ptr; //@line 315 "sonic.cpp"
      var $13=$remainingSamples; //@line 315 "sonic.cpp"
      var $14=$stream_addr; //@line 315 "sonic.cpp"
      var $numChannels3=(($14+28)&4294967295); //@line 315 "sonic.cpp"
      var $15=HEAP32[(($numChannels3)>>2)]; //@line 315 "sonic.cpp"
      var $mul2=((($13)*2)&4294967295); //@line 315 "sonic.cpp"
      var $mul4=((($mul2)*($15))&4294967295); //@line 315 "sonic.cpp"
      _llvm_memmove_p0i8_p0i8_i32($6, $12, $mul4, 1, 0); //@line 315 "sonic.cpp"
      ; //@line 317 "sonic.cpp"
    }
  
    var $16=$remainingSamples; //@line 318 "sonic.cpp"
    var $17=$stream_addr; //@line 318 "sonic.cpp"
    var $numInputSamples5=(($17+44)&4294967295); //@line 318 "sonic.cpp"
    HEAP32[(($numInputSamples5)>>2)]=$16; //@line 318 "sonic.cpp"
    ;
    return; //@line 319 "sonic.cpp"
    return;
  }
  

  function _getopt($argc, $argv, $optstring) {
    var __stackBase__  = STACKTOP; STACKTOP += 20; _memset(__stackBase__, 0, 20);
    var __label__;
  
    var $argc_addr;
    var $argv_addr;
    var $optstring_addr;
    var $data=__stackBase__;
    var $r;
    $argc_addr=$argc;
    $argv_addr=$argv;
    $optstring_addr=$optstring;
    __ZL12read_globalsP11getopt_data($data); //@line 423 "getopt.cpp"
    var $0=$argc_addr; //@line 424 "getopt.cpp"
    var $1=$argv_addr; //@line 424 "getopt.cpp"
    var $2=$optstring_addr; //@line 424 "getopt.cpp"
    var $call=__ZL15getopt_internaliPKPcPKcPK6optionPiiP11getopt_data($0, $1, $2, 0, 0, 0, $data); //@line 424 "getopt.cpp"
    $r=$call; //@line 424 "getopt.cpp"
    __ZL13write_globalsP11getopt_data($data); //@line 425 "getopt.cpp"
    var $3=$r; //@line 426 "getopt.cpp"
    STACKTOP = __stackBase__;
    return $3; //@line 426 "getopt.cpp"
    return null;
  }
  

  function __ZL12read_globalsP11getopt_data($data) {
    ;
    var __label__;
  
    var $data_addr;
    $data_addr=$data;
    var $0=HEAP32[((_optarg)>>2)]; //@line 154 "getopt.cpp"
    var $1=$data_addr; //@line 154 "getopt.cpp"
    var $optarg=(($1)&4294967295); //@line 154 "getopt.cpp"
    HEAP32[(($optarg)>>2)]=$0; //@line 154 "getopt.cpp"
    var $2=HEAP32[((_optind)>>2)]; //@line 155 "getopt.cpp"
    var $3=$data_addr; //@line 155 "getopt.cpp"
    var $optind=(($3+4)&4294967295); //@line 155 "getopt.cpp"
    HEAP32[(($optind)>>2)]=$2; //@line 155 "getopt.cpp"
    var $4=HEAP32[((_opterr)>>2)]; //@line 156 "getopt.cpp"
    var $5=$data_addr; //@line 156 "getopt.cpp"
    var $opterr=(($5+8)&4294967295); //@line 156 "getopt.cpp"
    HEAP32[(($opterr)>>2)]=$4; //@line 156 "getopt.cpp"
    var $6=HEAP32[((_optopt)>>2)]; //@line 157 "getopt.cpp"
    var $7=$data_addr; //@line 157 "getopt.cpp"
    var $optopt=(($7+12)&4294967295); //@line 157 "getopt.cpp"
    HEAP32[(($optopt)>>2)]=$6; //@line 157 "getopt.cpp"
    var $8=HEAP32[((__ZL8optwhere)>>2)]; //@line 158 "getopt.cpp"
    var $9=$data_addr; //@line 158 "getopt.cpp"
    var $optwhere=(($9+16)&4294967295); //@line 158 "getopt.cpp"
    HEAP32[(($optwhere)>>2)]=$8; //@line 158 "getopt.cpp"
    ;
    return; //@line 159 "getopt.cpp"
    return;
  }
  

  function __ZL15getopt_internaliPKPcPKcPK6optionPiiP11getopt_data($argc, $argv, $shortopts, $longopts, $longind, $only, $data) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $argc_addr;
    var $argv_addr;
    var $shortopts_addr;
    var $longopts_addr;
    var $longind_addr;
    var $only_addr;
    var $data_addr;
    var $ordering;
    var $permute_from;
    var $num_nonopts;
    var $optindex;
    var $match_chars;
    var $possible_arg;
    var $longopt_match;
    var $has_arg;
    var $cp;
    var $arg_next;
    $argc_addr=$argc;
    $argv_addr=$argv;
    $shortopts_addr=$shortopts;
    $longopts_addr=$longopts;
    $longind_addr=$longind;
    $only_addr=$only;
    $data_addr=$data;
    $ordering=0; //@line 179 "getopt.cpp"
    $permute_from=0; //@line 180 "getopt.cpp"
    $num_nonopts=0; //@line 181 "getopt.cpp"
    $optindex=0; //@line 182 "getopt.cpp"
    $match_chars=0; //@line 183 "getopt.cpp"
    $possible_arg=0; //@line 184 "getopt.cpp"
    $longopt_match=-1; //@line 185 "getopt.cpp"
    $has_arg=-1; //@line 186 "getopt.cpp"
    $cp=0; //@line 187 "getopt.cpp"
    $arg_next=0; //@line 188 "getopt.cpp"
    var $0=$argc_addr; //@line 191 "getopt.cpp"
    var $cmp=((($0))|0)==0; //@line 191 "getopt.cpp"
    if ($cmp) { __label__ = 6;; } else { __label__ = 1;; } //@line 191 "getopt.cpp"
    $if_then$$lor_lhs_false$2: do { 
      if (__label__ == 1) {
  
        var $1=$argv_addr; //@line 191 "getopt.cpp"
        var $cmp1=((($1))|0)==0; //@line 191 "getopt.cpp"
        if ($cmp1) { __label__ = 6;break $if_then$$lor_lhs_false$2; } //@line 191 "getopt.cpp"
  
        var $2=$shortopts_addr; //@line 191 "getopt.cpp"
        var $cmp3=((($2))|0)==0; //@line 191 "getopt.cpp"
        if ($cmp3) { __label__ = 3;; } else { __label__ = 4;; } //@line 191 "getopt.cpp"
        if (__label__ == 3) {
  
          var $3=$longopts_addr; //@line 191 "getopt.cpp"
          var $cmp4=((($3))|0)==0; //@line 191 "getopt.cpp"
          if ($cmp4) { __label__ = 6;break $if_then$$lor_lhs_false$2; } //@line 191 "getopt.cpp"
        }
  
        var $4=$data_addr; //@line 191 "getopt.cpp"
        var $optind=(($4+4)&4294967295); //@line 191 "getopt.cpp"
        var $5=HEAP32[(($optind)>>2)]; //@line 191 "getopt.cpp"
        var $6=$argc_addr; //@line 191 "getopt.cpp"
        var $cmp6=((($5))|0) >= ((($6))|0); //@line 191 "getopt.cpp"
        if ($cmp6) { __label__ = 6;break $if_then$$lor_lhs_false$2; } //@line 191 "getopt.cpp"
  
        var $7=$data_addr; //@line 191 "getopt.cpp"
        var $optind8=(($7+4)&4294967295); //@line 191 "getopt.cpp"
        var $8=HEAP32[(($optind8)>>2)]; //@line 191 "getopt.cpp"
        var $9=$argv_addr; //@line 191 "getopt.cpp"
        var $arrayidx=(($9+4*$8)&4294967295); //@line 191 "getopt.cpp"
        var $10=HEAP32[(($arrayidx)>>2)]; //@line 191 "getopt.cpp"
        var $cmp9=((($10))|0)==0; //@line 191 "getopt.cpp"
        if ($cmp9) { __label__ = 6;break $if_then$$lor_lhs_false$2; } //@line 191 "getopt.cpp"
  
        var $11=$data_addr; //@line 194 "getopt.cpp"
        var $optind10=(($11+4)&4294967295); //@line 194 "getopt.cpp"
        var $12=HEAP32[(($optind10)>>2)]; //@line 194 "getopt.cpp"
        var $13=$argv_addr; //@line 194 "getopt.cpp"
        var $arrayidx11=(($13+4*$12)&4294967295); //@line 194 "getopt.cpp"
        var $14=HEAP32[(($arrayidx11)>>2)]; //@line 194 "getopt.cpp"
        var $call=_strcmp($14, ((__str831)&4294967295)); //@line 194 "getopt.cpp"
        var $cmp12=((($call))|0)==0; //@line 194 "getopt.cpp"
        var $15=$data_addr; //@line 196 "getopt.cpp"
        var $optind14=(($15+4)&4294967295); //@line 196 "getopt.cpp"
        var $16=HEAP32[(($optind14)>>2)]; //@line 196 "getopt.cpp"
        if ($cmp12) { __label__ = 8;; } else { __label__ = 9;; } //@line 194 "getopt.cpp"
        if (__label__ == 8) {
  
          var $inc=((($16)+1)&4294967295); //@line 196 "getopt.cpp"
          HEAP32[(($optind14)>>2)]=$inc; //@line 196 "getopt.cpp"
          $retval=-1; //@line 197 "getopt.cpp"
          __label__ = 96;break $if_then$$lor_lhs_false$2; //@line 197 "getopt.cpp"
        }
        else if (__label__ == 9) {
  
          var $cmp17=((($16))|0)==0; //@line 201 "getopt.cpp"
          if ($cmp17) { __label__ = 10;; } else { __label__ = 11;; } //@line 201 "getopt.cpp"
          if (__label__ == 10) {
  
            var $17=$data_addr; //@line 202 "getopt.cpp"
            var $optwhere=(($17+16)&4294967295); //@line 202 "getopt.cpp"
            HEAP32[(($optwhere)>>2)]=1; //@line 202 "getopt.cpp"
            var $18=$data_addr; //@line 202 "getopt.cpp"
            var $optind19=(($18+4)&4294967295); //@line 202 "getopt.cpp"
            HEAP32[(($optind19)>>2)]=1; //@line 202 "getopt.cpp"
            ; //@line 202 "getopt.cpp"
          }
  
          var $19=$shortopts_addr; //@line 205 "getopt.cpp"
          var $cmp21=((($19))|0)!=0; //@line 205 "getopt.cpp"
          if ($cmp21) { __label__ = 12;; } else { __label__ = 15;; } //@line 205 "getopt.cpp"
          $land_lhs_true22$$if_else$16: do { 
            if (__label__ == 12) {
  
              var $20=$shortopts_addr; //@line 205 "getopt.cpp"
              var $21=HEAP8[($20)]; //@line 205 "getopt.cpp"
              var $conv=(tempInt=(($21)),(tempInt>=128?tempInt-256:tempInt)); //@line 205 "getopt.cpp"
              var $cmp23=((($conv))|0)==45; //@line 205 "getopt.cpp"
              if ($cmp23) { __label__ = 14;; } else { __label__ = 13;; } //@line 205 "getopt.cpp"
              if (__label__ == 13) {
  
                var $22=$shortopts_addr; //@line 205 "getopt.cpp"
                var $23=HEAP8[($22)]; //@line 205 "getopt.cpp"
                var $conv25=(tempInt=(($23)),(tempInt>=128?tempInt-256:tempInt)); //@line 205 "getopt.cpp"
                var $cmp26=((($conv25))|0)==43; //@line 205 "getopt.cpp"
                if (!($cmp26)) { __label__ = 15;break $land_lhs_true22$$if_else$16; } //@line 205 "getopt.cpp"
              }
  
              var $24=$shortopts_addr; //@line 207 "getopt.cpp"
              var $25=HEAP8[($24)]; //@line 207 "getopt.cpp"
              var $conv28=(tempInt=(($25)),(tempInt>=128?tempInt-256:tempInt)); //@line 207 "getopt.cpp"
              var $cmp29=((($conv28))|0)==45; //@line 207 "getopt.cpp"
              var $cond=($cmp29) ? 1 : 2; //@line 207 "getopt.cpp"
              $ordering=$cond; //@line 207 "getopt.cpp"
              var $26=$shortopts_addr; //@line 208 "getopt.cpp"
              var $incdec_ptr=(($26+1)&4294967295); //@line 208 "getopt.cpp"
              $shortopts_addr=$incdec_ptr; //@line 208 "getopt.cpp"
              __label__ = 16;break $land_lhs_true22$$if_else$16; //@line 209 "getopt.cpp"
            }
          } while(0);
          if (__label__ == 15) {
  
            var $call30=_getenv(((__str1832)&4294967295)); //@line 211 "getopt.cpp"
            var $cmp31=((($call30))|0)!=0; //@line 211 "getopt.cpp"
            var $cond32=($cmp31) ? 2 : 0; //@line 211 "getopt.cpp"
            $ordering=$cond32; //@line 211 "getopt.cpp"
            ;
          }
  
          var $27=$data_addr; //@line 217 "getopt.cpp"
          var $optwhere34=(($27+16)&4294967295); //@line 217 "getopt.cpp"
          var $28=HEAP32[(($optwhere34)>>2)]; //@line 217 "getopt.cpp"
          var $cmp35=((($28))|0)==1; //@line 217 "getopt.cpp"
          if ($cmp35) { __label__ = 17;; } else { __label__ = 28;; } //@line 217 "getopt.cpp"
          $if_then36$$if_end75$24: do { 
            if (__label__ == 17) {
  
              var $29=$ordering; //@line 219 "getopt.cpp"
              if ($29 == 2) {
                __label__ = 26;;
              }
              else if ($29 == 1) {
                __label__ = 24;;
              }
              else {
              __label__ = 18;;
              }
              
              if (__label__ == 18) {
  
                var $30=$data_addr; //@line 223 "getopt.cpp"
                var $optind37=(($30+4)&4294967295); //@line 223 "getopt.cpp"
                var $31=HEAP32[(($optind37)>>2)]; //@line 223 "getopt.cpp"
                $permute_from=$31; //@line 223 "getopt.cpp"
                $num_nonopts=0; //@line 224 "getopt.cpp"
                var $32=$data_addr; //@line 225 "getopt.cpp"
                var $optind381=(($32+4)&4294967295); //@line 225 "getopt.cpp"
                var $33=HEAP32[(($optind381)>>2)]; //@line 225 "getopt.cpp"
                var $34=$argv_addr; //@line 225 "getopt.cpp"
                var $arrayidx392=(($34+4*$33)&4294967295); //@line 225 "getopt.cpp"
                var $35=HEAP32[(($arrayidx392)>>2)]; //@line 225 "getopt.cpp"
                var $36=$only_addr; //@line 225 "getopt.cpp"
                var $call403=__ZL9is_optionPci($35, $36); //@line 225 "getopt.cpp"
                var $tobool4=((($call403))|0)!=0; //@line 225 "getopt.cpp"
                var $lnot5=($tobool4) ^ 1; //@line 225 "getopt.cpp"
                var $37=$data_addr; //@line 227 "getopt.cpp"
                var $optind416=(($37+4)&4294967295); //@line 227 "getopt.cpp"
                var $38=HEAP32[(($optind416)>>2)]; //@line 227 "getopt.cpp"
                if ($lnot5) { __lastLabel__ = 18; __label__ = 19;; } else { __lastLabel__ = 18; __label__ = 20;; } //@line 225 "getopt.cpp"
                $while_body$$while_end$28: do { 
                  if (__label__ == 19) {
                    while(1) { 
  
                      var $39=__lastLabel__ == 19 ? $47 : ($38);
                      var $optind417=__lastLabel__ == 19 ? $optind41 : ($optind416);
                      var $inc42=((($39)+1)&4294967295); //@line 227 "getopt.cpp"
                      HEAP32[(($optind417)>>2)]=$inc42; //@line 227 "getopt.cpp"
                      var $40=$num_nonopts; //@line 228 "getopt.cpp"
                      var $inc43=((($40)+1)&4294967295); //@line 228 "getopt.cpp"
                      $num_nonopts=$inc43; //@line 228 "getopt.cpp"
                      var $41=$data_addr; //@line 225 "getopt.cpp"
                      var $optind38=(($41+4)&4294967295); //@line 225 "getopt.cpp"
                      var $42=HEAP32[(($optind38)>>2)]; //@line 225 "getopt.cpp"
                      var $43=$argv_addr; //@line 225 "getopt.cpp"
                      var $arrayidx39=(($43+4*$42)&4294967295); //@line 225 "getopt.cpp"
                      var $44=HEAP32[(($arrayidx39)>>2)]; //@line 225 "getopt.cpp"
                      var $45=$only_addr; //@line 225 "getopt.cpp"
                      var $call40=__ZL9is_optionPci($44, $45); //@line 225 "getopt.cpp"
                      var $tobool=((($call40))|0)!=0; //@line 225 "getopt.cpp"
                      var $lnot=($tobool) ^ 1; //@line 225 "getopt.cpp"
                      var $46=$data_addr; //@line 227 "getopt.cpp"
                      var $optind41=(($46+4)&4294967295); //@line 227 "getopt.cpp"
                      var $47=HEAP32[(($optind41)>>2)]; //@line 227 "getopt.cpp"
                      if ($lnot) { __lastLabel__ = 19; __label__ = 19;continue ; } else { __lastLabel__ = 19; __label__ = 20;break $while_body$$while_end$28; } //@line 225 "getopt.cpp"
                    }
                  }
                } while(0);
  
                var $_lcssa=__lastLabel__ == 18 ? $38 : ($47);
                var $48=$argv_addr; //@line 230 "getopt.cpp"
                var $arrayidx45=(($48+4*$_lcssa)&4294967295); //@line 230 "getopt.cpp"
                var $49=HEAP32[(($arrayidx45)>>2)]; //@line 230 "getopt.cpp"
                var $cmp46=((($49))|0)==0; //@line 230 "getopt.cpp"
                if ($cmp46) { __label__ = 21;; } else { __label__ = 22;; } //@line 230 "getopt.cpp"
                if (__label__ == 21) {
  
                  var $50=$permute_from; //@line 233 "getopt.cpp"
                  var $51=$data_addr; //@line 233 "getopt.cpp"
                  var $optind48=(($51+4)&4294967295); //@line 233 "getopt.cpp"
                  HEAP32[(($optind48)>>2)]=$50; //@line 233 "getopt.cpp"
                  $retval=-1; //@line 234 "getopt.cpp"
                  __label__ = 96;break $if_then$$lor_lhs_false$2; //@line 234 "getopt.cpp"
                }
                else if (__label__ == 22) {
  
                  var $52=$data_addr; //@line 236 "getopt.cpp"
                  var $optind50=(($52+4)&4294967295); //@line 236 "getopt.cpp"
                  var $53=HEAP32[(($optind50)>>2)]; //@line 236 "getopt.cpp"
                  var $54=$argv_addr; //@line 236 "getopt.cpp"
                  var $arrayidx51=(($54+4*$53)&4294967295); //@line 236 "getopt.cpp"
                  var $55=HEAP32[(($arrayidx51)>>2)]; //@line 236 "getopt.cpp"
                  var $call52=_strcmp($55, ((__str831)&4294967295)); //@line 236 "getopt.cpp"
                  var $cmp53=((($call52))|0)==0; //@line 236 "getopt.cpp"
                  if (!($cmp53)) { __label__ = 28;break $if_then36$$if_end75$24; } //@line 236 "getopt.cpp"
  
                  var $56=$argv_addr; //@line 239 "getopt.cpp"
                  var $57=$permute_from; //@line 239 "getopt.cpp"
                  var $add_ptr=(($56+4*$57)&4294967295); //@line 239 "getopt.cpp"
                  var $58=$num_nonopts; //@line 239 "getopt.cpp"
                  __ZL7permutePKPcii($add_ptr, $58, 1); //@line 239 "getopt.cpp"
                  var $59=$permute_from; //@line 240 "getopt.cpp"
                  var $add=((($59)+1)&4294967295); //@line 240 "getopt.cpp"
                  var $60=$data_addr; //@line 240 "getopt.cpp"
                  var $optind55=(($60+4)&4294967295); //@line 240 "getopt.cpp"
                  HEAP32[(($optind55)>>2)]=$add; //@line 240 "getopt.cpp"
                  $retval=-1; //@line 241 "getopt.cpp"
                  __label__ = 96;break $if_then$$lor_lhs_false$2; //@line 241 "getopt.cpp"
                }
              }
              else if (__label__ == 26) {
  
                var $72=$data_addr; //@line 252 "getopt.cpp"
                var $optind69=(($72+4)&4294967295); //@line 252 "getopt.cpp"
                var $73=HEAP32[(($optind69)>>2)]; //@line 252 "getopt.cpp"
                var $74=$argv_addr; //@line 252 "getopt.cpp"
                var $arrayidx70=(($74+4*$73)&4294967295); //@line 252 "getopt.cpp"
                var $75=HEAP32[(($arrayidx70)>>2)]; //@line 252 "getopt.cpp"
                var $76=$only_addr; //@line 252 "getopt.cpp"
                var $call71=__ZL9is_optionPci($75, $76); //@line 252 "getopt.cpp"
                var $tobool72=((($call71))|0)!=0; //@line 252 "getopt.cpp"
                if ($tobool72) { __label__ = 28;break $if_then36$$if_end75$24; } //@line 252 "getopt.cpp"
  
                $retval=-1; //@line 253 "getopt.cpp"
                __label__ = 96;break $if_then$$lor_lhs_false$2; //@line 253 "getopt.cpp"
              }
              else if (__label__ == 24) {
  
                var $61=$data_addr; //@line 245 "getopt.cpp"
                var $optind59=(($61+4)&4294967295); //@line 245 "getopt.cpp"
                var $62=HEAP32[(($optind59)>>2)]; //@line 245 "getopt.cpp"
                var $63=$argv_addr; //@line 245 "getopt.cpp"
                var $arrayidx60=(($63+4*$62)&4294967295); //@line 245 "getopt.cpp"
                var $64=HEAP32[(($arrayidx60)>>2)]; //@line 245 "getopt.cpp"
                var $65=$only_addr; //@line 245 "getopt.cpp"
                var $call61=__ZL9is_optionPci($64, $65); //@line 245 "getopt.cpp"
                var $tobool62=((($call61))|0)!=0; //@line 245 "getopt.cpp"
                if ($tobool62) { __label__ = 28;break $if_then36$$if_end75$24; } //@line 245 "getopt.cpp"
  
                var $66=$data_addr; //@line 247 "getopt.cpp"
                var $optind64=(($66+4)&4294967295); //@line 247 "getopt.cpp"
                var $67=HEAP32[(($optind64)>>2)]; //@line 247 "getopt.cpp"
                var $inc65=((($67)+1)&4294967295); //@line 247 "getopt.cpp"
                HEAP32[(($optind64)>>2)]=$inc65; //@line 247 "getopt.cpp"
                var $68=$argv_addr; //@line 247 "getopt.cpp"
                var $arrayidx66=(($68+4*$67)&4294967295); //@line 247 "getopt.cpp"
                var $69=HEAP32[(($arrayidx66)>>2)]; //@line 247 "getopt.cpp"
                var $70=$data_addr; //@line 247 "getopt.cpp"
                var $optarg=(($70)&4294967295); //@line 247 "getopt.cpp"
                HEAP32[(($optarg)>>2)]=$69; //@line 247 "getopt.cpp"
                var $71=$data_addr; //@line 248 "getopt.cpp"
                var $optopt=(($71+12)&4294967295); //@line 248 "getopt.cpp"
                HEAP32[(($optopt)>>2)]=1; //@line 248 "getopt.cpp"
                $retval=1; //@line 248 "getopt.cpp"
                __label__ = 96;break $if_then$$lor_lhs_false$2; //@line 248 "getopt.cpp"
              }
            }
          } while(0);
  
          var $77=$longopts_addr; //@line 260 "getopt.cpp"
          var $cmp76=((($77))|0)!=0; //@line 260 "getopt.cpp"
          if ($cmp76) { __label__ = 29;; } else { __label__ = 52;; } //@line 260 "getopt.cpp"
          $land_lhs_true77$$if_end162$41: do { 
            if (__label__ == 29) {
  
              var $78=$data_addr; //@line 261 "getopt.cpp"
              var $optind78=(($78+4)&4294967295); //@line 261 "getopt.cpp"
              var $79=HEAP32[(($optind78)>>2)]; //@line 261 "getopt.cpp"
              var $80=$argv_addr; //@line 261 "getopt.cpp"
              var $arrayidx79=(($80+4*$79)&4294967295); //@line 261 "getopt.cpp"
              var $81=HEAP32[(($arrayidx79)>>2)]; //@line 261 "getopt.cpp"
              var $call80=_memcmp($81, ((__str831)&4294967295), 2); //@line 261 "getopt.cpp"
              var $cmp81=((($call80))|0)==0; //@line 261 "getopt.cpp"
              if ($cmp81) { __label__ = 32;; } else { __label__ = 30;; } //@line 261 "getopt.cpp"
              if (__label__ == 30) {
  
                var $82=$only_addr; //@line 261 "getopt.cpp"
                var $tobool83=((($82))|0)!=0; //@line 261 "getopt.cpp"
                if (!($tobool83)) { __label__ = 52;break $land_lhs_true77$$if_end162$41; } //@line 261 "getopt.cpp"
  
                var $83=$data_addr; //@line 261 "getopt.cpp"
                var $optind85=(($83+4)&4294967295); //@line 261 "getopt.cpp"
                var $84=HEAP32[(($optind85)>>2)]; //@line 261 "getopt.cpp"
                var $85=$argv_addr; //@line 261 "getopt.cpp"
                var $arrayidx86=(($85+4*$84)&4294967295); //@line 261 "getopt.cpp"
                var $86=HEAP32[(($arrayidx86)>>2)]; //@line 261 "getopt.cpp"
                var $arrayidx87=(($86)&4294967295); //@line 261 "getopt.cpp"
                var $87=HEAP8[($arrayidx87)]; //@line 261 "getopt.cpp"
                var $conv88=(tempInt=(($87)),(tempInt>=128?tempInt-256:tempInt)); //@line 261 "getopt.cpp"
                var $cmp89=((($conv88))|0)==43; //@line 261 "getopt.cpp"
                if (!($cmp89)) { __label__ = 52;break $land_lhs_true77$$if_end162$41; } //@line 261 "getopt.cpp"
              }
  
              var $88=$data_addr; //@line 261 "getopt.cpp"
              var $optwhere91=(($88+16)&4294967295); //@line 261 "getopt.cpp"
              var $89=HEAP32[(($optwhere91)>>2)]; //@line 261 "getopt.cpp"
              var $cmp92=((($89))|0)==1; //@line 261 "getopt.cpp"
              if (!($cmp92)) { __label__ = 52;break $land_lhs_true77$$if_end162$41; } //@line 261 "getopt.cpp"
  
              var $90=$data_addr; //@line 265 "getopt.cpp"
              var $optind94=(($90+4)&4294967295); //@line 265 "getopt.cpp"
              var $91=HEAP32[(($optind94)>>2)]; //@line 265 "getopt.cpp"
              var $92=$argv_addr; //@line 265 "getopt.cpp"
              var $arrayidx95=(($92+4*$91)&4294967295); //@line 265 "getopt.cpp"
              var $93=HEAP32[(($arrayidx95)>>2)]; //@line 265 "getopt.cpp"
              var $call96=_memcmp($93, ((__str831)&4294967295), 2); //@line 265 "getopt.cpp"
              var $cmp97=((($call96))|0)==0; //@line 265 "getopt.cpp"
              if ($cmp97) { __label__ = 34;; } else { __label__ = 35;; } //@line 265 "getopt.cpp"
              if (__label__ == 34) {
  
                var $94=$data_addr; //@line 266 "getopt.cpp"
                var $optwhere99=(($94+16)&4294967295); //@line 266 "getopt.cpp"
                HEAP32[(($optwhere99)>>2)]=2; //@line 266 "getopt.cpp"
                ; //@line 266 "getopt.cpp"
              }
  
              $longopt_match=-1; //@line 267 "getopt.cpp"
              var $95=$data_addr; //@line 268 "getopt.cpp"
              var $optind101=(($95+4)&4294967295); //@line 268 "getopt.cpp"
              var $96=HEAP32[(($optind101)>>2)]; //@line 268 "getopt.cpp"
              var $97=$argv_addr; //@line 268 "getopt.cpp"
              var $arrayidx102=(($97+4*$96)&4294967295); //@line 268 "getopt.cpp"
              var $98=HEAP32[(($arrayidx102)>>2)]; //@line 268 "getopt.cpp"
              var $99=$data_addr; //@line 268 "getopt.cpp"
              var $optwhere103=(($99+16)&4294967295); //@line 268 "getopt.cpp"
              var $100=HEAP32[(($optwhere103)>>2)]; //@line 268 "getopt.cpp"
              var $add_ptr104=(($98+$100)&4294967295); //@line 268 "getopt.cpp"
              var $call105=_strchr($add_ptr104, 61); //@line 268 "getopt.cpp"
              $possible_arg=$call105; //@line 268 "getopt.cpp"
              var $cmp106=((($call105))|0)==0; //@line 269 "getopt.cpp"
              if ($cmp106) { __label__ = 36;; } else { __label__ = 37;; } //@line 269 "getopt.cpp"
              if (__label__ == 36) {
  
                var $101=$data_addr; //@line 272 "getopt.cpp"
                var $optind108=(($101+4)&4294967295); //@line 272 "getopt.cpp"
                var $102=HEAP32[(($optind108)>>2)]; //@line 272 "getopt.cpp"
                var $103=$argv_addr; //@line 272 "getopt.cpp"
                var $arrayidx109=(($103+4*$102)&4294967295); //@line 272 "getopt.cpp"
                var $104=HEAP32[(($arrayidx109)>>2)]; //@line 272 "getopt.cpp"
                var $call110=_strlen($104); //@line 272 "getopt.cpp"
                $match_chars=$call110; //@line 272 "getopt.cpp"
                var $105=$data_addr; //@line 273 "getopt.cpp"
                var $optind111=(($105+4)&4294967295); //@line 273 "getopt.cpp"
                var $106=HEAP32[(($optind111)>>2)]; //@line 273 "getopt.cpp"
                var $107=$argv_addr; //@line 273 "getopt.cpp"
                var $arrayidx112=(($107+4*$106)&4294967295); //@line 273 "getopt.cpp"
                var $108=HEAP32[(($arrayidx112)>>2)]; //@line 273 "getopt.cpp"
                var $109=$match_chars; //@line 273 "getopt.cpp"
                var $add_ptr113=(($108+$109)&4294967295); //@line 273 "getopt.cpp"
                $possible_arg=$add_ptr113; //@line 273 "getopt.cpp"
                var $110=$match_chars; //@line 274 "getopt.cpp"
                var $111=$data_addr; //@line 274 "getopt.cpp"
                var $optwhere114=(($111+16)&4294967295); //@line 274 "getopt.cpp"
                var $112=HEAP32[(($optwhere114)>>2)]; //@line 274 "getopt.cpp"
                var $sub=((($110)-($112))&4294967295); //@line 274 "getopt.cpp"
                $match_chars=$sub; //@line 274 "getopt.cpp"
                ; //@line 275 "getopt.cpp"
              }
              else if (__label__ == 37) {
  
                var $113=$possible_arg; //@line 277 "getopt.cpp"
                var $114=$data_addr; //@line 277 "getopt.cpp"
                var $optind116=(($114+4)&4294967295); //@line 277 "getopt.cpp"
                var $115=HEAP32[(($optind116)>>2)]; //@line 277 "getopt.cpp"
                var $116=$argv_addr; //@line 277 "getopt.cpp"
                var $arrayidx117=(($116+4*$115)&4294967295); //@line 277 "getopt.cpp"
                var $117=HEAP32[(($arrayidx117)>>2)]; //@line 277 "getopt.cpp"
                var $sub_ptr_lhs_cast=($113); //@line 277 "getopt.cpp"
                var $sub_ptr_rhs_cast=($117); //@line 277 "getopt.cpp"
                var $sub_ptr_rhs_cast_neg=(((-($sub_ptr_rhs_cast)))&4294967295);
                var $118=$data_addr; //@line 277 "getopt.cpp"
                var $optwhere118=(($118+16)&4294967295); //@line 277 "getopt.cpp"
                var $119=HEAP32[(($optwhere118)>>2)]; //@line 277 "getopt.cpp"
                var $_neg=(((-($119)))&4294967295);
                var $sub_ptr_sub=((($sub_ptr_rhs_cast_neg)+($sub_ptr_lhs_cast))&4294967295); //@line 277 "getopt.cpp"
                var $sub119=((($sub_ptr_sub)+($_neg))&4294967295); //@line 277 "getopt.cpp"
                $match_chars=$sub119; //@line 277 "getopt.cpp"
                ;
              }
  
              $optindex=0; //@line 278 "getopt.cpp"
              ; //@line 278 "getopt.cpp"
              while(1) { 
  
                var $120=$optindex; //@line 278 "getopt.cpp"
                var $121=$longopts_addr; //@line 278 "getopt.cpp"
                var $arrayidx121=(($121+16*$120)&4294967295); //@line 278 "getopt.cpp"
                var $name=(($arrayidx121)&4294967295); //@line 278 "getopt.cpp"
                var $122=HEAP32[(($name)>>2)]; //@line 278 "getopt.cpp"
                var $cmp122=((($122))|0)!=0; //@line 278 "getopt.cpp"
                if (!($cmp122)) { __label__ = 49;break ; } //@line 278 "getopt.cpp"
  
                var $123=$data_addr; //@line 280 "getopt.cpp"
                var $optind123=(($123+4)&4294967295); //@line 280 "getopt.cpp"
                var $124=HEAP32[(($optind123)>>2)]; //@line 280 "getopt.cpp"
                var $125=$argv_addr; //@line 280 "getopt.cpp"
                var $arrayidx124=(($125+4*$124)&4294967295); //@line 280 "getopt.cpp"
                var $126=HEAP32[(($arrayidx124)>>2)]; //@line 280 "getopt.cpp"
                var $127=$data_addr; //@line 280 "getopt.cpp"
                var $optwhere125=(($127+16)&4294967295); //@line 280 "getopt.cpp"
                var $128=HEAP32[(($optwhere125)>>2)]; //@line 280 "getopt.cpp"
                var $add_ptr126=(($126+$128)&4294967295); //@line 280 "getopt.cpp"
                var $129=$optindex; //@line 280 "getopt.cpp"
                var $130=$longopts_addr; //@line 280 "getopt.cpp"
                var $arrayidx127=(($130+16*$129)&4294967295); //@line 280 "getopt.cpp"
                var $name128=(($arrayidx127)&4294967295); //@line 280 "getopt.cpp"
                var $131=HEAP32[(($name128)>>2)]; //@line 280 "getopt.cpp"
                var $132=$match_chars; //@line 280 "getopt.cpp"
                var $call129=_memcmp($add_ptr126, $131, $132); //@line 280 "getopt.cpp"
                var $cmp130=((($call129))|0)==0; //@line 280 "getopt.cpp"
                if ($cmp130) { __label__ = 41;; } else { __label__ = 48;; } //@line 280 "getopt.cpp"
                if (__label__ == 41) {
  
                  var $133=$match_chars; //@line 285 "getopt.cpp"
                  var $134=$optindex; //@line 285 "getopt.cpp"
                  var $135=$longopts_addr; //@line 285 "getopt.cpp"
                  var $arrayidx132=(($135+16*$134)&4294967295); //@line 285 "getopt.cpp"
                  var $name133=(($arrayidx132)&4294967295); //@line 285 "getopt.cpp"
                  var $136=HEAP32[(($name133)>>2)]; //@line 285 "getopt.cpp"
                  var $call134=_strlen($136); //@line 285 "getopt.cpp"
                  var $cmp135=((($133))|0)==((($call134))|0); //@line 285 "getopt.cpp"
                  if ($cmp135) { __label__ = 42;break ; } //@line 285 "getopt.cpp"
  
                  var $138=$longopt_match; //@line 293 "getopt.cpp"
                  var $cmp138=((($138))|0) < 0; //@line 293 "getopt.cpp"
                  if (!($cmp138)) { __label__ = 45;break ; } //@line 293 "getopt.cpp"
  
                  var $139=$optindex; //@line 294 "getopt.cpp"
                  $longopt_match=$139; //@line 294 "getopt.cpp"
                  ; //@line 308 "getopt.cpp"
                }
  
                var $157=$optindex; //@line 278 "getopt.cpp"
                var $inc156=((($157)+1)&4294967295); //@line 278 "getopt.cpp"
                $optindex=$inc156; //@line 278 "getopt.cpp"
                __label__ = 39;continue ; //@line 278 "getopt.cpp"
              }
              if (__label__ == 49) {
  
                var $_pr=$longopt_match; //@line 310 "getopt.cpp"
                __lastLabel__ = 49; ;
              }
              else if (__label__ == 42) {
  
                var $137=$optindex; //@line 287 "getopt.cpp"
                $longopt_match=$137; //@line 287 "getopt.cpp"
                __lastLabel__ = 42; ; //@line 288 "getopt.cpp"
              }
              else if (__label__ == 45) {
  
                var $140=$data_addr; //@line 298 "getopt.cpp"
                var $opterr=(($140+8)&4294967295); //@line 298 "getopt.cpp"
                var $141=HEAP32[(($opterr)>>2)]; //@line 298 "getopt.cpp"
                var $tobool141=((($141))|0)!=0; //@line 298 "getopt.cpp"
                if ($tobool141) { __label__ = 46;; } else { __label__ = 47;; } //@line 298 "getopt.cpp"
                if (__label__ == 46) {
  
                  var $142=HEAP32[((__impure_ptr)>>2)]; //@line 299 "getopt.cpp"
                  var $_stderr=(($142+12)&4294967295); //@line 299 "getopt.cpp"
                  var $143=HEAP32[(($_stderr)>>2)]; //@line 299 "getopt.cpp"
                  var $144=$argv_addr; //@line 299 "getopt.cpp"
                  var $arrayidx143=(($144)&4294967295); //@line 299 "getopt.cpp"
                  var $145=HEAP32[(($arrayidx143)>>2)]; //@line 299 "getopt.cpp"
                  var $146=$data_addr; //@line 299 "getopt.cpp"
                  var $optind144=(($146+4)&4294967295); //@line 299 "getopt.cpp"
                  var $147=HEAP32[(($optind144)>>2)]; //@line 299 "getopt.cpp"
                  var $148=$argv_addr; //@line 299 "getopt.cpp"
                  var $arrayidx145=(($148+4*$147)&4294967295); //@line 299 "getopt.cpp"
                  var $149=HEAP32[(($arrayidx145)>>2)]; //@line 299 "getopt.cpp"
                  var $150=$longopt_match; //@line 299 "getopt.cpp"
                  var $151=$longopts_addr; //@line 299 "getopt.cpp"
                  var $arrayidx146=(($151+16*$150)&4294967295); //@line 299 "getopt.cpp"
                  var $name147=(($arrayidx146)&4294967295); //@line 299 "getopt.cpp"
                  var $152=HEAP32[(($name147)>>2)]; //@line 299 "getopt.cpp"
                  var $153=$optindex; //@line 299 "getopt.cpp"
                  var $154=$longopts_addr; //@line 299 "getopt.cpp"
                  var $arrayidx148=(($154+16*$153)&4294967295); //@line 299 "getopt.cpp"
                  var $name149=(($arrayidx148)&4294967295); //@line 299 "getopt.cpp"
                  var $155=HEAP32[(($name149)>>2)]; //@line 299 "getopt.cpp"
                  var $call150=_fprintf($143, ((__str2833)&4294967295), allocate([$145,0,0,0,$149,0,0,0,$152,0,0,0,$155,0,0,0], ["i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 299 "getopt.cpp"
                  ; //@line 299 "getopt.cpp"
                }
  
                var $156=$data_addr; //@line 305 "getopt.cpp"
                var $optopt152=(($156+12)&4294967295); //@line 305 "getopt.cpp"
                HEAP32[(($optopt152)>>2)]=63; //@line 305 "getopt.cpp"
                $retval=63; //@line 305 "getopt.cpp"
                __label__ = 96;break $if_then$$lor_lhs_false$2; //@line 305 "getopt.cpp"
              }
  
              var $158=__lastLabel__ == 49 ? $_pr : ($137); //@line 310 "getopt.cpp"
              var $cmp157=((($158))|0) >= 0; //@line 310 "getopt.cpp"
              if (!($cmp157)) { __label__ = 52;break $land_lhs_true77$$if_end162$41; } //@line 310 "getopt.cpp"
  
              var $159=$longopt_match; //@line 311 "getopt.cpp"
              var $160=$longopts_addr; //@line 311 "getopt.cpp"
              var $arrayidx159=(($160+16*$159)&4294967295); //@line 311 "getopt.cpp"
              var $has_arg160=(($arrayidx159+4)&4294967295); //@line 311 "getopt.cpp"
              var $161=HEAP32[(($has_arg160)>>2)]; //@line 311 "getopt.cpp"
              $has_arg=$161; //@line 311 "getopt.cpp"
              ; //@line 311 "getopt.cpp"
            }
          } while(0);
  
          var $162=$longopt_match; //@line 315 "getopt.cpp"
          var $cmp163=((($162))|0) < 0; //@line 315 "getopt.cpp"
          if ($cmp163) { __label__ = 53;; } else { __label__ = 63;; } //@line 315 "getopt.cpp"
          $land_lhs_true164$$if_end217$73: do { 
            if (__label__ == 53) {
  
              var $163=$shortopts_addr; //@line 315 "getopt.cpp"
              var $cmp165=((($163))|0)!=0; //@line 315 "getopt.cpp"
              if (!($cmp165)) { __label__ = 63;break $land_lhs_true164$$if_end217$73; } //@line 315 "getopt.cpp"
  
              var $164=$shortopts_addr; //@line 317 "getopt.cpp"
              var $165=$data_addr; //@line 317 "getopt.cpp"
              var $optwhere167=(($165+16)&4294967295); //@line 317 "getopt.cpp"
              var $166=HEAP32[(($optwhere167)>>2)]; //@line 317 "getopt.cpp"
              var $167=$data_addr; //@line 317 "getopt.cpp"
              var $optind168=(($167+4)&4294967295); //@line 317 "getopt.cpp"
              var $168=HEAP32[(($optind168)>>2)]; //@line 317 "getopt.cpp"
              var $169=$argv_addr; //@line 317 "getopt.cpp"
              var $arrayidx169=(($169+4*$168)&4294967295); //@line 317 "getopt.cpp"
              var $170=HEAP32[(($arrayidx169)>>2)]; //@line 317 "getopt.cpp"
              var $arrayidx170=(($170+$166)&4294967295); //@line 317 "getopt.cpp"
              var $171=HEAP8[($arrayidx170)]; //@line 317 "getopt.cpp"
              var $conv171=(tempInt=(($171)),(tempInt>=128?tempInt-256:tempInt)); //@line 317 "getopt.cpp"
              var $call172=_strchr($164, $conv171); //@line 317 "getopt.cpp"
              $cp=$call172; //@line 317 "getopt.cpp"
              var $172=$cp; //@line 318 "getopt.cpp"
              var $cmp173=((($172))|0)==0; //@line 318 "getopt.cpp"
              if ($cmp173) { __label__ = 55;; } else { __label__ = 60;; } //@line 318 "getopt.cpp"
              if (__label__ == 55) {
  
                var $173=$data_addr; //@line 321 "getopt.cpp"
                var $opterr175=(($173+8)&4294967295); //@line 321 "getopt.cpp"
                var $174=HEAP32[(($opterr175)>>2)]; //@line 321 "getopt.cpp"
                var $tobool176=((($174))|0)!=0; //@line 321 "getopt.cpp"
                if ($tobool176) { __label__ = 56;; } else { __label__ = 57;; } //@line 321 "getopt.cpp"
                if (__label__ == 56) {
  
                  var $175=HEAP32[((__impure_ptr)>>2)]; //@line 322 "getopt.cpp"
                  var $_stderr178=(($175+12)&4294967295); //@line 322 "getopt.cpp"
                  var $176=HEAP32[(($_stderr178)>>2)]; //@line 322 "getopt.cpp"
                  var $177=$argv_addr; //@line 322 "getopt.cpp"
                  var $arrayidx179=(($177)&4294967295); //@line 322 "getopt.cpp"
                  var $178=HEAP32[(($arrayidx179)>>2)]; //@line 322 "getopt.cpp"
                  var $179=$data_addr; //@line 322 "getopt.cpp"
                  var $optwhere180=(($179+16)&4294967295); //@line 322 "getopt.cpp"
                  var $180=HEAP32[(($optwhere180)>>2)]; //@line 322 "getopt.cpp"
                  var $181=$data_addr; //@line 322 "getopt.cpp"
                  var $optind181=(($181+4)&4294967295); //@line 322 "getopt.cpp"
                  var $182=HEAP32[(($optind181)>>2)]; //@line 322 "getopt.cpp"
                  var $183=$argv_addr; //@line 322 "getopt.cpp"
                  var $arrayidx182=(($183+4*$182)&4294967295); //@line 322 "getopt.cpp"
                  var $184=HEAP32[(($arrayidx182)>>2)]; //@line 322 "getopt.cpp"
                  var $arrayidx183=(($184+$180)&4294967295); //@line 322 "getopt.cpp"
                  var $185=HEAP8[($arrayidx183)]; //@line 322 "getopt.cpp"
                  var $conv184=(tempInt=(($185)),(tempInt>=128?tempInt-256:tempInt)); //@line 322 "getopt.cpp"
                  var $call185=_fprintf($176, ((__str3834)&4294967295), allocate([$178,0,0,0,$conv184,0,0,0], ["i8*",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 322 "getopt.cpp"
                  ; //@line 322 "getopt.cpp"
                }
  
                var $186=$data_addr; //@line 325 "getopt.cpp"
                var $optwhere187=(($186+16)&4294967295); //@line 325 "getopt.cpp"
                var $187=HEAP32[(($optwhere187)>>2)]; //@line 325 "getopt.cpp"
                var $inc188=((($187)+1)&4294967295); //@line 325 "getopt.cpp"
                HEAP32[(($optwhere187)>>2)]=$inc188; //@line 325 "getopt.cpp"
                var $188=$data_addr; //@line 326 "getopt.cpp"
                var $optwhere189=(($188+16)&4294967295); //@line 326 "getopt.cpp"
                var $189=HEAP32[(($optwhere189)>>2)]; //@line 326 "getopt.cpp"
                var $190=$data_addr; //@line 326 "getopt.cpp"
                var $optind190=(($190+4)&4294967295); //@line 326 "getopt.cpp"
                var $191=HEAP32[(($optind190)>>2)]; //@line 326 "getopt.cpp"
                var $192=$argv_addr; //@line 326 "getopt.cpp"
                var $arrayidx191=(($192+4*$191)&4294967295); //@line 326 "getopt.cpp"
                var $193=HEAP32[(($arrayidx191)>>2)]; //@line 326 "getopt.cpp"
                var $arrayidx192=(($193+$189)&4294967295); //@line 326 "getopt.cpp"
                var $194=HEAP8[($arrayidx192)]; //@line 326 "getopt.cpp"
                var $conv193=(tempInt=(($194)),(tempInt>=128?tempInt-256:tempInt)); //@line 326 "getopt.cpp"
                var $cmp194=((($conv193))|0)==0; //@line 326 "getopt.cpp"
                if ($cmp194) { __label__ = 58;; } else { __label__ = 59;; } //@line 326 "getopt.cpp"
                if (__label__ == 58) {
  
                  var $195=$data_addr; //@line 328 "getopt.cpp"
                  var $optind196=(($195+4)&4294967295); //@line 328 "getopt.cpp"
                  var $196=HEAP32[(($optind196)>>2)]; //@line 328 "getopt.cpp"
                  var $inc197=((($196)+1)&4294967295); //@line 328 "getopt.cpp"
                  HEAP32[(($optind196)>>2)]=$inc197; //@line 328 "getopt.cpp"
                  var $197=$data_addr; //@line 329 "getopt.cpp"
                  var $optwhere198=(($197+16)&4294967295); //@line 329 "getopt.cpp"
                  HEAP32[(($optwhere198)>>2)]=1; //@line 329 "getopt.cpp"
                  ; //@line 330 "getopt.cpp"
                }
  
                var $198=$data_addr; //@line 331 "getopt.cpp"
                var $optopt200=(($198+12)&4294967295); //@line 331 "getopt.cpp"
                HEAP32[(($optopt200)>>2)]=63; //@line 331 "getopt.cpp"
                $retval=63; //@line 331 "getopt.cpp"
                __label__ = 96;break $if_then$$lor_lhs_false$2; //@line 331 "getopt.cpp"
              }
              else if (__label__ == 60) {
  
                var $199=$cp; //@line 333 "getopt.cpp"
                var $arrayidx202=(($199+1)&4294967295); //@line 333 "getopt.cpp"
                var $200=HEAP8[($arrayidx202)]; //@line 333 "getopt.cpp"
                var $conv203=(tempInt=(($200)),(tempInt>=128?tempInt-256:tempInt)); //@line 333 "getopt.cpp"
                var $cmp204=((($conv203))|0)==58; //@line 333 "getopt.cpp"
                if ($cmp204) { __lastLabel__ = 60; __label__ = 61;; } else { __lastLabel__ = 60; __label__ = 62;; } //@line 333 "getopt.cpp"
                if (__label__ == 61) {
  
                  var $201=$cp; //@line 333 "getopt.cpp"
                  var $arrayidx205=(($201+2)&4294967295); //@line 333 "getopt.cpp"
                  var $202=HEAP8[($arrayidx205)]; //@line 333 "getopt.cpp"
                  var $conv206=(tempInt=(($202)),(tempInt>=128?tempInt-256:tempInt)); //@line 333 "getopt.cpp"
                  var $cmp207=((($conv206))|0)==58; //@line 333 "getopt.cpp"
                  var $cond208=($cmp207) ? 2 : 1; //@line 333 "getopt.cpp"
                  __lastLabel__ = 61; ; //@line 333 "getopt.cpp"
                }
  
                var $cond209=__lastLabel__ == 61 ? $cond208 : (0); //@line 333 "getopt.cpp"
                $has_arg=$cond209; //@line 333 "getopt.cpp"
                var $203=$data_addr; //@line 335 "getopt.cpp"
                var $optind210=(($203+4)&4294967295); //@line 335 "getopt.cpp"
                var $204=HEAP32[(($optind210)>>2)]; //@line 335 "getopt.cpp"
                var $205=$argv_addr; //@line 335 "getopt.cpp"
                var $arrayidx211=(($205+4*$204)&4294967295); //@line 335 "getopt.cpp"
                var $206=HEAP32[(($arrayidx211)>>2)]; //@line 335 "getopt.cpp"
                var $207=$data_addr; //@line 335 "getopt.cpp"
                var $optwhere212=(($207+16)&4294967295); //@line 335 "getopt.cpp"
                var $208=HEAP32[(($optwhere212)>>2)]; //@line 335 "getopt.cpp"
                var $add_ptr213=(($206+$208)&4294967295); //@line 335 "getopt.cpp"
                var $add_ptr214=(($add_ptr213+1)&4294967295); //@line 335 "getopt.cpp"
                $possible_arg=$add_ptr214; //@line 335 "getopt.cpp"
                var $209=$cp; //@line 336 "getopt.cpp"
                var $210=HEAP8[($209)]; //@line 336 "getopt.cpp"
                var $conv215=(tempInt=(($210)),(tempInt>=128?tempInt-256:tempInt)); //@line 336 "getopt.cpp"
                var $211=$data_addr; //@line 336 "getopt.cpp"
                var $optopt216=(($211+12)&4294967295); //@line 336 "getopt.cpp"
                HEAP32[(($optopt216)>>2)]=$conv215; //@line 336 "getopt.cpp"
                ; //@line 337 "getopt.cpp"
              }
            }
          } while(0);
  
          $arg_next=0; //@line 340 "getopt.cpp"
          var $212=$has_arg; //@line 341 "getopt.cpp"
          if ($212 == 2) {
            __label__ = 64;;
          }
          else if ($212 == 1) {
            __label__ = 67;;
          }
          else {
          __label__ = 78;;
          }
          
          if (__label__ == 78) {
  
            var $254=$longopt_match; //@line 379 "getopt.cpp"
            var $cmp279=((($254))|0) < 0; //@line 379 "getopt.cpp"
            var $255=$data_addr; //@line 381 "getopt.cpp"
            var $optwhere281=(($255+16)&4294967295); //@line 381 "getopt.cpp"
            if ($cmp279) { __label__ = 79;; } else { __label__ = 81;; } //@line 379 "getopt.cpp"
            $if_then280$$if_else292$91: do { 
              if (__label__ == 79) {
  
                var $256=HEAP32[(($optwhere281)>>2)]; //@line 381 "getopt.cpp"
                var $inc282=((($256)+1)&4294967295); //@line 381 "getopt.cpp"
                HEAP32[(($optwhere281)>>2)]=$inc282; //@line 381 "getopt.cpp"
                var $257=$data_addr; //@line 382 "getopt.cpp"
                var $optwhere283=(($257+16)&4294967295); //@line 382 "getopt.cpp"
                var $258=HEAP32[(($optwhere283)>>2)]; //@line 382 "getopt.cpp"
                var $259=$data_addr; //@line 382 "getopt.cpp"
                var $optind284=(($259+4)&4294967295); //@line 382 "getopt.cpp"
                var $260=HEAP32[(($optind284)>>2)]; //@line 382 "getopt.cpp"
                var $261=$argv_addr; //@line 382 "getopt.cpp"
                var $arrayidx285=(($261+4*$260)&4294967295); //@line 382 "getopt.cpp"
                var $262=HEAP32[(($arrayidx285)>>2)]; //@line 382 "getopt.cpp"
                var $arrayidx286=(($262+$258)&4294967295); //@line 382 "getopt.cpp"
                var $263=HEAP8[($arrayidx286)]; //@line 382 "getopt.cpp"
                var $conv287=(tempInt=(($263)),(tempInt>=128?tempInt-256:tempInt)); //@line 382 "getopt.cpp"
                var $cmp288=((($conv287))|0)==0; //@line 382 "getopt.cpp"
                if (!($cmp288)) { __label__ = 82;break $if_then280$$if_else292$91; } //@line 382 "getopt.cpp"
  
                var $264=$data_addr; //@line 383 "getopt.cpp"
                var $optwhere290=(($264+16)&4294967295); //@line 383 "getopt.cpp"
                HEAP32[(($optwhere290)>>2)]=1; //@line 383 "getopt.cpp"
                ; //@line 383 "getopt.cpp"
              }
              else if (__label__ == 81) {
  
                HEAP32[(($optwhere281)>>2)]=1; //@line 386 "getopt.cpp"
                ;
              }
            } while(0);
  
            var $265=$data_addr; //@line 387 "getopt.cpp"
            var $optarg295=(($265)&4294967295); //@line 387 "getopt.cpp"
            HEAP32[(($optarg295)>>2)]=0; //@line 387 "getopt.cpp"
            ; //@line 388 "getopt.cpp"
          }
          else if (__label__ == 64) {
  
            var $213=$possible_arg; //@line 344 "getopt.cpp"
            var $214=HEAP8[($213)]; //@line 344 "getopt.cpp"
            var $conv219=(tempInt=(($214)),(tempInt>=128?tempInt-256:tempInt)); //@line 344 "getopt.cpp"
            var $cmp220=((($conv219))|0)==61; //@line 344 "getopt.cpp"
            if ($cmp220) { __label__ = 65;; } else { __label__ = 66;; } //@line 344 "getopt.cpp"
            if (__label__ == 65) {
  
              var $215=$possible_arg; //@line 345 "getopt.cpp"
              var $incdec_ptr222=(($215+1)&4294967295); //@line 345 "getopt.cpp"
              $possible_arg=$incdec_ptr222; //@line 345 "getopt.cpp"
              ; //@line 345 "getopt.cpp"
            }
  
            var $216=$possible_arg; //@line 346 "getopt.cpp"
            var $217=HEAP8[($216)]; //@line 346 "getopt.cpp"
            var $conv224=(tempInt=(($217)),(tempInt>=128?tempInt-256:tempInt)); //@line 346 "getopt.cpp"
            var $cmp225=((($conv224))|0)!=0; //@line 346 "getopt.cpp"
            var $218=$possible_arg; //@line 346 "getopt.cpp"
            var $cond229=($cmp225) ? ($218) : 0; //@line 346 "getopt.cpp"
            var $219=$data_addr; //@line 346 "getopt.cpp"
            var $optarg230=(($219)&4294967295); //@line 346 "getopt.cpp"
            HEAP32[(($optarg230)>>2)]=$cond229; //@line 346 "getopt.cpp"
            var $220=$data_addr; //@line 347 "getopt.cpp"
            var $optwhere231=(($220+16)&4294967295); //@line 347 "getopt.cpp"
            HEAP32[(($optwhere231)>>2)]=1; //@line 347 "getopt.cpp"
            ; //@line 348 "getopt.cpp"
          }
          else if (__label__ == 67) {
  
            var $221=$possible_arg; //@line 350 "getopt.cpp"
            var $222=HEAP8[($221)]; //@line 350 "getopt.cpp"
            var $conv233=(tempInt=(($222)),(tempInt>=128?tempInt-256:tempInt)); //@line 350 "getopt.cpp"
            var $cmp234=((($conv233))|0)==61; //@line 350 "getopt.cpp"
            if ($cmp234) { __label__ = 68;; } else { __label__ = 69;; } //@line 350 "getopt.cpp"
            if (__label__ == 68) {
  
              var $223=$possible_arg; //@line 351 "getopt.cpp"
              var $incdec_ptr236=(($223+1)&4294967295); //@line 351 "getopt.cpp"
              $possible_arg=$incdec_ptr236; //@line 351 "getopt.cpp"
              ; //@line 351 "getopt.cpp"
            }
  
            var $224=$possible_arg; //@line 352 "getopt.cpp"
            var $225=HEAP8[($224)]; //@line 352 "getopt.cpp"
            var $conv238=(tempInt=(($225)),(tempInt>=128?tempInt-256:tempInt)); //@line 352 "getopt.cpp"
            var $cmp239=((($conv238))|0)!=0; //@line 352 "getopt.cpp"
            if ($cmp239) { __label__ = 70;; } else { __label__ = 71;; } //@line 352 "getopt.cpp"
            if (__label__ == 70) {
  
              var $226=$possible_arg; //@line 354 "getopt.cpp"
              var $227=$data_addr; //@line 354 "getopt.cpp"
              var $optarg241=(($227)&4294967295); //@line 354 "getopt.cpp"
              HEAP32[(($optarg241)>>2)]=$226; //@line 354 "getopt.cpp"
              var $228=$data_addr; //@line 355 "getopt.cpp"
              var $optwhere242=(($228+16)&4294967295); //@line 355 "getopt.cpp"
              HEAP32[(($optwhere242)>>2)]=1; //@line 355 "getopt.cpp"
              ; //@line 356 "getopt.cpp"
            }
            else if (__label__ == 71) {
  
              var $229=$data_addr; //@line 357 "getopt.cpp"
              var $optind244=(($229+4)&4294967295); //@line 357 "getopt.cpp"
              var $230=HEAP32[(($optind244)>>2)]; //@line 357 "getopt.cpp"
              var $add245=((($230)+1)&4294967295); //@line 357 "getopt.cpp"
              var $231=$argc_addr; //@line 357 "getopt.cpp"
              var $cmp246=((($add245))|0) >= ((($231))|0); //@line 357 "getopt.cpp"
              var $232=$data_addr; //@line 359 "getopt.cpp"
              if ($cmp246) { __label__ = 72;; } else { __label__ = 77;; } //@line 357 "getopt.cpp"
              if (__label__ == 72) {
  
                var $opterr248=(($232+8)&4294967295); //@line 359 "getopt.cpp"
                var $233=HEAP32[(($opterr248)>>2)]; //@line 359 "getopt.cpp"
                var $tobool249=((($233))|0)!=0; //@line 359 "getopt.cpp"
                if ($tobool249) { __label__ = 73;; } else { __label__ = 76;; } //@line 359 "getopt.cpp"
                if (__label__ == 73) {
  
                  var $234=HEAP32[((__impure_ptr)>>2)]; //@line 361 "getopt.cpp"
                  var $_stderr251=(($234+12)&4294967295); //@line 361 "getopt.cpp"
                  var $235=HEAP32[(($_stderr251)>>2)]; //@line 361 "getopt.cpp"
                  var $236=$argv_addr; //@line 361 "getopt.cpp"
                  var $arrayidx252=(($236)&4294967295); //@line 361 "getopt.cpp"
                  var $237=HEAP32[(($arrayidx252)>>2)]; //@line 361 "getopt.cpp"
                  var $call253=_fprintf($235, ((__str4835)&4294967295), allocate([$237,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 361 "getopt.cpp"
                  var $238=$longopt_match; //@line 362 "getopt.cpp"
                  var $cmp254=((($238))|0) >= 0; //@line 362 "getopt.cpp"
                  var $239=HEAP32[((__impure_ptr)>>2)]; //@line 363 "getopt.cpp"
                  var $_stderr256=(($239+12)&4294967295); //@line 363 "getopt.cpp"
                  var $240=HEAP32[(($_stderr256)>>2)]; //@line 363 "getopt.cpp"
                  if ($cmp254) { __label__ = 74;; } else { __label__ = 75;; } //@line 362 "getopt.cpp"
                  if (__label__ == 74) {
  
                    var $241=$longopt_match; //@line 363 "getopt.cpp"
                    var $242=$longopts_addr; //@line 363 "getopt.cpp"
                    var $arrayidx257=(($242+16*$241)&4294967295); //@line 363 "getopt.cpp"
                    var $name258=(($arrayidx257)&4294967295); //@line 363 "getopt.cpp"
                    var $243=HEAP32[(($name258)>>2)]; //@line 363 "getopt.cpp"
                    var $call259=_fprintf($240, ((__str5836)&4294967295), allocate([$243,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 363 "getopt.cpp"
                    ; //@line 363 "getopt.cpp"
                  }
                  else if (__label__ == 75) {
  
                    var $244=$cp; //@line 365 "getopt.cpp"
                    var $245=HEAP8[($244)]; //@line 365 "getopt.cpp"
                    var $conv262=(tempInt=(($245)),(tempInt>=128?tempInt-256:tempInt)); //@line 365 "getopt.cpp"
                    var $call263=_fprintf($240, ((__str6837)&4294967295), allocate([$conv262,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 365 "getopt.cpp"
                    ;
                  }
                }
  
                var $246=$data_addr; //@line 367 "getopt.cpp"
                var $optind266=(($246+4)&4294967295); //@line 367 "getopt.cpp"
                var $247=HEAP32[(($optind266)>>2)]; //@line 367 "getopt.cpp"
                var $inc267=((($247)+1)&4294967295); //@line 367 "getopt.cpp"
                HEAP32[(($optind266)>>2)]=$inc267; //@line 367 "getopt.cpp"
                var $248=$data_addr; //@line 368 "getopt.cpp"
                var $optopt268=(($248+12)&4294967295); //@line 368 "getopt.cpp"
                HEAP32[(($optopt268)>>2)]=58; //@line 368 "getopt.cpp"
                $retval=58; //@line 368 "getopt.cpp"
                __label__ = 96;break $if_then$$lor_lhs_false$2; //@line 368 "getopt.cpp"
              }
              else if (__label__ == 77) {
  
                var $optind270=(($232+4)&4294967295); //@line 372 "getopt.cpp"
                var $249=HEAP32[(($optind270)>>2)]; //@line 372 "getopt.cpp"
                var $add271=((($249)+1)&4294967295); //@line 372 "getopt.cpp"
                var $250=$argv_addr; //@line 372 "getopt.cpp"
                var $arrayidx272=(($250+4*$add271)&4294967295); //@line 372 "getopt.cpp"
                var $251=HEAP32[(($arrayidx272)>>2)]; //@line 372 "getopt.cpp"
                var $252=$data_addr; //@line 372 "getopt.cpp"
                var $optarg273=(($252)&4294967295); //@line 372 "getopt.cpp"
                HEAP32[(($optarg273)>>2)]=$251; //@line 372 "getopt.cpp"
                $arg_next=1; //@line 373 "getopt.cpp"
                var $253=$data_addr; //@line 374 "getopt.cpp"
                var $optwhere274=(($253+16)&4294967295); //@line 374 "getopt.cpp"
                HEAP32[(($optwhere274)>>2)]=1; //@line 374 "getopt.cpp"
                ;
              }
            }
          }
  
          var $266=$ordering; //@line 392 "getopt.cpp"
          var $cmp297=((($266))|0)==0; //@line 392 "getopt.cpp"
          if ($cmp297) { __label__ = 84;; } else { __label__ = 87;; } //@line 392 "getopt.cpp"
          $land_lhs_true298$$if_else309$117: do { 
            if (__label__ == 84) {
  
              var $267=$data_addr; //@line 392 "getopt.cpp"
              var $optwhere299=(($267+16)&4294967295); //@line 392 "getopt.cpp"
              var $268=HEAP32[(($optwhere299)>>2)]; //@line 392 "getopt.cpp"
              var $cmp300=((($268))|0)==1; //@line 392 "getopt.cpp"
              if (!($cmp300)) { __label__ = 87;break $land_lhs_true298$$if_else309$117; } //@line 392 "getopt.cpp"
  
              var $269=$num_nonopts; //@line 392 "getopt.cpp"
              var $cmp302=((($269))|0)!=0; //@line 392 "getopt.cpp"
              if (!($cmp302)) { __label__ = 87;break $land_lhs_true298$$if_else309$117; } //@line 392 "getopt.cpp"
  
              var $270=$argv_addr; //@line 394 "getopt.cpp"
              var $271=$permute_from; //@line 394 "getopt.cpp"
              var $add_ptr304=(($270+4*$271)&4294967295); //@line 394 "getopt.cpp"
              var $272=$num_nonopts; //@line 394 "getopt.cpp"
              var $273=$arg_next; //@line 394 "getopt.cpp"
              var $add305=((($273)+1)&4294967295); //@line 394 "getopt.cpp"
              __ZL7permutePKPcii($add_ptr304, $272, $add305); //@line 394 "getopt.cpp"
              var $274=$permute_from; //@line 395 "getopt.cpp"
              var $275=$arg_next; //@line 395 "getopt.cpp"
              var $add306=((($274)+1)&4294967295); //@line 395 "getopt.cpp"
              var $add307=((($add306)+($275))&4294967295); //@line 395 "getopt.cpp"
              var $276=$data_addr; //@line 395 "getopt.cpp"
              var $optind308=(($276+4)&4294967295); //@line 395 "getopt.cpp"
              HEAP32[(($optind308)>>2)]=$add307; //@line 395 "getopt.cpp"
              __label__ = 89;break $land_lhs_true298$$if_else309$117; //@line 396 "getopt.cpp"
            }
          } while(0);
          $if_end318$$if_else309$121: do { 
            if (__label__ == 87) {
  
              var $277=$data_addr; //@line 397 "getopt.cpp"
              var $optwhere310=(($277+16)&4294967295); //@line 397 "getopt.cpp"
              var $278=HEAP32[(($optwhere310)>>2)]; //@line 397 "getopt.cpp"
              var $cmp311=((($278))|0)==1; //@line 397 "getopt.cpp"
              if (!($cmp311)) { __label__ = 89;break $if_end318$$if_else309$121; } //@line 397 "getopt.cpp"
  
              var $279=$data_addr; //@line 398 "getopt.cpp"
              var $optind313=(($279+4)&4294967295); //@line 398 "getopt.cpp"
              var $280=HEAP32[(($optind313)>>2)]; //@line 398 "getopt.cpp"
              var $281=$arg_next; //@line 398 "getopt.cpp"
              var $add314=((($280)+1)&4294967295); //@line 398 "getopt.cpp"
              var $add315=((($add314)+($281))&4294967295); //@line 398 "getopt.cpp"
              var $282=$data_addr; //@line 398 "getopt.cpp"
              var $optind316=(($282+4)&4294967295); //@line 398 "getopt.cpp"
              HEAP32[(($optind316)>>2)]=$add315; //@line 398 "getopt.cpp"
              ; //@line 398 "getopt.cpp"
            }
          } while(0);
  
          var $283=$longopt_match; //@line 401 "getopt.cpp"
          var $cmp319=((($283))|0) >= 0; //@line 401 "getopt.cpp"
          if ($cmp319) { __label__ = 90;; } else { __label__ = 95;; } //@line 401 "getopt.cpp"
          if (__label__ == 90) {
  
            var $284=$longind_addr; //@line 403 "getopt.cpp"
            var $cmp321=((($284))|0)!=0; //@line 403 "getopt.cpp"
            if ($cmp321) { __label__ = 91;; } else { __label__ = 92;; } //@line 403 "getopt.cpp"
            if (__label__ == 91) {
  
              var $285=$longopt_match; //@line 404 "getopt.cpp"
              var $286=$longind_addr; //@line 404 "getopt.cpp"
              HEAP32[(($286)>>2)]=$285; //@line 404 "getopt.cpp"
              ; //@line 404 "getopt.cpp"
            }
  
            var $287=$longopt_match; //@line 405 "getopt.cpp"
            var $288=$longopts_addr; //@line 405 "getopt.cpp"
            var $arrayidx324=(($288+16*$287)&4294967295); //@line 405 "getopt.cpp"
            var $flag=(($arrayidx324+8)&4294967295); //@line 405 "getopt.cpp"
            var $289=HEAP32[(($flag)>>2)]; //@line 405 "getopt.cpp"
            var $cmp325=((($289))|0)!=0; //@line 405 "getopt.cpp"
            var $290=$longopt_match; //@line 407 "getopt.cpp"
            var $291=$longopts_addr; //@line 407 "getopt.cpp"
            var $arrayidx327=(($291+16*$290)&4294967295); //@line 407 "getopt.cpp"
            var $val=(($arrayidx327+12)&4294967295); //@line 407 "getopt.cpp"
            var $292=HEAP32[(($val)>>2)]; //@line 407 "getopt.cpp"
            if ($cmp325) { __label__ = 93;; } else { __label__ = 94;; } //@line 405 "getopt.cpp"
            if (__label__ == 93) {
  
              var $293=$longopt_match; //@line 407 "getopt.cpp"
              var $294=$longopts_addr; //@line 407 "getopt.cpp"
              var $arrayidx328=(($294+16*$293)&4294967295); //@line 407 "getopt.cpp"
              var $flag329=(($arrayidx328+8)&4294967295); //@line 407 "getopt.cpp"
              var $295=HEAP32[(($flag329)>>2)]; //@line 407 "getopt.cpp"
              HEAP32[(($295)>>2)]=$292; //@line 407 "getopt.cpp"
              $retval=0; //@line 408 "getopt.cpp"
              __label__ = 96;break $if_then$$lor_lhs_false$2; //@line 408 "getopt.cpp"
            }
            else if (__label__ == 94) {
  
              $retval=$292; //@line 411 "getopt.cpp"
              __label__ = 96;break $if_then$$lor_lhs_false$2; //@line 411 "getopt.cpp"
            }
          }
          else if (__label__ == 95) {
  
            var $296=$data_addr; //@line 414 "getopt.cpp"
            var $optopt334=(($296+12)&4294967295); //@line 414 "getopt.cpp"
            var $297=HEAP32[(($optopt334)>>2)]; //@line 414 "getopt.cpp"
            $retval=$297; //@line 414 "getopt.cpp"
            __label__ = 96;break $if_then$$lor_lhs_false$2; //@line 414 "getopt.cpp"
          }
        }
      }
    } while(0);
    if (__label__ == 6) {
  
      $retval=-1; //@line 193 "getopt.cpp"
      ; //@line 193 "getopt.cpp"
    }
  
    var $298=$retval; //@line 415 "getopt.cpp"
    ;
    return $298; //@line 415 "getopt.cpp"
    return null;
  }
  

  function __ZL13write_globalsP11getopt_data($data) {
    ;
    var __label__;
  
    var $data_addr;
    $data_addr=$data;
    var $0=$data_addr; //@line 166 "getopt.cpp"
    var $optarg=(($0)&4294967295); //@line 166 "getopt.cpp"
    var $1=HEAP32[(($optarg)>>2)]; //@line 166 "getopt.cpp"
    HEAP32[((_optarg)>>2)]=$1; //@line 166 "getopt.cpp"
    var $2=$data_addr; //@line 167 "getopt.cpp"
    var $optind=(($2+4)&4294967295); //@line 167 "getopt.cpp"
    var $3=HEAP32[(($optind)>>2)]; //@line 167 "getopt.cpp"
    HEAP32[((_optind)>>2)]=$3; //@line 167 "getopt.cpp"
    var $4=$data_addr; //@line 168 "getopt.cpp"
    var $opterr=(($4+8)&4294967295); //@line 168 "getopt.cpp"
    var $5=HEAP32[(($opterr)>>2)]; //@line 168 "getopt.cpp"
    HEAP32[((_opterr)>>2)]=$5; //@line 168 "getopt.cpp"
    var $6=$data_addr; //@line 169 "getopt.cpp"
    var $optopt=(($6+12)&4294967295); //@line 169 "getopt.cpp"
    var $7=HEAP32[(($optopt)>>2)]; //@line 169 "getopt.cpp"
    HEAP32[((_optopt)>>2)]=$7; //@line 169 "getopt.cpp"
    var $8=$data_addr; //@line 170 "getopt.cpp"
    var $optwhere=(($8+16)&4294967295); //@line 170 "getopt.cpp"
    var $9=HEAP32[(($optwhere)>>2)]; //@line 170 "getopt.cpp"
    HEAP32[((__ZL8optwhere)>>2)]=$9; //@line 170 "getopt.cpp"
    ;
    return; //@line 171 "getopt.cpp"
    return;
  }
  

  function _getopt_long($argc, $argv, $shortopts, $longopts, $longind) {
    var __stackBase__  = STACKTOP; STACKTOP += 20; _memset(__stackBase__, 0, 20);
    var __label__;
  
    var $argc_addr;
    var $argv_addr;
    var $shortopts_addr;
    var $longopts_addr;
    var $longind_addr;
    var $data=__stackBase__;
    var $r;
    $argc_addr=$argc;
    $argv_addr=$argv;
    $shortopts_addr=$shortopts;
    $longopts_addr=$longopts;
    $longind_addr=$longind;
    __ZL12read_globalsP11getopt_data($data); //@line 436 "getopt.cpp"
    var $0=$argc_addr; //@line 437 "getopt.cpp"
    var $1=$argv_addr; //@line 437 "getopt.cpp"
    var $2=$shortopts_addr; //@line 437 "getopt.cpp"
    var $3=$longopts_addr; //@line 437 "getopt.cpp"
    var $4=$longind_addr; //@line 437 "getopt.cpp"
    var $call=__ZL15getopt_internaliPKPcPKcPK6optionPiiP11getopt_data($0, $1, $2, $3, $4, 0, $data); //@line 437 "getopt.cpp"
    $r=$call; //@line 437 "getopt.cpp"
    __ZL13write_globalsP11getopt_data($data); //@line 438 "getopt.cpp"
    var $5=$r; //@line 439 "getopt.cpp"
    STACKTOP = __stackBase__;
    return $5; //@line 439 "getopt.cpp"
    return null;
  }
  

  function _getopt_long_only($argc, $argv, $shortopts, $longopts, $longind) {
    var __stackBase__  = STACKTOP; STACKTOP += 20; _memset(__stackBase__, 0, 20);
    var __label__;
  
    var $argc_addr;
    var $argv_addr;
    var $shortopts_addr;
    var $longopts_addr;
    var $longind_addr;
    var $data=__stackBase__;
    var $r;
    $argc_addr=$argc;
    $argv_addr=$argv;
    $shortopts_addr=$shortopts;
    $longopts_addr=$longopts;
    $longind_addr=$longind;
    __ZL12read_globalsP11getopt_data($data); //@line 449 "getopt.cpp"
    var $0=$argc_addr; //@line 450 "getopt.cpp"
    var $1=$argv_addr; //@line 450 "getopt.cpp"
    var $2=$shortopts_addr; //@line 450 "getopt.cpp"
    var $3=$longopts_addr; //@line 450 "getopt.cpp"
    var $4=$longind_addr; //@line 450 "getopt.cpp"
    var $call=__ZL15getopt_internaliPKPcPKcPK6optionPiiP11getopt_data($0, $1, $2, $3, $4, 1, $data); //@line 450 "getopt.cpp"
    $r=$call; //@line 450 "getopt.cpp"
    __ZL13write_globalsP11getopt_data($data); //@line 451 "getopt.cpp"
    var $5=$r; //@line 452 "getopt.cpp"
    STACKTOP = __stackBase__;
    return $5; //@line 452 "getopt.cpp"
    return null;
  }
  

  function ___getopt_r($argc, $argv, $optstring, $data) {
    ;
    var __label__;
  
    var $argc_addr;
    var $argv_addr;
    var $optstring_addr;
    var $data_addr;
    $argc_addr=$argc;
    $argv_addr=$argv;
    $optstring_addr=$optstring;
    $data_addr=$data;
    var $0=$argc_addr; //@line 459 "getopt.cpp"
    var $1=$argv_addr; //@line 459 "getopt.cpp"
    var $2=$optstring_addr; //@line 459 "getopt.cpp"
    var $3=$data_addr; //@line 459 "getopt.cpp"
    var $call=__ZL15getopt_internaliPKPcPKcPK6optionPiiP11getopt_data($0, $1, $2, 0, 0, 0, $3); //@line 459 "getopt.cpp"
    ;
    return $call; //@line 459 "getopt.cpp"
    return null;
  }
  

  function ___getopt_long_r($argc, $argv, $shortopts, $longopts, $longind, $data) {
    ;
    var __label__;
  
    var $argc_addr;
    var $argv_addr;
    var $shortopts_addr;
    var $longopts_addr;
    var $longind_addr;
    var $data_addr;
    $argc_addr=$argc;
    $argv_addr=$argv;
    $shortopts_addr=$shortopts;
    $longopts_addr=$longopts;
    $longind_addr=$longind;
    $data_addr=$data;
    var $0=$argc_addr; //@line 467 "getopt.cpp"
    var $1=$argv_addr; //@line 467 "getopt.cpp"
    var $2=$shortopts_addr; //@line 467 "getopt.cpp"
    var $3=$longopts_addr; //@line 467 "getopt.cpp"
    var $4=$longind_addr; //@line 467 "getopt.cpp"
    var $5=$data_addr; //@line 467 "getopt.cpp"
    var $call=__ZL15getopt_internaliPKPcPKcPK6optionPiiP11getopt_data($0, $1, $2, $3, $4, 0, $5); //@line 467 "getopt.cpp"
    ;
    return $call; //@line 467 "getopt.cpp"
    return null;
  }
  

  function ___getopt_long_only_r($argc, $argv, $shortopts, $longopts, $longind, $data) {
    ;
    var __label__;
  
    var $argc_addr;
    var $argv_addr;
    var $shortopts_addr;
    var $longopts_addr;
    var $longind_addr;
    var $data_addr;
    $argc_addr=$argc;
    $argv_addr=$argv;
    $shortopts_addr=$shortopts;
    $longopts_addr=$longopts;
    $longind_addr=$longind;
    $data_addr=$data;
    var $0=$argc_addr; //@line 475 "getopt.cpp"
    var $1=$argv_addr; //@line 475 "getopt.cpp"
    var $2=$shortopts_addr; //@line 475 "getopt.cpp"
    var $3=$longopts_addr; //@line 475 "getopt.cpp"
    var $4=$longind_addr; //@line 475 "getopt.cpp"
    var $5=$data_addr; //@line 475 "getopt.cpp"
    var $call=__ZL15getopt_internaliPKPcPKcPK6optionPiiP11getopt_data($0, $1, $2, $3, $4, 1, $5); //@line 475 "getopt.cpp"
    ;
    return $call; //@line 475 "getopt.cpp"
    return null;
  }
  

  function __ZL9is_optionPci($argv_element, $only) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $argv_element_addr;
    var $only_addr;
    $argv_element_addr=$argv_element;
    $only_addr=$only;
    var $0=$argv_element_addr; //@line 145 "getopt.cpp"
    var $cmp=((($0))|0)==0; //@line 145 "getopt.cpp"
    if ($cmp) { __lastLabel__ = 0; __label__ = 4;; } else { __lastLabel__ = 0; __label__ = 1;; } //@line 145 "getopt.cpp"
    $lor_end$$lor_lhs_false$2: do { 
      if (__label__ == 1) {
  
        var $1=$argv_element_addr; //@line 145 "getopt.cpp"
        var $arrayidx=(($1)&4294967295); //@line 145 "getopt.cpp"
        var $2=HEAP8[($arrayidx)]; //@line 145 "getopt.cpp"
        var $conv=(tempInt=(($2)),(tempInt>=128?tempInt-256:tempInt)); //@line 145 "getopt.cpp"
        var $cmp1=((($conv))|0)==45; //@line 145 "getopt.cpp"
        if ($cmp1) { __lastLabel__ = 1; __label__ = 4;break $lor_end$$lor_lhs_false$2; } else { __lastLabel__ = 1; ; } //@line 145 "getopt.cpp"
  
        var $3=$only_addr; //@line 145 "getopt.cpp"
        var $tobool=((($3))|0)!=0; //@line 145 "getopt.cpp"
        if ($tobool) { __lastLabel__ = 2; ; } else { __lastLabel__ = 2; __label__ = 4;break $lor_end$$lor_lhs_false$2; } //@line 145 "getopt.cpp"
  
        var $4=$argv_element_addr; //@line 145 "getopt.cpp"
        var $arrayidx2=(($4)&4294967295); //@line 145 "getopt.cpp"
        var $5=HEAP8[($arrayidx2)]; //@line 145 "getopt.cpp"
        var $conv3=(tempInt=(($5)),(tempInt>=128?tempInt-256:tempInt)); //@line 145 "getopt.cpp"
        var $cmp4=((($conv3))|0)==43; //@line 145 "getopt.cpp"
        __lastLabel__ = 3; ;
      }
    } while(0);
  
    var $6=__lastLabel__ == 1 ? 1 : (__lastLabel__ == 0 ? 1 : (__lastLabel__ == 2 ? 0 : ($cmp4)));
    var $conv5=((($6))&1);
    ;
    return $conv5; //@line 147 "getopt.cpp"
    return null;
  }
  

  function __ZL7permutePKPcii($argv, $len1, $len2) {
    ;
    var __label__;
  
    var $argv_addr;
    var $len1_addr;
    var $len2_addr;
    $argv_addr=$argv;
    $len1_addr=$len1;
    $len2_addr=$len2;
    var $0=$argv_addr; //@line 136 "getopt.cpp"
    var $1=$len1_addr; //@line 136 "getopt.cpp"
    __ZL21reverse_argv_elementsPPci($0, $1); //@line 136 "getopt.cpp"
    var $2=$argv_addr; //@line 137 "getopt.cpp"
    var $3=$len1_addr; //@line 137 "getopt.cpp"
    var $4=$len2_addr; //@line 137 "getopt.cpp"
    var $add=((($4)+($3))&4294967295); //@line 137 "getopt.cpp"
    __ZL21reverse_argv_elementsPPci($2, $add); //@line 137 "getopt.cpp"
    var $5=$argv_addr; //@line 138 "getopt.cpp"
    var $6=$len2_addr; //@line 138 "getopt.cpp"
    __ZL21reverse_argv_elementsPPci($5, $6); //@line 138 "getopt.cpp"
    ;
    return; //@line 139 "getopt.cpp"
    return;
  }
  

  function __ZL21reverse_argv_elementsPPci($argv, $num) {
    ;
    var __label__;
  
    var $argv_addr;
    var $num_addr;
    var $i;
    var $tmp;
    $argv_addr=$argv;
    $num_addr=$num;
    $i=0; //@line 124 "getopt.cpp"
    var $0=$i; //@line 124 "getopt.cpp"
    var $1=$num_addr; //@line 124 "getopt.cpp"
    var $shr2=($1) >> 1; //@line 124 "getopt.cpp"
    var $cmp3=((($0))|0) < ((($shr2))|0); //@line 124 "getopt.cpp"
    if ($cmp3) { __label__ = 1;; } else { __label__ = 2;; } //@line 124 "getopt.cpp"
    $for_body$$for_end$2: do { 
      if (__label__ == 1) {
        while(1) { 
  
          var $2=$i; //@line 126 "getopt.cpp"
          var $3=$argv_addr; //@line 126 "getopt.cpp"
          var $arrayidx=(($3+4*$2)&4294967295); //@line 126 "getopt.cpp"
          var $4=HEAP32[(($arrayidx)>>2)]; //@line 126 "getopt.cpp"
          $tmp=$4; //@line 126 "getopt.cpp"
          var $5=$num_addr; //@line 127 "getopt.cpp"
          var $6=$i; //@line 127 "getopt.cpp"
          var $_neg=(((-($6)))&4294967295);
          var $sub=((($5)-1)&4294967295); //@line 127 "getopt.cpp"
          var $sub1=((($sub)+($_neg))&4294967295); //@line 127 "getopt.cpp"
          var $7=$argv_addr; //@line 127 "getopt.cpp"
          var $arrayidx2=(($7+4*$sub1)&4294967295); //@line 127 "getopt.cpp"
          var $8=HEAP32[(($arrayidx2)>>2)]; //@line 127 "getopt.cpp"
          var $9=$i; //@line 127 "getopt.cpp"
          var $10=$argv_addr; //@line 127 "getopt.cpp"
          var $arrayidx3=(($10+4*$9)&4294967295); //@line 127 "getopt.cpp"
          HEAP32[(($arrayidx3)>>2)]=$8; //@line 127 "getopt.cpp"
          var $11=$tmp; //@line 128 "getopt.cpp"
          var $12=$num_addr; //@line 128 "getopt.cpp"
          var $13=$i; //@line 128 "getopt.cpp"
          var $_neg1=(((-($13)))&4294967295);
          var $sub4=((($12)-1)&4294967295); //@line 128 "getopt.cpp"
          var $sub5=((($sub4)+($_neg1))&4294967295); //@line 128 "getopt.cpp"
          var $14=$argv_addr; //@line 128 "getopt.cpp"
          var $arrayidx6=(($14+4*$sub5)&4294967295); //@line 128 "getopt.cpp"
          HEAP32[(($arrayidx6)>>2)]=$11; //@line 128 "getopt.cpp"
          var $15=$i; //@line 124 "getopt.cpp"
          var $inc=((($15)+1)&4294967295); //@line 124 "getopt.cpp"
          $i=$inc; //@line 124 "getopt.cpp"
          var $16=$i; //@line 124 "getopt.cpp"
          var $17=$num_addr; //@line 124 "getopt.cpp"
          var $shr=($17) >> 1; //@line 124 "getopt.cpp"
          var $cmp=((($16))|0) < ((($shr))|0); //@line 124 "getopt.cpp"
          if ($cmp) { __label__ = 1;continue ; } else { __label__ = 2;break $for_body$$for_end$2; } //@line 124 "getopt.cpp"
        }
      }
    } while(0);
  
    ;
    return; //@line 130 "getopt.cpp"
    return;
  }
  

  function ___strtok_r($s, $delim, $lasts, $skip_leading_delim) {
    ;
    var __label__;
  
    var $retval;
    var $s_addr;
    var $delim_addr;
    var $lasts_addr;
    var $skip_leading_delim_addr;
    var $spanp;
    var $c;
    var $sc;
    var $tok;
    $s_addr=$s;
    $delim_addr=$delim;
    $lasts_addr=$lasts;
    $skip_leading_delim_addr=$skip_leading_delim;
    var $0=$s_addr; //@line 48 "strtok.cpp"
    var $cmp=((($0))|0)==0; //@line 48 "strtok.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 3;; } //@line 48 "strtok.cpp"
    $land_lhs_true$$cont$2: do { 
      if (__label__ == 1) {
  
        var $1=$lasts_addr; //@line 48 "strtok.cpp"
        var $2=HEAP32[(($1)>>2)]; //@line 48 "strtok.cpp"
        $s_addr=$2; //@line 48 "strtok.cpp"
        var $cmp1=((($2))|0)==0; //@line 48 "strtok.cpp"
        if (!($cmp1)) { __label__ = 3;break $land_lhs_true$$cont$2; } //@line 48 "strtok.cpp"
  
        $retval=0; //@line 49 "strtok.cpp"
        __label__ = 18;break $land_lhs_true$$cont$2; //@line 49 "strtok.cpp"
      }
    } while(0);
    if (__label__ == 3) {
      $cont$6: while(1) { 
  
        var $3=$s_addr; //@line 55 "strtok.cpp"
        var $incdec_ptr=(($3+1)&4294967295); //@line 55 "strtok.cpp"
        $s_addr=$incdec_ptr; //@line 55 "strtok.cpp"
        var $4=HEAP8[($3)]; //@line 55 "strtok.cpp"
        var $conv=(tempInt=(($4)),(tempInt>=128?tempInt-256:tempInt)); //@line 55 "strtok.cpp"
        $c=$conv; //@line 55 "strtok.cpp"
        var $5=$delim_addr; //@line 56 "strtok.cpp"
        $spanp=$5; //@line 56 "strtok.cpp"
        ; //@line 56 "strtok.cpp"
        while(1) { 
  
          var $6=$spanp; //@line 56 "strtok.cpp"
          var $incdec_ptr2=(($6+1)&4294967295); //@line 56 "strtok.cpp"
          $spanp=$incdec_ptr2; //@line 56 "strtok.cpp"
          var $7=HEAP8[($6)]; //@line 56 "strtok.cpp"
          var $conv3=(tempInt=(($7)),(tempInt>=128?tempInt-256:tempInt)); //@line 56 "strtok.cpp"
          $sc=$conv3; //@line 56 "strtok.cpp"
          var $cmp4=((($conv3))|0)!=0; //@line 56 "strtok.cpp"
          var $8=$c; //@line 57 "strtok.cpp"
          if (!($cmp4)) { __label__ = 8;break $cont$6; } //@line 56 "strtok.cpp"
  
          var $9=$sc; //@line 57 "strtok.cpp"
          var $cmp5=((($8))|0)==((($9))|0); //@line 57 "strtok.cpp"
          if ($cmp5) { __label__ = 6;break ; } else { __label__ = 4;continue ; } //@line 57 "strtok.cpp"
        }
  
        var $10=$skip_leading_delim_addr; //@line 58 "strtok.cpp"
        var $tobool=((($10))|0)!=0; //@line 58 "strtok.cpp"
        if ($tobool) { __label__ = 3;continue $cont$6; } else { __label__ = 7;break $cont$6; } //@line 58 "strtok.cpp"
      }
      if (__label__ == 8) {
  
        var $cmp9=((($8))|0)==0; //@line 69 "strtok.cpp"
        if ($cmp9) { __label__ = 9;; } else { __label__ = 10;; } //@line 69 "strtok.cpp"
        if (__label__ == 9) {
  
          var $15=$lasts_addr; //@line 70 "strtok.cpp"
          HEAP32[(($15)>>2)]=0; //@line 70 "strtok.cpp"
          $retval=0; //@line 71 "strtok.cpp"
          ; //@line 71 "strtok.cpp"
        }
        else if (__label__ == 10) {
  
          var $16=$s_addr; //@line 73 "strtok.cpp"
          var $add_ptr12=(($16+-1)&4294967295); //@line 73 "strtok.cpp"
          $tok=$add_ptr12; //@line 73 "strtok.cpp"
          ; //@line 79 "strtok.cpp"
          $for_cond13$17: while(1) { 
  
            var $17=$s_addr; //@line 80 "strtok.cpp"
            var $incdec_ptr14=(($17+1)&4294967295); //@line 80 "strtok.cpp"
            $s_addr=$incdec_ptr14; //@line 80 "strtok.cpp"
            var $18=HEAP8[($17)]; //@line 80 "strtok.cpp"
            var $conv15=(tempInt=(($18)),(tempInt>=128?tempInt-256:tempInt)); //@line 80 "strtok.cpp"
            $c=$conv15; //@line 80 "strtok.cpp"
            var $19=$delim_addr; //@line 81 "strtok.cpp"
            $spanp=$19; //@line 81 "strtok.cpp"
            ; //@line 82 "strtok.cpp"
            while(1) { 
  
              var $20=$spanp; //@line 83 "strtok.cpp"
              var $incdec_ptr16=(($20+1)&4294967295); //@line 83 "strtok.cpp"
              $spanp=$incdec_ptr16; //@line 83 "strtok.cpp"
              var $21=HEAP8[($20)]; //@line 83 "strtok.cpp"
              var $conv17=(tempInt=(($21)),(tempInt>=128?tempInt-256:tempInt)); //@line 83 "strtok.cpp"
              $sc=$conv17; //@line 83 "strtok.cpp"
              var $22=$c; //@line 83 "strtok.cpp"
              var $cmp18=((($conv17))|0)==((($22))|0); //@line 83 "strtok.cpp"
              if ($cmp18) { __label__ = 13;break $for_cond13$17; } //@line 83 "strtok.cpp"
  
              var $28=$sc; //@line 91 "strtok.cpp"
              var $cmp26=((($28))|0)!=0; //@line 91 "strtok.cpp"
              if ($cmp26) { __label__ = 12;continue ; } else { __label__ = 11;continue $for_cond13$17; } //@line 91 "strtok.cpp"
            }
          }
  
          var $23=$c; //@line 84 "strtok.cpp"
          var $cmp20=((($23))|0)==0; //@line 84 "strtok.cpp"
          if ($cmp20) { __label__ = 14;; } else { __label__ = 15;; } //@line 84 "strtok.cpp"
          if (__label__ == 14) {
  
            $s_addr=0; //@line 85 "strtok.cpp"
            ; //@line 85 "strtok.cpp"
          }
          else if (__label__ == 15) {
  
            var $24=$s_addr; //@line 87 "strtok.cpp"
            var $arrayidx23=(($24+-1)&4294967295); //@line 87 "strtok.cpp"
            HEAP8[($arrayidx23)]=0; //@line 87 "strtok.cpp"
            ;
          }
  
          var $25=$s_addr; //@line 88 "strtok.cpp"
          var $26=$lasts_addr; //@line 88 "strtok.cpp"
          HEAP32[(($26)>>2)]=$25; //@line 88 "strtok.cpp"
          var $27=$tok; //@line 89 "strtok.cpp"
          $retval=$27; //@line 89 "strtok.cpp"
          ; //@line 89 "strtok.cpp"
        }
      }
      else if (__label__ == 7) {
  
        var $11=$s_addr; //@line 62 "strtok.cpp"
        var $12=$lasts_addr; //@line 62 "strtok.cpp"
        HEAP32[(($12)>>2)]=$11; //@line 62 "strtok.cpp"
        var $13=$s_addr; //@line 63 "strtok.cpp"
        var $arrayidx=(($13+-1)&4294967295); //@line 63 "strtok.cpp"
        HEAP8[($arrayidx)]=0; //@line 63 "strtok.cpp"
        var $14=$s_addr; //@line 64 "strtok.cpp"
        var $add_ptr=(($14+-1)&4294967295); //@line 64 "strtok.cpp"
        $retval=$add_ptr; //@line 64 "strtok.cpp"
        ; //@line 64 "strtok.cpp"
      }
    }
  
    var $29=$retval; //@line 94 "strtok.cpp"
    ;
    return $29; //@line 94 "strtok.cpp"
    return null;
  }
  

  function _strtok_r($s, $delim, $lasts) {
    ;
    var __label__;
  
    var $s_addr;
    var $delim_addr;
    var $lasts_addr;
    $s_addr=$s;
    $delim_addr=$delim;
    $lasts_addr=$lasts;
    var $0=$s_addr; //@line 101 "strtok.cpp"
    var $1=$delim_addr; //@line 101 "strtok.cpp"
    var $2=$lasts_addr; //@line 101 "strtok.cpp"
    var $call=___strtok_r($0, $1, $2, 1); //@line 101 "strtok.cpp"
    ;
    return $call; //@line 101 "strtok.cpp"
    return null;
  }
  

  function _strtok($s, $delim) {
    var __stackBase__  = STACKTOP; STACKTOP += 4; _memset(__stackBase__, 0, 4);
    var __label__;
  
    var $s_addr;
    var $delim_addr;
    var $chr=__stackBase__;
    $s_addr=$s;
    $delim_addr=$delim;
    var $0=$s_addr; //@line 197 "strtok.cpp"
    var $1=$delim_addr; //@line 197 "strtok.cpp"
    var $call=___strtok_r($0, $1, $chr, 1); //@line 197 "strtok.cpp"
    STACKTOP = __stackBase__;
    return $call; //@line 197 "strtok.cpp"
    return null;
  }
  

// === Auto-generated postamble setup entry stuff ===

Module.callMain = function callMain(args) {
  var argc = args.length+1;
  function pad() {
    for (var i = 0; i < 4-1; i++) {
      argv.push(0);
    }
  }
  var argv = [allocate(intArrayFromString("/bin/this.program"), 'i8', ALLOC_STATIC) ];
  pad();
  for (var i = 0; i < argc-1; i = i + 1) {
    argv.push(allocate(intArrayFromString(args[i]), 'i8', ALLOC_STATIC));
    pad();
  }
  argv.push(0);
  argv = allocate(argv, 'i32', ALLOC_STATIC);

  return _main(argc, argv, 0);
}

function run(args) {
  args = args || Module.arguments;


_path_home=allocate(150, "i8", ALLOC_STATIC);
_filetype=allocate(5, "i8", ALLOC_STATIC);
_wavefile=allocate(200, "i8", ALLOC_STATIC);
_uri_callback=allocate(1, "i32 (i32, i8*, i8*)*", ALLOC_STATIC);
_phoneme_callback=allocate(1, "i32 (i8*)*", ALLOC_STATIC);
_f_wave=allocate(1, "%struct.__sFILE*", ALLOC_STATIC);
_quiet=allocate(1, "i32", ALLOC_STATIC);
_samples_total=allocate(1, "i32", ALLOC_STATIC);
_samples_split=allocate(1, "i32", ALLOC_STATIC);
_wavefile_count=allocate(1, "i32", ALLOC_STATIC);
_end_of_sentence=allocate(1, "i32", ALLOC_STATIC);
_voice_pcnt=allocate(60, "i16", ALLOC_STATIC);
__ZZ13DisplayVoicesP7__sFILEPcE7genders=allocate([32,77,70,32] /*  MF  */, "i8", ALLOC_STATIC);
__str1=allocate([80,116,121,32,76,97,110,103,117,97,103,101,32,65,103,101,47,71,101,110,100,101,114,32,86,111,105,99,101,78,97,109,101,32,32,32,32,32,32,32,70,105,108,101,32,32,32,32,32,32,32,32,79,116,104,101,114,32,76,97,110,103,115,10,0] /* Pty Language Age/Gen */, "i8", ALLOC_STATIC);
__str3=allocate([37,51,100,0] /* %3d\00 */, "i8", ALLOC_STATIC);
__str4=allocate([37,50,100,32,32,37,45,49,50,115,37,115,37,99,32,32,37,45,49,55,115,32,37,45,49,49,115,32,0] /* %2d  %-12s%s%c  %-17 */, "i8", ALLOC_STATIC);
__str5=allocate([40,37,115,32,37,100,41,0] /* (%s %d)\00 */, "i8", ALLOC_STATIC);
__ZZ4mainE12long_options=allocate([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 104, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 256, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 257, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 258, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 259, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 260, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 261, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 262, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 263, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 264, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 265, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 266, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], ["i8*",0,0,0,"i32",0,0,0,"i32*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32*",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__str6=allocate([104,101,108,112,0] /* help\00 */, "i8", ALLOC_STATIC);
__str7=allocate([115,116,100,105,110,0] /* stdin\00 */, "i8", ALLOC_STATIC);
__str8=allocate([99,111,109,112,105,108,101,45,100,101,98,117,103,0] /* compile-debug\00 */, "i8", ALLOC_STATIC);
__str9=allocate([99,111,109,112,105,108,101,0] /* compile\00 */, "i8", ALLOC_STATIC);
__str10=allocate([112,117,110,99,116,0] /* punct\00 */, "i8", ALLOC_STATIC);
__str11=allocate([118,111,105,99,101,115,0] /* voices\00 */, "i8", ALLOC_STATIC);
__str12=allocate([115,116,100,111,117,116,0] /* stdout\00 */, "i8", ALLOC_STATIC);
__str13=allocate([115,112,108,105,116,0] /* split\00 */, "i8", ALLOC_STATIC);
__str14=allocate([112,97,116,104,0] /* path\00 */, "i8", ALLOC_STATIC);
__str15=allocate([112,104,111,110,111,117,116,0] /* phonout\00 */, "i8", ALLOC_STATIC);
__str16=allocate([112,104,111,0] /* pho\00 */, "i8", ALLOC_STATIC);
__str17=allocate([105,112,97,0] /* ipa\00 */, "i8", ALLOC_STATIC);
__str18=allocate([70,97,105,108,101,100,32,116,111,32,114,101,97,100,32,0] /* Failed to read \00 */, "i8", ALLOC_STATIC);
__str19=allocate([97,58,98,58,102,58,103,58,104,107,58,108,58,112,58,113,115,58,118,58,119,58,120,88,109,122,0] /* a:b:f:g:hk:l:p:qs:v: */, "i8", ALLOC_STATIC);
__str21=allocate([10,115,112,101,97,107,32,116,101,120,116,45,116,111,45,115,112,101,101,99,104,58,32,37,115,32,32,32,68,97,116,97,32,97,116,58,32,37,115,10,37,115,0] /* \0Aspeak text-to-spe */, "i8", ALLOC_STATIC);
__str23=allocate([67,97,110,39,116,32,119,114,105,116,101,32,116,111,58,32,37,115,10,0] /* Can't write to: %s\0 */, "i8", ALLOC_STATIC);
__str25=allocate([37,115,118,111,105,99,101,32,39,37,115,39,10,0] /* %svoice '%s'\0A\00 */, "i8", ALLOC_STATIC);
__str27=allocate([37,115,102,105,108,101,32,39,37,115,39,10,0] /* %sfile '%s'\0A\00 */, "i8", ALLOC_STATIC);
__str28=allocate([67,97,110,39,116,32,119,114,105,116,101,32,116,111,32,111,117,116,112,117,116,32,102,105,108,101,32,39,37,115,39,10,39,0] /* Can't write to outpu */, "i8", ALLOC_STATIC);
__str29=allocate([45,119,32,111,112,116,105,111,110,32,109,117,115,116,32,98,101,32,117,115,101,100,32,98,101,99,97,117,115,101,32,116,104,101,32,112,114,111,103,114,97,109,32,119,97,115,32,98,117,105,108,116,32,119,105,116,104,111,117,116,32,97,32,115,111,117,110,100,32,105,110,116,101,114,102,97,99,101,10,0] /* -w option must be us */, "i8", ALLOC_STATIC);
__str30=allocate([37,115,95,37,46,50,100,37,115,0] /* %s_%.2d%s\00 */, "i8", ALLOC_STATIC);
__ZZL12OpenWaveFilePKciE8wave_hdr=allocate([82,73,70,70,36,240,255,127,87,65,86,69,102,109,116,32,16,0,0,0,1,0,1,0,9,61,0,0,18,122,0,0,2,0,16,0,100,97,116,97,0,240,255,127] /* RIFF$\F0\FF\7FWAVEfm */, "i8", ALLOC_STATIC);
__str32=allocate([101,110,95,85,83,46,85,84,70,45,56,0] /* en_US.UTF-8\00 */, "i8", ALLOC_STATIC);
__str33=allocate([85,84,70,45,56,0] /* UTF-8\00 */, "i8", ALLOC_STATIC);
__str35=allocate([70,97,105,108,101,100,32,116,111,32,108,111,97,100,32,101,115,112,101,97,107,45,100,97,116,97,10,0] /* Failed to load espea */, "i8", ALLOC_STATIC);
__str36=allocate([87,114,111,110,103,32,118,101,114,115,105,111,110,32,111,102,32,101,115,112,101,97,107,45,100,97,116,97,32,48,120,37,120,32,40,101,120,112,101,99,116,115,32,48,120,37,120,41,32,97,116,32,37,115,10,0] /* Wrong version of esp */, "i8", ALLOC_STATIC);
__str37=allocate([10,115,112,101,97,107,32,91,111,112,116,105,111,110,115,93,32,91,34,60,119,111,114,100,115,62,34,93,10,10,45,102,32,60,116,101,120,116,32,102,105,108,101,62,32,32,32,84,101,120,116,32,102,105,108,101,32,116,111,32,115,112,101,97,107,10,45,45,115,116,100,105,110,32,32,32,32,82,101,97,100,32,116,101,120,116,32,105,110,112,117,116,32,102,114,111,109,32,115,116,100,105,110,32,105,110,115,116,101,97,100,32,111,102,32,97,32,102,105,108,101,10,10,73,102,32,110,101,105,116,104,101,114,32,45,102,32,110,111,114,32,45,45,115,116,100,105,110,44,32,116,104,101,110,32,60,119,111,114,100,115,62,32,97,114,101,32,115,112,111,107,101,110,44,32,111,114,32,105,102,32,110,111,110,101,32,116,104,101,110,32,116,101,120,116,10,105,115,32,115,112,111,107,101,110,32,102,114,111,109,32,115,116,100,105,110,44,32,101,97,99,104,32,108,105,110,101,32,115,101,112,97,114,97,116,101,108,121,46,10,10,45,97,32,60,105,110,116,101,103,101,114,62,10,9,32,32,32,65,109,112,108,105,116,117,100,101,44,32,48,32,116,111,32,50,48,48,44,32,100,101,102,97,117,108,116,32,105,115,32,49,48,48,10,45,103,32,60,105,110,116,101,103,101,114,62,10,9,32,32,32,87,111,114,100,32,103,97,112,46,32,80,97,117,115,101,32,98,101,116,119,101,101,110,32,119,111,114,100,115,44,32,117,110,105,116,115,32,111,102,32,49,48,109,83,32,97,116,32,116,104,101,32,100,101,102,97,117,108,116,32,115,112,101,101,100,10,45,107,32,60,105,110,116,101,103,101,114,62,10,9,32,32,32,73,110,100,105,99,97,116,101,32,99,97,112,105,116,97,108,32,108,101,116,116,101,114,115,32,119,105,116,104,58,32,49,61,115,111,117,110,100,44,32,50,61,116,104,101,32,119,111,114,100,32,34,99,97,112,105,116,97,108,115,34,44,10,9,32,32,32,104,105,103,104,101,114,32,118,97,108,117,101,115,32,105,110,100,105,99,97,116,101,32,97,32,112,105,116,99,104,32,105,110,99,114,101,97,115,101,32,40,116,114,121,32,45,107,50,48,41,46,10,45,108,32,60,105,110,116,101,103,101,114,62,10,9,32,32,32,76,105,110,101,32,108,101,110,103,116,104,46,32,73,102,32,110,111,116,32,122,101,114,111,32,40,119,104,105,99,104,32,105,115,32,116,104,101,32,100,101,102,97,117,108,116,41,44,32,99,111,110,115,105,100,101,114,10,9,32,32,32,108,105,110,101,115,32,108,101,115,115,32,116,104,97,110,32,116,104,105,115,32,108,101,110,103,116,104,32,97,115,32,101,110,100,45,111,102,45,99,108,97,117,115,101,10,45,112,32,60,105,110,116,101,103,101,114,62,10,9,32,32,32,80,105,116,99,104,32,97,100,106,117,115,116,109,101,110,116,44,32,48,32,116,111,32,57,57,44,32,100,101,102,97,117,108,116,32,105,115,32,53,48,10,45,115,32,60,105,110,116,101,103,101,114,62,10,9,32,32,32,83,112,101,101,100,32,105,110,32,119,111,114,100,115,32,112,101,114,32,109,105,110,117,116,101,44,32,56,48,32,116,111,32,52,53,48,44,32,100,101,102,97,117,108,116,32,105,115,32,49,55,53,10,45,118,32,60,118,111,105,99,101,32,110,97,109,101,62,10,9,32,32,32,85,115,101,32,118,111,105,99,101,32,102,105,108,101,32,111,102,32,116,104,105,115,32,110,97,109,101,32,102,114,111,109,32,101,115,112,101,97,107,45,100,97,116,97,47,118,111,105,99,101,115,10,45,119,32,60,119,97,118,101,32,102,105,108,101,32,110,97,109,101,62,10,9,32,32,32,87,114,105,116,101,32,115,112,101,101,99,104,32,116,111,32,116,104,105,115,32,87,65,86,32,102,105,108,101,44,32,114,97,116,104,101,114,32,116,104,97,110,32,115,112,101,97,107,105,110,103,32,105,116,32,100,105,114,101,99,116,108,121,10,45,98,9,32,32,32,73,110,112,117,116,32,116,101,120,116,32,101,110,99,111,100,105,110,103,44,32,49,61,85,84,70,56,44,32,50,61,56,32,98,105,116,44,32,52,61,49,54,32,98,105,116,32,10,45,109,9,32,32,32,73,110,116,101,114,112,114,101,116,32,83,83,77,76,32,109,97,114,107,117,112,44,32,97,110,100,32,105,103,110,111,114,101,32,111,116,104,101,114,32,60,32,62,32,116,97,103,115,10,45,113,9,32,32,32,81,117,105,101,116,44,32,100,111,110,39,116,32,112,114,111,100,117,99,101,32,97,110,121,32,115,112,101,101,99,104,32,40,109,97,121,32,98,101,32,117,115,101,102,117,108,32,119,105,116,104,32,45,120,41,10,45,120,9,32,32,32,87,114,105,116,101,32,112,104,111,110,101,109,101,32,109,110,101,109,111,110,105,99,115,32,116,111,32,115,116,100,111,117,116,10,45,88,9,32,32,32,87,114,105,116,101,32,112,104,111,110,101,109,101,115,32,109,110,101,109,111,110,105,99,115,32,97,110,100,32,116,114,97,110,115,108,97,116,105,111,110,32,116,114,97,99,101,32,116,111,32,115,116,100,111,117,116,10,45,122,9,32,32,32,78,111,32,102,105,110,97,108,32,115,101,110,116,101,110,99,101,32,112,97,117,115,101,32,97,116,32,116,104,101,32,101,110,100,32,111,102,32,116,104,101,32,116,101,120,116,10,45,45,99,111,109,112,105,108,101,61,60,118,111,105,99,101,32,110,97,109,101,62,10,9,32,32,32,67,111,109,112,105,108,101,32,112,114,111,110,117,110,99,105,97,116,105,111,110,32,114,117,108,101,115,32,97,110,100,32,100,105,99,116,105,111,110,97,114,121,32,102,114,111,109,32,116,104,101,32,99,117,114,114,101,110,116,10,9,32,32,32,100,105,114,101,99,116,111,114,121,46,32,60,118,111,105,99,101,32,110,97,109,101,62,32,115,112,101,99,105,102,105,101,115,32,116,104,101,32,108,97,110,103,117,97,103,101,10,45,45,105,112,97,32,32,32,32,32,32,87,114,105,116,101,32,112,104,111,110,101,109,101,115,32,116,111,32,115,116,100,111,117,116,32,117,115,105,110,103,32,73,110,116,101,114,110,97,116,105,111,110,97,108,32,80,104,111,110,101,116,105,99,32,65,108,112,104,97,98,101,116,10,45,45,112,97,116,104,61,34,60,112,97,116,104,62,34,10,9,32,32,32,83,112,101,99,105,102,105,101,115,32,116,104,101,32,100,105,114,101,99,116,111,114,121,32,99,111,110,116,97,105,110,105,110,103,32,116,104,101,32,101,115,112,101,97,107,45,100,97,116,97,32,100,105,114,101,99,116,111,114,121,10,45,45,112,104,111,32,32,32,32,32,32,87,114,105,116,101,32,109,98,114,111,108,97,32,112,104,111,110,101,109,101,32,100,97,116,97,32,40,46,112,104,111,41,32,116,111,32,115,116,100,111,117,116,32,111,114,32,116,111,32,116,104,101,32,102,105,108,101,32,105,110,32,45,45,112,104,111,110,111,117,116,10,45,45,112,104,111,110,111,117,116,61,34,60,102,105,108,101,110,97,109,101,62,34,10,9,32,32,32,87,114,105,116,101,32,112,104,111,110,101,109,101,32,111,117,116,112,117,116,32,102,114,111,109,32,45,120,32,45,88,32,45,45,105,112,97,32,97,110,100,32,45,45,112,104,111,32,116,111,32,116,104,105,115,32,102,105,108,101,10,45,45,112,117,110,99,116,61,34,60,99,104,97,114,97,99,116,101,114,115,62,34,10,9,32,32,32,83,112,101,97,107,32,116,104,101,32,110,97,109,101,115,32,111,102,32,112,117,110,99,116,117,97,116,105,111,110,32,99,104,97,114,97,99,116,101,114,115,32,100,117,114,105,110,103,32,115,112,101,97,107,105,110,103,46,32,32,73,102,10,9,32,32,32,61,60,99,104,97,114,97,99,116,101,114,115,62,32,105,115,32,111,109,105,116,116,101,100,44,32,97,108,108,32,112,117,110,99,116,117,97,116,105,111,110,32,105,115,32,115,112,111,107,101,110,46,10,45,45,115,112,108,105,116,61,34,60,109,105,110,117,116,101,115,62,34,10,9,32,32,32,83,116,97,114,116,115,32,97,32,110,101,119,32,87,65,86,32,102,105,108,101,32,101,118,101,114,121,32,60,109,105,110,117,116,101,115,62,46,32,32,85,115,101,100,32,119,105,116,104,32,45,119,10,45,45,115,116,100,111,117,116,32,32,32,87,114,105,116,101,32,115,112,101,101,99,104,32,111,117,116,112,117,116,32,116,111,32,115,116,100,111,117,116,10,45,45,118,111,105,99,101,115,61,60,108,97,110,103,117,97,103,101,62,10,9,32,32,32,76,105,115,116,32,116,104,101,32,97,118,97,105,108,97,98,108,101,32,118,111,105,99,101,115,32,102,111,114,32,116,104,101,32,115,112,101,99,105,102,105,101,100,32,108,97,110,103,117,97,103,101,46,10,9,32,32,32,73,102,32,60,108,97,110,103,117,97,103,101,62,32,105,115,32,111,109,105,116,116,101,100,44,32,116,104,101,110,32,108,105,115,116,32,97,108,108,32,118,111,105,99,101,115,46,10,0] /* \0Aspeak [options] [ */, "i8", ALLOC_STATIC);
__str38=allocate([37,115,47,101,115,112,101,97,107,45,100,97,116,97,0] /* %s/espeak-data\00 */, "i8", ALLOC_STATIC);
__str39=allocate([69,83,80,69,65,75,95,68,65,84,65,95,80,65,84,72,0] /* ESPEAK_DATA_PATH\00 */, "i8", ALLOC_STATIC);
__str40=allocate([72,79,77,69,0] /* HOME\00 */, "i8", ALLOC_STATIC);
__str41=allocate([47,117,115,114,47,115,104,97,114,101,47,101,115,112,101,97,107,45,100,97,116,97,0] /* /usr/share/espeak-da */, "i8", ALLOC_STATIC);
__ZL5f_log=allocate(1, "%struct.__sFILE*", ALLOC_STATIC);
__str42=allocate([117,110,112,114,0] /* unpr\00 */, "i8", ALLOC_STATIC);
__str143=allocate([119,95,97,108,116,50,0] /* w_alt2\00 */, "i8", ALLOC_STATIC);
__str244=allocate([119,95,97,108,116,51,0] /* w_alt3\00 */, "i8", ALLOC_STATIC);
__str345=allocate([119,95,97,108,116,0] /* w_alt\00 */, "i8", ALLOC_STATIC);
__str446=allocate([112,95,97,108,116,50,0] /* p_alt2\00 */, "i8", ALLOC_STATIC);
__str547=allocate([112,95,97,108,116,51,0] /* p_alt3\00 */, "i8", ALLOC_STATIC);
__str648=allocate([112,95,97,108,116,0] /* p_alt\00 */, "i8", ALLOC_STATIC);
_mnem_rules=allocate([0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 18, 0, 0, 0, 0, 0, 0, 0, 19, 0, 0, 0, 0, 0, 0, 0, 17, 0, 0, 0, 0, 0, 0, 0, 34, 0, 0, 0, 0, 0, 0, 0, 35, 0, 0, 0, 0, 0, 0, 0, 33, 0, 0, 0, 0, 0, 0, 0, -1, 0, 0, 0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__str749=allocate([36,49,0] /* $1\00 */, "i8", ALLOC_STATIC);
__str850=allocate([36,50,0] /* $2\00 */, "i8", ALLOC_STATIC);
__str951=allocate([36,51,0] /* $3\00 */, "i8", ALLOC_STATIC);
__str1052=allocate([36,52,0] /* $4\00 */, "i8", ALLOC_STATIC);
__str1153=allocate([36,53,0] /* $5\00 */, "i8", ALLOC_STATIC);
__str1254=allocate([36,54,0] /* $6\00 */, "i8", ALLOC_STATIC);
__str1355=allocate([36,55,0] /* $7\00 */, "i8", ALLOC_STATIC);
__str1456=allocate([36,117,0] /* $u\00 */, "i8", ALLOC_STATIC);
__str1557=allocate([36,117,49,0] /* $u1\00 */, "i8", ALLOC_STATIC);
__str1658=allocate([36,117,50,0] /* $u2\00 */, "i8", ALLOC_STATIC);
__str1759=allocate([36,117,51,0] /* $u3\00 */, "i8", ALLOC_STATIC);
__str1860=allocate([36,117,43,0] /* $u+\00 */, "i8", ALLOC_STATIC);
__str1961=allocate([36,117,49,43,0] /* $u1+\00 */, "i8", ALLOC_STATIC);
__str2062=allocate([36,117,50,43,0] /* $u2+\00 */, "i8", ALLOC_STATIC);
__str2163=allocate([36,117,51,43,0] /* $u3+\00 */, "i8", ALLOC_STATIC);
__str2264=allocate([36,112,97,117,115,101,0] /* $pause\00 */, "i8", ALLOC_STATIC);
__str2365=allocate([36,111,110,108,121,0] /* $only\00 */, "i8", ALLOC_STATIC);
__str2466=allocate([36,111,110,108,121,115,0] /* $onlys\00 */, "i8", ALLOC_STATIC);
__str2567=allocate([36,115,116,114,101,110,100,0] /* $strend\00 */, "i8", ALLOC_STATIC);
__str2668=allocate([36,115,116,114,101,110,100,50,0] /* $strend2\00 */, "i8", ALLOC_STATIC);
__str2769=allocate([36,117,110,115,116,114,101,115,115,101,110,100,0] /* $unstressend\00 */, "i8", ALLOC_STATIC);
__str2870=allocate([36,97,116,101,110,100,0] /* $atend\00 */, "i8", ALLOC_STATIC);
__str2971=allocate([36,97,116,115,116,97,114,116,0] /* $atstart\00 */, "i8", ALLOC_STATIC);
__str3072=allocate([36,97,98,98,114,101,118,0] /* $abbrev\00 */, "i8", ALLOC_STATIC);
__str3173=allocate([36,115,116,101,109,0] /* $stem\00 */, "i8", ALLOC_STATIC);
__str3274=allocate([36,100,111,117,98,108,101,0] /* $double\00 */, "i8", ALLOC_STATIC);
__str3375=allocate([36,97,108,116,0] /* $alt\00 */, "i8", ALLOC_STATIC);
__str3476=allocate([36,97,108,116,49,0] /* $alt1\00 */, "i8", ALLOC_STATIC);
__str3577=allocate([36,97,108,116,50,0] /* $alt2\00 */, "i8", ALLOC_STATIC);
__str3678=allocate([36,97,108,116,51,0] /* $alt3\00 */, "i8", ALLOC_STATIC);
__str3779=allocate([36,99,111,109,98,105,110,101,0] /* $combine\00 */, "i8", ALLOC_STATIC);
__str3880=allocate([36,100,111,116,0] /* $dot\00 */, "i8", ALLOC_STATIC);
__str3981=allocate([36,104,97,115,100,111,116,0] /* $hasdot\00 */, "i8", ALLOC_STATIC);
__str4082=allocate([36,109,97,120,51,0] /* $max3\00 */, "i8", ALLOC_STATIC);
__str4183=allocate([36,98,114,107,0] /* $brk\00 */, "i8", ALLOC_STATIC);
__str4284=allocate([36,116,101,120,116,0] /* $text\00 */, "i8", ALLOC_STATIC);
__str43=allocate([36,118,101,114,98,102,0] /* $verbf\00 */, "i8", ALLOC_STATIC);
__str44=allocate([36,118,101,114,98,115,102,0] /* $verbsf\00 */, "i8", ALLOC_STATIC);
__str45=allocate([36,110,111,117,110,102,0] /* $nounf\00 */, "i8", ALLOC_STATIC);
__str46=allocate([36,112,97,115,116,102,0] /* $pastf\00 */, "i8", ALLOC_STATIC);
__str47=allocate([36,118,101,114,98,0] /* $verb\00 */, "i8", ALLOC_STATIC);
__str48=allocate([36,110,111,117,110,0] /* $noun\00 */, "i8", ALLOC_STATIC);
__str49=allocate([36,112,97,115,116,0] /* $past\00 */, "i8", ALLOC_STATIC);
__str50=allocate([36,118,101,114,98,101,120,116,101,110,100,0] /* $verbextend\00 */, "i8", ALLOC_STATIC);
__str51=allocate([36,99,97,112,105,116,97,108,0] /* $capital\00 */, "i8", ALLOC_STATIC);
__str52=allocate([36,97,108,108,99,97,112,115,0] /* $allcaps\00 */, "i8", ALLOC_STATIC);
__str53=allocate([36,97,99,99,101,110,116,0] /* $accent\00 */, "i8", ALLOC_STATIC);
__str54=allocate([36,115,101,110,116,101,110,99,101,0] /* $sentence\00 */, "i8", ALLOC_STATIC);
__str55=allocate([36,63,0] /* $?\00 */, "i8", ALLOC_STATIC);
__str56=allocate([36,116,101,120,116,109,111,100,101,0] /* $textmode\00 */, "i8", ALLOC_STATIC);
__str57=allocate([36,112,104,111,110,101,109,101,109,111,100,101,0] /* $phonememode\00 */, "i8", ALLOC_STATIC);
_mnem_flags=allocate([0, 0, 0, 0, 65, 0, 0, 0, 0, 0, 0, 0, 66, 0, 0, 0, 0, 0, 0, 0, 67, 0, 0, 0, 0, 0, 0, 0, 68, 0, 0, 0, 0, 0, 0, 0, 69, 0, 0, 0, 0, 0, 0, 0, 70, 0, 0, 0, 0, 0, 0, 0, 71, 0, 0, 0, 0, 0, 0, 0, 72, 0, 0, 0, 0, 0, 0, 0, 73, 0, 0, 0, 0, 0, 0, 0, 74, 0, 0, 0, 0, 0, 0, 0, 75, 0, 0, 0, 0, 0, 0, 0, 76, 0, 0, 0, 0, 0, 0, 0, 77, 0, 0, 0, 0, 0, 0, 0, 78, 0, 0, 0, 0, 0, 0, 0, 79, 0, 0, 0, 0, 0, 0, 0, 8, 0, 0, 0, 0, 0, 0, 0, 9, 0, 0, 0, 0, 0, 0, 0, 10, 0, 0, 0, 0, 0, 0, 0, 11, 0, 0, 0, 0, 0, 0, 0, 12, 0, 0, 0, 0, 0, 0, 0, 13, 0, 0, 0, 0, 0, 0, 0, 14, 0, 0, 0, 0, 0, 0, 0, 15, 0, 0, 0, 0, 0, 0, 0, 17, 0, 0, 0, 0, 0, 0, 0, 18, 0, 0, 0, 0, 0, 0, 0, 19, 0, 0, 0, 0, 0, 0, 0, 20, 0, 0, 0, 0, 0, 0, 0, 20, 0, 0, 0, 0, 0, 0, 0, 21, 0, 0, 0, 0, 0, 0, 0, 22, 0, 0, 0, 0, 0, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0, 24, 0, 0, 0, 0, 0, 0, 0, 25, 0, 0, 0, 0, 0, 0, 0, 27, 0, 0, 0, 0, 0, 0, 0, 28, 0, 0, 0, 0, 0, 0, 0, 29, 0, 0, 0, 0, 0, 0, 0, 32, 0, 0, 0, 0, 0, 0, 0, 33, 0, 0, 0, 0, 0, 0, 0, 34, 0, 0, 0, 0, 0, 0, 0, 35, 0, 0, 0, 0, 0, 0, 0, 36, 0, 0, 0, 0, 0, 0, 0, 37, 0, 0, 0, 0, 0, 0, 0, 38, 0, 0, 0, 0, 0, 0, 0, 40, 0, 0, 0, 0, 0, 0, 0, 41, 0, 0, 0, 0, 0, 0, 0, 42, 0, 0, 0, 0, 0, 0, 0, 43, 0, 0, 0, 0, 0, 0, 0, 45, 0, 0, 0, 0, 0, 0, 0, 100, 0, 0, 0, 0, 0, 0, 0, 200, 0, 0, 0, 0, 0, 0, 0, 201, 0, 0, 0, 0, 0, 0, 0, -1, 0, 0, 0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__ZZ22print_dictionary_flagsPjE3buf=allocate(20, "i8", ALLOC_STATIC);
__str59=allocate([37,115,32,32,48,120,37,120,47,37,120,0] /* %s  0x%x/%x\00 */, "i8", ALLOC_STATIC);
__ZZ10DecodeRulePKciPciE6output=allocate(60, "i8", ALLOC_STATIC);
__ZZ10DecodeRulePKciPciE7symbols=allocate([32,32,32,32,32,32,32,32,32,32,38,37,43,35,83,68,90,65,76,33,32,64,63,74,78,75,86,63,84,88,63,87] /*           &%+#SDZAL! */, "i8", ALLOC_STATIC);
__ZZ10DecodeRulePKciPciE10symbols_lg=allocate([65,66,67,72,70,71,89] /* ABCHFGY */, "i8", ALLOC_STATIC);
__str60=allocate([32,40,0] /*  (\00 */, "i8", ALLOC_STATIC);
__str61=allocate([101,105,112,118,100,102,113,32,116,98,97,32,0] /* eipvdfq tba \00 */, "i8", ALLOC_STATIC);
__str62=allocate([37,99,37,100,0] /* %c%d\00 */, "i8", ALLOC_STATIC);
__str64=allocate([37,53,100,58,9,0] /* %5d:\09\00 */, "i8", ALLOC_STATIC);
__str65=allocate([63,37,100,32,0] /* ?%d \00 */, "i8", ALLOC_STATIC);
__ZL11error_count=allocate(1, "i32", ALLOC_STATIC);
__ZL21error_need_dictionary=allocate(1, "i32", ALLOC_STATIC);
__ZL19letterGroupsDefined=allocate(26, "i8", ALLOC_STATIC);
__ZL10debug_flag=allocate(1, "i32", ALLOC_STATIC);
__str66=allocate([37,115,37,115,95,0] /* %s%s_\00 */, "i8", ALLOC_STATIC);
__str67=allocate([37,115,114,117,108,101,115,46,116,120,116,0] /* %srules.txt\00 */, "i8", ALLOC_STATIC);
__str69=allocate([37,115,114,117,108,101,115,0] /* %srules\00 */, "i8", ALLOC_STATIC);
__str71=allocate([119,98,43,0] /* wb+\00 */, "i8", ALLOC_STATIC);
__str72=allocate([37,115,37,99,116,101,109,112,0] /* %s%ctemp\00 */, "i8", ALLOC_STATIC);
__str73=allocate([85,115,105,110,103,32,112,104,111,110,101,109,101,116,97,98,108,101,58,32,39,37,115,39,10,0] /* Using phonemetable:  */, "i8", ALLOC_STATIC);
__str74=allocate([114,111,111,116,115,0] /* roots\00 */, "i8", ALLOC_STATIC);
__str75=allocate([108,105,115,116,0] /* list\00 */, "i8", ALLOC_STATIC);
__str76=allocate([108,105,115,116,120,0] /* listx\00 */, "i8", ALLOC_STATIC);
__str77=allocate([101,120,116,114,97,0] /* extra\00 */, "i8", ALLOC_STATIC);
__str78=allocate([67,111,109,112,105,108,105,110,103,58,32,39,37,115,39,10,0] /* Compiling: '%s'\0A\0 */, "i8", ALLOC_STATIC);
__ZL7linenum=allocate(1, "i32", ALLOC_STATIC);
__ZL10group_name=allocate(13, "i8", ALLOC_STATIC);
__str79=allocate([119,98,0] /* wb\00 */, "i8", ALLOC_STATIC);
__ZL9group3_ix=allocate(1, "i32", ALLOC_STATIC);
__str81=allocate([46,76,0] /* .L\00 */, "i8", ALLOC_STATIC);
__str82=allocate([46,114,101,112,108,97,99,101,0] /* .replace\00 */, "i8", ALLOC_STATIC);
__str83=allocate([46,103,114,111,117,112,0] /* .group\00 */, "i8", ALLOC_STATIC);
__str84=allocate([48,120,37,120,0] /* 0x%x\00 */, "i8", ALLOC_STATIC);
__str85=allocate([37,53,100,58,32,71,114,111,117,112,32,110,97,109,101,32,108,111,110,103,101,114,32,116,104,97,110,32,50,32,98,121,116,101,115,32,40,85,84,70,56,41,0] /* %5d: Group name long */, "i8", ALLOC_STATIC);
__str89=allocate([9,37,100,32,114,117,108,101,115,44,32,37,100,32,103,114,111,117,112,115,32,40,37,100,41,10,10,0] /* \09%d rules, %d grou */, "i8", ALLOC_STATIC);
__ZL9rule_cond=allocate(80, "i8", ALLOC_STATIC);
__ZL8rule_pre=allocate(80, "i8", ALLOC_STATIC);
__ZL9rule_post=allocate(80, "i8", ALLOC_STATIC);
__ZL10rule_match=allocate(80, "i8", ALLOC_STATIC);
__ZL13rule_phonemes=allocate(80, "i8", ALLOC_STATIC);
__str90=allocate([37,53,100,58,32,83,121,110,116,97,120,32,101,114,114,111,114,46,32,83,112,97,99,101,32,97,102,116,101,114,32,40,10,0] /* %5d: Syntax error. S */, "i8", ALLOC_STATIC);
__str91=allocate([36,103,114,111,117,112,0] /* $group\00 */, "i8", ALLOC_STATIC);
__str92=allocate([37,53,100,58,32,83,121,110,116,97,120,32,101,114,114,111,114,10,0] /* %5d: Syntax error\0A */, "i8", ALLOC_STATIC);
__str93=allocate([37,53,100,58,32,66,97,100,32,112,104,111,110,101,109,101,32,91,37,99,93,32,105,110,32,37,115,10,0] /* %5d: Bad phoneme [%c */, "i8", ALLOC_STATIC);
__str94=allocate([37,53,100,58,32,87,114,111,110,103,32,105,110,105,116,105,97,108,32,108,101,116,116,101,114,115,32,39,37,115,39,32,102,111,114,32,103,114,111,117,112,32,39,37,115,39,10,0] /* %5d: Wrong initial l */, "i8", ALLOC_STATIC);
__str95=allocate([37,53,100,58,32,98,97,100,32,99,111,110,100,105,116,105,111,110,32,110,117,109,98,101,114,32,63,37,100,10,0] /* %5d: bad condition n */, "i8", ALLOC_STATIC);
__ZZL16copy_rule_stringPcRiE6outbuf=allocate(20, "i8*", ALLOC_STATIC);
__ZZL16copy_rule_stringPcRiE10next_state=allocate([2, 0, 0, 0, 2, 0, 0, 0, 4, 0, 0, 0, 4, 0, 0, 0, 4, 0, 0, 0], ["i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__ZZL16copy_rule_stringPcRiE16lettergp_letters=allocate([0,1,2,0,0,4,5,3,6] /* \00\01\02\00\00\04\0 */, "i8", ALLOC_STATIC);
__str97=allocate([37,53,100,58,32,69,120,112,101,99,116,101,100,32,50,32,100,105,103,105,116,115,32,97,102,116,101,114,32,39,76,39,10,0] /* %5d: Expected 2 digi */, "i8", ALLOC_STATIC);
__str98=allocate([37,53,100,58,32,76,101,116,116,101,114,32,103,114,111,117,112,32,76,37,46,50,100,32,110,111,116,32,100,101,102,105,110,101,100,10,0] /* %5d: Letter group L% */, "i8", ALLOC_STATIC);
__str99=allocate([37,53,100,58,32,36,32,99,111,109,109,97,110,100,32,110,111,116,32,114,101,99,111,103,110,105,122,101,100,10,0] /* %5d: $ command not r */, "i8", ALLOC_STATIC);
__str100=allocate([37,53,100,58,32,69,120,112,101,99,116,101,100,32,50,32,100,105,103,105,116,115,32,97,102,116,101,114,32,39,46,76,39,10,0] /* %5d: Expected 2 digi */, "i8", ALLOC_STATIC);
__str101=allocate([37,53,100,58,32,108,101,116,116,101,114,103,114,111,117,112,32,111,117,116,32,111,102,32,114,97,110,103,101,32,40,48,49,45,37,46,50,100,41,10,0] /* %5d: lettergroup out */, "i8", ALLOC_STATIC);
__str102=allocate([37,53,100,58,32,108,101,116,116,101,114,103,114,111,117,112,32,76,37,46,50,100,32,105,115,32,97,108,114,101,97,100,121,32,100,101,102,105,110,101,100,10,0] /* %5d: lettergroup L%. */, "i8", ALLOC_STATIC);
__str103=allocate([57,0] /* 9\00 */, "i8", ALLOC_STATIC);
__ZL11hash_chains=allocate(4096, "i8*", ALLOC_STATIC);
__ZL11hash_counts=allocate(4096, "i32", ALLOC_STATIC);
__ZL9text_mode_b=allocate(1, "i1", ALLOC_STATIC);
__str104=allocate([37,115,37,115,46,116,120,116,0] /* %s%s.txt\00 */, "i8", ALLOC_STATIC);
__str106=allocate([67,97,110,39,116,32,97,108,108,111,99,97,116,101,32,109,101,109,111,114,121,10,0] /* Can't allocate memor */, "i8", ALLOC_STATIC);
__str107=allocate([9,37,100,32,101,110,116,114,105,101,115,10,0] /* \09%d entries\0A\00 */, "i8", ALLOC_STATIC);
__ZZL12compile_linePcS_PiE10nullstring=allocate(1, "i8", ALLOC_STATIC);
__str108=allocate([95,45,0] /* _-\00 */, "i8", ALLOC_STATIC);
__str109=allocate([37,53,100,58,32,85,110,107,110,111,119,110,32,107,101,121,119,111,114,100,58,32,37,115,10,0] /* %5d: Unknown keyword */, "i8", ALLOC_STATIC);
__str110=allocate([32,0] /*  \00 */, "i8", ALLOC_STATIC);
__str111=allocate([37,53,100,58,32,78,101,101,100,32,116,111,32,99,111,109,112,105,108,101,32,100,105,99,116,105,111,110,97,114,121,32,97,103,97,105,110,10,0] /* %5d: Need to compile */, "i8", ALLOC_STATIC);
__str112=allocate([37,53,100,58,32,66,97,100,32,112,104,111,110,101,109,101,32,91,37,99,93,32,40,48,120,37,120,41,32,105,110,58,32,37,115,32,32,37,115,10,0] /* %5d: Bad phoneme [%c */, "i8", ALLOC_STATIC);
__str113=allocate([85,43,37,120,0] /* U+%x\00 */, "i8", ALLOC_STATIC);
__str114=allocate([37,53,100,58,32,84,119,111,32,109,97,110,121,32,112,97,114,116,115,32,105,110,32,97,32,109,117,108,116,105,45,119,111,114,100,32,101,110,116,114,121,58,32,37,100,10,0] /* %5d: Two many parts  */, "i8", ALLOC_STATIC);
__str115=allocate([67,97,110,39,116,32,97,99,99,101,115,115,32,40,37,115,41,32,102,105,108,101,32,39,37,115,39,10,0] /* Can't access (%s) fi */, "i8", ALLOC_STATIC);
_dictionary_skipwords=allocate(1, "i32", ALLOC_STATIC);
_dictionary_name=allocate(40, "i8", ALLOC_STATIC);
__ZL13remove_accent=allocate([97,97,97,97,97,97,97,99,101,101,101,101,105,105,105,105,100,110,111,111,111,111,111,0,111,117,117,117,117,121,116,115,97,97,97,97,97,97,97,99,101,101,101,101,105,105,105,105,100,110,111,111,111,111,111,0,111,117,117,117,117,121,116,121,97,97,97,97,97,97,99,99,99,99,99,99,99,99,100,100,100,100,101,101,101,101,101,101,101,101,101,101,103,103,103,103,103,103,103,103,104,104,104,104,105,105,105,105,105,105,105,105,105,105,105,105,106,106,107,107,107,108,108,108,108,108,108,108,108,108,108,110,110,110,110,110,110,110,110,110,111,111,111,111,111,111,111,111,114,114,114,114,114,114,115,115,115,115,115,115,115,115,116,116,116,116,116,116,117,117,117,117,117,117,117,117,117,117,117,117,119,119,121,121,121,122,122,122,122,122,122,115,98,98,98,98,0,0,111,99,99,100,100,100,100,100,101,101,101,102,102,103,103,104,105,105,107,107,108,108,109,110,110,111,111,111,111,111,112,112,121,0,0,115,115,116,116,116,116,117,117,117,118,121,121,122,122,122,122,122,122,122,0,0,0,119,116,116,116,107,100,100,100,108,108,108,110,110,110,97,97,105,105,111,111,117,117,117,117,117,117,117,117,117,117,101,97,97,97,97,97,97,103,103,103,103,107,107,111,111,111,111,122,122,106,100,100,100,103,103,119,119,110,110,97,97,97,97,111,111,97,97,97,97,101,101,101,101,105,105,105,105,111,111,111,111,114,114,114,114,117,117,117,117,115,115,116,116,121,121,104,104,110,100,111,111,122,122,97,97,101,101,111,111,111,111,111,111,111,111,121,121,108,110,116,106,100,113,97,99,99,108,116,115,122,0,0,98,117,118,101,101,106,106,113,113,114,114,121,121,97,97,97,98,111,99,100,100,101,101,101,101,101,101,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0] /* aaaaaaaceeeeiiiidnoo */, "i8", ALLOC_STATIC);
__str116=allocate([37,115,37,99,37,115,95,100,105,99,116,0] /* %s%c%s_dict\00 */, "i8", ALLOC_STATIC);
__str2118=allocate([67,97,110,39,116,32,114,101,97,100,32,100,105,99,116,105,111,110,97,114,121,32,102,105,108,101,58,32,39,37,115,39,10,0] /* Can't read dictionar */, "i8", ALLOC_STATIC);
__str3119=allocate([69,109,112,116,121,32,95,100,105,99,116,32,102,105,108,101,58,32,39,37,115,10,0] /* Empty _dict file: '% */, "i8", ALLOC_STATIC);
__str4120=allocate([66,97,100,32,100,97,116,97,58,32,39,37,115,39,32,40,37,120,32,108,101,110,103,116,104,61,37,120,41,10,0] /* Bad data: '%s' (%x l */, "i8", ALLOC_STATIC);
__str5121=allocate([69,114,114,111,114,32,105,110,32,37,115,95,114,117,108,101,115,44,32,110,111,32,100,101,102,97,117,108,116,32,114,117,108,101,32,103,114,111,117,112,10,0] /* Error in %s_rules, n */, "i8", ALLOC_STATIC);
__str7123=allocate([61,61,44,44,39,42,32,32,0] /* ==,,'_  \00 */, "i8", ALLOC_STATIC);
_ipa1=allocate([32, 0, 33, 0, 34, 0, 688, 0, 36, 0, 37, 0, 230, 0, 712, 0, 40, 0, 638, 0, 42, 0, 43, 0, 716, 0, 45, 0, 46, 0, 47, 0, 594, 0, 49, 0, 50, 0, 604, 0, 52, 0, 53, 0, 54, 0, 55, 0, 629, 0, 57, 0, 720, 0, 690, 0, 60, 0, 61, 0, 62, 0, 660, 0, 601, 0, 593, 0, 946, 0, 231, 0, 240, 0, 603, 0, 70, 0, 610, 0, 295, 0, 618, 0, 607, 0, 75, 0, 76, 0, 625, 0, 331, 0, 596, 0, 934, 0, 611, 0, 640, 0, 643, 0, 952, 0, 650, 0, 652, 0, 339, 0, 967, 0, 248, 0, 658, 0, 810, 0, 92, 0, 93, 0, 94, 0, 95, 0, 96, 0, 97, 0, 98, 0, 99, 0, 100, 0, 101, 0, 102, 0, 609, 0, 104, 0, 105, 0, 106, 0, 107, 0, 108, 0, 109, 0, 110, 0, 111, 0, 112, 0, 113, 0, 114, 0, 115, 0, 116, 0, 117, 0, 118, 0, 119, 0, 120, 0, 121, 0, 122, 0, 123, 0, 124, 0, 125, 0, 771, 0, 127, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__str8124=allocate([61,61,44,44,39,39,0] /* ==,,''\00 */, "i8", ALLOC_STATIC);
__str9125=allocate([40,37,115,41,0] /* (%s)\00 */, "i8", ALLOC_STATIC);
__ZL15stress_phonemes=allocate([3,2,4,5,6,7,26] /* \03\02\04\05\06\07\1 */, "i8", ALLOC_STATIC);
__ZZ13SetWordStressP10TranslatorPcPjiiE15consonant_types=allocate([0,0,0,1,1,1,1,1,1,1,0,0,0,0,0,0] /* \00\00\00\01\01\01\0 */, "i8", ALLOC_STATIC);
__ZZ13SetWordStressP10TranslatorPcPjiiE8guess_ru=allocate([0,0,1,1,2,3,3,4,5,6,7,7,8,9,10,11] /* \00\00\01\01\02\03\0 */, "i8", ALLOC_STATIC);
__ZZ13SetWordStressP10TranslatorPcPjiiE10guess_ru_v=allocate([0,0,1,1,2,2,3,3,4,5,6,7,7,8,9,10] /* \00\00\01\01\02\02\0 */, "i8", ALLOC_STATIC);
__ZZ13SetWordStressP10TranslatorPcPjiiE10guess_ru_t=allocate([0,0,1,2,3,3,3,4,5,6,7,7,7,8,9,10] /* \00\00\01\02\03\03\0 */, "i8", ALLOC_STATIC);
__ZZ14TranslateRulesP10TranslatorPcS1_iS1_iPjE9str_pause=allocate([11,0] /* \0B\00 */, "i8", ALLOC_STATIC);
__str10126=allocate([85,110,112,114,111,110,111,117,110,99,97,98,108,101,63,32,39,37,115,39,10,0] /* Unpronouncable? '%s' */, "i8", ALLOC_STATIC);
__str11127=allocate([84,114,97,110,115,108,97,116,101,32,39,37,115,39,10,0] /* Translate '%s'\0A\00 */, "i8", ALLOC_STATIC);
__ZL13diereses_list=allocate([228, 0, 235, 0, 239, 0, 246, 0, 252, 0, 255, 0, 0, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ14LookupDictListP10TranslatorPPcS1_PjiP8WORD_TABE16word_replacement=allocate(160, "i8", ALLOC_STATIC);
__str15131=allocate([37,115,32,0] /* %s \00 */, "i8", ALLOC_STATIC);
__str16132=allocate([82,101,112,108,97,99,101,58,32,37,115,32,32,37,115,10,0] /* Replace: %s  %s\0A\0 */, "i8", ALLOC_STATIC);
__ZZ11LookupFlagsP10TranslatorPKcE5flags=allocate(8, "i32", ALLOC_STATIC);
__ZZ12RemoveEndingP10TranslatorPciS1_E6ending=allocate(12, "i8", ALLOC_STATIC);
__ZZ12RemoveEndingP10TranslatorPciS1_E16add_e_exceptions=allocate(8, "i8*", ALLOC_STATIC);
__str17133=allocate([105,111,110,0] /* ion\00 */, "i8", ALLOC_STATIC);
__ZZ12RemoveEndingP10TranslatorPciS1_E15add_e_additions=allocate(32, "i8*", ALLOC_STATIC);
__str18134=allocate([99,0] /* c\00 */, "i8", ALLOC_STATIC);
__str19135=allocate([114,115,0] /* rs\00 */, "i8", ALLOC_STATIC);
__str20136=allocate([105,114,0] /* ir\00 */, "i8", ALLOC_STATIC);
__str21137=allocate([117,114,0] /* ur\00 */, "i8", ALLOC_STATIC);
__str22138=allocate([97,116,104,0] /* ath\00 */, "i8", ALLOC_STATIC);
__str23139=allocate([110,115,0] /* ns\00 */, "i8", ALLOC_STATIC);
__str24140=allocate([117,0] /* u\00 */, "i8", ALLOC_STATIC);
__str25141=allocate([97,100,100,32,101,10,0] /* add e\0A\00 */, "i8", ALLOC_STATIC);
__str27143=allocate([101,115,0] /* es\00 */, "i8", ALLOC_STATIC);
__str28144=allocate([70,108,97,103,115,58,32,32,37,115,32,32,37,115,10,0] /* Flags:  %s  %s\0A\00 */, "i8", ALLOC_STATIC);
__str29145=allocate([70,111,117,110,100,58,32,39,37,115,32,37,115,0] /* Found: '%s %s\00 */, "i8", ALLOC_STATIC);
__str30146=allocate([70,111,117,110,100,58,32,39,37,115,0] /* Found: '%s\00 */, "i8", ALLOC_STATIC);
__str31147=allocate([39,32,91,37,115,93,32,32,37,115,10,0] /* ' [%s]  %s\0A\00 */, "i8", ALLOC_STATIC);
__ZZL9MatchRuleP10TranslatorPPcS1_iS1_P11MatchRecordiiE4best=allocate(16, ["i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0], ALLOC_STATIC);
__str32148=allocate([37,51,100,9,37,115,32,91,37,115,93,10,0] /* %3d\09%s [%s]\0A\00 */, "i8", ALLOC_STATIC);
__str34150=allocate([66,97,100,32,114,117,108,101,115,32,100,97,116,97,32,105,110,32,39,37,115,95,100,105,99,116,39,32,97,116,32,48,120,37,120,10,0] /* Bad rules data in '% */, "i8", ALLOC_STATIC);
_env_fall=allocate([255,253,250,248,246,244,242,240,238,236,234,232,230,228,226,224,222,220,218,216,214,212,210,208,206,204,202,200,198,196,194,192,190,188,186,184,182,180,178,176,174,172,170,168,166,164,162,160,158,156,154,152,150,148,146,144,142,140,138,136,134,132,130,128,126,124,122,120,118,116,114,112,110,108,106,104,102,100,98,96,94,92,90,88,86,84,82,80,78,76,74,72,70,68,66,64,62,60,58,56,54,52,50,48,46,44,42,40,38,36,34,32,30,28,26,24,22,20,18,16,14,12,10,8,6,4,2,0] /* \FF\FD\FA\F8\F6\F4\F */, "i8", ALLOC_STATIC);
_env_rise=allocate([0,2,4,6,8,10,12,14,16,18,20,22,24,26,28,30,32,34,36,38,40,42,44,46,48,50,52,54,56,58,60,62,64,66,68,70,72,74,76,78,80,82,84,86,88,90,92,94,96,98,100,102,104,106,108,110,112,114,116,118,120,122,124,126,128,130,132,134,136,138,140,142,144,146,148,150,152,154,156,158,160,162,164,166,168,170,172,174,176,178,180,182,184,186,188,190,192,194,196,198,200,202,204,206,208,210,212,214,216,218,220,222,224,226,228,230,232,234,236,238,240,242,244,246,248,250,253,255] /* \00\02\04\06\08\0A\0 */, "i8", ALLOC_STATIC);
_env_frise=allocate([255,244,234,224,214,204,195,186,177,168,159,151,143,135,127,120,113,106,99,92,86,80,74,68,63,57,52,47,43,38,34,30,26,23,19,16,13,11,8,6,4,2,1,0,0,0,0,0,0,0,1,2,3,4,5,7,8,10,12,14,16,19,21,23,26,29,31,34,37,40,44,46,48,50,52,54,57,59,61,64,66,69,71,74,76,79,81,84,87,90,93,95,98,101,104,107,110,113,116,120,123,126,129,133,136,139,143,146,150,153,157,160,164,168,172,175,179,183,187,191,195,199,203,207,211,215,219,224] /* \FF\F4\EA\E0\D6\CC\C */, "i8", ALLOC_STATIC);
__ZL11env_r_frise=allocate([207,204,201,198,195,192,189,185,180,176,171,167,162,156,151,146,140,134,129,123,117,111,105,99,93,87,80,74,68,62,56,51,45,39,34,28,23,18,13,8,4,2,2,1,0,0,0,0,0,1,1,2,3,4,5,7,8,10,12,13,15,18,20,22,25,27,30,33,36,39,42,45,48,52,54,56,58,60,63,65,67,70,72,75,77,80,82,85,88,90,93,96,99,102,105,108,111,114,117,120,123,126,129,133,136,139,143,146,150,153,157,160,164,168,172,175,179,183,187,191,195,199,203,207,211,215,219,224] /* \CF\CC\C9\C6\C3\C0\B */, "i8", ALLOC_STATIC);
__ZL10env_frise2=allocate([255,249,244,238,233,228,223,218,213,208,203,198,193,189,184,179,175,170,166,161,157,153,149,144,140,136,132,128,125,121,117,113,110,106,103,99,96,93,89,86,83,80,77,74,71,68,65,62,60,57,55,52,50,47,45,43,40,38,36,34,32,30,28,26,25,23,21,20,18,17,15,14,13,12,10,9,8,7,6,5,5,4,3,2,2,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,2,2,3,4,4,5,6,7,8,9,10,11,12,14,15,16,18,19,21,23,24,26,28,30,32] /* \FF\F9\F4\EE\E9\E4\D */, "i8", ALLOC_STATIC);
__ZL12env_r_frise2=allocate([208,206,205,204,202,200,199,197,195,193,192,189,187,184,181,179,176,173,170,167,163,160,157,153,150,146,143,139,135,132,128,124,120,116,112,109,105,101,97,93,89,85,81,77,74,70,66,62,59,55,52,49,47,45,42,40,38,36,34,32,30,28,26,25,23,21,20,18,17,15,14,13,12,10,9,8,7,6,5,5,4,3,2,2,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,2,2,3,4,4,5,6,7,8,9,10,11,12,14,15,16,18,19,21,23,24,26,28,30,32] /* \D0\CE\CD\CC\CA\C8\C */, "i8", ALLOC_STATIC);
__ZL12env_risefall=allocate([152,153,153,154,156,157,159,161,164,167,169,172,176,179,182,186,190,193,197,201,205,209,212,216,220,223,227,230,234,237,240,242,245,247,249,251,252,253,254,254,255,255,255,255,255,255,254,253,251,250,248,246,243,241,238,236,233,230,228,224,221,218,215,211,208,204,200,196,192,188,184,180,176,172,167,163,159,154,150,145,141,136,132,127,123,118,114,109,105,101,96,92,88,84,80,76,72,68,64,60,57,53,50,47,43,40,38,35,32,29,26,23,21,18,15,13,10,8,7,5,3,2,1,0,0,0,0,0] /* \98\99\99\9A\9C\9D\9 */, "i8", ALLOC_STATIC);
__ZL13env_fallrise3=allocate([254,255,255,255,255,255,254,253,252,250,248,246,244,241,238,235,232,229,225,222,218,214,210,205,201,196,191,186,182,176,171,166,161,156,150,145,139,134,128,123,117,111,106,100,95,89,84,79,73,68,63,58,53,48,43,38,34,29,25,21,17,13,10,7,4,3,1,0,0,0,0,0,0,0,0,1,1,2,4,5,7,9,11,13,16,18,21,24,27,30,34,37,41,45,49,53,58,62,67,72,76,81,87,91,94,98,101,104,107,110,113,116,118,120,123,124,126,128,129,130,131,131,132,132,131,131,130,129] /* \FE\FF\FF\FF\FF\FF\F */, "i8", ALLOC_STATIC);
__ZL13env_fallrise4=allocate([114,114,113,113,112,111,109,108,106,104,102,100,97,95,92,90,87,84,81,78,75,72,69,66,63,59,56,53,50,47,44,41,38,35,32,29,27,24,22,20,18,16,14,12,11,10,9,8,7,7,7,7,7,6,5,5,5,5,5,5,5,5,5,6,7,7,8,9,10,12,13,15,16,18,20,22,24,27,29,32,35,38,41,44,47,51,55,59,63,67,71,76,81,86,91,96,101,106,111,116,121,127,132,137,143,149,155,161,167,173,179,186,192,199,206,213,220,227,234,241,245,247,250,252,253,254,255,255] /* rrqqpomljhfda_\5CZWT */, "i8", ALLOC_STATIC);
__ZL9env_fall2=allocate([254,254,253,253,252,251,251,250,250,249,248,248,247,247,246,246,245,244,244,243,243,242,242,241,240,240,239,238,238,237,236,235,234,234,233,232,231,230,229,228,227,226,225,224,222,221,220,219,217,216,214,213,211,210,208,206,204,203,201,199,197,195,192,190,188,185,183,181,178,175,173,170,167,164,161,158,154,151,148,144,141,137,133,129,125,121,117,113,109,104,100,97,94,91,87,84,81,77,74,70,67,64,60,57,53,50,46,42,39,35,31,28,24,20,17,13,11,9,7,5,4,3,2,1,0,0,0,0] /* \FE\FE\FD\FD\FC\FB\F */, "i8", ALLOC_STATIC);
__ZL9env_rise2=allocate([0,0,0,0,1,1,1,2,2,3,3,4,4,5,6,6,7,8,8,9,10,11,12,12,13,14,15,16,17,18,19,20,22,23,24,25,27,28,29,31,32,34,35,37,38,40,41,43,45,47,48,50,52,54,56,58,60,62,64,66,68,71,73,75,78,80,82,85,87,90,93,95,98,101,103,106,109,112,115,118,121,124,127,130,134,137,140,144,147,150,154,157,160,163,166,169,172,175,178,181,184,187,190,193,196,199,202,205,208,211,214,217,220,223,226,228,231,233,236,238,240,242,244,246,248,250,251,253] /* \00\00\00\00\01\01\0 */, "i8", ALLOC_STATIC);
__ZL16env_risefallrise=allocate([127,127,127,128,129,131,132,135,137,140,143,146,150,153,157,161,165,170,174,178,183,187,192,197,201,205,210,214,218,222,226,230,234,237,240,243,245,248,250,251,252,253,254,254,253,252,251,249,247,244,240,236,231,226,220,213,206,198,189,180,169,158,146,136,130,125,119,114,108,102,96,90,84,78,73,66,60,55,50,45,40,36,31,27,24,20,17,14,12,9,7,6,5,4,4,4,4,5,6,8,10,13,16,20,24,29,35,41,47,55,62,71,80,90,100,112,124,131,133,136,138,140,142,143,145,146,147,147] /* \7F\7F\7F\80\81\83\8 */, "i8", ALLOC_STATIC);
_envelope_data=allocate(80, "i8*", ALLOC_STATIC);
__ZL18tone_nucleus_table=allocate([0, 64, 8, 0, 70, 18, 0, 0, 0, 0, 0, 0, 24, 12, 0, undef, 4, 80, 18, 6, 78, 22, 0, 0, 0, 0, 0, 0, 34, 52, 0, undef, 4, 88, 22, 6, 82, 22, 0, 0, 0, 0, 0, 0, 34, 64, 0, undef, 0, 92, 8, 0, 92, 80, 0, 0, 0, 0, 0, 0, 76, 8, 1, undef, 0, 86, 4, 0, 94, 66, 0, 0, 0, 0, 0, 0, 34, 10, 0, undef, 0, 62, 10, 0, 62, 20, 0, 0, 0, 0, 0, 0, 28, 16, 0, undef, 4, 68, 18, 6, 68, 22, 0, 0, 0, 0, 0, 0, 30, 44, 0, undef, 6, 64, 16, 0, 66, 32, 0, 0, 0, 0, 0, 0, 32, 18, 0, undef, 2, 68, 46, 0, 42, 32, 0, 0, 0, 0, 0, 0, 46, 58, 0, undef, 4, 78, 24, 6, 72, 22, 0, 0, 0, 0, 0, 0, 42, 52, 0, undef, 4, 88, 34, 0, 64, 32, 0, 0, 0, 0, 0, 0, 46, 82, 0, undef, 0, 56, 12, 0, 56, 20, 0, 0, 0, 0, 0, 0, 24, 12, 0, undef, 0, 70, 18, 0, 70, 24, 0, 0, 0, 0, 0, 0, 32, 20, 0, undef], ["i8","i8","i8","i8","i8","i8",0,0,"i16*",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i16*",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i16*",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i16*",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i16*",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i16*",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i16*",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i16*",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i16*",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i16*",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i16*",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i16*",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i16*",0,0,0,"i8","i8","i8","i8"], ALLOC_STATIC);
_punctuation_to_tone=allocate([0, 1, 2, 3, 0, 4, 0, 1, 2, 3, 0, 4, 5, 6, 2, 3, 0, 4, 5, 7, 1, 3, 0, 4, 8, 9, 10, 3, 0, 0, 8, 8, 10, 3, 0, 0, 11, 11, 11, 11, 0, 0, 12, 12, 12, 12, 0, 0], "i8", ALLOC_STATIC);
_n_tunes=allocate(1, "i32", ALLOC_STATIC);
_tunes=allocate(1, "%struct.TUNE*", ALLOC_STATIC);
__ZL12syllable_tab=allocate(1, "%struct.SYLLABLE*", ALLOC_STATIC);
__ZL8no_tonic_b=allocate(1, "i1", ALLOC_STATIC);
__ZL15tone_head_table=allocate([46, 57, 78, 50, 0, 0, 0, 0, 3, 7, 5, 0, 0, 0, 0, 0, 46, 57, 78, 46, 0, 0, 0, 0, 3, 7, 5, 0, 0, 0, 0, 0, 46, 57, 78, 46, 0, 0, 0, 0, 3, 7, 5, 0, 0, 0, 0, 0, 46, 57, 90, 50, 0, 0, 0, 0, 3, 9, 5, 0, 0, 0, 0, 0, 46, 57, 78, 50, 0, 0, 0, 0, 3, 7, 5, 0, 0, 0, 0, 0, 46, 57, 74, 55, 0, 0, 0, 0, 4, 7, 5, 0, 0, 0, 0, 0, 46, 57, 74, 55, 0, 0, 0, 0, 4, 7, 5, 0, 0, 0, 0, 0, 46, 57, 74, 55, 0, 0, 0, 0, 4, 7, 5, 0, 0, 0, 0, 0, 46, 57, 78, 50, 0, 0, 0, 0, 3, 7, 5, 0, 0, 0, 0, 0, 46, 57, 78, 46, 0, 0, 0, 0, 3, 7, 5, 0, 0, 0, 0, 0, 46, 57, 78, 50, 0, 0, 0, 0, 3, 7, 5, 0, 0, 0, 0, 0, 34, 41, 41, 32, 0, 0, 0, 0, 3, 7, 5, 0, 0, 0, 0, 0, 46, 57, 55, 50, 0, 0, 0, 0, 3, 7, 5, 0, 0, 0, 0, 0], ["i8","i8","i8","i8","i32*",0,0,0,"i8","i8","i8",0,"i8*",0,0,0,"i8","i8","i8","i8","i32*",0,0,0,"i8","i8","i8",0,"i8*",0,0,0,"i8","i8","i8","i8","i32*",0,0,0,"i8","i8","i8",0,"i8*",0,0,0,"i8","i8","i8","i8","i32*",0,0,0,"i8","i8","i8",0,"i8*",0,0,0,"i8","i8","i8","i8","i32*",0,0,0,"i8","i8","i8",0,"i8*",0,0,0,"i8","i8","i8","i8","i32*",0,0,0,"i8","i8","i8",0,"i8*",0,0,0,"i8","i8","i8","i8","i32*",0,0,0,"i8","i8","i8",0,"i8*",0,0,0,"i8","i8","i8","i8","i32*",0,0,0,"i8","i8","i8",0,"i8*",0,0,0,"i8","i8","i8","i8","i32*",0,0,0,"i8","i8","i8",0,"i8*",0,0,0,"i8","i8","i8","i8","i32*",0,0,0,"i8","i8","i8",0,"i8*",0,0,0,"i8","i8","i8","i8","i32*",0,0,0,"i8","i8","i8",0,"i8*",0,0,0,"i8","i8","i8","i8","i32*",0,0,0,"i8","i8","i8",0,"i8*",0,0,0,"i8","i8","i8","i8","i32*",0,0,0,"i8","i8","i8",0,"i8*",0,0,0], ALLOC_STATIC);
__ZL10number_pre=allocate(1, "i32", ALLOC_STATIC);
__ZL10tone_posn2=allocate(1, "i32", ALLOC_STATIC);
__ZL9tone_posn=allocate(1, "i32", ALLOC_STATIC);
__ZL11number_tail=allocate(1, "i32", ALLOC_STATIC);
__ZL14tone_pitch_env=allocate(1, "i32", ALLOC_STATIC);
__ZZL18calc_pitch_segmentiiP9TONE_HEADP12TONE_NUCLEUSiiE12continue_tab=allocate([230,32,20,8,0] /* \E6 \14\08\00 */, "i8", ALLOC_STATIC);
__ZL8min_drop=allocate([6, 0, 0, 0, 7, 0, 0, 0, 9, 0, 0, 0, 9, 0, 0, 0, 20, 0, 0, 0, 20, 0, 0, 0, 20, 0, 0, 0, 25, 0, 0, 0], ["i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__ZL7drops_0=allocate([9, 0, 0, 0, 9, 0, 0, 0, 16, 0, 0, 0, 16, 0, 0, 0, 16, 0, 0, 0, 23, 0, 0, 0, 55, 0, 0, 0, 32, 0, 0, 0], ["i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__ZL5oflow=allocate([0,40,24,8,0] /* \00(\18\08\00 */, "i8", ALLOC_STATIC);
__ZL9oflow_emf=allocate([10,52,32,20,10] /* \0A4 \14\0A */, "i8", ALLOC_STATIC);
__ZL10oflow_less=allocate([6,38,24,14,4] /* \06&\18\0E\04 */, "i8", ALLOC_STATIC);
__ZL12last_primary=allocate(1, "i32", ALLOC_STATIC);
_namedata=allocate(1, "i8*", ALLOC_STATIC);
__ZL7f_input=allocate(1, "%struct.__sFILE*", ALLOC_STATIC);
_p_textinput=allocate(1, "i8*", ALLOC_STATIC);
_p_wchar_input=allocate(1, "i32*", ALLOC_STATIC);
__ZL10ungot_word=allocate(1, "i8*", ALLOC_STATIC);
_count_characters=allocate(1, "i32", ALLOC_STATIC);
__ZL10ssml_stack=allocate(1520, ["i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8"], ALLOC_STATIC);
__ZL16current_voice_id=allocate(40, "i8", ALLOC_STATIC);
_param_stack=allocate(1280, "i32", ALLOC_STATIC);
_param_defaults=allocate([0, 0, 0, 0, 175, 0, 0, 0, 100, 0, 0, 0, 50, 0, 0, 0, 50, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], ["i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0], ALLOC_STATIC);
_walpha_tab=allocate([1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,254,255,1,255,1,255,1,255,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,255,1,255,1,255,1,255,255,255,210,1,255,1,255,206,1,255,205,205,1,255,255,79,202,203,1,255,205,207,255,211,209,1,255,255,255,211,213,255,214,1,255,1,255,1,255,218,1,255,218,255,255,1,255,218,1,255,217,217,1,255,1,255,219,1,255,255,255,1,255,255,255,255,255,255,255,2,1,255,2,1,255,2,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,255,2,1,255,1,255,255,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,255,0,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255] /* \01\FF\01\FF\01\FF\0 */, "i8", ALLOC_STATIC);
__ZL10ungot_char=allocate(1, "i32", ALLOC_STATIC);
__ZL12end_of_input_b=allocate(1, "i1", ALLOC_STATIC);
__str167=allocate([115,112,101,97,107,0] /* speak\00 */, "i8", ALLOC_STATIC);
__str1168=allocate([118,111,105,99,101,0] /* voice\00 */, "i8", ALLOC_STATIC);
__str2169=allocate([112,114,111,115,111,100,121,0] /* prosody\00 */, "i8", ALLOC_STATIC);
__str3170=allocate([115,97,121,45,97,115,0] /* say-as\00 */, "i8", ALLOC_STATIC);
__str4171=allocate([109,97,114,107,0] /* mark\00 */, "i8", ALLOC_STATIC);
__str5172=allocate([115,0] /* s\00 */, "i8", ALLOC_STATIC);
__str6173=allocate([112,0] /* p\00 */, "i8", ALLOC_STATIC);
__str7174=allocate([112,104,111,110,101,109,101,0] /* phoneme\00 */, "i8", ALLOC_STATIC);
__str8175=allocate([115,117,98,0] /* sub\00 */, "i8", ALLOC_STATIC);
__str9176=allocate([116,116,115,58,115,116,121,108,101,0] /* tts:style\00 */, "i8", ALLOC_STATIC);
__str10177=allocate([97,117,100,105,111,0] /* audio\00 */, "i8", ALLOC_STATIC);
__str11178=allocate([101,109,112,104,97,115,105,115,0] /* emphasis\00 */, "i8", ALLOC_STATIC);
__str12179=allocate([98,114,101,97,107,0] /* break\00 */, "i8", ALLOC_STATIC);
__str13180=allocate([109,101,116,97,100,97,116,97,0] /* metadata\00 */, "i8", ALLOC_STATIC);
__str14181=allocate([98,114,0] /* br\00 */, "i8", ALLOC_STATIC);
__str15182=allocate([108,105,0] /* li\00 */, "i8", ALLOC_STATIC);
__str16183=allocate([100,100,0] /* dd\00 */, "i8", ALLOC_STATIC);
__str17184=allocate([105,109,103,0] /* img\00 */, "i8", ALLOC_STATIC);
__str18185=allocate([116,100,0] /* td\00 */, "i8", ALLOC_STATIC);
__str19186=allocate([104,49,0] /* h1\00 */, "i8", ALLOC_STATIC);
__str20187=allocate([104,50,0] /* h2\00 */, "i8", ALLOC_STATIC);
__str21188=allocate([104,51,0] /* h3\00 */, "i8", ALLOC_STATIC);
__str22189=allocate([104,52,0] /* h4\00 */, "i8", ALLOC_STATIC);
__str23190=allocate([104,114,0] /* hr\00 */, "i8", ALLOC_STATIC);
__str24191=allocate([115,99,114,105,112,116,0] /* script\00 */, "i8", ALLOC_STATIC);
__str25192=allocate([115,116,121,108,101,0] /* style\00 */, "i8", ALLOC_STATIC);
__str26193=allocate([102,111,110,116,0] /* font\00 */, "i8", ALLOC_STATIC);
__str27194=allocate([98,0] /* b\00 */, "i8", ALLOC_STATIC);
__str28195=allocate([105,0] /* i\00 */, "i8", ALLOC_STATIC);
__str29196=allocate([115,116,114,111,110,103,0] /* strong\00 */, "i8", ALLOC_STATIC);
__str30197=allocate([101,109,0] /* em\00 */, "i8", ALLOC_STATIC);
__str31198=allocate([99,111,100,101,0] /* code\00 */, "i8", ALLOC_STATIC);
__ZL8ssmltags=allocate([0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 4, 0, 0, 0, 0, 0, 0, 0, 5, 0, 0, 0, 0, 0, 0, 0, 6, 0, 0, 0, 0, 0, 0, 0, 7, 0, 0, 0, 0, 0, 0, 0, 8, 0, 0, 0, 0, 0, 0, 0, 9, 0, 0, 0, 0, 0, 0, 0, 10, 0, 0, 0, 0, 0, 0, 0, 11, 0, 0, 0, 0, 0, 0, 0, 12, 0, 0, 0, 0, 0, 0, 0, 13, 0, 0, 0, 0, 0, 0, 0, 14, 0, 0, 0, 0, 0, 0, 0, 15, 0, 0, 0, 0, 0, 0, 0, 15, 0, 0, 0, 0, 0, 0, 0, 15, 0, 0, 0, 0, 0, 0, 0, 15, 0, 0, 0, 0, 0, 0, 0, 15, 0, 0, 0, 0, 0, 0, 0, 7, 0, 0, 0, 0, 0, 0, 0, 7, 0, 0, 0, 0, 0, 0, 0, 7, 0, 0, 0, 0, 0, 0, 0, 7, 0, 0, 0, 0, 0, 0, 0, 7, 0, 0, 0, 0, 0, 0, 0, 14, 0, 0, 0, 0, 0, 0, 0, 14, 0, 0, 0, 0, 0, 0, 0, 16, 0, 0, 0, 0, 0, 0, 0, 16, 0, 0, 0, 0, 0, 0, 0, 16, 0, 0, 0, 0, 0, 0, 0, 16, 0, 0, 0, 0, 0, 0, 0, 16, 0, 0, 0, 0, 0, 0, 0, 16, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__ZL10n_namedata=allocate(1, "i32", ALLOC_STATIC);
__ZL11namedata_ix=allocate(1, "i32", ALLOC_STATIC);
__str32199=allocate([103,116,0] /* gt\00 */, "i8", ALLOC_STATIC);
__str33200=allocate([108,116,0] /* lt\00 */, "i8", ALLOC_STATIC);
__str34201=allocate([97,109,112,0] /* amp\00 */, "i8", ALLOC_STATIC);
__str35202=allocate([113,117,111,116,0] /* quot\00 */, "i8", ALLOC_STATIC);
__str36203=allocate([110,98,115,112,0] /* nbsp\00 */, "i8", ALLOC_STATIC);
__str37204=allocate([97,112,111,115,0] /* apos\00 */, "i8", ALLOC_STATIC);
__ZL18xml_char_mnemonics=allocate([0, 0, 0, 0, 62, 0, 0, 0, 0, 0, 0, 0, 57404, 0, 0, 0, 0, 0, 0, 0, 38, 0, 0, 0, 0, 0, 0, 0, 34, 0, 0, 0, 0, 0, 0, 0, 32, 0, 0, 0, 0, 0, 0, 0, 39, 0, 0, 0, 0, 0, 0, 0, -1, 0, 0, 0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__ZZ10ReadClauseP10TranslatorP7__sFILEPcPsPiiS5_S3_E12ungot_string=allocate(24, "i8", ALLOC_STATIC);
__ZZ10ReadClauseP10TranslatorP7__sFILEPcPsPiiS5_S3_E15ungot_string_ix=allocate([-1], ["i32",0,0,0,0], ALLOC_STATIC);
__ZL19clear_skipping_text_b=allocate(1, "i1", ALLOC_STATIC);
__ZL11ungot_char2=allocate(1, "i32", ALLOC_STATIC);
__ZL19ssml_ignore_l_angle=allocate(1, "i32", ALLOC_STATIC);
__str38205=allocate([37,115,37,99,37,99,0] /* %s%c%c\00 */, "i8", ALLOC_STATIC);
__ZL10sayas_mode=allocate(1, "i32", ALLOC_STATIC);
__ZL11ignore_text_b=allocate(1, "i1", ALLOC_STATIC);
__ZL11punct_chars=allocate([44, 0, 46, 0, 63, 0, 33, 0, 58, 0, 59, 0, 8211, 0, 8212, 0, 8230, 0, 894, 0, 903, 0, 2404, 0, 1417, 0, 1373, 0, 1372, 0, 1374, 0, 1371, 0, 2843, 0, 1567, 0, 4962, 0, 4963, 0, 4964, 0, 4965, 0, 4966, 0, 4967, 0, 4968, 0, 4347, 0, 12289, 0, 12290, 0, -255, 0, -244, 0, -242, 0, -230, 0, -229, 0, -225, 0, 0, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZL16punct_attributes=allocate([0, 0, 0, 0, 266260, 0, 0, 0, 524328, 0, 0, 0, 532520, 0, 0, 0, 536621, 0, 0, 0, 262174, 0, 0, 0, 266270, 0, 0, 0, 266270, 0, 0, 0, 266270, 0, 0, 0, 2396190, 0, 0, 0, 532520, 0, 0, 0, 266270, 0, 0, 0, 557096, 0, 0, 0, 557096, 0, 0, 0, 266260, 0, 0, 0, 1585197, 0, 0, 0, 1581096, 0, 0, 0, 1572904, 0, 0, 0, 266270, 0, 0, 0, 532520, 0, 0, 0, 524328, 0, 0, 0, 266260, 0, 0, 0, 266270, 0, 0, 0, 262174, 0, 0, 0, 262174, 0, 0, 0, 532520, 0, 0, 0, 524358, 0, 0, 0, 524358, 0, 0, 0, 299028, 0, 0, 0, 557096, 0, 0, 0, 569389, 0, 0, 0, 299028, 0, 0, 0, 557096, 0, 0, 0, 294942, 0, 0, 0, 299038, 0, 0, 0, 565288, 0, 0, 0, 266270, 0, 0, 0, 0, 0, 0, 0], ["i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__str41208=allocate([32,32,32,0] /*    \00 */, "i8", ALLOC_STATIC);
__ZL12chars_ignore=allocate([8204, 0, 8205, 0, 0, 0], ["i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__str42209=allocate([105,32,0] /* i \00 */, "i8", ALLOC_STATIC);
__ZL10audio_text_b=allocate(1, "i1", ALLOC_STATIC);
__ZL17speech_parameters=allocate(60, "i32", ALLOC_STATIC);
__ZL12n_ssml_stack=allocate(1, "i32", ALLOC_STATIC);
__ZL13n_param_stack=allocate(1, "i32", ALLOC_STATIC);
__ZL7xmlbase=allocate(1, "i8*", ALLOC_STATIC);
__ZZL14LookupCharNameP10TranslatoriiE3buf=allocate(60, "i8", ALLOC_STATIC);
__str47214=allocate([91,2,95,94,95,37,115,32,37,115,32,95,94,95,37,115,93,93,0] /* [\02_^_%s %s _^_%s]] */, "i8", ALLOC_STATIC);
__str48215=allocate([91,2,37,115,93,93,32,0] /* [\02%s]] \00 */, "i8", ALLOC_STATIC);
__str49216=allocate([91,2,40,88,49,41,40,88,49,41,40,88,49,41,93,93,0] /* [\02(X1)(X1)(X1)]]\0 */, "i8", ALLOC_STATIC);
__ZZL13WordToString2jE3buf=allocate(5, "i8", ALLOC_STATIC);
__str50217=allocate([1,37,100,73,32,0] /* \01%dI \00 */, "i8", ALLOC_STATIC);
__str51218=allocate([32,37,115,0] /*  %s\00 */, "i8", ALLOC_STATIC);
__str52219=allocate([1,43,49,48,83,0] /* \01+10S\00 */, "i8", ALLOC_STATIC);
__str53220=allocate([32,1,45,49,48,83,0] /*  \01-10S\00 */, "i8", ALLOC_STATIC);
__str54221=allocate([32,37,115,32,37,100,32,37,115,0] /*  %s %d %s\00 */, "i8", ALLOC_STATIC);
__str55222=allocate([37,115,37,99,115,111,117,110,100,105,99,111,110,115,37,99,37,115,0] /* %s%csoundicons%c%s\0 */, "i8", ALLOC_STATIC);
__str57224=allocate([112,111,108,121,112,104,97,115,101,0] /* polyphase\00 */, "i8", ALLOC_STATIC);
__str58225=allocate([47,116,109,112,47,101,115,112,101,97,107,88,88,88,88,88,88,0] /* /tmp/espeakXXXXXX\00 */, "i8", ALLOC_STATIC);
__str59226=allocate([115,111,120,32,34,37,115,34,32,45,114,32,37,100,32,45,119,32,45,115,32,45,99,49,32,37,115,32,37,115,10,0] /* sox \22%s\22 -r %d - */, "i8", ALLOC_STATIC);
__str60227=allocate([91,2,37,115,93,93,0] /* [\02%s]]\00 */, "i8", ALLOC_STATIC);
__ZZL14ProcessSsmlTagPwPcRiiiE10mnem_punct=allocate([0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 0, -1, 0, 0, 0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__str61228=allocate([110,111,110,101,0] /* none\00 */, "i8", ALLOC_STATIC);
__str62229=allocate([97,108,108,0] /* all\00 */, "i8", ALLOC_STATIC);
__str63230=allocate([115,111,109,101,0] /* some\00 */, "i8", ALLOC_STATIC);
__ZZL14ProcessSsmlTagPwPcRiiiE13mnem_capitals=allocate([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 20, 0, 0, 0, 0, 0, 0, 0, -1, 0, 0, 0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__str64231=allocate([110,111,0] /* no\00 */, "i8", ALLOC_STATIC);
__str65232=allocate([115,112,101,108,108,105,110,103,0] /* spelling\00 */, "i8", ALLOC_STATIC);
__str66233=allocate([105,99,111,110,0] /* icon\00 */, "i8", ALLOC_STATIC);
__ZZL14ProcessSsmlTagPwPcRiiiE17mnem_interpret_as=allocate([0, 0, 0, 0, 18, 0, 0, 0, 0, 0, 0, 0, 20, 0, 0, 0, 0, 0, 0, 0, 36, 0, 0, 0, 0, 0, 0, 0, 64, 0, 0, 0, 0, 0, 0, 0, 193, 0, 0, 0, 0, 0, 0, 0, -1, 0, 0, 0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__str68235=allocate([99,104,97,114,97,99,116,101,114,115,0] /* characters\00 */, "i8", ALLOC_STATIC);
__str69236=allocate([116,116,115,58,99,104,97,114,0] /* tts:char\00 */, "i8", ALLOC_STATIC);
__str70237=allocate([116,116,115,58,107,101,121,0] /* tts:key\00 */, "i8", ALLOC_STATIC);
__str71238=allocate([116,116,115,58,100,105,103,105,116,115,0] /* tts:digits\00 */, "i8", ALLOC_STATIC);
__str72239=allocate([116,101,108,101,112,104,111,110,101,0] /* telephone\00 */, "i8", ALLOC_STATIC);
__ZZL14ProcessSsmlTagPwPcRiiiE17mnem_sayas_format=allocate([0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, -1, 0, 0, 0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__str73240=allocate([103,108,121,112,104,115,0] /* glyphs\00 */, "i8", ALLOC_STATIC);
__ZZL14ProcessSsmlTagPwPcRiiiE10mnem_break=allocate([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 4, 0, 0, 0, 0, 0, 0, 0, 5, 0, 0, 0, 0, 0, 0, 0, -1, 0, 0, 0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__str74241=allocate([120,45,119,101,97,107,0] /* x-weak\00 */, "i8", ALLOC_STATIC);
__str75242=allocate([119,101,97,107,0] /* weak\00 */, "i8", ALLOC_STATIC);
__str76243=allocate([109,101,100,105,117,109,0] /* medium\00 */, "i8", ALLOC_STATIC);
__str77244=allocate([120,45,115,116,114,111,110,103,0] /* x-strong\00 */, "i8", ALLOC_STATIC);
__ZZL14ProcessSsmlTagPwPcRiiiE13mnem_emphasis=allocate([0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 4, 0, 0, 0, 0, 0, 0, 0, -1, 0, 0, 0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__str78245=allocate([114,101,100,117,99,101,100,0] /* reduced\00 */, "i8", ALLOC_STATIC);
__str79246=allocate([109,111,100,101,114,97,116,101,0] /* moderate\00 */, "i8", ALLOC_STATIC);
__ZZL14ProcessSsmlTagPwPcRiiiE12prosody_attr=allocate(20, "i8*", ALLOC_STATIC);
__str80247=allocate([114,97,116,101,0] /* rate\00 */, "i8", ALLOC_STATIC);
__str81248=allocate([118,111,108,117,109,101,0] /* volume\00 */, "i8", ALLOC_STATIC);
__str82249=allocate([114,97,110,103,101,0] /* range\00 */, "i8", ALLOC_STATIC);
__ZL22ignore_if_self_closing=allocate([0,1,1,1,1,0,0,0,0,1,1,0,1,0,1,0,0,0,0] /* \00\01\01\01\01\00\0 */, "i8", ALLOC_STATIC);
__str83250=allocate([102,105,101,108,100,0] /* field\00 */, "i8", ALLOC_STATIC);
__str84251=allocate([109,111,100,101,0] /* mode\00 */, "i8", ALLOC_STATIC);
__str85252=allocate([112,117,110,99,116,117,97,116,105,111,110,0] /* punctuation\00 */, "i8", ALLOC_STATIC);
__str86253=allocate([99,97,112,105,116,97,108,95,108,101,116,116,101,114,115,0] /* capital_letters\00 */, "i8", ALLOC_STATIC);
__str87254=allocate([108,101,118,101,108,0] /* level\00 */, "i8", ALLOC_STATIC);
__ZZL14ProcessSsmlTagPwPcRiiiE23emphasis_to_pitch_range=allocate([50,50,40,70,90,90] /* 22(FZZ */, "i8", ALLOC_STATIC);
__ZZL14ProcessSsmlTagPwPcRiiiE18emphasis_to_volume=allocate([100,100,70,110,140,140] /* ddFn\8C\8C */, "i8", ALLOC_STATIC);
__str88255=allocate([105,110,116,101,114,112,114,101,116,45,97,115,0] /* interpret-as\00 */, "i8", ALLOC_STATIC);
__str89256=allocate([102,111,114,109,97,116,0] /* format\00 */, "i8", ALLOC_STATIC);
__str90257=allocate([100,101,116,97,105,108,0] /* detail\00 */, "i8", ALLOC_STATIC);
__str91258=allocate([37,99,37,100,89,0] /* %c%dY\00 */, "i8", ALLOC_STATIC);
__ZL11sayas_start=allocate(1, "i32", ALLOC_STATIC);
__str92259=allocate([97,108,105,97,115,0] /* alias\00 */, "i8", ALLOC_STATIC);
__str94261=allocate([37,99,37,100,77,0] /* %c%dM\00 */, "i8", ALLOC_STATIC);
__str95262=allocate([115,114,99,0] /* src\00 */, "i8", ALLOC_STATIC);
__str96263=allocate([37,115,47,37,115,0] /* %s/%s\00 */, "i8", ALLOC_STATIC);
__str97264=allocate([37,99,37,100,73,0] /* %c%dI\00 */, "i8", ALLOC_STATIC);
__str98265=allocate([37,99,37,100,85,0] /* %c%dU\00 */, "i8", ALLOC_STATIC);
__str99266=allocate([115,116,114,101,110,103,116,104,0] /* strength\00 */, "i8", ALLOC_STATIC);
__ZZL14ProcessSsmlTagPwPcRiiiE11break_value=allocate([0, 0, 0, 0, 7, 0, 0, 0, 14, 0, 0, 0, 21, 0, 0, 0, 40, 0, 0, 0, 80, 0, 0, 0], ["i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__str100267=allocate([37,99,37,100,66,0] /* %c%dB\00 */, "i8", ALLOC_STATIC);
__str101268=allocate([116,105,109,101,0] /* time\00 */, "i8", ALLOC_STATIC);
__str102269=allocate([120,109,108,58,98,97,115,101,0] /* xml:base\00 */, "i8", ALLOC_STATIC);
__ZZL18GetVoiceAttributesPwiE11mnem_gender=allocate([0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__str105272=allocate([110,101,117,116,114,97,108,0] /* neutral\00 */, "i8", ALLOC_STATIC);
__str106273=allocate([120,109,108,58,108,97,110,103,0] /* xml:lang\00 */, "i8", ALLOC_STATIC);
__str108275=allocate([97,103,101,0] /* age\00 */, "i8", ALLOC_STATIC);
__ZZL14LoadSoundFile2PKcE4slot=allocate([-1], ["i32",0,0,0,0], ALLOC_STATIC);
__str111278=allocate([115,112,97,99,101,32,0] /* space \00 */, "i8", ALLOC_STATIC);
__str112279=allocate([116,97,98,32,0] /* tab \00 */, "i8", ALLOC_STATIC);
__str113280=allocate([117,110,100,101,114,115,99,111,114,101,32,0] /* underscore \00 */, "i8", ALLOC_STATIC);
__str114281=allocate([100,111,117,98,108,101,45,113,117,111,116,101,32,0] /* double-quote \00 */, "i8", ALLOC_STATIC);
__ZZL14ReplaceKeyNamePciRiE8keynames=allocate([0, 0, 0, 0, 57376, 0, 0, 0, 0, 0, 0, 0, 57353, 0, 0, 0, 0, 0, 0, 0, 57439, 0, 0, 0, 0, 0, 0, 0, 34, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__ZZL19SetProsodyParameteriPwP11PARAM_STACKE11mnem_volume=allocate([0, 0, 0, 0, 100, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 30, 0, 0, 0, 0, 0, 0, 0, 65, 0, 0, 0, 0, 0, 0, 0, 100, 0, 0, 0, 0, 0, 0, 0, 150, 0, 0, 0, 0, 0, 0, 0, 230, 0, 0, 0, 0, 0, 0, 0, -1, 0, 0, 0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__str115282=allocate([115,105,108,101,110,116,0] /* silent\00 */, "i8", ALLOC_STATIC);
__str116283=allocate([120,45,115,111,102,116,0] /* x-soft\00 */, "i8", ALLOC_STATIC);
__str117=allocate([115,111,102,116,0] /* soft\00 */, "i8", ALLOC_STATIC);
__str118=allocate([108,111,117,100,0] /* loud\00 */, "i8", ALLOC_STATIC);
__str119=allocate([120,45,108,111,117,100,0] /* x-loud\00 */, "i8", ALLOC_STATIC);
__ZZL19SetProsodyParameteriPwP11PARAM_STACKE9mnem_rate=allocate([0, 0, 0, 0, 100, 0, 0, 0, 0, 0, 0, 0, 60, 0, 0, 0, 0, 0, 0, 0, 80, 0, 0, 0, 0, 0, 0, 0, 100, 0, 0, 0, 0, 0, 0, 0, 125, 0, 0, 0, 0, 0, 0, 0, 160, 0, 0, 0, 0, 0, 0, 0, -1, 0, 0, 0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__str120=allocate([120,45,115,108,111,119,0] /* x-slow\00 */, "i8", ALLOC_STATIC);
__str121=allocate([115,108,111,119,0] /* slow\00 */, "i8", ALLOC_STATIC);
__str122=allocate([102,97,115,116,0] /* fast\00 */, "i8", ALLOC_STATIC);
__str123=allocate([120,45,102,97,115,116,0] /* x-fast\00 */, "i8", ALLOC_STATIC);
__ZZL19SetProsodyParameteriPwP11PARAM_STACKE10mnem_pitch=allocate([0, 0, 0, 0, 100, 0, 0, 0, 0, 0, 0, 0, 70, 0, 0, 0, 0, 0, 0, 0, 85, 0, 0, 0, 0, 0, 0, 0, 100, 0, 0, 0, 0, 0, 0, 0, 110, 0, 0, 0, 0, 0, 0, 0, 120, 0, 0, 0, 0, 0, 0, 0, -1, 0, 0, 0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__str124=allocate([120,45,108,111,119,0] /* x-low\00 */, "i8", ALLOC_STATIC);
__str125=allocate([108,111,119,0] /* low\00 */, "i8", ALLOC_STATIC);
__str126=allocate([104,105,103,104,0] /* high\00 */, "i8", ALLOC_STATIC);
__str127=allocate([120,45,104,105,103,104,0] /* x-high\00 */, "i8", ALLOC_STATIC);
__ZZL19SetProsodyParameteriPwP11PARAM_STACKE10mnem_range=allocate([0, 0, 0, 0, 100, 0, 0, 0, 0, 0, 0, 0, 20, 0, 0, 0, 0, 0, 0, 0, 50, 0, 0, 0, 0, 0, 0, 0, 100, 0, 0, 0, 0, 0, 0, 0, 140, 0, 0, 0, 0, 0, 0, 0, 180, 0, 0, 0, 0, 0, 0, 0, -1, 0, 0, 0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__ZZL19SetProsodyParameteriPwP11PARAM_STACKE9mnem_tabs=allocate(20, "%struct.MNEM_TAB*", ALLOC_STATIC);
__ZZL17ProcessParamStackPcRiE10cmd_letter=allocate([0,83,65,80,82,0,67,0,0,0,0,0,70,0,0] /* \00SAPR\00C\00\00\00 */, "i8", ALLOC_STATIC);
__str128=allocate([37,99,37,100,37,99,0] /* %c%d%c\00 */, "i8", ALLOC_STATIC);
__ZZL16GetSsmlAttributePwPKcE5empty=allocate(4, "i32", ALLOC_STATIC);
__ZZL4GetCvE6ungot2=allocate(1, "i32", ALLOC_STATIC);
__ZZL4GetCvE5mask2=allocate([0,128,32,48] /* \00\80 0 */, "i8", ALLOC_STATIC);
__ZL6speed1=allocate([130], ["i32",0,0,0,0], ALLOC_STATIC);
__ZL6speed2=allocate([121], ["i32",0,0,0,0], ALLOC_STATIC);
__ZL6speed3=allocate([118], ["i32",0,0,0,0], ALLOC_STATIC);
__ZL12speed_lookup=allocate([255,255,255,255,255,253,249,245,242,238,235,232,228,225,222,218,216,213,210,207,204,201,198,196,193,191,188,186,183,181,179,176,174,172,169,168,165,163,161,159,158,155,153,152,150,148,146,145,143,141,139,137,136,135,133,131,130,129,127,126,124,123,122,120,119,118,117,115,114,113,112,111,110,109,107,106,105,104,103,102,101,100,99,98,97,96,95,94,93,92,91,90,89,89,88,87,86,85,84,83,82,82,81,80,80,79,78,77,76,76,75,75,74,73,72,71,71,70,69,69,68,67,67,66,66,65,64,64,63,62,62,61,61,60,59,59,58,58,57,57,56,56,55,54,54,53,53,52,52,52,51,50,50,49,49,48,48,47,47,46,46,46,45,45,44,44,44,43,43,42,41,40,40,40,39,39,39,38,38,38,37,37,37,36,36,35,35,35,35,34,34,34,33,33,33,32,32,31,31,31,30,30,30,29,29,29,29,28,28,27,27,27,27,26,26,26,26,25,25,25,24,24,24,24,23,23,23,23,22,22,22,21,21,21,21,20,20,20,20,19,19,19,18,18,17,17,17,16,16,16,16,16,16,15,15,15,15,14,14,14,13,13,13,12,12,12,12,11,11,11,11,10,10,10,9,9,9,8,8,8] /* \FF\FF\FF\FF\FF\FD\F */, "i8", ALLOC_STATIC);
__ZL14wav_factor_350=allocate([120,121,120,119,119,118,118,117,116,116,115,114,113,112,112,111,111,110,109,108,107,106,106,104,103,103,102,102,102,101,101,99,98,98,97,96,96,95,94,93,91,90,91,90,89,88,86,85,86,85,85,84,82,81,80,79,77,78,78,76,77,75,75,74,73,71,72,70,69,69,69,67,65,64,63,63,63,61,61,59,59,59,58,56,57,58,56,54,53,52,52,53,52,52,50,48,47,47,45,46,45] /* xyxwwvvuttsrqppoonml */, "i8", ALLOC_STATIC);
__ZL16pause_factor_350=allocate([22,22,22,22,22,22,22,21,21,21,21,20,20,19,19,18,17,16,15,15,15,15,15,15,15] /* \16\16\16\16\16\16\1 */, "i8", ALLOC_STATIC);
__ZZ11CalcLengthsP10TranslatorE14more_syllables=allocate(1, "i32", ALLOC_STATIC);
__str294=allocate([101,115,112,101,97,107,58,32,66,97,100,32,105,110,116,111,110,97,116,105,111,110,32,100,97,116,97,10,0] /* espeak: Bad intonati */, "i8", ALLOC_STATIC);
__ZL18letter_accents_0e0=allocate([870, 0, 358, 0, 614, 0, 1190, 0, 678, 0, 1062, 0, -30042, 0, 552, 0, 874, 0, 362, 0, 618, 0, 682, 0, 878, 0, 366, 0, 622, 0, 686, 0, 41, 0, 1203, 0, 884, 0, 372, 0, 628, 0, 1204, 0, 692, 0, 0, 0, 1140, 0, 890, 0, 378, 0, 634, 0, 698, 0, 382, 0, 57, 0, 702, 0, 0, 0, 934, 0, 0, 0, 422, 0, 0, 0, 998, 0, 0, 0, 360, 0, 0, 0, 616, 0, 0, 0, 808, 0, 0, 0, 488, 0, 0, 0, 489, 0, 0, 0, 1129, 0, 0, 0, 938, 0, 0, 0, 426, 0, 0, 0, 810, 0, 0, 0, 1002, 0, 0, 0, 490, 0, 0, 0, 620, 0, 0, 0, 428, 0, 0, 0, 812, 0, 0, 0, 556, 0, 0, 0, 621, 0, 0, 0, 1133, 0, 0, 0, 1198, 0, 0, 0, 942, 0, 0, 0, 430, 0, 0, 0, 1006, 0, 0, 0, 46, 0, 0, 0, -29714, 0, 0, 0, 623, 0, 0, 0, 560, 0, 48, 0, 0, 0, 369, 0, 0, 0, 561, 0, 0, 0, 497, 0, 0, 0, 817, 0, 0, 0, 1137, 0, 0, 0, 371, 0, 0, 0, 563, 0, 0, 0, 499, 0, 51, 0, 0, 0, 51, 0, 0, 0, 948, 0, 0, 0, 436, 0, 0, 0, 756, 0, 0, 0, -30028, 0, 0, 0, 375, 0, 0, 0, 567, 0, 0, 0, 503, 0, 0, 0, 376, 0, 0, 0, 632, 0, 0, 0, 568, 0, 0, 0, 504, 0, 0, 0, 569, 0, 0, 0, 505, 0, 0, 0, 1145, 0, 0, 0, 1210, 0, 0, 0, 954, 0, 0, 0, 442, 0, 0, 0, 1082, 0, 0, 0, 762, 0, 0, 0, 1018, 0, 0, 0, 636, 0, 0, 0, 638, 0, 0, 0, 0, 0, 383, 0, 0, 0, 831, 0, 0, 0, 511, 0, 56, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZL18letter_accents_250=allocate([166, 0, 1, 0, 129, 0, 1383, 0, 0, 0, 296, 0, 1321, 0, 1385, 0, 234, 0, 0, 0, 1346, 0, 0, 0, 195, 0, 7491, 0, 0, 0, 1263, 0, 1388, 0, 44, 0, 108, 0, 4, 0, 0, 0, 173, 0, 1389, 0, 0, 0, 1262, 0, 5, 0, 110, 0, 1201, 0, 1265, 0, 1329, 0, -28687, 0, 178, 0, 0, 0, 1394, 0, 0, 0, 1331, 0, 115, 0, 1268, 0, -25932, 0, 0, 0, 8, 0, 183, 0, 0, 0, 5431, 0, 0, 0, 1335, 0, 0, 0, 205, 0, 119, 0, 2231, 0, 1336, 0, 0, 0, 0, 0, 201, 0, 265, 0, 185, 0, 1337, 0, 1274, 0, 10, 0, 1403, 0, 187, 0, 188, 0, 190, 0, 126, 0, 1343, 0, 319, 0, 0, 0, 267, 0, 0, 0, 204, 0, 140, 0, 0, 0, 0, 0, 103, 0, 0, 0, 3436, 0, 109, 0, 303, 0, 176, 0, 113, 0, 1398, 0, 1100, 0, 7244, 0, -28695, 0, 0, 0, -12311, 0, -29127, 0, 0, 0, -12743, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZL13non_ascii_tab=allocate([0, 0, 945, 0, 601, 0, 603, 0, 947, 0, 953, 0, 339, 0, 969, 0, 966, 0, 643, 0, 965, 0, 658, 0, 660, 0, 638, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZL11accents_tab=allocate([0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__str297=allocate([37,115,37,99,37,115,37,99,37,115,37,115,0] /* %s%c%s%c%s%s\00 */, "i8", ALLOC_STATIC);
__str1298=allocate([37,115,37,99,37,99,37,115,0] /* %s%c%c%s\00 */, "i8", ALLOC_STATIC);
__str2299=allocate([37,99,37,115,37,99,37,115,37,99,0] /* %c%s%c%s%c\00 */, "i8", ALLOC_STATIC);
__ZZ12LookupLetterP10TranslatorjiPciE13single_letter=allocate(10, "i8", ALLOC_STATIC);
__str5302=allocate([95,35,37,100,32,0] /* _#%d \00 */, "i8", ALLOC_STATIC);
__str6303=allocate([95,99,97,112,0] /* _cap\00 */, "i8", ALLOC_STATIC);
__str7304=allocate([37,99,101,110,0] /* %cen\00 */, "i8", ALLOC_STATIC);
__str8305=allocate([95,63,65,0] /* _?A\00 */, "i8", ALLOC_STATIC);
__str9306=allocate([95,63,63,0] /* _??\00 */, "i8", ALLOC_STATIC);
__str10307=allocate([37,120,0] /* %x\00 */, "i8", ALLOC_STATIC);
__str11308=allocate([37,99,37,115,37,115,0] /* %c%s%s\00 */, "i8", ALLOC_STATIC);
__str12309=allocate([105,120,99,109,118,108,100,0] /* ixcmvld\00 */, "i8", ALLOC_STATIC);
__ZZ14TranslateRomanP10TranslatorPcS1_P8WORD_TABE12roman_values=allocate([1, 0, 0, 0, 10, 0, 0, 0, 100, 0, 0, 0, 1000, 0, 0, 0, 5, 0, 0, 0, 50, 0, 0, 0, 500, 0, 0, 0], ["i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__str13310=allocate([95,114,111,109,97,110,0] /* _roman\00 */, "i8", ALLOC_STATIC);
__str14311=allocate([32,32,37,100,32,32,32,32,0] /*   %d    \00 */, "i8", ALLOC_STATIC);
__ZZL17TranslateNumber_1P10TranslatorPcS1_PjP8WORD_TABiE9str_pause=allocate([11,0] /* \0B\00 */, "i8", ALLOC_STATIC);
__ZL14n_digit_lookup=allocate(1, "i32", ALLOC_STATIC);
__ZL12digit_lookup=allocate(1, "i8*", ALLOC_STATIC);
__ZL14number_control=allocate(1, "i32", ALLOC_STATIC);
__ZL23speak_missing_thousands=allocate(1, "i32", ALLOC_STATIC);
__ZL11ph_ordinal2=allocate(12, "i8", ALLOC_STATIC);
__str15312=allocate([95,35,37,115,0] /* _#%s\00 */, "i8", ALLOC_STATIC);
__str16313=allocate([95,48,0] /* _0\00 */, "i8", ALLOC_STATIC);
__str17314=allocate([95,100,112,116,0] /* _dpt\00 */, "i8", ALLOC_STATIC);
__str18315=allocate([95,48,77,37,100,0] /* _0M%d\00 */, "i8", ALLOC_STATIC);
__str19316=allocate([95,46,0] /* _.\00 */, "i8", ALLOC_STATIC);
__str20317=allocate([37,115,37,115,37,115,37,115,0] /* %s%s%s%s\00 */, "i8", ALLOC_STATIC);
__str21318=allocate([95,48,90,37,100,0] /* _0Z%d\00 */, "i8", ALLOC_STATIC);
__str22319=allocate([95,100,112,116,50,0] /* _dpt2\00 */, "i8", ALLOC_STATIC);
__str23320=allocate([95,37,100,102,0] /* _%df\00 */, "i8", ALLOC_STATIC);
__str24321=allocate([95,37,100,37,99,120,0] /* _%d%cx\00 */, "i8", ALLOC_STATIC);
__str25322=allocate([95,37,100,37,99,0] /* _%d%c\00 */, "i8", ALLOC_STATIC);
__str26323=allocate([95,37,100,101,0] /* _%de\00 */, "i8", ALLOC_STATIC);
__str27324=allocate([95,37,100,97,0] /* _%da\00 */, "i8", ALLOC_STATIC);
__str28325=allocate([95,37,100,0] /* _%d\00 */, "i8", ALLOC_STATIC);
__str29326=allocate([95,37,100,88,37,99,0] /* _%dX%c\00 */, "i8", ALLOC_STATIC);
__str30327=allocate([95,37,100,88,0] /* _%dX\00 */, "i8", ALLOC_STATIC);
__str31328=allocate([95,111,114,100,50,48,0] /* _ord20\00 */, "i8", ALLOC_STATIC);
__str32329=allocate([95,111,114,100,0] /* _ord\00 */, "i8", ALLOC_STATIC);
__str33330=allocate([95,48,97,110,100,0] /* _0and\00 */, "i8", ALLOC_STATIC);
__str35332=allocate([95,48,67,111,0] /* _0Co\00 */, "i8", ALLOC_STATIC);
__str36333=allocate([95,48,67,48,0] /* _0C0\00 */, "i8", ALLOC_STATIC);
__str37334=allocate([95,48,67,0] /* _0C\00 */, "i8", ALLOC_STATIC);
__str39336=allocate([95,37,100,67,111,0] /* _%dCo\00 */, "i8", ALLOC_STATIC);
__str40337=allocate([95,37,100,67,48,0] /* _%dC0\00 */, "i8", ALLOC_STATIC);
__str41338=allocate([95,37,100,67,0] /* _%dC\00 */, "i8", ALLOC_STATIC);
__str42339=allocate([95,37,100,77,37,100,111,0] /* _%dM%do\00 */, "i8", ALLOC_STATIC);
__str43340=allocate([95,37,100,77,37,100,101,0] /* _%dM%de\00 */, "i8", ALLOC_STATIC);
__str44341=allocate([95,37,100,77,37,100,120,0] /* _%dM%dx\00 */, "i8", ALLOC_STATIC);
__str45342=allocate([95,37,100,77,37,100,0] /* _%dM%d\00 */, "i8", ALLOC_STATIC);
__str46343=allocate([95,48,111,102,0] /* _0of\00 */, "i8", ALLOC_STATIC);
__str47344=allocate([95,37,115,37,100,111,0] /* _%s%do\00 */, "i8", ALLOC_STATIC);
__str48345=allocate([95,37,115,37,100,101,0] /* _%s%de\00 */, "i8", ALLOC_STATIC);
__str49346=allocate([95,37,115,37,100,120,0] /* _%s%dx\00 */, "i8", ALLOC_STATIC);
__str50347=allocate([95,37,115,37,100,0] /* _%s%d\00 */, "i8", ALLOC_STATIC);
__str51348=allocate([95,48,77,50,0] /* _0M2\00 */, "i8", ALLOC_STATIC);
__str52349=allocate([95,37,100,77,49,0] /* _%dM1\00 */, "i8", ALLOC_STATIC);
__str53350=allocate([95,48,77,49,0] /* _0M1\00 */, "i8", ALLOC_STATIC);
__str54351=allocate([48,77,65,0] /* 0MA\00 */, "i8", ALLOC_STATIC);
__str55352=allocate([49,77,65,0] /* 1MA\00 */, "i8", ALLOC_STATIC);
__str56353=allocate([48,77,0] /* 0M\00 */, "i8", ALLOC_STATIC);
__str57354=allocate([95,108,105,103,0] /* _lig\00 */, "i8", ALLOC_STATIC);
__str58355=allocate([95,115,109,99,0] /* _smc\00 */, "i8", ALLOC_STATIC);
__str59356=allocate([95,116,117,114,0] /* _tur\00 */, "i8", ALLOC_STATIC);
__str60357=allocate([95,114,101,118,0] /* _rev\00 */, "i8", ALLOC_STATIC);
__str61358=allocate([95,99,114,108,0] /* _crl\00 */, "i8", ALLOC_STATIC);
__str62359=allocate([95,97,99,117,0] /* _acu\00 */, "i8", ALLOC_STATIC);
__str63360=allocate([95,98,114,118,0] /* _brv\00 */, "i8", ALLOC_STATIC);
__str64361=allocate([95,104,97,99,0] /* _hac\00 */, "i8", ALLOC_STATIC);
__str65362=allocate([95,99,101,100,0] /* _ced\00 */, "i8", ALLOC_STATIC);
__str66363=allocate([95,99,105,114,0] /* _cir\00 */, "i8", ALLOC_STATIC);
__str67364=allocate([95,100,105,97,0] /* _dia\00 */, "i8", ALLOC_STATIC);
__str68365=allocate([95,97,99,50,0] /* _ac2\00 */, "i8", ALLOC_STATIC);
__str69366=allocate([95,100,111,116,0] /* _dot\00 */, "i8", ALLOC_STATIC);
__str70367=allocate([95,103,114,118,0] /* _grv\00 */, "i8", ALLOC_STATIC);
__str71368=allocate([95,109,99,110,0] /* _mcn\00 */, "i8", ALLOC_STATIC);
__str72369=allocate([95,111,103,111,0] /* _ogo\00 */, "i8", ALLOC_STATIC);
__str73370=allocate([95,114,110,103,0] /* _rng\00 */, "i8", ALLOC_STATIC);
__str74371=allocate([95,115,116,107,0] /* _stk\00 */, "i8", ALLOC_STATIC);
__str75372=allocate([95,116,108,100,0] /* _tld\00 */, "i8", ALLOC_STATIC);
__str76373=allocate([95,98,97,114,0] /* _bar\00 */, "i8", ALLOC_STATIC);
__str77374=allocate([95,114,102,120,0] /* _rfx\00 */, "i8", ALLOC_STATIC);
__str78375=allocate([95,104,111,107,0] /* _hok\00 */, "i8", ALLOC_STATIC);
_option_mbrola_phonemes=allocate(1, "i32", ALLOC_STATIC);
__ZL10mbrola_tab=allocate(1, "%struct.MBROLA_TAB*", ALLOC_STATIC);
__ZL15mbr_name_prefix=allocate(1, "i32", ALLOC_STATIC);
__str382=allocate([37,115,47,109,98,114,111,108,97,47,37,115,0] /* %s/mbrola/%s\00 */, "i8", ALLOC_STATIC);
__str1383=allocate([47,117,115,114,47,115,104,97,114,101,47,109,98,114,111,108,97,47,37,115,0] /* /usr/share/mbrola/%s */, "i8", ALLOC_STATIC);
__str2384=allocate([47,117,115,114,47,115,104,97,114,101,47,109,98,114,111,108,97,47,37,115,47,37,115,0] /* /usr/share/mbrola/%s */, "i8", ALLOC_STATIC);
__str3385=allocate([47,117,115,114,47,115,104,97,114,101,47,109,98,114,111,108,97,47,118,111,105,99,101,115,47,37,115,0] /* /usr/share/mbrola/vo */, "i8", ALLOC_STATIC);
__str4386=allocate([37,115,47,109,98,114,111,108,97,95,112,104,47,37,115,0] /* %s/mbrola_ph/%s\00 */, "i8", ALLOC_STATIC);
__ZL14mbrola_control=allocate(1, "i32", ALLOC_STATIC);
__ZZ15MbrolaTranslateP12PHONEME_LISTiiP7__sFILEE4phix=allocate(1, "i32", ALLOC_STATIC);
__ZZ15MbrolaTranslateP12PHONEME_LISTiiP7__sFILEE11embedded_ix=allocate(1, "i32", ALLOC_STATIC);
__ZZ15MbrolaTranslateP12PHONEME_LISTiiP7__sFILEE10word_count=allocate(1, "i32", ALLOC_STATIC);
__str6388=allocate([37,115,9,0] /* %s\09\00 */, "i8", ALLOC_STATIC);
__str8390=allocate([37,100,9,37,115,0] /* %d\09%s\00 */, "i8", ALLOC_STATIC);
__str9391=allocate([37,115,9,37,100,9,37,115,0] /* %s\09%d\09%s\00 */, "i8", ALLOC_STATIC);
__str10392=allocate([37,100,10,37,115,9,0] /* %d\0A%s\09\00 */, "i8", ALLOC_STATIC);
__str11393=allocate([37,100,37,115,10,0] /* %d%s\0A\00 */, "i8", ALLOC_STATIC);
__str12394=allocate([95,32,9,37,100,10,0] /* _ \09%d\0A\00 */, "i8", ALLOC_STATIC);
__ZZ10MbrolaFilliiE9n_samples=allocate(1, "i32", ALLOC_STATIC);
__ZZL10WritePitchiiiiiE6output=allocate(50, "i8", ALLOC_STATIC);
__str13395=allocate([32,48,32,37,100,0] /*  0 %d\00 */, "i8", ALLOC_STATIC);
__str14396=allocate([32,37,100,32,37,100,0] /*  %d %d\00 */, "i8", ALLOC_STATIC);
__str15397=allocate([10,0] /* \0A\00 */, "i8", ALLOC_STATIC);
__str16398=allocate([9,49,48,48,32,37,100,10,0] /* \09100 %d\0A\00 */, "i8", ALLOC_STATIC);
__ZZL10GetMbrNameP12PHONEME_LISTP11PHONEME_TABS2_S2_PiS3_S3_E4mnem=allocate(1, "i32", ALLOC_STATIC);
__str399=allocate([49,46,52,53,46,48,52,32,32,50,53,46,65,112,114,46,49,49,0] /* 1.45.04  25.Apr.11\0 */, "i8", ALLOC_STATIC);
_version_string=allocate(1, "i8*", ALLOC_STATIC);
_version_phdata=allocate([83200], ["i32",0,0,0,0], ALLOC_STATIC);
_option_device_number=allocate([-1], ["i32",0,0,0,0], ALLOC_STATIC);
_f_logespeak=allocate(1, "%struct.__sFILE*", ALLOC_STATIC);
_logging_type=allocate(1, "i32", ALLOC_STATIC);
_n_phoneme_tab=allocate(1, "i32", ALLOC_STATIC);
_current_phoneme_table=allocate(1, "i32", ALLOC_STATIC);
_phoneme_tab=allocate(1024, "%struct.PHONEME_TAB*", ALLOC_STATIC);
_phoneme_tab_flags=allocate(256, "i8", ALLOC_STATIC);
_phoneme_index=allocate(1, "i16*", ALLOC_STATIC);
_phondata_ptr=allocate(1, "i8*", ALLOC_STATIC);
_wavefile_data=allocate(1, "i8*", ALLOC_STATIC);
__ZL16phoneme_tab_data=allocate(1, "i8*", ALLOC_STATIC);
_n_phoneme_tables=allocate(1, "i32", ALLOC_STATIC);
_phoneme_tab_list=allocate(4800, ["i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0], ALLOC_STATIC);
_phoneme_tab_number=allocate(1, "i32", ALLOC_STATIC);
_wavefile_ix=allocate(1, "i32", ALLOC_STATIC);
_wavefile_amp=allocate(1, "i32", ALLOC_STATIC);
_wavefile_ix2=allocate(1, "i32", ALLOC_STATIC);
_wavefile_amp2=allocate(1, "i32", ALLOC_STATIC);
_seq_len_adjust=allocate(1, "i32", ALLOC_STATIC);
_vowel_transition=allocate(16, "i32", ALLOC_STATIC);
_vowel_transition0=allocate(1, "i32", ALLOC_STATIC);
_vowel_transition1=allocate(1, "i32", ALLOC_STATIC);
__str1412=allocate([112,104,111,110,116,97,98,0] /* phontab\00 */, "i8", ALLOC_STATIC);
__str2413=allocate([112,104,111,110,105,110,100,101,120,0] /* phonindex\00 */, "i8", ALLOC_STATIC);
__str3414=allocate([112,104,111,110,100,97,116,97,0] /* phondata\00 */, "i8", ALLOC_STATIC);
__str4415=allocate([105,110,116,111,110,97,116,105,111,110,115,0] /* intonations\00 */, "i8", ALLOC_STATIC);
__ZZ11LookupSpectP11PHONEME_TABiP10FMT_PARAMSPiP12PHONEME_LISTE10frames_buf=allocate(200, ["i16",0,"i16",0,"%struct.frame_t*",0,0,0,"i16",0,"i16",0,"%struct.frame_t*",0,0,0,"i16",0,"i16",0,"%struct.frame_t*",0,0,0,"i16",0,"i16",0,"%struct.frame_t*",0,0,0,"i16",0,"i16",0,"%struct.frame_t*",0,0,0,"i16",0,"i16",0,"%struct.frame_t*",0,0,0,"i16",0,"i16",0,"%struct.frame_t*",0,0,0,"i16",0,"i16",0,"%struct.frame_t*",0,0,0,"i16",0,"i16",0,"%struct.frame_t*",0,0,0,"i16",0,"i16",0,"%struct.frame_t*",0,0,0,"i16",0,"i16",0,"%struct.frame_t*",0,0,0,"i16",0,"i16",0,"%struct.frame_t*",0,0,0,"i16",0,"i16",0,"%struct.frame_t*",0,0,0,"i16",0,"i16",0,"%struct.frame_t*",0,0,0,"i16",0,"i16",0,"%struct.frame_t*",0,0,0,"i16",0,"i16",0,"%struct.frame_t*",0,0,0,"i16",0,"i16",0,"%struct.frame_t*",0,0,0,"i16",0,"i16",0,"%struct.frame_t*",0,0,0,"i16",0,"i16",0,"%struct.frame_t*",0,0,0,"i16",0,"i16",0,"%struct.frame_t*",0,0,0,"i16",0,"i16",0,"%struct.frame_t*",0,0,0,"i16",0,"i16",0,"%struct.frame_t*",0,0,0,"i16",0,"i16",0,"%struct.frame_t*",0,0,0,"i16",0,"i16",0,"%struct.frame_t*",0,0,0,"i16",0,"i16",0,"%struct.frame_t*",0,0,0], ALLOC_STATIC);
__str5416=allocate([101,115,112,101,97,107,58,32,78,111,32,101,110,118,101,108,111,112,101,10,0] /* espeak: No envelope\ */, "i8", ALLOC_STATIC);
__str7418=allocate([99,111,110,102,105,103,0] /* config\00 */, "i8", ALLOC_STATIC);
__str9420=allocate([108,111,103,0] /* log\00 */, "i8", ALLOC_STATIC);
__str10421=allocate([37,100,32,37,115,0] /* %d %s\00 */, "i8", ALLOC_STATIC);
__str11422=allocate([119,0] /* w\00 */, "i8", ALLOC_STATIC);
__str13424=allocate([112,97,95,100,101,118,105,99,101,0] /* pa_device\00 */, "i8", ALLOC_STATIC);
__str15426=allocate([115,111,117,110,100,105,99,111,110,0] /* soundicon\00 */, "i8", ALLOC_STATIC);
__str16427=allocate([95,37,99,32,37,115,0] /* _%c %s\00 */, "i8", ALLOC_STATIC);
_this_ph_data=allocate(152, ["i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8",0,0], ALLOC_STATIC);
__ZZL13NumInstnWordsPtE7n_words=allocate([1,1,1,1,1,1,1,1,1,2,4] /* \01\01\01\01\01\01\0 */, "i8", ALLOC_STATIC);
__ZZL18InterpretConditionP10TranslatoriP12PHONEME_LISTiE11ph_position=allocate([0, 0, 0, 0, 1, 0, 0, 0, 2, 0, 0, 0, 3, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 3, 0, 0, 0], ["i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__ZZL15StressConditionP10TranslatorP12PHONEME_LISTiiE15condition_level=allocate([1, 0, 0, 0, 2, 0, 0, 0, 4, 0, 0, 0, 15, 0, 0, 0], ["i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__str17428=allocate([73,110,118,97,108,105,100,32,105,110,115,116,114,117,99,116,105,111,110,32,37,46,52,120,32,102,111,114,32,112,104,111,110,101,109,101,32,39,37,115,39,10,0] /* Invalid instruction  */, "i8", ALLOC_STATIC);
__str18429=allocate([114,98,0] /* rb\00 */, "i8", ALLOC_STATIC);
__str19430=allocate([67,97,110,39,116,32,114,101,97,100,32,100,97,116,97,32,102,105,108,101,58,32,39,37,115,39,10,0] /* Can't read data file */, "i8", ALLOC_STATIC);
_n_phoneme_list=allocate(1, "i32", ALLOC_STATIC);
_phoneme_list=allocate(24000, ["i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0], ALLOC_STATIC);
_mbrola_delay=allocate(1, "i32", ALLOC_STATIC);
_mbrola_name=allocate(20, "i8", ALLOC_STATIC);
_speed=allocate(64, "i32", ALLOC_STATIC);
__ZL9new_voice=allocate(1, "%struct.voice_t*", ALLOC_STATIC);
_n_soundicon_tab=allocate([4], ["i32",0,0,0,0], ALLOC_STATIC);
_soundicon_tab=allocate(1280, ["i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0], ALLOC_STATIC);
__ZZ12WordToStringjE3buf=allocate(5, "i8", ALLOC_STATIC);
__ZL14last_pitch_cmd=allocate(1, "i32", ALLOC_STATIC);
__ZL12last_amp_cmd=allocate(1, "i32", ALLOC_STATIC);
__ZL10last_frame=allocate(1, "%struct.frame_t*", ALLOC_STATIC);
__ZL15syllable_centre=allocate(1, "i32", ALLOC_STATIC);
__ZZ18FormantTransition2P10frameref_tRijjP11PHONEME_TABiE10vcolouring=allocate([243, 0, 272, 0, 256, 0, 256, 0, 256, 0, 256, 0, 256, 0, 240, 0, 240, 0, 240, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZL10modn_flags=allocate(1, "i32", ALLOC_STATIC);
__ZZ8DoSpect2P11PHONEME_TABiP10FMT_PARAMSP12PHONEME_LISTiE9wave_flag_b=allocate(1, "i1", ALLOC_STATIC);
__ZL13fmt_amplitude=allocate(1, "i32", ALLOC_STATIC);
__ZL10last_wcmdq=allocate(1, "i32", ALLOC_STATIC);
__ZL12pitch_length=allocate(1, "i32", ALLOC_STATIC);
__ZL10amp_length=allocate(1, "i32", ALLOC_STATIC);
__ZZ8GenerateP12PHONEME_LISTPiiE2ix=allocate(1, "i32", ALLOC_STATIC);
__ZZ8GenerateP12PHONEME_LISTPiiE11embedded_ix=allocate(1, "i32", ALLOC_STATIC);
__ZZ8GenerateP12PHONEME_LISTPiiE10word_count=allocate(1, "i32", ALLOC_STATIC);
__ZZ8GenerateP12PHONEME_LISTPiiE8sourceix=allocate(1, "i32", ALLOC_STATIC);
__ZL14syllable_start=allocate(1, "i32", ALLOC_STATIC);
__ZL12syllable_end=allocate(1, "i32", ALLOC_STATIC);
__ZL8timer_on_b=allocate(1, "i1", ALLOC_STATIC);
__ZL6paused_b=allocate(1, "i1", ALLOC_STATIC);
__ZZ15SpeakNextClauseP7__sFILEPKviE6f_text=allocate(1, "%struct.__sFILE*", ALLOC_STATIC);
__ZZ15SpeakNextClauseP7__sFILEPKviE6p_text=allocate(1, "i8*", ALLOC_STATIC);
__str459=allocate([37,115,10,0] /* %s\0A\00 */, "i8", ALLOC_STATIC);
__str1460=allocate([87,97,114,110,105,110,103,58,32,65,99,99,101,110,116,101,100,32,108,101,116,116,101,114,115,32,97,114,101,32,110,111,116,32,114,101,99,111,103,110,105,122,101,100,44,32,101,103,58,32,85,43,48,49,48,68,10,83,101,116,32,76,67,95,67,84,89,80,69,32,116,111,32,97,32,85,84,70,45,56,32,108,111,99,97,108,101,10,0] /* Warning: Accented le */, "i8", ALLOC_STATIC);
__ZZL13set_frame_rmsP7frame_tiE8sqrt_tab=allocate([0, 0, 64, 0, 90, 0, 110, 0, 128, 0, 143, 0, 156, 0, 169, 0, 181, 0, 192, 0, 202, 0, 212, 0, 221, 0, 230, 0, 239, 0, 247, 0, 256, 0, 263, 0, 271, 0, 278, 0, 286, 0, 293, 0, 300, 0, 306, 0, 313, 0, 320, 0, 326, 0, 332, 0, 338, 0, 344, 0, 350, 0, 356, 0, 362, 0, 367, 0, 373, 0, 378, 0, 384, 0, 389, 0, 394, 0, 399, 0, 404, 0, 409, 0, 414, 0, 419, 0, 424, 0, 429, 0, 434, 0, 438, 0, 443, 0, 448, 0, 452, 0, 457, 0, 461, 0, 465, 0, 470, 0, 474, 0, 478, 0, 483, 0, 487, 0, 491, 0, 495, 0, 499, 0, 503, 0, 507, 0, 512, 0, 515, 0, 519, 0, 523, 0, 527, 0, 531, 0, 535, 0, 539, 0, 543, 0, 546, 0, 550, 0, 554, 0, 557, 0, 561, 0, 565, 0, 568, 0, 572, 0, 576, 0, 579, 0, 583, 0, 586, 0, 590, 0, 593, 0, 596, 0, 600, 0, 603, 0, 607, 0, 610, 0, 613, 0, 617, 0, 620, 0, 623, 0, 627, 0, 630, 0, 633, 0, 636, 0, 640, 0, 643, 0, 646, 0, 649, 0, 652, 0, 655, 0, 658, 0, 662, 0, 665, 0, 668, 0, 671, 0, 674, 0, 677, 0, 680, 0, 683, 0, 686, 0, 689, 0, 692, 0, 695, 0, 698, 0, 701, 0, 704, 0, 706, 0, 709, 0, 712, 0, 715, 0, 718, 0, 721, 0, 724, 0, 726, 0, 729, 0, 732, 0, 735, 0, 738, 0, 740, 0, 743, 0, 746, 0, 749, 0, 751, 0, 754, 0, 757, 0, 759, 0, 762, 0, 765, 0, 768, 0, 770, 0, 773, 0, 775, 0, 778, 0, 781, 0, 783, 0, 786, 0, 789, 0, 791, 0, 794, 0, 796, 0, 799, 0, 801, 0, 804, 0, 807, 0, 809, 0, 812, 0, 814, 0, 817, 0, 819, 0, 822, 0, 824, 0, 827, 0, 829, 0, 832, 0, 834, 0, 836, 0, 839, 0, 841, 0, 844, 0, 846, 0, 849, 0, 851, 0, 853, 0, 856, 0, 858, 0, 861, 0, 863, 0, 865, 0, 868, 0, 870, 0, 872, 0, 875, 0, 877, 0, 879, 0, 882, 0, 884, 0, 886, 0, 889, 0, 891, 0, 893, 0, 896, 0, 898, 0, 900, 0, 902, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZL10AllocFramevE2ix=allocate(1, "i32", ALLOC_STATIC);
__ZZL10AllocFramevE10frame_pool=allocate(10240, ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8"], ALLOC_STATIC);
_translator=allocate(1, "%struct.Translator*", ALLOC_STATIC);
_translator2=allocate(1, "%struct.Translator*", ALLOC_STATIC);
__ZL20translator2_language=allocate(20, "i8", ALLOC_STATIC);
_f_trans=allocate(1, "%struct.__sFILE*", ALLOC_STATIC);
_option_tone2=allocate(1, "i32", ALLOC_STATIC);
_option_tone_flags=allocate(1, "i32", ALLOC_STATIC);
_option_phonemes=allocate(1, "i32", ALLOC_STATIC);
_option_phoneme_events=allocate(1, "i32", ALLOC_STATIC);
_option_quiet=allocate(1, "i32", ALLOC_STATIC);
_option_endpause=allocate(1, "i32", ALLOC_STATIC);
_option_capitals=allocate(1, "i32", ALLOC_STATIC);
_option_punctuation=allocate(1, "i32", ALLOC_STATIC);
_option_sayas=allocate(1, "i32", ALLOC_STATIC);
_option_ssml=allocate(1, "i32", ALLOC_STATIC);
_option_phoneme_input=allocate(1, "i32", ALLOC_STATIC);
_option_phoneme_variants=allocate(1, "i32", ALLOC_STATIC);
_option_wordgap=allocate(1, "i32", ALLOC_STATIC);
_skip_sentences=allocate(1, "i32", ALLOC_STATIC);
_skip_words=allocate(1, "i32", ALLOC_STATIC);
_skip_characters=allocate(1, "i32", ALLOC_STATIC);
_skip_marker=allocate(50, "i8", ALLOC_STATIC);
_skipping_text=allocate(1, "i32", ALLOC_STATIC);
_end_character_position=allocate(1, "i32", ALLOC_STATIC);
_count_sentences=allocate(1, "i32", ALLOC_STATIC);
_count_words=allocate(1, "i32", ALLOC_STATIC);
_clause_start_char=allocate(1, "i32", ALLOC_STATIC);
_clause_start_word=allocate(1, "i32", ALLOC_STATIC);
_new_sentence=allocate(1, "i32", ALLOC_STATIC);
_pre_pause=allocate(1, "i32", ALLOC_STATIC);
_word_phonemes=allocate(160, "i8", ALLOC_STATIC);
_n_ph_list2=allocate(1, "i32", ALLOC_STATIC);
_ph_list2=allocate(8000, ["i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0], ALLOC_STATIC);
_option_punctlist=allocate(240, "i32", ALLOC_STATIC);
_ctrl_embedded=allocate([1], ["i8",0,0,0,0], ALLOC_STATIC);
_option_multibyte=allocate(1, "i32", ALLOC_STATIC);
_option_linelength=allocate(1, "i32", ALLOC_STATIC);
_embedded_list=allocate(1000, "i32", ALLOC_STATIC);
_n_replace_phonemes=allocate(1, "i32", ALLOC_STATIC);
_replace_phonemes=allocate(180, "i8", ALLOC_STATIC);
__ZL10ISO_8859_1=allocate([160, 0, 161, 0, 162, 0, 163, 0, 164, 0, 165, 0, 166, 0, 167, 0, 168, 0, 169, 0, 170, 0, 171, 0, 172, 0, 173, 0, 174, 0, 175, 0, 176, 0, 177, 0, 178, 0, 179, 0, 180, 0, 181, 0, 182, 0, 183, 0, 184, 0, 185, 0, 186, 0, 187, 0, 188, 0, 189, 0, 190, 0, 191, 0, 192, 0, 193, 0, 194, 0, 195, 0, 196, 0, 197, 0, 198, 0, 199, 0, 200, 0, 201, 0, 202, 0, 203, 0, 204, 0, 205, 0, 206, 0, 207, 0, 208, 0, 209, 0, 210, 0, 211, 0, 212, 0, 213, 0, 214, 0, 215, 0, 216, 0, 217, 0, 218, 0, 219, 0, 220, 0, 221, 0, 222, 0, 223, 0, 224, 0, 225, 0, 226, 0, 227, 0, 228, 0, 229, 0, 230, 0, 231, 0, 232, 0, 233, 0, 234, 0, 235, 0, 236, 0, 237, 0, 238, 0, 239, 0, 240, 0, 241, 0, 242, 0, 243, 0, 244, 0, 245, 0, 246, 0, 247, 0, 248, 0, 249, 0, 250, 0, 251, 0, 252, 0, 253, 0, 254, 0, 255, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZL10ISO_8859_2=allocate([160, 0, 260, 0, 728, 0, 321, 0, 164, 0, 317, 0, 346, 0, 167, 0, 168, 0, 352, 0, 350, 0, 356, 0, 377, 0, 173, 0, 381, 0, 379, 0, 176, 0, 261, 0, 731, 0, 322, 0, 180, 0, 318, 0, 347, 0, 711, 0, 184, 0, 353, 0, 351, 0, 357, 0, 378, 0, 733, 0, 382, 0, 380, 0, 340, 0, 193, 0, 194, 0, 258, 0, 196, 0, 313, 0, 262, 0, 199, 0, 268, 0, 201, 0, 280, 0, 203, 0, 282, 0, 205, 0, 206, 0, 270, 0, 272, 0, 323, 0, 327, 0, 211, 0, 212, 0, 336, 0, 214, 0, 215, 0, 344, 0, 366, 0, 218, 0, 368, 0, 220, 0, 221, 0, 354, 0, 223, 0, 341, 0, 225, 0, 226, 0, 259, 0, 228, 0, 314, 0, 263, 0, 231, 0, 269, 0, 233, 0, 281, 0, 235, 0, 283, 0, 237, 0, 238, 0, 271, 0, 273, 0, 324, 0, 328, 0, 243, 0, 244, 0, 337, 0, 246, 0, 247, 0, 345, 0, 367, 0, 250, 0, 369, 0, 252, 0, 253, 0, 355, 0, 729, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZL10ISO_8859_3=allocate([160, 0, 294, 0, 728, 0, 163, 0, 164, 0, 0, 0, 292, 0, 167, 0, 168, 0, 304, 0, 350, 0, 286, 0, 308, 0, 173, 0, 0, 0, 379, 0, 176, 0, 295, 0, 178, 0, 179, 0, 180, 0, 181, 0, 293, 0, 183, 0, 184, 0, 305, 0, 351, 0, 287, 0, 309, 0, 189, 0, 0, 0, 380, 0, 192, 0, 193, 0, 194, 0, 0, 0, 196, 0, 266, 0, 264, 0, 199, 0, 200, 0, 201, 0, 202, 0, 203, 0, 204, 0, 205, 0, 206, 0, 207, 0, 0, 0, 209, 0, 210, 0, 211, 0, 212, 0, 288, 0, 214, 0, 215, 0, 284, 0, 217, 0, 218, 0, 219, 0, 220, 0, 364, 0, 348, 0, 223, 0, 224, 0, 225, 0, 226, 0, 0, 0, 228, 0, 267, 0, 265, 0, 231, 0, 232, 0, 233, 0, 234, 0, 235, 0, 236, 0, 237, 0, 238, 0, 239, 0, 0, 0, 241, 0, 242, 0, 243, 0, 244, 0, 289, 0, 246, 0, 247, 0, 285, 0, 249, 0, 250, 0, 251, 0, 252, 0, 365, 0, 349, 0, 729, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZL10ISO_8859_4=allocate([160, 0, 260, 0, 312, 0, 342, 0, 164, 0, 296, 0, 315, 0, 167, 0, 168, 0, 352, 0, 274, 0, 290, 0, 358, 0, 173, 0, 381, 0, 175, 0, 176, 0, 261, 0, 731, 0, 343, 0, 180, 0, 297, 0, 316, 0, 711, 0, 184, 0, 353, 0, 275, 0, 291, 0, 359, 0, 330, 0, 382, 0, 331, 0, 256, 0, 193, 0, 194, 0, 195, 0, 196, 0, 197, 0, 198, 0, 302, 0, 268, 0, 201, 0, 280, 0, 203, 0, 278, 0, 205, 0, 206, 0, 298, 0, 272, 0, 325, 0, 332, 0, 310, 0, 212, 0, 213, 0, 214, 0, 215, 0, 216, 0, 370, 0, 218, 0, 219, 0, 220, 0, 360, 0, 362, 0, 223, 0, 257, 0, 225, 0, 226, 0, 227, 0, 228, 0, 229, 0, 230, 0, 303, 0, 269, 0, 233, 0, 281, 0, 235, 0, 279, 0, 237, 0, 238, 0, 299, 0, 273, 0, 326, 0, 333, 0, 311, 0, 244, 0, 245, 0, 246, 0, 247, 0, 248, 0, 371, 0, 250, 0, 251, 0, 252, 0, 361, 0, 363, 0, 729, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZL10ISO_8859_5=allocate([160, 0, 1025, 0, 1026, 0, 1027, 0, 1028, 0, 1029, 0, 1030, 0, 1031, 0, 1032, 0, 1033, 0, 1034, 0, 1035, 0, 1036, 0, 173, 0, 1038, 0, 1039, 0, 1040, 0, 1041, 0, 1042, 0, 1043, 0, 1044, 0, 1045, 0, 1046, 0, 1047, 0, 1048, 0, 1049, 0, 1050, 0, 1051, 0, 1052, 0, 1053, 0, 1054, 0, 1055, 0, 1056, 0, 1057, 0, 1058, 0, 1059, 0, 1060, 0, 1061, 0, 1062, 0, 1063, 0, 1064, 0, 1065, 0, 1066, 0, 1067, 0, 1068, 0, 1069, 0, 1070, 0, 1071, 0, 1072, 0, 1073, 0, 1074, 0, 1075, 0, 1076, 0, 1077, 0, 1078, 0, 1079, 0, 1080, 0, 1081, 0, 1082, 0, 1083, 0, 1084, 0, 1085, 0, 1086, 0, 1087, 0, 1088, 0, 1089, 0, 1090, 0, 1091, 0, 1092, 0, 1093, 0, 1094, 0, 1095, 0, 1096, 0, 1097, 0, 1098, 0, 1099, 0, 1100, 0, 1101, 0, 1102, 0, 1103, 0, 8470, 0, 1105, 0, 1106, 0, 1107, 0, 1108, 0, 1109, 0, 1110, 0, 1111, 0, 1112, 0, 1113, 0, 1114, 0, 1115, 0, 1116, 0, 167, 0, 1118, 0, 1119, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZL10ISO_8859_7=allocate([160, 0, 8216, 0, 8217, 0, 163, 0, 8364, 0, 8367, 0, 166, 0, 167, 0, 168, 0, 169, 0, 890, 0, 171, 0, 172, 0, 173, 0, 0, 0, 8213, 0, 176, 0, 177, 0, 178, 0, 179, 0, 900, 0, 901, 0, 902, 0, 183, 0, 904, 0, 905, 0, 906, 0, 187, 0, 908, 0, 189, 0, 910, 0, 911, 0, 912, 0, 913, 0, 914, 0, 915, 0, 916, 0, 917, 0, 918, 0, 919, 0, 920, 0, 921, 0, 922, 0, 923, 0, 924, 0, 925, 0, 926, 0, 927, 0, 928, 0, 929, 0, 0, 0, 931, 0, 932, 0, 933, 0, 934, 0, 935, 0, 936, 0, 937, 0, 938, 0, 939, 0, 940, 0, 941, 0, 942, 0, 943, 0, 944, 0, 945, 0, 946, 0, 947, 0, 948, 0, 949, 0, 950, 0, 951, 0, 952, 0, 953, 0, 954, 0, 955, 0, 956, 0, 957, 0, 958, 0, 959, 0, 960, 0, 961, 0, 962, 0, 963, 0, 964, 0, 965, 0, 966, 0, 967, 0, 968, 0, 969, 0, 970, 0, 971, 0, 972, 0, 973, 0, 974, 0, 0, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZL10ISO_8859_9=allocate([160, 0, 161, 0, 162, 0, 163, 0, 164, 0, 165, 0, 166, 0, 167, 0, 168, 0, 169, 0, 170, 0, 171, 0, 172, 0, 173, 0, 174, 0, 175, 0, 176, 0, 177, 0, 178, 0, 179, 0, 180, 0, 181, 0, 182, 0, 183, 0, 184, 0, 185, 0, 186, 0, 187, 0, 188, 0, 189, 0, 190, 0, 191, 0, 192, 0, 193, 0, 194, 0, 195, 0, 196, 0, 197, 0, 198, 0, 199, 0, 200, 0, 201, 0, 202, 0, 203, 0, 204, 0, 205, 0, 206, 0, 207, 0, 286, 0, 209, 0, 210, 0, 211, 0, 212, 0, 213, 0, 214, 0, 215, 0, 216, 0, 217, 0, 218, 0, 219, 0, 220, 0, 304, 0, 350, 0, 223, 0, 224, 0, 225, 0, 226, 0, 227, 0, 228, 0, 229, 0, 230, 0, 231, 0, 232, 0, 233, 0, 234, 0, 235, 0, 236, 0, 237, 0, 238, 0, 239, 0, 287, 0, 241, 0, 242, 0, 243, 0, 244, 0, 245, 0, 246, 0, 247, 0, 248, 0, 249, 0, 250, 0, 251, 0, 252, 0, 305, 0, 351, 0, 255, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZL11ISO_8859_14=allocate([160, 0, 7682, 0, 7683, 0, 163, 0, 266, 0, 267, 0, 7690, 0, 167, 0, 7808, 0, 169, 0, 7810, 0, 7691, 0, 7922, 0, 173, 0, 174, 0, 376, 0, 7710, 0, 7711, 0, 288, 0, 289, 0, 7744, 0, 7745, 0, 182, 0, 7766, 0, 7809, 0, 7767, 0, 7811, 0, 7776, 0, 7923, 0, 7812, 0, 7813, 0, 7777, 0, 192, 0, 193, 0, 194, 0, 195, 0, 196, 0, 197, 0, 198, 0, 199, 0, 200, 0, 201, 0, 202, 0, 203, 0, 204, 0, 205, 0, 206, 0, 207, 0, 372, 0, 209, 0, 210, 0, 211, 0, 212, 0, 213, 0, 214, 0, 7786, 0, 216, 0, 217, 0, 218, 0, 219, 0, 220, 0, 221, 0, 374, 0, 223, 0, 224, 0, 225, 0, 226, 0, 227, 0, 228, 0, 229, 0, 230, 0, 231, 0, 232, 0, 233, 0, 234, 0, 235, 0, 236, 0, 237, 0, 238, 0, 239, 0, 373, 0, 241, 0, 242, 0, 243, 0, 244, 0, 245, 0, 246, 0, 7787, 0, 248, 0, 249, 0, 250, 0, 251, 0, 252, 0, 253, 0, 375, 0, 255, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZL6KOI8_R=allocate([9552, 0, 9553, 0, 9554, 0, 1105, 0, 9555, 0, 9556, 0, 9557, 0, 9558, 0, 9559, 0, 9560, 0, 9561, 0, 9562, 0, 9563, 0, 9564, 0, 9565, 0, 9566, 0, 9567, 0, 9568, 0, 9569, 0, 1025, 0, 9570, 0, 9571, 0, 9572, 0, 9573, 0, 9574, 0, 9575, 0, 9576, 0, 9577, 0, 9578, 0, 9579, 0, 9580, 0, 169, 0, 1102, 0, 1072, 0, 1073, 0, 1094, 0, 1076, 0, 1077, 0, 1092, 0, 1075, 0, 1093, 0, 1080, 0, 1081, 0, 1082, 0, 1083, 0, 1084, 0, 1085, 0, 1086, 0, 1087, 0, 1103, 0, 1088, 0, 1089, 0, 1090, 0, 1091, 0, 1078, 0, 1074, 0, 1100, 0, 1099, 0, 1079, 0, 1096, 0, 1101, 0, 1097, 0, 1095, 0, 1098, 0, 1070, 0, 1040, 0, 1041, 0, 1062, 0, 1044, 0, 1045, 0, 1060, 0, 1043, 0, 1061, 0, 1048, 0, 1049, 0, 1050, 0, 1051, 0, 1052, 0, 1053, 0, 1054, 0, 1055, 0, 1071, 0, 1056, 0, 1057, 0, 1058, 0, 1059, 0, 1046, 0, 1042, 0, 1068, 0, 1067, 0, 1047, 0, 1064, 0, 1069, 0, 1065, 0, 1063, 0, 1066, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZL5ISCII=allocate([32, 0, 2305, 0, 2306, 0, 2307, 0, 2309, 0, 2310, 0, 2311, 0, 2312, 0, 2313, 0, 2314, 0, 2315, 0, 2318, 0, 2319, 0, 2320, 0, 2317, 0, 2322, 0, 2323, 0, 2324, 0, 2321, 0, 2325, 0, 2326, 0, 2327, 0, 2328, 0, 2329, 0, 2330, 0, 2331, 0, 2332, 0, 2333, 0, 2334, 0, 2335, 0, 2336, 0, 2337, 0, 2338, 0, 2339, 0, 2340, 0, 2341, 0, 2342, 0, 2343, 0, 2344, 0, 2345, 0, 2346, 0, 2347, 0, 2348, 0, 2349, 0, 2350, 0, 2351, 0, 2399, 0, 2352, 0, 2353, 0, 2354, 0, 2355, 0, 2356, 0, 2357, 0, 2358, 0, 2359, 0, 2360, 0, 2361, 0, 32, 0, 2366, 0, 2367, 0, 2368, 0, 2369, 0, 2370, 0, 2371, 0, 2374, 0, 2375, 0, 2376, 0, 2373, 0, 2378, 0, 2379, 0, 2380, 0, 2377, 0, 2381, 0, 2364, 0, 2404, 0, 32, 0, 32, 0, 32, 0, 32, 0, 32, 0, 32, 0, 48, 0, 49, 0, 50, 0, 51, 0, 52, 0, 53, 0, 54, 0, 55, 0, 56, 0, 57, 0, 32, 0, 32, 0, 32, 0, 32, 0, 32, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
_charsets=allocate(80, "i16*", ALLOC_STATIC);
__ZL15length_mod_tabs=allocate(24, "i8*", ALLOC_STATIC);
__ZZ7IsAlphajE18extra_indic_alphas=allocate([2672, 0, 2673, 0, 0, 0], ["i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZL8brackets=allocate([40, 0, 41, 0, 91, 0, 93, 0, 123, 0, 125, 0, 60, 0, 62, 0, 34, 0, 39, 0, 96, 0, 171, 0, 187, 0, 12298, 0, 12299, 0, -8132, 0, 0, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ8utf8_outjPcE4code=allocate([0,192,224,240] /* \00\C0\E0\F0 */, "i8", ALLOC_STATIC);
__ZZ8utf8_in2PiPKciE4mask=allocate([255,31,15,7] /* \FF\1F\0F\07 */, "i8", ALLOC_STATIC);
__str543=allocate([40,37,115,41,32,37,115,32,32,45,62,32,40,37,115,41,32,0] /* (%s) %s  -> (%s) \00 */, "i8", ALLOC_STATIC);
__str1544=allocate([37,115,10,10,0] /* %s\0A\0A\00 */, "i8", ALLOC_STATIC);
__ZZ13TranslateWordP10TranslatorPciP8WORD_TABE7word_zz=allocate([0,122,122,0] /* \00zz\00 */, "i8", ALLOC_STATIC);
__ZZ13TranslateWordP10TranslatorPciP8WORD_TABE7word_iz=allocate([0,105,122,0] /* \00iz\00 */, "i8", ALLOC_STATIC);
__ZZ13TranslateWordP10TranslatorPciP8WORD_TABE7word_ss=allocate([0,115,115,0] /* \00ss\00 */, "i8", ALLOC_STATIC);
__str2545=allocate([95,48,108,97,110,103,0] /* _0lang\00 */, "i8", ALLOC_STATIC);
__str4547=allocate([32,32,115,117,102,102,105,120,32,91,37,115,93,10,10,0] /*   suffix [%s]\0A\0A\ */, "i8", ALLOC_STATIC);
__str5548=allocate([104,115,120,0] /* hsx\00 */, "i8", ALLOC_STATIC);
__str6549=allocate([37,115,37,115,37,115,0] /* %s%s%s\00 */, "i8", ALLOC_STATIC);
__ZL18any_stressed_words_b=allocate(1, "i1", ALLOC_STATIC);
__ZZ15TranslateClauseP10TranslatorP7__sFILEPKvPiPPcE17voice_change_name=allocate(40, "i8", ALLOC_STATIC);
__ZL11embedded_ix=allocate(1, "i32", ALLOC_STATIC);
__ZL13embedded_read=allocate(1, "i32", ALLOC_STATIC);
__ZL6source=allocate(740, "i8", ALLOC_STATIC);
__str7550=allocate([67,76,65,85,83,69,32,37,120,58,10,0] /* CLAUSE %x:\0A\00 */, "i8", ALLOC_STATIC);
__str8551=allocate([69,78,68,67,76,65,85,83,69,10,0] /* ENDCLAUSE\0A\00 */, "i8", ALLOC_STATIC);
__ZL16max_clause_pause=allocate(1, "i32", ALLOC_STATIC);
__ZL13option_sayas2=allocate(1, "i32", ALLOC_STATIC);
__ZL18count_sayas_digits=allocate(1, "i32", ALLOC_STATIC);
__ZL6breaks=allocate([95, 0, 0, 0], ["i16",0,"i16",0], ALLOC_STATIC);
__ZL13word_emphasis_b=allocate(1, "i1", ALLOC_STATIC);
__ZL15option_emphasis=allocate(1, "i32", ALLOC_STATIC);
__ZL13embedded_flag_b=allocate(1, "i1", ALLOC_STATIC);
__str9552=allocate([87,79,82,68,58,32,102,108,103,61,37,46,53,120,32,108,101,110,61,37,100,32,32,39,0] /* WORD: flg=%.5x len=% */, "i8", ALLOC_STATIC);
__str10553=allocate([39,10,0] /* '\0A\00 */, "i8", ALLOC_STATIC);
__str11554=allocate([95,94,95,0] /* _^_\00 */, "i8", ALLOC_STATIC);
__ZZL13TranslateCharP10TranslatorPcijjPiE20hangul_compatibility=allocate([0,0,1,170,2,172,173,3,4,5,176,177,178,179,180,180,182,6,7,8,185,9,10,188,12,13,14,15,16,17,18,97,98,99,100,101,102,103,104,105,106,107,108,109,110,111,112,113,114,115,116,117] /* \00\00\01\AA\02\AC\A */, "i8", ALLOC_STATIC);
__ZZL14SubstituteCharP10TranslatorjjPiE11ignore_next_b=allocate(1, "i1", ALLOC_STATIC);
__str12555=allocate([80,83,65,82,72,84,73,86,89,77,85,66,70,0] /* PSARHTIVYMUBF\00 */, "i8", ALLOC_STATIC);
__ZL14length_mods_en=allocate([100,120,100,105,100,110,110,100,95,100,105,120,105,110,125,130,135,115,125,100,105,120,75,100,75,105,120,85,75,100,105,120,85,105,95,115,120,100,95,100,110,120,95,105,100,115,120,100,100,100,105,120,100,105,95,115,120,110,95,100,105,120,100,105,105,122,125,110,105,100,105,120,100,105,105,122,125,110,105,100,105,120,95,105,100,115,120,110,100,100,100,120,100,100,100,100,100,100,100,100] /* dxdidnnd_dixin}\82\8 */, "i8", ALLOC_STATIC);
__ZL15length_mods_en0=allocate([100,150,100,105,110,115,110,110,110,100,105,150,105,110,125,135,140,115,135,100,105,150,90,105,90,122,135,100,90,100,105,150,100,105,100,122,135,100,100,100,105,150,100,105,105,115,135,110,105,100,105,150,100,105,105,122,130,120,125,100,105,150,100,105,110,122,125,115,110,100,105,150,100,105,105,122,135,120,105,100,105,150,100,105,105,115,135,110,105,100,100,100,100,100,100,100,100,100,100,100] /* d\96dinsnnndi\96in}\ */, "i8", ALLOC_STATIC);
__ZL17length_mods_equal=allocate([110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110] /* nnnnnnnnnnnnnnnnnnnn */, "i8", ALLOC_STATIC);
__str580=allocate([35,10,0] /* #\0A\00 */, "i8", ALLOC_STATIC);
__str1581=allocate([117,110,97,98,108,101,32,116,111,32,103,101,116,32,46,119,97,118,32,104,101,97,100,101,114,32,102,114,111,109,32,109,98,114,111,108,97,0] /* unable to get .wav h */, "i8", ALLOC_STATIC);
__str2582=allocate([82,73,70,70,0] /* RIFF\00 */, "i8", ALLOC_STATIC);
__str3583=allocate([87,65,86,69,102,109,116,32,0] /* WAVEfmt \00 */, "i8", ALLOC_STATIC);
__str4584=allocate([109,98,114,111,108,97,32,100,105,100,32,110,111,116,32,114,101,116,117,114,110,32,97,32,46,119,97,118,32,104,101,97,100,101,114,0] /* mbrola did not retur */, "i8", ALLOC_STATIC);
__ZL14mbr_samplerate=allocate(1, "i32", ALLOC_STATIC);
__ZL14mbr_voice_path=allocate(1, "i8*", ALLOC_STATIC);
__ZL10mbr_volume=allocate([1], ["float",0,0,0,0], ALLOC_STATIC);
__ZL9mbr_state=allocate(1, "i32", ALLOC_STATIC);
__ZL7mbr_pid=allocate(1, "i32", ALLOC_STATIC);
__ZL10mbr_cmd_fd=allocate(1, "i32", ALLOC_STATIC);
__str5585=allocate([10,35,10,0] /* \0A#\0A\00 */, "i8", ALLOC_STATIC);
__ZL12mbr_audio_fd=allocate(1, "i32", ALLOC_STATIC);
__ZL12mbr_errorbuf=allocate(160, "i8", ALLOC_STATIC);
__ZL12mbr_error_fd=allocate(1, "i32", ALLOC_STATIC);
__str7587=allocate([114,101,97,100,40,101,114,114,111,114,41,58,32,37,115,0] /* read(error): %s\00 */, "i8", ALLOC_STATIC);
__str8588=allocate([71,111,116,32,97,32,114,101,115,101,116,32,115,105,103,110,97,108,0] /* Got a reset signal\0 */, "i8", ALLOC_STATIC);
__str9589=allocate([73,110,112,117,116,32,70,108,117,115,104,32,83,105,103,110,97,108,0] /* Input Flush Signal\0 */, "i8", ALLOC_STATIC);
__str10590=allocate([109,98,114,111,108,97,58,32,37,115,0] /* mbrola: %s\00 */, "i8", ALLOC_STATIC);
__str11591=allocate([109,98,114,111,108,97,32,99,108,111,115,101,100,32,115,116,100,101,114,114,32,97,110,100,32,100,105,100,32,110,111,116,32,101,120,105,116,0] /* mbrola closed stderr */, "i8", ALLOC_STATIC);
__str12592=allocate([119,97,105,116,112,105,100,40,41,32,105,115,32,99,111,110,102,117,115,101,100,0] /* waitpid() is confuse */, "i8", ALLOC_STATIC);
__str13593=allocate([109,98,114,111,108,97,32,100,105,101,100,32,98,121,32,115,105,103,110,97,108,32,37,100,0] /* mbrola died by signa */, "i8", ALLOC_STATIC);
__str14594=allocate([109,98,114,111,108,97,32,101,120,105,116,101,100,32,119,105,116,104,32,115,116,97,116,117,115,32,37,100,0] /* mbrola exited with s */, "i8", ALLOC_STATIC);
__str15595=allocate([109,98,114,111,108,97,32,100,105,101,100,32,97,110,100,32,119,97,105,116,32,115,116,97,116,117,115,32,105,115,32,119,101,105,114,100,0] /* mbrola died and wait */, "i8", ALLOC_STATIC);
__str16596=allocate([109,98,114,111,119,114,97,112,32,101,114,114,111,114,58,32,37,115,0] /* mbrowrap error: %s\0 */, "i8", ALLOC_STATIC);
__str17597=allocate([44,32,40,37,115,41,0] /* , (%s)\00 */, "i8", ALLOC_STATIC);
__ZL21mbr_pending_data_head=allocate(1, "%struct.datablock*", ALLOC_STATIC);
__ZL21mbr_pending_data_tail=allocate(1, "%struct.datablock*", ALLOC_STATIC);
__str18598=allocate([112,111,108,108,40,41,58,32,37,115,0] /* poll(): %s\00 */, "i8", ALLOC_STATIC);
__str19599=allocate([109,98,114,111,108,97,32,112,114,111,99,101,115,115,32,105,115,32,115,116,97,108,108,101,100,0] /* mbrola process is st */, "i8", ALLOC_STATIC);
__str20600=allocate([119,114,105,116,101,40,41,58,32,37,115,0] /* write(): %s\00 */, "i8", ALLOC_STATIC);
__str21601=allocate([114,101,97,100,40,41,58,32,37,115,0] /* read(): %s\00 */, "i8", ALLOC_STATIC);
__ZL13mbr_proc_stat=allocate(1, "i32", ALLOC_STATIC);
__str22602=allocate([109,98,114,111,108,97,32,105,110,105,116,32,114,101,113,117,101,115,116,32,119,104,101,110,32,97,108,114,101,97,100,121,32,105,110,105,116,105,97,108,105,122,101,100,0] /* mbrola init request  */, "i8", ALLOC_STATIC);
__str23603=allocate([102,111,114,107,40,41,58,32,37,115,0] /* fork(): %s\00 */, "i8", ALLOC_STATIC);
__str24604=allocate([100,117,112,50,40,41,58,32,37,115,10,0] /* dup2(): %s\0A\00 */, "i8", ALLOC_STATIC);
__str25605=allocate([37,103,0] /* %g\00 */, "i8", ALLOC_STATIC);
__str27607=allocate([45,101,0] /* -e\00 */, "i8", ALLOC_STATIC);
__str28608=allocate([45,118,0] /* -v\00 */, "i8", ALLOC_STATIC);
__str30610=allocate([45,46,119,97,118,0] /* -.wav\00 */, "i8", ALLOC_STATIC);
__str31611=allocate([109,98,114,111,108,97,58,32,37,115,10,0] /* mbrola: %s\0A\00 */, "i8", ALLOC_STATIC);
__str32612=allocate([47,112,114,111,99,47,37,100,47,115,116,97,116,0] /* /proc/%d/stat\00 */, "i8", ALLOC_STATIC);
__str33613=allocate([47,112,114,111,99,32,105,115,32,117,110,97,99,99,101,115,115,105,98,108,101,58,32,37,115,0] /* /proc is unaccessibl */, "i8", ALLOC_STATIC);
__str34614=allocate([102,99,110,116,108,40,41,58,32,37,115,0] /* fcntl(): %s\00 */, "i8", ALLOC_STATIC);
__str35615=allocate([112,105,112,101,40,41,58,32,37,115,0] /* pipe(): %s\00 */, "i8", ALLOC_STATIC);
__ZZ15SetIndicLettersP10TranslatorE15dev_consonants2=allocate([2,3,88,89,90,91,92,93,94,95] /* \02\03XYZ[\5C]^_ */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_fr=allocate([190, 0, 170, 0, 190, 0, 200, 0, 0, 0, 0, 0, 190, 0, 240, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE14stress_amps_fr=allocate([18,16,18,18,18,18,18,18] /* \12\10\12\12\12\12\1 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE14stress_amps_sk=allocate([17,17,20,20,20,22,22,21] /* \11\11\14\14\14\16\1 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_sk=allocate([190, 0, 190, 0, 210, 0, 210, 0, 0, 0, 0, 0, 210, 0, 210, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_ta=allocate([200, 0, 200, 0, 210, 0, 210, 0, 0, 0, 0, 0, 230, 0, 230, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE14stress_amps_ta=allocate([18,18,18,18,20,20,22,22] /* \12\12\12\12\14\14\1 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_af=allocate([170, 0, 140, 0, 220, 0, 220, 0, 0, 0, 0, 0, 250, 0, 270, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_bn=allocate([180, 0, 180, 0, 210, 0, 210, 0, 0, 0, 0, 0, 230, 0, 240, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE14stress_amps_bn=allocate([18,18,18,18,20,20,22,22] /* \12\12\12\12\14\14\1 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_cy=allocate([170, 0, 220, 0, 180, 0, 180, 0, 0, 0, 0, 0, 250, 0, 270, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE14stress_amps_cy=allocate([17,15,18,18,0,0,22,20] /* \11\0F\12\12\00\00\1 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_da=allocate([160, 0, 140, 0, 200, 0, 200, 0, 0, 0, 0, 0, 220, 0, 230, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_de=allocate([150, 0, 130, 0, 200, 0, 200, 0, 0, 0, 0, 0, 270, 0, 270, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE14stress_amps_de=allocate([20,20,20,20,20,22,22,20] /* \14\14\14\14\14\16\1 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_en=allocate([182, 0, 140, 0, 220, 0, 220, 0, 0, 0, 0, 0, 248, 0, 275, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__str630=allocate([97,101,105,111,117,121,0] /* aeiouy\00 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_el=allocate([155, 0, 180, 0, 210, 0, 210, 0, 0, 0, 0, 0, 270, 0, 300, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE14stress_amps_el=allocate([15,12,20,20,20,22,22,21] /* \0F\0C\14\14\14\16\1 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE9el_vowels=allocate([16,44,45,46,47,48,49,53,55,57,63,69,73,74,75,76,77,78,79,0] /* \10,-./01579?EIJKLMN */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE10el_fvowels=allocate([45,46,47,53,55,57,69,77,0] /* -./579EM\00 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE12el_voiceless=allocate([56,58,62,64,66,67,68,70,71,0] /* 8:>@BCDFG\00 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE13el_consonants=allocate([50,51,52,54,56,58,59,60,61,62,64,65,66,67,68,70,71,72,0] /* 23468:;<=>@ABCDFGH\0 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE18el_char_apostrophe=allocate([963, 0, 0, 0, 0, 0, 0, 0], ["i32",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_eo=allocate([150, 0, 150, 0, 230, 0, 180, 0, 0, 0, 0, 0, 300, 0, 320, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE14stress_amps_eo=allocate([16,14,20,20,20,22,22,21] /* \10\0E\14\14\14\16\1 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE18eo_char_apostrophe=allocate([108, 0, 0, 0, 0, 0, 0, 0], ["i32",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_es=allocate([180, 0, 210, 0, 190, 0, 190, 0, 0, 0, 0, 0, 230, 0, 260, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE14stress_amps_es=allocate([16,12,18,18,20,20,20,20] /* \10\0C\12\12\14\14\1 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE20ca_punct_within_word=allocate([39, 0, 0, 0, 183, 0, 0, 0, 0, 0, 0, 0], ["i32",0,0,0,"i32",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_eu=allocate([200, 0, 200, 0, 200, 0, 200, 0, 0, 0, 0, 0, 210, 0, 230, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE14stress_amps_eu=allocate([16,16,18,18,18,18,18,18] /* \10\10\12\12\12\12\1 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE14stress_amps_fi=allocate([18,16,22,22,20,22,22,22] /* \12\10\16\16\14\16\1 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_fi=allocate([150, 0, 180, 0, 200, 0, 200, 0, 0, 0, 0, 0, 210, 0, 250, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_hi=allocate([190, 0, 190, 0, 210, 0, 210, 0, 0, 0, 0, 0, 230, 0, 250, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE14stress_amps_hi=allocate([17,14,20,19,20,22,22,21] /* \11\0E\14\13\14\16\1 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE14stress_amps_hr=allocate([17,17,20,20,20,22,22,21] /* \11\11\14\14\14\16\1 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_hr=allocate([180, 0, 160, 0, 200, 0, 200, 0, 0, 0, 0, 0, 220, 0, 230, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_sr=allocate([160, 0, 150, 0, 200, 0, 200, 0, 0, 0, 0, 0, 250, 0, 260, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZL22replace_cyrillic_latin=allocate([1072, 0, 0, 0, 97, 0, 0, 0, 1073, 0, 0, 0, 98, 0, 0, 0, 1094, 0, 0, 0, 99, 0, 0, 0, 1115, 0, 0, 0, 263, 0, 0, 0, 1095, 0, 0, 0, 269, 0, 0, 0, 1119, 0, 0, 0, 25034852, 0, 0, 0, 1109, 0, 0, 0, 7995492, 0, 0, 0, 1076, 0, 0, 0, 100, 0, 0, 0, 1106, 0, 0, 0, 273, 0, 0, 0, 1077, 0, 0, 0, 101, 0, 0, 0, 1092, 0, 0, 0, 102, 0, 0, 0, 1075, 0, 0, 0, 103, 0, 0, 0, 1093, 0, 0, 0, 104, 0, 0, 0, 1080, 0, 0, 0, 105, 0, 0, 0, 1112, 0, 0, 0, 106, 0, 0, 0, 1082, 0, 0, 0, 107, 0, 0, 0, 1113, 0, 0, 0, 6946924, 0, 0, 0, 1083, 0, 0, 0, 108, 0, 0, 0, 1084, 0, 0, 0, 109, 0, 0, 0, 1114, 0, 0, 0, 6946926, 0, 0, 0, 1085, 0, 0, 0, 110, 0, 0, 0, 1086, 0, 0, 0, 111, 0, 0, 0, 1087, 0, 0, 0, 112, 0, 0, 0, 1088, 0, 0, 0, 114, 0, 0, 0, 1089, 0, 0, 0, 115, 0, 0, 0, 1096, 0, 0, 0, 353, 0, 0, 0, 1090, 0, 0, 0, 116, 0, 0, 0, 1091, 0, 0, 0, 117, 0, 0, 0, 1074, 0, 0, 0, 118, 0, 0, 0, 1079, 0, 0, 0, 122, 0, 0, 0, 1078, 0, 0, 0, 382, 0, 0, 0, 1107, 0, 0, 0, 273, 0, 0, 0, 1116, 0, 0, 0, 263, 0, 0, 0, 0, 0, 0, 0], ["i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE14stress_amps_hu=allocate([17,17,19,19,20,22,22,21] /* \11\11\13\13\14\16\1 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_hu=allocate([185, 0, 195, 0, 195, 0, 190, 0, 0, 0, 0, 0, 210, 0, 220, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_hy=allocate([250, 0, 200, 0, 250, 0, 250, 0, 0, 0, 0, 0, 250, 0, 250, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE9hy_vowels=allocate([49,53,55,56,59,72,85,0] /* 1578;HU\00 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE13hy_consonants=allocate([50,51,52,54,57,58,60,61,62,63,64,65,66,67,68,69,70,71,73,74,75,76,77,78,79,80,81,82,83,84,86,0] /* 23469:<=>?@ABCDEFGIJ */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_id=allocate([160, 0, 200, 0, 180, 0, 180, 0, 0, 0, 0, 0, 220, 0, 240, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE14stress_amps_id=allocate([16,18,18,18,20,22,22,21] /* \10\12\12\12\14\16\1 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_is=allocate([180, 0, 160, 0, 200, 0, 200, 0, 0, 0, 0, 0, 240, 0, 250, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE16is_lettergroup_B=allocate([99, 0, 0, 0, 102, 0, 0, 0, 104, 0, 0, 0, 107, 0, 0, 0, 112, 0, 0, 0, 116, 0, 0, 0, 120, 0, 0, 0, 254, 0, 0, 0, 0, 0, 0, 0], ["i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__str1631=allocate([107,112,115,116,0] /* kpst\00 */, "i8", ALLOC_STATIC);
__str2632=allocate([106,118,114,0] /* jvr\00 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_it=allocate([150, 0, 140, 0, 170, 0, 170, 0, 0, 0, 0, 0, 300, 0, 330, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE14stress_amps_it=allocate([15,14,19,19,20,22,22,20] /* \0F\0E\13\13\14\16\1 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE18stress_lengths_jbo=allocate([145, 0, 145, 0, 170, 0, 160, 0, 0, 0, 0, 0, 330, 0, 350, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE21jbo_punct_within_word=allocate([46, 0, 0, 0, 44, 0, 0, 0, 39, 0, 0, 0, 712, 0, 0, 0, 0, 0, 0, 0], ["i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE9ka_vowels=allocate([80,84,88,93,99,117,119,0] /* PTX]cuw\00 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE13ka_consonants=allocate([81,82,83,85,86,87,89,90,91,92,94,95,96,97,98,100,101,102,103,104,105,106,107,108,109,110,111,112,113,114,115,116,118,0] /* QRSUVWYZ[\5C^_`abdef */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE10ko_ivowels=allocate([99,100,103,104,109,114,116,117,0] /* cdghmrtu\00 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE9ko_voiced=allocate([2,5,6,171,175,183,188,0] /* \02\05\06\AB\AF\B7\B */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE14stress_amps_ku=allocate([18,18,20,20,20,22,22,21] /* \12\12\14\14\14\16\1 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_ku=allocate([180, 0, 180, 0, 190, 0, 180, 0, 0, 0, 0, 0, 230, 0, 240, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE14stress_amps_lv=allocate([17,13,20,20,20,22,22,21] /* \11\0D\14\14\14\16\1 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_lv=allocate([180, 0, 130, 0, 210, 0, 210, 0, 0, 0, 0, 0, 210, 0, 210, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE15vowels_cyrillic=allocate([1088, 0, 0, 0, 1072, 0, 0, 0, 1077, 0, 0, 0, 1080, 0, 0, 0, 1081, 0, 0, 0, 1086, 0, 0, 0, 1091, 0, 0, 0, 1099, 0, 0, 0, 1101, 0, 0, 0, 1102, 0, 0, 0, 1103, 0, 0, 0, 1104, 0, 0, 0, 1105, 0, 0, 0, 1110, 0, 0, 0, 1111, 0, 0, 0, 1117, 0, 0, 0, 1118, 0, 0, 0, 0, 0, 0, 0], ["i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE14stress_amps_mk=allocate([17,17,20,20,20,22,22,21] /* \11\11\14\14\14\16\1 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_mk=allocate([180, 0, 160, 0, 200, 0, 200, 0, 0, 0, 0, 0, 220, 0, 230, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_nl=allocate([160, 0, 135, 0, 210, 0, 210, 0, 0, 0, 0, 0, 260, 0, 280, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__str3633=allocate([101,0] /* e\00 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_no=allocate([160, 0, 140, 0, 200, 0, 200, 0, 0, 0, 0, 0, 220, 0, 230, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE14stress_amps_om=allocate([18,15,20,20,20,22,22,22] /* \12\0F\14\14\14\16\1 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_om=allocate([200, 0, 200, 0, 200, 0, 200, 0, 0, 0, 0, 0, 200, 0, 200, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_pl=allocate([160, 0, 190, 0, 175, 0, 175, 0, 0, 0, 0, 0, 200, 0, 210, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE14stress_amps_pl=allocate([17,13,19,19,20,22,22,21] /* \11\0D\13\13\14\16\1 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_pt=allocate([170, 0, 115, 0, 210, 0, 240, 0, 0, 0, 0, 0, 260, 0, 280, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE14stress_amps_pt=allocate([16,11,19,21,20,22,22,21] /* \10\0B\13\15\14\16\1 */, "i8", ALLOC_STATIC);
__str4634=allocate([98,99,100,102,103,106,107,109,110,112,113,115,116,118,120,122,0] /* bcdfgjkmnpqstvxz\00 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_ro=allocate([170, 0, 170, 0, 180, 0, 180, 0, 0, 0, 0, 0, 240, 0, 260, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE14stress_amps_ro=allocate([15,13,18,18,20,22,22,21] /* \0F\0D\12\12\14\16\1 */, "i8", ALLOC_STATIC);
__str5635=allocate([98,100,103,106,108,109,110,114,118,119,122,97,101,105,111,117,121,0] /* bdgjlmnrvwzaeiouy\00 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_sq=allocate([150, 0, 150, 0, 180, 0, 180, 0, 0, 0, 0, 0, 300, 0, 300, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE14stress_amps_sq=allocate([16,12,16,16,20,20,21,19] /* \10\0C\10\10\14\14\1 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE14stress_amps_sv=allocate([16,16,20,20,20,22,22,21] /* \10\10\14\14\14\16\1 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_sv=allocate([160, 0, 135, 0, 220, 0, 220, 0, 0, 0, 0, 0, 250, 0, 280, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_sw=allocate([160, 0, 170, 0, 200, 0, 200, 0, 0, 0, 0, 0, 320, 0, 340, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE14stress_amps_sw=allocate([16,12,19,19,20,22,22,21] /* \10\0C\13\13\14\16\1 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE14stress_amps_tr=allocate([18,16,20,21,20,21,21,20] /* \12\10\14\15\14\15\1 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_tr=allocate([190, 0, 180, 0, 200, 0, 230, 0, 0, 0, 0, 0, 240, 0, 250, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_vi=allocate([150, 0, 150, 0, 180, 0, 180, 0, 210, 0, 230, 0, 230, 0, 240, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE14stress_amps_vi=allocate([16,16,16,16,22,22,22,22] /* \10\10\10\10\16\16\1 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE9vowels_vi=allocate([97, 0, 0, 0, 224, 0, 0, 0, 225, 0, 0, 0, 7843, 0, 0, 0, 227, 0, 0, 0, 7841, 0, 0, 0, 259, 0, 0, 0, 7857, 0, 0, 0, 7855, 0, 0, 0, 7859, 0, 0, 0, 7861, 0, 0, 0, 7863, 0, 0, 0, 226, 0, 0, 0, 7847, 0, 0, 0, 7845, 0, 0, 0, 7849, 0, 0, 0, 7851, 0, 0, 0, 7853, 0, 0, 0, 101, 0, 0, 0, 232, 0, 0, 0, 233, 0, 0, 0, 7867, 0, 0, 0, 7869, 0, 0, 0, 7865, 0, 0, 0, 234, 0, 0, 0, 7873, 0, 0, 0, 7871, 0, 0, 0, 7875, 0, 0, 0, 7877, 0, 0, 0, 7879, 0, 0, 0, 105, 0, 0, 0, 236, 0, 0, 0, 237, 0, 0, 0, 7881, 0, 0, 0, 297, 0, 0, 0, 7883, 0, 0, 0, 111, 0, 0, 0, 242, 0, 0, 0, 243, 0, 0, 0, 7887, 0, 0, 0, 245, 0, 0, 0, 7885, 0, 0, 0, 244, 0, 0, 0, 7891, 0, 0, 0, 7889, 0, 0, 0, 7893, 0, 0, 0, 7895, 0, 0, 0, 7897, 0, 0, 0, 417, 0, 0, 0, 7901, 0, 0, 0, 7899, 0, 0, 0, 7903, 0, 0, 0, 7905, 0, 0, 0, 7907, 0, 0, 0, 117, 0, 0, 0, 249, 0, 0, 0, 250, 0, 0, 0, 7911, 0, 0, 0, 361, 0, 0, 0, 7909, 0, 0, 0, 432, 0, 0, 0, 7915, 0, 0, 0, 7913, 0, 0, 0, 7917, 0, 0, 0, 7919, 0, 0, 0, 7921, 0, 0, 0, 121, 0, 0, 0, 7923, 0, 0, 0, 253, 0, 0, 0, 7927, 0, 0, 0, 7929, 0, 0, 0, 30, 0, 0, 0, 0, 0, 0, 0], ["i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_zh=allocate([230, 0, 150, 0, 230, 0, 230, 0, 230, 0, 0, 0, 240, 0, 250, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE14stress_amps_zh=allocate([22,16,22,22,22,22,22,22] /* \16\10\16\16\16\16\1 */, "i8", ALLOC_STATIC);
__ZZL18Translator_RussianP10TranslatorE14stress_amps_ru=allocate([16,16,18,18,20,24,24,22] /* \10\10\12\12\14\18\1 */, "i8", ALLOC_STATIC);
__ZZL18Translator_RussianP10TranslatorE17stress_lengths_ru=allocate([150, 0, 140, 0, 220, 0, 220, 0, 0, 0, 0, 0, 260, 0, 280, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZL18Translator_RussianP10TranslatorE11ru_ivowels2=allocate([44,21,24,46,47,0] /* ,\15\18./\00 */, "i8", ALLOC_STATIC);
__ZZL18SetCyrillicLettersP10TranslatorE9ru_vowels=allocate([16,21,49,24,30,35,43,45,46,47,0] /* \10\151\18\1E#+-./\0 */, "i8", ALLOC_STATIC);
__ZZL18SetCyrillicLettersP10TranslatorE13ru_consonants=allocate([17,18,19,20,22,23,25,26,27,28,29,31,32,33,34,36,37,38,39,40,41,42,44,0] /* \11\12\13\14\16\17\1 */, "i8", ALLOC_STATIC);
__ZZL18SetCyrillicLettersP10TranslatorE7ru_soft=allocate([44,25,39,41,0] /* ,\19')\00 */, "i8", ALLOC_STATIC);
__ZZL18SetCyrillicLettersP10TranslatorE7ru_hard=allocate([42,22,38,40,0] /* _\16&(\00 */, "i8", ALLOC_STATIC);
__ZZL18SetCyrillicLettersP10TranslatorE10ru_nothard=allocate([17,18,19,20,23,25,26,27,28,29,31,32,33,34,36,37,39,41,44,0] /* \11\12\13\14\17\19\1 */, "i8", ALLOC_STATIC);
__ZZL18SetCyrillicLettersP10TranslatorE9ru_voiced=allocate([17,18,19,20,22,23,0] /* \11\12\13\14\16\17\0 */, "i8", ALLOC_STATIC);
__ZZL18SetCyrillicLettersP10TranslatorE10ru_ivowels=allocate([44,46,47,49,0] /* ,./1\00 */, "i8", ALLOC_STATIC);
__ZL8pairs_ru=allocate([268, 0, 270, 0, 275, 0, 769, 0, 783, 0, 1550, 0, 1553, 0, 2307, 0, 2817, 0, 2831, 0, 3073, 0, 3081, 0, 3585, 0, 3590, 0, 3593, 0, 3598, 0, 3599, 0, 3612, 0, 3843, 0, 3857, 0, 3858, 0, 4111, 0, 4113, 0, 4353, 0, 4358, 0, 4361, 0, 4367, 0, 4627, 0, 4640, 0, 32767, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZL13NewTranslatorvE12stress_amps2=allocate([18,18,20,20,20,22,22,20] /* \12\12\14\14\14\16\1 */, "i8", ALLOC_STATIC);
__ZZL13NewTranslatorvE15stress_lengths2=allocate([182, 0, 140, 0, 220, 0, 220, 0, 220, 0, 240, 0, 260, 0, 280, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZL13NewTranslatorvE13empty_wstring=allocate(4, "i32", ALLOC_STATIC);
__ZZL13NewTranslatorvE13punct_in_word=allocate([39, 0, 0, 0, 0, 0, 0, 0], ["i32",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__ZZL13NewTranslatorvE13default_tunes=allocate([0,1,2,3,0,0] /* \00\01\02\03\00\00 */, "i8", ALLOC_STATIC);
__str6636=allocate([97,101,105,111,117,0] /* aeiou\00 */, "i8", ALLOC_STATIC);
__str7637=allocate([98,99,100,102,103,106,107,108,109,110,112,113,115,116,118,120,122,0] /* bcdfgjklmnpqstvxz\00 */, "i8", ALLOC_STATIC);
__str8638=allocate([98,99,100,102,103,104,106,107,108,109,110,112,113,114,115,116,118,119,120,122,0] /* bcdfghjklmnpqrstvwxz */, "i8", ALLOC_STATIC);
__str9639=allocate([104,108,109,110,114,0] /* hlmnr\00 */, "i8", ALLOC_STATIC);
__str10640=allocate([99,102,104,107,112,113,115,116,120,0] /* cfhkpqstx\00 */, "i8", ALLOC_STATIC);
__str11641=allocate([98,100,103,106,108,109,110,114,118,119,121,122,0] /* bdgjlmnrvwyz\00 */, "i8", ALLOC_STATIC);
__str12642=allocate([101,105,121,0] /* eiy\00 */, "i8", ALLOC_STATIC);
__str13643=allocate(1, "i8", ALLOC_STATIC);
__str646=allocate([117,110,107,110,111,119,110,0] /* unknown\00 */, "i8", ALLOC_STATIC);
__str1647=allocate([109,97,108,101,0] /* male\00 */, "i8", ALLOC_STATIC);
__str2648=allocate([102,101,109,97,108,101,0] /* female\00 */, "i8", ALLOC_STATIC);
_genders=allocate([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0], ALLOC_STATIC);
_tone_points=allocate([600, 0, 0, 0, 170, 0, 0, 0, 1200, 0, 0, 0, 135, 0, 0, 0, 2000, 0, 0, 0, 110, 0, 0, 0, 3000, 0, 0, 0, 110, 0, 0, 0, -1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], ["i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0], ALLOC_STATIC);
_formant_rate=allocate(36, "i32", ALLOC_STATIC);
_voice_selected=allocate(24, ["i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8","i8","i8","i8","i32",0,0,0,"i8*",0,0,0], ALLOC_STATIC);
__str3653=allocate([114,101,100,117,99,101,95,116,0] /* reduce_t\00 */, "i8", ALLOC_STATIC);
__str4654=allocate([98,114,97,99,107,101,116,0] /* bracket\00 */, "i8", ALLOC_STATIC);
__ZL11options_tab=allocate([0, 0, 0, 0, 12, 0, 0, 0, 0, 0, 0, 0, 16, 0, 0, 0, 0, 0, 0, 0, -1, 0, 0, 0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__str5655=allocate([110,97,109,101,0] /* name\00 */, "i8", ALLOC_STATIC);
__str6656=allocate([108,97,110,103,117,97,103,101,0] /* language\00 */, "i8", ALLOC_STATIC);
__str7657=allocate([103,101,110,100,101,114,0] /* gender\00 */, "i8", ALLOC_STATIC);
__str8658=allocate([102,111,114,109,97,110,116,0] /* formant\00 */, "i8", ALLOC_STATIC);
__str9659=allocate([112,105,116,99,104,0] /* pitch\00 */, "i8", ALLOC_STATIC);
__str10660=allocate([112,104,111,110,101,109,101,115,0] /* phonemes\00 */, "i8", ALLOC_STATIC);
__str11661=allocate([116,114,97,110,115,108,97,116,111,114,0] /* translator\00 */, "i8", ALLOC_STATIC);
__str12662=allocate([100,105,99,116,105,111,110,97,114,121,0] /* dictionary\00 */, "i8", ALLOC_STATIC);
__str13663=allocate([115,116,114,101,115,115,76,101,110,103,116,104,0] /* stressLength\00 */, "i8", ALLOC_STATIC);
__str14664=allocate([115,116,114,101,115,115,65,109,112,0] /* stressAmp\00 */, "i8", ALLOC_STATIC);
__str15665=allocate([115,116,114,101,115,115,65,100,100,0] /* stressAdd\00 */, "i8", ALLOC_STATIC);
__str16666=allocate([105,110,116,111,110,97,116,105,111,110,0] /* intonation\00 */, "i8", ALLOC_STATIC);
__str17667=allocate([116,117,110,101,115,0] /* tunes\00 */, "i8", ALLOC_STATIC);
__str18668=allocate([100,105,99,116,114,117,108,101,115,0] /* dictrules\00 */, "i8", ALLOC_STATIC);
__str19669=allocate([115,116,114,101,115,115,114,117,108,101,0] /* stressrule\00 */, "i8", ALLOC_STATIC);
__str20670=allocate([99,104,97,114,115,101,116,0] /* charset\00 */, "i8", ALLOC_STATIC);
__str21671=allocate([114,101,112,108,97,99,101,0] /* replace\00 */, "i8", ALLOC_STATIC);
__str22672=allocate([119,111,114,100,115,0] /* words\00 */, "i8", ALLOC_STATIC);
__str23673=allocate([101,99,104,111,0] /* echo\00 */, "i8", ALLOC_STATIC);
__str24674=allocate([102,108,117,116,116,101,114,0] /* flutter\00 */, "i8", ALLOC_STATIC);
__str25675=allocate([114,111,117,103,104,110,101,115,115,0] /* roughness\00 */, "i8", ALLOC_STATIC);
__str26676=allocate([99,108,97,114,105,116,121,0] /* clarity\00 */, "i8", ALLOC_STATIC);
__str27677=allocate([116,111,110,101,0] /* tone\00 */, "i8", ALLOC_STATIC);
__str28678=allocate([118,111,105,99,105,110,103,0] /* voicing\00 */, "i8", ALLOC_STATIC);
__str29679=allocate([98,114,101,97,116,104,0] /* breath\00 */, "i8", ALLOC_STATIC);
__str30680=allocate([98,114,101,97,116,104,119,0] /* breathw\00 */, "i8", ALLOC_STATIC);
__str31681=allocate([110,117,109,98,101,114,115,0] /* numbers\00 */, "i8", ALLOC_STATIC);
__str32682=allocate([111,112,116,105,111,110,0] /* option\00 */, "i8", ALLOC_STATIC);
__str33683=allocate([109,98,114,111,108,97,0] /* mbrola\00 */, "i8", ALLOC_STATIC);
__str34684=allocate([99,111,110,115,111,110,97,110,116,115,0] /* consonants\00 */, "i8", ALLOC_STATIC);
__str35685=allocate([107,108,97,116,116,0] /* klatt\00 */, "i8", ALLOC_STATIC);
__str36686=allocate([102,97,115,116,95,116,101,115,116,50,0] /* fast_test2\00 */, "i8", ALLOC_STATIC);
__str37687=allocate([115,112,101,101,100,0] /* speed\00 */, "i8", ALLOC_STATIC);
__str38688=allocate([108,95,100,105,101,114,101,115,105,115,0] /* l_dieresis\00 */, "i8", ALLOC_STATIC);
__str39689=allocate([108,95,112,114,101,102,105,120,0] /* l_prefix\00 */, "i8", ALLOC_STATIC);
__str40690=allocate([108,95,114,101,103,114,101,115,115,105,118,101,95,118,0] /* l_regressive_v\00 */, "i8", ALLOC_STATIC);
__str41691=allocate([108,95,117,110,112,114,111,110,111,117,110,99,97,98,108,101,0] /* l_unpronouncable\00 */, "i8", ALLOC_STATIC);
__str42692=allocate([108,95,115,111,110,111,114,97,110,116,95,109,105,110,0] /* l_sonorant_min\00 */, "i8", ALLOC_STATIC);
__str43693=allocate([108,95,108,101,110,103,116,104,95,109,111,100,115,0] /* l_length_mods\00 */, "i8", ALLOC_STATIC);
__ZL11keyword_tab=allocate([0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 7, 0, 0, 0, 0, 0, 0, 0, 8, 0, 0, 0, 0, 0, 0, 0, 5, 0, 0, 0, 0, 0, 0, 0, 4, 0, 0, 0, 0, 0, 0, 0, 6, 0, 0, 0, 0, 0, 0, 0, 20, 0, 0, 0, 0, 0, 0, 0, 21, 0, 0, 0, 0, 0, 0, 0, 22, 0, 0, 0, 0, 0, 0, 0, 18, 0, 0, 0, 0, 0, 0, 0, 19, 0, 0, 0, 0, 0, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0, 24, 0, 0, 0, 0, 0, 0, 0, 25, 0, 0, 0, 0, 0, 0, 0, 32, 0, 0, 0, 0, 0, 0, 0, 17, 0, 0, 0, 0, 0, 0, 0, 9, 0, 0, 0, 0, 0, 0, 0, 10, 0, 0, 0, 0, 0, 0, 0, 11, 0, 0, 0, 0, 0, 0, 0, 12, 0, 0, 0, 0, 0, 0, 0, 13, 0, 0, 0, 0, 0, 0, 0, 14, 0, 0, 0, 0, 0, 0, 0, 15, 0, 0, 0, 0, 0, 0, 0, 16, 0, 0, 0, 0, 0, 0, 0, 26, 0, 0, 0, 0, 0, 0, 0, 27, 0, 0, 0, 0, 0, 0, 0, 28, 0, 0, 0, 0, 0, 0, 0, 33, 0, 0, 0, 0, 0, 0, 0, 29, 0, 0, 0, 0, 0, 0, 0, 30, 0, 0, 0, 0, 0, 0, 0, 31, 0, 0, 0, 0, 0, 0, 0, 257, 0, 0, 0, 0, 0, 0, 0, 259, 0, 0, 0, 0, 0, 0, 0, 260, 0, 0, 0, 0, 0, 0, 0, 261, 0, 0, 0, 0, 0, 0, 0, 263, 0, 0, 0, 0, 0, 0, 0, 262, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__ZL15variants_either=allocate([1,2,12,3,13,4,14,5,11,0,0,0] /* \01\02\0C\03\0D\04\0 */, "i8", ALLOC_STATIC);
__ZL13variants_male=allocate([1,2,3,4,5,0,0,0,0,0,0,0] /* \01\02\03\04\05\00\0 */, "i8", ALLOC_STATIC);
__ZL15variants_female=allocate([11,12,13,14,0,0,0,0,0,0,0,0] /* \0B\0C\0D\0E\00\00\0 */, "i8", ALLOC_STATIC);
_variant_lists=allocate(12, "i8*", ALLOC_STATIC);
__ZL9voicedata=allocate(1344, ["i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8"], ALLOC_STATIC);
_voice=allocate(1, "%struct.voice_t*", ALLOC_STATIC);
__str44696=allocate([37,100,32,37,100,32,37,100,32,37,100,32,37,100,32,37,100,32,37,100,32,37,100,32,37,100,32,37,100,0] /* %d %d %d %d %d %d %d */, "i8", ALLOC_STATIC);
__ZZ10VoiceResetiE15default_heights=allocate([128,128,120,120,110,110,128,128,128] /* \80\80xxnn\80\80\80 */, "i8", ALLOC_STATIC);
__ZZ10VoiceResetiE14default_widths=allocate([128,128,128,160,171,171,128,128,128] /* \80\80\80\A0\AB\AB\8 */, "i8", ALLOC_STATIC);
__ZZ10VoiceResetiE13breath_widths=allocate([0, 0, 0, 0, 200, 0, 0, 0, 200, 0, 0, 0, 400, 0, 0, 0, 400, 0, 0, 0, 400, 0, 0, 0, 600, 0, 0, 0, 600, 0, 0, 0, 600, 0, 0, 0], ["i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__ZL18formant_rate_22050=allocate([240, 0, 0, 0, 170, 0, 0, 0, 170, 0, 0, 0, 170, 0, 0, 0, 170, 0, 0, 0, 170, 0, 0, 0, 170, 0, 0, 0, 170, 0, 0, 0, 170, 0, 0, 0], ["i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__ZZ9LoadVoicePKciE16voice_identifier=allocate(40, "i8", ALLOC_STATIC);
__ZZ9LoadVoicePKciE10voice_name=allocate(40, "i8", ALLOC_STATIC);
__ZZ9LoadVoicePKciE15voice_languages=allocate(100, "i8", ALLOC_STATIC);
__str45697=allocate([100,101,102,97,117,108,116,0] /* default\00 */, "i8", ALLOC_STATIC);
__str46698=allocate([37,115,37,99,118,111,105,99,101,115,37,99,0] /* %s%cvoices%c\00 */, "i8", ALLOC_STATIC);
__str47699=allocate([37,115,37,115,0] /* %s%s\00 */, "i8", ALLOC_STATIC);
__str48700=allocate([37,115,37,115,37,99,37,115,0] /* %s%s%c%s\00 */, "i8", ALLOC_STATIC);
__str49701=allocate([37,115,101,120,116,114,97,37,99,37,115,0] /* %sextra%c%s\00 */, "i8", ALLOC_STATIC);
__str50702=allocate([37,115,116,101,115,116,37,99,37,115,0] /* %stest%c%s\00 */, "i8", ALLOC_STATIC);
__str51703=allocate([114,0] /* r\00 */, "i8", ALLOC_STATIC);
__str52704=allocate([101,110,0] /* en\00 */, "i8", ALLOC_STATIC);
__str53705=allocate([43,37,115,0] /* +%s\00 */, "i8", ALLOC_STATIC);
__str54706=allocate([37,115,32,37,100,0] /* %s %d\00 */, "i8", ALLOC_STATIC);
__str55707=allocate([118,97,114,105,97,110,116,0] /* variant\00 */, "i8", ALLOC_STATIC);
__str56708=allocate([45,0] /* -\00 */, "i8", ALLOC_STATIC);
__str57709=allocate([37,115,0] /* %s\00 */, "i8", ALLOC_STATIC);
__str58710=allocate([37,100,32,37,100,0] /* %d %d\00 */, "i8", ALLOC_STATIC);
__str59711=allocate([37,115,32,37,115,32,37,115,32,37,115,32,37,115,32,37,115,0] /* %s %s %s %s %s %s\00 */, "i8", ALLOC_STATIC);
__str60712=allocate([78,85,76,76,0] /* NULL\00 */, "i8", ALLOC_STATIC);
__str61713=allocate([85,110,107,110,111,119,110,32,116,117,110,101,32,39,37,115,39,10,0] /* Unknown tune '%s'\0A */, "i8", ALLOC_STATIC);
__str62714=allocate([37,100,32,37,100,32,37,100,32,37,100,0] /* %d %d %d %d\00 */, "i8", ALLOC_STATIC);
__str63715=allocate([37,100,0] /* %d\00 */, "i8", ALLOC_STATIC);
__str64716=allocate([37,115,32,37,100,32,37,100,0] /* %s %d %d\00 */, "i8", ALLOC_STATIC);
__str65717=allocate([66,97,100,32,118,111,105,99,101,32,111,112,116,105,111,110,58,32,37,115,32,37,115,10,0] /* Bad voice option: %s */, "i8", ALLOC_STATIC);
__str66718=allocate([37,115,32,37,115,32,37,100,0] /* %s %s %d\00 */, "i8", ALLOC_STATIC);
__str67719=allocate([109,98,114,111,108,97,32,118,111,105,99,101,32,110,111,116,32,102,111,117,110,100,10,0] /* mbrola voice not fou */, "i8", ALLOC_STATIC);
__str68720=allocate([66,97,100,32,118,111,105,99,101,32,97,116,116,114,105,98,117,116,101,58,32,37,115,10,0] /* Bad voice attribute: */, "i8", ALLOC_STATIC);
__str69721=allocate([85,110,107,110,111,119,110,32,112,104,111,110,101,109,101,32,116,97,98,108,101,58,32,39,37,115,39,10,0] /* Unknown phoneme tabl */, "i8", ALLOC_STATIC);
__ZL13n_voices_list=allocate(1, "i32", ALLOC_STATIC);
__ZL11voices_list=allocate(600, "%struct.espeak_VOICE*", ALLOC_STATIC);
__str70722=allocate([37,99,37,115,0] /* %c%s\00 */, "i8", ALLOC_STATIC);
__ZZ11SelectVoiceP12espeak_VOICEPiE14voice_variants=allocate(288, ["i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8","i8","i8","i8","i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8","i8","i8","i8","i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8","i8","i8","i8","i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8","i8","i8","i8","i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8","i8","i8","i8","i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8","i8","i8","i8","i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8","i8","i8","i8","i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8","i8","i8","i8","i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8","i8","i8","i8","i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8","i8","i8","i8","i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8","i8","i8","i8","i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8","i8","i8","i8","i32",0,0,0,"i8*",0,0,0], ALLOC_STATIC);
__ZZ11SelectVoiceP12espeak_VOICEPiE8voice_id=allocate(50, "i8", ALLOC_STATIC);
__ZZ11SelectVoiceP12espeak_VOICEPiE3buf=allocate(60, "i8", ALLOC_STATIC);
__str71723=allocate([37,115,43,37,115,0] /* %s+%s\00 */, "i8", ALLOC_STATIC);
__ZZ14SetVoiceByNamePKcE3buf=allocate(60, "i8", ALLOC_STATIC);
__ZZ17espeak_ListVoicesE6voices=allocate(600, "%struct.espeak_VOICE*", ALLOC_STATIC);
__str72724=allocate([37,115,37,99,118,111,105,99,101,115,0] /* %s%cvoices\00 */, "i8", ALLOC_STATIC);
__ZL15len_path_voices=allocate(1, "i32", ALLOC_STATIC);
__str73725=allocate([109,98,47,0] /* mb/\00 */, "i8", ALLOC_STATIC);
__str74726=allocate([37,115,37,99,37,115,0] /* %s%c%s\00 */, "i8", ALLOC_STATIC);
__str75727=allocate([118,97,114,105,97,110,116,115,0] /* variants\00 */, "i8", ALLOC_STATIC);
__ZZL23ExtractVoiceVariantNamePciE12variant_name=allocate(20, "i8", ALLOC_STATIC);
__str76728=allocate([33,118,37,99,0] /* !v%c\00 */, "i8", ALLOC_STATIC);
__str77729=allocate([37,115,109,37,100,0] /* %sm%d\00 */, "i8", ALLOC_STATIC);
__str78730=allocate([37,115,102,37,100,0] /* %sf%d\00 */, "i8", ALLOC_STATIC);
__str79731=allocate([37,100,32,37,115,32,37,115,0] /* %d %s %s\00 */, "i8", ALLOC_STATIC);
__str80732=allocate([37,100,32,37,100,32,37,100,32,37,100,32,37,100,32,37,100,32,37,100,32,37,100,0] /* %d %d %d %d %d %d %d */, "i8", ALLOC_STATIC);
__str81733=allocate([37,100,32,37,100,32,37,100,32,37,100,32,37,100,0] /* %d %d %d %d %d\00 */, "i8", ALLOC_STATIC);
__str82734=allocate([47,47,0] /* //\00 */, "i8", ALLOC_STATIC);
_sin_tab=allocate([0, 0, -25, 0, -50, 0, -75, 0, -100, 0, -125, 0, -150, 0, -175, 0, -201, 0, -226, 0, -251, 0, -276, 0, -301, 0, -326, 0, -351, 0, -376, 0, -401, 0, -427, 0, -452, 0, -477, 0, -502, 0, -527, 0, -552, 0, -577, 0, -602, 0, -627, 0, -652, 0, -677, 0, -702, 0, -727, 0, -752, 0, -777, 0, -802, 0, -827, 0, -852, 0, -877, 0, -902, 0, -927, 0, -952, 0, -977, 0, -1002, 0, -1027, 0, -1052, 0, -1077, 0, -1102, 0, -1127, 0, -1152, 0, -1177, 0, -1201, 0, -1226, 0, -1251, 0, -1276, 0, -1301, 0, -1326, 0, -1350, 0, -1375, 0, -1400, 0, -1425, 0, -1449, 0, -1474, 0, -1499, 0, -1523, 0, -1548, 0, -1573, 0, -1597, 0, -1622, 0, -1647, 0, -1671, 0, -1696, 0, -1721, 0, -1745, 0, -1770, 0, -1794, 0, -1819, 0, -1843, 0, -1868, 0, -1892, 0, -1917, 0, -1941, 0, -1965, 0, -1990, 0, -2014, 0, -2038, 0, -2063, 0, -2087, 0, -2111, 0, -2136, 0, -2160, 0, -2184, 0, -2208, 0, -2233, 0, -2257, 0, -2281, 0, -2305, 0, -2329, 0, -2353, 0, -2377, 0, -2401, 0, -2425, 0, -2449, 0, -2473, 0, -2497, 0, -2521, 0, -2545, 0, -2569, 0, -2593, 0, -2617, 0, -2640, 0, -2664, 0, -2688, 0, -2712, 0, -2735, 0, -2759, 0, -2783, 0, -2806, 0, -2830, 0, -2853, 0, -2877, 0, -2900, 0, -2924, 0, -2947, 0, -2971, 0, -2994, 0, -3018, 0, -3041, 0, -3064, 0, -3088, 0, -3111, 0, -3134, 0, -3157, 0, -3180, 0, -3204, 0, -3227, 0, -3250, 0, -3273, 0, -3296, 0, -3319, 0, -3342, 0, -3365, 0, -3388, 0, -3410, 0, -3433, 0, -3456, 0, -3479, 0, -3502, 0, -3524, 0, -3547, 0, -3570, 0, -3592, 0, -3615, 0, -3637, 0, -3660, 0, -3682, 0, -3705, 0, -3727, 0, -3749, 0, -3772, 0, -3794, 0, -3816, 0, -3839, 0, -3861, 0, -3883, 0, -3905, 0, -3927, 0, -3949, 0, -3971, 0, -3993, 0, -4015, 0, -4037, 0, -4059, 0, -4080, 0, -4102, 0, -4124, 0, -4146, 0, -4167, 0, -4189, 0, -4211, 0, -4232, 0, -4254, 0, -4275, 0, -4296, 0, -4318, 0, -4339, 0, -4360, 0, -4382, 0, -4403, 0, -4424, 0, -4445, 0, -4466, 0, -4487, 0, -4508, 0, -4529, 0, -4550, 0, -4571, 0, -4592, 0, -4613, 0, -4633, 0, -4654, 0, -4675, 0, -4695, 0, -4716, 0, -4736, 0, -4757, 0, -4777, 0, -4798, 0, -4818, 0, -4838, 0, -4859, 0, -4879, 0, -4899, 0, -4919, 0, -4939, 0, -4959, 0, -4979, 0, -4999, 0, -5019, 0, -5039, 0, -5059, 0, -5078, 0, -5098, 0, -5118, 0, -5137, 0, -5157, 0, -5176, 0, -5196, 0, -5215, 0, -5235, 0, -5254, 0, -5273, 0, -5292, 0, -5311, 0, -5331, 0, -5350, 0, -5369, 0, -5388, 0, -5406, 0, -5425, 0, -5444, 0, -5463, 0, -5482, 0, -5500, 0, -5519, 0, -5537, 0, -5556, 0, -5574, 0, -5593, 0, -5611, 0, -5629, 0, -5648, 0, -5666, 0, -5684, 0, -5702, 0, -5720, 0, -5738, 0, -5756, 0, -5774, 0, -5791, 0, -5809, 0, -5827, 0, -5844, 0, -5862, 0, -5880, 0, -5897, 0, -5914, 0, -5932, 0, -5949, 0, -5966, 0, -5984, 0, -6001, 0, -6018, 0, -6035, 0, -6052, 0, -6069, 0, -6085, 0, -6102, 0, -6119, 0, -6136, 0, -6152, 0, -6169, 0, -6185, 0, -6202, 0, -6218, 0, -6235, 0, -6251, 0, -6267, 0, -6283, 0, -6299, 0, -6315, 0, -6331, 0, -6347, 0, -6363, 0, -6379, 0, -6395, 0, -6410, 0, -6426, 0, -6441, 0, -6457, 0, -6472, 0, -6488, 0, -6503, 0, -6518, 0, -6533, 0, -6549, 0, -6564, 0, -6579, 0, -6594, 0, -6608, 0, -6623, 0, -6638, 0, -6653, 0, -6667, 0, -6682, 0, -6696, 0, -6711, 0, -6725, 0, -6739, 0, -6754, 0, -6768, 0, -6782, 0, -6796, 0, -6810, 0, -6824, 0, -6838, 0, -6852, 0, -6865, 0, -6879, 0, -6893, 0, -6906, 0, -6920, 0, -6933, 0, -6946, 0, -6960, 0, -6973, 0, -6986, 0, -6999, 0, -7012, 0, -7025, 0, -7038, 0, -7051, 0, -7064, 0, -7076, 0, -7089, 0, -7101, 0, -7114, 0, -7126, 0, -7139, 0, -7151, 0, -7163, 0, -7175, 0, -7187, 0, -7199, 0, -7211, 0, -7223, 0, -7235, 0, -7247, 0, -7259, 0, -7270, 0, -7282, 0, -7293, 0, -7305, 0, -7316, 0, -7327, 0, -7338, 0, -7349, 0, -7361, 0, -7372, 0, -7382, 0, -7393, 0, -7404, 0, -7415, 0, -7425, 0, -7436, 0, -7446, 0, -7457, 0, -7467, 0, -7478, 0, -7488, 0, -7498, 0, -7508, 0, -7518, 0, -7528, 0, -7538, 0, -7548, 0, -7557, 0, -7567, 0, -7577, 0, -7586, 0, -7596, 0, -7605, 0, -7614, 0, -7623, 0, -7633, 0, -7642, 0, -7651, 0, -7660, 0, -7668, 0, -7677, 0, -7686, 0, -7695, 0, -7703, 0, -7712, 0, -7720, 0, -7728, 0, -7737, 0, -7745, 0, -7753, 0, -7761, 0, -7769, 0, -7777, 0, -7785, 0, -7793, 0, -7800, 0, -7808, 0, -7816, 0, -7823, 0, -7830, 0, -7838, 0, -7845, 0, -7852, 0, -7859, 0, -7866, 0, -7873, 0, -7880, 0, -7887, 0, -7894, 0, -7900, 0, -7907, 0, -7914, 0, -7920, 0, -7926, 0, -7933, 0, -7939, 0, -7945, 0, -7951, 0, -7957, 0, -7963, 0, -7969, 0, -7975, 0, -7980, 0, -7986, 0, -7991, 0, -7997, 0, -8002, 0, -8008, 0, -8013, 0, -8018, 0, -8023, 0, -8028, 0, -8033, 0, -8038, 0, -8043, 0, -8047, 0, -8052, 0, -8057, 0, -8061, 0, -8066, 0, -8070, 0, -8074, 0, -8078, 0, -8082, 0, -8086, 0, -8090, 0, -8094, 0, -8098, 0, -8102, 0, -8105, 0, -8109, 0, -8113, 0, -8116, 0, -8119, 0, -8123, 0, -8126, 0, -8129, 0, -8132, 0, -8135, 0, -8138, 0, -8141, 0, -8143, 0, -8146, 0, -8149, 0, -8151, 0, -8153, 0, -8156, 0, -8158, 0, -8160, 0, -8162, 0, -8164, 0, -8166, 0, -8168, 0, -8170, 0, -8172, 0, -8174, 0, -8175, 0, -8177, 0, -8178, 0, -8179, 0, -8181, 0, -8182, 0, -8183, 0, -8184, 0, -8185, 0, -8186, 0, -8187, 0, -8187, 0, -8188, 0, -8189, 0, -8189, 0, -8190, 0, -8190, 0, -8190, 0, -8190, 0, -8190, 0, -8191, 0, -8190, 0, -8190, 0, -8190, 0, -8190, 0, -8190, 0, -8189, 0, -8189, 0, -8188, 0, -8187, 0, -8187, 0, -8186, 0, -8185, 0, -8184, 0, -8183, 0, -8182, 0, -8181, 0, -8179, 0, -8178, 0, -8177, 0, -8175, 0, -8174, 0, -8172, 0, -8170, 0, -8168, 0, -8166, 0, -8164, 0, -8162, 0, -8160, 0, -8158, 0, -8156, 0, -8153, 0, -8151, 0, -8149, 0, -8146, 0, -8143, 0, -8141, 0, -8138, 0, -8135, 0, -8132, 0, -8129, 0, -8126, 0, -8123, 0, -8119, 0, -8116, 0, -8113, 0, -8109, 0, -8105, 0, -8102, 0, -8098, 0, -8094, 0, -8090, 0, -8086, 0, -8082, 0, -8078, 0, -8074, 0, -8070, 0, -8066, 0, -8061, 0, -8057, 0, -8052, 0, -8047, 0, -8043, 0, -8038, 0, -8033, 0, -8028, 0, -8023, 0, -8018, 0, -8013, 0, -8008, 0, -8002, 0, -7997, 0, -7991, 0, -7986, 0, -7980, 0, -7975, 0, -7969, 0, -7963, 0, -7957, 0, -7951, 0, -7945, 0, -7939, 0, -7933, 0, -7926, 0, -7920, 0, -7914, 0, -7907, 0, -7900, 0, -7894, 0, -7887, 0, -7880, 0, -7873, 0, -7866, 0, -7859, 0, -7852, 0, -7845, 0, -7838, 0, -7830, 0, -7823, 0, -7816, 0, -7808, 0, -7800, 0, -7793, 0, -7785, 0, -7777, 0, -7769, 0, -7761, 0, -7753, 0, -7745, 0, -7737, 0, -7728, 0, -7720, 0, -7712, 0, -7703, 0, -7695, 0, -7686, 0, -7677, 0, -7668, 0, -7660, 0, -7651, 0, -7642, 0, -7633, 0, -7623, 0, -7614, 0, -7605, 0, -7596, 0, -7586, 0, -7577, 0, -7567, 0, -7557, 0, -7548, 0, -7538, 0, -7528, 0, -7518, 0, -7508, 0, -7498, 0, -7488, 0, -7478, 0, -7467, 0, -7457, 0, -7446, 0, -7436, 0, -7425, 0, -7415, 0, -7404, 0, -7393, 0, -7382, 0, -7372, 0, -7361, 0, -7349, 0, -7338, 0, -7327, 0, -7316, 0, -7305, 0, -7293, 0, -7282, 0, -7270, 0, -7259, 0, -7247, 0, -7235, 0, -7223, 0, -7211, 0, -7199, 0, -7187, 0, -7175, 0, -7163, 0, -7151, 0, -7139, 0, -7126, 0, -7114, 0, -7101, 0, -7089, 0, -7076, 0, -7064, 0, -7051, 0, -7038, 0, -7025, 0, -7012, 0, -6999, 0, -6986, 0, -6973, 0, -6960, 0, -6946, 0, -6933, 0, -6920, 0, -6906, 0, -6893, 0, -6879, 0, -6865, 0, -6852, 0, -6838, 0, -6824, 0, -6810, 0, -6796, 0, -6782, 0, -6768, 0, -6754, 0, -6739, 0, -6725, 0, -6711, 0, -6696, 0, -6682, 0, -6667, 0, -6653, 0, -6638, 0, -6623, 0, -6608, 0, -6594, 0, -6579, 0, -6564, 0, -6549, 0, -6533, 0, -6518, 0, -6503, 0, -6488, 0, -6472, 0, -6457, 0, -6441, 0, -6426, 0, -6410, 0, -6395, 0, -6379, 0, -6363, 0, -6347, 0, -6331, 0, -6315, 0, -6299, 0, -6283, 0, -6267, 0, -6251, 0, -6235, 0, -6218, 0, -6202, 0, -6185, 0, -6169, 0, -6152, 0, -6136, 0, -6119, 0, -6102, 0, -6085, 0, -6069, 0, -6052, 0, -6035, 0, -6018, 0, -6001, 0, -5984, 0, -5966, 0, -5949, 0, -5932, 0, -5914, 0, -5897, 0, -5880, 0, -5862, 0, -5844, 0, -5827, 0, -5809, 0, -5791, 0, -5774, 0, -5756, 0, -5738, 0, -5720, 0, -5702, 0, -5684, 0, -5666, 0, -5648, 0, -5629, 0, -5611, 0, -5593, 0, -5574, 0, -5556, 0, -5537, 0, -5519, 0, -5500, 0, -5482, 0, -5463, 0, -5444, 0, -5425, 0, -5406, 0, -5388, 0, -5369, 0, -5350, 0, -5331, 0, -5311, 0, -5292, 0, -5273, 0, -5254, 0, -5235, 0, -5215, 0, -5196, 0, -5176, 0, -5157, 0, -5137, 0, -5118, 0, -5098, 0, -5078, 0, -5059, 0, -5039, 0, -5019, 0, -4999, 0, -4979, 0, -4959, 0, -4939, 0, -4919, 0, -4899, 0, -4879, 0, -4859, 0, -4838, 0, -4818, 0, -4798, 0, -4777, 0, -4757, 0, -4736, 0, -4716, 0, -4695, 0, -4675, 0, -4654, 0, -4633, 0, -4613, 0, -4592, 0, -4571, 0, -4550, 0, -4529, 0, -4508, 0, -4487, 0, -4466, 0, -4445, 0, -4424, 0, -4403, 0, -4382, 0, -4360, 0, -4339, 0, -4318, 0, -4296, 0, -4275, 0, -4254, 0, -4232, 0, -4211, 0, -4189, 0, -4167, 0, -4146, 0, -4124, 0, -4102, 0, -4080, 0, -4059, 0, -4037, 0, -4015, 0, -3993, 0, -3971, 0, -3949, 0, -3927, 0, -3905, 0, -3883, 0, -3861, 0, -3839, 0, -3816, 0, -3794, 0, -3772, 0, -3749, 0, -3727, 0, -3705, 0, -3682, 0, -3660, 0, -3637, 0, -3615, 0, -3592, 0, -3570, 0, -3547, 0, -3524, 0, -3502, 0, -3479, 0, -3456, 0, -3433, 0, -3410, 0, -3388, 0, -3365, 0, -3342, 0, -3319, 0, -3296, 0, -3273, 0, -3250, 0, -3227, 0, -3204, 0, -3180, 0, -3157, 0, -3134, 0, -3111, 0, -3088, 0, -3064, 0, -3041, 0, -3018, 0, -2994, 0, -2971, 0, -2947, 0, -2924, 0, -2900, 0, -2877, 0, -2853, 0, -2830, 0, -2806, 0, -2783, 0, -2759, 0, -2735, 0, -2712, 0, -2688, 0, -2664, 0, -2640, 0, -2617, 0, -2593, 0, -2569, 0, -2545, 0, -2521, 0, -2497, 0, -2473, 0, -2449, 0, -2425, 0, -2401, 0, -2377, 0, -2353, 0, -2329, 0, -2305, 0, -2281, 0, -2257, 0, -2233, 0, -2208, 0, -2184, 0, -2160, 0, -2136, 0, -2111, 0, -2087, 0, -2063, 0, -2038, 0, -2014, 0, -1990, 0, -1965, 0, -1941, 0, -1917, 0, -1892, 0, -1868, 0, -1843, 0, -1819, 0, -1794, 0, -1770, 0, -1745, 0, -1721, 0, -1696, 0, -1671, 0, -1647, 0, -1622, 0, -1597, 0, -1573, 0, -1548, 0, -1523, 0, -1499, 0, -1474, 0, -1449, 0, -1425, 0, -1400, 0, -1375, 0, -1350, 0, -1326, 0, -1301, 0, -1276, 0, -1251, 0, -1226, 0, -1201, 0, -1177, 0, -1152, 0, -1127, 0, -1102, 0, -1077, 0, -1052, 0, -1027, 0, -1002, 0, -977, 0, -952, 0, -927, 0, -902, 0, -877, 0, -852, 0, -827, 0, -802, 0, -777, 0, -752, 0, -727, 0, -702, 0, -677, 0, -652, 0, -627, 0, -602, 0, -577, 0, -552, 0, -527, 0, -502, 0, -477, 0, -452, 0, -427, 0, -401, 0, -376, 0, -351, 0, -326, 0, -301, 0, -276, 0, -251, 0, -226, 0, -201, 0, -175, 0, -150, 0, -125, 0, -100, 0, -75, 0, -50, 0, -25, 0, 0, 0, 25, 0, 50, 0, 75, 0, 100, 0, 125, 0, 150, 0, 175, 0, 201, 0, 226, 0, 251, 0, 276, 0, 301, 0, 326, 0, 351, 0, 376, 0, 401, 0, 427, 0, 452, 0, 477, 0, 502, 0, 527, 0, 552, 0, 577, 0, 602, 0, 627, 0, 652, 0, 677, 0, 702, 0, 727, 0, 752, 0, 777, 0, 802, 0, 827, 0, 852, 0, 877, 0, 902, 0, 927, 0, 952, 0, 977, 0, 1002, 0, 1027, 0, 1052, 0, 1077, 0, 1102, 0, 1127, 0, 1152, 0, 1177, 0, 1201, 0, 1226, 0, 1251, 0, 1276, 0, 1301, 0, 1326, 0, 1350, 0, 1375, 0, 1400, 0, 1425, 0, 1449, 0, 1474, 0, 1499, 0, 1523, 0, 1548, 0, 1573, 0, 1597, 0, 1622, 0, 1647, 0, 1671, 0, 1696, 0, 1721, 0, 1745, 0, 1770, 0, 1794, 0, 1819, 0, 1843, 0, 1868, 0, 1892, 0, 1917, 0, 1941, 0, 1965, 0, 1990, 0, 2014, 0, 2038, 0, 2063, 0, 2087, 0, 2111, 0, 2136, 0, 2160, 0, 2184, 0, 2208, 0, 2233, 0, 2257, 0, 2281, 0, 2305, 0, 2329, 0, 2353, 0, 2377, 0, 2401, 0, 2425, 0, 2449, 0, 2473, 0, 2497, 0, 2521, 0, 2545, 0, 2569, 0, 2593, 0, 2617, 0, 2640, 0, 2664, 0, 2688, 0, 2712, 0, 2735, 0, 2759, 0, 2783, 0, 2806, 0, 2830, 0, 2853, 0, 2877, 0, 2900, 0, 2924, 0, 2947, 0, 2971, 0, 2994, 0, 3018, 0, 3041, 0, 3064, 0, 3088, 0, 3111, 0, 3134, 0, 3157, 0, 3180, 0, 3204, 0, 3227, 0, 3250, 0, 3273, 0, 3296, 0, 3319, 0, 3342, 0, 3365, 0, 3388, 0, 3410, 0, 3433, 0, 3456, 0, 3479, 0, 3502, 0, 3524, 0, 3547, 0, 3570, 0, 3592, 0, 3615, 0, 3637, 0, 3660, 0, 3682, 0, 3705, 0, 3727, 0, 3749, 0, 3772, 0, 3794, 0, 3816, 0, 3839, 0, 3861, 0, 3883, 0, 3905, 0, 3927, 0, 3949, 0, 3971, 0, 3993, 0, 4015, 0, 4037, 0, 4059, 0, 4080, 0, 4102, 0, 4124, 0, 4146, 0, 4167, 0, 4189, 0, 4211, 0, 4232, 0, 4254, 0, 4275, 0, 4296, 0, 4318, 0, 4339, 0, 4360, 0, 4382, 0, 4403, 0, 4424, 0, 4445, 0, 4466, 0, 4487, 0, 4508, 0, 4529, 0, 4550, 0, 4571, 0, 4592, 0, 4613, 0, 4633, 0, 4654, 0, 4675, 0, 4695, 0, 4716, 0, 4736, 0, 4757, 0, 4777, 0, 4798, 0, 4818, 0, 4838, 0, 4859, 0, 4879, 0, 4899, 0, 4919, 0, 4939, 0, 4959, 0, 4979, 0, 4999, 0, 5019, 0, 5039, 0, 5059, 0, 5078, 0, 5098, 0, 5118, 0, 5137, 0, 5157, 0, 5176, 0, 5196, 0, 5215, 0, 5235, 0, 5254, 0, 5273, 0, 5292, 0, 5311, 0, 5331, 0, 5350, 0, 5369, 0, 5388, 0, 5406, 0, 5425, 0, 5444, 0, 5463, 0, 5482, 0, 5500, 0, 5519, 0, 5537, 0, 5556, 0, 5574, 0, 5593, 0, 5611, 0, 5629, 0, 5648, 0, 5666, 0, 5684, 0, 5702, 0, 5720, 0, 5738, 0, 5756, 0, 5774, 0, 5791, 0, 5809, 0, 5827, 0, 5844, 0, 5862, 0, 5880, 0, 5897, 0, 5914, 0, 5932, 0, 5949, 0, 5966, 0, 5984, 0, 6001, 0, 6018, 0, 6035, 0, 6052, 0, 6069, 0, 6085, 0, 6102, 0, 6119, 0, 6136, 0, 6152, 0, 6169, 0, 6185, 0, 6202, 0, 6218, 0, 6235, 0, 6251, 0, 6267, 0, 6283, 0, 6299, 0, 6315, 0, 6331, 0, 6347, 0, 6363, 0, 6379, 0, 6395, 0, 6410, 0, 6426, 0, 6441, 0, 6457, 0, 6472, 0, 6488, 0, 6503, 0, 6518, 0, 6533, 0, 6549, 0, 6564, 0, 6579, 0, 6594, 0, 6608, 0, 6623, 0, 6638, 0, 6653, 0, 6667, 0, 6682, 0, 6696, 0, 6711, 0, 6725, 0, 6739, 0, 6754, 0, 6768, 0, 6782, 0, 6796, 0, 6810, 0, 6824, 0, 6838, 0, 6852, 0, 6865, 0, 6879, 0, 6893, 0, 6906, 0, 6920, 0, 6933, 0, 6946, 0, 6960, 0, 6973, 0, 6986, 0, 6999, 0, 7012, 0, 7025, 0, 7038, 0, 7051, 0, 7064, 0, 7076, 0, 7089, 0, 7101, 0, 7114, 0, 7126, 0, 7139, 0, 7151, 0, 7163, 0, 7175, 0, 7187, 0, 7199, 0, 7211, 0, 7223, 0, 7235, 0, 7247, 0, 7259, 0, 7270, 0, 7282, 0, 7293, 0, 7305, 0, 7316, 0, 7327, 0, 7338, 0, 7349, 0, 7361, 0, 7372, 0, 7382, 0, 7393, 0, 7404, 0, 7415, 0, 7425, 0, 7436, 0, 7446, 0, 7457, 0, 7467, 0, 7478, 0, 7488, 0, 7498, 0, 7508, 0, 7518, 0, 7528, 0, 7538, 0, 7548, 0, 7557, 0, 7567, 0, 7577, 0, 7586, 0, 7596, 0, 7605, 0, 7614, 0, 7623, 0, 7633, 0, 7642, 0, 7651, 0, 7660, 0, 7668, 0, 7677, 0, 7686, 0, 7695, 0, 7703, 0, 7712, 0, 7720, 0, 7728, 0, 7737, 0, 7745, 0, 7753, 0, 7761, 0, 7769, 0, 7777, 0, 7785, 0, 7793, 0, 7800, 0, 7808, 0, 7816, 0, 7823, 0, 7830, 0, 7838, 0, 7845, 0, 7852, 0, 7859, 0, 7866, 0, 7873, 0, 7880, 0, 7887, 0, 7894, 0, 7900, 0, 7907, 0, 7914, 0, 7920, 0, 7926, 0, 7933, 0, 7939, 0, 7945, 0, 7951, 0, 7957, 0, 7963, 0, 7969, 0, 7975, 0, 7980, 0, 7986, 0, 7991, 0, 7997, 0, 8002, 0, 8008, 0, 8013, 0, 8018, 0, 8023, 0, 8028, 0, 8033, 0, 8038, 0, 8043, 0, 8047, 0, 8052, 0, 8057, 0, 8061, 0, 8066, 0, 8070, 0, 8074, 0, 8078, 0, 8082, 0, 8086, 0, 8090, 0, 8094, 0, 8098, 0, 8102, 0, 8105, 0, 8109, 0, 8113, 0, 8116, 0, 8119, 0, 8123, 0, 8126, 0, 8129, 0, 8132, 0, 8135, 0, 8138, 0, 8141, 0, 8143, 0, 8146, 0, 8149, 0, 8151, 0, 8153, 0, 8156, 0, 8158, 0, 8160, 0, 8162, 0, 8164, 0, 8166, 0, 8168, 0, 8170, 0, 8172, 0, 8174, 0, 8175, 0, 8177, 0, 8178, 0, 8179, 0, 8181, 0, 8182, 0, 8183, 0, 8184, 0, 8185, 0, 8186, 0, 8187, 0, 8187, 0, 8188, 0, 8189, 0, 8189, 0, 8190, 0, 8190, 0, 8190, 0, 8190, 0, 8190, 0, 8191, 0, 8190, 0, 8190, 0, 8190, 0, 8190, 0, 8190, 0, 8189, 0, 8189, 0, 8188, 0, 8187, 0, 8187, 0, 8186, 0, 8185, 0, 8184, 0, 8183, 0, 8182, 0, 8181, 0, 8179, 0, 8178, 0, 8177, 0, 8175, 0, 8174, 0, 8172, 0, 8170, 0, 8168, 0, 8166, 0, 8164, 0, 8162, 0, 8160, 0, 8158, 0, 8156, 0, 8153, 0, 8151, 0, 8149, 0, 8146, 0, 8143, 0, 8141, 0, 8138, 0, 8135, 0, 8132, 0, 8129, 0, 8126, 0, 8123, 0, 8119, 0, 8116, 0, 8113, 0, 8109, 0, 8105, 0, 8102, 0, 8098, 0, 8094, 0, 8090, 0, 8086, 0, 8082, 0, 8078, 0, 8074, 0, 8070, 0, 8066, 0, 8061, 0, 8057, 0, 8052, 0, 8047, 0, 8043, 0, 8038, 0, 8033, 0, 8028, 0, 8023, 0, 8018, 0, 8013, 0, 8008, 0, 8002, 0, 7997, 0, 7991, 0, 7986, 0, 7980, 0, 7975, 0, 7969, 0, 7963, 0, 7957, 0, 7951, 0, 7945, 0, 7939, 0, 7933, 0, 7926, 0, 7920, 0, 7914, 0, 7907, 0, 7900, 0, 7894, 0, 7887, 0, 7880, 0, 7873, 0, 7866, 0, 7859, 0, 7852, 0, 7845, 0, 7838, 0, 7830, 0, 7823, 0, 7816, 0, 7808, 0, 7800, 0, 7793, 0, 7785, 0, 7777, 0, 7769, 0, 7761, 0, 7753, 0, 7745, 0, 7737, 0, 7728, 0, 7720, 0, 7712, 0, 7703, 0, 7695, 0, 7686, 0, 7677, 0, 7668, 0, 7660, 0, 7651, 0, 7642, 0, 7633, 0, 7623, 0, 7614, 0, 7605, 0, 7596, 0, 7586, 0, 7577, 0, 7567, 0, 7557, 0, 7548, 0, 7538, 0, 7528, 0, 7518, 0, 7508, 0, 7498, 0, 7488, 0, 7478, 0, 7467, 0, 7457, 0, 7446, 0, 7436, 0, 7425, 0, 7415, 0, 7404, 0, 7393, 0, 7382, 0, 7372, 0, 7361, 0, 7349, 0, 7338, 0, 7327, 0, 7316, 0, 7305, 0, 7293, 0, 7282, 0, 7270, 0, 7259, 0, 7247, 0, 7235, 0, 7223, 0, 7211, 0, 7199, 0, 7187, 0, 7175, 0, 7163, 0, 7151, 0, 7139, 0, 7126, 0, 7114, 0, 7101, 0, 7089, 0, 7076, 0, 7064, 0, 7051, 0, 7038, 0, 7025, 0, 7012, 0, 6999, 0, 6986, 0, 6973, 0, 6960, 0, 6946, 0, 6933, 0, 6920, 0, 6906, 0, 6893, 0, 6879, 0, 6865, 0, 6852, 0, 6838, 0, 6824, 0, 6810, 0, 6796, 0, 6782, 0, 6768, 0, 6754, 0, 6739, 0, 6725, 0, 6711, 0, 6696, 0, 6682, 0, 6667, 0, 6653, 0, 6638, 0, 6623, 0, 6608, 0, 6594, 0, 6579, 0, 6564, 0, 6549, 0, 6533, 0, 6518, 0, 6503, 0, 6488, 0, 6472, 0, 6457, 0, 6441, 0, 6426, 0, 6410, 0, 6395, 0, 6379, 0, 6363, 0, 6347, 0, 6331, 0, 6315, 0, 6299, 0, 6283, 0, 6267, 0, 6251, 0, 6235, 0, 6218, 0, 6202, 0, 6185, 0, 6169, 0, 6152, 0, 6136, 0, 6119, 0, 6102, 0, 6085, 0, 6069, 0, 6052, 0, 6035, 0, 6018, 0, 6001, 0, 5984, 0, 5966, 0, 5949, 0, 5932, 0, 5914, 0, 5897, 0, 5880, 0, 5862, 0, 5844, 0, 5827, 0, 5809, 0, 5791, 0, 5774, 0, 5756, 0, 5738, 0, 5720, 0, 5702, 0, 5684, 0, 5666, 0, 5648, 0, 5629, 0, 5611, 0, 5593, 0, 5574, 0, 5556, 0, 5537, 0, 5519, 0, 5500, 0, 5482, 0, 5463, 0, 5444, 0, 5425, 0, 5406, 0, 5388, 0, 5369, 0, 5350, 0, 5331, 0, 5311, 0, 5292, 0, 5273, 0, 5254, 0, 5235, 0, 5215, 0, 5196, 0, 5176, 0, 5157, 0, 5137, 0, 5118, 0, 5098, 0, 5078, 0, 5059, 0, 5039, 0, 5019, 0, 4999, 0, 4979, 0, 4959, 0, 4939, 0, 4919, 0, 4899, 0, 4879, 0, 4859, 0, 4838, 0, 4818, 0, 4798, 0, 4777, 0, 4757, 0, 4736, 0, 4716, 0, 4695, 0, 4675, 0, 4654, 0, 4633, 0, 4613, 0, 4592, 0, 4571, 0, 4550, 0, 4529, 0, 4508, 0, 4487, 0, 4466, 0, 4445, 0, 4424, 0, 4403, 0, 4382, 0, 4360, 0, 4339, 0, 4318, 0, 4296, 0, 4275, 0, 4254, 0, 4232, 0, 4211, 0, 4189, 0, 4167, 0, 4146, 0, 4124, 0, 4102, 0, 4080, 0, 4059, 0, 4037, 0, 4015, 0, 3993, 0, 3971, 0, 3949, 0, 3927, 0, 3905, 0, 3883, 0, 3861, 0, 3839, 0, 3816, 0, 3794, 0, 3772, 0, 3749, 0, 3727, 0, 3705, 0, 3682, 0, 3660, 0, 3637, 0, 3615, 0, 3592, 0, 3570, 0, 3547, 0, 3524, 0, 3502, 0, 3479, 0, 3456, 0, 3433, 0, 3410, 0, 3388, 0, 3365, 0, 3342, 0, 3319, 0, 3296, 0, 3273, 0, 3250, 0, 3227, 0, 3204, 0, 3180, 0, 3157, 0, 3134, 0, 3111, 0, 3088, 0, 3064, 0, 3041, 0, 3018, 0, 2994, 0, 2971, 0, 2947, 0, 2924, 0, 2900, 0, 2877, 0, 2853, 0, 2830, 0, 2806, 0, 2783, 0, 2759, 0, 2735, 0, 2712, 0, 2688, 0, 2664, 0, 2640, 0, 2617, 0, 2593, 0, 2569, 0, 2545, 0, 2521, 0, 2497, 0, 2473, 0, 2449, 0, 2425, 0, 2401, 0, 2377, 0, 2353, 0, 2329, 0, 2305, 0, 2281, 0, 2257, 0, 2233, 0, 2208, 0, 2184, 0, 2160, 0, 2136, 0, 2111, 0, 2087, 0, 2063, 0, 2038, 0, 2014, 0, 1990, 0, 1965, 0, 1941, 0, 1917, 0, 1892, 0, 1868, 0, 1843, 0, 1819, 0, 1794, 0, 1770, 0, 1745, 0, 1721, 0, 1696, 0, 1671, 0, 1647, 0, 1622, 0, 1597, 0, 1573, 0, 1548, 0, 1523, 0, 1499, 0, 1474, 0, 1449, 0, 1425, 0, 1400, 0, 1375, 0, 1350, 0, 1326, 0, 1301, 0, 1276, 0, 1251, 0, 1226, 0, 1201, 0, 1177, 0, 1152, 0, 1127, 0, 1102, 0, 1077, 0, 1052, 0, 1027, 0, 1002, 0, 977, 0, 952, 0, 927, 0, 902, 0, 877, 0, 852, 0, 827, 0, 802, 0, 777, 0, 752, 0, 727, 0, 702, 0, 677, 0, 652, 0, 627, 0, 602, 0, 577, 0, 552, 0, 527, 0, 502, 0, 477, 0, 452, 0, 427, 0, 401, 0, 376, 0, 351, 0, 326, 0, 301, 0, 276, 0, 251, 0, 226, 0, 201, 0, 175, 0, 150, 0, 125, 0, 100, 0, 75, 0, 50, 0, 25, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
_wvoice=allocate(1, "%struct.voice_t*", ALLOC_STATIC);
_f_log=allocate(1, "%struct.__sFILE*", ALLOC_STATIC);
_option_waveout=allocate(1, "i32", ALLOC_STATIC);
_option_log_frames=allocate(1, "i32", ALLOC_STATIC);
_embedded_value=allocate(60, "i32", ALLOC_STATIC);
_samplerate=allocate(1, "i32", ALLOC_STATIC);
_samplerate_native=allocate(1, "i32", ALLOC_STATIC);
__ZL5peaks=allocate(720, ["i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0], ALLOC_STATIC);
_echo_head=allocate(1, "i32", ALLOC_STATIC);
_echo_tail=allocate(1, "i32", ALLOC_STATIC);
_echo_amp=allocate(1, "i32", ALLOC_STATIC);
_echo_buf=allocate(11000, "i16", ALLOC_STATIC);
__ZL7rbreath=allocate(360, "double", ALLOC_STATIC);
_wdata=allocate(64, ["i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__ZL13amplitude_env=allocate(1, "i8*", ALLOC_STATIC);
_out_ptr=allocate(1, "i8*", ALLOC_STATIC);
_out_start=allocate(1, "i8*", ALLOC_STATIC);
_out_end=allocate(1, "i8*", ALLOC_STATIC);
_outbuf_size=allocate(1, "i32", ALLOC_STATIC);
_wcmdq=allocate(2560, "i32", ALLOC_STATIC);
_wcmdq_head=allocate(1, "i32", ALLOC_STATIC);
_wcmdq_tail=allocate(1, "i32", ALLOC_STATIC);
_embedded_default=allocate([0, 0, 0, 0, 50, 0, 0, 0, 175, 0, 0, 0, 100, 0, 0, 0, 50, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 175, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], ["i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0], ALLOC_STATIC);
_current_source_index=allocate(1, "i32", ALLOC_STATIC);
__ZL18sonicSpeedupStream=allocate(1, "%struct.sonicStreamStruct*", ALLOC_STATIC);
_sonicSpeed=allocate([1], ["double",0,0,0,0,0,0,0,0], ALLOC_STATIC);
_pitch_adjust_tab=allocate([64,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82,83,84,86,87,88,89,91,92,93,94,96,97,98,100,101,103,104,105,107,108,110,111,113,115,116,118,119,121,123,124,126,128,130,132,133,135,137,139,141,143,145,147,149,151,153,155,158,160,162,164,167,169,171,174,176,179,181,184,186,189,191,194,197,199,202,205,208,211,214,217,220,223,226,229,232,236,239,242,246,249,252,254,255] /* @ABCDEFGHIJKLMNOPQRS */, "i8", ALLOC_STATIC);
_pk_shape1=allocate([255,254,254,254,254,254,253,253,252,251,251,250,249,248,247,246,245,244,242,241,239,238,236,234,233,231,229,227,225,223,220,218,216,213,211,209,207,205,203,201,199,197,195,193,191,189,187,185,183,180,178,176,173,171,169,166,164,161,159,156,154,151,148,146,143,140,138,135,132,129,126,123,120,118,115,112,108,105,102,99,96,95,93,91,90,88,86,85,83,82,80,79,77,76,74,73,72,70,69,68,67,66,64,63,62,61,60,59,58,57,56,55,55,54,53,52,52,51,50,50,49,48,48,47,47,46,46,46,45,45,45,44,44,44,44,44,44,44,43,43,43,43,44,43,42,42,41,40,40,39,38,38,37,36,36,35,35,34,33,33,32,32,31,30,30,29,29,28,28,27,26,26,25,25,24,24,23,23,22,22,21,21,20,20,19,19,18,18,18,17,17,16,16,15,15,15,14,14,13,13,13,12,12,11,11,11,10,10,10,9,9,9,8,8,8,7,7,7,7,6,6,6,5,5,5,5,4,4,4,4,4,3,3,3,3,2,2,2,2,2,2,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0] /* \FF\FE\FE\FE\FE\FE\F */, "i8", ALLOC_STATIC);
__ZL16PHASE_INC_FACTOR=allocate(1, "i32", ALLOC_STATIC);
__ZL11Flutter_inc=allocate(1, "i32", ALLOC_STATIC);
__ZL11samplecount=allocate(1, "i32", ALLOC_STATIC);
__ZL8nsamples=allocate(1, "i32", ALLOC_STATIC);
__ZL9wavephase=allocate(1, "i32", ALLOC_STATIC);
__ZL12wavemult_max=allocate(1, "i32", ALLOC_STATIC);
__ZL15wavemult_offset=allocate(1, "i32", ALLOC_STATIC);
__ZL8wavemult=allocate([0,0,0,2,3,5,8,11,14,18,22,27,32,37,43,49,55,62,69,76,83,90,98,105,113,121,128,136,144,152,159,166,174,181,188,194,201,207,213,218,224,228,233,237,240,244,246,249,251,252,253,253,253,253,252,251,249,246,244,240,237,233,228,224,218,213,207,201,194,188,181,174,166,159,152,144,136,128,121,113,105,98,90,83,76,69,62,55,49,43,37,32,27,22,18,14,11,8,5,3,2,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0] /* \00\00\00\02\03\05\0 */, "i8", ALLOC_STATIC);
__ZL9pk_shape2=allocate([255,254,254,254,254,254,254,254,254,254,253,253,253,253,252,252,252,251,251,251,250,250,249,249,248,248,247,247,246,245,245,244,243,243,242,241,239,237,235,233,231,229,227,225,223,221,218,216,213,211,208,205,203,200,197,194,191,187,184,181,178,174,171,167,163,160,156,152,148,144,140,136,132,127,123,119,114,110,105,100,96,94,91,88,86,83,81,78,76,74,71,69,66,64,62,60,57,55,53,51,49,47,44,42,40,38,36,34,32,30,29,27,25,23,21,19,18,16,14,12,11,9,7,6,4,3,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0] /* \FF\FE\FE\FE\FE\FE\F */, "i8", ALLOC_STATIC);
__ZL8pk_shape=allocate(1, "i8*", ALLOC_STATIC);
__ZZ12GetAmplitudevE12amp_emphasis=allocate([16,16,10,16,22] /* \10\10\0A\10\16 */, "i8", ALLOC_STATIC);
__ZL17general_amplitude=allocate([60], ["i32",0,0,0,0], ALLOC_STATIC);
__ZL11peak_height=allocate(36, "i32", ALLOC_STATIC);
__ZL13peak_harmonic=allocate(36, "i32", ALLOC_STATIC);
__ZL16option_harmonic1_b=allocate(1, "i1", ALLOC_STATIC);
__ZL9harmspect=allocate(1, "i32*", ALLOC_STATIC);
__ZL8harm_inc=allocate(120, "i32", ALLOC_STATIC);
__ZL10minus_pi_t=allocate(1, "double", ALLOC_STATIC);
__ZL8two_pi_t=allocate(1, "double", ALLOC_STATIC);
__ZZ7WavegenvE4maxh=allocate(1, "i32", ALLOC_STATIC);
__ZZ7WavegenvE5maxh2=allocate(1, "i32", ALLOC_STATIC);
__ZZ7WavegenvE3agc=allocate([256], ["i32",0,0,0,0], ALLOC_STATIC);
__ZZ7WavegenvE13h_switch_sign=allocate(1, "i32", ALLOC_STATIC);
__ZZ7WavegenvE11cycle_count=allocate(1, "i32", ALLOC_STATIC);
__ZZ7WavegenvE10amplitude2=allocate(1, "i32", ALLOC_STATIC);
__ZL8end_wave_b=allocate(1, "i1", ALLOC_STATIC);
__ZL7hswitch=allocate(1, "i32", ALLOC_STATIC);
__ZL6hspect=allocate(3200, "i32", ALLOC_STATIC);
__ZL8phaseinc=allocate(1, "i32", ALLOC_STATIC);
__ZL13cycle_samples=allocate(1, "i32", ALLOC_STATIC);
__ZL9hf_factor=allocate(1, "i32", ALLOC_STATIC);
__ZL6cbytes=allocate(1, "i32", ALLOC_STATIC);
__ZL12glottal_flag=allocate(1, "i32", ALLOC_STATIC);
__ZL14glottal_reduce=allocate(1, "i32", ALLOC_STATIC);
__ZL6amp_ix=allocate(1, "i32", ALLOC_STATIC);
__ZL15modulation_type=allocate(1, "i32", ALLOC_STATIC);
__ZL14modulation_tab=allocate([0, 0, 0, 0, 0, 70, 242, 41, 0, 47, 0, 47, 0, 69, 242, 41, 0, 47, 0, 46, 0, 69, 242, 40, 0, 46, 0, 45, 0, 52, 242, 40, 0, 45, 45, 44, 0, 52, 242, 40, 0, 43, 43, 43, 0, 52, 242, 40, 0, 42, 42, 42, 0, 52, 242, 40, 0, 41, 41, 41, 0, 52, 242, 40], "i8", ALLOC_STATIC);
__ZL7voicing=allocate(1, "i32", ALLOC_STATIC);
__ZL12embedded_max=allocate([0, 0, 0, 0, 32767, 0, 0, 0, 750, 0, 0, 0, 300, 0, 0, 0, 99, 0, 0, 0, 99, 0, 0, 0, 99, 0, 0, 0, 0, 0, 0, 0, 750, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 0, 0, 0, 0, 0, 0, 0], ["i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__ZZ15WavegenSetVoiceP7voice_tE2v2=allocate(1344, ["i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8"], ALLOC_STATIC);
__ZL13consonant_amp=allocate([26], ["i32",0,0,0,0], ALLOC_STATIC);
__ZL11flutter_amp=allocate([64], ["i32",0,0,0,0], ALLOC_STATIC);
__ZZ8SetSynthiiP7frame_tS0_P7voice_tE19glottal_reduce_tab1=allocate([48, 0, 0, 0, 48, 0, 0, 0, 64, 0, 0, 0, 80, 0, 0, 0], ["i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__ZZ8SetSynthiiP7frame_tS0_P7voice_tE19glottal_reduce_tab2=allocate([144, 0, 0, 0, 160, 0, 0, 0, 176, 0, 0, 0, 192, 0, 0, 0], ["i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__ZL17samplecount_start=allocate(1, "i32", ALLOC_STATIC);
__ZZ12WavegenFill2iE6resume=allocate(1, "i32", ALLOC_STATIC);
__ZZ12WavegenFill2iE13echo_complete=allocate(1, "i32", ALLOC_STATIC);
__ZL11echo_length=allocate(1, "i32", ALLOC_STATIC);
__ZL7amp_inc=allocate(1, "i32", ALLOC_STATIC);
__ZZL8PlayWaveiiPhiiE9n_samples=allocate(1, "i32", ALLOC_STATIC);
__ZZL8PlayWaveiiPhiiE2ix=allocate(1, "i32", ALLOC_STATIC);
__ZZL11PlaySilenceiiE9n_samples=allocate(1, "i32", ALLOC_STATIC);
__ZZL17AdvanceParametersvE10Flutter_ix=allocate(1, "i32", ALLOC_STATIC);
__ZL11Flutter_tab=allocate([128,155,181,203,220,232,237,236,230,220,206,191,176,163,152,144,140,139,140,143,146,148,149,146,140,131,120,105,89,73,60,49,42,41,45,54,68,86,105,125,143,159,170,177,178,173,164,150,135,120,105,92,83,79,79,85,94,107,122,136,150,162,171,176,177,174,168,160,152,145,139,136,137,141,148,157,168,178,187,192,193,189,180,165,146,124,99,74,50,30,14,5,2,5,15,30,48,68,89,109,127,140,150,156,159,159,157,155,153,153,156,161,169,179,191,202,213,220,224,222,216,204,187,166,143,119,96,75,58,46,40,41,47,58,72,89,106,122,134,144,148,149,145,137,128,117,107,98,92,90,92,97,105,116,128,138,148,154,158,157,152,144,134,124,113,104,98,96,99,107,120,136,155,175,194,210,223,230,231,226,215,198,178,156,132,111,91,75,64,57,55,56,61,67,74,80,84,86,85,82,77,72,66,63,62,65,73,86,103,124,147,171,195,217,234,246,252,251,244,231,213,192,170,148,128,113,100,93,90,92,97,104,112,119,125,127,127,123,116,107,97,87,78,72,70,72,78,89,102,117,132,147,159,167,171,170,164,153,139,123,106,91,78,70,67,69,77,90,107,127,146,166,184,197,207,211,210,205,196,185,173,161,150,142,137,135,135,138,141,145,146,145,140,132,120,104,85,65,46,28,14,5,1,5,15,31,52,77,104,129,154,176,193,205,211,211,208,200,191,181,171,164,159,156,157,160,165,170,174,177,176,171,163,150,135,118,99,81,66,54,47,45,49,58,72,89,107,126,142,156,166,170,169,163,152,138,123,108,93,82,74,72,74,80,90,103,117,130] /* \80\9B\B5\CB\DC\E8\E */, "i8", ALLOC_STATIC);
_pause_phonemes=allocate([0,23,10,9,24,19,24,24] /* \00\17\0A\09\18\13\1 */, "i8", ALLOC_STATIC);
__ZZ15MakePhonemeListP10TranslatoriiE12types_double=allocate([6,7,8,3,0] /* \06\07\08\03\00 */, "i8", ALLOC_STATIC);
__ZL8kt_frame=allocate(288, "i32", ALLOC_STATIC);
__ZL10kt_globals=allocate(2748, ["i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"i32",0,0,0,"double",0,0,0,0,0,0,0,"i16*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0], ALLOC_STATIC);
__ZL5peaks801=allocate(720, ["i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0], ALLOC_STATIC);
__ZL12sample_count=allocate(1, "i32", ALLOC_STATIC);
__ZL8nsamples802=allocate(1, "i32", ALLOC_STATIC);
__ZL6klattp=allocate(40, "i32", ALLOC_STATIC);
__ZL10klattp_inc=allocate(80, "double", ALLOC_STATIC);
__ZL7klattp1=allocate(80, "double", ALLOC_STATIC);
__ZL8end_wave803=allocate(1, "i32", ALLOC_STATIC);
__ZZ14SetSynth_KlattiiP7frame_tS0_P7voice_tiE7prev_fr=allocate(64, ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8"], ALLOC_STATIC);
__ZL13scale_wav_tab=allocate([45, 0, 0, 0, 38, 0, 0, 0, 45, 0, 0, 0, 45, 0, 0, 0], ["i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__ZZ9KlattInitvE15natural_samples=allocate([-310, 0, -400, 0, 530, 0, 356, 0, 224, 0, 89, 0, 23, 0, -10, 0, -58, 0, -16, 0, 461, 0, 599, 0, 536, 0, 701, 0, 770, 0, 605, 0, 497, 0, 461, 0, 560, 0, 404, 0, 110, 0, 224, 0, 131, 0, 104, 0, -97, 0, 155, 0, 278, 0, -154, 0, -1165, 0, -598, 0, 737, 0, 125, 0, -592, 0, 41, 0, 11, 0, -247, 0, -10, 0, 65, 0, 92, 0, 80, 0, -304, 0, 71, 0, 167, 0, -1, 0, 122, 0, 233, 0, 161, 0, -43, 0, 278, 0, 479, 0, 485, 0, 407, 0, 266, 0, 650, 0, 134, 0, 80, 0, 236, 0, 68, 0, 260, 0, 269, 0, 179, 0, 53, 0, 140, 0, 275, 0, 293, 0, 296, 0, 104, 0, 257, 0, 152, 0, 311, 0, 182, 0, 263, 0, 245, 0, 125, 0, 314, 0, 140, 0, 44, 0, 203, 0, 230, 0, -235, 0, -286, 0, 23, 0, 107, 0, 92, 0, -91, 0, 38, 0, 464, 0, 443, 0, 176, 0, 98, 0, -784, 0, -2449, 0, -1891, 0, -1045, 0, -1600, 0, -1462, 0, -1384, 0, -1261, 0, -949, 0, -730, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ9KlattInitvE10formant_hz=allocate([280, 0, 688, 0, 1064, 0, 2806, 0, 3260, 0, 3700, 0, 6500, 0, 7000, 0, 8000, 0, 280, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ9KlattInitvE9bandwidth=allocate([89, 0, 160, 0, 70, 0, 160, 0, 200, 0, 200, 0, 500, 0, 500, 0, 500, 0, 89, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ9KlattInitvE12parallel_amp=allocate([0, 0, 59, 0, 59, 0, 59, 0, 59, 0, 59, 0, 59, 0, 0, 0, 0, 0, 0, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ9KlattInitvE11parallel_bw=allocate([59, 0, 59, 0, 89, 0, 149, 0, 200, 0, 200, 0, 500, 0, 0, 0, 0, 0, 0, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZL7parwaveP13klatt_frame_tE5noise=allocate(1, "double", ALLOC_STATIC);
__ZZL7parwaveP13klatt_frame_tE5voice=allocate(1, "double", ALLOC_STATIC);
__ZZL7parwaveP13klatt_frame_tE5vlast=allocate(1, "double", ALLOC_STATIC);
__ZZL7parwaveP13klatt_frame_tE8glotlast=allocate(1, "double", ALLOC_STATIC);
__ZZL7parwaveP13klatt_frame_tE5sourc=allocate(1, "double", ALLOC_STATIC);
__ZZL21pitch_synch_par_resetP13klatt_frame_tE4skew=allocate(1, "i32", ALLOC_STATIC);
__ZZL21pitch_synch_par_resetP13klatt_frame_tE2B0=allocate([1200, 0, 1142, 0, 1088, 0, 1038, 0, 991, 0, 948, 0, 907, 0, 869, 0, 833, 0, 799, 0, 768, 0, 738, 0, 710, 0, 683, 0, 658, 0, 634, 0, 612, 0, 590, 0, 570, 0, 551, 0, 533, 0, 515, 0, 499, 0, 483, 0, 468, 0, 454, 0, 440, 0, 427, 0, 415, 0, 403, 0, 391, 0, 380, 0, 370, 0, 360, 0, 350, 0, 341, 0, 332, 0, 323, 0, 315, 0, 307, 0, 300, 0, 292, 0, 285, 0, 278, 0, 272, 0, 265, 0, 259, 0, 253, 0, 247, 0, 242, 0, 237, 0, 231, 0, 226, 0, 221, 0, 217, 0, 212, 0, 208, 0, 204, 0, 199, 0, 195, 0, 192, 0, 188, 0, 184, 0, 180, 0, 177, 0, 174, 0, 170, 0, 167, 0, 164, 0, 161, 0, 158, 0, 155, 0, 153, 0, 150, 0, 147, 0, 145, 0, 142, 0, 140, 0, 137, 0, 135, 0, 133, 0, 131, 0, 128, 0, 126, 0, 124, 0, 122, 0, 120, 0, 119, 0, 117, 0, 115, 0, 113, 0, 111, 0, 110, 0, 108, 0, 106, 0, 105, 0, 103, 0, 102, 0, 100, 0, 99, 0, 97, 0, 96, 0, 95, 0, 93, 0, 92, 0, 91, 0, 90, 0, 88, 0, 87, 0, 86, 0, 85, 0, 84, 0, 83, 0, 82, 0, 80, 0, 79, 0, 78, 0, 77, 0, 76, 0, 75, 0, 75, 0, 74, 0, 73, 0, 72, 0, 71, 0, 70, 0, 69, 0, 68, 0, 68, 0, 67, 0, 66, 0, 65, 0, 64, 0, 64, 0, 63, 0, 62, 0, 61, 0, 61, 0, 60, 0, 59, 0, 59, 0, 58, 0, 57, 0, 57, 0, 56, 0, 56, 0, 55, 0, 55, 0, 54, 0, 54, 0, 53, 0, 53, 0, 52, 0, 52, 0, 51, 0, 51, 0, 50, 0, 50, 0, 49, 0, 49, 0, 48, 0, 48, 0, 47, 0, 47, 0, 46, 0, 46, 0, 45, 0, 45, 0, 44, 0, 44, 0, 43, 0, 43, 0, 42, 0, 42, 0, 41, 0, 41, 0, 41, 0, 41, 0, 40, 0, 40, 0, 39, 0, 39, 0, 38, 0, 38, 0, 38, 0, 38, 0, 37, 0, 37, 0, 36, 0, 36, 0, 36, 0, 36, 0, 35, 0, 35, 0, 35, 0, 35, 0, 34, 0, 34, 0, 33, 0, 33, 0, 33, 0, 33, 0, 32, 0, 32, 0, 32, 0, 32, 0, 31, 0, 31, 0, 31, 0, 31, 0, 30, 0, 30, 0, 30, 0, 30, 0, 29, 0, 29, 0, 29, 0, 29, 0, 28, 0, 28, 0, 28, 0, 28, 0, 27, 0, 27, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZL7DBtoLINlE8amptable=allocate([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 6, 0, 7, 0, 8, 0, 9, 0, 10, 0, 11, 0, 13, 0, 14, 0, 16, 0, 18, 0, 20, 0, 22, 0, 25, 0, 28, 0, 32, 0, 35, 0, 40, 0, 45, 0, 51, 0, 57, 0, 64, 0, 71, 0, 80, 0, 90, 0, 101, 0, 114, 0, 128, 0, 142, 0, 159, 0, 179, 0, 202, 0, 227, 0, 256, 0, 284, 0, 318, 0, 359, 0, 405, 0, 455, 0, 512, 0, 568, 0, 638, 0, 719, 0, 881, 0, 911, 0, 1024, 0, 1137, 0, 1276, 0, 1438, 0, 1622, 0, 1823, 0, 2048, 0, 2273, 0, 2552, 0, 2875, 0, 3244, 0, 3645, 0, 4096, 0, 4547, 0, 5104, 0, 5751, 0, 6488, 0, 7291, 0, 8192, 0, 9093, 0, 10207, 0, 11502, 0, 12976, 0, 14582, 0, 16384, 0, 18350, 0, 20644, 0, 23429, 0, 26214, 0, 29491, 0, 32767, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZL14natural_sourcevE5vwave=allocate(1, "double", ALLOC_STATIC);
__ZZL16impulsive_sourcevE7doublet=allocate([0, 0, 0, 0, 0, 0, 0, 0, 13000000, 0, 0, 0, 0, 0, 0, 0, -13000000, 0, 0, 0, 0, 0, 0, 0], ["double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0], ALLOC_STATIC);
__ZZL16impulsive_sourcevE5vwave=allocate(1, "double", ALLOC_STATIC);
__ZZL9gen_noisedE5nlast=allocate(1, "double", ALLOC_STATIC);
__ZZL7flutterP13klatt_frame_tE10time_count=allocate(1, "i32", ALLOC_STATIC);
__ZZL10frame_initP13klatt_frame_tE14amp_par_factor=allocate([0.6, 0, 0, 0, 0, 0, 0, 0, 0.4, 0, 0, 0, 0, 0, 0, 0, 0.15, 0, 0, 0, 0, 0, 0, 0, 0.06, 0, 0, 0, 0, 0, 0, 0, 0.04, 0, 0, 0, 0, 0, 0, 0, 0.022, 0, 0, 0, 0, 0, 0, 0, 0.03, 0, 0, 0, 0, 0, 0, 0], ["double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0], ALLOC_STATIC);
__str810=allocate([47,116,109,112,47,115,111,110,105,99,46,108,111,103,0] /* /tmp/sonic.log\00 */, "i8", ALLOC_STATIC);
__str1811=allocate([97,0] /* a\00 */, "i8", ALLOC_STATIC);
_optarg=allocate(1, "i8*", ALLOC_STATIC);
_optind=allocate(1, "i32", ALLOC_STATIC);
_opterr=allocate([1], ["i32",0,0,0,0], ALLOC_STATIC);
_optopt=allocate([63], ["i32",0,0,0,0], ALLOC_STATIC);
__ZL8optwhere=allocate(1, "i32", ALLOC_STATIC);
__str831=allocate([45,45,0] /* --\00 */, "i8", ALLOC_STATIC);
__str1832=allocate([80,79,83,73,88,76,89,95,67,79,82,82,69,67,84,0] /* POSIXLY_CORRECT\00 */, "i8", ALLOC_STATIC);
__str2833=allocate([37,115,58,32,111,112,116,105,111,110,32,96,37,115,39,32,105,115,32,97,109,98,105,103,117,111,117,115,32,40,99,111,117,108,100,32,98,101,32,96,45,45,37,115,39,32,111,114,32,96,45,45,37,115,39,41,10,0] /* %s: option `%s' is a */, "i8", ALLOC_STATIC);
__str3834=allocate([37,115,58,32,105,110,118,97,108,105,100,32,111,112,116,105,111,110,32,45,45,32,96,45,37,99,39,10,0] /* %s: invalid option - */, "i8", ALLOC_STATIC);
__str4835=allocate([37,115,58,32,97,114,103,117,109,101,110,116,32,114,101,113,117,105,114,101,100,32,102,111,114,32,111,112,116,105,111,110,32,96,0] /* %s: argument require */, "i8", ALLOC_STATIC);
__str5836=allocate([45,45,37,115,39,10,0] /* --%s'\0A\00 */, "i8", ALLOC_STATIC);
__str6837=allocate([45,37,99,39,10,0] /* -%c'\0A\00 */, "i8", ALLOC_STATIC);
HEAP32[((__ZZ4mainE12long_options)>>2)]=((__str6)&4294967295);
HEAP32[((__ZZ4mainE12long_options+16)>>2)]=((__str7)&4294967295);
HEAP32[((__ZZ4mainE12long_options+32)>>2)]=((__str8)&4294967295);
HEAP32[((__ZZ4mainE12long_options+48)>>2)]=((__str9)&4294967295);
HEAP32[((__ZZ4mainE12long_options+64)>>2)]=((__str10)&4294967295);
HEAP32[((__ZZ4mainE12long_options+80)>>2)]=((__str11)&4294967295);
HEAP32[((__ZZ4mainE12long_options+96)>>2)]=((__str12)&4294967295);
HEAP32[((__ZZ4mainE12long_options+112)>>2)]=((__str13)&4294967295);
HEAP32[((__ZZ4mainE12long_options+128)>>2)]=((__str14)&4294967295);
HEAP32[((__ZZ4mainE12long_options+144)>>2)]=((__str15)&4294967295);
HEAP32[((__ZZ4mainE12long_options+160)>>2)]=((__str16)&4294967295);
HEAP32[((__ZZ4mainE12long_options+176)>>2)]=((__str17)&4294967295);
HEAP32[((_mnem_rules)>>2)]=((__str42)&4294967295);
HEAP32[((_mnem_rules+8)>>2)]=((__str143)&4294967295);
HEAP32[((_mnem_rules+16)>>2)]=((__str244)&4294967295);
HEAP32[((_mnem_rules+24)>>2)]=((__str345)&4294967295);
HEAP32[((_mnem_rules+32)>>2)]=((__str446)&4294967295);
HEAP32[((_mnem_rules+40)>>2)]=((__str547)&4294967295);
HEAP32[((_mnem_rules+48)>>2)]=((__str648)&4294967295);
HEAP32[((_mnem_flags)>>2)]=((__str749)&4294967295);
HEAP32[((_mnem_flags+8)>>2)]=((__str850)&4294967295);
HEAP32[((_mnem_flags+16)>>2)]=((__str951)&4294967295);
HEAP32[((_mnem_flags+24)>>2)]=((__str1052)&4294967295);
HEAP32[((_mnem_flags+32)>>2)]=((__str1153)&4294967295);
HEAP32[((_mnem_flags+40)>>2)]=((__str1254)&4294967295);
HEAP32[((_mnem_flags+48)>>2)]=((__str1355)&4294967295);
HEAP32[((_mnem_flags+56)>>2)]=((__str1456)&4294967295);
HEAP32[((_mnem_flags+64)>>2)]=((__str1557)&4294967295);
HEAP32[((_mnem_flags+72)>>2)]=((__str1658)&4294967295);
HEAP32[((_mnem_flags+80)>>2)]=((__str1759)&4294967295);
HEAP32[((_mnem_flags+88)>>2)]=((__str1860)&4294967295);
HEAP32[((_mnem_flags+96)>>2)]=((__str1961)&4294967295);
HEAP32[((_mnem_flags+104)>>2)]=((__str2062)&4294967295);
HEAP32[((_mnem_flags+112)>>2)]=((__str2163)&4294967295);
HEAP32[((_mnem_flags+120)>>2)]=((__str2264)&4294967295);
HEAP32[((_mnem_flags+128)>>2)]=((__str2365)&4294967295);
HEAP32[((_mnem_flags+136)>>2)]=((__str2466)&4294967295);
HEAP32[((_mnem_flags+144)>>2)]=((__str2567)&4294967295);
HEAP32[((_mnem_flags+152)>>2)]=((__str2668)&4294967295);
HEAP32[((_mnem_flags+160)>>2)]=((__str2769)&4294967295);
HEAP32[((_mnem_flags+168)>>2)]=((__str2870)&4294967295);
HEAP32[((_mnem_flags+176)>>2)]=((__str2971)&4294967295);
HEAP32[((_mnem_flags+184)>>2)]=((__str3072)&4294967295);
HEAP32[((_mnem_flags+192)>>2)]=((__str3173)&4294967295);
HEAP32[((_mnem_flags+200)>>2)]=((__str3274)&4294967295);
HEAP32[((_mnem_flags+208)>>2)]=((__str3375)&4294967295);
HEAP32[((_mnem_flags+216)>>2)]=((__str3476)&4294967295);
HEAP32[((_mnem_flags+224)>>2)]=((__str3577)&4294967295);
HEAP32[((_mnem_flags+232)>>2)]=((__str3678)&4294967295);
HEAP32[((_mnem_flags+240)>>2)]=((__str3779)&4294967295);
HEAP32[((_mnem_flags+248)>>2)]=((__str3880)&4294967295);
HEAP32[((_mnem_flags+256)>>2)]=((__str3981)&4294967295);
HEAP32[((_mnem_flags+264)>>2)]=((__str4082)&4294967295);
HEAP32[((_mnem_flags+272)>>2)]=((__str4183)&4294967295);
HEAP32[((_mnem_flags+280)>>2)]=((__str4284)&4294967295);
HEAP32[((_mnem_flags+288)>>2)]=((__str43)&4294967295);
HEAP32[((_mnem_flags+296)>>2)]=((__str44)&4294967295);
HEAP32[((_mnem_flags+304)>>2)]=((__str45)&4294967295);
HEAP32[((_mnem_flags+312)>>2)]=((__str46)&4294967295);
HEAP32[((_mnem_flags+320)>>2)]=((__str47)&4294967295);
HEAP32[((_mnem_flags+328)>>2)]=((__str48)&4294967295);
HEAP32[((_mnem_flags+336)>>2)]=((__str49)&4294967295);
HEAP32[((_mnem_flags+344)>>2)]=((__str50)&4294967295);
HEAP32[((_mnem_flags+352)>>2)]=((__str51)&4294967295);
HEAP32[((_mnem_flags+360)>>2)]=((__str52)&4294967295);
HEAP32[((_mnem_flags+368)>>2)]=((__str53)&4294967295);
HEAP32[((_mnem_flags+376)>>2)]=((__str54)&4294967295);
HEAP32[((_mnem_flags+384)>>2)]=((__str55)&4294967295);
HEAP32[((_mnem_flags+392)>>2)]=((__str56)&4294967295);
HEAP32[((_mnem_flags+400)>>2)]=((__str57)&4294967295);
HEAP32[((__ZZL16copy_rule_stringPcRiE6outbuf)>>2)]=((__ZL9rule_cond)&4294967295);
HEAP32[((__ZZL16copy_rule_stringPcRiE6outbuf+4)>>2)]=((__ZL8rule_pre)&4294967295);
HEAP32[((__ZZL16copy_rule_stringPcRiE6outbuf+8)>>2)]=((__ZL10rule_match)&4294967295);
HEAP32[((__ZZL16copy_rule_stringPcRiE6outbuf+12)>>2)]=((__ZL9rule_post)&4294967295);
HEAP32[((__ZZL16copy_rule_stringPcRiE6outbuf+16)>>2)]=((__ZL13rule_phonemes)&4294967295);
HEAP32[((__ZZ12RemoveEndingP10TranslatorPciS1_E16add_e_exceptions)>>2)]=((__str17133)&4294967295);
HEAP32[((__ZZ12RemoveEndingP10TranslatorPciS1_E15add_e_additions)>>2)]=((__str18134)&4294967295);
HEAP32[((__ZZ12RemoveEndingP10TranslatorPciS1_E15add_e_additions+4)>>2)]=((__str19135)&4294967295);
HEAP32[((__ZZ12RemoveEndingP10TranslatorPciS1_E15add_e_additions+8)>>2)]=((__str20136)&4294967295);
HEAP32[((__ZZ12RemoveEndingP10TranslatorPciS1_E15add_e_additions+12)>>2)]=((__str21137)&4294967295);
HEAP32[((__ZZ12RemoveEndingP10TranslatorPciS1_E15add_e_additions+16)>>2)]=((__str22138)&4294967295);
HEAP32[((__ZZ12RemoveEndingP10TranslatorPciS1_E15add_e_additions+20)>>2)]=((__str23139)&4294967295);
HEAP32[((__ZZ12RemoveEndingP10TranslatorPciS1_E15add_e_additions+24)>>2)]=((__str24140)&4294967295);
HEAP32[((_envelope_data)>>2)]=((_env_fall)&4294967295);
HEAP32[((_envelope_data+4)>>2)]=((_env_fall)&4294967295);
HEAP32[((_envelope_data+8)>>2)]=((_env_rise)&4294967295);
HEAP32[((_envelope_data+12)>>2)]=((_env_rise)&4294967295);
HEAP32[((_envelope_data+16)>>2)]=((_env_frise)&4294967295);
HEAP32[((_envelope_data+20)>>2)]=((__ZL11env_r_frise)&4294967295);
HEAP32[((_envelope_data+24)>>2)]=((__ZL10env_frise2)&4294967295);
HEAP32[((_envelope_data+28)>>2)]=((__ZL12env_r_frise2)&4294967295);
HEAP32[((_envelope_data+32)>>2)]=((__ZL12env_risefall)&4294967295);
HEAP32[((_envelope_data+36)>>2)]=((__ZL12env_risefall)&4294967295);
HEAP32[((_envelope_data+40)>>2)]=((__ZL13env_fallrise3)&4294967295);
HEAP32[((_envelope_data+44)>>2)]=((__ZL13env_fallrise3)&4294967295);
HEAP32[((_envelope_data+48)>>2)]=((__ZL13env_fallrise4)&4294967295);
HEAP32[((_envelope_data+52)>>2)]=((__ZL13env_fallrise4)&4294967295);
HEAP32[((_envelope_data+56)>>2)]=((__ZL9env_fall2)&4294967295);
HEAP32[((_envelope_data+60)>>2)]=((__ZL9env_fall2)&4294967295);
HEAP32[((_envelope_data+64)>>2)]=((__ZL9env_rise2)&4294967295);
HEAP32[((_envelope_data+68)>>2)]=((__ZL9env_rise2)&4294967295);
HEAP32[((_envelope_data+72)>>2)]=((__ZL16env_risefallrise)&4294967295);
HEAP32[((_envelope_data+76)>>2)]=((__ZL16env_risefallrise)&4294967295);
HEAP32[((__ZL15tone_head_table+4)>>2)]=((__ZL7drops_0)&4294967295);
HEAP32[((__ZL15tone_head_table+12)>>2)]=((__ZL5oflow)&4294967295);
HEAP32[((__ZL15tone_head_table+20)>>2)]=((__ZL7drops_0)&4294967295);
HEAP32[((__ZL15tone_head_table+28)>>2)]=((__ZL5oflow)&4294967295);
HEAP32[((__ZL15tone_head_table+36)>>2)]=((__ZL7drops_0)&4294967295);
HEAP32[((__ZL15tone_head_table+44)>>2)]=((__ZL5oflow)&4294967295);
HEAP32[((__ZL15tone_head_table+52)>>2)]=((__ZL7drops_0)&4294967295);
HEAP32[((__ZL15tone_head_table+60)>>2)]=((__ZL9oflow_emf)&4294967295);
HEAP32[((__ZL15tone_head_table+68)>>2)]=((__ZL7drops_0)&4294967295);
HEAP32[((__ZL15tone_head_table+76)>>2)]=((__ZL5oflow)&4294967295);
HEAP32[((__ZL15tone_head_table+84)>>2)]=((__ZL7drops_0)&4294967295);
HEAP32[((__ZL15tone_head_table+92)>>2)]=((__ZL10oflow_less)&4294967295);
HEAP32[((__ZL15tone_head_table+100)>>2)]=((__ZL7drops_0)&4294967295);
HEAP32[((__ZL15tone_head_table+108)>>2)]=((__ZL10oflow_less)&4294967295);
HEAP32[((__ZL15tone_head_table+116)>>2)]=((__ZL7drops_0)&4294967295);
HEAP32[((__ZL15tone_head_table+124)>>2)]=((__ZL10oflow_less)&4294967295);
HEAP32[((__ZL15tone_head_table+132)>>2)]=((__ZL7drops_0)&4294967295);
HEAP32[((__ZL15tone_head_table+140)>>2)]=((__ZL5oflow)&4294967295);
HEAP32[((__ZL15tone_head_table+148)>>2)]=((__ZL7drops_0)&4294967295);
HEAP32[((__ZL15tone_head_table+156)>>2)]=((__ZL5oflow)&4294967295);
HEAP32[((__ZL15tone_head_table+164)>>2)]=((__ZL7drops_0)&4294967295);
HEAP32[((__ZL15tone_head_table+172)>>2)]=((__ZL5oflow)&4294967295);
HEAP32[((__ZL15tone_head_table+180)>>2)]=((__ZL7drops_0)&4294967295);
HEAP32[((__ZL15tone_head_table+188)>>2)]=((__ZL10oflow_less)&4294967295);
HEAP32[((__ZL15tone_head_table+196)>>2)]=((__ZL7drops_0)&4294967295);
HEAP32[((__ZL15tone_head_table+204)>>2)]=((__ZL10oflow_less)&4294967295);
HEAP32[((__ZL8ssmltags)>>2)]=((__str167)&4294967295);
HEAP32[((__ZL8ssmltags+8)>>2)]=((__str1168)&4294967295);
HEAP32[((__ZL8ssmltags+16)>>2)]=((__str2169)&4294967295);
HEAP32[((__ZL8ssmltags+24)>>2)]=((__str3170)&4294967295);
HEAP32[((__ZL8ssmltags+32)>>2)]=((__str4171)&4294967295);
HEAP32[((__ZL8ssmltags+40)>>2)]=((__str5172)&4294967295);
HEAP32[((__ZL8ssmltags+48)>>2)]=((__str6173)&4294967295);
HEAP32[((__ZL8ssmltags+56)>>2)]=((__str7174)&4294967295);
HEAP32[((__ZL8ssmltags+64)>>2)]=((__str8175)&4294967295);
HEAP32[((__ZL8ssmltags+72)>>2)]=((__str9176)&4294967295);
HEAP32[((__ZL8ssmltags+80)>>2)]=((__str10177)&4294967295);
HEAP32[((__ZL8ssmltags+88)>>2)]=((__str11178)&4294967295);
HEAP32[((__ZL8ssmltags+96)>>2)]=((__str12179)&4294967295);
HEAP32[((__ZL8ssmltags+104)>>2)]=((__str13180)&4294967295);
HEAP32[((__ZL8ssmltags+112)>>2)]=((__str14181)&4294967295);
HEAP32[((__ZL8ssmltags+120)>>2)]=((__str15182)&4294967295);
HEAP32[((__ZL8ssmltags+128)>>2)]=((__str16183)&4294967295);
HEAP32[((__ZL8ssmltags+136)>>2)]=((__str17184)&4294967295);
HEAP32[((__ZL8ssmltags+144)>>2)]=((__str18185)&4294967295);
HEAP32[((__ZL8ssmltags+152)>>2)]=((__str19186)&4294967295);
HEAP32[((__ZL8ssmltags+160)>>2)]=((__str20187)&4294967295);
HEAP32[((__ZL8ssmltags+168)>>2)]=((__str21188)&4294967295);
HEAP32[((__ZL8ssmltags+176)>>2)]=((__str22189)&4294967295);
HEAP32[((__ZL8ssmltags+184)>>2)]=((__str23190)&4294967295);
HEAP32[((__ZL8ssmltags+192)>>2)]=((__str24191)&4294967295);
HEAP32[((__ZL8ssmltags+200)>>2)]=((__str25192)&4294967295);
HEAP32[((__ZL8ssmltags+208)>>2)]=((__str26193)&4294967295);
HEAP32[((__ZL8ssmltags+216)>>2)]=((__str27194)&4294967295);
HEAP32[((__ZL8ssmltags+224)>>2)]=((__str28195)&4294967295);
HEAP32[((__ZL8ssmltags+232)>>2)]=((__str29196)&4294967295);
HEAP32[((__ZL8ssmltags+240)>>2)]=((__str30197)&4294967295);
HEAP32[((__ZL8ssmltags+248)>>2)]=((__str31198)&4294967295);
HEAP32[((__ZL18xml_char_mnemonics)>>2)]=((__str32199)&4294967295);
HEAP32[((__ZL18xml_char_mnemonics+8)>>2)]=((__str33200)&4294967295);
HEAP32[((__ZL18xml_char_mnemonics+16)>>2)]=((__str34201)&4294967295);
HEAP32[((__ZL18xml_char_mnemonics+24)>>2)]=((__str35202)&4294967295);
HEAP32[((__ZL18xml_char_mnemonics+32)>>2)]=((__str36203)&4294967295);
HEAP32[((__ZL18xml_char_mnemonics+40)>>2)]=((__str37204)&4294967295);
HEAP32[((__ZL7xmlbase)>>2)]=((__str13643)&4294967295);
HEAP32[((__ZZL14ProcessSsmlTagPwPcRiiiE10mnem_punct)>>2)]=((__str61228)&4294967295);
HEAP32[((__ZZL14ProcessSsmlTagPwPcRiiiE10mnem_punct+8)>>2)]=((__str62229)&4294967295);
HEAP32[((__ZZL14ProcessSsmlTagPwPcRiiiE10mnem_punct+16)>>2)]=((__str63230)&4294967295);
HEAP32[((__ZZL14ProcessSsmlTagPwPcRiiiE13mnem_capitals)>>2)]=((__str64231)&4294967295);
HEAP32[((__ZZL14ProcessSsmlTagPwPcRiiiE13mnem_capitals+8)>>2)]=((__str65232)&4294967295);
HEAP32[((__ZZL14ProcessSsmlTagPwPcRiiiE13mnem_capitals+16)>>2)]=((__str66233)&4294967295);
HEAP32[((__ZZL14ProcessSsmlTagPwPcRiiiE13mnem_capitals+24)>>2)]=((__str9659)&4294967295);
HEAP32[((__ZZL14ProcessSsmlTagPwPcRiiiE17mnem_interpret_as)>>2)]=((__str68235)&4294967295);
HEAP32[((__ZZL14ProcessSsmlTagPwPcRiiiE17mnem_interpret_as+8)>>2)]=((__str69236)&4294967295);
HEAP32[((__ZZL14ProcessSsmlTagPwPcRiiiE17mnem_interpret_as+16)>>2)]=((__str70237)&4294967295);
HEAP32[((__ZZL14ProcessSsmlTagPwPcRiiiE17mnem_interpret_as+24)>>2)]=((__str71238)&4294967295);
HEAP32[((__ZZL14ProcessSsmlTagPwPcRiiiE17mnem_interpret_as+32)>>2)]=((__str72239)&4294967295);
HEAP32[((__ZZL14ProcessSsmlTagPwPcRiiiE17mnem_sayas_format)>>2)]=((__str73240)&4294967295);
HEAP32[((__ZZL14ProcessSsmlTagPwPcRiiiE10mnem_break)>>2)]=((__str61228)&4294967295);
HEAP32[((__ZZL14ProcessSsmlTagPwPcRiiiE10mnem_break+8)>>2)]=((__str74241)&4294967295);
HEAP32[((__ZZL14ProcessSsmlTagPwPcRiiiE10mnem_break+16)>>2)]=((__str75242)&4294967295);
HEAP32[((__ZZL14ProcessSsmlTagPwPcRiiiE10mnem_break+24)>>2)]=((__str76243)&4294967295);
HEAP32[((__ZZL14ProcessSsmlTagPwPcRiiiE10mnem_break+32)>>2)]=((__str29196)&4294967295);
HEAP32[((__ZZL14ProcessSsmlTagPwPcRiiiE10mnem_break+40)>>2)]=((__str77244)&4294967295);
HEAP32[((__ZZL14ProcessSsmlTagPwPcRiiiE13mnem_emphasis)>>2)]=((__str61228)&4294967295);
HEAP32[((__ZZL14ProcessSsmlTagPwPcRiiiE13mnem_emphasis+8)>>2)]=((__str78245)&4294967295);
HEAP32[((__ZZL14ProcessSsmlTagPwPcRiiiE13mnem_emphasis+16)>>2)]=((__str79246)&4294967295);
HEAP32[((__ZZL14ProcessSsmlTagPwPcRiiiE13mnem_emphasis+24)>>2)]=((__str29196)&4294967295);
HEAP32[((__ZZL14ProcessSsmlTagPwPcRiiiE12prosody_attr+4)>>2)]=((__str80247)&4294967295);
HEAP32[((__ZZL14ProcessSsmlTagPwPcRiiiE12prosody_attr+8)>>2)]=((__str81248)&4294967295);
HEAP32[((__ZZL14ProcessSsmlTagPwPcRiiiE12prosody_attr+12)>>2)]=((__str9659)&4294967295);
HEAP32[((__ZZL14ProcessSsmlTagPwPcRiiiE12prosody_attr+16)>>2)]=((__str82249)&4294967295);
HEAP32[((__ZZL18GetVoiceAttributesPwiE11mnem_gender)>>2)]=((__str1647)&4294967295);
HEAP32[((__ZZL18GetVoiceAttributesPwiE11mnem_gender+8)>>2)]=((__str2648)&4294967295);
HEAP32[((__ZZL18GetVoiceAttributesPwiE11mnem_gender+16)>>2)]=((__str105272)&4294967295);
HEAP32[((__ZZL14ReplaceKeyNamePciRiE8keynames)>>2)]=((__str111278)&4294967295);
HEAP32[((__ZZL14ReplaceKeyNamePciRiE8keynames+8)>>2)]=((__str112279)&4294967295);
HEAP32[((__ZZL14ReplaceKeyNamePciRiE8keynames+16)>>2)]=((__str113280)&4294967295);
HEAP32[((__ZZL14ReplaceKeyNamePciRiE8keynames+24)>>2)]=((__str114281)&4294967295);
HEAP32[((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE11mnem_volume)>>2)]=((__str45697)&4294967295);
HEAP32[((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE11mnem_volume+8)>>2)]=((__str115282)&4294967295);
HEAP32[((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE11mnem_volume+16)>>2)]=((__str116283)&4294967295);
HEAP32[((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE11mnem_volume+24)>>2)]=((__str117)&4294967295);
HEAP32[((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE11mnem_volume+32)>>2)]=((__str76243)&4294967295);
HEAP32[((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE11mnem_volume+40)>>2)]=((__str118)&4294967295);
HEAP32[((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE11mnem_volume+48)>>2)]=((__str119)&4294967295);
HEAP32[((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE9mnem_rate)>>2)]=((__str45697)&4294967295);
HEAP32[((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE9mnem_rate+8)>>2)]=((__str120)&4294967295);
HEAP32[((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE9mnem_rate+16)>>2)]=((__str121)&4294967295);
HEAP32[((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE9mnem_rate+24)>>2)]=((__str76243)&4294967295);
HEAP32[((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE9mnem_rate+32)>>2)]=((__str122)&4294967295);
HEAP32[((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE9mnem_rate+40)>>2)]=((__str123)&4294967295);
HEAP32[((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE10mnem_pitch)>>2)]=((__str45697)&4294967295);
HEAP32[((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE10mnem_pitch+8)>>2)]=((__str124)&4294967295);
HEAP32[((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE10mnem_pitch+16)>>2)]=((__str125)&4294967295);
HEAP32[((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE10mnem_pitch+24)>>2)]=((__str76243)&4294967295);
HEAP32[((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE10mnem_pitch+32)>>2)]=((__str126)&4294967295);
HEAP32[((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE10mnem_pitch+40)>>2)]=((__str127)&4294967295);
HEAP32[((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE10mnem_range)>>2)]=((__str45697)&4294967295);
HEAP32[((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE10mnem_range+8)>>2)]=((__str124)&4294967295);
HEAP32[((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE10mnem_range+16)>>2)]=((__str125)&4294967295);
HEAP32[((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE10mnem_range+24)>>2)]=((__str76243)&4294967295);
HEAP32[((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE10mnem_range+32)>>2)]=((__str126)&4294967295);
HEAP32[((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE10mnem_range+40)>>2)]=((__str127)&4294967295);
HEAP32[((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE9mnem_tabs+4)>>2)]=((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE9mnem_rate)&4294967295);
HEAP32[((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE9mnem_tabs+8)>>2)]=((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE11mnem_volume)&4294967295);
HEAP32[((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE9mnem_tabs+12)>>2)]=((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE10mnem_pitch)&4294967295);
HEAP32[((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE9mnem_tabs+16)>>2)]=((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE10mnem_range)&4294967295);
HEAP32[((__ZL11accents_tab)>>2)]=((__str57354)&4294967295);
HEAP32[((__ZL11accents_tab+8)>>2)]=((__str58355)&4294967295);
HEAP32[((__ZL11accents_tab+16)>>2)]=((__str59356)&4294967295);
HEAP32[((__ZL11accents_tab+24)>>2)]=((__str60357)&4294967295);
HEAP32[((__ZL11accents_tab+32)>>2)]=((__str61358)&4294967295);
HEAP32[((__ZL11accents_tab+40)>>2)]=((__str62359)&4294967295);
HEAP32[((__ZL11accents_tab+48)>>2)]=((__str63360)&4294967295);
HEAP32[((__ZL11accents_tab+56)>>2)]=((__str64361)&4294967295);
HEAP32[((__ZL11accents_tab+64)>>2)]=((__str65362)&4294967295);
HEAP32[((__ZL11accents_tab+72)>>2)]=((__str66363)&4294967295);
HEAP32[((__ZL11accents_tab+80)>>2)]=((__str67364)&4294967295);
HEAP32[((__ZL11accents_tab+88)>>2)]=((__str68365)&4294967295);
HEAP32[((__ZL11accents_tab+96)>>2)]=((__str69366)&4294967295);
HEAP32[((__ZL11accents_tab+104)>>2)]=((__str70367)&4294967295);
HEAP32[((__ZL11accents_tab+112)>>2)]=((__str71368)&4294967295);
HEAP32[((__ZL11accents_tab+120)>>2)]=((__str72369)&4294967295);
HEAP32[((__ZL11accents_tab+128)>>2)]=((__str73370)&4294967295);
HEAP32[((__ZL11accents_tab+136)>>2)]=((__str74371)&4294967295);
HEAP32[((__ZL11accents_tab+144)>>2)]=((__str75372)&4294967295);
HEAP32[((__ZL11accents_tab+152)>>2)]=((__str76373)&4294967295);
HEAP32[((__ZL11accents_tab+160)>>2)]=((__str77374)&4294967295);
HEAP32[((__ZL11accents_tab+168)>>2)]=((__str78375)&4294967295);
HEAP32[((_version_string)>>2)]=((__str399)&4294967295);
HEAP32[((_charsets)>>2)]=((__ZL10ISO_8859_1)&4294967295);
HEAP32[((_charsets+4)>>2)]=((__ZL10ISO_8859_1)&4294967295);
HEAP32[((_charsets+8)>>2)]=((__ZL10ISO_8859_2)&4294967295);
HEAP32[((_charsets+12)>>2)]=((__ZL10ISO_8859_3)&4294967295);
HEAP32[((_charsets+16)>>2)]=((__ZL10ISO_8859_4)&4294967295);
HEAP32[((_charsets+20)>>2)]=((__ZL10ISO_8859_5)&4294967295);
HEAP32[((_charsets+24)>>2)]=((__ZL10ISO_8859_1)&4294967295);
HEAP32[((_charsets+28)>>2)]=((__ZL10ISO_8859_7)&4294967295);
HEAP32[((_charsets+32)>>2)]=((__ZL10ISO_8859_1)&4294967295);
HEAP32[((_charsets+36)>>2)]=((__ZL10ISO_8859_9)&4294967295);
HEAP32[((_charsets+40)>>2)]=((__ZL10ISO_8859_1)&4294967295);
HEAP32[((_charsets+44)>>2)]=((__ZL10ISO_8859_1)&4294967295);
HEAP32[((_charsets+48)>>2)]=((__ZL10ISO_8859_1)&4294967295);
HEAP32[((_charsets+52)>>2)]=((__ZL10ISO_8859_1)&4294967295);
HEAP32[((_charsets+56)>>2)]=((__ZL11ISO_8859_14)&4294967295);
HEAP32[((_charsets+60)>>2)]=((__ZL10ISO_8859_1)&4294967295);
HEAP32[((_charsets+64)>>2)]=((__ZL10ISO_8859_1)&4294967295);
HEAP32[((_charsets+68)>>2)]=((__ZL10ISO_8859_1)&4294967295);
HEAP32[((_charsets+72)>>2)]=((__ZL6KOI8_R)&4294967295);
HEAP32[((_charsets+76)>>2)]=((__ZL5ISCII)&4294967295);
HEAP32[((__ZL15length_mod_tabs)>>2)]=((__ZL14length_mods_en)&4294967295);
HEAP32[((__ZL15length_mod_tabs+4)>>2)]=((__ZL14length_mods_en)&4294967295);
HEAP32[((__ZL15length_mod_tabs+8)>>2)]=((__ZL15length_mods_en0)&4294967295);
HEAP32[((__ZL15length_mod_tabs+12)>>2)]=((__ZL17length_mods_equal)&4294967295);
HEAP32[((__ZL15length_mod_tabs+16)>>2)]=((__ZL17length_mods_equal)&4294967295);
HEAP32[((__ZL15length_mod_tabs+20)>>2)]=((__ZL17length_mods_equal)&4294967295);
HEAP32[((_genders)>>2)]=((__str646)&4294967295);
HEAP32[((_genders+8)>>2)]=((__str1647)&4294967295);
HEAP32[((_genders+16)>>2)]=((__str2648)&4294967295);
HEAP32[((__ZL11options_tab)>>2)]=((__str3653)&4294967295);
HEAP32[((__ZL11options_tab+8)>>2)]=((__str4654)&4294967295);
HEAP32[((__ZL11keyword_tab)>>2)]=((__str5655)&4294967295);
HEAP32[((__ZL11keyword_tab+8)>>2)]=((__str6656)&4294967295);
HEAP32[((__ZL11keyword_tab+16)>>2)]=((__str7657)&4294967295);
HEAP32[((__ZL11keyword_tab+24)>>2)]=((__str8658)&4294967295);
HEAP32[((__ZL11keyword_tab+32)>>2)]=((__str9659)&4294967295);
HEAP32[((__ZL11keyword_tab+40)>>2)]=((__str10660)&4294967295);
HEAP32[((__ZL11keyword_tab+48)>>2)]=((__str11661)&4294967295);
HEAP32[((__ZL11keyword_tab+56)>>2)]=((__str12662)&4294967295);
HEAP32[((__ZL11keyword_tab+64)>>2)]=((__str13663)&4294967295);
HEAP32[((__ZL11keyword_tab+72)>>2)]=((__str14664)&4294967295);
HEAP32[((__ZL11keyword_tab+80)>>2)]=((__str15665)&4294967295);
HEAP32[((__ZL11keyword_tab+88)>>2)]=((__str16666)&4294967295);
HEAP32[((__ZL11keyword_tab+96)>>2)]=((__str17667)&4294967295);
HEAP32[((__ZL11keyword_tab+104)>>2)]=((__str18668)&4294967295);
HEAP32[((__ZL11keyword_tab+112)>>2)]=((__str19669)&4294967295);
HEAP32[((__ZL11keyword_tab+120)>>2)]=((__str20670)&4294967295);
HEAP32[((__ZL11keyword_tab+128)>>2)]=((__str21671)&4294967295);
HEAP32[((__ZL11keyword_tab+136)>>2)]=((__str22672)&4294967295);
HEAP32[((__ZL11keyword_tab+144)>>2)]=((__str23673)&4294967295);
HEAP32[((__ZL11keyword_tab+152)>>2)]=((__str24674)&4294967295);
HEAP32[((__ZL11keyword_tab+160)>>2)]=((__str25675)&4294967295);
HEAP32[((__ZL11keyword_tab+168)>>2)]=((__str26676)&4294967295);
HEAP32[((__ZL11keyword_tab+176)>>2)]=((__str27677)&4294967295);
HEAP32[((__ZL11keyword_tab+184)>>2)]=((__str28678)&4294967295);
HEAP32[((__ZL11keyword_tab+192)>>2)]=((__str29679)&4294967295);
HEAP32[((__ZL11keyword_tab+200)>>2)]=((__str30680)&4294967295);
HEAP32[((__ZL11keyword_tab+208)>>2)]=((__str31681)&4294967295);
HEAP32[((__ZL11keyword_tab+216)>>2)]=((__str32682)&4294967295);
HEAP32[((__ZL11keyword_tab+224)>>2)]=((__str33683)&4294967295);
HEAP32[((__ZL11keyword_tab+232)>>2)]=((__str34684)&4294967295);
HEAP32[((__ZL11keyword_tab+240)>>2)]=((__str35685)&4294967295);
HEAP32[((__ZL11keyword_tab+248)>>2)]=((__str36686)&4294967295);
HEAP32[((__ZL11keyword_tab+256)>>2)]=((__str37687)&4294967295);
HEAP32[((__ZL11keyword_tab+264)>>2)]=((__str38688)&4294967295);
HEAP32[((__ZL11keyword_tab+272)>>2)]=((__str39689)&4294967295);
HEAP32[((__ZL11keyword_tab+280)>>2)]=((__str40690)&4294967295);
HEAP32[((__ZL11keyword_tab+288)>>2)]=((__str41691)&4294967295);
HEAP32[((__ZL11keyword_tab+296)>>2)]=((__str42692)&4294967295);
HEAP32[((__ZL11keyword_tab+304)>>2)]=((__str43693)&4294967295);
HEAP32[((_variant_lists)>>2)]=((__ZL15variants_either)&4294967295);
HEAP32[((_variant_lists+4)>>2)]=((__ZL13variants_male)&4294967295);
HEAP32[((_variant_lists+8)>>2)]=((__ZL15variants_female)&4294967295);
HEAP32[((_voice)>>2)]=__ZL9voicedata;
FS.init(); __ATEXIT__.push({ func: function() { FS.quit() } });
___setErrNo(0);
_fputc.ret = allocate([0], "i8", ALLOC_STATIC);
___buildEnvironment(ENV);
_fgetc.ret = allocate([0], "i8", ALLOC_STATIC);
FUNCTION_TABLE = [0,0,__ZL13rgroup_sorterP6RGROUPS0_,0,__Z13string_sorterPPcS0_,0,__ZL15VoiceNameSorterPKvS0_,0,__ZL16VoiceScoreSorterPKvS0_,0]; Module["FUNCTION_TABLE"] = FUNCTION_TABLE;


  __globalConstructor__();

  var ret = null;
  if (Module._main) {
    ret = Module.callMain(args);
    __shutdownRuntime__();
  }
  return ret;
}
Module.run = run;

// {{PRE_RUN_ADDITIONS}}


if (!Module.noInitialRun) {
  run();
}

// {{POST_RUN_ADDITIONS}}





  // {{MODULE_ADDITIONS}}

/*
  return Module;
}).call(this, {}, arguments); // Replace parameters as needed
*/


// EMSCRIPTEN_GENERATED_FUNCTIONS: ["__Z13GetFileLengthPKc","__Z5Alloci","__Z4FreePv","__Z13DisplayVoicesP7__sFILEPc","__Z13WVoiceChangedP7voice_t","__Z11MarkerEventijiPh","_main","__ZL9init_pathPcS_","__ZL10initialisev","__ZL12OpenWaveFilePKci","__ZL11WavegenFilev","__ZL13CloseWaveFilev","__Z8isspace2j","__Z14LookupMnemNameP8MNEM_TABi","__Z22print_dictionary_flagsPj","__Z10DecodeRulePKciPci","__Z13string_sorterPPcS0_","__Z17CompileDictionaryPKcS0_P7__sFILEPci","__ZL9fopen_logPKcS0_","__ZL22compile_dictlist_startv","__ZL21compile_dictlist_filePKcS0_","__ZL20compile_dictlist_endP7__sFILE","__ZL17compile_dictrulesP7__sFILES0_Pc","__ZL17output_rule_groupP7__sFILEiPPcS1_","__ZL19compile_lettergroupPcP7__sFILE","__ZL12compile_rulePc","__ZL13rgroup_sorterP6RGROUPS0_","__ZL16copy_rule_stringPcRi","__ZL12compile_linePcS_Pi","__Z8strncpy0PcPKci","__Z13Reverse4Bytesi","__Z10LookupMnemP8MNEM_TABPKc","__Z14LoadDictionaryP10TranslatorPKci","__ZL10InitGroupsP10Translator","__Z14HashDictionaryPKc","__Z14EncodePhonemesPcS_Ph","__Z14DecodePhonemesPKcPc","__Z26GetTranslatedPhonemeStringPci","__ZL15WritePhMnemonicPcPiP11PHONEME_TABP12PHONEME_LIST","__Z7IsVowelP10Translatori","__ZL8IsLetterP10Translatorii","__Z14UnpronouncableP10TranslatorPci","__ZL15Unpronouncable2P10TranslatorPc","__Z16ChangeWordStressP10TranslatorPci","__ZL14GetVowelStressP10TranslatorPhPaRiS3_i","__Z13SetWordStressP10TranslatorPcPjii","__Z14AppendPhonemesP10TranslatorPciPKc","__Z14TranslateRulesP10TranslatorPcS1_iS1_iPj","__Z6LookupP10TranslatorPKcPc","__ZL9MatchRuleP10TranslatorPPcS1_iS1_P11MatchRecordii","__Z21ApplySpecialAttributeP10TranslatorPci","__Z22ApplySpecialAttribute2P10TranslatorPci","__Z17TransposeAlphabetP10TranslatorPc","__Z14LookupDictListP10TranslatorPPcS1_PjiP8WORD_TAB","__ZL11LookupDict2P10TranslatorPKcS2_PcPjiP8WORD_TAB","__Z11LookupFlagsP10TranslatorPKc","__Z12RemoveEndingP10TranslatorPciS1_","__ZL13IsLetterGroupP10TranslatorPcii","__Z11CalcPitchesP10Translatori","__ZL16CalcPitches_ToneP10Translatori","__ZL18count_pitch_vowelsiii","__ZL12calc_pitchesiiii","__ZL13calc_pitches2iii","__ZL16SetPitchGradientiiii","__ZL18calc_pitch_segmentiiP9TONE_HEADP12TONE_NUCLEUSii","__ZL9set_pitchP8SYLLABLEii","__ZL16count_incrementsiii","__ZL17SetHeadIntonationP4TUNEiii","__ZL15CountUnstressediii","_iswalpha","_iswdigit","_iswalnum","_towlower","_towupper","_iswupper","_iswlower","_iswspace","_iswpunct","_wcschr","_wcslen","_wcstod","__Z9towlower2j","__Z3Eofv","__Z10Read4BytesP7__sFILE","__Z11AddNameDataPKci","__Z13SetVoiceStackP12espeak_VOICE","__Z10ReadClauseP10TranslatorP7__sFILEPcPsPiiS5_S3_","__ZL4GetCv","__ZL6UngetCi","__ZL14ProcessSsmlTagPwPcRiii","__ZL13LookupSpecialP10TranslatorPKcPc","__ZL10RemoveCharPc","__ZL19AnnouncePunctuationP10TranslatoriPiPcS1_i","__ZL14LookupCharNameP10Translatorii","__ZL8IsRomanUj","__Z12InitNamedatav","__Z9InitText2v","__ZL13WordToString2j","__ZL15LookupSoundiconi","__ZL13LoadSoundFilePKci","__ZL14PushParamStacki","__ZL16GetSsmlAttributePwPKc","__ZL7attrcmpPKwPKc","__ZL10attrlookupPKwPK8MNEM_TAB","__ZL17ProcessParamStackPcRi","__ZL19SetProsodyParameteriPwP11PARAM_STACK","__ZL13PopParamStackiPcRi","__ZL10attrnumberPKwii","__ZL14ReplaceKeyNamePciRi","__ZL13attrcopy_utf8PcPKwi","__ZL14LoadSoundFile2PKc","__ZL18GetVoiceAttributesPwi","__ZL14VoiceFromStackv","__ZL18attr_prosody_valueiPKwPi","__ZL8GetC_getv","__ZL10GetC_ungeti","__Z8SetSpeedi","__Z12SetParameteriii","__Z11CalcLengthsP10Translator","__ZL11DoEmbedded2Pi","__Z20LookupAccentedLetterP10TranslatorjPc","__ZL13LookupLetter2P10TranslatorjPc","__Z12LookupLetterP10TranslatorjiPci","__Z15TranslateLetterP10TranslatorPcS1_i","__Z17SetSpellingStressP10TranslatorPcii","__Z14TranslateRomanP10TranslatorPcS1_P8WORD_TAB","__ZL15CheckDotOrdinalP10TranslatorPcS1_P8WORD_TABi","__ZL11hu_number_ePKcii","__Z15TranslateNumberP10TranslatorPcS1_PjP8WORD_TABi","__ZL17TranslateNumber_1P10TranslatorPcS1_PjP8WORD_TABi","__ZL15LookupThousandsP10TranslatoriiiPc","__ZL10LookupNum3P10TranslatoriPciii","__ZL10LookupNum2P10TranslatoriiPc","__ZL9M_Varianti","__Z15LoadMbrolaTablePKcS0_i","_setNoError_MBR","__Z15MbrolaTranslateP12PHONEME_LISTiiP7__sFILE","__ZL10GetMbrNameP12PHONEME_LISTP11PHONEME_TABS2_S2_PiS3_S3_","__ZL10WritePitchiiiii","__Z14MbrolaGenerateP12PHONEME_LISTPii","__Z10MbrolaFillii","__Z11MbrolaResetv","__Z10LoadPhDatav","__ZL10ReadPhFilePvPKcPi","__Z10FreePhDatav","__Z11PhonemeCodej","__Z19LookupPhonemeStringPKc","__Z11LookupSpectP11PHONEME_TABiP10FMT_PARAMSPiP12PHONEME_LIST","__Z11GetEnvelopei","__Z18SelectPhonemeTablei","__ZL17SetUpPhonemeTableii","__Z18LookupPhonemeTablePKc","__Z22SelectPhonemeTableNamePKc","__Z10LoadConfigv","__Z16InterpretPhonemeP10TranslatoriP12PHONEME_LISTP12PHONEME_DATA","__ZL12InvalidInstnP11PHONEME_TABi","__ZL15StressConditionP10TranslatorP12PHONEME_LISTii","__ZL18InterpretConditionP10TranslatoriP12PHONEME_LISTi","__ZL13NumInstnWordsPt","__ZL15SwitchVowelTypeP12PHONEME_LISTP12PHONEME_DATAPPti","__Z17InterpretPhoneme2iP12PHONEME_DATA","__Z12WordToStringj","__Z14SynthesizeInitv","__Z11PauseLengthii","__Z9DoSample3P12PHONEME_DATAii","__ZL8EndPitchi","__ZL9DoSample2iiiiii","__Z18FormantTransition2P10frameref_tRijjP11PHONEME_TABi","__ZL9CopyFrameP7frame_ti","__ZL13set_frame_rmsP7frame_ti","__ZL14AdjustFormantsP7frame_tiiiiiii","__ZL14VowelClosenessP7frame_t","__ZL18DuplicateLastFrameP10frameref_tii","__ZL7DoPauseii","__Z8DoSpect2P11PHONEME_TABiP10FMT_PARAMSP12PHONEME_LISTi","__ZL11SmoothSpectv","__Z8DoMarkeriiii","__Z12DoSonicSpeedi","__Z13DoVoiceChangeP7voice_t","__Z10DoEmbeddedPii","__Z8GenerateP12PHONEME_LISTPii","__ZL12EndAmplitudev","__ZL11DoAmplitudeiPh","__ZL7DoPitchPhii","__ZL13StartSyllablev","__Z12SynthOnTimerv","__Z15SpeakNextClauseP7__sFILEPKvi","__Z11SynthStatusv","__ZL18formants_reduce_hfP7frame_ti","__ZL10AllocFramev","__Z13SetLengthModsP10Translatori","__Z7IsAlphaj","__Z11lookupwcharPKti","__Z7IsDigitj","__Z7IsSpacej","__Z16DeleteTranslatorP10Translator","__Z9IsBracketi","__Z8utf8_outjPc","__Z11utf8_nbytesPKc","__Z8utf8_in2PiPKci","__Z7utf8_inPiPKc","__Z8strchr_wPKci","__Z10IsAllUpperPKc","__Z24ChangeEquivalentPhonemesP10TranslatoriPc","__Z13TranslateWordP10TranslatorPciP8WORD_TAB","__ZL17CheckDottedAbbrevPcP8WORD_TAB","__ZL22SpeakIndividualLettersP10TranslatorPcS1_i","__Z14SetTranslator2PKc","__Z15TranslateClauseP10TranslatorP7__sFILEPKvPiPPc","__ZL9IsDigit09j","__ZL15EmbeddedCommandRj","__ZL13TranslateCharP10TranslatorPcijjPi","__ZL14TranslateWord2P10TranslatorPcP8WORD_TABii","__Z8InitTexti","__ZL14CountSyllablesPh","__ZL9SetPlist2P13PHONEME_LIST2h","__ZL14SubstituteCharP10TranslatorjjPi","_init_MBR","__ZL12start_mbrolaPKc","__ZL14send_to_mbrolaPKc","__ZL11stop_mbrolav","__ZL19receive_from_mbrolaPvj","__ZL3errPKcz","_close_MBR","__ZL17free_pending_datav","_reset_MBR","__ZL17mbrola_has_errorsv","_read_MBR","_write_MBR","_flush_MBR","_getFreq_MBR","_setVolumeRatio_MBR","_lastErrorStr_MBR","_resetError_MBR","__ZL11mbrola_diedv","__ZL3logPKcz","__ZL14mbrola_is_idlev","__ZL12create_pipesPiS_S_","__ZL11close_pipesPiS_S_","__Z15SetIndicLettersP10Translator","__ZL18SetLetterBitsRangeP10Translatoriii","__ZL13SetLetterBitsP10TranslatoriPKc","__Z15SetupTranslatorP10TranslatorPKsPKh","__Z16SelectTranslatorPKc","__ZL13NewTranslatorv","__ZL14SetLetterVowelP10Translatori","__ZL18SetCyrillicLettersP10Translator","__ZL15ResetLetterBitsP10Translatori","__ZL18Translator_RussianP10Translator","__Z14ReadTonePointsPcPi","__Z10VoiceReseti","__ZL13SetToneAdjustP7voice_tPi","__Z9LoadVoicePKci","__ZL11fgets_stripPciP7__sFILE","__ZL12VoiceFormantPc","__ZL12Read8NumbersPcPi","__ZL10LookupTunePKc","__ZL18PhonemeReplacementiPc","__Z16LoadVoiceVariantPKci","__ZL23ExtractVoiceVariantNamePci","__Z17SelectVoiceByNamePP12espeak_VOICEPKc","_espeak_ListVoices","__Z11SelectVoiceP12espeak_VOICEPi","__ZL14SetVoiceScoresP12espeak_VOICEPS0_i","__Z14SetVoiceByNamePKc","__Z20SetVoiceByPropertiesP12espeak_VOICE","__ZL9GetVoicesPKc","__ZL15VoiceNameSorterPKvS0_","_espeak_GetCurrentVoice","__ZL13ReadVoiceFileP7__sFILEPKcS2_","__ZL10ScoreVoiceP12espeak_VOICEPKciiS0_","__ZL16VoiceScoreSorterPKvS0_","__Z9WcmdqStopv","__Z9WcmdqFreev","__Z9WcmdqUsedv","__Z8WcmdqIncv","__Z16WavegenOpenSoundv","__Z17WavegenCloseSoundv","__Z16WavegenInitSoundv","__Z11WavegenInitii","__ZL17WavegenInitPkDatai","__Z12GetAmplitudev","__Z16PeaksToHarmspectP15wavegen_peaks_tiPii","__Z10InitBreathv","__ZL12setresonatorP9RESONATORiii","__Z7Wavegenv","__ZL17AdvanceParametersv","__ZL9SetBreathv","__ZL11ApplyBreathv","__Z11SetEmbeddedii","__ZL13SetWithRange0ii","__ZL14WavegenSetEchov","__ZL16SetPitchFormantsv","__Z15WavegenSetVoiceP7voice_t","__Z9SetPitch2P7voice_tiiPiS1_","__Z8SetPitchiPhii","__Z8SetSynthiiP7frame_tS0_P7voice_t","__Z11Write4BytesP7__sFILEi","__Z12WavegenFill2i","__ZL11PlaySilenceii","__ZL8PlayWaveiiPhii","__ZL8Wavegen2iiiP7frame_tS0_","__ZL12SetAmplitudeiPhi","__ZL12WcmdqIncHeadv","__Z11WavegenFilli","__ZL7SpeedUpPsiii","__ZL9resonatorP9RESONATORd","__Z15MakePhonemeListP10Translatorii","__ZL18SubstitutePhonemesP10TranslatorP12PHONEME_LIST","__Z10KlattReseti","__ZL6setabcllP11resonator_t","__Z13Wavegen_Klatti","__ZL10frame_initP13klatt_frame_t","__ZL7parwaveP13klatt_frame_t","__Z14SetSynth_KlattiiP7frame_tS0_P7voice_ti","__Z14Wavegen_Klatt2iiiP7frame_tS0_","__Z9KlattInitv","__ZL7flutterP13klatt_frame_t","__ZL9gen_noised","__ZL16impulsive_sourcev","__ZL14natural_sourcev","__ZL14sampled_sourcev","__ZL21pitch_synch_par_resetP13klatt_frame_t","__ZL9resonatorP11resonator_td","__ZL14antiresonator2P11resonator_td","__ZL10resonator2P11resonator_td","__ZL7DBtoLINl","__ZL10setzeroabcllP11resonator_t","__Z8sonicMSGPcz","_sonicGetSpeed","_sonicSetSpeed","_sonicGetPitch","_sonicSetPitch","_sonicGetVolume","_sonicSetVolume","_sonicGetSampleRate","_sonicGetNumChannels","_sonicDestroyStream","_sonicCreateStream","_sonicReadFloatFromStream","_sonicReadShortFromStream","_sonicReadUnsignedCharFromStream","_sonicFlushStream","_sonicWriteShortToStream","_sonicSamplesAvailable","_sonicWriteFloatToStream","__ZL28addFloatSamplesToInputBufferP17sonicStreamStructPfi","__ZL18processStreamInputP17sonicStreamStruct","__ZL28addShortSamplesToInputBufferP17sonicStreamStructPsi","_sonicWriteUnsignedCharToStream","__ZL35addUnsignedCharSamplesToInputBufferP17sonicStreamStructPhi","_sonicChangeFloatSpeed","_sonicChangeShortSpeed","__ZL26enlargeInputBufferIfNeededP17sonicStreamStructi","__ZL11changeSpeedP17sonicStreamStructf","__ZL12copyToOutputP17sonicStreamStructPsi","__ZL11adjustPitchP17sonicStreamStructi","__ZL12scaleSamplesPsif","__ZL27moveNewSamplesToPitchBufferP17sonicStreamStructi","__ZL15findPitchPeriodP17sonicStreamStructPs","__ZL27enlargeOutputBufferIfNeededP17sonicStreamStructi","__ZL10overlapAddiiPsS_S_","__ZL24overlapAddWithSeparationiiiPsS_S_","__ZL18removePitchSamplesP17sonicStreamStructi","__ZL22findPitchPeriodInRangePsiiPiS0_","__ZL15downSampleInputP17sonicStreamStructPsi","__ZL16prevPeriodBetterP17sonicStreamStructiii","__ZL17copyInputToOutputP17sonicStreamStructi","__ZL15skipPitchPeriodP17sonicStreamStructPsfi","__ZL17insertPitchPeriodP17sonicStreamStructPsfi","__ZL18removeInputSamplesP17sonicStreamStructi","_getopt","__ZL12read_globalsP11getopt_data","__ZL15getopt_internaliPKPcPKcPK6optionPiiP11getopt_data","__ZL13write_globalsP11getopt_data","_getopt_long","_getopt_long_only","___getopt_r","___getopt_long_r","___getopt_long_only_r","__ZL9is_optionPci","__ZL7permutePKPcii","__ZL21reverse_argv_elementsPPci","___strtok_r","_strtok_r","_strtok"]


return {
	Module: Module,
	FS: FS,
	run: run
};
}

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "good_job_01.mp3";

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "good_job_02.mp3";

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cheer.mp3";

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cable.mp3";

/***/ }),
/* 667 */
/***/ (function(module, exports) {

module.exports = {
	"voice_id": "en/en-us",
	"dict_id": "en_dict",
	"dict": "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",
	"voice": "Ly8gbW92aW5nIHRvd2FyZHMgVVMgRW5nbGlzaApuYW1lIGVuZ2xpc2gtdXMKbGFuZ3VhZ2UgZW4tdXMgMgpsYW5ndWFnZSBlbi1yCmxhbmd1YWdlIGVuIDMKZ2VuZGVyIG1hbGUKCnBob25lbWVzIGVuLXVzCmRpY3RydWxlcyAzIDYKb3B0aW9uIHJlZHVjZV90IDEKCnN0cmVzc0xlbmd0aCAxNDUgMTI1IDE5MCAxNzAgMCAwIDI2MCAyOTAKc3RyZXNzQW1wICAxNyAxNiAgMTkgMTkgIDE5IDE5ICAyMSAxOQoKcmVwbGFjZSAwMyBJICBpCnJlcGxhY2UgMDMgSTIgaQpyZXBsYWNlIDAzIEAgIEAvCg=="
};

/***/ }),
/* 668 */
/***/ (function(module, exports) {

module.exports = {
	"config": "Ly9wYV9kZXZpY2UgNwoKLy8gcGxheSBhIHNvdW5kIGZvciBwdW5jdHVhdGlvbiwgcmF0aGVyIHRoYW4gc3BlYWsgaXRzIG5hbWUKLy9zb3VuZGljb24gXyggL3Vzci9zaGFyZS9zb3VuZHMvc291bmQtaWNvbnMvbGVmdC1yb3VuZC1icmFja2V0Ci8vc291bmRpY29uIF8pIC91c3Ivc2hhcmUvc291bmRzL3NvdW5kLWljb25zL3JpZ2h0LXJvdW5kLWJyYWNrZXQKLy9zb3VuZGljb24gX1sgL3Vzci9zaGFyZS9zb3VuZHMvc291bmQtaWNvbnMvbGVmdC1zcXVhcmUtYnJhY2tldAovL3NvdW5kaWNvbiBfXSAvdXNyL3NoYXJlL3NvdW5kcy9zb3VuZC1pY29ucy9yaWdodC1zcXVhcmUtYnJhY2tldAovL3NvdW5kaWNvbiBfeyAvdXNyL3NoYXJlL3NvdW5kcy9zb3VuZC1pY29ucy9sZWZ0LWJyYWNlCi8vc291bmRpY29uIF99IC91c3Ivc2hhcmUvc291bmRzL3NvdW5kLWljb25zL3JpZ2h0LWJyYWNlCg==",
	"phontab": "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",
	"phonindex": "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",
	"phondata": "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",
	"intonations": "czEAAAAAAAAAAAAAAAAAAAAoGAgAAAAALjkAEAAA/1Ay/wQF+Pj4+/v7AEAIAEYSGAwARhIYDAAAAAAAAAAAAAAAAABjMQAAAAAAAAAAAAAAAAAAACgYCAAAAAAuOQAQAAD/UC7/BAX4+Pj7+/sEUBIGThYiNAZOFiI0AAAAAAAAAAAAAAAAAHExAAAAAAAAAAAAAAAAAAAQKBgIAAAAAC45ABAAAP9LK/8EBfn5+QAAAARYFgZSFiJCBlIWIkIAAAAAAAAAAAAAAAAAZTEAAAAAAAAAAAAAAAAAAAo0IBQKAAAALjkAEAAA/1oy/wMF9/f3AAAAAFwIAFxQTAgAXFBMCAAAAAAAAAAAAAAAAABzMgAAAAAAAAAAAAAAAAAAACEYCAAAAAAuOQAQAABLQTz/BAX7+Pj7+/sALBwAMioiHAAyKiIcAAAAAAAAAAAAAAAAAGMyAAAAAAAAAAAAAAAAAAAAKBgIAAAAAC45ABAAAP9BMv8EBfn4+Pn7+wI8KgI3KiI0AjcqIjQAAAAAAAAAAAAAAAAAcTIAAAAAAAAAAAAAAAAAABAoGAgAAAAAKEsAEAAA/0sr/wQF+fn5+QAAAkYyAiMtPEYCIy08RgAAAAAAAAAAAAAAAABlMgAAAAAAAAAAAAAAAAAACjQgFAoAAAAuOQAQAAD/WjL/AwX59/f5AAAAXAgAXFBMCABcUEwIAAAAAAAAAAAAAAAAAHMzAAAAAAAAAAAAAAAAAAAAKBgIAAAAAC45ABAAAP9QMv8EBfn4+Pn7+wBACABGEhgMAEYSGAwAAAAAAAAAAAAAAAAAYzMAAAAAAAAAAAAAAAAAAAAoGAgAAAAALjkAEAAA/0Ye/wQF+fj4+fv7BEsyAEYSGAwARhIYDAAAAAAAAAAAAAAAAABxMwAAAAAAAAAAAAAAAAAAECgYCAAAAAAuOQAQAAD/Syv/BAX5+fn5AAAEWBYGUhYiQgZSFiJCAAAAAAAAAAAAAAAAAGUzAAAAAAAAAAAAAAAAAAAKNCAUCgAAAC45ABAAAP9aMv8DBfn39/kAAABcCABcUEwIAFxQTAgAAAAAAAAAAAAAAAAA"
};

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(96);

__webpack_require__(670);

var _reactRouter = __webpack_require__(18);

var _Navigation = __webpack_require__(42);

var _Navigation2 = _interopRequireDefault(_Navigation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = _react2.default.createElement(_Navigation2.default, null);

var _ref2 = _react2.default.createElement(
    'span',
    { className: 'btn' },
    'Loading...'
);

var Resume = function (_React$Component) {
    _inherits(Resume, _React$Component);

    function Resume() {
        _classCallCheck(this, Resume);

        var _this = _possibleConstructorReturn(this, (Resume.__proto__ || Object.getPrototypeOf(Resume)).call(this));

        _this.EMBED_LINK = 'https://resume.creddle.io/embed/gou28joi3b';
        _this.EXTERNAL_LINK = 'https://resume.creddle.io/resume/gou28joi3b';
        _this.redirecting = false;
        return _this;
    }

    _createClass(Resume, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            if (window.innerWidth <= 850) {
                this.redirecting = true;
                window.location.replace(this.EXTERNAL_LINK);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { id: 'resume' },
                _ref,
                _react2.default.createElement(
                    'section',
                    null,
                    _react2.default.createElement(
                        'iframe',
                        { src: this.EMBED_LINK,
                            seamless: true },
                        _ref2
                    ),
                    _react2.default.createElement(
                        'a',
                        { className: 'btn', href: this.EXTERNAL_LINK },
                        this.redirecting ? 'Redirecting...' : 'View Resume'
                    )
                )
            );
        }
    }]);

    return Resume;
}(_react2.default.Component);

exports.default = Resume;

/***/ }),
/* 670 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__(94);

var _reduxImmutableStateInvariant = __webpack_require__(672);

var _reduxImmutableStateInvariant2 = _interopRequireDefault(_reduxImmutableStateInvariant);

var _reduxThunk = __webpack_require__(676);

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reducers = __webpack_require__(677);

var _reducers2 = _interopRequireDefault(_reducers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function configureStoreProd(initialState) {
  var middlewares = [
  // Add other middleware on this line...

  // thunk middleware can also accept an extra argument to be passed to each thunk action
  // https://github.com/gaearon/redux-thunk#injecting-a-custom-argument


  // thunk middleware can also accept an extra argument to be passed to each thunk action
  // https://github.com/gaearon/redux-thunk#injecting-a-custom-argument
  _reduxThunk2.default];

  return (0, _redux.createStore)(_reducers2.default, initialState, (0, _redux.compose)(_redux.applyMiddleware.apply(undefined, middlewares)));
}

function configureStoreDev(initialState) {
  var middlewares = [
  // Add other middleware on this line...

  // Redux middleware that spits an error on you when you try to mutate your state either inside a dispatch or between dispatches.
  (0, _reduxImmutableStateInvariant2.default)(), _reduxThunk2.default];

  var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _redux.compose; // add support for Redux dev tools
  var store = (0, _redux.createStore)(_reducers2.default, initialState, composeEnhancers(_redux.applyMiddleware.apply(undefined, middlewares)));

  if (false) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../reducers', function () {
      var nextReducer = require('../reducers').default; // eslint-disable-line global-require
      store.replaceReducer(nextReducer);
    });
  }

  return store;
}

var configureStore =  true ? configureStoreProd : configureStoreDev;

exports.default = configureStore;

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = immutableStateInvariantMiddleware;

var _invariant = __webpack_require__(10);

var _invariant2 = _interopRequireDefault(_invariant);

var _jsonStringifySafe = __webpack_require__(673);

var _jsonStringifySafe2 = _interopRequireDefault(_jsonStringifySafe);

var _isImmutable = __webpack_require__(674);

var _isImmutable2 = _interopRequireDefault(_isImmutable);

var _trackForMutations = __webpack_require__(675);

var _trackForMutations2 = _interopRequireDefault(_trackForMutations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BETWEEN_DISPATCHES_MESSAGE = ['A state mutation was detected between dispatches, in the path `%s`.', 'This may cause incorrect behavior.', '(http://redux.js.org/docs/Troubleshooting.html#never-mutate-reducer-arguments)'].join(' ');

var INSIDE_DISPATCH_MESSAGE = ['A state mutation was detected inside a dispatch, in the path: `%s`.', 'Take a look at the reducer(s) handling the action %s.', '(http://redux.js.org/docs/Troubleshooting.html#never-mutate-reducer-arguments)'].join(' ');

function immutableStateInvariantMiddleware() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$isImmutable = options.isImmutable,
      isImmutable = _options$isImmutable === undefined ? _isImmutable2.default : _options$isImmutable,
      ignore = options.ignore;

  var track = _trackForMutations2.default.bind(null, isImmutable, ignore);

  return function (_ref) {
    var getState = _ref.getState;

    var state = getState();
    var tracker = track(state);

    var result = void 0;
    return function (next) {
      return function (action) {
        state = getState();

        result = tracker.detectMutations();
        // Track before potentially not meeting the invariant
        tracker = track(state);

        (0, _invariant2.default)(!result.wasMutated, BETWEEN_DISPATCHES_MESSAGE, (result.path || []).join('.'));

        var dispatchedAction = next(action);
        state = getState();

        result = tracker.detectMutations();
        // Track before potentially not meeting the invariant
        tracker = track(state);

        (0, _invariant2.default)(!result.wasMutated, INSIDE_DISPATCH_MESSAGE, (result.path || []).join('.'), (0, _jsonStringifySafe2.default)(action));

        return dispatchedAction;
      };
    };
  };
}

/***/ }),
/* 673 */
/***/ (function(module, exports) {

exports = module.exports = stringify
exports.getSerialize = serializer

function stringify(obj, replacer, spaces, cycleReplacer) {
  return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces)
}

function serializer(replacer, cycleReplacer) {
  var stack = [], keys = []

  if (cycleReplacer == null) cycleReplacer = function(key, value) {
    if (stack[0] === value) return "[Circular ~]"
    return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]"
  }

  return function(key, value) {
    if (stack.length > 0) {
      var thisPos = stack.indexOf(this)
      ~thisPos ? stack.splice(thisPos + 1) : stack.push(this)
      ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key)
      if (~stack.indexOf(value)) value = cycleReplacer.call(this, key, value)
    }
    else stack.push(value)

    return replacer == null ? value : replacer.call(this, key, value)
  }
}


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = isImmutableDefault;
function isImmutableDefault(value) {
  return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object' || value === null || typeof value === 'undefined';
}

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = trackForMutations;
function trackForMutations(isImmutable, ignore, obj) {
  var trackedProperties = trackProperties(isImmutable, ignore, obj);
  return {
    detectMutations: function detectMutations() {
      return _detectMutations(isImmutable, ignore, trackedProperties, obj);
    }
  };
}

function trackProperties(isImmutable) {
  var ignore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var obj = arguments[2];
  var path = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

  var tracked = { value: obj };

  if (!isImmutable(obj)) {
    tracked.children = {};

    for (var key in obj) {
      var childPath = path.concat(key);
      if (ignore.length && ignore.indexOf(childPath.join('.')) !== -1) {
        continue;
      }

      tracked.children[key] = trackProperties(isImmutable, ignore, obj[key], childPath);
    }
  }
  return tracked;
}

function _detectMutations(isImmutable) {
  var ignore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var trackedProperty = arguments[2];
  var obj = arguments[3];
  var sameParentRef = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var path = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];

  var prevObj = trackedProperty ? trackedProperty.value : undefined;

  var sameRef = prevObj === obj;

  if (sameParentRef && !sameRef && !Number.isNaN(obj)) {
    return { wasMutated: true, path: path };
  }

  if (isImmutable(prevObj) || isImmutable(obj)) {
    return { wasMutated: false };
  }

  // Gather all keys from prev (tracked) and after objs
  var keysToDetect = {};
  Object.keys(trackedProperty.children).forEach(function (key) {
    keysToDetect[key] = true;
  });
  Object.keys(obj).forEach(function (key) {
    keysToDetect[key] = true;
  });

  var keys = Object.keys(keysToDetect);
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var childPath = path.concat(key);
    if (ignore.length && ignore.indexOf(childPath.join('.')) !== -1) {
      continue;
    }

    var result = _detectMutations(isImmutable, ignore, trackedProperty.children[key], obj[key], sameRef, childPath);

    if (result.wasMutated) {
      return result;
    }
  }
  return { wasMutated: false };
}

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch;
    var getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

exports['default'] = thunk;

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__(94);

var _reactRouterRedux = __webpack_require__(313);

// Set up your root reducer here...
var rootReducer = (0, _redux.combineReducers)({
  routing: _reactRouterRedux.routerReducer
});
exports.default = rootReducer;

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = syncHistoryWithStore;

var _reducer = __webpack_require__(314);

var defaultSelectLocationState = function defaultSelectLocationState(state) {
  return state.routing;
};

/**
 * This function synchronizes your history state with the Redux store.
 * Location changes flow from history to the store. An enhanced history is
 * returned with a listen method that responds to store updates for location.
 *
 * When this history is provided to the router, this means the location data
 * will flow like this:
 * history.push -> store.dispatch -> enhancedHistory.listen -> router
 * This ensures that when the store state changes due to a replay or other
 * event, the router will be updated appropriately and can transition to the
 * correct router state.
 */
function syncHistoryWithStore(history, store) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$selectLocationSt = _ref.selectLocationState,
      selectLocationState = _ref$selectLocationSt === undefined ? defaultSelectLocationState : _ref$selectLocationSt,
      _ref$adjustUrlOnRepla = _ref.adjustUrlOnReplay,
      adjustUrlOnReplay = _ref$adjustUrlOnRepla === undefined ? true : _ref$adjustUrlOnRepla;

  // Ensure that the reducer is mounted on the store and functioning properly.
  if (typeof selectLocationState(store.getState()) === 'undefined') {
    throw new Error('Expected the routing state to be available either as `state.routing` ' + 'or as the custom expression you can specify as `selectLocationState` ' + 'in the `syncHistoryWithStore()` options. ' + 'Ensure you have added the `routerReducer` to your store\'s ' + 'reducers via `combineReducers` or whatever method you use to isolate ' + 'your reducers.');
  }

  var initialLocation = void 0;
  var isTimeTraveling = void 0;
  var unsubscribeFromStore = void 0;
  var unsubscribeFromHistory = void 0;
  var currentLocation = void 0;

  // What does the store say about current location?
  var getLocationInStore = function getLocationInStore(useInitialIfEmpty) {
    var locationState = selectLocationState(store.getState());
    return locationState.locationBeforeTransitions || (useInitialIfEmpty ? initialLocation : undefined);
  };

  // Init initialLocation with potential location in store
  initialLocation = getLocationInStore();

  // If the store is replayed, update the URL in the browser to match.
  if (adjustUrlOnReplay) {
    var handleStoreChange = function handleStoreChange() {
      var locationInStore = getLocationInStore(true);
      if (currentLocation === locationInStore || initialLocation === locationInStore) {
        return;
      }

      // Update address bar to reflect store state
      isTimeTraveling = true;
      currentLocation = locationInStore;
      history.transitionTo(_extends({}, locationInStore, {
        action: 'PUSH'
      }));
      isTimeTraveling = false;
    };

    unsubscribeFromStore = store.subscribe(handleStoreChange);
    handleStoreChange();
  }

  // Whenever location changes, dispatch an action to get it in the store
  var handleLocationChange = function handleLocationChange(location) {
    // ... unless we just caused that location change
    if (isTimeTraveling) {
      return;
    }

    // Remember where we are
    currentLocation = location;

    // Are we being called for the first time?
    if (!initialLocation) {
      // Remember as a fallback in case state is reset
      initialLocation = location;

      // Respect persisted location, if any
      if (getLocationInStore()) {
        return;
      }
    }

    // Tell the store to update by dispatching an action
    store.dispatch({
      type: _reducer.LOCATION_CHANGE,
      payload: location
    });
  };
  unsubscribeFromHistory = history.listen(handleLocationChange);

  // History 3.x doesn't call listen synchronously, so fire the initial location change ourselves
  if (history.getCurrentLocation) {
    handleLocationChange(history.getCurrentLocation());
  }

  // The enhanced history uses store as source of truth
  return _extends({}, history, {
    // The listeners are subscribed to the store instead of history
    listen: function listen(listener) {
      // Copy of last location.
      var lastPublishedLocation = getLocationInStore(true);

      // Keep track of whether we unsubscribed, as Redux store
      // only applies changes in subscriptions on next dispatch
      var unsubscribed = false;
      var unsubscribeFromStore = store.subscribe(function () {
        var currentLocation = getLocationInStore(true);
        if (currentLocation === lastPublishedLocation) {
          return;
        }
        lastPublishedLocation = currentLocation;
        if (!unsubscribed) {
          listener(lastPublishedLocation);
        }
      });

      // History 2.x listeners expect a synchronous call. Make the first call to the
      // listener after subscribing to the store, in case the listener causes a
      // location change (e.g. when it redirects)
      if (!history.getCurrentLocation) {
        listener(lastPublishedLocation);
      }

      // Let user unsubscribe later
      return function () {
        unsubscribed = true;
        unsubscribeFromStore();
      };
    },


    // It also provides a way to destroy internal listeners
    unsubscribe: function unsubscribe() {
      if (adjustUrlOnReplay) {
        unsubscribeFromStore();
      }
      unsubscribeFromHistory();
    }
  });
}

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = routerMiddleware;

var _actions = __webpack_require__(315);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
 * provided history object. This will prevent these actions from reaching your
 * reducer or any middleware that comes after this one.
 */
function routerMiddleware(history) {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type !== _actions.CALL_HISTORY_METHOD) {
          return next(action);
        }

        var _action$payload = action.payload,
            method = _action$payload.method,
            args = _action$payload.args;

        history[method].apply(history, _toConsumableArray(args));
      };
    };
  };
}

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "favicon.ico";

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// main.a566b156b5c7019576ce.js